
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc28"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc28"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9TwI7", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", () => $911441c49a0faddf$export$dbba6cdedab4e68b);
$parcel$export(module.exports, "postInteractionLog", () => $911441c49a0faddf$export$d8f52e8f804021e8);
$parcel$export(module.exports, "interactionExtraMetrics", () => $911441c49a0faddf$export$481f88116dc8b7ad);
$parcel$export(module.exports, "segmentUnmountCache", () => $911441c49a0faddf$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $911441c49a0faddf$export$2b3954d2e8509985);
$parcel$export(module.exports, "remove", () => $911441c49a0faddf$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $911441c49a0faddf$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $911441c49a0faddf$export$e4380431c2bdabee);
$parcel$export(module.exports, "addIframeSegmentData", () => $911441c49a0faddf$export$c227d812a1e08d80);
$parcel$export(module.exports, "addCustomTiming", () => $911441c49a0faddf$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $911441c49a0faddf$export$728e28c22a0fba4);
$parcel$export(module.exports, "markFirstSegmentLoad", () => $911441c49a0faddf$export$85d1eb835f669bf);
$parcel$export(module.exports, "addSpan", () => $911441c49a0faddf$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $911441c49a0faddf$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "addHold", () => $911441c49a0faddf$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $911441c49a0faddf$export$10582acd678c213);
$parcel$export(module.exports, "removeHoldByID", () => $911441c49a0faddf$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $911441c49a0faddf$export$2df109852219d16e);
$parcel$export(module.exports, "addError", () => $911441c49a0faddf$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $911441c49a0faddf$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $911441c49a0faddf$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $911441c49a0faddf$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $911441c49a0faddf$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $911441c49a0faddf$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $911441c49a0faddf$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $911441c49a0faddf$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $911441c49a0faddf$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $911441c49a0faddf$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $911441c49a0faddf$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $911441c49a0faddf$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdex", () => $911441c49a0faddf$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $911441c49a0faddf$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $911441c49a0faddf$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $911441c49a0faddf$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $911441c49a0faddf$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $911441c49a0faddf$export$5342dcad19138a1c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $gdnRs = parcelRequire("gdnRs");

var $e6Qdr = parcelRequire("e6Qdr");

var $2x96i = parcelRequire("2x96i");

var $2YpBk = parcelRequire("2YpBk");

var $cAaWV = parcelRequire("cAaWV");

var $9GPxu = parcelRequire("9GPxu");

var $5UJvw = parcelRequire("5UJvw");

var $czEyx = parcelRequire("czEyx");

var $l5LZV = parcelRequire("l5LZV");

var $1M3oH = parcelRequire("1M3oH");

var $8uTBY = parcelRequire("8uTBY");

var $8UvJf = parcelRequire("8UvJf");

var $3F1qw = parcelRequire("3F1qw");

var $cQx5E = parcelRequire("cQx5E");

var $7Om7a = parcelRequire("7Om7a");

var $iut6i = parcelRequire("iut6i");
const $911441c49a0faddf$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $911441c49a0faddf$export$d8f52e8f804021e8 = new (0, $iut6i.default)();
const $911441c49a0faddf$export$481f88116dc8b7ad = new (0, $7Om7a.default)();
const $911441c49a0faddf$var$interactionQueue = [];
const $911441c49a0faddf$var$segmentCache = new Map();
const $911441c49a0faddf$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
let $911441c49a0faddf$var$firstSegmentLoadMarked = false;
const $911441c49a0faddf$var$segmentObservers = [];
function $911441c49a0faddf$export$2b3954d2e8509985() {
    const interactionId = (0, $8uTBY.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $cQx5E.interactions).get(interactionId.current);
}
function $911441c49a0faddf$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $cAaWV.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $911441c49a0faddf$var$performanceEventObserver;
const $911441c49a0faddf$export$17afbba0f16b4b19 = ()=>{
    $911441c49a0faddf$var$performanceEventObserver = $911441c49a0faddf$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $911441c49a0faddf$export$e6be05b411ce21a6(entry);
    });
    return $911441c49a0faddf$var$performanceEventObserver;
};
const $911441c49a0faddf$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $911441c49a0faddf$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $911441c49a0faddf$var$labelStackToString(labelStack, name) {
    var _stack$map;
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map((l)=>l.name)) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
}
function $911441c49a0faddf$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
}
function $911441c49a0faddf$var$addSegmentObserver(observer) {
    $911441c49a0faddf$var$segmentObservers.push(observer);
    for (const segmentInfo of $911441c49a0faddf$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $911441c49a0faddf$var$removeSegmentObserver(observer) {
    const index = $911441c49a0faddf$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $911441c49a0faddf$var$segmentObservers.splice(index, 1);
}
function $911441c49a0faddf$export$cd7f480d6b8286c3(interactionId) {
    (0, $cQx5E.interactions).delete(interactionId);
}
function $911441c49a0faddf$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $911441c49a0faddf$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $911441c49a0faddf$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $911441c49a0faddf$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $911441c49a0faddf$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null && (0, $e6Qdr.fg)('platform_ufo_3p_segment_timings')) {
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $911441c49a0faddf$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $911441c49a0faddf$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $2YpBk.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($911441c49a0faddf$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$911441c49a0faddf$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $911441c49a0faddf$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($911441c49a0faddf$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$911441c49a0faddf$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $911441c49a0faddf$export$85d1eb835f669bf(interactionId, labelStack, time = performance.now()) {
    if (!(0, $e6Qdr.fg)('platform_mark_ufo_segment_first_load')) return;
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null && !$911441c49a0faddf$var$firstSegmentLoadMarked) {
        $911441c49a0faddf$var$firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: 'first_segment_load',
            name: 'first_segment_load',
            labelStack: labelStack,
            time: time
        });
    }
}
function $911441c49a0faddf$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $cQx5E.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($911441c49a0faddf$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$911441c49a0faddf$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $911441c49a0faddf$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($911441c49a0faddf$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$911441c49a0faddf$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $911441c49a0faddf$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $cQx5E.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($911441c49a0faddf$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$911441c49a0faddf$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $911441c49a0faddf$export$9e04fe1a58571ec(moduleId, timestamp) {
    $911441c49a0faddf$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $911441c49a0faddf$export$6f228d1fdc911d7(identifier, start, end) {
    $911441c49a0faddf$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $911441c49a0faddf$var$moduleLoadingRequests = {};
function $911441c49a0faddf$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $911441c49a0faddf$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $911441c49a0faddf$var$labelStackToString(labelStack), name, startTime);
}
function $911441c49a0faddf$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $911441c49a0faddf$export$7606887303596f82(interactionId, labelStack, name, _experimental) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $gdnRs.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $911441c49a0faddf$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, {
                ...holdActive,
                start: start
            });
        } else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $911441c49a0faddf$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($911441c49a0faddf$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$911441c49a0faddf$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $911441c49a0faddf$var$removeHoldCriterion(id);
            const currentInteraction = (0, $cQx5E.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            const expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push({
                        ...expHold,
                        end: end
                    });
                    interaction.holdExpActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $911441c49a0faddf$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
        } else {
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $911441c49a0faddf$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $911441c49a0faddf$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $cQx5E.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $911441c49a0faddf$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $911441c49a0faddf$export$2df109852219d16e(interactionId) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $911441c49a0faddf$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $911441c49a0faddf$export$9e04fe1a58571ec($911441c49a0faddf$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $911441c49a0faddf$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $911441c49a0faddf$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $911441c49a0faddf$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $911441c49a0faddf$var$moduleLoadingRequests[info.identifier];
            $911441c49a0faddf$export$6f228d1fdc911d7($911441c49a0faddf$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $8uTBY.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $911441c49a0faddf$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $8uTBY.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $911441c49a0faddf$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $911441c49a0faddf$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $911441c49a0faddf$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $cQx5E.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $911441c49a0faddf$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig2;
    if ($911441c49a0faddf$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$911441c49a0faddf$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig2 = (0, $cAaWV.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.postInteractionLog) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) $911441c49a0faddf$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $911441c49a0faddf$var$pushToQueue(id, data) {
    $911441c49a0faddf$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $911441c49a0faddf$var$handleInteraction = $911441c49a0faddf$var$pushToQueue;
function $911441c49a0faddf$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $911441c49a0faddf$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $1M3oH.currentFeatureFlagsAccessed));
    (0, $l5LZV.clearActiveTrace)();
    $911441c49a0faddf$var$callCleanUpCallbacks(data);
    (0, $8UvJf.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $cAaWV.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    const sanitisedUfoName = (0, $czEyx.sanitizeUfoName)(data.ufoName);
    if (!(0, $2x96i.default)((0, $cAaWV.getPostInteractionRate)(sanitisedUfoName, data.type))) $911441c49a0faddf$export$d8f52e8f804021e8.stopVCObserver();
    if (!(0, $2x96i.default)((0, $cAaWV.getExtraInteractionRate)(sanitisedUfoName, data.type))) $911441c49a0faddf$export$481f88116dc8b7ad.stopAll(id);
    else if (!data.hold3pActive || data.hold3pActive.size === 0) {
        var _getConfig3;
        if (!((_getConfig3 = (0, $cAaWV.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.experimentalInteractionMetrics) !== null && _getConfig3 !== void 0 && _getConfig3.enabled)) $911441c49a0faddf$export$cd7f480d6b8286c3(id);
    }
    if ((0, $e6Qdr.fg)('platform_ufo_enable_terminal_errors')) {
        $911441c49a0faddf$export$dbba6cdedab4e68b.id = data.id;
        $911441c49a0faddf$export$dbba6cdedab4e68b.type = data.type;
        $911441c49a0faddf$export$dbba6cdedab4e68b.timestamp = data.end;
    }
    $911441c49a0faddf$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $911441c49a0faddf$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) {
        var _interactionExtraMetr;
        if (((_interactionExtraMetr = $911441c49a0faddf$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr === void 0 ? void 0 : _interactionExtraMetr.id) !== id) // If this same interaction was not already handled, handle it
        $911441c49a0faddf$var$handleInteraction(id, data);
    }
    if ($911441c49a0faddf$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $911441c49a0faddf$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$911441c49a0faddf$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $911441c49a0faddf$export$9e614a29a1ac213e(sinkFn) {
    if ($911441c49a0faddf$var$handleInteraction === $911441c49a0faddf$var$pushToQueue) {
        $911441c49a0faddf$var$handleInteraction = sinkFn;
        $911441c49a0faddf$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $911441c49a0faddf$var$interactionQueue.length = 0;
    }
}
function $911441c49a0faddf$export$8a1ba7bef607358a(sinkFn) {
    $911441c49a0faddf$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $911441c49a0faddf$var$activeSubmitted = false;
function $911441c49a0faddf$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc;
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const noMoreExpHolds = interaction.holdExpActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $cAaWV.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            var _getConfig4, _interactionExtraMetr2;
            if ((_getConfig4 = (0, $cAaWV.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.postInteractionLog) !== null && _getConfig4 !== void 0 && _getConfig4.enabled) {
                var _getConfig5;
                let experimentalVC90;
                let experimentalTTAI;
                if ((_getConfig5 = (0, $cAaWV.getConfig)()) !== null && _getConfig5 !== void 0 && (_getConfig5 = _getConfig5.experimentalInteractionMetrics) !== null && _getConfig5 !== void 0 && _getConfig5.enabled) {
                    var _await$getExperimenta;
                    experimentalVC90 = (_await$getExperimenta = await (0, $9GPxu.getExperimentalVCMetrics)(interaction)) === null || _await$getExperimenta === void 0 ? void 0 : _await$getExperimenta['metric:experimental:vc90'];
                    const { start: start, end: end } = interaction;
                    experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                }
                $911441c49a0faddf$export$d8f52e8f804021e8.onInteractionComplete({
                    ...interaction,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                });
            }
            if (((_interactionExtraMetr2 = $911441c49a0faddf$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr2 === void 0 ? void 0 : _interactionExtraMetr2.id) !== interactionId) {
                var _getConfig6;
                // If interactionExtraMetrics is not waiting for measuring this interaction
                if ((_getConfig6 = (0, $cAaWV.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.experimentalInteractionMetrics) !== null && _getConfig6 !== void 0 && _getConfig6.enabled) $911441c49a0faddf$export$cd7f480d6b8286c3(interactionId);
            }
            $911441c49a0faddf$var$activeSubmitted = false;
        };
        const noMoreActive3pHolds = ((_interaction$hold3pAc = interaction.hold3pActive) === null || _interaction$hold3pAc === void 0 ? void 0 : _interaction$hold3pAc.size) === 0 || interaction.hold3pActive === undefined;
        // If using raw data third party behavior, wait for 3p holds to clear
        if (shouldUseRawDataThirdParty) {
            // If there are no non-3p holds active, mark the interaction as successful
            // but don't finish until 3p holds are cleared
            if (noMoreActiveHolds && !noMoreActive3pHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                // Wait for 3p holds to clear before finishing
                return;
            }
            // If all holds (including 3p) are cleared, finish the interaction
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                if (!$911441c49a0faddf$var$activeSubmitted) {
                    var _getConfig7, _getConfig8, _getConfig9;
                    // Set end3p to current time when 3p holds cleared, but ensure it's at least interaction.end
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    $911441c49a0faddf$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((_getConfig7 = (0, $cAaWV.getConfig)()) !== null && _getConfig7 !== void 0 && (_getConfig7 = _getConfig7.extraInteractionMetrics) !== null && _getConfig7 !== void 0 && _getConfig7.enabled) $911441c49a0faddf$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((_getConfig8 = (0, $cAaWV.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.extraSearchPageInteraction) !== null && _getConfig8 !== void 0 && _getConfig8.enabled && interaction.ufoName === ((_getConfig9 = (0, $cAaWV.getConfig)()) === null || _getConfig9 === void 0 || (_getConfig9 = _getConfig9.extraSearchPageInteraction) === null || _getConfig9 === void 0 ? void 0 : _getConfig9.searchPageMetricName)) (0, $5UJvw.onSearchPageInteractionComplete)(interactionId, interaction);
                    $911441c49a0faddf$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    var _getConfig0;
                    if ((_getConfig0 = (0, $cAaWV.getConfig)()) !== null && _getConfig0 !== void 0 && (_getConfig0 = _getConfig0.experimentalInteractionMetrics) !== null && _getConfig0 !== void 0 && _getConfig0.enabled) (0, $9GPxu.onExperimentalInteractionComplete)(interactionId, interaction, endTime || interaction.end);
                    postInteraction();
                }
            }
            // Send separated third-party event even when feature flag is active
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime || interaction.end
                };
                $911441c49a0faddf$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        } else {
            var _interactionExtraMetr3;
            // Original behavior when feature flag is not active
            if (noMoreActiveHolds && ((_interactionExtraMetr3 = $911441c49a0faddf$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr3 === void 0 ? void 0 : _interactionExtraMetr3.id) !== interactionId) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!$911441c49a0faddf$var$activeSubmitted) {
                    var _getConfig1, _getConfig10, _getConfig11;
                    $911441c49a0faddf$var$finishInteraction(interactionId, interaction, endTime);
                    if ((_getConfig1 = (0, $cAaWV.getConfig)()) !== null && _getConfig1 !== void 0 && (_getConfig1 = _getConfig1.extraInteractionMetrics) !== null && _getConfig1 !== void 0 && _getConfig1.enabled) $911441c49a0faddf$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((_getConfig10 = (0, $cAaWV.getConfig)()) !== null && _getConfig10 !== void 0 && (_getConfig10 = _getConfig10.extraSearchPageInteraction) !== null && _getConfig10 !== void 0 && _getConfig10.enabled && interaction.ufoName === ((_getConfig11 = (0, $cAaWV.getConfig)()) === null || _getConfig11 === void 0 || (_getConfig11 = _getConfig11.extraSearchPageInteraction) === null || _getConfig11 === void 0 ? void 0 : _getConfig11.searchPageMetricName)) (0, $5UJvw.onSearchPageInteractionComplete)(interactionId, interaction);
                    $911441c49a0faddf$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    var _getConfig12;
                    if ((_getConfig12 = (0, $cAaWV.getConfig)()) !== null && _getConfig12 !== void 0 && (_getConfig12 = _getConfig12.experimentalInteractionMetrics) !== null && _getConfig12 !== void 0 && _getConfig12.enabled) (0, $9GPxu.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                    postInteraction();
                }
            }
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime
                };
                $911441c49a0faddf$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        }
    }
}
function $911441c49a0faddf$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $911441c49a0faddf$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $cAaWV.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $911441c49a0faddf$var$finishInteraction(interactionId, interaction, endTime);
            $911441c49a0faddf$export$d8f52e8f804021e8.reset();
            $911441c49a0faddf$export$d8f52e8f804021e8.stopVCObserver();
            $911441c49a0faddf$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $2x96i.default)((0, $cAaWV.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $9GPxu.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $911441c49a0faddf$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $911441c49a0faddf$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $911441c49a0faddf$var$finishInteraction(interactionId, interaction);
        $911441c49a0faddf$export$d8f52e8f804021e8.reset();
        $911441c49a0faddf$export$d8f52e8f804021e8.stopVCObserver();
        $911441c49a0faddf$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $2x96i.default)((0, $cAaWV.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $9GPxu.onExperimentalInteractionComplete)(interactionId, interaction);
            $911441c49a0faddf$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $911441c49a0faddf$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $cAaWV.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            $911441c49a0faddf$var$finishInteraction(interactionId, interaction, endTime);
            $911441c49a0faddf$export$d8f52e8f804021e8.reset();
            $911441c49a0faddf$export$d8f52e8f804021e8.stopVCObserver();
            $911441c49a0faddf$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $2x96i.default)((0, $cAaWV.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $9GPxu.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $911441c49a0faddf$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $911441c49a0faddf$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $911441c49a0faddf$var$finishInteraction(interactionId, interaction);
        $911441c49a0faddf$export$d8f52e8f804021e8.reset();
        $911441c49a0faddf$export$d8f52e8f804021e8.stopVCObserver();
        $911441c49a0faddf$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $2x96i.default)((0, $cAaWV.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $9GPxu.onExperimentalInteractionComplete)(interactionId, interaction);
            $911441c49a0faddf$export$cd7f480d6b8286c3(interactionId);
        }
    } else if ((0, $e6Qdr.fg)('platform_reset_post_interaction_on_new_interaction')) {
        // post-interaction log is active after interaction is aborted by new one
        $911441c49a0faddf$export$d8f52e8f804021e8.reset();
        $911441c49a0faddf$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $911441c49a0faddf$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $911441c49a0faddf$export$2b3954d2e8509985();
    const finishInteractions = (0, $cAaWV.getFinishInteractionOnTransition)();
    (0, $cQx5E.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions !== null && finishInteractions !== void 0 && finishInteractions.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $cAaWV.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $911441c49a0faddf$var$finishInteraction(interactionId, interaction, endTime);
            $911441c49a0faddf$export$d8f52e8f804021e8.reset();
            $911441c49a0faddf$export$d8f52e8f804021e8.stopVCObserver();
            $911441c49a0faddf$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $2x96i.default)((0, $cAaWV.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $9GPxu.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $911441c49a0faddf$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        if (!hasFinished) {
            $911441c49a0faddf$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $911441c49a0faddf$var$finishInteraction(interactionId, interaction);
        $911441c49a0faddf$export$d8f52e8f804021e8.reset();
        $911441c49a0faddf$export$d8f52e8f804021e8.stopVCObserver();
        $911441c49a0faddf$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $2x96i.default)((0, $cAaWV.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $9GPxu.onExperimentalInteractionComplete)(interactionId, interaction);
            $911441c49a0faddf$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $911441c49a0faddf$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $cQx5E.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $911441c49a0faddf$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    var _config$extraSearchPa, _config$extraSearchPa2;
    $911441c49a0faddf$export$481f88116dc8b7ad.reset();
    $911441c49a0faddf$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $cAaWV.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $911441c49a0faddf$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $911441c49a0faddf$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $2x96i.default)((0, $cAaWV.getCapabilityRate)('feature_flag_access'));
    const config = (0, $cAaWV.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 || (_config$extraSearchPa = config.extraSearchPageInteraction) === null || _config$extraSearchPa === void 0 ? void 0 : _config$extraSearchPa.enabled,
        searchPageRoute: config === null || config === void 0 || (_config$extraSearchPa2 = config.extraSearchPageInteraction) === null || _config$extraSearchPa2 === void 0 ? void 0 : _config$extraSearchPa2.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $3F1qw.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' && (0, $e6Qdr.fg)('platform_ufo_drop_prior_fg_interactions') ? {} : Object.fromEntries((0, $1M3oH.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $911441c49a0faddf$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $911441c49a0faddf$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $1M3oH.currentFeatureFlagsAccessed).clear();
    (0, $cQx5E.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $911441c49a0faddf$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $911441c49a0faddf$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $cAaWV.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $911441c49a0faddf$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig13, _config$extraInteract;
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig13 = (0, $cAaWV.getConfig)()) !== null && _getConfig13 !== void 0 && (_getConfig13 = _getConfig13.postInteractionLog) !== null && _getConfig13 !== void 0 && _getConfig13.enabled) $911441c49a0faddf$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $2x96i.default)((0, $cAaWV.getExperimentalInteractionRate)(ufoName, type))) (0, $9GPxu.experimentalVC).start({
            startTime: startTime
        });
        if (config !== null && config !== void 0 && (_config$extraInteract = config.extraInteractionMetrics) !== null && _config$extraInteract !== void 0 && _config$extraInteract.enabled) $911441c49a0faddf$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $911441c49a0faddf$export$4a759336b50e86e3(event) {
    const interaction = $911441c49a0faddf$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') $911441c49a0faddf$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $911441c49a0faddf$export$ad216cc25852d44b(apdex) {
    (0, $cQx5E.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $911441c49a0faddf$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $911441c49a0faddf$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $911441c49a0faddf$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $911441c49a0faddf$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $911441c49a0faddf$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $911441c49a0faddf$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($911441c49a0faddf$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $911441c49a0faddf$export$1c43f9ac826b6462(labelStack) {
    const key = $911441c49a0faddf$var$getSegmentCacheKey(labelStack);
    const existingSegment = $911441c49a0faddf$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $911441c49a0faddf$var$segmentCache.set(key, segmentInfo);
        $911441c49a0faddf$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $911441c49a0faddf$export$d0365e48b58231c3(labelStack) {
    const key = $911441c49a0faddf$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $911441c49a0faddf$var$segmentCache.get(key);
    if (segmentInfo) {
        $911441c49a0faddf$var$segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, $czEyx.stringifyLabelStackFully)(labelStack);
        $911441c49a0faddf$export$a2b14406ded37d60.set(cacheKey, ($911441c49a0faddf$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $911441c49a0faddf$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $911441c49a0faddf$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $cQx5E.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($911441c49a0faddf$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: (prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $911441c49a0faddf$export$6ce04c7ca6810a7e = [];
const $911441c49a0faddf$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $911441c49a0faddf$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $911441c49a0faddf$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $911441c49a0faddf$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("gdnRs", function(module, exports) {

var $bAyob = parcelRequire("bAyob");

var $9e0lC = parcelRequire("9e0lC");
var $030be07e4eef215e$var$uuid = $9e0lC;
$030be07e4eef215e$var$uuid.v1 = $bAyob;
$030be07e4eef215e$var$uuid.v4 = $9e0lC;
module.exports = $030be07e4eef215e$var$uuid;

});
parcelRegister("bAyob", function(module, exports) {

var $cGMw8 = parcelRequire("cGMw8");

var $lB50V = parcelRequire("lB50V");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $86fdbb7287c03d52$var$_nodeId;
var $86fdbb7287c03d52$var$_clockseq;
// Previous uuid creation time
var $86fdbb7287c03d52$var$_lastMSecs = 0;
var $86fdbb7287c03d52$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $86fdbb7287c03d52$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $86fdbb7287c03d52$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $86fdbb7287c03d52$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $cGMw8();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $86fdbb7287c03d52$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $86fdbb7287c03d52$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $86fdbb7287c03d52$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $86fdbb7287c03d52$var$_lastMSecs + (nsecs - $86fdbb7287c03d52$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $86fdbb7287c03d52$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $86fdbb7287c03d52$var$_lastMSecs = msecs;
    $86fdbb7287c03d52$var$_lastNSecs = nsecs;
    $86fdbb7287c03d52$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $lB50V(b);
}
module.exports = $86fdbb7287c03d52$var$v1;

});
parcelRegister("cGMw8", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $93cf0ad2b5c1120f$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($93cf0ad2b5c1120f$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $93cf0ad2b5c1120f$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $93cf0ad2b5c1120f$var$getRandomValues($93cf0ad2b5c1120f$var$rnds8);
        return $93cf0ad2b5c1120f$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $93cf0ad2b5c1120f$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $93cf0ad2b5c1120f$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $93cf0ad2b5c1120f$var$rnds;
    };
}

});

parcelRegister("lB50V", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $fb90f15b280a1f29$var$byteToHex = [];
for(var $fb90f15b280a1f29$var$i = 0; $fb90f15b280a1f29$var$i < 256; ++$fb90f15b280a1f29$var$i)$fb90f15b280a1f29$var$byteToHex[$fb90f15b280a1f29$var$i] = ($fb90f15b280a1f29$var$i + 0x100).toString(16).substr(1);
function $fb90f15b280a1f29$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $fb90f15b280a1f29$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $fb90f15b280a1f29$var$bytesToUuid;

});


parcelRegister("9e0lC", function(module, exports) {

var $cGMw8 = parcelRequire("cGMw8");

var $lB50V = parcelRequire("lB50V");
function $6b75b0eb32d0c1bd$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $cGMw8)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $lB50V(rnds);
}
module.exports = $6b75b0eb32d0c1bd$var$v4;

});


parcelRegister("e6Qdr", function(module, exports) {
$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $71cb8328060c1cea$export$ba05d765b8392e5e);
$parcel$export(module.exports, "fg", () => $71cb8328060c1cea$export$b40ec24ac8275656);

var $6v4eL = parcelRequire("6v4eL");
function $71cb8328060c1cea$export$ba05d765b8392e5e(flagResolver) {
    (0, $6v4eL.setBooleanResolver)(flagResolver);
}
function $71cb8328060c1cea$export$470e5c2be1411c89(name) {
    return (0, $6v4eL.resolveBooleanFlag)(name);
}
function $71cb8328060c1cea$export$b40ec24ac8275656(name) {
    return (0, $6v4eL.resolveBooleanFlag)(name);
}

});
parcelRegister("6v4eL", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $2e5e798eb52d12c8$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $2e5e798eb52d12c8$export$6333b6aff9fc6275);

var $1EFS8 = parcelRequire("1EFS8");

var $hHXe7 = parcelRequire("hHXe7");

var $6nQJh = parcelRequire("6nQJh");
const $2e5e798eb52d12c8$var$pkgName = '@atlaskit/platform-feature-flags';
const $2e5e798eb52d12c8$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $2e5e798eb52d12c8$var$hasProcessEnv = typeof $6nQJh !== 'undefined' && typeof $6nQJh.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $2e5e798eb52d12c8$var$ENV_ENABLE_PLATFORM_FF = $2e5e798eb52d12c8$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $2e5e798eb52d12c8$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2e5e798eb52d12c8$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
const $2e5e798eb52d12c8$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2e5e798eb52d12c8$var$ENV_ENABLE_PLATFORM_FF || $2e5e798eb52d12c8$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $2e5e798eb52d12c8$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $2e5e798eb52d12c8$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$2e5e798eb52d12c8$var$globalVar[$2e5e798eb52d12c8$export$7e41b1b2bdee3f98] = $2e5e798eb52d12c8$var$globalVar[$2e5e798eb52d12c8$export$7e41b1b2bdee3f98] || $2e5e798eb52d12c8$var$DEFAULT_PFF_GLOBAL;
function $2e5e798eb52d12c8$export$f2b591175b3e424c(resolver) {
    $2e5e798eb52d12c8$var$globalVar[$2e5e798eb52d12c8$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $2e5e798eb52d12c8$export$6333b6aff9fc6275(flagKey) {
    if ($2e5e798eb52d12c8$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $hHXe7.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2e5e798eb52d12c8$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $2e5e798eb52d12c8$var$globalVar[$2e5e798eb52d12c8$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $2e5e798eb52d12c8$var$globalVar[$2e5e798eb52d12c8$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $1EFS8.default).checkGate(flagKey);
        const result = (_globalVar$PFF_GLOBAL3 = $2e5e798eb52d12c8$var$globalVar[$2e5e798eb52d12c8$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("1EFS8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b972157158aa330$export$2e2bcd8739ae039);

var $dm5sF = parcelRequire("dm5sF");

var $2TU1X = parcelRequire("2TU1X");



var $4G9cg = parcelRequire("4G9cg");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $1b972157158aa330$var$FeatureGates {
    static #_ = this.client = new (0, $dm5sF.Client)();
    static #_2 = this.hasCheckGateErrorOccurred = false;
    static #_3 = this.hasGetExperimentValueErrorOccurred = false;
    static #_4 = this.checkGate = (gateName, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                // Attempt to retrieve an override value for the feature gate
                const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                // If an override value is found, return it immediately
                if (overrideValue !== undefined) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$1b972157158aa330$var$FeatureGates.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                $1b972157158aa330$var$FeatureGates.hasCheckGateErrorOccurred = true;
            }
        }
        // Proceed with the main logic if no override is found
        return this.client.checkGate(gateName, options);
    };
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static #_5 = this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$1b972157158aa330$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
        // Proceed with the main logic if no override is found
        return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
    };
    static #_6 = this.initializeCalled = this.client.initializeCalled.bind(this.client);
    static #_7 = this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    static #_8 = this.waitUntilInitializeCompleted = this.client.waitUntilInitializeCompleted.bind(this.client);
    static #_9 = this.initialize = this.client.initialize.bind(this.client);
    static #_10 = this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    static #_11 = this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    static #_12 = this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    static #_13 = this.getExperiment = this.client.getExperiment.bind(this.client);
    static #_14 = this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    static #_15 = this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    static #_16 = this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    static #_17 = this.overrideGate = this.client.overrideGate.bind(this.client);
    static #_18 = this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    static #_19 = this.overrideConfig = this.client.overrideConfig.bind(this.client);
    static #_20 = this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    static #_21 = this.setOverrides = this.client.setOverrides.bind(this.client);
    static #_22 = this.getOverrides = this.client.getOverrides.bind(this.client);
    static #_23 = this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    static #_24 = this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    static #_25 = this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    static #_26 = this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    static #_27 = this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    static #_28 = this.updateUser = this.client.updateUser.bind(this.client);
    static #_29 = this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    static #_30 = this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    static #_31 = this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    static #_32 = this.getLayer = this.client.getLayer.bind(this.client);
    static #_33 = this.getLayerValue = this.client.getLayerValue.bind(this.client);
}
let $1b972157158aa330$var$boundFGJS = $1b972157158aa330$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $1b972157158aa330$var$FeatureGates;
    else {
        var $1b972157158aa330$var$_boundFGJS, $1b972157158aa330$var$_boundFGJS$getPackage;
        $1b972157158aa330$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = (($1b972157158aa330$var$_boundFGJS = $1b972157158aa330$var$boundFGJS) === null || $1b972157158aa330$var$_boundFGJS === void 0 || ($1b972157158aa330$var$_boundFGJS$getPackage = $1b972157158aa330$var$_boundFGJS.getPackageVersion) === null || $1b972157158aa330$var$_boundFGJS$getPackage === void 0 ? void 0 : $1b972157158aa330$var$_boundFGJS$getPackage.call($1b972157158aa330$var$_boundFGJS)) || '4.10.0 or earlier';
        if (boundVersion !== (0, $2TU1X.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $2TU1X.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $1b972157158aa330$export$2e2bcd8739ae039 = $1b972157158aa330$var$boundFGJS;

});
parcelRegister("dm5sF", function(module, exports) {
$parcel$export(module.exports, "Client", () => $98f9abcde45d5405$export$1f2bb630327ac4b6);

var $25A38 = parcelRequire("25A38");

var $f6JQl = parcelRequire("f6JQl");

var $cjJZ4 = parcelRequire("cjJZ4");

var $gn9Xz = parcelRequire("gn9Xz");

var $jctIQ = parcelRequire("jctIQ");

var $dYLIm = parcelRequire("dYLIm");

var $aM04y = parcelRequire("aM04y");

var $fPG58 = parcelRequire("fPG58");

var $4G9cg = parcelRequire("4G9cg");

var $b82EI = parcelRequire("b82EI");

var $2TU1X = parcelRequire("2TU1X");
const $98f9abcde45d5405$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $98f9abcde45d5405$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $98f9abcde45d5405$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $fPG58.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
   * True if an initialize method was called and completed, meaning the client is now usable.
   * However if there was an error during initialization it may have initialized with default
   * values. Use {@link initCompleted} to check for this.
   */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $f6JQl.default)();
        this.dataAdapter = new (0, $aM04y.NoFetchDataAdapter)();
        /**
   * Call this if modifying the values being served by the Statsig library since it has its own
   * memoization cache which will not be updated if the values are changed outside of the library.
   */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $fPG58.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $b82EI.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $b82EI.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $b82EI.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $b82EI.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $2TU1X.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        var _analyticsWebClient;
        (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $2TU1X.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $4G9cg.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $b82EI.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $b82EI.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $b82EI.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $dYLIm.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $cjJZ4.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $cjJZ4.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $jctIQ.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        var _this$statsigClient$g;
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) {
            var _this$statsigClient;
            (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
        }
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $b82EI.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $b82EI.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $dYLIm.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $dYLIm.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        var _newClientOptions$net;
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $b82EI.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $98f9abcde45d5405$var$DEFAULT_CLIENT_KEY;
        if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $98f9abcde45d5405$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $4G9cg.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        const frontendUser = (0, $b82EI.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, $b82EI.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $25A38.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $25A38.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $25A38.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $25A38.StatsigClient)($98f9abcde45d5405$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        var _this$initOptions, _this$initOptions$upd;
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            const frontendUser = (0, $b82EI.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
            user = (0, $b82EI.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        } catch (err) {
            var _updateUserCompletion, _ref;
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            (_updateUserCompletion = (_ref = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref, false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $2TU1X.CLIENT_VERSION;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $gn9Xz.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $gn9Xz.Layer).fromLayer((0, $25A38._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("25A38", function(module, exports) {
"use strict";
var $185803155ca864e8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $185803155ca864e8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $185803155ca864e8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $6QnCP = parcelRequire("6QnCP");
module.exports.StatsigClient = $6QnCP.default;

$185803155ca864e8$var$__exportStar((parcelRequire("jsYdF")), module.exports);
const $185803155ca864e8$var$__STATSIG__ = Object.assign((0, (parcelRequire("jsYdF"))._getStatsigGlobal)(), {
    StatsigClient: $6QnCP.default
});
module.exports.default = $185803155ca864e8$var$__STATSIG__;

});
parcelRegister("jsYdF", function(module, exports) {
"use strict";
var $e2bf582aa1ff33ae$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e2bf582aa1ff33ae$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e2bf582aa1ff33ae$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("6uxgh")).Diagnostics;
    }
});

var $hwS9J = parcelRequire("hwS9J");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $hwS9J.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("5UTbF")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9VPyF")).Storage;
    }
});

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("kp2KG")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("bLydQ")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("6ov4E")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("25DlC")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("6uxgh")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("5pGQI")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("9pua7")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("45UAy")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("7u2ed")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("dvzcf")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("5q6Y4")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("5UTbF")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("ke05s")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("hGdaC")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("8JHTN")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("k1V5I")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("iggch")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("7kd8P")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("9SNK2")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("BVuCS")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("lJCRI")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("61sxj")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("d5Sq8")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("hMgh1")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("jKS9e")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("e3whw")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("9Gu55")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("eUCHo")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("5J2Ys")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("gTZ4F")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("fkEAr")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("60fOA")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("9VPyF")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("leoZm")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("hpkgr")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("gp44t")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("28i4u")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("6jEgT")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("gku4O")), module.exports);

$e2bf582aa1ff33ae$var$__exportStar((parcelRequire("JJ96z")), module.exports);
Object.assign((0, (parcelRequire("kp2KG"))._getStatsigGlobal)(), {
    Log: (parcelRequire("5UTbF")).Log,
    SDK_VERSION: (parcelRequire("9Gu55")).SDK_VERSION
});

});
parcelRegister("kp2KG", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $eda846e7305348d3$var$_a, $eda846e7305348d3$var$_b, $eda846e7305348d3$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $5UTbF = parcelRequire("5UTbF");
const $eda846e7305348d3$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $eda846e7305348d3$var$statsigGlobal;
    } catch (e) {
        return $eda846e7305348d3$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $eda846e7305348d3$var$_getStatsigGlobal;
const $eda846e7305348d3$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $eda846e7305348d3$var$_getStatsigGlobalFlag;
const $eda846e7305348d3$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $5UTbF.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $eda846e7305348d3$var$_getInstance;
const $eda846e7305348d3$var$GLOBAL_KEY = '__STATSIG__';
const $eda846e7305348d3$var$_window = typeof window !== 'undefined' ? window : {};
const $eda846e7305348d3$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $eda846e7305348d3$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $eda846e7305348d3$var$statsigGlobal = ($eda846e7305348d3$var$_c = ($eda846e7305348d3$var$_b = ($eda846e7305348d3$var$_a = $eda846e7305348d3$var$_window[$eda846e7305348d3$var$GLOBAL_KEY]) !== null && $eda846e7305348d3$var$_a !== void 0 ? $eda846e7305348d3$var$_a : $eda846e7305348d3$var$_global[$eda846e7305348d3$var$GLOBAL_KEY]) !== null && $eda846e7305348d3$var$_b !== void 0 ? $eda846e7305348d3$var$_b : $eda846e7305348d3$var$_globalThis[$eda846e7305348d3$var$GLOBAL_KEY]) !== null && $eda846e7305348d3$var$_c !== void 0 ? $eda846e7305348d3$var$_c : {
    instance: module.exports._getInstance
};
$eda846e7305348d3$var$_window[$eda846e7305348d3$var$GLOBAL_KEY] = $eda846e7305348d3$var$statsigGlobal;
$eda846e7305348d3$var$_global[$eda846e7305348d3$var$GLOBAL_KEY] = $eda846e7305348d3$var$statsigGlobal;
$eda846e7305348d3$var$_globalThis[$eda846e7305348d3$var$GLOBAL_KEY] = $eda846e7305348d3$var$statsigGlobal;

});
parcelRegister("5UTbF", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $44ecfdba103b2727$var$DEBUG = ' DEBUG ';
const $44ecfdba103b2727$var$_INFO = '  INFO ';
const $44ecfdba103b2727$var$_WARN = '  WARN ';
const $44ecfdba103b2727$var$ERROR = ' ERROR ';
function $44ecfdba103b2727$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $44ecfdba103b2727$var$Log {
    static info(...args) {
        if ($44ecfdba103b2727$var$Log.level >= module.exports.LogLevel.Info) console.info($44ecfdba103b2727$var$_INFO, ...$44ecfdba103b2727$var$addTag(args));
    }
    static debug(...args) {
        if ($44ecfdba103b2727$var$Log.level >= module.exports.LogLevel.Debug) console.debug($44ecfdba103b2727$var$DEBUG, ...$44ecfdba103b2727$var$addTag(args));
    }
    static warn(...args) {
        if ($44ecfdba103b2727$var$Log.level >= module.exports.LogLevel.Warn) console.warn($44ecfdba103b2727$var$_WARN, ...$44ecfdba103b2727$var$addTag(args));
    }
    static error(...args) {
        if ($44ecfdba103b2727$var$Log.level >= module.exports.LogLevel.Error) console.error($44ecfdba103b2727$var$ERROR, ...$44ecfdba103b2727$var$addTag(args));
    }
}
module.exports.Log = $44ecfdba103b2727$var$Log;
$44ecfdba103b2727$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("6uxgh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $4b9f5874ec958e13$var$MARKER_MAP = new Map();
const $4b9f5874ec958e13$var$ACT_START = 'start';
const $4b9f5874ec958e13$var$ACT_END = 'end';
const $4b9f5874ec958e13$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $4b9f5874ec958e13$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $4b9f5874ec958e13$var$_addMarker(sdkKey, $4b9f5874ec958e13$var$_createMarker({}, $4b9f5874ec958e13$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $4b9f5874ec958e13$var$_addMarker(sdkKey, $4b9f5874ec958e13$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $4b9f5874ec958e13$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $4b9f5874ec958e13$var$_addMarker(sdkKey, $4b9f5874ec958e13$var$_createMarker(data, $4b9f5874ec958e13$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $4b9f5874ec958e13$var$_addMarker(sdkKey, $4b9f5874ec958e13$var$_createMarker(data, $4b9f5874ec958e13$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $4b9f5874ec958e13$var$_addMarker(sdkKey, $4b9f5874ec958e13$var$_createMarker({}, $4b9f5874ec958e13$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $4b9f5874ec958e13$var$_addMarker(sdkKey, $4b9f5874ec958e13$var$_createMarker(data, $4b9f5874ec958e13$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $4b9f5874ec958e13$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $4b9f5874ec958e13$var$_safeGetField(e, 'code'),
            name: $4b9f5874ec958e13$var$_safeGetField(e, 'name'),
            message: $4b9f5874ec958e13$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $4b9f5874ec958e13$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $4b9f5874ec958e13$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $4b9f5874ec958e13$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $4b9f5874ec958e13$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $4b9f5874ec958e13$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $4b9f5874ec958e13$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $4b9f5874ec958e13$var$MARKER_MAP.set(sdkKey, markers);
}
function $4b9f5874ec958e13$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("hwS9J", function(module, exports) {
"use strict";
var $cc2f6f15db1bec36$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $bLydQ = parcelRequire("bLydQ");

var $dvzcf = parcelRequire("dvzcf");

var $5UTbF = parcelRequire("5UTbF");

var $hGdaC = parcelRequire("hGdaC");

var $7kd8P = parcelRequire("7kd8P");

var $e3whw = parcelRequire("e3whw");

var $eUCHo = parcelRequire("eUCHo");

var $9VPyF = parcelRequire("9VPyF");

var $gp44t = parcelRequire("gp44t");

var $6jEgT = parcelRequire("6jEgT");
const $cc2f6f15db1bec36$var$DEFAULT_QUEUE_SIZE = 100;
const $cc2f6f15db1bec36$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $cc2f6f15db1bec36$var$MAX_DEDUPER_KEYS = 1000;
const $cc2f6f15db1bec36$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $cc2f6f15db1bec36$var$MAX_FAILED_LOGS = 500;
const $cc2f6f15db1bec36$var$QUICK_FLUSH_WINDOW_MS = 200;
const $cc2f6f15db1bec36$var$EVENT_LOGGER_MAP = {};
class $cc2f6f15db1bec36$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $cc2f6f15db1bec36$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $cc2f6f15db1bec36$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $eUCHo.LoggingEnabledOption.disabled : $eUCHo.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $5UTbF.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $cc2f6f15db1bec36$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $gp44t.UrlConfiguration($hGdaC.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $9VPyF._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $9VPyF.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $cc2f6f15db1bec36$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $7kd8P._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $cc2f6f15db1bec36$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $6jEgT._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $cc2f6f15db1bec36$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $cc2f6f15db1bec36$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $cc2f6f15db1bec36$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $cc2f6f15db1bec36$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $cc2f6f15db1bec36$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $cc2f6f15db1bec36$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$cc2f6f15db1bec36$var$EventLogger._safeFlushAndForget(this._sdkKey), $cc2f6f15db1bec36$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $7kd8P._isServerEnv)()) return false;
        if (!(0, $e3whw._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $bLydQ._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $cc2f6f15db1bec36$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $cc2f6f15db1bec36$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $cc2f6f15db1bec36$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $6jEgT._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $5UTbF.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $5UTbF.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $cc2f6f15db1bec36$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$hGdaC.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $cc2f6f15db1bec36$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $9VPyF._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $5UTbF.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $9VPyF._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$cc2f6f15db1bec36$var$__awaiter(this, void 0, void 0, function*() {
                if (!$9VPyF.Storage.isReady()) yield $9VPyF.Storage.isReadyResolver();
                const events = (0, $9VPyF._getObjectFromStorage)(storageKey);
                if (!events) return;
                $9VPyF.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $5UTbF.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $dvzcf._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $5UTbF.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $7kd8P._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $cc2f6f15db1bec36$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $cc2f6f15db1bec36$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $cc2f6f15db1bec36$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $cc2f6f15db1bec36$var$EventLogger;

});
parcelRegister("bLydQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $dvzcf = parcelRequire("dvzcf");
function $890ea1561fb94553$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $dvzcf._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $890ea1561fb94553$var$_getUserStorageKey;
function $890ea1561fb94553$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $890ea1561fb94553$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $dvzcf._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $890ea1561fb94553$var$_getStorageKey;

});
parcelRegister("dvzcf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $hpkgr = parcelRequire("hpkgr");
const $9d5978effd93faca$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $9d5978effd93faca$var$_DJB2;
const $9d5978effd93faca$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $9d5978effd93faca$var$_DJB2Object;
const $9d5978effd93faca$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $hpkgr._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $9d5978effd93faca$var$_getSortedObject;

});
parcelRegister("hpkgr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $cac47d822bb35818$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $cac47d822bb35818$var$_typeOf;
function $cac47d822bb35818$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $cac47d822bb35818$var$_isTypeMatch;

});



parcelRegister("hGdaC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("7kd8P", function(module, exports) {

var $6nQJh = parcelRequire("6nQJh");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $55549846b004ce76$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $55549846b004ce76$var$_getWindowSafe;
const $55549846b004ce76$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $55549846b004ce76$var$_getDocumentSafe;
const $55549846b004ce76$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $6nQJh !== 'undefined' && $6nQJh.versions != null && $6nQJh.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $55549846b004ce76$var$_isServerEnv;
const $55549846b004ce76$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $55549846b004ce76$var$_addWindowEventListenerSafe;
const $55549846b004ce76$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $55549846b004ce76$var$_addDocumentEventListenerSafe;
const $55549846b004ce76$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $55549846b004ce76$var$_getCurrentPageUrlSafe;
const $55549846b004ce76$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $55549846b004ce76$var$_getUnloadEvent;

});
parcelRegister("6nQJh", function(module, exports) {
// shim for using process in browser
var $4a5dcb04ae0e12c8$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4a5dcb04ae0e12c8$var$cachedSetTimeout;
var $4a5dcb04ae0e12c8$var$cachedClearTimeout;
function $4a5dcb04ae0e12c8$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $4a5dcb04ae0e12c8$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $4a5dcb04ae0e12c8$var$cachedSetTimeout = setTimeout;
        else $4a5dcb04ae0e12c8$var$cachedSetTimeout = $4a5dcb04ae0e12c8$var$defaultSetTimout;
    } catch (e) {
        $4a5dcb04ae0e12c8$var$cachedSetTimeout = $4a5dcb04ae0e12c8$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $4a5dcb04ae0e12c8$var$cachedClearTimeout = clearTimeout;
        else $4a5dcb04ae0e12c8$var$cachedClearTimeout = $4a5dcb04ae0e12c8$var$defaultClearTimeout;
    } catch (e) {
        $4a5dcb04ae0e12c8$var$cachedClearTimeout = $4a5dcb04ae0e12c8$var$defaultClearTimeout;
    }
})();
function $4a5dcb04ae0e12c8$var$runTimeout(fun) {
    if ($4a5dcb04ae0e12c8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4a5dcb04ae0e12c8$var$cachedSetTimeout === $4a5dcb04ae0e12c8$var$defaultSetTimout || !$4a5dcb04ae0e12c8$var$cachedSetTimeout) && setTimeout) {
        $4a5dcb04ae0e12c8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4a5dcb04ae0e12c8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4a5dcb04ae0e12c8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4a5dcb04ae0e12c8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4a5dcb04ae0e12c8$var$runClearTimeout(marker) {
    if ($4a5dcb04ae0e12c8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4a5dcb04ae0e12c8$var$cachedClearTimeout === $4a5dcb04ae0e12c8$var$defaultClearTimeout || !$4a5dcb04ae0e12c8$var$cachedClearTimeout) && clearTimeout) {
        $4a5dcb04ae0e12c8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4a5dcb04ae0e12c8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4a5dcb04ae0e12c8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4a5dcb04ae0e12c8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4a5dcb04ae0e12c8$var$queue = [];
var $4a5dcb04ae0e12c8$var$draining = false;
var $4a5dcb04ae0e12c8$var$currentQueue;
var $4a5dcb04ae0e12c8$var$queueIndex = -1;
function $4a5dcb04ae0e12c8$var$cleanUpNextTick() {
    if (!$4a5dcb04ae0e12c8$var$draining || !$4a5dcb04ae0e12c8$var$currentQueue) return;
    $4a5dcb04ae0e12c8$var$draining = false;
    if ($4a5dcb04ae0e12c8$var$currentQueue.length) $4a5dcb04ae0e12c8$var$queue = $4a5dcb04ae0e12c8$var$currentQueue.concat($4a5dcb04ae0e12c8$var$queue);
    else $4a5dcb04ae0e12c8$var$queueIndex = -1;
    if ($4a5dcb04ae0e12c8$var$queue.length) $4a5dcb04ae0e12c8$var$drainQueue();
}
function $4a5dcb04ae0e12c8$var$drainQueue() {
    if ($4a5dcb04ae0e12c8$var$draining) return;
    var timeout = $4a5dcb04ae0e12c8$var$runTimeout($4a5dcb04ae0e12c8$var$cleanUpNextTick);
    $4a5dcb04ae0e12c8$var$draining = true;
    var len = $4a5dcb04ae0e12c8$var$queue.length;
    while(len){
        $4a5dcb04ae0e12c8$var$currentQueue = $4a5dcb04ae0e12c8$var$queue;
        $4a5dcb04ae0e12c8$var$queue = [];
        while(++$4a5dcb04ae0e12c8$var$queueIndex < len)if ($4a5dcb04ae0e12c8$var$currentQueue) $4a5dcb04ae0e12c8$var$currentQueue[$4a5dcb04ae0e12c8$var$queueIndex].run();
        $4a5dcb04ae0e12c8$var$queueIndex = -1;
        len = $4a5dcb04ae0e12c8$var$queue.length;
    }
    $4a5dcb04ae0e12c8$var$currentQueue = null;
    $4a5dcb04ae0e12c8$var$draining = false;
    $4a5dcb04ae0e12c8$var$runClearTimeout(timeout);
}
$4a5dcb04ae0e12c8$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4a5dcb04ae0e12c8$var$queue.push(new $4a5dcb04ae0e12c8$var$Item(fun, args));
    if ($4a5dcb04ae0e12c8$var$queue.length === 1 && !$4a5dcb04ae0e12c8$var$draining) $4a5dcb04ae0e12c8$var$runTimeout($4a5dcb04ae0e12c8$var$drainQueue);
};
// v8 likes predictible objects
function $4a5dcb04ae0e12c8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4a5dcb04ae0e12c8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4a5dcb04ae0e12c8$var$process.title = 'browser';
$4a5dcb04ae0e12c8$var$process.browser = true;
$4a5dcb04ae0e12c8$var$process.env = {};
$4a5dcb04ae0e12c8$var$process.argv = [];
$4a5dcb04ae0e12c8$var$process.version = ''; // empty string to avoid regexp issues
$4a5dcb04ae0e12c8$var$process.versions = {};
function $4a5dcb04ae0e12c8$var$noop() {}
$4a5dcb04ae0e12c8$var$process.on = $4a5dcb04ae0e12c8$var$noop;
$4a5dcb04ae0e12c8$var$process.addListener = $4a5dcb04ae0e12c8$var$noop;
$4a5dcb04ae0e12c8$var$process.once = $4a5dcb04ae0e12c8$var$noop;
$4a5dcb04ae0e12c8$var$process.off = $4a5dcb04ae0e12c8$var$noop;
$4a5dcb04ae0e12c8$var$process.removeListener = $4a5dcb04ae0e12c8$var$noop;
$4a5dcb04ae0e12c8$var$process.removeAllListeners = $4a5dcb04ae0e12c8$var$noop;
$4a5dcb04ae0e12c8$var$process.emit = $4a5dcb04ae0e12c8$var$noop;
$4a5dcb04ae0e12c8$var$process.prependListener = $4a5dcb04ae0e12c8$var$noop;
$4a5dcb04ae0e12c8$var$process.prependOnceListener = $4a5dcb04ae0e12c8$var$noop;
$4a5dcb04ae0e12c8$var$process.listeners = function(name) {
    return [];
};
$4a5dcb04ae0e12c8$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$4a5dcb04ae0e12c8$var$process.cwd = function() {
    return '/';
};
$4a5dcb04ae0e12c8$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$4a5dcb04ae0e12c8$var$process.umask = function() {
    return 0;
};

});


parcelRegister("e3whw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $a3ba62f85ca62fe5$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $a3ba62f85ca62fe5$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $a3ba62f85ca62fe5$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $a3ba62f85ca62fe5$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $a3ba62f85ca62fe5$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $a3ba62f85ca62fe5$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $a3ba62f85ca62fe5$var$GATE_EXPOSURE_NAME || eventName === $a3ba62f85ca62fe5$var$CONFIG_EXPOSURE_NAME || eventName === $a3ba62f85ca62fe5$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $a3ba62f85ca62fe5$var$_isExposureEvent;
const $a3ba62f85ca62fe5$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $a3ba62f85ca62fe5$var$_createExposure($a3ba62f85ca62fe5$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $a3ba62f85ca62fe5$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $a3ba62f85ca62fe5$var$_createGateExposure;
function $a3ba62f85ca62fe5$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $a3ba62f85ca62fe5$var$_mapExposures;
const $a3ba62f85ca62fe5$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $a3ba62f85ca62fe5$var$_createExposure($a3ba62f85ca62fe5$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $a3ba62f85ca62fe5$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $a3ba62f85ca62fe5$var$_createConfigExposure;
const $a3ba62f85ca62fe5$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $a3ba62f85ca62fe5$var$_createExposure($a3ba62f85ca62fe5$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $a3ba62f85ca62fe5$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $a3ba62f85ca62fe5$var$_createLayerParameterExposure;
const $a3ba62f85ca62fe5$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("eUCHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("9VPyF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $5UTbF = parcelRequire("5UTbF");

var $7kd8P = parcelRequire("7kd8P");
const $73b16e48824d783c$var$inMemoryStore = {};
const $73b16e48824d783c$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$73b16e48824d783c$var$inMemoryStore[key] ? $73b16e48824d783c$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $73b16e48824d783c$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $73b16e48824d783c$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($73b16e48824d783c$var$inMemoryStore)
};
let $73b16e48824d783c$var$_localStorageProvider = null;
try {
    const win = (0, $7kd8P._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $73b16e48824d783c$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $5UTbF.Log.warn('Failed to setup localStorageProvider.');
}
let $73b16e48824d783c$var$_main = $73b16e48824d783c$var$_localStorageProvider !== null && $73b16e48824d783c$var$_localStorageProvider !== void 0 ? $73b16e48824d783c$var$_localStorageProvider : $73b16e48824d783c$var$_inMemoryProvider;
let $73b16e48824d783c$var$_current = $73b16e48824d783c$var$_main;
function $73b16e48824d783c$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($73b16e48824d783c$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$73b16e48824d783c$var$_current.isReady(),
    isReadyResolver: ()=>$73b16e48824d783c$var$_current.isReadyResolver(),
    getProviderName: ()=>$73b16e48824d783c$var$_current.getProviderName(),
    getItem: (key)=>$73b16e48824d783c$var$_inMemoryBreaker(()=>$73b16e48824d783c$var$_current.getItem(key)),
    setItem: (key, value)=>$73b16e48824d783c$var$_inMemoryBreaker(()=>$73b16e48824d783c$var$_current.setItem(key, value)),
    removeItem: (key)=>$73b16e48824d783c$var$_current.removeItem(key),
    getAllKeys: ()=>$73b16e48824d783c$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $73b16e48824d783c$var$_main = newProvider;
        $73b16e48824d783c$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $73b16e48824d783c$var$_current = $73b16e48824d783c$var$_inMemoryProvider;
        else $73b16e48824d783c$var$_current = $73b16e48824d783c$var$_main;
    }
};
function $73b16e48824d783c$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $5UTbF.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $73b16e48824d783c$var$_getObjectFromStorage;
function $73b16e48824d783c$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $73b16e48824d783c$var$_setObjectInStorage;

});

parcelRegister("gp44t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $dvzcf = parcelRequire("dvzcf");

var $hGdaC = parcelRequire("hGdaC");
const $bf12239a2f9a3131$var$ENDPOINT_DNS_KEY_MAP = {
    [$hGdaC.Endpoint._initialize]: 'i',
    [$hGdaC.Endpoint._rgstr]: 'e',
    [$hGdaC.Endpoint._download_config_specs]: 'd'
};
class $bf12239a2f9a3131$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $bf12239a2f9a3131$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $hGdaC.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $dvzcf._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $bf12239a2f9a3131$var$UrlConfiguration;

});

parcelRegister("6jEgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $7kd8P = parcelRequire("7kd8P");
const $4993c17a1f98d2e2$var$FOREGROUND = 'foreground';
const $4993c17a1f98d2e2$var$BACKGROUND = 'background';
const $4993c17a1f98d2e2$var$LISTENERS = [];
let $4993c17a1f98d2e2$var$current = $4993c17a1f98d2e2$var$FOREGROUND;
let $4993c17a1f98d2e2$var$isUnloading = false;
const $4993c17a1f98d2e2$var$_isCurrentlyVisible = ()=>{
    return $4993c17a1f98d2e2$var$current === $4993c17a1f98d2e2$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $4993c17a1f98d2e2$var$_isCurrentlyVisible;
const $4993c17a1f98d2e2$var$_isUnloading = ()=>$4993c17a1f98d2e2$var$isUnloading;
module.exports._isUnloading = $4993c17a1f98d2e2$var$_isUnloading;
const $4993c17a1f98d2e2$var$_subscribeToVisiblityChanged = (listener)=>{
    $4993c17a1f98d2e2$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $4993c17a1f98d2e2$var$_subscribeToVisiblityChanged;
const $4993c17a1f98d2e2$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $4993c17a1f98d2e2$var$current) return;
    $4993c17a1f98d2e2$var$current = visibility;
    $4993c17a1f98d2e2$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $4993c17a1f98d2e2$var$_notifyVisibilityChanged;
(0, $7kd8P._addWindowEventListenerSafe)('focus', ()=>{
    $4993c17a1f98d2e2$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($4993c17a1f98d2e2$var$FOREGROUND);
});
(0, $7kd8P._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($4993c17a1f98d2e2$var$BACKGROUND));
(0, $7kd8P._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $4993c17a1f98d2e2$var$FOREGROUND : $4993c17a1f98d2e2$var$BACKGROUND);
});
(0, $7kd8P._addWindowEventListenerSafe)((0, $7kd8P._getUnloadEvent)(), ()=>{
    $4993c17a1f98d2e2$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($4993c17a1f98d2e2$var$BACKGROUND);
});

});


parcelRegister("9Gu55", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $70cf5ec04fb5a70e$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$70cf5ec04fb5a70e$var$metadata,
    add: (additions)=>{
        $70cf5ec04fb5a70e$var$metadata = Object.assign(Object.assign({}, $70cf5ec04fb5a70e$var$metadata), additions);
    }
};

});

parcelRegister("6ov4E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("25DlC", function(module, exports) {
"use strict";
var $185a92066b573f2d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $5UTbF = parcelRequire("5UTbF");

var $61sxj = parcelRequire("61sxj");

var $60fOA = parcelRequire("60fOA");

var $9VPyF = parcelRequire("9VPyF");

var $leoZm = parcelRequire("leoZm");
const $185a92066b573f2d$var$CACHE_LIMIT = 10;
const $185a92066b573f2d$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $185a92066b573f2d$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $185a92066b573f2d$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $185a92066b573f2d$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $60fOA._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $60fOA._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $185a92066b573f2d$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $61sxj.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $185a92066b573f2d$var$__awaiter(this, void 0, void 0, function*() {
            if (!$9VPyF.Storage.isReady()) yield $9VPyF.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $5UTbF.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $185a92066b573f2d$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $60fOA._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $185a92066b573f2d$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $5UTbF.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $leoZm._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $61sxj.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $185a92066b573f2d$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $185a92066b573f2d$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $5UTbF.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $9VPyF.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($9VPyF.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $leoZm._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $185a92066b573f2d$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $9VPyF.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $9VPyF._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $185a92066b573f2d$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $9VPyF.Storage.removeItem(evictable);
        }
        (0, $9VPyF._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $185a92066b573f2d$var$DataAdapterCore;
function $185a92066b573f2d$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $60fOA._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $185a92066b573f2d$var$_makeDataAdapterResult;
class $185a92066b573f2d$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $5UTbF.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $185a92066b573f2d$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $185a92066b573f2d$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("61sxj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $bLydQ = parcelRequire("bLydQ");

var $5UTbF = parcelRequire("5UTbF");

var $7kd8P = parcelRequire("7kd8P");

var $9VPyF = parcelRequire("9VPyF");

var $28i4u = parcelRequire("28i4u");
const $4628f8ced0fe6cac$var$PROMISE_MAP = {};
const $4628f8ced0fe6cac$var$COOKIE_ENABLED_MAP = {};
const $4628f8ced0fe6cac$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($4628f8ced0fe6cac$var$DISABLED_MAP[sdkKey]) return null;
        if ($4628f8ced0fe6cac$var$PROMISE_MAP[sdkKey] != null) return $4628f8ced0fe6cac$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $4628f8ced0fe6cac$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $4628f8ced0fe6cac$var$PROMISE_MAP[sdkKey] = stableID;
            $4628f8ced0fe6cac$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $4628f8ced0fe6cac$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $28i4u.getUUID)();
        $4628f8ced0fe6cac$var$_persistToStorage(stableID, sdkKey);
        $4628f8ced0fe6cac$var$_persistToCookie(stableID, sdkKey);
        $4628f8ced0fe6cac$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $4628f8ced0fe6cac$var$PROMISE_MAP[sdkKey] = override;
        $4628f8ced0fe6cac$var$_persistToStorage(override, sdkKey);
        $4628f8ced0fe6cac$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $4628f8ced0fe6cac$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $4628f8ced0fe6cac$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $4628f8ced0fe6cac$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $bLydQ._getStorageKey)(sdkKey)}`;
}
function $4628f8ced0fe6cac$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $4628f8ced0fe6cac$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $9VPyF._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $5UTbF.Log.warn('Failed to save StableID to storage');
    }
}
function $4628f8ced0fe6cac$var$_loadFromStorage(sdkKey) {
    const storageKey = $4628f8ced0fe6cac$var$_getStableIDStorageKey(sdkKey);
    return (0, $9VPyF._getObjectFromStorage)(storageKey);
}
function $4628f8ced0fe6cac$var$_loadFromCookie(sdkKey) {
    if (!$4628f8ced0fe6cac$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $7kd8P._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $4628f8ced0fe6cac$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $4628f8ced0fe6cac$var$_persistToCookie(stableID, sdkKey) {
    if (!$4628f8ced0fe6cac$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $7kd8P._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$4628f8ced0fe6cac$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $4628f8ced0fe6cac$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $bLydQ._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $4628f8ced0fe6cac$var$getCookieName;

});
parcelRegister("28i4u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $18da58b9077dd79f$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $18da58b9077dd79f$var$getUUID;

});


parcelRegister("60fOA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $dvzcf = parcelRequire("dvzcf");

var $5UTbF = parcelRequire("5UTbF");
function $0120c21b8af3a032$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $5UTbF.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $0120c21b8af3a032$var$_normalizeUser;
function $0120c21b8af3a032$var$_getFullUserHash(user) {
    return user ? (0, $dvzcf._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $0120c21b8af3a032$var$_getFullUserHash;

});

parcelRegister("leoZm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $5UTbF = parcelRequire("5UTbF");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $f74e4a05164f3def$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $5UTbF.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $f74e4a05164f3def$var$_typedJsonParse;

});


parcelRegister("5pGQI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9pua7", function(module, exports) {
"use strict";
var $6d9dd86ae432d224$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $5UTbF = parcelRequire("5UTbF");

var $9SNK2 = parcelRequire("9SNK2");

var $9Gu55 = parcelRequire("9Gu55");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $6d9dd86ae432d224$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $6d9dd86ae432d224$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $6d9dd86ae432d224$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $6d9dd86ae432d224$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $5UTbF.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$6d9dd86ae432d224$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($6d9dd86ae432d224$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $6d9dd86ae432d224$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $9SNK2.SDKType._get(this._sdkKey);
                    const statsigMetadata = $9Gu55.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $6d9dd86ae432d224$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $6d9dd86ae432d224$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $6d9dd86ae432d224$var$ErrorBoundary;
function $6d9dd86ae432d224$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $6d9dd86ae432d224$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $6d9dd86ae432d224$var$UNKNOWN_ERROR;
    }
}
function $6d9dd86ae432d224$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $6d9dd86ae432d224$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("9SNK2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $731fbdd89eb371e4$var$SDK_CLIENT = {};
let $731fbdd89eb371e4$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $731fbdd89eb371e4$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($731fbdd89eb371e4$var$suffix !== null && $731fbdd89eb371e4$var$suffix !== void 0 ? $731fbdd89eb371e4$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $731fbdd89eb371e4$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$731fbdd89eb371e4$var$suffix || $731fbdd89eb371e4$var$suffix === '-react') $731fbdd89eb371e4$var$suffix = '-' + binding;
    }
};

});


parcelRegister("45UAy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7u2ed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5q6Y4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ke05s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $eb952eb81274efa8$var$EXIST_KEYS = new Set([]);
const $eb952eb81274efa8$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $eb952eb81274efa8$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($eb952eb81274efa8$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($eb952eb81274efa8$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $eb952eb81274efa8$var$createMemoKey;

});

parcelRegister("8JHTN", function(module, exports) {
"use strict";
var $65c4942101c3a3b5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $kp2KG = parcelRequire("kp2KG");

var $kp2KG = parcelRequire("kp2KG");

var $6uxgh = parcelRequire("6uxgh");

var $5UTbF = parcelRequire("5UTbF");

var $hGdaC = parcelRequire("hGdaC");

var $gFAr4 = parcelRequire("gFAr4");

var $JJ96z = parcelRequire("JJ96z");

var $9SNK2 = parcelRequire("9SNK2");

var $7kd8P = parcelRequire("7kd8P");

var $BVuCS = parcelRequire("BVuCS");

var $61sxj = parcelRequire("61sxj");

var $hMgh1 = parcelRequire("hMgh1");

var $9Gu55 = parcelRequire("9Gu55");

var $eUCHo = parcelRequire("eUCHo");

var $6jEgT = parcelRequire("6jEgT");
const $65c4942101c3a3b5$var$DEFAULT_TIMEOUT_MS = 10000;
const $65c4942101c3a3b5$var$BACKOFF_BASE_MS = 500;
const $65c4942101c3a3b5$var$BACKOFF_MAX_MS = 30000;
const $65c4942101c3a3b5$var$RATE_LIMIT_WINDOW_MS = 1000;
const $65c4942101c3a3b5$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $65c4942101c3a3b5$var$LEAK_RATE = $65c4942101c3a3b5$var$RATE_LIMIT_MAX_REQ_COUNT / $65c4942101c3a3b5$var$RATE_LIMIT_WINDOW_MS;
const $65c4942101c3a3b5$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $65c4942101c3a3b5$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $65c4942101c3a3b5$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $gFAr4.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$65c4942101c3a3b5$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $65c4942101c3a3b5$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $65c4942101c3a3b5$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$65c4942101c3a3b5$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $5UTbF.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $6jEgT._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $65c4942101c3a3b5$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $65c4942101c3a3b5$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $65c4942101c3a3b5$var$_getErrorMessage(error);
                const timedOut = $65c4942101c3a3b5$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $65c4942101c3a3b5$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$65c4942101c3a3b5$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $hMgh1.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $5UTbF.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $65c4942101c3a3b5$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $eUCHo.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $eUCHo.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $65c4942101c3a3b5$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $65c4942101c3a3b5$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $hGdaC.Endpoint._initialize || args.urlConfig.endpoint === $hGdaC.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$hGdaC.NetworkParam.SdkKey]: args.sdkKey,
            [$hGdaC.NetworkParam.SdkType]: $9SNK2.SDKType._get(args.sdkKey),
            [$hGdaC.NetworkParam.SdkVersion]: $9Gu55.SDK_VERSION,
            [$hGdaC.NetworkParam.Time]: String(Date.now()),
            [$hGdaC.NetworkParam.SessionID]: $BVuCS.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $7kd8P._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $kp2KG._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$hGdaC.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $5UTbF.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $65c4942101c3a3b5$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$65c4942101c3a3b5$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($5UTbF.Log.error);
                writer.close().catch($5UTbF.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$hGdaC.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $5UTbF.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $65c4942101c3a3b5$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $65c4942101c3a3b5$var$NetworkCore;
const $65c4942101c3a3b5$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $5UTbF.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $65c4942101c3a3b5$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $61sxj.StableID.get(sdkKey);
    const sessionID = $BVuCS.SessionID.get(sdkKey);
    const sdkType = $9SNK2.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $9Gu55.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $65c4942101c3a3b5$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $kp2KG._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $JJ96z.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $eUCHo.LogEventCompressionMode.Disabled:
            return false;
        case $eUCHo.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $eUCHo.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $65c4942101c3a3b5$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $65c4942101c3a3b5$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $65c4942101c3a3b5$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $hGdaC.Endpoint._initialize) return;
    $6uxgh.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $65c4942101c3a3b5$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $hGdaC.Endpoint._initialize) return;
    $6uxgh.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $6uxgh.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $65c4942101c3a3b5$var$_exponentialBackoff(attempt) {
    return $65c4942101c3a3b5$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($65c4942101c3a3b5$var$BACKOFF_BASE_MS * (attempt * attempt), $65c4942101c3a3b5$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("gFAr4", function(module, exports) {
"use strict";
var $c22cbd0d68a9b6cf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $lMwlI = parcelRequire("lMwlI");

var $dvzcf = parcelRequire("dvzcf");

var $5UTbF = parcelRequire("5UTbF");

var $9VPyF = parcelRequire("9VPyF");
const $c22cbd0d68a9b6cf$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $c22cbd0d68a9b6cf$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $c22cbd0d68a9b6cf$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $c22cbd0d68a9b6cf$var$DEFAULT_TTL_MS;
        $c22cbd0d68a9b6cf$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $c22cbd0d68a9b6cf$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $c22cbd0d68a9b6cf$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $c22cbd0d68a9b6cf$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$c22cbd0d68a9b6cf$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $c22cbd0d68a9b6cf$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $c22cbd0d68a9b6cf$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $c22cbd0d68a9b6cf$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $c22cbd0d68a9b6cf$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $lMwlI._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $c22cbd0d68a9b6cf$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $c22cbd0d68a9b6cf$var$NetworkFallbackResolver;
function $c22cbd0d68a9b6cf$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $c22cbd0d68a9b6cf$var$_isDomainFailure;
function $c22cbd0d68a9b6cf$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $dvzcf._DJB2)(sdkKey)}`;
}
function $c22cbd0d68a9b6cf$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $c22cbd0d68a9b6cf$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $9VPyF.Storage.removeItem(hashKey);
        return;
    }
    $9VPyF.Storage.setItem(hashKey, JSON.stringify(info));
}
function $c22cbd0d68a9b6cf$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $c22cbd0d68a9b6cf$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $9VPyF.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $5UTbF.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $c22cbd0d68a9b6cf$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("lMwlI", function(module, exports) {
"use strict";
var $fdb72c8cc03b38de$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $fdb72c8cc03b38de$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $fdb72c8cc03b38de$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $fdb72c8cc03b38de$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $fdb72c8cc03b38de$var$MAX_START_LOOKUP = 200;
function $fdb72c8cc03b38de$var$_fetchTxtRecords(networkFunc) {
    return $fdb72c8cc03b38de$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($fdb72c8cc03b38de$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $fdb72c8cc03b38de$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $fdb72c8cc03b38de$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $fdb72c8cc03b38de$var$_fetchTxtRecords;
function $fdb72c8cc03b38de$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $fdb72c8cc03b38de$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $fdb72c8cc03b38de$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("JJ96z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $0897391c52505232$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $0897391c52505232$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $0897391c52505232$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("BVuCS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $kp2KG = parcelRequire("kp2KG");

var $bLydQ = parcelRequire("bLydQ");

var $5UTbF = parcelRequire("5UTbF");

var $9VPyF = parcelRequire("9VPyF");

var $28i4u = parcelRequire("28i4u");
const $07200db8d4b6d6c4$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $07200db8d4b6d6c4$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $07200db8d4b6d6c4$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($07200db8d4b6d6c4$var$PROMISE_MAP[sdkKey] == null) $07200db8d4b6d6c4$var$PROMISE_MAP[sdkKey] = $07200db8d4b6d6c4$var$_loadSession(sdkKey);
        const session = $07200db8d4b6d6c4$var$PROMISE_MAP[sdkKey];
        return $07200db8d4b6d6c4$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $07200db8d4b6d6c4$var$PROMISE_MAP[sdkKey] = $07200db8d4b6d6c4$var$_overrideSessionId(override, sdkKey);
    }
};
function $07200db8d4b6d6c4$var$_loadSession(sdkKey) {
    let data = $07200db8d4b6d6c4$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $28i4u.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $07200db8d4b6d6c4$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $07200db8d4b6d6c4$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($07200db8d4b6d6c4$var$_isIdle(data) || $07200db8d4b6d6c4$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $28i4u.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $07200db8d4b6d6c4$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $07200db8d4b6d6c4$var$_createSessionTimeout(sdkKey, $07200db8d4b6d6c4$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $07200db8d4b6d6c4$var$_createSessionTimeout(sdkKey, $07200db8d4b6d6c4$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $07200db8d4b6d6c4$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $kp2KG._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $07200db8d4b6d6c4$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $07200db8d4b6d6c4$var$MAX_SESSION_IDLE_TIME;
}
function $07200db8d4b6d6c4$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $07200db8d4b6d6c4$var$MAX_SESSION_AGE;
}
function $07200db8d4b6d6c4$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $bLydQ._getStorageKey)(sdkKey)}`;
}
function $07200db8d4b6d6c4$var$_persistToStorage(session, sdkKey) {
    const storageKey = $07200db8d4b6d6c4$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $9VPyF._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $5UTbF.Log.warn('Failed to save SessionID');
    }
}
function $07200db8d4b6d6c4$var$_loadFromStorage(sdkKey) {
    const storageKey = $07200db8d4b6d6c4$var$_getSessionIDStorageKey(sdkKey);
    return (0, $9VPyF._getObjectFromStorage)(storageKey);
}

});

parcelRegister("hMgh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("k1V5I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iggch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lJCRI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $fd2bf2cde2e78da8$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $fd2bf2cde2e78da8$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $fd2bf2cde2e78da8$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $fd2bf2cde2e78da8$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $fd2bf2cde2e78da8$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $fd2bf2cde2e78da8$var$_fastApproxSizeOf;

});

parcelRegister("d5Sq8", function(module, exports) {
"use strict";
var $9885f4c5d4283672$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $kp2KG = parcelRequire("kp2KG");

var $kp2KG = parcelRequire("kp2KG");

var $9pua7 = parcelRequire("9pua7");

var $hwS9J = parcelRequire("hwS9J");

var $5UTbF = parcelRequire("5UTbF");

var $ke05s = parcelRequire("ke05s");

var $7kd8P = parcelRequire("7kd8P");

var $BVuCS = parcelRequire("BVuCS");

var $61sxj = parcelRequire("61sxj");

var $eUCHo = parcelRequire("eUCHo");

var $9VPyF = parcelRequire("9VPyF");
const $9885f4c5d4283672$var$MAX_MEMO_CACHE_SIZE = 3000;
class $9885f4c5d4283672$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($5UTbF.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $9VPyF.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $BVuCS.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $9VPyF.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $61sxj.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $61sxj.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $hwS9J.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $9pua7.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $9VPyF.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $9885f4c5d4283672$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $9VPyF.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $61sxj.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($eUCHo.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $9885f4c5d4283672$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $5UTbF.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $ke05s.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $9885f4c5d4283672$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $9885f4c5d4283672$var$StatsigClientBase;
function $9885f4c5d4283672$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $7kd8P._isServerEnv)()) return;
    const statsigGlobal = (0, $kp2KG._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $5UTbF.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("jKS9e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("5J2Ys", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gTZ4F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $5UTbF = parcelRequire("5UTbF");

var $hpkgr = parcelRequire("hpkgr");
function $c4e1287f12a24fbd$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $c4e1287f12a24fbd$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $c4e1287f12a24fbd$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $c4e1287f12a24fbd$var$_makeFeatureGate;
function $c4e1287f12a24fbd$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $c4e1287f12a24fbd$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $c4e1287f12a24fbd$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $c4e1287f12a24fbd$var$_makeDynamicConfig;
function $c4e1287f12a24fbd$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $c4e1287f12a24fbd$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $c4e1287f12a24fbd$var$_makeExperiment;
function $c4e1287f12a24fbd$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $c4e1287f12a24fbd$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $c4e1287f12a24fbd$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $c4e1287f12a24fbd$var$_makeLayer;
function $c4e1287f12a24fbd$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $c4e1287f12a24fbd$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $c4e1287f12a24fbd$var$_mergeOverride;
function $c4e1287f12a24fbd$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $hpkgr._isTypeMatch)(found, fallback)) {
            $5UTbF.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $c4e1287f12a24fbd$var$_makeTypedGet;

});

parcelRegister("fkEAr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gku4O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $be35d8347050c8ed$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $be35d8347050c8ed$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("6QnCP", function(module, exports) {
"use strict";
var $4fb9ece8cfa65610$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jsYdF = parcelRequire("jsYdF");

var $eyd8U = parcelRequire("eyd8U");

var $jhvJm = parcelRequire("jhvJm");

var $eFtNP = parcelRequire("eFtNP");

var $4zwuS = parcelRequire("4zwuS");
class $4fb9ece8cfa65610$var$StatsigClient extends $jsYdF.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $jsYdF._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $4fb9ece8cfa65610$var$StatsigClient) return instance;
        $jsYdF.Log.warn((0, $jsYdF._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $4fb9ece8cfa65610$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $jsYdF.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $jhvJm.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $4zwuS.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($jsYdF.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($jsYdF.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($jsYdF.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($jsYdF.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($jsYdF.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($jsYdF.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $eyd8U.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $jsYdF.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $jsYdF.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $4fb9ece8cfa65610$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $jsYdF.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $jsYdF.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $4fb9ece8cfa65610$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $4fb9ece8cfa65610$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $jsYdF.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $jsYdF.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $jsYdF.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $jsYdF.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($jsYdF.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $jsYdF.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $jsYdF.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $jsYdF.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $jsYdF.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $jsYdF.StatsigSession.get(this._sdkKey),
            stableID: $jsYdF.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $4fb9ece8cfa65610$var$__awaiter(this, void 0, void 0, function*() {
            if (!$jsYdF.Storage.isReady()) yield $jsYdF.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $jsYdF.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $jsYdF.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $jsYdF._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$jsYdF.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$jsYdF.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $jsYdF.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $jsYdF._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $jsYdF._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $jsYdF._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $jsYdF._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $jsYdF._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $jsYdF._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $jsYdF._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $jsYdF._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $jsYdF._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $jsYdF._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $eFtNP._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $eFtNP._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $4fb9ece8cfa65610$var$StatsigClient;

});
parcelRegister("eyd8U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jsYdF = parcelRequire("jsYdF");

var $2KA5Z = parcelRequire("2KA5Z");

var $ipwCA = parcelRequire("ipwCA");
class $a97e6f8131870055$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $jsYdF._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $jsYdF._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $ipwCA.V2InitializeContainer(values);
        else this._values = new $2KA5Z.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $jsYdF.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $jsYdF.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $jsYdF._getFullUserHash)(userForComparison) !== (0, $jsYdF._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $a97e6f8131870055$var$EvaluationStore;

});
parcelRegister("2KA5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $jsYdF = parcelRequire("jsYdF");
class $200be07b5ccc6e62$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $jsYdF._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $200be07b5ccc6e62$var$V1InitializeContainer;

});

parcelRegister("ipwCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $jsYdF = parcelRequire("jsYdF");
class $d673ddb30765f48b$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $jsYdF._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $d673ddb30765f48b$var$V2InitializeContainer;

});


parcelRegister("jhvJm", function(module, exports) {
"use strict";
var $e09837e66418d17a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jsYdF = parcelRequire("jsYdF");

var $2LbyZ = parcelRequire("2LbyZ");
class $e09837e66418d17a$var$StatsigNetwork extends $jsYdF.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $jsYdF.UrlConfiguration($jsYdF.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $e09837e66418d17a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $jsYdF._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $e09837e66418d17a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $2LbyZ._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $e09837e66418d17a$var$StatsigNetwork;

});
parcelRegister("2LbyZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $jsYdF = parcelRequire("jsYdF");
const $2028f0c80f025320$var$MAX_DELTAS_SORT_DEPTH = 2;
function $2028f0c80f025320$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $jsYdF._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $2028f0c80f025320$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $2028f0c80f025320$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $jsYdF._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $2028f0c80f025320$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $2028f0c80f025320$var$_resolveDeltasResponse;
function $2028f0c80f025320$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $2028f0c80f025320$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $2028f0c80f025320$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $2028f0c80f025320$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $2028f0c80f025320$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $2028f0c80f025320$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("eFtNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $jsYdF = parcelRequire("jsYdF");
const $aadc033478473256$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $aadc033478473256$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $aadc033478473256$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $jsYdF._isTypeMatch)(value, fallback);
}
function $aadc033478473256$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $aadc033478473256$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $aadc033478473256$var$_shouldLogExposure(options) ? undefined : $aadc033478473256$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $aadc033478473256$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $aadc033478473256$var$_shouldLogExposure(options) ? undefined : $aadc033478473256$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($aadc033478473256$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $aadc033478473256$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $aadc033478473256$var$_shouldLogExposure(options) ? undefined : $aadc033478473256$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($aadc033478473256$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $aadc033478473256$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $aadc033478473256$var$_shouldLogExposure(options) ? undefined : $aadc033478473256$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($aadc033478473256$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $aadc033478473256$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $jsYdF._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $aadc033478473256$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $aadc033478473256$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $aadc033478473256$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $aadc033478473256$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $aadc033478473256$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $aadc033478473256$var$_makeParamStoreGetter;

});

parcelRegister("4zwuS", function(module, exports) {
"use strict";
var $3543a38d4519a13d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $jsYdF = parcelRequire("jsYdF");

var $jhvJm = parcelRequire("jhvJm");
class $3543a38d4519a13d$var$StatsigEvaluationsDataAdapter extends $jsYdF.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $jhvJm.default) this._network = network;
        else this._network = new $jhvJm.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $jsYdF._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $jsYdF._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $jsYdF.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $3543a38d4519a13d$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $jsYdF._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$jsYdF.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $jsYdF._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $3543a38d4519a13d$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("f6JQl", function(module, exports) {
$parcel$export(module.exports, "default", () => $869e40db1e7830e6$export$2e2bcd8739ae039);

var $7qlbH = parcelRequire("7qlbH");
const $869e40db1e7830e6$export$a66cbd9b2289cd78 = '@all-features';
class $869e40db1e7830e6$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($7qlbH)))();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($869e40db1e7830e6$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($869e40db1e7830e6$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($869e40db1e7830e6$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $869e40db1e7830e6$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});
parcelRegister("7qlbH", function(module, exports) {
'use strict';
var $567b658ba0ccd6f0$var$has = Object.prototype.hasOwnProperty, $567b658ba0ccd6f0$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $567b658ba0ccd6f0$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $567b658ba0ccd6f0$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $567b658ba0ccd6f0$var$Events().__proto__) $567b658ba0ccd6f0$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $567b658ba0ccd6f0$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $567b658ba0ccd6f0$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $567b658ba0ccd6f0$var$EE(fn, context || emitter, once), evt = $567b658ba0ccd6f0$var$prefix ? $567b658ba0ccd6f0$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $567b658ba0ccd6f0$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $567b658ba0ccd6f0$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $567b658ba0ccd6f0$var$EventEmitter() {
    this._events = new $567b658ba0ccd6f0$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $567b658ba0ccd6f0$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($567b658ba0ccd6f0$var$has.call(events, name)) names.push($567b658ba0ccd6f0$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $567b658ba0ccd6f0$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $567b658ba0ccd6f0$var$prefix ? $567b658ba0ccd6f0$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $567b658ba0ccd6f0$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $567b658ba0ccd6f0$var$prefix ? $567b658ba0ccd6f0$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $567b658ba0ccd6f0$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $567b658ba0ccd6f0$var$prefix ? $567b658ba0ccd6f0$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $567b658ba0ccd6f0$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $567b658ba0ccd6f0$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $567b658ba0ccd6f0$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $567b658ba0ccd6f0$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $567b658ba0ccd6f0$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $567b658ba0ccd6f0$var$prefix ? $567b658ba0ccd6f0$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $567b658ba0ccd6f0$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $567b658ba0ccd6f0$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $567b658ba0ccd6f0$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $567b658ba0ccd6f0$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $567b658ba0ccd6f0$var$prefix ? $567b658ba0ccd6f0$var$prefix + event : event;
        if (this._events[evt]) $567b658ba0ccd6f0$var$clearEvent(this, evt);
    } else {
        this._events = new $567b658ba0ccd6f0$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$567b658ba0ccd6f0$var$EventEmitter.prototype.off = $567b658ba0ccd6f0$var$EventEmitter.prototype.removeListener;
$567b658ba0ccd6f0$var$EventEmitter.prototype.addListener = $567b658ba0ccd6f0$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$567b658ba0ccd6f0$var$EventEmitter.prefixed = $567b658ba0ccd6f0$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$567b658ba0ccd6f0$var$EventEmitter.EventEmitter = $567b658ba0ccd6f0$var$EventEmitter;
module.exports = $567b658ba0ccd6f0$var$EventEmitter;

});


parcelRegister("cjJZ4", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $32dc9045dded374e$export$6dc24881a3d96325);

var $b82EI = parcelRequire("b82EI");
class $32dc9045dded374e$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        var _experiment$__evaluat;
        const config = new $32dc9045dded374e$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $b82EI.migrateEvaluationDetails)(experiment.details), (0, $b82EI.migrateSecondaryExposures)(((_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures) ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        var _this$_onDefaultValue2;
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            var _this$_onDefaultValue;
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("b82EI", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $55b9eba115c18738$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $55b9eba115c18738$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $55b9eba115c18738$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $55b9eba115c18738$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $55b9eba115c18738$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $55b9eba115c18738$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $55b9eba115c18738$export$55fd683752d01e67);

var $1lG1b = parcelRequire("1lG1b");

var $jctIQ = parcelRequire("jctIQ");

var $4G9cg = parcelRequire("4G9cg");
const $55b9eba115c18738$export$d119b37e5f788b43 = (options)=>({
        /**
   * If more federal PerimeterTypes are added in the future, this should be updated so
   * that isFedRamp() === true always returns the strictest perimeter.
   */ perimeter: (0, $1lG1b.isFedRamp)() ? (0, $4G9cg.PerimeterType).FEDRAMP_MODERATE : (0, $4G9cg.PerimeterType).COMMERCIAL,
        ...options
    });
const $55b9eba115c18738$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $55b9eba115c18738$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    const user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $55b9eba115c18738$export$1148cb79ceecd5fa(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return $55b9eba115c18738$export$1148cb79ceecd5fa(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $55b9eba115c18738$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $55b9eba115c18738$export$1148cb79ceecd5fa(target, ...sources);
}
const $55b9eba115c18738$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $55b9eba115c18738$var$evaluationReasonMappings = Object.entries((0, $jctIQ.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $55b9eba115c18738$export$18ad168d3dbac899 = (details)=>{
    var _evaluationReasonMapp;
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: ((_evaluationReasonMapp = $55b9eba115c18738$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))) === null || _evaluationReasonMapp === void 0 ? void 0 : _evaluationReasonMapp[1]) ?? (0, $jctIQ.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};
const $55b9eba115c18738$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("1lG1b", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $e847d6dd930e55d6$export$64d6499adf9b2e51);

var $7hLYi = parcelRequire("7hLYi");
function $e847d6dd930e55d6$export$64d6499adf9b2e51() {
    var _global$location;
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $7hLYi.FEDRAMP_MODERATE);
    const matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("7hLYi", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $4fe734b5d4f3e75a$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $4fe734b5d4f3e75a$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $4fe734b5d4f3e75a$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $4fe734b5d4f3e75a$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $4fe734b5d4f3e75a$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $4fe734b5d4f3e75a$export$404582bc18fe4d9e);
const $4fe734b5d4f3e75a$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $4fe734b5d4f3e75a$export$f005e2e9f707cb5f = 'commercial';
const $4fe734b5d4f3e75a$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $4fe734b5d4f3e75a$export$a739cd5aac835909 = 'stg';
const $4fe734b5d4f3e75a$export$42dd0cdd351a4a9 = 'prod';
const $4fe734b5d4f3e75a$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("jctIQ", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $49f9bef7be1b8ffe$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
const $49f9bef7be1b8ffe$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

});

parcelRegister("4G9cg", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $b6214f9d84e3f26f$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $b6214f9d84e3f26f$export$c42b7bbc5e7ba555);
const $b6214f9d84e3f26f$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const $b6214f9d84e3f26f$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const $b6214f9d84e3f26f$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("gn9Xz", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $1c2eae4fbf6a2d31$export$936d0764594b6eb3);

var $b82EI = parcelRequire("b82EI");
class $1c2eae4fbf6a2d31$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
        const value = new $1c2eae4fbf6a2d31$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $b82EI.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $b82EI.migrateSecondaryExposures)(((_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) ?? []), (0, $b82EI.migrateSecondaryExposures)(((_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) ?? []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        var _this$_logParameterFu;
        (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
    }
}

});

parcelRegister("dYLIm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9273e97383003cbf$export$2e2bcd8739ae039);

var $4G9cg = parcelRequire("4G9cg");

var $2TU1X = parcelRequire("2TU1X");

var $bFEvs = parcelRequire("bFEvs");
const $9273e97383003cbf$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $9273e97383003cbf$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $9273e97383003cbf$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $9273e97383003cbf$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $9273e97383003cbf$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $9273e97383003cbf$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $9273e97383003cbf$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $9273e97383003cbf$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $9273e97383003cbf$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $9273e97383003cbf$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $9273e97383003cbf$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $bFEvs.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $bFEvs.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $9273e97383003cbf$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $4G9cg.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $4G9cg.FeatureGateEnvironment).Production:
                return $9273e97383003cbf$export$18c93900db9358a4;
            case (0, $4G9cg.FeatureGateEnvironment).Staging:
                return $9273e97383003cbf$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $4G9cg.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $4G9cg.FeatureGateEnvironment).Development:
                return $9273e97383003cbf$export$f058dbf75c3bc647;
            case (0, $4G9cg.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $9273e97383003cbf$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $9273e97383003cbf$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $9273e97383003cbf$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $9273e97383003cbf$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $2TU1X.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $9273e97383003cbf$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$9273e97383003cbf$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$9273e97383003cbf$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("2TU1X", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $3a070e2f458de693$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $3a070e2f458de693$export$a59f8d67326bd1cb = undefined;

});

parcelRegister("bFEvs", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $c75d6ebc5b5152d4$export$286baf652d0b1206);
class $c75d6ebc5b5152d4$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("aM04y", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $c52ab7e469da3dc9$export$55fffef3474104af);

var $25A38 = parcelRequire("25A38");
class $c52ab7e469da3dc9$export$55fffef3474104af extends (0, $25A38.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $25A38.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $25A38._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $25A38._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $25A38._getStorageKey)(this._getSdkKey(), user);
        return `${0, $25A38.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("fPG58", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $d1ce4c54f34cb7bd$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $d1ce4c54f34cb7bd$export$bcb28fbac1def494);

var $jsYdF = parcelRequire("jsYdF");
const $d1ce4c54f34cb7bd$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $d1ce4c54f34cb7bd$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $d1ce4c54f34cb7bd$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $d1ce4c54f34cb7bd$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $d1ce4c54f34cb7bd$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $d1ce4c54f34cb7bd$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $d1ce4c54f34cb7bd$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $d1ce4c54f34cb7bd$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $d1ce4c54f34cb7bd$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $d1ce4c54f34cb7bd$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($d1ce4c54f34cb7bd$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($d1ce4c54f34cb7bd$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $jsYdF._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$d1ce4c54f34cb7bd$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($d1ce4c54f34cb7bd$var$djb2MapKey((0, $jsYdF._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($d1ce4c54f34cb7bd$var$djb2MapKey((0, $jsYdF._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($d1ce4c54f34cb7bd$var$djb2MapKey((0, $jsYdF._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($d1ce4c54f34cb7bd$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $d1ce4c54f34cb7bd$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($d1ce4c54f34cb7bd$var$djb2MapKey((0, $jsYdF._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($d1ce4c54f34cb7bd$var$djb2MapKey((0, $jsYdF._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($d1ce4c54f34cb7bd$var$djb2MapKey((0, $jsYdF._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($d1ce4c54f34cb7bd$var$djb2MapKey((0, $jsYdF._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($d1ce4c54f34cb7bd$var$djb2MapKey((0, $jsYdF._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($d1ce4c54f34cb7bd$var$djb2MapKey((0, $jsYdF._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $d1ce4c54f34cb7bd$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($d1ce4c54f34cb7bd$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $jsYdF._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $d1ce4c54f34cb7bd$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($d1ce4c54f34cb7bd$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $jsYdF._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $d1ce4c54f34cb7bd$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});



parcelRegister("hHXe7", function(module, exports) {
$parcel$export(module.exports, "debug", () => $dc788eea5d1144a2$export$1c9f709888824e05);
var $dc788eea5d1144a2$var$_process, $dc788eea5d1144a2$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $dc788eea5d1144a2$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($dc788eea5d1144a2$var$_process = globalThis.process) === null || $dc788eea5d1144a2$var$_process === void 0 || ($dc788eea5d1144a2$var$_process = $dc788eea5d1144a2$var$_process.env) === null || $dc788eea5d1144a2$var$_process === void 0 ? void 0 : $dc788eea5d1144a2$var$_process.JEST_WORKER_ID) !== undefined;
const $dc788eea5d1144a2$var$DEBUG_MODE = !$dc788eea5d1144a2$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($dc788eea5d1144a2$var$_process2 = globalThis.process) === null || $dc788eea5d1144a2$var$_process2 === void 0 || ($dc788eea5d1144a2$var$_process2 = $dc788eea5d1144a2$var$_process2.env) === null || $dc788eea5d1144a2$var$_process2 === void 0 ? void 0 : $dc788eea5d1144a2$var$_process2.NODE_ENV) !== 'production';
const $dc788eea5d1144a2$export$1c9f709888824e05 = (...args)=>{
    if (!$dc788eea5d1144a2$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});



parcelRegister("2x96i", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3c7c6b7332a091d$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $c3c7c6b7332a091d$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $c3c7c6b7332a091d$export$2e2bcd8739ae039 = $c3c7c6b7332a091d$var$coinflip;

});

parcelRegister("2YpBk", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $d88f7590af2e96ec$export$23e69abaca7d0236);

var $e6Qdr = parcelRequire("e6Qdr");
const $d88f7590af2e96ec$export$4c07c8a3507ce307 = 255;
function $d88f7590af2e96ec$export$23e69abaca7d0236(name) {
    if (name.length <= $d88f7590af2e96ec$export$4c07c8a3507ce307) return name;
    if ((0, $e6Qdr.fg)('platform_ufo_validate_timing_name_length')) return name.slice(0, $d88f7590af2e96ec$export$4c07c8a3507ce307);
    return name;
}

});

parcelRegister("cAaWV", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $30bd6a641b505484$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $30bd6a641b505484$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $30bd6a641b505484$export$44487a86467333c3);
$parcel$export(module.exports, "isUFOEnabled", () => $30bd6a641b505484$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $30bd6a641b505484$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $30bd6a641b505484$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $30bd6a641b505484$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $30bd6a641b505484$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getExperimentalInteractionRate", () => $30bd6a641b505484$export$563f73272328c0d);
$parcel$export(module.exports, "getVCRawDataInteractionRate", () => $30bd6a641b505484$export$48f4e0d964030a96);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $30bd6a641b505484$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $30bd6a641b505484$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $30bd6a641b505484$export$29b9ffb14861a1d);
$parcel$export(module.exports, "getExtraInteractionRate", () => $30bd6a641b505484$export$203bd06a99c66a0d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $30bd6a641b505484$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $30bd6a641b505484$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $30bd6a641b505484$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $30bd6a641b505484$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $30bd6a641b505484$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $30bd6a641b505484$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $30bd6a641b505484$export$c681731847989445);

var $e6Qdr = parcelRequire("e6Qdr");
let $30bd6a641b505484$var$config;
const $30bd6a641b505484$export$f9bb3bb330fb9609 = 'fy26.04';
function $30bd6a641b505484$export$2182e73d31080cbc() {
    return $30bd6a641b505484$export$f9bb3bb330fb9609;
}
const $30bd6a641b505484$export$d50dacda7fe6392b = 1000;
function $30bd6a641b505484$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = (newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof (enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) ?? [],
            ...Object.values(byExperience).flat()
        ];
        $30bd6a641b505484$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $30bd6a641b505484$var$config = newConfig;
}
function $30bd6a641b505484$export$44487a86467333c3() {
    return $30bd6a641b505484$var$config;
}
function $30bd6a641b505484$export$74bdb753f1cf4860() {
    var _config;
    // Default to enabled if config is not set or enabled is not explicitly false
    return ((_config = $30bd6a641b505484$var$config) === null || _config === void 0 ? void 0 : _config.enabled) !== false;
}
const $30bd6a641b505484$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $30bd6a641b505484$export$87fbc8e01b137811(experienceKey = '') {
    try {
        var _config$vc;
        if (!$30bd6a641b505484$var$config) return [];
        if ((_config$vc = $30bd6a641b505484$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _enabledVCRevisions$b;
            const { enabledVCRevisions: enabledVCRevisions } = $30bd6a641b505484$var$config.vc ?? {};
            if ($30bd6a641b505484$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $e6Qdr.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($30bd6a641b505484$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $30bd6a641b505484$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $30bd6a641b505484$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $30bd6a641b505484$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $30bd6a641b505484$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $30bd6a641b505484$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $30bd6a641b505484$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $30bd6a641b505484$export$2d8f8d64dc343d7b() {
    if (!$30bd6a641b505484$var$config) return undefined;
    try {
        var _config2, _config2$getReactHydr;
        const stats = (_config2 = $30bd6a641b505484$var$config) === null || _config2 === void 0 || (_config2$getReactHydr = _config2.getReactHydrationStats) === null || _config2$getReactHydr === void 0 ? void 0 : _config2$getReactHydr.call(_config2);
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $30bd6a641b505484$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$30bd6a641b505484$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $30bd6a641b505484$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $30bd6a641b505484$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $30bd6a641b505484$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$30bd6a641b505484$var$config) return 0;
        const { experimentalInteractionMetrics: experimentalInteractionMetrics } = $30bd6a641b505484$var$config;
        if (!(experimentalInteractionMetrics !== null && experimentalInteractionMetrics !== void 0 && experimentalInteractionMetrics.enabled)) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
function $30bd6a641b505484$export$48f4e0d964030a96(name, interactionType) {
    return $30bd6a641b505484$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $30bd6a641b505484$export$9c69f5a724f05f38(name, interactionType) {
    if (!(0, $e6Qdr.fg)('platform_ufo_raw_data_thirdparty')) return false;
    return $30bd6a641b505484$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $30bd6a641b505484$export$1d459f020c06ae34(name, interactionType) {
    return $30bd6a641b505484$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $30bd6a641b505484$export$29b9ffb14861a1d(capability) {
    if ((0, $e6Qdr.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$30bd6a641b505484$var$config) return 0;
        const { capability: capabilityRate } = $30bd6a641b505484$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $30bd6a641b505484$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$30bd6a641b505484$var$config) return 0;
        const gotConfig = $30bd6a641b505484$var$config[configName];
        if (!(gotConfig !== null && gotConfig !== void 0 && gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
function $30bd6a641b505484$export$203bd06a99c66a0d(name, interactionType) {
    return $30bd6a641b505484$var$getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
const $30bd6a641b505484$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $30bd6a641b505484$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$30bd6a641b505484$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $30bd6a641b505484$var$config;
        if (typingMethod != null && $30bd6a641b505484$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $30bd6a641b505484$export$2d311b3fd18dcab1() {
    try {
        if (!$30bd6a641b505484$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $30bd6a641b505484$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $30bd6a641b505484$export$4f4649ef27b6f5d6() {
    try {
        if (!$30bd6a641b505484$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $30bd6a641b505484$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $30bd6a641b505484$export$b150ddad71c80d77() {
    try {
        if (!$30bd6a641b505484$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $30bd6a641b505484$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $30bd6a641b505484$export$3c170167645a0eff() {
    try {
        if (!$30bd6a641b505484$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $30bd6a641b505484$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $30bd6a641b505484$export$d6dc9444bd15f70f() {
    try {
        if (!$30bd6a641b505484$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $30bd6a641b505484$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $30bd6a641b505484$export$20e8108b8ccdd0bd() {
    try {
        if (!$30bd6a641b505484$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $30bd6a641b505484$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $30bd6a641b505484$export$2a8604960d7d23d9 = 60000;
function $30bd6a641b505484$export$c681731847989445(ufoName) {
    try {
        if (!$30bd6a641b505484$var$config) return $30bd6a641b505484$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $30bd6a641b505484$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $30bd6a641b505484$export$2a8604960d7d23d9;
    } catch  {
        return $30bd6a641b505484$export$2a8604960d7d23d9;
    }
}

});

parcelRegister("9GPxu", function(module, exports) {
$parcel$export(module.exports, "sinkExperimentalHandler", () => $28f8e9c609b111b0$export$7aa99c40634ac65f);
$parcel$export(module.exports, "onExperimentalInteractionComplete", () => $28f8e9c609b111b0$export$1aed449484dedf63);
$parcel$export(module.exports, "experimentalVC", () => $28f8e9c609b111b0$export$81b28dca2587ec47);
$parcel$export(module.exports, "getExperimentalVCMetrics", () => $28f8e9c609b111b0$export$d17d2b5c5e8d732e);

var $cHs48 = parcelRequire("cHs48");

var $43OaL = parcelRequire("43OaL");
const $28f8e9c609b111b0$var$interactionBuffer = [];
let $28f8e9c609b111b0$var$bufferInteractionData = (interactionId, data)=>{
    $28f8e9c609b111b0$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $28f8e9c609b111b0$var$clearInteractionBuffer() {
    $28f8e9c609b111b0$var$interactionBuffer.length = 0;
}
function $28f8e9c609b111b0$var$appendInteractionData(interactionId, data) {
    $28f8e9c609b111b0$var$bufferInteractionData(interactionId, data);
}
function $28f8e9c609b111b0$export$c8a9e17ae62a073d(handler) {
    for (const { interactionId: interactionId, data: data } of $28f8e9c609b111b0$var$interactionBuffer)handler(interactionId, data);
    $28f8e9c609b111b0$var$clearInteractionBuffer();
    $28f8e9c609b111b0$var$bufferInteractionData = handler;
}
function $28f8e9c609b111b0$export$7aa99c40634ac65f(sinkFn) {
    $28f8e9c609b111b0$export$c8a9e17ae62a073d(sinkFn);
}
function $28f8e9c609b111b0$export$1aed449484dedf63(interactionId, data, endTime = performance.now()) {
    if (data.ufoName) {
        data.end = endTime;
        $28f8e9c609b111b0$var$appendInteractionData(interactionId, data);
        $28f8e9c609b111b0$var$clearInteractionBuffer();
    }
}
class $28f8e9c609b111b0$export$f9a59f57e0282541 {
    initialize(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $43OaL.VCObserver)({
            ...options,
            isPostInteraction: true
        });
        return this;
    }
    start({ startTime: startTime }) {
        var _this$vcObserver;
        (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
            startTime: startTime
        });
    }
    constructor(){
        this.vcObserver = null;
    }
}
const $28f8e9c609b111b0$export$81b28dca2587ec47 = new $28f8e9c609b111b0$export$f9a59f57e0282541();
async function $28f8e9c609b111b0$export$d17d2b5c5e8d732e(interaction) {
    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
    const vcObserver = interaction.experimentalVCObserver || $28f8e9c609b111b0$export$81b28dca2587ec47.vcObserver;
    const pageVisibilityUpToTTAI = (0, $cHs48.getPageVisibilityState)(interaction.start, interaction.end);
    if (vcObserver) {
        var _interaction$apdex;
        const prefix = 'ufo-experimental';
        const result = await vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime,
            isEventAborted: !!interaction.abortReason,
            prefix: prefix,
            vc: interaction.vc,
            experienceKey: interaction.ufoName,
            interactionId: interaction.id,
            interactionType: interaction.type,
            isPageVisible: pageVisibilityUpToTTAI === 'visible',
            interactionAbortReason: interaction.abortReason
        });
        const VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
        if (!VC || !(result !== null && result !== void 0 && result[`${prefix}:vc:clean`])) return result;
        if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:experimental:vc90': VC['90']
        };
    }
    return null;
}

});
parcelRegister("cHs48", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $1c03b1c9deb214a8$export$754443ce7c615bd7);
$parcel$export(module.exports, "isOpenedInBackground", () => $1c03b1c9deb214a8$export$21a1a62a307062f1);
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", () => $1c03b1c9deb214a8$export$95f048bd8bcdda23);
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $1c03b1c9deb214a8$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $1c03b1c9deb214a8$export$768b2008623433e1);
$parcel$export(module.exports, "setupThrottleDetection", () => $1c03b1c9deb214a8$export$fa0d29a9c87052da);
$parcel$export(module.exports, "isTabThrottled", () => $1c03b1c9deb214a8$export$62a28c860277b3bf);
$parcel$export(module.exports, "getPageVisibilityTimeline", () => $1c03b1c9deb214a8$export$5a06b84e47ad70d9);

var $36kyW = parcelRequire("36kyW");

var $e6Qdr = parcelRequire("e6Qdr");
const $1c03b1c9deb214a8$var$timings = [];
let $1c03b1c9deb214a8$var$wasHiddenFlag;
let $1c03b1c9deb214a8$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $1c03b1c9deb214a8$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $1c03b1c9deb214a8$var$openedInBackground = null;
function $1c03b1c9deb214a8$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $1c03b1c9deb214a8$var$SIZE = 50;
let $1c03b1c9deb214a8$var$insertIndex = 0;
function $1c03b1c9deb214a8$export$754443ce7c615bd7(startTime, endTime) {
    var _timings$find;
    const earliestHiddenTiming = (_timings$find = $1c03b1c9deb214a8$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)) === null || _timings$find === void 0 ? void 0 : _timings$find.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $1c03b1c9deb214a8$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $1c03b1c9deb214a8$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $1c03b1c9deb214a8$var$openedInBackground === true;
}
function $1c03b1c9deb214a8$var$pushHidden(isPageHiddenFlag, time) {
    $1c03b1c9deb214a8$var$timings[$1c03b1c9deb214a8$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $1c03b1c9deb214a8$var$insertIndex = ($1c03b1c9deb214a8$var$insertIndex + 1) % $1c03b1c9deb214a8$var$SIZE;
    $1c03b1c9deb214a8$var$wasHiddenFlag = isPageHiddenFlag;
}
function $1c03b1c9deb214a8$var$handleChange() {
    const isPageHiddenFlag = $1c03b1c9deb214a8$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$1c03b1c9deb214a8$var$wasHiddenFlag) $1c03b1c9deb214a8$var$pushHidden(isPageHiddenFlag);
        $1c03b1c9deb214a8$var$wasHiddenFlag = true;
    } else {
        if ($1c03b1c9deb214a8$var$wasHiddenFlag) $1c03b1c9deb214a8$var$pushHidden(isPageHiddenFlag);
        $1c03b1c9deb214a8$var$wasHiddenFlag = false;
    }
}
let $1c03b1c9deb214a8$var$hasHiddenTimingBeforeSetup = false;
function $1c03b1c9deb214a8$export$95f048bd8bcdda23() {
    return $1c03b1c9deb214a8$var$hasHiddenTimingBeforeSetup;
}
function $1c03b1c9deb214a8$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results === null || results === void 0 || results.forEach((result)=>{
            if ((0, $e6Qdr.fg)('platform_ufo_use_native_page_visibility_api')) $1c03b1c9deb214a8$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $1c03b1c9deb214a8$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $36kyW.bind)(window, {
        type: 'pageshow',
        listener: $1c03b1c9deb214a8$var$handleChange
    });
    (0, $36kyW.bind)(window, {
        type: 'pagehide',
        listener: $1c03b1c9deb214a8$var$handleChange
    });
    (0, $36kyW.bind)(document, {
        type: 'visibilitychange',
        listener: $1c03b1c9deb214a8$var$handleChange
    });
}
function $1c03b1c9deb214a8$export$554cefe0f0373da4() {
    if (!$1c03b1c9deb214a8$var$setupFlag) {
        const isPageHiddenFlag = $1c03b1c9deb214a8$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($1c03b1c9deb214a8$var$openedInBackground === null) $1c03b1c9deb214a8$var$openedInBackground = isPageHiddenFlag && setupTime < $1c03b1c9deb214a8$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $1c03b1c9deb214a8$var$pushHidden(isPageHiddenFlag, 0);
        $1c03b1c9deb214a8$var$setup();
        $1c03b1c9deb214a8$var$setupFlag = true;
    }
}
function $1c03b1c9deb214a8$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($1c03b1c9deb214a8$var$timings.length === 0) return 'visible';
    const currentSize = $1c03b1c9deb214a8$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $1c03b1c9deb214a8$var$insertIndex;
    let endIdx = $1c03b1c9deb214a8$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($1c03b1c9deb214a8$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($1c03b1c9deb214a8$var$timings[tmpIdx] && $1c03b1c9deb214a8$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($1c03b1c9deb214a8$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $1c03b1c9deb214a8$var$timings[startIdx]) hiddenState = $1c03b1c9deb214a8$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $1c03b1c9deb214a8$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $1c03b1c9deb214a8$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $1c03b1c9deb214a8$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $1c03b1c9deb214a8$var$throttleMeasurements = [];
let $1c03b1c9deb214a8$var$throttleInsertIndex = 0;
let $1c03b1c9deb214a8$var$throttleIntervalId = null;
let $1c03b1c9deb214a8$var$lastThrottleCheckTime = null;
let $1c03b1c9deb214a8$var$throttleSetupDone = false;
function $1c03b1c9deb214a8$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $1c03b1c9deb214a8$var$THROTTLE_DRIFT_THRESHOLD;
    $1c03b1c9deb214a8$var$throttleMeasurements[$1c03b1c9deb214a8$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $1c03b1c9deb214a8$var$throttleInsertIndex = ($1c03b1c9deb214a8$var$throttleInsertIndex + 1) % $1c03b1c9deb214a8$var$THROTTLE_BUFFER_SIZE;
}
function $1c03b1c9deb214a8$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($1c03b1c9deb214a8$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $1c03b1c9deb214a8$var$lastThrottleCheckTime;
        $1c03b1c9deb214a8$var$recordThrottleMeasurement($1c03b1c9deb214a8$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $1c03b1c9deb214a8$var$lastThrottleCheckTime = currentTime;
}
function $1c03b1c9deb214a8$export$fa0d29a9c87052da() {
    if ($1c03b1c9deb214a8$var$throttleSetupDone) return;
    $1c03b1c9deb214a8$var$throttleSetupDone = true;
    // Record the initial timestamp
    $1c03b1c9deb214a8$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $1c03b1c9deb214a8$var$throttleIntervalId = setInterval($1c03b1c9deb214a8$var$throttleCheckCallback, $1c03b1c9deb214a8$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $1c03b1c9deb214a8$export$3279694d66e4a1() {
    if ($1c03b1c9deb214a8$var$throttleIntervalId !== null) {
        clearInterval($1c03b1c9deb214a8$var$throttleIntervalId);
        $1c03b1c9deb214a8$var$throttleIntervalId = null;
    }
    $1c03b1c9deb214a8$var$lastThrottleCheckTime = null;
    $1c03b1c9deb214a8$var$throttleSetupDone = false;
    $1c03b1c9deb214a8$var$throttleMeasurements.length = 0;
    $1c03b1c9deb214a8$var$throttleInsertIndex = 0;
}
function $1c03b1c9deb214a8$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($1c03b1c9deb214a8$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $1c03b1c9deb214a8$var$throttleMeasurements.length; i++){
        const measurement = $1c03b1c9deb214a8$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $1c03b1c9deb214a8$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $1c03b1c9deb214a8$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $1c03b1c9deb214a8$export$9332de935653b687(measurement) {
    $1c03b1c9deb214a8$var$throttleMeasurements[$1c03b1c9deb214a8$var$throttleInsertIndex] = measurement;
    $1c03b1c9deb214a8$var$throttleInsertIndex = ($1c03b1c9deb214a8$var$throttleInsertIndex + 1) % $1c03b1c9deb214a8$var$THROTTLE_BUFFER_SIZE;
}
function $1c03b1c9deb214a8$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($1c03b1c9deb214a8$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $1c03b1c9deb214a8$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($1c03b1c9deb214a8$var$insertIndex + i) % currentSize;
        const entry = $1c03b1c9deb214a8$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($1c03b1c9deb214a8$var$insertIndex + i) % currentSize;
        const entry = $1c03b1c9deb214a8$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $1c03b1c9deb214a8$export$9332de935653b687
};

});
parcelRegister("36kyW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $365cf = parcelRequire("365cf");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $365cf.bind;
    }
});

var $aX0fV = parcelRequire("aX0fV");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $aX0fV.bindAll;
    }
});

});
parcelRegister("365cf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $2415f68d420b7154$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $2415f68d420b7154$var$bind;

});

parcelRegister("aX0fV", function(module, exports) {
"use strict";
var $7f8f9ce57caed75d$var$__assign = module.exports && module.exports.__assign || function() {
    $7f8f9ce57caed75d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7f8f9ce57caed75d$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $365cf = parcelRequire("365cf");
function $7f8f9ce57caed75d$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $7f8f9ce57caed75d$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $7f8f9ce57caed75d$var$__assign($7f8f9ce57caed75d$var$__assign({}, original), {
        options: $7f8f9ce57caed75d$var$__assign($7f8f9ce57caed75d$var$__assign({}, $7f8f9ce57caed75d$var$toOptions(sharedOptions)), $7f8f9ce57caed75d$var$toOptions(original.options))
    });
    return binding;
}
function $7f8f9ce57caed75d$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $7f8f9ce57caed75d$var$getBinding(original, sharedOptions);
        return (0, $365cf.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $7f8f9ce57caed75d$var$bindAll;

});



parcelRegister("43OaL", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $2820034be8182b76$export$1f70d263701b1d01);

var $e6Qdr = parcelRequire("e6Qdr");

var $cAaWV = parcelRequire("cAaWV");

var $9TwI7 = parcelRequire("9TwI7");

var $cGX1L = parcelRequire("cGX1L");

var $7ytdb = parcelRequire("7ytdb");

var $fSWhE = parcelRequire("fSWhE");

var $84DIS = parcelRequire("84DIS");

var $jZtCM = parcelRequire("jZtCM");
const $2820034be8182b76$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $2820034be8182b76$var$UNUSED_SECTOR = 0;
function $2820034be8182b76$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $2820034be8182b76$export$1f70d263701b1d01 {
    static #_ = /** config * */ this.VCParts = [
        '25',
        '50',
        '75',
        '80',
        '85',
        '90',
        '95',
        '98',
        '99'
    ];
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $cAaWV.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $2820034be8182b76$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $2820034be8182b76$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $2820034be8182b76$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $7ytdb.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $7ytdb.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            var _window$__ufo_devtool2, _window2;
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) {
                                var _window$__ufo_devtool, _window;
                                (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                            }
                            // Handle v2
                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            var _window$__on_ufo_vc_d2, _window4;
                            if (!isTTVCv1Disabled) {
                                var _window$__on_ufo_vc_d, _window3;
                                (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                            }
                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $fSWhE.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $2820034be8182b76$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $2820034be8182b76$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $cAaWV.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $9TwI7.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $cAaWV.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($2820034be8182b76$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $e6Qdr.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $9TwI7.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') break;
                    }
                    this.setAbortReason($2820034be8182b76$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($2820034be8182b76$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            var _window5;
            this.detachAbortListeners();
            let unbinds = (0, $cGX1L.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        this.observers = new (0, $jZtCM.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            },
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $cAaWV.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $2820034be8182b76$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $2820034be8182b76$var$UNUSED_SECTOR) {
            var _window$document;
            const element = {
                __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $2820034be8182b76$var$UNUSED_SECTOR && ssrTime !== $2820034be8182b76$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $2820034be8182b76$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $2820034be8182b76$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $2820034be8182b76$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $2820034be8182b76$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $2820034be8182b76$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    var _componentsLog$time;
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            var _acc$abs, _componentsLog$timest, _acc$rel;
            const currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (((_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $2820034be8182b76$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $cAaWV.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($2820034be8182b76$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $84DIS.getViewportWidth)();
        this.viewport.h = (0, $84DIS.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($2820034be8182b76$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($2820034be8182b76$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $2820034be8182b76$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("cGX1L", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $d6c8848777a6f71b$export$9010aa71841a6887);

var $36kyW = parcelRequire("36kyW");

var $fOo8v = parcelRequire("fOo8v");

var $84DIS = parcelRequire("84DIS");
function $d6c8848777a6f71b$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $36kyW.bind)(window, {
        type: (0, $fOo8v.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $fOo8v.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $36kyW.bind)(window, {
        type: (0, $fOo8v.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $fOo8v.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $36kyW.bind)(window, {
        type: (0, $fOo8v.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $84DIS.getViewportWidth)() !== initialViewPort.w || (0, $84DIS.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $fOo8v.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("fOo8v", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $6638d5d576383bac$export$199edc0307b5587f);
const $6638d5d576383bac$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("84DIS", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $71650b61261aaf39$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $71650b61261aaf39$export$4f01c15d21ef9cc6);
function $71650b61261aaf39$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $71650b61261aaf39$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("7ytdb", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $3e40bc1b527561a4$export$72e6dda9d5859230);
function $3e40bc1b527561a4$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                    rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                    visible: true,
                    attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                    oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                    newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                    ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("fSWhE", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $dda4eb840492bcae$export$5c86a34c9becd6d0);

var $cAaWV = parcelRequire("cAaWV");

var $cHs48 = parcelRequire("cHs48");
const $dda4eb840492bcae$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $dda4eb840492bcae$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $dda4eb840492bcae$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $dda4eb840492bcae$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $dda4eb840492bcae$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $dda4eb840492bcae$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $cHs48.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $cAaWV.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $dda4eb840492bcae$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $cAaWV.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $dda4eb840492bcae$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});

parcelRegister("jZtCM", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $5e4ed2c1ecf48821$export$b65d046240060e78);

var $9aqGr = parcelRequire("9aqGr");

var $3RyBe = parcelRequire("3RyBe");

var $aCcrY = parcelRequire("aCcrY");

var $T2wiA = parcelRequire("T2wiA");
const $5e4ed2c1ecf48821$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $5e4ed2c1ecf48821$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $5e4ed2c1ecf48821$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $5e4ed2c1ecf48821$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            var _this$intersectionObs2;
            (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        this.selectorConfig = {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $T2wiA.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder
            });
        }
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        var _this$mutationObserve;
        this.totalTime = 0;
        this.ssr = {
            state: $5e4ed2c1ecf48821$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        var _this$mutationObserve2, _this$intersectionObs;
        (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
        (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $5e4ed2c1ecf48821$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $5e4ed2c1ecf48821$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $5e4ed2c1ecf48821$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $5e4ed2c1ecf48821$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $5e4ed2c1ecf48821$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $9aqGr.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            var _this$intersectionObs3;
                            this.elementsInView.delete(node);
                            (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $3RyBe.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $9aqGr.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                    return;
                    if (!$5e4ed2c1ecf48821$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $aCcrY.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("9aqGr", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $66d15fc48b48d2d5$export$f61fbc3b9c4a9019);

var $bQ4Mn = parcelRequire("bQ4Mn");
function $66d15fc48b48d2d5$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $bQ4Mn.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("bQ4Mn", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $91d59b0a35abdc0e$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $91d59b0a35abdc0e$export$7028e9efe569888c);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $91d59b0a35abdc0e$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $91d59b0a35abdc0e$export$7028e9efe569888c = {
    [$91d59b0a35abdc0e$export$7674290405cc25b0]: true
};
function $91d59b0a35abdc0e$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ...$91d59b0a35abdc0e$export$7028e9efe569888c,
        children: children
    });
}

});
parcelRegister("gWgPx", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gRotv"));

});
parcelRegister("gRotv", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $c46494c91b22ef6f$export$ffb0004e005737fa, (v) => $c46494c91b22ef6f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $c46494c91b22ef6f$export$34b9dba7ce09269b, (v) => $c46494c91b22ef6f$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $c46494c91b22ef6f$export$25062201e9e25d76, (v) => $c46494c91b22ef6f$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c46494c91b22ef6f$export$ffb0004e005737fa;
var $c46494c91b22ef6f$export$34b9dba7ce09269b;
var $c46494c91b22ef6f$export$25062201e9e25d76;
'use strict';

var $8P7DW = parcelRequire("8P7DW");
var $c46494c91b22ef6f$var$k = Symbol.for("react.element"), $c46494c91b22ef6f$var$l = Symbol.for("react.fragment"), $c46494c91b22ef6f$var$m = Object.prototype.hasOwnProperty, $c46494c91b22ef6f$var$n = $8P7DW.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c46494c91b22ef6f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c46494c91b22ef6f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c46494c91b22ef6f$var$m.call(a, b) && !$c46494c91b22ef6f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c46494c91b22ef6f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c46494c91b22ef6f$var$n.current
    };
}
$c46494c91b22ef6f$export$ffb0004e005737fa = $c46494c91b22ef6f$var$l;
$c46494c91b22ef6f$export$34b9dba7ce09269b = $c46494c91b22ef6f$var$q;
$c46494c91b22ef6f$export$25062201e9e25d76 = $c46494c91b22ef6f$var$q;

});
parcelRegister("8P7DW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7T9zz"));

});
parcelRegister("7T9zz", function(module, exports) {
$parcel$export(module.exports, "Children", () => $5be5186244f8762f$export$dca3b0875bd9a954, (v) => $5be5186244f8762f$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $5be5186244f8762f$export$16fa2f45be04daa8, (v) => $5be5186244f8762f$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $5be5186244f8762f$export$ffb0004e005737fa, (v) => $5be5186244f8762f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $5be5186244f8762f$export$e2c29f18771995cb, (v) => $5be5186244f8762f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $5be5186244f8762f$export$221d75b3f55bb0bd, (v) => $5be5186244f8762f$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $5be5186244f8762f$export$5f8d39834fd61797, (v) => $5be5186244f8762f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $5be5186244f8762f$export$74bf444e3cd11ea5, (v) => $5be5186244f8762f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $5be5186244f8762f$export$ae55be85d98224ed, (v) => $5be5186244f8762f$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $5be5186244f8762f$export$3ba232387fd5d6dd, (v) => $5be5186244f8762f$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $5be5186244f8762f$export$e530037191fcd5d7, (v) => $5be5186244f8762f$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $5be5186244f8762f$export$fd42f52fd3ae1109, (v) => $5be5186244f8762f$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $5be5186244f8762f$export$c8a8987d4410bf2d, (v) => $5be5186244f8762f$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $5be5186244f8762f$export$d38cd72104c1f0e9, (v) => $5be5186244f8762f$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $5be5186244f8762f$export$7d1e3a5e95ceca43, (v) => $5be5186244f8762f$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $5be5186244f8762f$export$257a8862b851cb5b, (v) => $5be5186244f8762f$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $5be5186244f8762f$export$a8257692ac88316c, (v) => $5be5186244f8762f$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $5be5186244f8762f$export$488013bae63b21da, (v) => $5be5186244f8762f$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $5be5186244f8762f$export$7c73462e0d25e514, (v) => $5be5186244f8762f$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $5be5186244f8762f$export$7568632d0d33d16d, (v) => $5be5186244f8762f$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $5be5186244f8762f$export$88948ce120ea2619, (v) => $5be5186244f8762f$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $5be5186244f8762f$export$35808ee640e87ca7, (v) => $5be5186244f8762f$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $5be5186244f8762f$export$fae74005e78b1a27, (v) => $5be5186244f8762f$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $5be5186244f8762f$export$dc8fbce3eb94dc1e, (v) => $5be5186244f8762f$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $5be5186244f8762f$export$6a7bc4e911dc01cf, (v) => $5be5186244f8762f$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $5be5186244f8762f$export$6d9c69b0de29b591, (v) => $5be5186244f8762f$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $5be5186244f8762f$export$f680877a34711e37, (v) => $5be5186244f8762f$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $5be5186244f8762f$export$d5a552a76deda3c2, (v) => $5be5186244f8762f$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $5be5186244f8762f$export$aaabe4eda9ed9969, (v) => $5be5186244f8762f$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $5be5186244f8762f$export$e5c5a5f917a5871c, (v) => $5be5186244f8762f$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $5be5186244f8762f$export$1538c33de8887b59, (v) => $5be5186244f8762f$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $5be5186244f8762f$export$13e3392192263954, (v) => $5be5186244f8762f$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $5be5186244f8762f$export$b8f5890fc79d6aca, (v) => $5be5186244f8762f$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $5be5186244f8762f$export$60241385465d0a34, (v) => $5be5186244f8762f$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $5be5186244f8762f$export$306c0aa65ff9ec16, (v) => $5be5186244f8762f$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $5be5186244f8762f$export$7b286972b8d8ccbf, (v) => $5be5186244f8762f$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $5be5186244f8762f$export$83d89fbfd8236492, (v) => $5be5186244f8762f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5be5186244f8762f$export$dca3b0875bd9a954;
var $5be5186244f8762f$export$16fa2f45be04daa8;
var $5be5186244f8762f$export$ffb0004e005737fa;
var $5be5186244f8762f$export$e2c29f18771995cb;
var $5be5186244f8762f$export$221d75b3f55bb0bd;
var $5be5186244f8762f$export$5f8d39834fd61797;
var $5be5186244f8762f$export$74bf444e3cd11ea5;
var $5be5186244f8762f$export$ae55be85d98224ed;
var $5be5186244f8762f$export$3ba232387fd5d6dd;
var $5be5186244f8762f$export$e530037191fcd5d7;
var $5be5186244f8762f$export$fd42f52fd3ae1109;
var $5be5186244f8762f$export$c8a8987d4410bf2d;
var $5be5186244f8762f$export$d38cd72104c1f0e9;
var $5be5186244f8762f$export$7d1e3a5e95ceca43;
var $5be5186244f8762f$export$257a8862b851cb5b;
var $5be5186244f8762f$export$a8257692ac88316c;
var $5be5186244f8762f$export$488013bae63b21da;
var $5be5186244f8762f$export$7c73462e0d25e514;
var $5be5186244f8762f$export$7568632d0d33d16d;
var $5be5186244f8762f$export$88948ce120ea2619;
var $5be5186244f8762f$export$35808ee640e87ca7;
var $5be5186244f8762f$export$fae74005e78b1a27;
var $5be5186244f8762f$export$dc8fbce3eb94dc1e;
var $5be5186244f8762f$export$6a7bc4e911dc01cf;
var $5be5186244f8762f$export$6d9c69b0de29b591;
var $5be5186244f8762f$export$f680877a34711e37;
var $5be5186244f8762f$export$d5a552a76deda3c2;
var $5be5186244f8762f$export$aaabe4eda9ed9969;
var $5be5186244f8762f$export$e5c5a5f917a5871c;
var $5be5186244f8762f$export$1538c33de8887b59;
var $5be5186244f8762f$export$13e3392192263954;
var $5be5186244f8762f$export$b8f5890fc79d6aca;
var $5be5186244f8762f$export$60241385465d0a34;
var $5be5186244f8762f$export$306c0aa65ff9ec16;
var $5be5186244f8762f$export$7b286972b8d8ccbf;
var $5be5186244f8762f$export$83d89fbfd8236492;
'use strict';
var $5be5186244f8762f$var$l = Symbol.for("react.element"), $5be5186244f8762f$var$n = Symbol.for("react.portal"), $5be5186244f8762f$var$p = Symbol.for("react.fragment"), $5be5186244f8762f$var$q = Symbol.for("react.strict_mode"), $5be5186244f8762f$var$r = Symbol.for("react.profiler"), $5be5186244f8762f$var$t = Symbol.for("react.provider"), $5be5186244f8762f$var$u = Symbol.for("react.context"), $5be5186244f8762f$var$v = Symbol.for("react.forward_ref"), $5be5186244f8762f$var$w = Symbol.for("react.suspense"), $5be5186244f8762f$var$x = Symbol.for("react.memo"), $5be5186244f8762f$var$y = Symbol.for("react.lazy"), $5be5186244f8762f$var$z = Symbol.iterator;
function $5be5186244f8762f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5be5186244f8762f$var$z && a[$5be5186244f8762f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5be5186244f8762f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5be5186244f8762f$var$C = Object.assign, $5be5186244f8762f$var$D = {};
function $5be5186244f8762f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5be5186244f8762f$var$D;
    this.updater = e || $5be5186244f8762f$var$B;
}
$5be5186244f8762f$var$E.prototype.isReactComponent = {};
$5be5186244f8762f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$5be5186244f8762f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $5be5186244f8762f$var$F() {}
$5be5186244f8762f$var$F.prototype = $5be5186244f8762f$var$E.prototype;
function $5be5186244f8762f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5be5186244f8762f$var$D;
    this.updater = e || $5be5186244f8762f$var$B;
}
var $5be5186244f8762f$var$H = $5be5186244f8762f$var$G.prototype = new $5be5186244f8762f$var$F;
$5be5186244f8762f$var$H.constructor = $5be5186244f8762f$var$G;
$5be5186244f8762f$var$C($5be5186244f8762f$var$H, $5be5186244f8762f$var$E.prototype);
$5be5186244f8762f$var$H.isPureReactComponent = !0;
var $5be5186244f8762f$var$I = Array.isArray, $5be5186244f8762f$var$J = Object.prototype.hasOwnProperty, $5be5186244f8762f$var$K = {
    current: null
}, $5be5186244f8762f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5be5186244f8762f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$5be5186244f8762f$var$J.call(b, d) && !$5be5186244f8762f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $5be5186244f8762f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $5be5186244f8762f$var$K.current
    };
}
function $5be5186244f8762f$var$N(a, b) {
    return {
        $$typeof: $5be5186244f8762f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $5be5186244f8762f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5be5186244f8762f$var$l;
}
function $5be5186244f8762f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $5be5186244f8762f$var$P = /\/+/g;
function $5be5186244f8762f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $5be5186244f8762f$var$escape("" + a.key) : b.toString(36);
}
function $5be5186244f8762f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $5be5186244f8762f$var$l:
                case $5be5186244f8762f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $5be5186244f8762f$var$Q(h, 0) : d, $5be5186244f8762f$var$I(c) ? (e = "", null != a && (e = a.replace($5be5186244f8762f$var$P, "$&/") + "/"), $5be5186244f8762f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($5be5186244f8762f$var$O(c) && (c = $5be5186244f8762f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($5be5186244f8762f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($5be5186244f8762f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $5be5186244f8762f$var$Q(k, g);
        h += $5be5186244f8762f$var$R(k, b, e, f, c);
    }
    else if (f = $5be5186244f8762f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $5be5186244f8762f$var$Q(k, g++), h += $5be5186244f8762f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $5be5186244f8762f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $5be5186244f8762f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $5be5186244f8762f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $5be5186244f8762f$var$U = {
    current: null
}, $5be5186244f8762f$var$V = {
    transition: null
}, $5be5186244f8762f$var$W = {
    ReactCurrentDispatcher: $5be5186244f8762f$var$U,
    ReactCurrentBatchConfig: $5be5186244f8762f$var$V,
    ReactCurrentOwner: $5be5186244f8762f$var$K
};
function $5be5186244f8762f$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$5be5186244f8762f$export$dca3b0875bd9a954 = {
    map: $5be5186244f8762f$var$S,
    forEach: function(a, b, e) {
        $5be5186244f8762f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $5be5186244f8762f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $5be5186244f8762f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$5be5186244f8762f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$5be5186244f8762f$export$16fa2f45be04daa8 = $5be5186244f8762f$var$E;
$5be5186244f8762f$export$ffb0004e005737fa = $5be5186244f8762f$var$p;
$5be5186244f8762f$export$e2c29f18771995cb = $5be5186244f8762f$var$r;
$5be5186244f8762f$export$221d75b3f55bb0bd = $5be5186244f8762f$var$G;
$5be5186244f8762f$export$5f8d39834fd61797 = $5be5186244f8762f$var$q;
$5be5186244f8762f$export$74bf444e3cd11ea5 = $5be5186244f8762f$var$w;
$5be5186244f8762f$export$ae55be85d98224ed = $5be5186244f8762f$var$W;
$5be5186244f8762f$export$3ba232387fd5d6dd = $5be5186244f8762f$var$X;
$5be5186244f8762f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $5be5186244f8762f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $5be5186244f8762f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$5be5186244f8762f$var$J.call(b, f) && !$5be5186244f8762f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $5be5186244f8762f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$5be5186244f8762f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $5be5186244f8762f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $5be5186244f8762f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$5be5186244f8762f$export$c8a8987d4410bf2d = $5be5186244f8762f$var$M;
$5be5186244f8762f$export$d38cd72104c1f0e9 = function(a) {
    var b = $5be5186244f8762f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$5be5186244f8762f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5be5186244f8762f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $5be5186244f8762f$var$v,
        render: a
    };
};
$5be5186244f8762f$export$a8257692ac88316c = $5be5186244f8762f$var$O;
$5be5186244f8762f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $5be5186244f8762f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $5be5186244f8762f$var$T
    };
};
$5be5186244f8762f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $5be5186244f8762f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$5be5186244f8762f$export$7568632d0d33d16d = function(a) {
    var b = $5be5186244f8762f$var$V.transition;
    $5be5186244f8762f$var$V.transition = {};
    try {
        a();
    } finally{
        $5be5186244f8762f$var$V.transition = b;
    }
};
$5be5186244f8762f$export$88948ce120ea2619 = $5be5186244f8762f$var$X;
$5be5186244f8762f$export$35808ee640e87ca7 = function(a, b) {
    return $5be5186244f8762f$var$U.current.useCallback(a, b);
};
$5be5186244f8762f$export$fae74005e78b1a27 = function(a) {
    return $5be5186244f8762f$var$U.current.useContext(a);
};
$5be5186244f8762f$export$dc8fbce3eb94dc1e = function() {};
$5be5186244f8762f$export$6a7bc4e911dc01cf = function(a) {
    return $5be5186244f8762f$var$U.current.useDeferredValue(a);
};
$5be5186244f8762f$export$6d9c69b0de29b591 = function(a, b) {
    return $5be5186244f8762f$var$U.current.useEffect(a, b);
};
$5be5186244f8762f$export$f680877a34711e37 = function() {
    return $5be5186244f8762f$var$U.current.useId();
};
$5be5186244f8762f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $5be5186244f8762f$var$U.current.useImperativeHandle(a, b, e);
};
$5be5186244f8762f$export$aaabe4eda9ed9969 = function(a, b) {
    return $5be5186244f8762f$var$U.current.useInsertionEffect(a, b);
};
$5be5186244f8762f$export$e5c5a5f917a5871c = function(a, b) {
    return $5be5186244f8762f$var$U.current.useLayoutEffect(a, b);
};
$5be5186244f8762f$export$1538c33de8887b59 = function(a, b) {
    return $5be5186244f8762f$var$U.current.useMemo(a, b);
};
$5be5186244f8762f$export$13e3392192263954 = function(a, b, e) {
    return $5be5186244f8762f$var$U.current.useReducer(a, b, e);
};
$5be5186244f8762f$export$b8f5890fc79d6aca = function(a) {
    return $5be5186244f8762f$var$U.current.useRef(a);
};
$5be5186244f8762f$export$60241385465d0a34 = function(a) {
    return $5be5186244f8762f$var$U.current.useState(a);
};
$5be5186244f8762f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $5be5186244f8762f$var$U.current.useSyncExternalStore(a, b, e);
};
$5be5186244f8762f$export$7b286972b8d8ccbf = function() {
    return $5be5186244f8762f$var$U.current.useTransition();
};
$5be5186244f8762f$export$83d89fbfd8236492 = "18.3.1";

});






parcelRegister("3RyBe", function(module, exports) {
$parcel$export(module.exports, "default", () => $893d0a5b00c8910b$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $893d0a5b00c8910b$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $893d0a5b00c8910b$export$2e2bcd8739ae039 = $893d0a5b00c8910b$var$isNonVisualStyleMutation;

});

parcelRegister("aCcrY", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $ff7a1489dc4ec222$export$166779fc0f49d4df);
const $ff7a1489dc4ec222$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $ff7a1489dc4ec222$export$166779fc0f49d4df {
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$ff7a1489dc4ec222$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$ff7a1489dc4ec222$var$GLOBAL_RLL_HANDLERS_KEY] = new $ff7a1489dc4ec222$export$166779fc0f49d4df();
            return globalThis[$ff7a1489dc4ec222$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $ff7a1489dc4ec222$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            var _el$dataset;
            if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
}

});

parcelRegister("T2wiA", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $dfbdd15722a1bf56$export$c0102f1a1198d10f);
const $dfbdd15722a1bf56$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $dfbdd15722a1bf56$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $dfbdd15722a1bf56$export$c0102f1a1198d10f {
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = (el)=>{
            var _el$dataset;
            const ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $dfbdd15722a1bf56$var$PAGE_LAYOUT_ID) return $dfbdd15722a1bf56$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            var _el$dataset2;
            const ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $dfbdd15722a1bf56$var$PAGE_LAYOUT_ID) return $dfbdd15722a1bf56$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            var _this$intersectionObs5;
            (_this$intersectionObs5 = this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch  {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                var _window$__SSR_PLACEHO, _this$intersectionObs;
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $dfbdd15722a1bf56$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $dfbdd15722a1bf56$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $dfbdd15722a1bf56$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $dfbdd15722a1bf56$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this$intersectionObs2;
                this.callbacks.set(id, resolve);
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            var _this$intersectionObs3;
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this$intersectionObs4;
                this.reactValidateCallbacks.set(id, resolve);
                (_this$intersectionObs4 = this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});




parcelRegister("5UJvw", function(module, exports) {
$parcel$export(module.exports, "sinkExtraSearchPageInteractionHandler", () => $04526424381f2021$export$e6a07a94f3e112d4);
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $04526424381f2021$export$74b9ce7e9d206a8);
const $04526424381f2021$var$interactionBuffer = [];
let $04526424381f2021$var$bufferInteractionData = (interactionId, data)=>{
    $04526424381f2021$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $04526424381f2021$var$clearInteractionBuffer() {
    $04526424381f2021$var$interactionBuffer.length = 0;
}
function $04526424381f2021$var$appendInteractionData(interactionId, data) {
    $04526424381f2021$var$bufferInteractionData(interactionId, data);
}
function $04526424381f2021$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $04526424381f2021$var$interactionBuffer)handler(interactionId, data);
    $04526424381f2021$var$clearInteractionBuffer();
    $04526424381f2021$var$bufferInteractionData = handler;
}
function $04526424381f2021$export$e6a07a94f3e112d4(sinkFn) {
    $04526424381f2021$var$installInteractionSink(sinkFn);
}
function $04526424381f2021$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $04526424381f2021$var$appendInteractionData(interactionId, data);
        $04526424381f2021$var$clearInteractionBuffer();
    }
}

});

parcelRegister("czEyx", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $d96926423d7d33bf$export$e08487ea3ae92adb);
$parcel$export(module.exports, "isSegmentLabel", () => $d96926423d7d33bf$export$1adbaf5c2363e4ae);
$parcel$export(module.exports, "buildSegmentTree", () => $d96926423d7d33bf$export$1569bc0edeecbcd8);
$parcel$export(module.exports, "stringifyLabelStackFully", () => $d96926423d7d33bf$export$caeee352b541de1f);
$parcel$export(module.exports, "labelStackStartWith", () => $d96926423d7d33bf$export$1787b1cd413c7e2);
$parcel$export(module.exports, "optimizeLabelStack", () => $d96926423d7d33bf$export$a0cd72da07c76b4c);
$parcel$export(module.exports, "optimizeLabelStackWithRegistry", () => $d96926423d7d33bf$export$cb3145456a04e238);
$parcel$export(module.exports, "getOldSegmentsLabelStack", () => $d96926423d7d33bf$export$b70bcfd92c93435e);

var $cAaWV = parcelRequire("cAaWV");
function $d96926423d7d33bf$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $d96926423d7d33bf$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $d96926423d7d33bf$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, $cAaWV.getConfig)();
    const segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    const addSegmentsMap = new Map();
    labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = $d96926423d7d33bf$export$88f21baa687271f4(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = $d96926423d7d33bf$export$1adbaf5c2363e4ae(label);
            const name = label.name;
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        }
    });
    return {
        r: r
    };
}
function $d96926423d7d33bf$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        if ($d96926423d7d33bf$export$1adbaf5c2363e4ae(l)) return `${l.name}:${l.segmentId}`;
        return l.name;
    }).join('/');
}
function $d96926423d7d33bf$export$88f21baa687271f4(labelStack) {
    return labelStack.map((l)=>{
        if ($d96926423d7d33bf$export$1adbaf5c2363e4ae(l)) return `${l.name}:segment`;
        return l.name;
    }).join('/');
}
function $d96926423d7d33bf$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$d96926423d7d33bf$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name).join('/');
}
function $d96926423d7d33bf$export$1787b1cd413c7e2(labelStack, startWith) {
    return $d96926423d7d33bf$export$caeee352b541de1f(labelStack).startsWith($d96926423d7d33bf$export$caeee352b541de1f(startWith));
}
function $d96926423d7d33bf$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $d96926423d7d33bf$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: ls.name,
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {},
            ...ls.type ? {
                t: ls.type
            } : {}
        }));
}
function $d96926423d7d33bf$export$cb3145456a04e238(labelStack, reactUFOVersion, registry) {
    if (registry && reactUFOVersion === '2.0.0') {
        const ref = $d96926423d7d33bf$var$getLabelStackReference(labelStack);
        return registry.register(ref);
    }
    return $d96926423d7d33bf$export$a0cd72da07c76b4c(labelStack, reactUFOVersion);
}
function $d96926423d7d33bf$export$b70bcfd92c93435e(segments, _interactionType) {
    const config = (0, $cAaWV.getConfig)();
    const addSegmentsMap = new Map();
    const segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    return segments.map(({ labelStack: labelStack, ...others })=>{
        const stringifiedLabelStack = $d96926423d7d33bf$export$88f21baa687271f4(labelStack);
        const segmentsInfo = [];
        for (const ls of labelStack){
            const isSegment = $d96926423d7d33bf$export$1adbaf5c2363e4ae(ls);
            if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
                const threshold = segmentThreshold[ls.name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            segmentsInfo.push({
                n: ls.name,
                ...ls.segmentId ? {
                    s: ls.segmentId
                } : {},
                ...ls.type ? {
                    t: ls.type
                } : {}
            });
        }
        return {
            ...others,
            labelStack: segmentsInfo
        };
    });
}

});

parcelRegister("l5LZV", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $206ce4095ade43bf$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $206ce4095ade43bf$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $206ce4095ade43bf$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $206ce4095ade43bf$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $206ce4095ade43bf$export$6e17cce6446848f9);
parcelRequire("5bVra");
var $81CCG = parcelRequire("81CCG");
var $lKG8Q = parcelRequire("lKG8Q");

var $e6Qdr = parcelRequire("e6Qdr");

var $7IuMj = parcelRequire("7IuMj");

var $5ByXd = parcelRequire("5ByXd");
const $206ce4095ade43bf$var$state = {
    context: null
};
const $206ce4095ade43bf$var$traceIdKey = (0, $lKG8Q.createContextKey)('traceId');
const $206ce4095ade43bf$var$spanIdKey = (0, $lKG8Q.createContextKey)('spanId');
const $206ce4095ade43bf$var$experienceTypeKey = (0, $lKG8Q.createContextKey)('type');
function $206ce4095ade43bf$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $206ce4095ade43bf$export$f2e521e495a88544(interactionId, experienceType) {
    $206ce4095ade43bf$export$a1002be327997103(interactionId.replace(/-/g, ''), $206ce4095ade43bf$export$295213bc4d0c54ad(), experienceType);
}
function $206ce4095ade43bf$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $e6Qdr.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $lKG8Q.ROOT_CONTEXT).setValue($206ce4095ade43bf$var$traceIdKey, traceId).setValue($206ce4095ade43bf$var$spanIdKey, spanId).setValue($206ce4095ade43bf$var$experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $7IuMj.getContextManager)() instanceof (0, $7IuMj.UFOContextManager)) {
            let contextManager = (0, $7IuMj.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else $206ce4095ade43bf$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $206ce4095ade43bf$export$b6ac780db3a3cc77() {
    if ((0, $e6Qdr.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $81CCG.context).active().getValue($206ce4095ade43bf$var$traceIdKey)),
            spanId: String((0, $81CCG.context).active().getValue($206ce4095ade43bf$var$spanIdKey)),
            type: String((0, $81CCG.context).active().getValue($206ce4095ade43bf$var$experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return $206ce4095ade43bf$var$state.context || undefined;
}
function $206ce4095ade43bf$export$17ab21d7be720b() {
    if ((0, $e6Qdr.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $7IuMj.getContextManager)() instanceof (0, $7IuMj.UFOContextManager)) {
            let contextManager = (0, $7IuMj.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $lKG8Q.ROOT_CONTEXT));
        }
    } else $206ce4095ade43bf$var$state.context = null;
}
function $206ce4095ade43bf$export$6e17cce6446848f9(_url) {
    if ($206ce4095ade43bf$export$b6ac780db3a3cc77() === undefined) return null;
    const { traceId: traceId, spanId: spanId } = $206ce4095ade43bf$export$b6ac780db3a3cc77();
    return (0, $5ByXd.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $206ce4095ade43bf$export$a1e7396778592551(_url) {
    const traceHeaders = $206ce4095ade43bf$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("5bVra", function(module, exports) {
$parcel$export(module.exports, "context", () => (parcelRequire("81CCG")).context);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $lKG8Q = parcelRequire("lKG8Q");















var $81CCG = parcelRequire("81CCG");

var $1QgrK = parcelRequire("1QgrK");

var $a8ljk = parcelRequire("a8ljk");

var $01Qw3 = parcelRequire("01Qw3");

var $6t1GZ = parcelRequire("6t1GZ");
var // Default export.
$3c7a88ae7d95fc28$export$2e2bcd8739ae039 = {
    context: (0, $81CCG.context),
    diag: (0, $1QgrK.diag),
    metrics: (0, $a8ljk.metrics),
    propagation: (0, $01Qw3.propagation),
    trace: (0, $6t1GZ.trace)
};

});
parcelRegister("lKG8Q", function(module, exports) {
$parcel$export(module.exports, "createContextKey", () => $fd5e9552ae3859c7$export$b8c322c5a7cfce78);
$parcel$export(module.exports, "ROOT_CONTEXT", () => $fd5e9552ae3859c7$export$78df28f9b2f9a7dc);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $fd5e9552ae3859c7$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $fd5e9552ae3859c7$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $fd5e9552ae3859c7$export$78df28f9b2f9a7dc = new $fd5e9552ae3859c7$var$BaseContext();

});

parcelRegister("81CCG", function(module, exports) {
$parcel$export(module.exports, "context", () => $5d7c606f28609e03$export$a078c61943f9dbbe);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $dbYDR = parcelRequire("dbYDR");
var $5d7c606f28609e03$export$a078c61943f9dbbe = (0, $dbYDR.ContextAPI).getInstance();

});
parcelRegister("dbYDR", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", () => $99ab57a3eb811117$export$4148866f0a453927);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $i056k = parcelRequire("i056k");

var $kbnAA = parcelRequire("kbnAA");

var $kMxlo = parcelRequire("kMxlo");
var $99ab57a3eb811117$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $99ab57a3eb811117$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $99ab57a3eb811117$var$API_NAME = 'context';
var $99ab57a3eb811117$var$NOOP_CONTEXT_MANAGER = new (0, $i056k.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $99ab57a3eb811117$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $kbnAA.registerGlobal)($99ab57a3eb811117$var$API_NAME, contextManager, (0, $kMxlo.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $99ab57a3eb811117$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $99ab57a3eb811117$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $kbnAA.getGlobal)($99ab57a3eb811117$var$API_NAME) || $99ab57a3eb811117$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $kbnAA.unregisterGlobal)($99ab57a3eb811117$var$API_NAME, (0, $kMxlo.DiagAPI).instance());
    };
    return ContextAPI;
}();

});
parcelRegister("i056k", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", () => $d1ac2f072857815a$export$a27e5df35d1539a6);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $lKG8Q = parcelRequire("lKG8Q");
var $d1ac2f072857815a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d1ac2f072857815a$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $d1ac2f072857815a$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $lKG8Q.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $d1ac2f072857815a$var$__spreadArray([
            thisArg
        ], $d1ac2f072857815a$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

});

parcelRegister("kbnAA", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", () => $eb172203d3892778$export$d586ae880b433238);
$parcel$export(module.exports, "getGlobal", () => $eb172203d3892778$export$a4e55266d2135a7f);
$parcel$export(module.exports, "unregisterGlobal", () => $eb172203d3892778$export$d42ac835f38d1fb2);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dMmBx = parcelRequire("dMmBx");

var $d0lOS = parcelRequire("d0lOS");

var $bzdpG = parcelRequire("bzdpG");
var $eb172203d3892778$var$major = (0, $d0lOS.VERSION).split('.')[0];
var $eb172203d3892778$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $eb172203d3892778$var$major);
var $eb172203d3892778$var$_global = (0, $dMmBx._globalThis);
function $eb172203d3892778$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $eb172203d3892778$var$_global[$eb172203d3892778$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $eb172203d3892778$var$_global[$eb172203d3892778$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $d0lOS.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $d0lOS.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $d0lOS.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $d0lOS.VERSION) + ".");
    return true;
}
function $eb172203d3892778$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $eb172203d3892778$var$_global[$eb172203d3892778$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $bzdpG.isCompatible)(globalVersion)) return;
    return (_b = $eb172203d3892778$var$_global[$eb172203d3892778$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $eb172203d3892778$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $d0lOS.VERSION) + ".");
    var api = $eb172203d3892778$var$_global[$eb172203d3892778$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("dMmBx", function(module, exports) {
$parcel$export(module.exports, "_globalThis", () => $a0814ace7ec3a7c8$export$5c524ddf7208c00c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $a0814ace7ec3a7c8$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});

parcelRegister("d0lOS", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $977c336299bf0590$export$a4ad2735b021c132);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $977c336299bf0590$export$a4ad2735b021c132 = '1.9.0';

});

parcelRegister("bzdpG", function(module, exports) {
$parcel$export(module.exports, "isCompatible", () => $86bd5e31b2983b16$export$7fc0d8c3ab188c4c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $d0lOS = parcelRequire("d0lOS");
var $86bd5e31b2983b16$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $86bd5e31b2983b16$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($86bd5e31b2983b16$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($86bd5e31b2983b16$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $86bd5e31b2983b16$export$7fc0d8c3ab188c4c = $86bd5e31b2983b16$export$a5733a4d26a1ec61((0, $d0lOS.VERSION));

});


parcelRegister("kMxlo", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", () => $f21227cbe1e697ec$export$5c8937ffc688cfd3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jXimZ = parcelRequire("jXimZ");

var $6aLJn = parcelRequire("6aLJn");

var $bMxdC = parcelRequire("bMxdC");

var $kbnAA = parcelRequire("kbnAA");
var $f21227cbe1e697ec$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f21227cbe1e697ec$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f21227cbe1e697ec$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $f21227cbe1e697ec$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $kbnAA.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $f21227cbe1e697ec$var$__spreadArray([], $f21227cbe1e697ec$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $bMxdC.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $kbnAA.getGlobal)('diag');
            var newLogger = (0, $6aLJn.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $bMxdC.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $kbnAA.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $kbnAA.unregisterGlobal)($f21227cbe1e697ec$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $jXimZ.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

});
parcelRegister("jXimZ", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", () => $e871c6d9e17c1158$export$b4bccc12f5b13129);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kbnAA = parcelRequire("kbnAA");
var $e871c6d9e17c1158$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e871c6d9e17c1158$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $e871c6d9e17c1158$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e871c6d9e17c1158$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e871c6d9e17c1158$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e871c6d9e17c1158$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e871c6d9e17c1158$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $e871c6d9e17c1158$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $e871c6d9e17c1158$var$logProxy(funcName, namespace, args) {
    var logger = (0, $kbnAA.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $e871c6d9e17c1158$var$__spreadArray([], $e871c6d9e17c1158$var$__read(args), false));
}

});

parcelRegister("6aLJn", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", () => $47e8b397ab15ccc2$export$9a9cc475abb19689);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bMxdC = parcelRequire("bMxdC");
function $47e8b397ab15ccc2$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $bMxdC.DiagLogLevel).NONE) maxLevel = (0, $bMxdC.DiagLogLevel).NONE;
    else if (maxLevel > (0, $bMxdC.DiagLogLevel).ALL) maxLevel = (0, $bMxdC.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $bMxdC.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $bMxdC.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $bMxdC.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $bMxdC.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $bMxdC.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("bMxdC", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", () => $893df1e98917a52f$export$b7d7b4c0f3c95263);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $893df1e98917a52f$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($893df1e98917a52f$export$b7d7b4c0f3c95263 || ($893df1e98917a52f$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("1QgrK", function(module, exports) {
$parcel$export(module.exports, "diag", () => $157767b49fef8729$export$c042e7c2f59bc046);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $kMxlo = parcelRequire("kMxlo");
var $157767b49fef8729$export$c042e7c2f59bc046 = (0, $kMxlo.DiagAPI).instance();

});

parcelRegister("a8ljk", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $760b2e97142d4b7e$export$b0c5c2fac8144e54);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $fPFA5 = parcelRequire("fPFA5");
var $760b2e97142d4b7e$export$b0c5c2fac8144e54 = (0, $fPFA5.MetricsAPI).getInstance();

});
parcelRegister("fPFA5", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", () => $b86bdf95a90191c2$export$1339f6eb6111c638);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $7JO7b = parcelRequire("7JO7b");

var $kbnAA = parcelRequire("kbnAA");

var $kMxlo = parcelRequire("kMxlo");
var $b86bdf95a90191c2$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $b86bdf95a90191c2$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $kbnAA.registerGlobal)($b86bdf95a90191c2$var$API_NAME, provider, (0, $kMxlo.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $kbnAA.getGlobal)($b86bdf95a90191c2$var$API_NAME) || (0, $7JO7b.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $kbnAA.unregisterGlobal)($b86bdf95a90191c2$var$API_NAME, (0, $kMxlo.DiagAPI).instance());
    };
    return MetricsAPI;
}();

});
parcelRegister("7JO7b", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", () => $5a239c22de4011ee$export$d21fe83355c56e18);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $38P2i = parcelRequire("38P2i");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $5a239c22de4011ee$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $38P2i.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var $5a239c22de4011ee$export$d21fe83355c56e18 = new $5a239c22de4011ee$export$51c513ea08316108();

});
parcelRegister("38P2i", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", () => $2499b529f40c76f5$export$65e277d35235a01f);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2499b529f40c76f5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $2499b529f40c76f5$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $2499b529f40c76f5$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $2499b529f40c76f5$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $2499b529f40c76f5$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $2499b529f40c76f5$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $2499b529f40c76f5$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $2499b529f40c76f5$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $2499b529f40c76f5$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $2499b529f40c76f5$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $2499b529f40c76f5$export$b556ba0f560c45b = /** @class */ function(_super) {
    $2499b529f40c76f5$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($2499b529f40c76f5$export$834a616d1cf278b);
var $2499b529f40c76f5$export$df09a35db160df98 = /** @class */ function(_super) {
    $2499b529f40c76f5$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($2499b529f40c76f5$export$834a616d1cf278b);
var $2499b529f40c76f5$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $2499b529f40c76f5$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($2499b529f40c76f5$export$834a616d1cf278b);
var $2499b529f40c76f5$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $2499b529f40c76f5$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($2499b529f40c76f5$export$834a616d1cf278b);
var $2499b529f40c76f5$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $2499b529f40c76f5$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $2499b529f40c76f5$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($2499b529f40c76f5$export$a5a3e7829c289482);
var $2499b529f40c76f5$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $2499b529f40c76f5$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($2499b529f40c76f5$export$a5a3e7829c289482);
var $2499b529f40c76f5$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $2499b529f40c76f5$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($2499b529f40c76f5$export$a5a3e7829c289482);
var $2499b529f40c76f5$export$65e277d35235a01f = new $2499b529f40c76f5$export$c23c6f85dd4fc1e9();
var $2499b529f40c76f5$export$e6d19fe5233efc54 = new $2499b529f40c76f5$export$b556ba0f560c45b();
var $2499b529f40c76f5$export$dd01300aacbcec1c = new $2499b529f40c76f5$export$b7f4a3c7ea16c24();
var $2499b529f40c76f5$export$689c32a6a552e1a6 = new $2499b529f40c76f5$export$ef064c3e0426c607();
var $2499b529f40c76f5$export$2f189cd99d2b7429 = new $2499b529f40c76f5$export$df09a35db160df98();
var $2499b529f40c76f5$export$163422b94c3edbcb = new $2499b529f40c76f5$export$7a7e4b169d5c93a8();
var $2499b529f40c76f5$export$ea67e3c6ff624776 = new $2499b529f40c76f5$export$6990a2f90809ffc1();
var $2499b529f40c76f5$export$5b8be9ab17b673b3 = new $2499b529f40c76f5$export$3ec3555bc6f693a4();
function $2499b529f40c76f5$export$bc3a498ccbb5c2b5() {
    return $2499b529f40c76f5$export$65e277d35235a01f;
}

});




parcelRegister("01Qw3", function(module, exports) {
$parcel$export(module.exports, "propagation", () => $0058d4b3d31bcfc8$export$3e49040daa9dba20);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $ghi0Z = parcelRequire("ghi0Z");
var $0058d4b3d31bcfc8$export$3e49040daa9dba20 = (0, $ghi0Z.PropagationAPI).getInstance();

});
parcelRegister("ghi0Z", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", () => $bd9c353ff171c1d1$export$471eda0a6213cac9);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kbnAA = parcelRequire("kbnAA");

var $i1pKU = parcelRequire("i1pKU");

var $ikjnb = parcelRequire("ikjnb");

var $dY975 = parcelRequire("dY975");

var $bQMXJ = parcelRequire("bQMXJ");

var $kMxlo = parcelRequire("kMxlo");
var $bd9c353ff171c1d1$var$API_NAME = 'propagation';
var $bd9c353ff171c1d1$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $i1pKU.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $bd9c353ff171c1d1$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $bQMXJ.createBaggage);
        this.getBaggage = (0, $dY975.getBaggage);
        this.getActiveBaggage = (0, $dY975.getActiveBaggage);
        this.setBaggage = (0, $dY975.setBaggage);
        this.deleteBaggage = (0, $dY975.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $kbnAA.registerGlobal)($bd9c353ff171c1d1$var$API_NAME, propagator, (0, $kMxlo.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $ikjnb.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $ikjnb.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $kbnAA.unregisterGlobal)($bd9c353ff171c1d1$var$API_NAME, (0, $kMxlo.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $kbnAA.getGlobal)($bd9c353ff171c1d1$var$API_NAME) || $bd9c353ff171c1d1$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

});
parcelRegister("i1pKU", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", () => $d1ec4c867b3b2b0d$export$8356c7eb3af7963b);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $d1ec4c867b3b2b0d$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

});

parcelRegister("ikjnb", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", () => $d5791f5351fbb7ba$export$a0f575f55f38720a);
$parcel$export(module.exports, "defaultTextMapSetter", () => $d5791f5351fbb7ba$export$f70f1d111fccf1c1);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d5791f5351fbb7ba$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $d5791f5351fbb7ba$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("dY975", function(module, exports) {
$parcel$export(module.exports, "getBaggage", () => $a2b7f2b032fdb3df$export$f3bffa0b5dd10d1e);
$parcel$export(module.exports, "getActiveBaggage", () => $a2b7f2b032fdb3df$export$120a1756099436ee);
$parcel$export(module.exports, "setBaggage", () => $a2b7f2b032fdb3df$export$adc9ca19eab3f500);
$parcel$export(module.exports, "deleteBaggage", () => $a2b7f2b032fdb3df$export$4ca3a8a743c9f633);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dbYDR = parcelRequire("dbYDR");

var $lKG8Q = parcelRequire("lKG8Q");
/**
 * Baggage key
 */ var $a2b7f2b032fdb3df$var$BAGGAGE_KEY = (0, $lKG8Q.createContextKey)('OpenTelemetry Baggage Key');
function $a2b7f2b032fdb3df$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($a2b7f2b032fdb3df$var$BAGGAGE_KEY) || undefined;
}
function $a2b7f2b032fdb3df$export$120a1756099436ee() {
    return $a2b7f2b032fdb3df$export$f3bffa0b5dd10d1e((0, $dbYDR.ContextAPI).getInstance().active());
}
function $a2b7f2b032fdb3df$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($a2b7f2b032fdb3df$var$BAGGAGE_KEY, baggage);
}
function $a2b7f2b032fdb3df$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($a2b7f2b032fdb3df$var$BAGGAGE_KEY);
}

});

parcelRegister("bQMXJ", function(module, exports) {
$parcel$export(module.exports, "createBaggage", () => $8a0a87eeb3d25907$export$1034a425c7384452);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kMxlo = parcelRequire("kMxlo");

var $f0QwV = parcelRequire("f0QwV");

var $Ipzoh = parcelRequire("Ipzoh");
var $8a0a87eeb3d25907$var$diag = (0, $kMxlo.DiagAPI).instance();
function $8a0a87eeb3d25907$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $f0QwV.BaggageImpl)(new Map(Object.entries(entries)));
}
function $8a0a87eeb3d25907$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $8a0a87eeb3d25907$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $Ipzoh.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

});
parcelRegister("f0QwV", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", () => $aedf9a7c8e964270$export$b8c511fa1a5f4987);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $aedf9a7c8e964270$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $aedf9a7c8e964270$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $aedf9a7c8e964270$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $aedf9a7c8e964270$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $aedf9a7c8e964270$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

});

parcelRegister("Ipzoh", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", () => $0857f1cf002a32e2$export$92dd2fe8ddb5cb7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $0857f1cf002a32e2$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("6t1GZ", function(module, exports) {
$parcel$export(module.exports, "trace", () => $4b56c3906c41e67c$export$357889f174732d38);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $jLXog = parcelRequire("jLXog");
var $4b56c3906c41e67c$export$357889f174732d38 = (0, $jLXog.TraceAPI).getInstance();

});
parcelRegister("jLXog", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", () => $e65079d09edcd97e$export$2cccde6fcc7b568a);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kbnAA = parcelRequire("kbnAA");

var $6uxlN = parcelRequire("6uxlN");

var $gSR2R = parcelRequire("gSR2R");

var $bycYH = parcelRequire("bycYH");

var $kMxlo = parcelRequire("kMxlo");
var $e65079d09edcd97e$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $e65079d09edcd97e$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $6uxlN.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $gSR2R.wrapSpanContext);
        this.isSpanContextValid = (0, $gSR2R.isSpanContextValid);
        this.deleteSpan = (0, $bycYH.deleteSpan);
        this.getSpan = (0, $bycYH.getSpan);
        this.getActiveSpan = (0, $bycYH.getActiveSpan);
        this.getSpanContext = (0, $bycYH.getSpanContext);
        this.setSpan = (0, $bycYH.setSpan);
        this.setSpanContext = (0, $bycYH.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $kbnAA.registerGlobal)($e65079d09edcd97e$var$API_NAME, this._proxyTracerProvider, (0, $kMxlo.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $kbnAA.getGlobal)($e65079d09edcd97e$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $kbnAA.unregisterGlobal)($e65079d09edcd97e$var$API_NAME, (0, $kMxlo.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $6uxlN.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

});
parcelRegister("6uxlN", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", () => $4b9f6a23d1eae14a$export$4137aabcb4254962);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1GJFR = parcelRequire("1GJFR");

var $59kkK = parcelRequire("59kkK");
var $4b9f6a23d1eae14a$var$NOOP_TRACER_PROVIDER = new (0, $59kkK.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $4b9f6a23d1eae14a$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $1GJFR.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $4b9f6a23d1eae14a$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

});
parcelRegister("1GJFR", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", () => $13ad24a522ed5d5e$export$df2c38268c6bb6b3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $crhKK = parcelRequire("crhKK");
var $13ad24a522ed5d5e$var$NOOP_TRACER = new (0, $crhKK.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $13ad24a522ed5d5e$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $13ad24a522ed5d5e$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

});
parcelRegister("crhKK", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", () => $90e5c701debc2c81$export$714c1036cabcd223);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dbYDR = parcelRequire("dbYDR");

var $bycYH = parcelRequire("bycYH");

var $7uUX9 = parcelRequire("7uUX9");

var $gSR2R = parcelRequire("gSR2R");
var $90e5c701debc2c81$var$contextApi = (0, $dbYDR.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $90e5c701debc2c81$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $90e5c701debc2c81$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $7uUX9.NonRecordingSpan)();
        var parentFromContext = context && (0, $bycYH.getSpanContext)(context);
        if ($90e5c701debc2c81$var$isSpanContext(parentFromContext) && (0, $gSR2R.isSpanContextValid)(parentFromContext)) return new (0, $7uUX9.NonRecordingSpan)(parentFromContext);
        else return new (0, $7uUX9.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $90e5c701debc2c81$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $bycYH.setSpan)(parentContext, span);
        return $90e5c701debc2c81$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $90e5c701debc2c81$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("bycYH", function(module, exports) {
$parcel$export(module.exports, "getSpan", () => $868cefde6eda57dc$export$246e04ba06066af1);
$parcel$export(module.exports, "getActiveSpan", () => $868cefde6eda57dc$export$1be426a8e585c83e);
$parcel$export(module.exports, "setSpan", () => $868cefde6eda57dc$export$8ab2f2e6ee8ed0a8);
$parcel$export(module.exports, "deleteSpan", () => $868cefde6eda57dc$export$a6bbfe9a17f7941c);
$parcel$export(module.exports, "setSpanContext", () => $868cefde6eda57dc$export$c90bf5428c14cdb1);
$parcel$export(module.exports, "getSpanContext", () => $868cefde6eda57dc$export$1a635f8f0b912781);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $lKG8Q = parcelRequire("lKG8Q");

var $7uUX9 = parcelRequire("7uUX9");

var $dbYDR = parcelRequire("dbYDR");
/**
 * span key
 */ var $868cefde6eda57dc$var$SPAN_KEY = (0, $lKG8Q.createContextKey)('OpenTelemetry Context Key SPAN');
function $868cefde6eda57dc$export$246e04ba06066af1(context) {
    return context.getValue($868cefde6eda57dc$var$SPAN_KEY) || undefined;
}
function $868cefde6eda57dc$export$1be426a8e585c83e() {
    return $868cefde6eda57dc$export$246e04ba06066af1((0, $dbYDR.ContextAPI).getInstance().active());
}
function $868cefde6eda57dc$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($868cefde6eda57dc$var$SPAN_KEY, span);
}
function $868cefde6eda57dc$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($868cefde6eda57dc$var$SPAN_KEY);
}
function $868cefde6eda57dc$export$c90bf5428c14cdb1(context, spanContext) {
    return $868cefde6eda57dc$export$8ab2f2e6ee8ed0a8(context, new (0, $7uUX9.NonRecordingSpan)(spanContext));
}
function $868cefde6eda57dc$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $868cefde6eda57dc$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("7uUX9", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", () => $5757836d487587f0$export$972d28f7c6a8c6c7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $iUXUI = parcelRequire("iUXUI");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $5757836d487587f0$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $iUXUI.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

});
parcelRegister("iUXUI", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", () => $dc5bee978c4625a7$export$55cc39fb0d4bb4c0);
$parcel$export(module.exports, "INVALID_TRACEID", () => $dc5bee978c4625a7$export$22be96e88d95e128);
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", () => $dc5bee978c4625a7$export$8591e4c852b66703);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $46mTy = parcelRequire("46mTy");
var $dc5bee978c4625a7$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $dc5bee978c4625a7$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $dc5bee978c4625a7$export$8591e4c852b66703 = {
    traceId: $dc5bee978c4625a7$export$22be96e88d95e128,
    spanId: $dc5bee978c4625a7$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $46mTy.TraceFlags).NONE
};

});
parcelRegister("46mTy", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", () => $2fc97b70afbb31ac$export$bf9049ad2b0883ff);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2fc97b70afbb31ac$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($2fc97b70afbb31ac$export$bf9049ad2b0883ff || ($2fc97b70afbb31ac$export$bf9049ad2b0883ff = {}));

});




parcelRegister("gSR2R", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", () => $c4aad6216f29a37a$export$e4373b9a2c09216c);
$parcel$export(module.exports, "wrapSpanContext", () => $c4aad6216f29a37a$export$c19cc0f1911bdb85);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $iUXUI = parcelRequire("iUXUI");

var $7uUX9 = parcelRequire("7uUX9");
var $c4aad6216f29a37a$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $c4aad6216f29a37a$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $c4aad6216f29a37a$export$29dd34cf1269f6da(traceId) {
    return $c4aad6216f29a37a$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $iUXUI.INVALID_TRACEID);
}
function $c4aad6216f29a37a$export$8e51c6d8f0586aff(spanId) {
    return $c4aad6216f29a37a$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $iUXUI.INVALID_SPANID);
}
function $c4aad6216f29a37a$export$e4373b9a2c09216c(spanContext) {
    return $c4aad6216f29a37a$export$29dd34cf1269f6da(spanContext.traceId) && $c4aad6216f29a37a$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $c4aad6216f29a37a$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $7uUX9.NonRecordingSpan)(spanContext);
}

});



parcelRegister("59kkK", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", () => $3bfd90d98a75db0e$export$87d8e93756f9e86e);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $crhKK = parcelRequire("crhKK");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $3bfd90d98a75db0e$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $crhKK.NoopTracer)();
    };
    return NoopTracerProvider;
}();

});





parcelRegister("7IuMj", function(module, exports) {
$parcel$export(module.exports, "setContextManager", () => $1f1664298fc82bb5$export$4a00ab8a5dd9b5cf);
$parcel$export(module.exports, "getContextManager", () => $1f1664298fc82bb5$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $1f1664298fc82bb5$export$dd301b96c16f583d);

var $lKG8Q = parcelRequire("lKG8Q");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $1f1664298fc82bb5$var$contextManager;
function $1f1664298fc82bb5$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $1f1664298fc82bb5$var$contextManager = ctxMgr;
}
function $1f1664298fc82bb5$export$831109c9f7727010() {
    return $1f1664298fc82bb5$var$contextManager;
}
class $1f1664298fc82bb5$export$dd301b96c16f583d {
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $lKG8Q.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $lKG8Q.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $lKG8Q.ROOT_CONTEXT);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $lKG8Q.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
   * whether the context manager is enabled or not
   */ this._enabled = false;
        /**
   * Keeps the reference to current context
   */ this._currentContext = (0, $lKG8Q.ROOT_CONTEXT);
    }
}

});

parcelRegister("5ByXd", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $d935c7341c22dd45$export$1115c5277eb10d5e);
function $d935c7341c22dd45$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("1M3oH", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $70dc6d1501ab3839$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $70dc6d1501ab3839$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $70dc6d1501ab3839$export$47fade9662f71000);

var $4Ptaw = parcelRequire("4Ptaw");
const $70dc6d1501ab3839$export$5b78c989c8db2561 = new Map();
const $70dc6d1501ab3839$export$2a5c8df26bb89760 = new Map();
function $70dc6d1501ab3839$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $4Ptaw.redactValue)(featureFlagValue);
    $70dc6d1501ab3839$export$5b78c989c8db2561.set(featureFlagName, value);
    $70dc6d1501ab3839$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("4Ptaw", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $add2e8cb2ca117e3$export$fcc03ee4c944962f);

var $evBGN = parcelRequire("evBGN");
function $add2e8cb2ca117e3$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $add2e8cb2ca117e3$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $add2e8cb2ca117e3$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $add2e8cb2ca117e3$export$7b4abba432e57989(value) {
    return $add2e8cb2ca117e3$var$isString(value) && $add2e8cb2ca117e3$var$startsAsObject(value) || $add2e8cb2ca117e3$var$isObject(value);
}
function $add2e8cb2ca117e3$export$fcc03ee4c944962f(featureFlagValue) {
    return $add2e8cb2ca117e3$export$7b4abba432e57989(featureFlagValue) ? (0, $evBGN.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("evBGN", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $e5826bd297e65fd2$export$42f4885608027d0c);
const $e5826bd297e65fd2$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("8uTBY", function(module, exports) {
$parcel$export(module.exports, "DefaultInteractionID", () => $41022001dea3909c$export$3109542b68df9ba1);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $41022001dea3909c$export$3e0c3023952f6774);
$parcel$export(module.exports, "default", () => $41022001dea3909c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $41022001dea3909c$export$37bca3107733ac1e);

var $8P7DW = parcelRequire("8P7DW");
const $41022001dea3909c$var$listeners = new Set();
// Observable interaction ID implementation
class $41022001dea3909c$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) $41022001dea3909c$var$listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const $41022001dea3909c$var$initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new $41022001dea3909c$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $41022001dea3909c$export$3109542b68df9ba1 = $41022001dea3909c$var$initializeGlobalDefaultInteractionID();
const $41022001dea3909c$export$3e0c3023952f6774 = (listener)=>{
    $41022001dea3909c$var$listeners.add(listener);
    return ()=>{
        $41022001dea3909c$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
const $41022001dea3909c$var$interactionContext = (0, $8P7DW.createContext)($41022001dea3909c$export$3109542b68df9ba1);
var $41022001dea3909c$export$2e2bcd8739ae039 = $41022001dea3909c$var$interactionContext;
const $41022001dea3909c$export$37bca3107733ac1e = ()=>$41022001dea3909c$export$3109542b68df9ba1;
const $41022001dea3909c$export$9f6000531b78127e = ()=>$41022001dea3909c$export$3109542b68df9ba1;

});

parcelRegister("8UvJf", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $b95bb544aa1673d2$export$c8760e11c713fafc);
$parcel$export(module.exports, "default", () => $b95bb544aa1673d2$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $cAaWV = parcelRequire("cAaWV");

var $9TwI7 = parcelRequire("9TwI7");

var $6nQJh = parcelRequire("6nQJh");
var $b95bb544aa1673d2$var$_process;
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $b95bb544aa1673d2$var$startTimes = new Map();
const $b95bb544aa1673d2$var$spanStates = new Map();
const $b95bb544aa1673d2$export$cf4e4023c0a34c8d = ()=>{
    $b95bb544aa1673d2$var$startTimes.clear();
    $b95bb544aa1673d2$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $b95bb544aa1673d2$var$lastActiveInteraction;
function $b95bb544aa1673d2$var$checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    const activeInteractionId = (_getActiveInteraction = (0, $9TwI7.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!$b95bb544aa1673d2$var$lastActiveInteraction && $b95bb544aa1673d2$var$lastActiveInteraction !== activeInteractionId) $b95bb544aa1673d2$export$cf4e4023c0a34c8d();
    $b95bb544aa1673d2$var$lastActiveInteraction = activeInteractionId;
}
const $b95bb544aa1673d2$var$getIsNativeTracingEnabled = ()=>{
    var _getConfig;
    return ((_getConfig = (0, $cAaWV.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.ssr) === null || _getConfig === void 0 ? void 0 : _getConfig.enableNativeTracing) ?? false;
};
const $b95bb544aa1673d2$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    var _startTimes$get, _vm_internals__;
    if (!$b95bb544aa1673d2$var$startTimes.has(id)) $b95bb544aa1673d2$var$startTimes.set(id, []);
    (_startTimes$get = $b95bb544aa1673d2$var$startTimes.get(id)) === null || _startTimes$get === void 0 || _startTimes$get.push(performance.now());
    if (!$b95bb544aa1673d2$var$getIsNativeTracingEnabled()) return null;
    const startSpan = (_vm_internals__ = globalThis.__vm_internals__) === null || _vm_internals__ === void 0 || (_vm_internals__ = _vm_internals__.telemetry) === null || _vm_internals__ === void 0 ? void 0 : _vm_internals__.startSpan;
    let spanState = $b95bb544aa1673d2$var$spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext === null || parentContext === void 0 ? void 0 : parentContext.spanId
        });
        spanState = {
            span: span
        };
        $b95bb544aa1673d2$var$spanStates.set(id, spanState);
    }
    return spanState;
};
const $b95bb544aa1673d2$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $6nQJh !== 'undefined' && Boolean((($b95bb544aa1673d2$var$_process = $6nQJh) === null || $b95bb544aa1673d2$var$_process === void 0 || ($b95bb544aa1673d2$var$_process = $b95bb544aa1673d2$var$_process.env) === null || $b95bb544aa1673d2$var$_process === void 0 ? void 0 : $b95bb544aa1673d2$var$_process.REACT_SSR) || false);
const $b95bb544aa1673d2$var$ProfilerMarker = ({ onRender: onRender })=>{
    onRender === null || onRender === void 0 || onRender();
    return null;
};
const $b95bb544aa1673d2$var$ParentSpanContext = /*#__PURE__*/ (0, $8P7DW.createContext)(null);
const $b95bb544aa1673d2$export$c8760e11c713fafc = ()=>{
    $b95bb544aa1673d2$var$spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $b95bb544aa1673d2$var$spanStates.clear();
};
const $b95bb544aa1673d2$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $8P7DW.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    $b95bb544aa1673d2$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $8P7DW.useContext)($b95bb544aa1673d2$var$ParentSpanContext);
    const currentSpanState = $b95bb544aa1673d2$var$onStartRender(reactProfilerId, labelStack[labelStack.length - 1].name, parentSpan);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)($b95bb544aa1673d2$var$ParentSpanContext.Provider, {
            value: (currentSpanState === null || currentSpanState === void 0 ? void 0 : currentSpanState.span.getSpanContext()) ?? null,
            children: [
                children,
                /*#__PURE__*/ (0, $gWgPx.jsx)($b95bb544aa1673d2$var$ProfilerMarker, {
                    onRender: ()=>{
                        const startTimesForId = $b95bb544aa1673d2$var$startTimes.get(reactProfilerId);
                        if (startTimesForId !== null && startTimesForId !== void 0 && startTimesForId.length) {
                            const endTime = performance.now();
                            const firstStartTime = startTimesForId[0];
                            const lastStartTime = startTimesForId[startTimesForId.length - 1];
                            const baseDuration = endTime - lastStartTime;
                            const actualDuration = endTime - firstStartTime;
                            onRender('mount', // this is incorrect, but on the server there is no mount phase
                            actualDuration, baseDuration, firstStartTime, endTime);
                        }
                        const spanState = $b95bb544aa1673d2$var$spanStates.get(reactProfilerId);
                        if (spanState) spanState.latestEndTime = performance.now();
                    }
                })
            ]
        })
    });
};
const $b95bb544aa1673d2$var$SsrRenderProfiler = (props)=>{
    if ($b95bb544aa1673d2$var$isInSSR) return /*#__PURE__*/ (0, $gWgPx.jsx)($b95bb544aa1673d2$export$b8bd105b650b1c1e, {
        ...props
    });
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)($b95bb544aa1673d2$var$ProfilerMarker, {}),
            props.children
        ]
    });
};
var $b95bb544aa1673d2$export$2e2bcd8739ae039 = $b95bb544aa1673d2$var$SsrRenderProfiler;

});

parcelRegister("3F1qw", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $3b6f0d4201a50913$export$4a1fe1ab3c13bbf5);
$parcel$export(module.exports, "newVCObserver", () => $3b6f0d4201a50913$export$c69731bddfc24d85);

var $e6Qdr = parcelRequire("e6Qdr");

var $cAaWV = parcelRequire("cAaWV");

var $kkHRc = parcelRequire("kkHRc");

var $43OaL = parcelRequire("43OaL");

var $dLX1M = parcelRequire("dLX1M");

var $aCcrY = parcelRequire("aCcrY");

var $T2wiA = parcelRequire("T2wiA");

var $6nQJh = parcelRequire("6nQJh");
var $3b6f0d4201a50913$var$_process;
class $3b6f0d4201a50913$export$4a1fe1ab3c13bbf5 {
    /**
   * Returns true if the new VC observer pipeline should be active.
   * This is needed even when no client-side revisions are enabled, because
   * the raw-handler must still collect observations for server-side TTVC
   * recalculation when the server-side sync gate is on.
   */ static shouldUseNewVCObserver(experienceKey) {
        return (0, $cAaWV.isVCRevisionEnabled)('fy25.03', experienceKey) || (0, $cAaWV.isVCRevisionEnabled)('fy26.04', experienceKey) || (0, $e6Qdr.fg)('ufo_disable_ttvc_v4');
    }
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $T2wiA.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        if ($3b6f0d4201a50913$export$4a1fe1ab3c13bbf5.shouldUseNewVCObserver()) this.newVCObserver = new (0, $dLX1M.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $cAaWV.isVCRevisionEnabled)('fy25.01') || (0, $cAaWV.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $43OaL.VCObserver)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        var _window;
        // Process any SSR abort listeners that remain
        if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $cAaWV.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $cAaWV.isVCRevisionEnabled)('fy25.02', experienceKey)) {
            var _this$oldVCObserver;
            (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                startTime: startTime
            });
        }
        if ($3b6f0d4201a50913$export$4a1fe1ab3c13bbf5.shouldUseNewVCObserver(experienceKey)) {
            var _this$newVCObserver;
            (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                startTime: startTime
            });
        }
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $cAaWV.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $cAaWV.isVCRevisionEnabled)('fy25.02', experienceKey)) {
            var _this$oldVCObserver2;
            (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
        }
        if ($3b6f0d4201a50913$export$4a1fe1ab3c13bbf5.shouldUseNewVCObserver(experienceKey)) {
            var _this$newVCObserver2;
            (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
        }
        (0, $aCcrY.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        var _this$oldVCObserver3;
        return ((_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) ?? null;
    }
    async getVCResult(param) {
        var _this$oldVCObserver4, _this$newVCObserver3, _v3v4Result$;
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $cAaWV.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $cAaWV.isVCRevisionEnabled)('fy25.02', experienceKey) ? await ((_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param)) : {};
        const v3v4Result = $3b6f0d4201a50913$export$4a1fe1ab3c13bbf5.shouldUseNewVCObserver(experienceKey) ? await ((_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        })) : [];
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result === null || v3v4Result === void 0 || (_v3v4Result$ = v3v4Result[0]) === null || _v3v4Result$ === void 0 ? void 0 : _v3v4Result$.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...(v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        var _this$oldVCObserver5, _this$newVCObserver4;
        (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
        (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        var _this$oldVCObserver6, _this$newVCObserver5;
        (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
        (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        var _this$oldVCObserver7, _this$newVCObserver6;
        (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
        (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
}
// Some products set this variable to indicate it is running in SSR
let $3b6f0d4201a50913$var$isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $3b6f0d4201a50913$var$isReactSSR = typeof $6nQJh !== 'undefined' && Boolean((($3b6f0d4201a50913$var$_process = $6nQJh) === null || $3b6f0d4201a50913$var$_process === void 0 || ($3b6f0d4201a50913$var$_process = $3b6f0d4201a50913$var$_process.env) === null || $3b6f0d4201a50913$var$_process === void 0 ? void 0 : $3b6f0d4201a50913$var$_process.REACT_SSR) || false);
function $3b6f0d4201a50913$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($3b6f0d4201a50913$var$isReactSSR || $3b6f0d4201a50913$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}
function $3b6f0d4201a50913$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$3b6f0d4201a50913$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $kkHRc.VCObserverNOOP)() : new $3b6f0d4201a50913$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}
function $3b6f0d4201a50913$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !$3b6f0d4201a50913$export$68d57b133e88584d();
    const observer = shouldMockVCObserver ? new (0, $kkHRc.VCObserverNOOP)() : new $3b6f0d4201a50913$export$4a1fe1ab3c13bbf5(opts);
    return observer;
}

});
parcelRegister("kkHRc", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $8493b475234076e8$export$24d07287b49da906);
class $8493b475234076e8$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

});

parcelRegister("dLX1M", function(module, exports) {
$parcel$export(module.exports, "getHasAbortingEventDuringSSR", () => $2e93b1dfe921f738$export$88af4849fcc5bbc9);
$parcel$export(module.exports, "default", () => $2e93b1dfe921f738$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $cAaWV = parcelRequire("cAaWV");

var $9TwI7 = parcelRequire("9TwI7");

var $T2wiA = parcelRequire("T2wiA");

var $fIW09 = parcelRequire("fIW09");

var $6v7Dz = parcelRequire("6v7Dz");

var $5HtP4 = parcelRequire("5HtP4");

var $6RF0V = parcelRequire("6RF0V");

var $64aDB = parcelRequire("64aDB");

var $fmjaC = parcelRequire("fmjaC");

var $4b95D = parcelRequire("4b95D");

var $6IAFj = parcelRequire("6IAFj");

var $hKkIH = parcelRequire("hKkIH");

var $kKed5 = parcelRequire("kKed5");
const $2e93b1dfe921f738$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $2e93b1dfe921f738$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
let $2e93b1dfe921f738$var$hasAbortingEventDuringSSR = false;
function $2e93b1dfe921f738$export$88af4849fcc5bbc9() {
    return $2e93b1dfe921f738$var$hasAbortingEventDuringSSR;
}
class $2e93b1dfe921f738$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $2e93b1dfe921f738$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $fIW09.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        this.selectorConfig = config.selectorConfig ?? $2e93b1dfe921f738$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $T2wiA.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: ((_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) ?? false
            });
        }
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $hKkIH.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    const labelStacks = $2e93b1dfe921f738$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $kKed5.default)({
            onEvent: ({ time: time, type: type })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $e6Qdr.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $9TwI7.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') return;
                }
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
    start(_) {
        var _this$viewportObserve;
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $2e93b1dfe921f738$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
        if ((0, $e6Qdr.fg)('ufo_fix_aborting_interaction_detection_during_ssr')) {
            var _window, _this$windowEventObse;
            this.entriesTimeline.clear();
            if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                const abortListeners = window.__SSR_ABORT_LISTENERS__;
                const aborts = abortListeners.aborts;
                if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                    if (typeof time === 'number') this.entriesTimeline.push({
                        time: time,
                        data: {
                            type: 'window:event',
                            eventType: key
                        }
                    });
                });
            }
            (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
        } else {
            var _window2, _this$windowEventObse2;
            if ((_window2 = window) !== null && _window2 !== void 0 && _window2.__SSR_ABORT_LISTENERS__) {
                const abortListeners = window.__SSR_ABORT_LISTENERS__;
                const aborts = abortListeners.aborts;
                if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                    if (typeof time === 'number') {
                        this.entriesTimeline.push({
                            time: time,
                            data: {
                                type: 'window:event',
                                eventType: key
                            }
                        });
                        if ((0, $e6Qdr.fg)('ufo_detect_aborting_interaction_during_ssr')) $2e93b1dfe921f738$var$hasAbortingEventDuringSSR = true;
                    }
                });
            }
            (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.start();
            this.entriesTimeline.clear();
        }
    }
    stop() {
        var _this$viewportObserve2, _this$windowEventObse3;
        (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
        (_this$windowEventObse3 = this.windowEventObserver) === null || _this$windowEventObse3 === void 0 || _this$windowEventObse3.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $2e93b1dfe921f738$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $64aDB.default)(),
                    width: (0, $fmjaC.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $64aDB.default)(),
                    right: (0, $fmjaC.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeRawData: includeRawData, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $5HtP4.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $cAaWV.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $6RF0V.default)();
        const calculator_next = new (0, $4b95D.default)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $cAaWV.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $cAaWV.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data when fy26.04 is not in the client config so the server
        // can recalculate fy26.04 metrics (ssrRatio, labelStacks, speedIndex) from raw observations.
        const shouldIncludeRawData = includeRawData || !isFy2604Enabled;
        if (shouldIncludeRawData) {
            const rawVCCalculationStartTime = performance.now();
            const rawHandler = new (0, $6IAFj.default)();
            // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
            const rawStopTime = rawDataStopTime ?? stop;
            const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                start: start,
                stop: rawStopTime
            }) : orderedEntries;
            const raw = await rawHandler.getRawData({
                entries: rawOrderedEntries,
                startTime: start,
                stopTime: rawStopTime,
                isPageVisible: isPageVisible
            });
            results.forEach((result)=>{
                delete result.vcDetails;
                delete result.ratios;
            });
            if (raw) {
                raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                results.push(raw);
            }
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $6v7Dz.default)(this.selectorConfig, element);
    }
}
function $2e93b1dfe921f738$var$labelStackFromFiber(fiber) {
    var _fiber$child;
    const value = fiber === null || fiber === void 0 || (_fiber$child = fiber.child) === null || _fiber$child === void 0 || (_fiber$child = _fiber$child.memoizedProps) === null || _fiber$child === void 0 ? void 0 : _fiber$child.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function $2e93b1dfe921f738$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>label.name).join('/');
}
function $2e93b1dfe921f738$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>label.name).join('/');
}
function $2e93b1dfe921f738$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $2e93b1dfe921f738$var$labelStackFromFiber(currentFiber);
                labelStackString = $2e93b1dfe921f738$var$labelStackToString(labelStack) || 'unknown';
                segment = $2e93b1dfe921f738$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $2e93b1dfe921f738$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $2e93b1dfe921f738$var$traverseFiber(fiber) : null;
}

});
parcelRegister("fIW09", function(module, exports) {
$parcel$export(module.exports, "default", () => $060513d4b29c0be1$export$2e2bcd8739ae039);
class $060513d4b29c0be1$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        var _this$sortedEntriesCa;
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("6v7Dz", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c33147c654cc1a7$export$2e2bcd8739ae039);
const $4c33147c654cc1a7$var$nameCache = new WeakMap();
function $4c33147c654cc1a7$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $4c33147c654cc1a7$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $4c33147c654cc1a7$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $4c33147c654cc1a7$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $4c33147c654cc1a7$var$nameCache.set(element, name);
    return name;
}
var $4c33147c654cc1a7$export$2e2bcd8739ae039 = $4c33147c654cc1a7$var$getElementName;

});

parcelRegister("5HtP4", function(module, exports) {
$parcel$export(module.exports, "default", () => $442eeba91b4fff70$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $ljBCP = parcelRequire("ljBCP");

var $7OKnP = parcelRequire("7OKnP");

var $RRlBi = parcelRequire("RRlBi");

var $g27Nv = parcelRequire("g27Nv");

var $kwQc9 = parcelRequire("kwQc9");
const $442eeba91b4fff70$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $442eeba91b4fff70$var$REVISION_NO = 'fy25.03';
const $442eeba91b4fff70$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $442eeba91b4fff70$export$2e2bcd8739ae039 extends (0, $RRlBi.default) {
    constructor(revisionNo){
        super(revisionNo ?? $442eeba91b4fff70$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$442eeba91b4fff70$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $e6Qdr.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $ljBCP.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $ljBCP.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $7OKnP.containsDnDMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $g27Nv.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $g27Nv.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || (0, $g27Nv.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $e6Qdr.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, $g27Nv.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $e6Qdr.fg)('platform_ufo_exclude_dark_reader_extension') || (0, $g27Nv.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $e6Qdr.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
            return true;
        }
        if ((0, $kwQc9.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($442eeba91b4fff70$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("ljBCP", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $7123c3ccb91b3941$export$9db1624a8af791a4);

var $1EFS8 = parcelRequire("1EFS8");

var $1M3oH = parcelRequire("1M3oH");
const $7123c3ccb91b3941$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $1EFS8.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $1EFS8.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $1M3oH.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

});

parcelRegister("7OKnP", function(module, exports) {
$parcel$export(module.exports, "containsDnDMutationInStyle", () => $31685e7d09b4c696$export$7867ddcf372cd2bf);
$parcel$export(module.exports, "default", () => $31685e7d09b4c696$export$2e2bcd8739ae039);
const $31685e7d09b4c696$var$isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const $31685e7d09b4c696$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $31685e7d09b4c696$export$e20e7bf2c822f3df({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $31685e7d09b4c696$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $31685e7d09b4c696$export$7867ddcf372cd2bf({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = $31685e7d09b4c696$var$parseStyleSet(oldValue);
    const newStyles = $31685e7d09b4c696$var$parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles ?? [])if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
        if (!$31685e7d09b4c696$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles ?? [])if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(s))) {
        if (!$31685e7d09b4c696$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
var $31685e7d09b4c696$export$2e2bcd8739ae039 = $31685e7d09b4c696$export$e20e7bf2c822f3df;

});

parcelRegister("RRlBi", function(module, exports) {
$parcel$export(module.exports, "default", () => $867a18b81cfda3f9$export$2e2bcd8739ae039);

var $edG0y = parcelRequire("edG0y");

var $f1LEa = parcelRequire("f1LEa");

var $64aDB = parcelRequire("64aDB");

var $fmjaC = parcelRequire("fmjaC");
// Helper function for reporting ratios
function $867a18b81cfda3f9$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $867a18b81cfda3f9$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $fmjaC.default)();
        const viewportHeight = (0, $64aDB.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $867a18b81cfda3f9$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ('elementName' in entry.data && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        var _window, _window2, _window3, _window4, _window6;
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $edG0y.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $fmjaC.default)(),
                height: (0, $64aDB.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $f1LEa.detectLayoutShiftCause)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>{
                    var _entry$rect, _entry$previousRect;
                    return {
                        ...entry,
                        rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                        previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                    };
                }),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_vc_3p_debug_data) === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                var _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou;
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push({
                    ...viewportData,
                    rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                    previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
            var _window5, _window5$__ufo_devtoo;
            (_window5 = window) === null || _window5 === void 0 || (_window5$__ufo_devtoo = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window5$__ufo_devtoo === void 0 || _window5$__ufo_devtoo.call(_window5, v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof ((_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
            var _window7, _window7$__on_ufo_vc_;
            (_window7 = window) === null || _window7 === void 0 || (_window7$__on_ufo_vc_ = _window7.__on_ufo_vc_debug_data_ready) === null || _window7$__on_ufo_vc_ === void 0 || _window7$__on_ufo_vc_.call(_window7, v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        var _vcDetails$;
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) ?? false,
                    dist: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) ?? false
                },
                total_mut: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) ?? 0,
                mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': (vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
}

});
parcelRegister("edG0y", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $77659fff41889cd1$export$96ea73435089b05a);

var $e6Qdr = parcelRequire("e6Qdr");

var $cde8z = parcelRequire("cde8z");
async function $77659fff41889cd1$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $cde8z.ViewportCanvas)(viewport, (0, $e6Qdr.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $77659fff41889cd1$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $77659fff41889cd1$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $cde8z.ViewportCanvas)(viewport, (0, $e6Qdr.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $77659fff41889cd1$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $77659fff41889cd1$export$2e2bcd8739ae039 = $77659fff41889cd1$var$calculateTTVCPercentiles;
function $77659fff41889cd1$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $77659fff41889cd1$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});
parcelRegister("cde8z", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $fed74b3599917c39$export$3e59ac9de7402fb1);

var $gYqAk = parcelRequire("gYqAk");
class $fed74b3599917c39$export$3e59ac9de7402fb1 {
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $fed74b3599917c39$export$54591583ed0b20ce(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $fed74b3599917c39$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $fed74b3599917c39$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}
function $fed74b3599917c39$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $fed74b3599917c39$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $gYqAk.default)();
    }
    return arr;
}

});
parcelRegister("gYqAk", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6b6bf496b7f3fc2$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $f6b6bf496b7f3fc2$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $f6b6bf496b7f3fc2$export$2e2bcd8739ae039 = $f6b6bf496b7f3fc2$var$taskYield;

});



parcelRegister("f1LEa", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $62a0d5cd9af94168$export$93ce39b765ea2cd3);
const $62a0d5cd9af94168$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $62a0d5cd9af94168$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $62a0d5cd9af94168$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $62a0d5cd9af94168$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $62a0d5cd9af94168$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $62a0d5cd9af94168$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $62a0d5cd9af94168$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $62a0d5cd9af94168$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $62a0d5cd9af94168$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("64aDB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba879c7bf07ba881$export$2e2bcd8739ae039);
function $ba879c7bf07ba881$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $ba879c7bf07ba881$export$2e2bcd8739ae039 = $ba879c7bf07ba881$var$getViewportHeight;

});

parcelRegister("fmjaC", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ac6318fa99b48a2$export$2e2bcd8739ae039);
function $1ac6318fa99b48a2$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $1ac6318fa99b48a2$export$2e2bcd8739ae039 = $1ac6318fa99b48a2$var$getViewportWidth;

});


parcelRegister("g27Nv", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $5c218555072bae67$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $5c218555072bae67$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $5c218555072bae67$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $5c218555072bae67$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $5c218555072bae67$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $5c218555072bae67$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id'
];
const $5c218555072bae67$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $5c218555072bae67$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $5c218555072bae67$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $5c218555072bae67$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});

parcelRegister("kwQc9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c09edbc20aa0cd2$export$2e2bcd8739ae039);
function $7c09edbc20aa0cd2$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $7c09edbc20aa0cd2$export$2e2bcd8739ae039 = $7c09edbc20aa0cd2$var$isViewportEntryData;

});


parcelRegister("6RF0V", function(module, exports) {
$parcel$export(module.exports, "default", () => $57cf1e5275927305$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $5HtP4 = parcelRequire("5HtP4");

var $g27Nv = parcelRequire("g27Nv");
const $57cf1e5275927305$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $57cf1e5275927305$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $57cf1e5275927305$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $57cf1e5275927305$export$2e2bcd8739ae039 extends (0, $5HtP4.default) {
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = (0, $e6Qdr.fg)('platform_ufo_ignore_data_fabric_mode') ? [
            'data-fabric-mode'
        ] : [];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$57cf1e5275927305$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $57cf1e5275927305$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $e6Qdr.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $g27Nv.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $e6Qdr.fg)('platform_ufo_exclude_dark_reader_extension') ? (0, $g27Nv.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES) : [],
            ...(0, $e6Qdr.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $g27Nv.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $g27Nv.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $g27Nv.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $57cf1e5275927305$var$getConsideredEntryTypes().includes(entry.data.type);
    }
}

});

parcelRegister("4b95D", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f7c3f5ce239f2c5$export$2e2bcd8739ae039);

var $6RF0V = parcelRequire("6RF0V");
const $6f7c3f5ce239f2c5$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $6f7c3f5ce239f2c5$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $6f7c3f5ce239f2c5$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $6f7c3f5ce239f2c5$export$2e2bcd8739ae039 extends (0, $6RF0V.default) {
    constructor(){
        super('next');
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$6f7c3f5ce239f2c5$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $6f7c3f5ce239f2c5$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($6f7c3f5ce239f2c5$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});

parcelRegister("6IAFj", function(module, exports) {
$parcel$export(module.exports, "default", () => $12dedd5dea7850e1$export$2e2bcd8739ae039);

var $cHs48 = parcelRequire("cHs48");

var $64aDB = parcelRequire("64aDB");

var $fmjaC = parcelRequire("fmjaC");
const $12dedd5dea7850e1$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $12dedd5dea7850e1$var$MAX_OBSERVATIONS = 200;
const $12dedd5dea7850e1$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $12dedd5dea7850e1$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $12dedd5dea7850e1$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $12dedd5dea7850e1$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($12dedd5dea7850e1$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $cHs48.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $fmjaC.default)(),
                h: (0, $64aDB.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $12dedd5dea7850e1$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $12dedd5dea7850e1$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $12dedd5dea7850e1$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$12dedd5dea7850e1$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId
            };
            return eventObservation;
        });
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
        if (rawObservations.length > $12dedd5dea7850e1$var$MAX_OBSERVATIONS) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$12dedd5dea7850e1$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
            // Collect referenced IDs from remaining observations
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            // Remove unreferenced entries from maps
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
            for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
        }
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
        if (rawEventObservations.length > $12dedd5dea7850e1$var$MAX_OBSERVATIONS) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$12dedd5dea7850e1$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
            // Collect referenced IDs from remaining observations
            const referencedEvts = new Set();
            for (const observation of rawEventObservations)if (observation.evt > 0) referencedEvts.add(observation.evt);
            // Remove unreferenced entries from maps
            for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
        }
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: rawObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $fmjaC.default)(),
                h: (0, $64aDB.default)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}

});

parcelRegister("hKkIH", function(module, exports) {
$parcel$export(module.exports, "default", () => $338b7fbe18b1bd8f$export$2e2bcd8739ae039);

var $9aqGr = parcelRequire("9aqGr");

var $7OKnP = parcelRequire("7OKnP");

var $3RyBe = parcelRequire("3RyBe");

var $aCcrY = parcelRequire("aCcrY");

var $jRgTc = parcelRequire("jRgTc");

var $9OWuD = parcelRequire("9OWuD");

var $44kpv = parcelRequire("44kpv");

var $dEGBQ = parcelRequire("dEGBQ");

var $9QJ1f = parcelRequire("9QJ1f");

var $5M6cz = parcelRequire("5M6cz");

var $9vwJ7 = parcelRequire("9vwJ7");

var $04WQx = parcelRequire("04WQx");

var $bvGbi = parcelRequire("bvGbi");

var $7d6LR = parcelRequire("7d6LR");
const $338b7fbe18b1bd8f$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $9vwJ7.default)(target)) return 'mutation:remount';
        if ((0, $9aqGr.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $9vwJ7.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $aCcrY.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $bvGbi.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $338b7fbe18b1bd8f$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $9vwJ7.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $9aqGr.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $9vwJ7.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $aCcrY.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $bvGbi.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $338b7fbe18b1bd8f$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $5M6cz.isElementVisible)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                var _this$getSSRState, _this$intersectionObs;
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $dEGBQ.default)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $9QJ1f.isContainedWithinSmartAnswers)(addedNode));
                const isTargetReactRoot = targetNode === ((_this$getSSRState = this.getSSRState) === null || _this$getSSRState === void 0 || (_this$getSSRState = _this$getSSRState.call(this)) === null || _this$getSSRState === void 0 ? void 0 : _this$getSSRState.reactRootElement);
                (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $338b7fbe18b1bd8f$var$createElementMutationsWatcherNew : $338b7fbe18b1bd8f$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            var _this$intersectionObs2;
            (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $9aqGr.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $dEGBQ.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $9QJ1f.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $7OKnP.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $3RyBe.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $04WQx.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $aCcrY.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $7d6LR.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $bvGbi.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            var _this$searchPageConfi, _this$searchPageConfi2, _window;
            return ((_this$searchPageConfi = this.searchPageConfig) === null || _this$searchPageConfi === void 0 ? void 0 : _this$searchPageConfi.enableSmartAnswersMutations) && ((_this$searchPageConfi2 = this.searchPageConfig) === null || _this$searchPageConfi2 === void 0 ? void 0 : _this$searchPageConfi2.searchPageRoute) && ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname) && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $jRgTc.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $9OWuD.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $44kpv.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        var _this$mutationObserve, _this$performanceObse;
        if (this.isStarted) return;
        this.initializeObservers();
        (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        var _this$mutationObserve2, _this$intersectionObs3, _this$performanceObse2;
        if (!this.isStarted) return;
        (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
        (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.disconnect();
        (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $dEGBQ.cleanupCaches)(this.mapIs3pResult);
    }
}

});
parcelRegister("jRgTc", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $f5a68bc76d580439$export$c3799d33e0ae80a5);

var $3EjSa = parcelRequire("3EjSa");
function $f5a68bc76d580439$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $f5a68bc76d580439$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $3EjSa.isZeroDimensionRectangle)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$f5a68bc76d580439$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("3EjSa", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $50772f6f6d033106$export$80d6b07c2266a1c6);
function $50772f6f6d033106$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("9OWuD", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2685b38f1cb9ff8$export$2e2bcd8739ae039);

var $ljBCP = parcelRequire("ljBCP");
function $a2685b38f1cb9ff8$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $ljBCP.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
        	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
        	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
        	Conceptually there is after all a mutation: there is an old value replaced with a new one,
        	and whether or not they are the same doesn't really matter.
        	And Custom elements should work the same way as MutationObserver."
        	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
        */ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $a2685b38f1cb9ff8$export$2e2bcd8739ae039 = $a2685b38f1cb9ff8$var$createMutationObserver;

});

parcelRegister("44kpv", function(module, exports) {
$parcel$export(module.exports, "default", () => $142ab319a666f613$export$2e2bcd8739ae039);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $142ab319a666f613$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $142ab319a666f613$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $142ab319a666f613$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $142ab319a666f613$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $142ab319a666f613$export$2e2bcd8739ae039 = $142ab319a666f613$var$createPerformanceObserver;

});

parcelRegister("dEGBQ", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $931cada98fc277cd$export$6a35c3789c327630);
$parcel$export(module.exports, "default", () => $931cada98fc277cd$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $2x96i = parcelRequire("2x96i");

var $iBdpP = parcelRequire("iBdpP");

var $fZc1M = parcelRequire("fZc1M");
const $931cada98fc277cd$var$DEFAULT_MAX_LEVEL = 20;
const $931cada98fc277cd$var$INCREASED_DOM_WALK_MAX_LEVEL = 40;
const $931cada98fc277cd$var$INCREASED_FIBER_WALK_MAX_LEVEL = 40;
function $931cada98fc277cd$var$getDomWalkMaxLevel() {
    return (0, $e6Qdr.fg)('platform_ufo_3p_forge_detection_fix') ? $931cada98fc277cd$var$INCREASED_DOM_WALK_MAX_LEVEL : $931cada98fc277cd$var$DEFAULT_MAX_LEVEL;
}
function $931cada98fc277cd$var$getFiberWalkMaxLevel() {
    return (0, $e6Qdr.fg)('platform_ufo_3p_forge_detection_fix') ? $931cada98fc277cd$var$INCREASED_FIBER_WALK_MAX_LEVEL : $931cada98fc277cd$var$DEFAULT_MAX_LEVEL;
}
// Cache cleanup
let $931cada98fc277cd$var$callCount = 0;
const $931cada98fc277cd$var$CLEANUP_THRESHOLD = 50;
function $931cada98fc277cd$var$maybeCleanup(resultCache) {
    $931cada98fc277cd$var$callCount++;
    if ($931cada98fc277cd$var$callCount >= $931cada98fc277cd$var$CLEANUP_THRESHOLD && (0, $2x96i.default)(0.3)) $931cada98fc277cd$export$6a35c3789c327630(resultCache);
}
function $931cada98fc277cd$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $931cada98fc277cd$var$callCount = 0;
    return resultCache;
}
function $931cada98fc277cd$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $931cada98fc277cd$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    let fiber = null;
    let checkedNodes = [];
    const domWalkMaxLevel = $931cada98fc277cd$var$getDomWalkMaxLevel();
    // Always use cached fiber strategy to handle non-React elements reliably
    fiber = (0, $fZc1M.default)(node, domWalkMaxLevel, checkedNodes);
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $iBdpP.default)(fiber, targetComponentName, $931cada98fc277cd$var$getFiberWalkMaxLevel());
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("iBdpP", function(module, exports) {
$parcel$export(module.exports, "default", () => $4439c93c883e1c2b$export$2e2bcd8739ae039);

var $eZTB9 = parcelRequire("eZTB9");
function $4439c93c883e1c2b$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $eZTB9.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $4439c93c883e1c2b$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("eZTB9", function(module, exports) {
$parcel$export(module.exports, "default", () => $779dcf1d84717e9c$export$2e2bcd8739ae039);
// Helper function to extract component name from fiber
function $779dcf1d84717e9c$export$2e2bcd8739ae039(fiber) {
    const type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("fZc1M", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0d1611aef38e945$export$2e2bcd8739ae039);

var $6ZKR9 = parcelRequire("6ZKR9");
function $a0d1611aef38e945$export$2e2bcd8739ae039(element, maxLevel, checkedNodes) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return null;
    checkedNodes.push(element);
    const fiber = (0, $6ZKR9.default)(element);
    if (fiber) return fiber;
    // Walk up the DOM tree to find the fiber
    const parent = element.parentElement;
    if (!parent) return null;
    // Recursively check parent
    return $a0d1611aef38e945$export$2e2bcd8739ae039(parent, maxLevel - 1, checkedNodes);
}

});
parcelRegister("6ZKR9", function(module, exports) {
$parcel$export(module.exports, "default", () => $79ed1219191280d7$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $79ed1219191280d7$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("9QJ1f", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $76f3e0ac3f737665$export$16c2770458939f21);

var $lCTyY = parcelRequire("lCTyY");
function $76f3e0ac3f737665$export$16c2770458939f21(node) {
    const doc = (0, $lCTyY.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});
parcelRegister("lCTyY", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $b114055a57668b0e$export$f65ca476c09acec0);
const $b114055a57668b0e$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("5M6cz", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $b9f782f84c521ed8$export$e989c0fffaa6b27a);
function $b9f782f84c521ed8$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("9vwJ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b1858f3e1733c97$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $1b1858f3e1733c97$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $1b1858f3e1733c97$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("04WQx", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $447236591c661a29$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $447236591c661a29$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("bvGbi", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $afef898e4585081b$export$fde63bc968551821);
const $afef898e4585081b$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $afef898e4585081b$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $afef898e4585081b$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $afef898e4585081b$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $afef898e4585081b$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $afef898e4585081b$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("7d6LR", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $70a6b8a29cb4df3d$export$597b41700f7dcd36);
const $70a6b8a29cb4df3d$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $70a6b8a29cb4df3d$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $70a6b8a29cb4df3d$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $70a6b8a29cb4df3d$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("kKed5", function(module, exports) {
$parcel$export(module.exports, "default", () => $197d6b3eb3b704a9$export$2e2bcd8739ae039);

var $36kyW = parcelRequire("36kyW");
class $197d6b3eb3b704a9$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $36kyW.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $36kyW.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});



parcelRegister("cQx5E", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $a7fdad5a50f71055$export$cc97b17ef9aeb088);
const $a7fdad5a50f71055$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("7Om7a", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a0ed2b5f983aa2c$export$2e2bcd8739ae039);

var $3F1qw = parcelRequire("3F1qw");

var $cQx5E = parcelRequire("cQx5E");

var $9TwI7 = parcelRequire("9TwI7");
class $4a0ed2b5f983aa2c$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $3F1qw.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }, interactionId) {
        if (this.eligibleToMeasure(interactionId)) {
            var _this$vcObserver;
            (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                startTime: startTime
            });
        }
    }
    stopVCObserver() {
        var _this$vcObserver2;
        (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
    }
    // Check if the current interaction is eligible for measurement
    eligibleToMeasure(interactionId) {
        const interaction = (0, $cQx5E.interactions).get(interactionId);
        return (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition';
    }
    updateFinishedInteraction(interaction) {
        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition') this.finishedInteraction = interaction;
    }
    setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    sinkHandler(fn) {
        this.sinkHandlerFn = fn;
    }
    onInteractionComplete(id, data) {
        if (data.ufoName) {
            const updatedData = {
                ...data,
                vcObserver: this.vcObserver ?? undefined
            };
            this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
        }
        this.stopVCObserver();
        (0, $9TwI7.remove)(id);
        this.reset();
    }
    reset() {
        var _this$finishedInterac;
        this.stopVCObserver();
        if ((_this$finishedInterac = this.finishedInteraction) !== null && _this$finishedInterac !== void 0 && _this$finishedInterac.id) (0, $9TwI7.remove)(this.finishedInteraction.id);
        this.finishedInteraction = null;
        this.lastInteractionFinishVCResult = undefined;
    }
    stopAll(id) {
        (0, $9TwI7.remove)(id);
        this.reset();
    }
    constructor(){
        // Store the finished interaction (as non-3p interaction)
        this.finishedInteraction = null;
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        this.vcObserver = null;
        this.sinkHandlerFn = ()=>{};
    }
}

});

parcelRegister("iut6i", function(module, exports) {
$parcel$export(module.exports, "default", () => $03e936d628930a87$export$2e2bcd8739ae039);

var $cAaWV = parcelRequire("cAaWV");

var $cHs48 = parcelRequire("cHs48");

var $3F1qw = parcelRequire("3F1qw");
const $03e936d628930a87$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $03e936d628930a87$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $3F1qw.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        var _this$vcObserver;
        (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        var _this$vcObserver2;
        (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        var _this$reactProfilerTi;
        return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        var _this$vcObserver4, _config$vc, _config$vc2, _this$vcObserver5;
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            var _this$vcObserver3;
            this.reset();
            (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 || _this$vcObserver3.stop();
            return;
        }
        const pageVisibilityState = (0, $cHs48.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $cAaWV.getConfig)();
        const postInteractionFinishVCResult = await ((_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 ? void 0 : _this$vcObserver4.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config === null || config === void 0 || (_config$vc = config.vc) === null || _config$vc === void 0 ? void 0 : _config$vc.includeSSRInV3,
            includeSSRRatio: config === null || config === void 0 || (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        }));
        (_this$vcObserver5 = this.vcObserver) === null || _this$vcObserver5 === void 0 || _this$vcObserver5.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, experimentalTTAI: experimentalTTAI, experimentalVC90: experimentalVC90, errors: errors }) {
        var _getConfig;
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            experimentalTTAI: experimentalTTAI,
            experimentalVC90: experimentalVC90,
            errors: errors
        };
        const timeout = ((_getConfig = (0, $cAaWV.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $03e936d628930a87$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
   * Basic info about interaction that has just finished
   */ this.lastInteractionFinish = null;
        /**
   * Array of observed react render timings
   */ this.reactProfilerTimings = [];
        /**
   * Store the scheduled sink timeout Id so that it can be cancelled when needed
   */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
   * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
   */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
   * Handler function to process / send the observation data
   */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("jByYr", function(module, exports) {
$parcel$export(module.exports, "getMetaData", () => $16059f54f7733ed0$export$929b5cc2a4ac0922);
$parcel$export(module.exports, "getMeta", () => $16059f54f7733ed0$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getMetaFromHTML", () => $16059f54f7733ed0$export$5a64793485e318f6);
$parcel$export(module.exports, "setHTMLMeta", () => $16059f54f7733ed0$export$11f8d00783d7fcf3);
$parcel$export(module.exports, "getCloudId", () => $16059f54f7733ed0$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getActivationId", () => $16059f54f7733ed0$export$3ad4bb31a1816ff6);
$parcel$export(module.exports, "getHelpCenterAri", () => $16059f54f7733ed0$export$5b6c1ffe6316b179);
$parcel$export(module.exports, "getWorkspaceAri", () => $16059f54f7733ed0$export$8e2de40963827c80);
$parcel$export(module.exports, "getLayoutAri", () => $16059f54f7733ed0$export$b6b5277467022679);
$parcel$export(module.exports, "isValidLayoutAriPresent", () => $16059f54f7733ed0$export$7a9c037572667aa1);
$parcel$export(module.exports, "addMetaToHead", () => $16059f54f7733ed0$export$9e7e16a3dbced495);

var $jW99n = parcelRequire("jW99n");
// oxlint-disable-next-line no-shadow
var $16059f54f7733ed0$var$EnvType = /*#__PURE__*/ function(EnvType) {
    EnvType["LOCAL"] = "local";
    EnvType["DEV"] = "dev";
    EnvType["STAGING"] = "staging";
    EnvType["PROD"] = "prod";
    return EnvType;
}($16059f54f7733ed0$var$EnvType || {});
const $16059f54f7733ed0$var$requiredMetaTags = {
    'account-id': 'accountId',
    'ajs-user-locale': 'userLocale',
    'ajs-account-type': 'accountType',
    'ajs-sdPluginVersion': 'sdPluginVersion',
    'ajs-context-path': 'contextPath',
    environment: 'environment',
    'tenant-id': 'tenantId',
    'activation-id': 'activationId',
    'help-center-ari': 'helpCenterARI',
    'home-page-layout-ari': 'homePageLayoutARI'
};
const $16059f54f7733ed0$export$929b5cc2a4ac0922 = ()=>{
    const metaData = {};
    Object.entries($16059f54f7733ed0$var$requiredMetaTags).forEach(([key, name])=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        metaData[name] = $16059f54f7733ed0$export$c47913ca32a5c6f7(key);
    });
    return Object.freeze(metaData);
};
function $16059f54f7733ed0$export$5a64793485e318f6(name) {
    const metaElement = (0, $jW99n.default).querySelector(`meta[name="${name}"]`);
    const metaValue = metaElement && metaElement.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
}
function $16059f54f7733ed0$export$c47913ca32a5c6f7(name) {
    return $16059f54f7733ed0$export$5a64793485e318f6(name);
}
const $16059f54f7733ed0$export$11f8d00783d7fcf3 = (name, value)=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    let node = document.querySelector(`meta[name="${name}"]`);
    if (!node) {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        node = document.createElement('meta');
        node.setAttribute('name', name);
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.head.appendChild(node);
    }
    node.setAttribute('content', value);
};
const $16059f54f7733ed0$export$fdd2c0ba94025c3c = ()=>{
    return $16059f54f7733ed0$export$c47913ca32a5c6f7('tenant-id') || '';
};
const $16059f54f7733ed0$export$3ad4bb31a1816ff6 = ()=>$16059f54f7733ed0$export$c47913ca32a5c6f7('activation-id') ?? '';
const $16059f54f7733ed0$export$5b6c1ffe6316b179 = ()=>{
    return $16059f54f7733ed0$export$c47913ca32a5c6f7('help-center-ari') || '';
};
const $16059f54f7733ed0$export$8e2de40963827c80 = ()=>{
    return $16059f54f7733ed0$export$c47913ca32a5c6f7('jira-workspace-ari') || '';
};
const $16059f54f7733ed0$export$b6b5277467022679 = ()=>{
    return $16059f54f7733ed0$export$c47913ca32a5c6f7('home-page-layout-ari') || '';
};
const $16059f54f7733ed0$export$7a9c037572667aa1 = ()=>{
    const layoutAri = $16059f54f7733ed0$export$b6b5277467022679();
    return layoutAri !== '' && layoutAri !== 'null';
};
const $16059f54f7733ed0$export$9e7e16a3dbced495 = (name, value)=>{
    var _document$head;
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const existingMetaTag = document.querySelector(`meta[name="${name}"]`);
    if ((existingMetaTag === null || existingMetaTag === void 0 ? void 0 : existingMetaTag.getAttribute('content')) === value) return;
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const metaTag = existingMetaTag || document.createElement('meta');
    metaTag.setAttribute('name', name);
    metaTag.setAttribute('content', value);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (_document$head = document.head) === null || _document$head === void 0 || _document$head.insertBefore(metaTag, document.head.childNodes[0]);
};

});
parcelRegister("jW99n", function(module, exports) {
$parcel$export(module.exports, "default", () => $f83d2ea07164ee7b$export$2e2bcd8739ae039);
class $f83d2ea07164ee7b$export$6e283cdda5461374 {
    constructor(){
        this.store = {
            elements: {}
        };
        this.parsedHTML = null;
    }
    startup(parsedHTML) {
        this.parsedHTML = parsedHTML;
    }
    isRunningInSnapvmRuntime() {
        return typeof window === 'undefined';
    }
    getDataRef() {
        if (this.isRunningInSnapvmRuntime()) return this.parsedHTML;
        // Set to document when not in SnapVM runtime (Classic and Client side render cases)
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        return document;
    }
    getElementById(elementId) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.getElementById(elementId);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in getElementById');
        return null;
    }
    querySelector(selector) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.querySelector(selector);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in querySelector');
        return null;
    }
    querySelectorAll(selector) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.querySelectorAll(selector);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in querySelectorAll');
        return [];
    }
    getElementsByTagName(tagName) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.getElementsByTagName(tagName);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in getElementsByTagName');
        return [];
    }
    addClassName(elementName, className) {
        if (this.isRunningInSnapvmRuntime()) {
            if (!this.store.elements[elementName]) this.store.elements[elementName] = {
                classList: []
            };
            this.store.elements[elementName].classList.push(className);
            return;
        }
        if (elementName === 'body') {
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            document.body.classList.add(className);
            return;
        }
        // oxlint-disable-next-line no-console
        console.warn('invalid elementName sent to addClassName. elementName: ', elementName);
    }
    getStore() {
        return this.store;
    }
}
const $f83d2ea07164ee7b$var$clientServerBridge = new $f83d2ea07164ee7b$export$6e283cdda5461374();
var $f83d2ea07164ee7b$export$2e2bcd8739ae039 = $f83d2ea07164ee7b$var$clientServerBridge;

});


parcelRegister("cInSQ", function(module, exports) {
$parcel$export(module.exports, "startLighthouseObserver", () => $2a01308c0ba92d00$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $2a01308c0ba92d00$export$b46cecdf698e4bb5);

var $9Cepy = parcelRequire("9Cepy");

var $egF4d = parcelRequire("egF4d");

var $43qA3 = parcelRequire("43qA3");

var $qXuJv = parcelRequire("qXuJv");

var $8kZgk = parcelRequire("8kZgk");
function $2a01308c0ba92d00$export$5ecf2aafafee3e0() {
    (0, $8kZgk.startLSObserver)();
    (0, $8kZgk.startLTObserver)();
}
function $2a01308c0ba92d00$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $43qA3.getTBT)(start, stop, (0, $qXuJv.EntriesBuffer)[(0, $egF4d.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $9Cepy.getCLS)(start, stop, (0, $qXuJv.EntriesBuffer)[(0, $egF4d.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("9Cepy", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $a96aed379e352449$export$fc6227831ee7c7);

var $e6Qdr = parcelRequire("e6Qdr");
function $a96aed379e352449$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $a96aed379e352449$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, $e6Qdr.fg)('platform_ufo_filter_cls_logs_same_rects_positions')) {
            var _entry$sources;
            const allSourcesHaveSameRects = entry === null || entry === void 0 || (_entry$sources = entry.sources) === null || _entry$sources === void 0 ? void 0 : _entry$sources.every(({ previousRect: previousRect, currentRect: currentRect })=>$a96aed379e352449$var$isSameRects(previousRect, currentRect));
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("egF4d", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $f3d95cbb942a2201$export$a4def92db6fc8e17);
const $f3d95cbb942a2201$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("43qA3", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $3c952e6fbc2fdf80$export$2d6e933b35bd3407);
const $3c952e6fbc2fdf80$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $3c952e6fbc2fdf80$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $3c952e6fbc2fdf80$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $3c952e6fbc2fdf80$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $3c952e6fbc2fdf80$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("qXuJv", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $5cf1e0a6e972fbb0$export$f7dc16cbd16f7bbe);

var $egF4d = parcelRequire("egF4d");
class $5cf1e0a6e972fbb0$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $5cf1e0a6e972fbb0$export$f7dc16cbd16f7bbe = {
    [(0, $egF4d.PerformanceObserverEntryTypes).LongTask]: new $5cf1e0a6e972fbb0$export$2c6e86519c9e8188(),
    [(0, $egF4d.PerformanceObserverEntryTypes).LayoutShift]: new $5cf1e0a6e972fbb0$export$2c6e86519c9e8188()
};

});

parcelRegister("8kZgk", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $62160441d7011a19$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $62160441d7011a19$export$54fb8b6aaf70ec9c);

var $egF4d = parcelRequire("egF4d");

var $qXuJv = parcelRequire("qXuJv");
let $62160441d7011a19$var$pe = null;
function $62160441d7011a19$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($62160441d7011a19$var$pe !== null) return $62160441d7011a19$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $egF4d.PerformanceObserverEntryTypes).LayoutShift) (0, $qXuJv.EntriesBuffer)[(0, $egF4d.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $egF4d.PerformanceObserverEntryTypes).LongTask) (0, $qXuJv.EntriesBuffer)[(0, $egF4d.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $62160441d7011a19$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $62160441d7011a19$var$pe;
}
function $62160441d7011a19$export$768ccc3ab7bac3ea() {
    var _getObserver;
    (_getObserver = $62160441d7011a19$var$getObserver()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $egF4d.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $62160441d7011a19$export$54fb8b6aaf70ec9c() {
    var _getObserver2;
    (_getObserver2 = $62160441d7011a19$var$getObserver()) === null || _getObserver2 === void 0 || _getObserver2.observe({
        type: (0, $egF4d.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("czITK", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $6988c5a3103ecffe$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $6988c5a3103ecffe$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $6988c5a3103ecffe$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $6988c5a3103ecffe$export$a3271f53e91faab7);
const $6988c5a3103ecffe$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $6988c5a3103ecffe$var$pressureRecordBuffer = [];
let $6988c5a3103ecffe$var$pressureObserver = null;
let $6988c5a3103ecffe$var$memoryRecordBuffer = [];
let $6988c5a3103ecffe$var$memoryInterval;
function $6988c5a3103ecffe$export$6c1060bed5fea050() {
    $6988c5a3103ecffe$var$pressureRecordBuffer.length = 0;
}
function $6988c5a3103ecffe$export$aa672c7221b183b0() {
    $6988c5a3103ecffe$var$memoryRecordBuffer.length = 0;
}
function $6988c5a3103ecffe$export$ec86686c1d2e65bc(filter) {
    $6988c5a3103ecffe$var$pressureRecordBuffer = $6988c5a3103ecffe$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $6988c5a3103ecffe$export$c0142ac82f5d0c28(filter) {
    $6988c5a3103ecffe$var$memoryRecordBuffer = $6988c5a3103ecffe$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $6988c5a3103ecffe$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $6988c5a3103ecffe$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $6988c5a3103ecffe$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $6988c5a3103ecffe$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $6988c5a3103ecffe$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $6988c5a3103ecffe$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $6988c5a3103ecffe$var$convertBytesToMegabytes($6988c5a3103ecffe$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $6988c5a3103ecffe$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $6988c5a3103ecffe$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $6988c5a3103ecffe$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $6988c5a3103ecffe$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $6988c5a3103ecffe$var$pressureObserver = new PressureObserver((records)=>{
                if ($6988c5a3103ecffe$var$pressureRecordBuffer.length + records.length <= $6988c5a3103ecffe$var$BUFFER_MAX_LENGTH) $6988c5a3103ecffe$var$pressureRecordBuffer.push(...records);
            });
            $6988c5a3103ecffe$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $6988c5a3103ecffe$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $6988c5a3103ecffe$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($6988c5a3103ecffe$var$memoryRecordBuffer.length <= $6988c5a3103ecffe$var$BUFFER_MAX_LENGTH) $6988c5a3103ecffe$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $6988c5a3103ecffe$export$10899ada382f2ae3() {
    clearInterval($6988c5a3103ecffe$var$memoryInterval);
}
function $6988c5a3103ecffe$export$b9fdd785f0fc1d40() {
    var _pressureObserver;
    (_pressureObserver = $6988c5a3103ecffe$var$pressureObserver) === null || _pressureObserver === void 0 || _pressureObserver.disconnect();
}

});

parcelRegister("18KuK", function(module, exports) {
$parcel$export(module.exports, "default", () => $23186e2dbe3c46a0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $23186e2dbe3c46a0$export$11bcb6e9af2aca35);

var $8P7DW = parcelRequire("8P7DW");

var $9uKqY = parcelRequire("9uKqY");
var $23186e2dbe3c46a0$export$2e2bcd8739ae039 = (0, $9uKqY.default);
function $23186e2dbe3c46a0$export$11bcb6e9af2aca35() {
    return (0, $8P7DW.useContext)((0, $9uKqY.default));
}

});
parcelRegister("9uKqY", function(module, exports) {
$parcel$export(module.exports, "default", () => $36d749f8eb86889d$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $36d749f8eb86889d$var$interactionContext = (0, $8P7DW.createContext)(null);
var $36d749f8eb86889d$export$2e2bcd8739ae039 = $36d749f8eb86889d$var$interactionContext;

});


parcelRegister("8WiY5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b333aa0574efe7d$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $3b333aa0574efe7d$var$UFORouteName = {
    current: null
};
var $3b333aa0574efe7d$export$2e2bcd8739ae039 = $3b333aa0574efe7d$var$UFORouteName;

});

parcelRegister("3r6Td", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $28093cd68ba75b2c$export$c4744153514ff05d, (v) => $28093cd68ba75b2c$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $28093cd68ba75b2c$export$3e506c1ccc9cc1a7, (v) => $28093cd68ba75b2c$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $28093cd68ba75b2c$export$e26fe2ed2fa76875, (v) => $28093cd68ba75b2c$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $28093cd68ba75b2c$export$502329bbf4b505b1, (v) => $28093cd68ba75b2c$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $28093cd68ba75b2c$export$6e3807111c4874c4, (v) => $28093cd68ba75b2c$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $28093cd68ba75b2c$export$c27134553091fb3a, (v) => $28093cd68ba75b2c$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $28093cd68ba75b2c$export$33ee1acdc04fd2a2, (v) => $28093cd68ba75b2c$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $28093cd68ba75b2c$export$b00a404bbd5edef2, (v) => $28093cd68ba75b2c$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $28093cd68ba75b2c$export$8352ce38b91d0c62, (v) => $28093cd68ba75b2c$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $28093cd68ba75b2c$export$d66a1c1c77bd778b, (v) => $28093cd68ba75b2c$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $28093cd68ba75b2c$export$d3dfb8e4810cb555, (v) => $28093cd68ba75b2c$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $28093cd68ba75b2c$export$839f9183b0465a69, (v) => $28093cd68ba75b2c$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $28093cd68ba75b2c$export$72fdf0e06517287b, (v) => $28093cd68ba75b2c$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $28093cd68ba75b2c$export$4b844e58a3e414b4, (v) => $28093cd68ba75b2c$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $28093cd68ba75b2c$export$816d2913ae6b83b1, (v) => $28093cd68ba75b2c$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $28093cd68ba75b2c$export$61bcfe829111a1d0, (v) => $28093cd68ba75b2c$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $28093cd68ba75b2c$export$7ee8c9beb337bc3f, (v) => $28093cd68ba75b2c$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $28093cd68ba75b2c$export$b5836b71941fa3ed, (v) => $28093cd68ba75b2c$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $28093cd68ba75b2c$export$cf845f2c119da08a, (v) => $28093cd68ba75b2c$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $28093cd68ba75b2c$export$c4744153514ff05d;
var $28093cd68ba75b2c$export$3e506c1ccc9cc1a7;
var $28093cd68ba75b2c$export$e26fe2ed2fa76875;
var $28093cd68ba75b2c$export$502329bbf4b505b1;
var $28093cd68ba75b2c$export$6e3807111c4874c4;
var $28093cd68ba75b2c$export$c27134553091fb3a;
var $28093cd68ba75b2c$export$33ee1acdc04fd2a2;
var $28093cd68ba75b2c$export$b00a404bbd5edef2;
var $28093cd68ba75b2c$export$8352ce38b91d0c62;
var $28093cd68ba75b2c$export$d66a1c1c77bd778b;
var $28093cd68ba75b2c$export$d3dfb8e4810cb555;
var $28093cd68ba75b2c$export$839f9183b0465a69;
var $28093cd68ba75b2c$export$72fdf0e06517287b;
var $28093cd68ba75b2c$export$4b844e58a3e414b4;
var $28093cd68ba75b2c$export$816d2913ae6b83b1;
var $28093cd68ba75b2c$export$61bcfe829111a1d0;
var $28093cd68ba75b2c$export$7ee8c9beb337bc3f;
var $28093cd68ba75b2c$export$b5836b71941fa3ed;
var $28093cd68ba75b2c$export$cf845f2c119da08a;
'use strict';
function $28093cd68ba75b2c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $28093cd68ba75b2c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $28093cd68ba75b2c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $28093cd68ba75b2c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $28093cd68ba75b2c$var$g(C, c)) n < e && 0 > $28093cd68ba75b2c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $28093cd68ba75b2c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $28093cd68ba75b2c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $28093cd68ba75b2c$var$l = performance;
    $28093cd68ba75b2c$export$c4744153514ff05d = function() {
        return $28093cd68ba75b2c$var$l.now();
    };
} else {
    var $28093cd68ba75b2c$var$p = Date, $28093cd68ba75b2c$var$q = $28093cd68ba75b2c$var$p.now();
    $28093cd68ba75b2c$export$c4744153514ff05d = function() {
        return $28093cd68ba75b2c$var$p.now() - $28093cd68ba75b2c$var$q;
    };
}
var $28093cd68ba75b2c$var$r = [], $28093cd68ba75b2c$var$t = [], $28093cd68ba75b2c$var$u = 1, $28093cd68ba75b2c$var$v = null, $28093cd68ba75b2c$var$y = 3, $28093cd68ba75b2c$var$z = !1, $28093cd68ba75b2c$var$A = !1, $28093cd68ba75b2c$var$B = !1, $28093cd68ba75b2c$var$D = "function" === typeof setTimeout ? setTimeout : null, $28093cd68ba75b2c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $28093cd68ba75b2c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $28093cd68ba75b2c$var$G(a) {
    for(var b = $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$t); null !== b;){
        if (null === b.callback) $28093cd68ba75b2c$var$k($28093cd68ba75b2c$var$t);
        else if (b.startTime <= a) $28093cd68ba75b2c$var$k($28093cd68ba75b2c$var$t), b.sortIndex = b.expirationTime, $28093cd68ba75b2c$var$f($28093cd68ba75b2c$var$r, b);
        else break;
        b = $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$t);
    }
}
function $28093cd68ba75b2c$var$H(a) {
    $28093cd68ba75b2c$var$B = !1;
    $28093cd68ba75b2c$var$G(a);
    if (!$28093cd68ba75b2c$var$A) {
        if (null !== $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$r)) $28093cd68ba75b2c$var$A = !0, $28093cd68ba75b2c$var$I($28093cd68ba75b2c$var$J);
        else {
            var b = $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$t);
            null !== b && $28093cd68ba75b2c$var$K($28093cd68ba75b2c$var$H, b.startTime - a);
        }
    }
}
function $28093cd68ba75b2c$var$J(a, b) {
    $28093cd68ba75b2c$var$A = !1;
    $28093cd68ba75b2c$var$B && ($28093cd68ba75b2c$var$B = !1, $28093cd68ba75b2c$var$E($28093cd68ba75b2c$var$L), $28093cd68ba75b2c$var$L = -1);
    $28093cd68ba75b2c$var$z = !0;
    var c = $28093cd68ba75b2c$var$y;
    try {
        $28093cd68ba75b2c$var$G(b);
        for($28093cd68ba75b2c$var$v = $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$r); null !== $28093cd68ba75b2c$var$v && (!($28093cd68ba75b2c$var$v.expirationTime > b) || a && !$28093cd68ba75b2c$var$M());){
            var d = $28093cd68ba75b2c$var$v.callback;
            if ("function" === typeof d) {
                $28093cd68ba75b2c$var$v.callback = null;
                $28093cd68ba75b2c$var$y = $28093cd68ba75b2c$var$v.priorityLevel;
                var e = d($28093cd68ba75b2c$var$v.expirationTime <= b);
                b = $28093cd68ba75b2c$export$c4744153514ff05d();
                "function" === typeof e ? $28093cd68ba75b2c$var$v.callback = e : $28093cd68ba75b2c$var$v === $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$r) && $28093cd68ba75b2c$var$k($28093cd68ba75b2c$var$r);
                $28093cd68ba75b2c$var$G(b);
            } else $28093cd68ba75b2c$var$k($28093cd68ba75b2c$var$r);
            $28093cd68ba75b2c$var$v = $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$r);
        }
        if (null !== $28093cd68ba75b2c$var$v) var w = !0;
        else {
            var m = $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$t);
            null !== m && $28093cd68ba75b2c$var$K($28093cd68ba75b2c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $28093cd68ba75b2c$var$v = null, $28093cd68ba75b2c$var$y = c, $28093cd68ba75b2c$var$z = !1;
    }
}
var $28093cd68ba75b2c$var$N = !1, $28093cd68ba75b2c$var$O = null, $28093cd68ba75b2c$var$L = -1, $28093cd68ba75b2c$var$P = 5, $28093cd68ba75b2c$var$Q = -1;
function $28093cd68ba75b2c$var$M() {
    return $28093cd68ba75b2c$export$c4744153514ff05d() - $28093cd68ba75b2c$var$Q < $28093cd68ba75b2c$var$P ? !1 : !0;
}
function $28093cd68ba75b2c$var$R() {
    if (null !== $28093cd68ba75b2c$var$O) {
        var a = $28093cd68ba75b2c$export$c4744153514ff05d();
        $28093cd68ba75b2c$var$Q = a;
        var b = !0;
        try {
            b = $28093cd68ba75b2c$var$O(!0, a);
        } finally{
            b ? $28093cd68ba75b2c$var$S() : ($28093cd68ba75b2c$var$N = !1, $28093cd68ba75b2c$var$O = null);
        }
    } else $28093cd68ba75b2c$var$N = !1;
}
var $28093cd68ba75b2c$var$S;
if ("function" === typeof $28093cd68ba75b2c$var$F) $28093cd68ba75b2c$var$S = function() {
    $28093cd68ba75b2c$var$F($28093cd68ba75b2c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $28093cd68ba75b2c$var$T = new MessageChannel, $28093cd68ba75b2c$var$U = $28093cd68ba75b2c$var$T.port2;
    $28093cd68ba75b2c$var$T.port1.onmessage = $28093cd68ba75b2c$var$R;
    $28093cd68ba75b2c$var$S = function() {
        $28093cd68ba75b2c$var$U.postMessage(null);
    };
} else $28093cd68ba75b2c$var$S = function() {
    $28093cd68ba75b2c$var$D($28093cd68ba75b2c$var$R, 0);
};
function $28093cd68ba75b2c$var$I(a) {
    $28093cd68ba75b2c$var$O = a;
    $28093cd68ba75b2c$var$N || ($28093cd68ba75b2c$var$N = !0, $28093cd68ba75b2c$var$S());
}
function $28093cd68ba75b2c$var$K(a, b) {
    $28093cd68ba75b2c$var$L = $28093cd68ba75b2c$var$D(function() {
        a($28093cd68ba75b2c$export$c4744153514ff05d());
    }, b);
}
$28093cd68ba75b2c$export$3e506c1ccc9cc1a7 = 5;
$28093cd68ba75b2c$export$e26fe2ed2fa76875 = 1;
$28093cd68ba75b2c$export$502329bbf4b505b1 = 4;
$28093cd68ba75b2c$export$6e3807111c4874c4 = 3;
$28093cd68ba75b2c$export$c27134553091fb3a = null;
$28093cd68ba75b2c$export$33ee1acdc04fd2a2 = 2;
$28093cd68ba75b2c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$28093cd68ba75b2c$export$8352ce38b91d0c62 = function() {
    $28093cd68ba75b2c$var$A || $28093cd68ba75b2c$var$z || ($28093cd68ba75b2c$var$A = !0, $28093cd68ba75b2c$var$I($28093cd68ba75b2c$var$J));
};
$28093cd68ba75b2c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $28093cd68ba75b2c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$28093cd68ba75b2c$export$d3dfb8e4810cb555 = function() {
    return $28093cd68ba75b2c$var$y;
};
$28093cd68ba75b2c$export$839f9183b0465a69 = function() {
    return $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$r);
};
$28093cd68ba75b2c$export$72fdf0e06517287b = function(a) {
    switch($28093cd68ba75b2c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $28093cd68ba75b2c$var$y;
    }
    var c = $28093cd68ba75b2c$var$y;
    $28093cd68ba75b2c$var$y = b;
    try {
        return a();
    } finally{
        $28093cd68ba75b2c$var$y = c;
    }
};
$28093cd68ba75b2c$export$4b844e58a3e414b4 = function() {};
$28093cd68ba75b2c$export$816d2913ae6b83b1 = function() {};
$28093cd68ba75b2c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $28093cd68ba75b2c$var$y;
    $28093cd68ba75b2c$var$y = a;
    try {
        return b();
    } finally{
        $28093cd68ba75b2c$var$y = c;
    }
};
$28093cd68ba75b2c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $28093cd68ba75b2c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $28093cd68ba75b2c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $28093cd68ba75b2c$var$f($28093cd68ba75b2c$var$t, a), null === $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$r) && a === $28093cd68ba75b2c$var$h($28093cd68ba75b2c$var$t) && ($28093cd68ba75b2c$var$B ? ($28093cd68ba75b2c$var$E($28093cd68ba75b2c$var$L), $28093cd68ba75b2c$var$L = -1) : $28093cd68ba75b2c$var$B = !0, $28093cd68ba75b2c$var$K($28093cd68ba75b2c$var$H, c - d))) : (a.sortIndex = e, $28093cd68ba75b2c$var$f($28093cd68ba75b2c$var$r, a), $28093cd68ba75b2c$var$A || $28093cd68ba75b2c$var$z || ($28093cd68ba75b2c$var$A = !0, $28093cd68ba75b2c$var$I($28093cd68ba75b2c$var$J)));
    return a;
};
$28093cd68ba75b2c$export$b5836b71941fa3ed = $28093cd68ba75b2c$var$M;
$28093cd68ba75b2c$export$cf845f2c119da08a = function(a) {
    var b = $28093cd68ba75b2c$var$y;
    return function() {
        var c = $28093cd68ba75b2c$var$y;
        $28093cd68ba75b2c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $28093cd68ba75b2c$var$y = c;
        }
    };
};

});

parcelRegister("hL9vO", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("heULS").then(()=>parcelRequire('kPHA3'));

});
parcelRegister("j9MRt", function(module, exports) {
"use strict";

function $df24c27795537539$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("1PGaS")).resolve(id));
}
module.exports = $df24c27795537539$var$load;

});
parcelRegister("1PGaS", function(module, exports) {
$parcel$export(module.exports, "register", () => $155b44d19d04d791$export$6503ec6e8aabbaf, (v) => $155b44d19d04d791$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $155b44d19d04d791$export$f7ad0328861e2f03, (v) => $155b44d19d04d791$export$f7ad0328861e2f03 = v);
var $155b44d19d04d791$export$6503ec6e8aabbaf;
var $155b44d19d04d791$export$f7ad0328861e2f03;
"use strict";
var $155b44d19d04d791$var$mapping = new Map();
function $155b44d19d04d791$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$155b44d19d04d791$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $155b44d19d04d791$var$resolve(id) {
    var resolved = $155b44d19d04d791$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$155b44d19d04d791$export$6503ec6e8aabbaf = $155b44d19d04d791$var$register;
$155b44d19d04d791$export$f7ad0328861e2f03 = $155b44d19d04d791$var$resolve;

});



parcelRegister("OBHqn", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("1tqO8").then(()=>parcelRequire('dCSDr'));

});

parcelRegister("iFWS8", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("3Undu").then(()=>parcelRequire('2tVnE'));

});

parcelRegister("llViW", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("10yC1").then(()=>parcelRequire('8wHE5'));

});

parcelRegister("CcUdd", function(module, exports) {
$parcel$export(module.exports, "configure", () => $6ebfa3dea652b84d$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $6ebfa3dea652b84d$export$44487a86467333c3);

var $cAaWV = parcelRequire("cAaWV");
const $6ebfa3dea652b84d$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $6ebfa3dea652b84d$var$getAllowedParams() {
    const config = (0, $cAaWV.getConfig)();
    return (config === null || config === void 0 ? void 0 : config.allowedResourcesParams) || $6ebfa3dea652b84d$var$defaultAllowedParams;
}
function $6ebfa3dea652b84d$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $6ebfa3dea652b84d$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch  {
        return urlString;
    }
}
let $6ebfa3dea652b84d$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $6ebfa3dea652b84d$var$handleQueryParams(url);
    }
};
function $6ebfa3dea652b84d$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $6ebfa3dea652b84d$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $6ebfa3dea652b84d$var$config = newConfig;
}
function $6ebfa3dea652b84d$export$44487a86467333c3() {
    return $6ebfa3dea652b84d$var$config;
}

});

parcelRegister("d0x1x", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $7b5c2547f641d4d0$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $7b5c2547f641d4d0$export$4138a729ef1db028);

var $epwwe = parcelRequire("epwwe");
const $7b5c2547f641d4d0$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $7b5c2547f641d4d0$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $7b5c2547f641d4d0$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        var _entry$serverTiming, _entry$serverTiming2;
        const duration = (0, $epwwe.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = ((_entry$serverTiming = entry.serverTiming) === null || _entry$serverTiming === void 0 ? void 0 : _entry$serverTiming.find((timing)=>timing.name === 'atl-edge')) || ((_entry$serverTiming2 = entry.serverTiming) === null || _entry$serverTiming2 === void 0 ? void 0 : _entry$serverTiming2.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi'));
        const serverTime = totalBackendTimeEntry ? (0, $epwwe.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $epwwe.roundEpsilon)(entry.startTime),
            duration: (0, $epwwe.roundEpsilon)(entry.duration),
            fetchStart: (0, $epwwe.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $epwwe.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $epwwe.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $epwwe.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $epwwe.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $epwwe.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        var _performance$getEntri;
        const performance = $7b5c2547f641d4d0$var$getPerformanceObject();
        const PerformanceObserver = $7b5c2547f641d4d0$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($7b5c2547f641d4d0$export$bea963256235a63e.observer) return;
        const resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $7b5c2547f641d4d0$export$bea963256235a63e.timings = resources.map((resource)=>$7b5c2547f641d4d0$export$bea963256235a63e.transformResource(resource));
        $7b5c2547f641d4d0$export$bea963256235a63e.observer = new PerformanceObserver($7b5c2547f641d4d0$export$bea963256235a63e.addTimings);
        $7b5c2547f641d4d0$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($7b5c2547f641d4d0$export$bea963256235a63e.observer) {
            $7b5c2547f641d4d0$export$bea963256235a63e.observer.disconnect();
            $7b5c2547f641d4d0$export$bea963256235a63e.observer = null;
        }
        $7b5c2547f641d4d0$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$7b5c2547f641d4d0$export$bea963256235a63e.transformResource(entry));
        const overflow = $7b5c2547f641d4d0$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $7b5c2547f641d4d0$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $7b5c2547f641d4d0$export$bea963256235a63e.maxSize;
            $7b5c2547f641d4d0$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $7b5c2547f641d4d0$export$bea963256235a63e.timings.push(...entries);
    }
};
function $7b5c2547f641d4d0$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $7b5c2547f641d4d0$export$4138a729ef1db028(startTime, endTime) {
    const performance = $7b5c2547f641d4d0$var$getPerformanceObject();
    const PerformanceObserver = $7b5c2547f641d4d0$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$7b5c2547f641d4d0$export$bea963256235a63e.observer) {
        const resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$7b5c2547f641d4d0$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $7b5c2547f641d4d0$export$bea963256235a63e.timings.filter((timing)=>$7b5c2547f641d4d0$var$isValidTiming(timing, startTime, endTime));
}

});
parcelRegister("epwwe", function(module, exports) {
$parcel$export(module.exports, "roundEpsilon", () => $6d7c05b71b2fa002$export$56014375de40214b);
function $6d7c05b71b2fa002$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("a30pz", function(module, exports) {
$parcel$export(module.exports, "configure", () => $ac4e908cdf115c2a$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $ac4e908cdf115c2a$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $ac4e908cdf115c2a$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $ac4e908cdf115c2a$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $ac4e908cdf115c2a$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $ac4e908cdf115c2a$export$1c4a9b5e6e22393d);
const $ac4e908cdf115c2a$var$NESTED_METRIC_SEPARATOR = '/';
function $ac4e908cdf115c2a$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $ac4e908cdf115c2a$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $ac4e908cdf115c2a$var$SSR_PREFIX = 'ssr';
function $ac4e908cdf115c2a$var$mapKey(key) {
    if (key === 'total') return $ac4e908cdf115c2a$var$SSR_PREFIX;
    return `${$ac4e908cdf115c2a$var$SSR_PREFIX}${$ac4e908cdf115c2a$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $ac4e908cdf115c2a$var$config;
function $ac4e908cdf115c2a$export$8d21e34596265fa2(ssrConfig) {
    $ac4e908cdf115c2a$var$config = ssrConfig;
}
function $ac4e908cdf115c2a$var$getPerformanceNavigationTiming() {
    var _performance$getEntri;
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (_performance$getEntri = performance.getEntriesByType('navigation')) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri[0];
}
function $ac4e908cdf115c2a$var$getServerTimingsByName() {
    var _getPerformanceNaviga;
    const serverTimingsByName = Object.fromEntries(((_getPerformanceNaviga = $ac4e908cdf115c2a$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga === void 0 || (_getPerformanceNaviga = _getPerformanceNaviga.serverTiming) === null || _getPerformanceNaviga === void 0 ? void 0 : _getPerformanceNaviga.map((timing)=>[
            timing.name,
            timing
        ])) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $ac4e908cdf115c2a$var$getEdgeOffset(edgeTtfb) {
    var _getPerformanceNaviga2;
    const clientTtfb = (_getPerformanceNaviga2 = $ac4e908cdf115c2a$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga2 === void 0 ? void 0 : _getPerformanceNaviga2.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $ac4e908cdf115c2a$export$5300d1b82e594615() {
    var _serverTimingsByName$, _serverTimingsByName$2, _serverTimingsByName$3, _serverTimingsByName$4, _serverTimingsByName$5, _serverTimingsByName$6, _serverTimingsByName$7, _serverTimingsByName$8;
    const serverTimingsByName = $ac4e908cdf115c2a$var$getServerTimingsByName();
    const edgeTotalDuration = ((_serverTimingsByName$ = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$ === void 0 ? void 0 : _serverTimingsByName$.duration) ?? ((_serverTimingsByName$2 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$2 === void 0 ? void 0 : _serverTimingsByName$2.duration);
    if (!edgeTotalDuration) return null;
    const edgeOffset = $ac4e908cdf115c2a$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (((_serverTimingsByName$3 = serverTimingsByName['cdn-upstream-dns']) === null || _serverTimingsByName$3 === void 0 ? void 0 : _serverTimingsByName$3.duration) || 0) + (((_serverTimingsByName$4 = serverTimingsByName['cdn-upstream-connect']) === null || _serverTimingsByName$4 === void 0 ? void 0 : _serverTimingsByName$4.duration) || 0);
    const cfUpstreamDuration = (((_serverTimingsByName$5 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$5 === void 0 ? void 0 : _serverTimingsByName$5.duration) || 0) - cfInternalDuration;
    const cfDownstreamDuration = (((_serverTimingsByName$6 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$6 === void 0 ? void 0 : _serverTimingsByName$6.duration) || 0) - (((_serverTimingsByName$7 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$7 === void 0 ? void 0 : _serverTimingsByName$7.duration) || 0);
    const atlEdgeDuration = (_serverTimingsByName$8 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$8 === void 0 ? void 0 : _serverTimingsByName$8.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        var _serverTimingsByName$9;
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: (_serverTimingsByName$9 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$9 === void 0 ? void 0 : _serverTimingsByName$9.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        var _serverTimingsByName$0;
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: (_serverTimingsByName$0 = serverTimingsByName['atl-edge-internal']) === null || _serverTimingsByName$0 === void 0 ? void 0 : _serverTimingsByName$0.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    (edgeTimings === null || edgeTimings === void 0 ? void 0 : edgeTimings.edge) && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $ac4e908cdf115c2a$export$bf7408e83532dcd0() {
    var _config;
    const defaultSSRTimings = $ac4e908cdf115c2a$export$5300d1b82e594615() || {};
    let configTimings = {};
    if (typeof ((_config = $ac4e908cdf115c2a$var$config) === null || _config === void 0 ? void 0 : _config.getTimings) === 'function') configTimings = $ac4e908cdf115c2a$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($ac4e908cdf115c2a$var$filterEntry(entry[1])) acc[$ac4e908cdf115c2a$var$mapKey(entry[0])] = $ac4e908cdf115c2a$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $ac4e908cdf115c2a$export$c7ad864055e75537() {
    var _config2;
    return !!((_config2 = $ac4e908cdf115c2a$var$config) !== null && _config2 !== void 0 && _config2.getDoneMark());
}
function $ac4e908cdf115c2a$export$5eade9354185583d() {
    var _config3, _config3$getSsrPhaseS;
    return (_config3 = $ac4e908cdf115c2a$var$config) === null || _config3 === void 0 || (_config3$getSsrPhaseS = _config3.getSsrPhaseSuccess) === null || _config3$getSsrPhaseS === void 0 ? void 0 : _config3$getSsrPhaseS.call(_config3);
}
function $ac4e908cdf115c2a$export$3def7672244bab0c() {
    var _config4;
    return ((_config4 = $ac4e908cdf115c2a$var$config) === null || _config4 === void 0 ? void 0 : _config4.getDoneMark()) ?? undefined;
}
function $ac4e908cdf115c2a$export$1c4a9b5e6e22393d() {
    var _config5;
    if (!((_config5 = $ac4e908cdf115c2a$var$config) !== null && _config5 !== void 0 && _config5.getFeatureFlags)) return undefined;
    try {
        return $ac4e908cdf115c2a$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}

});

parcelRegister("hrPHR", function(module, exports) {
$parcel$export(module.exports, "EnvType", () => $43e6f85c459f9f69$export$76f4b1ef26f59baf);
$parcel$export(module.exports, "getEnv", () => $43e6f85c459f9f69$export$4bd44a2aa29d3d6e);
$parcel$export(module.exports, "getIsPageServerSideRendered", () => $43e6f85c459f9f69$export$11bdeb36ea0511ca);
$parcel$export(module.exports, "getIsMultiHCEnabled", () => $43e6f85c459f9f69$export$ae0e930c2df55631);
$parcel$export(module.exports, "getIsHCCustomizationEnabled", () => $43e6f85c459f9f69$export$efe1682951193de4);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $43e6f85c459f9f69$export$a90992f5204fc247);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $43e6f85c459f9f69$export$9679fa5312e1354b);
$parcel$export(module.exports, "getHoistedProjectKey", () => $43e6f85c459f9f69$export$3b0fd0e16a94f75);

var $jW99n = parcelRequire("jW99n");

var $jByYr = parcelRequire("jByYr");
var $43e6f85c459f9f69$export$76f4b1ef26f59baf = /*#__PURE__*/ function(EnvType) {
    EnvType["LOCAL"] = "local";
    EnvType["DEV"] = "dev";
    EnvType["STAGING"] = "staging";
    EnvType["PROD"] = "prod";
    return EnvType;
}({});
function $43e6f85c459f9f69$var$parseEnvironment() {
    const env = (0, $jByYr.getMeta)('environment');
    if (env === 'prod') return "prod";
    if (env === 'staging') return "staging";
    return "dev";
}
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const $43e6f85c459f9f69$var$parseJson = (content)=>content ? JSON.parse(content) : {};
const $43e6f85c459f9f69$var$envElement = (0, $jW99n.default).getElementById('envJson');
let $43e6f85c459f9f69$var$envData;
const $43e6f85c459f9f69$export$4bd44a2aa29d3d6e = ()=>{
    if ($43e6f85c459f9f69$var$envData) return $43e6f85c459f9f69$var$envData;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    $43e6f85c459f9f69$var$envData = Object.freeze({
        ...$43e6f85c459f9f69$var$parseJson($43e6f85c459f9f69$var$envElement && $43e6f85c459f9f69$var$envElement.textContent),
        environment: $43e6f85c459f9f69$var$parseEnvironment()
    });
    return $43e6f85c459f9f69$var$envData;
};
const $43e6f85c459f9f69$export$11bdeb36ea0511ca = ()=>{
    // @ts-ignore - TS2339: Property '__IS_PAGE_SERVER_SIDE_RENDERED__' does not exist on type 'Window & typeof globalThis'.
    // This was added when adding project references to help center.
    return window.__IS_PAGE_SERVER_SIDE_RENDERED__;
};
const $43e6f85c459f9f69$export$ae0e930c2df55631 = ()=>{
    var _getEnv$featuredValue;
    return (_getEnv$featuredValue = $43e6f85c459f9f69$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue === void 0 ? void 0 : _getEnv$featuredValue.multiHelpCenterEnabled;
};
const $43e6f85c459f9f69$export$efe1682951193de4 = ()=>{
    var _getEnv$featuredValue2;
    return (_getEnv$featuredValue2 = $43e6f85c459f9f69$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue2 === void 0 ? void 0 : _getEnv$featuredValue2.helpCenterCustomizationEnabled;
};
const $43e6f85c459f9f69$export$a90992f5204fc247 = ()=>{
    var _getEnv$featuredValue3;
    return ((_getEnv$featuredValue3 = $43e6f85c459f9f69$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue3 === void 0 ? void 0 : _getEnv$featuredValue3.jsmAiConfigEnabled) ?? false;
};
const $43e6f85c459f9f69$export$9679fa5312e1354b = ()=>{
    return $43e6f85c459f9f69$export$4bd44a2aa29d3d6e().jiraDisplayUrl;
};
const $43e6f85c459f9f69$export$3b0fd0e16a94f75 = ()=>{
    return $43e6f85c459f9f69$export$4bd44a2aa29d3d6e().hoistedProjectKey;
};
const $43e6f85c459f9f69$export$e567920edc63a849 = ()=>{
    return $43e6f85c459f9f69$export$4bd44a2aa29d3d6e().relativeBaseUrl;
};

});

parcelRegister("4L08H", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $446c9dde1d210500$export$e9ba7ef9458d1a4a);
$parcel$export(module.exports, "updateUserInfo", () => $446c9dde1d210500$export$c305be0ec5c00f16);
$parcel$export(module.exports, "getAnalyticsWebClientPromise", () => $446c9dde1d210500$export$799525ac94ca811d);

var $jXNbL = parcelRequire("jXNbL");
var $b5UnP = parcelRequire("b5UnP");

var $jByYr = parcelRequire("jByYr");

var $1We2B = parcelRequire("1We2B");

var $1EFS8 = parcelRequire("1EFS8");

var $17wqU = parcelRequire("17wqU");
var $8hleO = parcelRequire("8hleO");

var $iziiq = parcelRequire("iziiq");

var $gOotW = parcelRequire("gOotW");

var $gk18s = parcelRequire("gk18s");

var $lKEMb = parcelRequire("lKEMb");

var $hrPHR = parcelRequire("hrPHR");

var $8YEr6 = parcelRequire("8YEr6");

var $1Hxwl = parcelRequire("1Hxwl");

/**
 * Feature flag: analytics_client_is_synthetic
 *
 * Enables passing the isSynthetic flag to analytics client to identify
 * synthetic/automated traffic in analytics data.
 */ const $446c9dde1d210500$var$ANALYTICS_CLIENT_IS_SYNTHETIC = 'analytics_client_is_synthetic';
const $446c9dde1d210500$var$isAnalyticsClientIsSyntheticEnabled = ()=>(0, $1EFS8.default).checkGate($446c9dde1d210500$var$ANALYTICS_CLIENT_IS_SYNTHETIC);
const $446c9dde1d210500$var$GAS_V3_ROUTE = 'gateway/api/gasv3/api/v1';
class $446c9dde1d210500$export$208d0eb1d9fc833e {
    init({ tenantId: tenantId, userId: userId, subProduct: subProduct, product: product, environment: environment, locale: locale, callback: callback, version: version, shouldTriggerUIViewed: shouldTriggerUIViewed = true }) {
        this.analyticsClient = new (0, $jXNbL.default)({
            product: product,
            locale: locale,
            env: environment,
            version: version || '1.0.0',
            origin: (0, $b5UnP.originType).WEB,
            ...(0, $gOotW.isIsolatedCloud)() ? {
                ic: (0, $gOotW.isolationContextId)()
            } : undefined
        }, {
            disableCookiePersistence: true,
            ...$446c9dde1d210500$var$isAnalyticsClientIsSyntheticEnabled() ? {
                isSynthetic: (0, $jByYr.getMeta)('ajs-is-synthetic') === 'true'
            } : undefined,
            ...(0, $gOotW.isIsolatedCloud)() ? {
                apiHost: `${window.location.hostname}/${$446c9dde1d210500$var$GAS_V3_ROUTE}`
            } : undefined
        });
        this.bootstrapEventPayloadOverride();
        if (!this.analyticsClient) return false;
        if (tenantId) this.analyticsClient.setTenantInfo((0, $b5UnP.tenantType).CLOUD_ID, tenantId);
        if (userId) this.analyticsClient.setUserInfo((0, $b5UnP.userType).ATLASSIAN_ACCOUNT, userId);
        if (subProduct) this.analyticsClient.setSubproduct(subProduct);
        if (shouldTriggerUIViewed) {
            const callbackFn = typeof callback === 'function' ? callback : (0, $1We2B.noop);
            this.analyticsClient.startUIViewedEvent(callbackFn);
        }
        return true;
    }
    addCommonHelpCenterData(event) {
        if (typeof event === 'object') event.attributes = {
            ...event.attributes,
            ...(0, $1Hxwl.getHelpCenterAnalyticsData)(),
            ...(0, $8YEr6.getApplicationType)()
        };
        return event;
    }
    bootstrapEventPayloadOverride() {
        const sendUIEvent = this.analyticsClient.sendUIEvent;
        const sendTrackEvent = this.analyticsClient.sendTrackEvent;
        const sendOperationalEvent = this.analyticsClient.sendOperationalEvent;
        const sendScreenEvent = this.analyticsClient.sendScreenEvent;
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendUIEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            //eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendUIEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendTrackEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            //eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendTrackEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendOperationalEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            //eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendOperationalEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendScreenEvent = (event, callback, attributes)=>{
            //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const existingAttrs = typeof attributes === 'object' ? attributes : {
                //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                value: attributes // non object vales are directly assigned as attributes accept `any`
            };
            //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const updatedAttrs = {
                ...existingAttrs,
                ...(0, $1Hxwl.getHelpCenterAnalyticsData)(),
                ...(0, $8YEr6.getApplicationType)()
            };
            //eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendScreenEvent.call(this.analyticsClient, event, callback, updatedAttrs);
        };
    }
    getDataFromEvent(event, channel) {
        if (channel === (0, $17wqU.ANALYTICS_BRIDGE_CHANNEL)) return (0, $8hleO.extractAWCDataFromEvent)(event);
        return (0, $iziiq.getEvent)(event);
    }
    sendEvent(event, channel) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const { type: type, payload: payload } = this.getDataFromEvent(event, channel);
        try {
            switch(type){
                case 0, $iziiq.UI_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendUIEvent(payload);
                    break;
                case 0, $iziiq.TRACK_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendTrackEvent(payload);
                    break;
                case 0, $iziiq.OPERATIONAL_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendOperationalEvent(payload);
                    break;
                case 0, $iziiq.SCREEN_EVENT_TYPE:
                    // Disabling existing violations, should be fixed when revisited.
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendScreenEvent(payload.name, null, payload.attributes);
                    break;
                default:
                    (0, $lKEMb.devLog)(`An event was blackholed because it was of an invalid analyticsType: ${// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    event.payload.analyticsType}.\nMake sure analyticsType is specified in the event's payload and is one of ${[
                        (0, $iziiq.UI_EVENT_TYPE),
                        (0, $iziiq.TRACK_EVENT_TYPE),
                        (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                        (0, $iziiq.SCREEN_EVENT_TYPE)
                    ].join(', ')}.`);
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('Failed to send analytic data. It may be malformed, or sessionStorage may be disabled.', err);
        }
    }
    getInstance() {
        return this.analyticsClient;
    }
    updateUserInfo(accountId) {
        this.analyticsClient.setUserInfo((0, $b5UnP.userType).ATLASSIAN_ACCOUNT, accountId);
    }
}
let $446c9dde1d210500$var$analyticsWebClient;
const $446c9dde1d210500$export$e9ba7ef9458d1a4a = ()=>{
    if ($446c9dde1d210500$var$analyticsWebClient) return $446c9dde1d210500$var$analyticsWebClient;
    const locale = (0, $jByYr.getMeta)('ajs-user-locale') || (0, $jByYr.getMeta)('user-locale') || '';
    const tenantId = (0, $jByYr.getMeta)('tenant-id') || '';
    const accountId = (0, $jByYr.getMeta)('account-id') || '';
    const version = window.BUILD_KEY;
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const environment = (0, $hrPHR.getEnv)().environment;
    $446c9dde1d210500$var$analyticsWebClient = new $446c9dde1d210500$export$208d0eb1d9fc833e();
    $446c9dde1d210500$var$analyticsWebClient.init({
        tenantId: tenantId,
        environment: environment,
        locale: locale,
        version: version,
        subProduct: isCSM ? 'customer-service' : 'serviceDesk',
        userId: accountId,
        product: 'jira',
        shouldTriggerUIViewed: false
    });
    return $446c9dde1d210500$var$analyticsWebClient;
};
const $446c9dde1d210500$export$c305be0ec5c00f16 = (accountId)=>{
    $446c9dde1d210500$var$analyticsWebClient.updateUserInfo(accountId);
};
const $446c9dde1d210500$export$799525ac94ca811d = ()=>Promise.resolve($446c9dde1d210500$export$e9ba7ef9458d1a4a());
const $446c9dde1d210500$export$474e180ec53844ef = ()=>{
    $446c9dde1d210500$var$analyticsWebClient = undefined;
};

});
parcelRegister("jXNbL", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a94f838daff07ef$export$2e2bcd8739ae039);

var $gOotW = parcelRequire("gOotW");

var $b5UnP = parcelRequire("b5UnP");

var $fJgDp = parcelRequire("fJgDp");

var $3EX7N = parcelRequire("3EX7N");

var $i5JVe = parcelRequire("i5JVe");

var $d3qqy = parcelRequire("d3qqy");

var $3nWZx = parcelRequire("3nWZx");

var $cxJpC = parcelRequire("cxJpC");

var $iY4qk = parcelRequire("iY4qk");

var $XV4tF = parcelRequire("XV4tF");

var $2uxKZ = parcelRequire("2uxKZ");

var $3I45y = parcelRequire("3I45y");

var $2IZ6Z = parcelRequire("2IZ6Z");

var $1jkuR = parcelRequire("1jkuR");

var $kcuea = parcelRequire("kcuea");

var $j8ShH = parcelRequire("j8ShH");

var $inrzB = parcelRequire("inrzB");

var $gey9z = parcelRequire("gey9z");

var $hjija = parcelRequire("hjija");

var $hk0S5 = parcelRequire("hk0S5");

var $cRyar = parcelRequire("cRyar");

var $aePKi = parcelRequire("aePKi");

var $60DSr = parcelRequire("60DSr");

var $fEM2b = parcelRequire("fEM2b");

var $5K6mD = parcelRequire("5K6mD");
const $9a94f838daff07ef$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $9a94f838daff07ef$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $9a94f838daff07ef$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $9a94f838daff07ef$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $3EX7N.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $3EX7N.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($9a94f838daff07ef$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch  {
                this._safeSessionStorage.removeItem($9a94f838daff07ef$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($9a94f838daff07ef$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $b5UnP.eventType).UI:
                case (0, $b5UnP.eventType).OPERATIONAL:
                case (0, $b5UnP.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $b5UnP.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $b5UnP.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
    * Calling this function in the intialisation of the client in product
    * captures specified 'origin tracing' URL params and fires a single origin landed event
    * <p>
    * This function expects a mapping between the keys for any URL parameters
    *  that should be captured and removed for origin tracing
    * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
    * Each handler function should return an object with two items
    * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
    * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
    *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
    * </p>
    * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
    * e.g. from a share or email
    *
    * An example calling this function using an external decoding library, with taskSessionId specified to persist
    * analyticsWebClient.setOriginTracingHandlers({
         atlOrigin: encodedOrigin => {
             const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
             return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
         },
     });
    *
    * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
    * @this {AnalyticsWebClient}
    */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $b5UnP.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $b5UnP.isType)((0, $b5UnP.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $b5UnP.objectValues)((0, $b5UnP.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $iY4qk.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $b5UnP.isType)((0, $b5UnP.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $b5UnP.objectValues)((0, $b5UnP.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $b5UnP.isType)((0, $b5UnP.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $b5UnP.objectValues)((0, $b5UnP.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $b5UnP.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
   * @deprecated
   * please use {@link sendScreenEvent instead)
   */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
   * send screen event
   * @param event The event / For retrocompatibility event name is still supported here.
   * @param callback
   * @param attributes. Deprecated, will get ignored if using an event object as first param.
   */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $iY4qk.validateScreenEvent)(screenName);
            (0, $iY4qk.validateContainers)(screenContainers);
            const builtEvent = (0, $3nWZx.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $fEM2b.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $iY4qk.validateTrackEvent)(event);
            const builtEvent = (0, $3nWZx.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $b5UnP.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $3nWZx.buildActionName)(event), builtEvent, this._context, (0, $fEM2b.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $iY4qk.validateUIEvent)(event);
            const builtEvent = (0, $3nWZx.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $b5UnP.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $3nWZx.buildActionName)(event), builtEvent, this._context, (0, $fEM2b.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $iY4qk.validateOperationalEvent)(event);
            const builtEvent = (0, $3nWZx.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $b5UnP.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $3nWZx.buildActionName)(event), builtEvent, this._context, (0, $fEM2b.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = (callback)=>{
            return new (0, $hk0S5.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $b5UnP.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $b5UnP.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $b5UnP.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $b5UnP.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $b5UnP.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $b5UnP.objectValues)((0, $b5UnP.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $b5UnP.isType)((0, $b5UnP.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $b5UnP.objectValues)((0, $b5UnP.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $b5UnP.originType).WEB;
        else if (!(0, $b5UnP.isType)((0, $b5UnP.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $b5UnP.objectValues)((0, $b5UnP.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $b5UnP.originType).WEB ? (0, $b5UnP.platformType).WEB : (0, $b5UnP.platformType).DESKTOP;
        else (0, $iY4qk.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $gOotW.isFedrampModerate)()) productInfo.perimeter = (0, $b5UnP.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $b5UnP.perimeterType).COMMERCIAL;
        if (!(0, $b5UnP.isType)((0, $b5UnP.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $b5UnP.objectValues)((0, $b5UnP.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $gOotW.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $d3qqy.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $d3qqy.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $3nWZx.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $j8ShH.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $1jkuR.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $5K6mD.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $2uxKZ.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $XV4tF.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $9a94f838daff07ef$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $2IZ6Z.default)();
        this._tabTracking = new (0, $inrzB.default)();
        this._sessionTracking = new (0, $kcuea.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $gey9z.default)();
        this._originTracing = new (0, $3I45y.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $fJgDp.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $cRyar.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $cxJpC.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $hjija.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $60DSr.default)();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $i5JVe.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $aePKi.TestSupport).isGeminiVREnvironment() && !(0, $aePKi.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $aePKi.TestSupport).isGeminiVREnvironment() && !(0, $aePKi.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("gOotW", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $496bf768c711a8e4$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $496bf768c711a8e4$export$104cb891a6e90b3a);
$parcel$export(module.exports, "isolatedCloudDomain", () => $496bf768c711a8e4$export$80638ee198476daf);
$parcel$export(module.exports, "isolationContextId", () => $496bf768c711a8e4$export$839b022803d38d4d);
$parcel$export(module.exports, "cloudEnvironment", () => $496bf768c711a8e4$export$9e04105551ffc5c4);

var $5nkQa = parcelRequire("5nkQa");

var $5dpJ3 = parcelRequire("5dpJ3");
function $496bf768c711a8e4$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return ((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInIC) ?? false;
    }
    const atlCtxCookieValues = (0, $5dpJ3.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $5nkQa.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $496bf768c711a8e4$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex2;
        // @ts-ignore
        return ((_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) ?? false;
    }
    const atlCtxCookieValues = (0, $5dpJ3.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $5nkQa.FEDRAMP_MODERATE);
}
function $496bf768c711a8e4$export$80638ee198476daf() {
    if (typeof document === 'undefined') {
        var _globalThis$location;
        return (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname;
    }
    const atlCtxCookieValues = (0, $5dpJ3.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $496bf768c711a8e4$export$839b022803d38d4d() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex3;
        // @ts-ignore
        return $496bf768c711a8e4$export$9186ccba8effc5de() ? (_globalThis$ssrContex3 = globalThis.ssrContext) === null || _globalThis$ssrContex3 === void 0 ? void 0 : _globalThis$ssrContex3.icName : undefined;
    }
    const atlCtxCookieValues = (0, $5dpJ3.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}
function $496bf768c711a8e4$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $496bf768c711a8e4$var$cloudEnvironmentSsrLookup();
    return $496bf768c711a8e4$var$cloudEnvironmentCookieLookup();
}
function $496bf768c711a8e4$var$cloudEnvironmentSsrLookup() {
    var _globalThis$ssrContex4, _globalThis$ssrContex5;
    // @ts-ignore
    if (((_globalThis$ssrContex4 = globalThis.ssrContext) === null || _globalThis$ssrContex4 === void 0 ? void 0 : _globalThis$ssrContex4.isInIC) === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $5nkQa.COMMERCIAL)
    };
    // @ts-ignore
    if (((_globalThis$ssrContex5 = globalThis.ssrContext) === null || _globalThis$ssrContex5 === void 0 ? void 0 : _globalThis$ssrContex5.isInFedramp) === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $5nkQa.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $5nkQa.COMMERCIAL)
    };
}
function $496bf768c711a8e4$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $5dpJ3.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $5nkQa.COMMERCIAL)
    };
    const isIc = (0, $5nkQa.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $5nkQa.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $5nkQa.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $5nkQa.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}

});
parcelRegister("5nkQa", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $b1a885e9c2a309fa$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $b1a885e9c2a309fa$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $b1a885e9c2a309fa$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $b1a885e9c2a309fa$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $b1a885e9c2a309fa$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $b1a885e9c2a309fa$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $b1a885e9c2a309fa$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $b1a885e9c2a309fa$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $b1a885e9c2a309fa$export$a0ffa0598c95dfb7);
const $b1a885e9c2a309fa$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $b1a885e9c2a309fa$export$f005e2e9f707cb5f = 'commercial';
const $b1a885e9c2a309fa$export$a739cd5aac835909 = 'staging';
const $b1a885e9c2a309fa$export$42dd0cdd351a4a9 = 'prod';
const $b1a885e9c2a309fa$export$404582bc18fe4d9e = 'dev';
const $b1a885e9c2a309fa$export$d8347b4aae768c2d = [
    $b1a885e9c2a309fa$export$f005e2e9f707cb5f
];
const $b1a885e9c2a309fa$export$b1b1ccc8f3e7f954 = [
    $b1a885e9c2a309fa$export$f005e2e9f707cb5f,
    $b1a885e9c2a309fa$export$ce553301d55c2fd8
];
const $b1a885e9c2a309fa$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $b1a885e9c2a309fa$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $b1a885e9c2a309fa$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("5dpJ3", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $3a49da5e5387feb8$export$3fa7b7af96286cc9);

var $5nkQa = parcelRequire("5nkQa");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $3a49da5e5387feb8$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $3a49da5e5387feb8$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $3a49da5e5387feb8$var$getRawCookieValue((0, $5nkQa.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $3a49da5e5387feb8$var$getRawCookieValue((0, $5nkQa.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $3a49da5e5387feb8$var$getRawCookieValue((0, $5nkQa.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});


parcelRegister("b5UnP", function(module, exports) {
$parcel$export(module.exports, "envType", () => $d8f80cc89c8b36e1$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $d8f80cc89c8b36e1$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $d8f80cc89c8b36e1$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $d8f80cc89c8b36e1$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $d8f80cc89c8b36e1$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $d8f80cc89c8b36e1$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $d8f80cc89c8b36e1$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $d8f80cc89c8b36e1$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $d8f80cc89c8b36e1$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $d8f80cc89c8b36e1$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $d8f80cc89c8b36e1$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $d8f80cc89c8b36e1$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $d8f80cc89c8b36e1$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $d8f80cc89c8b36e1$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $d8f80cc89c8b36e1$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $d8f80cc89c8b36e1$export$e73680b18d9b7c6e);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $d8f80cc89c8b36e1$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $d8f80cc89c8b36e1$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $d8f80cc89c8b36e1$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $d8f80cc89c8b36e1$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $d8f80cc89c8b36e1$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $d8f80cc89c8b36e1$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $d8f80cc89c8b36e1$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $d8f80cc89c8b36e1$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $d8f80cc89c8b36e1$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $d8f80cc89c8b36e1$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $d8f80cc89c8b36e1$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $d8f80cc89c8b36e1$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $d8f80cc89c8b36e1$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $d8f80cc89c8b36e1$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $d8f80cc89c8b36e1$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $d8f80cc89c8b36e1$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $d8f80cc89c8b36e1$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("fJgDp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d11dbdec38187f$export$2e2bcd8739ae039);

var $b5UnP = parcelRequire("b5UnP");

var $2IZ6Z = parcelRequire("2IZ6Z");

var $eAMYg = parcelRequire("eAMYg");
class $d6d11dbdec38187f$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $b5UnP.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
     * For initialLoad type:
     * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
     *
     * For transition type:
     * 1. active status is tracked in active events map (_isActiveEvents)
     *
     * For any type, if startTime or stopTime is specified:
     * 1. If currently active (!_isHidden)
     */ if (event.type === (0, $b5UnP.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $b5UnP.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $b5UnP.isType)((0, $b5UnP.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
     * For a transition, if the startTime was not specified,
     * the start event should have been present.
     */ if (!event.startTime && event.type === (0, $b5UnP.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $2IZ6Z.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $eAMYg.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("2IZ6Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $69d68cafe7df8ad6$export$2e2bcd8739ae039);
class $69d68cafe7df8ad6$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("eAMYg", function(module, exports) {
$parcel$export(module.exports, "default", () => $89e0e9415c885bc8$export$2e2bcd8739ae039);
class $89e0e9415c885bc8$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("3EX7N", function(module, exports) {
$parcel$export(module.exports, "default", () => $af95280ee02ee9ed$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $af95280ee02ee9ed$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $af95280ee02ee9ed$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($af95280ee02ee9ed$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("i5JVe", function(module, exports) {
$parcel$export(module.exports, "default", () => $de9061e12db9b430$export$2e2bcd8739ae039);

var $gH4H3 = parcelRequire("gH4H3");
var $6Q0K1 = parcelRequire("6Q0K1");
var $70Wq6 = parcelRequire("70Wq6");

var $b5UnP = parcelRequire("b5UnP");

var $cRyar = parcelRequire("cRyar");
const $de9061e12db9b430$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $6Q0K1.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $de9061e12db9b430$export$2e2bcd8739ae039 {
    constructor(options){
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, $b5UnP.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $70Wq6.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $cRyar.default)($de9061e12db9b430$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $6Q0K1.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $6Q0K1.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $gH4H3.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("gH4H3", function(module, exports) {
$parcel$export(module.exports, "default", () => $58e1e36f9bb47ec0$export$2e2bcd8739ae039);

var $1pfMV = parcelRequire("1pfMV");

var $gOotW = parcelRequire("gOotW");

var $e6Qdr = parcelRequire("e6Qdr");

var $4KnCl = parcelRequire("4KnCl");

var $ehX2F = parcelRequire("ehX2F");
const $58e1e36f9bb47ec0$export$b9dd752fb13352ce = 'interactionSession.source';
const $58e1e36f9bb47ec0$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $58e1e36f9bb47ec0$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($58e1e36f9bb47ec0$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($58e1e36f9bb47ec0$export$b9dd752fb13352ce) : null;
        const shouldDisable = (0, $e6Qdr.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $1pfMV.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $gOotW.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $4KnCl.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $ehX2F.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($58e1e36f9bb47ec0$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($58e1e36f9bb47ec0$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("1pfMV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $bBab2 = parcelRequire("bBab2");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $bBab2.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $bBab2.isFeatureEnabled;
    }
});

});
parcelRegister("bBab2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $gOotW = parcelRequire("gOotW");

var $OddlM = parcelRequire("OddlM");
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $871b0b60faa4361a$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $871b0b60faa4361a$var$getBoundaryKey();
    return (0, $OddlM.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $871b0b60faa4361a$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $871b0b60faa4361a$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const boundaryKey = $871b0b60faa4361a$var$getBoundaryKey();
    const aemResult = (0, $OddlM.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    if (!aemResult) return false;
    const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
    return predicate ? predicate() : true;
}
module.exports.isFeatureEnabled = $871b0b60faa4361a$var$isFeatureEnabled;
function $871b0b60faa4361a$var$getBoundaryKey() {
    if ((0, $gOotW.isFedrampModerate)()) return $OddlM.FED_MOD_KEY;
    if ((0, $gOotW.isIsolatedCloud)()) return $OddlM.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $OddlM.COMMERCIAL_KEY;
}

});
parcelRegister("OddlM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $fRrsA = parcelRequire("fRrsA");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $fRrsA.isEnvironmentBlockEnabledForBoundary;
    }
});

var $fRrsA = parcelRequire("fRrsA");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $fRrsA.isFeatureEnabledForBoundary;
    }
});

var $fRmiy = parcelRequire("fRmiy");
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $fRmiy.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $fRmiy.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $fRmiy.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});
parcelRegister("fRrsA", function(module, exports) {
"use strict";
var $b8c11b469b84bf0e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $b8c11b469b84bf0e$var$sdk_data_json_1 = $b8c11b469b84bf0e$var$__importDefault((parcelRequire("dRsBn")));
const $b8c11b469b84bf0e$var$aemEnvironmentBlockData = $b8c11b469b84bf0e$var$sdk_data_json_1.default;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $b8c11b469b84bf0e$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $b8c11b469b84bf0e$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $b8c11b469b84bf0e$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $b8c11b469b84bf0e$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($b8c11b469b84bf0e$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $b8c11b469b84bf0e$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[boundaryKey] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $b8c11b469b84bf0e$var$isFeatureEnabledForBoundary;
function $b8c11b469b84bf0e$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $b8c11b469b84bf0e$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[boundaryKey] === true;
}

});
parcelRegister("dRsBn", function(module, exports) {
module.exports = JSON.parse("{\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-product\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-api-token-controls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-app-requests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-app-updates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-audit-log\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-backup-and-restore\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-billing-console\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-byok\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-contacts\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-management\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-residency\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-help\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-llm\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-org-create\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-product-insights\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-product-links\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-saml-sso\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-sandbox\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-site-rename\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-system-health\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-use-available-apps\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-user-counts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"assets\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"assets-data-manager\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"assets-recent-items\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"assets-reports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"atlassian-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"bitbucket\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"bitbucket-slack-app\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"pipelines\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"chat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"compass\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ccma\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-anonymous-access\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-company-hub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-content-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-content-manager\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-databases\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-editing-experience\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-editor-offline-storage\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-employee-directory\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-invitations\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-loom-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-mission-control\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-mobile-app\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-ms-teams-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-page-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-presenter-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-public-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-questions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-search\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-server\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-slack-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-slides\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-smart-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-space-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-team-calendars\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-whiteboards\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"customer-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"dx\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"env-manager-testing-product\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":false,\"fedramp-moderate\":false},\"features\":{\"env-manager-testing-feature\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":false,\"fedramp-moderate\":false}}}},\"focus\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"goals\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"guard-standard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"home\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"home-status-backend\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"jira\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"jcma-x2c\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jcma\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-apps-menu\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-audit-log\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-backlogs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-boards-and-views\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-calendar-view\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-components\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-forms\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-github-for-jira\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-github-workflows\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-in-product-help\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-insights\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-issue\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-loom-banner\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-mobile-app\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-oasis-reports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-opsgenie\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-plans\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-project-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-project-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-releases\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-share\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-site-optimiser\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-slack\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-smart-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-team-managed-projects\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-workflow-configuration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"jira-align\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-ai-ops\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-ai-services\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-approvals\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-automation-playbook\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-boysenberry\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-canned-responses\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-change-calendar\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-change-risk-assessment\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-chat-ops\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-chat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-cloud-megatron\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-csat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-email-requests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-entity-migration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-forms\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-help-center-change-password\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center-password-login\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-incident-conference-calls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-issue\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-journey-builder\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-queues\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-related-issues\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-reports-operations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-request-intake\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-services\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-shield\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-sla-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-surveys\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"opsgenie\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"loom\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"projects\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-projects\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"rovo-dev\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"statuspage\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"studio\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"talent\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"teams\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"teams-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"teams-third-party-invites\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"trello\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"anti-abuse-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"application-tunnels\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"atlassian-cli\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"central-ai\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ai-3p-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"ai-safety\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"collaboration-graph\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"gen-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"knowledge-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"knowledge-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"machine-learning-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"user-recommendations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"collaboration-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"commerce-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"commerce-platform-self-serve\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"customer-data-lake\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ecosystem-oauth\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"forge-cli\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-remote-capabilities\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-system-apps\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":false,\"fedramp-moderate\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"block-service\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"real-time-presence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"experience-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"bxp-signup\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"identity\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"identity-mail-proxy\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"identity-virality\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"marketplace\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"data-center-to-agc\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"migration-link-fixing\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"migrations-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"brie\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"media-migration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"navigation\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"navigation-home-entry-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":false,\"fedramp-moderate\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"notification-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"notifications-fpn-link\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"post-office\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"product-integrations-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"search\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"search-townsquare-tab\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"smartlinks\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"user-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-graphql-gateway\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-platform-deployer\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-branches\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"automation-platform-conditions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"automation-platform-event-processing\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-frontend\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-triggers\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"aws-cloud-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"bifrost\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"cell-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"cloud-security\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"compliance-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"consent-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"consenthub\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"core-network-automation\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"core-network-automation-cna-theia\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"cross-gateway\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-classification-governance-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-exchange-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"aqui\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"eureka\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"kamino\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"shipyard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"topic-osb\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"data-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ers-import\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"ers\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"sql\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"data-platform-services\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-telemetry-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"decisions-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"detection-and-response-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"edge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"edge-cloudfront\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"encryption-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"cryptor\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"environment-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"flight-deck-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"golden-ami\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-data-lake\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-edge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-edge-httpbin\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"job-execution-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"kitt-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"media-cdn-delivery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"messaging-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"observability-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"pollinator\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"provisioning\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"secrets\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"security-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"service-to-service-fabric\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"sliver\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"staff-authentication-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"targeting-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"flock\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"tenant-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"tenant-platform-tenant-data-destroyer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"vdi\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"workplace-technology-solutions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}}}}");

});


parcelRegister("fRmiy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];

});




parcelRegister("4KnCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $0562f90e25deef6e$export$2e2bcd8739ae039);

var $j3vbx = parcelRequire("j3vbx");
const $0562f90e25deef6e$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $0562f90e25deef6e$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($0562f90e25deef6e$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$0562f90e25deef6e$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$0562f90e25deef6e$export$7bc189309d2ad463] = new (0, $j3vbx.default)();
                interactionSessionTracking = window[$0562f90e25deef6e$export$7bc189309d2ad463];
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error initialising InteractionSessionTracking - ${error instanceof Error ? error.message : String(error)}`);
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("j3vbx", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", () => $0e2787f17cfbed40$export$5d4c4eab0863aae3);
$parcel$export(module.exports, "default", () => $0e2787f17cfbed40$export$2e2bcd8739ae039);

var $ehX2F = parcelRequire("ehX2F");
// WARNING: The value of INTERACTION_SESSION_ID_STORAGE_KEY will be used by Analytics Web Client to attach the session ID to events.
// If you change this, you will need to update the Analytics Web Client code as well.
const $0e2787f17cfbed40$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $0e2787f17cfbed40$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $0e2787f17cfbed40$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $0e2787f17cfbed40$export$285f6bddd927a06d = 1800000; // 30 minutes
const $0e2787f17cfbed40$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $0e2787f17cfbed40$export$a92e915d70316eb2 = 5000; // 5 seconds
const $0e2787f17cfbed40$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $0e2787f17cfbed40$var$INTEGER_REGEX = /^\d+$/;
const $0e2787f17cfbed40$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $0e2787f17cfbed40$export$2e2bcd8739ae039 {
    constructor(){
        this.analyticsReady = false;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($0e2787f17cfbed40$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($0e2787f17cfbed40$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($0e2787f17cfbed40$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($0e2787f17cfbed40$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($0e2787f17cfbed40$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $0e2787f17cfbed40$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $0e2787f17cfbed40$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $0e2787f17cfbed40$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $ehX2F.default)();
    }
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Error retrieving interaction session ID - ${err instanceof Error ? err.message : String(err)}`);
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($0e2787f17cfbed40$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($0e2787f17cfbed40$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($0e2787f17cfbed40$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($0e2787f17cfbed40$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($0e2787f17cfbed40$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $0e2787f17cfbed40$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $0e2787f17cfbed40$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($0e2787f17cfbed40$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($0e2787f17cfbed40$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
   * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
   *
   * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
   * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
   *
   * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
   */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("ehX2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $3141576f2bcb7b0d$export$2e2bcd8739ae039);

var $l4s77 = parcelRequire("l4s77");

var $aN3I3 = parcelRequire("aN3I3");
class $3141576f2bcb7b0d$export$2e2bcd8739ae039 extends (0, $aN3I3.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $l4s77.default);
        } catch (err) {
            storageToUse = (0, $l4s77.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("l4s77", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d7baf707b667ff0$export$2e2bcd8739ae039);
class $3d7baf707b667ff0$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $3d7baf707b667ff0$var$inmemorystorage = new $3d7baf707b667ff0$export$90e3e001bcac59c7();
var $3d7baf707b667ff0$export$2e2bcd8739ae039 = $3d7baf707b667ff0$var$inmemorystorage;

});

parcelRegister("aN3I3", function(module, exports) {
$parcel$export(module.exports, "default", () => $db644ce02f894414$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $l4s77 = parcelRequire("l4s77");
const $db644ce02f894414$export$41c06fdd37b7e9a5 = 'awc';
const $db644ce02f894414$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $db644ce02f894414$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function $db644ce02f894414$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $db644ce02f894414$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $l4s77.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ($db644ce02f894414$export$48c17662a6902497(window[$db644ce02f894414$export$770aa8bc07b3de03])) inMemoryStorage = window[$db644ce02f894414$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $l4s77.default);
                if (!window[$db644ce02f894414$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$db644ce02f894414$export$770aa8bc07b3de03] = (0, $l4s77.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($db644ce02f894414$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== "prod") prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ($db644ce02f894414$export$48c17662a6902497(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});





parcelRegister("6Q0K1", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $a8a5646d02ded1e2$export$81d16f1428ce0486);
$parcel$export(module.exports, "generateUrlWithParams", () => $a8a5646d02ded1e2$export$2e3999ec51334ffe);
const $a8a5646d02ded1e2$export$81d16f1428ce0486 = 'xpis';
const $a8a5646d02ded1e2$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    const urlObj = new URL(url);
    urlObj.searchParams.set($a8a5646d02ded1e2$export$81d16f1428ce0486, paramValueEncoded);
    return urlObj.toString();
};

});

parcelRegister("70Wq6", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $22c780d7822f7abb$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $22c780d7822f7abb$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];

});

parcelRegister("cRyar", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $6f63a21b6d10baaa$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $6f63a21b6d10baaa$export$2e2bcd8739ae039);

var $57GLV = parcelRequire("57GLV");

var $h6xpv = parcelRequire("h6xpv");
const $6f63a21b6d10baaa$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $6f63a21b6d10baaa$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $6f63a21b6d10baaa$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $57GLV.parseUrl)(removedFragmentURL);
    const captureParams = (0, $h6xpv.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $h6xpv.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $57GLV.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $6f63a21b6d10baaa$export$2e2bcd8739ae039 = $6f63a21b6d10baaa$var$urlParamExtractor;

});
parcelRegister("57GLV", function(module, exports) {
$parcel$export(module.exports, "extract", () => $3baec8cd6b6eae24$export$f9380c9a627682d3, (v) => $3baec8cd6b6eae24$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $3baec8cd6b6eae24$export$98e6a39c04603d36, (v) => $3baec8cd6b6eae24$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $3baec8cd6b6eae24$export$fac44ee5b035f737, (v) => $3baec8cd6b6eae24$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $3baec8cd6b6eae24$export$7a5253c0f62e0150, (v) => $3baec8cd6b6eae24$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $3baec8cd6b6eae24$export$a8c1621ea79325d3, (v) => $3baec8cd6b6eae24$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $3baec8cd6b6eae24$export$357523c63a2253b9, (v) => $3baec8cd6b6eae24$export$357523c63a2253b9 = v);
var $3baec8cd6b6eae24$export$f9380c9a627682d3;
var $3baec8cd6b6eae24$export$98e6a39c04603d36;
var $3baec8cd6b6eae24$export$fac44ee5b035f737;
var $3baec8cd6b6eae24$export$7a5253c0f62e0150;
var $3baec8cd6b6eae24$export$a8c1621ea79325d3;
var $3baec8cd6b6eae24$export$357523c63a2253b9;
var $3baec8cd6b6eae24$export$44c361b8ec72ef7f;
'use strict';

var $1EjKD = parcelRequire("1EjKD");

var $2CzF2 = parcelRequire("2CzF2");

var $1UjEq = parcelRequire("1UjEq");

var $fSLA5 = parcelRequire("fSLA5");
const $3baec8cd6b6eae24$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $3baec8cd6b6eae24$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $3baec8cd6b6eae24$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3baec8cd6b6eae24$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $3baec8cd6b6eae24$var$encode(key, options),
                            '[',
                            $3baec8cd6b6eae24$var$encode(index, options),
                            ']=',
                            $3baec8cd6b6eae24$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3baec8cd6b6eae24$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $3baec8cd6b6eae24$var$encode(key, options),
                            '[]=',
                            $3baec8cd6b6eae24$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3baec8cd6b6eae24$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $3baec8cd6b6eae24$var$encode(key, options),
                            ':list=',
                            $3baec8cd6b6eae24$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $3baec8cd6b6eae24$var$encode(key, options),
                                keyValueSep,
                                $3baec8cd6b6eae24$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $3baec8cd6b6eae24$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $3baec8cd6b6eae24$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3baec8cd6b6eae24$var$encode(key, options),
                            '=',
                            $3baec8cd6b6eae24$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $3baec8cd6b6eae24$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $3baec8cd6b6eae24$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3baec8cd6b6eae24$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3baec8cd6b6eae24$var$decode(item, options)) : value === null ? value : $3baec8cd6b6eae24$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $3baec8cd6b6eae24$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3baec8cd6b6eae24$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3baec8cd6b6eae24$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $3baec8cd6b6eae24$var$encode(value, options) {
    if (options.encode) return options.strict ? $1EjKD(value) : encodeURIComponent(value);
    return value;
}
function $3baec8cd6b6eae24$var$decode(value, options) {
    if (options.decode) return $2CzF2(value);
    return value;
}
function $3baec8cd6b6eae24$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $3baec8cd6b6eae24$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3baec8cd6b6eae24$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3baec8cd6b6eae24$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3baec8cd6b6eae24$var$extract(input) {
    input = $3baec8cd6b6eae24$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $3baec8cd6b6eae24$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $3baec8cd6b6eae24$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3baec8cd6b6eae24$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3baec8cd6b6eae24$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $1UjEq(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $3baec8cd6b6eae24$var$decode(value, options);
        formatter($3baec8cd6b6eae24$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $3baec8cd6b6eae24$var$parseValue(value[k], options);
        else ret[key] = $3baec8cd6b6eae24$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3baec8cd6b6eae24$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3baec8cd6b6eae24$export$f9380c9a627682d3 = $3baec8cd6b6eae24$var$extract;
$3baec8cd6b6eae24$export$98e6a39c04603d36 = $3baec8cd6b6eae24$var$parse;
$3baec8cd6b6eae24$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $3baec8cd6b6eae24$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3baec8cd6b6eae24$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $3baec8cd6b6eae24$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $3baec8cd6b6eae24$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $3baec8cd6b6eae24$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $3baec8cd6b6eae24$var$encode(key, options) + '=' + $3baec8cd6b6eae24$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$3baec8cd6b6eae24$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $1UjEq(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $3baec8cd6b6eae24$var$parse($3baec8cd6b6eae24$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3baec8cd6b6eae24$var$decode(hash, options)
    } : {});
};
$3baec8cd6b6eae24$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$3baec8cd6b6eae24$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $3baec8cd6b6eae24$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $3baec8cd6b6eae24$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3baec8cd6b6eae24$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3baec8cd6b6eae24$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3baec8cd6b6eae24$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$3baec8cd6b6eae24$var$encodeFragmentIdentifier] ? $3baec8cd6b6eae24$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$3baec8cd6b6eae24$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$3baec8cd6b6eae24$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $3baec8cd6b6eae24$export$7a5253c0f62e0150(input, options);
    return $3baec8cd6b6eae24$export$a8c1621ea79325d3({
        url: url,
        query: $fSLA5(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3baec8cd6b6eae24$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3baec8cd6b6eae24$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("1EjKD", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("2CzF2", function(module, exports) {
'use strict';
var $1e8acae71a01788b$var$token = '%[a-f0-9]{2}';
var $1e8acae71a01788b$var$singleMatcher = new RegExp('(' + $1e8acae71a01788b$var$token + ')|([^%]+?)', 'gi');
var $1e8acae71a01788b$var$multiMatcher = new RegExp('(' + $1e8acae71a01788b$var$token + ')+', 'gi');
function $1e8acae71a01788b$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $1e8acae71a01788b$var$decodeComponents(left), $1e8acae71a01788b$var$decodeComponents(right));
}
function $1e8acae71a01788b$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($1e8acae71a01788b$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $1e8acae71a01788b$var$decodeComponents(tokens, i).join('');
            tokens = input.match($1e8acae71a01788b$var$singleMatcher) || [];
        }
        return input;
    }
}
function $1e8acae71a01788b$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $1e8acae71a01788b$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $1e8acae71a01788b$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $1e8acae71a01788b$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $1e8acae71a01788b$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("1UjEq", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("fSLA5", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("h6xpv", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $db0a64e47904dff4$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $db0a64e47904dff4$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $db0a64e47904dff4$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $db0a64e47904dff4$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $db0a64e47904dff4$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $db0a64e47904dff4$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $db0a64e47904dff4$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $db0a64e47904dff4$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $db0a64e47904dff4$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $db0a64e47904dff4$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $db0a64e47904dff4$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $db0a64e47904dff4$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $db0a64e47904dff4$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$db0a64e47904dff4$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $db0a64e47904dff4$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("d3qqy", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $6bf9c571f35f5766$export$f56713ced121eb91);
$parcel$export(module.exports, "isThirdParty", () => $6bf9c571f35f5766$export$ab34f90cc32c8960);

var $b5UnP = parcelRequire("b5UnP");
const $6bf9c571f35f5766$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $b5UnP.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $6bf9c571f35f5766$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $b5UnP.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("3nWZx", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $348077d8b4dafdd0$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $348077d8b4dafdd0$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $348077d8b4dafdd0$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $348077d8b4dafdd0$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $348077d8b4dafdd0$export$7bf451af4a8e3dd9);

var $b5UnP = parcelRequire("b5UnP");

var $9BFq7 = parcelRequire("9BFq7");
const $348077d8b4dafdd0$var$libraryVersion = undefined;
function $348077d8b4dafdd0$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $348077d8b4dafdd0$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $348077d8b4dafdd0$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $348077d8b4dafdd0$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $348077d8b4dafdd0$var$buildAliases(aliases) {
    if ($348077d8b4dafdd0$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $348077d8b4dafdd0$var$buildGroups(groups) {
    if ($348077d8b4dafdd0$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $348077d8b4dafdd0$var$buildEventOverrides(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}
function $348077d8b4dafdd0$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $348077d8b4dafdd0$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $348077d8b4dafdd0$var$getProductField(productInfo.env, overrides.env);
    const product = $348077d8b4dafdd0$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $348077d8b4dafdd0$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $348077d8b4dafdd0$var$getProductField(productInfo.version, overrides.version);
    const origin = $348077d8b4dafdd0$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $348077d8b4dafdd0$var$getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic
    };
}
function $348077d8b4dafdd0$var$isNotEmptyObject(obj) {
    return (0, $9BFq7.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $348077d8b4dafdd0$var$buildAttributesWithName(name, attrObject) {
    return $348077d8b4dafdd0$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $348077d8b4dafdd0$var$buildAttributes(attributes) {
    return $348077d8b4dafdd0$var$buildAttributesWithName('attributes', attributes);
}
function $348077d8b4dafdd0$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $348077d8b4dafdd0$export$f045f238d77c002a(containers) {
    if ($348077d8b4dafdd0$var$isNotEmptyObject(containers)) {
        const validContainers = $348077d8b4dafdd0$export$3f5115a568819c1a(containers);
        return $348077d8b4dafdd0$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $348077d8b4dafdd0$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$348077d8b4dafdd0$export$f045f238d77c002a(event.containers)
    };
}
function $348077d8b4dafdd0$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $348077d8b4dafdd0$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $348077d8b4dafdd0$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $348077d8b4dafdd0$var$buildProductFields(productInfo);
    const tenantFields = $348077d8b4dafdd0$var$buildTenantFields(tenantInfo);
    const userFields = $348077d8b4dafdd0$var$buildUserFields(userInfo);
    const orgFields = $348077d8b4dafdd0$var$buildOrgFields(orgInfo);
    const workspaceFields = $348077d8b4dafdd0$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $b5UnP.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$348077d8b4dafdd0$var$buildAttributes(attributes),
        ...$348077d8b4dafdd0$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$348077d8b4dafdd0$export$f045f238d77c002a(containers),
        ...$348077d8b4dafdd0$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$348077d8b4dafdd0$var$buildAliases(aliases),
        ...$348077d8b4dafdd0$var$buildGroups(groups)
    };
}
function $348077d8b4dafdd0$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $348077d8b4dafdd0$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $348077d8b4dafdd0$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $348077d8b4dafdd0$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $348077d8b4dafdd0$var$libraryVersion
            },
            validationMode: $348077d8b4dafdd0$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $348077d8b4dafdd0$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $348077d8b4dafdd0$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $348077d8b4dafdd0$var$buildProductFields(productInfo, $348077d8b4dafdd0$export$e3d99b4bfec06f6e(event));
    const tenantFields = $348077d8b4dafdd0$var$buildTenantFields(tenantInfo);
    const orgFields = $348077d8b4dafdd0$var$buildOrgFields(orgInfo);
    const workspaceFields = $348077d8b4dafdd0$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $348077d8b4dafdd0$var$buildUserFields(userInfo);
    const actionFields = $348077d8b4dafdd0$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$348077d8b4dafdd0$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$348077d8b4dafdd0$var$buildAliases(aliases),
        ...$348077d8b4dafdd0$var$buildGroups(groups)
    };
}

});
parcelRegister("9BFq7", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $d8589642faf2df0c$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $d8589642faf2df0c$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $d8589642faf2df0c$var$isObjectObject(o) {
    return $d8589642faf2df0c$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $d8589642faf2df0c$export$53b83ca8eaab0383(o) {
    if ($d8589642faf2df0c$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($d8589642faf2df0c$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("cxJpC", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b739a600d0c163f$export$2e2bcd8739ae039);

var $jeZC8 = parcelRequire("jeZC8");

var $2SRj9 = parcelRequire("2SRj9");

var $cyGJs = parcelRequire("cyGJs");
class $6b739a600d0c163f$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $jeZC8.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $jeZC8.MAX_DELAY_TIMEOUT)) : (0, $jeZC8.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $cyGJs.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $cyGJs.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $2SRj9.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("jeZC8", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $8c21201229ed64f1$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $8c21201229ed64f1$export$8575e30be0feb909);
const $8c21201229ed64f1$export$cf090d5281b5ae06 = 10000;
const $8c21201229ed64f1$export$8575e30be0feb909 = 30000;

});

parcelRegister("2SRj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b2ca78db66542af$export$2e2bcd8739ae039);

var $3nWZx = parcelRequire("3nWZx");

var $h6xpv = parcelRequire("h6xpv");

var $4gboc = parcelRequire("4gboc");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $8b2ca78db66542af$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $8b2ca78db66542af$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $8b2ca78db66542af$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $8b2ca78db66542af$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $8b2ca78db66542af$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $h6xpv.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $h6xpv.equals)(group.userInfo, args.userInfo) && (0, $h6xpv.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $3nWZx.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $4gboc.default)(compressionRules);
    }
}

});
parcelRegister("4gboc", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebcec0a5b1d57d7b$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $3nWZx = parcelRequire("3nWZx");

var $h6xpv = parcelRequire("h6xpv");

var $eMukt = parcelRequire("eMukt");
class $ebcec0a5b1d57d7b$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $3nWZx.buildActionFields)(event, event.eventType);
                    contextFields = (0, $h6xpv.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $h6xpv.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $eMukt.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("eMukt", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $4f8659a53a8ed121$export$89b3253ddfd2e6e8);

var $iY4qk = parcelRequire("iY4qk");

var $h6xpv = parcelRequire("h6xpv");
class $4f8659a53a8ed121$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
   * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
   * @param event
   * @returns {boolean}
   */ this.canCompress = (event)=>{
            try {
                return event && (0, $iY4qk.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
   * This function compresses as many events in the given collection as possible.<p>
   * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
   * appended to the end of the resulting array.
   *
   * @param events A collection of analytic events to compress
   * @returns {Array.<Object>} The action fields for the resulting compressed events
   */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $h6xpv.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $iY4qk.validateActionEventType)(event.eventType);
                (0, $iY4qk.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("iY4qk", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $cc027e75166d51fd$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $cc027e75166d51fd$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $cc027e75166d51fd$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $cc027e75166d51fd$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $cc027e75166d51fd$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $cc027e75166d51fd$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateUIEvent", () => $cc027e75166d51fd$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $cc027e75166d51fd$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $cc027e75166d51fd$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $cc027e75166d51fd$export$801b46c35394d316);

var $b5UnP = parcelRequire("b5UnP");

var $9BFq7 = parcelRequire("9BFq7");
const $cc027e75166d51fd$var$actionEventTypes = Object.freeze([
    (0, $b5UnP.eventType).OPERATIONAL,
    (0, $b5UnP.eventType).TRACK,
    (0, $b5UnP.eventType).UI
]);
function $cc027e75166d51fd$export$df8ff30e3c960006(container) {
    if (!(0, $9BFq7.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $cc027e75166d51fd$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$cc027e75166d51fd$export$df8ff30e3c960006(container));
}
function $cc027e75166d51fd$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $b5UnP.eventType).OPERATIONAL:
        case (0, $b5UnP.eventType).TRACK:
        case (0, $b5UnP.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $cc027e75166d51fd$export$4a8d7476662aebcc(type) {
    if (!$cc027e75166d51fd$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$cc027e75166d51fd$var$actionEventTypes}]`);
    return true;
}
function $cc027e75166d51fd$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $cc027e75166d51fd$export$e63ea5d8477971d3(event.containers);
}
function $cc027e75166d51fd$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $cc027e75166d51fd$export$8c014fd74b0c8b99(event) {
    $cc027e75166d51fd$export$e0c121325c66ed4c(event);
}
function $cc027e75166d51fd$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $cc027e75166d51fd$export$e5bac0930c812e90(event) {
    $cc027e75166d51fd$export$e0c121325c66ed4c(event);
}
function $cc027e75166d51fd$export$1e561554275607ef(event) {
    $cc027e75166d51fd$export$e0c121325c66ed4c(event);
}
function $cc027e75166d51fd$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $b5UnP.isType)((0, $b5UnP.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $b5UnP.objectValues)((0, $b5UnP.userType))}]`);
}
function $cc027e75166d51fd$export$801b46c35394d316(productInfo) {
    if (!(0, $b5UnP.isType)((0, $b5UnP.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $b5UnP.objectValues)((0, $b5UnP.platformType))}]`);
    if (productInfo.origin === (0, $b5UnP.originType).DESKTOP && !(0, $b5UnP.isType)((0, $b5UnP.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $b5UnP.originType).WEB && !(0, $b5UnP.isType)((0, $b5UnP.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("cyGJs", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $867e9a586ba95eb5$export$fa6e3729c21cb8f);
var $867e9a586ba95eb5$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("XV4tF", function(module, exports) {
$parcel$export(module.exports, "default", () => $50b4b5c92ba2cb54$export$2e2bcd8739ae039);

var $4QdEf = parcelRequire("4QdEf");

var $ijfv7 = parcelRequire("ijfv7");

var $60DSr = parcelRequire("60DSr");

var $1A0O5 = parcelRequire("1A0O5");

var $agXqE = parcelRequire("agXqE");

var $bVZFJ = parcelRequire("bVZFJ");

var $6okOp = parcelRequire("6okOp");

var $KDfuk = parcelRequire("KDfuk");

var $gW0rc = parcelRequire("gW0rc");

var $iyhUf = parcelRequire("iyhUf");
class $50b4b5c92ba2cb54$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $50b4b5c92ba2cb54$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $50b4b5c92ba2cb54$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $50b4b5c92ba2cb54$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $50b4b5c92ba2cb54$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $50b4b5c92ba2cb54$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $50b4b5c92ba2cb54$export$2e2bcd8739ae039 {
    constructor(options){
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            var _this$lastSendEventsE, _this$metadataClient;
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: ((_this$lastSendEventsE = this.lastSendEventsError) === null || _this$lastSendEventsE === void 0 ? void 0 : _this$lastSendEventsE.message) || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                metadataClientMetrics: ((_this$metadataClient = this.metadataClient) === null || _this$metadataClient === void 0 ? void 0 : _this$metadataClient.metrics) || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                var _this$originTracingCl;
                const response = await (0, $6okOp.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                (_this$originTracingCl = this.originTracingClient) === null || _this$originTracingCl === void 0 || _this$originTracingCl.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $KDfuk.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $KDfuk.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $KDfuk.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $KDfuk.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        var _this$options;
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $agXqE.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $gW0rc.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $ijfv7.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $4QdEf.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $KDfuk.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $KDfuk.SegmentEventTypes).TRACK,
            properties: (0, $iyhUf.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $KDfuk.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $KDfuk.SegmentEventTypes).PAGE,
            properties: (0, $iyhUf.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $KDfuk.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $KDfuk.SegmentEventTypes).IDENTIFY,
            traits: (0, $iyhUf.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $iyhUf.prepareEventContext)(context);
        const segmentContext = (0, $iyhUf.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $60DSr.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        var _msg$context;
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = (_msg$context = msg.context) === null || _msg$context === void 0 ? void 0 : _msg$context.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo !== null && metadataInfo !== void 0 && metadataInfo.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                var _responseObject$messa;
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $50b4b5c92ba2cb54$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $50b4b5c92ba2cb54$var$Message(((_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.error) || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $50b4b5c92ba2cb54$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $1A0O5.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $50b4b5c92ba2cb54$var$BatchInterceptor {
    static #_ = this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $50b4b5c92ba2cb54$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $50b4b5c92ba2cb54$export$133650fcdde1b226(success, statusCode, (0, $bVZFJ.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $bVZFJ.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $bVZFJ.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $bVZFJ.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $50b4b5c92ba2cb54$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $50b4b5c92ba2cb54$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error !== void 0 && error.message) {
            const match = error.message.match($50b4b5c92ba2cb54$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $50b4b5c92ba2cb54$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $50b4b5c92ba2cb54$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $50b4b5c92ba2cb54$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $50b4b5c92ba2cb54$export$133650fcdde1b226(false, -1, (0, $bVZFJ.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("4QdEf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e76fb55f78e0e662$export$2e2bcd8739ae039);

var $6EmnW = parcelRequire("6EmnW");

var $e76fb55f78e0e662$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $6EmnW.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("6EmnW", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $8773ab9bb6b63e69$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $8773ab9bb6b63e69$export$2e2bcd8739ae039);

var $6nWiP = parcelRequire("6nWiP");
var $iTVv0 = parcelRequire("iTVv0");

var $9raMI = parcelRequire("9raMI");
var $5KJlh = parcelRequire("5KJlh");
var $3xJjY = parcelRequire("3xJjY");

var $ijfv7 = parcelRequire("ijfv7");

var $8gAb7 = parcelRequire("8gAb7");

var $5ab7Y = parcelRequire("5ab7Y");
var $i1sOA = parcelRequire("i1sOA");

var $gvwff = parcelRequire("gvwff");
const $8773ab9bb6b63e69$var$ONE_MINUTE = 60000;
const $8773ab9bb6b63e69$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $8773ab9bb6b63e69$var$ONE_MINUTE,
    minRetryDelay: $8773ab9bb6b63e69$var$ONE_MINUTE,
    maxRetryDelay: $8773ab9bb6b63e69$var$ONE_MINUTE
};
const $8773ab9bb6b63e69$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $8773ab9bb6b63e69$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $5KJlh.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $8773ab9bb6b63e69$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $5ab7Y.default)({
            ...this.options,
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $5ab7Y.default)({
            ...$8773ab9bb6b63e69$var$LONG_POLLING_OPTIONS,
            waitInterval: $8773ab9bb6b63e69$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $ijfv7.default)();
        this.networkStatus = new (0, $8gAb7.default)((status)=>{
            if (status === (0, $gvwff.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $3xJjY.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $gvwff.NetworkStatusEnum).OFFLINE) {
            done((0, $i1sOA.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $9raMI.CallbackProcessingErrorName)) {
                done((0, $i1sOA.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $6nWiP.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $iTVv0.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $3xJjY.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $i1sOA.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $i1sOA.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $i1sOA.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $8773ab9bb6b63e69$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $8773ab9bb6b63e69$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $8773ab9bb6b63e69$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $8773ab9bb6b63e69$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $8773ab9bb6b63e69$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $8773ab9bb6b63e69$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $8773ab9bb6b63e69$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $8773ab9bb6b63e69$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $8773ab9bb6b63e69$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("6nWiP", function(module, exports) {
$parcel$export(module.exports, "default", () => $7efc2f1a5bde9b88$export$2e2bcd8739ae039);

var $6RVOU = parcelRequire("6RVOU");

var $iKcjR = parcelRequire("iKcjR");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $7efc2f1a5bde9b88$var$validSuffixs = Object.values((0, $6RVOU.LocalStorageKeySuffix));
var $7efc2f1a5bde9b88$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $7efc2f1a5bde9b88$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $6RVOU.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $iKcjR.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("6RVOU", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $14fd78d3e0c5d571$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $14fd78d3e0c5d571$export$8bb2c1fb2b1765a9);
var $14fd78d3e0c5d571$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $14fd78d3e0c5d571$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("iKcjR", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $10436b888b156198$export$8433d54f767cbec5);

var $6RVOU = parcelRequire("6RVOU");
const $10436b888b156198$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $6RVOU.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $6RVOU.LocalStorageKeySuffix).ACK}`,
        [(0, $6RVOU.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $6RVOU.LocalStorageKeySuffix).QUEUE}`,
        [(0, $6RVOU.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $6RVOU.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $6RVOU.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $6RVOU.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $6RVOU.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $6RVOU.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("iTVv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $71ffa9a602538aa6$export$2e2bcd8739ae039);

var $60DSr = parcelRequire("60DSr");

var $6RVOU = parcelRequire("6RVOU");

var $iKcjR = parcelRequire("iKcjR");
const $71ffa9a602538aa6$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $71ffa9a602538aa6$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $6RVOU.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $6RVOU.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $71ffa9a602538aa6$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $71ffa9a602538aa6$var$promisedSetTimeout((0, $6RVOU.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $6RVOU.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $71ffa9a602538aa6$var$promisedSetTimeout((0, $6RVOU.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $6RVOU.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $71ffa9a602538aa6$var$reclaim(options, callback);
};
const $71ffa9a602538aa6$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $71ffa9a602538aa6$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $71ffa9a602538aa6$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $71ffa9a602538aa6$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $71ffa9a602538aa6$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $60DSr.default)();
    const queuesToReclaim = $71ffa9a602538aa6$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$71ffa9a602538aa6$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $iKcjR.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("60DSr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca06976e9dc78dc6$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $ca06976e9dc78dc6$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("9raMI", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $acf10679a119f6de$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $acf10679a119f6de$export$2e2bcd8739ae039);
const $acf10679a119f6de$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $acf10679a119f6de$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $acf10679a119f6de$export$2e2bcd8739ae039.prototype);
        this.name = $acf10679a119f6de$export$a409c8de90e11e14;
    }
}

});

parcelRegister("5KJlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $600697c23432d0ad$export$2e2bcd8739ae039);

var $2xMdx = parcelRequire("2xMdx");

var $3xJjY = parcelRequire("3xJjY");

var $9raMI = parcelRequire("9raMI");
var $600697c23432d0ad$export$2e2bcd8739ae039 = (0, $2xMdx.default);

});
parcelRegister("2xMdx", function(module, exports) {
$parcel$export(module.exports, "default", () => $633f2b57d8f952f4$export$2e2bcd8739ae039);

var $3xJjY = parcelRequire("3xJjY");

var $710cM = parcelRequire("710cM");
var $gJ51N = parcelRequire("gJ51N");

var $kV5b8 = parcelRequire("kV5b8");

var $a504Y = parcelRequire("a504Y");

var $hafKT = parcelRequire("hafKT");
class $633f2b57d8f952f4$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $hafKT.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $kV5b8.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $710cM.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $a504Y.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $3xJjY.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $3xJjY.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $gJ51N.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $3xJjY.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $a504Y.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $3xJjY.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("3xJjY", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $878c149215788aa2$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $878c149215788aa2$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $878c149215788aa2$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $878c149215788aa2$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $878c149215788aa2$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $878c149215788aa2$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $878c149215788aa2$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $878c149215788aa2$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $878c149215788aa2$export$7710d69e6f450f20);
const $878c149215788aa2$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $878c149215788aa2$export$8cad224051643259 = 'analytics-web-client';
const $878c149215788aa2$export$3d8420be07b276ab = 'analytics-resilience';
const $878c149215788aa2$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $878c149215788aa2$export$89d9c1ff8ac91862 = 'timeAdded';
const $878c149215788aa2$export$a37d385bcd713809 = 'retryAttempts';
const $878c149215788aa2$export$6d8635fed0e4b14d = 15000;
var $878c149215788aa2$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $878c149215788aa2$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("710cM", function(module, exports) {
$parcel$export(module.exports, "default", () => $26f2602dfea2973e$export$2e2bcd8739ae039);
const $26f2602dfea2973e$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $26f2602dfea2973e$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $26f2602dfea2973e$export$2e2bcd8739ae039.prototype);
        this.name = $26f2602dfea2973e$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("gJ51N", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $f8a2352c2d2f66be$export$74101021e0969375);

var $iJ43v = parcelRequire("iJ43v");

var $9raMI = parcelRequire("9raMI");

var $6WMsS = parcelRequire("6WMsS");
const $f8a2352c2d2f66be$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $iJ43v.AbandonWriteErrorName) || errorWithName.name === (0, $9raMI.CallbackProcessingErrorName) || errorWithName.name === (0, $6WMsS.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("iJ43v", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $54b00117c4e65cb5$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $54b00117c4e65cb5$export$2e2bcd8739ae039);
const $54b00117c4e65cb5$export$ba95206613c96b28 = 'AbandonWriteError';
class $54b00117c4e65cb5$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $54b00117c4e65cb5$export$2e2bcd8739ae039.prototype);
        this.name = $54b00117c4e65cb5$export$ba95206613c96b28;
    }
}

});

parcelRegister("6WMsS", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $a8a749be6d3b2770$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $a8a749be6d3b2770$export$2e2bcd8739ae039);
const $a8a749be6d3b2770$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $a8a749be6d3b2770$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $a8a749be6d3b2770$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("kV5b8", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c4fe37a3a4fb796$export$2e2bcd8739ae039);

var $3xJjY = parcelRequire("3xJjY");

var $3oBJL = parcelRequire("3oBJL");

var $9raMI = parcelRequire("9raMI");
var $6WMsS = parcelRequire("6WMsS");
var $710cM = parcelRequire("710cM");
var $gJ51N = parcelRequire("gJ51N");

var $3HkY8 = parcelRequire("3HkY8");

var $hafKT = parcelRequire("hafKT");
class $6c4fe37a3a4fb796$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $710cM.default)());
                    }, (0, $3xJjY.INDEXEDDB_TIMEOUT));
                    /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $3xJjY.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $3xJjY.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $3xJjY.TIME_TO_PROCESS_AFTER_INDEX), (0, $3xJjY.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $3xJjY.RETRY_INDEX), (0, $3xJjY.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $3xJjY.TIME_ADDED_INDEX), (0, $3xJjY.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $3xJjY.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $710cM.default)());
                    };
                    try {
                        await (0, $hafKT.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $710cM.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $710cM.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $3xJjY.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $hafKT.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $3xJjY.GuardPolicy).IGNORE) throw new (0, $6WMsS.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $gJ51N.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $3xJjY.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $hafKT.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $gJ51N.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $3oBJL.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $3oBJL.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $3xJjY.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $3oBJL.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $hafKT.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $hafKT.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $hafKT.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $hafKT.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $3xJjY.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $hafKT.requestToPromise)(request);
            await (0, $hafKT.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $3oBJL.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $9raMI.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $hafKT.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $3xJjY.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $3xJjY.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $hafKT.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $710cM.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $3HkY8.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $3xJjY.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("3oBJL", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $654b66b953aacc03$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $654b66b953aacc03$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $654b66b953aacc03$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $654b66b953aacc03$export$1188664dfff364c8);
const $654b66b953aacc03$export$b6df3d334cec060f = 7;
const $654b66b953aacc03$export$14ef152a03a4b6ee = 60000;
const $654b66b953aacc03$export$da9ab7b2fd5998e8 = 10;
const $654b66b953aacc03$export$1188664dfff364c8 = 8000;

});

parcelRegister("3HkY8", function(module, exports) {
$parcel$export(module.exports, "default", () => $340bfdcf07acd917$export$2e2bcd8739ae039);

var $3xJjY = parcelRequire("3xJjY");

var $iJ43v = parcelRequire("iJ43v");

var $hafKT = parcelRequire("hafKT");
class $340bfdcf07acd917$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
   * This query fetches the oldest events currently stored in AWC IndexedDb object store
   * and deletes them sequentially
   */ this.deleteOldestNEvents = async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $3xJjY.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $hafKT.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $3xJjY.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $3xJjY.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $3xJjY.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $3xJjY.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $hafKT.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $hafKT.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $iJ43v.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $3xJjY.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $hafKT.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("hafKT", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $eb0fcd6b59fd659f$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $eb0fcd6b59fd659f$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $eb0fcd6b59fd659f$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $eb0fcd6b59fd659f$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $eb0fcd6b59fd659f$export$342d941b6f724995);

var $60DSr = parcelRequire("60DSr");

var $3oBJL = parcelRequire("3oBJL");
const $eb0fcd6b59fd659f$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $60DSr.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $eb0fcd6b59fd659f$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $3oBJL.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $3oBJL.EVENT_COUNT_LIMIT)
    });
const $eb0fcd6b59fd659f$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $eb0fcd6b59fd659f$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $eb0fcd6b59fd659f$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $eb0fcd6b59fd659f$export$2a5213bce1720b42(transaction);
};
const $eb0fcd6b59fd659f$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("a504Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $97cc815f7f067f9b$export$2e2bcd8739ae039);

var $3xJjY = parcelRequire("3xJjY");

var $3oBJL = parcelRequire("3oBJL");

var $9raMI = parcelRequire("9raMI");
var $6WMsS = parcelRequire("6WMsS");

var $dP2I0 = parcelRequire("dP2I0");

var $hafKT = parcelRequire("hafKT");
class $97cc815f7f067f9b$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $hafKT.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $dP2I0.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $3xJjY.GuardPolicy).ABANDON) {
        if (policy === (0, $3xJjY.GuardPolicy).IGNORE) throw new (0, $6WMsS.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $hafKT.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $3xJjY.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $hafKT.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $3xJjY.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $3oBJL.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $3oBJL.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $3oBJL.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $3oBJL.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $9raMI.default)(error);
        }
    }
    storeType() {
        return (0, $3xJjY.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("dP2I0", function(module, exports) {
$parcel$export(module.exports, "default", () => $724acc9b10d8bc8a$export$2e2bcd8739ae039);

var $3xJjY = parcelRequire("3xJjY");

var $iJ43v = parcelRequire("iJ43v");
class $724acc9b10d8bc8a$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
   * Unlike IndexedDb, we cannot take advantage of any index. So we are,
   * treating the memory store as a sorted set when adding items.
   */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $3xJjY.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $3xJjY.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $3xJjY.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $iJ43v.default)((0, $3xJjY.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("ijfv7", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cf3161395aab397$export$2e2bcd8739ae039);

var $gvwff = parcelRequire("gvwff");
class $2cf3161395aab397$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $gvwff.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $2cf3161395aab397$var$cachedMetricsClient = null;
var $2cf3161395aab397$export$2e2bcd8739ae039 = ()=>{
    if (!$2cf3161395aab397$var$cachedMetricsClient) $2cf3161395aab397$var$cachedMetricsClient = new $2cf3161395aab397$export$4b62ee5120ab50a8();
    return $2cf3161395aab397$var$cachedMetricsClient;
};

});
parcelRegister("gvwff", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $abab93e266b77ce2$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $abab93e266b77ce2$export$ee138fa712d11b84);
var $abab93e266b77ce2$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $abab93e266b77ce2$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("8gAb7", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b437a7a86bd5eeb$export$2e2bcd8739ae039);

var $gvwff = parcelRequire("gvwff");
class $9b437a7a86bd5eeb$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $gvwff.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $gvwff.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $gvwff.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $gvwff.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $gvwff.NetworkStatusEnum).ONLINE;
        return (0, $gvwff.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("5ab7Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $58c1699b188611fb$export$2e2bcd8739ae039);

var $cxYn7 = parcelRequire("cxYn7");

var $i1sOA = parcelRequire("i1sOA");
const $58c1699b188611fb$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $58c1699b188611fb$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $58c1699b188611fb$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $i1sOA.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $i1sOA.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $cxYn7.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $i1sOA.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $58c1699b188611fb$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $58c1699b188611fb$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $58c1699b188611fb$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $58c1699b188611fb$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $58c1699b188611fb$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $58c1699b188611fb$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $cxYn7.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("cxYn7", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $ed0cbb965ccc1aa1$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $ed0cbb965ccc1aa1$export$590a718599f8f8b3);
var $ed0cbb965ccc1aa1$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $ed0cbb965ccc1aa1$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $ed0cbb965ccc1aa1$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("i1sOA", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $e6166e6c9df35fcc$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $e6166e6c9df35fcc$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("1A0O5", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $04520535a3626137$export$c21270cab66ab290);

var $KDfuk = parcelRequire("KDfuk");
function $04520535a3626137$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $KDfuk.SegmentEventTypes).PAGE || item.msg.type === (0, $KDfuk.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $KDfuk.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $04520535a3626137$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$04520535a3626137$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("KDfuk", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $f0205c56f03802ea$export$a63e16b3351b8c36);
$parcel$export(module.exports, "FetchError", () => $f0205c56f03802ea$export$26e841bcf1aeb894);
$parcel$export(module.exports, "SegmentEventTypes", () => $f0205c56f03802ea$export$ddf929981dc6feb3);
$parcel$export(module.exports, "MetadataResponse", () => $f0205c56f03802ea$export$4b1a5e5486cc0d80);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $f0205c56f03802ea$export$96f086dcf574a9e2);
class $f0205c56f03802ea$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $f0205c56f03802ea$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
var $f0205c56f03802ea$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $f0205c56f03802ea$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $f0205c56f03802ea$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $f0205c56f03802ea$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
        return new $f0205c56f03802ea$export$4b1a5e5486cc0d80((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
    }
}
class $f0205c56f03802ea$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $f0205c56f03802ea$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});


parcelRegister("agXqE", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $fb0ad1718c210a63$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $fb0ad1718c210a63$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $fb0ad1718c210a63$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $fb0ad1718c210a63$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $fb0ad1718c210a63$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $fb0ad1718c210a63$export$6f1c008dd0c3b67e);
const $fb0ad1718c210a63$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $fb0ad1718c210a63$export$8fddcd1eff390364 = 60000; // 60 seconds
const $fb0ad1718c210a63$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $fb0ad1718c210a63$export$6649d5c857717efe = 5000; // 5 seconds
const $fb0ad1718c210a63$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $fb0ad1718c210a63$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("bVZFJ", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $825a39858cdd84b0$export$ba118f9de1e5ac63);
const $825a39858cdd84b0$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("6okOp", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $ec5bb473886717c8$export$8e8f0180c1b41fad);

var $hXXvg = parcelRequire("hXXvg");

var $KDfuk = parcelRequire("KDfuk");
const $ec5bb473886717c8$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $ec5bb473886717c8$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $ec5bb473886717c8$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status !== 200) throw new (0, $KDfuk.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch  {}
    throw new (0, $KDfuk.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $ec5bb473886717c8$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $ec5bb473886717c8$var$getCorsForUrl = (0, $hXXvg.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("hXXvg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1461a75e2840225$export$2e2bcd8739ae039);
var $d1461a75e2840225$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $d1461a75e2840225$var$isEqual(first, second) {
    if (first === second) return true;
    if ($d1461a75e2840225$var$safeIsNaN(first) && $d1461a75e2840225$var$safeIsNaN(second)) return true;
    return false;
}
function $d1461a75e2840225$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$d1461a75e2840225$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $d1461a75e2840225$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $d1461a75e2840225$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("gW0rc", function(module, exports) {
$parcel$export(module.exports, "default", () => $54a7728a365539b5$export$2e2bcd8739ae039);

var $knQOQ = parcelRequire("knQOQ");

var $11p2W = parcelRequire("11p2W");
var $ge6br = parcelRequire("ge6br");

var $dCmkF = parcelRequire("dCmkF");

var $60DSr = parcelRequire("60DSr");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $54a7728a365539b5$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $54a7728a365539b5$var$SAFE = 'SAFE';
const $54a7728a365539b5$var$UNSAFE = 'UNSAFE';
const $54a7728a365539b5$var$NOT_FOUND = 'NOT_FOUND';
const $54a7728a365539b5$var$COOKIE = 'COOKIE';
const $54a7728a365539b5$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $54a7728a365539b5$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $dCmkF.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $ge6br.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $11p2W.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $11p2W.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $54a7728a365539b5$var$LOCAL_STORAGE ? this.store.getItem((0, $11p2W.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $11p2W.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $54a7728a365539b5$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $54a7728a365539b5$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $54a7728a365539b5$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($54a7728a365539b5$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $knQOQ.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $54a7728a365539b5$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $54a7728a365539b5$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $54a7728a365539b5$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $54a7728a365539b5$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($54a7728a365539b5$var$COOKIE);
        switch(cookieValue.type){
            case $54a7728a365539b5$var$SAFE:
            case $54a7728a365539b5$var$UNSAFE:
                this.store.setItem((0, $11p2W.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $54a7728a365539b5$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $60DSr.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("knQOQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed6eed6692b2d9f0$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $3vObA = parcelRequire("3vObA");

var $vJNuT = parcelRequire("vJNuT");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $ed6eed6692b2d9f0$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $ed6eed6692b2d9f0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $vJNuT.default)(2, arguments);
    var dateLeft = (0, $bNvBk.default)(dirtyDateLeft);
    var dateRight = (0, $bNvBk.default)(dirtyDateRight);
    var sign = $ed6eed6692b2d9f0$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $3vObA.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($ed6eed6692b2d9f0$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("bNvBk", function(module, exports) {
$parcel$export(module.exports, "default", () => $896cc89b7c465a0d$export$2e2bcd8739ae039);

var $1Vgto = parcelRequire("1Vgto");

var $vJNuT = parcelRequire("vJNuT");
function $896cc89b7c465a0d$export$2e2bcd8739ae039(argument) {
    (0, $vJNuT.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $1Vgto.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("1Vgto", function(module, exports) {
$parcel$export(module.exports, "default", () => $1667e48aff1a514e$export$2e2bcd8739ae039);
function $1667e48aff1a514e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1667e48aff1a514e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1667e48aff1a514e$export$2e2bcd8739ae039(o);
}

});

parcelRegister("vJNuT", function(module, exports) {
$parcel$export(module.exports, "default", () => $05f66bc37faa9bc1$export$2e2bcd8739ae039);
function $05f66bc37faa9bc1$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("3vObA", function(module, exports) {
$parcel$export(module.exports, "default", () => $28eb3236505b7290$export$2e2bcd8739ae039);

var $7idWn = parcelRequire("7idWn");

var $3IpnE = parcelRequire("3IpnE");

var $vJNuT = parcelRequire("vJNuT");
var $28eb3236505b7290$var$MILLISECONDS_IN_DAY = 86400000;
function $28eb3236505b7290$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $vJNuT.default)(2, arguments);
    var startOfDayLeft = (0, $3IpnE.default)(dirtyDateLeft);
    var startOfDayRight = (0, $3IpnE.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $7idWn.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $7idWn.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $28eb3236505b7290$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("7idWn", function(module, exports) {
$parcel$export(module.exports, "default", () => $54f50721f2dd469b$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $54f50721f2dd469b$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("3IpnE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b492b2bc7d568f2$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");
function $2b492b2bc7d568f2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $vJNuT.default)(1, arguments);
    var date = (0, $bNvBk.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("11p2W", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $8d59640ac86d7a83$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $8d59640ac86d7a83$export$d4cb17942ea57c95);
var $8d59640ac86d7a83$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $8d59640ac86d7a83$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $8d59640ac86d7a83$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $8d59640ac86d7a83$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $8d59640ac86d7a83$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $8d59640ac86d7a83$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $8d59640ac86d7a83$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $8d59640ac86d7a83$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $8d59640ac86d7a83$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $8d59640ac86d7a83$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("ge6br", function(module, exports) {
$parcel$export(module.exports, "default", () => $42c76c4db3e4c1a9$export$2e2bcd8739ae039);

var $8Bt4H = parcelRequire("8Bt4H");

var $11p2W = parcelRequire("11p2W");

var $haV83 = parcelRequire("haV83");

var $fUGK5 = parcelRequire("fUGK5");
class $42c76c4db3e4c1a9$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $fUGK5.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))) : new (0, $haV83.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $11p2W.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $11p2W.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $11p2W.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $fUGK5.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $11p2W.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $11p2W.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $11p2W.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $11p2W.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("8Bt4H", function(module, exports) {
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("haV83", function(module, exports) {
$parcel$export(module.exports, "default", () => $8722d548a7987d4c$export$2e2bcd8739ae039);

var $dCmkF = parcelRequire("dCmkF");
class $8722d548a7987d4c$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $dCmkF.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("dCmkF", function(module, exports) {
$parcel$export(module.exports, "default", () => $48af838b09fba9ab$export$2e2bcd8739ae039);

var $420kQ = parcelRequire("420kQ");

var $aQuD9 = parcelRequire("aQuD9");
class $48af838b09fba9ab$export$2e2bcd8739ae039 extends (0, $aQuD9.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.localStorage || (0, $420kQ.default);
        } catch (err) {
            storageToUse = (0, $420kQ.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("420kQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $601ea3956b3706cc$export$2e2bcd8739ae039);
class $601ea3956b3706cc$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $601ea3956b3706cc$var$inmemorystorage = new $601ea3956b3706cc$export$90e3e001bcac59c7();
var $601ea3956b3706cc$export$2e2bcd8739ae039 = $601ea3956b3706cc$var$inmemorystorage;

});

parcelRegister("aQuD9", function(module, exports) {
$parcel$export(module.exports, "default", () => $1614ed2483aa580c$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $b5UnP = parcelRequire("b5UnP");

var $420kQ = parcelRequire("420kQ");
const $1614ed2483aa580c$export$41c06fdd37b7e9a5 = 'awc';
const $1614ed2483aa580c$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $1614ed2483aa580c$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $1614ed2483aa580c$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $420kQ.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($1614ed2483aa580c$export$48c17662a6902497(globalThis[$1614ed2483aa580c$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$1614ed2483aa580c$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $420kQ.default);
                if (!globalThis[$1614ed2483aa580c$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$1614ed2483aa580c$export$770aa8bc07b3de03] = (0, $420kQ.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($1614ed2483aa580c$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $b5UnP.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($1614ed2483aa580c$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("fUGK5", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $16056afe1d6af4c1$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $16056afe1d6af4c1$export$de6821eed3d5f32d);

var $8Bt4H = parcelRequire("8Bt4H");

var $hXXvg = parcelRequire("hXXvg");

var $11p2W = parcelRequire("11p2W");
const $16056afe1d6af4c1$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $16056afe1d6af4c1$export$eb80e1beaa8dacf8 = (0, $11p2W.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $16056afe1d6af4c1$export$19164982d36535d8 = 'tld_test';
const $16056afe1d6af4c1$export$de6821eed3d5f32d = (0, $hXXvg.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).set($16056afe1d6af4c1$export$eb80e1beaa8dacf8, $16056afe1d6af4c1$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).get($16056afe1d6af4c1$export$eb80e1beaa8dacf8) === $16056afe1d6af4c1$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).remove($16056afe1d6af4c1$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("iyhUf", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $b12a389685b7fead$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventContext", () => $b12a389685b7fead$export$6b26e26d40264200);
$parcel$export(module.exports, "prepareEventProperties", () => $b12a389685b7fead$export$44d22e5fb02cc68e);
// @ts-ignore

var $9Wshd = parcelRequire("9Wshd");
const $b12a389685b7fead$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = {
        ...context.context,
        userAgent: navigator.userAgent
    };
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides !== null && overrides !== void 0 && overrides.excludedProperties) result.excludedProperties = {
        ...result.excludedProperties,
        ...$b12a389685b7fead$var$nestedRemoveUndefinedValues(overrides.excludedProperties, '$.excludedProperties')
    };
    if (overrides !== null && overrides !== void 0 && overrides.userConsents) result.userConsents = {
        ...result.userConsents,
        ...$b12a389685b7fead$var$nestedRemoveUndefinedValues(overrides.userConsents, '$.userConsents')
    };
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $b12a389685b7fead$var$removeFalseyProperties(result.excludedProperties);
    return result;
};
const $b12a389685b7fead$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = $b12a389685b7fead$var$nestedRemoveUndefinedValues(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Wshd)))(propertiesWithoutUndefined);
};
const $b12a389685b7fead$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $b12a389685b7fead$var$nestedRemoveUndefinedValues(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Wshd)))(propertiesWithoutUndefined);
};
// Shallow removal of all falsey properties from an object, returning a new object.
const $b12a389685b7fead$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
// This function will essentially deepClone as well
const $b12a389685b7fead$var$nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});
parcelRegister("9Wshd", function(module, exports) {
'use strict';

var $fSxZ7 = parcelRequire("fSxZ7");
/**
 * Expose `traverse`.
 */ module.exports = $73cf76f9b95aa746$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $73cf76f9b95aa746$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $73cf76f9b95aa746$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $73cf76f9b95aa746$var$traverseArray(input, strict);
    else if ($fSxZ7.is(input, strict)) return $fSxZ7.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $73cf76f9b95aa746$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $73cf76f9b95aa746$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $73cf76f9b95aa746$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $73cf76f9b95aa746$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("fSxZ7", function(module, exports) {
$parcel$export(module.exports, "parse", () => $b8f642d3a256caa2$export$98e6a39c04603d36, (v) => $b8f642d3a256caa2$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $b8f642d3a256caa2$export$226b3eccf92c9ed9, (v) => $b8f642d3a256caa2$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $b8f642d3a256caa2$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $b8f642d3a256caa2$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $b8f642d3a256caa2$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$b8f642d3a256caa2$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $b8f642d3a256caa2$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$b8f642d3a256caa2$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $b8f642d3a256caa2$var$matcher.test(string);
};

});




parcelRegister("2uxKZ", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $3aded16725ca1ecf$export$1ac223ae496131c9);

var $8gAb7 = parcelRequire("8gAb7");

var $6EmnW = parcelRequire("6EmnW");

var $5ab7Y = parcelRequire("5ab7Y");
var $i1sOA = parcelRequire("i1sOA");

var $gvwff = parcelRequire("gvwff");

var $1jkuR = parcelRequire("1jkuR");

var $aePKi = parcelRequire("aePKi");

var $agXqE = parcelRequire("agXqE");

var $lxd9k = parcelRequire("lxd9k");

var $KDfuk = parcelRequire("KDfuk");
class $3aded16725ca1ecf$export$1ac223ae496131c9 {
    static #_ = this.INITIAL_REFRESH_DELAY = 1;
    static #_2 = this.Factory = (apiHostProtocol, apiHost, product)=>{
        return new $3aded16725ca1ecf$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
    };
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $1jkuR.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $agXqE.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $agXqE.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $5ab7Y.default)({
            ...this._options,
            waitInterval: (0, $agXqE.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $3aded16725ca1ecf$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        var _this$_fetchAbortCont;
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        (_this$_fetchAbortCont = this._fetchAbortController) === null || _this$_fetchAbortCont === void 0 || _this$_fetchAbortCont.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $8gAb7.default)((status)=>{
            if (status === (0, $gvwff.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        var _this$_fetchAbortCont2;
        if ((0, $aePKi.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        (_this$_fetchAbortCont2 = this._fetchAbortController) === null || _this$_fetchAbortCont2 === void 0 || _this$_fetchAbortCont2.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $lxd9k.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $agXqE.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $KDfuk.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $KDfuk.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $KDfuk.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        var _this$_userInfo, _this$_userInfo2;
        if (((_this$_userInfo = this._userInfo) === null || _this$_userInfo === void 0 ? void 0 : _this$_userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : _this$_userInfo2.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        var _this$_tenantInfo, _this$_tenantInfo2;
        if (((_this$_tenantInfo = this._tenantInfo) === null || _this$_tenantInfo === void 0 ? void 0 : _this$_tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this$_tenantInfo2 = this._tenantInfo) === null || _this$_tenantInfo2 === void 0 ? void 0 : _this$_tenantInfo2.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        var _this$_networkStatus;
        if (((_this$_networkStatus = this._networkStatus) === null || _this$_networkStatus === void 0 ? void 0 : _this$_networkStatus.getNetworkStatus()) === (0, $gvwff.NetworkStatusEnum).OFFLINE) {
            done((0, $i1sOA.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $i1sOA.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch  {
            done((0, $i1sOA.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $agXqE.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, $6EmnW.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, $6EmnW.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, $6EmnW.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, $6EmnW.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("1jkuR", function(module, exports) {
$parcel$export(module.exports, "selectHost", () => $0281551ea20028c2$export$18c0b81944902eae);
$parcel$export(module.exports, "isStargateProxyPath", () => $0281551ea20028c2$export$83a9dd8d74be72c);

var $b5UnP = parcelRequire("b5UnP");
const $0281551ea20028c2$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $0281551ea20028c2$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $0281551ea20028c2$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $0281551ea20028c2$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $0281551ea20028c2$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $0281551ea20028c2$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $0281551ea20028c2$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $0281551ea20028c2$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $0281551ea20028c2$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
 * Returns the full Stargate proxy URL (host + proxy path) for the current host.
 *
 * This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
 * and Oasis IC environments. Using the first-party proxy works around browser
 * restrictions with third-party cookies.
 *
 * In non-browser environments (e.g. SSR) where `window` is not defined, the host
 * portion is omitted and the function returns only `STARGATE_PROXY_PATH`
 * (i.e. `/gateway/api/gasv3/api/v1`).
 */ function $0281551ea20028c2$var$stargateProxyUrl() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $0281551ea20028c2$export$5df9262e102d0c32;
}
const $0281551ea20028c2$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $b5UnP.envType).LOCAL || env === (0, $b5UnP.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $b5UnP.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $b5UnP.envType).PROD ? $0281551ea20028c2$var$FEDRAMP_PROD_HOST : $0281551ea20028c2$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $b5UnP.envType).PROD ? $0281551ea20028c2$var$STARGATE_FEDRAMP_PROD_HOST : $0281551ea20028c2$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $0281551ea20028c2$var$stargateProxyUrl();
};
const $0281551ea20028c2$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $b5UnP.envType).PROD ? $0281551ea20028c2$var$PROD_HOST : $0281551ea20028c2$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $b5UnP.envType).PROD ? $0281551ea20028c2$var$STARGATE_PROD_HOST : $0281551ea20028c2$var$STARGATE_STAGING_HOST;
    return $0281551ea20028c2$var$stargateProxyUrl();
};
function $0281551ea20028c2$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $0281551ea20028c2$var$stargateProxyUrl();
    }
    if (perimeter === (0, $b5UnP.perimeterType).FEDRAMP_MODERATE) return $0281551ea20028c2$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $0281551ea20028c2$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $0281551ea20028c2$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === $0281551ea20028c2$var$stargateProxyUrl();
}

});

parcelRegister("aePKi", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $8136a1787e433fad$export$44b578549c42d779);
class $8136a1787e433fad$export$44b578549c42d779 {
    static #_ = this.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    static #_2 = this.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    static #_3 = this.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    static #_4 = this.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($8136a1787e433fad$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($8136a1787e433fad$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($8136a1787e433fad$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($8136a1787e433fad$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}

});

parcelRegister("lxd9k", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $815dcf837efd75f8$export$55b0d0261469055);

var $hXXvg = parcelRequire("hXXvg");

var $KDfuk = parcelRequire("KDfuk");
const $815dcf837efd75f8$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
    const requestAbortController = $815dcf837efd75f8$var$createRequestAbortController(timeout, signal);
    const corsOptions = $815dcf837efd75f8$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ''}`,
        userIdType: `${((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ''}`,
        tenantId: `${((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ''}`,
        tenantIdType: `${((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $KDfuk.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $815dcf837efd75f8$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 || signal.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $815dcf837efd75f8$var$getCorsForUrl = (0, $hXXvg.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});


parcelRegister("3I45y", function(module, exports) {
$parcel$export(module.exports, "default", () => $2af8a09300ce70cf$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $b5UnP = parcelRequire("b5UnP");

var $cRyar = parcelRequire("cRyar");
class $2af8a09300ce70cf$export$2e2bcd8739ae039 {
    static #_ = this.messageEvent = 'origin landed';
    constructor(){
        this.pendingCleanup = null;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $b5UnP.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = (0, $e6Qdr.fg)('puma-1542-preserve-origin-params') ? ()=>{} : historyReplaceFn;
            const capturedURLParams = (0, $cRyar.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            // Store cleanup function internally if we captured any params
            if ((0, $e6Qdr.fg)('puma-1542-preserve-origin-params')) {
                if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                    (0, $cRyar.default)(isCaptureParam, historyReplaceFn);
                };
            }
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if ((0, $e6Qdr.fg)('puma-1542-preserve-origin-params')) {
                if (this.pendingCleanup) {
                    const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $2af8a09300ce70cf$export$2e2bcd8739ae039.messageEvent);
                    if (hasOriginLanded) this._cleanupOriginParams();
                }
            }
        } catch  {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}

});

parcelRegister("kcuea", function(module, exports) {
$parcel$export(module.exports, "default", () => $19bfa0eac7e5b6bd$export$2e2bcd8739ae039);

var $dCmkF = parcelRequire("dCmkF");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $19bfa0eac7e5b6bd$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $19bfa0eac7e5b6bd$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $19bfa0eac7e5b6bd$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $19bfa0eac7e5b6bd$export$285f6bddd927a06d = 1800000; // 30 minutes
const $19bfa0eac7e5b6bd$export$a92e915d70316eb2 = 5000; // 5 seconds
const $19bfa0eac7e5b6bd$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $19bfa0eac7e5b6bd$export$5702a91a6f42969f = ()=>{};
class $19bfa0eac7e5b6bd$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($19bfa0eac7e5b6bd$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($19bfa0eac7e5b6bd$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $19bfa0eac7e5b6bd$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $19bfa0eac7e5b6bd$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $19bfa0eac7e5b6bd$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $19bfa0eac7e5b6bd$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $dCmkF.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($19bfa0eac7e5b6bd$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($19bfa0eac7e5b6bd$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$19bfa0eac7e5b6bd$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("j8ShH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eed5bfa0736b4df$export$2e2bcd8739ae039);

var $420kQ = parcelRequire("420kQ");

var $aQuD9 = parcelRequire("aQuD9");
class $2eed5bfa0736b4df$export$2e2bcd8739ae039 extends (0, $aQuD9.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.sessionStorage || (0, $420kQ.default);
        } catch (err) {
            storageToUse = (0, $420kQ.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("inrzB", function(module, exports) {
$parcel$export(module.exports, "default", () => $31e94ecb9538b1b9$export$2e2bcd8739ae039);

var $j8ShH = parcelRequire("j8ShH");

var $60DSr = parcelRequire("60DSr");
const $31e94ecb9538b1b9$var$STORAGE_KEY = 'tab.id';
class $31e94ecb9538b1b9$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, $60DSr.default)();
            this._safeSessionStorage.setItem($31e94ecb9538b1b9$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $j8ShH.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($31e94ecb9538b1b9$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("gey9z", function(module, exports) {
$parcel$export(module.exports, "default", () => $f69a36fb2a4ad340$export$2e2bcd8739ae039);

var $57GLV = parcelRequire("57GLV");

var $b5UnP = parcelRequire("b5UnP");

var $h6xpv = parcelRequire("h6xpv");

var $j8ShH = parcelRequire("j8ShH");

var $cRyar = parcelRequire("cRyar");

var $60DSr = parcelRequire("60DSr");
const $f69a36fb2a4ad340$var$STORAGE_KEY = 'taskSessions';
const $f69a36fb2a4ad340$var$INIT_KEY = 'taskSessionsInit';
const $f69a36fb2a4ad340$var$AWC_PARAM_PREFIX = 'awc.';
const $f69a36fb2a4ad340$var$TASK_SESSION_RELOAD_TIME = 3000;
class $f69a36fb2a4ad340$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($f69a36fb2a4ad340$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($f69a36fb2a4ad340$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($f69a36fb2a4ad340$var$INIT_KEY) || '0', 10) < currentTimestamp - $f69a36fb2a4ad340$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($f69a36fb2a4ad340$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($f69a36fb2a4ad340$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($f69a36fb2a4ad340$var$STORAGE_KEY) || '');
            } catch  {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($f69a36fb2a4ad340$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch  {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, $60DSr.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $57GLV.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $h6xpv.pick)(currentState, includedTaskSessions) : (0, $h6xpv.omit)(currentState, Object.values((0, $b5UnP.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $h6xpv.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$f69a36fb2a4ad340$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $57GLV.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $h6xpv.mapKeys)((0, $cRyar.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $j8ShH.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($f69a36fb2a4ad340$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
}

});

parcelRegister("hjija", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9b9c11a413a9b35$export$2e2bcd8739ae039);

var $8Bt4H = parcelRequire("8Bt4H");

var $11p2W = parcelRequire("11p2W");

var $aePKi = parcelRequire("aePKi");
const $c9b9c11a413a9b35$var$MAX_CACHE_SIZE = 100;
const $c9b9c11a413a9b35$var$COOKIE_NAME = (0, $11p2W.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $c9b9c11a413a9b35$var$DEBUG_TAG = 'synthetic';
class $c9b9c11a413a9b35$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $c9b9c11a413a9b35$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $c9b9c11a413a9b35$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($c9b9c11a413a9b35$var$DEBUG_TAG)) event.tags.push($c9b9c11a413a9b35$var$DEBUG_TAG);
        } else event.tags = [
            $c9b9c11a413a9b35$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $aePKi.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).get($c9b9c11a413a9b35$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).remove($c9b9c11a413a9b35$var$COOKIE_NAME);
        }
        return false;
    }
}
var $c9b9c11a413a9b35$export$2e2bcd8739ae039 = $c9b9c11a413a9b35$var$TestingCache;

});

parcelRegister("hk0S5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1abd47680795fdbd$export$2e2bcd8739ae039);

var $b5UnP = parcelRequire("b5UnP");

var $f8EaS = parcelRequire("f8EaS");

var $dCmkF = parcelRequire("dCmkF");
const $1abd47680795fdbd$var$DEFAULT_DELAY = 2000; // 2 seconds
const $1abd47680795fdbd$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $1abd47680795fdbd$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $1abd47680795fdbd$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $1abd47680795fdbd$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($1abd47680795fdbd$var$SendEventDecision || {});
class $1abd47680795fdbd$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this.signalUserActive = ()=>{
            this._sendUserActiveEvents();
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch  {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._handleDwellTimerTriggered = ()=>{
            const document = (0, $f8EaS.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        };
        this._sendUserActiveEvents = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case 3:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 1:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $b5UnP.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
                return 2;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
            return 4;
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $1abd47680795fdbd$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $1abd47680795fdbd$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $1abd47680795fdbd$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $1abd47680795fdbd$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $dCmkF.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("f8EaS", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $f8113e823931e6a3$export$f65ca476c09acec0);
const $f8113e823931e6a3$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("fEM2b", function(module, exports) {
$parcel$export(module.exports, "default", () => $437644a9d4e5c783$export$2e2bcd8739ae039);
function $437644a9d4e5c783$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("5K6mD", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $80464b98dbd7e595$export$fbe53bbbe682bcdd);

var $9lLNZ = parcelRequire("9lLNZ");
const $80464b98dbd7e595$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $9lLNZ.createTimeoutXid)()), (0, $9lLNZ.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $9lLNZ.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("9lLNZ", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $ecf690687914f488$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $ecf690687914f488$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $ecf690687914f488$export$fa341d0c750d705b);

var $dKCSD = parcelRequire("dKCSD");
const $ecf690687914f488$export$545bcbd53afabfa3 = 5000;
const $ecf690687914f488$export$af4087e36d63846 = ()=>[
        {
            type: (0, $dKCSD.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $dKCSD.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $ecf690687914f488$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $dKCSD.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $dKCSD.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("dKCSD", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $6f42341cf1f1d797$export$92ca0438bcb0d396);
var $6f42341cf1f1d797$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $6f42341cf1f1d797$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("1We2B", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.23';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution, see: https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            var index = -1, length = path.length;
            if (!length) return true;
            var isRootPrimitive = object == null || typeof object !== 'object' && typeof object !== 'function';
            while(++index < length){
                var key = path[index];
                // skip non-string keys (e.g., Symbols, numbers)
                if (typeof key !== 'string') continue;
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block "constructor.prototype" chains
                if (key === 'constructor' && index + 1 < length && typeof path[index + 1] === 'string' && path[index + 1] === 'prototype') {
                    // Allow ONLY when the path starts at a primitive root, e.g., _.unset(0, 'constructor.prototype.a')
                    if (isRootPrimitive && index === 0) continue;
                    return false;
                }
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("17wqU", function(module, exports) {
$parcel$export(module.exports, "SCREEN", () => $e5ea67e5857aa6d8$export$f636b5b56f1d624a);
$parcel$export(module.exports, "MODAL", () => $e5ea67e5857aa6d8$export$1171103ea9083ffa);
$parcel$export(module.exports, "INLINE_DIALOG", () => $e5ea67e5857aa6d8$export$cae2783c9279926);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $e5ea67e5857aa6d8$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $e5ea67e5857aa6d8$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $e5ea67e5857aa6d8$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $e5ea67e5857aa6d8$export$12346a674644c156);
$parcel$export(module.exports, "ANALYTICS_BRIDGE_CHANNEL", () => $e5ea67e5857aa6d8$export$2ceccf177fae277c);
const $e5ea67e5857aa6d8$export$f636b5b56f1d624a = 'Screen';
const $e5ea67e5857aa6d8$export$9d2de6eebf7462b5 = 'Drawer';
const $e5ea67e5857aa6d8$export$1171103ea9083ffa = 'Modal';
const $e5ea67e5857aa6d8$export$cae2783c9279926 = 'InlineDialog';
const $e5ea67e5857aa6d8$export$d1123261ca8831d2 = 'Dropdown';
const $e5ea67e5857aa6d8$export$a1562d08625f5d7e = 'UI';
const $e5ea67e5857aa6d8$export$947dac6c72b26f81 = 'TRACK';
const $e5ea67e5857aa6d8$export$f1d537d508d2945a = 'SCREEN';
const $e5ea67e5857aa6d8$export$12346a674644c156 = 'OPERATIONAL';
const $e5ea67e5857aa6d8$export$2ceccf177fae277c = 'analyticsBridge';

});

parcelRegister("8hleO", function(module, exports) {
$parcel$export(module.exports, "extractAWCDataFromEvent", () => $e9ba8379fd920382$export$1c850cf68c053906);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $6uLHU = parcelRequire("6uLHU");

var $ljlVI = parcelRequire("ljlVI");

var $17wqU = parcelRequire("17wqU");

var $7ioXG = parcelRequire("7ioXG");
const $e9ba8379fd920382$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $7ioXG.getAnalyticsType)(castedEvent);
    const attributes = (0, $7ioXG.getAttributes)(castedEvent);
    const source = (0, $7ioXG.getSource)(castedEvent);
    const actionSubject = (0, $7ioXG.getActionSubject)(castedEvent);
    if (analyticsType === (0, $17wqU.SCREEN_EVENT_TYPE)) return {
        type: (0, $17wqU.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $17wqU.UI_EVENT_TYPE:
        case 0, $17wqU.TRACK_EVENT_TYPE:
        case 0, $17wqU.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $7ioXG.getAction)(castedEvent);
                const actionSubjectId = (0, $7ioXG.getActionSubjectId)(castedEvent);
                const containerId = (0, $7ioXG.getContainerId)(castedEvent);
                const containerType = (0, $7ioXG.getContainerType)(castedEvent);
                const objectId = (0, $7ioXG.getObjectId)(castedEvent);
                const objectType = (0, $7ioXG.getObjectType)(castedEvent);
                const tags = (0, $7ioXG.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($ljlVI)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uLHU))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("6uLHU", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $4baa8d0eb0187e90$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $4baa8d0eb0187e90$var$isUndefined;

});

parcelRegister("ljlVI", function(module, exports) {

var $2b4jE = parcelRequire("2b4jE");

var $3ZHd7 = parcelRequire("3ZHd7");

var $bFQKe = parcelRequire("bFQKe");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $f83c6220c9ec116d$var$omitBy(object, predicate) {
    return $bFQKe(object, $3ZHd7($2b4jE(predicate)));
}
module.exports = $f83c6220c9ec116d$var$omitBy;

});
parcelRegister("2b4jE", function(module, exports) {

var $awc8i = parcelRequire("awc8i");

var $bXbMc = parcelRequire("bXbMc");

var $3uvNM = parcelRequire("3uvNM");

var $u1Zdx = parcelRequire("u1Zdx");

var $aK0IP = parcelRequire("aK0IP");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $195ff4e99eee651b$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $3uvNM;
    if (typeof value == 'object') return $u1Zdx(value) ? $bXbMc(value[0], value[1]) : $awc8i(value);
    return $aK0IP(value);
}
module.exports = $195ff4e99eee651b$var$baseIteratee;

});
parcelRegister("awc8i", function(module, exports) {

var $6DGSm = parcelRequire("6DGSm");

var $fqBKL = parcelRequire("fqBKL");

var $kIsAr = parcelRequire("kIsAr");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $7a864dda933dbd36$var$baseMatches(source) {
    var matchData = $fqBKL(source);
    if (matchData.length == 1 && matchData[0][2]) return $kIsAr(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $6DGSm(object, source, matchData);
    };
}
module.exports = $7a864dda933dbd36$var$baseMatches;

});
parcelRegister("6DGSm", function(module, exports) {

var $h0gnZ = parcelRequire("h0gnZ");

var $lrTfh = parcelRequire("lrTfh");
/** Used to compose bitmasks for value comparisons. */ var $4d57a4d5445ae24a$var$COMPARE_PARTIAL_FLAG = 1, $4d57a4d5445ae24a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $4d57a4d5445ae24a$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $h0gnZ;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $lrTfh(srcValue, objValue, $4d57a4d5445ae24a$var$COMPARE_PARTIAL_FLAG | $4d57a4d5445ae24a$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $4d57a4d5445ae24a$var$baseIsMatch;

});
parcelRegister("h0gnZ", function(module, exports) {

var $7QPwU = parcelRequire("7QPwU");

var $1sOyM = parcelRequire("1sOyM");

var $2PqjU = parcelRequire("2PqjU");

var $aaJNa = parcelRequire("aaJNa");

var $gI1HQ = parcelRequire("gI1HQ");

var $66RJm = parcelRequire("66RJm");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c60f25a456c878ea$var$Stack(entries) {
    var data = this.__data__ = new $7QPwU(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$c60f25a456c878ea$var$Stack.prototype.clear = $1sOyM;
$c60f25a456c878ea$var$Stack.prototype['delete'] = $2PqjU;
$c60f25a456c878ea$var$Stack.prototype.get = $aaJNa;
$c60f25a456c878ea$var$Stack.prototype.has = $gI1HQ;
$c60f25a456c878ea$var$Stack.prototype.set = $66RJm;
module.exports = $c60f25a456c878ea$var$Stack;

});
parcelRegister("7QPwU", function(module, exports) {

var $cOg9V = parcelRequire("cOg9V");

var $7ZYlB = parcelRequire("7ZYlB");

var $jtOzQ = parcelRequire("jtOzQ");

var $hrNbz = parcelRequire("hrNbz");

var $2HvCR = parcelRequire("2HvCR");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5b755c7dd38da3f8$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$5b755c7dd38da3f8$var$ListCache.prototype.clear = $cOg9V;
$5b755c7dd38da3f8$var$ListCache.prototype['delete'] = $7ZYlB;
$5b755c7dd38da3f8$var$ListCache.prototype.get = $jtOzQ;
$5b755c7dd38da3f8$var$ListCache.prototype.has = $hrNbz;
$5b755c7dd38da3f8$var$ListCache.prototype.set = $2HvCR;
module.exports = $5b755c7dd38da3f8$var$ListCache;

});
parcelRegister("cOg9V", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $9536b069d3c7c77d$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $9536b069d3c7c77d$var$listCacheClear;

});

parcelRegister("7ZYlB", function(module, exports) {

var $25Vna = parcelRequire("25Vna");
/** Used for built-in method references. */ var $5d2d0aa8c2dba33a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $5d2d0aa8c2dba33a$var$splice = $5d2d0aa8c2dba33a$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5d2d0aa8c2dba33a$var$listCacheDelete(key) {
    var data = this.__data__, index = $25Vna(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $5d2d0aa8c2dba33a$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $5d2d0aa8c2dba33a$var$listCacheDelete;

});
parcelRegister("25Vna", function(module, exports) {

var $4Q3b3 = parcelRequire("4Q3b3");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $18688d6f28997823$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($4Q3b3(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $18688d6f28997823$var$assocIndexOf;

});
parcelRegister("4Q3b3", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $385e7bb2e7605405$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $385e7bb2e7605405$var$eq;

});



parcelRegister("jtOzQ", function(module, exports) {

var $25Vna = parcelRequire("25Vna");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e2e7f54c5fced4df$var$listCacheGet(key) {
    var data = this.__data__, index = $25Vna(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $e2e7f54c5fced4df$var$listCacheGet;

});

parcelRegister("hrNbz", function(module, exports) {

var $25Vna = parcelRequire("25Vna");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cb3b1c8544f96fe8$var$listCacheHas(key) {
    return $25Vna(this.__data__, key) > -1;
}
module.exports = $cb3b1c8544f96fe8$var$listCacheHas;

});

parcelRegister("2HvCR", function(module, exports) {

var $25Vna = parcelRequire("25Vna");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $1f7821204ee01127$var$listCacheSet(key, value) {
    var data = this.__data__, index = $25Vna(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $1f7821204ee01127$var$listCacheSet;

});


parcelRegister("1sOyM", function(module, exports) {

var $7QPwU = parcelRequire("7QPwU");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $110fa01ec4df1826$var$stackClear() {
    this.__data__ = new $7QPwU;
    this.size = 0;
}
module.exports = $110fa01ec4df1826$var$stackClear;

});

parcelRegister("2PqjU", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $20f4c2d71dea3f97$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $20f4c2d71dea3f97$var$stackDelete;

});

parcelRegister("aaJNa", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $767e5be982a36ba6$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $767e5be982a36ba6$var$stackGet;

});

parcelRegister("gI1HQ", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c2a2143932d5a366$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $c2a2143932d5a366$var$stackHas;

});

parcelRegister("66RJm", function(module, exports) {

var $7QPwU = parcelRequire("7QPwU");

var $2oodj = parcelRequire("2oodj");

var $4PRkI = parcelRequire("4PRkI");
/** Used as the size to enable large array optimizations. */ var $472cfb65063a4f4c$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $472cfb65063a4f4c$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $7QPwU) {
        var pairs = data.__data__;
        if (!$2oodj || pairs.length < $472cfb65063a4f4c$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4PRkI(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $472cfb65063a4f4c$var$stackSet;

});
parcelRegister("2oodj", function(module, exports) {

var $7GxQ0 = parcelRequire("7GxQ0");

var $gTpPE = parcelRequire("gTpPE");
/* Built-in method references that are verified to be native. */ var $1be09b06c7c6e7be$var$Map = $7GxQ0($gTpPE, 'Map');
module.exports = $1be09b06c7c6e7be$var$Map;

});
parcelRegister("7GxQ0", function(module, exports) {

var $8RTui = parcelRequire("8RTui");

var $2U8k6 = parcelRequire("2U8k6");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5986b4249571eafa$var$getNative(object, key) {
    var value = $2U8k6(object, key);
    return $8RTui(value) ? value : undefined;
}
module.exports = $5986b4249571eafa$var$getNative;

});
parcelRegister("8RTui", function(module, exports) {

var $jgzbA = parcelRequire("jgzbA");

var $3sG4U = parcelRequire("3sG4U");

var $j7DJp = parcelRequire("j7DJp");

var $a90AN = parcelRequire("a90AN");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $674e50ab2ee28eb4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $674e50ab2ee28eb4$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $674e50ab2ee28eb4$var$funcProto = Function.prototype, $674e50ab2ee28eb4$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $674e50ab2ee28eb4$var$funcToString = $674e50ab2ee28eb4$var$funcProto.toString;
/** Used to check objects for own properties. */ var $674e50ab2ee28eb4$var$hasOwnProperty = $674e50ab2ee28eb4$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $674e50ab2ee28eb4$var$reIsNative = RegExp('^' + $674e50ab2ee28eb4$var$funcToString.call($674e50ab2ee28eb4$var$hasOwnProperty).replace($674e50ab2ee28eb4$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $674e50ab2ee28eb4$var$baseIsNative(value) {
    if (!$j7DJp(value) || $3sG4U(value)) return false;
    var pattern = $jgzbA(value) ? $674e50ab2ee28eb4$var$reIsNative : $674e50ab2ee28eb4$var$reIsHostCtor;
    return pattern.test($a90AN(value));
}
module.exports = $674e50ab2ee28eb4$var$baseIsNative;

});
parcelRegister("jgzbA", function(module, exports) {

var $8t6rv = parcelRequire("8t6rv");

var $j7DJp = parcelRequire("j7DJp");
/** `Object#toString` result references. */ var $e06ace22a44eca20$var$asyncTag = '[object AsyncFunction]', $e06ace22a44eca20$var$funcTag = '[object Function]', $e06ace22a44eca20$var$genTag = '[object GeneratorFunction]', $e06ace22a44eca20$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e06ace22a44eca20$var$isFunction(value) {
    if (!$j7DJp(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $8t6rv(value);
    return tag == $e06ace22a44eca20$var$funcTag || tag == $e06ace22a44eca20$var$genTag || tag == $e06ace22a44eca20$var$asyncTag || tag == $e06ace22a44eca20$var$proxyTag;
}
module.exports = $e06ace22a44eca20$var$isFunction;

});
parcelRegister("8t6rv", function(module, exports) {

var $2LyK3 = parcelRequire("2LyK3");

var $eJXqN = parcelRequire("eJXqN");

var $hHjcA = parcelRequire("hHjcA");
/** `Object#toString` result references. */ var $62a6078b8d4e0c11$var$nullTag = '[object Null]', $62a6078b8d4e0c11$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $62a6078b8d4e0c11$var$symToStringTag = $2LyK3 ? $2LyK3.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $62a6078b8d4e0c11$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $62a6078b8d4e0c11$var$undefinedTag : $62a6078b8d4e0c11$var$nullTag;
    return $62a6078b8d4e0c11$var$symToStringTag && $62a6078b8d4e0c11$var$symToStringTag in Object(value) ? $eJXqN(value) : $hHjcA(value);
}
module.exports = $62a6078b8d4e0c11$var$baseGetTag;

});
parcelRegister("2LyK3", function(module, exports) {

var $gTpPE = parcelRequire("gTpPE");
/** Built-in value references. */ var $203aeb8fb54246d8$var$Symbol = $gTpPE.Symbol;
module.exports = $203aeb8fb54246d8$var$Symbol;

});
parcelRegister("gTpPE", function(module, exports) {

var $enSz0 = parcelRequire("enSz0");
/** Detect free variable `self`. */ var $c4c5d2167384ffcd$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c4c5d2167384ffcd$var$root = $enSz0 || $c4c5d2167384ffcd$var$freeSelf || Function('return this')();
module.exports = $c4c5d2167384ffcd$var$root;

});
parcelRegister("enSz0", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $a78d89e18667d9fd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $a78d89e18667d9fd$var$freeGlobal;

});



parcelRegister("eJXqN", function(module, exports) {

var $2LyK3 = parcelRequire("2LyK3");
/** Used for built-in method references. */ var $abb35e7a7f13ab95$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $abb35e7a7f13ab95$var$hasOwnProperty = $abb35e7a7f13ab95$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $abb35e7a7f13ab95$var$nativeObjectToString = $abb35e7a7f13ab95$var$objectProto.toString;
/** Built-in value references. */ var $abb35e7a7f13ab95$var$symToStringTag = $2LyK3 ? $2LyK3.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $abb35e7a7f13ab95$var$getRawTag(value) {
    var isOwn = $abb35e7a7f13ab95$var$hasOwnProperty.call(value, $abb35e7a7f13ab95$var$symToStringTag), tag = value[$abb35e7a7f13ab95$var$symToStringTag];
    try {
        value[$abb35e7a7f13ab95$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $abb35e7a7f13ab95$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$abb35e7a7f13ab95$var$symToStringTag] = tag;
        else delete value[$abb35e7a7f13ab95$var$symToStringTag];
    }
    return result;
}
module.exports = $abb35e7a7f13ab95$var$getRawTag;

});

parcelRegister("hHjcA", function(module, exports) {
/** Used for built-in method references. */ var $ce2558f3cfda4533$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ce2558f3cfda4533$var$nativeObjectToString = $ce2558f3cfda4533$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $ce2558f3cfda4533$var$objectToString(value) {
    return $ce2558f3cfda4533$var$nativeObjectToString.call(value);
}
module.exports = $ce2558f3cfda4533$var$objectToString;

});


parcelRegister("j7DJp", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $debd7d9e65df7807$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $debd7d9e65df7807$var$isObject;

});


parcelRegister("3sG4U", function(module, exports) {

var $eyz4u = parcelRequire("eyz4u");
/** Used to detect methods masquerading as native. */ var $2854a07ed05d6f95$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($eyz4u && $eyz4u.keys && $eyz4u.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $2854a07ed05d6f95$var$isMasked(func) {
    return !!$2854a07ed05d6f95$var$maskSrcKey && $2854a07ed05d6f95$var$maskSrcKey in func;
}
module.exports = $2854a07ed05d6f95$var$isMasked;

});
parcelRegister("eyz4u", function(module, exports) {

var $gTpPE = parcelRequire("gTpPE");
/** Used to detect overreaching core-js shims. */ var $a98f7217b0a9bb68$var$coreJsData = $gTpPE["__core-js_shared__"];
module.exports = $a98f7217b0a9bb68$var$coreJsData;

});


parcelRegister("a90AN", function(module, exports) {
/** Used for built-in method references. */ var $762b344c5673bb02$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $762b344c5673bb02$var$funcToString = $762b344c5673bb02$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $762b344c5673bb02$var$toSource(func) {
    if (func != null) {
        try {
            return $762b344c5673bb02$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $762b344c5673bb02$var$toSource;

});


parcelRegister("2U8k6", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $21d74491cd1ac5bc$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $21d74491cd1ac5bc$var$getValue;

});



parcelRegister("4PRkI", function(module, exports) {

var $ahfCH = parcelRequire("ahfCH");

var $dsuqu = parcelRequire("dsuqu");

var $b9gcY = parcelRequire("b9gcY");

var $e1cAh = parcelRequire("e1cAh");

var $dQ601 = parcelRequire("dQ601");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $38554bb32ca0588b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$38554bb32ca0588b$var$MapCache.prototype.clear = $ahfCH;
$38554bb32ca0588b$var$MapCache.prototype['delete'] = $dsuqu;
$38554bb32ca0588b$var$MapCache.prototype.get = $b9gcY;
$38554bb32ca0588b$var$MapCache.prototype.has = $e1cAh;
$38554bb32ca0588b$var$MapCache.prototype.set = $dQ601;
module.exports = $38554bb32ca0588b$var$MapCache;

});
parcelRegister("ahfCH", function(module, exports) {

var $frGmW = parcelRequire("frGmW");

var $7QPwU = parcelRequire("7QPwU");

var $2oodj = parcelRequire("2oodj");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $77b79c553e555814$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $frGmW,
        'map': new ($2oodj || $7QPwU),
        'string': new $frGmW
    };
}
module.exports = $77b79c553e555814$var$mapCacheClear;

});
parcelRegister("frGmW", function(module, exports) {

var $awJvY = parcelRequire("awJvY");

var $iiTDu = parcelRequire("iiTDu");

var $lg7NY = parcelRequire("lg7NY");

var $epyZV = parcelRequire("epyZV");

var $lGTRU = parcelRequire("lGTRU");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b3ea3e3fa62d965d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$b3ea3e3fa62d965d$var$Hash.prototype.clear = $awJvY;
$b3ea3e3fa62d965d$var$Hash.prototype['delete'] = $iiTDu;
$b3ea3e3fa62d965d$var$Hash.prototype.get = $lg7NY;
$b3ea3e3fa62d965d$var$Hash.prototype.has = $epyZV;
$b3ea3e3fa62d965d$var$Hash.prototype.set = $lGTRU;
module.exports = $b3ea3e3fa62d965d$var$Hash;

});
parcelRegister("awJvY", function(module, exports) {

var $2mmOi = parcelRequire("2mmOi");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $7aa032cda1288513$var$hashClear() {
    this.__data__ = $2mmOi ? $2mmOi(null) : {};
    this.size = 0;
}
module.exports = $7aa032cda1288513$var$hashClear;

});
parcelRegister("2mmOi", function(module, exports) {

var $7GxQ0 = parcelRequire("7GxQ0");
/* Built-in method references that are verified to be native. */ var $1b7f547b29fceb1a$var$nativeCreate = $7GxQ0(Object, 'create');
module.exports = $1b7f547b29fceb1a$var$nativeCreate;

});


parcelRegister("iiTDu", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d535108d2750a00c$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $d535108d2750a00c$var$hashDelete;

});

parcelRegister("lg7NY", function(module, exports) {

var $2mmOi = parcelRequire("2mmOi");
/** Used to stand-in for `undefined` hash values. */ var $f7a1257e22a612d7$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $f7a1257e22a612d7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7a1257e22a612d7$var$hasOwnProperty = $f7a1257e22a612d7$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f7a1257e22a612d7$var$hashGet(key) {
    var data = this.__data__;
    if ($2mmOi) {
        var result = data[key];
        return result === $f7a1257e22a612d7$var$HASH_UNDEFINED ? undefined : result;
    }
    return $f7a1257e22a612d7$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $f7a1257e22a612d7$var$hashGet;

});

parcelRegister("epyZV", function(module, exports) {

var $2mmOi = parcelRequire("2mmOi");
/** Used for built-in method references. */ var $a7de8c54ce6afb7d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a7de8c54ce6afb7d$var$hasOwnProperty = $a7de8c54ce6afb7d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a7de8c54ce6afb7d$var$hashHas(key) {
    var data = this.__data__;
    return $2mmOi ? data[key] !== undefined : $a7de8c54ce6afb7d$var$hasOwnProperty.call(data, key);
}
module.exports = $a7de8c54ce6afb7d$var$hashHas;

});

parcelRegister("lGTRU", function(module, exports) {

var $2mmOi = parcelRequire("2mmOi");
/** Used to stand-in for `undefined` hash values. */ var $04133d58e47e26fb$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $04133d58e47e26fb$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $2mmOi && value === undefined ? $04133d58e47e26fb$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $04133d58e47e26fb$var$hashSet;

});



parcelRegister("dsuqu", function(module, exports) {

var $lKzuy = parcelRequire("lKzuy");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9cc57de2313c2124$var$mapCacheDelete(key) {
    var result = $lKzuy(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9cc57de2313c2124$var$mapCacheDelete;

});
parcelRegister("lKzuy", function(module, exports) {

var $dc26X = parcelRequire("dc26X");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $fd596cc57f1cf11e$var$getMapData(map, key) {
    var data = map.__data__;
    return $dc26X(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $fd596cc57f1cf11e$var$getMapData;

});
parcelRegister("dc26X", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $99ae089286a0b9a8$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $99ae089286a0b9a8$var$isKeyable;

});



parcelRegister("b9gcY", function(module, exports) {

var $lKzuy = parcelRequire("lKzuy");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $81dd1b9bc9ad8ac9$var$mapCacheGet(key) {
    return $lKzuy(this, key).get(key);
}
module.exports = $81dd1b9bc9ad8ac9$var$mapCacheGet;

});

parcelRegister("e1cAh", function(module, exports) {

var $lKzuy = parcelRequire("lKzuy");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a34aeb9ff3ed2979$var$mapCacheHas(key) {
    return $lKzuy(this, key).has(key);
}
module.exports = $a34aeb9ff3ed2979$var$mapCacheHas;

});

parcelRegister("dQ601", function(module, exports) {

var $lKzuy = parcelRequire("lKzuy");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a134c90cf5db748c$var$mapCacheSet(key, value) {
    var data = $lKzuy(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $a134c90cf5db748c$var$mapCacheSet;

});




parcelRegister("lrTfh", function(module, exports) {

var $kbf0E = parcelRequire("kbf0E");

var $b6nDQ = parcelRequire("b6nDQ");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f9d6f934029d7fe1$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$b6nDQ(value) && !$b6nDQ(other)) return value !== value && other !== other;
    return $kbf0E(value, other, bitmask, customizer, $f9d6f934029d7fe1$var$baseIsEqual, stack);
}
module.exports = $f9d6f934029d7fe1$var$baseIsEqual;

});
parcelRegister("kbf0E", function(module, exports) {

var $h0gnZ = parcelRequire("h0gnZ");

var $5voU4 = parcelRequire("5voU4");

var $a2jMB = parcelRequire("a2jMB");

var $jWgj1 = parcelRequire("jWgj1");

var $8vSaN = parcelRequire("8vSaN");

var $u1Zdx = parcelRequire("u1Zdx");

var $eSjJt = parcelRequire("eSjJt");

var $89P5Q = parcelRequire("89P5Q");
/** Used to compose bitmasks for value comparisons. */ var $eb107a4fce087b84$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $eb107a4fce087b84$var$argsTag = '[object Arguments]', $eb107a4fce087b84$var$arrayTag = '[object Array]', $eb107a4fce087b84$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $eb107a4fce087b84$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eb107a4fce087b84$var$hasOwnProperty = $eb107a4fce087b84$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $eb107a4fce087b84$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $u1Zdx(object), othIsArr = $u1Zdx(other), objTag = objIsArr ? $eb107a4fce087b84$var$arrayTag : $8vSaN(object), othTag = othIsArr ? $eb107a4fce087b84$var$arrayTag : $8vSaN(other);
    objTag = objTag == $eb107a4fce087b84$var$argsTag ? $eb107a4fce087b84$var$objectTag : objTag;
    othTag = othTag == $eb107a4fce087b84$var$argsTag ? $eb107a4fce087b84$var$objectTag : othTag;
    var objIsObj = objTag == $eb107a4fce087b84$var$objectTag, othIsObj = othTag == $eb107a4fce087b84$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $eSjJt(object)) {
        if (!$eSjJt(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $h0gnZ);
        return objIsArr || $89P5Q(object) ? $5voU4(object, other, bitmask, customizer, equalFunc, stack) : $a2jMB(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $eb107a4fce087b84$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $eb107a4fce087b84$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $eb107a4fce087b84$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $h0gnZ);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $h0gnZ);
    return $jWgj1(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $eb107a4fce087b84$var$baseIsEqualDeep;

});
parcelRegister("5voU4", function(module, exports) {

var $2tHRa = parcelRequire("2tHRa");

var $hXPpS = parcelRequire("hXPpS");

var $3tkIe = parcelRequire("3tkIe");
/** Used to compose bitmasks for value comparisons. */ var $40232a46db6caedc$var$COMPARE_PARTIAL_FLAG = 1, $40232a46db6caedc$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $40232a46db6caedc$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $40232a46db6caedc$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $40232a46db6caedc$var$COMPARE_UNORDERED_FLAG ? new $2tHRa : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$hXPpS(other, function(othValue, othIndex) {
                if (!$3tkIe(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $40232a46db6caedc$var$equalArrays;

});
parcelRegister("2tHRa", function(module, exports) {

var $4PRkI = parcelRequire("4PRkI");

var $g5JhG = parcelRequire("g5JhG");

var $4uLTT = parcelRequire("4uLTT");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $1ce04f2f3b245784$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4PRkI;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$1ce04f2f3b245784$var$SetCache.prototype.add = $1ce04f2f3b245784$var$SetCache.prototype.push = $g5JhG;
$1ce04f2f3b245784$var$SetCache.prototype.has = $4uLTT;
module.exports = $1ce04f2f3b245784$var$SetCache;

});
parcelRegister("g5JhG", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $bb703d7b122e036a$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $bb703d7b122e036a$var$setCacheAdd(value) {
    this.__data__.set(value, $bb703d7b122e036a$var$HASH_UNDEFINED);
    return this;
}
module.exports = $bb703d7b122e036a$var$setCacheAdd;

});

parcelRegister("4uLTT", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $345f1ed108c55272$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $345f1ed108c55272$var$setCacheHas;

});


parcelRegister("hXPpS", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $d13fd498989c696f$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $d13fd498989c696f$var$arraySome;

});

parcelRegister("3tkIe", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $28742595b262ef02$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $28742595b262ef02$var$cacheHas;

});


parcelRegister("a2jMB", function(module, exports) {

var $2LyK3 = parcelRequire("2LyK3");

var $c0Swu = parcelRequire("c0Swu");

var $4Q3b3 = parcelRequire("4Q3b3");

var $5voU4 = parcelRequire("5voU4");

var $4X8RU = parcelRequire("4X8RU");

var $b3aAi = parcelRequire("b3aAi");
/** Used to compose bitmasks for value comparisons. */ var $74e96fc317549446$var$COMPARE_PARTIAL_FLAG = 1, $74e96fc317549446$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $74e96fc317549446$var$boolTag = '[object Boolean]', $74e96fc317549446$var$dateTag = '[object Date]', $74e96fc317549446$var$errorTag = '[object Error]', $74e96fc317549446$var$mapTag = '[object Map]', $74e96fc317549446$var$numberTag = '[object Number]', $74e96fc317549446$var$regexpTag = '[object RegExp]', $74e96fc317549446$var$setTag = '[object Set]', $74e96fc317549446$var$stringTag = '[object String]', $74e96fc317549446$var$symbolTag = '[object Symbol]';
var $74e96fc317549446$var$arrayBufferTag = '[object ArrayBuffer]', $74e96fc317549446$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $74e96fc317549446$var$symbolProto = $2LyK3 ? $2LyK3.prototype : undefined, $74e96fc317549446$var$symbolValueOf = $74e96fc317549446$var$symbolProto ? $74e96fc317549446$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $74e96fc317549446$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $74e96fc317549446$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $74e96fc317549446$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $c0Swu(object), new $c0Swu(other))) return false;
            return true;
        case $74e96fc317549446$var$boolTag:
        case $74e96fc317549446$var$dateTag:
        case $74e96fc317549446$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $4Q3b3(+object, +other);
        case $74e96fc317549446$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $74e96fc317549446$var$regexpTag:
        case $74e96fc317549446$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $74e96fc317549446$var$mapTag:
            var convert = $4X8RU;
        case $74e96fc317549446$var$setTag:
            var isPartial = bitmask & $74e96fc317549446$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $b3aAi);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $74e96fc317549446$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $5voU4(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $74e96fc317549446$var$symbolTag:
            if ($74e96fc317549446$var$symbolValueOf) return $74e96fc317549446$var$symbolValueOf.call(object) == $74e96fc317549446$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $74e96fc317549446$var$equalByTag;

});
parcelRegister("c0Swu", function(module, exports) {

var $gTpPE = parcelRequire("gTpPE");
/** Built-in value references. */ var $8befc74733c3ec6a$var$Uint8Array = $gTpPE.Uint8Array;
module.exports = $8befc74733c3ec6a$var$Uint8Array;

});

parcelRegister("4X8RU", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $39b38d3c9bb2c9e6$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $39b38d3c9bb2c9e6$var$mapToArray;

});

parcelRegister("b3aAi", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $80b82f5d577fee9c$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $80b82f5d577fee9c$var$setToArray;

});


parcelRegister("jWgj1", function(module, exports) {

var $jEh55 = parcelRequire("jEh55");
/** Used to compose bitmasks for value comparisons. */ var $e8401519f2cfb40b$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $e8401519f2cfb40b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e8401519f2cfb40b$var$hasOwnProperty = $e8401519f2cfb40b$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e8401519f2cfb40b$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e8401519f2cfb40b$var$COMPARE_PARTIAL_FLAG, objProps = $jEh55(object), objLength = objProps.length, othProps = $jEh55(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $e8401519f2cfb40b$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $e8401519f2cfb40b$var$equalObjects;

});
parcelRegister("jEh55", function(module, exports) {

var $g8d0G = parcelRequire("g8d0G");

var $f4Un0 = parcelRequire("f4Un0");

var $4ztaZ = parcelRequire("4ztaZ");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e4df00ac89938c59$var$getAllKeys(object) {
    return $g8d0G(object, $4ztaZ, $f4Un0);
}
module.exports = $e4df00ac89938c59$var$getAllKeys;

});
parcelRegister("g8d0G", function(module, exports) {

var $icCJ2 = parcelRequire("icCJ2");

var $u1Zdx = parcelRequire("u1Zdx");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $bbe77c353773a34f$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $u1Zdx(object) ? result : $icCJ2(result, symbolsFunc(object));
}
module.exports = $bbe77c353773a34f$var$baseGetAllKeys;

});
parcelRegister("icCJ2", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $d407630cc3f3be43$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $d407630cc3f3be43$var$arrayPush;

});

parcelRegister("u1Zdx", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $05a457e8e219e154$var$isArray = Array.isArray;
module.exports = $05a457e8e219e154$var$isArray;

});


parcelRegister("f4Un0", function(module, exports) {

var $1rJ6v = parcelRequire("1rJ6v");

var $1n6Oe = parcelRequire("1n6Oe");
/** Used for built-in method references. */ var $afa2f4a2517ad483$var$objectProto = Object.prototype;
/** Built-in value references. */ var $afa2f4a2517ad483$var$propertyIsEnumerable = $afa2f4a2517ad483$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $afa2f4a2517ad483$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $afa2f4a2517ad483$var$getSymbols = !$afa2f4a2517ad483$var$nativeGetSymbols ? $1n6Oe : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $1rJ6v($afa2f4a2517ad483$var$nativeGetSymbols(object), function(symbol) {
        return $afa2f4a2517ad483$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $afa2f4a2517ad483$var$getSymbols;

});
parcelRegister("1rJ6v", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $10db4cbf0a4f9995$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $10db4cbf0a4f9995$var$arrayFilter;

});

parcelRegister("1n6Oe", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $0ffd3896f26665de$var$stubArray() {
    return [];
}
module.exports = $0ffd3896f26665de$var$stubArray;

});


parcelRegister("4ztaZ", function(module, exports) {

var $9qPNR = parcelRequire("9qPNR");

var $2AfZ8 = parcelRequire("2AfZ8");

var $eG4u6 = parcelRequire("eG4u6");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $3541101482a0843c$var$keys(object) {
    return $eG4u6(object) ? $9qPNR(object) : $2AfZ8(object);
}
module.exports = $3541101482a0843c$var$keys;

});
parcelRegister("9qPNR", function(module, exports) {

var $El2ye = parcelRequire("El2ye");

var $ireFH = parcelRequire("ireFH");

var $u1Zdx = parcelRequire("u1Zdx");

var $eSjJt = parcelRequire("eSjJt");

var $lexYg = parcelRequire("lexYg");

var $89P5Q = parcelRequire("89P5Q");
/** Used for built-in method references. */ var $6ddeb9d224421d79$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6ddeb9d224421d79$var$hasOwnProperty = $6ddeb9d224421d79$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $6ddeb9d224421d79$var$arrayLikeKeys(value, inherited) {
    var isArr = $u1Zdx(value), isArg = !isArr && $ireFH(value), isBuff = !isArr && !isArg && $eSjJt(value), isType = !isArr && !isArg && !isBuff && $89P5Q(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $El2ye(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $6ddeb9d224421d79$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $lexYg(key, length)))) result.push(key);
    return result;
}
module.exports = $6ddeb9d224421d79$var$arrayLikeKeys;

});
parcelRegister("El2ye", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $07940ead21979c2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $07940ead21979c2d$var$baseTimes;

});

parcelRegister("ireFH", function(module, exports) {

var $i945o = parcelRequire("i945o");

var $b6nDQ = parcelRequire("b6nDQ");
/** Used for built-in method references. */ var $d6c62118045fd1ac$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d6c62118045fd1ac$var$hasOwnProperty = $d6c62118045fd1ac$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $d6c62118045fd1ac$var$propertyIsEnumerable = $d6c62118045fd1ac$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $d6c62118045fd1ac$var$isArguments = $i945o(function() {
    return arguments;
}()) ? $i945o : function(value) {
    return $b6nDQ(value) && $d6c62118045fd1ac$var$hasOwnProperty.call(value, 'callee') && !$d6c62118045fd1ac$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $d6c62118045fd1ac$var$isArguments;

});
parcelRegister("i945o", function(module, exports) {

var $8t6rv = parcelRequire("8t6rv");

var $b6nDQ = parcelRequire("b6nDQ");
/** `Object#toString` result references. */ var $d35c3ca2b029dd7d$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $d35c3ca2b029dd7d$var$baseIsArguments(value) {
    return $b6nDQ(value) && $8t6rv(value) == $d35c3ca2b029dd7d$var$argsTag;
}
module.exports = $d35c3ca2b029dd7d$var$baseIsArguments;

});
parcelRegister("b6nDQ", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $815297ffec7a3a16$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $815297ffec7a3a16$var$isObjectLike;

});



parcelRegister("eSjJt", function(module, exports) {

var $gTpPE = parcelRequire("gTpPE");

var $fS6v2 = parcelRequire("fS6v2");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $gTpPE.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fS6v2;
module.exports = isBuffer;

});
parcelRegister("fS6v2", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b8e0f0df41158b18$var$stubFalse() {
    return false;
}
module.exports = $b8e0f0df41158b18$var$stubFalse;

});


parcelRegister("lexYg", function(module, exports) {
/** Used as references for various `Number` constants. */ var $f75541b8aecd3799$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $f75541b8aecd3799$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $f75541b8aecd3799$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $f75541b8aecd3799$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $f75541b8aecd3799$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $f75541b8aecd3799$var$isIndex;

});

parcelRegister("89P5Q", function(module, exports) {

var $6KGUv = parcelRequire("6KGUv");

var $iiVLm = parcelRequire("iiVLm");

var $fIN6M = parcelRequire("fIN6M");
/* Node.js helper references. */ var $5f06cc09737ee659$var$nodeIsTypedArray = $fIN6M && $fIN6M.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $5f06cc09737ee659$var$isTypedArray = $5f06cc09737ee659$var$nodeIsTypedArray ? $iiVLm($5f06cc09737ee659$var$nodeIsTypedArray) : $6KGUv;
module.exports = $5f06cc09737ee659$var$isTypedArray;

});
parcelRegister("6KGUv", function(module, exports) {

var $8t6rv = parcelRequire("8t6rv");

var $jQ8Qj = parcelRequire("jQ8Qj");

var $b6nDQ = parcelRequire("b6nDQ");
/** `Object#toString` result references. */ var $4ea85313b1f5e1b7$var$argsTag = '[object Arguments]', $4ea85313b1f5e1b7$var$arrayTag = '[object Array]', $4ea85313b1f5e1b7$var$boolTag = '[object Boolean]', $4ea85313b1f5e1b7$var$dateTag = '[object Date]', $4ea85313b1f5e1b7$var$errorTag = '[object Error]', $4ea85313b1f5e1b7$var$funcTag = '[object Function]', $4ea85313b1f5e1b7$var$mapTag = '[object Map]', $4ea85313b1f5e1b7$var$numberTag = '[object Number]', $4ea85313b1f5e1b7$var$objectTag = '[object Object]', $4ea85313b1f5e1b7$var$regexpTag = '[object RegExp]', $4ea85313b1f5e1b7$var$setTag = '[object Set]', $4ea85313b1f5e1b7$var$stringTag = '[object String]', $4ea85313b1f5e1b7$var$weakMapTag = '[object WeakMap]';
var $4ea85313b1f5e1b7$var$arrayBufferTag = '[object ArrayBuffer]', $4ea85313b1f5e1b7$var$dataViewTag = '[object DataView]', $4ea85313b1f5e1b7$var$float32Tag = '[object Float32Array]', $4ea85313b1f5e1b7$var$float64Tag = '[object Float64Array]', $4ea85313b1f5e1b7$var$int8Tag = '[object Int8Array]', $4ea85313b1f5e1b7$var$int16Tag = '[object Int16Array]', $4ea85313b1f5e1b7$var$int32Tag = '[object Int32Array]', $4ea85313b1f5e1b7$var$uint8Tag = '[object Uint8Array]', $4ea85313b1f5e1b7$var$uint8ClampedTag = '[object Uint8ClampedArray]', $4ea85313b1f5e1b7$var$uint16Tag = '[object Uint16Array]', $4ea85313b1f5e1b7$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $4ea85313b1f5e1b7$var$typedArrayTags = {};
$4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$float32Tag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$float64Tag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$int8Tag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$int16Tag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$int32Tag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$uint8Tag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$uint8ClampedTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$uint16Tag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$uint32Tag] = true;
$4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$argsTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$arrayTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$arrayBufferTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$boolTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$dataViewTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$dateTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$errorTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$funcTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$mapTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$numberTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$objectTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$regexpTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$setTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$stringTag] = $4ea85313b1f5e1b7$var$typedArrayTags[$4ea85313b1f5e1b7$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $4ea85313b1f5e1b7$var$baseIsTypedArray(value) {
    return $b6nDQ(value) && $jQ8Qj(value.length) && !!$4ea85313b1f5e1b7$var$typedArrayTags[$8t6rv(value)];
}
module.exports = $4ea85313b1f5e1b7$var$baseIsTypedArray;

});
parcelRegister("jQ8Qj", function(module, exports) {
/** Used as references for various `Number` constants. */ var $e719bba4a3937e4c$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e719bba4a3937e4c$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $e719bba4a3937e4c$var$MAX_SAFE_INTEGER;
}
module.exports = $e719bba4a3937e4c$var$isLength;

});


parcelRegister("iiVLm", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d536b6efa85709bf$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $d536b6efa85709bf$var$baseUnary;

});

parcelRegister("fIN6M", function(module, exports) {

var $enSz0 = parcelRequire("enSz0");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $enSz0.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("2AfZ8", function(module, exports) {

var $c5V8J = parcelRequire("c5V8J");

var $lEwll = parcelRequire("lEwll");
/** Used for built-in method references. */ var $1e1b57e10490228f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1e1b57e10490228f$var$hasOwnProperty = $1e1b57e10490228f$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $1e1b57e10490228f$var$baseKeys(object) {
    if (!$c5V8J(object)) return $lEwll(object);
    var result = [];
    for(var key in Object(object))if ($1e1b57e10490228f$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $1e1b57e10490228f$var$baseKeys;

});
parcelRegister("c5V8J", function(module, exports) {
/** Used for built-in method references. */ var $8ce24670f1cdefd1$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $8ce24670f1cdefd1$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $8ce24670f1cdefd1$var$objectProto;
    return value === proto;
}
module.exports = $8ce24670f1cdefd1$var$isPrototype;

});

parcelRegister("lEwll", function(module, exports) {

var $lEzIf = parcelRequire("lEzIf");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fc366c16653e6c55$var$nativeKeys = $lEzIf(Object.keys, Object);
module.exports = $fc366c16653e6c55$var$nativeKeys;

});
parcelRegister("lEzIf", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fc390931a4aabf85$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $fc390931a4aabf85$var$overArg;

});



parcelRegister("eG4u6", function(module, exports) {

var $jgzbA = parcelRequire("jgzbA");

var $jQ8Qj = parcelRequire("jQ8Qj");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $aaf877791c1bf5bd$var$isArrayLike(value) {
    return value != null && $jQ8Qj(value.length) && !$jgzbA(value);
}
module.exports = $aaf877791c1bf5bd$var$isArrayLike;

});




parcelRegister("8vSaN", function(module, exports) {

var $agV8k = parcelRequire("agV8k");

var $2oodj = parcelRequire("2oodj");

var $5gjMr = parcelRequire("5gjMr");

var $3ddYs = parcelRequire("3ddYs");

var $fdq8B = parcelRequire("fdq8B");

var $8t6rv = parcelRequire("8t6rv");

var $a90AN = parcelRequire("a90AN");
/** `Object#toString` result references. */ var $632b3da351307db4$var$mapTag = '[object Map]', $632b3da351307db4$var$objectTag = '[object Object]', $632b3da351307db4$var$promiseTag = '[object Promise]', $632b3da351307db4$var$setTag = '[object Set]', $632b3da351307db4$var$weakMapTag = '[object WeakMap]';
var $632b3da351307db4$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $632b3da351307db4$var$dataViewCtorString = $a90AN($agV8k), $632b3da351307db4$var$mapCtorString = $a90AN($2oodj), $632b3da351307db4$var$promiseCtorString = $a90AN($5gjMr), $632b3da351307db4$var$setCtorString = $a90AN($3ddYs), $632b3da351307db4$var$weakMapCtorString = $a90AN($fdq8B);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $632b3da351307db4$var$getTag = $8t6rv;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($agV8k && $632b3da351307db4$var$getTag(new $agV8k(new ArrayBuffer(1))) != $632b3da351307db4$var$dataViewTag || $2oodj && $632b3da351307db4$var$getTag(new $2oodj) != $632b3da351307db4$var$mapTag || $5gjMr && $632b3da351307db4$var$getTag($5gjMr.resolve()) != $632b3da351307db4$var$promiseTag || $3ddYs && $632b3da351307db4$var$getTag(new $3ddYs) != $632b3da351307db4$var$setTag || $fdq8B && $632b3da351307db4$var$getTag(new $fdq8B) != $632b3da351307db4$var$weakMapTag) $632b3da351307db4$var$getTag = function(value) {
    var result = $8t6rv(value), Ctor = result == $632b3da351307db4$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $a90AN(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $632b3da351307db4$var$dataViewCtorString:
            return $632b3da351307db4$var$dataViewTag;
        case $632b3da351307db4$var$mapCtorString:
            return $632b3da351307db4$var$mapTag;
        case $632b3da351307db4$var$promiseCtorString:
            return $632b3da351307db4$var$promiseTag;
        case $632b3da351307db4$var$setCtorString:
            return $632b3da351307db4$var$setTag;
        case $632b3da351307db4$var$weakMapCtorString:
            return $632b3da351307db4$var$weakMapTag;
    }
    return result;
};
module.exports = $632b3da351307db4$var$getTag;

});
parcelRegister("agV8k", function(module, exports) {

var $7GxQ0 = parcelRequire("7GxQ0");

var $gTpPE = parcelRequire("gTpPE");
/* Built-in method references that are verified to be native. */ var $77a7b77f8b900625$var$DataView = $7GxQ0($gTpPE, 'DataView');
module.exports = $77a7b77f8b900625$var$DataView;

});

parcelRegister("5gjMr", function(module, exports) {

var $7GxQ0 = parcelRequire("7GxQ0");

var $gTpPE = parcelRequire("gTpPE");
/* Built-in method references that are verified to be native. */ var $3d4dca555cff014e$var$Promise = $7GxQ0($gTpPE, 'Promise');
module.exports = $3d4dca555cff014e$var$Promise;

});

parcelRegister("3ddYs", function(module, exports) {

var $7GxQ0 = parcelRequire("7GxQ0");

var $gTpPE = parcelRequire("gTpPE");
/* Built-in method references that are verified to be native. */ var $256d6cf838390bfc$var$Set = $7GxQ0($gTpPE, 'Set');
module.exports = $256d6cf838390bfc$var$Set;

});

parcelRegister("fdq8B", function(module, exports) {

var $7GxQ0 = parcelRequire("7GxQ0");

var $gTpPE = parcelRequire("gTpPE");
/* Built-in method references that are verified to be native. */ var $b13c584d227fc92d$var$WeakMap = $7GxQ0($gTpPE, 'WeakMap');
module.exports = $b13c584d227fc92d$var$WeakMap;

});





parcelRegister("fqBKL", function(module, exports) {

var $iLGZ6 = parcelRequire("iLGZ6");

var $4ztaZ = parcelRequire("4ztaZ");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $b3b691ba05624999$var$getMatchData(object) {
    var result = $4ztaZ(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $iLGZ6(value)
        ];
    }
    return result;
}
module.exports = $b3b691ba05624999$var$getMatchData;

});
parcelRegister("iLGZ6", function(module, exports) {

var $j7DJp = parcelRequire("j7DJp");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $da9df59e2f09c2f8$var$isStrictComparable(value) {
    return value === value && !$j7DJp(value);
}
module.exports = $da9df59e2f09c2f8$var$isStrictComparable;

});


parcelRegister("kIsAr", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f14e17764cb843f9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $f14e17764cb843f9$var$matchesStrictComparable;

});


parcelRegister("bXbMc", function(module, exports) {

var $lrTfh = parcelRequire("lrTfh");

var $cSBxc = parcelRequire("cSBxc");

var $l7WY8 = parcelRequire("l7WY8");

var $fABhm = parcelRequire("fABhm");

var $iLGZ6 = parcelRequire("iLGZ6");

var $kIsAr = parcelRequire("kIsAr");

var $1DDv1 = parcelRequire("1DDv1");
/** Used to compose bitmasks for value comparisons. */ var $8b3e56f0ab0a4898$var$COMPARE_PARTIAL_FLAG = 1, $8b3e56f0ab0a4898$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $8b3e56f0ab0a4898$var$baseMatchesProperty(path, srcValue) {
    if ($fABhm(path) && $iLGZ6(srcValue)) return $kIsAr($1DDv1(path), srcValue);
    return function(object) {
        var objValue = $cSBxc(object, path);
        return objValue === undefined && objValue === srcValue ? $l7WY8(object, path) : $lrTfh(srcValue, objValue, $8b3e56f0ab0a4898$var$COMPARE_PARTIAL_FLAG | $8b3e56f0ab0a4898$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $8b3e56f0ab0a4898$var$baseMatchesProperty;

});
parcelRegister("cSBxc", function(module, exports) {

var $29blh = parcelRequire("29blh");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $9607a4c36d158bf4$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $29blh(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $9607a4c36d158bf4$var$get;

});
parcelRegister("29blh", function(module, exports) {

var $7lN7R = parcelRequire("7lN7R");

var $1DDv1 = parcelRequire("1DDv1");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $1905385b2dcdd6ba$var$baseGet(object, path) {
    path = $7lN7R(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$1DDv1(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $1905385b2dcdd6ba$var$baseGet;

});
parcelRegister("7lN7R", function(module, exports) {

var $u1Zdx = parcelRequire("u1Zdx");

var $fABhm = parcelRequire("fABhm");

var $lqErr = parcelRequire("lqErr");

var $bDVqc = parcelRequire("bDVqc");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $55a099e92f4a1e9f$var$castPath(value, object) {
    if ($u1Zdx(value)) return value;
    return $fABhm(value, object) ? [
        value
    ] : $lqErr($bDVqc(value));
}
module.exports = $55a099e92f4a1e9f$var$castPath;

});
parcelRegister("fABhm", function(module, exports) {

var $u1Zdx = parcelRequire("u1Zdx");

var $jK5ch = parcelRequire("jK5ch");
/** Used to match property names within property paths. */ var $b59722a6ac8848c7$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $b59722a6ac8848c7$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $b59722a6ac8848c7$var$isKey(value, object) {
    if ($u1Zdx(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $jK5ch(value)) return true;
    return $b59722a6ac8848c7$var$reIsPlainProp.test(value) || !$b59722a6ac8848c7$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $b59722a6ac8848c7$var$isKey;

});
parcelRegister("jK5ch", function(module, exports) {

var $8t6rv = parcelRequire("8t6rv");

var $b6nDQ = parcelRequire("b6nDQ");
/** `Object#toString` result references. */ var $e5f65840e96acbe7$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e5f65840e96acbe7$var$isSymbol(value) {
    return typeof value == 'symbol' || $b6nDQ(value) && $8t6rv(value) == $e5f65840e96acbe7$var$symbolTag;
}
module.exports = $e5f65840e96acbe7$var$isSymbol;

});


parcelRegister("lqErr", function(module, exports) {

var $ag8MD = parcelRequire("ag8MD");
/** Used to match property names within property paths. */ var $f99b658db4391157$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f99b658db4391157$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f99b658db4391157$var$stringToPath = $ag8MD(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f99b658db4391157$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f99b658db4391157$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $f99b658db4391157$var$stringToPath;

});
parcelRegister("ag8MD", function(module, exports) {

var $5yW8f = parcelRequire("5yW8f");
/** Used as the maximum memoize cache size. */ var $77823637bc10f7a5$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $77823637bc10f7a5$var$memoizeCapped(func) {
    var result = $5yW8f(func, function(key) {
        if (cache.size === $77823637bc10f7a5$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $77823637bc10f7a5$var$memoizeCapped;

});
parcelRegister("5yW8f", function(module, exports) {

var $4PRkI = parcelRequire("4PRkI");
/** Error message constants. */ var $40cd3886c4d2da86$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $40cd3886c4d2da86$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($40cd3886c4d2da86$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($40cd3886c4d2da86$var$memoize.Cache || $4PRkI);
    return memoized;
}
// Expose `MapCache`.
$40cd3886c4d2da86$var$memoize.Cache = $4PRkI;
module.exports = $40cd3886c4d2da86$var$memoize;

});



parcelRegister("bDVqc", function(module, exports) {

var $1jDe0 = parcelRequire("1jDe0");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $879fe0f68510f56a$var$toString(value) {
    return value == null ? '' : $1jDe0(value);
}
module.exports = $879fe0f68510f56a$var$toString;

});
parcelRegister("1jDe0", function(module, exports) {

var $2LyK3 = parcelRequire("2LyK3");

var $8Qvsd = parcelRequire("8Qvsd");

var $u1Zdx = parcelRequire("u1Zdx");

var $jK5ch = parcelRequire("jK5ch");
/** Used as references for various `Number` constants. */ var $0f55fe04bc4df51b$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $0f55fe04bc4df51b$var$symbolProto = $2LyK3 ? $2LyK3.prototype : undefined, $0f55fe04bc4df51b$var$symbolToString = $0f55fe04bc4df51b$var$symbolProto ? $0f55fe04bc4df51b$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $0f55fe04bc4df51b$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($u1Zdx(value)) // Recursively convert values (susceptible to call stack limits).
    return $8Qvsd(value, $0f55fe04bc4df51b$var$baseToString) + '';
    if ($jK5ch(value)) return $0f55fe04bc4df51b$var$symbolToString ? $0f55fe04bc4df51b$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$0f55fe04bc4df51b$var$INFINITY ? '-0' : result;
}
module.exports = $0f55fe04bc4df51b$var$baseToString;

});
parcelRegister("8Qvsd", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $670b9433edf3f450$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $670b9433edf3f450$var$arrayMap;

});




parcelRegister("1DDv1", function(module, exports) {

var $jK5ch = parcelRequire("jK5ch");
/** Used as references for various `Number` constants. */ var $131812afc725bc5e$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $131812afc725bc5e$var$toKey(value) {
    if (typeof value == 'string' || $jK5ch(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$131812afc725bc5e$var$INFINITY ? '-0' : result;
}
module.exports = $131812afc725bc5e$var$toKey;

});



parcelRegister("l7WY8", function(module, exports) {

var $kXjLm = parcelRequire("kXjLm");

var $c8BRx = parcelRequire("c8BRx");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $f617fe6907ea1386$var$hasIn(object, path) {
    return object != null && $c8BRx(object, path, $kXjLm);
}
module.exports = $f617fe6907ea1386$var$hasIn;

});
parcelRegister("kXjLm", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f418a5d827601de6$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $f418a5d827601de6$var$baseHasIn;

});

parcelRegister("c8BRx", function(module, exports) {

var $7lN7R = parcelRequire("7lN7R");

var $ireFH = parcelRequire("ireFH");

var $u1Zdx = parcelRequire("u1Zdx");

var $lexYg = parcelRequire("lexYg");

var $jQ8Qj = parcelRequire("jQ8Qj");

var $1DDv1 = parcelRequire("1DDv1");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $8d639a163c19a6eb$var$hasPath(object, path, hasFunc) {
    path = $7lN7R(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $1DDv1(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $jQ8Qj(length) && $lexYg(key, length) && ($u1Zdx(object) || $ireFH(object));
}
module.exports = $8d639a163c19a6eb$var$hasPath;

});



parcelRegister("3uvNM", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $28acd7a68a900211$var$identity(value) {
    return value;
}
module.exports = $28acd7a68a900211$var$identity;

});

parcelRegister("aK0IP", function(module, exports) {

var $d8wBL = parcelRequire("d8wBL");

var $02jDR = parcelRequire("02jDR");

var $fABhm = parcelRequire("fABhm");

var $1DDv1 = parcelRequire("1DDv1");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $7d1ec2a5508fcf58$var$property(path) {
    return $fABhm(path) ? $d8wBL($1DDv1(path)) : $02jDR(path);
}
module.exports = $7d1ec2a5508fcf58$var$property;

});
parcelRegister("d8wBL", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $9905510346080339$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $9905510346080339$var$baseProperty;

});

parcelRegister("02jDR", function(module, exports) {

var $29blh = parcelRequire("29blh");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $006f6c80ebaa3610$var$basePropertyDeep(path) {
    return function(object) {
        return $29blh(object, path);
    };
}
module.exports = $006f6c80ebaa3610$var$basePropertyDeep;

});



parcelRegister("3ZHd7", function(module, exports) {
/** Error message constants. */ var $2e88964f52d0361f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $2e88964f52d0361f$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($2e88964f52d0361f$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = $2e88964f52d0361f$var$negate;

});

parcelRegister("bFQKe", function(module, exports) {

var $8Qvsd = parcelRequire("8Qvsd");

var $2b4jE = parcelRequire("2b4jE");

var $8jMNK = parcelRequire("8jMNK");

var $fpBIt = parcelRequire("fpBIt");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $87fc700688e03664$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $8Qvsd($fpBIt(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $2b4jE(predicate);
    return $8jMNK(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = $87fc700688e03664$var$pickBy;

});
parcelRegister("8jMNK", function(module, exports) {

var $29blh = parcelRequire("29blh");

var $eQSI7 = parcelRequire("eQSI7");

var $7lN7R = parcelRequire("7lN7R");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $60e5f40026d493b7$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $29blh(object, path);
        if (predicate(value, path)) $eQSI7(result, $7lN7R(path, object), value);
    }
    return result;
}
module.exports = $60e5f40026d493b7$var$basePickBy;

});
parcelRegister("eQSI7", function(module, exports) {

var $c8U2B = parcelRequire("c8U2B");

var $7lN7R = parcelRequire("7lN7R");

var $lexYg = parcelRequire("lexYg");

var $j7DJp = parcelRequire("j7DJp");

var $1DDv1 = parcelRequire("1DDv1");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $ad005c6b0f20bc0b$var$baseSet(object, path, value, customizer) {
    if (!$j7DJp(object)) return object;
    path = $7lN7R(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $1DDv1(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $j7DJp(objValue) ? objValue : $lexYg(path[index + 1]) ? [] : {};
        }
        $c8U2B(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $ad005c6b0f20bc0b$var$baseSet;

});
parcelRegister("c8U2B", function(module, exports) {

var $9MKrk = parcelRequire("9MKrk");

var $4Q3b3 = parcelRequire("4Q3b3");
/** Used for built-in method references. */ var $8d71b3f29a633acb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8d71b3f29a633acb$var$hasOwnProperty = $8d71b3f29a633acb$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $8d71b3f29a633acb$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($8d71b3f29a633acb$var$hasOwnProperty.call(object, key) && $4Q3b3(objValue, value)) || value === undefined && !(key in object)) $9MKrk(object, key, value);
}
module.exports = $8d71b3f29a633acb$var$assignValue;

});
parcelRegister("9MKrk", function(module, exports) {

var $a58ZP = parcelRequire("a58ZP");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $71fc9ebd5ea05ba1$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $a58ZP) $a58ZP(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $71fc9ebd5ea05ba1$var$baseAssignValue;

});
parcelRegister("a58ZP", function(module, exports) {

var $7GxQ0 = parcelRequire("7GxQ0");
var $7571597748e37026$var$defineProperty = function() {
    try {
        var func = $7GxQ0(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $7571597748e37026$var$defineProperty;

});





parcelRegister("fpBIt", function(module, exports) {

var $g8d0G = parcelRequire("g8d0G");

var $9rivZ = parcelRequire("9rivZ");

var $gLcp5 = parcelRequire("gLcp5");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b3867276b83da02a$var$getAllKeysIn(object) {
    return $g8d0G(object, $gLcp5, $9rivZ);
}
module.exports = $b3867276b83da02a$var$getAllKeysIn;

});
parcelRegister("9rivZ", function(module, exports) {

var $icCJ2 = parcelRequire("icCJ2");

var $pJ185 = parcelRequire("pJ185");

var $f4Un0 = parcelRequire("f4Un0");

var $1n6Oe = parcelRequire("1n6Oe");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6df4ff5d8c08fafb$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6df4ff5d8c08fafb$var$getSymbolsIn = !$6df4ff5d8c08fafb$var$nativeGetSymbols ? $1n6Oe : function(object) {
    var result = [];
    while(object){
        $icCJ2(result, $f4Un0(object));
        object = $pJ185(object);
    }
    return result;
};
module.exports = $6df4ff5d8c08fafb$var$getSymbolsIn;

});
parcelRegister("pJ185", function(module, exports) {

var $lEzIf = parcelRequire("lEzIf");
/** Built-in value references. */ var $04d5416539c48b06$var$getPrototype = $lEzIf(Object.getPrototypeOf, Object);
module.exports = $04d5416539c48b06$var$getPrototype;

});


parcelRegister("gLcp5", function(module, exports) {

var $9qPNR = parcelRequire("9qPNR");

var $bVeF8 = parcelRequire("bVeF8");

var $eG4u6 = parcelRequire("eG4u6");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $c33aa8388e466fb6$var$keysIn(object) {
    return $eG4u6(object) ? $9qPNR(object, true) : $bVeF8(object);
}
module.exports = $c33aa8388e466fb6$var$keysIn;

});
parcelRegister("bVeF8", function(module, exports) {

var $j7DJp = parcelRequire("j7DJp");

var $c5V8J = parcelRequire("c5V8J");

var $wCawP = parcelRequire("wCawP");
/** Used for built-in method references. */ var $8ae0643a725cf70a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8ae0643a725cf70a$var$hasOwnProperty = $8ae0643a725cf70a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8ae0643a725cf70a$var$baseKeysIn(object) {
    if (!$j7DJp(object)) return $wCawP(object);
    var isProto = $c5V8J(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$8ae0643a725cf70a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $8ae0643a725cf70a$var$baseKeysIn;

});
parcelRegister("wCawP", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $062098ce0e75056f$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $062098ce0e75056f$var$nativeKeysIn;

});






parcelRegister("7ioXG", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsType", () => $0d58590e6d4e8d8b$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $0d58590e6d4e8d8b$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $0d58590e6d4e8d8b$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $0d58590e6d4e8d8b$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $0d58590e6d4e8d8b$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $0d58590e6d4e8d8b$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $0d58590e6d4e8d8b$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $0d58590e6d4e8d8b$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $0d58590e6d4e8d8b$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $0d58590e6d4e8d8b$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $0d58590e6d4e8d8b$export$af63d7414243dad3);

var $aFboM = parcelRequire("aFboM");

var $6uLHU = parcelRequire("6uLHU");

var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $ljlVI = parcelRequire("ljlVI");

var $cw4ow = parcelRequire("cw4ow");
const $0d58590e6d4e8d8b$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $0d58590e6d4e8d8b$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $0d58590e6d4e8d8b$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $0d58590e6d4e8d8b$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $0d58590e6d4e8d8b$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($ljlVI)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uLHU))));
};
const $0d58590e6d4e8d8b$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))($0d58590e6d4e8d8b$var$extractFromContext(event, 'source').filter(Boolean));
const $0d58590e6d4e8d8b$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))($0d58590e6d4e8d8b$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))($0d58590e6d4e8d8b$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $0d58590e6d4e8d8b$export$6ca3170acb89054 = (event)=>event.payload.action;
const $0d58590e6d4e8d8b$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $0d58590e6d4e8d8b$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))($0d58590e6d4e8d8b$var$extractFromContext(event, 'containerId').filter(Boolean));
const $0d58590e6d4e8d8b$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))($0d58590e6d4e8d8b$var$extractFromContext(event, 'containerType').filter(Boolean));
const $0d58590e6d4e8d8b$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))($0d58590e6d4e8d8b$var$extractFromContext(event, 'objectId').filter(Boolean));
const $0d58590e6d4e8d8b$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))($0d58590e6d4e8d8b$var$extractFromContext(event, 'objectType').filter(Boolean));
const $0d58590e6d4e8d8b$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($cw4ow)))((0, (/*@__PURE__*/$parcel$interopDefault($aFboM)))($0d58590e6d4e8d8b$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});
parcelRegister("aFboM", function(module, exports) {

var $4EmqQ = parcelRequire("4EmqQ");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $7c369345b7fb75e0$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $4EmqQ(array, 1) : [];
}
module.exports = $7c369345b7fb75e0$var$flatten;

});
parcelRegister("4EmqQ", function(module, exports) {

var $icCJ2 = parcelRequire("icCJ2");

var $btv6i = parcelRequire("btv6i");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $362c4c64f83a2c9d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $btv6i);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $362c4c64f83a2c9d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $icCJ2(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $362c4c64f83a2c9d$var$baseFlatten;

});
parcelRegister("btv6i", function(module, exports) {

var $2LyK3 = parcelRequire("2LyK3");

var $ireFH = parcelRequire("ireFH");

var $u1Zdx = parcelRequire("u1Zdx");
/** Built-in value references. */ var $85aa870e43028d09$var$spreadableSymbol = $2LyK3 ? $2LyK3.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $85aa870e43028d09$var$isFlattenable(value) {
    return $u1Zdx(value) || $ireFH(value) || !!($85aa870e43028d09$var$spreadableSymbol && value && value[$85aa870e43028d09$var$spreadableSymbol]);
}
module.exports = $85aa870e43028d09$var$isFlattenable;

});



parcelRegister("eKg28", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $abc1cc77f1e0ac87$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $abc1cc77f1e0ac87$var$last;

});

parcelRegister("4BY1L", function(module, exports) {

var $dDSld = parcelRequire("dDSld");

var $ccBx4 = parcelRequire("ccBx4");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $35b92e55ebdfdd50$var$merge = $ccBx4(function(object, source, srcIndex) {
    $dDSld(object, source, srcIndex);
});
module.exports = $35b92e55ebdfdd50$var$merge;

});
parcelRegister("dDSld", function(module, exports) {

var $h0gnZ = parcelRequire("h0gnZ");

var $75okT = parcelRequire("75okT");

var $2nwas = parcelRequire("2nwas");

var $7kVFn = parcelRequire("7kVFn");

var $j7DJp = parcelRequire("j7DJp");

var $gLcp5 = parcelRequire("gLcp5");

var $j5u1P = parcelRequire("j5u1P");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $9ee911e6a0bb7ece$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $2nwas(source, function(srcValue, key) {
        stack || (stack = new $h0gnZ);
        if ($j7DJp(srcValue)) $7kVFn(object, source, key, srcIndex, $9ee911e6a0bb7ece$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($j5u1P(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $75okT(object, key, newValue);
        }
    }, $gLcp5);
}
module.exports = $9ee911e6a0bb7ece$var$baseMerge;

});
parcelRegister("75okT", function(module, exports) {

var $9MKrk = parcelRequire("9MKrk");

var $4Q3b3 = parcelRequire("4Q3b3");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $528be0a871a9587e$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$4Q3b3(object[key], value) || value === undefined && !(key in object)) $9MKrk(object, key, value);
}
module.exports = $528be0a871a9587e$var$assignMergeValue;

});

parcelRegister("2nwas", function(module, exports) {

var $jH6Tb = parcelRequire("jH6Tb");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $1bb6ae910a2f1f6d$var$baseFor = $jH6Tb();
module.exports = $1bb6ae910a2f1f6d$var$baseFor;

});
parcelRegister("jH6Tb", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e567607cc7a07731$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $e567607cc7a07731$var$createBaseFor;

});


parcelRegister("7kVFn", function(module, exports) {

var $75okT = parcelRequire("75okT");

var $7Qql0 = parcelRequire("7Qql0");

var $e5SPB = parcelRequire("e5SPB");

var $yPhrz = parcelRequire("yPhrz");

var $4mZYy = parcelRequire("4mZYy");

var $ireFH = parcelRequire("ireFH");

var $u1Zdx = parcelRequire("u1Zdx");

var $7yLOE = parcelRequire("7yLOE");

var $eSjJt = parcelRequire("eSjJt");

var $jgzbA = parcelRequire("jgzbA");

var $j7DJp = parcelRequire("j7DJp");

var $9G25R = parcelRequire("9G25R");

var $89P5Q = parcelRequire("89P5Q");

var $j5u1P = parcelRequire("j5u1P");

var $b46ui = parcelRequire("b46ui");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $557721fa1565042d$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $j5u1P(object, key), srcValue = $j5u1P(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $75okT(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $u1Zdx(srcValue), isBuff = !isArr && $eSjJt(srcValue), isTyped = !isArr && !isBuff && $89P5Q(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($u1Zdx(objValue)) newValue = objValue;
            else if ($7yLOE(objValue)) newValue = $yPhrz(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $7Qql0(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $e5SPB(srcValue, true);
            } else newValue = [];
        } else if ($9G25R(srcValue) || $ireFH(srcValue)) {
            newValue = objValue;
            if ($ireFH(objValue)) newValue = $b46ui(objValue);
            else if (!$j7DJp(objValue) || $jgzbA(objValue)) newValue = $4mZYy(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $75okT(object, key, newValue);
}
module.exports = $557721fa1565042d$var$baseMergeDeep;

});
parcelRegister("7Qql0", function(module, exports) {

var $gTpPE = parcelRequire("gTpPE");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $gTpPE.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("e5SPB", function(module, exports) {

var $pY1cd = parcelRequire("pY1cd");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $a42c10ad9d915e3d$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $pY1cd(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $a42c10ad9d915e3d$var$cloneTypedArray;

});
parcelRegister("pY1cd", function(module, exports) {

var $c0Swu = parcelRequire("c0Swu");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $04e0e44bf99527c6$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $c0Swu(result).set(new $c0Swu(arrayBuffer));
    return result;
}
module.exports = $04e0e44bf99527c6$var$cloneArrayBuffer;

});


parcelRegister("yPhrz", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $068af44cd7091f55$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $068af44cd7091f55$var$copyArray;

});

parcelRegister("4mZYy", function(module, exports) {

var $lnJKK = parcelRequire("lnJKK");

var $pJ185 = parcelRequire("pJ185");

var $c5V8J = parcelRequire("c5V8J");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $32e94a925ea01457$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$c5V8J(object) ? $lnJKK($pJ185(object)) : {};
}
module.exports = $32e94a925ea01457$var$initCloneObject;

});
parcelRegister("lnJKK", function(module, exports) {

var $j7DJp = parcelRequire("j7DJp");
/** Built-in value references. */ var $f90f3c8ec53ae3ca$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $f90f3c8ec53ae3ca$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$j7DJp(proto)) return {};
        if ($f90f3c8ec53ae3ca$var$objectCreate) return $f90f3c8ec53ae3ca$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $f90f3c8ec53ae3ca$var$baseCreate;

});


parcelRegister("7yLOE", function(module, exports) {

var $eG4u6 = parcelRequire("eG4u6");

var $b6nDQ = parcelRequire("b6nDQ");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $5810cc9c67263af0$var$isArrayLikeObject(value) {
    return $b6nDQ(value) && $eG4u6(value);
}
module.exports = $5810cc9c67263af0$var$isArrayLikeObject;

});

parcelRegister("9G25R", function(module, exports) {

var $8t6rv = parcelRequire("8t6rv");

var $pJ185 = parcelRequire("pJ185");

var $b6nDQ = parcelRequire("b6nDQ");
/** `Object#toString` result references. */ var $70b9a90e41e3fe02$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $70b9a90e41e3fe02$var$funcProto = Function.prototype, $70b9a90e41e3fe02$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $70b9a90e41e3fe02$var$funcToString = $70b9a90e41e3fe02$var$funcProto.toString;
/** Used to check objects for own properties. */ var $70b9a90e41e3fe02$var$hasOwnProperty = $70b9a90e41e3fe02$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $70b9a90e41e3fe02$var$objectCtorString = $70b9a90e41e3fe02$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $70b9a90e41e3fe02$var$isPlainObject(value) {
    if (!$b6nDQ(value) || $8t6rv(value) != $70b9a90e41e3fe02$var$objectTag) return false;
    var proto = $pJ185(value);
    if (proto === null) return true;
    var Ctor = $70b9a90e41e3fe02$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $70b9a90e41e3fe02$var$funcToString.call(Ctor) == $70b9a90e41e3fe02$var$objectCtorString;
}
module.exports = $70b9a90e41e3fe02$var$isPlainObject;

});

parcelRegister("j5u1P", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $de55c6f5a8ef81a9$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $de55c6f5a8ef81a9$var$safeGet;

});

parcelRegister("b46ui", function(module, exports) {

var $fISzQ = parcelRequire("fISzQ");

var $gLcp5 = parcelRequire("gLcp5");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $80e519c3498cb89e$var$toPlainObject(value) {
    return $fISzQ(value, $gLcp5(value));
}
module.exports = $80e519c3498cb89e$var$toPlainObject;

});
parcelRegister("fISzQ", function(module, exports) {

var $c8U2B = parcelRequire("c8U2B");

var $9MKrk = parcelRequire("9MKrk");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $b7254cf1d5c3e5dc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $9MKrk(object, key, newValue);
        else $c8U2B(object, key, newValue);
    }
    return object;
}
module.exports = $b7254cf1d5c3e5dc$var$copyObject;

});




parcelRegister("ccBx4", function(module, exports) {

var $1cUsb = parcelRequire("1cUsb");

var $dRQeC = parcelRequire("dRQeC");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $8e23b831a8b328dd$var$createAssigner(assigner) {
    return $1cUsb(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $dRQeC(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $8e23b831a8b328dd$var$createAssigner;

});
parcelRegister("1cUsb", function(module, exports) {

var $3uvNM = parcelRequire("3uvNM");

var $cw0V9 = parcelRequire("cw0V9");

var $g3T4p = parcelRequire("g3T4p");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $0e12b3ee5bb18a7f$var$baseRest(func, start) {
    return $g3T4p($cw0V9(func, start, $3uvNM), func + '');
}
module.exports = $0e12b3ee5bb18a7f$var$baseRest;

});
parcelRegister("cw0V9", function(module, exports) {

var $d5wFU = parcelRequire("d5wFU");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $91c9301004137d36$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $91c9301004137d36$var$overRest(func, start, transform) {
    start = $91c9301004137d36$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $91c9301004137d36$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $d5wFU(func, this, otherArgs);
    };
}
module.exports = $91c9301004137d36$var$overRest;

});
parcelRegister("d5wFU", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $98751692107f54c2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $98751692107f54c2$var$apply;

});


parcelRegister("g3T4p", function(module, exports) {

var $6wghe = parcelRequire("6wghe");

var $lU7d1 = parcelRequire("lU7d1");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $bb17a4ee6f57d9a4$var$setToString = $lU7d1($6wghe);
module.exports = $bb17a4ee6f57d9a4$var$setToString;

});
parcelRegister("6wghe", function(module, exports) {

var $1zTXj = parcelRequire("1zTXj");

var $a58ZP = parcelRequire("a58ZP");

var $3uvNM = parcelRequire("3uvNM");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4bf25b7e172b8df5$var$baseSetToString = !$a58ZP ? $3uvNM : function(func, string) {
    return $a58ZP(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $1zTXj(string),
        'writable': true
    });
};
module.exports = $4bf25b7e172b8df5$var$baseSetToString;

});
parcelRegister("1zTXj", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $126476f8a9e22c65$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $126476f8a9e22c65$var$constant;

});


parcelRegister("lU7d1", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $ff246b7b72f5266e$var$HOT_COUNT = 800, $ff246b7b72f5266e$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ff246b7b72f5266e$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $ff246b7b72f5266e$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $ff246b7b72f5266e$var$nativeNow(), remaining = $ff246b7b72f5266e$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $ff246b7b72f5266e$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $ff246b7b72f5266e$var$shortOut;

});



parcelRegister("dRQeC", function(module, exports) {

var $4Q3b3 = parcelRequire("4Q3b3");

var $eG4u6 = parcelRequire("eG4u6");

var $lexYg = parcelRequire("lexYg");

var $j7DJp = parcelRequire("j7DJp");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $a188be5443334fd4$var$isIterateeCall(value, index, object) {
    if (!$j7DJp(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $eG4u6(object) && $lexYg(index, object.length) : type == 'string' && index in object) return $4Q3b3(object[index], value);
    return false;
}
module.exports = $a188be5443334fd4$var$isIterateeCall;

});



parcelRegister("cw4ow", function(module, exports) {

var $9ynuU = parcelRequire("9ynuU");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $91cbe1d41663310b$var$uniq(array) {
    return array && array.length ? $9ynuU(array) : [];
}
module.exports = $91cbe1d41663310b$var$uniq;

});
parcelRegister("9ynuU", function(module, exports) {

var $2tHRa = parcelRequire("2tHRa");

var $2UH9P = parcelRequire("2UH9P");

var $5b81o = parcelRequire("5b81o");

var $3tkIe = parcelRequire("3tkIe");

var $ad1g7 = parcelRequire("ad1g7");

var $b3aAi = parcelRequire("b3aAi");
/** Used as the size to enable large array optimizations. */ var $6f49842c33a004e8$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $6f49842c33a004e8$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $2UH9P, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $5b81o;
    } else if (length >= $6f49842c33a004e8$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $ad1g7(array);
        if (set) return $b3aAi(set);
        isCommon = false;
        includes = $3tkIe;
        seen = new $2tHRa;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6f49842c33a004e8$var$baseUniq;

});
parcelRegister("2UH9P", function(module, exports) {

var $lrhJ3 = parcelRequire("lrhJ3");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $21f249e9fe354892$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $lrhJ3(array, value, 0) > -1;
}
module.exports = $21f249e9fe354892$var$arrayIncludes;

});
parcelRegister("lrhJ3", function(module, exports) {

var $bD57f = parcelRequire("bD57f");

var $f4bta = parcelRequire("f4bta");

var $jm6bJ = parcelRequire("jm6bJ");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f9b9de8f724438bb$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jm6bJ(array, value, fromIndex) : $bD57f(array, $f4bta, fromIndex);
}
module.exports = $f9b9de8f724438bb$var$baseIndexOf;

});
parcelRegister("bD57f", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87774e1d97fc2e6c$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $87774e1d97fc2e6c$var$baseFindIndex;

});

parcelRegister("f4bta", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $af80205759d9b473$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $af80205759d9b473$var$baseIsNaN;

});

parcelRegister("jm6bJ", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e174df434cf74774$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e174df434cf74774$var$strictIndexOf;

});



parcelRegister("5b81o", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $3c5433bf19ef4cc2$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $3c5433bf19ef4cc2$var$arrayIncludesWith;

});

parcelRegister("ad1g7", function(module, exports) {

var $3ddYs = parcelRequire("3ddYs");

var $7PRFC = parcelRequire("7PRFC");

var $b3aAi = parcelRequire("b3aAi");
/** Used as references for various `Number` constants. */ var $76ec184c395433ff$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $76ec184c395433ff$var$createSet = !($3ddYs && 1 / $b3aAi(new $3ddYs([
    ,
    -0
]))[1] == $76ec184c395433ff$var$INFINITY) ? $7PRFC : function(values) {
    return new $3ddYs(values);
};
module.exports = $76ec184c395433ff$var$createSet;

});
parcelRegister("7PRFC", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $5b46eda46dd77611$var$noop() {
// No operation performed.
}
module.exports = $5b46eda46dd77611$var$noop;

});






parcelRegister("iziiq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestEvent = module.exports.OPERATIONAL_EVENT_TYPE = module.exports.SCREEN_EVENT_TYPE = module.exports.TRACK_EVENT_TYPE = module.exports.UI_EVENT_TYPE = module.exports.getEvent = module.exports.MountEvent = module.exports.fireAnalyticsEvent = module.exports.withAnalyticsContext = module.exports.AnalyticsContext = module.exports.EventTypes = module.exports.ScreenTypes = undefined;

var $bQrep = parcelRequire("bQrep");
Object.defineProperty(module.exports, 'ScreenTypes', {
    enumerable: true,
    get: function get() {
        return $bQrep.ScreenTypes;
    }
});
Object.defineProperty(module.exports, 'EventTypes', {
    enumerable: true,
    get: function get() {
        return $bQrep.EventTypes;
    }
});
Object.defineProperty(module.exports, 'UI_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $bQrep.UI_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'TRACK_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $bQrep.TRACK_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'SCREEN_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $bQrep.SCREEN_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'OPERATIONAL_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $bQrep.OPERATIONAL_EVENT_TYPE;
    }
});

var $3VwIi = parcelRequire("3VwIi");
Object.defineProperty(module.exports, 'createTestEvent', {
    enumerable: true,
    get: function get() {
        return $3VwIi.createTestEvent;
    }
});

var $9sPDn = parcelRequire("9sPDn");
var $d849b01e412db598$var$_analyticsContext2 = $d849b01e412db598$var$_interopRequireDefault($9sPDn);

var $26Ik8 = parcelRequire("26Ik8");
var $d849b01e412db598$var$_mountEvent2 = $d849b01e412db598$var$_interopRequireDefault($26Ik8);

var $jtI2d = parcelRequire("jtI2d");
var $d849b01e412db598$var$_withAnalyticsContext2 = $d849b01e412db598$var$_interopRequireDefault($jtI2d);

var $5Fg3O = parcelRequire("5Fg3O");
var $d849b01e412db598$var$_fireAnalyticsEvent2 = $d849b01e412db598$var$_interopRequireDefault($5Fg3O);

var $e7EyD = parcelRequire("e7EyD");
var $d849b01e412db598$var$_getEventForWebClient2 = $d849b01e412db598$var$_interopRequireDefault($e7EyD);
function $d849b01e412db598$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.AnalyticsContext = $d849b01e412db598$var$_analyticsContext2.default;
module.exports.withAnalyticsContext = $d849b01e412db598$var$_withAnalyticsContext2.default;
module.exports.fireAnalyticsEvent = $d849b01e412db598$var$_fireAnalyticsEvent2.default;
module.exports.MountEvent = $d849b01e412db598$var$_mountEvent2.default;
module.exports.getEvent = $d849b01e412db598$var$_getEventForWebClient2.default;

});
parcelRegister("bQrep", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * ANALYTICS WEB CLIENT EVENTS
 */ var $89f9ac9a70161259$var$UI_EVENT_TYPE = module.exports.UI_EVENT_TYPE = 'UI';
var $89f9ac9a70161259$var$TRACK_EVENT_TYPE = module.exports.TRACK_EVENT_TYPE = 'TRACK';
var $89f9ac9a70161259$var$SCREEN_EVENT_TYPE = module.exports.SCREEN_EVENT_TYPE = 'SCREEN';
var $89f9ac9a70161259$var$OPERATIONAL_EVENT_TYPE = module.exports.OPERATIONAL_EVENT_TYPE = 'OPERATIONAL';
/**
 * END ANALYTICS WEB CLIENT EVENTS
 */ var $89f9ac9a70161259$var$PAGE_EVENT_ACTION = module.exports.PAGE_EVENT_ACTION = 'page-view';
var $89f9ac9a70161259$var$SCREEN = module.exports.SCREEN = 'Screen';
var $89f9ac9a70161259$var$DRAWER = module.exports.DRAWER = 'Drawer';
var $89f9ac9a70161259$var$MODAL = module.exports.MODAL = 'Modal';
var $89f9ac9a70161259$var$INLINE_DIALOG = module.exports.INLINE_DIALOG = 'InlineDialog';
var $89f9ac9a70161259$var$DROPDOWN = module.exports.DROPDOWN = 'Dropdown';
var $89f9ac9a70161259$var$ScreenTypes = module.exports.ScreenTypes = {
    SCREEN: $89f9ac9a70161259$var$SCREEN,
    MODAL: $89f9ac9a70161259$var$MODAL,
    DRAWER: $89f9ac9a70161259$var$DRAWER,
    INLINE_DIALOG: $89f9ac9a70161259$var$INLINE_DIALOG,
    DROPDOWN: $89f9ac9a70161259$var$DROPDOWN
};
var $89f9ac9a70161259$var$EventTypes = module.exports.EventTypes = {
    UI: $89f9ac9a70161259$var$UI_EVENT_TYPE,
    TRACK: $89f9ac9a70161259$var$TRACK_EVENT_TYPE,
    SCREEN: $89f9ac9a70161259$var$SCREEN_EVENT_TYPE,
    OPERATIONAL: $89f9ac9a70161259$var$OPERATIONAL_EVENT_TYPE
};

});

parcelRegister("3VwIi", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestEvent = undefined;

var $hlZhv = parcelRequire("hlZhv");
var $2dc01230f3403151$var$createTestEvent = module.exports.createTestEvent = function createTestEvent() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        payload: {
            action: 'thisIsADumyAction'
        }
    };
    return new $hlZhv.default(payload);
};

});
parcelRegister("hlZhv", function(module, exports) {
$parcel$export(module.exports, "isUIAnalyticsEvent", () => $7b309bf181a0a835$export$35f8383928ba8d7);
$parcel$export(module.exports, "default", () => $7b309bf181a0a835$export$2e2bcd8739ae039);
/// <reference types="node" />

var $4C9Oe = parcelRequire("4C9Oe");
const $7b309bf181a0a835$export$35f8383928ba8d7 = (obj)=>{
    var _obj$constructor;
    return obj instanceof $7b309bf181a0a835$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
class $7b309bf181a0a835$export$2e2bcd8739ae039 extends (0, $4C9Oe.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
     * A hacky "deep clone" of the object. This is limited in that it wont
     * support functions, regexs, Maps, Sets, etc, but none of those need to
     * be represented in our payload.
     */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $7b309bf181a0a835$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("4C9Oe", function(module, exports) {
$parcel$export(module.exports, "isAnalyticsEvent", () => $233ac3420b8ab533$export$ad4be5c2ec28cecf);
$parcel$export(module.exports, "default", () => $233ac3420b8ab533$export$2e2bcd8739ae039);
const $233ac3420b8ab533$export$ad4be5c2ec28cecf = (obj)=>{
    var _obj$constructor;
    return obj instanceof $233ac3420b8ab533$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
class $233ac3420b8ab533$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $233ac3420b8ab533$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});



parcelRegister("9sPDn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4xqTJ = parcelRequire("4xqTJ");
var $6e3ec80566da3783$var$_getPrototypeOf2 = $6e3ec80566da3783$var$_interopRequireDefault($4xqTJ);

var $5TXFC = parcelRequire("5TXFC");
var $6e3ec80566da3783$var$_classCallCheck3 = $6e3ec80566da3783$var$_interopRequireDefault($5TXFC);

var $aqT68 = parcelRequire("aqT68");
var $6e3ec80566da3783$var$_createClass3 = $6e3ec80566da3783$var$_interopRequireDefault($aqT68);

var $elXYp = parcelRequire("elXYp");
var $6e3ec80566da3783$var$_possibleConstructorReturn3 = $6e3ec80566da3783$var$_interopRequireDefault($elXYp);

var $iLcSb = parcelRequire("iLcSb");
var $6e3ec80566da3783$var$_inherits3 = $6e3ec80566da3783$var$_interopRequireDefault($iLcSb);

var $8P7DW = parcelRequire("8P7DW");
var $6e3ec80566da3783$var$_react2 = $6e3ec80566da3783$var$_interopRequireDefault($8P7DW);

var $8gu7I = parcelRequire("8gu7I");

var $9k519 = parcelRequire("9k519");
var $6e3ec80566da3783$var$_createContextData2 = $6e3ec80566da3783$var$_interopRequireDefault($9k519);
function $6e3ec80566da3783$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6e3ec80566da3783$var$AnalyticsContextWrapper = function(_Component) {
    (0, $6e3ec80566da3783$var$_inherits3.default)(AnalyticsContextWrapper, _Component);
    function AnalyticsContextWrapper() {
        (0, $6e3ec80566da3783$var$_classCallCheck3.default)(this, AnalyticsContextWrapper);
        return (0, $6e3ec80566da3783$var$_possibleConstructorReturn3.default)(this, (AnalyticsContextWrapper.__proto__ || (0, $6e3ec80566da3783$var$_getPrototypeOf2.default)(AnalyticsContextWrapper)).apply(this, arguments));
    }
    (0, $6e3ec80566da3783$var$_createClass3.default)(AnalyticsContextWrapper, [
        {
            key: 'render',
            value: function render() {
                var data = (0, $6e3ec80566da3783$var$_createContextData2.default)(this.props);
                return $6e3ec80566da3783$var$_react2.default.createElement($8gu7I.default, {
                    data: data
                }, this.props.children);
            }
        }
    ]);
    return AnalyticsContextWrapper;
}($8P7DW.Component);
module.exports.default = $6e3ec80566da3783$var$AnalyticsContextWrapper;

});
parcelRegister("4xqTJ", function(module, exports) {

module.exports = {
    "default": (parcelRequire("1NJif")),
    __esModule: true
};

});
parcelRegister("1NJif", function(module, exports) {
parcelRequire("g4rv4");

module.exports = (parcelRequire("6O9ss")).Object.getPrototypeOf;

});
parcelRegister("g4rv4", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $Nc4D4 = parcelRequire("Nc4D4");

var $7mm1R = parcelRequire("7mm1R");

(parcelRequire("cLNTT"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $7mm1R($Nc4D4(it));
    };
});

});
parcelRegister("Nc4D4", function(module, exports) {
// 7.1.13 ToObject(argument)

var $5U3Pf = parcelRequire("5U3Pf");
module.exports = function(it) {
    return Object($5U3Pf(it));
};

});
parcelRegister("5U3Pf", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("7mm1R", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $5agjt = parcelRequire("5agjt");

var $Nc4D4 = parcelRequire("Nc4D4");

var $55bbacf6aa3028bc$var$IE_PROTO = (parcelRequire("78caH"))('IE_PROTO');
var $55bbacf6aa3028bc$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $Nc4D4(O);
    if ($5agjt(O, $55bbacf6aa3028bc$var$IE_PROTO)) return O[$55bbacf6aa3028bc$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $55bbacf6aa3028bc$var$ObjectProto : null;
};

});
parcelRegister("5agjt", function(module, exports) {
var $3c2a8a6069b6dd51$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $3c2a8a6069b6dd51$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("78caH", function(module, exports) {

var $5312b8c4a0612d84$var$shared = (parcelRequire("cPbj7"))('keys');

var $2nNTP = parcelRequire("2nNTP");
module.exports = function(key) {
    return $5312b8c4a0612d84$var$shared[key] || ($5312b8c4a0612d84$var$shared[key] = $2nNTP(key));
};

});
parcelRegister("cPbj7", function(module, exports) {

var $6O9ss = parcelRequire("6O9ss");

var $l4Hr5 = parcelRequire("l4Hr5");
var $956304db33589367$var$SHARED = '__core-js_shared__';
var $956304db33589367$var$store = $l4Hr5[$956304db33589367$var$SHARED] || ($l4Hr5[$956304db33589367$var$SHARED] = {});

(module.exports = function(key, value) {
    return $956304db33589367$var$store[key] || ($956304db33589367$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $6O9ss.version,
    mode: (parcelRequire("d0QN5")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("6O9ss", function(module, exports) {
var $4f4ebfbab13428b5$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $4f4ebfbab13428b5$var$core; // eslint-disable-line no-undef

});

parcelRegister("l4Hr5", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $f57baa2e6648bfcf$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $f57baa2e6648bfcf$var$global; // eslint-disable-line no-undef

});

parcelRegister("d0QN5", function(module, exports) {
module.exports = true;

});


parcelRegister("2nNTP", function(module, exports) {
var $1bc46fc1ffc04c8c$var$id = 0;
var $1bc46fc1ffc04c8c$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$1bc46fc1ffc04c8c$var$id + $1bc46fc1ffc04c8c$var$px).toString(36));
};

});



parcelRegister("cLNTT", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $i8prp = parcelRequire("i8prp");

var $6O9ss = parcelRequire("6O9ss");

var $lVNri = parcelRequire("lVNri");
module.exports = function(KEY, exec) {
    var fn = ($6O9ss.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $i8prp($i8prp.S + $i8prp.F * $lVNri(function() {
        fn(1);
    }), 'Object', exp);
};

});
parcelRegister("i8prp", function(module, exports) {

var $l4Hr5 = parcelRequire("l4Hr5");

var $6O9ss = parcelRequire("6O9ss");

var $6Zatx = parcelRequire("6Zatx");

var $2G8qW = parcelRequire("2G8qW");

var $5agjt = parcelRequire("5agjt");
var $d33cb56a1044f5f0$var$PROTOTYPE = 'prototype';
var $d33cb56a1044f5f0$var$$export = function(type, name, source) {
    var IS_FORCED = type & $d33cb56a1044f5f0$var$$export.F;
    var IS_GLOBAL = type & $d33cb56a1044f5f0$var$$export.G;
    var IS_STATIC = type & $d33cb56a1044f5f0$var$$export.S;
    var IS_PROTO = type & $d33cb56a1044f5f0$var$$export.P;
    var IS_BIND = type & $d33cb56a1044f5f0$var$$export.B;
    var IS_WRAP = type & $d33cb56a1044f5f0$var$$export.W;
    var exports = IS_GLOBAL ? $6O9ss : $6O9ss[name] || ($6O9ss[name] = {});
    var expProto = exports[$d33cb56a1044f5f0$var$PROTOTYPE];
    var target = IS_GLOBAL ? $l4Hr5 : IS_STATIC ? $l4Hr5[name] : ($l4Hr5[name] || {})[$d33cb56a1044f5f0$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $5agjt(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $6Zatx(out, $l4Hr5) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$d33cb56a1044f5f0$var$PROTOTYPE] = C[$d33cb56a1044f5f0$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $6Zatx(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $d33cb56a1044f5f0$var$$export.R && expProto && !expProto[key]) $2G8qW(expProto, key, out);
        }
    }
};
// type bitmap
$d33cb56a1044f5f0$var$$export.F = 1; // forced
$d33cb56a1044f5f0$var$$export.G = 2; // global
$d33cb56a1044f5f0$var$$export.S = 4; // static
$d33cb56a1044f5f0$var$$export.P = 8; // proto
$d33cb56a1044f5f0$var$$export.B = 16; // bind
$d33cb56a1044f5f0$var$$export.W = 32; // wrap
$d33cb56a1044f5f0$var$$export.U = 64; // safe
$d33cb56a1044f5f0$var$$export.R = 128; // real proto method for `library`
module.exports = $d33cb56a1044f5f0$var$$export;

});
parcelRegister("6Zatx", function(module, exports) {
// optional / simple context binding

var $iIRh8 = parcelRequire("iIRh8");
module.exports = function(fn, that, length) {
    $iIRh8(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("iIRh8", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("2G8qW", function(module, exports) {

var $8Lj0B = parcelRequire("8Lj0B");

var $iJSqT = parcelRequire("iJSqT");

module.exports = (parcelRequire("3mDMk")) ? function(object, key, value) {
    return $8Lj0B.f(object, key, $iJSqT(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("8Lj0B", function(module, exports) {
$parcel$export(module.exports, "f", () => $66117545b66f3336$export$2d1720544b23b823, (v) => $66117545b66f3336$export$2d1720544b23b823 = v);
var $66117545b66f3336$export$2d1720544b23b823;

var $64xJ3 = parcelRequire("64xJ3");

var $bWCC4 = parcelRequire("bWCC4");

var $cOR6I = parcelRequire("cOR6I");
var $66117545b66f3336$var$dP = Object.defineProperty;

$66117545b66f3336$export$2d1720544b23b823 = (parcelRequire("3mDMk")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $64xJ3(O);
    P = $cOR6I(P, true);
    $64xJ3(Attributes);
    if ($bWCC4) try {
        return $66117545b66f3336$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("64xJ3", function(module, exports) {

var $9cWk2 = parcelRequire("9cWk2");
module.exports = function(it) {
    if (!$9cWk2(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("9cWk2", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("bWCC4", function(module, exports) {



module.exports = !(parcelRequire("3mDMk")) && !(parcelRequire("lVNri"))(function() {
    return Object.defineProperty((parcelRequire("b70N3"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("3mDMk", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("lVNri"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("lVNri", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("b70N3", function(module, exports) {

var $9cWk2 = parcelRequire("9cWk2");

var $l4Hr5 = parcelRequire("l4Hr5");
var $8170f610e764a732$require$document = $l4Hr5.document;
// typeof document.createElement is 'object' in old IE
var $8170f610e764a732$var$is = $9cWk2($8170f610e764a732$require$document) && $9cWk2($8170f610e764a732$require$document.createElement);
module.exports = function(it) {
    return $8170f610e764a732$var$is ? $8170f610e764a732$require$document.createElement(it) : {};
};

});


parcelRegister("cOR6I", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $9cWk2 = parcelRequire("9cWk2");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$9cWk2(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$9cWk2(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$9cWk2(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$9cWk2(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("iJSqT", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});







parcelRegister("5TXFC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $44c060165e2fa224$export$1e511d4a378977f5, (v) => $44c060165e2fa224$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $44c060165e2fa224$export$2e2bcd8739ae039, (v) => $44c060165e2fa224$export$2e2bcd8739ae039 = v);
var $44c060165e2fa224$export$1e511d4a378977f5;
var $44c060165e2fa224$export$2e2bcd8739ae039;
"use strict";
$44c060165e2fa224$export$1e511d4a378977f5 = true;
$44c060165e2fa224$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("aqT68", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $7987126711c4643a$export$1e511d4a378977f5, (v) => $7987126711c4643a$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7987126711c4643a$export$2e2bcd8739ae039, (v) => $7987126711c4643a$export$2e2bcd8739ae039 = v);
var $7987126711c4643a$export$1e511d4a378977f5;
var $7987126711c4643a$export$2e2bcd8739ae039;
"use strict";
$7987126711c4643a$export$1e511d4a378977f5 = true;

var $3Uieq = parcelRequire("3Uieq");
var $7987126711c4643a$var$_defineProperty2 = $7987126711c4643a$var$_interopRequireDefault($3Uieq);
function $7987126711c4643a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$7987126711c4643a$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $7987126711c4643a$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("3Uieq", function(module, exports) {

module.exports = {
    "default": (parcelRequire("jMZru")),
    __esModule: true
};

});
parcelRegister("jMZru", function(module, exports) {
parcelRequire("7m2QM");

var $6O9ss = parcelRequire("6O9ss");
var $e68229341507e818$require$$Object = $6O9ss.Object;
module.exports = function defineProperty(it, key, desc) {
    return $e68229341507e818$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("7m2QM", function(module, exports) {

var $i8prp = parcelRequire("i8prp");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$i8prp($i8prp.S + $i8prp.F * !(parcelRequire("3mDMk")), 'Object', {
    defineProperty: (parcelRequire("8Lj0B")).f
});

});




parcelRegister("elXYp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $a7318c4c9b6f30a1$export$1e511d4a378977f5, (v) => $a7318c4c9b6f30a1$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $a7318c4c9b6f30a1$export$2e2bcd8739ae039, (v) => $a7318c4c9b6f30a1$export$2e2bcd8739ae039 = v);
var $a7318c4c9b6f30a1$export$1e511d4a378977f5;
var $a7318c4c9b6f30a1$export$2e2bcd8739ae039;
"use strict";
$a7318c4c9b6f30a1$export$1e511d4a378977f5 = true;

var $iRCw0 = parcelRequire("iRCw0");
var $a7318c4c9b6f30a1$var$_typeof3 = $a7318c4c9b6f30a1$var$_interopRequireDefault($iRCw0);
function $a7318c4c9b6f30a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a7318c4c9b6f30a1$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $a7318c4c9b6f30a1$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("iRCw0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $dbbb0d8a40b8b8aa$export$1e511d4a378977f5, (v) => $dbbb0d8a40b8b8aa$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $dbbb0d8a40b8b8aa$export$2e2bcd8739ae039, (v) => $dbbb0d8a40b8b8aa$export$2e2bcd8739ae039 = v);
var $dbbb0d8a40b8b8aa$export$1e511d4a378977f5;
var $dbbb0d8a40b8b8aa$export$2e2bcd8739ae039;
"use strict";
$dbbb0d8a40b8b8aa$export$1e511d4a378977f5 = true;

var $gcVHk = parcelRequire("gcVHk");
var $dbbb0d8a40b8b8aa$var$_iterator2 = $dbbb0d8a40b8b8aa$var$_interopRequireDefault($gcVHk);

var $lccab = parcelRequire("lccab");
var $dbbb0d8a40b8b8aa$var$_symbol2 = $dbbb0d8a40b8b8aa$var$_interopRequireDefault($lccab);
var $dbbb0d8a40b8b8aa$var$_typeof = typeof $dbbb0d8a40b8b8aa$var$_symbol2.default === "function" && typeof $dbbb0d8a40b8b8aa$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $dbbb0d8a40b8b8aa$var$_symbol2.default === "function" && obj.constructor === $dbbb0d8a40b8b8aa$var$_symbol2.default && obj !== $dbbb0d8a40b8b8aa$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $dbbb0d8a40b8b8aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$dbbb0d8a40b8b8aa$export$2e2bcd8739ae039 = typeof $dbbb0d8a40b8b8aa$var$_symbol2.default === "function" && $dbbb0d8a40b8b8aa$var$_typeof($dbbb0d8a40b8b8aa$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $dbbb0d8a40b8b8aa$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $dbbb0d8a40b8b8aa$var$_symbol2.default === "function" && obj.constructor === $dbbb0d8a40b8b8aa$var$_symbol2.default && obj !== $dbbb0d8a40b8b8aa$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $dbbb0d8a40b8b8aa$var$_typeof(obj);
};

});
parcelRegister("gcVHk", function(module, exports) {

module.exports = {
    "default": (parcelRequire("60ojM")),
    __esModule: true
};

});
parcelRegister("60ojM", function(module, exports) {
parcelRequire("9JGry");
parcelRequire("cONfo");

module.exports = (parcelRequire("21Q0n")).f('iterator');

});
parcelRegister("9JGry", function(module, exports) {
'use strict';

var $71693d622dd1bdbc$var$$at = (parcelRequire("dQVMF"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("5x6GT"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $71693d622dd1bdbc$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("dQVMF", function(module, exports) {

var $hJy5h = parcelRequire("hJy5h");

var $5U3Pf = parcelRequire("5U3Pf");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($5U3Pf(that));
        var i = $hJy5h(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});
parcelRegister("hJy5h", function(module, exports) {
// 7.1.4 ToInteger
var $ce9114099b464c08$var$ceil = Math.ceil;
var $ce9114099b464c08$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $ce9114099b464c08$var$floor : $ce9114099b464c08$var$ceil)(it);
};

});


parcelRegister("5x6GT", function(module, exports) {
'use strict';

var $d0QN5 = parcelRequire("d0QN5");

var $i8prp = parcelRequire("i8prp");

var $9jEIl = parcelRequire("9jEIl");

var $2G8qW = parcelRequire("2G8qW");

var $k9LSK = parcelRequire("k9LSK");

var $5EKgq = parcelRequire("5EKgq");

var $2xk2H = parcelRequire("2xk2H");

var $7mm1R = parcelRequire("7mm1R");

var $4075397607604985$var$ITERATOR = (parcelRequire("30Hzc"))('iterator');
var $4075397607604985$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $4075397607604985$var$FF_ITERATOR = '@@iterator';
var $4075397607604985$var$KEYS = 'keys';
var $4075397607604985$var$VALUES = 'values';
var $4075397607604985$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $5EKgq(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$4075397607604985$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $4075397607604985$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $4075397607604985$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $4075397607604985$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$4075397607604985$var$ITERATOR] || proto[$4075397607604985$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $7mm1R($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $2xk2H(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$d0QN5 && typeof IteratorPrototype[$4075397607604985$var$ITERATOR] != 'function') $2G8qW(IteratorPrototype, $4075397607604985$var$ITERATOR, $4075397607604985$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $4075397607604985$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$d0QN5 || FORCED) && ($4075397607604985$var$BUGGY || VALUES_BUG || !proto[$4075397607604985$var$ITERATOR])) $2G8qW(proto, $4075397607604985$var$ITERATOR, $default);
    // Plug for library
    $k9LSK[NAME] = $default;
    $k9LSK[TAG] = $4075397607604985$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($4075397607604985$var$VALUES),
            keys: IS_SET ? $default : getMethod($4075397607604985$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $9jEIl(proto, key, methods[key]);
        } else $i8prp($i8prp.P + $i8prp.F * ($4075397607604985$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("9jEIl", function(module, exports) {

module.exports = (parcelRequire("2G8qW"));

});

parcelRegister("k9LSK", function(module, exports) {
module.exports = {};

});

parcelRegister("5EKgq", function(module, exports) {
'use strict';

var $51S2y = parcelRequire("51S2y");

var $iJSqT = parcelRequire("iJSqT");

var $2xk2H = parcelRequire("2xk2H");
var $41e4933d0ec1ce9a$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("2G8qW"))($41e4933d0ec1ce9a$var$IteratorPrototype, (parcelRequire("30Hzc"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $51S2y($41e4933d0ec1ce9a$var$IteratorPrototype, {
        next: $iJSqT(1, next)
    });
    $2xk2H(Constructor, NAME + ' Iterator');
};

});
parcelRegister("51S2y", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $64xJ3 = parcelRequire("64xJ3");

var $aFjYv = parcelRequire("aFjYv");

var $iPFin = parcelRequire("iPFin");

var $3a96f6facb6f3767$var$IE_PROTO = (parcelRequire("78caH"))('IE_PROTO');
var $3a96f6facb6f3767$var$Empty = function() {};
var $3a96f6facb6f3767$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $3a96f6facb6f3767$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("b70N3"))('iframe');
    var i = $iPFin.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("1NbiO")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $3a96f6facb6f3767$var$createDict = iframeDocument.F;
    while(i--)delete $3a96f6facb6f3767$var$createDict[$3a96f6facb6f3767$var$PROTOTYPE][$iPFin[i]];
    return $3a96f6facb6f3767$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $3a96f6facb6f3767$var$Empty[$3a96f6facb6f3767$var$PROTOTYPE] = $64xJ3(O);
        result = new $3a96f6facb6f3767$var$Empty();
        $3a96f6facb6f3767$var$Empty[$3a96f6facb6f3767$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$3a96f6facb6f3767$var$IE_PROTO] = O;
    } else result = $3a96f6facb6f3767$var$createDict();
    return Properties === undefined ? result : $aFjYv(result, Properties);
};

});
parcelRegister("aFjYv", function(module, exports) {

var $8Lj0B = parcelRequire("8Lj0B");

var $64xJ3 = parcelRequire("64xJ3");

var $fCcvZ = parcelRequire("fCcvZ");

module.exports = (parcelRequire("3mDMk")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $64xJ3(O);
    var keys = $fCcvZ(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$8Lj0B.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("fCcvZ", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $1YUje = parcelRequire("1YUje");

var $iPFin = parcelRequire("iPFin");
module.exports = Object.keys || function keys(O) {
    return $1YUje(O, $iPFin);
};

});
parcelRegister("1YUje", function(module, exports) {

var $5agjt = parcelRequire("5agjt");

var $c5edP = parcelRequire("c5edP");

var $171712da2a7f8057$var$arrayIndexOf = (parcelRequire("hy06F"))(false);

var $171712da2a7f8057$var$IE_PROTO = (parcelRequire("78caH"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $c5edP(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $171712da2a7f8057$var$IE_PROTO) $5agjt(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($5agjt(O, key = names[i++])) ~$171712da2a7f8057$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("c5edP", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $esjmH = parcelRequire("esjmH");

var $5U3Pf = parcelRequire("5U3Pf");
module.exports = function(it) {
    return $esjmH($5U3Pf(it));
};

});
parcelRegister("esjmH", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $3QvoR = parcelRequire("3QvoR");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $3QvoR(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("3QvoR", function(module, exports) {
var $2cce95d22805fbf3$var$toString = {}.toString;
module.exports = function(it) {
    return $2cce95d22805fbf3$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("hy06F", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $c5edP = parcelRequire("c5edP");

var $lEq1j = parcelRequire("lEq1j");

var $m1OkG = parcelRequire("m1OkG");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $c5edP($this);
        var length = $lEq1j(O.length);
        var index = $m1OkG(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("lEq1j", function(module, exports) {
// 7.1.15 ToLength

var $hJy5h = parcelRequire("hJy5h");
var $fc3184790996788c$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $fc3184790996788c$var$min($hJy5h(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});

parcelRegister("m1OkG", function(module, exports) {

var $hJy5h = parcelRequire("hJy5h");
var $042375c75d44dbec$var$max = Math.max;
var $042375c75d44dbec$var$min = Math.min;
module.exports = function(index, length) {
    index = $hJy5h(index);
    return index < 0 ? $042375c75d44dbec$var$max(index + length, 0) : $042375c75d44dbec$var$min(index, length);
};

});



parcelRegister("iPFin", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("1NbiO", function(module, exports) {

var $l4Hr5 = parcelRequire("l4Hr5");
var $14e3227d8de86372$require$document = $l4Hr5.document;
module.exports = $14e3227d8de86372$require$document && $14e3227d8de86372$require$document.documentElement;

});


parcelRegister("2xk2H", function(module, exports) {

var $8Lj0B = parcelRequire("8Lj0B");
var $1d8e35e2af36725e$require$def = $8Lj0B.f;

var $5agjt = parcelRequire("5agjt");

var $1d8e35e2af36725e$var$TAG = (parcelRequire("30Hzc"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$5agjt(it = stat ? it : it.prototype, $1d8e35e2af36725e$var$TAG)) $1d8e35e2af36725e$require$def(it, $1d8e35e2af36725e$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("30Hzc", function(module, exports) {

var $23132a9ad66f1946$var$store = (parcelRequire("cPbj7"))('wks');

var $2nNTP = parcelRequire("2nNTP");

var $l4Hr5 = parcelRequire("l4Hr5");
var $23132a9ad66f1946$require$Symbol = $l4Hr5.Symbol;
var $23132a9ad66f1946$var$USE_SYMBOL = typeof $23132a9ad66f1946$require$Symbol == 'function';
var $23132a9ad66f1946$var$$exports = module.exports = function(name) {
    return $23132a9ad66f1946$var$store[name] || ($23132a9ad66f1946$var$store[name] = $23132a9ad66f1946$var$USE_SYMBOL && $23132a9ad66f1946$require$Symbol[name] || ($23132a9ad66f1946$var$USE_SYMBOL ? $23132a9ad66f1946$require$Symbol : $2nNTP)('Symbol.' + name));
};
$23132a9ad66f1946$var$$exports.store = $23132a9ad66f1946$var$store;

});





parcelRegister("cONfo", function(module, exports) {
parcelRequire("4XrPL");

var $l4Hr5 = parcelRequire("l4Hr5");

var $2G8qW = parcelRequire("2G8qW");

var $k9LSK = parcelRequire("k9LSK");

var $95505b031818047f$var$TO_STRING_TAG = (parcelRequire("30Hzc"))('toStringTag');
var $95505b031818047f$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $95505b031818047f$var$i = 0; $95505b031818047f$var$i < $95505b031818047f$var$DOMIterables.length; $95505b031818047f$var$i++){
    var $95505b031818047f$var$NAME = $95505b031818047f$var$DOMIterables[$95505b031818047f$var$i];
    var $95505b031818047f$var$Collection = $l4Hr5[$95505b031818047f$var$NAME];
    var $95505b031818047f$var$proto = $95505b031818047f$var$Collection && $95505b031818047f$var$Collection.prototype;
    if ($95505b031818047f$var$proto && !$95505b031818047f$var$proto[$95505b031818047f$var$TO_STRING_TAG]) $2G8qW($95505b031818047f$var$proto, $95505b031818047f$var$TO_STRING_TAG, $95505b031818047f$var$NAME);
    $k9LSK[$95505b031818047f$var$NAME] = $k9LSK.Array;
}

});
parcelRegister("4XrPL", function(module, exports) {
'use strict';

var $eKedI = parcelRequire("eKedI");

var $cmPUE = parcelRequire("cmPUE");

var $k9LSK = parcelRequire("k9LSK");

var $c5edP = parcelRequire("c5edP");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("5x6GT"))(Array, 'Array', function(iterated, kind) {
    this._t = $c5edP(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $cmPUE(1);
    }
    if (kind == 'keys') return $cmPUE(0, index);
    if (kind == 'values') return $cmPUE(0, O[index]);
    return $cmPUE(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$k9LSK.Arguments = $k9LSK.Array;
$eKedI('keys');
$eKedI('values');
$eKedI('entries');

});
parcelRegister("eKedI", function(module, exports) {
module.exports = function() {};

});

parcelRegister("cmPUE", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("21Q0n", function(module, exports) {
$parcel$export(module.exports, "f", () => $17a403e7ef61710c$export$2d1720544b23b823, (v) => $17a403e7ef61710c$export$2d1720544b23b823 = v);
var $17a403e7ef61710c$export$2d1720544b23b823;

$17a403e7ef61710c$export$2d1720544b23b823 = (parcelRequire("30Hzc"));

});



parcelRegister("lccab", function(module, exports) {

module.exports = {
    "default": (parcelRequire("iUG4N")),
    __esModule: true
};

});
parcelRegister("iUG4N", function(module, exports) {
parcelRequire("233te");
parcelRequire("8o8tJ");
parcelRequire("eYlnw");
parcelRequire("d0TUl");

module.exports = (parcelRequire("6O9ss")).Symbol;

});
parcelRegister("233te", function(module, exports) {
'use strict';

var $l4Hr5 = parcelRequire("l4Hr5");

var $5agjt = parcelRequire("5agjt");

var $3mDMk = parcelRequire("3mDMk");

var $i8prp = parcelRequire("i8prp");

var $9jEIl = parcelRequire("9jEIl");

var $jIxDP = parcelRequire("jIxDP");
var $17de8dc49b6f0ffd$require$META = $jIxDP.KEY;

var $lVNri = parcelRequire("lVNri");

var $cPbj7 = parcelRequire("cPbj7");

var $2xk2H = parcelRequire("2xk2H");

var $2nNTP = parcelRequire("2nNTP");

var $30Hzc = parcelRequire("30Hzc");

var $21Q0n = parcelRequire("21Q0n");

var $eSkWH = parcelRequire("eSkWH");

var $f8EEp = parcelRequire("f8EEp");

var $kj5ch = parcelRequire("kj5ch");

var $64xJ3 = parcelRequire("64xJ3");

var $9cWk2 = parcelRequire("9cWk2");

var $Nc4D4 = parcelRequire("Nc4D4");

var $c5edP = parcelRequire("c5edP");

var $cOR6I = parcelRequire("cOR6I");

var $iJSqT = parcelRequire("iJSqT");

var $51S2y = parcelRequire("51S2y");

var $kgPNT = parcelRequire("kgPNT");

var $3SW5P = parcelRequire("3SW5P");

var $exSzs = parcelRequire("exSzs");

var $8Lj0B = parcelRequire("8Lj0B");

var $fCcvZ = parcelRequire("fCcvZ");
var $17de8dc49b6f0ffd$var$gOPD = $3SW5P.f;
var $17de8dc49b6f0ffd$var$dP = $8Lj0B.f;
var $17de8dc49b6f0ffd$var$gOPN = $kgPNT.f;
var $17de8dc49b6f0ffd$var$$Symbol = $l4Hr5.Symbol;
var $17de8dc49b6f0ffd$var$$JSON = $l4Hr5.JSON;
var $17de8dc49b6f0ffd$var$_stringify = $17de8dc49b6f0ffd$var$$JSON && $17de8dc49b6f0ffd$var$$JSON.stringify;
var $17de8dc49b6f0ffd$var$PROTOTYPE = 'prototype';
var $17de8dc49b6f0ffd$var$HIDDEN = $30Hzc('_hidden');
var $17de8dc49b6f0ffd$var$TO_PRIMITIVE = $30Hzc('toPrimitive');
var $17de8dc49b6f0ffd$var$isEnum = {}.propertyIsEnumerable;
var $17de8dc49b6f0ffd$var$SymbolRegistry = $cPbj7('symbol-registry');
var $17de8dc49b6f0ffd$var$AllSymbols = $cPbj7('symbols');
var $17de8dc49b6f0ffd$var$OPSymbols = $cPbj7('op-symbols');
var $17de8dc49b6f0ffd$var$ObjectProto = Object[$17de8dc49b6f0ffd$var$PROTOTYPE];
var $17de8dc49b6f0ffd$var$USE_NATIVE = typeof $17de8dc49b6f0ffd$var$$Symbol == 'function' && !!$exSzs.f;
var $17de8dc49b6f0ffd$var$QObject = $l4Hr5.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $17de8dc49b6f0ffd$var$setter = !$17de8dc49b6f0ffd$var$QObject || !$17de8dc49b6f0ffd$var$QObject[$17de8dc49b6f0ffd$var$PROTOTYPE] || !$17de8dc49b6f0ffd$var$QObject[$17de8dc49b6f0ffd$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $17de8dc49b6f0ffd$var$setSymbolDesc = $3mDMk && $lVNri(function() {
    return $51S2y($17de8dc49b6f0ffd$var$dP({}, 'a', {
        get: function() {
            return $17de8dc49b6f0ffd$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $17de8dc49b6f0ffd$var$gOPD($17de8dc49b6f0ffd$var$ObjectProto, key);
    if (protoDesc) delete $17de8dc49b6f0ffd$var$ObjectProto[key];
    $17de8dc49b6f0ffd$var$dP(it, key, D);
    if (protoDesc && it !== $17de8dc49b6f0ffd$var$ObjectProto) $17de8dc49b6f0ffd$var$dP($17de8dc49b6f0ffd$var$ObjectProto, key, protoDesc);
} : $17de8dc49b6f0ffd$var$dP;
var $17de8dc49b6f0ffd$var$wrap = function(tag) {
    var sym = $17de8dc49b6f0ffd$var$AllSymbols[tag] = $51S2y($17de8dc49b6f0ffd$var$$Symbol[$17de8dc49b6f0ffd$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $17de8dc49b6f0ffd$var$isSymbol = $17de8dc49b6f0ffd$var$USE_NATIVE && typeof $17de8dc49b6f0ffd$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $17de8dc49b6f0ffd$var$$Symbol;
};
var $17de8dc49b6f0ffd$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $17de8dc49b6f0ffd$var$ObjectProto) $17de8dc49b6f0ffd$var$$defineProperty($17de8dc49b6f0ffd$var$OPSymbols, key, D);
    $64xJ3(it);
    key = $cOR6I(key, true);
    $64xJ3(D);
    if ($5agjt($17de8dc49b6f0ffd$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$5agjt(it, $17de8dc49b6f0ffd$var$HIDDEN)) $17de8dc49b6f0ffd$var$dP(it, $17de8dc49b6f0ffd$var$HIDDEN, $iJSqT(1, {}));
            it[$17de8dc49b6f0ffd$var$HIDDEN][key] = true;
        } else {
            if ($5agjt(it, $17de8dc49b6f0ffd$var$HIDDEN) && it[$17de8dc49b6f0ffd$var$HIDDEN][key]) it[$17de8dc49b6f0ffd$var$HIDDEN][key] = false;
            D = $51S2y(D, {
                enumerable: $iJSqT(0, false)
            });
        }
        return $17de8dc49b6f0ffd$var$setSymbolDesc(it, key, D);
    }
    return $17de8dc49b6f0ffd$var$dP(it, key, D);
};
var $17de8dc49b6f0ffd$var$$defineProperties = function defineProperties(it, P) {
    $64xJ3(it);
    var keys = $f8EEp(P = $c5edP(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$17de8dc49b6f0ffd$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $17de8dc49b6f0ffd$var$$create = function create(it, P) {
    return P === undefined ? $51S2y(it) : $17de8dc49b6f0ffd$var$$defineProperties($51S2y(it), P);
};
var $17de8dc49b6f0ffd$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $17de8dc49b6f0ffd$var$isEnum.call(this, key = $cOR6I(key, true));
    if (this === $17de8dc49b6f0ffd$var$ObjectProto && $5agjt($17de8dc49b6f0ffd$var$AllSymbols, key) && !$5agjt($17de8dc49b6f0ffd$var$OPSymbols, key)) return false;
    return E || !$5agjt(this, key) || !$5agjt($17de8dc49b6f0ffd$var$AllSymbols, key) || $5agjt(this, $17de8dc49b6f0ffd$var$HIDDEN) && this[$17de8dc49b6f0ffd$var$HIDDEN][key] ? E : true;
};
var $17de8dc49b6f0ffd$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $c5edP(it);
    key = $cOR6I(key, true);
    if (it === $17de8dc49b6f0ffd$var$ObjectProto && $5agjt($17de8dc49b6f0ffd$var$AllSymbols, key) && !$5agjt($17de8dc49b6f0ffd$var$OPSymbols, key)) return;
    var D = $17de8dc49b6f0ffd$var$gOPD(it, key);
    if (D && $5agjt($17de8dc49b6f0ffd$var$AllSymbols, key) && !($5agjt(it, $17de8dc49b6f0ffd$var$HIDDEN) && it[$17de8dc49b6f0ffd$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $17de8dc49b6f0ffd$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $17de8dc49b6f0ffd$var$gOPN($c5edP(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$5agjt($17de8dc49b6f0ffd$var$AllSymbols, key = names[i++]) && key != $17de8dc49b6f0ffd$var$HIDDEN && key != $17de8dc49b6f0ffd$require$META) result.push(key);
    return result;
};
var $17de8dc49b6f0ffd$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $17de8dc49b6f0ffd$var$ObjectProto;
    var names = $17de8dc49b6f0ffd$var$gOPN(IS_OP ? $17de8dc49b6f0ffd$var$OPSymbols : $c5edP(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($5agjt($17de8dc49b6f0ffd$var$AllSymbols, key = names[i++]) && (IS_OP ? $5agjt($17de8dc49b6f0ffd$var$ObjectProto, key) : true)) result.push($17de8dc49b6f0ffd$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$17de8dc49b6f0ffd$var$USE_NATIVE) {
    $17de8dc49b6f0ffd$var$$Symbol = function Symbol() {
        if (this instanceof $17de8dc49b6f0ffd$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $2nNTP(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $17de8dc49b6f0ffd$var$ObjectProto) $set.call($17de8dc49b6f0ffd$var$OPSymbols, value);
            if ($5agjt(this, $17de8dc49b6f0ffd$var$HIDDEN) && $5agjt(this[$17de8dc49b6f0ffd$var$HIDDEN], tag)) this[$17de8dc49b6f0ffd$var$HIDDEN][tag] = false;
            $17de8dc49b6f0ffd$var$setSymbolDesc(this, tag, $iJSqT(1, value));
        };
        if ($3mDMk && $17de8dc49b6f0ffd$var$setter) $17de8dc49b6f0ffd$var$setSymbolDesc($17de8dc49b6f0ffd$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $17de8dc49b6f0ffd$var$wrap(tag);
    };
    $9jEIl($17de8dc49b6f0ffd$var$$Symbol[$17de8dc49b6f0ffd$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $3SW5P.f = $17de8dc49b6f0ffd$var$$getOwnPropertyDescriptor;
    $8Lj0B.f = $17de8dc49b6f0ffd$var$$defineProperty;
    (parcelRequire("1yxwe")).f = $kgPNT.f = $17de8dc49b6f0ffd$var$$getOwnPropertyNames;
    (parcelRequire("uaQZm")).f = $17de8dc49b6f0ffd$var$$propertyIsEnumerable;
    $exSzs.f = $17de8dc49b6f0ffd$var$$getOwnPropertySymbols;
    if ($3mDMk && !(parcelRequire("d0QN5"))) $9jEIl($17de8dc49b6f0ffd$var$ObjectProto, 'propertyIsEnumerable', $17de8dc49b6f0ffd$var$$propertyIsEnumerable, true);
    $21Q0n.f = function(name) {
        return $17de8dc49b6f0ffd$var$wrap($30Hzc(name));
    };
}
$i8prp($i8prp.G + $i8prp.W + $i8prp.F * !$17de8dc49b6f0ffd$var$USE_NATIVE, {
    Symbol: $17de8dc49b6f0ffd$var$$Symbol
});
for(var $17de8dc49b6f0ffd$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $17de8dc49b6f0ffd$var$j = 0; $17de8dc49b6f0ffd$var$es6Symbols.length > $17de8dc49b6f0ffd$var$j;)$30Hzc($17de8dc49b6f0ffd$var$es6Symbols[$17de8dc49b6f0ffd$var$j++]);
for(var $17de8dc49b6f0ffd$var$wellKnownSymbols = $fCcvZ($30Hzc.store), $17de8dc49b6f0ffd$var$k = 0; $17de8dc49b6f0ffd$var$wellKnownSymbols.length > $17de8dc49b6f0ffd$var$k;)$eSkWH($17de8dc49b6f0ffd$var$wellKnownSymbols[$17de8dc49b6f0ffd$var$k++]);
$i8prp($i8prp.S + $i8prp.F * !$17de8dc49b6f0ffd$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $5agjt($17de8dc49b6f0ffd$var$SymbolRegistry, key += '') ? $17de8dc49b6f0ffd$var$SymbolRegistry[key] : $17de8dc49b6f0ffd$var$SymbolRegistry[key] = $17de8dc49b6f0ffd$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$17de8dc49b6f0ffd$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $17de8dc49b6f0ffd$var$SymbolRegistry)if ($17de8dc49b6f0ffd$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $17de8dc49b6f0ffd$var$setter = true;
    },
    useSimple: function() {
        $17de8dc49b6f0ffd$var$setter = false;
    }
});
$i8prp($i8prp.S + $i8prp.F * !$17de8dc49b6f0ffd$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $17de8dc49b6f0ffd$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $17de8dc49b6f0ffd$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $17de8dc49b6f0ffd$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $17de8dc49b6f0ffd$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $17de8dc49b6f0ffd$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $17de8dc49b6f0ffd$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $17de8dc49b6f0ffd$var$FAILS_ON_PRIMITIVES = $lVNri(function() {
    $exSzs.f(1);
});
$i8prp($i8prp.S + $i8prp.F * $17de8dc49b6f0ffd$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $exSzs.f($Nc4D4(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$17de8dc49b6f0ffd$var$$JSON && $i8prp($i8prp.S + $i8prp.F * (!$17de8dc49b6f0ffd$var$USE_NATIVE || $lVNri(function() {
    var S = $17de8dc49b6f0ffd$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $17de8dc49b6f0ffd$var$_stringify([
        S
    ]) != '[null]' || $17de8dc49b6f0ffd$var$_stringify({
        a: S
    }) != '{}' || $17de8dc49b6f0ffd$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$9cWk2(replacer) && it === undefined || $17de8dc49b6f0ffd$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$kj5ch(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$17de8dc49b6f0ffd$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $17de8dc49b6f0ffd$var$_stringify.apply($17de8dc49b6f0ffd$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$17de8dc49b6f0ffd$var$$Symbol[$17de8dc49b6f0ffd$var$PROTOTYPE][$17de8dc49b6f0ffd$var$TO_PRIMITIVE] || (parcelRequire("2G8qW"))($17de8dc49b6f0ffd$var$$Symbol[$17de8dc49b6f0ffd$var$PROTOTYPE], $17de8dc49b6f0ffd$var$TO_PRIMITIVE, $17de8dc49b6f0ffd$var$$Symbol[$17de8dc49b6f0ffd$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$2xk2H($17de8dc49b6f0ffd$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$2xk2H(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$2xk2H($l4Hr5.JSON, 'JSON', true);

});
parcelRegister("jIxDP", function(module, exports) {

var $e5ac38d7ab325b4a$var$META = (parcelRequire("2nNTP"))('meta');

var $9cWk2 = parcelRequire("9cWk2");

var $5agjt = parcelRequire("5agjt");

var $8Lj0B = parcelRequire("8Lj0B");
var $e5ac38d7ab325b4a$require$setDesc = $8Lj0B.f;
var $e5ac38d7ab325b4a$var$id = 0;
var $e5ac38d7ab325b4a$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $e5ac38d7ab325b4a$var$FREEZE = !(parcelRequire("lVNri"))(function() {
    return $e5ac38d7ab325b4a$var$isExtensible(Object.preventExtensions({}));
});
var $e5ac38d7ab325b4a$var$setMeta = function(it) {
    $e5ac38d7ab325b4a$require$setDesc(it, $e5ac38d7ab325b4a$var$META, {
        value: {
            i: 'O' + ++$e5ac38d7ab325b4a$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $e5ac38d7ab325b4a$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$9cWk2(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$5agjt(it, $e5ac38d7ab325b4a$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$e5ac38d7ab325b4a$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $e5ac38d7ab325b4a$var$setMeta(it);
    // return object ID
    }
    return it[$e5ac38d7ab325b4a$var$META].i;
};
var $e5ac38d7ab325b4a$var$getWeak = function(it, create) {
    if (!$5agjt(it, $e5ac38d7ab325b4a$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$e5ac38d7ab325b4a$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $e5ac38d7ab325b4a$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$e5ac38d7ab325b4a$var$META].w;
};
// add metadata on freeze-family methods calling
var $e5ac38d7ab325b4a$var$onFreeze = function(it) {
    if ($e5ac38d7ab325b4a$var$FREEZE && $e5ac38d7ab325b4a$var$meta.NEED && $e5ac38d7ab325b4a$var$isExtensible(it) && !$5agjt(it, $e5ac38d7ab325b4a$var$META)) $e5ac38d7ab325b4a$var$setMeta(it);
    return it;
};
var $e5ac38d7ab325b4a$var$meta = module.exports = {
    KEY: $e5ac38d7ab325b4a$var$META,
    NEED: false,
    fastKey: $e5ac38d7ab325b4a$var$fastKey,
    getWeak: $e5ac38d7ab325b4a$var$getWeak,
    onFreeze: $e5ac38d7ab325b4a$var$onFreeze
};

});

parcelRegister("eSkWH", function(module, exports) {

var $l4Hr5 = parcelRequire("l4Hr5");

var $6O9ss = parcelRequire("6O9ss");

var $d0QN5 = parcelRequire("d0QN5");

var $21Q0n = parcelRequire("21Q0n");

var $8Lj0B = parcelRequire("8Lj0B");
var $ad465b366a0654d4$require$defineProperty = $8Lj0B.f;
module.exports = function(name) {
    var $Symbol = $6O9ss.Symbol || ($6O9ss.Symbol = $d0QN5 ? {} : $l4Hr5.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $ad465b366a0654d4$require$defineProperty($Symbol, name, {
        value: $21Q0n.f(name)
    });
};

});

parcelRegister("f8EEp", function(module, exports) {
// all enumerable object keys, includes symbols

var $fCcvZ = parcelRequire("fCcvZ");

var $exSzs = parcelRequire("exSzs");

var $uaQZm = parcelRequire("uaQZm");
module.exports = function(it) {
    var result = $fCcvZ(it);
    var getSymbols = $exSzs.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $uaQZm.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});
parcelRegister("exSzs", function(module, exports) {
$parcel$export(module.exports, "f", () => $02bb969e742dde21$export$2d1720544b23b823, (v) => $02bb969e742dde21$export$2d1720544b23b823 = v);
var $02bb969e742dde21$export$2d1720544b23b823;
$02bb969e742dde21$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("uaQZm", function(module, exports) {
$parcel$export(module.exports, "f", () => $05ab38c448cf296b$export$2d1720544b23b823, (v) => $05ab38c448cf296b$export$2d1720544b23b823 = v);
var $05ab38c448cf296b$export$2d1720544b23b823;
$05ab38c448cf296b$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("kj5ch", function(module, exports) {
// 7.2.2 IsArray(argument)

var $3QvoR = parcelRequire("3QvoR");
module.exports = Array.isArray || function isArray(arg) {
    return $3QvoR(arg) == 'Array';
};

});

parcelRegister("kgPNT", function(module, exports) {
$parcel$export(module.exports, "f", () => $ec1d7c6e5d082fb2$export$2d1720544b23b823, (v) => $ec1d7c6e5d082fb2$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $ec1d7c6e5d082fb2$export$2d1720544b23b823;

var $c5edP = parcelRequire("c5edP");

var $1yxwe = parcelRequire("1yxwe");
var $ec1d7c6e5d082fb2$require$gOPN = $1yxwe.f;
var $ec1d7c6e5d082fb2$var$toString = {}.toString;
var $ec1d7c6e5d082fb2$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $ec1d7c6e5d082fb2$var$getWindowNames = function(it) {
    try {
        return $ec1d7c6e5d082fb2$require$gOPN(it);
    } catch (e) {
        return $ec1d7c6e5d082fb2$var$windowNames.slice();
    }
};
$ec1d7c6e5d082fb2$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $ec1d7c6e5d082fb2$var$windowNames && $ec1d7c6e5d082fb2$var$toString.call(it) == '[object Window]' ? $ec1d7c6e5d082fb2$var$getWindowNames(it) : $ec1d7c6e5d082fb2$require$gOPN($c5edP(it));
};

});
parcelRegister("1yxwe", function(module, exports) {
$parcel$export(module.exports, "f", () => $1222f78cac7a8ac5$export$2d1720544b23b823, (v) => $1222f78cac7a8ac5$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $1222f78cac7a8ac5$export$2d1720544b23b823;

var $1YUje = parcelRequire("1YUje");

var $1222f78cac7a8ac5$var$hiddenKeys = (parcelRequire("iPFin")).concat('length', 'prototype');
$1222f78cac7a8ac5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $1YUje(O, $1222f78cac7a8ac5$var$hiddenKeys);
};

});


parcelRegister("3SW5P", function(module, exports) {
$parcel$export(module.exports, "f", () => $2d437a529d0bd567$export$2d1720544b23b823, (v) => $2d437a529d0bd567$export$2d1720544b23b823 = v);
var $2d437a529d0bd567$export$2d1720544b23b823;

var $uaQZm = parcelRequire("uaQZm");

var $iJSqT = parcelRequire("iJSqT");

var $c5edP = parcelRequire("c5edP");

var $cOR6I = parcelRequire("cOR6I");

var $5agjt = parcelRequire("5agjt");

var $bWCC4 = parcelRequire("bWCC4");
var $2d437a529d0bd567$var$gOPD = Object.getOwnPropertyDescriptor;

$2d437a529d0bd567$export$2d1720544b23b823 = (parcelRequire("3mDMk")) ? $2d437a529d0bd567$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $c5edP(O);
    P = $cOR6I(P, true);
    if ($bWCC4) try {
        return $2d437a529d0bd567$var$gOPD(O, P);
    } catch (e) {}
    if ($5agjt(O, P)) return $iJSqT(!$uaQZm.f.call(O, P), O[P]);
};

});


parcelRegister("8o8tJ", function(module, exports) {

});

parcelRegister("eYlnw", function(module, exports) {

(parcelRequire("eSkWH"))('asyncIterator');

});

parcelRegister("d0TUl", function(module, exports) {

(parcelRequire("eSkWH"))('observable');

});





parcelRegister("iLcSb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $da869a18fdae2a4d$export$1e511d4a378977f5, (v) => $da869a18fdae2a4d$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $da869a18fdae2a4d$export$2e2bcd8739ae039, (v) => $da869a18fdae2a4d$export$2e2bcd8739ae039 = v);
var $da869a18fdae2a4d$export$1e511d4a378977f5;
var $da869a18fdae2a4d$export$2e2bcd8739ae039;
"use strict";
$da869a18fdae2a4d$export$1e511d4a378977f5 = true;

var $hd2Af = parcelRequire("hd2Af");
var $da869a18fdae2a4d$var$_setPrototypeOf2 = $da869a18fdae2a4d$var$_interopRequireDefault($hd2Af);

var $7X25D = parcelRequire("7X25D");
var $da869a18fdae2a4d$var$_create2 = $da869a18fdae2a4d$var$_interopRequireDefault($7X25D);

var $iRCw0 = parcelRequire("iRCw0");
var $da869a18fdae2a4d$var$_typeof3 = $da869a18fdae2a4d$var$_interopRequireDefault($iRCw0);
function $da869a18fdae2a4d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$da869a18fdae2a4d$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $da869a18fdae2a4d$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $da869a18fdae2a4d$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $da869a18fdae2a4d$var$_setPrototypeOf2.default ? (0, $da869a18fdae2a4d$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("hd2Af", function(module, exports) {

module.exports = {
    "default": (parcelRequire("gfk5J")),
    __esModule: true
};

});
parcelRegister("gfk5J", function(module, exports) {
parcelRequire("1lFFm");

module.exports = (parcelRequire("6O9ss")).Object.setPrototypeOf;

});
parcelRegister("1lFFm", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $i8prp = parcelRequire("i8prp");

$i8prp($i8prp.S, 'Object', {
    setPrototypeOf: (parcelRequire("hEvGV")).set
});

});
parcelRegister("hEvGV", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $9cWk2 = parcelRequire("9cWk2");

var $64xJ3 = parcelRequire("64xJ3");
var $cd9ec15a9d53d897$var$check = function(O, proto) {
    $64xJ3(O);
    if (!$9cWk2(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("6Zatx"))(Function.call, (parcelRequire("3SW5P")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $cd9ec15a9d53d897$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $cd9ec15a9d53d897$var$check
};

});




parcelRegister("7X25D", function(module, exports) {

module.exports = {
    "default": (parcelRequire("2En6U")),
    __esModule: true
};

});
parcelRegister("2En6U", function(module, exports) {
parcelRequire("1QGaH");

var $6O9ss = parcelRequire("6O9ss");
var $1ee13e6e93e45828$require$$Object = $6O9ss.Object;
module.exports = function create(P, D) {
    return $1ee13e6e93e45828$require$$Object.create(P, D);
};

});
parcelRegister("1QGaH", function(module, exports) {

var $i8prp = parcelRequire("i8prp");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$i8prp($i8prp.S, 'Object', {
    create: (parcelRequire("51S2y"))
});

});




parcelRegister("8gu7I", function(module, exports) {
$parcel$export(module.exports, "default", () => $39cd97acf4cea739$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $6oezt = parcelRequire("6oezt");

var $c63ap = parcelRequire("c63ap");

var $f8Q6J = parcelRequire("f8Q6J");
const $39cd97acf4cea739$var$AnalyticsContext = (props)=>{
    const isModernContext = (0, $6oezt.default) || (0, $e6Qdr.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $f8Q6J.default), {
        ...props
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $c63ap.default), {
        ...props
    });
};
var $39cd97acf4cea739$export$2e2bcd8739ae039 = $39cd97acf4cea739$var$AnalyticsContext;

});
parcelRegister("6oezt", function(module, exports) {
$parcel$export(module.exports, "default", () => $80c72b2aa2e87669$export$2e2bcd8739ae039);

var $6nQJh = parcelRequire("6nQJh");
var $80c72b2aa2e87669$var$_process$env;
/// <reference types="node" />
const $80c72b2aa2e87669$var$_default_1 = typeof $6nQJh !== 'undefined' && $6nQJh !== null && (($80c72b2aa2e87669$var$_process$env = {}, $80c72b2aa2e87669$var$_process$env === void 0) ? void 0 : $80c72b2aa2e87669$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
var $80c72b2aa2e87669$export$2e2bcd8739ae039 = $80c72b2aa2e87669$var$_default_1;

});

parcelRegister("c63ap", function(module, exports) {
$parcel$export(module.exports, "default", () => $3025e7d1390d2551$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $93Fg7 = parcelRequire("93Fg7");

var $i2rB4 = parcelRequire("i2rB4");
const $3025e7d1390d2551$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func
};
const $3025e7d1390d2551$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $3025e7d1390d2551$var$AnalyticsContext extends (0, $8P7DW.Component) {
    static #_ = this.contextTypes = $3025e7d1390d2551$var$ContextTypes;
    static #_2 = this.childContextTypes = $3025e7d1390d2551$var$ContextTypes;
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $3025e7d1390d2551$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $3025e7d1390d2551$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $i2rB4.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
var $3025e7d1390d2551$export$2e2bcd8739ae039 = $3025e7d1390d2551$var$AnalyticsContext;

});
parcelRegister("93Fg7", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $69846606049569ba$var$ReactIs, $69846606049569ba$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("c1xej"))();

});
parcelRegister("c1xej", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $8jROH = parcelRequire("8jROH");
function $8c0f5acf41aa0c57$var$emptyFunction() {}
function $8c0f5acf41aa0c57$var$emptyFunctionWithReset() {}
$8c0f5acf41aa0c57$var$emptyFunctionWithReset.resetWarningCache = $8c0f5acf41aa0c57$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $8jROH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $8c0f5acf41aa0c57$var$emptyFunctionWithReset,
        resetWarningCache: $8c0f5acf41aa0c57$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8jROH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $60e9d7f4869c330d$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $60e9d7f4869c330d$var$ReactPropTypesSecret;

});



parcelRegister("i2rB4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d21dd2162a59270a$export$2e2bcd8739ae039);

var $lRojT = parcelRequire("lRojT");
var $d21dd2162a59270a$export$2e2bcd8739ae039 = (0, $lRojT.default);

});
parcelRegister("lRojT", function(module, exports) {
$parcel$export(module.exports, "default", () => $fea1699b6141633a$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
var $fea1699b6141633a$var$AnalyticsNextContext = (0, $8P7DW.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $fea1699b6141633a$export$2e2bcd8739ae039 = $fea1699b6141633a$var$AnalyticsNextContext;

});



parcelRegister("f8Q6J", function(module, exports) {
$parcel$export(module.exports, "default", () => $055ed9597a4898b6$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $i2rB4 = parcelRequire("i2rB4");

var $hixr3 = parcelRequire("hixr3");

var $19XqD = parcelRequire("19XqD");
const $055ed9597a4898b6$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $19XqD.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $hixr3.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $8P7DW.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $8P7DW.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $i2rB4.default).Provider, {
        value: value,
        children: children
    });
};
var $055ed9597a4898b6$export$2e2bcd8739ae039 = $055ed9597a4898b6$var$AnalyticsContext;

});
parcelRegister("hixr3", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $82df034d7064e3e0$export$d1f587f82ad51c4);

var $8P7DW = parcelRequire("8P7DW");

var $i2rB4 = parcelRequire("i2rB4");
const $82df034d7064e3e0$export$d1f587f82ad51c4 = ()=>{
    return (0, $8P7DW.useContext)((0, $i2rB4.default));
};

});

parcelRegister("19XqD", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $f2eedc66c0ec20bb$export$1d27a74659855e44);

var $8P7DW = parcelRequire("8P7DW");
const $f2eedc66c0ec20bb$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $8P7DW.useRef)(value);
    ref.current = value;
    return ref;
};

});



parcelRegister("9k519", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $evBv1 = parcelRequire("evBv1");
var $6c99dfb0bb1ad97e$var$_extends3 = $6c99dfb0bb1ad97e$var$_interopRequireDefault($evBv1);

var $6zZ4f = parcelRequire("6zZ4f");
var $6c99dfb0bb1ad97e$var$_objectWithoutProperties3 = $6c99dfb0bb1ad97e$var$_interopRequireDefault($6zZ4f);

var $h77QL = parcelRequire("h77QL");
var $6c99dfb0bb1ad97e$var$_isUndefined2 = $6c99dfb0bb1ad97e$var$_interopRequireDefault($h77QL);

var $4FG1Q = parcelRequire("4FG1Q");
var $6c99dfb0bb1ad97e$var$_omitBy2 = $6c99dfb0bb1ad97e$var$_interopRequireDefault($4FG1Q);

var $27U5U = parcelRequire("27U5U");
var $6c99dfb0bb1ad97e$var$_mapDataPayloadToContextPayload2 = $6c99dfb0bb1ad97e$var$_interopRequireDefault($27U5U);
function $6c99dfb0bb1ad97e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(props) {
    var sourceName = props.sourceName, sourceType = props.sourceType, componentName = props.componentName, other = (0, $6c99dfb0bb1ad97e$var$_objectWithoutProperties3.default)(props, [
        'sourceName',
        'sourceType',
        'componentName'
    ]);
    var validProps = (0, $6c99dfb0bb1ad97e$var$_mapDataPayloadToContextPayload2.default)(other);
    var source = sourceName && sourceType ? '' + sourceName + sourceType : undefined;
    return (0, $6c99dfb0bb1ad97e$var$_omitBy2.default)((0, $6c99dfb0bb1ad97e$var$_extends3.default)({
        componentName: componentName,
        source: source
    }, validProps), $6c99dfb0bb1ad97e$var$_isUndefined2.default);
};

});
parcelRegister("evBv1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $a9010c82c8a92e4a$export$1e511d4a378977f5, (v) => $a9010c82c8a92e4a$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $a9010c82c8a92e4a$export$2e2bcd8739ae039, (v) => $a9010c82c8a92e4a$export$2e2bcd8739ae039 = v);
var $a9010c82c8a92e4a$export$1e511d4a378977f5;
var $a9010c82c8a92e4a$export$2e2bcd8739ae039;
"use strict";
$a9010c82c8a92e4a$export$1e511d4a378977f5 = true;

var $1RlJK = parcelRequire("1RlJK");
var $a9010c82c8a92e4a$var$_assign2 = $a9010c82c8a92e4a$var$_interopRequireDefault($1RlJK);
function $a9010c82c8a92e4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a9010c82c8a92e4a$export$2e2bcd8739ae039 = $a9010c82c8a92e4a$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("1RlJK", function(module, exports) {

module.exports = {
    "default": (parcelRequire("91eaV")),
    __esModule: true
};

});
parcelRegister("91eaV", function(module, exports) {
parcelRequire("b5ciI");

module.exports = (parcelRequire("6O9ss")).Object.assign;

});
parcelRegister("b5ciI", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $i8prp = parcelRequire("i8prp");

$i8prp($i8prp.S + $i8prp.F, 'Object', {
    assign: (parcelRequire("lOJi5"))
});

});
parcelRegister("lOJi5", function(module, exports) {
'use strict';

var $3mDMk = parcelRequire("3mDMk");

var $fCcvZ = parcelRequire("fCcvZ");

var $exSzs = parcelRequire("exSzs");

var $uaQZm = parcelRequire("uaQZm");

var $Nc4D4 = parcelRequire("Nc4D4");

var $esjmH = parcelRequire("esjmH");
var $fe216643ef4b9fb1$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$fe216643ef4b9fb1$var$$assign || (parcelRequire("lVNri"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $fe216643ef4b9fb1$var$$assign({}, A)[S] != 7 || Object.keys($fe216643ef4b9fb1$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $Nc4D4(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $exSzs.f;
    var isEnum = $uaQZm.f;
    while(aLen > index){
        var S = $esjmH(arguments[index++]);
        var keys = getSymbols ? $fCcvZ(S).concat(getSymbols(S)) : $fCcvZ(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$3mDMk || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $fe216643ef4b9fb1$var$$assign;

});





parcelRegister("6zZ4f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $4ca561af48dce28e$export$1e511d4a378977f5, (v) => $4ca561af48dce28e$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $4ca561af48dce28e$export$2e2bcd8739ae039, (v) => $4ca561af48dce28e$export$2e2bcd8739ae039 = v);
var $4ca561af48dce28e$export$1e511d4a378977f5;
var $4ca561af48dce28e$export$2e2bcd8739ae039;
"use strict";
$4ca561af48dce28e$export$1e511d4a378977f5 = true;
$4ca561af48dce28e$export$2e2bcd8739ae039 = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

});

parcelRegister("h77QL", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $c7592df31a57287c$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $c7592df31a57287c$var$isUndefined;

});

parcelRegister("4FG1Q", function(module, exports) {

var $alxWa = parcelRequire("alxWa");

var $9lzlI = parcelRequire("9lzlI");

var $g0Amj = parcelRequire("g0Amj");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $366b97cc5d9f6701$var$omitBy(object, predicate) {
    return $g0Amj(object, $9lzlI($alxWa(predicate)));
}
module.exports = $366b97cc5d9f6701$var$omitBy;

});
parcelRegister("alxWa", function(module, exports) {

var $j6Igm = parcelRequire("j6Igm");

var $8TrU4 = parcelRequire("8TrU4");

var $4J5Np = parcelRequire("4J5Np");

var $8q346 = parcelRequire("8q346");

var $48LxI = parcelRequire("48LxI");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $788630c3758face4$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $4J5Np;
    if (typeof value == 'object') return $8q346(value) ? $8TrU4(value[0], value[1]) : $j6Igm(value);
    return $48LxI(value);
}
module.exports = $788630c3758face4$var$baseIteratee;

});
parcelRegister("j6Igm", function(module, exports) {

var $lQZU2 = parcelRequire("lQZU2");

var $665GB = parcelRequire("665GB");

var $bHcex = parcelRequire("bHcex");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $de90e98a8b3778c7$var$baseMatches(source) {
    var matchData = $665GB(source);
    if (matchData.length == 1 && matchData[0][2]) return $bHcex(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $lQZU2(object, source, matchData);
    };
}
module.exports = $de90e98a8b3778c7$var$baseMatches;

});
parcelRegister("lQZU2", function(module, exports) {

var $6RLEe = parcelRequire("6RLEe");

var $gaQ7K = parcelRequire("gaQ7K");
/** Used to compose bitmasks for value comparisons. */ var $fe8e78ed1fc0b6fa$var$COMPARE_PARTIAL_FLAG = 1, $fe8e78ed1fc0b6fa$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $fe8e78ed1fc0b6fa$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $6RLEe;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $gaQ7K(srcValue, objValue, $fe8e78ed1fc0b6fa$var$COMPARE_PARTIAL_FLAG | $fe8e78ed1fc0b6fa$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $fe8e78ed1fc0b6fa$var$baseIsMatch;

});
parcelRegister("6RLEe", function(module, exports) {

var $ISROv = parcelRequire("ISROv");

var $crVoM = parcelRequire("crVoM");

var $b4Evm = parcelRequire("b4Evm");

var $93fKE = parcelRequire("93fKE");

var $lhSkx = parcelRequire("lhSkx");

var $bSJ5m = parcelRequire("bSJ5m");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4ffca72c6bff18f0$var$Stack(entries) {
    var data = this.__data__ = new $ISROv(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$4ffca72c6bff18f0$var$Stack.prototype.clear = $crVoM;
$4ffca72c6bff18f0$var$Stack.prototype['delete'] = $b4Evm;
$4ffca72c6bff18f0$var$Stack.prototype.get = $93fKE;
$4ffca72c6bff18f0$var$Stack.prototype.has = $lhSkx;
$4ffca72c6bff18f0$var$Stack.prototype.set = $bSJ5m;
module.exports = $4ffca72c6bff18f0$var$Stack;

});
parcelRegister("ISROv", function(module, exports) {

var $jbWeh = parcelRequire("jbWeh");

var $1ixS1 = parcelRequire("1ixS1");

var $8IFfb = parcelRequire("8IFfb");

var $8Cf6g = parcelRequire("8Cf6g");

var $8fM7X = parcelRequire("8fM7X");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $086eab9c6308c3a2$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$086eab9c6308c3a2$var$ListCache.prototype.clear = $jbWeh;
$086eab9c6308c3a2$var$ListCache.prototype['delete'] = $1ixS1;
$086eab9c6308c3a2$var$ListCache.prototype.get = $8IFfb;
$086eab9c6308c3a2$var$ListCache.prototype.has = $8Cf6g;
$086eab9c6308c3a2$var$ListCache.prototype.set = $8fM7X;
module.exports = $086eab9c6308c3a2$var$ListCache;

});
parcelRegister("jbWeh", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $df8c3686cafa86c3$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $df8c3686cafa86c3$var$listCacheClear;

});

parcelRegister("1ixS1", function(module, exports) {

var $i6F5d = parcelRequire("i6F5d");
/** Used for built-in method references. */ var $0f21becfe32920db$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $0f21becfe32920db$var$splice = $0f21becfe32920db$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0f21becfe32920db$var$listCacheDelete(key) {
    var data = this.__data__, index = $i6F5d(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $0f21becfe32920db$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $0f21becfe32920db$var$listCacheDelete;

});
parcelRegister("i6F5d", function(module, exports) {

var $ddQci = parcelRequire("ddQci");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d2e8a7cec577d8e4$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ddQci(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $d2e8a7cec577d8e4$var$assocIndexOf;

});
parcelRegister("ddQci", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $9a04fa915ef18959$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $9a04fa915ef18959$var$eq;

});



parcelRegister("8IFfb", function(module, exports) {

var $i6F5d = parcelRequire("i6F5d");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $65926cf59f6d267b$var$listCacheGet(key) {
    var data = this.__data__, index = $i6F5d(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $65926cf59f6d267b$var$listCacheGet;

});

parcelRegister("8Cf6g", function(module, exports) {

var $i6F5d = parcelRequire("i6F5d");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $645d95e54939238e$var$listCacheHas(key) {
    return $i6F5d(this.__data__, key) > -1;
}
module.exports = $645d95e54939238e$var$listCacheHas;

});

parcelRegister("8fM7X", function(module, exports) {

var $i6F5d = parcelRequire("i6F5d");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $60250e8d7a3eab05$var$listCacheSet(key, value) {
    var data = this.__data__, index = $i6F5d(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $60250e8d7a3eab05$var$listCacheSet;

});


parcelRegister("crVoM", function(module, exports) {

var $ISROv = parcelRequire("ISROv");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $910487d8a37ddf3d$var$stackClear() {
    this.__data__ = new $ISROv;
    this.size = 0;
}
module.exports = $910487d8a37ddf3d$var$stackClear;

});

parcelRegister("b4Evm", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $80ff7cdbaa8ff664$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $80ff7cdbaa8ff664$var$stackDelete;

});

parcelRegister("93fKE", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $69709ccd1df2f1f3$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $69709ccd1df2f1f3$var$stackGet;

});

parcelRegister("lhSkx", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f7f554623f980151$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $f7f554623f980151$var$stackHas;

});

parcelRegister("bSJ5m", function(module, exports) {

var $ISROv = parcelRequire("ISROv");

var $01ruK = parcelRequire("01ruK");

var $dRHf4 = parcelRequire("dRHf4");
/** Used as the size to enable large array optimizations. */ var $8a67b5dfec6f1c0e$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $8a67b5dfec6f1c0e$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $ISROv) {
        var pairs = data.__data__;
        if (!$01ruK || pairs.length < $8a67b5dfec6f1c0e$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $dRHf4(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $8a67b5dfec6f1c0e$var$stackSet;

});
parcelRegister("01ruK", function(module, exports) {

var $9t30I = parcelRequire("9t30I");

var $3YcUl = parcelRequire("3YcUl");
/* Built-in method references that are verified to be native. */ var $00456c04be70a619$var$Map = $9t30I($3YcUl, 'Map');
module.exports = $00456c04be70a619$var$Map;

});
parcelRegister("9t30I", function(module, exports) {

var $4I2m1 = parcelRequire("4I2m1");

var $dhuYI = parcelRequire("dhuYI");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $6e4928521e3ccd5a$var$getNative(object, key) {
    var value = $dhuYI(object, key);
    return $4I2m1(value) ? value : undefined;
}
module.exports = $6e4928521e3ccd5a$var$getNative;

});
parcelRegister("4I2m1", function(module, exports) {

var $fIflg = parcelRequire("fIflg");

var $aqnJO = parcelRequire("aqnJO");

var $3nMgq = parcelRequire("3nMgq");

var $kKg7s = parcelRequire("kKg7s");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $36dd18fab0b1ae05$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $36dd18fab0b1ae05$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $36dd18fab0b1ae05$var$funcProto = Function.prototype, $36dd18fab0b1ae05$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $36dd18fab0b1ae05$var$funcToString = $36dd18fab0b1ae05$var$funcProto.toString;
/** Used to check objects for own properties. */ var $36dd18fab0b1ae05$var$hasOwnProperty = $36dd18fab0b1ae05$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $36dd18fab0b1ae05$var$reIsNative = RegExp('^' + $36dd18fab0b1ae05$var$funcToString.call($36dd18fab0b1ae05$var$hasOwnProperty).replace($36dd18fab0b1ae05$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $36dd18fab0b1ae05$var$baseIsNative(value) {
    if (!$3nMgq(value) || $aqnJO(value)) return false;
    var pattern = $fIflg(value) ? $36dd18fab0b1ae05$var$reIsNative : $36dd18fab0b1ae05$var$reIsHostCtor;
    return pattern.test($kKg7s(value));
}
module.exports = $36dd18fab0b1ae05$var$baseIsNative;

});
parcelRegister("fIflg", function(module, exports) {

var $khKMn = parcelRequire("khKMn");

var $3nMgq = parcelRequire("3nMgq");
/** `Object#toString` result references. */ var $b706ddad4c72a2f3$var$asyncTag = '[object AsyncFunction]', $b706ddad4c72a2f3$var$funcTag = '[object Function]', $b706ddad4c72a2f3$var$genTag = '[object GeneratorFunction]', $b706ddad4c72a2f3$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b706ddad4c72a2f3$var$isFunction(value) {
    if (!$3nMgq(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $khKMn(value);
    return tag == $b706ddad4c72a2f3$var$funcTag || tag == $b706ddad4c72a2f3$var$genTag || tag == $b706ddad4c72a2f3$var$asyncTag || tag == $b706ddad4c72a2f3$var$proxyTag;
}
module.exports = $b706ddad4c72a2f3$var$isFunction;

});
parcelRegister("khKMn", function(module, exports) {

var $aQNXY = parcelRequire("aQNXY");

var $02Mho = parcelRequire("02Mho");

var $9RbeW = parcelRequire("9RbeW");
/** `Object#toString` result references. */ var $ec49ae966f50bfb5$var$nullTag = '[object Null]', $ec49ae966f50bfb5$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ec49ae966f50bfb5$var$symToStringTag = $aQNXY ? $aQNXY.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ec49ae966f50bfb5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ec49ae966f50bfb5$var$undefinedTag : $ec49ae966f50bfb5$var$nullTag;
    return $ec49ae966f50bfb5$var$symToStringTag && $ec49ae966f50bfb5$var$symToStringTag in Object(value) ? $02Mho(value) : $9RbeW(value);
}
module.exports = $ec49ae966f50bfb5$var$baseGetTag;

});
parcelRegister("aQNXY", function(module, exports) {

var $3YcUl = parcelRequire("3YcUl");
/** Built-in value references. */ var $7e6584f737402801$var$Symbol = $3YcUl.Symbol;
module.exports = $7e6584f737402801$var$Symbol;

});
parcelRegister("3YcUl", function(module, exports) {

var $kvrMD = parcelRequire("kvrMD");
/** Detect free variable `self`. */ var $2e40fceb6da8ad11$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $2e40fceb6da8ad11$var$root = $kvrMD || $2e40fceb6da8ad11$var$freeSelf || Function('return this')();
module.exports = $2e40fceb6da8ad11$var$root;

});
parcelRegister("kvrMD", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $eedc411df3aad375$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $eedc411df3aad375$var$freeGlobal;

});



parcelRegister("02Mho", function(module, exports) {

var $aQNXY = parcelRequire("aQNXY");
/** Used for built-in method references. */ var $0085a354884c9774$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0085a354884c9774$var$hasOwnProperty = $0085a354884c9774$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0085a354884c9774$var$nativeObjectToString = $0085a354884c9774$var$objectProto.toString;
/** Built-in value references. */ var $0085a354884c9774$var$symToStringTag = $aQNXY ? $aQNXY.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $0085a354884c9774$var$getRawTag(value) {
    var isOwn = $0085a354884c9774$var$hasOwnProperty.call(value, $0085a354884c9774$var$symToStringTag), tag = value[$0085a354884c9774$var$symToStringTag];
    try {
        value[$0085a354884c9774$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $0085a354884c9774$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$0085a354884c9774$var$symToStringTag] = tag;
        else delete value[$0085a354884c9774$var$symToStringTag];
    }
    return result;
}
module.exports = $0085a354884c9774$var$getRawTag;

});

parcelRegister("9RbeW", function(module, exports) {
/** Used for built-in method references. */ var $72d1c85103f4346a$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $72d1c85103f4346a$var$nativeObjectToString = $72d1c85103f4346a$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $72d1c85103f4346a$var$objectToString(value) {
    return $72d1c85103f4346a$var$nativeObjectToString.call(value);
}
module.exports = $72d1c85103f4346a$var$objectToString;

});


parcelRegister("3nMgq", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2768f5444e226ea4$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $2768f5444e226ea4$var$isObject;

});


parcelRegister("aqnJO", function(module, exports) {

var $8cWbo = parcelRequire("8cWbo");
/** Used to detect methods masquerading as native. */ var $796ebef7307b4cba$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($8cWbo && $8cWbo.keys && $8cWbo.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $796ebef7307b4cba$var$isMasked(func) {
    return !!$796ebef7307b4cba$var$maskSrcKey && $796ebef7307b4cba$var$maskSrcKey in func;
}
module.exports = $796ebef7307b4cba$var$isMasked;

});
parcelRegister("8cWbo", function(module, exports) {

var $3YcUl = parcelRequire("3YcUl");
/** Used to detect overreaching core-js shims. */ var $5f9c939a5741d6cc$var$coreJsData = $3YcUl["__core-js_shared__"];
module.exports = $5f9c939a5741d6cc$var$coreJsData;

});


parcelRegister("kKg7s", function(module, exports) {
/** Used for built-in method references. */ var $f1a49b7f21a133d5$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f1a49b7f21a133d5$var$funcToString = $f1a49b7f21a133d5$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f1a49b7f21a133d5$var$toSource(func) {
    if (func != null) {
        try {
            return $f1a49b7f21a133d5$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $f1a49b7f21a133d5$var$toSource;

});


parcelRegister("dhuYI", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $9ab4e48ac8a243b5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $9ab4e48ac8a243b5$var$getValue;

});



parcelRegister("dRHf4", function(module, exports) {

var $7iH1p = parcelRequire("7iH1p");

var $2hzIg = parcelRequire("2hzIg");

var $1PKAO = parcelRequire("1PKAO");

var $0Qw9z = parcelRequire("0Qw9z");

var $6xls2 = parcelRequire("6xls2");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a181c4911dcff024$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a181c4911dcff024$var$MapCache.prototype.clear = $7iH1p;
$a181c4911dcff024$var$MapCache.prototype['delete'] = $2hzIg;
$a181c4911dcff024$var$MapCache.prototype.get = $1PKAO;
$a181c4911dcff024$var$MapCache.prototype.has = $0Qw9z;
$a181c4911dcff024$var$MapCache.prototype.set = $6xls2;
module.exports = $a181c4911dcff024$var$MapCache;

});
parcelRegister("7iH1p", function(module, exports) {

var $6CjCx = parcelRequire("6CjCx");

var $ISROv = parcelRequire("ISROv");

var $01ruK = parcelRequire("01ruK");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $550b960b653975ad$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $6CjCx,
        'map': new ($01ruK || $ISROv),
        'string': new $6CjCx
    };
}
module.exports = $550b960b653975ad$var$mapCacheClear;

});
parcelRegister("6CjCx", function(module, exports) {

var $iAEv1 = parcelRequire("iAEv1");

var $4z9yB = parcelRequire("4z9yB");

var $5lqPd = parcelRequire("5lqPd");

var $eRqJb = parcelRequire("eRqJb");

var $cM4Vo = parcelRequire("cM4Vo");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4d1582f27092264c$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$4d1582f27092264c$var$Hash.prototype.clear = $iAEv1;
$4d1582f27092264c$var$Hash.prototype['delete'] = $4z9yB;
$4d1582f27092264c$var$Hash.prototype.get = $5lqPd;
$4d1582f27092264c$var$Hash.prototype.has = $eRqJb;
$4d1582f27092264c$var$Hash.prototype.set = $cM4Vo;
module.exports = $4d1582f27092264c$var$Hash;

});
parcelRegister("iAEv1", function(module, exports) {

var $iwNbp = parcelRequire("iwNbp");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $037e1cebe9ff51f6$var$hashClear() {
    this.__data__ = $iwNbp ? $iwNbp(null) : {};
    this.size = 0;
}
module.exports = $037e1cebe9ff51f6$var$hashClear;

});
parcelRegister("iwNbp", function(module, exports) {

var $9t30I = parcelRequire("9t30I");
/* Built-in method references that are verified to be native. */ var $d7d15ddd30f4c7bc$var$nativeCreate = $9t30I(Object, 'create');
module.exports = $d7d15ddd30f4c7bc$var$nativeCreate;

});


parcelRegister("4z9yB", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3531d82c0c7f7977$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $3531d82c0c7f7977$var$hashDelete;

});

parcelRegister("5lqPd", function(module, exports) {

var $iwNbp = parcelRequire("iwNbp");
/** Used to stand-in for `undefined` hash values. */ var $3e43b8c9df0c7dd0$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $3e43b8c9df0c7dd0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e43b8c9df0c7dd0$var$hasOwnProperty = $3e43b8c9df0c7dd0$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3e43b8c9df0c7dd0$var$hashGet(key) {
    var data = this.__data__;
    if ($iwNbp) {
        var result = data[key];
        return result === $3e43b8c9df0c7dd0$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3e43b8c9df0c7dd0$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $3e43b8c9df0c7dd0$var$hashGet;

});

parcelRegister("eRqJb", function(module, exports) {

var $iwNbp = parcelRequire("iwNbp");
/** Used for built-in method references. */ var $ad1abf7ec5511f18$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ad1abf7ec5511f18$var$hasOwnProperty = $ad1abf7ec5511f18$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ad1abf7ec5511f18$var$hashHas(key) {
    var data = this.__data__;
    return $iwNbp ? data[key] !== undefined : $ad1abf7ec5511f18$var$hasOwnProperty.call(data, key);
}
module.exports = $ad1abf7ec5511f18$var$hashHas;

});

parcelRegister("cM4Vo", function(module, exports) {

var $iwNbp = parcelRequire("iwNbp");
/** Used to stand-in for `undefined` hash values. */ var $94cdc9abd9f6a5b5$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $94cdc9abd9f6a5b5$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $iwNbp && value === undefined ? $94cdc9abd9f6a5b5$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $94cdc9abd9f6a5b5$var$hashSet;

});



parcelRegister("2hzIg", function(module, exports) {

var $bkfCP = parcelRequire("bkfCP");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1a98df224fb2a025$var$mapCacheDelete(key) {
    var result = $bkfCP(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $1a98df224fb2a025$var$mapCacheDelete;

});
parcelRegister("bkfCP", function(module, exports) {

var $ktuy5 = parcelRequire("ktuy5");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $83edaed0635f49e3$var$getMapData(map, key) {
    var data = map.__data__;
    return $ktuy5(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $83edaed0635f49e3$var$getMapData;

});
parcelRegister("ktuy5", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $ee7e366b06e8f9d5$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $ee7e366b06e8f9d5$var$isKeyable;

});



parcelRegister("1PKAO", function(module, exports) {

var $bkfCP = parcelRequire("bkfCP");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $155eb23382daf16e$var$mapCacheGet(key) {
    return $bkfCP(this, key).get(key);
}
module.exports = $155eb23382daf16e$var$mapCacheGet;

});

parcelRegister("0Qw9z", function(module, exports) {

var $bkfCP = parcelRequire("bkfCP");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0028bd1a79b503d2$var$mapCacheHas(key) {
    return $bkfCP(this, key).has(key);
}
module.exports = $0028bd1a79b503d2$var$mapCacheHas;

});

parcelRegister("6xls2", function(module, exports) {

var $bkfCP = parcelRequire("bkfCP");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $4c2676ef447e54de$var$mapCacheSet(key, value) {
    var data = $bkfCP(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $4c2676ef447e54de$var$mapCacheSet;

});




parcelRegister("gaQ7K", function(module, exports) {

var $amKkT = parcelRequire("amKkT");

var $dHm51 = parcelRequire("dHm51");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $bc660339ea6374b3$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$dHm51(value) && !$dHm51(other)) return value !== value && other !== other;
    return $amKkT(value, other, bitmask, customizer, $bc660339ea6374b3$var$baseIsEqual, stack);
}
module.exports = $bc660339ea6374b3$var$baseIsEqual;

});
parcelRegister("amKkT", function(module, exports) {

var $6RLEe = parcelRequire("6RLEe");

var $FvHe4 = parcelRequire("FvHe4");

var $ew7DS = parcelRequire("ew7DS");

var $it8Uj = parcelRequire("it8Uj");

var $2zY8I = parcelRequire("2zY8I");

var $8q346 = parcelRequire("8q346");

var $fomC7 = parcelRequire("fomC7");

var $1N3Uy = parcelRequire("1N3Uy");
/** Used to compose bitmasks for value comparisons. */ var $78bfe6d3ffd4d2f7$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $78bfe6d3ffd4d2f7$var$argsTag = '[object Arguments]', $78bfe6d3ffd4d2f7$var$arrayTag = '[object Array]', $78bfe6d3ffd4d2f7$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $78bfe6d3ffd4d2f7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $78bfe6d3ffd4d2f7$var$hasOwnProperty = $78bfe6d3ffd4d2f7$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $78bfe6d3ffd4d2f7$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $8q346(object), othIsArr = $8q346(other), objTag = objIsArr ? $78bfe6d3ffd4d2f7$var$arrayTag : $2zY8I(object), othTag = othIsArr ? $78bfe6d3ffd4d2f7$var$arrayTag : $2zY8I(other);
    objTag = objTag == $78bfe6d3ffd4d2f7$var$argsTag ? $78bfe6d3ffd4d2f7$var$objectTag : objTag;
    othTag = othTag == $78bfe6d3ffd4d2f7$var$argsTag ? $78bfe6d3ffd4d2f7$var$objectTag : othTag;
    var objIsObj = objTag == $78bfe6d3ffd4d2f7$var$objectTag, othIsObj = othTag == $78bfe6d3ffd4d2f7$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $fomC7(object)) {
        if (!$fomC7(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $6RLEe);
        return objIsArr || $1N3Uy(object) ? $FvHe4(object, other, bitmask, customizer, equalFunc, stack) : $ew7DS(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $78bfe6d3ffd4d2f7$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $78bfe6d3ffd4d2f7$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $78bfe6d3ffd4d2f7$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $6RLEe);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $6RLEe);
    return $it8Uj(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $78bfe6d3ffd4d2f7$var$baseIsEqualDeep;

});
parcelRegister("FvHe4", function(module, exports) {

var $355VB = parcelRequire("355VB");

var $cisk1 = parcelRequire("cisk1");

var $0gkRj = parcelRequire("0gkRj");
/** Used to compose bitmasks for value comparisons. */ var $07cc6aa74a8c7070$var$COMPARE_PARTIAL_FLAG = 1, $07cc6aa74a8c7070$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $07cc6aa74a8c7070$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $07cc6aa74a8c7070$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $07cc6aa74a8c7070$var$COMPARE_UNORDERED_FLAG ? new $355VB : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$cisk1(other, function(othValue, othIndex) {
                if (!$0gkRj(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $07cc6aa74a8c7070$var$equalArrays;

});
parcelRegister("355VB", function(module, exports) {

var $dRHf4 = parcelRequire("dRHf4");

var $26uLM = parcelRequire("26uLM");

var $7BxUz = parcelRequire("7BxUz");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $23e66fea4335d784$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $dRHf4;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$23e66fea4335d784$var$SetCache.prototype.add = $23e66fea4335d784$var$SetCache.prototype.push = $26uLM;
$23e66fea4335d784$var$SetCache.prototype.has = $7BxUz;
module.exports = $23e66fea4335d784$var$SetCache;

});
parcelRegister("26uLM", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $1884028695d4bb97$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $1884028695d4bb97$var$setCacheAdd(value) {
    this.__data__.set(value, $1884028695d4bb97$var$HASH_UNDEFINED);
    return this;
}
module.exports = $1884028695d4bb97$var$setCacheAdd;

});

parcelRegister("7BxUz", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $58964b3864a79089$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $58964b3864a79089$var$setCacheHas;

});


parcelRegister("cisk1", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $8f3d229da00cc1f4$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $8f3d229da00cc1f4$var$arraySome;

});

parcelRegister("0gkRj", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $000cac142fb31ed1$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $000cac142fb31ed1$var$cacheHas;

});


parcelRegister("ew7DS", function(module, exports) {

var $aQNXY = parcelRequire("aQNXY");

var $4Yqwf = parcelRequire("4Yqwf");

var $ddQci = parcelRequire("ddQci");

var $FvHe4 = parcelRequire("FvHe4");

var $kcGK6 = parcelRequire("kcGK6");

var $czrSd = parcelRequire("czrSd");
/** Used to compose bitmasks for value comparisons. */ var $a919fb6cf492a4cc$var$COMPARE_PARTIAL_FLAG = 1, $a919fb6cf492a4cc$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $a919fb6cf492a4cc$var$boolTag = '[object Boolean]', $a919fb6cf492a4cc$var$dateTag = '[object Date]', $a919fb6cf492a4cc$var$errorTag = '[object Error]', $a919fb6cf492a4cc$var$mapTag = '[object Map]', $a919fb6cf492a4cc$var$numberTag = '[object Number]', $a919fb6cf492a4cc$var$regexpTag = '[object RegExp]', $a919fb6cf492a4cc$var$setTag = '[object Set]', $a919fb6cf492a4cc$var$stringTag = '[object String]', $a919fb6cf492a4cc$var$symbolTag = '[object Symbol]';
var $a919fb6cf492a4cc$var$arrayBufferTag = '[object ArrayBuffer]', $a919fb6cf492a4cc$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $a919fb6cf492a4cc$var$symbolProto = $aQNXY ? $aQNXY.prototype : undefined, $a919fb6cf492a4cc$var$symbolValueOf = $a919fb6cf492a4cc$var$symbolProto ? $a919fb6cf492a4cc$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a919fb6cf492a4cc$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $a919fb6cf492a4cc$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $a919fb6cf492a4cc$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $4Yqwf(object), new $4Yqwf(other))) return false;
            return true;
        case $a919fb6cf492a4cc$var$boolTag:
        case $a919fb6cf492a4cc$var$dateTag:
        case $a919fb6cf492a4cc$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $ddQci(+object, +other);
        case $a919fb6cf492a4cc$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $a919fb6cf492a4cc$var$regexpTag:
        case $a919fb6cf492a4cc$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $a919fb6cf492a4cc$var$mapTag:
            var convert = $kcGK6;
        case $a919fb6cf492a4cc$var$setTag:
            var isPartial = bitmask & $a919fb6cf492a4cc$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $czrSd);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $a919fb6cf492a4cc$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $FvHe4(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $a919fb6cf492a4cc$var$symbolTag:
            if ($a919fb6cf492a4cc$var$symbolValueOf) return $a919fb6cf492a4cc$var$symbolValueOf.call(object) == $a919fb6cf492a4cc$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $a919fb6cf492a4cc$var$equalByTag;

});
parcelRegister("4Yqwf", function(module, exports) {

var $3YcUl = parcelRequire("3YcUl");
/** Built-in value references. */ var $39f1562778141444$var$Uint8Array = $3YcUl.Uint8Array;
module.exports = $39f1562778141444$var$Uint8Array;

});

parcelRegister("kcGK6", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $eb561567c4bfabab$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $eb561567c4bfabab$var$mapToArray;

});

parcelRegister("czrSd", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $926e6001942749cc$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $926e6001942749cc$var$setToArray;

});


parcelRegister("it8Uj", function(module, exports) {

var $hxFYM = parcelRequire("hxFYM");
/** Used to compose bitmasks for value comparisons. */ var $d721d83bd5756512$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $d721d83bd5756512$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d721d83bd5756512$var$hasOwnProperty = $d721d83bd5756512$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d721d83bd5756512$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $d721d83bd5756512$var$COMPARE_PARTIAL_FLAG, objProps = $hxFYM(object), objLength = objProps.length, othProps = $hxFYM(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $d721d83bd5756512$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $d721d83bd5756512$var$equalObjects;

});
parcelRegister("hxFYM", function(module, exports) {

var $g5Zcz = parcelRequire("g5Zcz");

var $9DJv2 = parcelRequire("9DJv2");

var $dFikY = parcelRequire("dFikY");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cc5614f7b5ffdb8f$var$getAllKeys(object) {
    return $g5Zcz(object, $dFikY, $9DJv2);
}
module.exports = $cc5614f7b5ffdb8f$var$getAllKeys;

});
parcelRegister("g5Zcz", function(module, exports) {

var $fC54b = parcelRequire("fC54b");

var $8q346 = parcelRequire("8q346");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $bb7c965f777b3b64$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $8q346(object) ? result : $fC54b(result, symbolsFunc(object));
}
module.exports = $bb7c965f777b3b64$var$baseGetAllKeys;

});
parcelRegister("fC54b", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $b5de55b3254e2aa2$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $b5de55b3254e2aa2$var$arrayPush;

});

parcelRegister("8q346", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $621321217ad5ea0a$var$isArray = Array.isArray;
module.exports = $621321217ad5ea0a$var$isArray;

});


parcelRegister("9DJv2", function(module, exports) {

var $2atEb = parcelRequire("2atEb");

var $9bCiF = parcelRequire("9bCiF");
/** Used for built-in method references. */ var $704b0cd57aeb4661$var$objectProto = Object.prototype;
/** Built-in value references. */ var $704b0cd57aeb4661$var$propertyIsEnumerable = $704b0cd57aeb4661$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $704b0cd57aeb4661$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $704b0cd57aeb4661$var$getSymbols = !$704b0cd57aeb4661$var$nativeGetSymbols ? $9bCiF : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $2atEb($704b0cd57aeb4661$var$nativeGetSymbols(object), function(symbol) {
        return $704b0cd57aeb4661$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $704b0cd57aeb4661$var$getSymbols;

});
parcelRegister("2atEb", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $1943833dd1e6e1ba$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $1943833dd1e6e1ba$var$arrayFilter;

});

parcelRegister("9bCiF", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $6b02d9b78a12f624$var$stubArray() {
    return [];
}
module.exports = $6b02d9b78a12f624$var$stubArray;

});


parcelRegister("dFikY", function(module, exports) {

var $f3rs9 = parcelRequire("f3rs9");

var $h5S0a = parcelRequire("h5S0a");

var $4Gxuc = parcelRequire("4Gxuc");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $9f2d541c3a6c9f75$var$keys(object) {
    return $4Gxuc(object) ? $f3rs9(object) : $h5S0a(object);
}
module.exports = $9f2d541c3a6c9f75$var$keys;

});
parcelRegister("f3rs9", function(module, exports) {

var $4X2dd = parcelRequire("4X2dd");

var $2ZGmQ = parcelRequire("2ZGmQ");

var $8q346 = parcelRequire("8q346");

var $fomC7 = parcelRequire("fomC7");

var $ggGy1 = parcelRequire("ggGy1");

var $1N3Uy = parcelRequire("1N3Uy");
/** Used for built-in method references. */ var $af5c6e70cd86b160$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $af5c6e70cd86b160$var$hasOwnProperty = $af5c6e70cd86b160$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $af5c6e70cd86b160$var$arrayLikeKeys(value, inherited) {
    var isArr = $8q346(value), isArg = !isArr && $2ZGmQ(value), isBuff = !isArr && !isArg && $fomC7(value), isType = !isArr && !isArg && !isBuff && $1N3Uy(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $4X2dd(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $af5c6e70cd86b160$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $ggGy1(key, length)))) result.push(key);
    return result;
}
module.exports = $af5c6e70cd86b160$var$arrayLikeKeys;

});
parcelRegister("4X2dd", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $39ae63612e016d2e$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $39ae63612e016d2e$var$baseTimes;

});

parcelRegister("2ZGmQ", function(module, exports) {

var $1ftSA = parcelRequire("1ftSA");

var $dHm51 = parcelRequire("dHm51");
/** Used for built-in method references. */ var $22e22496e314a5b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $22e22496e314a5b5$var$hasOwnProperty = $22e22496e314a5b5$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $22e22496e314a5b5$var$propertyIsEnumerable = $22e22496e314a5b5$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $22e22496e314a5b5$var$isArguments = $1ftSA(function() {
    return arguments;
}()) ? $1ftSA : function(value) {
    return $dHm51(value) && $22e22496e314a5b5$var$hasOwnProperty.call(value, 'callee') && !$22e22496e314a5b5$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $22e22496e314a5b5$var$isArguments;

});
parcelRegister("1ftSA", function(module, exports) {

var $khKMn = parcelRequire("khKMn");

var $dHm51 = parcelRequire("dHm51");
/** `Object#toString` result references. */ var $0e8e5e97a1e254de$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $0e8e5e97a1e254de$var$baseIsArguments(value) {
    return $dHm51(value) && $khKMn(value) == $0e8e5e97a1e254de$var$argsTag;
}
module.exports = $0e8e5e97a1e254de$var$baseIsArguments;

});
parcelRegister("dHm51", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9f906b277ce0e1df$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $9f906b277ce0e1df$var$isObjectLike;

});



parcelRegister("fomC7", function(module, exports) {

var $3YcUl = parcelRequire("3YcUl");

var $8ttGK = parcelRequire("8ttGK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $3YcUl.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $8ttGK;
module.exports = isBuffer;

});
parcelRegister("8ttGK", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $62b80fac150eedc0$var$stubFalse() {
    return false;
}
module.exports = $62b80fac150eedc0$var$stubFalse;

});


parcelRegister("ggGy1", function(module, exports) {
/** Used as references for various `Number` constants. */ var $bd7f2515909efd3a$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $bd7f2515909efd3a$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $bd7f2515909efd3a$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $bd7f2515909efd3a$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $bd7f2515909efd3a$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $bd7f2515909efd3a$var$isIndex;

});

parcelRegister("1N3Uy", function(module, exports) {

var $eoX5Y = parcelRequire("eoX5Y");

var $1GNDk = parcelRequire("1GNDk");

var $40DOw = parcelRequire("40DOw");
/* Node.js helper references. */ var $14dd66bff2a7ca5f$var$nodeIsTypedArray = $40DOw && $40DOw.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $14dd66bff2a7ca5f$var$isTypedArray = $14dd66bff2a7ca5f$var$nodeIsTypedArray ? $1GNDk($14dd66bff2a7ca5f$var$nodeIsTypedArray) : $eoX5Y;
module.exports = $14dd66bff2a7ca5f$var$isTypedArray;

});
parcelRegister("eoX5Y", function(module, exports) {

var $khKMn = parcelRequire("khKMn");

var $6YEZM = parcelRequire("6YEZM");

var $dHm51 = parcelRequire("dHm51");
/** `Object#toString` result references. */ var $a7c125ad891f1569$var$argsTag = '[object Arguments]', $a7c125ad891f1569$var$arrayTag = '[object Array]', $a7c125ad891f1569$var$boolTag = '[object Boolean]', $a7c125ad891f1569$var$dateTag = '[object Date]', $a7c125ad891f1569$var$errorTag = '[object Error]', $a7c125ad891f1569$var$funcTag = '[object Function]', $a7c125ad891f1569$var$mapTag = '[object Map]', $a7c125ad891f1569$var$numberTag = '[object Number]', $a7c125ad891f1569$var$objectTag = '[object Object]', $a7c125ad891f1569$var$regexpTag = '[object RegExp]', $a7c125ad891f1569$var$setTag = '[object Set]', $a7c125ad891f1569$var$stringTag = '[object String]', $a7c125ad891f1569$var$weakMapTag = '[object WeakMap]';
var $a7c125ad891f1569$var$arrayBufferTag = '[object ArrayBuffer]', $a7c125ad891f1569$var$dataViewTag = '[object DataView]', $a7c125ad891f1569$var$float32Tag = '[object Float32Array]', $a7c125ad891f1569$var$float64Tag = '[object Float64Array]', $a7c125ad891f1569$var$int8Tag = '[object Int8Array]', $a7c125ad891f1569$var$int16Tag = '[object Int16Array]', $a7c125ad891f1569$var$int32Tag = '[object Int32Array]', $a7c125ad891f1569$var$uint8Tag = '[object Uint8Array]', $a7c125ad891f1569$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a7c125ad891f1569$var$uint16Tag = '[object Uint16Array]', $a7c125ad891f1569$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $a7c125ad891f1569$var$typedArrayTags = {};
$a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$float32Tag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$float64Tag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$int8Tag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$int16Tag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$int32Tag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$uint8Tag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$uint8ClampedTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$uint16Tag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$uint32Tag] = true;
$a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$argsTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$arrayTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$arrayBufferTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$boolTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$dataViewTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$dateTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$errorTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$funcTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$mapTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$numberTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$objectTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$regexpTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$setTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$stringTag] = $a7c125ad891f1569$var$typedArrayTags[$a7c125ad891f1569$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a7c125ad891f1569$var$baseIsTypedArray(value) {
    return $dHm51(value) && $6YEZM(value.length) && !!$a7c125ad891f1569$var$typedArrayTags[$khKMn(value)];
}
module.exports = $a7c125ad891f1569$var$baseIsTypedArray;

});
parcelRegister("6YEZM", function(module, exports) {
/** Used as references for various `Number` constants. */ var $51482581530e9b1b$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $51482581530e9b1b$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $51482581530e9b1b$var$MAX_SAFE_INTEGER;
}
module.exports = $51482581530e9b1b$var$isLength;

});


parcelRegister("1GNDk", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $13b036cf7a24b86a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $13b036cf7a24b86a$var$baseUnary;

});

parcelRegister("40DOw", function(module, exports) {

var $kvrMD = parcelRequire("kvrMD");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $kvrMD.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("h5S0a", function(module, exports) {

var $3ZG5S = parcelRequire("3ZG5S");

var $gG9KX = parcelRequire("gG9KX");
/** Used for built-in method references. */ var $c71ccae2b4d5f7b6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c71ccae2b4d5f7b6$var$hasOwnProperty = $c71ccae2b4d5f7b6$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c71ccae2b4d5f7b6$var$baseKeys(object) {
    if (!$3ZG5S(object)) return $gG9KX(object);
    var result = [];
    for(var key in Object(object))if ($c71ccae2b4d5f7b6$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $c71ccae2b4d5f7b6$var$baseKeys;

});
parcelRegister("3ZG5S", function(module, exports) {
/** Used for built-in method references. */ var $2e87b89212fc0497$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $2e87b89212fc0497$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $2e87b89212fc0497$var$objectProto;
    return value === proto;
}
module.exports = $2e87b89212fc0497$var$isPrototype;

});

parcelRegister("gG9KX", function(module, exports) {

var $4rimC = parcelRequire("4rimC");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c2482303fcf99841$var$nativeKeys = $4rimC(Object.keys, Object);
module.exports = $c2482303fcf99841$var$nativeKeys;

});
parcelRegister("4rimC", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $33b7edb78c73be83$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $33b7edb78c73be83$var$overArg;

});



parcelRegister("4Gxuc", function(module, exports) {

var $fIflg = parcelRequire("fIflg");

var $6YEZM = parcelRequire("6YEZM");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $36950f4dd91cedc2$var$isArrayLike(value) {
    return value != null && $6YEZM(value.length) && !$fIflg(value);
}
module.exports = $36950f4dd91cedc2$var$isArrayLike;

});




parcelRegister("2zY8I", function(module, exports) {

var $2sPLD = parcelRequire("2sPLD");

var $01ruK = parcelRequire("01ruK");

var $d5lWr = parcelRequire("d5lWr");

var $4YQIZ = parcelRequire("4YQIZ");

var $gdNpq = parcelRequire("gdNpq");

var $khKMn = parcelRequire("khKMn");

var $kKg7s = parcelRequire("kKg7s");
/** `Object#toString` result references. */ var $1e0d801aa3b91948$var$mapTag = '[object Map]', $1e0d801aa3b91948$var$objectTag = '[object Object]', $1e0d801aa3b91948$var$promiseTag = '[object Promise]', $1e0d801aa3b91948$var$setTag = '[object Set]', $1e0d801aa3b91948$var$weakMapTag = '[object WeakMap]';
var $1e0d801aa3b91948$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $1e0d801aa3b91948$var$dataViewCtorString = $kKg7s($2sPLD), $1e0d801aa3b91948$var$mapCtorString = $kKg7s($01ruK), $1e0d801aa3b91948$var$promiseCtorString = $kKg7s($d5lWr), $1e0d801aa3b91948$var$setCtorString = $kKg7s($4YQIZ), $1e0d801aa3b91948$var$weakMapCtorString = $kKg7s($gdNpq);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $1e0d801aa3b91948$var$getTag = $khKMn;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($2sPLD && $1e0d801aa3b91948$var$getTag(new $2sPLD(new ArrayBuffer(1))) != $1e0d801aa3b91948$var$dataViewTag || $01ruK && $1e0d801aa3b91948$var$getTag(new $01ruK) != $1e0d801aa3b91948$var$mapTag || $d5lWr && $1e0d801aa3b91948$var$getTag($d5lWr.resolve()) != $1e0d801aa3b91948$var$promiseTag || $4YQIZ && $1e0d801aa3b91948$var$getTag(new $4YQIZ) != $1e0d801aa3b91948$var$setTag || $gdNpq && $1e0d801aa3b91948$var$getTag(new $gdNpq) != $1e0d801aa3b91948$var$weakMapTag) $1e0d801aa3b91948$var$getTag = function(value) {
    var result = $khKMn(value), Ctor = result == $1e0d801aa3b91948$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $kKg7s(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $1e0d801aa3b91948$var$dataViewCtorString:
            return $1e0d801aa3b91948$var$dataViewTag;
        case $1e0d801aa3b91948$var$mapCtorString:
            return $1e0d801aa3b91948$var$mapTag;
        case $1e0d801aa3b91948$var$promiseCtorString:
            return $1e0d801aa3b91948$var$promiseTag;
        case $1e0d801aa3b91948$var$setCtorString:
            return $1e0d801aa3b91948$var$setTag;
        case $1e0d801aa3b91948$var$weakMapCtorString:
            return $1e0d801aa3b91948$var$weakMapTag;
    }
    return result;
};
module.exports = $1e0d801aa3b91948$var$getTag;

});
parcelRegister("2sPLD", function(module, exports) {

var $9t30I = parcelRequire("9t30I");

var $3YcUl = parcelRequire("3YcUl");
/* Built-in method references that are verified to be native. */ var $1cb65a393c5f39b6$var$DataView = $9t30I($3YcUl, 'DataView');
module.exports = $1cb65a393c5f39b6$var$DataView;

});

parcelRegister("d5lWr", function(module, exports) {

var $9t30I = parcelRequire("9t30I");

var $3YcUl = parcelRequire("3YcUl");
/* Built-in method references that are verified to be native. */ var $986cc32003cd90d0$var$Promise = $9t30I($3YcUl, 'Promise');
module.exports = $986cc32003cd90d0$var$Promise;

});

parcelRegister("4YQIZ", function(module, exports) {

var $9t30I = parcelRequire("9t30I");

var $3YcUl = parcelRequire("3YcUl");
/* Built-in method references that are verified to be native. */ var $3a05aa0862658cab$var$Set = $9t30I($3YcUl, 'Set');
module.exports = $3a05aa0862658cab$var$Set;

});

parcelRegister("gdNpq", function(module, exports) {

var $9t30I = parcelRequire("9t30I");

var $3YcUl = parcelRequire("3YcUl");
/* Built-in method references that are verified to be native. */ var $bcf42fdf699137f8$var$WeakMap = $9t30I($3YcUl, 'WeakMap');
module.exports = $bcf42fdf699137f8$var$WeakMap;

});





parcelRegister("665GB", function(module, exports) {

var $fxWT9 = parcelRequire("fxWT9");

var $dFikY = parcelRequire("dFikY");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $4707b6c8e7e89b7e$var$getMatchData(object) {
    var result = $dFikY(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $fxWT9(value)
        ];
    }
    return result;
}
module.exports = $4707b6c8e7e89b7e$var$getMatchData;

});
parcelRegister("fxWT9", function(module, exports) {

var $3nMgq = parcelRequire("3nMgq");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $b5179e189ed71927$var$isStrictComparable(value) {
    return value === value && !$3nMgq(value);
}
module.exports = $b5179e189ed71927$var$isStrictComparable;

});


parcelRegister("bHcex", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $883d33333a587df0$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $883d33333a587df0$var$matchesStrictComparable;

});


parcelRegister("8TrU4", function(module, exports) {

var $gaQ7K = parcelRequire("gaQ7K");

var $2JX3T = parcelRequire("2JX3T");

var $gSSiO = parcelRequire("gSSiO");

var $hORXJ = parcelRequire("hORXJ");

var $fxWT9 = parcelRequire("fxWT9");

var $bHcex = parcelRequire("bHcex");

var $cdIrr = parcelRequire("cdIrr");
/** Used to compose bitmasks for value comparisons. */ var $67991acd72763872$var$COMPARE_PARTIAL_FLAG = 1, $67991acd72763872$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $67991acd72763872$var$baseMatchesProperty(path, srcValue) {
    if ($hORXJ(path) && $fxWT9(srcValue)) return $bHcex($cdIrr(path), srcValue);
    return function(object) {
        var objValue = $2JX3T(object, path);
        return objValue === undefined && objValue === srcValue ? $gSSiO(object, path) : $gaQ7K(srcValue, objValue, $67991acd72763872$var$COMPARE_PARTIAL_FLAG | $67991acd72763872$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $67991acd72763872$var$baseMatchesProperty;

});
parcelRegister("2JX3T", function(module, exports) {

var $gpjeE = parcelRequire("gpjeE");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $1fed9928c2ef6ddc$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $gpjeE(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $1fed9928c2ef6ddc$var$get;

});
parcelRegister("gpjeE", function(module, exports) {

var $cW65O = parcelRequire("cW65O");

var $cdIrr = parcelRequire("cdIrr");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $bf1de6df95fab6c3$var$baseGet(object, path) {
    path = $cW65O(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$cdIrr(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $bf1de6df95fab6c3$var$baseGet;

});
parcelRegister("cW65O", function(module, exports) {

var $8q346 = parcelRequire("8q346");

var $hORXJ = parcelRequire("hORXJ");

var $ez60o = parcelRequire("ez60o");

var $ajlGl = parcelRequire("ajlGl");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $96afa0b19738b775$var$castPath(value, object) {
    if ($8q346(value)) return value;
    return $hORXJ(value, object) ? [
        value
    ] : $ez60o($ajlGl(value));
}
module.exports = $96afa0b19738b775$var$castPath;

});
parcelRegister("hORXJ", function(module, exports) {

var $8q346 = parcelRequire("8q346");

var $9f248 = parcelRequire("9f248");
/** Used to match property names within property paths. */ var $cf90f702e72f93ed$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $cf90f702e72f93ed$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $cf90f702e72f93ed$var$isKey(value, object) {
    if ($8q346(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $9f248(value)) return true;
    return $cf90f702e72f93ed$var$reIsPlainProp.test(value) || !$cf90f702e72f93ed$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $cf90f702e72f93ed$var$isKey;

});
parcelRegister("9f248", function(module, exports) {

var $khKMn = parcelRequire("khKMn");

var $dHm51 = parcelRequire("dHm51");
/** `Object#toString` result references. */ var $6ba71df826f6e287$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6ba71df826f6e287$var$isSymbol(value) {
    return typeof value == 'symbol' || $dHm51(value) && $khKMn(value) == $6ba71df826f6e287$var$symbolTag;
}
module.exports = $6ba71df826f6e287$var$isSymbol;

});


parcelRegister("ez60o", function(module, exports) {

var $2Rwj5 = parcelRequire("2Rwj5");
/** Used to match property names within property paths. */ var $a9a8fe1fab9f896c$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a9a8fe1fab9f896c$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a9a8fe1fab9f896c$var$stringToPath = $2Rwj5(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($a9a8fe1fab9f896c$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a9a8fe1fab9f896c$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $a9a8fe1fab9f896c$var$stringToPath;

});
parcelRegister("2Rwj5", function(module, exports) {

var $b5rgi = parcelRequire("b5rgi");
/** Used as the maximum memoize cache size. */ var $21599776345cd8d5$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $21599776345cd8d5$var$memoizeCapped(func) {
    var result = $b5rgi(func, function(key) {
        if (cache.size === $21599776345cd8d5$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $21599776345cd8d5$var$memoizeCapped;

});
parcelRegister("b5rgi", function(module, exports) {

var $dRHf4 = parcelRequire("dRHf4");
/** Error message constants. */ var $81254ef85bec93a8$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $81254ef85bec93a8$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($81254ef85bec93a8$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($81254ef85bec93a8$var$memoize.Cache || $dRHf4);
    return memoized;
}
// Expose `MapCache`.
$81254ef85bec93a8$var$memoize.Cache = $dRHf4;
module.exports = $81254ef85bec93a8$var$memoize;

});



parcelRegister("ajlGl", function(module, exports) {

var $jAgFt = parcelRequire("jAgFt");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $781c7f4e101e1b57$var$toString(value) {
    return value == null ? '' : $jAgFt(value);
}
module.exports = $781c7f4e101e1b57$var$toString;

});
parcelRegister("jAgFt", function(module, exports) {

var $aQNXY = parcelRequire("aQNXY");

var $kXeGk = parcelRequire("kXeGk");

var $8q346 = parcelRequire("8q346");

var $9f248 = parcelRequire("9f248");
/** Used as references for various `Number` constants. */ var $e41e4effbb2cf394$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e41e4effbb2cf394$var$symbolProto = $aQNXY ? $aQNXY.prototype : undefined, $e41e4effbb2cf394$var$symbolToString = $e41e4effbb2cf394$var$symbolProto ? $e41e4effbb2cf394$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e41e4effbb2cf394$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($8q346(value)) // Recursively convert values (susceptible to call stack limits).
    return $kXeGk(value, $e41e4effbb2cf394$var$baseToString) + '';
    if ($9f248(value)) return $e41e4effbb2cf394$var$symbolToString ? $e41e4effbb2cf394$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$e41e4effbb2cf394$var$INFINITY ? '-0' : result;
}
module.exports = $e41e4effbb2cf394$var$baseToString;

});
parcelRegister("kXeGk", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $f414b4d1390a5888$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $f414b4d1390a5888$var$arrayMap;

});




parcelRegister("cdIrr", function(module, exports) {

var $9f248 = parcelRequire("9f248");
/** Used as references for various `Number` constants. */ var $8e592c19b966cd03$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $8e592c19b966cd03$var$toKey(value) {
    if (typeof value == 'string' || $9f248(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$8e592c19b966cd03$var$INFINITY ? '-0' : result;
}
module.exports = $8e592c19b966cd03$var$toKey;

});



parcelRegister("gSSiO", function(module, exports) {

var $9uJHq = parcelRequire("9uJHq");

var $bw5nz = parcelRequire("bw5nz");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $c4abcfd0aae44aef$var$hasIn(object, path) {
    return object != null && $bw5nz(object, path, $9uJHq);
}
module.exports = $c4abcfd0aae44aef$var$hasIn;

});
parcelRegister("9uJHq", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $6e9a5d5c4ce0a33d$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $6e9a5d5c4ce0a33d$var$baseHasIn;

});

parcelRegister("bw5nz", function(module, exports) {

var $cW65O = parcelRequire("cW65O");

var $2ZGmQ = parcelRequire("2ZGmQ");

var $8q346 = parcelRequire("8q346");

var $ggGy1 = parcelRequire("ggGy1");

var $6YEZM = parcelRequire("6YEZM");

var $cdIrr = parcelRequire("cdIrr");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $8626db0da5d224aa$var$hasPath(object, path, hasFunc) {
    path = $cW65O(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $cdIrr(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $6YEZM(length) && $ggGy1(key, length) && ($8q346(object) || $2ZGmQ(object));
}
module.exports = $8626db0da5d224aa$var$hasPath;

});



parcelRegister("4J5Np", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $370fdc5cb9340ccb$var$identity(value) {
    return value;
}
module.exports = $370fdc5cb9340ccb$var$identity;

});

parcelRegister("48LxI", function(module, exports) {

var $iqk2j = parcelRequire("iqk2j");

var $2dQmr = parcelRequire("2dQmr");

var $hORXJ = parcelRequire("hORXJ");

var $cdIrr = parcelRequire("cdIrr");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $303cc9c7aa346db9$var$property(path) {
    return $hORXJ(path) ? $iqk2j($cdIrr(path)) : $2dQmr(path);
}
module.exports = $303cc9c7aa346db9$var$property;

});
parcelRegister("iqk2j", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d69a3282cb31c03f$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $d69a3282cb31c03f$var$baseProperty;

});

parcelRegister("2dQmr", function(module, exports) {

var $gpjeE = parcelRequire("gpjeE");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $19e569743095f8fa$var$basePropertyDeep(path) {
    return function(object) {
        return $gpjeE(object, path);
    };
}
module.exports = $19e569743095f8fa$var$basePropertyDeep;

});



parcelRegister("9lzlI", function(module, exports) {
/** Error message constants. */ var $6ce17ed7cfc2b334$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $6ce17ed7cfc2b334$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($6ce17ed7cfc2b334$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = $6ce17ed7cfc2b334$var$negate;

});

parcelRegister("g0Amj", function(module, exports) {

var $kXeGk = parcelRequire("kXeGk");

var $alxWa = parcelRequire("alxWa");

var $9q9JR = parcelRequire("9q9JR");

var $cehQN = parcelRequire("cehQN");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $ba78d98826259fa4$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $kXeGk($cehQN(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $alxWa(predicate);
    return $9q9JR(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = $ba78d98826259fa4$var$pickBy;

});
parcelRegister("9q9JR", function(module, exports) {

var $gpjeE = parcelRequire("gpjeE");

var $igf3n = parcelRequire("igf3n");

var $cW65O = parcelRequire("cW65O");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $6dbe18ab3419e823$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $gpjeE(object, path);
        if (predicate(value, path)) $igf3n(result, $cW65O(path, object), value);
    }
    return result;
}
module.exports = $6dbe18ab3419e823$var$basePickBy;

});
parcelRegister("igf3n", function(module, exports) {

var $4Edgv = parcelRequire("4Edgv");

var $cW65O = parcelRequire("cW65O");

var $ggGy1 = parcelRequire("ggGy1");

var $3nMgq = parcelRequire("3nMgq");

var $cdIrr = parcelRequire("cdIrr");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $d4b565f22ab28474$var$baseSet(object, path, value, customizer) {
    if (!$3nMgq(object)) return object;
    path = $cW65O(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $cdIrr(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $3nMgq(objValue) ? objValue : $ggGy1(path[index + 1]) ? [] : {};
        }
        $4Edgv(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $d4b565f22ab28474$var$baseSet;

});
parcelRegister("4Edgv", function(module, exports) {

var $55ZT1 = parcelRequire("55ZT1");

var $ddQci = parcelRequire("ddQci");
/** Used for built-in method references. */ var $362530108f71f76b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $362530108f71f76b$var$hasOwnProperty = $362530108f71f76b$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $362530108f71f76b$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($362530108f71f76b$var$hasOwnProperty.call(object, key) && $ddQci(objValue, value)) || value === undefined && !(key in object)) $55ZT1(object, key, value);
}
module.exports = $362530108f71f76b$var$assignValue;

});
parcelRegister("55ZT1", function(module, exports) {

var $9b62A = parcelRequire("9b62A");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3b5d6cb98904bdcc$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $9b62A) $9b62A(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $3b5d6cb98904bdcc$var$baseAssignValue;

});
parcelRegister("9b62A", function(module, exports) {

var $9t30I = parcelRequire("9t30I");
var $6ae9d3b244c23789$var$defineProperty = function() {
    try {
        var func = $9t30I(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $6ae9d3b244c23789$var$defineProperty;

});





parcelRegister("cehQN", function(module, exports) {

var $g5Zcz = parcelRequire("g5Zcz");

var $itnTW = parcelRequire("itnTW");

var $11ojn = parcelRequire("11ojn");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8e74a3939dea83e5$var$getAllKeysIn(object) {
    return $g5Zcz(object, $11ojn, $itnTW);
}
module.exports = $8e74a3939dea83e5$var$getAllKeysIn;

});
parcelRegister("itnTW", function(module, exports) {

var $fC54b = parcelRequire("fC54b");

var $3YMPE = parcelRequire("3YMPE");

var $9DJv2 = parcelRequire("9DJv2");

var $9bCiF = parcelRequire("9bCiF");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d72d79bb5bd8bd8f$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d72d79bb5bd8bd8f$var$getSymbolsIn = !$d72d79bb5bd8bd8f$var$nativeGetSymbols ? $9bCiF : function(object) {
    var result = [];
    while(object){
        $fC54b(result, $9DJv2(object));
        object = $3YMPE(object);
    }
    return result;
};
module.exports = $d72d79bb5bd8bd8f$var$getSymbolsIn;

});
parcelRegister("3YMPE", function(module, exports) {

var $4rimC = parcelRequire("4rimC");
/** Built-in value references. */ var $2e5cdab444190c04$var$getPrototype = $4rimC(Object.getPrototypeOf, Object);
module.exports = $2e5cdab444190c04$var$getPrototype;

});


parcelRegister("11ojn", function(module, exports) {

var $f3rs9 = parcelRequire("f3rs9");

var $2sIpe = parcelRequire("2sIpe");

var $4Gxuc = parcelRequire("4Gxuc");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $0be8be3522c0fe13$var$keysIn(object) {
    return $4Gxuc(object) ? $f3rs9(object, true) : $2sIpe(object);
}
module.exports = $0be8be3522c0fe13$var$keysIn;

});
parcelRegister("2sIpe", function(module, exports) {

var $3nMgq = parcelRequire("3nMgq");

var $3ZG5S = parcelRequire("3ZG5S");

var $1gsoB = parcelRequire("1gsoB");
/** Used for built-in method references. */ var $1cb0a4697e36852f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1cb0a4697e36852f$var$hasOwnProperty = $1cb0a4697e36852f$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $1cb0a4697e36852f$var$baseKeysIn(object) {
    if (!$3nMgq(object)) return $1gsoB(object);
    var isProto = $3ZG5S(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$1cb0a4697e36852f$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $1cb0a4697e36852f$var$baseKeysIn;

});
parcelRegister("1gsoB", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0ebd4fe512b52f03$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $0ebd4fe512b52f03$var$nativeKeysIn;

});






parcelRegister("27U5U", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(payload) {
    var tags = payload.tags, containerId = payload.containerId, containerType = payload.containerType, objectId = payload.objectId, objectType = payload.objectType, attributes = payload.attributes;
    return {
        tags: tags,
        containerId: containerId,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    };
};

});



parcelRegister("26Ik8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4xqTJ = parcelRequire("4xqTJ");
var $188e86165e299d3c$var$_getPrototypeOf2 = $188e86165e299d3c$var$_interopRequireDefault($4xqTJ);

var $5TXFC = parcelRequire("5TXFC");
var $188e86165e299d3c$var$_classCallCheck3 = $188e86165e299d3c$var$_interopRequireDefault($5TXFC);

var $aqT68 = parcelRequire("aqT68");
var $188e86165e299d3c$var$_createClass3 = $188e86165e299d3c$var$_interopRequireDefault($aqT68);

var $elXYp = parcelRequire("elXYp");
var $188e86165e299d3c$var$_possibleConstructorReturn3 = $188e86165e299d3c$var$_interopRequireDefault($elXYp);

var $iLcSb = parcelRequire("iLcSb");
var $188e86165e299d3c$var$_inherits3 = $188e86165e299d3c$var$_interopRequireDefault($iLcSb);

var $8P7DW = parcelRequire("8P7DW");

var $k7ZVu = parcelRequire("k7ZVu");
function $188e86165e299d3c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $188e86165e299d3c$var$MountTracker = function(_Component) {
    (0, $188e86165e299d3c$var$_inherits3.default)(MountTracker, _Component);
    function MountTracker() {
        (0, $188e86165e299d3c$var$_classCallCheck3.default)(this, MountTracker);
        return (0, $188e86165e299d3c$var$_possibleConstructorReturn3.default)(this, (MountTracker.__proto__ || (0, $188e86165e299d3c$var$_getPrototypeOf2.default)(MountTracker)).apply(this, arguments));
    }
    (0, $188e86165e299d3c$var$_createClass3.default)(MountTracker, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                // $FlowFixMe
                this.props.onMount();
            }
        },
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return MountTracker;
}($8P7DW.Component);
module.exports.default = (0, $k7ZVu.default)({
    onMount: {
        action: 'viewed'
    }
})($188e86165e299d3c$var$MountTracker);

});
parcelRegister("k7ZVu", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5031aa3947851c7$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $1wBi5 = parcelRequire("1wBi5");
const $d5031aa3947851c7$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps: patchedEventProps } = (0, $1wBi5.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, $gWgPx.jsx)(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $d5031aa3947851c7$export$2e2bcd8739ae039 = $d5031aa3947851c7$var$withAnalyticsEvents;

});
parcelRegister("MmGmU", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $6100f41e7766f1dd$export$5bf35293e545f20c);

var $5cxZG = parcelRequire("5cxZG");

var $hlZhv = parcelRequire("hlZhv");

var $hixr3 = parcelRequire("hixr3");
function $6100f41e7766f1dd$export$5bf35293e545f20c() {
    const analyticsContext = (0, $hixr3.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $5cxZG.useCallbackOne)((payload)=>{
        return new (0, $hlZhv.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("5cxZG", function(module, exports) {
$parcel$export(module.exports, "useMemoOne", () => $3c98713c19e5f5b5$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useCallbackOne", () => $3c98713c19e5f5b5$export$33752cf3ee811995);

var $8P7DW = parcelRequire("8P7DW");
function $3c98713c19e5f5b5$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $3c98713c19e5f5b5$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $8P7DW.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $8P7DW.useRef)(true);
    var committed = (0, $8P7DW.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $3c98713c19e5f5b5$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $8P7DW.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $3c98713c19e5f5b5$export$33752cf3ee811995(callback, inputs) {
    return $3c98713c19e5f5b5$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $3c98713c19e5f5b5$export$1538c33de8887b59 = $3c98713c19e5f5b5$export$b6feb8998cd9b342;
var $3c98713c19e5f5b5$export$35808ee640e87ca7 = $3c98713c19e5f5b5$export$33752cf3ee811995;

});


parcelRegister("1wBi5", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $d1d51b0dbc4da3de$export$9ebb5a84d17e5d18);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");
function $d1d51b0dbc4da3de$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const handlerCache = (0, $8P7DW.useRef)({});
    const patchedProps = (0, $8P7DW.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});



parcelRegister("jtI2d", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4xqTJ = parcelRequire("4xqTJ");
var $e2e2e21d0167532a$var$_getPrototypeOf2 = $e2e2e21d0167532a$var$_interopRequireDefault($4xqTJ);

var $5TXFC = parcelRequire("5TXFC");
var $e2e2e21d0167532a$var$_classCallCheck3 = $e2e2e21d0167532a$var$_interopRequireDefault($5TXFC);

var $aqT68 = parcelRequire("aqT68");
var $e2e2e21d0167532a$var$_createClass3 = $e2e2e21d0167532a$var$_interopRequireDefault($aqT68);

var $elXYp = parcelRequire("elXYp");
var $e2e2e21d0167532a$var$_possibleConstructorReturn3 = $e2e2e21d0167532a$var$_interopRequireDefault($elXYp);

var $iLcSb = parcelRequire("iLcSb");
var $e2e2e21d0167532a$var$_inherits3 = $e2e2e21d0167532a$var$_interopRequireDefault($iLcSb);

var $8P7DW = parcelRequire("8P7DW");
var $e2e2e21d0167532a$var$_react2 = $e2e2e21d0167532a$var$_interopRequireDefault($8P7DW);

var $9sPDn = parcelRequire("9sPDn");
var $e2e2e21d0167532a$var$_analyticsContext2 = $e2e2e21d0167532a$var$_interopRequireDefault($9sPDn);
function $e2e2e21d0167532a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(Props) {
    return function(WrappedComponent) {
        return function(_Component) {
            (0, $e2e2e21d0167532a$var$_inherits3.default)(WithAnalyticsContext, _Component);
            function WithAnalyticsContext() {
                (0, $e2e2e21d0167532a$var$_classCallCheck3.default)(this, WithAnalyticsContext);
                return (0, $e2e2e21d0167532a$var$_possibleConstructorReturn3.default)(this, (WithAnalyticsContext.__proto__ || (0, $e2e2e21d0167532a$var$_getPrototypeOf2.default)(WithAnalyticsContext)).apply(this, arguments));
            }
            (0, $e2e2e21d0167532a$var$_createClass3.default)(WithAnalyticsContext, [
                {
                    key: 'render',
                    value: function render() {
                        return $e2e2e21d0167532a$var$_react2.default.createElement($e2e2e21d0167532a$var$_analyticsContext2.default, Props, $e2e2e21d0167532a$var$_react2.default.createElement(WrappedComponent, this.props));
                    }
                }
            ]);
            return WithAnalyticsContext;
        }($8P7DW.Component);
    };
};

});

parcelRegister("5Fg3O", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bQrep = parcelRequire("bQrep");

var $gmlhq = parcelRequire("gmlhq");

var $SqIfc = parcelRequire("SqIfc");

var $8ht3d = parcelRequire("8ht3d");

var $lKHEM = parcelRequire("lKHEM");
// data.type necessary cause of flow
module.exports.default = function(data) {
    if (!data) throw new Error('No event data passed in');
    if (data.client && data.type !== $bQrep.OPERATIONAL_EVENT_TYPE) throw new Error('Sending events via client is not supported in non Operational events');
    if (data.type === $bQrep.UI_EVENT_TYPE) (0, $lKHEM.fireAnalyticsUiEvent)(data.analyticsEvent, data.payload);
    else if (data.type === $bQrep.TRACK_EVENT_TYPE) (0, $8ht3d.fireAnalyticsTrackEvent)(data.analyticsEvent, data.payload);
    else if (data.type === $bQrep.OPERATIONAL_EVENT_TYPE) (0, $gmlhq.fireAnalyticsOperationalEvent)(data);
    else if (data.type === $bQrep.SCREEN_EVENT_TYPE) (0, $SqIfc.fireAnalyticsScreenEvent)(data.analyticsEvent, data.payload);
    else throw new Error('Event type not supported: ' + data.type);
};

});
parcelRegister("gmlhq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsOperationalEvent = module.exports.fireAnalyticsOperationalEventWithClient = module.exports.fireAnalyticsOperationEventWithEvent = undefined;

var $evBv1 = parcelRequire("evBv1");
var $be8f352d5ea8702a$var$_extends3 = $be8f352d5ea8702a$var$_interopRequireDefault($evBv1);

var $h77QL = parcelRequire("h77QL");
var $be8f352d5ea8702a$var$_isUndefined2 = $be8f352d5ea8702a$var$_interopRequireDefault($h77QL);

var $g0Amj = parcelRequire("g0Amj");
var $be8f352d5ea8702a$var$_pickBy2 = $be8f352d5ea8702a$var$_interopRequireDefault($g0Amj);

var $bQrep = parcelRequire("bQrep");

var $27U5U = parcelRequire("27U5U");
var $be8f352d5ea8702a$var$_mapDataPayloadToContextPayload2 = $be8f352d5ea8702a$var$_interopRequireDefault($27U5U);
function $be8f352d5ea8702a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $be8f352d5ea8702a$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $be8f352d5ea8702a$var$_isUndefined2.default)(a);
};
var $be8f352d5ea8702a$var$mapOperationalPayload = function mapOperationalPayload(payload) {
    var context = (0, $be8f352d5ea8702a$var$_mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;
    return (0, $be8f352d5ea8702a$var$_pickBy2.default)((0, $be8f352d5ea8702a$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), $be8f352d5ea8702a$var$isNotUndefined);
};
var $be8f352d5ea8702a$var$mapOperationalPayloadToClient = function mapOperationalPayloadToClient(payload) {
    var context = (0, $be8f352d5ea8702a$var$_mapDataPayloadToContextPayload2.default)(payload);
    var sourceName = payload.sourceName, sourceType = payload.sourceType, action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId;
    if (!action || !actionSubject || !sourceName || !sourceType) return false;
    var source = sourceName + sourceType;
    return (0, $be8f352d5ea8702a$var$_pickBy2.default)((0, $be8f352d5ea8702a$var$_extends3.default)({}, context, {
        source: source,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), $be8f352d5ea8702a$var$isNotUndefined);
};
var $be8f352d5ea8702a$var$fireAnalyticsOperationEventWithEvent = module.exports.fireAnalyticsOperationEventWithEvent = function fireAnalyticsOperationEventWithEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $be8f352d5ea8702a$var$_extends3.default)({}, $be8f352d5ea8702a$var$mapOperationalPayload(payload), {
        analyticsType: $bQrep.OPERATIONAL_EVENT_TYPE
    })).fire();
};
var $be8f352d5ea8702a$var$fireAnalyticsOperationalEventWithClient = module.exports.fireAnalyticsOperationalEventWithClient = function fireAnalyticsOperationalEventWithClient(client, payload) {
    if (!client.sendOperationalEvent) throw new Error('No Operational event fired, sendOperationEvent doesnt exist');
    if (!(typeof client.sendOperationalEvent === 'function')) throw new Error('No Operational event fired, sendOperationEvent is not a function');
    var mappedPayload = $be8f352d5ea8702a$var$mapOperationalPayloadToClient(payload);
    if (!mappedPayload) throw new Error('No Operational event fired, missing payload attributes. Operational events require an action, actionSubject, sourceName and sourceType');
    return client.sendOperationalEvent(mappedPayload);
};
var $be8f352d5ea8702a$var$fireAnalyticsOperationalEvent = module.exports.fireAnalyticsOperationalEvent = function fireAnalyticsOperationalEvent(data) {
    if (data.client) return $be8f352d5ea8702a$var$fireAnalyticsOperationalEventWithClient(data.client, data.payload);
    return $be8f352d5ea8702a$var$fireAnalyticsOperationEventWithEvent(data.analyticsEvent, data.payload);
};

});

parcelRegister("SqIfc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsScreenEvent = undefined;

var $evBv1 = parcelRequire("evBv1");
var $0a39c3d456dfcb6a$var$_extends3 = $0a39c3d456dfcb6a$var$_interopRequireDefault($evBv1);

var $h77QL = parcelRequire("h77QL");
var $0a39c3d456dfcb6a$var$_isUndefined2 = $0a39c3d456dfcb6a$var$_interopRequireDefault($h77QL);

var $g0Amj = parcelRequire("g0Amj");
var $0a39c3d456dfcb6a$var$_pickBy2 = $0a39c3d456dfcb6a$var$_interopRequireDefault($g0Amj);

var $bQrep = parcelRequire("bQrep");
function $0a39c3d456dfcb6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0a39c3d456dfcb6a$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $0a39c3d456dfcb6a$var$_isUndefined2.default)(a);
};
var $0a39c3d456dfcb6a$var$mapPayload = function mapPayload(payload) {
    return (0, $0a39c3d456dfcb6a$var$_pickBy2.default)((0, $0a39c3d456dfcb6a$var$_extends3.default)({}, payload, payload.attributes, {
        attributes: undefined
    }), $0a39c3d456dfcb6a$var$isNotUndefined);
};
var $0a39c3d456dfcb6a$var$fireAnalyticsScreenEvent = module.exports.fireAnalyticsScreenEvent = function fireAnalyticsScreenEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $0a39c3d456dfcb6a$var$_extends3.default)({}, $0a39c3d456dfcb6a$var$mapPayload(payload || {}), {
        analyticsType: $bQrep.SCREEN_EVENT_TYPE
    })).fire();
};

});

parcelRegister("8ht3d", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsTrackEvent = undefined;

var $evBv1 = parcelRequire("evBv1");
var $6076722e78e0e6fe$var$_extends3 = $6076722e78e0e6fe$var$_interopRequireDefault($evBv1);

var $h77QL = parcelRequire("h77QL");
var $6076722e78e0e6fe$var$_isUndefined2 = $6076722e78e0e6fe$var$_interopRequireDefault($h77QL);

var $g0Amj = parcelRequire("g0Amj");
var $6076722e78e0e6fe$var$_pickBy2 = $6076722e78e0e6fe$var$_interopRequireDefault($g0Amj);

var $bQrep = parcelRequire("bQrep");

var $27U5U = parcelRequire("27U5U");
var $6076722e78e0e6fe$var$_mapDataPayloadToContextPayload2 = $6076722e78e0e6fe$var$_interopRequireDefault($27U5U);
function $6076722e78e0e6fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6076722e78e0e6fe$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $6076722e78e0e6fe$var$_isUndefined2.default)(a);
};
var $6076722e78e0e6fe$var$mapPayload = function mapPayload(payload) {
    var context = (0, $6076722e78e0e6fe$var$_mapDataPayloadToContextPayload2.default)(payload);
    var action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId;
    return (0, $6076722e78e0e6fe$var$_pickBy2.default)((0, $6076722e78e0e6fe$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), $6076722e78e0e6fe$var$isNotUndefined);
};
var $6076722e78e0e6fe$var$fireAnalyticsTrackEvent = module.exports.fireAnalyticsTrackEvent = function fireAnalyticsTrackEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $6076722e78e0e6fe$var$_extends3.default)({}, $6076722e78e0e6fe$var$mapPayload(payload), {
        analyticsType: $bQrep.TRACK_EVENT_TYPE
    })).fire();
};

});

parcelRegister("lKHEM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsUiEvent = undefined;

var $evBv1 = parcelRequire("evBv1");
var $fd5fc22f70880178$var$_extends3 = $fd5fc22f70880178$var$_interopRequireDefault($evBv1);

var $h77QL = parcelRequire("h77QL");
var $fd5fc22f70880178$var$_isUndefined2 = $fd5fc22f70880178$var$_interopRequireDefault($h77QL);

var $g0Amj = parcelRequire("g0Amj");
var $fd5fc22f70880178$var$_pickBy2 = $fd5fc22f70880178$var$_interopRequireDefault($g0Amj);

var $bQrep = parcelRequire("bQrep");

var $27U5U = parcelRequire("27U5U");
var $fd5fc22f70880178$var$_mapDataPayloadToContextPayload2 = $fd5fc22f70880178$var$_interopRequireDefault($27U5U);
function $fd5fc22f70880178$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fd5fc22f70880178$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $fd5fc22f70880178$var$_isUndefined2.default)(a);
};
/**
 * Analytics web react 2.0
 */ var $fd5fc22f70880178$var$mapUiPayload = function mapUiPayload(payload) {
    var context = (0, $fd5fc22f70880178$var$_mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;
    return (0, $fd5fc22f70880178$var$_pickBy2.default)((0, $fd5fc22f70880178$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), $fd5fc22f70880178$var$isNotUndefined);
};
var $fd5fc22f70880178$var$fireAnalyticsUiEvent = module.exports.fireAnalyticsUiEvent = function fireAnalyticsUiEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $fd5fc22f70880178$var$_extends3.default)({}, $fd5fc22f70880178$var$mapUiPayload(payload), {
        analyticsType: $bQrep.UI_EVENT_TYPE
    })).fire();
};

});


parcelRegister("e7EyD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $evBv1 = parcelRequire("evBv1");
var $a4812e0af5a1c2ee$var$_extends3 = $a4812e0af5a1c2ee$var$_interopRequireDefault($evBv1);

var $h77QL = parcelRequire("h77QL");
var $a4812e0af5a1c2ee$var$_isUndefined2 = $a4812e0af5a1c2ee$var$_interopRequireDefault($h77QL);

var $gipvx = parcelRequire("gipvx");
var $a4812e0af5a1c2ee$var$_last2 = $a4812e0af5a1c2ee$var$_interopRequireDefault($gipvx);

var $4FG1Q = parcelRequire("4FG1Q");
var $a4812e0af5a1c2ee$var$_omitBy2 = $a4812e0af5a1c2ee$var$_interopRequireDefault($4FG1Q);

var $bQrep = parcelRequire("bQrep");

var $eWsVm = parcelRequire("eWsVm");
function $a4812e0af5a1c2ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a4812e0af5a1c2ee$var$getActionSubjectForEventType = function getActionSubjectForEventType(event, analyticsType) {
    if (analyticsType === $bQrep.TRACK_EVENT_TYPE) return (0, $eWsVm.getActionSubject)(event);
    return (0, $a4812e0af5a1c2ee$var$_last2.default)((0, $eWsVm.getComponents)(event));
};
/**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * AtlasKit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */ module.exports.default = function(event) {
    var sources = (0, $eWsVm.getSources)(event);
    var analyticsType = (0, $eWsVm.getAnalyticsType)(event);
    var actionSubject = $a4812e0af5a1c2ee$var$getActionSubjectForEventType(event, analyticsType);
    var source = (0, $a4812e0af5a1c2ee$var$_last2.default)(sources);
    var action = (0, $eWsVm.getAction)(event);
    var attributes = (0, $a4812e0af5a1c2ee$var$_extends3.default)({}, (0, $eWsVm.getAttributes)(event), {
        namespaces: sources.join('.')
    });
    if (action === $bQrep.PAGE_EVENT_ACTION || analyticsType === $bQrep.SCREEN_EVENT_TYPE) return {
        type: $bQrep.SCREEN_EVENT_TYPE,
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case $bQrep.UI_EVENT_TYPE:
        case $bQrep.TRACK_EVENT_TYPE:
        case $bQrep.OPERATIONAL_EVENT_TYPE:
            var actionSubjectId = (0, $eWsVm.getActionSubjectId)(event);
            var containerId = (0, $a4812e0af5a1c2ee$var$_last2.default)((0, $eWsVm.getContainerIds)(event));
            var containerType = (0, $a4812e0af5a1c2ee$var$_last2.default)((0, $eWsVm.getContainerTypes)(event));
            var objectId = (0, $a4812e0af5a1c2ee$var$_last2.default)((0, $eWsVm.getObjectIds)(event));
            var objectType = (0, $a4812e0af5a1c2ee$var$_last2.default)((0, $eWsVm.getObjectTypes)(event));
            var tags = (0, $eWsVm.getTags)(event);
            return {
                type: analyticsType,
                payload: (0, $a4812e0af5a1c2ee$var$_omitBy2.default)({
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    source: source,
                    tags: tags,
                    containerType: containerType,
                    containerId: containerId,
                    objectType: objectType,
                    objectId: objectId,
                    attributes: attributes
                }, $a4812e0af5a1c2ee$var$_isUndefined2.default)
            };
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("gipvx", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $bdd21d19437f6e54$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $bdd21d19437f6e54$var$last;

});

parcelRegister("eWsVm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAction = module.exports.getAnalyticsType = module.exports.getActionSubjectId = module.exports.getObjectIds = module.exports.getObjectTypes = module.exports.getContainerIds = module.exports.getContainerTypes = module.exports.getTags = module.exports.getAttributes = module.exports.getSources = module.exports.getActionSubject = module.exports.getComponents = undefined;

var $6zZ4f = parcelRequire("6zZ4f");
var $ae0ceb3b15aa2605$var$_objectWithoutProperties3 = $ae0ceb3b15aa2605$var$_interopRequireDefault($6zZ4f);

var $j9wX8 = parcelRequire("j9wX8");
var $ae0ceb3b15aa2605$var$_merge2 = $ae0ceb3b15aa2605$var$_interopRequireDefault($j9wX8);

var $95ko3 = parcelRequire("95ko3");
var $ae0ceb3b15aa2605$var$_uniq2 = $ae0ceb3b15aa2605$var$_interopRequireDefault($95ko3);
function $ae0ceb3b15aa2605$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ae0ceb3b15aa2605$var$extractFromEventContext = function extractFromEventContext(propertyNames, event) {
    return event.context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
};
var $ae0ceb3b15aa2605$var$extractFromEventPayload = function extractFromEventPayload(propertyName, event) {
    return event.payload[propertyName];
};
var $ae0ceb3b15aa2605$var$extractFromPayloadOrContext = function extractFromPayloadOrContext(propertyName, event) {
    var payloadProp = $ae0ceb3b15aa2605$var$extractFromEventPayload(propertyName, event);
    var contextProps = $ae0ceb3b15aa2605$var$extractFromEventContext([
        propertyName
    ], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};
var $ae0ceb3b15aa2605$var$extractPayloadAttributes = function extractPayloadAttributes(event) {
    var _event$payload = event.payload, tags = _event$payload.tags, actionSubjectId = _event$payload.actionSubjectId, containerType = _event$payload.containerType, containerId = _event$payload.containerId, objectType = _event$payload.objectType, objectId = _event$payload.objectId, analyticsType = _event$payload.analyticsType, name = _event$payload.name, action = _event$payload.action, actionSubject = _event$payload.actionSubject, attributes = (0, $ae0ceb3b15aa2605$var$_objectWithoutProperties3.default)(_event$payload, [
        'tags',
        'actionSubjectId',
        'containerType',
        'containerId',
        'objectType',
        'objectId',
        'analyticsType',
        'name',
        'action',
        'actionSubject'
    ]);
    return attributes;
};
var $ae0ceb3b15aa2605$var$getComponents = module.exports.getComponents = function getComponents(event) {
    return $ae0ceb3b15aa2605$var$extractFromEventContext([
        'component',
        'componentName'
    ], event);
};
var $ae0ceb3b15aa2605$var$getActionSubject = module.exports.getActionSubject = function getActionSubject(event) {
    return $ae0ceb3b15aa2605$var$extractFromEventPayload('actionSubject', event);
};
var $ae0ceb3b15aa2605$var$getSources = module.exports.getSources = function getSources(event) {
    return $ae0ceb3b15aa2605$var$extractFromEventContext([
        'source'
    ], event);
};
var $ae0ceb3b15aa2605$var$getAttributes = module.exports.getAttributes = function getAttributes(event) {
    return (0, $ae0ceb3b15aa2605$var$_merge2.default)($ae0ceb3b15aa2605$var$extractFromEventContext([
        'attributes'
    ], event).reduce(function(result, extraAttributes) {
        return (0, $ae0ceb3b15aa2605$var$_merge2.default)(result, extraAttributes);
    }, {}), $ae0ceb3b15aa2605$var$extractPayloadAttributes(event));
};
var $ae0ceb3b15aa2605$var$getTags = module.exports.getTags = function getTags(event) {
    var tags = (0, $ae0ceb3b15aa2605$var$_uniq2.default)($ae0ceb3b15aa2605$var$extractFromEventContext([
        'tags'
    ], event).reduce(function(result, extraTags) {
        return result.concat(extraTags);
    }, []).concat($ae0ceb3b15aa2605$var$extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};
var $ae0ceb3b15aa2605$var$getContainerTypes = module.exports.getContainerTypes = function getContainerTypes(event) {
    return $ae0ceb3b15aa2605$var$extractFromPayloadOrContext('containerType', event);
};
var $ae0ceb3b15aa2605$var$getContainerIds = module.exports.getContainerIds = function getContainerIds(event) {
    return $ae0ceb3b15aa2605$var$extractFromPayloadOrContext('containerId', event);
};
var $ae0ceb3b15aa2605$var$getObjectTypes = module.exports.getObjectTypes = function getObjectTypes(event) {
    return $ae0ceb3b15aa2605$var$extractFromPayloadOrContext('objectType', event);
};
var $ae0ceb3b15aa2605$var$getObjectIds = module.exports.getObjectIds = function getObjectIds(event) {
    return $ae0ceb3b15aa2605$var$extractFromPayloadOrContext('objectId', event);
};
// singluar extractors
var $ae0ceb3b15aa2605$var$getActionSubjectId = module.exports.getActionSubjectId = function getActionSubjectId(event) {
    return $ae0ceb3b15aa2605$var$extractFromEventPayload('actionSubjectId', event);
};
var $ae0ceb3b15aa2605$var$getAnalyticsType = module.exports.getAnalyticsType = function getAnalyticsType(event) {
    return $ae0ceb3b15aa2605$var$extractFromEventPayload('analyticsType', event);
};
var $ae0ceb3b15aa2605$var$getAction = module.exports.getAction = function getAction(event) {
    return $ae0ceb3b15aa2605$var$extractFromEventPayload('action', event);
};

});
parcelRegister("j9wX8", function(module, exports) {

var $gdNdP = parcelRequire("gdNdP");

var $5jeKr = parcelRequire("5jeKr");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $df186b545826f83f$var$merge = $5jeKr(function(object, source, srcIndex) {
    $gdNdP(object, source, srcIndex);
});
module.exports = $df186b545826f83f$var$merge;

});
parcelRegister("gdNdP", function(module, exports) {

var $6RLEe = parcelRequire("6RLEe");

var $3vyeA = parcelRequire("3vyeA");

var $cG6Li = parcelRequire("cG6Li");

var $eNdrb = parcelRequire("eNdrb");

var $3nMgq = parcelRequire("3nMgq");

var $11ojn = parcelRequire("11ojn");

var $ebscy = parcelRequire("ebscy");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $bcf40ab953a1f06d$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $cG6Li(source, function(srcValue, key) {
        stack || (stack = new $6RLEe);
        if ($3nMgq(srcValue)) $eNdrb(object, source, key, srcIndex, $bcf40ab953a1f06d$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($ebscy(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $3vyeA(object, key, newValue);
        }
    }, $11ojn);
}
module.exports = $bcf40ab953a1f06d$var$baseMerge;

});
parcelRegister("3vyeA", function(module, exports) {

var $55ZT1 = parcelRequire("55ZT1");

var $ddQci = parcelRequire("ddQci");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $28ded2894f1555b9$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$ddQci(object[key], value) || value === undefined && !(key in object)) $55ZT1(object, key, value);
}
module.exports = $28ded2894f1555b9$var$assignMergeValue;

});

parcelRegister("cG6Li", function(module, exports) {

var $gG6yN = parcelRequire("gG6yN");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $93aea705c2026959$var$baseFor = $gG6yN();
module.exports = $93aea705c2026959$var$baseFor;

});
parcelRegister("gG6yN", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $c245a849f7d713dd$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $c245a849f7d713dd$var$createBaseFor;

});


parcelRegister("eNdrb", function(module, exports) {

var $3vyeA = parcelRequire("3vyeA");

var $airsz = parcelRequire("airsz");

var $aNH3x = parcelRequire("aNH3x");

var $apgAW = parcelRequire("apgAW");

var $jtKeN = parcelRequire("jtKeN");

var $2ZGmQ = parcelRequire("2ZGmQ");

var $8q346 = parcelRequire("8q346");

var $9vVjJ = parcelRequire("9vVjJ");

var $fomC7 = parcelRequire("fomC7");

var $fIflg = parcelRequire("fIflg");

var $3nMgq = parcelRequire("3nMgq");

var $b5CxW = parcelRequire("b5CxW");

var $1N3Uy = parcelRequire("1N3Uy");

var $ebscy = parcelRequire("ebscy");

var $4UNV5 = parcelRequire("4UNV5");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $ac5010b24187fe34$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $ebscy(object, key), srcValue = $ebscy(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $3vyeA(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $8q346(srcValue), isBuff = !isArr && $fomC7(srcValue), isTyped = !isArr && !isBuff && $1N3Uy(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($8q346(objValue)) newValue = objValue;
            else if ($9vVjJ(objValue)) newValue = $apgAW(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $airsz(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $aNH3x(srcValue, true);
            } else newValue = [];
        } else if ($b5CxW(srcValue) || $2ZGmQ(srcValue)) {
            newValue = objValue;
            if ($2ZGmQ(objValue)) newValue = $4UNV5(objValue);
            else if (!$3nMgq(objValue) || $fIflg(objValue)) newValue = $jtKeN(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $3vyeA(object, key, newValue);
}
module.exports = $ac5010b24187fe34$var$baseMergeDeep;

});
parcelRegister("airsz", function(module, exports) {

var $3YcUl = parcelRequire("3YcUl");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $3YcUl.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("aNH3x", function(module, exports) {

var $lcMGs = parcelRequire("lcMGs");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $7dcfe101299433af$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $lcMGs(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $7dcfe101299433af$var$cloneTypedArray;

});
parcelRegister("lcMGs", function(module, exports) {

var $4Yqwf = parcelRequire("4Yqwf");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $f7007b8d5d585351$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $4Yqwf(result).set(new $4Yqwf(arrayBuffer));
    return result;
}
module.exports = $f7007b8d5d585351$var$cloneArrayBuffer;

});


parcelRegister("apgAW", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $79391c90a7dd8068$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $79391c90a7dd8068$var$copyArray;

});

parcelRegister("jtKeN", function(module, exports) {

var $3tHLR = parcelRequire("3tHLR");

var $3YMPE = parcelRequire("3YMPE");

var $3ZG5S = parcelRequire("3ZG5S");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $e2e49791a3a2287a$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$3ZG5S(object) ? $3tHLR($3YMPE(object)) : {};
}
module.exports = $e2e49791a3a2287a$var$initCloneObject;

});
parcelRegister("3tHLR", function(module, exports) {

var $3nMgq = parcelRequire("3nMgq");
/** Built-in value references. */ var $2886088a1e4f3f0d$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $2886088a1e4f3f0d$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$3nMgq(proto)) return {};
        if ($2886088a1e4f3f0d$var$objectCreate) return $2886088a1e4f3f0d$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $2886088a1e4f3f0d$var$baseCreate;

});


parcelRegister("9vVjJ", function(module, exports) {

var $4Gxuc = parcelRequire("4Gxuc");

var $dHm51 = parcelRequire("dHm51");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $6ed37853e0e5643c$var$isArrayLikeObject(value) {
    return $dHm51(value) && $4Gxuc(value);
}
module.exports = $6ed37853e0e5643c$var$isArrayLikeObject;

});

parcelRegister("b5CxW", function(module, exports) {

var $khKMn = parcelRequire("khKMn");

var $3YMPE = parcelRequire("3YMPE");

var $dHm51 = parcelRequire("dHm51");
/** `Object#toString` result references. */ var $812e0fdf6cc19d16$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $812e0fdf6cc19d16$var$funcProto = Function.prototype, $812e0fdf6cc19d16$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $812e0fdf6cc19d16$var$funcToString = $812e0fdf6cc19d16$var$funcProto.toString;
/** Used to check objects for own properties. */ var $812e0fdf6cc19d16$var$hasOwnProperty = $812e0fdf6cc19d16$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $812e0fdf6cc19d16$var$objectCtorString = $812e0fdf6cc19d16$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $812e0fdf6cc19d16$var$isPlainObject(value) {
    if (!$dHm51(value) || $khKMn(value) != $812e0fdf6cc19d16$var$objectTag) return false;
    var proto = $3YMPE(value);
    if (proto === null) return true;
    var Ctor = $812e0fdf6cc19d16$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $812e0fdf6cc19d16$var$funcToString.call(Ctor) == $812e0fdf6cc19d16$var$objectCtorString;
}
module.exports = $812e0fdf6cc19d16$var$isPlainObject;

});

parcelRegister("ebscy", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a537f7fd1635c053$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $a537f7fd1635c053$var$safeGet;

});

parcelRegister("4UNV5", function(module, exports) {

var $bZHT5 = parcelRequire("bZHT5");

var $11ojn = parcelRequire("11ojn");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $39431d6d57d580d2$var$toPlainObject(value) {
    return $bZHT5(value, $11ojn(value));
}
module.exports = $39431d6d57d580d2$var$toPlainObject;

});
parcelRegister("bZHT5", function(module, exports) {

var $4Edgv = parcelRequire("4Edgv");

var $55ZT1 = parcelRequire("55ZT1");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $8bb76f58fa86777d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $55ZT1(object, key, newValue);
        else $4Edgv(object, key, newValue);
    }
    return object;
}
module.exports = $8bb76f58fa86777d$var$copyObject;

});




parcelRegister("5jeKr", function(module, exports) {

var $iYo9G = parcelRequire("iYo9G");

var $k6eJ6 = parcelRequire("k6eJ6");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $3dda2ac3cc524ba4$var$createAssigner(assigner) {
    return $iYo9G(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $k6eJ6(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $3dda2ac3cc524ba4$var$createAssigner;

});
parcelRegister("iYo9G", function(module, exports) {

var $4J5Np = parcelRequire("4J5Np");

var $1r2vi = parcelRequire("1r2vi");

var $wHOzh = parcelRequire("wHOzh");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $dd0091526e40ef4d$var$baseRest(func, start) {
    return $wHOzh($1r2vi(func, start, $4J5Np), func + '');
}
module.exports = $dd0091526e40ef4d$var$baseRest;

});
parcelRegister("1r2vi", function(module, exports) {

var $973DW = parcelRequire("973DW");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $10ba41483e6f7020$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $10ba41483e6f7020$var$overRest(func, start, transform) {
    start = $10ba41483e6f7020$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $10ba41483e6f7020$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $973DW(func, this, otherArgs);
    };
}
module.exports = $10ba41483e6f7020$var$overRest;

});
parcelRegister("973DW", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $6a2797f9c9767f49$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $6a2797f9c9767f49$var$apply;

});


parcelRegister("wHOzh", function(module, exports) {

var $2khQx = parcelRequire("2khQx");

var $2cdC0 = parcelRequire("2cdC0");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $0624f9f15c182bb5$var$setToString = $2cdC0($2khQx);
module.exports = $0624f9f15c182bb5$var$setToString;

});
parcelRegister("2khQx", function(module, exports) {

var $RPjKD = parcelRequire("RPjKD");

var $9b62A = parcelRequire("9b62A");

var $4J5Np = parcelRequire("4J5Np");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1b1b4af27e66f516$var$baseSetToString = !$9b62A ? $4J5Np : function(func, string) {
    return $9b62A(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $RPjKD(string),
        'writable': true
    });
};
module.exports = $1b1b4af27e66f516$var$baseSetToString;

});
parcelRegister("RPjKD", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $0a1cc1f3b1eede5a$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $0a1cc1f3b1eede5a$var$constant;

});


parcelRegister("2cdC0", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $199742cea8955727$var$HOT_COUNT = 800, $199742cea8955727$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $199742cea8955727$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $199742cea8955727$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $199742cea8955727$var$nativeNow(), remaining = $199742cea8955727$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $199742cea8955727$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $199742cea8955727$var$shortOut;

});



parcelRegister("k6eJ6", function(module, exports) {

var $ddQci = parcelRequire("ddQci");

var $4Gxuc = parcelRequire("4Gxuc");

var $ggGy1 = parcelRequire("ggGy1");

var $3nMgq = parcelRequire("3nMgq");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $ea1fca87b5f9270f$var$isIterateeCall(value, index, object) {
    if (!$3nMgq(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $4Gxuc(object) && $ggGy1(index, object.length) : type == 'string' && index in object) return $ddQci(object[index], value);
    return false;
}
module.exports = $ea1fca87b5f9270f$var$isIterateeCall;

});



parcelRegister("95ko3", function(module, exports) {

var $1z3To = parcelRequire("1z3To");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $69d4651c90f32777$var$uniq(array) {
    return array && array.length ? $1z3To(array) : [];
}
module.exports = $69d4651c90f32777$var$uniq;

});
parcelRegister("1z3To", function(module, exports) {

var $355VB = parcelRequire("355VB");

var $95eCQ = parcelRequire("95eCQ");

var $3uEVE = parcelRequire("3uEVE");

var $0gkRj = parcelRequire("0gkRj");

var $6dvkD = parcelRequire("6dvkD");

var $czrSd = parcelRequire("czrSd");
/** Used as the size to enable large array optimizations. */ var $123c14437a8a2020$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $123c14437a8a2020$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $95eCQ, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3uEVE;
    } else if (length >= $123c14437a8a2020$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $6dvkD(array);
        if (set) return $czrSd(set);
        isCommon = false;
        includes = $0gkRj;
        seen = new $355VB;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $123c14437a8a2020$var$baseUniq;

});
parcelRegister("95eCQ", function(module, exports) {

var $2LSrq = parcelRequire("2LSrq");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $69cfed07b4448198$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $2LSrq(array, value, 0) > -1;
}
module.exports = $69cfed07b4448198$var$arrayIncludes;

});
parcelRegister("2LSrq", function(module, exports) {

var $65YAC = parcelRequire("65YAC");

var $hh8Rz = parcelRequire("hh8Rz");

var $e3KtK = parcelRequire("e3KtK");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $204a337ce7f7d21d$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $e3KtK(array, value, fromIndex) : $65YAC(array, $hh8Rz, fromIndex);
}
module.exports = $204a337ce7f7d21d$var$baseIndexOf;

});
parcelRegister("65YAC", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4702358f640a7405$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $4702358f640a7405$var$baseFindIndex;

});

parcelRegister("hh8Rz", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c93ae6352bbda887$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $c93ae6352bbda887$var$baseIsNaN;

});

parcelRegister("e3KtK", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a3c5663b854a3c4f$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $a3c5663b854a3c4f$var$strictIndexOf;

});



parcelRegister("3uEVE", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $28b3ec0a235ab62f$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $28b3ec0a235ab62f$var$arrayIncludesWith;

});

parcelRegister("6dvkD", function(module, exports) {

var $4YQIZ = parcelRequire("4YQIZ");

var $jLuKu = parcelRequire("jLuKu");

var $czrSd = parcelRequire("czrSd");
/** Used as references for various `Number` constants. */ var $486c42d28839d865$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $486c42d28839d865$var$createSet = !($4YQIZ && 1 / $czrSd(new $4YQIZ([
    ,
    -0
]))[1] == $486c42d28839d865$var$INFINITY) ? $jLuKu : function(values) {
    return new $4YQIZ(values);
};
module.exports = $486c42d28839d865$var$createSet;

});
parcelRegister("jLuKu", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e63a422c1c17897e$var$noop() {
// No operation performed.
}
module.exports = $e63a422c1c17897e$var$noop;

});







parcelRegister("gk18s", function(module, exports) {
$parcel$export(module.exports, "isAdvancedHelpCenter", () => $55313652acbd7e7b$export$a8032b4abe96a350);
$parcel$export(module.exports, "isUnifiedHelpHelpCenter", () => $55313652acbd7e7b$export$35fba107189c9761);
$parcel$export(module.exports, "isFlexiHCEnabledInDefaultHC", () => $55313652acbd7e7b$export$64db2d25a762d602);
$parcel$export(module.exports, "isDefaultHelpCenter", () => $55313652acbd7e7b$export$6770869865ec8ff4);
$parcel$export(module.exports, "isKoshEnabledForDefaultHelpCenter", () => $55313652acbd7e7b$export$f8bf208a2ec06357);
$parcel$export(module.exports, "isHelpCentersManagement", () => $55313652acbd7e7b$export$f20af57447c92bed);
$parcel$export(module.exports, "isCSMHelpCenter", () => $55313652acbd7e7b$export$3eacdddcf63bcdf9);
$parcel$export(module.exports, "getIsHelpHub", () => $55313652acbd7e7b$export$b4319ea987d17576);
$parcel$export(module.exports, "isJcsOnlyRestrictedRoute", () => $55313652acbd7e7b$export$ab40e3484f545b4f);
$parcel$export(module.exports, "getSlugForAdvancedHCFromArticleView", () => $55313652acbd7e7b$export$6287fcdbdaf12366);
$parcel$export(module.exports, "getSlugForHelpCenter", () => $55313652acbd7e7b$export$1487e10d6956fe03);

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $7FSs7 = parcelRequire("7FSs7");

var $1EFS8 = parcelRequire("1EFS8");

var $hrPHR = parcelRequire("hrPHR");
const $55313652acbd7e7b$export$a8032b4abe96a350 = ()=>{
    return (0, $7FSs7.getRelativeBasePath)().startsWith('/helpcenter') && !$55313652acbd7e7b$export$35fba107189c9761();
};
const $55313652acbd7e7b$export$64db2d25a762d602 = ()=>{
    return $55313652acbd7e7b$export$6770869865ec8ff4();
};
const $55313652acbd7e7b$export$6770869865ec8ff4 = ()=>{
    return (0, $7FSs7.getRelativeBasePath)().startsWith('/servicedesk/customer');
};
const $55313652acbd7e7b$export$f8bf208a2ec06357 = ()=>{
    if ((0, $HGACo.isDefaultHCCallsJiraEnabled)() && $55313652acbd7e7b$export$6770869865ec8ff4()) return false;
    return true;
};
const $55313652acbd7e7b$export$35fba107189c9761 = ()=>{
    return (0, $7FSs7.getRelativeBasePath)() === (0, $8rTkC.UNIFIED_HELP_CENTER_BASE_PATH);
};
const $55313652acbd7e7b$export$f20af57447c92bed = ()=>{
    return (0, $7FSs7.getRelativeBasePath)() === (0, $8rTkC.HELP_CENTERS_MANAGEMENT_BASE_PATH);
};
const $55313652acbd7e7b$export$3eacdddcf63bcdf9 = (helpCenterType)=>{
    return (0, $HGACo.isJsmCsMasterFlagEnabled)() && helpCenterType === 'CUSTOMER_SERVICE';
};
const $55313652acbd7e7b$export$b4319ea987d17576 = ()=>{
    return (0, $hrPHR.getEnv)().helpCenterType === 'HELP_HUB';
};
const $55313652acbd7e7b$export$ab40e3484f545b4f = (customerAccountAvailability)=>{
    return $55313652acbd7e7b$export$6770869865ec8ff4() && customerAccountAvailability === 'JCS_ONLY' && (0, $HGACo.isCsmAccessControlSplitEnabled)();
};
const $55313652acbd7e7b$export$6287fcdbdaf12366 = (url)=>{
    const pattern = $55313652acbd7e7b$export$3eacdddcf63bcdf9((0, $hrPHR.getEnv)().helpCenterType) && (0, $1EFS8.default).checkGate('csm_navigation_handling_for_confluence_embed_view') ? /https:\/\/.*?\/helpcenter\/([^/]+)\// : /https:\/\/.*?\/helpcenter\/([^/]+)\/portal\//;
    const match = url.match(pattern);
    return match && match[1] ? match[1] : undefined;
};
const $55313652acbd7e7b$export$1487e10d6956fe03 = ()=>{
    const pattern = /\/helpcenter\/([^/?]*)/;
    const match = (0, $7FSs7.getRelativeBasePath)().match(pattern);
    return match && match[1] ? match[1] : undefined;
};

});
parcelRegister("8rTkC", function(module, exports) {
$parcel$export(module.exports, "USER_TYPING_DEBOUNCE_TIME", () => $1302e3e205bca0f9$export$c5b77883736a2a29);
$parcel$export(module.exports, "SELECTED_SECTION_BORDER_WIDTH", () => $1302e3e205bca0f9$export$57e6e5c7bcaced24);
$parcel$export(module.exports, "HTTP", () => $1302e3e205bca0f9$export$ee9d07cf1658f1a7);
$parcel$export(module.exports, "SPINNER_DELAY", () => $1302e3e205bca0f9$export$fb1d6648e4d00b79);
$parcel$export(module.exports, "ScreenName", () => $1302e3e205bca0f9$export$acfa120f168ab3f8);
$parcel$export(module.exports, "RouteName", () => $1302e3e205bca0f9$export$bfbea4d618559e4a);
$parcel$export(module.exports, "RoutePath", () => $1302e3e205bca0f9$export$1b64c75ea7ed0865);
$parcel$export(module.exports, "ExperienceName", () => $1302e3e205bca0f9$export$b881bd9f00ed8ed1);
$parcel$export(module.exports, "BrowserMetricViewName", () => $1302e3e205bca0f9$export$d28ca3cbca982562);
$parcel$export(module.exports, "EngagementMessages", () => $1302e3e205bca0f9$export$a0841dbe900de5cb);
$parcel$export(module.exports, "EngagementMessagesTarget", () => $1302e3e205bca0f9$export$e396ee6d05cbdca4);
$parcel$export(module.exports, "PORTAL_PARENT_PRODUCT", () => $1302e3e205bca0f9$export$218d9cffbbd32919);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SHIM_URL", () => $1302e3e205bca0f9$export$4ef7b134a809306c);
$parcel$export(module.exports, "UNIFIED_HELP_CENTER_BASE_PATH", () => $1302e3e205bca0f9$export$edfbc36787ce1acb);
$parcel$export(module.exports, "HELP_CENTERS_MANAGEMENT_BASE_PATH", () => $1302e3e205bca0f9$export$f9a9f80d0023ea53);
$parcel$export(module.exports, "VA_ON_HC_CONVERSATION_PATH", () => $1302e3e205bca0f9$export$640d6db9adfb1ee9);
$parcel$export(module.exports, "VA_ON_PORTAL_CONVERSATION_PATH", () => $1302e3e205bca0f9$export$ea450ea04b439b84);
$parcel$export(module.exports, "DEFAULT_HELP_CENTER_TYPE", () => $1302e3e205bca0f9$export$e2ce1da1cf52c1f4);
$parcel$export(module.exports, "DEFAULT_CUSTOMER_ACCOUNT_AVAILABILITY", () => $1302e3e205bca0f9$export$c7ac69203430ee56);
// This file contains re-used UI view related constants
/* The amount of time to wait before doing some work that is triggered by user typing */ const $1302e3e205bca0f9$export$c5b77883736a2a29 = 500;
const $1302e3e205bca0f9$export$57e6e5c7bcaced24 = 1.5;
const $1302e3e205bca0f9$export$ee9d07cf1658f1a7 = {
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    OFFLINE: 0,
    SERVER: 500,
    UNAUTHORIZED: 401
};
const $1302e3e205bca0f9$export$fb1d6648e4d00b79 = 300;
var $1302e3e205bca0f9$export$acfa120f168ab3f8 = /*#__PURE__*/ function(ScreenName) {
    ScreenName["HELP_CENTER"] = "portalHelpCenter";
    ScreenName["HELP_CENTER_CUSTOMIZE_SIDEBAR"] = "portalCustomizeHelpCenter";
    ScreenName["HELP_CENTER_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeHelpCenterAnnouncement";
    ScreenName["HELP_CENTER_VSA_CHAT_SIDEBAR"] = "portalCustomizeHelpCenterVsaChatSidebar";
    ScreenName["HELP_CENTER_CUSTOMIZE_LOOK_AND_FEEL_SIDEBAR"] = "portalCustomizeLookAndFeelSidebar";
    ScreenName["HELP_CENTER_CUSTOMIZE_LOGIN_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeLoginAnnouncementSidebar";
    ScreenName["HELP_CENTERS_MANAGEMENT"] = "helpCentersManagement";
    ScreenName["HELP_HUBS_MANAGEMENT"] = "helpHubsManagement";
    ScreenName["EDIT_HELP_CENTER"] = "helpCenterEditDetails";
    ScreenName["MANAGE_PROJECTS"] = "helpCenterManageProjects";
    ScreenName["MANAGE_PAGES"] = "helpCenterManagePages";
    ScreenName["FEEDBACK"] = "portalRequestFeedback";
    ScreenName["FEEDBACK_SUBMITTED"] = "portalRequestFeedbackCommentSubmitted";
    ScreenName["LOGIN"] = "portalLogin";
    ScreenName["LOGIN_PASSWORD"] = "portalLoginPassword";
    ScreenName["LOGIN_FORGOT_PASSWORD_CONFIRMATION"] = "portalLoginForgotPasswordConfirmation";
    ScreenName["LOGIN_SINGLE_SIGN_ON"] = "portalLoginSingleSignOn";
    ScreenName["LOGIN_SINGLE_SIGN_ON_CUSTOMER"] = "portalLoginSingleSignOnCustomer";
    ScreenName["LOGIN_ACTION"] = "portalLoginAction";
    ScreenName["LOGIN_ANNOUNCEMENT_CARD"] = "portalLoginAnnouncementCard";
    ScreenName["LOGIN_SSO_TEST_MODE_ERROR"] = "portalLoginSsoTestModeError";
    ScreenName["RESET_PASSWORD"] = "portalResetPassword";
    ScreenName["UNSUBSCRIBE"] = "portalUnsubscribeConfirmation";
    ScreenName["REQUEST_CREATE"] = "portalRequestCreate";
    ScreenName["REQUEST_DETAILS"] = "portalRequestDetails";
    ScreenName["REQUEST_LIST"] = "portalRequests";
    ScreenName["APPROVAL_LIST"] = "portalApprovals";
    ScreenName["KNOWLEDGE_CATEGORY"] = "categoryPage";
    ScreenName["REQUEST_CREATE_ANONYMOUS_SUCCESS"] = "requestCreateAnonymousSuccess";
    ScreenName["PORTAL_HOME"] = "singlePortal";
    ScreenName["REQUEST_GROUP_LIST"] = "requestGroupList";
    ScreenName["REQUEST_GROUP"] = "requestGroup";
    ScreenName["SIGNUP"] = "portalSignup";
    ScreenName["INVITED_SIGNUP"] = "portalAcceptInvite";
    ScreenName["COMPLETE_SIGNUP"] = "portalCompleteSignup";
    ScreenName["VERIFY_EMAIL"] = "portalVerifyEmail";
    ScreenName["COMPLETE_SIGNUP_TOKEN_EXPIRED"] = "portalCompleteSignupTokenExpired";
    ScreenName["COMPLETE_SIGNUP_TOKEN_INVALID"] = "portalCompleteSignupTokenInvalid";
    ScreenName["CHECK_EMAIL"] = "portalValidateEmail";
    ScreenName["KNOWLEDGE_ARTICLE"] = "knowledgeArticle";
    ScreenName["KNOWLEDGE_ALL_SEARCH_RESULTS"] = "knowledgeAllSearchResults";
    ScreenName["USER_PROFILE"] = "portalProfile";
    ScreenName["ADD_ANNOUNCEMENT_SIDEBAR"] = "addAnnouncementSidebar";
    ScreenName["REQUEST_LIST_CUSTOMIZE_SIDEBAR"] = "requestListCustomizeSidebar";
    ScreenName["REQUEST_APPROVAL"] = "requestApproval";
    ScreenName["PORTAL_REORDER_SETTINGS"] = "portalReorderSettings";
    ScreenName["ERROR_NOT_FOUND"] = "errorNotFound";
    ScreenName["PORTAL_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeAnnouncementSidebar";
    ScreenName["VIEW_TOPIC"] = "viewTopic";
    ScreenName["VIEW_CUSTOM_PAGE"] = "viewCustomPage";
    ScreenName["EDIT_CUSTOM_PAGE"] = "editCustomPage";
    ScreenName["EDIT_TOPICS_LAYOUT"] = "editTopicsLayout";
    ScreenName["EDIT_TOPIC"] = "editTopic";
    ScreenName["PORTAL_ACCESS_FORBIDDEN"] = "PortalAccessForbidden";
    ScreenName["EMBED_REQUEST_CREATE"] = "embedRequestCreate";
    ScreenName["EMBED_LOGIN_SUCCESS"] = "embedLoginSuccess";
    ScreenName["EMBED_SINGLE_PORTAL"] = "embedSinglePortal";
    ScreenName["EMBED_KB_ARTICLE"] = "embedKBArticle";
    ScreenName["VIEW_HOMEPAGE"] = "portalHelpCenter";
    ScreenName["EDIT_HOMEPAGE"] = "editHomepage";
    ScreenName["HELP_DESK_REPORTING"] = "helpDeskReporting";
    ScreenName["UNIFIED_HELP_HOME_PAGE"] = "unifiedHelpHomePage";
    ScreenName["UNIFIED_HELP_TEST_HARNESS"] = "unifiedHelpTestHarness";
    ScreenName["ADD_HELP_CONTENT_KNOWLEDGE_RESOURCES"] = "addHelpContentKnowledgeResources";
    ScreenName["ADD_HELP_CONTENT_EXTERNAL_LINKS"] = "addHelpContentExternalLinks";
    ScreenName["HELP_CENTER_SEARCH"] = "PortalSearch";
    ScreenName["CONVERSATION_PAGE"] = "conversationPage";
    ScreenName["CONSENT_FORM_PAGE"] = "consentFormPage";
    ScreenName["AI_ANSWER"] = "aiAnswer";
    ScreenName["CSM_CONTACT_US"] = "csmContactUs";
    ScreenName["CSM_FOLDER"] = "csmFolder";
    ScreenName["CSM_REQUESTS_LIST"] = "csmRequestsList";
    ScreenName["CSM_REQUEST_DETAILS"] = "csmRequestDetails";
    ScreenName["CSM_VIEW_HOMEPAGE"] = "csmViewHomepage";
    ScreenName["KNOWLEDGE_CARDS"] = "knowledgeCards";
    ScreenName["EMBED_FEATURED_PORTALS"] = "embedFeaturedPortals";
    ScreenName["VIRTUAL_SERVICE_AGENT_HEADER"] = "virtualServiceAgentHeader";
    ScreenName["TOPIC_ITEM_HOMEPAGE"] = "topicItemHomepage";
    ScreenName["TOPIC_ITEM"] = "topicItem";
    ScreenName["OMNICHANNEL_CONVERSATION_SOURCES"] = "omnichannelConversationSources";
    ScreenName["SURVEY"] = "survey";
    return ScreenName;
}({});
var $1302e3e205bca0f9$export$bfbea4d618559e4a = /*#__PURE__*/ function(RouteName) {
    RouteName["VIEW_CUSTOM_PAGE"] = "view-custom-page";
    RouteName["EDIT_CUSTOM_PAGE"] = "edit-custom-page";
    RouteName["CSM_CONTACT_US_PAGE"] = "contact-us";
    RouteName["CSM_FOLDER_PAGE"] = "csm-folder";
    RouteName["CSM_REQUESTS_LIST_PAGE"] = "csm-requests-list";
    RouteName["CSM_REQUEST_DETAILS_PAGE"] = "csm-request-details";
    return RouteName;
}({});
var $1302e3e205bca0f9$export$1b64c75ea7ed0865 = /*#__PURE__*/ function(RoutePath) {
    RoutePath["VIEW_CUSTOM_PAGE"] = "/page/:id/:title?";
    RoutePath["EDIT_CUSTOM_PAGE"] = "/page/edit/:id/:title?";
    RoutePath["CSM_CONTACT_US_PATH"] = "/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?";
    RoutePath["CSM_FOLDER_PATH"] = "/folder/:folderId";
    RoutePath["CSM_REQUESTS_LIST_PATH"] = "/user/requests";
    RoutePath["CSM_REQUEST_DETAILS_PATH"] = "/user/requests/:requestKey";
    return RoutePath;
}({});
var $1302e3e205bca0f9$export$b881bd9f00ed8ed1 = /*#__PURE__*/ function(ExperienceName) {
    ExperienceName["REQUEST_CREATE"] = "request-create";
    ExperienceName["REQUEST_CREATE_CSM"] = "request-create-csm";
    ExperienceName["HELP_CENTER"] = "view-help-center";
    ExperienceName["CUSTOM_PAGE"] = "view-custom-page";
    ExperienceName["EDIT_CUSTOM_PAGE"] = "edit-custom-page";
    ExperienceName["HELP_CENTER_CSM"] = "view-help-center-csm";
    ExperienceName["FEATURED_AND_SORTED_PORTALS"] = "featured-and-sorted-portals";
    return ExperienceName;
}({});
var $1302e3e205bca0f9$export$d28ca3cbca982562 = /*#__PURE__*/ function(BrowserMetricViewName) {
    BrowserMetricViewName["REQUEST_DETAIL_VIEW"] = "request-detail";
    BrowserMetricViewName["COMMENT_EDITOR_VIEW"] = "comment-editor";
    return BrowserMetricViewName;
}({});
var $1302e3e205bca0f9$export$a0841dbe900de5cb = /*#__PURE__*/ function(EngagementMessages) {
    EngagementMessages["SIDEBAR_REFACTOR"] = "jsm-portal-sidebar-refactor";
    EngagementMessages["PORTAL_REORDER_EXPERIENCE"] = "jsm-portal-reordering-change-boarding";
    EngagementMessages["TOPICS"] = "jsm-customer-portal-topics";
    EngagementMessages["EXTERNAL_RESOURCES_IN_TOPICS"] = "external-resources-in-topics-pill";
    EngagementMessages["TOPICS_FOR_ALL"] = "topics-for-all-customisation";
    EngagementMessages["CHANGE_BOARD_CUSTOMISE_BUTTON"] = "jsm_admins_customization_with_button";
    EngagementMessages["CHANGE_BOARD_HELP_CENTER_SETTINGS_BUTTON"] = "jsm_admins_help_center_settings_button";
    EngagementMessages["CHANGE_BOARD_ADMINS_FREE_AND_STANDARD_EDITION"] = "changeboarding_jsm_admins_home_free_std";
    EngagementMessages["CHANGE_BOARD_ADMINS_SINGLE_PORTAL_SCREEN"] = "changeboarding_jsm_admins_singleportal";
    EngagementMessages["CHANGE_BOARD_ADMINS_PREMIUM_ENTERPRISE"] = "changeboarding_jsm_admins_premium_entr";
    EngagementMessages["ONBOARD_VA_REPORTING"] = "va-reporting-changeboarding-message";
    EngagementMessages["ONBOARD_VA_ON_HC"] = "va-on-hc-onboarding-message";
    EngagementMessages["CHANGE_BOARD_VISUAL_REFRESH"] = "jsm-visual-refresh-changeboarding";
    EngagementMessages["INCREASED_FLEXIBILITY_CHANGEBOARDING"] = "jsm-increased-flexibility-changeboarding";
    return EngagementMessages;
}({});
var $1302e3e205bca0f9$export$e396ee6d05cbdca4 = /*#__PURE__*/ function(EngagementMessagesTarget) {
    EngagementMessagesTarget["CHANGE_BOARDING_SPOTLIGHT"] = "changeBoardingSpotLight";
    EngagementMessagesTarget["CHANGE_BOARDING_CUSTOMISE_BUTTON_SPOTLIGHT"] = "changeBoardingCustomiseButtonSpotLight";
    EngagementMessagesTarget["CHANGE_BOARD_HELP_CENTER_SETTINGS_BUTTON"] = "changeBoardHelpCenterSettingsButton";
    EngagementMessagesTarget["MUTLI_HC_CHANGE_BOARDING_SPOTLIGHT"] = "multihcDropdownChangeBoardingSpotlight";
    EngagementMessagesTarget["REPORTING_ONBOARDING_SPOTLIGHT"] = "reportingOnboardingSpotlight";
    EngagementMessagesTarget["VISUAL_REFRESH_CHANGEBOARDING_SPOTLIGHT"] = "visualRefreshChangeboardingSpotlight";
    return EngagementMessagesTarget;
}({});
const $1302e3e205bca0f9$export$218d9cffbbd32919 = 'JSM-Portal';
const $1302e3e205bca0f9$export$4ef7b134a809306c = '/plugins/servlet/servicedesk/customer/confluence/shim/';
const $1302e3e205bca0f9$export$edfbc36787ce1acb = '/helpcenter/unified';
const $1302e3e205bca0f9$export$f9a9f80d0023ea53 = '/helpcenter-management';
const $1302e3e205bca0f9$export$640d6db9adfb1ee9 = '/conversation';
const $1302e3e205bca0f9$export$ea450ea04b439b84 = '/portal/:portalId/conversation';
const $1302e3e205bca0f9$export$e2ce1da1cf52c1f4 = 'BASIC';
const $1302e3e205bca0f9$export$c7ac69203430ee56 = 'JSM_AND_JCS';

});

parcelRegister("HGACo", function(module, exports) {
$parcel$export(module.exports, "RICH_TEXT_AREA_FIELD", () => $28d16348e1fba347$export$706f525b497c4077);
$parcel$export(module.exports, "ENHANCED_RENDER_EXPERIENCE_FOR_KNOWLEDGE_ARTICLES", () => $28d16348e1fba347$export$75614d0a3eb5eb71);
$parcel$export(module.exports, "REDIRECT_TO_LOGIN_PAGE_ON_INVALID_TOKEN_FOR_HOME_PAGE", () => $28d16348e1fba347$export$a7cb1f93b93ef093);
$parcel$export(module.exports, "UNIFIED_HELP_REPORTING_PAGE", () => $28d16348e1fba347$export$4111277bf9799237);
$parcel$export(module.exports, "UNIFIED_HELP_ADD_FILTER_FOR_CUSTOMER_ACCOUNTS", () => $28d16348e1fba347$export$a1c6198e9bfea49a);
$parcel$export(module.exports, "BASIC_HC_CALLS_JIRA", () => $28d16348e1fba347$export$bed2f83bab9fefc1);
$parcel$export(module.exports, "ENABLE_HC_LAYOUT_GRANULAR_INTERACTION", () => $28d16348e1fba347$export$5a0ff3ed688d6fd9);
$parcel$export(module.exports, "JSM_VIRTUAL_AGENT_ANONYMOUS_ACCESS", () => $28d16348e1fba347$export$56132373c73141db);
$parcel$export(module.exports, "ENABLE_REACT_18_CREATEROOT", () => $28d16348e1fba347$export$c59907e47c96b562);
$parcel$export(module.exports, "DONT_USE_HYDRATE_SSR", () => $28d16348e1fba347$export$f1de11b7a101becf);
$parcel$export(module.exports, "HELP_CENTER_REFRESH_FLAG", () => $28d16348e1fba347$export$cb73a351cc03929f);
$parcel$export(module.exports, "EMAIL_VERIFIED_SIGNAL_ON_CUSTOMERS_PAGE", () => $28d16348e1fba347$export$660d24662c32371a);
$parcel$export(module.exports, "ENABLE_INCREASED_FLEXIBILITY", () => $28d16348e1fba347$export$13d57865c16811e5);
$parcel$export(module.exports, "ENABLE_FOLLOWUP_QUESTIONS_ON_PORTAL", () => $28d16348e1fba347$export$40e944519b773806);
$parcel$export(module.exports, "PROFORMA_ADVANCED_CONDITIONS_MAPPING", () => $28d16348e1fba347$export$a9a13faf0986d8b5);
$parcel$export(module.exports, "PROFORMA_LOCAL_CONSUMPTION_PORTAL_CREATE", () => $28d16348e1fba347$export$11856bc97b04d562);
$parcel$export(module.exports, "HELP_SEEKER_CAN_CREATE_NEW_LABELS_BUGFIX", () => $28d16348e1fba347$export$9b05a4405c037799);
$parcel$export(module.exports, "isGranularLayoutInteractionTestEnabled", () => $28d16348e1fba347$export$b72719f56aaa7616);
$parcel$export(module.exports, "isEmailVerifiedSignalEnabled", () => $28d16348e1fba347$export$d418c5a93f5a612e);
$parcel$export(module.exports, "isWrmOptimizationsEnabled", () => $28d16348e1fba347$export$9d40c615991b681d);
$parcel$export(module.exports, "isRichTextAreaEnabled", () => $28d16348e1fba347$export$ed104cfad45df81c);
$parcel$export(module.exports, "isEnhanceRenderExperienceForKnowledgeArticlesEnabled", () => $28d16348e1fba347$export$787ffd123ce73274);
$parcel$export(module.exports, "isRedirectToLoginPageOnInvalidTokenForHomePage", () => $28d16348e1fba347$export$98cff3536fe06a4);
$parcel$export(module.exports, "islooselyLazyJsErrorsToSentryEnabled", () => $28d16348e1fba347$export$bf2b9f47d2bc9d17);
$parcel$export(module.exports, "isCustomThemingEnabled", () => $28d16348e1fba347$export$dbb8ae3ec0512e12);
$parcel$export(module.exports, "isUnifiedHelpReportingPageEnabled", () => $28d16348e1fba347$export$6c48cb93a07ea1fe);
$parcel$export(module.exports, "isProjectMappingInHelpCenterEnabled", () => $28d16348e1fba347$export$6abd2200cda9c9c3);
$parcel$export(module.exports, "isUnifiedHelpAddFilterForCustomerAccounts", () => $28d16348e1fba347$export$4fd1074ca1df827a);
$parcel$export(module.exports, "isFixRelayIdConflictInHelpCenter", () => $28d16348e1fba347$export$65c1b2a8a68046aa);
$parcel$export(module.exports, "isJsmCsMasterFlagEnabled", () => $28d16348e1fba347$export$fd486b6069ca6b2);
$parcel$export(module.exports, "isCsmAccessControlSplitEnabled", () => $28d16348e1fba347$export$27c460ed295f06bd);
$parcel$export(module.exports, "isAiWidgetTeam25Enabled", () => $28d16348e1fba347$export$4b18120aa62097f1);
$parcel$export(module.exports, "isCsmPremiumSlaDisabledFlagEnabled", () => $28d16348e1fba347$export$5f0f83b8f3fb9683);
$parcel$export(module.exports, "isUpdateArticlesLinkCsmEnabled", () => $28d16348e1fba347$export$19229ae1da4441b0);
$parcel$export(module.exports, "isJcsprojectTypeM3Enabled", () => $28d16348e1fba347$export$84646dccbb096e42);
$parcel$export(module.exports, "isCsmContactUsSectionEnabled", () => $28d16348e1fba347$export$2ccd8035d1dcad87);
$parcel$export(module.exports, "isDefaultHCCallsJiraEnabled", () => $28d16348e1fba347$export$5dea29067755e1b0);
$parcel$export(module.exports, "isCrossSiteConnieConnectionEnabled", () => $28d16348e1fba347$export$8cfd0c7691c6e406);
$parcel$export(module.exports, "isKbArticlesSameTabRedirectionEnabled", () => $28d16348e1fba347$export$6bf26299f5ce3574);
$parcel$export(module.exports, "isAdvancedCustomizationEditPageEnabled", () => $28d16348e1fba347$export$3cf244665c3df4c1);
$parcel$export(module.exports, "isUseReact18CreateRootEnabled", () => $28d16348e1fba347$export$34d3b9372e9be463);
$parcel$export(module.exports, "isReactHydrateDisabledInSSR", () => $28d16348e1fba347$export$73e675d1db50bd4a);
$parcel$export(module.exports, "isHelpCenterNewDropdownEnabled", () => $28d16348e1fba347$export$88973464e4142e9f);
$parcel$export(module.exports, "isVirtualAgentHeaderButtonEnabled", () => $28d16348e1fba347$export$ae66df261c55d7b5);
$parcel$export(module.exports, "isCustomiseDropDownChangeBoardingEnabled", () => $28d16348e1fba347$export$48982649dd732b1e);
$parcel$export(module.exports, "isFilterNullTraceIdFromGraphqlCallsEnabled", () => $28d16348e1fba347$export$32ff46784ecd3055);
$parcel$export(module.exports, "isPremiumSLAErrorFilterEnabled", () => $28d16348e1fba347$export$c7b4663aa3b178c3);
$parcel$export(module.exports, "isRetryMechanismTuningEnabled", () => $28d16348e1fba347$export$484a220addce746c);
$parcel$export(module.exports, "isUseNewEditorCardProviderEnabled", () => $28d16348e1fba347$export$f4ef25b2974427ab);
$parcel$export(module.exports, "isProformaTTVCUpdateMeasureEnabled", () => $28d16348e1fba347$export$f1047a0c2946b9);
$parcel$export(module.exports, "isVAFollowupQueryOnlyForPositiveResponseEnabled", () => $28d16348e1fba347$export$4f2c4b6112c249bd);
$parcel$export(module.exports, "isSlashOptionalInHelpCenterHomeRoute", () => $28d16348e1fba347$export$353d729916e0a841);
$parcel$export(module.exports, "isRemoveNonCriticalResourceFromViewHomePageRouteEnabled", () => $28d16348e1fba347$export$3cadddd5cbcfe776);
$parcel$export(module.exports, "isRemoveRedundantModelsCreateRequest", () => $28d16348e1fba347$export$3e14f092c6d5897c);
$parcel$export(module.exports, "isOmniChannelEnabled", () => $28d16348e1fba347$export$2df383cb702d9c39);
$parcel$export(module.exports, "enableRelaySubscriptions", () => $28d16348e1fba347$export$eee0b0109d7d7c2b);
$parcel$export(module.exports, "isVAOnHelpCenterGAEnabled", () => $28d16348e1fba347$export$34d4b53afdfa223d);
$parcel$export(module.exports, "isConsumeLooselyLazyManifestInSSREnabled", () => $28d16348e1fba347$export$a9795343511ea5c1);
$parcel$export(module.exports, "isMigrateToAnalyticsBridgeEnabled", () => $28d16348e1fba347$export$6ef513d6f7be5888);
$parcel$export(module.exports, "isDefaultHCUsingGqlBrandingCalls", () => $28d16348e1fba347$export$d10ba47ac271b5fb);
$parcel$export(module.exports, "isProjectMappingChangeBoardingEnabled", () => $28d16348e1fba347$export$d0f3905affab5e5b);
$parcel$export(module.exports, "isUseHelpCenterRefresh", () => $28d16348e1fba347$export$6c961d647d8a8d16);
$parcel$export(module.exports, "isDraftArticleSuggestionsEnabled", () => $28d16348e1fba347$export$edadb203ac2a6c5c);
$parcel$export(module.exports, "isForgeCustomFieldsOnPortalViewEnabled", () => $28d16348e1fba347$export$5998e12cd61e03e4);
$parcel$export(module.exports, "isOverridingFragmentsAnalyticsPropEnabled", () => $28d16348e1fba347$export$f68ee857fdba507f);
$parcel$export(module.exports, "isForgeAppsInJSMPhase1Enabled", () => $28d16348e1fba347$export$5c862b9f85068bd7);
$parcel$export(module.exports, "isUiModificationsSupportEnabled", () => $28d16348e1fba347$export$2b4c3a76f069fbf5);
$parcel$export(module.exports, "isTextFieldSupportEnabled", () => $28d16348e1fba347$export$97cf619b5c503901);
$parcel$export(module.exports, "isNumberFieldSupportEnabled", () => $28d16348e1fba347$export$5377338157c93a4a);
$parcel$export(module.exports, "isDateTimeSupportEnabled", () => $28d16348e1fba347$export$a3127feadc5f63ef);
$parcel$export(module.exports, "isDueDateSupportEnabled", () => $28d16348e1fba347$export$ca4e8050793caa6);
$parcel$export(module.exports, "isTextAreaSupportEnabled", () => $28d16348e1fba347$export$682d85ee096f07a9);
$parcel$export(module.exports, "isCascadingSelectSupportEnabled", () => $28d16348e1fba347$export$b738c6acf33d051a);
$parcel$export(module.exports, "isLabelsSupportEnabled", () => $28d16348e1fba347$export$fe4ccb1b2f4366aa);
$parcel$export(module.exports, "isUserPickerSupportEnabled", () => $28d16348e1fba347$export$d16c700a701ab994);
$parcel$export(module.exports, "cascadingSelectDefaultValueSupportEnabled", () => $28d16348e1fba347$export$5621e5c6b3b162df);
$parcel$export(module.exports, "isUpdateAnalyticsFailureEventWithError", () => $28d16348e1fba347$export$6636c7ae8eb80195);
$parcel$export(module.exports, "isFollowupEnabledForPortal", () => $28d16348e1fba347$export$cd1b5399e7ea70f2);
$parcel$export(module.exports, "isAiAnswer24HourTimeoutEnabled", () => $28d16348e1fba347$export$6d74bd5fbad4512e);
$parcel$export(module.exports, "shouldCommentEditorRerenderOnSubmit", () => $28d16348e1fba347$export$353c59e30456fe10);
$parcel$export(module.exports, "isSummaryFieldDebounced", () => $28d16348e1fba347$export$e3771f1bb7cb73b4);
$parcel$export(module.exports, "isDarkerBorderEnabledForRichTextArea", () => $28d16348e1fba347$export$6d497404d8f015fa);
$parcel$export(module.exports, "isCustomPagesUiEnabled", () => $28d16348e1fba347$export$7dd0505e68d032aa);
$parcel$export(module.exports, "isJiraFieldHandlingEnabled", () => $28d16348e1fba347$export$7769d816882d3d99);
$parcel$export(module.exports, "isIncreasedFlexibilityEnabled", () => $28d16348e1fba347$export$81ac031d5c9eadb5);
$parcel$export(module.exports, "isElementRendererSplitEnabled", () => $28d16348e1fba347$export$6a665c3fef32cc75);
$parcel$export(module.exports, "isGdayFeaturesForKbArticlesEnabled", () => $28d16348e1fba347$export$95fbac9bfbfa10f2);
$parcel$export(module.exports, "isOmnichannelEnabledForHC", () => $28d16348e1fba347$export$c008df611f489124);
$parcel$export(module.exports, "isIsomorphicErrorHandlingEnabled", () => $28d16348e1fba347$export$b50d6f62f99953f3);
$parcel$export(module.exports, "isOmnichannelCombinedAPIEnabledForHC", () => $28d16348e1fba347$export$8eb90609f6b1f9d4);
$parcel$export(module.exports, "isClearRequestFormOnUnmount", () => $28d16348e1fba347$export$e37eef2ad9537fcf);
$parcel$export(module.exports, "isItsmIssueRenamingEnabled", () => $28d16348e1fba347$export$54d7baed1ffc6f83);
$parcel$export(module.exports, "isItsmProjectRenamingEnabled", () => $28d16348e1fba347$export$bd371ef032bb50b4);
$parcel$export(module.exports, "isOmnichannelGreetingAPIEnabled", () => $28d16348e1fba347$export$59c4c8d95bf1eefc);
$parcel$export(module.exports, "isIsomorphicDompurifyLibUsed", () => $28d16348e1fba347$export$c5fadf0a3c794577);
$parcel$export(module.exports, "isFetchJsonUsedInCmdbObjectField", () => $28d16348e1fba347$export$6f37a64a78f7ae99);
$parcel$export(module.exports, "isHomepageErrorHasStatusCodeEnabled", () => $28d16348e1fba347$export$47ad7b9bdb77ff6a);
$parcel$export(module.exports, "isOmnichannelSubscriptionErrorpageEnabled", () => $28d16348e1fba347$export$492c9921026864bb);
$parcel$export(module.exports, "isReact18LazyEnabled", () => $28d16348e1fba347$export$fbc5dd39f5b596ee);
$parcel$export(module.exports, "isVisualRefreshChangeboardingEnabled", () => $28d16348e1fba347$export$fd9bbc956c4b639d);
$parcel$export(module.exports, "isIncreasedFlexibilityChangeboardingEnabled", () => $28d16348e1fba347$export$d55f20edfbf68f28);
$parcel$export(module.exports, "isThemeStatePassed", () => $28d16348e1fba347$export$6587e77243044aac);
$parcel$export(module.exports, "isRequestCreateSkipDropdownInitialOptionsCallEnabled", () => $28d16348e1fba347$export$4c0bb2a2e82edb28);
$parcel$export(module.exports, "isFilterQueryErrorFromSentryEnabled", () => $28d16348e1fba347$export$41f8345167e5e3f1);
$parcel$export(module.exports, "isHideKbColumnEnabled", () => $28d16348e1fba347$export$787e10895d9b5b56);
$parcel$export(module.exports, "isVsaSettingsPerformanceImprovementsEnabled", () => $28d16348e1fba347$export$2803857b1fa00ccb);
$parcel$export(module.exports, "isTotalArticleCountEnabled", () => $28d16348e1fba347$export$dbf6a8ec8de99792);
$parcel$export(module.exports, "isHideVsaEndpointsEnabled", () => $28d16348e1fba347$export$5ee14c6848af11b8);
$parcel$export(module.exports, "isVsaAdoptionHeaderChatButtonEnabled", () => $28d16348e1fba347$export$3c09ad5d9c354810);
$parcel$export(module.exports, "isColorDesignTokenEnabled", () => $28d16348e1fba347$export$c7b1d6ed7aedb077);
$parcel$export(module.exports, "isAdsTokenSupportInSSREnabled", () => $28d16348e1fba347$export$d4ec8c5c1eac2bd1);
$parcel$export(module.exports, "isVsaAdoptionPortalChatSideBarEnabled", () => $28d16348e1fba347$export$4e32738a2a810c82);
$parcel$export(module.exports, "isJcsTwgEntitlementsIdToAriEnabled", () => $28d16348e1fba347$export$5950094230c8f65b);
$parcel$export(module.exports, "isHubsEnabledInHelpCenter", () => $28d16348e1fba347$export$b03e57f56b691f9d);
$parcel$export(module.exports, "isMultiSelectEnabled", () => $28d16348e1fba347$export$3d9060e51ab7079e);
$parcel$export(module.exports, "isCortopv2ExperimentTGEnabled", () => $28d16348e1fba347$export$334ea9c48e4dea3f);
$parcel$export(module.exports, "isCortopv2ExperimentEnabledWithExposure", () => $28d16348e1fba347$export$dc2e212d295f2e92);
$parcel$export(module.exports, "isJsmSurveysCoreFeatureEnabled", () => $28d16348e1fba347$export$a953b7b444ffe51e);
$parcel$export(module.exports, "isForgeFixUndefinedExtensionErrorEnalbled", () => $28d16348e1fba347$export$1511e4c6da7511fd);
$parcel$export(module.exports, "isJsmPortalRovoIntegrationEnabled", () => $28d16348e1fba347$export$c2b1b7c65c5a4a75);
$parcel$export(module.exports, "isDatePickerSupportEnabled", () => $28d16348e1fba347$export$1df7079ae40c80e4);
$parcel$export(module.exports, "isGraphqlResponseEmptyCheckEnabled", () => $28d16348e1fba347$export$15b096e14fb08a5d);
$parcel$export(module.exports, "isAurumAssetsPcs3707942Enabled", () => $28d16348e1fba347$export$58c47d24d634e7b);
$parcel$export(module.exports, "isSurveysRouteEnabled", () => $28d16348e1fba347$export$3c40ce1901660201);
$parcel$export(module.exports, "isCsmLoginPageLinkBlankPageFixEnabled", () => $28d16348e1fba347$export$5cd00f51a9bb65a2);
$parcel$export(module.exports, "isJsmPortalKeepRedirectionDestinationEnabled", () => $28d16348e1fba347$export$3c14e337595a4049);
$parcel$export(module.exports, "isProformaAdvancedConditionsMappingEnabled", () => $28d16348e1fba347$export$63bb23d2425a5457);
$parcel$export(module.exports, "isProformaLocalConsumptionPortalCreateEnabled", () => $28d16348e1fba347$export$aaddf89a6dc7a70e);
$parcel$export(module.exports, "isHelpSeekerCanCreateNewLabelsBugfixEnabled", () => $28d16348e1fba347$export$86e7d7e27ae6e308);
$parcel$export(module.exports, "isPortalSignupFormSubtitleUpdateEnabled", () => $28d16348e1fba347$export$772a4190ad30e6ca);
$parcel$export(module.exports, "isAddForbidTagsInHtmlSanitizationEnabled", () => $28d16348e1fba347$export$8493007e9d62d2f7);
$parcel$export(module.exports, "isRovoAgentsToolsConfigM2Enabled", () => $28d16348e1fba347$export$ea979393725a029);
$parcel$export(module.exports, "isStudioGsnAndScenarioRefreshEnabled", () => $28d16348e1fba347$export$a111e2ff03776b7c);
$parcel$export(module.exports, "isRequestListInfiniteScrollEnabled", () => $28d16348e1fba347$export$46753c7d3f251473);
$parcel$export(module.exports, "isEmptyStringFilterOnFirstReqListLoadEnabled", () => $28d16348e1fba347$export$71262ddd43589494);
$parcel$export(module.exports, "isApprovalListInfiniteScrollEnabled", () => $28d16348e1fba347$export$e86f67505602f2f);
/**
 * Define feature flag here as constants.
 *
 * export const KB_ENHANCEMENTS = 'jsd.px.kb-enhancements';
 *
 * Use them in react components.
 * import { KB_ENHANCEMENTS } from '@helpcenter/feature-flags';
 * import { FeatureFlag } from 'view/common/feature-flag';
 *
 * <FeatureFlag name={KB_ENHANCEMENTS}>
 *  I will be shown in true :-)
 * </FeatureFlag>
 *
 * ========== NOTE ===================
 * BE CAREFUL ADDING FEATURE FLAGS, IF YOU RENAME THEM IT WILL CHANGE THE ANALYTIC CONTEXT
 * NAME AND NO LONGER SEND THE SAME CONTEXT ATTRIBUTE NAME.
 * ===================================
 */ 
var $1EFS8 = parcelRequire("1EFS8");
const $28d16348e1fba347$export$706f525b497c4077 = 'jsd-use-adf-default-value-for-textarea';
const $28d16348e1fba347$export$75614d0a3eb5eb71 = 'jsm-enhanced-render-exp-for-knowledge-articles';
const $28d16348e1fba347$var$ENABLE_KB_ARTICLES_OPEN_IN_SAME_TAB = 'make-kb-articles-open-in-same-tab';
const $28d16348e1fba347$export$a7cb1f93b93ef093 = 'redirect_to_login_for_hc_home_page_un_authorized';
const $28d16348e1fba347$export$4111277bf9799237 = 'help_center_reporting_route';
const $28d16348e1fba347$export$a1c6198e9bfea49a = 'unified-help-add-filter-for-customer-accounts';
const $28d16348e1fba347$export$bed2f83bab9fefc1 = 'basic_hc_calls_jira';
const $28d16348e1fba347$var$JCSM_CS_MASTER_FLAG = 'jcs_master_flag';
const $28d16348e1fba347$var$CSM_ACCESS_CONTROL_SPLIT = 'csm_access_control_split_take2';
const $28d16348e1fba347$var$CSM_PREMIUM_SLA_DISABLED_FLAG = 'jsm_csm_premium_sla_config';
const $28d16348e1fba347$var$AI_WIDGET_TEAM25 = 'berry-5094-ai-widget-support-website-team25';
const $28d16348e1fba347$var$CSM_CONTACT_US_SECTION = 'jcs_contact_us_section';
const $28d16348e1fba347$export$5a0ff3ed688d6fd9 = 'enable-hc-layout-granular-interactions';
const $28d16348e1fba347$export$56132373c73141db = 'anonymous_virtual_agent_access';
const $28d16348e1fba347$export$c59907e47c96b562 = 'enable_react-18';
const $28d16348e1fba347$export$f1de11b7a101becf = 'dont_use_hydrate_in_portal_ssr';
const $28d16348e1fba347$var$FIX_RELAY_ID_CONFLICT_IN_HELP_CENTER = 'fix_relay_id_conflict_in_help_center';
const $28d16348e1fba347$var$ADVANCED_HELP_CENTER_CUSTOMIZATION_EDIT_PAGE = 'advanced_help_center_customization_edit_page';
const $28d16348e1fba347$var$TUNING_RETRY_MECHANISM_FOR_MODELS_ENDPOINT = 'tuning_model_retries';
const $28d16348e1fba347$var$FILTER_PREMIUM_SLA_ERRORS = 'filter_premium_sla_errors';
const $28d16348e1fba347$var$HELP_CENTER_DROPDOWN_REDESIGN = 'help_center_dropdown_redesign';
const $28d16348e1fba347$var$CUSTOMISATION_BUTTON_CHANGE_BOARDING = 'enable_customisation_button_change_boarding';
const $28d16348e1fba347$var$PROJECT_MAPPING_ENABLED_IN_MULTI_HC = 'enable_project_mapping_for_help_center';
const $28d16348e1fba347$var$FILTER_NULL_TRACE_ID_FROM_GRAPHQL_CALLS = 'filter_null_trace_id_from_graphql_calls';
const $28d16348e1fba347$var$USE_NEW_EDITOR_CARD_PROVIDER = 'use_new_editor_card_provider';
const $28d16348e1fba347$var$REMOVE_SLASH_FROM_HOMEPAGE_ROUTE = 'remove_slash_from_homepage_routes';
const $28d16348e1fba347$var$REMOVE_NON_CRITICAL_RESOURCE_FROM_VIEW_HOMEPAGE_ROUTE = 'remove_non_critical_resource_from_hc_home_route';
const $28d16348e1fba347$var$ENABLE_CROSS_SITE_CONFLUENCE = 'enable-cross-site-confluence';
const $28d16348e1fba347$var$PROFORMA_TTVC_UPDATE_PACKAGE_ENABLED = 'measure_proforma_ttvc_impact';
const $28d16348e1fba347$var$HANDLE_FOLLOW_UP_QUERIES_ON_VA = 'handling_followupquery_on_feedback_response';
const $28d16348e1fba347$var$REMOVE_CREATE_REQUEST_REDUNDANT_MODELS = 'jsm-create-request-redundant-models-fe';
const $28d16348e1fba347$var$VA_OMNICHANNEL_ENABLED = 'va_on_hc_and_portal_toggle_rest_or_graphql';
const $28d16348e1fba347$var$ENABLE_RELAY_SUBSCRIPTIONS = 'enable_subscription_in_relay';
const $28d16348e1fba347$var$CONSUME_LOOSELY_LAZY_MANIFEST_IN_SSR = 'consume_loosely_lazy_manifest_in_ssr';
const $28d16348e1fba347$var$DEFAULT_HC_USING_GQL_BRANDING = 'default_hc_using_gql_branding';
const $28d16348e1fba347$var$PROJECT_MAPPING_CHANGE_BOARDING = 'project_mapping_change_boarding';
const $28d16348e1fba347$export$cb73a351cc03929f = 'enable_increased_flexibility'; // TODO: using same key as increased flexibility for bundle release
const $28d16348e1fba347$var$ENABLE_FORGE_APPS_IN_JSM_PHASE_1 = 'enable_forge_apps_in_jsm_layout_builder_phase_1';
const $28d16348e1fba347$var$UNABLE_ANALYTICS_FAILURE_EVENT_WITH_ERROR = 'update_analytics_failure_event_with_error';
const $28d16348e1fba347$export$660d24662c32371a = 'sptn-1697-email-verified-signal-on-customers-page';
const $28d16348e1fba347$var$COMMENT_EDITOR_RERENDER_ON_SUBMIT = 'comment_editor_rerender_on_submit';
const $28d16348e1fba347$var$SUMMARY_FIELD_DEBOUNCED = 'summary-field-debounced';
const $28d16348e1fba347$var$DARKER_BORDER_FOR_RICH_TEXT_AREA = 'editor-darker-border';
const $28d16348e1fba347$var$HELP_CENTER_CUSTOM_PAGES = 'help_center_custom_pages_ui';
const $28d16348e1fba347$var$HOMEPAGE_ERROR_HAS_STATUS_CODE = 'homepage_error_has_status_code';
const $28d16348e1fba347$var$REACT_18_LAZY_ENABLED = 'react_18_lazy_enabled';
const $28d16348e1fba347$export$13d57865c16811e5 = 'enable_increased_flexibility';
const $28d16348e1fba347$export$40e944519b773806 = 'enable_followup_questions_on_omni_channel_portal';
const $28d16348e1fba347$var$JSM_GDAY_FEATURES = 'jsm_gday_kb_features';
const $28d16348e1fba347$var$ENABLE_ISOMORPHIC_ERROR_HANDLING = 'enable_isomorphic_error_handling';
const $28d16348e1fba347$var$FETCHJSON_USED_IN_CMDB_OBJECT_FIELD = 'fetchjson_used_in_cmdb_object_field';
const $28d16348e1fba347$var$VISUAL_REFRESH_ONBOARDING = 'visual-refresh-changeboarding';
const $28d16348e1fba347$var$INCREASED_FLEXIBILITY_CHANGEBOARDING = 'increased-flexibility-changeboarding';
const $28d16348e1fba347$var$REQUEST_CREATE_DROPDOWN_INITIAL_OPTIONS_CALL = 'request_create_dropdown_initial_options_call';
const $28d16348e1fba347$var$FILTER_QUERY_ERROR_FROM_SENTRY = 'filter_query_error_from_sentry';
const $28d16348e1fba347$var$HIDE_KB_COLUMN_PROJECT_BREAKDOWN = 'hc_vsa_settings_hide_kb_article_column';
const $28d16348e1fba347$var$VSA_SETTINGS_PERFORMANCE_IMPROVEMENTS = 'hc_vsa_settings_performance_improvements';
const $28d16348e1fba347$var$COLOR_DESIGN_TOKEN_ADOPTION = 'add_color_design_token_support_into_help_center';
const $28d16348e1fba347$var$ENABLE_ADS_TOKEN_SUPPORT_IN_SSR = 'help_center_ads_token_support_in_ssr';
const $28d16348e1fba347$var$TOTAL_ARTICLE_COUNT = 'hc_show_kb_total_article_count';
const $28d16348e1fba347$var$VSA_ADOPTION_TOUCHPOINT_HELP_CENTER = 'vsa-adoption-touchpoint-help-center';
const $28d16348e1fba347$var$HIDE_VSA_ENDPOINTS = 'hide_vsa_endpoints';
const $28d16348e1fba347$var$VSA_ADOPTION_HEADER_CHAT_BUTTON = 'vsa-adoption-header-chat-button';
const $28d16348e1fba347$var$ENABLE_JIRA_FIELD_HANDLING = 'enable_jira_field_handling_in_omnichannel';
const $28d16348e1fba347$var$VSA_ADOPTION_CHAT_SIDE_BAR = 'vsa-adoption-portal-chat-side-bar';
const $28d16348e1fba347$var$ENABLE_HUBS_IN_HELP_CENTER = 'enable-hubs-in-help-center';
const $28d16348e1fba347$var$ENABLE_MULTI_SELECT_CF_UIM_SUPPORT = 'ditto_uim_jsm_multi_select_support';
const $28d16348e1fba347$var$CORTOPV2_EXPERIMENT = 'jsmgrowth-177_jsm_cortopv2';
const $28d16348e1fba347$var$CORTOPV2_EXPERIMENT_TG = 'jsmgrowth-177_jsm_cortopv2_tg';
const $28d16348e1fba347$var$JSM_FORGE_PORTAL_FIX_UNDEFINED_EXTENSION_ERROR = 'jsm_forge_portal_fix_undefined_extension_error';
const $28d16348e1fba347$var$JSM_PORTAL_ROVO_INTEGRATION = 'jsm_portal_rovo_integration';
const $28d16348e1fba347$var$JSM_DATEPICKER_FIELD_SUPPORT = 'ditto_uim_jsm_datepicker_field_support';
const $28d16348e1fba347$var$GRAPHQL_RESPONSE_EMPTY_CHECK = 'jsm_graphql_response_empty_check';
const $28d16348e1fba347$var$AURUM_ASSETS_PCS_3707942 = 'aurum_assets_pcs-3707942';
const $28d16348e1fba347$var$JSM_SURVEYS_GATE = 'jsm_surveys_gate';
const $28d16348e1fba347$var$CSM_LOGIN_PAGE_LINK_BLANK_PAGE = 'csm_login_page_link_leads_to_blank_page';
const $28d16348e1fba347$var$PORTAL_SIGNUP_FORM_SUBTITLE_UPDATE = 'banana_5112_update_set_password_email_copy';
const $28d16348e1fba347$export$a9a13faf0986d8b5 = 'proforma_advanced_conditions_mapping';
const $28d16348e1fba347$export$11856bc97b04d562 = 'proforma_local_consumption_portal_create';
const $28d16348e1fba347$export$9b05a4405c037799 = 'help_seeker_can_create_new_labels_bugfix';
const $28d16348e1fba347$var$JSM_PORTAL_KEEP_REDIRECTION_DESTINATION = 'jsdcloud_15510_portal_keep_redirection_destination';
const $28d16348e1fba347$var$JSM_SURVEYS_CORE_FEATURE = 'jsm_surveys_core_feature';
const $28d16348e1fba347$var$ADD_FORBID_TAGS_IN_HTML_SANITIZATION = 'add_forbid_tags_in_html_sanitization';
const $28d16348e1fba347$var$ROVO_AGENTS_TOOLS_CONFIG_M2 = 'rovo_agents_tools_config_m2';
const $28d16348e1fba347$var$REQUEST_LIST_INFINITE_SCROLL = 'portal-6922-request-list-jsis-pagination';
const $28d16348e1fba347$var$APPROVAL_LIST_INFINITE_SCROLL = 'portal-approval-list-jsis-pagination';
const $28d16348e1fba347$var$EMPTY_STRING_FILTER_ON_FIRST_REQ_LIST_LOAD = 'empty_string_filter_on_first_req_list_load';
const $28d16348e1fba347$export$b72719f56aaa7616 = ()=>(0, $1EFS8.default).checkGate($28d16348e1fba347$export$5a0ff3ed688d6fd9);
const $28d16348e1fba347$export$d418c5a93f5a612e = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$660d24662c32371a);
};
const $28d16348e1fba347$export$9d40c615991b681d = ()=>true;
const $28d16348e1fba347$export$ed104cfad45df81c = ()=>(0, $1EFS8.default).checkGate($28d16348e1fba347$export$706f525b497c4077);
const $28d16348e1fba347$export$787ffd123ce73274 = ()=>(0, $1EFS8.default).checkGate($28d16348e1fba347$export$75614d0a3eb5eb71);
const $28d16348e1fba347$export$98cff3536fe06a4 = ()=>(0, $1EFS8.default).checkGate($28d16348e1fba347$export$a7cb1f93b93ef093);
const $28d16348e1fba347$export$bf2b9f47d2bc9d17 = ()=>(0, $1EFS8.default).checkGate('throw_lazy_error_boundary_js_errors_to_sentry');
const $28d16348e1fba347$export$dbb8ae3ec0512e12 = ()=>false;
const $28d16348e1fba347$export$6c48cb93a07ea1fe = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$4111277bf9799237);
};
const $28d16348e1fba347$export$6abd2200cda9c9c3 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$PROJECT_MAPPING_ENABLED_IN_MULTI_HC);
};
const $28d16348e1fba347$export$4fd1074ca1df827a = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$a1c6198e9bfea49a);
};
const $28d16348e1fba347$export$65c1b2a8a68046aa = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$FIX_RELAY_ID_CONFLICT_IN_HELP_CENTER);
};
const $28d16348e1fba347$export$fd486b6069ca6b2 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$JCSM_CS_MASTER_FLAG);
};
const $28d16348e1fba347$export$27c460ed295f06bd = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$CSM_ACCESS_CONTROL_SPLIT);
};
const $28d16348e1fba347$export$4b18120aa62097f1 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$AI_WIDGET_TEAM25);
};
const $28d16348e1fba347$export$5f0f83b8f3fb9683 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$CSM_PREMIUM_SLA_DISABLED_FLAG);
};
const $28d16348e1fba347$export$19229ae1da4441b0 = ()=>{
    return (0, $1EFS8.default).checkGate('update_articles_links_csm');
};
const $28d16348e1fba347$export$84646dccbb096e42 = ()=>{
    return (0, $1EFS8.default).checkGate('jcs_project_type_m3');
};
const $28d16348e1fba347$export$2ccd8035d1dcad87 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$CSM_CONTACT_US_SECTION);
};
const $28d16348e1fba347$export$5dea29067755e1b0 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$bed2f83bab9fefc1);
};
const $28d16348e1fba347$export$8cfd0c7691c6e406 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ENABLE_CROSS_SITE_CONFLUENCE);
};
const $28d16348e1fba347$export$6bf26299f5ce3574 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ENABLE_KB_ARTICLES_OPEN_IN_SAME_TAB);
};
const $28d16348e1fba347$export$3cf244665c3df4c1 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ADVANCED_HELP_CENTER_CUSTOMIZATION_EDIT_PAGE);
};
const $28d16348e1fba347$export$34d3b9372e9be463 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$c59907e47c96b562);
};
const $28d16348e1fba347$export$73e675d1db50bd4a = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$f1de11b7a101becf);
};
const $28d16348e1fba347$export$88973464e4142e9f = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$HELP_CENTER_DROPDOWN_REDESIGN);
};
const $28d16348e1fba347$export$ae66df261c55d7b5 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$VSA_ADOPTION_TOUCHPOINT_HELP_CENTER);
};
const $28d16348e1fba347$export$48982649dd732b1e = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$CUSTOMISATION_BUTTON_CHANGE_BOARDING);
};
const $28d16348e1fba347$export$32ff46784ecd3055 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$FILTER_NULL_TRACE_ID_FROM_GRAPHQL_CALLS);
};
const $28d16348e1fba347$export$c7b4663aa3b178c3 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$FILTER_PREMIUM_SLA_ERRORS);
};
const $28d16348e1fba347$export$484a220addce746c = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$TUNING_RETRY_MECHANISM_FOR_MODELS_ENDPOINT);
};
const $28d16348e1fba347$export$f4ef25b2974427ab = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$USE_NEW_EDITOR_CARD_PROVIDER);
};
const $28d16348e1fba347$export$f1047a0c2946b9 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$PROFORMA_TTVC_UPDATE_PACKAGE_ENABLED);
};
const $28d16348e1fba347$export$4f2c4b6112c249bd = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$HANDLE_FOLLOW_UP_QUERIES_ON_VA);
};
const $28d16348e1fba347$export$353d729916e0a841 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$REMOVE_SLASH_FROM_HOMEPAGE_ROUTE);
};
const $28d16348e1fba347$export$3cadddd5cbcfe776 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$REMOVE_NON_CRITICAL_RESOURCE_FROM_VIEW_HOMEPAGE_ROUTE);
};
const $28d16348e1fba347$export$3e14f092c6d5897c = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$REMOVE_CREATE_REQUEST_REDUNDANT_MODELS);
};
const $28d16348e1fba347$export$2df383cb702d9c39 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$VA_OMNICHANNEL_ENABLED);
};
const $28d16348e1fba347$export$eee0b0109d7d7c2b = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ENABLE_RELAY_SUBSCRIPTIONS);
};
const $28d16348e1fba347$export$34d4b53afdfa223d = ()=>{
    return (0, $1EFS8.default).checkGate('va_on_help_center_ga');
};
const $28d16348e1fba347$export$a9795343511ea5c1 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$CONSUME_LOOSELY_LAZY_MANIFEST_IN_SSR);
};
const $28d16348e1fba347$export$6ef513d6f7be5888 = ()=>{
    return (0, $1EFS8.default).checkGate('jsm-portal-migrate-to-analytics-bridge');
};
const $28d16348e1fba347$export$d10ba47ac271b5fb = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$DEFAULT_HC_USING_GQL_BRANDING);
};
const $28d16348e1fba347$export$d0f3905affab5e5b = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$PROJECT_MAPPING_CHANGE_BOARDING);
};
const $28d16348e1fba347$export$6c961d647d8a8d16 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$cb73a351cc03929f);
};
const $28d16348e1fba347$export$edadb203ac2a6c5c = ()=>{
    return (0, $1EFS8.default).checkGate('ai-answer-using-draft-article');
};
const $28d16348e1fba347$export$5998e12cd61e03e4 = ()=>(0, $1EFS8.default).checkGate('forge_custom_fields_on_jsm_portal_view');
const $28d16348e1fba347$export$f68ee857fdba507f = ()=>(0, $1EFS8.default).checkGate('is_overriding_fragments_analytics_prop');
const $28d16348e1fba347$export$5c862b9f85068bd7 = ()=>(0, $1EFS8.default).checkGate($28d16348e1fba347$var$ENABLE_FORGE_APPS_IN_JSM_PHASE_1);
const $28d16348e1fba347$export$2b4c3a76f069fbf5 = ()=>(0, $1EFS8.default).checkGate('ditto_uim_-_jsm_support_main');
const $28d16348e1fba347$export$97cf619b5c503901 = ()=>{
    return (0, $1EFS8.default).checkGate('uim_jsm_textfield_support');
};
const $28d16348e1fba347$export$5377338157c93a4a = ()=>{
    return (0, $1EFS8.default).checkGate('ditto_uim_jsm_number_field_support');
};
const $28d16348e1fba347$export$a3127feadc5f63ef = ()=>{
    return (0, $1EFS8.default).checkGate('ditto_uim_jsm_datetime_field_support');
};
const $28d16348e1fba347$export$ca4e8050793caa6 = ()=>{
    return (0, $1EFS8.default).checkGate('uim_jsm_duedate_support');
};
const $28d16348e1fba347$export$682d85ee096f07a9 = ()=>{
    return (0, $1EFS8.default).checkGate('ditto_uim_jsm_textarea_support');
};
const $28d16348e1fba347$export$b738c6acf33d051a = ()=>{
    return (0, $1EFS8.default).checkGate('ditto_uim_jsm_cascading_select_support');
};
const $28d16348e1fba347$export$fe4ccb1b2f4366aa = ()=>{
    return (0, $1EFS8.default).checkGate('ditto_uim_jsm_labels_support');
};
const $28d16348e1fba347$export$d16c700a701ab994 = ()=>{
    return (0, $1EFS8.default).checkGate('ditto_uim_jsm_user_picker_support');
};
const $28d16348e1fba347$export$5621e5c6b3b162df = ()=>{
    return (0, $1EFS8.default).checkGate('ditto_uim_jsm_cascading_default_value_support');
};
const $28d16348e1fba347$export$6636c7ae8eb80195 = ()=>(0, $1EFS8.default).checkGate($28d16348e1fba347$var$UNABLE_ANALYTICS_FAILURE_EVENT_WITH_ERROR);
const $28d16348e1fba347$export$cd1b5399e7ea70f2 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$40e944519b773806);
};
const $28d16348e1fba347$export$6d74bd5fbad4512e = ()=>{
    return (0, $1EFS8.default).checkGate('ai_answer_default_timeout_to_24_hours');
};
const $28d16348e1fba347$export$353c59e30456fe10 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$COMMENT_EDITOR_RERENDER_ON_SUBMIT);
};
const $28d16348e1fba347$export$e3771f1bb7cb73b4 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$SUMMARY_FIELD_DEBOUNCED);
};
const $28d16348e1fba347$export$6d497404d8f015fa = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$DARKER_BORDER_FOR_RICH_TEXT_AREA);
};
const $28d16348e1fba347$export$7dd0505e68d032aa = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$HELP_CENTER_CUSTOM_PAGES);
};
const $28d16348e1fba347$export$7769d816882d3d99 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ENABLE_JIRA_FIELD_HANDLING);
};
const $28d16348e1fba347$export$81ac031d5c9eadb5 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$13d57865c16811e5);
};
const $28d16348e1fba347$export$6a665c3fef32cc75 = ()=>{
    return (0, $1EFS8.default).checkGate('enable_element_renderer_split');
};
const $28d16348e1fba347$export$95fbac9bfbfa10f2 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$JSM_GDAY_FEATURES);
};
const $28d16348e1fba347$export$c008df611f489124 = ()=>{
    return (0, $1EFS8.default).checkGate('enable_omni_channel_for_helpcenter');
};
const $28d16348e1fba347$export$b50d6f62f99953f3 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ENABLE_ISOMORPHIC_ERROR_HANDLING);
};
const $28d16348e1fba347$export$8eb90609f6b1f9d4 = ()=>{
    return (0, $1EFS8.default).checkGate('enable_combinedapi_flow_in_helpcenter');
};
const $28d16348e1fba347$export$e37eef2ad9537fcf = ()=>{
    return (0, $1EFS8.default).checkGate('clear_request_form_on_unmount');
};
const $28d16348e1fba347$export$54d7baed1ffc6f83 = ()=>{
    return (0, $1EFS8.default).checkGate('itsm-issue-renaming');
};
const $28d16348e1fba347$export$bd371ef032bb50b4 = ()=>{
    return (0, $1EFS8.default).checkGate('itsm-project-renaming');
};
const $28d16348e1fba347$export$59c4c8d95bf1eefc = ()=>{
    return (0, $1EFS8.default).checkGate('jsm_chat_orchestrator_greeting_api_enabled');
};
const $28d16348e1fba347$export$c5fadf0a3c794577 = ()=>{
    return (0, $1EFS8.default).checkGate('isomorphic-dompurify-enabled');
};
const $28d16348e1fba347$export$6f37a64a78f7ae99 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$FETCHJSON_USED_IN_CMDB_OBJECT_FIELD);
};
const $28d16348e1fba347$export$47ad7b9bdb77ff6a = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$HOMEPAGE_ERROR_HAS_STATUS_CODE);
};
const $28d16348e1fba347$export$492c9921026864bb = ()=>{
    return (0, $1EFS8.default).checkGate('enable_omnichannel_subscription_error_page');
};
const $28d16348e1fba347$export$fbc5dd39f5b596ee = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$REACT_18_LAZY_ENABLED);
};
const $28d16348e1fba347$export$fd9bbc956c4b639d = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$VISUAL_REFRESH_ONBOARDING);
};
const $28d16348e1fba347$export$d55f20edfbf68f28 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$INCREASED_FLEXIBILITY_CHANGEBOARDING);
};
const $28d16348e1fba347$export$6587e77243044aac = ()=>{
    return (0, $1EFS8.default).checkGate('pass-theme-state-in-ep');
};
const $28d16348e1fba347$export$4c0bb2a2e82edb28 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$REQUEST_CREATE_DROPDOWN_INITIAL_OPTIONS_CALL);
};
const $28d16348e1fba347$export$41f8345167e5e3f1 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$FILTER_QUERY_ERROR_FROM_SENTRY);
};
const $28d16348e1fba347$export$787e10895d9b5b56 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$HIDE_KB_COLUMN_PROJECT_BREAKDOWN);
};
const $28d16348e1fba347$export$2803857b1fa00ccb = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$VSA_SETTINGS_PERFORMANCE_IMPROVEMENTS);
};
const $28d16348e1fba347$export$dbf6a8ec8de99792 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$TOTAL_ARTICLE_COUNT);
};
const $28d16348e1fba347$export$5ee14c6848af11b8 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$HIDE_VSA_ENDPOINTS);
};
const $28d16348e1fba347$export$3c09ad5d9c354810 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$VSA_ADOPTION_HEADER_CHAT_BUTTON);
};
const $28d16348e1fba347$export$c7b1d6ed7aedb077 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$COLOR_DESIGN_TOKEN_ADOPTION);
};
const $28d16348e1fba347$export$d4ec8c5c1eac2bd1 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ENABLE_ADS_TOKEN_SUPPORT_IN_SSR);
};
const $28d16348e1fba347$export$4e32738a2a810c82 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$VSA_ADOPTION_CHAT_SIDE_BAR);
};
const $28d16348e1fba347$export$5950094230c8f65b = ()=>{
    return (0, $1EFS8.default).checkGate('jcs_twg_entitlements_id_to_ari');
};
const $28d16348e1fba347$export$b03e57f56b691f9d = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ENABLE_HUBS_IN_HELP_CENTER);
};
const $28d16348e1fba347$export$3d9060e51ab7079e = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ENABLE_MULTI_SELECT_CF_UIM_SUPPORT);
};
const $28d16348e1fba347$export$334ea9c48e4dea3f = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$CORTOPV2_EXPERIMENT_TG);
};
const $28d16348e1fba347$export$dc2e212d295f2e92 = (fireGateExposure = false)=>{
    return (0, $1EFS8.default).getExperimentValue($28d16348e1fba347$var$CORTOPV2_EXPERIMENT, 'isEnabled', false, {
        fireExperimentExposure: fireGateExposure
    });
};
const $28d16348e1fba347$export$a953b7b444ffe51e = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$JSM_SURVEYS_CORE_FEATURE);
};
const $28d16348e1fba347$export$1511e4c6da7511fd = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$JSM_FORGE_PORTAL_FIX_UNDEFINED_EXTENSION_ERROR);
};
const $28d16348e1fba347$export$c2b1b7c65c5a4a75 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$JSM_PORTAL_ROVO_INTEGRATION);
};
const $28d16348e1fba347$export$1df7079ae40c80e4 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$JSM_DATEPICKER_FIELD_SUPPORT);
};
const $28d16348e1fba347$export$15b096e14fb08a5d = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$GRAPHQL_RESPONSE_EMPTY_CHECK);
};
const $28d16348e1fba347$export$58c47d24d634e7b = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$AURUM_ASSETS_PCS_3707942);
};
const $28d16348e1fba347$export$3c40ce1901660201 = ()=>(0, $1EFS8.default).checkGate($28d16348e1fba347$var$JSM_SURVEYS_GATE);
const $28d16348e1fba347$export$5cd00f51a9bb65a2 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$CSM_LOGIN_PAGE_LINK_BLANK_PAGE);
};
const $28d16348e1fba347$export$3c14e337595a4049 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$JSM_PORTAL_KEEP_REDIRECTION_DESTINATION);
};
const $28d16348e1fba347$export$63bb23d2425a5457 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$a9a13faf0986d8b5);
};
const $28d16348e1fba347$export$aaddf89a6dc7a70e = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$export$11856bc97b04d562);
};
const $28d16348e1fba347$export$86e7d7e27ae6e308 = ()=>(0, $1EFS8.default).checkGate($28d16348e1fba347$export$9b05a4405c037799);
const $28d16348e1fba347$export$772a4190ad30e6ca = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$PORTAL_SIGNUP_FORM_SUBTITLE_UPDATE);
};
const $28d16348e1fba347$export$8493007e9d62d2f7 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ADD_FORBID_TAGS_IN_HTML_SANITIZATION);
};
const $28d16348e1fba347$export$ea979393725a029 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$ROVO_AGENTS_TOOLS_CONFIG_M2);
};
const $28d16348e1fba347$export$a111e2ff03776b7c = ()=>{
    return (0, $1EFS8.default).checkGate('studio-gsn-and-scenario-refresh');
};
const $28d16348e1fba347$export$46753c7d3f251473 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$REQUEST_LIST_INFINITE_SCROLL);
};
const $28d16348e1fba347$export$71262ddd43589494 = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$EMPTY_STRING_FILTER_ON_FIRST_REQ_LIST_LOAD);
};
const $28d16348e1fba347$export$e86f67505602f2f = ()=>{
    return (0, $1EFS8.default).checkGate($28d16348e1fba347$var$APPROVAL_LIST_INFINITE_SCROLL);
};

});

parcelRegister("7FSs7", function(module, exports) {
$parcel$export(module.exports, "contextPath", () => $6a3a0e3a4f62d529$export$bcb673b8a0b7ff6e);
$parcel$export(module.exports, "getRelativeBasePath", () => $6a3a0e3a4f62d529$export$8bbd42317ee66540);
$parcel$export(module.exports, "getBasePath", () => $6a3a0e3a4f62d529$export$9099264ed9b1c55a);
$parcel$export(module.exports, "getBaseName", () => $6a3a0e3a4f62d529$export$a8b0425edf52c70e);
$parcel$export(module.exports, "historyObservable", () => $6a3a0e3a4f62d529$export$a43a1132874d88e3);
$parcel$export(module.exports, "default", () => $6a3a0e3a4f62d529$export$2e2bcd8739ae039);

var $fSYYZ = parcelRequire("fSYYZ");
parcelRequire("9wocP");
var $02U4x = parcelRequire("02U4x");

var $4yRg9 = parcelRequire("4yRg9");

var $jW99n = parcelRequire("jW99n");

var $hrPHR = parcelRequire("hrPHR");
const $6a3a0e3a4f62d529$export$bcb673b8a0b7ff6e = $4yRg9.getMeta('context-path') || '';
const $6a3a0e3a4f62d529$export$8bbd42317ee66540 = ()=>{
    if ((0, $hrPHR.getEnv)().hasOwnProperty('relativeBaseUrl')) return (0, $hrPHR.getEnv)().relativeBaseUrl;
    return '/servicedesk/customer';
};
const $6a3a0e3a4f62d529$export$9099264ed9b1c55a = ()=>{
    if ((0, $hrPHR.getEnv)().hasOwnProperty('baseUrl')) return (0, $hrPHR.getEnv)().baseUrl;
    return `${$6a3a0e3a4f62d529$export$bcb673b8a0b7ff6e}${$6a3a0e3a4f62d529$export$8bbd42317ee66540()}`;
};
const $6a3a0e3a4f62d529$export$e75259171a9ba0d5 = (url)=>{
    return url.replace('/servicedesk/customer', (0, $hrPHR.getEnv)().relativeBaseUrl);
};
const $6a3a0e3a4f62d529$export$c4e6c35f2dffd087 = (url)=>{
    return url.replace((0, $hrPHR.getEnv)().relativeBaseUrl, '/servicedesk/customer');
};
const $6a3a0e3a4f62d529$export$a8b0425edf52c70e = ()=>`${$6a3a0e3a4f62d529$export$bcb673b8a0b7ff6e}${$6a3a0e3a4f62d529$export$8bbd42317ee66540()}`;
const $6a3a0e3a4f62d529$var$history = (0, $jW99n.default).isRunningInSnapvmRuntime() ? (0, $02U4x.createMemoryHistory)({
    initialEntries: [
        $6a3a0e3a4f62d529$export$a8b0425edf52c70e()
    ]
}) : (0, $02U4x.createBrowserHistory)({
    basename: $6a3a0e3a4f62d529$export$a8b0425edf52c70e()
});
const $6a3a0e3a4f62d529$export$a43a1132874d88e3 = (0, $fSYYZ.Observable).create((observer)=>{
    $6a3a0e3a4f62d529$var$history.listen((location, action)=>observer.next({
            location: location,
            action: action
        }));
});
var $6a3a0e3a4f62d529$export$2e2bcd8739ae039 = $6a3a0e3a4f62d529$var$history;

});
parcelRegister("fSYYZ", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $b90b34107a011689$export$77cea355fa80b5f4, (v) => $b90b34107a011689$export$77cea355fa80b5f4 = v);
var $b90b34107a011689$export$77cea355fa80b5f4;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");

var $b7J3L = parcelRequire("b7J3L");

var $bGiX7 = parcelRequire("bGiX7");

var $i11ER = parcelRequire("i11ER");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $b90b34107a011689$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $b7J3L.toSubscriber(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($9Cdpe.root.Rx && $9Cdpe.root.Rx.config && $9Cdpe.root.Rx.config.Promise) PromiseCtor = $9Cdpe.root.Rx.config.Promise;
            else if ($9Cdpe.root.Promise) PromiseCtor = $9Cdpe.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$bGiX7.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $i11ER.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($9Cdpe.root.Rx && $9Cdpe.root.Rx.config && $9Cdpe.root.Rx.config.Promise) PromiseCtor = $9Cdpe.root.Rx.config.Promise;
            else if ($9Cdpe.root.Promise) PromiseCtor = $9Cdpe.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$b90b34107a011689$export$77cea355fa80b5f4 = $b90b34107a011689$var$Observable;

});
parcelRegister("9Cdpe", function(module, exports) {
$parcel$export(module.exports, "root", () => $70020fd5d9e1564b$export$e8e78c978b129247, (v) => $70020fd5d9e1564b$export$e8e78c978b129247 = v);
var $70020fd5d9e1564b$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $70020fd5d9e1564b$var$__window = typeof window !== 'undefined' && window;
var $70020fd5d9e1564b$var$__self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
var $70020fd5d9e1564b$var$__global = typeof $parcel$global !== 'undefined' && $parcel$global;
var $70020fd5d9e1564b$var$_root = $70020fd5d9e1564b$var$__window || $70020fd5d9e1564b$var$__global || $70020fd5d9e1564b$var$__self;
$70020fd5d9e1564b$export$e8e78c978b129247 = $70020fd5d9e1564b$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$70020fd5d9e1564b$var$_root) throw new Error('RxJS could not find any global context (window, self, global)');
})();

});

parcelRegister("b7J3L", function(module, exports) {
$parcel$export(module.exports, "toSubscriber", () => $81934d19ea8e3a8d$export$2a12c2cebbfd1087, (v) => $81934d19ea8e3a8d$export$2a12c2cebbfd1087 = v);
var $81934d19ea8e3a8d$export$2a12c2cebbfd1087;
"use strict";

var $8qR8S = parcelRequire("8qR8S");

var $1zOpv = parcelRequire("1zOpv");

var $67vDe = parcelRequire("67vDe");
function $81934d19ea8e3a8d$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $8qR8S.Subscriber) return nextOrObserver;
        if (nextOrObserver[$1zOpv.rxSubscriber]) return nextOrObserver[$1zOpv.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $8qR8S.Subscriber($67vDe.empty);
    return new $8qR8S.Subscriber(nextOrObserver, error, complete);
}
$81934d19ea8e3a8d$export$2a12c2cebbfd1087 = $81934d19ea8e3a8d$var$toSubscriber;

});
parcelRegister("8qR8S", function(module, exports) {
"use strict";
var $6239f95d509704d8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aLsQP = parcelRequire("aLsQP");

var $aBkDT = parcelRequire("aBkDT");

var $67vDe = parcelRequire("67vDe");

var $1zOpv = parcelRequire("1zOpv");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $6239f95d509704d8$var$Subscriber = function(_super) {
    $6239f95d509704d8$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $67vDe.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $67vDe.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($6239f95d509704d8$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$1zOpv.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $6239f95d509704d8$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $6239f95d509704d8$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$1zOpv.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($aBkDT.Subscription);
module.exports.Subscriber = $6239f95d509704d8$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6239f95d509704d8$var$SafeSubscriber = function(_super) {
    $6239f95d509704d8$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($aLsQP.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $67vDe.empty) {
                context = Object.create(observerOrNext);
                if ($aLsQP.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($6239f95d509704d8$var$Subscriber);
function $6239f95d509704d8$var$isTrustedSubscriber(obj) {
    return obj instanceof $6239f95d509704d8$var$Subscriber || 'syncErrorThrowable' in obj && obj[$1zOpv.rxSubscriber];
}

});
parcelRegister("aLsQP", function(module, exports) {
$parcel$export(module.exports, "isFunction", () => $7d64ac63f39621bb$export$f6e2535fb5126e54, (v) => $7d64ac63f39621bb$export$f6e2535fb5126e54 = v);
var $7d64ac63f39621bb$export$f6e2535fb5126e54;
"use strict";
function $7d64ac63f39621bb$var$isFunction(x) {
    return typeof x === 'function';
}
$7d64ac63f39621bb$export$f6e2535fb5126e54 = $7d64ac63f39621bb$var$isFunction;

});

parcelRegister("aBkDT", function(module, exports) {
$parcel$export(module.exports, "Subscription", () => $7b7d5f403cf63762$export$f55210826850c514, (v) => $7b7d5f403cf63762$export$f55210826850c514 = v);
var $7b7d5f403cf63762$export$f55210826850c514;
"use strict";

var $5G96M = parcelRequire("5G96M");

var $jr9dF = parcelRequire("jr9dF");

var $aLsQP = parcelRequire("aLsQP");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $3cVZM = parcelRequire("3cVZM");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $7b7d5f403cf63762$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($aLsQP.isFunction(_unsubscribe)) {
            var trial = $3XqeD.tryCatch(_unsubscribe).call(this);
            if (trial === $h0Tv0.errorObject) {
                hasErrors = true;
                errors = errors || ($h0Tv0.errorObject.e instanceof $3cVZM.UnsubscriptionError ? $7b7d5f403cf63762$var$flattenUnsubscriptionErrors($h0Tv0.errorObject.e.errors) : [
                    $h0Tv0.errorObject.e
                ]);
            }
        }
        if ($5G96M.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($jr9dF.isObject(sub)) {
                    var trial = $3XqeD.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $h0Tv0.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $h0Tv0.errorObject.e;
                        if (err instanceof $3cVZM.UnsubscriptionError) errors = errors.concat($7b7d5f403cf63762$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $3cVZM.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== 'function' /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$7b7d5f403cf63762$export$f55210826850c514 = $7b7d5f403cf63762$var$Subscription;
function $7b7d5f403cf63762$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $3cVZM.UnsubscriptionError ? err.errors : err);
    }, []);
}

});
parcelRegister("5G96M", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $4227f0bfda568a81$export$43bee75e5e14138e, (v) => $4227f0bfda568a81$export$43bee75e5e14138e = v);
var $4227f0bfda568a81$export$43bee75e5e14138e;
"use strict";
$4227f0bfda568a81$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("jr9dF", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $e267b0bd1160b85c$export$a6cdc56e425d0d0a, (v) => $e267b0bd1160b85c$export$a6cdc56e425d0d0a = v);
var $e267b0bd1160b85c$export$a6cdc56e425d0d0a;
"use strict";
function $e267b0bd1160b85c$var$isObject(x) {
    return x != null && typeof x === 'object';
}
$e267b0bd1160b85c$export$a6cdc56e425d0d0a = $e267b0bd1160b85c$var$isObject;

});

parcelRegister("3XqeD", function(module, exports) {
$parcel$export(module.exports, "tryCatch", () => $2e1b3b89575c54de$export$d234c058d1d4e435, (v) => $2e1b3b89575c54de$export$d234c058d1d4e435 = v);
var $2e1b3b89575c54de$export$d234c058d1d4e435;
"use strict";

var $h0Tv0 = parcelRequire("h0Tv0");
var $2e1b3b89575c54de$var$tryCatchTarget;
function $2e1b3b89575c54de$var$tryCatcher() {
    try {
        return $2e1b3b89575c54de$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $h0Tv0.errorObject.e = e;
        return $h0Tv0.errorObject;
    }
}
function $2e1b3b89575c54de$var$tryCatch(fn) {
    $2e1b3b89575c54de$var$tryCatchTarget = fn;
    return $2e1b3b89575c54de$var$tryCatcher;
}
$2e1b3b89575c54de$export$d234c058d1d4e435 = $2e1b3b89575c54de$var$tryCatch;

});
parcelRegister("h0Tv0", function(module, exports) {
$parcel$export(module.exports, "errorObject", () => $c62d7cb3ddee5296$export$fc504b39d7c1176, (v) => $c62d7cb3ddee5296$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $c62d7cb3ddee5296$export$fc504b39d7c1176;
"use strict";
$c62d7cb3ddee5296$export$fc504b39d7c1176 = {
    e: {}
};

});


parcelRegister("3cVZM", function(module, exports) {
"use strict";
var $255f7ac41e2d27b5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $255f7ac41e2d27b5$var$UnsubscriptionError = function(_super) {
    $255f7ac41e2d27b5$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $255f7ac41e2d27b5$var$UnsubscriptionError;

});


parcelRegister("67vDe", function(module, exports) {
$parcel$export(module.exports, "empty", () => $474beef3fa3048d7$export$6e22c362a0406a2c, (v) => $474beef3fa3048d7$export$6e22c362a0406a2c = v);
var $474beef3fa3048d7$export$6e22c362a0406a2c;
"use strict";
$474beef3fa3048d7$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRegister("1zOpv", function(module, exports) {
$parcel$export(module.exports, "rxSubscriber", () => $126029c8bb93ef90$export$77f77496d7cade10, (v) => $126029c8bb93ef90$export$77f77496d7cade10 = v);
var $126029c8bb93ef90$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $126029c8bb93ef90$export$4a2e07ff24d010f0;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");
var $126029c8bb93ef90$var$Symbol = $9Cdpe.root.Symbol;
$126029c8bb93ef90$export$77f77496d7cade10 = typeof $126029c8bb93ef90$var$Symbol === 'function' && typeof $126029c8bb93ef90$var$Symbol.for === 'function' ? $126029c8bb93ef90$var$Symbol.for('rxSubscriber') : '@@rxSubscriber';
$126029c8bb93ef90$export$4a2e07ff24d010f0 = $126029c8bb93ef90$export$77f77496d7cade10;

});



parcelRegister("bGiX7", function(module, exports) {
$parcel$export(module.exports, "observable", () => $8812518b323915e5$export$5ab46cbf6120b33a, (v) => $8812518b323915e5$export$5ab46cbf6120b33a = v);
var $8812518b323915e5$export$7e68bb2e8ecea8fe;
var $8812518b323915e5$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $8812518b323915e5$export$a7c40509ff863847;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");
function $8812518b323915e5$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    } else $$observable = '@@observable';
    return $$observable;
}
$8812518b323915e5$export$7e68bb2e8ecea8fe = $8812518b323915e5$var$getSymbolObservable;
$8812518b323915e5$export$5ab46cbf6120b33a = $8812518b323915e5$var$getSymbolObservable($9Cdpe.root);
$8812518b323915e5$export$a7c40509ff863847 = $8812518b323915e5$export$5ab46cbf6120b33a;

});

parcelRegister("i11ER", function(module, exports) {
$parcel$export(module.exports, "pipe", () => $d1d99b3aeb57a83e$export$a4627e546088548d, (v) => $d1d99b3aeb57a83e$export$a4627e546088548d = v);
$parcel$export(module.exports, "pipeFromArray", () => $d1d99b3aeb57a83e$export$71f88a61afaa14d7, (v) => $d1d99b3aeb57a83e$export$71f88a61afaa14d7 = v);
var $d1d99b3aeb57a83e$export$a4627e546088548d;
var $d1d99b3aeb57a83e$export$71f88a61afaa14d7;
"use strict";

var $9fPei = parcelRequire("9fPei");
/* tslint:enable:max-line-length */ function $d1d99b3aeb57a83e$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $d1d99b3aeb57a83e$var$pipeFromArray(fns);
}
$d1d99b3aeb57a83e$export$a4627e546088548d = $d1d99b3aeb57a83e$var$pipe;
/* @internal */ function $d1d99b3aeb57a83e$var$pipeFromArray(fns) {
    if (!fns) return $9fPei.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$d1d99b3aeb57a83e$export$71f88a61afaa14d7 = $d1d99b3aeb57a83e$var$pipeFromArray;

});
parcelRegister("9fPei", function(module, exports) {
$parcel$export(module.exports, "noop", () => $6bcd40e001757e31$export$8793edee2d425525, (v) => $6bcd40e001757e31$export$8793edee2d425525 = v);
var $6bcd40e001757e31$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $6bcd40e001757e31$var$noop() {}
$6bcd40e001757e31$export$8793edee2d425525 = $6bcd40e001757e31$var$noop;

});



parcelRegister("9wocP", function(module, exports) {
$parcel$export(module.exports, "createBrowserHistory", () => (parcelRequire("02U4x")).createBrowserHistory);
$parcel$export(module.exports, "createMemoryHistory", () => (parcelRequire("02U4x")).createMemoryHistory);
$parcel$export(module.exports, "Redirect", () => (parcelRequire("7mb2c")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("3vYjO")).Router);
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("21W2d")).RouterSubscriber);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("iyRi5")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("hDCsk")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("i9cdb")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("dKPjT")).useRouterActions);
$parcel$export(module.exports, "withRouter", () => (parcelRequire("bDnSZ")).withRouter);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("jT4Pl")).RouteComponent);
$parcel$export(module.exports, "Link", () => (parcelRequire("cKYBS")).default);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("9v2UH")).generatePath);
$parcel$export(module.exports, "RouterStore", () => (parcelRequire("a9XM1")).RouterStore);
$parcel$export(module.exports, "useRouterStoreActions", () => (parcelRequire("a9XM1")).useRouterStoreActions);
$parcel$export(module.exports, "createResource", () => (parcelRequire("5U6in")).createResource);
$parcel$export(module.exports, "useResource", () => (parcelRequire("hgkVf")).useResource);

var $02U4x = parcelRequire("02U4x");
parcelRequire("hIf1l");
var $7mb2c = parcelRequire("7mb2c");
var $3vYjO = parcelRequire("3vYjO");
var $21W2d = parcelRequire("21W2d");
var $iyRi5 = parcelRequire("iyRi5");
var $hDCsk = parcelRequire("hDCsk");
var $i9cdb = parcelRequire("i9cdb");
var $dKPjT = parcelRequire("dKPjT");
var $bDnSZ = parcelRequire("bDnSZ");
parcelRequire("d0dRl");
var $cKYBS = parcelRequire("cKYBS");
var $jT4Pl = parcelRequire("jT4Pl");
parcelRequire("f18fu");
var $9v2UH = parcelRequire("9v2UH");

var $bofd0 = parcelRequire("bofd0");

var $a9XM1 = parcelRequire("a9XM1");

var $jnML8 = parcelRequire("jnML8");
parcelRequire("889Kb");
var $5U6in = parcelRequire("5U6in");
var $hgkVf = parcelRequire("hgkVf");

});
parcelRegister("02U4x", function(module, exports) {
$parcel$export(module.exports, "parsePath", () => $008baec7f9a42681$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createPath", () => $008baec7f9a42681$export$fe53371bee54353d);
$parcel$export(module.exports, "createLocation", () => $008baec7f9a42681$export$90c043f1c57770b8);
$parcel$export(module.exports, "createBrowserHistory", () => $008baec7f9a42681$export$719fc203c4e16dee);
$parcel$export(module.exports, "createMemoryHistory", () => $008baec7f9a42681$export$2b76ad033c6e6d08);

var $cCnFQ = parcelRequire("cCnFQ");

var $at0wA = parcelRequire("at0wA");

var $5KhxJ = parcelRequire("5KhxJ");


var $clS24 = parcelRequire("clS24");
function $008baec7f9a42681$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $008baec7f9a42681$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $008baec7f9a42681$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $008baec7f9a42681$var$stripBasename(path, prefix) {
    return $008baec7f9a42681$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $008baec7f9a42681$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $008baec7f9a42681$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $008baec7f9a42681$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $008baec7f9a42681$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $008baec7f9a42681$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $cCnFQ.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $at0wA.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $008baec7f9a42681$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $5KhxJ.default)(a.state, b.state);
}
function $008baec7f9a42681$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $008baec7f9a42681$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $008baec7f9a42681$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $008baec7f9a42681$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $008baec7f9a42681$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $008baec7f9a42681$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $008baec7f9a42681$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $008baec7f9a42681$var$PopStateEvent = 'popstate';
var $008baec7f9a42681$var$HashChangeEvent = 'hashchange';
function $008baec7f9a42681$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $008baec7f9a42681$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$008baec7f9a42681$var$canUseDOM && (0, $clS24.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $008baec7f9a42681$var$supportsHistory();
    var needsHashChangeListener = !$008baec7f9a42681$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $008baec7f9a42681$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $008baec7f9a42681$var$stripTrailingSlash($008baec7f9a42681$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $008baec7f9a42681$var$stripBasename(path, basename);
        return $008baec7f9a42681$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $008baec7f9a42681$var$createTransitionManager();
    function setState(nextState) {
        (0, $cCnFQ.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($008baec7f9a42681$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($008baec7f9a42681$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($008baec7f9a42681$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $008baec7f9a42681$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $008baec7f9a42681$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $008baec7f9a42681$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($008baec7f9a42681$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($008baec7f9a42681$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($008baec7f9a42681$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($008baec7f9a42681$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $008baec7f9a42681$var$HashChangeEvent$1 = 'hashchange';
var $008baec7f9a42681$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $008baec7f9a42681$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $008baec7f9a42681$var$stripLeadingSlash,
        decodePath: $008baec7f9a42681$var$addLeadingSlash
    },
    slash: {
        encodePath: $008baec7f9a42681$var$addLeadingSlash,
        decodePath: $008baec7f9a42681$var$addLeadingSlash
    }
};
function $008baec7f9a42681$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $008baec7f9a42681$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $008baec7f9a42681$var$pushHashPath(path) {
    window.location.hash = path;
}
function $008baec7f9a42681$var$replaceHashPath(path) {
    window.location.replace($008baec7f9a42681$var$stripHash(window.location.href) + '#' + path);
}
function $008baec7f9a42681$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$008baec7f9a42681$var$canUseDOM && (0, $clS24.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $008baec7f9a42681$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $008baec7f9a42681$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $008baec7f9a42681$var$stripTrailingSlash($008baec7f9a42681$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $008baec7f9a42681$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($008baec7f9a42681$var$getHashPath());
        if (basename) path = $008baec7f9a42681$var$stripBasename(path, basename);
        return $008baec7f9a42681$export$90c043f1c57770b8(path);
    }
    var transitionManager = $008baec7f9a42681$var$createTransitionManager();
    function setState(nextState) {
        (0, $cCnFQ.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $008baec7f9a42681$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $008baec7f9a42681$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $008baec7f9a42681$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($008baec7f9a42681$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($008baec7f9a42681$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $008baec7f9a42681$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $008baec7f9a42681$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $008baec7f9a42681$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $008baec7f9a42681$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $008baec7f9a42681$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $008baec7f9a42681$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $008baec7f9a42681$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $008baec7f9a42681$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $008baec7f9a42681$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($008baec7f9a42681$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $008baec7f9a42681$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $008baec7f9a42681$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $008baec7f9a42681$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $008baec7f9a42681$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($008baec7f9a42681$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($008baec7f9a42681$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($008baec7f9a42681$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $008baec7f9a42681$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $008baec7f9a42681$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $008baec7f9a42681$var$createTransitionManager();
    function setState(nextState) {
        (0, $cCnFQ.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $008baec7f9a42681$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $008baec7f9a42681$export$90c043f1c57770b8(entry, undefined, createKey()) : $008baec7f9a42681$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $008baec7f9a42681$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $008baec7f9a42681$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $008baec7f9a42681$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $008baec7f9a42681$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("cCnFQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $92fb65ca6a51ffe1$export$2e2bcd8739ae039);
function $92fb65ca6a51ffe1$export$2e2bcd8739ae039() {
    return $92fb65ca6a51ffe1$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $92fb65ca6a51ffe1$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("at0wA", function(module, exports) {
$parcel$export(module.exports, "default", () => $01f76f90657004ee$export$2e2bcd8739ae039);
function $01f76f90657004ee$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $01f76f90657004ee$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $01f76f90657004ee$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $01f76f90657004ee$var$isAbsolute(to);
    var isFromAbs = from && $01f76f90657004ee$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $01f76f90657004ee$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $01f76f90657004ee$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $01f76f90657004ee$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $01f76f90657004ee$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$01f76f90657004ee$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $01f76f90657004ee$export$2e2bcd8739ae039 = $01f76f90657004ee$var$resolvePathname;

});

parcelRegister("5KhxJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $42eedb4cdddcc2f8$export$2e2bcd8739ae039);
function $42eedb4cdddcc2f8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $42eedb4cdddcc2f8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $42eedb4cdddcc2f8$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $42eedb4cdddcc2f8$var$valueOf(a);
        var bValue = $42eedb4cdddcc2f8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $42eedb4cdddcc2f8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $42eedb4cdddcc2f8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $42eedb4cdddcc2f8$export$2e2bcd8739ae039 = $42eedb4cdddcc2f8$var$valueEqual;

});

parcelRegister("clS24", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fe15be9ba448132$export$2e2bcd8739ae039);
var $8fe15be9ba448132$var$isProduction = true;
var $8fe15be9ba448132$var$prefix = 'Invariant failed';
function $8fe15be9ba448132$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($8fe15be9ba448132$var$isProduction) throw new Error($8fe15be9ba448132$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($8fe15be9ba448132$var$prefix, ": ").concat(provided) : $8fe15be9ba448132$var$prefix;
    throw new Error(value);
}

});


parcelRegister("hIf1l", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => (parcelRequire("7mb2c")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("3vYjO")).Router);
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("21W2d")).RouterSubscriber);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("iyRi5")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("hDCsk")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("i9cdb")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("dKPjT")).useRouterActions);
$parcel$export(module.exports, "withRouter", () => (parcelRequire("bDnSZ")).withRouter);

var $7mb2c = parcelRequire("7mb2c");

var $3vYjO = parcelRequire("3vYjO");

var $gPYXY = parcelRequire("gPYXY");

var $21W2d = parcelRequire("21W2d");

var $a9XM1 = parcelRequire("a9XM1");

var $iyRi5 = parcelRequire("iyRi5");

var $hDCsk = parcelRequire("hDCsk");

var $i9cdb = parcelRequire("i9cdb");

var $dKPjT = parcelRequire("dKPjT");

var $bDnSZ = parcelRequire("bDnSZ");

});
parcelRegister("7mb2c", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $55b325ab9d427f27$export$2d8d895a0a0f636e);

var $cCnFQ = parcelRequire("cCnFQ");

var $ceo2e = parcelRequire("ceo2e");

var $02U4x = parcelRequire("02U4x");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("f18fu");
var $8O9Y6 = parcelRequire("8O9Y6");

var $i9cdb = parcelRequire("i9cdb");
class $55b325ab9d427f27$var$Redirector extends (0, $8P7DW.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $02U4x.createPath)((0, $8O9Y6.generateLocationFromPath)(to.path, routeAttributes)) : (0, $02U4x.createPath)(to) : to;
        const currentPath = (0, $02U4x.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $ceo2e.default)($55b325ab9d427f27$var$Redirector, "defaultProps", {
    push: false
});
const $55b325ab9d427f27$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $i9cdb.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($55b325ab9d427f27$var$Redirector, (0, $cCnFQ.default)({
        actions: actions,
        location: location
    }, props));
};

});
parcelRegister("ceo2e", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e796fb55f516ebb$export$2e2bcd8739ae039);

var $cYerE = parcelRequire("cYerE");
function $8e796fb55f516ebb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $cYerE.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("cYerE", function(module, exports) {
$parcel$export(module.exports, "default", () => $97164b176a9b97fd$export$2e2bcd8739ae039);

var $1Vgto = parcelRequire("1Vgto");

var $aplYJ = parcelRequire("aplYJ");
function $97164b176a9b97fd$export$2e2bcd8739ae039(t) {
    var i = (0, $aplYJ.default)(t, "string");
    return "symbol" == (0, $1Vgto.default)(i) ? i : i + "";
}

});
parcelRegister("aplYJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $793d49ab43f68a17$export$2e2bcd8739ae039);

var $1Vgto = parcelRequire("1Vgto");
function $793d49ab43f68a17$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1Vgto.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1Vgto.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("f18fu", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("8O9Y6")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("9v2UH")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("eexci")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("4AFh2")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("1DU2r")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("1DU2r")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("5zGpL")).isSameRouteMatch);

var $ej0g5 = parcelRequire("ej0g5");

var $8O9Y6 = parcelRequire("8O9Y6");

var $9v2UH = parcelRequire("9v2UH");

var $eexci = parcelRequire("eexci");

var $4AFh2 = parcelRequire("4AFh2");

var $1DU2r = parcelRequire("1DU2r");

var $5zGpL = parcelRequire("5zGpL");

});
parcelRegister("ej0g5", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $a6a30a5ce745520e$export$883c3f3b6c000133);

var $cCnFQ = parcelRequire("cCnFQ");

var $02U4x = parcelRequire("02U4x");

var $cyxgG = parcelRequire("cyxgG");

var $66rHy = parcelRequire("66rHy");
const $a6a30a5ce745520e$var$hasWindow = ()=>typeof window !== 'undefined';
const $a6a30a5ce745520e$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($66rHy)))
};
const $a6a30a5ce745520e$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $a6a30a5ce745520e$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $a6a30a5ce745520e$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($cyxgG)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $a6a30a5ce745520e$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $a6a30a5ce745520e$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $a6a30a5ce745520e$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $cCnFQ.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $a6a30a5ce745520e$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $a6a30a5ce745520e$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $02U4x.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $02U4x.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $a6a30a5ce745520e$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
        createHref: (location)=>(0, $02U4x.createPath)(location)
    } : $a6a30a5ce745520e$var$methodsPlaceholders);
};

});
parcelRegister("cyxgG", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $92427758baba9151$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $92427758baba9151$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $92427758baba9151$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $92427758baba9151$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $92427758baba9151$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $92427758baba9151$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $92427758baba9151$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $92427758baba9151$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $92427758baba9151$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $92427758baba9151$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $92427758baba9151$var$root = $92427758baba9151$var$freeGlobal || $92427758baba9151$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $92427758baba9151$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $92427758baba9151$var$objectToString = $92427758baba9151$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $92427758baba9151$var$nativeMax = Math.max, $92427758baba9151$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $92427758baba9151$var$now = function() {
    return $92427758baba9151$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $92427758baba9151$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($92427758baba9151$var$FUNC_ERROR_TEXT);
    wait = $92427758baba9151$var$toNumber(wait) || 0;
    if ($92427758baba9151$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $92427758baba9151$var$nativeMax($92427758baba9151$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $92427758baba9151$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $92427758baba9151$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($92427758baba9151$var$now());
    }
    function debounced() {
        var time = $92427758baba9151$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $92427758baba9151$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $92427758baba9151$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $92427758baba9151$var$isSymbol(value) {
    return typeof value == 'symbol' || $92427758baba9151$var$isObjectLike(value) && $92427758baba9151$var$objectToString.call(value) == $92427758baba9151$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $92427758baba9151$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($92427758baba9151$var$isSymbol(value)) return $92427758baba9151$var$NAN;
    if ($92427758baba9151$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $92427758baba9151$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($92427758baba9151$var$reTrim, '');
    var isBinary = $92427758baba9151$var$reIsBinary.test(value);
    return isBinary || $92427758baba9151$var$reIsOctal.test(value) ? $92427758baba9151$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $92427758baba9151$var$reIsBadHex.test(value) ? $92427758baba9151$var$NAN : +value;
}
module.exports = $92427758baba9151$var$debounce;

});

parcelRegister("66rHy", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $4718ca8c0a610887$var$noop() {
// No operation performed.
}
module.exports = $4718ca8c0a610887$var$noop;

});


parcelRegister("8O9Y6", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $669ab9c16d997609$export$37e0729cc751960b);

var $fihms = parcelRequire("fihms");

var $lg6T0 = parcelRequire("lg6T0");
function $669ab9c16d997609$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $lg6T0.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $fihms.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("fihms", function(module, exports) {
$parcel$export(module.exports, "compile", () => $b226010900e5b86b$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $b226010900e5b86b$export$71304158c7e35877);
/**
 * Tokenize input string.
 */ function $b226010900e5b86b$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $b226010900e5b86b$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $b226010900e5b86b$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($b226010900e5b86b$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($b226010900e5b86b$var$escapeString(prevText), ")[^").concat($b226010900e5b86b$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $b226010900e5b86b$export$ef7acd7185315e22(str, options) {
    return $b226010900e5b86b$export$5b9bad9e403cf3d9($b226010900e5b86b$export$98e6a39c04603d36(str, options), options);
}
function $b226010900e5b86b$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $b226010900e5b86b$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $b226010900e5b86b$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $b226010900e5b86b$export$71304158c7e35877(str, keys, options);
    return $b226010900e5b86b$export$968e97c88708237a(re, keys, options);
}
function $b226010900e5b86b$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $b226010900e5b86b$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $b226010900e5b86b$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $b226010900e5b86b$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $b226010900e5b86b$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $b226010900e5b86b$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $b226010900e5b86b$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $b226010900e5b86b$var$stringToRegexp(path, keys, options) {
    return $b226010900e5b86b$export$9a9303716def6456($b226010900e5b86b$export$98e6a39c04603d36(path, options), keys, options);
}
function $b226010900e5b86b$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($b226010900e5b86b$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($b226010900e5b86b$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $b226010900e5b86b$var$escapeString(encode(token));
        else {
            var prefix = $b226010900e5b86b$var$escapeString(encode(token.prefix));
            var suffix = $b226010900e5b86b$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $b226010900e5b86b$var$flags(options));
}
function $b226010900e5b86b$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $b226010900e5b86b$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $b226010900e5b86b$var$arrayToRegexp(path, keys, options);
    return $b226010900e5b86b$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("lg6T0", function(module, exports) {
'use strict';

var $hbytZ = parcelRequire("hbytZ");

var $9JeYB = parcelRequire("9JeYB");
var $f7a06f106851c95e$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $f7a06f106851c95e$var$CRHTLF = /[\n\r\t]/g, $f7a06f106851c95e$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $f7a06f106851c95e$var$port = /:\d+$/, $f7a06f106851c95e$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $f7a06f106851c95e$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $f7a06f106851c95e$var$trimLeft(str) {
    return (str ? str : '').toString().replace($f7a06f106851c95e$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $f7a06f106851c95e$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $f7a06f106851c95e$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $f7a06f106851c95e$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $f7a06f106851c95e$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $f7a06f106851c95e$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $f7a06f106851c95e$var$Url(loc, {});
        for(key in $f7a06f106851c95e$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $f7a06f106851c95e$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $f7a06f106851c95e$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $f7a06f106851c95e$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $f7a06f106851c95e$var$extractProtocol(address, location) {
    address = $f7a06f106851c95e$var$trimLeft(address);
    address = address.replace($f7a06f106851c95e$var$CRHTLF, '');
    location = location || {};
    var match = $f7a06f106851c95e$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($f7a06f106851c95e$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $f7a06f106851c95e$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $f7a06f106851c95e$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $f7a06f106851c95e$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $f7a06f106851c95e$var$Url(address, location, parser) {
    address = $f7a06f106851c95e$var$trimLeft(address);
    address = address.replace($f7a06f106851c95e$var$CRHTLF, '');
    if (!(this instanceof $f7a06f106851c95e$var$Url)) return new $f7a06f106851c95e$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $f7a06f106851c95e$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $9JeYB.parse;
    location = $f7a06f106851c95e$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $f7a06f106851c95e$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $f7a06f106851c95e$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$f7a06f106851c95e$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $f7a06f106851c95e$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $f7a06f106851c95e$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$hbytZ(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $f7a06f106851c95e$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $f7a06f106851c95e$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $9JeYB.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$hbytZ(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($f7a06f106851c95e$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $f7a06f106851c95e$var$rules.length; i++){
        var ins = $f7a06f106851c95e$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $f7a06f106851c95e$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $f7a06f106851c95e$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $9JeYB.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $f7a06f106851c95e$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $f7a06f106851c95e$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $f7a06f106851c95e$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$f7a06f106851c95e$var$Url.prototype = {
    set: $f7a06f106851c95e$var$set,
    toString: $f7a06f106851c95e$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$f7a06f106851c95e$var$Url.extractProtocol = $f7a06f106851c95e$var$extractProtocol;
$f7a06f106851c95e$var$Url.location = $f7a06f106851c95e$var$lolcation;
$f7a06f106851c95e$var$Url.trimLeft = $f7a06f106851c95e$var$trimLeft;
$f7a06f106851c95e$var$Url.qs = $9JeYB;
module.exports = $f7a06f106851c95e$var$Url;

});
parcelRegister("hbytZ", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("9JeYB", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $01d3ef35e2f61b7e$export$fac44ee5b035f737, (v) => $01d3ef35e2f61b7e$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $01d3ef35e2f61b7e$export$98e6a39c04603d36, (v) => $01d3ef35e2f61b7e$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $01d3ef35e2f61b7e$export$fac44ee5b035f737;
var $01d3ef35e2f61b7e$export$98e6a39c04603d36;
'use strict';
var $01d3ef35e2f61b7e$var$has = Object.prototype.hasOwnProperty, $01d3ef35e2f61b7e$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $01d3ef35e2f61b7e$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $01d3ef35e2f61b7e$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $01d3ef35e2f61b7e$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $01d3ef35e2f61b7e$var$decode(part[1]), value = $01d3ef35e2f61b7e$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $01d3ef35e2f61b7e$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($01d3ef35e2f61b7e$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $01d3ef35e2f61b7e$var$undef || isNaN(value))) value = '';
        key = $01d3ef35e2f61b7e$var$encode(key);
        value = $01d3ef35e2f61b7e$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$01d3ef35e2f61b7e$export$fac44ee5b035f737 = $01d3ef35e2f61b7e$var$querystringify;
$01d3ef35e2f61b7e$export$98e6a39c04603d36 = $01d3ef35e2f61b7e$var$querystring;

});



parcelRegister("9v2UH", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $6ea944dc6311c5a1$export$82476f982757e71e);

var $fihms = parcelRequire("fihms");
const $6ea944dc6311c5a1$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $fihms.compile)(pattern)(params);

});

parcelRegister("eexci", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $a5cc1fcab3254067$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $6nQJh = parcelRequire("6nQJh");
const $a5cc1fcab3254067$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $a5cc1fcab3254067$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $6nQJh !== 'undefined' && $6nQJh.versions != null && $6nQJh.versions.node != null) return true;
    if ($a5cc1fcab3254067$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("4AFh2", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $357a8a5753656228$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $357a8a5753656228$export$2e2bcd8739ae039);

var $lg6T0 = parcelRequire("lg6T0");

var $2Y4BJ = parcelRequire("2Y4BJ");

var $5tEmd = parcelRequire("5tEmd");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $357a8a5753656228$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $lg6T0.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $5tEmd.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $2Y4BJ.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $5tEmd.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $357a8a5753656228$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$357a8a5753656228$var$matchRoute(routes, pathname, queryParams, basePath);
const $357a8a5753656228$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $357a8a5753656228$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $357a8a5753656228$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$357a8a5753656228$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("2Y4BJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2294c254e3471b8f$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");

var $dsFu0 = parcelRequire("dsFu0");

var $chp04 = parcelRequire("chp04");
/* This should match what react-router does to compute a root match. */ const $2294c254e3471b8f$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $2294c254e3471b8f$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $dsFu0.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $2294c254e3471b8f$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $chp04.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $cCnFQ.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $2294c254e3471b8f$export$2e2bcd8739ae039 = $2294c254e3471b8f$var$execRouteMatching;

});
parcelRegister("dsFu0", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cce118bc2e5e4f0$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $fihms = parcelRequire("fihms");
const $9cce118bc2e5e4f0$var$cache = {};
const $9cce118bc2e5e4f0$var$cacheLimit = 10000;
let $9cce118bc2e5e4f0$var$cacheCount = 0;
function $9cce118bc2e5e4f0$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $9cce118bc2e5e4f0$var$cache[cacheKey] || ($9cce118bc2e5e4f0$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $fihms.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($9cce118bc2e5e4f0$var$cacheCount < $9cce118bc2e5e4f0$var$cacheLimit) {
        pathCache[path] = result;
        $9cce118bc2e5e4f0$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $9cce118bc2e5e4f0$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $9cce118bc2e5e4f0$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $9cce118bc2e5e4f0$export$2e2bcd8739ae039 = $9cce118bc2e5e4f0$var$matchPath;

});

parcelRegister("chp04", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f0a7714058abd09$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $8f0a7714058abd09$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $cCnFQ.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $8f0a7714058abd09$export$2e2bcd8739ae039 = $8f0a7714058abd09$var$matchQuery;

});


parcelRegister("5tEmd", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $3fcef755028939ff$export$f594abf16a5ad948);
const $3fcef755028939ff$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $3fcef755028939ff$var$MAX_CACHE_SIZE = 1000;
function $3fcef755028939ff$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$3fcef755028939ff$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $3fcef755028939ff$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($3fcef755028939ff$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $3fcef755028939ff$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $3fcef755028939ff$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("1DU2r", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $1324e706e51f35df$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $1324e706e51f35df$export$a0bd0313cbeabd49);

var $lg6T0 = parcelRequire("lg6T0");

var $jnML8 = parcelRequire("jnML8");

var $9v2UH = parcelRequire("9v2UH");

var $4AFh2 = parcelRequire("4AFh2");
const $1324e706e51f35df$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $9v2UH.generatePath)(route.path, params);
    const matchedRoute = (0, $4AFh2.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $jnML8.DEFAULT_MATCH),
        query: query
    };
};
const $1324e706e51f35df$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $lg6T0.qs).parse(search);
    const matchedRoute = (0, $4AFh2.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $jnML8.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $jnML8.DEFAULT_MATCH)
    };
};

});
parcelRegister("jnML8", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $e1c5fcdd7997a862$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $e1c5fcdd7997a862$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $e1c5fcdd7997a862$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $e1c5fcdd7997a862$export$fa440ddf675c8a93);

var $66rHy = parcelRequire("66rHy");

var $ej0g5 = parcelRequire("ej0g5");
const $e1c5fcdd7997a862$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $e1c5fcdd7997a862$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $e1c5fcdd7997a862$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $e1c5fcdd7997a862$export$39607c9878cf5148 = (0, $ej0g5.createLegacyHistory)();
const $e1c5fcdd7997a862$export$1515254c8c90bebb = {
    location: $e1c5fcdd7997a862$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy)))
};
const $e1c5fcdd7997a862$export$fa440ddf675c8a93 = 'POP';

});


parcelRegister("5zGpL", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $40f11f43e588fa9b$export$5997e70fc4543270);
const $40f11f43e588fa9b$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $40f11f43e588fa9b$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $40f11f43e588fa9b$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $40f11f43e588fa9b$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});


parcelRegister("i9cdb", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $d3628a403ca07e1f$export$9a302a45f65d0572);

var $a9XM1 = parcelRequire("a9XM1");
const $d3628a403ca07e1f$export$9a302a45f65d0572 = (0, $a9XM1.useRouterStore);

});
parcelRegister("a9XM1", function(module, exports) {
$parcel$export(module.exports, "RouterStore", () => $76591c6c4d4f8882$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $76591c6c4d4f8882$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $76591c6c4d4f8882$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $76591c6c4d4f8882$export$ada49399abf7a3a1);

var $cCnFQ = parcelRequire("cCnFQ");

var $02U4x = parcelRequire("02U4x");

var $lR4hY = parcelRequire("lR4hY");
var $6xLCs = parcelRequire("6xLCs");
var $iOIPr = parcelRequire("iOIPr");
var $kUoOn = parcelRequire("kUoOn");
var $jvxRx = parcelRequire("jvxRx");

var $jnML8 = parcelRequire("jnML8");
parcelRequire("f18fu");
var $1DU2r = parcelRequire("1DU2r");
var $8O9Y6 = parcelRequire("8O9Y6");
var $9v2UH = parcelRequire("9v2UH");
var $eexci = parcelRequire("eexci");
var $4AFh2 = parcelRequire("4AFh2");

var $g165c = parcelRequire("g165c");
const $76591c6c4d4f8882$export$36d128238e6b60f5 = {
    action: (0, $jnML8.DEFAULT_ACTION),
    basePath: '',
    location: (0, $jnML8.DEFAULT_HISTORY).location,
    history: (0, $jnML8.DEFAULT_HISTORY),
    match: (0, $jnML8.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $jnML8.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $76591c6c4d4f8882$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $1DU2r.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $cCnFQ.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $eexci.isServerEnvironment)()) dispatch($76591c6c4d4f8882$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $1DU2r.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $g165c.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $lR4hY.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $cCnFQ.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $g165c.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $g165c.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $8O9Y6.generateLocationFromPath)(route.path, (0, $cCnFQ.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $4AFh2.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $g165c.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $g165c.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $8O9Y6.generateLocationFromPath)(route.path, (0, $cCnFQ.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $4AFh2.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $cCnFQ.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $g165c.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $g165c.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $cCnFQ.default)({}, existingPathParams, params);
            const updatedPath = (0, $9v2UH.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $cCnFQ.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $g165c.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $g165c.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $76591c6c4d4f8882$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $g165c.isExternalAbsolutePath)(path)) {
                const location = (0, $02U4x.parsePath)((0, $g165c.getRelativePath)(path, basePath));
                nextContext = (0, $1DU2r.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $lR4hY.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $76591c6c4d4f8882$export$1cf0ecab63b1963c = (0, $kUoOn.createStore)({
    initialState: $76591c6c4d4f8882$export$36d128238e6b60f5,
    actions: $76591c6c4d4f8882$var$actions,
    name: 'router'
});
const $76591c6c4d4f8882$export$d6b817abe7a77ea5 = (0, $iOIPr.createContainer)($76591c6c4d4f8882$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($76591c6c4d4f8882$var$actions.bootstrapStore(props));
            !(0, $eexci.isServerEnvironment)() && dispatch($76591c6c4d4f8882$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $eexci.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $76591c6c4d4f8882$export$9569010eab09ae9e = (0, $6xLCs.createHook)($76591c6c4d4f8882$export$1cf0ecab63b1963c);
const $76591c6c4d4f8882$export$ada49399abf7a3a1 = (0, $6xLCs.createActionsHook)($76591c6c4d4f8882$export$1cf0ecab63b1963c);
function $76591c6c4d4f8882$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $6xLCs.createHook)($76591c6c4d4f8882$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $76591c6c4d4f8882$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $jvxRx.defaultRegistry).getStore($76591c6c4d4f8882$export$1cf0ecab63b1963c);
const $76591c6c4d4f8882$export$ebf37f7e180b13a9 = ()=>$76591c6c4d4f8882$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("lR4hY", function(module, exports) {
$parcel$export(module.exports, "batch", () => $fe91dfe82e9f9c05$export$712ea50be43a7858);
/* eslint-disable import/no-unresolved */ 
var $6Q1OD = parcelRequire("6Q1OD");

var $2NwEO = parcelRequire("2NwEO");

var $8Mxh4 = parcelRequire("8Mxh4");

var $dxlJL = parcelRequire("dxlJL");
let $fe91dfe82e9f9c05$var$isInsideBatchedSchedule = false;
function $fe91dfe82e9f9c05$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $8Mxh4.default).batchUpdates || !(0, $dxlJL.default).scheduling() || $fe91dfe82e9f9c05$var$isInsideBatchedSchedule) return (0, $6Q1OD.unstable_batchedUpdates)(fn);
    $fe91dfe82e9f9c05$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $2NwEO.unstable_scheduleCallback)((0, $2NwEO.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $6Q1OD.unstable_batchedUpdates)(fn);
        $fe91dfe82e9f9c05$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("6Q1OD", function(module, exports) {
'use strict';
function $4fa901fba9722ec5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4fa901fba9722ec5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4fa901fba9722ec5$var$checkDCE();

module.exports = (parcelRequire("VtK6e"));

});
parcelRegister("VtK6e", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0acc653c28085d6b$export$ae55be85d98224ed, (v) => $0acc653c28085d6b$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0acc653c28085d6b$export$d39a5bbd09211389, (v) => $0acc653c28085d6b$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0acc653c28085d6b$export$882461b6382ed46c, (v) => $0acc653c28085d6b$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0acc653c28085d6b$export$466bfc07425424d5, (v) => $0acc653c28085d6b$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0acc653c28085d6b$export$cd75ccfd720a3cd4, (v) => $0acc653c28085d6b$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0acc653c28085d6b$export$fa8d919ba61d84db, (v) => $0acc653c28085d6b$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0acc653c28085d6b$export$757ceba2d55c277e, (v) => $0acc653c28085d6b$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0acc653c28085d6b$export$b3890eb0ae9dca99, (v) => $0acc653c28085d6b$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0acc653c28085d6b$export$502457920280e6be, (v) => $0acc653c28085d6b$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0acc653c28085d6b$export$c78a37762a8d58e1, (v) => $0acc653c28085d6b$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0acc653c28085d6b$export$dc54d992c10e8a18, (v) => $0acc653c28085d6b$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0acc653c28085d6b$export$83d89fbfd8236492, (v) => $0acc653c28085d6b$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0acc653c28085d6b$export$ae55be85d98224ed;
var $0acc653c28085d6b$export$d39a5bbd09211389;
var $0acc653c28085d6b$export$882461b6382ed46c;
var $0acc653c28085d6b$export$466bfc07425424d5;
var $0acc653c28085d6b$export$cd75ccfd720a3cd4;
var $0acc653c28085d6b$export$fa8d919ba61d84db;
var $0acc653c28085d6b$export$757ceba2d55c277e;
var $0acc653c28085d6b$export$b3890eb0ae9dca99;
var $0acc653c28085d6b$export$502457920280e6be;
var $0acc653c28085d6b$export$c78a37762a8d58e1;
var $0acc653c28085d6b$export$dc54d992c10e8a18;
var $0acc653c28085d6b$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $8P7DW = parcelRequire("8P7DW");

var $2NwEO = parcelRequire("2NwEO");
function $0acc653c28085d6b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0acc653c28085d6b$var$da = new Set, $0acc653c28085d6b$var$ea = {};
function $0acc653c28085d6b$var$fa(a, b) {
    $0acc653c28085d6b$var$ha(a, b);
    $0acc653c28085d6b$var$ha(a + "Capture", b);
}
function $0acc653c28085d6b$var$ha(a, b) {
    $0acc653c28085d6b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0acc653c28085d6b$var$da.add(b[a]);
}
var $0acc653c28085d6b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0acc653c28085d6b$var$ja = Object.prototype.hasOwnProperty, $0acc653c28085d6b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0acc653c28085d6b$var$la = {}, $0acc653c28085d6b$var$ma = {};
function $0acc653c28085d6b$var$na(a) {
    if ($0acc653c28085d6b$var$ja.call($0acc653c28085d6b$var$ma, a)) return !0;
    if ($0acc653c28085d6b$var$ja.call($0acc653c28085d6b$var$la, a)) return !1;
    if ($0acc653c28085d6b$var$ka.test(a)) return $0acc653c28085d6b$var$ma[a] = !0;
    $0acc653c28085d6b$var$la[a] = !0;
    return !1;
}
function $0acc653c28085d6b$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0acc653c28085d6b$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0acc653c28085d6b$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0acc653c28085d6b$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0acc653c28085d6b$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0acc653c28085d6b$var$t[b] = new $0acc653c28085d6b$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0acc653c28085d6b$var$ra = /[\-:]([a-z])/g;
function $0acc653c28085d6b$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0acc653c28085d6b$var$ra, $0acc653c28085d6b$var$ta);
    $0acc653c28085d6b$var$t[b] = new $0acc653c28085d6b$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0acc653c28085d6b$var$ra, $0acc653c28085d6b$var$ta);
    $0acc653c28085d6b$var$t[b] = new $0acc653c28085d6b$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0acc653c28085d6b$var$ra, $0acc653c28085d6b$var$ta);
    $0acc653c28085d6b$var$t[b] = new $0acc653c28085d6b$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0acc653c28085d6b$var$t.xlinkHref = new $0acc653c28085d6b$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0acc653c28085d6b$var$t[a] = new $0acc653c28085d6b$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0acc653c28085d6b$var$ua(a, b, c, d) {
    var e = $0acc653c28085d6b$var$t.hasOwnProperty(b) ? $0acc653c28085d6b$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0acc653c28085d6b$var$pa(b, c, e, d) && (c = null), d || null === e ? $0acc653c28085d6b$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0acc653c28085d6b$var$va = $8P7DW.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0acc653c28085d6b$var$wa = Symbol.for("react.element"), $0acc653c28085d6b$var$xa = Symbol.for("react.portal"), $0acc653c28085d6b$var$ya = Symbol.for("react.fragment"), $0acc653c28085d6b$var$za = Symbol.for("react.strict_mode"), $0acc653c28085d6b$var$Aa = Symbol.for("react.profiler"), $0acc653c28085d6b$var$Ba = Symbol.for("react.provider"), $0acc653c28085d6b$var$Ca = Symbol.for("react.context"), $0acc653c28085d6b$var$Da = Symbol.for("react.forward_ref"), $0acc653c28085d6b$var$Ea = Symbol.for("react.suspense"), $0acc653c28085d6b$var$Fa = Symbol.for("react.suspense_list"), $0acc653c28085d6b$var$Ga = Symbol.for("react.memo"), $0acc653c28085d6b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0acc653c28085d6b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0acc653c28085d6b$var$Ja = Symbol.iterator;
function $0acc653c28085d6b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0acc653c28085d6b$var$Ja && a[$0acc653c28085d6b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0acc653c28085d6b$var$u = Object.assign, $0acc653c28085d6b$var$La;
function $0acc653c28085d6b$var$Ma(a) {
    if (void 0 === $0acc653c28085d6b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0acc653c28085d6b$var$La = b && b[1] || "";
    }
    return "\n" + $0acc653c28085d6b$var$La + a;
}
var $0acc653c28085d6b$var$Na = !1;
function $0acc653c28085d6b$var$Oa(a, b) {
    if (!a || $0acc653c28085d6b$var$Na) return "";
    $0acc653c28085d6b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0acc653c28085d6b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0acc653c28085d6b$var$Ma(a) : "";
}
function $0acc653c28085d6b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0acc653c28085d6b$var$Ma(a.type);
        case 16:
            return $0acc653c28085d6b$var$Ma("Lazy");
        case 13:
            return $0acc653c28085d6b$var$Ma("Suspense");
        case 19:
            return $0acc653c28085d6b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0acc653c28085d6b$var$Oa(a.type, !1), a;
        case 11:
            return a = $0acc653c28085d6b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0acc653c28085d6b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0acc653c28085d6b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0acc653c28085d6b$var$ya:
            return "Fragment";
        case $0acc653c28085d6b$var$xa:
            return "Portal";
        case $0acc653c28085d6b$var$Aa:
            return "Profiler";
        case $0acc653c28085d6b$var$za:
            return "StrictMode";
        case $0acc653c28085d6b$var$Ea:
            return "Suspense";
        case $0acc653c28085d6b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0acc653c28085d6b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0acc653c28085d6b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0acc653c28085d6b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0acc653c28085d6b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0acc653c28085d6b$var$Qa(a.type) || "Memo";
        case $0acc653c28085d6b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0acc653c28085d6b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0acc653c28085d6b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0acc653c28085d6b$var$Qa(b);
        case 8:
            return b === $0acc653c28085d6b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0acc653c28085d6b$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0acc653c28085d6b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0acc653c28085d6b$var$Ua(a) {
    var b = $0acc653c28085d6b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0acc653c28085d6b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0acc653c28085d6b$var$Ua(a));
}
function $0acc653c28085d6b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0acc653c28085d6b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0acc653c28085d6b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0acc653c28085d6b$var$Ya(a, b) {
    var c = b.checked;
    return $0acc653c28085d6b$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0acc653c28085d6b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0acc653c28085d6b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0acc653c28085d6b$var$$a(a, b) {
    b = b.checked;
    null != b && $0acc653c28085d6b$var$ua(a, "checked", b, !1);
}
function $0acc653c28085d6b$var$ab(a, b) {
    $0acc653c28085d6b$var$$a(a, b);
    var c = $0acc653c28085d6b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0acc653c28085d6b$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0acc653c28085d6b$var$bb(a, b.type, $0acc653c28085d6b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0acc653c28085d6b$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0acc653c28085d6b$var$bb(a, b, c) {
    if ("number" !== b || $0acc653c28085d6b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0acc653c28085d6b$var$db = Array.isArray;
function $0acc653c28085d6b$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0acc653c28085d6b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0acc653c28085d6b$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0acc653c28085d6b$var$p(91));
    return $0acc653c28085d6b$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0acc653c28085d6b$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0acc653c28085d6b$var$p(92));
            if ($0acc653c28085d6b$var$db(c)) {
                if (1 < c.length) throw Error($0acc653c28085d6b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0acc653c28085d6b$var$Sa(c)
    };
}
function $0acc653c28085d6b$var$hb(a, b) {
    var c = $0acc653c28085d6b$var$Sa(b.value), d = $0acc653c28085d6b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0acc653c28085d6b$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0acc653c28085d6b$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0acc653c28085d6b$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0acc653c28085d6b$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0acc653c28085d6b$var$mb, $0acc653c28085d6b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0acc653c28085d6b$var$mb = $0acc653c28085d6b$var$mb || document.createElement("div");
        $0acc653c28085d6b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0acc653c28085d6b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0acc653c28085d6b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0acc653c28085d6b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0acc653c28085d6b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0acc653c28085d6b$var$pb).forEach(function(a) {
    $0acc653c28085d6b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0acc653c28085d6b$var$pb[b] = $0acc653c28085d6b$var$pb[a];
    });
});
function $0acc653c28085d6b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0acc653c28085d6b$var$pb.hasOwnProperty(a) && $0acc653c28085d6b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0acc653c28085d6b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0acc653c28085d6b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0acc653c28085d6b$var$tb = $0acc653c28085d6b$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0acc653c28085d6b$var$ub(a, b) {
    if (b) {
        if ($0acc653c28085d6b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0acc653c28085d6b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0acc653c28085d6b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0acc653c28085d6b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0acc653c28085d6b$var$p(62));
    }
}
function $0acc653c28085d6b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0acc653c28085d6b$var$wb = null;
function $0acc653c28085d6b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0acc653c28085d6b$var$yb = null, $0acc653c28085d6b$var$zb = null, $0acc653c28085d6b$var$Ab = null;
function $0acc653c28085d6b$var$Bb(a) {
    if (a = $0acc653c28085d6b$var$Cb(a)) {
        if ("function" !== typeof $0acc653c28085d6b$var$yb) throw Error($0acc653c28085d6b$var$p(280));
        var b = a.stateNode;
        b && (b = $0acc653c28085d6b$var$Db(b), $0acc653c28085d6b$var$yb(a.stateNode, a.type, b));
    }
}
function $0acc653c28085d6b$var$Eb(a) {
    $0acc653c28085d6b$var$zb ? $0acc653c28085d6b$var$Ab ? $0acc653c28085d6b$var$Ab.push(a) : $0acc653c28085d6b$var$Ab = [
        a
    ] : $0acc653c28085d6b$var$zb = a;
}
function $0acc653c28085d6b$var$Fb() {
    if ($0acc653c28085d6b$var$zb) {
        var a = $0acc653c28085d6b$var$zb, b = $0acc653c28085d6b$var$Ab;
        $0acc653c28085d6b$var$Ab = $0acc653c28085d6b$var$zb = null;
        $0acc653c28085d6b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0acc653c28085d6b$var$Bb(b[a]);
    }
}
function $0acc653c28085d6b$var$Gb(a, b) {
    return a(b);
}
function $0acc653c28085d6b$var$Hb() {}
var $0acc653c28085d6b$var$Ib = !1;
function $0acc653c28085d6b$var$Jb(a, b, c) {
    if ($0acc653c28085d6b$var$Ib) return a(b, c);
    $0acc653c28085d6b$var$Ib = !0;
    try {
        return $0acc653c28085d6b$var$Gb(a, b, c);
    } finally{
        if ($0acc653c28085d6b$var$Ib = !1, null !== $0acc653c28085d6b$var$zb || null !== $0acc653c28085d6b$var$Ab) $0acc653c28085d6b$var$Hb(), $0acc653c28085d6b$var$Fb();
    }
}
function $0acc653c28085d6b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0acc653c28085d6b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0acc653c28085d6b$var$p(231, b, typeof c));
    return c;
}
var $0acc653c28085d6b$var$Lb = !1;
if ($0acc653c28085d6b$var$ia) try {
    var $0acc653c28085d6b$var$Mb = {};
    Object.defineProperty($0acc653c28085d6b$var$Mb, "passive", {
        get: function() {
            $0acc653c28085d6b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0acc653c28085d6b$var$Mb, $0acc653c28085d6b$var$Mb);
    window.removeEventListener("test", $0acc653c28085d6b$var$Mb, $0acc653c28085d6b$var$Mb);
} catch (a) {
    $0acc653c28085d6b$var$Lb = !1;
}
function $0acc653c28085d6b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $0acc653c28085d6b$var$Ob = !1, $0acc653c28085d6b$var$Pb = null, $0acc653c28085d6b$var$Qb = !1, $0acc653c28085d6b$var$Rb = null, $0acc653c28085d6b$var$Sb = {
    onError: function(a) {
        $0acc653c28085d6b$var$Ob = !0;
        $0acc653c28085d6b$var$Pb = a;
    }
};
function $0acc653c28085d6b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0acc653c28085d6b$var$Ob = !1;
    $0acc653c28085d6b$var$Pb = null;
    $0acc653c28085d6b$var$Nb.apply($0acc653c28085d6b$var$Sb, arguments);
}
function $0acc653c28085d6b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0acc653c28085d6b$var$Tb.apply(this, arguments);
    if ($0acc653c28085d6b$var$Ob) {
        if ($0acc653c28085d6b$var$Ob) {
            var l = $0acc653c28085d6b$var$Pb;
            $0acc653c28085d6b$var$Ob = !1;
            $0acc653c28085d6b$var$Pb = null;
        } else throw Error($0acc653c28085d6b$var$p(198));
        $0acc653c28085d6b$var$Qb || ($0acc653c28085d6b$var$Qb = !0, $0acc653c28085d6b$var$Rb = l);
    }
}
function $0acc653c28085d6b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0acc653c28085d6b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0acc653c28085d6b$var$Xb(a) {
    if ($0acc653c28085d6b$var$Vb(a) !== a) throw Error($0acc653c28085d6b$var$p(188));
}
function $0acc653c28085d6b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0acc653c28085d6b$var$Vb(a);
        if (null === b) throw Error($0acc653c28085d6b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0acc653c28085d6b$var$Xb(e), a;
                if (f === d) return $0acc653c28085d6b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0acc653c28085d6b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0acc653c28085d6b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0acc653c28085d6b$var$p(190));
    }
    if (3 !== c.tag) throw Error($0acc653c28085d6b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0acc653c28085d6b$var$Zb(a) {
    a = $0acc653c28085d6b$var$Yb(a);
    return null !== a ? $0acc653c28085d6b$var$$b(a) : null;
}
function $0acc653c28085d6b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0acc653c28085d6b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0acc653c28085d6b$var$ac = $2NwEO.unstable_scheduleCallback, $0acc653c28085d6b$var$bc = $2NwEO.unstable_cancelCallback, $0acc653c28085d6b$var$cc = $2NwEO.unstable_shouldYield, $0acc653c28085d6b$var$dc = $2NwEO.unstable_requestPaint, $0acc653c28085d6b$var$A = $2NwEO.unstable_now, $0acc653c28085d6b$var$ec = $2NwEO.unstable_getCurrentPriorityLevel, $0acc653c28085d6b$var$fc = $2NwEO.unstable_ImmediatePriority, $0acc653c28085d6b$var$gc = $2NwEO.unstable_UserBlockingPriority, $0acc653c28085d6b$var$hc = $2NwEO.unstable_NormalPriority, $0acc653c28085d6b$var$ic = $2NwEO.unstable_LowPriority, $0acc653c28085d6b$var$jc = $2NwEO.unstable_IdlePriority, $0acc653c28085d6b$var$kc = null, $0acc653c28085d6b$var$lc = null, $0acc653c28085d6b$var$B = null, $0acc653c28085d6b$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $0acc653c28085d6b$var$nc(a, b) {
    if ($0acc653c28085d6b$var$lc && "function" === typeof $0acc653c28085d6b$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $0acc653c28085d6b$var$fc;
                break;
            case 4:
                d = $0acc653c28085d6b$var$gc;
                break;
            case 16:
                d = $0acc653c28085d6b$var$hc;
                break;
            case 536870912:
                d = $0acc653c28085d6b$var$jc;
                break;
            default:
                d = $0acc653c28085d6b$var$hc;
        }
        $0acc653c28085d6b$var$lc.onCommitFiberRoot($0acc653c28085d6b$var$kc, a, d, c);
    } catch (e) {}
}
function $0acc653c28085d6b$var$oc(a) {
    $0acc653c28085d6b$var$B = a;
}
function $0acc653c28085d6b$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $0acc653c28085d6b$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $0acc653c28085d6b$var$rc() {
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markCommitStopped && $0acc653c28085d6b$var$B.markCommitStopped();
}
function $0acc653c28085d6b$var$sc(a) {
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentRenderStarted && $0acc653c28085d6b$var$B.markComponentRenderStarted(a);
}
function $0acc653c28085d6b$var$tc() {
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentRenderStopped && $0acc653c28085d6b$var$B.markComponentRenderStopped();
}
function $0acc653c28085d6b$var$uc(a) {
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentLayoutEffectUnmountStarted && $0acc653c28085d6b$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $0acc653c28085d6b$var$vc() {
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentLayoutEffectUnmountStopped && $0acc653c28085d6b$var$B.markComponentLayoutEffectUnmountStopped();
}
function $0acc653c28085d6b$var$wc(a) {
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markRenderStarted && $0acc653c28085d6b$var$B.markRenderStarted(a);
}
function $0acc653c28085d6b$var$xc() {
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markRenderStopped && $0acc653c28085d6b$var$B.markRenderStopped();
}
function $0acc653c28085d6b$var$yc(a, b) {
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markStateUpdateScheduled && $0acc653c28085d6b$var$B.markStateUpdateScheduled(a, b);
}
var $0acc653c28085d6b$var$Ac = Math.clz32 ? Math.clz32 : $0acc653c28085d6b$var$zc, $0acc653c28085d6b$var$Bc = Math.log, $0acc653c28085d6b$var$Cc = Math.LN2;
function $0acc653c28085d6b$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0acc653c28085d6b$var$Bc(a) / $0acc653c28085d6b$var$Cc | 0) | 0;
}
function $0acc653c28085d6b$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $0acc653c28085d6b$var$Dc = 64, $0acc653c28085d6b$var$Ec = 4194304;
function $0acc653c28085d6b$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0acc653c28085d6b$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0acc653c28085d6b$var$Fc(h) : (f &= g, 0 !== f && (d = $0acc653c28085d6b$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $0acc653c28085d6b$var$Fc(g) : 0 !== f && (d = $0acc653c28085d6b$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0acc653c28085d6b$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0acc653c28085d6b$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0acc653c28085d6b$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0acc653c28085d6b$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0acc653c28085d6b$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0acc653c28085d6b$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0acc653c28085d6b$var$Kc() {
    var a = $0acc653c28085d6b$var$Dc;
    $0acc653c28085d6b$var$Dc <<= 1;
    0 === ($0acc653c28085d6b$var$Dc & 4194240) && ($0acc653c28085d6b$var$Dc = 64);
    return a;
}
function $0acc653c28085d6b$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0acc653c28085d6b$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0acc653c28085d6b$var$Ac(b);
    a[b] = c;
}
function $0acc653c28085d6b$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0acc653c28085d6b$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0acc653c28085d6b$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0acc653c28085d6b$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $0acc653c28085d6b$var$Pc(a, b, c) {
    if ($0acc653c28085d6b$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $0acc653c28085d6b$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $0acc653c28085d6b$var$Qc(a, b) {
    if ($0acc653c28085d6b$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $0acc653c28085d6b$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $0acc653c28085d6b$var$E = 0;
function $0acc653c28085d6b$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0acc653c28085d6b$var$Sc, $0acc653c28085d6b$var$Tc, $0acc653c28085d6b$var$Uc, $0acc653c28085d6b$var$Vc, $0acc653c28085d6b$var$Wc, $0acc653c28085d6b$var$Xc = !1, $0acc653c28085d6b$var$Yc = [], $0acc653c28085d6b$var$Zc = null, $0acc653c28085d6b$var$$c = null, $0acc653c28085d6b$var$ad = null, $0acc653c28085d6b$var$bd = new Map, $0acc653c28085d6b$var$cd = new Map, $0acc653c28085d6b$var$dd = [], $0acc653c28085d6b$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0acc653c28085d6b$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0acc653c28085d6b$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0acc653c28085d6b$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $0acc653c28085d6b$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $0acc653c28085d6b$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0acc653c28085d6b$var$cd.delete(b.pointerId);
    }
}
function $0acc653c28085d6b$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0acc653c28085d6b$var$Cb(b), null !== b && $0acc653c28085d6b$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0acc653c28085d6b$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0acc653c28085d6b$var$Zc = $0acc653c28085d6b$var$gd($0acc653c28085d6b$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $0acc653c28085d6b$var$$c = $0acc653c28085d6b$var$gd($0acc653c28085d6b$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $0acc653c28085d6b$var$ad = $0acc653c28085d6b$var$gd($0acc653c28085d6b$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0acc653c28085d6b$var$bd.set(f, $0acc653c28085d6b$var$gd($0acc653c28085d6b$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0acc653c28085d6b$var$cd.set(f, $0acc653c28085d6b$var$gd($0acc653c28085d6b$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0acc653c28085d6b$var$id(a) {
    var b = $0acc653c28085d6b$var$jd(a.target);
    if (null !== b) {
        var c = $0acc653c28085d6b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0acc653c28085d6b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0acc653c28085d6b$var$Wc(a.priority, function() {
                        $0acc653c28085d6b$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0acc653c28085d6b$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0acc653c28085d6b$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0acc653c28085d6b$var$wb = d;
            c.target.dispatchEvent(d);
            $0acc653c28085d6b$var$wb = null;
        } else return b = $0acc653c28085d6b$var$Cb(c), null !== b && $0acc653c28085d6b$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0acc653c28085d6b$var$md(a, b, c) {
    $0acc653c28085d6b$var$kd(a) && c.delete(b);
}
function $0acc653c28085d6b$var$nd() {
    $0acc653c28085d6b$var$Xc = !1;
    null !== $0acc653c28085d6b$var$Zc && $0acc653c28085d6b$var$kd($0acc653c28085d6b$var$Zc) && ($0acc653c28085d6b$var$Zc = null);
    null !== $0acc653c28085d6b$var$$c && $0acc653c28085d6b$var$kd($0acc653c28085d6b$var$$c) && ($0acc653c28085d6b$var$$c = null);
    null !== $0acc653c28085d6b$var$ad && $0acc653c28085d6b$var$kd($0acc653c28085d6b$var$ad) && ($0acc653c28085d6b$var$ad = null);
    $0acc653c28085d6b$var$bd.forEach($0acc653c28085d6b$var$md);
    $0acc653c28085d6b$var$cd.forEach($0acc653c28085d6b$var$md);
}
function $0acc653c28085d6b$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0acc653c28085d6b$var$Xc || ($0acc653c28085d6b$var$Xc = !0, $2NwEO.unstable_scheduleCallback($2NwEO.unstable_NormalPriority, $0acc653c28085d6b$var$nd)));
}
function $0acc653c28085d6b$var$pd(a) {
    function b(b) {
        return $0acc653c28085d6b$var$od(b, a);
    }
    if (0 < $0acc653c28085d6b$var$Yc.length) {
        $0acc653c28085d6b$var$od($0acc653c28085d6b$var$Yc[0], a);
        for(var c = 1; c < $0acc653c28085d6b$var$Yc.length; c++){
            var d = $0acc653c28085d6b$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0acc653c28085d6b$var$Zc && $0acc653c28085d6b$var$od($0acc653c28085d6b$var$Zc, a);
    null !== $0acc653c28085d6b$var$$c && $0acc653c28085d6b$var$od($0acc653c28085d6b$var$$c, a);
    null !== $0acc653c28085d6b$var$ad && $0acc653c28085d6b$var$od($0acc653c28085d6b$var$ad, a);
    $0acc653c28085d6b$var$bd.forEach(b);
    $0acc653c28085d6b$var$cd.forEach(b);
    for(c = 0; c < $0acc653c28085d6b$var$dd.length; c++)d = $0acc653c28085d6b$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0acc653c28085d6b$var$dd.length && (c = $0acc653c28085d6b$var$dd[0], null === c.blockedOn);)$0acc653c28085d6b$var$id(c), null === c.blockedOn && $0acc653c28085d6b$var$dd.shift();
}
var $0acc653c28085d6b$var$qd = $0acc653c28085d6b$var$va.ReactCurrentBatchConfig, $0acc653c28085d6b$var$rd = !0;
function $0acc653c28085d6b$var$sd(a, b, c, d) {
    var e = $0acc653c28085d6b$var$E, f = $0acc653c28085d6b$var$qd.transition;
    $0acc653c28085d6b$var$qd.transition = null;
    try {
        $0acc653c28085d6b$var$E = 1, $0acc653c28085d6b$var$td(a, b, c, d);
    } finally{
        $0acc653c28085d6b$var$E = e, $0acc653c28085d6b$var$qd.transition = f;
    }
}
function $0acc653c28085d6b$var$ud(a, b, c, d) {
    var e = $0acc653c28085d6b$var$E, f = $0acc653c28085d6b$var$qd.transition;
    $0acc653c28085d6b$var$qd.transition = null;
    try {
        $0acc653c28085d6b$var$E = 4, $0acc653c28085d6b$var$td(a, b, c, d);
    } finally{
        $0acc653c28085d6b$var$E = e, $0acc653c28085d6b$var$qd.transition = f;
    }
}
function $0acc653c28085d6b$var$td(a, b, c, d) {
    if ($0acc653c28085d6b$var$rd) {
        var e = $0acc653c28085d6b$var$ld(a, b, c, d);
        if (null === e) $0acc653c28085d6b$var$vd(a, b, d, $0acc653c28085d6b$var$wd, c), $0acc653c28085d6b$var$fd(a, d);
        else if ($0acc653c28085d6b$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($0acc653c28085d6b$var$fd(a, d), b & 4 && -1 < $0acc653c28085d6b$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $0acc653c28085d6b$var$Cb(e);
                null !== f && $0acc653c28085d6b$var$Sc(f);
                f = $0acc653c28085d6b$var$ld(a, b, c, d);
                null === f && $0acc653c28085d6b$var$vd(a, b, d, $0acc653c28085d6b$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0acc653c28085d6b$var$vd(a, b, d, null, c);
    }
}
var $0acc653c28085d6b$var$wd = null;
function $0acc653c28085d6b$var$ld(a, b, c, d) {
    $0acc653c28085d6b$var$wd = null;
    a = $0acc653c28085d6b$var$xb(d);
    a = $0acc653c28085d6b$var$jd(a);
    if (null !== a) {
        if (b = $0acc653c28085d6b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0acc653c28085d6b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0acc653c28085d6b$var$wd = a;
    return null;
}
function $0acc653c28085d6b$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0acc653c28085d6b$var$ec()){
                case $0acc653c28085d6b$var$fc:
                    return 1;
                case $0acc653c28085d6b$var$gc:
                    return 4;
                case $0acc653c28085d6b$var$hc:
                case $0acc653c28085d6b$var$ic:
                    return 16;
                case $0acc653c28085d6b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0acc653c28085d6b$var$yd = null, $0acc653c28085d6b$var$zd = null, $0acc653c28085d6b$var$Ad = null;
function $0acc653c28085d6b$var$Bd() {
    if ($0acc653c28085d6b$var$Ad) return $0acc653c28085d6b$var$Ad;
    var a, b = $0acc653c28085d6b$var$zd, c = b.length, d, e = "value" in $0acc653c28085d6b$var$yd ? $0acc653c28085d6b$var$yd.value : $0acc653c28085d6b$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0acc653c28085d6b$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0acc653c28085d6b$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0acc653c28085d6b$var$Dd() {
    return !0;
}
function $0acc653c28085d6b$var$Ed() {
    return !1;
}
function $0acc653c28085d6b$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0acc653c28085d6b$var$Dd : $0acc653c28085d6b$var$Ed;
        this.isPropagationStopped = $0acc653c28085d6b$var$Ed;
        return this;
    }
    $0acc653c28085d6b$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0acc653c28085d6b$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0acc653c28085d6b$var$Dd);
        },
        persist: function() {},
        isPersistent: $0acc653c28085d6b$var$Dd
    });
    return b;
}
var $0acc653c28085d6b$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0acc653c28085d6b$var$Hd = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$Gd), $0acc653c28085d6b$var$Id = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Gd, {
    view: 0,
    detail: 0
}), $0acc653c28085d6b$var$Jd = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$Id), $0acc653c28085d6b$var$Kd, $0acc653c28085d6b$var$Ld, $0acc653c28085d6b$var$Md, $0acc653c28085d6b$var$Od = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0acc653c28085d6b$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0acc653c28085d6b$var$Md && ($0acc653c28085d6b$var$Md && "mousemove" === a.type ? ($0acc653c28085d6b$var$Kd = a.screenX - $0acc653c28085d6b$var$Md.screenX, $0acc653c28085d6b$var$Ld = a.screenY - $0acc653c28085d6b$var$Md.screenY) : $0acc653c28085d6b$var$Ld = $0acc653c28085d6b$var$Kd = 0, $0acc653c28085d6b$var$Md = a);
        return $0acc653c28085d6b$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0acc653c28085d6b$var$Ld;
    }
}), $0acc653c28085d6b$var$Pd = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$Od), $0acc653c28085d6b$var$Qd = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Od, {
    dataTransfer: 0
}), $0acc653c28085d6b$var$Rd = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$Qd), $0acc653c28085d6b$var$Sd = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Id, {
    relatedTarget: 0
}), $0acc653c28085d6b$var$Td = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$Sd), $0acc653c28085d6b$var$Ud = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0acc653c28085d6b$var$Vd = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$Ud), $0acc653c28085d6b$var$Wd = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0acc653c28085d6b$var$Xd = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$Wd), $0acc653c28085d6b$var$Yd = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Gd, {
    data: 0
}), $0acc653c28085d6b$var$Zd = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$Yd), $0acc653c28085d6b$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0acc653c28085d6b$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0acc653c28085d6b$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0acc653c28085d6b$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0acc653c28085d6b$var$be[a]) ? !!b[a] : !1;
}
function $0acc653c28085d6b$var$Nd() {
    return $0acc653c28085d6b$var$ce;
}
var $0acc653c28085d6b$var$de = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $0acc653c28085d6b$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0acc653c28085d6b$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0acc653c28085d6b$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0acc653c28085d6b$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $0acc653c28085d6b$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0acc653c28085d6b$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0acc653c28085d6b$var$ee = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$de), $0acc653c28085d6b$var$fe = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0acc653c28085d6b$var$ge = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$fe), $0acc653c28085d6b$var$he = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0acc653c28085d6b$var$Nd
}), $0acc653c28085d6b$var$ie = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$he), $0acc653c28085d6b$var$je = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0acc653c28085d6b$var$ke = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$je), $0acc653c28085d6b$var$le = $0acc653c28085d6b$var$u({}, $0acc653c28085d6b$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0acc653c28085d6b$var$me = $0acc653c28085d6b$var$Fd($0acc653c28085d6b$var$le), $0acc653c28085d6b$var$ne = [
    9,
    13,
    27,
    32
], $0acc653c28085d6b$var$oe = $0acc653c28085d6b$var$ia && "CompositionEvent" in window, $0acc653c28085d6b$var$pe = null;
$0acc653c28085d6b$var$ia && "documentMode" in document && ($0acc653c28085d6b$var$pe = document.documentMode);
var $0acc653c28085d6b$var$qe = $0acc653c28085d6b$var$ia && "TextEvent" in window && !$0acc653c28085d6b$var$pe, $0acc653c28085d6b$var$re = $0acc653c28085d6b$var$ia && (!$0acc653c28085d6b$var$oe || $0acc653c28085d6b$var$pe && 8 < $0acc653c28085d6b$var$pe && 11 >= $0acc653c28085d6b$var$pe), $0acc653c28085d6b$var$se = String.fromCharCode(32), $0acc653c28085d6b$var$te = !1;
function $0acc653c28085d6b$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0acc653c28085d6b$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0acc653c28085d6b$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0acc653c28085d6b$var$we = !1;
function $0acc653c28085d6b$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $0acc653c28085d6b$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0acc653c28085d6b$var$te = !0;
            return $0acc653c28085d6b$var$se;
        case "textInput":
            return a = b.data, a === $0acc653c28085d6b$var$se && $0acc653c28085d6b$var$te ? null : a;
        default:
            return null;
    }
}
function $0acc653c28085d6b$var$ye(a, b) {
    if ($0acc653c28085d6b$var$we) return "compositionend" === a || !$0acc653c28085d6b$var$oe && $0acc653c28085d6b$var$ue(a, b) ? (a = $0acc653c28085d6b$var$Bd(), $0acc653c28085d6b$var$Ad = $0acc653c28085d6b$var$zd = $0acc653c28085d6b$var$yd = null, $0acc653c28085d6b$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0acc653c28085d6b$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0acc653c28085d6b$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0acc653c28085d6b$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0acc653c28085d6b$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $0acc653c28085d6b$var$Be(a, b, c, d) {
    $0acc653c28085d6b$var$Eb(d);
    b = $0acc653c28085d6b$var$Ce(b, "onChange");
    0 < b.length && (c = new $0acc653c28085d6b$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0acc653c28085d6b$var$De = null, $0acc653c28085d6b$var$Ee = null;
function $0acc653c28085d6b$var$Fe(a) {
    $0acc653c28085d6b$var$Ge(a, 0);
}
function $0acc653c28085d6b$var$He(a) {
    var b = $0acc653c28085d6b$var$Ie(a);
    if ($0acc653c28085d6b$var$Wa(b)) return a;
}
function $0acc653c28085d6b$var$Je(a, b) {
    if ("change" === a) return b;
}
var $0acc653c28085d6b$var$Ke = !1;
if ($0acc653c28085d6b$var$ia) {
    var $0acc653c28085d6b$var$Le;
    if ($0acc653c28085d6b$var$ia) {
        var $0acc653c28085d6b$var$Me = "oninput" in document;
        if (!$0acc653c28085d6b$var$Me) {
            var $0acc653c28085d6b$var$Ne = document.createElement("div");
            $0acc653c28085d6b$var$Ne.setAttribute("oninput", "return;");
            $0acc653c28085d6b$var$Me = "function" === typeof $0acc653c28085d6b$var$Ne.oninput;
        }
        $0acc653c28085d6b$var$Le = $0acc653c28085d6b$var$Me;
    } else $0acc653c28085d6b$var$Le = !1;
    $0acc653c28085d6b$var$Ke = $0acc653c28085d6b$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $0acc653c28085d6b$var$Oe() {
    $0acc653c28085d6b$var$De && ($0acc653c28085d6b$var$De.detachEvent("onpropertychange", $0acc653c28085d6b$var$Pe), $0acc653c28085d6b$var$Ee = $0acc653c28085d6b$var$De = null);
}
function $0acc653c28085d6b$var$Pe(a) {
    if ("value" === a.propertyName && $0acc653c28085d6b$var$He($0acc653c28085d6b$var$Ee)) {
        var b = [];
        $0acc653c28085d6b$var$Be(b, $0acc653c28085d6b$var$Ee, a, $0acc653c28085d6b$var$xb(a));
        $0acc653c28085d6b$var$Jb($0acc653c28085d6b$var$Fe, b);
    }
}
function $0acc653c28085d6b$var$Qe(a, b, c) {
    "focusin" === a ? ($0acc653c28085d6b$var$Oe(), $0acc653c28085d6b$var$De = b, $0acc653c28085d6b$var$Ee = c, $0acc653c28085d6b$var$De.attachEvent("onpropertychange", $0acc653c28085d6b$var$Pe)) : "focusout" === a && $0acc653c28085d6b$var$Oe();
}
function $0acc653c28085d6b$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0acc653c28085d6b$var$He($0acc653c28085d6b$var$Ee);
}
function $0acc653c28085d6b$var$Se(a, b) {
    if ("click" === a) return $0acc653c28085d6b$var$He(b);
}
function $0acc653c28085d6b$var$Te(a, b) {
    if ("input" === a || "change" === a) return $0acc653c28085d6b$var$He(b);
}
function $0acc653c28085d6b$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0acc653c28085d6b$var$Ve = "function" === typeof Object.is ? Object.is : $0acc653c28085d6b$var$Ue;
function $0acc653c28085d6b$var$We(a, b) {
    if ($0acc653c28085d6b$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0acc653c28085d6b$var$ja.call(b, e) || !$0acc653c28085d6b$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $0acc653c28085d6b$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0acc653c28085d6b$var$Ye(a, b) {
    var c = $0acc653c28085d6b$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0acc653c28085d6b$var$Xe(c);
    }
}
function $0acc653c28085d6b$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0acc653c28085d6b$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0acc653c28085d6b$var$$e() {
    for(var a = window, b = $0acc653c28085d6b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0acc653c28085d6b$var$Xa(a.document);
    }
    return b;
}
function $0acc653c28085d6b$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0acc653c28085d6b$var$bf(a) {
    var b = $0acc653c28085d6b$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0acc653c28085d6b$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0acc653c28085d6b$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0acc653c28085d6b$var$Ye(c, f);
                var g = $0acc653c28085d6b$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0acc653c28085d6b$var$cf = $0acc653c28085d6b$var$ia && "documentMode" in document && 11 >= document.documentMode, $0acc653c28085d6b$var$df = null, $0acc653c28085d6b$var$ef = null, $0acc653c28085d6b$var$ff = null, $0acc653c28085d6b$var$gf = !1;
function $0acc653c28085d6b$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0acc653c28085d6b$var$gf || null == $0acc653c28085d6b$var$df || $0acc653c28085d6b$var$df !== $0acc653c28085d6b$var$Xa(d) || (d = $0acc653c28085d6b$var$df, "selectionStart" in d && $0acc653c28085d6b$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0acc653c28085d6b$var$ff && $0acc653c28085d6b$var$We($0acc653c28085d6b$var$ff, d) || ($0acc653c28085d6b$var$ff = d, d = $0acc653c28085d6b$var$Ce($0acc653c28085d6b$var$ef, "onSelect"), 0 < d.length && (b = new $0acc653c28085d6b$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0acc653c28085d6b$var$df)));
}
function $0acc653c28085d6b$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0acc653c28085d6b$var$kf = {
    animationend: $0acc653c28085d6b$var$jf("Animation", "AnimationEnd"),
    animationiteration: $0acc653c28085d6b$var$jf("Animation", "AnimationIteration"),
    animationstart: $0acc653c28085d6b$var$jf("Animation", "AnimationStart"),
    transitionend: $0acc653c28085d6b$var$jf("Transition", "TransitionEnd")
}, $0acc653c28085d6b$var$lf = {}, $0acc653c28085d6b$var$mf = {};
$0acc653c28085d6b$var$ia && ($0acc653c28085d6b$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $0acc653c28085d6b$var$kf.animationend.animation, delete $0acc653c28085d6b$var$kf.animationiteration.animation, delete $0acc653c28085d6b$var$kf.animationstart.animation), "TransitionEvent" in window || delete $0acc653c28085d6b$var$kf.transitionend.transition);
function $0acc653c28085d6b$var$nf(a) {
    if ($0acc653c28085d6b$var$lf[a]) return $0acc653c28085d6b$var$lf[a];
    if (!$0acc653c28085d6b$var$kf[a]) return a;
    var b = $0acc653c28085d6b$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0acc653c28085d6b$var$mf) return $0acc653c28085d6b$var$lf[a] = b[c];
    return a;
}
var $0acc653c28085d6b$var$of = $0acc653c28085d6b$var$nf("animationend"), $0acc653c28085d6b$var$pf = $0acc653c28085d6b$var$nf("animationiteration"), $0acc653c28085d6b$var$qf = $0acc653c28085d6b$var$nf("animationstart"), $0acc653c28085d6b$var$rf = $0acc653c28085d6b$var$nf("transitionend"), $0acc653c28085d6b$var$sf = new Map, $0acc653c28085d6b$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0acc653c28085d6b$var$uf(a, b) {
    $0acc653c28085d6b$var$sf.set(a, b);
    $0acc653c28085d6b$var$fa(b, [
        a
    ]);
}
for(var $0acc653c28085d6b$var$vf = 0; $0acc653c28085d6b$var$vf < $0acc653c28085d6b$var$tf.length; $0acc653c28085d6b$var$vf++){
    var $0acc653c28085d6b$var$wf = $0acc653c28085d6b$var$tf[$0acc653c28085d6b$var$vf], $0acc653c28085d6b$var$xf = $0acc653c28085d6b$var$wf.toLowerCase(), $0acc653c28085d6b$var$yf = $0acc653c28085d6b$var$wf[0].toUpperCase() + $0acc653c28085d6b$var$wf.slice(1);
    $0acc653c28085d6b$var$uf($0acc653c28085d6b$var$xf, "on" + $0acc653c28085d6b$var$yf);
}
$0acc653c28085d6b$var$uf($0acc653c28085d6b$var$of, "onAnimationEnd");
$0acc653c28085d6b$var$uf($0acc653c28085d6b$var$pf, "onAnimationIteration");
$0acc653c28085d6b$var$uf($0acc653c28085d6b$var$qf, "onAnimationStart");
$0acc653c28085d6b$var$uf("dblclick", "onDoubleClick");
$0acc653c28085d6b$var$uf("focusin", "onFocus");
$0acc653c28085d6b$var$uf("focusout", "onBlur");
$0acc653c28085d6b$var$uf($0acc653c28085d6b$var$rf, "onTransitionEnd");
$0acc653c28085d6b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0acc653c28085d6b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0acc653c28085d6b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0acc653c28085d6b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0acc653c28085d6b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0acc653c28085d6b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0acc653c28085d6b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0acc653c28085d6b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0acc653c28085d6b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0acc653c28085d6b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0acc653c28085d6b$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0acc653c28085d6b$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($0acc653c28085d6b$var$zf));
function $0acc653c28085d6b$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0acc653c28085d6b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0acc653c28085d6b$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0acc653c28085d6b$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0acc653c28085d6b$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($0acc653c28085d6b$var$Qb) throw a = $0acc653c28085d6b$var$Rb, $0acc653c28085d6b$var$Qb = !1, $0acc653c28085d6b$var$Rb = null, a;
}
function $0acc653c28085d6b$var$F(a, b) {
    var c = b[$0acc653c28085d6b$var$Cf];
    void 0 === c && (c = b[$0acc653c28085d6b$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0acc653c28085d6b$var$Df(b, a, 2, !1), c.add(d));
}
function $0acc653c28085d6b$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0acc653c28085d6b$var$Df(c, a, d, b);
}
var $0acc653c28085d6b$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $0acc653c28085d6b$var$Gf(a) {
    if (!a[$0acc653c28085d6b$var$Ff]) {
        a[$0acc653c28085d6b$var$Ff] = !0;
        $0acc653c28085d6b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0acc653c28085d6b$var$Af.has(b) || $0acc653c28085d6b$var$Ef(b, !1, a), $0acc653c28085d6b$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0acc653c28085d6b$var$Ff] || (b[$0acc653c28085d6b$var$Ff] = !0, $0acc653c28085d6b$var$Ef("selectionchange", !1, b));
    }
}
function $0acc653c28085d6b$var$Df(a, b, c, d) {
    switch($0acc653c28085d6b$var$xd(b)){
        case 1:
            var e = $0acc653c28085d6b$var$sd;
            break;
        case 4:
            e = $0acc653c28085d6b$var$ud;
            break;
        default:
            e = $0acc653c28085d6b$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0acc653c28085d6b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0acc653c28085d6b$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0acc653c28085d6b$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0acc653c28085d6b$var$Jb(function() {
        var d = f, e = $0acc653c28085d6b$var$xb(c), g = [];
        a: {
            var h = $0acc653c28085d6b$var$sf.get(a);
            if (void 0 !== h) {
                var k = $0acc653c28085d6b$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $0acc653c28085d6b$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0acc653c28085d6b$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $0acc653c28085d6b$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $0acc653c28085d6b$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0acc653c28085d6b$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0acc653c28085d6b$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0acc653c28085d6b$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0acc653c28085d6b$var$ie;
                        break;
                    case $0acc653c28085d6b$var$of:
                    case $0acc653c28085d6b$var$pf:
                    case $0acc653c28085d6b$var$qf:
                        k = $0acc653c28085d6b$var$Vd;
                        break;
                    case $0acc653c28085d6b$var$rf:
                        k = $0acc653c28085d6b$var$ke;
                        break;
                    case "scroll":
                        k = $0acc653c28085d6b$var$Jd;
                        break;
                    case "wheel":
                        k = $0acc653c28085d6b$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0acc653c28085d6b$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0acc653c28085d6b$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $0acc653c28085d6b$var$Kb(y, x), null != D && w.push($0acc653c28085d6b$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0acc653c28085d6b$var$wb && (m = c.relatedTarget || c.fromElement) && ($0acc653c28085d6b$var$jd(m) || m[$0acc653c28085d6b$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $0acc653c28085d6b$var$jd(m) : null, null !== m && (C = $0acc653c28085d6b$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $0acc653c28085d6b$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $0acc653c28085d6b$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $0acc653c28085d6b$var$Ie(k);
                        v = null == m ? h : $0acc653c28085d6b$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $0acc653c28085d6b$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $0acc653c28085d6b$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $0acc653c28085d6b$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $0acc653c28085d6b$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $0acc653c28085d6b$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $0acc653c28085d6b$var$Jf(w);
                                x = $0acc653c28085d6b$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $0acc653c28085d6b$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $0acc653c28085d6b$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $0acc653c28085d6b$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $0acc653c28085d6b$var$Je;
                else if ($0acc653c28085d6b$var$Ae(h)) {
                    if ($0acc653c28085d6b$var$Ke) ca = $0acc653c28085d6b$var$Te;
                    else {
                        ca = $0acc653c28085d6b$var$Re;
                        var R = $0acc653c28085d6b$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $0acc653c28085d6b$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $0acc653c28085d6b$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $0acc653c28085d6b$var$bb(h, "number", h.value);
            }
            R = d ? $0acc653c28085d6b$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($0acc653c28085d6b$var$Ae(R) || "true" === R.contentEditable) $0acc653c28085d6b$var$df = R, $0acc653c28085d6b$var$ef = d, $0acc653c28085d6b$var$ff = null;
                    break;
                case "focusout":
                    $0acc653c28085d6b$var$ff = $0acc653c28085d6b$var$ef = $0acc653c28085d6b$var$df = null;
                    break;
                case "mousedown":
                    $0acc653c28085d6b$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0acc653c28085d6b$var$gf = !1;
                    $0acc653c28085d6b$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($0acc653c28085d6b$var$cf) break;
                case "keydown":
                case "keyup":
                    $0acc653c28085d6b$var$hf(g, c, e);
            }
            var sa;
            if ($0acc653c28085d6b$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $0acc653c28085d6b$var$we ? $0acc653c28085d6b$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($0acc653c28085d6b$var$re && "ko" !== c.locale && ($0acc653c28085d6b$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $0acc653c28085d6b$var$we && (sa = $0acc653c28085d6b$var$Bd()) : ($0acc653c28085d6b$var$yd = e, $0acc653c28085d6b$var$zd = "value" in $0acc653c28085d6b$var$yd ? $0acc653c28085d6b$var$yd.value : $0acc653c28085d6b$var$yd.textContent, $0acc653c28085d6b$var$we = !0)), R = $0acc653c28085d6b$var$Ce(d, V), 0 < R.length && (V = new $0acc653c28085d6b$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $0acc653c28085d6b$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $0acc653c28085d6b$var$qe ? $0acc653c28085d6b$var$xe(a, c) : $0acc653c28085d6b$var$ye(a, c)) d = $0acc653c28085d6b$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $0acc653c28085d6b$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $0acc653c28085d6b$var$Ge(g, b);
    });
}
function $0acc653c28085d6b$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0acc653c28085d6b$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0acc653c28085d6b$var$Kb(a, c), null != f && d.unshift($0acc653c28085d6b$var$Hf(a, f, e)), f = $0acc653c28085d6b$var$Kb(a, b), null != f && d.push($0acc653c28085d6b$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0acc653c28085d6b$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0acc653c28085d6b$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0acc653c28085d6b$var$Kb(c, f), null != k && g.unshift($0acc653c28085d6b$var$Hf(c, k, h))) : e || (k = $0acc653c28085d6b$var$Kb(c, f), null != k && g.push($0acc653c28085d6b$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0acc653c28085d6b$var$Lf = /\r\n?/g, $0acc653c28085d6b$var$Mf = /\u0000|\uFFFD/g;
function $0acc653c28085d6b$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0acc653c28085d6b$var$Lf, "\n").replace($0acc653c28085d6b$var$Mf, "");
}
function $0acc653c28085d6b$var$Of(a, b, c) {
    b = $0acc653c28085d6b$var$Nf(b);
    if ($0acc653c28085d6b$var$Nf(a) !== b && c) throw Error($0acc653c28085d6b$var$p(425));
}
function $0acc653c28085d6b$var$Pf() {}
var $0acc653c28085d6b$var$Qf = null, $0acc653c28085d6b$var$Rf = null;
function $0acc653c28085d6b$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0acc653c28085d6b$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $0acc653c28085d6b$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0acc653c28085d6b$var$Vf = "function" === typeof Promise ? Promise : void 0, $0acc653c28085d6b$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0acc653c28085d6b$var$Vf ? function(a) {
    return $0acc653c28085d6b$var$Vf.resolve(null).then(a).catch($0acc653c28085d6b$var$Wf);
} : $0acc653c28085d6b$var$Tf;
function $0acc653c28085d6b$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0acc653c28085d6b$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0acc653c28085d6b$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0acc653c28085d6b$var$pd(b);
}
function $0acc653c28085d6b$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0acc653c28085d6b$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0acc653c28085d6b$var$ag = Math.random().toString(36).slice(2), $0acc653c28085d6b$var$bg = "__reactFiber$" + $0acc653c28085d6b$var$ag, $0acc653c28085d6b$var$cg = "__reactProps$" + $0acc653c28085d6b$var$ag, $0acc653c28085d6b$var$If = "__reactContainer$" + $0acc653c28085d6b$var$ag, $0acc653c28085d6b$var$Cf = "__reactEvents$" + $0acc653c28085d6b$var$ag, $0acc653c28085d6b$var$dg = "__reactListeners$" + $0acc653c28085d6b$var$ag, $0acc653c28085d6b$var$eg = "__reactHandles$" + $0acc653c28085d6b$var$ag;
function $0acc653c28085d6b$var$jd(a) {
    var b = a[$0acc653c28085d6b$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0acc653c28085d6b$var$If] || c[$0acc653c28085d6b$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0acc653c28085d6b$var$$f(a); null !== a;){
                if (c = a[$0acc653c28085d6b$var$bg]) return c;
                a = $0acc653c28085d6b$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0acc653c28085d6b$var$Cb(a) {
    a = a[$0acc653c28085d6b$var$bg] || a[$0acc653c28085d6b$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0acc653c28085d6b$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0acc653c28085d6b$var$p(33));
}
function $0acc653c28085d6b$var$Db(a) {
    return a[$0acc653c28085d6b$var$cg] || null;
}
var $0acc653c28085d6b$var$fg = [], $0acc653c28085d6b$var$gg = -1;
function $0acc653c28085d6b$var$hg(a) {
    return {
        current: a
    };
}
function $0acc653c28085d6b$var$G(a) {
    0 > $0acc653c28085d6b$var$gg || (a.current = $0acc653c28085d6b$var$fg[$0acc653c28085d6b$var$gg], $0acc653c28085d6b$var$fg[$0acc653c28085d6b$var$gg] = null, $0acc653c28085d6b$var$gg--);
}
function $0acc653c28085d6b$var$H(a, b) {
    $0acc653c28085d6b$var$gg++;
    $0acc653c28085d6b$var$fg[$0acc653c28085d6b$var$gg] = a.current;
    a.current = b;
}
var $0acc653c28085d6b$var$ig = {}, $0acc653c28085d6b$var$I = $0acc653c28085d6b$var$hg($0acc653c28085d6b$var$ig), $0acc653c28085d6b$var$jg = $0acc653c28085d6b$var$hg(!1), $0acc653c28085d6b$var$kg = $0acc653c28085d6b$var$ig;
function $0acc653c28085d6b$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0acc653c28085d6b$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0acc653c28085d6b$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0acc653c28085d6b$var$ng() {
    $0acc653c28085d6b$var$G($0acc653c28085d6b$var$jg);
    $0acc653c28085d6b$var$G($0acc653c28085d6b$var$I);
}
function $0acc653c28085d6b$var$og(a, b, c) {
    if ($0acc653c28085d6b$var$I.current !== $0acc653c28085d6b$var$ig) throw Error($0acc653c28085d6b$var$p(168));
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$I, b);
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$jg, c);
}
function $0acc653c28085d6b$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0acc653c28085d6b$var$p(108, $0acc653c28085d6b$var$Ra(a) || "Unknown", e));
    return $0acc653c28085d6b$var$u({}, c, d);
}
function $0acc653c28085d6b$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0acc653c28085d6b$var$ig;
    $0acc653c28085d6b$var$kg = $0acc653c28085d6b$var$I.current;
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$I, a);
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$jg, $0acc653c28085d6b$var$jg.current);
    return !0;
}
function $0acc653c28085d6b$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0acc653c28085d6b$var$p(169));
    c ? (a = $0acc653c28085d6b$var$pg(a, b, $0acc653c28085d6b$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $0acc653c28085d6b$var$G($0acc653c28085d6b$var$jg), $0acc653c28085d6b$var$G($0acc653c28085d6b$var$I), $0acc653c28085d6b$var$H($0acc653c28085d6b$var$I, a)) : $0acc653c28085d6b$var$G($0acc653c28085d6b$var$jg);
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$jg, c);
}
var $0acc653c28085d6b$var$sg = null, $0acc653c28085d6b$var$tg = !1, $0acc653c28085d6b$var$ug = !1;
function $0acc653c28085d6b$var$vg(a) {
    null === $0acc653c28085d6b$var$sg ? $0acc653c28085d6b$var$sg = [
        a
    ] : $0acc653c28085d6b$var$sg.push(a);
}
function $0acc653c28085d6b$var$wg(a) {
    $0acc653c28085d6b$var$tg = !0;
    $0acc653c28085d6b$var$vg(a);
}
function $0acc653c28085d6b$var$xg() {
    if (!$0acc653c28085d6b$var$ug && null !== $0acc653c28085d6b$var$sg) {
        $0acc653c28085d6b$var$ug = !0;
        var a = 0, b = $0acc653c28085d6b$var$E;
        try {
            var c = $0acc653c28085d6b$var$sg;
            for($0acc653c28085d6b$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0acc653c28085d6b$var$sg = null;
            $0acc653c28085d6b$var$tg = !1;
        } catch (e) {
            throw null !== $0acc653c28085d6b$var$sg && ($0acc653c28085d6b$var$sg = $0acc653c28085d6b$var$sg.slice(a + 1)), $0acc653c28085d6b$var$ac($0acc653c28085d6b$var$fc, $0acc653c28085d6b$var$xg), e;
        } finally{
            $0acc653c28085d6b$var$E = b, $0acc653c28085d6b$var$ug = !1;
        }
    }
    return null;
}
var $0acc653c28085d6b$var$yg = [], $0acc653c28085d6b$var$zg = 0, $0acc653c28085d6b$var$Ag = null, $0acc653c28085d6b$var$Bg = 0, $0acc653c28085d6b$var$Cg = [], $0acc653c28085d6b$var$Dg = 0, $0acc653c28085d6b$var$Eg = null, $0acc653c28085d6b$var$Fg = 1, $0acc653c28085d6b$var$Gg = "";
function $0acc653c28085d6b$var$Hg(a, b) {
    $0acc653c28085d6b$var$yg[$0acc653c28085d6b$var$zg++] = $0acc653c28085d6b$var$Bg;
    $0acc653c28085d6b$var$yg[$0acc653c28085d6b$var$zg++] = $0acc653c28085d6b$var$Ag;
    $0acc653c28085d6b$var$Ag = a;
    $0acc653c28085d6b$var$Bg = b;
}
function $0acc653c28085d6b$var$Ig(a, b, c) {
    $0acc653c28085d6b$var$Cg[$0acc653c28085d6b$var$Dg++] = $0acc653c28085d6b$var$Fg;
    $0acc653c28085d6b$var$Cg[$0acc653c28085d6b$var$Dg++] = $0acc653c28085d6b$var$Gg;
    $0acc653c28085d6b$var$Cg[$0acc653c28085d6b$var$Dg++] = $0acc653c28085d6b$var$Eg;
    $0acc653c28085d6b$var$Eg = a;
    var d = $0acc653c28085d6b$var$Fg;
    a = $0acc653c28085d6b$var$Gg;
    var e = 32 - $0acc653c28085d6b$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0acc653c28085d6b$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0acc653c28085d6b$var$Fg = 1 << 32 - $0acc653c28085d6b$var$Ac(b) + e | c << e | d;
        $0acc653c28085d6b$var$Gg = f + a;
    } else $0acc653c28085d6b$var$Fg = 1 << f | c << e | d, $0acc653c28085d6b$var$Gg = a;
}
function $0acc653c28085d6b$var$Jg(a) {
    null !== a.return && ($0acc653c28085d6b$var$Hg(a, 1), $0acc653c28085d6b$var$Ig(a, 1, 0));
}
function $0acc653c28085d6b$var$Kg(a) {
    for(; a === $0acc653c28085d6b$var$Ag;)$0acc653c28085d6b$var$Ag = $0acc653c28085d6b$var$yg[--$0acc653c28085d6b$var$zg], $0acc653c28085d6b$var$yg[$0acc653c28085d6b$var$zg] = null, $0acc653c28085d6b$var$Bg = $0acc653c28085d6b$var$yg[--$0acc653c28085d6b$var$zg], $0acc653c28085d6b$var$yg[$0acc653c28085d6b$var$zg] = null;
    for(; a === $0acc653c28085d6b$var$Eg;)$0acc653c28085d6b$var$Eg = $0acc653c28085d6b$var$Cg[--$0acc653c28085d6b$var$Dg], $0acc653c28085d6b$var$Cg[$0acc653c28085d6b$var$Dg] = null, $0acc653c28085d6b$var$Gg = $0acc653c28085d6b$var$Cg[--$0acc653c28085d6b$var$Dg], $0acc653c28085d6b$var$Cg[$0acc653c28085d6b$var$Dg] = null, $0acc653c28085d6b$var$Fg = $0acc653c28085d6b$var$Cg[--$0acc653c28085d6b$var$Dg], $0acc653c28085d6b$var$Cg[$0acc653c28085d6b$var$Dg] = null;
}
var $0acc653c28085d6b$var$Lg = null, $0acc653c28085d6b$var$Mg = null, $0acc653c28085d6b$var$J = !1, $0acc653c28085d6b$var$Ng = null;
function $0acc653c28085d6b$var$Og(a, b) {
    var c = $0acc653c28085d6b$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0acc653c28085d6b$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0acc653c28085d6b$var$Lg = a, $0acc653c28085d6b$var$Mg = $0acc653c28085d6b$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0acc653c28085d6b$var$Lg = a, $0acc653c28085d6b$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0acc653c28085d6b$var$Eg ? {
                id: $0acc653c28085d6b$var$Fg,
                overflow: $0acc653c28085d6b$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0acc653c28085d6b$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0acc653c28085d6b$var$Lg = a, $0acc653c28085d6b$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0acc653c28085d6b$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0acc653c28085d6b$var$Sg(a) {
    if ($0acc653c28085d6b$var$J) {
        var b = $0acc653c28085d6b$var$Mg;
        if (b) {
            var c = b;
            if (!$0acc653c28085d6b$var$Qg(a, b)) {
                if ($0acc653c28085d6b$var$Rg(a)) throw Error($0acc653c28085d6b$var$p(418));
                b = $0acc653c28085d6b$var$Zf(c.nextSibling);
                var d = $0acc653c28085d6b$var$Lg;
                b && $0acc653c28085d6b$var$Qg(a, b) ? $0acc653c28085d6b$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $0acc653c28085d6b$var$J = !1, $0acc653c28085d6b$var$Lg = a);
            }
        } else {
            if ($0acc653c28085d6b$var$Rg(a)) throw Error($0acc653c28085d6b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0acc653c28085d6b$var$J = !1;
            $0acc653c28085d6b$var$Lg = a;
        }
    }
}
function $0acc653c28085d6b$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0acc653c28085d6b$var$Lg = a;
}
function $0acc653c28085d6b$var$Ug(a) {
    if (a !== $0acc653c28085d6b$var$Lg) return !1;
    if (!$0acc653c28085d6b$var$J) return $0acc653c28085d6b$var$Tg(a), $0acc653c28085d6b$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0acc653c28085d6b$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $0acc653c28085d6b$var$Mg)) {
        if ($0acc653c28085d6b$var$Rg(a)) throw $0acc653c28085d6b$var$Vg(), Error($0acc653c28085d6b$var$p(418));
        for(; b;)$0acc653c28085d6b$var$Og(a, b), b = $0acc653c28085d6b$var$Zf(b.nextSibling);
    }
    $0acc653c28085d6b$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0acc653c28085d6b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0acc653c28085d6b$var$Mg = $0acc653c28085d6b$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0acc653c28085d6b$var$Mg = null;
        }
    } else $0acc653c28085d6b$var$Mg = $0acc653c28085d6b$var$Lg ? $0acc653c28085d6b$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0acc653c28085d6b$var$Vg() {
    for(var a = $0acc653c28085d6b$var$Mg; a;)a = $0acc653c28085d6b$var$Zf(a.nextSibling);
}
function $0acc653c28085d6b$var$Wg() {
    $0acc653c28085d6b$var$Mg = $0acc653c28085d6b$var$Lg = null;
    $0acc653c28085d6b$var$J = !1;
}
function $0acc653c28085d6b$var$Xg(a) {
    null === $0acc653c28085d6b$var$Ng ? $0acc653c28085d6b$var$Ng = [
        a
    ] : $0acc653c28085d6b$var$Ng.push(a);
}
var $0acc653c28085d6b$var$Yg = $0acc653c28085d6b$var$va.ReactCurrentBatchConfig;
function $0acc653c28085d6b$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0acc653c28085d6b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0acc653c28085d6b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0acc653c28085d6b$var$p(284));
        if (!c._owner) throw Error($0acc653c28085d6b$var$p(290, a));
    }
    return a;
}
function $0acc653c28085d6b$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0acc653c28085d6b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0acc653c28085d6b$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $0acc653c28085d6b$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0acc653c28085d6b$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0acc653c28085d6b$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0acc653c28085d6b$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0acc653c28085d6b$var$Ha && $0acc653c28085d6b$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $0acc653c28085d6b$var$Zg(a, b, c), d.return = a, d;
        d = $0acc653c28085d6b$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0acc653c28085d6b$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0acc653c28085d6b$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0acc653c28085d6b$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0acc653c28085d6b$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0acc653c28085d6b$var$wa:
                    return c = $0acc653c28085d6b$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0acc653c28085d6b$var$Zg(a, null, b), c.return = a, c;
                case $0acc653c28085d6b$var$xa:
                    return b = $0acc653c28085d6b$var$fh(b, a.mode, c), b.return = a, b;
                case $0acc653c28085d6b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0acc653c28085d6b$var$db(b) || $0acc653c28085d6b$var$Ka(b)) return b = $0acc653c28085d6b$var$gh(b, a.mode, c, null), b.return = a, b;
            $0acc653c28085d6b$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0acc653c28085d6b$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0acc653c28085d6b$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0acc653c28085d6b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0acc653c28085d6b$var$db(c) || $0acc653c28085d6b$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $0acc653c28085d6b$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0acc653c28085d6b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0acc653c28085d6b$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0acc653c28085d6b$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($0acc653c28085d6b$var$db(d) || $0acc653c28085d6b$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $0acc653c28085d6b$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $0acc653c28085d6b$var$J && $0acc653c28085d6b$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $0acc653c28085d6b$var$J && $0acc653c28085d6b$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $0acc653c28085d6b$var$J && $0acc653c28085d6b$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $0acc653c28085d6b$var$Ka(h);
        if ("function" !== typeof l) throw Error($0acc653c28085d6b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0acc653c28085d6b$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $0acc653c28085d6b$var$J && $0acc653c28085d6b$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $0acc653c28085d6b$var$J && $0acc653c28085d6b$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0acc653c28085d6b$var$J && $0acc653c28085d6b$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0acc653c28085d6b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0acc653c28085d6b$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0acc653c28085d6b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0acc653c28085d6b$var$Ha && $0acc653c28085d6b$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0acc653c28085d6b$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0acc653c28085d6b$var$ya ? (d = $0acc653c28085d6b$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0acc653c28085d6b$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0acc653c28085d6b$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0acc653c28085d6b$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0acc653c28085d6b$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0acc653c28085d6b$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($0acc653c28085d6b$var$db(f)) return m(a, d, f, h);
            if ($0acc653c28085d6b$var$Ka(f)) return w(a, d, f, h);
            $0acc653c28085d6b$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0acc653c28085d6b$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $0acc653c28085d6b$var$hh = $0acc653c28085d6b$var$bh(!0), $0acc653c28085d6b$var$ih = $0acc653c28085d6b$var$bh(!1), $0acc653c28085d6b$var$jh = $0acc653c28085d6b$var$hg(null), $0acc653c28085d6b$var$kh = null, $0acc653c28085d6b$var$lh = null, $0acc653c28085d6b$var$mh = null;
function $0acc653c28085d6b$var$nh() {
    $0acc653c28085d6b$var$mh = $0acc653c28085d6b$var$lh = $0acc653c28085d6b$var$kh = null;
}
function $0acc653c28085d6b$var$oh(a) {
    var b = $0acc653c28085d6b$var$jh.current;
    $0acc653c28085d6b$var$G($0acc653c28085d6b$var$jh);
    a._currentValue = b;
}
function $0acc653c28085d6b$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0acc653c28085d6b$var$qh(a, b) {
    $0acc653c28085d6b$var$kh = a;
    $0acc653c28085d6b$var$mh = $0acc653c28085d6b$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0acc653c28085d6b$var$rh = !0), a.firstContext = null);
}
function $0acc653c28085d6b$var$sh(a) {
    var b = a._currentValue;
    if ($0acc653c28085d6b$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0acc653c28085d6b$var$lh) {
            if (null === $0acc653c28085d6b$var$kh) throw Error($0acc653c28085d6b$var$p(308));
            $0acc653c28085d6b$var$lh = a;
            $0acc653c28085d6b$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0acc653c28085d6b$var$lh = $0acc653c28085d6b$var$lh.next = a;
    }
    return b;
}
var $0acc653c28085d6b$var$th = null;
function $0acc653c28085d6b$var$uh(a) {
    null === $0acc653c28085d6b$var$th ? $0acc653c28085d6b$var$th = [
        a
    ] : $0acc653c28085d6b$var$th.push(a);
}
function $0acc653c28085d6b$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0acc653c28085d6b$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0acc653c28085d6b$var$wh(a, d);
}
function $0acc653c28085d6b$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0acc653c28085d6b$var$xh = !1;
function $0acc653c28085d6b$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0acc653c28085d6b$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0acc653c28085d6b$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0acc653c28085d6b$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0acc653c28085d6b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0acc653c28085d6b$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0acc653c28085d6b$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0acc653c28085d6b$var$wh(a, c);
}
function $0acc653c28085d6b$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0acc653c28085d6b$var$Oc(a, c);
    }
}
function $0acc653c28085d6b$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0acc653c28085d6b$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $0acc653c28085d6b$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $0acc653c28085d6b$var$u({}, q, r);
                            break a;
                        case 2:
                            $0acc653c28085d6b$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0acc653c28085d6b$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0acc653c28085d6b$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0acc653c28085d6b$var$p(191, e));
            e.call(d);
        }
    }
}
var $0acc653c28085d6b$var$Hh = {}, $0acc653c28085d6b$var$Ih = $0acc653c28085d6b$var$hg($0acc653c28085d6b$var$Hh), $0acc653c28085d6b$var$Jh = $0acc653c28085d6b$var$hg($0acc653c28085d6b$var$Hh), $0acc653c28085d6b$var$Kh = $0acc653c28085d6b$var$hg($0acc653c28085d6b$var$Hh);
function $0acc653c28085d6b$var$Lh(a) {
    if (a === $0acc653c28085d6b$var$Hh) throw Error($0acc653c28085d6b$var$p(174));
    return a;
}
function $0acc653c28085d6b$var$Mh(a, b) {
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$Kh, b);
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$Jh, a);
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$Ih, $0acc653c28085d6b$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0acc653c28085d6b$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0acc653c28085d6b$var$kb(b, a);
    }
    $0acc653c28085d6b$var$G($0acc653c28085d6b$var$Ih);
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$Ih, b);
}
function $0acc653c28085d6b$var$Nh() {
    $0acc653c28085d6b$var$G($0acc653c28085d6b$var$Ih);
    $0acc653c28085d6b$var$G($0acc653c28085d6b$var$Jh);
    $0acc653c28085d6b$var$G($0acc653c28085d6b$var$Kh);
}
function $0acc653c28085d6b$var$Oh(a) {
    $0acc653c28085d6b$var$Lh($0acc653c28085d6b$var$Kh.current);
    var b = $0acc653c28085d6b$var$Lh($0acc653c28085d6b$var$Ih.current);
    var c = $0acc653c28085d6b$var$kb(b, a.type);
    b !== c && ($0acc653c28085d6b$var$H($0acc653c28085d6b$var$Jh, a), $0acc653c28085d6b$var$H($0acc653c28085d6b$var$Ih, c));
}
function $0acc653c28085d6b$var$Ph(a) {
    $0acc653c28085d6b$var$Jh.current === a && ($0acc653c28085d6b$var$G($0acc653c28085d6b$var$Ih), $0acc653c28085d6b$var$G($0acc653c28085d6b$var$Jh));
}
var $0acc653c28085d6b$var$L = $0acc653c28085d6b$var$hg(0);
function $0acc653c28085d6b$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0acc653c28085d6b$var$Rh = [];
function $0acc653c28085d6b$var$Sh() {
    for(var a = 0; a < $0acc653c28085d6b$var$Rh.length; a++)$0acc653c28085d6b$var$Rh[a]._workInProgressVersionPrimary = null;
    $0acc653c28085d6b$var$Rh.length = 0;
}
var $0acc653c28085d6b$var$Th = $0acc653c28085d6b$var$va.ReactCurrentDispatcher, $0acc653c28085d6b$var$Uh = $0acc653c28085d6b$var$va.ReactCurrentBatchConfig, $0acc653c28085d6b$var$Vh = 0, $0acc653c28085d6b$var$M = null, $0acc653c28085d6b$var$N = null, $0acc653c28085d6b$var$O = null, $0acc653c28085d6b$var$Wh = !1, $0acc653c28085d6b$var$Xh = !1, $0acc653c28085d6b$var$Yh = 0, $0acc653c28085d6b$var$Zh = 0;
function $0acc653c28085d6b$var$P() {
    throw Error($0acc653c28085d6b$var$p(321));
}
function $0acc653c28085d6b$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0acc653c28085d6b$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $0acc653c28085d6b$var$ai(a, b, c, d, e, f) {
    $0acc653c28085d6b$var$Vh = f;
    $0acc653c28085d6b$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0acc653c28085d6b$var$Th.current = null === a || null === a.memoizedState ? $0acc653c28085d6b$var$bi : $0acc653c28085d6b$var$ci;
    a = c(d, e);
    if ($0acc653c28085d6b$var$Xh) {
        f = 0;
        do {
            $0acc653c28085d6b$var$Xh = !1;
            $0acc653c28085d6b$var$Yh = 0;
            if (25 <= f) throw Error($0acc653c28085d6b$var$p(301));
            f += 1;
            $0acc653c28085d6b$var$O = $0acc653c28085d6b$var$N = null;
            b.updateQueue = null;
            $0acc653c28085d6b$var$Th.current = $0acc653c28085d6b$var$di;
            a = c(d, e);
        }while ($0acc653c28085d6b$var$Xh);
    }
    $0acc653c28085d6b$var$Th.current = $0acc653c28085d6b$var$ei;
    b = null !== $0acc653c28085d6b$var$N && null !== $0acc653c28085d6b$var$N.next;
    $0acc653c28085d6b$var$Vh = 0;
    $0acc653c28085d6b$var$O = $0acc653c28085d6b$var$N = $0acc653c28085d6b$var$M = null;
    $0acc653c28085d6b$var$Wh = !1;
    if (b) throw Error($0acc653c28085d6b$var$p(300));
    return a;
}
function $0acc653c28085d6b$var$fi() {
    var a = 0 !== $0acc653c28085d6b$var$Yh;
    $0acc653c28085d6b$var$Yh = 0;
    return a;
}
function $0acc653c28085d6b$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0acc653c28085d6b$var$O ? $0acc653c28085d6b$var$M.memoizedState = $0acc653c28085d6b$var$O = a : $0acc653c28085d6b$var$O = $0acc653c28085d6b$var$O.next = a;
    return $0acc653c28085d6b$var$O;
}
function $0acc653c28085d6b$var$hi() {
    if (null === $0acc653c28085d6b$var$N) {
        var a = $0acc653c28085d6b$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0acc653c28085d6b$var$N.next;
    var b = null === $0acc653c28085d6b$var$O ? $0acc653c28085d6b$var$M.memoizedState : $0acc653c28085d6b$var$O.next;
    if (null !== b) $0acc653c28085d6b$var$O = b, $0acc653c28085d6b$var$N = a;
    else {
        if (null === a) throw Error($0acc653c28085d6b$var$p(310));
        $0acc653c28085d6b$var$N = a;
        a = {
            memoizedState: $0acc653c28085d6b$var$N.memoizedState,
            baseState: $0acc653c28085d6b$var$N.baseState,
            baseQueue: $0acc653c28085d6b$var$N.baseQueue,
            queue: $0acc653c28085d6b$var$N.queue,
            next: null
        };
        null === $0acc653c28085d6b$var$O ? $0acc653c28085d6b$var$M.memoizedState = $0acc653c28085d6b$var$O = a : $0acc653c28085d6b$var$O = $0acc653c28085d6b$var$O.next = a;
    }
    return $0acc653c28085d6b$var$O;
}
function $0acc653c28085d6b$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0acc653c28085d6b$var$ji(a) {
    var b = $0acc653c28085d6b$var$hi(), c = b.queue;
    if (null === c) throw Error($0acc653c28085d6b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0acc653c28085d6b$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($0acc653c28085d6b$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0acc653c28085d6b$var$M.lanes |= n;
                $0acc653c28085d6b$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0acc653c28085d6b$var$Ve(d, b.memoizedState) || ($0acc653c28085d6b$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0acc653c28085d6b$var$M.lanes |= f, $0acc653c28085d6b$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0acc653c28085d6b$var$ki(a) {
    var b = $0acc653c28085d6b$var$hi(), c = b.queue;
    if (null === c) throw Error($0acc653c28085d6b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0acc653c28085d6b$var$Ve(f, b.memoizedState) || ($0acc653c28085d6b$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0acc653c28085d6b$var$li() {}
function $0acc653c28085d6b$var$mi(a, b) {
    var c = $0acc653c28085d6b$var$M, d = $0acc653c28085d6b$var$hi(), e = b(), f = !$0acc653c28085d6b$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $0acc653c28085d6b$var$rh = !0);
    d = d.queue;
    $0acc653c28085d6b$var$ni($0acc653c28085d6b$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0acc653c28085d6b$var$O && $0acc653c28085d6b$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0acc653c28085d6b$var$pi(9, $0acc653c28085d6b$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $0acc653c28085d6b$var$Q) throw Error($0acc653c28085d6b$var$p(349));
        0 !== ($0acc653c28085d6b$var$Vh & 30) || $0acc653c28085d6b$var$ri(c, b, e);
    }
    return e;
}
function $0acc653c28085d6b$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0acc653c28085d6b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0acc653c28085d6b$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0acc653c28085d6b$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0acc653c28085d6b$var$si(b) && $0acc653c28085d6b$var$ti(a);
}
function $0acc653c28085d6b$var$oi(a, b, c) {
    return c(function() {
        $0acc653c28085d6b$var$si(b) && $0acc653c28085d6b$var$ti(a);
    });
}
function $0acc653c28085d6b$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0acc653c28085d6b$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $0acc653c28085d6b$var$ti(a) {
    var b = $0acc653c28085d6b$var$wh(a, 1);
    null !== b && $0acc653c28085d6b$var$ui(b, a, 1, -1);
}
function $0acc653c28085d6b$var$vi(a) {
    var b = $0acc653c28085d6b$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0acc653c28085d6b$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0acc653c28085d6b$var$wi.bind(null, $0acc653c28085d6b$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0acc653c28085d6b$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0acc653c28085d6b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0acc653c28085d6b$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0acc653c28085d6b$var$xi() {
    return $0acc653c28085d6b$var$hi().memoizedState;
}
function $0acc653c28085d6b$var$Ai(a, b, c, d) {
    var e = $0acc653c28085d6b$var$gi();
    $0acc653c28085d6b$var$M.flags |= a;
    e.memoizedState = $0acc653c28085d6b$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0acc653c28085d6b$var$Bi(a, b, c, d) {
    var e = $0acc653c28085d6b$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0acc653c28085d6b$var$N) {
        var g = $0acc653c28085d6b$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0acc653c28085d6b$var$$h(d, g.deps)) {
            e.memoizedState = $0acc653c28085d6b$var$pi(b, c, f, d);
            return;
        }
    }
    $0acc653c28085d6b$var$M.flags |= a;
    e.memoizedState = $0acc653c28085d6b$var$pi(1 | b, c, f, d);
}
function $0acc653c28085d6b$var$Ci(a, b) {
    return $0acc653c28085d6b$var$Ai(8390656, 8, a, b);
}
function $0acc653c28085d6b$var$ni(a, b) {
    return $0acc653c28085d6b$var$Bi(2048, 8, a, b);
}
function $0acc653c28085d6b$var$Di(a, b) {
    return $0acc653c28085d6b$var$Bi(4, 2, a, b);
}
function $0acc653c28085d6b$var$Ei(a, b) {
    return $0acc653c28085d6b$var$Bi(4, 4, a, b);
}
function $0acc653c28085d6b$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0acc653c28085d6b$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0acc653c28085d6b$var$Bi(4, 4, $0acc653c28085d6b$var$Fi.bind(null, b, a), c);
}
function $0acc653c28085d6b$var$Hi() {}
function $0acc653c28085d6b$var$Ii(a, b) {
    var c = $0acc653c28085d6b$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0acc653c28085d6b$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0acc653c28085d6b$var$Ji(a, b) {
    var c = $0acc653c28085d6b$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0acc653c28085d6b$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0acc653c28085d6b$var$Ki(a, b, c) {
    if (0 === ($0acc653c28085d6b$var$Vh & 21)) return a.baseState && (a.baseState = !1, $0acc653c28085d6b$var$rh = !0), a.memoizedState = c;
    $0acc653c28085d6b$var$Ve(c, b) || (c = $0acc653c28085d6b$var$Kc(), $0acc653c28085d6b$var$M.lanes |= c, $0acc653c28085d6b$var$Fh |= c, a.baseState = !0);
    return b;
}
function $0acc653c28085d6b$var$Li(a, b) {
    var c = $0acc653c28085d6b$var$E;
    $0acc653c28085d6b$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0acc653c28085d6b$var$Uh.transition;
    $0acc653c28085d6b$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0acc653c28085d6b$var$E = c, $0acc653c28085d6b$var$Uh.transition = d;
    }
}
function $0acc653c28085d6b$var$Mi() {
    return $0acc653c28085d6b$var$hi().memoizedState;
}
function $0acc653c28085d6b$var$Ni(a, b, c) {
    var d = $0acc653c28085d6b$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0acc653c28085d6b$var$Pi(a)) $0acc653c28085d6b$var$Qi(b, c);
    else if (c = $0acc653c28085d6b$var$vh(a, b, c, d), null !== c) {
        var e = $0acc653c28085d6b$var$Ri();
        $0acc653c28085d6b$var$ui(c, a, d, e);
        $0acc653c28085d6b$var$Si(c, b, d);
    }
    $0acc653c28085d6b$var$yc(a, d);
}
function $0acc653c28085d6b$var$wi(a, b, c) {
    var d = $0acc653c28085d6b$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0acc653c28085d6b$var$Pi(a)) $0acc653c28085d6b$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0acc653c28085d6b$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0acc653c28085d6b$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0acc653c28085d6b$var$vh(a, b, e, d);
        null !== c && (e = $0acc653c28085d6b$var$Ri(), $0acc653c28085d6b$var$ui(c, a, d, e), $0acc653c28085d6b$var$Si(c, b, d));
    }
    $0acc653c28085d6b$var$yc(a, d);
}
function $0acc653c28085d6b$var$Pi(a) {
    var b = a.alternate;
    return a === $0acc653c28085d6b$var$M || null !== b && b === $0acc653c28085d6b$var$M;
}
function $0acc653c28085d6b$var$Qi(a, b) {
    $0acc653c28085d6b$var$Xh = $0acc653c28085d6b$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0acc653c28085d6b$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0acc653c28085d6b$var$Oc(a, c);
    }
}
var $0acc653c28085d6b$var$ei = {
    readContext: $0acc653c28085d6b$var$sh,
    useCallback: $0acc653c28085d6b$var$P,
    useContext: $0acc653c28085d6b$var$P,
    useEffect: $0acc653c28085d6b$var$P,
    useImperativeHandle: $0acc653c28085d6b$var$P,
    useInsertionEffect: $0acc653c28085d6b$var$P,
    useLayoutEffect: $0acc653c28085d6b$var$P,
    useMemo: $0acc653c28085d6b$var$P,
    useReducer: $0acc653c28085d6b$var$P,
    useRef: $0acc653c28085d6b$var$P,
    useState: $0acc653c28085d6b$var$P,
    useDebugValue: $0acc653c28085d6b$var$P,
    useDeferredValue: $0acc653c28085d6b$var$P,
    useTransition: $0acc653c28085d6b$var$P,
    useMutableSource: $0acc653c28085d6b$var$P,
    useSyncExternalStore: $0acc653c28085d6b$var$P,
    useId: $0acc653c28085d6b$var$P,
    unstable_isNewReconciler: !1
}, $0acc653c28085d6b$var$bi = {
    readContext: $0acc653c28085d6b$var$sh,
    useCallback: function(a, b) {
        $0acc653c28085d6b$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0acc653c28085d6b$var$sh,
    useEffect: $0acc653c28085d6b$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0acc653c28085d6b$var$Ai(4194308, 4, $0acc653c28085d6b$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0acc653c28085d6b$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0acc653c28085d6b$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0acc653c28085d6b$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0acc653c28085d6b$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0acc653c28085d6b$var$Ni.bind(null, $0acc653c28085d6b$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0acc653c28085d6b$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0acc653c28085d6b$var$vi,
    useDebugValue: $0acc653c28085d6b$var$Hi,
    useDeferredValue: function(a) {
        return $0acc653c28085d6b$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $0acc653c28085d6b$var$vi(!1), b = a[0];
        a = $0acc653c28085d6b$var$Li.bind(null, a[1]);
        $0acc653c28085d6b$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0acc653c28085d6b$var$M, e = $0acc653c28085d6b$var$gi();
        if ($0acc653c28085d6b$var$J) {
            if (void 0 === c) throw Error($0acc653c28085d6b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0acc653c28085d6b$var$Q) throw Error($0acc653c28085d6b$var$p(349));
            0 !== ($0acc653c28085d6b$var$Vh & 30) || $0acc653c28085d6b$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0acc653c28085d6b$var$Ci($0acc653c28085d6b$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0acc653c28085d6b$var$pi(9, $0acc653c28085d6b$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0acc653c28085d6b$var$gi(), b = $0acc653c28085d6b$var$Q.identifierPrefix;
        if ($0acc653c28085d6b$var$J) {
            var c = $0acc653c28085d6b$var$Gg;
            var d = $0acc653c28085d6b$var$Fg;
            c = (d & ~(1 << 32 - $0acc653c28085d6b$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0acc653c28085d6b$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0acc653c28085d6b$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0acc653c28085d6b$var$ci = {
    readContext: $0acc653c28085d6b$var$sh,
    useCallback: $0acc653c28085d6b$var$Ii,
    useContext: $0acc653c28085d6b$var$sh,
    useEffect: $0acc653c28085d6b$var$ni,
    useImperativeHandle: $0acc653c28085d6b$var$Gi,
    useInsertionEffect: $0acc653c28085d6b$var$Di,
    useLayoutEffect: $0acc653c28085d6b$var$Ei,
    useMemo: $0acc653c28085d6b$var$Ji,
    useReducer: $0acc653c28085d6b$var$ji,
    useRef: $0acc653c28085d6b$var$xi,
    useState: function() {
        return $0acc653c28085d6b$var$ji($0acc653c28085d6b$var$ii);
    },
    useDebugValue: $0acc653c28085d6b$var$Hi,
    useDeferredValue: function(a) {
        var b = $0acc653c28085d6b$var$hi();
        return $0acc653c28085d6b$var$Ki(b, $0acc653c28085d6b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0acc653c28085d6b$var$ji($0acc653c28085d6b$var$ii)[0], b = $0acc653c28085d6b$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0acc653c28085d6b$var$li,
    useSyncExternalStore: $0acc653c28085d6b$var$mi,
    useId: $0acc653c28085d6b$var$Mi,
    unstable_isNewReconciler: !1
}, $0acc653c28085d6b$var$di = {
    readContext: $0acc653c28085d6b$var$sh,
    useCallback: $0acc653c28085d6b$var$Ii,
    useContext: $0acc653c28085d6b$var$sh,
    useEffect: $0acc653c28085d6b$var$ni,
    useImperativeHandle: $0acc653c28085d6b$var$Gi,
    useInsertionEffect: $0acc653c28085d6b$var$Di,
    useLayoutEffect: $0acc653c28085d6b$var$Ei,
    useMemo: $0acc653c28085d6b$var$Ji,
    useReducer: $0acc653c28085d6b$var$ki,
    useRef: $0acc653c28085d6b$var$xi,
    useState: function() {
        return $0acc653c28085d6b$var$ki($0acc653c28085d6b$var$ii);
    },
    useDebugValue: $0acc653c28085d6b$var$Hi,
    useDeferredValue: function(a) {
        var b = $0acc653c28085d6b$var$hi();
        return null === $0acc653c28085d6b$var$N ? b.memoizedState = a : $0acc653c28085d6b$var$Ki(b, $0acc653c28085d6b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0acc653c28085d6b$var$ki($0acc653c28085d6b$var$ii)[0], b = $0acc653c28085d6b$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0acc653c28085d6b$var$li,
    useSyncExternalStore: $0acc653c28085d6b$var$mi,
    useId: $0acc653c28085d6b$var$Mi,
    unstable_isNewReconciler: !1
}, $0acc653c28085d6b$var$Ti = $2NwEO.unstable_now, $0acc653c28085d6b$var$Ui = 0, $0acc653c28085d6b$var$Vi = -1, $0acc653c28085d6b$var$Wi = -1, $0acc653c28085d6b$var$Xi = -1, $0acc653c28085d6b$var$Yi = !1, $0acc653c28085d6b$var$Zi = !1;
function $0acc653c28085d6b$var$$i(a, b) {
    if (0 <= $0acc653c28085d6b$var$Wi) {
        var c = $0acc653c28085d6b$var$Ti() - $0acc653c28085d6b$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $0acc653c28085d6b$var$Wi = -1;
    }
}
function $0acc653c28085d6b$var$aj(a) {
    if (0 <= $0acc653c28085d6b$var$Vi) {
        var b = $0acc653c28085d6b$var$Ti() - $0acc653c28085d6b$var$Vi;
        $0acc653c28085d6b$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $0acc653c28085d6b$var$bj(a) {
    if (0 <= $0acc653c28085d6b$var$Xi) {
        var b = $0acc653c28085d6b$var$Ti() - $0acc653c28085d6b$var$Xi;
        $0acc653c28085d6b$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $0acc653c28085d6b$var$cj() {
    $0acc653c28085d6b$var$Vi = $0acc653c28085d6b$var$Ti();
}
function $0acc653c28085d6b$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $0acc653c28085d6b$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $0acc653c28085d6b$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0acc653c28085d6b$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0acc653c28085d6b$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0acc653c28085d6b$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0acc653c28085d6b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0acc653c28085d6b$var$Ri(), e = $0acc653c28085d6b$var$Oi(a), f = $0acc653c28085d6b$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0acc653c28085d6b$var$Bh(a, f, e);
        null !== b && ($0acc653c28085d6b$var$ui(b, a, e, d), $0acc653c28085d6b$var$Ch(b, a, e));
        $0acc653c28085d6b$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0acc653c28085d6b$var$Ri(), e = $0acc653c28085d6b$var$Oi(a), f = $0acc653c28085d6b$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0acc653c28085d6b$var$Bh(a, f, e);
        null !== b && ($0acc653c28085d6b$var$ui(b, a, e, d), $0acc653c28085d6b$var$Ch(b, a, e));
        $0acc653c28085d6b$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0acc653c28085d6b$var$Ri(), d = $0acc653c28085d6b$var$Oi(a), e = $0acc653c28085d6b$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0acc653c28085d6b$var$Bh(a, e, d);
        null !== b && ($0acc653c28085d6b$var$ui(b, a, d, c), $0acc653c28085d6b$var$Ch(b, a, d));
        null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markForceUpdateScheduled && $0acc653c28085d6b$var$B.markForceUpdateScheduled(a, d);
    }
};
function $0acc653c28085d6b$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0acc653c28085d6b$var$We(c, d) || !$0acc653c28085d6b$var$We(e, f) : !0;
}
function $0acc653c28085d6b$var$ij(a, b, c) {
    var d = !1, e = $0acc653c28085d6b$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0acc653c28085d6b$var$sh(f) : (e = $0acc653c28085d6b$var$mg(b) ? $0acc653c28085d6b$var$kg : $0acc653c28085d6b$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0acc653c28085d6b$var$lg(a, e) : $0acc653c28085d6b$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0acc653c28085d6b$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0acc653c28085d6b$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0acc653c28085d6b$var$gj.enqueueReplaceState(b, b.state, null);
}
function $0acc653c28085d6b$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0acc653c28085d6b$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0acc653c28085d6b$var$sh(f) : (f = $0acc653c28085d6b$var$mg(b) ? $0acc653c28085d6b$var$kg : $0acc653c28085d6b$var$I.current, e.context = $0acc653c28085d6b$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0acc653c28085d6b$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0acc653c28085d6b$var$gj.enqueueReplaceState(e, e.state, null), $0acc653c28085d6b$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0acc653c28085d6b$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $0acc653c28085d6b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0acc653c28085d6b$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0acc653c28085d6b$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0acc653c28085d6b$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $0acc653c28085d6b$var$pj(a, b, c) {
    c = $0acc653c28085d6b$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0acc653c28085d6b$var$qj || ($0acc653c28085d6b$var$qj = !0, $0acc653c28085d6b$var$rj = d);
        $0acc653c28085d6b$var$nj(a, b);
    };
    return c;
}
function $0acc653c28085d6b$var$sj(a, b, c) {
    c = $0acc653c28085d6b$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0acc653c28085d6b$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0acc653c28085d6b$var$nj(a, b);
        "function" !== typeof d && (null === $0acc653c28085d6b$var$tj ? $0acc653c28085d6b$var$tj = new Set([
            this
        ]) : $0acc653c28085d6b$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0acc653c28085d6b$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0acc653c28085d6b$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $0acc653c28085d6b$var$vj.bind(null, a, b, c), $0acc653c28085d6b$var$mc && $0acc653c28085d6b$var$wj(a, c), b.then(d, d));
}
function $0acc653c28085d6b$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0acc653c28085d6b$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0acc653c28085d6b$var$Ah(-1, 1), b.tag = 2, $0acc653c28085d6b$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0acc653c28085d6b$var$zj = $0acc653c28085d6b$var$va.ReactCurrentOwner, $0acc653c28085d6b$var$rh = !1;
function $0acc653c28085d6b$var$Aj(a, b, c, d) {
    b.child = null === a ? $0acc653c28085d6b$var$ih(b, null, c, d) : $0acc653c28085d6b$var$hh(b, a.child, c, d);
}
function $0acc653c28085d6b$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0acc653c28085d6b$var$qh(b, e);
    $0acc653c28085d6b$var$sc(b);
    d = $0acc653c28085d6b$var$ai(a, b, c, d, f, e);
    c = $0acc653c28085d6b$var$fi();
    $0acc653c28085d6b$var$tc();
    if (null !== a && !$0acc653c28085d6b$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0acc653c28085d6b$var$Cj(a, b, e);
    $0acc653c28085d6b$var$J && c && $0acc653c28085d6b$var$Jg(b);
    b.flags |= 1;
    $0acc653c28085d6b$var$Aj(a, b, d, e);
    return b.child;
}
function $0acc653c28085d6b$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0acc653c28085d6b$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0acc653c28085d6b$var$Fj(a, b, f, d, e);
        a = $0acc653c28085d6b$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0acc653c28085d6b$var$We;
        if (c(g, d) && a.ref === b.ref) return $0acc653c28085d6b$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $0acc653c28085d6b$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0acc653c28085d6b$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0acc653c28085d6b$var$We(f, d) && a.ref === b.ref) {
            if ($0acc653c28085d6b$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0acc653c28085d6b$var$rh = !0);
            else return b.lanes = a.lanes, $0acc653c28085d6b$var$Cj(a, b, e);
        }
    }
    return $0acc653c28085d6b$var$Gj(a, b, c, d, e);
}
function $0acc653c28085d6b$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0acc653c28085d6b$var$H($0acc653c28085d6b$var$Ij, $0acc653c28085d6b$var$Jj), $0acc653c28085d6b$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0acc653c28085d6b$var$H($0acc653c28085d6b$var$Ij, $0acc653c28085d6b$var$Jj), $0acc653c28085d6b$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0acc653c28085d6b$var$H($0acc653c28085d6b$var$Ij, $0acc653c28085d6b$var$Jj);
            $0acc653c28085d6b$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0acc653c28085d6b$var$H($0acc653c28085d6b$var$Ij, $0acc653c28085d6b$var$Jj), $0acc653c28085d6b$var$Jj |= d;
    $0acc653c28085d6b$var$Aj(a, b, e, c);
    return b.child;
}
function $0acc653c28085d6b$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0acc653c28085d6b$var$Gj(a, b, c, d, e) {
    var f = $0acc653c28085d6b$var$mg(c) ? $0acc653c28085d6b$var$kg : $0acc653c28085d6b$var$I.current;
    f = $0acc653c28085d6b$var$lg(b, f);
    $0acc653c28085d6b$var$qh(b, e);
    $0acc653c28085d6b$var$sc(b);
    c = $0acc653c28085d6b$var$ai(a, b, c, d, f, e);
    d = $0acc653c28085d6b$var$fi();
    $0acc653c28085d6b$var$tc();
    if (null !== a && !$0acc653c28085d6b$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0acc653c28085d6b$var$Cj(a, b, e);
    $0acc653c28085d6b$var$J && d && $0acc653c28085d6b$var$Jg(b);
    b.flags |= 1;
    $0acc653c28085d6b$var$Aj(a, b, c, e);
    return b.child;
}
function $0acc653c28085d6b$var$Lj(a, b, c, d, e) {
    if ($0acc653c28085d6b$var$mg(c)) {
        var f = !0;
        $0acc653c28085d6b$var$qg(b);
    } else f = !1;
    $0acc653c28085d6b$var$qh(b, e);
    if (null === b.stateNode) $0acc653c28085d6b$var$Mj(a, b), $0acc653c28085d6b$var$ij(b, c, d), $0acc653c28085d6b$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0acc653c28085d6b$var$sh(l) : (l = $0acc653c28085d6b$var$mg(c) ? $0acc653c28085d6b$var$kg : $0acc653c28085d6b$var$I.current, l = $0acc653c28085d6b$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0acc653c28085d6b$var$jj(b, g, d, l);
        $0acc653c28085d6b$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0acc653c28085d6b$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0acc653c28085d6b$var$jg.current || $0acc653c28085d6b$var$xh ? ("function" === typeof n && ($0acc653c28085d6b$var$fj(b, c, n, d), k = b.memoizedState), (h = $0acc653c28085d6b$var$xh || $0acc653c28085d6b$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0acc653c28085d6b$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0acc653c28085d6b$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0acc653c28085d6b$var$sh(k) : (k = $0acc653c28085d6b$var$mg(c) ? $0acc653c28085d6b$var$kg : $0acc653c28085d6b$var$I.current, k = $0acc653c28085d6b$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0acc653c28085d6b$var$jj(b, g, d, k);
        $0acc653c28085d6b$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $0acc653c28085d6b$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $0acc653c28085d6b$var$jg.current || $0acc653c28085d6b$var$xh ? ("function" === typeof z && ($0acc653c28085d6b$var$fj(b, c, z, d), m = b.memoizedState), (l = $0acc653c28085d6b$var$xh || $0acc653c28085d6b$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0acc653c28085d6b$var$Nj(a, b, c, d, f, e);
}
function $0acc653c28085d6b$var$Nj(a, b, c, d, e, f) {
    $0acc653c28085d6b$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0acc653c28085d6b$var$rg(b, c, !1), $0acc653c28085d6b$var$Cj(a, b, f);
    d = b.stateNode;
    $0acc653c28085d6b$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $0acc653c28085d6b$var$Wi = -1;
    } else $0acc653c28085d6b$var$sc(b), h = d.render(), $0acc653c28085d6b$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $0acc653c28085d6b$var$hh(b, a.child, null, f), b.child = $0acc653c28085d6b$var$hh(b, null, g, f)) : $0acc653c28085d6b$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $0acc653c28085d6b$var$rg(b, c, !0);
    return b.child;
}
function $0acc653c28085d6b$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0acc653c28085d6b$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0acc653c28085d6b$var$og(a, b.context, !1);
    $0acc653c28085d6b$var$Mh(a, b.containerInfo);
}
function $0acc653c28085d6b$var$Rj(a, b, c, d, e) {
    $0acc653c28085d6b$var$Wg();
    $0acc653c28085d6b$var$Xg(e);
    b.flags |= 256;
    $0acc653c28085d6b$var$Aj(a, b, c, d);
    return b.child;
}
var $0acc653c28085d6b$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0acc653c28085d6b$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0acc653c28085d6b$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $0acc653c28085d6b$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$L, e & 1);
    if (null === a) {
        $0acc653c28085d6b$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $0acc653c28085d6b$var$Vj(g, d, 0, null), a = $0acc653c28085d6b$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0acc653c28085d6b$var$Tj(c), b.memoizedState = $0acc653c28085d6b$var$Sj, a) : $0acc653c28085d6b$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0acc653c28085d6b$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $0acc653c28085d6b$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0acc653c28085d6b$var$ch(h, f) : (f = $0acc653c28085d6b$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0acc653c28085d6b$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0acc653c28085d6b$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0acc653c28085d6b$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0acc653c28085d6b$var$Wj(a, b) {
    b = $0acc653c28085d6b$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0acc653c28085d6b$var$Yj(a, b, c, d) {
    null !== d && $0acc653c28085d6b$var$Xg(d);
    $0acc653c28085d6b$var$hh(b, a.child, null, c);
    a = $0acc653c28085d6b$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0acc653c28085d6b$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0acc653c28085d6b$var$mj(Error($0acc653c28085d6b$var$p(422))), $0acc653c28085d6b$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0acc653c28085d6b$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0acc653c28085d6b$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0acc653c28085d6b$var$hh(b, a.child, null, g);
        b.child.memoizedState = $0acc653c28085d6b$var$Tj(g);
        b.memoizedState = $0acc653c28085d6b$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0acc653c28085d6b$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0acc653c28085d6b$var$p(419));
        d = $0acc653c28085d6b$var$mj(f, d, void 0);
        return $0acc653c28085d6b$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0acc653c28085d6b$var$rh || h) {
        d = $0acc653c28085d6b$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0acc653c28085d6b$var$wh(a, e), $0acc653c28085d6b$var$ui(d, a, e, -1));
        }
        $0acc653c28085d6b$var$Zj();
        d = $0acc653c28085d6b$var$mj(Error($0acc653c28085d6b$var$p(421)));
        return $0acc653c28085d6b$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0acc653c28085d6b$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0acc653c28085d6b$var$Mg = $0acc653c28085d6b$var$Zf(e.nextSibling);
    $0acc653c28085d6b$var$Lg = b;
    $0acc653c28085d6b$var$J = !0;
    $0acc653c28085d6b$var$Ng = null;
    null !== a && ($0acc653c28085d6b$var$Cg[$0acc653c28085d6b$var$Dg++] = $0acc653c28085d6b$var$Fg, $0acc653c28085d6b$var$Cg[$0acc653c28085d6b$var$Dg++] = $0acc653c28085d6b$var$Gg, $0acc653c28085d6b$var$Cg[$0acc653c28085d6b$var$Dg++] = $0acc653c28085d6b$var$Eg, $0acc653c28085d6b$var$Fg = a.id, $0acc653c28085d6b$var$Gg = a.overflow, $0acc653c28085d6b$var$Eg = b);
    b = $0acc653c28085d6b$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0acc653c28085d6b$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0acc653c28085d6b$var$ph(a.return, b, c);
}
function $0acc653c28085d6b$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0acc653c28085d6b$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0acc653c28085d6b$var$Aj(a, b, d.children, c);
    d = $0acc653c28085d6b$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0acc653c28085d6b$var$bk(a, c, b);
            else if (19 === a.tag) $0acc653c28085d6b$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0acc653c28085d6b$var$H($0acc653c28085d6b$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0acc653c28085d6b$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0acc653c28085d6b$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0acc653c28085d6b$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0acc653c28085d6b$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $0acc653c28085d6b$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0acc653c28085d6b$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0acc653c28085d6b$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0acc653c28085d6b$var$Wi = -1;
    $0acc653c28085d6b$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0acc653c28085d6b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0acc653c28085d6b$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0acc653c28085d6b$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0acc653c28085d6b$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $0acc653c28085d6b$var$Oj(b);
            $0acc653c28085d6b$var$Wg();
            break;
        case 5:
            $0acc653c28085d6b$var$Oh(b);
            break;
        case 1:
            $0acc653c28085d6b$var$mg(b.type) && $0acc653c28085d6b$var$qg(b);
            break;
        case 4:
            $0acc653c28085d6b$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0acc653c28085d6b$var$H($0acc653c28085d6b$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0acc653c28085d6b$var$H($0acc653c28085d6b$var$L, $0acc653c28085d6b$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0acc653c28085d6b$var$Uj(a, b, c);
                $0acc653c28085d6b$var$H($0acc653c28085d6b$var$L, $0acc653c28085d6b$var$L.current & 1);
                a = $0acc653c28085d6b$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0acc653c28085d6b$var$H($0acc653c28085d6b$var$L, $0acc653c28085d6b$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0acc653c28085d6b$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0acc653c28085d6b$var$H($0acc653c28085d6b$var$L, $0acc653c28085d6b$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0acc653c28085d6b$var$Hj(a, b, c);
    }
    return $0acc653c28085d6b$var$Cj(a, b, c);
}
var $0acc653c28085d6b$var$fk, $0acc653c28085d6b$var$gk, $0acc653c28085d6b$var$hk, $0acc653c28085d6b$var$ik;
$0acc653c28085d6b$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0acc653c28085d6b$var$gk = function() {};
$0acc653c28085d6b$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0acc653c28085d6b$var$Lh($0acc653c28085d6b$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $0acc653c28085d6b$var$Ya(a, e);
                d = $0acc653c28085d6b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0acc653c28085d6b$var$u({}, e, {
                    value: void 0
                });
                d = $0acc653c28085d6b$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0acc653c28085d6b$var$fb(a, e);
                d = $0acc653c28085d6b$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0acc653c28085d6b$var$Pf);
        }
        $0acc653c28085d6b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0acc653c28085d6b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0acc653c28085d6b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0acc653c28085d6b$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0acc653c28085d6b$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0acc653c28085d6b$var$jk(a, b) {
    if (!$0acc653c28085d6b$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0acc653c28085d6b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0acc653c28085d6b$var$kk(a, b, c) {
    var d = b.pendingProps;
    $0acc653c28085d6b$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0acc653c28085d6b$var$S(b), null;
        case 1:
            return $0acc653c28085d6b$var$mg(b.type) && $0acc653c28085d6b$var$ng(), $0acc653c28085d6b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0acc653c28085d6b$var$Nh();
            $0acc653c28085d6b$var$G($0acc653c28085d6b$var$jg);
            $0acc653c28085d6b$var$G($0acc653c28085d6b$var$I);
            $0acc653c28085d6b$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0acc653c28085d6b$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0acc653c28085d6b$var$Ng && ($0acc653c28085d6b$var$lk($0acc653c28085d6b$var$Ng), $0acc653c28085d6b$var$Ng = null));
            $0acc653c28085d6b$var$gk(a, b);
            $0acc653c28085d6b$var$S(b);
            return null;
        case 5:
            $0acc653c28085d6b$var$Ph(b);
            var e = $0acc653c28085d6b$var$Lh($0acc653c28085d6b$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0acc653c28085d6b$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0acc653c28085d6b$var$p(166));
                    $0acc653c28085d6b$var$S(b);
                    return null;
                }
                a = $0acc653c28085d6b$var$Lh($0acc653c28085d6b$var$Ih.current);
                if ($0acc653c28085d6b$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$0acc653c28085d6b$var$bg] = b;
                    d[$0acc653c28085d6b$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $0acc653c28085d6b$var$F("cancel", d);
                            $0acc653c28085d6b$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0acc653c28085d6b$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0acc653c28085d6b$var$zf.length; e++)$0acc653c28085d6b$var$F($0acc653c28085d6b$var$zf[e], d);
                            break;
                        case "source":
                            $0acc653c28085d6b$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0acc653c28085d6b$var$F("error", d);
                            $0acc653c28085d6b$var$F("load", d);
                            break;
                        case "details":
                            $0acc653c28085d6b$var$F("toggle", d);
                            break;
                        case "input":
                            $0acc653c28085d6b$var$Za(d, c);
                            $0acc653c28085d6b$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $0acc653c28085d6b$var$F("invalid", d);
                            break;
                        case "textarea":
                            $0acc653c28085d6b$var$gb(d, c), $0acc653c28085d6b$var$F("invalid", d);
                    }
                    $0acc653c28085d6b$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $0acc653c28085d6b$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $0acc653c28085d6b$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $0acc653c28085d6b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0acc653c28085d6b$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $0acc653c28085d6b$var$Va(d);
                            $0acc653c28085d6b$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $0acc653c28085d6b$var$Va(d);
                            $0acc653c28085d6b$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $0acc653c28085d6b$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0acc653c28085d6b$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0acc653c28085d6b$var$bg] = b;
                    a[$0acc653c28085d6b$var$cg] = d;
                    $0acc653c28085d6b$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0acc653c28085d6b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0acc653c28085d6b$var$F("cancel", a);
                                $0acc653c28085d6b$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0acc653c28085d6b$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0acc653c28085d6b$var$zf.length; e++)$0acc653c28085d6b$var$F($0acc653c28085d6b$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0acc653c28085d6b$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0acc653c28085d6b$var$F("error", a);
                                $0acc653c28085d6b$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $0acc653c28085d6b$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0acc653c28085d6b$var$Za(a, d);
                                e = $0acc653c28085d6b$var$Ya(a, d);
                                $0acc653c28085d6b$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0acc653c28085d6b$var$u({}, d, {
                                    value: void 0
                                });
                                $0acc653c28085d6b$var$F("invalid", a);
                                break;
                            case "textarea":
                                $0acc653c28085d6b$var$gb(a, d);
                                e = $0acc653c28085d6b$var$fb(a, d);
                                $0acc653c28085d6b$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0acc653c28085d6b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0acc653c28085d6b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0acc653c28085d6b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0acc653c28085d6b$var$ob(a, k) : "number" === typeof k && $0acc653c28085d6b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0acc653c28085d6b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0acc653c28085d6b$var$F("scroll", a) : null != k && $0acc653c28085d6b$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0acc653c28085d6b$var$Va(a);
                                $0acc653c28085d6b$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $0acc653c28085d6b$var$Va(a);
                                $0acc653c28085d6b$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0acc653c28085d6b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0acc653c28085d6b$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0acc653c28085d6b$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0acc653c28085d6b$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0acc653c28085d6b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0acc653c28085d6b$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0acc653c28085d6b$var$p(166));
                a = $0acc653c28085d6b$var$Lh($0acc653c28085d6b$var$Kh.current);
                $0acc653c28085d6b$var$Lh($0acc653c28085d6b$var$Ih.current);
                if ($0acc653c28085d6b$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$0acc653c28085d6b$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $0acc653c28085d6b$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $0acc653c28085d6b$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $0acc653c28085d6b$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$0acc653c28085d6b$var$bg] = b, b.stateNode = d;
            }
            $0acc653c28085d6b$var$S(b);
            return null;
        case 13:
            $0acc653c28085d6b$var$G($0acc653c28085d6b$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0acc653c28085d6b$var$J && null !== $0acc653c28085d6b$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0acc653c28085d6b$var$Vg(), $0acc653c28085d6b$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $0acc653c28085d6b$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0acc653c28085d6b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0acc653c28085d6b$var$p(317));
                        f[$0acc653c28085d6b$var$bg] = b;
                        $0acc653c28085d6b$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $0acc653c28085d6b$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $0acc653c28085d6b$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $0acc653c28085d6b$var$Ng && ($0acc653c28085d6b$var$lk($0acc653c28085d6b$var$Ng), $0acc653c28085d6b$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $0acc653c28085d6b$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0acc653c28085d6b$var$L.current & 1) ? 0 === $0acc653c28085d6b$var$T && ($0acc653c28085d6b$var$T = 3) : $0acc653c28085d6b$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0acc653c28085d6b$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $0acc653c28085d6b$var$Nh(), $0acc653c28085d6b$var$gk(a, b), null === a && $0acc653c28085d6b$var$Gf(b.stateNode.containerInfo), $0acc653c28085d6b$var$S(b), null;
        case 10:
            return $0acc653c28085d6b$var$oh(b.type._context), $0acc653c28085d6b$var$S(b), null;
        case 17:
            return $0acc653c28085d6b$var$mg(b.type) && $0acc653c28085d6b$var$ng(), $0acc653c28085d6b$var$S(b), null;
        case 19:
            $0acc653c28085d6b$var$G($0acc653c28085d6b$var$L);
            f = b.memoizedState;
            if (null === f) return $0acc653c28085d6b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0acc653c28085d6b$var$jk(f, !1);
                else {
                    if (0 !== $0acc653c28085d6b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0acc653c28085d6b$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0acc653c28085d6b$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $0acc653c28085d6b$var$H($0acc653c28085d6b$var$L, $0acc653c28085d6b$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0acc653c28085d6b$var$A() > $0acc653c28085d6b$var$mk && (b.flags |= 128, d = !0, $0acc653c28085d6b$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0acc653c28085d6b$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $0acc653c28085d6b$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0acc653c28085d6b$var$J) return $0acc653c28085d6b$var$S(b), null;
                    } else 2 * $0acc653c28085d6b$var$A() - f.renderingStartTime > $0acc653c28085d6b$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $0acc653c28085d6b$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0acc653c28085d6b$var$A(), b.sibling = null, a = $0acc653c28085d6b$var$L.current, $0acc653c28085d6b$var$H($0acc653c28085d6b$var$L, d ? a & 1 | 2 : a & 1), b;
            $0acc653c28085d6b$var$S(b);
            return null;
        case 22:
        case 23:
            return $0acc653c28085d6b$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0acc653c28085d6b$var$Jj & 1073741824) && ($0acc653c28085d6b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0acc653c28085d6b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0acc653c28085d6b$var$p(156, b.tag));
}
function $0acc653c28085d6b$var$ok(a, b) {
    $0acc653c28085d6b$var$Kg(b);
    switch(b.tag){
        case 1:
            return $0acc653c28085d6b$var$mg(b.type) && $0acc653c28085d6b$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $0acc653c28085d6b$var$dj(b), b) : null;
        case 3:
            return $0acc653c28085d6b$var$Nh(), $0acc653c28085d6b$var$G($0acc653c28085d6b$var$jg), $0acc653c28085d6b$var$G($0acc653c28085d6b$var$I), $0acc653c28085d6b$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0acc653c28085d6b$var$Ph(b), null;
        case 13:
            $0acc653c28085d6b$var$G($0acc653c28085d6b$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0acc653c28085d6b$var$p(340));
                $0acc653c28085d6b$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $0acc653c28085d6b$var$dj(b), b) : null;
        case 19:
            return $0acc653c28085d6b$var$G($0acc653c28085d6b$var$L), null;
        case 4:
            return $0acc653c28085d6b$var$Nh(), null;
        case 10:
            return $0acc653c28085d6b$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $0acc653c28085d6b$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0acc653c28085d6b$var$pk = !1, $0acc653c28085d6b$var$qk = !1, $0acc653c28085d6b$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $0acc653c28085d6b$var$U = null, $0acc653c28085d6b$var$sk = null, $0acc653c28085d6b$var$tk = null;
function $0acc653c28085d6b$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $0acc653c28085d6b$var$cj(), b.componentWillUnmount();
    } finally{
        $0acc653c28085d6b$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $0acc653c28085d6b$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $0acc653c28085d6b$var$cj(), c(null);
            } finally{
                $0acc653c28085d6b$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $0acc653c28085d6b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0acc653c28085d6b$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $0acc653c28085d6b$var$W(a, b, d);
    }
}
var $0acc653c28085d6b$var$xk = !1;
function $0acc653c28085d6b$var$yk(a, b) {
    $0acc653c28085d6b$var$Qf = $0acc653c28085d6b$var$rd;
    a = $0acc653c28085d6b$var$$e();
    if ($0acc653c28085d6b$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0acc653c28085d6b$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $0acc653c28085d6b$var$rd = !1;
    for($0acc653c28085d6b$var$U = b; null !== $0acc653c28085d6b$var$U;)if (b = $0acc653c28085d6b$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0acc653c28085d6b$var$U = a;
    else for(; null !== $0acc653c28085d6b$var$U;){
        b = $0acc653c28085d6b$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $0acc653c28085d6b$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0acc653c28085d6b$var$p(163));
            }
        } catch (D) {
            $0acc653c28085d6b$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0acc653c28085d6b$var$U = a;
            break;
        }
        $0acc653c28085d6b$var$U = b.return;
    }
    m = $0acc653c28085d6b$var$xk;
    $0acc653c28085d6b$var$xk = !1;
    return m;
}
function $0acc653c28085d6b$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentPassiveEffectUnmountStarted && $0acc653c28085d6b$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $0acc653c28085d6b$var$uc(b), $0acc653c28085d6b$var$wk(b, c, f), 0 !== (a & 8) ? null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentPassiveEffectUnmountStopped && $0acc653c28085d6b$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $0acc653c28085d6b$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0acc653c28085d6b$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentPassiveEffectMountStarted && $0acc653c28085d6b$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentLayoutEffectMountStarted && $0acc653c28085d6b$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentPassiveEffectMountStopped && $0acc653c28085d6b$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentLayoutEffectMountStopped && $0acc653c28085d6b$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $0acc653c28085d6b$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $0acc653c28085d6b$var$cj(), b(c);
            } finally{
                $0acc653c28085d6b$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $0acc653c28085d6b$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0acc653c28085d6b$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0acc653c28085d6b$var$bg], delete b[$0acc653c28085d6b$var$cg], delete b[$0acc653c28085d6b$var$Cf], delete b[$0acc653c28085d6b$var$dg], delete b[$0acc653c28085d6b$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0acc653c28085d6b$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0acc653c28085d6b$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0acc653c28085d6b$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0acc653c28085d6b$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0acc653c28085d6b$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($0acc653c28085d6b$var$Fk(a, b, c), a = a.sibling; null !== a;)$0acc653c28085d6b$var$Fk(a, b, c), a = a.sibling;
}
function $0acc653c28085d6b$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0acc653c28085d6b$var$Gk(a, b, c), a = a.sibling; null !== a;)$0acc653c28085d6b$var$Gk(a, b, c), a = a.sibling;
}
var $0acc653c28085d6b$var$X = null, $0acc653c28085d6b$var$Hk = !1;
function $0acc653c28085d6b$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$0acc653c28085d6b$var$Jk(a, b, c), c = c.sibling;
}
function $0acc653c28085d6b$var$Jk(a, b, c) {
    if ($0acc653c28085d6b$var$lc && "function" === typeof $0acc653c28085d6b$var$lc.onCommitFiberUnmount) try {
        $0acc653c28085d6b$var$lc.onCommitFiberUnmount($0acc653c28085d6b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0acc653c28085d6b$var$qk || $0acc653c28085d6b$var$vk(c, b);
        case 6:
            var d = $0acc653c28085d6b$var$X, e = $0acc653c28085d6b$var$Hk;
            $0acc653c28085d6b$var$X = null;
            $0acc653c28085d6b$var$Ik(a, b, c);
            $0acc653c28085d6b$var$X = d;
            $0acc653c28085d6b$var$Hk = e;
            null !== $0acc653c28085d6b$var$X && ($0acc653c28085d6b$var$Hk ? (a = $0acc653c28085d6b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0acc653c28085d6b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0acc653c28085d6b$var$X && ($0acc653c28085d6b$var$Hk ? (a = $0acc653c28085d6b$var$X, c = c.stateNode, 8 === a.nodeType ? $0acc653c28085d6b$var$Yf(a.parentNode, c) : 1 === a.nodeType && $0acc653c28085d6b$var$Yf(a, c), $0acc653c28085d6b$var$pd(a)) : $0acc653c28085d6b$var$Yf($0acc653c28085d6b$var$X, c.stateNode));
            break;
        case 4:
            d = $0acc653c28085d6b$var$X;
            e = $0acc653c28085d6b$var$Hk;
            $0acc653c28085d6b$var$X = c.stateNode.containerInfo;
            $0acc653c28085d6b$var$Hk = !0;
            $0acc653c28085d6b$var$Ik(a, b, c);
            $0acc653c28085d6b$var$X = d;
            $0acc653c28085d6b$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0acc653c28085d6b$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0acc653c28085d6b$var$wk(c, b, g) : 0 !== (f & 4) && ($0acc653c28085d6b$var$uc(c), c.mode & 2 ? ($0acc653c28085d6b$var$cj(), $0acc653c28085d6b$var$wk(c, b, g), $0acc653c28085d6b$var$aj(c)) : $0acc653c28085d6b$var$wk(c, b, g), $0acc653c28085d6b$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $0acc653c28085d6b$var$Ik(a, b, c);
            break;
        case 1:
            if (!$0acc653c28085d6b$var$qk && ($0acc653c28085d6b$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $0acc653c28085d6b$var$uk(c, d);
            } catch (h) {
                $0acc653c28085d6b$var$W(c, b, h);
            }
            $0acc653c28085d6b$var$Ik(a, b, c);
            break;
        case 21:
            $0acc653c28085d6b$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0acc653c28085d6b$var$qk = (d = $0acc653c28085d6b$var$qk) || null !== c.memoizedState, $0acc653c28085d6b$var$Ik(a, b, c), $0acc653c28085d6b$var$qk = d) : $0acc653c28085d6b$var$Ik(a, b, c);
            break;
        default:
            $0acc653c28085d6b$var$Ik(a, b, c);
    }
}
function $0acc653c28085d6b$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0acc653c28085d6b$var$rk);
        b.forEach(function(b) {
            var d = $0acc653c28085d6b$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($0acc653c28085d6b$var$mc) {
                    if (null !== $0acc653c28085d6b$var$sk && null !== $0acc653c28085d6b$var$tk) $0acc653c28085d6b$var$wj($0acc653c28085d6b$var$tk, $0acc653c28085d6b$var$sk);
                    else throw Error($0acc653c28085d6b$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $0acc653c28085d6b$var$Mk(a, b, c) {
    $0acc653c28085d6b$var$sk = c;
    $0acc653c28085d6b$var$tk = a;
    $0acc653c28085d6b$var$Nk(b, a);
    $0acc653c28085d6b$var$tk = $0acc653c28085d6b$var$sk = null;
}
function $0acc653c28085d6b$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0acc653c28085d6b$var$X = h.stateNode;
                        $0acc653c28085d6b$var$Hk = !1;
                        break a;
                    case 3:
                        $0acc653c28085d6b$var$X = h.stateNode.containerInfo;
                        $0acc653c28085d6b$var$Hk = !0;
                        break a;
                    case 4:
                        $0acc653c28085d6b$var$X = h.stateNode.containerInfo;
                        $0acc653c28085d6b$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0acc653c28085d6b$var$X) throw Error($0acc653c28085d6b$var$p(160));
            $0acc653c28085d6b$var$Jk(f, g, e);
            $0acc653c28085d6b$var$X = null;
            $0acc653c28085d6b$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0acc653c28085d6b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0acc653c28085d6b$var$Nk(b, a), b = b.sibling;
}
function $0acc653c28085d6b$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0acc653c28085d6b$var$Ok(b, a);
            $0acc653c28085d6b$var$Pk(a);
            if (d & 4) {
                try {
                    $0acc653c28085d6b$var$zk(3, a, a.return), $0acc653c28085d6b$var$Ak(3, a);
                } catch (m) {
                    $0acc653c28085d6b$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $0acc653c28085d6b$var$cj(), $0acc653c28085d6b$var$zk(5, a, a.return);
                    } catch (m) {
                        $0acc653c28085d6b$var$W(a, a.return, m);
                    }
                    $0acc653c28085d6b$var$aj(a);
                } else try {
                    $0acc653c28085d6b$var$zk(5, a, a.return);
                } catch (m) {
                    $0acc653c28085d6b$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $0acc653c28085d6b$var$Ok(b, a);
            $0acc653c28085d6b$var$Pk(a);
            d & 512 && null !== c && $0acc653c28085d6b$var$vk(c, c.return);
            break;
        case 5:
            $0acc653c28085d6b$var$Ok(b, a);
            $0acc653c28085d6b$var$Pk(a);
            d & 512 && null !== c && $0acc653c28085d6b$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0acc653c28085d6b$var$ob(e, "");
                } catch (m) {
                    $0acc653c28085d6b$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0acc653c28085d6b$var$$a(e, f);
                    $0acc653c28085d6b$var$vb(h, g);
                    var l = $0acc653c28085d6b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $0acc653c28085d6b$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $0acc653c28085d6b$var$nb(e, q) : "children" === n ? $0acc653c28085d6b$var$ob(e, q) : $0acc653c28085d6b$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $0acc653c28085d6b$var$ab(e, f);
                            break;
                        case "textarea":
                            $0acc653c28085d6b$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $0acc653c28085d6b$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0acc653c28085d6b$var$eb(e, !!f.multiple, f.defaultValue, !0) : $0acc653c28085d6b$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0acc653c28085d6b$var$cg] = f;
                } catch (m) {
                    $0acc653c28085d6b$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $0acc653c28085d6b$var$Ok(b, a);
            $0acc653c28085d6b$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0acc653c28085d6b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $0acc653c28085d6b$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $0acc653c28085d6b$var$Ok(b, a);
            $0acc653c28085d6b$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0acc653c28085d6b$var$pd(b.containerInfo);
            } catch (m) {
                $0acc653c28085d6b$var$W(a, a.return, m);
            }
            break;
        case 4:
            $0acc653c28085d6b$var$Ok(b, a);
            $0acc653c28085d6b$var$Pk(a);
            break;
        case 13:
            $0acc653c28085d6b$var$Ok(b, a);
            $0acc653c28085d6b$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0acc653c28085d6b$var$Qk = $0acc653c28085d6b$var$A()));
            d & 4 && $0acc653c28085d6b$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0acc653c28085d6b$var$qk = (l = $0acc653c28085d6b$var$qk) || n, $0acc653c28085d6b$var$Ok(b, a), $0acc653c28085d6b$var$qk = l) : $0acc653c28085d6b$var$Ok(b, a);
            $0acc653c28085d6b$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($0acc653c28085d6b$var$U = a, n = a.child; null !== n;){
                    for(q = $0acc653c28085d6b$var$U = n; null !== $0acc653c28085d6b$var$U;){
                        r = $0acc653c28085d6b$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $0acc653c28085d6b$var$cj(), $0acc653c28085d6b$var$zk(4, r, r.return);
                                } finally{
                                    $0acc653c28085d6b$var$aj(r);
                                }
                                else $0acc653c28085d6b$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $0acc653c28085d6b$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $0acc653c28085d6b$var$uk(c, d);
                                    } catch (m) {
                                        $0acc653c28085d6b$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $0acc653c28085d6b$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0acc653c28085d6b$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $0acc653c28085d6b$var$U = z) : $0acc653c28085d6b$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0acc653c28085d6b$var$rb("display", g));
                            } catch (m) {
                                $0acc653c28085d6b$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $0acc653c28085d6b$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0acc653c28085d6b$var$Ok(b, a);
            $0acc653c28085d6b$var$Pk(a);
            d & 4 && $0acc653c28085d6b$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $0acc653c28085d6b$var$Ok(b, a), $0acc653c28085d6b$var$Pk(a);
    }
}
function $0acc653c28085d6b$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0acc653c28085d6b$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0acc653c28085d6b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0acc653c28085d6b$var$ob(e, ""), d.flags &= -33);
                    var f = $0acc653c28085d6b$var$Ek(a);
                    $0acc653c28085d6b$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0acc653c28085d6b$var$Ek(a);
                    $0acc653c28085d6b$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($0acc653c28085d6b$var$p(161));
            }
        } catch (k) {
            $0acc653c28085d6b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0acc653c28085d6b$var$Sk(a, b, c) {
    $0acc653c28085d6b$var$sk = c;
    $0acc653c28085d6b$var$tk = b;
    $0acc653c28085d6b$var$U = a;
    $0acc653c28085d6b$var$Tk(a, b, c);
    $0acc653c28085d6b$var$tk = $0acc653c28085d6b$var$sk = null;
}
function $0acc653c28085d6b$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0acc653c28085d6b$var$U;){
        var e = $0acc653c28085d6b$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0acc653c28085d6b$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0acc653c28085d6b$var$qk;
                h = $0acc653c28085d6b$var$pk;
                var l = $0acc653c28085d6b$var$qk;
                $0acc653c28085d6b$var$pk = g;
                if (($0acc653c28085d6b$var$qk = k) && !l) for($0acc653c28085d6b$var$U = e; null !== $0acc653c28085d6b$var$U;)g = $0acc653c28085d6b$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0acc653c28085d6b$var$Uk(e) : null !== k ? (k.return = g, $0acc653c28085d6b$var$U = k) : $0acc653c28085d6b$var$Uk(e);
                for(; null !== f;)$0acc653c28085d6b$var$U = f, $0acc653c28085d6b$var$Tk(f, b, c), f = f.sibling;
                $0acc653c28085d6b$var$U = e;
                $0acc653c28085d6b$var$pk = h;
                $0acc653c28085d6b$var$qk = l;
            }
            $0acc653c28085d6b$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0acc653c28085d6b$var$U = f) : $0acc653c28085d6b$var$Vk(a, b, c);
    }
}
function $0acc653c28085d6b$var$Vk(a) {
    for(; null !== $0acc653c28085d6b$var$U;){
        var b = $0acc653c28085d6b$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$0acc653c28085d6b$var$qk) {
                            if (b.mode & 2) try {
                                $0acc653c28085d6b$var$cj(), $0acc653c28085d6b$var$Ak(5, b);
                            } finally{
                                $0acc653c28085d6b$var$aj(b);
                            }
                            else $0acc653c28085d6b$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0acc653c28085d6b$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $0acc653c28085d6b$var$cj(), d.componentDidMount();
                                } finally{
                                    $0acc653c28085d6b$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0acc653c28085d6b$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $0acc653c28085d6b$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $0acc653c28085d6b$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $0acc653c28085d6b$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $0acc653c28085d6b$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $0acc653c28085d6b$var$Ui;
                        c = null === c ? "mount" : "update";
                        $0acc653c28085d6b$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $0acc653c28085d6b$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $0acc653c28085d6b$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0acc653c28085d6b$var$p(163));
                }
                $0acc653c28085d6b$var$qk || b.flags & 512 && $0acc653c28085d6b$var$Bk(b);
            } catch (v) {
                $0acc653c28085d6b$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $0acc653c28085d6b$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $0acc653c28085d6b$var$U = k;
            break;
        }
        $0acc653c28085d6b$var$U = b.return;
    }
}
function $0acc653c28085d6b$var$Rk(a) {
    for(; null !== $0acc653c28085d6b$var$U;){
        var b = $0acc653c28085d6b$var$U;
        if (b === a) {
            $0acc653c28085d6b$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0acc653c28085d6b$var$U = c;
            break;
        }
        $0acc653c28085d6b$var$U = b.return;
    }
}
function $0acc653c28085d6b$var$Uk(a) {
    for(; null !== $0acc653c28085d6b$var$U;){
        var b = $0acc653c28085d6b$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $0acc653c28085d6b$var$cj();
                        var c = b.return;
                        try {
                            $0acc653c28085d6b$var$Ak(4, b);
                        } catch (l) {
                            $0acc653c28085d6b$var$W(b, c, l);
                        }
                    } finally{
                        $0acc653c28085d6b$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $0acc653c28085d6b$var$Ak(4, b);
                        } catch (l) {
                            $0acc653c28085d6b$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $0acc653c28085d6b$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $0acc653c28085d6b$var$Bk(b);
                    } catch (l) {
                        $0acc653c28085d6b$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $0acc653c28085d6b$var$Bk(b);
                    } catch (l) {
                        $0acc653c28085d6b$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $0acc653c28085d6b$var$W(b, b.return, l);
        }
        if (b === a) {
            $0acc653c28085d6b$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $0acc653c28085d6b$var$U = k;
            break;
        }
        $0acc653c28085d6b$var$U = b.return;
    }
}
var $0acc653c28085d6b$var$Xk = Math.ceil, $0acc653c28085d6b$var$Yk = $0acc653c28085d6b$var$va.ReactCurrentDispatcher, $0acc653c28085d6b$var$Zk = $0acc653c28085d6b$var$va.ReactCurrentOwner, $0acc653c28085d6b$var$$k = $0acc653c28085d6b$var$va.ReactCurrentBatchConfig, $0acc653c28085d6b$var$K = 0, $0acc653c28085d6b$var$Q = null, $0acc653c28085d6b$var$Y = null, $0acc653c28085d6b$var$Z = 0, $0acc653c28085d6b$var$Jj = 0, $0acc653c28085d6b$var$Ij = $0acc653c28085d6b$var$hg(0), $0acc653c28085d6b$var$T = 0, $0acc653c28085d6b$var$al = null, $0acc653c28085d6b$var$Fh = 0, $0acc653c28085d6b$var$bl = 0, $0acc653c28085d6b$var$cl = 0, $0acc653c28085d6b$var$dl = null, $0acc653c28085d6b$var$el = null, $0acc653c28085d6b$var$Qk = 0, $0acc653c28085d6b$var$mk = Infinity, $0acc653c28085d6b$var$fl = null, $0acc653c28085d6b$var$qj = !1, $0acc653c28085d6b$var$rj = null, $0acc653c28085d6b$var$tj = null, $0acc653c28085d6b$var$gl = !1, $0acc653c28085d6b$var$hl = null, $0acc653c28085d6b$var$il = 0, $0acc653c28085d6b$var$jl = [], $0acc653c28085d6b$var$kl = 0, $0acc653c28085d6b$var$ll = null, $0acc653c28085d6b$var$ml = -1, $0acc653c28085d6b$var$nl = 0;
function $0acc653c28085d6b$var$Ri() {
    return 0 !== ($0acc653c28085d6b$var$K & 6) ? $0acc653c28085d6b$var$A() : -1 !== $0acc653c28085d6b$var$ml ? $0acc653c28085d6b$var$ml : $0acc653c28085d6b$var$ml = $0acc653c28085d6b$var$A();
}
function $0acc653c28085d6b$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0acc653c28085d6b$var$K & 2) && 0 !== $0acc653c28085d6b$var$Z) return $0acc653c28085d6b$var$Z & -$0acc653c28085d6b$var$Z;
    if (null !== $0acc653c28085d6b$var$Yg.transition) return 0 === $0acc653c28085d6b$var$nl && ($0acc653c28085d6b$var$nl = $0acc653c28085d6b$var$Kc()), $0acc653c28085d6b$var$nl;
    a = $0acc653c28085d6b$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0acc653c28085d6b$var$xd(a.type);
    return a;
}
function $0acc653c28085d6b$var$ui(a, b, c, d) {
    if (50 < $0acc653c28085d6b$var$kl) throw $0acc653c28085d6b$var$kl = 0, $0acc653c28085d6b$var$ll = null, Error($0acc653c28085d6b$var$p(185));
    $0acc653c28085d6b$var$Mc(a, c, d);
    if (0 === ($0acc653c28085d6b$var$K & 2) || a !== $0acc653c28085d6b$var$Q) $0acc653c28085d6b$var$mc && $0acc653c28085d6b$var$Pc(a, b, c), a === $0acc653c28085d6b$var$Q && (0 === ($0acc653c28085d6b$var$K & 2) && ($0acc653c28085d6b$var$bl |= c), 4 === $0acc653c28085d6b$var$T && $0acc653c28085d6b$var$ol(a, $0acc653c28085d6b$var$Z)), $0acc653c28085d6b$var$pl(a, d), 1 === c && 0 === $0acc653c28085d6b$var$K && 0 === (b.mode & 1) && ($0acc653c28085d6b$var$mk = $0acc653c28085d6b$var$A() + 500, $0acc653c28085d6b$var$tg && $0acc653c28085d6b$var$xg());
}
function $0acc653c28085d6b$var$pl(a, b) {
    var c = a.callbackNode;
    $0acc653c28085d6b$var$Ic(a, b);
    var d = $0acc653c28085d6b$var$Gc(a, a === $0acc653c28085d6b$var$Q ? $0acc653c28085d6b$var$Z : 0);
    if (0 === d) null !== c && $0acc653c28085d6b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0acc653c28085d6b$var$bc(c);
        if (1 === b) 0 === a.tag ? $0acc653c28085d6b$var$wg($0acc653c28085d6b$var$ql.bind(null, a)) : $0acc653c28085d6b$var$vg($0acc653c28085d6b$var$ql.bind(null, a)), $0acc653c28085d6b$var$Xf(function() {
            0 === ($0acc653c28085d6b$var$K & 6) && $0acc653c28085d6b$var$xg();
        }), c = null;
        else {
            switch($0acc653c28085d6b$var$Rc(d)){
                case 1:
                    c = $0acc653c28085d6b$var$fc;
                    break;
                case 4:
                    c = $0acc653c28085d6b$var$gc;
                    break;
                case 16:
                    c = $0acc653c28085d6b$var$hc;
                    break;
                case 536870912:
                    c = $0acc653c28085d6b$var$jc;
                    break;
                default:
                    c = $0acc653c28085d6b$var$hc;
            }
            c = $0acc653c28085d6b$var$rl(c, $0acc653c28085d6b$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0acc653c28085d6b$var$sl(a, b) {
    $0acc653c28085d6b$var$Zi = $0acc653c28085d6b$var$Yi = !1;
    $0acc653c28085d6b$var$ml = -1;
    $0acc653c28085d6b$var$nl = 0;
    if (0 !== ($0acc653c28085d6b$var$K & 6)) throw Error($0acc653c28085d6b$var$p(327));
    var c = a.callbackNode;
    if ($0acc653c28085d6b$var$tl() && a.callbackNode !== c) return null;
    var d = $0acc653c28085d6b$var$Gc(a, a === $0acc653c28085d6b$var$Q ? $0acc653c28085d6b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0acc653c28085d6b$var$ul(a, d);
    else {
        b = d;
        var e = $0acc653c28085d6b$var$K;
        $0acc653c28085d6b$var$K |= 2;
        var f = $0acc653c28085d6b$var$vl();
        if ($0acc653c28085d6b$var$Q !== a || $0acc653c28085d6b$var$Z !== b) {
            if ($0acc653c28085d6b$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($0acc653c28085d6b$var$wj(a, $0acc653c28085d6b$var$Z), g.clear());
                $0acc653c28085d6b$var$Qc(a, b);
            }
            $0acc653c28085d6b$var$fl = null;
            $0acc653c28085d6b$var$mk = $0acc653c28085d6b$var$A() + 500;
            $0acc653c28085d6b$var$wl(a, b);
        }
        $0acc653c28085d6b$var$wc(b);
        for(;;)try {
            $0acc653c28085d6b$var$xl();
            break;
        } catch (h) {
            $0acc653c28085d6b$var$yl(a, h);
        }
        $0acc653c28085d6b$var$nh();
        $0acc653c28085d6b$var$Yk.current = f;
        $0acc653c28085d6b$var$K = e;
        null !== $0acc653c28085d6b$var$Y ? (null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markRenderYielded && $0acc653c28085d6b$var$B.markRenderYielded(), b = 0) : ($0acc653c28085d6b$var$xc(), $0acc653c28085d6b$var$Q = null, $0acc653c28085d6b$var$Z = 0, b = $0acc653c28085d6b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0acc653c28085d6b$var$Jc(a), 0 !== e && (d = e, b = $0acc653c28085d6b$var$zl(a, e)));
        if (1 === b) throw c = $0acc653c28085d6b$var$al, $0acc653c28085d6b$var$wl(a, 0), $0acc653c28085d6b$var$ol(a, d), $0acc653c28085d6b$var$pl(a, $0acc653c28085d6b$var$A()), c;
        if (6 === b) $0acc653c28085d6b$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0acc653c28085d6b$var$Al(e) && (b = $0acc653c28085d6b$var$ul(a, d), 2 === b && (f = $0acc653c28085d6b$var$Jc(a), 0 !== f && (d = f, b = $0acc653c28085d6b$var$zl(a, f))), 1 === b)) throw c = $0acc653c28085d6b$var$al, $0acc653c28085d6b$var$wl(a, 0), $0acc653c28085d6b$var$ol(a, d), $0acc653c28085d6b$var$pl(a, $0acc653c28085d6b$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0acc653c28085d6b$var$p(345));
                case 2:
                    $0acc653c28085d6b$var$Cl(a, $0acc653c28085d6b$var$el, $0acc653c28085d6b$var$fl);
                    break;
                case 3:
                    $0acc653c28085d6b$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $0acc653c28085d6b$var$Qk + 500 - $0acc653c28085d6b$var$A(), 10 < b)) {
                        if (0 !== $0acc653c28085d6b$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0acc653c28085d6b$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0acc653c28085d6b$var$Tf($0acc653c28085d6b$var$Cl.bind(null, a, $0acc653c28085d6b$var$el, $0acc653c28085d6b$var$fl), b);
                        break;
                    }
                    $0acc653c28085d6b$var$Cl(a, $0acc653c28085d6b$var$el, $0acc653c28085d6b$var$fl);
                    break;
                case 4:
                    $0acc653c28085d6b$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $0acc653c28085d6b$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $0acc653c28085d6b$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0acc653c28085d6b$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0acc653c28085d6b$var$Tf($0acc653c28085d6b$var$Cl.bind(null, a, $0acc653c28085d6b$var$el, $0acc653c28085d6b$var$fl), d);
                        break;
                    }
                    $0acc653c28085d6b$var$Cl(a, $0acc653c28085d6b$var$el, $0acc653c28085d6b$var$fl);
                    break;
                case 5:
                    $0acc653c28085d6b$var$Cl(a, $0acc653c28085d6b$var$el, $0acc653c28085d6b$var$fl);
                    break;
                default:
                    throw Error($0acc653c28085d6b$var$p(329));
            }
        }
    }
    $0acc653c28085d6b$var$pl(a, $0acc653c28085d6b$var$A());
    return a.callbackNode === c ? $0acc653c28085d6b$var$sl.bind(null, a) : null;
}
function $0acc653c28085d6b$var$zl(a, b) {
    var c = $0acc653c28085d6b$var$dl;
    a.current.memoizedState.isDehydrated && ($0acc653c28085d6b$var$wl(a, b).flags |= 256);
    a = $0acc653c28085d6b$var$ul(a, b);
    2 !== a && (b = $0acc653c28085d6b$var$el, $0acc653c28085d6b$var$el = c, null !== b && $0acc653c28085d6b$var$lk(b));
    return a;
}
function $0acc653c28085d6b$var$lk(a) {
    null === $0acc653c28085d6b$var$el ? $0acc653c28085d6b$var$el = a : $0acc653c28085d6b$var$el.push.apply($0acc653c28085d6b$var$el, a);
}
function $0acc653c28085d6b$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0acc653c28085d6b$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0acc653c28085d6b$var$ol(a, b) {
    b &= ~$0acc653c28085d6b$var$cl;
    b &= ~$0acc653c28085d6b$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0acc653c28085d6b$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0acc653c28085d6b$var$ql(a) {
    $0acc653c28085d6b$var$Yi = $0acc653c28085d6b$var$Zi;
    $0acc653c28085d6b$var$Zi = !1;
    if (0 !== ($0acc653c28085d6b$var$K & 6)) throw Error($0acc653c28085d6b$var$p(327));
    $0acc653c28085d6b$var$tl();
    var b = $0acc653c28085d6b$var$Gc(a, 0);
    if (0 === (b & 1)) return $0acc653c28085d6b$var$pl(a, $0acc653c28085d6b$var$A()), null;
    var c = $0acc653c28085d6b$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0acc653c28085d6b$var$Jc(a);
        0 !== d && (b = d, c = $0acc653c28085d6b$var$zl(a, d));
    }
    if (1 === c) throw c = $0acc653c28085d6b$var$al, $0acc653c28085d6b$var$wl(a, 0), $0acc653c28085d6b$var$ol(a, b), $0acc653c28085d6b$var$pl(a, $0acc653c28085d6b$var$A()), c;
    if (6 === c) throw Error($0acc653c28085d6b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0acc653c28085d6b$var$Cl(a, $0acc653c28085d6b$var$el, $0acc653c28085d6b$var$fl);
    $0acc653c28085d6b$var$pl(a, $0acc653c28085d6b$var$A());
    return null;
}
function $0acc653c28085d6b$var$Dl(a, b) {
    var c = $0acc653c28085d6b$var$K;
    $0acc653c28085d6b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0acc653c28085d6b$var$K = c, 0 === $0acc653c28085d6b$var$K && ($0acc653c28085d6b$var$mk = $0acc653c28085d6b$var$A() + 500, $0acc653c28085d6b$var$tg && $0acc653c28085d6b$var$xg());
    }
}
function $0acc653c28085d6b$var$El(a) {
    null !== $0acc653c28085d6b$var$hl && 0 === $0acc653c28085d6b$var$hl.tag && 0 === ($0acc653c28085d6b$var$K & 6) && $0acc653c28085d6b$var$tl();
    var b = $0acc653c28085d6b$var$K;
    $0acc653c28085d6b$var$K |= 1;
    var c = $0acc653c28085d6b$var$$k.transition, d = $0acc653c28085d6b$var$E;
    try {
        if ($0acc653c28085d6b$var$$k.transition = null, $0acc653c28085d6b$var$E = 1, a) return a();
    } finally{
        $0acc653c28085d6b$var$E = d, $0acc653c28085d6b$var$$k.transition = c, $0acc653c28085d6b$var$K = b, 0 === ($0acc653c28085d6b$var$K & 6) && $0acc653c28085d6b$var$xg();
    }
}
function $0acc653c28085d6b$var$nk() {
    $0acc653c28085d6b$var$Jj = $0acc653c28085d6b$var$Ij.current;
    $0acc653c28085d6b$var$G($0acc653c28085d6b$var$Ij);
}
function $0acc653c28085d6b$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0acc653c28085d6b$var$Uf(c));
    if (null !== $0acc653c28085d6b$var$Y) for(c = $0acc653c28085d6b$var$Y.return; null !== c;){
        var d = c;
        $0acc653c28085d6b$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0acc653c28085d6b$var$ng();
                break;
            case 3:
                $0acc653c28085d6b$var$Nh();
                $0acc653c28085d6b$var$G($0acc653c28085d6b$var$jg);
                $0acc653c28085d6b$var$G($0acc653c28085d6b$var$I);
                $0acc653c28085d6b$var$Sh();
                break;
            case 5:
                $0acc653c28085d6b$var$Ph(d);
                break;
            case 4:
                $0acc653c28085d6b$var$Nh();
                break;
            case 13:
                $0acc653c28085d6b$var$G($0acc653c28085d6b$var$L);
                break;
            case 19:
                $0acc653c28085d6b$var$G($0acc653c28085d6b$var$L);
                break;
            case 10:
                $0acc653c28085d6b$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $0acc653c28085d6b$var$nk();
        }
        c = c.return;
    }
    $0acc653c28085d6b$var$Q = a;
    $0acc653c28085d6b$var$Y = a = $0acc653c28085d6b$var$ch(a.current, null);
    $0acc653c28085d6b$var$Z = $0acc653c28085d6b$var$Jj = b;
    $0acc653c28085d6b$var$T = 0;
    $0acc653c28085d6b$var$al = null;
    $0acc653c28085d6b$var$cl = $0acc653c28085d6b$var$bl = $0acc653c28085d6b$var$Fh = 0;
    $0acc653c28085d6b$var$el = $0acc653c28085d6b$var$dl = null;
    if (null !== $0acc653c28085d6b$var$th) {
        for(b = 0; b < $0acc653c28085d6b$var$th.length; b++)if (c = $0acc653c28085d6b$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0acc653c28085d6b$var$th = null;
    }
    return a;
}
function $0acc653c28085d6b$var$yl(a, b) {
    do {
        var c = $0acc653c28085d6b$var$Y;
        try {
            $0acc653c28085d6b$var$nh();
            $0acc653c28085d6b$var$Th.current = $0acc653c28085d6b$var$ei;
            if ($0acc653c28085d6b$var$Wh) {
                for(var d = $0acc653c28085d6b$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0acc653c28085d6b$var$Wh = !1;
            }
            $0acc653c28085d6b$var$Vh = 0;
            $0acc653c28085d6b$var$O = $0acc653c28085d6b$var$N = $0acc653c28085d6b$var$M = null;
            $0acc653c28085d6b$var$Xh = !1;
            $0acc653c28085d6b$var$Yh = 0;
            $0acc653c28085d6b$var$Zk.current = null;
            if (null === c || null === c.return) {
                $0acc653c28085d6b$var$T = 1;
                $0acc653c28085d6b$var$al = b;
                $0acc653c28085d6b$var$Y = null;
                break;
            }
            c.mode & 2 && $0acc653c28085d6b$var$$i(c, !0);
            $0acc653c28085d6b$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentSuspended && $0acc653c28085d6b$var$B.markComponentSuspended(c, f, $0acc653c28085d6b$var$Z);
            } else null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markComponentErrored && $0acc653c28085d6b$var$B.markComponentErrored(c, b, $0acc653c28085d6b$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $0acc653c28085d6b$var$Z;
                k.flags |= 32768;
                $0acc653c28085d6b$var$mc && $0acc653c28085d6b$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $0acc653c28085d6b$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $0acc653c28085d6b$var$yj(z, h, k, g, b);
                        z.mode & 1 && $0acc653c28085d6b$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0acc653c28085d6b$var$uj(g, l, b);
                            $0acc653c28085d6b$var$Zj();
                            break a;
                        }
                        f = Error($0acc653c28085d6b$var$p(426));
                    }
                } else if ($0acc653c28085d6b$var$J && k.mode & 1) {
                    var C = $0acc653c28085d6b$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $0acc653c28085d6b$var$yj(C, h, k, g, b);
                        $0acc653c28085d6b$var$Xg($0acc653c28085d6b$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $0acc653c28085d6b$var$lj(f, k);
                4 !== $0acc653c28085d6b$var$T && ($0acc653c28085d6b$var$T = 2);
                null === $0acc653c28085d6b$var$dl ? $0acc653c28085d6b$var$dl = [
                    g
                ] : $0acc653c28085d6b$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $0acc653c28085d6b$var$pj(g, f, b);
                            $0acc653c28085d6b$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $0acc653c28085d6b$var$tj || !$0acc653c28085d6b$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $0acc653c28085d6b$var$sj(g, k, b);
                                $0acc653c28085d6b$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $0acc653c28085d6b$var$Fl(c);
        } catch (ca) {
            b = ca;
            $0acc653c28085d6b$var$Y === c && null !== c && ($0acc653c28085d6b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0acc653c28085d6b$var$vl() {
    var a = $0acc653c28085d6b$var$Yk.current;
    $0acc653c28085d6b$var$Yk.current = $0acc653c28085d6b$var$ei;
    return null === a ? $0acc653c28085d6b$var$ei : a;
}
function $0acc653c28085d6b$var$Zj() {
    if (0 === $0acc653c28085d6b$var$T || 3 === $0acc653c28085d6b$var$T || 2 === $0acc653c28085d6b$var$T) $0acc653c28085d6b$var$T = 4;
    null === $0acc653c28085d6b$var$Q || 0 === ($0acc653c28085d6b$var$Fh & 268435455) && 0 === ($0acc653c28085d6b$var$bl & 268435455) || $0acc653c28085d6b$var$ol($0acc653c28085d6b$var$Q, $0acc653c28085d6b$var$Z);
}
function $0acc653c28085d6b$var$ul(a, b) {
    var c = $0acc653c28085d6b$var$K;
    $0acc653c28085d6b$var$K |= 2;
    var d = $0acc653c28085d6b$var$vl();
    if ($0acc653c28085d6b$var$Q !== a || $0acc653c28085d6b$var$Z !== b) {
        if ($0acc653c28085d6b$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($0acc653c28085d6b$var$wj(a, $0acc653c28085d6b$var$Z), e.clear());
            $0acc653c28085d6b$var$Qc(a, b);
        }
        $0acc653c28085d6b$var$fl = null;
        $0acc653c28085d6b$var$wl(a, b);
    }
    $0acc653c28085d6b$var$wc(b);
    for(;;)try {
        $0acc653c28085d6b$var$Gl();
        break;
    } catch (f) {
        $0acc653c28085d6b$var$yl(a, f);
    }
    $0acc653c28085d6b$var$nh();
    $0acc653c28085d6b$var$K = c;
    $0acc653c28085d6b$var$Yk.current = d;
    if (null !== $0acc653c28085d6b$var$Y) throw Error($0acc653c28085d6b$var$p(261));
    $0acc653c28085d6b$var$xc();
    $0acc653c28085d6b$var$Q = null;
    $0acc653c28085d6b$var$Z = 0;
    return $0acc653c28085d6b$var$T;
}
function $0acc653c28085d6b$var$Gl() {
    for(; null !== $0acc653c28085d6b$var$Y;)$0acc653c28085d6b$var$Hl($0acc653c28085d6b$var$Y);
}
function $0acc653c28085d6b$var$xl() {
    for(; null !== $0acc653c28085d6b$var$Y && !$0acc653c28085d6b$var$cc();)$0acc653c28085d6b$var$Hl($0acc653c28085d6b$var$Y);
}
function $0acc653c28085d6b$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($0acc653c28085d6b$var$Wi = $0acc653c28085d6b$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $0acc653c28085d6b$var$Ti()), b = $0acc653c28085d6b$var$Il(b, a, $0acc653c28085d6b$var$Jj), $0acc653c28085d6b$var$$i(a, !0)) : b = $0acc653c28085d6b$var$Il(b, a, $0acc653c28085d6b$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0acc653c28085d6b$var$Fl(a) : $0acc653c28085d6b$var$Y = b;
    $0acc653c28085d6b$var$Zk.current = null;
}
function $0acc653c28085d6b$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $0acc653c28085d6b$var$kk(c, b, $0acc653c28085d6b$var$Jj);
            else {
                var d = b;
                $0acc653c28085d6b$var$Wi = $0acc653c28085d6b$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $0acc653c28085d6b$var$Ti());
                c = $0acc653c28085d6b$var$kk(c, b, $0acc653c28085d6b$var$Jj);
                $0acc653c28085d6b$var$$i(b, !1);
            }
            if (null !== c) {
                $0acc653c28085d6b$var$Y = c;
                return;
            }
        } else {
            c = $0acc653c28085d6b$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0acc653c28085d6b$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $0acc653c28085d6b$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0acc653c28085d6b$var$T = 6;
                $0acc653c28085d6b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0acc653c28085d6b$var$Y = b;
            return;
        }
        $0acc653c28085d6b$var$Y = b = a;
    }while (null !== b);
    0 === $0acc653c28085d6b$var$T && ($0acc653c28085d6b$var$T = 5);
}
function $0acc653c28085d6b$var$Cl(a, b, c) {
    var d = $0acc653c28085d6b$var$E, e = $0acc653c28085d6b$var$$k.transition;
    try {
        $0acc653c28085d6b$var$$k.transition = null, $0acc653c28085d6b$var$E = 1, $0acc653c28085d6b$var$Jl(a, b, c, d);
    } finally{
        $0acc653c28085d6b$var$$k.transition = e, $0acc653c28085d6b$var$E = d;
    }
    return null;
}
function $0acc653c28085d6b$var$Jl(a, b, c, d) {
    do $0acc653c28085d6b$var$tl();
    while (null !== $0acc653c28085d6b$var$hl);
    if (0 !== ($0acc653c28085d6b$var$K & 6)) throw Error($0acc653c28085d6b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markCommitStarted && $0acc653c28085d6b$var$B.markCommitStarted(e);
    if (null === c) return $0acc653c28085d6b$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0acc653c28085d6b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0acc653c28085d6b$var$Nc(a, f);
    a === $0acc653c28085d6b$var$Q && ($0acc653c28085d6b$var$Y = $0acc653c28085d6b$var$Q = null, $0acc653c28085d6b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0acc653c28085d6b$var$gl || ($0acc653c28085d6b$var$gl = !0, $0acc653c28085d6b$var$rl($0acc653c28085d6b$var$hc, function() {
        $0acc653c28085d6b$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0acc653c28085d6b$var$$k.transition;
        $0acc653c28085d6b$var$$k.transition = null;
        var g = $0acc653c28085d6b$var$E;
        $0acc653c28085d6b$var$E = 1;
        var h = $0acc653c28085d6b$var$K;
        $0acc653c28085d6b$var$K |= 4;
        $0acc653c28085d6b$var$Zk.current = null;
        $0acc653c28085d6b$var$yk(a, c);
        $0acc653c28085d6b$var$Ui = $0acc653c28085d6b$var$Ti();
        $0acc653c28085d6b$var$Mk(a, c, e);
        $0acc653c28085d6b$var$bf($0acc653c28085d6b$var$Rf);
        $0acc653c28085d6b$var$rd = !!$0acc653c28085d6b$var$Qf;
        $0acc653c28085d6b$var$Rf = $0acc653c28085d6b$var$Qf = null;
        a.current = c;
        null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markLayoutEffectsStarted && $0acc653c28085d6b$var$B.markLayoutEffectsStarted(e);
        $0acc653c28085d6b$var$Sk(c, a, e);
        null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markLayoutEffectsStopped && $0acc653c28085d6b$var$B.markLayoutEffectsStopped();
        $0acc653c28085d6b$var$dc();
        $0acc653c28085d6b$var$K = h;
        $0acc653c28085d6b$var$E = g;
        $0acc653c28085d6b$var$$k.transition = f;
    } else a.current = c, $0acc653c28085d6b$var$Ui = $0acc653c28085d6b$var$Ti();
    $0acc653c28085d6b$var$gl && ($0acc653c28085d6b$var$gl = !1, $0acc653c28085d6b$var$hl = a, $0acc653c28085d6b$var$il = e);
    f = a.pendingLanes;
    0 === f && ($0acc653c28085d6b$var$tj = null);
    $0acc653c28085d6b$var$nc(c.stateNode, d);
    $0acc653c28085d6b$var$mc && a.memoizedUpdaters.clear();
    $0acc653c28085d6b$var$pl(a, $0acc653c28085d6b$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0acc653c28085d6b$var$qj) throw $0acc653c28085d6b$var$qj = !1, a = $0acc653c28085d6b$var$rj, $0acc653c28085d6b$var$rj = null, a;
    0 !== ($0acc653c28085d6b$var$il & 1) && 0 !== a.tag && $0acc653c28085d6b$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($0acc653c28085d6b$var$Zi = !0, a === $0acc653c28085d6b$var$ll ? $0acc653c28085d6b$var$kl++ : ($0acc653c28085d6b$var$kl = 0, $0acc653c28085d6b$var$ll = a)) : $0acc653c28085d6b$var$kl = 0;
    $0acc653c28085d6b$var$xg();
    $0acc653c28085d6b$var$rc();
    return null;
}
function $0acc653c28085d6b$var$tl() {
    if (null !== $0acc653c28085d6b$var$hl) {
        var a = $0acc653c28085d6b$var$Rc($0acc653c28085d6b$var$il), b = $0acc653c28085d6b$var$$k.transition, c = $0acc653c28085d6b$var$E;
        try {
            $0acc653c28085d6b$var$$k.transition = null;
            $0acc653c28085d6b$var$E = 16 > a ? 16 : a;
            if (null === $0acc653c28085d6b$var$hl) var d = !1;
            else {
                a = $0acc653c28085d6b$var$hl;
                var e = $0acc653c28085d6b$var$il;
                $0acc653c28085d6b$var$hl = null;
                $0acc653c28085d6b$var$il = 0;
                if (0 !== ($0acc653c28085d6b$var$K & 6)) throw Error($0acc653c28085d6b$var$p(331));
                null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markPassiveEffectsStarted && $0acc653c28085d6b$var$B.markPassiveEffectsStarted(e);
                e = $0acc653c28085d6b$var$K;
                $0acc653c28085d6b$var$K |= 4;
                for($0acc653c28085d6b$var$U = a.current; null !== $0acc653c28085d6b$var$U;){
                    var f = $0acc653c28085d6b$var$U, g = f.child;
                    if (0 !== ($0acc653c28085d6b$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0acc653c28085d6b$var$U = l; null !== $0acc653c28085d6b$var$U;){
                                    var n = $0acc653c28085d6b$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($0acc653c28085d6b$var$Xi = $0acc653c28085d6b$var$Ti(), $0acc653c28085d6b$var$zk(8, q, f), $0acc653c28085d6b$var$bj(q)) : $0acc653c28085d6b$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $0acc653c28085d6b$var$U = r;
                                    else for(; null !== $0acc653c28085d6b$var$U;){
                                        n = $0acc653c28085d6b$var$U;
                                        var z = n.sibling, m = n.return;
                                        $0acc653c28085d6b$var$Ck(n);
                                        if (n === l) {
                                            $0acc653c28085d6b$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $0acc653c28085d6b$var$U = z;
                                            break;
                                        }
                                        $0acc653c28085d6b$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $0acc653c28085d6b$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0acc653c28085d6b$var$U = g;
                    else b: for(; null !== $0acc653c28085d6b$var$U;){
                        f = $0acc653c28085d6b$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($0acc653c28085d6b$var$Xi = $0acc653c28085d6b$var$Ti(), $0acc653c28085d6b$var$zk(9, k, k.return), $0acc653c28085d6b$var$bj(k)) : $0acc653c28085d6b$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $0acc653c28085d6b$var$U = y;
                            break b;
                        }
                        $0acc653c28085d6b$var$U = f.return;
                    }
                }
                var v = a.current;
                for($0acc653c28085d6b$var$U = v; null !== $0acc653c28085d6b$var$U;){
                    g = $0acc653c28085d6b$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $0acc653c28085d6b$var$U = D;
                    else b: for(g = v; null !== $0acc653c28085d6b$var$U;){
                        h = $0acc653c28085d6b$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $0acc653c28085d6b$var$Xi = $0acc653c28085d6b$var$Ti();
                                        try {
                                            $0acc653c28085d6b$var$Ak(9, l);
                                        } finally{
                                            $0acc653c28085d6b$var$bj(l);
                                        }
                                    } else $0acc653c28085d6b$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $0acc653c28085d6b$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $0acc653c28085d6b$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $0acc653c28085d6b$var$U = ca;
                            break b;
                        }
                        $0acc653c28085d6b$var$U = h.return;
                    }
                }
                v = $0acc653c28085d6b$var$jl;
                $0acc653c28085d6b$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $0acc653c28085d6b$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $0acc653c28085d6b$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markPassiveEffectsStopped && $0acc653c28085d6b$var$B.markPassiveEffectsStopped();
                $0acc653c28085d6b$var$K = e;
                $0acc653c28085d6b$var$xg();
                if ($0acc653c28085d6b$var$lc && "function" === typeof $0acc653c28085d6b$var$lc.onPostCommitFiberRoot) try {
                    $0acc653c28085d6b$var$lc.onPostCommitFiberRoot($0acc653c28085d6b$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $0acc653c28085d6b$var$E = c, $0acc653c28085d6b$var$$k.transition = b;
        }
    }
    return !1;
}
function $0acc653c28085d6b$var$Wk(a) {
    $0acc653c28085d6b$var$jl.push(a);
    $0acc653c28085d6b$var$gl || ($0acc653c28085d6b$var$gl = !0, $0acc653c28085d6b$var$rl($0acc653c28085d6b$var$hc, function() {
        $0acc653c28085d6b$var$tl();
        return null;
    }));
}
function $0acc653c28085d6b$var$Kl(a, b, c) {
    b = $0acc653c28085d6b$var$lj(c, b);
    b = $0acc653c28085d6b$var$pj(a, b, 1);
    a = $0acc653c28085d6b$var$Bh(a, b, 1);
    b = $0acc653c28085d6b$var$Ri();
    null !== a && ($0acc653c28085d6b$var$Mc(a, 1, b), $0acc653c28085d6b$var$pl(a, b));
}
function $0acc653c28085d6b$var$W(a, b, c) {
    if (3 === a.tag) $0acc653c28085d6b$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0acc653c28085d6b$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0acc653c28085d6b$var$tj || !$0acc653c28085d6b$var$tj.has(d))) {
                a = $0acc653c28085d6b$var$lj(c, a);
                a = $0acc653c28085d6b$var$sj(b, a, 1);
                b = $0acc653c28085d6b$var$Bh(b, a, 1);
                a = $0acc653c28085d6b$var$Ri();
                null !== b && ($0acc653c28085d6b$var$Mc(b, 1, a), $0acc653c28085d6b$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0acc653c28085d6b$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0acc653c28085d6b$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $0acc653c28085d6b$var$Q === a && ($0acc653c28085d6b$var$Z & c) === c && (4 === $0acc653c28085d6b$var$T || 3 === $0acc653c28085d6b$var$T && ($0acc653c28085d6b$var$Z & 130023424) === $0acc653c28085d6b$var$Z && 500 > $0acc653c28085d6b$var$A() - $0acc653c28085d6b$var$Qk ? $0acc653c28085d6b$var$wl(a, 0) : $0acc653c28085d6b$var$cl |= c);
    $0acc653c28085d6b$var$pl(a, b);
}
function $0acc653c28085d6b$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0acc653c28085d6b$var$Ec, $0acc653c28085d6b$var$Ec <<= 1, 0 === ($0acc653c28085d6b$var$Ec & 130023424) && ($0acc653c28085d6b$var$Ec = 4194304)));
    var c = $0acc653c28085d6b$var$Ri();
    a = $0acc653c28085d6b$var$wh(a, b);
    null !== a && ($0acc653c28085d6b$var$Mc(a, b, c), $0acc653c28085d6b$var$pl(a, c));
}
function $0acc653c28085d6b$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0acc653c28085d6b$var$Ll(a, c);
}
function $0acc653c28085d6b$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0acc653c28085d6b$var$p(314));
    }
    null !== d && d.delete(b);
    $0acc653c28085d6b$var$Ll(a, c);
}
var $0acc653c28085d6b$var$Il;
$0acc653c28085d6b$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0acc653c28085d6b$var$jg.current) $0acc653c28085d6b$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0acc653c28085d6b$var$rh = !1, $0acc653c28085d6b$var$ek(a, b, c);
            $0acc653c28085d6b$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0acc653c28085d6b$var$rh = !1, $0acc653c28085d6b$var$J && 0 !== (b.flags & 1048576) && $0acc653c28085d6b$var$Ig(b, $0acc653c28085d6b$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0acc653c28085d6b$var$Mj(a, b);
            a = b.pendingProps;
            var e = $0acc653c28085d6b$var$lg(b, $0acc653c28085d6b$var$I.current);
            $0acc653c28085d6b$var$qh(b, c);
            $0acc653c28085d6b$var$sc(b);
            e = $0acc653c28085d6b$var$ai(null, b, d, a, e, c);
            var f = $0acc653c28085d6b$var$fi();
            $0acc653c28085d6b$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0acc653c28085d6b$var$mg(d) ? (f = !0, $0acc653c28085d6b$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0acc653c28085d6b$var$yh(b), e.updater = $0acc653c28085d6b$var$gj, b.stateNode = e, e._reactInternals = b, $0acc653c28085d6b$var$kj(b, d, a, c), b = $0acc653c28085d6b$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $0acc653c28085d6b$var$J && f && $0acc653c28085d6b$var$Jg(b), $0acc653c28085d6b$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0acc653c28085d6b$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0acc653c28085d6b$var$Ml(d);
                a = $0acc653c28085d6b$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $0acc653c28085d6b$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0acc653c28085d6b$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0acc653c28085d6b$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0acc653c28085d6b$var$Dj(null, b, d, $0acc653c28085d6b$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($0acc653c28085d6b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0acc653c28085d6b$var$ej(d, e), $0acc653c28085d6b$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0acc653c28085d6b$var$ej(d, e), $0acc653c28085d6b$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $0acc653c28085d6b$var$Oj(b);
                if (null === a) throw Error($0acc653c28085d6b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0acc653c28085d6b$var$zh(a, b);
                $0acc653c28085d6b$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0acc653c28085d6b$var$lj(Error($0acc653c28085d6b$var$p(423)), b);
                        b = $0acc653c28085d6b$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0acc653c28085d6b$var$lj(Error($0acc653c28085d6b$var$p(424)), b);
                        b = $0acc653c28085d6b$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($0acc653c28085d6b$var$Mg = $0acc653c28085d6b$var$Zf(b.stateNode.containerInfo.firstChild), $0acc653c28085d6b$var$Lg = b, $0acc653c28085d6b$var$J = !0, $0acc653c28085d6b$var$Ng = null, c = $0acc653c28085d6b$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0acc653c28085d6b$var$Wg();
                    if (d === e) {
                        b = $0acc653c28085d6b$var$Cj(a, b, c);
                        break a;
                    }
                    $0acc653c28085d6b$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0acc653c28085d6b$var$Oh(b), null === a && $0acc653c28085d6b$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0acc653c28085d6b$var$Sf(d, e) ? g = null : null !== f && $0acc653c28085d6b$var$Sf(d, f) && (b.flags |= 32), $0acc653c28085d6b$var$Kj(a, b), $0acc653c28085d6b$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $0acc653c28085d6b$var$Sg(b), null;
        case 13:
            return $0acc653c28085d6b$var$Uj(a, b, c);
        case 4:
            return $0acc653c28085d6b$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0acc653c28085d6b$var$hh(b, null, d, c) : $0acc653c28085d6b$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0acc653c28085d6b$var$ej(d, e), $0acc653c28085d6b$var$Bj(a, b, d, e, c);
        case 7:
            return $0acc653c28085d6b$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0acc653c28085d6b$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $0acc653c28085d6b$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0acc653c28085d6b$var$H($0acc653c28085d6b$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0acc653c28085d6b$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$0acc653c28085d6b$var$jg.current) {
                            b = $0acc653c28085d6b$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0acc653c28085d6b$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0acc653c28085d6b$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0acc653c28085d6b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0acc653c28085d6b$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0acc653c28085d6b$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0acc653c28085d6b$var$qh(b, c), e = $0acc653c28085d6b$var$sh(e), $0acc653c28085d6b$var$sc(b), d = d(e), $0acc653c28085d6b$var$tc(), b.flags |= 1, $0acc653c28085d6b$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0acc653c28085d6b$var$ej(d, b.pendingProps), e = $0acc653c28085d6b$var$ej(d.type, e), $0acc653c28085d6b$var$Dj(a, b, d, e, c);
        case 15:
            return $0acc653c28085d6b$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0acc653c28085d6b$var$ej(d, e), $0acc653c28085d6b$var$Mj(a, b), b.tag = 1, $0acc653c28085d6b$var$mg(d) ? (a = !0, $0acc653c28085d6b$var$qg(b)) : a = !1, $0acc653c28085d6b$var$qh(b, c), $0acc653c28085d6b$var$ij(b, d, e), $0acc653c28085d6b$var$kj(b, d, e, c), $0acc653c28085d6b$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $0acc653c28085d6b$var$dk(a, b, c);
        case 22:
            return $0acc653c28085d6b$var$Hj(a, b, c);
    }
    throw Error($0acc653c28085d6b$var$p(156, b.tag));
};
function $0acc653c28085d6b$var$wj(a, b) {
    $0acc653c28085d6b$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $0acc653c28085d6b$var$Pc(a, c, b);
    });
}
function $0acc653c28085d6b$var$rl(a, b) {
    return $0acc653c28085d6b$var$ac(a, b);
}
function $0acc653c28085d6b$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $0acc653c28085d6b$var$Pg(a, b, c, d) {
    return new $0acc653c28085d6b$var$Nl(a, b, c, d);
}
function $0acc653c28085d6b$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0acc653c28085d6b$var$Ml(a) {
    if ("function" === typeof a) return $0acc653c28085d6b$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0acc653c28085d6b$var$Da) return 11;
        if (a === $0acc653c28085d6b$var$Ga) return 14;
    }
    return 2;
}
function $0acc653c28085d6b$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $0acc653c28085d6b$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $0acc653c28085d6b$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0acc653c28085d6b$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0acc653c28085d6b$var$ya:
            return $0acc653c28085d6b$var$gh(c.children, e, f, b);
        case $0acc653c28085d6b$var$za:
            g = 8;
            e |= 8;
            break;
        case $0acc653c28085d6b$var$Aa:
            return a = $0acc653c28085d6b$var$Pg(12, c, b, e | 2), a.elementType = $0acc653c28085d6b$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $0acc653c28085d6b$var$Ea:
            return a = $0acc653c28085d6b$var$Pg(13, c, b, e), a.elementType = $0acc653c28085d6b$var$Ea, a.lanes = f, a;
        case $0acc653c28085d6b$var$Fa:
            return a = $0acc653c28085d6b$var$Pg(19, c, b, e), a.elementType = $0acc653c28085d6b$var$Fa, a.lanes = f, a;
        case $0acc653c28085d6b$var$Ia:
            return $0acc653c28085d6b$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0acc653c28085d6b$var$Ba:
                    g = 10;
                    break a;
                case $0acc653c28085d6b$var$Ca:
                    g = 9;
                    break a;
                case $0acc653c28085d6b$var$Da:
                    g = 11;
                    break a;
                case $0acc653c28085d6b$var$Ga:
                    g = 14;
                    break a;
                case $0acc653c28085d6b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0acc653c28085d6b$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0acc653c28085d6b$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0acc653c28085d6b$var$gh(a, b, c, d) {
    a = $0acc653c28085d6b$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0acc653c28085d6b$var$Vj(a, b, c, d) {
    a = $0acc653c28085d6b$var$Pg(22, a, d, b);
    a.elementType = $0acc653c28085d6b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0acc653c28085d6b$var$dh(a, b, c) {
    a = $0acc653c28085d6b$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0acc653c28085d6b$var$fh(a, b, c) {
    b = $0acc653c28085d6b$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0acc653c28085d6b$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0acc653c28085d6b$var$Lc(0);
    this.expirationTimes = $0acc653c28085d6b$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0acc653c28085d6b$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $0acc653c28085d6b$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $0acc653c28085d6b$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $0acc653c28085d6b$var$mc && (b |= 2);
    f = $0acc653c28085d6b$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0acc653c28085d6b$var$yh(f);
    return a;
}
function $0acc653c28085d6b$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0acc653c28085d6b$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0acc653c28085d6b$var$Rl(a) {
    if (!a) return $0acc653c28085d6b$var$ig;
    a = a._reactInternals;
    a: {
        if ($0acc653c28085d6b$var$Vb(a) !== a || 1 !== a.tag) throw Error($0acc653c28085d6b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0acc653c28085d6b$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0acc653c28085d6b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0acc653c28085d6b$var$mg(c)) return $0acc653c28085d6b$var$pg(a, c, b);
    }
    return b;
}
function $0acc653c28085d6b$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $0acc653c28085d6b$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $0acc653c28085d6b$var$Rl(null);
    c = a.current;
    d = $0acc653c28085d6b$var$Ri();
    e = $0acc653c28085d6b$var$Oi(c);
    f = $0acc653c28085d6b$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0acc653c28085d6b$var$Bh(c, f, e);
    a.current.lanes = e;
    $0acc653c28085d6b$var$Mc(a, e, d);
    $0acc653c28085d6b$var$pl(a, d);
    return a;
}
function $0acc653c28085d6b$var$Tl(a, b, c, d) {
    var e = b.current, f = $0acc653c28085d6b$var$Ri(), g = $0acc653c28085d6b$var$Oi(e);
    null !== $0acc653c28085d6b$var$B && "function" === typeof $0acc653c28085d6b$var$B.markRenderScheduled && $0acc653c28085d6b$var$B.markRenderScheduled(g);
    c = $0acc653c28085d6b$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0acc653c28085d6b$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0acc653c28085d6b$var$Bh(e, b, g);
    null !== a && ($0acc653c28085d6b$var$ui(a, e, g, f), $0acc653c28085d6b$var$Ch(a, e, g));
    return g;
}
function $0acc653c28085d6b$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0acc653c28085d6b$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0acc653c28085d6b$var$Wl(a, b) {
    $0acc653c28085d6b$var$Vl(a, b);
    (a = a.alternate) && $0acc653c28085d6b$var$Vl(a, b);
}
function $0acc653c28085d6b$var$Xl() {
    return null;
}
var $0acc653c28085d6b$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0acc653c28085d6b$var$Zl(a) {
    this._internalRoot = a;
}
$0acc653c28085d6b$var$$l.prototype.render = $0acc653c28085d6b$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0acc653c28085d6b$var$p(409));
    $0acc653c28085d6b$var$Tl(a, b, null, null);
};
$0acc653c28085d6b$var$$l.prototype.unmount = $0acc653c28085d6b$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0acc653c28085d6b$var$El(function() {
            $0acc653c28085d6b$var$Tl(null, a, null, null);
        });
        b[$0acc653c28085d6b$var$If] = null;
    }
};
function $0acc653c28085d6b$var$$l(a) {
    this._internalRoot = a;
}
$0acc653c28085d6b$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0acc653c28085d6b$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0acc653c28085d6b$var$dd.length && 0 !== b && b < $0acc653c28085d6b$var$dd[c].priority; c++);
        $0acc653c28085d6b$var$dd.splice(c, 0, a);
        0 === c && $0acc653c28085d6b$var$id(a);
    }
};
function $0acc653c28085d6b$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0acc653c28085d6b$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0acc653c28085d6b$var$cm() {}
function $0acc653c28085d6b$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0acc653c28085d6b$var$Ul(g);
                f.call(a);
            };
        }
        var g = $0acc653c28085d6b$var$Sl(b, d, a, 0, null, !1, !1, "", $0acc653c28085d6b$var$cm);
        a._reactRootContainer = g;
        a[$0acc653c28085d6b$var$If] = g.current;
        $0acc653c28085d6b$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $0acc653c28085d6b$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0acc653c28085d6b$var$Ul(k);
            h.call(a);
        };
    }
    var k = $0acc653c28085d6b$var$Pl(a, 0, !1, null, null, !1, !1, "", $0acc653c28085d6b$var$cm);
    a._reactRootContainer = k;
    a[$0acc653c28085d6b$var$If] = k.current;
    $0acc653c28085d6b$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $0acc653c28085d6b$var$El(function() {
        $0acc653c28085d6b$var$Tl(b, k, c, d);
    });
    return k;
}
function $0acc653c28085d6b$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0acc653c28085d6b$var$Ul(g);
                h.call(a);
            };
        }
        $0acc653c28085d6b$var$Tl(b, g, a, e);
    } else g = $0acc653c28085d6b$var$dm(c, b, a, e, d);
    return $0acc653c28085d6b$var$Ul(g);
}
$0acc653c28085d6b$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0acc653c28085d6b$var$Fc(b.pendingLanes);
                0 !== c && ($0acc653c28085d6b$var$Oc(b, c | 1), $0acc653c28085d6b$var$pl(b, $0acc653c28085d6b$var$A()), 0 === ($0acc653c28085d6b$var$K & 6) && ($0acc653c28085d6b$var$mk = $0acc653c28085d6b$var$A() + 500, $0acc653c28085d6b$var$xg()));
            }
            break;
        case 13:
            $0acc653c28085d6b$var$El(function() {
                var b = $0acc653c28085d6b$var$wh(a, 1);
                if (null !== b) {
                    var c = $0acc653c28085d6b$var$Ri();
                    $0acc653c28085d6b$var$ui(b, a, 1, c);
                }
            }), $0acc653c28085d6b$var$Wl(a, 1);
    }
};
$0acc653c28085d6b$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $0acc653c28085d6b$var$wh(a, 134217728);
        if (null !== b) {
            var c = $0acc653c28085d6b$var$Ri();
            $0acc653c28085d6b$var$ui(b, a, 134217728, c);
        }
        $0acc653c28085d6b$var$Wl(a, 134217728);
    }
};
$0acc653c28085d6b$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $0acc653c28085d6b$var$Oi(a), c = $0acc653c28085d6b$var$wh(a, b);
        if (null !== c) {
            var d = $0acc653c28085d6b$var$Ri();
            $0acc653c28085d6b$var$ui(c, a, b, d);
        }
        $0acc653c28085d6b$var$Wl(a, b);
    }
};
$0acc653c28085d6b$var$Vc = function() {
    return $0acc653c28085d6b$var$E;
};
$0acc653c28085d6b$var$Wc = function(a, b) {
    var c = $0acc653c28085d6b$var$E;
    try {
        return $0acc653c28085d6b$var$E = a, b();
    } finally{
        $0acc653c28085d6b$var$E = c;
    }
};
$0acc653c28085d6b$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0acc653c28085d6b$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0acc653c28085d6b$var$Db(d);
                        if (!e) throw Error($0acc653c28085d6b$var$p(90));
                        $0acc653c28085d6b$var$Wa(d);
                        $0acc653c28085d6b$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0acc653c28085d6b$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $0acc653c28085d6b$var$eb(a, !!c.multiple, b, !1);
    }
};
$0acc653c28085d6b$var$Gb = $0acc653c28085d6b$var$Dl;
$0acc653c28085d6b$var$Hb = $0acc653c28085d6b$var$El;
var $0acc653c28085d6b$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $0acc653c28085d6b$var$Cb,
        $0acc653c28085d6b$var$Ie,
        $0acc653c28085d6b$var$Db,
        $0acc653c28085d6b$var$Eb,
        $0acc653c28085d6b$var$Fb,
        $0acc653c28085d6b$var$Dl
    ]
}, $0acc653c28085d6b$var$gm = {
    findFiberByHostInstance: $0acc653c28085d6b$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $0acc653c28085d6b$var$u({}, a, {
            getLaneLabelMap: $0acc653c28085d6b$var$pc,
            injectProfilingHooks: $0acc653c28085d6b$var$oc
        }), $0acc653c28085d6b$var$kc = b.inject(a), $0acc653c28085d6b$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $0acc653c28085d6b$var$gm.bundleType,
    version: $0acc653c28085d6b$var$gm.version,
    rendererPackageName: $0acc653c28085d6b$var$gm.rendererPackageName,
    rendererConfig: $0acc653c28085d6b$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0acc653c28085d6b$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0acc653c28085d6b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0acc653c28085d6b$var$gm.findFiberByHostInstance || $0acc653c28085d6b$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$0acc653c28085d6b$export$ae55be85d98224ed = $0acc653c28085d6b$var$fm;
$0acc653c28085d6b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0acc653c28085d6b$var$am(b)) throw Error($0acc653c28085d6b$var$p(200));
    return $0acc653c28085d6b$var$Ql(a, b, null, c);
};
$0acc653c28085d6b$export$882461b6382ed46c = function(a, b) {
    if (!$0acc653c28085d6b$var$am(a)) throw Error($0acc653c28085d6b$var$p(299));
    var c = !1, d = "", e = $0acc653c28085d6b$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0acc653c28085d6b$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$0acc653c28085d6b$var$If] = b.current;
    $0acc653c28085d6b$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $0acc653c28085d6b$var$Zl(b);
};
$0acc653c28085d6b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0acc653c28085d6b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0acc653c28085d6b$var$p(268, a));
    }
    a = $0acc653c28085d6b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0acc653c28085d6b$export$cd75ccfd720a3cd4 = function(a) {
    return $0acc653c28085d6b$var$El(a);
};
$0acc653c28085d6b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0acc653c28085d6b$var$bm(b)) throw Error($0acc653c28085d6b$var$p(200));
    return $0acc653c28085d6b$var$em(null, a, b, !0, c);
};
$0acc653c28085d6b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0acc653c28085d6b$var$am(a)) throw Error($0acc653c28085d6b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0acc653c28085d6b$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0acc653c28085d6b$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0acc653c28085d6b$var$If] = b.current;
    $0acc653c28085d6b$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0acc653c28085d6b$var$$l(b);
};
$0acc653c28085d6b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0acc653c28085d6b$var$bm(b)) throw Error($0acc653c28085d6b$var$p(200));
    return $0acc653c28085d6b$var$em(null, a, b, !1, c);
};
$0acc653c28085d6b$export$502457920280e6be = function(a) {
    if (!$0acc653c28085d6b$var$bm(a)) throw Error($0acc653c28085d6b$var$p(40));
    return a._reactRootContainer ? ($0acc653c28085d6b$var$El(function() {
        $0acc653c28085d6b$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0acc653c28085d6b$var$If] = null;
        });
    }), !0) : !1;
};
$0acc653c28085d6b$export$c78a37762a8d58e1 = $0acc653c28085d6b$var$Dl;
$0acc653c28085d6b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0acc653c28085d6b$var$bm(c)) throw Error($0acc653c28085d6b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0acc653c28085d6b$var$p(38));
    return $0acc653c28085d6b$var$em(a, b, c, !1, d);
};
$0acc653c28085d6b$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("2NwEO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3r6Td"));

});



parcelRegister("8Mxh4", function(module, exports) {
$parcel$export(module.exports, "default", () => $664c9e09198a0a62$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $664c9e09198a0a62$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $664c9e09198a0a62$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))),
    devtools: false,
    middlewares: new Set(),
    mutator: $664c9e09198a0a62$var$defaultMutator
};
var $664c9e09198a0a62$export$2e2bcd8739ae039 = $664c9e09198a0a62$var$defaults;

});

parcelRegister("dxlJL", function(module, exports) {
$parcel$export(module.exports, "default", () => $9daf37f430e51bc5$export$2e2bcd8739ae039);
const $9daf37f430e51bc5$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $9daf37f430e51bc5$export$2e2bcd8739ae039 = $9daf37f430e51bc5$var$supports;

});


parcelRegister("6xLCs", function(module, exports) {
$parcel$export(module.exports, "createHook", () => $4c3ac3537a54412e$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createActionsHook", () => $4c3ac3537a54412e$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $4c3ac3537a54412e$export$6e4e5611de132e85);

var $8P7DW = parcelRequire("8P7DW");

var $h2txa = parcelRequire("h2txa");

var $15wlh = parcelRequire("15wlh");

var $lJS87 = parcelRequire("lJS87");
const $4c3ac3537a54412e$var$EMPTY_SELECTOR = ()=>undefined;
const $4c3ac3537a54412e$var$DEFAULT_SELECTOR = (state)=>state;
function $4c3ac3537a54412e$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $8P7DW.useContext)((0, $15wlh.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $8P7DW.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $8P7DW.useMemo)(()=>selector ? (0, $lJS87.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $4c3ac3537a54412e$var$EMPTY_SELECTOR : $4c3ac3537a54412e$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $8P7DW.useState)({})[1];
        const getSnapshot = (0, $8P7DW.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $h2txa.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $4c3ac3537a54412e$export$7c643e1d6648e418(Store) {
    const useHook = $4c3ac3537a54412e$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $4c3ac3537a54412e$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $4c3ac3537a54412e$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("h2txa", function(module, exports) {
'use strict';

module.exports = (parcelRequire("183NG"));

});
parcelRegister("183NG", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $0d297c71c167d101$export$306c0aa65ff9ec16, (v) => $0d297c71c167d101$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0d297c71c167d101$export$306c0aa65ff9ec16;
"use strict";

var $8P7DW = parcelRequire("8P7DW");
function $0d297c71c167d101$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $0d297c71c167d101$var$objectIs = "function" === typeof Object.is ? Object.is : $0d297c71c167d101$var$is, $0d297c71c167d101$var$useState = $8P7DW.useState, $0d297c71c167d101$var$useEffect = $8P7DW.useEffect, $0d297c71c167d101$var$useLayoutEffect = $8P7DW.useLayoutEffect, $0d297c71c167d101$var$useDebugValue = $8P7DW.useDebugValue;
function $0d297c71c167d101$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $0d297c71c167d101$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $0d297c71c167d101$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $0d297c71c167d101$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $0d297c71c167d101$var$useEffect(function() {
        $0d297c71c167d101$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $0d297c71c167d101$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $0d297c71c167d101$var$useDebugValue(value);
    return value;
}
function $0d297c71c167d101$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$0d297c71c167d101$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $0d297c71c167d101$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $0d297c71c167d101$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $0d297c71c167d101$var$useSyncExternalStore$1 : $0d297c71c167d101$var$useSyncExternalStore$2;
$0d297c71c167d101$export$306c0aa65ff9ec16 = void 0 !== $8P7DW.useSyncExternalStore ? $8P7DW.useSyncExternalStore : $0d297c71c167d101$var$shim;

});


parcelRegister("15wlh", function(module, exports) {
$parcel$export(module.exports, "Context", () => $0caf589691978969$export$841858b892ce1f4c);

var $8P7DW = parcelRequire("8P7DW");

var $jvxRx = parcelRequire("jvxRx");
const $0caf589691978969$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext({
    globalRegistry: (0, $jvxRx.defaultRegistry),
    retrieveStore: (Store)=>(0, $jvxRx.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("jvxRx", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", () => $e33b2df1c9faf3a1$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $e33b2df1c9faf3a1$export$9d726ae4880b1060);

var $dxlJL = parcelRequire("dxlJL");

var $gdhbF = parcelRequire("gdhbF");

var $gerU5 = parcelRequire("gerU5");
const $e33b2df1c9faf3a1$export$e4d628ba0054221b = '__global__';
class $e33b2df1c9faf3a1$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $e33b2df1c9faf3a1$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $dxlJL.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $gerU5.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $gdhbF.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $e33b2df1c9faf3a1$export$9d726ae4880b1060 = new $e33b2df1c9faf3a1$export$acb47f32da33501e();

});
parcelRegister("gdhbF", function(module, exports) {
$parcel$export(module.exports, "bindActions", () => $bcdb31451b6a2343$export$5ee1d46cd0883a22);

var $8Mxh4 = parcelRequire("8Mxh4");
const $bcdb31451b6a2343$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $bcdb31451b6a2343$var$warnings = new WeakMap();
const $bcdb31451b6a2343$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $8Mxh4.default).devtools ? $bcdb31451b6a2343$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$bcdb31451b6a2343$var$warnings.has(actionFn)) $bcdb31451b6a2343$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $bcdb31451b6a2343$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $bcdb31451b6a2343$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});

parcelRegister("gerU5", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd13993cf72a2305$export$2e2bcd8739ae039);

var $h3DeM = parcelRequire("h3DeM");

var $k0vHd = parcelRequire("k0vHd");

var $8Mxh4 = parcelRequire("8Mxh4");

var $aECXx = parcelRequire("aECXx");
function $bd13993cf72a2305$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $aECXx.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $h3DeM.default)(storeState, (0, $8Mxh4.default).middlewares);
    return storeState;
}
var $bd13993cf72a2305$export$2e2bcd8739ae039 = (0, $k0vHd.default)($bd13993cf72a2305$var$createStoreState);

});
parcelRegister("h3DeM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6b1273a210994c2$export$2e2bcd8739ae039);

var $8Mxh4 = parcelRequire("8Mxh4");

var $fjH1V = parcelRequire("fjH1V");
const $c6b1273a210994c2$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $fjH1V.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $8Mxh4.default).mutator);
var $c6b1273a210994c2$export$2e2bcd8739ae039 = $c6b1273a210994c2$var$applyMiddleware;

});
parcelRegister("fjH1V", function(module, exports) {
$parcel$export(module.exports, "default", () => $b26a0239966a289a$export$2e2bcd8739ae039);

var $dAsQ8 = parcelRequire("dAsQ8");
const $b26a0239966a289a$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $dAsQ8.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $b26a0239966a289a$export$2e2bcd8739ae039 = $b26a0239966a289a$var$updateMiddleware;

});
parcelRegister("dAsQ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e45022abf8d8eea$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $9e45022abf8d8eea$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $9e45022abf8d8eea$var$CACHE = new WeakMap();
function $9e45022abf8d8eea$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($9e45022abf8d8eea$var$CACHE.has(objA)) keysA = $9e45022abf8d8eea$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $9e45022abf8d8eea$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($9e45022abf8d8eea$var$CACHE.has(objB)) keysB = $9e45022abf8d8eea$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $9e45022abf8d8eea$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$9e45022abf8d8eea$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("k0vHd", function(module, exports) {
$parcel$export(module.exports, "default", () => $e90c64ec84d44408$export$2e2bcd8739ae039);

var $8Mxh4 = parcelRequire("8Mxh4");
const $e90c64ec84d44408$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $e90c64ec84d44408$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $8Mxh4.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $8Mxh4.default).devtools === 'function' ? (0, $8Mxh4.default).devtools(storeState) : {};
                        devTools = $e90c64ec84d44408$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $e90c64ec84d44408$export$2e2bcd8739ae039 = $e90c64ec84d44408$var$withDevtools;

});

parcelRegister("aECXx", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c1bdc4c67eb2876$export$2e2bcd8739ae039);

var $8Mxh4 = parcelRequire("8Mxh4");

var $lR4hY = parcelRequire("lR4hY");

var $dxlJL = parcelRequire("dxlJL");
const $7c1bdc4c67eb2876$var$QUEUE = [];
let $7c1bdc4c67eb2876$var$scheduled;
function $7c1bdc4c67eb2876$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $8Mxh4.default).batchUpdates || !(0, $dxlJL.default).scheduling()) return (0, $lR4hY.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$7c1bdc4c67eb2876$var$QUEUE.includes(fn)) $7c1bdc4c67eb2876$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($7c1bdc4c67eb2876$var$scheduled) return;
    $7c1bdc4c67eb2876$var$scheduled = (0, $lR4hY.batch)(()=>{
        let queueFn;
        while(queueFn = $7c1bdc4c67eb2876$var$QUEUE.shift())queueFn();
        $7c1bdc4c67eb2876$var$scheduled = null;
    });
}

});




parcelRegister("lJS87", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $fd37ca04ae3fd7e5$export$595d22ed68ca2841);
$parcel$export(module.exports, "getSelectorInstance", () => $fd37ca04ae3fd7e5$export$38d24f3c60944dd5);

var $5Vw3Q = parcelRequire("5Vw3Q");
function $fd37ca04ae3fd7e5$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $5Vw3Q.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $5Vw3Q.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $fd37ca04ae3fd7e5$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $fd37ca04ae3fd7e5$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $fd37ca04ae3fd7e5$var$cache = new WeakMap();
function $fd37ca04ae3fd7e5$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$fd37ca04ae3fd7e5$var$cache.has(storeState)) $fd37ca04ae3fd7e5$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $fd37ca04ae3fd7e5$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $fd37ca04ae3fd7e5$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $fd37ca04ae3fd7e5$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("5Vw3Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $450b2547c2667a3a$export$2e2bcd8739ae039);

var $dAsQ8 = parcelRequire("dAsQ8");
function $450b2547c2667a3a$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $450b2547c2667a3a$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $dAsQ8.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$450b2547c2667a3a$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $450b2547c2667a3a$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $450b2547c2667a3a$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $dAsQ8.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("iOIPr", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $db2fab8ebed7db0a$export$26ae5ca175b4ec5a);

var $8P7DW = parcelRequire("8P7DW");

var $93Fg7 = parcelRequire("93Fg7");

var $15wlh = parcelRequire("15wlh");

var $gdhbF = parcelRequire("gdhbF");
var $jvxRx = parcelRequire("jvxRx");

var $dAsQ8 = parcelRequire("dAsQ8");
const $db2fab8ebed7db0a$var$_excluded = [
    "children"
], $db2fab8ebed7db0a$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $db2fab8ebed7db0a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $db2fab8ebed7db0a$var$noop = ()=>()=>{};
function $db2fab8ebed7db0a$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $db2fab8ebed7db0a$var$noop, onUpdate: onUpdate = $db2fab8ebed7db0a$var$noop, onCleanup: onCleanup = $db2fab8ebed7db0a$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $db2fab8ebed7db0a$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $db2fab8ebed7db0a$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $db2fab8ebed7db0a$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $db2fab8ebed7db0a$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $db2fab8ebed7db0a$var$createFunctionContainer(StoreOrOptions);
}
function $db2fab8ebed7db0a$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $8P7DW.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $jvxRx.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $db2fab8ebed7db0a$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $8P7DW.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $8P7DW.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $gdhbF.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $gdhbF.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $db2fab8ebed7db0a$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $8P7DW.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $8P7DW.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $db2fab8ebed7db0a$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $db2fab8ebed7db0a$var$_objectWithoutPropertiesLoose(props, $db2fab8ebed7db0a$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $db2fab8ebed7db0a$var$_objectWithoutPropertiesLoose(restProps, $db2fab8ebed7db0a$var$_excluded2);
        const ctx = (0, $8P7DW.useContext)((0, $15wlh.Context));
        const registry = $db2fab8ebed7db0a$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $8P7DW.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $db2fab8ebed7db0a$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $db2fab8ebed7db0a$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $dAsQ8.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $8P7DW.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $8P7DW.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $15wlh.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).bool
    };
    return FunctionContainer;
}

});

parcelRegister("kUoOn", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $f38c48ac6571c6ba$export$f51a9068ac82ea43);

var $7W86r = parcelRequire("7W86r");
function $f38c48ac6571c6ba$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $7W86r.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $f38c48ac6571c6ba$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $f38c48ac6571c6ba$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("7W86r", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c743c432a202a00$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $5c743c432a202a00$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("g165c", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $ba9175480bf68fc1$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $ba9175480bf68fc1$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $ba9175480bf68fc1$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $ba9175480bf68fc1$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $ba9175480bf68fc1$export$c9237620ff7fdf7c);

var $lg6T0 = parcelRequire("lg6T0");
parcelRequire("f18fu");
var $5zGpL = parcelRequire("5zGpL");
const $ba9175480bf68fc1$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $ba9175480bf68fc1$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $ba9175480bf68fc1$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $ba9175480bf68fc1$var$stripTrailingSlash(prefix);
        prefix = $ba9175480bf68fc1$var$addLeadingSlash(prefix);
        path = $ba9175480bf68fc1$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $ba9175480bf68fc1$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $ba9175480bf68fc1$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$ba9175480bf68fc1$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($lg6T0)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($lg6T0)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $ba9175480bf68fc1$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$ba9175480bf68fc1$export$e83e3719fc818ee5(path)) {
        path = $ba9175480bf68fc1$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($lg6T0)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $ba9175480bf68fc1$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $lg6T0.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $ba9175480bf68fc1$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $ba9175480bf68fc1$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $5zGpL.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});




parcelRegister("3vYjO", function(module, exports) {
$parcel$export(module.exports, "Router", () => $28f30e5a4efe7d5a$export$55185c17a0fcbe46);

var $cCnFQ = parcelRequire("cCnFQ");

var $02U4x = parcelRequire("02U4x");

var $8P7DW = parcelRequire("8P7DW");

var $a9XM1 = parcelRequire("a9XM1");
const $28f30e5a4efe7d5a$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $a9XM1.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $28f30e5a4efe7d5a$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $8P7DW.useMemo)(()=>(0, $02U4x.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($28f30e5a4efe7d5a$export$55185c17a0fcbe46, (0, $cCnFQ.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("gPYXY", function(module, exports) {

var $8P7DW = parcelRequire("8P7DW");

var $dKPjT = parcelRequire("dKPjT");
const $c420b36298674872$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $dKPjT.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, children(actions));
};
$c420b36298674872$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("dKPjT", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $a037614a84d5d6d0$export$402e82ff1b20594b);

var $a9XM1 = parcelRequire("a9XM1");
const $a037614a84d5d6d0$export$402e82ff1b20594b = (0, $a9XM1.useRouterStoreActions);

});


parcelRegister("21W2d", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => $17a8b140dd347ce5$export$672d721d310ff5f0);

var $911Xe = parcelRequire("911Xe");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("f18fu");
var $eexci = parcelRequire("eexci");

var $a9XM1 = parcelRequire("a9XM1");
const $17a8b140dd347ce5$var$_excluded = [
    "listen"
];
const $17a8b140dd347ce5$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $a9XM1.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $911Xe.default)(_ref, $17a8b140dd347ce5$var$_excluded);
    if (!state.unlisten && !(0, $eexci.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, children(state, actions));
};

});
parcelRegister("911Xe", function(module, exports) {
$parcel$export(module.exports, "default", () => $6905b92a385beb27$export$2e2bcd8739ae039);
function $6905b92a385beb27$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("iyRi5", function(module, exports) {
$parcel$export(module.exports, "usePathParam", () => $d834bd5f190ef7bb$export$8c8591dcd57728e6);

var $8P7DW = parcelRequire("8P7DW");

var $6xLCs = parcelRequire("6xLCs");

var $a9XM1 = parcelRequire("a9XM1");
const $d834bd5f190ef7bb$var$createPathParamHook = (0, $6xLCs.createHook)((0, $a9XM1.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $d834bd5f190ef7bb$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $d834bd5f190ef7bb$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $8P7DW.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("hDCsk", function(module, exports) {
$parcel$export(module.exports, "useQueryParam", () => $cd73e8b836379d65$export$ae316f0eeb712a36);

var $8P7DW = parcelRequire("8P7DW");

var $6xLCs = parcelRequire("6xLCs");

var $a9XM1 = parcelRequire("a9XM1");
const $cd73e8b836379d65$var$createQueryParamHook = (0, $6xLCs.createHook)((0, $a9XM1.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $cd73e8b836379d65$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $cd73e8b836379d65$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $8P7DW.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("bDnSZ", function(module, exports) {
$parcel$export(module.exports, "withRouter", () => $8785dd77d12b7bc0$export$369b6b2b30582e8e);

var $cCnFQ = parcelRequire("cCnFQ");

var $8P7DW = parcelRequire("8P7DW");

var $a9XM1 = parcelRequire("a9XM1");
const $8785dd77d12b7bc0$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $8785dd77d12b7bc0$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $8785dd77d12b7bc0$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $a9XM1.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, (0, $cCnFQ.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});


parcelRegister("d0dRl", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("cKYBS")).default);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("jT4Pl")).RouteComponent);

var $cKYBS = parcelRequire("cKYBS");

var $jT4Pl = parcelRequire("jT4Pl");

});
parcelRegister("cKYBS", function(module, exports) {
$parcel$export(module.exports, "default", () => $9498cbc38a3943b3$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");

var $911Xe = parcelRequire("911Xe");

var $02U4x = parcelRequire("02U4x");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("f18fu");
var $1DU2r = parcelRequire("1DU2r");
var $8O9Y6 = parcelRequire("8O9Y6");

var $a9XM1 = parcelRequire("a9XM1");

var $2BjBl = parcelRequire("2BjBl");
parcelRequire("9tq7A");
var $4ZOgH = parcelRequire("4ZOgH");
var $ltHD2 = parcelRequire("ltHD2");
const $9498cbc38a3943b3$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $9498cbc38a3943b3$var$PREFETCH_DELAY = 225;
const $9498cbc38a3943b3$var$Link = /*#__PURE__*/ (0, $8P7DW.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $911Xe.default)(_ref, $9498cbc38a3943b3$var$_excluded);
    const routerActions = (0, $a9XM1.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $2BjBl.useTimeout)($9498cbc38a3943b3$var$PREFETCH_DELAY);
    const validLinkType = (0, $4ZOgH.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $8P7DW.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $02U4x.createPath)((0, $8O9Y6.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $8P7DW.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $1DU2r.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $ltHD2.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $8P7DW.createElement)(validLinkType, (0, $cCnFQ.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$9498cbc38a3943b3$var$Link.displayName = 'Link';
var $9498cbc38a3943b3$export$2e2bcd8739ae039 = $9498cbc38a3943b3$var$Link;

});
parcelRegister("2BjBl", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $1e4e3de54d9e9c83$export$d8e6abf214c9ec0f);

var $8P7DW = parcelRequire("8P7DW");
const $1e4e3de54d9e9c83$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $8P7DW.useRef)();
    const schedule = (0, $8P7DW.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $8P7DW.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("9tq7A", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("4ZOgH")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("ltHD2")).handleNavigation);

var $4ZOgH = parcelRequire("4ZOgH");

var $ltHD2 = parcelRequire("ltHD2");

});
parcelRegister("4ZOgH", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => $3a33da2e1819f317$export$855ece989b15eb57);
const $3a33da2e1819f317$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $3a33da2e1819f317$export$855ece989b15eb57 = (type)=>$3a33da2e1819f317$var$VALID_LINK_TYPES.includes(type) ? type : 'a';

});

parcelRegister("ltHD2", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $fa2e262255bb27a4$export$706ad1af8096e280);

var $2mPba = parcelRequire("2mPba");
const $fa2e262255bb27a4$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $2mPba.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $2mPba.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $2mPba.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("2mPba", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $1b9555f670228d5c$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $1b9555f670228d5c$export$130b789831072f4c);
const $1b9555f670228d5c$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $1b9555f670228d5c$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});




parcelRegister("jT4Pl", function(module, exports) {
$parcel$export(module.exports, "RouteComponent", () => $e7a6e5f6efc63f97$export$7903e4b73fc7d6c3);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hIf1l");
var $i9cdb = parcelRequire("i9cdb");
const $e7a6e5f6efc63f97$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $i9cdb.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});


parcelRegister("bofd0", function(module, exports) {
parcelRequire("f18fu");
var $1DU2r = parcelRequire("1DU2r");
const $84adbbc49ae98d82$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $1DU2r.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("889Kb", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => (parcelRequire("4uyrL")).createResourcesPlugin);
$parcel$export(module.exports, "useResource", () => (parcelRequire("hgkVf")).useResource);
$parcel$export(module.exports, "createResource", () => (parcelRequire("5U6in")).createResource);

var $4uyrL = parcelRequire("4uyrL");

var $gPNNg = parcelRequire("gPNNg");

var $hgkVf = parcelRequire("hgkVf");

var $9dF2q = parcelRequire("9dF2q");
parcelRequire("flbHS");
var $5U6in = parcelRequire("5U6in");

var $4uyrL = parcelRequire("4uyrL");

var $6ZKFO = parcelRequire("6ZKFO");

});
parcelRegister("4uyrL", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => $3454af30352582fe$export$23ed892c481a96fe);

var $flbHS = parcelRequire("flbHS");
parcelRequire("l0day");
var $c7j9q = parcelRequire("c7j9q");
const $3454af30352582fe$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $3454af30352582fe$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $flbHS.getResourceStore)().actions;
    const nextResources = (0, $c7j9q.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $3454af30352582fe$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $flbHS.getResourceStore)().actions;
    const nextResources = (0, $c7j9q.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $3454af30352582fe$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $flbHS.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $3454af30352582fe$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $3454af30352582fe$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $3454af30352582fe$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $flbHS.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $flbHS.getResourceStore)().actions;
            const nextResources = (0, $c7j9q.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $flbHS.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("flbHS", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $b2b1e5e68e00ac82$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $b2b1e5e68e00ac82$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $b2b1e5e68e00ac82$export$98e41a62c9bef75e);
$parcel$export(module.exports, "createResource", () => (parcelRequire("5U6in")).createResource);

var $cCnFQ = parcelRequire("cCnFQ");

var $911Xe = parcelRequire("911Xe");

var $6xLCs = parcelRequire("6xLCs");
var $iOIPr = parcelRequire("iOIPr");
var $kUoOn = parcelRequire("kUoOn");
var $5SFeI = parcelRequire("5SFeI");
var $jvxRx = parcelRequire("jvxRx");
parcelRequire("f18fu");
var $eexci = parcelRequire("eexci");

var $hEk1y = parcelRequire("hEk1y");
parcelRequire("l0day");
var $imAV7 = parcelRequire("imAV7");
var $4JwzI = parcelRequire("4JwzI");
var $5U6in = parcelRequire("5U6in");
var $1lO5J = parcelRequire("1lO5J");
var $fQhd4 = parcelRequire("fQhd4");
var $1UPE5 = parcelRequire("1UPE5");
var $e69Rq = parcelRequire("e69Rq");
var $l4sMh = parcelRequire("l4sMh");
var $91DHj = parcelRequire("91DHj");
var $400IA = parcelRequire("400IA");
var $1WCXT = parcelRequire("1WCXT");
var $aVMxX = parcelRequire("aVMxX");
var $1S4MT = parcelRequire("1S4MT");
const $b2b1e5e68e00ac82$var$_excluded = [
    "context"
], $b2b1e5e68e00ac82$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $b2b1e5e68e00ac82$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $1lO5J.deleteResourceState)(type, key));
                dispatch((0, $imAV7.executeForDependents)(resource, (dependentResource)=>$b2b1e5e68e00ac82$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $1lO5J.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $911Xe.default)(_getState, $b2b1e5e68e00ac82$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $hEk1y.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $cCnFQ.default)({}, prevSlice, changes, {
                expiresAt: (0, $l4sMh.getExpiresAt)(maxAge),
                accessedAt: (0, $1UPE5.getAccessedAt)()
            });
            dispatch((0, $1lO5J.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $imAV7.executeForDependents)(resource, (dependentResource)=>$b2b1e5e68e00ac82$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $1lO5J.getResourceState)(type, key));
            if (cached && (0, $91DHj.shouldUseCache)(cached)) {
                if ((0, $91DHj.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $400IA.setSsrDataPromise)(cached);
                    cached = (0, $l4sMh.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $1UPE5.getAccessedAt)();
                dispatch((0, $1lO5J.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($b2b1e5e68e00ac82$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $1lO5J.getResourceState)(type, key)) || (0, $e69Rq.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $1S4MT.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $1lO5J.getPrefetchSlice)(type, key)) || (0, $4JwzI.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $imAV7.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $1lO5J.setResourceState)(type, key, (0, $cCnFQ.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $1UPE5.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $imAV7.executeForDependents)(resource, (dependentResource)=>$b2b1e5e68e00ac82$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $1WCXT.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $1lO5J.getResourceState)(type, key));
            const finalSlice = (0, $cCnFQ.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $1UPE5.getAccessedAt)(),
                expiresAt: (0, $l4sMh.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $1lO5J.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $1lO5J.getPrefetchSlice)(type, key)) || (0, $4JwzI.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $imAV7.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $1lO5J.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $imAV7.executeForDependents)(resource, (dependentResource)=>$b2b1e5e68e00ac82$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $b2b1e5e68e00ac82$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $imAV7.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $b2b1e5e68e00ac82$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $imAV7.actionWithDependencies)(routerStoreContext.route.resources, resource, $b2b1e5e68e00ac82$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $imAV7.actionWithDependencies)(routerStoreContext.route.resources, resource, $b2b1e5e68e00ac82$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $imAV7.actionWithDependencies)(routerStoreContext.route.resources, resource, $b2b1e5e68e00ac82$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($b2b1e5e68e00ac82$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $1lO5J.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $1lO5J.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $eexci.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $imAV7.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$b2b1e5e68e00ac82$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $imAV7.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$b2b1e5e68e00ac82$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $cCnFQ.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $aVMxX.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $911Xe.default)(_ref, $b2b1e5e68e00ac82$var$_excluded2);
                const deserializedError = !error ? null : (0, $fQhd4.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $cCnFQ.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $aVMxX.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $fQhd4.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $1WCXT.TimeoutError) ? loading : false
                }))
};
const $b2b1e5e68e00ac82$export$94f50dade551bd01 = (0, $kUoOn.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $b2b1e5e68e00ac82$export$e324594224ef24da,
    name: 'router-resources'
});
const $b2b1e5e68e00ac82$export$cc90fb9c37c5589d = (0, $iOIPr.createContainer)($b2b1e5e68e00ac82$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $b2b1e5e68e00ac82$export$fee1a6213543bd78 = (0, $5SFeI.createSubscriber)($b2b1e5e68e00ac82$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $hEk1y.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $b2b1e5e68e00ac82$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $jvxRx.defaultRegistry).getStore($b2b1e5e68e00ac82$export$94f50dade551bd01);
const $b2b1e5e68e00ac82$export$ac3608e0bb357c7 = (0, $6xLCs.createHook)($b2b1e5e68e00ac82$export$94f50dade551bd01, {
    selector: (0, $hEk1y.getSliceForResource)
});
const $b2b1e5e68e00ac82$export$98e41a62c9bef75e = (0, $6xLCs.createActionsHook)($b2b1e5e68e00ac82$export$94f50dade551bd01);
const $b2b1e5e68e00ac82$export$e59f52df235ac7b3 = (0, $6xLCs.createHook)($b2b1e5e68e00ac82$export$94f50dade551bd01, {
    selector: (0, $hEk1y.getResourceStoreContext)
});

});
parcelRegister("5SFeI", function(module, exports) {
$parcel$export(module.exports, "createSubscriber", () => $4481fb8fb2f149c2$export$48f338a7e080595c);

var $6xLCs = parcelRequire("6xLCs");
const $4481fb8fb2f149c2$var$_excluded = [
    "children"
];
function $4481fb8fb2f149c2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4481fb8fb2f149c2$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $4481fb8fb2f149c2$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $6xLCs.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $4481fb8fb2f149c2$var$_objectWithoutPropertiesLoose(_ref, $4481fb8fb2f149c2$var$_excluded);
        const api = useStore($4481fb8fb2f149c2$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}

});

parcelRegister("hEk1y", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $cd95b473e9de2eab$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $cd95b473e9de2eab$export$6a0b1779210de0ee);

var $cCnFQ = parcelRequire("cCnFQ");
parcelRequire("l0day");
var $e69Rq = parcelRequire("e69Rq");
const $cd95b473e9de2eab$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $cCnFQ.default)({}, slice) : (0, $e69Rq.getDefaultStateSlice)();
};
const $cd95b473e9de2eab$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("l0day", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("1UPE5")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("4JwzI")).createLoadingSlice);
$parcel$export(module.exports, "createResource", () => (parcelRequire("5U6in")).createResource);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("imAV7")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("imAV7")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("imAV7")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("imAV7")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("l4sMh")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("l4sMh")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("e69Rq")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("c7j9q")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("1S4MT")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("1lO5J")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("1lO5J")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("1lO5J")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("1lO5J")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("1lO5J")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("fQhd4")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("fQhd4")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("91DHj")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("91DHj")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("400IA")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("1WCXT")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("aVMxX")).transformData);

var $1UPE5 = parcelRequire("1UPE5");

var $4JwzI = parcelRequire("4JwzI");

var $5U6in = parcelRequire("5U6in");

var $imAV7 = parcelRequire("imAV7");

var $l4sMh = parcelRequire("l4sMh");

var $8JVCQ = parcelRequire("8JVCQ");

var $e69Rq = parcelRequire("e69Rq");

var $1UXBB = parcelRequire("1UXBB");

var $c7j9q = parcelRequire("c7j9q");

var $1S4MT = parcelRequire("1S4MT");

var $1lO5J = parcelRequire("1lO5J");

var $bkIbC = parcelRequire("bkIbC");

var $fQhd4 = parcelRequire("fQhd4");

var $91DHj = parcelRequire("91DHj");

var $400IA = parcelRequire("400IA");

var $1WCXT = parcelRequire("1WCXT");

var $aVMxX = parcelRequire("aVMxX");

});
parcelRegister("1UPE5", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $1653152111d803bc$export$9ccb639b7a119f61);
const $1653152111d803bc$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("4JwzI", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $3724a22170e0a1d1$export$dc62515c8f0b52dd);

var $cCnFQ = parcelRequire("cCnFQ");

var $kOF0n = parcelRequire("kOF0n");

var $l4sMh = parcelRequire("l4sMh");

var $8JVCQ = parcelRequire("8JVCQ");

var $1WCXT = parcelRequire("1WCXT");

var $3llqM = parcelRequire("3llqM");
function $3724a22170e0a1d1$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $cCnFQ.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $8JVCQ.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $1WCXT.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $l4sMh.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $kOF0n.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $l4sMh.getExpiresAt)((0, $3llqM.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("kOF0n", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", () => $f27848ea810b5ac4$export$881d135f98d8d7d0);
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", () => $f27848ea810b5ac4$export$9ab5bdcb8a1d6c34);
$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", () => $f27848ea810b5ac4$export$12c1dc38ea1692da);
const $f27848ea810b5ac4$export$881d135f98d8d7d0 = 100;
const $f27848ea810b5ac4$export$9ab5bdcb8a1d6c34 = false;
const $f27848ea810b5ac4$export$12c1dc38ea1692da = 0;

});

parcelRegister("l4sMh", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $f5704b598720e3f8$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $f5704b598720e3f8$export$18d1d420fd588368);

var $cCnFQ = parcelRequire("cCnFQ");
const $f5704b598720e3f8$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $f5704b598720e3f8$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $cCnFQ.default)({}, slice, {
        expiresAt: $f5704b598720e3f8$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("8JVCQ", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $65cf39e73febb4ff$export$58634b3a58ae66b7);
const $65cf39e73febb4ff$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("1WCXT", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $16a96ee29db3092e$export$66d311bf29d5c89c);
class $16a96ee29db3092e$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("3llqM", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $26f3f5001b462929$export$37d3126be6549b13);
const $26f3f5001b462929$export$37d3126be6549b13 = 10000;

});


parcelRegister("5U6in", function(module, exports) {
$parcel$export(module.exports, "createResource", () => $44c710dc018b570a$export$edd172c6c83c39cc);

var $kOF0n = parcelRequire("kOF0n");
/**
 * Utility method to created async versions of getData functions
 */ const $44c710dc018b570a$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $44c710dc018b570a$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $44c710dc018b570a$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $kOF0n.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $kOF0n.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $kOF0n.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("imAV7", function(module, exports) {
$parcel$export(module.exports, "actionWithDependencies", () => $037335596ae3ee7e$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $037335596ae3ee7e$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $037335596ae3ee7e$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $037335596ae3ee7e$export$75915f81f2a6540a);

var $cCnFQ = parcelRequire("cCnFQ");

var $e69Rq = parcelRequire("e69Rq");

var $1lO5J = parcelRequire("1lO5J");
var $037335596ae3ee7e$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $037335596ae3ee7e$var$fromEntries = ($037335596ae3ee7e$var$_Object$fromEntries = Object.fromEntries) != null ? $037335596ae3ee7e$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $037335596ae3ee7e$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $037335596ae3ee7e$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $037335596ae3ee7e$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($037335596ae3ee7e$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($037335596ae3ee7e$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($037335596ae3ee7e$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $037335596ae3ee7e$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($037335596ae3ee7e$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $037335596ae3ee7e$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$037335596ae3ee7e$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $037335596ae3ee7e$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($037335596ae3ee7e$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $037335596ae3ee7e$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($037335596ae3ee7e$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $037335596ae3ee7e$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($037335596ae3ee7e$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $037335596ae3ee7e$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $037335596ae3ee7e$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $037335596ae3ee7e$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $1lO5J.getResourceState)(dependencyType, key)) || (0, $e69Rq.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $1lO5J.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $cCnFQ.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("e69Rq", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $a439465b3fce4025$export$fa8e33c3301e2e94);

var $cCnFQ = parcelRequire("cCnFQ");

var $1UPE5 = parcelRequire("1UPE5");

var $kOF0n = parcelRequire("kOF0n");

var $l4sMh = parcelRequire("l4sMh");

var $jzZBr = parcelRequire("jzZBr");
const $a439465b3fce4025$export$fa8e33c3301e2e94 = ()=>(0, $cCnFQ.default)({}, (0, $jzZBr.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, $l4sMh.getExpiresAt)((0, $kOF0n.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $1UPE5.getAccessedAt)()
    });

});
parcelRegister("jzZBr", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $e4111246f05c6e90$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $e4111246f05c6e90$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});


parcelRegister("1lO5J", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $0fbe9bb7087f5f7b$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $0fbe9bb7087f5f7b$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $0fbe9bb7087f5f7b$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $0fbe9bb7087f5f7b$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $0fbe9bb7087f5f7b$export$d40f35dc5952864b);

var $911Xe = parcelRequire("911Xe");

var $cCnFQ = parcelRequire("cCnFQ");
function $0fbe9bb7087f5f7b$var$_toPropertyKey(t) {
    var i = $0fbe9bb7087f5f7b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $0fbe9bb7087f5f7b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $0fbe9bb7087f5f7b$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $0fbe9bb7087f5f7b$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $cCnFQ.default)({}, prefetching, {
                [type]: (0, $cCnFQ.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $0fbe9bb7087f5f7b$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($0fbe9bb7087f5f7b$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $cCnFQ.default)({}, data, {
                [type]: (0, $cCnFQ.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $0fbe9bb7087f5f7b$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $0fbe9bb7087f5f7b$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $911Xe.default)(data, [
            type
        ].map($0fbe9bb7087f5f7b$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $911Xe.default)(resourceForType, [
                key
            ].map($0fbe9bb7087f5f7b$var$_toPropertyKey));
            setState({
                data: (0, $cCnFQ.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("1UXBB", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $165941d7868f6413$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $165941d7868f6413$export$cd7fbe7e979df558);
const $165941d7868f6413$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $165941d7868f6413$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$165941d7868f6413$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("c7j9q", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $8d24fe759a7eb0cd$export$7cbbc763e2f3d65d);

var $1UXBB = parcelRequire("1UXBB");

var $bkIbC = parcelRequire("bkIbC");
const $8d24fe759a7eb0cd$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $bkIbC.routeHasResources)(nextRoute)) return [];
    if ((0, $bkIbC.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $1UXBB.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $1UXBB.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("bkIbC", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $8403d671c99c04f1$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $8403d671c99c04f1$export$221027ff1aa38f82);
const $8403d671c99c04f1$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $8403d671c99c04f1$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("1S4MT", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $15ce8c51bcbfd576$export$89440b7623c2c75c);

var $1lO5J = parcelRequire("1lO5J");
const $15ce8c51bcbfd576$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $15ce8c51bcbfd576$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $15ce8c51bcbfd576$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $15ce8c51bcbfd576$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $15ce8c51bcbfd576$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $1lO5J.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("fQhd4", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $b8890fdd340d37a5$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $b8890fdd340d37a5$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $b8890fdd340d37a5$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $b8890fdd340d37a5$var$NonError);
    }
}
const $b8890fdd340d37a5$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $b8890fdd340d37a5$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $b8890fdd340d37a5$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $b8890fdd340d37a5$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $b8890fdd340d37a5$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $b8890fdd340d37a5$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $b8890fdd340d37a5$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $b8890fdd340d37a5$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $b8890fdd340d37a5$var$NonError(value);
};

});

parcelRegister("91DHj", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $692300242caac008$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $692300242caac008$export$399de8c43d0ece3c);
const $692300242caac008$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $692300242caac008$var$isFresh = (resource)=>{
    if ($692300242caac008$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $692300242caac008$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($692300242caac008$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("400IA", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $2e97b818f89af1de$export$2e4da1b414980956);

var $cCnFQ = parcelRequire("cCnFQ");
const $2e97b818f89af1de$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $cCnFQ.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("aVMxX", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $7f54e2a10c4aab00$export$3ceb62baab058c6b);
const $7f54e2a10c4aab00$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});





parcelRegister("gPNNg", function(module, exports) {

var $8P7DW = parcelRequire("8P7DW");

var $hgkVf = parcelRequire("hgkVf");
const $c41808bca7e45f56$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $hgkVf.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, children(result));
};

});
parcelRegister("hgkVf", function(module, exports) {
$parcel$export(module.exports, "useResource", () => $c914290a0c059100$export$9f6abfd74295843b);

var $cCnFQ = parcelRequire("cCnFQ");

var $8P7DW = parcelRequire("8P7DW");

var $6xLCs = parcelRequire("6xLCs");
parcelRequire("9wocP");
var $a9XM1 = parcelRequire("a9XM1");

var $flbHS = parcelRequire("flbHS");
const $c914290a0c059100$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $flbHS.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $a9XM1.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $8P7DW.useMemo)(()=>(0, $6xLCs.createHook)((0, $a9XM1.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $flbHS.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $8P7DW.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $8P7DW.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $8P7DW.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $8P7DW.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $8P7DW.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $cCnFQ.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});


parcelRegister("9dF2q", function(module, exports) {

var $flbHS = parcelRequire("flbHS");
const $6b652946d2fe87a2$export$dee7bf9fc0ff48c3 = (fn)=>(0, $flbHS.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("6ZKFO", function(module, exports) {
const $517ca4ed960cdab7$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});



parcelRegister("4yRg9", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $455dfdc26daf78e9$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getEventQueue", () => $455dfdc26daf78e9$export$584d8b0a0989eefd);
/**
 * Wrapper around AJS
 */ 
var $1We2B = parcelRequire("1We2B");

var $jByYr = parcelRequire("jByYr");
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $455dfdc26daf78e9$var$ajs = window.AJS;
const $455dfdc26daf78e9$export$c47913ca32a5c6f7 = (key)=>{
    if ($455dfdc26daf78e9$var$ajs && $455dfdc26daf78e9$var$ajs.Meta) return $455dfdc26daf78e9$var$ajs.Meta.get(key);
    /** When jsd-dw-portal-wrm-optimisations is on we fallback to a native version of getMeta that doesn't rely on AJS being loaded on the page via WRM */ const value = (0, $jByYr.getMetaFromHTML)(key);
    return (0, $1We2B.isNil)(value) ? undefined : value;
};
const $455dfdc26daf78e9$export$584d8b0a0989eefd = ()=>{
    return $455dfdc26daf78e9$var$ajs === undefined ? undefined : $455dfdc26daf78e9$var$ajs.EventQueue;
};

});



parcelRegister("lKEMb", function(module, exports) {
$parcel$export(module.exports, "devLog", () => $c131a48ab50f1cc4$export$c45ebb6cef9d5b7b);

var $hrPHR = parcelRequire("hrPHR");
function $c131a48ab50f1cc4$export$c45ebb6cef9d5b7b(message, ...optionalParams) {
    const env = (0, $hrPHR.getEnv)();
    // eslint-disable-next-line no-console
    env.environment !== (0, $hrPHR.EnvType).PROD && console.log(message, ...optionalParams);
}

});

parcelRegister("8YEr6", function(module, exports) {
$parcel$export(module.exports, "getApplicationType", () => $569d7907d64afd3b$export$4f7ec84576d049fa);

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");
const $569d7907d64afd3b$export$4f7ec84576d049fa = ()=>{
    return {
        applicationType: (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) ? 'jcs' : 'jsm'
    };
};

});

parcelRegister("1Hxwl", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterAnalyticsData", () => $64c3a94559d81769$export$bd448d1bc798d83d);

var $gk18s = parcelRequire("gk18s");

var $jByYr = parcelRequire("jByYr");
const $64c3a94559d81769$export$bd448d1bc798d83d = ()=>{
    const helpCenterAnalyticsData = !(0, $gk18s.isHelpCentersManagement)() ? {
        helpCenterType: (0, $gk18s.isAdvancedHelpCenter)() ? 'custom' : 'default',
        helpCenterAri: (0, $jByYr.getHelpCenterAri)()
    } : undefined;
    return helpCenterAnalyticsData;
};

});


parcelRegister("4OjKJ", function(module, exports) {
$parcel$export(module.exports, "sentryQueue", () => $9492924be42c8865$export$4bff35a64b482759);

var $lut7F = parcelRequire("lut7F");
const $9492924be42c8865$export$4bff35a64b482759 = {
    pushError (err) {
        if ((0, $lut7F.isSentryEnabled)()) {
            if (!window.JSM_EXCEPTION_QUEUE) window.JSM_EXCEPTION_QUEUE = [
                err
            ];
            else window.JSM_EXCEPTION_QUEUE.push(err);
        }
    },
    flushErrors () {
        var _window$JSM_EXCEPTION;
        (_window$JSM_EXCEPTION = window.JSM_EXCEPTION_QUEUE) === null || _window$JSM_EXCEPTION === void 0 || _window$JSM_EXCEPTION.forEach((err)=>(0, $lut7F.reportError)(err));
        delete window.JSM_EXCEPTION_QUEUE;
    }
};

});
parcelRegister("lut7F", function(module, exports) {
$parcel$export(module.exports, "isSentryEnabled", () => $2a8d5dceccc8aab3$export$ec3dcf0ab235344b);
$parcel$export(module.exports, "reportError", () => $2a8d5dceccc8aab3$export$b33b857ad1d9900e);

var $9dPOl = parcelRequire("9dPOl");

var $dMfOg = parcelRequire("dMfOg");

var $1We2B = parcelRequire("1We2B");

var $hrPHR = parcelRequire("hrPHR");
const $2a8d5dceccc8aab3$export$ec3dcf0ab235344b = ()=>{
    const env = (0, $hrPHR.getEnv)();
    if (env.environment === (0, $hrPHR.EnvType).STAGING) return true;
    return env.environment === (0, $hrPHR.EnvType).PROD;
};
const $2a8d5dceccc8aab3$export$b33b857ad1d9900e = (exception, additionalErrorData)=>{
    // eslint-disable-next-line no-console
    console.error('reportError', exception, additionalErrorData);
    if ($2a8d5dceccc8aab3$export$ec3dcf0ab235344b()) {
        if (additionalErrorData && (0, $1We2B.isNil)(additionalErrorData.message) && exception instanceof Error) $9dPOl.withScope((scope)=>{
            const { teamName: teamName, errorBoundaryId: errorBoundaryId, errorBoundaryPackageName: packageName } = additionalErrorData;
            if (errorBoundaryId) scope.setTag('errorBoundaryId', errorBoundaryId);
            if (packageName) scope.setTag('packageName', packageName);
            if (teamName) scope.setTag('teamName', teamName);
            const event = (0, $dMfOg.eventFromUnknownInput)(exception);
            $9dPOl.captureEvent({
                ...event,
                message: (additionalErrorData === null || additionalErrorData === void 0 ? void 0 : additionalErrorData.message) || event.message
            });
        });
        else {
            const event = (0, $dMfOg.eventFromUnknownInput)(exception);
            $9dPOl.captureEvent({
                ...event,
                message: (additionalErrorData === null || additionalErrorData === void 0 ? void 0 : additionalErrorData.message) || event.message
            });
        }
    }
};

});
parcelRegister("9dPOl", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $6b6d84884e2e34c7$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $6b6d84884e2e34c7$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $6b6d84884e2e34c7$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $6b6d84884e2e34c7$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $6b6d84884e2e34c7$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $6b6d84884e2e34c7$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $6b6d84884e2e34c7$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $6b6d84884e2e34c7$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $6b6d84884e2e34c7$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $6b6d84884e2e34c7$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $6b6d84884e2e34c7$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $6b6d84884e2e34c7$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $6b6d84884e2e34c7$export$e262da7ae6480481);

var $26Yns = parcelRequire("26Yns");

var $jOQ1l = parcelRequire("jOQ1l");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6b6d84884e2e34c7$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $jOQ1l.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $26Yns.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $6b6d84884e2e34c7$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $6b6d84884e2e34c7$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $6b6d84884e2e34c7$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $6b6d84884e2e34c7$var$callOnHub('captureMessage', message, level, (0, $26Yns.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $6b6d84884e2e34c7$export$1462b974fdcf6ba2(event) {
    return $6b6d84884e2e34c7$var$callOnHub('captureEvent', event);
}
function $6b6d84884e2e34c7$export$99d44f04437e9cb8(callback) {
    $6b6d84884e2e34c7$var$callOnHub('configureScope', callback);
}
function $6b6d84884e2e34c7$export$efda9a273d7a036d(breadcrumb) {
    $6b6d84884e2e34c7$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $6b6d84884e2e34c7$export$2f04de43fe27971a(name, context) {
    $6b6d84884e2e34c7$var$callOnHub('setContext', name, context);
}
function $6b6d84884e2e34c7$export$bb4922da0dd51b92(extras) {
    $6b6d84884e2e34c7$var$callOnHub('setExtras', extras);
}
function $6b6d84884e2e34c7$export$74a8fb34822092e6(tags) {
    $6b6d84884e2e34c7$var$callOnHub('setTags', tags);
}
function $6b6d84884e2e34c7$export$8e8e7789d42ed61d(key, extra) {
    $6b6d84884e2e34c7$var$callOnHub('setExtra', key, extra);
}
function $6b6d84884e2e34c7$export$a37d07ee78eb4569(key, value) {
    $6b6d84884e2e34c7$var$callOnHub('setTag', key, value);
}
function $6b6d84884e2e34c7$export$8b6bb3dd62a01be2(user) {
    $6b6d84884e2e34c7$var$callOnHub('setUser', user);
}
function $6b6d84884e2e34c7$export$ec58d9285c204497(callback) {
    $6b6d84884e2e34c7$var$callOnHub('withScope', callback);
}
function $6b6d84884e2e34c7$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $6b6d84884e2e34c7$var$callOnHub.apply(void 0, (0, $26Yns.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $6b6d84884e2e34c7$export$e262da7ae6480481(context, customSamplingContext) {
    return $6b6d84884e2e34c7$var$callOnHub('startTransaction', (0, $26Yns.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("26Yns", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $189afa037647fd53$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $189afa037647fd53$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $189afa037647fd53$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $189afa037647fd53$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $189afa037647fd53$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $189afa037647fd53$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $189afa037647fd53$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $189afa037647fd53$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $189afa037647fd53$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $189afa037647fd53$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $189afa037647fd53$export$1216008129fb82ed);
$parcel$export(module.exports, "__importDefault", () => $189afa037647fd53$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $189afa037647fd53$var$extendStatics = function(d, b) {
    $189afa037647fd53$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $189afa037647fd53$var$extendStatics(d, b);
};
function $189afa037647fd53$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $189afa037647fd53$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $189afa037647fd53$export$18ce0697a983be9b = function() {
    $189afa037647fd53$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $189afa037647fd53$export$18ce0697a983be9b.apply(this, arguments);
};
function $189afa037647fd53$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $189afa037647fd53$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $189afa037647fd53$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $189afa037647fd53$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $189afa037647fd53$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $189afa037647fd53$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $189afa037647fd53$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $189afa037647fd53$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $189afa037647fd53$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $189afa037647fd53$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $189afa037647fd53$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $189afa037647fd53$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $189afa037647fd53$export$45d3717a4c69092e(o, m, p);
}
function $189afa037647fd53$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $189afa037647fd53$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $189afa037647fd53$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($189afa037647fd53$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $189afa037647fd53$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $189afa037647fd53$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $189afa037647fd53$export$10c90e4f7922046c(v) {
    return this instanceof $189afa037647fd53$export$10c90e4f7922046c ? (this.v = v, this) : new $189afa037647fd53$export$10c90e4f7922046c(v);
}
function $189afa037647fd53$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $189afa037647fd53$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $189afa037647fd53$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $189afa037647fd53$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $189afa037647fd53$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $189afa037647fd53$export$19a8beecd37a4c45 === "function" ? $189afa037647fd53$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $189afa037647fd53$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $189afa037647fd53$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $189afa037647fd53$var$ownKeys = function(o) {
    $189afa037647fd53$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $189afa037647fd53$var$ownKeys(o);
};
function $189afa037647fd53$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $189afa037647fd53$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $189afa037647fd53$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $189afa037647fd53$var$__setModuleDefault(result, mod);
    return result;
}
function $189afa037647fd53$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $189afa037647fd53$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $189afa037647fd53$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $189afa037647fd53$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $189afa037647fd53$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $189afa037647fd53$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $189afa037647fd53$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $189afa037647fd53$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $189afa037647fd53$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $189afa037647fd53$export$2e2bcd8739ae039 = {
    __extends: $189afa037647fd53$export$a8ba968b8961cb8a,
    __assign: $189afa037647fd53$export$18ce0697a983be9b,
    __rest: $189afa037647fd53$export$3c9a16f847548506,
    __decorate: $189afa037647fd53$export$29e00dfd3077644b,
    __param: $189afa037647fd53$export$d5ad3fd78186038f,
    __esDecorate: $189afa037647fd53$export$3a84e1ae4e97e9b0,
    __runInitializers: $189afa037647fd53$export$d831c04e792af3d,
    __propKey: $189afa037647fd53$export$6a2a36740a146cb8,
    __setFunctionName: $189afa037647fd53$export$d1a06452d3489bc7,
    __metadata: $189afa037647fd53$export$f1db080c865becb9,
    __awaiter: $189afa037647fd53$export$1050f835b63b671e,
    __generator: $189afa037647fd53$export$67ebef60e6f28a6,
    __createBinding: $189afa037647fd53$export$45d3717a4c69092e,
    __exportStar: $189afa037647fd53$export$f33643c0debef087,
    __values: $189afa037647fd53$export$19a8beecd37a4c45,
    __read: $189afa037647fd53$export$8d051b38c9118094,
    __spread: $189afa037647fd53$export$afc72e2116322959,
    __spreadArrays: $189afa037647fd53$export$6388937ca91ccae8,
    __spreadArray: $189afa037647fd53$export$1216008129fb82ed,
    __await: $189afa037647fd53$export$10c90e4f7922046c,
    __asyncGenerator: $189afa037647fd53$export$e427f37a30a4de9b,
    __asyncDelegator: $189afa037647fd53$export$bbd80228419bb833,
    __asyncValues: $189afa037647fd53$export$e3b29a3d6162315f,
    __makeTemplateObject: $189afa037647fd53$export$4fb47efe1390b86f,
    __importStar: $189afa037647fd53$export$c21735bcef00d192,
    __importDefault: $189afa037647fd53$export$da59b14a69baef04,
    __classPrivateFieldGet: $189afa037647fd53$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $189afa037647fd53$export$d40a35129aaff81f,
    __classPrivateFieldIn: $189afa037647fd53$export$81fdc39f203e4e04,
    __addDisposableResource: $189afa037647fd53$export$88ac25d8e944e405,
    __disposeResources: $189afa037647fd53$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $189afa037647fd53$export$889dfb5d17574b0b
};

});

parcelRegister("jOQ1l", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $e6db0a088abd80c9$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $e6db0a088abd80c9$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $e6db0a088abd80c9$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $e6db0a088abd80c9$export$a07cdf6544bbd7c);

var $26Yns = parcelRequire("26Yns");
parcelRequire("8hRpd");
var $2qcAN = parcelRequire("2qcAN");
var $eCu93 = parcelRequire("eCu93");
var $gC6hj = parcelRequire("gC6hj");
var $9mPGZ = parcelRequire("9mPGZ");
var $5wyAc = parcelRequire("5wyAc");

var $f7Msz = parcelRequire("f7Msz");

var $9I9eJ = parcelRequire("9I9eJ");

var $iOmYe = parcelRequire("iOmYe");
var $e6db0a088abd80c9$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $e6db0a088abd80c9$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $e6db0a088abd80c9$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $9I9eJ.Scope)();
        if (_version === void 0) _version = $e6db0a088abd80c9$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $9I9eJ.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $5wyAc.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $26Yns.__assign)((0, $26Yns.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $5wyAc.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $26Yns.__assign)((0, $26Yns.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $5wyAc.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $26Yns.__assign)((0, $26Yns.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $e6db0a088abd80c9$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $eCu93.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $26Yns.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $2qcAN.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $e6db0a088abd80c9$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $e6db0a088abd80c9$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $f7Msz.IS_DEBUG_BUILD) && (0, $2qcAN.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $gC6hj.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $iOmYe.Session)((0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $26Yns.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $e6db0a088abd80c9$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $f7Msz.IS_DEBUG_BUILD) && (0, $2qcAN.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $e6db0a088abd80c9$export$19eade501500c6c1() {
    var carrier = (0, $gC6hj.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $e6db0a088abd80c9$export$4188a14ad302d1bc(hub) {
    var registry = $e6db0a088abd80c9$export$19eade501500c6c1();
    var oldHub = $e6db0a088abd80c9$export$bfa8a924a84a76b7(registry);
    $e6db0a088abd80c9$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $e6db0a088abd80c9$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $e6db0a088abd80c9$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$e6db0a088abd80c9$var$hasHubOnCarrier(registry) || $e6db0a088abd80c9$export$bfa8a924a84a76b7(registry).isOlderThan($e6db0a088abd80c9$export$24a86ef7798177e4)) $e6db0a088abd80c9$export$849f05434e95d2f2(registry, new $e6db0a088abd80c9$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $9mPGZ.isNodeEnv)()) return $e6db0a088abd80c9$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $e6db0a088abd80c9$export$bfa8a924a84a76b7(registry);
}
function $e6db0a088abd80c9$export$1c4d656130202699() {
    (0, $f7Msz.IS_DEBUG_BUILD) && (0, $2qcAN.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $e6db0a088abd80c9$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $e6db0a088abd80c9$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $e6db0a088abd80c9$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $e6db0a088abd80c9$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$e6db0a088abd80c9$var$hasHubOnCarrier(activeDomain) || $e6db0a088abd80c9$export$bfa8a924a84a76b7(activeDomain).isOlderThan($e6db0a088abd80c9$export$24a86ef7798177e4)) {
            var registryHubTopStack = $e6db0a088abd80c9$export$bfa8a924a84a76b7(registry).getStackTop();
            $e6db0a088abd80c9$export$849f05434e95d2f2(activeDomain, new $e6db0a088abd80c9$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $9I9eJ.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $e6db0a088abd80c9$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $e6db0a088abd80c9$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $e6db0a088abd80c9$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $e6db0a088abd80c9$export$bfa8a924a84a76b7(carrier) {
    return (0, $gC6hj.getGlobalSingleton)('hub', function() {
        return new $e6db0a088abd80c9$export$8c41bb232f1008b1();
    }, carrier);
}
function $e6db0a088abd80c9$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("8hRpd", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("gC6hj")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("gC6hj")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("7jtnn")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("7jtnn")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("2qcAN")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("2qcAN")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("5wyAc")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("is2mp")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("h0O0B")).SyncPromise);





parcelRequire("gC6hj");

parcelRequire("7jtnn");
parcelRequire("2qcAN");

parcelRequire("5wyAc");

var $9mPGZ = parcelRequire("9mPGZ");

parcelRequire("is2mp");







parcelRequire("h0O0B");

var $eCu93 = parcelRequire("eCu93");





$parcel$exportWildcard(module.exports, $9mPGZ);
$parcel$exportWildcard(module.exports, $eCu93);

});
parcelRegister("gC6hj", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $c18510a873b5950c$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $c18510a873b5950c$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9mPGZ = parcelRequire("9mPGZ");
var $c18510a873b5950c$var$fallbackGlobalObject = {};
function $c18510a873b5950c$export$256479dc0cea61c4() {
    return (0, $9mPGZ.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $c18510a873b5950c$var$fallbackGlobalObject;
}
function $c18510a873b5950c$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $c18510a873b5950c$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("9mPGZ", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $gK0ux = parcelRequire("gK0ux");

var $6nQJh = parcelRequire("6nQJh");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $gK0ux.isBrowserBundle)() && Object.prototype.toString.call(typeof $6nQJh !== 'undefined' ? $6nQJh : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("gK0ux", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $c30152d5e3f6d3ad$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $c30152d5e3f6d3ad$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("7jtnn", function(module, exports) {
$parcel$export(module.exports, "isError", () => $5531183563e041d0$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $5531183563e041d0$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $5531183563e041d0$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $5531183563e041d0$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $5531183563e041d0$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $5531183563e041d0$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $5531183563e041d0$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $5531183563e041d0$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $5531183563e041d0$export$f5b060c2914b97c8);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $5531183563e041d0$var$objectToString = Object.prototype.toString;
function $5531183563e041d0$export$e6127cc7fe7395c3(wat) {
    switch($5531183563e041d0$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $5531183563e041d0$export$49034edbe6b62415(wat, Error);
    }
}
function $5531183563e041d0$var$isBuiltin(wat, ty) {
    return $5531183563e041d0$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $5531183563e041d0$export$9f9636d330b71954(wat) {
    return $5531183563e041d0$var$isBuiltin(wat, 'ErrorEvent');
}
function $5531183563e041d0$export$ef9e2056653f0c8e(wat) {
    return $5531183563e041d0$var$isBuiltin(wat, 'DOMError');
}
function $5531183563e041d0$export$12e869b2a583f783(wat) {
    return $5531183563e041d0$var$isBuiltin(wat, 'DOMException');
}
function $5531183563e041d0$export$844ec244b1367d54(wat) {
    return $5531183563e041d0$var$isBuiltin(wat, 'String');
}
function $5531183563e041d0$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $5531183563e041d0$export$53b83ca8eaab0383(wat) {
    return $5531183563e041d0$var$isBuiltin(wat, 'Object');
}
function $5531183563e041d0$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $5531183563e041d0$export$49034edbe6b62415(wat, Event);
}
function $5531183563e041d0$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $5531183563e041d0$export$49034edbe6b62415(wat, Element);
}
function $5531183563e041d0$export$49841c62b9eff15(wat) {
    return $5531183563e041d0$var$isBuiltin(wat, 'RegExp');
}
function $5531183563e041d0$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $5531183563e041d0$export$bc2894c7158efbac(wat) {
    return $5531183563e041d0$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $5531183563e041d0$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $5531183563e041d0$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("2qcAN", function(module, exports) {
$parcel$export(module.exports, "consoleSandbox", () => $1c37c711edbb0647$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $1c37c711edbb0647$export$af88d00dbe7f521);

var $26Yns = parcelRequire("26Yns");

var $f2vNl = parcelRequire("f2vNl");

var $gC6hj = parcelRequire("gC6hj");
// TODO: Implement different loggers for different environments
var $1c37c711edbb0647$var$global = (0, $gC6hj.getGlobalObject)();
/** Prefix for logging strings */ var $1c37c711edbb0647$var$PREFIX = 'Sentry Logger ';
var $1c37c711edbb0647$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $1c37c711edbb0647$export$cda52e2a8927a2ca(callback) {
    var global = (0, $gC6hj.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $1c37c711edbb0647$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $1c37c711edbb0647$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $f2vNl.IS_DEBUG_BUILD) $1c37c711edbb0647$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $1c37c711edbb0647$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $1c37c711edbb0647$var$global.console)[name].apply(_a, (0, $26Yns.__spread)([
                    $1c37c711edbb0647$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $1c37c711edbb0647$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $1c37c711edbb0647$export$af88d00dbe7f521;
if (0, $f2vNl.IS_DEBUG_BUILD) $1c37c711edbb0647$export$af88d00dbe7f521 = (0, $gC6hj.getGlobalSingleton)('logger', $1c37c711edbb0647$var$makeLogger);
else $1c37c711edbb0647$export$af88d00dbe7f521 = $1c37c711edbb0647$var$makeLogger();

});
parcelRegister("f2vNl", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $af2fb4b29d1a9510$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $af2fb4b29d1a9510$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("5wyAc", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $405ac45418784592$export$19f53698e68b2496);

var $26Yns = parcelRequire("26Yns");

var $gC6hj = parcelRequire("gC6hj");

var $is2mp = parcelRequire("is2mp");

var $6FsBa = parcelRequire("6FsBa");
function $405ac45418784592$export$19f53698e68b2496() {
    var global = (0, $gC6hj.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $405ac45418784592$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $405ac45418784592$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $405ac45418784592$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $405ac45418784592$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $405ac45418784592$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $405ac45418784592$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $405ac45418784592$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $405ac45418784592$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $405ac45418784592$export$d364f2020ab30578(input) {
    var match = input.match($405ac45418784592$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $405ac45418784592$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $6FsBa.snipLine)(line, 0);
    });
    frame.context_line = (0, $6FsBa.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $6FsBa.snipLine)(line, 0);
    });
}
function $405ac45418784592$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $405ac45418784592$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $is2mp.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("is2mp", function(module, exports) {
$parcel$export(module.exports, "addNonEnumerableProperty", () => $d6ecac3d4af06331$export$e73679ffaf56810e);
$parcel$export(module.exports, "dropUndefinedKeys", () => $d6ecac3d4af06331$export$d25f2688db1bb433);

var $26Yns = parcelRequire("26Yns");

var $IkRb2 = parcelRequire("IkRb2");

var $7jtnn = parcelRequire("7jtnn");

var $6FsBa = parcelRequire("6FsBa");
function $d6ecac3d4af06331$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $d6ecac3d4af06331$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $d6ecac3d4af06331$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $d6ecac3d4af06331$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $d6ecac3d4af06331$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $d6ecac3d4af06331$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $d6ecac3d4af06331$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $d6ecac3d4af06331$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $7jtnn.isError)(value)) newObj = (0, $26Yns.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $d6ecac3d4af06331$var$getOwnProperties(value));
    else if ((0, $7jtnn.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $26Yns.__assign)({
            type: event_1.type,
            target: $d6ecac3d4af06331$var$serializeEventTarget(event_1.target),
            currentTarget: $d6ecac3d4af06331$var$serializeEventTarget(event_1.currentTarget)
        }, $d6ecac3d4af06331$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $7jtnn.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $d6ecac3d4af06331$var$serializeEventTarget(target) {
    try {
        return (0, $7jtnn.isElement)(target) ? (0, $IkRb2.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $d6ecac3d4af06331$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $d6ecac3d4af06331$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($d6ecac3d4af06331$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $6FsBa.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $6FsBa.truncate)(serialized, maxLength);
    }
    return '';
}
function $d6ecac3d4af06331$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $7jtnn.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $26Yns.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $d6ecac3d4af06331$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($d6ecac3d4af06331$export$d25f2688db1bb433);
    return val;
}
function $d6ecac3d4af06331$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7jtnn.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("IkRb2", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $085449e15c7c613a$export$5647df6b7814ac86);

var $gC6hj = parcelRequire("gC6hj");

var $7jtnn = parcelRequire("7jtnn");
function $085449e15c7c613a$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $085449e15c7c613a$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $085449e15c7c613a$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $7jtnn.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $085449e15c7c613a$export$1cfafeee2987818b() {
    var global = (0, $gC6hj.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("6FsBa", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $4dacc17ca8251570$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $4dacc17ca8251570$export$4215662d762d6f9d);

var $7jtnn = parcelRequire("7jtnn");
function $4dacc17ca8251570$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $4dacc17ca8251570$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $4dacc17ca8251570$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $4dacc17ca8251570$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $7jtnn.isString)(value)) return false;
    if ((0, $7jtnn.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $4dacc17ca8251570$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("h0O0B", function(module, exports) {
$parcel$export(module.exports, "SyncPromise", () => $c6293a7878e3cf45$export$6f292d4960313241);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7jtnn = parcelRequire("7jtnn");
function $c6293a7878e3cf45$export$1fda8aa4d135f8aa(value) {
    return new $c6293a7878e3cf45$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $c6293a7878e3cf45$export$78e43115b553f358(reason) {
    return new $c6293a7878e3cf45$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $c6293a7878e3cf45$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $7jtnn.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("eCu93", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $gC6hj = parcelRequire("gC6hj");

var $9mPGZ = parcelRequire("9mPGZ");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $gC6hj.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $9mPGZ.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $9mPGZ.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $gC6hj.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});


parcelRegister("f7Msz", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $b02d1996544f4969$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $b02d1996544f4969$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("9I9eJ", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $711f634d57689299$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $711f634d57689299$export$8e4e25f54d456511);

var $26Yns = parcelRequire("26Yns");
parcelRequire("8hRpd");
var $eCu93 = parcelRequire("eCu93");
var $gC6hj = parcelRequire("gC6hj");
var $7jtnn = parcelRequire("7jtnn");
var $h0O0B = parcelRequire("h0O0B");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $711f634d57689299$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $711f634d57689299$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $26Yns.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $26Yns.__assign)({}, scope._tags);
            newScope._extra = (0, $26Yns.__assign)({}, scope._extra);
            newScope._contexts = (0, $26Yns.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $26Yns.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $7jtnn.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $711f634d57689299$var$MAX_BREADCRUMBS) : $711f634d57689299$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $26Yns.__assign)({
            timestamp: (0, $eCu93.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $26Yns.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $26Yns.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $26Yns.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $26Yns.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $26Yns.__spread)($711f634d57689299$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $h0O0B.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $26Yns.__assign)({}, event), hint);
                if ((0, $7jtnn.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $711f634d57689299$var$getGlobalEventProcessors() {
    return (0, $gC6hj.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $711f634d57689299$export$8e4e25f54d456511(callback) {
    $711f634d57689299$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("iOmYe", function(module, exports) {
$parcel$export(module.exports, "Session", () => $db1eb6f3de758bcc$export$1fb4852a55678982);
parcelRequire("8hRpd");
var $is2mp = parcelRequire("is2mp");
var $eCu93 = parcelRequire("eCu93");
var $5wyAc = parcelRequire("5wyAc");
/**
 * @inheritdoc
 */ var $db1eb6f3de758bcc$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $5wyAc.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $eCu93.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $eCu93.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $5wyAc.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $is2mp.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("dMfOg", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $26Yns = parcelRequire("26Yns");

var $7dUhV = parcelRequire("7dUhV");
parcelRequire("khHJA");
var $1QJ8J = parcelRequire("1QJ8J");
var $7sB74 = parcelRequire("7sB74");
var $jvXYw = parcelRequire("jvXYw");
var $7dhJq = parcelRequire("7dhJq");
var $03yOv = parcelRequire("03yOv");
var $73tIz = parcelRequire("73tIz");

var $k9EHS = parcelRequire("k9EHS");
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */ function $a07c058d52101abe$var$exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $a07c058d52101abe$var$parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: $a07c058d52101abe$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
module.exports.exceptionFromError = $a07c058d52101abe$var$exceptionFromError;
/**
 * @hidden
 */ function $a07c058d52101abe$var$eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: $7dhJq.isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + $jvXYw.extractExceptionKeysForMessage(exception)
                }
            ]
        },
        extra: {
            __serialized__: $03yOv.normalizeToSize(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $a07c058d52101abe$var$parseStackFrames(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
module.exports.eventFromPlainObject = $a07c058d52101abe$var$eventFromPlainObject;
/**
 * @hidden
 */ function $a07c058d52101abe$var$eventFromError(ex) {
    return {
        exception: {
            values: [
                $a07c058d52101abe$var$exceptionFromError(ex)
            ]
        }
    };
}
module.exports.eventFromError = $a07c058d52101abe$var$eventFromError;
/** Parses stack frames from an error */ function $a07c058d52101abe$var$parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $a07c058d52101abe$var$getPopSize(ex);
    try {
        return $7sB74.createStackParser($k9EHS.opera10StackParser, $k9EHS.opera11StackParser, $k9EHS.chromeStackParser, $k9EHS.winjsStackParser, $k9EHS.geckoStackParser)(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
module.exports.parseStackFrames = $a07c058d52101abe$var$parseStackFrames;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $a07c058d52101abe$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $a07c058d52101abe$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($a07c058d52101abe$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $a07c058d52101abe$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $a07c058d52101abe$var$eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $a07c058d52101abe$var$eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    $1QJ8J.addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
    event.level = $7dUhV.Severity.Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return $73tIz.resolvedSyncPromise(event);
}
module.exports.eventFromException = $a07c058d52101abe$var$eventFromException;
/**
 * Builds and Event from a Message
 * @hidden
 */ function $a07c058d52101abe$var$eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) level = $7dUhV.Severity.Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $a07c058d52101abe$var$eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return $73tIz.resolvedSyncPromise(event);
}
module.exports.eventFromMessage = $a07c058d52101abe$var$eventFromMessage;
/**
 * @hidden
 */ function $a07c058d52101abe$var$eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ($7dhJq.isErrorEvent(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $a07c058d52101abe$var$eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ($7dhJq.isDOMError(exception) || $7dhJq.isDOMException(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $a07c058d52101abe$var$eventFromError(exception);
        else {
            var name_1 = domException.name || ($7dhJq.isDOMError(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $a07c058d52101abe$var$eventFromString(message, syntheticException, attachStacktrace);
            $1QJ8J.addExceptionTypeValue(event, message);
        }
        if ('code' in domException) event.tags = $26Yns.__assign($26Yns.__assign({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ($7dhJq.isError(exception)) // we have a real Error object, do nothing
    return $a07c058d52101abe$var$eventFromError(exception);
    if ($7dhJq.isPlainObject(exception) || $7dhJq.isEvent(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $a07c058d52101abe$var$eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        $1QJ8J.addExceptionMechanism(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $a07c058d52101abe$var$eventFromString(exception, syntheticException, attachStacktrace);
    $1QJ8J.addExceptionTypeValue(event, "" + exception, undefined);
    $1QJ8J.addExceptionMechanism(event, {
        synthetic: true
    });
    return event;
}
module.exports.eventFromUnknownInput = $a07c058d52101abe$var$eventFromUnknownInput;
/**
 * @hidden
 */ function $a07c058d52101abe$var$eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $a07c058d52101abe$var$parseStackFrames(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}
module.exports.eventFromString = $a07c058d52101abe$var$eventFromString;

});
parcelRegister("7dUhV", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $542568f45d6bd53f$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $542568f45d6bd53f$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($542568f45d6bd53f$export$918a9776c0a3cf27 || ($542568f45d6bd53f$export$918a9776c0a3cf27 = {}));
var $542568f45d6bd53f$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("khHJA", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("emF3L")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("3fvx1")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("3fvx1")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("a7iFf")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("a7iFf")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("9HMyy")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("eCKEK")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("9kMYu")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("7dhJq")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("7dhJq")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("7dhJq")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("7dhJq")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("7dhJq")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("7dhJq")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("7dhJq")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("7dhJq")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("7dhJq")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("7dhJq")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("g22PF")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("1QJ8J")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("1QJ8J")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("1QJ8J")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("1QJ8J")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("1QJ8J")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("1QJ8J")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("03yOv")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("03yOv")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("jvXYw")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("jvXYw")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("jvXYw")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("jvXYw")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("jvXYw")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("jvXYw")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("enMla")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("d4rmG")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("7sB74")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("7sB74")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("14A9E")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("1JVAb")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("1JVAb")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("1JVAb")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("8rfhF")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("8rfhF")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("8rfhF")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("73tIz")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("73tIz")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("73tIz")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("7YW6e")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("7YW6e")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("7YW6e")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("frpgL")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("1RTkP")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("1RTkP")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("1RTkP")).updateRateLimits);
parcelRequire("emF3L");
parcelRequire("3fvx1");
parcelRequire("a7iFf");

parcelRequire("9HMyy");
parcelRequire("eCKEK");
parcelRequire("9kMYu");
parcelRequire("7dhJq");
parcelRequire("g22PF");

parcelRequire("1QJ8J");

var $9rzO2 = parcelRequire("9rzO2");
parcelRequire("03yOv");
parcelRequire("jvXYw");

parcelRequire("enMla");
parcelRequire("d4rmG");
parcelRequire("7sB74");
parcelRequire("14A9E");
parcelRequire("1JVAb");
parcelRequire("8rfhF");
parcelRequire("73tIz");

var $fiIpw = parcelRequire("fiIpw");


parcelRequire("7YW6e");
parcelRequire("frpgL");
parcelRequire("1RTkP");
$parcel$exportWildcard(module.exports, $9rzO2);
$parcel$exportWildcard(module.exports, $fiIpw);

});
parcelRegister("emF3L", function(module, exports) {
$parcel$export(module.exports, "forget", () => $a752f8621ab2fdcb$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a752f8621ab2fdcb$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("3fvx1", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $25db3b559425455b$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $25db3b559425455b$export$1cfafeee2987818b);

var $eCKEK = parcelRequire("eCKEK");

var $7dhJq = parcelRequire("7dhJq");
function $25db3b559425455b$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $25db3b559425455b$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $25db3b559425455b$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $7dhJq.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $25db3b559425455b$export$1cfafeee2987818b() {
    var global = (0, $eCKEK.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("eCKEK", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $aa58ce44324fdcc1$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $aa58ce44324fdcc1$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9rzO2 = parcelRequire("9rzO2");
var $aa58ce44324fdcc1$var$fallbackGlobalObject = {};
function $aa58ce44324fdcc1$export$256479dc0cea61c4() {
    return (0, $9rzO2.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $aa58ce44324fdcc1$var$fallbackGlobalObject;
}
function $aa58ce44324fdcc1$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $aa58ce44324fdcc1$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("9rzO2", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $fROJq = parcelRequire("fROJq");

var $6nQJh = parcelRequire("6nQJh");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $fROJq.isBrowserBundle)() && Object.prototype.toString.call(typeof $6nQJh !== 'undefined' ? $6nQJh : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("fROJq", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $b8d32884a5f310fc$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $b8d32884a5f310fc$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("7dhJq", function(module, exports) {
$parcel$export(module.exports, "isError", () => $54078073762e0901$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $54078073762e0901$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $54078073762e0901$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $54078073762e0901$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $54078073762e0901$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $54078073762e0901$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $54078073762e0901$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $54078073762e0901$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $54078073762e0901$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $54078073762e0901$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $54078073762e0901$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $54078073762e0901$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $54078073762e0901$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $54078073762e0901$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $54078073762e0901$var$objectToString = Object.prototype.toString;
function $54078073762e0901$export$e6127cc7fe7395c3(wat) {
    switch($54078073762e0901$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $54078073762e0901$export$49034edbe6b62415(wat, Error);
    }
}
function $54078073762e0901$var$isBuiltin(wat, ty) {
    return $54078073762e0901$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $54078073762e0901$export$9f9636d330b71954(wat) {
    return $54078073762e0901$var$isBuiltin(wat, 'ErrorEvent');
}
function $54078073762e0901$export$ef9e2056653f0c8e(wat) {
    return $54078073762e0901$var$isBuiltin(wat, 'DOMError');
}
function $54078073762e0901$export$12e869b2a583f783(wat) {
    return $54078073762e0901$var$isBuiltin(wat, 'DOMException');
}
function $54078073762e0901$export$844ec244b1367d54(wat) {
    return $54078073762e0901$var$isBuiltin(wat, 'String');
}
function $54078073762e0901$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $54078073762e0901$export$53b83ca8eaab0383(wat) {
    return $54078073762e0901$var$isBuiltin(wat, 'Object');
}
function $54078073762e0901$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $54078073762e0901$export$49034edbe6b62415(wat, Event);
}
function $54078073762e0901$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $54078073762e0901$export$49034edbe6b62415(wat, Element);
}
function $54078073762e0901$export$49841c62b9eff15(wat) {
    return $54078073762e0901$var$isBuiltin(wat, 'RegExp');
}
function $54078073762e0901$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $54078073762e0901$export$bc2894c7158efbac(wat) {
    return $54078073762e0901$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $54078073762e0901$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $54078073762e0901$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("a7iFf", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $75d90926bd117cf8$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $75d90926bd117cf8$export$128827c3562ec0cb);

var $26Yns = parcelRequire("26Yns");

var $9HMyy = parcelRequire("9HMyy");

var $5ur4L = parcelRequire("5ur4L");
/** Regular expression used to parse a Dsn. */ var $75d90926bd117cf8$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $75d90926bd117cf8$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $75d90926bd117cf8$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $75d90926bd117cf8$var$dsnFromString(str) {
    var match = $75d90926bd117cf8$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $9HMyy.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $26Yns.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $75d90926bd117cf8$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $75d90926bd117cf8$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $75d90926bd117cf8$var$validateDsn(dsn) {
    if (!(0, $5ur4L.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $9HMyy.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $9HMyy.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$75d90926bd117cf8$var$isValidProtocol(protocol)) throw new (0, $9HMyy.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $9HMyy.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $75d90926bd117cf8$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $75d90926bd117cf8$var$dsnFromString(from) : $75d90926bd117cf8$var$dsnFromComponents(from);
    $75d90926bd117cf8$var$validateDsn(components);
    return components;
}

});
parcelRegister("9HMyy", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $710dcb811e604035$export$5949942ba2a7c0e2);

var $26Yns = parcelRequire("26Yns");

var $9P94v = parcelRequire("9P94v");
/** An error emitted by Sentry SDKs and related utilities. */ var $710dcb811e604035$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $9P94v.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("9P94v", function(module, exports) {
$parcel$export(module.exports, "setPrototypeOf", () => $726fe9ed5cdaaa8f$export$1cb0d91350beb6cc);
var $726fe9ed5cdaaa8f$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $726fe9ed5cdaaa8f$var$setProtoOf : $726fe9ed5cdaaa8f$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $726fe9ed5cdaaa8f$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $726fe9ed5cdaaa8f$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("5ur4L", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $3ff4c1cc5df4de7d$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $3ff4c1cc5df4de7d$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("9kMYu", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => $6cbbf8a3e11be1e7$export$285b9172a3741fb7);

var $26Yns = parcelRequire("26Yns");

var $5ur4L = parcelRequire("5ur4L");

var $eCKEK = parcelRequire("eCKEK");

var $7dhJq = parcelRequire("7dhJq");

var $g22PF = parcelRequire("g22PF");

var $jvXYw = parcelRequire("jvXYw");

var $7sB74 = parcelRequire("7sB74");

var $8rfhF = parcelRequire("8rfhF");
var $6cbbf8a3e11be1e7$var$global = (0, $eCKEK.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $6cbbf8a3e11be1e7$var$handlers = {};
var $6cbbf8a3e11be1e7$var$instrumented = {};
/** Instruments given API */ function $6cbbf8a3e11be1e7$var$instrument(type) {
    if ($6cbbf8a3e11be1e7$var$instrumented[type]) return;
    $6cbbf8a3e11be1e7$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $6cbbf8a3e11be1e7$var$instrumentConsole();
            break;
        case 'dom':
            $6cbbf8a3e11be1e7$var$instrumentDOM();
            break;
        case 'xhr':
            $6cbbf8a3e11be1e7$var$instrumentXHR();
            break;
        case 'fetch':
            $6cbbf8a3e11be1e7$var$instrumentFetch();
            break;
        case 'history':
            $6cbbf8a3e11be1e7$var$instrumentHistory();
            break;
        case 'error':
            $6cbbf8a3e11be1e7$var$instrumentError();
            break;
        case 'unhandledrejection':
            $6cbbf8a3e11be1e7$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $5ur4L.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $6cbbf8a3e11be1e7$export$285b9172a3741fb7(type, callback) {
    $6cbbf8a3e11be1e7$var$handlers[type] = $6cbbf8a3e11be1e7$var$handlers[type] || [];
    $6cbbf8a3e11be1e7$var$handlers[type].push(callback);
    $6cbbf8a3e11be1e7$var$instrument(type);
}
/** JSDoc */ function $6cbbf8a3e11be1e7$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$6cbbf8a3e11be1e7$var$handlers[type]) return;
    try {
        for(var _b = (0, $26Yns.__values)($6cbbf8a3e11be1e7$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $5ur4L.IS_DEBUG_BUILD) && (0, $g22PF.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $7sB74.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $6cbbf8a3e11be1e7$var$instrumentConsole() {
    if (!('console' in $6cbbf8a3e11be1e7$var$global)) return;
    (0, $g22PF.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $6cbbf8a3e11be1e7$var$global.console)) return;
        (0, $jvXYw.fill)($6cbbf8a3e11be1e7$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $6cbbf8a3e11be1e7$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($6cbbf8a3e11be1e7$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $6cbbf8a3e11be1e7$var$instrumentFetch() {
    if (!(0, $8rfhF.supportsNativeFetch)()) return;
    (0, $jvXYw.fill)($6cbbf8a3e11be1e7$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $6cbbf8a3e11be1e7$var$getFetchMethod(args),
                    url: $6cbbf8a3e11be1e7$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $6cbbf8a3e11be1e7$var$triggerHandlers('fetch', (0, $26Yns.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($6cbbf8a3e11be1e7$var$global, args).then(function(response) {
                $6cbbf8a3e11be1e7$var$triggerHandlers('fetch', (0, $26Yns.__assign)((0, $26Yns.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $6cbbf8a3e11be1e7$var$triggerHandlers('fetch', (0, $26Yns.__assign)((0, $26Yns.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $6cbbf8a3e11be1e7$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $6cbbf8a3e11be1e7$var$global && (0, $7dhJq.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $6cbbf8a3e11be1e7$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $6cbbf8a3e11be1e7$var$global && (0, $7dhJq.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $6cbbf8a3e11be1e7$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $6cbbf8a3e11be1e7$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $jvXYw.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $7dhJq.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $7dhJq.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $6cbbf8a3e11be1e7$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $jvXYw.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $jvXYw.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $6cbbf8a3e11be1e7$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $6cbbf8a3e11be1e7$var$lastHref;
/** JSDoc */ function $6cbbf8a3e11be1e7$var$instrumentHistory() {
    if (!(0, $8rfhF.supportsHistory)()) return;
    var oldOnPopState = $6cbbf8a3e11be1e7$var$global.onpopstate;
    $6cbbf8a3e11be1e7$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $6cbbf8a3e11be1e7$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $6cbbf8a3e11be1e7$var$lastHref;
        $6cbbf8a3e11be1e7$var$lastHref = to;
        $6cbbf8a3e11be1e7$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $6cbbf8a3e11be1e7$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $6cbbf8a3e11be1e7$var$lastHref = to;
                $6cbbf8a3e11be1e7$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $jvXYw.fill)($6cbbf8a3e11be1e7$var$global.history, 'pushState', historyReplacementFunction);
    (0, $jvXYw.fill)($6cbbf8a3e11be1e7$var$global.history, 'replaceState', historyReplacementFunction);
}
var $6cbbf8a3e11be1e7$var$debounceDuration = 1000;
var $6cbbf8a3e11be1e7$var$debounceTimerID;
var $6cbbf8a3e11be1e7$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $6cbbf8a3e11be1e7$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $6cbbf8a3e11be1e7$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $6cbbf8a3e11be1e7$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $6cbbf8a3e11be1e7$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($6cbbf8a3e11be1e7$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($6cbbf8a3e11be1e7$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $6cbbf8a3e11be1e7$var$lastCapturedEvent = event;
        } else if ($6cbbf8a3e11be1e7$var$shouldShortcircuitPreviousDebounce($6cbbf8a3e11be1e7$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $6cbbf8a3e11be1e7$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($6cbbf8a3e11be1e7$var$debounceTimerID);
        $6cbbf8a3e11be1e7$var$debounceTimerID = $6cbbf8a3e11be1e7$var$global.setTimeout(function() {
            $6cbbf8a3e11be1e7$var$debounceTimerID = undefined;
        }, $6cbbf8a3e11be1e7$var$debounceDuration);
    };
}
/** JSDoc */ function $6cbbf8a3e11be1e7$var$instrumentDOM() {
    if (!('document' in $6cbbf8a3e11be1e7$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $6cbbf8a3e11be1e7$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $6cbbf8a3e11be1e7$var$makeDOMEventHandler(triggerDOMHandler, true);
    $6cbbf8a3e11be1e7$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $6cbbf8a3e11be1e7$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $6cbbf8a3e11be1e7$var$global[target] && $6cbbf8a3e11be1e7$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $jvXYw.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $6cbbf8a3e11be1e7$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $jvXYw.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $6cbbf8a3e11be1e7$var$_oldOnErrorHandler = null;
/** JSDoc */ function $6cbbf8a3e11be1e7$var$instrumentError() {
    $6cbbf8a3e11be1e7$var$_oldOnErrorHandler = $6cbbf8a3e11be1e7$var$global.onerror;
    $6cbbf8a3e11be1e7$var$global.onerror = function(msg, url, line, column, error) {
        $6cbbf8a3e11be1e7$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($6cbbf8a3e11be1e7$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $6cbbf8a3e11be1e7$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $6cbbf8a3e11be1e7$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $6cbbf8a3e11be1e7$var$instrumentUnhandledRejection() {
    $6cbbf8a3e11be1e7$var$_oldOnUnhandledRejectionHandler = $6cbbf8a3e11be1e7$var$global.onunhandledrejection;
    $6cbbf8a3e11be1e7$var$global.onunhandledrejection = function(e) {
        $6cbbf8a3e11be1e7$var$triggerHandlers('unhandledrejection', e);
        if ($6cbbf8a3e11be1e7$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $6cbbf8a3e11be1e7$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("g22PF", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $babf07ae14cdd34b$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $babf07ae14cdd34b$export$af88d00dbe7f521);

var $26Yns = parcelRequire("26Yns");

var $5ur4L = parcelRequire("5ur4L");

var $eCKEK = parcelRequire("eCKEK");
// TODO: Implement different loggers for different environments
var $babf07ae14cdd34b$var$global = (0, $eCKEK.getGlobalObject)();
/** Prefix for logging strings */ var $babf07ae14cdd34b$var$PREFIX = 'Sentry Logger ';
var $babf07ae14cdd34b$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $babf07ae14cdd34b$export$cda52e2a8927a2ca(callback) {
    var global = (0, $eCKEK.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $babf07ae14cdd34b$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $babf07ae14cdd34b$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $5ur4L.IS_DEBUG_BUILD) $babf07ae14cdd34b$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $babf07ae14cdd34b$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $babf07ae14cdd34b$var$global.console)[name].apply(_a, (0, $26Yns.__spread)([
                    $babf07ae14cdd34b$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $babf07ae14cdd34b$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $babf07ae14cdd34b$export$af88d00dbe7f521;
if (0, $5ur4L.IS_DEBUG_BUILD) $babf07ae14cdd34b$export$af88d00dbe7f521 = (0, $eCKEK.getGlobalSingleton)('logger', $babf07ae14cdd34b$var$makeLogger);
else $babf07ae14cdd34b$export$af88d00dbe7f521 = $babf07ae14cdd34b$var$makeLogger();

});

parcelRegister("jvXYw", function(module, exports) {
$parcel$export(module.exports, "fill", () => $e34f6f696b8c617d$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $e34f6f696b8c617d$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $e34f6f696b8c617d$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $e34f6f696b8c617d$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $e34f6f696b8c617d$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $e34f6f696b8c617d$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $e34f6f696b8c617d$export$b0244d5063c0b61b);

var $26Yns = parcelRequire("26Yns");

var $3fvx1 = parcelRequire("3fvx1");

var $7dhJq = parcelRequire("7dhJq");

var $1JVAb = parcelRequire("1JVAb");
function $e34f6f696b8c617d$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $e34f6f696b8c617d$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $e34f6f696b8c617d$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $e34f6f696b8c617d$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $e34f6f696b8c617d$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $e34f6f696b8c617d$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $e34f6f696b8c617d$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $e34f6f696b8c617d$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $7dhJq.isError)(value)) newObj = (0, $26Yns.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $e34f6f696b8c617d$var$getOwnProperties(value));
    else if ((0, $7dhJq.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $26Yns.__assign)({
            type: event_1.type,
            target: $e34f6f696b8c617d$var$serializeEventTarget(event_1.target),
            currentTarget: $e34f6f696b8c617d$var$serializeEventTarget(event_1.currentTarget)
        }, $e34f6f696b8c617d$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $7dhJq.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $e34f6f696b8c617d$var$serializeEventTarget(target) {
    try {
        return (0, $7dhJq.isElement)(target) ? (0, $3fvx1.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $e34f6f696b8c617d$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $e34f6f696b8c617d$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($e34f6f696b8c617d$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $1JVAb.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $1JVAb.truncate)(serialized, maxLength);
    }
    return '';
}
function $e34f6f696b8c617d$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $7dhJq.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $26Yns.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $e34f6f696b8c617d$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($e34f6f696b8c617d$export$d25f2688db1bb433);
    return val;
}
function $e34f6f696b8c617d$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7dhJq.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("1JVAb", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $1446a92293d13ad1$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $1446a92293d13ad1$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $1446a92293d13ad1$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $1446a92293d13ad1$export$cdded5b28a5f8c6d);

var $7dhJq = parcelRequire("7dhJq");
function $1446a92293d13ad1$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $1446a92293d13ad1$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $1446a92293d13ad1$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $1446a92293d13ad1$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $7dhJq.isString)(value)) return false;
    if ((0, $7dhJq.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $1446a92293d13ad1$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("7sB74", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $56e7efcae846bef5$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $56e7efcae846bef5$export$aad197c7121a6651);

var $26Yns = parcelRequire("26Yns");
var $56e7efcae846bef5$var$STACKTRACE_LIMIT = 50;
function $56e7efcae846bef5$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $26Yns.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $26Yns.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $56e7efcae846bef5$export$c55c24c0eeba0205(frames);
    };
}
function $56e7efcae846bef5$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $56e7efcae846bef5$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $56e7efcae846bef5$var$defaultFunctionName = '<anonymous>';
function $56e7efcae846bef5$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $56e7efcae846bef5$var$defaultFunctionName;
        return fn.name || $56e7efcae846bef5$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $56e7efcae846bef5$var$defaultFunctionName;
    }
}

});

parcelRegister("8rfhF", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $624cb36872b2947a$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $624cb36872b2947a$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $624cb36872b2947a$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $624cb36872b2947a$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $624cb36872b2947a$export$67fc34576016d6ec);

var $5ur4L = parcelRequire("5ur4L");

var $eCKEK = parcelRequire("eCKEK");

var $g22PF = parcelRequire("g22PF");
function $624cb36872b2947a$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $624cb36872b2947a$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $624cb36872b2947a$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $624cb36872b2947a$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $eCKEK.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $624cb36872b2947a$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $624cb36872b2947a$export$c82d238e23c40b21() {
    if (!$624cb36872b2947a$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $eCKEK.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($624cb36872b2947a$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $624cb36872b2947a$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $5ur4L.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $624cb36872b2947a$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $eCKEK.getGlobalObject)();
}
function $624cb36872b2947a$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$624cb36872b2947a$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $624cb36872b2947a$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $eCKEK.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("1QJ8J", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $158da99d4bd898ae$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $158da99d4bd898ae$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $158da99d4bd898ae$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $158da99d4bd898ae$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $158da99d4bd898ae$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $158da99d4bd898ae$export$6de4ffac6a2f1098);

var $26Yns = parcelRequire("26Yns");

var $eCKEK = parcelRequire("eCKEK");

var $jvXYw = parcelRequire("jvXYw");

var $1JVAb = parcelRequire("1JVAb");
function $158da99d4bd898ae$export$19f53698e68b2496() {
    var global = (0, $eCKEK.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $158da99d4bd898ae$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $158da99d4bd898ae$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $158da99d4bd898ae$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $158da99d4bd898ae$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $158da99d4bd898ae$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $158da99d4bd898ae$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $158da99d4bd898ae$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $158da99d4bd898ae$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $158da99d4bd898ae$export$d364f2020ab30578(input) {
    var match = input.match($158da99d4bd898ae$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $158da99d4bd898ae$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $1JVAb.snipLine)(line, 0);
    });
    frame.context_line = (0, $1JVAb.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $1JVAb.snipLine)(line, 0);
    });
}
function $158da99d4bd898ae$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $158da99d4bd898ae$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $jvXYw.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("03yOv", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $00ab49352734abee$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $00ab49352734abee$export$23fbbb20bed71033);

var $26Yns = parcelRequire("26Yns");

var $7dhJq = parcelRequire("7dhJq");

var $fBq1f = parcelRequire("fBq1f");

var $jvXYw = parcelRequire("jvXYw");

var $7sB74 = parcelRequire("7sB74");
function $00ab49352734abee$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $00ab49352734abee$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $00ab49352734abee$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $00ab49352734abee$export$a3295358bff77e(object, depth);
    if ($00ab49352734abee$var$jsonSize(normalized) > maxSize) return $00ab49352734abee$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $00ab49352734abee$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $fBq1f.memoBuilder)();
    var _a = (0, $26Yns.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $7dhJq.isNaN)(value)) return value;
    var stringified = $00ab49352734abee$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $7dhJq.isError)(value) || (0, $7dhJq.isEvent)(value) ? (0, $jvXYw.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $00ab49352734abee$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $00ab49352734abee$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $7dhJq.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $7sB74.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $00ab49352734abee$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $00ab49352734abee$var$jsonSize(value) {
    return $00ab49352734abee$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("fBq1f", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $b5be7e92ca6b80e5$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $b5be7e92ca6b80e5$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("enMla", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $a788b61711e67874$export$85a4f67f852183e6);

var $9HMyy = parcelRequire("9HMyy");

var $73tIz = parcelRequire("73tIz");
function $a788b61711e67874$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $73tIz.rejectedSyncPromise)(new (0, $9HMyy.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $73tIz.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $73tIz.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("73tIz", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $522fdd9424d89c8c$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $522fdd9424d89c8c$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $522fdd9424d89c8c$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7dhJq = parcelRequire("7dhJq");
function $522fdd9424d89c8c$export$1fda8aa4d135f8aa(value) {
    return new $522fdd9424d89c8c$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $522fdd9424d89c8c$export$78e43115b553f358(reason) {
    return new $522fdd9424d89c8c$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $522fdd9424d89c8c$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $7dhJq.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("d4rmG", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $9840e032f993342a$export$e01cef29b4327697);

var $7dUhV = parcelRequire("7dUhV");

var $klTWn = parcelRequire("klTWn");
function $9840e032f993342a$var$isSupportedSeverity(level) {
    return (0, $klTWn.SeverityLevels).indexOf(level) !== -1;
}
function $9840e032f993342a$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $7dUhV.Severity).Warning;
    if ($9840e032f993342a$var$isSupportedSeverity(level)) return level;
    return (0, $7dUhV.Severity).Log;
}

});
parcelRegister("klTWn", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $ed11296dfd4901a5$export$484b1ea9aec914c);
var $ed11296dfd4901a5$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("14A9E", function(module, exports) {
$parcel$export(module.exports, "eventStatusFromHttpCode", () => $0c8235b6eb49cae9$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $0c8235b6eb49cae9$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("fiIpw", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $eCKEK = parcelRequire("eCKEK");

var $9rzO2 = parcelRequire("9rzO2");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $eCKEK.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $9rzO2.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $9rzO2.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $eCKEK.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("7YW6e", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $5cfb34566786f010$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $5cfb34566786f010$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $5cfb34566786f010$export$32f9b428425aac85);

var $26Yns = parcelRequire("26Yns");

var $7dhJq = parcelRequire("7dhJq");
function $5cfb34566786f010$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $5cfb34566786f010$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $26Yns.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $26Yns.__spread)(items, [
            newItem
        ])
    ];
}
function $5cfb34566786f010$export$d84939284bbafcd4(envelope) {
    var _a = (0, $26Yns.__read)(envelope, 2), _b = (0, $26Yns.__read)(_a[1], 1), _c = (0, $26Yns.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $5cfb34566786f010$export$32f9b428425aac85(envelope) {
    var _a = (0, $26Yns.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $26Yns.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $7dhJq.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("frpgL", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $b3dcfa9a8609e501$export$f3b9ed77c03eeb00);

var $7YW6e = parcelRequire("7YW6e");

var $fiIpw = parcelRequire("fiIpw");
function $b3dcfa9a8609e501$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $fiIpw.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $7YW6e.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("1RTkP", function(module, exports) {
$parcel$export(module.exports, "disabledUntil", () => $15c5aa117f7bee3a$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $15c5aa117f7bee3a$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $15c5aa117f7bee3a$export$699aff705e0d49d4);

var $26Yns = parcelRequire("26Yns");
var $15c5aa117f7bee3a$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $15c5aa117f7bee3a$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $15c5aa117f7bee3a$export$b09ce39faaeb1e7c;
}
function $15c5aa117f7bee3a$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $15c5aa117f7bee3a$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $15c5aa117f7bee3a$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $15c5aa117f7bee3a$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $26Yns.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $26Yns.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $26Yns.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $15c5aa117f7bee3a$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("k9EHS", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $26Yns = parcelRequire("26Yns");
// global reference to slice
var $eac4396568362ab4$var$UNKNOWN_FUNCTION = '?';
var $eac4396568362ab4$var$OPERA10_PRIORITY = 10;
var $eac4396568362ab4$var$OPERA11_PRIORITY = 20;
var $eac4396568362ab4$var$CHROME_PRIORITY = 30;
var $eac4396568362ab4$var$WINJS_PRIORITY = 40;
var $eac4396568362ab4$var$GECKO_PRIORITY = 50;
function $eac4396568362ab4$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $eac4396568362ab4$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $eac4396568362ab4$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $eac4396568362ab4$var$chrome = function(line) {
    var parts = $eac4396568362ab4$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $eac4396568362ab4$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = $26Yns.__read($eac4396568362ab4$var$extractSafariExtensionDetails(parts[1] || $eac4396568362ab4$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $eac4396568362ab4$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
module.exports.chromeStackParser = [
    $eac4396568362ab4$var$CHROME_PRIORITY,
    $eac4396568362ab4$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $eac4396568362ab4$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $eac4396568362ab4$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $eac4396568362ab4$var$gecko = function(line) {
    var _a;
    var parts = $eac4396568362ab4$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $eac4396568362ab4$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $eac4396568362ab4$var$UNKNOWN_FUNCTION;
        _a = $26Yns.__read($eac4396568362ab4$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $eac4396568362ab4$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
module.exports.geckoStackParser = [
    $eac4396568362ab4$var$GECKO_PRIORITY,
    $eac4396568362ab4$var$gecko
];
var $eac4396568362ab4$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $eac4396568362ab4$var$winjs = function(line) {
    var parts = $eac4396568362ab4$var$winjsRegex.exec(line);
    return parts ? $eac4396568362ab4$var$createFrame(parts[2], parts[1] || $eac4396568362ab4$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
module.exports.winjsStackParser = [
    $eac4396568362ab4$var$WINJS_PRIORITY,
    $eac4396568362ab4$var$winjs
];
var $eac4396568362ab4$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $eac4396568362ab4$var$opera10 = function(line) {
    var parts = $eac4396568362ab4$var$opera10Regex.exec(line);
    return parts ? $eac4396568362ab4$var$createFrame(parts[2], parts[3] || $eac4396568362ab4$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
module.exports.opera10StackParser = [
    $eac4396568362ab4$var$OPERA10_PRIORITY,
    $eac4396568362ab4$var$opera10
];
var $eac4396568362ab4$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $eac4396568362ab4$var$opera11 = function(line) {
    var parts = $eac4396568362ab4$var$opera11Regex.exec(line);
    return parts ? $eac4396568362ab4$var$createFrame(parts[5], parts[3] || parts[4] || $eac4396568362ab4$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
module.exports.opera11StackParser = [
    $eac4396568362ab4$var$OPERA11_PRIORITY,
    $eac4396568362ab4$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $eac4396568362ab4$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $eac4396568362ab4$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});




parcelRegister("c88Yy", function(module, exports) {
$parcel$export(module.exports, "getApplication", () => $16f38a28884ea3f3$export$205bc258834dc08);
$parcel$export(module.exports, "bootstrap", () => $16f38a28884ea3f3$export$36aff1fbb4f5dfc6);

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $1We2B = parcelRequire("1We2B");

var $Yw2wm = parcelRequire("Yw2wm");
parcelRequire("4PbDu");
var $dPcrt = parcelRequire("dPcrt");

var $gKxW2 = parcelRequire("gKxW2");

var $bZZgp = parcelRequire("bZZgp");

var $7kgBm = parcelRequire("7kgBm");

var $fAqaB = parcelRequire("fAqaB");

var $5ZF2p = parcelRequire("5ZF2p");

var $hrPHR = parcelRequire("hrPHR");

var $9VGQW = parcelRequire("9VGQW");

var $d1xjT = parcelRequire("d1xjT");

var $lhZa3 = parcelRequire("lhZa3");
const $16f38a28884ea3f3$var$initialiseAppUtilities = (0, $1We2B.once)(()=>{
    (0, $9VGQW.initialisePlatformFeatureFlags)();
    (0, $5ZF2p.initialiseConnectAndSentryAndCleanUrl)();
    (0, $7kgBm.install)();
    (0, $fAqaB.initBrowserMetricsV3)();
});
const $16f38a28884ea3f3$export$205bc258834dc08 = ()=>{
    const atlassianHelpConfig = {
        ...(0, $hrPHR.getEnv)(),
        ...(0, $jByYr.getMetaData)()
    };
    (0, $gKxW2.ModelsCache).getInstance().initFromInitialJsonPayload();
    $16f38a28884ea3f3$var$initialiseAppUtilities();
    return /*#__PURE__*/ $8P7DW.createElement((0, $bZZgp.default), {
        name: "help-center-root"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $lhZa3.AtlassianHelp), {
        config: atlassianHelpConfig
    }));
};
const $16f38a28884ea3f3$export$36aff1fbb4f5dfc6 = ()=>{
    (0, $dPcrt.LooselyLazy).init({
        retry: 3
    });
    const rootId = 'root';
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    let container = document.getElementById(rootId);
    if (!container) {
        // If there is no root element available yet, add one.
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        container = document.createElement('span');
        container.id = rootId;
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.body.appendChild(container);
    }
    // Invalid report.
    // eslint-disable-next-line testing-library/render-result-naming-convention
    const isPageServerSideRendered = (0, $hrPHR.getIsPageServerSideRendered)();
    // Workaround for this google translate problem https://github.com/facebook/react/issues/11538#issuecomment-417504600
    // which is causing this issue https://hello.jira.atlassian.cloud/browse/PORTAL-5241, affecting view page reliability
    (0, $d1xjT.handleDOMGoogleTranslateIssues)();
    if ((0, $HGACo.isUseReact18CreateRootEnabled)()) {
        if (isPageServerSideRendered && !(0, $HGACo.isReactHydrateDisabledInSSR)()) (0, $Yw2wm.hydrateRoot)(container, $16f38a28884ea3f3$export$205bc258834dc08());
        else (0, $Yw2wm.createRoot)(container).render($16f38a28884ea3f3$export$205bc258834dc08());
    } else if (isPageServerSideRendered && !(0, $HGACo.isReactHydrateDisabledInSSR)()) (0, $6Q1OD.hydrate)($16f38a28884ea3f3$export$205bc258834dc08(), container);
    else (0, $6Q1OD.render)($16f38a28884ea3f3$export$205bc258834dc08(), container);
};

});
parcelRegister("Yw2wm", function(module, exports) {
$parcel$export(module.exports, "createRoot", () => $0b5e751ed1619e95$export$882461b6382ed46c, (v) => $0b5e751ed1619e95$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b5e751ed1619e95$export$757ceba2d55c277e, (v) => $0b5e751ed1619e95$export$757ceba2d55c277e = v);
var $0b5e751ed1619e95$export$882461b6382ed46c;
var $0b5e751ed1619e95$export$757ceba2d55c277e;
'use strict';

var $6Q1OD = parcelRequire("6Q1OD");
var $0b5e751ed1619e95$var$i;
$0b5e751ed1619e95$export$882461b6382ed46c = $6Q1OD.createRoot;
$0b5e751ed1619e95$export$757ceba2d55c277e = $6Q1OD.hydrateRoot;

});

parcelRegister("4PbDu", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("dPcrt")).LooselyLazy);
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("fGOkV")).lazyForPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("fGOkV")).lazy);
$parcel$export(module.exports, "LazyWait", () => (parcelRequire("1ZbH0")).LazyWait);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3FFzY")).LazySuspense);
parcelRequire("dB4XT");
var $jS2wf = parcelRequire("jS2wf");

var $dPcrt = parcelRequire("dPcrt");

var $fGOkV = parcelRequire("fGOkV");
parcelRequire("3db3k");
var $1ZbH0 = parcelRequire("1ZbH0");
parcelRequire("faBtV");
var $3FFzY = parcelRequire("3FFzY");

var $7CsKa = parcelRequire("7CsKa");

var $jPFHL = parcelRequire("jPFHL");

});
parcelRegister("dB4XT", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $9e629507e59bd1b4$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $9e629507e59bd1b4$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("jS2wf")).MODE);

var $jS2wf = parcelRequire("jS2wf");
const $9e629507e59bd1b4$var$DEFAULT_CROSS_ORIGIN = undefined;
const $9e629507e59bd1b4$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $9e629507e59bd1b4$var$DEFAULT_MODE = (0, $jS2wf.MODE).HYDRATE;
const $9e629507e59bd1b4$var$DEFAULT_RETRY = 2;
const $9e629507e59bd1b4$var$config = {
    crossOrigin: $9e629507e59bd1b4$var$DEFAULT_CROSS_ORIGIN,
    manifest: $9e629507e59bd1b4$var$DEFAULT_MANIFEST,
    mode: $9e629507e59bd1b4$var$DEFAULT_MODE,
    retry: $9e629507e59bd1b4$var$DEFAULT_RETRY
};
const $9e629507e59bd1b4$export$44487a86467333c3 = ()=>$9e629507e59bd1b4$var$config;
const $9e629507e59bd1b4$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $9e629507e59bd1b4$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $9e629507e59bd1b4$var$DEFAULT_CROSS_ORIGIN;
    $9e629507e59bd1b4$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $9e629507e59bd1b4$var$DEFAULT_MANIFEST;
    $9e629507e59bd1b4$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $9e629507e59bd1b4$var$DEFAULT_MODE;
    $9e629507e59bd1b4$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $9e629507e59bd1b4$var$DEFAULT_RETRY;
};

});
parcelRegister("jS2wf", function(module, exports) {
$parcel$export(module.exports, "MODE", () => $e77503b33d13c5c4$export$e48589d9e4824227);
const $e77503b33d13c5c4$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("dPcrt", function(module, exports) {
$parcel$export(module.exports, "LooselyLazy", () => $a109b086d83bc5c8$export$33c5f161e1d4706);

var $6XPVe = parcelRequire("6XPVe");

var $dB4XT = parcelRequire("dB4XT");
parcelRequire("7CsKa");
var $1ZUWQ = parcelRequire("1ZUWQ");
var $jfPfv = parcelRequire("jfPfv");

var $f2x9e = parcelRequire("f2x9e");
const $a109b086d83bc5c8$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $dB4XT.setConfig)(config);
        (0, $1ZUWQ.LISTENERS).length = 0;
        (0, $jfPfv.setCurrent)(0);
        if (!(0, $f2x9e.isNodeEnvironment)()) (0, $6XPVe.collect)();
    }
};

});
parcelRegister("6XPVe", function(module, exports) {
$parcel$export(module.exports, "collect", () => $5120876fa681afcf$export$bb44f104e3c54dae);

var $dB4XT = parcelRequire("dB4XT");
var $jS2wf = parcelRequire("jS2wf");

var $fCbcc = parcelRequire("fCbcc");

var $osCyY = parcelRequire("osCyY");

var $Xs3qq = parcelRequire("Xs3qq");
const $5120876fa681afcf$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $dB4XT.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $jS2wf.MODE).RENDER ? (0, $osCyY.cloneElements)(markers[i], lazyBegin) : (0, $Xs3qq.refElements)(markers[i], lazyBegin);
        if ((0, $fCbcc.COLLECTED).has(lazyBegin)) (0, $fCbcc.COLLECTED).get(lazyBegin).push(value);
        else (0, $fCbcc.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("fCbcc", function(module, exports) {
$parcel$export(module.exports, "PHASE", () => $b5e316dd28866dec$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $b5e316dd28866dec$export$4831ef3968ea94ef);
const $b5e316dd28866dec$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $b5e316dd28866dec$export$4831ef3968ea94ef = new Map();

});

parcelRegister("osCyY", function(module, exports) {
$parcel$export(module.exports, "cloneElements", () => $0498718991aaa55c$export$c42217d53a7ebafb);
const $0498718991aaa55c$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("Xs3qq", function(module, exports) {
$parcel$export(module.exports, "refElements", () => $0b2b45caaf47ac99$export$c69443129766a7fc);
const $0b2b45caaf47ac99$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("7CsKa", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("jfPfv")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("jfPfv")).setCurrent);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("1ZUWQ")).LISTENERS);

var $jfPfv = parcelRequire("jfPfv");

var $1ZUWQ = parcelRequire("1ZUWQ");

var $gKu8l = parcelRequire("gKu8l");

});
parcelRegister("jfPfv", function(module, exports) {
$parcel$export(module.exports, "setCurrent", () => $e0472c074b01205d$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $e0472c074b01205d$export$5a25eca35e5debcb);

var $8P7DW = parcelRequire("8P7DW");

var $fCbcc = parcelRequire("fCbcc");

var $1ZUWQ = parcelRequire("1ZUWQ");

var $gKu8l = parcelRequire("gKu8l");
let $e0472c074b01205d$var$CURRENT_PHASE = (0, $fCbcc.PHASE).PAINT;
const $e0472c074b01205d$export$5f80f094fd31fffd = (phase)=>{
    $e0472c074b01205d$var$CURRENT_PHASE = phase;
    (0, $1ZUWQ.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $e0472c074b01205d$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $8P7DW.createContext)({
    subscribe: (0, $gKu8l.createSubscribe)((0, $1ZUWQ.LISTENERS)),
    currentValue: ()=>$e0472c074b01205d$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $e0472c074b01205d$export$5f80f094fd31fffd((0, $fCbcc.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$e0472c074b01205d$export$5f80f094fd31fffd((0, $fCbcc.PHASE).PAINT)
    }
});
const $e0472c074b01205d$export$1dc361b277327f88 = ()=>{
    const v = (0, $8P7DW.useContext)($e0472c074b01205d$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("1ZUWQ", function(module, exports) {
$parcel$export(module.exports, "LISTENERS", () => $1747a9a316ac6ea4$export$81b9c458a026d68f);
const $1747a9a316ac6ea4$export$81b9c458a026d68f = [];

});

parcelRegister("gKu8l", function(module, exports) {
$parcel$export(module.exports, "createSubscribe", () => $c318511efd20a2fd$export$364097d812234b3f);
const $c318511efd20a2fd$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("f2x9e", function(module, exports) {
$parcel$export(module.exports, "getExport", () => $af30c1631d08cbb1$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $af30c1631d08cbb1$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $af30c1631d08cbb1$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $af30c1631d08cbb1$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("7FBF0")).default);

var $7FBF0 = parcelRequire("7FBF0");
const $af30c1631d08cbb1$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $af30c1631d08cbb1$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $af30c1631d08cbb1$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $af30c1631d08cbb1$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("7FBF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $5959934f853ff29f$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $5959934f853ff29f$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("fGOkV", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => $b6c1d30bacad902b$export$c952e5f94576010e);
$parcel$export(module.exports, "lazy", () => $b6c1d30bacad902b$export$488013bae63b21da);

var $g60HB = parcelRequire("g60HB");

var $dB4XT = parcelRequire("dB4XT");

var $fCbcc = parcelRequire("fCbcc");

var $f2x9e = parcelRequire("f2x9e");
var $7FBF0 = parcelRequire("7FBF0");

var $lTu9q = parcelRequire("lTu9q");

var $65NiA = parcelRequire("65NiA");

var $hV0Pi = parcelRequire("hV0Pi");

var $6I03P = parcelRequire("6I03P");

var $goIQl = parcelRequire("goIQl");

var $bGtpR = parcelRequire("bGtpR");

var $8qqoh = parcelRequire("8qqoh");
function $b6c1d30bacad902b$var$_extends() {
    $b6c1d30bacad902b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b6c1d30bacad902b$var$_extends.apply(this, arguments);
}
function $b6c1d30bacad902b$var$lazyProxy(_loader, { defer: defer = (0, $fCbcc.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $f2x9e.isNodeEnvironment)();
    const dataLazyId = (0, $7FBF0.default)(moduleId);
    const LazyInternal = isServer ? (0, $hV0Pi.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $65NiA.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $6I03P.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $dB4XT.getConfig)();
                return (0, $bGtpR.retry)(_loader, {
                    delay: (0, $lTu9q.RETRY_DELAY),
                    factor: (0, $lTu9q.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $f2x9e.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $dB4XT.getConfig)();
        return (0, $g60HB.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $fCbcc.PHASE).PAINT ? (0, $lTu9q.PRIORITY).HIGH : (0, $lTu9q.PRIORITY).LOW;
        return (0, $goIQl.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $b6c1d30bacad902b$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $fCbcc.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $fCbcc.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $fCbcc.PHASE).LAZY
    }
};
function $b6c1d30bacad902b$export$c952e5f94576010e(loader, opts) {
    return $b6c1d30bacad902b$var$lazyProxy(loader, $b6c1d30bacad902b$var$_extends({}, $b6c1d30bacad902b$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $b6c1d30bacad902b$export$291dd592399bdafa(loader, opts) {
    return $b6c1d30bacad902b$var$lazyProxy(loader, $b6c1d30bacad902b$var$_extends({}, $b6c1d30bacad902b$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $b6c1d30bacad902b$export$488013bae63b21da(loader, opts) {
    return $b6c1d30bacad902b$var$lazyProxy(loader, $b6c1d30bacad902b$var$_extends({}, $b6c1d30bacad902b$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("g60HB", function(module, exports) {
$parcel$export(module.exports, "getAssetUrlsFromId", () => $bb7dc05c48ae3258$export$303f43e55cf1ef2f);
const $bb7dc05c48ae3258$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("lTu9q", function(module, exports) {
$parcel$export(module.exports, "PRIORITY", () => $ff061f64822e1cf3$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $ff061f64822e1cf3$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $ff061f64822e1cf3$export$ba64c908e55507fe);
const $ff061f64822e1cf3$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $ff061f64822e1cf3$export$a339266ad71b2447 = 300;
const $ff061f64822e1cf3$export$ba64c908e55507fe = 1;

});

parcelRegister("65NiA", function(module, exports) {
$parcel$export(module.exports, "createComponentClient", () => $46f9736ac5d97c19$export$6898b5504b58699a);

var $8P7DW = parcelRequire("8P7DW");

var $dB4XT = parcelRequire("dB4XT");
var $jS2wf = parcelRequire("jS2wf");

var $fCbcc = parcelRequire("fCbcc");
parcelRequire("3db3k");
var $tRQr3 = parcelRequire("tRQr3");
parcelRequire("7CsKa");
var $jfPfv = parcelRequire("jfPfv");
parcelRequire("faBtV");
var $hZtXm = parcelRequire("hZtXm");

var $lTu9q = parcelRequire("lTu9q");

var $8qqoh = parcelRequire("8qqoh");

var $gXBT0 = parcelRequire("gXBT0");

var $fIctU = parcelRequire("fIctU");

var $goIQl = parcelRequire("goIQl");

var $jPFHL = parcelRequire("jPFHL");

var $kOjqc = parcelRequire("kOjqc");
function $46f9736ac5d97c19$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $8P7DW.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $8P7DW.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $fCbcc.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $fCbcc.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $8P7DW.useContext)((0, $jPFHL.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $8qqoh.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $kOjqc.useSubscription)({
            context: (0, $tRQr3.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $fCbcc.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $kOjqc.useSubscription)({
                context: (0, $jfPfv.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $8P7DW.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $goIQl.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $lTu9q.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $8P7DW.useContext)((0, $hZtXm.LazySuspenseContext));
        (0, $8P7DW.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $fCbcc.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $dB4XT.getConfig)().mode === (0, $jS2wf.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gXBT0.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fIctU.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("3db3k", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("tRQr3")).WaitContext);
$parcel$export(module.exports, "LazyWait", () => (parcelRequire("1ZbH0")).LazyWait);

var $tRQr3 = parcelRequire("tRQr3");

var $1ZbH0 = parcelRequire("1ZbH0");

});
parcelRegister("tRQr3", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $059c79fd889e91e6$export$9ba3fe09d15de47b);

var $8P7DW = parcelRequire("8P7DW");

var $fUsNJ = parcelRequire("fUsNJ");
const $059c79fd889e91e6$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $8P7DW.createContext)({
    subscribe: ()=>(0, $fUsNJ.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("fUsNJ", function(module, exports) {
$parcel$export(module.exports, "noopCleanup", () => $b9526d43e62d315d$export$276c7dbda7675aec);
const $b9526d43e62d315d$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};

});


parcelRegister("1ZbH0", function(module, exports) {
$parcel$export(module.exports, "LazyWait", () => $17248ed7e1bb9ec9$export$7bf6cf03fd32cddb);

var $8P7DW = parcelRequire("8P7DW");

var $tRQr3 = parcelRequire("tRQr3");
const $17248ed7e1bb9ec9$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $8P7DW.useContext)((0, $tRQr3.WaitContext));
    const value = (0, $8P7DW.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $8P7DW.useRef)(new Set());
    const api = (0, $8P7DW.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $8P7DW.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $tRQr3.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("faBtV", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3FFzY")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("hZtXm")).LazySuspenseContext);

var $3FFzY = parcelRequire("3FFzY");

var $hZtXm = parcelRequire("hZtXm");

});
parcelRegister("3FFzY", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $2ac574378703f488$export$256c542058532d6f);

var $8P7DW = parcelRequire("8P7DW");

var $f2x9e = parcelRequire("f2x9e");

var $hZtXm = parcelRequire("hZtXm");
class $2ac574378703f488$export$256c542058532d6f extends (0, $8P7DW.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $8P7DW.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hZtXm.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hZtXm.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $f2x9e.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("hZtXm", function(module, exports) {
$parcel$export(module.exports, "LazySuspenseContext", () => $d18f5ee079d36755$export$c33990e84065970c);

var $8P7DW = parcelRequire("8P7DW");
const $d18f5ee079d36755$export$c33990e84065970c = /*#__PURE__*/ (0, $8P7DW.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("8qqoh", function(module, exports) {
$parcel$export(module.exports, "createLoaderError", () => $6225390c4582203c$export$c73a6a6f0bf7d425);
const $6225390c4582203c$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $6225390c4582203c$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$6225390c4582203c$export$6aa69c1258005366]: true
    });
    return error;
};
const $6225390c4582203c$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($6225390c4582203c$export$6aa69c1258005366);

});

parcelRegister("gXBT0", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackRender", () => $c58f8b71d1ee30b0$export$d55db778a3e1446b);

var $8P7DW = parcelRequire("8P7DW");
function $c58f8b71d1ee30b0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $c58f8b71d1ee30b0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $8P7DW.useRef)(null);
    const { current: ssrDomNodes } = (0, $8P7DW.useRef)(content || []);
    (0, $8P7DW.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($c58f8b71d1ee30b0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $c58f8b71d1ee30b0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $c58f8b71d1ee30b0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});

parcelRegister("fIctU", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $b704a5a3a2882737$export$ca5b8fbc835d95e4);

var $8P7DW = parcelRequire("8P7DW");

var $f2x9e = parcelRequire("f2x9e");
function $b704a5a3a2882737$var$_extends() {
    $b704a5a3a2882737$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b704a5a3a2882737$var$_extends.apply(this, arguments);
}
const $b704a5a3a2882737$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $f2x9e.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $8P7DW.createElement)((0, $8P7DW.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $8P7DW.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $8P7DW.createElement)(tagName.toLowerCase(), $b704a5a3a2882737$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("goIQl", function(module, exports) {
$parcel$export(module.exports, "preloadAsset", () => $bf01ac2913f1c45e$export$25bad4aa00c45355);

var $g60HB = parcelRequire("g60HB");

var $fUsNJ = parcelRequire("fUsNJ");

var $dB4XT = parcelRequire("dB4XT");

var $f2x9e = parcelRequire("f2x9e");

var $lTu9q = parcelRequire("lTu9q");

var $dMVHP = parcelRequire("dMVHP");

var $jPFHL = parcelRequire("jPFHL");
function $bf01ac2913f1c45e$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $dB4XT.getConfig)();
    const assets = (0, $g60HB.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $dMVHP.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $bf01ac2913f1c45e$var$fakePromise = {
    then: ()=>$bf01ac2913f1c45e$var$fakePromise,
    catch: ()=>$bf01ac2913f1c45e$var$fakePromise,
    finally: ()=>$bf01ac2913f1c45e$var$fakePromise
};
function $bf01ac2913f1c45e$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $dMVHP.insertLinkTag)(href, rel));
        return $bf01ac2913f1c45e$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $bf01ac2913f1c45e$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $fUsNJ.noopCleanup;
}
function $bf01ac2913f1c45e$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $f2x9e.isNodeEnvironment)()) return 0, $fUsNJ.noopCleanup;
    (_GlobalReactLooselyLa = (0, $jPFHL.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $lTu9q.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $bf01ac2913f1c45e$export$3af04dbcb01bad4d,
        $bf01ac2913f1c45e$export$1046fd6a49d5e7a,
        $bf01ac2913f1c45e$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $fUsNJ.noopCleanup;
}

});
parcelRegister("dMVHP", function(module, exports) {
$parcel$export(module.exports, "insertLinkTag", () => $a09c854007ef57d4$export$6610512821c8a4ce);

var $jPFHL = parcelRequire("jPFHL");

var $fUsNJ = parcelRequire("fUsNJ");

var $dB4XT = parcelRequire("dB4XT");
function $a09c854007ef57d4$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $fUsNJ.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $dB4XT.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $jPFHL.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});
parcelRegister("jPFHL", function(module, exports) {
$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $e703216f800a1173$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $e703216f800a1173$export$8146ab57a3f7a7cb);

var $8P7DW = parcelRequire("8P7DW");
const $e703216f800a1173$export$e2d53c0cbedd2710 = {
    current: null
};
const $e703216f800a1173$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $8P7DW.createContext)($e703216f800a1173$export$e2d53c0cbedd2710);

});



parcelRegister("kOjqc", function(module, exports) {
$parcel$export(module.exports, "useSubscription", () => $f2678ae365bdb972$export$368b4214baeb914c);

var $8P7DW = parcelRequire("8P7DW");
function $f2678ae365bdb972$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $8P7DW.useContext)(context);
    (0, $8P7DW.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("hV0Pi", function(module, exports) {
$parcel$export(module.exports, "createComponentServer", () => $d0b866a3d79bf94c$export$eb2e4b04351cdd9e);

var $g60HB = parcelRequire("g60HB");

var $8P7DW = parcelRequire("8P7DW");

var $dB4XT = parcelRequire("dB4XT");

var $fCbcc = parcelRequire("fCbcc");
parcelRequire("faBtV");
var $hZtXm = parcelRequire("hZtXm");

var $f2x9e = parcelRequire("f2x9e");

var $8qqoh = parcelRequire("8qqoh");
function $d0b866a3d79bf94c$var$load(moduleId, loader) {
    try {
        return (0, $f2x9e.getExport)(loader());
    } catch (err) {
        throw (0, $8qqoh.createLoaderError)(err);
    }
}
function $d0b866a3d79bf94c$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $d0b866a3d79bf94c$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $8P7DW.useContext)((0, $hZtXm.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $dB4XT.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $fCbcc.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $g60HB.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("link", {
                key: url,
                rel: defer === (0, $fCbcc.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("6I03P", function(module, exports) {
$parcel$export(module.exports, "createDeferred", () => $4e26e6364385e6e3$export$e673efccd97e4223);
const $4e26e6364385e6e3$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("bGtpR", function(module, exports) {
$parcel$export(module.exports, "retry", () => $881a6f5dd884049e$export$9369b12211e1fce4);
const $881a6f5dd884049e$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $881a6f5dd884049e$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $881a6f5dd884049e$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $881a6f5dd884049e$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $881a6f5dd884049e$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $881a6f5dd884049e$var$calculateDelay(context, policy);
        if (delay) await $881a6f5dd884049e$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("gKxW2", function(module, exports) {
$parcel$export(module.exports, "ModelsCache", () => $9f281c5296196a91$export$6525a85e50433f6b);

var $1We2B = parcelRequire("1We2B");

var $fDcSZ = parcelRequire("fDcSZ");

var $jjE9o = parcelRequire("jjE9o");

var $9EsDH = parcelRequire("9EsDH");
const $9f281c5296196a91$var$TEN_MINUTE_TIMEOUT = 600;
const $9f281c5296196a91$var$createCacheOperationalPayload = (modelType, cacheEventType)=>{
    return {
        action: cacheEventType,
        actionSubject: 'model-caches',
        source: 'unknownSource',
        attributes: {
            modelType: modelType
        }
    };
};
const $9f281c5296196a91$var$fireCacheMissOperationalEvent = (modelType)=>{
    (0, $jjE9o.operationalEvent)($9f281c5296196a91$var$createCacheOperationalPayload(modelType, 'cache-missed'));
};
const $9f281c5296196a91$var$fireCacheHitOperationalEvent = (modelType)=>{
    (0, $jjE9o.operationalEvent)($9f281c5296196a91$var$createCacheOperationalPayload(modelType, 'cache-hit'));
};
class $9f281c5296196a91$export$6525a85e50433f6b {
    constructor(){
        /**
   * We will cache the user model later after splitting it into two; a static component and one for dynamic data such
   * as counts.
   */ this.toCacheModels = [
            'helpCenterBranding',
            'suggestedRequestTypes',
            'organisations',
            'portalsAndRequestTypes',
            ...this.addNewModelsToCache()
        ];
        const cacheTTL = $9f281c5296196a91$var$TEN_MINUTE_TIMEOUT;
        this.cache = new (0, (/*@__PURE__*/$parcel$interopDefault($fDcSZ)))({
            stdTTL: cacheTTL,
            checkperiod: cacheTTL * 0.5,
            useClones: false
        });
    }
    static getInstance() {
        if (!$9f281c5296196a91$export$6525a85e50433f6b.instance) $9f281c5296196a91$export$6525a85e50433f6b.instance = new $9f281c5296196a91$export$6525a85e50433f6b();
        return $9f281c5296196a91$export$6525a85e50433f6b.instance;
    }
    shouldCache(modelType) {
        return this.toCacheModels.includes(modelType);
    }
    getFromCache(request) {
        const cachedResult = this.getFromCacheInternal(request);
        if (cachedResult !== undefined) $9f281c5296196a91$var$fireCacheHitOperationalEvent(request.type);
        else $9f281c5296196a91$var$fireCacheMissOperationalEvent(request.type);
        return cachedResult;
    }
    getFromCacheInternal(request) {
        const requestCacheEntries = this.cache.get(request.type) || [];
        return requestCacheEntries.find((cacheEntry)=>(0, $1We2B.isEqual)(cacheEntry.request, request));
    }
    putToCache(request, modelsResponse) {
        const fromCache = this.getFromCacheInternal(request);
        if (fromCache === undefined) {
            const requests = this.cache.get(request.type) || [];
            requests.push({
                request: request,
                response: modelsResponse
            });
            this.cache.set(request.type, requests);
        }
    }
    del(modelType) {
        this.cache.del(modelType);
    }
    /**
   * Initialise model cache with models contained in jsonPayload div.
   * This avoids loading them again during app init.
   *
   * Note that this implementation assumes model requests during initial page loads don't contain any parameters
   * other than the modelType.
   */ initFromInitialJsonPayload() {
        const initialModelState = (0, $9EsDH.default)();
        for (const modelTypeStr of Object.keys(initialModelState)){
            const modelType = modelTypeStr;
            if ($9f281c5296196a91$export$6525a85e50433f6b.getInstance().shouldCache(modelType)) $9f281c5296196a91$export$6525a85e50433f6b.getInstance().putToCache({
                type: modelType,
                params: {}
            }, // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            {
                [modelType]: initialModelState[modelType]
            });
        }
    }
    addNewModelsToCache() {
        return [
            'portal',
            'branding',
            'portalWebFragments',
            'user'
        ];
    }
}

});
parcelRegister("fDcSZ", function(module, exports) {

/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/ (function() {
    var exports;
    exports = module.exports = (parcelRequire("8sbCk"));
    exports.version = '5.1.2';
}).call(module.exports);

});
parcelRegister("8sbCk", function(module, exports) {

var $eJ41X = parcelRequire("eJ41X");
var $01969cb25fdce6ac$require$Buffer = $eJ41X.Buffer;


/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/ (function() {
    var EventEmitter, NodeCache, clone, splice = [].splice, boundMethodCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new Error('Bound instance method accessed before binding');
    }, indexOf = [].indexOf;
    clone = (parcelRequire("74BSo"));
    EventEmitter = (parcelRequire("618PS")).EventEmitter;
    // generate superclass
    module.exports = NodeCache = (function() {
        class NodeCache extends EventEmitter {
            constructor(options = {}){
                super();
                // ## get
                // get a cached key and change the stats
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // **Example:**
                //	myCache.get "myKey", ( err, val )
                this.get = this.get.bind(this);
                // ## mget
                // get multiple cached keys at once and change the stats
                // **Parameters:**
                // * `keys` ( String|Number[] ): an array of keys
                // **Example:**
                //	myCache.mget [ "foo", "bar" ]
                this.mget = this.mget.bind(this);
                // ## set
                // set a cached key and change the stats
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // * `value` ( Any ): A element to cache. If the option `option.forceString` is `true` the module trys to translate it to a serialized JSON
                // * `[ ttl ]` ( Number | String ): ( optional ) The time to live in seconds.
                // **Example:**
                //	myCache.set "myKey", "my_String Value"
                //	myCache.set "myKey", "my_String Value", 10
                this.set = this.set.bind(this);
                // ## mset
                // set multiple keys at once
                // **Parameters:**
                // * `keyValueSet` ( Object[] ): an array of object which includes key,value and ttl
                // **Example:**
                //	myCache.mset(
                //		[
                //			{
                //				key: "myKey",
                //				val: "myValue",
                //				ttl: [ttl in seconds]
                //			}
                //		])
                this.mset = this.mset.bind(this);
                // ## del
                // remove keys
                // **Parameters:**
                // * `keys` ( String | Number | String|Number[] ): cache key to delete or a array of cache keys
                // **Return**
                // ( Number ): Number of deleted keys
                // **Example:**
                //	myCache.del( "myKey" )
                this.del = this.del.bind(this);
                // ## take
                // get the cached value and remove the key from the cache.
                // Equivalent to calling `get(key)` + `del(key)`.
                // Useful for implementing `single use` mechanism such as OTP, where once a value is read it will become obsolete.
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // **Example:**
                //	myCache.take "myKey", ( err, val )
                this.take = this.take.bind(this);
                // ## ttl
                // reset or redefine the ttl of a key. `ttl` = 0 means infinite lifetime.
                // If `ttl` is not passed the default ttl is used.
                // If `ttl` < 0 the key will be deleted.
                // **Parameters:**
                // * `key` ( String | Number ): cache key to reset the ttl value
                // * `ttl` ( Number ): ( optional -> options.stdTTL || 0 ) The time to live in seconds
                // **Return**
                // ( Boolen ): key found and ttl set
                // **Example:**
                //	myCache.ttl( "myKey" ) // will set ttl to default ttl
                //	myCache.ttl( "myKey", 1000 )
                this.ttl = this.ttl.bind(this);
                // ## getTtl
                // receive the ttl of a key.
                // **Parameters:**
                // * `key` ( String | Number ): cache key to check the ttl value
                // **Return**
                // ( Number|undefined ): The timestamp in ms when the key will expire, 0 if it will never expire or undefined if it not exists
                // **Example:**
                //	myCache.getTtl( "myKey" )
                this.getTtl = this.getTtl.bind(this);
                // ## keys
                // list all keys within this cache
                // **Return**
                // ( Array ): An array of all keys
                // **Example:**
                //     _keys = myCache.keys()
                //     # [ "foo", "bar", "fizz", "buzz", "anotherKeys" ]
                this.keys = this.keys.bind(this);
                // ## has
                // Check if a key is cached
                // **Parameters:**
                // * `key` ( String | Number ): cache key to check the ttl value
                // **Return**
                // ( Boolean ): A boolean that indicates if the key is cached
                // **Example:**
                //     _exists = myCache.has('myKey')
                //     # true
                this.has = this.has.bind(this);
                // ## getStats
                // get the stats
                // **Parameters:**
                // -
                // **Return**
                // ( Object ): Stats data
                // **Example:**
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.getStats = this.getStats.bind(this);
                // ## flushAll
                // flush the whole data and reset the stats
                // **Example:**
                //     myCache.flushAll()
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.flushAll = this.flushAll.bind(this);
                // ## flushStats
                // flush the stats and reset all counters to 0
                // **Example:**
                //     myCache.flushStats()
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.flushStats = this.flushStats.bind(this);
                // ## close
                // This will clear the interval timeout which is set on checkperiod option.
                // **Example:**
                //     myCache.close()
                this.close = this.close.bind(this);
                // ## _checkData
                // internal housekeeping method.
                // Check all the cached data and delete the invalid values
                this._checkData = this._checkData.bind(this);
                // ## _check
                // internal method the check the value. If it's not valid any more delete it
                this._check = this._check.bind(this);
                // ## _isInvalidKey
                // internal method to check if the type of a key is either `number` or `string`
                this._isInvalidKey = this._isInvalidKey.bind(this);
                // ## _wrap
                // internal method to wrap a value in an object with some metadata
                this._wrap = this._wrap.bind(this);
                // ## _getValLength
                // internal method to calculate the value length
                this._getValLength = this._getValLength.bind(this);
                // ## _error
                // internal method to handle an error message
                this._error = this._error.bind(this);
                // ## _initErrors
                // internal method to generate error message templates
                this._initErrors = this._initErrors.bind(this);
                this.options = options;
                this._initErrors();
                // container for cached data
                this.data = {};
                // module options
                this.options = Object.assign({
                    // convert all elements to string
                    forceString: false,
                    // used standard size for calculating value size
                    objectValueSize: 80,
                    promiseValueSize: 80,
                    arrayValueSize: 40,
                    // standard time to live in seconds. 0 = infinity;
                    stdTTL: 0,
                    // time in seconds to check all data and delete expired keys
                    checkperiod: 600,
                    // en/disable cloning of variables. If `true` you'll get a copy of the cached variable. If `false` you'll save and get just the reference
                    useClones: true,
                    // whether values should be deleted automatically at expiration
                    deleteOnExpire: true,
                    // enable legacy callbacks
                    enableLegacyCallbacks: false,
                    // max amount of keys that are being stored
                    maxKeys: -1
                }, this.options);
                // generate functions with callbacks (legacy)
                if (this.options.enableLegacyCallbacks) {
                    console.warn("WARNING! node-cache legacy callback support will drop in v6.x");
                    [
                        "get",
                        "mget",
                        "set",
                        "del",
                        "ttl",
                        "getTtl",
                        "keys",
                        "has"
                    ].forEach((methodKey)=>{
                        var oldMethod;
                        // reference real function
                        oldMethod = this[methodKey];
                        this[methodKey] = function(...args) {
                            var cb, err, ref, res;
                            ref = args, [...args] = ref, [cb] = splice.call(args, -1);
                            // return a callback if cb is defined and a function
                            if (typeof cb === "function") try {
                                res = oldMethod(...args);
                                cb(null, res);
                            } catch (error1) {
                                err = error1;
                                cb(err);
                            }
                            else return oldMethod(...args, cb);
                        };
                    });
                }
                // statistics container
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                // pre allocate valid keytypes array
                this.validKeyTypes = [
                    "string",
                    "number"
                ];
                // initalize checking period
                this._checkData();
                return;
            }
            get(key) {
                var _ret, err;
                boundMethodCheck(this, NodeCache);
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // get data and incremet stats
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    this.stats.hits++;
                    _ret = this._unwrap(this.data[key]);
                    // return data
                    return _ret;
                } else {
                    // if not found return undefined
                    this.stats.misses++;
                    return void 0;
                }
            }
            mget(keys) {
                var _err, err, i, key, len, oRet;
                boundMethodCheck(this, NodeCache);
                // convert a string to an array of one key
                if (!Array.isArray(keys)) {
                    _err = this._error("EKEYSTYPE");
                    throw _err;
                }
                // define return
                oRet = {};
                for(i = 0, len = keys.length; i < len; i++){
                    key = keys[i];
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                    // get data and increment stats
                    if (this.data[key] != null && this._check(key, this.data[key])) {
                        this.stats.hits++;
                        oRet[key] = this._unwrap(this.data[key]);
                    } else // if not found return a error
                    this.stats.misses++;
                }
                // return all found keys
                return oRet;
            }
            set(key, value, ttl) {
                var _err, err, existent;
                boundMethodCheck(this, NodeCache);
                // check if cache is overflowing
                if (this.options.maxKeys > -1 && this.stats.keys >= this.options.maxKeys) {
                    _err = this._error("ECACHEFULL");
                    throw _err;
                }
                // force the data to string
                this.options.forceString;
                // set default ttl if not passed
                if (ttl == null) ttl = this.options.stdTTL;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // internal helper variables
                existent = false;
                // remove existing data from stats
                if (this.data[key]) {
                    existent = true;
                    this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
                }
                // set the value
                this.data[key] = this._wrap(value, ttl);
                this.stats.vsize += this._getValLength(value);
                // only add the keys and key-size if the key is new
                if (!existent) {
                    this.stats.ksize += this._getKeyLength(key);
                    this.stats.keys++;
                }
                this.emit("set", key, value);
                // return true
                return true;
            }
            mset(keyValueSet) {
                var _err, err, i, j, key, keyValuePair, len, len1, ttl, val;
                boundMethodCheck(this, NodeCache);
                // check if cache is overflowing
                if (this.options.maxKeys > -1 && this.stats.keys + keyValueSet.length >= this.options.maxKeys) {
                    _err = this._error("ECACHEFULL");
                    throw _err;
                }
                // loop over keyValueSet to validate key and ttl
                for(i = 0, len = keyValueSet.length; i < len; i++){
                    keyValuePair = keyValueSet[i];
                    ({ key: key, val: val, ttl: ttl } = keyValuePair);
                    // check if there is ttl and it's a number
                    if (ttl && typeof ttl !== "number") {
                        _err = this._error("ETTLTYPE");
                        throw _err;
                    }
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                }
                for(j = 0, len1 = keyValueSet.length; j < len1; j++){
                    keyValuePair = keyValueSet[j];
                    ({ key: key, val: val, ttl: ttl } = keyValuePair);
                    this.set(key, val, ttl);
                }
                return true;
            }
            del(keys) {
                var delCount, err, i, key, len, oldVal;
                boundMethodCheck(this, NodeCache);
                // convert keys to an array of itself
                if (!Array.isArray(keys)) keys = [
                    keys
                ];
                delCount = 0;
                for(i = 0, len = keys.length; i < len; i++){
                    key = keys[i];
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                    // only delete if existent
                    if (this.data[key] != null) {
                        // calc the stats
                        this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
                        this.stats.ksize -= this._getKeyLength(key);
                        this.stats.keys--;
                        delCount++;
                        // delete the value
                        oldVal = this.data[key];
                        delete this.data[key];
                        // return true
                        this.emit("del", key, oldVal.v);
                    }
                }
                return delCount;
            }
            take(key) {
                var _ret;
                boundMethodCheck(this, NodeCache);
                _ret = this.get(key);
                if (_ret != null) this.del(key);
                return _ret;
            }
            ttl(key, ttl) {
                var err;
                boundMethodCheck(this, NodeCache);
                ttl || (ttl = this.options.stdTTL);
                if (!key) return false;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // check for existent data and update the ttl value
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    // if ttl < 0 delete the key. otherwise reset the value
                    if (ttl >= 0) this.data[key] = this._wrap(this.data[key].v, ttl, false);
                    else this.del(key);
                    return true;
                } else // return false if key has not been found
                return false;
            }
            getTtl(key) {
                var _ttl, err;
                boundMethodCheck(this, NodeCache);
                if (!key) return void 0;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // check for existant data and update the ttl value
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    _ttl = this.data[key].t;
                    return _ttl;
                } else // return undefined if key has not been found
                return void 0;
            }
            keys() {
                var _keys;
                boundMethodCheck(this, NodeCache);
                _keys = Object.keys(this.data);
                return _keys;
            }
            has(key) {
                var _exists;
                boundMethodCheck(this, NodeCache);
                _exists = this.data[key] != null && this._check(key, this.data[key]);
                return _exists;
            }
            getStats() {
                boundMethodCheck(this, NodeCache);
                return this.stats;
            }
            flushAll(_startPeriod = true) {
                boundMethodCheck(this, NodeCache);
                // parameter just for testing
                // set data empty
                this.data = {};
                // reset stats
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                // reset check period
                this._killCheckPeriod();
                this._checkData(_startPeriod);
                this.emit("flush");
            }
            flushStats() {
                boundMethodCheck(this, NodeCache);
                // reset stats
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                this.emit("flush_stats");
            }
            close() {
                boundMethodCheck(this, NodeCache);
                this._killCheckPeriod();
            }
            _checkData(startPeriod = true) {
                var key, ref, value;
                boundMethodCheck(this, NodeCache);
                ref = this.data;
                // run the housekeeping method
                for(key in ref){
                    value = ref[key];
                    this._check(key, value);
                }
                if (startPeriod && this.options.checkperiod > 0) {
                    this.checkTimeout = setTimeout(this._checkData, this.options.checkperiod * 1000, startPeriod);
                    if (this.checkTimeout != null && this.checkTimeout.unref != null) this.checkTimeout.unref();
                }
            }
            // ## _killCheckPeriod
            // stop the checkdata period. Only needed to abort the script in testing mode.
            _killCheckPeriod() {
                if (this.checkTimeout != null) return clearTimeout(this.checkTimeout);
            }
            _check(key, data) {
                var _retval;
                boundMethodCheck(this, NodeCache);
                _retval = true;
                // data is invalid if the ttl is too old and is not 0
                // console.log data.t < Date.now(), data.t, Date.now()
                if (data.t !== 0 && data.t < Date.now()) {
                    if (this.options.deleteOnExpire) {
                        _retval = false;
                        this.del(key);
                    }
                    this.emit("expired", key, this._unwrap(data));
                }
                return _retval;
            }
            _isInvalidKey(key) {
                var ref;
                boundMethodCheck(this, NodeCache);
                if (ref = typeof key, indexOf.call(this.validKeyTypes, ref) < 0) return this._error("EKEYTYPE", {
                    type: typeof key
                });
            }
            _wrap(value, ttl, asClone = true) {
                var livetime, now, oReturn, ttlMultiplicator;
                boundMethodCheck(this, NodeCache);
                if (!this.options.useClones) asClone = false;
                // define the time to live
                now = Date.now();
                livetime = 0;
                ttlMultiplicator = 1000;
                // use given ttl
                if (ttl === 0) livetime = 0;
                else if (ttl) livetime = now + ttl * ttlMultiplicator;
                else // use standard ttl
                if (this.options.stdTTL === 0) livetime = this.options.stdTTL;
                else livetime = now + this.options.stdTTL * ttlMultiplicator;
                // return the wrapped value
                return oReturn = {
                    t: livetime,
                    v: asClone ? clone(value) : value
                };
            }
            // ## _unwrap
            // internal method to extract get the value out of the wrapped value
            _unwrap(value, asClone = true) {
                if (!this.options.useClones) asClone = false;
                if (value.v != null) {
                    if (asClone) return clone(value.v);
                    else return value.v;
                }
                return null;
            }
            // ## _getKeyLength
            // internal method the calculate the key length
            _getKeyLength(key) {
                return key.toString().length;
            }
            _getValLength(value) {
                boundMethodCheck(this, NodeCache);
                if (typeof value === "string") // if the value is a String get the real length
                return value.length;
                else if (this.options.forceString) // force string if it's defined and not passed
                return JSON.stringify(value).length;
                else if (Array.isArray(value)) // if the data is an Array multiply each element with a defined default length
                return this.options.arrayValueSize * value.length;
                else if (typeof value === "number") return 8;
                else if (typeof (value != null ? value.then : void 0) === "function") // if the data is a Promise, use defined default
                // (can't calculate actual/resolved value size synchronously)
                return this.options.promiseValueSize;
                else if (typeof $01969cb25fdce6ac$require$Buffer !== "undefined" && $01969cb25fdce6ac$require$Buffer !== null ? $01969cb25fdce6ac$require$Buffer.isBuffer(value) : void 0) return value.length;
                else if (value != null && typeof value === "object") // if the data is an Object multiply each element with a defined default length
                return this.options.objectValueSize * Object.keys(value).length;
                else if (typeof value === "boolean") return 8;
                else // default fallback
                return 0;
            }
            _error(type, data = {}) {
                var error;
                boundMethodCheck(this, NodeCache);
                // generate the error object
                error = new Error();
                error.name = type;
                error.errorcode = type;
                error.message = this.ERRORS[type] != null ? this.ERRORS[type](data) : "-";
                error.data = data;
                // return the error object
                return error;
            }
            _initErrors() {
                var _errMsg, _errT, ref;
                boundMethodCheck(this, NodeCache);
                this.ERRORS = {};
                ref = this._ERRORS;
                for(_errT in ref){
                    _errMsg = ref[_errT];
                    this.ERRORS[_errT] = this.createErrorMessage(_errMsg);
                }
            }
            createErrorMessage(errMsg) {
                return function(args) {
                    return errMsg.replace("__key", args.type);
                };
            }
        }
        NodeCache.prototype._ERRORS = {
            "ENOTFOUND": "Key `__key` not found",
            "ECACHEFULL": "Cache max keys amount exceeded",
            "EKEYTYPE": "The key argument has to be of type `string` or `number`. Found: `__key`",
            "EKEYSTYPE": "The keys argument has to be an array.",
            "ETTLTYPE": "The ttl argument has to be a number."
        };
        return NodeCache;
    }).call(this);
}).call(module.exports);

});
parcelRegister("eJ41X", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $ab88650d4a54c52f$export$a143d493d941bafc, (v) => $ab88650d4a54c52f$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $ab88650d4a54c52f$export$e4cf37d7f6fb9e0a, (v) => $ab88650d4a54c52f$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $ab88650d4a54c52f$export$f99ded8fe4b79145, (v) => $ab88650d4a54c52f$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $ab88650d4a54c52f$export$599f31c3813fae4d, (v) => $ab88650d4a54c52f$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $ab88650d4a54c52f$export$a143d493d941bafc;
var $ab88650d4a54c52f$export$e4cf37d7f6fb9e0a;
var $ab88650d4a54c52f$export$f99ded8fe4b79145;
var $ab88650d4a54c52f$export$599f31c3813fae4d;
'use strict';

var $iIqrN = parcelRequire("iIqrN");

var $hRhKz = parcelRequire("hRhKz");
var $ab88650d4a54c52f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$ab88650d4a54c52f$export$a143d493d941bafc = $ab88650d4a54c52f$var$Buffer;
$ab88650d4a54c52f$export$e4cf37d7f6fb9e0a = $ab88650d4a54c52f$var$SlowBuffer;
$ab88650d4a54c52f$export$f99ded8fe4b79145 = 50;
var $ab88650d4a54c52f$var$K_MAX_LENGTH = 0x7fffffff;
$ab88650d4a54c52f$export$599f31c3813fae4d = $ab88650d4a54c52f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ab88650d4a54c52f$var$Buffer.TYPED_ARRAY_SUPPORT = $ab88650d4a54c52f$var$typedArraySupport();
if (!$ab88650d4a54c52f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ab88650d4a54c52f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ab88650d4a54c52f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$ab88650d4a54c52f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ab88650d4a54c52f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$ab88650d4a54c52f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ab88650d4a54c52f$var$createBuffer(length) {
    if (length > $ab88650d4a54c52f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ab88650d4a54c52f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ab88650d4a54c52f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ab88650d4a54c52f$var$allocUnsafe(arg);
    }
    return $ab88650d4a54c52f$var$from(arg, encodingOrOffset, length);
}
$ab88650d4a54c52f$var$Buffer.poolSize = 8192; // not used by this implementation
function $ab88650d4a54c52f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $ab88650d4a54c52f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ab88650d4a54c52f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($ab88650d4a54c52f$var$isInstance(value, ArrayBuffer) || value && $ab88650d4a54c52f$var$isInstance(value.buffer, ArrayBuffer)) return $ab88650d4a54c52f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($ab88650d4a54c52f$var$isInstance(value, SharedArrayBuffer) || value && $ab88650d4a54c52f$var$isInstance(value.buffer, SharedArrayBuffer))) return $ab88650d4a54c52f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ab88650d4a54c52f$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $ab88650d4a54c52f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $ab88650d4a54c52f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ab88650d4a54c52f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ab88650d4a54c52f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ab88650d4a54c52f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ab88650d4a54c52f$var$Buffer, Uint8Array);
function $ab88650d4a54c52f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ab88650d4a54c52f$var$alloc(size, fill, encoding) {
    $ab88650d4a54c52f$var$assertSize(size);
    if (size <= 0) return $ab88650d4a54c52f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $ab88650d4a54c52f$var$createBuffer(size).fill(fill, encoding) : $ab88650d4a54c52f$var$createBuffer(size).fill(fill);
    return $ab88650d4a54c52f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ab88650d4a54c52f$var$Buffer.alloc = function(size, fill, encoding) {
    return $ab88650d4a54c52f$var$alloc(size, fill, encoding);
};
function $ab88650d4a54c52f$var$allocUnsafe(size) {
    $ab88650d4a54c52f$var$assertSize(size);
    return $ab88650d4a54c52f$var$createBuffer(size < 0 ? 0 : $ab88650d4a54c52f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ab88650d4a54c52f$var$Buffer.allocUnsafe = function(size) {
    return $ab88650d4a54c52f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ab88650d4a54c52f$var$Buffer.allocUnsafeSlow = function(size) {
    return $ab88650d4a54c52f$var$allocUnsafe(size);
};
function $ab88650d4a54c52f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$ab88650d4a54c52f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $ab88650d4a54c52f$var$byteLength(string, encoding) | 0;
    var buf = $ab88650d4a54c52f$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ab88650d4a54c52f$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $ab88650d4a54c52f$var$checked(array.length) | 0;
    var buf = $ab88650d4a54c52f$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ab88650d4a54c52f$var$fromArrayView(arrayView) {
    if ($ab88650d4a54c52f$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $ab88650d4a54c52f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ab88650d4a54c52f$var$fromArrayLike(arrayView);
}
function $ab88650d4a54c52f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ab88650d4a54c52f$var$Buffer.prototype);
    return buf;
}
function $ab88650d4a54c52f$var$fromObject(obj) {
    if ($ab88650d4a54c52f$var$Buffer.isBuffer(obj)) {
        var len = $ab88650d4a54c52f$var$checked(obj.length) | 0;
        var buf = $ab88650d4a54c52f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $ab88650d4a54c52f$var$numberIsNaN(obj.length)) return $ab88650d4a54c52f$var$createBuffer(0);
        return $ab88650d4a54c52f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $ab88650d4a54c52f$var$fromArrayLike(obj.data);
}
function $ab88650d4a54c52f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ab88650d4a54c52f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ab88650d4a54c52f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $ab88650d4a54c52f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ab88650d4a54c52f$var$Buffer.alloc(+length);
}
$ab88650d4a54c52f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ab88650d4a54c52f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ab88650d4a54c52f$var$Buffer.compare = function compare(a, b) {
    if ($ab88650d4a54c52f$var$isInstance(a, Uint8Array)) a = $ab88650d4a54c52f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ab88650d4a54c52f$var$isInstance(b, Uint8Array)) b = $ab88650d4a54c52f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ab88650d4a54c52f$var$Buffer.isBuffer(a) || !$ab88650d4a54c52f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ab88650d4a54c52f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$ab88650d4a54c52f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ab88650d4a54c52f$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $ab88650d4a54c52f$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($ab88650d4a54c52f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $ab88650d4a54c52f$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ab88650d4a54c52f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ab88650d4a54c52f$var$byteLength(string, encoding) {
    if ($ab88650d4a54c52f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ab88650d4a54c52f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $ab88650d4a54c52f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $ab88650d4a54c52f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ab88650d4a54c52f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ab88650d4a54c52f$var$Buffer.byteLength = $ab88650d4a54c52f$var$byteLength;
function $ab88650d4a54c52f$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $ab88650d4a54c52f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $ab88650d4a54c52f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $ab88650d4a54c52f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $ab88650d4a54c52f$var$latin1Slice(this, start, end);
        case 'base64':
            return $ab88650d4a54c52f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ab88650d4a54c52f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ab88650d4a54c52f$var$Buffer.prototype._isBuffer = true;
function $ab88650d4a54c52f$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ab88650d4a54c52f$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$ab88650d4a54c52f$var$swap(this, i, i + 1);
    return this;
};
$ab88650d4a54c52f$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $ab88650d4a54c52f$var$swap(this, i, i + 3);
        $ab88650d4a54c52f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ab88650d4a54c52f$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $ab88650d4a54c52f$var$swap(this, i, i + 7);
        $ab88650d4a54c52f$var$swap(this, i + 1, i + 6);
        $ab88650d4a54c52f$var$swap(this, i + 2, i + 5);
        $ab88650d4a54c52f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ab88650d4a54c52f$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $ab88650d4a54c52f$var$utf8Slice(this, 0, length);
    return $ab88650d4a54c52f$var$slowToString.apply(this, arguments);
};
$ab88650d4a54c52f$var$Buffer.prototype.toLocaleString = $ab88650d4a54c52f$var$Buffer.prototype.toString;
$ab88650d4a54c52f$var$Buffer.prototype.equals = function equals(b) {
    if (!$ab88650d4a54c52f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $ab88650d4a54c52f$var$Buffer.compare(this, b) === 0;
};
$ab88650d4a54c52f$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $ab88650d4a54c52f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($ab88650d4a54c52f$var$customInspectSymbol) $ab88650d4a54c52f$var$Buffer.prototype[$ab88650d4a54c52f$var$customInspectSymbol] = $ab88650d4a54c52f$var$Buffer.prototype.inspect;
$ab88650d4a54c52f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ab88650d4a54c52f$var$isInstance(target, Uint8Array)) target = $ab88650d4a54c52f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ab88650d4a54c52f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ab88650d4a54c52f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if ($ab88650d4a54c52f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $ab88650d4a54c52f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ab88650d4a54c52f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ab88650d4a54c52f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ab88650d4a54c52f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $ab88650d4a54c52f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ab88650d4a54c52f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ab88650d4a54c52f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ab88650d4a54c52f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ab88650d4a54c52f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ab88650d4a54c52f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ab88650d4a54c52f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ab88650d4a54c52f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ab88650d4a54c52f$var$utf8Write(buf, string, offset, length) {
    return $ab88650d4a54c52f$var$blitBuffer($ab88650d4a54c52f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ab88650d4a54c52f$var$asciiWrite(buf, string, offset, length) {
    return $ab88650d4a54c52f$var$blitBuffer($ab88650d4a54c52f$var$asciiToBytes(string), buf, offset, length);
}
function $ab88650d4a54c52f$var$base64Write(buf, string, offset, length) {
    return $ab88650d4a54c52f$var$blitBuffer($ab88650d4a54c52f$var$base64ToBytes(string), buf, offset, length);
}
function $ab88650d4a54c52f$var$ucs2Write(buf, string, offset, length) {
    return $ab88650d4a54c52f$var$blitBuffer($ab88650d4a54c52f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ab88650d4a54c52f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $ab88650d4a54c52f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $ab88650d4a54c52f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $ab88650d4a54c52f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $ab88650d4a54c52f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ab88650d4a54c52f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ab88650d4a54c52f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ab88650d4a54c52f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $iIqrN.fromByteArray(buf);
    else return $iIqrN.fromByteArray(buf.slice(start, end));
}
function $ab88650d4a54c52f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ab88650d4a54c52f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $ab88650d4a54c52f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ab88650d4a54c52f$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $ab88650d4a54c52f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ab88650d4a54c52f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ab88650d4a54c52f$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ab88650d4a54c52f$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ab88650d4a54c52f$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $ab88650d4a54c52f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ab88650d4a54c52f$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ab88650d4a54c52f$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ab88650d4a54c52f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ab88650d4a54c52f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$ab88650d4a54c52f$var$Buffer.prototype.readUintLE = $ab88650d4a54c52f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ab88650d4a54c52f$var$Buffer.prototype.readUintBE = $ab88650d4a54c52f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ab88650d4a54c52f$var$Buffer.prototype.readUint8 = $ab88650d4a54c52f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ab88650d4a54c52f$var$Buffer.prototype.readUint16LE = $ab88650d4a54c52f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ab88650d4a54c52f$var$Buffer.prototype.readUint16BE = $ab88650d4a54c52f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ab88650d4a54c52f$var$Buffer.prototype.readUint32LE = $ab88650d4a54c52f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ab88650d4a54c52f$var$Buffer.prototype.readUint32BE = $ab88650d4a54c52f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ab88650d4a54c52f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ab88650d4a54c52f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ab88650d4a54c52f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ab88650d4a54c52f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ab88650d4a54c52f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ab88650d4a54c52f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ab88650d4a54c52f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ab88650d4a54c52f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 4, this.length);
    return $hRhKz.read(this, offset, true, 23, 4);
};
$ab88650d4a54c52f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 4, this.length);
    return $hRhKz.read(this, offset, false, 23, 4);
};
$ab88650d4a54c52f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 8, this.length);
    return $hRhKz.read(this, offset, true, 52, 8);
};
$ab88650d4a54c52f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkOffset(offset, 8, this.length);
    return $hRhKz.read(this, offset, false, 52, 8);
};
function $ab88650d4a54c52f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ab88650d4a54c52f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$ab88650d4a54c52f$var$Buffer.prototype.writeUintLE = $ab88650d4a54c52f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ab88650d4a54c52f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeUintBE = $ab88650d4a54c52f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ab88650d4a54c52f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeUint8 = $ab88650d4a54c52f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeUint16LE = $ab88650d4a54c52f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeUint16BE = $ab88650d4a54c52f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeUint32LE = $ab88650d4a54c52f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeUint32BE = $ab88650d4a54c52f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ab88650d4a54c52f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $ab88650d4a54c52f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ab88650d4a54c52f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ab88650d4a54c52f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $ab88650d4a54c52f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    $hRhKz.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ab88650d4a54c52f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ab88650d4a54c52f$var$writeFloat(this, value, offset, true, noAssert);
};
$ab88650d4a54c52f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ab88650d4a54c52f$var$writeFloat(this, value, offset, false, noAssert);
};
function $ab88650d4a54c52f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ab88650d4a54c52f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    $hRhKz.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ab88650d4a54c52f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ab88650d4a54c52f$var$writeDouble(this, value, offset, true, noAssert);
};
$ab88650d4a54c52f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ab88650d4a54c52f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ab88650d4a54c52f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ab88650d4a54c52f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ab88650d4a54c52f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$ab88650d4a54c52f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $ab88650d4a54c52f$var$Buffer.isBuffer(val) ? val : $ab88650d4a54c52f$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $ab88650d4a54c52f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ab88650d4a54c52f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ab88650d4a54c52f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $ab88650d4a54c52f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $ab88650d4a54c52f$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ab88650d4a54c52f$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ab88650d4a54c52f$var$base64ToBytes(str) {
    return $iIqrN.toByteArray($ab88650d4a54c52f$var$base64clean(str));
}
function $ab88650d4a54c52f$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ab88650d4a54c52f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ab88650d4a54c52f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $ab88650d4a54c52f$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("iIqrN", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $da00d9f70e395ba5$export$d622b2ad8d90c771, (v) => $da00d9f70e395ba5$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $da00d9f70e395ba5$export$6100ba28696e12de, (v) => $da00d9f70e395ba5$export$6100ba28696e12de = v);
var $da00d9f70e395ba5$export$a48f0734ac7c2329;
var $da00d9f70e395ba5$export$d622b2ad8d90c771;
var $da00d9f70e395ba5$export$6100ba28696e12de;
'use strict';
$da00d9f70e395ba5$export$a48f0734ac7c2329 = $da00d9f70e395ba5$var$byteLength;
$da00d9f70e395ba5$export$d622b2ad8d90c771 = $da00d9f70e395ba5$var$toByteArray;
$da00d9f70e395ba5$export$6100ba28696e12de = $da00d9f70e395ba5$var$fromByteArray;
var $da00d9f70e395ba5$var$lookup = [];
var $da00d9f70e395ba5$var$revLookup = [];
var $da00d9f70e395ba5$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $da00d9f70e395ba5$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $da00d9f70e395ba5$var$i = 0, $da00d9f70e395ba5$var$len = $da00d9f70e395ba5$var$code.length; $da00d9f70e395ba5$var$i < $da00d9f70e395ba5$var$len; ++$da00d9f70e395ba5$var$i){
    $da00d9f70e395ba5$var$lookup[$da00d9f70e395ba5$var$i] = $da00d9f70e395ba5$var$code[$da00d9f70e395ba5$var$i];
    $da00d9f70e395ba5$var$revLookup[$da00d9f70e395ba5$var$code.charCodeAt($da00d9f70e395ba5$var$i)] = $da00d9f70e395ba5$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$da00d9f70e395ba5$var$revLookup['-'.charCodeAt(0)] = 62;
$da00d9f70e395ba5$var$revLookup['_'.charCodeAt(0)] = 63;
function $da00d9f70e395ba5$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $da00d9f70e395ba5$var$byteLength(b64) {
    var lens = $da00d9f70e395ba5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $da00d9f70e395ba5$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $da00d9f70e395ba5$var$toByteArray(b64) {
    var tmp;
    var lens = $da00d9f70e395ba5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $da00d9f70e395ba5$var$Arr($da00d9f70e395ba5$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $da00d9f70e395ba5$var$revLookup[b64.charCodeAt(i)] << 18 | $da00d9f70e395ba5$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $da00d9f70e395ba5$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $da00d9f70e395ba5$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $da00d9f70e395ba5$var$revLookup[b64.charCodeAt(i)] << 2 | $da00d9f70e395ba5$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $da00d9f70e395ba5$var$revLookup[b64.charCodeAt(i)] << 10 | $da00d9f70e395ba5$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $da00d9f70e395ba5$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $da00d9f70e395ba5$var$tripletToBase64(num) {
    return $da00d9f70e395ba5$var$lookup[num >> 18 & 0x3F] + $da00d9f70e395ba5$var$lookup[num >> 12 & 0x3F] + $da00d9f70e395ba5$var$lookup[num >> 6 & 0x3F] + $da00d9f70e395ba5$var$lookup[num & 0x3F];
}
function $da00d9f70e395ba5$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($da00d9f70e395ba5$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $da00d9f70e395ba5$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($da00d9f70e395ba5$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($da00d9f70e395ba5$var$lookup[tmp >> 2] + $da00d9f70e395ba5$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($da00d9f70e395ba5$var$lookup[tmp >> 10] + $da00d9f70e395ba5$var$lookup[tmp >> 4 & 0x3F] + $da00d9f70e395ba5$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("hRhKz", function(module, exports) {
$parcel$export(module.exports, "read", () => $d00527b5c3fbbd45$export$aafa59e2e03f2942, (v) => $d00527b5c3fbbd45$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $d00527b5c3fbbd45$export$68d8715fc104d294, (v) => $d00527b5c3fbbd45$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $d00527b5c3fbbd45$export$aafa59e2e03f2942;
var $d00527b5c3fbbd45$export$68d8715fc104d294;
$d00527b5c3fbbd45$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$d00527b5c3fbbd45$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("74BSo", function(module, exports) {

var $eJ41X = parcelRequire("eJ41X");
var $526649984c3b166e$require$Buffer = $eJ41X.Buffer;
var $526649984c3b166e$var$clone = function() {
    'use strict';
    function _instanceof(obj, type) {
        return type != null && obj instanceof type;
    }
    var nativeMap;
    try {
        nativeMap = Map;
    } catch (_) {
        // maybe a reference error because no `Map`. Give it a dummy value that no
        // value will ever be an instanceof.
        nativeMap = function() {};
    }
    var nativeSet;
    try {
        nativeSet = Set;
    } catch (_) {
        nativeSet = function() {};
    }
    var nativePromise;
    try {
        nativePromise = Promise;
    } catch (_) {
        nativePromise = function() {};
    }
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof $526649984c3b166e$require$Buffer != 'undefined';
        if (typeof circular == 'undefined') circular = true;
        if (typeof depth == 'undefined') depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth === 0) return parent;
            var child;
            var proto;
            if (typeof parent != 'object') return parent;
            if (_instanceof(parent, nativeMap)) child = new nativeMap();
            else if (_instanceof(parent, nativeSet)) child = new nativeSet();
            else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                parent.then(function(value) {
                    resolve(_clone(value, depth - 1));
                }, function(err) {
                    reject(_clone(err, depth - 1));
                });
            });
            else if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && $526649984c3b166e$require$Buffer.isBuffer(parent)) {
                if ($526649984c3b166e$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = $526649984c3b166e$require$Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new $526649984c3b166e$require$Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (_instanceof(parent, Error)) child = Object.create(parent);
            else if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
            });
            if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
            });
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(parent);
                for(var i = 0; i < symbols.length; i++){
                    // Don't need to worry about cloning a symbol because it is a primitive,
                    // like a number or string.
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                    child[symbol] = _clone(parent[symbol], depth - 1);
                    if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                        enumerable: false
                    });
                }
            }
            if (includeNonEnumerable) {
                var allPropertyNames = Object.getOwnPropertyNames(parent);
                for(var i = 0; i < allPropertyNames.length; i++){
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                    if (descriptor && descriptor.enumerable) continue;
                    child[propertyName] = _clone(parent[propertyName], depth - 1);
                    Object.defineProperty(child, propertyName, {
                        enumerable: false
                    });
                }
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = '';
        if (re.global) flags += 'g';
        if (re.ignoreCase) flags += 'i';
        if (re.multiline) flags += 'm';
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (module.exports) module.exports = $526649984c3b166e$var$clone;

});

parcelRegister("618PS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4619b0aaf09ca41f$var$R = typeof Reflect === 'object' ? Reflect : null;
var $4619b0aaf09ca41f$var$ReflectApply = $4619b0aaf09ca41f$var$R && typeof $4619b0aaf09ca41f$var$R.apply === 'function' ? $4619b0aaf09ca41f$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4619b0aaf09ca41f$var$ReflectOwnKeys;
if ($4619b0aaf09ca41f$var$R && typeof $4619b0aaf09ca41f$var$R.ownKeys === 'function') $4619b0aaf09ca41f$var$ReflectOwnKeys = $4619b0aaf09ca41f$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4619b0aaf09ca41f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4619b0aaf09ca41f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4619b0aaf09ca41f$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4619b0aaf09ca41f$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4619b0aaf09ca41f$var$EventEmitter() {
    $4619b0aaf09ca41f$var$EventEmitter.init.call(this);
}
module.exports = $4619b0aaf09ca41f$var$EventEmitter;
module.exports.once = $4619b0aaf09ca41f$var$once;
// Backwards-compat with node 0.10.x
$4619b0aaf09ca41f$var$EventEmitter.EventEmitter = $4619b0aaf09ca41f$var$EventEmitter;
$4619b0aaf09ca41f$var$EventEmitter.prototype._events = undefined;
$4619b0aaf09ca41f$var$EventEmitter.prototype._eventsCount = 0;
$4619b0aaf09ca41f$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4619b0aaf09ca41f$var$defaultMaxListeners = 10;
function $4619b0aaf09ca41f$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($4619b0aaf09ca41f$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $4619b0aaf09ca41f$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4619b0aaf09ca41f$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4619b0aaf09ca41f$var$defaultMaxListeners = arg;
    }
});
$4619b0aaf09ca41f$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4619b0aaf09ca41f$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4619b0aaf09ca41f$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4619b0aaf09ca41f$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4619b0aaf09ca41f$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4619b0aaf09ca41f$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4619b0aaf09ca41f$var$_getMaxListeners(this);
};
$4619b0aaf09ca41f$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4619b0aaf09ca41f$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4619b0aaf09ca41f$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4619b0aaf09ca41f$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4619b0aaf09ca41f$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4619b0aaf09ca41f$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4619b0aaf09ca41f$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4619b0aaf09ca41f$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4619b0aaf09ca41f$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4619b0aaf09ca41f$var$_addListener(this, type, listener, false);
};
$4619b0aaf09ca41f$var$EventEmitter.prototype.on = $4619b0aaf09ca41f$var$EventEmitter.prototype.addListener;
$4619b0aaf09ca41f$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4619b0aaf09ca41f$var$_addListener(this, type, listener, true);
};
function $4619b0aaf09ca41f$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4619b0aaf09ca41f$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4619b0aaf09ca41f$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4619b0aaf09ca41f$var$EventEmitter.prototype.once = function once(type, listener) {
    $4619b0aaf09ca41f$var$checkListener(listener);
    this.on(type, $4619b0aaf09ca41f$var$_onceWrap(this, type, listener));
    return this;
};
$4619b0aaf09ca41f$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4619b0aaf09ca41f$var$checkListener(listener);
    this.prependListener(type, $4619b0aaf09ca41f$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4619b0aaf09ca41f$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4619b0aaf09ca41f$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4619b0aaf09ca41f$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4619b0aaf09ca41f$var$EventEmitter.prototype.off = $4619b0aaf09ca41f$var$EventEmitter.prototype.removeListener;
$4619b0aaf09ca41f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4619b0aaf09ca41f$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4619b0aaf09ca41f$var$unwrapListeners(evlistener) : $4619b0aaf09ca41f$var$arrayClone(evlistener, evlistener.length);
}
$4619b0aaf09ca41f$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4619b0aaf09ca41f$var$_listeners(this, type, true);
};
$4619b0aaf09ca41f$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4619b0aaf09ca41f$var$_listeners(this, type, false);
};
$4619b0aaf09ca41f$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4619b0aaf09ca41f$var$listenerCount.call(emitter, type);
};
$4619b0aaf09ca41f$var$EventEmitter.prototype.listenerCount = $4619b0aaf09ca41f$var$listenerCount;
function $4619b0aaf09ca41f$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4619b0aaf09ca41f$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4619b0aaf09ca41f$var$ReflectOwnKeys(this._events) : [];
};
function $4619b0aaf09ca41f$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4619b0aaf09ca41f$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4619b0aaf09ca41f$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4619b0aaf09ca41f$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4619b0aaf09ca41f$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4619b0aaf09ca41f$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4619b0aaf09ca41f$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4619b0aaf09ca41f$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4619b0aaf09ca41f$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});



parcelRegister("jjE9o", function(module, exports) {
$parcel$export(module.exports, "AnalyticsActionSubjects", () => $720d8ea9ce728bc3$export$5378e27bf4bd9964);
$parcel$export(module.exports, "AnalyticsTrackActions", () => $720d8ea9ce728bc3$export$66cb7b42e8abaf2a);
$parcel$export(module.exports, "trackIssueEvent", () => $720d8ea9ce728bc3$export$a5fa4cf2c5c28270);
$parcel$export(module.exports, "trackIssueEventNext", () => $720d8ea9ce728bc3$export$3967c914d9a6a7eb);
$parcel$export(module.exports, "trackRequestCreateNonGenericErrors", () => $720d8ea9ce728bc3$export$6d75dc6487ba0729);
$parcel$export(module.exports, "firstInteraction", () => $720d8ea9ce728bc3$export$f90e311dc845e78d);
$parcel$export(module.exports, "operationalEvent", () => $720d8ea9ce728bc3$export$396108a0e963cc78);
$parcel$export(module.exports, "ConnectRequestCreateEventType", () => $720d8ea9ce728bc3$export$814045484cc5c60c);
$parcel$export(module.exports, "sendConnectTimeoutEventForRequestCreation", () => $720d8ea9ce728bc3$export$bd82f0e8f384bdee);
$parcel$export(module.exports, "composeAnalyticsEvent", () => $720d8ea9ce728bc3$export$812115af7f978952);

var $1We2B = parcelRequire("1We2B");

var $iziiq = parcelRequire("iziiq");

var $8rTkC = parcelRequire("8rTkC");

var $lut7F = parcelRequire("lut7F");

var $4L08H = parcelRequire("4L08H");
var $720d8ea9ce728bc3$export$5378e27bf4bd9964 = /*#__PURE__*/ function(AnalyticsActionSubjects) {
    AnalyticsActionSubjects["ISSUE"] = "issue";
    AnalyticsActionSubjects["FORM"] = "form";
    AnalyticsActionSubjects["COMMENT"] = "comment";
    AnalyticsActionSubjects["REQUEST_TYPE"] = "issueType";
    AnalyticsActionSubjects["REQUEST_TYPE_GROUP"] = "requestTypeGroup";
    return AnalyticsActionSubjects;
}({});
var $720d8ea9ce728bc3$export$66cb7b42e8abaf2a = /*#__PURE__*/ function(AnalyticsTrackActions) {
    AnalyticsTrackActions["CREATED"] = "created";
    AnalyticsTrackActions["DELETED"] = "deleted";
    AnalyticsTrackActions["UPDATED"] = "updated";
    AnalyticsTrackActions["VIEWED"] = "viewed";
    AnalyticsTrackActions["FETCHED"] = "fetched";
    AnalyticsTrackActions["CREATED_FAILURE"] = "created_failure";
    AnalyticsTrackActions["DELETED_FAILURE"] = "deleted_failure";
    AnalyticsTrackActions["UPDATED_FAILURE"] = "updated_failure";
    AnalyticsTrackActions["FETCHED_FAILURE"] = "fetched_failure";
    return AnalyticsTrackActions;
}({});
var $720d8ea9ce728bc3$export$3b99c8679ca910fe = /*#__PURE__*/ function(AnalyticsUIActions) {
    AnalyticsUIActions["CLICKED"] = "clicked";
    return AnalyticsUIActions;
}({});
const $720d8ea9ce728bc3$var$defaultTrackData = {
    source: 'portalScreen'
};
const $720d8ea9ce728bc3$var$issueTrackData = {
    ...$720d8ea9ce728bc3$var$defaultTrackData,
    containerType: 'project',
    objectType: 'issue',
    actionSubject: "issue"
};
function $720d8ea9ce728bc3$var$getUserRole(user, portal) {
    if (user.getAccountId()) {
        if (portal && portal.getPortalAnnouncement().getCanAdministerProject()) return 'agent-project-admin';
        if (user.getAgentForPortal()) return 'agent';
        return 'customer';
    }
    return 'anonymous';
}
const $720d8ea9ce728bc3$var$getDefaultAttributes = (user, portal)=>({
        attributes: {
            jsdRole: $720d8ea9ce728bc3$var$getUserRole(user, portal),
            projectType: 'serviceDesk'
        }
    });
function $720d8ea9ce728bc3$export$a5fa4cf2c5c28270(data, user, portal) {
    const analyticsWebClient = (0, $4L08H.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $1We2B.defaultsDeep)($720d8ea9ce728bc3$var$getDefaultAttributes(user, portal), $720d8ea9ce728bc3$var$issueTrackData, {
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            attributes: data.attributes
        });
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendTrackEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('trackIssueEvent: failed to send analytics data', err);
        }
    }
}
function $720d8ea9ce728bc3$export$3967c914d9a6a7eb(data, user, createAnalyticsEvent, portal) {
    try {
        const trackData = {
            analyticsType: 'TRACK',
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            ...$720d8ea9ce728bc3$var$issueTrackData,
            ...$720d8ea9ce728bc3$var$getDefaultAttributes(user, portal).attributes,
            ...data.attributes
        };
        const analyticsEvent = createAnalyticsEvent(trackData);
        analyticsEvent.fire();
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('trackIssueEventNext: failed to send analytics data', err);
    }
}
function $720d8ea9ce728bc3$export$6d75dc6487ba0729(errors, createAnalyticsEvent) {
    if (!createAnalyticsEvent) return;
    try {
        // Refrain from passing error messages from fieldError and submissionError to avoid PII logging
        const { errorReasonKey: errorReasonKey, traceId: traceId, fieldErrors: fieldErrors = {}, submissionError: submissionError = {} } = errors;
        const trackData = {
            errorReasonKey: errorReasonKey,
            traceId: traceId,
            hasSubmissionErrors: Object.keys(submissionError).length > 0,
            hasFieldErrors: Object.keys(fieldErrors).length > 0,
            analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
            action: 'failed',
            actionSubject: 'requestCreateNonGenericError'
        };
        const analyticsEvent = createAnalyticsEvent(trackData);
        analyticsEvent.context.push({
            componentName: 'requestCreateNonGenericError'
        });
        analyticsEvent.fire();
    } catch (err) {
        (0, $lut7F.reportError)(err, {
            message: 'trackRequestCreateNonGenericErrors: failed to send analytics data'
        });
    }
}
let $720d8ea9ce728bc3$var$firstInteractionTracked = false;
function $720d8ea9ce728bc3$export$f90e311dc845e78d(data) {
    // In the interest of not spamming the analytics server, we try to limit this request to one per tab.
    // This does not guarantee that there is only 1 event fired per interaction as the user can start interaction on a separate tab
    if (!$720d8ea9ce728bc3$var$firstInteractionTracked) {
        $720d8ea9ce728bc3$var$firstInteractionTracked = true;
        const combinedData = {
            action: 'firstPortalMeaningfulInteraction',
            actionSubject: data.actionSubject,
            source: data.source,
            attributes: {
                isNewPortal: String(!!data.isNewPortal)
            }
        };
        $720d8ea9ce728bc3$export$62d6d0288077e3fc(combinedData);
    }
}
function $720d8ea9ce728bc3$export$62d6d0288077e3fc(data) {
    const analyticsWebClient = (0, $4L08H.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        const baseAttributes = {
            attributes: {
                projectType: 'servicedesk'
            }
        };
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $1We2B.defaultsDeep)(baseAttributes, data);
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendUIEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('uiEvent: failed to send analytics data', err);
        }
    }
}
function $720d8ea9ce728bc3$export$396108a0e963cc78(data) {
    const analyticsWebClient = (0, $4L08H.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        const baseAttributes = {
            attributes: {
                projectType: 'servicedesk'
            }
        };
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $1We2B.defaultsDeep)(baseAttributes, data);
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendOperationalEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('operationalEvent: failed to send analytics data', err);
        }
    }
}
const $720d8ea9ce728bc3$var$commentTrackData = {
    ...$720d8ea9ce728bc3$var$defaultTrackData,
    containerType: 'project',
    objectType: 'issue',
    actionSubject: "comment"
};
function $720d8ea9ce728bc3$export$ef4b02ed2d124f10(data, user, portal) {
    const analyticsWebClient = (0, $4L08H.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $1We2B.defaultsDeep)($720d8ea9ce728bc3$var$getDefaultAttributes(user, portal), $720d8ea9ce728bc3$var$commentTrackData, {
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            actionSubjectId: data.commentId,
            attributes: data.attributes
        });
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendTrackEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('trackCommentEvent: failed to send analytics data', err);
        }
    }
}
var $720d8ea9ce728bc3$export$814045484cc5c60c = /*#__PURE__*/ function(ConnectRequestCreateEventType) {
    ConnectRequestCreateEventType["VALIDATE"] = "connectValidationTimedOut";
    ConnectRequestCreateEventType["SERIALIZE"] = "connectSerializationTimedOut";
    ConnectRequestCreateEventType["LEGACY"] = "connectValidationOrSerializationTimedOut";
    return ConnectRequestCreateEventType;
}({});
function $720d8ea9ce728bc3$export$bd82f0e8f384bdee(eventType, connectKey, requestTypeId) {
    const analyticsWebClient = (0, $4L08H.getAnalyticsWebClient)();
    if (analyticsWebClient) try {
        const event = {
            actionSubject: 'connectKey.requestType',
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            actionSubjectId: `${connectKey}.${requestTypeId}`
        };
        if (eventType === "connectValidationOrSerializationTimedOut") {
            event.actionSubject = 'requestType';
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            event.actionSubjectId = `${requestTypeId}`;
        }
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsWebClient.getInstance().sendOperationalEvent({
            action: eventType,
            actionSubject: event.actionSubject,
            actionSubjectId: event.actionSubjectId,
            source: (0, $8rTkC.ScreenName).REQUEST_CREATE
        });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('sendConnectTimeoutEventForRequestCreation: failed to send analytics data', err);
    }
}
const $720d8ea9ce728bc3$export$812115af7f978952 = (createAnalyticsEvent)=>(payload)=>{
        if (createAnalyticsEvent) return createAnalyticsEvent({
            analyticsType: payload.analyticsType,
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: payload.actionSubjectId,
            ...payload.attributes
        });
        return undefined;
    };

});

parcelRegister("9EsDH", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b8c51787fb2a98b$export$2e2bcd8739ae039);
/**
 * Util to help pre-fetching of initial model data
 */ 
var $jW99n = parcelRequire("jW99n");

var $jByYr = parcelRequire("jByYr");

var $8iTFq = parcelRequire("8iTFq");

var $1EFS8 = parcelRequire("1EFS8");

var $gk18s = parcelRequire("gk18s");

var $8uMLL = parcelRequire("8uMLL");

var $d1iVz = parcelRequire("d1iVz");

var $7PBOc = parcelRequire("7PBOc");
let $9b8c51787fb2a98b$var$cachedObject;
let $9b8c51787fb2a98b$var$ssrBrandingResponse = undefined;
var $9b8c51787fb2a98b$export$2e2bcd8739ae039 = ()=>{
    const jsonPayload = (0, $jW99n.default).getElementById('jsonPayload');
    if (!$9b8c51787fb2a98b$var$cachedObject) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    $9b8c51787fb2a98b$var$cachedObject = jsonPayload && jsonPayload.textContent && JSON.parse(jsonPayload.textContent) || {};
    if ((0, $gk18s.isKoshEnabledForDefaultHelpCenter)()) {
        delete $9b8c51787fb2a98b$var$cachedObject.helpCenterBranding;
        delete $9b8c51787fb2a98b$var$cachedObject.featuredAndSortedPortals;
        delete $9b8c51787fb2a98b$var$cachedObject.loginAnnouncements;
        /**
     * If we're on the client and we have a cached response from SSR query cache, use it right away.
     */ if ((0, $1EFS8.default).checkGate('hydrate_jsm_ssr_branding') && true) {
            if ($9b8c51787fb2a98b$var$ssrBrandingResponse === undefined) {
                const ssrCache = (0, $7PBOc.QueryResponseCache);
                const reqId = (0, $8iTFq.getRequest)((0, $d1iVz.default)).params.id;
                const resp = reqId && ssrCache.get(reqId, {
                    cloudId: (0, $jByYr.getCloudId)(),
                    helpCenterAri: (0, $jByYr.getHelpCenterAri)()
                });
                if (resp !== null) // @ts-ignore
                $9b8c51787fb2a98b$var$ssrBrandingResponse = (0, $8uMLL.convertToHCBrandingResponse)(resp.data);
                else $9b8c51787fb2a98b$var$ssrBrandingResponse = null;
            }
            if ($9b8c51787fb2a98b$var$ssrBrandingResponse !== null && $9b8c51787fb2a98b$var$ssrBrandingResponse !== undefined) $9b8c51787fb2a98b$var$cachedObject.helpCenterBranding = $9b8c51787fb2a98b$var$ssrBrandingResponse;
        }
    }
    return $9b8c51787fb2a98b$var$cachedObject;
};
const $9b8c51787fb2a98b$export$246d7bb795c4c0e = ()=>{
    $9b8c51787fb2a98b$var$cachedObject = undefined;
    $9b8c51787fb2a98b$var$ssrBrandingResponse = undefined;
};

});
parcelRegister("8iTFq", function(module, exports) {
/**
 * Relay v0.0.0-main-39e79f66
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("et5Dp"));

});
parcelRegister("et5Dp", function(module, exports) {
'use strict';

var $h83vz = parcelRequire("h83vz");

var $1hOty = parcelRequire("1hOty");

var $ky5UD = parcelRequire("ky5UD");

var $cZWl0 = parcelRequire("cZWl0");

var $8m1jd = parcelRequire("8m1jd");

var $2JAYX = parcelRequire("2JAYX");

var $iG05J = parcelRequire("iG05J");

var $fhrrS = parcelRequire("fhrrS");

var $lCG2T = parcelRequire("lCG2T");

var $luiKZ = parcelRequire("luiKZ");

var $6JK2n = parcelRequire("6JK2n");

var $fqAvV = parcelRequire("fqAvV");

var $gNgqC = parcelRequire("gNgqC");

var $lnHeP = parcelRequire("lnHeP");

var $2yJ7U = parcelRequire("2yJ7U");

var $iZ3II = parcelRequire("iZ3II");

var $3vT9g = parcelRequire("3vT9g");
var $a888250c25d28de7$var$generateClientID = $3vT9g.generateClientID, $a888250c25d28de7$var$generateUniqueClientID = $3vT9g.generateUniqueClientID, $a888250c25d28de7$var$isClientID = $3vT9g.isClientID;

var $gGI9o = parcelRequire("gGI9o");

var $7VYU6 = parcelRequire("7VYU6");

var $cG3gu = parcelRequire("cG3gu");
var $a888250c25d28de7$var$isSuspenseSentinel = $cG3gu.isSuspenseSentinel, $a888250c25d28de7$var$suspenseSentinel = $cG3gu.suspenseSentinel;

var $dedH7 = parcelRequire("dedH7");

var $4GJVs = parcelRequire("4GJVs");

var $l3ub9 = parcelRequire("l3ub9");

var $j1ZVo = parcelRequire("j1ZVo");

var $1EF6z = parcelRequire("1EF6z");

var $dqEgB = parcelRequire("dqEgB");

var $8AGUk = parcelRequire("8AGUk");

var $cKnH2 = parcelRequire("cKnH2");

var $1lIVB = parcelRequire("1lIVB");

var $gjpAU = parcelRequire("gjpAU");

var $kLaEL = parcelRequire("kLaEL");

var $aJi4Y = parcelRequire("aJi4Y");

var $9xkPb = parcelRequire("9xkPb");

var $51AJZ = parcelRequire("51AJZ");

var $2dGDG = parcelRequire("2dGDG");

var $kZml9 = parcelRequire("kZml9");

var $6NDOU = parcelRequire("6NDOU");

var $5O54S = parcelRequire("5O54S");

var $ajvHf = parcelRequire("ajvHf");

var $8qEbl = parcelRequire("8qEbl");

var $diF8P = parcelRequire("diF8P");

var $ioCp5 = parcelRequire("ioCp5");

var $lgvRG = parcelRequire("lgvRG");

var $c8c0K = parcelRequire("c8c0K");

var $cM5Il = parcelRequire("cM5Il");

var $3P0TL = parcelRequire("3P0TL");

var $eepJZ = parcelRequire("eepJZ");

var $7X5FK = parcelRequire("7X5FK");

var $kD8cH = parcelRequire("kD8cH");

var $eXHjc = parcelRequire("eXHjc");

var $iqDqR = parcelRequire("iqDqR");

var $eu4CI = parcelRequire("eu4CI");

var $ljupL = parcelRequire("ljupL");

var $6bezN = parcelRequire("6bezN");

var $gKv1J = parcelRequire("gKv1J");

var $kTvRX = parcelRequire("kTvRX");

var $dvXDj = parcelRequire("dvXDj");
var $a888250c25d28de7$var$mapStr, $a888250c25d28de7$var$setStr, $a888250c25d28de7$var$promiseStr, $a888250c25d28de7$var$objStr;
module.exports = {
    Environment: $1EF6z,
    Network: $lCG2T,
    Observable: $luiKZ,
    QueryResponseCache: $6JK2n,
    RecordSource: $kLaEL,
    Record: $8AGUk,
    ReplaySubject: $gKv1J,
    Store: $1lIVB,
    areEqualSelectors: $cKnH2.areEqualSelectors,
    createFragmentSpecResolver: $gGI9o,
    createNormalizationSelector: $cKnH2.createNormalizationSelector,
    createOperationDescriptor: $dqEgB.createOperationDescriptor,
    createReaderSelector: $cKnH2.createReaderSelector,
    createRequestDescriptor: $dqEgB.createRequestDescriptor,
    getArgumentValues: $aJi4Y.getArgumentValues,
    getDataIDsFromFragment: $cKnH2.getDataIDsFromFragment,
    getDataIDsFromObject: $cKnH2.getDataIDsFromObject,
    getNode: $2yJ7U.getNode,
    getFragment: $2yJ7U.getFragment,
    getInlineDataFragment: $2yJ7U.getInlineDataFragment,
    getModuleComponentKey: $aJi4Y.getModuleComponentKey,
    getModuleOperationKey: $aJi4Y.getModuleOperationKey,
    getPaginationFragment: $2yJ7U.getPaginationFragment,
    getPluralSelector: $cKnH2.getPluralSelector,
    getRefetchableFragment: $2yJ7U.getRefetchableFragment,
    getRequest: $2yJ7U.getRequest,
    getRequestIdentifier: $c8c0K,
    getSelector: $cKnH2.getSelector,
    getSelectorsFromObject: $cKnH2.getSelectorsFromObject,
    getSingularSelector: $cKnH2.getSingularSelector,
    getStorageKey: $aJi4Y.getStorageKey,
    getVariablesFromFragment: $cKnH2.getVariablesFromFragment,
    getVariablesFromObject: $cKnH2.getVariablesFromObject,
    getVariablesFromPluralFragment: $cKnH2.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $cKnH2.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $3P0TL,
    graphql: $2yJ7U.graphql,
    isFragment: $2yJ7U.isFragment,
    isInlineDataFragment: $2yJ7U.isInlineDataFragment,
    isSuspenseSentinel: $a888250c25d28de7$var$isSuspenseSentinel,
    suspenseSentinel: $a888250c25d28de7$var$suspenseSentinel,
    isRequest: $2yJ7U.isRequest,
    readInlineData: $l3ub9,
    MutationTypes: $fhrrS.MutationTypes,
    RangeOperations: $fhrrS.RangeOperations,
    DefaultHandlerProvider: $cZWl0,
    ConnectionHandler: $h83vz,
    MutationHandlers: $ky5UD,
    VIEWER_ID: $51AJZ.VIEWER_ID,
    VIEWER_TYPE: $51AJZ.VIEWER_TYPE,
    applyOptimisticMutation: $8m1jd,
    commitLocalUpdate: $2JAYX,
    commitMutation: $iG05J,
    fetchQuery: $fqAvV,
    fetchQuery_DEPRECATED: $gNgqC,
    isRelayModernEnvironment: $dedH7,
    requestSubscription: $2dGDG,
    ConnectionInterface: $1hOty,
    PreloadableQueryRegistry: $iZ3II,
    RelayProfiler: $6bezN,
    createPayloadFor3DField: $kZml9,
    RelayConcreteNode: $eXHjc,
    RelayError: $eu4CI,
    RelayFeatureFlags: $ljupL,
    DEFAULT_HANDLE_KEY: $iqDqR.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $aJi4Y.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $aJi4Y.FRAGMENT_OWNER_KEY,
    ID_KEY: $aJi4Y.ID_KEY,
    REF_KEY: $aJi4Y.REF_KEY,
    REFS_KEY: $aJi4Y.REFS_KEY,
    ROOT_ID: $aJi4Y.ROOT_ID,
    ROOT_TYPE: $aJi4Y.ROOT_TYPE,
    TYPENAME_KEY: $aJi4Y.TYPENAME_KEY,
    deepFreeze: $6NDOU,
    generateClientID: $a888250c25d28de7$var$generateClientID,
    generateUniqueClientID: $a888250c25d28de7$var$generateUniqueClientID,
    getRelayHandleKey: $lgvRG,
    isClientID: $a888250c25d28de7$var$isClientID,
    isPromise: $eepJZ,
    isScalarAndEqual: $7X5FK,
    recycleNodesInto: $kD8cH,
    stableCopy: $kTvRX,
    getFragmentIdentifier: $5O54S,
    getRefetchMetadata: $ioCp5,
    getPaginationMetadata: $ajvHf,
    getPaginationVariables: $8qEbl,
    getPendingOperationsForFragment: $diF8P,
    getValueAtPath: $cM5Il,
    __internal: {
        ResolverFragments: $9xkPb,
        OperationTracker: $gjpAU,
        createRelayContext: $7VYU6,
        getOperationVariables: $j1ZVo.getOperationVariables,
        getLocalVariables: $j1ZVo.getLocalVariables,
        fetchQuery: $lnHeP.fetchQuery,
        fetchQueryDeduped: $lnHeP.fetchQueryDeduped,
        getPromiseForActiveRequest: $lnHeP.getPromiseForActiveRequest,
        getObservableForActiveRequest: $lnHeP.getObservableForActiveRequest,
        normalizeResponse: $4GJVs,
        withProvidedVariables: $dvXDj
    }
};

});
parcelRegister("h83vz", function(module, exports) {
'use strict';

var $3vT9g = parcelRequire("3vT9g");
var $c785e7ab1550d673$var$generateClientID = $3vT9g.generateClientID;

var $aJi4Y = parcelRequire("aJi4Y");
var $c785e7ab1550d673$var$getStableStorageKey = $aJi4Y.getStableStorageKey;

var $lgvRG = parcelRequire("lgvRG");

var $1hOty = parcelRequire("1hOty");

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
var $c785e7ab1550d673$var$CONNECTION = 'connection';
var $c785e7ab1550d673$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $c785e7ab1550d673$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $1hOty.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey);
        return;
    }
    var clientConnectionID = $c785e7ab1550d673$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $c785e7ab1550d673$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $c785e7ab1550d673$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($c785e7ab1550d673$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $c785e7ab1550d673$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $c785e7ab1550d673$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $c785e7ab1550d673$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $c785e7ab1550d673$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $c785e7ab1550d673$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $c785e7ab1550d673$var$getConnection(record, key, filters) {
    var handleKey = $lgvRG($c785e7ab1550d673$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $c785e7ab1550d673$var$getConnectionID(recordID, key, filters) {
    var handleKey = $lgvRG($c785e7ab1550d673$var$CONNECTION, key, null);
    var storageKey = $c785e7ab1550d673$var$getStableStorageKey(handleKey, filters);
    return $c785e7ab1550d673$var$generateClientID(recordID, storageKey);
}
function $c785e7ab1550d673$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $1hOty.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $c785e7ab1550d673$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $1hOty.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $c785e7ab1550d673$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $c785e7ab1550d673$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $1hOty.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $c785e7ab1550d673$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $1hOty.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $c785e7ab1550d673$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $1hOty.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($c785e7ab1550d673$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $3rEVE(false);
    var edgeID = $c785e7ab1550d673$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $c785e7ab1550d673$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $c785e7ab1550d673$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $1hOty.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $c785e7ab1550d673$var$buildConnectionEdge,
    createEdge: $c785e7ab1550d673$var$createEdge,
    deleteNode: $c785e7ab1550d673$var$deleteNode,
    getConnection: $c785e7ab1550d673$var$getConnection,
    getConnectionID: $c785e7ab1550d673$var$getConnectionID,
    insertEdgeAfter: $c785e7ab1550d673$var$insertEdgeAfter,
    insertEdgeBefore: $c785e7ab1550d673$var$insertEdgeBefore,
    update: $c785e7ab1550d673$var$update
};

});
parcelRegister("3vT9g", function(module, exports) {
'use strict';

var $ljupL = parcelRequire("ljupL");

var $9KYrX = parcelRequire("9KYrX");
var $28ef0bafdb962bbf$var$intern = $9KYrX.intern;
var $28ef0bafdb962bbf$var$PREFIX = 'client:';
function $28ef0bafdb962bbf$var$generateClientID(id, storageKey, index) {
    var internedId = $ljupL.STRING_INTERN_LEVEL <= 0 ? id : $28ef0bafdb962bbf$var$intern(id, $ljupL.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($28ef0bafdb962bbf$var$PREFIX) !== 0) key = $28ef0bafdb962bbf$var$PREFIX + key;
    return key;
}
function $28ef0bafdb962bbf$var$isClientID(id) {
    return id.indexOf($28ef0bafdb962bbf$var$PREFIX) === 0;
}
var $28ef0bafdb962bbf$var$localID = 0;
function $28ef0bafdb962bbf$var$generateUniqueClientID() {
    return "".concat($28ef0bafdb962bbf$var$PREFIX, "local:").concat($28ef0bafdb962bbf$var$localID++);
}
function $28ef0bafdb962bbf$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($28ef0bafdb962bbf$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $28ef0bafdb962bbf$var$generateClientID,
    generateClientObjectClientID: $28ef0bafdb962bbf$var$generateClientObjectClientID,
    generateUniqueClientID: $28ef0bafdb962bbf$var$generateUniqueClientID,
    isClientID: $28ef0bafdb962bbf$var$isClientID
};

});
parcelRegister("ljupL", function(module, exports) {
'use strict';
var $f842f6fe886c7374$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_LOAD_QUERY_REQUEST_DEDUPING: true,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    ENABLE_FIELD_ERROR_HANDLING: false,
    ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT: false,
    ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false
};
module.exports = $f842f6fe886c7374$var$RelayFeatureFlags;

});

parcelRegister("9KYrX", function(module, exports) {
'use strict';
var $71a74d0356add0c6$var$internTable = new Map();
var $71a74d0356add0c6$var$nextIndex = 1;
var $71a74d0356add0c6$var$digits = $71a74d0356add0c6$var$initDigitTable();
var $71a74d0356add0c6$var$INTERN_PREFIX = '\t';
var $71a74d0356add0c6$var$ESCAPE_PREFIX = '\v';
function $71a74d0356add0c6$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $71a74d0356add0c6$var$escape(str) {
    if (str[0] === $71a74d0356add0c6$var$INTERN_PREFIX && $71a74d0356add0c6$var$digits.has(str[1]) || str[0] === $71a74d0356add0c6$var$ESCAPE_PREFIX) return $71a74d0356add0c6$var$ESCAPE_PREFIX + str;
    return str;
}
function $71a74d0356add0c6$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $71a74d0356add0c6$var$escape(str);
    var internedString = $71a74d0356add0c6$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $71a74d0356add0c6$var$INTERN_PREFIX + $71a74d0356add0c6$var$nextIndex++;
    $71a74d0356add0c6$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $71a74d0356add0c6$var$intern
};

});


parcelRegister("aJi4Y", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $7cfc2181ee12cfbe$var$_interopRequireDefault = $dw9g1.default;

var $7cfc2181ee12cfbe$var$_toConsumableArray2 = $7cfc2181ee12cfbe$var$_interopRequireDefault((parcelRequire("agTSl")));

var $lgvRG = parcelRequire("lgvRG");

var $eXHjc = parcelRequire("eXHjc");

var $kTvRX = parcelRequire("kTvRX");

var $3rEVE = parcelRequire("3rEVE");
var $7cfc2181ee12cfbe$var$VARIABLE = $eXHjc.VARIABLE, $7cfc2181ee12cfbe$var$LITERAL = $eXHjc.LITERAL, $7cfc2181ee12cfbe$var$OBJECT_VALUE = $eXHjc.OBJECT_VALUE, $7cfc2181ee12cfbe$var$LIST_VALUE = $eXHjc.LIST_VALUE;
var $7cfc2181ee12cfbe$var$ERRORS_KEY = '__errors';
var $7cfc2181ee12cfbe$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $7cfc2181ee12cfbe$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
function $7cfc2181ee12cfbe$var$getArgumentValue(arg, variables) {
    if (arg.kind === $7cfc2181ee12cfbe$var$VARIABLE) return $7cfc2181ee12cfbe$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $7cfc2181ee12cfbe$var$LITERAL) return arg.value;
    else if (arg.kind === $7cfc2181ee12cfbe$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $7cfc2181ee12cfbe$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $7cfc2181ee12cfbe$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($7cfc2181ee12cfbe$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $7cfc2181ee12cfbe$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$7cfc2181ee12cfbe$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $7cfc2181ee12cfbe$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $7cfc2181ee12cfbe$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $lgvRG(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $7cfc2181ee12cfbe$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $7cfc2181ee12cfbe$var$formatStorageKey(handleName, $7cfc2181ee12cfbe$var$getArgumentValues(filterArgs, variables));
}
function $7cfc2181ee12cfbe$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $7cfc2181ee12cfbe$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $7cfc2181ee12cfbe$var$formatStorageKey(name, $7cfc2181ee12cfbe$var$getArgumentValues(args, variables)) : name;
}
function $7cfc2181ee12cfbe$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $7cfc2181ee12cfbe$var$getStableStorageKey(name, args) {
    return $7cfc2181ee12cfbe$var$formatStorageKey(name, $kTvRX(args));
}
function $7cfc2181ee12cfbe$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $7cfc2181ee12cfbe$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $3rEVE(false);
    return $kTvRX(variables[name]);
}
function $7cfc2181ee12cfbe$var$getModuleComponentKey(documentName) {
    return "".concat($7cfc2181ee12cfbe$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $7cfc2181ee12cfbe$var$getModuleOperationKey(documentName) {
    return "".concat($7cfc2181ee12cfbe$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $7cfc2181ee12cfbe$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $7cfc2181ee12cfbe$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    formatStorageKey: $7cfc2181ee12cfbe$var$formatStorageKey,
    getArgumentValue: $7cfc2181ee12cfbe$var$getArgumentValue,
    getArgumentValues: $7cfc2181ee12cfbe$var$getArgumentValues,
    getHandleStorageKey: $7cfc2181ee12cfbe$var$getHandleStorageKey,
    getStorageKey: $7cfc2181ee12cfbe$var$getStorageKey,
    getStableStorageKey: $7cfc2181ee12cfbe$var$getStableStorageKey,
    getModuleComponentKey: $7cfc2181ee12cfbe$var$getModuleComponentKey,
    getModuleOperationKey: $7cfc2181ee12cfbe$var$getModuleOperationKey
};
module.exports = $7cfc2181ee12cfbe$var$RelayStoreUtils;

});
parcelRegister("dw9g1", function(module, exports) {
function $9d7571dbb74751e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $9d7571dbb74751e1$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("agTSl", function(module, exports) {

var $2S8uj = parcelRequire("2S8uj");

var $ev9DF = parcelRequire("ev9DF");

var $7iHPQ = parcelRequire("7iHPQ");

var $2KO55 = parcelRequire("2KO55");
function $77a6bdbde9a26cf8$var$_toConsumableArray(r) {
    return $2S8uj(r) || $ev9DF(r) || $7iHPQ(r) || $2KO55();
}
module.exports = $77a6bdbde9a26cf8$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2S8uj", function(module, exports) {

var $jPoos = parcelRequire("jPoos");
function $21773569c8046b04$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $jPoos(r);
}
module.exports = $21773569c8046b04$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jPoos", function(module, exports) {
function $e6f5b3c2ac2e6707$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $e6f5b3c2ac2e6707$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ev9DF", function(module, exports) {
function $a8eb7002926ef2f5$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $a8eb7002926ef2f5$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7iHPQ", function(module, exports) {

var $jPoos = parcelRequire("jPoos");
function $550c379b8af344cf$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $jPoos(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $jPoos(r, a) : void 0;
    }
}
module.exports = $550c379b8af344cf$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2KO55", function(module, exports) {
function $2016b9b911a900de$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $2016b9b911a900de$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lgvRG", function(module, exports) {
'use strict';

var $iqDqR = parcelRequire("iqDqR");
var $f7b3cf4cf40bc6eb$var$DEFAULT_HANDLE_KEY = $iqDqR.DEFAULT_HANDLE_KEY;

var $3rEVE = parcelRequire("3rEVE");
function $f7b3cf4cf40bc6eb$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $f7b3cf4cf40bc6eb$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $3rEVE(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $f7b3cf4cf40bc6eb$var$getRelayHandleKey;

});
parcelRegister("iqDqR", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});

parcelRegister("3rEVE", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $2823a451db6d307d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $2823a451db6d307d$var$invariant;

});


parcelRegister("eXHjc", function(module, exports) {
'use strict';
var $ae482b927fff8cca$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $ae482b927fff8cca$var$RelayConcreteNode;

});

parcelRegister("kTvRX", function(module, exports) {
'use strict';
function $f361aa495a02f177$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($f361aa495a02f177$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $f361aa495a02f177$var$stableCopy(value[keys[i]]);
    return stable;
}
module.exports = $f361aa495a02f177$var$stableCopy;

});


parcelRegister("1hOty", function(module, exports) {
'use strict';
var $0efe886936beb379$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $0efe886936beb379$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $0efe886936beb379$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $0efe886936beb379$var$config = newConfig;
    },
    get: function get() {
        return $0efe886936beb379$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $0efe886936beb379$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $0efe886936beb379$var$ConnectionInterface;

});

parcelRegister("l1Dol", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $glUSl = parcelRequire("glUSl");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $f4e83f59aee29804$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $f4e83f59aee29804$var$warning = $glUSl;
module.exports = $f4e83f59aee29804$var$warning;

});
parcelRegister("glUSl", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $be7ab9cc5586939a$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $be7ab9cc5586939a$var$emptyFunction = function emptyFunction() {};
$be7ab9cc5586939a$var$emptyFunction.thatReturns = $be7ab9cc5586939a$var$makeEmptyFunction;
$be7ab9cc5586939a$var$emptyFunction.thatReturnsFalse = $be7ab9cc5586939a$var$makeEmptyFunction(false);
$be7ab9cc5586939a$var$emptyFunction.thatReturnsTrue = $be7ab9cc5586939a$var$makeEmptyFunction(true);
$be7ab9cc5586939a$var$emptyFunction.thatReturnsNull = $be7ab9cc5586939a$var$makeEmptyFunction(null);
$be7ab9cc5586939a$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$be7ab9cc5586939a$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $be7ab9cc5586939a$var$emptyFunction;

});



parcelRegister("ky5UD", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $03dc50cd5c4e7cf8$var$_interopRequireDefault = $dw9g1.default;

var $03dc50cd5c4e7cf8$var$_createForOfIteratorHelper2 = $03dc50cd5c4e7cf8$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $h83vz = parcelRequire("h83vz");

var $1hOty = parcelRequire("1hOty");

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
var $03dc50cd5c4e7cf8$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $03dc50cd5c4e7cf8$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $3rEVE(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $03dc50cd5c4e7cf8$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $h83vz.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $03dc50cd5c4e7cf8$var$AppendEdgeHandler = {
    update: $03dc50cd5c4e7cf8$var$edgeUpdater($h83vz.insertEdgeAfter)
};
var $03dc50cd5c4e7cf8$var$PrependEdgeHandler = {
    update: $03dc50cd5c4e7cf8$var$edgeUpdater($h83vz.insertEdgeBefore)
};
var $03dc50cd5c4e7cf8$var$AppendNodeHandler = {
    update: $03dc50cd5c4e7cf8$var$nodeUpdater($h83vz.insertEdgeAfter)
};
var $03dc50cd5c4e7cf8$var$PrependNodeHandler = {
    update: $03dc50cd5c4e7cf8$var$nodeUpdater($h83vz.insertEdgeBefore)
};
function $03dc50cd5c4e7cf8$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $3rEVE(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $1hOty.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $03dc50cd5c4e7cf8$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $03dc50cd5c4e7cf8$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $h83vz.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $3rEVE(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $03dc50cd5c4e7cf8$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $3rEVE(false);
        !(edgeTypeName != null) && $3rEVE(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $1hOty.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $03dc50cd5c4e7cf8$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $03dc50cd5c4e7cf8$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $h83vz.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $3rEVE(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $03dc50cd5c4e7cf8$var$AppendEdgeHandler,
    DeleteRecordHandler: $03dc50cd5c4e7cf8$var$DeleteRecordHandler,
    PrependEdgeHandler: $03dc50cd5c4e7cf8$var$PrependEdgeHandler,
    AppendNodeHandler: $03dc50cd5c4e7cf8$var$AppendNodeHandler,
    PrependNodeHandler: $03dc50cd5c4e7cf8$var$PrependNodeHandler,
    DeleteEdgeHandler: $03dc50cd5c4e7cf8$var$DeleteEdgeHandler
};

});
parcelRegister("9GBUH", function(module, exports) {

var $7iHPQ = parcelRequire("7iHPQ");
function $70d5722078fe40d3$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7iHPQ(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $70d5722078fe40d3$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cZWl0", function(module, exports) {
'use strict';

var $h83vz = parcelRequire("h83vz");

var $ky5UD = parcelRequire("ky5UD");

var $3rEVE = parcelRequire("3rEVE");
function $97686f3815499874$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $h83vz;
        case 'deleteRecord':
            return $ky5UD.DeleteRecordHandler;
        case 'deleteEdge':
            return $ky5UD.DeleteEdgeHandler;
        case 'appendEdge':
            return $ky5UD.AppendEdgeHandler;
        case 'prependEdge':
            return $ky5UD.PrependEdgeHandler;
        case 'appendNode':
            return $ky5UD.AppendNodeHandler;
        case 'prependNode':
            return $ky5UD.PrependNodeHandler;
    }
    $3rEVE(false);
}
module.exports = $97686f3815499874$var$RelayDefaultHandlerProvider;

});

parcelRegister("8m1jd", function(module, exports) {
'use strict';

var $2yJ7U = parcelRequire("2yJ7U");
var $615164c03a8b3412$var$getRequest = $2yJ7U.getRequest;

var $dedH7 = parcelRequire("dedH7");

var $dqEgB = parcelRequire("dqEgB");
var $615164c03a8b3412$var$createOperationDescriptor = $dqEgB.createOperationDescriptor;

var $fhrrS = parcelRequire("fhrrS");

var $3rEVE = parcelRequire("3rEVE");
function $615164c03a8b3412$var$applyOptimisticMutation(environment, config) {
    !$dedH7(environment) && $3rEVE(false);
    var mutation = $615164c03a8b3412$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $615164c03a8b3412$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $fhrrS.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $615164c03a8b3412$var$applyOptimisticMutation;

});
parcelRegister("2yJ7U", function(module, exports) {
'use strict';

var $eXHjc = parcelRequire("eXHjc");

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
function $1dd1c2f1cea7f6db$var$graphql(strings) {
    $3rEVE(false);
}
function $1dd1c2f1cea7f6db$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $1dd1c2f1cea7f6db$var$isFragment(node) {
    var fragment = $1dd1c2f1cea7f6db$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $eXHjc.FRAGMENT;
}
function $1dd1c2f1cea7f6db$var$isRequest(node) {
    var request = $1dd1c2f1cea7f6db$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $eXHjc.REQUEST;
}
function $1dd1c2f1cea7f6db$var$isUpdatableQuery(node) {
    var updatableQuery = $1dd1c2f1cea7f6db$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $eXHjc.UPDATABLE_QUERY;
}
function $1dd1c2f1cea7f6db$var$isInlineDataFragment(node) {
    var fragment = $1dd1c2f1cea7f6db$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $eXHjc.INLINE_DATA_FRAGMENT;
}
function $1dd1c2f1cea7f6db$var$getFragment(taggedNode) {
    var fragment = $1dd1c2f1cea7f6db$var$getNode(taggedNode);
    !$1dd1c2f1cea7f6db$var$isFragment(fragment) && $3rEVE(false);
    return fragment;
}
function $1dd1c2f1cea7f6db$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $1dd1c2f1cea7f6db$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $1dd1c2f1cea7f6db$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $1dd1c2f1cea7f6db$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $1dd1c2f1cea7f6db$var$getRequest(taggedNode) {
    var request = $1dd1c2f1cea7f6db$var$getNode(taggedNode);
    !$1dd1c2f1cea7f6db$var$isRequest(request) && $3rEVE(false);
    return request;
}
function $1dd1c2f1cea7f6db$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $1dd1c2f1cea7f6db$var$getNode(taggedNode);
    !$1dd1c2f1cea7f6db$var$isUpdatableQuery(updatableQuery) && $3rEVE(false);
    return updatableQuery;
}
function $1dd1c2f1cea7f6db$var$getInlineDataFragment(taggedNode) {
    var fragment = $1dd1c2f1cea7f6db$var$getNode(taggedNode);
    !$1dd1c2f1cea7f6db$var$isInlineDataFragment(fragment) && $3rEVE(false);
    return fragment;
}
module.exports = {
    getFragment: $1dd1c2f1cea7f6db$var$getFragment,
    getNode: $1dd1c2f1cea7f6db$var$getNode,
    getPaginationFragment: $1dd1c2f1cea7f6db$var$getPaginationFragment,
    getRefetchableFragment: $1dd1c2f1cea7f6db$var$getRefetchableFragment,
    getRequest: $1dd1c2f1cea7f6db$var$getRequest,
    getUpdatableQuery: $1dd1c2f1cea7f6db$var$getUpdatableQuery,
    getInlineDataFragment: $1dd1c2f1cea7f6db$var$getInlineDataFragment,
    graphql: $1dd1c2f1cea7f6db$var$graphql,
    isFragment: $1dd1c2f1cea7f6db$var$isFragment,
    isRequest: $1dd1c2f1cea7f6db$var$isRequest,
    isUpdatableQuery: $1dd1c2f1cea7f6db$var$isUpdatableQuery,
    isInlineDataFragment: $1dd1c2f1cea7f6db$var$isInlineDataFragment
};

});

parcelRegister("dedH7", function(module, exports) {
'use strict';
function $9a17349a99fa1737$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $9a17349a99fa1737$var$isRelayModernEnvironment;

});

parcelRegister("dqEgB", function(module, exports) {
'use strict';
parcelRequire("6NDOU");

var $c8c0K = parcelRequire("c8c0K");

var $j1ZVo = parcelRequire("j1ZVo");
var $9c6cf03d8a089646$var$getOperationVariables = $j1ZVo.getOperationVariables;

var $cKnH2 = parcelRequire("cKnH2");
var $9c6cf03d8a089646$var$createNormalizationSelector = $cKnH2.createNormalizationSelector, $9c6cf03d8a089646$var$createReaderSelector = $cKnH2.createReaderSelector;

var $aJi4Y = parcelRequire("aJi4Y");
var $9c6cf03d8a089646$var$ROOT_ID = $aJi4Y.ROOT_ID;
function $9c6cf03d8a089646$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $9c6cf03d8a089646$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $9c6cf03d8a089646$var$getOperationVariables(operation, request.params.providedVariables, variables);
    var requestDescriptor = $9c6cf03d8a089646$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $9c6cf03d8a089646$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $9c6cf03d8a089646$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $9c6cf03d8a089646$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $c8c0K(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $9c6cf03d8a089646$var$createOperationDescriptor,
    createRequestDescriptor: $9c6cf03d8a089646$var$createRequestDescriptor
};

});
parcelRegister("6NDOU", function(module, exports) {
'use strict';
function $4f36351fadaae9b6$var$deepFreeze(object) {
    if (!$4f36351fadaae9b6$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $4f36351fadaae9b6$var$deepFreeze(property);
    });
    return object;
}
function $4f36351fadaae9b6$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $4f36351fadaae9b6$var$deepFreeze;

});

parcelRegister("c8c0K", function(module, exports) {
'use strict';

var $kTvRX = parcelRequire("kTvRX");

var $3rEVE = parcelRequire("3rEVE");
function $8d4f8c8e09b38c80$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $3rEVE(false);
    return requestID + JSON.stringify($kTvRX(variables));
}
module.exports = $8d4f8c8e09b38c80$var$getRequestIdentifier;

});

parcelRegister("j1ZVo", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $ddae2542ea4e5d55$var$_interopRequireDefault = $dw9g1.default;

var $ddae2542ea4e5d55$var$_objectSpread2 = $ddae2542ea4e5d55$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $aJi4Y = parcelRequire("aJi4Y");
var $ddae2542ea4e5d55$var$getArgumentValues = $aJi4Y.getArgumentValues;

var $3rEVE = parcelRequire("3rEVE");
function $ddae2542ea4e5d55$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $ddae2542ea4e5d55$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $3rEVE(false);
        }
    });
    return variables || argumentVariables;
}
function $ddae2542ea4e5d55$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $ddae2542ea4e5d55$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $ddae2542ea4e5d55$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $ddae2542ea4e5d55$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $ddae2542ea4e5d55$var$getLocalVariables,
    getFragmentVariables: $ddae2542ea4e5d55$var$getFragmentVariables,
    getOperationVariables: $ddae2542ea4e5d55$var$getOperationVariables
};

});
parcelRegister("RoT9E", function(module, exports) {

var $cO17m = parcelRequire("cO17m");
function $0a0841b53724effe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a0841b53724effe$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a0841b53724effe$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cO17m(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a0841b53724effe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $0a0841b53724effe$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cO17m", function(module, exports) {

var $MYMsF = parcelRequire("MYMsF");
function $952b0580eac0c0d2$var$_defineProperty(e, r, t) {
    return (r = $MYMsF(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $952b0580eac0c0d2$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("MYMsF", function(module, exports) {

var $1ychu = parcelRequire("1ychu");
var $0933a193f148024a$var$_typeof = $1ychu.default;

var $2kj2v = parcelRequire("2kj2v");
function $0933a193f148024a$var$toPropertyKey(t) {
    var i = $2kj2v(t, "string");
    return "symbol" == $0933a193f148024a$var$_typeof(i) ? i : i + "";
}
module.exports = $0933a193f148024a$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1ychu", function(module, exports) {
function $12127e2d6563e178$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $12127e2d6563e178$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $12127e2d6563e178$var$_typeof(o);
}
module.exports = $12127e2d6563e178$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2kj2v", function(module, exports) {

var $1ychu = parcelRequire("1ychu");
var $1b1c37dcec321feb$var$_typeof = $1ychu.default;
function $1b1c37dcec321feb$var$toPrimitive(t, r) {
    if ("object" != $1b1c37dcec321feb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1b1c37dcec321feb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $1b1c37dcec321feb$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("cKnH2", function(module, exports) {
'use strict';

var $j1ZVo = parcelRequire("j1ZVo");
var $947c28e75088835b$var$getFragmentVariables = $j1ZVo.getFragmentVariables;

var $aJi4Y = parcelRequire("aJi4Y");
var $947c28e75088835b$var$CLIENT_EDGE_TRAVERSAL_PATH = $aJi4Y.CLIENT_EDGE_TRAVERSAL_PATH, $947c28e75088835b$var$FRAGMENT_OWNER_KEY = $aJi4Y.FRAGMENT_OWNER_KEY, $947c28e75088835b$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $aJi4Y.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $947c28e75088835b$var$FRAGMENTS_KEY = $aJi4Y.FRAGMENTS_KEY, $947c28e75088835b$var$ID_KEY = $aJi4Y.ID_KEY;

var $kgHsa = parcelRequire("kgHsa");

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
function $947c28e75088835b$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $3rEVE(false);
    var dataID = item[$947c28e75088835b$var$ID_KEY];
    var fragments = item[$947c28e75088835b$var$FRAGMENTS_KEY];
    var mixedOwner = item[$947c28e75088835b$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$947c28e75088835b$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $947c28e75088835b$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$947c28e75088835b$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $947c28e75088835b$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $947c28e75088835b$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $947c28e75088835b$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $947c28e75088835b$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $3rEVE(false);
        return $947c28e75088835b$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $3rEVE(false);
        return $947c28e75088835b$var$getSingularSelector(fragment, item);
    }
}
function $947c28e75088835b$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $947c28e75088835b$var$getSelector(fragment, item);
    }
    return selectors;
}
function $947c28e75088835b$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $947c28e75088835b$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $947c28e75088835b$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $3rEVE(false);
        return $947c28e75088835b$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $3rEVE(false);
        return $947c28e75088835b$var$getDataID(fragment, item);
    }
}
function $947c28e75088835b$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $947c28e75088835b$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $947c28e75088835b$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $3rEVE(false);
    var dataID = item[$947c28e75088835b$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $947c28e75088835b$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $947c28e75088835b$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $947c28e75088835b$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $3rEVE(false);
        return $947c28e75088835b$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $3rEVE(false);
        return $947c28e75088835b$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $947c28e75088835b$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $947c28e75088835b$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $947c28e75088835b$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $947c28e75088835b$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $947c28e75088835b$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $kgHsa(thisSelector.variables, thatSelector.variables) && $947c28e75088835b$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $947c28e75088835b$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $947c28e75088835b$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $kgHsa(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $947c28e75088835b$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $947c28e75088835b$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $947c28e75088835b$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $947c28e75088835b$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $947c28e75088835b$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $947c28e75088835b$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $947c28e75088835b$var$areEqualSelectors,
    createReaderSelector: $947c28e75088835b$var$createReaderSelector,
    createNormalizationSelector: $947c28e75088835b$var$createNormalizationSelector,
    getDataIDsFromFragment: $947c28e75088835b$var$getDataIDsFromFragment,
    getDataIDsFromObject: $947c28e75088835b$var$getDataIDsFromObject,
    getSingularSelector: $947c28e75088835b$var$getSingularSelector,
    getPluralSelector: $947c28e75088835b$var$getPluralSelector,
    getSelector: $947c28e75088835b$var$getSelector,
    getSelectorsFromObject: $947c28e75088835b$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $947c28e75088835b$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $947c28e75088835b$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $947c28e75088835b$var$getVariablesFromFragment,
    getVariablesFromObject: $947c28e75088835b$var$getVariablesFromObject
};

});
parcelRegister("kgHsa", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $ec1702326f44756c$var$aStackPool = [];
var $ec1702326f44756c$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $ec1702326f44756c$var$areEqual(a, b) {
    var aStack = $ec1702326f44756c$var$aStackPool.length ? $ec1702326f44756c$var$aStackPool.pop() : [];
    var bStack = $ec1702326f44756c$var$bStackPool.length ? $ec1702326f44756c$var$bStackPool.pop() : [];
    var result = $ec1702326f44756c$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $ec1702326f44756c$var$aStackPool.push(aStack);
    $ec1702326f44756c$var$bStackPool.push(bStack);
    return result;
}
function $ec1702326f44756c$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$ec1702326f44756c$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$ec1702326f44756c$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $ec1702326f44756c$var$areEqual;

});



parcelRegister("fhrrS", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $b1fdbc485e15480f$var$_interopRequireDefault = $dw9g1.default;

var $b1fdbc485e15480f$var$_createForOfIteratorHelper2 = $b1fdbc485e15480f$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $h83vz = parcelRequire("h83vz");
parcelRequire("l1Dol");
var $b1fdbc485e15480f$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $b1fdbc485e15480f$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $b1fdbc485e15480f$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $b1fdbc485e15480f$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $b1fdbc485e15480f$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $b1fdbc485e15480f$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $b1fdbc485e15480f$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $b1fdbc485e15480f$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $b1fdbc485e15480f$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $b1fdbc485e15480f$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $b1fdbc485e15480f$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $h83vz.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $h83vz.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $h83vz.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $h83vz.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $b1fdbc485e15480f$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $b1fdbc485e15480f$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $b1fdbc485e15480f$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $b1fdbc485e15480f$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $b1fdbc485e15480f$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $b1fdbc485e15480f$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $h83vz.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $h83vz.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $b1fdbc485e15480f$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $b1fdbc485e15480f$var$MutationTypes,
    RangeOperations: $b1fdbc485e15480f$var$RangeOperations,
    convert: $b1fdbc485e15480f$var$convert
};

});


parcelRegister("2JAYX", function(module, exports) {
'use strict';
function $1fdc789c8748f571$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $1fdc789c8748f571$var$commitLocalUpdate;

});

parcelRegister("iG05J", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $d98c3867654403e4$var$_interopRequireDefault = $dw9g1.default;

var $d98c3867654403e4$var$_toConsumableArray2 = $d98c3867654403e4$var$_interopRequireDefault((parcelRequire("agTSl")));

var $2yJ7U = parcelRequire("2yJ7U");
var $d98c3867654403e4$var$getRequest = $2yJ7U.getRequest;

var $3vT9g = parcelRequire("3vT9g");
var $d98c3867654403e4$var$generateUniqueClientID = $3vT9g.generateUniqueClientID;

var $dedH7 = parcelRequire("dedH7");

var $dqEgB = parcelRequire("dqEgB");
var $d98c3867654403e4$var$createOperationDescriptor = $dqEgB.createOperationDescriptor;

var $fhrrS = parcelRequire("fhrrS");
parcelRequire("kufOw");

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
function $d98c3867654403e4$var$commitMutation(environment, config) {
    !$dedH7(environment) && $3rEVE(false);
    var mutation = $d98c3867654403e4$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $d98c3867654403e4$var$createOperationDescriptor(mutation, variables, cacheConfig, $d98c3867654403e4$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $fhrrS.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $d98c3867654403e4$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $d98c3867654403e4$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $d98c3867654403e4$var$commitMutation;

});
parcelRegister("kufOw", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $eea2e04dec2d11b2$var$_interopRequireDefault = $dw9g1.default;

var $eea2e04dec2d11b2$var$_objectSpread2 = $eea2e04dec2d11b2$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $eXHjc = parcelRequire("eXHjc");
var $eea2e04dec2d11b2$var$ACTOR_CHANGE = $eXHjc.ACTOR_CHANGE, $eea2e04dec2d11b2$var$CLIENT_COMPONENT = $eXHjc.CLIENT_COMPONENT, $eea2e04dec2d11b2$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $eXHjc.CLIENT_EDGE_TO_CLIENT_OBJECT, $eea2e04dec2d11b2$var$CLIENT_EXTENSION = $eXHjc.CLIENT_EXTENSION, $eea2e04dec2d11b2$var$CONDITION = $eXHjc.CONDITION, $eea2e04dec2d11b2$var$DEFER = $eXHjc.DEFER, $eea2e04dec2d11b2$var$FRAGMENT_SPREAD = $eXHjc.FRAGMENT_SPREAD, $eea2e04dec2d11b2$var$INLINE_FRAGMENT = $eXHjc.INLINE_FRAGMENT, $eea2e04dec2d11b2$var$LINKED_FIELD = $eXHjc.LINKED_FIELD, $eea2e04dec2d11b2$var$LINKED_HANDLE = $eXHjc.LINKED_HANDLE, $eea2e04dec2d11b2$var$MODULE_IMPORT = $eXHjc.MODULE_IMPORT, $eea2e04dec2d11b2$var$RELAY_LIVE_RESOLVER = $eXHjc.RELAY_LIVE_RESOLVER, $eea2e04dec2d11b2$var$RELAY_RESOLVER = $eXHjc.RELAY_RESOLVER, $eea2e04dec2d11b2$var$SCALAR_FIELD = $eXHjc.SCALAR_FIELD, $eea2e04dec2d11b2$var$SCALAR_HANDLE = $eXHjc.SCALAR_HANDLE, $eea2e04dec2d11b2$var$STREAM = $eXHjc.STREAM, $eea2e04dec2d11b2$var$TYPE_DISCRIMINATOR = $eXHjc.TYPE_DISCRIMINATOR;
parcelRequire("l1Dol");
var $eea2e04dec2d11b2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $eea2e04dec2d11b2$var$validateMutation = function validateMutation() {};
var $eea2e04dec2d11b2$var$addFieldToDiff, $eea2e04dec2d11b2$var$validateSelections, $eea2e04dec2d11b2$var$validateSelection, $eea2e04dec2d11b2$var$validateModuleImport, $eea2e04dec2d11b2$var$validateAbstractKey, $eea2e04dec2d11b2$var$validateField, $eea2e04dec2d11b2$var$validateOptimisticResponse;
module.exports = $eea2e04dec2d11b2$var$validateMutation;

});


parcelRegister("lCG2T", function(module, exports) {
'use strict';

var $dvXDj = parcelRequire("dvXDj");

var $5otom = parcelRequire("5otom");
var $fbddc2fb70bda04d$var$convertFetch = $5otom.convertFetch;

var $3rEVE = parcelRequire("3rEVE");
function $fbddc2fb70bda04d$var$create(fetchFn, subscribe) {
    var observeFetch = $fbddc2fb70bda04d$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $dvXDj(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $3rEVE(false);
            !!uploadables && $3rEVE(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $3rEVE(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $fbddc2fb70bda04d$var$create
};

});
parcelRegister("dvXDj", function(module, exports) {
'use strict';
parcelRequire("kgHsa");
parcelRequire("l1Dol");
var $9d6c6d7ddfc1f141$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $9d6c6d7ddfc1f141$var$debugCache = $9d6c6d7ddfc1f141$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $9d6c6d7ddfc1f141$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$9d6c6d7ddfc1f141$var$debugCache.has(providerFunction)) {
                $9d6c6d7ddfc1f141$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $9d6c6d7ddfc1f141$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$9d6c6d7ddfc1f141$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $9d6c6d7ddfc1f141$var$withProvidedVariables;

});

parcelRegister("5otom", function(module, exports) {
'use strict';

var $luiKZ = parcelRequire("luiKZ");
function $3ed5fe3d1338d9ea$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $luiKZ.create(function(sink) {
            return sink.error(result);
        });
        return $luiKZ.from(result);
    };
}
module.exports = {
    convertFetch: $3ed5fe3d1338d9ea$var$convertFetch
};

});
parcelRegister("luiKZ", function(module, exports) {
'use strict';

var $eepJZ = parcelRequire("eepJZ");
var $fa4af311b178990a$var$hostReportError = $fa4af311b178990a$var$swallowError;
var $fa4af311b178990a$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $fa4af311b178990a$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $fa4af311b178990a$var$isObservable(obj) ? $fa4af311b178990a$var$fromObservable(obj) : $eepJZ(obj) ? $fa4af311b178990a$var$fromPromise(obj) : $fa4af311b178990a$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $fa4af311b178990a$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $fa4af311b178990a$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $fa4af311b178990a$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $fa4af311b178990a$var$fromObservable(obj) {
    return obj instanceof $fa4af311b178990a$var$RelayObservable ? obj : $fa4af311b178990a$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $fa4af311b178990a$var$fromPromise(promise) {
    return $fa4af311b178990a$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $fa4af311b178990a$var$fromValue(value) {
    return $fa4af311b178990a$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $fa4af311b178990a$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $fa4af311b178990a$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $fa4af311b178990a$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $fa4af311b178990a$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $fa4af311b178990a$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $fa4af311b178990a$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $fa4af311b178990a$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $fa4af311b178990a$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $fa4af311b178990a$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $fa4af311b178990a$var$RelayObservable;

});
parcelRegister("eepJZ", function(module, exports) {
'use strict';
function $a5c6570d82cbc3d1$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $a5c6570d82cbc3d1$var$isPromise;

});




parcelRegister("6JK2n", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $4e7aa81702506fc3$var$_interopRequireDefault = $dw9g1.default;

var $4e7aa81702506fc3$var$_objectSpread2 = $4e7aa81702506fc3$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $kTvRX = parcelRequire("kTvRX");

var $3rEVE = parcelRequire("3rEVE");
var $4e7aa81702506fc3$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $3rEVE(false);
        !(ttl > 0) && $3rEVE(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $4e7aa81702506fc3$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$4e7aa81702506fc3$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $4e7aa81702506fc3$var$_objectSpread2["default"])((0, $4e7aa81702506fc3$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $4e7aa81702506fc3$var$_objectSpread2["default"])((0, $4e7aa81702506fc3$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $4e7aa81702506fc3$var$_objectSpread2["default"])((0, $4e7aa81702506fc3$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $4e7aa81702506fc3$var$_objectSpread2["default"])((0, $4e7aa81702506fc3$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $4e7aa81702506fc3$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $4e7aa81702506fc3$var$getCacheKey(queryID, variables) {
    return JSON.stringify($kTvRX({
        queryID: queryID,
        variables: variables
    }));
}
function $4e7aa81702506fc3$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $4e7aa81702506fc3$var$RelayQueryResponseCache;

});

parcelRegister("fqAvV", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $b3b59ba0c47fcb52$var$_interopRequireDefault = $dw9g1.default;

var $b3b59ba0c47fcb52$var$_objectSpread2 = $b3b59ba0c47fcb52$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $luiKZ = parcelRequire("luiKZ");

var $dqEgB = parcelRequire("dqEgB");
var $b3b59ba0c47fcb52$var$createOperationDescriptor = $dqEgB.createOperationDescriptor;

var $3P0TL = parcelRequire("3P0TL");

var $lnHeP = parcelRequire("lnHeP");

var $2yJ7U = parcelRequire("2yJ7U");
var $b3b59ba0c47fcb52$var$getRequest = $2yJ7U.getRequest;

var $3rEVE = parcelRequire("3rEVE");
function $b3b59ba0c47fcb52$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $b3b59ba0c47fcb52$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $3rEVE(false);
    var networkCacheConfig = (0, $b3b59ba0c47fcb52$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $b3b59ba0c47fcb52$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        var _queryNode$fragment$m, _queryNode$fragment$m2;
        $3P0TL(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_queryNode$fragment$m = (_queryNode$fragment$m2 = queryNode.fragment.metadata) === null || _queryNode$fragment$m2 === void 0 ? void 0 : _queryNode$fragment$m2.throwOnFieldError) !== null && _queryNode$fragment$m !== void 0 ? _queryNode$fragment$m : false);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $b3b59ba0c47fcb52$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $luiKZ.from(environment.lookup(operation.fragment)).map(readData);
            return $b3b59ba0c47fcb52$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $b3b59ba0c47fcb52$var$getNetworkObservable(environment, operation) {
    return $lnHeP.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $b3b59ba0c47fcb52$var$fetchQuery;

});
parcelRegister("3P0TL", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $2c86d4eb2c016880$var$_interopRequireDefault = $dw9g1.default;

var $2c86d4eb2c016880$var$_createForOfIteratorHelper2 = $2c86d4eb2c016880$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $aebCs = parcelRequire("aebCs");

var $2c86d4eb2c016880$var$_RelayFeatureFlags = $2c86d4eb2c016880$var$_interopRequireDefault((parcelRequire("ljupL")));
function $2c86d4eb2c016880$var$handlePotentialSnapshotErrors(environment, missingRequiredFields, relayResolverErrors, errorResponseFields, throwOnFieldError) {
    var _iterator = (0, $2c86d4eb2c016880$var$_createForOfIteratorHelper2["default"])(relayResolverErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var resolverError = _step.value;
            environment.relayFieldLogger({
                kind: 'relay_resolver.error',
                owner: resolverError.field.owner,
                fieldPath: resolverError.field.path,
                error: resolverError.error
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (relayResolverErrors.length > 0 && ($2c86d4eb2c016880$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError)) throw new $aebCs.RelayFieldError("Relay: Unexpected resolver exception", relayResolverErrors.map(function(e) {
        return {
            message: e.error.message
        };
    }));
    if (($2c86d4eb2c016880$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING || throwOnFieldError) && errorResponseFields != null) {
        if (errorResponseFields != null) {
            var _iterator2 = (0, $2c86d4eb2c016880$var$_createForOfIteratorHelper2["default"])(errorResponseFields), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var fieldError = _step2.value;
                    var path = fieldError.path, owner = fieldError.owner, error = fieldError.error;
                    environment.relayFieldLogger({
                        kind: 'relay_field_payload.error',
                        owner: owner,
                        fieldPath: path,
                        error: error
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
        if ($2c86d4eb2c016880$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError) throw new $aebCs.RelayFieldError("Relay: Unexpected response payload - this object includes an errors property in which you can access the underlying errors", errorResponseFields.map(function(_ref) {
            var error = _ref.error;
            return error;
        }));
    }
    if (missingRequiredFields != null) switch(missingRequiredFields.action){
        case 'THROW':
            var _missingRequiredField = missingRequiredFields.field, _path = _missingRequiredField.path, _owner = _missingRequiredField.owner;
            environment.relayFieldLogger({
                kind: 'missing_field.throw',
                owner: _owner,
                fieldPath: _path
            });
            throw new Error("Relay: Missing @required value at path '".concat(_path, "' in '").concat(_owner, "'."));
        case 'LOG':
            missingRequiredFields.fields.forEach(function(_ref2) {
                var path = _ref2.path, owner = _ref2.owner;
                environment.relayFieldLogger({
                    kind: 'missing_field.log',
                    owner: owner,
                    fieldPath: path
                });
            });
            break;
        default:
            missingRequiredFields.action;
    }
}
module.exports = $2c86d4eb2c016880$var$handlePotentialSnapshotErrors;

});
parcelRegister("aebCs", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $772439874f59925c$var$_interopRequireDefault = $dw9g1.default;

var $772439874f59925c$var$_objectSpread2 = $772439874f59925c$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $772439874f59925c$var$_objectWithoutPropertiesLoose2 = $772439874f59925c$var$_interopRequireDefault((parcelRequire("9wUL7")));

var $772439874f59925c$var$_createForOfIteratorHelper2 = $772439874f59925c$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $772439874f59925c$var$_inheritsLoose2 = $772439874f59925c$var$_interopRequireDefault((parcelRequire("fDncS")));

var $772439874f59925c$var$_wrapNativeSuper2 = $772439874f59925c$var$_interopRequireDefault((parcelRequire("cX21S")));

var $772439874f59925c$var$_toConsumableArray2 = $772439874f59925c$var$_interopRequireDefault((parcelRequire("agTSl")));
var $772439874f59925c$var$_excluded = [
    "path",
    "locations"
];

var $ljupL = parcelRequire("ljupL");
var $772439874f59925c$var$SELF = Symbol('$SELF');
var $772439874f59925c$var$RelayFieldError = /*#__PURE__*/ function(_Error) {
    (0, $772439874f59925c$var$_inheritsLoose2["default"])(RelayFieldError, _Error);
    function RelayFieldError(message) {
        var _this;
        var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _this = _Error.call(this, message) || this;
        _this.name = 'RelayFieldError';
        _this.message = message;
        _this.errors = errors;
        return _this;
    }
    return RelayFieldError;
}(/*#__PURE__*/ (0, $772439874f59925c$var$_wrapNativeSuper2["default"])(Error));
function $772439874f59925c$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    if (!$ljupL.ENABLE_FIELD_ERROR_HANDLING) return null;
    var trie = new Map();
    var _iterator = (0, $772439874f59925c$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $772439874f59925c$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $772439874f59925c$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($772439874f59925c$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $772439874f59925c$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $772439874f59925c$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $772439874f59925c$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $772439874f59925c$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $772439874f59925c$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $772439874f59925c$var$_toConsumableArray2["default"])(value));
            else $772439874f59925c$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $772439874f59925c$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $772439874f59925c$var$_objectSpread2["default"])((0, $772439874f59925c$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $772439874f59925c$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $772439874f59925c$var$SELF,
    buildErrorTrie: $772439874f59925c$var$buildErrorTrie,
    getNestedErrorTrieByKey: $772439874f59925c$var$getNestedErrorTrieByKey,
    getErrorsByKey: $772439874f59925c$var$getErrorsByKey,
    RelayFieldError: $772439874f59925c$var$RelayFieldError
};

});
parcelRegister("9wUL7", function(module, exports) {
function $6f03215bfef1466c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $6f03215bfef1466c$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fDncS", function(module, exports) {

var $8laJj = parcelRequire("8laJj");
function $b61c7fe80edf883e$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $8laJj(t, o);
}
module.exports = $b61c7fe80edf883e$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8laJj", function(module, exports) {
function $61289b9aecbfb52b$var$_setPrototypeOf(t, e) {
    return module.exports = $61289b9aecbfb52b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $61289b9aecbfb52b$var$_setPrototypeOf(t, e);
}
module.exports = $61289b9aecbfb52b$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cX21S", function(module, exports) {

var $4Oj7O = parcelRequire("4Oj7O");

var $8laJj = parcelRequire("8laJj");

var $6M8Ss = parcelRequire("6M8Ss");

var $jZJKj = parcelRequire("jZJKj");
function $96dc91b5a1989e09$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $96dc91b5a1989e09$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$6M8Ss(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $jZJKj(t, arguments, $4Oj7O(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $8laJj(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $96dc91b5a1989e09$var$_wrapNativeSuper(t);
}
module.exports = $96dc91b5a1989e09$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4Oj7O", function(module, exports) {
function $380aaabfabf947c4$var$_getPrototypeOf(t) {
    return module.exports = $380aaabfabf947c4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $380aaabfabf947c4$var$_getPrototypeOf(t);
}
module.exports = $380aaabfabf947c4$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6M8Ss", function(module, exports) {
function $4eee1c9e7b83367c$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $4eee1c9e7b83367c$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jZJKj", function(module, exports) {

var $l5Hny = parcelRequire("l5Hny");

var $8laJj = parcelRequire("8laJj");
function $03c1aa1d08c62b95$var$_construct(t, e, r) {
    if ($l5Hny()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $8laJj(p, r.prototype), p;
}
module.exports = $03c1aa1d08c62b95$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("l5Hny", function(module, exports) {
function $f5abb6bfe0b8d32f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $f5abb6bfe0b8d32f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $f5abb6bfe0b8d32f$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("lnHeP", function(module, exports) {
'use strict';

var $luiKZ = parcelRequire("luiKZ");

var $gKv1J = parcelRequire("gKv1J");

var $3rEVE = parcelRequire("3rEVE");
var $f90d492210676213$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $f90d492210676213$var$requestCachesByEnvironment = $f90d492210676213$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $f90d492210676213$var$fetchQuery(environment, operation) {
    return $f90d492210676213$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $f90d492210676213$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $luiKZ.create(function(sink) {
        var requestCache = $f90d492210676213$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $gKv1J(),
                    subjectForInFlightStatus: new $gKv1J(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $f90d492210676213$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $f90d492210676213$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $f90d492210676213$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $f90d492210676213$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $3rEVE(false);
        return $f90d492210676213$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $f90d492210676213$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $luiKZ.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $f90d492210676213$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $luiKZ.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $f90d492210676213$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $f90d492210676213$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $f90d492210676213$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $f90d492210676213$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $f90d492210676213$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $f90d492210676213$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $f90d492210676213$var$getRequestCache(environment) {
    var cached = $f90d492210676213$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $f90d492210676213$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $f90d492210676213$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $3rEVE(false);
    return cached;
}
module.exports = {
    fetchQuery: $f90d492210676213$var$fetchQuery,
    fetchQueryDeduped: $f90d492210676213$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $f90d492210676213$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $f90d492210676213$var$getObservableForActiveRequest
};

});
parcelRegister("gKv1J", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $c3190282e5ebcb48$var$_interopRequireDefault = $dw9g1.default;

var $c3190282e5ebcb48$var$_createForOfIteratorHelper2 = $c3190282e5ebcb48$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $c3190282e5ebcb48$var$_defineProperty2 = $c3190282e5ebcb48$var$_interopRequireDefault((parcelRequire("cO17m")));

var $luiKZ = parcelRequire("luiKZ");

var $3rEVE = parcelRequire("3rEVE");
var $c3190282e5ebcb48$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $c3190282e5ebcb48$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $c3190282e5ebcb48$var$_defineProperty2["default"])(this, "_events", []);
        (0, $c3190282e5ebcb48$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $c3190282e5ebcb48$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $luiKZ.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $3rEVE(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $c3190282e5ebcb48$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $c3190282e5ebcb48$var$RelayReplaySubject;

});



parcelRegister("gNgqC", function(module, exports) {
'use strict';

var $dqEgB = parcelRequire("dqEgB");
var $c39df74b83143ae8$var$createOperationDescriptor = $dqEgB.createOperationDescriptor;

var $2yJ7U = parcelRequire("2yJ7U");
var $c39df74b83143ae8$var$getRequest = $2yJ7U.getRequest;
function $c39df74b83143ae8$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $c39df74b83143ae8$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $c39df74b83143ae8$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $c39df74b83143ae8$var$fetchQuery_DEPRECATED;

});

parcelRegister("iZ3II", function(module, exports) {
'use strict';
var $dd20cf47f58a5f8c$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $dd20cf47f58a5f8c$var$preloadableQueryRegistry = new $dd20cf47f58a5f8c$var$PreloadableQueryRegistry();
module.exports = $dd20cf47f58a5f8c$var$preloadableQueryRegistry;

});

parcelRegister("gGI9o", function(module, exports) {
'use strict';

var $89EYT = parcelRequire("89EYT");
parcelRequire("l1Dol");
function $c262d0f98b65d2c0$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $89EYT(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $c262d0f98b65d2c0$var$createFragmentSpecResolver;

});
parcelRegister("89EYT", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $5efef401498053d1$var$_interopRequireDefault = $dw9g1.default;

var $5efef401498053d1$var$_objectSpread2 = $5efef401498053d1$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $5efef401498053d1$var$_defineProperty2 = $5efef401498053d1$var$_interopRequireDefault((parcelRequire("cO17m")));

var $diF8P = parcelRequire("diF8P");

var $3P0TL = parcelRequire("3P0TL");

var $7X5FK = parcelRequire("7X5FK");

var $kD8cH = parcelRequire("kD8cH");

var $ljupL = parcelRequire("ljupL");

var $dqEgB = parcelRequire("dqEgB");
var $5efef401498053d1$var$createRequestDescriptor = $dqEgB.createRequestDescriptor;

var $cKnH2 = parcelRequire("cKnH2");
var $5efef401498053d1$var$areEqualSelectors = $cKnH2.areEqualSelectors, $5efef401498053d1$var$createReaderSelector = $cKnH2.createReaderSelector, $5efef401498053d1$var$getSelectorsFromObject = $cKnH2.getSelectorsFromObject;

var $kgHsa = parcelRequire("kgHsa");

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
var $5efef401498053d1$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $5efef401498053d1$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $5efef401498053d1$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $5efef401498053d1$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$7X5FK(_nextItem, prevItem)) {
                        nextData = nextData || (0, $5efef401498053d1$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($ljupL.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $5efef401498053d1$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $5efef401498053d1$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $5efef401498053d1$var$SelectorListResolver) && $3rEVE(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $5efef401498053d1$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $5efef401498053d1$var$SelectorResolver) && $3rEVE(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $5efef401498053d1$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $5efef401498053d1$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._missingRequiredFields = snapshot.missingRequiredFields;
            _this2._errorResponseFields = snapshot.errorResponseFields;
            _this2._relayResolverErrors = snapshot.relayResolverErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._missingRequiredFields = _snapshot.missingRequiredFields;
        this._errorResponseFields = _snapshot.errorResponseFields;
        this._relayResolverErrors = _snapshot.relayResolverErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($ljupL.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        var _this$_selector$node$, _this$_selector$node$2;
        if (this._isMissingData === true) {
            var pendingOperationsResult = $diF8P(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $3P0TL(this._environment, this._missingRequiredFields, this._relayResolverErrors, this._errorResponseFields, (_this$_selector$node$ = (_this$_selector$node$2 = this._selector.node.metadata) === null || _this$_selector$node$2 === void 0 ? void 0 : _this$_selector$node$2.throwOnFieldError) !== null && _this$_selector$node$ !== void 0 ? _this$_selector$node$ : false);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $5efef401498053d1$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $kD8cH(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._missingRequiredFields = snapshot.missingRequiredFields;
        this._errorResponseFields = snapshot.errorResponseFields;
        this._relayResolverErrors = snapshot.relayResolverErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($kgHsa(variables, this._selector.variables)) return;
        var requestDescriptor = $5efef401498053d1$var$createRequestDescriptor(request, variables);
        var selector = $5efef401498053d1$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $5efef401498053d1$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $5efef401498053d1$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($5efef401498053d1$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $5efef401498053d1$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $5efef401498053d1$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $5efef401498053d1$var$RelayModernFragmentSpecResolver;

});
parcelRegister("diF8P", function(module, exports) {
'use strict';

var $lnHeP = parcelRequire("lnHeP");
var $9aecde9ec8294422$var$getPromiseForActiveRequest = $lnHeP.getPromiseForActiveRequest;
function $9aecde9ec8294422$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $9aecde9ec8294422$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var result = environment.getOperationTracker().getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $9aecde9ec8294422$var$getPendingOperationsForFragment;

});

parcelRegister("7X5FK", function(module, exports) {
'use strict';
function $5ca2718318e4e1bb$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $5ca2718318e4e1bb$var$isScalarAndEqual;

});

parcelRegister("kD8cH", function(module, exports) {
'use strict';
function $f04dd047a64eabae$var$recycleNodesInto(prevData, nextData) {
    return $f04dd047a64eabae$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $f04dd047a64eabae$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $f04dd047a64eabae$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $f04dd047a64eabae$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $f04dd047a64eabae$var$recycleNodesInto;

});



parcelRegister("7VYU6", function(module, exports) {
'use strict';

var $3rEVE = parcelRequire("3rEVE");
var $5c6d19869e767b91$var$relayContext;
var $5c6d19869e767b91$var$firstReact;
function $5c6d19869e767b91$var$createRelayContext(react) {
    if (!$5c6d19869e767b91$var$relayContext) {
        $5c6d19869e767b91$var$relayContext = react.createContext(null);
        $5c6d19869e767b91$var$firstReact = react;
    }
    !(react === $5c6d19869e767b91$var$firstReact) && $3rEVE(false);
    return $5c6d19869e767b91$var$relayContext;
}
module.exports = $5c6d19869e767b91$var$createRelayContext;

});

parcelRegister("cG3gu", function(module, exports) {
'use strict';
var $93abf09f0122fc4f$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $93abf09f0122fc4f$var$suspenseSentinel() {
    return $93abf09f0122fc4f$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $93abf09f0122fc4f$var$isSuspenseSentinel(value) {
    return value === $93abf09f0122fc4f$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $93abf09f0122fc4f$var$isSuspenseSentinel,
    suspenseSentinel: $93abf09f0122fc4f$var$suspenseSentinel
};

});

parcelRegister("4GJVs", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $369eb58d97357767$var$_interopRequireDefault = $dw9g1.default;

var $369eb58d97357767$var$_objectSpread2 = $369eb58d97357767$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $369eb58d97357767$var$_RelayModernRecord = $369eb58d97357767$var$_interopRequireDefault((parcelRequire("8AGUk")));

var $369eb58d97357767$var$_RelayRecordSource = $369eb58d97357767$var$_interopRequireDefault((parcelRequire("kLaEL")));

var $369eb58d97357767$var$_RelayResponseNormalizer = $369eb58d97357767$var$_interopRequireDefault((parcelRequire("bvAsJ")));
function $369eb58d97357767$var$normalizeResponse(response, selector, typeName, options) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $369eb58d97357767$var$_RelayRecordSource["default"].create();
    var record = $369eb58d97357767$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $369eb58d97357767$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors);
    return (0, $369eb58d97357767$var$_objectSpread2["default"])((0, $369eb58d97357767$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $369eb58d97357767$var$normalizeResponse;

});
parcelRegister("8AGUk", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $6412f80e8e5871ad$var$_interopRequireDefault = $dw9g1.default;

var $6412f80e8e5871ad$var$_defineProperty2 = $6412f80e8e5871ad$var$_interopRequireDefault((parcelRequire("cO17m")));

var $6412f80e8e5871ad$var$_objectWithoutPropertiesLoose2 = $6412f80e8e5871ad$var$_interopRequireDefault((parcelRequire("9wUL7")));

var $6412f80e8e5871ad$var$_toPropertyKey2 = $6412f80e8e5871ad$var$_interopRequireDefault((parcelRequire("MYMsF")));

var $6412f80e8e5871ad$var$_objectSpread2 = $6412f80e8e5871ad$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $6NDOU = parcelRequire("6NDOU");

var $3vT9g = parcelRequire("3vT9g");
var $6412f80e8e5871ad$var$generateClientObjectClientID = $3vT9g.generateClientObjectClientID, $6412f80e8e5871ad$var$isClientID = $3vT9g.isClientID;

var $cG3gu = parcelRequire("cG3gu");
var $6412f80e8e5871ad$var$isSuspenseSentinel = $cG3gu.isSuspenseSentinel;

var $aJi4Y = parcelRequire("aJi4Y");
var $6412f80e8e5871ad$var$ACTOR_IDENTIFIER_KEY = $aJi4Y.ACTOR_IDENTIFIER_KEY, $6412f80e8e5871ad$var$ERRORS_KEY = $aJi4Y.ERRORS_KEY, $6412f80e8e5871ad$var$ID_KEY = $aJi4Y.ID_KEY, $6412f80e8e5871ad$var$INVALIDATED_AT_KEY = $aJi4Y.INVALIDATED_AT_KEY, $6412f80e8e5871ad$var$REF_KEY = $aJi4Y.REF_KEY, $6412f80e8e5871ad$var$REFS_KEY = $aJi4Y.REFS_KEY, $6412f80e8e5871ad$var$RELAY_RESOLVER_VALUE_KEY = $aJi4Y.RELAY_RESOLVER_VALUE_KEY, $6412f80e8e5871ad$var$ROOT_ID = $aJi4Y.ROOT_ID, $6412f80e8e5871ad$var$TYPENAME_KEY = $aJi4Y.TYPENAME_KEY;

var $kgHsa = parcelRequire("kgHsa");

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
function $6412f80e8e5871ad$var$clone(record) {
    return (0, $6412f80e8e5871ad$var$_objectSpread2["default"])({}, record);
}
function $6412f80e8e5871ad$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $6412f80e8e5871ad$var$ID_KEY && key !== $6412f80e8e5871ad$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $6412f80e8e5871ad$var$create(dataID, typeName) {
    var record = {};
    record[$6412f80e8e5871ad$var$ID_KEY] = dataID;
    record[$6412f80e8e5871ad$var$TYPENAME_KEY] = typeName;
    return record;
}
function $6412f80e8e5871ad$var$fromObject(json) {
    return json;
}
function $6412f80e8e5871ad$var$getDataID(record) {
    return record[$6412f80e8e5871ad$var$ID_KEY];
}
function $6412f80e8e5871ad$var$getFields(record) {
    if ($6412f80e8e5871ad$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $6412f80e8e5871ad$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $6412f80e8e5871ad$var$getType(record) {
    return record[$6412f80e8e5871ad$var$TYPENAME_KEY];
}
function $6412f80e8e5871ad$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$6412f80e8e5871ad$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $6412f80e8e5871ad$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($6412f80e8e5871ad$var$REF_KEY) && !value.hasOwnProperty($6412f80e8e5871ad$var$REFS_KEY)) && $3rEVE(false);
    return value;
}
function $6412f80e8e5871ad$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $6412f80e8e5871ad$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$6412f80e8e5871ad$var$REF_KEY] === 'string') && $3rEVE(false);
    return link[$6412f80e8e5871ad$var$REF_KEY];
}
function $6412f80e8e5871ad$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$6412f80e8e5871ad$var$REF_KEY] === 'string';
}
function $6412f80e8e5871ad$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$6412f80e8e5871ad$var$REFS_KEY])) && $3rEVE(false);
    return links[$6412f80e8e5871ad$var$REFS_KEY];
}
function $6412f80e8e5871ad$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$6412f80e8e5871ad$var$REFS_KEY]) && links[$6412f80e8e5871ad$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $6412f80e8e5871ad$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$6412f80e8e5871ad$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $6412f80e8e5871ad$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$6412f80e8e5871ad$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$6412f80e8e5871ad$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$kgHsa(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $6412f80e8e5871ad$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $6412f80e8e5871ad$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($kgHsa(prevValue, nextValue) && $kgHsa(prevErrors, nextErrors)) continue;
            updated = (0, $6412f80e8e5871ad$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$6412f80e8e5871ad$var$ERRORS_KEY] = (0, $6412f80e8e5871ad$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $6412f80e8e5871ad$var$setValue(updated, _storageKey2, nextValue);
        $6412f80e8e5871ad$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $6412f80e8e5871ad$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($6412f80e8e5871ad$var$ERRORS_KEY in record1 || $6412f80e8e5871ad$var$ERRORS_KEY in record2) {
        var errors1 = record1[$6412f80e8e5871ad$var$ERRORS_KEY], fields1 = (0, $6412f80e8e5871ad$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $6412f80e8e5871ad$var$ERRORS_KEY
        ].map($6412f80e8e5871ad$var$_toPropertyKey2["default"]));
        var errors2 = record2[$6412f80e8e5871ad$var$ERRORS_KEY], fields2 = (0, $6412f80e8e5871ad$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $6412f80e8e5871ad$var$ERRORS_KEY
        ].map($6412f80e8e5871ad$var$_toPropertyKey2["default"]));
        var updated = (0, $6412f80e8e5871ad$var$_objectSpread2["default"])((0, $6412f80e8e5871ad$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$6412f80e8e5871ad$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $6412f80e8e5871ad$var$_objectSpread2["default"])((0, $6412f80e8e5871ad$var$_objectSpread2["default"])({}, record1), record2);
}
function $6412f80e8e5871ad$var$freeze(record) {
    $6NDOU(record);
}
function $6412f80e8e5871ad$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$6412f80e8e5871ad$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$6412f80e8e5871ad$var$ERRORS_KEY] = (0, $6412f80e8e5871ad$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$6412f80e8e5871ad$var$ERRORS_KEY];
        }
    }
}
function $6412f80e8e5871ad$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $6412f80e8e5871ad$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$6412f80e8e5871ad$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $6412f80e8e5871ad$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$6412f80e8e5871ad$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $6412f80e8e5871ad$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$6412f80e8e5871ad$var$REF_KEY] = linkedID;
    link[$6412f80e8e5871ad$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $6412f80e8e5871ad$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$6412f80e8e5871ad$var$REF_KEY] === 'string' && link[$6412f80e8e5871ad$var$ACTOR_IDENTIFIER_KEY] != null) && $3rEVE(false);
    return [
        link[$6412f80e8e5871ad$var$ACTOR_IDENTIFIER_KEY],
        link[$6412f80e8e5871ad$var$REF_KEY]
    ];
}
function $6412f80e8e5871ad$var$getResolverLinkedRecordID(record, typeName) {
    var id = $6412f80e8e5871ad$var$getValue(record, $6412f80e8e5871ad$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $6412f80e8e5871ad$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $3rEVE(false);
    return $6412f80e8e5871ad$var$generateClientObjectClientID(typeName, id);
}
function $6412f80e8e5871ad$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $6412f80e8e5871ad$var$getValue(record, $6412f80e8e5871ad$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $6412f80e8e5871ad$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $3rEVE(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $3rEVE(false);
        return $6412f80e8e5871ad$var$generateClientObjectClientID(typeName, id);
    });
}
function $6412f80e8e5871ad$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $6412f80e8e5871ad$var$clone,
    copyFields: $6412f80e8e5871ad$var$copyFields,
    create: $6412f80e8e5871ad$var$create,
    freeze: $6412f80e8e5871ad$var$freeze,
    fromObject: $6412f80e8e5871ad$var$fromObject,
    getDataID: $6412f80e8e5871ad$var$getDataID,
    getErrors: $6412f80e8e5871ad$var$getErrors,
    getFields: $6412f80e8e5871ad$var$getFields,
    getInvalidationEpoch: $6412f80e8e5871ad$var$getInvalidationEpoch,
    getLinkedRecordID: $6412f80e8e5871ad$var$getLinkedRecordID,
    getLinkedRecordIDs: $6412f80e8e5871ad$var$getLinkedRecordIDs,
    getType: $6412f80e8e5871ad$var$getType,
    getValue: $6412f80e8e5871ad$var$getValue,
    hasValue: $6412f80e8e5871ad$var$hasValue,
    hasLinkedRecordID: $6412f80e8e5871ad$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $6412f80e8e5871ad$var$hasLinkedRecordIDs,
    merge: $6412f80e8e5871ad$var$merge,
    setErrors: $6412f80e8e5871ad$var$setErrors,
    setValue: $6412f80e8e5871ad$var$setValue,
    setLinkedRecordID: $6412f80e8e5871ad$var$setLinkedRecordID,
    setLinkedRecordIDs: $6412f80e8e5871ad$var$setLinkedRecordIDs,
    update: $6412f80e8e5871ad$var$update,
    getActorLinkedRecordID: $6412f80e8e5871ad$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $6412f80e8e5871ad$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $6412f80e8e5871ad$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $6412f80e8e5871ad$var$getResolverLinkedRecordIDs,
    toJSON: $6412f80e8e5871ad$var$toJSON
};

});

parcelRegister("kLaEL", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $f1d0769bb08f6cf3$var$_interopRequireDefault = $dw9g1.default;

var $f1d0769bb08f6cf3$var$_createForOfIteratorHelper2 = $f1d0769bb08f6cf3$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $8AGUk = parcelRequire("8AGUk");

var $cl6lV = parcelRequire("cl6lV");
var $f1d0769bb08f6cf3$var$EXISTENT = $cl6lV.EXISTENT, $f1d0769bb08f6cf3$var$NONEXISTENT = $cl6lV.NONEXISTENT, $f1d0769bb08f6cf3$var$UNKNOWN = $cl6lV.UNKNOWN;
var $f1d0769bb08f6cf3$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $8AGUk.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $f1d0769bb08f6cf3$var$UNKNOWN;
        return this._records.get(dataID) == null ? $f1d0769bb08f6cf3$var$NONEXISTENT : $f1d0769bb08f6cf3$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $f1d0769bb08f6cf3$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $8AGUk.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $f1d0769bb08f6cf3$var$RelayRecordSource;

});
parcelRegister("cl6lV", function(module, exports) {
'use strict';
var $8fbc5fb463ee577a$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $8fbc5fb463ee577a$var$RelayRecordState;

});


parcelRegister("bvAsJ", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $860edfa6de2ab2ba$var$_interopRequireDefault = $dw9g1.default;

var $860edfa6de2ab2ba$var$_createForOfIteratorHelper2 = $860edfa6de2ab2ba$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $860edfa6de2ab2ba$var$_toConsumableArray2 = $860edfa6de2ab2ba$var$_interopRequireDefault((parcelRequire("agTSl")));

var $dd1dY = parcelRequire("dd1dY");
var $860edfa6de2ab2ba$var$ACTOR_IDENTIFIER_FIELD_NAME = $dd1dY.ACTOR_IDENTIFIER_FIELD_NAME, $860edfa6de2ab2ba$var$getActorIdentifierFromPayload = $dd1dY.getActorIdentifierFromPayload;

var $eXHjc = parcelRequire("eXHjc");
var $860edfa6de2ab2ba$var$ACTOR_CHANGE = $eXHjc.ACTOR_CHANGE, $860edfa6de2ab2ba$var$CLIENT_COMPONENT = $eXHjc.CLIENT_COMPONENT, $860edfa6de2ab2ba$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $eXHjc.CLIENT_EDGE_TO_CLIENT_OBJECT, $860edfa6de2ab2ba$var$CLIENT_EXTENSION = $eXHjc.CLIENT_EXTENSION, $860edfa6de2ab2ba$var$CONDITION = $eXHjc.CONDITION, $860edfa6de2ab2ba$var$DEFER = $eXHjc.DEFER, $860edfa6de2ab2ba$var$FRAGMENT_SPREAD = $eXHjc.FRAGMENT_SPREAD, $860edfa6de2ab2ba$var$INLINE_FRAGMENT = $eXHjc.INLINE_FRAGMENT, $860edfa6de2ab2ba$var$LINKED_FIELD = $eXHjc.LINKED_FIELD, $860edfa6de2ab2ba$var$LINKED_HANDLE = $eXHjc.LINKED_HANDLE, $860edfa6de2ab2ba$var$MODULE_IMPORT = $eXHjc.MODULE_IMPORT, $860edfa6de2ab2ba$var$RELAY_LIVE_RESOLVER = $eXHjc.RELAY_LIVE_RESOLVER, $860edfa6de2ab2ba$var$RELAY_RESOLVER = $eXHjc.RELAY_RESOLVER, $860edfa6de2ab2ba$var$SCALAR_FIELD = $eXHjc.SCALAR_FIELD, $860edfa6de2ab2ba$var$SCALAR_HANDLE = $eXHjc.SCALAR_HANDLE, $860edfa6de2ab2ba$var$STREAM = $eXHjc.STREAM, $860edfa6de2ab2ba$var$TYPE_DISCRIMINATOR = $eXHjc.TYPE_DISCRIMINATOR;

var $3vT9g = parcelRequire("3vT9g");
var $860edfa6de2ab2ba$var$generateClientID = $3vT9g.generateClientID, $860edfa6de2ab2ba$var$isClientID = $3vT9g.isClientID;

var $j1ZVo = parcelRequire("j1ZVo");
var $860edfa6de2ab2ba$var$getLocalVariables = $j1ZVo.getLocalVariables;

var $aebCs = parcelRequire("aebCs");
var $860edfa6de2ab2ba$var$buildErrorTrie = $aebCs.buildErrorTrie, $860edfa6de2ab2ba$var$getErrorsByKey = $aebCs.getErrorsByKey, $860edfa6de2ab2ba$var$getNestedErrorTrieByKey = $aebCs.getNestedErrorTrieByKey;

var $8AGUk = parcelRequire("8AGUk");

var $cKnH2 = parcelRequire("cKnH2");
var $860edfa6de2ab2ba$var$createNormalizationSelector = $cKnH2.createNormalizationSelector;

var $aJi4Y = parcelRequire("aJi4Y");
var $860edfa6de2ab2ba$var$ROOT_ID = $aJi4Y.ROOT_ID, $860edfa6de2ab2ba$var$TYPENAME_KEY = $aJi4Y.TYPENAME_KEY, $860edfa6de2ab2ba$var$getArgumentValues = $aJi4Y.getArgumentValues, $860edfa6de2ab2ba$var$getHandleStorageKey = $aJi4Y.getHandleStorageKey, $860edfa6de2ab2ba$var$getModuleComponentKey = $aJi4Y.getModuleComponentKey, $860edfa6de2ab2ba$var$getModuleOperationKey = $aJi4Y.getModuleOperationKey, $860edfa6de2ab2ba$var$getStorageKey = $aJi4Y.getStorageKey;

var $e691y = parcelRequire("e691y");
var $860edfa6de2ab2ba$var$TYPE_SCHEMA_TYPE = $e691y.TYPE_SCHEMA_TYPE, $860edfa6de2ab2ba$var$generateTypeID = $e691y.generateTypeID;
parcelRequire("kgHsa");

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
function $860edfa6de2ab2ba$var$normalize(recordSource, selector, response, options, errors) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $860edfa6de2ab2ba$var$RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $860edfa6de2ab2ba$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, $860edfa6de2ab2ba$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $3rEVE(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $860edfa6de2ab2ba$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $860edfa6de2ab2ba$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $860edfa6de2ab2ba$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $8AGUk.create(typeID, $860edfa6de2ab2ba$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $8AGUk.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $3rEVE(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$860edfa6de2ab2ba$var$TYPENAME_KEY];
        !(typeName != null) && $3rEVE(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case $860edfa6de2ab2ba$var$SCALAR_FIELD:
                case $860edfa6de2ab2ba$var$LINKED_FIELD:
                    this._normalizeField(selection, record, data);
                    break;
                case $860edfa6de2ab2ba$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case $860edfa6de2ab2ba$var$FRAGMENT_SPREAD:
                    var prevVariables = this._variables;
                    this._variables = $860edfa6de2ab2ba$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case $860edfa6de2ab2ba$var$INLINE_FRAGMENT:
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $8AGUk.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = $8AGUk.getType(record);
                        var typeID = $860edfa6de2ab2ba$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $8AGUk.create(typeID, $860edfa6de2ab2ba$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $8AGUk.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case $860edfa6de2ab2ba$var$TYPE_DISCRIMINATOR:
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = $8AGUk.getType(record);
                    var _typeID = $860edfa6de2ab2ba$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $8AGUk.create(_typeID, $860edfa6de2ab2ba$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $8AGUk.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case $860edfa6de2ab2ba$var$LINKED_HANDLE:
                case $860edfa6de2ab2ba$var$SCALAR_HANDLE:
                    var args = selection.args ? $860edfa6de2ab2ba$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $860edfa6de2ab2ba$var$getStorageKey(selection, this._variables);
                    var handleKey = $860edfa6de2ab2ba$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $8AGUk.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $860edfa6de2ab2ba$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case $860edfa6de2ab2ba$var$MODULE_IMPORT:
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case $860edfa6de2ab2ba$var$DEFER:
                    this._normalizeDefer(selection, record, data);
                    break;
                case $860edfa6de2ab2ba$var$STREAM:
                    this._normalizeStream(selection, record, data);
                    break;
                case $860edfa6de2ab2ba$var$CLIENT_EXTENSION:
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case $860edfa6de2ab2ba$var$CLIENT_COMPONENT:
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case $860edfa6de2ab2ba$var$ACTOR_CHANGE:
                    this._normalizeActorChange(selection, record, data);
                    break;
                case $860edfa6de2ab2ba$var$RELAY_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $860edfa6de2ab2ba$var$RELAY_LIVE_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $860edfa6de2ab2ba$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $3rEVE(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $860edfa6de2ab2ba$var$_toConsumableArray2["default"])(this._path),
            selector: $860edfa6de2ab2ba$var$createNormalizationSelector(defer, $8AGUk.getDataID(record), this._variables),
            typeName: $8AGUk.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $860edfa6de2ab2ba$var$_toConsumableArray2["default"])(this._path),
            parentID: $8AGUk.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $3rEVE(false);
        var typeName = $8AGUk.getType(record);
        var componentKey = $860edfa6de2ab2ba$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $8AGUk.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $860edfa6de2ab2ba$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $8AGUk.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $8AGUk.getDataID(record),
            operationReference: operationReference,
            path: (0, $860edfa6de2ab2ba$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $3rEVE(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $860edfa6de2ab2ba$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $8AGUk.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $860edfa6de2ab2ba$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $8AGUk.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === $860edfa6de2ab2ba$var$SCALAR_FIELD) $8AGUk.setValue(record, storageKey, fieldValue);
        else if (selection.kind === $860edfa6de2ab2ba$var$LINKED_FIELD) {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $860edfa6de2ab2ba$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $3rEVE(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $3rEVE(false);
        var responseKey = field.alias || field.name;
        var storageKey = $860edfa6de2ab2ba$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $8AGUk.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $860edfa6de2ab2ba$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $8AGUk.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $8AGUk.getLinkedRecordID(record, storageKey) || $860edfa6de2ab2ba$var$generateClientID($8AGUk.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $3rEVE(false);
        $8AGUk.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $860edfa6de2ab2ba$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $3rEVE(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $8AGUk.getLinkedRecordID(record, storageKey) || $860edfa6de2ab2ba$var$generateClientID($8AGUk.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $3rEVE(false);
        $8AGUk.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $8AGUk.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $3rEVE(false);
        var prevIDs = $8AGUk.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $860edfa6de2ab2ba$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $3rEVE(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $860edfa6de2ab2ba$var$generateClientID($8AGUk.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $3rEVE(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $8AGUk.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $8AGUk.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = $8AGUk.getDataID(record);
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $860edfa6de2ab2ba$var$normalize
};

});
parcelRegister("dd1dY", function(module, exports) {
'use strict';
var $99dd70645e1d7d91$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $8T3Ai = parcelRequire("8T3Ai");
var $99dd70645e1d7d91$var$getActorIdentifier = $8T3Ai.getActorIdentifier;
function $99dd70645e1d7d91$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$99dd70645e1d7d91$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $99dd70645e1d7d91$var$getActorIdentifier(payload[$99dd70645e1d7d91$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $99dd70645e1d7d91$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $99dd70645e1d7d91$var$getActorIdentifierFromPayload
};

});
parcelRegister("8T3Ai", function(module, exports) {
'use strict';

var $3rEVE = parcelRequire("3rEVE");
var $67863d8d39c33a2a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $67863d8d39c33a2a$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $67863d8d39c33a2a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $3rEVE(false);
}
module.exports = {
    assertInternalActorIdentifier: $67863d8d39c33a2a$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $67863d8d39c33a2a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("e691y", function(module, exports) {
'use strict';
var $a438a03c77aa02de$var$PREFIX = 'client:__type:';
var $a438a03c77aa02de$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $a438a03c77aa02de$var$generateTypeID(typeName) {
    return $a438a03c77aa02de$var$PREFIX + typeName;
}
function $a438a03c77aa02de$var$isTypeID(id) {
    return id.indexOf($a438a03c77aa02de$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $a438a03c77aa02de$var$generateTypeID,
    isTypeID: $a438a03c77aa02de$var$isTypeID,
    TYPE_SCHEMA_TYPE: $a438a03c77aa02de$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("l3ub9", function(module, exports) {
'use strict';

var $2yJ7U = parcelRequire("2yJ7U");
var $f54149b0861ae762$var$getInlineDataFragment = $2yJ7U.getInlineDataFragment;

var $aJi4Y = parcelRequire("aJi4Y");
var $f54149b0861ae762$var$FRAGMENTS_KEY = $aJi4Y.FRAGMENTS_KEY;

var $3rEVE = parcelRequire("3rEVE");
function $f54149b0861ae762$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $f54149b0861ae762$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $3rEVE(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$f54149b0861ae762$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $3rEVE(false);
    return inlineData;
}
module.exports = $f54149b0861ae762$var$readInlineData;

});

parcelRegister("1EF6z", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $134969722348aaca$var$_interopRequireDefault = $dw9g1.default;

var $134969722348aaca$var$_objectSpread2 = $134969722348aaca$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $cZWl0 = parcelRequire("cZWl0");

var $8T3Ai = parcelRequire("8T3Ai");
var $134969722348aaca$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $8T3Ai.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $134969722348aaca$var$assertInternalActorIdentifier = $8T3Ai.assertInternalActorIdentifier;

var $luiKZ = parcelRequire("luiKZ");

var $4bdUI = parcelRequire("4bdUI");

var $gjpAU = parcelRequire("gjpAU");

var $3bslE = parcelRequire("3bslE");

var $bidvu = parcelRequire("bidvu");

var $kXaHH = parcelRequire("kXaHH");

var $4GJVs = parcelRequire("4GJVs");

var $dZJy4 = parcelRequire("dZJy4");

var $i79PO = parcelRequire("i79PO");

var $kLaEL = parcelRequire("kLaEL");
parcelRequire("3rEVE");
var $134969722348aaca$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $134969722348aaca$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $kXaHH;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $4bdUI(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $bidvu;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $i79PO(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $cZWl0, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $4GJVs;
        this.__setNet = function(newNet) {
            return _this._network = $4bdUI(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $gjpAU();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $3bslE(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $luiKZ.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$134969722348aaca$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $luiKZ.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $kLaEL.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $134969722348aaca$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $134969722348aaca$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $134969722348aaca$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $134969722348aaca$var$_objectSpread2["default"])((0, $134969722348aaca$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $luiKZ.create(function(sink) {
            var executor = $dZJy4.execute({
                actorIdentifier: $134969722348aaca$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $134969722348aaca$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $134969722348aaca$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $134969722348aaca$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$134969722348aaca$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $134969722348aaca$var$emptyFunction() {}
module.exports = $134969722348aaca$var$RelayModernEnvironment;

});
parcelRegister("4bdUI", function(module, exports) {
'use strict';

var $5pgAH = parcelRequire("5pgAH");
function $30b2fb7e5d413ee0$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = $5pgAH();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
module.exports = $30b2fb7e5d413ee0$var$wrapNetworkWithLogObserver;

});
parcelRegister("5pgAH", function(module, exports) {
'use strict';
var $3efc282b3f2b0c8a$var$id = 100000;
function $3efc282b3f2b0c8a$var$generateID() {
    return $3efc282b3f2b0c8a$var$id++;
}
module.exports = $3efc282b3f2b0c8a$var$generateID;

});


parcelRegister("gjpAU", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $be024635e2307b7c$var$_interopRequireDefault = $dw9g1.default;

var $be024635e2307b7c$var$_createForOfIteratorHelper2 = $be024635e2307b7c$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $3rEVE = parcelRequire("3rEVE");
var $be024635e2307b7c$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $be024635e2307b7c$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $be024635e2307b7c$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $be024635e2307b7c$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $be024635e2307b7c$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $be024635e2307b7c$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $3rEVE(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $be024635e2307b7c$var$RelayOperationTracker;

});

parcelRegister("3bslE", function(module, exports) {
'use strict';
function $2518638b1b9e4122$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $2518638b1b9e4122$var$registerEnvironmentWithDevTools;

});

parcelRegister("bidvu", function(module, exports) {
'use strict';

var $51AJZ = parcelRequire("51AJZ");
var $838bda5762c7e36e$var$VIEWER_ID = $51AJZ.VIEWER_ID, $838bda5762c7e36e$var$VIEWER_TYPE = $51AJZ.VIEWER_TYPE;
function $838bda5762c7e36e$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $838bda5762c7e36e$var$VIEWER_TYPE) return fieldValue.id == null ? $838bda5762c7e36e$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $838bda5762c7e36e$var$defaultGetDataID;

});
parcelRegister("51AJZ", function(module, exports) {
'use strict';

var $3vT9g = parcelRequire("3vT9g");
var $3a898bb5bfc598f6$var$generateClientID = $3vT9g.generateClientID;

var $aJi4Y = parcelRequire("aJi4Y");
var $3a898bb5bfc598f6$var$ROOT_ID = $aJi4Y.ROOT_ID;
var $3a898bb5bfc598f6$var$VIEWER_ID = $3a898bb5bfc598f6$var$generateClientID($3a898bb5bfc598f6$var$ROOT_ID, 'viewer');
var $3a898bb5bfc598f6$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $3a898bb5bfc598f6$var$VIEWER_ID,
    VIEWER_TYPE: $3a898bb5bfc598f6$var$VIEWER_TYPE
};

});


parcelRegister("kXaHH", function(module, exports) {
'use strict';
var $f4119ee3f7301985$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $f4119ee3f7301985$var$defaultRelayFieldLogger;

});

parcelRegister("dZJy4", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $a3044dd5cd748c04$var$_interopRequireDefault = $dw9g1.default;

var $a3044dd5cd748c04$var$_createForOfIteratorHelper2 = $a3044dd5cd748c04$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $a3044dd5cd748c04$var$_toConsumableArray2 = $a3044dd5cd748c04$var$_interopRequireDefault((parcelRequire("agTSl")));

var $luiKZ = parcelRequire("luiKZ");

var $5pgAH = parcelRequire("5pgAH");

var $fZZs3 = parcelRequire("fZZs3");

var $eu4CI = parcelRequire("eu4CI");

var $ljupL = parcelRequire("ljupL");

var $kTvRX = parcelRequire("kTvRX");

var $YbHqL = parcelRequire("YbHqL");

var $3vT9g = parcelRequire("3vT9g");
var $a3044dd5cd748c04$var$generateClientID = $3vT9g.generateClientID, $a3044dd5cd748c04$var$generateUniqueClientID = $3vT9g.generateUniqueClientID;

var $j1ZVo = parcelRequire("j1ZVo");
var $a3044dd5cd748c04$var$getLocalVariables = $j1ZVo.getLocalVariables;

var $8AGUk = parcelRequire("8AGUk");

var $cKnH2 = parcelRequire("cKnH2");
var $a3044dd5cd748c04$var$createNormalizationSelector = $cKnH2.createNormalizationSelector, $a3044dd5cd748c04$var$createReaderSelector = $cKnH2.createReaderSelector;

var $kLaEL = parcelRequire("kLaEL");

var $aJi4Y = parcelRequire("aJi4Y");
var $a3044dd5cd748c04$var$ROOT_TYPE = $aJi4Y.ROOT_TYPE, $a3044dd5cd748c04$var$TYPENAME_KEY = $aJi4Y.TYPENAME_KEY, $a3044dd5cd748c04$var$getStorageKey = $aJi4Y.getStorageKey;

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
function $a3044dd5cd748c04$var$execute(config) {
    return new $a3044dd5cd748c04$var$Executor(config);
}
var $a3044dd5cd748c04$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log, normalizeResponse = _ref2.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $5pgAH();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($ljupL.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (!$ljupL.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $3rEVE(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $luiKZ.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                });
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        this._schedule(function() {
            var _withDuration = $YbHqL(function() {
                _this4._handleNext(response);
                _this4._maybeCompleteSubscriptionOperationTracking();
            }), duration = _withDuration[0];
            _this4._log({
                name: 'execute.next',
                executeId: _this4._executeId,
                response: response,
                duration: duration
            });
        });
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $eu4CI.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $3rEVE(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $3rEVE(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $a3044dd5cd748c04$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $a3044dd5cd748c04$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $a3044dd5cd748c04$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $a3044dd5cd748c04$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $3rEVE(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $a3044dd5cd748c04$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            $a3044dd5cd748c04$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $kLaEL.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($ljupL.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $a3044dd5cd748c04$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $a3044dd5cd748c04$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $3rEVE(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $a3044dd5cd748c04$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $a3044dd5cd748c04$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return this._normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $fZZs3(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $a3044dd5cd748c04$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $a3044dd5cd748c04$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $a3044dd5cd748c04$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $fZZs3(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $luiKZ.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $luiKZ.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $fZZs3(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $ljupL.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withDuration2 = $YbHqL(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), duration = _withDuration2[0];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $3rEVE(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $3rEVE(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $a3044dd5cd748c04$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $3rEVE(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $8AGUk.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $a3044dd5cd748c04$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $3rEVE(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $3rEVE(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $3rEVE(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $kLaEL.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $3rEVE(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $a3044dd5cd748c04$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $kLaEL.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $3rEVE(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $a3044dd5cd748c04$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $3rEVE(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $8AGUk.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $3rEVE(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $3rEVE(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$a3044dd5cd748c04$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $3rEVE(false);
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : $a3044dd5cd748c04$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $3rEVE(false);
        var selector = $a3044dd5cd748c04$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $8AGUk.clone(parentRecord);
        var nextIDs = (0, $a3044dd5cd748c04$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $8AGUk.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, $a3044dd5cd748c04$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $a3044dd5cd748c04$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $a3044dd5cd748c04$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $a3044dd5cd748c04$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $a3044dd5cd748c04$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $3rEVE(false);
        return operationLoader;
    };
    return Executor;
}();
function $a3044dd5cd748c04$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $3rEVE(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function $a3044dd5cd748c04$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($kTvRX(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $a3044dd5cd748c04$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $3rEVE(false);
}
module.exports = {
    execute: $a3044dd5cd748c04$var$execute
};

});
parcelRegister("fZZs3", function(module, exports) {
'use strict';

var $eXHjc = parcelRequire("eXHjc");
var $ba5c387e01ad8b14$var$REQUEST = $eXHjc.REQUEST, $ba5c387e01ad8b14$var$SPLIT_OPERATION = $eXHjc.SPLIT_OPERATION;
function $ba5c387e01ad8b14$var$getOperation(node) {
    switch(node.kind){
        case $ba5c387e01ad8b14$var$REQUEST:
            return node.operation;
        case $ba5c387e01ad8b14$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $ba5c387e01ad8b14$var$getOperation;

});

parcelRegister("eu4CI", function(module, exports) {
'use strict';
function $a8b774229ade648e$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $a8b774229ade648e$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $a8b774229ade648e$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("YbHqL", function(module, exports) {
'use strict';
var $0b4eadfcc62f58e9$var$_window, $0b4eadfcc62f58e9$var$_window$performance;
var $0b4eadfcc62f58e9$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($0b4eadfcc62f58e9$var$_window = window) === null || $0b4eadfcc62f58e9$var$_window === void 0 ? void 0 : ($0b4eadfcc62f58e9$var$_window$performance = $0b4eadfcc62f58e9$var$_window.performance) === null || $0b4eadfcc62f58e9$var$_window$performance === void 0 ? void 0 : $0b4eadfcc62f58e9$var$_window$performance.now) === 'function';
function $0b4eadfcc62f58e9$var$currentTimestamp() {
    if ($0b4eadfcc62f58e9$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $0b4eadfcc62f58e9$var$withDuration(cb) {
    var startTime = $0b4eadfcc62f58e9$var$currentTimestamp();
    var result = cb();
    return [
        $0b4eadfcc62f58e9$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $0b4eadfcc62f58e9$var$withDuration;

});


parcelRegister("i79PO", function(module, exports) {
'use strict';
var $d3008264a6335d28$var$_global$ErrorUtils$ap, $d3008264a6335d28$var$_global$ErrorUtils;

var $aDzr3 = parcelRequire("aDzr3");

var $8jf5f = parcelRequire("8jf5f");

var $ahHUX = parcelRequire("ahHUX");

var $e170H = parcelRequire("e170H");

var $kLaEL = parcelRequire("kLaEL");

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
var $d3008264a6335d28$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $d3008264a6335d28$var$applyWithGuard = ($d3008264a6335d28$var$_global$ErrorUtils$ap = $d3008264a6335d28$var$_global === null || $d3008264a6335d28$var$_global === void 0 ? void 0 : ($d3008264a6335d28$var$_global$ErrorUtils = $d3008264a6335d28$var$_global.ErrorUtils) === null || $d3008264a6335d28$var$_global$ErrorUtils === void 0 ? void 0 : $d3008264a6335d28$var$_global$ErrorUtils.applyWithGuard) !== null && $d3008264a6335d28$var$_global$ErrorUtils$ap !== void 0 ? $d3008264a6335d28$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $d3008264a6335d28$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $3rEVE(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $aDzr3(this._store.getSource(), source);
        var recordSourceProxy = new $8jf5f(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $3rEVE(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $3rEVE(false);
            var recordSourceSelectorProxy = new $ahHUX(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $d3008264a6335d28$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $kLaEL.create();
                var mutator = new $aDzr3(_this2._store.getSource(), sink);
                var recordSourceProxy = new $8jf5f(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                $d3008264a6335d28$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $kLaEL.create();
        var mutator = new $aDzr3(this._store.getSource(), sink);
        var recordSourceProxy = new $8jf5f(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $d3008264a6335d28$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $d3008264a6335d28$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $ahHUX(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $d3008264a6335d28$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $d3008264a6335d28$var$lookupSelector(source, selector) {
    var selectorData = $e170H.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $d3008264a6335d28$var$RelayPublishQueue;

});
parcelRegister("aDzr3", function(module, exports) {
'use strict';

var $8AGUk = parcelRequire("8AGUk");

var $cl6lV = parcelRequire("cl6lV");
var $7be9089bfa9b79c4$var$EXISTENT = $cl6lV.EXISTENT;

var $3rEVE = parcelRequire("3rEVE");
var $7be9089bfa9b79c4$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $8AGUk.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $8AGUk.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $8AGUk.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $3rEVE(false);
            sinkRecord = $8AGUk.create(dataID, $8AGUk.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $3rEVE(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $8AGUk.copyFields(baseSource, sink);
        if (sinkSource) $8AGUk.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $8AGUk.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $7be9089bfa9b79c4$var$EXISTENT && this._sink.getStatus(dataID) !== $7be9089bfa9b79c4$var$EXISTENT) && $3rEVE(false);
        var record = $8AGUk.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $8AGUk.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $8AGUk.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $8AGUk.setValue(sinkRecord, storageKey, value);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $8AGUk.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $8AGUk.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $8AGUk.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $8AGUk.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $7be9089bfa9b79c4$var$RelayRecordSourceMutator;

});

parcelRegister("8jf5f", function(module, exports) {
'use strict';

var $8AGUk = parcelRequire("8AGUk");

var $cl6lV = parcelRequire("cl6lV");
var $60cbcc5bd9867740$var$EXISTENT = $cl6lV.EXISTENT, $60cbcc5bd9867740$var$NONEXISTENT = $cl6lV.NONEXISTENT;

var $aJi4Y = parcelRequire("aJi4Y");
var $60cbcc5bd9867740$var$ROOT_ID = $aJi4Y.ROOT_ID, $60cbcc5bd9867740$var$ROOT_TYPE = $aJi4Y.ROOT_TYPE;

var $6FkRr = parcelRequire("6FkRr");
var $60cbcc5bd9867740$var$_readUpdatableFragment = $6FkRr.readUpdatableFragment;

var $kd2qU = parcelRequire("kd2qU");
var $60cbcc5bd9867740$var$_readUpdatableQuery = $kd2qU.readUpdatableQuery;

var $79dKM = parcelRequire("79dKM");

var $3rEVE = parcelRequire("3rEVE");
var $60cbcc5bd9867740$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $60cbcc5bd9867740$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $60cbcc5bd9867740$var$EXISTENT) _this.create(dataID, $8AGUk.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $60cbcc5bd9867740$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $3rEVE(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $3rEVE(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $60cbcc5bd9867740$var$ROOT_ID) && $3rEVE(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $60cbcc5bd9867740$var$EXISTENT) this._proxies[dataID] = new $79dKM(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $60cbcc5bd9867740$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($60cbcc5bd9867740$var$ROOT_ID);
        if (!root) root = this.create($60cbcc5bd9867740$var$ROOT_ID, $60cbcc5bd9867740$var$ROOT_TYPE);
        !(root && root.getType() === $60cbcc5bd9867740$var$ROOT_TYPE) && $3rEVE(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $60cbcc5bd9867740$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $60cbcc5bd9867740$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $60cbcc5bd9867740$var$RelayRecordSourceProxy;

});
parcelRegister("6FkRr", function(module, exports) {
'use strict';

var $2yJ7U = parcelRequire("2yJ7U");
var $4da6c0f48fae3eb5$var$getFragment = $2yJ7U.getFragment;

var $cKnH2 = parcelRequire("cKnH2");
var $4da6c0f48fae3eb5$var$getVariablesFromFragment = $cKnH2.getVariablesFromFragment;

var $aJi4Y = parcelRequire("aJi4Y");
var $4da6c0f48fae3eb5$var$ID_KEY = $aJi4Y.ID_KEY;

var $93tog = parcelRequire("93tog");
var $4da6c0f48fae3eb5$var$createUpdatableProxy = $93tog.createUpdatableProxy;

var $3rEVE = parcelRequire("3rEVE");
function $4da6c0f48fae3eb5$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $4da6c0f48fae3eb5$var$getFragment(fragment);
    var fragmentVariables = $4da6c0f48fae3eb5$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$4da6c0f48fae3eb5$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $3rEVE(false);
    return {
        updatableData: $4da6c0f48fae3eb5$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $4da6c0f48fae3eb5$var$readUpdatableFragment
};

});
parcelRegister("93tog", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $697b312f71a2dfb6$var$_interopRequireDefault = $dw9g1.default;

var $697b312f71a2dfb6$var$_createForOfIteratorHelper2 = $697b312f71a2dfb6$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $aJi4Y = parcelRequire("aJi4Y");
var $697b312f71a2dfb6$var$getArgumentValues = $aJi4Y.getArgumentValues;

var $eXHjc = parcelRequire("eXHjc");
var $697b312f71a2dfb6$var$ACTOR_CHANGE = $eXHjc.ACTOR_CHANGE, $697b312f71a2dfb6$var$ALIASED_FRAGMENT_SPREAD = $eXHjc.ALIASED_FRAGMENT_SPREAD, $697b312f71a2dfb6$var$ALIASED_INLINE_FRAGMENT_SPREAD = $eXHjc.ALIASED_INLINE_FRAGMENT_SPREAD, $697b312f71a2dfb6$var$CATCH_FIELD = $eXHjc.CATCH_FIELD, $697b312f71a2dfb6$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $eXHjc.CLIENT_EDGE_TO_CLIENT_OBJECT, $697b312f71a2dfb6$var$CLIENT_EDGE_TO_SERVER_OBJECT = $eXHjc.CLIENT_EDGE_TO_SERVER_OBJECT, $697b312f71a2dfb6$var$CLIENT_EXTENSION = $eXHjc.CLIENT_EXTENSION, $697b312f71a2dfb6$var$CONDITION = $eXHjc.CONDITION, $697b312f71a2dfb6$var$DEFER = $eXHjc.DEFER, $697b312f71a2dfb6$var$FRAGMENT_SPREAD = $eXHjc.FRAGMENT_SPREAD, $697b312f71a2dfb6$var$INLINE_DATA_FRAGMENT_SPREAD = $eXHjc.INLINE_DATA_FRAGMENT_SPREAD, $697b312f71a2dfb6$var$INLINE_FRAGMENT = $eXHjc.INLINE_FRAGMENT, $697b312f71a2dfb6$var$LINKED_FIELD = $eXHjc.LINKED_FIELD, $697b312f71a2dfb6$var$MODULE_IMPORT = $eXHjc.MODULE_IMPORT, $697b312f71a2dfb6$var$RELAY_LIVE_RESOLVER = $eXHjc.RELAY_LIVE_RESOLVER, $697b312f71a2dfb6$var$RELAY_RESOLVER = $eXHjc.RELAY_RESOLVER, $697b312f71a2dfb6$var$REQUIRED_FIELD = $eXHjc.REQUIRED_FIELD, $697b312f71a2dfb6$var$SCALAR_FIELD = $eXHjc.SCALAR_FIELD, $697b312f71a2dfb6$var$STREAM = $eXHjc.STREAM;
var $697b312f71a2dfb6$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $697b312f71a2dfb6$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $697b312f71a2dfb6$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $697b312f71a2dfb6$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $697b312f71a2dfb6$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case $697b312f71a2dfb6$var$LINKED_FIELD:
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $697b312f71a2dfb6$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $697b312f71a2dfb6$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $697b312f71a2dfb6$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $697b312f71a2dfb6$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case $697b312f71a2dfb6$var$SCALAR_FIELD:
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $697b312f71a2dfb6$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $697b312f71a2dfb6$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $697b312f71a2dfb6$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $697b312f71a2dfb6$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case $697b312f71a2dfb6$var$INLINE_FRAGMENT:
                    if (updatableProxyRootRecord.getType() === selection.type) $697b312f71a2dfb6$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $697b312f71a2dfb6$var$CLIENT_EXTENSION:
                    $697b312f71a2dfb6$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $697b312f71a2dfb6$var$FRAGMENT_SPREAD:
                    break;
                case $697b312f71a2dfb6$var$CONDITION:
                case $697b312f71a2dfb6$var$ACTOR_CHANGE:
                case $697b312f71a2dfb6$var$ALIASED_FRAGMENT_SPREAD:
                case $697b312f71a2dfb6$var$INLINE_DATA_FRAGMENT_SPREAD:
                case $697b312f71a2dfb6$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                case $697b312f71a2dfb6$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $697b312f71a2dfb6$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                case $697b312f71a2dfb6$var$DEFER:
                case $697b312f71a2dfb6$var$MODULE_IMPORT:
                case $697b312f71a2dfb6$var$RELAY_LIVE_RESOLVER:
                case $697b312f71a2dfb6$var$REQUIRED_FIELD:
                case $697b312f71a2dfb6$var$CATCH_FIELD:
                case $697b312f71a2dfb6$var$STREAM:
                case $697b312f71a2dfb6$var$RELAY_RESOLVER:
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $697b312f71a2dfb6$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $697b312f71a2dfb6$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $697b312f71a2dfb6$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $697b312f71a2dfb6$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $697b312f71a2dfb6$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $697b312f71a2dfb6$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $697b312f71a2dfb6$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $697b312f71a2dfb6$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $697b312f71a2dfb6$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $697b312f71a2dfb6$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $697b312f71a2dfb6$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $697b312f71a2dfb6$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $697b312f71a2dfb6$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $697b312f71a2dfb6$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $697b312f71a2dfb6$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $697b312f71a2dfb6$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $697b312f71a2dfb6$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $697b312f71a2dfb6$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $697b312f71a2dfb6$var$createUpdatableProxy
};

});


parcelRegister("kd2qU", function(module, exports) {
'use strict';

var $2yJ7U = parcelRequire("2yJ7U");
var $eb66e8b1ebf342d6$var$getUpdatableQuery = $2yJ7U.getUpdatableQuery;

var $93tog = parcelRequire("93tog");
var $eb66e8b1ebf342d6$var$createUpdatableProxy = $93tog.createUpdatableProxy;
function $eb66e8b1ebf342d6$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $eb66e8b1ebf342d6$var$getUpdatableQuery(query);
    return {
        updatableData: $eb66e8b1ebf342d6$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $eb66e8b1ebf342d6$var$readUpdatableQuery
};

});

parcelRegister("79dKM", function(module, exports) {
'use strict';

var $3vT9g = parcelRequire("3vT9g");
var $53440ad5de1ea066$var$generateClientID = $3vT9g.generateClientID;

var $aJi4Y = parcelRequire("aJi4Y");
var $53440ad5de1ea066$var$getStableStorageKey = $aJi4Y.getStableStorageKey;

var $3rEVE = parcelRequire("3rEVE");
var $53440ad5de1ea066$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $3rEVE(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $53440ad5de1ea066$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args) {
        !$53440ad5de1ea066$var$isValidLeafValue(value) && $3rEVE(false);
        return this.setValue__UNSAFE(value, name, args);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args) {
        var storageKey = $53440ad5de1ea066$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $53440ad5de1ea066$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $3rEVE(false);
        var storageKey = $53440ad5de1ea066$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $53440ad5de1ea066$var$getStableStorageKey(name, args);
            var clientID = $53440ad5de1ea066$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $53440ad5de1ea066$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $3rEVE(false);
        var storageKey = $53440ad5de1ea066$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $53440ad5de1ea066$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($53440ad5de1ea066$var$isValidLeafValue);
}
module.exports = $53440ad5de1ea066$var$RelayRecordProxy;

});


parcelRegister("ahHUX", function(module, exports) {
'use strict';

var $aJi4Y = parcelRequire("aJi4Y");
var $77cd8f10f3412548$var$ROOT_TYPE = $aJi4Y.ROOT_TYPE, $77cd8f10f3412548$var$getStorageKey = $aJi4Y.getStorageKey;

var $6FkRr = parcelRequire("6FkRr");
var $77cd8f10f3412548$var$_readUpdatableFragment = $6FkRr.readUpdatableFragment;

var $kd2qU = parcelRequire("kd2qU");
var $77cd8f10f3412548$var$_readUpdatableQuery = $kd2qU.readUpdatableQuery;

var $3rEVE = parcelRequire("3rEVE");
var $77cd8f10f3412548$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $77cd8f10f3412548$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $3rEVE(false);
        !(field.plural === plural) && $3rEVE(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $77cd8f10f3412548$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $77cd8f10f3412548$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $77cd8f10f3412548$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $77cd8f10f3412548$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $77cd8f10f3412548$var$RelayRecordSourceSelectorProxy;

});

parcelRegister("e170H", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $a34698c3f399c0d4$var$_interopRequireDefault = $dw9g1.default;

var $a34698c3f399c0d4$var$_defineProperty2 = $a34698c3f399c0d4$var$_interopRequireDefault((parcelRequire("cO17m")));

var $a34698c3f399c0d4$var$_createForOfIteratorHelper2 = $a34698c3f399c0d4$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $a34698c3f399c0d4$var$_toConsumableArray2 = $a34698c3f399c0d4$var$_interopRequireDefault((parcelRequire("agTSl")));

var $eXHjc = parcelRequire("eXHjc");
var $a34698c3f399c0d4$var$ACTOR_CHANGE = $eXHjc.ACTOR_CHANGE, $a34698c3f399c0d4$var$ALIASED_FRAGMENT_SPREAD = $eXHjc.ALIASED_FRAGMENT_SPREAD, $a34698c3f399c0d4$var$ALIASED_INLINE_FRAGMENT_SPREAD = $eXHjc.ALIASED_INLINE_FRAGMENT_SPREAD, $a34698c3f399c0d4$var$CATCH_FIELD = $eXHjc.CATCH_FIELD, $a34698c3f399c0d4$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $eXHjc.CLIENT_EDGE_TO_CLIENT_OBJECT, $a34698c3f399c0d4$var$CLIENT_EDGE_TO_SERVER_OBJECT = $eXHjc.CLIENT_EDGE_TO_SERVER_OBJECT, $a34698c3f399c0d4$var$CLIENT_EXTENSION = $eXHjc.CLIENT_EXTENSION, $a34698c3f399c0d4$var$CONDITION = $eXHjc.CONDITION, $a34698c3f399c0d4$var$DEFER = $eXHjc.DEFER, $a34698c3f399c0d4$var$FRAGMENT_SPREAD = $eXHjc.FRAGMENT_SPREAD, $a34698c3f399c0d4$var$INLINE_DATA_FRAGMENT_SPREAD = $eXHjc.INLINE_DATA_FRAGMENT_SPREAD, $a34698c3f399c0d4$var$INLINE_FRAGMENT = $eXHjc.INLINE_FRAGMENT, $a34698c3f399c0d4$var$LINKED_FIELD = $eXHjc.LINKED_FIELD, $a34698c3f399c0d4$var$MODULE_IMPORT = $eXHjc.MODULE_IMPORT, $a34698c3f399c0d4$var$RELAY_LIVE_RESOLVER = $eXHjc.RELAY_LIVE_RESOLVER, $a34698c3f399c0d4$var$RELAY_RESOLVER = $eXHjc.RELAY_RESOLVER, $a34698c3f399c0d4$var$REQUIRED_FIELD = $eXHjc.REQUIRED_FIELD, $a34698c3f399c0d4$var$SCALAR_FIELD = $eXHjc.SCALAR_FIELD, $a34698c3f399c0d4$var$STREAM = $eXHjc.STREAM;

var $ljupL = parcelRequire("ljupL");

var $cG3gu = parcelRequire("cG3gu");
var $a34698c3f399c0d4$var$isSuspenseSentinel = $cG3gu.isSuspenseSentinel;

var $j1ZVo = parcelRequire("j1ZVo");

var $8AGUk = parcelRequire("8AGUk");

var $aJi4Y = parcelRequire("aJi4Y");
var $a34698c3f399c0d4$var$CLIENT_EDGE_TRAVERSAL_PATH = $aJi4Y.CLIENT_EDGE_TRAVERSAL_PATH, $a34698c3f399c0d4$var$FRAGMENT_OWNER_KEY = $aJi4Y.FRAGMENT_OWNER_KEY, $a34698c3f399c0d4$var$FRAGMENT_PROP_NAME_KEY = $aJi4Y.FRAGMENT_PROP_NAME_KEY, $a34698c3f399c0d4$var$FRAGMENTS_KEY = $aJi4Y.FRAGMENTS_KEY, $a34698c3f399c0d4$var$ID_KEY = $aJi4Y.ID_KEY, $a34698c3f399c0d4$var$MODULE_COMPONENT_KEY = $aJi4Y.MODULE_COMPONENT_KEY, $a34698c3f399c0d4$var$ROOT_ID = $aJi4Y.ROOT_ID, $a34698c3f399c0d4$var$getArgumentValues = $aJi4Y.getArgumentValues, $a34698c3f399c0d4$var$getModuleComponentKey = $aJi4Y.getModuleComponentKey, $a34698c3f399c0d4$var$getStorageKey = $aJi4Y.getStorageKey;

var $c649G = parcelRequire("c649G");
var $a34698c3f399c0d4$var$NoopResolverCache = $c649G.NoopResolverCache;

var $9xkPb = parcelRequire("9xkPb");
var $a34698c3f399c0d4$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = $9xkPb.RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL, $a34698c3f399c0d4$var$withResolverContext = $9xkPb.withResolverContext;

var $e691y = parcelRequire("e691y");
var $a34698c3f399c0d4$var$generateTypeID = $e691y.generateTypeID;

var $3rEVE = parcelRequire("3rEVE");
function $a34698c3f399c0d4$var$read(recordSource, selector, resolverCache) {
    var reader = new $a34698c3f399c0d4$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $a34698c3f399c0d4$var$NoopResolverCache());
    return reader.read();
}
var $a34698c3f399c0d4$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache) {
        var _selector$clientEdgeT;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $a34698c3f399c0d4$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._missingRequiredFields = null;
        this._errorResponseFields = null;
        this._owner = selector.owner;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._resolverErrors = [];
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            var recordType = $8AGUk.getType(record);
            if (recordType !== node.type && dataID !== $a34698c3f399c0d4$var$ROOT_ID) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
            else if (implementsInterface == null) this._isMissingData = true;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            missingRequiredFields: this._missingRequiredFields,
            relayResolverErrors: this._resolverErrors,
            errorResponseFields: this._errorResponseFields
        };
    };
    _proto._maybeAddErrorResponseFields = function _maybeAddErrorResponseFields(record, storageKey) {
        if (!$ljupL.ENABLE_FIELD_ERROR_HANDLING) return;
        var errors = $8AGUk.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var _iterator = (0, $a34698c3f399c0d4$var$_createForOfIteratorHelper2["default"])(errors), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _error$path;
                var error = _step.value;
                this._errorResponseFields.push({
                    owner: owner,
                    path: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                    error: error
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing() {
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing();
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $3rEVE(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(fieldPath, action) {
        var _this$_missingRequire;
        if (((_this$_missingRequire = this._missingRequiredFields) === null || _this$_missingRequire === void 0 ? void 0 : _this$_missingRequire.action) === 'THROW') return;
        var owner = this._fragmentName;
        switch(action){
            case 'THROW':
                this._missingRequiredFields = {
                    action: action,
                    field: {
                        path: fieldPath,
                        owner: owner
                    }
                };
                return;
            case 'LOG':
                if (this._missingRequiredFields == null) this._missingRequiredFields = {
                    action: action,
                    fields: [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ]
                };
                else this._missingRequiredFields = {
                    action: action,
                    fields: [].concat((0, $a34698c3f399c0d4$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ])
                };
                return;
            default:
                action;
        }
    };
    _proto._handleCatchFieldValue = function _handleCatchFieldValue(selection, record, data, value) {
        var _selection$field$back, _selection$field, _field$alias, _this$_missingRequire2;
        var to = selection.to;
        var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
        var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
        !(fieldName != null) && $3rEVE(false);
        if (this._errorResponseFields != null) for(var i = 0; i < this._errorResponseFields.length; i++)this._errorResponseFields[i].to = to;
        if (((_this$_missingRequire2 = this._missingRequiredFields) === null || _this$_missingRequire2 === void 0 ? void 0 : _this$_missingRequire2.action) === 'THROW') {
            var _this$_missingRequire3;
            if (((_this$_missingRequire3 = this._missingRequiredFields) === null || _this$_missingRequire3 === void 0 ? void 0 : _this$_missingRequire3.field) == null) return;
            if (this._errorResponseFields == null) this._errorResponseFields = [];
            var _this$_missingRequire4 = this._missingRequiredFields.field, owner = _this$_missingRequire4.owner, path = _this$_missingRequire4.path;
            this._errorResponseFields.push({
                owner: owner,
                path: path,
                error: {
                    message: "Relay: Missing @required value at path '".concat(path, "' in '").concat(owner, "'.")
                },
                to: to
            });
            this._missingRequiredFields = null;
            return;
        }
        if (this._errorResponseFields != null) {
            var errors = this._errorResponseFields.map(function(error) {
                return error.error;
            });
            data[fieldName] = {
                ok: false,
                errors: errors
            };
            return;
        }
        data[fieldName] = {
            ok: true,
            value: value
        };
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            var action = selection.action;
            if (action !== 'NONE') this._maybeReportUnexpectedNull(selection.path, action);
            return false;
        }
        return true;
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case $a34698c3f399c0d4$var$REQUIRED_FIELD:
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case $a34698c3f399c0d4$var$CATCH_FIELD:
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if ($ljupL.ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE) {
                        if (selection.to != 'NULL') this._handleCatchFieldValue(selection, record, data, catchFieldValue);
                    }
                    break;
                case $a34698c3f399c0d4$var$SCALAR_FIELD:
                    this._readScalar(selection, record, data);
                    break;
                case $a34698c3f399c0d4$var$LINKED_FIELD:
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case $a34698c3f399c0d4$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case $a34698c3f399c0d4$var$INLINE_FRAGMENT:
                    if (this._readInlineFragment(selection, record, data) === false) return false;
                    break;
                case $a34698c3f399c0d4$var$RELAY_LIVE_RESOLVER:
                case $a34698c3f399c0d4$var$RELAY_RESOLVER:
                    if (!$ljupL.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                    this._readResolverField(selection, record, data);
                    break;
                case $a34698c3f399c0d4$var$FRAGMENT_SPREAD:
                    this._createFragmentPointer(selection, record, data);
                    break;
                case $a34698c3f399c0d4$var$ALIASED_FRAGMENT_SPREAD:
                    data[selection.name] = this._createAliasedFragmentSpread(selection, record);
                    break;
                case $a34698c3f399c0d4$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                    var fieldValue = this._readInlineFragment(selection.fragment, record, {});
                    if (fieldValue === false) fieldValue = null;
                    data[selection.name] = fieldValue;
                    break;
                case $a34698c3f399c0d4$var$MODULE_IMPORT:
                    this._readModuleImport(selection, record, data);
                    break;
                case $a34698c3f399c0d4$var$INLINE_DATA_FRAGMENT_SPREAD:
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case $a34698c3f399c0d4$var$DEFER:
                case $a34698c3f399c0d4$var$CLIENT_EXTENSION:
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData) return false;
                    break;
                case $a34698c3f399c0d4$var$STREAM:
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData2) return false;
                    break;
                case $a34698c3f399c0d4$var$ACTOR_CHANGE:
                    this._readActorChange(selection, record, data);
                    break;
                case $a34698c3f399c0d4$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $a34698c3f399c0d4$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                    this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $3rEVE(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case $a34698c3f399c0d4$var$SCALAR_FIELD:
                return this._readScalar(selection.field, record, data);
            case $a34698c3f399c0d4$var$LINKED_FIELD:
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case $a34698c3f399c0d4$var$RELAY_RESOLVER:
                if (!$ljupL.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $a34698c3f399c0d4$var$RELAY_LIVE_RESOLVER:
                if (!$ljupL.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $a34698c3f399c0d4$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
            case $a34698c3f399c0d4$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                if (!$ljupL.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readClientEdge(selection.field, record, data);
            default:
                selection.field.kind;
                $3rEVE(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $8AGUk.getDataID(record);
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
            snapshot = $a34698c3f399c0d4$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $a34698c3f399c0d4$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $a34698c3f399c0d4$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $a34698c3f399c0d4$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $a34698c3f399c0d4$var$getResolverValue(field, _this._variables, key), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $a34698c3f399c0d4$var$getResolverValue(field, _this._variables, null), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propogateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propogateResolverMetadata = function _propogateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingRequiredFields != null) this._addMissingRequiredFields(cachedSnapshot.missingRequiredFields);
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator2 = (0, $a34698c3f399c0d4$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missing = _step2.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator3 = (0, $a34698c3f399c0d4$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var missingResolverField = _step3.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
            var _iterator4 = (0, $a34698c3f399c0d4$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.relayResolverErrors), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var error = _step4.value;
                    this._resolverErrors.push(error);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) this._resolverErrors.push({
            field: {
                path: fieldPath,
                owner: this._fragmentName
            },
            error: resolverError
        });
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push({
                path: "".concat(this._fragmentName, ".").concat(fieldPath),
                liveStateID: suspenseID
            });
        }
        if (updatedDataIDs != null) {
            var _iterator5 = (0, $a34698c3f399c0d4$var$_createForOfIteratorHelper2["default"])(updatedDataIDs), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var recordID = _step5.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this2 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $3rEVE(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $a34698c3f399c0d4$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $3rEVE(false);
            var storeIDs;
            !(field.kind === $a34698c3f399c0d4$var$CLIENT_EDGE_TO_CLIENT_OBJECT) && $3rEVE(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $3rEVE(false);
                var localId = $a34698c3f399c0d4$var$extractIdFromResponse(itemResponse);
                var id = _this2._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $3rEVE(false);
                    var model = _this2._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map($a34698c3f399c0d4$var$extractIdFromResponse);
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $a34698c3f399c0d4$var$extractIdFromResponse(clientEdgeResolverResponse);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === $a34698c3f399c0d4$var$CLIENT_EDGE_TO_CLIENT_OBJECT) {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $3rEVE(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $3rEVE(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $3rEVE(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $3rEVE(false);
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $a34698c3f399c0d4$var$getStorageKey(field, this._variables);
        var value = $8AGUk.getValue(record, storageKey);
        if (value === null) this._maybeAddErrorResponseFields(record, storageKey);
        else if (value === undefined) this._markDataAsMissing();
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $a34698c3f399c0d4$var$getStorageKey(field, this._variables);
        var linkedID = $8AGUk.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddErrorResponseFields(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing();
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $3rEVE(false);
        var value = this._traverse(field, linkedID, prevData);
        data[fieldName] = value;
        return value;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $a34698c3f399c0d4$var$getStorageKey(field, this._variables);
        var externalRef = $8AGUk.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing();
            else if (externalRef === null) this._maybeAddErrorResponseFields(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $8AGUk.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $a34698c3f399c0d4$var$getStorageKey(field, this._variables);
        var linkedIDs = $8AGUk.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null) this._maybeAddErrorResponseFields(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this3 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing();
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $3rEVE(false);
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this3._markDataAsMissing();
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $3rEVE(false);
            linkedArray[nextIndex] = _this3._traverse(field, linkedID, prevItem);
        });
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $a34698c3f399c0d4$var$getModuleComponentKey(moduleImport.documentName);
        var component = $8AGUk.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing();
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$a34698c3f399c0d4$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$a34698c3f399c0d4$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._createAliasedFragmentSpread = function _createAliasedFragmentSpread(namedFragmentSpread, record) {
        var abstractKey = namedFragmentSpread.abstractKey;
        if (abstractKey == null) {
            var typeName = $8AGUk.getType(record);
            if (typeName == null || typeName !== namedFragmentSpread.type) return null;
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) return null;
            else if (implementsInterface == null) {
                this._markDataAsMissing();
                return undefined;
            }
        }
        var fieldData = {};
        this._createFragmentPointer(namedFragmentSpread.fragment, record, fieldData);
        return $8AGUk.fromObject(fieldData);
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            var typeName = $8AGUk.getType(record);
            if (typeName == null || typeName !== inlineFragment.type) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return undefined;
            } else if (implementsInterface == null) {
                this._markDataAsMissing();
                return null;
            }
        }
        return data;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$a34698c3f399c0d4$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$a34698c3f399c0d4$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $3rEVE(false);
        if (data[$a34698c3f399c0d4$var$ID_KEY] == null) data[$a34698c3f399c0d4$var$ID_KEY] = $8AGUk.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $a34698c3f399c0d4$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$a34698c3f399c0d4$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$a34698c3f399c0d4$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $a34698c3f399c0d4$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$a34698c3f399c0d4$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$a34698c3f399c0d4$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $3rEVE(false);
        if (data[$a34698c3f399c0d4$var$ID_KEY] == null) data[$a34698c3f399c0d4$var$ID_KEY] = $8AGUk.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $a34698c3f399c0d4$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $j1ZVo.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._addMissingRequiredFields = function _addMissingRequiredFields(additional) {
        if (this._missingRequiredFields == null) {
            this._missingRequiredFields = additional;
            return;
        }
        if (this._missingRequiredFields.action === 'THROW') return;
        if (additional.action === 'THROW') {
            this._missingRequiredFields = additional;
            return;
        }
        this._missingRequiredFields = {
            action: 'LOG',
            fields: [].concat((0, $a34698c3f399c0d4$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), (0, $a34698c3f399c0d4$var$_toConsumableArray2["default"])(additional.fields))
        };
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $8AGUk.getType(record);
        var typeRecord = this._recordSource.get($a34698c3f399c0d4$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $8AGUk.getValue(typeRecord, abstractKey) : null;
        return implementsInterface;
    };
    return RelayReader;
}();
function $a34698c3f399c0d4$var$getResolverValue(field, variables, fragmentKey) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $a34698c3f399c0d4$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        if (e === $a34698c3f399c0d4$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL) resolverResult = undefined;
        else resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $a34698c3f399c0d4$var$extractIdFromResponse(individualResponse) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $3rEVE(false);
}
module.exports = {
    read: $a34698c3f399c0d4$var$read
};

});
parcelRegister("c649G", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $8ce944baa6259dd5$var$_interopRequireDefault = $dw9g1.default;

var $8ce944baa6259dd5$var$_createForOfIteratorHelper2 = $8ce944baa6259dd5$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $kD8cH = parcelRequire("kD8cH");

var $eXHjc = parcelRequire("eXHjc");
var $8ce944baa6259dd5$var$RELAY_LIVE_RESOLVER = $eXHjc.RELAY_LIVE_RESOLVER;

var $ljupL = parcelRequire("ljupL");

var $dF318 = parcelRequire("dF318");

var $3vT9g = parcelRequire("3vT9g");
var $8ce944baa6259dd5$var$generateClientID = $3vT9g.generateClientID;

var $8AGUk = parcelRequire("8AGUk");

var $aJi4Y = parcelRequire("aJi4Y");
var $8ce944baa6259dd5$var$RELAY_RESOLVER_ERROR_KEY = $aJi4Y.RELAY_RESOLVER_ERROR_KEY, $8ce944baa6259dd5$var$RELAY_RESOLVER_INVALIDATION_KEY = $aJi4Y.RELAY_RESOLVER_INVALIDATION_KEY, $8ce944baa6259dd5$var$RELAY_RESOLVER_SNAPSHOT_KEY = $aJi4Y.RELAY_RESOLVER_SNAPSHOT_KEY, $8ce944baa6259dd5$var$RELAY_RESOLVER_VALUE_KEY = $aJi4Y.RELAY_RESOLVER_VALUE_KEY, $8ce944baa6259dd5$var$getStorageKey = $aJi4Y.getStorageKey;

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
var $8ce944baa6259dd5$var$emptySet = new Set();
var $8ce944baa6259dd5$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $8ce944baa6259dd5$var$RELAY_LIVE_RESOLVER) && $3rEVE(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $3rEVE(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
function $8ce944baa6259dd5$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $8ce944baa6259dd5$var$RecordResolverCache = /*#__PURE__*/ function() {
    function RecordResolverCache(getRecordSource) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
    }
    var _proto2 = RecordResolverCache.prototype;
    _proto2.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = recordSource.get(recordID);
        !(record != null) && $3rEVE(false);
        var storageKey = $8ce944baa6259dd5$var$getStorageKey(field, variables);
        var linkedID = $8AGUk.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $8ce944baa6259dd5$var$generateClientID(recordID, storageKey);
            linkedRecord = $8AGUk.create(linkedID, '__RELAY_RESOLVER__');
            var evaluationResult = evaluate();
            $dF318(evaluationResult.resolverResult);
            $8AGUk.setValue(linkedRecord, $8ce944baa6259dd5$var$RELAY_RESOLVER_VALUE_KEY, evaluationResult.resolverResult);
            $8AGUk.setValue(linkedRecord, $8ce944baa6259dd5$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $8AGUk.setValue(linkedRecord, $8ce944baa6259dd5$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = recordSource.get(recordID);
            !(currentRecord != null) && $3rEVE(false);
            var nextRecord = $8AGUk.clone(currentRecord);
            $8AGUk.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna;
                var fragmentStorageKey = $8ce944baa6259dd5$var$getStorageKey(field.fragment, variables);
                var resolverID = $8ce944baa6259dd5$var$generateClientID(recordID, fragmentStorageKey);
                $8ce944baa6259dd5$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $8ce944baa6259dd5$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna = evaluationResult.snapshot) === null || _evaluationResult$sna === void 0 ? void 0 : _evaluationResult$sna.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $8ce944baa6259dd5$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $8ce944baa6259dd5$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        }
        var answer = $8AGUk.getValue(linkedRecord, $8ce944baa6259dd5$var$RELAY_RESOLVER_VALUE_KEY);
        var snapshot = $8AGUk.getValue(linkedRecord, $8ce944baa6259dd5$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $8AGUk.getValue(linkedRecord, $8ce944baa6259dd5$var$RELAY_RESOLVER_ERROR_KEY);
        return [
            answer,
            linkedID,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto2.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var _iterator2 = (0, $8ce944baa6259dd5$var$_createForOfIteratorHelper2["default"])((_this$_recordIDToReso = this._recordIDToResolverIDs.get(recordID)) !== null && _this$_recordIDToReso !== void 0 ? _this$_recordIDToReso : $8ce944baa6259dd5$var$emptySet), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _this$_recordIDToReso;
                    var fragment = _step2.value;
                    if (!visited.has(fragment)) {
                        var _iterator3 = (0, $8ce944baa6259dd5$var$_createForOfIteratorHelper2["default"])((_this$_resolverIDToRe = this._resolverIDToRecordIDs.get(fragment)) !== null && _this$_resolverIDToRe !== void 0 ? _this$_resolverIDToRe : $8ce944baa6259dd5$var$emptySet), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var _this$_resolverIDToRe;
                                var anotherRecordID = _step3.value;
                                this._markInvalidatedResolverRecord(anotherRecordID, recordSource, updatedDataIDs);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    };
    _proto2._markInvalidatedResolverRecord = function _markInvalidatedResolverRecord(dataID, recordSource, updatedDataIDs) {
        var record = recordSource.get(dataID);
        if (!record) return;
        var nextRecord = $8AGUk.clone(record);
        $8AGUk.setValue(nextRecord, $8ce944baa6259dd5$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
        recordSource.set(dataID, nextRecord);
    };
    _proto2._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$8AGUk.getValue(record, $8ce944baa6259dd5$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $8AGUk.getValue(record, $8ce944baa6259dd5$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $kD8cH(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($ljupL.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $8AGUk.clone(record);
            $8AGUk.setValue(nextRecord, $8ce944baa6259dd5$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($8AGUk.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto2.ensureClientRecord = function ensureClientRecord(id, typename) {
        $3rEVE(false);
    };
    _proto2.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        $3rEVE(false);
    };
    return RecordResolverCache;
}();
module.exports = {
    NoopResolverCache: $8ce944baa6259dd5$var$NoopResolverCache,
    RecordResolverCache: $8ce944baa6259dd5$var$RecordResolverCache
};

});
parcelRegister("dF318", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});


parcelRegister("9xkPb", function(module, exports) {
'use strict';

var $2yJ7U = parcelRequire("2yJ7U");
var $6f17597609bcef19$var$getFragment = $2yJ7U.getFragment;

var $cKnH2 = parcelRequire("cKnH2");
var $6f17597609bcef19$var$getSelector = $cKnH2.getSelector;

var $3rEVE = parcelRequire("3rEVE");
var $6f17597609bcef19$var$contextStack = [];
function $6f17597609bcef19$var$withResolverContext(context, cb) {
    $6f17597609bcef19$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $6f17597609bcef19$var$contextStack.pop();
    }
}
function $6f17597609bcef19$var$readFragment(fragmentInput, fragmentKey) {
    if (!$6f17597609bcef19$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $6f17597609bcef19$var$contextStack[$6f17597609bcef19$var$contextStack.length - 1];
    var fragmentNode = $6f17597609bcef19$var$getFragment(fragmentInput);
    var fragmentSelector = $6f17597609bcef19$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $3rEVE(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $3rEVE(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData;
    if (isMissingData) throw $6f17597609bcef19$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL;
    return data;
}
var $6f17597609bcef19$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = {};
module.exports = {
    readFragment: $6f17597609bcef19$var$readFragment,
    withResolverContext: $6f17597609bcef19$var$withResolverContext,
    RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL: $6f17597609bcef19$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL
};

});




parcelRegister("1lIVB", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $0fba9a656e3aa91a$var$_interopRequireDefault = $dw9g1.default;

var $0fba9a656e3aa91a$var$_createForOfIteratorHelper2 = $0fba9a656e3aa91a$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $0fba9a656e3aa91a$var$_defineProperty2 = $0fba9a656e3aa91a$var$_interopRequireDefault((parcelRequire("cO17m")));

var $8T3Ai = parcelRequire("8T3Ai");
var $0fba9a656e3aa91a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $8T3Ai.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $0fba9a656e3aa91a$var$assertInternalActorIdentifier = $8T3Ai.assertInternalActorIdentifier;
parcelRequire("6NDOU");

var $ljupL = parcelRequire("ljupL");

var $hdTum = parcelRequire("hdTum");

var $ikAsR = parcelRequire("ikAsR");

var $bidvu = parcelRequire("bidvu");

var $8AGUk = parcelRequire("8AGUk");

var $aH8bB = parcelRequire("aH8bB");

var $e170H = parcelRequire("e170H");

var $7HU3A = parcelRequire("7HU3A");

var $cIeRV = parcelRequire("cIeRV");

var $aJi4Y = parcelRequire("aJi4Y");

var $aJi4Y = parcelRequire("aJi4Y");
var $0fba9a656e3aa91a$var$ROOT_ID = $aJi4Y.ROOT_ID, $0fba9a656e3aa91a$var$ROOT_TYPE = $aJi4Y.ROOT_TYPE;

var $c649G = parcelRequire("c649G");
var $0fba9a656e3aa91a$var$RecordResolverCache = $c649G.RecordResolverCache;

var $3rEVE = parcelRequire("3rEVE");
var $0fba9a656e3aa91a$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $0fba9a656e3aa91a$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa;
        (0, $0fba9a656e3aa91a$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $0fba9a656e3aa91a$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $hdTum;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $bidvu;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $0fba9a656e3aa91a$var$RecordResolverCache(function() {
            return _this._getMutableRecordSource();
        });
        this._storeSubscriptions = new $cIeRV(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents;
        $0fba9a656e3aa91a$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $0fba9a656e3aa91a$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $0fba9a656e3aa91a$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $ikAsR.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $0fba9a656e3aa91a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $0fba9a656e3aa91a$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $e170H.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        if ($ljupL.ENABLE_RELAY_RESOLVERS) this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $0fba9a656e3aa91a$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $8AGUk.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $0fba9a656e3aa91a$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $3rEVE(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $aH8bB.create(this.getSource());
    };
    _proto.restore = function restore() {
        !(this._optimisticSource != null) && $3rEVE(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $0fba9a656e3aa91a$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $7HU3A.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) this._recordSource.remove(dataID);
                }
            }
            return;
        }
    };
    return RelayModernStore;
}();
function $0fba9a656e3aa91a$var$initializeRecordSource(target) {
    if (!target.has($0fba9a656e3aa91a$var$ROOT_ID)) {
        var rootRecord = $8AGUk.create($0fba9a656e3aa91a$var$ROOT_ID, $0fba9a656e3aa91a$var$ROOT_TYPE);
        target.set($0fba9a656e3aa91a$var$ROOT_ID, rootRecord);
    }
}
function $0fba9a656e3aa91a$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $8AGUk.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $8AGUk.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $8AGUk.setValue(nextRecord, $aJi4Y.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $8AGUk.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $0fba9a656e3aa91a$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $0fba9a656e3aa91a$var$RelayModernStore;

});
parcelRegister("hdTum", function(module, exports) {
'use strict';
var $c89eb178745082d5$var$resolvedPromise = Promise.resolve();
function $c89eb178745082d5$var$resolveImmediate(callback) {
    $c89eb178745082d5$var$resolvedPromise.then(callback)["catch"]($c89eb178745082d5$var$throwNext);
}
function $c89eb178745082d5$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $c89eb178745082d5$var$resolveImmediate;

});

parcelRegister("ikAsR", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $d5866156ac3ed9d0$var$_interopRequireDefault = $dw9g1.default;

var $d5866156ac3ed9d0$var$_createForOfIteratorHelper2 = $d5866156ac3ed9d0$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $aDzr3 = parcelRequire("aDzr3");

var $8jf5f = parcelRequire("8jf5f");

var $fZZs3 = parcelRequire("fZZs3");

var $eXHjc = parcelRequire("eXHjc");

var $3vT9g = parcelRequire("3vT9g");
var $d5866156ac3ed9d0$var$isClientID = $3vT9g.isClientID;

var $eNjeA = parcelRequire("eNjeA");

var $fXdGz = parcelRequire("fXdGz");

var $j1ZVo = parcelRequire("j1ZVo");
var $d5866156ac3ed9d0$var$getLocalVariables = $j1ZVo.getLocalVariables;

var $8AGUk = parcelRequire("8AGUk");

var $cl6lV = parcelRequire("cl6lV");
var $d5866156ac3ed9d0$var$EXISTENT = $cl6lV.EXISTENT, $d5866156ac3ed9d0$var$UNKNOWN = $cl6lV.UNKNOWN;

var $aJi4Y = parcelRequire("aJi4Y");

var $e691y = parcelRequire("e691y");
var $d5866156ac3ed9d0$var$TYPE_SCHEMA_TYPE = $e691y.TYPE_SCHEMA_TYPE, $d5866156ac3ed9d0$var$generateTypeID = $e691y.generateTypeID;

var $3rEVE = parcelRequire("3rEVE");
var $d5866156ac3ed9d0$var$ACTOR_CHANGE = $eXHjc.ACTOR_CHANGE, $d5866156ac3ed9d0$var$CONDITION = $eXHjc.CONDITION, $d5866156ac3ed9d0$var$CLIENT_COMPONENT = $eXHjc.CLIENT_COMPONENT, $d5866156ac3ed9d0$var$CLIENT_EXTENSION = $eXHjc.CLIENT_EXTENSION, $d5866156ac3ed9d0$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $eXHjc.CLIENT_EDGE_TO_CLIENT_OBJECT, $d5866156ac3ed9d0$var$DEFER = $eXHjc.DEFER, $d5866156ac3ed9d0$var$FRAGMENT_SPREAD = $eXHjc.FRAGMENT_SPREAD, $d5866156ac3ed9d0$var$INLINE_FRAGMENT = $eXHjc.INLINE_FRAGMENT, $d5866156ac3ed9d0$var$LINKED_FIELD = $eXHjc.LINKED_FIELD, $d5866156ac3ed9d0$var$LINKED_HANDLE = $eXHjc.LINKED_HANDLE, $d5866156ac3ed9d0$var$MODULE_IMPORT = $eXHjc.MODULE_IMPORT, $d5866156ac3ed9d0$var$RELAY_RESOLVER = $eXHjc.RELAY_RESOLVER, $d5866156ac3ed9d0$var$RELAY_LIVE_RESOLVER = $eXHjc.RELAY_LIVE_RESOLVER, $d5866156ac3ed9d0$var$SCALAR_FIELD = $eXHjc.SCALAR_FIELD, $d5866156ac3ed9d0$var$SCALAR_HANDLE = $eXHjc.SCALAR_HANDLE, $d5866156ac3ed9d0$var$STREAM = $eXHjc.STREAM, $d5866156ac3ed9d0$var$TYPE_DISCRIMINATOR = $eXHjc.TYPE_DISCRIMINATOR;
var $d5866156ac3ed9d0$var$getModuleOperationKey = $aJi4Y.getModuleOperationKey, $d5866156ac3ed9d0$var$getStorageKey = $aJi4Y.getStorageKey, $d5866156ac3ed9d0$var$getArgumentValues = $aJi4Y.getArgumentValues;
function $d5866156ac3ed9d0$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $d5866156ac3ed9d0$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    return checker.check(node, dataID);
}
var $d5866156ac3ed9d0$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $aDzr3(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $8jf5f(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $3rEVE(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $d5866156ac3ed9d0$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $d5866156ac3ed9d0$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $d5866156ac3ed9d0$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $d5866156ac3ed9d0$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $d5866156ac3ed9d0$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $d5866156ac3ed9d0$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $d5866156ac3ed9d0$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $d5866156ac3ed9d0$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $d5866156ac3ed9d0$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $d5866156ac3ed9d0$var$UNKNOWN) this._handleMissing();
        if (status === $d5866156ac3ed9d0$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $8AGUk.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $d5866156ac3ed9d0$var$SCALAR_FIELD:
                    _this2._checkScalar(selection, dataID);
                    break;
                case $d5866156ac3ed9d0$var$LINKED_FIELD:
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case $d5866156ac3ed9d0$var$ACTOR_CHANGE:
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case $d5866156ac3ed9d0$var$CONDITION:
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $d5866156ac3ed9d0$var$INLINE_FRAGMENT:
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $3rEVE(false);
                        var _typeID = $d5866156ac3ed9d0$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case $d5866156ac3ed9d0$var$LINKED_HANDLE:
                    var handleField = $eNjeA(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case $d5866156ac3ed9d0$var$SCALAR_HANDLE:
                    var _handleField = $fXdGz(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case $d5866156ac3ed9d0$var$MODULE_IMPORT:
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case $d5866156ac3ed9d0$var$DEFER:
                case $d5866156ac3ed9d0$var$STREAM:
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $d5866156ac3ed9d0$var$FRAGMENT_SPREAD:
                    var prevVariables = _this2._variables;
                    _this2._variables = $d5866156ac3ed9d0$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case $d5866156ac3ed9d0$var$CLIENT_EXTENSION:
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case $d5866156ac3ed9d0$var$TYPE_DISCRIMINATOR:
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $3rEVE(false);
                    var typeID = $d5866156ac3ed9d0$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case $d5866156ac3ed9d0$var$CLIENT_COMPONENT:
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case $d5866156ac3ed9d0$var$RELAY_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $d5866156ac3ed9d0$var$RELAY_LIVE_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $d5866156ac3ed9d0$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $3rEVE(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $3rEVE(false);
        var operationKey = $d5866156ac3ed9d0$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $fZZs3(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $d5866156ac3ed9d0$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $d5866156ac3ed9d0$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $d5866156ac3ed9d0$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $d5866156ac3ed9d0$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $d5866156ac3ed9d0$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $8AGUk.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $d5866156ac3ed9d0$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $d5866156ac3ed9d0$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $d5866156ac3ed9d0$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $d5866156ac3ed9d0$var$check
};

});
parcelRegister("eNjeA", function(module, exports) {
'use strict';

var $eXHjc = parcelRequire("eXHjc");
var $ac548fd4558c2550$var$LINKED_FIELD = $eXHjc.LINKED_FIELD;

var $aJi4Y = parcelRequire("aJi4Y");
var $ac548fd4558c2550$var$getHandleStorageKey = $aJi4Y.getHandleStorageKey;

var $kgHsa = parcelRequire("kgHsa");

var $3rEVE = parcelRequire("3rEVE");
function $ac548fd4558c2550$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $ac548fd4558c2550$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $kgHsa(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $ac548fd4558c2550$var$LINKED_FIELD) && $3rEVE(false);
    var handleKey = $ac548fd4558c2550$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $ac548fd4558c2550$var$cloneRelayHandleSourceField;

});

parcelRegister("fXdGz", function(module, exports) {
'use strict';

var $eXHjc = parcelRequire("eXHjc");
var $b9d6fb5cfd6c4514$var$SCALAR_FIELD = $eXHjc.SCALAR_FIELD;

var $aJi4Y = parcelRequire("aJi4Y");
var $b9d6fb5cfd6c4514$var$getHandleStorageKey = $aJi4Y.getHandleStorageKey;

var $kgHsa = parcelRequire("kgHsa");

var $3rEVE = parcelRequire("3rEVE");
function $b9d6fb5cfd6c4514$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $b9d6fb5cfd6c4514$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $kgHsa(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $b9d6fb5cfd6c4514$var$SCALAR_FIELD) && $3rEVE(false);
    var handleKey = $b9d6fb5cfd6c4514$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $b9d6fb5cfd6c4514$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("aH8bB", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $7c944520914e52df$var$_interopRequireDefault = $dw9g1.default;

var $7c944520914e52df$var$_objectSpread2 = $7c944520914e52df$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $8AGUk = parcelRequire("8AGUk");

var $kLaEL = parcelRequire("kLaEL");

var $3rEVE = parcelRequire("3rEVE");
var $7c944520914e52df$var$UNPUBLISH_RECORD_SENTINEL = $8AGUk.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $7c944520914e52df$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $kLaEL.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $7c944520914e52df$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $7c944520914e52df$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $kLaEL.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $7c944520914e52df$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $7c944520914e52df$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $8AGUk.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $7c944520914e52df$var$create(base) {
    return new $7c944520914e52df$var$RelayOptimisticRecordSource(base);
}
function $7c944520914e52df$var$getOptimisticRecordIDs(source) {
    !(source instanceof $7c944520914e52df$var$RelayOptimisticRecordSource) && $3rEVE(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $7c944520914e52df$var$create,
    getOptimisticRecordIDs: $7c944520914e52df$var$getOptimisticRecordIDs
};

});

parcelRegister("7HU3A", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $59c808440d660902$var$_interopRequireDefault = $dw9g1.default;

var $59c808440d660902$var$_createForOfIteratorHelper2 = $59c808440d660902$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $fZZs3 = parcelRequire("fZZs3");

var $eXHjc = parcelRequire("eXHjc");

var $eNjeA = parcelRequire("eNjeA");

var $aTdXk = parcelRequire("aTdXk");

var $j1ZVo = parcelRequire("j1ZVo");
var $59c808440d660902$var$getLocalVariables = $j1ZVo.getLocalVariables;

var $8AGUk = parcelRequire("8AGUk");

var $aJi4Y = parcelRequire("aJi4Y");

var $e691y = parcelRequire("e691y");
var $59c808440d660902$var$generateTypeID = $e691y.generateTypeID;

var $3rEVE = parcelRequire("3rEVE");
var $59c808440d660902$var$ACTOR_CHANGE = $eXHjc.ACTOR_CHANGE, $59c808440d660902$var$CONDITION = $eXHjc.CONDITION, $59c808440d660902$var$CLIENT_COMPONENT = $eXHjc.CLIENT_COMPONENT, $59c808440d660902$var$CLIENT_EXTENSION = $eXHjc.CLIENT_EXTENSION, $59c808440d660902$var$DEFER = $eXHjc.DEFER, $59c808440d660902$var$FRAGMENT_SPREAD = $eXHjc.FRAGMENT_SPREAD, $59c808440d660902$var$INLINE_FRAGMENT = $eXHjc.INLINE_FRAGMENT, $59c808440d660902$var$LINKED_FIELD = $eXHjc.LINKED_FIELD, $59c808440d660902$var$MODULE_IMPORT = $eXHjc.MODULE_IMPORT, $59c808440d660902$var$LINKED_HANDLE = $eXHjc.LINKED_HANDLE, $59c808440d660902$var$SCALAR_FIELD = $eXHjc.SCALAR_FIELD, $59c808440d660902$var$SCALAR_HANDLE = $eXHjc.SCALAR_HANDLE, $59c808440d660902$var$STREAM = $eXHjc.STREAM, $59c808440d660902$var$TYPE_DISCRIMINATOR = $eXHjc.TYPE_DISCRIMINATOR, $59c808440d660902$var$RELAY_RESOLVER = $eXHjc.RELAY_RESOLVER, $59c808440d660902$var$RELAY_LIVE_RESOLVER = $eXHjc.RELAY_LIVE_RESOLVER, $59c808440d660902$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $eXHjc.CLIENT_EDGE_TO_CLIENT_OBJECT;
var $59c808440d660902$var$getStorageKey = $aJi4Y.getStorageKey, $59c808440d660902$var$getModuleOperationKey = $aJi4Y.getModuleOperationKey;
function $59c808440d660902$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $59c808440d660902$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
var $59c808440d660902$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $3rEVE(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $59c808440d660902$var$ACTOR_CHANGE:
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case $59c808440d660902$var$LINKED_FIELD:
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case $59c808440d660902$var$CONDITION:
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case $59c808440d660902$var$INLINE_FRAGMENT:
                    if (selection.abstractKey == null) {
                        var typeName = $8AGUk.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $aJi4Y.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $8AGUk.getType(record);
                        var typeID = $59c808440d660902$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case $59c808440d660902$var$FRAGMENT_SPREAD:
                    var prevVariables = _this._variables;
                    _this._variables = $59c808440d660902$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case $59c808440d660902$var$LINKED_HANDLE:
                    var handleField = $eNjeA(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case $59c808440d660902$var$DEFER:
                case $59c808440d660902$var$STREAM:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $59c808440d660902$var$SCALAR_FIELD:
                case $59c808440d660902$var$SCALAR_HANDLE:
                    break;
                case $59c808440d660902$var$TYPE_DISCRIMINATOR:
                    var _typeName2 = $8AGUk.getType(record);
                    var _typeID = $59c808440d660902$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case $59c808440d660902$var$MODULE_IMPORT:
                    _this._traverseModuleImport(selection, record);
                    break;
                case $59c808440d660902$var$CLIENT_EXTENSION:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $59c808440d660902$var$CLIENT_COMPONENT:
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case $59c808440d660902$var$RELAY_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $59c808440d660902$var$RELAY_LIVE_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $59c808440d660902$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $3rEVE(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $aTdXk(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $59c808440d660902$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $8AGUk.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $59c808440d660902$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $8AGUk.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = $59c808440d660902$var$getStorageKey(field, this._variables);
        var dataID = $8AGUk.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $3rEVE(false);
        var operationKey = $59c808440d660902$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $8AGUk.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $fZZs3(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $59c808440d660902$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $59c808440d660902$var$getStorageKey(field, this._variables);
        var linkedID = $8AGUk.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $59c808440d660902$var$getStorageKey(field, this._variables);
        var linkedIDs = $8AGUk.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $59c808440d660902$var$mark
};

});
parcelRegister("aTdXk", function(module, exports) {
'use strict';

var $8AGUk = parcelRequire("8AGUk");

var $aJi4Y = parcelRequire("aJi4Y");
var $7ed9ddc571be824c$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $aJi4Y.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $3rEVE = parcelRequire("3rEVE");
function $7ed9ddc571be824c$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $8AGUk.getValue(record, $7ed9ddc571be824c$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $3rEVE(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $7ed9ddc571be824c$var$getOutputTypeRecordIDs;

});


parcelRegister("cIeRV", function(module, exports) {
'use strict';
parcelRequire("6NDOU");

var $kD8cH = parcelRequire("kD8cH");

var $ljupL = parcelRequire("ljupL");

var $f72Pt = parcelRequire("f72Pt");

var $iwPa8 = parcelRequire("iwPa8");

var $e170H = parcelRequire("e170H");
var $941520b3199d4fe0$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $e170H.read(source, snapshot.selector, _this2._resolverCache);
            var nextData = $kD8cH(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    missingRequiredFields: backup.missingRequiredFields,
                    relayResolverErrors: backup.relayResolverErrors,
                    errorResponseFields: backup.errorResponseFields
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $f72Pt(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $e170H.read(source, snapshot.selector, this._resolverCache) : backup;
        var nextData = $kD8cH(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            missingRequiredFields: nextSnapshot.missingRequiredFields,
            relayResolverErrors: nextSnapshot.relayResolverErrors,
            errorResponseFields: nextSnapshot.errorResponseFields
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $ljupL.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($ljupL.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $iwPa8(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $941520b3199d4fe0$var$RelayStoreSubscriptions;

});
parcelRegister("f72Pt", function(module, exports) {
'use strict';
var $b009b44952e411a9$var$ITERATOR_KEY = Symbol.iterator;
function $b009b44952e411a9$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$b009b44952e411a9$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $b009b44952e411a9$var$hasOverlappingIDs;

});

parcelRegister("iwPa8", function(module, exports) {
'use strict';

var $aJi4Y = parcelRequire("aJi4Y");
var $d7d2e6f0f58aede6$var$ROOT_ID = $aJi4Y.ROOT_ID;

var $51AJZ = parcelRequire("51AJZ");
var $d7d2e6f0f58aede6$var$VIEWER_ID = $51AJZ.VIEWER_ID;
var $d7d2e6f0f58aede6$var$ITERATOR_KEY = Symbol.iterator;
function $d7d2e6f0f58aede6$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$d7d2e6f0f58aede6$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $d7d2e6f0f58aede6$var$ROOT_ID && key !== $d7d2e6f0f58aede6$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $d7d2e6f0f58aede6$var$hasSignificantOverlappingIDs;

});



parcelRegister("2dGDG", function(module, exports) {
'use strict';

var $fhrrS = parcelRequire("fhrrS");

var $2yJ7U = parcelRequire("2yJ7U");
var $19dddedf698b0c8b$var$getRequest = $2yJ7U.getRequest;

var $dqEgB = parcelRequire("dqEgB");
var $19dddedf698b0c8b$var$createOperationDescriptor = $dqEgB.createOperationDescriptor;

var $cKnH2 = parcelRequire("cKnH2");
var $19dddedf698b0c8b$var$createReaderSelector = $cKnH2.createReaderSelector;
parcelRequire("l1Dol");
function $19dddedf698b0c8b$var$requestSubscription(environment, config) {
    var subscription = $19dddedf698b0c8b$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $19dddedf698b0c8b$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $fhrrS.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $19dddedf698b0c8b$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $19dddedf698b0c8b$var$requestSubscription;

});

parcelRegister("kZml9", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $f47ad56e05921036$var$_interopRequireDefault = $dw9g1.default;

var $f47ad56e05921036$var$_objectSpread2 = $f47ad56e05921036$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $aJi4Y = parcelRequire("aJi4Y");
var $f47ad56e05921036$var$getModuleComponentKey = $aJi4Y.getModuleComponentKey, $f47ad56e05921036$var$getModuleOperationKey = $aJi4Y.getModuleOperationKey;
function $f47ad56e05921036$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $f47ad56e05921036$var$_objectSpread2["default"])({}, response);
    data[$f47ad56e05921036$var$getModuleComponentKey(name)] = component;
    data[$f47ad56e05921036$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $f47ad56e05921036$var$createPayloadFor3DField;

});

parcelRegister("5O54S", function(module, exports) {
'use strict';

var $cKnH2 = parcelRequire("cKnH2");
var $43a58f9830b37fb6$var$getDataIDsFromFragment = $cKnH2.getDataIDsFromFragment, $43a58f9830b37fb6$var$getSelector = $cKnH2.getSelector, $43a58f9830b37fb6$var$getVariablesFromFragment = $cKnH2.getVariablesFromFragment;

var $4E0s7 = parcelRequire("4E0s7");

var $ljupL = parcelRequire("ljupL");

var $kTvRX = parcelRequire("kTvRX");

var $9KYrX = parcelRequire("9KYrX");
var $43a58f9830b37fb6$var$intern = $9KYrX.intern;
function $43a58f9830b37fb6$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $43a58f9830b37fb6$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $43a58f9830b37fb6$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $43a58f9830b37fb6$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($ljupL.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $ljupL.STRING_INTERN_LEVEL <= 1 ? ids : $43a58f9830b37fb6$var$intern(ids, $ljupL.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $4E0s7(fragmentVariables) ? '{}' : JSON.stringify($kTvRX(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $ljupL.STRING_INTERN_LEVEL <= 1 ? _ids : $43a58f9830b37fb6$var$intern(_ids, $ljupL.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($kTvRX(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $43a58f9830b37fb6$var$getFragmentIdentifier;

});
parcelRegister("4E0s7", function(module, exports) {
'use strict';
var $361b3fb5d1d24913$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $361b3fb5d1d24913$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($361b3fb5d1d24913$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $361b3fb5d1d24913$var$isEmptyObject;

});


parcelRegister("ajvHf", function(module, exports) {
'use strict';

var $ioCp5 = parcelRequire("ioCp5");

var $3rEVE = parcelRequire("3rEVE");
function $782443ffccdd817e$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $ioCp5(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $3rEVE(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $3rEVE(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $3rEVE(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $782443ffccdd817e$var$getPaginationMetadata;

});
parcelRegister("ioCp5", function(module, exports) {
'use strict';

var $3rEVE = parcelRequire("3rEVE");
function $d6484206e4b36fc9$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $3rEVE(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $3rEVE(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $3rEVE(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $3rEVE(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $3rEVE(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $d6484206e4b36fc9$var$getRefetchMetadata;

});


parcelRegister("8qEbl", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $622febbd6af0d71c$var$_interopRequireDefault = $dw9g1.default;

var $622febbd6af0d71c$var$_defineProperty2 = $622febbd6af0d71c$var$_interopRequireDefault((parcelRequire("cO17m")));

var $622febbd6af0d71c$var$_objectSpread4 = $622febbd6af0d71c$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
function $622febbd6af0d71c$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $3rEVE(false);
        var _paginationVariables = (0, $622febbd6af0d71c$var$_objectSpread4["default"])((0, $622febbd6af0d71c$var$_objectSpread4["default"])((0, $622febbd6af0d71c$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $622febbd6af0d71c$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $622febbd6af0d71c$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $3rEVE(false);
    var paginationVariables = (0, $622febbd6af0d71c$var$_objectSpread4["default"])((0, $622febbd6af0d71c$var$_objectSpread4["default"])((0, $622febbd6af0d71c$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $622febbd6af0d71c$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $622febbd6af0d71c$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $622febbd6af0d71c$var$getPaginationVariables;

});

parcelRegister("cM5Il", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $94ce66791940e5fd$var$_interopRequireDefault = $dw9g1.default;

var $94ce66791940e5fd$var$_createForOfIteratorHelper2 = $94ce66791940e5fd$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $3rEVE = parcelRequire("3rEVE");
function $94ce66791940e5fd$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $94ce66791940e5fd$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $3rEVE(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $3rEVE(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $94ce66791940e5fd$var$getValueAtPath;

});

parcelRegister("6bezN", function(module, exports) {
'use strict';
var $47ff13bd43613dfb$var$profileHandlersByName = {};
var $47ff13bd43613dfb$var$defaultProfiler = {
    stop: function stop() {}
};
var $47ff13bd43613dfb$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $47ff13bd43613dfb$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $47ff13bd43613dfb$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$47ff13bd43613dfb$var$profileHandlersByName.hasOwnProperty(name)) $47ff13bd43613dfb$var$profileHandlersByName[name] = [];
        $47ff13bd43613dfb$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($47ff13bd43613dfb$var$profileHandlersByName.hasOwnProperty(name)) $47ff13bd43613dfb$var$removeFromArray($47ff13bd43613dfb$var$profileHandlersByName[name], handler);
    }
};
function $47ff13bd43613dfb$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $47ff13bd43613dfb$var$RelayProfiler;

});



parcelRegister("8uMLL", function(module, exports) {
$parcel$export(module.exports, "fetchBrandingData", () => $4ead79f1bdfc1c9b$export$7bfdb01d731b8001);
$parcel$export(module.exports, "convertToHCBrandingResponse", () => $4ead79f1bdfc1c9b$export$4560b37f8fc33ae3);

var $d1iVz = parcelRequire("d1iVz");

var $jByYr = parcelRequire("jByYr");

var $8iTFq = parcelRequire("8iTFq");

var $1EFS8 = parcelRequire("1EFS8");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $gyskF = parcelRequire("gyskF");
const $4ead79f1bdfc1c9b$export$7bfdb01d731b8001 = ()=>{
    return (0, $8iTFq.fetchQuery)((0, $gyskF.getRelayEnvironment)(), (0, $d1iVz.default), {
        cloudId: (0, $jByYr.getCloudId)(),
        helpCenterAri: (0, $jByYr.getHelpCenterAri)()
    }, {
        fetchPolicy: 'store-or-network'
    });
};
const $4ead79f1bdfc1c9b$var$mapTranslations = (translations, fieldName, acc)=>{
    translations === null || translations === void 0 || translations.forEach((translation)=>{
        if (translation && acc[translation === null || translation === void 0 ? void 0 : translation.locale] !== undefined) acc[translation.locale][fieldName] = translation.value;
        else if (translation) acc[translation === null || translation === void 0 ? void 0 : translation.locale] = {
            [fieldName]: translation.value,
            localeDisplayName: translation.localeDisplayName
        };
    });
};
const $4ead79f1bdfc1c9b$export$4560b37f8fc33ae3 = (response)=>{
    var _response$helpCenter;
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    if (response === undefined) return null;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') return null;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter') {
        var _homePageAnnouncement, _homePageAnnouncement2;
        const branding = data.helpCenterBranding;
        const announcements = data.announcements;
        const sharedPortalName = data.name;
        const { homePageAnnouncements: homePageAnnouncements } = announcements || {};
        const { logo: logo, banner: banner, homePageTitle: homePageTitle, colors: colors, hasTopBarBeenSplit: hasTopBarBeenSplit } = branding;
        const initialTranslation = {};
        let translations = {};
        if (homePageAnnouncements) translations = homePageAnnouncements === null || homePageAnnouncements === void 0 ? void 0 : homePageAnnouncements.filter((announcement)=>!!announcement).reduce((acc, announcement)=>{
            const { nameTranslationsRaw: nameTranslationsRaw, descriptionTranslationsRaw: descriptionTranslationsRaw } = announcement;
            $4ead79f1bdfc1c9b$var$mapTranslations(nameTranslationsRaw, 'announcementHeader', acc);
            $4ead79f1bdfc1c9b$var$mapTranslations(descriptionTranslationsRaw, 'announcementMessage', acc);
            return acc;
        }, initialTranslation);
        $4ead79f1bdfc1c9b$var$mapTranslations(sharedPortalName === null || sharedPortalName === void 0 ? void 0 : sharedPortalName.translations, 'sharedPortalName', translations);
        $4ead79f1bdfc1c9b$var$mapTranslations(homePageTitle === null || homePageTitle === void 0 ? void 0 : homePageTitle.translations, 'helpCenterTitle', translations);
        const getDefaultTitle = ()=>{
            if (isCSM) return 'How can we help?';
            return 'Welcome to the Help Center';
        };
        const isDefaultNavColorAsBannerColorEnabled = (0, $1EFS8.default).checkGate('default_navigation_color_as_banner_color');
        const portalThemeColor = (colors === null || colors === void 0 ? void 0 : colors.primary) || '#0074e0';
        const helpCenterTitleColor = (colors === null || colors === void 0 ? void 0 : colors.bannerTextColor) || '#ffffff';
        return {
            translations: translations,
            portalThemeColor: portalThemeColor,
            helpCenterTitleColor: helpCenterTitleColor,
            logoUrl: (logo === null || logo === void 0 ? void 0 : logo.url) || '',
            logoId: (logo === null || logo === void 0 ? void 0 : logo.fileId) || '',
            bannerMediaApiFileId: (banner === null || banner === void 0 ? void 0 : banner.fileId) || '',
            bannerMediaApiUrl: (banner === null || banner === void 0 ? void 0 : banner.url) || '',
            helpCenterTitle: (homePageTitle === null || homePageTitle === void 0 ? void 0 : homePageTitle.default) || getDefaultTitle(),
            canEditAnnouncement: !!(announcements !== null && announcements !== void 0 && announcements.canEditHomePageAnnouncement),
            userInitialAnnouncementHeader: homePageAnnouncements && ((_homePageAnnouncement = homePageAnnouncements[0]) === null || _homePageAnnouncement === void 0 ? void 0 : _homePageAnnouncement.name) || '',
            userInitialAnnouncementMessageWiki: homePageAnnouncements && ((_homePageAnnouncement2 = homePageAnnouncements[0]) === null || _homePageAnnouncement2 === void 0 ? void 0 : _homePageAnnouncement2.description) || '',
            sharedPortalName: isCSM ? '' : (sharedPortalName === null || sharedPortalName === void 0 ? void 0 : sharedPortalName.default) || '',
            siteDefaultLanguageTag: data.siteDefaultLanguageTag || 'en-US',
            userLanguageTag: data.userLanguageTag || 'en-US',
            topBarColor: (colors === null || colors === void 0 ? void 0 : colors.topBarColor) || (isDefaultNavColorAsBannerColorEnabled ? portalThemeColor : '#FFFFFF'),
            // elevation.surface
            topBarTextColor: (colors === null || colors === void 0 ? void 0 : colors.topBarTextColor) || (isDefaultNavColorAsBannerColorEnabled ? helpCenterTitleColor : '#172B4D'),
            // color.text
            hasTopBarBeenSplit: hasTopBarBeenSplit ?? false,
            isBannerAvailable: !!branding.isBannerAvailable,
            useDefaultBanner: !!branding.useDefaultBanner,
            isLogoAvailable: !!branding.isLogoAvailable
        };
    }
    return null;
};

});
parcelRegister("d1iVz", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcc9f58e994931cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<762b42f3490374656d56e2bee709a301>>
 * @relayHash d9e8688fd258712e7252323bfaac25bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4022d9416d0f15d10e96cf464eb40e25456a447dd4ffcf15934193900d7b3bf6
const $bcc9f58e994931cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "locale"
        },
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "default"
        },
        {
            "concreteType": "HelpCenterTranslation",
            "kind": "LinkedField",
            "name": "translations",
            "plural": true,
            "selections": v4 /*: any*/ 
        }
    ], v6 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "fileId"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ], v8 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterHomePageTitle",
                "kind": "LinkedField",
                "name": "homePageTitle",
                "plural": false,
                "selections": v5 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBanner",
                "kind": "LinkedField",
                "name": "banner",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "primary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bannerTextColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "topBarColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "topBarTextColor"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "isBannerAvailable"
            },
            {
                "kind": "ScalarField",
                "name": "isLogoAvailable"
            },
            {
                "kind": "ScalarField",
                "name": "useDefaultBanner"
            },
            {
                "kind": "ScalarField",
                "name": "hasTopBarBeenSplit"
            }
        ]
    }, v9 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canEditHomePageAnnouncement"
            },
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "homePageAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "nameTranslationsRaw",
                        "plural": true,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "descriptionTranslationsRaw",
                        "plural": true,
                        "selections": v4 /*: any*/ 
                    }
                ]
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "siteDefaultLanguageTag"
    }, v11 = {
        "kind": "ScalarField",
        "name": "userLanguageTag"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterBrandingQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "helpCenter.helpCenterById.helpCenterBranding"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterBrandingQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4022d9416d0f15d10e96cf464eb40e25456a447dd4ffcf15934193900d7b3bf6",
            "metadata": {},
            "name": "helpCenterBrandingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bcc9f58e994931cd$var$node.hash = "4d4bfd3b05fd09feee5f588ec411df08";
var $bcc9f58e994931cd$export$2e2bcd8739ae039 = $bcc9f58e994931cd$var$node;

});

parcelRegister("gyskF", function(module, exports) {
$parcel$export(module.exports, "getRelayEnvironment", () => $acb9ab354c6f27a8$export$ffa93f1e5be01566);

var $HGACo = parcelRequire("HGACo");

var $e6Qdr = parcelRequire("e6Qdr");

var $jHrvS = parcelRequire("jHrvS");

var $ijGqG = parcelRequire("ijGqG");

var $8bYXN = parcelRequire("8bYXN");

var $7PBOc = parcelRequire("7PBOc");

var $2EjAH = parcelRequire("2EjAH");

var $6MsBn = parcelRequire("6MsBn");
const $acb9ab354c6f27a8$var$sharedRelayEnvironment = (0, $jHrvS.createRelayEnvironment)({
    ...!(0, $HGACo.isFixRelayIdConflictInHelpCenter)() ? {
        getDataID: undefined
    } : {},
    networkOptions: {
        setEndpoint: (0, $8bYXN.default).setEndpoint,
        getHeaders: (0, $8bYXN.default).getHeaders,
        isServer: false,
        subscribeExtensions: (0, $2EjAH.subscribeOptions).extensions,
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onSubscribeError: (0, $2EjAH.subscribeOptions).onError,
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onSubscribeTrigger: (0, $2EjAH.subscribeOptions).onTrigger,
        queryResponseCache: (0, $7PBOc.QueryResponseCache),
        validateResponse: (0, $8bYXN.default).validateResponse
    }
});
const $acb9ab354c6f27a8$export$ffa93f1e5be01566 = ()=>{
    if ((0, $e6Qdr.fg)('platform_relay_use_shared_relay_env_help_center')) return $acb9ab354c6f27a8$var$sharedRelayEnvironment;
    return 0, $ijGqG.default;
};

});
parcelRegister("jHrvS", function(module, exports) {
$parcel$export(module.exports, "createRelayEnvironment", () => $0cfb41eb77488cf1$export$7afaa9c867644497);

var $8iTFq = parcelRequire("8iTFq");

var $lNqln = parcelRequire("lNqln");

var $clS24 = parcelRequire("clS24");

var $hY5aL = parcelRequire("hY5aL");

var $5PxFh = parcelRequire("5PxFh");

var $kLyNd = parcelRequire("kLyNd");

var $3IdqB = parcelRequire("3IdqB");

var $6rrkR = parcelRequire("6rrkR");

var $5QPoh = parcelRequire("5QPoh");
// Enable Relay Resolvers globally for this module
(0, $8iTFq.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $0cfb41eb77488cf1$var$createNetwork(networkOptions) {
    return (0, $8iTFq.Network).create((request, variables, cacheConfig)=>(0, $kLyNd.fetch)(request, variables, cacheConfig, networkOptions), networkOptions.isServer === false ? (0, $5QPoh.createSubscribeFn)(networkOptions) : undefined);
}
const $0cfb41eb77488cf1$var$createStore = (source, options)=>{
    return new (0, (/*@__PURE__*/$parcel$interopDefault($lNqln)))(source, options);
};
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $0cfb41eb77488cf1$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $8iTFq.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
const $0cfb41eb77488cf1$var$DeleteEdgeHandler = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $clS24.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $hY5aL.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $0cfb41eb77488cf1$var$deleteNode(connection, id);
            }
        });
    }
};
function $0cfb41eb77488cf1$var$HandlerProvider(handle) {
    switch(handle){
        case 'deleteEdge':
            return $0cfb41eb77488cf1$var$DeleteEdgeHandler;
        default:
            return (0, $8iTFq.DefaultHandlerProvider)(handle);
    }
}
function $0cfb41eb77488cf1$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID }) {
    return new (0, $8iTFq.Environment)({
        configName: 'Atlassian Shared Graphql Gateway',
        network: $0cfb41eb77488cf1$var$createNetwork(networkOptions || {
            isServer: false
        }),
        store: $0cfb41eb77488cf1$var$createStore(new (0, $8iTFq.RecordSource)(), {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $5PxFh.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $5PxFh.default),
        scheduler: (0, $6rrkR.default),
        missingFieldHandlers: (0, $3IdqB.default),
        handlerProvider: $0cfb41eb77488cf1$var$HandlerProvider
    });
}

});
parcelRegister("lNqln", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $fde29bed4e2633e1$var$_interopRequireDefault = $dw9g1.default;

var $fde29bed4e2633e1$var$_createForOfIteratorHelper2 = $fde29bed4e2633e1$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $fde29bed4e2633e1$var$_defineProperty2 = $fde29bed4e2633e1$var$_interopRequireDefault((parcelRequire("cO17m")));

var $8T3Ai = parcelRequire("8T3Ai");
var $fde29bed4e2633e1$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $8T3Ai.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $fde29bed4e2633e1$var$assertInternalActorIdentifier = $8T3Ai.assertInternalActorIdentifier;
parcelRequire("6NDOU");

var $hdTum = parcelRequire("hdTum");

var $ikAsR = parcelRequire("ikAsR");

var $bidvu = parcelRequire("bidvu");

var $8AGUk = parcelRequire("8AGUk");

var $aH8bB = parcelRequire("aH8bB");

var $e170H = parcelRequire("e170H");

var $7HU3A = parcelRequire("7HU3A");

var $cIeRV = parcelRequire("cIeRV");

var $aJi4Y = parcelRequire("aJi4Y");

var $aJi4Y = parcelRequire("aJi4Y");
var $fde29bed4e2633e1$var$ROOT_ID = $aJi4Y.ROOT_ID, $fde29bed4e2633e1$var$ROOT_TYPE = $aJi4Y.ROOT_TYPE;

var $70pnn = parcelRequire("70pnn");
var $fde29bed4e2633e1$var$LiveResolverCache = $70pnn.LiveResolverCache, $fde29bed4e2633e1$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $70pnn.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $fde29bed4e2633e1$var$getUpdatedDataIDs = $70pnn.getUpdatedDataIDs;

var $3rEVE = parcelRequire("3rEVE");
var $fde29bed4e2633e1$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $fde29bed4e2633e1$var$LiveResolverStore = /*#__PURE__*/ function() {
    function LiveResolverStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
        (0, $fde29bed4e2633e1$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $fde29bed4e2633e1$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $hdTum;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $bidvu;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $fde29bed4e2633e1$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $cIeRV(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        $fde29bed4e2633e1$var$initializeRecordSource(this._recordSource);
    }
    var _proto = LiveResolverStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $fde29bed4e2633e1$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $fde29bed4e2633e1$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $ikAsR.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $fde29bed4e2633e1$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $fde29bed4e2633e1$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $e170H.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $fde29bed4e2633e1$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'LiveResolverStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $8AGUk.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        var invalidationState = {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
        return invalidationState;
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $fde29bed4e2633e1$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $3rEVE(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $aH8bB.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $3rEVE(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $aH8bB.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $fde29bed4e2633e1$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $7HU3A.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $8AGUk.getValue(record, $fde29bed4e2633e1$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $fde29bed4e2633e1$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return LiveResolverStore;
}();
function $fde29bed4e2633e1$var$initializeRecordSource(target) {
    if (!target.has($fde29bed4e2633e1$var$ROOT_ID)) {
        var rootRecord = $8AGUk.create($fde29bed4e2633e1$var$ROOT_ID, $fde29bed4e2633e1$var$ROOT_TYPE);
        target.set($fde29bed4e2633e1$var$ROOT_ID, rootRecord);
    }
}
function $fde29bed4e2633e1$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $8AGUk.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $8AGUk.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $8AGUk.setValue(nextRecord, $aJi4Y.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $8AGUk.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $fde29bed4e2633e1$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $fde29bed4e2633e1$var$LiveResolverStore;

});
parcelRegister("70pnn", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $519c37a9fdd49daa$var$_interopRequireDefault = $dw9g1.default;

var $519c37a9fdd49daa$var$_createForOfIteratorHelper2 = $519c37a9fdd49daa$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $kD8cH = parcelRequire("kD8cH");

var $eXHjc = parcelRequire("eXHjc");
var $519c37a9fdd49daa$var$RELAY_LIVE_RESOLVER = $eXHjc.RELAY_LIVE_RESOLVER;

var $ljupL = parcelRequire("ljupL");

var $dF318 = parcelRequire("dF318");

var $3vT9g = parcelRequire("3vT9g");
var $519c37a9fdd49daa$var$generateClientID = $3vT9g.generateClientID, $519c37a9fdd49daa$var$generateClientObjectClientID = $3vT9g.generateClientObjectClientID;

var $8AGUk = parcelRequire("8AGUk");

var $cKnH2 = parcelRequire("cKnH2");
var $519c37a9fdd49daa$var$createNormalizationSelector = $cKnH2.createNormalizationSelector;

var $kLaEL = parcelRequire("kLaEL");

var $bvAsJ = parcelRequire("bvAsJ");
var $519c37a9fdd49daa$var$normalize = $bvAsJ.normalize;

var $aJi4Y = parcelRequire("aJi4Y");
var $519c37a9fdd49daa$var$RELAY_RESOLVER_ERROR_KEY = $aJi4Y.RELAY_RESOLVER_ERROR_KEY, $519c37a9fdd49daa$var$RELAY_RESOLVER_INVALIDATION_KEY = $aJi4Y.RELAY_RESOLVER_INVALIDATION_KEY, $519c37a9fdd49daa$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $aJi4Y.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $519c37a9fdd49daa$var$RELAY_RESOLVER_SNAPSHOT_KEY = $aJi4Y.RELAY_RESOLVER_SNAPSHOT_KEY, $519c37a9fdd49daa$var$RELAY_RESOLVER_VALUE_KEY = $aJi4Y.RELAY_RESOLVER_VALUE_KEY, $519c37a9fdd49daa$var$getStorageKey = $aJi4Y.getStorageKey;

var $aTdXk = parcelRequire("aTdXk");

var $eCa0X = parcelRequire("eCa0X");

var $cG3gu = parcelRequire("cG3gu");
var $519c37a9fdd49daa$var$isSuspenseSentinel = $cG3gu.isSuspenseSentinel;

var $3rEVE = parcelRequire("3rEVE");
parcelRequire("l1Dol");
var $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $519c37a9fdd49daa$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $519c37a9fdd49daa$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $519c37a9fdd49daa$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $519c37a9fdd49daa$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $519c37a9fdd49daa$var$expectRecord(recordSource, recordID);
        var storageKey = $519c37a9fdd49daa$var$getStorageKey(field, variables);
        var linkedID = $8AGUk.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $519c37a9fdd49daa$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $519c37a9fdd49daa$var$generateClientID(recordID, storageKey);
            linkedRecord = $8AGUk.create(linkedID, $519c37a9fdd49daa$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $8AGUk.setValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $8AGUk.setValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $519c37a9fdd49daa$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $3rEVE(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $519c37a9fdd49daa$var$expectRecord(recordSource, recordID);
            var nextRecord = $8AGUk.clone(currentRecord);
            $8AGUk.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $519c37a9fdd49daa$var$getStorageKey(field.fragment, variables);
                var resolverID = $519c37a9fdd49daa$var$generateClientID(recordID, fragmentStorageKey);
                $519c37a9fdd49daa$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $519c37a9fdd49daa$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $519c37a9fdd49daa$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $519c37a9fdd49daa$var$RELAY_LIVE_RESOLVER && $8AGUk.getValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $519c37a9fdd49daa$var$generateClientID(recordID, storageKey);
            linkedRecord = $8AGUk.clone(linkedRecord);
            var _liveState = $8AGUk.getValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$eCa0X(_liveState)) $3rEVE(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $8AGUk.setValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $8AGUk.getValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $8AGUk.getValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($519c37a9fdd49daa$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $519c37a9fdd49daa$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $3rEVE(false);
        var liveState = $8AGUk.getValue(liveStateRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $8AGUk.setValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $8AGUk.setValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $8AGUk.setValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$8AGUk.hasValue(currentRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $8AGUk.clone(currentRecord);
            $8AGUk.setValue(nextRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $kLaEL.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $kLaEL.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $3rEVE(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $8AGUk.setValue(resolverRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$519c37a9fdd49daa$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $aTdXk(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $3rEVE(false);
                resolverValue = [];
                var nextSource = $kLaEL.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $3rEVE(false);
                    var typename = $519c37a9fdd49daa$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $519c37a9fdd49daa$var$generateClientObjectClientID(typename, $8AGUk.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $519c37a9fdd49daa$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $519c37a9fdd49daa$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $3rEVE(false);
                var _typename = $519c37a9fdd49daa$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $519c37a9fdd49daa$var$generateClientObjectClientID(_typename, $8AGUk.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $519c37a9fdd49daa$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $8AGUk.setValue(resolverRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $dF318(resolverValue);
            $8AGUk.setValue(resolverRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $dF318(value);
            $8AGUk.setValue(resolverRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $8AGUk.getValue(resolverRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $519c37a9fdd49daa$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$8AGUk.getValue(record, $519c37a9fdd49daa$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $8AGUk.getValue(record, $519c37a9fdd49daa$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $kD8cH(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($ljupL.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $8AGUk.clone(record);
            $8AGUk.setValue(nextRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($8AGUk.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $kLaEL.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $8AGUk.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $519c37a9fdd49daa$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $519c37a9fdd49daa$var$normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = $8AGUk.create(outputTypeDataID, typename);
                $8AGUk.setValue(_record, $519c37a9fdd49daa$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $3rEVE(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $519c37a9fdd49daa$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $8AGUk.create(key, typeName);
            $8AGUk.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $519c37a9fdd49daa$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $519c37a9fdd49daa$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $519c37a9fdd49daa$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $519c37a9fdd49daa$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $519c37a9fdd49daa$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $8AGUk.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $519c37a9fdd49daa$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $519c37a9fdd49daa$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $8AGUk.getFields(record).forEach(function(field) {
        if ($8AGUk.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $8AGUk.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($8AGUk.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $8AGUk.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $519c37a9fdd49daa$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $8AGUk.clone(record);
    $8AGUk.setValue(nextRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $519c37a9fdd49daa$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $519c37a9fdd49daa$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $519c37a9fdd49daa$var$isResolverRecord(_record2)) $519c37a9fdd49daa$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $519c37a9fdd49daa$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $519c37a9fdd49daa$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $519c37a9fdd49daa$var$isResolverRecord(record)) $519c37a9fdd49daa$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $519c37a9fdd49daa$var$isResolverRecord(record) {
    return $8AGUk.getType(record) === $519c37a9fdd49daa$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $519c37a9fdd49daa$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $8AGUk.getValue(linkedRecord, $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $519c37a9fdd49daa$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $3rEVE(false);
    return record;
}
function $519c37a9fdd49daa$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $519c37a9fdd49daa$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $3rEVE(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $519c37a9fdd49daa$var$LiveResolverCache,
    getUpdatedDataIDs: $519c37a9fdd49daa$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $519c37a9fdd49daa$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("eCa0X", function(module, exports) {
'use strict';
function $02bee8ce440a29d7$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $02bee8ce440a29d7$var$isLiveStateValue;

});



parcelRegister("hY5aL", function(module, exports) {
$parcel$export(module.exports, "default", () => $d14c0d70891aaa5b$export$2e2bcd8739ae039);
var $d14c0d70891aaa5b$var$isProduction = true;
function $d14c0d70891aaa5b$var$warning(condition, message) {
    if (!$d14c0d70891aaa5b$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $d14c0d70891aaa5b$export$2e2bcd8739ae039 = $d14c0d70891aaa5b$var$warning;

});

parcelRegister("5PxFh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f769b703c407b67$export$2e2bcd8739ae039);
function $1f769b703c407b67$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    return `${String(id)}:::::${typeName}`;
}

});

parcelRegister("kLyNd", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $7fb1b6f310e4f321$export$e7aa7bc5c1b3cfb3);

var $cmTnD = parcelRequire("cmTnD");

var $8iTFq = parcelRequire("8iTFq");

var $e6Qdr = parcelRequire("e6Qdr");

var $bk1ET = parcelRequire("bk1ET");

var $93lwJ = parcelRequire("93lwJ");

var $fHgyD = parcelRequire("fHgyD");

var $l3iko = parcelRequire("l3iko");

var $72kQy = parcelRequire("72kQy");

var $bZbPJ = parcelRequire("bZbPJ");

var $8RTPF = parcelRequire("8RTPF");

var $d7lkZ = parcelRequire("d7lkZ");

var $2MiWf = parcelRequire("2MiWf");
const $7fb1b6f310e4f321$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $7fb1b6f310e4f321$var$moduleID = 'relay-fetch';
const $7fb1b6f310e4f321$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    var _dependencies$getLogg;
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies === null || dependencies === void 0 || (_dependencies$getLogg = dependencies.getLoggingAndMetricsHelper) === null || _dependencies$getLogg === void 0 ? void 0 : _dependencies$getLogg.call(dependencies, loggingMetadata);
    function augmentResponse(response) {
        (0, $l3iko.addTraceId)(queryName, (0, $2MiWf.getTraceIdFromExtensions)(response));
        (0, $bk1ET.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $8iTFq.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$7fb1b6f310e4f321$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                var _dependencies$earlySc;
                const endpoint = (0, $93lwJ.getAggEndpoint)(request, cacheConfig);
                const body = (0, $93lwJ.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies !== null && dependencies !== void 0 && dependencies.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies !== null && dependencies !== void 0 && dependencies.getAbortSignal) options.signal = dependencies === null || dependencies === void 0 ? void 0 : dependencies.getAbortSignal();
                const fetchOverNetwork = (0, $8RTPF.buildGraphqlSmartFetch)({
                    url: dependencies !== null && dependencies !== void 0 && dependencies.setEndpoint ? dependencies === null || dependencies === void 0 ? void 0 : dependencies.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: (dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies === null || dependencies === void 0 || (_dependencies$earlySc = dependencies.earlyScriptPromise) === null || _dependencies$earlySc === void 0 ? void 0 : _dependencies$earlySc.call(dependencies, request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies !== null && dependencies !== void 0 && dependencies.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!(dependencies !== null && dependencies !== void 0 && dependencies.isServer) && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $8RTPF.processMultipartPromise)(()=>(0, $d7lkZ.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $d7lkZ.shouldRetry),
                        retryAttempts: (0, $d7lkZ.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logErrorRetry
                    }));
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies !== null && dependencies !== void 0 && dependencies.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $7fb1b6f310e4f321$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $fHgyD.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $fHgyD.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $fHgyD.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && $7fb1b6f310e4f321$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $bZbPJ.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (dependencies !== null && dependencies !== void 0 && dependencies.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                var _dependencies$onInval;
                                dependencies === null || dependencies === void 0 || (_dependencies$onInval = dependencies.onInvalidResponse) === null || _dependencies$onInval === void 0 || _dependencies$onInval.call(dependencies, request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            if ((0, $e6Qdr.fg)('platform_relay_use_new_non_nullability')) response = $7fb1b6f310e4f321$export$b143926e518df3b(singularResponse);
                            else enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && requestID != null && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.queryResponseCache) !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && $7fb1b6f310e4f321$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics === null || loggingAndMetrics === void 0 || loggingAndMetrics.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!(dependencies !== null && dependencies !== void 0 && dependencies.isServer) && requestID != null) {
                var _dependencies$queryRe;
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies === null || dependencies === void 0 || (_dependencies$queryRe = dependencies.queryResponseCache) === null || _dependencies$queryRe === void 0 ? void 0 : _dependencies$queryRe.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cmTnD)))(ssrCache)) {
                    var _dependencies$queryRe2;
                    dependencies === null || dependencies === void 0 || (_dependencies$queryRe2 = dependencies.queryResponseCache) === null || _dependencies$queryRe2 === void 0 || _dependencies$queryRe2.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($7fb1b6f310e4f321$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $72kQy.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $72kQy.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                var _dependencies$handleA;
                                dependencies === null || dependencies === void 0 || (_dependencies$handleA = dependencies.handleAbort) === null || _dependencies$handleA === void 0 || _dependencies$handleA.call(dependencies, request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics === null || loggingAndMetrics === void 0 || loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};
function $7fb1b6f310e4f321$export$b143926e518df3b(response) {
    if (response.data) {
        // Enforce non-nullability of the product namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        let sanitisedData = Object.assign({}, response.data);
        const productKeys = [
            'jira',
            'customerService',
            'graphStore'
        ];
        for (const product of productKeys)if (sanitisedData[product] === null) delete sanitisedData[product];
        if (Object.keys(sanitisedData).length === 0) // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Dataa
        sanitisedData = null;
        response.data = sanitisedData;
    }
    return response;
}

});
parcelRegister("cmTnD", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $90127f75072b42c3$var$isNil(value) {
    return value == null;
}
module.exports = $90127f75072b42c3$var$isNil;

});

parcelRegister("bk1ET", function(module, exports) {
$parcel$export(module.exports, "putExtensions", () => $6002d3aefc81acf2$export$17dc47fdf278de21);
const $6002d3aefc81acf2$var$OperationExtensionsMap = {};
const $6002d3aefc81acf2$export$8656ba3981c6f6c1 = (operationName)=>{
    $6002d3aefc81acf2$var$OperationExtensionsMap[operationName] = $6002d3aefc81acf2$var$OperationExtensionsMap[operationName] || [];
};
const $6002d3aefc81acf2$export$f16fa6040161f056 = (operationName)=>{
    $6002d3aefc81acf2$var$OperationExtensionsMap[operationName] = undefined;
};
const $6002d3aefc81acf2$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $6002d3aefc81acf2$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $6002d3aefc81acf2$export$7c6ea4184129ef74 = (operationName)=>$6002d3aefc81acf2$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("93lwJ", function(module, exports) {
$parcel$export(module.exports, "getAggEndpoint", () => $f06dc6724abc3ba9$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $f06dc6724abc3ba9$export$55bce18df99af758);

var $6nQJh = parcelRequire("6nQJh");
const $f06dc6724abc3ba9$var$branchSlug = typeof $6nQJh !== 'undefined' && $6nQJh.env ? undefined : undefined;
const $f06dc6724abc3ba9$export$8f8c52ac77845a86 = `/gateway/api/graphql${$f06dc6724abc3ba9$var$branchSlug ? `/${$f06dc6724abc3ba9$var$branchSlug}/graphql` : ''}`;
const $f06dc6724abc3ba9$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    var _cacheConfig$metadata;
    let endpoint = $f06dc6724abc3ba9$export$8f8c52ac77845a86;
    if ((_cacheConfig$metadata = cacheConfig.metadata) !== null && _cacheConfig$metadata !== void 0 && _cacheConfig$metadata.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $f06dc6724abc3ba9$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("fHgyD", function(module, exports) {
$parcel$export(module.exports, "QueryPromisesMap", () => $997a249f87f4f947$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $997a249f87f4f947$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $997a249f87f4f947$export$607b80f5bc6e396d = new Map();
const $997a249f87f4f947$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("l3iko", function(module, exports) {
$parcel$export(module.exports, "addTraceId", () => $45dffce202a7f7f2$export$fcaa732775f12226);
const $45dffce202a7f7f2$var$OperationTraceIdMap = {};
const $45dffce202a7f7f2$export$a2bcb2fac360646c = (operationName)=>{
    $45dffce202a7f7f2$var$OperationTraceIdMap[operationName] = $45dffce202a7f7f2$var$OperationTraceIdMap[operationName] || [];
};
const $45dffce202a7f7f2$export$559128bdc4352001 = (operationName)=>{
    $45dffce202a7f7f2$var$OperationTraceIdMap[operationName] = undefined;
};
const $45dffce202a7f7f2$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $45dffce202a7f7f2$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $45dffce202a7f7f2$export$5113e470f5c95670 = (operationName)=>$45dffce202a7f7f2$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("72kQy", function(module, exports) {
$parcel$export(module.exports, "getClientDispatcher", () => $f02a29fd0777c155$export$5bb012cf9b3a5452);

var $9LNK0 = parcelRequire("9LNK0");
const $f02a29fd0777c155$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $f02a29fd0777c155$var$dispatcher;
const $f02a29fd0777c155$export$5bb012cf9b3a5452 = ()=>{
    if (!$f02a29fd0777c155$var$dispatcher) {
        $f02a29fd0777c155$var$dispatcher = new (0, $9LNK0.ClientDispatcher)();
        // Handle the server hangup scenarios
        $f02a29fd0777c155$var$dispatcher.register($f02a29fd0777c155$export$eb5d9c90d65c7fea, $f02a29fd0777c155$var$dispatcher._abort.bind($f02a29fd0777c155$var$dispatcher));
    }
    return $f02a29fd0777c155$var$dispatcher;
};

});
parcelRegister("9LNK0", function(module, exports) {
$parcel$export(module.exports, "ClientDispatcher", () => $1dcf88de2187593a$export$3f5ba18eb97af725);
class $1dcf88de2187593a$export$3f5ba18eb97af725 {
    constructor(){
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
    /**
   * Ingest a payload from the server.
   * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
   * @param payload - The payload to ingest.
   */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
   * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when the event is ingested.
   */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
   * Unregister a callback for a given event.
   * @param id
   */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
   * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when abort detected.
   */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
   * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
   * @private
   * @param props
   */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
   * Execute a callback with the given payload.
   * @param callback - The callback to execute.
   * @param payload - The payload to execute the callback with.
   */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("bZbPJ", function(module, exports) {
$parcel$export(module.exports, "registerEvent", () => $9462abcd8376e5ff$export$bd50bc4cd3c601ee);
const $9462abcd8376e5ff$var$events = [];
const $9462abcd8376e5ff$export$bd50bc4cd3c601ee = (event)=>{
    $9462abcd8376e5ff$var$events.push(event);
};
const $9462abcd8376e5ff$export$3c7145db84d4587c = ()=>{
    return $9462abcd8376e5ff$var$events.splice(0, $9462abcd8376e5ff$var$events.length);
};

});

parcelRegister("8RTPF", function(module, exports) {
$parcel$export(module.exports, "processMultipartPromise", () => $5bc36cb630648de7$export$f76505a7f2969e4e);
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $5bc36cb630648de7$export$33c9c992c7855d86);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $4BY1L = parcelRequire("4BY1L");

var $8iTFq = parcelRequire("8iTFq");

var $e6Qdr = parcelRequire("e6Qdr");

var $lrG8W = parcelRequire("lrG8W");
const $5bc36cb630648de7$var$NO_CONTENT = 204;
function $5bc36cb630648de7$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function $5bc36cb630648de7$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
async function $5bc36cb630648de7$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $5bc36cb630648de7$export$701544522b0c6c99(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $5bc36cb630648de7$export$701544522b0c6c99(incompleteChunk, boundaryString, observer);
    observer.complete();
}
function $5bc36cb630648de7$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $5bc36cb630648de7$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        $5bc36cb630648de7$export$efb69f1fe7577739(streamReader(), boundary, observer).catch((error)=>observer.error(error));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        observer.error(error);
    }
}
function $5bc36cb630648de7$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $5bc36cb630648de7$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>{
        var _response$headers;
        let traceId = '';
        if ((0, $e6Qdr.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        observer.error(new Error(`Error while parsing text response ${traceId}(Content-Type: ${response === null || response === void 0 || (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('content-type')}): ${error instanceof Error ? error.message : String(error)}`));
    });
}
function $5bc36cb630648de7$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $8iTFq.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === $5bc36cb630648de7$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $5bc36cb630648de7$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $5bc36cb630648de7$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $5bc36cb630648de7$var$handleMultipartResponse(response, observer);
            else $5bc36cb630648de7$var$handleTextResponse(response, observer);
        }).catch((error)=>observer.error(error));
    });
}
const $5bc36cb630648de7$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
const $5bc36cb630648de7$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $5bc36cb630648de7$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function $5bc36cb630648de7$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function $5bc36cb630648de7$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}
function $5bc36cb630648de7$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = $5bc36cb630648de7$export$28ae0033b80c6303(baseUrl, variables).length;
    const headersSize = $5bc36cb630648de7$export$dd754c3ef60c6999(headers || {});
    return queryLength <= $5bc36cb630648de7$var$MAX_QUERY_LENGTH && headersSize <= $5bc36cb630648de7$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function $5bc36cb630648de7$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    var _cacheConfig$metadata;
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $5bc36cb630648de7$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $lrG8W.getRelayExperimentalApis)().join(','),
        ...(cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.headers) || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = $5bc36cb630648de7$export$5ad31d96a9271d42({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = $5bc36cb630648de7$export$28ae0033b80c6303(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}

});
parcelRegister("lrG8W", function(module, exports) {
$parcel$export(module.exports, "getRelayExperimentalApis", () => $f403547557ccf320$export$2cb71284f72ca45b);

var $e6Qdr = parcelRequire("e6Qdr");
const $f403547557ccf320$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs',
    'help-object-store-agg-beta',
    'HelpCenterReorderTopics'
];
const $f403547557ccf320$var$RelayExperimentalApisWithPolaris = [
    ...$f403547557ccf320$export$ebe3a775ce3053a5,
    'polaris-v0'
];
const $f403547557ccf320$export$2cb71284f72ca45b = ()=>{
    return (0, $e6Qdr.fg)('platform_relay_experimental_apis_polaris') ? $f403547557ccf320$var$RelayExperimentalApisWithPolaris : $f403547557ccf320$export$ebe3a775ce3053a5;
};

});


parcelRegister("d7lkZ", function(module, exports) {
$parcel$export(module.exports, "retryOnError", () => $b41615764ba5a674$export$f859c88bfac2cf2c);
$parcel$export(module.exports, "shouldRetry", () => $b41615764ba5a674$export$7bfea3c3d460ecd8);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $b41615764ba5a674$export$9dec0f42cc67f6ab);
const $b41615764ba5a674$export$81189edc9b923717 = 1;
const $b41615764ba5a674$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $b41615764ba5a674$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $b41615764ba5a674$export$81189edc9b923717 ? $b41615764ba5a674$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};
const $b41615764ba5a674$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $b41615764ba5a674$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return $b41615764ba5a674$export$81189edc9b923717;
    return 0;
};

});

parcelRegister("2MiWf", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $ba7ed9e51027e166$export$eefb7f54c3b07211);
const $ba7ed9e51027e166$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};

});


parcelRegister("3IdqB", function(module, exports) {
$parcel$export(module.exports, "default", () => $60ea85c52d0f79cb$export$2e2bcd8739ae039);

var $6nTAH = parcelRequire("6nTAH");

var $5PxFh = parcelRequire("5PxFh");
const $60ea85c52d0f79cb$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $60ea85c52d0f79cb$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $60ea85c52d0f79cb$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $6nTAH.JiraFilterAri).parse(id).filterId;
            if ($60ea85c52d0f79cb$var$isCustomFilter(filterId)) return (0, $5PxFh.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($60ea85c52d0f79cb$var$isSystemFilter(filterId)) return (0, $5PxFh.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $60ea85c52d0f79cb$var$MissingFieldHandlers = [
    $60ea85c52d0f79cb$export$77232ec02db7a24a
];
var $60ea85c52d0f79cb$export$2e2bcd8739ae039 = $60ea85c52d0f79cb$var$MissingFieldHandlers;

});
parcelRegister("6nTAH", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAri", () => $4a6003439f8d8fb5$export$3cfb6cc809e835bd);

var $leQsf = parcelRequire("leQsf");

var $jmrxw = parcelRequire("jmrxw");

var $6LWYQ = parcelRequire("6LWYQ");
// src/jira/filter/manifest.ts
var $4a6003439f8d8fb5$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $leQsf.JiraFilterAriResourceOwner),
    resourceType: (0, $leQsf.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $4a6003439f8d8fb5$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $jmrxw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4a6003439f8d8fb5$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $4a6003439f8d8fb5$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4a6003439f8d8fb5$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $4a6003439f8d8fb5$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $6LWYQ.AriParser).fromOpts(derivedOpts, $4a6003439f8d8fb5$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6LWYQ.AriParser).fromString(maybeAri, $4a6003439f8d8fb5$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("leQsf", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $f76398260b006660$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $f76398260b006660$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $f76398260b006660$export$e6199848f52f1119 = "jira", $f76398260b006660$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("jmrxw", function(module, exports) {
$parcel$export(module.exports, "RegisteredAri", () => $e1856f3218a03f75$export$579ee78b1dcf0a11);

var $jySvk = parcelRequire("jySvk");
// src/core/registered-ari.ts
var $e1856f3218a03f75$export$579ee78b1dcf0a11 = class extends (0, $jySvk.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $jySvk.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("jySvk", function(module, exports) {
$parcel$export(module.exports, "Ari", () => $e3db78b1d3c7572a$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $e3db78b1d3c7572a$export$44a7af7122933d6b);

var $6LWYQ = parcelRequire("6LWYQ");
// src/core/ari.ts
var $e3db78b1d3c7572a$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $6LWYQ.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $e3db78b1d3c7572a$export$44a7af7122933d6b = class _AnyAri extends $e3db78b1d3c7572a$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $6LWYQ.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $6LWYQ.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("6LWYQ", function(module, exports) {
$parcel$export(module.exports, "AriParser", () => $4ee4e22792543224$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $4ee4e22792543224$export$ab4b293d0121b8ee);

var $cMn8Q = parcelRequire("cMn8Q");

var $dohZE = parcelRequire("dohZE");
// src/core/rules/cloud-id.ts
function $4ee4e22792543224$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $dohZE.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $4ee4e22792543224$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $dohZE.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $4ee4e22792543224$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $4ee4e22792543224$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $4ee4e22792543224$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $dohZE.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $4ee4e22792543224$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $dohZE.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $4ee4e22792543224$var$NUMBER_OF_ARI_SEGMENTS = 5, $4ee4e22792543224$export$4c3a8cde7a55740b = class extends (0, $cMn8Q.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $4ee4e22792543224$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $cMn8Q.validateAriQualifier)(qualifier), (0, $cMn8Q.validatePlatformQualifier)(platformQualifier), $4ee4e22792543224$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $4ee4e22792543224$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $4ee4e22792543224$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $4ee4e22792543224$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $dohZE.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $dohZE.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $4ee4e22792543224$var$NUMBER_OF_ATI_SEGMENTS = 4, $4ee4e22792543224$var$AtiParser = class extends (0, $cMn8Q.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $4ee4e22792543224$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $cMn8Q.validateAtiQualifier)(qualifier), (0, $cMn8Q.validatePlatformQualifier)(platformQualifier), $4ee4e22792543224$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $4ee4e22792543224$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $cMn8Q.validateAtiQualifier)(qualifier), (0, $cMn8Q.validatePlatformQualifier)(platformQualifier), $4ee4e22792543224$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $4ee4e22792543224$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $4ee4e22792543224$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $4ee4e22792543224$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("cMn8Q", function(module, exports) {
$parcel$export(module.exports, "validatePlatformQualifier", () => $94dbeb3253abf21a$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $94dbeb3253abf21a$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $94dbeb3253abf21a$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $94dbeb3253abf21a$export$3d09a5c28ff3e040);

var $dohZE = parcelRequire("dohZE");
// src/core/rules/platform-qualifier.ts
function $94dbeb3253abf21a$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $dohZE.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $94dbeb3253abf21a$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $dohZE.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $94dbeb3253abf21a$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $dohZE.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $94dbeb3253abf21a$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $dohZE.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $94dbeb3253abf21a$var$NUMBER_OF_BASE_SEGMENTS = 5, $94dbeb3253abf21a$var$SEGMENT_SEPARATOR = ":", $94dbeb3253abf21a$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($94dbeb3253abf21a$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $dohZE.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $94dbeb3253abf21a$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($94dbeb3253abf21a$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($94dbeb3253abf21a$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("dohZE", function(module, exports) {
$parcel$export(module.exports, "ValidationError", () => $9bfb7961b7c0dcec$export$2191b9da168c6cf0);
// src/errors.ts
var $9bfb7961b7c0dcec$export$2191b9da168c6cf0 = class extends Error {
};

});







parcelRegister("6rrkR", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5eec36ab4bb5c7a$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d5eec36ab4bb5c7a$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($6Q1OD))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $6Q1OD.version) === 'undefined' || (0, $6Q1OD.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($6Q1OD))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).startTransition === 'function') // @ts-ignore -error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});

parcelRegister("5QPoh", function(module, exports) {
$parcel$export(module.exports, "createSubscribeFn", () => $e4cc394ea19b549a$export$10f5a0700f263f11);

var $8iTFq = parcelRequire("8iTFq");

var $HECGK = parcelRequire("HECGK");
var $82GcB = parcelRequire("82GcB");
let $e4cc394ea19b549a$var$cachedDefaultSubscribe;
function $e4cc394ea19b549a$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $e4cc394ea19b549a$var$cachedDefaultSubscribe !== 'undefined') return $e4cc394ea19b549a$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>(0, $8iTFq.Observable).create((sink)=>{
            var _cacheConfig$metadata, _subscribeOptions$onS;
            const client = (0, $HECGK.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = (cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.replay) || undefined;
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...(subscribeOptions === null || subscribeOptions === void 0 ? void 0 : subscribeOptions.subscribeExtensions) || {},
                    ...replayConfig && {
                        replay: replayConfig
                    }
                }
            };
            let requestId = null;
            subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS = subscribeOptions.onSubscribeTrigger) === null || _subscribeOptions$onS === void 0 || _subscribeOptions$onS.call(subscribeOptions, payload);
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    var _value$extensions;
                    // @ts-expect-error agg prop is missing on generic "extensions" type
                    const aggRequestId = value === null || value === void 0 || (_value$extensions = value.extensions) === null || _value$extensions === void 0 || (_value$extensions = _value$extensions.gateway) === null || _value$extensions === void 0 ? void 0 : _value$extensions.request_id;
                    requestId = aggRequestId ?? requestId;
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (sinkError)=>{
                    var _subscribeOptions$onS2;
                    const errorInfo = (0, $82GcB.getSinkError)(sinkError);
                    sink.error(errorInfo);
                    subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS2 = subscribeOptions.onSubscribeError) === null || _subscribeOptions$onS2 === void 0 || _subscribeOptions$onS2.call(subscribeOptions, {
                        ...payload,
                        requestId: requestId
                    });
                }
            });
        });
    if (typeof subscribeOptions === 'undefined') $e4cc394ea19b549a$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $e4cc394ea19b549a$export$ec068583843480e7 = $e4cc394ea19b549a$export$10f5a0700f263f11();

});
parcelRegister("HECGK", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $bb7a1461c2968512$export$6bb76d6eba7e258c);

var $8YYOl = parcelRequire("8YYOl");

var $lrG8W = parcelRequire("lrG8W");

var $kc7qx = parcelRequire("kc7qx");

var $atuly = parcelRequire("atuly");
let $bb7a1461c2968512$var$client;
const $bb7a1461c2968512$export$6bb76d6eba7e258c = ()=>{
    if ((0, $atuly.isSSR)()) return null;
    if (!$bb7a1461c2968512$var$client) {
        var _window, _window2;
        $bb7a1461c2968512$var$client = (0, $8YYOl.createClient)({
            url: (0, $atuly.getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $kc7qx.WS_CLIENT_KEEP_ALIVE),
            retryAttempts: (0, $kc7qx.WS_CLIENT_RETRIES),
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${((_window = window) === null || _window === void 0 ? void 0 : _window.BUILD_KEY) ?? ''}::${((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.SSR_BUILD_KEY) ?? ''}`,
                'X-ExperimentalApi': (0, $lrG8W.getRelayExperimentalApis)().join(',')
            }
        });
    }
    return $bb7a1461c2968512$var$client;
};
const $bb7a1461c2968512$export$2f0afd443356d36f = ()=>{
    $bb7a1461c2968512$var$client = null;
};

});
parcelRegister("8YYOl", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $68a3191b2fa3e46f$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $69LmC = parcelRequire("69LmC");

var $1gsbg = parcelRequire("1gsbg");
var $68a3191b2fa3e46f$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $68a3191b2fa3e46f$var$__await ? (this.v = v, this) : new $68a3191b2fa3e46f$var$__await(v);
};
var $68a3191b2fa3e46f$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $68a3191b2fa3e46f$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $68a3191b2fa3e46f$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $68a3191b2fa3e46f$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$68a3191b2fa3e46f$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $69LmC.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $69LmC.stringifyMessage)({
                                    type: (0, $69LmC.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $68a3191b2fa3e46f$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $69LmC.stringifyMessage)(payload ? {
                            type: (0, $69LmC.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $69LmC.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $69LmC.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $69LmC.CloseCode).InternalClientError, (0, $1gsbg.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $69LmC.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $69LmC.stringifyMessage)(message.payload ? {
                                    type: (0, $69LmC.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $69LmC.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $69LmC.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $69LmC.CloseCode).BadResponse, (0, $1gsbg.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($68a3191b2fa3e46f$var$isLikeCloseEvent(errOrCloseEvent) && ($68a3191b2fa3e46f$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $69LmC.CloseCode).InternalServerError,
            (0, $69LmC.CloseCode).InternalClientError,
            (0, $69LmC.CloseCode).BadRequest,
            (0, $69LmC.CloseCode).BadResponse,
            (0, $69LmC.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $69LmC.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $69LmC.CloseCode).SubscriberAlreadyExists,
            (0, $69LmC.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($68a3191b2fa3e46f$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $69LmC.MessageType).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $69LmC.MessageType).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $69LmC.MessageType).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $69LmC.stringifyMessage)({
                    id: id,
                    type: (0, $69LmC.MessageType).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $69LmC.stringifyMessage)({
                        id: id,
                        type: (0, $69LmC.MessageType).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $68a3191b2fa3e46f$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $68a3191b2fa3e46f$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $68a3191b2fa3e46f$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $68a3191b2fa3e46f$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $68a3191b2fa3e46f$export$f5b1bfead8e118a7());
        }
    };
}
class $68a3191b2fa3e46f$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $68a3191b2fa3e46f$var$isLikeCloseEvent(val) {
    return (0, $1gsbg.isObject)(val) && 'code' in val && 'reason' in val;
}
function $68a3191b2fa3e46f$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $68a3191b2fa3e46f$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("69LmC", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $47b852d22c60121e$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $47b852d22c60121e$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $47b852d22c60121e$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $47b852d22c60121e$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $47b852d22c60121e$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $1gsbg = parcelRequire("1gsbg");
const $47b852d22c60121e$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $47b852d22c60121e$export$ec743af8bb66f3be = 'graphql-ws';
var $47b852d22c60121e$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($47b852d22c60121e$export$777128f41f6616ec || ($47b852d22c60121e$export$777128f41f6616ec = {}));
var $47b852d22c60121e$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($47b852d22c60121e$export$80edbf15fa61a4db || ($47b852d22c60121e$export$80edbf15fa61a4db = {}));
function $47b852d22c60121e$export$c17861b159b1b673(val) {
    if (!(0, $1gsbg.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $1gsbg.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $1gsbg.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $47b852d22c60121e$export$80edbf15fa61a4db.ConnectionInit:
        case $47b852d22c60121e$export$80edbf15fa61a4db.ConnectionAck:
        case $47b852d22c60121e$export$80edbf15fa61a4db.Ping:
        case $47b852d22c60121e$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $1gsbg.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $47b852d22c60121e$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $1gsbg.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $1gsbg.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $1gsbg.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $1gsbg.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $1gsbg.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $1gsbg.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $1gsbg.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $1gsbg.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $1gsbg.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $1gsbg.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $47b852d22c60121e$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $1gsbg.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $1gsbg.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $1gsbg.extendedTypeof)(val.payload)}`);
            break;
        case $47b852d22c60121e$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $1gsbg.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $1gsbg.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $47b852d22c60121e$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $1gsbg.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $47b852d22c60121e$export$9e0e49e75fa7d548(val) {
    try {
        $47b852d22c60121e$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $47b852d22c60121e$export$f2f615077a189f21(data, reviver) {
    return $47b852d22c60121e$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $47b852d22c60121e$export$77896e5b47bfd50b(msg, replacer) {
    $47b852d22c60121e$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("1gsbg", function(module, exports) {
$parcel$export(module.exports, "extendedTypeof", () => $0ebd252b17b26366$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $0ebd252b17b26366$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $0ebd252b17b26366$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $0ebd252b17b26366$export$2937fa0c8dddae54);
/** @private */ function $0ebd252b17b26366$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $0ebd252b17b26366$export$a6cdc56e425d0d0a(val) {
    return $0ebd252b17b26366$export$573326049e1b1c6b(val) === 'object';
}
function $0ebd252b17b26366$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $0ebd252b17b26366$export$92bd080471bc30f1(val) {
    return $0ebd252b17b26366$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $0ebd252b17b26366$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $0ebd252b17b26366$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("kc7qx", function(module, exports) {
$parcel$export(module.exports, "WS_CLIENT_KEEP_ALIVE", () => $10d84d5cdacb5d46$export$8b012b965402e06a);
$parcel$export(module.exports, "WS_CLIENT_RETRIES", () => $10d84d5cdacb5d46$export$bf6cd96e19b2987f);
const $10d84d5cdacb5d46$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $10d84d5cdacb5d46$export$bf6cd96e19b2987f = 100;
const $10d84d5cdacb5d46$export$1ad8434180c5936c = 300000; // 5m

});

parcelRegister("atuly", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $5abb21a6b515de92$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $5abb21a6b515de92$export$29a72e89601dfc59);
const $5abb21a6b515de92$export$48d7c418edadb60c = ()=>globalThis.__SERVER__ ?? false;
const $5abb21a6b515de92$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("82GcB", function(module, exports) {
$parcel$export(module.exports, "getSinkError", () => $5e39a78b0fa490fb$export$ece4736473c28965);
const $5e39a78b0fa490fb$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});



parcelRegister("ijGqG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1344a0ecde527ac9$export$2e2bcd8739ae039);

var $HGACo = parcelRequire("HGACo");

var $8iTFq = parcelRequire("8iTFq");

var $hrPHR = parcelRequire("hrPHR");

var $5PxFh = parcelRequire("5PxFh");

var $6tv7M = parcelRequire("6tv7M");

var $99sQr = parcelRequire("99sQr");

var $2EjAH = parcelRequire("2EjAH");

var $iUD5T = parcelRequire("iUD5T");
const $1344a0ecde527ac9$var$fetchRelay = (params, variables, cacheConfig, uploadables)=>{
    const fetcher = (0, $hrPHR.getIsPageServerSideRendered)() ? (0, $99sQr.default) : (0, $6tv7M.default);
    return fetcher(params, variables, cacheConfig, uploadables);
};
const $1344a0ecde527ac9$var$getNetWork = ()=>{
    if (!(0, $HGACo.enableRelaySubscriptions)() || (0, $iUD5T.isSSR)()) return (0, $8iTFq.Network).create($1344a0ecde527ac9$var$fetchRelay);
    return (0, $8iTFq.Network).create($1344a0ecde527ac9$var$fetchRelay, (0, $2EjAH.subscribe));
};
var // Export a singleton instance of Relay Environment configured with our network function:
$1344a0ecde527ac9$export$2e2bcd8739ae039 = new (0, $8iTFq.Environment)({
    network: $1344a0ecde527ac9$var$getNetWork(),
    store: new (0, $8iTFq.Store)(new (0, $8iTFq.RecordSource)()),
    ...(0, $HGACo.isFixRelayIdConflictInHelpCenter)() ? {
        getDataID: (0, $5PxFh.default)
    } : {}
});

});
parcelRegister("6tv7M", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb187c827244eb49$export$2e2bcd8739ae039);

var $1EFS8 = parcelRequire("1EFS8");

var $hrPHR = parcelRequire("hrPHR");

var $klz3F = parcelRequire("klz3F");

var $3GIk2 = parcelRequire("3GIk2");
const $bb187c827244eb49$var$fetchQuery = ({ operationKind: operationKind, id: id, name: name }, variables)=>{
    const isJsmScaleTestAggCheckEnabled = (0, $1EFS8.default).checkGate('jsm_scale_60k_testing_in_help_center');
    const isAggAttributionHeadersEnabled = (0, $1EFS8.default).checkGate('jsm-help-center-agg-attribution-headers');
    const AGG_BASE_PATH = id ? `/gateway/api/graphql/pq/${id}` : '/gateway/api/graphql';
    let AGG_PATH = AGG_BASE_PATH;
    if (isJsmScaleTestAggCheckEnabled && (0, $hrPHR.getEnv)().environment !== (0, $hrPHR.EnvType).PROD) {
        const AGG_BRANCH_SLUG = 'branch-issue-remove-rate-limit';
        AGG_PATH = id ? `/gateway/api/graphql/${AGG_BRANCH_SLUG}/graphql/pq/${id}` : `/gateway/api/graphql/${AGG_BRANCH_SLUG}/graphql`;
    }
    const body = JSON.stringify({
        variables: variables,
        operationName: name
    });
    return (0, $klz3F.fetchJson)(AGG_PATH, {
        body: body,
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            ...operationKind === 'mutation' && {
                'X-ExperimentalApi': 'help-object-store-agg-beta, HelpCenterReorderTopics'
            },
            ...isAggAttributionHeadersEnabled && (0, $3GIk2.getAggHeaders)()
        }
    });
};
var $bb187c827244eb49$export$2e2bcd8739ae039 = $bb187c827244eb49$var$fetchQuery;

});
parcelRegister("klz3F", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $1e35148b4c77ec7e$export$26e841bcf1aeb894);
$parcel$export(module.exports, "fetchJson", () => $1e35148b4c77ec7e$export$6d71b655afe1638d);
$parcel$export(module.exports, "handleGraphQlErrors", () => $1e35148b4c77ec7e$export$e7e6c134f67b83b7);
$parcel$export(module.exports, "isFetchNetworkOrClientError", () => $1e35148b4c77ec7e$export$68d314c2a361832e);

var $HGACo = parcelRequire("HGACo");

var $1We2B = parcelRequire("1We2B");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");
const $1e35148b4c77ec7e$var$NO_CONTENT = 204;
const $1e35148b4c77ec7e$var$NETWORK_ERROR_MESSAGE = 'Failed to fetch';
const $1e35148b4c77ec7e$var$EMPTY_TRACE_ID_ERROR_MESSAGE = 'Failed to fetch got empty traceId';
const $1e35148b4c77ec7e$var$NETWORK_ERROR_CODE = 0;
class $1e35148b4c77ec7e$export$26e841bcf1aeb894 extends Error {
    constructor(message, status, filterFromSentry){
        super(message);
        this.status = status;
        this.filterFromSentry = filterFromSentry;
    }
}
const $1e35148b4c77ec7e$export$6d71b655afe1638d = (url, params)=>{
    return fetch(url, params).then($1e35148b4c77ec7e$var$handleErrors).then($1e35148b4c77ec7e$var$processResponseFromServer).then($1e35148b4c77ec7e$export$e7e6c134f67b83b7).catch($1e35148b4c77ec7e$var$handleNetworkErrors);
};
const $1e35148b4c77ec7e$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new $1e35148b4c77ec7e$export$26e841bcf1aeb894($1e35148b4c77ec7e$var$NETWORK_ERROR_MESSAGE, $1e35148b4c77ec7e$var$NETWORK_ERROR_CODE);
    throw err;
};
const $1e35148b4c77ec7e$var$handleErrors = (response)=>{
    if (!response.ok) {
        const traceId = response.headers.get('atl-traceid');
        // If the traceId is null, it indicates that the request never reached the Atlassian network. In such cases, we should not throw an error. This situation may occur if the request has been intercepted by a firewall or another proxy server. For more details, refer to the discussion in the following Slack thread: https://atlassian.slack.com/archives/C06Q6AC22MV/p1711342785804189?thread_ts=1711335142.173669&cid=C06Q6AC22MV
        if ((0, $HGACo.isFilterNullTraceIdFromGraphqlCallsEnabled)() && !traceId) // If the request does not have a traceId we treat it as a network error.
        throw new $1e35148b4c77ec7e$export$26e841bcf1aeb894($1e35148b4c77ec7e$var$EMPTY_TRACE_ID_ERROR_MESSAGE, $1e35148b4c77ec7e$var$NETWORK_ERROR_CODE);
        if (traceId) // We filter out network errors with traceId from Sentry as they are not actionable and can be investigated from Splunk.
        throw new $1e35148b4c77ec7e$export$26e841bcf1aeb894(`ErrorCode: ${response.status}, traceId: ${traceId}`, response.status, true);
        throw new $1e35148b4c77ec7e$export$26e841bcf1aeb894(`ErrorCode: ${response.status}, traceId: null`, response.status);
    }
    return response;
};
const $1e35148b4c77ec7e$var$processResponseFromServer = (response)=>{
    if (response.status === $1e35148b4c77ec7e$var$NO_CONTENT) return Promise.resolve(null);
    return response.json();
};
const $1e35148b4c77ec7e$export$e7e6c134f67b83b7 = (response)=>{
    const dataEmptyCheck = (0, $HGACo.isGraphqlResponseEmptyCheckEnabled)() && (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && response && typeof response === 'object' && 'data' in response ? (0, $1We2B.isEmpty)(response.data) : true;
    if (response && typeof response === 'object' && // @ts-ignore TS(2339) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Property 'hasOwnProperty' does not exist on type '... Remove this comment to see the full error message
    response.hasOwnProperty('errors') && // @ts-ignore TS(2339) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Property 'hasOwnProperty' does not exist on type '... Remove this comment to see the full error message
    response.hasOwnProperty('extensions') && dataEmptyCheck) {
        var _graphQlResponse$exte, _graphQlResponse$erro3, _graphQlResponse$erro4;
        // throw error from graphql API
        const graphQlResponse = response;
        const traceId = (_graphQlResponse$exte = graphQlResponse.extensions) === null || _graphQlResponse$exte === void 0 || (_graphQlResponse$exte = _graphQlResponse$exte.gateway) === null || _graphQlResponse$exte === void 0 ? void 0 : _graphQlResponse$exte.request_id;
        if (traceId) {
            var _graphQlResponse$erro, _graphQlResponse$erro2;
            throw new $1e35148b4c77ec7e$export$26e841bcf1aeb894(`ErrorCode: ${(_graphQlResponse$erro = graphQlResponse.errors) === null || _graphQlResponse$erro === void 0 || (_graphQlResponse$erro = _graphQlResponse$erro[0]) === null || _graphQlResponse$erro === void 0 ? void 0 : _graphQlResponse$erro.message}, traceId: ${traceId}`, Number((_graphQlResponse$erro2 = graphQlResponse.errors) === null || _graphQlResponse$erro2 === void 0 || (_graphQlResponse$erro2 = _graphQlResponse$erro2[0]) === null || _graphQlResponse$erro2 === void 0 || (_graphQlResponse$erro2 = _graphQlResponse$erro2.extensions) === null || _graphQlResponse$erro2 === void 0 ? void 0 : _graphQlResponse$erro2.statusCode) || 500, true);
        }
        throw new $1e35148b4c77ec7e$export$26e841bcf1aeb894(`Error: ${(_graphQlResponse$erro3 = graphQlResponse.errors) === null || _graphQlResponse$erro3 === void 0 || (_graphQlResponse$erro3 = _graphQlResponse$erro3[0]) === null || _graphQlResponse$erro3 === void 0 ? void 0 : _graphQlResponse$erro3.message}, traceId: null`, Number((_graphQlResponse$erro4 = graphQlResponse.errors) === null || _graphQlResponse$erro4 === void 0 || (_graphQlResponse$erro4 = _graphQlResponse$erro4[0]) === null || _graphQlResponse$erro4 === void 0 || (_graphQlResponse$erro4 = _graphQlResponse$erro4.extensions) === null || _graphQlResponse$erro4 === void 0 ? void 0 : _graphQlResponse$erro4.statusCode) || 500);
    }
    return response;
};
const $1e35148b4c77ec7e$export$ad8c5cf7dd4c3caf = (err)=>{
    return err.status === $1e35148b4c77ec7e$var$NETWORK_ERROR_CODE;
};
const $1e35148b4c77ec7e$export$fa5c2d120eda5e1c = (err)=>{
    if ((0, $HGACo.isPremiumSLAErrorFilterEnabled)()) return err.status < 500;
    return err.status >= 400 && err.status < 500;
};
const $1e35148b4c77ec7e$export$68d314c2a361832e = (err)=>{
    return $1e35148b4c77ec7e$export$ad8c5cf7dd4c3caf(err) || $1e35148b4c77ec7e$export$fa5c2d120eda5e1c(err);
};

});

parcelRegister("3GIk2", function(module, exports) {
$parcel$export(module.exports, "getAggHeaders", () => $d29302de22172538$export$3818fdda9ab5fc7e);

var $jByYr = parcelRequire("jByYr");
const $d29302de22172538$export$3818fdda9ab5fc7e = ()=>({
        'X-B3-TraceId': (0, $jByYr.getMeta)('X-B3-TraceId') || '',
        'atl-attribution': JSON.stringify({
            atlWorkspaceId: (0, $jByYr.getWorkspaceAri)(),
            tenantId: (0, $jByYr.getCloudId)(),
            product: 'Jira',
            service: 'jsm-help-center-ui'
        })
    });

});


parcelRegister("99sQr", function(module, exports) {
$parcel$export(module.exports, "default", () => $25333a8f5d286b09$export$2e2bcd8739ae039);

var $1We2B = parcelRequire("1We2B");

var $8iTFq = parcelRequire("8iTFq");

var $1EFS8 = parcelRequire("1EFS8");

var $hrPHR = parcelRequire("hrPHR");

var $klz3F = parcelRequire("klz3F");

var $3GIk2 = parcelRequire("3GIk2");

var $7PBOc = parcelRequire("7PBOc");
const $25333a8f5d286b09$export$aa8bf897e49821c3 = new Set();
const $25333a8f5d286b09$var$fetchQuery = (request, variables)=>{
    const isJsmScaleTestAggCheckEnabled = (0, $1EFS8.default).checkGate('jsm_scale_60k_testing_in_help_center');
    const isAggAttributionHeadersEnabled = (0, $1EFS8.default).checkGate('jsm-help-center-agg-attribution-headers');
    return (0, $8iTFq.Observable).create((sink)=>{
        const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
        const cachedResponse = requestID ? (0, $7PBOc.QueryResponseCache).get(requestID, variables) : undefined;
        /**
     * If we're on the client and we have a cached response, return it immediately.
     */ if (!(0, $1We2B.isNil)(cachedResponse)) {
            if (requestID != null) (0, $7PBOc.QueryResponseCache).delete(requestID, variables);
            sink.next(cachedResponse);
            sink.complete();
            return;
        }
        const { id: id, operationKind: operationKind, name: queryName } = request;
        const metaData = {
            queryName: queryName,
            operationKind: operationKind
        };
        const AGG_BASE_PATH = id ? `/gateway/api/graphql/pq/${id}` : '/gateway/api/graphql';
        let AGG_PATH = AGG_BASE_PATH;
        if (isJsmScaleTestAggCheckEnabled && (0, $hrPHR.getEnv)().environment !== (0, $hrPHR.EnvType).PROD) {
            const AGG_BRANCH_SLUG = 'branch-issue-remove-rate-limit';
            AGG_PATH = id ? `/gateway/api/graphql/${AGG_BRANCH_SLUG}/graphql/pq/${id}` : `/gateway/api/graphql/${AGG_BRANCH_SLUG}/graphql`;
        }
        const body = JSON.stringify({
            variables: variables
        });
        const promise = (0, $klz3F.fetchJson)(`${AGG_PATH}`, {
            body: body,
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                ...operationKind === 'mutation' && {
                    'X-ExperimentalApi': 'help-object-store-agg-beta, HelpCenterReorderTopics'
                },
                ...isAggAttributionHeadersEnabled && (0, $3GIk2.getAggHeaders)()
            }
        });
        promise.then((response)=>{
            sink.next(response);
            sink.complete();
            return response;
        }).catch((error)=>{
            sink.error(error);
        });
    });
};
var $25333a8f5d286b09$export$2e2bcd8739ae039 = $25333a8f5d286b09$var$fetchQuery;

});
parcelRegister("7PBOc", function(module, exports) {
$parcel$export(module.exports, "QueryResponseCache", () => $ac51fb356856ffb8$export$688bd21be71b9e5d);
/**
 * This implementation is copied from Jira frontend.
 */ 
var $8iTFq = parcelRequire("8iTFq");

var $lut7F = parcelRequire("lut7F");
const $ac51fb356856ffb8$var$CACHE_NAME = 'RELAY_SSR_CACHE';
const $ac51fb356856ffb8$export$611736262b635f8d = (queryID, variables)=>JSON.stringify((0, $8iTFq.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
const $ac51fb356856ffb8$export$1e65e863cf3a0f21 = (cacheKey)=>JSON.parse(cacheKey).queryID;
class $ac51fb356856ffb8$export$be21c283b097d175 extends (0, $8iTFq.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        // Load cached data from the server, if available
        let spaState = {};
        {
            var _document$getElementB;
            const spaStateFromServer = (_document$getElementB = document.getElementById('spa-state')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.getAttribute('data-state');
            try {
                spaState = spaStateFromServer ? JSON.parse(decodeURIComponent(spaStateFromServer)) : {};
            } catch (err) {
                (0, $lut7F.reportError)(err);
            }
        }
        const cachedData = spaState[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(undefined);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        setTimeout(()=>{
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $ac51fb356856ffb8$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $ac51fb356856ffb8$export$688bd21be71b9e5d = new $ac51fb356856ffb8$export$be21c283b097d175({
    cacheName: $ac51fb356856ffb8$var$CACHE_NAME,
    size: Infinity,
    ttl: Infinity
});
const $ac51fb356856ffb8$export$de9cebd147177ad2 = ()=>$ac51fb356856ffb8$export$688bd21be71b9e5d.serialize();

});


parcelRegister("2EjAH", function(module, exports) {
$parcel$export(module.exports, "subscribeOptions", () => $383abbc7246ec04f$export$9bdaf447ae2b3b45);
$parcel$export(module.exports, "subscribe", () => $383abbc7246ec04f$export$ec068583843480e7);

var $8iTFq = parcelRequire("8iTFq");

var $4L08H = parcelRequire("4L08H");

var $MvnMh = parcelRequire("MvnMh");
const $383abbc7246ec04f$export$9bdaf447ae2b3b45 = {
    extensions: {},
    onTrigger: (payload)=>(0, $4L08H.getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            const analyticsPayload = {
                action: 'triggered',
                actionSubject: 'relaySubscription',
                source: 'portal-frontend',
                ...payload
            };
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.getInstance().sendOperationalEvent(analyticsPayload);
        }),
    onError: (payload)=>(0, $4L08H.getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            const analyticsPayload = {
                action: 'failed',
                actionSubject: 'relaySubscription',
                source: 'portal-frontend',
                operationName: payload.operationName,
                requestId: payload.requestId
            };
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.getInstance().sendOperationalEvent(analyticsPayload);
        })
};
const $383abbc7246ec04f$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $8iTFq.Observable).create((sink)=>{
        const client = (0, $MvnMh.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            operationName: operationName,
            variables: variables,
            query: '',
            extensions: {
                pq: id,
                ...$383abbc7246ec04f$export$9bdaf447ae2b3b45.extensions
            }
        };
        let requestId;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        $383abbc7246ec04f$export$9bdaf447ae2b3b45.onTrigger(payload);
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                var _value$extensions;
                const aggRequestId = value === null || value === void 0 || (_value$extensions = value.extensions) === null || _value$extensions === void 0 || (_value$extensions = _value$extensions.gateway) === null || _value$extensions === void 0 ? void 0 : _value$extensions.request_id;
                requestId = aggRequestId ?? requestId;
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = $383abbc7246ec04f$export$ece4736473c28965(sinkError);
                sink.error(errorInfo);
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                $383abbc7246ec04f$export$9bdaf447ae2b3b45.onError({
                    operationName: operationName,
                    requestId: requestId
                });
            }
        });
    });
const $383abbc7246ec04f$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (error instanceof Event) errorInfo = new Error(`Event: ${error.type}`);
    else // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    errorInfo = new Error(`Unknown sink error: ${error}`);
    return errorInfo;
};

});
parcelRegister("MvnMh", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $228d6428061d195d$export$6bb76d6eba7e258c);

var $8YYOl = parcelRequire("8YYOl");

var $iUD5T = parcelRequire("iUD5T");
let $228d6428061d195d$var$client = null;
const $228d6428061d195d$export$6bb76d6eba7e258c = ()=>{
    if ((0, $iUD5T.isSSR)()) return null;
    if ($228d6428061d195d$var$client == null) $228d6428061d195d$var$client = (0, $8YYOl.createClient)({
        url: (0, $iUD5T.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $iUD5T.WS_CLIENT_KEEP_ALIVE),
        retryAttempts: (0, $iUD5T.WS_CLIENT_RETRIES),
        connectionParams: {
            'atl-client-name': 'jira-frontend'
        }
    });
    return $228d6428061d195d$var$client;
};
const $228d6428061d195d$export$2f0afd443356d36f = ()=>{
    $228d6428061d195d$var$client = null;
};

});
parcelRegister("iUD5T", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $a064f87870bbfb0e$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $a064f87870bbfb0e$export$29a72e89601dfc59);
$parcel$export(module.exports, "WS_CLIENT_KEEP_ALIVE", () => $a064f87870bbfb0e$export$8b012b965402e06a);
$parcel$export(module.exports, "WS_CLIENT_RETRIES", () => $a064f87870bbfb0e$export$bf6cd96e19b2987f);
const $a064f87870bbfb0e$export$48d7c418edadb60c = ()=>false ?? false;
const $a064f87870bbfb0e$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
const $a064f87870bbfb0e$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $a064f87870bbfb0e$export$bf6cd96e19b2987f = 100;

});




parcelRegister("8bYXN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b98bc007fc9b4a3$export$2e2bcd8739ae039);

var $klz3F = parcelRequire("klz3F");

var $1EFS8 = parcelRequire("1EFS8");

var $HGACo = parcelRequire("HGACo");

var $hrPHR = parcelRequire("hrPHR");

var $3GIk2 = parcelRequire("3GIk2");
const $3b98bc007fc9b4a3$var$setEndpoint = (endpoint)=>{
    const isJsmScaleTestAggCheckEnabled = (0, $1EFS8.default).checkGate('jsm_scale_60k_testing_in_help_center');
    isJsmScaleTestAggCheckEnabled && ((0, $hrPHR.getEnv)().environment, (0, $hrPHR.EnvType).PROD);
    return endpoint;
};
const $3b98bc007fc9b4a3$var$getHeaders = ()=>{
    if (!(0, $1EFS8.default).checkGate('jsm-help-center-agg-attribution-headers')) return {};
    return (0, $3GIk2.getAggHeaders)();
};
// Refactored from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/92866a25d86943454624c5ac4fe38a59a17ed7d1/help-center/packages/util/fetch/fetch.tsx#fetch.tsx-51:66
const $3b98bc007fc9b4a3$var$NETWORK_ERROR_CODE = 0;
const $3b98bc007fc9b4a3$var$EMPTY_TRACE_ID_ERROR_MESSAGE = 'Failed to fetch got empty traceId';
const $3b98bc007fc9b4a3$var$validateResponse = (_request, gqlData)=>{
    if (typeof gqlData === 'object' && typeof gqlData.data === 'undefined') {
        var _gqlData$extensions;
        const traceId = (_gqlData$extensions = gqlData.extensions) === null || _gqlData$extensions === void 0 || (_gqlData$extensions = _gqlData$extensions.gateway) === null || _gqlData$extensions === void 0 ? void 0 : _gqlData$extensions.request_id;
        const statusCode = $3b98bc007fc9b4a3$var$getErrorStatusCode('errors' in gqlData && gqlData.errors || []);
        if (typeof traceId === 'undefined' && (0, $HGACo.isFilterNullTraceIdFromGraphqlCallsEnabled)()) throw new (0, $klz3F.FetchError)($3b98bc007fc9b4a3$var$EMPTY_TRACE_ID_ERROR_MESSAGE, $3b98bc007fc9b4a3$var$NETWORK_ERROR_CODE);
        if (traceId) throw new (0, $klz3F.FetchError)(`ErrorCode: ${statusCode}, traceId: ${traceId}`, statusCode, true);
    }
    // This function returns the response but this unused.
    // All that we rely upon is thrown errors to ensure that there aren't any problems with the response.
    (0, $klz3F.handleGraphQlErrors)(gqlData);
    // This returns true as the response will be valid if an error is not thrown above.
    return true;
};
function $3b98bc007fc9b4a3$var$errorHasAggErrorExtension(err) {
    if (typeof err !== 'object' || err === null) return false;
    if ('extensions' in err === false || typeof err !== 'object' || err === null) return false;
    if (typeof err.extensions !== 'object' || err.extensions === null || 'statusCode' in err.extensions === false) return false;
    return typeof err.extensions.statusCode === 'number';
}
function $3b98bc007fc9b4a3$var$getErrorStatusCode(errors) {
    var _errorExtension$exten;
    if (Array.isArray(errors) === false) return 200;
    const errorExtension = errors.find($3b98bc007fc9b4a3$var$errorHasAggErrorExtension);
    if (typeof (errorExtension === null || errorExtension === void 0 || (_errorExtension$exten = errorExtension.extensions) === null || _errorExtension$exten === void 0 ? void 0 : _errorExtension$exten.statusCode) !== 'number') return 500;
    return errorExtension.extensions.statusCode;
}
var $3b98bc007fc9b4a3$export$2e2bcd8739ae039 = {
    setEndpoint: $3b98bc007fc9b4a3$var$setEndpoint,
    getHeaders: $3b98bc007fc9b4a3$var$getHeaders,
    validateResponse: $3b98bc007fc9b4a3$var$validateResponse,
    getErrorStatusCode: $3b98bc007fc9b4a3$var$getErrorStatusCode,
    errorHasAggErrorExtension: $3b98bc007fc9b4a3$var$errorHasAggErrorExtension
};

});

parcelRegister("6MsBn", function(module, exports) {
$parcel$export(module.exports, "getRelayDataId", () => $a052c4e7d4b55491$export$944f9dc3d03637c3);

var $HGACo = parcelRequire("HGACo");

var $5PxFh = parcelRequire("5PxFh");
const $a052c4e7d4b55491$export$944f9dc3d03637c3 = (id, typeName)=>{
    if ((0, $HGACo.isFixRelayIdConflictInHelpCenter)()) return (0, $5PxFh.default)({
        id: id
    }, typeName);
    return id;
};

});





parcelRegister("bZZgp", function(module, exports) {
$parcel$export(module.exports, "default", () => $7859f2befdbad098$export$2e2bcd8739ae039);

var $fD1fX = parcelRequire("fD1fX");

var $26t03 = parcelRequire("26t03");

var $7859f2befdbad098$export$2e2bcd8739ae039 = (0, $fD1fX.default);

});
parcelRegister("fD1fX", function(module, exports) {
$parcel$export(module.exports, "default", () => $273bdec95dd5aeb2$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $2NwEO = parcelRequire("2NwEO");

var $gdnRs = parcelRequire("gdnRs");

var $2x96i = parcelRequire("2x96i");

var $cAaWV = parcelRequire("cAaWV");

var $l5LZV = parcelRequire("l5LZV");

var $18KuK = parcelRequire("18KuK");

var $8uTBY = parcelRequire("8uTBY");

var $9TwI7 = parcelRequire("9TwI7");

var $8WiY5 = parcelRequire("8WiY5");

var $f6669 = parcelRequire("f6669");

var $4aDpc = parcelRequire("4aDpc");

var $8UvJf = parcelRequire("8UvJf");
let $273bdec95dd5aeb2$var$tryCompleteHandle;
let $273bdec95dd5aeb2$var$hasMarkedFirstSegmentLoad = false;
/** A portion of the page we apply measurement to */ const $273bdec95dd5aeb2$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party' })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $cAaWV.isUFOEnabled)();
    const parentContext = (0, $8P7DW.useContext)((0, $18KuK.default));
    const segmentIdMap = (0, $8P7DW.useMemo)(()=>{
        if (!(parentContext !== null && parentContext !== void 0 && parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $8P7DW.useMemo)(()=>{
        if (mode === 'single') return (0, $f6669.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $f6669.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $8P7DW.useMemo)(()=>parentContext !== null && parentContext !== void 0 && parentContext.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            } // Only pass non-default types (not 'first-party') in payload to reduce size
        ] : [
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ], [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    const interactionId = (0, $8P7DW.useContext)((0, $8uTBY.default));
    if (interactionId.current != null && !$273bdec95dd5aeb2$var$hasMarkedFirstSegmentLoad) {
        (0, $9TwI7.markFirstSegmentLoad)(interactionId.current, labelStack, performance.now());
        $273bdec95dd5aeb2$var$hasMarkedFirstSegmentLoad = true;
    }
    const interactionContext = (0, $8P7DW.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($273bdec95dd5aeb2$var$tryCompleteHandle) {
                        var _cancelAnimationFrame;
                        (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 || _cancelAnimationFrame($273bdec95dd5aeb2$var$tryCompleteHandle);
                    }
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            var _globalThis$document;
                            const isPageVisible = (globalThis === null || globalThis === void 0 || (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $273bdec95dd5aeb2$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $273bdec95dd5aeb2$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $9TwI7.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $9TwI7.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $2NwEO.unstable_scheduleCallback)((0, $2NwEO.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name, experimental = false) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, experimental);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $9TwI7.addHold)(interactionId.current, labelStack, name, experimental);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $9TwI7.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $9TwI7.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental (name = 'unknown') {
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $cAaWV.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $cAaWV.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    var _activeInteraction$mi;
                    const activeInteraction = (0, $9TwI7.getActiveInteraction)();
                    activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $9TwI7.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $cAaWV.getInteractionRate)(name, 'press');
                if ((0, $2x96i.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $gdnRs.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $l5LZV.setInteractionActiveTrace)(newId, 'press');
                    (0, $9TwI7.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $8WiY5.default).current, (0, $l5LZV.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $9TwI7.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $9TwI7.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $9TwI7.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $9TwI7.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $9TwI7.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $9TwI7.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $9TwI7.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $9TwI7.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $4aDpc.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $8P7DW.useRef)(false);
    const onRender = (0, $8P7DW.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((_getConfig = (0, $cAaWV.getConfig)()) !== null && _getConfig !== void 0 && _getConfig.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $8P7DW.useEffect)(()=>{
        (0, $9TwI7.addSegment)(labelStack);
        return ()=>{
            (0, $9TwI7.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $8P7DW.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: children
    });
    const ufoSegment = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $18KuK.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8UvJf.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args),
        children: ufoSegment
    });
};
$273bdec95dd5aeb2$var$UFOSegment.displayName = 'UFOSegment';
var $273bdec95dd5aeb2$export$2e2bcd8739ae039 = $273bdec95dd5aeb2$var$UFOSegment;

});
parcelRegister("f6669", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7364e774dbe9480$export$2e2bcd8739ae039);
function $b7364e774dbe9480$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $b7364e774dbe9480$export$2e2bcd8739ae039 = $b7364e774dbe9480$var$generateId;

});

parcelRegister("4aDpc", function(module, exports) {
$parcel$export(module.exports, "default", () => $df304d1f3c80ef48$export$2e2bcd8739ae039);

var $6nQJh = parcelRequire("6nQJh");
function $df304d1f3c80ef48$var$scheduleOnPaint(callback) {
    var _process, _globalThis$document;
    const isSSR = typeof window === 'undefined' || Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__) || typeof $6nQJh !== 'undefined' && Boolean((_process = $6nQJh) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $df304d1f3c80ef48$export$2e2bcd8739ae039 = $df304d1f3c80ef48$var$scheduleOnPaint;

});


parcelRegister("26t03", function(module, exports) {
$parcel$export(module.exports, "UFOThirdPartySegment", () => $1547eaad767c92fb$export$5f6fe75c46d0124e);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $18KuK = parcelRequire("18KuK");

var $8uTBY = parcelRequire("8uTBY");

var $9TwI7 = parcelRequire("9TwI7");

var $fD1fX = parcelRequire("fD1fX");
// Event types from ExhaustiveFrameEventTransformMap that carry segment timing data.
const $1547eaad767c92fb$var$SEGMENT_TIMING_EVENTS = new Set([
    // 'user-interacted',
    'navigation-timing',
    // 'resource-timing',
    // 'dcls-score',
    'fcp-snapshot',
    'lcp-snapshot'
]);
/**
 * Reads the segmentId from the UFOInteractionContext that UFOSegment provides
 * to its children, then stores it in a ref accessible to the timeline handler.
 */ function $1547eaad767c92fb$var$IframeSegmentIdReader({ segmentIdRef: segmentIdRef }) {
    const context = (0, $8P7DW.useContext)((0, $18KuK.default));
    const labelStack = context === null || context === void 0 ? void 0 : context.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    if (segmentId && segmentIdRef.current !== segmentId) segmentIdRef.current = segmentId;
    return null;
}
/**
 * Renders null but subscribes to the performance timeline (via onRegisterIframeEventListener)
 * and forwards segment timing events into segment3pTimings. Activated only when
 * onRegisterIframeEventListener is provided to UFOThirdPartySegment.
 *
 * Raw window.postMessage / __ready handling is intentionally not implemented here;
 * consumers (e.g. Forge UI) should push validated events through the same callback.
 */ function $1547eaad767c92fb$var$IframeSegment({ onRegisterIframeEventListener: onRegisterIframeEventListener }) {
    const interactionId = (0, $8P7DW.useContext)((0, $8uTBY.default));
    const segmentIdRef = (0, $8P7DW.useRef)(undefined);
    // Subscribe to the performance event timeline for segment timing data only.
    // (No timing sensitivity — these events arrive well after the listener is registered.)
    (0, $8P7DW.useEffect)(()=>{
        const handleEvent = (event)=>{
            if ($1547eaad767c92fb$var$SEGMENT_TIMING_EVENTS.has(event.type) && interactionId.current && segmentIdRef.current) {
                const { type: type, ...rest } = event;
                (0, $9TwI7.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                    label: type,
                    data: rest
                });
            }
        };
        const unregister = onRegisterIframeEventListener(handleEvent);
        return ()=>{
            unregister();
        };
    }, [
        onRegisterIframeEventListener,
        interactionId
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)($1547eaad767c92fb$var$IframeSegmentIdReader, {
        segmentIdRef: segmentIdRef
    });
}
const $1547eaad767c92fb$export$5f6fe75c46d0124e = (props)=>{
    const { children: children, onRegisterIframeEventListener: onRegisterIframeEventListener, ...otherProps } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $fD1fX.default), {
        type: "third-party",
        ...otherProps,
        children: [
            onRegisterIframeEventListener && /*#__PURE__*/ (0, $gWgPx.jsx)($1547eaad767c92fb$var$IframeSegment, {
                onRegisterIframeEventListener: onRegisterIframeEventListener
            }),
            children
        ]
    });
};
$1547eaad767c92fb$export$5f6fe75c46d0124e.displayName = 'UFOThirdPartySegment';

});


parcelRegister("7kgBm", function(module, exports) {
$parcel$export(module.exports, "install", () => $f23a495186bbeb8b$export$4b3e715f166fdd78);

var $1We2B = parcelRequire("1We2B");
parcelRequire("4N6cH");
var $a1Beh = parcelRequire("a1Beh");
parcelRequire("gV052");
var $4teOe = parcelRequire("4teOe");
const $f23a495186bbeb8b$export$4b3e715f166fdd78 = (0, $1We2B.once)(()=>{
    // asset-field-value is rendered on Request Details; it displays the names of assets linked to the request
    if (typeof window !== 'undefined' && window.customElements) {
        customElements.define('asset-field-value', (0, $a1Beh.getAssetFieldValueElementClass)());
        customElements.define('cmdb-field-value', (0, $4teOe.getCmdbFieldValueElement)());
    }
});

});
parcelRegister("4N6cH", function(module, exports) {
$parcel$export(module.exports, "getAssetFieldValueElementClass", () => (parcelRequire("a1Beh")).getAssetFieldValueElementClass);

var $a1Beh = parcelRequire("a1Beh");

});
parcelRegister("a1Beh", function(module, exports) {
$parcel$export(module.exports, "getAssetFieldValueElementClass", () => $7e0660a799712b80$export$586e8886906ef36f);

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");

var $45a3E = parcelRequire("45a3E");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $Yw2wm = parcelRequire("Yw2wm");

var $ai5ZE = parcelRequire("ai5ZE");

var $ktdLU = parcelRequire("ktdLU");

var $44YJW = parcelRequire("44YJW");

var $lut7F = parcelRequire("lut7F");

var $d1qUE = parcelRequire("d1qUE");
const $7e0660a799712b80$var$onIntlError = (intlError)=>{
    try {
        $lut7F.reportError(intlError);
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $7e0660a799712b80$export$3bcefabe8b04378c = (intlError)=>{
    $7e0660a799712b80$var$onIntlError(`IntlV5: ${intlError.message}`);
};
const $7e0660a799712b80$export$586e8886906ef36f = ()=>{
    class AssetFieldValueElement extends HTMLElement {
        connectedCallback() {
            // create a Shadow DOM (i.e. the contents of this web component)
            const shadow = this.attachShadow({
                mode: 'open'
            });
            // Jira passes the asset's origin as a data-origin attribute
            const origin = this.getAttribute('data-origin');
            if ((0, $HGACo.isUseReact18CreateRootEnabled)()) {
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                const container = document.createElement('span');
                const root = (0, $Yw2wm.createRoot)(container);
                root.render(// @ts-ignore
                /*#__PURE__*/ $8P7DW.createElement((0, $45a3E.IntlProvider), {
                    messages: (0, $ktdLU.default)(),
                    locale: (0, $44YJW.getLanguageFromLocale)((0, $jByYr.getMetaData)().userLocale),
                    onError: $7e0660a799712b80$var$onIntlError
                }, /*#__PURE__*/ $8P7DW.createElement((0, $ai5ZE.default), {
                    messages: (0, $ktdLU.default)(),
                    locale: (0, $44YJW.getLanguageFromLocale)((0, $jByYr.getMetaData)().userLocale),
                    onError: $7e0660a799712b80$export$3bcefabe8b04378c
                }, /*#__PURE__*/ $8P7DW.createElement((0, $d1qUE.default), {
                    origin: origin
                }))));
                shadow.appendChild(container);
            } else {
                // render the component with its props, and add to the Shadow DOM
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                const root = document.createElement('span');
                // eslint-disable-next-line react/no-deprecated
                $6Q1OD.render(// @ts-ignore
                /*#__PURE__*/ $8P7DW.createElement((0, $45a3E.IntlProvider), {
                    messages: (0, $ktdLU.default)(),
                    locale: (0, $44YJW.getLanguageFromLocale)((0, $jByYr.getMetaData)().userLocale),
                    onError: $7e0660a799712b80$var$onIntlError
                }, /*#__PURE__*/ $8P7DW.createElement((0, $ai5ZE.default), {
                    messages: (0, $ktdLU.default)(),
                    locale: (0, $44YJW.getLanguageFromLocale)((0, $jByYr.getMetaData)().userLocale),
                    onError: $7e0660a799712b80$export$3bcefabe8b04378c
                }, /*#__PURE__*/ $8P7DW.createElement((0, $d1qUE.default), {
                    origin: origin
                }))), root);
                shadow.appendChild(root);
            }
        }
    }
    return AssetFieldValueElement;
};

});
parcelRegister("45a3E", function(module, exports) {
$parcel$export(module.exports, "addLocaleData", () => $2f8f6e5af3274a3b$export$9b0a0997606861b1);
$parcel$export(module.exports, "defineMessages", () => $2f8f6e5af3274a3b$export$1adfeb024f5185b);
$parcel$export(module.exports, "IntlProvider", () => $2f8f6e5af3274a3b$export$480518999dfc4151);
/*
 * Copyright 2018, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $lOPnY = parcelRequire("lOPnY");

var $hOqQy = parcelRequire("hOqQy");

var $lUE6N = parcelRequire("lUE6N");

var $93Fg7 = parcelRequire("93Fg7");

var $8P7DW = parcelRequire("8P7DW");

var $lqUhi = parcelRequire("lqUhi");

var $3rEVE = parcelRequire("3rEVE");

var $1SVIu = parcelRequire("1SVIu");
// GENERATED FILE
var $2f8f6e5af3274a3b$var$defaultLocaleData = {
    "locale": "en",
    "pluralRuleFunction": function pluralRuleFunction(n, ord) {
        var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
        return n == 1 && v0 ? "one" : "other";
    },
    "fields": {
        "year": {
            "displayName": "year",
            "relative": {
                "0": "this year",
                "1": "next year",
                "-1": "last year"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} year",
                    "other": "in {0} years"
                },
                "past": {
                    "one": "{0} year ago",
                    "other": "{0} years ago"
                }
            }
        },
        "month": {
            "displayName": "month",
            "relative": {
                "0": "this month",
                "1": "next month",
                "-1": "last month"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} month",
                    "other": "in {0} months"
                },
                "past": {
                    "one": "{0} month ago",
                    "other": "{0} months ago"
                }
            }
        },
        "day": {
            "displayName": "day",
            "relative": {
                "0": "today",
                "1": "tomorrow",
                "-1": "yesterday"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} day",
                    "other": "in {0} days"
                },
                "past": {
                    "one": "{0} day ago",
                    "other": "{0} days ago"
                }
            }
        },
        "hour": {
            "displayName": "hour",
            "relative": {
                "0": "this hour"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} hour",
                    "other": "in {0} hours"
                },
                "past": {
                    "one": "{0} hour ago",
                    "other": "{0} hours ago"
                }
            }
        },
        "minute": {
            "displayName": "minute",
            "relative": {
                "0": "this minute"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} minute",
                    "other": "in {0} minutes"
                },
                "past": {
                    "one": "{0} minute ago",
                    "other": "{0} minutes ago"
                }
            }
        },
        "second": {
            "displayName": "second",
            "relative": {
                "0": "now"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} second",
                    "other": "in {0} seconds"
                },
                "past": {
                    "one": "{0} second ago",
                    "other": "{0} seconds ago"
                }
            }
        }
    }
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ function $2f8f6e5af3274a3b$export$9b0a0997606861b1() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var locales = Array.isArray(data) ? data : [
        data
    ];
    locales.forEach(function(localeData) {
        if (localeData && localeData.locale) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hOqQy))).__addLocaleData(localeData);
            (0, (/*@__PURE__*/$parcel$interopDefault($lUE6N))).__addLocaleData(localeData);
        }
    });
}
function $2f8f6e5af3274a3b$var$hasLocaleData(locale) {
    var localeParts = (locale || '').split('-');
    while(localeParts.length > 0){
        if ($2f8f6e5af3274a3b$var$hasIMFAndIRFLocaleData(localeParts.join('-'))) return true;
        localeParts.pop();
    }
    return false;
}
function $2f8f6e5af3274a3b$var$hasIMFAndIRFLocaleData(locale) {
    var normalizedLocale = locale && locale.toLowerCase();
    return !!((0, (/*@__PURE__*/$parcel$interopDefault($hOqQy))).__localeData__[normalizedLocale] && (0, (/*@__PURE__*/$parcel$interopDefault($lUE6N))).__localeData__[normalizedLocale]);
}
var $2f8f6e5af3274a3b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $2f8f6e5af3274a3b$var$asyncGenerator = function() {
    function AwaitValue(value) {
        this.value = value;
    }
    function AsyncGenerator(gen) {
        var front, back;
        function send(key, arg) {
            return new Promise(function(resolve, reject) {
                var request = {
                    key: key,
                    arg: arg,
                    resolve: resolve,
                    reject: reject,
                    next: null
                };
                if (back) back = back.next = request;
                else {
                    front = back = request;
                    resume(key, arg);
                }
            });
        }
        function resume(key, arg) {
            try {
                var result = gen[key](arg);
                var value = result.value;
                if (value instanceof AwaitValue) Promise.resolve(value.value).then(function(arg) {
                    resume("next", arg);
                }, function(arg) {
                    resume("throw", arg);
                });
                else settle(result.done ? "return" : "normal", result.value);
            } catch (err) {
                settle("throw", err);
            }
        }
        function settle(type, value) {
            switch(type){
                case "return":
                    front.resolve({
                        value: value,
                        done: true
                    });
                    break;
                case "throw":
                    front.reject(value);
                    break;
                default:
                    front.resolve({
                        value: value,
                        done: false
                    });
                    break;
            }
            front = front.next;
            if (front) resume(front.key, front.arg);
            else back = null;
        }
        this._invoke = send;
        if (typeof gen.return !== "function") this.return = undefined;
    }
    if (typeof Symbol === "function" && Symbol.asyncIterator) AsyncGenerator.prototype[Symbol.asyncIterator] = function() {
        return this;
    };
    AsyncGenerator.prototype.next = function(arg) {
        return this._invoke("next", arg);
    };
    AsyncGenerator.prototype.throw = function(arg) {
        return this._invoke("throw", arg);
    };
    AsyncGenerator.prototype.return = function(arg) {
        return this._invoke("return", arg);
    };
    return {
        wrap: function(fn) {
            return function() {
                return new AsyncGenerator(fn.apply(this, arguments));
            };
        },
        await: function(value) {
            return new AwaitValue(value);
        }
    };
}();
var $2f8f6e5af3274a3b$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $2f8f6e5af3274a3b$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $2f8f6e5af3274a3b$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $2f8f6e5af3274a3b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2f8f6e5af3274a3b$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $2f8f6e5af3274a3b$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $2f8f6e5af3274a3b$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $2f8f6e5af3274a3b$var$toConsumableArray = function(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$var$bool = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).bool;
var $2f8f6e5af3274a3b$var$number = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).number;
var $2f8f6e5af3274a3b$var$string = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).string;
var $2f8f6e5af3274a3b$var$func = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func;
var $2f8f6e5af3274a3b$var$object = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).object;
var $2f8f6e5af3274a3b$var$oneOf = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).oneOf;
var $2f8f6e5af3274a3b$var$shape = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).shape;
var $2f8f6e5af3274a3b$var$any = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).any;
var $2f8f6e5af3274a3b$var$oneOfType = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).oneOfType;
var $2f8f6e5af3274a3b$var$localeMatcher = $2f8f6e5af3274a3b$var$oneOf([
    'best fit',
    'lookup'
]);
var $2f8f6e5af3274a3b$var$narrowShortLong = $2f8f6e5af3274a3b$var$oneOf([
    'narrow',
    'short',
    'long'
]);
var $2f8f6e5af3274a3b$var$numeric2digit = $2f8f6e5af3274a3b$var$oneOf([
    'numeric',
    '2-digit'
]);
var $2f8f6e5af3274a3b$var$funcReq = $2f8f6e5af3274a3b$var$func.isRequired;
var $2f8f6e5af3274a3b$var$intlConfigPropTypes = {
    locale: $2f8f6e5af3274a3b$var$string,
    timeZone: $2f8f6e5af3274a3b$var$string,
    formats: $2f8f6e5af3274a3b$var$object,
    messages: $2f8f6e5af3274a3b$var$object,
    textComponent: $2f8f6e5af3274a3b$var$any,
    defaultLocale: $2f8f6e5af3274a3b$var$string,
    defaultFormats: $2f8f6e5af3274a3b$var$object
};
var $2f8f6e5af3274a3b$var$intlFormatPropTypes = {
    formatDate: $2f8f6e5af3274a3b$var$funcReq,
    formatTime: $2f8f6e5af3274a3b$var$funcReq,
    formatRelative: $2f8f6e5af3274a3b$var$funcReq,
    formatNumber: $2f8f6e5af3274a3b$var$funcReq,
    formatPlural: $2f8f6e5af3274a3b$var$funcReq,
    formatMessage: $2f8f6e5af3274a3b$var$funcReq,
    formatHTMLMessage: $2f8f6e5af3274a3b$var$funcReq
};
var $2f8f6e5af3274a3b$export$db9134ac6ad368cf = $2f8f6e5af3274a3b$var$shape($2f8f6e5af3274a3b$var$_extends({}, $2f8f6e5af3274a3b$var$intlConfigPropTypes, $2f8f6e5af3274a3b$var$intlFormatPropTypes, {
    formatters: $2f8f6e5af3274a3b$var$object,
    now: $2f8f6e5af3274a3b$var$funcReq
}));
var $2f8f6e5af3274a3b$var$messageDescriptorPropTypes = {
    id: $2f8f6e5af3274a3b$var$string.isRequired,
    description: $2f8f6e5af3274a3b$var$oneOfType([
        $2f8f6e5af3274a3b$var$string,
        $2f8f6e5af3274a3b$var$object
    ]),
    defaultMessage: $2f8f6e5af3274a3b$var$string
};
var $2f8f6e5af3274a3b$var$dateTimeFormatPropTypes = {
    localeMatcher: $2f8f6e5af3274a3b$var$localeMatcher,
    formatMatcher: $2f8f6e5af3274a3b$var$oneOf([
        'basic',
        'best fit'
    ]),
    timeZone: $2f8f6e5af3274a3b$var$string,
    hour12: $2f8f6e5af3274a3b$var$bool,
    weekday: $2f8f6e5af3274a3b$var$narrowShortLong,
    era: $2f8f6e5af3274a3b$var$narrowShortLong,
    year: $2f8f6e5af3274a3b$var$numeric2digit,
    month: $2f8f6e5af3274a3b$var$oneOf([
        'numeric',
        '2-digit',
        'narrow',
        'short',
        'long'
    ]),
    day: $2f8f6e5af3274a3b$var$numeric2digit,
    hour: $2f8f6e5af3274a3b$var$numeric2digit,
    minute: $2f8f6e5af3274a3b$var$numeric2digit,
    second: $2f8f6e5af3274a3b$var$numeric2digit,
    timeZoneName: $2f8f6e5af3274a3b$var$oneOf([
        'short',
        'long'
    ])
};
var $2f8f6e5af3274a3b$var$numberFormatPropTypes = {
    localeMatcher: $2f8f6e5af3274a3b$var$localeMatcher,
    style: $2f8f6e5af3274a3b$var$oneOf([
        'decimal',
        'currency',
        'percent'
    ]),
    currency: $2f8f6e5af3274a3b$var$string,
    currencyDisplay: $2f8f6e5af3274a3b$var$oneOf([
        'symbol',
        'code',
        'name'
    ]),
    useGrouping: $2f8f6e5af3274a3b$var$bool,
    minimumIntegerDigits: $2f8f6e5af3274a3b$var$number,
    minimumFractionDigits: $2f8f6e5af3274a3b$var$number,
    maximumFractionDigits: $2f8f6e5af3274a3b$var$number,
    minimumSignificantDigits: $2f8f6e5af3274a3b$var$number,
    maximumSignificantDigits: $2f8f6e5af3274a3b$var$number
};
var $2f8f6e5af3274a3b$var$relativeFormatPropTypes = {
    style: $2f8f6e5af3274a3b$var$oneOf([
        'best fit',
        'numeric'
    ]),
    units: $2f8f6e5af3274a3b$var$oneOf([
        'second',
        'minute',
        'hour',
        'day',
        'month',
        'year',
        'second-short',
        'minute-short',
        'hour-short',
        'day-short',
        'month-short',
        'year-short'
    ])
};
var $2f8f6e5af3274a3b$var$pluralFormatPropTypes = {
    style: $2f8f6e5af3274a3b$var$oneOf([
        'cardinal',
        'ordinal'
    ])
};
/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/ var $2f8f6e5af3274a3b$var$intlConfigPropNames = Object.keys($2f8f6e5af3274a3b$var$intlConfigPropTypes);
var $2f8f6e5af3274a3b$var$ESCAPED_CHARS = {
    '&': '&amp;',
    '>': '&gt;',
    '<': '&lt;',
    '"': '&quot;',
    "'": '&#x27;'
};
var $2f8f6e5af3274a3b$var$UNSAFE_CHARS_REGEX = /[&><"']/g;
function $2f8f6e5af3274a3b$var$escape(str) {
    return ('' + str).replace($2f8f6e5af3274a3b$var$UNSAFE_CHARS_REGEX, function(match) {
        return $2f8f6e5af3274a3b$var$ESCAPED_CHARS[match];
    });
}
function $2f8f6e5af3274a3b$var$filterProps(props, whitelist) {
    var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return whitelist.reduce(function(filtered, name) {
        if (props.hasOwnProperty(name)) filtered[name] = props[name];
        else if (defaults$$1.hasOwnProperty(name)) filtered[name] = defaults$$1[name];
        return filtered;
    }, {});
}
function $2f8f6e5af3274a3b$var$invariantIntlContext() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, intl = _ref.intl;
    (0, (/*@__PURE__*/$parcel$interopDefault($3rEVE)))(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
function $2f8f6e5af3274a3b$var$shallowEquals(objA, objB) {
    if (objA === objB) return true;
    if ((typeof objA === 'undefined' ? 'undefined' : $2f8f6e5af3274a3b$var$_typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : $2f8f6e5af3274a3b$var$_typeof(objB)) !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for(var i = 0; i < keysA.length; i++){
        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
function $2f8f6e5af3274a3b$var$shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
    var props = _ref2.props, state = _ref2.state, _ref2$context = _ref2.context, context = _ref2$context === undefined ? {} : _ref2$context;
    var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _context$intl = context.intl, intl = _context$intl === undefined ? {} : _context$intl;
    var _nextContext$intl = nextContext.intl, nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
    return !$2f8f6e5af3274a3b$var$shallowEquals(nextProps, props) || !$2f8f6e5af3274a3b$var$shallowEquals(nextState, state) || !(nextIntl === intl || $2f8f6e5af3274a3b$var$shallowEquals($2f8f6e5af3274a3b$var$filterProps(nextIntl, $2f8f6e5af3274a3b$var$intlConfigPropNames), $2f8f6e5af3274a3b$var$filterProps(intl, $2f8f6e5af3274a3b$var$intlConfigPropNames)));
}
function $2f8f6e5af3274a3b$var$createError(message, exception) {
    var eMsg = exception ? '\n' + exception : '';
    return '[React Intl] ' + message + eMsg;
}
function $2f8f6e5af3274a3b$var$defaultErrorHandler(error) {}
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ // Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux
function $2f8f6e5af3274a3b$var$getDisplayName(Component$$1) {
    return Component$$1.displayName || Component$$1.name || 'Component';
}
function $2f8f6e5af3274a3b$export$3afb67c2a576ab2c(WrappedComponent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$intlPropName = options.intlPropName, intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName, _options$withRef = options.withRef, withRef = _options$withRef === undefined ? false : _options$withRef;
    var InjectIntl = function(_Component) {
        $2f8f6e5af3274a3b$var$inherits(InjectIntl, _Component);
        function InjectIntl(props, context) {
            $2f8f6e5af3274a3b$var$classCallCheck(this, InjectIntl);
            var _this = $2f8f6e5af3274a3b$var$possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
            $2f8f6e5af3274a3b$var$invariantIntlContext(context);
            return _this;
        }
        $2f8f6e5af3274a3b$var$createClass(InjectIntl, [
            {
                key: 'getWrappedInstance',
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($3rEVE)))(withRef, "[React Intl] To access the wrapped instance, the `{withRef: true}` option must be set when calling: `injectIntl()`");
                    return this.refs.wrappedInstance;
                }
            },
            {
                key: 'render',
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, $2f8f6e5af3274a3b$var$_extends({}, this.props, $2f8f6e5af3274a3b$var$defineProperty({}, intlPropName, this.context.intl), {
                        ref: withRef ? 'wrappedInstance' : null
                    }));
                }
            }
        ]);
        return InjectIntl;
    }((0, $8P7DW.Component));
    InjectIntl.displayName = 'InjectIntl(' + $2f8f6e5af3274a3b$var$getDisplayName(WrappedComponent) + ')';
    InjectIntl.contextTypes = {
        intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf
    };
    InjectIntl.WrappedComponent = WrappedComponent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lqUhi)))(InjectIntl, WrappedComponent);
}
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ function $2f8f6e5af3274a3b$export$1adfeb024f5185b(messageDescriptors) {
    // This simply returns what's passed-in because it's meant to be a hook for
    // babel-plugin-react-intl.
    return messageDescriptors;
}
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ // This is a "hack" until a proper `intl-pluralformat` package is created.
function $2f8f6e5af3274a3b$var$resolveLocale(locales) {
    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
    return (0, (/*@__PURE__*/$parcel$interopDefault($hOqQy))).prototype._resolveLocale(locales);
}
function $2f8f6e5af3274a3b$var$findPluralFunction(locale) {
    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
    return (0, (/*@__PURE__*/$parcel$interopDefault($hOqQy))).prototype._findPluralRuleFunction(locale);
}
var $2f8f6e5af3274a3b$var$IntlPluralFormat = function IntlPluralFormat(locales) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $2f8f6e5af3274a3b$var$classCallCheck(this, IntlPluralFormat);
    var useOrdinal = options.style === 'ordinal';
    var pluralFn = $2f8f6e5af3274a3b$var$findPluralFunction($2f8f6e5af3274a3b$var$resolveLocale(locales));
    this.format = function(value) {
        return pluralFn(value, useOrdinal);
    };
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$var$DATE_TIME_FORMAT_OPTIONS = Object.keys($2f8f6e5af3274a3b$var$dateTimeFormatPropTypes);
var $2f8f6e5af3274a3b$var$NUMBER_FORMAT_OPTIONS = Object.keys($2f8f6e5af3274a3b$var$numberFormatPropTypes);
var $2f8f6e5af3274a3b$var$RELATIVE_FORMAT_OPTIONS = Object.keys($2f8f6e5af3274a3b$var$relativeFormatPropTypes);
var $2f8f6e5af3274a3b$var$PLURAL_FORMAT_OPTIONS = Object.keys($2f8f6e5af3274a3b$var$pluralFormatPropTypes);
var $2f8f6e5af3274a3b$var$RELATIVE_FORMAT_THRESHOLDS = {
    second: 60,
    minute: 60,
    hour: 24,
    day: 30,
    month: 12
};
function $2f8f6e5af3274a3b$var$updateRelativeFormatThresholds(newThresholds) {
    var thresholds = (0, (/*@__PURE__*/$parcel$interopDefault($lUE6N))).thresholds;
    thresholds.second = newThresholds.second;
    thresholds.minute = newThresholds.minute;
    thresholds.hour = newThresholds.hour;
    thresholds.day = newThresholds.day;
    thresholds.month = newThresholds.month;
    thresholds['second-short'] = newThresholds['second-short'];
    thresholds['minute-short'] = newThresholds['minute-short'];
    thresholds['hour-short'] = newThresholds['hour-short'];
    thresholds['day-short'] = newThresholds['day-short'];
    thresholds['month-short'] = newThresholds['month-short'];
}
function $2f8f6e5af3274a3b$var$getNamedFormat(formats, type, name, onError) {
    var format = formats && formats[type] && formats[type][name];
    if (format) return format;
    onError($2f8f6e5af3274a3b$var$createError('No ' + type + ' format named: ' + name));
}
function $2f8f6e5af3274a3b$var$formatDate(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats, timeZone = config.timeZone;
    var format = options.format;
    var onError = config.onError || $2f8f6e5af3274a3b$var$defaultErrorHandler;
    var date = new Date(value);
    var defaults$$1 = $2f8f6e5af3274a3b$var$_extends({}, timeZone && {
        timeZone: timeZone
    }, format && $2f8f6e5af3274a3b$var$getNamedFormat(formats, 'date', format, onError));
    var filteredOptions = $2f8f6e5af3274a3b$var$filterProps(options, $2f8f6e5af3274a3b$var$DATE_TIME_FORMAT_OPTIONS, defaults$$1);
    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        onError($2f8f6e5af3274a3b$var$createError('Error formatting date.', e));
    }
    return String(date);
}
function $2f8f6e5af3274a3b$var$formatTime(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats, timeZone = config.timeZone;
    var format = options.format;
    var onError = config.onError || $2f8f6e5af3274a3b$var$defaultErrorHandler;
    var date = new Date(value);
    var defaults$$1 = $2f8f6e5af3274a3b$var$_extends({}, timeZone && {
        timeZone: timeZone
    }, format && $2f8f6e5af3274a3b$var$getNamedFormat(formats, 'time', format, onError));
    var filteredOptions = $2f8f6e5af3274a3b$var$filterProps(options, $2f8f6e5af3274a3b$var$DATE_TIME_FORMAT_OPTIONS, defaults$$1);
    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = $2f8f6e5af3274a3b$var$_extends({}, filteredOptions, {
        hour: 'numeric',
        minute: 'numeric'
    });
    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        onError($2f8f6e5af3274a3b$var$createError('Error formatting time.', e));
    }
    return String(date);
}
function $2f8f6e5af3274a3b$var$formatRelative(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats;
    var format = options.format;
    var onError = config.onError || $2f8f6e5af3274a3b$var$defaultErrorHandler;
    var date = new Date(value);
    var now = new Date(options.now);
    var defaults$$1 = format && $2f8f6e5af3274a3b$var$getNamedFormat(formats, 'relative', format, onError);
    var filteredOptions = $2f8f6e5af3274a3b$var$filterProps(options, $2f8f6e5af3274a3b$var$RELATIVE_FORMAT_OPTIONS, defaults$$1);
    // Capture the current threshold values, then temporarily override them with
    // specific values just for this render.
    var oldThresholds = $2f8f6e5af3274a3b$var$_extends({}, (0, (/*@__PURE__*/$parcel$interopDefault($lUE6N))).thresholds);
    $2f8f6e5af3274a3b$var$updateRelativeFormatThresholds($2f8f6e5af3274a3b$var$RELATIVE_FORMAT_THRESHOLDS);
    try {
        return state.getRelativeFormat(locale, filteredOptions).format(date, {
            now: isFinite(now) ? now : state.now()
        });
    } catch (e) {
        onError($2f8f6e5af3274a3b$var$createError('Error formatting relative time.', e));
    } finally{
        $2f8f6e5af3274a3b$var$updateRelativeFormatThresholds(oldThresholds);
    }
    return String(date);
}
function $2f8f6e5af3274a3b$var$formatNumber(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats;
    var format = options.format;
    var onError = config.onError || $2f8f6e5af3274a3b$var$defaultErrorHandler;
    var defaults$$1 = format && $2f8f6e5af3274a3b$var$getNamedFormat(formats, 'number', format, onError);
    var filteredOptions = $2f8f6e5af3274a3b$var$filterProps(options, $2f8f6e5af3274a3b$var$NUMBER_FORMAT_OPTIONS, defaults$$1);
    try {
        return state.getNumberFormat(locale, filteredOptions).format(value);
    } catch (e) {
        onError($2f8f6e5af3274a3b$var$createError('Error formatting number.', e));
    }
    return String(value);
}
function $2f8f6e5af3274a3b$var$formatPlural(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale;
    var filteredOptions = $2f8f6e5af3274a3b$var$filterProps(options, $2f8f6e5af3274a3b$var$PLURAL_FORMAT_OPTIONS);
    var onError = config.onError || $2f8f6e5af3274a3b$var$defaultErrorHandler;
    try {
        return state.getPluralFormat(locale, filteredOptions).format(value);
    } catch (e) {
        onError($2f8f6e5af3274a3b$var$createError('Error formatting plural.', e));
    }
    return 'other';
}
function $2f8f6e5af3274a3b$var$formatMessage(config, state) {
    var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats, messages = config.messages, defaultLocale = config.defaultLocale, defaultFormats = config.defaultFormats;
    var id = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, (/*@__PURE__*/$parcel$interopDefault($3rEVE)))(id, '[React Intl] An `id` must be provided to format a message.');
    var message = messages && messages[id];
    var hasValues = Object.keys(values).length > 0;
    // Avoid expensive message formatting for simple messages without values. In
    // development messages will always be formatted in case of missing values.
    if (!hasValues && true) return message || defaultMessage || id;
    var formattedMessage = void 0;
    var onError = config.onError || $2f8f6e5af3274a3b$var$defaultErrorHandler;
    if (message) try {
        var formatter = state.getMessageFormat(message, locale, formats);
        formattedMessage = formatter.format(values);
    } catch (e) {
        onError($2f8f6e5af3274a3b$var$createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
    else // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) onError($2f8f6e5af3274a3b$var$createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    if (!formattedMessage && defaultMessage) try {
        var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
        formattedMessage = _formatter.format(values);
    } catch (e) {
        onError($2f8f6e5af3274a3b$var$createError('Error formatting the default message for: "' + id + '"', e));
    }
    if (!formattedMessage) onError($2f8f6e5af3274a3b$var$createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
    return formattedMessage || message || defaultMessage || id;
}
function $2f8f6e5af3274a3b$var$formatHTMLMessage(config, state, messageDescriptor) {
    var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // Process all the values before they are used when formatting the ICU
    // Message string. Since the formatted message might be injected via
    // `innerHTML`, all String-based values need to be HTML-escaped.
    var escapedValues = Object.keys(rawValues).reduce(function(escaped, name) {
        var value = rawValues[name];
        escaped[name] = typeof value === 'string' ? $2f8f6e5af3274a3b$var$escape(value) : value;
        return escaped;
    }, {});
    return $2f8f6e5af3274a3b$var$formatMessage(config, state, messageDescriptor, escapedValues);
}
var $2f8f6e5af3274a3b$var$format = Object.freeze({
    formatDate: $2f8f6e5af3274a3b$var$formatDate,
    formatTime: $2f8f6e5af3274a3b$var$formatTime,
    formatRelative: $2f8f6e5af3274a3b$var$formatRelative,
    formatNumber: $2f8f6e5af3274a3b$var$formatNumber,
    formatPlural: $2f8f6e5af3274a3b$var$formatPlural,
    formatMessage: $2f8f6e5af3274a3b$var$formatMessage,
    formatHTMLMessage: $2f8f6e5af3274a3b$var$formatHTMLMessage
});
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$var$intlConfigPropNames$1 = Object.keys($2f8f6e5af3274a3b$var$intlConfigPropTypes);
var $2f8f6e5af3274a3b$var$intlFormatPropNames = Object.keys($2f8f6e5af3274a3b$var$intlFormatPropTypes);
// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var $2f8f6e5af3274a3b$var$defaultProps = {
    formats: {},
    messages: {},
    timeZone: null,
    textComponent: 'span',
    defaultLocale: 'en',
    defaultFormats: {},
    onError: $2f8f6e5af3274a3b$var$defaultErrorHandler
};
var $2f8f6e5af3274a3b$export$480518999dfc4151 = function(_Component) {
    $2f8f6e5af3274a3b$var$inherits(IntlProvider, _Component);
    function IntlProvider(props) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $2f8f6e5af3274a3b$var$classCallCheck(this, IntlProvider);
        var _this = $2f8f6e5af3274a3b$var$possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
        (0, (/*@__PURE__*/$parcel$interopDefault($3rEVE)))(typeof Intl !== 'undefined', "[React Intl] The `Intl` APIs must be available in the runtime, and do not appear to be built-in. An `Intl` polyfill should be loaded.\nSee: http://formatjs.io/guides/runtime-environments/");
        var intlContext = context.intl;
        // Used to stabilize time when performing an initial rendering so that
        // all relative times use the same reference "now" time.
        var initialNow = void 0;
        if (isFinite(props.initialNow)) initialNow = Number(props.initialNow);
        else // When an `initialNow` isn't provided via `props`, look to see an
        // <IntlProvider> exists in the ancestry and call its `now()`
        // function to propagate its value for "now".
        initialNow = intlContext ? intlContext.now() : Date.now();
        // Creating `Intl*` formatters is expensive. If there's a parent
        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
        // memoize the `Intl*` constructors and cache them for the lifecycle of
        // this IntlProvider instance.
        var _ref = intlContext || {}, _ref$formatters = _ref.formatters, formatters = _ref$formatters === undefined ? {
            getDateTimeFormat: (0, (/*@__PURE__*/$parcel$interopDefault($1SVIu)))(Intl.DateTimeFormat),
            getNumberFormat: (0, (/*@__PURE__*/$parcel$interopDefault($1SVIu)))(Intl.NumberFormat),
            getMessageFormat: (0, (/*@__PURE__*/$parcel$interopDefault($1SVIu)))((0, (/*@__PURE__*/$parcel$interopDefault($hOqQy)))),
            getRelativeFormat: (0, (/*@__PURE__*/$parcel$interopDefault($1SVIu)))((0, (/*@__PURE__*/$parcel$interopDefault($lUE6N)))),
            getPluralFormat: (0, (/*@__PURE__*/$parcel$interopDefault($1SVIu)))($2f8f6e5af3274a3b$var$IntlPluralFormat)
        } : _ref$formatters;
        _this.state = $2f8f6e5af3274a3b$var$_extends({}, formatters, {
            // Wrapper to provide stable "now" time for initial render.
            now: function now() {
                return _this._didDisplay ? Date.now() : initialNow;
            }
        });
        return _this;
    }
    $2f8f6e5af3274a3b$var$createClass(IntlProvider, [
        {
            key: 'getConfig',
            value: function getConfig() {
                var intlContext = this.context.intl;
                // Build a whitelisted config object from `props`, defaults, and
                // `context.intl`, if an <IntlProvider> exists in the ancestry.
                var config = $2f8f6e5af3274a3b$var$filterProps(this.props, $2f8f6e5af3274a3b$var$intlConfigPropNames$1, intlContext);
                // Apply default props. This must be applied last after the props have
                // been resolved and inherited from any <IntlProvider> in the ancestry.
                // This matches how React resolves `defaultProps`.
                for(var propName in $2f8f6e5af3274a3b$var$defaultProps)if (config[propName] === undefined) config[propName] = $2f8f6e5af3274a3b$var$defaultProps[propName];
                if (!$2f8f6e5af3274a3b$var$hasLocaleData(config.locale)) {
                    var _config = config, locale = _config.locale, defaultLocale = _config.defaultLocale, defaultFormats = _config.defaultFormats, onError = _config.onError;
                    onError($2f8f6e5af3274a3b$var$createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));
                    // Since there's no registered locale data for `locale`, this will
                    // fallback to the `defaultLocale` to make sure things can render.
                    // The `messages` are overridden to the `defaultProps` empty object
                    // to maintain referential equality across re-renders. It's assumed
                    // each <FormattedMessage> contains a `defaultMessage` prop.
                    config = $2f8f6e5af3274a3b$var$_extends({}, config, {
                        locale: defaultLocale,
                        formats: defaultFormats,
                        messages: $2f8f6e5af3274a3b$var$defaultProps.messages
                    });
                }
                return config;
            }
        },
        {
            key: 'getBoundFormatFns',
            value: function getBoundFormatFns(config, state) {
                return $2f8f6e5af3274a3b$var$intlFormatPropNames.reduce(function(boundFormatFns, name) {
                    boundFormatFns[name] = $2f8f6e5af3274a3b$var$format[name].bind(null, config, state);
                    return boundFormatFns;
                }, {});
            }
        },
        {
            key: 'getChildContext',
            value: function getChildContext() {
                var config = this.getConfig();
                // Bind intl factories and current config to the format functions.
                var boundFormatFns = this.getBoundFormatFns(config, this.state);
                var _state = this.state, now = _state.now, formatters = $2f8f6e5af3274a3b$var$objectWithoutProperties(_state, [
                    'now'
                ]);
                return {
                    intl: $2f8f6e5af3274a3b$var$_extends({}, config, boundFormatFns, {
                        formatters: formatters,
                        now: now
                    })
                };
            }
        },
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $2f8f6e5af3274a3b$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this._didDisplay = true;
            }
        },
        {
            key: 'render',
            value: function render() {
                return (0, $8P7DW.Children).only(this.props.children);
            }
        }
    ]);
    return IntlProvider;
}((0, $8P7DW.Component));
$2f8f6e5af3274a3b$export$480518999dfc4151.displayName = 'IntlProvider';
$2f8f6e5af3274a3b$export$480518999dfc4151.contextTypes = {
    intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf
};
$2f8f6e5af3274a3b$export$480518999dfc4151.childContextTypes = {
    intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf.isRequired
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$export$40ae3194919d16b = function(_Component) {
    $2f8f6e5af3274a3b$var$inherits(FormattedDate, _Component);
    function FormattedDate(props, context) {
        $2f8f6e5af3274a3b$var$classCallCheck(this, FormattedDate);
        var _this = $2f8f6e5af3274a3b$var$possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
        $2f8f6e5af3274a3b$var$invariantIntlContext(context);
        return _this;
    }
    $2f8f6e5af3274a3b$var$createClass(FormattedDate, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $2f8f6e5af3274a3b$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _context$intl = this.context.intl, formatDate = _context$intl.formatDate, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, children = _props.children;
                var formattedDate = formatDate(value, this.props);
                if (typeof children === 'function') return children(formattedDate);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Text, null, formattedDate);
            }
        }
    ]);
    return FormattedDate;
}((0, $8P7DW.Component));
$2f8f6e5af3274a3b$export$40ae3194919d16b.displayName = 'FormattedDate';
$2f8f6e5af3274a3b$export$40ae3194919d16b.contextTypes = {
    intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$export$5b390a54f8a846f7 = function(_Component) {
    $2f8f6e5af3274a3b$var$inherits(FormattedTime, _Component);
    function FormattedTime(props, context) {
        $2f8f6e5af3274a3b$var$classCallCheck(this, FormattedTime);
        var _this = $2f8f6e5af3274a3b$var$possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
        $2f8f6e5af3274a3b$var$invariantIntlContext(context);
        return _this;
    }
    $2f8f6e5af3274a3b$var$createClass(FormattedTime, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $2f8f6e5af3274a3b$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _context$intl = this.context.intl, formatTime = _context$intl.formatTime, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, children = _props.children;
                var formattedTime = formatTime(value, this.props);
                if (typeof children === 'function') return children(formattedTime);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Text, null, formattedTime);
            }
        }
    ]);
    return FormattedTime;
}((0, $8P7DW.Component));
$2f8f6e5af3274a3b$export$5b390a54f8a846f7.displayName = 'FormattedTime';
$2f8f6e5af3274a3b$export$5b390a54f8a846f7.contextTypes = {
    intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$var$SECOND = 1000;
var $2f8f6e5af3274a3b$var$MINUTE = 60000;
var $2f8f6e5af3274a3b$var$HOUR = 3600000;
var $2f8f6e5af3274a3b$var$DAY = 86400000;
// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var $2f8f6e5af3274a3b$var$MAX_TIMER_DELAY = 2147483647;
function $2f8f6e5af3274a3b$var$selectUnits(delta) {
    var absDelta = Math.abs(delta);
    if (absDelta < $2f8f6e5af3274a3b$var$MINUTE) return 'second';
    if (absDelta < $2f8f6e5af3274a3b$var$HOUR) return 'minute';
    if (absDelta < $2f8f6e5af3274a3b$var$DAY) return 'hour';
    // The maximum scheduled delay will be measured in days since the maximum
    // timer delay is less than the number of milliseconds in 25 days.
    return 'day';
}
function $2f8f6e5af3274a3b$var$getUnitDelay(units) {
    switch(units){
        case 'second':
            return $2f8f6e5af3274a3b$var$SECOND;
        case 'minute':
            return $2f8f6e5af3274a3b$var$MINUTE;
        case 'hour':
            return $2f8f6e5af3274a3b$var$HOUR;
        case 'day':
            return $2f8f6e5af3274a3b$var$DAY;
        default:
            return $2f8f6e5af3274a3b$var$MAX_TIMER_DELAY;
    }
}
function $2f8f6e5af3274a3b$var$isSameDate(a, b) {
    if (a === b) return true;
    var aTime = new Date(a).getTime();
    var bTime = new Date(b).getTime();
    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}
var $2f8f6e5af3274a3b$export$a560185ee54e4a40 = function(_Component) {
    $2f8f6e5af3274a3b$var$inherits(FormattedRelative, _Component);
    function FormattedRelative(props, context) {
        $2f8f6e5af3274a3b$var$classCallCheck(this, FormattedRelative);
        var _this = $2f8f6e5af3274a3b$var$possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
        $2f8f6e5af3274a3b$var$invariantIntlContext(context);
        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
        // `now` is stored as state so that `render()` remains a function of
        // props + state, instead of accessing `Date.now()` inside `render()`.
        _this.state = {
            now: now
        };
        return _this;
    }
    $2f8f6e5af3274a3b$var$createClass(FormattedRelative, [
        {
            key: 'scheduleNextUpdate',
            value: function scheduleNextUpdate(props, state) {
                var _this2 = this;
                // Cancel and pending update because we're scheduling a new update.
                clearTimeout(this._timer);
                var value = props.value, units = props.units, updateInterval = props.updateInterval;
                var time = new Date(value).getTime();
                // If the `updateInterval` is falsy, including `0` or we don't have a
                // valid date, then auto updates have been turned off, so we bail and
                // skip scheduling an update.
                if (!updateInterval || !isFinite(time)) return;
                var delta = time - state.now;
                var unitDelay = $2f8f6e5af3274a3b$var$getUnitDelay(units || $2f8f6e5af3274a3b$var$selectUnits(delta));
                var unitRemainder = Math.abs(delta % unitDelay);
                // We want the largest possible timer delay which will still display
                // accurate information while reducing unnecessary re-renders. The delay
                // should be until the next "interesting" moment, like a tick from
                // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
                var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
                this._timer = setTimeout(function() {
                    _this2.setState({
                        now: _this2.context.intl.now()
                    });
                }, delay);
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.scheduleNextUpdate(this.props, this.state);
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(_ref) {
                var nextValue = _ref.value;
                // When the `props.value` date changes, `state.now` needs to be updated,
                // and the next update can be rescheduled.
                if (!$2f8f6e5af3274a3b$var$isSameDate(nextValue, this.props.value)) this.setState({
                    now: this.context.intl.now()
                });
            }
        },
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $2f8f6e5af3274a3b$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps, nextState) {
                this.scheduleNextUpdate(nextProps, nextState);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                clearTimeout(this._timer);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _context$intl = this.context.intl, formatRelative = _context$intl.formatRelative, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, children = _props.children;
                var formattedRelative = formatRelative(value, $2f8f6e5af3274a3b$var$_extends({}, this.props, this.state));
                if (typeof children === 'function') return children(formattedRelative);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Text, null, formattedRelative);
            }
        }
    ]);
    return FormattedRelative;
}((0, $8P7DW.Component));
$2f8f6e5af3274a3b$export$a560185ee54e4a40.displayName = 'FormattedRelative';
$2f8f6e5af3274a3b$export$a560185ee54e4a40.contextTypes = {
    intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf
};
$2f8f6e5af3274a3b$export$a560185ee54e4a40.defaultProps = {
    updateInterval: 10000
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$export$db80edc1e6b2f63d = function(_Component) {
    $2f8f6e5af3274a3b$var$inherits(FormattedNumber, _Component);
    function FormattedNumber(props, context) {
        $2f8f6e5af3274a3b$var$classCallCheck(this, FormattedNumber);
        var _this = $2f8f6e5af3274a3b$var$possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
        $2f8f6e5af3274a3b$var$invariantIntlContext(context);
        return _this;
    }
    $2f8f6e5af3274a3b$var$createClass(FormattedNumber, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $2f8f6e5af3274a3b$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _context$intl = this.context.intl, formatNumber = _context$intl.formatNumber, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, children = _props.children;
                var formattedNumber = formatNumber(value, this.props);
                if (typeof children === 'function') return children(formattedNumber);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Text, null, formattedNumber);
            }
        }
    ]);
    return FormattedNumber;
}((0, $8P7DW.Component));
$2f8f6e5af3274a3b$export$db80edc1e6b2f63d.displayName = 'FormattedNumber';
$2f8f6e5af3274a3b$export$db80edc1e6b2f63d.contextTypes = {
    intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$export$da755058eada5424 = function(_Component) {
    $2f8f6e5af3274a3b$var$inherits(FormattedPlural, _Component);
    function FormattedPlural(props, context) {
        $2f8f6e5af3274a3b$var$classCallCheck(this, FormattedPlural);
        var _this = $2f8f6e5af3274a3b$var$possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
        $2f8f6e5af3274a3b$var$invariantIntlContext(context);
        return _this;
    }
    $2f8f6e5af3274a3b$var$createClass(FormattedPlural, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $2f8f6e5af3274a3b$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _context$intl = this.context.intl, formatPlural = _context$intl.formatPlural, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, other = _props.other, children = _props.children;
                var pluralCategory = formatPlural(value, this.props);
                var formattedPlural = this.props[pluralCategory] || other;
                if (typeof children === 'function') return children(formattedPlural);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Text, null, formattedPlural);
            }
        }
    ]);
    return FormattedPlural;
}((0, $8P7DW.Component));
$2f8f6e5af3274a3b$export$da755058eada5424.displayName = 'FormattedPlural';
$2f8f6e5af3274a3b$export$da755058eada5424.contextTypes = {
    intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf
};
$2f8f6e5af3274a3b$export$da755058eada5424.defaultProps = {
    style: 'cardinal'
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$var$defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
    return $2f8f6e5af3274a3b$var$formatMessage({}, {
        getMessageFormat: (0, (/*@__PURE__*/$parcel$interopDefault($1SVIu)))((0, (/*@__PURE__*/$parcel$interopDefault($hOqQy))))
    }, descriptor, values);
};
var $2f8f6e5af3274a3b$export$561a3c611f78824a = function(_Component) {
    $2f8f6e5af3274a3b$var$inherits(FormattedMessage, _Component);
    function FormattedMessage(props, context) {
        $2f8f6e5af3274a3b$var$classCallCheck(this, FormattedMessage);
        var _this = $2f8f6e5af3274a3b$var$possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
        if (!props.defaultMessage) $2f8f6e5af3274a3b$var$invariantIntlContext(context);
        return _this;
    }
    $2f8f6e5af3274a3b$var$createClass(FormattedMessage, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                var values = this.props.values;
                var nextValues = nextProps.values;
                if (!$2f8f6e5af3274a3b$var$shallowEquals(nextValues, values)) return true;
                // Since `values` has already been checked, we know they're not
                // different, so the current `values` are carried over so the shallow
                // equals comparison on the other props isn't affected by the `values`.
                var nextPropsToCheck = $2f8f6e5af3274a3b$var$_extends({}, nextProps, {
                    values: values
                });
                for(var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)next[_key - 1] = arguments[_key];
                return $2f8f6e5af3274a3b$var$shouldIntlComponentUpdate.apply(undefined, [
                    this,
                    nextPropsToCheck
                ].concat(next));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _ref = this.context.intl || {}, _ref$formatMessage = _ref.formatMessage, formatMessage$$1 = _ref$formatMessage === undefined ? $2f8f6e5af3274a3b$var$defaultFormatMessage : _ref$formatMessage, _ref$textComponent = _ref.textComponent, Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;
                var _props = this.props, id = _props.id, description = _props.description, defaultMessage = _props.defaultMessage, values = _props.values, _props$tagName = _props.tagName, Component$$1 = _props$tagName === undefined ? Text : _props$tagName, children = _props.children;
                var tokenDelimiter = void 0;
                var tokenizedValues = void 0;
                var elements = void 0;
                var hasValues = values && Object.keys(values).length > 0;
                if (hasValues) {
                    // Creates a token with a random UID that should not be guessable or
                    // conflict with other parts of the `message` string.
                    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
                    var generateToken = function() {
                        var counter = 0;
                        return function() {
                            return 'ELEMENT-' + uid + '-' + (counter += 1);
                        };
                    }();
                    // Splitting with a delimiter to support IE8. When using a regex
                    // with a capture group IE8 does not include the capture group in
                    // the resulting array.
                    tokenDelimiter = '@__' + uid + '__@';
                    tokenizedValues = {};
                    elements = {};
                    // Iterates over the `props` to keep track of any React Element
                    // values so they can be represented by the `token` as a placeholder
                    // when the `message` is formatted. This allows the formatted
                    // message to then be broken-up into parts with references to the
                    // React Elements inserted back in.
                    Object.keys(values).forEach(function(name) {
                        var value = values[name];
                        if ((0, $8P7DW.isValidElement)(value)) {
                            var token = generateToken();
                            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
                            elements[token] = value;
                        } else tokenizedValues[name] = value;
                    });
                }
                var descriptor = {
                    id: id,
                    description: description,
                    defaultMessage: defaultMessage
                };
                var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);
                var nodes = void 0;
                var hasElements = elements && Object.keys(elements).length > 0;
                if (hasElements) // Split the message into parts so the React Element values captured
                // above can be inserted back into the rendered message. This
                // approach allows messages to render with React Elements while
                // keeping React's virtual diffing working properly.
                nodes = formattedMessage.split(tokenDelimiter).filter(function(part) {
                    return !!part;
                }).map(function(part) {
                    return elements[part] || part;
                });
                else nodes = [
                    formattedMessage
                ];
                if (typeof children === 'function') return children.apply(undefined, $2f8f6e5af3274a3b$var$toConsumableArray(nodes));
                // Needs to use `createElement()` instead of JSX, otherwise React will
                // warn about a missing `key` prop with rich-text message formatting.
                return (0, $8P7DW.createElement).apply(undefined, [
                    Component$$1,
                    null
                ].concat($2f8f6e5af3274a3b$var$toConsumableArray(nodes)));
            }
        }
    ]);
    return FormattedMessage;
}((0, $8P7DW.Component));
$2f8f6e5af3274a3b$export$561a3c611f78824a.displayName = 'FormattedMessage';
$2f8f6e5af3274a3b$export$561a3c611f78824a.contextTypes = {
    intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf
};
$2f8f6e5af3274a3b$export$561a3c611f78824a.defaultProps = {
    values: {}
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $2f8f6e5af3274a3b$export$1055f6fa4dffb817 = function(_Component) {
    $2f8f6e5af3274a3b$var$inherits(FormattedHTMLMessage, _Component);
    function FormattedHTMLMessage(props, context) {
        $2f8f6e5af3274a3b$var$classCallCheck(this, FormattedHTMLMessage);
        var _this = $2f8f6e5af3274a3b$var$possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
        $2f8f6e5af3274a3b$var$invariantIntlContext(context);
        return _this;
    }
    $2f8f6e5af3274a3b$var$createClass(FormattedHTMLMessage, [
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate(nextProps) {
                var values = this.props.values;
                var nextValues = nextProps.values;
                if (!$2f8f6e5af3274a3b$var$shallowEquals(nextValues, values)) return true;
                // Since `values` has already been checked, we know they're not
                // different, so the current `values` are carried over so the shallow
                // equals comparison on the other props isn't affected by the `values`.
                var nextPropsToCheck = $2f8f6e5af3274a3b$var$_extends({}, nextProps, {
                    values: values
                });
                for(var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)next[_key - 1] = arguments[_key];
                return $2f8f6e5af3274a3b$var$shouldIntlComponentUpdate.apply(undefined, [
                    this,
                    nextPropsToCheck
                ].concat(next));
            }
        },
        {
            key: 'render',
            value: function render() {
                var _context$intl = this.context.intl, formatHTMLMessage = _context$intl.formatHTMLMessage, Text = _context$intl.textComponent;
                var _props = this.props, id = _props.id, description = _props.description, defaultMessage = _props.defaultMessage, rawValues = _props.values, _props$tagName = _props.tagName, Component$$1 = _props$tagName === undefined ? Text : _props$tagName, children = _props.children;
                var descriptor = {
                    id: id,
                    description: description,
                    defaultMessage: defaultMessage
                };
                var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
                if (typeof children === 'function') return children(formattedHTMLMessage);
                // Since the message presumably has HTML in it, we need to set
                // `innerHTML` in order for it to be rendered and not escaped by React.
                // To be safe, all string prop values were escaped when formatting the
                // message. It is assumed that the message is not UGC, and came from the
                // developer making it more like a template.
                //
                // Note: There's a perf impact of using this component since there's no
                // way for React to do its virtual DOM diffing.
                var html = {
                    __html: formattedHTMLMessage
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component$$1, {
                    dangerouslySetInnerHTML: html
                });
            }
        }
    ]);
    return FormattedHTMLMessage;
}((0, $8P7DW.Component));
$2f8f6e5af3274a3b$export$1055f6fa4dffb817.displayName = 'FormattedHTMLMessage';
$2f8f6e5af3274a3b$export$1055f6fa4dffb817.contextTypes = {
    intl: $2f8f6e5af3274a3b$export$db9134ac6ad368cf
};
$2f8f6e5af3274a3b$export$1055f6fa4dffb817.defaultProps = {
    values: {}
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ $2f8f6e5af3274a3b$export$9b0a0997606861b1($2f8f6e5af3274a3b$var$defaultLocaleData);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ $2f8f6e5af3274a3b$export$9b0a0997606861b1((0, (/*@__PURE__*/$parcel$interopDefault($lOPnY))));

});
parcelRegister("lOPnY", function(module, exports) {
"use strict";

});

parcelRegister("hOqQy", function(module, exports) {
/* jshint node:true */ 'use strict';

var $7GBuo = parcelRequire("7GBuo");
var IntlMessageFormat = $7GBuo.default;
parcelRequire("lOPnY");
// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;

});
parcelRegister("7GBuo", function(module, exports) {
$parcel$export(module.exports, "default", () => $598989365d61cc92$export$2e2bcd8739ae039, (v) => $598989365d61cc92$export$2e2bcd8739ae039 = v);
/* jslint esnext: true */ var $598989365d61cc92$export$2e2bcd8739ae039;
"use strict";

var $b8clS = parcelRequire("b8clS");

var $3GcrF = parcelRequire("3GcrF");
$b8clS.default.__addLocaleData($3GcrF.default);
$b8clS.default.defaultLocale = 'en';
$598989365d61cc92$export$2e2bcd8739ae039 = $b8clS.default;

});
parcelRegister("b8clS", function(module, exports) {
$parcel$export(module.exports, "default", () => $81aa05e53ed158da$export$2e2bcd8739ae039, (v) => $81aa05e53ed158da$export$2e2bcd8739ae039 = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $81aa05e53ed158da$export$2e2bcd8739ae039;
"use strict";

var $9oASx = parcelRequire("9oASx");

var $5g6be = parcelRequire("5g6be");

var $6uy54 = parcelRequire("6uy54");

var $cf41c = parcelRequire("cf41c");
$81aa05e53ed158da$export$2e2bcd8739ae039 = $81aa05e53ed158da$var$MessageFormat;
// -- MessageFormat --------------------------------------------------------
function $81aa05e53ed158da$var$MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ? $81aa05e53ed158da$var$MessageFormat.__parse(message) : message;
    if (!(ast && ast.type === 'messageFormatPattern')) throw new TypeError('A message must be provided as a String or AST.');
    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats($81aa05e53ed158da$var$MessageFormat.formats, formats);
    // Defined first because it's used to build the format pattern.
    $5g6be.defineProperty(this, '_locale', {
        value: this._resolveLocale(locales)
    });
    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern = this._compilePattern(ast, locales, formats, pluralFn);
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function(values) {
        try {
            return messageFormat._format(pattern, values);
        } catch (e) {
            if (e.variableId) throw new Error('The intl string context variable \'' + e.variableId + '\'' + ' was not provided to the string \'' + message + '\'');
            else throw e;
        }
    };
}
// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
$5g6be.defineProperty($81aa05e53ed158da$var$MessageFormat, 'formats', {
    enumerable: true,
    value: {
        number: {
            'currency': {
                style: 'currency'
            },
            'percent': {
                style: 'percent'
            }
        },
        date: {
            'short': {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            'medium': {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            'long': {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            'full': {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            'short': {
                hour: 'numeric',
                minute: 'numeric'
            },
            'medium': {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            'long': {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            'full': {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});
// Define internal private properties for dealing with locale data.
$5g6be.defineProperty($81aa05e53ed158da$var$MessageFormat, '__localeData__', {
    value: $5g6be.objCreate(null)
});
$5g6be.defineProperty($81aa05e53ed158da$var$MessageFormat, '__addLocaleData', {
    value: function(data) {
        if (!(data && data.locale)) throw new Error("Locale data provided to IntlMessageFormat is missing a `locale` property");
        $81aa05e53ed158da$var$MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
    }
});
// Defines `__parse()` static method as an exposed private.
$5g6be.defineProperty($81aa05e53ed158da$var$MessageFormat, '__parse', {
    value: $cf41c.default.parse
});
// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
$5g6be.defineProperty($81aa05e53ed158da$var$MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
$81aa05e53ed158da$var$MessageFormat.prototype.resolvedOptions = function() {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};
$81aa05e53ed158da$var$MessageFormat.prototype._compilePattern = function(ast, locales, formats, pluralFn) {
    var compiler = new $6uy54.default(locales, formats, pluralFn);
    return compiler.compile(ast);
};
$81aa05e53ed158da$var$MessageFormat.prototype._findPluralRuleFunction = function(locale) {
    var localeData = $81aa05e53ed158da$var$MessageFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while(data){
        if (data.pluralRuleFunction) return data.pluralRuleFunction;
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error("Locale data added to IntlMessageFormat is missing a `pluralRuleFunction` for :" + locale);
};
$81aa05e53ed158da$var$MessageFormat.prototype._format = function(pattern, values) {
    var result = '', i, len, part, id, value, err;
    for(i = 0, len = pattern.length; i < len; i += 1){
        part = pattern[i];
        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }
        id = part.id;
        // Enforce that all required values are provided by the caller.
        if (!(values && $9oASx.hop.call(values, id))) {
            err = new Error('A value must be provided for: ' + id);
            err.variableId = id;
            throw err;
        }
        value = values[id];
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) result += this._format(part.getOption(value), values);
        else result += part.format(value);
    }
    return result;
};
$81aa05e53ed158da$var$MessageFormat.prototype._mergeFormats = function(defaults, formats) {
    var mergedFormats = {}, type, mergedType;
    for(type in defaults){
        if (!$9oASx.hop.call(defaults, type)) continue;
        mergedFormats[type] = mergedType = $5g6be.objCreate(defaults[type]);
        if (formats && $9oASx.hop.call(formats, type)) $9oASx.extend(mergedType, formats[type]);
    }
    return mergedFormats;
};
$81aa05e53ed158da$var$MessageFormat.prototype._resolveLocale = function(locales) {
    if (typeof locales === 'string') locales = [
        locales
    ];
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat($81aa05e53ed158da$var$MessageFormat.defaultLocale);
    var localeData = $81aa05e53ed158da$var$MessageFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for(i = 0, len = locales.length; i < len; i += 1){
        localeParts = locales[i].toLowerCase().split('-');
        while(localeParts.length){
            data = localeData[localeParts.join('-')];
            if (data) // Return the normalized locale string; e.g., we return "en-US",
            // instead of "en-us".
            return data.locale;
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlMessageFormat for: ' + locales.join(', ') + ', or the default locale: ' + defaultLocale);
};

});
parcelRegister("9oASx", function(module, exports) {
$parcel$export(module.exports, "extend", () => $01c3eb32ca665e48$export$8b58be045bf06082, (v) => $01c3eb32ca665e48$export$8b58be045bf06082 = v);
$parcel$export(module.exports, "hop", () => $01c3eb32ca665e48$export$ddc501d3db01d79c, (v) => $01c3eb32ca665e48$export$ddc501d3db01d79c = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $01c3eb32ca665e48$export$8b58be045bf06082;
var $01c3eb32ca665e48$export$ddc501d3db01d79c;
"use strict";
$01c3eb32ca665e48$export$8b58be045bf06082 = $01c3eb32ca665e48$var$extend;
var $01c3eb32ca665e48$var$hop = Object.prototype.hasOwnProperty;
function $01c3eb32ca665e48$var$extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1), i, len, source, key;
    for(i = 0, len = sources.length; i < len; i += 1){
        source = sources[i];
        if (!source) continue;
        for(key in source)if ($01c3eb32ca665e48$var$hop.call(source, key)) obj[key] = source[key];
    }
    return obj;
}
$01c3eb32ca665e48$export$ddc501d3db01d79c = $01c3eb32ca665e48$var$hop;

});

parcelRegister("5g6be", function(module, exports) {
$parcel$export(module.exports, "defineProperty", () => $3d433da1ef90c9e8$export$fdab3c20aae16ddf, (v) => $3d433da1ef90c9e8$export$fdab3c20aae16ddf = v);
$parcel$export(module.exports, "objCreate", () => $3d433da1ef90c9e8$export$c09f2411a4ae511b, (v) => $3d433da1ef90c9e8$export$c09f2411a4ae511b = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $3d433da1ef90c9e8$export$fdab3c20aae16ddf;
var $3d433da1ef90c9e8$export$c09f2411a4ae511b;
"use strict";

var $9oASx = parcelRequire("9oASx");
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var $3d433da1ef90c9e8$var$realDefineProp = function() {
    try {
        return !!Object.defineProperty({}, 'a', {});
    } catch (e) {
        return false;
    }
}();
var $3d433da1ef90c9e8$var$es3 = !$3d433da1ef90c9e8$var$realDefineProp && !Object.prototype.__defineGetter__;
var $3d433da1ef90c9e8$var$defineProperty = $3d433da1ef90c9e8$var$realDefineProp ? Object.defineProperty : function(obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);
    else if (!$9oASx.hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};
var $3d433da1ef90c9e8$var$objCreate = Object.create || function(proto, props) {
    var obj, k;
    function F() {}
    F.prototype = proto;
    obj = new F();
    for(k in props)if ($9oASx.hop.call(props, k)) $3d433da1ef90c9e8$var$defineProperty(obj, k, props[k]);
    return obj;
};
$3d433da1ef90c9e8$export$fdab3c20aae16ddf = $3d433da1ef90c9e8$var$defineProperty, $3d433da1ef90c9e8$export$c09f2411a4ae511b = $3d433da1ef90c9e8$var$objCreate;

});

parcelRegister("6uy54", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b9ffb20fd73c48f$export$2e2bcd8739ae039, (v) => $4b9ffb20fd73c48f$export$2e2bcd8739ae039 = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $4b9ffb20fd73c48f$export$2e2bcd8739ae039;
"use strict";
$4b9ffb20fd73c48f$export$2e2bcd8739ae039 = $4b9ffb20fd73c48f$var$Compiler;
function $4b9ffb20fd73c48f$var$Compiler(locales, formats, pluralFn) {
    this.locales = locales;
    this.formats = formats;
    this.pluralFn = pluralFn;
}
$4b9ffb20fd73c48f$var$Compiler.prototype.compile = function(ast) {
    this.pluralStack = [];
    this.currentPlural = null;
    this.pluralNumberFormat = null;
    return this.compileMessage(ast);
};
$4b9ffb20fd73c48f$var$Compiler.prototype.compileMessage = function(ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) throw new Error('Message AST is not of type: "messageFormatPattern"');
    var elements = ast.elements, pattern = [];
    var i, len, element;
    for(i = 0, len = elements.length; i < len; i += 1){
        element = elements[i];
        switch(element.type){
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;
            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;
            default:
                throw new Error('Message element does not have a valid type');
        }
    }
    return pattern;
};
$4b9ffb20fd73c48f$var$Compiler.prototype.compileMessageText = function(element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        return new $4b9ffb20fd73c48f$var$PluralOffsetString(this.currentPlural.id, this.currentPlural.format.offset, this.pluralNumberFormat, element.value);
    }
    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};
$4b9ffb20fd73c48f$var$Compiler.prototype.compileArgument = function(element) {
    var format = element.format;
    if (!format) return new $4b9ffb20fd73c48f$var$StringFormat(element.id);
    var formats = this.formats, locales = this.locales, pluralFn = this.pluralFn, options;
    switch(format.type){
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id: element.id,
                format: new Intl.NumberFormat(locales, options).format
            };
        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id: element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };
        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id: element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };
        case 'pluralFormat':
            options = this.compileOptions(element);
            return new $4b9ffb20fd73c48f$var$PluralFormat(element.id, format.ordinal, format.offset, options, pluralFn);
        case 'selectFormat':
            options = this.compileOptions(element);
            return new $4b9ffb20fd73c48f$var$SelectFormat(element.id, options);
        default:
            throw new Error('Message element does not have a valid format type');
    }
};
$4b9ffb20fd73c48f$var$Compiler.prototype.compileOptions = function(element) {
    var format = element.format, options = format.options, optionsHash = {};
    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;
    var i, len, option;
    for(i = 0, len = options.length; i < len; i += 1){
        option = options[i];
        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }
    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();
    return optionsHash;
};
// -- Compiler Helper Classes --------------------------------------------------
function $4b9ffb20fd73c48f$var$StringFormat(id) {
    this.id = id;
}
$4b9ffb20fd73c48f$var$StringFormat.prototype.format = function(value) {
    if (!value && typeof value !== 'number') return '';
    return typeof value === 'string' ? value : String(value);
};
function $4b9ffb20fd73c48f$var$PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id = id;
    this.useOrdinal = useOrdinal;
    this.offset = offset;
    this.options = options;
    this.pluralFn = pluralFn;
}
$4b9ffb20fd73c48f$var$PluralFormat.prototype.getOption = function(value) {
    var options = this.options;
    var option = options['=' + value] || options[this.pluralFn(value - this.offset, this.useOrdinal)];
    return option || options.other;
};
function $4b9ffb20fd73c48f$var$PluralOffsetString(id, offset, numberFormat, string) {
    this.id = id;
    this.offset = offset;
    this.numberFormat = numberFormat;
    this.string = string;
}
$4b9ffb20fd73c48f$var$PluralOffsetString.prototype.format = function(value) {
    var number = this.numberFormat.format(value - this.offset);
    return this.string.replace(/(^|[^\\])#/g, '$1' + number).replace(/\\#/g, '#');
};
function $4b9ffb20fd73c48f$var$SelectFormat(id, options) {
    this.id = id;
    this.options = options;
}
$4b9ffb20fd73c48f$var$SelectFormat.prototype.getOption = function(value) {
    var options = this.options;
    return options[value] || options.other;
};

});

parcelRegister("cf41c", function(module, exports) {
'use strict';

exports = module.exports = (parcelRequire("8We8W")).default;
exports['default'] = exports;

});
parcelRegister("8We8W", function(module, exports) {
$parcel$export(module.exports, "default", () => $681eb614cb14866c$export$2e2bcd8739ae039, (v) => $681eb614cb14866c$export$2e2bcd8739ae039 = v);
var $681eb614cb14866c$export$2e2bcd8739ae039;
"use strict";
$681eb614cb14866c$export$2e2bcd8739ae039 = function() {
    "use strict";
    /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */ function peg$subclass(child, parent) {
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
    }
    function peg$SyntaxError(message, expected, found, location) {
        this.message = message;
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, peg$SyntaxError);
    }
    peg$subclass(peg$SyntaxError, Error);
    function peg$parse(input) {
        var options = arguments.length > 1 ? arguments[1] : {}, parser = this, peg$FAILED = {}, peg$startRuleFunctions = {
            start: peg$parsestart
        }, peg$startRuleFunction = peg$parsestart, peg$c0 = function(elements) {
            return {
                type: 'messageFormatPattern',
                elements: elements,
                location: location()
            };
        }, peg$c1 = function(text) {
            var string = '', i, j, outerLen, inner, innerLen;
            for(i = 0, outerLen = text.length; i < outerLen; i += 1){
                inner = text[i];
                for(j = 0, innerLen = inner.length; j < innerLen; j += 1)string += inner[j];
            }
            return string;
        }, peg$c2 = function(messageText) {
            return {
                type: 'messageTextElement',
                value: messageText,
                location: location()
            };
        }, peg$c3 = /^[^ \t\n\r,.+={}#]/, peg$c4 = {
            type: "class",
            value: "[^ \\t\\n\\r,.+={}#]",
            description: "[^ \\t\\n\\r,.+={}#]"
        }, peg$c5 = "{", peg$c6 = {
            type: "literal",
            value: "{",
            description: "\"{\""
        }, peg$c7 = ",", peg$c8 = {
            type: "literal",
            value: ",",
            description: "\",\""
        }, peg$c9 = "}", peg$c10 = {
            type: "literal",
            value: "}",
            description: "\"}\""
        }, peg$c11 = function(id, format) {
            return {
                type: 'argumentElement',
                id: id,
                format: format && format[2],
                location: location()
            };
        }, peg$c12 = "number", peg$c13 = {
            type: "literal",
            value: "number",
            description: "\"number\""
        }, peg$c14 = "date", peg$c15 = {
            type: "literal",
            value: "date",
            description: "\"date\""
        }, peg$c16 = "time", peg$c17 = {
            type: "literal",
            value: "time",
            description: "\"time\""
        }, peg$c18 = function(type, style) {
            return {
                type: type + 'Format',
                style: style && style[2],
                location: location()
            };
        }, peg$c19 = "plural", peg$c20 = {
            type: "literal",
            value: "plural",
            description: "\"plural\""
        }, peg$c21 = function(pluralStyle) {
            return {
                type: pluralStyle.type,
                ordinal: false,
                offset: pluralStyle.offset || 0,
                options: pluralStyle.options,
                location: location()
            };
        }, peg$c22 = "selectordinal", peg$c23 = {
            type: "literal",
            value: "selectordinal",
            description: "\"selectordinal\""
        }, peg$c24 = function(pluralStyle) {
            return {
                type: pluralStyle.type,
                ordinal: true,
                offset: pluralStyle.offset || 0,
                options: pluralStyle.options,
                location: location()
            };
        }, peg$c25 = "select", peg$c26 = {
            type: "literal",
            value: "select",
            description: "\"select\""
        }, peg$c27 = function(options) {
            return {
                type: 'selectFormat',
                options: options,
                location: location()
            };
        }, peg$c28 = "=", peg$c29 = {
            type: "literal",
            value: "=",
            description: "\"=\""
        }, peg$c30 = function(selector, pattern) {
            return {
                type: 'optionalFormatPattern',
                selector: selector,
                value: pattern,
                location: location()
            };
        }, peg$c31 = "offset:", peg$c32 = {
            type: "literal",
            value: "offset:",
            description: "\"offset:\""
        }, peg$c33 = function(number) {
            return number;
        }, peg$c34 = function(offset, options) {
            return {
                type: 'pluralFormat',
                offset: offset,
                options: options,
                location: location()
            };
        }, peg$c35 = {
            type: "other",
            description: "whitespace"
        }, peg$c36 = /^[ \t\n\r]/, peg$c37 = {
            type: "class",
            value: "[ \\t\\n\\r]",
            description: "[ \\t\\n\\r]"
        }, peg$c38 = {
            type: "other",
            description: "optionalWhitespace"
        }, peg$c39 = /^[0-9]/, peg$c40 = {
            type: "class",
            value: "[0-9]",
            description: "[0-9]"
        }, peg$c41 = /^[0-9a-f]/i, peg$c42 = {
            type: "class",
            value: "[0-9a-f]i",
            description: "[0-9a-f]i"
        }, peg$c43 = "0", peg$c44 = {
            type: "literal",
            value: "0",
            description: "\"0\""
        }, peg$c45 = /^[1-9]/, peg$c46 = {
            type: "class",
            value: "[1-9]",
            description: "[1-9]"
        }, peg$c47 = function(digits) {
            return parseInt(digits, 10);
        }, peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/, peg$c49 = {
            type: "class",
            value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]",
            description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]"
        }, peg$c50 = "\\\\", peg$c51 = {
            type: "literal",
            value: "\\\\",
            description: "\"\\\\\\\\\""
        }, peg$c52 = function() {
            return '\\';
        }, peg$c53 = "\\#", peg$c54 = {
            type: "literal",
            value: "\\#",
            description: "\"\\\\#\""
        }, peg$c55 = function() {
            return '\\#';
        }, peg$c56 = "\\{", peg$c57 = {
            type: "literal",
            value: "\\{",
            description: "\"\\\\{\""
        }, peg$c58 = function() {
            return '\u007B';
        }, peg$c59 = "\\}", peg$c60 = {
            type: "literal",
            value: "\\}",
            description: "\"\\\\}\""
        }, peg$c61 = function() {
            return '\u007D';
        }, peg$c62 = "\\u", peg$c63 = {
            type: "literal",
            value: "\\u",
            description: "\"\\\\u\""
        }, peg$c64 = function(digits) {
            return String.fromCharCode(parseInt(digits, 16));
        }, peg$c65 = function(chars) {
            return chars.join('');
        }, peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [
            {
                line: 1,
                column: 1,
                seenCR: false
            }
        ], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ("startRule" in options) {
            if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
            peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
            return input.substring(peg$savedPos, peg$currPos);
        }
        function location() {
            return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description) {
            throw peg$buildException(null, [
                {
                    type: "other",
                    description: description
                }
            ], input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
        }
        function error(message) {
            throw peg$buildException(message, null, input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
        }
        function peg$computePosDetails(pos) {
            var details = peg$posDetailsCache[pos], p, ch;
            if (details) return details;
            else {
                p = pos - 1;
                while(!peg$posDetailsCache[p])p--;
                details = peg$posDetailsCache[p];
                details = {
                    line: details.line,
                    column: details.column,
                    seenCR: details.seenCR
                };
                while(p < pos){
                    ch = input.charAt(p);
                    if (ch === "\n") {
                        if (!details.seenCR) details.line++;
                        details.column = 1;
                        details.seenCR = false;
                    } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
                        details.line++;
                        details.column = 1;
                        details.seenCR = true;
                    } else {
                        details.column++;
                        details.seenCR = false;
                    }
                    p++;
                }
                peg$posDetailsCache[pos] = details;
                return details;
            }
        }
        function peg$computeLocation(startPos, endPos) {
            var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
            return {
                start: {
                    offset: startPos,
                    line: startPosDetails.line,
                    column: startPosDetails.column
                },
                end: {
                    offset: endPos,
                    line: endPosDetails.line,
                    column: endPosDetails.column
                }
            };
        }
        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) return;
            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos;
                peg$maxFailExpected = [];
            }
            peg$maxFailExpected.push(expected);
        }
        function peg$buildException(message, expected, found, location) {
            function cleanupExpected(expected) {
                var i = 1;
                expected.sort(function(a, b) {
                    if (a.description < b.description) return -1;
                    else if (a.description > b.description) return 1;
                    else return 0;
                });
                while(i < expected.length)if (expected[i - 1] === expected[i]) expected.splice(i, 1);
                else i++;
            }
            function buildMessage(expected, found) {
                function stringEscape(s) {
                    function hex(ch) {
                        return ch.charCodeAt(0).toString(16).toUpperCase();
                    }
                    return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\x08/g, '\\b').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\f/g, '\\f').replace(/\r/g, '\\r').replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) {
                        return '\\x0' + hex(ch);
                    }).replace(/[\x10-\x1F\x80-\xFF]/g, function(ch) {
                        return '\\x' + hex(ch);
                    }).replace(/[\u0100-\u0FFF]/g, function(ch) {
                        return '\\u0' + hex(ch);
                    }).replace(/[\u1000-\uFFFF]/g, function(ch) {
                        return '\\u' + hex(ch);
                    });
                }
                var expectedDescs = new Array(expected.length), expectedDesc, foundDesc, i;
                for(i = 0; i < expected.length; i++)expectedDescs[i] = expected[i].description;
                expectedDesc = expected.length > 1 ? expectedDescs.slice(0, -1).join(", ") + " or " + expectedDescs[expected.length - 1] : expectedDescs[0];
                foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
                return "Expected " + expectedDesc + " but " + foundDesc + " found.";
            }
            if (expected !== null) cleanupExpected(expected);
            return new peg$SyntaxError(message !== null ? message : buildMessage(expected, found), expected, found, location);
        }
        function peg$parsestart() {
            var s0;
            s0 = peg$parsemessageFormatPattern();
            return s0;
        }
        function peg$parsemessageFormatPattern() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsemessageFormatElement();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsemessageFormatElement();
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c0(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parsemessageFormatElement() {
            var s0;
            s0 = peg$parsemessageTextElement();
            if (s0 === peg$FAILED) s0 = peg$parseargumentElement();
            return s0;
        }
        function peg$parsemessageText() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$currPos;
            s3 = peg$parse_();
            if (s3 !== peg$FAILED) {
                s4 = peg$parsechars();
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    if (s5 !== peg$FAILED) {
                        s3 = [
                            s3,
                            s4,
                            s5
                        ];
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$currPos;
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsechars();
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_();
                        if (s5 !== peg$FAILED) {
                            s3 = [
                                s3,
                                s4,
                                s5
                            ];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
            else s1 = peg$FAILED;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c1(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsews();
                if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
                else s0 = s1;
            }
            return s0;
        }
        function peg$parsemessageTextElement() {
            var s0, s1;
            s0 = peg$currPos;
            s1 = peg$parsemessageText();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c2(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseargument() {
            var s0, s1, s2;
            s0 = peg$parsenumber();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                if (peg$c3.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c4);
                }
                if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                    s1.push(s2);
                    if (peg$c3.test(input.charAt(peg$currPos))) {
                        s2 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c4);
                    }
                }
                else s1 = peg$FAILED;
                if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
                else s0 = s1;
            }
            return s0;
        }
        function peg$parseargumentElement() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 123) {
                s1 = peg$c5;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c6);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseargument();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s6 = peg$c7;
                                peg$currPos++;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c8);
                            }
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parse_();
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parseelementFormat();
                                    if (s8 !== peg$FAILED) {
                                        s6 = [
                                            s6,
                                            s7,
                                            s8
                                        ];
                                        s5 = s6;
                                    } else {
                                        peg$currPos = s5;
                                        s5 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s5;
                                    s5 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                            if (s5 === peg$FAILED) s5 = null;
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 125) {
                                        s7 = peg$c9;
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c10);
                                    }
                                    if (s7 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c11(s3, s5);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseelementFormat() {
            var s0;
            s0 = peg$parsesimpleFormat();
            if (s0 === peg$FAILED) {
                s0 = peg$parsepluralFormat();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseselectOrdinalFormat();
                    if (s0 === peg$FAILED) s0 = peg$parseselectFormat();
                }
            }
            return s0;
        }
        function peg$parsesimpleFormat() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c12) {
                s1 = peg$c12;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c13);
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 4) === peg$c14) {
                    s1 = peg$c14;
                    peg$currPos += 4;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c15);
                }
                if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 4) === peg$c16) {
                        s1 = peg$c16;
                        peg$currPos += 4;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c17);
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s4 = peg$c7;
                        peg$currPos++;
                    } else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parsechars();
                            if (s6 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5,
                                    s6
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                    if (s3 === peg$FAILED) s3 = null;
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c18(s1, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsepluralFormat() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c19) {
                s1 = peg$c19;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c20);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s3 = peg$c7;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsepluralStyle();
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c21(s5);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseselectOrdinalFormat() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 13) === peg$c22) {
                s1 = peg$c22;
                peg$currPos += 13;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c23);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s3 = peg$c7;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsepluralStyle();
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c24(s5);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseselectFormat() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c25) {
                s1 = peg$c25;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c26);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s3 = peg$c7;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseoptionalFormatPattern();
                            if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                                s5.push(s6);
                                s6 = peg$parseoptionalFormatPattern();
                            }
                            else s5 = peg$FAILED;
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c27(s5);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseselector() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 61) {
                s2 = peg$c28;
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c29);
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parsenumber();
                if (s3 !== peg$FAILED) {
                    s2 = [
                        s2,
                        s3
                    ];
                    s1 = s2;
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            if (s0 === peg$FAILED) s0 = peg$parsechars();
            return s0;
        }
        function peg$parseoptionalFormatPattern() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = peg$parse_();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseselector();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parse_();
                    if (s3 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 123) {
                            s4 = peg$c5;
                            peg$currPos++;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c6);
                        }
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parse_();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parsemessageFormatPattern();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parse_();
                                    if (s7 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 125) {
                                            s8 = peg$c9;
                                            peg$currPos++;
                                        } else {
                                            s8 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c10);
                                        }
                                        if (s8 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c30(s2, s6);
                                            s0 = s1;
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseoffset() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 7) === peg$c31) {
                s1 = peg$c31;
                peg$currPos += 7;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c32);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsenumber();
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c33(s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsepluralStyle() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parseoffset();
            if (s1 === peg$FAILED) s1 = null;
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseoptionalFormatPattern();
                    if (s4 !== peg$FAILED) while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseoptionalFormatPattern();
                    }
                    else s3 = peg$FAILED;
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c34(s1, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsews() {
            var s0, s1;
            peg$silentFails++;
            s0 = [];
            if (peg$c36.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c37);
            }
            if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
                s0.push(s1);
                if (peg$c36.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c37);
                }
            }
            else s0 = peg$FAILED;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c35);
            }
            return s0;
        }
        function peg$parse_() {
            var s0, s1, s2;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsews();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsews();
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c38);
            }
            return s0;
        }
        function peg$parsedigit() {
            var s0;
            if (peg$c39.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c40);
            }
            return s0;
        }
        function peg$parsehexDigit() {
            var s0;
            if (peg$c41.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c42);
            }
            return s0;
        }
        function peg$parsenumber() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 48) {
                s1 = peg$c43;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c44);
            }
            if (s1 === peg$FAILED) {
                s1 = peg$currPos;
                s2 = peg$currPos;
                if (peg$c45.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c46);
                }
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    s5 = peg$parsedigit();
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        s5 = peg$parsedigit();
                    }
                    if (s4 !== peg$FAILED) {
                        s3 = [
                            s3,
                            s4
                        ];
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
                else s1 = s2;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c47(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parsechar() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            if (peg$c48.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c49);
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c50) {
                    s1 = peg$c50;
                    peg$currPos += 2;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c51);
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c52();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c53) {
                        s1 = peg$c53;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c54);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c55();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c56) {
                            s1 = peg$c56;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c57);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c58();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 2) === peg$c59) {
                                s1 = peg$c59;
                                peg$currPos += 2;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c60);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c61();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 2) === peg$c62) {
                                    s1 = peg$c62;
                                    peg$currPos += 2;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c63);
                                }
                                if (s1 !== peg$FAILED) {
                                    s2 = peg$currPos;
                                    s3 = peg$currPos;
                                    s4 = peg$parsehexDigit();
                                    if (s4 !== peg$FAILED) {
                                        s5 = peg$parsehexDigit();
                                        if (s5 !== peg$FAILED) {
                                            s6 = peg$parsehexDigit();
                                            if (s6 !== peg$FAILED) {
                                                s7 = peg$parsehexDigit();
                                                if (s7 !== peg$FAILED) {
                                                    s4 = [
                                                        s4,
                                                        s5,
                                                        s6,
                                                        s7
                                                    ];
                                                    s3 = s4;
                                                } else {
                                                    peg$currPos = s3;
                                                    s3 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s3;
                                                s3 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                    if (s3 !== peg$FAILED) s2 = input.substring(s2, peg$currPos);
                                    else s2 = s3;
                                    if (s2 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c64(s2);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parsechars() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsechar();
            if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsechar();
            }
            else s1 = peg$FAILED;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c65(s1);
            }
            s0 = s1;
            return s0;
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
        else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail({
                type: "end",
                description: "end of input"
            });
            throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
        }
    }
    return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse
    };
}();

});



parcelRegister("3GcrF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2adef2aec03dbcf3$export$2e2bcd8739ae039, (v) => $2adef2aec03dbcf3$export$2e2bcd8739ae039 = v);
// GENERATED FILE
var $2adef2aec03dbcf3$export$2e2bcd8739ae039;
"use strict";
$2adef2aec03dbcf3$export$2e2bcd8739ae039 = {
    "locale": "en",
    "pluralRuleFunction": function(n, ord) {
        var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
        return n == 1 && v0 ? "one" : "other";
    }
};

});



parcelRegister("lUE6N", function(module, exports) {
/* jshint node:true */ 'use strict';

var $6RU4e = parcelRequire("6RU4e");
var IntlRelativeFormat = $6RU4e.default;
parcelRequire("lOPnY");
// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;

});
parcelRegister("6RU4e", function(module, exports) {
"use strict";
/* jslint esnext: true */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ilrPj = parcelRequire("ilrPj");

var $2Hl4Y = parcelRequire("2Hl4Y");
$ilrPj.default.__addLocaleData($2Hl4Y.default);
$ilrPj.default.defaultLocale = 'en';
module.exports.default = $ilrPj.default;

});
parcelRegister("ilrPj", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4Rof2 = parcelRequire("4Rof2");

var $jDL63 = parcelRequire("jDL63");

var $dkjqU = parcelRequire("dkjqU");
module.exports.default = $d5afc5f66ece4e5c$var$RelativeFormat;
// -----------------------------------------------------------------------------
var $d5afc5f66ece4e5c$var$FIELDS = [
    'second',
    'second-short',
    'minute',
    'minute-short',
    'hour',
    'hour-short',
    'day',
    'day-short',
    'month',
    'month-short',
    'year',
    'year-short'
];
var $d5afc5f66ece4e5c$var$STYLES = [
    'best fit',
    'numeric'
];
// -- RelativeFormat -----------------------------------------------------------
function $d5afc5f66ece4e5c$var$RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if ($dkjqU.isArray(locales)) locales = locales.concat();
    $dkjqU.defineProperty(this, '_locale', {
        value: this._resolveLocale(locales)
    });
    $dkjqU.defineProperty(this, '_options', {
        value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        }
    });
    $dkjqU.defineProperty(this, '_locales', {
        value: locales
    });
    $dkjqU.defineProperty(this, '_fields', {
        value: this._findFields(this._locale)
    });
    $dkjqU.defineProperty(this, '_messages', {
        value: $dkjqU.objCreate(null)
    });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
$dkjqU.defineProperty($d5afc5f66ece4e5c$var$RelativeFormat, '__localeData__', {
    value: $dkjqU.objCreate(null)
});
$dkjqU.defineProperty($d5afc5f66ece4e5c$var$RelativeFormat, '__addLocaleData', {
    value: function() {
        for(var i = 0; i < arguments.length; i++){
            var datum = arguments[i];
            if (!(datum && datum.locale)) throw new Error("Locale data provided to IntlRelativeFormat is missing a `locale` property value");
            $d5afc5f66ece4e5c$var$RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            $4Rof2.default.__addLocaleData(datum);
        }
    }
});
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
$dkjqU.defineProperty($d5afc5f66ece4e5c$var$RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
$dkjqU.defineProperty($d5afc5f66ece4e5c$var$RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45,
        'second-short': 45,
        minute: 45,
        'minute-short': 45,
        hour: 22,
        'hour-short': 22,
        day: 26,
        'day-short': 26,
        month: 11,
        'month-short': 11 // months to year
    }
});
$d5afc5f66ece4e5c$var$RelativeFormat.prototype.resolvedOptions = function() {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
$d5afc5f66ece4e5c$var$RelativeFormat.prototype._compileMessage = function(units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for(i in relativeTime.future)if (relativeTime.future.hasOwnProperty(i)) future += ' ' + i + ' {' + relativeTime.future[i].replace('{0}', '#') + '}';
    for(i in relativeTime.past)if (relativeTime.past.hasOwnProperty(i)) past += ' ' + i + ' {' + relativeTime.past[i].replace('{0}', '#') + '}';
    var message = '{when, select, future {{0, plural, ' + future + '}}' + 'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new $4Rof2.default(message, locales);
};
$d5afc5f66ece4e5c$var$RelativeFormat.prototype._getMessage = function(units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) messages[units] = this._compileMessage(units);
    return messages[units];
};
$d5afc5f66ece4e5c$var$RelativeFormat.prototype._getRelativeUnits = function(diff, units) {
    var field = this._fields[units];
    if (field.relative) return field.relative[diff];
};
$d5afc5f66ece4e5c$var$RelativeFormat.prototype._findFields = function(locale) {
    var localeData = $d5afc5f66ece4e5c$var$RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while(data){
        if (data.fields) return data.fields;
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' + locale);
};
$d5afc5f66ece4e5c$var$RelativeFormat.prototype._format = function(date, options) {
    var now = options && options.now !== undefined ? options.now : $dkjqU.dateNow();
    if (date === undefined) date = now;
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) throw new RangeError("The `now` option provided to IntlRelativeFormat#format() is not in valid range.");
    if (!isFinite(date)) throw new RangeError("The date value provided to IntlRelativeFormat#format() is not in valid range.");
    var diffReport = $jDL63.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) return relativeUnits;
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
$d5afc5f66ece4e5c$var$RelativeFormat.prototype._isValidUnits = function(units) {
    if (!units || $dkjqU.arrIndexOf.call($d5afc5f66ece4e5c$var$FIELDS, units) >= 0) return true;
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && $dkjqU.arrIndexOf.call($d5afc5f66ece4e5c$var$FIELDS, suggestion) >= 0) throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' + 'value, did you mean: ' + suggestion);
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' + 'must be one of: "' + $d5afc5f66ece4e5c$var$FIELDS.join('", "') + '"');
};
$d5afc5f66ece4e5c$var$RelativeFormat.prototype._resolveLocale = function(locales) {
    if (typeof locales === 'string') locales = [
        locales
    ];
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat($d5afc5f66ece4e5c$var$RelativeFormat.defaultLocale);
    var localeData = $d5afc5f66ece4e5c$var$RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for(i = 0, len = locales.length; i < len; i += 1){
        localeParts = locales[i].toLowerCase().split('-');
        while(localeParts.length){
            data = localeData[localeParts.join('-')];
            if (data) // Return the normalized locale string; e.g., we return "en-US",
            // instead of "en-us".
            return data.locale;
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' + locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
$d5afc5f66ece4e5c$var$RelativeFormat.prototype._resolveStyle = function(style) {
    // Default to "best fit" style.
    if (!style) return $d5afc5f66ece4e5c$var$STYLES[0];
    if ($dkjqU.arrIndexOf.call($d5afc5f66ece4e5c$var$STYLES, style) >= 0) return style;
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' + 'must be one of: "' + $d5afc5f66ece4e5c$var$STYLES.join('", "') + '"');
};
$d5afc5f66ece4e5c$var$RelativeFormat.prototype._selectUnits = function(diffReport) {
    var i, l, units;
    var fields = $d5afc5f66ece4e5c$var$FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });
    for(i = 0, l = fields.length; i < l; i += 1){
        units = fields[i];
        if (Math.abs(diffReport[units]) < $d5afc5f66ece4e5c$var$RelativeFormat.thresholds[units]) break;
    }
    return units;
};

});
parcelRegister("4Rof2", function(module, exports) {
/* jshint node:true */ 'use strict';

var $4vUyr = parcelRequire("4vUyr");
var IntlMessageFormat = $4vUyr.default;
parcelRequire("lOPnY");
// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;

});
parcelRegister("4vUyr", function(module, exports) {
$parcel$export(module.exports, "default", () => $3495ed3a1c2d543a$export$2e2bcd8739ae039, (v) => $3495ed3a1c2d543a$export$2e2bcd8739ae039 = v);
/* jslint esnext: true */ var $3495ed3a1c2d543a$export$2e2bcd8739ae039;
"use strict";

var $aG4HX = parcelRequire("aG4HX");

var $9vNCn = parcelRequire("9vNCn");
$aG4HX.default.__addLocaleData($9vNCn.default);
$aG4HX.default.defaultLocale = 'en';
$3495ed3a1c2d543a$export$2e2bcd8739ae039 = $aG4HX.default;

});
parcelRegister("aG4HX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c617a8da6cf876b$export$2e2bcd8739ae039, (v) => $7c617a8da6cf876b$export$2e2bcd8739ae039 = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $7c617a8da6cf876b$export$2e2bcd8739ae039;
"use strict";

var $3AGrU = parcelRequire("3AGrU");

var $loXqt = parcelRequire("loXqt");

var $fNdRY = parcelRequire("fNdRY");

var $2w2z1 = parcelRequire("2w2z1");
$7c617a8da6cf876b$export$2e2bcd8739ae039 = $7c617a8da6cf876b$var$MessageFormat;
// -- MessageFormat --------------------------------------------------------
function $7c617a8da6cf876b$var$MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ? $7c617a8da6cf876b$var$MessageFormat.__parse(message) : message;
    if (!(ast && ast.type === 'messageFormatPattern')) throw new TypeError('A message must be provided as a String or AST.');
    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats($7c617a8da6cf876b$var$MessageFormat.formats, formats);
    // Defined first because it's used to build the format pattern.
    $loXqt.defineProperty(this, '_locale', {
        value: this._resolveLocale(locales)
    });
    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern = this._compilePattern(ast, locales, formats, pluralFn);
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function(values) {
        try {
            return messageFormat._format(pattern, values);
        } catch (e) {
            if (e.variableId) throw new Error('The intl string context variable \'' + e.variableId + '\'' + ' was not provided to the string \'' + message + '\'');
            else throw e;
        }
    };
}
// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
$loXqt.defineProperty($7c617a8da6cf876b$var$MessageFormat, 'formats', {
    enumerable: true,
    value: {
        number: {
            'currency': {
                style: 'currency'
            },
            'percent': {
                style: 'percent'
            }
        },
        date: {
            'short': {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            'medium': {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            'long': {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            'full': {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            'short': {
                hour: 'numeric',
                minute: 'numeric'
            },
            'medium': {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            'long': {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            'full': {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});
// Define internal private properties for dealing with locale data.
$loXqt.defineProperty($7c617a8da6cf876b$var$MessageFormat, '__localeData__', {
    value: $loXqt.objCreate(null)
});
$loXqt.defineProperty($7c617a8da6cf876b$var$MessageFormat, '__addLocaleData', {
    value: function(data) {
        if (!(data && data.locale)) throw new Error("Locale data provided to IntlMessageFormat is missing a `locale` property");
        $7c617a8da6cf876b$var$MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
    }
});
// Defines `__parse()` static method as an exposed private.
$loXqt.defineProperty($7c617a8da6cf876b$var$MessageFormat, '__parse', {
    value: $2w2z1.default.parse
});
// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
$loXqt.defineProperty($7c617a8da6cf876b$var$MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
$7c617a8da6cf876b$var$MessageFormat.prototype.resolvedOptions = function() {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};
$7c617a8da6cf876b$var$MessageFormat.prototype._compilePattern = function(ast, locales, formats, pluralFn) {
    var compiler = new $fNdRY.default(locales, formats, pluralFn);
    return compiler.compile(ast);
};
$7c617a8da6cf876b$var$MessageFormat.prototype._findPluralRuleFunction = function(locale) {
    var localeData = $7c617a8da6cf876b$var$MessageFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while(data){
        if (data.pluralRuleFunction) return data.pluralRuleFunction;
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error("Locale data added to IntlMessageFormat is missing a `pluralRuleFunction` for :" + locale);
};
$7c617a8da6cf876b$var$MessageFormat.prototype._format = function(pattern, values) {
    var result = '', i, len, part, id, value, err;
    for(i = 0, len = pattern.length; i < len; i += 1){
        part = pattern[i];
        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }
        id = part.id;
        // Enforce that all required values are provided by the caller.
        if (!(values && $3AGrU.hop.call(values, id))) {
            err = new Error('A value must be provided for: ' + id);
            err.variableId = id;
            throw err;
        }
        value = values[id];
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) result += this._format(part.getOption(value), values);
        else result += part.format(value);
    }
    return result;
};
$7c617a8da6cf876b$var$MessageFormat.prototype._mergeFormats = function(defaults, formats) {
    var mergedFormats = {}, type, mergedType;
    for(type in defaults){
        if (!$3AGrU.hop.call(defaults, type)) continue;
        mergedFormats[type] = mergedType = $loXqt.objCreate(defaults[type]);
        if (formats && $3AGrU.hop.call(formats, type)) $3AGrU.extend(mergedType, formats[type]);
    }
    return mergedFormats;
};
$7c617a8da6cf876b$var$MessageFormat.prototype._resolveLocale = function(locales) {
    if (typeof locales === 'string') locales = [
        locales
    ];
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat($7c617a8da6cf876b$var$MessageFormat.defaultLocale);
    var localeData = $7c617a8da6cf876b$var$MessageFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for(i = 0, len = locales.length; i < len; i += 1){
        localeParts = locales[i].toLowerCase().split('-');
        while(localeParts.length){
            data = localeData[localeParts.join('-')];
            if (data) // Return the normalized locale string; e.g., we return "en-US",
            // instead of "en-us".
            return data.locale;
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlMessageFormat for: ' + locales.join(', ') + ', or the default locale: ' + defaultLocale);
};

});
parcelRegister("3AGrU", function(module, exports) {
$parcel$export(module.exports, "extend", () => $29d5a96cdc0284bd$export$8b58be045bf06082, (v) => $29d5a96cdc0284bd$export$8b58be045bf06082 = v);
$parcel$export(module.exports, "hop", () => $29d5a96cdc0284bd$export$ddc501d3db01d79c, (v) => $29d5a96cdc0284bd$export$ddc501d3db01d79c = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $29d5a96cdc0284bd$export$8b58be045bf06082;
var $29d5a96cdc0284bd$export$ddc501d3db01d79c;
"use strict";
$29d5a96cdc0284bd$export$8b58be045bf06082 = $29d5a96cdc0284bd$var$extend;
var $29d5a96cdc0284bd$var$hop = Object.prototype.hasOwnProperty;
function $29d5a96cdc0284bd$var$extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1), i, len, source, key;
    for(i = 0, len = sources.length; i < len; i += 1){
        source = sources[i];
        if (!source) continue;
        for(key in source)if ($29d5a96cdc0284bd$var$hop.call(source, key)) obj[key] = source[key];
    }
    return obj;
}
$29d5a96cdc0284bd$export$ddc501d3db01d79c = $29d5a96cdc0284bd$var$hop;

});

parcelRegister("loXqt", function(module, exports) {
$parcel$export(module.exports, "defineProperty", () => $f949efa7417baa88$export$fdab3c20aae16ddf, (v) => $f949efa7417baa88$export$fdab3c20aae16ddf = v);
$parcel$export(module.exports, "objCreate", () => $f949efa7417baa88$export$c09f2411a4ae511b, (v) => $f949efa7417baa88$export$c09f2411a4ae511b = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $f949efa7417baa88$export$fdab3c20aae16ddf;
var $f949efa7417baa88$export$c09f2411a4ae511b;
"use strict";

var $3AGrU = parcelRequire("3AGrU");
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var $f949efa7417baa88$var$realDefineProp = function() {
    try {
        return !!Object.defineProperty({}, 'a', {});
    } catch (e) {
        return false;
    }
}();
var $f949efa7417baa88$var$es3 = !$f949efa7417baa88$var$realDefineProp && !Object.prototype.__defineGetter__;
var $f949efa7417baa88$var$defineProperty = $f949efa7417baa88$var$realDefineProp ? Object.defineProperty : function(obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);
    else if (!$3AGrU.hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};
var $f949efa7417baa88$var$objCreate = Object.create || function(proto, props) {
    var obj, k;
    function F() {}
    F.prototype = proto;
    obj = new F();
    for(k in props)if ($3AGrU.hop.call(props, k)) $f949efa7417baa88$var$defineProperty(obj, k, props[k]);
    return obj;
};
$f949efa7417baa88$export$fdab3c20aae16ddf = $f949efa7417baa88$var$defineProperty, $f949efa7417baa88$export$c09f2411a4ae511b = $f949efa7417baa88$var$objCreate;

});

parcelRegister("fNdRY", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7f630d80d0bf153$export$2e2bcd8739ae039, (v) => $b7f630d80d0bf153$export$2e2bcd8739ae039 = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $b7f630d80d0bf153$export$2e2bcd8739ae039;
"use strict";
$b7f630d80d0bf153$export$2e2bcd8739ae039 = $b7f630d80d0bf153$var$Compiler;
function $b7f630d80d0bf153$var$Compiler(locales, formats, pluralFn) {
    this.locales = locales;
    this.formats = formats;
    this.pluralFn = pluralFn;
}
$b7f630d80d0bf153$var$Compiler.prototype.compile = function(ast) {
    this.pluralStack = [];
    this.currentPlural = null;
    this.pluralNumberFormat = null;
    return this.compileMessage(ast);
};
$b7f630d80d0bf153$var$Compiler.prototype.compileMessage = function(ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) throw new Error('Message AST is not of type: "messageFormatPattern"');
    var elements = ast.elements, pattern = [];
    var i, len, element;
    for(i = 0, len = elements.length; i < len; i += 1){
        element = elements[i];
        switch(element.type){
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;
            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;
            default:
                throw new Error('Message element does not have a valid type');
        }
    }
    return pattern;
};
$b7f630d80d0bf153$var$Compiler.prototype.compileMessageText = function(element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        return new $b7f630d80d0bf153$var$PluralOffsetString(this.currentPlural.id, this.currentPlural.format.offset, this.pluralNumberFormat, element.value);
    }
    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};
$b7f630d80d0bf153$var$Compiler.prototype.compileArgument = function(element) {
    var format = element.format;
    if (!format) return new $b7f630d80d0bf153$var$StringFormat(element.id);
    var formats = this.formats, locales = this.locales, pluralFn = this.pluralFn, options;
    switch(format.type){
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id: element.id,
                format: new Intl.NumberFormat(locales, options).format
            };
        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id: element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };
        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id: element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };
        case 'pluralFormat':
            options = this.compileOptions(element);
            return new $b7f630d80d0bf153$var$PluralFormat(element.id, format.ordinal, format.offset, options, pluralFn);
        case 'selectFormat':
            options = this.compileOptions(element);
            return new $b7f630d80d0bf153$var$SelectFormat(element.id, options);
        default:
            throw new Error('Message element does not have a valid format type');
    }
};
$b7f630d80d0bf153$var$Compiler.prototype.compileOptions = function(element) {
    var format = element.format, options = format.options, optionsHash = {};
    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;
    var i, len, option;
    for(i = 0, len = options.length; i < len; i += 1){
        option = options[i];
        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }
    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();
    return optionsHash;
};
// -- Compiler Helper Classes --------------------------------------------------
function $b7f630d80d0bf153$var$StringFormat(id) {
    this.id = id;
}
$b7f630d80d0bf153$var$StringFormat.prototype.format = function(value) {
    if (!value && typeof value !== 'number') return '';
    return typeof value === 'string' ? value : String(value);
};
function $b7f630d80d0bf153$var$PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id = id;
    this.useOrdinal = useOrdinal;
    this.offset = offset;
    this.options = options;
    this.pluralFn = pluralFn;
}
$b7f630d80d0bf153$var$PluralFormat.prototype.getOption = function(value) {
    var options = this.options;
    var option = options['=' + value] || options[this.pluralFn(value - this.offset, this.useOrdinal)];
    return option || options.other;
};
function $b7f630d80d0bf153$var$PluralOffsetString(id, offset, numberFormat, string) {
    this.id = id;
    this.offset = offset;
    this.numberFormat = numberFormat;
    this.string = string;
}
$b7f630d80d0bf153$var$PluralOffsetString.prototype.format = function(value) {
    var number = this.numberFormat.format(value - this.offset);
    return this.string.replace(/(^|[^\\])#/g, '$1' + number).replace(/\\#/g, '#');
};
function $b7f630d80d0bf153$var$SelectFormat(id, options) {
    this.id = id;
    this.options = options;
}
$b7f630d80d0bf153$var$SelectFormat.prototype.getOption = function(value) {
    var options = this.options;
    return options[value] || options.other;
};

});

parcelRegister("2w2z1", function(module, exports) {
'use strict';

exports = module.exports = (parcelRequire("9OCau")).default;
exports['default'] = exports;

});
parcelRegister("9OCau", function(module, exports) {
$parcel$export(module.exports, "default", () => $725663fa5da4031e$export$2e2bcd8739ae039, (v) => $725663fa5da4031e$export$2e2bcd8739ae039 = v);
var $725663fa5da4031e$export$2e2bcd8739ae039;
"use strict";
$725663fa5da4031e$export$2e2bcd8739ae039 = function() {
    "use strict";
    /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */ function peg$subclass(child, parent) {
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
    }
    function peg$SyntaxError(message, expected, found, location) {
        this.message = message;
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, peg$SyntaxError);
    }
    peg$subclass(peg$SyntaxError, Error);
    function peg$parse(input) {
        var options = arguments.length > 1 ? arguments[1] : {}, parser = this, peg$FAILED = {}, peg$startRuleFunctions = {
            start: peg$parsestart
        }, peg$startRuleFunction = peg$parsestart, peg$c0 = function(elements) {
            return {
                type: 'messageFormatPattern',
                elements: elements,
                location: location()
            };
        }, peg$c1 = function(text) {
            var string = '', i, j, outerLen, inner, innerLen;
            for(i = 0, outerLen = text.length; i < outerLen; i += 1){
                inner = text[i];
                for(j = 0, innerLen = inner.length; j < innerLen; j += 1)string += inner[j];
            }
            return string;
        }, peg$c2 = function(messageText) {
            return {
                type: 'messageTextElement',
                value: messageText,
                location: location()
            };
        }, peg$c3 = /^[^ \t\n\r,.+={}#]/, peg$c4 = {
            type: "class",
            value: "[^ \\t\\n\\r,.+={}#]",
            description: "[^ \\t\\n\\r,.+={}#]"
        }, peg$c5 = "{", peg$c6 = {
            type: "literal",
            value: "{",
            description: "\"{\""
        }, peg$c7 = ",", peg$c8 = {
            type: "literal",
            value: ",",
            description: "\",\""
        }, peg$c9 = "}", peg$c10 = {
            type: "literal",
            value: "}",
            description: "\"}\""
        }, peg$c11 = function(id, format) {
            return {
                type: 'argumentElement',
                id: id,
                format: format && format[2],
                location: location()
            };
        }, peg$c12 = "number", peg$c13 = {
            type: "literal",
            value: "number",
            description: "\"number\""
        }, peg$c14 = "date", peg$c15 = {
            type: "literal",
            value: "date",
            description: "\"date\""
        }, peg$c16 = "time", peg$c17 = {
            type: "literal",
            value: "time",
            description: "\"time\""
        }, peg$c18 = function(type, style) {
            return {
                type: type + 'Format',
                style: style && style[2],
                location: location()
            };
        }, peg$c19 = "plural", peg$c20 = {
            type: "literal",
            value: "plural",
            description: "\"plural\""
        }, peg$c21 = function(pluralStyle) {
            return {
                type: pluralStyle.type,
                ordinal: false,
                offset: pluralStyle.offset || 0,
                options: pluralStyle.options,
                location: location()
            };
        }, peg$c22 = "selectordinal", peg$c23 = {
            type: "literal",
            value: "selectordinal",
            description: "\"selectordinal\""
        }, peg$c24 = function(pluralStyle) {
            return {
                type: pluralStyle.type,
                ordinal: true,
                offset: pluralStyle.offset || 0,
                options: pluralStyle.options,
                location: location()
            };
        }, peg$c25 = "select", peg$c26 = {
            type: "literal",
            value: "select",
            description: "\"select\""
        }, peg$c27 = function(options) {
            return {
                type: 'selectFormat',
                options: options,
                location: location()
            };
        }, peg$c28 = "=", peg$c29 = {
            type: "literal",
            value: "=",
            description: "\"=\""
        }, peg$c30 = function(selector, pattern) {
            return {
                type: 'optionalFormatPattern',
                selector: selector,
                value: pattern,
                location: location()
            };
        }, peg$c31 = "offset:", peg$c32 = {
            type: "literal",
            value: "offset:",
            description: "\"offset:\""
        }, peg$c33 = function(number) {
            return number;
        }, peg$c34 = function(offset, options) {
            return {
                type: 'pluralFormat',
                offset: offset,
                options: options,
                location: location()
            };
        }, peg$c35 = {
            type: "other",
            description: "whitespace"
        }, peg$c36 = /^[ \t\n\r]/, peg$c37 = {
            type: "class",
            value: "[ \\t\\n\\r]",
            description: "[ \\t\\n\\r]"
        }, peg$c38 = {
            type: "other",
            description: "optionalWhitespace"
        }, peg$c39 = /^[0-9]/, peg$c40 = {
            type: "class",
            value: "[0-9]",
            description: "[0-9]"
        }, peg$c41 = /^[0-9a-f]/i, peg$c42 = {
            type: "class",
            value: "[0-9a-f]i",
            description: "[0-9a-f]i"
        }, peg$c43 = "0", peg$c44 = {
            type: "literal",
            value: "0",
            description: "\"0\""
        }, peg$c45 = /^[1-9]/, peg$c46 = {
            type: "class",
            value: "[1-9]",
            description: "[1-9]"
        }, peg$c47 = function(digits) {
            return parseInt(digits, 10);
        }, peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/, peg$c49 = {
            type: "class",
            value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]",
            description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]"
        }, peg$c50 = "\\\\", peg$c51 = {
            type: "literal",
            value: "\\\\",
            description: "\"\\\\\\\\\""
        }, peg$c52 = function() {
            return '\\';
        }, peg$c53 = "\\#", peg$c54 = {
            type: "literal",
            value: "\\#",
            description: "\"\\\\#\""
        }, peg$c55 = function() {
            return '\\#';
        }, peg$c56 = "\\{", peg$c57 = {
            type: "literal",
            value: "\\{",
            description: "\"\\\\{\""
        }, peg$c58 = function() {
            return '\u007B';
        }, peg$c59 = "\\}", peg$c60 = {
            type: "literal",
            value: "\\}",
            description: "\"\\\\}\""
        }, peg$c61 = function() {
            return '\u007D';
        }, peg$c62 = "\\u", peg$c63 = {
            type: "literal",
            value: "\\u",
            description: "\"\\\\u\""
        }, peg$c64 = function(digits) {
            return String.fromCharCode(parseInt(digits, 16));
        }, peg$c65 = function(chars) {
            return chars.join('');
        }, peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [
            {
                line: 1,
                column: 1,
                seenCR: false
            }
        ], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ("startRule" in options) {
            if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
            peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
            return input.substring(peg$savedPos, peg$currPos);
        }
        function location() {
            return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description) {
            throw peg$buildException(null, [
                {
                    type: "other",
                    description: description
                }
            ], input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
        }
        function error(message) {
            throw peg$buildException(message, null, input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
        }
        function peg$computePosDetails(pos) {
            var details = peg$posDetailsCache[pos], p, ch;
            if (details) return details;
            else {
                p = pos - 1;
                while(!peg$posDetailsCache[p])p--;
                details = peg$posDetailsCache[p];
                details = {
                    line: details.line,
                    column: details.column,
                    seenCR: details.seenCR
                };
                while(p < pos){
                    ch = input.charAt(p);
                    if (ch === "\n") {
                        if (!details.seenCR) details.line++;
                        details.column = 1;
                        details.seenCR = false;
                    } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
                        details.line++;
                        details.column = 1;
                        details.seenCR = true;
                    } else {
                        details.column++;
                        details.seenCR = false;
                    }
                    p++;
                }
                peg$posDetailsCache[pos] = details;
                return details;
            }
        }
        function peg$computeLocation(startPos, endPos) {
            var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
            return {
                start: {
                    offset: startPos,
                    line: startPosDetails.line,
                    column: startPosDetails.column
                },
                end: {
                    offset: endPos,
                    line: endPosDetails.line,
                    column: endPosDetails.column
                }
            };
        }
        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) return;
            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos;
                peg$maxFailExpected = [];
            }
            peg$maxFailExpected.push(expected);
        }
        function peg$buildException(message, expected, found, location) {
            function cleanupExpected(expected) {
                var i = 1;
                expected.sort(function(a, b) {
                    if (a.description < b.description) return -1;
                    else if (a.description > b.description) return 1;
                    else return 0;
                });
                while(i < expected.length)if (expected[i - 1] === expected[i]) expected.splice(i, 1);
                else i++;
            }
            function buildMessage(expected, found) {
                function stringEscape(s) {
                    function hex(ch) {
                        return ch.charCodeAt(0).toString(16).toUpperCase();
                    }
                    return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\x08/g, '\\b').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\f/g, '\\f').replace(/\r/g, '\\r').replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) {
                        return '\\x0' + hex(ch);
                    }).replace(/[\x10-\x1F\x80-\xFF]/g, function(ch) {
                        return '\\x' + hex(ch);
                    }).replace(/[\u0100-\u0FFF]/g, function(ch) {
                        return '\\u0' + hex(ch);
                    }).replace(/[\u1000-\uFFFF]/g, function(ch) {
                        return '\\u' + hex(ch);
                    });
                }
                var expectedDescs = new Array(expected.length), expectedDesc, foundDesc, i;
                for(i = 0; i < expected.length; i++)expectedDescs[i] = expected[i].description;
                expectedDesc = expected.length > 1 ? expectedDescs.slice(0, -1).join(", ") + " or " + expectedDescs[expected.length - 1] : expectedDescs[0];
                foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
                return "Expected " + expectedDesc + " but " + foundDesc + " found.";
            }
            if (expected !== null) cleanupExpected(expected);
            return new peg$SyntaxError(message !== null ? message : buildMessage(expected, found), expected, found, location);
        }
        function peg$parsestart() {
            var s0;
            s0 = peg$parsemessageFormatPattern();
            return s0;
        }
        function peg$parsemessageFormatPattern() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsemessageFormatElement();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsemessageFormatElement();
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c0(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parsemessageFormatElement() {
            var s0;
            s0 = peg$parsemessageTextElement();
            if (s0 === peg$FAILED) s0 = peg$parseargumentElement();
            return s0;
        }
        function peg$parsemessageText() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$currPos;
            s3 = peg$parse_();
            if (s3 !== peg$FAILED) {
                s4 = peg$parsechars();
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    if (s5 !== peg$FAILED) {
                        s3 = [
                            s3,
                            s4,
                            s5
                        ];
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$currPos;
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsechars();
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_();
                        if (s5 !== peg$FAILED) {
                            s3 = [
                                s3,
                                s4,
                                s5
                            ];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
            else s1 = peg$FAILED;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c1(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsews();
                if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
                else s0 = s1;
            }
            return s0;
        }
        function peg$parsemessageTextElement() {
            var s0, s1;
            s0 = peg$currPos;
            s1 = peg$parsemessageText();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c2(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseargument() {
            var s0, s1, s2;
            s0 = peg$parsenumber();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                if (peg$c3.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c4);
                }
                if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                    s1.push(s2);
                    if (peg$c3.test(input.charAt(peg$currPos))) {
                        s2 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c4);
                    }
                }
                else s1 = peg$FAILED;
                if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
                else s0 = s1;
            }
            return s0;
        }
        function peg$parseargumentElement() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 123) {
                s1 = peg$c5;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c6);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseargument();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s6 = peg$c7;
                                peg$currPos++;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c8);
                            }
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parse_();
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parseelementFormat();
                                    if (s8 !== peg$FAILED) {
                                        s6 = [
                                            s6,
                                            s7,
                                            s8
                                        ];
                                        s5 = s6;
                                    } else {
                                        peg$currPos = s5;
                                        s5 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s5;
                                    s5 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                            if (s5 === peg$FAILED) s5 = null;
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 125) {
                                        s7 = peg$c9;
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c10);
                                    }
                                    if (s7 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c11(s3, s5);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseelementFormat() {
            var s0;
            s0 = peg$parsesimpleFormat();
            if (s0 === peg$FAILED) {
                s0 = peg$parsepluralFormat();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseselectOrdinalFormat();
                    if (s0 === peg$FAILED) s0 = peg$parseselectFormat();
                }
            }
            return s0;
        }
        function peg$parsesimpleFormat() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c12) {
                s1 = peg$c12;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c13);
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 4) === peg$c14) {
                    s1 = peg$c14;
                    peg$currPos += 4;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c15);
                }
                if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 4) === peg$c16) {
                        s1 = peg$c16;
                        peg$currPos += 4;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c17);
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s4 = peg$c7;
                        peg$currPos++;
                    } else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parsechars();
                            if (s6 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5,
                                    s6
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                    if (s3 === peg$FAILED) s3 = null;
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c18(s1, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsepluralFormat() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c19) {
                s1 = peg$c19;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c20);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s3 = peg$c7;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsepluralStyle();
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c21(s5);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseselectOrdinalFormat() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 13) === peg$c22) {
                s1 = peg$c22;
                peg$currPos += 13;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c23);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s3 = peg$c7;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsepluralStyle();
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c24(s5);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseselectFormat() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c25) {
                s1 = peg$c25;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c26);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s3 = peg$c7;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseoptionalFormatPattern();
                            if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                                s5.push(s6);
                                s6 = peg$parseoptionalFormatPattern();
                            }
                            else s5 = peg$FAILED;
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c27(s5);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseselector() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 61) {
                s2 = peg$c28;
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c29);
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parsenumber();
                if (s3 !== peg$FAILED) {
                    s2 = [
                        s2,
                        s3
                    ];
                    s1 = s2;
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            if (s0 === peg$FAILED) s0 = peg$parsechars();
            return s0;
        }
        function peg$parseoptionalFormatPattern() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = peg$parse_();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseselector();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parse_();
                    if (s3 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 123) {
                            s4 = peg$c5;
                            peg$currPos++;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c6);
                        }
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parse_();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parsemessageFormatPattern();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parse_();
                                    if (s7 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 125) {
                                            s8 = peg$c9;
                                            peg$currPos++;
                                        } else {
                                            s8 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c10);
                                        }
                                        if (s8 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c30(s2, s6);
                                            s0 = s1;
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseoffset() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 7) === peg$c31) {
                s1 = peg$c31;
                peg$currPos += 7;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c32);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsenumber();
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c33(s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsepluralStyle() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parseoffset();
            if (s1 === peg$FAILED) s1 = null;
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseoptionalFormatPattern();
                    if (s4 !== peg$FAILED) while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseoptionalFormatPattern();
                    }
                    else s3 = peg$FAILED;
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c34(s1, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsews() {
            var s0, s1;
            peg$silentFails++;
            s0 = [];
            if (peg$c36.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c37);
            }
            if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
                s0.push(s1);
                if (peg$c36.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c37);
                }
            }
            else s0 = peg$FAILED;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c35);
            }
            return s0;
        }
        function peg$parse_() {
            var s0, s1, s2;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsews();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsews();
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c38);
            }
            return s0;
        }
        function peg$parsedigit() {
            var s0;
            if (peg$c39.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c40);
            }
            return s0;
        }
        function peg$parsehexDigit() {
            var s0;
            if (peg$c41.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c42);
            }
            return s0;
        }
        function peg$parsenumber() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 48) {
                s1 = peg$c43;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c44);
            }
            if (s1 === peg$FAILED) {
                s1 = peg$currPos;
                s2 = peg$currPos;
                if (peg$c45.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c46);
                }
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    s5 = peg$parsedigit();
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        s5 = peg$parsedigit();
                    }
                    if (s4 !== peg$FAILED) {
                        s3 = [
                            s3,
                            s4
                        ];
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
                else s1 = s2;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c47(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parsechar() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            if (peg$c48.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c49);
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c50) {
                    s1 = peg$c50;
                    peg$currPos += 2;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c51);
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c52();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c53) {
                        s1 = peg$c53;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c54);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c55();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c56) {
                            s1 = peg$c56;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c57);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c58();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 2) === peg$c59) {
                                s1 = peg$c59;
                                peg$currPos += 2;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c60);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c61();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 2) === peg$c62) {
                                    s1 = peg$c62;
                                    peg$currPos += 2;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c63);
                                }
                                if (s1 !== peg$FAILED) {
                                    s2 = peg$currPos;
                                    s3 = peg$currPos;
                                    s4 = peg$parsehexDigit();
                                    if (s4 !== peg$FAILED) {
                                        s5 = peg$parsehexDigit();
                                        if (s5 !== peg$FAILED) {
                                            s6 = peg$parsehexDigit();
                                            if (s6 !== peg$FAILED) {
                                                s7 = peg$parsehexDigit();
                                                if (s7 !== peg$FAILED) {
                                                    s4 = [
                                                        s4,
                                                        s5,
                                                        s6,
                                                        s7
                                                    ];
                                                    s3 = s4;
                                                } else {
                                                    peg$currPos = s3;
                                                    s3 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s3;
                                                s3 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                    if (s3 !== peg$FAILED) s2 = input.substring(s2, peg$currPos);
                                    else s2 = s3;
                                    if (s2 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c64(s2);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parsechars() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsechar();
            if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsechar();
            }
            else s1 = peg$FAILED;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c65(s1);
            }
            s0 = s1;
            return s0;
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
        else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail({
                type: "end",
                description: "end of input"
            });
            throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
        }
    }
    return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse
    };
}();

});



parcelRegister("9vNCn", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ecd7f6990b81bf0$export$2e2bcd8739ae039, (v) => $6ecd7f6990b81bf0$export$2e2bcd8739ae039 = v);
// GENERATED FILE
var $6ecd7f6990b81bf0$export$2e2bcd8739ae039;
"use strict";
$6ecd7f6990b81bf0$export$2e2bcd8739ae039 = {
    "locale": "en",
    "pluralRuleFunction": function(n, ord) {
        var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
        return n == 1 && v0 ? "one" : "other";
    }
};

});



parcelRegister("jDL63", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/* jslint esnext: true */ var $e4c631417702abc7$var$round = Math.round;
function $e4c631417702abc7$var$daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var $e4c631417702abc7$var$MILLISECONDS_IN_MINUTE = 60000;
var $e4c631417702abc7$var$MILLISECONDS_IN_DAY = 86400000;
function $e4c631417702abc7$var$startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function $e4c631417702abc7$var$differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = $e4c631417702abc7$var$startOfDay(dirtyDateLeft);
    var startOfDayRight = $e4c631417702abc7$var$startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - startOfDayLeft.getTimezoneOffset() * $e4c631417702abc7$var$MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() - startOfDayRight.getTimezoneOffset() * $e4c631417702abc7$var$MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $e4c631417702abc7$var$MILLISECONDS_IN_DAY);
}
function $e4c631417702abc7$var$default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = $e4c631417702abc7$var$round(to - from), second = $e4c631417702abc7$var$round(millisecond / 1000), minute = $e4c631417702abc7$var$round(second / 60), hour = $e4c631417702abc7$var$round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = $e4c631417702abc7$var$differenceInCalendarDays(to, from);
    var week = $e4c631417702abc7$var$round(day / 7);
    var rawYears = $e4c631417702abc7$var$daysToYears(day), month = $e4c631417702abc7$var$round(rawYears * 12), year = $e4c631417702abc7$var$round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
module.exports.default = $e4c631417702abc7$var$default_1;

});

parcelRegister("dkjqU", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/* jslint esnext: true */ // Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var $9b3c37966a733091$var$hop = Object.prototype.hasOwnProperty;
var $9b3c37966a733091$var$toString = Object.prototype.toString;
var $9b3c37966a733091$var$realDefineProp = function() {
    try {
        return !!Object.defineProperty({}, 'a', {});
    } catch (e) {
        return false;
    }
}();
var $9b3c37966a733091$var$es3 = !$9b3c37966a733091$var$realDefineProp && !Object.prototype.__defineGetter__;
var $9b3c37966a733091$var$defineProperty = $9b3c37966a733091$var$realDefineProp ? Object.defineProperty : function(obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);
    else if (!$9b3c37966a733091$var$hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};
module.exports.defineProperty = $9b3c37966a733091$var$defineProperty;
var $9b3c37966a733091$var$objCreate = Object.create || function(proto, props) {
    var obj, k;
    function F() {}
    F.prototype = proto;
    obj = new F();
    for(k in props)if ($9b3c37966a733091$var$hop.call(props, k)) $9b3c37966a733091$var$defineProperty(obj, k, props[k]);
    return obj;
};
module.exports.objCreate = $9b3c37966a733091$var$objCreate;
var $9b3c37966a733091$var$arrIndexOf = Array.prototype.indexOf || function(search, fromIndex) {
    /*jshint validthis:true */ var arr = this;
    if (!arr.length) return -1;
    for(var i = fromIndex || 0, max = arr.length; i < max; i++){
        if (arr[i] === search) return i;
    }
    return -1;
};
module.exports.arrIndexOf = $9b3c37966a733091$var$arrIndexOf;
var $9b3c37966a733091$var$isArray = Array.isArray || function(obj) {
    return $9b3c37966a733091$var$toString.call(obj) === '[object Array]';
};
module.exports.isArray = $9b3c37966a733091$var$isArray;
var $9b3c37966a733091$var$dateNow = Date.now || function() {
    return new Date().getTime();
};
module.exports.dateNow = $9b3c37966a733091$var$dateNow;

});


parcelRegister("2Hl4Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/* @generated */ module.exports.default = {
    "locale": "en",
    "pluralRuleFunction": function(n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord) return n10 == 1 && n100 != 11 ? 'one' : n10 == 2 && n100 != 12 ? 'two' : n10 == 3 && n100 != 13 ? 'few' : 'other';
        return n == 1 && v0 ? 'one' : 'other';
    },
    "fields": {
        "year": {
            "displayName": "year",
            "relative": {
                "0": "this year",
                "1": "next year",
                "-1": "last year"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} year",
                    "other": "in {0} years"
                },
                "past": {
                    "one": "{0} year ago",
                    "other": "{0} years ago"
                }
            }
        },
        "year-short": {
            "displayName": "yr.",
            "relative": {
                "0": "this yr.",
                "1": "next yr.",
                "-1": "last yr."
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} yr.",
                    "other": "in {0} yr."
                },
                "past": {
                    "one": "{0} yr. ago",
                    "other": "{0} yr. ago"
                }
            }
        },
        "month": {
            "displayName": "month",
            "relative": {
                "0": "this month",
                "1": "next month",
                "-1": "last month"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} month",
                    "other": "in {0} months"
                },
                "past": {
                    "one": "{0} month ago",
                    "other": "{0} months ago"
                }
            }
        },
        "month-short": {
            "displayName": "mo.",
            "relative": {
                "0": "this mo.",
                "1": "next mo.",
                "-1": "last mo."
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} mo.",
                    "other": "in {0} mo."
                },
                "past": {
                    "one": "{0} mo. ago",
                    "other": "{0} mo. ago"
                }
            }
        },
        "week": {
            "displayName": "week",
            "relativePeriod": "the week of {0}",
            "relative": {
                "0": "this week",
                "1": "next week",
                "-1": "last week"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} week",
                    "other": "in {0} weeks"
                },
                "past": {
                    "one": "{0} week ago",
                    "other": "{0} weeks ago"
                }
            }
        },
        "week-short": {
            "displayName": "wk.",
            "relativePeriod": "the week of {0}",
            "relative": {
                "0": "this wk.",
                "1": "next wk.",
                "-1": "last wk."
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} wk.",
                    "other": "in {0} wk."
                },
                "past": {
                    "one": "{0} wk. ago",
                    "other": "{0} wk. ago"
                }
            }
        },
        "day": {
            "displayName": "day",
            "relative": {
                "0": "today",
                "1": "tomorrow",
                "-1": "yesterday"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} day",
                    "other": "in {0} days"
                },
                "past": {
                    "one": "{0} day ago",
                    "other": "{0} days ago"
                }
            }
        },
        "day-short": {
            "displayName": "day",
            "relative": {
                "0": "today",
                "1": "tomorrow",
                "-1": "yesterday"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} day",
                    "other": "in {0} days"
                },
                "past": {
                    "one": "{0} day ago",
                    "other": "{0} days ago"
                }
            }
        },
        "hour": {
            "displayName": "hour",
            "relative": {
                "0": "this hour"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} hour",
                    "other": "in {0} hours"
                },
                "past": {
                    "one": "{0} hour ago",
                    "other": "{0} hours ago"
                }
            }
        },
        "hour-short": {
            "displayName": "hr.",
            "relative": {
                "0": "this hour"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} hr.",
                    "other": "in {0} hr."
                },
                "past": {
                    "one": "{0} hr. ago",
                    "other": "{0} hr. ago"
                }
            }
        },
        "minute": {
            "displayName": "minute",
            "relative": {
                "0": "this minute"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} minute",
                    "other": "in {0} minutes"
                },
                "past": {
                    "one": "{0} minute ago",
                    "other": "{0} minutes ago"
                }
            }
        },
        "minute-short": {
            "displayName": "min.",
            "relative": {
                "0": "this minute"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} min.",
                    "other": "in {0} min."
                },
                "past": {
                    "one": "{0} min. ago",
                    "other": "{0} min. ago"
                }
            }
        },
        "second": {
            "displayName": "second",
            "relative": {
                "0": "now"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} second",
                    "other": "in {0} seconds"
                },
                "past": {
                    "one": "{0} second ago",
                    "other": "{0} seconds ago"
                }
            }
        },
        "second-short": {
            "displayName": "sec.",
            "relative": {
                "0": "now"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} sec.",
                    "other": "in {0} sec."
                },
                "past": {
                    "one": "{0} sec. ago",
                    "other": "{0} sec. ago"
                }
            }
        }
    }
};

});



parcelRegister("lqUhi", function(module, exports) {
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f9a7ae4f031a8c6e$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f9a7ae4f031a8c6e$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f9a7ae4f031a8c6e$var$defineProperty = Object.defineProperty;
var $f9a7ae4f031a8c6e$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f9a7ae4f031a8c6e$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f9a7ae4f031a8c6e$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f9a7ae4f031a8c6e$var$getPrototypeOf = Object.getPrototypeOf;
var $f9a7ae4f031a8c6e$var$objectPrototype = $f9a7ae4f031a8c6e$var$getPrototypeOf && $f9a7ae4f031a8c6e$var$getPrototypeOf(Object);
function $f9a7ae4f031a8c6e$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($f9a7ae4f031a8c6e$var$objectPrototype) {
            var inheritedComponent = $f9a7ae4f031a8c6e$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f9a7ae4f031a8c6e$var$objectPrototype) $f9a7ae4f031a8c6e$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f9a7ae4f031a8c6e$var$getOwnPropertyNames(sourceComponent);
        if ($f9a7ae4f031a8c6e$var$getOwnPropertySymbols) keys = keys.concat($f9a7ae4f031a8c6e$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f9a7ae4f031a8c6e$var$REACT_STATICS[key] && !$f9a7ae4f031a8c6e$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $f9a7ae4f031a8c6e$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $f9a7ae4f031a8c6e$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $f9a7ae4f031a8c6e$var$hoistNonReactStatics;

});

parcelRegister("1SVIu", function(module, exports) {
'use strict';

exports = module.exports = (parcelRequire("3XSit")).default;
exports['default'] = exports;

});
parcelRegister("3XSit", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e310002350524ea$export$2e2bcd8739ae039, (v) => $2e310002350524ea$export$2e2bcd8739ae039 = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jshint esnext: true */ var $2e310002350524ea$export$2e2bcd8739ae039;
"use strict";

var $9Yx8w = parcelRequire("9Yx8w");
$2e310002350524ea$export$2e2bcd8739ae039 = $2e310002350524ea$var$createFormatCache;
// -----------------------------------------------------------------------------
function $2e310002350524ea$var$createFormatCache(FormatConstructor) {
    var cache = $9Yx8w.objCreate(null);
    return function() {
        var args = Array.prototype.slice.call(arguments);
        var cacheId = $2e310002350524ea$var$getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ($9Yx8w.bind.apply(FormatConstructor, [
                null
            ].concat(args)))();
            if (cacheId) cache[cacheId] = format;
        }
        return format;
    };
}
// -- Utilities ----------------------------------------------------------------
function $2e310002350524ea$var$getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') return;
    var cacheId = [];
    var i, len, input;
    for(i = 0, len = inputs.length; i < len; i += 1){
        input = inputs[i];
        if (input && typeof input === 'object') cacheId.push($2e310002350524ea$var$orderedProps(input));
        else cacheId.push(input);
    }
    return JSON.stringify(cacheId);
}
function $2e310002350524ea$var$orderedProps(obj) {
    var props = [], keys = [];
    var key, i, len, prop;
    for(key in obj)if (obj.hasOwnProperty(key)) keys.push(key);
    var orderedKeys = keys.sort();
    for(i = 0, len = orderedKeys.length; i < len; i += 1){
        key = orderedKeys[i];
        prop = {};
        prop[key] = obj[key];
        props[i] = prop;
    }
    return props;
}

});
parcelRegister("9Yx8w", function(module, exports) {
$parcel$export(module.exports, "bind", () => $01dfcc0ff8452c9e$export$2385a24977818dd0, (v) => $01dfcc0ff8452c9e$export$2385a24977818dd0 = v);
$parcel$export(module.exports, "objCreate", () => $01dfcc0ff8452c9e$export$c09f2411a4ae511b, (v) => $01dfcc0ff8452c9e$export$c09f2411a4ae511b = v);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ // Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
var $01dfcc0ff8452c9e$export$2385a24977818dd0;
var $01dfcc0ff8452c9e$export$fdab3c20aae16ddf;
var $01dfcc0ff8452c9e$export$c09f2411a4ae511b;
"use strict";
var $01dfcc0ff8452c9e$var$bind = Function.prototype.bind || function(oThis) {
    if (typeof this !== 'function') // closest thing possible to the ECMAScript 5
    // internal IsCallable function
    throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    var aArgs = Array.prototype.slice.call(arguments, 1), fToBind = this, fNOP = function() {}, fBound = function() {
        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
    };
    if (this.prototype) // native functions don't have a prototype
    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();
    return fBound;
};
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var $01dfcc0ff8452c9e$var$hop = Object.prototype.hasOwnProperty;
var $01dfcc0ff8452c9e$var$realDefineProp = function() {
    try {
        return !!Object.defineProperty({}, 'a', {});
    } catch (e) {
        return false;
    }
}();
var $01dfcc0ff8452c9e$var$es3 = !$01dfcc0ff8452c9e$var$realDefineProp && !Object.prototype.__defineGetter__;
var $01dfcc0ff8452c9e$var$defineProperty = $01dfcc0ff8452c9e$var$realDefineProp ? Object.defineProperty : function(obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);
    else if (!$01dfcc0ff8452c9e$var$hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};
var $01dfcc0ff8452c9e$var$objCreate = Object.create || function(proto, props) {
    var obj, k;
    function F() {}
    F.prototype = proto;
    obj = new F();
    for(k in props)if ($01dfcc0ff8452c9e$var$hop.call(props, k)) $01dfcc0ff8452c9e$var$defineProperty(obj, k, props[k]);
    return obj;
};
$01dfcc0ff8452c9e$export$2385a24977818dd0 = $01dfcc0ff8452c9e$var$bind, $01dfcc0ff8452c9e$export$fdab3c20aae16ddf = $01dfcc0ff8452c9e$var$defineProperty, $01dfcc0ff8452c9e$export$c09f2411a4ae511b = $01dfcc0ff8452c9e$var$objCreate;

});




parcelRegister("ai5ZE", function(module, exports) {
$parcel$export(module.exports, "default", () => $77e03bf66b3a3c7e$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $26Yns = parcelRequire("26Yns");

var $cTigd = parcelRequire("cTigd");

var $8P7DW = parcelRequire("8P7DW");

var $81wAJ = parcelRequire("81wAJ");

var $egJfF = parcelRequire("egJfF");

var $l4a5B = parcelRequire("l4a5B");
function $77e03bf66b3a3c7e$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $77e03bf66b3a3c7e$var$IntlProvider = /** @class */ function(_super) {
    (0, $26Yns.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $cTigd.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $egJfF.createIntl)($77e03bf66b3a3c7e$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $77e03bf66b3a3c7e$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $77e03bf66b3a3c7e$var$processIntlConfig(props);
        if (!(0, $81wAJ.shallowEqual)(prevConfig, config)) return {
            intl: (0, $egJfF.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $81wAJ.invariantIntlContext)(this.state.intl);
        return $8P7DW.createElement((0, $l4a5B.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $81wAJ.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($8P7DW.PureComponent);
var $77e03bf66b3a3c7e$export$2e2bcd8739ae039 = $77e03bf66b3a3c7e$var$IntlProvider;

});
parcelRegister("cTigd", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $9628c9457567e211$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $9628c9457567e211$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $9628c9457567e211$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $9628c9457567e211$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $9628c9457567e211$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $9628c9457567e211$export$4ee1db8ce44a209b);

var $26Yns = parcelRequire("26Yns");

var $9Urfj = parcelRequire("9Urfj");
parcelRequire("1aeM9");
var $2Q5N6 = parcelRequire("2Q5N6");

var $cn8SS = parcelRequire("cn8SS");
function $9628c9457567e211$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $9628c9457567e211$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $9628c9457567e211$var$defaultErrorHandler = function(error) {};
var $9628c9457567e211$var$defaultWarnHandler = function(warning) {};
var $9628c9457567e211$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $9628c9457567e211$var$defaultErrorHandler,
    onWarn: $9628c9457567e211$var$defaultWarnHandler
};
function $9628c9457567e211$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $9628c9457567e211$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $9628c9457567e211$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $9628c9457567e211$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $9Urfj.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $9628c9457567e211$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $9Urfj.strategies).variadic
    });
    var getNumberFormat = (0, $9Urfj.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $9628c9457567e211$var$createFastMemoizeCache(cache.number),
        strategy: (0, $9Urfj.strategies).variadic
    });
    var getPluralRules = (0, $9Urfj.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $26Yns.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $9628c9457567e211$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $9Urfj.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $9Urfj.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $2Q5N6.IntlMessageFormat)(message, locales, overrideFormats, (0, $26Yns.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $9628c9457567e211$var$createFastMemoizeCache(cache.message),
            strategy: (0, $9Urfj.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $9Urfj.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9628c9457567e211$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $9Urfj.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $9Urfj.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9628c9457567e211$var$createFastMemoizeCache(cache.list),
            strategy: (0, $9Urfj.strategies).variadic
        }),
        getDisplayNames: (0, $9Urfj.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9628c9457567e211$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $9Urfj.strategies).variadic
        })
    };
}
function $9628c9457567e211$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $cn8SS.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("9Urfj", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $736e7a7e403069c2$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $736e7a7e403069c2$export$c5491a8691a23b9e);
//
// Main
//
function $736e7a7e403069c2$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $736e7a7e403069c2$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $736e7a7e403069c2$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $736e7a7e403069c2$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $736e7a7e403069c2$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $736e7a7e403069c2$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $736e7a7e403069c2$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $736e7a7e403069c2$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $736e7a7e403069c2$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $736e7a7e403069c2$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $736e7a7e403069c2$var$monadic : $736e7a7e403069c2$var$variadic;
    return $736e7a7e403069c2$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $736e7a7e403069c2$var$strategyVariadic(fn, options) {
    return $736e7a7e403069c2$var$assemble(fn, this, $736e7a7e403069c2$var$variadic, options.cache.create(), options.serializer);
}
function $736e7a7e403069c2$var$strategyMonadic(fn, options) {
    return $736e7a7e403069c2$var$assemble(fn, this, $736e7a7e403069c2$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $736e7a7e403069c2$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $736e7a7e403069c2$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $736e7a7e403069c2$var$cacheDefault = {
    create: function create() {
        return new $736e7a7e403069c2$var$ObjectWithoutPrototypeCache();
    }
};
var $736e7a7e403069c2$export$c5491a8691a23b9e = {
    variadic: $736e7a7e403069c2$var$strategyVariadic,
    monadic: $736e7a7e403069c2$var$strategyMonadic
};

});

parcelRegister("1aeM9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("iyNl7")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("iyNl7")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("bqFwU")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("2Q5N6")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $2Q5N6 = parcelRequire("2Q5N6");
parcelRequire("iyNl7");
parcelRequire("bqFwU");
var $0d922fbc494d6bfe$export$2e2bcd8739ae039 = (0, $2Q5N6.IntlMessageFormat);

});
parcelRegister("2Q5N6", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $2114ee0f696de201$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $26Yns = parcelRequire("26Yns");

var $9Urfj = parcelRequire("9Urfj");

var $v8eBL = parcelRequire("v8eBL");

var $bqFwU = parcelRequire("bqFwU");
// -- MessageFormat --------------------------------------------------------
function $2114ee0f696de201$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $2114ee0f696de201$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $2114ee0f696de201$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $26Yns.__assign)({}, defaultConfig));
}
function $2114ee0f696de201$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $2114ee0f696de201$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $9Urfj.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $2114ee0f696de201$var$createFastMemoizeCache(cache.number),
            strategy: (0, $9Urfj.strategies).variadic
        }),
        getDateTimeFormat: (0, $9Urfj.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $2114ee0f696de201$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $9Urfj.strategies).variadic
        }),
        getPluralRules: (0, $9Urfj.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $2114ee0f696de201$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $9Urfj.strategies).variadic
        })
    };
}
var $2114ee0f696de201$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $bqFwU.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $bqFwU.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $26Yns.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $26Yns.__assign)((0, $26Yns.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $2114ee0f696de201$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $2114ee0f696de201$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $v8eBL.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("v8eBL", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("1QVGK")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("1QVGK")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("1QVGK")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("1QVGK")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("1QVGK")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("1QVGK")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("1QVGK")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("1QVGK")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("1QVGK")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("1QVGK")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("1QVGK")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("1QVGK")).TYPE);
$parcel$export(module.exports, "parse", () => $05d948967d5c746a$export$98e6a39c04603d36);

var $26Yns = parcelRequire("26Yns");

var $jvqqU = parcelRequire("jvqqU");

var $lTwQF = parcelRequire("lTwQF");

var $1QVGK = parcelRequire("1QVGK");

var $cDTS4 = parcelRequire("cDTS4");
function $05d948967d5c746a$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $1QVGK.isSelectElement)(el) || (0, $1QVGK.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $05d948967d5c746a$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $1QVGK.isNumberElement)(el) && (0, $1QVGK.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $1QVGK.isDateElement)(el) || (0, $1QVGK.isTimeElement)(el)) && (0, $1QVGK.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $1QVGK.isTagElement)(el)) $05d948967d5c746a$var$pruneLocation(el.children);
    });
}
function $05d948967d5c746a$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $26Yns.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $lTwQF.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $jvqqU.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $05d948967d5c746a$var$pruneLocation(result.val);
    return result.val;
}
var $05d948967d5c746a$export$d3c1bfa0f7d806e9 = (0, $lTwQF.Parser);

});
parcelRegister("jvqqU", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $e3356a9efc0c4255$export$896afd8541959ee5);
var $e3356a9efc0c4255$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($e3356a9efc0c4255$export$896afd8541959ee5 || ($e3356a9efc0c4255$export$896afd8541959ee5 = {}));

});

parcelRegister("lTwQF", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $ff0837099cadc7cf$export$7acfa6ed01010e37);

var $26Yns = parcelRequire("26Yns");

var $jvqqU = parcelRequire("jvqqU");

var $1QVGK = parcelRequire("1QVGK");

var $5yTqi = parcelRequire("5yTqi");
parcelRequire("ixjbU");
var $72UbE = parcelRequire("72UbE");
var $ex3Ow = parcelRequire("ex3Ow");

var $aIKWg = parcelRequire("aIKWg");
var $ff0837099cadc7cf$var$_a;
var $ff0837099cadc7cf$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $5yTqi.SPACE_SEPARATOR_REGEX).source, "*"));
var $ff0837099cadc7cf$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $5yTqi.SPACE_SEPARATOR_REGEX).source, "*$"));
function $ff0837099cadc7cf$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $ff0837099cadc7cf$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $ff0837099cadc7cf$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $ff0837099cadc7cf$var$hasNativeFromEntries = !!Object.fromEntries;
var $ff0837099cadc7cf$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $ff0837099cadc7cf$var$hasTrimStart = !!String.prototype.trimStart;
var $ff0837099cadc7cf$var$hasTrimEnd = !!String.prototype.trimEnd;
var $ff0837099cadc7cf$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $ff0837099cadc7cf$var$isSafeInteger = $ff0837099cadc7cf$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $ff0837099cadc7cf$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $ff0837099cadc7cf$var$re = $ff0837099cadc7cf$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $ff0837099cadc7cf$var$REGEX_SUPPORTS_U_AND_Y = (($ff0837099cadc7cf$var$_a = $ff0837099cadc7cf$var$re.exec('a')) === null || $ff0837099cadc7cf$var$_a === void 0 ? void 0 : $ff0837099cadc7cf$var$_a[0]) === 'a';
} catch (_) {
    $ff0837099cadc7cf$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $ff0837099cadc7cf$var$startsWith = $ff0837099cadc7cf$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $ff0837099cadc7cf$var$fromCodePoint = $ff0837099cadc7cf$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $ff0837099cadc7cf$var$fromEntries = // native
$ff0837099cadc7cf$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $ff0837099cadc7cf$var$codePointAt = $ff0837099cadc7cf$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $ff0837099cadc7cf$var$trimStart = $ff0837099cadc7cf$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($ff0837099cadc7cf$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $ff0837099cadc7cf$var$trimEnd = $ff0837099cadc7cf$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($ff0837099cadc7cf$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $ff0837099cadc7cf$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $ff0837099cadc7cf$var$matchIdentifierAtIndex;
if ($ff0837099cadc7cf$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $ff0837099cadc7cf$var$IDENTIFIER_PREFIX_RE_1 = $ff0837099cadc7cf$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $ff0837099cadc7cf$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $ff0837099cadc7cf$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $ff0837099cadc7cf$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$ff0837099cadc7cf$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $ff0837099cadc7cf$var$codePointAt(s, index);
        if (c === undefined || $ff0837099cadc7cf$var$_isWhiteSpace(c) || $ff0837099cadc7cf$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $ff0837099cadc7cf$var$fromCodePoint.apply(void 0, match);
};
var $ff0837099cadc7cf$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $1QVGK.TYPE).pound,
                    location: $ff0837099cadc7cf$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $jvqqU.ErrorKind).UNMATCHED_CLOSING_TAG, $ff0837099cadc7cf$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $ff0837099cadc7cf$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $1QVGK.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $ff0837099cadc7cf$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$ff0837099cadc7cf$var$_isAlpha(this.char())) return this.error((0, $jvqqU.ErrorKind).INVALID_TAG, $ff0837099cadc7cf$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $jvqqU.ErrorKind).UNMATCHED_CLOSING_TAG, $ff0837099cadc7cf$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $jvqqU.ErrorKind).INVALID_TAG, $ff0837099cadc7cf$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $1QVGK.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $ff0837099cadc7cf$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $jvqqU.ErrorKind).UNCLOSED_TAG, $ff0837099cadc7cf$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $jvqqU.ErrorKind).INVALID_TAG, $ff0837099cadc7cf$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $ff0837099cadc7cf$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $ff0837099cadc7cf$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $1QVGK.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$ff0837099cadc7cf$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $ff0837099cadc7cf$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $ff0837099cadc7cf$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $jvqqU.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $jvqqU.ErrorKind).EMPTY_ARGUMENT, $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $jvqqU.ErrorKind).MALFORMED_ARGUMENT, $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $jvqqU.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $1QVGK.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $jvqqU.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $jvqqU.ErrorKind).MALFORMED_ARGUMENT, $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $ff0837099cadc7cf$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $ff0837099cadc7cf$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $jvqqU.ErrorKind).EXPECT_ARGUMENT_TYPE, $ff0837099cadc7cf$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $ff0837099cadc7cf$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $jvqqU.ErrorKind).EXPECT_ARGUMENT_STYLE, $ff0837099cadc7cf$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $ff0837099cadc7cf$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $ff0837099cadc7cf$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $ff0837099cadc7cf$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $1QVGK.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $jvqqU.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $aIKWg.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $1QVGK.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $72UbE.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $1QVGK.TYPE).date : (0, $1QVGK.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $1QVGK.TYPE).number : argType === 'date' ? (0, $1QVGK.TYPE).date : (0, $1QVGK.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $jvqqU.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $ff0837099cadc7cf$var$createLocation(typeEndPosition_1, (0, $26Yns.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $jvqqU.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $ff0837099cadc7cf$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $jvqqU.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $jvqqU.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $1QVGK.TYPE).select,
                        value: value,
                        options: $ff0837099cadc7cf$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $1QVGK.TYPE).plural,
                        value: value,
                        options: $ff0837099cadc7cf$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $jvqqU.ErrorKind).INVALID_ARGUMENT_TYPE, $ff0837099cadc7cf$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $jvqqU.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $jvqqU.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $ff0837099cadc7cf$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $ex3Ow.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $jvqqU.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $1QVGK.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $ex3Ow.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $jvqqU.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $jvqqU.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $ff0837099cadc7cf$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $jvqqU.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $jvqqU.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $jvqqU.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $jvqqU.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $ff0837099cadc7cf$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $ff0837099cadc7cf$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $jvqqU.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $jvqqU.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $ff0837099cadc7cf$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $jvqqU.ErrorKind).MISSING_OTHER_CLAUSE, $ff0837099cadc7cf$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $ff0837099cadc7cf$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$ff0837099cadc7cf$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $ff0837099cadc7cf$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($ff0837099cadc7cf$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $ff0837099cadc7cf$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $ff0837099cadc7cf$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $ff0837099cadc7cf$var$_isAlphaOrSlash(codepoint) {
    return $ff0837099cadc7cf$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $ff0837099cadc7cf$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $ff0837099cadc7cf$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $ff0837099cadc7cf$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("1QVGK", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $15976586a93c4427$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $15976586a93c4427$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $15976586a93c4427$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $15976586a93c4427$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $15976586a93c4427$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $15976586a93c4427$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $15976586a93c4427$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $15976586a93c4427$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $15976586a93c4427$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $15976586a93c4427$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $15976586a93c4427$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $15976586a93c4427$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $15976586a93c4427$export$7680c41f1a55f4cf);
var $15976586a93c4427$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($15976586a93c4427$export$b87f371cbc396fcf || ($15976586a93c4427$export$b87f371cbc396fcf = {}));
var $15976586a93c4427$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($15976586a93c4427$export$906452485466fa53 || ($15976586a93c4427$export$906452485466fa53 = {}));
function $15976586a93c4427$export$cfa10c5697238752(el) {
    return el.type === $15976586a93c4427$export$b87f371cbc396fcf.literal;
}
function $15976586a93c4427$export$4f55724281bdfaf9(el) {
    return el.type === $15976586a93c4427$export$b87f371cbc396fcf.argument;
}
function $15976586a93c4427$export$e11187b219e191e1(el) {
    return el.type === $15976586a93c4427$export$b87f371cbc396fcf.number;
}
function $15976586a93c4427$export$32d811605da75f40(el) {
    return el.type === $15976586a93c4427$export$b87f371cbc396fcf.date;
}
function $15976586a93c4427$export$34ec46f596b1702f(el) {
    return el.type === $15976586a93c4427$export$b87f371cbc396fcf.time;
}
function $15976586a93c4427$export$dcfe1c11d168b5a1(el) {
    return el.type === $15976586a93c4427$export$b87f371cbc396fcf.select;
}
function $15976586a93c4427$export$6c796d116f0a4fbc(el) {
    return el.type === $15976586a93c4427$export$b87f371cbc396fcf.plural;
}
function $15976586a93c4427$export$c0ece297bdd0c082(el) {
    return el.type === $15976586a93c4427$export$b87f371cbc396fcf.pound;
}
function $15976586a93c4427$export$5c83de34745812b(el) {
    return el.type === $15976586a93c4427$export$b87f371cbc396fcf.tag;
}
function $15976586a93c4427$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $15976586a93c4427$export$906452485466fa53.number);
}
function $15976586a93c4427$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $15976586a93c4427$export$906452485466fa53.dateTime);
}
function $15976586a93c4427$export$f0ac572c1121c662(value) {
    return {
        type: $15976586a93c4427$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $15976586a93c4427$export$425e864b0ba114f1(value, style) {
    return {
        type: $15976586a93c4427$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("5yTqi", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $40cb1e9ccd20eb8d$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $40cb1e9ccd20eb8d$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $40cb1e9ccd20eb8d$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("ixjbU", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("72UbE")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("ex3Ow")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("ex3Ow")).parseNumberSkeletonFromString);
parcelRequire("72UbE");
parcelRequire("ex3Ow");

});
parcelRegister("72UbE", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $52144de004389338$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $52144de004389338$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $52144de004389338$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($52144de004389338$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("ex3Ow", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $a9471b177506a5a3$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $a9471b177506a5a3$export$47c6f8480bda3e11);

var $26Yns = parcelRequire("26Yns");

var $4ivXp = parcelRequire("4ivXp");
function $a9471b177506a5a3$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $4ivXp.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $a9471b177506a5a3$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $a9471b177506a5a3$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $a9471b177506a5a3$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $a9471b177506a5a3$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $a9471b177506a5a3$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $a9471b177506a5a3$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($a9471b177506a5a3$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $a9471b177506a5a3$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $a9471b177506a5a3$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$a9471b177506a5a3$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $a9471b177506a5a3$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $a9471b177506a5a3$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $a9471b177506a5a3$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $a9471b177506a5a3$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, all), $a9471b177506a5a3$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, all), $a9471b177506a5a3$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($a9471b177506a5a3$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($a9471b177506a5a3$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($a9471b177506a5a3$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($a9471b177506a5a3$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), $a9471b177506a5a3$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($a9471b177506a5a3$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), $a9471b177506a5a3$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $a9471b177506a5a3$var$parseSign(token.stem);
        if (signOpts) result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $a9471b177506a5a3$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("4ivXp", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $3211a1e97b689b8d$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $3211a1e97b689b8d$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("aIKWg", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $7ce26c7e65de06e5$export$29c5368be8904d27);

var $kMV51 = parcelRequire("kMV51");
function $7ce26c7e65de06e5$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $7ce26c7e65de06e5$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $7ce26c7e65de06e5$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $kMV51.timeData)[regionTag || ''] || (0, $kMV51.timeData)[languageTag || ''] || (0, $kMV51.timeData)["".concat(languageTag, "-001")] || (0, $kMV51.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("kMV51", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $f2249142e8ada4e7$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $f2249142e8ada4e7$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("cDTS4", function(module, exports) {

var $26Yns = parcelRequire("26Yns");

var $1QVGK = parcelRequire("1QVGK");
function $934477635ef7e97f$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $26Yns.__spreadArray)([], obj.map($934477635ef7e97f$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $934477635ef7e97f$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $934477635ef7e97f$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $934477635ef7e97f$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $934477635ef7e97f$export$be5687ba8bbdf416((0, $26Yns.__spreadArray)((0, $26Yns.__spreadArray)((0, $26Yns.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $934477635ef7e97f$var$isPluralOrSelectElement(el) {
    return (0, $1QVGK.isPluralElement)(el) || (0, $1QVGK.isSelectElement)(el);
}
function $934477635ef7e97f$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($934477635ef7e97f$var$isPluralOrSelectElement(el)) return true;
        if ((0, $1QVGK.isTagElement)(el)) return $934477635ef7e97f$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $934477635ef7e97f$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($934477635ef7e97f$var$isPluralOrSelectElement(el)) return [
            $934477635ef7e97f$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $1QVGK.isTagElement)(el) && $934477635ef7e97f$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $934477635ef7e97f$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $1QVGK.isArgumentElement)(el) || (0, $1QVGK.isDateElement)(el) || (0, $1QVGK.isTimeElement)(el) || (0, $1QVGK.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $1QVGK.isPluralElement)(el) || (0, $1QVGK.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $934477635ef7e97f$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $1QVGK.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $934477635ef7e97f$var$collectVariables(el.children, vars);
        }
    });
}
function $934477635ef7e97f$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $934477635ef7e97f$var$collectVariables(a, aVars);
    $934477635ef7e97f$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $1QVGK.TYPE)[type], " vs ").concat((0, $1QVGK.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("bqFwU", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $852256639e47248d$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $852256639e47248d$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $852256639e47248d$export$275d4a3bb5f66fda);
parcelRequire("v8eBL");
var $1QVGK = parcelRequire("1QVGK");

var $iyNl7 = parcelRequire("iyNl7");
var $852256639e47248d$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($852256639e47248d$export$49694c2877b44c57 || ($852256639e47248d$export$49694c2877b44c57 = {}));
function $852256639e47248d$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $852256639e47248d$export$49694c2877b44c57.literal || part.type !== $852256639e47248d$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $852256639e47248d$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $852256639e47248d$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $1QVGK.isLiteralElement)(els[0])) return [
        {
            type: $852256639e47248d$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $1QVGK.isLiteralElement)(el)) {
            result.push({
                type: $852256639e47248d$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $1QVGK.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $852256639e47248d$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $iyNl7.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $1QVGK.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $852256639e47248d$export$49694c2877b44c57.literal : $852256639e47248d$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $1QVGK.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $1QVGK.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $852256639e47248d$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $1QVGK.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $1QVGK.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $852256639e47248d$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $1QVGK.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $1QVGK.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $852256639e47248d$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $1QVGK.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$852256639e47248d$export$df0c12a2d414a163(formatFn)) throw new (0, $iyNl7.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $852256639e47248d$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $852256639e47248d$export$49694c2877b44c57.literal : $852256639e47248d$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $1QVGK.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $iyNl7.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $852256639e47248d$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $1QVGK.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $iyNl7.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $iyNl7.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $iyNl7.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $852256639e47248d$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $852256639e47248d$var$mergeLiteral(result);
}

});
parcelRegister("iyNl7", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $d831acce2e160192$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $d831acce2e160192$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $d831acce2e160192$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $d831acce2e160192$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $d831acce2e160192$export$8bfc137e4d23fdf0);

var $26Yns = parcelRequire("26Yns");
var $d831acce2e160192$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($d831acce2e160192$export$d4e71bc0b80dc0fb || ($d831acce2e160192$export$d4e71bc0b80dc0fb = {}));
var $d831acce2e160192$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $d831acce2e160192$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $d831acce2e160192$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($d831acce2e160192$export$7369836851cc1329);
var $d831acce2e160192$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $d831acce2e160192$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($d831acce2e160192$export$7369836851cc1329);
var $d831acce2e160192$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $d831acce2e160192$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($d831acce2e160192$export$7369836851cc1329);

});




parcelRegister("cn8SS", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $901e863885b79144$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $901e863885b79144$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $901e863885b79144$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $901e863885b79144$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $901e863885b79144$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $901e863885b79144$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $901e863885b79144$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $901e863885b79144$export$2ddcb436d0aa3688);

var $26Yns = parcelRequire("26Yns");
var $901e863885b79144$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($901e863885b79144$export$557d6acb76e8a244 || ($901e863885b79144$export$557d6acb76e8a244 = {}));
var $901e863885b79144$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $901e863885b79144$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $901e863885b79144$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($901e863885b79144$export$c016d36112f6ddf8);
var $901e863885b79144$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $901e863885b79144$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($901e863885b79144$export$c016d36112f6ddf8);
var $901e863885b79144$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $901e863885b79144$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($901e863885b79144$export$c016d36112f6ddf8);
var $901e863885b79144$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $901e863885b79144$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($901e863885b79144$export$c016d36112f6ddf8);
var $901e863885b79144$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($901e863885b79144$export$e3b7eee1dbc44895);
var $901e863885b79144$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $901e863885b79144$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($901e863885b79144$export$c016d36112f6ddf8);

});


parcelRegister("81wAJ", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $5d77b2aec735e299$export$f5708dca728d7177);
$parcel$export(module.exports, "invariantIntlContext", () => $5d77b2aec735e299$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $5d77b2aec735e299$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "toKeyedReactNodeArray", () => $5d77b2aec735e299$export$d2fd241e0b53c057);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $5d77b2aec735e299$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $5d77b2aec735e299$export$d36bdfa510afb180);

var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $cTigd = parcelRequire("cTigd");
function $5d77b2aec735e299$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $5d77b2aec735e299$export$45c4bbf6e55bba1f(intl) {
    $5d77b2aec735e299$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $5d77b2aec735e299$export$b52f8d6fc0d47415 = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, (0, $cTigd.DEFAULT_INTL_CONFIG)), {
    textComponent: $8P7DW.Fragment
});
var $5d77b2aec735e299$var$toKeyedReactNode = function(reactNode, key) {
    return $8P7DW.isValidElement(reactNode) ? $8P7DW.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $5d77b2aec735e299$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $8P7DW.Children.map(children, $5d77b2aec735e299$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $5d77b2aec735e299$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($5d77b2aec735e299$export$d2fd241e0b53c057(parts));
    };
}
function $5d77b2aec735e299$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});

parcelRegister("egJfF", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $a635a959ae269e79$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $26Yns = parcelRequire("26Yns");

var $guQi6 = parcelRequire("guQi6");
var $79V2R = parcelRequire("79V2R");

var $bqFwU = parcelRequire("bqFwU");

var $81wAJ = parcelRequire("81wAJ");
function $a635a959ae269e79$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $bqFwU.isFormatXMLElementFn)(v) ? (0, $81wAJ.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $a635a959ae269e79$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $a635a959ae269e79$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $79V2R.formatMessage).apply(void 0, (0, $26Yns.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $81wAJ.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $a635a959ae269e79$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $26Yns.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $a635a959ae269e79$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $guQi6.createIntl)((0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, (0, $81wAJ.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, coreIntl), {
        formatMessage: $a635a959ae269e79$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $a635a959ae269e79$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("guQi6", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $c02802902fa1a511$export$7e4cbedfdd7b4c0d);

var $26Yns = parcelRequire("26Yns");

var $hkNTN = parcelRequire("hkNTN");

var $ghtEs = parcelRequire("ghtEs");

var $cn8SS = parcelRequire("cn8SS");

var $fkdY8 = parcelRequire("fkdY8");

var $79V2R = parcelRequire("79V2R");

var $8WYpv = parcelRequire("8WYpv");

var $7hOFR = parcelRequire("7hOFR");

var $kgtKn = parcelRequire("kgtKn");

var $cTigd = parcelRequire("cTigd");
function $c02802902fa1a511$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $c02802902fa1a511$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $c02802902fa1a511$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $c02802902fa1a511$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $cTigd.createFormatters)(cache);
    var resolvedConfig = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, (0, $cTigd.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $cn8SS.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $cn8SS.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $cn8SS.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $c02802902fa1a511$var$verifyConfigMessages(resolvedConfig);
    return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $8WYpv.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $8WYpv.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $kgtKn.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $hkNTN.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $hkNTN.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $hkNTN.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $hkNTN.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $hkNTN.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $7hOFR.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $79V2R.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $79V2R.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $fkdY8.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $fkdY8.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $ghtEs.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("hkNTN", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $c9eb02caecc55a58$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $c9eb02caecc55a58$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $c9eb02caecc55a58$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $c9eb02caecc55a58$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $c9eb02caecc55a58$export$af6e5d7a5c73edeb);

var $26Yns = parcelRequire("26Yns");

var $cn8SS = parcelRequire("cn8SS");

var $cTigd = parcelRequire("cTigd");
var $c9eb02caecc55a58$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $c9eb02caecc55a58$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $cTigd.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $cTigd.filterProps)(options, $c9eb02caecc55a58$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $c9eb02caecc55a58$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $c9eb02caecc55a58$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $cn8SS.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $c9eb02caecc55a58$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $c9eb02caecc55a58$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $cn8SS.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $c9eb02caecc55a58$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $c9eb02caecc55a58$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $cn8SS.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $c9eb02caecc55a58$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $c9eb02caecc55a58$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $cn8SS.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $c9eb02caecc55a58$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $c9eb02caecc55a58$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $cn8SS.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("ghtEs", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $bda53c0dbc962d1f$export$62fe1a4d9e891fa2);

var $cTigd = parcelRequire("cTigd");

var $iyNl7 = parcelRequire("iyNl7");

var $cn8SS = parcelRequire("cn8SS");
var $bda53c0dbc962d1f$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $bda53c0dbc962d1f$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $iyNl7.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $iyNl7.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $cTigd.filterProps)(options, $bda53c0dbc962d1f$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $cn8SS.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("fkdY8", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $b2838f3a29bfc456$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $b2838f3a29bfc456$export$6f284aad1934db69);

var $26Yns = parcelRequire("26Yns");

var $iyNl7 = parcelRequire("iyNl7");

var $cn8SS = parcelRequire("cn8SS");

var $cTigd = parcelRequire("cTigd");
var $b2838f3a29bfc456$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $b2838f3a29bfc456$var$now = Date.now();
function $b2838f3a29bfc456$var$generateToken(i) {
    return "".concat($b2838f3a29bfc456$var$now, "_").concat(i, "_").concat($b2838f3a29bfc456$var$now);
}
function $b2838f3a29bfc456$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $b2838f3a29bfc456$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $b2838f3a29bfc456$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $iyNl7.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $iyNl7.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $cTigd.filterProps)(options, $b2838f3a29bfc456$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $b2838f3a29bfc456$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $26Yns.__assign)((0, $26Yns.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $cn8SS.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("79V2R", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $53659fab0fed25c2$export$25868d1e8e76735f);

var $26Yns = parcelRequire("26Yns");
parcelRequire("v8eBL");
var $1QVGK = parcelRequire("1QVGK");
parcelRequire("1aeM9");
var $2Q5N6 = parcelRequire("2Q5N6");

var $cn8SS = parcelRequire("cn8SS");

var $cTigd = parcelRequire("cTigd");
function $53659fab0fed25c2$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $26Yns.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $53659fab0fed25c2$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $26Yns.__assign)((0, $26Yns.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $53659fab0fed25c2$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $2Q5N6.IntlMessageFormat).formats;
    return (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, mfFormats), f1), {
        date: $53659fab0fed25c2$var$deepMergeOptions($53659fab0fed25c2$var$setTimeZoneInOptions(mfFormats.date, timeZone), $53659fab0fed25c2$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $53659fab0fed25c2$var$deepMergeOptions($53659fab0fed25c2$var$setTimeZoneInOptions(mfFormats.time, timeZone), $53659fab0fed25c2$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $53659fab0fed25c2$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $cTigd.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $1QVGK.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, defaultRichTextElements), values || {});
    formats = $53659fab0fed25c2$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $53659fab0fed25c2$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $cn8SS.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $cn8SS.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $26Yns.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $cn8SS.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $cn8SS.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("8WYpv", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $684299bd365de99d$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $684299bd365de99d$export$6871080848f10b2f);

var $cn8SS = parcelRequire("cn8SS");

var $cTigd = parcelRequire("cTigd");
var $684299bd365de99d$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $684299bd365de99d$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $cTigd.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $cTigd.filterProps)(options, $684299bd365de99d$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $684299bd365de99d$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $684299bd365de99d$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $cn8SS.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $684299bd365de99d$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $684299bd365de99d$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $cn8SS.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("7hOFR", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $54e16dc104fa3f0d$export$bbbd05c900f3568d);

var $iyNl7 = parcelRequire("iyNl7");

var $cn8SS = parcelRequire("cn8SS");

var $cTigd = parcelRequire("cTigd");
var $54e16dc104fa3f0d$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $54e16dc104fa3f0d$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $iyNl7.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $iyNl7.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $cTigd.filterProps)(options, $54e16dc104fa3f0d$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $cn8SS.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("kgtKn", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $ec0c60631c33e83b$export$b4ea3b48dcf921f6);

var $cTigd = parcelRequire("cTigd");

var $iyNl7 = parcelRequire("iyNl7");

var $cn8SS = parcelRequire("cn8SS");
var $ec0c60631c33e83b$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $ec0c60631c33e83b$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $cTigd.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $cTigd.filterProps)(options, $ec0c60631c33e83b$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $ec0c60631c33e83b$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $iyNl7.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $iyNl7.ErrorCode).MISSING_INTL_API));
    try {
        return $ec0c60631c33e83b$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $cn8SS.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});



parcelRegister("l4a5B", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $f561cc36aaec2d45$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $f561cc36aaec2d45$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $f561cc36aaec2d45$export$2e2bcd8739ae039);

var $26Yns = parcelRequire("26Yns");

var $fG5y9 = parcelRequire("fG5y9");

var $8P7DW = parcelRequire("8P7DW");

var $81wAJ = parcelRequire("81wAJ");
function $f561cc36aaec2d45$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $f561cc36aaec2d45$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $8P7DW.createContext(null)) : $8P7DW.createContext(null);
var $f561cc36aaec2d45$var$IntlConsumer = $f561cc36aaec2d45$var$IntlContext.Consumer, $f561cc36aaec2d45$var$IntlProvider = $f561cc36aaec2d45$var$IntlContext.Provider;
var $f561cc36aaec2d45$export$2881499e37b75b9a = $f561cc36aaec2d45$var$IntlProvider;
var $f561cc36aaec2d45$export$841858b892ce1f4c = $f561cc36aaec2d45$var$IntlContext;
function $f561cc36aaec2d45$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $8P7DW.createElement($f561cc36aaec2d45$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $81wAJ.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $8P7DW.createElement(WrappedComponent, (0, $26Yns.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($f561cc36aaec2d45$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($fG5y9)))(// @ts-expect-error
    $8P7DW.forwardRef(function(props, ref) {
        return $8P7DW.createElement(WithIntl, (0, $26Yns.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fG5y9)))(WithIntl, WrappedComponent);
}

});
parcelRegister("fG5y9", function(module, exports) {
'use strict';

var $3a2df = parcelRequire("3a2df");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $b69f1555d4637d8d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $b69f1555d4637d8d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $b69f1555d4637d8d$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $b69f1555d4637d8d$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $b69f1555d4637d8d$var$TYPE_STATICS = {};
$b69f1555d4637d8d$var$TYPE_STATICS[$3a2df.ForwardRef] = $b69f1555d4637d8d$var$FORWARD_REF_STATICS;
$b69f1555d4637d8d$var$TYPE_STATICS[$3a2df.Memo] = $b69f1555d4637d8d$var$MEMO_STATICS;
function $b69f1555d4637d8d$var$getStatics(component) {
    // React v16.11 and below
    if ($3a2df.isMemo(component)) return $b69f1555d4637d8d$var$MEMO_STATICS;
     // React v16.12 and above
    return $b69f1555d4637d8d$var$TYPE_STATICS[component['$$typeof']] || $b69f1555d4637d8d$var$REACT_STATICS;
}
var $b69f1555d4637d8d$var$defineProperty = Object.defineProperty;
var $b69f1555d4637d8d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $b69f1555d4637d8d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b69f1555d4637d8d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $b69f1555d4637d8d$var$getPrototypeOf = Object.getPrototypeOf;
var $b69f1555d4637d8d$var$objectPrototype = Object.prototype;
function $b69f1555d4637d8d$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($b69f1555d4637d8d$var$objectPrototype) {
            var inheritedComponent = $b69f1555d4637d8d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $b69f1555d4637d8d$var$objectPrototype) $b69f1555d4637d8d$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $b69f1555d4637d8d$var$getOwnPropertyNames(sourceComponent);
        if ($b69f1555d4637d8d$var$getOwnPropertySymbols) keys = keys.concat($b69f1555d4637d8d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $b69f1555d4637d8d$var$getStatics(targetComponent);
        var sourceStatics = $b69f1555d4637d8d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$b69f1555d4637d8d$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $b69f1555d4637d8d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $b69f1555d4637d8d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $b69f1555d4637d8d$var$hoistNonReactStatics;

});
parcelRegister("3a2df", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a5fdh"));

});
parcelRegister("a5fdh", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $75762c077f7c5b2c$export$2b8d127b894957b9, (v) => $75762c077f7c5b2c$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $75762c077f7c5b2c$export$cea3a54a6425200c, (v) => $75762c077f7c5b2c$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $75762c077f7c5b2c$export$a7c73072b1a182ae, (v) => $75762c077f7c5b2c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $75762c077f7c5b2c$export$9f27bc3417b4524d, (v) => $75762c077f7c5b2c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $75762c077f7c5b2c$export$db77ccec0bb4ccac, (v) => $75762c077f7c5b2c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $75762c077f7c5b2c$export$8392c0c9d3dcbd35, (v) => $75762c077f7c5b2c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $75762c077f7c5b2c$export$ffb0004e005737fa, (v) => $75762c077f7c5b2c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $75762c077f7c5b2c$export$b624eff549462981, (v) => $75762c077f7c5b2c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $75762c077f7c5b2c$export$7897aa7841a5380c, (v) => $75762c077f7c5b2c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $75762c077f7c5b2c$export$602eac185826482c, (v) => $75762c077f7c5b2c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $75762c077f7c5b2c$export$e2c29f18771995cb, (v) => $75762c077f7c5b2c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $75762c077f7c5b2c$export$5f8d39834fd61797, (v) => $75762c077f7c5b2c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $75762c077f7c5b2c$export$74bf444e3cd11ea5, (v) => $75762c077f7c5b2c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $75762c077f7c5b2c$export$92387174baf9b227, (v) => $75762c077f7c5b2c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $75762c077f7c5b2c$export$ec112efeb987d9c6, (v) => $75762c077f7c5b2c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $75762c077f7c5b2c$export$b706b080d889d2c9, (v) => $75762c077f7c5b2c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $75762c077f7c5b2c$export$5be5a87408f70ddc, (v) => $75762c077f7c5b2c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $75762c077f7c5b2c$export$45a5e7f76e0caa8d, (v) => $75762c077f7c5b2c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $75762c077f7c5b2c$export$455c2e768291efa6, (v) => $75762c077f7c5b2c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $75762c077f7c5b2c$export$9522e17588c12572, (v) => $75762c077f7c5b2c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $75762c077f7c5b2c$export$2110ac352bb060b9, (v) => $75762c077f7c5b2c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $75762c077f7c5b2c$export$56885ab8b9c456ab, (v) => $75762c077f7c5b2c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $75762c077f7c5b2c$export$d927fcb6adf8f9de, (v) => $75762c077f7c5b2c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $75762c077f7c5b2c$export$b82d16f27459e05a, (v) => $75762c077f7c5b2c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $75762c077f7c5b2c$export$522c17b4f5e123e8, (v) => $75762c077f7c5b2c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $75762c077f7c5b2c$export$1aabd8a0274ecfd6, (v) => $75762c077f7c5b2c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $75762c077f7c5b2c$export$9b621391a187a31a, (v) => $75762c077f7c5b2c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $75762c077f7c5b2c$export$f5bbd400c2f4426f, (v) => $75762c077f7c5b2c$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $75762c077f7c5b2c$export$2b8d127b894957b9;
var $75762c077f7c5b2c$export$cea3a54a6425200c;
var $75762c077f7c5b2c$export$a7c73072b1a182ae;
var $75762c077f7c5b2c$export$9f27bc3417b4524d;
var $75762c077f7c5b2c$export$db77ccec0bb4ccac;
var $75762c077f7c5b2c$export$8392c0c9d3dcbd35;
var $75762c077f7c5b2c$export$ffb0004e005737fa;
var $75762c077f7c5b2c$export$b624eff549462981;
var $75762c077f7c5b2c$export$7897aa7841a5380c;
var $75762c077f7c5b2c$export$602eac185826482c;
var $75762c077f7c5b2c$export$e2c29f18771995cb;
var $75762c077f7c5b2c$export$5f8d39834fd61797;
var $75762c077f7c5b2c$export$74bf444e3cd11ea5;
var $75762c077f7c5b2c$export$92387174baf9b227;
var $75762c077f7c5b2c$export$ec112efeb987d9c6;
var $75762c077f7c5b2c$export$b706b080d889d2c9;
var $75762c077f7c5b2c$export$5be5a87408f70ddc;
var $75762c077f7c5b2c$export$45a5e7f76e0caa8d;
var $75762c077f7c5b2c$export$455c2e768291efa6;
var $75762c077f7c5b2c$export$9522e17588c12572;
var $75762c077f7c5b2c$export$2110ac352bb060b9;
var $75762c077f7c5b2c$export$56885ab8b9c456ab;
var $75762c077f7c5b2c$export$d927fcb6adf8f9de;
var $75762c077f7c5b2c$export$b82d16f27459e05a;
var $75762c077f7c5b2c$export$522c17b4f5e123e8;
var $75762c077f7c5b2c$export$1aabd8a0274ecfd6;
var $75762c077f7c5b2c$export$9b621391a187a31a;
var $75762c077f7c5b2c$export$f5bbd400c2f4426f;
'use strict';
var $75762c077f7c5b2c$var$b = "function" === typeof Symbol && Symbol.for, $75762c077f7c5b2c$var$c = $75762c077f7c5b2c$var$b ? Symbol.for("react.element") : 60103, $75762c077f7c5b2c$var$d = $75762c077f7c5b2c$var$b ? Symbol.for("react.portal") : 60106, $75762c077f7c5b2c$var$e = $75762c077f7c5b2c$var$b ? Symbol.for("react.fragment") : 60107, $75762c077f7c5b2c$var$f = $75762c077f7c5b2c$var$b ? Symbol.for("react.strict_mode") : 60108, $75762c077f7c5b2c$var$g = $75762c077f7c5b2c$var$b ? Symbol.for("react.profiler") : 60114, $75762c077f7c5b2c$var$h = $75762c077f7c5b2c$var$b ? Symbol.for("react.provider") : 60109, $75762c077f7c5b2c$var$k = $75762c077f7c5b2c$var$b ? Symbol.for("react.context") : 60110, $75762c077f7c5b2c$var$l = $75762c077f7c5b2c$var$b ? Symbol.for("react.async_mode") : 60111, $75762c077f7c5b2c$var$m = $75762c077f7c5b2c$var$b ? Symbol.for("react.concurrent_mode") : 60111, $75762c077f7c5b2c$var$n = $75762c077f7c5b2c$var$b ? Symbol.for("react.forward_ref") : 60112, $75762c077f7c5b2c$var$p = $75762c077f7c5b2c$var$b ? Symbol.for("react.suspense") : 60113, $75762c077f7c5b2c$var$q = $75762c077f7c5b2c$var$b ? Symbol.for("react.suspense_list") : 60120, $75762c077f7c5b2c$var$r = $75762c077f7c5b2c$var$b ? Symbol.for("react.memo") : 60115, $75762c077f7c5b2c$var$t = $75762c077f7c5b2c$var$b ? Symbol.for("react.lazy") : 60116, $75762c077f7c5b2c$var$v = $75762c077f7c5b2c$var$b ? Symbol.for("react.block") : 60121, $75762c077f7c5b2c$var$w = $75762c077f7c5b2c$var$b ? Symbol.for("react.fundamental") : 60117, $75762c077f7c5b2c$var$x = $75762c077f7c5b2c$var$b ? Symbol.for("react.responder") : 60118, $75762c077f7c5b2c$var$y = $75762c077f7c5b2c$var$b ? Symbol.for("react.scope") : 60119;
function $75762c077f7c5b2c$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $75762c077f7c5b2c$var$c:
                switch(a = a.type, a){
                    case $75762c077f7c5b2c$var$l:
                    case $75762c077f7c5b2c$var$m:
                    case $75762c077f7c5b2c$var$e:
                    case $75762c077f7c5b2c$var$g:
                    case $75762c077f7c5b2c$var$f:
                    case $75762c077f7c5b2c$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $75762c077f7c5b2c$var$k:
                            case $75762c077f7c5b2c$var$n:
                            case $75762c077f7c5b2c$var$t:
                            case $75762c077f7c5b2c$var$r:
                            case $75762c077f7c5b2c$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $75762c077f7c5b2c$var$d:
                return u;
        }
    }
}
function $75762c077f7c5b2c$var$A(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$m;
}
$75762c077f7c5b2c$export$2b8d127b894957b9 = $75762c077f7c5b2c$var$l;
$75762c077f7c5b2c$export$cea3a54a6425200c = $75762c077f7c5b2c$var$m;
$75762c077f7c5b2c$export$a7c73072b1a182ae = $75762c077f7c5b2c$var$k;
$75762c077f7c5b2c$export$9f27bc3417b4524d = $75762c077f7c5b2c$var$h;
$75762c077f7c5b2c$export$db77ccec0bb4ccac = $75762c077f7c5b2c$var$c;
$75762c077f7c5b2c$export$8392c0c9d3dcbd35 = $75762c077f7c5b2c$var$n;
$75762c077f7c5b2c$export$ffb0004e005737fa = $75762c077f7c5b2c$var$e;
$75762c077f7c5b2c$export$b624eff549462981 = $75762c077f7c5b2c$var$t;
$75762c077f7c5b2c$export$7897aa7841a5380c = $75762c077f7c5b2c$var$r;
$75762c077f7c5b2c$export$602eac185826482c = $75762c077f7c5b2c$var$d;
$75762c077f7c5b2c$export$e2c29f18771995cb = $75762c077f7c5b2c$var$g;
$75762c077f7c5b2c$export$5f8d39834fd61797 = $75762c077f7c5b2c$var$f;
$75762c077f7c5b2c$export$74bf444e3cd11ea5 = $75762c077f7c5b2c$var$p;
$75762c077f7c5b2c$export$92387174baf9b227 = function(a) {
    return $75762c077f7c5b2c$var$A(a) || $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$l;
};
$75762c077f7c5b2c$export$ec112efeb987d9c6 = $75762c077f7c5b2c$var$A;
$75762c077f7c5b2c$export$b706b080d889d2c9 = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$k;
};
$75762c077f7c5b2c$export$5be5a87408f70ddc = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$h;
};
$75762c077f7c5b2c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $75762c077f7c5b2c$var$c;
};
$75762c077f7c5b2c$export$455c2e768291efa6 = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$n;
};
$75762c077f7c5b2c$export$9522e17588c12572 = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$e;
};
$75762c077f7c5b2c$export$2110ac352bb060b9 = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$t;
};
$75762c077f7c5b2c$export$56885ab8b9c456ab = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$r;
};
$75762c077f7c5b2c$export$d927fcb6adf8f9de = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$d;
};
$75762c077f7c5b2c$export$b82d16f27459e05a = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$g;
};
$75762c077f7c5b2c$export$522c17b4f5e123e8 = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$f;
};
$75762c077f7c5b2c$export$1aabd8a0274ecfd6 = function(a) {
    return $75762c077f7c5b2c$var$z(a) === $75762c077f7c5b2c$var$p;
};
$75762c077f7c5b2c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $75762c077f7c5b2c$var$e || a === $75762c077f7c5b2c$var$m || a === $75762c077f7c5b2c$var$g || a === $75762c077f7c5b2c$var$f || a === $75762c077f7c5b2c$var$p || a === $75762c077f7c5b2c$var$q || "object" === typeof a && null !== a && (a.$$typeof === $75762c077f7c5b2c$var$t || a.$$typeof === $75762c077f7c5b2c$var$r || a.$$typeof === $75762c077f7c5b2c$var$h || a.$$typeof === $75762c077f7c5b2c$var$k || a.$$typeof === $75762c077f7c5b2c$var$n || a.$$typeof === $75762c077f7c5b2c$var$w || a.$$typeof === $75762c077f7c5b2c$var$x || a.$$typeof === $75762c077f7c5b2c$var$y || a.$$typeof === $75762c077f7c5b2c$var$v);
};
$75762c077f7c5b2c$export$f5bbd400c2f4426f = $75762c077f7c5b2c$var$z;

});





parcelRegister("ktdLU", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d80ea8f8c9273c3$export$2e2bcd8739ae039);
function $3d80ea8f8c9273c3$export$2e2bcd8739ae039() {
    window.__JSD_I18N_MESSAGES = window.__JSD_I18N_MESSAGES || {};
    return window.__JSD_I18N_MESSAGES;
}

});

parcelRegister("44YJW", function(module, exports) {
$parcel$export(module.exports, "addSuportedLocaleData", () => $7059253fa8bb5665$export$7fa3dca0309d7f6f);
$parcel$export(module.exports, "getLanguageFromLocale", () => $7059253fa8bb5665$export$e085862dfb8d71);

var $45a3E = parcelRequire("45a3E");

var $4ppiK = parcelRequire("4ppiK");

var $jJ5z2 = parcelRequire("jJ5z2");

var $h8dNw = parcelRequire("h8dNw");

var $cU8ja = parcelRequire("cU8ja");

var $i1bL9 = parcelRequire("i1bL9");

var $6RGv7 = parcelRequire("6RGv7");

var $cwiPU = parcelRequire("cwiPU");

var $jQibz = parcelRequire("jQibz");

var $5rBIH = parcelRequire("5rBIH");

var $1RhZK = parcelRequire("1RhZK");

var $dKwjV = parcelRequire("dKwjV");

var $cK3pM = parcelRequire("cK3pM");

var $hw6Dp = parcelRequire("hw6Dp");

var $eGGw0 = parcelRequire("eGGw0");

var $eHiOh = parcelRequire("eHiOh");

var $gbpk6 = parcelRequire("gbpk6");

var $iHUyH = parcelRequire("iHUyH");

var $h3wzN = parcelRequire("h3wzN");

var $5oNvS = parcelRequire("5oNvS");

var $efPbP = parcelRequire("efPbP");

var $QQTQn = parcelRequire("QQTQn");

var $3Bkhv = parcelRequire("3Bkhv");

var $2uhJV = parcelRequire("2uhJV");

var $iuaQn = parcelRequire("iuaQn");

var $lG3EA = parcelRequire("lG3EA");
let $7059253fa8bb5665$var$hasAlreadyAdded = false;
const $7059253fa8bb5665$export$7fa3dca0309d7f6f = ()=>{
    if ($7059253fa8bb5665$var$hasAlreadyAdded) return;
    (0, $45a3E.addLocaleData)([
        ...(0, (/*@__PURE__*/$parcel$interopDefault($cU8ja))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($h8dNw))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($i1bL9))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jQibz))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($cK3pM))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($hw6Dp))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($iHUyH))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($5oNvS))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4ppiK))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($cwiPU))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($5rBIH))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($dKwjV))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eHiOh))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($h3wzN))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($efPbP))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lG3EA))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jJ5z2))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($6RGv7))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1RhZK))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($eGGw0))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($gbpk6))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($QQTQn))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($iuaQn))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($2uhJV))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($3Bkhv)))
    ]);
    $7059253fa8bb5665$var$hasAlreadyAdded = true;
};
const $7059253fa8bb5665$export$e085862dfb8d71 = (locale)=>{
    if (locale && locale.trim()) {
        if (locale === 'pt_BR' || locale === 'pt-BR') return 'pt-BR';
        return locale.split('_')[0].split('-')[0].trim();
    }
    // default to 'en'
    return 'en';
};

});
parcelRegister("4ppiK", function(module, exports) {
!function(e, a) {
    module.exports = a();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "cs",
            pluralRuleFunction: function(e, a) {
                var n = String(e).split("."), t = n[0], o = !n[1];
                return a ? "other" : 1 == e && o ? "one" : t >= 2 && t <= 4 && o ? "few" : o ? "other" : "many";
            },
            fields: {
                year: {
                    displayName: "rok",
                    relative: {
                        0: "tento rok",
                        1: "p\u0159\xed\u0161t\xed rok",
                        "-1": "minul\xfd rok"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} rok",
                            few: "za {0} roky",
                            many: "za {0} roku",
                            other: "za {0} let"
                        },
                        past: {
                            one: "p\u0159ed {0} rokem",
                            few: "p\u0159ed {0} lety",
                            many: "p\u0159ed {0} roku",
                            other: "p\u0159ed {0} lety"
                        }
                    }
                },
                month: {
                    displayName: "m\u011Bs\xedc",
                    relative: {
                        0: "tento m\u011Bs\xedc",
                        1: "p\u0159\xed\u0161t\xed m\u011Bs\xedc",
                        "-1": "minul\xfd m\u011Bs\xedc"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} m\u011Bs\xedc",
                            few: "za {0} m\u011Bs\xedce",
                            many: "za {0} m\u011Bs\xedce",
                            other: "za {0} m\u011Bs\xedc\u016F"
                        },
                        past: {
                            one: "p\u0159ed {0} m\u011Bs\xedcem",
                            few: "p\u0159ed {0} m\u011Bs\xedci",
                            many: "p\u0159ed {0} m\u011Bs\xedce",
                            other: "p\u0159ed {0} m\u011Bs\xedci"
                        }
                    }
                },
                day: {
                    displayName: "den",
                    relative: {
                        0: "dnes",
                        1: "z\xedtra",
                        2: "poz\xedt\u0159\xed",
                        "-2": "p\u0159edev\u010D\xedrem",
                        "-1": "v\u010Dera"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} den",
                            few: "za {0} dny",
                            many: "za {0} dne",
                            other: "za {0} dn\xed"
                        },
                        past: {
                            one: "p\u0159ed {0} dnem",
                            few: "p\u0159ed {0} dny",
                            many: "p\u0159ed {0} dne",
                            other: "p\u0159ed {0} dny"
                        }
                    }
                },
                hour: {
                    displayName: "hodina",
                    relative: {
                        0: "tuto hodinu"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} hodinu",
                            few: "za {0} hodiny",
                            many: "za {0} hodiny",
                            other: "za {0} hodin"
                        },
                        past: {
                            one: "p\u0159ed {0} hodinou",
                            few: "p\u0159ed {0} hodinami",
                            many: "p\u0159ed {0} hodiny",
                            other: "p\u0159ed {0} hodinami"
                        }
                    }
                },
                minute: {
                    displayName: "minuta",
                    relative: {
                        0: "tuto minutu"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} minutu",
                            few: "za {0} minuty",
                            many: "za {0} minuty",
                            other: "za {0} minut"
                        },
                        past: {
                            one: "p\u0159ed {0} minutou",
                            few: "p\u0159ed {0} minutami",
                            many: "p\u0159ed {0} minuty",
                            other: "p\u0159ed {0} minutami"
                        }
                    }
                },
                second: {
                    displayName: "sekunda",
                    relative: {
                        0: "nyn\xed"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} sekundu",
                            few: "za {0} sekundy",
                            many: "za {0} sekundy",
                            other: "za {0} sekund"
                        },
                        past: {
                            one: "p\u0159ed {0} sekundou",
                            few: "p\u0159ed {0} sekundami",
                            many: "p\u0159ed {0} sekundy",
                            other: "p\u0159ed {0} sekundami"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("jJ5z2", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "da",
            pluralRuleFunction: function(e, t) {
                var r = String(e).split("."), n = r[0], o = Number(r[0]) == e;
                return t ? "other" : 1 != e && (o || 0 != n && 1 != n) ? "other" : "one";
            },
            fields: {
                year: {
                    displayName: "\xe5r",
                    relative: {
                        0: "i \xe5r",
                        1: "n\xe6ste \xe5r",
                        "-1": "sidste \xe5r"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} \xe5r",
                            other: "om {0} \xe5r"
                        },
                        past: {
                            one: "for {0} \xe5r siden",
                            other: "for {0} \xe5r siden"
                        }
                    }
                },
                month: {
                    displayName: "m\xe5ned",
                    relative: {
                        0: "denne m\xe5ned",
                        1: "n\xe6ste m\xe5ned",
                        "-1": "sidste m\xe5ned"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} m\xe5ned",
                            other: "om {0} m\xe5neder"
                        },
                        past: {
                            one: "for {0} m\xe5ned siden",
                            other: "for {0} m\xe5neder siden"
                        }
                    }
                },
                day: {
                    displayName: "dag",
                    relative: {
                        0: "i dag",
                        1: "i morgen",
                        2: "i overmorgen",
                        "-2": "i forg\xe5rs",
                        "-1": "i g\xe5r"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} dag",
                            other: "om {0} dage"
                        },
                        past: {
                            one: "for {0} dag siden",
                            other: "for {0} dage siden"
                        }
                    }
                },
                hour: {
                    displayName: "time",
                    relative: {
                        0: "i den kommende time"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} time",
                            other: "om {0} timer"
                        },
                        past: {
                            one: "for {0} time siden",
                            other: "for {0} timer siden"
                        }
                    }
                },
                minute: {
                    displayName: "minut",
                    relative: {
                        0: "i det kommende minut"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} minut",
                            other: "om {0} minutter"
                        },
                        past: {
                            one: "for {0} minut siden",
                            other: "for {0} minutter siden"
                        }
                    }
                },
                second: {
                    displayName: "sekund",
                    relative: {
                        0: "nu"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} sekund",
                            other: "om {0} sekunder"
                        },
                        past: {
                            one: "for {0} sekund siden",
                            other: "for {0} sekunder siden"
                        }
                    }
                }
            }
        },
        {
            locale: "da-GL",
            parentLocale: "da"
        }
    ];
});

});

parcelRegister("h8dNw", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "de",
            pluralRuleFunction: function(e, t) {
                var n = !String(e).split(".")[1];
                return t ? "other" : 1 == e && n ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "Jahr",
                    relative: {
                        0: "dieses Jahr",
                        1: "n\xe4chstes Jahr",
                        "-1": "letztes Jahr"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} Jahr",
                            other: "in {0} Jahren"
                        },
                        past: {
                            one: "vor {0} Jahr",
                            other: "vor {0} Jahren"
                        }
                    }
                },
                month: {
                    displayName: "Monat",
                    relative: {
                        0: "diesen Monat",
                        1: "n\xe4chsten Monat",
                        "-1": "letzten Monat"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} Monat",
                            other: "in {0} Monaten"
                        },
                        past: {
                            one: "vor {0} Monat",
                            other: "vor {0} Monaten"
                        }
                    }
                },
                day: {
                    displayName: "Tag",
                    relative: {
                        0: "heute",
                        1: "morgen",
                        2: "\xfcbermorgen",
                        "-2": "vorgestern",
                        "-1": "gestern"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} Tag",
                            other: "in {0} Tagen"
                        },
                        past: {
                            one: "vor {0} Tag",
                            other: "vor {0} Tagen"
                        }
                    }
                },
                hour: {
                    displayName: "Stunde",
                    relative: {
                        0: "in dieser Stunde"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} Stunde",
                            other: "in {0} Stunden"
                        },
                        past: {
                            one: "vor {0} Stunde",
                            other: "vor {0} Stunden"
                        }
                    }
                },
                minute: {
                    displayName: "Minute",
                    relative: {
                        0: "in dieser Minute"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} Minute",
                            other: "in {0} Minuten"
                        },
                        past: {
                            one: "vor {0} Minute",
                            other: "vor {0} Minuten"
                        }
                    }
                },
                second: {
                    displayName: "Sekunde",
                    relative: {
                        0: "jetzt"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} Sekunde",
                            other: "in {0} Sekunden"
                        },
                        past: {
                            one: "vor {0} Sekunde",
                            other: "vor {0} Sekunden"
                        }
                    }
                }
            }
        },
        {
            locale: "de-AT",
            parentLocale: "de"
        },
        {
            locale: "de-BE",
            parentLocale: "de"
        },
        {
            locale: "de-CH",
            parentLocale: "de"
        },
        {
            locale: "de-IT",
            parentLocale: "de"
        },
        {
            locale: "de-LI",
            parentLocale: "de"
        },
        {
            locale: "de-LU",
            parentLocale: "de"
        }
    ];
});

});

parcelRegister("cU8ja", function(module, exports) {
!function(e, a) {
    module.exports = a();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "en",
            pluralRuleFunction: function(e, a) {
                var n = String(e).split("."), l = !n[1], o = Number(n[0]) == e, t = o && n[0].slice(-1), r = o && n[0].slice(-2);
                return a ? 1 == t && 11 != r ? "one" : 2 == t && 12 != r ? "two" : 3 == t && 13 != r ? "few" : "other" : 1 == e && l ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "year",
                    relative: {
                        0: "this year",
                        1: "next year",
                        "-1": "last year"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} year",
                            other: "in {0} years"
                        },
                        past: {
                            one: "{0} year ago",
                            other: "{0} years ago"
                        }
                    }
                },
                month: {
                    displayName: "month",
                    relative: {
                        0: "this month",
                        1: "next month",
                        "-1": "last month"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} month",
                            other: "in {0} months"
                        },
                        past: {
                            one: "{0} month ago",
                            other: "{0} months ago"
                        }
                    }
                },
                day: {
                    displayName: "day",
                    relative: {
                        0: "today",
                        1: "tomorrow",
                        "-1": "yesterday"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} day",
                            other: "in {0} days"
                        },
                        past: {
                            one: "{0} day ago",
                            other: "{0} days ago"
                        }
                    }
                },
                hour: {
                    displayName: "hour",
                    relative: {
                        0: "this hour"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} hour",
                            other: "in {0} hours"
                        },
                        past: {
                            one: "{0} hour ago",
                            other: "{0} hours ago"
                        }
                    }
                },
                minute: {
                    displayName: "minute",
                    relative: {
                        0: "this minute"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} minute",
                            other: "in {0} minutes"
                        },
                        past: {
                            one: "{0} minute ago",
                            other: "{0} minutes ago"
                        }
                    }
                },
                second: {
                    displayName: "second",
                    relative: {
                        0: "now"
                    },
                    relativeTime: {
                        future: {
                            one: "in {0} second",
                            other: "in {0} seconds"
                        },
                        past: {
                            one: "{0} second ago",
                            other: "{0} seconds ago"
                        }
                    }
                }
            }
        },
        {
            locale: "en-001",
            parentLocale: "en"
        },
        {
            locale: "en-150",
            parentLocale: "en-001"
        },
        {
            locale: "en-AG",
            parentLocale: "en-001"
        },
        {
            locale: "en-AI",
            parentLocale: "en-001"
        },
        {
            locale: "en-AS",
            parentLocale: "en"
        },
        {
            locale: "en-AT",
            parentLocale: "en-150"
        },
        {
            locale: "en-AU",
            parentLocale: "en-001"
        },
        {
            locale: "en-BB",
            parentLocale: "en-001"
        },
        {
            locale: "en-BE",
            parentLocale: "en-001"
        },
        {
            locale: "en-BI",
            parentLocale: "en"
        },
        {
            locale: "en-BM",
            parentLocale: "en-001"
        },
        {
            locale: "en-BS",
            parentLocale: "en-001"
        },
        {
            locale: "en-BW",
            parentLocale: "en-001"
        },
        {
            locale: "en-BZ",
            parentLocale: "en-001"
        },
        {
            locale: "en-CA",
            parentLocale: "en-001"
        },
        {
            locale: "en-CC",
            parentLocale: "en-001"
        },
        {
            locale: "en-CH",
            parentLocale: "en-150"
        },
        {
            locale: "en-CK",
            parentLocale: "en-001"
        },
        {
            locale: "en-CM",
            parentLocale: "en-001"
        },
        {
            locale: "en-CX",
            parentLocale: "en-001"
        },
        {
            locale: "en-CY",
            parentLocale: "en-001"
        },
        {
            locale: "en-DE",
            parentLocale: "en-150"
        },
        {
            locale: "en-DG",
            parentLocale: "en-001"
        },
        {
            locale: "en-DK",
            parentLocale: "en-150"
        },
        {
            locale: "en-DM",
            parentLocale: "en-001"
        },
        {
            locale: "en-Dsrt",
            pluralRuleFunction: function(e, a) {
                return "other";
            },
            fields: {
                year: {
                    displayName: "Year",
                    relative: {
                        0: "this year",
                        1: "next year",
                        "-1": "last year"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} y"
                        },
                        past: {
                            other: "-{0} y"
                        }
                    }
                },
                month: {
                    displayName: "Month",
                    relative: {
                        0: "this month",
                        1: "next month",
                        "-1": "last month"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} m"
                        },
                        past: {
                            other: "-{0} m"
                        }
                    }
                },
                day: {
                    displayName: "Day",
                    relative: {
                        0: "today",
                        1: "tomorrow",
                        "-1": "yesterday"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} d"
                        },
                        past: {
                            other: "-{0} d"
                        }
                    }
                },
                hour: {
                    displayName: "Hour",
                    relative: {
                        0: "this hour"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} h"
                        },
                        past: {
                            other: "-{0} h"
                        }
                    }
                },
                minute: {
                    displayName: "Minute",
                    relative: {
                        0: "this minute"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} min"
                        },
                        past: {
                            other: "-{0} min"
                        }
                    }
                },
                second: {
                    displayName: "Second",
                    relative: {
                        0: "now"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} s"
                        },
                        past: {
                            other: "-{0} s"
                        }
                    }
                }
            }
        },
        {
            locale: "en-ER",
            parentLocale: "en-001"
        },
        {
            locale: "en-FI",
            parentLocale: "en-150"
        },
        {
            locale: "en-FJ",
            parentLocale: "en-001"
        },
        {
            locale: "en-FK",
            parentLocale: "en-001"
        },
        {
            locale: "en-FM",
            parentLocale: "en-001"
        },
        {
            locale: "en-GB",
            parentLocale: "en-001"
        },
        {
            locale: "en-GD",
            parentLocale: "en-001"
        },
        {
            locale: "en-GG",
            parentLocale: "en-001"
        },
        {
            locale: "en-GH",
            parentLocale: "en-001"
        },
        {
            locale: "en-GI",
            parentLocale: "en-001"
        },
        {
            locale: "en-GM",
            parentLocale: "en-001"
        },
        {
            locale: "en-GU",
            parentLocale: "en"
        },
        {
            locale: "en-GY",
            parentLocale: "en-001"
        },
        {
            locale: "en-HK",
            parentLocale: "en-001"
        },
        {
            locale: "en-IE",
            parentLocale: "en-001"
        },
        {
            locale: "en-IL",
            parentLocale: "en-001"
        },
        {
            locale: "en-IM",
            parentLocale: "en-001"
        },
        {
            locale: "en-IN",
            parentLocale: "en-001"
        },
        {
            locale: "en-IO",
            parentLocale: "en-001"
        },
        {
            locale: "en-JE",
            parentLocale: "en-001"
        },
        {
            locale: "en-JM",
            parentLocale: "en-001"
        },
        {
            locale: "en-KE",
            parentLocale: "en-001"
        },
        {
            locale: "en-KI",
            parentLocale: "en-001"
        },
        {
            locale: "en-KN",
            parentLocale: "en-001"
        },
        {
            locale: "en-KY",
            parentLocale: "en-001"
        },
        {
            locale: "en-LC",
            parentLocale: "en-001"
        },
        {
            locale: "en-LR",
            parentLocale: "en-001"
        },
        {
            locale: "en-LS",
            parentLocale: "en-001"
        },
        {
            locale: "en-MG",
            parentLocale: "en-001"
        },
        {
            locale: "en-MH",
            parentLocale: "en"
        },
        {
            locale: "en-MO",
            parentLocale: "en-001"
        },
        {
            locale: "en-MP",
            parentLocale: "en"
        },
        {
            locale: "en-MS",
            parentLocale: "en-001"
        },
        {
            locale: "en-MT",
            parentLocale: "en-001"
        },
        {
            locale: "en-MU",
            parentLocale: "en-001"
        },
        {
            locale: "en-MW",
            parentLocale: "en-001"
        },
        {
            locale: "en-MY",
            parentLocale: "en-001"
        },
        {
            locale: "en-NA",
            parentLocale: "en-001"
        },
        {
            locale: "en-NF",
            parentLocale: "en-001"
        },
        {
            locale: "en-NG",
            parentLocale: "en-001"
        },
        {
            locale: "en-NL",
            parentLocale: "en-150"
        },
        {
            locale: "en-NR",
            parentLocale: "en-001"
        },
        {
            locale: "en-NU",
            parentLocale: "en-001"
        },
        {
            locale: "en-NZ",
            parentLocale: "en-001"
        },
        {
            locale: "en-PG",
            parentLocale: "en-001"
        },
        {
            locale: "en-PH",
            parentLocale: "en-001"
        },
        {
            locale: "en-PK",
            parentLocale: "en-001"
        },
        {
            locale: "en-PN",
            parentLocale: "en-001"
        },
        {
            locale: "en-PR",
            parentLocale: "en"
        },
        {
            locale: "en-PW",
            parentLocale: "en-001"
        },
        {
            locale: "en-RW",
            parentLocale: "en-001"
        },
        {
            locale: "en-SB",
            parentLocale: "en-001"
        },
        {
            locale: "en-SC",
            parentLocale: "en-001"
        },
        {
            locale: "en-SD",
            parentLocale: "en-001"
        },
        {
            locale: "en-SE",
            parentLocale: "en-150"
        },
        {
            locale: "en-SG",
            parentLocale: "en-001"
        },
        {
            locale: "en-SH",
            parentLocale: "en-001"
        },
        {
            locale: "en-SI",
            parentLocale: "en-150"
        },
        {
            locale: "en-SL",
            parentLocale: "en-001"
        },
        {
            locale: "en-SS",
            parentLocale: "en-001"
        },
        {
            locale: "en-SX",
            parentLocale: "en-001"
        },
        {
            locale: "en-SZ",
            parentLocale: "en-001"
        },
        {
            locale: "en-Shaw",
            pluralRuleFunction: function(e, a) {
                return "other";
            },
            fields: {
                year: {
                    displayName: "Year",
                    relative: {
                        0: "this year",
                        1: "next year",
                        "-1": "last year"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} y"
                        },
                        past: {
                            other: "-{0} y"
                        }
                    }
                },
                month: {
                    displayName: "Month",
                    relative: {
                        0: "this month",
                        1: "next month",
                        "-1": "last month"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} m"
                        },
                        past: {
                            other: "-{0} m"
                        }
                    }
                },
                day: {
                    displayName: "Day",
                    relative: {
                        0: "today",
                        1: "tomorrow",
                        "-1": "yesterday"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} d"
                        },
                        past: {
                            other: "-{0} d"
                        }
                    }
                },
                hour: {
                    displayName: "Hour",
                    relative: {
                        0: "this hour"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} h"
                        },
                        past: {
                            other: "-{0} h"
                        }
                    }
                },
                minute: {
                    displayName: "Minute",
                    relative: {
                        0: "this minute"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} min"
                        },
                        past: {
                            other: "-{0} min"
                        }
                    }
                },
                second: {
                    displayName: "Second",
                    relative: {
                        0: "now"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} s"
                        },
                        past: {
                            other: "-{0} s"
                        }
                    }
                }
            }
        },
        {
            locale: "en-TC",
            parentLocale: "en-001"
        },
        {
            locale: "en-TK",
            parentLocale: "en-001"
        },
        {
            locale: "en-TO",
            parentLocale: "en-001"
        },
        {
            locale: "en-TT",
            parentLocale: "en-001"
        },
        {
            locale: "en-TV",
            parentLocale: "en-001"
        },
        {
            locale: "en-TZ",
            parentLocale: "en-001"
        },
        {
            locale: "en-UG",
            parentLocale: "en-001"
        },
        {
            locale: "en-UM",
            parentLocale: "en"
        },
        {
            locale: "en-US",
            parentLocale: "en"
        },
        {
            locale: "en-VC",
            parentLocale: "en-001"
        },
        {
            locale: "en-VG",
            parentLocale: "en-001"
        },
        {
            locale: "en-VI",
            parentLocale: "en"
        },
        {
            locale: "en-VU",
            parentLocale: "en-001"
        },
        {
            locale: "en-WS",
            parentLocale: "en-001"
        },
        {
            locale: "en-ZA",
            parentLocale: "en-001"
        },
        {
            locale: "en-ZM",
            parentLocale: "en-001"
        },
        {
            locale: "en-ZW",
            parentLocale: "en-001"
        }
    ];
});

});

parcelRegister("i1bL9", function(module, exports) {
!function(e, a) {
    module.exports = a();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "es",
            pluralRuleFunction: function(e, a) {
                return a ? "other" : 1 == e ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "a\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el pr\xf3ximo a\xf1o",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "mes",
                    relative: {
                        0: "este mes",
                        1: "el pr\xf3ximo mes",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} mes",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "d\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "anteayer",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-419",
            parentLocale: "es"
        },
        {
            locale: "es-AR",
            parentLocale: "es-419"
        },
        {
            locale: "es-BO",
            parentLocale: "es-419"
        },
        {
            locale: "es-BR",
            parentLocale: "es-419"
        },
        {
            locale: "es-BZ",
            parentLocale: "es-419"
        },
        {
            locale: "es-CL",
            parentLocale: "es-419"
        },
        {
            locale: "es-CO",
            parentLocale: "es-419"
        },
        {
            locale: "es-CR",
            parentLocale: "es-419",
            fields: {
                year: {
                    displayName: "a\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el pr\xf3ximo a\xf1o",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "mes",
                    relative: {
                        0: "este mes",
                        1: "el pr\xf3ximo mes",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} mes",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "d\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "antier",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-CU",
            parentLocale: "es-419"
        },
        {
            locale: "es-DO",
            parentLocale: "es-419",
            fields: {
                year: {
                    displayName: "A\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el pr\xf3ximo a\xf1o",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "Mes",
                    relative: {
                        0: "este mes",
                        1: "el pr\xf3ximo mes",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} mes",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "D\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "anteayer",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "Minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "Segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-EA",
            parentLocale: "es"
        },
        {
            locale: "es-EC",
            parentLocale: "es-419"
        },
        {
            locale: "es-GQ",
            parentLocale: "es"
        },
        {
            locale: "es-GT",
            parentLocale: "es-419",
            fields: {
                year: {
                    displayName: "a\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el pr\xf3ximo a\xf1o",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "mes",
                    relative: {
                        0: "este mes",
                        1: "el pr\xf3ximo mes",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} mes",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "d\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "antier",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-HN",
            parentLocale: "es-419",
            fields: {
                year: {
                    displayName: "a\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el pr\xf3ximo a\xf1o",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "mes",
                    relative: {
                        0: "este mes",
                        1: "el pr\xf3ximo mes",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} mes",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "d\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "antier",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-IC",
            parentLocale: "es"
        },
        {
            locale: "es-MX",
            parentLocale: "es-419",
            fields: {
                year: {
                    displayName: "a\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el a\xf1o pr\xf3ximo",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "mes",
                    relative: {
                        0: "este mes",
                        1: "el mes pr\xf3ximo",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "en {0} mes",
                            other: "en {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "d\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "antier",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-NI",
            parentLocale: "es-419",
            fields: {
                year: {
                    displayName: "a\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el pr\xf3ximo a\xf1o",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "mes",
                    relative: {
                        0: "este mes",
                        1: "el pr\xf3ximo mes",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} mes",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "d\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "antier",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-PA",
            parentLocale: "es-419",
            fields: {
                year: {
                    displayName: "a\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el pr\xf3ximo a\xf1o",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "mes",
                    relative: {
                        0: "este mes",
                        1: "el pr\xf3ximo mes",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} mes",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "d\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "antier",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-PE",
            parentLocale: "es-419"
        },
        {
            locale: "es-PH",
            parentLocale: "es"
        },
        {
            locale: "es-PR",
            parentLocale: "es-419"
        },
        {
            locale: "es-PY",
            parentLocale: "es-419",
            fields: {
                year: {
                    displayName: "a\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el pr\xf3ximo a\xf1o",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "mes",
                    relative: {
                        0: "este mes",
                        1: "el pr\xf3ximo mes",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} mes",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "d\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "antes de ayer",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-SV",
            parentLocale: "es-419",
            fields: {
                year: {
                    displayName: "a\xf1o",
                    relative: {
                        0: "este a\xf1o",
                        1: "el pr\xf3ximo a\xf1o",
                        "-1": "el a\xf1o pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} a\xf1o",
                            other: "dentro de {0} a\xf1os"
                        },
                        past: {
                            one: "hace {0} a\xf1o",
                            other: "hace {0} a\xf1os"
                        }
                    }
                },
                month: {
                    displayName: "mes",
                    relative: {
                        0: "este mes",
                        1: "el pr\xf3ximo mes",
                        "-1": "el mes pasado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} mes",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "hace {0} mes",
                            other: "hace {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "d\xeda",
                    relative: {
                        0: "hoy",
                        1: "ma\xf1ana",
                        2: "pasado ma\xf1ana",
                        "-2": "antier",
                        "-1": "ayer"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} d\xeda",
                            other: "dentro de {0} d\xedas"
                        },
                        past: {
                            one: "hace {0} d\xeda",
                            other: "hace {0} d\xedas"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "hace {0} hora",
                            other: "hace {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "hace {0} minuto",
                            other: "hace {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "ahora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "hace {0} segundo",
                            other: "hace {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "es-US",
            parentLocale: "es-419"
        },
        {
            locale: "es-UY",
            parentLocale: "es-419"
        },
        {
            locale: "es-VE",
            parentLocale: "es-419"
        }
    ];
});

});

parcelRegister("6RGv7", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "et",
            pluralRuleFunction: function(e, t) {
                var a = !String(e).split(".")[1];
                return t ? "other" : 1 == e && a ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "aasta",
                    relative: {
                        0: "k\xe4esolev aasta",
                        1: "j\xe4rgmine aasta",
                        "-1": "eelmine aasta"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} aasta p\xe4rast",
                            other: "{0} aasta p\xe4rast"
                        },
                        past: {
                            one: "{0} aasta eest",
                            other: "{0} aasta eest"
                        }
                    }
                },
                month: {
                    displayName: "kuu",
                    relative: {
                        0: "k\xe4esolev kuu",
                        1: "j\xe4rgmine kuu",
                        "-1": "eelmine kuu"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} kuu p\xe4rast",
                            other: "{0} kuu p\xe4rast"
                        },
                        past: {
                            one: "{0} kuu eest",
                            other: "{0} kuu eest"
                        }
                    }
                },
                day: {
                    displayName: "p\xe4ev",
                    relative: {
                        0: "t\xe4na",
                        1: "homme",
                        2: "\xfclehomme",
                        "-2": "\xfcleeile",
                        "-1": "eile"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} p\xe4eva p\xe4rast",
                            other: "{0} p\xe4eva p\xe4rast"
                        },
                        past: {
                            one: "{0} p\xe4eva eest",
                            other: "{0} p\xe4eva eest"
                        }
                    }
                },
                hour: {
                    displayName: "tund",
                    relative: {
                        0: "praegusel tunnil"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} tunni p\xe4rast",
                            other: "{0} tunni p\xe4rast"
                        },
                        past: {
                            one: "{0} tunni eest",
                            other: "{0} tunni eest"
                        }
                    }
                },
                minute: {
                    displayName: "minut",
                    relative: {
                        0: "praegusel minutil"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} minuti p\xe4rast",
                            other: "{0} minuti p\xe4rast"
                        },
                        past: {
                            one: "{0} minuti eest",
                            other: "{0} minuti eest"
                        }
                    }
                },
                second: {
                    displayName: "sekund",
                    relative: {
                        0: "n\xfc\xfcd"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} sekundi p\xe4rast",
                            other: "{0} sekundi p\xe4rast"
                        },
                        past: {
                            one: "{0} sekundi eest",
                            other: "{0} sekundi eest"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("cwiPU", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "fi",
            pluralRuleFunction: function(t, e) {
                var n = !String(t).split(".")[1];
                return e ? "other" : 1 == t && n ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "vuosi",
                    relative: {
                        0: "t\xe4n\xe4 vuonna",
                        1: "ensi vuonna",
                        "-1": "viime vuonna"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} vuoden p\xe4\xe4st\xe4",
                            other: "{0} vuoden p\xe4\xe4st\xe4"
                        },
                        past: {
                            one: "{0} vuosi sitten",
                            other: "{0} vuotta sitten"
                        }
                    }
                },
                month: {
                    displayName: "kuukausi",
                    relative: {
                        0: "t\xe4ss\xe4 kuussa",
                        1: "ensi kuussa",
                        "-1": "viime kuussa"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} kuukauden p\xe4\xe4st\xe4",
                            other: "{0} kuukauden p\xe4\xe4st\xe4"
                        },
                        past: {
                            one: "{0} kuukausi sitten",
                            other: "{0} kuukautta sitten"
                        }
                    }
                },
                day: {
                    displayName: "p\xe4iv\xe4",
                    relative: {
                        0: "t\xe4n\xe4\xe4n",
                        1: "huomenna",
                        2: "ylihuomenna",
                        "-2": "toissa p\xe4iv\xe4n\xe4",
                        "-1": "eilen"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} p\xe4iv\xe4n p\xe4\xe4st\xe4",
                            other: "{0} p\xe4iv\xe4n p\xe4\xe4st\xe4"
                        },
                        past: {
                            one: "{0} p\xe4iv\xe4 sitten",
                            other: "{0} p\xe4iv\xe4\xe4 sitten"
                        }
                    }
                },
                hour: {
                    displayName: "tunti",
                    relative: {
                        0: "t\xe4m\xe4n tunnin aikana"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} tunnin p\xe4\xe4st\xe4",
                            other: "{0} tunnin p\xe4\xe4st\xe4"
                        },
                        past: {
                            one: "{0} tunti sitten",
                            other: "{0} tuntia sitten"
                        }
                    }
                },
                minute: {
                    displayName: "minuutti",
                    relative: {
                        0: "t\xe4m\xe4n minuutin aikana"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} minuutin p\xe4\xe4st\xe4",
                            other: "{0} minuutin p\xe4\xe4st\xe4"
                        },
                        past: {
                            one: "{0} minuutti sitten",
                            other: "{0} minuuttia sitten"
                        }
                    }
                },
                second: {
                    displayName: "sekunti",
                    relative: {
                        0: "nyt"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} sekunnin p\xe4\xe4st\xe4",
                            other: "{0} sekunnin p\xe4\xe4st\xe4"
                        },
                        past: {
                            one: "{0} sekunti sitten",
                            other: "{0} sekuntia sitten"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("jQibz", function(module, exports) {
!function(e, a) {
    module.exports = a();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "fr",
            pluralRuleFunction: function(e, a) {
                return a ? 1 == e ? "one" : "other" : e >= 0 && e < 2 ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "ann\xe9e",
                    relative: {
                        0: "cette ann\xe9e",
                        1: "l\u2019ann\xe9e prochaine",
                        "-1": "l\u2019ann\xe9e derni\xe8re"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} an",
                            other: "dans {0} ans"
                        },
                        past: {
                            one: "il y a {0} an",
                            other: "il y a {0} ans"
                        }
                    }
                },
                month: {
                    displayName: "mois",
                    relative: {
                        0: "ce mois-ci",
                        1: "le mois prochain",
                        "-1": "le mois dernier"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} mois",
                            other: "dans {0} mois"
                        },
                        past: {
                            one: "il y a {0} mois",
                            other: "il y a {0} mois"
                        }
                    }
                },
                day: {
                    displayName: "jour",
                    relative: {
                        0: "aujourd\u2019hui",
                        1: "demain",
                        2: "apr\xe8s-demain",
                        "-2": "avant-hier",
                        "-1": "hier"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} jour",
                            other: "dans {0} jours"
                        },
                        past: {
                            one: "il y a {0} jour",
                            other: "il y a {0} jours"
                        }
                    }
                },
                hour: {
                    displayName: "heure",
                    relative: {
                        0: "cette heure-ci"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} heure",
                            other: "dans {0} heures"
                        },
                        past: {
                            one: "il y a {0} heure",
                            other: "il y a {0} heures"
                        }
                    }
                },
                minute: {
                    displayName: "minute",
                    relative: {
                        0: "cette minute-ci"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} minute",
                            other: "dans {0} minutes"
                        },
                        past: {
                            one: "il y a {0} minute",
                            other: "il y a {0} minutes"
                        }
                    }
                },
                second: {
                    displayName: "seconde",
                    relative: {
                        0: "maintenant"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} seconde",
                            other: "dans {0} secondes"
                        },
                        past: {
                            one: "il y a {0} seconde",
                            other: "il y a {0} secondes"
                        }
                    }
                }
            }
        },
        {
            locale: "fr-BE",
            parentLocale: "fr"
        },
        {
            locale: "fr-BF",
            parentLocale: "fr"
        },
        {
            locale: "fr-BI",
            parentLocale: "fr"
        },
        {
            locale: "fr-BJ",
            parentLocale: "fr"
        },
        {
            locale: "fr-BL",
            parentLocale: "fr"
        },
        {
            locale: "fr-CA",
            parentLocale: "fr",
            fields: {
                year: {
                    displayName: "ann\xe9e",
                    relative: {
                        0: "cette ann\xe9e",
                        1: "l\u2019ann\xe9e prochaine",
                        "-1": "l\u2019ann\xe9e derni\xe8re"
                    },
                    relativeTime: {
                        future: {
                            one: "Dans {0}\xa0an",
                            other: "Dans {0}\xa0ans"
                        },
                        past: {
                            one: "Il y a {0}\xa0an",
                            other: "Il y a {0}\xa0ans"
                        }
                    }
                },
                month: {
                    displayName: "mois",
                    relative: {
                        0: "ce mois-ci",
                        1: "le mois prochain",
                        "-1": "le mois dernier"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} mois",
                            other: "dans {0} mois"
                        },
                        past: {
                            one: "il y a {0} mois",
                            other: "il y a {0} mois"
                        }
                    }
                },
                day: {
                    displayName: "jour",
                    relative: {
                        0: "aujourd\u2019hui",
                        1: "demain",
                        2: "apr\xe8s-demain",
                        "-2": "avant-hier",
                        "-1": "hier"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} jour",
                            other: "dans {0} jours"
                        },
                        past: {
                            one: "il y a {0} jour",
                            other: "il y a {0} jours"
                        }
                    }
                },
                hour: {
                    displayName: "heure",
                    relative: {
                        0: "cette heure-ci"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} heure",
                            other: "dans {0} heures"
                        },
                        past: {
                            one: "il y a {0} heure",
                            other: "il y a {0} heures"
                        }
                    }
                },
                minute: {
                    displayName: "minute",
                    relative: {
                        0: "cette minute-ci"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} minute",
                            other: "dans {0} minutes"
                        },
                        past: {
                            one: "il y a {0} minute",
                            other: "il y a {0} minutes"
                        }
                    }
                },
                second: {
                    displayName: "seconde",
                    relative: {
                        0: "maintenant"
                    },
                    relativeTime: {
                        future: {
                            one: "dans {0} seconde",
                            other: "dans {0} secondes"
                        },
                        past: {
                            one: "il y a {0} seconde",
                            other: "il y a {0} secondes"
                        }
                    }
                }
            }
        },
        {
            locale: "fr-CD",
            parentLocale: "fr"
        },
        {
            locale: "fr-CF",
            parentLocale: "fr"
        },
        {
            locale: "fr-CG",
            parentLocale: "fr"
        },
        {
            locale: "fr-CH",
            parentLocale: "fr"
        },
        {
            locale: "fr-CI",
            parentLocale: "fr"
        },
        {
            locale: "fr-CM",
            parentLocale: "fr"
        },
        {
            locale: "fr-DJ",
            parentLocale: "fr"
        },
        {
            locale: "fr-DZ",
            parentLocale: "fr"
        },
        {
            locale: "fr-GA",
            parentLocale: "fr"
        },
        {
            locale: "fr-GF",
            parentLocale: "fr"
        },
        {
            locale: "fr-GN",
            parentLocale: "fr"
        },
        {
            locale: "fr-GP",
            parentLocale: "fr"
        },
        {
            locale: "fr-GQ",
            parentLocale: "fr"
        },
        {
            locale: "fr-HT",
            parentLocale: "fr"
        },
        {
            locale: "fr-KM",
            parentLocale: "fr"
        },
        {
            locale: "fr-LU",
            parentLocale: "fr"
        },
        {
            locale: "fr-MA",
            parentLocale: "fr"
        },
        {
            locale: "fr-MC",
            parentLocale: "fr"
        },
        {
            locale: "fr-MF",
            parentLocale: "fr"
        },
        {
            locale: "fr-MG",
            parentLocale: "fr"
        },
        {
            locale: "fr-ML",
            parentLocale: "fr"
        },
        {
            locale: "fr-MQ",
            parentLocale: "fr"
        },
        {
            locale: "fr-MR",
            parentLocale: "fr"
        },
        {
            locale: "fr-MU",
            parentLocale: "fr"
        },
        {
            locale: "fr-NC",
            parentLocale: "fr"
        },
        {
            locale: "fr-NE",
            parentLocale: "fr"
        },
        {
            locale: "fr-PF",
            parentLocale: "fr"
        },
        {
            locale: "fr-PM",
            parentLocale: "fr"
        },
        {
            locale: "fr-RE",
            parentLocale: "fr"
        },
        {
            locale: "fr-RW",
            parentLocale: "fr"
        },
        {
            locale: "fr-SC",
            parentLocale: "fr"
        },
        {
            locale: "fr-SN",
            parentLocale: "fr"
        },
        {
            locale: "fr-SY",
            parentLocale: "fr"
        },
        {
            locale: "fr-TD",
            parentLocale: "fr"
        },
        {
            locale: "fr-TG",
            parentLocale: "fr"
        },
        {
            locale: "fr-TN",
            parentLocale: "fr"
        },
        {
            locale: "fr-VU",
            parentLocale: "fr"
        },
        {
            locale: "fr-WF",
            parentLocale: "fr"
        },
        {
            locale: "fr-YT",
            parentLocale: "fr"
        }
    ];
});

});

parcelRegister("5rBIH", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "hu",
            pluralRuleFunction: function(e, t) {
                return t ? 1 == e || 5 == e ? "one" : "other" : 1 == e ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "\xe9v",
                    relative: {
                        0: "ez az \xe9v",
                        1: "k\xf6vetkez\u0151 \xe9v",
                        "-1": "el\u0151z\u0151 \xe9v"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} \xe9v m\xfalva",
                            other: "{0} \xe9v m\xfalva"
                        },
                        past: {
                            one: "{0} \xe9vvel ezel\u0151tt",
                            other: "{0} \xe9vvel ezel\u0151tt"
                        }
                    }
                },
                month: {
                    displayName: "h\xf3nap",
                    relative: {
                        0: "ez a h\xf3nap",
                        1: "k\xf6vetkez\u0151 h\xf3nap",
                        "-1": "el\u0151z\u0151 h\xf3nap"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} h\xf3nap m\xfalva",
                            other: "{0} h\xf3nap m\xfalva"
                        },
                        past: {
                            one: "{0} h\xf3nappal ezel\u0151tt",
                            other: "{0} h\xf3nappal ezel\u0151tt"
                        }
                    }
                },
                day: {
                    displayName: "nap",
                    relative: {
                        0: "ma",
                        1: "holnap",
                        2: "holnaput\xe1n",
                        "-2": "tegnapel\u0151tt",
                        "-1": "tegnap"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} nap m\xfalva",
                            other: "{0} nap m\xfalva"
                        },
                        past: {
                            one: "{0} nappal ezel\u0151tt",
                            other: "{0} nappal ezel\u0151tt"
                        }
                    }
                },
                hour: {
                    displayName: "\xf3ra",
                    relative: {
                        0: "ebben az \xf3r\xe1ban"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} \xf3ra m\xfalva",
                            other: "{0} \xf3ra m\xfalva"
                        },
                        past: {
                            one: "{0} \xf3r\xe1val ezel\u0151tt",
                            other: "{0} \xf3r\xe1val ezel\u0151tt"
                        }
                    }
                },
                minute: {
                    displayName: "perc",
                    relative: {
                        0: "ebben a percben"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} perc m\xfalva",
                            other: "{0} perc m\xfalva"
                        },
                        past: {
                            one: "{0} perccel ezel\u0151tt",
                            other: "{0} perccel ezel\u0151tt"
                        }
                    }
                },
                second: {
                    displayName: "m\xe1sodperc",
                    relative: {
                        0: "most"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} m\xe1sodperc m\xfalva",
                            other: "{0} m\xe1sodperc m\xfalva"
                        },
                        past: {
                            one: "{0} m\xe1sodperccel ezel\u0151tt",
                            other: "{0} m\xe1sodperccel ezel\u0151tt"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("1RhZK", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "is",
            pluralRuleFunction: function(e, r) {
                var t = String(e).split("."), i = t[0], u = Number(t[0]) == e, a = i.slice(-1), n = i.slice(-2);
                return r ? "other" : u && 1 == a && 11 != n || !u ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "\xe1r",
                    relative: {
                        0: "\xe1 \xfeessu \xe1ri",
                        1: "\xe1 n\xe6sta \xe1ri",
                        "-1": "\xe1 s\xed\xf0asta \xe1ri"
                    },
                    relativeTime: {
                        future: {
                            one: "eftir {0} \xe1r",
                            other: "eftir {0} \xe1r"
                        },
                        past: {
                            one: "fyrir {0} \xe1ri",
                            other: "fyrir {0} \xe1rum"
                        }
                    }
                },
                month: {
                    displayName: "m\xe1nu\xf0ur",
                    relative: {
                        0: "\xed \xfeessum m\xe1nu\xf0i",
                        1: "\xed n\xe6sta m\xe1nu\xf0i",
                        "-1": "\xed s\xed\xf0asta m\xe1nu\xf0i"
                    },
                    relativeTime: {
                        future: {
                            one: "eftir {0} m\xe1nu\xf0",
                            other: "eftir {0} m\xe1nu\xf0i"
                        },
                        past: {
                            one: "fyrir {0} m\xe1nu\xf0i",
                            other: "fyrir {0} m\xe1nu\xf0um"
                        }
                    }
                },
                day: {
                    displayName: "dagur",
                    relative: {
                        0: "\xed dag",
                        1: "\xe1 morgun",
                        2: "eftir tvo daga",
                        "-2": "\xed fyrradag",
                        "-1": "\xed g\xe6r"
                    },
                    relativeTime: {
                        future: {
                            one: "eftir {0} dag",
                            other: "eftir {0} daga"
                        },
                        past: {
                            one: "fyrir {0} degi",
                            other: "fyrir {0} d\xf6gum"
                        }
                    }
                },
                hour: {
                    displayName: "klukkustund",
                    relative: {
                        0: "this hour"
                    },
                    relativeTime: {
                        future: {
                            one: "eftir {0} klukkustund",
                            other: "eftir {0} klukkustundir"
                        },
                        past: {
                            one: "fyrir {0} klukkustund",
                            other: "fyrir {0} klukkustundum"
                        }
                    }
                },
                minute: {
                    displayName: "m\xedn\xfata",
                    relative: {
                        0: "this minute"
                    },
                    relativeTime: {
                        future: {
                            one: "eftir {0} m\xedn\xfatu",
                            other: "eftir {0} m\xedn\xfatur"
                        },
                        past: {
                            one: "fyrir {0} m\xedn\xfatu",
                            other: "fyrir {0} m\xedn\xfatum"
                        }
                    }
                },
                second: {
                    displayName: "sek\xfanda",
                    relative: {
                        0: "n\xfana"
                    },
                    relativeTime: {
                        future: {
                            one: "eftir {0} sek\xfandu",
                            other: "eftir {0} sek\xfandur"
                        },
                        past: {
                            one: "fyrir {0} sek\xfandu",
                            other: "fyrir {0} sek\xfandum"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("dKwjV", function(module, exports) {
!function(e, o) {
    module.exports = o();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "it",
            pluralRuleFunction: function(e, o) {
                var t = !String(e).split(".")[1];
                return o ? 11 == e || 8 == e || 80 == e || 800 == e ? "many" : "other" : 1 == e && t ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "anno",
                    relative: {
                        0: "quest\u2019anno",
                        1: "anno prossimo",
                        "-1": "anno scorso"
                    },
                    relativeTime: {
                        future: {
                            one: "tra {0} anno",
                            other: "tra {0} anni"
                        },
                        past: {
                            one: "{0} anno fa",
                            other: "{0} anni fa"
                        }
                    }
                },
                month: {
                    displayName: "mese",
                    relative: {
                        0: "questo mese",
                        1: "mese prossimo",
                        "-1": "mese scorso"
                    },
                    relativeTime: {
                        future: {
                            one: "tra {0} mese",
                            other: "tra {0} mesi"
                        },
                        past: {
                            one: "{0} mese fa",
                            other: "{0} mesi fa"
                        }
                    }
                },
                day: {
                    displayName: "giorno",
                    relative: {
                        0: "oggi",
                        1: "domani",
                        2: "dopodomani",
                        "-2": "l\u2019altro ieri",
                        "-1": "ieri"
                    },
                    relativeTime: {
                        future: {
                            one: "tra {0} giorno",
                            other: "tra {0} giorni"
                        },
                        past: {
                            one: "{0} giorno fa",
                            other: "{0} giorni fa"
                        }
                    }
                },
                hour: {
                    displayName: "ora",
                    relative: {
                        0: "quest\u2019ora"
                    },
                    relativeTime: {
                        future: {
                            one: "tra {0} ora",
                            other: "tra {0} ore"
                        },
                        past: {
                            one: "{0} ora fa",
                            other: "{0} ore fa"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "questo minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "tra {0} minuto",
                            other: "tra {0} minuti"
                        },
                        past: {
                            one: "{0} minuto fa",
                            other: "{0} minuti fa"
                        }
                    }
                },
                second: {
                    displayName: "secondo",
                    relative: {
                        0: "ora"
                    },
                    relativeTime: {
                        future: {
                            one: "tra {0} secondo",
                            other: "tra {0} secondi"
                        },
                        past: {
                            one: "{0} secondo fa",
                            other: "{0} secondi fa"
                        }
                    }
                }
            }
        },
        {
            locale: "it-CH",
            parentLocale: "it"
        },
        {
            locale: "it-SM",
            parentLocale: "it"
        },
        {
            locale: "it-VA",
            parentLocale: "it"
        }
    ];
});

});

parcelRegister("cK3pM", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "ja",
            pluralRuleFunction: function(e, t) {
                return "other";
            },
            fields: {
                year: {
                    displayName: "\u5E74",
                    relative: {
                        0: "\u4ECA\u5E74",
                        1: "\u7FCC\u5E74",
                        "-1": "\u6628\u5E74"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u5E74\u5F8C"
                        },
                        past: {
                            other: "{0} \u5E74\u524D"
                        }
                    }
                },
                month: {
                    displayName: "\u6708",
                    relative: {
                        0: "\u4ECA\u6708",
                        1: "\u7FCC\u6708",
                        "-1": "\u5148\u6708"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u304B\u6708\u5F8C"
                        },
                        past: {
                            other: "{0} \u304B\u6708\u524D"
                        }
                    }
                },
                day: {
                    displayName: "\u65E5",
                    relative: {
                        0: "\u4ECA\u65E5",
                        1: "\u660E\u65E5",
                        2: "\u660E\u5F8C\u65E5",
                        "-2": "\u4E00\u6628\u65E5",
                        "-1": "\u6628\u65E5"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u65E5\u5F8C"
                        },
                        past: {
                            other: "{0} \u65E5\u524D"
                        }
                    }
                },
                hour: {
                    displayName: "\u6642",
                    relative: {
                        0: "1 \u6642\u9593\u4EE5\u5185"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u6642\u9593\u5F8C"
                        },
                        past: {
                            other: "{0} \u6642\u9593\u524D"
                        }
                    }
                },
                minute: {
                    displayName: "\u5206",
                    relative: {
                        0: "1 \u5206\u4EE5\u5185"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u5206\u5F8C"
                        },
                        past: {
                            other: "{0} \u5206\u524D"
                        }
                    }
                },
                second: {
                    displayName: "\u79D2",
                    relative: {
                        0: "\u4ECA"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u79D2\u5F8C"
                        },
                        past: {
                            other: "{0} \u79D2\u524D"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("hw6Dp", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "ko",
            pluralRuleFunction: function(e, t) {
                return "other";
            },
            fields: {
                year: {
                    displayName: "\uB144",
                    relative: {
                        0: "\uC62C\uD574",
                        1: "\uB0B4\uB144",
                        "-1": "\uC791\uB144"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\uB144 \uD6C4"
                        },
                        past: {
                            other: "{0}\uB144 \uC804"
                        }
                    }
                },
                month: {
                    displayName: "\uC6D4",
                    relative: {
                        0: "\uC774\uBC88 \uB2EC",
                        1: "\uB2E4\uC74C \uB2EC",
                        "-1": "\uC9C0\uB09C\uB2EC"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\uAC1C\uC6D4 \uD6C4"
                        },
                        past: {
                            other: "{0}\uAC1C\uC6D4 \uC804"
                        }
                    }
                },
                day: {
                    displayName: "\uC77C",
                    relative: {
                        0: "\uC624\uB298",
                        1: "\uB0B4\uC77C",
                        2: "\uBAA8\uB808",
                        "-2": "\uADF8\uC800\uAED8",
                        "-1": "\uC5B4\uC81C"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\uC77C \uD6C4"
                        },
                        past: {
                            other: "{0}\uC77C \uC804"
                        }
                    }
                },
                hour: {
                    displayName: "\uC2DC",
                    relative: {
                        0: "\uD604\uC7AC \uC2DC\uAC04"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\uC2DC\uAC04 \uD6C4"
                        },
                        past: {
                            other: "{0}\uC2DC\uAC04 \uC804"
                        }
                    }
                },
                minute: {
                    displayName: "\uBD84",
                    relative: {
                        0: "\uD604\uC7AC \uBD84"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\uBD84 \uD6C4"
                        },
                        past: {
                            other: "{0}\uBD84 \uC804"
                        }
                    }
                },
                second: {
                    displayName: "\uCD08",
                    relative: {
                        0: "\uC9C0\uAE08"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\uCD08 \uD6C4"
                        },
                        past: {
                            other: "{0}\uCD08 \uC804"
                        }
                    }
                }
            }
        },
        {
            locale: "ko-KP",
            parentLocale: "ko"
        }
    ];
});

});

parcelRegister("eGGw0", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "nl",
            pluralRuleFunction: function(e, n) {
                var a = !String(e).split(".")[1];
                return n ? "other" : 1 == e && a ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "jaar",
                    relative: {
                        0: "dit jaar",
                        1: "volgend jaar",
                        "-1": "vorig jaar"
                    },
                    relativeTime: {
                        future: {
                            one: "over {0} jaar",
                            other: "over {0} jaar"
                        },
                        past: {
                            one: "{0} jaar geleden",
                            other: "{0} jaar geleden"
                        }
                    }
                },
                month: {
                    displayName: "maand",
                    relative: {
                        0: "deze maand",
                        1: "volgende maand",
                        "-1": "vorige maand"
                    },
                    relativeTime: {
                        future: {
                            one: "over {0} maand",
                            other: "over {0} maanden"
                        },
                        past: {
                            one: "{0} maand geleden",
                            other: "{0} maanden geleden"
                        }
                    }
                },
                day: {
                    displayName: "dag",
                    relative: {
                        0: "vandaag",
                        1: "morgen",
                        2: "overmorgen",
                        "-2": "eergisteren",
                        "-1": "gisteren"
                    },
                    relativeTime: {
                        future: {
                            one: "over {0} dag",
                            other: "over {0} dagen"
                        },
                        past: {
                            one: "{0} dag geleden",
                            other: "{0} dagen geleden"
                        }
                    }
                },
                hour: {
                    displayName: "uur",
                    relative: {
                        0: "binnen een uur"
                    },
                    relativeTime: {
                        future: {
                            one: "over {0} uur",
                            other: "over {0} uur"
                        },
                        past: {
                            one: "{0} uur geleden",
                            other: "{0} uur geleden"
                        }
                    }
                },
                minute: {
                    displayName: "minuut",
                    relative: {
                        0: "binnen een minuut"
                    },
                    relativeTime: {
                        future: {
                            one: "over {0} minuut",
                            other: "over {0} minuten"
                        },
                        past: {
                            one: "{0} minuut geleden",
                            other: "{0} minuten geleden"
                        }
                    }
                },
                second: {
                    displayName: "seconde",
                    relative: {
                        0: "nu"
                    },
                    relativeTime: {
                        future: {
                            one: "over {0} seconde",
                            other: "over {0} seconden"
                        },
                        past: {
                            one: "{0} seconde geleden",
                            other: "{0} seconden geleden"
                        }
                    }
                }
            }
        },
        {
            locale: "nl-AW",
            parentLocale: "nl"
        },
        {
            locale: "nl-BE",
            parentLocale: "nl"
        },
        {
            locale: "nl-BQ",
            parentLocale: "nl"
        },
        {
            locale: "nl-CW",
            parentLocale: "nl"
        },
        {
            locale: "nl-SR",
            parentLocale: "nl"
        },
        {
            locale: "nl-SX",
            parentLocale: "nl"
        }
    ];
});

});

parcelRegister("eHiOh", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "no",
            pluralRuleFunction: function(e, t) {
                return t ? "other" : 1 == e ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "Year",
                    relative: {
                        0: "this year",
                        1: "next year",
                        "-1": "last year"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} y"
                        },
                        past: {
                            other: "-{0} y"
                        }
                    }
                },
                month: {
                    displayName: "Month",
                    relative: {
                        0: "this month",
                        1: "next month",
                        "-1": "last month"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} m"
                        },
                        past: {
                            other: "-{0} m"
                        }
                    }
                },
                day: {
                    displayName: "Day",
                    relative: {
                        0: "today",
                        1: "tomorrow",
                        "-1": "yesterday"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} d"
                        },
                        past: {
                            other: "-{0} d"
                        }
                    }
                },
                hour: {
                    displayName: "Hour",
                    relative: {
                        0: "this hour"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} h"
                        },
                        past: {
                            other: "-{0} h"
                        }
                    }
                },
                minute: {
                    displayName: "Minute",
                    relative: {
                        0: "this minute"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} min"
                        },
                        past: {
                            other: "-{0} min"
                        }
                    }
                },
                second: {
                    displayName: "Second",
                    relative: {
                        0: "now"
                    },
                    relativeTime: {
                        future: {
                            other: "+{0} s"
                        },
                        past: {
                            other: "-{0} s"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("gbpk6", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "pl",
            pluralRuleFunction: function(e, t) {
                var a = String(e).split("."), i = a[0], n = !a[1], m = i.slice(-1), u = i.slice(-2);
                return t ? "other" : 1 == e && n ? "one" : n && m >= 2 && m <= 4 && (u < 12 || u > 14) ? "few" : n && 1 != i && (0 == m || 1 == m) || n && m >= 5 && m <= 9 || n && u >= 12 && u <= 14 ? "many" : "other";
            },
            fields: {
                year: {
                    displayName: "rok",
                    relative: {
                        0: "w tym roku",
                        1: "w przysz\u0142ym roku",
                        "-1": "w zesz\u0142ym roku"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} rok",
                            few: "za {0} lata",
                            many: "za {0} lat",
                            other: "za {0} roku"
                        },
                        past: {
                            one: "{0} rok temu",
                            few: "{0} lata temu",
                            many: "{0} lat temu",
                            other: "{0} roku temu"
                        }
                    }
                },
                month: {
                    displayName: "miesi\u0105c",
                    relative: {
                        0: "w tym miesi\u0105cu",
                        1: "w przysz\u0142ym miesi\u0105cu",
                        "-1": "w zesz\u0142ym miesi\u0105cu"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} miesi\u0105c",
                            few: "za {0} miesi\u0105ce",
                            many: "za {0} miesi\u0119cy",
                            other: "za {0} miesi\u0105ca"
                        },
                        past: {
                            one: "{0} miesi\u0105c temu",
                            few: "{0} miesi\u0105ce temu",
                            many: "{0} miesi\u0119cy temu",
                            other: "{0} miesi\u0105ca temu"
                        }
                    }
                },
                day: {
                    displayName: "dzie\u0144",
                    relative: {
                        0: "dzisiaj",
                        1: "jutro",
                        2: "pojutrze",
                        "-2": "przedwczoraj",
                        "-1": "wczoraj"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} dzie\u0144",
                            few: "za {0} dni",
                            many: "za {0} dni",
                            other: "za {0} dnia"
                        },
                        past: {
                            one: "{0} dzie\u0144 temu",
                            few: "{0} dni temu",
                            many: "{0} dni temu",
                            other: "{0} dnia temu"
                        }
                    }
                },
                hour: {
                    displayName: "godzina",
                    relative: {
                        0: "ta godzina"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} godzin\u0119",
                            few: "za {0} godziny",
                            many: "za {0} godzin",
                            other: "za {0} godziny"
                        },
                        past: {
                            one: "{0} godzin\u0119 temu",
                            few: "{0} godziny temu",
                            many: "{0} godzin temu",
                            other: "{0} godziny temu"
                        }
                    }
                },
                minute: {
                    displayName: "minuta",
                    relative: {
                        0: "ta minuta"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} minut\u0119",
                            few: "za {0} minuty",
                            many: "za {0} minut",
                            other: "za {0} minuty"
                        },
                        past: {
                            one: "{0} minut\u0119 temu",
                            few: "{0} minuty temu",
                            many: "{0} minut temu",
                            other: "{0} minuty temu"
                        }
                    }
                },
                second: {
                    displayName: "sekunda",
                    relative: {
                        0: "teraz"
                    },
                    relativeTime: {
                        future: {
                            one: "za {0} sekund\u0119",
                            few: "za {0} sekundy",
                            many: "za {0} sekund",
                            other: "za {0} sekundy"
                        },
                        past: {
                            one: "{0} sekund\u0119 temu",
                            few: "{0} sekundy temu",
                            many: "{0} sekund temu",
                            other: "{0} sekundy temu"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("iHUyH", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "pt",
            pluralRuleFunction: function(e, t) {
                var o = String(e).split(".")[0];
                return t ? "other" : 0 == o || 1 == o ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "ano",
                    relative: {
                        0: "este ano",
                        1: "pr\xf3ximo ano",
                        "-1": "ano passado"
                    },
                    relativeTime: {
                        future: {
                            one: "em {0} ano",
                            other: "em {0} anos"
                        },
                        past: {
                            one: "h\xe1 {0} ano",
                            other: "h\xe1 {0} anos"
                        }
                    }
                },
                month: {
                    displayName: "m\xeas",
                    relative: {
                        0: "este m\xeas",
                        1: "pr\xf3ximo m\xeas",
                        "-1": "m\xeas passado"
                    },
                    relativeTime: {
                        future: {
                            one: "em {0} m\xeas",
                            other: "em {0} meses"
                        },
                        past: {
                            one: "h\xe1 {0} m\xeas",
                            other: "h\xe1 {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "dia",
                    relative: {
                        0: "hoje",
                        1: "amanh\xe3",
                        2: "depois de amanh\xe3",
                        "-2": "anteontem",
                        "-1": "ontem"
                    },
                    relativeTime: {
                        future: {
                            one: "em {0} dia",
                            other: "em {0} dias"
                        },
                        past: {
                            one: "h\xe1 {0} dia",
                            other: "h\xe1 {0} dias"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "em {0} hora",
                            other: "em {0} horas"
                        },
                        past: {
                            one: "h\xe1 {0} hora",
                            other: "h\xe1 {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "em {0} minuto",
                            other: "em {0} minutos"
                        },
                        past: {
                            one: "h\xe1 {0} minuto",
                            other: "h\xe1 {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "agora"
                    },
                    relativeTime: {
                        future: {
                            one: "em {0} segundo",
                            other: "em {0} segundos"
                        },
                        past: {
                            one: "h\xe1 {0} segundo",
                            other: "h\xe1 {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "pt-AO",
            parentLocale: "pt-PT"
        },
        {
            locale: "pt-PT",
            parentLocale: "pt",
            fields: {
                year: {
                    displayName: "ano",
                    relative: {
                        0: "este ano",
                        1: "pr\xf3ximo ano",
                        "-1": "ano passado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} ano",
                            other: "dentro de {0} anos"
                        },
                        past: {
                            one: "h\xe1 {0} ano",
                            other: "h\xe1 {0} anos"
                        }
                    }
                },
                month: {
                    displayName: "m\xeas",
                    relative: {
                        0: "este m\xeas",
                        1: "pr\xf3ximo m\xeas",
                        "-1": "m\xeas passado"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} m\xeas",
                            other: "dentro de {0} meses"
                        },
                        past: {
                            one: "h\xe1 {0} m\xeas",
                            other: "h\xe1 {0} meses"
                        }
                    }
                },
                day: {
                    displayName: "dia",
                    relative: {
                        0: "hoje",
                        1: "amanh\xe3",
                        2: "depois de amanh\xe3",
                        "-2": "anteontem",
                        "-1": "ontem"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} dia",
                            other: "dentro de {0} dias"
                        },
                        past: {
                            one: "h\xe1 {0} dia",
                            other: "h\xe1 {0} dias"
                        }
                    }
                },
                hour: {
                    displayName: "hora",
                    relative: {
                        0: "esta hora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} hora",
                            other: "dentro de {0} horas"
                        },
                        past: {
                            one: "h\xe1 {0} hora",
                            other: "h\xe1 {0} horas"
                        }
                    }
                },
                minute: {
                    displayName: "minuto",
                    relative: {
                        0: "este minuto"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} minuto",
                            other: "dentro de {0} minutos"
                        },
                        past: {
                            one: "h\xe1 {0} minuto",
                            other: "h\xe1 {0} minutos"
                        }
                    }
                },
                second: {
                    displayName: "segundo",
                    relative: {
                        0: "agora"
                    },
                    relativeTime: {
                        future: {
                            one: "dentro de {0} segundo",
                            other: "dentro de {0} segundos"
                        },
                        past: {
                            one: "h\xe1 {0} segundo",
                            other: "h\xe1 {0} segundos"
                        }
                    }
                }
            }
        },
        {
            locale: "pt-CH",
            parentLocale: "pt-PT"
        },
        {
            locale: "pt-CV",
            parentLocale: "pt-PT"
        },
        {
            locale: "pt-GQ",
            parentLocale: "pt-PT"
        },
        {
            locale: "pt-GW",
            parentLocale: "pt-PT"
        },
        {
            locale: "pt-LU",
            parentLocale: "pt-PT"
        },
        {
            locale: "pt-MO",
            parentLocale: "pt-PT"
        },
        {
            locale: "pt-MZ",
            parentLocale: "pt-PT"
        },
        {
            locale: "pt-ST",
            parentLocale: "pt-PT"
        },
        {
            locale: "pt-TL",
            parentLocale: "pt-PT"
        }
    ];
});

});

parcelRegister("h3wzN", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "ro",
            pluralRuleFunction: function(e, t) {
                var a = String(e).split("."), u = !a[1], n = Number(a[0]) == e && a[0].slice(-2);
                return t ? 1 == e ? "one" : "other" : 1 == e && u ? "one" : !u || 0 == e || 1 != e && n >= 1 && n <= 19 ? "few" : "other";
            },
            fields: {
                year: {
                    displayName: "an",
                    relative: {
                        0: "anul acesta",
                        1: "anul viitor",
                        "-1": "anul trecut"
                    },
                    relativeTime: {
                        future: {
                            one: "peste {0} an",
                            few: "peste {0} ani",
                            other: "peste {0} de ani"
                        },
                        past: {
                            one: "acum {0} an",
                            few: "acum {0} ani",
                            other: "acum {0} de ani"
                        }
                    }
                },
                month: {
                    displayName: "lun\u0103",
                    relative: {
                        0: "luna aceasta",
                        1: "luna viitoare",
                        "-1": "luna trecut\u0103"
                    },
                    relativeTime: {
                        future: {
                            one: "peste {0} lun\u0103",
                            few: "peste {0} luni",
                            other: "peste {0} de luni"
                        },
                        past: {
                            one: "acum {0} lun\u0103",
                            few: "acum {0} luni",
                            other: "acum {0} de luni"
                        }
                    }
                },
                day: {
                    displayName: "zi",
                    relative: {
                        0: "azi",
                        1: "m\xe2ine",
                        2: "poim\xe2ine",
                        "-2": "alalt\u0103ieri",
                        "-1": "ieri"
                    },
                    relativeTime: {
                        future: {
                            one: "peste {0} zi",
                            few: "peste {0} zile",
                            other: "peste {0} de zile"
                        },
                        past: {
                            one: "acum {0} zi",
                            few: "acum {0} zile",
                            other: "acum {0} de zile"
                        }
                    }
                },
                hour: {
                    displayName: "or\u0103",
                    relative: {
                        0: "ora aceasta"
                    },
                    relativeTime: {
                        future: {
                            one: "peste {0} or\u0103",
                            few: "peste {0} ore",
                            other: "peste {0} de ore"
                        },
                        past: {
                            one: "acum {0} or\u0103",
                            few: "acum {0} ore",
                            other: "acum {0} de ore"
                        }
                    }
                },
                minute: {
                    displayName: "minut",
                    relative: {
                        0: "minutul acesta"
                    },
                    relativeTime: {
                        future: {
                            one: "peste {0} minut",
                            few: "peste {0} minute",
                            other: "peste {0} de minute"
                        },
                        past: {
                            one: "acum {0} minut",
                            few: "acum {0} minute",
                            other: "acum {0} de minute"
                        }
                    }
                },
                second: {
                    displayName: "secund\u0103",
                    relative: {
                        0: "acum"
                    },
                    relativeTime: {
                        future: {
                            one: "peste {0} secund\u0103",
                            few: "peste {0} secunde",
                            other: "peste {0} de secunde"
                        },
                        past: {
                            one: "acum {0} secund\u0103",
                            few: "acum {0} secunde",
                            other: "acum {0} de secunde"
                        }
                    }
                }
            }
        },
        {
            locale: "ro-MD",
            parentLocale: "ro"
        }
    ];
});

});

parcelRegister("5oNvS", function(module, exports) {
!function(e, a) {
    module.exports = a();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "ru",
            pluralRuleFunction: function(e, a) {
                var t = String(e).split("."), r = t[0], o = !t[1], n = r.slice(-1), l = r.slice(-2);
                return a ? "other" : o && 1 == n && 11 != l ? "one" : o && n >= 2 && n <= 4 && (l < 12 || l > 14) ? "few" : o && 0 == n || o && n >= 5 && n <= 9 || o && l >= 11 && l <= 14 ? "many" : "other";
            },
            fields: {
                year: {
                    displayName: "\u0433\u043E\u0434",
                    relative: {
                        0: "\u0432 \u044D\u0442\u043E\u043C \u0433\u043E\u0434\u0443",
                        1: "\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0433\u043E\u0434\u0443",
                        "-1": "\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u0433\u043E\u0434\u0443"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u0433\u043E\u0434",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u0433\u043E\u0434\u0430",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u043B\u0435\u0442",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u0433\u043E\u0434\u0430"
                        },
                        past: {
                            one: "{0} \u0433\u043E\u0434 \u043D\u0430\u0437\u0430\u0434",
                            few: "{0} \u0433\u043E\u0434\u0430 \u043D\u0430\u0437\u0430\u0434",
                            many: "{0} \u043B\u0435\u0442 \u043D\u0430\u0437\u0430\u0434",
                            other: "{0} \u0433\u043E\u0434\u0430 \u043D\u0430\u0437\u0430\u0434"
                        }
                    }
                },
                month: {
                    displayName: "\u043C\u0435\u0441\u044F\u0446",
                    relative: {
                        0: "\u0432 \u044D\u0442\u043E\u043C \u043C\u0435\u0441\u044F\u0446\u0435",
                        1: "\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u043C\u0435\u0441\u044F\u0446\u0435",
                        "-1": "\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C \u043C\u0435\u0441\u044F\u0446\u0435"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0435\u0441\u044F\u0446",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0435\u0441\u044F\u0446\u0430",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0435\u0441\u044F\u0446\u0430"
                        },
                        past: {
                            one: "{0} \u043C\u0435\u0441\u044F\u0446 \u043D\u0430\u0437\u0430\u0434",
                            few: "{0} \u043C\u0435\u0441\u044F\u0446\u0430 \u043D\u0430\u0437\u0430\u0434",
                            many: "{0} \u043C\u0435\u0441\u044F\u0446\u0435\u0432 \u043D\u0430\u0437\u0430\u0434",
                            other: "{0} \u043C\u0435\u0441\u044F\u0446\u0430 \u043D\u0430\u0437\u0430\u0434"
                        }
                    }
                },
                day: {
                    displayName: "\u0434\u0435\u043D\u044C",
                    relative: {
                        0: "\u0441\u0435\u0433\u043E\u0434\u043D\u044F",
                        1: "\u0437\u0430\u0432\u0442\u0440\u0430",
                        2: "\u043F\u043E\u0441\u043B\u0435\u0437\u0430\u0432\u0442\u0440\u0430",
                        "-2": "\u043F\u043E\u0437\u0430\u0432\u0447\u0435\u0440\u0430",
                        "-1": "\u0432\u0447\u0435\u0440\u0430"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u0434\u0435\u043D\u044C",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u0434\u043D\u044F",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u0434\u043D\u0435\u0439",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u0434\u043D\u044F"
                        },
                        past: {
                            one: "{0} \u0434\u0435\u043D\u044C \u043D\u0430\u0437\u0430\u0434",
                            few: "{0} \u0434\u043D\u044F \u043D\u0430\u0437\u0430\u0434",
                            many: "{0} \u0434\u043D\u0435\u0439 \u043D\u0430\u0437\u0430\u0434",
                            other: "{0} \u0434\u043D\u044F \u043D\u0430\u0437\u0430\u0434"
                        }
                    }
                },
                hour: {
                    displayName: "\u0447\u0430\u0441",
                    relative: {
                        0: "\u0432 \u044D\u0442\u043E\u043C \u0447\u0430\u0441\u0435"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u0447\u0430\u0441",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u0447\u0430\u0441\u0430",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u0447\u0430\u0441\u043E\u0432",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u0447\u0430\u0441\u0430"
                        },
                        past: {
                            one: "{0} \u0447\u0430\u0441 \u043D\u0430\u0437\u0430\u0434",
                            few: "{0} \u0447\u0430\u0441\u0430 \u043D\u0430\u0437\u0430\u0434",
                            many: "{0} \u0447\u0430\u0441\u043E\u0432 \u043D\u0430\u0437\u0430\u0434",
                            other: "{0} \u0447\u0430\u0441\u0430 \u043D\u0430\u0437\u0430\u0434"
                        }
                    }
                },
                minute: {
                    displayName: "\u043C\u0438\u043D\u0443\u0442\u0430",
                    relative: {
                        0: "\u0432 \u044D\u0442\u0443 \u043C\u0438\u043D\u0443\u0442\u0443"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0438\u043D\u0443\u0442\u0443",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0438\u043D\u0443\u0442\u044B",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0438\u043D\u0443\u0442",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0438\u043D\u0443\u0442\u044B"
                        },
                        past: {
                            one: "{0} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
                            few: "{0} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
                            many: "{0} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434",
                            other: "{0} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434"
                        }
                    }
                },
                second: {
                    displayName: "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
                    relative: {
                        0: "\u0441\u0435\u0439\u0447\u0430\u0441"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u0441\u0435\u043A\u0443\u043D\u0434",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u0441\u0435\u043A\u0443\u043D\u0434\u044B"
                        },
                        past: {
                            one: "{0} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
                            few: "{0} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
                            many: "{0} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434",
                            other: "{0} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434"
                        }
                    }
                }
            }
        },
        {
            locale: "ru-BY",
            parentLocale: "ru"
        },
        {
            locale: "ru-KG",
            parentLocale: "ru"
        },
        {
            locale: "ru-KZ",
            parentLocale: "ru"
        },
        {
            locale: "ru-MD",
            parentLocale: "ru"
        },
        {
            locale: "ru-UA",
            parentLocale: "ru"
        }
    ];
});

});

parcelRegister("efPbP", function(module, exports) {
!function(e, o) {
    module.exports = o();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "sk",
            pluralRuleFunction: function(e, o) {
                var a = String(e).split("."), t = a[0], i = !a[1];
                return o ? "other" : 1 == e && i ? "one" : t >= 2 && t <= 4 && i ? "few" : i ? "other" : "many";
            },
            fields: {
                year: {
                    displayName: "rok",
                    relative: {
                        0: "tento rok",
                        1: "bud\xfaci rok",
                        "-1": "minul\xfd rok"
                    },
                    relativeTime: {
                        future: {
                            one: "o {0} rok",
                            few: "o {0} roky",
                            many: "o {0} roka",
                            other: "o {0} rokov"
                        },
                        past: {
                            one: "pred {0} rokom",
                            few: "pred {0} rokmi",
                            many: "pred {0} roka",
                            other: "pred {0} rokmi"
                        }
                    }
                },
                month: {
                    displayName: "mesiac",
                    relative: {
                        0: "tento mesiac",
                        1: "bud\xfaci mesiac",
                        "-1": "minul\xfd mesiac"
                    },
                    relativeTime: {
                        future: {
                            one: "o {0} mesiac",
                            few: "o {0} mesiace",
                            many: "o {0} mesiaca",
                            other: "o {0} mesiacov"
                        },
                        past: {
                            one: "pred {0} mesiacom",
                            few: "pred {0} mesiacmi",
                            many: "pred {0} mesiaca",
                            other: "pred {0} mesiacmi"
                        }
                    }
                },
                day: {
                    displayName: "de\u0148",
                    relative: {
                        0: "dnes",
                        1: "zajtra",
                        2: "pozajtra",
                        "-2": "predv\u010Derom",
                        "-1": "v\u010Dera"
                    },
                    relativeTime: {
                        future: {
                            one: "o {0} de\u0148",
                            few: "o {0} dni",
                            many: "o {0} d\u0148a",
                            other: "o {0} dn\xed"
                        },
                        past: {
                            one: "pred {0} d\u0148om",
                            few: "pred {0} d\u0148ami",
                            many: "pred {0} d\u0148a",
                            other: "pred {0} d\u0148ami"
                        }
                    }
                },
                hour: {
                    displayName: "hodina",
                    relative: {
                        0: "v tejto hodine"
                    },
                    relativeTime: {
                        future: {
                            one: "o {0} hodinu",
                            few: "o {0} hodiny",
                            many: "o {0} hodiny",
                            other: "o {0} hod\xedn"
                        },
                        past: {
                            one: "pred {0} hodinou",
                            few: "pred {0} hodinami",
                            many: "pred {0} hodinou",
                            other: "pred {0} hodinami"
                        }
                    }
                },
                minute: {
                    displayName: "min\xfata",
                    relative: {
                        0: "v tejto min\xfate"
                    },
                    relativeTime: {
                        future: {
                            one: "o {0} min\xfatu",
                            few: "o {0} min\xfaty",
                            many: "o {0} min\xfaty",
                            other: "o {0} min\xfat"
                        },
                        past: {
                            one: "pred {0} min\xfatou",
                            few: "pred {0} min\xfatami",
                            many: "pred {0} min\xfaty",
                            other: "pred {0} min\xfatami"
                        }
                    }
                },
                second: {
                    displayName: "sekunda",
                    relative: {
                        0: "teraz"
                    },
                    relativeTime: {
                        future: {
                            one: "o {0} sekundu",
                            few: "o {0} sekundy",
                            many: "o {0} sekundy",
                            other: "o {0} sek\xfand"
                        },
                        past: {
                            one: "pred {0} sekundou",
                            few: "pred {0} sekundami",
                            many: "pred {0} sekundy",
                            other: "pred {0} sekundami"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("QQTQn", function(module, exports) {
!function(e, a) {
    module.exports = a();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "sv",
            pluralRuleFunction: function(e, a) {
                var r = String(e).split("."), n = !r[1], t = Number(r[0]) == e, o = t && r[0].slice(-1), i = t && r[0].slice(-2);
                return a ? 1 != o && 2 != o || 11 == i || 12 == i ? "other" : "one" : 1 == e && n ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "\xe5r",
                    relative: {
                        0: "i \xe5r",
                        1: "n\xe4sta \xe5r",
                        "-1": "i fjol"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} \xe5r",
                            other: "om {0} \xe5r"
                        },
                        past: {
                            one: "f\xf6r {0} \xe5r sedan",
                            other: "f\xf6r {0} \xe5r sedan"
                        }
                    }
                },
                month: {
                    displayName: "m\xe5nad",
                    relative: {
                        0: "denna m\xe5nad",
                        1: "n\xe4sta m\xe5nad",
                        "-1": "f\xf6rra m\xe5naden"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} m\xe5nad",
                            other: "om {0} m\xe5nader"
                        },
                        past: {
                            one: "f\xf6r {0} m\xe5nad sedan",
                            other: "f\xf6r {0} m\xe5nader sedan"
                        }
                    }
                },
                day: {
                    displayName: "dag",
                    relative: {
                        0: "i dag",
                        1: "i morgon",
                        2: "i \xf6vermorgon",
                        "-2": "i f\xf6rrg\xe5r",
                        "-1": "i g\xe5r"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} dag",
                            other: "om {0} dagar"
                        },
                        past: {
                            one: "f\xf6r {0} dag sedan",
                            other: "f\xf6r {0} dagar sedan"
                        }
                    }
                },
                hour: {
                    displayName: "timme",
                    relative: {
                        0: "denna timme"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} timme",
                            other: "om {0} timmar"
                        },
                        past: {
                            one: "f\xf6r {0} timme sedan",
                            other: "f\xf6r {0} timmar sedan"
                        }
                    }
                },
                minute: {
                    displayName: "minut",
                    relative: {
                        0: "denna minut"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} minut",
                            other: "om {0} minuter"
                        },
                        past: {
                            one: "f\xf6r {0} minut sedan",
                            other: "f\xf6r {0} minuter sedan"
                        }
                    }
                },
                second: {
                    displayName: "sekund",
                    relative: {
                        0: "nu"
                    },
                    relativeTime: {
                        future: {
                            one: "om {0} sekund",
                            other: "om {0} sekunder"
                        },
                        past: {
                            one: "f\xf6r {0} sekund sedan",
                            other: "f\xf6r {0} sekunder sedan"
                        }
                    }
                }
            }
        },
        {
            locale: "sv-AX",
            parentLocale: "sv"
        },
        {
            locale: "sv-FI",
            parentLocale: "sv"
        }
    ];
});

});

parcelRegister("3Bkhv", function(module, exports) {
!function(e, a) {
    module.exports = a();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "tr",
            pluralRuleFunction: function(e, a) {
                return a ? "other" : 1 == e ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "y\u0131l",
                    relative: {
                        0: "bu y\u0131l",
                        1: "gelecek y\u0131l",
                        "-1": "ge\xe7en y\u0131l"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} y\u0131l sonra",
                            other: "{0} y\u0131l sonra"
                        },
                        past: {
                            one: "{0} y\u0131l \xf6nce",
                            other: "{0} y\u0131l \xf6nce"
                        }
                    }
                },
                month: {
                    displayName: "ay",
                    relative: {
                        0: "bu ay",
                        1: "gelecek ay",
                        "-1": "ge\xe7en ay"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} ay sonra",
                            other: "{0} ay sonra"
                        },
                        past: {
                            one: "{0} ay \xf6nce",
                            other: "{0} ay \xf6nce"
                        }
                    }
                },
                day: {
                    displayName: "g\xfcn",
                    relative: {
                        0: "bug\xfcn",
                        1: "yar\u0131n",
                        2: "\xf6b\xfcr g\xfcn",
                        "-2": "evvelsi g\xfcn",
                        "-1": "d\xfcn"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} g\xfcn sonra",
                            other: "{0} g\xfcn sonra"
                        },
                        past: {
                            one: "{0} g\xfcn \xf6nce",
                            other: "{0} g\xfcn \xf6nce"
                        }
                    }
                },
                hour: {
                    displayName: "saat",
                    relative: {
                        0: "bu saat"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} saat sonra",
                            other: "{0} saat sonra"
                        },
                        past: {
                            one: "{0} saat \xf6nce",
                            other: "{0} saat \xf6nce"
                        }
                    }
                },
                minute: {
                    displayName: "dakika",
                    relative: {
                        0: "bu dakika"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} dakika sonra",
                            other: "{0} dakika sonra"
                        },
                        past: {
                            one: "{0} dakika \xf6nce",
                            other: "{0} dakika \xf6nce"
                        }
                    }
                },
                second: {
                    displayName: "saniye",
                    relative: {
                        0: "\u015Fimdi"
                    },
                    relativeTime: {
                        future: {
                            one: "{0} saniye sonra",
                            other: "{0} saniye sonra"
                        },
                        past: {
                            one: "{0} saniye \xf6nce",
                            other: "{0} saniye \xf6nce"
                        }
                    }
                }
            }
        },
        {
            locale: "tr-CY",
            parentLocale: "tr"
        }
    ];
});

});

parcelRegister("2uhJV", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "uk",
            pluralRuleFunction: function(e, t) {
                var a = String(e).split("."), n = a[0], o = !a[1], r = Number(a[0]) == e, i = r && a[0].slice(-1), l = r && a[0].slice(-2), f = n.slice(-1), m = n.slice(-2);
                return t ? 3 == i && 13 != l ? "few" : "other" : o && 1 == f && 11 != m ? "one" : o && f >= 2 && f <= 4 && (m < 12 || m > 14) ? "few" : o && 0 == f || o && f >= 5 && f <= 9 || o && m >= 11 && m <= 14 ? "many" : "other";
            },
            fields: {
                year: {
                    displayName: "\u0440\u0456\u043A",
                    relative: {
                        0: "\u0446\u044C\u043E\u0433\u043E \u0440\u043E\u043A\u0443",
                        1: "\u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u043A\u0443",
                        "-1": "\u0442\u043E\u0440\u0456\u043A"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u0440\u0456\u043A",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u0440\u043E\u043A\u0438",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u0440\u043E\u043A\u0456\u0432",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u0440\u043E\u043A\u0443"
                        },
                        past: {
                            one: "{0} \u0440\u0456\u043A \u0442\u043E\u043C\u0443",
                            few: "{0} \u0440\u043E\u043A\u0438 \u0442\u043E\u043C\u0443",
                            many: "{0} \u0440\u043E\u043A\u0456\u0432 \u0442\u043E\u043C\u0443",
                            other: "{0} \u0440\u043E\u043A\u0443 \u0442\u043E\u043C\u0443"
                        }
                    }
                },
                month: {
                    displayName: "\u043C\u0456\u0441\u044F\u0446\u044C",
                    relative: {
                        0: "\u0446\u044C\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F",
                        1: "\u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F",
                        "-1": "\u043C\u0438\u043D\u0443\u043B\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0456\u0441\u044F\u0446\u044C",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0456\u0441\u044F\u0446\u0456",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u043C\u0456\u0441\u044F\u0446\u044F"
                        },
                        past: {
                            one: "{0} \u043C\u0456\u0441\u044F\u0446\u044C \u0442\u043E\u043C\u0443",
                            few: "{0} \u043C\u0456\u0441\u044F\u0446\u0456 \u0442\u043E\u043C\u0443",
                            many: "{0} \u043C\u0456\u0441\u044F\u0446\u0456\u0432 \u0442\u043E\u043C\u0443",
                            other: "{0} \u043C\u0456\u0441\u044F\u0446\u044F \u0442\u043E\u043C\u0443"
                        }
                    }
                },
                day: {
                    displayName: "\u0434\u0435\u043D\u044C",
                    relative: {
                        0: "\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
                        1: "\u0437\u0430\u0432\u0442\u0440\u0430",
                        2: "\u043F\u0456\u0441\u043B\u044F\u0437\u0430\u0432\u0442\u0440\u0430",
                        "-2": "\u043F\u043E\u0437\u0430\u0432\u0447\u043E\u0440\u0430",
                        "-1": "\u0443\u0447\u043E\u0440\u0430"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u0434\u0435\u043D\u044C",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u0434\u043D\u0456",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u0434\u043D\u0456\u0432",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u0434\u043D\u044F"
                        },
                        past: {
                            one: "{0} \u0434\u0435\u043D\u044C \u0442\u043E\u043C\u0443",
                            few: "{0} \u0434\u043D\u0456 \u0442\u043E\u043C\u0443",
                            many: "{0} \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443",
                            other: "{0} \u0434\u043D\u044F \u0442\u043E\u043C\u0443"
                        }
                    }
                },
                hour: {
                    displayName: "\u0433\u043E\u0434\u0438\u043D\u0430",
                    relative: {
                        0: "\u0446\u0456\u0454\u0457 \u0433\u043E\u0434\u0438\u043D\u0438"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u0433\u043E\u0434\u0438\u043D\u0443",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u0433\u043E\u0434\u0438\u043D\u0438",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u0433\u043E\u0434\u0438\u043D",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u0433\u043E\u0434\u0438\u043D\u0438"
                        },
                        past: {
                            one: "{0} \u0433\u043E\u0434\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
                            few: "{0} \u0433\u043E\u0434\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
                            many: "{0} \u0433\u043E\u0434\u0438\u043D \u0442\u043E\u043C\u0443",
                            other: "{0} \u0433\u043E\u0434\u0438\u043D\u0438 \u0442\u043E\u043C\u0443"
                        }
                    }
                },
                minute: {
                    displayName: "\u0445\u0432\u0438\u043B\u0438\u043D\u0430",
                    relative: {
                        0: "\u0446\u0456\u0454\u0457 \u0445\u0432\u0438\u043B\u0438\u043D\u0438"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u0445\u0432\u0438\u043B\u0438\u043D",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u0445\u0432\u0438\u043B\u0438\u043D\u0438"
                        },
                        past: {
                            one: "{0} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
                            few: "{0} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
                            many: "{0} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443",
                            other: "{0} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443"
                        }
                    }
                },
                second: {
                    displayName: "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
                    relative: {
                        0: "\u0437\u0430\u0440\u0430\u0437"
                    },
                    relativeTime: {
                        future: {
                            one: "\u0447\u0435\u0440\u0435\u0437 {0} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
                            few: "\u0447\u0435\u0440\u0435\u0437 {0} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
                            many: "\u0447\u0435\u0440\u0435\u0437 {0} \u0441\u0435\u043A\u0443\u043D\u0434",
                            other: "\u0447\u0435\u0440\u0435\u0437 {0} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
                        },
                        past: {
                            one: "{0} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
                            few: "{0} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
                            many: "{0} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443",
                            other: "{0} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("iuaQn", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "vi",
            pluralRuleFunction: function(e, t) {
                return t && 1 == e ? "one" : "other";
            },
            fields: {
                year: {
                    displayName: "N\u0103m",
                    relative: {
                        0: "n\u0103m nay",
                        1: "n\u0103m sau",
                        "-1": "n\u0103m ngo\xe1i"
                    },
                    relativeTime: {
                        future: {
                            other: "sau {0} n\u0103m n\u1EEFa"
                        },
                        past: {
                            other: "{0} n\u0103m tr\u01B0\u1EDBc"
                        }
                    }
                },
                month: {
                    displayName: "Th\xe1ng",
                    relative: {
                        0: "th\xe1ng n\xe0y",
                        1: "th\xe1ng sau",
                        "-1": "th\xe1ng tr\u01B0\u1EDBc"
                    },
                    relativeTime: {
                        future: {
                            other: "sau {0} th\xe1ng n\u1EEFa"
                        },
                        past: {
                            other: "{0} th\xe1ng tr\u01B0\u1EDBc"
                        }
                    }
                },
                day: {
                    displayName: "Ng\xe0y",
                    relative: {
                        0: "H\xf4m nay",
                        1: "Ng\xe0y mai",
                        2: "Ng\xe0y kia",
                        "-2": "H\xf4m kia",
                        "-1": "H\xf4m qua"
                    },
                    relativeTime: {
                        future: {
                            other: "sau {0} ng\xe0y n\u1EEFa"
                        },
                        past: {
                            other: "{0} ng\xe0y tr\u01B0\u1EDBc"
                        }
                    }
                },
                hour: {
                    displayName: "Gi\u1EDD",
                    relative: {
                        0: "gi\u1EDD n\xe0y"
                    },
                    relativeTime: {
                        future: {
                            other: "sau {0} gi\u1EDD n\u1EEFa"
                        },
                        past: {
                            other: "{0} gi\u1EDD tr\u01B0\u1EDBc"
                        }
                    }
                },
                minute: {
                    displayName: "Ph\xfat",
                    relative: {
                        0: "ph\xfat n\xe0y"
                    },
                    relativeTime: {
                        future: {
                            other: "sau {0} ph\xfat n\u1EEFa"
                        },
                        past: {
                            other: "{0} ph\xfat tr\u01B0\u1EDBc"
                        }
                    }
                },
                second: {
                    displayName: "Gi\xe2y",
                    relative: {
                        0: "b\xe2y gi\u1EDD"
                    },
                    relativeTime: {
                        future: {
                            other: "sau {0} gi\xe2y n\u1EEFa"
                        },
                        past: {
                            other: "{0} gi\xe2y tr\u01B0\u1EDBc"
                        }
                    }
                }
            }
        }
    ];
});

});

parcelRegister("lG3EA", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return [
        {
            locale: "zh",
            pluralRuleFunction: function(e, t) {
                return "other";
            },
            fields: {
                year: {
                    displayName: "\u5E74",
                    relative: {
                        0: "\u4ECA\u5E74",
                        1: "\u660E\u5E74",
                        "-1": "\u53BB\u5E74"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5E74\u540E"
                        },
                        past: {
                            other: "{0}\u5E74\u524D"
                        }
                    }
                },
                month: {
                    displayName: "\u6708",
                    relative: {
                        0: "\u672C\u6708",
                        1: "\u4E0B\u4E2A\u6708",
                        "-1": "\u4E0A\u4E2A\u6708"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u4E2A\u6708\u540E"
                        },
                        past: {
                            other: "{0}\u4E2A\u6708\u524D"
                        }
                    }
                },
                day: {
                    displayName: "\u65E5",
                    relative: {
                        0: "\u4ECA\u5929",
                        1: "\u660E\u5929",
                        2: "\u540E\u5929",
                        "-2": "\u524D\u5929",
                        "-1": "\u6628\u5929"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5929\u540E"
                        },
                        past: {
                            other: "{0}\u5929\u524D"
                        }
                    }
                },
                hour: {
                    displayName: "\u5C0F\u65F6",
                    relative: {
                        0: "\u8FD9\u4E00\u65F6\u95F4 / \u6B64\u65F6"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5C0F\u65F6\u540E"
                        },
                        past: {
                            other: "{0}\u5C0F\u65F6\u524D"
                        }
                    }
                },
                minute: {
                    displayName: "\u5206\u949F",
                    relative: {
                        0: "\u6B64\u523B"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5206\u949F\u540E"
                        },
                        past: {
                            other: "{0}\u5206\u949F\u524D"
                        }
                    }
                },
                second: {
                    displayName: "\u79D2",
                    relative: {
                        0: "\u73B0\u5728"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u79D2\u949F\u540E"
                        },
                        past: {
                            other: "{0}\u79D2\u949F\u524D"
                        }
                    }
                }
            }
        },
        {
            locale: "zh-Hans",
            parentLocale: "zh"
        },
        {
            locale: "zh-Hans-HK",
            parentLocale: "zh-Hans",
            fields: {
                year: {
                    displayName: "\u5E74",
                    relative: {
                        0: "\u4ECA\u5E74",
                        1: "\u660E\u5E74",
                        "-1": "\u53BB\u5E74"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5E74\u540E"
                        },
                        past: {
                            other: "{0}\u5E74\u524D"
                        }
                    }
                },
                month: {
                    displayName: "\u6708",
                    relative: {
                        0: "\u672C\u6708",
                        1: "\u4E0B\u4E2A\u6708",
                        "-1": "\u4E0A\u4E2A\u6708"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u4E2A\u6708\u540E"
                        },
                        past: {
                            other: "{0}\u4E2A\u6708\u524D"
                        }
                    }
                },
                day: {
                    displayName: "\u65E5",
                    relative: {
                        0: "\u4ECA\u5929",
                        1: "\u660E\u5929",
                        2: "\u540E\u5929",
                        "-2": "\u524D\u5929",
                        "-1": "\u6628\u5929"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5929\u540E"
                        },
                        past: {
                            other: "{0}\u5929\u524D"
                        }
                    }
                },
                hour: {
                    displayName: "\u5C0F\u65F6",
                    relative: {
                        0: "\u8FD9\u4E00\u65F6\u95F4 / \u6B64\u65F6"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5C0F\u65F6\u540E"
                        },
                        past: {
                            other: "{0}\u5C0F\u65F6\u524D"
                        }
                    }
                },
                minute: {
                    displayName: "\u5206\u949F",
                    relative: {
                        0: "\u6B64\u523B"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5206\u949F\u540E"
                        },
                        past: {
                            other: "{0}\u5206\u949F\u524D"
                        }
                    }
                },
                second: {
                    displayName: "\u79D2",
                    relative: {
                        0: "\u73B0\u5728"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u79D2\u540E"
                        },
                        past: {
                            other: "{0}\u79D2\u524D"
                        }
                    }
                }
            }
        },
        {
            locale: "zh-Hans-MO",
            parentLocale: "zh-Hans",
            fields: {
                year: {
                    displayName: "\u5E74",
                    relative: {
                        0: "\u4ECA\u5E74",
                        1: "\u660E\u5E74",
                        "-1": "\u53BB\u5E74"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5E74\u540E"
                        },
                        past: {
                            other: "{0}\u5E74\u524D"
                        }
                    }
                },
                month: {
                    displayName: "\u6708",
                    relative: {
                        0: "\u672C\u6708",
                        1: "\u4E0B\u4E2A\u6708",
                        "-1": "\u4E0A\u4E2A\u6708"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u4E2A\u6708\u540E"
                        },
                        past: {
                            other: "{0}\u4E2A\u6708\u524D"
                        }
                    }
                },
                day: {
                    displayName: "\u65E5",
                    relative: {
                        0: "\u4ECA\u5929",
                        1: "\u660E\u5929",
                        2: "\u540E\u5929",
                        "-2": "\u524D\u5929",
                        "-1": "\u6628\u5929"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5929\u540E"
                        },
                        past: {
                            other: "{0}\u5929\u524D"
                        }
                    }
                },
                hour: {
                    displayName: "\u5C0F\u65F6",
                    relative: {
                        0: "\u8FD9\u4E00\u65F6\u95F4 / \u6B64\u65F6"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5C0F\u65F6\u540E"
                        },
                        past: {
                            other: "{0}\u5C0F\u65F6\u524D"
                        }
                    }
                },
                minute: {
                    displayName: "\u5206\u949F",
                    relative: {
                        0: "\u6B64\u523B"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5206\u949F\u540E"
                        },
                        past: {
                            other: "{0}\u5206\u949F\u524D"
                        }
                    }
                },
                second: {
                    displayName: "\u79D2",
                    relative: {
                        0: "\u73B0\u5728"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u79D2\u540E"
                        },
                        past: {
                            other: "{0}\u79D2\u524D"
                        }
                    }
                }
            }
        },
        {
            locale: "zh-Hans-SG",
            parentLocale: "zh-Hans",
            fields: {
                year: {
                    displayName: "\u5E74",
                    relative: {
                        0: "\u4ECA\u5E74",
                        1: "\u660E\u5E74",
                        "-1": "\u53BB\u5E74"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5E74\u540E"
                        },
                        past: {
                            other: "{0}\u5E74\u524D"
                        }
                    }
                },
                month: {
                    displayName: "\u6708",
                    relative: {
                        0: "\u672C\u6708",
                        1: "\u4E0B\u4E2A\u6708",
                        "-1": "\u4E0A\u4E2A\u6708"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u4E2A\u6708\u540E"
                        },
                        past: {
                            other: "{0}\u4E2A\u6708\u524D"
                        }
                    }
                },
                day: {
                    displayName: "\u65E5",
                    relative: {
                        0: "\u4ECA\u5929",
                        1: "\u660E\u5929",
                        2: "\u540E\u5929",
                        "-2": "\u524D\u5929",
                        "-1": "\u6628\u5929"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5929\u540E"
                        },
                        past: {
                            other: "{0}\u5929\u524D"
                        }
                    }
                },
                hour: {
                    displayName: "\u5C0F\u65F6",
                    relative: {
                        0: "\u8FD9\u4E00\u65F6\u95F4 / \u6B64\u65F6"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5C0F\u65F6\u540E"
                        },
                        past: {
                            other: "{0}\u5C0F\u65F6\u524D"
                        }
                    }
                },
                minute: {
                    displayName: "\u5206\u949F",
                    relative: {
                        0: "\u6B64\u523B"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u5206\u949F\u540E"
                        },
                        past: {
                            other: "{0}\u5206\u949F\u524D"
                        }
                    }
                },
                second: {
                    displayName: "\u79D2",
                    relative: {
                        0: "\u73B0\u5728"
                    },
                    relativeTime: {
                        future: {
                            other: "{0}\u79D2\u540E"
                        },
                        past: {
                            other: "{0}\u79D2\u524D"
                        }
                    }
                }
            }
        },
        {
            locale: "zh-Hant",
            pluralRuleFunction: function(e, t) {
                return "other";
            },
            fields: {
                year: {
                    displayName: "\u5E74",
                    relative: {
                        0: "\u4ECA\u5E74",
                        1: "\u660E\u5E74",
                        "-1": "\u53BB\u5E74"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u5E74\u5F8C"
                        },
                        past: {
                            other: "{0} \u5E74\u524D"
                        }
                    }
                },
                month: {
                    displayName: "\u6708",
                    relative: {
                        0: "\u672C\u6708",
                        1: "\u4E0B\u500B\u6708",
                        "-1": "\u4E0A\u500B\u6708"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u500B\u6708\u5F8C"
                        },
                        past: {
                            other: "{0} \u500B\u6708\u524D"
                        }
                    }
                },
                day: {
                    displayName: "\u65E5",
                    relative: {
                        0: "\u4ECA\u5929",
                        1: "\u660E\u5929",
                        2: "\u5F8C\u5929",
                        "-2": "\u524D\u5929",
                        "-1": "\u6628\u5929"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u5929\u5F8C"
                        },
                        past: {
                            other: "{0} \u5929\u524D"
                        }
                    }
                },
                hour: {
                    displayName: "\u5C0F\u6642",
                    relative: {
                        0: "\u9019\u4E00\u5C0F\u6642"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u5C0F\u6642\u5F8C"
                        },
                        past: {
                            other: "{0} \u5C0F\u6642\u524D"
                        }
                    }
                },
                minute: {
                    displayName: "\u5206\u9418",
                    relative: {
                        0: "\u9019\u4E00\u5206\u9418"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u5206\u9418\u5F8C"
                        },
                        past: {
                            other: "{0} \u5206\u9418\u524D"
                        }
                    }
                },
                second: {
                    displayName: "\u79D2",
                    relative: {
                        0: "\u73FE\u5728"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u79D2\u5F8C"
                        },
                        past: {
                            other: "{0} \u79D2\u524D"
                        }
                    }
                }
            }
        },
        {
            locale: "zh-Hant-HK",
            parentLocale: "zh-Hant",
            fields: {
                year: {
                    displayName: "\u5E74",
                    relative: {
                        0: "\u4ECA\u5E74",
                        1: "\u4E0B\u5E74",
                        "-1": "\u4E0A\u5E74"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u5E74\u5F8C"
                        },
                        past: {
                            other: "{0} \u5E74\u524D"
                        }
                    }
                },
                month: {
                    displayName: "\u6708",
                    relative: {
                        0: "\u672C\u6708",
                        1: "\u4E0B\u500B\u6708",
                        "-1": "\u4E0A\u500B\u6708"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u500B\u6708\u5F8C"
                        },
                        past: {
                            other: "{0} \u500B\u6708\u524D"
                        }
                    }
                },
                day: {
                    displayName: "\u65E5",
                    relative: {
                        0: "\u4ECA\u65E5",
                        1: "\u660E\u65E5",
                        2: "\u5F8C\u65E5",
                        "-2": "\u524D\u65E5",
                        "-1": "\u6628\u65E5"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u65E5\u5F8C"
                        },
                        past: {
                            other: "{0} \u65E5\u524D"
                        }
                    }
                },
                hour: {
                    displayName: "\u5C0F\u6642",
                    relative: {
                        0: "\u9019\u500B\u5C0F\u6642"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u5C0F\u6642\u5F8C"
                        },
                        past: {
                            other: "{0} \u5C0F\u6642\u524D"
                        }
                    }
                },
                minute: {
                    displayName: "\u5206\u9418",
                    relative: {
                        0: "\u9019\u5206\u9418"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u5206\u9418\u5F8C"
                        },
                        past: {
                            other: "{0} \u5206\u9418\u524D"
                        }
                    }
                },
                second: {
                    displayName: "\u79D2",
                    relative: {
                        0: "\u73FE\u5728"
                    },
                    relativeTime: {
                        future: {
                            other: "{0} \u79D2\u5F8C"
                        },
                        past: {
                            other: "{0} \u79D2\u524D"
                        }
                    }
                }
            }
        },
        {
            locale: "zh-Hant-MO",
            parentLocale: "zh-Hant-HK"
        }
    ];
});

});


parcelRegister("d1qUE", function(module, exports) {
$parcel$export(module.exports, "default", () => $521ea8ddcbe36371$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $breWd = parcelRequire("breWd");

var $l4a5B = parcelRequire("l4a5B");

var $7FSs7 = parcelRequire("7FSs7");

var $4e7kU = parcelRequire("4e7kU");
class $521ea8ddcbe36371$export$1e0c5ecf7bd99e3 extends $8P7DW.Component {
    componentDidMount() {
        const { origin: origin } = this.props;
        if (origin === null) return;
        (0, $breWd.get)(`${(0, $7FSs7.contextPath)}/rest/assetapi/asset/${origin}`)// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .map(({ response: response })=>response)// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        .map((asset)=>this.setState({
                value: asset.label.value
            })).subscribe({
            error: ()=>this.setState({
                    isErrored: true
                })
        });
    }
    render() {
        const { intl: intl, origin: origin } = this.props;
        const { value: value, isErrored: isErrored } = this.state;
        if (isErrored || origin === null) return intl.formatMessage((0, $4e7kU.default).unknown);
        if (value === undefined) return intl.formatMessage((0, $4e7kU.default).loading);
        return value;
    }
    constructor(...args){
        super(...args), this.state = {};
    }
}
var $521ea8ddcbe36371$export$2e2bcd8739ae039 = (0, $l4a5B.default)($521ea8ddcbe36371$export$1e0c5ecf7bd99e3);

});
parcelRegister("breWd", function(module, exports) {
$parcel$export(module.exports, "get", () => $08a2d50808b5079a$export$3988ae62b71be9a3);
$parcel$export(module.exports, "post", () => $08a2d50808b5079a$export$299ba2dee77727e9);
$parcel$export(module.exports, "put", () => $08a2d50808b5079a$export$327f7b26ebf455db);
$parcel$export(module.exports, "doDelete", () => $08a2d50808b5079a$export$3450a603e4796ceb);

var $fSYYZ = parcelRequire("fSYYZ");

var $jCUfl = parcelRequire("jCUfl");
const $08a2d50808b5079a$export$e68fce4c5f453854 = (0, $fSYYZ.Observable).ajax;
const $08a2d50808b5079a$export$3988ae62b71be9a3 = (0, $jCUfl.traceableAjaxGet);
const $08a2d50808b5079a$export$299ba2dee77727e9 = (0, $jCUfl.traceableAjaxPost);
const $08a2d50808b5079a$export$327f7b26ebf455db = (0, $jCUfl.traceableAjaxPut);
const $08a2d50808b5079a$export$3450a603e4796ceb = (0, $jCUfl.traceableAjaxDelete);

});
parcelRegister("jCUfl", function(module, exports) {
$parcel$export(module.exports, "traceableAjaxGet", () => $20c11f884db90ee9$export$9b2538eb22ed41e3);
$parcel$export(module.exports, "traceableAjaxPost", () => $20c11f884db90ee9$export$9f4e186c104ab31a);
$parcel$export(module.exports, "traceableAjaxPut", () => $20c11f884db90ee9$export$54de09e82d9434c3);
$parcel$export(module.exports, "traceableAjaxDelete", () => $20c11f884db90ee9$export$d507aea434380fd4);

var $fSYYZ = parcelRequire("fSYYZ");

var $l5LZV = parcelRequire("l5LZV");
const $20c11f884db90ee9$var$extendHeadersWithTracing = (url, originalHeaders = {})=>({
        ...originalHeaders,
        ...(0, $l5LZV.getActiveTraceHttpRequestHeaders)(url)
    });
const $20c11f884db90ee9$export$9b2538eb22ed41e3 = (url, headers)=>{
    return (0, $fSYYZ.Observable).ajax.get(url, $20c11f884db90ee9$var$extendHeadersWithTracing(url, headers));
};
const $20c11f884db90ee9$export$9f4e186c104ab31a = (url, body, headers)=>{
    return (0, $fSYYZ.Observable).ajax.post(url, body, $20c11f884db90ee9$var$extendHeadersWithTracing(url, headers));
};
const $20c11f884db90ee9$export$54de09e82d9434c3 = (url, body, headers)=>{
    return (0, $fSYYZ.Observable).ajax.put(url, body, $20c11f884db90ee9$var$extendHeadersWithTracing(url, headers));
};
const $20c11f884db90ee9$export$d507aea434380fd4 = (url, headers)=>{
    return (0, $fSYYZ.Observable).ajax.delete(url, $20c11f884db90ee9$var$extendHeadersWithTracing(url, headers));
};

});


parcelRegister("4e7kU", function(module, exports) {
$parcel$export(module.exports, "default", () => $3de12b6027ad8834$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $3de12b6027ad8834$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    loading: {
        id: 'asset.tracking.field.loading.asset',
        defaultMessage: 'Loading asset...',
        description: 'Displayed when asset label is being loaded from saffron (asset microservice)'
    },
    unknown: {
        id: 'asset.tracking.field.unknown.asset',
        defaultMessage: 'Unknown asset',
        description: 'Displayed when a value for an asset field is not known (eg: it has been deleted)'
    }
});

});
parcelRegister("7B9et", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $5883267549e17902$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $5883267549e17902$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $5883267549e17902$export$40ae3194919d16b);

var $lmSJp = parcelRequire("lmSJp");

var $egJfF = parcelRequire("egJfF");

var $kdOV9 = parcelRequire("kdOV9");

var $l4a5B = parcelRequire("l4a5B");

var $l4cjO = parcelRequire("l4cjO");

var $aTmFN = parcelRequire("aTmFN");

var $ai5ZE = parcelRequire("ai5ZE");

var $FZQK7 = parcelRequire("FZQK7");

var $5jYgE = parcelRequire("5jYgE");

var $cTigd = parcelRequire("cTigd");
var $cn8SS = parcelRequire("cn8SS");
function $5883267549e17902$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $5883267549e17902$export$747d244ee58120dd(msg) {
    return msg;
}
var $5883267549e17902$export$40ae3194919d16b = (0, $lmSJp.createFormattedComponent)('formatDate');
var $5883267549e17902$export$5b390a54f8a846f7 = (0, $lmSJp.createFormattedComponent)('formatTime');
var $5883267549e17902$export$db80edc1e6b2f63d = (0, $lmSJp.createFormattedComponent)('formatNumber');
var $5883267549e17902$export$f52b44e459e6e71d = (0, $lmSJp.createFormattedComponent)('formatList');
var $5883267549e17902$export$c2336ea5aaab92fa = (0, $lmSJp.createFormattedComponent)('formatDisplayName');
var $5883267549e17902$export$7fdc7d2c91ce149b = (0, $lmSJp.createFormattedDateTimePartsComponent)('formatDate');
var $5883267549e17902$export$ec35873761676c2a = (0, $lmSJp.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("lmSJp", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $f8e61b8dfac91431$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $f8e61b8dfac91431$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $f8e61b8dfac91431$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $f8e61b8dfac91431$export$b37e14176d001dec);

var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");
var $f8e61b8dfac91431$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($f8e61b8dfac91431$var$DisplayName || ($f8e61b8dfac91431$var$DisplayName = {}));
var $f8e61b8dfac91431$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($f8e61b8dfac91431$var$DisplayNameParts || ($f8e61b8dfac91431$var$DisplayNameParts = {}));
var $f8e61b8dfac91431$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $5jYgE.default)();
    var value = props.value, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$f8e61b8dfac91431$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $f8e61b8dfac91431$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $5jYgE.default)();
    var value = props.value, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$f8e61b8dfac91431$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $f8e61b8dfac91431$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $5jYgE.default)();
        var value = props.value, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $f8e61b8dfac91431$var$DisplayNameParts[name];
    return ComponentParts;
}
function $f8e61b8dfac91431$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $5jYgE.default)();
        var value = props.value, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $8P7DW.Fragment;
        return $8P7DW.createElement(Text, null, formattedValue);
    };
    Component.displayName = $f8e61b8dfac91431$var$DisplayName[name];
    return Component;
}

});
parcelRegister("5jYgE", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dfd79fbacc8d271$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $81wAJ = parcelRequire("81wAJ");

var $l4a5B = parcelRequire("l4a5B");
function $3dfd79fbacc8d271$export$2e2bcd8739ae039() {
    var intl = $8P7DW.useContext((0, $l4a5B.Context));
    (0, $81wAJ.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("kdOV9", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb8c855b08535248$export$2e2bcd8739ae039);

var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");
var $eb8c855b08535248$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $5jYgE.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $8P7DW.Fragment;
    return $8P7DW.createElement(Text, null, formattedValue);
};
$eb8c855b08535248$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $eb8c855b08535248$export$2e2bcd8739ae039 = $eb8c855b08535248$var$FormattedDateTimeRange;

});

parcelRegister("l4cjO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f56386eb6513b540$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $81wAJ = parcelRequire("81wAJ");

var $5jYgE = parcelRequire("5jYgE");
function $f56386eb6513b540$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $26Yns.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $26Yns.__rest)(nextProps, [
        "values"
    ]);
    return (0, $81wAJ.shallowEqual)(nextValues, values) && (0, $81wAJ.shallowEqual)(otherProps, nextOtherProps);
}
function $f56386eb6513b540$var$FormattedMessage(props) {
    var intl = (0, $5jYgE.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $8P7DW.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $8P7DW.createElement(Component, null, nodes);
    return $8P7DW.createElement($8P7DW.Fragment, null, nodes);
}
$f56386eb6513b540$var$FormattedMessage.displayName = 'FormattedMessage';
var $f56386eb6513b540$var$MemoizedFormattedMessage = $8P7DW.memo($f56386eb6513b540$var$FormattedMessage, $f56386eb6513b540$var$areEqual);
$f56386eb6513b540$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $f56386eb6513b540$export$2e2bcd8739ae039 = $f56386eb6513b540$var$MemoizedFormattedMessage;

});

parcelRegister("aTmFN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ee0a0daa1b10d39$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");
var $7ee0a0daa1b10d39$var$FormattedPlural = function(props) {
    var _a = (0, $5jYgE.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $8P7DW.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$7ee0a0daa1b10d39$var$FormattedPlural.displayName = 'FormattedPlural';
var $7ee0a0daa1b10d39$export$2e2bcd8739ae039 = $7ee0a0daa1b10d39$var$FormattedPlural;

});

parcelRegister("FZQK7", function(module, exports) {
$parcel$export(module.exports, "default", () => $07e3ce82a66ca31f$export$2e2bcd8739ae039);

var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $81wAJ = parcelRequire("81wAJ");

var $5jYgE = parcelRequire("5jYgE");
var $07e3ce82a66ca31f$var$MINUTE = 60;
var $07e3ce82a66ca31f$var$HOUR = 3600;
var $07e3ce82a66ca31f$var$DAY = 86400;
function $07e3ce82a66ca31f$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $07e3ce82a66ca31f$var$MINUTE) return 'second';
    if (absValue < $07e3ce82a66ca31f$var$HOUR) return 'minute';
    if (absValue < $07e3ce82a66ca31f$var$DAY) return 'hour';
    return 'day';
}
function $07e3ce82a66ca31f$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $07e3ce82a66ca31f$var$MINUTE;
        case 'hour':
            return $07e3ce82a66ca31f$var$HOUR;
        default:
            return $07e3ce82a66ca31f$var$DAY;
    }
}
function $07e3ce82a66ca31f$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $07e3ce82a66ca31f$var$MINUTE;
        default:
            return value * $07e3ce82a66ca31f$var$HOUR;
    }
}
var $07e3ce82a66ca31f$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $07e3ce82a66ca31f$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $07e3ce82a66ca31f$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $07e3ce82a66ca31f$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $5jYgE.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $26Yns.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $8P7DW.createElement(Text, null, formattedRelativeTime);
    return $8P7DW.createElement($8P7DW.Fragment, null, formattedRelativeTime);
};
var $07e3ce82a66ca31f$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $26Yns.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $81wAJ.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $07e3ce82a66ca31f$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $8P7DW.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $8P7DW.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $8P7DW.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($07e3ce82a66ca31f$var$canIncrement(unit) ? $07e3ce82a66ca31f$var$valueToSeconds(value, unit) : 0);
    }
    $8P7DW.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$07e3ce82a66ca31f$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $07e3ce82a66ca31f$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $07e3ce82a66ca31f$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($07e3ce82a66ca31f$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $07e3ce82a66ca31f$var$selectUnit(currentValueInSeconds);
        var unitDuration = $07e3ce82a66ca31f$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $8P7DW.createElement($07e3ce82a66ca31f$var$SimpleFormattedRelativeTime, (0, $26Yns.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$07e3ce82a66ca31f$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $07e3ce82a66ca31f$export$2e2bcd8739ae039 = $07e3ce82a66ca31f$var$FormattedRelativeTime;

});






parcelRegister("gV052", function(module, exports) {
$parcel$export(module.exports, "getCmdbFieldValueElement", () => (parcelRequire("4teOe")).getCmdbFieldValueElement);

var $4teOe = parcelRequire("4teOe");

});
parcelRegister("4teOe", function(module, exports) {
$parcel$export(module.exports, "getCmdbFieldValueElement", () => $998b48e1bf1b6550$export$ce19e854d193d5b3);

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");

var $45a3E = parcelRequire("45a3E");

var $edC7N = parcelRequire("edC7N");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $Yw2wm = parcelRequire("Yw2wm");

var $ai5ZE = parcelRequire("ai5ZE");

var $bP2rs = parcelRequire("bP2rs");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");

var $ktdLU = parcelRequire("ktdLU");

var $44YJW = parcelRequire("44YJW");

var $lut7F = parcelRequire("lut7F");
parcelRequire("acg8g");
var $cBSPm = parcelRequire("cBSPm");
const $998b48e1bf1b6550$var$onIntlError = (intlError)=>{
    try {
        $lut7F.reportError(intlError);
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $998b48e1bf1b6550$export$3bcefabe8b04378c = (intlError)=>{
    $998b48e1bf1b6550$var$onIntlError(`IntlV5: ${intlError.message}`);
};
const $998b48e1bf1b6550$export$3c09dff16567da2f = (base64String)=>{
    try {
        // Decode base64 string while preserving Unicode characters
        const binaryString = atob(base64String || '');
        const bytes = new Uint8Array(binaryString.length);
        for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
        const decoder = new TextDecoder('utf-8');
        const decodedString = decoder.decode(bytes);
        return JSON.parse(decodedString);
    } catch (e) {
        return null;
    }
};
const $998b48e1bf1b6550$export$ce19e854d193d5b3 = ()=>{
    class CmdbFieldValueElement extends HTMLElement {
        connectedCallback() {
            // Jira passes the cmdb object data as a data-object-details-base64 attribute
            const objectDetailsBase64 = this.getAttribute('data-object-details-base64');
            const parsedObjectDetails = $998b48e1bf1b6550$export$3c09dff16567da2f(objectDetailsBase64);
            if (!parsedObjectDetails) return;
            if ((0, $HGACo.isUseReact18CreateRootEnabled)()) {
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                const container = document.createElement('span');
                const root = (0, $Yw2wm.createRoot)(container);
                root.render(// @ts-ignore
                /*#__PURE__*/ $8P7DW.createElement((0, $45a3E.IntlProvider), {
                    messages: (0, $ktdLU.default)(),
                    locale: (0, $44YJW.getLanguageFromLocale)((0, $jByYr.getMetaData)().userLocale),
                    onError: $998b48e1bf1b6550$var$onIntlError
                }, /*#__PURE__*/ $8P7DW.createElement((0, $ai5ZE.default), {
                    messages: (0, $ktdLU.default)(),
                    locale: (0, $44YJW.getLanguageFromLocale)((0, $jByYr.getMetaData)().userLocale),
                    onError: $998b48e1bf1b6550$export$3bcefabe8b04378c
                }, /*#__PURE__*/ $8P7DW.createElement((0, $bP2rs.default), {
                    onEvent: (0, $9ypa9.legacySendEvent)
                }, /*#__PURE__*/ $8P7DW.createElement((0, $iziiq.AnalyticsContext), {
                    sourceName: "portalUnknown",
                    sourceType: (0, $iziiq.ScreenTypes).SCREEN,
                    attributes: {
                        context: 'Portal'
                    }
                }, /*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
                    packageName: "cmdbFieldValueWebComponent",
                    id: "cmdb-object-card",
                    renderError: ()=>null
                }, /*#__PURE__*/ $8P7DW.createElement((0, $cBSPm.default), {
                    cmdbObject: parsedObjectDetails
                })))))));
                this.appendChild(container);
            } else {
                // render the component with its props, and add to the Shadow DOM
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                const root = document.createElement('span');
                // eslint-disable-next-line react/no-deprecated
                $6Q1OD.render(// @ts-ignore
                /*#__PURE__*/ $8P7DW.createElement((0, $45a3E.IntlProvider), {
                    messages: (0, $ktdLU.default)(),
                    locale: (0, $44YJW.getLanguageFromLocale)((0, $jByYr.getMetaData)().userLocale),
                    onError: $998b48e1bf1b6550$var$onIntlError
                }, /*#__PURE__*/ $8P7DW.createElement((0, $ai5ZE.default), {
                    messages: (0, $ktdLU.default)(),
                    locale: (0, $44YJW.getLanguageFromLocale)((0, $jByYr.getMetaData)().userLocale),
                    onError: $998b48e1bf1b6550$export$3bcefabe8b04378c
                }, /*#__PURE__*/ $8P7DW.createElement((0, $bP2rs.default), {
                    onEvent: (0, $9ypa9.legacySendEvent)
                }, /*#__PURE__*/ $8P7DW.createElement((0, $iziiq.AnalyticsContext), {
                    sourceName: "portalUnknown",
                    sourceType: (0, $iziiq.ScreenTypes).SCREEN,
                    attributes: {
                        context: 'Portal'
                    }
                }, /*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
                    packageName: "cmdbFieldValueWebComponent",
                    id: "cmdb-object-card",
                    renderError: ()=>null
                }, /*#__PURE__*/ $8P7DW.createElement((0, $cBSPm.default), {
                    cmdbObject: parsedObjectDetails
                })))))), root);
                this.appendChild(root);
            }
        }
    }
    return CmdbFieldValueElement;
};

});
parcelRegister("edC7N", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8cad7e997ddfe39$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");

var $9ypa9 = parcelRequire("9ypa9");
const $a8cad7e997ddfe39$var$SENTRY_EXCLUDED_STATUS_CODES = [
    429
];
class $a8cad7e997ddfe39$export$e926676385687eaf extends $8P7DW.Component {
    componentDidCatch(error) {
        const { id: id, createAnalyticsEvent: createAnalyticsEvent, analyticsAttributes: analyticsAttributes, packageName: packageName, onError: onError } = this.props;
        this.setState({
            error: error
        });
        const data = {};
        if (id) data.errorBoundaryId = id;
        if (packageName) data.errorBoundaryPackageName = packageName;
        const shouldExclude = (0, $1EFS8.default).checkGate('enable_sentry_exclusions_in_error_boundary') && error && error.hasOwnProperty('status') && $a8cad7e997ddfe39$var$SENTRY_EXCLUDED_STATUS_CODES.includes(error.status);
        if (!shouldExclude) (0, $9ypa9.trackError)('app.boundary.uncaught.error', data, error);
        if (createAnalyticsEvent !== undefined) {
            const analyticsEvent = createAnalyticsEvent({
                ...analyticsAttributes,
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                errorMessage: (0, $9ypa9.getErrorData)(error)
            });
            // TODO: FSD-4121 switch to using '@atlassian/error-handling'
            // Note that `componentName` is used as `actionSubject` in gasV3 operational events, and takes this form as described at
            // https://hello.atlassian.net/wiki/spaces/ALBS/pages/589347147/Jira+monitoring+frontend+errors#Step-2%3A-register-events
            const finalId = id || 'unknownErrorBoundary';
            const finalPackage = packageName || 'unknownPackage';
            const actionSubject = `${finalPackage}.${finalId}`;
            analyticsEvent.context.push({
                componentName: actionSubject
            });
            analyticsEvent.fire();
        }
        if (onError) onError(error);
    }
    render() {
        const { children: children, renderError: renderError } = this.props;
        const { error: error } = this.state;
        if (error) return renderError ? renderError(error) : null;
        return children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
var $a8cad7e997ddfe39$export$2e2bcd8739ae039 = (0, $eS4yu.default)()((0, $k7ZVu.default)()($a8cad7e997ddfe39$export$e926676385687eaf));

});
parcelRegister("eS4yu", function(module, exports) {
$parcel$export(module.exports, "default", () => $c862fb7c0db84b9f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8gu7I = parcelRequire("8gu7I");
const $c862fb7c0db84b9f$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $8P7DW.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8gu7I.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)(WrappedComponent, {
                    ...rest,
                    ref: ref
                })
            });
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $c862fb7c0db84b9f$export$2e2bcd8739ae039 = $c862fb7c0db84b9f$var$withAnalyticsContext;

});

parcelRegister("9ypa9", function(module, exports) {
$parcel$export(module.exports, "legacySendEvent", () => $ea01b3da82c646ef$export$31613c62bfdc6a53);
$parcel$export(module.exports, "sendEventFromAnalyticsBridge", () => $ea01b3da82c646ef$export$80c476f25a50624a);
$parcel$export(module.exports, "sendAtlaskitUIEvent", () => $ea01b3da82c646ef$export$8c604b65319094be);
$parcel$export(module.exports, "legacyTrackEvent", () => $ea01b3da82c646ef$export$d34aefccac2c4e2b);
$parcel$export(module.exports, "getErrorData", () => $ea01b3da82c646ef$export$6fd42d413c537998);
$parcel$export(module.exports, "trackError", () => $ea01b3da82c646ef$export$5a6ec5e5079bbe35);

var $HGACo = parcelRequire("HGACo");

var $17wqU = parcelRequire("17wqU");

var $iziiq = parcelRequire("iziiq");

var $jjE9o = parcelRequire("jjE9o");

var $4zGZd = parcelRequire("4zGZd");

var $lut7F = parcelRequire("lut7F");

var $16el4 = parcelRequire("16el4");

var $4L08H = parcelRequire("4L08H");

var $eKRnz = parcelRequire("eKRnz");
const $ea01b3da82c646ef$var$getMeta = ()=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,  @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    const buildVersion = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION;
    return {
        sessionId: $eKRnz.sessionId,
        context: window.location.pathname,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        version: buildVersion ? buildVersion.buildKey : 'JPF-STORYBOOK-000'
    };
};
function $ea01b3da82c646ef$export$31613c62bfdc6a53(event) {
    $ea01b3da82c646ef$var$sendEvent(event);
}
function $ea01b3da82c646ef$export$80c476f25a50624a(event) {
    $ea01b3da82c646ef$var$sendEvent(event, (0, $17wqU.ANALYTICS_BRIDGE_CHANNEL));
}
function $ea01b3da82c646ef$var$sendEvent(event, channel) {
    const analyticsWebClient = (0, $4L08H.getAnalyticsWebClient)();
    if (analyticsWebClient) analyticsWebClient.sendEvent(event, channel);
    (0, $16el4.reportAnalyticsEvent)(event);
}
const $ea01b3da82c646ef$var$extractFromEventContext = (propertyNames, event)=>// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    event.context// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/ban-types
    .reduceRight((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
function $ea01b3da82c646ef$export$8c604b65319094be(event) {
    const analyticsWebClient = (0, $4L08H.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        event.update({
            // Don't override analyticsType if it already exists.
            // Else set it to UI_EVENT_TYPE.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            analyticsType: event.payload.analyticsType || (0, $iziiq.UI_EVENT_TYPE),
            // Extract actionSubjectId from context.
            // Analytics web react enforces it must be defined here - else it won't pick it up.
            // See: https://bitbucket.org/atlassian/analytics-web-react/src/master/src/utils/extract-data-from-event.js?at=master#lines-89
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            actionSubjectId: $ea01b3da82c646ef$var$extractFromEventContext([
                'actionSubjectId'
            ], event)[0]
        });
        analyticsWebClient.sendEvent(event);
    }
}
function $ea01b3da82c646ef$export$d34aefccac2c4e2b(eventName, data) {
    const mergedData = {
        ...data,
        ...$ea01b3da82c646ef$var$getMeta()
    };
    (0, $4zGZd.trackLegacyEvent)(eventName, mergedData);
}
function $ea01b3da82c646ef$var$truncateMessage(message, length = 25) {
    if (message === null || message === undefined) return 'null';
    return message.slice(0, length);
}
function $ea01b3da82c646ef$var$sendErrorToSentry(error, additionalErrorData) {
    try {
        // log to sentry
        (0, $lut7F.reportError)(error, additionalErrorData);
    } catch (ex) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access ,@typescript-eslint/no-unsafe-assignment
        const errorMessage = JSON.stringify({
            name: ex.name,
            msg: ex.message
        });
        $ea01b3da82c646ef$export$d34aefccac2c4e2b('sentry.error.tracking.failed', {
            error: errorMessage
        });
        (0, $jjE9o.operationalEvent)({
            action: 'failed',
            actionSubjectId: 'SentryErrorTracking',
            attributes: {
                error: errorMessage,
                ...additionalErrorData
            },
            source: 'unknownSource'
        });
    }
}
/**
 * this error tracking event is to send the caught sentry error to the newer GASv3 analytics as an
 * operational event
 */ function $ea01b3da82c646ef$var$sendOperationalErrorEvent(eventName, error, additionalAttribute) {
    (0, $jjE9o.operationalEvent)({
        action: 'failed',
        actionSubjectId: 'SentryErrorTracking',
        actionSubject: 'sentryError',
        source: 'unknownSource',
        attributes: {
            ...additionalAttribute,
            error: error,
            eventName: eventName
        }
    });
}
function $ea01b3da82c646ef$export$6fd42d413c537998(error) {
    let errorData = '';
    if (!error) // undefined error
    errorData = JSON.stringify({
        msg: 'null'
    });
    else if (!!error.xhr) {
        // ajax error
        const ajaxError = error;
        const xhr = ajaxError.xhr;
        errorData = JSON.stringify({
            name: 'AjaxError',
            // we can hard code this here because we know it's an ajax error
            stat: xhr.status,
            msg: $ea01b3da82c646ef$var$truncateMessage(ajaxError.message)
        });
    } else if (typeof error === 'string') // error as string
    errorData = JSON.stringify({
        msg: error
    });
    else {
        // generic js error
        const jsError = error;
        errorData = JSON.stringify({
            name: $ea01b3da82c646ef$var$truncateMessage(jsError.name),
            msg: $ea01b3da82c646ef$var$truncateMessage(jsError.message, 100)
        });
    }
    return errorData;
}
function $ea01b3da82c646ef$export$5a6ec5e5079bbe35(eventName, data, error) {
    const errorData = $ea01b3da82c646ef$export$6fd42d413c537998(error);
    // Skip sending to Sentry if it's an AjaxError or if filterFromSentry is true
    if (error && !error.xhr && !((0, $HGACo.isFilterQueryErrorFromSentryEnabled)() && error.filterFromSentry)) {
        if (typeof error === 'string') $ea01b3da82c646ef$var$sendErrorToSentry(new Error(error), data);
        else {
            // generic js error
            const jsError = error;
            $ea01b3da82c646ef$var$sendErrorToSentry(jsError, data);
        }
    }
    /**  behind the WRM optimisation feature flag and do not fire
   *  operational event for errors caught by error boundary
   */ if ((0, $HGACo.isWrmOptimizationsEnabled)() && !(data && data.errorBoundaryId)) $ea01b3da82c646ef$var$sendOperationalErrorEvent(eventName, errorData, data);
    const eventData = {
        ...data,
        error: errorData
    };
    return $ea01b3da82c646ef$export$d34aefccac2c4e2b(eventName, eventData);
}

});
parcelRegister("4zGZd", function(module, exports) {
$parcel$export(module.exports, "trackLegacyEvent", () => $2b24d0801895f9ee$export$655ee831d8b45890);

var $HGACo = parcelRequire("HGACo");

var $4yRg9 = parcelRequire("4yRg9");

var $eKRnz = parcelRequire("eKRnz");

var $AbrGu = parcelRequire("AbrGu");

var $1qct3 = parcelRequire("1qct3");

var $6OqZp = parcelRequire("6OqZp");
const $2b24d0801895f9ee$var$sanitizeAnalyticEvent = (eventName, eventProperties)=>{
    // for any new events which have been added to portal frontend whitelist
    // we will add a prefix to the eventname and sanitize its properties
    if ((0, $AbrGu.isWhiteListEvent)(eventName)) return {
        name: `jsd.portal.frontend.${eventName}`,
        properties: (0, $AbrGu.sanitizeEventProperties)(eventName, eventProperties)
    };
    // if events not in whitelist, we will let cloud analytic plugin handle it instead
    return {
        name: eventName,
        properties: eventProperties
    };
};
const $2b24d0801895f9ee$export$655ee831d8b45890 = (name, data)=>{
    const props = {
        ...data,
        sessionId: $eKRnz.sessionId
    };
    props.sdVersion = (0, $1qct3.getPluginVersion)() || props.sdVersion || 'unknown';
    props.portalFrontendBuildKey = (0, $1qct3.getCustomerPortalFrontendBuildKey)() || props.portalFrontendBuildKey || 'unknown';
    const safeEventObject = $2b24d0801895f9ee$var$sanitizeAnalyticEvent(name, props);
    // TODO: replace with fireLegacyEvent(safeEventObject) from src/rest/legacy-event
    // the reason now here is to cater for the https://jdog.jira-dev.com/browse/JSDKB-1468 task which
    // still consumes the GASv2 events, this following code should be removed once the above task is fixed
    if ((0, $HGACo.isWrmOptimizationsEnabled)()) {
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6OqZp.fireLegacyEvent)(safeEventObject);
        return;
    }
    const eventQueue = (0, $4yRg9.getEventQueue)();
    eventQueue && eventQueue.push(safeEventObject);
};

});
parcelRegister("eKRnz", function(module, exports) {
$parcel$export(module.exports, "sessionId", () => $32795f949e1ffa12$export$f1faf18bafef2950);

var $1u2vz = parcelRequire("1u2vz");
const $32795f949e1ffa12$export$f1faf18bafef2950 = (0, $1u2vz.default)();

});
parcelRegister("1u2vz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0442c3a52c0c40ca$export$2e2bcd8739ae039);

var $461ul = parcelRequire("461ul");
const $0442c3a52c0c40ca$var$s4 = ()=>(0, $461ul.default).floor((1 + (0, $461ul.default).random()) * 0x10000).toString(16).substring(1);
function $0442c3a52c0c40ca$export$2e2bcd8739ae039() {
    return `${$0442c3a52c0c40ca$var$s4()}${$0442c3a52c0c40ca$var$s4()}-${$0442c3a52c0c40ca$var$s4()}-${$0442c3a52c0c40ca$var$s4()}-${$0442c3a52c0c40ca$var$s4()}-${$0442c3a52c0c40ca$var$s4()}${$0442c3a52c0c40ca$var$s4()}${$0442c3a52c0c40ca$var$s4()}`;
}

});
parcelRegister("461ul", function(module, exports) {
$parcel$export(module.exports, "default", () => $8afd470e247ded18$export$2e2bcd8739ae039);
// This exists so we can have an easier time stubbing it out in tests.
var $8afd470e247ded18$export$2e2bcd8739ae039 = Math;

});



parcelRegister("AbrGu", function(module, exports) {
$parcel$export(module.exports, "isWhiteListEvent", () => $5928266b8f2b3af5$export$364166d55b6d152b);
$parcel$export(module.exports, "sanitizeEventProperties", () => $5928266b8f2b3af5$export$fc45a7cd0562e9ff);

var $1We2B = parcelRequire("1We2B");

var $5ylfn = parcelRequire("5ylfn");
const $5928266b8f2b3af5$var$WHITELIST_KEYS = Object.keys($5ylfn);
const $5928266b8f2b3af5$export$364166d55b6d152b = (eventName)=>(0, $1We2B.includes)($5928266b8f2b3af5$var$WHITELIST_KEYS, eventName);
const $5928266b8f2b3af5$export$fc45a7cd0562e9ff = (eventName, eventProperties)=>{
    return (0, $1We2B.pick)(eventProperties, $5ylfn[eventName]);
};

});
parcelRegister("5ylfn", function(module, exports) {
module.exports = JSON.parse("{\"footer.waclink.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"search.overlay.button.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"session.logout.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"header.avatar.menu.opened\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.profile.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.logout.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.my.request.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.all.requests.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.pending.approval.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.my.approval.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.organisation.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.spotlight.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"kbPortalView.helpful.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"kbPortalView.not.helpful.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"request.change.spotlight.dismiss.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"search.result.kb.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"search.result.portal.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"search.result.request.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"sentry.error.tracking.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"helpcenter.search.textbox.focused\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"helpcenter.search.textbox.submit\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"portal.search.onboarding.dismiss.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"portal.search.onboarding.target.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"spotlight.dismiss.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"spotlightKey\",\"error\"],\"servicedesk.customerview.smartportal.browse.popular.portals.portal.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"portalFrontendBuildKey\"],\"servicedesk.customerview.smartportal.browse.popular.portals.browse.all.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"organisation.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"kbsuggestions.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"findlabel.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"finduser.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"servicedesk.customerview.smartportal.browse.recent.requesttypes.requesttype.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content.save.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content.cancel.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"async.loader.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"portal.home.announcement.banner.collapse.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"portal.home.announcement.banner.expand.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"categories.fetch.all.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"category.articles.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"raise.request.cta.button\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"]}");

});


parcelRegister("1qct3", function(module, exports) {
$parcel$export(module.exports, "getPluginVersion", () => $bcf05d0373ad12ad$export$face9f52d66c8c0f);
$parcel$export(module.exports, "getCustomerPortalFrontendBuildKey", () => $bcf05d0373ad12ad$export$d9a9dd9e37b497b6);

var $4yRg9 = parcelRequire("4yRg9");
const $bcf05d0373ad12ad$export$face9f52d66c8c0f = ()=>{
    return (0, $4yRg9.getMeta) && (0, $4yRg9.getMeta)('sdPluginVersion');
};
const $bcf05d0373ad12ad$export$d9a9dd9e37b497b6 = ()=>{
    if (window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.buildKey;
    return undefined;
};

});

parcelRegister("6OqZp", function(module, exports) {
$parcel$export(module.exports, "fireLegacyEvent", () => $c8a8415239dc4cf3$export$88121588a617f5f9);

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $c8a8415239dc4cf3$export$88121588a617f5f9 = (event, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/analytics/1.0/publish/bulk`;
    const body = [
        event
    ];
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(uri, body, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).toPromise();
};

});


parcelRegister("16el4", function(module, exports) {
$parcel$export(module.exports, "reportAnalyticsEvent", () => $3d02bcc5559a8297$export$4d9f272573494add);

var $9dPOl = parcelRequire("9dPOl");
var $7dUhV = parcelRequire("7dUhV");

var $iziiq = parcelRequire("iziiq");

var $lKEMb = parcelRequire("lKEMb");
const $3d02bcc5559a8297$export$4d9f272573494add = (event)=>{
    try {
        const { analyticsType: analyticsType, action: action, componentName: componentName, actionSubjectId: actionSubjectId, source: source } = [
            ...event.context || [],
            event.payload
        ].reduce((acc, curr)=>({
                ...acc,
                ...curr
            }), {
            eventType: undefined,
            action: undefined,
            componentName: undefined,
            actionSubjectId: undefined,
            source: undefined
        });
        // for screen events, source has the name of the screen
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-template-expressions
        const actionSubject = analyticsType === (0, $iziiq.SCREEN_EVENT_TYPE) ? `screen<${source}>` : componentName;
        if (analyticsType && action && actionSubject) {
            if (analyticsType !== (0, $iziiq.UI_EVENT_TYPE) && analyticsType !== (0, $iziiq.TRACK_EVENT_TYPE) && analyticsType !== (0, $iziiq.OPERATIONAL_EVENT_TYPE) && analyticsType !== (0, $iziiq.SCREEN_EVENT_TYPE)) {
                (0, $lKEMb.devLog)(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                `An event was left out of Sentry breadcrumbs because it had an invalid analyticsType: ${analyticsType}.\nAllowed types: ${[
                    (0, $iziiq.UI_EVENT_TYPE),
                    (0, $iziiq.TRACK_EVENT_TYPE),
                    (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                    (0, $iziiq.SCREEN_EVENT_TYPE)
                ].join(', ')}`);
                return;
            }
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const eventDescription = `${analyticsType} ${action} ${actionSubject}`;
            const eventDescriptionWithId = actionSubjectId ? // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${eventDescription}<${actionSubjectId}>` : eventDescription;
            // omit source for screen events because it's already about them!
            const eventMessage = source && analyticsType !== (0, $iziiq.SCREEN_EVENT_TYPE) ? // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${eventDescriptionWithId} from source<${source}>` : eventDescriptionWithId;
            // Scenario: a user clicks on a button with ID myButton on a screen with ID myScreen
            // Here's what's sent as a breadcrumb: ui clicked button<myButton> from source<myScreen>
            // When some data is missing, it's omitted, so we still get a good idea of what was going on.
            $9dPOl.addBreadcrumb({
                category: 'analytics',
                message: eventMessage,
                level: $7dUhV.Severity.Info
            });
        }
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.error('Error capturing analytics event as Sentry breadcrumb', exception);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        $9dPOl.captureEvent({
            exception: exception,
            message: 'Error capturing analytics event as Sentry breadcrumb'
        });
    }
};

});



parcelRegister("bP2rs", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ec0bc63708d6b60$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $6oezt = parcelRequire("6oezt");

var $aQQg6 = parcelRequire("aQQg6");

var $ldxHn = parcelRequire("ldxHn");
const $1ec0bc63708d6b60$var$AnalyticsListener = (props)=>{
    const isModernContext = (0, $6oezt.default) || (0, $e6Qdr.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ldxHn.default), {
        ...props
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $aQQg6.default), {
        ...props
    });
};
var $1ec0bc63708d6b60$export$2e2bcd8739ae039 = $1ec0bc63708d6b60$var$AnalyticsListener;

});
parcelRegister("aQQg6", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e583eeb10f7fe7c$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $93Fg7 = parcelRequire("93Fg7");

var $i2rB4 = parcelRequire("i2rB4");
const $9e583eeb10f7fe7c$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func
};
const $9e583eeb10f7fe7c$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $9e583eeb10f7fe7c$var$AnalyticsListener extends (0, $8P7DW.Component) {
    static #_ = this.contextTypes = $9e583eeb10f7fe7c$var$ContextTypes;
    static #_2 = this.childContextTypes = $9e583eeb10f7fe7c$var$ContextTypes;
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            }), this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $9e583eeb10f7fe7c$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        }, this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $9e583eeb10f7fe7c$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $i2rB4.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
var $9e583eeb10f7fe7c$export$2e2bcd8739ae039 = $9e583eeb10f7fe7c$var$AnalyticsListener;

});

parcelRegister("ldxHn", function(module, exports) {
$parcel$export(module.exports, "default", () => $a835bf85529329b8$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $i2rB4 = parcelRequire("i2rB4");

var $hixr3 = parcelRequire("hixr3");

var $19XqD = parcelRequire("19XqD");
const $a835bf85529329b8$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $hixr3.useAnalyticsContext)();
    const onEventRef = (0, $19XqD.useTrackedRef)(onEvent);
    const channelRef = (0, $19XqD.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $8P7DW.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $8P7DW.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $i2rB4.default).Provider, {
        value: value,
        children: children
    });
};
var $a835bf85529329b8$export$2e2bcd8739ae039 = $a835bf85529329b8$var$AnalyticsListener;

});


parcelRegister("acg8g", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectCard", () => (parcelRequire("cBSPm")).default);

var $cBSPm = parcelRequire("cBSPm");

});
parcelRegister("cBSPm", function(module, exports) {
$parcel$export(module.exports, "default", () => $6de961ce1e6d035b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $jW99n = parcelRequire("jW99n");

var $l4a5B = parcelRequire("l4a5B");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $37U6z = parcelRequire("37U6z");

var $jjE9o = parcelRequire("jjE9o");
parcelRequire("dvX8Y");
var $kW6YT = parcelRequire("kW6YT");
parcelRequire("iXNah");
var $gzLeM = parcelRequire("gzLeM");
parcelRequire("klfoP");
var $si1h7 = parcelRequire("si1h7");

var $5ePZd = parcelRequire("5ePZd");
const $6de961ce1e6d035b$var$CmdbObjectCard = ({ intl: intl, cmdbObject: cmdbObject })=>{
    var _clientServerBridge$q;
    const [expanded, setExpanded] = (0, $8P7DW.useState)(false);
    const timezoneId = // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    typeof document !== 'undefined' ? (_clientServerBridge$q = (0, $jW99n.default).querySelector('meta[name="user-timezone"]')) === null || _clientServerBridge$q === void 0 ? void 0 : _clientServerBridge$q.getAttribute('content') : undefined;
    (0, $8P7DW.useEffect)(()=>{
        // Fire an event when the component is rendered, to measure successful renders
        if (cmdbObject !== null) (0, $jjE9o.operationalEvent)({
            action: 'rendered',
            actionSubject: 'cmdbObjectCard',
            source: 'cmdbObjectCard'
        });
    }, [
        cmdbObject
    ]);
    if (cmdbObject === null) return intl.formatMessage((0, $5ePZd.default).error);
    const renderChevronButton = ()=>{
        if (cmdbObject.attributes.length === 0) return null;
        const buttonLabel = intl.formatMessage(expanded ? (0, $5ePZd.default).collapseLabel : (0, $5ePZd.default).expandLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $si1h7.ExpandCollapseToggle), {
            isExpanded: expanded,
            label: buttonLabel,
            onClick: ()=>setExpanded(!expanded),
            testId: "cmdb-object-card-expand-collapse-toggle"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $6de961ce1e6d035b$var$containerStyles,
        testId: "cmdb-object-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kW6YT.MemoizedInsightIcon), cmdbObject.avatar.mediaClientConfig), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $6de961ce1e6d035b$var$labelStyles
    }, cmdbObject.label), renderChevronButton()), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $6de961ce1e6d035b$var$attributesListContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gzLeM.AttributeList), {
        attributes: cmdbObject.attributes,
        timezoneId: timezoneId
    })));
};
var $6de961ce1e6d035b$export$2e2bcd8739ae039 = (0, $l4a5B.default)($6de961ce1e6d035b$var$CmdbObjectCard);
const $6de961ce1e6d035b$var$containerStyles = (0, $37U6z.xcss)({
    position: 'relative',
    width: '100%',
    maxWidth: '600px',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    marginBottom: 'space.100',
    padding: 'space.100',
    boxSizing: 'border-box'
});
const $6de961ce1e6d035b$var$labelStyles = (0, $37U6z.xcss)({
    font: 'font.heading.xsmall',
    color: 'color.text.subtle',
    margin: 'space.0',
    paddingLeft: 'space.100',
    flexGrow: 1,
    minWidth: 'space.0',
    overflowWrap: 'break-word'
});
const $6de961ce1e6d035b$var$attributesListContainerStyles = (0, $37U6z.xcss)({
    marginTop: 'space.200'
});

});
parcelRegister("6Hfjm", function(module, exports) {
$parcel$export(module.exports, "Box", () => $1e2bbf5c3dcd623f$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $1e2bbf5c3dcd623f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $YDqMU = parcelRequire("YDqMU");

var $j4RVe = parcelRequire("j4RVe");

var $37U6z = parcelRequire("37U6z");
function $1e2bbf5c3dcd623f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e2bbf5c3dcd623f$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $37U6z.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $8Z0o8.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $1e2bbf5c3dcd623f$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $j4RVe.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $j4RVe.isSurfaceColorToken)(backgroundColor) && (0, $j4RVe.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $j4RVe.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $j4RVe.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $j4RVe.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $j4RVe.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $j4RVe.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $j4RVe.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $j4RVe.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $YDqMU.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $1e2bbf5c3dcd623f$export$2e2bcd8739ae039 = $1e2bbf5c3dcd623f$export$e71c4d32a2263218;
const $1e2bbf5c3dcd623f$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("8Z0o8", function(module, exports) {
$parcel$export(module.exports, "Global", () => $68a45257090f7a02$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $68a45257090f7a02$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $68a45257090f7a02$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $68a45257090f7a02$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $68a45257090f7a02$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("cZiJt")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("cZiJt")).w);

var $cZiJt = parcelRequire("cZiJt");

var $8P7DW = parcelRequire("8P7DW");

var $aQXFp = parcelRequire("aQXFp");

var $iULns = parcelRequire("iULns");

var $jcYcQ = parcelRequire("jcYcQ");
parcelRequire("cOW1h");
parcelRequire("cCnFQ");
parcelRequire("5Txo2");

parcelRequire("fG5y9");
var $68a45257090f7a02$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $68a45257090f7a02$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $cZiJt.h).call(props, 'css')) // $FlowFixMe
    return $8P7DW.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $cZiJt.E);
    createElementArgArray[1] = (0, $cZiJt.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $8P7DW.createElement.apply(null, createElementArgArray);
};
var $68a45257090f7a02$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $68a45257090f7a02$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $cZiJt.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $jcYcQ.serializeStyles)([
        styles
    ], undefined, $8P7DW.useContext((0, $cZiJt.T)));
    if (!(0, $cZiJt.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8P7DW.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8P7DW.useRef();
    (0, $iULns.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $iULns.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $aQXFp.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $68a45257090f7a02$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $jcYcQ.serializeStyles)(args);
}
var $68a45257090f7a02$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $68a45257090f7a02$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $68a45257090f7a02$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $68a45257090f7a02$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $aQXFp.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $68a45257090f7a02$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $iULns.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $aQXFp.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $68a45257090f7a02$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $cZiJt.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $jcYcQ.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $aQXFp.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $68a45257090f7a02$var$merge(cache.registered, css, $68a45257090f7a02$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8P7DW.useContext((0, $cZiJt.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement($68a45257090f7a02$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $68a45257090f7a02$var$isBrowser, $68a45257090f7a02$var$isTestEnv, $68a45257090f7a02$var$globalContext, $68a45257090f7a02$var$globalKey;

});
parcelRegister("cZiJt", function(module, exports) {
$parcel$export(module.exports, "i", () => $9749b6682714d5b3$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $9749b6682714d5b3$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $9749b6682714d5b3$export$e7094788287c5e9b);
$parcel$export(module.exports, "_", () => $9749b6682714d5b3$export$71511d61b312f219);
$parcel$export(module.exports, "w", () => $9749b6682714d5b3$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $9749b6682714d5b3$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $9749b6682714d5b3$export$3b14a55fb2447963);
$parcel$export(module.exports, "a", () => $9749b6682714d5b3$export$407448d2b89b1813);
$parcel$export(module.exports, "b", () => $9749b6682714d5b3$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "c", () => $9749b6682714d5b3$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $9749b6682714d5b3$export$a9c23c6ac3fc3eca);

var $8P7DW = parcelRequire("8P7DW");

var $cOW1h = parcelRequire("cOW1h");

var $cCnFQ = parcelRequire("cCnFQ");

var $5Txo2 = parcelRequire("5Txo2");

var $jy8ZC = parcelRequire("jy8ZC");

var $aQXFp = parcelRequire("aQXFp");

var $jcYcQ = parcelRequire("jcYcQ");

var $iULns = parcelRequire("iULns");
var $9749b6682714d5b3$export$23f2a1d2818174ef = true;
var $9749b6682714d5b3$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $9749b6682714d5b3$var$EmotionCacheContext = /* #__PURE__ */ $8P7DW.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $cOW1h.default)({
    key: 'css'
}) : null);
var $9749b6682714d5b3$export$e7094788287c5e9b = $9749b6682714d5b3$var$EmotionCacheContext.Provider;
var $9749b6682714d5b3$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8P7DW.useContext)($9749b6682714d5b3$var$EmotionCacheContext);
};
var $9749b6682714d5b3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $8P7DW.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8P7DW.useContext)($9749b6682714d5b3$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$9749b6682714d5b3$export$23f2a1d2818174ef) $9749b6682714d5b3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8P7DW.useContext)($9749b6682714d5b3$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $cOW1h.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8P7DW.createElement($9749b6682714d5b3$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $9749b6682714d5b3$export$971d5caa766a69d7 = /* #__PURE__ */ $8P7DW.createContext({});
var $9749b6682714d5b3$export$3b14a55fb2447963 = function useTheme() {
    return $8P7DW.useContext($9749b6682714d5b3$export$971d5caa766a69d7);
};
var $9749b6682714d5b3$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $cCnFQ.default)({}, outerTheme, theme);
};
var $9749b6682714d5b3$var$createCacheWithTheme = /* #__PURE__ */ (0, $5Txo2.default)(function(outerTheme) {
    return (0, $5Txo2.default)(function(theme) {
        return $9749b6682714d5b3$var$getTheme(outerTheme, theme);
    });
});
var $9749b6682714d5b3$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $8P7DW.useContext($9749b6682714d5b3$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $9749b6682714d5b3$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8P7DW.createElement($9749b6682714d5b3$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $9749b6682714d5b3$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $8P7DW.useContext($9749b6682714d5b3$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8P7DW.createElement(Component, (0, $cCnFQ.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $8P7DW.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $jy8ZC.default)(WithTheme, Component);
}
var $9749b6682714d5b3$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $9749b6682714d5b3$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $9749b6682714d5b3$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $9749b6682714d5b3$var$getLastPart(match[1]);
    return undefined;
};
var $9749b6682714d5b3$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $9749b6682714d5b3$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $9749b6682714d5b3$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $9749b6682714d5b3$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($9749b6682714d5b3$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $9749b6682714d5b3$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $9749b6682714d5b3$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $9749b6682714d5b3$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $9749b6682714d5b3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($9749b6682714d5b3$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$9749b6682714d5b3$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $9749b6682714d5b3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $aQXFp.registerStyles)(cache, serialized, isStringTag);
    (0, $iULns.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $aQXFp.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $9749b6682714d5b3$var$Emotion = /* #__PURE__ */ $9749b6682714d5b3$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$9749b6682714d5b3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $aQXFp.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $jcYcQ.serializeStyles)(registeredStyles, undefined, $8P7DW.useContext($9749b6682714d5b3$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($9749b6682714d5b3$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $9749b6682714d5b3$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement($9749b6682714d5b3$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8P7DW.createElement(WrappedComponent, newProps));
});
var $9749b6682714d5b3$export$a9c23c6ac3fc3eca = $9749b6682714d5b3$var$Emotion;

});
parcelRegister("cOW1h", function(module, exports) {
$parcel$export(module.exports, "default", () => $95572910224bde5b$export$2e2bcd8739ae039);

var $5pNYN = parcelRequire("5pNYN");

var $aVAig = parcelRequire("aVAig");
var $g7IrH = parcelRequire("g7IrH");
var $fqnx2 = parcelRequire("fqnx2");
var $lVs31 = parcelRequire("lVs31");
var $7yU1G = parcelRequire("7yU1G");
var $1XdHb = parcelRequire("1XdHb");
parcelRequire("5Txo2");
parcelRequire("jr7zY");
var $95572910224bde5b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $aVAig.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $aVAig.token)(character)) break;
        (0, $aVAig.next)();
    }
    return (0, $aVAig.slice)(begin, (0, $aVAig.position));
};
var $95572910224bde5b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $aVAig.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $aVAig.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $95572910224bde5b$var$identifierWithPointTracking((0, $aVAig.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $aVAig.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $aVAig.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $g7IrH.from)(character);
    }
    while (character = (0, $aVAig.next)());
    return parsed;
};
var $95572910224bde5b$var$getRules = function getRules(value, points) {
    return (0, $aVAig.dealloc)($95572910224bde5b$var$toRules((0, $aVAig.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $95572910224bde5b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $95572910224bde5b$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$95572910224bde5b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $95572910224bde5b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $95572910224bde5b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $95572910224bde5b$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $95572910224bde5b$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $95572910224bde5b$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($95572910224bde5b$var$ignoreFlag) > -1;
};
var $95572910224bde5b$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($95572910224bde5b$var$isIgnoringComment(node)) return;
                    break;
                }
            }
        }
    };
};
var $95572910224bde5b$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $95572910224bde5b$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$95572910224bde5b$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $95572910224bde5b$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $95572910224bde5b$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$95572910224bde5b$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $95572910224bde5b$var$nullifyElement(element);
    } else if ($95572910224bde5b$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $95572910224bde5b$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $95572910224bde5b$var$prefix(value, length) {
    switch((0, $g7IrH.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lVs31.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lVs31.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MOZ) + value + (0, $lVs31.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + value + value;
        // order
        case 6165:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $lVs31.WEBKIT) + value + (0, $g7IrH.replace)(value, /(\w+).+(:[^]+)/, (0, $lVs31.WEBKIT) + 'box-$1$2' + (0, $lVs31.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + 'flex-item-' + (0, $g7IrH.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + 'flex-line-pack' + (0, $g7IrH.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $lVs31.WEBKIT) + 'box-' + (0, $g7IrH.replace)(value, '-grow', '') + (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $lVs31.WEBKIT) + (0, $g7IrH.replace)(value, /([^-])(transform)/g, '$1' + (0, $lVs31.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $g7IrH.replace)((0, $g7IrH.replace)((0, $g7IrH.replace)(value, /(zoom-|grab)/, (0, $lVs31.WEBKIT) + '$1'), /(image-set)/, (0, $lVs31.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $g7IrH.replace)(value, /(image-set\([^]*)/, (0, $lVs31.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $g7IrH.replace)((0, $g7IrH.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lVs31.WEBKIT) + 'box-pack:$3' + (0, $lVs31.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $lVs31.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $g7IrH.replace)(value, /(.+)-inline(.+)/, (0, $lVs31.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $g7IrH.strlen)(value) - 1 - length > 6) switch((0, $g7IrH.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $g7IrH.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $g7IrH.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $lVs31.WEBKIT) + '$2-$3' + '$1' + (0, $lVs31.MOZ) + ((0, $g7IrH.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $g7IrH.indexof)(value, 'stretch') ? $95572910224bde5b$var$prefix((0, $g7IrH.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $g7IrH.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $g7IrH.charat)(value, (0, $g7IrH.strlen)(value) - 3 - (~(0, $g7IrH.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $g7IrH.replace)(value, ':', ':' + (0, $lVs31.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $g7IrH.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $lVs31.WEBKIT) + ((0, $g7IrH.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $lVs31.WEBKIT) + '$2$3' + '$1' + (0, $lVs31.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $g7IrH.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + value + value;
    }
    return value;
}
var $95572910224bde5b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $lVs31.DECLARATION:
                element["return"] = $95572910224bde5b$var$prefix(element.value, element.length);
                break;
            case 0, $lVs31.KEYFRAMES:
                return (0, $1XdHb.serialize)([
                    (0, $aVAig.copy)(element, {
                        value: (0, $g7IrH.replace)(element.value, '@', '@' + (0, $lVs31.WEBKIT))
                    })
                ], callback);
            case 0, $lVs31.RULESET:
                if (element.length) return (0, $g7IrH.combine)(element.props, function(value) {
                    switch((0, $g7IrH.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $1XdHb.serialize)([
                                (0, $aVAig.copy)(element, {
                                    props: [
                                        (0, $g7IrH.replace)(value, /:(read-\w+)/, ':' + (0, $lVs31.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $1XdHb.serialize)([
                                (0, $aVAig.copy)(element, {
                                    props: [
                                        (0, $g7IrH.replace)(value, /:(plac\w+)/, ':' + (0, $lVs31.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $aVAig.copy)(element, {
                                    props: [
                                        (0, $g7IrH.replace)(value, /:(plac\w+)/, ':' + (0, $lVs31.MOZ) + '$1')
                                    ]
                                }),
                                (0, $aVAig.copy)(element, {
                                    props: [
                                        (0, $g7IrH.replace)(value, /:(plac\w+)/, (0, $lVs31.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $95572910224bde5b$var$defaultStylisPlugins = [
    $95572910224bde5b$var$prefixer
];
var $95572910224bde5b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $95572910224bde5b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $95572910224bde5b$var$compat,
        $95572910224bde5b$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $1XdHb.stringify),
        (0, $7yU1G.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $7yU1G.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $1XdHb.serialize)((0, $fqnx2.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $5pNYN.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("5pNYN", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $3f160e7271031182$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $3f160e7271031182$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $3f160e7271031182$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3f160e7271031182$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3f160e7271031182$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $3f160e7271031182$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("aVAig", function(module, exports) {
$parcel$export(module.exports, "position", () => $7f4b616da4527a1d$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $7f4b616da4527a1d$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $7f4b616da4527a1d$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $7f4b616da4527a1d$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $7f4b616da4527a1d$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $7f4b616da4527a1d$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $7f4b616da4527a1d$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $7f4b616da4527a1d$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $7f4b616da4527a1d$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $7f4b616da4527a1d$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $7f4b616da4527a1d$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $7f4b616da4527a1d$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $7f4b616da4527a1d$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $7f4b616da4527a1d$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $7f4b616da4527a1d$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $7f4b616da4527a1d$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $7f4b616da4527a1d$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $7f4b616da4527a1d$export$4254d4e2b3745c4c);

var $g7IrH = parcelRequire("g7IrH");
var $7f4b616da4527a1d$export$53f1d5ea8de3d7c = 1;
var $7f4b616da4527a1d$export$4e0c71f277ca26b3 = 1;
var $7f4b616da4527a1d$export$f24224f1c91d8156 = 0;
var $7f4b616da4527a1d$export$5880b8b5730aff45 = 0;
var $7f4b616da4527a1d$export$c0306caf338ac095 = 0;
var $7f4b616da4527a1d$export$30a86d91af8ff6e6 = '';
function $7f4b616da4527a1d$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $7f4b616da4527a1d$export$53f1d5ea8de3d7c,
        column: $7f4b616da4527a1d$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $7f4b616da4527a1d$export$784d13d8ee351f07(root, props) {
    return (0, $g7IrH.assign)($7f4b616da4527a1d$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $7f4b616da4527a1d$export$eba6f6f03b0a92e7() {
    return $7f4b616da4527a1d$export$c0306caf338ac095;
}
function $7f4b616da4527a1d$export$232faf9add678146() {
    $7f4b616da4527a1d$export$c0306caf338ac095 = $7f4b616da4527a1d$export$5880b8b5730aff45 > 0 ? (0, $g7IrH.charat)($7f4b616da4527a1d$export$30a86d91af8ff6e6, --$7f4b616da4527a1d$export$5880b8b5730aff45) : 0;
    if ($7f4b616da4527a1d$export$4e0c71f277ca26b3--, $7f4b616da4527a1d$export$c0306caf338ac095 === 10) $7f4b616da4527a1d$export$4e0c71f277ca26b3 = 1, $7f4b616da4527a1d$export$53f1d5ea8de3d7c--;
    return $7f4b616da4527a1d$export$c0306caf338ac095;
}
function $7f4b616da4527a1d$export$48cfd1e771a65c4f() {
    $7f4b616da4527a1d$export$c0306caf338ac095 = $7f4b616da4527a1d$export$5880b8b5730aff45 < $7f4b616da4527a1d$export$f24224f1c91d8156 ? (0, $g7IrH.charat)($7f4b616da4527a1d$export$30a86d91af8ff6e6, $7f4b616da4527a1d$export$5880b8b5730aff45++) : 0;
    if ($7f4b616da4527a1d$export$4e0c71f277ca26b3++, $7f4b616da4527a1d$export$c0306caf338ac095 === 10) $7f4b616da4527a1d$export$4e0c71f277ca26b3 = 1, $7f4b616da4527a1d$export$53f1d5ea8de3d7c++;
    return $7f4b616da4527a1d$export$c0306caf338ac095;
}
function $7f4b616da4527a1d$export$4d3fb11e950abb9e() {
    return (0, $g7IrH.charat)($7f4b616da4527a1d$export$30a86d91af8ff6e6, $7f4b616da4527a1d$export$5880b8b5730aff45);
}
function $7f4b616da4527a1d$export$e88cb2efb12ae807() {
    return $7f4b616da4527a1d$export$5880b8b5730aff45;
}
function $7f4b616da4527a1d$export$58adb3bec8346d0f(begin, end) {
    return (0, $g7IrH.substr)($7f4b616da4527a1d$export$30a86d91af8ff6e6, begin, end);
}
function $7f4b616da4527a1d$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $7f4b616da4527a1d$export$2de70f21292aac9e(value) {
    return $7f4b616da4527a1d$export$53f1d5ea8de3d7c = $7f4b616da4527a1d$export$4e0c71f277ca26b3 = 1, $7f4b616da4527a1d$export$f24224f1c91d8156 = (0, $g7IrH.strlen)($7f4b616da4527a1d$export$30a86d91af8ff6e6 = value), $7f4b616da4527a1d$export$5880b8b5730aff45 = 0, [];
}
function $7f4b616da4527a1d$export$45918ac1574455b1(value) {
    return $7f4b616da4527a1d$export$30a86d91af8ff6e6 = '', value;
}
function $7f4b616da4527a1d$export$410ac95b9ec204b8(type) {
    return (0, $g7IrH.trim)($7f4b616da4527a1d$export$58adb3bec8346d0f($7f4b616da4527a1d$export$5880b8b5730aff45 - 1, $7f4b616da4527a1d$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $7f4b616da4527a1d$export$660b2ee2d4fb4eff(value) {
    return $7f4b616da4527a1d$export$45918ac1574455b1($7f4b616da4527a1d$export$5f8c09e3ae6f64e1($7f4b616da4527a1d$export$2de70f21292aac9e(value)));
}
function $7f4b616da4527a1d$export$7af1228ff777d175(type) {
    while($7f4b616da4527a1d$export$c0306caf338ac095 = $7f4b616da4527a1d$export$4d3fb11e950abb9e())if ($7f4b616da4527a1d$export$c0306caf338ac095 < 33) $7f4b616da4527a1d$export$48cfd1e771a65c4f();
    else break;
    return $7f4b616da4527a1d$export$9e1725a4cfeada27(type) > 2 || $7f4b616da4527a1d$export$9e1725a4cfeada27($7f4b616da4527a1d$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $7f4b616da4527a1d$export$5f8c09e3ae6f64e1(children) {
    while($7f4b616da4527a1d$export$48cfd1e771a65c4f())switch($7f4b616da4527a1d$export$9e1725a4cfeada27($7f4b616da4527a1d$export$c0306caf338ac095)){
        case 0:
            (0, $g7IrH.append)($7f4b616da4527a1d$export$c2ab62c7bf24634($7f4b616da4527a1d$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $g7IrH.append)($7f4b616da4527a1d$export$410ac95b9ec204b8($7f4b616da4527a1d$export$c0306caf338ac095), children);
            break;
        default:
            (0, $g7IrH.append)((0, $g7IrH.from)($7f4b616da4527a1d$export$c0306caf338ac095), children);
    }
    return children;
}
function $7f4b616da4527a1d$export$955ba06d119e085e(index, count) {
    while(--count && $7f4b616da4527a1d$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($7f4b616da4527a1d$export$c0306caf338ac095 < 48 || $7f4b616da4527a1d$export$c0306caf338ac095 > 102 || $7f4b616da4527a1d$export$c0306caf338ac095 > 57 && $7f4b616da4527a1d$export$c0306caf338ac095 < 65 || $7f4b616da4527a1d$export$c0306caf338ac095 > 70 && $7f4b616da4527a1d$export$c0306caf338ac095 < 97) break;
    return $7f4b616da4527a1d$export$58adb3bec8346d0f(index, $7f4b616da4527a1d$export$e88cb2efb12ae807() + (count < 6 && $7f4b616da4527a1d$export$4d3fb11e950abb9e() == 32 && $7f4b616da4527a1d$export$48cfd1e771a65c4f() == 32));
}
function $7f4b616da4527a1d$export$c889f2fcc19dbf12(type) {
    while($7f4b616da4527a1d$export$48cfd1e771a65c4f())switch($7f4b616da4527a1d$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $7f4b616da4527a1d$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $7f4b616da4527a1d$export$c889f2fcc19dbf12($7f4b616da4527a1d$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $7f4b616da4527a1d$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $7f4b616da4527a1d$export$48cfd1e771a65c4f();
            break;
    }
    return $7f4b616da4527a1d$export$5880b8b5730aff45;
}
function $7f4b616da4527a1d$export$4254d4e2b3745c4c(type, index) {
    while($7f4b616da4527a1d$export$48cfd1e771a65c4f())// //
    if (type + $7f4b616da4527a1d$export$c0306caf338ac095 === 57) break;
    else if (type + $7f4b616da4527a1d$export$c0306caf338ac095 === 84 && $7f4b616da4527a1d$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $7f4b616da4527a1d$export$58adb3bec8346d0f(index, $7f4b616da4527a1d$export$5880b8b5730aff45 - 1) + '*' + (0, $g7IrH.from)(type === 47 ? type : $7f4b616da4527a1d$export$48cfd1e771a65c4f());
}
function $7f4b616da4527a1d$export$c2ab62c7bf24634(index) {
    while(!$7f4b616da4527a1d$export$9e1725a4cfeada27($7f4b616da4527a1d$export$4d3fb11e950abb9e()))$7f4b616da4527a1d$export$48cfd1e771a65c4f();
    return $7f4b616da4527a1d$export$58adb3bec8346d0f(index, $7f4b616da4527a1d$export$5880b8b5730aff45);
}

});
parcelRegister("g7IrH", function(module, exports) {
$parcel$export(module.exports, "abs", () => $bbcfc6cf13bb5a75$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $bbcfc6cf13bb5a75$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $bbcfc6cf13bb5a75$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $bbcfc6cf13bb5a75$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $bbcfc6cf13bb5a75$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $bbcfc6cf13bb5a75$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $bbcfc6cf13bb5a75$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $bbcfc6cf13bb5a75$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $bbcfc6cf13bb5a75$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $bbcfc6cf13bb5a75$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $bbcfc6cf13bb5a75$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $bbcfc6cf13bb5a75$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $bbcfc6cf13bb5a75$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $bbcfc6cf13bb5a75$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $bbcfc6cf13bb5a75$export$2335f513bbd82c6d = Math.abs;
var $bbcfc6cf13bb5a75$export$6788812c4e6611e6 = String.fromCharCode;
var $bbcfc6cf13bb5a75$export$e6e34fd1f2686227 = Object.assign;
function $bbcfc6cf13bb5a75$export$d6af199866bfb566(value, length) {
    return $bbcfc6cf13bb5a75$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $bbcfc6cf13bb5a75$export$a9db5e087081082d(value, 0)) << 2 ^ $bbcfc6cf13bb5a75$export$a9db5e087081082d(value, 1)) << 2 ^ $bbcfc6cf13bb5a75$export$a9db5e087081082d(value, 2)) << 2 ^ $bbcfc6cf13bb5a75$export$a9db5e087081082d(value, 3) : 0;
}
function $bbcfc6cf13bb5a75$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $bbcfc6cf13bb5a75$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $bbcfc6cf13bb5a75$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $bbcfc6cf13bb5a75$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $bbcfc6cf13bb5a75$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $bbcfc6cf13bb5a75$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $bbcfc6cf13bb5a75$export$36776f635604f274(value) {
    return value.length;
}
function $bbcfc6cf13bb5a75$export$f9084667e487ed46(value) {
    return value.length;
}
function $bbcfc6cf13bb5a75$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $bbcfc6cf13bb5a75$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("fqnx2", function(module, exports) {
$parcel$export(module.exports, "compile", () => $b3ab89a525a1371b$export$ef7acd7185315e22);

var $lVs31 = parcelRequire("lVs31");

var $g7IrH = parcelRequire("g7IrH");

var $aVAig = parcelRequire("aVAig");
function $b3ab89a525a1371b$export$ef7acd7185315e22(value) {
    return (0, $aVAig.dealloc)($b3ab89a525a1371b$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $aVAig.alloc)(value), 0, [
        0
    ], value));
}
function $b3ab89a525a1371b$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $aVAig.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $g7IrH.charat)(characters, length - 1) == 58) {
                if ((0, $g7IrH.indexof)(characters += (0, $g7IrH.replace)((0, $aVAig.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $aVAig.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $aVAig.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $aVAig.escaping)((0, $aVAig.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $aVAig.peek)()){
                case 42:
                case 47:
                    (0, $g7IrH.append)($b3ab89a525a1371b$export$4a34f930e789283c((0, $aVAig.commenter)((0, $aVAig.next)(), (0, $aVAig.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $g7IrH.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $g7IrH.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $g7IrH.strlen)(characters) - length) (0, $g7IrH.append)(property > 32 ? $b3ab89a525a1371b$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $b3ab89a525a1371b$export$f8483753829ec8f3((0, $g7IrH.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $g7IrH.append)(reference = $b3ab89a525a1371b$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $b3ab89a525a1371b$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $g7IrH.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $b3ab89a525a1371b$export$98e6a39c04603d36(value, reference, reference, rule && (0, $g7IrH.append)($b3ab89a525a1371b$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $b3ab89a525a1371b$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $g7IrH.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $aVAig.prev)() == 125) continue;
            }
            switch(characters += (0, $g7IrH.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $g7IrH.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $aVAig.peek)() === 45) characters += (0, $aVAig.delimit)((0, $aVAig.next)());
                    atrule = (0, $aVAig.peek)(), offset = length = (0, $g7IrH.strlen)(type = characters += (0, $aVAig.identifier)((0, $aVAig.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $g7IrH.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $b3ab89a525a1371b$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $g7IrH.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $g7IrH.substr)(value, post + 1, post = (0, $g7IrH.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $g7IrH.trim)(j > 0 ? rule[x] + ' ' + y : (0, $g7IrH.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $aVAig.node)(value, root, parent, offset === 0 ? (0, $lVs31.RULESET) : type, props, children, length);
}
function $b3ab89a525a1371b$export$4a34f930e789283c(value, root, parent) {
    return (0, $aVAig.node)(value, root, parent, (0, $lVs31.COMMENT), (0, $g7IrH.from)((0, $aVAig.char)()), (0, $g7IrH.substr)(value, 2, -2), 0);
}
function $b3ab89a525a1371b$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $aVAig.node)(value, root, parent, (0, $lVs31.DECLARATION), (0, $g7IrH.substr)(value, 0, length), (0, $g7IrH.substr)(value, length + 1, -1), length);
}

});
parcelRegister("lVs31", function(module, exports) {
$parcel$export(module.exports, "MS", () => $ff64ad8ea7e089c7$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $ff64ad8ea7e089c7$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $ff64ad8ea7e089c7$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $ff64ad8ea7e089c7$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $ff64ad8ea7e089c7$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $ff64ad8ea7e089c7$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $ff64ad8ea7e089c7$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $ff64ad8ea7e089c7$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $ff64ad8ea7e089c7$export$d773506282b3cfe6);
var $ff64ad8ea7e089c7$export$71ad59f2e432cfe8 = '-ms-';
var $ff64ad8ea7e089c7$export$2c0f367103c8d01c = '-moz-';
var $ff64ad8ea7e089c7$export$39dfd62a25e0fe93 = '-webkit-';
var $ff64ad8ea7e089c7$export$a29989082612d0d9 = 'comm';
var $ff64ad8ea7e089c7$export$aa3a2e812ca8570d = 'rule';
var $ff64ad8ea7e089c7$export$527d108ccf083c2b = 'decl';
var $ff64ad8ea7e089c7$export$d3d35020fa5b54f0 = '@page';
var $ff64ad8ea7e089c7$export$500415a86c544f73 = '@media';
var $ff64ad8ea7e089c7$export$a763edbf796b780a = '@import';
var $ff64ad8ea7e089c7$export$2790aeb8b4e5c826 = '@charset';
var $ff64ad8ea7e089c7$export$1cc683e23b84b133 = '@viewport';
var $ff64ad8ea7e089c7$export$9447a5efea57e862 = '@supports';
var $ff64ad8ea7e089c7$export$ef011b4e114b1fba = '@document';
var $ff64ad8ea7e089c7$export$6aad947bda0f3f46 = '@namespace';
var $ff64ad8ea7e089c7$export$b44a8529a35fcb60 = '@keyframes';
var $ff64ad8ea7e089c7$export$2c16de31893252e6 = '@font-face';
var $ff64ad8ea7e089c7$export$3d846dd52e150c6f = '@counter-style';
var $ff64ad8ea7e089c7$export$22314bfbb57653fe = '@font-feature-values';
var $ff64ad8ea7e089c7$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("7yU1G", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $58172b06c0f44f18$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $58172b06c0f44f18$export$38bcb760f1d4871c);

var $lVs31 = parcelRequire("lVs31");

var $g7IrH = parcelRequire("g7IrH");

var $aVAig = parcelRequire("aVAig");

var $1XdHb = parcelRequire("1XdHb");

var $5PsHq = parcelRequire("5PsHq");
function $58172b06c0f44f18$export$5a7767152ae0305f(collection) {
    var length = (0, $g7IrH.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $58172b06c0f44f18$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $58172b06c0f44f18$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $lVs31.DECLARATION:
                element.return = (0, $5PsHq.prefix)(element.value, element.length, children);
                return;
            case 0, $lVs31.KEYFRAMES:
                return (0, $1XdHb.serialize)([
                    (0, $aVAig.copy)(element, {
                        value: (0, $g7IrH.replace)(element.value, '@', '@' + (0, $lVs31.WEBKIT))
                    })
                ], callback);
            case 0, $lVs31.RULESET:
                if (element.length) return (0, $g7IrH.combine)(element.props, function(value) {
                    switch((0, $g7IrH.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $1XdHb.serialize)([
                                (0, $aVAig.copy)(element, {
                                    props: [
                                        (0, $g7IrH.replace)(value, /:(read-\w+)/, ':' + (0, $lVs31.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $1XdHb.serialize)([
                                (0, $aVAig.copy)(element, {
                                    props: [
                                        (0, $g7IrH.replace)(value, /:(plac\w+)/, ':' + (0, $lVs31.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $aVAig.copy)(element, {
                                    props: [
                                        (0, $g7IrH.replace)(value, /:(plac\w+)/, ':' + (0, $lVs31.MOZ) + '$1')
                                    ]
                                }),
                                (0, $aVAig.copy)(element, {
                                    props: [
                                        (0, $g7IrH.replace)(value, /:(plac\w+)/, (0, $lVs31.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $58172b06c0f44f18$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $lVs31.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $g7IrH.combine)((0, $aVAig.tokenize)(value), function(value, index, children) {
                    switch((0, $g7IrH.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $g7IrH.substr)(value, 1, (0, $g7IrH.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $g7IrH.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $g7IrH.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $g7IrH.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("1XdHb", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $16c5ecccb184d6c5$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $16c5ecccb184d6c5$export$fac44ee5b035f737);

var $lVs31 = parcelRequire("lVs31");

var $g7IrH = parcelRequire("g7IrH");
function $16c5ecccb184d6c5$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $g7IrH.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $16c5ecccb184d6c5$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $lVs31.LAYER:
            if (element.children.length) break;
        case 0, $lVs31.IMPORT:
        case 0, $lVs31.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $lVs31.COMMENT:
            return '';
        case 0, $lVs31.KEYFRAMES:
            return element.return = element.value + '{' + $16c5ecccb184d6c5$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $lVs31.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $g7IrH.strlen)(children = $16c5ecccb184d6c5$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("5PsHq", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $43e7fa4051e16f4a$export$82e9f45cca5ba907);

var $lVs31 = parcelRequire("lVs31");

var $g7IrH = parcelRequire("g7IrH");
function $43e7fa4051e16f4a$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $g7IrH.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lVs31.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lVs31.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $lVs31.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MOZ) + value + (0, $lVs31.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $g7IrH.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + value + value;
        // order
        case 6165:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $lVs31.WEBKIT) + value + (0, $g7IrH.replace)(value, /(\w+).+(:[^]+)/, (0, $lVs31.WEBKIT) + 'box-$1$2' + (0, $lVs31.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + 'flex-item-' + (0, $g7IrH.replace)(value, /flex-|-self/g, '') + (!(0, $g7IrH.match)(value, /flex-|baseline/) ? (0, $lVs31.MS) + 'grid-row-' + (0, $g7IrH.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + 'flex-line-pack' + (0, $g7IrH.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $lVs31.WEBKIT) + 'box-' + (0, $g7IrH.replace)(value, '-grow', '') + (0, $lVs31.WEBKIT) + value + (0, $lVs31.MS) + (0, $g7IrH.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $lVs31.WEBKIT) + (0, $g7IrH.replace)(value, /([^-])(transform)/g, '$1' + (0, $lVs31.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $g7IrH.replace)((0, $g7IrH.replace)((0, $g7IrH.replace)(value, /(zoom-|grab)/, (0, $lVs31.WEBKIT) + '$1'), /(image-set)/, (0, $lVs31.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $g7IrH.replace)(value, /(image-set\([^]*)/, (0, $lVs31.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $g7IrH.replace)((0, $g7IrH.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lVs31.WEBKIT) + 'box-pack:$3' + (0, $lVs31.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $lVs31.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $g7IrH.match)(value, /flex-|baseline/)) return (0, $lVs31.MS) + 'grid-column-align' + (0, $g7IrH.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $lVs31.MS) + (0, $g7IrH.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $g7IrH.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $g7IrH.indexof)(value + (children = children[length].value), 'span') ? value : (0, $lVs31.MS) + (0, $g7IrH.replace)(value, '-start', '') + value + (0, $lVs31.MS) + 'grid-row-span:' + (~(0, $g7IrH.indexof)(children, 'span') ? (0, $g7IrH.match)(children, /\d+/) : +(0, $g7IrH.match)(children, /\d+/) - +(0, $g7IrH.match)(value, /\d+/)) + ';';
            return (0, $lVs31.MS) + (0, $g7IrH.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $g7IrH.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $lVs31.MS) + (0, $g7IrH.replace)((0, $g7IrH.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $g7IrH.replace)(value, /(.+)-inline(.+)/, (0, $lVs31.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $g7IrH.strlen)(value) - 1 - length > 6) switch((0, $g7IrH.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $g7IrH.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $g7IrH.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $lVs31.WEBKIT) + '$2-$3' + '$1' + (0, $lVs31.MOZ) + ((0, $g7IrH.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $g7IrH.indexof)(value, 'stretch') ? $43e7fa4051e16f4a$export$82e9f45cca5ba907((0, $g7IrH.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $g7IrH.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $lVs31.MS) + a + ':' + b + f + (c ? (0, $lVs31.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $g7IrH.charat)(value, length + 6) === 121) return (0, $g7IrH.replace)(value, ':', ':' + (0, $lVs31.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $g7IrH.charat)(value, (0, $g7IrH.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $g7IrH.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $lVs31.WEBKIT) + ((0, $g7IrH.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $lVs31.WEBKIT) + '$2$3' + '$1' + (0, $lVs31.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $g7IrH.replace)(value, ':', ':' + (0, $lVs31.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $g7IrH.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("5Txo2", function(module, exports) {
$parcel$export(module.exports, "default", () => $44abfcb904313ddb$export$2e2bcd8739ae039);
var $44abfcb904313ddb$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("jr7zY", function(module, exports) {
function $e2666aff81039b34$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("jy8ZC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3b82b140b55a444$export$2e2bcd8739ae039);

var $fG5y9 = parcelRequire("fG5y9");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $e3b82b140b55a444$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fG5y9)))(targetComponent, sourceComponent);
};

});

parcelRegister("aQXFp", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $7e6d0b5254998ed1$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $7e6d0b5254998ed1$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $7e6d0b5254998ed1$export$6f077d94b33a01aa);
var $7e6d0b5254998ed1$var$isBrowser = true;
function $7e6d0b5254998ed1$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $7e6d0b5254998ed1$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $7e6d0b5254998ed1$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $7e6d0b5254998ed1$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $7e6d0b5254998ed1$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("jcYcQ", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $dfbdd703603b20f0$export$6321afa313b251b5);

var $ikd0W = parcelRequire("ikd0W");

var $5JQpV = parcelRequire("5JQpV");

var $3t5HD = parcelRequire("3t5HD");
var $dfbdd703603b20f0$var$isDevelopment = false;
var $dfbdd703603b20f0$var$hyphenateRegex = /[A-Z]|^ms/g;
var $dfbdd703603b20f0$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $dfbdd703603b20f0$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $dfbdd703603b20f0$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $dfbdd703603b20f0$var$processStyleName = /* #__PURE__ */ (0, $3t5HD.default)(function(styleName) {
    return $dfbdd703603b20f0$var$isCustomProperty(styleName) ? styleName : styleName.replace($dfbdd703603b20f0$var$hyphenateRegex, '-$&').toLowerCase();
});
var $dfbdd703603b20f0$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($dfbdd703603b20f0$var$animationRegex, function(match, p1, p2) {
                $dfbdd703603b20f0$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $dfbdd703603b20f0$var$cursor
                };
                return p1;
            });
    }
    if ((0, $5JQpV.default)[key] !== 1 && !$dfbdd703603b20f0$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $dfbdd703603b20f0$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $dfbdd703603b20f0$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $dfbdd703603b20f0$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $dfbdd703603b20f0$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $dfbdd703603b20f0$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $dfbdd703603b20f0$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $dfbdd703603b20f0$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $dfbdd703603b20f0$var$cursor;
                var result = interpolation(mergedProps);
                $dfbdd703603b20f0$var$cursor = previousCursor;
                return $dfbdd703603b20f0$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $dfbdd703603b20f0$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $dfbdd703603b20f0$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($dfbdd703603b20f0$var$isProcessableValue(asString)) string += $dfbdd703603b20f0$var$processStyleName(key) + ":" + $dfbdd703603b20f0$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $dfbdd703603b20f0$var$isDevelopment) throw new Error($dfbdd703603b20f0$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($dfbdd703603b20f0$var$isProcessableValue(value[_i])) string += $dfbdd703603b20f0$var$processStyleName(key) + ":" + $dfbdd703603b20f0$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $dfbdd703603b20f0$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $dfbdd703603b20f0$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $dfbdd703603b20f0$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $dfbdd703603b20f0$var$cursor;
function $dfbdd703603b20f0$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $dfbdd703603b20f0$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $dfbdd703603b20f0$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $dfbdd703603b20f0$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $dfbdd703603b20f0$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $dfbdd703603b20f0$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $ikd0W.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $dfbdd703603b20f0$var$cursor
    };
}

});
parcelRegister("ikd0W", function(module, exports) {
$parcel$export(module.exports, "default", () => $d574309d734f8505$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $d574309d734f8505$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("5JQpV", function(module, exports) {
$parcel$export(module.exports, "default", () => $42d9d0ace2ae17ca$export$2e2bcd8739ae039);
var $42d9d0ace2ae17ca$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("3t5HD", function(module, exports) {
$parcel$export(module.exports, "default", () => $286880f81da4a562$export$2e2bcd8739ae039);
function $286880f81da4a562$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("iULns", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $dc52351c153a2592$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $dc52351c153a2592$export$811a713a7276cb9d);

var $8P7DW = parcelRequire("8P7DW");
var $dc52351c153a2592$var$syncFallback = function syncFallback(create) {
    return create();
};
var $dc52351c153a2592$var$useInsertionEffect = false;
var $dc52351c153a2592$export$db21c7ffa21794e7 = $dc52351c153a2592$var$useInsertionEffect || $dc52351c153a2592$var$syncFallback;
var $dc52351c153a2592$export$811a713a7276cb9d = $dc52351c153a2592$var$useInsertionEffect || $8P7DW.useLayoutEffect;

});



parcelRegister("YDqMU", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $1ace6de2703adeb1$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $1ace6de2703adeb1$export$1aeb4f6b93c4540d);

var $8P7DW = parcelRequire("8P7DW");
const $1ace6de2703adeb1$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $8P7DW.createContext)('elevation.surface');
const $1ace6de2703adeb1$export$1aeb4f6b93c4540d = ()=>{
    return (0, $8P7DW.useContext)($1ace6de2703adeb1$export$1ca2a26fecb070ae);
};
$1ace6de2703adeb1$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("j4RVe", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $782f217b29aeec73$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $782f217b29aeec73$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $782f217b29aeec73$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $782f217b29aeec73$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $782f217b29aeec73$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $782f217b29aeec73$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $782f217b29aeec73$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $782f217b29aeec73$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $782f217b29aeec73$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $782f217b29aeec73$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $782f217b29aeec73$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $782f217b29aeec73$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $782f217b29aeec73$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $782f217b29aeec73$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $782f217b29aeec73$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $782f217b29aeec73$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $782f217b29aeec73$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $782f217b29aeec73$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $782f217b29aeec73$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $782f217b29aeec73$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $782f217b29aeec73$export$38845ca010b93505);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $782f217b29aeec73$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $782f217b29aeec73$export$5e65a44e5b6ecadb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $bTvke = parcelRequire("bTvke");
const $782f217b29aeec73$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $782f217b29aeec73$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $782f217b29aeec73$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $782f217b29aeec73$export$632685d741f3dbbf = {
    ...$782f217b29aeec73$export$958d0ae7f2977ae4,
    ...$782f217b29aeec73$export$d2dc61f58390201c
};
const $782f217b29aeec73$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $782f217b29aeec73$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $782f217b29aeec73$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
const $782f217b29aeec73$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
const $782f217b29aeec73$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
const $782f217b29aeec73$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $782f217b29aeec73$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
const $782f217b29aeec73$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
const $782f217b29aeec73$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $782f217b29aeec73$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
const $782f217b29aeec73$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
const $782f217b29aeec73$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $782f217b29aeec73$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $782f217b29aeec73$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $782f217b29aeec73$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $782f217b29aeec73$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $782f217b29aeec73$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const $782f217b29aeec73$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $782f217b29aeec73$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = /*#__PURE__*/ (0, $8Z0o8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $782f217b29aeec73$export$e615f061ca585a6c = $782f217b29aeec73$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $782f217b29aeec73$export$ca0f9c2de39ffed7(spacingProperty, $782f217b29aeec73$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $782f217b29aeec73$export$bf46c3f9eeafc71f = $782f217b29aeec73$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $782f217b29aeec73$export$ca0f9c2de39ffed7(spacingProperty, $782f217b29aeec73$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $782f217b29aeec73$export$e7af83bafe7f9e63 = $782f217b29aeec73$export$ca0f9c2de39ffed7('backgroundColor', $782f217b29aeec73$export$d1d79bf68ac056bd);
const $782f217b29aeec73$export$3a1bcba60b23d7f0 = $782f217b29aeec73$export$ca0f9c2de39ffed7('color', $782f217b29aeec73$export$8473307aa00d6ea1);
const $782f217b29aeec73$export$45f3f4fe16f9f7d5 = $782f217b29aeec73$export$ca0f9c2de39ffed7('fontWeight', $782f217b29aeec73$export$303e322c6b1ed114);
const $782f217b29aeec73$export$68cc305da27dbaa4 = $782f217b29aeec73$export$ca0f9c2de39ffed7('fontFamily', $782f217b29aeec73$export$3c7e9587132614b4);
const $782f217b29aeec73$export$128f10c238242f83 = $782f217b29aeec73$export$ca0f9c2de39ffed7('font', $782f217b29aeec73$export$6ffa317d5e70375);
const $782f217b29aeec73$export$219d364c0da35ae4 = $782f217b29aeec73$export$ca0f9c2de39ffed7('font', $782f217b29aeec73$export$236bfe3a33ef1292);
const $782f217b29aeec73$export$38845ca010b93505 = $782f217b29aeec73$export$ca0f9c2de39ffed7('fontWeight', $782f217b29aeec73$export$855cfd311192d666);
const $782f217b29aeec73$export$ff257d957d48c421 = $782f217b29aeec73$export$ca0f9c2de39ffed7((0, $bTvke.CURRENT_SURFACE_CSS_VAR), $782f217b29aeec73$export$41a358c9c2356760);
const $782f217b29aeec73$export$5e65a44e5b6ecadb = (color)=>$782f217b29aeec73$export$41a358c9c2356760[color] !== undefined;
const $782f217b29aeec73$export$7001ce64d9ff7c7f = $782f217b29aeec73$export$ca0f9c2de39ffed7('font', $782f217b29aeec73$export$b805719bc8cb376);

});
parcelRegister("bTvke", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $c1669c5ed1fc059b$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $c1669c5ed1fc059b$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $c1669c5ed1fc059b$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $c1669c5ed1fc059b$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $c1669c5ed1fc059b$export$352e418ed5b6193a);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $c1669c5ed1fc059b$export$9d7b58831ae93caa);
const $c1669c5ed1fc059b$export$4ef52930e33717cd = 'data-theme';
const $c1669c5ed1fc059b$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $c1669c5ed1fc059b$export$a00eac3f8684bcd0 = 'data-color-mode';
const $c1669c5ed1fc059b$export$2112803007239c61 = 'data-contrast-mode';
const $c1669c5ed1fc059b$export$352e418ed5b6193a = 'data-custom-theme';
const $c1669c5ed1fc059b$export$6f0c6fb8c80fcc92 = 'ds';
const $c1669c5ed1fc059b$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $c1669c5ed1fc059b$export$dddac1532e822863 = `--${$c1669c5ed1fc059b$export$6f0c6fb8c80fcc92}-token-not-found`;
const $c1669c5ed1fc059b$export$9d7b58831ae93caa = `--${$c1669c5ed1fc059b$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});


parcelRegister("37U6z", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $dcd3e9cf465d1b66$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $dcd3e9cf465d1b66$export$f6c783d06584602c);
/* xcss.tsx generated by @compiled/babel-plugin v0.37.1 */ /* xcss.tsx generated by @compiled/babel-plugin v0.37.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $j4RVe = parcelRequire("j4RVe");

var $6nQJh = parcelRequire("6nQJh");
const $dcd3e9cf465d1b66$export$9a199fbafee0014e = {
    backgroundColor: (0, $j4RVe.backgroundColorMap),
    blockSize: (0, $j4RVe.dimensionMap),
    borderBlockColor: (0, $j4RVe.borderColorMap),
    borderBlockEndColor: (0, $j4RVe.borderColorMap),
    borderBlockEndWidth: (0, $j4RVe.borderWidthMap),
    borderBlockStartColor: (0, $j4RVe.borderColorMap),
    borderBlockStartWidth: (0, $j4RVe.borderWidthMap),
    borderBlockWidth: (0, $j4RVe.borderWidthMap),
    borderBottomColor: (0, $j4RVe.borderColorMap),
    borderBottomLeftRadius: (0, $j4RVe.borderRadiusMap),
    borderBottomRightRadius: (0, $j4RVe.borderRadiusMap),
    borderBottomWidth: (0, $j4RVe.borderWidthMap),
    borderColor: (0, $j4RVe.borderColorMap),
    borderEndEndRadius: (0, $j4RVe.borderRadiusMap),
    borderEndStartRadius: (0, $j4RVe.borderRadiusMap),
    borderInlineColor: (0, $j4RVe.borderColorMap),
    borderInlineEndColor: (0, $j4RVe.borderColorMap),
    borderInlineEndWidth: (0, $j4RVe.borderWidthMap),
    borderInlineStartColor: (0, $j4RVe.borderColorMap),
    borderInlineStartWidth: (0, $j4RVe.borderWidthMap),
    borderInlineWidth: (0, $j4RVe.borderWidthMap),
    borderLeftColor: (0, $j4RVe.borderColorMap),
    borderLeftWidth: (0, $j4RVe.borderWidthMap),
    borderRadius: (0, $j4RVe.borderRadiusMap),
    borderRightColor: (0, $j4RVe.borderColorMap),
    borderRightWidth: (0, $j4RVe.borderWidthMap),
    borderStartEndRadius: (0, $j4RVe.borderRadiusMap),
    borderStartStartRadius: (0, $j4RVe.borderRadiusMap),
    borderTopColor: (0, $j4RVe.borderColorMap),
    borderTopLeftRadius: (0, $j4RVe.borderRadiusMap),
    borderTopRightRadius: (0, $j4RVe.borderRadiusMap),
    borderTopWidth: (0, $j4RVe.borderWidthMap),
    borderWidth: (0, $j4RVe.borderWidthMap),
    bottom: (0, $j4RVe.allSpaceMap),
    boxShadow: (0, $j4RVe.shadowMap),
    color: (0, $j4RVe.textColorMap),
    columnGap: (0, $j4RVe.positiveSpaceMap),
    font: (0, $j4RVe.fontMap),
    fontFamily: (0, $j4RVe.fontFamilyMap),
    fontWeight: (0, $j4RVe.fontWeightMap),
    gap: (0, $j4RVe.positiveSpaceMap),
    height: (0, $j4RVe.dimensionMap),
    inlineSize: (0, $j4RVe.dimensionMap),
    inset: (0, $j4RVe.allSpaceMap),
    insetBlock: (0, $j4RVe.allSpaceMap),
    insetBlockEnd: (0, $j4RVe.allSpaceMap),
    insetBlockStart: (0, $j4RVe.allSpaceMap),
    insetInline: (0, $j4RVe.allSpaceMap),
    insetInlineEnd: (0, $j4RVe.allSpaceMap),
    insetInlineStart: (0, $j4RVe.allSpaceMap),
    left: (0, $j4RVe.allSpaceMap),
    margin: (0, $j4RVe.allSpaceMap),
    marginBlock: (0, $j4RVe.allSpaceMap),
    marginBlockEnd: (0, $j4RVe.allSpaceMap),
    marginBlockStart: (0, $j4RVe.allSpaceMap),
    marginBottom: (0, $j4RVe.allSpaceMap),
    marginInline: (0, $j4RVe.allSpaceMap),
    marginInlineEnd: (0, $j4RVe.allSpaceMap),
    marginInlineStart: (0, $j4RVe.allSpaceMap),
    marginLeft: (0, $j4RVe.allSpaceMap),
    marginRight: (0, $j4RVe.allSpaceMap),
    marginTop: (0, $j4RVe.allSpaceMap),
    maxBlockSize: (0, $j4RVe.dimensionMap),
    maxHeight: (0, $j4RVe.dimensionMap),
    maxInlineSize: (0, $j4RVe.dimensionMap),
    maxWidth: (0, $j4RVe.dimensionMap),
    minBlockSize: (0, $j4RVe.dimensionMap),
    minHeight: (0, $j4RVe.dimensionMap),
    minInlineSize: (0, $j4RVe.dimensionMap),
    minWidth: (0, $j4RVe.dimensionMap),
    opacity: (0, $j4RVe.opacityMap),
    outlineColor: (0, $j4RVe.borderColorMap),
    outlineOffset: (0, $j4RVe.allSpaceMap),
    outlineWidth: (0, $j4RVe.borderWidthMap),
    padding: (0, $j4RVe.positiveSpaceMap),
    paddingBlock: (0, $j4RVe.positiveSpaceMap),
    paddingBlockEnd: (0, $j4RVe.positiveSpaceMap),
    paddingBlockStart: (0, $j4RVe.positiveSpaceMap),
    paddingBottom: (0, $j4RVe.positiveSpaceMap),
    paddingInline: (0, $j4RVe.positiveSpaceMap),
    paddingInlineEnd: (0, $j4RVe.positiveSpaceMap),
    paddingInlineStart: (0, $j4RVe.positiveSpaceMap),
    paddingLeft: (0, $j4RVe.positiveSpaceMap),
    paddingRight: (0, $j4RVe.positiveSpaceMap),
    paddingTop: (0, $j4RVe.positiveSpaceMap),
    right: (0, $j4RVe.allSpaceMap),
    rowGap: (0, $j4RVe.positiveSpaceMap),
    top: (0, $j4RVe.allSpaceMap),
    width: (0, $j4RVe.dimensionMap),
    zIndex: (0, $j4RVe.layerMap)
};
const $dcd3e9cf465d1b66$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $dcd3e9cf465d1b66$var$isSafeEnvToThrow = ()=>typeof $6nQJh === 'object' && typeof $6nQJh.env === 'object' && false;
const $dcd3e9cf465d1b66$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $dcd3e9cf465d1b66$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $dcd3e9cf465d1b66$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($dcd3e9cf465d1b66$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $dcd3e9cf465d1b66$var$safeSelectors.test(key)) {
            styleObj[key] = $dcd3e9cf465d1b66$var$transformStyles(value);
            return;
        }
        if ($dcd3e9cf465d1b66$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($dcd3e9cf465d1b66$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $dcd3e9cf465d1b66$export$9a199fbafee0014e)) return;
        const tokenValue = $dcd3e9cf465d1b66$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $dcd3e9cf465d1b66$var$baseXcss = (style)=>{
    const transformedStyles = $dcd3e9cf465d1b66$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$dcd3e9cf465d1b66$var$uniqueSymbol]: /*#__PURE__*/ (0, $8Z0o8.css)(transformedStyles)
    };
};
const $dcd3e9cf465d1b66$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $dcd3e9cf465d1b66$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$dcd3e9cf465d1b66$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $dcd3e9cf465d1b66$export$f6c783d06584602c(style) {
    return $dcd3e9cf465d1b66$var$baseXcss(style);
}

});


parcelRegister("ktwNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a8aa90d05174307$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $37U6z = parcelRequire("37U6z");

var $dqsXi = parcelRequire("dqsXi");
const $1a8aa90d05174307$var$flexGrowMap = {
    hug: (0, $37U6z.xcss)({
        flexGrow: 0
    }),
    fill: (0, $37U6z.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $1a8aa90d05174307$var$separatorStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $1a8aa90d05174307$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        css: $1a8aa90d05174307$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $1a8aa90d05174307$var$Inline = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $8Z0o8.jsx)($1a8aa90d05174307$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $8P7DW.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $1a8aa90d05174307$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $dqsXi.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$1a8aa90d05174307$var$Inline.displayName = 'Inline';
var $1a8aa90d05174307$export$2e2bcd8739ae039 = $1a8aa90d05174307$var$Inline;

});
parcelRegister("dqsXi", function(module, exports) {
$parcel$export(module.exports, "default", () => $7068969feb30cece$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $j4RVe = parcelRequire("j4RVe");

var $37U6z = parcelRequire("37U6z");
function $7068969feb30cece$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7068969feb30cece$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $7068969feb30cece$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $7068969feb30cece$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $7068969feb30cece$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $7068969feb30cece$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $7068969feb30cece$var$Flex = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $37U6z.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $7068969feb30cece$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $j4RVe.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $j4RVe.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $j4RVe.spaceStylesMap).rowGap[rowGap],
            alignItems && $7068969feb30cece$var$alignItemsMap[alignItems],
            direction && $7068969feb30cece$var$flexDirectionMap[direction],
            justifyContent && $7068969feb30cece$var$justifyContentMap[justifyContent],
            wrap && $7068969feb30cece$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$7068969feb30cece$var$Flex.displayName = 'Flex';
var $7068969feb30cece$export$2e2bcd8739ae039 = $7068969feb30cece$var$Flex;

});


parcelRegister("dvX8Y", function(module, exports) {
$parcel$export(module.exports, "MemoizedInsightIcon", () => (parcelRequire("kW6YT")).MemoizedInsightIcon);

var $kW6YT = parcelRequire("kW6YT");

});
parcelRegister("kW6YT", function(module, exports) {
$parcel$export(module.exports, "MemoizedInsightIcon", () => $a1b08ef0a21bb453$export$55641517b59933d7);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $gtkbA = parcelRequire("gtkbA");
var $hIXV0 = parcelRequire("hIXV0");
var $ku7ln = parcelRequire("ku7ln");

var $98j5w = parcelRequire("98j5w");
const $a1b08ef0a21bb453$var$ICON_SIZE = 'small';
const $a1b08ef0a21bb453$var$sizeInPx = (0, $gtkbA.AVATAR_SIZES)[$a1b08ef0a21bb453$var$ICON_SIZE];
// We want to reuse mediaClientConfigs across all InsightIcons to avoid extra http requests
// MediaImage internally checks for object equality to prevent image refetch.
// That's why we need to check for the individual parameters equality at this level
// and prevent the property mediaClientConfig to change
const $a1b08ef0a21bb453$var$mediaClientConfigs = new Map();
const $a1b08ef0a21bb453$var$getMediaClientConfig = ({ mediaJwtToken: mediaJwtToken, clientId: clientId, mediaBaseUrl: mediaBaseUrl })=>{
    const key = `${mediaJwtToken}:${clientId}:${mediaBaseUrl}`;
    if ($a1b08ef0a21bb453$var$mediaClientConfigs.has(key)) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return $a1b08ef0a21bb453$var$mediaClientConfigs.get(key);
    const mediaClientConfig = {
        authProvider: ()=>Promise.resolve({
                clientId: clientId,
                token: mediaJwtToken,
                baseUrl: mediaBaseUrl
            }),
        useSha256ForUploads: true
    };
    $a1b08ef0a21bb453$var$mediaClientConfigs.set(key, mediaClientConfig);
    return mediaClientConfig;
};
const $a1b08ef0a21bb453$var$hasAuth = ({ mediaBaseUrl: mediaBaseUrl, mediaJwtToken: mediaJwtToken, fileId: fileId, clientId: clientId })=>Boolean(mediaBaseUrl) && Boolean(mediaJwtToken) && Boolean(clientId) && Boolean(fileId);
const $a1b08ef0a21bb453$var$DefaultIcon = ()=>/*#__PURE__*/ $8P7DW.createElement((0, $hIXV0.default), {
        appearance: "square",
        size: "small"
    });
// Mimics logic from jira/src/packages/servicedesk/insight-common/insight-icon/src/ui/index.tsx
const $a1b08ef0a21bb453$var$renderAvatar = (src)=>/*#__PURE__*/ $8P7DW.createElement("img", {
        loading: "lazy",
        src: src,
        width: $a1b08ef0a21bb453$var$sizeInPx,
        height: $a1b08ef0a21bb453$var$sizeInPx,
        alt: ""
    });
const $a1b08ef0a21bb453$export$4f72cced31fa9b94 = (props)=>{
    const { fileId: fileId, iconUrl: iconUrl, MediaImage: MediaImage = (0, $98j5w.MediaImageWithErrorBoundary) } = props;
    if (!$a1b08ef0a21bb453$var$hasAuth({
        ...props
    }) || !MediaImage) {
        if ((0, $HGACo.isAurumAssetsPcs3707942Enabled)() && iconUrl) return $a1b08ef0a21bb453$var$renderAvatar(iconUrl);
        return /*#__PURE__*/ $8P7DW.createElement($a1b08ef0a21bb453$var$DefaultIcon, null);
    }
    const fileIdentifier = {
        id: fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: 24,
        height: 24
    };
    return /*#__PURE__*/ $8P7DW.createElement("div", null, /*#__PURE__*/ $8P7DW.createElement(MediaImage, {
        identifier: fileIdentifier,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        mediaClientConfig: $a1b08ef0a21bb453$var$getMediaClientConfig(props),
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $8P7DW.createElement((0, $ku7ln.default), {
            appearance: "square",
            size: "small"
        });
        if (error) return /*#__PURE__*/ $8P7DW.createElement($a1b08ef0a21bb453$var$DefaultIcon, null);
        if (!data) return /*#__PURE__*/ $8P7DW.createElement($a1b08ef0a21bb453$var$DefaultIcon, null);
        return /*#__PURE__*/ $8P7DW.createElement((0, $hIXV0.default), {
            src: data.src,
            appearance: "square",
            size: "small"
        });
    }));
};
const $a1b08ef0a21bb453$export$55641517b59933d7 = /*#__PURE__*/ $8P7DW.memo($a1b08ef0a21bb453$export$4f72cced31fa9b94);

});
parcelRegister("gtkbA", function(module, exports) {
$parcel$export(module.exports, "AVATAR_SIZES", () => $007805623ac3f109$export$9a270941bcff7e77);
const $007805623ac3f109$export$9a270941bcff7e77 = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $007805623ac3f109$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $007805623ac3f109$export$e2bd4c1faded7921 = 2;
const $007805623ac3f109$export$89a980dfdf90df51 = 0.9;

});

parcelRegister("hIXV0", function(module, exports) {
$parcel$export(module.exports, "default", () => $608ff0da1132bc24$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $MmGmU = parcelRequire("MmGmU");

var $fnhqr = parcelRequire("fnhqr");

var $jtYAk = parcelRequire("jtYAk");

var $3P9B7 = parcelRequire("3P9B7");

var $ckYIe = parcelRequire("ckYIe");

var $kMh0o = parcelRequire("kMh0o");

var $bRyBN = parcelRequire("bRyBN");

var $k54zF = parcelRequire("k54zF");

var $djlCe = parcelRequire("djlCe");

var $fqthz = parcelRequire("fqthz");
const $608ff0da1132bc24$var$packageName = undefined;
const $608ff0da1132bc24$var$packageVersion = undefined;
const $608ff0da1132bc24$var$containerStyles = null;
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $608ff0da1132bc24$var$Avatar = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', isDecorative: isDecorative = false, imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const context = (0, $fqthz.useAvatarContext)();
    const size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, $8P7DW.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $8P7DW.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $8P7DW.useRef)(analyticsContext);
    const labelId = (0, $fnhqr.useId)();
    (0, $8P7DW.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $8P7DW.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $608ff0da1132bc24$var$packageName,
                packageVersion: $608ff0da1132bc24$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ const context = {
            componentName: 'avatar',
            packageName: $608ff0da1132bc24$var$packageName,
            packageVersion: $608ff0da1132bc24$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $kMh0o.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $8n1kL.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ckYIe.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $bRyBN.default)(isDisabled, href, onClick, ariaHasPopup),
                        appearance: appearance,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        'aria-controls': ariaControls,
                        'aria-expanded': ariaExpanded,
                        'aria-haspopup': ariaHasPopup,
                        avatarImage: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3P9B7.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jtYAk.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $k54zF.default), {
                    appearance: appearance,
                    size: size,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $djlCe.default), {
                    appearance: appearance,
                    size: size,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$608ff0da1132bc24$var$Avatar.displayName = 'Avatar';
var $608ff0da1132bc24$export$2e2bcd8739ae039 = $608ff0da1132bc24$var$Avatar;

});
parcelRegister("8n1kL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6181819c9f40d590$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $6181819c9f40d590$var$ATOMIC_GROUP_LENGTH = 5;
function $6181819c9f40d590$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $6181819c9f40d590$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("fnhqr", function(module, exports) {
$parcel$export(module.exports, "useId", () => $ce5256c2eee12bad$export$f680877a34711e37);

var $8P7DW = parcelRequire("8P7DW");
function $ce5256c2eee12bad$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("jtYAk", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $340d98c20dd5ca2b$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $e6Qdr = parcelRequire("e6Qdr");

var $ckYIe = parcelRequire("ckYIe");

var $kMh0o = parcelRequire("kMh0o");
const $340d98c20dd5ca2b$var$boxShadowCssVar = '--avatar-box-shadow';
const $340d98c20dd5ca2b$var$bgColorCssVar = '--avatar-bg-color';
const $340d98c20dd5ca2b$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $340d98c20dd5ca2b$var$unboundStyles = {
    rootCustomBorder: "_11q7cxp3",
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonFocusContainerMarginFg: "_195g1ksc",
    hexagonBorderContainerCustomBorder: "_11q7cxp3",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagonBorderContainerMarginFg: "_1mou18m8 _195gzwb8",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _1llweo6y"
};
const $340d98c20dd5ca2b$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $340d98c20dd5ca2b$var$marginAdjustmentMap = {
    xsmall: "_195gcwjc",
    small: "_195gcwjc",
    medium: "_195gs7t4",
    large: "_195gs7t4",
    xlarge: "_195g8ocb",
    xxlarge: "_195g1ukp"
};
const $340d98c20dd5ca2b$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children }, ref)=>{
    (0, $kMh0o.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $8P7DW.useContext)((0, $ckYIe.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ (0, $gWgPx.jsx)(Container, {
        style: {
            [$340d98c20dd5ca2b$var$bgColorCssVar]: borderColor,
            [$340d98c20dd5ca2b$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $8n1kL.default)([
            $340d98c20dd5ca2b$var$unboundStyles.root,
            (0, $e6Qdr.fg)('avatar-custom-border') && $340d98c20dd5ca2b$var$unboundStyles.rootCustomBorder,
            $340d98c20dd5ca2b$var$styles.root,
            appearance === 'square' && $340d98c20dd5ca2b$var$styles.square,
            appearance === 'circle' && $340d98c20dd5ca2b$var$styles.circle,
            appearance === 'hexagon' && $340d98c20dd5ca2b$var$unboundStyles.hexagon,
            $340d98c20dd5ca2b$var$widthHeightMap[size],
            stackIndex !== undefined && $340d98c20dd5ca2b$var$styles.positionRelative,
            isInteractive && !isDisabled && $340d98c20dd5ca2b$var$unboundStyles.interactive,
            isInteractive && !isDisabled && (0, $e6Qdr.fg)('platform-dst-motion-uplift') && $340d98c20dd5ca2b$var$unboundStyles.interactiveMotion,
            isDisabled && $340d98c20dd5ca2b$var$styles.disabled
        ]),
        children: children || avatarImage
    });
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        style: {
            [$340d98c20dd5ca2b$var$bgColorCssVar]: borderColor,
            [$340d98c20dd5ca2b$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $8n1kL.default)([
            $340d98c20dd5ca2b$var$unboundStyles.hexagonFocusContainer,
            !(0, $e6Qdr.fg)('platform_dst_hexagon_avatar_unified_size') && $340d98c20dd5ca2b$var$marginAdjustmentMap[size],
            (0, $e6Qdr.fg)('platform_dst_hexagon_avatar_unified_size') && $340d98c20dd5ca2b$var$unboundStyles.hexagonFocusContainerMarginFg
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
            "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
            className: (0, $8n1kL.default)([
                $340d98c20dd5ca2b$var$unboundStyles.hexagonBorderContainer,
                (0, $e6Qdr.fg)('avatar-custom-border') && $340d98c20dd5ca2b$var$unboundStyles.hexagonBorderContainerCustomBorder,
                (0, $e6Qdr.fg)('platform_dst_hexagon_avatar_unified_size') && $340d98c20dd5ca2b$var$unboundStyles.hexagonBorderContainerMarginFg
            ]),
            children: renderedContent
        })
    });
});

});
parcelRegister("ckYIe", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", () => $55d4cc7e8622fa6c$export$b983474ddd0b6d28);

var $8P7DW = parcelRequire("8P7DW");
const $55d4cc7e8622fa6c$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $55d4cc7e8622fa6c$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $8P7DW.createContext)($55d4cc7e8622fa6c$var$defaultAvatarContentProps);

});

parcelRegister("kMh0o", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $aad6eba552c173a5$export$6b4cbd90d24955ad);
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $aad6eba552c173a5$export$7db5c57474082dd9);

var $8P7DW = parcelRequire("8P7DW");
const $aad6eba552c173a5$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $8P7DW.createContext)(false);
const $aad6eba552c173a5$export$7db5c57474082dd9 = ()=>{
    const context = (0, $8P7DW.useContext)($aad6eba552c173a5$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});


parcelRegister("3P9B7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5922d6c4e37f6e94$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $edpmG = parcelRequire("edpmG");

var $5s8Mf = parcelRequire("5s8Mf");

var $dp5Yd = parcelRequire("dp5Yd");
const $5922d6c4e37f6e94$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
const $5922d6c4e37f6e94$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
const $5922d6c4e37f6e94$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $5922d6c4e37f6e94$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $8P7DW.useState)(false);
    // If src changes, reset state
    (0, $8P7DW.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5s8Mf))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($edpmG))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dp5Yd))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
            className: (0, $8n1kL.default)([
                $5922d6c4e37f6e94$var$styles.icon,
                $5922d6c4e37f6e94$var$nestedSvgStylesMap[size]
            ]),
            children: renderedIcon
        });
    }
    return /*#__PURE__*/ (0, $gWgPx.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $8n1kL.default)([
            $5922d6c4e37f6e94$var$styles.image,
            $5922d6c4e37f6e94$var$borderRadiusMap[size],
            appearance === 'circle' && $5922d6c4e37f6e94$var$styles.circle,
            appearance === 'hexagon' && $5922d6c4e37f6e94$var$styles.hexagon
        ])
    });
};
var $5922d6c4e37f6e94$export$2e2bcd8739ae039 = $5922d6c4e37f6e94$var$AvatarImage;

});
parcelRegister("edpmG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e079be55658218810235742dfafa5bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a595f47f275b634b$var$_react = $a595f47f275b634b$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $a595f47f275b634b$var$_baseNew = $a595f47f275b634b$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $a595f47f275b634b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a595f47f275b634b$var$AiAgentIcon = (props)=>/*#__PURE__*/ $a595f47f275b634b$var$_react.default.createElement($a595f47f275b634b$var$_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$a595f47f275b634b$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $a595f47f275b634b$var$_default = module.exports.default = $a595f47f275b634b$var$AiAgentIcon;

});
parcelRegister("kJTzo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("hLU7q")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("hLU7q")).Icon);

var $hLU7q = parcelRequire("hLU7q");

});
parcelRegister("hLU7q", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $f1a1e8a2af384eaf$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $f1a1e8a2af384eaf$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $f1a1e8a2af384eaf$var$svgStyles = null;
const $f1a1e8a2af384eaf$var$iconStyles = null;
const $f1a1e8a2af384eaf$var$smallIconStyles = null;
const $f1a1e8a2af384eaf$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $f1a1e8a2af384eaf$var$baseHcmStyles = null;
const $f1a1e8a2af384eaf$var$scaleSize = null;
const $f1a1e8a2af384eaf$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $f1a1e8a2af384eaf$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $f1a1e8a2af384eaf$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $f1a1e8a2af384eaf$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8P7DW.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $f1a1e8a2af384eaf$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $8n1kL.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $8n1kL.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $f1a1e8a2af384eaf$var$coreSizeSmall[spacing] : $f1a1e8a2af384eaf$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var $f1a1e8a2af384eaf$export$2e2bcd8739ae039 = $f1a1e8a2af384eaf$export$f04a61298a47a40f;

});



parcelRegister("5s8Mf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f866040e7af179d$var$_react = $3f866040e7af179d$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $3f866040e7af179d$var$_baseNew = $3f866040e7af179d$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $3f866040e7af179d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f866040e7af179d$var$PersonIcon = (props)=>/*#__PURE__*/ $3f866040e7af179d$var$_react.default.createElement($3f866040e7af179d$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$3f866040e7af179d$var$PersonIcon.displayName = 'PersonIcon';
var $3f866040e7af179d$var$_default = module.exports.default = $3f866040e7af179d$var$PersonIcon;

});

parcelRegister("dp5Yd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c223db7065cc8c2$var$_react = $9c223db7065cc8c2$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $9c223db7065cc8c2$var$_baseNew = $9c223db7065cc8c2$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $9c223db7065cc8c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c223db7065cc8c2$var$ReleaseIcon = (props)=>/*#__PURE__*/ $9c223db7065cc8c2$var$_react.default.createElement($9c223db7065cc8c2$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$9c223db7065cc8c2$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $9c223db7065cc8c2$var$_default = module.exports.default = $9c223db7065cc8c2$var$ReleaseIcon;

});


parcelRegister("bRyBN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea75f637b05da237$export$2e2bcd8739ae039);
const $ea75f637b05da237$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $ea75f637b05da237$export$2e2bcd8739ae039 = $ea75f637b05da237$var$getCustomElement;

});

parcelRegister("k54zF", function(module, exports) {
$parcel$export(module.exports, "default", () => $384f75b94b233d7d$export$2e2bcd8739ae039);
/* presence-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $eYojc = parcelRequire("eYojc");
const $384f75b94b233d7d$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $384f75b94b233d7d$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $384f75b94b233d7d$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $384f75b94b233d7d$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
const $384f75b94b233d7d$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ const $384f75b94b233d7d$var$PresenceWrapper = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $8n1kL.default)([
            $384f75b94b233d7d$var$styles.root,
            $384f75b94b233d7d$var$iconSizeMap[size],
            $384f75b94b233d7d$var$circleIconOffsetMap[size],
            appearance === 'square' && $384f75b94b233d7d$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $384f75b94b233d7d$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eYojc.default), {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};
var $384f75b94b233d7d$export$2e2bcd8739ae039 = $384f75b94b233d7d$var$PresenceWrapper;

});
parcelRegister("eYojc", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ea7150cdb807aac$export$2e2bcd8739ae039);
/* presence.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $lmP1A = parcelRequire("lmP1A");
const $7ea7150cdb807aac$var$BusyIndicator = /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gWgPx.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $7ea7150cdb807aac$var$FocusIndicator = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Fragment), {
    children: /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
        fill: "var(--ds-icon-discovery, #AF59E1)",
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $7ea7150cdb807aac$var$OfflineIndicator = /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $7ea7150cdb807aac$var$OnlineIndicator = /*#__PURE__*/ (0, $gWgPx.jsx)("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $7ea7150cdb807aac$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $7ea7150cdb807aac$var$BusyIndicator;
        case 'focus':
            return $7ea7150cdb807aac$var$FocusIndicator;
        case 'offline':
            return $7ea7150cdb807aac$var$OfflineIndicator;
        case 'online':
            return $7ea7150cdb807aac$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $7ea7150cdb807aac$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $lmP1A.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $7ea7150cdb807aac$var$getPresence(presence)
        }) : children
    });
var $7ea7150cdb807aac$export$2e2bcd8739ae039 = $7ea7150cdb807aac$var$AvatarPresence;

});
parcelRegister("lmP1A", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c9d205ed69c1874$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $1c9d205ed69c1874$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $1c9d205ed69c1874$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $1c9d205ed69c1874$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $8n1kL.default)([
            $1c9d205ed69c1874$var$styles.root,
            $1c9d205ed69c1874$var$unboundStyles.root
        ]),
        children: children
    });
var $1c9d205ed69c1874$export$2e2bcd8739ae039 = $1c9d205ed69c1874$var$IconWrapper;

});



parcelRegister("djlCe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3c08b828d6a6d14$export$2e2bcd8739ae039);
/* status-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $jmP4T = parcelRequire("jmP4T");
const $d3c08b828d6a6d14$var$styles = {
    root: "_kqswstnw"
};
const $d3c08b828d6a6d14$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $d3c08b828d6a6d14$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
const $d3c08b828d6a6d14$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
const $d3c08b828d6a6d14$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ const $d3c08b828d6a6d14$var$StatusWrapper = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $8n1kL.default)([
            $d3c08b828d6a6d14$var$styles.root,
            $d3c08b828d6a6d14$var$iconSizeMap[size],
            $d3c08b828d6a6d14$var$circleIconOffsetMap[size],
            appearance === 'square' && $d3c08b828d6a6d14$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $d3c08b828d6a6d14$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jmP4T.default), {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};
var $d3c08b828d6a6d14$export$2e2bcd8739ae039 = $d3c08b828d6a6d14$var$StatusWrapper;

});
parcelRegister("jmP4T", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4abee0ac3a81350$export$2e2bcd8739ae039);
/* status.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $lmP1A = parcelRequire("lmP1A");
const $b4abee0ac3a81350$var$ApprovedIndicator = /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gWgPx.jsx)("circle", {
            fill: "var(--ds-icon-success, #6A9A23)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $b4abee0ac3a81350$var$DeclinedIndicator = /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gWgPx.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $b4abee0ac3a81350$var$LockedIndicator = /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
    children: [
        /*#__PURE__*/ (0, $gWgPx.jsx)("circle", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
function $b4abee0ac3a81350$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $b4abee0ac3a81350$var$ApprovedIndicator;
        case 'declined':
            return $b4abee0ac3a81350$var$DeclinedIndicator;
        case 'locked':
            return $b4abee0ac3a81350$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $b4abee0ac3a81350$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $lmP1A.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $b4abee0ac3a81350$var$getStatus(status)
        }) : children
    });
var $b4abee0ac3a81350$export$2e2bcd8739ae039 = $b4abee0ac3a81350$var$AvatarStatus;

});


parcelRegister("fqthz", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", () => $aea874b00bb3a922$export$b50b87a1c4086b23);

var $8P7DW = parcelRequire("8P7DW");

var $btaXm = parcelRequire("btaXm");
const $aea874b00bb3a922$export$b50b87a1c4086b23 = ()=>(0, $8P7DW.useContext)((0, $btaXm.AvatarContext));

});
parcelRegister("btaXm", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $bd725b23fb626b38$export$a20dad690e1279e2);

var $8P7DW = parcelRequire("8P7DW");
const $bd725b23fb626b38$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);

});



parcelRegister("ku7ln", function(module, exports) {
$parcel$export(module.exports, "default", () => $815df799fd7901ef$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $815df799fd7901ef$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $815df799fd7901ef$var$styles = {
    root: "_2rko1qll _189e1dm9 _1dqonqa1 _1h6d1j28 _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    square: "_2rkol0p1",
    hexagon: "_mkrz1k6g",
    strongOpacity: "_tzy4clii"
};
const $815df799fd7901ef$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $815df799fd7901ef$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        style: {
            [$815df799fd7901ef$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $8n1kL.default)([
            $815df799fd7901ef$var$styles.root,
            $815df799fd7901ef$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' && $815df799fd7901ef$var$styles.square,
            appearance === 'hexagon' && $815df799fd7901ef$var$styles.hexagon,
            weight === 'strong' && $815df799fd7901ef$var$styles.strongOpacity
        ])
    });
var $815df799fd7901ef$export$2e2bcd8739ae039 = $815df799fd7901ef$var$Skeleton;

});

parcelRegister("98j5w", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $4eb8322d741eb4ff$export$758a2fef95a29ad0);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $dCWA1 = parcelRequire("dCWA1");

var $gYeBF = parcelRequire("gYeBF");
const $4eb8322d741eb4ff$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $dCWA1.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gYeBF.MediaImageWithMediaClient), {
            ...props
        })
    });

});
parcelRegister("dCWA1", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $9ebc43b9717782b4$export$e926676385687eaf);
$parcel$export(module.exports, "withErrorBoundary", () => $9ebc43b9717782b4$export$f0c7a449e0cfaec7);

var $8P7DW = parcelRequire("8P7DW");
'use client';
const $9ebc43b9717782b4$export$b16d9fb1a22de840 = (0, $8P7DW.createContext)(null);
const $9ebc43b9717782b4$var$initialState = {
    didCatch: false,
    error: null
};
class $9ebc43b9717782b4$export$e926676385687eaf extends (0, $8P7DW.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $9ebc43b9717782b4$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($9ebc43b9717782b4$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $9ebc43b9717782b4$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($9ebc43b9717782b4$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $8P7DW.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $8P7DW.createElement)($9ebc43b9717782b4$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $9ebc43b9717782b4$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $9ebc43b9717782b4$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $9ebc43b9717782b4$export$c052f6604b7d51fe() {
    const context = (0, $8P7DW.useContext)($9ebc43b9717782b4$export$b16d9fb1a22de840);
    $9ebc43b9717782b4$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $8P7DW.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $8P7DW.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $9ebc43b9717782b4$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $8P7DW.forwardRef)((props, ref)=>(0, $8P7DW.createElement)($9ebc43b9717782b4$export$e926676385687eaf, errorBoundaryProps, (0, $8P7DW.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});

parcelRegister("gYeBF", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithMediaClient", () => $18c427d5771ef81c$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $1B7gt = parcelRequire("1B7gt");

var $cY581 = parcelRequire("cY581");

var $e6Qdr = parcelRequire("e6Qdr");
const $18c427d5771ef81c$var$copyDivStyles = null;
const $18c427d5771ef81c$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $cY581.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview !== null && preview !== void 0 && preview.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview === null || preview === void 0 ? void 0 : preview.dataURI
                } : undefined
            }),
            (0, $e6Qdr.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $8n1kL.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $gWgPx.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $18c427d5771ef81c$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $8P7DW.useMemo)(()=>(0, $1B7gt.withMediaClient)($18c427d5771ef81c$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $gWgPx.jsx)(MediaImageComponent, {
        ...props
    });
};

});
parcelRegister("1B7gt", function(module, exports) {
$parcel$export(module.exports, "withMediaClient", () => $50346bca05802cab$export$9f7977d4a2561bee);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $k56KN = parcelRequire("k56KN");

var $c0KQ5 = parcelRequire("c0KQ5");

var $lbS2q = parcelRequire("lbS2q");
const $50346bca05802cab$export$9f7977d4a2561bee = (Component)=>(0, $k56KN.componentWithCondition)(()=>(0, $e6Qdr.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $8P7DW.useContext)((0, $lbS2q.MediaClientContext));
        const mediaClient = (0, $8P7DW.useMemo)(()=>existingMediaClient ?? (0, $c0KQ5.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lbS2q.MediaClientContext).Provider, {
            value: mediaClient,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
                ...otherProps,
                mediaClient: mediaClient
            })
        });
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $lbS2q.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lbS2q.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lbS2q.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        }));

});
parcelRegister("k56KN", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $8d33287579922aed$export$6e8ea24b15199873);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
function $8d33287579922aed$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $gWgPx.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $gWgPx.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("c0KQ5", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $1d31bc8c6cfb6e35$export$c9ecbc1b719fd417);

var $jXhVs = parcelRequire("jXhVs");
const $1d31bc8c6cfb6e35$export$f92e83e86b03c398 = new Map();
const $1d31bc8c6cfb6e35$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $jXhVs.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $1d31bc8c6cfb6e35$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $jXhVs.MediaClient)(mediaClientConfig);
        $1d31bc8c6cfb6e35$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("jXhVs", function(module, exports) {
$parcel$export(module.exports, "MediaClient", () => $a6f0854ef2cf2f8e$export$fba8b4ca6d386aec);

var $emRst = parcelRequire("emRst");
parcelRequire("7F07j");
var $kD2pI = parcelRequire("kD2pI");

var $bXafe = parcelRequire("bXafe");

var $5Ivto = parcelRequire("5Ivto");

var $fQVty = parcelRequire("fQVty");
parcelRequire("9XIuz");
var $2qxba = parcelRequire("2qxba");

class $a6f0854ef2cf2f8e$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $2qxba.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $bXafe.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $kD2pI.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $5Ivto.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $emRst.EventEmitter2)();
        this.stargate = new (0, $fQVty.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
   * @internal
   */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getClientId(collectionName) {
        return this.mediaStore.getClientId(collectionName);
    }
    getClientIdSync() {
        return this.mediaStore.getClientIdSync();
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("fYB20"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("emRst", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ 
var $6nQJh = parcelRequire("6nQJh");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $6nQJh !== 'undefined' && $6nQJh.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $6nQJh.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("7F07j", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => (parcelRequire("lSQPi")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("aOz0a")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("aOz0a")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("kD2pI")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $lSQPi = parcelRequire("lSQPi");

var $aOz0a = parcelRequire("aOz0a");

var $kD2pI = parcelRequire("kD2pI");

});
parcelRegister("lSQPi", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => $f48edef65d5dc5c7$export$8cef61637918b288);

var $emRst = parcelRequire("emRst");

var $4E7es = parcelRequire("4E7es");
const $f48edef65d5dc5c7$export$8cef61637918b288 = {
    streams: new (0, $4E7es.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $emRst.EventEmitter2)()
};

});
parcelRegister("4E7es", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("aOz0a", function(module, exports) {
$parcel$export(module.exports, "isClientBasedAuth", () => $e4c60f7f5c984db4$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $e4c60f7f5c984db4$export$17f6055767a8d96a);
function $e4c60f7f5c984db4$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $e4c60f7f5c984db4$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $e4c60f7f5c984db4$export$17f6055767a8d96a = (auth)=>{
    if ($e4c60f7f5c984db4$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("kD2pI", function(module, exports) {
$parcel$export(module.exports, "ChunkHashAlgorithm", () => $9c6c4c1851a194a7$export$d3e73a50cc549c2e);
var $9c6c4c1851a194a7$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("bXafe", function(module, exports) {
$parcel$export(module.exports, "MediaStore", () => $f8f08115e3b30b6e$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $f8f08115e3b30b6e$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $f8f08115e3b30b6e$export$20f9315304dd6726);
parcelRequire("7F07j");
var $kD2pI = parcelRequire("kD2pI");
var $aOz0a = parcelRequire("aOz0a");

var $e1GLO = parcelRequire("e1GLO");

var $fXZcU = parcelRequire("fXZcU");

var $a6Vky = parcelRequire("a6Vky");
var $3d9KP = parcelRequire("3d9KP");

var $6769H = parcelRequire("6769H");

var $gjxu2 = parcelRequire("gjxu2");

var $jqiVv = parcelRequire("jqiVv");

var $fwHjD = parcelRequire("fwHjD");

var $6qN3B = parcelRequire("6qN3B");

var $e6Qdr = parcelRequire("e6Qdr");
const $f8f08115e3b30b6e$var$MEDIA_API_REGION = 'media-api-region';
const $f8f08115e3b30b6e$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $f8f08115e3b30b6e$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': (params === null || params === void 0 ? void 0 : params['max-age']) ?? (0, $e1GLO.FILE_CACHE_MAX_AGE),
        allowAnimated: (params === null || params === void 0 ? void 0 : params.allowAnimated) ?? true,
        mode: (params === null || params === void 0 ? void 0 : params.mode) ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $e1GLO.MAX_RESOLUTION),
            height: (0, $e1GLO.MAX_RESOLUTION)
        } : {}
    };
};
const $f8f08115e3b30b6e$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $f8f08115e3b30b6e$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $gjxu2.isCDNEnabled)()) result += '/cdn';
    return result;
};
const $f8f08115e3b30b6e$var$decodeJwtToken = (token)=>{
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
};
class $f8f08115e3b30b6e$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $e1GLO.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $6769H.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $3d9KP.request)(artifactUrl, options, abortController).then((0, $6769H.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $6769H.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $jqiVv.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $jqiVv.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $kD2pI.ChunkHashAlgorithm).Sha256;
    }
    async getClientId(collectionName) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return $f8f08115e3b30b6e$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
    }
    getClientIdSync() {
        try {
            const auth = this.resolveInitialAuth();
            return $f8f08115e3b30b6e$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
        } catch  {
            // initialAuth may not be available, return undefined
            return undefined;
        }
    }
    static extractClientIdFromAuth(auth) {
        if ((0, $aOz0a.isClientBasedAuth)(auth)) return auth.clientId;
        // decode JWT token and get clientId (or iss) from payload
        try {
            const jwtPayload = $f8f08115e3b30b6e$var$decodeJwtToken(auth.token);
            return jwtPayload.clientId;
        } catch  {
        // leave clientId as undefined
        }
        return undefined;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $6769H.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $f8f08115e3b30b6e$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $6769H.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $f8f08115e3b30b6e$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $6769H.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $6769H.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const wmv = (0, $e6Qdr.fg)('confluence_watermark_admin_ui') ? (0, $6qN3B.getWatermarkVersionFromToken)(auth.token) : undefined;
        const options = {
            params: {
                ...$f8f08115e3b30b6e$var$extendImageParams(params),
                ...wmv ? {
                    wmv: wmv
                } : {}
            },
            auth: auth
        };
        const imageEndpoint = $f8f08115e3b30b6e$var$cdnFeatureFlag('image');
        if ((0, $fwHjD.isPathBasedEnabled)()) return (0, $fwHjD.mapToPathBasedUrl)((0, $6769H.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
        return (0, $gjxu2.mapToMediaCdnUrl)((0, $6769H.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $e1GLO.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $f8f08115e3b30b6e$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $6769H.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $e1GLO.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $f8f08115e3b30b6e$var$cdnFeatureFlag('binary');
        if ((0, $fwHjD.isPathBasedEnabled)()) return (0, $fwHjD.mapToPathBasedUrl)((0, $6769H.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
        return (0, $gjxu2.mapToMediaCdnUrl)((0, $6769H.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $e1GLO.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
    	const cdnUrl = artifacts[artifactName]?.cdnUrl;
    	if (cdnUrl) {
    		return cdnUrl;
    	}
    } */ const artifactUrl = (0, $fXZcU.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const url = (0, $gjxu2.mapToMediaCdnUrl)((0, $6769H.createUrl)(`${auth.baseUrl}${artifactUrl}`, options), auth.token);
        if ((0, $fwHjD.isPathBasedEnabled)()) return (0, $fwHjD.mapToPathBasedUrl)(url);
        return url;
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $f8f08115e3b30b6e$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        let wmvParams = {};
        let authOptions = {
            authContext: {
                collectionName: params && params.collection
            }
        };
        if ((0, $e6Qdr.fg)('confluence_watermark_admin_ui')) {
            const auth = await this.resolveAuth(authOptions.authContext);
            const wmv = (0, $6qN3B.getWatermarkVersionFromToken)(auth.token);
            if (wmv) wmvParams = {
                wmv: wmv
            };
            authOptions = {
                resolvedAuth: auth
            };
        }
        const options = {
            ...metadata,
            ...authOptions,
            params: {
                ...$f8f08115e3b30b6e$var$extendImageParams(params, fetchMaxRes),
                ...wmvParams
            },
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $6769H.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $f8f08115e3b30b6e$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $6769H.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $6769H.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $f8f08115e3b30b6e$var$cdnFeatureFlag('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $e1GLO.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $6769H.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $f8f08115e3b30b6e$var$cdnFeatureFlag('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $e1GLO.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $6769H.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $f8f08115e3b30b6e$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: // Contains collection name to write to
            params,
            // Contains collection name to write to
            headers: $f8f08115e3b30b6e$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: // Contains collection name to read from
            traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $6769H.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext, clientId) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $f8f08115e3b30b6e$var$jsonHeaders,
            body: JSON.stringify({
                id: id,
                clientId: clientId
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>{
                        var _err$metadata;
                        return (0, $6769H.defaultShouldRetryError)(err) || (0, $a6Vky.isRequestError)(err) && (err === null || err === void 0 || (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode) === 401;
                    }
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $6769H.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $f8f08115e3b30b6e$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $aOz0a.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $6769H.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $gjxu2.mapToMediaCdnUrl)(url, auth.token);
        if ((0, $fwHjD.isPathBasedEnabled)()) url = (0, $fwHjD.mapToPathBasedUrl)(url);
        const response = await (0, $3d9KP.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $f8f08115e3b30b6e$var$setKeyValueInSessionStorage($f8f08115e3b30b6e$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $f8f08115e3b30b6e$var$setKeyValueInSessionStorage($f8f08115e3b30b6e$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $3d9KP.request)(url, {
            method: 'HEAD',
            traceContext: (0, $6769H.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $f8f08115e3b30b6e$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $f8f08115e3b30b6e$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $f8f08115e3b30b6e$export$c8b741e18397852a = ()=>{
    return $f8f08115e3b30b6e$var$getValueFromSessionStorage($f8f08115e3b30b6e$var$MEDIA_API_ENVIRONMENT);
};
const $f8f08115e3b30b6e$export$20f9315304dd6726 = ()=>{
    return $f8f08115e3b30b6e$var$getValueFromSessionStorage($f8f08115e3b30b6e$var$MEDIA_API_REGION);
};

});
parcelRegister("e1GLO", function(module, exports) {
$parcel$export(module.exports, "RECENTS_COLLECTION", () => $ff04a89316cefd77$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $ff04a89316cefd77$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $ff04a89316cefd77$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $ff04a89316cefd77$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $ff04a89316cefd77$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $ff04a89316cefd77$export$f14f521f3d306044);

var $9lyDh = parcelRequire("9lyDh");
const $ff04a89316cefd77$export$860a16125e30000b = 'recents';
const $ff04a89316cefd77$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $ff04a89316cefd77$export$6e70f30e392bc53f = 4096;
const $ff04a89316cefd77$export$c1abb8bab1e615cd = 5 * (0, $9lyDh.DATA_UNIT).MB;
const $ff04a89316cefd77$export$3d5157f0def70e54 = 1000;
const $ff04a89316cefd77$export$f14f521f3d306044 = 2 * (0, $9lyDh.DATA_UNIT).TB;

});
parcelRegister("9lyDh", function(module, exports) {
$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $ceb61f27c8899240$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $ceb61f27c8899240$export$76cfea4c354af843);
const $ceb61f27c8899240$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $ceb61f27c8899240$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $ceb61f27c8899240$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("fXZcU", function(module, exports) {
$parcel$export(module.exports, "getArtifactUrl", () => $c6d50a65939c511d$export$1cc24defa44e7f84);

var $gjxu2 = parcelRequire("gjxu2");
const $c6d50a65939c511d$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    var _artifacts$prop, _artifacts$prop3;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $gjxu2.isCDNEnabled)() && (_artifacts$prop = artifacts[prop]) !== null && _artifacts$prop !== void 0 && _artifacts$prop.url) {
        var _artifacts$prop2;
        return `${(_artifacts$prop2 = artifacts[prop]) === null || _artifacts$prop2 === void 0 ? void 0 : _artifacts$prop2.url}/cdn`;
    }
    return (_artifacts$prop3 = artifacts[prop]) === null || _artifacts$prop3 === void 0 ? void 0 : _artifacts$prop3.url;
};

});
parcelRegister("gjxu2", function(module, exports) {
$parcel$export(module.exports, "isCDNEnabled", () => $cf3ed81ed3ab59a4$export$3e47d0e609e44278);
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $cf3ed81ed3ab59a4$export$fb88a576cf28364d);

var $e6Qdr = parcelRequire("e6Qdr");

var $kg0Mq = parcelRequire("kg0Mq");

var $gOotW = parcelRequire("gOotW");

var $fwHjD = parcelRequire("fwHjD");
const $cf3ed81ed3ab59a4$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $cf3ed81ed3ab59a4$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $cf3ed81ed3ab59a4$export$3e47d0e609e44278() {
    return (0, $kg0Mq.isCommercial)() && !(0, $gOotW.isIsolatedCloud)() && (0, $e6Qdr.fg)('platform_media_cdn_delivery') && !(0, $fwHjD.isPathBasedEnabled)();
}
function $cf3ed81ed3ab59a4$export$fb88a576cf28364d(url, token) {
    const tokenLength = (token === null || token === void 0 ? void 0 : token.length) ?? 0;
    if (!$cf3ed81ed3ab59a4$export$3e47d0e609e44278() || tokenLength > $cf3ed81ed3ab59a4$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $e6Qdr.fg)('platform_media_cdn_delivery') && (0, $e6Qdr.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $cf3ed81ed3ab59a4$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("kg0Mq", function(module, exports) {
$parcel$export(module.exports, "isCommercial", () => $1a6ff5bb1536a5d7$export$df69ff6733e73e50);
function $1a6ff5bb1536a5d7$export$df69ff6733e73e50() {
    var _global$location;
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !((_global$location = global.location) !== null && _global$location !== void 0 && (_global$location = _global$location.hostname) !== null && _global$location !== void 0 && _global$location.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/));
}

});

parcelRegister("fwHjD", function(module, exports) {
$parcel$export(module.exports, "isPathBasedEnabled", () => $22ebef68238a5a3f$export$6de3392754e98e65);
$parcel$export(module.exports, "mapToPathBasedUrl", () => $22ebef68238a5a3f$export$774e2add1fbe26aa);
$parcel$export(module.exports, "mapRetryUrlToPathBasedUrl", () => $22ebef68238a5a3f$export$e71b0af0000b3cfa);

var $e6Qdr = parcelRequire("e6Qdr");

var $iJTif = parcelRequire("iJTif");
const $22ebef68238a5a3f$var$mediaApiPathPrefix = '/media-api';
function $22ebef68238a5a3f$var$getRelativeUrl(absoluteUrl) {
    const url = new URL(absoluteUrl);
    return `${url.pathname}${url.search}${url.hash}`;
}
function $22ebef68238a5a3f$export$6de3392754e98e65() {
    var _getDocument;
    const isLocalhost = ((_getDocument = (0, $iJTif.default)()) === null || _getDocument === void 0 || (_getDocument = _getDocument.location) === null || _getDocument === void 0 ? void 0 : _getDocument.hostname) === 'localhost';
    return (0, $e6Qdr.fg)('platform_media_path_based_route') && !isLocalhost;
}
function $22ebef68238a5a3f$export$774e2add1fbe26aa(url) {
    if ($22ebef68238a5a3f$export$6de3392754e98e65()) {
        var _getDocument2;
        const parsedUrl = new URL(url);
        if (!parsedUrl.pathname.startsWith($22ebef68238a5a3f$var$mediaApiPathPrefix)) parsedUrl.pathname = `${$22ebef68238a5a3f$var$mediaApiPathPrefix}${parsedUrl.pathname}`;
        const location = (_getDocument2 = (0, $iJTif.default)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $22ebef68238a5a3f$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}
function $22ebef68238a5a3f$export$e71b0af0000b3cfa(url) {
    var _getDocument3;
    const parsedUrl = new URL(url);
    parsedUrl.host = ((_getDocument3 = (0, $iJTif.default)()) === null || _getDocument3 === void 0 ? void 0 : _getDocument3.location.host) ?? '';
    // remove CDN from the URL for retry if it exists
    const pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    if (!parsedUrl.pathname.startsWith($22ebef68238a5a3f$var$mediaApiPathPrefix)) parsedUrl.pathname = `${$22ebef68238a5a3f$var$mediaApiPathPrefix}${parsedUrl.pathname}`;
    return parsedUrl;
}

});
parcelRegister("iJTif", function(module, exports) {
$parcel$export(module.exports, "default", () => $792fb8dfa549f74b$export$2e2bcd8739ae039);
var $792fb8dfa549f74b$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




parcelRegister("a6Vky", function(module, exports) {
$parcel$export(module.exports, "RequestError", () => $7a8b57ee01eab3f0$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $7a8b57ee01eab3f0$export$3717b1ffef4428ea);

var $cMcHx = parcelRequire("cMcHx");
class $7a8b57ee01eab3f0$export$43ee7d0e4f429743 extends (0, $cMcHx.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $7a8b57ee01eab3f0$export$3717b1ffef4428ea(err) {
    return err instanceof $7a8b57ee01eab3f0$export$43ee7d0e4f429743;
}

});
parcelRegister("cMcHx", function(module, exports) {
$parcel$export(module.exports, "BaseMediaClientError", () => $e4e3f9f208c66d21$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $e4e3f9f208c66d21$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $e4e3f9f208c66d21$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $e4e3f9f208c66d21$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $e4e3f9f208c66d21$export$c2b89b9a32286816);

var $hVb4r = parcelRequire("hVb4r");
class $e4e3f9f208c66d21$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $e4e3f9f208c66d21$export$e574d1724215079f extends $e4e3f9f208c66d21$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $e4e3f9f208c66d21$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $e4e3f9f208c66d21$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $e4e3f9f208c66d21$export$a5db89cfc88eff9 = (errorFileState)=>{
    var _errorFileState$detai;
    const error = (_errorFileState$detai = errorFileState.details) === null || _errorFileState$detai === void 0 ? void 0 : _errorFileState$detai.error;
    return new $e4e3f9f208c66d21$export$e574d1724215079f((error === null || error === void 0 ? void 0 : error.reason) || 'unknown-reason', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
};
const $e4e3f9f208c66d21$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error === null || error === void 0 ? void 0 : error.reason,
                metadata: error === null || error === void 0 ? void 0 : error.metadata,
                innerError: error === null || error === void 0 ? void 0 : error.innerError
            },
            // Legacy details
            ...error === null || error === void 0 ? void 0 : error.attributes
        },
        message: error === null || error === void 0 ? void 0 : error.message
    };
};

});
parcelRegister("hVb4r", function(module, exports) {
$parcel$export(module.exports, "getMediaClientErrorReason", () => $a6b0848094322e88$export$c15d72765ee2baa4);
function $a6b0848094322e88$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $a6b0848094322e88$export$c15d72765ee2baa4(err) {
    return $a6b0848094322e88$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("3d9KP", function(module, exports) {
$parcel$export(module.exports, "request", () => $d850f7820328b30c$export$b5fe3f66a567bec0);

var $a6Vky = parcelRequire("a6Vky");

var $6769H = parcelRequire("6769H");

var $e6Qdr = parcelRequire("e6Qdr");

var $fwHjD = parcelRequire("fwHjD");

var $6ypPU = parcelRequire("6ypPU");
async function $d850f7820328b30c$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $6769H.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $6769H.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $6769H.createProcessFetchResponse)(metadata));
    if ((0, $e6Qdr.fg)('platform_media_retry_edge_error')) {
        const shouldRetryError = (err)=>{
            var _getNavigator;
            if ((0, $6769H.isFetchNetworkError)(err) && (_getNavigator = (0, $6ypPU.default)()) !== null && _getNavigator !== void 0 && _getNavigator.userAgent.includes('Edg/')) return false;
            return (0, $6769H.defaultShouldRetryError)(err);
        };
        try {
            return await (0, $6769H.fetchRetry)(doFetch, metadata, {
                ...retryOptions,
                shouldRetryError: shouldRetryError
            });
        } catch (error) {
            var _getNavigator2;
            if ((0, $6769H.isFetchNetworkError)(error) && (_getNavigator2 = (0, $6ypPU.default)()) !== null && _getNavigator2 !== void 0 && _getNavigator2.userAgent.includes('Edg/')) {
                const doFetchWithPathBasedUrl = ()=>fetch((0, $6769H.createUrl)((0, $fwHjD.mapRetryUrlToPathBasedUrl)(url).toString(), {
                        params: params
                    }), {
                        method: method,
                        body: body,
                        headers: (0, $6769H.extendHeaders)(headers, auth, traceContext),
                        signal: controller && controller.signal
                    }).then((0, $6769H.createProcessFetchResponse)(metadata));
                return (0, $6769H.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions);
            }
            throw error;
        }
    }
    return (0, $6769H.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("6769H", function(module, exports) {
$parcel$export(module.exports, "isFetchNetworkError", () => $eb7e7ea86cb70df3$export$ad8c5cf7dd4c3caf);
$parcel$export(module.exports, "extendTraceContext", () => $eb7e7ea86cb70df3$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $eb7e7ea86cb70df3$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $eb7e7ea86cb70df3$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $eb7e7ea86cb70df3$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $eb7e7ea86cb70df3$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $eb7e7ea86cb70df3$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $eb7e7ea86cb70df3$export$782df2acbe10b22c);
$parcel$export(module.exports, "createProcessFetchResponse", () => $eb7e7ea86cb70df3$export$6e2e477edb7d6032);
parcelRequire("7F07j");
var $aOz0a = parcelRequire("aOz0a");

var $cul7x = parcelRequire("cul7x");

var $8kmt4 = parcelRequire("8kmt4");

var $a6Vky = parcelRequire("a6Vky");
const $eb7e7ea86cb70df3$var$getStatusCode = (error)=>{
    var _error$metadata;
    return (0, $a6Vky.isRequestError)(error) && ((_error$metadata = error.metadata) === null || _error$metadata === void 0 ? void 0 : _error$metadata.statusCode) && error.metadata.statusCode;
};
function $eb7e7ea86cb70df3$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $eb7e7ea86cb70df3$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $eb7e7ea86cb70df3$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $eb7e7ea86cb70df3$export$bc96a6a479480590(error) {
    const statusCode = error && $eb7e7ea86cb70df3$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $eb7e7ea86cb70df3$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: (traceContext === null || traceContext === void 0 ? void 0 : traceContext.spanId) || (0, $cul7x.getRandomTelemetryId)()
    } : undefined;
const $eb7e7ea86cb70df3$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $eb7e7ea86cb70df3$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$eb7e7ea86cb70df3$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$eb7e7ea86cb70df3$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $eb7e7ea86cb70df3$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $aOz0a.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $eb7e7ea86cb70df3$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth === null || auth === void 0 ? void 0 : auth.baseUrl);
    const authParams = auth && (0, $8kmt4.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $eb7e7ea86cb70df3$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$eb7e7ea86cb70df3$export$eaf4479116d2f925(auth),
        ...$eb7e7ea86cb70df3$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $eb7e7ea86cb70df3$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $a6Vky.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$eb7e7ea86cb70df3$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $eb7e7ea86cb70df3$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $a6Vky.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$eb7e7ea86cb70df3$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $eb7e7ea86cb70df3$export$fee2242cbb339663 = (err)=>{
    const statusCode = $eb7e7ea86cb70df3$var$getStatusCode(err);
    return $eb7e7ea86cb70df3$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $eb7e7ea86cb70df3$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    // 1 second is generally a good timeout to start
    maxAttempts: 5,
    // Current test delay is 60s, so retries should finish before if a promise takes < 1s
    factor: 2 // Good for polling, which is out main use case
};
function $eb7e7ea86cb70df3$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $a6Vky.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $eb7e7ea86cb70df3$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$eb7e7ea86cb70df3$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $eb7e7ea86cb70df3$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $eb7e7ea86cb70df3$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($eb7e7ea86cb70df3$export$de0b576cf7ce4a53(err)) throw new (0, $a6Vky.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $a6Vky.isRequestError)(lastError)) throw $eb7e7ea86cb70df3$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $a6Vky.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $eb7e7ea86cb70df3$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $eb7e7ea86cb70df3$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $eb7e7ea86cb70df3$export$6397609af718d008(statusCode);
    return new (0, $a6Vky.RequestError)(reason, {
        ...metadata,
        ...$eb7e7ea86cb70df3$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $eb7e7ea86cb70df3$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $eb7e7ea86cb70df3$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $eb7e7ea86cb70df3$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("cul7x", function(module, exports) {
$parcel$export(module.exports, "isUndefined", () => $0890cbc3c50f327c$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $0890cbc3c50f327c$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $0890cbc3c50f327c$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $0890cbc3c50f327c$export$2e36de8639bad0ad);
const $0890cbc3c50f327c$export$fce6876652108ab = (value)=>value === undefined;
const $0890cbc3c50f327c$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $0890cbc3c50f327c$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $0890cbc3c50f327c$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $0890cbc3c50f327c$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $0890cbc3c50f327c$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $0890cbc3c50f327c$export$456b25e3a9b4a843(byte) {
    var _window;
    let randomHex;
    if ((_window = window) !== null && _window !== void 0 && _window.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $0890cbc3c50f327c$var$getRandomHexValues(byte);
    }
    else randomHex = $0890cbc3c50f327c$var$getRandomHexValues(byte);
    return randomHex;
}
function $0890cbc3c50f327c$export$2e36de8639bad0ad() {
    return $0890cbc3c50f327c$export$456b25e3a9b4a843(8);
}

});

parcelRegister("8kmt4", function(module, exports) {
$parcel$export(module.exports, "mapAuthToQueryParameters", () => $5d5fb2ef2e6aa517$export$6833b130611df767);
parcelRequire("7F07j");
var $aOz0a = parcelRequire("aOz0a");
function $5d5fb2ef2e6aa517$export$6833b130611df767(auth) {
    if ((0, $aOz0a.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});


parcelRegister("6ypPU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5a06b3aa35d7b84$export$2e2bcd8739ae039);
var $a5a06b3aa35d7b84$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};

});


parcelRegister("jqiVv", function(module, exports) {
$parcel$export(module.exports, "resolveAuth", () => $84aff70188401d5a$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $84aff70188401d5a$export$5211e1371264aec3);

var $e6Qdr = parcelRequire("e6Qdr");

var $jwTaq = parcelRequire("jwTaq");

var $fVZIj = parcelRequire("fVZIj");

var $1hC07 = parcelRequire("1hC07");
const $84aff70188401d5a$export$560085fe411c0660 = 10000;
const $84aff70188401d5a$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $84aff70188401d5a$export$560085fe411c0660)=>{
    const startTime = performance.now();
    let eventEmitted = false;
    // Feature flag: wrap authProvider with analytics event emission
    const authProviderPromise = (0, $e6Qdr.fg)('platform_media_auth_provider_analytics') ? authProvider(authContext).then((result)=>{
        const durationMs = performance.now() - startTime;
        if (!eventEmitted) {
            eventEmitted = true;
            (0, $1hC07.globalMediaEventEmitter).emit('auth-provider-succeeded', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext
            });
        } else {
            // Timeout already fired - auth arrived too late
            const timeoutError = new (0, $jwTaq.MediaStoreError)('authProviderTimedOut');
            (0, $1hC07.globalMediaEventEmitter).emit('auth-provider-failed', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext,
                error: timeoutError
            });
        }
        return result;
    }).catch((error)=>{
        const durationMs = performance.now() - startTime;
        eventEmitted = true;
        (0, $1hC07.globalMediaEventEmitter).emit('auth-provider-failed', {
            durationMs: durationMs,
            timeoutMs: authProviderTimeout,
            authContext: authContext,
            error: error
        });
        throw error;
    }) : authProvider(authContext); // Original behavior when FG off
    let auth;
    try {
        auth = await Promise.race([
            authProviderPromise,
            (0, $fVZIj.rejectTimeout)(authProviderTimeout, new (0, $jwTaq.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        // Mark as emitted so late arrivals are handled correctly by .then()/.catch()
        if (!eventEmitted && (0, $e6Qdr.fg)('platform_media_auth_provider_analytics')) eventEmitted = true;
        // PRESERVE ORIGINAL ERROR HANDLING
        if (err instanceof (0, $jwTaq.MediaStoreError)) throw err;
        throw new (0, $jwTaq.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $jwTaq.MediaStoreError)('emptyAuth');
    /*
     We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
     Token expiration check in the frontend is a bad idea. Don't do it!
     More info:
     https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
     https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
   */ return auth;
};
const $84aff70188401d5a$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $jwTaq.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("jwTaq", function(module, exports) {
$parcel$export(module.exports, "MediaStoreError", () => $cd914708319b8dad$export$b78480bd311630bc);

var $cMcHx = parcelRequire("cMcHx");
class $cd914708319b8dad$export$b78480bd311630bc extends (0, $cMcHx.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $cd914708319b8dad$export$8d2a9b675b2ce37a(err) {
    return err instanceof $cd914708319b8dad$export$b78480bd311630bc;
}

});

parcelRegister("fVZIj", function(module, exports) {
$parcel$export(module.exports, "rejectTimeout", () => $011a00658d6d7e59$export$cf2d2a1124beacb2);
const $011a00658d6d7e59$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $011a00658d6d7e59$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});

parcelRegister("1hC07", function(module, exports) {
$parcel$export(module.exports, "globalMediaEventEmitter", () => $fab79d54031f6ad4$export$68d003d3105952ad);
parcelRequire("7F07j");
var $lSQPi = parcelRequire("lSQPi");
const $fab79d54031f6ad4$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $lSQPi.mediaState).eventEmitter) (0, $lSQPi.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $lSQPi.mediaState).eventEmitter) (0, $lSQPi.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $lSQPi.mediaState).eventEmitter) return (0, $lSQPi.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});


parcelRegister("6qN3B", function(module, exports) {
$parcel$export(module.exports, "getWatermarkVersionFromToken", () => $c0963c21722d65e5$export$5296269cf74e58e);
function $c0963c21722d65e5$export$5296269cf74e58e(token) {
    try {
        const parts = token.split('.');
        if (parts.length < 2) return undefined;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.watermark) return undefined;
        const watermarkData = JSON.parse(payload.watermark);
        return watermarkData.v;
    } catch  {
        return undefined;
    }
}

});


parcelRegister("5Ivto", function(module, exports) {
$parcel$export(module.exports, "FileFetcherImpl", () => $7dbec4e710b69f74$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("gVdPo")).FileFetcherError);

var $aBkDT = parcelRequire("aBkDT");

var $a8ocL = parcelRequire("a8ocL");

var $9e0lC = parcelRequire("9e0lC");
parcelRequire("7F07j");
var $aOz0a = parcelRequire("aOz0a");

var $e6Qdr = parcelRequire("e6Qdr");

var $1oLwy = parcelRequire("1oLwy");

var $bXafe = parcelRequire("bXafe");

var $57mjO = parcelRequire("57mjO");

var $9lyDh = parcelRequire("9lyDh");

var $gVdPo = parcelRequire("gVdPo");

var $kGH4Z = parcelRequire("kGH4Z");

var $iv4S5 = parcelRequire("iv4S5");

var $1hC07 = parcelRequire("1hC07");

var $e1GLO = parcelRequire("e1GLO");

var $hEYLa = parcelRequire("hEYLa");

var $3C79p = parcelRequire("3C79p");

var $kvTXU = parcelRequire("kvTXU");

var $9DbYH = parcelRequire("9DbYH");

var $a2gNT = parcelRequire("a2gNT");

var $hdLcR = parcelRequire("hdLcR");
var $bYXwd = parcelRequire("bYXwd");

var $653NU = parcelRequire("653NU");

var $4bshn = parcelRequire("4bshn");

var $o96nQ = parcelRequire("o96nQ");

var $grbQp = parcelRequire("grbQp");

var $k8hLB = parcelRequire("k8hLB");

var $7jtRJ = parcelRequire("7jtRJ");
parcelRequire("9XIuz");
var $2qxba = parcelRequire("2qxba");

var $i4Us6 = parcelRequire("i4Us6");

var $6769H = parcelRequire("6769H");

var $cMcHx = parcelRequire("cMcHx");
const $7dbec4e710b69f74$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $7dbec4e710b69f74$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $7dbec4e710b69f74$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $2qxba.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $cMcHx.isCommonMediaClientError)(error)) return (0, $cMcHx.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $cMcHx.CommonMediaClientError)(error);
                return (0, $cMcHx.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $cMcHx.CommonMediaClientError)((error === null || error === void 0 ? void 0 : error.reason) || 'unknown', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
                return (0, $cMcHx.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh)=>{
            const subject = (0, $4bshn.createMediaSubject)();
            const poll = new (0, $k8hLB.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $9lyDh.isNotFoundMediaItemDetails)(response)) throw new (0, $gVdPo.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $7jtRJ.isEmptyFile)(response)) throw new (0, $gVdPo.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $57mjO.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $a2gNT.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' // name property is not available in base64 image
             } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $kvTXU.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $57mjO.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            var _fileState$mediaMetad;
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            if ('mediaMetadata' in fileState && (_fileState$mediaMetad = fileState.mediaMetadata) !== null && _fileState$mediaMetad !== void 0 && _fileState$mediaMetad.duration) return fileState.mediaMetadata.duration;
            // If the duration is not present, we need to fetch it from the artifact
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch  {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $3C79p.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $i4Us6.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hEYLa)))(id)) {
            const subject = (0, $4bshn.createMediaSubject)();
            const err = new (0, $gVdPo.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $hdLcR.fromObservable)(subject);
        }
        if (forceRefresh) (0, $iv4S5.getFileStreamsCache)().remove(id);
        return (0, $hdLcR.fromObservable)((0, $iv4S5.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $bYXwd.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($9e0lC)))();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($9e0lC)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $4bshn.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = (0, $e6Qdr.fg)('platform_media_upload_external_anonymize_filename') ? crypto.randomUUID() : url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $iv4S5.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $o96nQ.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $653NU.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $4bshn.createMediaSubject)();
        (0, $iv4S5.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $aBkDT.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $a8ocL.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $9DbYH.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $kGH4Z.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller === null || controller === void 0 || controller.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $hdLcR.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $1oLwy.downloadUrl)(url, {
            name: name
        });
        (0, $1hC07.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $e1GLO.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $6769H.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $bXafe.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $aOz0a.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext, source.clientId);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $iv4S5.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($7dbec4e710b69f74$var$isCopySourceFileWithToken(source) && $7dbec4e710b69f74$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $o96nQ.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $57mjO.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $4bshn.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $57mjO.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $57mjO.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $grbQp.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $9DbYH.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $9DbYH.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $57mjO.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $57mjO.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $57mjO.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $iv4S5.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $4bshn.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("a8ocL", function(module, exports) {
"use strict";
var $760d6d55cbf617d0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $760d6d55cbf617d0$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        return source.lift(new $760d6d55cbf617d0$var$MapOperator(project, thisArg));
    };
}
module.exports.map = $760d6d55cbf617d0$var$map;
var $760d6d55cbf617d0$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $760d6d55cbf617d0$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
module.exports.MapOperator = $760d6d55cbf617d0$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $760d6d55cbf617d0$var$MapSubscriber = function(_super) {
    $760d6d55cbf617d0$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($8qR8S.Subscriber);

});

parcelRegister("1oLwy", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $a964cec3fe95b1cc$export$8a96edb1c96563f4);
const $a964cec3fe95b1cc$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("57mjO", function(module, exports) {
$parcel$export(module.exports, "isUploadingFileState", () => $33f609b7ab68ac47$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $33f609b7ab68ac47$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $33f609b7ab68ac47$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $33f609b7ab68ac47$export$f863e1e09c8a926);
$parcel$export(module.exports, "isFinalFileState", () => $33f609b7ab68ac47$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $33f609b7ab68ac47$export$8f33148a37b0c72f);
$parcel$export(module.exports, "hasArtifacts", () => $33f609b7ab68ac47$export$ecdf3dee1d148302);
$parcel$export(module.exports, "isImageRepresentationReady", () => $33f609b7ab68ac47$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $33f609b7ab68ac47$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $33f609b7ab68ac47$export$ea3730792e8bebfb);
const $33f609b7ab68ac47$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $33f609b7ab68ac47$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $33f609b7ab68ac47$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $33f609b7ab68ac47$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $33f609b7ab68ac47$export$92dd692b31e42e64 = (fileState)=>!$33f609b7ab68ac47$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $33f609b7ab68ac47$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $33f609b7ab68ac47$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $33f609b7ab68ac47$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $33f609b7ab68ac47$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $33f609b7ab68ac47$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata, failReason: failReason } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing',
                failReason: failReason
            };
    }
};
const $33f609b7ab68ac47$export$ea3730792e8bebfb = (id, item)=>{
    return $33f609b7ab68ac47$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("gVdPo", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => $025d58c5780f85ca$export$e3e60f0dab8641de);

var $cMcHx = parcelRequire("cMcHx");
class $025d58c5780f85ca$export$e3e60f0dab8641de extends (0, $cMcHx.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $025d58c5780f85ca$export$5c3435f75ce0ce70(err) {
    return err instanceof $025d58c5780f85ca$export$e3e60f0dab8641de;
}

});

parcelRegister("kGH4Z", function(module, exports) {
$parcel$export(module.exports, "uploadFile", () => $b62d4fe7cc76fb01$export$a5575dbeeffdad98);

var $6OLyD = parcelRequire("6OLyD");

var $dwdYm = parcelRequire("dwdYm");

var $6xf0A = parcelRequire("6xf0A");

var $eRu6S = parcelRequire("eRu6S");

var $8lDv8 = parcelRequire("8lDv8");

var $e1GLO = parcelRequire("e1GLO");

var $1madi = parcelRequire("1madi");
const $b62d4fe7cc76fb01$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $eRu6S.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $b62d4fe7cc76fb01$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $b62d4fe7cc76fb01$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $b62d4fe7cc76fb01$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $b62d4fe7cc76fb01$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $b62d4fe7cc76fb01$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $e1GLO.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $1madi.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $1madi.fileSizeError)) callbacks === null || callbacks === void 0 || callbacks.onUploadFinish(new (0, $8lDv8.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks === null || callbacks === void 0 || callbacks.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $6OLyD.chunkinator)(content, {
        hashingFunction: (blob)=>$b62d4fe7cc76fb01$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $b62d4fe7cc76fb01$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $e1GLO.PROCESSING_BATCH_SIZE),
        processingFunction: $b62d4fe7cc76fb01$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $dwdYm.from)(deferredUploadId).pipe((0, $6xf0A.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $6xf0A.concatMap)(()=>(0, $dwdYm.from)($b62d4fe7cc76fb01$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $b62d4fe7cc76fb01$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("6OLyD", function(module, exports) {
$parcel$export(module.exports, "chunkinator", () => $1831f867494d3e69$export$9ab6bef3838698f8);

var $epwkG = parcelRequire("epwkG");

var $6xf0A = parcelRequire("6xf0A");

var $ezyFF = parcelRequire("ezyFF");

var $lDQiC = parcelRequire("lDQiC");

var $80OSY = parcelRequire("80OSY");

var $c0Ho7 = parcelRequire("c0Ho7");

var $8TU0b = parcelRequire("8TU0b");

var $e4kE8 = parcelRequire("e4kE8");

var $ihdZY = parcelRequire("ihdZY");

var $dwdYm = parcelRequire("dwdYm");
const $1831f867494d3e69$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $lDQiC.fromPromise)((0, $ihdZY.fetchBlob)(file)).pipe((0, $6xf0A.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $80OSY.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $c0Ho7.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $8TU0b.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $epwkG.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $e4kE8.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $6xf0A.concatMap)((batchedChunks)=>{
            return (0, $dwdYm.from)(batchedChunks);
        }), (0, $ezyFF.bufferCount)(totalChunks));
    }));
const $1831f867494d3e69$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $1831f867494d3e69$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("epwkG", function(module, exports) {
"use strict";
var $a7dc7b14064ef761$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $a7dc7b14064ef761$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $a7dc7b14064ef761$var$DoOperator(nextOrObserver, error, complete));
    };
}
module.exports.tap = $a7dc7b14064ef761$var$tap;
var $a7dc7b14064ef761$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a7dc7b14064ef761$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a7dc7b14064ef761$var$DoSubscriber = function(_super) {
    $a7dc7b14064ef761$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $8qR8S.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($8qR8S.Subscriber);

});

parcelRegister("6xf0A", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $4c217784ab20fd5a$export$c28c8388be0ab31a, (v) => $4c217784ab20fd5a$export$c28c8388be0ab31a = v);
var $4c217784ab20fd5a$export$c28c8388be0ab31a;
"use strict";

var $5iPTs = parcelRequire("5iPTs");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $4c217784ab20fd5a$var$concatMap(project, resultSelector) {
    return $5iPTs.mergeMap(project, resultSelector, 1);
}
$4c217784ab20fd5a$export$c28c8388be0ab31a = $4c217784ab20fd5a$var$concatMap;

});
parcelRegister("5iPTs", function(module, exports) {
"use strict";
var $3dc6e321131b358d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $2Q6Ms = parcelRequire("2Q6Ms");

var $9u1V0 = parcelRequire("9u1V0");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $3dc6e321131b358d$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $3dc6e321131b358d$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
module.exports.mergeMap = $3dc6e321131b358d$var$mergeMap;
var $3dc6e321131b358d$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $3dc6e321131b358d$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
module.exports.MergeMapOperator = $3dc6e321131b358d$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3dc6e321131b358d$var$MergeMapSubscriber = function(_super) {
    $3dc6e321131b358d$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($2Q6Ms.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($9u1V0.OuterSubscriber);
module.exports.MergeMapSubscriber = $3dc6e321131b358d$var$MergeMapSubscriber;

});
parcelRegister("2Q6Ms", function(module, exports) {
$parcel$export(module.exports, "subscribeToResult", () => $2115b29934da5564$export$d0604af3321cfb1b, (v) => $2115b29934da5564$export$d0604af3321cfb1b = v);
var $2115b29934da5564$export$d0604af3321cfb1b;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");

var $aLjgb = parcelRequire("aLjgb");

var $cBWuO = parcelRequire("cBWuO");

var $jr9dF = parcelRequire("jr9dF");

var $fSYYZ = parcelRequire("fSYYZ");

var $7lPC2 = parcelRequire("7lPC2");

var $dBHHM = parcelRequire("dBHHM");

var $bGiX7 = parcelRequire("bGiX7");
function $2115b29934da5564$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $dBHHM.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $fSYYZ.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($aLjgb.isArrayLike(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($cBWuO.isPromise(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $9Cdpe.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$7lPC2.iterator] === 'function') {
        var iterator = result[$7lPC2.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$bGiX7.observable] === 'function') {
        var obs = result[$bGiX7.observable]();
        if (typeof obs.subscribe !== 'function') destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        else return obs.subscribe(new $dBHHM.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $jr9dF.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
$2115b29934da5564$export$d0604af3321cfb1b = $2115b29934da5564$var$subscribeToResult;

});
parcelRegister("aLjgb", function(module, exports) {
$parcel$export(module.exports, "isArrayLike", () => $7d5d3bc87b59349d$export$1e2f57719e155213, (v) => $7d5d3bc87b59349d$export$1e2f57719e155213 = v);
var $7d5d3bc87b59349d$export$1e2f57719e155213;
"use strict";
$7d5d3bc87b59349d$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("cBWuO", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $92e650d781ea5bea$export$4369c812aac99591, (v) => $92e650d781ea5bea$export$4369c812aac99591 = v);
var $92e650d781ea5bea$export$4369c812aac99591;
"use strict";
function $92e650d781ea5bea$var$isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
$92e650d781ea5bea$export$4369c812aac99591 = $92e650d781ea5bea$var$isPromise;

});

parcelRegister("7lPC2", function(module, exports) {
$parcel$export(module.exports, "iterator", () => $55a287b73aa092c7$export$6f58e2338da23f4d, (v) => $55a287b73aa092c7$export$6f58e2338da23f4d = v);
var $55a287b73aa092c7$export$77b88d321d1c84c6;
var $55a287b73aa092c7$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $55a287b73aa092c7$export$9785f547d3164dac;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");
function $55a287b73aa092c7$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) Symbol.iterator = Symbol('iterator polyfill');
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') return '@@iterator';
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) return key;
            }
        }
        return '@@iterator';
    }
}
$55a287b73aa092c7$export$77b88d321d1c84c6 = $55a287b73aa092c7$var$symbolIteratorPonyfill;
$55a287b73aa092c7$export$6f58e2338da23f4d = $55a287b73aa092c7$var$symbolIteratorPonyfill($9Cdpe.root);
$55a287b73aa092c7$export$9785f547d3164dac = $55a287b73aa092c7$export$6f58e2338da23f4d;

});

parcelRegister("dBHHM", function(module, exports) {
"use strict";
var $9e80a2016c2e875c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9e80a2016c2e875c$var$InnerSubscriber = function(_super) {
    $9e80a2016c2e875c$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($8qR8S.Subscriber);
module.exports.InnerSubscriber = $9e80a2016c2e875c$var$InnerSubscriber;

});


parcelRegister("9u1V0", function(module, exports) {
"use strict";
var $6e786759e1d605a5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6e786759e1d605a5$var$OuterSubscriber = function(_super) {
    $6e786759e1d605a5$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($8qR8S.Subscriber);
module.exports.OuterSubscriber = $6e786759e1d605a5$var$OuterSubscriber;

});



parcelRegister("ezyFF", function(module, exports) {
"use strict";
var $a9bf3a873fb736de$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $a9bf3a873fb736de$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new $a9bf3a873fb736de$var$BufferCountOperator(bufferSize, startBufferEvery));
    };
}
module.exports.bufferCount = $a9bf3a873fb736de$var$bufferCount;
var $a9bf3a873fb736de$var$BufferCountOperator = function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = $a9bf3a873fb736de$var$BufferCountSubscriber;
        else this.subscriberClass = $a9bf3a873fb736de$var$BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a9bf3a873fb736de$var$BufferCountSubscriber = function(_super) {
    $a9bf3a873fb736de$var$__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}($8qR8S.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a9bf3a873fb736de$var$BufferSkipCountSubscriber = function(_super) {
    $a9bf3a873fb736de$var$__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}($8qR8S.Subscriber);

});

parcelRegister("lDQiC", function(module, exports) {
$parcel$export(module.exports, "fromPromise", () => $fc15cf0a6ed6fe67$export$60f45028237c39d1, (v) => $fc15cf0a6ed6fe67$export$60f45028237c39d1 = v);
var $fc15cf0a6ed6fe67$export$60f45028237c39d1;
"use strict";

var $k6qiL = parcelRequire("k6qiL");
$fc15cf0a6ed6fe67$export$60f45028237c39d1 = $k6qiL.PromiseObservable.create;

});
parcelRegister("k6qiL", function(module, exports) {
"use strict";
var $ea28c5214c447e97$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9Cdpe = parcelRequire("9Cdpe");

var $fSYYZ = parcelRequire("fSYYZ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $ea28c5214c447e97$var$PromiseObservable = function(_super) {
    $ea28c5214c447e97$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $9Cdpe.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($ea28c5214c447e97$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($ea28c5214c447e97$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($ea28c5214c447e97$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $9Cdpe.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($fSYYZ.Observable);
module.exports.PromiseObservable = $ea28c5214c447e97$var$PromiseObservable;
function $ea28c5214c447e97$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $ea28c5214c447e97$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}

});


parcelRegister("80OSY", function(module, exports) {
$parcel$export(module.exports, "slicenator", () => $19541a5bac4e97db$export$5b92d769f2f57509);

var $dp85X = parcelRequire("dp85X");

var $a8ocL = parcelRequire("a8ocL");
const $19541a5bac4e97db$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $dp85X.range)(0, totalChunks).pipe((0, $a8ocL.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});
parcelRegister("dp85X", function(module, exports) {
$parcel$export(module.exports, "range", () => $9c23e3a943493204$export$d02631cccf789723, (v) => $9c23e3a943493204$export$d02631cccf789723 = v);
var $9c23e3a943493204$export$d02631cccf789723;
"use strict";

var $6QQsE = parcelRequire("6QQsE");
$9c23e3a943493204$export$d02631cccf789723 = $6QQsE.RangeObservable.create;

});
parcelRegister("6QQsE", function(module, exports) {
"use strict";
var $4fd04b1a3a909201$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $4fd04b1a3a909201$var$RangeObservable = function(_super) {
    $4fd04b1a3a909201$var$__extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */ RangeObservable.create = function(start, count, scheduler) {
        if (start === void 0) start = 0;
        if (count === void 0) count = 0;
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function(state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) return;
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(RangeObservable.dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(start++);
            if (subscriber.closed) break;
        }while (true);
    };
    return RangeObservable;
}($fSYYZ.Observable);
module.exports.RangeObservable = $4fd04b1a3a909201$var$RangeObservable;

});



parcelRegister("c0Ho7", function(module, exports) {
$parcel$export(module.exports, "hashinator", () => $cbc6b2f85cb5a39a$export$d5f5a550a38ec367);

var $ihdZY = parcelRequire("ihdZY");
const $cbc6b2f85cb5a39a$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $cbc6b2f85cb5a39a$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $ihdZY.asyncMap)($cbc6b2f85cb5a39a$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("ihdZY", function(module, exports) {
$parcel$export(module.exports, "fetchBlob", () => $fdef0f46430f2429$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $fdef0f46430f2429$export$707ee4c4c95d39e3);

var $fSYYZ = parcelRequire("fSYYZ");

var $5iPTs = parcelRequire("5iPTs");
async function $fdef0f46430f2429$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $fdef0f46430f2429$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $fdef0f46430f2429$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $fSYYZ.Observable)((sub)=>{
            notifiers.push($fdef0f46430f2429$var$notify(project(value), sub, onReady));
        });
};
const $fdef0f46430f2429$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $5iPTs.mergeMap)($fdef0f46430f2429$var$mapper(project), concurrent);

});


parcelRegister("8TU0b", function(module, exports) {
$parcel$export(module.exports, "uploadinator", () => $bd7182783feead36$export$94ce0f3fcf999415);

var $ihdZY = parcelRequire("ihdZY");
const $bd7182783feead36$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $ihdZY.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("e4kE8", function(module, exports) {
$parcel$export(module.exports, "processinator", () => $eeb88ef2859ae93b$export$2f21790600302ed);

var $ezyFF = parcelRequire("ezyFF");

var $6xf0A = parcelRequire("6xf0A");
const $eeb88ef2859ae93b$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $ezyFF.bufferCount)(options.batchSize)).pipe((0, $6xf0A.concatMap)(process));
};

});

parcelRegister("dwdYm", function(module, exports) {
$parcel$export(module.exports, "from", () => $9d791a2b1b0ea271$export$6788812c4e6611e6, (v) => $9d791a2b1b0ea271$export$6788812c4e6611e6 = v);
var $9d791a2b1b0ea271$export$6788812c4e6611e6;
"use strict";

var $doqIY = parcelRequire("doqIY");
$9d791a2b1b0ea271$export$6788812c4e6611e6 = $doqIY.FromObservable.create;

});
parcelRegister("doqIY", function(module, exports) {
"use strict";
var $9c023f258ce07058$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5G96M = parcelRequire("5G96M");

var $aLjgb = parcelRequire("aLjgb");

var $cBWuO = parcelRequire("cBWuO");

var $k6qiL = parcelRequire("k6qiL");

var $gthPZ = parcelRequire("gthPZ");

var $iLZ0l = parcelRequire("iLZ0l");

var $aQTsu = parcelRequire("aQTsu");

var $7lPC2 = parcelRequire("7lPC2");

var $fSYYZ = parcelRequire("fSYYZ");

var $auaKp = parcelRequire("auaKp");

var $bGiX7 = parcelRequire("bGiX7");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $9c023f258ce07058$var$FromObservable = function(_super) {
    $9c023f258ce07058$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$bGiX7.observable] === 'function') {
                if (ish instanceof $fSYYZ.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($5G96M.isArray(ish)) return new $iLZ0l.ArrayObservable(ish, scheduler);
            else if ($cBWuO.isPromise(ish)) return new $k6qiL.PromiseObservable(ish, scheduler);
            else if (typeof ish[$7lPC2.iterator] === 'function' || typeof ish === 'string') return new $gthPZ.IteratorObservable(ish, scheduler);
            else if ($aLjgb.isArrayLike(ish)) return new $aQTsu.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$bGiX7.observable]().subscribe(subscriber);
        else return ish[$bGiX7.observable]().subscribe(new $auaKp.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($fSYYZ.Observable);
module.exports.FromObservable = $9c023f258ce07058$var$FromObservable;

});
parcelRegister("gthPZ", function(module, exports) {
"use strict";
var $bfdd30edd9cd3e83$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9Cdpe = parcelRequire("9Cdpe");

var $fSYYZ = parcelRequire("fSYYZ");

var $7lPC2 = parcelRequire("7lPC2");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $bfdd30edd9cd3e83$var$IteratorObservable = function(_super) {
    $bfdd30edd9cd3e83$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error('iterator cannot be null.');
        this.iterator = $bfdd30edd9cd3e83$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === 'function') iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($fSYYZ.Observable);
module.exports.IteratorObservable = $bfdd30edd9cd3e83$var$IteratorObservable;
var $bfdd30edd9cd3e83$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$7lPC2.iterator] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $bfdd30edd9cd3e83$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $bfdd30edd9cd3e83$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$7lPC2.iterator] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $bfdd30edd9cd3e83$var$getIterator(obj) {
    var i = obj[$7lPC2.iterator];
    if (!i && typeof obj === 'string') return new $bfdd30edd9cd3e83$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $bfdd30edd9cd3e83$var$ArrayIterator(obj);
    if (!i) throw new TypeError('object is not iterable');
    return obj[$7lPC2.iterator]();
}
var $bfdd30edd9cd3e83$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $bfdd30edd9cd3e83$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$bfdd30edd9cd3e83$var$numberIsFinite(len)) return len;
    len = $bfdd30edd9cd3e83$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $bfdd30edd9cd3e83$var$maxSafeInteger) return $bfdd30edd9cd3e83$var$maxSafeInteger;
    return len;
}
function $bfdd30edd9cd3e83$var$numberIsFinite(value) {
    return typeof value === 'number' && $9Cdpe.root.isFinite(value);
}
function $bfdd30edd9cd3e83$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}

});

parcelRegister("iLZ0l", function(module, exports) {
"use strict";
var $daabf00920b813c0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $35Srn = parcelRequire("35Srn");

var $fyVhl = parcelRequire("fyVhl");

var $bOxHY = parcelRequire("bOxHY");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $daabf00920b813c0$var$ArrayObservable = function(_super) {
    $daabf00920b813c0$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($bOxHY.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $35Srn.ScalarObservable(array[0], scheduler);
        else return new $fyVhl.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($fSYYZ.Observable);
module.exports.ArrayObservable = $daabf00920b813c0$var$ArrayObservable;

});
parcelRegister("35Srn", function(module, exports) {
"use strict";
var $240c1182b14077b2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $240c1182b14077b2$var$ScalarObservable = function(_super) {
    $240c1182b14077b2$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($fSYYZ.Observable);
module.exports.ScalarObservable = $240c1182b14077b2$var$ScalarObservable;

});

parcelRegister("fyVhl", function(module, exports) {
"use strict";
var $b546765a90617801$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $b546765a90617801$var$EmptyObservable = function(_super) {
    $b546765a90617801$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($fSYYZ.Observable);
module.exports.EmptyObservable = $b546765a90617801$var$EmptyObservable;

});

parcelRegister("bOxHY", function(module, exports) {
$parcel$export(module.exports, "isScheduler", () => $899e82fa8b669c16$export$187e35932e88c15c, (v) => $899e82fa8b669c16$export$187e35932e88c15c = v);
var $899e82fa8b669c16$export$187e35932e88c15c;
"use strict";
function $899e82fa8b669c16$var$isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
$899e82fa8b669c16$export$187e35932e88c15c = $899e82fa8b669c16$var$isScheduler;

});


parcelRegister("aQTsu", function(module, exports) {
"use strict";
var $7e69c7a181a6451a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $35Srn = parcelRequire("35Srn");

var $fyVhl = parcelRequire("fyVhl");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $7e69c7a181a6451a$var$ArrayLikeObservable = function(_super) {
    $7e69c7a181a6451a$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $fyVhl.EmptyObservable();
        else if (length === 1) return new $35Srn.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($fSYYZ.Observable);
module.exports.ArrayLikeObservable = $7e69c7a181a6451a$var$ArrayLikeObservable;

});

parcelRegister("auaKp", function(module, exports) {
"use strict";
var $7a250af82baf9ffb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $hGDIR = parcelRequire("hGDIR");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $7a250af82baf9ffb$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $7a250af82baf9ffb$var$ObserveOnOperator(scheduler, delay));
    };
}
module.exports.observeOn = $7a250af82baf9ffb$var$observeOn;
var $7a250af82baf9ffb$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7a250af82baf9ffb$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
module.exports.ObserveOnOperator = $7a250af82baf9ffb$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7a250af82baf9ffb$var$ObserveOnSubscriber = function(_super) {
    $7a250af82baf9ffb$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $7a250af82baf9ffb$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($hGDIR.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($hGDIR.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($hGDIR.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($8qR8S.Subscriber);
module.exports.ObserveOnSubscriber = $7a250af82baf9ffb$var$ObserveOnSubscriber;
var $7a250af82baf9ffb$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
module.exports.ObserveOnMessage = $7a250af82baf9ffb$var$ObserveOnMessage;

});
parcelRegister("hGDIR", function(module, exports) {
$parcel$export(module.exports, "Notification", () => $ce052bf6ede3dbde$export$14834abbfce3b8cd, (v) => $ce052bf6ede3dbde$export$14834abbfce3b8cd = v);
var $ce052bf6ede3dbde$export$14834abbfce3b8cd;
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $ce052bf6ede3dbde$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return $fSYYZ.Observable.of(this.value);
            case 'E':
                return $fSYYZ.Observable.throw(this.error);
            case 'C':
                return $fSYYZ.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== 'undefined') return new Notification('N', value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}();
$ce052bf6ede3dbde$export$14834abbfce3b8cd = $ce052bf6ede3dbde$var$Notification;

});





parcelRegister("eRu6S", function(module, exports) {
$parcel$export(module.exports, "createHasher", () => $bba3742e11441d24$export$14b114effbc08b6b);
parcelRequire("7F07j");
var $kD2pI = parcelRequire("kD2pI");
let $bba3742e11441d24$var$hasher = null;
let $bba3742e11441d24$var$sha256Hasher = null;
const $bba3742e11441d24$export$d9c9d11cd648a505 = ()=>{
    $bba3742e11441d24$var$hasher = null;
    $bba3742e11441d24$var$sha256Hasher = null;
};


const $bba3742e11441d24$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $kD2pI.ChunkHashAlgorithm).Sha256) {
            if (!$bba3742e11441d24$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("6qJ4Q"));
                $bba3742e11441d24$var$sha256Hasher = new SimpleHasher();
            }
            return $bba3742e11441d24$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("baT4d"));
    $bba3742e11441d24$var$hasher = new SimpleHasher();
    return $bba3742e11441d24$var$hasher;
};

});
parcelRegister("6qJ4Q", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("fIr61").then(()=>parcelRequire('9Wgfo'));

});

parcelRegister("baT4d", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("dpapA"),
    $j9MRt("1l0WT")
]).then(()=>parcelRequire('3uKLH'));

});


parcelRegister("8lDv8", function(module, exports) {
$parcel$export(module.exports, "UploaderError", () => $8b6571fcf64c6c2f$export$515240c3f059c807);

var $cMcHx = parcelRequire("cMcHx");
class $8b6571fcf64c6c2f$export$515240c3f059c807 extends (0, $cMcHx.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $8b6571fcf64c6c2f$export$80ee180172bc336(err) {
    return err instanceof $8b6571fcf64c6c2f$export$515240c3f059c807;
}

});

parcelRegister("1madi", function(module, exports) {
$parcel$export(module.exports, "fileSizeError", () => $2e14324cde439101$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $2e14324cde439101$export$71f452e02035c1e2);

var $9lyDh = parcelRequire("9lyDh");

var $e1GLO = parcelRequire("e1GLO");
const $2e14324cde439101$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $2e14324cde439101$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $e1GLO.MAX_UPLOAD_FILE_SIZE)) throw new Error($2e14324cde439101$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $9lyDh.DATA_UNIT).GB) return 5 * (0, $9lyDh.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $9lyDh.DATA_UNIT).GB && fileSize <= 50 * (0, $9lyDh.DATA_UNIT).GB) return 50 * (0, $9lyDh.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $9lyDh.DATA_UNIT).GB && fileSize <= 0.95 * (0, $9lyDh.DATA_UNIT).TB) return 100 * (0, $9lyDh.DATA_UNIT).MB;
    return 210 * (0, $9lyDh.DATA_UNIT).MB;
};

});


parcelRegister("iv4S5", function(module, exports) {
$parcel$export(module.exports, "getFileStreamsCache", () => $a93b8456e39c20a1$export$f2f061938c1e6810);
class $a93b8456e39c20a1$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $a93b8456e39c20a1$var$streamCache;

const $a93b8456e39c20a1$export$f2f061938c1e6810 = ()=>{
    if (!$a93b8456e39c20a1$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("lSQPi")).mediaState;
        $a93b8456e39c20a1$var$streamCache = new $a93b8456e39c20a1$export$4293896e79732236(mediaState.streams);
    }
    return $a93b8456e39c20a1$var$streamCache;
};

});

parcelRegister("hEYLa", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $eJ41X = parcelRequire("eJ41X");
var $cdb54db522557e0d$require$Buffer = $eJ41X.Buffer;
var $cdb54db522557e0d$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $cdb54db522557e0d$var$_byteToHex = [];
for(var $cdb54db522557e0d$var$i = 0; $cdb54db522557e0d$var$i < 256; $cdb54db522557e0d$var$i++)$cdb54db522557e0d$var$_byteToHex[$cdb54db522557e0d$var$i] = ($cdb54db522557e0d$var$i + 0x100).toString(16).substr(1);
function $cdb54db522557e0d$var$unparse(buf, offset) {
    var i = offset || 0, bth = $cdb54db522557e0d$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($cdb54db522557e0d$require$Buffer.isBuffer(uuid)) parsedUuid = $cdb54db522557e0d$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$cdb54db522557e0d$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $cdb54db522557e0d$var$extractVersion(parsedUuid);
    else if ($cdb54db522557e0d$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $cdb54db522557e0d$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("3C79p", function(module, exports) {
$parcel$export(module.exports, "createFileDataloader", () => $9a7e3ef2e8cde0ca$export$ae188fee39529b82);

var $8qoQb = parcelRequire("8qoQb");

var $cul7x = parcelRequire("cul7x");
const $9a7e3ef2e8cde0ca$export$b79d95ee17a87a = 100;
const $9a7e3ef2e8cde0ca$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $9a7e3ef2e8cde0ca$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $9a7e3ef2e8cde0ca$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $9a7e3ef2e8cde0ca$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $9a7e3ef2e8cde0ca$var$makeCacheKey(id, collection);
        if ($9a7e3ef2e8cde0ca$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($9a7e3ef2e8cde0ca$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $9a7e3ef2e8cde0ca$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $9a7e3ef2e8cde0ca$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $cul7x.getRandomTelemetryId)(),
                spanId: (0, $cul7x.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $9a7e3ef2e8cde0ca$export$71cd2e8f8162d47b(keys, items);
    };
}
function $9a7e3ef2e8cde0ca$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($8qoQb)))($9a7e3ef2e8cde0ca$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $9a7e3ef2e8cde0ca$export$b79d95ee17a87a
    });
}

});
parcelRegister("8qoQb", function(module, exports) {

var $6nQJh = parcelRequire("6nQJh");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $62240549037249ad$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $62240549037249ad$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $62240549037249ad$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $62240549037249ad$var$getValidCacheKeyFn(options);
        this._cacheMap = $62240549037249ad$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $62240549037249ad$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $62240549037249ad$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$62240549037249ad$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $62240549037249ad$var$enqueuePostPromiseJob = typeof $6nQJh === 'object' && typeof $6nQJh.nextTick === 'function' ? function(fn) {
    if (!$62240549037249ad$var$resolvedPromise) $62240549037249ad$var$resolvedPromise = Promise.resolve();
    $62240549037249ad$var$resolvedPromise.then(function() {
        $6nQJh.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $62240549037249ad$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $62240549037249ad$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $62240549037249ad$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $62240549037249ad$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $62240549037249ad$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $62240549037249ad$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $62240549037249ad$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$62240549037249ad$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $62240549037249ad$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $62240549037249ad$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $62240549037249ad$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $62240549037249ad$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $62240549037249ad$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $62240549037249ad$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $62240549037249ad$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $62240549037249ad$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $62240549037249ad$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $62240549037249ad$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $62240549037249ad$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $62240549037249ad$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $62240549037249ad$var$DataLoader;

});


parcelRegister("kvTXU", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $61adccf02fa23487$export$ac3214931ffd82af);

var $o96nQ = parcelRequire("o96nQ");
const $61adccf02fa23487$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $o96nQ.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("o96nQ", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $3e1c5a28a934566b$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("iutGU")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("iutGU")).isVideoMimeTypeSupportedByBrowser);

var $3fGPx = parcelRequire("3fGPx");

var $iutGU = parcelRequire("iutGU");

var $i5NWw = parcelRequire("i5NWw");
const $3e1c5a28a934566b$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $3fGPx.isArchive)(mimeType)) return 'archive';
    if ((0, $iutGU.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $i5NWw.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $iutGU.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $i5NWw.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $iutGU.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $i5NWw.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $iutGU.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $i5NWw.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("3fGPx", function(module, exports) {
$parcel$export(module.exports, "isArchive", () => $ef3be639587624bb$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $ef3be639587624bb$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("iutGU", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $d9737b30fa44aa6d$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $d9737b30fa44aa6d$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $d9737b30fa44aa6d$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $d9737b30fa44aa6d$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $d9737b30fa44aa6d$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $d9737b30fa44aa6d$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $d9737b30fa44aa6d$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $d9737b30fa44aa6d$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $d9737b30fa44aa6d$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $d9737b30fa44aa6d$export$55ca6cdaf6093034 = (mimeType)=>$d9737b30fa44aa6d$export$74325e3c843a9555(mimeType) || $d9737b30fa44aa6d$export$c021f2623a75015f(mimeType) || $d9737b30fa44aa6d$export$ff36075ea755a717(mimeType) || $d9737b30fa44aa6d$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("i5NWw", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $2611cb0f73521080$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $2611cb0f73521080$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $2611cb0f73521080$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $2611cb0f73521080$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $2611cb0f73521080$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $2611cb0f73521080$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $2611cb0f73521080$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $2611cb0f73521080$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $2611cb0f73521080$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $2611cb0f73521080$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $2611cb0f73521080$export$548d9148a80556a3 = (mimeType)=>$2611cb0f73521080$export$e9a065a80f76311e(mimeType) || $2611cb0f73521080$export$86baad7a89d908e9(mimeType) || $2611cb0f73521080$export$8cba23825d020bbb(mimeType) || $2611cb0f73521080$export$9c2b4de5fdca2ce3(mimeType) || $2611cb0f73521080$export$94e1479e01d2af53(mimeType);

});



parcelRegister("9DbYH", function(module, exports) {
$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $d1d064619329f8b8$export$89097c0ec1e0dee1);

var $57mjO = parcelRequire("57mjO");
const $d1d064619329f8b8$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $57mjO.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("a2gNT", function(module, exports) {
$parcel$export(module.exports, "convertBase64ToBlob", () => $77a6a2e65e9a4e19$export$ed17558b11b88056);
const $77a6a2e65e9a4e19$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("hdLcR", function(module, exports) {
$parcel$export(module.exports, "fromObservable", () => $a01613f41cab8b61$export$4b2432e2d8723823);

var $4bshn = parcelRequire("4bshn");
function $a01613f41cab8b61$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $a01613f41cab8b61$export$8659d1f07d151381(item) {
    return $a01613f41cab8b61$export$4b2432e2d8723823((0, $4bshn.createMediaSubject)(item));
}

});
parcelRegister("4bshn", function(module, exports) {
$parcel$export(module.exports, "createMediaSubject", () => $8b7e83856f4707cf$export$bc76d51553fa5e35);

var $1PAG0 = parcelRequire("1PAG0");
function $8b7e83856f4707cf$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $1PAG0.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});
parcelRegister("1PAG0", function(module, exports) {
"use strict";
var $1557010d2c691703$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $iE1oT = parcelRequire("iE1oT");

var $aBkDT = parcelRequire("aBkDT");

var $auaKp = parcelRequire("auaKp");

var $eDWrK = parcelRequire("eDWrK");

var $iXHCg = parcelRequire("iXHCg");
/**
 * @class ReplaySubject<T>
 */ var $1557010d2c691703$var$ReplaySubject = function(_super) {
    $1557010d2c691703$var$__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function(value) {
        var now = this._getNow();
        this._events.push(new $1557010d2c691703$var$ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function(subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) throw new $eDWrK.ObjectUnsubscribedError();
        else if (this.hasError) subscription = $aBkDT.Subscription.EMPTY;
        else if (this.isStopped) subscription = $aBkDT.Subscription.EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new $iXHCg.SubjectSubscription(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new $auaKp.ObserveOnSubscriber(subscriber, scheduler));
        var len = _events.length;
        for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || $iE1oT.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}($bTlA1.Subject);
module.exports.ReplaySubject = $1557010d2c691703$var$ReplaySubject;
var $1557010d2c691703$var$ReplayEvent = function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

});
parcelRegister("bTlA1", function(module, exports) {
"use strict";
var $8a8592171a22de44$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $8qR8S = parcelRequire("8qR8S");

var $aBkDT = parcelRequire("aBkDT");

var $eDWrK = parcelRequire("eDWrK");

var $iXHCg = parcelRequire("iXHCg");

var $1zOpv = parcelRequire("1zOpv");
/**
 * @class SubjectSubscriber<T>
 */ var $8a8592171a22de44$var$SubjectSubscriber = function(_super) {
    $8a8592171a22de44$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($8qR8S.Subscriber);
module.exports.SubjectSubscriber = $8a8592171a22de44$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $8a8592171a22de44$var$Subject = function(_super) {
    $8a8592171a22de44$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$1zOpv.rxSubscriber] = function() {
        return new $8a8592171a22de44$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $8a8592171a22de44$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $eDWrK.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $eDWrK.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $eDWrK.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $eDWrK.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $eDWrK.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $aBkDT.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $aBkDT.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $iXHCg.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $fSYYZ.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $8a8592171a22de44$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($fSYYZ.Observable);
module.exports.Subject = $8a8592171a22de44$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $8a8592171a22de44$var$AnonymousSubject = function(_super) {
    $8a8592171a22de44$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $aBkDT.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($8a8592171a22de44$var$Subject);
module.exports.AnonymousSubject = $8a8592171a22de44$var$AnonymousSubject;

});
parcelRegister("eDWrK", function(module, exports) {
"use strict";
var $02c04a8201c88c27$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $02c04a8201c88c27$var$ObjectUnsubscribedError = function(_super) {
    $02c04a8201c88c27$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
module.exports.ObjectUnsubscribedError = $02c04a8201c88c27$var$ObjectUnsubscribedError;

});

parcelRegister("iXHCg", function(module, exports) {
"use strict";
var $dcdf91f110d7f4cc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aBkDT = parcelRequire("aBkDT");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $dcdf91f110d7f4cc$var$SubjectSubscription = function(_super) {
    $dcdf91f110d7f4cc$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($aBkDT.Subscription);
module.exports.SubjectSubscription = $dcdf91f110d7f4cc$var$SubjectSubscription;

});


parcelRegister("iE1oT", function(module, exports) {
$parcel$export(module.exports, "queue", () => $d92d0c8562f73489$export$4f7fa46ff53e516f, (v) => $d92d0c8562f73489$export$4f7fa46ff53e516f = v);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */ var $d92d0c8562f73489$export$4f7fa46ff53e516f;
"use strict";

var $8Oeyc = parcelRequire("8Oeyc");

var $e5jzu = parcelRequire("e5jzu");
$d92d0c8562f73489$export$4f7fa46ff53e516f = new $e5jzu.QueueScheduler($8Oeyc.QueueAction);

});
parcelRegister("8Oeyc", function(module, exports) {
"use strict";
var $669e47a9b370cdbf$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ercxm = parcelRequire("ercxm");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $669e47a9b370cdbf$var$QueueAction = function(_super) {
    $669e47a9b370cdbf$var$__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}($ercxm.AsyncAction);
module.exports.QueueAction = $669e47a9b370cdbf$var$QueueAction;

});
parcelRegister("ercxm", function(module, exports) {
"use strict";
var $a82d4fe1f2124ea8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9Cdpe = parcelRequire("9Cdpe");

var $7KtUF = parcelRequire("7KtUF");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a82d4fe1f2124ea8$var$AsyncAction = function(_super) {
    $a82d4fe1f2124ea8$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $9Cdpe.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $9Cdpe.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($7KtUF.Action);
module.exports.AsyncAction = $a82d4fe1f2124ea8$var$AsyncAction;

});
parcelRegister("7KtUF", function(module, exports) {
"use strict";
var $5a440861304967a3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aBkDT = parcelRequire("aBkDT");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $5a440861304967a3$var$Action = function(_super) {
    $5a440861304967a3$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($aBkDT.Subscription);
module.exports.Action = $5a440861304967a3$var$Action;

});



parcelRegister("e5jzu", function(module, exports) {
"use strict";
var $a410b6cba92d4116$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $leugC = parcelRequire("leugC");
var $a410b6cba92d4116$var$QueueScheduler = function(_super) {
    $a410b6cba92d4116$var$__extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}($leugC.AsyncScheduler);
module.exports.QueueScheduler = $a410b6cba92d4116$var$QueueScheduler;

});
parcelRegister("leugC", function(module, exports) {
"use strict";
var $f752623287f6f4ef$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lI7Pd = parcelRequire("lI7Pd");
var $f752623287f6f4ef$var$AsyncScheduler = function(_super) {
    $f752623287f6f4ef$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($lI7Pd.Scheduler);
module.exports.AsyncScheduler = $f752623287f6f4ef$var$AsyncScheduler;

});
parcelRegister("lI7Pd", function(module, exports) {
$parcel$export(module.exports, "Scheduler", () => $fce3c6e73c3052cc$export$d3e54bb8584cda7c, (v) => $fce3c6e73c3052cc$export$d3e54bb8584cda7c = v);
var $fce3c6e73c3052cc$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $fce3c6e73c3052cc$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$fce3c6e73c3052cc$export$d3e54bb8584cda7c = $fce3c6e73c3052cc$var$Scheduler;

});







parcelRegister("bYXwd", function(module, exports) {
$parcel$export(module.exports, "toPromise", () => $2b87000779a476d6$export$4dbaaf6c79705e6c);

var $aBkDT = parcelRequire("aBkDT");
const $2b87000779a476d6$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aBkDT.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("653NU", function(module, exports) {
$parcel$export(module.exports, "getDimensionsFromBlob", () => $20cd976865a6a8db$export$71797c284d89a3e1);

var $d1Lbt = parcelRequire("d1Lbt");

var $SvqUz = parcelRequire("SvqUz");
const $20cd976865a6a8db$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $d1Lbt.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $SvqUz.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("d1Lbt", function(module, exports) {
$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $dee7c6c697556d30$export$a1c3205f28a20414);
const $dee7c6c697556d30$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("SvqUz", function(module, exports) {
$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $16b50abcf524feb4$export$62aabd5ff85d0451);
const $16b50abcf524feb4$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("grbQp", function(module, exports) {
$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $792cdea96a46a42c$export$2ccdd6f9a9eba6a);

var $iutGU = parcelRequire("iutGU");
var $i5NWw = parcelRequire("i5NWw");

var $SvqUz = parcelRequire("SvqUz");
async function $792cdea96a46a42c$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $iutGU.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $i5NWw.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $SvqUz.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("k8hLB", function(module, exports) {
$parcel$export(module.exports, "PollingFunction", () => $9804440138a63cc8$export$4c54d536f8e37dc2);

var $hFwrS = parcelRequire("hFwrS");
const $9804440138a63cc8$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $9804440138a63cc8$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$9804440138a63cc8$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $hFwrS.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $hFwrS.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("hFwrS", function(module, exports) {
$parcel$export(module.exports, "PollingError", () => $918db12a51a79568$export$c3748c310e92340a);

var $cMcHx = parcelRequire("cMcHx");
class $918db12a51a79568$export$c3748c310e92340a extends (0, $cMcHx.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $918db12a51a79568$export$541e3e52eea6fece(err) {
    return err instanceof $918db12a51a79568$export$c3748c310e92340a;
}

});


parcelRegister("7jtRJ", function(module, exports) {
$parcel$export(module.exports, "isEmptyFile", () => $735f62beb202ee73$export$728192ce8dd94659);
const $735f62beb202ee73$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $735f62beb202ee73$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $735f62beb202ee73$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("9XIuz", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => (parcelRequire("2qxba")).mediaStore);

var $2qxba = parcelRequire("2qxba");

});
parcelRegister("2qxba", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => $8b8f5b235071a672$export$5785580dea19518d);

var $9hQbI = parcelRequire("9hQbI");

var $j8rWw = parcelRequire("j8rWw");

var $ayvtO = parcelRequire("ayvtO");
const $8b8f5b235071a672$var$mediaStoreWithoutDevtools = (0, $ayvtO.createStore)()((0, $9hQbI.subscribeWithSelector)((0, $j8rWw.immer)(()=>({
        files: {}
    }))));
const $8b8f5b235071a672$var$mediaStoreWithDevtools = (0, $ayvtO.createStore)()((0, $9hQbI.devtools)((0, $9hQbI.subscribeWithSelector)((0, $j8rWw.immer)(()=>({
        files: {}
    })))));
const $8b8f5b235071a672$export$5785580dea19518d = $8b8f5b235071a672$var$mediaStoreWithoutDevtools;
const $8b8f5b235071a672$export$503459913a0dc356 = (initialStore)=>{
    return (0, $ayvtO.createStore)()((0, $9hQbI.subscribeWithSelector)((0, $j8rWw.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("9hQbI", function(module, exports) {
$parcel$export(module.exports, "devtools", () => $6c2e2f03033de7f1$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $6c2e2f03033de7f1$export$5c593627aef9f076);
var $6c2e2f03033de7f1$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/middleware.mjs"
});
const $6c2e2f03033de7f1$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $6c2e2f03033de7f1$export$4feba8a1bc8e9afd = $6c2e2f03033de7f1$var$reduxImpl;
const $6c2e2f03033de7f1$var$trackedConnections = /* @__PURE__ */ new Map();
const $6c2e2f03033de7f1$var$getTrackedConnectionState = (name)=>{
    const api = $6c2e2f03033de7f1$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $6c2e2f03033de7f1$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $6c2e2f03033de7f1$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $6c2e2f03033de7f1$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $6c2e2f03033de7f1$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($6c2e2f03033de7f1$import_meta.env ? $6c2e2f03033de7f1$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($6c2e2f03033de7f1$import_meta.env ? $6c2e2f03033de7f1$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $6c2e2f03033de7f1$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$6c2e2f03033de7f1$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($6c2e2f03033de7f1$import_meta.env ? $6c2e2f03033de7f1$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $6c2e2f03033de7f1$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($6c2e2f03033de7f1$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($6c2e2f03033de7f1$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $6c2e2f03033de7f1$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($6c2e2f03033de7f1$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $6c2e2f03033de7f1$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $6c2e2f03033de7f1$export$6922d3b3a607469e = $6c2e2f03033de7f1$var$devtoolsImpl;
const $6c2e2f03033de7f1$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $6c2e2f03033de7f1$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $6c2e2f03033de7f1$export$5c593627aef9f076 = $6c2e2f03033de7f1$var$subscribeWithSelectorImpl;
const $6c2e2f03033de7f1$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $6c2e2f03033de7f1$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $6c2e2f03033de7f1$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $6c2e2f03033de7f1$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $6c2e2f03033de7f1$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $6c2e2f03033de7f1$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $6c2e2f03033de7f1$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $6c2e2f03033de7f1$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $6c2e2f03033de7f1$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $6c2e2f03033de7f1$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $6c2e2f03033de7f1$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $6c2e2f03033de7f1$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($6c2e2f03033de7f1$import_meta.env ? $6c2e2f03033de7f1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $6c2e2f03033de7f1$var$oldImpl(config, baseOptions);
    }
    return $6c2e2f03033de7f1$var$newImpl(config, baseOptions);
};
const $6c2e2f03033de7f1$export$9a6132153fba2e0 = $6c2e2f03033de7f1$var$persistImpl;

});

parcelRegister("j8rWw", function(module, exports) {
$parcel$export(module.exports, "immer", () => $0398546572f0cf39$export$428de7ec69ac95c);

var $lhSyv = parcelRequire("lhSyv");
const $0398546572f0cf39$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $lhSyv.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $0398546572f0cf39$export$428de7ec69ac95c = $0398546572f0cf39$var$immerImpl;

});
parcelRegister("lhSyv", function(module, exports) {
$parcel$export(module.exports, "produce", () => $f7f581165c89e498$export$b46cabe22e78bc00);
// src/utils/env.ts
var $f7f581165c89e498$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $f7f581165c89e498$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $f7f581165c89e498$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $f7f581165c89e498$var$errors = [];
function $f7f581165c89e498$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $f7f581165c89e498$var$O = Object;
var $f7f581165c89e498$var$getPrototypeOf = $f7f581165c89e498$var$O.getPrototypeOf;
var $f7f581165c89e498$var$CONSTRUCTOR = "constructor";
var $f7f581165c89e498$var$PROTOTYPE = "prototype";
var $f7f581165c89e498$var$CONFIGURABLE = "configurable";
var $f7f581165c89e498$var$ENUMERABLE = "enumerable";
var $f7f581165c89e498$var$WRITABLE = "writable";
var $f7f581165c89e498$var$VALUE = "value";
var $f7f581165c89e498$export$541ac630993a4c84 = (value)=>!!value && !!value[$f7f581165c89e498$var$DRAFT_STATE];
function $f7f581165c89e498$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $f7f581165c89e498$var$isPlainObject(value) || $f7f581165c89e498$var$isArray(value) || !!value[$f7f581165c89e498$export$6ee2082928bcb0ee] || !!value[$f7f581165c89e498$var$CONSTRUCTOR]?.[$f7f581165c89e498$export$6ee2082928bcb0ee] || $f7f581165c89e498$var$isMap(value) || $f7f581165c89e498$var$isSet(value);
}
var $f7f581165c89e498$var$objectCtorString = $f7f581165c89e498$var$O[$f7f581165c89e498$var$PROTOTYPE][$f7f581165c89e498$var$CONSTRUCTOR].toString();
var $f7f581165c89e498$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $f7f581165c89e498$var$isPlainObject(value) {
    if (!value || !$f7f581165c89e498$var$isObjectish(value)) return false;
    const proto = $f7f581165c89e498$var$getPrototypeOf(value);
    if (proto === null || proto === $f7f581165c89e498$var$O[$f7f581165c89e498$var$PROTOTYPE]) return true;
    const Ctor = $f7f581165c89e498$var$O.hasOwnProperty.call(proto, $f7f581165c89e498$var$CONSTRUCTOR) && proto[$f7f581165c89e498$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$f7f581165c89e498$var$isFunction(Ctor)) return false;
    let ctorString = $f7f581165c89e498$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $f7f581165c89e498$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $f7f581165c89e498$var$objectCtorString;
}
function $f7f581165c89e498$export$22e8af3f75a010e3(value) {
    if (!$f7f581165c89e498$export$541ac630993a4c84(value)) $f7f581165c89e498$var$die(15, value);
    return value[$f7f581165c89e498$var$DRAFT_STATE].base_;
}
function $f7f581165c89e498$var$each(obj, iter, strict = true) {
    if ($f7f581165c89e498$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $f7f581165c89e498$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $f7f581165c89e498$var$getArchtype(thing) {
    const state = thing[$f7f581165c89e498$var$DRAFT_STATE];
    return state ? state.type_ : $f7f581165c89e498$var$isArray(thing) ? 1 /* Array */  : $f7f581165c89e498$var$isMap(thing) ? 2 /* Map */  : $f7f581165c89e498$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $f7f581165c89e498$var$has = (thing, prop, type = $f7f581165c89e498$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $f7f581165c89e498$var$O[$f7f581165c89e498$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $f7f581165c89e498$var$get = (thing, prop, type = $f7f581165c89e498$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $f7f581165c89e498$var$set = (thing, propOrOldValue, value, type = $f7f581165c89e498$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $f7f581165c89e498$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $f7f581165c89e498$var$isArray = Array.isArray;
var $f7f581165c89e498$var$isMap = (target)=>target instanceof Map;
var $f7f581165c89e498$var$isSet = (target)=>target instanceof Set;
var $f7f581165c89e498$var$isObjectish = (target)=>typeof target === "object";
var $f7f581165c89e498$var$isFunction = (target)=>typeof target === "function";
var $f7f581165c89e498$var$isBoolean = (target)=>typeof target === "boolean";
function $f7f581165c89e498$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $f7f581165c89e498$var$getProxyDraft = (value)=>{
    if (!$f7f581165c89e498$var$isObjectish(value)) return null;
    return value?.[$f7f581165c89e498$var$DRAFT_STATE];
};
var $f7f581165c89e498$var$latest = (state)=>state.copy_ || state.base_;
var $f7f581165c89e498$var$getValue = (value)=>{
    const proxyDraft = $f7f581165c89e498$var$getProxyDraft(value);
    return proxyDraft ? proxyDraft.copy_ ?? proxyDraft.base_ : value;
};
var $f7f581165c89e498$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $f7f581165c89e498$var$shallowCopy(base, strict) {
    if ($f7f581165c89e498$var$isMap(base)) return new Map(base);
    if ($f7f581165c89e498$var$isSet(base)) return new Set(base);
    if ($f7f581165c89e498$var$isArray(base)) return Array[$f7f581165c89e498$var$PROTOTYPE].slice.call(base);
    const isPlain = $f7f581165c89e498$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $f7f581165c89e498$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$f7f581165c89e498$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$f7f581165c89e498$var$WRITABLE] === false) {
                desc[$f7f581165c89e498$var$WRITABLE] = true;
                desc[$f7f581165c89e498$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$f7f581165c89e498$var$CONFIGURABLE]: true,
                [$f7f581165c89e498$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$f7f581165c89e498$var$ENUMERABLE]: desc[$f7f581165c89e498$var$ENUMERABLE],
                [$f7f581165c89e498$var$VALUE]: base[key]
            };
        }
        return $f7f581165c89e498$var$O.create($f7f581165c89e498$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $f7f581165c89e498$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $f7f581165c89e498$var$O.create(proto);
        return $f7f581165c89e498$var$O.assign(obj, base);
    }
}
function $f7f581165c89e498$export$792f3d81ea979f55(obj, deep = false) {
    if ($f7f581165c89e498$var$isFrozen(obj) || $f7f581165c89e498$export$541ac630993a4c84(obj) || !$f7f581165c89e498$export$16e3aed3edb85946(obj)) return obj;
    if ($f7f581165c89e498$var$getArchtype(obj) > 1) $f7f581165c89e498$var$O.defineProperties(obj, {
        set: $f7f581165c89e498$var$dontMutateMethodOverride,
        add: $f7f581165c89e498$var$dontMutateMethodOverride,
        clear: $f7f581165c89e498$var$dontMutateMethodOverride,
        delete: $f7f581165c89e498$var$dontMutateMethodOverride
    });
    $f7f581165c89e498$var$O.freeze(obj);
    if (deep) $f7f581165c89e498$var$each(obj, (_key, value)=>{
        $f7f581165c89e498$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $f7f581165c89e498$var$dontMutateFrozenCollections() {
    $f7f581165c89e498$var$die(2);
}
var $f7f581165c89e498$var$dontMutateMethodOverride = {
    [$f7f581165c89e498$var$VALUE]: $f7f581165c89e498$var$dontMutateFrozenCollections
};
function $f7f581165c89e498$var$isFrozen(obj) {
    if (obj === null || !$f7f581165c89e498$var$isObjectish(obj)) return true;
    return $f7f581165c89e498$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $f7f581165c89e498$var$PluginMapSet = "MapSet";
var $f7f581165c89e498$var$PluginPatches = "Patches";
var $f7f581165c89e498$var$PluginArrayMethods = "ArrayMethods";
var $f7f581165c89e498$var$plugins = {};
function $f7f581165c89e498$var$getPlugin(pluginKey) {
    const plugin = $f7f581165c89e498$var$plugins[pluginKey];
    if (!plugin) $f7f581165c89e498$var$die(0, pluginKey);
    return plugin;
}
var $f7f581165c89e498$var$isPluginLoaded = (pluginKey)=>!!$f7f581165c89e498$var$plugins[pluginKey];
function $f7f581165c89e498$var$loadPlugin(pluginKey, implementation) {
    if (!$f7f581165c89e498$var$plugins[pluginKey]) $f7f581165c89e498$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $f7f581165c89e498$var$currentScope;
var $f7f581165c89e498$var$getCurrentScope = ()=>$f7f581165c89e498$var$currentScope;
var $f7f581165c89e498$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $f7f581165c89e498$var$isPluginLoaded($f7f581165c89e498$var$PluginMapSet) ? $f7f581165c89e498$var$getPlugin($f7f581165c89e498$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $f7f581165c89e498$var$isPluginLoaded($f7f581165c89e498$var$PluginArrayMethods) ? $f7f581165c89e498$var$getPlugin($f7f581165c89e498$var$PluginArrayMethods) : void 0
    });
function $f7f581165c89e498$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $f7f581165c89e498$var$getPlugin($f7f581165c89e498$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $f7f581165c89e498$var$revokeScope(scope) {
    $f7f581165c89e498$var$leaveScope(scope);
    scope.drafts_.forEach($f7f581165c89e498$var$revokeDraft);
    scope.drafts_ = null;
}
function $f7f581165c89e498$var$leaveScope(scope) {
    if (scope === $f7f581165c89e498$var$currentScope) $f7f581165c89e498$var$currentScope = scope.parent_;
}
var $f7f581165c89e498$var$enterScope = (immer2)=>$f7f581165c89e498$var$currentScope = $f7f581165c89e498$var$createScope($f7f581165c89e498$var$currentScope, immer2);
function $f7f581165c89e498$var$revokeDraft(draft) {
    const state = draft[$f7f581165c89e498$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $f7f581165c89e498$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$f7f581165c89e498$var$DRAFT_STATE].modified_) {
            $f7f581165c89e498$var$revokeScope(scope);
            $f7f581165c89e498$var$die(4);
        }
        if ($f7f581165c89e498$export$16e3aed3edb85946(result)) result = $f7f581165c89e498$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$f7f581165c89e498$var$DRAFT_STATE].base_, result, scope);
    } else result = $f7f581165c89e498$var$finalize(scope, baseDraft);
    $f7f581165c89e498$var$maybeFreeze(scope, result, true);
    $f7f581165c89e498$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $f7f581165c89e498$export$45b790e32b2810ee ? result : void 0;
}
function $f7f581165c89e498$var$finalize(rootScope, value) {
    if ($f7f581165c89e498$var$isFrozen(value)) return value;
    const state = value[$f7f581165c89e498$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $f7f581165c89e498$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$f7f581165c89e498$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $f7f581165c89e498$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $f7f581165c89e498$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $f7f581165c89e498$export$792f3d81ea979f55(value, deep);
}
function $f7f581165c89e498$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $f7f581165c89e498$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $f7f581165c89e498$var$EMPTY_LOCATIONS_RESULT = [];
function $f7f581165c89e498$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $f7f581165c89e498$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $f7f581165c89e498$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $f7f581165c89e498$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $f7f581165c89e498$var$each(parentCopy, (key, value)=>{
            if ($f7f581165c89e498$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $f7f581165c89e498$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$f7f581165c89e498$var$set(parentCopy, location, finalizedValue, parentType);
}
function $f7f581165c89e498$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$f7f581165c89e498$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $f7f581165c89e498$var$getFinalValue(state);
        $f7f581165c89e498$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $f7f581165c89e498$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $f7f581165c89e498$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $f7f581165c89e498$var$markStateFinalized(state);
    }
}
function $f7f581165c89e498$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($f7f581165c89e498$export$541ac630993a4c84(value)) {
        const state = value[$f7f581165c89e498$var$DRAFT_STATE];
        if ($f7f581165c89e498$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $f7f581165c89e498$var$prepareCopy(target);
            const finalizedValue = $f7f581165c89e498$var$getFinalValue(state);
            $f7f581165c89e498$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($f7f581165c89e498$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $f7f581165c89e498$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $f7f581165c89e498$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($f7f581165c89e498$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $f7f581165c89e498$var$handleValue($f7f581165c89e498$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $f7f581165c89e498$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($f7f581165c89e498$export$541ac630993a4c84(target) || handledSet.has(target) || !$f7f581165c89e498$export$16e3aed3edb85946(target) || $f7f581165c89e498$var$isFrozen(target)) return target;
    handledSet.add(target);
    $f7f581165c89e498$var$each(target, (key, value)=>{
        if ($f7f581165c89e498$export$541ac630993a4c84(value)) {
            const state = value[$f7f581165c89e498$var$DRAFT_STATE];
            if ($f7f581165c89e498$var$isSameScope(state, rootScope)) {
                const updatedValue = $f7f581165c89e498$var$getFinalValue(state);
                $f7f581165c89e498$var$set(target, key, updatedValue, target.type_);
                $f7f581165c89e498$var$markStateFinalized(state);
            }
        } else if ($f7f581165c89e498$export$16e3aed3edb85946(value)) $f7f581165c89e498$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $f7f581165c89e498$var$createProxyProxy(base, parent) {
    const baseIsArray = $f7f581165c89e498$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $f7f581165c89e498$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $f7f581165c89e498$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $f7f581165c89e498$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $f7f581165c89e498$var$objectTraps = {
    get (state, prop) {
        if (prop === $f7f581165c89e498$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $f7f581165c89e498$var$latest(state);
        if (!$f7f581165c89e498$var$has(source, prop, state.type_)) return $f7f581165c89e498$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$f7f581165c89e498$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $f7f581165c89e498$var$isArrayIndex(prop)) return value;
        if (value === $f7f581165c89e498$var$peek(state.base_, prop)) {
            $f7f581165c89e498$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $f7f581165c89e498$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $f7f581165c89e498$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($f7f581165c89e498$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $f7f581165c89e498$var$getDescriptorFromProto($f7f581165c89e498$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $f7f581165c89e498$var$peek($f7f581165c89e498$var$latest(state), prop);
            const currentState = current2?.[$f7f581165c89e498$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($f7f581165c89e498$var$is(value, current2) && (value !== void 0 || $f7f581165c89e498$var$has(state.base_, prop, state.type_))) return true;
            $f7f581165c89e498$var$prepareCopy(state);
            $f7f581165c89e498$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $f7f581165c89e498$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $f7f581165c89e498$var$prepareCopy(state);
        if ($f7f581165c89e498$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $f7f581165c89e498$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $f7f581165c89e498$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$f7f581165c89e498$var$WRITABLE]: true,
            [$f7f581165c89e498$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$f7f581165c89e498$var$ENUMERABLE]: desc[$f7f581165c89e498$var$ENUMERABLE],
            [$f7f581165c89e498$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $f7f581165c89e498$var$die(11);
    },
    getPrototypeOf (state) {
        return $f7f581165c89e498$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $f7f581165c89e498$var$die(12);
    }
};
var $f7f581165c89e498$var$arrayTraps = {};
for(let key in $f7f581165c89e498$var$objectTraps){
    let fn = $f7f581165c89e498$var$objectTraps[key];
    $f7f581165c89e498$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$f7f581165c89e498$var$arrayTraps.deleteProperty = function(state, prop) {
    return $f7f581165c89e498$var$arrayTraps.set.call(this, state, prop, void 0);
};
$f7f581165c89e498$var$arrayTraps.set = function(state, prop, value) {
    return $f7f581165c89e498$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $f7f581165c89e498$var$peek(draft, prop) {
    const state = draft[$f7f581165c89e498$var$DRAFT_STATE];
    const source = state ? $f7f581165c89e498$var$latest(state) : draft;
    return source[prop];
}
function $f7f581165c89e498$var$readPropFromProto(state, source, prop) {
    const desc = $f7f581165c89e498$var$getDescriptorFromProto(source, prop);
    return desc ? $f7f581165c89e498$var$VALUE in desc ? desc[$f7f581165c89e498$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $f7f581165c89e498$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $f7f581165c89e498$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $f7f581165c89e498$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $f7f581165c89e498$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $f7f581165c89e498$var$markChanged(state.parent_);
    }
}
function $f7f581165c89e498$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $f7f581165c89e498$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $f7f581165c89e498$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($f7f581165c89e498$var$isFunction(base) && !$f7f581165c89e498$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$f7f581165c89e498$var$isFunction(recipe)) $f7f581165c89e498$var$die(6);
            if (patchListener !== void 0 && !$f7f581165c89e498$var$isFunction(patchListener)) $f7f581165c89e498$var$die(7);
            let result;
            if ($f7f581165c89e498$export$16e3aed3edb85946(base)) {
                const scope = $f7f581165c89e498$var$enterScope(this);
                const proxy = $f7f581165c89e498$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $f7f581165c89e498$var$revokeScope(scope);
                    else $f7f581165c89e498$var$leaveScope(scope);
                }
                $f7f581165c89e498$var$usePatchesInScope(scope, patchListener);
                return $f7f581165c89e498$var$processResult(result, scope);
            } else if (!base || !$f7f581165c89e498$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $f7f581165c89e498$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $f7f581165c89e498$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $f7f581165c89e498$var$getPlugin($f7f581165c89e498$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $f7f581165c89e498$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($f7f581165c89e498$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($f7f581165c89e498$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($f7f581165c89e498$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($f7f581165c89e498$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$f7f581165c89e498$export$16e3aed3edb85946(base)) $f7f581165c89e498$var$die(8);
        if ($f7f581165c89e498$export$541ac630993a4c84(base)) base = $f7f581165c89e498$export$97aac956da55dae9(base);
        const scope = $f7f581165c89e498$var$enterScope(this);
        const proxy = $f7f581165c89e498$var$createProxy(scope, base, void 0);
        proxy[$f7f581165c89e498$var$DRAFT_STATE].isManual_ = true;
        $f7f581165c89e498$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$f7f581165c89e498$var$DRAFT_STATE];
        if (!state || !state.isManual_) $f7f581165c89e498$var$die(9);
        const { scope_: scope } = state;
        $f7f581165c89e498$var$usePatchesInScope(scope, patchListener);
        return $f7f581165c89e498$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $f7f581165c89e498$var$getPlugin($f7f581165c89e498$var$PluginPatches).applyPatches_;
        if ($f7f581165c89e498$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $f7f581165c89e498$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $f7f581165c89e498$var$isMap(value) ? $f7f581165c89e498$var$getPlugin($f7f581165c89e498$var$PluginMapSet).proxyMap_(value, parent) : $f7f581165c89e498$var$isSet(value) ? $f7f581165c89e498$var$getPlugin($f7f581165c89e498$var$PluginMapSet).proxySet_(value, parent) : $f7f581165c89e498$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $f7f581165c89e498$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $f7f581165c89e498$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $f7f581165c89e498$export$97aac956da55dae9(value) {
    if (!$f7f581165c89e498$export$541ac630993a4c84(value)) $f7f581165c89e498$var$die(10, value);
    return $f7f581165c89e498$var$currentImpl(value);
}
function $f7f581165c89e498$var$currentImpl(value) {
    if (!$f7f581165c89e498$export$16e3aed3edb85946(value) || $f7f581165c89e498$var$isFrozen(value)) return value;
    const state = value[$f7f581165c89e498$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $f7f581165c89e498$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $f7f581165c89e498$var$shallowCopy(value, true);
    $f7f581165c89e498$var$each(copy, (key, childValue)=>{
        $f7f581165c89e498$var$set(copy, key, $f7f581165c89e498$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $f7f581165c89e498$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $f7f581165c89e498$var$getProxyDraft($f7f581165c89e498$var$get(parentCopy, state.key_));
            const valueAtKey = $f7f581165c89e498$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $f7f581165c89e498$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $f7f581165c89e498$var$get(current2, key);
            if (!$f7f581165c89e498$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$f7f581165c89e498$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $f7f581165c89e498$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $f7f581165c89e498$var$get(base_, key, type_);
            const value = $f7f581165c89e498$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $f7f581165c89e498$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $f7f581165c89e498$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $f7f581165c89e498$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $f7f581165c89e498$var$CONSTRUCTOR)) $f7f581165c89e498$var$die(errorOffset + 3);
                if ($f7f581165c89e498$var$isFunction(base) && p === $f7f581165c89e498$var$PROTOTYPE) $f7f581165c89e498$var$die(errorOffset + 3);
                base = $f7f581165c89e498$var$get(base, p);
                if (!$f7f581165c89e498$var$isObjectish(base)) $f7f581165c89e498$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $f7f581165c89e498$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $f7f581165c89e498$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $f7f581165c89e498$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$f7f581165c89e498$export$16e3aed3edb85946(obj)) return obj;
        if ($f7f581165c89e498$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($f7f581165c89e498$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($f7f581165c89e498$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($f7f581165c89e498$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($f7f581165c89e498$var$has(obj, $f7f581165c89e498$export$6ee2082928bcb0ee)) cloned[$f7f581165c89e498$export$6ee2082928bcb0ee] = obj[$f7f581165c89e498$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($f7f581165c89e498$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $f7f581165c89e498$var$loadPlugin($f7f581165c89e498$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $f7f581165c89e498$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$f7f581165c89e498$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $f7f581165c89e498$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $f7f581165c89e498$var$latest(this[$f7f581165c89e498$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $f7f581165c89e498$var$latest(this[$f7f581165c89e498$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$f7f581165c89e498$var$latest(state).has(key) || $f7f581165c89e498$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $f7f581165c89e498$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $f7f581165c89e498$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $f7f581165c89e498$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($f7f581165c89e498$var$latest(state).size) {
                prepareMapCopy(state);
                $f7f581165c89e498$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $f7f581165c89e498$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            $f7f581165c89e498$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $f7f581165c89e498$var$latest(state).get(key);
            if (state.finalized_ || !$f7f581165c89e498$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $f7f581165c89e498$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $f7f581165c89e498$var$latest(this[$f7f581165c89e498$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($f7f581165c89e498$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$f7f581165c89e498$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$f7f581165c89e498$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $f7f581165c89e498$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $f7f581165c89e498$var$latest(this[$f7f581165c89e498$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $f7f581165c89e498$var$markChanged(state);
                state.copy_.add(value);
                $f7f581165c89e498$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $f7f581165c89e498$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($f7f581165c89e498$var$latest(state).size) {
                prepareSetCopy(state);
                $f7f581165c89e498$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$f7f581165c89e498$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($f7f581165c89e498$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$f7f581165c89e498$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($f7f581165c89e498$export$16e3aed3edb85946(value)) {
                    const draft = $f7f581165c89e498$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $f7f581165c89e498$var$die(3, JSON.stringify($f7f581165c89e498$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($f7f581165c89e498$var$getValue(value));
            });
        }
    }
    $f7f581165c89e498$var$loadPlugin($f7f581165c89e498$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $f7f581165c89e498$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $f7f581165c89e498$var$prepareCopy(state);
        const result = operation();
        $f7f581165c89e498$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $f7f581165c89e498$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $f7f581165c89e498$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $f7f581165c89e498$var$loadPlugin($f7f581165c89e498$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $f7f581165c89e498$var$immer = new $f7f581165c89e498$export$aaadc6ff0f822719();
var $f7f581165c89e498$export$b46cabe22e78bc00 = $f7f581165c89e498$var$immer.produce;
var $f7f581165c89e498$export$4da66d41c9492c78 = /* @__PURE__ */ $f7f581165c89e498$var$immer.produceWithPatches.bind($f7f581165c89e498$var$immer);
var $f7f581165c89e498$export$573f26f60825c493 = /* @__PURE__ */ $f7f581165c89e498$var$immer.setAutoFreeze.bind($f7f581165c89e498$var$immer);
var $f7f581165c89e498$export$333ce65961cbe047 = /* @__PURE__ */ $f7f581165c89e498$var$immer.setUseStrictShallowCopy.bind($f7f581165c89e498$var$immer);
var $f7f581165c89e498$export$1045b3be3904c489 = /* @__PURE__ */ $f7f581165c89e498$var$immer.setUseStrictIteration.bind($f7f581165c89e498$var$immer);
var $f7f581165c89e498$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $f7f581165c89e498$var$immer.applyPatches.bind($f7f581165c89e498$var$immer);
var $f7f581165c89e498$export$3c3214997190395f = /* @__PURE__ */ $f7f581165c89e498$var$immer.createDraft.bind($f7f581165c89e498$var$immer);
var $f7f581165c89e498$export$c60f5e69c521b528 = /* @__PURE__ */ $f7f581165c89e498$var$immer.finishDraft.bind($f7f581165c89e498$var$immer);
var $f7f581165c89e498$export$c05b21e3257751e5 = (value)=>value;
var $f7f581165c89e498$export$20f911b3f8cf0b74 = (value)=>value;

});


parcelRegister("ayvtO", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $7af57f99ed931c2a$export$f51a9068ac82ea43);
var $7af57f99ed931c2a$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/vanilla.mjs"
});
const $7af57f99ed931c2a$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($7af57f99ed931c2a$import_meta.env ? $7af57f99ed931c2a$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $7af57f99ed931c2a$export$f51a9068ac82ea43 = (createState)=>createState ? $7af57f99ed931c2a$var$createStoreImpl(createState) : $7af57f99ed931c2a$var$createStoreImpl;
var $7af57f99ed931c2a$export$2e2bcd8739ae039 = (createState)=>{
    if (($7af57f99ed931c2a$import_meta.env ? $7af57f99ed931c2a$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $7af57f99ed931c2a$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("i4Us6", function(module, exports) {
$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $c49ad6663939e7b2$export$57945b6819e39246);

var $8qoQb = parcelRequire("8qoQb");

var $cul7x = parcelRequire("cul7x");
const $c49ad6663939e7b2$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $c49ad6663939e7b2$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $cul7x.getRandomTelemetryId)(),
                spanId: (0, $cul7x.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            var _items$find;
            return (_items$find = items.find((item)=>item.id === id && item.collection === collectionName)) === null || _items$find === void 0 ? void 0 : _items$find.error;
        });
    };
}
function $c49ad6663939e7b2$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($8qoQb)))($c49ad6663939e7b2$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $c49ad6663939e7b2$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("fQVty", function(module, exports) {
$parcel$export(module.exports, "StargateClient", () => $97543ccc1c53f21b$export$c66ca190f89caaac);
class $97543ccc1c53f21b$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("fYB20", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("gK4y0").then(()=>parcelRequire('j7T76'));

});



parcelRegister("lbS2q", function(module, exports) {
$parcel$export(module.exports, "MediaClientContext", () => $30a410aa1875999f$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $30a410aa1875999f$export$5bff351c86f56d97);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $c0KQ5 = parcelRequire("c0KQ5");
const $30a410aa1875999f$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(undefined);
const $30a410aa1875999f$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $8P7DW.useMemo)(()=>(0, $c0KQ5.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)($30a410aa1875999f$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});


parcelRegister("cY581", function(module, exports) {
$parcel$export(module.exports, "useFilePreview", () => $d0dfe43a86dc625d$export$4eaebdef02112fe4);

var $8P7DW = parcelRequire("8P7DW");

var $57mjO = parcelRequire("57mjO");
var $cMcHx = parcelRequire("cMcHx");

var $8GsH4 = parcelRequire("8GsH4");
var $9yf1P = parcelRequire("9yf1P");
var $1pgNF = parcelRequire("1pgNF");

var $iutGU = parcelRequire("iutGU");

var $e6Qdr = parcelRequire("e6Qdr");

var $18KuK = parcelRequire("18KuK");

var $1SBlJ = parcelRequire("1SBlJ");

var $fvwkK = parcelRequire("fvwkK");

var $ZT5hB = parcelRequire("ZT5hB");
var $do6DC = parcelRequire("do6DC");
var $gE4mo = parcelRequire("gE4mo");

var $2fm8h = parcelRequire("2fm8h");
var $9GALT = parcelRequire("9GALT");

var $bPwGw = parcelRequire("bPwGw");
// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $d0dfe43a86dc625d$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $d0dfe43a86dc625d$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: // TODO: mediaBlobUrlAttrs can be missing several values contained in the file details. The preview hook is not updating the params in the preview after the file details are available.
allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $1pgNF.useMediaClient)();
    const [status, setStatus] = (0, $8P7DW.useState)('loading');
    const [error, setError] = (0, $8P7DW.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $8P7DW.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $8P7DW.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $8P7DW.useState)('not-resolved');
    const ssrReliabilityRef = (0, $8P7DW.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $18KuK.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $8P7DW.useState)(false);
    (0, $8P7DW.useLayoutEffect)(()=>{
        if (isLoading && (0, $e6Qdr.fg)('platform_close_image_blindspot_2')) return ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $8P7DW.useMemo)(()=>dimensions ? (0, $bPwGw.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $bPwGw.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $gE4mo.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $9GALT.getSSRData)(identifier, resizeMode);
            if (ssrData !== null && ssrData !== void 0 && ssrData.error) ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                server: {
                    status: 'fail',
                    ...ssrData.error
                }
            };
            if (!(ssrData !== null && ssrData !== void 0 && ssrData.dataURI)) {
                // Only attempt SSR preview generation if:
                // 1. We're on the server (ssr='server'), OR
                // 2. We're on the client AND there is SSR data (meaning SSR actually happened)
                // If ssr='client' but there's no SSR data, it means this is a client-side navigation
                // where no SSR occurred, so we should skip SSR preview generation entirely.
                if (ssr === 'server' || ssrData) try {
                    return (0, $ZT5hB.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
                } catch (e) {
                    ssrReliabilityRef.current = {
                        ...ssrReliabilityRef.current,
                        [ssr]: {
                            status: 'fail',
                            ...(0, $1SBlJ.extractErrorInfo)(e, traceContext)
                        }
                    };
                }
            } else {
                const { dimensions: dimensions, dataURI: dataURI, srcSet: srcSet, loading: loading } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data',
                    srcSet: srcSet,
                    lazy: loading === 'lazy'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $8P7DW.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $9yf1P.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $57mjO.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && (fileState === null || fileState === void 0 ? void 0 : fileState.status) !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $8P7DW.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $fvwkK.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $fvwkK.MediaFilePreviewError)('metadata-fetch', (0, $cMcHx.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $8P7DW.useEffect)(()=>{
        var _getSSRData;
        if (!(0, $e6Qdr.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (_getSSRData = (0, $9GALT.getSSRData)(identifier, resizeMode)) === null || _getSSRData === void 0 ? void 0 : _getSSRData.loadPromise;
        if (preview && (0, $ZT5hB.isSSRDataPreview)(preview) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $bPwGw.useCurrentValueRef)(()=>{
        return (0, $ZT5hB.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $8P7DW.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $bPwGw.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $bPwGw.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $8P7DW.useEffect)(()=>{
        const cachedPreview = (0, $gE4mo.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $bPwGw.isBigger)(cachedPreview === null || cachedPreview === void 0 ? void 0 : cachedPreview.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $do6DC.isSupportedLocalPreview)(mediaType) && (0, $iutGU.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $ZT5hB.getAndCacheLocalPreview)(mediaClient, identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current, identifier.collectionName).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $bPwGw.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $ZT5hB.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            // If the preview is not wider than the requested dimensions, we can skip the refetch
            if (preview && (0, $ZT5hB.isSSRPreview)(preview) && !(0, $bPwGw.isWider)(preview.dimensions, dimensions) && (0, $e6Qdr.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $fvwkK.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        identifier.collectionName,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        mediaClient,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus,
        dimensions
    ]);
    //----------------------------------------------------------------
    // Cache ref tracking — prevent blob URL eviction while mounted
    //----------------------------------------------------------------
    (0, $8P7DW.useEffect)(()=>{
        (0, $gE4mo.mediaFilePreviewCache).acquire(identifier.id, resizeMode);
        return ()=>{
            (0, $gE4mo.mediaFilePreviewCache).release(identifier.id, resizeMode);
        };
    }, [
        identifier.id,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $8P7DW.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $ZT5hB.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current = {
            ...ssrReliabilityRef.current,
            client: (0, $1SBlJ.createFailedSSRObject)(failedPreview, traceContext)
        };
        const isSSR = (0, $ZT5hB.isSSRDataPreview)(failedPreview) || (0, $ZT5hB.isSSRClientPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) ssrReliabilityRef.current = {
            server: (0, $1SBlJ.createFailedSSRObject)(failedPreview, traceContext),
            client: (0, $1SBlJ.createFailedSSRObject)(failedPreview, traceContext)
        };
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== (preview === null || preview === void 0 ? void 0 : preview.dataURI)) return;
        const isLocal = (0, $ZT5hB.isLocalPreview)(failedPreview);
        const isRemote = (0, $ZT5hB.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $fvwkK.ImageLoadError)(failedPreview === null || failedPreview === void 0 ? void 0 : failedPreview.source);
            (0, $gE4mo.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview === null || preview === void 0 ? void 0 : preview.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $8P7DW.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $ZT5hB.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                client: {
                    status: 'success'
                }
            };
            /*
          If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
        */ if ((0, $ZT5hB.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
            /*
      Handle 'ssr-server' source which is used when:
      1. ssr='server' is passed to getSSRPreview (server-side rendering)
      2. DEFAULT_SSR_PREVIEW is used (placeholder during SSR)
      This ensures ssrReliability is updated to 'success' when the server-rendered image loads.
      */ if (newPreview.source === 'ssr-server' && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if ((newPreview === null || newPreview === void 0 ? void 0 : newPreview.dataURI) !== (preview === null || preview === void 0 ? void 0 : preview.dataURI)) return;
    }, [
        preview === null || preview === void 0 ? void 0 : preview.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>{
        var _ssrReliabilityRef$cu;
        return (0, $2fm8h.generateScriptProps)(identifier, preview === null || preview === void 0 ? void 0 : preview.dataURI, resizeMode, preview === null || preview === void 0 ? void 0 : preview.srcSet, requestDimensions, ((_ssrReliabilityRef$cu = ssrReliabilityRef.current.server) === null || _ssrReliabilityRef$cu === void 0 ? void 0 : _ssrReliabilityRef$cu.status) === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $e6Qdr.fg)('media-perf-uplift-mutation-fix'),
            'media-perf-lazy-loading-optimisation': (0, $e6Qdr.fg)('media-perf-lazy-loading-optimisation')
        });
    } : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $8GsH4.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $e6Qdr.fg)('media-perf-uplift-mutation-fix') ? $d0dfe43a86dc625d$var$DEFAULT_SSR_PREVIEW : preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("8GsH4", function(module, exports) {
$parcel$export(module.exports, "useCopyIntent", () => $f6b12419a2171c7b$export$46fd859414de9d62);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $e6Qdr = parcelRequire("e6Qdr");

var $1pgNF = parcelRequire("1pgNF");

var $ch1Ln = parcelRequire("ch1Ln");

var $h2y43 = parcelRequire("h2y43");
function $f6b12419a2171c7b$var$useCurrentValueRef(value) {
    const ref = (0, $8P7DW.useRef)(value);
    ref.current = value;
    return ref;
}
const $f6b12419a2171c7b$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $1pgNF.useMediaClient)();
    const innerRef = (0, $8P7DW.useRef)(null);
    const clientIdRef = (0, $8P7DW.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    // Pre-fetch clientId so it's available synchronously during copy event
    (0, $8P7DW.useEffect)(()=>{
        if ((0, $e6Qdr.fg)('platform_media_cross_client_copy_with_auth')) mediaClient.getClientId(options.collectionName).then((clientId)=>{
            clientIdRef.current = clientId;
        }).catch(()=>{
        // Silently handle - product might not have authProvider configured
        });
    }, [
        mediaClient,
        options.collectionName
    ]);
    const registerCopyIntentRef = $f6b12419a2171c7b$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $ch1Ln.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $ch1Ln.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $8P7DW.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $e6Qdr.fg)('platform_media_cross_client_copy')) elem === null || elem === void 0 || elem.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $8P7DW.useCallback)((event)=>{
        var _getSelection;
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && ((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.containsNode(currentCopyTarget, true));
        if (currentSelectionContainsNode) {
            registerCopyIntentRef.current();
            // Add clientId to the copied HTML (must be synchronous)
            if ((0, $e6Qdr.fg)('platform_media_cross_client_copy_with_auth')) {
                var _event$clipboardData;
                const clientId = clientIdRef.current;
                const html = (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('text/html');
                // Look for media nodes by data-node-type which is always present
                if (html && html.includes('data-node-type="media') && clientId) {
                    var _event$clipboardData2;
                    // Insert data-client-id after data-node-type="media" or data-node-type="mediaInline"
                    const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId}"$2`);
                    (_event$clipboardData2 = event.clipboardData) === null || _event$clipboardData2 === void 0 || _event$clipboardData2.setData('text/html', modifiedHtml);
                }
            }
        }
    }, [
        registerCopyIntentRef
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if ((0, $e6Qdr.fg)('platform_media_cross_client_copy')) {
            var _getDocument;
            (_getDocument = (0, $h2y43.getDocument)()) === null || _getDocument === void 0 || _getDocument.addEventListener('copy', onGlobalCopy);
        }
        return ()=>{
            var _getDocument2;
            return (_getDocument2 = (0, $h2y43.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.removeEventListener('copy', onGlobalCopy);
        };
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("1pgNF", function(module, exports) {
$parcel$export(module.exports, "useMediaClient", () => $9bcfda91ef2ea78d$export$8b3e87ea56c3a345);

var $8P7DW = parcelRequire("8P7DW");

var $lbS2q = parcelRequire("lbS2q");

var $77jeI = parcelRequire("77jeI");
const $9bcfda91ef2ea78d$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext((0, $lbS2q.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext((0, $77jeI.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("77jeI", function(module, exports) {
$parcel$export(module.exports, "MediaContext", () => $b9ed2ca05654c466$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b9ed2ca05654c466$export$57164260bc1f1218);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $c0KQ5 = parcelRequire("c0KQ5");

var $eciDv = parcelRequire("eciDv");
const $b9ed2ca05654c466$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(undefined);
const $b9ed2ca05654c466$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $8P7DW.useMemo)(()=>(0, $c0KQ5.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $eciDv.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gWgPx.jsx)($b9ed2ca05654c466$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("eciDv", function(module, exports) {
$parcel$export(module.exports, "useMediaParsedSettings", () => $80ec39f9408551d9$export$d54af28440a5efc0);

var $8P7DW = parcelRequire("8P7DW");

var $eX1jv = parcelRequire("eX1jv");
const $80ec39f9408551d9$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $8P7DW.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $eX1jv.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("eX1jv", function(module, exports) {
$parcel$export(module.exports, "defaultMediaUserPreferences", () => $73b6894bf05b2e27$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $73b6894bf05b2e27$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $73b6894bf05b2e27$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($73b6894bf05b2e27$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $73b6894bf05b2e27$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $73b6894bf05b2e27$export$2d23ed2854ac1650 = $73b6894bf05b2e27$export$7e209e67b965bc63($73b6894bf05b2e27$var$defaultUserPreferences);

});




parcelRegister("ch1Ln", function(module, exports) {
$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $09a04d5abe0aefae$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $09a04d5abe0aefae$export$aacb463551da2e8f);

var $a6Vky = parcelRequire("a6Vky");
const $09a04d5abe0aefae$var$getRequestErrorDetails = (err)=>{
    if ((0, $a6Vky.isRequestError)(err)) {
        var _err$metadata, _err$metadata2, _err$metadata3, _err$metadata4;
        return {
            request: {
                statusCode: (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode,
                traceContext: (_err$metadata2 = err.metadata) === null || _err$metadata2 === void 0 ? void 0 : _err$metadata2.traceContext,
                mediaEnv: (_err$metadata3 = err.metadata) === null || _err$metadata3 === void 0 ? void 0 : _err$metadata3.mediaEnv,
                mediaRegion: (_err$metadata4 = err.metadata) === null || _err$metadata4 === void 0 ? void 0 : _err$metadata4.mediaRegion
            }
        };
    }
    return undefined;
};
const $09a04d5abe0aefae$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $a6Vky.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$09a04d5abe0aefae$var$getRequestErrorDetails(error)
        }
    };
};
const $09a04d5abe0aefae$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("h2y43", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $e1f2ce1e8b5514e9$export$f65ca476c09acec0);
const $e1f2ce1e8b5514e9$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("9yf1P", function(module, exports) {
$parcel$export(module.exports, "useFileState", () => $1ccfca12161b6c9e$export$90ff537b0999afb);

var $8P7DW = parcelRequire("8P7DW");

var $1pgNF = parcelRequire("1pgNF");

var $jk4G9 = parcelRequire("jk4G9");
function $1ccfca12161b6c9e$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $1pgNF.useMediaClient)();
    const fileState = (0, $jk4G9.useMediaStore)((state)=>state.files[id]);
    (0, $8P7DW.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("jk4G9", function(module, exports) {
$parcel$export(module.exports, "useMediaStore", () => $01fccf808281865b$export$8a9cc8c330400af8);

var $aWGxn = parcelRequire("aWGxn");

var $1pgNF = parcelRequire("1pgNF");
const $01fccf808281865b$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $aWGxn.useStore)(store, selector, equals);
function $01fccf808281865b$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $1pgNF.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $01fccf808281865b$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("aWGxn", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $7f80512bf42095f5$export$6ccbb43953eebf8);

var $ayvtO = parcelRequire("ayvtO");

var $8P7DW = parcelRequire("8P7DW");

var $doeWf = parcelRequire("doeWf");
var $7f80512bf42095f5$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $7f80512bf42095f5$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW)));
const { useSyncExternalStoreWithSelector: $7f80512bf42095f5$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($doeWf)));
let $7f80512bf42095f5$var$didWarnAboutEqualityFn = false;
const $7f80512bf42095f5$var$identity = (arg)=>arg;
function $7f80512bf42095f5$export$6ccbb43953eebf8(api, selector = $7f80512bf42095f5$var$identity, equalityFn) {
    if (($7f80512bf42095f5$import_meta.env ? $7f80512bf42095f5$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$7f80512bf42095f5$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $7f80512bf42095f5$var$didWarnAboutEqualityFn = true;
    }
    const slice = $7f80512bf42095f5$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $7f80512bf42095f5$var$useDebugValue(slice);
    return slice;
}
const $7f80512bf42095f5$var$createImpl = (createState)=>{
    if (($7f80512bf42095f5$import_meta.env ? $7f80512bf42095f5$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ayvtO.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$7f80512bf42095f5$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $7f80512bf42095f5$export$185802fd694ee1f5 = (createState)=>createState ? $7f80512bf42095f5$var$createImpl(createState) : $7f80512bf42095f5$var$createImpl;
var $7f80512bf42095f5$export$2e2bcd8739ae039 = (createState)=>{
    if (($7f80512bf42095f5$import_meta.env ? $7f80512bf42095f5$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $7f80512bf42095f5$export$185802fd694ee1f5(createState);
};

});
parcelRegister("doeWf", function(module, exports) {
'use strict';

module.exports = (parcelRequire("79I9e"));

});
parcelRegister("79I9e", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $535b9e8b1818a8f6$export$bf730a2d8bf68b42, (v) => $535b9e8b1818a8f6$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $535b9e8b1818a8f6$export$bf730a2d8bf68b42;
"use strict";

var $8P7DW = parcelRequire("8P7DW");

var $h2txa = parcelRequire("h2txa");
function $535b9e8b1818a8f6$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $535b9e8b1818a8f6$var$objectIs = "function" === typeof Object.is ? Object.is : $535b9e8b1818a8f6$var$is, $535b9e8b1818a8f6$var$useSyncExternalStore = $h2txa.useSyncExternalStore, $535b9e8b1818a8f6$var$useRef = $8P7DW.useRef, $535b9e8b1818a8f6$var$useEffect = $8P7DW.useEffect, $535b9e8b1818a8f6$var$useMemo = $8P7DW.useMemo, $535b9e8b1818a8f6$var$useDebugValue = $8P7DW.useDebugValue;
$535b9e8b1818a8f6$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $535b9e8b1818a8f6$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $535b9e8b1818a8f6$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($535b9e8b1818a8f6$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $535b9e8b1818a8f6$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $535b9e8b1818a8f6$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $535b9e8b1818a8f6$var$useDebugValue(value);
    return value;
};

});





parcelRegister("1SBlJ", function(module, exports) {
$parcel$export(module.exports, "extractErrorInfo", () => $8f3d104bf3e65935$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $8f3d104bf3e65935$export$768c370ed0dbaeb3);

var $cMcHx = parcelRequire("cMcHx");

var $fvwkK = parcelRequire("fvwkK");
const $8f3d104bf3e65935$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $cMcHx.isCommonMediaClientError)(secondaryError)) {
        var _secondaryError$metad;
        return (_secondaryError$metad = secondaryError.metadata) === null || _secondaryError$metad === void 0 ? void 0 : _secondaryError$metad.traceContext;
    }
};
const $8f3d104bf3e65935$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $8f3d104bf3e65935$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $cMcHx.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $8f3d104bf3e65935$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $cMcHx.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $8f3d104bf3e65935$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $8f3d104bf3e65935$export$4af9d71992e89714(error),
        error: $8f3d104bf3e65935$export$88c61dcad53762da(error),
        errorDetail: $8f3d104bf3e65935$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $8f3d104bf3e65935$export$29aa614726672b2e(error)
    };
};
const $8f3d104bf3e65935$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$8f3d104bf3e65935$export$74aaf4784c2edb2c(new (0, $fvwkK.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("fvwkK", function(module, exports) {
$parcel$export(module.exports, "MediaFilePreviewError", () => $6bfdcc650aaa797b$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $6bfdcc650aaa797b$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $6bfdcc650aaa797b$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $6bfdcc650aaa797b$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $6bfdcc650aaa797b$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $6bfdcc650aaa797b$export$7156ce7b78b49bd7);
class $6bfdcc650aaa797b$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $6bfdcc650aaa797b$export$2c035820a31723e extends $6bfdcc650aaa797b$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $6bfdcc650aaa797b$export$10ab445310d30114 extends $6bfdcc650aaa797b$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $6bfdcc650aaa797b$export$18e89b7e50818288 extends $6bfdcc650aaa797b$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $6bfdcc650aaa797b$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $6bfdcc650aaa797b$export$d0a45ab59b4606b extends $6bfdcc650aaa797b$export$96e559194c287cf4 {
    constructor(source){
        super($6bfdcc650aaa797b$var$getImageLoadPrimaryReason(source));
    }
}
function $6bfdcc650aaa797b$export$553696a6e769784c(err) {
    return err instanceof $6bfdcc650aaa797b$export$96e559194c287cf4;
}
const $6bfdcc650aaa797b$export$b380593ba3516c6f = (err)=>err instanceof $6bfdcc650aaa797b$export$2c035820a31723e;
const $6bfdcc650aaa797b$export$e1d87830b3784f94 = (err)=>err instanceof $6bfdcc650aaa797b$export$10ab445310d30114;
const $6bfdcc650aaa797b$export$443aeb298d35d79d = (err)=>$6bfdcc650aaa797b$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $6bfdcc650aaa797b$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($6bfdcc650aaa797b$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $6bfdcc650aaa797b$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $6bfdcc650aaa797b$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("ZT5hB", function(module, exports) {
$parcel$export(module.exports, "getSSRPreview", () => $e6e16ccec024d251$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $e6e16ccec024d251$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $e6e16ccec024d251$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $e6e16ccec024d251$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $e6e16ccec024d251$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $e6e16ccec024d251$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $e6e16ccec024d251$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $e6e16ccec024d251$export$98e935d981c884d);

var $95w60 = parcelRequire("95w60");

var $e6Qdr = parcelRequire("e6Qdr");

var $fvwkK = parcelRequire("fvwkK");

var $gE4mo = parcelRequire("gE4mo");

var $do6DC = parcelRequire("do6DC");
const $e6e16ccec024d251$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $95w60.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $gE4mo.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $e6e16ccec024d251$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs)=>{
    const rawDataURI = mediaClient.getImageUrlSync(id, params);
    return mediaBlobUrlAttrs ? (0, $95w60.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
};
/**
 * Merges a clientId into mediaBlobUrlAttrs for cross-client copy support.
 * Returns the original attrs unchanged if clientId is not available or the feature flag is off.
 */ const $e6e16ccec024d251$var$mergeClientIdIntoAttrs = (clientId, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!clientId) return mediaBlobUrlAttrs;
    if (mediaBlobUrlAttrs) return {
        ...mediaBlobUrlAttrs,
        clientId: clientId
    };
    // Construct minimal attrs when none provided
    return {
        id: id,
        clientId: clientId,
        contextId: collectionName || '',
        collection: collectionName
    };
};
const $e6e16ccec024d251$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    try {
        // Synchronously extract clientId from initialAuth and merge into blob URL attrs
        const clientId = (0, $e6Qdr.fg)('platform_media_cross_client_copy_with_auth') ? mediaClient.getClientIdSync() : undefined;
        const attrsWithClientId = $e6e16ccec024d251$var$mergeClientIdIntoAttrs(clientId, id, mediaBlobUrlAttrs, params.collection);
        const dataURI = $e6e16ccec024d251$var$getDataUri(mediaClient, id, params, attrsWithClientId);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $e6e16ccec024d251$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, attrsWithClientId);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $fvwkK.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $e6e16ccec024d251$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $e6e16ccec024d251$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $e6e16ccec024d251$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $e6e16ccec024d251$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $e6e16ccec024d251$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
/**
 * Resolves clientId (sync first, async fallback) and enriches mediaBlobUrlAttrs
 * with it for cross-client copy support.
 */ const $e6e16ccec024d251$var$enrichAttrsWithClientId = async (mediaClient, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!(0, $e6Qdr.fg)('platform_media_cross_client_copy_with_auth')) return mediaBlobUrlAttrs;
    // Try sync first, then async fallback
    let clientId = mediaClient.getClientIdSync();
    if (!clientId) try {
        clientId = await mediaClient.getClientId(collectionName);
    } catch  {
    // clientId is optional, silently fail
    }
    return $e6e16ccec024d251$var$mergeClientIdIntoAttrs(clientId, id, mediaBlobUrlAttrs, collectionName);
};
const $e6e16ccec024d251$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const [remotePreview, enrichedAttrs] = await Promise.all([
        (0, $do6DC.getRemotePreview)(mediaClient, id, params, traceContext),
        $e6e16ccec024d251$var$enrichAttrsWithClientId(mediaClient, id, mediaBlobUrlAttrs, params.collection)
    ]);
    return $e6e16ccec024d251$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, enrichedAttrs);
};
const $e6e16ccec024d251$export$98e935d981c884d = async (mediaClient, id, filePreview, dimensions, mode, mediaBlobUrlAttrs, collectionName)=>{
    const [localPreview, enrichedAttrs] = await Promise.all([
        (0, $do6DC.getLocalPreview)(filePreview),
        $e6e16ccec024d251$var$enrichAttrsWithClientId(mediaClient, id, mediaBlobUrlAttrs, collectionName)
    ]);
    return $e6e16ccec024d251$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, enrichedAttrs);
};

});
parcelRegister("95w60", function(module, exports) {
$parcel$export(module.exports, "isMediaBlobUrl", () => $bf3d7959261df05a$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $bf3d7959261df05a$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $bf3d7959261df05a$export$e51a8146182600b8);
const $bf3d7959261df05a$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $bf3d7959261df05a$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$bf3d7959261df05a$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $bf3d7959261df05a$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $bf3d7959261df05a$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $bf3d7959261df05a$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    const clientId = params.get('clientId');
    // check if we have the required params (clientId is optional for backwards compatibility)
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        clientId: clientId || undefined,
        collection: $bf3d7959261df05a$var$getStringFromParams(params, 'collection'),
        alt: $bf3d7959261df05a$var$getStringFromParams(params, 'alt'),
        height: $bf3d7959261df05a$var$getNumberFromParams(params, 'height'),
        width: $bf3d7959261df05a$var$getNumberFromParams(params, 'width'),
        size: $bf3d7959261df05a$var$getNumberFromParams(params, 'size'),
        name: $bf3d7959261df05a$var$getStringFromParams(params, 'name'),
        mimeType: $bf3d7959261df05a$var$getStringFromParams(params, 'mimeType')
    };
};
const $bf3d7959261df05a$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $bf3d7959261df05a$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$bf3d7959261df05a$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $bf3d7959261df05a$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("gE4mo", function(module, exports) {
$parcel$export(module.exports, "mediaFilePreviewCache", () => $335f5af73800f8a1$export$b7e8ee3f7a41459);

var $fFU9O = parcelRequire("fFU9O");
const $335f5af73800f8a1$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $335f5af73800f8a1$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $335f5af73800f8a1$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $335f5af73800f8a1$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $335f5af73800f8a1$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
        this.acquire = (id, mode)=>{
            const cacheKey = $335f5af73800f8a1$export$611736262b635f8d(id, mode);
            this.previewCache.acquire(cacheKey);
        };
        this.release = (id, mode)=>{
            const cacheKey = $335f5af73800f8a1$export$611736262b635f8d(id, mode);
            this.previewCache.release(cacheKey);
        };
    }
}
const $335f5af73800f8a1$export$b7e8ee3f7a41459 = new $335f5af73800f8a1$export$7b50526c091bb915((0, $fFU9O.createObjectURLCache)());

});
parcelRegister("fFU9O", function(module, exports) {
$parcel$export(module.exports, "createObjectURLCache", () => $9dccb42b901bc593$export$ba71be67d5c32535);

var $4E7es = parcelRequire("4E7es");

var $e6Qdr = parcelRequire("e6Qdr");
const $9dccb42b901bc593$export$36d0f9859761643d = 50;
/**
 * LRU cache that checks whether the oldest entry should be evicted
 * this means that the cache can grow past the softLimit if `shouldEvict` returns false.
 *
 * When `platform_media_safe_blob_url_eviction` is ON the oldest
 * entry is kept if `shouldEvict` returns false.
 * When the flag is OFF the oldest entry is always evicted.
 */ class $9dccb42b901bc593$var$EvictionLRUCache extends (0, $4E7es.LRUMap) {
    constructor(softLimit, options){
        super(softLimit);
        this.shouldEvict = options === null || options === void 0 ? void 0 : options.shouldEvict;
        this.onEvict = options === null || options === void 0 ? void 0 : options.onEvict;
    }
    shift() {
        if ((0, $e6Qdr.fg)('platform_media_safe_blob_url_eviction')) {
            const oldest = this.oldest;
            if (oldest && this.shouldEvict && !this.shouldEvict([
                oldest.key,
                oldest.value
            ])) return undefined;
        }
        const entry = super.shift();
        if (entry && this.onEvict) this.onEvict(entry);
        return entry;
    }
}
class $9dccb42b901bc593$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.activeRefs = new Map();
        this.cache = new $9dccb42b901bc593$var$EvictionLRUCache(size, {
            shouldEvict: (entry)=>!this.isInUse(entry[0]),
            onEvict: (entry)=>{
                if (entry[1].dataURI) {
                    const dataURI = (0, $e6Qdr.fg)('platform_media_safe_blob_url_eviction') ? entry[1].dataURI.split('#')[0] : entry[1].dataURI;
                    if (dataURI) URL.revokeObjectURL(dataURI);
                }
            }
        });
    }
    /**
   * Marks a cache key as actively in use by a consumer.
   * Multiple consumers can acquire the same key; eviction is
   * blocked until all consumers have released it.
   */ acquire(key) {
        this.activeRefs.set(key, (this.activeRefs.get(key) ?? 0) + 1);
    }
    release(key) {
        const count = this.activeRefs.get(key) ?? 0;
        if (count <= 1) this.activeRefs.delete(key);
        else this.activeRefs.set(key, count - 1);
    }
    isInUse(key) {
        return (this.activeRefs.get(key) ?? 0) > 0;
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        this.activeRefs.delete(key);
        const dataURI = (0, $e6Qdr.fg)('platform_media_safe_blob_url_eviction') ? removed === null || removed === void 0 ? void 0 : removed.dataURI.split('#')[0] : removed === null || removed === void 0 ? void 0 : removed.dataURI;
        dataURI && URL.revokeObjectURL(dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $9dccb42b901bc593$export$ba71be67d5c32535 = ()=>new $9dccb42b901bc593$export$75d1c8c9ba1d0773($9dccb42b901bc593$export$36d0f9859761643d);

});


parcelRegister("do6DC", function(module, exports) {
$parcel$export(module.exports, "isSupportedLocalPreview", () => $8de281dccee1cf18$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $8de281dccee1cf18$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $8de281dccee1cf18$export$bfe20bd01db02b3);

var $o96nQ = parcelRequire("o96nQ");

var $hpQ2p = parcelRequire("hpQ2p");

var $fvwkK = parcelRequire("fvwkK");

var $kwOw6 = parcelRequire("kwOw6");
const $8de281dccee1cf18$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $8de281dccee1cf18$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $hpQ2p.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $fvwkK.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $8de281dccee1cf18$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $kwOw6.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $fvwkK.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $8de281dccee1cf18$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $fvwkK.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $o96nQ.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $8de281dccee1cf18$var$getImageLocalPreview(value);
            case 'video':
                return $8de281dccee1cf18$var$getVideoLocalPreview(value);
            default:
                throw new (0, $fvwkK.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $fvwkK.LocalPreviewError)('local-preview-unsupported');
};
const $8de281dccee1cf18$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $fvwkK.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("hpQ2p", function(module, exports) {
$parcel$export(module.exports, "getImageInfo", () => $245d58f896712d27$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $245d58f896712d27$export$67689507e8404821);

var $lBOl5 = parcelRequire("lBOl5");

var $4xEWI = parcelRequire("4xEWI");

var $fhvWZ = parcelRequire("fhvWZ");

var $2PIOU = parcelRequire("2PIOU");
const { Orientation: $245d58f896712d27$var$Orientation, XResolution: $245d58f896712d27$var$XResolution } = (0, $lBOl5.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $245d58f896712d27$var$DPI_WEB_BASELINE = 72;
async function $245d58f896712d27$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $245d58f896712d27$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $245d58f896712d27$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $245d58f896712d27$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $245d58f896712d27$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
     * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
     * So we are only relying on X axis.
     */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $245d58f896712d27$var$DPI_WEB_BASELINE;
        else return $245d58f896712d27$export$268f92356524130b(tags, $245d58f896712d27$var$XResolution, $245d58f896712d27$var$DPI_WEB_BASELINE) / $245d58f896712d27$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $245d58f896712d27$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$245d58f896712d27$var$Orientation]) {
        const tagValue = tags[$245d58f896712d27$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $lBOl5.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $245d58f896712d27$export$67689507e8404821(file) {
    const tags = await (0, $4xEWI.readImageMetaTags)(file);
    return $245d58f896712d27$var$getOrientationFromTags(tags);
}
function $245d58f896712d27$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $245d58f896712d27$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $245d58f896712d27$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $4xEWI.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $245d58f896712d27$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $245d58f896712d27$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
   * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
   * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
   * We've also received JAC tickets reporting incorrect dimensions because of this
   * https://jira.atlassian.com/browse/CONFCLOUD-78275
   * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
   */ try {
        const img = await (0, $fhvWZ.loadImage)(src);
        const { width: width, height: height } = (0, $fhvWZ.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("lBOl5", function(module, exports) {
$parcel$export(module.exports, "ImageType", () => $51216abc934bc255$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $51216abc934bc255$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $51216abc934bc255$export$f6ea0c89fd7d156);
var $51216abc934bc255$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $51216abc934bc255$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $51216abc934bc255$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    // none
    'top-right': 2,
    // flip horizontal
    'bottom-right': 3,
    // rotate 180
    'bottom-left': 4,
    // flip vertical
    'left-top': 5,
    // transpose
    'right-top': 6,
    // rotate 90
    'right-bottom': 7,
    // transverse
    'left-bottom': 8 // rotate 270
};

});

parcelRegister("4xEWI", function(module, exports) {
$parcel$export(module.exports, "readImageMetaTags", () => $30461920e73a1a85$export$41982b5c7acb23c4);

var $lBOl5 = parcelRequire("lBOl5");

var $5izSe = parcelRequire("5izSe");

var $Ag0uP = parcelRequire("Ag0uP");

var $6BYvQ = parcelRequire("6BYvQ");
async function $30461920e73a1a85$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $lBOl5.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $Ag0uP.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $6BYvQ.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $lBOl5.ImageType).JPEG) return await (0, $5izSe.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("5izSe", function(module, exports) {
$parcel$export(module.exports, "readJPEGExifMetaData", () => $becb4b0516277b3b$export$556b2ccec62d7f2a);

var $lBOl5 = parcelRequire("lBOl5");
const { XResolution: $becb4b0516277b3b$var$XResolution, YResolution: $becb4b0516277b3b$var$YResolution } = (0, $lBOl5.SupportedImageMetaTag);
let $becb4b0516277b3b$var$loadImage;

function $becb4b0516277b3b$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$becb4b0516277b3b$var$loadImage) {
            const module = await (parcelRequire("3R14A"));
            $becb4b0516277b3b$var$loadImage = module.default || module;
        }
        $becb4b0516277b3b$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $becb4b0516277b3b$var$XResolution || key === $becb4b0516277b3b$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("3R14A", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("lLg1r").then(()=>parcelRequire('erreU'));

});


parcelRegister("Ag0uP", function(module, exports) {
$parcel$export(module.exports, "readPNGXMPMetaData", () => $bd0f64100443a7af$export$5fb37736440fca6f);

var $fhvWZ = parcelRequire("fhvWZ");
let $bd0f64100443a7af$var$pngChunksExtract;

async function $bd0f64100443a7af$export$5fb37736440fca6f(file) {
    if (!$bd0f64100443a7af$var$pngChunksExtract) {
        const module = await (parcelRequire("3zTAA"));
        $bd0f64100443a7af$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $fhvWZ.fileToArrayBuffer)(file);
    const chunks = $bd0f64100443a7af$var$pngChunksExtract(buffer);
    return await $bd0f64100443a7af$export$9185743fdd58ce45(chunks);
}
async function $bd0f64100443a7af$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
   * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
   * Order of every chunk is not guaranteed.
   * And both iTXt and pHYs are Ancillary chunks.
   */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
     * iTXt contains the useful XMP/XML string data of meta tags
     */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
     * Pixels per unit, X axis: 4 bytes (unsigned integer)
     * Pixels per unit, Y axis: 4 bytes (unsigned integer)
     * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
     */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("fhvWZ", function(module, exports) {
$parcel$export(module.exports, "getFileInfo", () => $7751055e9d13df9a$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $7751055e9d13df9a$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $7751055e9d13df9a$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $7751055e9d13df9a$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $7751055e9d13df9a$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $7751055e9d13df9a$export$61a1de0822e2820);

var $8LYcB = parcelRequire("8LYcB");

var $kMqLp = parcelRequire("kMqLp");

var $d5XWs = parcelRequire("d5XWs");

var $3k9EK = parcelRequire("3k9EK");

var $bNO88 = parcelRequire("bNO88");

var $fO7pR = parcelRequire("fO7pR");

var $9Gmjn = parcelRequire("9Gmjn");

var $8H7Uq = parcelRequire("8H7Uq");

var $cMAID = parcelRequire("cMAID");

var $d3ST1 = parcelRequire("d3ST1");

var $bcFna = parcelRequire("bcFna");

var $bhL35 = parcelRequire("bhL35");

var $k2NAj = parcelRequire("k2NAj");

var $jqDNR = parcelRequire("jqDNR");

var $4EOWy = parcelRequire("4EOWy");

var $42VpU = parcelRequire("42VpU");
function $7751055e9d13df9a$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $7751055e9d13df9a$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $7751055e9d13df9a$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $7751055e9d13df9a$export$849633012686f7ee(file)
    };
}
async function $7751055e9d13df9a$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $7751055e9d13df9a$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $7751055e9d13df9a$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $7751055e9d13df9a$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $7751055e9d13df9a$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $7751055e9d13df9a$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $7751055e9d13df9a$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8LYcB)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cMAID)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bcFna)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cMAID)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d3ST1)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8H7Uq)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3k9EK)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jqDNR)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d5XWs)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kMqLp)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($k2NAj)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bhL35)))
    }
];
function $7751055e9d13df9a$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $7751055e9d13df9a$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $42VpU.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4EOWy)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bNO88)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fO7pR)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Gmjn)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("8LYcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $66316970f38dedf0$var$_react = $66316970f38dedf0$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $66316970f38dedf0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $66316970f38dedf0$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $66316970f38dedf0$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$66316970f38dedf0$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $66316970f38dedf0$var$_default = module.exports.default = $66316970f38dedf0$var$PdfDocument24Icon;

});
parcelRegister("dhVx2", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $1c6f30314ae63f16$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $1c6f30314ae63f16$var$iconStyles = null;
const $1c6f30314ae63f16$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ const $1c6f30314ae63f16$var$baseHcmStyles = null;
const $1c6f30314ae63f16$var$primaryEqualsSecondaryHcmStyles = null;
const $1c6f30314ae63f16$var$secondaryTransparentHcmStyles = null;
const $1c6f30314ae63f16$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8P7DW.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $gWgPx.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $8n1kL.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $1c6f30314ae63f16$var$sizeStyles[size]
        ])
    });
});
var $1c6f30314ae63f16$export$2e2bcd8739ae039 = $1c6f30314ae63f16$export$f04a61298a47a40f;

});


parcelRegister("kMqLp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f20d0d0bbbe6a76c$var$_react = $f20d0d0bbbe6a76c$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $f20d0d0bbbe6a76c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f20d0d0bbbe6a76c$var$Gif24Icon = (props)=>/*#__PURE__*/ $f20d0d0bbbe6a76c$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f20d0d0bbbe6a76c$var$Gif24Icon.displayName = 'Gif24Icon';
var $f20d0d0bbbe6a76c$var$_default = module.exports.default = $f20d0d0bbbe6a76c$var$Gif24Icon;

});

parcelRegister("d5XWs", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $988a3d33b889cb12$var$_react = $988a3d33b889cb12$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $988a3d33b889cb12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $988a3d33b889cb12$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $988a3d33b889cb12$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$988a3d33b889cb12$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $988a3d33b889cb12$var$_default = module.exports.default = $988a3d33b889cb12$var$PowerpointPresentation24Icon;

});

parcelRegister("3k9EK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $26babae5f2c4132d$var$_react = $26babae5f2c4132d$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $26babae5f2c4132d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $26babae5f2c4132d$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $26babae5f2c4132d$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$26babae5f2c4132d$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $26babae5f2c4132d$var$_default = module.exports.default = $26babae5f2c4132d$var$WordDocument24Icon;

});

parcelRegister("bNO88", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $897b282216a89d35$var$_react = $897b282216a89d35$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $897b282216a89d35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $897b282216a89d35$var$Sketch24Icon = (props)=>/*#__PURE__*/ $897b282216a89d35$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$897b282216a89d35$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $897b282216a89d35$var$_default = module.exports.default = $897b282216a89d35$var$Sketch24Icon;

});

parcelRegister("fO7pR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $b8214731b0631fe8$var$_react = $b8214731b0631fe8$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $b8214731b0631fe8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b8214731b0631fe8$var$Figma24Icon = (props)=>/*#__PURE__*/ $b8214731b0631fe8$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$b8214731b0631fe8$var$Figma24Icon.displayName = 'Figma24Icon';
var $b8214731b0631fe8$var$_default = module.exports.default = $b8214731b0631fe8$var$Figma24Icon;

});

parcelRegister("9Gmjn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $70c957e95a3f0ad3$var$_react = $70c957e95a3f0ad3$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $70c957e95a3f0ad3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $70c957e95a3f0ad3$var$Executable24Icon = (props)=>/*#__PURE__*/ $70c957e95a3f0ad3$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$70c957e95a3f0ad3$var$Executable24Icon.displayName = 'Executable24Icon';
var $70c957e95a3f0ad3$var$_default = module.exports.default = $70c957e95a3f0ad3$var$Executable24Icon;

});

parcelRegister("8H7Uq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $654879792f8db09e$var$_react = $654879792f8db09e$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $654879792f8db09e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $654879792f8db09e$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $654879792f8db09e$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$654879792f8db09e$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $654879792f8db09e$var$_default = module.exports.default = $654879792f8db09e$var$GoogleDoc24Icon;

});

parcelRegister("cMAID", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $94e673585f88b03e$var$_react = $94e673585f88b03e$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $94e673585f88b03e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $94e673585f88b03e$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $94e673585f88b03e$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$94e673585f88b03e$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $94e673585f88b03e$var$_default = module.exports.default = $94e673585f88b03e$var$GoogleForm24Icon;

});

parcelRegister("d3ST1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $982621758b6124b9$var$_react = $982621758b6124b9$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $982621758b6124b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $982621758b6124b9$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $982621758b6124b9$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$982621758b6124b9$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $982621758b6124b9$var$_default = module.exports.default = $982621758b6124b9$var$GoogleSheet24Icon;

});

parcelRegister("bcFna", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8280e872bb096a5c$var$_react = $8280e872bb096a5c$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $8280e872bb096a5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8280e872bb096a5c$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $8280e872bb096a5c$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8280e872bb096a5c$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $8280e872bb096a5c$var$_default = module.exports.default = $8280e872bb096a5c$var$GoogleSlide24Icon;

});

parcelRegister("bhL35", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8375c72167a44220$var$_react = $8375c72167a44220$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $8375c72167a44220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8375c72167a44220$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $8375c72167a44220$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8375c72167a44220$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $8375c72167a44220$var$_default = module.exports.default = $8375c72167a44220$var$ExcelSpreadsheet24Icon;

});

parcelRegister("k2NAj", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e97a750d53032dde$var$_react = $e97a750d53032dde$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $e97a750d53032dde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e97a750d53032dde$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $e97a750d53032dde$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e97a750d53032dde$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $e97a750d53032dde$var$_default = module.exports.default = $e97a750d53032dde$var$Spreadsheet24Icon;

});

parcelRegister("jqDNR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e24f521ffb66c5e8$var$_react = $e24f521ffb66c5e8$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $e24f521ffb66c5e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e24f521ffb66c5e8$var$Presentation24Icon = (props)=>/*#__PURE__*/ $e24f521ffb66c5e8$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e24f521ffb66c5e8$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $e24f521ffb66c5e8$var$_default = module.exports.default = $e24f521ffb66c5e8$var$Presentation24Icon;

});

parcelRegister("4EOWy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $36426a254eea59c8$var$_react = $36426a254eea59c8$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dhVx2 = parcelRequire("dhVx2");
function $36426a254eea59c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36426a254eea59c8$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $36426a254eea59c8$var$_react.default.createElement($dhVx2.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$36426a254eea59c8$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $36426a254eea59c8$var$_default = module.exports.default = $36426a254eea59c8$var$SourceCode24Icon;

});

parcelRegister("42VpU", function(module, exports) {
$parcel$export(module.exports, "getExtension", () => $1d711f332f10ecd3$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $1d711f332f10ecd3$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $1d711f332f10ecd3$export$ba4368c844580f9e);
function $1d711f332f10ecd3$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $1d711f332f10ecd3$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $1d711f332f10ecd3$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $1d711f332f10ecd3$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $1d711f332f10ecd3$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $1d711f332f10ecd3$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $1d711f332f10ecd3$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            if (mimetype === 'text/plain') return 'text';
            return null;
    }
}

});


parcelRegister("3zTAA", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("k3Lom").then(()=>parcelRequire('awfvB'));

});


parcelRegister("6BYvQ", function(module, exports) {
$parcel$export(module.exports, "parseXMPMetaData", () => $8e895133e45d9220$export$55c3bc9841b19de2);
function $8e895133e45d9220$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("2PIOU", function(module, exports) {
$parcel$export(module.exports, "isRotated", () => $4a26f289ab4c659e$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $4a26f289ab4c659e$export$43142f95b8de7a91);
const $4a26f289ab4c659e$var$ORIENT_TRANSFORMS = {
    1: 'none',
    // Horizontal (normal)
    2: 'rotateY(180deg)',
    // Mirror horizontal
    3: 'rotate(180deg)',
    // Rotate 180
    4: 'rotate(180deg) rotateY(180deg)',
    // Mirror vertical
    5: 'rotate(270deg) rotateY(180deg)',
    // Mirror horizontal and rotate 270 CW
    6: 'rotate(90deg)',
    // Rotate 90 CW
    7: 'rotate(90deg) rotateY(180deg)',
    // Mirror horizontal and rotate 90 CW
    8: 'rotate(270deg)' // Rotate 270 CW
};
const $4a26f289ab4c659e$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $4a26f289ab4c659e$export$43142f95b8de7a91 = (orientation)=>{
    return $4a26f289ab4c659e$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("kwOw6", function(module, exports) {
$parcel$export(module.exports, "takeSnapshot", () => $20b70bc33da85712$export$4269d30173168e5c);
const $20b70bc33da85712$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("2fm8h", function(module, exports) {
$parcel$export(module.exports, "getMediaCardSSR", () => $7c67351d91b2091b$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $7c67351d91b2091b$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $7c67351d91b2091b$export$de7c49925e44d75d);
const $7c67351d91b2091b$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $7c67351d91b2091b$export$d26005e8749921c9 = 'mediaCountSsr';
const $7c67351d91b2091b$export$7aeb4eab53a57df7 = 'performanceEntries';
const $7c67351d91b2091b$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
const $7c67351d91b2091b$var$MAX_EAGER_LOAD_COUNT = 6;
function $7c67351d91b2091b$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $7c67351d91b2091b$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $7c67351d91b2091b$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $7c67351d91b2091b$var$dashed = (param)=>param ? `-${param}` : '';
const $7c67351d91b2091b$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$7c67351d91b2091b$var$dashed(collectionName)}${$7c67351d91b2091b$var$dashed(occurrenceKey)}${$7c67351d91b2091b$var$dashed(resizeMode)}`;
const $7c67351d91b2091b$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const key = $7c67351d91b2091b$export$a47fb462a08de82f(identifier, mode);
    // Serialize the parameters for injection into the script
    const params = {
        key: key,
        dataURI: dataURI,
        mode: mode,
        srcSet: srcSet,
        dimensions: dimensions,
        error: error,
        featureFlags: featureFlags,
        maxEagerLoadCount: $7c67351d91b2091b$var$MAX_EAGER_LOAD_COUNT
    };
    // Read originalScriptCode.ts before making changes
    return `!function(e){var r=document.currentScript,i=window.__MEDIA_INTERNAL=window.__MEDIA_INTERNAL||{},n=i.mediaCardSsr=i.mediaCardSsr||{},o=e.key,t=e.dataURI,d=e.mode,a=e.srcSet,s=e.dimensions,m=e.error,l=e.featureFlags;if(l["media-perf-uplift-mutation-fix"]){var u,c,f=n[o],v=f&&f.mode===d&&(null===(u=f.dimensions)||void 0===u?void 0:u.width)&&(null==s?void 0:s.width)&&f.dimensions.width>s.width,E=v?f.srcSet:a,p=v?f.dataURI:t,w={dataURI:p,dimensions:s,error:m,srcSet:E,loading:"lazy",loadPromise:void 0,mode:d},S=null==r||null===(c=r.parentElement)||void 0===c?void 0:c.querySelector("img");if(i.mediaCountSsr=i.mediaCountSsr||0,S){if(l["media-perf-lazy-loading-optimisation"]&&i.mediaCountSsr<e.maxEagerLoadCount){i.mediaCountSsr++,S.removeAttribute("loading"),w.loading="";var g=new PerformanceObserver((function(e){e.getEntries().forEach((function(e){E.includes(e.name)&&(i.performanceEntries=i.performanceEntries||[],i.performanceEntries.push(e),g.disconnect())}))}));g.observe({type:"resource"})}p&&(S.src=p),E&&(S.srcset=E),w.loadPromise=new Promise((function(e,r){S.addEventListener("load",(function(){return e()})),S.addEventListener("error",(function(){return r(new Error("Failed to load image"))}))}))}n[o]=v?f:w}else n[o]={dataURI:t,dimensions:s,error:m};null==r||r.remove()}({replace:""});`.replace('{replace:""}', JSON.stringify(params));
};
const $7c67351d91b2091b$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $7c67351d91b2091b$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });

});

parcelRegister("9GALT", function(module, exports) {
$parcel$export(module.exports, "getSSRData", () => $7bc80f917a761631$export$d3a890b0f7844b6f);

var $2fm8h = parcelRequire("2fm8h");
const $7bc80f917a761631$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $2fm8h.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $2fm8h.getKey)(identifier, resizeMode)];
};

});

parcelRegister("bPwGw", function(module, exports) {
$parcel$export(module.exports, "isBigger", () => $0c5a5a0c48b21dbf$export$912a00e9a5470d9a);
$parcel$export(module.exports, "isWider", () => $0c5a5a0c48b21dbf$export$ae6224430098bc5f);
$parcel$export(module.exports, "createRequestDimensions", () => $0c5a5a0c48b21dbf$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $0c5a5a0c48b21dbf$export$b3e10e1f0fbb71db);

var $8P7DW = parcelRequire("8P7DW");
const $0c5a5a0c48b21dbf$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
const $0c5a5a0c48b21dbf$export$ae6224430098bc5f = (current, next)=>{
    if (current === undefined && next !== undefined) return true;
    const currentWidth = (current === null || current === void 0 ? void 0 : current.width) || 0;
    const nextWidth = (next === null || next === void 0 ? void 0 : next.width) || 0;
    return currentWidth < nextWidth;
};
/** Verifies if the current screen is retina display */ function $0c5a5a0c48b21dbf$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $0c5a5a0c48b21dbf$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $0c5a5a0c48b21dbf$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $0c5a5a0c48b21dbf$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $8P7DW.useRef)(value);
    ref.current = value;
    return ref;
}

});






parcelRegister("iXNah", function(module, exports) {
$parcel$export(module.exports, "AttributeList", () => (parcelRequire("gzLeM")).AttributeList);

var $gzLeM = parcelRequire("gzLeM");

});
parcelRegister("gzLeM", function(module, exports) {
$parcel$export(module.exports, "AttributeList", () => $728b597d264a65f7$export$f632a70b7942a9ca);

var $8P7DW = parcelRequire("8P7DW");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $lJXkt = parcelRequire("lJXkt");
const $728b597d264a65f7$export$f632a70b7942a9ca = ({ attributes: attributes, timezoneId: timezoneId })=>{
    const objectAttributeValuesAreNotEmpty = (values)=>{
        return values.every((value)=>Object.keys(value).length > 0);
    };
    const renderAttribute = (attribute)=>{
        var _attribute$objectType;
        if (((_attribute$objectType = attribute.objectTypeAttribute.defaultType) === null || _attribute$objectType === void 0 ? void 0 : _attribute$objectType.name) === 'DateTime' && timezoneId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
            const displayValue = value.value ? (0, $lJXkt.convertToTimezone)(value.value, timezoneId) : value.displayValue;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
                key: index
            }, displayValue);
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
                key: index
            }, value.displayValue);
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $728b597d264a65f7$var$ListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        as: "dl",
        xcss: $728b597d264a65f7$var$ListStyles
    }, attributes.map((attribute)=>objectAttributeValuesAreNotEmpty(attribute.objectAttributeValues) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            key: attribute.id,
            xcss: $728b597d264a65f7$var$AttributeWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: "dt",
            xcss: $728b597d264a65f7$var$AttributeLabelWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
            size: "xsmall",
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: "span",
            xcss: $728b597d264a65f7$var$attributeLabelStyles
        }, attribute.objectTypeAttribute.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: "dd",
            xcss: $728b597d264a65f7$var$AttributeValueStyles
        }, renderAttribute(attribute))))));
};
const $728b597d264a65f7$var$ListStyles = (0, $37U6z.xcss)({
    paddingLeft: 'space.0'
});
const $728b597d264a65f7$var$ListWrapperStyles = (0, $37U6z.xcss)({
    /* Offset the outside padding from children */ // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.negative.050',
    marginRight: 'space.negative.150',
    marginBottom: 'space.negative.050',
    marginLeft: 'space.negative.150'
});
const $728b597d264a65f7$var$attributeLabelStyles = (0, $37U6z.xcss)({
    color: 'color.text.subtle'
});
const $728b597d264a65f7$var$AttributeLabelWrapperStyles = (0, $37U6z.xcss)({
    marginBlock: 'space.050',
    marginInline: 'space.150',
    minHeight: 'space.300',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.300',
    flexBasis: '112px',
    flexGrow: 1
});
const $728b597d264a65f7$var$AttributeValueStyles = (0, $37U6z.xcss)({
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    color: 'color.text',
    // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.050',
    marginRight: 'space.150',
    marginBottom: 'space.050',
    marginLeft: 'space.150',
    minHeight: 'space.300',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.300',
    flexBasis: '224px',
    flexGrow: 1
});
const $728b597d264a65f7$var$AttributeWrapperStyles = (0, $37U6z.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
});

});
parcelRegister("iqJis", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4d8eac234e27f6a$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v0.37.1 */ /* heading.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $j4RVe = parcelRequire("j4RVe");

var $YDqMU = parcelRequire("YDqMU");

var $cdpMe = parcelRequire("cdpMe");

var $6nQJh = parcelRequire("6nQJh");
const $f4d8eac234e27f6a$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $f4d8eac234e27f6a$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $f4d8eac234e27f6a$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $f4d8eac234e27f6a$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ const $f4d8eac234e27f6a$var$useColor = (colorProp)=>{
    const surface = (0, $YDqMU.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $j4RVe.inverseColorMap).hasOwnProperty(surface)) return (0, $j4RVe.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $f4d8eac234e27f6a$var$Heading = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $6nQJh;
    const [hLevel, inferredElement] = (0, $cdpMe.useHeading)($f4d8eac234e27f6a$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $f4d8eac234e27f6a$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $8n1kL.default)([
            $f4d8eac234e27f6a$var$styles.reset,
            $f4d8eac234e27f6a$var$headingSizeStyles[size],
            $f4d8eac234e27f6a$var$headingColorStyles[color]
        ]),
        children: children
    });
});
var $f4d8eac234e27f6a$export$2e2bcd8739ae039 = $f4d8eac234e27f6a$var$Heading;

});
parcelRegister("cdpMe", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $050a00cadd3701d6$export$97a37b1befbbf9b1);

var $cxIf7 = parcelRequire("cxIf7");
const $050a00cadd3701d6$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $cxIf7.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("cxIf7", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $9d6aa61ece23e2f2$export$6a64a1e2d0bbbf75);

var $8P7DW = parcelRequire("8P7DW");

var $cYr56 = parcelRequire("cYr56");
const $9d6aa61ece23e2f2$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $8P7DW.useContext)((0, $cYr56.HeadingLevelContext));
};

});
parcelRegister("cYr56", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $26920f548ed5f713$export$d1fa8a19e192bc63);

var $8P7DW = parcelRequire("8P7DW");
const $26920f548ed5f713$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $8P7DW.createContext)(0);

});




parcelRegister("lJXkt", function(module, exports) {
$parcel$export(module.exports, "convertToTimezone", () => $bb598e3bd9608e93$export$4d189baac548427);
const $bb598e3bd9608e93$export$4d189baac548427 = (dateString, timezoneId)=>{
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: timezoneId
    }).format(date);
};

});



parcelRegister("klfoP", function(module, exports) {
$parcel$export(module.exports, "ExpandCollapseToggle", () => (parcelRequire("si1h7")).ExpandCollapseToggle);

var $si1h7 = parcelRequire("si1h7");

});
parcelRegister("si1h7", function(module, exports) {
$parcel$export(module.exports, "ExpandCollapseToggle", () => $5f13966fcd1c9922$export$170fda29b81e014c);

var $8P7DW = parcelRequire("8P7DW");

var $ifRQf = parcelRequire("ifRQf");

var $cDQfx = parcelRequire("cDQfx");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $ea6bZ = parcelRequire("ea6bZ");
const $5f13966fcd1c9922$export$170fda29b81e014c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ea6bZ.default), {
        content: props.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ifRQf.default), {
        appearance: "subtle",
        onClick: props.onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: [
                $5f13966fcd1c9922$var$animatedRotationStyles,
                props.isExpanded && $5f13966fcd1c9922$var$animatedRotationStylesInverted
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
            spacing: "spacious",
            label: props.label,
            size: "small"
        })),
        testId: props.testId
    }));
};
const $5f13966fcd1c9922$var$animatedRotationStyles = (0, $37U6z.xcss)({
    transition: '200ms ease all',
    transform: 'rotate(0deg)'
});
const $5f13966fcd1c9922$var$animatedRotationStylesInverted = (0, $37U6z.xcss)({
    transform: 'rotate(180deg)'
});

});
parcelRegister("ifRQf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2965d459fcc3fb5$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $5J6r2 = parcelRequire("5J6r2");

var $fK6Kn = parcelRequire("fK6Kn");

var $9j2sK = parcelRequire("9j2sK");

var $iF6L5 = parcelRequire("iF6L5");
const $e2965d459fcc3fb5$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $e2965d459fcc3fb5$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $5J6r2.default), onMouseUp: providedOnMouseUp = (0, $5J6r2.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $iF6L5.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $8P7DW.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $8P7DW.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($e2965d459fcc3fb5$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $8P7DW.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($e2965d459fcc3fb5$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $8P7DW.useMemo)(()=>(0, $9j2sK.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fK6Kn.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$e2965d459fcc3fb5$var$Button.displayName = 'Button';
var $e2965d459fcc3fb5$export$2e2bcd8739ae039 = $e2965d459fcc3fb5$var$Button;

});
parcelRegister("5J6r2", function(module, exports) {
$parcel$export(module.exports, "default", () => $addf55c20b14de0c$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $addf55c20b14de0c$export$2e2bcd8739ae039() {}

});

parcelRegister("fK6Kn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1119181ccda24de3$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $aeYmt = parcelRequire("aeYmt");

var $5J6r2 = parcelRequire("5J6r2");

var $d4WRD = parcelRequire("d4WRD");

var $f5PJM = parcelRequire("f5PJM");

var $9uKqY = parcelRequire("9uKqY");

var $kUreS = parcelRequire("kUreS");

var $aPJmP = parcelRequire("aPJmP");

var $66S15 = parcelRequire("66S15");

var $elD2V = parcelRequire("elD2V");

var $ajoEz = parcelRequire("ajoEz");

var $38wKs = parcelRequire("38wKs");
function $1119181ccda24de3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $1119181ccda24de3$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $1119181ccda24de3$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $1119181ccda24de3$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $1119181ccda24de3$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $ajoEz.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $1119181ccda24de3$var$getChildren = (children, childrenStyles)=>{
    if ((0, $ajoEz.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $1119181ccda24de3$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $5J6r2.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $5J6r2.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $8P7DW.useRef)();
    const setRef = (0, $8P7DW.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $d4WRD.default)(ourRef, autoFocus);
    const interactionContext = (0, $8P7DW.useContext)((0, $9uKqY.default));
    const handleClick = (0, $8P7DW.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $8P7DW.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $8P7DW.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $8Z0o8.css)((0, $66S15.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $f5PJM.default), null, /*#__PURE__*/ (0, $8Z0o8.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $1119181ccda24de3$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $kUreS.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $elD2V.getIconStyle)({
                spacing: spacing
            }),
            $1119181ccda24de3$var$getSpacingFix(children, $1119181ccda24de3$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $1119181ccda24de3$var$getChildren(children, [
        fadeStyles,
        (0, $aPJmP.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $elD2V.getIconStyle)({
                spacing: spacing
            }),
            $1119181ccda24de3$var$getSpacingFix(children, $1119181ccda24de3$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        css: [
            (0, $38wKs.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1119181ccda24de3$export$2e2bcd8739ae039 = $1119181ccda24de3$var$ButtonBase;

});
parcelRegister("aeYmt", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $0092318ecf354712$export$a4687b0234b40e28);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $19XqD = parcelRequire("19XqD");
function $0092318ecf354712$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $19XqD.useTrackedRef)(analyticsData);
    const fnRef = (0, $19XqD.useTrackedRef)(fn);
    const handler = (0, $8P7DW.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("d4WRD", function(module, exports) {
$parcel$export(module.exports, "default", () => $b678c0afe2ecd9ac$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $b678c0afe2ecd9ac$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $8P7DW.useRef)(true);
    (0, $8P7DW.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("f5PJM", function(module, exports) {
$parcel$export(module.exports, "default", () => $d225e3b1ecca2df3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");
const $d225e3b1ecca2df3$var$BORDER_WIDTH = 2;
const $d225e3b1ecca2df3$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $d225e3b1ecca2df3$var$BORDER_WIDTH
});
const $d225e3b1ecca2df3$var$baseInsetStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$d225e3b1ecca2df3$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $d225e3b1ecca2df3$var$focusRingStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $d225e3b1ecca2df3$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $d225e3b1ecca2df3$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $d225e3b1ecca2df3$var$insetFocusRingStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $d225e3b1ecca2df3$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $d225e3b1ecca2df3$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $d225e3b1ecca2df3$var$FocusRing = /*#__PURE__*/ (0, $8P7DW.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $d225e3b1ecca2df3$var$baseInsetStyles : $d225e3b1ecca2df3$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $d225e3b1ecca2df3$var$insetFocusRingStyles : $d225e3b1ecca2df3$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8Z0o8.ClassNames), null, ({ css: css, cx: cx })=>(0, $8P7DW.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $8P7DW.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$d225e3b1ecca2df3$var$FocusRing.displayName = 'FocusRing';
var $d225e3b1ecca2df3$export$2e2bcd8739ae039 = $d225e3b1ecca2df3$var$FocusRing;

});

parcelRegister("kUreS", function(module, exports) {
$parcel$export(module.exports, "default", () => $412771a04a65a393$export$2e2bcd8739ae039);
function $412771a04a65a393$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $412771a04a65a393$var$tabKeyCode = 9;
function $412771a04a65a393$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $412771a04a65a393$var$tabKeyCode) return;
    $412771a04a65a393$var$abort(event);
}
const $412771a04a65a393$var$block = {
    onMouseDownCapture: $412771a04a65a393$var$abort,
    onMouseUpCapture: $412771a04a65a393$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $412771a04a65a393$var$onKey,
    onKeyUpCapture: $412771a04a65a393$var$onKey,
    onTouchStartCapture: $412771a04a65a393$var$abort,
    onTouchEndCapture: $412771a04a65a393$var$abort,
    onPointerDownCapture: $412771a04a65a393$var$abort,
    onPointerUpCapture: $412771a04a65a393$var$abort,
    onClickCapture: $412771a04a65a393$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $412771a04a65a393$var$abort
};
const $412771a04a65a393$var$doNotBlock = {};
function $412771a04a65a393$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $412771a04a65a393$var$doNotBlock : $412771a04a65a393$var$block;
}

});

parcelRegister("aPJmP", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $e85903c23a1d8b33$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");
function $e85903c23a1d8b33$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $8Z0o8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("66S15", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $fdec242ffc6efa09$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");
function $fdec242ffc6efa09$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $8Z0o8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("elD2V", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $4e4cba45e87ace02$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");
function $4e4cba45e87ace02$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $8Z0o8.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("ajoEz", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $6eb8d1ef49be073b$export$20bbd2efb0d734c4);

var $8P7DW = parcelRequire("8P7DW");

var $dojiU = parcelRequire("dojiU");
const $6eb8d1ef49be073b$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $8P7DW.isValidElement)(children) && children.type === (0, $dojiU.default);
};

});
parcelRegister("dojiU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebb01633832dca2c$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $ebb01633832dca2c$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $ebb01633832dca2c$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $8n1kL.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
$ebb01633832dca2c$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $ebb01633832dca2c$export$2e2bcd8739ae039 = $ebb01633832dca2c$var$VisuallyHidden;

});


parcelRegister("38wKs", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $98f118fc2ccf7c21$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $98f118fc2ccf7c21$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("9j2sK", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $51533fb4e63cc22e$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $e6Qdr = parcelRequire("e6Qdr");
const $51533fb4e63cc22e$var$gridSize = 8;
const $51533fb4e63cc22e$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $51533fb4e63cc22e$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $51533fb4e63cc22e$var$lineHeights = {
    default: $51533fb4e63cc22e$var$heights.default,
    compact: $51533fb4e63cc22e$var$heights.compact,
    none: 'inherit'
};
const $51533fb4e63cc22e$var$padding = {
    // 10px gutter
    default: `0 ${$51533fb4e63cc22e$var$gridSize + $51533fb4e63cc22e$var$gridSize / 4}px`,
    compact: `0 ${$51533fb4e63cc22e$var$gridSize + $51533fb4e63cc22e$var$gridSize / 4}px`,
    none: '0'
};
const $51533fb4e63cc22e$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$51533fb4e63cc22e$var$gridSize / 4}px`,
    default: `0 ${$51533fb4e63cc22e$var$gridSize / 4}px`,
    none: '0'
};
const $51533fb4e63cc22e$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $51533fb4e63cc22e$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $51533fb4e63cc22e$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$51533fb4e63cc22e$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $51533fb4e63cc22e$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const $51533fb4e63cc22e$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const $51533fb4e63cc22e$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $51533fb4e63cc22e$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const $51533fb4e63cc22e$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const $51533fb4e63cc22e$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $51533fb4e63cc22e$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$51533fb4e63cc22e$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $51533fb4e63cc22e$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $51533fb4e63cc22e$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $e6Qdr.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $51533fb4e63cc22e$var$heights[spacing],
        lineHeight: $51533fb4e63cc22e$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $51533fb4e63cc22e$var$singleIconPadding[spacing] : $51533fb4e63cc22e$var$padding[spacing],
        verticalAlign: $51533fb4e63cc22e$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $51533fb4e63cc22e$var$selectedStyles : {
            ...appearance === 'default' && $51533fb4e63cc22e$var$defaultStyles,
            ...appearance === 'primary' && $51533fb4e63cc22e$var$primaryStyles,
            ...appearance === 'link' && $51533fb4e63cc22e$var$linkStyles,
            ...appearance === 'subtle' && $51533fb4e63cc22e$var$subtleStyles,
            ...appearance === 'subtle-link' && $51533fb4e63cc22e$var$subtleLinkStyles,
            ...appearance === 'warning' && $51533fb4e63cc22e$var$warningStyles,
            ...appearance === 'danger' && $51533fb4e63cc22e$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $51533fb4e63cc22e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $51533fb4e63cc22e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $51533fb4e63cc22e$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                }
            },
            ...$51533fb4e63cc22e$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});

parcelRegister("iF6L5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a41d2aff4a8ab80$export$2e2bcd8739ae039);

var $ajoEz = parcelRequire("ajoEz");
function $7a41d2aff4a8ab80$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $ajoEz.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("cDQfx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9341a84049e482dc$var$_react = $9341a84049e482dc$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $9341a84049e482dc$var$_baseNew = $9341a84049e482dc$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $9341a84049e482dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9341a84049e482dc$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $9341a84049e482dc$var$_react.default.createElement($9341a84049e482dc$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$9341a84049e482dc$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $9341a84049e482dc$var$_default = module.exports.default = $9341a84049e482dc$var$ChevronDownIcon;

});

parcelRegister("ea6bZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5334c51050cffb6d$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $czI4P = parcelRequire("czI4P");

var $5J6r2 = parcelRequire("5J6r2");

var $gyviG = parcelRequire("gyviG");

var $kggbE = parcelRequire("kggbE");

var $egphw = parcelRequire("egphw");

var $cBwgz = parcelRequire("cBwgz");
var $bT4U6 = parcelRequire("bT4U6");

var $e6Qdr = parcelRequire("e6Qdr");

var $cenhL = parcelRequire("cenhL");

var $1NJBM = parcelRequire("1NJBM");

var $2nrNX = parcelRequire("2nrNX");

var $47tOb = parcelRequire("47tOb");

var $dHI4i = parcelRequire("dHI4i");

var $iKbWw = parcelRequire("iKbWw");

var $9SblW = parcelRequire("9SblW");

var $18PG6 = parcelRequire("18PG6");

var $6Yfz4 = parcelRequire("6Yfz4");
const $5334c51050cffb6d$var$tooltipZIndex = (0, $2nrNX.layers).tooltip();
const $5334c51050cffb6d$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
};
// Inverts motion direction
const $5334c51050cffb6d$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $5334c51050cffb6d$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $5334c51050cffb6d$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $6Yfz4.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $5J6r2.default), onHide: onHide = (0, $5J6r2.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, UNSAFE_shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, UNSAFE_shouldRenderToParent: UNSAFE_shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position;
    const onShowHandler = (0, $czI4P.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$5334c51050cffb6d$var$analyticsAttributes
    });
    const onHideHandler = (0, $czI4P.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$5334c51050cffb6d$var$analyticsAttributes
    });
    const apiRef = (0, $8P7DW.useRef)(null);
    const [state, setState] = (0, $8P7DW.useState)('hide');
    const targetRef = (0, $8P7DW.useRef)(null);
    const containerRef = (0, $8P7DW.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $8P7DW.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $kggbE.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $kggbE.default)(onShowHandler);
    const onHideHandlerStable = (0, $kggbE.default)(onHideHandler);
    const delayStable = (0, $kggbE.default)(delay);
    const canAppearStable = (0, $kggbE.default)(canAppear);
    const hasCalledShowHandler = (0, $8P7DW.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $kggbE.default)(shouldAlwaysFadeIn);
    const start = (0, $8P7DW.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $8P7DW.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $8P7DW.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $8P7DW.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $8P7DW.useRef)(false);
    (0, $8P7DW.useEffect)(()=>{
        return (0, $47tOb.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $8P7DW.useCallback)((source)=>{
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: (0, $e6Qdr.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? shouldAlwaysFadeInStable.current : false
        };
        const api = (0, $9SblW.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $8P7DW.useCallback)(()=>{
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $gyviG.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $8P7DW.useEffect)(()=>{
        if (state === 'hide') return 0, $5J6r2.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $36kyW.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $8P7DW.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $8P7DW.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $8P7DW.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = isMousePosition ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            // Removing old `mouse` behind gate because it stored a function.
            // With the gate we just store the coords which are easier to work with.
            mouse: (0, $e6Qdr.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : (0, $dHI4i.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            }),
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $8P7DW.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) {
            if (!(0, $e6Qdr.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) apiRef.current.mousePosition = (0, $dHI4i.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            });
            apiRef.current.mousePos = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        }
    } : undefined;
    const onMouseOverTooltip = (0, $8P7DW.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $8P7DW.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $8P7DW.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $8P7DW.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $8P7DW.useCallback)(()=>{
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $egphw.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        var _apiRef$current5, _apiRef$current6;
        if (isMousePosition && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePos && targetRef.current && (0, $e6Qdr.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) return (0, $iKbWw.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePosition && !(0, $e6Qdr.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback')) {
            var _apiRef$current7;
            return (_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePosition;
        }
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $18PG6.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // Adding `data-testid` to the TriggerProps interface breaks Buttons, so we use type assertion
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $8P7DW.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    const PopperWrapper = UNSAFE_shouldRenderToParent && (0, $e6Qdr.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? (0, $8P7DW.Fragment) : $5334c51050cffb6d$var$TooltipPortal;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : // @ts-ignore
            /*#__PURE__*/ (0, $gWgPx.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $gWgPx.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cenhL.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = isMousePosition ? undefined : $5334c51050cffb6d$var$invertedDirection[$5334c51050cffb6d$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBwgz.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bT4U6.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $gWgPx.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
var $5334c51050cffb6d$export$2e2bcd8739ae039 = $5334c51050cffb6d$var$Tooltip;
const $5334c51050cffb6d$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1NJBM.default), {
        zIndex: $5334c51050cffb6d$var$tooltipZIndex,
        children: children
    });
};

});
parcelRegister("czI4P", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $a86a84aa5beb7908$export$1a04351537078b55);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $19XqD = parcelRequire("19XqD");
function $a86a84aa5beb7908$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $19XqD.useTrackedRef)(analyticsData);
    const fnRef = (0, $19XqD.useTrackedRef)(fn);
    const handler = (0, $8P7DW.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("gyviG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4879a5b4e31b8c2$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $dquZk = parcelRequire("dquZk");
function $a4879a5b4e31b8c2$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $8P7DW.useRef)(false);
    const onKeyDown = (0, $8P7DW.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $dquZk.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $8P7DW.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $8P7DW.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $36kyW.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("dquZk", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $57e43cbfdb8247f1$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $57e43cbfdb8247f1$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_LEFT", () => $57e43cbfdb8247f1$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $57e43cbfdb8247f1$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_HOME", () => $57e43cbfdb8247f1$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $57e43cbfdb8247f1$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $57e43cbfdb8247f1$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $57e43cbfdb8247f1$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $57e43cbfdb8247f1$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $57e43cbfdb8247f1$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $57e43cbfdb8247f1$export$390330c10ff2b9a1 = 'ArrowUp';
const $57e43cbfdb8247f1$export$a80636c6f41931fe = 'ArrowDown';
const $57e43cbfdb8247f1$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $57e43cbfdb8247f1$export$c40f9845adc73fb5 = 'ArrowRight';
const $57e43cbfdb8247f1$export$4af703091671bc = 'Home';
const $57e43cbfdb8247f1$export$e2bc30913faa5db7 = 'End';
const $57e43cbfdb8247f1$export$10f6869ed0a7d75b = 'Tab';
const $57e43cbfdb8247f1$export$8152f929a25a0ff4 = 'Enter';
const $57e43cbfdb8247f1$export$e51a3576c045c8d5 = 'Space';
const $57e43cbfdb8247f1$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("kggbE", function(module, exports) {
$parcel$export(module.exports, "default", () => $d95397c38eee4b81$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $d95397c38eee4b81$export$2e2bcd8739ae039(value) {
    const ref = (0, $8P7DW.useRef)(value);
    (0, $8P7DW.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("egphw", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $248f6022cd27ca58$export$469bb693f11edc7f);

var $8P7DW = parcelRequire("8P7DW");

var $8jNtG = parcelRequire("8jNtG");

var $kkzxS = parcelRequire("kkzxS");
function $248f6022cd27ca58$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose }) {
    const context = (0, $8P7DW.useContext)((0, $8jNtG.OpenLayerObserverContext));
    const namespace = (0, $kkzxS.useOpenLayerObserverNamespace)();
    (0, $8P7DW.useEffect)(()=>{
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("8jNtG", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $6a46793383465374$export$5fbf4d7fae6cdc00);

var $8P7DW = parcelRequire("8P7DW");
const $6a46793383465374$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $8P7DW.createContext)(null);

});

parcelRegister("kkzxS", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $10243eb573d9ba4d$export$1d57e79091cc3046);

var $8P7DW = parcelRequire("8P7DW");

var $bU6OJ = parcelRequire("bU6OJ");
function $10243eb573d9ba4d$export$1d57e79091cc3046() {
    const namespace = (0, $8P7DW.useContext)((0, $bU6OJ.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("bU6OJ", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $c714101ed6a6398c$export$644a49f3b8c50fcd);

var $8P7DW = parcelRequire("8P7DW");
const $c714101ed6a6398c$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $8P7DW.createContext)(null);

});



parcelRegister("cBwgz", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $72088f54cb1674d3$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $72088f54cb1674d3$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");
// We define empty context here so the object doesn't change.
const $72088f54cb1674d3$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $72088f54cb1674d3$var$ExitingContext = /*#__PURE__*/ (0, $8P7DW.createContext)($72088f54cb1674d3$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $72088f54cb1674d3$var$wrapChildWithContextProvider = (child, value = $72088f54cb1674d3$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)($72088f54cb1674d3$var$ExitingContext.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $72088f54cb1674d3$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $8P7DW.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $72088f54cb1674d3$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $72088f54cb1674d3$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $72088f54cb1674d3$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $72088f54cb1674d3$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $72088f54cb1674d3$var$ExitingPersistence = /*#__PURE__*/ (0, $8P7DW.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $8P7DW.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $8P7DW.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $8P7DW.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $8P7DW.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $72088f54cb1674d3$var$childrenToArray(previousChildren);
    const current = $72088f54cb1674d3$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const missingKeys = $72088f54cb1674d3$var$getMissingKeys(current, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $72088f54cb1674d3$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $e6Qdr.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $72088f54cb1674d3$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$72088f54cb1674d3$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $72088f54cb1674d3$export$3b6f38abbdcbd000 = ()=>{
    return (0, $8P7DW.useContext)($72088f54cb1674d3$var$ExitingContext);
};
$72088f54cb1674d3$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $72088f54cb1674d3$export$2e2bcd8739ae039 = $72088f54cb1674d3$var$ExitingPersistence;

});

parcelRegister("bT4U6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ce1763efdb1279e$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $eWrxM = parcelRequire("eWrxM");
const $4ce1763efdb1279e$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $4ce1763efdb1279e$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $4ce1763efdb1279e$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eWrxM.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $4ce1763efdb1279e$export$2e2bcd8739ae039 = $4ce1763efdb1279e$var$FadeIn;

});
parcelRegister("eWrxM", function(module, exports) {
$parcel$export(module.exports, "default", () => $71b168bca1fd2794$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $jh41u = parcelRequire("jh41u");

var $41dEz = parcelRequire("41dEz");

var $htHd6 = parcelRequire("htHd6");

var $cBwgz = parcelRequire("cBwgz");

var $81C2I = parcelRequire("81C2I");
const $71b168bca1fd2794$var$zoomIn = null;
const $71b168bca1fd2794$var$zoomOut = null;
const $71b168bca1fd2794$var$fadeIn = null;
const $71b168bca1fd2794$var$fadeOut = null;
const $71b168bca1fd2794$var$fadeInFromTop = null;
const $71b168bca1fd2794$var$fadeOutFromTop = null;
const $71b168bca1fd2794$var$fadeInFromLeft = null;
const $71b168bca1fd2794$var$fadeOutFromLeft = null;
const $71b168bca1fd2794$var$fadeInFromBottom = null;
const $71b168bca1fd2794$var$fadeOutFromBottom = null;
const $71b168bca1fd2794$var$fadeInFromRight = null;
const $71b168bca1fd2794$var$fadeOutFromRight = null;
const $71b168bca1fd2794$var$fadeInFromTopConstant = null;
const $71b168bca1fd2794$var$fadeOutFromTopConstant = null;
const $71b168bca1fd2794$var$fadeInFromLeftConstant = null;
const $71b168bca1fd2794$var$fadeOutFromLeftConstant = null;
const $71b168bca1fd2794$var$fadeInFromBottomConstant = null;
const $71b168bca1fd2794$var$fadeOutFromBottomConstant = null;
const $71b168bca1fd2794$var$fadeInFromRightConstant = null;
const $71b168bca1fd2794$var$fadeOutFromRightConstant = null;
const $71b168bca1fd2794$var$slideInFromTop = null;
const $71b168bca1fd2794$var$slideOutFromTop = null;
const $71b168bca1fd2794$var$slideInFromRight = null;
const $71b168bca1fd2794$var$slideOutFromRight = null;
const $71b168bca1fd2794$var$slideInFromBottom = null;
const $71b168bca1fd2794$var$slideOutFromBottom = null;
const $71b168bca1fd2794$var$slideInFromLeft = null;
const $71b168bca1fd2794$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $71b168bca1fd2794$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $81C2I.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $cBwgz.useExitingPersistence)();
    const setTimeout = (0, $htHd6.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $8P7DW.useState)(appear);
    (0, $8P7DW.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $jh41u.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $41dEz.exitingDurations)[duration] : (0, $41dEz.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $8n1kL.default)([
            (0, $8n1kL.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $8n1kL.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $8n1kL.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $8n1kL.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $8n1kL.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $8n1kL.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $8n1kL.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $8n1kL.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $8n1kL.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $8n1kL.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $8n1kL.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $8n1kL.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $8n1kL.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $8n1kL.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $8n1kL.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $8n1kL.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $8n1kL.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $8n1kL.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $8n1kL.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $8n1kL.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $8n1kL.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $8n1kL.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $8n1kL.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $8n1kL.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $8n1kL.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $8n1kL.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $8n1kL.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $8n1kL.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $8n1kL.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $8n1kL.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $8n1kL.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $8n1kL.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $8n1kL.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $8n1kL.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $8n1kL.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $8n1kL.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $8n1kL.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $8n1kL.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $8n1kL.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $8n1kL.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $8n1kL.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $8n1kL.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $8n1kL.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $8n1kL.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $8n1kL.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $8n1kL.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $8n1kL.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $8n1kL.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $8n1kL.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $8n1kL.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $8n1kL.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $71b168bca1fd2794$export$2e2bcd8739ae039 = $71b168bca1fd2794$var$EnteringMotion;

});
parcelRegister("jh41u", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $51ae526d381cf703$export$b7baf7667a68d87c);
$parcel$export(module.exports, "useIsReducedMotion", () => $51ae526d381cf703$export$c537e63161742ce3);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $51ae526d381cf703$export$f0f789643ba5a83c);
$parcel$export(module.exports, "prefersReducedMotion", () => $51ae526d381cf703$export$ff7706047246b98b);

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");
const $51ae526d381cf703$var$isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;
const $51ae526d381cf703$export$b7baf7667a68d87c = ()=>{
    if (!$51ae526d381cf703$var$isMatchMediaAvailable()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};
const $51ae526d381cf703$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $8P7DW.useState)($51ae526d381cf703$export$b7baf7667a68d87c);
    (0, $8P7DW.useEffect)(()=>{
        if (!$51ae526d381cf703$var$isMatchMediaAvailable()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $36kyW.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
const $51ae526d381cf703$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
const $51ae526d381cf703$export$ff7706047246b98b = ()=>$51ae526d381cf703$export$f0f789643ba5a83c;

});

parcelRegister("41dEz", function(module, exports) {
$parcel$export(module.exports, "durations", () => $2537102976ea2f14$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $2537102976ea2f14$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $2537102976ea2f14$export$368bacef0dacbe05 = 25;
const $2537102976ea2f14$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $2537102976ea2f14$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $2537102976ea2f14$export$30fa1a2e62ae150c = {
    none: $2537102976ea2f14$export$38b928a7167ce124.none,
    small: $2537102976ea2f14$export$38b928a7167ce124.small * $2537102976ea2f14$var$EXITING_MOTION_MULTIPLIER,
    medium: $2537102976ea2f14$export$38b928a7167ce124.medium * $2537102976ea2f14$var$EXITING_MOTION_MULTIPLIER,
    large: $2537102976ea2f14$export$38b928a7167ce124.large * $2537102976ea2f14$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("htHd6", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $ecc45166e847d19a$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $ecc45166e847d19a$export$4f34107a2b00f39c);

var $8P7DW = parcelRequire("8P7DW");
const $ecc45166e847d19a$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $ecc45166e847d19a$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $8P7DW.useRef)([]);
    (0, $8P7DW.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ecc45166e847d19a$var$getHookDeps(opts));
    return (0, $8P7DW.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
const $ecc45166e847d19a$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $8P7DW.useRef)([]);
    (0, $8P7DW.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ecc45166e847d19a$var$getHookDeps(opts));
    return (0, $8P7DW.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("81C2I", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $738470247b144f87$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $738470247b144f87$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $5J6r2 = parcelRequire("5J6r2");

var $kgdFP = parcelRequire("kgdFP");

var $8Qyky = parcelRequire("8Qyky");
const $738470247b144f87$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $8P7DW.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $5J6r2.default)
    }));
const $738470247b144f87$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $8Qyky.useUniqueId)();
    const context = (0, $8P7DW.useContext)($738470247b144f87$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $738470247b144f87$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $8P7DW.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $8P7DW.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $kgdFP.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $gWgPx.jsx)($738470247b144f87$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var $738470247b144f87$export$2e2bcd8739ae039 = $738470247b144f87$var$StaggeredEntrance;

});
parcelRegister("kgdFP", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $cca2a369976ddb3c$export$e5c5a5f917a5871c);

var $8P7DW = parcelRequire("8P7DW");
const $cca2a369976ddb3c$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $8P7DW.useEffect) : (0, $8P7DW.useLayoutEffect);

});

parcelRegister("8Qyky", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $16cfd90064c81f4c$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $8P7DW = parcelRequire("8P7DW");
function $16cfd90064c81f4c$export$c485849f2e393253() {
    const identifier = (0, $8P7DW.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("cenhL", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $d24c43d6cf650c8e$export$badac9ada3a0bdf9);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $frvCQ = parcelRequire("frvCQ");

var $6LwKw = parcelRequire("6LwKw");

const $d24c43d6cf650c8e$var$viewportPadding = 5;
const $d24c43d6cf650c8e$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $d24c43d6cf650c8e$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $d24c43d6cf650c8e$var$defaultChildrenFn() {
    return null;
}
const $d24c43d6cf650c8e$var$defaultOffset = [
    0,
    8
];
function $d24c43d6cf650c8e$export$badac9ada3a0bdf9({ children: children = $d24c43d6cf650c8e$var$defaultChildrenFn, offset: offset = $d24c43d6cf650c8e$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $8P7DW.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $d24c43d6cf650c8e$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $6LwKw.getMaxSizeModifiers)({
            viewportPadding: $d24c43d6cf650c8e$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$d24c43d6cf650c8e$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $8P7DW.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $frvCQ.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("frvCQ", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $b3e1e8c71822badd$export$badac9ada3a0bdf9);

var $8P7DW = parcelRequire("8P7DW");

var $2wPsV = parcelRequire("2wPsV");

var $h44BJ = parcelRequire("h44BJ");

var $dJDJS = parcelRequire("dJDJS");
var $b3e1e8c71822badd$var$NOOP = function NOOP() {
    return void 0;
};
var $b3e1e8c71822badd$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $b3e1e8c71822badd$var$EMPTY_MODIFIERS = [];
function $b3e1e8c71822badd$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $b3e1e8c71822badd$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $8P7DW.useContext((0, $2wPsV.ManagerReferenceNodeContext));
    var _React$useState = $8P7DW.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $8P7DW.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $8P7DW.useEffect(function() {
        (0, $h44BJ.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $8P7DW.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $dJDJS.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $8P7DW.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $b3e1e8c71822badd$var$NOOP,
            update: update || $b3e1e8c71822badd$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $h44BJ.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("2wPsV", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $1d767def66137d74$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $1d767def66137d74$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $1d767def66137d74$export$d0d38e7dec7a1a61);

var $8P7DW = parcelRequire("8P7DW");
var $1d767def66137d74$export$3dbd3405086fec7b = $8P7DW.createContext();
var $1d767def66137d74$export$cbabb21c2529b130 = $8P7DW.createContext();
function $1d767def66137d74$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $8P7DW.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $8P7DW.useRef(false);
    $8P7DW.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $8P7DW.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $8P7DW.createElement($1d767def66137d74$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $8P7DW.createElement($1d767def66137d74$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("h44BJ", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $c6c6625d25ffc0df$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $c6c6625d25ffc0df$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $c6c6625d25ffc0df$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $c6c6625d25ffc0df$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $c6c6625d25ffc0df$export$700979bc83e7db82);

var $8P7DW = parcelRequire("8P7DW");
var $c6c6625d25ffc0df$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $c6c6625d25ffc0df$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $c6c6625d25ffc0df$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $c6c6625d25ffc0df$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $c6c6625d25ffc0df$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $c6c6625d25ffc0df$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $8P7DW.useLayoutEffect : $8P7DW.useEffect;

});

parcelRegister("dJDJS", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $9ffe4da43791d0b9$export$f4d5bf230a36dd6e);

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");

var $idNj9 = parcelRequire("idNj9");

var $8DF3i = parcelRequire("8DF3i");

var $h44BJ = parcelRequire("h44BJ");
var $9ffe4da43791d0b9$var$EMPTY_MODIFIERS = [];
var $9ffe4da43791d0b9$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $8P7DW.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $9ffe4da43791d0b9$var$EMPTY_MODIFIERS
    };
    var _React$useState = $8P7DW.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $8P7DW.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $6Q1OD.flushSync(function() {
                    setState({
                        styles: (0, $h44BJ.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $h44BJ.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $8P7DW.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8DF3i)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $8P7DW.useRef();
    (0, $h44BJ.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $h44BJ.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $idNj9.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("idNj9", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $d43fb06b643f41fe$export$8f7491d57c8f97a9);

var $eKLRG = parcelRequire("eKLRG");

var $hsSuG = parcelRequire("hsSuG");

var $k6lHD = parcelRequire("k6lHD");

var $cWEex = parcelRequire("cWEex");

var $3TyYi = parcelRequire("3TyYi");

var $awnvg = parcelRequire("awnvg");

var $fCSsJ = parcelRequire("fCSsJ");

var $diy8B = parcelRequire("diy8B");

var $6vxsn = parcelRequire("6vxsn");

var $3RUIf = parcelRequire("3RUIf");


var $d43fb06b643f41fe$export$d34966752335dd47 = [
    (0, $hsSuG.default),
    (0, $k6lHD.default),
    (0, $cWEex.default),
    (0, $3TyYi.default),
    (0, $awnvg.default),
    (0, $fCSsJ.default),
    (0, $diy8B.default),
    (0, $6vxsn.default),
    (0, $3RUIf.default)
];
var $d43fb06b643f41fe$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $eKLRG.popperGenerator)({
    defaultModifiers: $d43fb06b643f41fe$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("eKLRG", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $abda7d84f488d485$export$ed5e13716264f202);

var $eI1Mz = parcelRequire("eI1Mz");

var $lAbUb = parcelRequire("lAbUb");

var $4xSfy = parcelRequire("4xSfy");

var $751Bq = parcelRequire("751Bq");

var $g9CXz = parcelRequire("g9CXz");

var $bpFoa = parcelRequire("bpFoa");

var $6dMyE = parcelRequire("6dMyE");


var $lfdd5 = parcelRequire("lfdd5");
var $abda7d84f488d485$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $abda7d84f488d485$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $abda7d84f488d485$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $abda7d84f488d485$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $abda7d84f488d485$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $lfdd5.isElement)(reference) ? (0, $4xSfy.default)(reference) : reference.contextElement ? (0, $4xSfy.default)(reference.contextElement) : [],
                    popper: (0, $4xSfy.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $g9CXz.default)((0, $6dMyE.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$abda7d84f488d485$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $eI1Mz.default)(reference, (0, $751Bq.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $lAbUb.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bpFoa.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$abda7d84f488d485$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $abda7d84f488d485$export$8f7491d57c8f97a9 = /*#__PURE__*/ $abda7d84f488d485$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("eI1Mz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab568eb018a753e5$export$2e2bcd8739ae039);

var $9MUtA = parcelRequire("9MUtA");

var $bCQHZ = parcelRequire("bCQHZ");

var $76h9R = parcelRequire("76h9R");

var $lfdd5 = parcelRequire("lfdd5");

var $4MIcF = parcelRequire("4MIcF");

var $4IOw3 = parcelRequire("4IOw3");

var $dmCZ5 = parcelRequire("dmCZ5");

var $gfnDs = parcelRequire("gfnDs");
function $ab568eb018a753e5$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $gfnDs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $gfnDs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $ab568eb018a753e5$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $lfdd5.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $lfdd5.isHTMLElement)(offsetParent) && $ab568eb018a753e5$var$isElementScaled(offsetParent);
    var documentElement = (0, $4IOw3.default)(offsetParent);
    var rect = (0, $9MUtA.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $76h9R.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $dmCZ5.default)(documentElement)) scroll = (0, $bCQHZ.default)(offsetParent);
        if ((0, $lfdd5.isHTMLElement)(offsetParent)) {
            offsets = (0, $9MUtA.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $4MIcF.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("9MUtA", function(module, exports) {
$parcel$export(module.exports, "default", () => $720467c1845f47db$export$2e2bcd8739ae039);

var $lfdd5 = parcelRequire("lfdd5");

var $gfnDs = parcelRequire("gfnDs");

var $32Imk = parcelRequire("32Imk");

var $lavgH = parcelRequire("lavgH");
function $720467c1845f47db$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $lfdd5.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $gfnDs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $gfnDs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $lfdd5.isElement)(element) ? (0, $32Imk.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $lavgH.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("lfdd5", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $f7753eeb65e184a7$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $f7753eeb65e184a7$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $f7753eeb65e184a7$export$af51f0f06c0f328a);

var $32Imk = parcelRequire("32Imk");
function $f7753eeb65e184a7$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $32Imk.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f7753eeb65e184a7$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $32Imk.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f7753eeb65e184a7$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $32Imk.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("32Imk", function(module, exports) {
$parcel$export(module.exports, "default", () => $2373f7c7783a73b4$export$2e2bcd8739ae039);
function $2373f7c7783a73b4$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("gfnDs", function(module, exports) {
$parcel$export(module.exports, "max", () => $bd4061934797aea8$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $bd4061934797aea8$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $bd4061934797aea8$export$2077e0241d6afd3c);
var $bd4061934797aea8$export$8960430cfd85939f = Math.max;
var $bd4061934797aea8$export$96ec731ed4dcb222 = Math.min;
var $bd4061934797aea8$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("lavgH", function(module, exports) {
$parcel$export(module.exports, "default", () => $f692c962b7b2a930$export$2e2bcd8739ae039);

var $e57PC = parcelRequire("e57PC");
function $f692c962b7b2a930$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $e57PC.default)());
}

});
parcelRegister("e57PC", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4079b8103175152$export$2e2bcd8739ae039);
function $a4079b8103175152$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("bCQHZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $876c211cc8ade880$export$2e2bcd8739ae039);

var $9rAIL = parcelRequire("9rAIL");

var $32Imk = parcelRequire("32Imk");

var $lfdd5 = parcelRequire("lfdd5");

var $4kSNJ = parcelRequire("4kSNJ");
function $876c211cc8ade880$export$2e2bcd8739ae039(node) {
    if (node === (0, $32Imk.default)(node) || !(0, $lfdd5.isHTMLElement)(node)) return (0, $9rAIL.default)(node);
    else return (0, $4kSNJ.default)(node);
}

});
parcelRegister("9rAIL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e031eb781421b69$export$2e2bcd8739ae039);

var $32Imk = parcelRequire("32Imk");
function $6e031eb781421b69$export$2e2bcd8739ae039(node) {
    var win = (0, $32Imk.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4kSNJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $32838a0991da1aba$export$2e2bcd8739ae039);
function $32838a0991da1aba$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("76h9R", function(module, exports) {
$parcel$export(module.exports, "default", () => $52b667271257345b$export$2e2bcd8739ae039);
function $52b667271257345b$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("4MIcF", function(module, exports) {
$parcel$export(module.exports, "default", () => $37bdeefde708b2c8$export$2e2bcd8739ae039);

var $9MUtA = parcelRequire("9MUtA");

var $4IOw3 = parcelRequire("4IOw3");

var $9rAIL = parcelRequire("9rAIL");
function $37bdeefde708b2c8$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $9MUtA.default)((0, $4IOw3.default)(element)).left + (0, $9rAIL.default)(element).scrollLeft;
}

});
parcelRegister("4IOw3", function(module, exports) {
$parcel$export(module.exports, "default", () => $370274e884656840$export$2e2bcd8739ae039);

var $lfdd5 = parcelRequire("lfdd5");
function $370274e884656840$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $lfdd5.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("dmCZ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bab91e0c101d853$export$2e2bcd8739ae039);

var $jvATp = parcelRequire("jvATp");
function $9bab91e0c101d853$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $jvATp.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("jvATp", function(module, exports) {
$parcel$export(module.exports, "default", () => $e33d87b1103f0b7e$export$2e2bcd8739ae039);

var $32Imk = parcelRequire("32Imk");
function $e33d87b1103f0b7e$export$2e2bcd8739ae039(element) {
    return (0, $32Imk.default)(element).getComputedStyle(element);
}

});



parcelRegister("lAbUb", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb6631e046ef2434$export$2e2bcd8739ae039);

var $9MUtA = parcelRequire("9MUtA");
function $fb6631e046ef2434$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $9MUtA.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("4xSfy", function(module, exports) {
$parcel$export(module.exports, "default", () => $34f4536773a68593$export$2e2bcd8739ae039);

var $kERsF = parcelRequire("kERsF");

var $4BddN = parcelRequire("4BddN");

var $32Imk = parcelRequire("32Imk");

var $dmCZ5 = parcelRequire("dmCZ5");
function $34f4536773a68593$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $kERsF.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $32Imk.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $dmCZ5.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($34f4536773a68593$export$2e2bcd8739ae039((0, $4BddN.default)(target)));
}

});
parcelRegister("kERsF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0a1036041091897$export$2e2bcd8739ae039);

var $4BddN = parcelRequire("4BddN");

var $dmCZ5 = parcelRequire("dmCZ5");

var $76h9R = parcelRequire("76h9R");

var $lfdd5 = parcelRequire("lfdd5");
function $f0a1036041091897$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $76h9R.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $lfdd5.isHTMLElement)(node) && (0, $dmCZ5.default)(node)) return node;
    return $f0a1036041091897$export$2e2bcd8739ae039((0, $4BddN.default)(node));
}

});
parcelRegister("4BddN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3594dfa878fc2870$export$2e2bcd8739ae039);

var $76h9R = parcelRequire("76h9R");

var $4IOw3 = parcelRequire("4IOw3");

var $lfdd5 = parcelRequire("lfdd5");
function $3594dfa878fc2870$export$2e2bcd8739ae039(element) {
    if ((0, $76h9R.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $lfdd5.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4IOw3.default)(element) // fallback
    );
}

});



parcelRegister("751Bq", function(module, exports) {
$parcel$export(module.exports, "default", () => $527a3e4945b1015d$export$2e2bcd8739ae039);

var $32Imk = parcelRequire("32Imk");

var $76h9R = parcelRequire("76h9R");

var $jvATp = parcelRequire("jvATp");

var $lfdd5 = parcelRequire("lfdd5");

var $9rVcX = parcelRequire("9rVcX");

var $4BddN = parcelRequire("4BddN");

var $e57PC = parcelRequire("e57PC");
function $527a3e4945b1015d$var$getTrueOffsetParent(element) {
    if (!(0, $lfdd5.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $jvATp.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $527a3e4945b1015d$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $e57PC.default)());
    var isIE = /Trident/i.test((0, $e57PC.default)());
    if (isIE && (0, $lfdd5.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $jvATp.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $4BddN.default)(element);
    if ((0, $lfdd5.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $lfdd5.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $76h9R.default)(currentNode)) < 0){
        var css = (0, $jvATp.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $527a3e4945b1015d$export$2e2bcd8739ae039(element) {
    var window = (0, $32Imk.default)(element);
    var offsetParent = $527a3e4945b1015d$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $9rVcX.default)(offsetParent) && (0, $jvATp.default)(offsetParent).position === 'static')offsetParent = $527a3e4945b1015d$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $76h9R.default)(offsetParent) === 'html' || (0, $76h9R.default)(offsetParent) === 'body' && (0, $jvATp.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $527a3e4945b1015d$var$getContainingBlock(element) || window;
}

});
parcelRegister("9rVcX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e1302fe9a507860$export$2e2bcd8739ae039);

var $76h9R = parcelRequire("76h9R");
function $6e1302fe9a507860$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $76h9R.default)(element)) >= 0;
}

});


parcelRegister("g9CXz", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc2bb5355ebd88a5$export$2e2bcd8739ae039);

var $km0jK = parcelRequire("km0jK");
function $bc2bb5355ebd88a5$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $bc2bb5355ebd88a5$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $bc2bb5355ebd88a5$var$order(modifiers); // order based on phase
    return (0, $km0jK.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("km0jK", function(module, exports) {
$parcel$export(module.exports, "top", () => $ed161bc082c838a0$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $ed161bc082c838a0$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $ed161bc082c838a0$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $ed161bc082c838a0$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $ed161bc082c838a0$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $ed161bc082c838a0$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $ed161bc082c838a0$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $ed161bc082c838a0$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $ed161bc082c838a0$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $ed161bc082c838a0$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $ed161bc082c838a0$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $ed161bc082c838a0$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $ed161bc082c838a0$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $ed161bc082c838a0$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $ed161bc082c838a0$export$d087d3878fdf71d5);
var $ed161bc082c838a0$export$1e95b668f3b82d = 'top';
var $ed161bc082c838a0$export$40e543e69a8b3fbb = 'bottom';
var $ed161bc082c838a0$export$79ffe56a765070d2 = 'right';
var $ed161bc082c838a0$export$eabcd2c8791e7bf4 = 'left';
var $ed161bc082c838a0$export$dfb5619354ba860 = 'auto';
var $ed161bc082c838a0$export$aec2ce47c367b8c3 = [
    $ed161bc082c838a0$export$1e95b668f3b82d,
    $ed161bc082c838a0$export$40e543e69a8b3fbb,
    $ed161bc082c838a0$export$79ffe56a765070d2,
    $ed161bc082c838a0$export$eabcd2c8791e7bf4
];
var $ed161bc082c838a0$export$b3571188c770cc5a = 'start';
var $ed161bc082c838a0$export$bd5df0f255a350f8 = 'end';
var $ed161bc082c838a0$export$390fd549c5303b4d = 'clippingParents';
var $ed161bc082c838a0$export$d7b7311ec04a3e8f = 'viewport';
var $ed161bc082c838a0$export$ae5ab1c730825774 = 'popper';
var $ed161bc082c838a0$export$ca50aac9f3ba507f = 'reference';
var $ed161bc082c838a0$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ed161bc082c838a0$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ed161bc082c838a0$export$b3571188c770cc5a,
        placement + "-" + $ed161bc082c838a0$export$bd5df0f255a350f8
    ]);
}, []);
var $ed161bc082c838a0$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ed161bc082c838a0$export$aec2ce47c367b8c3, [
    $ed161bc082c838a0$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ed161bc082c838a0$export$b3571188c770cc5a,
        placement + "-" + $ed161bc082c838a0$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ed161bc082c838a0$export$421679a7c3d56e = 'beforeRead';
var $ed161bc082c838a0$export$aafa59e2e03f2942 = 'read';
var $ed161bc082c838a0$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $ed161bc082c838a0$export$c65e99957a05207c = 'beforeMain';
var $ed161bc082c838a0$export$f22da7240b7add18 = 'main';
var $ed161bc082c838a0$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ed161bc082c838a0$export$8d4d2d70e7d46032 = 'beforeWrite';
var $ed161bc082c838a0$export$68d8715fc104d294 = 'write';
var $ed161bc082c838a0$export$70a6e5159acce2e6 = 'afterWrite';
var $ed161bc082c838a0$export$d087d3878fdf71d5 = [
    $ed161bc082c838a0$export$421679a7c3d56e,
    $ed161bc082c838a0$export$aafa59e2e03f2942,
    $ed161bc082c838a0$export$6964f6c886723980,
    $ed161bc082c838a0$export$c65e99957a05207c,
    $ed161bc082c838a0$export$f22da7240b7add18,
    $ed161bc082c838a0$export$bab79516f2d662fe,
    $ed161bc082c838a0$export$8d4d2d70e7d46032,
    $ed161bc082c838a0$export$68d8715fc104d294,
    $ed161bc082c838a0$export$70a6e5159acce2e6
];

});


parcelRegister("bpFoa", function(module, exports) {
$parcel$export(module.exports, "default", () => $84f2227c6f589d7d$export$2e2bcd8739ae039);
function $84f2227c6f589d7d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("6dMyE", function(module, exports) {
$parcel$export(module.exports, "default", () => $48799f8cdde3cffe$export$2e2bcd8739ae039);
function $48799f8cdde3cffe$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hsSuG", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb6f528aea1296ac$export$2e2bcd8739ae039);

var $32Imk = parcelRequire("32Imk");
var $cb6f528aea1296ac$var$passive = {
    passive: true
};
function $cb6f528aea1296ac$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $32Imk.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cb6f528aea1296ac$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cb6f528aea1296ac$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cb6f528aea1296ac$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cb6f528aea1296ac$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cb6f528aea1296ac$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cb6f528aea1296ac$var$effect,
    data: {}
};

});

parcelRegister("k6lHD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea2533e2cc11eca2$export$2e2bcd8739ae039);

var $9veCL = parcelRequire("9veCL");
function $ea2533e2cc11eca2$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9veCL.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ea2533e2cc11eca2$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ea2533e2cc11eca2$var$popperOffsets,
    data: {}
};

});
parcelRegister("9veCL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6eb25a654a22d23b$export$2e2bcd8739ae039);

var $jl9AR = parcelRequire("jl9AR");

var $lPJpz = parcelRequire("lPJpz");

var $5EQQL = parcelRequire("5EQQL");

var $km0jK = parcelRequire("km0jK");
function $6eb25a654a22d23b$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $jl9AR.default)(placement) : null;
    var variation = placement ? (0, $lPJpz.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $km0jK.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $km0jK.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $km0jK.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $km0jK.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $5EQQL.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $km0jK.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $km0jK.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("jl9AR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1476b94cd3ead14$export$2e2bcd8739ae039);

function $e1476b94cd3ead14$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("lPJpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe519624b47d0f26$export$2e2bcd8739ae039);
function $fe519624b47d0f26$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("5EQQL", function(module, exports) {
$parcel$export(module.exports, "default", () => $41e9af15243fe2a2$export$2e2bcd8739ae039);
function $41e9af15243fe2a2$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("cWEex", function(module, exports) {
$parcel$export(module.exports, "default", () => $96ca1c565de2cb47$export$2e2bcd8739ae039);

var $km0jK = parcelRequire("km0jK");

var $751Bq = parcelRequire("751Bq");

var $32Imk = parcelRequire("32Imk");

var $4IOw3 = parcelRequire("4IOw3");

var $jvATp = parcelRequire("jvATp");

var $jl9AR = parcelRequire("jl9AR");

var $lPJpz = parcelRequire("lPJpz");

var $gfnDs = parcelRequire("gfnDs");
var $96ca1c565de2cb47$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $96ca1c565de2cb47$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $gfnDs.round)(x * dpr) / dpr || 0,
        y: (0, $gfnDs.round)(y * dpr) / dpr || 0
    };
}
function $96ca1c565de2cb47$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $km0jK.left);
    var sideY = (0, $km0jK.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $751Bq.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $32Imk.default)(popper)) {
            offsetParent = (0, $4IOw3.default)(popper);
            if ((0, $jvATp.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $km0jK.top) || (placement === (0, $km0jK.left) || placement === (0, $km0jK.right)) && variation === (0, $km0jK.end)) {
            sideY = (0, $km0jK.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $km0jK.left) || (placement === (0, $km0jK.top) || placement === (0, $km0jK.bottom)) && variation === (0, $km0jK.end)) {
            sideX = (0, $km0jK.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $96ca1c565de2cb47$var$unsetSides);
    var _ref4 = roundOffsets === true ? $96ca1c565de2cb47$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $32Imk.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $96ca1c565de2cb47$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $jl9AR.default)(state.placement),
        variation: (0, $lPJpz.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $96ca1c565de2cb47$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $96ca1c565de2cb47$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $96ca1c565de2cb47$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $96ca1c565de2cb47$var$computeStyles,
    data: {}
};

});

parcelRegister("3TyYi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d61a2c6bee1d06f$export$2e2bcd8739ae039);

var $76h9R = parcelRequire("76h9R");

var $lfdd5 = parcelRequire("lfdd5");
// and applies them to the HTMLElements such as popper and arrow
function $2d61a2c6bee1d06f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $lfdd5.isHTMLElement)(element) || !(0, $76h9R.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $2d61a2c6bee1d06f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $lfdd5.isHTMLElement)(element) || !(0, $76h9R.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $2d61a2c6bee1d06f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $2d61a2c6bee1d06f$var$applyStyles,
    effect: $2d61a2c6bee1d06f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("awnvg", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a8f1fc82c0636ae$export$2e2bcd8739ae039);

var $jl9AR = parcelRequire("jl9AR");

var $km0jK = parcelRequire("km0jK");
function $7a8f1fc82c0636ae$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $jl9AR.default)(placement);
    var invertDistance = [
        (0, $km0jK.left),
        (0, $km0jK.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $km0jK.left),
        (0, $km0jK.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7a8f1fc82c0636ae$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $km0jK.placements).reduce(function(acc, placement) {
        acc[placement] = $7a8f1fc82c0636ae$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7a8f1fc82c0636ae$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $7a8f1fc82c0636ae$var$offset
};

});

parcelRegister("fCSsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b604a6bf3d444823$export$2e2bcd8739ae039);

var $cvMKk = parcelRequire("cvMKk");

var $jl9AR = parcelRequire("jl9AR");

var $2Qcu4 = parcelRequire("2Qcu4");

var $a0pYS = parcelRequire("a0pYS");

var $8sPZA = parcelRequire("8sPZA");

var $km0jK = parcelRequire("km0jK");

var $lPJpz = parcelRequire("lPJpz");
function $b604a6bf3d444823$var$getExpandedFallbackPlacements(placement) {
    if ((0, $jl9AR.default)(placement) === (0, $km0jK.auto)) return [];
    var oppositePlacement = (0, $cvMKk.default)(placement);
    return [
        (0, $2Qcu4.default)(placement),
        oppositePlacement,
        (0, $2Qcu4.default)(oppositePlacement)
    ];
}
function $b604a6bf3d444823$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $jl9AR.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $cvMKk.default)(preferredPlacement)
    ] : $b604a6bf3d444823$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $jl9AR.default)(placement) === (0, $km0jK.auto) ? (0, $8sPZA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $jl9AR.default)(placement);
        var isStartVariation = (0, $lPJpz.default)(placement) === (0, $km0jK.start);
        var isVertical = [
            (0, $km0jK.top),
            (0, $km0jK.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $a0pYS.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $km0jK.right) : (0, $km0jK.left) : isStartVariation ? (0, $km0jK.bottom) : (0, $km0jK.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $cvMKk.default)(mainVariationSide);
        var altVariationSide = (0, $cvMKk.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b604a6bf3d444823$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b604a6bf3d444823$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("cvMKk", function(module, exports) {
$parcel$export(module.exports, "default", () => $91be3147f206e86a$export$2e2bcd8739ae039);
var $91be3147f206e86a$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $91be3147f206e86a$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $91be3147f206e86a$var$hash[matched];
    });
}

});

parcelRegister("2Qcu4", function(module, exports) {
$parcel$export(module.exports, "default", () => $211a1f305c10cd21$export$2e2bcd8739ae039);
var $211a1f305c10cd21$var$hash = {
    start: 'end',
    end: 'start'
};
function $211a1f305c10cd21$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $211a1f305c10cd21$var$hash[matched];
    });
}

});

parcelRegister("a0pYS", function(module, exports) {
$parcel$export(module.exports, "default", () => $748e0eb88af1f252$export$2e2bcd8739ae039);

var $jqtRI = parcelRequire("jqtRI");

var $4IOw3 = parcelRequire("4IOw3");

var $9MUtA = parcelRequire("9MUtA");

var $9veCL = parcelRequire("9veCL");

var $jxURd = parcelRequire("jxURd");

var $km0jK = parcelRequire("km0jK");

var $lfdd5 = parcelRequire("lfdd5");

var $71OUS = parcelRequire("71OUS");

var $kXPvI = parcelRequire("kXPvI");
function $748e0eb88af1f252$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $km0jK.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $km0jK.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $km0jK.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $71OUS.default)(typeof padding !== 'number' ? padding : (0, $kXPvI.default)(padding, (0, $km0jK.basePlacements)));
    var altContext = elementContext === (0, $km0jK.popper) ? (0, $km0jK.reference) : (0, $km0jK.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $jqtRI.default)((0, $lfdd5.isElement)(element) ? element : element.contextElement || (0, $4IOw3.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $9MUtA.default)(state.elements.reference);
    var popperOffsets = (0, $9veCL.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $jxURd.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $km0jK.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $km0jK.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $km0jK.right),
                (0, $km0jK.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $km0jK.top),
                (0, $km0jK.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("jqtRI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2479caeb22f5abb$export$2e2bcd8739ae039);

var $km0jK = parcelRequire("km0jK");

var $bjjno = parcelRequire("bjjno");

var $k24QG = parcelRequire("k24QG");

var $4xSfy = parcelRequire("4xSfy");

var $751Bq = parcelRequire("751Bq");

var $4IOw3 = parcelRequire("4IOw3");

var $jvATp = parcelRequire("jvATp");

var $lfdd5 = parcelRequire("lfdd5");

var $9MUtA = parcelRequire("9MUtA");

var $4BddN = parcelRequire("4BddN");

var $864K9 = parcelRequire("864K9");

var $76h9R = parcelRequire("76h9R");

var $jxURd = parcelRequire("jxURd");

var $gfnDs = parcelRequire("gfnDs");
function $e2479caeb22f5abb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $9MUtA.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $e2479caeb22f5abb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $km0jK.viewport) ? (0, $jxURd.default)((0, $bjjno.default)(element, strategy)) : (0, $lfdd5.isElement)(clippingParent) ? $e2479caeb22f5abb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $jxURd.default)((0, $k24QG.default)((0, $4IOw3.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $e2479caeb22f5abb$var$getClippingParents(element) {
    var clippingParents = (0, $4xSfy.default)((0, $4BddN.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $jvATp.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $lfdd5.isHTMLElement)(element) ? (0, $751Bq.default)(element) : element;
    if (!(0, $lfdd5.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $lfdd5.isElement)(clippingParent) && (0, $864K9.default)(clippingParent, clipperElement) && (0, $76h9R.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $e2479caeb22f5abb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $e2479caeb22f5abb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $e2479caeb22f5abb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $gfnDs.max)(rect.top, accRect.top);
        accRect.right = (0, $gfnDs.min)(rect.right, accRect.right);
        accRect.bottom = (0, $gfnDs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $gfnDs.max)(rect.left, accRect.left);
        return accRect;
    }, $e2479caeb22f5abb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("bjjno", function(module, exports) {
$parcel$export(module.exports, "default", () => $83c07fc4fe4d9a64$export$2e2bcd8739ae039);

var $32Imk = parcelRequire("32Imk");

var $4IOw3 = parcelRequire("4IOw3");

var $4MIcF = parcelRequire("4MIcF");

var $lavgH = parcelRequire("lavgH");
function $83c07fc4fe4d9a64$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $32Imk.default)(element);
    var html = (0, $4IOw3.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $lavgH.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $4MIcF.default)(element),
        y: y
    };
}

});

parcelRegister("k24QG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e957c16de8485f14$export$2e2bcd8739ae039);

var $4IOw3 = parcelRequire("4IOw3");

var $jvATp = parcelRequire("jvATp");

var $4MIcF = parcelRequire("4MIcF");

var $9rAIL = parcelRequire("9rAIL");

var $gfnDs = parcelRequire("gfnDs");
function $e957c16de8485f14$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4IOw3.default)(element);
    var winScroll = (0, $9rAIL.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $gfnDs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $gfnDs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $4MIcF.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $jvATp.default)(body || html).direction === 'rtl') x += (0, $gfnDs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("864K9", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e52902d5b26f1e7$export$2e2bcd8739ae039);

var $lfdd5 = parcelRequire("lfdd5");
function $5e52902d5b26f1e7$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $lfdd5.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("jxURd", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3ad3410a6848478$export$2e2bcd8739ae039);
function $e3ad3410a6848478$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("71OUS", function(module, exports) {
$parcel$export(module.exports, "default", () => $51e01f500e1d3ea2$export$2e2bcd8739ae039);

var $3SdXy = parcelRequire("3SdXy");
function $51e01f500e1d3ea2$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $3SdXy.default)(), paddingObject);
}

});
parcelRegister("3SdXy", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d213e4d563db69d$export$2e2bcd8739ae039);
function $2d213e4d563db69d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("kXPvI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f431464821f60b4f$export$2e2bcd8739ae039);
function $f431464821f60b4f$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("8sPZA", function(module, exports) {
$parcel$export(module.exports, "default", () => $629944dedda532b1$export$2e2bcd8739ae039);

var $lPJpz = parcelRequire("lPJpz");

var $km0jK = parcelRequire("km0jK");

var $a0pYS = parcelRequire("a0pYS");

var $jl9AR = parcelRequire("jl9AR");
function $629944dedda532b1$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $km0jK.placements) : _options$allowedAutoP;
    var variation = (0, $lPJpz.default)(placement);
    var placements = variation ? flipVariations ? (0, $km0jK.variationPlacements) : (0, $km0jK.variationPlacements).filter(function(placement) {
        return (0, $lPJpz.default)(placement) === variation;
    }) : (0, $km0jK.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $a0pYS.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $jl9AR.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("diy8B", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ae76fdb81fef2fc$export$2e2bcd8739ae039);

var $km0jK = parcelRequire("km0jK");

var $jl9AR = parcelRequire("jl9AR");

var $5EQQL = parcelRequire("5EQQL");

var $bxqtD = parcelRequire("bxqtD");

var $hO2Bz = parcelRequire("hO2Bz");

var $lAbUb = parcelRequire("lAbUb");

var $751Bq = parcelRequire("751Bq");

var $a0pYS = parcelRequire("a0pYS");

var $lPJpz = parcelRequire("lPJpz");

var $3SdXy = parcelRequire("3SdXy");

var $gfnDs = parcelRequire("gfnDs");
function $9ae76fdb81fef2fc$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $a0pYS.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $jl9AR.default)(state.placement);
    var variation = (0, $lPJpz.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $5EQQL.default)(basePlacement);
    var altAxis = (0, $bxqtD.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $km0jK.top) : (0, $km0jK.left);
        var altSide = mainAxis === 'y' ? (0, $km0jK.bottom) : (0, $km0jK.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $km0jK.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $km0jK.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $lAbUb.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $3SdXy.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $hO2Bz.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $751Bq.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $hO2Bz.within)(tether ? (0, $gfnDs.min)(min, tetherMin) : min, offset, tether ? (0, $gfnDs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $km0jK.top) : (0, $km0jK.left);
        var _altSide = mainAxis === 'x' ? (0, $km0jK.bottom) : (0, $km0jK.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $km0jK.top),
            (0, $km0jK.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $hO2Bz.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $hO2Bz.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9ae76fdb81fef2fc$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9ae76fdb81fef2fc$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("bxqtD", function(module, exports) {
$parcel$export(module.exports, "default", () => $86675087777e01a0$export$2e2bcd8739ae039);
function $86675087777e01a0$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("hO2Bz", function(module, exports) {
$parcel$export(module.exports, "within", () => $cf692077434ee910$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $cf692077434ee910$export$86c8af6d3ef0b4a);

var $gfnDs = parcelRequire("gfnDs");
function $cf692077434ee910$export$f28d906d67a997f3(min, value, max) {
    return (0, $gfnDs.max)(min, (0, $gfnDs.min)(value, max));
}
function $cf692077434ee910$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $cf692077434ee910$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("6vxsn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bcf9722ffeb3bcd$export$2e2bcd8739ae039);

var $jl9AR = parcelRequire("jl9AR");

var $lAbUb = parcelRequire("lAbUb");

var $864K9 = parcelRequire("864K9");

var $751Bq = parcelRequire("751Bq");

var $5EQQL = parcelRequire("5EQQL");

var $hO2Bz = parcelRequire("hO2Bz");

var $71OUS = parcelRequire("71OUS");

var $kXPvI = parcelRequire("kXPvI");

var $km0jK = parcelRequire("km0jK");
var $4bcf9722ffeb3bcd$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $71OUS.default)(typeof padding !== 'number' ? padding : (0, $kXPvI.default)(padding, (0, $km0jK.basePlacements)));
};
function $4bcf9722ffeb3bcd$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $jl9AR.default)(state.placement);
    var axis = (0, $5EQQL.default)(basePlacement);
    var isVertical = [
        (0, $km0jK.left),
        (0, $km0jK.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $4bcf9722ffeb3bcd$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $lAbUb.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $km0jK.top) : (0, $km0jK.left);
    var maxProp = axis === 'y' ? (0, $km0jK.bottom) : (0, $km0jK.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $751Bq.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $hO2Bz.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $4bcf9722ffeb3bcd$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $864K9.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $4bcf9722ffeb3bcd$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $4bcf9722ffeb3bcd$var$arrow,
    effect: $4bcf9722ffeb3bcd$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("3RUIf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d125045e88edbd6$export$2e2bcd8739ae039);

var $km0jK = parcelRequire("km0jK");

var $a0pYS = parcelRequire("a0pYS");
function $2d125045e88edbd6$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $2d125045e88edbd6$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $km0jK.top),
        (0, $km0jK.right),
        (0, $km0jK.bottom),
        (0, $km0jK.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $2d125045e88edbd6$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $a0pYS.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $a0pYS.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $2d125045e88edbd6$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $2d125045e88edbd6$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $2d125045e88edbd6$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $2d125045e88edbd6$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $2d125045e88edbd6$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $2d125045e88edbd6$var$hide
};

});


parcelRegister("8DF3i", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $64a1cf58e51724d3$var$hasElementType = typeof Element !== 'undefined';
var $64a1cf58e51724d3$var$hasMap = typeof Map === 'function';
var $64a1cf58e51724d3$var$hasSet = typeof Set === 'function';
var $64a1cf58e51724d3$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $64a1cf58e51724d3$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$64a1cf58e51724d3$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($64a1cf58e51724d3$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$64a1cf58e51724d3$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($64a1cf58e51724d3$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($64a1cf58e51724d3$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($64a1cf58e51724d3$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$64a1cf58e51724d3$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $64a1cf58e51724d3$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("6LwKw", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $a47807d7cdb461d7$export$6d8c2b45c99d6e3f);
function $a47807d7cdb461d7$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                var _data$viewport, _data$viewport2, _state$modifiersData;
                const data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = ((_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});


parcelRegister("1NJBM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f20b5d6f5e822b5d$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $4HQIN = parcelRequire("4HQIN");

var $ew9tC = parcelRequire("ew9tC");

var $1FThT = parcelRequire("1FThT");

var $i5jdY = parcelRequire("i5jdY");
function $f20b5d6f5e822b5d$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect', isClosed: isClosed = false }) {
    const isSubsequentRender = (0, $1FThT.default)(mountStrategy);
    (0, $i5jdY.default)(zIndex);
    return !(0, $e6Qdr.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4HQIN.default), {
        zIndex: zIndex,
        isClosed: isClosed,
        children: children
    }) : null : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ew9tC.default), {
        zIndex: zIndex,
        isClosed: isClosed,
        children: children
    });
}

});
parcelRegister("4HQIN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6109b3090cb659a9$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");

var $5x7GG = parcelRequire("5x7GG");
var $g7crg = parcelRequire("g7crg");

var $e6Qdr = parcelRequire("e6Qdr");

var $b25oG = parcelRequire("b25oG");

var $fqNLx = parcelRequire("fqNLx");

var $3v1KW = parcelRequire("3v1KW");
function $6109b3090cb659a9$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children, isClosed: isClosed = false } = props;
    const container = (0, $8P7DW.useMemo)(()=>(0, $fqNLx.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $g7crg.useColorMode)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $b25oG.appendPortalContainerIfNotAppended)(container);
    (0, $8P7DW.useEffect)(()=>{
        if ((0, $e6Qdr.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $3v1KW.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $8P7DW.useEffect)(()=>{
        return ()=>{
            (0, $3v1KW.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $6Q1OD.createPortal)(colorMode ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $5x7GG.default), {
        defaultColorMode: colorMode,
        children: children
    }) : children, container);
}

});
parcelRegister("5x7GG", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b34adfd388d27b4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $dPQrY = parcelRequire("dPQrY");
var $8hYHC = parcelRequire("8hYHC");
var $bTvke = parcelRequire("bTvke");

var $9qiZO = parcelRequire("9qiZO");

var $34wXk = parcelRequire("34wXk");

var $2keJG = parcelRequire("2keJG");

var $f0oQn = parcelRequire("f0oQn");

var $c9J3S = parcelRequire("c9J3S");

var $6KVyT = parcelRequire("6KVyT");
const $7b34adfd388d27b4$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
const $7b34adfd388d27b4$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $7b34adfd388d27b4$var$prefersDarkModeMql = $7b34adfd388d27b4$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $7b34adfd388d27b4$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $7b34adfd388d27b4$var$prefersDarkModeMql !== null && $7b34adfd388d27b4$var$prefersDarkModeMql !== void 0 && $7b34adfd388d27b4$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
const $7b34adfd388d27b4$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $7b34adfd388d27b4$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $8P7DW.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $8P7DW.useState)($7b34adfd388d27b4$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $8P7DW.useState)(()=>({
            ...$7b34adfd388d27b4$var$defaultThemeSettings,
            ...defaultTheme
        }));
    const setColorMode = (0, $8P7DW.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($7b34adfd388d27b4$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $8P7DW.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $8P7DW.useRef)(null);
    const isInsideAppProvider = (0, $9qiZO.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $9qiZO.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $c9J3S.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $8P7DW.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $8hYHC.default)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $6KVyT.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (!$7b34adfd388d27b4$var$prefersDarkModeMql) return;
        const unbindListener = (0, $36kyW.bind)($7b34adfd388d27b4$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $dPQrY.default)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $bTvke.SUBTREE_THEME_ATTRIBUTE)]: true
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2keJG.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $34wXk.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $34wXk.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $f0oQn.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $f0oQn.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                            ...attrs,
                            className: (0, $8n1kL.default)([
                                $7b34adfd388d27b4$var$contentStyles.body
                            ]),
                            children: children
                        }) : children
                    })
                })
            })
        })
    });
}
var $7b34adfd388d27b4$export$2e2bcd8739ae039 = $7b34adfd388d27b4$var$ThemeProvider;

});
parcelRegister("dPQrY", function(module, exports) {
$parcel$export(module.exports, "default", () => $da20da5cffb710a2$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $bTvke = parcelRequire("bTvke");

var $4dNaw = parcelRequire("4dNaw");

var $kLJeV = parcelRequire("kLJeV");

var $8svlf = parcelRequire("8svlf");

var $gzeMu = parcelRequire("gzeMu");
const $da20da5cffb710a2$var$defaultColorMode = 'light';
const $da20da5cffb710a2$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $da20da5cffb710a2$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $4dNaw.themeStateDefaults)['colorMode'], dark: dark = (0, $4dNaw.themeStateDefaults)['dark'], light: light = (0, $4dNaw.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $4dNaw.themeStateDefaults)['contrastMode'], motion: motion = (0, $4dNaw.themeStateDefaults)['motion'](), shape: shape = (0, $4dNaw.themeStateDefaults)['shape'](), spacing: spacing = (0, $4dNaw.themeStateDefaults)['spacing'], typography: typography = (0, $4dNaw.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $4dNaw.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $kLJeV.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $bTvke.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $bTvke.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $da20da5cffb710a2$var$defaultColorMode : colorMode
    };
    if ((0, $e6Qdr.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $bTvke.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $da20da5cffb710a2$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $8svlf.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $gzeMu.hash)(optionString);
        result[0, $bTvke.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $da20da5cffb710a2$export$2e2bcd8739ae039 = $da20da5cffb710a2$var$getThemeHtmlAttrs;

});
parcelRegister("4dNaw", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $02830543c72dc6c4$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $02830543c72dc6c4$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $02830543c72dc6c4$export$92ba366331403db2);
$parcel$export(module.exports, "themeStateDefaults", () => $02830543c72dc6c4$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $02830543c72dc6c4$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");
const $02830543c72dc6c4$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ const $02830543c72dc6c4$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $02830543c72dc6c4$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $02830543c72dc6c4$var$themeOverrideIds = [];
const $02830543c72dc6c4$export$92ba366331403db2 = [
    ...$02830543c72dc6c4$export$7d43e72a58e3283f,
    ...$02830543c72dc6c4$var$themeOverrideIds
];
const $02830543c72dc6c4$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
function $02830543c72dc6c4$var$getShapeDefault() {
    if ((0, $e6Qdr.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $02830543c72dc6c4$var$getMotionDefault() {
    if ((0, $e6Qdr.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
const $02830543c72dc6c4$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $02830543c72dc6c4$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $02830543c72dc6c4$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};
var $02830543c72dc6c4$export$2e2bcd8739ae039 = $02830543c72dc6c4$var$themeConfig;

});

parcelRegister("kLJeV", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $6ad5557664d976ee$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $6ad5557664d976ee$export$62c37ab81302621a);

var $4dNaw = parcelRequire("4dNaw");
const $6ad5557664d976ee$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $6ad5557664d976ee$var$customThemeOptions = 'UNSAFE_themeOptions';
const $6ad5557664d976ee$var$isThemeKind = (themeKind)=>{
    return $6ad5557664d976ee$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $6ad5557664d976ee$var$isThemeIds = (themeId)=>{
    return (0, $4dNaw.themeIds).find((id)=>id === themeId) !== undefined;
};
const $6ad5557664d976ee$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $6ad5557664d976ee$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $6ad5557664d976ee$var$isColorMode(id)) themeObject[kind] = id;
        if ($6ad5557664d976ee$var$isThemeKind(kind) && $6ad5557664d976ee$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $6ad5557664d976ee$var$customThemeOptions) try {
            themeObject[$6ad5557664d976ee$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $6ad5557664d976ee$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $6ad5557664d976ee$var$isColorMode(id) || // custom theme state
        kind === $6ad5557664d976ee$var$customThemeOptions && typeof id === 'object' || // other theme states
        $6ad5557664d976ee$var$isThemeKind(kind) && typeof id === 'string' && $6ad5557664d976ee$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});

parcelRegister("8svlf", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $b0fafdeb933ecbbd$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $b0fafdeb933ecbbd$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $b0fafdeb933ecbbd$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $b0fafdeb933ecbbd$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $b0fafdeb933ecbbd$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $b0fafdeb933ecbbd$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $b0fafdeb933ecbbd$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $b0fafdeb933ecbbd$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $b0fafdeb933ecbbd$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $b0fafdeb933ecbbd$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $b0fafdeb933ecbbd$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $b0fafdeb933ecbbd$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $b0fafdeb933ecbbd$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $b0fafdeb933ecbbd$export$b36dbdb4f463f05c(hex) {
    if (!$b0fafdeb933ecbbd$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $b0fafdeb933ecbbd$export$1212645cf40ebf71(hex)
    ];
}
function $b0fafdeb933ecbbd$export$5a544e13ad4e1fa5(hex) {
    if (!$b0fafdeb933ecbbd$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $b0fafdeb933ecbbd$export$47ea145a83f50dc0(hex) {
    if (!$b0fafdeb933ecbbd$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $b0fafdeb933ecbbd$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $b0fafdeb933ecbbd$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $b0fafdeb933ecbbd$export$d061e26956a60b0a(foreground, background) {
    if (!$b0fafdeb933ecbbd$var$isValidHex(foreground) || !$b0fafdeb933ecbbd$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $b0fafdeb933ecbbd$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $b0fafdeb933ecbbd$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $b0fafdeb933ecbbd$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $b0fafdeb933ecbbd$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $b0fafdeb933ecbbd$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $b0fafdeb933ecbbd$var$rgbToLab(rgbA);
    let labB = $b0fafdeb933ecbbd$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $b0fafdeb933ecbbd$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("gzeMu", function(module, exports) {
$parcel$export(module.exports, "hash", () => $c679a92c93013ebc$export$d6af199866bfb566);
const $c679a92c93013ebc$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("8hYHC", function(module, exports) {
$parcel$export(module.exports, "default", () => $60666b263668aaa6$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $l5njV = parcelRequire("l5njV");

var $4dNaw = parcelRequire("4dNaw");

var $8svlf = parcelRequire("8svlf");

var $OOHzs = parcelRequire("OOHzs");

var $5DMjK = parcelRequire("5DMjK");

var $6X8MD = parcelRequire("6X8MD");

var $9yGPt = parcelRequire("9yGPt");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $60666b263668aaa6$var$setGlobalTheme = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $4dNaw.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $4dNaw.themeStateDefaults)['contrastMode'], dark: dark = (0, $4dNaw.themeStateDefaults)['dark'], light: light = (0, $4dNaw.themeStateDefaults)['light'], shape: shape = (0, $4dNaw.themeStateDefaults)['shape'](), spacing: spacing = (0, $4dNaw.themeStateDefaults)['spacing'], typography: typography = (0, $4dNaw.themeStateDefaults)['typography'], motion: motion = (0, $4dNaw.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $4dNaw.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $4dNaw.themeStateDefaults),
        typography: (0, $4dNaw.themeStateDefaults)['typography'],
        shape: (0, $4dNaw.themeStateDefaults)['shape'](),
        motion: (0, $4dNaw.themeStateDefaults)['motion'](),
        ...(0, $l5njV.default)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $e6Qdr.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $6X8MD.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $9yGPt.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $8svlf.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
        const mode = colorMode || (0, $4dNaw.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $5DMjK.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("lgSDe"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $6X8MD.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $OOHzs.default)(themeState);
    return autoUnbind;
};
var $60666b263668aaa6$export$2e2bcd8739ae039 = $60666b263668aaa6$var$setGlobalTheme;

});
parcelRegister("l5njV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7eadb676b7b8d630$export$2e2bcd8739ae039);

var $bTvke = parcelRequire("bTvke");

var $4dNaw = parcelRequire("4dNaw");

var $kLJeV = parcelRequire("kLJeV");
const $7eadb676b7b8d630$var$isThemeColorMode = (colorMode)=>{
    return (0, $4dNaw.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $7eadb676b7b8d630$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $bTvke.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $bTvke.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $kLJeV.themeStringToObject)(theme),
        ...$7eadb676b7b8d630$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $7eadb676b7b8d630$export$2e2bcd8739ae039 = $7eadb676b7b8d630$var$getGlobalTheme;

});

parcelRegister("OOHzs", function(module, exports) {
$parcel$export(module.exports, "default", () => $da9355db35cfa7d0$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $dPQrY = parcelRequire("dPQrY");

var $efOQC = parcelRequire("efOQC");

var $56sKU = parcelRequire("56sKU");
function $da9355db35cfa7d0$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $efOQC.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $efOQC.default).bind();
    } else (0, $efOQC.default).unbind();
    if ((0, $e6Qdr.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $56sKU.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $56sKU.default).bind();
        } else (0, $56sKU.default).unbind();
    }
    const themeAttributes = (0, $dPQrY.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $efOQC.default).unbind();
        if ((0, $e6Qdr.fg)('platform_increased-contrast-themes')) (0, $56sKU.default).unbind();
    };
}

});
parcelRegister("efOQC", function(module, exports) {
$parcel$export(module.exports, "default", () => $b98f054a96ced7e0$export$2e2bcd8739ae039);

var $36kyW = parcelRequire("36kyW");

var $bTvke = parcelRequire("bTvke");

var $9yGPt = parcelRequire("9yGPt");
const $b98f054a96ced7e0$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $b98f054a96ced7e0$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $bTvke.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $b98f054a96ced7e0$var$darkModeMql = $b98f054a96ced7e0$var$isMatchMediaAvailable && window.matchMedia((0, $9yGPt.darkModeMediaQuery));
class $b98f054a96ced7e0$var$ColorModeObserver {
    getColorMode() {
        if (!$b98f054a96ced7e0$var$darkModeMql) return 'light';
        return $b98f054a96ced7e0$var$darkModeMql !== null && $b98f054a96ced7e0$var$darkModeMql !== void 0 && $b98f054a96ced7e0$var$darkModeMql.matches ? 'dark' : 'light';
    }
    bind() {
        if ($b98f054a96ced7e0$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $36kyW.bind)($b98f054a96ced7e0$var$darkModeMql, {
            type: 'change',
            listener: $b98f054a96ced7e0$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $b98f054a96ced7e0$var$SingletonColorModeObserver = new $b98f054a96ced7e0$var$ColorModeObserver();
var $b98f054a96ced7e0$export$2e2bcd8739ae039 = $b98f054a96ced7e0$var$SingletonColorModeObserver;

});
parcelRegister("9yGPt", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $16ed0efa55daa74b$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "loadThemeCss", () => $16ed0efa55daa74b$export$8a48286ed7df6720);
$parcel$export(module.exports, "darkModeMediaQuery", () => $16ed0efa55daa74b$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $16ed0efa55daa74b$export$8662df6937d86fcb);

var $h9vMN = parcelRequire("h9vMN");

var $bTvke = parcelRequire("bTvke");
const $16ed0efa55daa74b$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $bTvke.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $bTvke.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $16ed0efa55daa74b$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $16ed0efa55daa74b$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $h9vMN.default)[themeId]();
    return themeCss;
};
const $16ed0efa55daa74b$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $16ed0efa55daa74b$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("h9vMN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad7c7c84f4000181$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









const $ad7c7c84f4000181$var$themeImportsMap = {
    'light': ()=>(parcelRequire("kSD57")),
    'light-future': ()=>(parcelRequire("3qdE0")),
    'light-increased-contrast': ()=>(parcelRequire("cZ2LQ")),
    'dark': ()=>(parcelRequire("j3N5N")),
    'dark-future': ()=>(parcelRequire("cFbef")),
    'dark-increased-contrast': ()=>(parcelRequire("1w8Pm")),
    'spacing': ()=>(parcelRequire("7IlG4")),
    'typography': ()=>(parcelRequire("6HVWD")),
    'shape': ()=>(parcelRequire("eoDgI")),
    'motion': ()=>(parcelRequire("fwq8d"))
};
var $ad7c7c84f4000181$export$2e2bcd8739ae039 = $ad7c7c84f4000181$var$themeImportsMap;

});
parcelRegister("kSD57", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("cYUtr").then(()=>parcelRequire('e8C18'));

});

parcelRegister("3qdE0", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("bCgXO").then(()=>parcelRequire('g8wHq'));

});

parcelRegister("cZ2LQ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("lut7n").then(()=>parcelRequire('lBRDX'));

});

parcelRegister("j3N5N", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("2YcXL").then(()=>parcelRequire('6vfFf'));

});

parcelRegister("cFbef", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("6aUoA").then(()=>parcelRequire('9XzZO'));

});

parcelRegister("1w8Pm", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("7NRmI").then(()=>parcelRequire('6DNSC'));

});

parcelRegister("7IlG4", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("foqPx").then(()=>parcelRequire('63g9t'));

});

parcelRegister("6HVWD", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("bYNPc").then(()=>parcelRequire('byQC7'));

});

parcelRegister("eoDgI", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("2XHNA").then(()=>parcelRequire('2SOUQ'));

});

parcelRegister("fwq8d", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("51RPX").then(()=>parcelRequire('245Py'));

});




parcelRegister("56sKU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f10d1b7636e60fc$export$2e2bcd8739ae039);

var $36kyW = parcelRequire("36kyW");

var $bTvke = parcelRequire("bTvke");

var $9yGPt = parcelRequire("9yGPt");
const $2f10d1b7636e60fc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $2f10d1b7636e60fc$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $bTvke.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $2f10d1b7636e60fc$var$contrastModeMql = $2f10d1b7636e60fc$var$isMatchMediaAvailable && window.matchMedia((0, $9yGPt.moreContrastMediaQuery));
class $2f10d1b7636e60fc$var$ContrastModeObserver {
    getContrastMode() {
        if (!$2f10d1b7636e60fc$var$contrastModeMql) return 'no-preference';
        return $2f10d1b7636e60fc$var$contrastModeMql !== null && $2f10d1b7636e60fc$var$contrastModeMql !== void 0 && $2f10d1b7636e60fc$var$contrastModeMql.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($2f10d1b7636e60fc$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $36kyW.bind)($2f10d1b7636e60fc$var$contrastModeMql, {
            type: 'change',
            listener: $2f10d1b7636e60fc$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $2f10d1b7636e60fc$var$SingletonContrastModeObserver = new $2f10d1b7636e60fc$var$ContrastModeObserver();
var $2f10d1b7636e60fc$export$2e2bcd8739ae039 = $2f10d1b7636e60fc$var$SingletonContrastModeObserver;

});


parcelRegister("5DMjK", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $f8012bcc0ae9d6f2$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $f8012bcc0ae9d6f2$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $f8012bcc0ae9d6f2$export$e673f367da2ff23e);

var $kQnTW = parcelRequire("kQnTW");

var $bTvke = parcelRequire("bTvke");

var $gzeMu = parcelRequire("gzeMu");
function $f8012bcc0ae9d6f2$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $gzeMu.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $bTvke.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $bTvke.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $f8012bcc0ae9d6f2$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $bTvke.CUSTOM_THEME_ATTRIBUTE)}][${(0, $bTvke.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $f8012bcc0ae9d6f2$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $kQnTW.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}

});
parcelRegister("kQnTW", function(module, exports) {
$parcel$export(module.exports, "default", () => $622bb5bc166f6d70$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1de8a9439d40392e3e4945ecf9d9214>>
 * @codegenCommand yarn build tokens
 */ const $622bb5bc166f6d70$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $622bb5bc166f6d70$export$2e2bcd8739ae039 = $622bb5bc166f6d70$var$tokens;

});


parcelRegister("6X8MD", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $f6f856012a0b737a$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $f6f856012a0b737a$export$5d76d7014f4a5d08);

var $e6Qdr = parcelRequire("e6Qdr");

var $fbtNj = parcelRequire("fbtNj");
const $f6f856012a0b737a$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $e6Qdr.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $fbtNj.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $e6Qdr.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $fbtNj.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $f6f856012a0b737a$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("fbtNj", function(module, exports) {
$parcel$export(module.exports, "default", () => $850226c77b308f7e$export$2e2bcd8739ae039);

var $4dNaw = parcelRequire("4dNaw");
function $850226c77b308f7e$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $4dNaw.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("lgSDe", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("9ZuJd").then(()=>parcelRequire('9i1DW'));

});


parcelRegister("9qiZO", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $655197cb8537fe3e$export$7981b2444296e410);
$parcel$export(module.exports, "useIsInsideAppProvider", () => $655197cb8537fe3e$export$26aa23367bfbab0e);
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $655197cb8537fe3e$export$d2def9838ca456c0);
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $655197cb8537fe3e$export$a782702263f77544);

var $8P7DW = parcelRequire("8P7DW");
const $655197cb8537fe3e$export$7981b2444296e410 = /*#__PURE__*/ (0, $8P7DW.createContext)(false);
const $655197cb8537fe3e$export$26aa23367bfbab0e = ()=>{
    return (0, $8P7DW.useContext)($655197cb8537fe3e$export$7981b2444296e410);
};
const $655197cb8537fe3e$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $8P7DW.createContext)(false);
const $655197cb8537fe3e$export$a782702263f77544 = ()=>{
    return (0, $8P7DW.useContext)($655197cb8537fe3e$export$d2def9838ca456c0);
};

});

parcelRegister("34wXk", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $ef1b513112ae02ae$export$49ddd74a6729fdb0);
$parcel$export(module.exports, "SetColorModeContext", () => $ef1b513112ae02ae$export$b06130bad0bbc70f);

var $8P7DW = parcelRequire("8P7DW");
const $ef1b513112ae02ae$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);
const $ef1b513112ae02ae$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);

});

parcelRegister("2keJG", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $8d6e2f543a513ad1$export$332347eeb335453c);

var $8P7DW = parcelRequire("8P7DW");
const $8d6e2f543a513ad1$export$332347eeb335453c = /*#__PURE__*/ (0, $8P7DW.createContext)(false);

});

parcelRegister("f0oQn", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $28c8cd44bbb12f22$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $28c8cd44bbb12f22$export$f7a97b47760e2a13);

var $8P7DW = parcelRequire("8P7DW");
const $28c8cd44bbb12f22$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);
const $28c8cd44bbb12f22$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);

});

parcelRegister("c9J3S", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $b35833d10b9a52d4$export$7ca11437599d653d);

var $8P7DW = parcelRequire("8P7DW");

var $2keJG = parcelRequire("2keJG");
const $b35833d10b9a52d4$export$7ca11437599d653d = ()=>{
    return (0, $8P7DW.useContext)((0, $2keJG.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("6KVyT", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $4a2248386bb56a8b$export$7d4a7e812d176b24);

var $lCTyY = parcelRequire("lCTyY");

var $h9vMN = parcelRequire("h9vMN");

var $9B06U = parcelRequire("9B06U");
const $4a2248386bb56a8b$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $9B06U.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $h9vMN.default)[themeId]();
    return themeCss;
};
const $4a2248386bb56a8b$var$mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $lCTyY.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $9B06U.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $4a2248386bb56a8b$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $4a2248386bb56a8b$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $4a2248386bb56a8b$var$mountThemeCss(themeCss, themeId);
};
const $4a2248386bb56a8b$export$7d4a7e812d176b24 = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($4a2248386bb56a8b$var$loadAndMountThemeCss);
};

});
parcelRegister("9B06U", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $aae5d3c7dfee2636$export$835a0dc855d02822);

var $lCTyY = parcelRequire("lCTyY");

var $bTvke = parcelRequire("bTvke");
function $aae5d3c7dfee2636$export$835a0dc855d02822(themeId) {
    const doc = (0, $lCTyY.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $bTvke.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("g7crg", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $db5e03454bbb8a01$export$20f3076712c8dfa);

var $8P7DW = parcelRequire("8P7DW");

var $l5njV = parcelRequire("l5njV");
var $iXP8B = parcelRequire("iXP8B");

var $34wXk = parcelRequire("34wXk");
function $db5e03454bbb8a01$export$20f3076712c8dfa() {
    const value = (0, $8P7DW.useContext)((0, $34wXk.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $l5njV.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $8P7DW.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
    (0, $8P7DW.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $iXP8B.default)((theme)=>{
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("iXP8B", function(module, exports) {
$parcel$export(module.exports, "default", () => $c76a9ada58765f67$export$2e2bcd8739ae039);

var $bTvke = parcelRequire("bTvke");

var $l5njV = parcelRequire("l5njV");
class $c76a9ada58765f67$export$2e2bcd8739ae039 {
    static #_ = this.observer = null;
    static #_2 = this.callbacks = new Set();
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $c76a9ada58765f67$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$c76a9ada58765f67$export$2e2bcd8739ae039.observer) {
            $c76a9ada58765f67$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $l5njV.default)();
                $c76a9ada58765f67$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $c76a9ada58765f67$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $bTvke.THEME_DATA_ATTRIBUTE),
                    (0, $bTvke.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $c76a9ada58765f67$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($c76a9ada58765f67$export$2e2bcd8739ae039.callbacks.size === 0 && $c76a9ada58765f67$export$2e2bcd8739ae039.observer) {
            $c76a9ada58765f67$export$2e2bcd8739ae039.observer.disconnect();
            $c76a9ada58765f67$export$2e2bcd8739ae039.observer = null;
        }
    }
}

});


parcelRegister("b25oG", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $23ad4a5e170e61ec$export$c582005add11e141);

var $35lEW = parcelRequire("35lEW");

var $8VqaP = parcelRequire("8VqaP");
const $23ad4a5e170e61ec$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $35lEW.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        const parent = document.createElement('div');
        parent.className = (0, $35lEW.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $8VqaP.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $23ad4a5e170e61ec$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $23ad4a5e170e61ec$var$getPortalParent().appendChild(container);
};

});
parcelRegister("35lEW", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $afbb5d8d323a8be0$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $afbb5d8d323a8be0$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $afbb5d8d323a8be0$export$13f57c02915787b3);
const $afbb5d8d323a8be0$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $afbb5d8d323a8be0$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $afbb5d8d323a8be0$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("8VqaP", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $185678c73db77a73$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $185678c73db77a73$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("fqNLx", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $27b2878ab0f81b06$export$26ae5ca175b4ec5a);

var $35lEW = parcelRequire("35lEW");
const $27b2878ab0f81b06$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $35lEW.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("3v1KW", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $246ff5bf1e97ce43$export$da99f98bf3fe55b3);

var $35lEW = parcelRequire("35lEW");

var $8VqaP = parcelRequire("8VqaP");
const $246ff5bf1e97ce43$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $35lEW.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        const parent = document.createElement('div');
        parent.className = (0, $35lEW.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $8VqaP.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $246ff5bf1e97ce43$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $246ff5bf1e97ce43$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("ew9tC", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa56a297e54594d9$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");

var $5x7GG = parcelRequire("5x7GG");
var $g7crg = parcelRequire("g7crg");

var $e6Qdr = parcelRequire("e6Qdr");

var $kO5Mm = parcelRequire("kO5Mm");

var $eLCKs = parcelRequire("eLCKs");

var $c1M7G = parcelRequire("c1M7G");

var $4EuAL = parcelRequire("4EuAL");
function $aa56a297e54594d9$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children, isClosed: isClosed } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $8P7DW.useState)(null);
    const colorMode = (0, $g7crg.useColorMode)();
    (0, $kO5Mm.useIsomorphicLayoutEffect)(()=>{
        if ((0, $e6Qdr.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                let tempPortalContainer = (0, $eLCKs.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                const portalParent = (0, $c1M7G.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return ()=>{
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $4EuAL.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            const tempPortalContainer = (0, $eLCKs.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(tempPortalContainer);
            const portalParent = (0, $c1M7G.createPortalParent)();
            if (!tempPortalContainer || !portalParent) return;
            portalParent.appendChild(tempPortalContainer);
            return ()=>{
                if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $e6Qdr.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ const suspendedChildren = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
        fallback: null,
        children: colorMode ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $5x7GG.default), {
            defaultColorMode: colorMode,
            children: children
        }) : children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $6Q1OD.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("kO5Mm", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $1581cb2aff5be5a9$export$700979bc83e7db82);

var $8P7DW = parcelRequire("8P7DW");
const $1581cb2aff5be5a9$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $8P7DW.useLayoutEffect) : (0, $8P7DW.useEffect);

});

parcelRegister("eLCKs", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $9d5070535f53373f$export$fef014d7cef9e543);

var $35lEW = parcelRequire("35lEW");
const $9d5070535f53373f$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $9d5070535f53373f$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($9d5070535f53373f$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $35lEW.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("c1M7G", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $c8657f57e3607dae$export$95029ca7aca2989e);

var $35lEW = parcelRequire("35lEW");

var $8VqaP = parcelRequire("8VqaP");
const $c8657f57e3607dae$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $c8657f57e3607dae$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($c8657f57e3607dae$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $35lEW.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            const parent = document.createElement('div');
            parent.className = (0, $35lEW.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $8VqaP.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});

parcelRegister("4EuAL", function(module, exports) {
$parcel$export(module.exports, "removePortalParent", () => $37d96fdae622a2f1$export$7b20876b2769b301);

var $8VqaP = parcelRequire("8VqaP");
const $37d96fdae622a2f1$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $37d96fdae622a2f1$export$7b20876b2769b301 = (parentElement)=>{
    if ($37d96fdae622a2f1$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody;
            (_getBody = (0, $8VqaP.getBody)()) === null || _getBody === void 0 || _getBody.removeChild(parentElement);
        }
    }
};

});


parcelRegister("1FThT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b34c0c5c8d465d1e$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $kO5Mm = parcelRequire("kO5Mm");
const $b34c0c5c8d465d1e$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $8P7DW.useState)(false);
    const [useMountEffect] = (0, $8P7DW.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $kO5Mm.useIsomorphicLayoutEffect) : (0, $8P7DW.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $b34c0c5c8d465d1e$export$2e2bcd8739ae039 = $b34c0c5c8d465d1e$var$useIsSubsequentRender;

});

parcelRegister("i5jdY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c69471dbc24ec0c$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $5aNN7 = parcelRequire("5aNN7");

var $kV2WU = parcelRequire("kV2WU");
const $9c69471dbc24ec0c$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $8P7DW.useEffect)(()=>{
        (0, $kV2WU.default)((0, $5aNN7.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, $kV2WU.default)((0, $5aNN7.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $9c69471dbc24ec0c$export$2e2bcd8739ae039 = $9c69471dbc24ec0c$var$useFirePortalEvent;

});
parcelRegister("5aNN7", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $1c9871c1dfd89c02$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $1c9871c1dfd89c02$export$80816bd900e5bd00);
const $1c9871c1dfd89c02$export$ed5835cc67e87f72 = 'akPortalMount';
const $1c9871c1dfd89c02$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("kV2WU", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e416fd0c9f03bea$export$2e2bcd8739ae039);
const $4e416fd0c9f03bea$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $4e416fd0c9f03bea$var$getLayerName = (zIndex)=>{
    return $4e416fd0c9f03bea$var$zIndexToName.hasOwnProperty(zIndex) ? $4e416fd0c9f03bea$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $4e416fd0c9f03bea$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $4e416fd0c9f03bea$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $4e416fd0c9f03bea$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $4e416fd0c9f03bea$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("2nrNX", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $jbqt2 = parcelRequire("jbqt2");
module.exports = Object.assign({}, $jbqt2, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($jbqt2.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("jbqt2", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $34a8f2550b67432e$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $34a8f2550b67432e$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $34a8f2550b67432e$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "focusRing", () => $34a8f2550b67432e$export$8e24544ddba725ee);
$parcel$export(module.exports, "noFocusRing", () => $34a8f2550b67432e$export$c0dd343266bc3261);
$parcel$export(module.exports, "layers", () => $34a8f2550b67432e$export$7be255094ccdc533);
$parcel$export(module.exports, "visuallyHidden", () => $34a8f2550b67432e$export$a1b3edb637fb4f35);
$parcel$export(module.exports, "assistive", () => $34a8f2550b67432e$export$ba1d834b86d72a09);
$parcel$export(module.exports, "skeletonShimmer", () => $34a8f2550b67432e$export$e497e856b4f89fcd);

var $8IuGA = parcelRequire("8IuGA");
const $34a8f2550b67432e$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $34a8f2550b67432e$export$c93026a968943f95 = 'light';
const $34a8f2550b67432e$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $34a8f2550b67432e$export$8e24544ddba725ee = (color = "var(--ds-border-focused, #4688EC)", outlineWidth = 2)=>{
    (0, $8IuGA.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $34a8f2550b67432e$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $34a8f2550b67432e$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $34a8f2550b67432e$export$a1b3edb637fb4f35 = ()=>{
    (0, $8IuGA.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $34a8f2550b67432e$export$ba1d834b86d72a09 = $34a8f2550b67432e$export$a1b3edb637fb4f35;
const $34a8f2550b67432e$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: "var(--ds-skeleton, #0515240F)",
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, #0515240F)"
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
            }
        }
    });

});
parcelRegister("8IuGA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b06deb8e19148599$export$2e2bcd8739ae039);

var $eBsHp = parcelRequire("eBsHp");
function $b06deb8e19148599$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $eBsHp.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}

});
parcelRegister("eBsHp", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ac152f9cdfca8b6$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $4ac152f9cdfca8b6$var$printed = {};
function $4ac152f9cdfca8b6$export$2e2bcd8739ae039(message) {
    if ($4ac152f9cdfca8b6$var$printed[message]) return;
    $4ac152f9cdfca8b6$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});




parcelRegister("47tOb", function(module, exports) {
$parcel$export(module.exports, "register", () => $5ae011b6274103ac$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $36kyW = parcelRequire("36kyW");
const $5ae011b6274103ac$var$registrations = new Set();
let $5ae011b6274103ac$var$cleanupEndEventListeners = null;
function $5ae011b6274103ac$var$onDragStart() {
    if ($5ae011b6274103ac$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $5ae011b6274103ac$var$cleanupEndEventListeners = (0, $36kyW.bindAll)(window, [
        {
            type: 'dragend',
            listener: $5ae011b6274103ac$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $5ae011b6274103ac$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $5ae011b6274103ac$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($5ae011b6274103ac$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $5ae011b6274103ac$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $5ae011b6274103ac$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $5ae011b6274103ac$var$cleanupEndEventListeners = null;
    const clone = Array.from($5ae011b6274103ac$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $5ae011b6274103ac$var$bindStartEvents() {
    return (0, $36kyW.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $5ae011b6274103ac$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $5ae011b6274103ac$var$onDragStart
        }
    ]);
}
let $5ae011b6274103ac$var$cleanupStartEventListeners = null;
function $5ae011b6274103ac$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$5ae011b6274103ac$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $5ae011b6274103ac$var$cleanupStartEventListeners = $5ae011b6274103ac$var$bindStartEvents();
    $5ae011b6274103ac$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $5ae011b6274103ac$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $5ae011b6274103ac$var$registrations.delete(registration);
        if ($5ae011b6274103ac$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $5ae011b6274103ac$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $5ae011b6274103ac$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("dHI4i", function(module, exports) {
$parcel$export(module.exports, "getMousePosition", () => $1ea240e4e43b9a1d$export$642213d516a9b928);
function $1ea240e4e43b9a1d$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});

parcelRegister("iKbWw", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $56f19b31a1fa8775$export$2e68479e0a5d8746);
function $56f19b31a1fa8775$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("9SblW", function(module, exports) {
$parcel$export(module.exports, "show", () => $cbb25a8bc239c92e$export$57bf213be019eeb0);

var $e6Qdr = parcelRequire("e6Qdr");
let $cbb25a8bc239c92e$var$delayId = null;
function $cbb25a8bc239c92e$var$clearScheduled() {
    if ($cbb25a8bc239c92e$var$delayId != null) {
        window.clearTimeout($cbb25a8bc239c92e$var$delayId);
        $cbb25a8bc239c92e$var$delayId = null;
    }
}
function $cbb25a8bc239c92e$var$scheduleTimeout(fn, delay) {
    $cbb25a8bc239c92e$var$clearScheduled();
    $cbb25a8bc239c92e$var$delayId = window.setTimeout(()=>{
        $cbb25a8bc239c92e$var$delayId = null;
        fn();
    }, delay);
}
let $cbb25a8bc239c92e$var$active = null;
function $cbb25a8bc239c92e$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($cbb25a8bc239c92e$var$active && $cbb25a8bc239c92e$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $cbb25a8bc239c92e$var$clearScheduled();
            $cbb25a8bc239c92e$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $cbb25a8bc239c92e$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $cbb25a8bc239c92e$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $cbb25a8bc239c92e$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const shouldAlwaysFadeIn = (0, $e6Qdr.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? entry.shouldAlwaysFadeIn : false;
        const showImmediately = Boolean($cbb25a8bc239c92e$var$active && $cbb25a8bc239c92e$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($cbb25a8bc239c92e$var$active) {
            $cbb25a8bc239c92e$var$clearScheduled();
            $cbb25a8bc239c92e$var$active.entry.hide({
                isImmediate: true
            });
            $cbb25a8bc239c92e$var$active.entry.done();
            $cbb25a8bc239c92e$var$active = null;
        }
        // this tooltip is now the active tooltip
        $cbb25a8bc239c92e$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $cbb25a8bc239c92e$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        // Removing old `mousePosition` behind gate because it stored a function.
        // With the gate we just store the coords which are easier to work with.
        mousePosition: (0, $e6Qdr.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? undefined : getInitialMouse(),
        mousePos: entry.source.type === 'mouse' && (0, $e6Qdr.fg)('platform_dst_nav4_side_nav_resize_tooltip_feedback') ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("18PG6", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d43c1eb1a670861$export$2e2bcd8739ae039);

var $k3AEg = parcelRequire("k3AEg");
function $1d43c1eb1a670861$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $k3AEg.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("k3AEg", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $a22ee15d3c77a5c3$export$6ee17796e3d70de2);

var $fnhqr = parcelRequire("fnhqr");
function $a22ee15d3c77a5c3$export$6ee17796e3d70de2() {
    const uid = (0, $fnhqr.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});


parcelRegister("6Yfz4", function(module, exports) {
$parcel$export(module.exports, "default", () => $e57fc32c986f47f3$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $iTSI3 = parcelRequire("iTSI3");
const $e57fc32c986f47f3$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $e57fc32c986f47f3$var$TooltipContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iTSI3.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8n1kL.default)([
            $e57fc32c986f47f3$var$styles.base,
            truncate && $e57fc32c986f47f3$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        children: children
    });
});
$e57fc32c986f47f3$var$TooltipContainer.displayName = 'TooltipContainer';
var $e57fc32c986f47f3$export$2e2bcd8739ae039 = $e57fc32c986f47f3$var$TooltipContainer;

});
parcelRegister("iTSI3", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ca72b51370f9bec$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $a8LKj = parcelRequire("a8LKj");
const $1ca72b51370f9bec$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $1ca72b51370f9bec$var$TooltipPrimitive = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
            role: "tooltip",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8n1kL.default)([
                "_80om73ad",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                children,
                shortcut && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $a8LKj.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$1ca72b51370f9bec$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $1ca72b51370f9bec$export$2e2bcd8739ae039 = $1ca72b51370f9bec$var$TooltipPrimitive;

});
parcelRegister("a8LKj", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $2bf9f895ad2aba8e$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $2bf9f895ad2aba8e$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $2bf9f895ad2aba8e$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $8n1kL.default)([
            $2bf9f895ad2aba8e$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $gWgPx.jsx)("kbd", {
                className: (0, $8n1kL.default)([
                    $2bf9f895ad2aba8e$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};

});






parcelRegister("5ePZd", function(module, exports) {
$parcel$export(module.exports, "default", () => $594b5de2581d4d9f$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $594b5de2581d4d9f$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    error: {
        id: 'cmdb.object.card.error.loading.object',
        defaultMessage: 'Error occured loading object',
        description: 'Displayed when a value for a CMDB Assets field does not load'
    },
    expandLabel: {
        id: 'cmdb.object.card.expand.label',
        defaultMessage: 'Expand object details',
        description: 'Label for the expand button on the CMDB object field'
    },
    collapseLabel: {
        id: 'cmdb.object.card.collapse.label',
        defaultMessage: 'Collapse object details',
        description: 'Label for the collapse button on the CMDB object field'
    }
});

});






parcelRegister("fAqaB", function(module, exports) {
$parcel$export(module.exports, "initBrowserMetricsV3", () => $7363882913f1fcab$export$229e3124c8dc9ca9);
$parcel$export(module.exports, "startPageLoad", () => $7363882913f1fcab$export$5244fe38dccf2e1d);
$parcel$export(module.exports, "perfMark", () => $7363882913f1fcab$export$61a691dabeb80f51);

var $8P7DW = parcelRequire("8P7DW");

var $4G9cg = parcelRequire("4G9cg");

var $1lG1b = parcelRequire("1lG1b");

var $cvmkw = parcelRequire("cvmkw");

var $hX9nG = parcelRequire("hX9nG");

var $4L08H = parcelRequire("4L08H");

var $brLzz = parcelRequire("brLzz");

var $lKEMb = parcelRequire("lKEMb");

var $jByYr = parcelRequire("jByYr");

var $h4skC = parcelRequire("h4skC");

var $jvs4a = parcelRequire("jvs4a");
var $iClA3 = parcelRequire("iClA3");
const $7363882913f1fcab$var$PERFORMANCE_MARK_PREFIX = 'jsd.performance.profile.customer.portal';
/**
 * List of feature flags whose value has to be sent along with Browser metrics.
 */ const $7363882913f1fcab$var$FEATURE_FLAGS_TO_REPORT = [];
const $7363882913f1fcab$export$229e3124c8dc9ca9 = ()=>{
    var _window$JSD_CUSTOMER_;
    if (typeof window === 'undefined') return;
    /**
   * tenant and region information for UFO
   */ const region = (0, $jByYr.getMeta)('ajs-region');
    const tenantType = (0, $jByYr.getMeta)('ajs-is-synthetic') === 'true' ? (0, $iClA3.TenantType).Synthetic : (0, $iClA3.TenantType).RealUser;
    /**
   * Framework and Product Info
   */ const perimeter = (0, $1lG1b.isFedRamp)() ? (0, $4G9cg.PerimeterType).FEDRAMP_MODERATE : (0, $4G9cg.PerimeterType).COMMERCIAL;
    const info = {
        perimeter: perimeter,
        product: 'jira',
        app: {
            version: {
                web: ((_window$JSD_CUSTOMER_ = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) === null || _window$JSD_CUSTOMER_ === void 0 ? void 0 : _window$JSD_CUSTOMER_.buildKey) || 'local'
            },
            framework: {
                version: $8P7DW.version,
                name: 'react'
            }
        },
        region: region !== null ? region : 'none'
    };
    /**
   * eventPipelineClient expects pre configured `analytics-web-client` promise.
   */ const endpoints = {
        eventPipelineClient: (0, $4L08H.getAnalyticsWebClientPromise)().then((client)=>{
            return client.getInstance();
        })
    };
    // Disabling existing violations, should be fixed when revisited.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (0, $4L08H.getAnalyticsWebClientPromise)().then((client)=>{
        (0, $jvs4a.payloadPublisher).setup({
            product: info.product,
            app: info.app,
            region: region || info.region,
            gasv3: client.getInstance(),
            resourceTimings: (0, $hX9nG.resourceTimingsPlugin),
            featureFlags: $7363882913f1fcab$var$FEATURE_FLAGS_TO_REPORT,
            ...tenantType && {
                tenantType: tenantType
            }
        });
    });
    (0, $cvmkw.browserMetrics).init({
        info: info,
        endpoints: endpoints,
        plugins: {
            featureFlags: (0, $hX9nG.featureFlagsPlugin),
            resourceTimings: (0, $hX9nG.resourceTimingsPlugin)
        },
        events: {
            all: {
                featureFlags: $7363882913f1fcab$var$FEATURE_FLAGS_TO_REPORT,
                plugins: [
                    (0, $hX9nG.customPerfMarks)
                ]
            }
        },
        ssr: {
            getDoneMark: ()=>{
                var _getMark;
                return ((_getMark = (0, $h4skC.getMark)('ssr.spa.rendered')) === null || _getMark === void 0 ? void 0 : _getMark.startTime) || null;
            }
        }
    });
};
let $7363882913f1fcab$var$isInitialPageLoadTracked = false;
const $7363882913f1fcab$export$5244fe38dccf2e1d = (screenName)=>{
    if (typeof window === 'undefined') return;
    if ((0, $brLzz.isPageLoadInstrumented)(screenName)) {
        (0, $lKEMb.devLog)('Browser metrics v3: startPageLoad() fired');
        (0, $cvmkw.browserMetrics).startPageLoad({
            isInitial: !$7363882913f1fcab$var$isInitialPageLoadTracked
        });
    }
    if (!$7363882913f1fcab$var$isInitialPageLoadTracked) $7363882913f1fcab$var$isInitialPageLoadTracked = true;
};
function $7363882913f1fcab$export$61a691dabeb80f51(shortKey) {
    let key = shortKey.trim();
    if (!key.startsWith($7363882913f1fcab$var$PERFORMANCE_MARK_PREFIX)) key = `${$7363882913f1fcab$var$PERFORMANCE_MARK_PREFIX}.${shortKey}`;
    window.performance && window.performance.mark && window.performance.mark(key);
}

});
parcelRegister("cvmkw", function(module, exports) {
$parcel$export(module.exports, "browserMetrics", () => $dcdd1deac1fcb9cf$export$c08e7affcf78b064);

var $dElPp = parcelRequire("dElPp");

var $i5Qpa = parcelRequire("i5Qpa");

var $enWiR = parcelRequire("enWiR");

var $dKLTH = parcelRequire("dKLTH");

var $aE3hW = parcelRequire("aE3hW");

var $7eLcz = parcelRequire("7eLcz");

var $fmtzc = parcelRequire("fmtzc");

var $b4xSG = parcelRequire("b4xSG");
const $dcdd1deac1fcb9cf$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            var _config$events$BMEven, _config$ssr;
            (0, $dKLTH.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $b4xSG.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $aE3hW.webVitalsObserver).start();
            if (config.debug) {
                (0, $i5Qpa.logger).enable();
                (0, $fmtzc.submitter).setDebug(true);
                (0, $enWiR.pageLoadMetaMetric).setDebug(true);
            }
            (0, $fmtzc.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $dElPp.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $7eLcz.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $enWiR.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $enWiR.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $enWiR.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $enWiR.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $enWiR.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $enWiR.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $dcdd1deac1fcb9cf$export$c08e7affcf78b064 = $dcdd1deac1fcb9cf$var$makeBrowserMetrics();

});
parcelRegister("dElPp", function(module, exports) {
$parcel$export(module.exports, "SSRGetDoneMark", () => $d24ae6a4374f96c4$export$9e87a201397ac0a9);
const $d24ae6a4374f96c4$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $d24ae6a4374f96c4$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("i5Qpa", function(module, exports) {
$parcel$export(module.exports, "logger", () => $c40a5012a0e43559$export$af88d00dbe7f521);
const $c40a5012a0e43559$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("enWiR", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetaMetric", () => $d696f1a21a9c0466$export$24b7a1a311eb05dc);

var $b4xSG = parcelRequire("b4xSG");

var $e0WVl = parcelRequire("e0WVl");

var $cYqoX = parcelRequire("cYqoX");
class $d696f1a21a9c0466$export$9609608c00ea5077 extends (0, $cYqoX.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $e0WVl.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $d696f1a21a9c0466$export$24b7a1a311eb05dc = new $d696f1a21a9c0466$export$9609608c00ea5077({
    type: (0, $b4xSG.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("b4xSG", function(module, exports) {
$parcel$export(module.exports, "BMEventsType", () => $6c40c71a66ac794a$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $6c40c71a66ac794a$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $6c40c71a66ac794a$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $6c40c71a66ac794a$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $6c40c71a66ac794a$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $6c40c71a66ac794a$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $6c40c71a66ac794a$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $6c40c71a66ac794a$export$983b017156c2aee2);
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $6c40c71a66ac794a$export$5866f95702a15142);
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $6c40c71a66ac794a$export$f087a59bd717e49d);
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $6c40c71a66ac794a$export$b10c1d9a7db7765b);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $6c40c71a66ac794a$export$60c0193054fc3040);

var $e0WVl = parcelRequire("e0WVl");
var $6c40c71a66ac794a$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $6c40c71a66ac794a$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $6c40c71a66ac794a$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $6c40c71a66ac794a$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $6c40c71a66ac794a$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $6c40c71a66ac794a$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $6c40c71a66ac794a$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $6c40c71a66ac794a$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
const $6c40c71a66ac794a$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $6c40c71a66ac794a$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $6c40c71a66ac794a$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $6c40c71a66ac794a$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $6c40c71a66ac794a$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("e0WVl", function(module, exports) {
$parcel$export(module.exports, "MetricState", () => $0139a3d40c5c0969$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $0139a3d40c5c0969$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $0139a3d40c5c0969$export$2bce4ffdd840e878);

var $e6Qdr = parcelRequire("e6Qdr");

var $gkZFD = parcelRequire("gkZFD");

var $egksB = parcelRequire("egksB");

var $i5Qpa = parcelRequire("i5Qpa");

var $dKLTH = parcelRequire("dKLTH");

var $aLdn4 = parcelRequire("aLdn4");
var $0139a3d40c5c0969$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $0139a3d40c5c0969$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $0139a3d40c5c0969$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $0139a3d40c5c0969$export$2bce4ffdd840e878 {
    static #_ = this.FMP = 'fmp';
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $0139a3d40c5c0969$var$getPageVisibleState();
        this.traceContext = null;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        var _this$config$timings;
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach((entry)=>{
            if ((0, $egksB.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $i5Qpa.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $0139a3d40c5c0969$var$getPageVisibleState();
        (0, $dKLTH.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
        this.startTrace(this.key);
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $i5Qpa.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $i5Qpa.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $dKLTH.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        this.stopTrace();
        return true;
    }
    startTrace(metricKey) {
        if ((0, $e6Qdr.fg)('uip_bm3_tracing')) {
            let traceContext = (0, $gkZFD.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $gkZFD.generateTraceId)(),
                    spanId: (0, $gkZFD.generateSpanId)()
                };
                (0, $gkZFD.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'bm3.' + metricKey);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $e6Qdr.fg)('uip_bm3_tracing')) (0, $gkZFD.clearActiveTrace)();
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $i5Qpa.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $dKLTH.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type,
            ...(0, $e6Qdr.fg)('uip_bm3_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
   *
   * @param metric
   * The array of Until metrics can be of two types
   * This function returns an UntilExperience
   */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $0139a3d40c5c0969$export$2bce4ffdd840e878 ? (0, $aLdn4.UntilExperience).fromMetric(metricOrConfig) : (0, $aLdn4.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = (currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $0139a3d40c5c0969$var$getPageVisibleState();
        this.traceContext = null;
    }
}

});
parcelRegister("gkZFD", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $089d85ea87956051$export$295213bc4d0c54ad);
$parcel$export(module.exports, "generateTraceId", () => $089d85ea87956051$export$dc6d7ea554bcce10);
$parcel$export(module.exports, "setActiveTrace", () => $089d85ea87956051$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $089d85ea87956051$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $089d85ea87956051$export$17ab21d7be720b);

var $jXNbL = parcelRequire("jXNbL");
var $b5UnP = parcelRequire("b5UnP");

var $8yq3R = parcelRequire("8yq3R");
function $089d85ea87956051$var$getEnvironment() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, $b5UnP.envType).PROD;
    const { hostname: hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, $b5UnP.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, $b5UnP.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, $b5UnP.envType).STAGING;
    return (0, $b5UnP.envType).PROD;
}
// Get an AWC so that we can record issues when setting or getting the global trace context
// Heavily borrowed from browser-storage-controls package
const $089d85ea87956051$var$getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = $089d85ea87956051$var$getEnvironment();
            instance = new (0, $jXNbL.default)({
                env: env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
/**
 * Global state for storing the active trace context.
 * This is a simple in-memory store that maintains the current trace context
 */ const $089d85ea87956051$var$state = {
    context: null
};
function $089d85ea87956051$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $089d85ea87956051$export$dc6d7ea554bcce10() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $089d85ea87956051$export$a1002be327997103(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ($089d85ea87956051$var$state.context !== null) $089d85ea87956051$var$getAnalyticsClient().sendOperationalEvent({
        source: source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: $089d85ea87956051$var$state.context,
            incomingContext: {
                traceId: traceId,
                spanId: spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else $089d85ea87956051$var$state.context = {
        traceId: traceId,
        spanId: spanId
    };
}
function $089d85ea87956051$export$b6ac780db3a3cc77() {
    return $089d85ea87956051$var$state.context;
}
function $089d85ea87956051$export$17ab21d7be720b() {
    $089d85ea87956051$var$state.context = null;
}
function $089d85ea87956051$export$63b3d412fff54e8d() {
    const trace = $089d85ea87956051$export$b6ac780db3a3cc77();
    if (!trace) return null;
    const { traceId: traceId, spanId: spanId } = trace;
    return (0, $8yq3R.makeTraceHttpHeaders)(traceId, spanId);
}
function $089d85ea87956051$export$a1e7396778592551() {
    const headers = $089d85ea87956051$export$63b3d412fff54e8d();
    return headers ? new URLSearchParams(headers).toString().toLowerCase() : null;
}

});
parcelRegister("8yq3R", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpHeaders", () => $d85b0a9f2125f14c$export$c7fbc6d88d400f6f);
/**
 * Creates HTTP headers from trace context.
 *
 * @param traceId - The trace ID
 * @param spanId - The span ID
 * @returns An object containing HTTP headers to add to outgoing requests in order to propagate the trace context
 */ function $d85b0a9f2125f14c$export$c7fbc6d88d400f6f(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("egksB", function(module, exports) {
$parcel$export(module.exports, "restrictedTimingKeys", () => $2b74caf04eaffac6$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $2b74caf04eaffac6$export$df21d285cfcda81e);
const $2b74caf04eaffac6$export$1d17377365286b00 = [
    'ssr'
];
const $2b74caf04eaffac6$export$df21d285cfcda81e = 7500;

});

parcelRegister("dKLTH", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $0d482efd4cee84b6$export$13e680397ec8f3eb);
class $0d482efd4cee84b6$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $0d482efd4cee84b6$export$13e680397ec8f3eb = new $0d482efd4cee84b6$var$VisibilityChangeObserver();

});

parcelRegister("aLdn4", function(module, exports) {
$parcel$export(module.exports, "UntilExperience", () => $45e677d436be829d$export$3fcc0936ee2cc852);
class $45e677d436be829d$export$3fcc0936ee2cc852 {
    static #_ = this.FMP = 'fmp';
    static fromConfig(config) {
        return new $45e677d436be829d$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $45e677d436be829d$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$45e677d436be829d$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
   * Get the time it takes for a segment to become fully interactable,
   * regardless of whether it uses the FMP as the stop time. (Eventual load)
   */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$45e677d436be829d$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});



parcelRegister("cYqoX", function(module, exports) {
$parcel$export(module.exports, "BasePageLoadMetric", () => $9d5f7deb9a1f3813$export$fd1447b187f590fe);

var $i5Qpa = parcelRequire("i5Qpa");

var $e0WVl = parcelRequire("e0WVl");
class $9d5f7deb9a1f3813$export$fd1447b187f590fe extends (0, $e0WVl.BaseMetric) {
    static #_ = this.FMP = 'fmp';
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $i5Qpa.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $e0WVl.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $i5Qpa.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $i5Qpa.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $e0WVl.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $9d5f7deb9a1f3813$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $9d5f7deb9a1f3813$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($9d5f7deb9a1f3813$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("aE3hW", function(module, exports) {
$parcel$export(module.exports, "webVitalsObserver", () => $66c3b1ec6d99aecb$export$253d38dccbb37615);


class $66c3b1ec6d99aecb$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("lBIRZ"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("fdAkf"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $66c3b1ec6d99aecb$export$253d38dccbb37615 = new $66c3b1ec6d99aecb$var$WebVitalsObserver();

});
parcelRegister("lBIRZ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("jT0so").then(()=>parcelRequire('BrRBu'));

});

parcelRegister("fdAkf", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("bBP9u").then(()=>parcelRequire('4L4pu'));

});


parcelRegister("7eLcz", function(module, exports) {
$parcel$export(module.exports, "Route", () => $13e675e23ff1205d$export$e7b0ac011bb776c6);
const $13e675e23ff1205d$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("fmtzc", function(module, exports) {
$parcel$export(module.exports, "submitter", () => $14fc6be74a0cedf6$export$c21a25872e3f5a2b);

var $9TwI7 = parcelRequire("9TwI7");

var $b4xSG = parcelRequire("b4xSG");

var $6XQBA = parcelRequire("6XQBA");

var $gkfG2 = parcelRequire("gkfG2");
const $14fc6be74a0cedf6$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $gkfG2.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $b4xSG.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $9TwI7.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $6XQBA.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
        return;
    }
};

});
parcelRegister("6XQBA", function(module, exports) {
$parcel$export(module.exports, "eventDataProcessor", () => $a0f4e559295f10d1$export$896b6e121bbaec25);

var $egksB = parcelRequire("egksB");

var $i5Qpa = parcelRequire("i5Qpa");

var $6Y7BR = parcelRequire("6Y7BR");

var $ePFkk = parcelRequire("ePFkk");

var $6O8RM = parcelRequire("6O8RM");

var $ammr6 = parcelRequire("ammr6");

var $7kVEF = parcelRequire("7kVEF");

var $ghE3g = parcelRequire("ghE3g");

var $1kmzR = parcelRequire("1kmzR");

var $cUl6M = parcelRequire("cUl6M");

var $7hDHF = parcelRequire("7hDHF");

var $55efH = parcelRequire("55efH");

var $9kA3X = parcelRequire("9kA3X");

var $ibTSx = parcelRequire("ibTSx");

var $7jdG4 = parcelRequire("7jdG4");

var $9oUvQ = parcelRequire("9oUvQ");

var $8iPKP = parcelRequire("8iPKP");

var $b2r4P = parcelRequire("b2r4P");

var $le6Ci = parcelRequire("le6Ci");

var $b2bvY = parcelRequire("b2bvY");

var $563Y0 = parcelRequire("563Y0");

var $54hos = parcelRequire("54hos");

var $8vP5R = parcelRequire("8vP5R");

var $4JkEP = parcelRequire("4JkEP");

var $iZXyv = parcelRequire("iZXyv");

var $lLkdz = parcelRequire("lLkdz");

var $aQ7Wt = parcelRequire("aQ7Wt");

var $cFbv5 = parcelRequire("cFbv5");

var $fG0h7 = parcelRequire("fG0h7");

var $71FNg = parcelRequire("71FNg");

var $kVNHV = parcelRequire("kVNHV");

var $ih16k = parcelRequire("ih16k");

var $eBUPx = parcelRequire("eBUPx");

var $7STfj = parcelRequire("7STfj");

var $4dwqq = parcelRequire("4dwqq");

var $86n4l = parcelRequire("86n4l");

var $1k7bs = parcelRequire("1k7bs");

var $a8Imy = parcelRequire("a8Imy");

var $b4xSG = parcelRequire("b4xSG");
const $a0f4e559295f10d1$var$defaultSet = [
    (0, $cUl6M.eventKey),
    (0, $9oUvQ.eventType),
    (0, $9kA3X.eventProduct),
    (0, $55efH.eventPopulation),
    (0, $7jdG4.eventRoute),
    (0, $ghE3g.eventId),
    (0, $7hDHF.eventLocalTime),
    (0, $ibTSx.eventRegion),
    (0, $ePFkk.appFramework),
    (0, $6O8RM.appVersion),
    (0, $ammr6.bmVersion),
    (0, $kVNHV.telemetryBrowser),
    (0, $ih16k.telemetryCpu),
    (0, $eBUPx.telemetryMemory),
    (0, $7STfj.telemetryNetwork),
    (0, $7kVEF.customData),
    (0, $8iPKP.featureFlags),
    (0, $b2r4P.hostname),
    (0, $cFbv5.productCustomData),
    (0, $4dwqq.appTimings),
    (0, $1k7bs.resourceTimings),
    (0, $a8Imy.traceContext)
];
const $a0f4e559295f10d1$var$pageLoadCommon = [
    ...$a0f4e559295f10d1$var$defaultSet,
    (0, $lLkdz.pageVisibleState),
    (0, $aQ7Wt.pageVisibleValue),
    (0, $1kmzR.eventInitial),
    (0, $8vP5R.pageLoadMetrics),
    (0, $86n4l.bundleEvalTimings)
];
const $a0f4e559295f10d1$var$initialPageLoadSet = [
    ...$a0f4e559295f10d1$var$pageLoadCommon,
    (0, $b2bvY.initialPageLoadMetrics),
    (0, $54hos.navigationMetrics),
    (0, $71FNg.ssrSuccess),
    (0, $fG0h7.ssrFeatureFlags)
];
const $a0f4e559295f10d1$var$spaTransitionSet = [
    ...$a0f4e559295f10d1$var$pageLoadCommon
];
const $a0f4e559295f10d1$var$pageSegmentLoadSet = [
    ...$a0f4e559295f10d1$var$defaultSet,
    (0, $4JkEP.pageSegmentLoadMetrics),
    (0, $lLkdz.pageVisibleState),
    (0, $aQ7Wt.pageVisibleValue),
    (0, $1kmzR.eventInitial),
    (0, $86n4l.bundleEvalTimings)
];
const $a0f4e559295f10d1$var$interactionSet = [
    ...$a0f4e559295f10d1$var$defaultSet,
    (0, $lLkdz.pageVisibleState),
    (0, $aQ7Wt.pageVisibleValue),
    (0, $563Y0.interactionMetrics)
];
const $a0f4e559295f10d1$var$customMetricSet = [
    ...$a0f4e559295f10d1$var$defaultSet,
    (0, $lLkdz.pageVisibleState),
    (0, $aQ7Wt.pageVisibleValue),
    (0, $le6Ci.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $a0f4e559295f10d1$var$webVitalsMetricSet = [
    ...$a0f4e559295f10d1$var$defaultSet,
    (0, $iZXyv.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $a0f4e559295f10d1$var$waitForCLS = (delay = (0, $egksB.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $a0f4e559295f10d1$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $i5Qpa.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $b4xSG.BMEventsType).PAGE_LOAD && (0, $6Y7BR.isPageLoadMetricData)(data) && data.isInitial) set = $a0f4e559295f10d1$var$initialPageLoadSet;
    if (data.config.type === (0, $b4xSG.BMEventsType).PAGE_LOAD && (0, $6Y7BR.isPageLoadMetricData)(data) && !data.isInitial) set = $a0f4e559295f10d1$var$spaTransitionSet;
    if (data.config.type === (0, $b4xSG.BMEventsType).PAGE_SEGMENT_LOAD && (0, $6Y7BR.isPageSegmentLoadMetricData)(data)) set = $a0f4e559295f10d1$var$pageSegmentLoadSet;
    if (data.config.type === (0, $b4xSG.BMEventsType).INLINE_RESULT) set = $a0f4e559295f10d1$var$interactionSet;
    if (data.config.type === (0, $b4xSG.BMEventsType).CUSTOM) set = $a0f4e559295f10d1$var$customMetricSet;
    if (data.config.type === (0, $b4xSG.BMEventsType).WEB_VITALS) {
        set = $a0f4e559295f10d1$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $a0f4e559295f10d1$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, // some plugins support page load specific data with special check
        globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("6Y7BR", function(module, exports) {
$parcel$export(module.exports, "isPageLoadMetricData", () => $12d625cd71f420bb$export$b0e12e7abb0bff11);
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $12d625cd71f420bb$export$83d0099ee6dbb5b0);
$parcel$export(module.exports, "isPageLoadConfig", () => $12d625cd71f420bb$export$8672fa27ba8bba88);
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $12d625cd71f420bb$export$abe063537ef4987b);
$parcel$export(module.exports, "isInteractionConfig", () => $12d625cd71f420bb$export$ae68674b6a9353be);
$parcel$export(module.exports, "isCustomConfig", () => $12d625cd71f420bb$export$b493eb8b2ba87421);

var $b4xSG = parcelRequire("b4xSG");
const $12d625cd71f420bb$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $b4xSG.BMEventsType).PAGE_LOAD;
};
const $12d625cd71f420bb$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $b4xSG.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $12d625cd71f420bb$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $b4xSG.BMEventsType).PAGE_LOAD;
};
const $12d625cd71f420bb$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $b4xSG.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $12d625cd71f420bb$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $b4xSG.BMEventsType).INLINE_RESULT;
};
const $12d625cd71f420bb$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $b4xSG.BMEventsType).CUSTOM;
};

});

parcelRegister("ePFkk", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $67c9e76dc09be263$export$e34e4529b979f74c);
const $67c9e76dc09be263$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("6O8RM", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $27d79a2cabc703fa$export$82ae485178b37419);
const $27d79a2cabc703fa$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("ammr6", function(module, exports) {
$parcel$export(module.exports, "bmVersion", () => $d318b4b6d979a74c$export$5cafa465fc876895);
const $d318b4b6d979a74c$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("7kVEF", function(module, exports) {
$parcel$export(module.exports, "customData", () => $009281a77ceb891e$export$f7e743c7db162193);
const $009281a77ceb891e$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("ghE3g", function(module, exports) {
$parcel$export(module.exports, "eventId", () => $e780afcfefdc7e9a$export$aed28df7ac07d79a);
const $e780afcfefdc7e9a$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("1kmzR", function(module, exports) {
$parcel$export(module.exports, "eventInitial", () => $b6b93369a4ff72e0$export$fa8e91d436b3ef8b);

var $6Y7BR = parcelRequire("6Y7BR");
const $b6b93369a4ff72e0$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $6Y7BR.isPageLoadMetricData)(data) && !(0, $6Y7BR.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("cUl6M", function(module, exports) {
$parcel$export(module.exports, "eventKey", () => $7fac6ba44ee901c5$export$10be2d3a558d3f88);

var $jQLD7 = parcelRequire("jQLD7");
const $7fac6ba44ee901c5$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $jQLD7.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("jQLD7", function(module, exports) {
$parcel$export(module.exports, "mapEventType", () => $7b0d2e748c58f3c8$export$b334d07f11140768);

var $b4xSG = parcelRequire("b4xSG");
const $7b0d2e748c58f3c8$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $b4xSG.BMEventsType).CUSTOM:
            return (0, $b4xSG.StorableBMEventsType).CUSTOM;
        case (0, $b4xSG.BMEventsType).INLINE_RESULT:
            return (0, $b4xSG.StorableBMEventsType).INLINE_RESULT;
        case (0, $b4xSG.BMEventsType).PAGE_LOAD:
            return (0, $b4xSG.StorableBMEventsType).PAGE_LOAD;
        case (0, $b4xSG.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $b4xSG.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $b4xSG.BMEventsType).WEB_VITALS:
            return (0, $b4xSG.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("7hDHF", function(module, exports) {
$parcel$export(module.exports, "eventLocalTime", () => $5a9bbdf26f8f038b$export$5219854ae7ec45da);

var $aLwb2 = parcelRequire("aLwb2");
const $5a9bbdf26f8f038b$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $aLwb2.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $aLwb2.default)(new Date(), 'i'), 10)
    });

});
parcelRegister("aLwb2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d6740dd1a15db11$export$2e2bcd8739ae039);

var $dUEnu = parcelRequire("dUEnu");

var $j72dC = parcelRequire("j72dC");

var $bNvBk = parcelRequire("bNvBk");

var $66gQ6 = parcelRequire("66gQ6");

var $9Xddg = parcelRequire("9Xddg");

var $7idWn = parcelRequire("7idWn");

var $jM2Hx = parcelRequire("jM2Hx");

var $gucCl = parcelRequire("gucCl");

var $vJNuT = parcelRequire("vJNuT");

var $a0pIq = parcelRequire("a0pIq");

var $2WLy2 = parcelRequire("2WLy2");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7d6740dd1a15db11$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7d6740dd1a15db11$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7d6740dd1a15db11$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7d6740dd1a15db11$var$doubleQuoteRegExp = /''/g;
var $7d6740dd1a15db11$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $7d6740dd1a15db11$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $vJNuT.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $a0pIq.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $2WLy2.default);
    var firstWeekContainsDate = (0, $gucCl.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $gucCl.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $bNvBk.default)(dirtyDate);
    if (!(0, $dUEnu.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $7idWn.default)(originalDate);
    var utcDate = (0, $j72dC.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($7d6740dd1a15db11$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $9Xddg.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($7d6740dd1a15db11$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $7d6740dd1a15db11$var$cleanEscapedString(substring);
        var formatter = (0, $66gQ6.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $jM2Hx.isProtectedWeekYearToken)(substring)) (0, $jM2Hx.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $jM2Hx.isProtectedDayOfYearToken)(substring)) (0, $jM2Hx.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($7d6740dd1a15db11$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $7d6740dd1a15db11$var$cleanEscapedString(input) {
    var matched = input.match($7d6740dd1a15db11$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($7d6740dd1a15db11$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("dUEnu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a20fd38851a442f5$export$2e2bcd8739ae039);

var $eH3MD = parcelRequire("eH3MD");

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");
function $a20fd38851a442f5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $vJNuT.default)(1, arguments);
    if (!(0, $eH3MD.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $bNvBk.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("eH3MD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab2804254036387b$export$2e2bcd8739ae039);

var $1Vgto = parcelRequire("1Vgto");

var $vJNuT = parcelRequire("vJNuT");
function $ab2804254036387b$export$2e2bcd8739ae039(value) {
    (0, $vJNuT.default)(1, arguments);
    return value instanceof Date || (0, $1Vgto.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("j72dC", function(module, exports) {
$parcel$export(module.exports, "default", () => $dea06459f54616f7$export$2e2bcd8739ae039);

var $41GUe = parcelRequire("41GUe");

var $vJNuT = parcelRequire("vJNuT");

var $gucCl = parcelRequire("gucCl");
function $dea06459f54616f7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $vJNuT.default)(2, arguments);
    var amount = (0, $gucCl.default)(dirtyAmount);
    return (0, $41GUe.default)(dirtyDate, -amount);
}

});
parcelRegister("41GUe", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ee889a5f71dc85d$export$2e2bcd8739ae039);

var $gucCl = parcelRequire("gucCl");

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");
function $2ee889a5f71dc85d$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $vJNuT.default)(2, arguments);
    var timestamp = (0, $bNvBk.default)(dirtyDate).getTime();
    var amount = (0, $gucCl.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("gucCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0093c3c7f6214cd$export$2e2bcd8739ae039);
function $c0093c3c7f6214cd$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("66gQ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $47105d8f55bca05f$export$2e2bcd8739ae039);

var $3cr12 = parcelRequire("3cr12");

var $fvN1a = parcelRequire("fvN1a");

var $N6eqV = parcelRequire("N6eqV");

var $ZUXIX = parcelRequire("ZUXIX");

var $kBtdq = parcelRequire("kBtdq");

var $gsRiF = parcelRequire("gsRiF");

var $eTeZm = parcelRequire("eTeZm");
var $47105d8f55bca05f$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $47105d8f55bca05f$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $eTeZm.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $kBtdq.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $gsRiF.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $gsRiF.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $N6eqV.default)(date);
        // Padding
        return (0, $gsRiF.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $gsRiF.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $gsRiF.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $gsRiF.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $eTeZm.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $gsRiF.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $ZUXIX.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $gsRiF.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $fvN1a.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $gsRiF.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $eTeZm.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $3cr12.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $gsRiF.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $gsRiF.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $gsRiF.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $gsRiF.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $47105d8f55bca05f$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $47105d8f55bca05f$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $47105d8f55bca05f$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $47105d8f55bca05f$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $47105d8f55bca05f$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $47105d8f55bca05f$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $eTeZm.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $eTeZm.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $gsRiF.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $gsRiF.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $eTeZm.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $eTeZm.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $eTeZm.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $47105d8f55bca05f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $47105d8f55bca05f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $47105d8f55bca05f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $47105d8f55bca05f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $47105d8f55bca05f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $47105d8f55bca05f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $47105d8f55bca05f$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $47105d8f55bca05f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $47105d8f55bca05f$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $47105d8f55bca05f$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $gsRiF.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $gsRiF.default)(timestamp, token.length);
    }
};
function $47105d8f55bca05f$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $gsRiF.default)(minutes, 2);
}
function $47105d8f55bca05f$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $gsRiF.default)(Math.abs(offset) / 60, 2);
    }
    return $47105d8f55bca05f$var$formatTimezone(offset, dirtyDelimiter);
}
function $47105d8f55bca05f$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $gsRiF.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $gsRiF.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $47105d8f55bca05f$export$2e2bcd8739ae039 = $47105d8f55bca05f$var$formatters;

});
parcelRegister("3cr12", function(module, exports) {
$parcel$export(module.exports, "default", () => $254772dda766d4b1$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");
var $254772dda766d4b1$var$MILLISECONDS_IN_DAY = 86400000;
function $254772dda766d4b1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $vJNuT.default)(1, arguments);
    var date = (0, $bNvBk.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $254772dda766d4b1$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("fvN1a", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4afc629775b21b6$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $9u5Tc = parcelRequire("9u5Tc");

var $iyHLl = parcelRequire("iyHLl");

var $vJNuT = parcelRequire("vJNuT");
var $b4afc629775b21b6$var$MILLISECONDS_IN_WEEK = 604800000;
function $b4afc629775b21b6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $vJNuT.default)(1, arguments);
    var date = (0, $bNvBk.default)(dirtyDate);
    var diff = (0, $9u5Tc.default)(date).getTime() - (0, $iyHLl.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b4afc629775b21b6$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("9u5Tc", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e7b7bdf654d6492$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");
function $6e7b7bdf654d6492$export$2e2bcd8739ae039(dirtyDate) {
    (0, $vJNuT.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $bNvBk.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("iyHLl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d82d594ced65eeab$export$2e2bcd8739ae039);

var $N6eqV = parcelRequire("N6eqV");

var $9u5Tc = parcelRequire("9u5Tc");

var $vJNuT = parcelRequire("vJNuT");
function $d82d594ced65eeab$export$2e2bcd8739ae039(dirtyDate) {
    (0, $vJNuT.default)(1, arguments);
    var year = (0, $N6eqV.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $9u5Tc.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("N6eqV", function(module, exports) {
$parcel$export(module.exports, "default", () => $0939693910b4ce13$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");

var $9u5Tc = parcelRequire("9u5Tc");
function $0939693910b4ce13$export$2e2bcd8739ae039(dirtyDate) {
    (0, $vJNuT.default)(1, arguments);
    var date = (0, $bNvBk.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $9u5Tc.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $9u5Tc.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("ZUXIX", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ba1e2250b2cdfdb$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $4N9Ow = parcelRequire("4N9Ow");

var $2M3Su = parcelRequire("2M3Su");

var $vJNuT = parcelRequire("vJNuT");
var $0ba1e2250b2cdfdb$var$MILLISECONDS_IN_WEEK = 604800000;
function $0ba1e2250b2cdfdb$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $vJNuT.default)(1, arguments);
    var date = (0, $bNvBk.default)(dirtyDate);
    var diff = (0, $4N9Ow.default)(date, options).getTime() - (0, $2M3Su.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0ba1e2250b2cdfdb$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("4N9Ow", function(module, exports) {
$parcel$export(module.exports, "default", () => $37d359d8fde1a831$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");

var $gucCl = parcelRequire("gucCl");

var $a0pIq = parcelRequire("a0pIq");
function $37d359d8fde1a831$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $vJNuT.default)(1, arguments);
    var defaultOptions = (0, $a0pIq.getDefaultOptions)();
    var weekStartsOn = (0, $gucCl.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bNvBk.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("a0pIq", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $748dda091950db37$export$430a3269e24b912e);
var $748dda091950db37$var$defaultOptions = {};
function $748dda091950db37$export$430a3269e24b912e() {
    return $748dda091950db37$var$defaultOptions;
}
function $748dda091950db37$export$95365be1b0704abc(newOptions) {
    $748dda091950db37$var$defaultOptions = newOptions;
}

});


parcelRegister("2M3Su", function(module, exports) {
$parcel$export(module.exports, "default", () => $2053128757878862$export$2e2bcd8739ae039);

var $kBtdq = parcelRequire("kBtdq");

var $vJNuT = parcelRequire("vJNuT");

var $4N9Ow = parcelRequire("4N9Ow");

var $gucCl = parcelRequire("gucCl");

var $a0pIq = parcelRequire("a0pIq");
function $2053128757878862$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $vJNuT.default)(1, arguments);
    var defaultOptions = (0, $a0pIq.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gucCl.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $kBtdq.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $4N9Ow.default)(firstWeek, options);
    return date;
}

});
parcelRegister("kBtdq", function(module, exports) {
$parcel$export(module.exports, "default", () => $effdecf186390e81$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");

var $4N9Ow = parcelRequire("4N9Ow");

var $gucCl = parcelRequire("gucCl");

var $a0pIq = parcelRequire("a0pIq");
function $effdecf186390e81$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $vJNuT.default)(1, arguments);
    var date = (0, $bNvBk.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $a0pIq.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gucCl.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $4N9Ow.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $4N9Ow.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("gsRiF", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfc89b23724cbf29$export$2e2bcd8739ae039);
function $bfc89b23724cbf29$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("eTeZm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad71d430b711b28d$export$2e2bcd8739ae039);

var $gsRiF = parcelRequire("gsRiF");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $ad71d430b711b28d$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $gsRiF.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $gsRiF.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $gsRiF.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $gsRiF.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $gsRiF.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $gsRiF.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $gsRiF.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $gsRiF.default)(fractionalSeconds, token.length);
    }
};
var $ad71d430b711b28d$export$2e2bcd8739ae039 = $ad71d430b711b28d$var$formatters;

});


parcelRegister("9Xddg", function(module, exports) {
$parcel$export(module.exports, "default", () => $73f3df892268632d$export$2e2bcd8739ae039);
var $73f3df892268632d$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $73f3df892268632d$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $73f3df892268632d$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $73f3df892268632d$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $73f3df892268632d$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $73f3df892268632d$var$timeLongFormatter(timePattern, formatLong));
};
var $73f3df892268632d$var$longFormatters = {
    p: $73f3df892268632d$var$timeLongFormatter,
    P: $73f3df892268632d$var$dateTimeLongFormatter
};
var $73f3df892268632d$export$2e2bcd8739ae039 = $73f3df892268632d$var$longFormatters;

});

parcelRegister("jM2Hx", function(module, exports) {
$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $e654986d17d81302$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $e654986d17d81302$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $e654986d17d81302$export$8073c1ae88f0e727);
var $e654986d17d81302$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $e654986d17d81302$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $e654986d17d81302$export$c6cc36aa33304772(token) {
    return $e654986d17d81302$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $e654986d17d81302$export$c6b49d6dceb604a1(token) {
    return $e654986d17d81302$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $e654986d17d81302$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("2WLy2", function(module, exports) {
$parcel$export(module.exports, "default", () => $2255e197063c42db$export$2e2bcd8739ae039);

var $c4Qbs = parcelRequire("c4Qbs");
var $2255e197063c42db$export$2e2bcd8739ae039 = (0, $c4Qbs.default);

});
parcelRegister("c4Qbs", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cae56616f785e27$export$2e2bcd8739ae039);

var $3djFR = parcelRequire("3djFR");

var $e1Wl4 = parcelRequire("e1Wl4");

var $bbgYZ = parcelRequire("bbgYZ");

var $bfaVc = parcelRequire("bfaVc");

var $HBPLY = parcelRequire("HBPLY");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $8cae56616f785e27$var$locale = {
    code: 'en-US',
    formatDistance: (0, $3djFR.default),
    formatLong: (0, $e1Wl4.default),
    formatRelative: (0, $bbgYZ.default),
    localize: (0, $bfaVc.default),
    match: (0, $HBPLY.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $8cae56616f785e27$export$2e2bcd8739ae039 = $8cae56616f785e27$var$locale;

});
parcelRegister("3djFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2571d8e623b51d88$export$2e2bcd8739ae039);
var $2571d8e623b51d88$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $2571d8e623b51d88$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2571d8e623b51d88$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $2571d8e623b51d88$export$2e2bcd8739ae039 = $2571d8e623b51d88$var$formatDistance;

});

parcelRegister("e1Wl4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a36e698dedaef08b$export$2e2bcd8739ae039);

var $ke0OP = parcelRequire("ke0OP");
var $a36e698dedaef08b$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a36e698dedaef08b$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a36e698dedaef08b$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a36e698dedaef08b$var$formatLong = {
    date: (0, $ke0OP.default)({
        formats: $a36e698dedaef08b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke0OP.default)({
        formats: $a36e698dedaef08b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke0OP.default)({
        formats: $a36e698dedaef08b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a36e698dedaef08b$export$2e2bcd8739ae039 = $a36e698dedaef08b$var$formatLong;

});
parcelRegister("ke0OP", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb95c010ca7bd688$export$2e2bcd8739ae039);
function $eb95c010ca7bd688$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("bbgYZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $823de531f4cd3da0$export$2e2bcd8739ae039);
var $823de531f4cd3da0$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $823de531f4cd3da0$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $823de531f4cd3da0$var$formatRelativeLocale[token];
};
var $823de531f4cd3da0$export$2e2bcd8739ae039 = $823de531f4cd3da0$var$formatRelative;

});

parcelRegister("bfaVc", function(module, exports) {
$parcel$export(module.exports, "default", () => $82f9913c721523ea$export$2e2bcd8739ae039);

var $iodCl = parcelRequire("iodCl");
var $82f9913c721523ea$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $82f9913c721523ea$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $82f9913c721523ea$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $82f9913c721523ea$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $82f9913c721523ea$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $82f9913c721523ea$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $82f9913c721523ea$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $82f9913c721523ea$var$localize = {
    ordinalNumber: $82f9913c721523ea$var$ordinalNumber,
    era: (0, $iodCl.default)({
        values: $82f9913c721523ea$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $iodCl.default)({
        values: $82f9913c721523ea$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $iodCl.default)({
        values: $82f9913c721523ea$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $iodCl.default)({
        values: $82f9913c721523ea$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $iodCl.default)({
        values: $82f9913c721523ea$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $82f9913c721523ea$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $82f9913c721523ea$export$2e2bcd8739ae039 = $82f9913c721523ea$var$localize;

});
parcelRegister("iodCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d635080b1be3f6cf$export$2e2bcd8739ae039);
function $d635080b1be3f6cf$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("HBPLY", function(module, exports) {
$parcel$export(module.exports, "default", () => $08315d520594c809$export$2e2bcd8739ae039);

var $23fxg = parcelRequire("23fxg");

var $b2q8Z = parcelRequire("b2q8Z");
var $08315d520594c809$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $08315d520594c809$var$parseOrdinalNumberPattern = /\d+/i;
var $08315d520594c809$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $08315d520594c809$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $08315d520594c809$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $08315d520594c809$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $08315d520594c809$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $08315d520594c809$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $08315d520594c809$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $08315d520594c809$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $08315d520594c809$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $08315d520594c809$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $08315d520594c809$var$match = {
    ordinalNumber: (0, $b2q8Z.default)({
        matchPattern: $08315d520594c809$var$matchOrdinalNumberPattern,
        parsePattern: $08315d520594c809$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $23fxg.default)({
        matchPatterns: $08315d520594c809$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $08315d520594c809$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $23fxg.default)({
        matchPatterns: $08315d520594c809$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $08315d520594c809$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $23fxg.default)({
        matchPatterns: $08315d520594c809$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $08315d520594c809$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $23fxg.default)({
        matchPatterns: $08315d520594c809$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $08315d520594c809$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $23fxg.default)({
        matchPatterns: $08315d520594c809$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $08315d520594c809$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $08315d520594c809$export$2e2bcd8739ae039 = $08315d520594c809$var$match;

});
parcelRegister("23fxg", function(module, exports) {
$parcel$export(module.exports, "default", () => $17e7e9a1d431e7f4$export$2e2bcd8739ae039);
function $17e7e9a1d431e7f4$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $17e7e9a1d431e7f4$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $17e7e9a1d431e7f4$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $17e7e9a1d431e7f4$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $17e7e9a1d431e7f4$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("b2q8Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $8094294391a8ec08$export$2e2bcd8739ae039);
function $8094294391a8ec08$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("55efH", function(module, exports) {
$parcel$export(module.exports, "eventPopulation", () => $272da4073f099769$export$9086dbeda9b1d633);
const $272da4073f099769$export$9086dbeda9b1d633 = (_config, _data, globalConfig)=>{
    if (!globalConfig.population) return {};
    return {
        'event:population': `${globalConfig.population}`
    };
};

});

parcelRegister("9kA3X", function(module, exports) {
$parcel$export(module.exports, "eventProduct", () => $88cb93762bd52383$export$a7df4e8088db8843);
const $88cb93762bd52383$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("ibTSx", function(module, exports) {
$parcel$export(module.exports, "eventRegion", () => $cbdc3e6a2a7af3b5$export$d0117b71adcdebc0);
const $cbdc3e6a2a7af3b5$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("7jdG4", function(module, exports) {
$parcel$export(module.exports, "eventRoute", () => $ec790f5f5d8c1c88$export$44d3627af289ca16);
const $ec790f5f5d8c1c88$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("9oUvQ", function(module, exports) {
$parcel$export(module.exports, "eventType", () => $a44d208564498671$export$4c045e605d532c98);

var $jQLD7 = parcelRequire("jQLD7");
const $a44d208564498671$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $jQLD7.mapEventType)(config.type)
    };
};

});

parcelRegister("8iPKP", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $298cdde1965a1046$export$e62953d023125748);
const $298cdde1965a1046$export$e62953d023125748 = (config, _data, globalConfig)=>{
    var _config$featureFlags;
    const localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("b2r4P", function(module, exports) {
$parcel$export(module.exports, "hostname", () => $4398edac252d8d6e$export$640106f6dc7d2706);
const $4398edac252d8d6e$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("le6Ci", function(module, exports) {
$parcel$export(module.exports, "customEventMetrics", () => $3cb713a67d186685$export$cab039265c52a2e9);

var $6Y7BR = parcelRequire("6Y7BR");
const $3cb713a67d186685$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    var _config$slo, _config$histogram;
    if (!(0, $6Y7BR.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload['metric:duration:slo'] = payload['metric:duration'] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload['metric:duration:slo:threshold'] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("b2bvY", function(module, exports) {
$parcel$export(module.exports, "initialPageLoadMetrics", () => $09f4355e00639cdb$export$cc95aa3f6ea8e5cb);
const $09f4355e00639cdb$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("563Y0", function(module, exports) {
$parcel$export(module.exports, "interactionMetrics", () => $5e5dc1737f20d145$export$86db56030b57ba34);

var $6Y7BR = parcelRequire("6Y7BR");

var $b4xSG = parcelRequire("b4xSG");
const $5e5dc1737f20d145$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    var _config$histogram;
    if (!(0, $6Y7BR.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $b4xSG.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $b4xSG.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        var _config$histogram2;
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $b4xSG.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $b4xSG.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $b4xSG.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("54hos", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $cf927e8ce952d321$export$b88d990436be0f8a);
const $cf927e8ce952d321$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("8vP5R", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetrics", () => $03eab86efa48088f$export$2878bf482e539059);

var $6Y7BR = parcelRequire("6Y7BR");

var $b4xSG = parcelRequire("b4xSG");
const $03eab86efa48088f$var$getThreshold = (isInitial, metric)=>{
    return (0, $b4xSG.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $03eab86efa48088f$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $03eab86efa48088f$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $6Y7BR.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $b4xSG.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $03eab86efa48088f$var$getHistogram(data.isInitial, (0, $b4xSG.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $03eab86efa48088f$var$getHistogram(data.isInitial, (0, $b4xSG.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $03eab86efa48088f$var$getHistogram(data.isInitial, (0, $b4xSG.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $03eab86efa48088f$var$getHistogram(data.isInitial, (0, $b4xSG.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $03eab86efa48088f$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $03eab86efa48088f$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});

parcelRegister("4JkEP", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $18b7cd4520540078$export$ba86cb47f2f22db5);

var $enWiR = parcelRequire("enWiR");

var $6Y7BR = parcelRequire("6Y7BR");

var $b4xSG = parcelRequire("b4xSG");
const $18b7cd4520540078$var$getThreshold = (isInitial, metric)=>{
    return (0, $b4xSG.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $18b7cd4520540078$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $18b7cd4520540078$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    var _config$slo, _config$slo2;
    if (!(0, $6Y7BR.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $b4xSG.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $18b7cd4520540078$var$getHistogram(data.isInitial, (0, $b4xSG.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $18b7cd4520540078$var$getHistogram(data.isInitial, (0, $b4xSG.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $18b7cd4520540078$var$getHistogram(data.isInitial, (0, $b4xSG.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $18b7cd4520540078$var$getHistogram(data.isInitial, (0, $b4xSG.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        const threshold = $18b7cd4520540078$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        const threshold = $18b7cd4520540078$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $b4xSG.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $b4xSG.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $enWiR.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $b4xSG.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("iZXyv", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetrics", () => $6b99b974f8eec802$export$3731db279f590f30);

var $e0WVl = parcelRequire("e0WVl");

var $dKLTH = parcelRequire("dKLTH");

var $aE3hW = parcelRequire("aE3hW");

var $aQ7Wt = parcelRequire("aQ7Wt");
const $6b99b974f8eec802$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $e0WVl.PageVisibleState).MIXED;
    };
    (0, $dKLTH.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
    const webVitalMetrics = await $6b99b974f8eec802$export$193ae490b52081dd(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
    (0, $dKLTH.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $aQ7Wt.pageVisibleValue)(config, data, globalConfig)
    };
};
const $6b99b974f8eec802$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $aE3hW.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $aE3hW.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $aE3hW.webVitalsObserver).data;
};

});
parcelRegister("aQ7Wt", function(module, exports) {
$parcel$export(module.exports, "pageVisibleValue", () => $b788cae56f7e1157$export$177b923114656380);

var $e0WVl = parcelRequire("e0WVl");
var $b4xSG = parcelRequire("b4xSG");
const $b788cae56f7e1157$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $b4xSG.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $e0WVl.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("lLkdz", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $a00d1aac99089058$export$723b4c298aca63af);
const $a00d1aac99089058$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("cFbv5", function(module, exports) {
$parcel$export(module.exports, "productCustomData", () => $6e278071468d503b$export$fa2af6e412815a74);
const $6e278071468d503b$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("fG0h7", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $c0764c560c1dd50e$export$fdbea518c19dfa8);

var $b4xSG = parcelRequire("b4xSG");
const $c0764c560c1dd50e$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $c0764c560c1dd50e$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
    // no config or missing
    if (!((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags)) return null;
    const includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $b4xSG.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $b4xSG.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $b4xSG.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $c0764c560c1dd50e$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("71FNg", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $f7d2832319a22dd2$export$a3dc8251cf55b2e0);
const $f7d2832319a22dd2$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("kVNHV", function(module, exports) {
$parcel$export(module.exports, "telemetryBrowser", () => $deb0cade54439540$export$386b10ac64a50b1);

var $6m6Qb = parcelRequire("6m6Qb");
const $deb0cade54439540$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6m6Qb))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($6m6Qb))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});
parcelRegister("6m6Qb", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("ih16k", function(module, exports) {
$parcel$export(module.exports, "telemetryCpu", () => $a25d10f97bc00aaf$export$9f84cb359ed29139);
const $a25d10f97bc00aaf$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("eBUPx", function(module, exports) {
$parcel$export(module.exports, "telemetryMemory", () => $894bb3c89b250a64$export$496c14d72b257e07);
const $894bb3c89b250a64$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("7STfj", function(module, exports) {
$parcel$export(module.exports, "telemetryNetwork", () => $e7051f3f5ffb4b5f$export$88bf7b55f7fc4e8e);
const $e7051f3f5ffb4b5f$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("4dwqq", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $29deef7afcab842c$export$e952f50a4f2d02da);

var $b4xSG = parcelRequire("b4xSG");

var $44OGm = parcelRequire("44OGm");

var $7HDmc = parcelRequire("7HDmc");
const $29deef7afcab842c$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $b4xSG.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $44OGm.customTimings)(config, data);
    const ssr = config.type === (0, $b4xSG.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $7HDmc.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("44OGm", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $04a1d57c4124b463$export$6126f85083a72c6e);

var $4kaff = parcelRequire("4kaff");
const $04a1d57c4124b463$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $04a1d57c4124b463$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $04a1d57c4124b463$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $04a1d57c4124b463$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $4kaff.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("4kaff", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $dd630d9fd2d698a8$export$b98e411ae80c806f);
const $dd630d9fd2d698a8$export$b98e411ae80c806f = '/';

});


parcelRegister("7HDmc", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $acb837ee41bc8320$export$130f411261a599c5);

var $4kaff = parcelRequire("4kaff");
const $acb837ee41bc8320$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $acb837ee41bc8320$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $acb837ee41bc8320$var$SSR_PREFIX = 'ssr';
const $acb837ee41bc8320$var$mapKey = (key)=>{
    if (key === 'total') return $acb837ee41bc8320$var$SSR_PREFIX;
    return `${$acb837ee41bc8320$var$SSR_PREFIX}${0, $4kaff.NESTED_METRIC_SEPARATOR}${key}`;
};
const $acb837ee41bc8320$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($acb837ee41bc8320$var$filterEntry(entry[1])) acc[$acb837ee41bc8320$var$mapKey(entry[0])] = $acb837ee41bc8320$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("86n4l", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $e936e286db30f706$export$1a2bb347935fc536);
const $e936e286db30f706$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $e936e286db30f706$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($e936e286db30f706$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("1k7bs", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $cfbec28894f4a88a$export$81a7d52441a06b50);
const $cfbec28894f4a88a$var$cacheableTypes = [
    'script',
    'link'
];
const $cfbec28894f4a88a$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $cfbec28894f4a88a$var$CACHE_NETWORK = 'network';
const $cfbec28894f4a88a$var$CACHE_MEMORY = 'memory';
const $cfbec28894f4a88a$var$CACHE_DISK = 'disk';
const $cfbec28894f4a88a$var$calculateTransferType = (type, duration, size)=>{
    if (!$cfbec28894f4a88a$var$cacheableTypes.includes(type)) return $cfbec28894f4a88a$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $cfbec28894f4a88a$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $cfbec28894f4a88a$var$CACHE_DISK;
    if (size === undefined) return null;
    return $cfbec28894f4a88a$var$CACHE_NETWORK;
};
const $cfbec28894f4a88a$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$cfbec28894f4a88a$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $cfbec28894f4a88a$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $cfbec28894f4a88a$var$withoutHeaders = ()=>false;
const $cfbec28894f4a88a$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $cfbec28894f4a88a$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $cfbec28894f4a88a$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $cfbec28894f4a88a$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $cfbec28894f4a88a$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $cfbec28894f4a88a$var$getNetworkData = (item, eventStart, hasTimingHeaders = $cfbec28894f4a88a$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$cfbec28894f4a88a$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($cfbec28894f4a88a$var$cacheableTypes.includes(type)) {
        const transferType = $cfbec28894f4a88a$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$cfbec28894f4a88a$var$getSizeObject(size)
        };
        if (transferType !== $cfbec28894f4a88a$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$cfbec28894f4a88a$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$cfbec28894f4a88a$var$getSizeObject(size)
    };
};
const $cfbec28894f4a88a$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $cfbec28894f4a88a$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $cfbec28894f4a88a$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$cfbec28894f4a88a$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$cfbec28894f4a88a$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});

parcelRegister("a8Imy", function(module, exports) {
$parcel$export(module.exports, "traceContext", () => $4811a5f2eee8f1d8$export$90f20fc1d8cfb95b);
const $4811a5f2eee8f1d8$export$90f20fc1d8cfb95b = (_config, data, _globalConfig)=>{
    if (!data.traceContext) return null;
    return {
        tracingContext: {
            'X-B3-TraceId': data.traceContext.traceId,
            'X-B3-SpanId': data.traceContext.spanId
        }
    };
};

});


parcelRegister("gkfG2", function(module, exports) {
$parcel$export(module.exports, "makeShareableGlobalConfig", () => $396473110435a509$export$5b4fb14409a2a825);

var $b4xSG = parcelRequire("b4xSG");
const $396473110435a509$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $396473110435a509$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = (eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) ?? (allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) ?? (0, $b4xSG.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($396473110435a509$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    });
};
const $396473110435a509$export$5b4fb14409a2a825 = async (globalConfig)=>{
    var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3;
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: (_globalConfig$events$ = globalConfig.events[(0, $b4xSG.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $b4xSG.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $b4xSG.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
        }
    };
    return {
        [(0, $b4xSG.BMEventsType).PAGE_LOAD]: $396473110435a509$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b4xSG.BMEventsType).PAGE_LOAD]),
        [(0, $b4xSG.BMEventsType).PAGE_SEGMENT_LOAD]: $396473110435a509$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b4xSG.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $b4xSG.BMEventsType).INLINE_RESULT]: $396473110435a509$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b4xSG.BMEventsType).INLINE_RESULT]),
        [(0, $b4xSG.BMEventsType).CUSTOM]: $396473110435a509$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b4xSG.BMEventsType).CUSTOM]),
        [(0, $b4xSG.BMEventsType).WEB_VITALS]: $396473110435a509$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $b4xSG.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("hX9nG", function(module, exports) {
$parcel$export(module.exports, "featureFlagsPlugin", () => $cd22a4b8cf9e4966$export$79626a094e303f80);
$parcel$export(module.exports, "resourceTimingsPlugin", () => $cd22a4b8cf9e4966$export$8c43ac1c32352978);
$parcel$export(module.exports, "customPerfMarks", () => $cd22a4b8cf9e4966$export$960f38db9936e6ea);

var $1EFS8 = parcelRequire("1EFS8");

var $lKEMb = parcelRequire("lKEMb");

var $74Kbe = parcelRequire("74Kbe");

var $60ZjY = parcelRequire("60ZjY");
const $cd22a4b8cf9e4966$export$e5bb225813e92c1f = (url)=>url.includes('jsm-portal-frontend');
const $cd22a4b8cf9e4966$export$79626a094e303f80 = {
    client: Promise.resolve({
        getValue: (featureFlagName)=>{
            return (0, $1EFS8.default).checkGate(featureFlagName);
        }
    })
};
const $cd22a4b8cf9e4966$export$6dfc8bfc2349f367 = (url)=>{
    const { isProcessed: isProcessed, url: processedUrl } = (0, $60ZjY.processUrl)(url, []);
    if (!isProcessed) {
        (0, $lKEMb.devLog)(`Unsanitised URL: ${processedUrl}`);
        return 'unknown';
    }
    return processedUrl;
};
const $cd22a4b8cf9e4966$export$8c43ac1c32352978 = {
    hasTimingHeaders: $cd22a4b8cf9e4966$export$e5bb225813e92c1f,
    sanitiseEndpoints: $cd22a4b8cf9e4966$export$6dfc8bfc2349f367,
    mapResources: (0, $74Kbe.sanitizeAssetName)(false)
};
function $cd22a4b8cf9e4966$export$960f38db9936e6ea() {
    var _window$performance, _window$performance$g;
    const marks = {};
    const entries = (_window$performance = window.performance) === null || _window$performance === void 0 || (_window$performance$g = _window$performance.getEntriesByType) === null || _window$performance$g === void 0 ? void 0 : _window$performance$g.call(_window$performance, 'mark');
    if (entries && entries.length > 0) entries.forEach((entry)=>{
        const key = `mark__${entry.name}`;
        const value = Math.floor(entry.startTime);
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        marks[key] = value;
    });
    return marks;
}

});
parcelRegister("74Kbe", function(module, exports) {
$parcel$export(module.exports, "sanitizeAssetName", () => $be6e7ebd8d40f9cd$export$715967a06dea6152);
/**
 * Webpack dev assets without hashes
 */ const $be6e7ebd8d40f9cd$var$webpackDevAssetsRegexp = /(.*)\.(?:chunk|bundle)(_[a-z]+-[A-Z]+)?\.js$/;
/**
 * Webpack prod assets with hashes
 */ const $be6e7ebd8d40f9cd$var$webpackProdAssetsRegexp = /(.*)\.(?:chunk|bundle)\..*(_[a-z]+-[A-Z]+)?\.js$/;
/**
 * jira.webresources:calendar.js asset with localization string
 */ const $be6e7ebd8d40f9cd$var$calendarWRMRegexp = /(jira.webresources:calendar)(-[a-z]+).js$/;
/**
 * This returns the base name of the asset/url that is getting loaded.
 * eg: for: https://<your-domain>/assets/servicedesk-vendor.chunk.js
 * return servicedesk-vendor.chunk.js
 * @param assetPathOrURL all the external asset/path urls,  eg: anything refereced using <link>, <script> etc tag
 */ const $be6e7ebd8d40f9cd$var$getBaseName = (assetPathOrURL)=>assetPathOrURL.split('#')[0].split('?')[0].split('/').pop() || '';
const $be6e7ebd8d40f9cd$export$715967a06dea6152 = (isDevelopment)=>(assetPathOrURL)=>{
        const assetBaseName = $be6e7ebd8d40f9cd$var$getBaseName(assetPathOrURL);
        const webpackAssetsMatch = assetBaseName.match(isDevelopment ? $be6e7ebd8d40f9cd$var$webpackDevAssetsRegexp : $be6e7ebd8d40f9cd$var$webpackProdAssetsRegexp);
        if (webpackAssetsMatch) return `${webpackAssetsMatch[1]}.js`;
        const calendarWRMMatch = assetBaseName.match($be6e7ebd8d40f9cd$var$calendarWRMRegexp);
        if (calendarWRMMatch) return `${calendarWRMMatch[1]}.js`;
        return assetBaseName;
    };

});

parcelRegister("60ZjY", function(module, exports) {
$parcel$export(module.exports, "processUrl", () => $52684d3ba1947729$export$8378cb52a6ed7e05);
class $52684d3ba1947729$export$b323b8cc3ace981b {
    /**
   * Processes URLs that match a given pattern.
   *
   * @param pattern The pattern to match the URL against
   * @param onMatch The action to perform on the URL
   */ constructor(options){
        this.hasMatched = false;
        this.name = options.name;
        this.onMatch = options.onMatch;
        this.pattern = options.pattern;
    }
    /**
   * True if the last URL processed matched the processor's pattern.
   */ getHasMatched() {
        return this.hasMatched;
    }
    /**
   * The name of the processor.
   */ getName() {
        return this.name;
    }
    /**
   * Attempt to process the URL.
   *
   * If the URL matches the processor's pattern, then the URL is processed
   * and `hasMatched` is set to true. Otherwise, return the URL as is, and
   * set `hasMatched` to false.
   *
   * @param url The URL to process
   * @returns The URL (processed if the pattern matched, otherwise as-is)
   */ process(url) {
        const match = url.match(this.pattern);
        if (match) {
            this.hasMatched = true;
            const processedUrl = this.onMatch(url, match);
            return processedUrl;
        }
        this.hasMatched = false;
        return url;
    }
}
const $52684d3ba1947729$export$8378cb52a6ed7e05 = (url, processors)=>{
    for (const processor of processors){
        const processedUrl = processor.process(url);
        if (processor.getHasMatched()) return {
            url: processedUrl,
            isProcessed: true
        };
    }
    return {
        url: url,
        isProcessed: false
    };
};

});


parcelRegister("brLzz", function(module, exports) {
$parcel$export(module.exports, "isPageLoadInstrumented", () => $f116a8855b1969ff$export$f571430402d3e925);
$parcel$export(module.exports, "default", () => $f116a8855b1969ff$export$2e2bcd8739ae039);

var $ewGAZ = parcelRequire("ewGAZ");

var $8rTkC = parcelRequire("8rTkC");
const $f116a8855b1969ff$export$8d6ac02b84099d24 = ()=>{
    if (window.__IS_PAGE_SERVER_SIDE_RENDERED__) return {
        ssr: {
            doneAsFmp: true
        }
    };
    return {};
};
/**
 * Object containing page load metric for all instrumented screens,
 * as we instrument BM3 for more screens we update values here
 * all new keys will follow the `service-management.help-center.[screenName]` schema
 * and can be accessed using `jira.fe.page-load.service-management.help-center.[screenName]`
 */ const $f116a8855b1969ff$var$perfConfig = {
    [(0, $8rTkC.ScreenName).HELP_CENTER]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-help-center',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).PORTAL_REORDER_SETTINGS]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-reorder-settings',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).VIEW_TOPIC]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.view-topic',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).EDIT_TOPIC]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.edit-topic',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).EDIT_HOMEPAGE]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.edit-homepage',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).ADD_HELP_CONTENT_KNOWLEDGE_RESOURCES]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.add-help-content-knowledge-resources',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).ADD_HELP_CONTENT_EXTERNAL_LINKS]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.add-help-content-external-links',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).UNIFIED_HELP_HOME_PAGE]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.unified-help-center.home-page',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).HELP_CENTERS_MANAGEMENT]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.help-centers-management',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).HELP_HUBS_MANAGEMENT]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.help-hubs-management',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    })
};
const $f116a8855b1969ff$var$bm3BatchOneMetrics = {
    [(0, $8rTkC.ScreenName).REQUEST_LIST]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-requests',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).LOGIN]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-login',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.knowledge-article',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).LOGIN_SINGLE_SIGN_ON]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-login-single-sign-on',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).SIGNUP]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-signup',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).APPROVAL_LIST]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-approvals',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).KNOWLEDGE_CATEGORY]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.category-page',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).USER_PROFILE]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-profile',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).CHECK_EMAIL]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-validate-email',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).COMPLETE_SIGNUP]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).RESET_PASSWORD]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-reset-password',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).INVITED_SIGNUP]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-accept-invite',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).COMPLETE_SIGNUP_TOKEN_INVALID]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup-token-invalid',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).COMPLETE_SIGNUP_TOKEN_EXPIRED]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup-token-expired',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-login-forgot-password-confirmation',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).CONSENT_FORM_PAGE]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.user-consent',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    })
};
const $f116a8855b1969ff$var$bm3BatchTwoMetrics = {
    [(0, $8rTkC.ScreenName).REQUEST_DETAILS]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-details',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).REQUEST_CREATE]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-create',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).PORTAL_HOME]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.single-portal',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).REQUEST_GROUP]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.request-group',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).REQUEST_GROUP_LIST]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.request-group-list',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).FEEDBACK]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-feedback',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.request-create-anonymous-success',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).UNSUBSCRIBE]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-unsubscribe-confirmation',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    }),
    [(0, $8rTkC.ScreenName).FEEDBACK_SUBMITTED]: (0, $ewGAZ.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-feedback-comment-submitted',
        ...$f116a8855b1969ff$export$8d6ac02b84099d24()
    })
};
Object.assign($f116a8855b1969ff$var$perfConfig, $f116a8855b1969ff$var$bm3BatchOneMetrics, $f116a8855b1969ff$var$bm3BatchTwoMetrics);
const $f116a8855b1969ff$export$f571430402d3e925 = (screenName)=>{
    if (!screenName) return false;
    return $f116a8855b1969ff$var$perfConfig.hasOwnProperty(screenName);
};
var $f116a8855b1969ff$export$2e2bcd8739ae039 = $f116a8855b1969ff$var$perfConfig;

});
parcelRegister("ewGAZ", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $d948b0b018cae443$export$b0c5c2fac8144e54);

var $2S28G = parcelRequire("2S28G");

var $aP6fy = parcelRequire("aP6fy");
const $d948b0b018cae443$export$b0c5c2fac8144e54 = {
    pageLoad: $aP6fy.pageLoad,
    pageSegmentLoad: $aP6fy.pageSegmentLoad,
    interaction: $aP6fy.interaction,
    custom: $aP6fy.custom,
    concurrent: $2S28G.concurrent
};

});
parcelRegister("2S28G", function(module, exports) {
$parcel$export(module.exports, "concurrent", () => $9de6c2866776fe72$export$370df09ecc3de059);

var $b4xSG = parcelRequire("b4xSG");

var $aP6fy = parcelRequire("aP6fy");
const $9de6c2866776fe72$var$concurrentMetrics = {};
const $9de6c2866776fe72$var$getKey = (config, type)=>`${type}--${config.key}`;
const $9de6c2866776fe72$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $9de6c2866776fe72$var$ensurePath = (config, type)=>{
    const key = $9de6c2866776fe72$var$getKey(config, type);
    if (!(key in $9de6c2866776fe72$var$concurrentMetrics)) $9de6c2866776fe72$var$concurrentMetrics[key] = {};
};
const $9de6c2866776fe72$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $9de6c2866776fe72$var$getKey(config, type);
    if (concurrentKey in $9de6c2866776fe72$var$concurrentMetrics && $9de6c2866776fe72$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $9de6c2866776fe72$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $9de6c2866776fe72$var$concurrentMetrics)) $9de6c2866776fe72$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $9de6c2866776fe72$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $9de6c2866776fe72$var$validateConfig(config);
    $9de6c2866776fe72$var$ensurePath(config, type);
    const metricFromCache = $9de6c2866776fe72$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $b4xSG.BMEventsType).INLINE_RESULT ? (0, $aP6fy.interaction) : (0, $aP6fy.custom);
    const metric = metricFactory(config);
    $9de6c2866776fe72$var$concurrentMetrics[$9de6c2866776fe72$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $9de6c2866776fe72$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$9de6c2866776fe72$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $b4xSG.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$9de6c2866776fe72$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $b4xSG.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$9de6c2866776fe72$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $b4xSG.BMEventsType).CUSTOM)
};

});
parcelRegister("aP6fy", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $0b62e373ab0854c3$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $0b62e373ab0854c3$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $0b62e373ab0854c3$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $0b62e373ab0854c3$export$4c00f665f0d4b443);

var $iErH2 = parcelRequire("iErH2");

var $7TRYd = parcelRequire("7TRYd");

var $eW3BX = parcelRequire("eW3BX");

var $b4xSG = parcelRequire("b4xSG");
const $0b62e373ab0854c3$export$791d520f7e8058a5 = (config)=>{
    return new (0, $7TRYd.PageLoadMetric)({
        ...config,
        type: (0, $b4xSG.BMEventsType).PAGE_LOAD
    });
};
const $0b62e373ab0854c3$export$94114666844d5f66 = (config)=>{
    return new (0, $eW3BX.PageSegmentLoadMetric)({
        ...config,
        type: (0, $b4xSG.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $0b62e373ab0854c3$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iErH2.Metric)({
        ...config,
        type: (0, $b4xSG.BMEventsType).INLINE_RESULT
    });
};
const $0b62e373ab0854c3$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iErH2.Metric)({
        ...config,
        type: (0, $b4xSG.BMEventsType).CUSTOM
    });
};

});
parcelRegister("iErH2", function(module, exports) {
$parcel$export(module.exports, "Metric", () => $f99f29ea8f354eab$export$efdd3e096bc27746);

var $7eLcz = parcelRequire("7eLcz");

var $fmtzc = parcelRequire("fmtzc");

var $e0WVl = parcelRequire("e0WVl");
class $f99f29ea8f354eab$export$efdd3e096bc27746 extends (0, $e0WVl.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $7eLcz.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $fmtzc.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("7TRYd", function(module, exports) {
$parcel$export(module.exports, "PageLoadMetric", () => $8e3eec26c4e05d94$export$3c51073271a9eac3);

var $dElPp = parcelRequire("dElPp");

var $i5Qpa = parcelRequire("i5Qpa");

var $7eLcz = parcelRequire("7eLcz");

var $fmtzc = parcelRequire("fmtzc");

var $b4xSG = parcelRequire("b4xSG");

var $cYqoX = parcelRequire("cYqoX");

var $enWiR = parcelRequire("enWiR");

var $1myfc = parcelRequire("1myfc");
class $8e3eec26c4e05d94$export$3c51073271a9eac3 extends (0, $cYqoX.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $enWiR.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        var _this$config$ssr;
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $enWiR.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $enWiR.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
            if (!this.marks[(0, $cYqoX.BasePageLoadMetric).FMP]) {
                const mark = (0, $dElPp.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $enWiR.pageLoadMetaMetric).markFMP(mark);
            } else (0, $enWiR.pageLoadMetaMetric).markFMP(this.marks[(0, $cYqoX.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $7eLcz.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $fmtzc.submitter).queue(data);
        (0, $i5Qpa.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $enWiR.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $enWiR.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $enWiR.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        var _configChunk$BMEvents;
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $fmtzc.submitter).config.configChunk;
        if (!(configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $b4xSG.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled)) return false;
        const webVitalMetric = new (0, $1myfc.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $fmtzc.submitter).queue(webVitalMetric.getData());
        (0, $i5Qpa.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("1myfc", function(module, exports) {
$parcel$export(module.exports, "WebVitalsMetric", () => $de6e44c90c7ef35b$export$dc0d85d4d6503cd7);

var $b4xSG = parcelRequire("b4xSG");

var $e0WVl = parcelRequire("e0WVl");
class $de6e44c90c7ef35b$export$dc0d85d4d6503cd7 extends (0, $e0WVl.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $b4xSG.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $e0WVl.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("eW3BX", function(module, exports) {
$parcel$export(module.exports, "PageSegmentLoadMetric", () => $758b4a2000568f62$export$24c8bfcd77494cc1);

var $dElPp = parcelRequire("dElPp");

var $b4xSG = parcelRequire("b4xSG");

var $e0WVl = parcelRequire("e0WVl");

var $iErH2 = parcelRequire("iErH2");

var $enWiR = parcelRequire("enWiR");
class $758b4a2000568f62$export$24c8bfcd77494cc1 extends (0, $iErH2.Metric) {
    static #_ = this.FMP = 'fmp';
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $enWiR.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $758b4a2000568f62$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($758b4a2000568f62$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        var _this$config$ssr;
        const pageLoadData = (0, $enWiR.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
            if (!this.marks[$758b4a2000568f62$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $dElPp.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $b4xSG.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $e0WVl.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $e0WVl.MetricState).STARTED) (0, $enWiR.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});





parcelRegister("h4skC", function(module, exports) {
$parcel$export(module.exports, "getMark", () => $57ef016360658ed0$export$f45af69d005a6ed);
const $57ef016360658ed0$export$f45af69d005a6ed = (markName)=>{
    if (!performance.getEntriesByName) return null;
    const marks = performance.getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};

});

parcelRegister("jvs4a", function(module, exports) {
$parcel$export(module.exports, "payloadPublisher", () => $db917eb957563ce6$export$edb879ae55bb9be3);

var $e6Qdr = parcelRequire("e6Qdr");

var $2lzZD = parcelRequire("2lzZD");
var $8Jiir = parcelRequire("8Jiir");

var $gBFgd = parcelRequire("gBFgd");

var $782sr = parcelRequire("782sr");

var $1VCaI = parcelRequire("1VCaI");

var $c7MjP = parcelRequire("c7MjP");

var $iClA3 = parcelRequire("iClA3");

var $gzaw2 = parcelRequire("gzaw2");

var $dakgk = parcelRequire("dakgk");

var $7W6JZ = parcelRequire("7W6JZ");

var $g4lpe = parcelRequire("g4lpe");

var $7PCel = parcelRequire("7PCel");

var $jNMeD = parcelRequire("jNMeD");

var $1AIE6 = parcelRequire("1AIE6");

var $eGcKR = parcelRequire("eGcKR");

var $2Y59J = parcelRequire("2Y59J");

var $1StIH = parcelRequire("1StIH");

var $6pT8d = parcelRequire("6pT8d");

var $d1dbK = parcelRequire("d1dbK");

var $lQfqV = parcelRequire("lQfqV");

var $8mHQ2 = parcelRequire("8mHQ2");

var $1TXyT = parcelRequire("1TXyT");

var $ix64c = parcelRequire("ix64c");
var $db917eb957563ce6$var$_getWindowObject;
const $db917eb957563ce6$var$UNKNOWN_VALUE = 'unknown';
const $db917eb957563ce6$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $db917eb957563ce6$var$UNKNOWN_VALUE,
    id: $db917eb957563ce6$var$UNKNOWN_VALUE,
    uuid: $db917eb957563ce6$var$UNKNOWN_VALUE,
    state: {
        id: $db917eb957563ce6$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $2lzZD.ExperienceTypes).Experience,
    category: $db917eb957563ce6$var$UNKNOWN_VALUE,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $1VCaI.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $db917eb957563ce6$var$Publisher {
    publish(data) {
        var _getPerformanceObject, _getPerformanceObject2, _getPerformanceObject3;
        const payloadStart = ((_getPerformanceObject = (0, $ix64c.getPerformanceObject)()) === null || _getPerformanceObject === void 0 ? void 0 : _getPerformanceObject.now()) || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $782sr.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$db917eb957563ce6$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $c7MjP.UFO_BUILD_VERSION) || $db917eb957563ce6$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $1AIE6.eventBrowserPlugin)(),
                    ...(0, $eGcKR.eventCpusPlugin)(),
                    ...(0, $1StIH.eventMemoryPlugin)(),
                    ...(0, $6pT8d.eventNetworkPlugin)(),
                    ...(0, $7PCel.appFramework)(this.app),
                    ...(0, $jNMeD.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $iClA3.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $7W6JZ.pageVisibleState)(supportedData),
                    ...(0, $1TXyT.isInitialPageLoad)(supportedData) && (0, $lQfqV.ssrSuccess)(this.ssr),
                    ...(0, $1TXyT.isInitialPageLoad)(supportedData) && (0, $d1dbK.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $2Y59J.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: {
                    ...this.getPerformanceMetrics(supportedData),
                    ...supportedData.traceContext && (0, $e6Qdr.fg)('ufo_v1_tracing_2') ? {
                        'ufo:tracingContext': {
                            'X-B3-TraceId': supportedData.traceContext.traceId,
                            'X-B3-SpanId': supportedData.traceContext.spanId,
                            browserTimeOrigin: ((_getPerformanceObject2 = (0, $ix64c.getPerformanceObject)()) === null || _getPerformanceObject2 === void 0 ? void 0 : _getPerformanceObject2.timeOrigin) ?? 0
                        }
                    } : null
                },
                task: supportedData.id
            }
        };
        const payloadEnd = ((_getPerformanceObject3 = (0, $ix64c.getPerformanceObject)()) === null || _getPerformanceObject3 === void 0 ? void 0 : _getPerformanceObject3.now()) || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $782sr.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $gBFgd.getGlobalEventStream)() instanceof (0, $gzaw2.UFOGlobalEventStream))) {
            const eventStream = new (0, $gzaw2.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $1VCaI.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $gBFgd.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $8Jiir.visibilityChangeObserver).start();
        (0, $g4lpe.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $dakgk.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $db917eb957563ce6$var$UNKNOWN_VALUE;
        this.hostname = (($db917eb957563ce6$var$_getWindowObject = (0, $ix64c.getWindowObject)()) === null || $db917eb957563ce6$var$_getWindowObject === void 0 || ($db917eb957563ce6$var$_getWindowObject = $db917eb957563ce6$var$_getWindowObject.location) === null || $db917eb957563ce6$var$_getWindowObject === void 0 ? void 0 : $db917eb957563ce6$var$_getWindowObject.hostname) || '';
        this.tenantType = (0, $iClA3.TenantType).RealUser;
        this.app = {
            version: {
                web: $db917eb957563ce6$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $8mHQ2.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $db917eb957563ce6$export$edb879ae55bb9be3 = new $db917eb957563ce6$var$Publisher();

});
parcelRegister("2lzZD", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $0448b3381280e02e$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $0448b3381280e02e$export$cc26007c03242fff);
var $0448b3381280e02e$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $0448b3381280e02e$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("8Jiir", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $dbb45e4c73682066$export$13e680397ec8f3eb);

var $ah7DZ = parcelRequire("ah7DZ");
class $dbb45e4c73682066$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $ah7DZ.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $dbb45e4c73682066$export$13e680397ec8f3eb = new $dbb45e4c73682066$var$VisibilityChangeObserver();

});
parcelRegister("ah7DZ", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $8579a68476e7da2c$export$15e172712955e18f);
const $8579a68476e7da2c$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("gBFgd", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $5577eb73bdfab9b3$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $5577eb73bdfab9b3$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $5577eb73bdfab9b3$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $5577eb73bdfab9b3$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $5577eb73bdfab9b3$export$7c957416596ca127);

var $782sr = parcelRequire("782sr");

var $1VCaI = parcelRequire("1VCaI");
const $5577eb73bdfab9b3$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $5577eb73bdfab9b3$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $5577eb73bdfab9b3$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $5577eb73bdfab9b3$export$c1522520b417b066 = (eventStream)=>{
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $782sr.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $5577eb73bdfab9b3$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $1VCaI.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $5577eb73bdfab9b3$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $1VCaI.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $5577eb73bdfab9b3$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $1VCaI.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("782sr", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $9b67b5f1c9b7545b$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $9b67b5f1c9b7545b$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $9b67b5f1c9b7545b$export$d53d07b6034c4560);
class $9b67b5f1c9b7545b$var$UFOLogger {
    static #_ = this.UFOprefix = "[ufo\uD83D\uDEF8]";
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($9b67b5f1c9b7545b$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($9b67b5f1c9b7545b$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $9b67b5f1c9b7545b$export$4ab84f6f04f6566d = new $9b67b5f1c9b7545b$var$UFOLogger();
const $9b67b5f1c9b7545b$export$b4958caff08a0960 = (...args)=>{
    $9b67b5f1c9b7545b$export$4ab84f6f04f6566d.log(...args);
};
const $9b67b5f1c9b7545b$export$d53d07b6034c4560 = (...args)=>{
    $9b67b5f1c9b7545b$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("1VCaI", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $637e3df7744b52d5$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $637e3df7744b52d5$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $637e3df7744b52d5$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $637e3df7744b52d5$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $637e3df7744b52d5$export$837e0f79a8056912);
var $637e3df7744b52d5$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $637e3df7744b52d5$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $637e3df7744b52d5$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $637e3df7744b52d5$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $637e3df7744b52d5$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $637e3df7744b52d5$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $637e3df7744b52d5$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $637e3df7744b52d5$export$9f2bf58999404c75 = 'fmp';
const $637e3df7744b52d5$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("c7MjP", function(module, exports) {
$parcel$export(module.exports, "UFO_BUILD_VERSION", () => $25092712971d5264$export$93809551debf385f);
// temp solution until a proper versioning
const $25092712971d5264$export$93809551debf385f = '0.1.7';

});

parcelRegister("iClA3", function(module, exports) {
$parcel$export(module.exports, "TenantType", () => $6ff9ac734213d378$export$92a757ac1398962f);

var $6ff9ac734213d378$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("gzaw2", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStream", () => $1647897aaa6b8551$export$faf4c91b80fc830e);

var $782sr = parcelRequire("782sr");

var $1VCaI = parcelRequire("1VCaI");
class $1647897aaa6b8551$export$faf4c91b80fc830e {
    push(event) {
        (0, $782sr.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $1VCaI.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $1VCaI.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $1VCaI.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        var _this$subscribers$eve;
        if (this.subscribers[0, $1VCaI.SUBSCRIBE_ALL]) this.subscribers[0, $1VCaI.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        (_this$subscribers$eve = this.subscribers[eventPayload.id]) === null || _this$subscribers$eve === void 0 || _this$subscribers$eve.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $782sr.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("dakgk", function(module, exports) {
$parcel$export(module.exports, "getPerformancePayload", () => $9c986a8c116f1432$export$738d24377baf6a5e);

var $2lzZD = parcelRequire("2lzZD");

var $1VCaI = parcelRequire("1VCaI");

var $1TXyT = parcelRequire("1TXyT");

var $37EhN = parcelRequire("37EhN");

var $5JkMj = parcelRequire("5JkMj");

var $3gh3Z = parcelRequire("3gh3Z");

var $i8e8w = parcelRequire("i8e8w");
const $9c986a8c116f1432$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $9c986a8c116f1432$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $9c986a8c116f1432$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $9c986a8c116f1432$var$getHistogram = (data, performanceConfig, isInitial)=>{
    var _data$performanceConf;
    let histogram = {};
    if ((_data$performanceConf = data.performanceConfig) !== null && _data$performanceConf !== void 0 && _data$performanceConf.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig !== null && performanceConfig !== void 0 && performanceConfig.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $2lzZD.ExperiencePerformanceTypes).PageLoad:
            case (0, $2lzZD.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$9c986a8c116f1432$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$9c986a8c116f1432$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $2lzZD.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$9c986a8c116f1432$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$9c986a8c116f1432$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $2lzZD.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$9c986a8c116f1432$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};
const $9c986a8c116f1432$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    var _data$metrics$marks$f;
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = ((_data$metrics$marks$f = data.metrics.marks.find((mark)=>mark.name === (0, $1VCaI.FMP_MARK))) === null || _data$metrics$marks$f === void 0 ? void 0 : _data$metrics$marks$f.time) || (0, $1TXyT.isInitialPageLoad)(data) && (ssr === null || ssr === void 0 ? void 0 : ssr.getDoneMark());
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$9c986a8c116f1432$var$LoadMetricKeys.tti]: Math.round(tti),
        [$9c986a8c116f1432$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$9c986a8c116f1432$var$getHistogram(data, performanceConfig)
    };
};
const $9c986a8c116f1432$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $1VCaI.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$9c986a8c116f1432$var$InlineResultMetricKeys.result]: Math.round(result),
        [$9c986a8c116f1432$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$9c986a8c116f1432$var$getHistogram(data, performanceConfig)
    };
};
const $9c986a8c116f1432$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$9c986a8c116f1432$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$9c986a8c116f1432$var$getHistogram(data, performanceConfig)
    };
};
const $9c986a8c116f1432$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $2lzZD.ExperiencePerformanceTypes).PageLoad:
        case (0, $2lzZD.ExperiencePerformanceTypes).PageSegmentLoad:
            return $9c986a8c116f1432$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $2lzZD.ExperiencePerformanceTypes).InlineResult:
            return $9c986a8c116f1432$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $2lzZD.ExperiencePerformanceTypes).Custom:
            return $9c986a8c116f1432$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $9c986a8c116f1432$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$9c986a8c116f1432$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $i8e8w.resourceTimings)(data, resourceConfig),
        ...(0, $3gh3Z.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $5JkMj.appTimings)(data, ssr),
        ...(0, $1TXyT.isInitialPageLoad)(data) ? (0, $37EhN.navigationMetrics)() : null
    };
};

});
parcelRegister("1TXyT", function(module, exports) {
$parcel$export(module.exports, "isInitialPageLoad", () => $6f492ab42b442006$export$7167d96e9881d500);

var $2lzZD = parcelRequire("2lzZD");
const $6f492ab42b442006$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $2lzZD.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("37EhN", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $1c8feccf3af52009$export$b88d990436be0f8a);
const $1c8feccf3af52009$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("5JkMj", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $46d4963c6a66e603$export$e952f50a4f2d02da);

var $2lzZD = parcelRequire("2lzZD");

var $1TXyT = parcelRequire("1TXyT");

var $6AbgV = parcelRequire("6AbgV");

var $6S4Nh = parcelRequire("6S4Nh");
const $46d4963c6a66e603$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $2lzZD.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $6AbgV.customTimings)(data);
    const ssr = (0, $1TXyT.isInitialPageLoad)(data) ? (0, $6S4Nh.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("6AbgV", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $0e83cb5a0df0fa20$export$6126f85083a72c6e);
const $0e83cb5a0df0fa20$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $0e83cb5a0df0fa20$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $0e83cb5a0df0fa20$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("6S4Nh", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $3b90210c88fe9936$export$130f411261a599c5);

var $bdfPg = parcelRequire("bdfPg");
const $3b90210c88fe9936$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $3b90210c88fe9936$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $3b90210c88fe9936$var$SSR_PREFIX = 'ssr';
const $3b90210c88fe9936$var$mapKey = (key)=>{
    if (key === 'total') return $3b90210c88fe9936$var$SSR_PREFIX;
    return `${$3b90210c88fe9936$var$SSR_PREFIX}${0, $bdfPg.NESTED_METRIC_SEPARATOR}${key}`;
};
const $3b90210c88fe9936$export$130f411261a599c5 = (ssr)=>{
    if (!(ssr !== null && ssr !== void 0 && ssr.getTimings)) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($3b90210c88fe9936$var$filterEntry(entry[1])) acc[$3b90210c88fe9936$var$mapKey(entry[0])] = $3b90210c88fe9936$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
parcelRegister("bdfPg", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $1b6e7a206ed053c2$export$b98e411ae80c806f);
const $1b6e7a206ed053c2$export$b98e411ae80c806f = '/';

});



parcelRegister("3gh3Z", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $771b58109c6bf882$export$1a2bb347935fc536);

var $ix64c = parcelRequire("ix64c");
const $771b58109c6bf882$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $ix64c.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance === null || performance === void 0 || performance.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings !== null && bundleEvalTimings !== void 0 && bundleEvalTimings.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("ix64c", function(module, exports) {
$parcel$export(module.exports, "getWindowObject", () => $abad41d8184390e5$export$9aa44f85591248d9);
$parcel$export(module.exports, "getPerformanceObject", () => $abad41d8184390e5$export$8cd0c777b0eb66a0);
$parcel$export(module.exports, "getPerformanceObserverObject", () => $abad41d8184390e5$export$74560fd4e61fd440);
const $abad41d8184390e5$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $abad41d8184390e5$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $abad41d8184390e5$export$9aa44f85591248d9() || {};
    return performance;
};
const $abad41d8184390e5$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $abad41d8184390e5$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};

});


parcelRegister("i8e8w", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $49709081f1fac865$export$81a7d52441a06b50);

var $ix64c = parcelRequire("ix64c");

var $g4lpe = parcelRequire("g4lpe");
const $49709081f1fac865$var$cacheableTypes = [
    'script',
    'link'
];
const $49709081f1fac865$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $49709081f1fac865$var$CACHE_NETWORK = 'network';
const $49709081f1fac865$var$CACHE_MEMORY = 'memory';
const $49709081f1fac865$var$CACHE_DISK = 'disk';
const $49709081f1fac865$var$calculateTransferType = (type, duration, size)=>{
    if (!$49709081f1fac865$var$cacheableTypes.includes(type)) return $49709081f1fac865$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $49709081f1fac865$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $49709081f1fac865$var$CACHE_DISK;
    if (size === undefined) return null;
    return $49709081f1fac865$var$CACHE_NETWORK;
};
const $49709081f1fac865$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$49709081f1fac865$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $ix64c.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $49709081f1fac865$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $49709081f1fac865$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $49709081f1fac865$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $49709081f1fac865$var$getNetworkData = (item, eventStart, hasTimingHeaders = $49709081f1fac865$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$49709081f1fac865$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($49709081f1fac865$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $49709081f1fac865$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$49709081f1fac865$var$getSizeObject(transferSize)
        };
        if (transferType !== $49709081f1fac865$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$49709081f1fac865$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$49709081f1fac865$var$getSizeObject(transferSize)
    };
};
const $49709081f1fac865$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $ix64c.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !(resourceTimings !== null && resourceTimings !== void 0 && resourceTimings.sanitiseEndpoints)) return null;
    const resources = (0, $g4lpe.getResourceTimings)(data.result.startTime, performance);
    if (!(resources !== null && resources !== void 0 && resources.length)) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $49709081f1fac865$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $49709081f1fac865$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$49709081f1fac865$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("g4lpe", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $239519273f857318$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $239519273f857318$export$9eebb59359c2e9e5);
// @flow strict-local

var $782sr = parcelRequire("782sr");

var $ix64c = parcelRequire("ix64c");
const $239519273f857318$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $ix64c.getPerformanceObject)(), PerformanceObserver1 = (0, $ix64c.getPerformanceObserverObject)())=>{
        var _performance$getEntri;
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($239519273f857318$export$bea963256235a63e.observer) {
            (0, $782sr.ufologger).warn('Observer is already running');
            return;
        }
        const resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $239519273f857318$export$bea963256235a63e.timings = resources.map((resource)=>$239519273f857318$export$bea963256235a63e.transformResource(resource));
        $239519273f857318$export$bea963256235a63e.observer = new PerformanceObserver1($239519273f857318$export$bea963256235a63e.addTimings);
        $239519273f857318$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($239519273f857318$export$bea963256235a63e.observer) {
            $239519273f857318$export$bea963256235a63e.observer.disconnect();
            $239519273f857318$export$bea963256235a63e.observer = null;
        }
        $239519273f857318$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$239519273f857318$export$bea963256235a63e.transformResource(entry));
        const overflow = $239519273f857318$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $239519273f857318$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $239519273f857318$export$bea963256235a63e.maxSize;
            $239519273f857318$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $239519273f857318$export$bea963256235a63e.timings.push(...entries);
    }
};
const $239519273f857318$export$9eebb59359c2e9e5 = (startTime, performance = (0, $ix64c.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$239519273f857318$export$bea963256235a63e.observer) {
        const resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $239519273f857318$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});



parcelRegister("7W6JZ", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $658c089553958136$export$723b4c298aca63af);

var $1VCaI = parcelRequire("1VCaI");
const $658c089553958136$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $1VCaI.PageVisibleState).HIDDEN : (0, $1VCaI.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("7PCel", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $1fbe36edcc543c9b$export$e34e4529b979f74c);
const $1fbe36edcc543c9b$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("jNMeD", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $aa7edac0b8b4725d$export$82ae485178b37419);
const $aa7edac0b8b4725d$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("1AIE6", function(module, exports) {
$parcel$export(module.exports, "eventBrowserPlugin", () => $4bb901bd427b099b$export$f435c2789ca334a7);

var $6m6Qb = parcelRequire("6m6Qb");

var $hXXvg = parcelRequire("hXXvg");

var $ix64c = parcelRequire("ix64c");
const $4bb901bd427b099b$export$f435c2789ca334a7 = (0, $hXXvg.default)(()=>{
    var _getWindowObject;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6m6Qb))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($6m6Qb))).getParser(((_getWindowObject = (0, $ix64c.getWindowObject)()) === null || _getWindowObject === void 0 || (_getWindowObject = _getWindowObject.navigator) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.userAgent) || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("eGcKR", function(module, exports) {
$parcel$export(module.exports, "eventCpusPlugin", () => $f7641105f1e22874$export$db7649b8854107ad);

var $hXXvg = parcelRequire("hXXvg");
const $f7641105f1e22874$export$db7649b8854107ad = (0, $hXXvg.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("2Y59J", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $cee0b12d8dad94fb$export$e62953d023125748);
const $cee0b12d8dad94fb$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("1StIH", function(module, exports) {
$parcel$export(module.exports, "eventMemoryPlugin", () => $f7357a52f672c3fc$export$81efaf8414879a1a);

var $hXXvg = parcelRequire("hXXvg");
const $f7357a52f672c3fc$export$81efaf8414879a1a = (0, $hXXvg.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("6pT8d", function(module, exports) {
$parcel$export(module.exports, "eventNetworkPlugin", () => $d9771f5510b4d53b$export$ce1cf816dce1da56);
const $d9771f5510b4d53b$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("d1dbK", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $81c54123de34de2f$export$fdbea518c19dfa8);
const $81c54123de34de2f$export$fdbea518c19dfa8 = (ssr)=>{
    if (!(ssr !== null && ssr !== void 0 && ssr.getFeatureFlags)) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("lQfqV", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $81e3380ae75ad26e$export$a3dc8251cf55b2e0);
const $81e3380ae75ad26e$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr !== null && ssr !== void 0 && ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("8mHQ2", function(module, exports) {
$parcel$export(module.exports, "Route", () => $ec21b30c76a06975$export$e7b0ac011bb776c6);
const $ec21b30c76a06975$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});



parcelRegister("5ZF2p", function(module, exports) {
$parcel$export(module.exports, "initialiseConnectAndSentryAndCleanUrl", () => $73a9ef9bcde5aeae$export$d937591d0adcb4ed);

var $HGACo = parcelRequire("HGACo");

var $51UkY = parcelRequire("51UkY");

var $glMVg = parcelRequire("glMVg");

var $2Np0t = parcelRequire("2Np0t");

var $6GNhI = parcelRequire("6GNhI");

var $lut7F = parcelRequire("lut7F");

var $2V8Gk = parcelRequire("2V8Gk");

var $4OjKJ = parcelRequire("4OjKJ");
const $73a9ef9bcde5aeae$export$d937591d0adcb4ed = ()=>{
    if (!(0, $HGACo.isWrmOptimizationsEnabled)()) (0, $51UkY.awaitGlobal)('connectHost', (0, $glMVg.default));
    if ((0, $lut7F.isSentryEnabled)()) {
        (0, $2V8Gk.install)();
        (0, $4OjKJ.sentryQueue).flushErrors();
    }
    const url = (0, $6GNhI.href)();
    const modifiedUrl = (0, $2Np0t.removeParamsFromUrl)(url, [
        'sda_source'
    ]);
    if (url !== modifiedUrl) (0, $2Np0t.set)({
        sda_source: undefined
    });
};

});
parcelRegister("51UkY", function(module, exports) {
$parcel$export(module.exports, "awaitGlobal", () => $09cb266558aa4dcd$export$653e97524db056d2);
const $09cb266558aa4dcd$var$isGlobalDefined = (objName)=>{
    // @ts-ignore TS(7015) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
    return window[objName] !== undefined;
};
const $09cb266558aa4dcd$export$653e97524db056d2 = (objectName, cb)=>{
    if ($09cb266558aa4dcd$var$isGlobalDefined(objectName)) cb();
    else {
        const intervalTime = 100;
        let loopCounter = 0;
        const awaitInterval = setInterval(()=>{
            if ($09cb266558aa4dcd$var$isGlobalDefined(objectName)) {
                clearInterval(awaitInterval);
                cb();
            }
            loopCounter += 1;
            // Loop will run for maximum of 10 seconds
            if (loopCounter > 100) clearInterval(awaitInterval);
        }, intervalTime);
    }
};

});

parcelRegister("glMVg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8eb058e3ef0e25d3$export$2e2bcd8739ae039);

var $cqt5Z = parcelRequire("cqt5Z");
function $8eb058e3ef0e25d3$var$init() {
    const { connectHost: connectHost } = window;
    const api = (0, $cqt5Z.connectApi)(connectHost);
    function createRequestPropertiesModule() {
        class RequestProperties {
            validate(isValid, context) {
                api.validate(isValid, context._context);
            }
            serialize(data, context) {
                api.serialize(data, context._context);
            }
        }
        return {
            constructor: RequestProperties,
            validate: RequestProperties.prototype.validate,
            serialize: RequestProperties.prototype.serialize
        };
    }
    const jiraServiceDesk = {
        RequestProperties: createRequestPropertiesModule()
    };
    connectHost.defineModule('jiraServiceDesk', jiraServiceDesk);
}
var $8eb058e3ef0e25d3$export$2e2bcd8739ae039 = $8eb058e3ef0e25d3$var$init;

});
parcelRegister("cqt5Z", function(module, exports) {
$parcel$export(module.exports, "getAppKeyFromFullKey", () => $415f5ed0e3504d83$export$30f3f10c136c0ee6);
$parcel$export(module.exports, "getUniqueAppKeysFromConnectFragments", () => $415f5ed0e3504d83$export$bc66b351c49d3b94);
$parcel$export(module.exports, "connectApi", () => $415f5ed0e3504d83$export$b0d55f75723432a0);
$parcel$export(module.exports, "validate", () => $415f5ed0e3504d83$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "serialize", () => $415f5ed0e3504d83$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "register", () => $415f5ed0e3504d83$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "unregister", () => $415f5ed0e3504d83$export$d07f55d4c15c0440);
// Events that the connect field add-on will need to listen to, These are API.
// We don't need to worry about these as it's handled by us but they shouldn't be changed.

var $1We2B = parcelRequire("1We2B");
const $415f5ed0e3504d83$var$EVENTS = {
    VALIDATE: 'jira-servicedesk-request-properties-validate',
    SERIALIZE: 'jira-servicedesk-request-properties-serialize'
};
const $415f5ed0e3504d83$var$connectPluginKey = 'com.atlassian.plugins.atlassian-connect-plugin';
const $415f5ed0e3504d83$var$internalListOfAddons = {};
function $415f5ed0e3504d83$var$getFullkey(context) {
    const addonKey = context.extension.addon_key;
    const panelKey = context.extension.key;
    return `${$415f5ed0e3504d83$var$connectPluginKey}:${addonKey}__${panelKey}`;
}
const $415f5ed0e3504d83$export$30f3f10c136c0ee6 = (fullKey = '')=>{
    const strippedOfModuleKey = fullKey.substring(0, fullKey.lastIndexOf('__'));
    return strippedOfModuleKey.substring(strippedOfModuleKey.lastIndexOf(':') + 1);
};
const $415f5ed0e3504d83$export$bc66b351c49d3b94 = (connectFragments)=>{
    return (0, $1We2B.uniq)(connectFragments.map((fragment)=>$415f5ed0e3504d83$export$30f3f10c136c0ee6(fragment.key)));
};
let $415f5ed0e3504d83$var$connectHost;
const $415f5ed0e3504d83$export$b0d55f75723432a0 = (host)=>{
    $415f5ed0e3504d83$var$connectHost = host;
    $415f5ed0e3504d83$var$connectHost.onIframeEstablished((context)=>{
        const fullKey = $415f5ed0e3504d83$var$getFullkey(context);
        const addonRef = $415f5ed0e3504d83$var$internalListOfAddons[fullKey];
        if (!!addonRef) $415f5ed0e3504d83$var$internalListOfAddons[fullKey] = {
            ...$415f5ed0e3504d83$var$internalListOfAddons[fullKey],
            contextExtension: context.extension
        };
    });
    return {
        // add-ons will call this on the request create page with the result of the validation after they receive the EVENTS.VALIDATE event
        validate (isValid, context) {
            const fullKey = $415f5ed0e3504d83$var$getFullkey(context);
            const addonRef = $415f5ed0e3504d83$var$internalListOfAddons[fullKey];
            if (!!addonRef) addonRef.onValidated(isValid);
        },
        // add-ons will call this on the request create page with the serialized data after they receive the EVENTS.SERIALIZE event
        serialize (data, context) {
            const fullKey = $415f5ed0e3504d83$var$getFullkey(context);
            const addonRef = $415f5ed0e3504d83$var$internalListOfAddons[fullKey];
            if (!!addonRef) addonRef.onSerialized(data);
        }
    };
};
const $415f5ed0e3504d83$export$a22775fa5e2eebd9 = (key)=>{
    const addonRef = $415f5ed0e3504d83$var$internalListOfAddons[key];
    $415f5ed0e3504d83$var$connectHost && addonRef && addonRef.contextExtension && $415f5ed0e3504d83$var$connectHost.broadcastEvent($415f5ed0e3504d83$var$EVENTS.VALIDATE, addonRef.contextExtension);
};
const $415f5ed0e3504d83$export$dfdc1655ccc5b9cb = (key)=>{
    const addonRef = $415f5ed0e3504d83$var$internalListOfAddons[key];
    $415f5ed0e3504d83$var$connectHost && addonRef && addonRef.contextExtension && $415f5ed0e3504d83$var$connectHost.broadcastEvent($415f5ed0e3504d83$var$EVENTS.SERIALIZE, addonRef.contextExtension);
};
const $415f5ed0e3504d83$export$6503ec6e8aabbaf = (key, onSerialized, onValidated)=>{
    $415f5ed0e3504d83$var$internalListOfAddons[key] = {
        onSerialized: onSerialized,
        onValidated: onValidated
    };
};
const $415f5ed0e3504d83$export$d07f55d4c15c0440 = (key)=>{
    delete $415f5ed0e3504d83$var$internalListOfAddons[key];
};

});


parcelRegister("2Np0t", function(module, exports) {
$parcel$export(module.exports, "getAll", () => $d63f77e9fda83afc$export$2774c37398bee8b2);
$parcel$export(module.exports, "get", () => $d63f77e9fda83afc$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $d63f77e9fda83afc$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "addParamsToUrl", () => $d63f77e9fda83afc$export$e1e3ddd390fd26f2);
$parcel$export(module.exports, "removeParamsFromUrl", () => $d63f77e9fda83afc$export$9d6317f3c41bff91);

var $1We2B = parcelRequire("1We2B");

var $h1yZX = parcelRequire("h1yZX");

var $7FSs7 = parcelRequire("7FSs7");
function $d63f77e9fda83afc$export$2774c37398bee8b2() {
    if (!(0, $7FSs7.default).location.search) return {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...$h1yZX.parse((0, $7FSs7.default).location.search)
    };
}
function $d63f77e9fda83afc$export$3988ae62b71be9a3(key) {
    const values = $d63f77e9fda83afc$export$2774c37398bee8b2();
    return values && values[key];
}
const $d63f77e9fda83afc$export$fac44ee5b035f737 = (queryParams)=>$h1yZX.stringify(queryParams).replace(/%20/g, '+');
function $d63f77e9fda83afc$export$adaa4cf7ef1b65be(newValues, replace = true) {
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const values = $h1yZX.parse((0, $7FSs7.default).location.search);
    const search = $d63f77e9fda83afc$export$fac44ee5b035f737({
        ...values,
        ...newValues
    });
    const newLocation = {
        ...(0, $7FSs7.default).location,
        search: search
    };
    if (replace) (0, $7FSs7.default).replace(newLocation);
    else (0, $7FSs7.default).push(newLocation);
}
const $d63f77e9fda83afc$export$e1e3ddd390fd26f2 = (url, addParams)=>{
    const qs = $h1yZX.extract(url);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const params = {
        ...$h1yZX.parse(qs),
        ...addParams
    };
    const newQueryString = $d63f77e9fda83afc$export$fac44ee5b035f737(params);
    if (newQueryString) return `${url.split('?')[0]}?${newQueryString}`;
    return url;
};
const $d63f77e9fda83afc$export$9d6317f3c41bff91 = (url, paramsToRemove)=>{
    const qs = $h1yZX.extract(url);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const params = $h1yZX.parse(qs);
    let isParamsRemoved = false;
    paramsToRemove.forEach((paramToRemove)=>{
        if ((0, $1We2B.has)(params, paramToRemove)) {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            delete params[paramToRemove];
            isParamsRemoved = true;
        }
    });
    // don't modify url if there is nothing to remove
    if (!isParamsRemoved) return url;
    const newQueryString = $d63f77e9fda83afc$export$fac44ee5b035f737(params);
    const urlWithoutQuery = url.split('?')[0];
    if (newQueryString) return `${urlWithoutQuery}?${newQueryString}`;
    return urlWithoutQuery;
};

});
parcelRegister("h1yZX", function(module, exports) {
$parcel$export(module.exports, "extract", () => $c64dad939742facf$export$f9380c9a627682d3, (v) => $c64dad939742facf$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $c64dad939742facf$export$98e6a39c04603d36, (v) => $c64dad939742facf$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $c64dad939742facf$export$fac44ee5b035f737, (v) => $c64dad939742facf$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $c64dad939742facf$export$7a5253c0f62e0150, (v) => $c64dad939742facf$export$7a5253c0f62e0150 = v);
var $c64dad939742facf$export$f9380c9a627682d3;
var $c64dad939742facf$export$98e6a39c04603d36;
var $c64dad939742facf$export$fac44ee5b035f737;
var $c64dad939742facf$export$7a5253c0f62e0150;
'use strict';

var $6Decr = parcelRequire("6Decr");

var $4odPp = parcelRequire("4odPp");

var $2CzF2 = parcelRequire("2CzF2");
function $c64dad939742facf$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $c64dad939742facf$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $c64dad939742facf$var$encode(key, opts),
                    '[',
                    $c64dad939742facf$var$encode(index, opts),
                    ']=',
                    $c64dad939742facf$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $c64dad939742facf$var$encode(key, opts) : [
                    $c64dad939742facf$var$encode(key, opts),
                    '[]=',
                    $c64dad939742facf$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $c64dad939742facf$var$encode(key, opts) : [
                    $c64dad939742facf$var$encode(key, opts),
                    '=',
                    $c64dad939742facf$var$encode(value, opts)
                ].join('');
            };
    }
}
function $c64dad939742facf$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $c64dad939742facf$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $6Decr(value) : encodeURIComponent(value);
    return value;
}
function $c64dad939742facf$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $c64dad939742facf$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $c64dad939742facf$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $c64dad939742facf$var$parse(str, opts) {
    opts = $4odPp({
        arrayFormat: 'none'
    }, opts);
    var formatter = $c64dad939742facf$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $2CzF2(val);
        formatter($2CzF2(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $c64dad939742facf$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$c64dad939742facf$export$f9380c9a627682d3 = $c64dad939742facf$var$extract;
$c64dad939742facf$export$98e6a39c04603d36 = $c64dad939742facf$var$parse;
$c64dad939742facf$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $4odPp(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $c64dad939742facf$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $c64dad939742facf$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $c64dad939742facf$var$encode(key, opts) + '=' + $c64dad939742facf$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$c64dad939742facf$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $c64dad939742facf$var$parse($c64dad939742facf$var$extract(str), opts)
    };
};

});
parcelRegister("6Decr", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("4odPp", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $3324214c1fda2c0a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3324214c1fda2c0a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3324214c1fda2c0a$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3324214c1fda2c0a$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $3324214c1fda2c0a$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3324214c1fda2c0a$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3324214c1fda2c0a$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3324214c1fda2c0a$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3324214c1fda2c0a$var$getOwnPropertySymbols) {
            symbols = $3324214c1fda2c0a$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3324214c1fda2c0a$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("6GNhI", function(module, exports) {
$parcel$export(module.exports, "reload", () => $2c100592f6b5f15c$export$32da5b5043dcd88c);
$parcel$export(module.exports, "replace", () => $2c100592f6b5f15c$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "pathname", () => $2c100592f6b5f15c$export$7333db99aa99d383);
$parcel$export(module.exports, "location", () => $2c100592f6b5f15c$export$17b07c660794dc13);
$parcel$export(module.exports, "href", () => $2c100592f6b5f15c$export$8f51af5840e0602a);
$parcel$export(module.exports, "hash", () => $2c100592f6b5f15c$export$d6af199866bfb566);
$parcel$export(module.exports, "origin", () => $2c100592f6b5f15c$export$f710a83a91838a36);
$parcel$export(module.exports, "search", () => $2c100592f6b5f15c$export$d76128d007d19019);
$parcel$export(module.exports, "open", () => $2c100592f6b5f15c$export$3ce6949f20cea765);
$parcel$export(module.exports, "assign", () => $2c100592f6b5f15c$export$e6e34fd1f2686227);
$parcel$export(module.exports, "isValidLocation", () => $2c100592f6b5f15c$export$f15ea956d38b6f8a);

var $1We2B = parcelRequire("1We2B");
const $2c100592f6b5f15c$export$32da5b5043dcd88c = ()=>window.location.reload();
const $2c100592f6b5f15c$export$77ad94ebf1c2b9ed = (path)=>window.location.replace(path);
const $2c100592f6b5f15c$export$7333db99aa99d383 = ()=>window.location.pathname;
const $2c100592f6b5f15c$export$17b07c660794dc13 = ()=>window.location;
const $2c100592f6b5f15c$export$8f51af5840e0602a = ()=>window.location.href;
const $2c100592f6b5f15c$export$d6af199866bfb566 = ()=>window.location.hash;
const $2c100592f6b5f15c$export$f710a83a91838a36 = ()=>window.location.origin;
const $2c100592f6b5f15c$export$d76128d007d19019 = ()=>window.location.search;
const $2c100592f6b5f15c$export$3ce6949f20cea765 = (url, target)=>window.open(url, target);
const $2c100592f6b5f15c$export$e6e34fd1f2686227 = (url)=>window.location.assign(url);
const $2c100592f6b5f15c$export$f15ea956d38b6f8a = (maybeUrl)=>{
    if (decodeURIComponent(maybeUrl).startsWith('//')) return false;
    return (0, $1We2B.startsWith)(maybeUrl, 'http') || (0, $1We2B.startsWith)(maybeUrl, '/') || (0, $1We2B.startsWith)(maybeUrl, '%2F') || (0, $1We2B.startsWith)(maybeUrl, '%2f');
};

});

parcelRegister("2V8Gk", function(module, exports) {
$parcel$export(module.exports, "install", () => $50038558160c12f9$export$4b3e715f166fdd78);

var $9dPOl = parcelRequire("9dPOl");
var $jOQ1l = parcelRequire("jOQ1l");
var $3Gufo = parcelRequire("3Gufo");

var $7g6jd = parcelRequire("7g6jd");

var $1lG1b = parcelRequire("1lG1b");

var $jByYr = parcelRequire("jByYr");

var $hrPHR = parcelRequire("hrPHR");
function $50038558160c12f9$export$94684a7ef5037b24(event) {
    try {
        var _event$exception;
        const rewriteStacktrace = (value)=>{
            var _value$stacktrace, _value$stacktrace2;
            if (!Array.isArray(value === null || value === void 0 || (_value$stacktrace = value.stacktrace) === null || _value$stacktrace === void 0 ? void 0 : _value$stacktrace.frames)) return;
            value === null || value === void 0 || (_value$stacktrace2 = value.stacktrace) === null || _value$stacktrace2 === void 0 || _value$stacktrace2.frames.forEach((frame)=>{
                if (!frame.filename) return;
                // Yes, we're manipulating the input, this is an implicit choice for this part
                // of the codebase
                frame.filename = frame.filename.replace('/assets-brotli/', '/assets/');
            });
        };
        // for non-error errors there can be a top-level `event.stacktrace`
        rewriteStacktrace(event);
        // for normal errors there can be exception.values, these might contain stacktraces
        if (Array.isArray(event === null || event === void 0 || (_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : _event$exception.values)) {
            var _event$exception2;
            event === null || event === void 0 || (_event$exception2 = event.exception) === null || _event$exception2 === void 0 || _event$exception2.values.forEach(rewriteStacktrace);
        }
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.warn('Unable to rewrite stacktrace filenames', ex);
    }
    return event;
}
function $50038558160c12f9$var$getSentryEnv(env) {
    switch(env){
        case (0, $hrPHR.EnvType).PROD:
            return 'production';
        case (0, $hrPHR.EnvType).STAGING:
            return 'staging';
        default:
            return 'development';
    }
}
class $50038558160c12f9$var$SentryInstaller {
    static install() {
        // Check if we have already initialised Sentry to be defensive in case two fragments are loaded in the same page, we don't want duplicated error reports.
        const client = $jOQ1l.getCurrentHub().getClient();
        if (client && client.getOptions().enabled) return;
        $3Gufo.init({
            dsn: $50038558160c12f9$var$SentryInstaller.JS_ERROR_TRACKING_SENTRY_URL,
            release: $50038558160c12f9$var$SentryInstaller.getRelease(),
            environment: $50038558160c12f9$var$getSentryEnv((0, $hrPHR.getEnv)().environment),
            // This is evaluated against the *first* frame of the stack trace. If it doesn't match, the error is not sent.
            whitelistUrls: $50038558160c12f9$var$SentryInstaller.FRONTEND_RESOURCES,
            beforeSend: (event)=>{
                return $50038558160c12f9$export$94684a7ef5037b24(event);
            },
            maxBreadcrumbs: 100,
            integrations: (integrations)=>{
                integrations.push(// This is used to mark which frames of the stacktrace are part of our app. They will be displayed in a different UI in Sentry.
                new $7g6jd.RewriteFrames({
                    iteratee: (frame)=>{
                        if (frame.filename) frame.in_app = $50038558160c12f9$var$SentryInstaller.FRONTEND_RESOURCES.some((path)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            path.test(frame.filename));
                        return frame;
                    }
                }));
                return integrations;
            }
        });
        // This is for OpsGenie, so that alerts are tagged correctly.
        $9dPOl.configureScope((scope)=>{
            scope.setTag('environment_type', (0, $hrPHR.getEnv)().environment);
            scope.setTag('service_id', 'jsm-portal-frontend');
            const commit = $50038558160c12f9$var$SentryInstaller.getCommit();
            if (commit) scope.setTag('commit', commit);
            const cloudId = $50038558160c12f9$var$SentryInstaller.getCloudId();
            if (cloudId) scope.setTag('cloud_id', cloudId);
        });
    // TODO: add Aa ID + feature flags state tracking  - FSD-2309
    }
    static #_ = // TODO: extract this URL in a env variable - FSD-2309
    this.JS_ERROR_TRACKING_SENTRY_URL = (0, $1lG1b.isFedRamp)() ? 'https://9f5728b18f4afcbbd6127c57b615afa3@sentry.prod.services.kitt-inf-us-gov-mod.net/15' : 'https://dc9ea62591514adf8234e2c995959d5c@o55978.ingest.sentry.io/5988807';
    static #_2 = this.FRONTEND_RESOURCES = [
        // Our DEV and PROD environments in Micros Static.
        /https:\/\/jsm-portal-frontend\..*\.atl-paas\.net\//,
        /https:\/\/jsd-portal-frontend\..*\.atl-paas\.net\//,
        /https:\/\/jsm-help-center-ui\..*\.atl-paas\.net\//,
        /https:\/\/jsm-help-center-ui\..*\.atlassian-us-gov-mod\.com\//,
        // For devs using `yarn dev`.
        /localhost/
    ];
    static getCommit() {
        if (window.JSD_CUSTOMER_PORTAL_BUILD_VERSION && window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.commit) return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.commit;
        return undefined;
    }
    static getRelease() {
        return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION && window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.buildKey;
    }
    static getCloudId() {
        return (0, $jByYr.getMeta)('tenant-id');
    }
}
const $50038558160c12f9$export$4b3e715f166fdd78 = $50038558160c12f9$var$SentryInstaller.install;

});
parcelRegister("3Gufo", function(module, exports) {
$parcel$export(module.exports, "defaultIntegrations", () => $2aecc1d23f886a80$export$5ef831fccfce35e5);
$parcel$export(module.exports, "init", () => $2aecc1d23f886a80$export$2cd8252107eb640b);
$parcel$export(module.exports, "showReportDialog", () => $2aecc1d23f886a80$export$3a8fd680da42627b);
$parcel$export(module.exports, "lastEventId", () => $2aecc1d23f886a80$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "forceLoad", () => $2aecc1d23f886a80$export$a3f323d81eede727);
$parcel$export(module.exports, "onLoad", () => $2aecc1d23f886a80$export$4e4d8b287d028b6b);
$parcel$export(module.exports, "flush", () => $2aecc1d23f886a80$export$4909b86c8034bf73);
$parcel$export(module.exports, "close", () => $2aecc1d23f886a80$export$8360e631d277ea4d);
$parcel$export(module.exports, "wrap", () => $2aecc1d23f886a80$export$4997ffc0176396a6);

var $26Yns = parcelRequire("26Yns");

var $jOQ1l = parcelRequire("jOQ1l");
var $hjuID = parcelRequire("hjuID");
var $5ruwa = parcelRequire("5ruwa");
parcelRequire("khHJA");
var $9kMYu = parcelRequire("9kMYu");
var $eCKEK = parcelRequire("eCKEK");
var $g22PF = parcelRequire("g22PF");
var $73tIz = parcelRequire("73tIz");

var $31xdy = parcelRequire("31xdy");

var $2GohQ = parcelRequire("2GohQ");

var $1gtR4 = parcelRequire("1gtR4");

var $hKlbM = parcelRequire("hKlbM");
var $9Ez91 = parcelRequire("9Ez91");
var $5pCOQ = parcelRequire("5pCOQ");
var $9WQK8 = parcelRequire("9WQK8");
var $aiiSG = parcelRequire("aiiSG");
var $91Czo = parcelRequire("91Czo");
var $2aecc1d23f886a80$export$5ef831fccfce35e5 = [
    new (0, $5ruwa).InboundFilters(),
    new (0, $5ruwa).FunctionToString(),
    new (0, $aiiSG.TryCatch)(),
    new (0, $hKlbM.Breadcrumbs)(),
    new (0, $5pCOQ.GlobalHandlers)(),
    new (0, $9WQK8.LinkedErrors)(),
    new (0, $9Ez91.Dedupe)(),
    new (0, $91Czo.UserAgent)()
];
function $2aecc1d23f886a80$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $2aecc1d23f886a80$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $eCKEK.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $hjuID.initAndBind)((0, $31xdy.BrowserClient), options);
    if (options.autoSessionTracking) $2aecc1d23f886a80$var$startSessionTracking();
}
function $2aecc1d23f886a80$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $jOQ1l.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $2aecc1d23f886a80$export$5d4e9fd7fac8e617() {
    return (0, $jOQ1l.getCurrentHub)().lastEventId();
}
function $2aecc1d23f886a80$export$a3f323d81eede727() {
// Noop
}
function $2aecc1d23f886a80$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $2aecc1d23f886a80$export$4909b86c8034bf73(timeout) {
    var client = (0, $jOQ1l.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('Cannot flush events. No client defined.');
    return (0, $73tIz.resolvedSyncPromise)(false);
}
function $2aecc1d23f886a80$export$8360e631d277ea4d(timeout) {
    var client = (0, $jOQ1l.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $73tIz.resolvedSyncPromise)(false);
}
function $2aecc1d23f886a80$export$4997ffc0176396a6(fn) {
    return (0, $1gtR4.wrap)(fn)();
}
function $2aecc1d23f886a80$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $2aecc1d23f886a80$var$startSessionTracking() {
    var window = (0, $eCKEK.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $jOQ1l.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $2aecc1d23f886a80$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $9kMYu.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $2aecc1d23f886a80$var$startSessionOnHub((0, $jOQ1l.getCurrentHub)());
    });
}

});
parcelRegister("hjuID", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $c9ac0a232a729360$export$5333c3f1c58d9bc1);

var $jOQ1l = parcelRequire("jOQ1l");
parcelRequire("khHJA");
var $g22PF = parcelRequire("g22PF");

var $i39so = parcelRequire("i39so");
function $c9ac0a232a729360$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $i39so.IS_DEBUG_BUILD) (0, $g22PF.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $jOQ1l.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});
parcelRegister("i39so", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $d23fd7bc93c22e56$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $d23fd7bc93c22e56$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("5ruwa", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("dxGdd")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("eIdHD")).InboundFilters);

var $dxGdd = parcelRequire("dxGdd");

var $eIdHD = parcelRequire("eIdHD");

});
parcelRegister("dxGdd", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => $9dbf19e4cefbca34$export$da4704525c20ae79);
parcelRequire("khHJA");
var $jvXYw = parcelRequire("jvXYw");
var $9dbf19e4cefbca34$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $9dbf19e4cefbca34$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $9dbf19e4cefbca34$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $jvXYw.getOriginalFunction)(this) || this;
            return $9dbf19e4cefbca34$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("eIdHD", function(module, exports) {
$parcel$export(module.exports, "InboundFilters", () => $ab5fcdd40f7e8fe2$export$2ffbb5359dcc6be4);

var $26Yns = parcelRequire("26Yns");
parcelRequire("khHJA");
var $1QJ8J = parcelRequire("1QJ8J");
var $1JVAb = parcelRequire("1JVAb");
var $g22PF = parcelRequire("g22PF");

var $i39so = parcelRequire("i39so");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $ab5fcdd40f7e8fe2$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $ab5fcdd40f7e8fe2$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $ab5fcdd40f7e8fe2$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $ab5fcdd40f7e8fe2$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $ab5fcdd40f7e8fe2$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $26Yns.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $26Yns.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $26Yns.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $ab5fcdd40f7e8fe2$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $ab5fcdd40f7e8fe2$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $ab5fcdd40f7e8fe2$var$_isSentryError(event)) {
        (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $1QJ8J.getEventDescription)(event));
        return true;
    }
    if ($ab5fcdd40f7e8fe2$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $1QJ8J.getEventDescription)(event));
        return true;
    }
    if ($ab5fcdd40f7e8fe2$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $1QJ8J.getEventDescription)(event) + ".\nUrl: " + $ab5fcdd40f7e8fe2$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$ab5fcdd40f7e8fe2$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $1QJ8J.getEventDescription)(event) + ".\nUrl: " + $ab5fcdd40f7e8fe2$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $ab5fcdd40f7e8fe2$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $ab5fcdd40f7e8fe2$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $1JVAb.isMatchingPattern)(message, pattern);
        });
    });
}
function $ab5fcdd40f7e8fe2$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $ab5fcdd40f7e8fe2$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $1JVAb.isMatchingPattern)(url, pattern);
    });
}
function $ab5fcdd40f7e8fe2$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $ab5fcdd40f7e8fe2$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $1JVAb.isMatchingPattern)(url, pattern);
    });
}
function $ab5fcdd40f7e8fe2$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).error("Cannot extract message for event " + (0, $1QJ8J.getEventDescription)(event));
        return [];
    }
    return [];
}
function $ab5fcdd40f7e8fe2$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $ab5fcdd40f7e8fe2$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $ab5fcdd40f7e8fe2$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $ab5fcdd40f7e8fe2$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $ab5fcdd40f7e8fe2$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).error("Cannot extract url for event " + (0, $1QJ8J.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("31xdy", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $233b3b65b54813c7$export$1df9218a526d318d);

var $26Yns = parcelRequire("26Yns");

var $kdKTJ = parcelRequire("kdKTJ");
var $9qb1h = parcelRequire("9qb1h");
parcelRequire("khHJA");
var $eCKEK = parcelRequire("eCKEK");
var $g22PF = parcelRequire("g22PF");

var $75ASw = parcelRequire("75ASw");

var $2GohQ = parcelRequire("2GohQ");

var $1gtR4 = parcelRequire("1gtR4");

var $hKlbM = parcelRequire("hKlbM");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $233b3b65b54813c7$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $26Yns.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $9qb1h.SDK_VERSION)
                }
            ],
            version: (0, $9qb1h.SDK_VERSION)
        };
        _this = _super.call(this, (0, $75ASw.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $eCKEK.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $1gtR4.injectReportDialog)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $hKlbM.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $kdKTJ.BaseClient));

});
parcelRegister("kdKTJ", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $eb896678a568face$export$4f22f74eddb7716a);

var $26Yns = parcelRequire("26Yns");

var $9I9eJ = parcelRequire("9I9eJ");
parcelRequire("khHJA");
var $1QJ8J = parcelRequire("1QJ8J");
var $fiIpw = parcelRequire("fiIpw");
var $7dhJq = parcelRequire("7dhJq");
var $g22PF = parcelRequire("g22PF");
var $a7iFf = parcelRequire("a7iFf");
var $03yOv = parcelRequire("03yOv");
var $73tIz = parcelRequire("73tIz");
var $9HMyy = parcelRequire("9HMyy");
var $1JVAb = parcelRequire("1JVAb");

var $i39so = parcelRequire("i39so");

var $9tPBS = parcelRequire("9tPBS");
var $eb896678a568face$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $eb896678a568face$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $a7iFf.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $1QJ8J.checkOrSetAlreadyCaught)(exception)) {
            (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).log($eb896678a568face$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $7dhJq.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $1QJ8J.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).log($eb896678a568face$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $9tPBS.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $26Yns.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $26Yns.__assign)((0, $26Yns.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $73tIz.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $1QJ8J.uuid4)()),
            timestamp: event.timestamp || (0, $fiIpw.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $9I9eJ.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $73tIz.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $03yOv.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, b), b.data && {
                    data: (0, $03yOv.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $03yOv.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $03yOv.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $03yOv.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $1JVAb.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $1JVAb.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $1JVAb.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $26Yns.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $73tIz.rejectedSyncPromise)(new (0, $9HMyy.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $73tIz.rejectedSyncPromise)(new (0, $9HMyy.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $9HMyy.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $eb896678a568face$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $9HMyy.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $9HMyy.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $9HMyy.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $eb896678a568face$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $7dhJq.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $7dhJq.isPlainObject)(event) || event === null)) throw new (0, $9HMyy.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $9HMyy.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $7dhJq.isPlainObject)(rv) || rv === null)) throw new (0, $9HMyy.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("9tPBS", function(module, exports) {
$parcel$export(module.exports, "setupIntegrations", () => $6e6edb2190f89aad$export$51abed9797baa598);

var $26Yns = parcelRequire("26Yns");

var $9I9eJ = parcelRequire("9I9eJ");
var $jOQ1l = parcelRequire("jOQ1l");
parcelRequire("khHJA");
var $jvXYw = parcelRequire("jvXYw");
var $g22PF = parcelRequire("g22PF");

var $i39so = parcelRequire("i39so");
var $6e6edb2190f89aad$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $6e6edb2190f89aad$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $6e6edb2190f89aad$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $26Yns.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $26Yns.__spread)($6e6edb2190f89aad$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $26Yns.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $6e6edb2190f89aad$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $26Yns.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $6e6edb2190f89aad$export$e7390a03b70a6f2f(integration) {
    if ($6e6edb2190f89aad$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $9I9eJ.addGlobalEventProcessor), (0, $jOQ1l.getCurrentHub));
    $6e6edb2190f89aad$export$b14a8888f80a0b3e.push(integration.name);
    (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).log("Integration installed: " + integration.name);
}
function $6e6edb2190f89aad$export$51abed9797baa598(options) {
    var integrations = {};
    $6e6edb2190f89aad$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $6e6edb2190f89aad$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $jvXYw.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("9qb1h", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $6dbf170bca2f0a6b$export$31499a9cd224b78c);
var $6dbf170bca2f0a6b$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("75ASw", function(module, exports) {
$parcel$export(module.exports, "BrowserBackend", () => $52959b5310707ab1$export$2526e21aec9d0ce7);

var $26Yns = parcelRequire("26Yns");

var $fJR33 = parcelRequire("fJR33");
var $8BAwm = parcelRequire("8BAwm");

var $7dUhV = parcelRequire("7dUhV");
parcelRequire("khHJA");
var $8rfhF = parcelRequire("8rfhF");

var $kgbg7 = parcelRequire("kgbg7");

var $6KqSt = parcelRequire("6KqSt");
var $kNFcE = parcelRequire("kNFcE");
var $e2ZoK = parcelRequire("e2ZoK");
var $9bneS = parcelRequire("9bneS");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $52959b5310707ab1$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $kgbg7.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $7dUhV.Severity).Info;
        return (0, $kgbg7.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $8BAwm.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $8BAwm.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $8rfhF.supportsFetch)()) {
            var requestOptions = (0, $26Yns.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $kNFcE.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $6KqSt.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $e2ZoK.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $9bneS.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $fJR33.BaseBackend));

});
parcelRegister("fJR33", function(module, exports) {
$parcel$export(module.exports, "BaseBackend", () => $b7543548d7e5444c$export$8f43a53a38d7e95f);

var $26Yns = parcelRequire("26Yns");
parcelRequire("khHJA");
var $g22PF = parcelRequire("g22PF");
var $9HMyy = parcelRequire("9HMyy");

var $8BAwm = parcelRequire("8BAwm");

var $i39so = parcelRequire("i39so");

var $2d8e6 = parcelRequire("2d8e6");

var $9MKo3 = parcelRequire("9MKo3");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $b7543548d7e5444c$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $9HMyy.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $9HMyy.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $8BAwm.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $2d8e6.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $8BAwm.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $26Yns.__read)((0, $2d8e6.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $i39so.IS_DEBUG_BUILD) && (0, $g22PF.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $9MKo3.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("8BAwm", function(module, exports) {
$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $643e1bb503b50558$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $643e1bb503b50558$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $643e1bb503b50558$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $643e1bb503b50558$export$671c7ed8e40a7a57);
parcelRequire("khHJA");
var $a7iFf = parcelRequire("a7iFf");
var $jvXYw = parcelRequire("jvXYw");
var $643e1bb503b50558$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $643e1bb503b50558$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $a7iFf.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $643e1bb503b50558$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $643e1bb503b50558$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $643e1bb503b50558$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $643e1bb503b50558$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $643e1bb503b50558$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $a7iFf.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $643e1bb503b50558$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $643e1bb503b50558$var$_getIngestEndpoint(dsn, target) {
    return "" + $643e1bb503b50558$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $643e1bb503b50558$var$_encodedAuth(dsn) {
    return (0, $jvXYw.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $643e1bb503b50558$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $643e1bb503b50558$var$getStoreEndpoint(dsn) {
    return $643e1bb503b50558$var$_getIngestEndpoint(dsn, 'store');
}
function $643e1bb503b50558$export$c1677e22ac2217a5(dsn) {
    return $643e1bb503b50558$var$getStoreEndpoint(dsn) + "?" + $643e1bb503b50558$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $643e1bb503b50558$var$_getEnvelopeEndpoint(dsn) {
    return $643e1bb503b50558$var$_getIngestEndpoint(dsn, 'envelope');
}
function $643e1bb503b50558$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $643e1bb503b50558$var$_getEnvelopeEndpoint(dsn) + "?" + $643e1bb503b50558$var$_encodedAuth(dsn);
}
function $643e1bb503b50558$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $643e1bb503b50558$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $643e1bb503b50558$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $a7iFf.makeDsn)(dsnLike);
    var endpoint = $643e1bb503b50558$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $a7iFf.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("2d8e6", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $19c32d47811c933e$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $19c32d47811c933e$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $19c32d47811c933e$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $19c32d47811c933e$export$2006389de558b996);

var $26Yns = parcelRequire("26Yns");
parcelRequire("khHJA");
var $7YW6e = parcelRequire("7YW6e");
var $a7iFf = parcelRequire("a7iFf");
var $03yOv = parcelRequire("03yOv");

var $8BAwm = parcelRequire("8BAwm");
/** Extract sdk info from from the API metadata */ function $19c32d47811c933e$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $19c32d47811c933e$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $26Yns.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $26Yns.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $19c32d47811c933e$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $19c32d47811c933e$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $26Yns.__assign)((0, $26Yns.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $a7iFf.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $7YW6e.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $19c32d47811c933e$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $26Yns.__read)($19c32d47811c933e$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $7YW6e.serializeEnvelope)(envelope),
        type: type,
        url: (0, $8BAwm.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $19c32d47811c933e$export$c31057337a18010f(event, api) {
    var sdkInfo = $19c32d47811c933e$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $19c32d47811c933e$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $26Yns.__assign)((0, $26Yns.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $a7iFf.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $7YW6e.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $19c32d47811c933e$export$2006389de558b996(event, api) {
    var sdkInfo = $19c32d47811c933e$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $19c32d47811c933e$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $03yOv.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $8BAwm.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $8BAwm.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $26Yns.__assign)((0, $26Yns.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $a7iFf.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $7YW6e.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $7YW6e.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("9MKo3", function(module, exports) {
$parcel$export(module.exports, "NoopTransport", () => $71fc9439db8230a4$export$6f2767450ea1346c);
parcelRequire("khHJA");
var $73tIz = parcelRequire("73tIz");
/** Noop transport */ var $71fc9439db8230a4$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $73tIz.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $73tIz.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("kgbg7", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $ebfe090f29d738c5$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $ebfe090f29d738c5$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $ebfe090f29d738c5$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $ebfe090f29d738c5$export$5425b53185d13d6c);

var $26Yns = parcelRequire("26Yns");

var $7dUhV = parcelRequire("7dUhV");
parcelRequire("khHJA");
var $1QJ8J = parcelRequire("1QJ8J");
var $7sB74 = parcelRequire("7sB74");
var $jvXYw = parcelRequire("jvXYw");
var $7dhJq = parcelRequire("7dhJq");
var $03yOv = parcelRequire("03yOv");
var $73tIz = parcelRequire("73tIz");

var $5UM1T = parcelRequire("5UM1T");
function $ebfe090f29d738c5$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $ebfe090f29d738c5$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $ebfe090f29d738c5$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $ebfe090f29d738c5$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $7dhJq.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $jvXYw.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $03yOv.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $ebfe090f29d738c5$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $ebfe090f29d738c5$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $ebfe090f29d738c5$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $ebfe090f29d738c5$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $ebfe090f29d738c5$var$getPopSize(ex);
    try {
        return (0, $7sB74.createStackParser)((0, $5UM1T.opera10StackParser), (0, $5UM1T.opera11StackParser), (0, $5UM1T.chromeStackParser), (0, $5UM1T.winjsStackParser), (0, $5UM1T.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $ebfe090f29d738c5$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $ebfe090f29d738c5$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($ebfe090f29d738c5$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $ebfe090f29d738c5$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $ebfe090f29d738c5$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $ebfe090f29d738c5$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $1QJ8J.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $7dUhV.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $73tIz.resolvedSyncPromise)(event);
}
function $ebfe090f29d738c5$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $7dUhV.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $ebfe090f29d738c5$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $73tIz.resolvedSyncPromise)(event);
}
function $ebfe090f29d738c5$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $7dhJq.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $ebfe090f29d738c5$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $7dhJq.isDOMError)(exception) || (0, $7dhJq.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $ebfe090f29d738c5$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $7dhJq.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $ebfe090f29d738c5$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $1QJ8J.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $7dhJq.isError)(exception)) // we have a real Error object, do nothing
    return $ebfe090f29d738c5$export$73fbea5a0a5234af(exception);
    if ((0, $7dhJq.isPlainObject)(exception) || (0, $7dhJq.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $ebfe090f29d738c5$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $1QJ8J.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $ebfe090f29d738c5$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $1QJ8J.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $1QJ8J.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $ebfe090f29d738c5$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $ebfe090f29d738c5$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("5UM1T", function(module, exports) {
$parcel$export(module.exports, "chromeStackParser", () => $44e7705dc448e81a$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $44e7705dc448e81a$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $44e7705dc448e81a$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $44e7705dc448e81a$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $44e7705dc448e81a$export$989a1824b4734ce6);

var $26Yns = parcelRequire("26Yns");
// global reference to slice
var $44e7705dc448e81a$var$UNKNOWN_FUNCTION = '?';
var $44e7705dc448e81a$var$OPERA10_PRIORITY = 10;
var $44e7705dc448e81a$var$OPERA11_PRIORITY = 20;
var $44e7705dc448e81a$var$CHROME_PRIORITY = 30;
var $44e7705dc448e81a$var$WINJS_PRIORITY = 40;
var $44e7705dc448e81a$var$GECKO_PRIORITY = 50;
function $44e7705dc448e81a$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $44e7705dc448e81a$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $44e7705dc448e81a$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $44e7705dc448e81a$var$chrome = function(line) {
    var parts = $44e7705dc448e81a$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $44e7705dc448e81a$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $26Yns.__read)($44e7705dc448e81a$var$extractSafariExtensionDetails(parts[1] || $44e7705dc448e81a$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $44e7705dc448e81a$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $44e7705dc448e81a$export$c693d9295441d8f9 = [
    $44e7705dc448e81a$var$CHROME_PRIORITY,
    $44e7705dc448e81a$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $44e7705dc448e81a$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $44e7705dc448e81a$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $44e7705dc448e81a$var$gecko = function(line) {
    var _a;
    var parts = $44e7705dc448e81a$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $44e7705dc448e81a$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $44e7705dc448e81a$var$UNKNOWN_FUNCTION;
        _a = (0, $26Yns.__read)($44e7705dc448e81a$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $44e7705dc448e81a$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $44e7705dc448e81a$export$c9ddf1e2b5d48bff = [
    $44e7705dc448e81a$var$GECKO_PRIORITY,
    $44e7705dc448e81a$var$gecko
];
var $44e7705dc448e81a$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $44e7705dc448e81a$var$winjs = function(line) {
    var parts = $44e7705dc448e81a$var$winjsRegex.exec(line);
    return parts ? $44e7705dc448e81a$var$createFrame(parts[2], parts[1] || $44e7705dc448e81a$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $44e7705dc448e81a$export$b6d155d85c1dcba5 = [
    $44e7705dc448e81a$var$WINJS_PRIORITY,
    $44e7705dc448e81a$var$winjs
];
var $44e7705dc448e81a$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $44e7705dc448e81a$var$opera10 = function(line) {
    var parts = $44e7705dc448e81a$var$opera10Regex.exec(line);
    return parts ? $44e7705dc448e81a$var$createFrame(parts[2], parts[3] || $44e7705dc448e81a$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $44e7705dc448e81a$export$966ec832d9699d6 = [
    $44e7705dc448e81a$var$OPERA10_PRIORITY,
    $44e7705dc448e81a$var$opera10
];
var $44e7705dc448e81a$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $44e7705dc448e81a$var$opera11 = function(line) {
    var parts = $44e7705dc448e81a$var$opera11Regex.exec(line);
    return parts ? $44e7705dc448e81a$var$createFrame(parts[5], parts[3] || parts[4] || $44e7705dc448e81a$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $44e7705dc448e81a$export$989a1824b4734ce6 = [
    $44e7705dc448e81a$var$OPERA11_PRIORITY,
    $44e7705dc448e81a$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $44e7705dc448e81a$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $44e7705dc448e81a$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("6KqSt", function(module, exports) {
$parcel$export(module.exports, "FetchTransport", () => $4e9be34892bec6fa$export$2bdee3f9b92f4e82);

var $26Yns = parcelRequire("26Yns");
parcelRequire("khHJA");
var $9HMyy = parcelRequire("9HMyy");
var $8rfhF = parcelRequire("8rfhF");
var $73tIz = parcelRequire("73tIz");

var $2PkH3 = parcelRequire("2PkH3");

var $dnYr6 = parcelRequire("dnYr6");
/** `fetch` based transport */ var $4e9be34892bec6fa$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $dnYr6.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $8rfhF.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $73tIz.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $9HMyy.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $2PkH3.BaseTransport));

});
parcelRegister("2PkH3", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => $20f06573fcc7f4be$export$74b99d619e90f481);

var $26Yns = parcelRequire("26Yns");

var $2d8e6 = parcelRequire("2d8e6");
var $8BAwm = parcelRequire("8BAwm");
parcelRequire("khHJA");
var $frpgL = parcelRequire("frpgL");
var $1RTkP = parcelRequire("1RTkP");
var $a7iFf = parcelRequire("a7iFf");
var $14A9E = parcelRequire("14A9E");
var $eCKEK = parcelRequire("eCKEK");
var $g22PF = parcelRequire("g22PF");
var $enMla = parcelRequire("enMla");
var $7YW6e = parcelRequire("7YW6e");

var $2GohQ = parcelRequire("2GohQ");

var $dnYr6 = parcelRequire("dnYr6");
function $20f06573fcc7f4be$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $20f06573fcc7f4be$var$global = (0, $eCKEK.getGlobalObject)();
/** Base Transport class implementation */ var $20f06573fcc7f4be$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $enMla.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $8BAwm.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $8BAwm.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $20f06573fcc7f4be$var$global.document) $20f06573fcc7f4be$var$global.document.addEventListener('visibilitychange', function() {
            if ($20f06573fcc7f4be$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $2d8e6.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $2d8e6.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $20f06573fcc7f4be$var$requestTypeToCategory(category) + ":" + reason;
        (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).log('No outcomes to flush');
            return;
        }
        (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $8BAwm.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $26Yns.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $frpgL.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $a7iFf.dsnToString)(this._api.dsn));
        try {
            (0, $dnYr6.sendReport)(url, (0, $7YW6e.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $14A9E.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $1RTkP.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $2GohQ.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $g22PF.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $20f06573fcc7f4be$var$requestTypeToCategory(requestType);
        return new Date((0, $1RTkP.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $20f06573fcc7f4be$var$requestTypeToCategory(requestType);
        return (0, $1RTkP.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("2GohQ", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $1f4257e1a88a7b82$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $1f4257e1a88a7b82$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("dnYr6", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $9bec4daddab42cb1$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $9bec4daddab42cb1$export$84bb63b2c17ec44d);
parcelRequire("khHJA");
var $emF3L = parcelRequire("emF3L");
var $eCKEK = parcelRequire("eCKEK");
var $8rfhF = parcelRequire("8rfhF");
var $g22PF = parcelRequire("g22PF");

var $2GohQ = parcelRequire("2GohQ");
var $9bec4daddab42cb1$var$global = (0, $eCKEK.getGlobalObject)();
var $9bec4daddab42cb1$var$cachedFetchImpl;
function $9bec4daddab42cb1$export$8be2119ce08e3379() {
    if ($9bec4daddab42cb1$var$cachedFetchImpl) return $9bec4daddab42cb1$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $8rfhF.isNativeFetch)($9bec4daddab42cb1$var$global.fetch)) return $9bec4daddab42cb1$var$cachedFetchImpl = $9bec4daddab42cb1$var$global.fetch.bind($9bec4daddab42cb1$var$global);
    var document = $9bec4daddab42cb1$var$global.document;
    var fetchImpl = $9bec4daddab42cb1$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $9bec4daddab42cb1$var$cachedFetchImpl = fetchImpl.bind($9bec4daddab42cb1$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $9bec4daddab42cb1$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($9bec4daddab42cb1$var$global && $9bec4daddab42cb1$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $9bec4daddab42cb1$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $9bec4daddab42cb1$var$global.navigator.sendBeacon.bind($9bec4daddab42cb1$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $8rfhF.supportsFetch)()) {
        var fetch_1 = $9bec4daddab42cb1$export$8be2119ce08e3379();
        return (0, $emF3L.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("kNFcE", function(module, exports) {
$parcel$export(module.exports, "makeNewFetchTransport", () => $f248584c06303f53$export$1c57e6bfd09bad13);

var $26Yns = parcelRequire("26Yns");

var $6jSLs = parcelRequire("6jSLs");

var $dnYr6 = parcelRequire("dnYr6");
function $f248584c06303f53$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $dnYr6.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $26Yns.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $6jSLs.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("6jSLs", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $499eff841b26ac28$export$d09f50d9ab7f7b69);
parcelRequire("khHJA");
var $1RTkP = parcelRequire("1RTkP");
var $14A9E = parcelRequire("14A9E");
var $7YW6e = parcelRequire("7YW6e");
var $enMla = parcelRequire("enMla");
var $73tIz = parcelRequire("73tIz");
var $499eff841b26ac28$export$d8a725a7dce95622 = 'error';
var $499eff841b26ac28$export$99adc6fe67a3c63e = 'transaction';
var $499eff841b26ac28$export$9d7ad34f132fe68f = 'attachment';
var $499eff841b26ac28$export$42d9e7b5fc564c45 = 'session';
var $499eff841b26ac28$export$e515cf6dfd2f98b8 = 30;
function $499eff841b26ac28$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $enMla.makePromiseBuffer)(options.bufferSize || $499eff841b26ac28$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $7YW6e.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $7YW6e.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $1RTkP.isRateLimited)(rateLimits, category)) return (0, $73tIz.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $499eff841b26ac28$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $14A9E.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $1RTkP.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $73tIz.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $73tIz.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $499eff841b26ac28$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $499eff841b26ac28$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $1RTkP.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("e2ZoK", function(module, exports) {
$parcel$export(module.exports, "makeNewXHRTransport", () => $a3a0e0ff2f6fedf5$export$4c0ac1dd4bbf4921);

var $6jSLs = parcelRequire("6jSLs");
parcelRequire("khHJA");
var $73tIz = parcelRequire("73tIz");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $a3a0e0ff2f6fedf5$var$XHR_READYSTATE_DONE = 4;
function $a3a0e0ff2f6fedf5$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $73tIz.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $a3a0e0ff2f6fedf5$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $6jSLs.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("9bneS", function(module, exports) {
$parcel$export(module.exports, "XHRTransport", () => $6af72aeebce715c8$export$874a283af77e8e62);

var $26Yns = parcelRequire("26Yns");
parcelRequire("khHJA");
var $9HMyy = parcelRequire("9HMyy");
var $73tIz = parcelRequire("73tIz");

var $2PkH3 = parcelRequire("2PkH3");
/** `XHR` based transport */ var $6af72aeebce715c8$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $73tIz.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $9HMyy.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $2PkH3.BaseTransport));

});


parcelRegister("1gtR4", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreOnError", () => $0ebe71a6dc4929d7$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $0ebe71a6dc4929d7$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $0ebe71a6dc4929d7$export$deb9aac8ea0b576c);

var $26Yns = parcelRequire("26Yns");

var $9dPOl = parcelRequire("9dPOl");
var $8BAwm = parcelRequire("8BAwm");
parcelRequire("khHJA");
var $1QJ8J = parcelRequire("1QJ8J");
var $jvXYw = parcelRequire("jvXYw");
var $eCKEK = parcelRequire("eCKEK");
var $g22PF = parcelRequire("g22PF");

var $2GohQ = parcelRequire("2GohQ");
var $0ebe71a6dc4929d7$var$global = (0, $eCKEK.getGlobalObject)();
var $0ebe71a6dc4929d7$var$ignoreOnError = 0;
function $0ebe71a6dc4929d7$export$b79738ab10c590b2() {
    return $0ebe71a6dc4929d7$var$ignoreOnError > 0;
}
function $0ebe71a6dc4929d7$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $0ebe71a6dc4929d7$var$ignoreOnError += 1;
    setTimeout(function() {
        $0ebe71a6dc4929d7$var$ignoreOnError -= 1;
    });
}
function $0ebe71a6dc4929d7$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $jvXYw.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $0ebe71a6dc4929d7$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $0ebe71a6dc4929d7$export$1265a142ff5ba165();
            (0, $9dPOl.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $1QJ8J.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $1QJ8J.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $9dPOl.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $jvXYw.markFunctionWrapped)(sentryWrapped, fn);
    (0, $jvXYw.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $0ebe71a6dc4929d7$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$0ebe71a6dc4929d7$var$global.document) return;
    if (!options.eventId) {
        (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $0ebe71a6dc4929d7$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $8BAwm.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $0ebe71a6dc4929d7$var$global.document.head || $0ebe71a6dc4929d7$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("hKlbM", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", () => $ceb72b40ff9c7f67$export$2dc68d50d56fbbd);

var $26Yns = parcelRequire("26Yns");

var $jOQ1l = parcelRequire("jOQ1l");

var $7dUhV = parcelRequire("7dUhV");
parcelRequire("khHJA");
var $9kMYu = parcelRequire("9kMYu");
var $1QJ8J = parcelRequire("1QJ8J");
var $eCKEK = parcelRequire("eCKEK");
var $3fvx1 = parcelRequire("3fvx1");
var $1JVAb = parcelRequire("1JVAb");
var $d4rmG = parcelRequire("d4rmG");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $ceb72b40ff9c7f67$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $26Yns.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $jOQ1l.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $1QJ8J.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $9kMYu.addInstrumentationHandler)('console', $ceb72b40ff9c7f67$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $9kMYu.addInstrumentationHandler)('dom', $ceb72b40ff9c7f67$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $9kMYu.addInstrumentationHandler)('xhr', $ceb72b40ff9c7f67$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $9kMYu.addInstrumentationHandler)('fetch', $ceb72b40ff9c7f67$var$_fetchBreadcrumb);
        if (this._options.history) (0, $9kMYu.addInstrumentationHandler)('history', $ceb72b40ff9c7f67$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ceb72b40ff9c7f67$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $3fvx1.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $3fvx1.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $jOQ1l.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ceb72b40ff9c7f67$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $d4rmG.severityFromString)(handlerData.level),
        message: (0, $1JVAb.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $1JVAb.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $jOQ1l.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ceb72b40ff9c7f67$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $jOQ1l.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ceb72b40ff9c7f67$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $jOQ1l.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $7dUhV.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $jOQ1l.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $26Yns.__assign)((0, $26Yns.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ceb72b40ff9c7f67$var$_historyBreadcrumb(handlerData) {
    var global = (0, $eCKEK.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $1QJ8J.parseUrl)(global.location.href);
    var parsedFrom = (0, $1QJ8J.parseUrl)(from);
    var parsedTo = (0, $1QJ8J.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $jOQ1l.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("9Ez91", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $70731c6fd3b8fa4b$export$688d98c249d31ad3);
parcelRequire("khHJA");
var $g22PF = parcelRequire("g22PF");

var $2GohQ = parcelRequire("2GohQ");
/** Deduplication filter */ var $70731c6fd3b8fa4b$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($70731c6fd3b8fa4b$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $70731c6fd3b8fa4b$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($70731c6fd3b8fa4b$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($70731c6fd3b8fa4b$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $70731c6fd3b8fa4b$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$70731c6fd3b8fa4b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$70731c6fd3b8fa4b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $70731c6fd3b8fa4b$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $70731c6fd3b8fa4b$var$_getExceptionFromEvent(previousEvent);
    var currentException = $70731c6fd3b8fa4b$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$70731c6fd3b8fa4b$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$70731c6fd3b8fa4b$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $70731c6fd3b8fa4b$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $70731c6fd3b8fa4b$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $70731c6fd3b8fa4b$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $70731c6fd3b8fa4b$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $70731c6fd3b8fa4b$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $70731c6fd3b8fa4b$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("5pCOQ", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => $3f0d66301c7235a0$export$204155decbc90e5a);

var $26Yns = parcelRequire("26Yns");

var $jOQ1l = parcelRequire("jOQ1l");

var $7dUhV = parcelRequire("7dUhV");
parcelRequire("khHJA");
var $1QJ8J = parcelRequire("1QJ8J");
var $9kMYu = parcelRequire("9kMYu");
var $3fvx1 = parcelRequire("3fvx1");
var $7dhJq = parcelRequire("7dhJq");
var $g22PF = parcelRequire("g22PF");

var $kgbg7 = parcelRequire("kgbg7");

var $2GohQ = parcelRequire("2GohQ");

var $1gtR4 = parcelRequire("1gtR4");
/** Global handlers */ var $3f0d66301c7235a0$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $3f0d66301c7235a0$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $3f0d66301c7235a0$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $26Yns.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $3f0d66301c7235a0$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $3f0d66301c7235a0$var$_installGlobalOnErrorHandler() {
    (0, $9kMYu.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $26Yns.__read)($3f0d66301c7235a0$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($3f0d66301c7235a0$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $1gtR4.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $7dhJq.isString)(msg) ? $3f0d66301c7235a0$var$_eventFromIncompleteOnError(msg, url, line, column) : $3f0d66301c7235a0$var$_enhanceEventWithInitialFrame((0, $kgbg7.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $7dUhV.Severity).Error;
        $3f0d66301c7235a0$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $3f0d66301c7235a0$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $9kMYu.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $26Yns.__read)($3f0d66301c7235a0$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($3f0d66301c7235a0$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $1gtR4.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $7dhJq.isPrimitive)(error) ? $3f0d66301c7235a0$var$_eventFromRejectionWithPrimitive(error) : (0, $kgbg7.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $7dUhV.Severity).Error;
        $3f0d66301c7235a0$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3f0d66301c7235a0$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3f0d66301c7235a0$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $7dhJq.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $3f0d66301c7235a0$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3f0d66301c7235a0$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $7dhJq.isString)(url) && url.length > 0 ? url : (0, $3fvx1.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3f0d66301c7235a0$var$globalHandlerLog(type) {
    (0, $2GohQ.IS_DEBUG_BUILD) && (0, $g22PF.logger).log("Global Handler attached: " + type);
}
function $3f0d66301c7235a0$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $1QJ8J.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $3f0d66301c7235a0$var$getHubAndAttachStacktrace() {
    var hub = (0, $jOQ1l.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("9WQK8", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $73e271820b2994ff$export$8d1e60aaf616fb4f);

var $26Yns = parcelRequire("26Yns");

var $9I9eJ = parcelRequire("9I9eJ");
var $jOQ1l = parcelRequire("jOQ1l");
parcelRequire("khHJA");
var $7dhJq = parcelRequire("7dhJq");

var $kgbg7 = parcelRequire("kgbg7");
var $73e271820b2994ff$var$DEFAULT_KEY = 'cause';
var $73e271820b2994ff$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $73e271820b2994ff$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $73e271820b2994ff$var$DEFAULT_KEY;
        this._limit = options.limit || $73e271820b2994ff$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $9I9eJ.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $jOQ1l.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $73e271820b2994ff$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $73e271820b2994ff$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $7dhJq.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $73e271820b2994ff$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $26Yns.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $73e271820b2994ff$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $7dhJq.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $kgbg7.exceptionFromError)(error[key]);
    return $73e271820b2994ff$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $26Yns.__spread)([
        exception
    ], stack));
}

});

parcelRegister("aiiSG", function(module, exports) {
$parcel$export(module.exports, "TryCatch", () => $77ea3b2f3172e714$export$f1a018517668e6d3);

var $26Yns = parcelRequire("26Yns");
parcelRequire("khHJA");
var $jvXYw = parcelRequire("jvXYw");
var $7sB74 = parcelRequire("7sB74");
var $eCKEK = parcelRequire("eCKEK");

var $1gtR4 = parcelRequire("1gtR4");
var $77ea3b2f3172e714$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $77ea3b2f3172e714$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $26Yns.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $eCKEK.getGlobalObject)();
        if (this._options.setTimeout) (0, $jvXYw.fill)(global, 'setTimeout', $77ea3b2f3172e714$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $jvXYw.fill)(global, 'setInterval', $77ea3b2f3172e714$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $jvXYw.fill)(global, 'requestAnimationFrame', $77ea3b2f3172e714$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $jvXYw.fill)(XMLHttpRequest.prototype, 'send', $77ea3b2f3172e714$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $77ea3b2f3172e714$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($77ea3b2f3172e714$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $77ea3b2f3172e714$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $1gtR4.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $7sB74.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $77ea3b2f3172e714$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $1gtR4.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $7sB74.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $77ea3b2f3172e714$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $jvXYw.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $7sB74.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $jvXYw.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $7sB74.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $1gtR4.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $77ea3b2f3172e714$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $eCKEK.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $jvXYw.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $1gtR4.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $7sB74.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $1gtR4.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $7sB74.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $jvXYw.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("91Czo", function(module, exports) {
$parcel$export(module.exports, "UserAgent", () => $69222032ad382489$export$5fba5e10934a4faf);

var $26Yns = parcelRequire("26Yns");

var $9I9eJ = parcelRequire("9I9eJ");
var $jOQ1l = parcelRequire("jOQ1l");
parcelRequire("khHJA");
var $eCKEK = parcelRequire("eCKEK");
var $69222032ad382489$var$global = (0, $eCKEK.getGlobalObject)();
/** UserAgent */ var $69222032ad382489$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $9I9eJ.addGlobalEventProcessor)(function(event) {
            if ((0, $jOQ1l.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$69222032ad382489$var$global.navigator && !$69222032ad382489$var$global.location && !$69222032ad382489$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $69222032ad382489$var$global.location && $69222032ad382489$var$global.location.href;
                var referrer = ($69222032ad382489$var$global.document || {}).referrer;
                var userAgent = ($69222032ad382489$var$global.navigator || {}).userAgent;
                var headers = (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("7g6jd", function(module, exports) {
$parcel$export(module.exports, "RewriteFrames", () => $548eebdae6b03419$export$af39fa91d1acf248);

var $26Yns = parcelRequire("26Yns");
parcelRequire("5kSOS");
var $3B82N = parcelRequire("3B82N");
/** Rewrite event frames paths */ var $548eebdae6b03419$export$af39fa91d1acf248 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function RewriteFrames(options) {
        var _this = this;
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = RewriteFrames.id;
        /**
         * @inheritDoc
         */ this._prefix = 'app:///';
        /**
         * @inheritDoc
         */ this._iteratee = function(frame) {
            if (!frame.filename) return frame;
            // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
            var isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
            var startsWithSlash = /^\//.test(frame.filename);
            if (isWindowsFrame || startsWithSlash) {
                var filename = isWindowsFrame ? frame.filename.replace(/^[A-Z]:/, '') // remove Windows-style prefix
                .replace(/\\/g, '/') // replace all `\\` instances with `/`
                 : frame.filename;
                var base = _this._root ? (0, $3B82N.relative)(_this._root, filename) : (0, $3B82N.basename)(filename);
                frame.filename = "" + _this._prefix + base;
            }
            return frame;
        };
        if (options.root) this._root = options.root;
        if (options.prefix) this._prefix = options.prefix;
        if (options.iteratee) this._iteratee = options.iteratee;
    }
    /**
     * @inheritDoc
     */ RewriteFrames.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(RewriteFrames);
            if (self) return self.process(event);
            return event;
        });
    };
    /** JSDoc */ RewriteFrames.prototype.process = function(originalEvent) {
        var processedEvent = originalEvent;
        if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = this._processExceptionsEvent(processedEvent);
        if (originalEvent.stacktrace) processedEvent = this._processStacktraceEvent(processedEvent);
        return processedEvent;
    };
    /** JSDoc */ RewriteFrames.prototype._processExceptionsEvent = function(event) {
        var _this = this;
        try {
            return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, event), {
                exception: (0, $26Yns.__assign)((0, $26Yns.__assign)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, value), {
                            stacktrace: _this._processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktraceEvent = function(event) {
        try {
            return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, event), {
                stacktrace: this._processStacktrace(event.stacktrace)
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktrace = function(stacktrace) {
        var _this = this;
        return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, stacktrace), {
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function(f) {
                return _this._iteratee(f);
            })
        });
    };
    /**
     * @inheritDoc
     */ RewriteFrames.id = 'RewriteFrames';
    return RewriteFrames;
}();

});
parcelRegister("5kSOS", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("bz0KW")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("7svr9")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("7svr9")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("lnK9y")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("lnK9y")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("gyIda")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("xohzt")).fill);
$parcel$export(module.exports, "basename", () => (parcelRequire("3B82N")).basename);
$parcel$export(module.exports, "relative", () => (parcelRequire("3B82N")).relative);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("3BpUd")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("dLLy5")).safeJoin);





parcelRequire("bz0KW");

parcelRequire("7svr9");
parcelRequire("lnK9y");



var $8LcVN = parcelRequire("8LcVN");
parcelRequire("gyIda");
parcelRequire("xohzt");
parcelRequire("3B82N");

parcelRequire("3BpUd");


parcelRequire("dLLy5");



var $lEs1A = parcelRequire("lEs1A");





$parcel$exportWildcard(module.exports, $8LcVN);
$parcel$exportWildcard(module.exports, $lEs1A);

});
parcelRegister("bz0KW", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $86b38cc2feac3b35$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $86b38cc2feac3b35$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $8LcVN = parcelRequire("8LcVN");
var $86b38cc2feac3b35$var$fallbackGlobalObject = {};
function $86b38cc2feac3b35$export$256479dc0cea61c4() {
    return (0, $8LcVN.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $86b38cc2feac3b35$var$fallbackGlobalObject;
}
function $86b38cc2feac3b35$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $86b38cc2feac3b35$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("8LcVN", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $83272 = parcelRequire("83272");

var $6nQJh = parcelRequire("6nQJh");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $83272.isBrowserBundle)() && Object.prototype.toString.call(typeof $6nQJh !== 'undefined' ? $6nQJh : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("83272", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $5dc03e05f945b7c8$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $5dc03e05f945b7c8$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("7svr9", function(module, exports) {
$parcel$export(module.exports, "isError", () => $56e388a98c399b5e$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $56e388a98c399b5e$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $56e388a98c399b5e$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $56e388a98c399b5e$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $56e388a98c399b5e$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $56e388a98c399b5e$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $56e388a98c399b5e$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $56e388a98c399b5e$export$49841c62b9eff15);
$parcel$export(module.exports, "isSyntheticEvent", () => $56e388a98c399b5e$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $56e388a98c399b5e$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $56e388a98c399b5e$var$objectToString = Object.prototype.toString;
function $56e388a98c399b5e$export$e6127cc7fe7395c3(wat) {
    switch($56e388a98c399b5e$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $56e388a98c399b5e$export$49034edbe6b62415(wat, Error);
    }
}
function $56e388a98c399b5e$var$isBuiltin(wat, ty) {
    return $56e388a98c399b5e$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $56e388a98c399b5e$export$9f9636d330b71954(wat) {
    return $56e388a98c399b5e$var$isBuiltin(wat, 'ErrorEvent');
}
function $56e388a98c399b5e$export$ef9e2056653f0c8e(wat) {
    return $56e388a98c399b5e$var$isBuiltin(wat, 'DOMError');
}
function $56e388a98c399b5e$export$12e869b2a583f783(wat) {
    return $56e388a98c399b5e$var$isBuiltin(wat, 'DOMException');
}
function $56e388a98c399b5e$export$844ec244b1367d54(wat) {
    return $56e388a98c399b5e$var$isBuiltin(wat, 'String');
}
function $56e388a98c399b5e$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $56e388a98c399b5e$export$53b83ca8eaab0383(wat) {
    return $56e388a98c399b5e$var$isBuiltin(wat, 'Object');
}
function $56e388a98c399b5e$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $56e388a98c399b5e$export$49034edbe6b62415(wat, Event);
}
function $56e388a98c399b5e$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $56e388a98c399b5e$export$49034edbe6b62415(wat, Element);
}
function $56e388a98c399b5e$export$49841c62b9eff15(wat) {
    return $56e388a98c399b5e$var$isBuiltin(wat, 'RegExp');
}
function $56e388a98c399b5e$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $56e388a98c399b5e$export$bc2894c7158efbac(wat) {
    return $56e388a98c399b5e$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $56e388a98c399b5e$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $56e388a98c399b5e$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("lnK9y", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $f90f8bfbd4d63aa2$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $f90f8bfbd4d63aa2$export$af88d00dbe7f521);

var $26Yns = parcelRequire("26Yns");

var $iUoDS = parcelRequire("iUoDS");

var $bz0KW = parcelRequire("bz0KW");
// TODO: Implement different loggers for different environments
var $f90f8bfbd4d63aa2$var$global = (0, $bz0KW.getGlobalObject)();
/** Prefix for logging strings */ var $f90f8bfbd4d63aa2$var$PREFIX = 'Sentry Logger ';
var $f90f8bfbd4d63aa2$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $f90f8bfbd4d63aa2$export$cda52e2a8927a2ca(callback) {
    var global = (0, $bz0KW.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $f90f8bfbd4d63aa2$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $f90f8bfbd4d63aa2$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $iUoDS.IS_DEBUG_BUILD) $f90f8bfbd4d63aa2$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $f90f8bfbd4d63aa2$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $f90f8bfbd4d63aa2$var$global.console)[name].apply(_a, (0, $26Yns.__spread)([
                    $f90f8bfbd4d63aa2$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $f90f8bfbd4d63aa2$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $f90f8bfbd4d63aa2$export$af88d00dbe7f521;
if (0, $iUoDS.IS_DEBUG_BUILD) $f90f8bfbd4d63aa2$export$af88d00dbe7f521 = (0, $bz0KW.getGlobalSingleton)('logger', $f90f8bfbd4d63aa2$var$makeLogger);
else $f90f8bfbd4d63aa2$export$af88d00dbe7f521 = $f90f8bfbd4d63aa2$var$makeLogger();

});
parcelRegister("iUoDS", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $dc4092605e45aa95$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $dc4092605e45aa95$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("gyIda", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $c0e21dc6bae56e43$export$a3295358bff77e);

var $26Yns = parcelRequire("26Yns");

var $7svr9 = parcelRequire("7svr9");

var $rAzz2 = parcelRequire("rAzz2");

var $xohzt = parcelRequire("xohzt");

var $dC66H = parcelRequire("dC66H");
function $c0e21dc6bae56e43$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $c0e21dc6bae56e43$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $c0e21dc6bae56e43$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $c0e21dc6bae56e43$export$a3295358bff77e(object, depth);
    if ($c0e21dc6bae56e43$var$jsonSize(normalized) > maxSize) return $c0e21dc6bae56e43$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $c0e21dc6bae56e43$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $rAzz2.memoBuilder)();
    var _a = (0, $26Yns.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $7svr9.isNaN)(value)) return value;
    var stringified = $c0e21dc6bae56e43$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $7svr9.isError)(value) || (0, $7svr9.isEvent)(value) ? (0, $xohzt.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $c0e21dc6bae56e43$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $c0e21dc6bae56e43$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $7svr9.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $dC66H.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $c0e21dc6bae56e43$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $c0e21dc6bae56e43$var$jsonSize(value) {
    return $c0e21dc6bae56e43$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("rAzz2", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $052ee44a68aaa4b5$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $052ee44a68aaa4b5$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("xohzt", function(module, exports) {
$parcel$export(module.exports, "fill", () => $0645eb297ce0b582$export$9563e054e6f787fb);
$parcel$export(module.exports, "convertToPlainObject", () => $0645eb297ce0b582$export$62ff257738bf57f5);

var $26Yns = parcelRequire("26Yns");

var $25n9o = parcelRequire("25n9o");

var $7svr9 = parcelRequire("7svr9");

var $dLLy5 = parcelRequire("dLLy5");
function $0645eb297ce0b582$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $0645eb297ce0b582$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $0645eb297ce0b582$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $0645eb297ce0b582$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $0645eb297ce0b582$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $0645eb297ce0b582$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $0645eb297ce0b582$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $0645eb297ce0b582$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $7svr9.isError)(value)) newObj = (0, $26Yns.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $0645eb297ce0b582$var$getOwnProperties(value));
    else if ((0, $7svr9.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $26Yns.__assign)({
            type: event_1.type,
            target: $0645eb297ce0b582$var$serializeEventTarget(event_1.target),
            currentTarget: $0645eb297ce0b582$var$serializeEventTarget(event_1.currentTarget)
        }, $0645eb297ce0b582$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $7svr9.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $0645eb297ce0b582$var$serializeEventTarget(target) {
    try {
        return (0, $7svr9.isElement)(target) ? (0, $25n9o.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $0645eb297ce0b582$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $0645eb297ce0b582$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($0645eb297ce0b582$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $dLLy5.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $dLLy5.truncate)(serialized, maxLength);
    }
    return '';
}
function $0645eb297ce0b582$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $7svr9.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $26Yns.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $0645eb297ce0b582$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($0645eb297ce0b582$export$d25f2688db1bb433);
    return val;
}
function $0645eb297ce0b582$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7svr9.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("25n9o", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $184e019dc1a427c4$export$5647df6b7814ac86);

var $bz0KW = parcelRequire("bz0KW");

var $7svr9 = parcelRequire("7svr9");
function $184e019dc1a427c4$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $184e019dc1a427c4$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $184e019dc1a427c4$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $7svr9.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $184e019dc1a427c4$export$1cfafeee2987818b() {
    var global = (0, $bz0KW.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("dLLy5", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $a0648c526fd41d0b$export$6a506b36fdea397d);
$parcel$export(module.exports, "safeJoin", () => $a0648c526fd41d0b$export$465e9d514283d4fd);

var $7svr9 = parcelRequire("7svr9");
function $a0648c526fd41d0b$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $a0648c526fd41d0b$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $a0648c526fd41d0b$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $a0648c526fd41d0b$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $7svr9.isString)(value)) return false;
    if ((0, $7svr9.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $a0648c526fd41d0b$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("dC66H", function(module, exports) {
$parcel$export(module.exports, "getFunctionName", () => $9e938fb0fe5fa3f7$export$aad197c7121a6651);

var $26Yns = parcelRequire("26Yns");
var $9e938fb0fe5fa3f7$var$STACKTRACE_LIMIT = 50;
function $9e938fb0fe5fa3f7$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $26Yns.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $26Yns.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $9e938fb0fe5fa3f7$export$c55c24c0eeba0205(frames);
    };
}
function $9e938fb0fe5fa3f7$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $9e938fb0fe5fa3f7$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $9e938fb0fe5fa3f7$var$defaultFunctionName = '<anonymous>';
function $9e938fb0fe5fa3f7$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $9e938fb0fe5fa3f7$var$defaultFunctionName;
        return fn.name || $9e938fb0fe5fa3f7$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $9e938fb0fe5fa3f7$var$defaultFunctionName;
    }
}

});


parcelRegister("3B82N", function(module, exports) {
$parcel$export(module.exports, "relative", () => $29eb113725fae96b$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $29eb113725fae96b$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */ function $29eb113725fae96b$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        } else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) // eslint-disable-next-line no-plusplus
    for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var $29eb113725fae96b$var$splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */ function $29eb113725fae96b$var$splitPath(filename) {
    var parts = $29eb113725fae96b$var$splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
function $29eb113725fae96b$export$f7ad0328861e2f03() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $29eb113725fae96b$var$normalizeArray(resolvedPath.split('/').filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $29eb113725fae96b$var$trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $29eb113725fae96b$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $29eb113725fae96b$export$f7ad0328861e2f03(from).substr(1);
    to = $29eb113725fae96b$export$f7ad0328861e2f03(to).substr(1);
    /* eslint-enable no-param-reassign */ var fromParts = $29eb113725fae96b$var$trim(from.split('/'));
    var toParts = $29eb113725fae96b$var$trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
function $29eb113725fae96b$export$6af368f973c74c5(path) {
    var isPathAbsolute = $29eb113725fae96b$export$e434c7255acda994(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = $29eb113725fae96b$var$normalizeArray(path.split('/').filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
function $29eb113725fae96b$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
function $29eb113725fae96b$export$f7e2c8231c57a8bd() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $29eb113725fae96b$export$6af368f973c74c5(args.join('/'));
}
function $29eb113725fae96b$export$7f7b8152cc673abe(path) {
    var result = $29eb113725fae96b$var$splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
    return root + dir;
}
function $29eb113725fae96b$export$9bf319d8f74f51d1(path, ext) {
    var f = $29eb113725fae96b$var$splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) f = f.substr(0, f.length - ext.length);
    return f;
}

});

parcelRegister("3BpUd", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $29f8ec2233b8b69c$export$e01cef29b4327697);

var $7dUhV = parcelRequire("7dUhV");

var $juv0Q = parcelRequire("juv0Q");
function $29f8ec2233b8b69c$var$isSupportedSeverity(level) {
    return (0, $juv0Q.SeverityLevels).indexOf(level) !== -1;
}
function $29f8ec2233b8b69c$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $7dUhV.Severity).Warning;
    if ($29f8ec2233b8b69c$var$isSupportedSeverity(level)) return level;
    return (0, $7dUhV.Severity).Log;
}

});
parcelRegister("juv0Q", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $e308e0264ac27b3c$export$484b1ea9aec914c);
var $e308e0264ac27b3c$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("lEs1A", function(module, exports) {

var $bz0KW = parcelRequire("bz0KW");

var $8LcVN = parcelRequire("8LcVN");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $bz0KW.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $8LcVN.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $8LcVN.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $bz0KW.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});





parcelRegister("9VGQW", function(module, exports) {
$parcel$export(module.exports, "initialisePlatformFeatureFlags", () => $4b9988e427eff58a$export$bcd24dd77ba35b8a);
/**
 *  Adapted from JFE:
 *  https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/common-legacy-do-not-add-anything-new/src/util/get-feature-flag-value.js
 *
 */ 
var $1EFS8 = parcelRequire("1EFS8");

var $e6Qdr = parcelRequire("e6Qdr");
const $4b9988e427eff58a$export$bcd24dd77ba35b8a = ()=>{
    (0, $e6Qdr.setBooleanFeatureFlagResolver)((flagKey)=>(0, $1EFS8.default).checkGate(flagKey));
};

});

parcelRegister("d1xjT", function(module, exports) {
$parcel$export(module.exports, "handleDOMGoogleTranslateIssues", () => $2afe412aa6ceace9$export$d1215808cd22e615);
// #reference /confluence/packages/confluence-frontend-server/src/google-translate-issue-workaround.js

var $9ypa9 = parcelRequire("9ypa9");
const $2afe412aa6ceace9$var$ErrorType = Object.freeze({
    REMOVE_CHILD_ERROR: 'removeChildError',
    INSERT_BEFORE_ERROR: 'insertBeforeError'
});
function $2afe412aa6ceace9$export$d1215808cd22e615() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
            if (child.parentNode !== this) {
                if (console) {
                    // eslint-disable-next-line no-console
                    console.error('Cannot remove a child from a different parent', child, this);
                    $2afe412aa6ceace9$var$sendRemoveChildErrorAnalyticsEvent(child);
                }
                return child;
            }
            // eslint-disable-next-line prefer-rest-params,@typescript-eslint/no-unsafe-return
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    // eslint-disable-next-line no-console
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    $2afe412aa6ceace9$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode);
                }
                return newNode;
            }
            // eslint-disable-next-line prefer-rest-params,@typescript-eslint/no-unsafe-return
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
/**
 * Send an analytics event when a 'removeChild' error occurs. This function helps to track the occurrence of this suppressed error.
 * @param {Node} childNode - The node that is attempted to be removed.
 */ function $2afe412aa6ceace9$var$sendRemoveChildErrorAnalyticsEvent(childNode) {
    const nodeData = {
        nodeToBeRemoved: $2afe412aa6ceace9$var$extractNodeData(childNode)
    };
    $2afe412aa6ceace9$var$sendAnalyticsEvent($2afe412aa6ceace9$var$ErrorType.REMOVE_CHILD_ERROR, nodeData);
}
/**
 * Send an analytics event when an 'insertBefore' error occurs.  This function helps to track the occurrence of this suppressed error.
 * @param {Node} referenceNode - The existing node in the DOM tree. The new node is intended to be inserted before this node.
 * @param {Node} newNode - The new node that is attempted to be inserted.
 */ function $2afe412aa6ceace9$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode) {
    const nodeData = {
        newNode: $2afe412aa6ceace9$var$extractNodeData(newNode),
        referenceNode: $2afe412aa6ceace9$var$extractNodeData(referenceNode)
    };
    $2afe412aa6ceace9$var$sendAnalyticsEvent($2afe412aa6ceace9$var$ErrorType.INSERT_BEFORE_ERROR, nodeData);
}
function $2afe412aa6ceace9$var$sendAnalyticsEvent(action, nodeData) {
    (0, $9ypa9.trackError)('google.translate.issue.error', {
        ...nodeData,
        errorBoundaryId: 'root',
        suppressedError: action,
        errorBoundaryPackageName: 'unknown'
    }, new Error(action));
}
function $2afe412aa6ceace9$var$extractNodeData(node) {
    var _node$parentElement;
    if (!node) return {};
    return {
        nodeName: node.nodeName,
        parentElementNodeName: (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.nodeName,
        isConnected: node.isConnected
    };
}

});

parcelRegister("lhZa3", function(module, exports) {
$parcel$export(module.exports, "AtlassianHelp", () => $7619b762e2591b31$export$1d3b4fb23d556424);

var $8P7DW = parcelRequire("8P7DW");

var $edC7N = parcelRequire("edC7N");

var $5dezq = parcelRequire("5dezq");
parcelRequire("5NIXX");
var $fuc2f = parcelRequire("fuc2f");
parcelRequire("eT1JU");
var $7Zfpv = parcelRequire("7Zfpv");
parcelRequire("ar7wO");
var $fj93T = parcelRequire("fj93T");
const $7619b762e2591b31$var$renderError = ()=>/*#__PURE__*/ $8P7DW.createElement((0, $fuc2f.default), null);
const $7619b762e2591b31$export$1d3b4fb23d556424 = ({ config: config })=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $5dezq.AppProviders), {
        config: config
    }, /*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
        renderError: $7619b762e2591b31$var$renderError
    }, /*#__PURE__*/ $8P7DW.createElement((0, $fj93T.ThemingContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $7Zfpv.default), null))));
};

});
parcelRegister("5dezq", function(module, exports) {
$parcel$export(module.exports, "store", () => $095e7ed5f2f9727f$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "injectReducer", () => $095e7ed5f2f9727f$export$8d491a82891620e4);
$parcel$export(module.exports, "onIntlNextError", () => $095e7ed5f2f9727f$export$3bcefabe8b04378c);
$parcel$export(module.exports, "AppProviders", () => $095e7ed5f2f9727f$export$6c4743022ef2c318);

var $8P7DW = parcelRequire("8P7DW");

var $45a3E = parcelRequire("45a3E");
parcelRequire("hAQvO");
var $3WYqK = parcelRequire("3WYqK");

var $HGACo = parcelRequire("HGACo");

var $1We2B = parcelRequire("1We2B");

var $ai5ZE = parcelRequire("ai5ZE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("6Fjys");
var $8ICBx = parcelRequire("8ICBx");

var $cz1oy = parcelRequire("cz1oy");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $4GTRJ = parcelRequire("4GTRJ");
parcelRequire("9llZ5");
var $b7pji = parcelRequire("b7pji");
parcelRequire("81vfS");
var $liIpM = parcelRequire("liIpM");
parcelRequire("80NsQ");
var $kSAgc = parcelRequire("kSAgc");
parcelRequire("hGzcq");
var $gRzju = parcelRequire("gRzju");
parcelRequire("jp3Ur");
var $7bCNa = parcelRequire("7bCNa");
var $1s1Af = parcelRequire("1s1Af");

var $bP2rs = parcelRequire("bP2rs");

var $17wqU = parcelRequire("17wqU");

var $51Jlt = parcelRequire("51Jlt");

var $9ypa9 = parcelRequire("9ypa9");

var $4L08H = parcelRequire("4L08H");

var $lmVcW = parcelRequire("lmVcW");

var $jjE9o = parcelRequire("jjE9o");

var $cwJhX = parcelRequire("cwJhX");

var $9ypa9 = parcelRequire("9ypa9");

var $eIXeQ = parcelRequire("eIXeQ");

var $gcZ9C = parcelRequire("gcZ9C");

var $ktdLU = parcelRequire("ktdLU");

var $7PmZt = parcelRequire("7PmZt");

var $44YJW = parcelRequire("44YJW");

var $gyskF = parcelRequire("gyskF");

var $dd3om = parcelRequire("dd3om");
parcelRequire("aAfp6");
var $eou6j = parcelRequire("eou6j");
const $095e7ed5f2f9727f$var$initialState = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $095e7ed5f2f9727f$var$accountTypeMetaTagMiddleware = ()=>(next)=>(action)=>{
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (action.type === (0, $8ICBx.UPDATE_USER_MODEL)) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $51Jlt.setAccountMetaTag)(action.payload.atlassianAccountManaged, action.payload.accountId);
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return next(action);
        };
const { store: $095e7ed5f2f9727f$export$6f57813fe9f31bf9, injectReducer: $095e7ed5f2f9727f$export$8d491a82891620e4 } = (0, $cz1oy.default)({
    initialState: $095e7ed5f2f9727f$var$initialState,
    middleware: [
        $095e7ed5f2f9727f$var$accountTypeMetaTagMiddleware
    ]
});
(0, $44YJW.addSuportedLocaleData)();
const $095e7ed5f2f9727f$export$ec3f29afcf92cc87 = (intlError)=>{
    try {
        /**
     * Do not report to sentry if missing translations are from external packages.
     * Extend the regexp to add support for multiple packages
     */ if (!intlError) return;
        const isExternalTranslation = intlError.match(/Missing message: "fabric\.(editor|media|theme|emoji)\..*/);
        const { errorKey: errorKey, errorLocale: errorLocale, isNonFinal: isNonFinal } = (0, $7PmZt.intlErrorMatch)(intlError);
        // According to this document https://hello.atlassian.net/wiki/spaces/i18n/pages/647802766/Localized+Language+Support+Coverage+and+Strategy after 2018 we have discontinued support for these locales
        const isUnSupportedLocale = !!intlError.match(/.*Missing message.*for locale "(ro|pt|no|sk|et|is)".*/);
        if (isExternalTranslation || isUnSupportedLocale) return;
        (0, $jjE9o.operationalEvent)({
            attributes: {
                isNonFinal: isNonFinal,
                key: errorKey,
                locale: errorLocale
            },
            actionSubject: 'intl_translation',
            action: 'missing',
            source: 'unknownSource'
        });
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $095e7ed5f2f9727f$export$3bcefabe8b04378c = (intlError)=>{
    $095e7ed5f2f9727f$export$ec3f29afcf92cc87(`IntlV5: ${intlError.message}`);
};
class $095e7ed5f2f9727f$export$6c4743022ef2c318 extends $8P7DW.Component {
    render() {
        const { config: config } = this.props;
        const analyticsClient = (0, $4L08H.getAnalyticsWebClient)().getInstance();
        const envFeatureFlags = $095e7ed5f2f9727f$export$6f57813fe9f31bf9.getState().persisted.env.featureFlags;
        const configFeatureFlags = config === null || config === void 0 ? void 0 : config.featureFlags;
        const memoizedFeatureFlags = (0, $1We2B.memoize)(// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (envFFs, configFFs)=>({
                ...envFFs,
                ...configFFs
            }), (...args)=>(0, $1We2B.keys)({
                ...args[0],
                ...args[1]
            }));
        const WrmResourceProvider = (0, $HGACo.isWrmOptimizationsEnabled)() ? (0, $dd3om.default) : $8P7DW.Fragment;
        return /*#__PURE__*/ $8P7DW.createElement((0, $h3cOB.RelayEnvironmentProvider), {
            environment: (0, $gyskF.getRelayEnvironment)()
        }, /*#__PURE__*/ $8P7DW.createElement((0, $lmVcW.CustomDomainsAnalyticsProvider), {
            baseUrl: config.baseUrl
        }, /*#__PURE__*/ $8P7DW.createElement((0, $7bCNa.default), {
            client: analyticsClient,
            excludedChannels: [
                (0, $1s1Af.FabricChannel).atlaskit
            ]
        }, /*#__PURE__*/ $8P7DW.createElement((0, $b7pji.EngagementProviderWrapper), {
            config: config,
            analyticsClientInstance: analyticsClient
        }, /*#__PURE__*/ $8P7DW.createElement((0, $bP2rs.default), {
            onEvent: (0, $9ypa9.sendAtlaskitUIEvent),
            channel: "atlaskit"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $bP2rs.default), {
            onEvent: (0, $9ypa9.sendEventFromAnalyticsBridge),
            channel: (0, $17wqU.ANALYTICS_BRIDGE_CHANNEL)
        }, /*#__PURE__*/ $8P7DW.createElement((0, $bP2rs.default), {
            onEvent: (0, $9ypa9.legacySendEvent)
        }, /*#__PURE__*/ $8P7DW.createElement((0, $45a3E.IntlProvider), {
            messages: (0, $ktdLU.default)(),
            locale: (0, $44YJW.getLanguageFromLocale)((0, $hx8zX.getLocale)($095e7ed5f2f9727f$export$6f57813fe9f31bf9.getState())),
            onError: $095e7ed5f2f9727f$export$ec3f29afcf92cc87
        }, /*#__PURE__*/ $8P7DW.createElement((0, $ai5ZE.default), {
            messages: (0, $ktdLU.default)(),
            locale: (0, $44YJW.getLanguageFromLocale)((0, $hx8zX.getLocale)($095e7ed5f2f9727f$export$6f57813fe9f31bf9.getState())),
            onError: $095e7ed5f2f9727f$export$3bcefabe8b04378c
        }, /*#__PURE__*/ $8P7DW.createElement((0, $3WYqK.default), {
            store: $095e7ed5f2f9727f$export$6f57813fe9f31bf9
        }, /*#__PURE__*/ $8P7DW.createElement((0, $eou6j.default), {
            config: this.props.config
        }, /*#__PURE__*/ $8P7DW.createElement(WrmResourceProvider, null, /*#__PURE__*/ $8P7DW.createElement((0, $eIXeQ.PortalAnalyticsContext), null, /*#__PURE__*/ $8P7DW.createElement((0, $4GTRJ.HelpSeekerTypeProvider), null, /*#__PURE__*/ $8P7DW.createElement((0, $liIpM.default), {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            featureFlags: memoizedFeatureFlags(envFeatureFlags, configFeatureFlags)
        }, /*#__PURE__*/ $8P7DW.createElement((0, $cwJhX.default), null, /*#__PURE__*/ $8P7DW.createElement((0, $gcZ9C.default), null, /*#__PURE__*/ $8P7DW.createElement((0, $kSAgc.TFECacheProvider), null, /*#__PURE__*/ $8P7DW.createElement((0, $gRzju.CustomiseSidebarTriggerProvider), null, this.props.children)))))))))))))))))));
    }
}

});
parcelRegister("hAQvO", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("3WYqK")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("jvoWT")).default);

var $3WYqK = parcelRequire("3WYqK");

var $cLTgs = parcelRequire("cLTgs");

var $h1FuS = parcelRequire("h1FuS");

var $jvoWT = parcelRequire("jvoWT");

});
parcelRegister("3WYqK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e05aa13141525a7$export$2e2bcd8739ae039);

var $bhSWU = parcelRequire("bhSWU");

var $8P7DW = parcelRequire("8P7DW");

var $93Fg7 = parcelRequire("93Fg7");

var $h1FuS = parcelRequire("h1FuS");
var $2e05aa13141525a7$var$Provider = /*#__PURE__*/ function(_Component) {
    (0, $bhSWU.default)(Provider, _Component);
    function Provider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        var store = props.store;
        _this.state = {
            storeState: store.getState(),
            store: store
        };
        return _this;
    }
    var _proto = Provider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.subscribe();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
        this._isMounted = false;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.store !== prevProps.store) {
            if (this.unsubscribe) this.unsubscribe();
            this.subscribe();
        }
    };
    _proto.subscribe = function subscribe() {
        var _this2 = this;
        var store = this.props.store;
        this.unsubscribe = store.subscribe(function() {
            var newStoreState = store.getState();
            if (!_this2._isMounted) return;
            _this2.setState(function(providerState) {
                // If the value is the same, skip the unnecessary state update.
                if (providerState.storeState === newStoreState) return null;
                return {
                    storeState: newStoreState
                };
            });
        }); // Actions might have been dispatched between render and mount - handle those
        var postMountStoreState = store.getState();
        if (postMountStoreState !== this.state.storeState) this.setState({
            storeState: postMountStoreState
        });
    };
    _proto.render = function render() {
        var Context = this.props.context || (0, $h1FuS.ReactReduxContext);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Context.Provider, {
            value: this.state
        }, this.props.children);
    };
    return Provider;
}((0, $8P7DW.Component));
$2e05aa13141525a7$var$Provider.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).shape({
        subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func.isRequired,
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func.isRequired,
        getState: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func.isRequired
    }),
    context: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).any
};
var $2e05aa13141525a7$export$2e2bcd8739ae039 = $2e05aa13141525a7$var$Provider;

});
parcelRegister("bhSWU", function(module, exports) {
$parcel$export(module.exports, "default", () => $837be7f8e4533573$export$2e2bcd8739ae039);

var $lK6UL = parcelRequire("lK6UL");
function $837be7f8e4533573$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $lK6UL.default)(t, o);
}

});
parcelRegister("lK6UL", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd4341edf6012f70$export$2e2bcd8739ae039);
function $fd4341edf6012f70$export$2e2bcd8739ae039(t, e) {
    return $fd4341edf6012f70$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $fd4341edf6012f70$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("h1FuS", function(module, exports) {
$parcel$export(module.exports, "ReactReduxContext", () => $c652b820f636d03f$export$cc80c08dc91f1c00);

var $8P7DW = parcelRequire("8P7DW");
var $c652b820f636d03f$export$cc80c08dc91f1c00 = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(null);
var $c652b820f636d03f$export$2e2bcd8739ae039 = $c652b820f636d03f$export$cc80c08dc91f1c00;

});


parcelRegister("cLTgs", function(module, exports) {
$parcel$export(module.exports, "default", () => $94c4be2fb0869e1f$export$2e2bcd8739ae039);

var $hWoqU = parcelRequire("hWoqU");

var $bhSWU = parcelRequire("bhSWU");

var $cCnFQ = parcelRequire("cCnFQ");

var $911Xe = parcelRequire("911Xe");

var $fG5y9 = parcelRequire("fG5y9");

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");

var $3a2df = parcelRequire("3a2df");

var $h1FuS = parcelRequire("h1FuS");
var $94c4be2fb0869e1f$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $94c4be2fb0869e1f$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $h1FuS.ReactReduxContext) : _ref2$context, connectOptions = (0, $911Xe.default)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef",
        "forwardRef",
        "context"
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3rEVE)))(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
    (0, (/*@__PURE__*/$parcel$interopDefault($3rEVE)))(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
    var customStoreWarningMessage = "To use a custom Redux store for specific components,  create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    (0, (/*@__PURE__*/$parcel$interopDefault($3rEVE)))(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $cCnFQ.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        var OuterBaseComponent = (0, $8P7DW.Component);
        if (pure) OuterBaseComponent = (0, $8P7DW.PureComponent);
        function makeDerivedPropsSelector() {
            var lastProps;
            var lastState;
            var lastDerivedProps;
            var lastStore;
            var lastSelectorFactoryOptions;
            var sourceSelector;
            return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
                if (pure && lastProps === props && lastState === state) return lastDerivedProps;
                if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
                    lastStore = store;
                    lastSelectorFactoryOptions = selectorFactoryOptions;
                    sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
                }
                lastProps = props;
                lastState = state;
                var nextProps = sourceSelector(state, props);
                lastDerivedProps = nextProps;
                return lastDerivedProps;
            };
        }
        function makeChildElementSelector() {
            var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
            return function selectChildElement(WrappedComponent, childProps, forwardRef) {
                if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
                    lastChildProps = childProps;
                    lastForwardRef = forwardRef;
                    lastComponent = WrappedComponent;
                    lastChildElement = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, (0, $cCnFQ.default)({}, childProps, {
                        ref: forwardRef
                    }));
                }
                return lastChildElement;
            };
        }
        var Connect = /*#__PURE__*/ function(_OuterBaseComponent) {
            (0, $bhSWU.default)(Connect, _OuterBaseComponent);
            function Connect(props) {
                var _this;
                _this = _OuterBaseComponent.call(this, props) || this;
                (0, (/*@__PURE__*/$parcel$interopDefault($3rEVE)))(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
                _this.selectDerivedProps = makeDerivedPropsSelector();
                _this.selectChildElement = makeChildElementSelector();
                _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind((0, $hWoqU.default)(_this));
                return _this;
            }
            var _proto = Connect.prototype;
            _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
                // calling renderWrappedComponent on prototype from indirectRenderWrappedComponent bound to `this`
                return this.renderWrappedComponent(value);
            };
            _proto.renderWrappedComponent = function renderWrappedComponent(value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($3rEVE)))(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
                var storeState = value.storeState, store = value.store;
                var wrapperProps = this.props;
                var forwardedRef;
                if (forwardRef) {
                    wrapperProps = this.props.wrapperProps;
                    forwardedRef = this.props.forwardedRef;
                }
                var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
                return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
            };
            _proto.render = function render() {
                var ContextToUse = this.props.context && this.props.context.Consumer && (0, $3a2df.isContextConsumer)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
            };
            return Connect;
        }(OuterBaseComponent);
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(function forwardConnectRef(props, ref) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Connect, {
                    wrapperProps: props,
                    forwardedRef: ref
                });
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fG5y9)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($fG5y9)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("hWoqU", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0face58bde19fc0$export$2e2bcd8739ae039);
function $d0face58bde19fc0$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("jvoWT", function(module, exports) {
$parcel$export(module.exports, "default", () => $e33443e616456f50$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");

var $911Xe = parcelRequire("911Xe");

var $cLTgs = parcelRequire("cLTgs");

var $juumv = parcelRequire("juumv");

var $eW08E = parcelRequire("eW08E");

var $4KXSs = parcelRequire("4KXSs");

var $1g2UA = parcelRequire("1g2UA");

var $1DUCN = parcelRequire("1DUCN");
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $e33443e616456f50$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $e33443e616456f50$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $e33443e616456f50$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $cLTgs.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $4KXSs.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $eW08E.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $1g2UA.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $1DUCN.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $e33443e616456f50$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $juumv.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $juumv.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $juumv.default) : _ref3$areMergedPropsE, extraOptions = (0, $911Xe.default)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = $e33443e616456f50$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $e33443e616456f50$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $e33443e616456f50$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $cCnFQ.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $e33443e616456f50$export$2e2bcd8739ae039 = $e33443e616456f50$export$9f9feb656dec1fc4();

});
parcelRegister("juumv", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3085ef15923d038$export$2e2bcd8739ae039);
var $e3085ef15923d038$var$hasOwn = Object.prototype.hasOwnProperty;
function $e3085ef15923d038$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $e3085ef15923d038$export$2e2bcd8739ae039(objA, objB) {
    if ($e3085ef15923d038$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$e3085ef15923d038$var$hasOwn.call(objB, keysA[i]) || !$e3085ef15923d038$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("eW08E", function(module, exports) {
$parcel$export(module.exports, "default", () => $adf696f8a2622711$export$2e2bcd8739ae039);
parcelRequire("haxwJ");
var $akTfz = parcelRequire("akTfz");

var $8IwGp = parcelRequire("8IwGp");
function $adf696f8a2622711$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $8IwGp.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $adf696f8a2622711$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $8IwGp.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $adf696f8a2622711$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $8IwGp.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $akTfz.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $adf696f8a2622711$export$2e2bcd8739ae039 = [
    $adf696f8a2622711$export$a9f27b4b187c1166,
    $adf696f8a2622711$export$ba20d1a7aa0c4a90,
    $adf696f8a2622711$export$94a6e55709d4d961
];

});
parcelRegister("haxwJ", function(module, exports) {
$parcel$export(module.exports, "createStore", () => (parcelRequire("14lC8")).default);
$parcel$export(module.exports, "combineReducers", () => (parcelRequire("02gNN")).default);
$parcel$export(module.exports, "bindActionCreators", () => (parcelRequire("akTfz")).default);
$parcel$export(module.exports, "applyMiddleware", () => (parcelRequire("5YU7f")).default);
$parcel$export(module.exports, "compose", () => (parcelRequire("hxVai")).default);

var $14lC8 = parcelRequire("14lC8");

var $02gNN = parcelRequire("02gNN");

var $akTfz = parcelRequire("akTfz");

var $5YU7f = parcelRequire("5YU7f");

var $hxVai = parcelRequire("hxVai");
parcelRequire("cj4ED");
/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $c7fd6094b470553b$var$isCrushed() {}

});
parcelRegister("14lC8", function(module, exports) {
$parcel$export(module.exports, "ActionTypes", () => $0c76ee428220fa8a$export$1385d81a6c6bbcd4);
$parcel$export(module.exports, "default", () => $0c76ee428220fa8a$export$2e2bcd8739ae039);

var $iJRGs = parcelRequire("iJRGs");

var $cvEGI = parcelRequire("cvEGI");
var $0c76ee428220fa8a$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $0c76ee428220fa8a$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($0c76ee428220fa8a$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $iJRGs.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $0c76ee428220fa8a$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $cvEGI.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $0c76ee428220fa8a$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $cvEGI.default] = observable, _ref2;
}

});
parcelRegister("iJRGs", function(module, exports) {
$parcel$export(module.exports, "default", () => $da461276b0b2b941$export$2e2bcd8739ae039);

var $ir75P = parcelRequire("ir75P");

var $ljAGt = parcelRequire("ljAGt");

var $dnhAf = parcelRequire("dnhAf");
/** `Object#toString` result references. */ var $da461276b0b2b941$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $da461276b0b2b941$var$funcProto = Function.prototype, $da461276b0b2b941$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $da461276b0b2b941$var$funcToString = $da461276b0b2b941$var$funcProto.toString;
/** Used to check objects for own properties. */ var $da461276b0b2b941$var$hasOwnProperty = $da461276b0b2b941$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $da461276b0b2b941$var$objectCtorString = $da461276b0b2b941$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $da461276b0b2b941$var$isPlainObject(value) {
    if (!(0, $dnhAf.default)(value) || (0, $ir75P.default)(value) != $da461276b0b2b941$var$objectTag) return false;
    var proto = (0, $ljAGt.default)(value);
    if (proto === null) return true;
    var Ctor = $da461276b0b2b941$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $da461276b0b2b941$var$funcToString.call(Ctor) == $da461276b0b2b941$var$objectCtorString;
}
var $da461276b0b2b941$export$2e2bcd8739ae039 = $da461276b0b2b941$var$isPlainObject;

});
parcelRegister("ir75P", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6c040220b5ea47a$export$2e2bcd8739ae039);

var $lqiMB = parcelRequire("lqiMB");

var $5dAAu = parcelRequire("5dAAu");

var $kBthU = parcelRequire("kBthU");
/** `Object#toString` result references. */ var $d6c040220b5ea47a$var$nullTag = '[object Null]', $d6c040220b5ea47a$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $d6c040220b5ea47a$var$symToStringTag = (0, $lqiMB.default) ? (0, $lqiMB.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $d6c040220b5ea47a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $d6c040220b5ea47a$var$undefinedTag : $d6c040220b5ea47a$var$nullTag;
    return $d6c040220b5ea47a$var$symToStringTag && $d6c040220b5ea47a$var$symToStringTag in Object(value) ? (0, $5dAAu.default)(value) : (0, $kBthU.default)(value);
}
var $d6c040220b5ea47a$export$2e2bcd8739ae039 = $d6c040220b5ea47a$var$baseGetTag;

});
parcelRegister("lqiMB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f98a989291b67c68$export$2e2bcd8739ae039);

var $k5IvI = parcelRequire("k5IvI");
/** Built-in value references. */ var $f98a989291b67c68$var$Symbol = (0, $k5IvI.default).Symbol;
var $f98a989291b67c68$export$2e2bcd8739ae039 = $f98a989291b67c68$var$Symbol;

});
parcelRegister("k5IvI", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea06cd201b997a71$export$2e2bcd8739ae039);

var $i8orZ = parcelRequire("i8orZ");
/** Detect free variable `self`. */ var $ea06cd201b997a71$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ea06cd201b997a71$var$root = (0, $i8orZ.default) || $ea06cd201b997a71$var$freeSelf || Function('return this')();
var $ea06cd201b997a71$export$2e2bcd8739ae039 = $ea06cd201b997a71$var$root;

});
parcelRegister("i8orZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d33bf0af086e0535$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $d33bf0af086e0535$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $d33bf0af086e0535$export$2e2bcd8739ae039 = $d33bf0af086e0535$var$freeGlobal;

});



parcelRegister("5dAAu", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cca8c2c0a354272$export$2e2bcd8739ae039);

var $lqiMB = parcelRequire("lqiMB");
/** Used for built-in method references. */ var $3cca8c2c0a354272$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3cca8c2c0a354272$var$hasOwnProperty = $3cca8c2c0a354272$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3cca8c2c0a354272$var$nativeObjectToString = $3cca8c2c0a354272$var$objectProto.toString;
/** Built-in value references. */ var $3cca8c2c0a354272$var$symToStringTag = (0, $lqiMB.default) ? (0, $lqiMB.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3cca8c2c0a354272$var$getRawTag(value) {
    var isOwn = $3cca8c2c0a354272$var$hasOwnProperty.call(value, $3cca8c2c0a354272$var$symToStringTag), tag = value[$3cca8c2c0a354272$var$symToStringTag];
    try {
        value[$3cca8c2c0a354272$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3cca8c2c0a354272$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3cca8c2c0a354272$var$symToStringTag] = tag;
        else delete value[$3cca8c2c0a354272$var$symToStringTag];
    }
    return result;
}
var $3cca8c2c0a354272$export$2e2bcd8739ae039 = $3cca8c2c0a354272$var$getRawTag;

});

parcelRegister("kBthU", function(module, exports) {
$parcel$export(module.exports, "default", () => $effdfb4daa117047$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $effdfb4daa117047$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $effdfb4daa117047$var$nativeObjectToString = $effdfb4daa117047$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $effdfb4daa117047$var$objectToString(value) {
    return $effdfb4daa117047$var$nativeObjectToString.call(value);
}
var $effdfb4daa117047$export$2e2bcd8739ae039 = $effdfb4daa117047$var$objectToString;

});


parcelRegister("ljAGt", function(module, exports) {
$parcel$export(module.exports, "default", () => $f847d3ff9978289f$export$2e2bcd8739ae039);

var $ckv1R = parcelRequire("ckv1R");
/** Built-in value references. */ var $f847d3ff9978289f$var$getPrototype = (0, $ckv1R.default)(Object.getPrototypeOf, Object);
var $f847d3ff9978289f$export$2e2bcd8739ae039 = $f847d3ff9978289f$var$getPrototype;

});
parcelRegister("ckv1R", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f9f6c000dd3d2b6$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $8f9f6c000dd3d2b6$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $8f9f6c000dd3d2b6$export$2e2bcd8739ae039 = $8f9f6c000dd3d2b6$var$overArg;

});


parcelRegister("dnhAf", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bcb101c1f65ff54$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9bcb101c1f65ff54$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $9bcb101c1f65ff54$export$2e2bcd8739ae039 = $9bcb101c1f65ff54$var$isObjectLike;

});


parcelRegister("cvEGI", function(module, exports) {
$parcel$export(module.exports, "default", () => $91b7f1156141a254$export$2e2bcd8739ae039);
/* global window */ 
var $cdaH5 = parcelRequire("cdaH5");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $cdaH5.default)(root);
var $91b7f1156141a254$export$2e2bcd8739ae039 = result;

});
parcelRegister("cdaH5", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e3efe841ccdf0ec$export$2e2bcd8739ae039);
function $8e3efe841ccdf0ec$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});



parcelRegister("02gNN", function(module, exports) {
$parcel$export(module.exports, "default", () => $006d3891cdbf5622$export$2e2bcd8739ae039);

var $14lC8 = parcelRequire("14lC8");

var $iJRGs = parcelRequire("iJRGs");
parcelRequire("cj4ED");
function $006d3891cdbf5622$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function $006d3891cdbf5622$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $14lC8.ActionTypes).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $iJRGs.default)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $006d3891cdbf5622$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $14lC8.ActionTypes).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, $14lC8.ActionTypes).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function $006d3891cdbf5622$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $006d3891cdbf5622$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $006d3891cdbf5622$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});
parcelRegister("cj4ED", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $8f5adea0f9a0a7f3$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});


parcelRegister("akTfz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7866a12f9e6297d1$export$2e2bcd8739ae039);
function $7866a12f9e6297d1$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $7866a12f9e6297d1$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $7866a12f9e6297d1$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $7866a12f9e6297d1$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("5YU7f", function(module, exports) {
$parcel$export(module.exports, "default", () => $45ae15ca544cc5ac$export$2e2bcd8739ae039);

var $hxVai = parcelRequire("hxVai");
var $45ae15ca544cc5ac$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $45ae15ca544cc5ac$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $hxVai.default).apply(undefined, chain)(store.dispatch);
            return $45ae15ca544cc5ac$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("hxVai", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc61dc852e3aff1b$export$2e2bcd8739ae039);
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $cc61dc852e3aff1b$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});



parcelRegister("8IwGp", function(module, exports) {
$parcel$export(module.exports, "wrapMapToPropsConstant", () => $658bc8f00f9a1564$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $658bc8f00f9a1564$export$8d46c7f53c8c602f);
parcelRequire("41aN4");
function $658bc8f00f9a1564$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $658bc8f00f9a1564$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $658bc8f00f9a1564$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $658bc8f00f9a1564$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $658bc8f00f9a1564$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("41aN4", function(module, exports) {

var $lqwvs = parcelRequire("lqwvs");

var $aCOG9 = parcelRequire("aCOG9");
function $2ecfa02d32700c94$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $lqwvs.default)(value)) (0, $aCOG9.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("lqwvs", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9953dcc21ea2bdd$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f9953dcc21ea2bdd$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("aCOG9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bc4c3c067be49bd$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $7bc4c3c067be49bd$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("4KXSs", function(module, exports) {
$parcel$export(module.exports, "default", () => $3769e7b7fbaa1a66$export$2e2bcd8739ae039);

var $8IwGp = parcelRequire("8IwGp");
function $3769e7b7fbaa1a66$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $8IwGp.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $3769e7b7fbaa1a66$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $8IwGp.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $3769e7b7fbaa1a66$export$2e2bcd8739ae039 = [
    $3769e7b7fbaa1a66$export$23fc470827b14aa,
    $3769e7b7fbaa1a66$export$514bc8c1a53c1d66
];

});

parcelRegister("1g2UA", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ea98b4990cecd4e$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");
parcelRequire("41aN4");
function $0ea98b4990cecd4e$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $cCnFQ.default)({}, ownProps, stateProps, dispatchProps);
}
function $0ea98b4990cecd4e$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $0ea98b4990cecd4e$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $0ea98b4990cecd4e$export$5b105939c84b5234(mergeProps) : undefined;
}
function $0ea98b4990cecd4e$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $0ea98b4990cecd4e$export$691c327fc30bc857;
    } : undefined;
}
var $0ea98b4990cecd4e$export$2e2bcd8739ae039 = [
    $0ea98b4990cecd4e$export$d61b680184bc3f00,
    $0ea98b4990cecd4e$export$a13ba70ef50dda6d
];

});

parcelRegister("1DUCN", function(module, exports) {
$parcel$export(module.exports, "default", () => $13255b707b8af1ec$export$2e2bcd8739ae039);

var $911Xe = parcelRequire("911Xe");
parcelRequire("kT1z1");
function $13255b707b8af1ec$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $13255b707b8af1ec$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $13255b707b8af1ec$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $911Xe.default)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $13255b707b8af1ec$export$d20c0c2ca6eb2b6f : $13255b707b8af1ec$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("kT1z1", function(module, exports) {

var $aCOG9 = parcelRequire("aCOG9");
function $f34a284751fd8001$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!selector.hasOwnProperty('dependsOnOwnProps')) (0, $aCOG9.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $f34a284751fd8001$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $f34a284751fd8001$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $f34a284751fd8001$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $f34a284751fd8001$var$verify(mergeProps, 'mergeProps', displayName);
}

});




parcelRegister("h3cOB", function(module, exports) {
/**
 * Relay v0.0.0-main-39e79f66
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("fOLHm"));

});
parcelRegister("fOLHm", function(module, exports) {
'use strict';

var $dAHvh = parcelRequire("dAHvh");

var $kaDfN = parcelRequire("kaDfN");

var $9MmH5 = parcelRequire("9MmH5");

var $b8Qu9 = parcelRequire("b8Qu9");

var $5RYx7 = parcelRequire("5RYx7");

var $cjhWM = parcelRequire("cjhWM");

var $ikyor = parcelRequire("ikyor");

var $9DkE7 = parcelRequire("9DkE7");

var $4hYSN = parcelRequire("4hYSN");
var $b84086720b07cc0c$var$loadQuery = $4hYSN.loadQuery;

var $fjLEC = parcelRequire("fjLEC");

var $9FN0m = parcelRequire("9FN0m");

var $7Ww5l = parcelRequire("7Ww5l");

var $hKZad = parcelRequire("hKZad");

var $atGyY = parcelRequire("atGyY");

var $1mybG = parcelRequire("1mybG");

var $kPW8X = parcelRequire("kPW8X");

var $gfjSs = parcelRequire("gfjSs");

var $iQgMP = parcelRequire("iQgMP");

var $dolRG = parcelRequire("dolRG");

var $45oVL = parcelRequire("45oVL");

var $5hzUs = parcelRequire("5hzUs");

var $83zse = parcelRequire("83zse");

var $7aDcq = parcelRequire("7aDcq");

var $8iTFq = parcelRequire("8iTFq");
module.exports = {
    ConnectionHandler: $8iTFq.ConnectionHandler,
    QueryRenderer: $5RYx7,
    LocalQueryRenderer: $9MmH5,
    MutationTypes: $8iTFq.MutationTypes,
    RangeOperations: $8iTFq.RangeOperations,
    ReactRelayContext: $dAHvh,
    applyOptimisticMutation: $8iTFq.applyOptimisticMutation,
    commitLocalUpdate: $8iTFq.commitLocalUpdate,
    commitMutation: $8iTFq.commitMutation,
    createFragmentContainer: $kaDfN.createContainer,
    createPaginationContainer: $b8Qu9.createContainer,
    createRefetchContainer: $cjhWM.createContainer,
    fetchQuery_DEPRECATED: $8iTFq.fetchQuery_DEPRECATED,
    graphql: $8iTFq.graphql,
    readInlineData: $8iTFq.readInlineData,
    requestSubscription: $8iTFq.requestSubscription,
    EntryPointContainer: $ikyor,
    RelayEnvironmentProvider: $9FN0m,
    ProfilerContext: $fjLEC,
    fetchQuery: $8iTFq.fetchQuery,
    loadQuery: $b84086720b07cc0c$var$loadQuery,
    loadEntryPoint: $9DkE7,
    useClientQuery: $7Ww5l,
    useFragment: $atGyY,
    useLazyLoadQuery: $1mybG,
    useEntryPointLoader: $hKZad,
    useQueryLoader: $dolRG,
    useMutation: $kPW8X,
    usePaginationFragment: $gfjSs,
    usePreloadedQuery: $iQgMP,
    useRefetchableFragment: $45oVL,
    useRelayEnvironment: $5hzUs,
    useSubscribeToInvalidationState: $83zse,
    useSubscription: $7aDcq
};

});
parcelRegister("dAHvh", function(module, exports) {
'use strict';

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $9e506207aad4fb92$var$createRelayContext = $8iTFq.__internal.createRelayContext;
module.exports = $9e506207aad4fb92$var$createRelayContext($8P7DW);

});

parcelRegister("kaDfN", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $eaf330d21d4215cd$var$_interopRequireDefault = $dw9g1.default;

var $eaf330d21d4215cd$var$_extends2 = $eaf330d21d4215cd$var$_interopRequireDefault((parcelRequire("bl2sI")));

var $eaf330d21d4215cd$var$_objectWithoutPropertiesLoose2 = $eaf330d21d4215cd$var$_interopRequireDefault((parcelRequire("9wUL7")));

var $eaf330d21d4215cd$var$_assertThisInitialized2 = $eaf330d21d4215cd$var$_interopRequireDefault((parcelRequire("k1oZn")));

var $eaf330d21d4215cd$var$_inheritsLoose2 = $eaf330d21d4215cd$var$_interopRequireDefault((parcelRequire("fDncS")));

var $eaf330d21d4215cd$var$_defineProperty2 = $eaf330d21d4215cd$var$_interopRequireDefault((parcelRequire("cO17m")));
var $eaf330d21d4215cd$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $96NQr = parcelRequire("96NQr");

var $jXMPb = parcelRequire("jXMPb");
var $eaf330d21d4215cd$var$getContainerName = $jXMPb.getContainerName;

var $cXzhV = parcelRequire("cXzhV");
var $eaf330d21d4215cd$var$assertRelayContext = $cXzhV.assertRelayContext;

var $kgHsa = parcelRequire("kgHsa");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $eaf330d21d4215cd$var$createFragmentSpecResolver = $8iTFq.createFragmentSpecResolver, $eaf330d21d4215cd$var$getDataIDsFromObject = $8iTFq.getDataIDsFromObject, $eaf330d21d4215cd$var$isScalarAndEqual = $8iTFq.isScalarAndEqual;
function $eaf330d21d4215cd$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $eaf330d21d4215cd$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $eaf330d21d4215cd$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $eaf330d21d4215cd$var$_defineProperty2["default"])((0, $eaf330d21d4215cd$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $eaf330d21d4215cd$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $eaf330d21d4215cd$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $eaf330d21d4215cd$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $eaf330d21d4215cd$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $eaf330d21d4215cd$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $eaf330d21d4215cd$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $eaf330d21d4215cd$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$kgHsa(prevIDs, nextIDs)) {
                resolver = $eaf330d21d4215cd$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $eaf330d21d4215cd$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $eaf330d21d4215cd$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$eaf330d21d4215cd$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $eaf330d21d4215cd$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $eaf330d21d4215cd$var$_excluded);
            return /*#__PURE__*/ $8P7DW.createElement(Component, (0, $eaf330d21d4215cd$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($8P7DW.Component), (0, $eaf330d21d4215cd$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $eaf330d21d4215cd$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $eaf330d21d4215cd$var$createContainer(Component, fragmentSpec) {
    return $96NQr(Component, fragmentSpec, $eaf330d21d4215cd$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $eaf330d21d4215cd$var$createContainer
};

});
parcelRegister("bl2sI", function(module, exports) {
function $841390c8bc2f0b62$var$_extends() {
    return module.exports = $841390c8bc2f0b62$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $841390c8bc2f0b62$var$_extends.apply(null, arguments);
}
module.exports = $841390c8bc2f0b62$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("k1oZn", function(module, exports) {
function $e93748f2dad59d30$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $e93748f2dad59d30$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("96NQr", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $6a1b56bea6ffc503$var$_interopRequireDefault = $dw9g1.default;

var $6a1b56bea6ffc503$var$_extends2 = $6a1b56bea6ffc503$var$_interopRequireDefault((parcelRequire("bl2sI")));

var $eGzTv = parcelRequire("eGzTv");

var $jXMPb = parcelRequire("jXMPb");
var $6a1b56bea6ffc503$var$getComponentName = $jXMPb.getComponentName, $6a1b56bea6ffc503$var$getContainerName = $jXMPb.getContainerName;

var $dAHvh = parcelRequire("dAHvh");

var $ajykT = parcelRequire("ajykT");

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $6a1b56bea6ffc503$var$getFragment = $8iTFq.getFragment;
var $6a1b56bea6ffc503$var$useContext = $8P7DW.useContext;
function $6a1b56bea6ffc503$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $6a1b56bea6ffc503$var$getContainerName(ComponentClass);
    $eGzTv($6a1b56bea6ffc503$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $6a1b56bea6ffc503$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $6a1b56bea6ffc503$var$useContext($dAHvh);
        !(context != null) && $3rEVE(false);
        var queryRendererContext = $6a1b56bea6ffc503$var$useContext($ajykT);
        return /*#__PURE__*/ $8P7DW.createElement(Container, (0, $6a1b56bea6ffc503$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $8P7DW.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $6a1b56bea6ffc503$var$buildReactRelayContainer;

});
parcelRegister("eGzTv", function(module, exports) {
'use strict';

var $3rEVE = parcelRequire("3rEVE");
function $ab10d4c99cf13f44$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $3rEVE(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $3rEVE(false);
    }
}
module.exports = $ab10d4c99cf13f44$var$assertFragmentMap;

});

parcelRegister("jXMPb", function(module, exports) {
'use strict';
function $e8896691bac32828$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $e8896691bac32828$var$getContainerName(Component) {
    return 'Relay(' + $e8896691bac32828$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $e8896691bac32828$var$getComponentName,
    getContainerName: $e8896691bac32828$var$getContainerName
};

});

parcelRegister("ajykT", function(module, exports) {
'use strict';

var $8P7DW = parcelRequire("8P7DW");
module.exports = $8P7DW.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("cXzhV", function(module, exports) {
'use strict';

var $l1y4z = parcelRequire("l1y4z");

var $3rEVE = parcelRequire("3rEVE");
function $96f65e3b41a27d01$var$assertRelayContext(relay) {
    !$96f65e3b41a27d01$var$isRelayContext(relay) && $3rEVE(false);
    return relay;
}
function $96f65e3b41a27d01$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $l1y4z(context.environment);
}
module.exports = {
    assertRelayContext: $96f65e3b41a27d01$var$assertRelayContext,
    isRelayContext: $96f65e3b41a27d01$var$isRelayContext
};

});
parcelRegister("l1y4z", function(module, exports) {
'use strict';
function $f4e41f1fe52bcad1$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $f4e41f1fe52bcad1$var$isRelayEnvironment;

});



parcelRegister("9MmH5", function(module, exports) {
'use strict';

var $dAHvh = parcelRequire("dAHvh");

var $ajykT = parcelRequire("ajykT");

var $kgHsa = parcelRequire("kgHsa");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $01d65baa8a9ee212$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $01d65baa8a9ee212$var$deepFreeze = $8iTFq.deepFreeze, $01d65baa8a9ee212$var$getRequest = $8iTFq.getRequest;
var $01d65baa8a9ee212$var$useLayoutEffect = $8P7DW.useLayoutEffect, $01d65baa8a9ee212$var$useState = $8P7DW.useState, $01d65baa8a9ee212$var$useRef = $8P7DW.useRef, $01d65baa8a9ee212$var$useMemo = $8P7DW.useMemo;
var $01d65baa8a9ee212$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $01d65baa8a9ee212$var$useDeepCompare(value) {
    var latestValue = $8P7DW.useRef(value);
    if (!$kgHsa(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $01d65baa8a9ee212$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $01d65baa8a9ee212$var$useDeepCompare(variables);
    var operation = $01d65baa8a9ee212$var$useMemo(function() {
        var request = $01d65baa8a9ee212$var$getRequest(query);
        return $01d65baa8a9ee212$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $01d65baa8a9ee212$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $01d65baa8a9ee212$var$useRef(null);
    var _useState = $01d65baa8a9ee212$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $01d65baa8a9ee212$var$useRef(null);
    var snapshot = $01d65baa8a9ee212$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $01d65baa8a9ee212$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($dAHvh.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $8P7DW.createElement($ajykT.Provider, {
        value: $01d65baa8a9ee212$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $01d65baa8a9ee212$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("b8Qu9", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $81c9278b26480471$var$_interopRequireDefault = $dw9g1.default;

var $81c9278b26480471$var$_extends2 = $81c9278b26480471$var$_interopRequireDefault((parcelRequire("bl2sI")));

var $81c9278b26480471$var$_objectWithoutPropertiesLoose2 = $81c9278b26480471$var$_interopRequireDefault((parcelRequire("9wUL7")));

var $81c9278b26480471$var$_assertThisInitialized2 = $81c9278b26480471$var$_interopRequireDefault((parcelRequire("k1oZn")));

var $81c9278b26480471$var$_inheritsLoose2 = $81c9278b26480471$var$_interopRequireDefault((parcelRequire("fDncS")));

var $81c9278b26480471$var$_defineProperty2 = $81c9278b26480471$var$_interopRequireDefault((parcelRequire("cO17m")));

var $81c9278b26480471$var$_objectSpread3 = $81c9278b26480471$var$_interopRequireDefault((parcelRequire("RoT9E")));
var $81c9278b26480471$var$_excluded = [
    "componentRef"
], $81c9278b26480471$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $81c9278b26480471$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $96NQr = parcelRequire("96NQr");

var $3AMCr = parcelRequire("3AMCr");

var $jXMPb = parcelRequire("jXMPb");
var $81c9278b26480471$var$getComponentName = $jXMPb.getComponentName, $81c9278b26480471$var$getContainerName = $jXMPb.getContainerName;

var $dAHvh = parcelRequire("dAHvh");

var $ldbrG = parcelRequire("ldbrG");

var $cXzhV = parcelRequire("cXzhV");
var $81c9278b26480471$var$assertRelayContext = $cXzhV.assertRelayContext;

var $kgHsa = parcelRequire("kgHsa");

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $81c9278b26480471$var$ConnectionInterface = $8iTFq.ConnectionInterface, $81c9278b26480471$var$Observable = $8iTFq.Observable, $81c9278b26480471$var$RelayFeatureFlags = $8iTFq.RelayFeatureFlags, $81c9278b26480471$var$createFragmentSpecResolver = $8iTFq.createFragmentSpecResolver, $81c9278b26480471$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $81c9278b26480471$var$getDataIDsFromObject = $8iTFq.getDataIDsFromObject, $81c9278b26480471$var$getRequest = $8iTFq.getRequest, $81c9278b26480471$var$getVariablesFromObject = $8iTFq.getVariablesFromObject, $81c9278b26480471$var$isScalarAndEqual = $8iTFq.isScalarAndEqual;
parcelRequire("l1Dol");
var $81c9278b26480471$var$FORWARD = 'forward';
function $81c9278b26480471$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $3rEVE(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $81c9278b26480471$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $3rEVE(false);
    return function(prevVars, totalCount) {
        return (0, $81c9278b26480471$var$_objectSpread3["default"])((0, $81c9278b26480471$var$_objectSpread3["default"])({}, prevVars), {}, (0, $81c9278b26480471$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $81c9278b26480471$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $3rEVE(false);
            !!foundConnectionMetadata && $3rEVE(false);
            foundConnectionMetadata = (0, $81c9278b26480471$var$_objectSpread3["default"])((0, $81c9278b26480471$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $3rEVE(false);
    return foundConnectionMetadata || {};
}
function $81c9278b26480471$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $81c9278b26480471$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $81c9278b26480471$var$getComponentName(Component);
    var containerName = $81c9278b26480471$var$getContainerName(Component);
    var metadata = $81c9278b26480471$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $81c9278b26480471$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $3rEVE(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $81c9278b26480471$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $81c9278b26480471$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $81c9278b26480471$var$_defineProperty2["default"])((0, $81c9278b26480471$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $81c9278b26480471$var$_defineProperty2["default"])((0, $81c9278b26480471$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $81c9278b26480471$var$_defineProperty2["default"])((0, $81c9278b26480471$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $81c9278b26480471$var$_defineProperty2["default"])((0, $81c9278b26480471$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $81c9278b26480471$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $81c9278b26480471$var$_defineProperty2["default"])((0, $81c9278b26480471$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $81c9278b26480471$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $81c9278b26480471$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $81c9278b26480471$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $81c9278b26480471$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($81c9278b26480471$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $81c9278b26480471$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $81c9278b26480471$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($81c9278b26480471$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($81c9278b26480471$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $81c9278b26480471$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $81c9278b26480471$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $81c9278b26480471$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $3AMCr(fragments, this.props);
            var nextRootVariables = $3AMCr(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$kgHsa(prevRootVariables, nextRootVariables) || !$kgHsa(prevIDs, nextIDs)) {
                this._cleanup();
                if ($81c9278b26480471$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $81c9278b26480471$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $81c9278b26480471$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$81c9278b26480471$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $81c9278b26480471$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $81c9278b26480471$var$_excluded);
            var props = (0, $81c9278b26480471$var$_objectSpread3["default"])((0, $81c9278b26480471$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $81c9278b26480471$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $3rEVE(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $3rEVE(false);
            !(typeof pageInfo === 'object') && $3rEVE(false);
            var hasMore = direction === $81c9278b26480471$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $81c9278b26480471$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $ldbrG();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $81c9278b26480471$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $81c9278b26480471$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $81c9278b26480471$var$_excluded2);
            var props = (0, $81c9278b26480471$var$_objectSpread3["default"])((0, $81c9278b26480471$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $3AMCr(fragments, restProps);
            fragmentVariables = $81c9278b26480471$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $81c9278b26480471$var$_objectSpread3["default"])((0, $81c9278b26480471$var$_objectSpread3["default"])((0, $81c9278b26480471$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $3rEVE(false);
            fetchVariables = (0, $81c9278b26480471$var$_objectSpread3["default"])((0, $81c9278b26480471$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $81c9278b26480471$var$_objectSpread3["default"])((0, $81c9278b26480471$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $81c9278b26480471$var$getRequest(connectionConfig.query);
            var operation = $81c9278b26480471$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$kgHsa(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $81c9278b26480471$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $81c9278b26480471$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $81c9278b26480471$var$_excluded3);
            return /*#__PURE__*/ $8P7DW.createElement($dAHvh.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $8P7DW.createElement(Component, (0, $81c9278b26480471$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($8P7DW.Component), (0, $81c9278b26480471$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $81c9278b26480471$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $96NQr(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $81c9278b26480471$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $81c9278b26480471$var$createContainer
};

});
parcelRegister("3AMCr", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $29da72a3cbf58d02$var$_interopRequireDefault = $dw9g1.default;

var $29da72a3cbf58d02$var$_objectSpread2 = $29da72a3cbf58d02$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $8iTFq = parcelRequire("8iTFq");
var $29da72a3cbf58d02$var$getSelector = $8iTFq.getSelector;
function $29da72a3cbf58d02$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $29da72a3cbf58d02$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $29da72a3cbf58d02$var$_objectSpread2["default"])((0, $29da72a3cbf58d02$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $29da72a3cbf58d02$var$getRootVariablesForFragments;

});

parcelRegister("ldbrG", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $f713b0b8c9903d8f$var$_interopRequireDefault = $dw9g1.default;

var $f713b0b8c9903d8f$var$_defineProperty2 = $f713b0b8c9903d8f$var$_interopRequireDefault((parcelRequire("cO17m")));

var $3rEVE = parcelRequire("3rEVE");

var $8iTFq = parcelRequire("8iTFq");
var $f713b0b8c9903d8f$var$fetchQuery = $8iTFq.__internal.fetchQuery, $f713b0b8c9903d8f$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $f713b0b8c9903d8f$var$isRelayModernEnvironment = $8iTFq.isRelayModernEnvironment;
var $f713b0b8c9903d8f$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $f713b0b8c9903d8f$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $f713b0b8c9903d8f$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$f713b0b8c9903d8f$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $f713b0b8c9903d8f$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $3rEVE(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $f713b0b8c9903d8f$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $3rEVE(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $3rEVE(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $f713b0b8c9903d8f$var$ReactRelayQueryFetcher;

});


parcelRegister("5RYx7", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $4460dba108f88171$var$_interopRequireDefault = $dw9g1.default;

var $4460dba108f88171$var$_objectSpread2 = $4460dba108f88171$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $4460dba108f88171$var$_assertThisInitialized2 = $4460dba108f88171$var$_interopRequireDefault((parcelRequire("k1oZn")));

var $4460dba108f88171$var$_inheritsLoose2 = $4460dba108f88171$var$_interopRequireDefault((parcelRequire("fDncS")));

var $4460dba108f88171$var$_defineProperty2 = $4460dba108f88171$var$_interopRequireDefault((parcelRequire("cO17m")));

var $dAHvh = parcelRequire("dAHvh");

var $ldbrG = parcelRequire("ldbrG");

var $ajykT = parcelRequire("ajykT");

var $kgHsa = parcelRequire("kgHsa");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $4460dba108f88171$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $4460dba108f88171$var$deepFreeze = $8iTFq.deepFreeze, $4460dba108f88171$var$getRequest = $8iTFq.getRequest;
var $4460dba108f88171$var$requestCache = {};
var $4460dba108f88171$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $4460dba108f88171$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $4460dba108f88171$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $4460dba108f88171$var$_defineProperty2["default"])((0, $4460dba108f88171$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $4460dba108f88171$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $4460dba108f88171$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $4460dba108f88171$var$getRequest(query);
            requestCacheKey = $4460dba108f88171$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $4460dba108f88171$var$requestCache[requestCacheKey] ? $4460dba108f88171$var$requestCache[requestCacheKey].queryFetcher : new $ldbrG();
        } else queryFetcher = new $ldbrG();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $4460dba108f88171$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $4460dba108f88171$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$kgHsa(prevState.prevPropsVariables, nextProps.variables)) return $4460dba108f88171$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $4460dba108f88171$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $4460dba108f88171$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $4460dba108f88171$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $4460dba108f88171$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $4460dba108f88171$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $4460dba108f88171$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $8P7DW.createElement($dAHvh.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $8P7DW.createElement($ajykT.Provider, {
            value: $4460dba108f88171$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($8P7DW.Component);
function $4460dba108f88171$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $4460dba108f88171$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $4460dba108f88171$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $4460dba108f88171$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $4460dba108f88171$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $4460dba108f88171$var$getRequest(query);
        var requestCacheKey = $4460dba108f88171$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $4460dba108f88171$var$requestCache[requestCacheKey] ? $4460dba108f88171$var$requestCache[requestCacheKey].queryFetcher : new $ldbrG(prevSelectionReferences);
    } else queryFetcher = new $ldbrG(prevSelectionReferences);
    return (0, $4460dba108f88171$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $4460dba108f88171$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $4460dba108f88171$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $4460dba108f88171$var$getRequest(query);
        var operation = $4460dba108f88171$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $4460dba108f88171$var$requestCache[requestCacheKey]) {
            var snapshot = $4460dba108f88171$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $4460dba108f88171$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $4460dba108f88171$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $4460dba108f88171$var$getRequestCacheKey(request.params, props.variables);
            $4460dba108f88171$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $4460dba108f88171$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $4460dba108f88171$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $4460dba108f88171$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $4460dba108f88171$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $4460dba108f88171$var$ReactRelayQueryRenderer;

});

parcelRegister("cjhWM", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $8f652e4ba152895f$var$_interopRequireDefault = $dw9g1.default;

var $8f652e4ba152895f$var$_extends2 = $8f652e4ba152895f$var$_interopRequireDefault((parcelRequire("bl2sI")));

var $8f652e4ba152895f$var$_objectWithoutPropertiesLoose2 = $8f652e4ba152895f$var$_interopRequireDefault((parcelRequire("9wUL7")));

var $8f652e4ba152895f$var$_objectSpread2 = $8f652e4ba152895f$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $8f652e4ba152895f$var$_assertThisInitialized2 = $8f652e4ba152895f$var$_interopRequireDefault((parcelRequire("k1oZn")));

var $8f652e4ba152895f$var$_inheritsLoose2 = $8f652e4ba152895f$var$_interopRequireDefault((parcelRequire("fDncS")));

var $8f652e4ba152895f$var$_defineProperty2 = $8f652e4ba152895f$var$_interopRequireDefault((parcelRequire("cO17m")));
var $8f652e4ba152895f$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $96NQr = parcelRequire("96NQr");

var $3AMCr = parcelRequire("3AMCr");

var $jXMPb = parcelRequire("jXMPb");
var $8f652e4ba152895f$var$getContainerName = $jXMPb.getContainerName;

var $dAHvh = parcelRequire("dAHvh");

var $ldbrG = parcelRequire("ldbrG");

var $cXzhV = parcelRequire("cXzhV");
var $8f652e4ba152895f$var$assertRelayContext = $cXzhV.assertRelayContext;

var $kgHsa = parcelRequire("kgHsa");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $8f652e4ba152895f$var$Observable = $8iTFq.Observable, $8f652e4ba152895f$var$createFragmentSpecResolver = $8iTFq.createFragmentSpecResolver, $8f652e4ba152895f$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $8f652e4ba152895f$var$getDataIDsFromObject = $8iTFq.getDataIDsFromObject, $8f652e4ba152895f$var$getRequest = $8iTFq.getRequest, $8f652e4ba152895f$var$getVariablesFromObject = $8iTFq.getVariablesFromObject, $8f652e4ba152895f$var$isScalarAndEqual = $8iTFq.isScalarAndEqual;
parcelRequire("l1Dol");
function $8f652e4ba152895f$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $8f652e4ba152895f$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $8f652e4ba152895f$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $8f652e4ba152895f$var$_defineProperty2["default"])((0, $8f652e4ba152895f$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $8f652e4ba152895f$var$_defineProperty2["default"])((0, $8f652e4ba152895f$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $8f652e4ba152895f$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $3AMCr(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $8f652e4ba152895f$var$_objectSpread2["default"])((0, $8f652e4ba152895f$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $8f652e4ba152895f$var$_objectSpread2["default"])((0, $8f652e4ba152895f$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $8f652e4ba152895f$var$getRequest(taggedNode);
                var operation = $8f652e4ba152895f$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $8f652e4ba152895f$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $8f652e4ba152895f$var$_objectSpread2["default"])((0, $8f652e4ba152895f$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $8f652e4ba152895f$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $8f652e4ba152895f$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $8f652e4ba152895f$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $8f652e4ba152895f$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $8f652e4ba152895f$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $8f652e4ba152895f$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $3AMCr(fragments, prevProps);
            var nextRootVariables = $3AMCr(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$kgHsa(prevRootVariables, nextRootVariables) || !$kgHsa(prevIDs, nextIDs)) {
                resolver = $8f652e4ba152895f$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $8f652e4ba152895f$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$8f652e4ba152895f$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $8f652e4ba152895f$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $ldbrG();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $8f652e4ba152895f$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $8f652e4ba152895f$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $8P7DW.createElement($dAHvh.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $8P7DW.createElement(Component, (0, $8f652e4ba152895f$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($8P7DW.Component), (0, $8f652e4ba152895f$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $8f652e4ba152895f$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $8f652e4ba152895f$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $96NQr(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $8f652e4ba152895f$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $8f652e4ba152895f$var$createContainer
};

});

parcelRegister("ikyor", function(module, exports) {
'use strict';

var $fjLEC = parcelRequire("fjLEC");

var $5hzUs = parcelRequire("5hzUs");

var $8P7DW = parcelRequire("8P7DW");

var $8P7DW = parcelRequire("8P7DW");
var $d584c608158b19d7$var$useContext = $8P7DW.useContext, $d584c608158b19d7$var$useEffect = $8P7DW.useEffect;
parcelRequire("l1Dol");
function $d584c608158b19d7$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $d584c608158b19d7$var$useContext($fjLEC);
    var environment = $5hzUs();
    $d584c608158b19d7$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $8P7DW.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $d584c608158b19d7$var$EntryPointContainer;

});
parcelRegister("fjLEC", function(module, exports) {
'use strict';

var $8P7DW = parcelRequire("8P7DW");
var $b26d9879a3dd10c4$var$ProfilerContext = $8P7DW.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $b26d9879a3dd10c4$var$ProfilerContext;

});

parcelRegister("5hzUs", function(module, exports) {
'use strict';

var $dAHvh = parcelRequire("dAHvh");

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");
var $3d8a6533c6b1cd26$var$useContext = $8P7DW.useContext;
function $3d8a6533c6b1cd26$var$useRelayEnvironment() {
    var context = $3d8a6533c6b1cd26$var$useContext($dAHvh);
    !(context != null) && $3rEVE(false);
    return context.environment;
}
module.exports = $3d8a6533c6b1cd26$var$useRelayEnvironment;

});


parcelRegister("9DkE7", function(module, exports) {
'use strict';

var $4hYSN = parcelRequire("4hYSN");
var $7037c57826bf676c$var$loadQuery = $4hYSN.loadQuery;
function $7037c57826bf676c$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var _queries$queryPropNam = queries[queryPropName], environmentProviderOptions = _queries$queryPropNam.environmentProviderOptions, options = _queries$queryPropNam.options, parameters = _queries$queryPropNam.parameters, variables = _queries$queryPropNam.variables;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $7037c57826bf676c$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $7037c57826bf676c$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $7037c57826bf676c$var$loadEntryPoint;

});
parcelRegister("4hYSN", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $31f7fa0410f3a549$var$_interopRequireDefault = $dw9g1.default;

var $31f7fa0410f3a549$var$_objectSpread2 = $31f7fa0410f3a549$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $31f7fa0410f3a549$var$fetchQueryDeduped = $8iTFq.__internal.fetchQueryDeduped, $31f7fa0410f3a549$var$Observable = $8iTFq.Observable, $31f7fa0410f3a549$var$PreloadableQueryRegistry = $8iTFq.PreloadableQueryRegistry, $31f7fa0410f3a549$var$RelayFeatureFlags = $8iTFq.RelayFeatureFlags, $31f7fa0410f3a549$var$ReplaySubject = $8iTFq.ReplaySubject, $31f7fa0410f3a549$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $31f7fa0410f3a549$var$getRequest = $8iTFq.getRequest, $31f7fa0410f3a549$var$getRequestIdentifier = $8iTFq.getRequestIdentifier;
parcelRequire("l1Dol");
var $31f7fa0410f3a549$var$RenderDispatcher = null;
var $31f7fa0410f3a549$var$fetchKey = 100001;
function $31f7fa0410f3a549$var$useTrackLoadQueryInRender() {
    if ($31f7fa0410f3a549$var$RenderDispatcher === null) {
        var _React$__SECRET_INTER, _React$__SECRET_INTER2;
        $31f7fa0410f3a549$var$RenderDispatcher = (_React$__SECRET_INTER = $8P7DW.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER === void 0 ? void 0 : (_React$__SECRET_INTER2 = _React$__SECRET_INTER.ReactCurrentDispatcher) === null || _React$__SECRET_INTER2 === void 0 ? void 0 : _React$__SECRET_INTER2.current;
    }
}
function $31f7fa0410f3a549$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _React$__SECRET_INTER3, _React$__SECRET_INTER4, _options$__nameForWar, _options$fetchPolicy;
    var CurrentDispatcher = (_React$__SECRET_INTER3 = $8P7DW.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER3 === void 0 ? void 0 : (_React$__SECRET_INTER4 = _React$__SECRET_INTER3.ReactCurrentDispatcher) === null || _React$__SECRET_INTER4 === void 0 ? void 0 : _React$__SECRET_INTER4.current;
    $31f7fa0410f3a549$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $31f7fa0410f3a549$var$_objectSpread2["default"])((0, $31f7fa0410f3a549$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $31f7fa0410f3a549$var$ReplaySubject();
    var returnedObservable = $31f7fa0410f3a549$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params) {
        didMakeNetworkRequest = true;
        var observable;
        var subject = new $31f7fa0410f3a549$var$ReplaySubject();
        if ($31f7fa0410f3a549$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
            var identifier = 'raw-network-request-' + $31f7fa0410f3a549$var$getRequestIdentifier(params, variables);
            observable = $31f7fa0410f3a549$var$fetchQueryDeduped(environment, identifier, function() {
                var network = environment.getNetwork();
                return network.execute(params, variables, networkCacheConfig);
            });
        } else {
            var network = environment.getNetwork();
            observable = network.execute(params, variables, networkCacheConfig);
        }
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $31f7fa0410f3a549$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        if ($31f7fa0410f3a549$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $31f7fa0410f3a549$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $31f7fa0410f3a549$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params);
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $3rEVE(false);
        var _module = $31f7fa0410f3a549$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $31f7fa0410f3a549$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $31f7fa0410f3a549$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $31f7fa0410f3a549$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $31f7fa0410f3a549$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $31f7fa0410f3a549$var$loadQuery,
    useTrackLoadQueryInRender: $31f7fa0410f3a549$var$useTrackLoadQueryInRender
};

});


parcelRegister("9FN0m", function(module, exports) {
'use strict';

var $dAHvh = parcelRequire("dAHvh");

var $8P7DW = parcelRequire("8P7DW");
var $70adf4bbbfdfc22e$var$useMemo = $8P7DW.useMemo;
function $70adf4bbbfdfc22e$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $70adf4bbbfdfc22e$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($dAHvh.Provider, {
        value: context
    }, children);
}
module.exports = $70adf4bbbfdfc22e$var$RelayEnvironmentProvider;

});

parcelRegister("7Ww5l", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $5c86d6a1f47f4c5c$var$_interopRequireDefault = $dw9g1.default;

var $5c86d6a1f47f4c5c$var$_objectSpread2 = $5c86d6a1f47f4c5c$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $1mybG = parcelRequire("1mybG");
function $5c86d6a1f47f4c5c$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $1mybG(query, variables, (0, $5c86d6a1f47f4c5c$var$_objectSpread2["default"])((0, $5c86d6a1f47f4c5c$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $5c86d6a1f47f4c5c$var$useClientQuery;

});
parcelRegister("1mybG", function(module, exports) {
'use strict';

var $4hYSN = parcelRequire("4hYSN");
var $0fe25d6f48c5bb2c$var$useTrackLoadQueryInRender = $4hYSN.useTrackLoadQueryInRender;

var $azc28 = parcelRequire("azc28");

var $8Nnai = parcelRequire("8Nnai");

var $5hzUs = parcelRequire("5hzUs");

var $8iTFq = parcelRequire("8iTFq");
var $0fe25d6f48c5bb2c$var$fetchQuery = $8iTFq.__internal.fetchQuery;
function $0fe25d6f48c5bb2c$var$useLazyLoadQuery(gqlQuery, variables, options) {
    $0fe25d6f48c5bb2c$var$useTrackLoadQueryInRender();
    var environment = $5hzUs();
    var query = $8Nnai(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $azc28({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $0fe25d6f48c5bb2c$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $0fe25d6f48c5bb2c$var$useLazyLoadQuery;

});
parcelRegister("azc28", function(module, exports) {
'use strict';

var $fjLEC = parcelRequire("fjLEC");

var $8hU2S = parcelRequire("8hU2S");
var $7b1681dfd69c2373$var$getQueryCacheIdentifier = $8hU2S.getQueryCacheIdentifier, $7b1681dfd69c2373$var$getQueryResourceForEnvironment = $8hU2S.getQueryResourceForEnvironment;

var $5P6cG = parcelRequire("5P6cG");

var $lbE50 = parcelRequire("lbE50");

var $5hzUs = parcelRequire("5hzUs");

var $8P7DW = parcelRequire("8P7DW");
var $7b1681dfd69c2373$var$useContext = $8P7DW.useContext, $7b1681dfd69c2373$var$useEffect = $8P7DW.useEffect, $7b1681dfd69c2373$var$useState = $8P7DW.useState, $7b1681dfd69c2373$var$useRef = $8P7DW.useRef;
function $7b1681dfd69c2373$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $5hzUs();
    var profilerContext = $7b1681dfd69c2373$var$useContext($fjLEC);
    var QueryResource = $7b1681dfd69c2373$var$getQueryResourceForEnvironment(environment);
    var _useState = $7b1681dfd69c2373$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $5P6cG(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $7b1681dfd69c2373$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $7b1681dfd69c2373$var$useRef(false);
    $7b1681dfd69c2373$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $7b1681dfd69c2373$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $7b1681dfd69c2373$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $lbE50(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $7b1681dfd69c2373$var$useLazyLoadQueryNode;

});
parcelRegister("8hU2S", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $608b62ba6a45d015$var$_interopRequireDefault = $dw9g1.default;

var $608b62ba6a45d015$var$_objectSpread2 = $608b62ba6a45d015$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $608b62ba6a45d015$var$_defineProperty2 = $608b62ba6a45d015$var$_interopRequireDefault((parcelRequire("cO17m")));

var $eTDpn = parcelRequire("eTDpn");

var $3v1pR = parcelRequire("3v1pR");

var $3rEVE = parcelRequire("3rEVE");

var $8iTFq = parcelRequire("8iTFq");
var $608b62ba6a45d015$var$isPromise = $8iTFq.isPromise;
parcelRequire("l1Dol");
var $608b62ba6a45d015$var$CACHE_CAPACITY = 1000;
var $608b62ba6a45d015$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $608b62ba6a45d015$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $608b62ba6a45d015$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $608b62ba6a45d015$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $608b62ba6a45d015$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $608b62ba6a45d015$var$operationIsLiveQuery(operation) ? $608b62ba6a45d015$var$DEFAULT_LIVE_FETCH_POLICY : $608b62ba6a45d015$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $608b62ba6a45d015$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $608b62ba6a45d015$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $608b62ba6a45d015$var$nextID = 200000;
function $608b62ba6a45d015$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $608b62ba6a45d015$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $3v1pR(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $608b62ba6a45d015$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $608b62ba6a45d015$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $608b62ba6a45d015$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $eTDpn.create($608b62ba6a45d015$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $608b62ba6a45d015$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $608b62ba6a45d015$var$operationIsLiveQuery(operation) ? $608b62ba6a45d015$var$DEFAULT_LIVE_FETCH_POLICY : $608b62ba6a45d015$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $608b62ba6a45d015$var$_objectSpread2["default"])((0, $608b62ba6a45d015$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($608b62ba6a45d015$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $608b62ba6a45d015$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $608b62ba6a45d015$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $608b62ba6a45d015$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $608b62ba6a45d015$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $608b62ba6a45d015$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $608b62ba6a45d015$var$_objectSpread2["default"])((0, $608b62ba6a45d015$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($608b62ba6a45d015$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $608b62ba6a45d015$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $3rEVE(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $608b62ba6a45d015$var$createQueryResource(environment) {
    return new $608b62ba6a45d015$var$QueryResourceImpl(environment);
}
var $608b62ba6a45d015$var$dataResources = $608b62ba6a45d015$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $608b62ba6a45d015$var$getQueryResourceForEnvironment(environment) {
    var cached = $608b62ba6a45d015$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $608b62ba6a45d015$var$createQueryResource(environment);
    $608b62ba6a45d015$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $608b62ba6a45d015$var$createQueryResource,
    getQueryResourceForEnvironment: $608b62ba6a45d015$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $608b62ba6a45d015$var$getQueryCacheIdentifier
};

});
parcelRegister("eTDpn", function(module, exports) {
'use strict';

var $3rEVE = parcelRequire("3rEVE");
var $ad84c564d210f7ca$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $3rEVE(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $ad84c564d210f7ca$var$create(capacity) {
    return new $ad84c564d210f7ca$var$LRUCache(capacity);
}
module.exports = {
    create: $ad84c564d210f7ca$var$create
};

});

parcelRegister("3v1pR", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $28c55d93122c8a21$var$_interopRequireDefault = $dw9g1.default;

var $28c55d93122c8a21$var$_defineProperty2 = $28c55d93122c8a21$var$_interopRequireDefault((parcelRequire("cO17m")));
parcelRequire("l1Dol");
var $28c55d93122c8a21$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $28c55d93122c8a21$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $28c55d93122c8a21$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $28c55d93122c8a21$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $28c55d93122c8a21$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $28c55d93122c8a21$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $28c55d93122c8a21$var$SuspenseResource;

});


parcelRegister("5P6cG", function(module, exports) {
'use strict';

var $b1Ije = parcelRequire("b1Ije");

var $8P7DW = parcelRequire("8P7DW");
var $43d687188f5d6e15$var$useCallback = $8P7DW.useCallback, $43d687188f5d6e15$var$useEffect = $8P7DW.useEffect;
function $43d687188f5d6e15$var$useFetchTrackingRef() {
    var subscriptionRef = $b1Ije(null);
    var isFetchingRef = $b1Ije(false);
    var disposeFetch = $43d687188f5d6e15$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $43d687188f5d6e15$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $43d687188f5d6e15$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $43d687188f5d6e15$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $43d687188f5d6e15$var$useFetchTrackingRef;

});
parcelRegister("b1Ije", function(module, exports) {
'use strict';

var $8P7DW = parcelRequire("8P7DW");
var $80722896b85c0aa5$var$useMemo = $8P7DW.useMemo;
function $80722896b85c0aa5$var$useUnsafeRef_DEPRECATED(init) {
    return $80722896b85c0aa5$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $80722896b85c0aa5$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("lbE50", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $f6c9b71025555412$var$_interopRequireDefault = $dw9g1.default;

var $f6c9b71025555412$var$_objectSpread2 = $f6c9b71025555412$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $f6c9b71025555412$var$_createForOfIteratorHelper2 = $f6c9b71025555412$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $f6c9b71025555412$var$_toConsumableArray2 = $f6c9b71025555412$var$_interopRequireDefault((parcelRequire("agTSl")));

var $8hU2S = parcelRequire("8hU2S");
var $f6c9b71025555412$var$getQueryResourceForEnvironment = $8hU2S.getQueryResourceForEnvironment;

var $5hzUs = parcelRequire("5hzUs");

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");
var $f6c9b71025555412$var$useDebugValue = $8P7DW.useDebugValue, $f6c9b71025555412$var$useEffect = $8P7DW.useEffect, $f6c9b71025555412$var$useMemo = $8P7DW.useMemo, $f6c9b71025555412$var$useRef = $8P7DW.useRef, $f6c9b71025555412$var$useState = $8P7DW.useState;

var $8iTFq = parcelRequire("8iTFq");
var $f6c9b71025555412$var$_require3$__internal = $8iTFq.__internal, $f6c9b71025555412$var$fetchQueryInternal = $f6c9b71025555412$var$_require3$__internal.fetchQuery, $f6c9b71025555412$var$getPromiseForActiveRequest = $f6c9b71025555412$var$_require3$__internal.getPromiseForActiveRequest, $f6c9b71025555412$var$RelayFeatureFlags = $8iTFq.RelayFeatureFlags, $f6c9b71025555412$var$areEqualSelectors = $8iTFq.areEqualSelectors, $f6c9b71025555412$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $f6c9b71025555412$var$getPendingOperationsForFragment = $8iTFq.getPendingOperationsForFragment, $f6c9b71025555412$var$getSelector = $8iTFq.getSelector, $f6c9b71025555412$var$getVariablesFromFragment = $8iTFq.getVariablesFromFragment, $f6c9b71025555412$var$handlePotentialSnapshotErrors = $8iTFq.handlePotentialSnapshotErrors, $f6c9b71025555412$var$recycleNodesInto = $8iTFq.recycleNodesInto;
parcelRequire("l1Dol");
function $f6c9b71025555412$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $f6c9b71025555412$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $f6c9b71025555412$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $f6c9b71025555412$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $f6c9b71025555412$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $f6c9b71025555412$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $f6c9b71025555412$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $f6c9b71025555412$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $f6c9b71025555412$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator5 = (0, $f6c9b71025555412$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step5.value;
                $f6c9b71025555412$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $f6c9b71025555412$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $f6c9b71025555412$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            missingRequiredFields: currentSnapshot.missingRequiredFields,
            relayResolverErrors: currentSnapshot.relayResolverErrors,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $f6c9b71025555412$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                missingRequiredFields: _currentSnapshot.missingRequiredFields,
                relayResolverErrors: _currentSnapshot.relayResolverErrors,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $3rEVE(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $f6c9b71025555412$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $f6c9b71025555412$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $f6c9b71025555412$var$_objectSpread2["default"])((0, $f6c9b71025555412$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $f6c9b71025555412$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $f6c9b71025555412$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $f6c9b71025555412$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $f6c9b71025555412$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $f6c9b71025555412$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $f6c9b71025555412$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $f6c9b71025555412$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $f6c9b71025555412$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $f6c9b71025555412$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $f6c9b71025555412$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $f6c9b71025555412$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $f6c9b71025555412$var$useMemo(function() {
        return $f6c9b71025555412$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $3rEVE(false);
    else !!Array.isArray(fragmentRef) && $3rEVE(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $3rEVE(false);
    var environment = $5hzUs();
    var _useState = $f6c9b71025555412$var$useState(function() {
        return $f6c9b71025555412$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $f6c9b71025555412$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $f6c9b71025555412$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $f6c9b71025555412$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$f6c9b71025555412$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $f6c9b71025555412$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $f6c9b71025555412$var$useRef(false);
    $f6c9b71025555412$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = $f6c9b71025555412$var$useMemo(function() {
            var missingClientEdges = $f6c9b71025555412$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $f6c9b71025555412$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $f6c9b71025555412$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $f6c9b71025555412$var$useEffect(function() {
            var QueryResource = $f6c9b71025555412$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $f6c9b71025555412$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    var _iterator9 = (0, $f6c9b71025555412$var$_createForOfIteratorHelper2["default"])(disposables), _step9;
                    try {
                        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                            var disposable = _step9.value;
                            disposable.dispose();
                        }
                    } catch (err) {
                        _iterator9.e(err);
                    } finally{
                        _iterator9.f();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($f6c9b71025555412$var$isMissingData(state)) {
        var suspendingLiveResolvers = $f6c9b71025555412$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(_ref) {
            var liveStateID = _ref.liveStateID;
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($f6c9b71025555412$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$f6c9b71025555412$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $3rEVE(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $f6c9b71025555412$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $f6c9b71025555412$var$handlePotentialSnapshotErrorsForState(environment, state);
    var hasPendingStateChanges = $f6c9b71025555412$var$useRef(false);
    $f6c9b71025555412$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $f6c9b71025555412$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $f6c9b71025555412$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $f6c9b71025555412$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $f6c9b71025555412$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $3rEVE(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $3rEVE(false);
        data = state.snapshot.data;
    }
    if ($f6c9b71025555412$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $f6c9b71025555412$var$useFragmentInternal;

});


parcelRegister("8Nnai", function(module, exports) {
'use strict';

var $cuCWV = parcelRequire("cuCWV");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $6674de738b8e30ae$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $6674de738b8e30ae$var$getRequest = $8iTFq.getRequest;
var $6674de738b8e30ae$var$useMemo = $8P7DW.useMemo;
function $6674de738b8e30ae$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $cuCWV(variables);
    var memoCacheConfig = $cuCWV(cacheConfig || {});
    return $6674de738b8e30ae$var$useMemo(function() {
        return $6674de738b8e30ae$var$createOperationDescriptor($6674de738b8e30ae$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $6674de738b8e30ae$var$useMemoOperationDescriptor;

});
parcelRegister("cuCWV", function(module, exports) {
'use strict';

var $kgHsa = parcelRequire("kgHsa");

var $8P7DW = parcelRequire("8P7DW");
var $91867ff1987e85cc$var$useState = $8P7DW.useState;
function $91867ff1987e85cc$var$useMemoVariables(variables) {
    var _useState = $91867ff1987e85cc$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($kgHsa(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $91867ff1987e85cc$var$useMemoVariables;

});




parcelRegister("hKZad", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $ced62d64743956da$var$_interopRequireDefault = $dw9g1.default;

var $ced62d64743956da$var$_createForOfIteratorHelper2 = $ced62d64743956da$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $9DkE7 = parcelRequire("9DkE7");

var $4hYSN = parcelRequire("4hYSN");
var $ced62d64743956da$var$useTrackLoadQueryInRender = $4hYSN.useTrackLoadQueryInRender;

var $9zVnU = parcelRequire("9zVnU");

var $8P7DW = parcelRequire("8P7DW");
var $ced62d64743956da$var$useCallback = $8P7DW.useCallback, $ced62d64743956da$var$useEffect = $8P7DW.useEffect, $ced62d64743956da$var$useRef = $8P7DW.useRef, $ced62d64743956da$var$useState = $8P7DW.useState;
var $ced62d64743956da$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $ced62d64743956da$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    $ced62d64743956da$var$useTrackLoadQueryInRender();
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $ced62d64743956da$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $9zVnU();
    var undisposedEntryPointReferencesRef = $ced62d64743956da$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $ced62d64743956da$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $ced62d64743956da$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $ced62d64743956da$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $ced62d64743956da$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $9DkE7(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $ced62d64743956da$var$useRef(false);
    $ced62d64743956da$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $ced62d64743956da$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $ced62d64743956da$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $ced62d64743956da$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $ced62d64743956da$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $ced62d64743956da$var$useLoadEntryPoint;

});
parcelRegister("9zVnU", function(module, exports) {
'use strict';

var $8P7DW = parcelRequire("8P7DW");
var $6f93e54f7fe6b7fb$var$useEffect = $8P7DW.useEffect, $6f93e54f7fe6b7fb$var$useRef = $8P7DW.useRef;
function $6f93e54f7fe6b7fb$var$useIsMountedRef() {
    var isMountedRef = $6f93e54f7fe6b7fb$var$useRef(true);
    $6f93e54f7fe6b7fb$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $6f93e54f7fe6b7fb$var$useIsMountedRef;

});


parcelRegister("atGyY", function(module, exports) {
'use strict';

var $4hYSN = parcelRequire("4hYSN");
var $7a0da0fb5b67fa9e$var$useTrackLoadQueryInRender = $4hYSN.useTrackLoadQueryInRender;

var $lbE50 = parcelRequire("lbE50");

var $3LDx6 = parcelRequire("3LDx6");

var $8P7DW = parcelRequire("8P7DW");
var $7a0da0fb5b67fa9e$var$useDebugValue = $8P7DW.useDebugValue;

var $8iTFq = parcelRequire("8iTFq");
var $7a0da0fb5b67fa9e$var$getFragment = $8iTFq.getFragment;
function $7a0da0fb5b67fa9e$var$useFragment(fragment, key) {
    $7a0da0fb5b67fa9e$var$useTrackLoadQueryInRender();
    var fragmentNode = $7a0da0fb5b67fa9e$var$getFragment(fragment);
    $3LDx6(fragmentNode, 'first argument of useFragment()');
    var data = $lbE50(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $7a0da0fb5b67fa9e$var$useFragment;

});
parcelRegister("3LDx6", function(module, exports) {
'use strict';
parcelRequire("b1Ije");
parcelRequire("l1Dol");
function $2be46d4bbc8dbf93$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $2be46d4bbc8dbf93$var$useStaticFragmentNodeWarning;

});


parcelRegister("kPW8X", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $f2b5ac24e9fd603c$var$_interopRequireDefault = $dw9g1.default;

var $f2b5ac24e9fd603c$var$_objectSpread2 = $f2b5ac24e9fd603c$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $9zVnU = parcelRequire("9zVnU");

var $5hzUs = parcelRequire("5hzUs");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $f2b5ac24e9fd603c$var$defaultCommitMutation = $8iTFq.commitMutation;
var $f2b5ac24e9fd603c$var$useState = $8P7DW.useState, $f2b5ac24e9fd603c$var$useEffect = $8P7DW.useEffect, $f2b5ac24e9fd603c$var$useRef = $8P7DW.useRef, $f2b5ac24e9fd603c$var$useCallback = $8P7DW.useCallback;
function $f2b5ac24e9fd603c$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f2b5ac24e9fd603c$var$defaultCommitMutation;
    var environment = $5hzUs();
    var isMountedRef = $9zVnU();
    var environmentRef = $f2b5ac24e9fd603c$var$useRef(environment);
    var mutationRef = $f2b5ac24e9fd603c$var$useRef(mutation);
    var inFlightMutationsRef = $f2b5ac24e9fd603c$var$useRef(new Set());
    var _useState = $f2b5ac24e9fd603c$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $f2b5ac24e9fd603c$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $f2b5ac24e9fd603c$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $f2b5ac24e9fd603c$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $f2b5ac24e9fd603c$var$_objectSpread2["default"])((0, $f2b5ac24e9fd603c$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $f2b5ac24e9fd603c$var$useMutation;

});

parcelRegister("gfjSs", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $bd3d774364faf2d8$var$_interopRequireDefault = $dw9g1.default;

var $bd3d774364faf2d8$var$_objectSpread2 = $bd3d774364faf2d8$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $95D2h = parcelRequire("95D2h");

var $e7S3Q = parcelRequire("e7S3Q");

var $5hzUs = parcelRequire("5hzUs");

var $3LDx6 = parcelRequire("3LDx6");

var $8P7DW = parcelRequire("8P7DW");
var $bd3d774364faf2d8$var$useCallback = $8P7DW.useCallback, $bd3d774364faf2d8$var$useDebugValue = $8P7DW.useDebugValue, $bd3d774364faf2d8$var$useState = $8P7DW.useState;

var $8iTFq = parcelRequire("8iTFq");
var $bd3d774364faf2d8$var$getFragment = $8iTFq.getFragment, $bd3d774364faf2d8$var$getFragmentIdentifier = $8iTFq.getFragmentIdentifier, $bd3d774364faf2d8$var$getPaginationMetadata = $8iTFq.getPaginationMetadata;
function $bd3d774364faf2d8$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $bd3d774364faf2d8$var$getFragment(fragmentInput);
    $3LDx6(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $bd3d774364faf2d8$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $e7S3Q(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $bd3d774364faf2d8$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $bd3d774364faf2d8$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $bd3d774364faf2d8$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $bd3d774364faf2d8$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $bd3d774364faf2d8$var$_objectSpread2["default"])((0, $bd3d774364faf2d8$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $bd3d774364faf2d8$var$useLoadMore(args) {
    var environment = $5hzUs();
    var _useState = $bd3d774364faf2d8$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        }
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $95D2h((0, $bd3d774364faf2d8$var$_objectSpread2["default"])((0, $bd3d774364faf2d8$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $bd3d774364faf2d8$var$usePaginationFragment;

});
parcelRegister("95D2h", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $69e2dc5c68ee3eeb$var$_interopRequireDefault = $dw9g1.default;

var $69e2dc5c68ee3eeb$var$_objectSpread2 = $69e2dc5c68ee3eeb$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $5P6cG = parcelRequire("5P6cG");

var $9zVnU = parcelRequire("9zVnU");

var $gQhYl = parcelRequire("gQhYl");

var $5hzUs = parcelRequire("5hzUs");

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");
var $69e2dc5c68ee3eeb$var$useCallback = $8P7DW.useCallback, $69e2dc5c68ee3eeb$var$useEffect = $8P7DW.useEffect, $69e2dc5c68ee3eeb$var$useState = $8P7DW.useState;

var $8iTFq = parcelRequire("8iTFq");
var $69e2dc5c68ee3eeb$var$fetchQuery = $8iTFq.__internal.fetchQuery, $69e2dc5c68ee3eeb$var$ConnectionInterface = $8iTFq.ConnectionInterface, $69e2dc5c68ee3eeb$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $69e2dc5c68ee3eeb$var$getPaginationVariables = $8iTFq.getPaginationVariables, $69e2dc5c68ee3eeb$var$getRefetchMetadata = $8iTFq.getRefetchMetadata, $69e2dc5c68ee3eeb$var$getSelector = $8iTFq.getSelector, $69e2dc5c68ee3eeb$var$getValueAtPath = $8iTFq.getValueAtPath;
parcelRequire("l1Dol");
function $69e2dc5c68ee3eeb$var$useLoadMoreFunction(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $5hzUs();
    var _useFetchTrackingRef = $5P6cG(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $69e2dc5c68ee3eeb$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $9zVnU();
    var _useState = $69e2dc5c68ee3eeb$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $69e2dc5c68ee3eeb$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $gQhYl(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $69e2dc5c68ee3eeb$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $69e2dc5c68ee3eeb$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var loadMore = $69e2dc5c68ee3eeb$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $69e2dc5c68ee3eeb$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $3rEVE(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $69e2dc5c68ee3eeb$var$_objectSpread2["default"])((0, $69e2dc5c68ee3eeb$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $69e2dc5c68ee3eeb$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $69e2dc5c68ee3eeb$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $69e2dc5c68ee3eeb$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $69e2dc5c68ee3eeb$var$fetchQuery(environment, paginationQuery).subscribe((0, $69e2dc5c68ee3eeb$var$_objectSpread2["default"])((0, $69e2dc5c68ee3eeb$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
function $69e2dc5c68ee3eeb$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $69e2dc5c68ee3eeb$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $69e2dc5c68ee3eeb$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $3rEVE(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $3rEVE(false);
    !(typeof pageInfo === 'object') && $3rEVE(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $3rEVE(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $69e2dc5c68ee3eeb$var$useLoadMoreFunction;

});
parcelRegister("gQhYl", function(module, exports) {
'use strict';

var $5hzUs = parcelRequire("5hzUs");

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");

var $8iTFq = parcelRequire("8iTFq");
var $c42f719406df3f02$var$getObservableForActiveRequest = $8iTFq.__internal.getObservableForActiveRequest, $c42f719406df3f02$var$getSelector = $8iTFq.getSelector;
var $c42f719406df3f02$var$useEffect = $8P7DW.useEffect, $c42f719406df3f02$var$useState = $8P7DW.useState, $c42f719406df3f02$var$useMemo = $8P7DW.useMemo;
function $c42f719406df3f02$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $5hzUs();
    var observable = $c42f719406df3f02$var$useMemo(function() {
        var selector = $c42f719406df3f02$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $3rEVE(false);
        return $c42f719406df3f02$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $c42f719406df3f02$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $c42f719406df3f02$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $c42f719406df3f02$var$useIsOperationNodeActive;

});


parcelRegister("e7S3Q", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $a48ba78c1cbe16f9$var$_interopRequireDefault = $dw9g1.default;

var $a48ba78c1cbe16f9$var$_objectSpread2 = $a48ba78c1cbe16f9$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $fjLEC = parcelRequire("fjLEC");

var $8hU2S = parcelRequire("8hU2S");
var $a48ba78c1cbe16f9$var$getQueryResourceForEnvironment = $8hU2S.getQueryResourceForEnvironment;

var $fKGjT = parcelRequire("fKGjT");

var $lbE50 = parcelRequire("lbE50");

var $9zVnU = parcelRequire("9zVnU");

var $dolRG = parcelRequire("dolRG");

var $5hzUs = parcelRequire("5hzUs");

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");
var $a48ba78c1cbe16f9$var$useCallback = $8P7DW.useCallback, $a48ba78c1cbe16f9$var$useContext = $8P7DW.useContext, $a48ba78c1cbe16f9$var$useReducer = $8P7DW.useReducer;

var $8iTFq = parcelRequire("8iTFq");
var $a48ba78c1cbe16f9$var$fetchQuery = $8iTFq.__internal.fetchQuery, $a48ba78c1cbe16f9$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $a48ba78c1cbe16f9$var$getFragmentIdentifier = $8iTFq.getFragmentIdentifier, $a48ba78c1cbe16f9$var$getRefetchMetadata = $8iTFq.getRefetchMetadata, $a48ba78c1cbe16f9$var$getSelector = $8iTFq.getSelector, $a48ba78c1cbe16f9$var$getValueAtPath = $8iTFq.getValueAtPath;
parcelRequire("l1Dol");
function $a48ba78c1cbe16f9$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $a48ba78c1cbe16f9$var$_objectSpread2["default"])((0, $a48ba78c1cbe16f9$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $a48ba78c1cbe16f9$var$useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $5hzUs();
    var _getRefetchMetadata = $a48ba78c1cbe16f9$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $a48ba78c1cbe16f9$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $a48ba78c1cbe16f9$var$useReducer($a48ba78c1cbe16f9$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $a48ba78c1cbe16f9$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $a48ba78c1cbe16f9$var$useContext($fjLEC);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $dolRG(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $a48ba78c1cbe16f9$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $fKGjT(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $3rEVE(false);
        var refetchedFragmentRef = $a48ba78c1cbe16f9$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $lbE50(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $a48ba78c1cbe16f9$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $a48ba78c1cbe16f9$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $9zVnU();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $a48ba78c1cbe16f9$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $a48ba78c1cbe16f9$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $a48ba78c1cbe16f9$var$_objectSpread2["default"])((0, $a48ba78c1cbe16f9$var$_objectSpread2["default"])((0, $a48ba78c1cbe16f9$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $a48ba78c1cbe16f9$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $a48ba78c1cbe16f9$var$debugFunctions;
module.exports = $a48ba78c1cbe16f9$var$useRefetchableFragmentNode;

});
parcelRegister("fKGjT", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $b77bfabba1d33ce2$var$_interopRequireDefault = $dw9g1.default;

var $b77bfabba1d33ce2$var$_objectSpread2 = $b77bfabba1d33ce2$var$_interopRequireDefault((parcelRequire("RoT9E")));

var $b77bfabba1d33ce2$var$_createForOfIteratorHelper2 = $b77bfabba1d33ce2$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $8hU2S = parcelRequire("8hU2S");
var $b77bfabba1d33ce2$var$getQueryResourceForEnvironment = $8hU2S.getQueryResourceForEnvironment;

var $3rEVE = parcelRequire("3rEVE");

var $8iTFq = parcelRequire("8iTFq");
var $b77bfabba1d33ce2$var$fetchQueryInternal = $8iTFq.__internal.fetchQuery, $b77bfabba1d33ce2$var$RelayFeatureFlags = $8iTFq.RelayFeatureFlags, $b77bfabba1d33ce2$var$createOperationDescriptor = $8iTFq.createOperationDescriptor, $b77bfabba1d33ce2$var$getPendingOperationsForFragment = $8iTFq.getPendingOperationsForFragment, $b77bfabba1d33ce2$var$getSelector = $8iTFq.getSelector, $b77bfabba1d33ce2$var$getVariablesFromFragment = $8iTFq.getVariablesFromFragment, $b77bfabba1d33ce2$var$handlePotentialSnapshotErrors = $8iTFq.handlePotentialSnapshotErrors;
parcelRequire("l1Dol");
function $b77bfabba1d33ce2$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $b77bfabba1d33ce2$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $b77bfabba1d33ce2$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $b77bfabba1d33ce2$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $b77bfabba1d33ce2$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $b77bfabba1d33ce2$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator3 = (0, $b77bfabba1d33ce2$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step3.value;
                $b77bfabba1d33ce2$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $b77bfabba1d33ce2$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $b77bfabba1d33ce2$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $b77bfabba1d33ce2$var$_objectSpread2["default"])((0, $b77bfabba1d33ce2$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $b77bfabba1d33ce2$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $b77bfabba1d33ce2$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $b77bfabba1d33ce2$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $b77bfabba1d33ce2$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $b77bfabba1d33ce2$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $b77bfabba1d33ce2$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $3rEVE(false);
    else !!Array.isArray(fragmentRef) && $3rEVE(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $3rEVE(false);
    var state = $b77bfabba1d33ce2$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var missingClientEdges = $b77bfabba1d33ce2$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $b77bfabba1d33ce2$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($b77bfabba1d33ce2$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($b77bfabba1d33ce2$var$isMissingData(state)) {
        !(fragmentSelector != null) && $3rEVE(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $b77bfabba1d33ce2$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $b77bfabba1d33ce2$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($b77bfabba1d33ce2$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $b77bfabba1d33ce2$var$readFragmentInternal;

});

parcelRegister("dolRG", function(module, exports) {
'use strict';

var $dw9g1 = parcelRequire("dw9g1");
var $9bfe7a2c39cb1980$var$_interopRequireDefault = $dw9g1.default;

var $9bfe7a2c39cb1980$var$_createForOfIteratorHelper2 = $9bfe7a2c39cb1980$var$_interopRequireDefault((parcelRequire("9GBUH")));

var $4hYSN = parcelRequire("4hYSN");
var $9bfe7a2c39cb1980$var$loadQuery = $4hYSN.loadQuery, $9bfe7a2c39cb1980$var$useTrackLoadQueryInRender = $4hYSN.useTrackLoadQueryInRender;

var $9zVnU = parcelRequire("9zVnU");

var $5hzUs = parcelRequire("5hzUs");

var $8P7DW = parcelRequire("8P7DW");
var $9bfe7a2c39cb1980$var$useCallback = $8P7DW.useCallback, $9bfe7a2c39cb1980$var$useEffect = $8P7DW.useEffect, $9bfe7a2c39cb1980$var$useRef = $8P7DW.useRef, $9bfe7a2c39cb1980$var$useState = $8P7DW.useState;

var $8iTFq = parcelRequire("8iTFq");
var $9bfe7a2c39cb1980$var$getRequest = $8iTFq.getRequest;
var $9bfe7a2c39cb1980$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $9bfe7a2c39cb1980$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $9bfe7a2c39cb1980$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $9bfe7a2c39cb1980$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $9bfe7a2c39cb1980$var$initialNullQueryReferenceState;
    var environment = $5hzUs();
    $9bfe7a2c39cb1980$var$useTrackLoadQueryInRender();
    var isMountedRef = $9zVnU();
    var undisposedQueryReferencesRef = $9bfe7a2c39cb1980$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $9bfe7a2c39cb1980$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $9bfe7a2c39cb1980$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $9bfe7a2c39cb1980$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($9bfe7a2c39cb1980$var$initialNullQueryReferenceState);
            setQueryReference($9bfe7a2c39cb1980$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $9bfe7a2c39cb1980$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $9bfe7a2c39cb1980$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $9bfe7a2c39cb1980$var$useRef(false);
    $9bfe7a2c39cb1980$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $9bfe7a2c39cb1980$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $9bfe7a2c39cb1980$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($9bfe7a2c39cb1980$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $9bfe7a2c39cb1980$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $9bfe7a2c39cb1980$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($9bfe7a2c39cb1980$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $9bfe7a2c39cb1980$var$useQueryLoader;

});



parcelRegister("iQgMP", function(module, exports) {
'use strict';

var $4hYSN = parcelRequire("4hYSN");
var $db7a1ac4dad5027a$var$useTrackLoadQueryInRender = $4hYSN.useTrackLoadQueryInRender;

var $azc28 = parcelRequire("azc28");

var $8Nnai = parcelRequire("8Nnai");

var $5hzUs = parcelRequire("5hzUs");

var $3rEVE = parcelRequire("3rEVE");

var $8P7DW = parcelRequire("8P7DW");
var $db7a1ac4dad5027a$var$useDebugValue = $8P7DW.useDebugValue;

var $8iTFq = parcelRequire("8iTFq");
var $db7a1ac4dad5027a$var$_require3$__internal = $8iTFq.__internal, $db7a1ac4dad5027a$var$fetchQueryDeduped = $db7a1ac4dad5027a$var$_require3$__internal.fetchQueryDeduped, $db7a1ac4dad5027a$var$fetchQuery = $db7a1ac4dad5027a$var$_require3$__internal.fetchQuery;
parcelRequire("l1Dol");
function $db7a1ac4dad5027a$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    $db7a1ac4dad5027a$var$useTrackLoadQueryInRender();
    var environment = $5hzUs();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $8Nnai(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $3rEVE(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $db7a1ac4dad5027a$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $db7a1ac4dad5027a$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $azc28(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $db7a1ac4dad5027a$var$usePreloadedQuery;

});

parcelRegister("45oVL", function(module, exports) {
'use strict';

var $e7S3Q = parcelRequire("e7S3Q");

var $3LDx6 = parcelRequire("3LDx6");

var $8P7DW = parcelRequire("8P7DW");
var $2f9af7c18341a64d$var$useDebugValue = $8P7DW.useDebugValue;

var $8iTFq = parcelRequire("8iTFq");
var $2f9af7c18341a64d$var$getFragment = $8iTFq.getFragment;
function $2f9af7c18341a64d$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $2f9af7c18341a64d$var$getFragment(fragmentInput);
    $3LDx6(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $e7S3Q(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $2f9af7c18341a64d$var$useRefetchableFragment;

});

parcelRegister("83zse", function(module, exports) {
'use strict';

var $5hzUs = parcelRequire("5hzUs");

var $8P7DW = parcelRequire("8P7DW");
var $5dda1b061ea4de9b$var$useEffect = $8P7DW.useEffect, $5dda1b061ea4de9b$var$useRef = $8P7DW.useRef;
function $5dda1b061ea4de9b$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $5hzUs();
    var disposableRef = $5dda1b061ea4de9b$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $5dda1b061ea4de9b$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $5dda1b061ea4de9b$var$useSubscribeToInvalidationState;

});

parcelRegister("7aDcq", function(module, exports) {
'use strict';

var $5hzUs = parcelRequire("5hzUs");

var $8P7DW = parcelRequire("8P7DW");
var $5387dfc1d59087c7$var$useEffect = $8P7DW.useEffect;

var $8iTFq = parcelRequire("8iTFq");
var $5387dfc1d59087c7$var$requestSubscription = $8iTFq.requestSubscription;
function $5387dfc1d59087c7$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $5387dfc1d59087c7$var$requestSubscription;
    var environment = $5hzUs();
    $5387dfc1d59087c7$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $5387dfc1d59087c7$var$useSubscription;

});



parcelRegister("6Fjys", function(module, exports) {
$parcel$export(module.exports, "updateUserModelAction", () => (parcelRequire("8ICBx")).updateUserModelAction);
$parcel$export(module.exports, "UPDATE_USER_MODEL", () => (parcelRequire("8ICBx")).UPDATE_USER_MODEL);
$parcel$export(module.exports, "updateUserModelAnonymousAction", () => (parcelRequire("8ICBx")).updateUserModelAnonymousAction);
$parcel$export(module.exports, "UPDATE_USER_TO_ANON", () => (parcelRequire("8ICBx")).UPDATE_USER_TO_ANON);
$parcel$export(module.exports, "saveUserProfile", () => (parcelRequire("8ICBx")).saveUserProfile);
$parcel$export(module.exports, "SAVE_USER_PROFILE", () => (parcelRequire("8ICBx")).SAVE_USER_PROFILE);
$parcel$export(module.exports, "saveUserProfileFailure", () => (parcelRequire("8ICBx")).saveUserProfileFailure);
$parcel$export(module.exports, "SAVE_USER_PROFILE_FAILURE", () => (parcelRequire("8ICBx")).SAVE_USER_PROFILE_FAILURE);
$parcel$export(module.exports, "setUserProfileValidationErrors", () => (parcelRequire("8ICBx")).setUserProfileValidationErrors);
$parcel$export(module.exports, "SET_USER_PROFILE_VALIDATION_ERRORS", () => (parcelRequire("8ICBx")).SET_USER_PROFILE_VALIDATION_ERRORS);
$parcel$export(module.exports, "saveUserProfileSuccess", () => (parcelRequire("8ICBx")).saveUserProfileSuccess);
$parcel$export(module.exports, "SAVE_USER_PROFILE_SUCCESS", () => (parcelRequire("8ICBx")).SAVE_USER_PROFILE_SUCCESS);
$parcel$export(module.exports, "showChangePasswordDialog", () => (parcelRequire("8ICBx")).showChangePasswordDialog);
$parcel$export(module.exports, "SHOW_CHANGE_PASSWORD_DIALOG", () => (parcelRequire("8ICBx")).SHOW_CHANGE_PASSWORD_DIALOG);
$parcel$export(module.exports, "closeChangePasswordDialog", () => (parcelRequire("8ICBx")).closeChangePasswordDialog);
$parcel$export(module.exports, "CLOSE_CHANGE_PASSWORD_DIALOG", () => (parcelRequire("8ICBx")).CLOSE_CHANGE_PASSWORD_DIALOG);
$parcel$export(module.exports, "validateAndSavePasswordChange", () => (parcelRequire("8ICBx")).validateAndSavePasswordChange);
$parcel$export(module.exports, "validatePassword", () => (parcelRequire("8ICBx")).validatePassword);
$parcel$export(module.exports, "VALIDATE_PASSWORD", () => (parcelRequire("8ICBx")).VALIDATE_PASSWORD);
$parcel$export(module.exports, "validatePasswordSuccess", () => (parcelRequire("8ICBx")).validatePasswordSuccess);
$parcel$export(module.exports, "VALIDATE_PASSWORD_SUCCESS", () => (parcelRequire("8ICBx")).VALIDATE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "VALIDATE_AND_SAVE_PASSWORD_CHANGE", () => (parcelRequire("8ICBx")).VALIDATE_AND_SAVE_PASSWORD_CHANGE);
$parcel$export(module.exports, "changePassword", () => (parcelRequire("8ICBx")).changePassword);
$parcel$export(module.exports, "CHANGE_PASSWORD", () => (parcelRequire("8ICBx")).CHANGE_PASSWORD);
$parcel$export(module.exports, "changePasswordFailure", () => (parcelRequire("8ICBx")).changePasswordFailure);
$parcel$export(module.exports, "CHANGE_PASSWORD_FAILURE", () => (parcelRequire("8ICBx")).CHANGE_PASSWORD_FAILURE);
$parcel$export(module.exports, "CHANGE_PASSWORD_SUCCESS", () => (parcelRequire("8ICBx")).CHANGE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "successfullyLoggedIn", () => (parcelRequire("8ICBx")).successfullyLoggedIn);
$parcel$export(module.exports, "SUCCESSFULLY_LOGGED_IN", () => (parcelRequire("8ICBx")).SUCCESSFULLY_LOGGED_IN);
$parcel$export(module.exports, "UPDATE_USER_REQUESTS_COUNTS_MODEL", () => (parcelRequire("8ICBx")).UPDATE_USER_REQUESTS_COUNTS_MODEL);
$parcel$export(module.exports, "forgotPassword", () => (parcelRequire("8ICBx")).forgotPassword);
$parcel$export(module.exports, "forgotPasswordSuccess", () => (parcelRequire("8ICBx")).forgotPasswordSuccess);
$parcel$export(module.exports, "forgotPasswordFailure", () => (parcelRequire("8ICBx")).forgotPasswordFailure);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD", () => (parcelRequire("8ICBx")).USER_PROFILE_FORGOT_PASSWORD);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("8ICBx")).USER_PROFILE_FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_FAILURE", () => (parcelRequire("8ICBx")).USER_PROFILE_FORGOT_PASSWORD_FAILURE);

var $8ICBx = parcelRequire("8ICBx");

});
parcelRegister("8ICBx", function(module, exports) {
$parcel$export(module.exports, "UPDATE_USER_MODEL", () => $c9f7956e8b60ae89$export$bb738d1d47f9c080);
$parcel$export(module.exports, "UPDATE_USER_REQUESTS_COUNTS_MODEL", () => $c9f7956e8b60ae89$export$e2e5f617828e4213);
$parcel$export(module.exports, "UPDATE_USER_TO_ANON", () => $c9f7956e8b60ae89$export$b1b3790fd3dd41e);
$parcel$export(module.exports, "SAVE_USER_PROFILE", () => $c9f7956e8b60ae89$export$ed8e9a22a73d5238);
$parcel$export(module.exports, "SAVE_USER_PROFILE_SUCCESS", () => $c9f7956e8b60ae89$export$c705a7e05c58a85d);
$parcel$export(module.exports, "SAVE_USER_PROFILE_FAILURE", () => $c9f7956e8b60ae89$export$617cd283d6722784);
$parcel$export(module.exports, "SET_USER_PROFILE_VALIDATION_ERRORS", () => $c9f7956e8b60ae89$export$9e99a97090f99b20);
$parcel$export(module.exports, "SUCCESSFULLY_LOGGED_IN", () => $c9f7956e8b60ae89$export$dbaf6c31aeaab4c0);
$parcel$export(module.exports, "SHOW_CHANGE_PASSWORD_DIALOG", () => $c9f7956e8b60ae89$export$15f268d233a1a9e8);
$parcel$export(module.exports, "CLOSE_CHANGE_PASSWORD_DIALOG", () => $c9f7956e8b60ae89$export$5ea2388969a07735);
$parcel$export(module.exports, "VALIDATE_AND_SAVE_PASSWORD_CHANGE", () => $c9f7956e8b60ae89$export$d4203d6239c0a45f);
$parcel$export(module.exports, "VALIDATE_PASSWORD", () => $c9f7956e8b60ae89$export$2776cc46c0e74482);
$parcel$export(module.exports, "VALIDATE_PASSWORD_SUCCESS", () => $c9f7956e8b60ae89$export$87c02ba615b030f7);
$parcel$export(module.exports, "CHANGE_PASSWORD", () => $c9f7956e8b60ae89$export$67e8c4b0fd356271);
$parcel$export(module.exports, "CHANGE_PASSWORD_SUCCESS", () => $c9f7956e8b60ae89$export$52dd5c72d66642a1);
$parcel$export(module.exports, "CHANGE_PASSWORD_FAILURE", () => $c9f7956e8b60ae89$export$8095eb34b5a9bf48);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD", () => $c9f7956e8b60ae89$export$b03aac23a3b960e0);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_SUCCESS", () => $c9f7956e8b60ae89$export$fd1274b492be3442);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_FAILURE", () => $c9f7956e8b60ae89$export$228c8378e3cf38db);
$parcel$export(module.exports, "updateUserModelAction", () => $c9f7956e8b60ae89$export$e64d70be6597f269);
$parcel$export(module.exports, "updateUserRequestsCountsAction", () => $c9f7956e8b60ae89$export$8de1e14d714c3764);
$parcel$export(module.exports, "updateUserModelAnonymousAction", () => $c9f7956e8b60ae89$export$c79034a87b96133d);
$parcel$export(module.exports, "saveUserProfile", () => $c9f7956e8b60ae89$export$12b30392f405d671);
$parcel$export(module.exports, "saveUserProfileSuccess", () => $c9f7956e8b60ae89$export$7ded1c1b185ee372);
$parcel$export(module.exports, "saveUserProfileFailure", () => $c9f7956e8b60ae89$export$bb55fe7965c57a31);
$parcel$export(module.exports, "setUserProfileValidationErrors", () => $c9f7956e8b60ae89$export$f5417889851341ee);
$parcel$export(module.exports, "showChangePasswordDialog", () => $c9f7956e8b60ae89$export$b473bd12e6a9a566);
$parcel$export(module.exports, "closeChangePasswordDialog", () => $c9f7956e8b60ae89$export$1a2f283b7350e33f);
$parcel$export(module.exports, "validatePassword", () => $c9f7956e8b60ae89$export$4d2a7159fda5dc93);
$parcel$export(module.exports, "validateAndSavePasswordChange", () => $c9f7956e8b60ae89$export$3d37c4744747732c);
$parcel$export(module.exports, "changePassword", () => $c9f7956e8b60ae89$export$99d837dc30eb1ef7);
$parcel$export(module.exports, "validatePasswordSuccess", () => $c9f7956e8b60ae89$export$6c2ac98735d96a42);
$parcel$export(module.exports, "changePasswordFailure", () => $c9f7956e8b60ae89$export$a60289eb7ee45981);
$parcel$export(module.exports, "successfullyLoggedIn", () => $c9f7956e8b60ae89$export$ffc865c9cfe87560);
$parcel$export(module.exports, "forgotPassword", () => $c9f7956e8b60ae89$export$66791fb2cfeec3e);
$parcel$export(module.exports, "forgotPasswordSuccess", () => $c9f7956e8b60ae89$export$e65d2e9031cf7578);
$parcel$export(module.exports, "forgotPasswordFailure", () => $c9f7956e8b60ae89$export$c82fc620622643dd);
const $c9f7956e8b60ae89$export$bb738d1d47f9c080 = 'state.persisted.user.UPDATE_USER_MODEL';
const $c9f7956e8b60ae89$export$e2e5f617828e4213 = 'state.persisted.user.UPDATE_USER_REQUESTS_COUNTS_MODEL';
const $c9f7956e8b60ae89$export$b1b3790fd3dd41e = 'state.persisted.user.UPDATE_USER_TO_ANON';
const $c9f7956e8b60ae89$export$ed8e9a22a73d5238 = 'state.persisted.user.SAVE_USER_PROFILE';
const $c9f7956e8b60ae89$export$c705a7e05c58a85d = 'state.persisted.user.SAVE_USER_PROFILE_SUCCESS';
const $c9f7956e8b60ae89$export$617cd283d6722784 = 'state.persisted.user.SAVE_USER_PROFILE_FAILURE';
const $c9f7956e8b60ae89$export$9e99a97090f99b20 = 'state.persisted.user.SET_USER_PROFILE_VALIDATION_ERRORS';
const $c9f7956e8b60ae89$export$dbaf6c31aeaab4c0 = 'state.persisted.user.SUCCESSFULLY_LOGGED_IN';
const $c9f7956e8b60ae89$export$15f268d233a1a9e8 = 'state.ui.user.profile.SHOW_CHANGE_PASSWORD_DIALOG';
const $c9f7956e8b60ae89$export$5ea2388969a07735 = 'state.ui.user.profile.CLOSE_CHANGE_PASSWORD_DIALOG';
const $c9f7956e8b60ae89$export$d4203d6239c0a45f = 'state.persisted.user.VALIDATE_AND_SAVE_PASSWORD_CHANGE';
const $c9f7956e8b60ae89$export$2776cc46c0e74482 = 'state.persisted.user.VALIDATE_PASSWORD';
const $c9f7956e8b60ae89$export$87c02ba615b030f7 = 'state.persisted.user.VALIDATE_PASSWORD_SUCCESS';
const $c9f7956e8b60ae89$export$67e8c4b0fd356271 = 'state.persisted.user.CHANGE_PASSWORD';
const $c9f7956e8b60ae89$export$52dd5c72d66642a1 = 'state.persisted.user.CHANGE_PASSWORD_SUCCESS';
const $c9f7956e8b60ae89$export$8095eb34b5a9bf48 = 'state.persisted.user.CHANGE_PASSWORD_FAILURE';
const $c9f7956e8b60ae89$export$b03aac23a3b960e0 = 'state.ui.user.profile.FORGOT_PASSWORD';
const $c9f7956e8b60ae89$export$fd1274b492be3442 = 'state.ui.user.profile.FORGOT_PASSWORD_SUCCESS';
const $c9f7956e8b60ae89$export$228c8378e3cf38db = 'state.ui.user.profile.FORGOT_PASSWORD_FAILURE';
const $c9f7956e8b60ae89$export$e64d70be6597f269 = (userResponse)=>({
        payload: userResponse,
        type: $c9f7956e8b60ae89$export$bb738d1d47f9c080
    });
const $c9f7956e8b60ae89$export$8de1e14d714c3764 = (userRequestsCountsResponse)=>({
        payload: userRequestsCountsResponse,
        type: $c9f7956e8b60ae89$export$e2e5f617828e4213
    });
const $c9f7956e8b60ae89$export$c79034a87b96133d = ()=>({
        type: $c9f7956e8b60ae89$export$b1b3790fd3dd41e
    });
const $c9f7956e8b60ae89$export$12b30392f405d671 = (displayName, language, timezone)=>({
        payload: {
            displayName: displayName,
            language: language,
            timezone: timezone
        },
        type: $c9f7956e8b60ae89$export$ed8e9a22a73d5238
    });
const $c9f7956e8b60ae89$export$7ded1c1b185ee372 = (displayName, language, timezone)=>({
        payload: {
            displayName: displayName,
            language: language,
            timezone: timezone
        },
        type: $c9f7956e8b60ae89$export$c705a7e05c58a85d
    });
const $c9f7956e8b60ae89$export$bb55fe7965c57a31 = ()=>({
        type: $c9f7956e8b60ae89$export$617cd283d6722784
    });
const $c9f7956e8b60ae89$export$f5417889851341ee = (nameError, timezoneError)=>({
        payload: {
            nameError: nameError,
            timezoneError: timezoneError
        },
        type: $c9f7956e8b60ae89$export$9e99a97090f99b20
    });
const $c9f7956e8b60ae89$export$b473bd12e6a9a566 = ()=>({
        type: $c9f7956e8b60ae89$export$15f268d233a1a9e8
    });
const $c9f7956e8b60ae89$export$1a2f283b7350e33f = ()=>({
        type: $c9f7956e8b60ae89$export$5ea2388969a07735
    });
const $c9f7956e8b60ae89$export$4d2a7159fda5dc93 = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $c9f7956e8b60ae89$export$2776cc46c0e74482
    });
const $c9f7956e8b60ae89$export$3d37c4744747732c = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $c9f7956e8b60ae89$export$d4203d6239c0a45f
    });
const $c9f7956e8b60ae89$export$99d837dc30eb1ef7 = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $c9f7956e8b60ae89$export$67e8c4b0fd356271
    });
const $c9f7956e8b60ae89$export$6c2ac98735d96a42 = ()=>({
        type: $c9f7956e8b60ae89$export$87c02ba615b030f7
    });
const $c9f7956e8b60ae89$export$592a066e988f52df = ()=>({
        type: $c9f7956e8b60ae89$export$52dd5c72d66642a1
    });
const $c9f7956e8b60ae89$export$a60289eb7ee45981 = (currentPasswordError, newPasswordError, confirmPasswordError, generalError)=>({
        payload: {
            currentPasswordError: currentPasswordError,
            newPasswordError: newPasswordError,
            confirmPasswordError: confirmPasswordError,
            generalError: generalError
        },
        type: $c9f7956e8b60ae89$export$8095eb34b5a9bf48
    });
const $c9f7956e8b60ae89$export$ffc865c9cfe87560 = ()=>{
    return {
        type: $c9f7956e8b60ae89$export$dbaf6c31aeaab4c0
    };
};
const $c9f7956e8b60ae89$export$66791fb2cfeec3e = (resetUrl, email, createAnalyticsEvent)=>({
        type: $c9f7956e8b60ae89$export$b03aac23a3b960e0,
        payload: {
            resetUrl: resetUrl,
            email: email,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $c9f7956e8b60ae89$export$e65d2e9031cf7578 = ()=>({
        type: $c9f7956e8b60ae89$export$fd1274b492be3442
    });
const $c9f7956e8b60ae89$export$c82fc620622643dd = ()=>({
        type: $c9f7956e8b60ae89$export$228c8378e3cf38db
    });

});


parcelRegister("cz1oy", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f1eaefb1434b90b$export$2e2bcd8739ae039);
parcelRequire("haxwJ");
var $5YU7f = parcelRequire("5YU7f");
var $02gNN = parcelRequire("02gNN");
var $hxVai = parcelRequire("hxVai");
var $14lC8 = parcelRequire("14lC8");
parcelRequire("durY1");
var $4l1s1 = parcelRequire("4l1s1");

var $lTxXN = parcelRequire("lTxXN");

var $WIQuk = parcelRequire("WIQuk");

var $9Epbp = parcelRequire("9Epbp");

var $bGZ6O = parcelRequire("bGZ6O");
const $2f1eaefb1434b90b$var$createReducer = (asyncPersistedReducers, asyncUIReducers)=>{
    const persisted = (0, $WIQuk.getCombinedPersistedReducer)(asyncPersistedReducers);
    const ui = (0, $bGZ6O.getCombinedUIReducer)(asyncUIReducers);
    return (0, $02gNN.default)({
        persisted: persisted,
        ui: ui
    });
};
/**
 * Sometimes we want to run storybooks as standalone apps so we can embed them. In that case they
 * behave a little differently to when they are embedded inside the Storybook application frame.
 * This checks a query parameter to make sure we don't run into CORS issues.
 *
 * @returns True if we're in a storybook and it's being embedded outside the usual storybook frame.
 */ const $2f1eaefb1434b90b$var$isStandaloneStory = ()=>{
    const params = new URLSearchParams(window.location.search);
    return (params.get('singleStory') || params.get('singlestory')) === 'true';
};
function $2f1eaefb1434b90b$export$2e2bcd8739ae039({ initialState: initialState, middleware: middleware = [], initializeEpics: initializeEpics = true } = {}) {
    // Enables redux for storybook
    // trueWindow will hold the value of the window in which portal is loaded
    let trueWindow;
    // if portal is loaded inside an iframe, window.self will not be equal to window.top
    if ($2f1eaefb1434b90b$var$isStandaloneStory() || window.self !== window.top) trueWindow = window.self || window;
    else trueWindow = window.parent || window;
    const composeEnhancers = trueWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $hxVai.default);
    const epicMiddlewares = initializeEpics ? [
        (0, $4l1s1.createEpicMiddleware)((0, $lTxXN.default))
    ] : [];
    const store = (0, $14lC8.default)((0, $9Epbp.default), initialState || {}, composeEnhancers((0, $5YU7f.default)(...epicMiddlewares, ...middleware)));
    let asyncPersistedReducers = {};
    let asyncUIReducers = {};
    const injectReducer = (storeType, key, asyncReducer)=>{
        if (storeType === 'ui') asyncUIReducers = {
            ...asyncUIReducers,
            [key]: asyncReducer
        };
        if (storeType === 'persisted') asyncPersistedReducers = {
            ...asyncPersistedReducers,
            [key]: asyncReducer
        };
        store.replaceReducer($2f1eaefb1434b90b$var$createReducer(asyncPersistedReducers, asyncUIReducers));
    };
    return {
        store: store,
        injectReducer: injectReducer
    };
}

});
parcelRegister("durY1", function(module, exports) {
$parcel$export(module.exports, "createEpicMiddleware", () => (parcelRequire("4l1s1")).createEpicMiddleware);
$parcel$export(module.exports, "combineEpics", () => (parcelRequire("fPmNS")).combineEpics);

var $4l1s1 = parcelRequire("4l1s1");

var $dOxOE = parcelRequire("dOxOE");

var $fPmNS = parcelRequire("fPmNS");

var $3wk87 = parcelRequire("3wk87");

var $g4hqP = parcelRequire("g4hqP");

});
parcelRegister("4l1s1", function(module, exports) {
$parcel$export(module.exports, "createEpicMiddleware", () => $328a3fb264dec514$export$147cf6f7ce5462cb);

var $bTlA1 = parcelRequire("bTlA1");

var $d6SrZ = parcelRequire("d6SrZ");

var $5Nymb = parcelRequire("5Nymb");

var $dOxOE = parcelRequire("dOxOE");

var $3wk87 = parcelRequire("3wk87");
var $328a3fb264dec514$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $328a3fb264dec514$var$defaultAdapter = {
    input: function input(action$) {
        return action$;
    },
    output: function output(action$) {
        return action$;
    }
};
var $328a3fb264dec514$var$defaultOptions = {
    adapter: $328a3fb264dec514$var$defaultAdapter
};
function $328a3fb264dec514$export$147cf6f7ce5462cb(rootEpic) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $328a3fb264dec514$var$defaultOptions;
    if (typeof rootEpic !== 'function') throw new TypeError('You must provide a root Epic to createEpicMiddleware');
    // even though we used default param, we need to merge the defaults
    // inside the options object as well in case they declare only some
    options = $328a3fb264dec514$var$_extends({}, $328a3fb264dec514$var$defaultOptions, options);
    var input$ = new (0, $bTlA1.Subject)();
    var action$ = options.adapter.input(new (0, $dOxOE.ActionsObservable)(input$));
    var epic$ = new (0, $bTlA1.Subject)();
    var store = void 0;
    var epicMiddleware = function epicMiddleware(_store) {
        store = _store;
        return function(next) {
            var _context;
            (_context = (0, $d6SrZ.map).call(epic$, function(epic) {
                var vault = store;
                var output$ = 'dependencies' in options ? epic(action$, vault, options.dependencies) : epic(action$, vault);
                if (!output$) throw new TypeError('Your root Epic "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
                return output$;
            }), $5Nymb.switchMap).call(_context, function(output$) {
                return options.adapter.output(output$);
            }).subscribe(store.dispatch);
            // Setup initial root epic
            epic$.next(rootEpic);
            return function(action) {
                var result = next(action);
                input$.next(action);
                return result;
            };
        };
    };
    epicMiddleware.replaceEpic = function(rootEpic) {
        // gives the previous root Epic a last chance
        // to do some clean up
        store.dispatch({
            type: (0, $3wk87.EPIC_END)
        });
        // switches to the new root Epic, synchronously terminating
        // the previous one
        epic$.next(rootEpic);
    };
    return epicMiddleware;
}

});
parcelRegister("d6SrZ", function(module, exports) {
$parcel$export(module.exports, "map", () => $98b6129c37c3973a$export$871de8747c9eaa88, (v) => $98b6129c37c3973a$export$871de8747c9eaa88 = v);
var $98b6129c37c3973a$export$871de8747c9eaa88;
"use strict";

var $a8ocL = parcelRequire("a8ocL");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $98b6129c37c3973a$var$map(project, thisArg) {
    return $a8ocL.map(project, thisArg)(this);
}
$98b6129c37c3973a$export$871de8747c9eaa88 = $98b6129c37c3973a$var$map;

});

parcelRegister("5Nymb", function(module, exports) {
$parcel$export(module.exports, "switchMap", () => $438c2de7ed577430$export$9f6ea8e48bc26eab, (v) => $438c2de7ed577430$export$9f6ea8e48bc26eab = v);
var $438c2de7ed577430$export$9f6ea8e48bc26eab;
"use strict";

var $aE20L = parcelRequire("aE20L");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $438c2de7ed577430$var$switchMap(project, resultSelector) {
    return $aE20L.switchMap(project, resultSelector)(this);
}
$438c2de7ed577430$export$9f6ea8e48bc26eab = $438c2de7ed577430$var$switchMap;

});
parcelRegister("aE20L", function(module, exports) {
"use strict";
var $7bff333c63763a72$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $7bff333c63763a72$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $7bff333c63763a72$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $7bff333c63763a72$var$switchMap;
var $7bff333c63763a72$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7bff333c63763a72$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7bff333c63763a72$var$SwitchMapSubscriber = function(_super) {
    $7bff333c63763a72$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $2Q6Ms.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($9u1V0.OuterSubscriber);

});


parcelRegister("dOxOE", function(module, exports) {
$parcel$export(module.exports, "ActionsObservable", () => $a0ea2d03f2777e51$export$fa75b7f5c32db4e9);

var $fSYYZ = parcelRequire("fSYYZ");

var $fyy56 = parcelRequire("fyy56");

var $dwdYm = parcelRequire("dwdYm");

var $g4hqP = parcelRequire("g4hqP");
var $a0ea2d03f2777e51$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $a0ea2d03f2777e51$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0ea2d03f2777e51$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a0ea2d03f2777e51$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a0ea2d03f2777e51$export$fa75b7f5c32db4e9 = function(_Observable) {
    $a0ea2d03f2777e51$var$_inherits(ActionsObservable, _Observable);
    $a0ea2d03f2777e51$var$_createClass(ActionsObservable, null, [
        {
            key: 'of',
            value: function of() {
                return new this((0, $fyy56.of).apply(undefined, arguments));
            }
        },
        {
            key: 'from',
            value: function from(actions, scheduler) {
                return new this((0, $dwdYm.from)(actions, scheduler));
            }
        }
    ]);
    function ActionsObservable(actionsSubject) {
        $a0ea2d03f2777e51$var$_classCallCheck(this, ActionsObservable);
        var _this = $a0ea2d03f2777e51$var$_possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        _this.source = actionsSubject;
        return _this;
    }
    $a0ea2d03f2777e51$var$_createClass(ActionsObservable, [
        {
            key: 'lift',
            value: function lift(operator) {
                var observable = new ActionsObservable(this);
                observable.operator = operator;
                return observable;
            }
        },
        {
            key: 'ofType',
            value: function ofType() {
                return (0, $g4hqP.ofType).apply(undefined, arguments)(this);
            }
        }
    ]);
    return ActionsObservable;
}((0, $fSYYZ.Observable));

});
parcelRegister("fyy56", function(module, exports) {
$parcel$export(module.exports, "of", () => $b53477d313c71d60$export$ba255e9e49e00608, (v) => $b53477d313c71d60$export$ba255e9e49e00608 = v);
var $b53477d313c71d60$export$ba255e9e49e00608;
"use strict";

var $iLZ0l = parcelRequire("iLZ0l");
$b53477d313c71d60$export$ba255e9e49e00608 = $iLZ0l.ArrayObservable.of;

});

parcelRegister("g4hqP", function(module, exports) {
$parcel$export(module.exports, "ofType", () => $bb2a8a9dfca237e3$export$5db8774c0df95fce);

var $lN4a0 = parcelRequire("lN4a0");
var $bb2a8a9dfca237e3$var$keyHasType = function keyHasType(type, key) {
    return type === key || typeof key === 'function' && type === key.toString();
};
function $bb2a8a9dfca237e3$export$5db8774c0df95fce() {
    for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
    return function ofTypeOperatorFunction(source) {
        return (0, $lN4a0.filter).call(source, function(_ref) {
            var type = _ref.type;
            var len = keys.length;
            if (len === 1) return $bb2a8a9dfca237e3$var$keyHasType(type, keys[0]);
            else for(var i = 0; i < len; i++){
                if ($bb2a8a9dfca237e3$var$keyHasType(type, keys[i])) return true;
            }
            return false;
        });
    };
}

});
parcelRegister("lN4a0", function(module, exports) {
$parcel$export(module.exports, "filter", () => $fdd166c1afe3f986$export$3dea766d36a8935f, (v) => $fdd166c1afe3f986$export$3dea766d36a8935f = v);
var $fdd166c1afe3f986$export$3dea766d36a8935f;
"use strict";

var $6gAgO = parcelRequire("6gAgO");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $fdd166c1afe3f986$var$filter(predicate, thisArg) {
    return $6gAgO.filter(predicate, thisArg)(this);
}
$fdd166c1afe3f986$export$3dea766d36a8935f = $fdd166c1afe3f986$var$filter;

});
parcelRegister("6gAgO", function(module, exports) {
"use strict";
var $49005f3986060574$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $49005f3986060574$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $49005f3986060574$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $49005f3986060574$var$filter;
var $49005f3986060574$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $49005f3986060574$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $49005f3986060574$var$FilterSubscriber = function(_super) {
    $49005f3986060574$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($8qR8S.Subscriber);

});




parcelRegister("3wk87", function(module, exports) {
$parcel$export(module.exports, "EPIC_END", () => $2903f99fff2e63c5$export$b74d5afcca2d016c);
var $2903f99fff2e63c5$export$b74d5afcca2d016c = '@@redux-observable/EPIC_END';

});


parcelRegister("fPmNS", function(module, exports) {
$parcel$export(module.exports, "combineEpics", () => $b85d4eb57f067a0f$export$6259fe981e4a41dc);

var $5S14C = parcelRequire("5S14C");
function $b85d4eb57f067a0f$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $b85d4eb57f067a0f$export$6259fe981e4a41dc = function combineEpics() {
    for(var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++)epics[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return (0, $5S14C.merge).apply(undefined, $b85d4eb57f067a0f$var$_toConsumableArray(epics.map(function(epic) {
            var output$ = epic.apply(undefined, args);
            if (!output$) throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
            return output$;
        })));
    };
};

});
parcelRegister("5S14C", function(module, exports) {
$parcel$export(module.exports, "merge", () => $4462d4175b9e5086$export$4950aa0f605343fb, (v) => $4462d4175b9e5086$export$4950aa0f605343fb = v);
var $4462d4175b9e5086$export$4950aa0f605343fb;
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $iLZ0l = parcelRequire("iLZ0l");

var $bOxHY = parcelRequire("bOxHY");

var $44a5l = parcelRequire("44a5l");
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $4462d4175b9e5086$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($bOxHY.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $fSYYZ.Observable) return observables[0];
    return $44a5l.mergeAll(concurrent)(new $iLZ0l.ArrayObservable(observables, scheduler));
}
$4462d4175b9e5086$export$4950aa0f605343fb = $4462d4175b9e5086$var$merge;

});
parcelRegister("44a5l", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $2f5f5bd855b59409$export$18aef43295bbe906, (v) => $2f5f5bd855b59409$export$18aef43295bbe906 = v);
var $2f5f5bd855b59409$export$18aef43295bbe906;
"use strict";

var $5iPTs = parcelRequire("5iPTs");

var $7tpsL = parcelRequire("7tpsL");
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $2f5f5bd855b59409$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $5iPTs.mergeMap($7tpsL.identity, null, concurrent);
}
$2f5f5bd855b59409$export$18aef43295bbe906 = $2f5f5bd855b59409$var$mergeAll;

});
parcelRegister("7tpsL", function(module, exports) {
$parcel$export(module.exports, "identity", () => $570efe419a5aa8f4$export$f0954fd7d5368655, (v) => $570efe419a5aa8f4$export$f0954fd7d5368655 = v);
var $570efe419a5aa8f4$export$f0954fd7d5368655;
"use strict";
function $570efe419a5aa8f4$var$identity(x) {
    return x;
}
$570efe419a5aa8f4$export$f0954fd7d5368655 = $570efe419a5aa8f4$var$identity;

});





parcelRegister("lTxXN", function(module, exports) {
$parcel$export(module.exports, "epic$", () => $e50ce491c459dad8$export$5eda8fe942b06fa7);
$parcel$export(module.exports, "default", () => $e50ce491c459dad8$export$2e2bcd8739ae039);
parcelRequire("durY1");
var $fPmNS = parcelRequire("fPmNS");

var $bhOdO = parcelRequire("bhOdO");

var $3PjqI = parcelRequire("3PjqI");

var $id21D = parcelRequire("id21D");

var $20NcP = parcelRequire("20NcP");

var $4TajJ = parcelRequire("4TajJ");

var $3sdOx = parcelRequire("3sdOx");

var $5pHTi = parcelRequire("5pHTi");

var $hehn5 = parcelRequire("hehn5");

var $arBRl = parcelRequire("arBRl");

var $9WGLz = parcelRequire("9WGLz");

var $QNd0j = parcelRequire("QNd0j");
var $hIQoN = parcelRequire("hIQoN");
var $89KLv = parcelRequire("89KLv");
var $2zcfw = parcelRequire("2zcfw");
var $bsMZz = parcelRequire("bsMZz");

var $4IszM = parcelRequire("4IszM");

var $d7Bhl = parcelRequire("d7Bhl");

var $cUiSx = parcelRequire("cUiSx");

var $gFQz2 = parcelRequire("gFQz2");

var $7hmkV = parcelRequire("7hmkV");

var $hd3jj = parcelRequire("hd3jj");
var $9JgMX = parcelRequire("9JgMX");
var $4mrSX = parcelRequire("4mrSX");
var $5c7tt = parcelRequire("5c7tt");
var $c2YsM = parcelRequire("c2YsM");
var $ejLoz = parcelRequire("ejLoz");
var $2XNFs = parcelRequire("2XNFs");
var $9Z0Uy = parcelRequire("9Z0Uy");

var $lCiks = parcelRequire("lCiks");

var $k4Ps4 = parcelRequire("k4Ps4");
var $aXxPo = parcelRequire("aXxPo");
var $38VXc = parcelRequire("38VXc");
var $jGbgC = parcelRequire("jGbgC");
var $7T5tP = parcelRequire("7T5tP");

var $dXTIL = parcelRequire("dXTIL");

var $cqrFQ = parcelRequire("cqrFQ");

var $erSSa = parcelRequire("erSSa");

var $3K5ah = parcelRequire("3K5ah");

var $fw9vu = parcelRequire("fw9vu");

var $5HqNJ = parcelRequire("5HqNJ");
const $e50ce491c459dad8$export$678ceb4a4ee87d76 = [
    (0, $gFQz2.default),
    (0, $erSSa.default),
    (0, $cUiSx.logOutEpic),
    (0, $4TajJ.default),
    (0, $lCiks.requestGroupsEpic),
    (0, $aXxPo.createGroupWithRequestTypeEpic),
    (0, $k4Ps4.addRequestTypeToRequestGroupEpic),
    (0, $38VXc.deleteRequestTypeFromGroupEpic),
    (0, $7T5tP.setRequestTypeGroupsEpic),
    (0, $jGbgC.reorderRequestTypeEpic),
    (0, $hd3jj.changeRequestSubscriptionEpic),
    (0, $9JgMX.createCommentEpic),
    (0, $4mrSX.decideApprovalEpic),
    (0, $c2YsM.removeOrganisationEpic),
    (0, $ejLoz.removeParticipantEpic),
    (0, $2XNFs.shareRequestEpic),
    (0, $9Z0Uy.transitionRequestEpic),
    (0, $5c7tt.getMediaReadCredentialsEpic),
    (0, $5pHTi.handleAjaxErrorEpic),
    (0, $3K5ah.resendValidationEmailEpic),
    (0, $fw9vu.validateAndSavePasswordChangeEpic),
    (0, $fw9vu.validateEpic),
    (0, $fw9vu.changePasswordEpic),
    (0, $fw9vu.updateUserProfileEpic),
    (0, $QNd0j.checkLoginActionEpic),
    (0, $2zcfw.forgotPasswordEpic),
    (0, $hIQoN.createPasswordEpic),
    (0, $bsMZz.loginEpic),
    (0, $arBRl.invitedSignUpEpic),
    (0, $id21D.completeSignupEpic),
    (0, $id21D.sendNewSignupLinkEpic),
    (0, $hehn5.updateHelpCenterBrandingEpic),
    (0, $hehn5.updateHelpCenterBrandingEpicMutationSuccess),
    (0, $hehn5.updateHelpCenterBrandingEpicMutationFailure),
    (0, $cqrFQ.resetPasswordEpic),
    (0, $4IszM.updateLoginAnnouncementsEpic),
    (0, $7hmkV.updatePortalAnnouncementsEpic),
    (0, $5HqNJ.forgotPasswordEpic),
    (0, $89KLv.exitTestModeEpic),
    (0, $dXTIL.resendVerifyEmailEpic),
    (0, $d7Bhl.loginConsentEpic),
    (0, $20NcP.fetchCrossSiteArticleEpic),
    (0, $3sdOx.fetchSpaceKeyEpic),
    (0, $9WGLz.fetchLinkedSpacesEpic)
];
const $e50ce491c459dad8$var$staticEpics = (0, $fPmNS.combineEpics)(...$e50ce491c459dad8$export$678ceb4a4ee87d76);
const $e50ce491c459dad8$export$5eda8fe942b06fa7 = new (0, $bhOdO.BehaviorSubject)($e50ce491c459dad8$var$staticEpics);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e50ce491c459dad8$var$combinedEpic = (action$, store$, deps)=>$e50ce491c459dad8$export$5eda8fe942b06fa7.pipe((0, $3PjqI.mergeMap)((epic)=>epic(action$, store$, deps)));
var $e50ce491c459dad8$export$2e2bcd8739ae039 = $e50ce491c459dad8$var$combinedEpic;

});
parcelRegister("bhOdO", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $83783d3841f6be99$export$77cea355fa80b5f4, (v) => $83783d3841f6be99$export$77cea355fa80b5f4 = v);
$parcel$export(module.exports, "Subscription", () => $83783d3841f6be99$export$f55210826850c514, (v) => $83783d3841f6be99$export$f55210826850c514 = v);
$parcel$export(module.exports, "BehaviorSubject", () => $83783d3841f6be99$export$cc3d42e6b2b9cf8b, (v) => $83783d3841f6be99$export$cc3d42e6b2b9cf8b = v);
$parcel$export(module.exports, "AjaxError", () => $83783d3841f6be99$export$9b8f4d0b97ba3d22, (v) => $83783d3841f6be99$export$9b8f4d0b97ba3d22 = v);
$parcel$export(module.exports, "Scheduler", () => $83783d3841f6be99$export$d3e54bb8584cda7c, (v) => $83783d3841f6be99$export$d3e54bb8584cda7c = v);
var $83783d3841f6be99$export$b6bbab5a9b109038;
var $83783d3841f6be99$export$155189cde295587d;
var $83783d3841f6be99$export$77cea355fa80b5f4;
var $83783d3841f6be99$export$f55210826850c514;
var $83783d3841f6be99$export$60959659b2c22881;
var $83783d3841f6be99$export$fe960da701faae26;
var $83783d3841f6be99$export$915d2682b0aa0991;
var $83783d3841f6be99$export$cc3d42e6b2b9cf8b;
var $83783d3841f6be99$export$9038dea0172d3ba9;
var $83783d3841f6be99$export$14834abbfce3b8cd;
var $83783d3841f6be99$export$78f6d1b1dbcda304;
var $83783d3841f6be99$export$630691c4a0cd4093;
var $83783d3841f6be99$export$f708eee25634bc80;
var $83783d3841f6be99$export$66d311bf29d5c89c;
var $83783d3841f6be99$export$c9648b76fd580c34;
var $83783d3841f6be99$export$8bb95198b45adaac;
var $83783d3841f6be99$export$d9bcbd5e1ff81430;
var $83783d3841f6be99$export$62927158df9c43dd;
var $83783d3841f6be99$export$789cef2613b1402;
var $83783d3841f6be99$export$ae07db09d6fbd01b;
var $83783d3841f6be99$export$9b8f4d0b97ba3d22;
var $83783d3841f6be99$export$fcf72a1ab36e1e65;
var $83783d3841f6be99$export$a4627e546088548d;
var $83783d3841f6be99$export$ccbce4efa7f8029b;
var $83783d3841f6be99$export$d3e54bb8584cda7c;
var $83783d3841f6be99$export$3e25e887b7a5b37b;
"use strict";

var $bTlA1 = parcelRequire("bTlA1");
$83783d3841f6be99$export$b6bbab5a9b109038 = $bTlA1.Subject;
$83783d3841f6be99$export$155189cde295587d = $bTlA1.AnonymousSubject;

var $fSYYZ = parcelRequire("fSYYZ");
$83783d3841f6be99$export$77cea355fa80b5f4 = $fSYYZ.Observable;
parcelRequire("iUyah");
parcelRequire("2RhXy");
parcelRequire("aJ1y8");
parcelRequire("aY7Ho");
parcelRequire("eaJVW");
parcelRequire("b0u6a");
parcelRequire("d7Oz5");
parcelRequire("ok1hF");
parcelRequire("2kHqX");
parcelRequire("89gk9");
parcelRequire("a3iWS");
parcelRequire("kVOut");
parcelRequire("f31N5");
parcelRequire("8vquY");
parcelRequire("ea502");
parcelRequire("cPUQ4");
parcelRequire("6wtQK");
parcelRequire("jw3ro");
parcelRequire("5Iorn");
parcelRequire("aJoZJ");
parcelRequire("I6fgQ");
parcelRequire("cGEPL");
parcelRequire("4Ckx2");
parcelRequire("5kaVk");
parcelRequire("19zxt");
parcelRequire("1K6IC");
parcelRequire("awnCy");
parcelRequire("h6DNT");
parcelRequire("7unGx");
parcelRequire("7VEUR");
parcelRequire("hZdSJ");
parcelRequire("4aEZK");
parcelRequire("eGN1M");
parcelRequire("9sfh1");
parcelRequire("bnzpL");
parcelRequire("atLdb");
parcelRequire("krlKV");
parcelRequire("7OsES");
parcelRequire("cAqrV");
parcelRequire("80uDu");
parcelRequire("4bhYG");
parcelRequire("kFeFV");
parcelRequire("1S12b");
parcelRequire("9TWxp");
parcelRequire("kYxIu");
parcelRequire("iu70Q");
parcelRequire("ho0n1");
parcelRequire("cW5tW");
parcelRequire("jTiXh");
parcelRequire("cc5mX");
parcelRequire("3GwHk");
parcelRequire("7KYcz");
parcelRequire("ffqk3");
parcelRequire("eUkxr");
parcelRequire("bBFFm");
parcelRequire("kLrVY");
parcelRequire("6bTwL");
parcelRequire("2AXfq");
parcelRequire("iwUFB");
parcelRequire("3MI4L");
parcelRequire("9CTIf");
parcelRequire("1Lchw");
parcelRequire("7stYY");
parcelRequire("a5gmV");
parcelRequire("iiJom");
parcelRequire("eSAVQ");
parcelRequire("5aati");
parcelRequire("1dAP5");
parcelRequire("eJymB");
parcelRequire("1FiQt");
parcelRequire("j1S14");
parcelRequire("aYRT6");
parcelRequire("gKh21");
parcelRequire("39D21");
parcelRequire("5YCSX");
parcelRequire("4LtqF");
parcelRequire("grW3p");
parcelRequire("ejY3t");
parcelRequire("7F53D");
parcelRequire("lWjiv");
parcelRequire("cq5G1");
parcelRequire("6WY02");
parcelRequire("2LLLC");
parcelRequire("fpBmy");
parcelRequire("slMhX");
parcelRequire("jWkIz");
parcelRequire("4eGeb");
parcelRequire("gz9r1");
parcelRequire("619O0");
parcelRequire("fkuNu");
parcelRequire("jNH9H");
parcelRequire("4P4PG");
parcelRequire("9ah3j");
parcelRequire("1Qzd1");
parcelRequire("l91U6");
parcelRequire("6Rwnw");
parcelRequire("ejt2r");
parcelRequire("37wBt");
parcelRequire("d0r0I");
parcelRequire("kT6Jb");
parcelRequire("essAN");
parcelRequire("1IH9O");
parcelRequire("5DO4t");
parcelRequire("ihsE6");
parcelRequire("2iNoG");
parcelRequire("ftnPc");
parcelRequire("aLeMa");
parcelRequire("67dsu");
parcelRequire("7PQNG");
parcelRequire("3HCxQ");
parcelRequire("lFgjx");
parcelRequire("dhUM1");
parcelRequire("jK7uq");
parcelRequire("6tmYF");
parcelRequire("1HNnq");
parcelRequire("33t0w");
parcelRequire("qmSA3");
parcelRequire("3vHQZ");
parcelRequire("gjHCM");
parcelRequire("5who5");
parcelRequire("gZSQK");
parcelRequire("gLr0q");
parcelRequire("8Ijk8");
parcelRequire("gTWzI");
parcelRequire("39wDQ");
parcelRequire("tnrSr");
parcelRequire("6UIxa");
parcelRequire("b0vRQ");
parcelRequire("9pehG");

var $aBkDT = parcelRequire("aBkDT");
$83783d3841f6be99$export$f55210826850c514 = $aBkDT.Subscription;

var $8qR8S = parcelRequire("8qR8S");
$83783d3841f6be99$export$60959659b2c22881 = $8qR8S.Subscriber;

var $16pOr = parcelRequire("16pOr");
$83783d3841f6be99$export$fe960da701faae26 = $16pOr.AsyncSubject;

var $1PAG0 = parcelRequire("1PAG0");
$83783d3841f6be99$export$915d2682b0aa0991 = $1PAG0.ReplaySubject;

var $5YUlS = parcelRequire("5YUlS");
$83783d3841f6be99$export$cc3d42e6b2b9cf8b = $5YUlS.BehaviorSubject;

var $4mMLC = parcelRequire("4mMLC");
$83783d3841f6be99$export$9038dea0172d3ba9 = $4mMLC.ConnectableObservable;

var $hGDIR = parcelRequire("hGDIR");
$83783d3841f6be99$export$14834abbfce3b8cd = $hGDIR.Notification;

var $jUTRE = parcelRequire("jUTRE");
$83783d3841f6be99$export$78f6d1b1dbcda304 = $jUTRE.EmptyError;

var $9JK9X = parcelRequire("9JK9X");
$83783d3841f6be99$export$630691c4a0cd4093 = $9JK9X.ArgumentOutOfRangeError;

var $eDWrK = parcelRequire("eDWrK");
$83783d3841f6be99$export$f708eee25634bc80 = $eDWrK.ObjectUnsubscribedError;

var $xjW0u = parcelRequire("xjW0u");
$83783d3841f6be99$export$66d311bf29d5c89c = $xjW0u.TimeoutError;

var $3cVZM = parcelRequire("3cVZM");
$83783d3841f6be99$export$c9648b76fd580c34 = $3cVZM.UnsubscriptionError;

var $5oAGq = parcelRequire("5oAGq");
$83783d3841f6be99$export$8bb95198b45adaac = $5oAGq.TimeInterval;

var $hpCBz = parcelRequire("hpCBz");
$83783d3841f6be99$export$d9bcbd5e1ff81430 = $hpCBz.Timestamp;

var $djy06 = parcelRequire("djy06");
$83783d3841f6be99$export$62927158df9c43dd = $djy06.TestScheduler;

var $3Hw6c = parcelRequire("3Hw6c");
$83783d3841f6be99$export$789cef2613b1402 = $3Hw6c.VirtualTimeScheduler;

var $ekYoH = parcelRequire("ekYoH");
$83783d3841f6be99$export$ae07db09d6fbd01b = $ekYoH.AjaxResponse;
$83783d3841f6be99$export$9b8f4d0b97ba3d22 = $ekYoH.AjaxError;
$83783d3841f6be99$export$fcf72a1ab36e1e65 = $ekYoH.AjaxTimeoutError;

var $i11ER = parcelRequire("i11ER");
$83783d3841f6be99$export$a4627e546088548d = $i11ER.pipe;

var $2SiZJ = parcelRequire("2SiZJ");

var $gFD0E = parcelRequire("gFD0E");

var $iE1oT = parcelRequire("iE1oT");

var $7Hi3W = parcelRequire("7Hi3W");

var $1zOpv = parcelRequire("1zOpv");

var $7lPC2 = parcelRequire("7lPC2");

var $bGiX7 = parcelRequire("bGiX7");

var $3PjqI = parcelRequire("3PjqI");
$83783d3841f6be99$export$ccbce4efa7f8029b = $3PjqI;
/* tslint:enable:no-unused-variable */ /**
 * @typedef {Object} Rx.Scheduler
 * @property {Scheduler} queue Schedules on a queue in the current event frame
 * (trampoline scheduler). Use this for iteration operations.
 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
 * fastest transport mechanism available, either Node.js' `process.nextTick()`
 * or Web Worker MessageChannel or setTimeout or others. Use this for
 * asynchronous conversions.
 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
 * time-based operations.
 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
 * Use this for synchronizing with the platform's painting
 */ var $83783d3841f6be99$var$Scheduler = {
    asap: $2SiZJ.asap,
    queue: $iE1oT.queue,
    animationFrame: $7Hi3W.animationFrame,
    async: $gFD0E.async
};
$83783d3841f6be99$export$d3e54bb8584cda7c = $83783d3841f6be99$var$Scheduler;
/**
 * @typedef {Object} Rx.Symbol
 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
 * an object that has all of the traits of an Rx Subscriber, including the
 * ability to add and remove subscriptions to the subscription chain and
 * guarantees involving event triggering (can't "next" after unsubscription,
 * etc).
 * @property {Symbol|string} observable A symbol to use as a property name to
 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
 * to retrieve an iterator from an object.
 */ var $83783d3841f6be99$var$Symbol = {
    rxSubscriber: $1zOpv.rxSubscriber,
    observable: $bGiX7.observable,
    iterator: $7lPC2.iterator
};
$83783d3841f6be99$export$3e25e887b7a5b37b = $83783d3841f6be99$var$Symbol;

});
parcelRegister("iUyah", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $lAxg0 = parcelRequire("lAxg0");
$fSYYZ.Observable.bindCallback = $lAxg0.bindCallback;

});
parcelRegister("lAxg0", function(module, exports) {
$parcel$export(module.exports, "bindCallback", () => $fb76c1f5d23b207d$export$ba9059a8de3f18e, (v) => $fb76c1f5d23b207d$export$ba9059a8de3f18e = v);
var $fb76c1f5d23b207d$export$ba9059a8de3f18e;
"use strict";

var $7kL6U = parcelRequire("7kL6U");
$fb76c1f5d23b207d$export$ba9059a8de3f18e = $7kL6U.BoundCallbackObservable.create;

});
parcelRegister("7kL6U", function(module, exports) {
"use strict";
var $556ef1cd53921e6e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $16pOr = parcelRequire("16pOr");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $556ef1cd53921e6e$var$BoundCallbackObservable = function(_super) {
    $556ef1cd53921e6e$var$__extends(BoundCallbackObservable, _super);
    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */ /**
     * Converts a callback API to a function that returns an Observable.
     *
     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
     * it will return a function `g` that when called as `g(x)` will output an
     * Observable.</span>
     *
     * `bindCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, the
     * last parameter must be a callback function that `func` calls when it is
     * done.
     *
     * The output of `bindCallback` is a function that takes the same parameters
     * as `func`, except the last one (the callback). When the output function
     * is called with arguments it will return an Observable. If function `func`
     * calls its callback with one argument the Observable will emit that value.
     * If on the other hand the callback is called with multiple values the resulting
     * Observable will emit an array with said values as arguments.
     *
     * It is very important to remember that input function `func` is not called
     * when the output function is, but rather when the Observable returned by the output
     * function is subscribed. This means if `func` makes an AJAX request, that request
     * will be made every time someone subscribes to the resulting Observable, but not before.
     *
     * Optionally, a selector function can be passed to `bindObservable`. The selector function
     * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
     * Even though by default multiple arguments passed to callback appear in the stream as an array
     * the selector function will be called with arguments directly, just as the callback would.
     * This means you can imagine the default selector (when one is not provided explicitly)
     * as a function that aggregates all its arguments into an array, or simply returns first argument
     * if there is only one.
     *
     * The last optional parameter - {@link Scheduler} - can be used to control when the call
     * to `func` happens after someone subscribes to Observable, as well as when results
     * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
     * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
     * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
     * and call `subscribe` on the output Observable all function calls that are currently executing
     * will end before `func` is invoked.
     *
     * By default results passed to the callback are emitted immediately after `func` invokes the callback.
     * In particular, if the callback is called synchronously the subscription of the resulting Observable
     * will call the `next` function synchronously as well.  If you want to defer that call,
     * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
     * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
     *
     * Note that the Observable created by the output function will always emit a single value
     * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
     * calls will not appear in the stream. If you need to listen for multiple calls,
     *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
     *
     * If `func` depends on some context (`this` property) and is not already bound the context of `func`
     * will be the context that the output function has at call time. In particular, if `func`
     * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
     * it is recommended that the context of the output function is set to that object as well.
     *
     * If the input function calls its callback in the "node style" (i.e. first argument to callback is
     * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
     * provides convenient error handling and probably is a better choice.
     * `bindCallback` will treat such functions the same as any other and error parameters
     * (whether passed or not) will always be interpreted as regular callback argument.
     *
     *
     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
     * // Suppose we have jQuery.getJSON('/my/url', callback)
     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
     * var result = getJSONAsObservable('/my/url');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Receive an array of arguments passed to a callback</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 5
     *   console.log(b); // 'some string'
     *   console.log(c); // {someProperty: 'someValue'}
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
     * boundSomeFunction().subscribe(values => {
     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
     * });
     *
     *
     * @example <caption>Use bindCallback with a selector function</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 'a'
     *   console.log(b); // 'b'
     *   console.log(c); // 'c'
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
     * boundSomeFunction().subscribe(value => {
     *   console.log(value) // 'abc'
     * });
     *
     *
     * @example <caption>Compare behaviour with and without async Scheduler</caption>
     * function iCallMyCallbackSynchronously(cb) {
     *   cb();
     * }
     *
     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
     *
     * boundSyncFn().subscribe(() => console.log('I was sync!'));
     * boundAsyncFn().subscribe(() => console.log('I was async!'));
     * console.log('This happened...');
     *
     * // Logs:
     * // I was sync!
     * // This happened...
     * // I was async!
     *
     *
     * @example <caption>Use bindCallback on an object method</caption>
     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
     * .subscribe(subscriber);
     *
     *
     * @see {@link bindNodeCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func A function with a callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps them to a value that is emitted on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the callback would deliver.
     * @static true
     * @name bindCallback
     * @owner Observable
     */ BoundCallbackObservable.create = function(func, selector, scheduler) {
        if (selector === void 0) selector = undefined;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            return new BoundCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundCallbackObservable.prototype._subscribe = function(subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new $16pOr.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    if (selector) {
                        var result_1 = $3XqeD.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === $h0Tv0.errorObject) subject.error($h0Tv0.errorObject.e);
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    } else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = $3XqeD.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === $h0Tv0.errorObject) subject.error($h0Tv0.errorObject.e);
            }
            return subject.subscribe(subscriber);
        } else return scheduler.schedule(BoundCallbackObservable.dispatch, 0, {
            source: this,
            subscriber: subscriber,
            context: this.context
        });
    };
    BoundCallbackObservable.dispatch = function(state) {
        var self = this;
        var source = state.source, subscriber = state.subscriber, context = state.context;
        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
        var subject = source.subject;
        if (!subject) {
            subject = source.subject = new $16pOr.AsyncSubject();
            var handler = function handlerFn() {
                var innerArgs = [];
                for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                var source = handlerFn.source;
                var selector = source.selector, subject = source.subject;
                if (selector) {
                    var result_2 = $3XqeD.tryCatch(selector).apply(this, innerArgs);
                    if (result_2 === $h0Tv0.errorObject) self.add(scheduler.schedule($556ef1cd53921e6e$var$dispatchError, 0, {
                        err: $h0Tv0.errorObject.e,
                        subject: subject
                    }));
                    else self.add(scheduler.schedule($556ef1cd53921e6e$var$dispatchNext, 0, {
                        value: result_2,
                        subject: subject
                    }));
                } else {
                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                    self.add(scheduler.schedule($556ef1cd53921e6e$var$dispatchNext, 0, {
                        value: value,
                        subject: subject
                    }));
                }
            };
            // use named function to pass values in without closure
            handler.source = source;
            var result = $3XqeD.tryCatch(callbackFunc).apply(context, args.concat(handler));
            if (result === $h0Tv0.errorObject) subject.error($h0Tv0.errorObject.e);
        }
        self.add(subject.subscribe(subscriber));
    };
    return BoundCallbackObservable;
}($fSYYZ.Observable);
module.exports.BoundCallbackObservable = $556ef1cd53921e6e$var$BoundCallbackObservable;
function $556ef1cd53921e6e$var$dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function $556ef1cd53921e6e$var$dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

});
parcelRegister("16pOr", function(module, exports) {
"use strict";
var $0cda5fd6aeea9b63$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $aBkDT = parcelRequire("aBkDT");
/**
 * @class AsyncSubject<T>
 */ var $0cda5fd6aeea9b63$var$AsyncSubject = function(_super) {
    $0cda5fd6aeea9b63$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $aBkDT.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $aBkDT.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($bTlA1.Subject);
module.exports.AsyncSubject = $0cda5fd6aeea9b63$var$AsyncSubject;

});




parcelRegister("2RhXy", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $ignI9 = parcelRequire("ignI9");
$fSYYZ.Observable.bindNodeCallback = $ignI9.bindNodeCallback;

});
parcelRegister("ignI9", function(module, exports) {
$parcel$export(module.exports, "bindNodeCallback", () => $d4bc1d26150153b7$export$4893451713772b1a, (v) => $d4bc1d26150153b7$export$4893451713772b1a = v);
var $d4bc1d26150153b7$export$4893451713772b1a;
"use strict";

var $heH2s = parcelRequire("heH2s");
$d4bc1d26150153b7$export$4893451713772b1a = $heH2s.BoundNodeCallbackObservable.create;

});
parcelRegister("heH2s", function(module, exports) {
"use strict";
var $c8c5210976598a69$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $16pOr = parcelRequire("16pOr");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $c8c5210976598a69$var$BoundNodeCallbackObservable = function(_super) {
    $c8c5210976598a69$var$__extends(BoundNodeCallbackObservable, _super);
    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */ /**
     * Converts a Node.js-style callback API to a function that returns an
     * Observable.
     *
     * <span class="informal">It's just like {@link bindCallback}, but the
     * callback is expected to be of type `callback(error, result)`.</span>
     *
     * `bindNodeCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done. The callback function is expected to follow Node.js conventions,
     * where the first argument to the callback is an error object, signaling
     * whether call was successful. If that object is passed to callback, it means
     * something went wrong.
     *
     * The output of `bindNodeCallback` is a function that takes the same
     * parameters as `func`, except the last one (the callback). When the output
     * function is called with arguments, it will return an Observable.
     * If `func` calls its callback with error parameter present, Observable will
     * error with that value as well. If error parameter is not passed, Observable will emit
     * second parameter. If there are more parameters (third and so on),
     * Observable will emit an array with all arguments, except first error argument.
     *
     * Optionally `bindNodeCallback` accepts selector function, which allows you to
     * make resulting Observable emit value computed by selector, instead of regular
     * callback arguments. It works similarly to {@link bindCallback} selector, but
     * Node.js-style error argument will never be passed to that function.
     *
     * Note that `func` will not be called at the same time output function is,
     * but rather whenever resulting Observable is subscribed. By default call to
     * `func` will happen synchronously after subscription, but that can be changed
     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
     * can also control when values from callback will be emitted by Observable.
     * To find out more, check out documentation for {@link bindCallback}, where
     * Scheduler works exactly the same.
     *
     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
     * of returned function, when it is called.
     *
     * After Observable emits value, it will complete immediately. This means
     * even if `func` calls callback again, values from second and consecutive
     * calls will never appear on the stream. If you need to handle functions
     * that call callbacks multiple times, check out {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
     * "Node.js-style" callbacks are just a convention, so if you write for
     * browsers or any other environment and API you use implements that callback style,
     * `bindNodeCallback` can be safely used on that API functions as well.
     *
     * Remember that Error object passed to callback does not have to be an instance
     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
     * Error parameter of callback function is interpreted as "present", when value
     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
     * string or boolean `true`. In all of these cases resulting Observable would error
     * with that value. This means usually regular style callbacks will fail very often when
     * `bindNodeCallback` is used. If your Observable errors much more often then you
     * would expect, check if callback really is called in Node.js-style and, if not,
     * switch to {@link bindCallback} instead.
     *
     * Note that even if error parameter is technically present in callback, but its value
     * is falsy, it still won't appear in array emitted by Observable or in selector function.
     *
     *
     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
     * import * as fs from 'fs';
     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Use on function calling callback with multiple arguments</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // null
     *   console.log(a); // 5
     *   console.log(b); // "some string"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // [5, "some string"]
     * });
     *
     *
     * @example <caption>Use with selector function</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // undefined
     *   console.log(a); // "abc"
     *   console.log(b); // "DEF"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // "abcDEF"
     * });
     *
     *
     * @example <caption>Use on function calling callback in regular style</caption>
     * someFunction(a => {
     *   console.log(a); // 5
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(
     *   value => {}             // never gets called
     *   err => console.log(err) // 5
     *);
     *
     *
     * @see {@link bindCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a Node.js-style callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the Node.js callback would
     * deliver.
     * @static true
     * @name bindNodeCallback
     * @owner Observable
     */ BoundNodeCallbackObservable.create = function(func, selector, scheduler) {
        if (selector === void 0) selector = undefined;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundNodeCallbackObservable.prototype._subscribe = function(subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new $16pOr.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    var err = innerArgs.shift();
                    if (err) subject.error(err);
                    else if (selector) {
                        var result_1 = $3XqeD.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === $h0Tv0.errorObject) subject.error($h0Tv0.errorObject.e);
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    } else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = $3XqeD.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === $h0Tv0.errorObject) subject.error($h0Tv0.errorObject.e);
            }
            return subject.subscribe(subscriber);
        } else return scheduler.schedule($c8c5210976598a69$var$dispatch, 0, {
            source: this,
            subscriber: subscriber,
            context: this.context
        });
    };
    return BoundNodeCallbackObservable;
}($fSYYZ.Observable);
module.exports.BoundNodeCallbackObservable = $c8c5210976598a69$var$BoundNodeCallbackObservable;
function $c8c5210976598a69$var$dispatch(state) {
    var self = this;
    var source = state.source, subscriber = state.subscriber, context = state.context;
    // XXX: cast to `any` to access to the private field in `source`.
    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
    var subject = source.subject;
    if (!subject) {
        subject = source.subject = new $16pOr.AsyncSubject();
        var handler = function handlerFn() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
            var source = handlerFn.source;
            var selector = source.selector, subject = source.subject;
            var err = innerArgs.shift();
            if (err) self.add(scheduler.schedule($c8c5210976598a69$var$dispatchError, 0, {
                err: err,
                subject: subject
            }));
            else if (selector) {
                var result_2 = $3XqeD.tryCatch(selector).apply(this, innerArgs);
                if (result_2 === $h0Tv0.errorObject) self.add(scheduler.schedule($c8c5210976598a69$var$dispatchError, 0, {
                    err: $h0Tv0.errorObject.e,
                    subject: subject
                }));
                else self.add(scheduler.schedule($c8c5210976598a69$var$dispatchNext, 0, {
                    value: result_2,
                    subject: subject
                }));
            } else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                self.add(scheduler.schedule($c8c5210976598a69$var$dispatchNext, 0, {
                    value: value,
                    subject: subject
                }));
            }
        };
        // use named function to pass values in without closure
        handler.source = source;
        var result = $3XqeD.tryCatch(callbackFunc).apply(context, args.concat(handler));
        if (result === $h0Tv0.errorObject) self.add(scheduler.schedule($c8c5210976598a69$var$dispatchError, 0, {
            err: $h0Tv0.errorObject.e,
            subject: subject
        }));
    }
    self.add(subject.subscribe(subscriber));
}
function $c8c5210976598a69$var$dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function $c8c5210976598a69$var$dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

});



parcelRegister("aJ1y8", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5j05Y = parcelRequire("5j05Y");
$fSYYZ.Observable.combineLatest = $5j05Y.combineLatest;

});
parcelRegister("5j05Y", function(module, exports) {
$parcel$export(module.exports, "combineLatest", () => $3dcecd03ee721eef$export$77fa7d86f5204e8a, (v) => $3dcecd03ee721eef$export$77fa7d86f5204e8a = v);
var $3dcecd03ee721eef$export$77fa7d86f5204e8a;
"use strict";

var $bOxHY = parcelRequire("bOxHY");

var $5G96M = parcelRequire("5G96M");

var $iLZ0l = parcelRequire("iLZ0l");

var $gVAew = parcelRequire("gVAew");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from all the Observables passed as
 * arguments. This is done by subscribing to each Observable in order and,
 * whenever any Observable emits, collecting an array of the most recent
 * values from each Observable. So if you pass `n` Observables to operator,
 * returned Observable will always emit an array of `n` values, in order
 * corresponding to order of passed Observables (value from the first Observable
 * on the first place and so on).
 *
 * Static version of `combineLatest` accepts either an array of Observables
 * or each Observable can be put directly as an argument. Note that array of
 * Observables is good choice, if you don't know beforehand how many Observables
 * you will combine. Passing empty array will result in Observable that
 * completes immediately.
 *
 * To ensure output array has always the same length, `combineLatest` will
 * actually wait for all input Observables to emit at least once,
 * before it starts emitting results. This means if some Observable emits
 * values before other Observables started emitting, all that values but last
 * will be lost. On the other hand, is some Observable does not emit value but
 * completes, resulting Observable will complete at the same moment without
 * emitting anything, since it will be now impossible to include value from
 * completed Observable in resulting array. Also, if some input Observable does
 * not emit any value and never completes, `combineLatest` will also never emit
 * and never complete, since, again, it will wait for all streams to emit some
 * value.
 *
 * If at least one Observable was passed to `combineLatest` and all passed Observables
 * emitted something, resulting Observable will complete when all combined
 * streams complete. So even if some Observable completes, result of
 * `combineLatest` will still emit values when other Observables do. In case
 * of completed Observable, its value from now on will always be the last
 * emitted value. On the other hand, if any Observable errors, `combineLatest`
 * will error immediately as well, and all other Observables will be unsubscribed.
 *
 * `combineLatest` accepts as optional parameter `project` function, which takes
 * as arguments all values that would normally be emitted by resulting Observable.
 * `project` can return any kind of value, which will be then emitted by Observable
 * instead of default array. Note that `project` does not take as argument that array
 * of values, but values themselves. That means default `project` can be imagined
 * as function that takes all its arguments and puts them into an array.
 *
 *
 * @example <caption>Combine two timer Observables</caption>
 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
 * combinedTimers.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0] after 0.5s
 * // [1, 0] after 1s
 * // [1, 1] after 1.5s
 * // [2, 1] after 2s
 *
 *
 * @example <caption>Combine an array of Observables</caption>
 * const observables = [1, 5, 10].map(
 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
 * );
 * const combined = Rx.Observable.combineLatest(observables);
 * combined.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0, 0] immediately
 * // [1, 0, 0] after 1s
 * // [1, 5, 0] after 5s
 * // [1, 5, 10] after 10s
 *
 *
 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
 * More than one input Observables may be given as arguments
 * or an array of Observables may be given as the first argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each input Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @static true
 * @name combineLatest
 * @owner Observable
 */ function $3dcecd03ee721eef$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    var scheduler = null;
    if ($bOxHY.isScheduler(observables[observables.length - 1])) scheduler = observables.pop();
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $5G96M.isArray(observables[0])) observables = observables[0];
    return new $iLZ0l.ArrayObservable(observables, scheduler).lift(new $gVAew.CombineLatestOperator(project));
}
$3dcecd03ee721eef$export$77fa7d86f5204e8a = $3dcecd03ee721eef$var$combineLatest;

});
parcelRegister("gVAew", function(module, exports) {
"use strict";
var $c52e1364bec155b5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iLZ0l = parcelRequire("iLZ0l");

var $5G96M = parcelRequire("5G96M");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
var $c52e1364bec155b5$var$none = {};
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $c52e1364bec155b5$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $5G96M.isArray(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call(new $iLZ0l.ArrayObservable([
            source
        ].concat(observables)), new $c52e1364bec155b5$var$CombineLatestOperator(project));
    };
}
module.exports.combineLatest = $c52e1364bec155b5$var$combineLatest;
var $c52e1364bec155b5$var$CombineLatestOperator = function() {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c52e1364bec155b5$var$CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}();
module.exports.CombineLatestOperator = $c52e1364bec155b5$var$CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c52e1364bec155b5$var$CombineLatestSubscriber = function(_super) {
    $c52e1364bec155b5$var$__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($c52e1364bec155b5$var$none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add($2Q6Ms.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $c52e1364bec155b5$var$none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) this._tryProject(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function(values) {
        var result;
        try {
            result = this.project.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}($9u1V0.OuterSubscriber);
module.exports.CombineLatestSubscriber = $c52e1364bec155b5$var$CombineLatestSubscriber;

});



parcelRegister("aY7Ho", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $jpGTf = parcelRequire("jpGTf");
$fSYYZ.Observable.concat = $jpGTf.concat;

});
parcelRegister("jpGTf", function(module, exports) {
$parcel$export(module.exports, "concat", () => $e2219f3246db366a$export$ee1b3e54f0441b22, (v) => $e2219f3246db366a$export$ee1b3e54f0441b22 = v);
var $e2219f3246db366a$export$ee1b3e54f0441b22;
"use strict";

var $bOxHY = parcelRequire("bOxHY");

var $fyy56 = parcelRequire("fyy56");

var $dwdYm = parcelRequire("dwdYm");

var $dS4Ly = parcelRequire("dS4Ly");
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */ function $e2219f3246db366a$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    if (observables.length === 1 || observables.length === 2 && $bOxHY.isScheduler(observables[1])) return $dwdYm.from(observables[0]);
    return $dS4Ly.concatAll()($fyy56.of.apply(void 0, observables));
}
$e2219f3246db366a$export$ee1b3e54f0441b22 = $e2219f3246db366a$var$concat;

});
parcelRegister("dS4Ly", function(module, exports) {
$parcel$export(module.exports, "concatAll", () => $a19403ebb18b17e4$export$b314777ae20abca9, (v) => $a19403ebb18b17e4$export$b314777ae20abca9 = v);
var $a19403ebb18b17e4$export$b314777ae20abca9;
"use strict";

var $44a5l = parcelRequire("44a5l");
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $a19403ebb18b17e4$var$concatAll() {
    return $44a5l.mergeAll(1);
}
$a19403ebb18b17e4$export$b314777ae20abca9 = $a19403ebb18b17e4$var$concatAll;

});



parcelRegister("eaJVW", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $beNUo = parcelRequire("beNUo");
$fSYYZ.Observable.defer = $beNUo.defer;

});
parcelRegister("beNUo", function(module, exports) {
$parcel$export(module.exports, "defer", () => $82e7b74e895295fd$export$260e5c0943f31606, (v) => $82e7b74e895295fd$export$260e5c0943f31606 = v);
var $82e7b74e895295fd$export$260e5c0943f31606;
"use strict";

var $4G74R = parcelRequire("4G74R");
$82e7b74e895295fd$export$260e5c0943f31606 = $4G74R.DeferObservable.create;

});
parcelRegister("4G74R", function(module, exports) {
"use strict";
var $368093195dea87cd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $2Q6Ms = parcelRequire("2Q6Ms");

var $9u1V0 = parcelRequire("9u1V0");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $368093195dea87cd$var$DeferObservable = function(_super) {
    $368093195dea87cd$var$__extends(DeferObservable, _super);
    function DeferObservable(observableFactory) {
        _super.call(this);
        this.observableFactory = observableFactory;
    }
    /**
     * Creates an Observable that, on subscribe, calls an Observable factory to
     * make an Observable for each new Observer.
     *
     * <span class="informal">Creates the Observable lazily, that is, only when it
     * is subscribed.
     * </span>
     *
     * <img src="./img/defer.png" width="100%">
     *
     * `defer` allows you to create the Observable only when the Observer
     * subscribes, and create a fresh Observable for each Observer. It waits until
     * an Observer subscribes to it, and then it generates an Observable,
     * typically with an Observable factory function. It does this afresh for each
     * subscriber, so although each subscriber may think it is subscribing to the
     * same Observable, in fact each subscriber gets its own individual
     * Observable.
     *
     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
     * var clicksOrInterval = Rx.Observable.defer(function () {
     *   if (Math.random() > 0.5) {
     *     return Rx.Observable.fromEvent(document, 'click');
     *   } else {
     *     return Rx.Observable.interval(1000);
     *   }
     * });
     * clicksOrInterval.subscribe(x => console.log(x));
     *
     * // Results in the following behavior:
     * // If the result of Math.random() is greater than 0.5 it will listen
     * // for clicks anywhere on the "document"; when document is clicked it
     * // will log a MouseEvent object to the console. If the result is less
     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
     *
     * @see {@link create}
     *
     * @param {function(): SubscribableOrPromise} observableFactory The Observable
     * factory function to invoke for each Observer that subscribes to the output
     * Observable. May also return a Promise, which will be converted on the fly
     * to an Observable.
     * @return {Observable} An Observable whose Observers' subscriptions trigger
     * an invocation of the given Observable factory function.
     * @static true
     * @name defer
     * @owner Observable
     */ DeferObservable.create = function(observableFactory) {
        return new DeferObservable(observableFactory);
    };
    /** @deprecated internal use only */ DeferObservable.prototype._subscribe = function(subscriber) {
        return new $368093195dea87cd$var$DeferSubscriber(subscriber, this.observableFactory);
    };
    return DeferObservable;
}($fSYYZ.Observable);
module.exports.DeferObservable = $368093195dea87cd$var$DeferObservable;
var $368093195dea87cd$var$DeferSubscriber = function(_super) {
    $368093195dea87cd$var$__extends(DeferSubscriber, _super);
    function DeferSubscriber(destination, factory) {
        _super.call(this, destination);
        this.factory = factory;
        this.tryDefer();
    }
    DeferSubscriber.prototype.tryDefer = function() {
        try {
            this._callFactory();
        } catch (err) {
            this._error(err);
        }
    };
    DeferSubscriber.prototype._callFactory = function() {
        var result = this.factory();
        if (result) this.add($2Q6Ms.subscribeToResult(this, result));
    };
    return DeferSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("b0u6a", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $8pgsu = parcelRequire("8pgsu");
$fSYYZ.Observable.empty = $8pgsu.empty;

});
parcelRegister("8pgsu", function(module, exports) {
$parcel$export(module.exports, "empty", () => $61ed6cdee61a91e3$export$6e22c362a0406a2c, (v) => $61ed6cdee61a91e3$export$6e22c362a0406a2c = v);
var $61ed6cdee61a91e3$export$6e22c362a0406a2c;
"use strict";

var $fyVhl = parcelRequire("fyVhl");
$61ed6cdee61a91e3$export$6e22c362a0406a2c = $fyVhl.EmptyObservable.create;

});


parcelRegister("d7Oz5", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $ilKjM = parcelRequire("ilKjM");
$fSYYZ.Observable.forkJoin = $ilKjM.forkJoin;

});
parcelRegister("ilKjM", function(module, exports) {
$parcel$export(module.exports, "forkJoin", () => $d5be1def60d0f657$export$b5bbde3786dfbd68, (v) => $d5be1def60d0f657$export$b5bbde3786dfbd68 = v);
var $d5be1def60d0f657$export$b5bbde3786dfbd68;
"use strict";

var $7ELnm = parcelRequire("7ELnm");
$d5be1def60d0f657$export$b5bbde3786dfbd68 = $7ELnm.ForkJoinObservable.create;

});
parcelRegister("7ELnm", function(module, exports) {
"use strict";
var $593104a64fbb4218$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $fyVhl = parcelRequire("fyVhl");

var $5G96M = parcelRequire("5G96M");

var $2Q6Ms = parcelRequire("2Q6Ms");

var $9u1V0 = parcelRequire("9u1V0");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $593104a64fbb4218$var$ForkJoinObservable = function(_super) {
    $593104a64fbb4218$var$__extends(ForkJoinObservable, _super);
    function ForkJoinObservable(sources, resultSelector) {
        _super.call(this);
        this.sources = sources;
        this.resultSelector = resultSelector;
    }
    /* tslint:enable:max-line-length */ /**
     * Joins last values emitted by passed Observables.
     *
     * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
     *
     * <img src="./img/forkJoin.png" width="100%">
     *
     * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
     * or directly as arguments. If no input Observables are provided, resulting stream will complete
     * immediately.
     *
     * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
     * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
     * array will have `n` values, where first value is the last thing emitted by the first Observable,
     * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
     * not emit more than once and it will complete after that. If you need to emit combined values not only
     * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
     * or {@link zip} instead.
     *
     * In order for resulting array to have the same length as the number of input Observables, whenever any of
     * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
     * and it will not emit anything either, even if it already has some last values from other Observables.
     * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
     * unless at any point some other Observable completes without emitting value, which brings us back to
     * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
     * have to emit something at least once and complete.
     *
     * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
     * will be immediately unsubscribed.
     *
     * Optionally `forkJoin` accepts project function, that will be called with values which normally
     * would land in emitted array. Whatever is returned by project function, will appear in output
     * Observable instead. This means that default project can be thought of as a function that takes
     * all its arguments and puts them into an array. Note that project function will be called only
     * when output Observable is supposed to emit a result.
     *
     * @example <caption>Use forkJoin with operator emitting immediately</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.of(1, 2, 3, 4),
     *   Rx.Observable.of(5, 6, 7, 8)
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [4, 8]
     * // "This is how it ends!"
     *
     *
     * @example <caption>Use forkJoin with operator emitting after some time</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [2, 3] after 3 seconds
     * // "This is how it ends!" immediately after
     *
     *
     * @example <caption>Use forkJoin with project function</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
     *   (n, m) => n + m
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // 5 after 3 seconds
     * // "This is how it ends!" immediately after
     *
     * @see {@link combineLatest}
     * @see {@link zip}
     *
     * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
     * passed directly to the operator.
     * @param {function} [project] Function that takes values emitted by input Observables and returns value
     * that will appear in resulting Observable instead of default array.
     * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
     * or value from project function.
     * @static true
     * @name forkJoin
     * @owner Observable
     */ ForkJoinObservable.create = function() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i - 0] = arguments[_i];
        if (sources === null || arguments.length === 0) return new $fyVhl.EmptyObservable();
        var resultSelector = null;
        if (typeof sources[sources.length - 1] === 'function') resultSelector = sources.pop();
        // if the first and only other argument besides the resultSelector is an array
        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
        if (sources.length === 1 && $5G96M.isArray(sources[0])) sources = sources[0];
        if (sources.length === 0) return new $fyVhl.EmptyObservable();
        return new ForkJoinObservable(sources, resultSelector);
    };
    /** @deprecated internal use only */ ForkJoinObservable.prototype._subscribe = function(subscriber) {
        return new $593104a64fbb4218$var$ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
    };
    return ForkJoinObservable;
}($fSYYZ.Observable);
module.exports.ForkJoinObservable = $593104a64fbb4218$var$ForkJoinObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $593104a64fbb4218$var$ForkJoinSubscriber = function(_super) {
    $593104a64fbb4218$var$__extends(ForkJoinSubscriber, _super);
    function ForkJoinSubscriber(destination, sources, resultSelector) {
        _super.call(this, destination);
        this.sources = sources;
        this.resultSelector = resultSelector;
        this.completed = 0;
        this.haveValues = 0;
        var len = sources.length;
        this.total = len;
        this.values = new Array(len);
        for(var i = 0; i < len; i++){
            var source = sources[i];
            var innerSubscription = $2Q6Ms.subscribeToResult(this, source, null, i);
            if (innerSubscription) {
                innerSubscription.outerIndex = i;
                this.add(innerSubscription);
            }
        }
    }
    ForkJoinSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        if (!innerSub._hasValue) {
            innerSub._hasValue = true;
            this.haveValues++;
        }
    };
    ForkJoinSubscriber.prototype.notifyComplete = function(innerSub) {
        var destination = this.destination;
        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
        var len = values.length;
        if (!innerSub._hasValue) {
            destination.complete();
            return;
        }
        this.completed++;
        if (this.completed !== len) return;
        if (haveValues === len) {
            var value = resultSelector ? resultSelector.apply(this, values) : values;
            destination.next(value);
        }
        destination.complete();
    };
    return ForkJoinSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("ok1hF", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $dwdYm = parcelRequire("dwdYm");
$fSYYZ.Observable.from = $dwdYm.from;

});

parcelRegister("2kHqX", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $7pLpf = parcelRequire("7pLpf");
$fSYYZ.Observable.fromEvent = $7pLpf.fromEvent;

});
parcelRegister("7pLpf", function(module, exports) {
$parcel$export(module.exports, "fromEvent", () => $565fa415dd562bad$export$a36e16046ae8f1bb, (v) => $565fa415dd562bad$export$a36e16046ae8f1bb = v);
var $565fa415dd562bad$export$a36e16046ae8f1bb;
"use strict";

var $j5ST6 = parcelRequire("j5ST6");
$565fa415dd562bad$export$a36e16046ae8f1bb = $j5ST6.FromEventObservable.create;

});
parcelRegister("j5ST6", function(module, exports) {
"use strict";
var $de690f85f42a543d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $3XqeD = parcelRequire("3XqeD");

var $aLsQP = parcelRequire("aLsQP");

var $h0Tv0 = parcelRequire("h0Tv0");

var $aBkDT = parcelRequire("aBkDT");
var $de690f85f42a543d$var$toString = Object.prototype.toString;
function $de690f85f42a543d$var$isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function $de690f85f42a543d$var$isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function $de690f85f42a543d$var$isNodeList(sourceObj) {
    return !!sourceObj && $de690f85f42a543d$var$toString.call(sourceObj) === '[object NodeList]';
}
function $de690f85f42a543d$var$isHTMLCollection(sourceObj) {
    return !!sourceObj && $de690f85f42a543d$var$toString.call(sourceObj) === '[object HTMLCollection]';
}
function $de690f85f42a543d$var$isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $de690f85f42a543d$var$FromEventObservable = function(_super) {
    $de690f85f42a543d$var$__extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */ /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node.js
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * `fromEvent` accepts as a first argument event target, which is an object with methods
     * for registering event handler functions. As a second argument it takes string that indicates
     * type of event we want to listen for. `fromEvent` supports selected types of event targets,
     * which are described in detail below. If your event target does not match any of the ones listed,
     * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
     * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
     * handler functions have different names, but they all accept a string describing event type
     * and function itself, which will be called whenever said event happens.
     *
     * Every time resulting Observable is subscribed, event handler function will be registered
     * to event target on given event type. When that event fires, value
     * passed as a first argument to registered function will be emitted by output Observable.
     * When Observable is unsubscribed, function will be unregistered from event target.
     *
     * Note that if event target calls registered function with more than one argument, second
     * and following arguments will not appear in resulting stream. In order to get access to them,
     * you can pass to `fromEvent` optional project function, which will be called with all arguments
     * passed to event handler. Output Observable will then emit value returned by project function,
     * instead of the usual value.
     *
     * Remember that event targets listed below are checked via duck typing. It means that
     * no matter what kind of object you have and no matter what environment you work in,
     * you can safely use `fromEvent` on that object if it exposes described methods (provided
     * of course they behave as was described above). So for example if Node.js library exposes
     * event target which has the same method names as DOM EventTarget, `fromEvent` is still
     * a good choice.
     *
     * If the API you use is more callback then event handler oriented (subscribed
     * callback function fires only once and thus there is no need to manually
     * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
     * instead.
     *
     * `fromEvent` supports following types of event targets:
     *
     * **DOM EventTarget**
     *
     * This is an object with `addEventListener` and `removeEventListener` methods.
     *
     * In the browser, `addEventListener` accepts - apart from event type string and event
     * handler function arguments - optional third parameter, which is either an object or boolean,
     * both used for additional configuration how and when passed function will be called. When
     * `fromEvent` is used with event target of that type, you can provide this values
     * as third parameter as well.
     *
     * **Node.js EventEmitter**
     *
     * An object with `addListener` and `removeListener` methods.
     *
     * **JQuery-style event target**
     *
     * An object with `on` and `off` methods
     *
     * **DOM NodeList**
     *
     * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
     *
     * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
     * it contains and install event handler function in every of them. When returned Observable
     * is unsubscribed, function will be removed from all Nodes.
     *
     * **DOM HtmlCollection**
     *
     * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
     * installed and removed in each of elements.
     *
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console every time a click
     * // occurs on the document.
     *
     *
     * @example <caption>Use addEventListener with capture option</caption>
     * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
     *                                                                          // which will be passed to addEventListener
     * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
     *
     * clicksInDocument.subscribe(() => console.log('document'));
     * clicksInDiv.subscribe(() => console.log('div'));
     *
     * // By default events bubble UP in DOM tree, so normally
     * // when we would click on div in document
     * // "div" would be logged first and then "document".
     * // Since we specified optional `capture` option, document
     * // will catch event when it goes DOWN DOM tree, so console
     * // will log "document" and then "div".
     *
     * @see {@link bindCallback}
     * @see {@link bindNodeCallback}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOM EventTarget, Node.js
     * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */ FromEventObservable.create = function(target, eventName, options, selector) {
        if ($aLsQP.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function(sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if ($de690f85f42a543d$var$isNodeList(sourceObj) || $de690f85f42a543d$var$isHTMLCollection(sourceObj)) for(var i = 0, len = sourceObj.length; i < len; i++)FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        else if ($de690f85f42a543d$var$isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function() {
                return source_1.removeEventListener(eventName, handler, options);
            };
        } else if ($de690f85f42a543d$var$isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function() {
                return source_2.off(eventName, handler);
            };
        } else if ($de690f85f42a543d$var$isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function() {
                return source_3.removeListener(eventName, handler);
            };
        } else throw new TypeError('Invalid event target');
        subscriber.add(new $aBkDT.Subscription(unsubscribe));
    };
    /** @deprecated internal use only */ FromEventObservable.prototype._subscribe = function(subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            var result = $3XqeD.tryCatch(selector).apply(void 0, args);
            if (result === $h0Tv0.errorObject) subscriber.error($h0Tv0.errorObject.e);
            else subscriber.next(result);
        } : function(e) {
            return subscriber.next(e);
        };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}($fSYYZ.Observable);
module.exports.FromEventObservable = $de690f85f42a543d$var$FromEventObservable;

});



parcelRegister("89gk9", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $aZXKz = parcelRequire("aZXKz");
$fSYYZ.Observable.fromEventPattern = $aZXKz.fromEventPattern;

});
parcelRegister("aZXKz", function(module, exports) {
$parcel$export(module.exports, "fromEventPattern", () => $801df2ffec3ae157$export$af596f9f0ff848f8, (v) => $801df2ffec3ae157$export$af596f9f0ff848f8 = v);
var $801df2ffec3ae157$export$af596f9f0ff848f8;
"use strict";

var $3xyVj = parcelRequire("3xyVj");
$801df2ffec3ae157$export$af596f9f0ff848f8 = $3xyVj.FromEventPatternObservable.create;

});
parcelRegister("3xyVj", function(module, exports) {
"use strict";
var $293f8b39766343bd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aLsQP = parcelRequire("aLsQP");

var $fSYYZ = parcelRequire("fSYYZ");

var $aBkDT = parcelRequire("aBkDT");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $293f8b39766343bd$var$FromEventPatternObservable = function(_super) {
    $293f8b39766343bd$var$__extends(FromEventPatternObservable, _super);
    function FromEventPatternObservable(addHandler, removeHandler, selector) {
        _super.call(this);
        this.addHandler = addHandler;
        this.removeHandler = removeHandler;
        this.selector = selector;
    }
    /**
     * Creates an Observable from an API based on addHandler/removeHandler
     * functions.
     *
     * <span class="informal">Converts any addHandler/removeHandler API to an
     * Observable.</span>
     *
     * <img src="./img/fromEventPattern.png" width="100%">
     *
     * Creates an Observable by using the `addHandler` and `removeHandler`
     * functions to add and remove the handlers, with an optional selector
     * function to project the event arguments to a result. The `addHandler` is
     * called when the output Observable is subscribed, and `removeHandler` is
     * called when the Subscription is unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * function addClickHandler(handler) {
     *   document.addEventListener('click', handler);
     * }
     *
     * function removeClickHandler(handler) {
     *   document.removeEventListener('click', handler);
     * }
     *
     * var clicks = Rx.Observable.fromEventPattern(
     *   addClickHandler,
     *   removeClickHandler
     * );
     * clicks.subscribe(x => console.log(x));
     *
     * @see {@link from}
     * @see {@link fromEvent}
     *
     * @param {function(handler: Function): any} addHandler A function that takes
     * a `handler` function as argument and attaches it somehow to the actual
     * source of events.
     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
     * takes a `handler` function as argument and removes it in case it was
     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
     * removeHandler function will forward it.
     * @param {function(...args: any): T} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEventPattern
     * @owner Observable
     */ FromEventPatternObservable.create = function(addHandler, removeHandler, selector) {
        return new FromEventPatternObservable(addHandler, removeHandler, selector);
    };
    /** @deprecated internal use only */ FromEventPatternObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var removeHandler = this.removeHandler;
        var handler = !!this.selector ? function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            _this._callSelector(subscriber, args);
        } : function(e) {
            subscriber.next(e);
        };
        var retValue = this._callAddHandler(handler, subscriber);
        if (!$aLsQP.isFunction(removeHandler)) return;
        subscriber.add(new $aBkDT.Subscription(function() {
            //TODO: determine whether or not to forward to error handler
            removeHandler(handler, retValue);
        }));
    };
    FromEventPatternObservable.prototype._callSelector = function(subscriber, args) {
        try {
            var result = this.selector.apply(this, args);
            subscriber.next(result);
        } catch (e) {
            subscriber.error(e);
        }
    };
    FromEventPatternObservable.prototype._callAddHandler = function(handler, errorSubscriber) {
        try {
            return this.addHandler(handler) || null;
        } catch (e) {
            errorSubscriber.error(e);
        }
    };
    return FromEventPatternObservable;
}($fSYYZ.Observable);
module.exports.FromEventPatternObservable = $293f8b39766343bd$var$FromEventPatternObservable;

});



parcelRegister("a3iWS", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $lDQiC = parcelRequire("lDQiC");
$fSYYZ.Observable.fromPromise = $lDQiC.fromPromise;

});

parcelRegister("kVOut", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hvPTI = parcelRequire("hvPTI");
$fSYYZ.Observable.generate = $hvPTI.generate;

});
parcelRegister("hvPTI", function(module, exports) {
$parcel$export(module.exports, "generate", () => $cbfd96b692bcbbf4$export$80d376111cc09ad7, (v) => $cbfd96b692bcbbf4$export$80d376111cc09ad7 = v);
var $cbfd96b692bcbbf4$export$80d376111cc09ad7;
"use strict";

var $iNjIM = parcelRequire("iNjIM");
$cbfd96b692bcbbf4$export$80d376111cc09ad7 = $iNjIM.GenerateObservable.create;

});
parcelRegister("iNjIM", function(module, exports) {
"use strict";
var $daec19cf19d9f936$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $bOxHY = parcelRequire("bOxHY");
var $daec19cf19d9f936$var$selfSelector = function(value) {
    return value;
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $daec19cf19d9f936$var$GenerateObservable = function(_super) {
    $daec19cf19d9f936$var$__extends(GenerateObservable, _super);
    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
        _super.call(this);
        this.initialState = initialState;
        this.condition = condition;
        this.iterate = iterate;
        this.resultSelector = resultSelector;
        this.scheduler = scheduler;
    }
    GenerateObservable.create = function(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
        if (arguments.length == 1) return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || $daec19cf19d9f936$var$selfSelector, initialStateOrOptions.scheduler);
        if (resultSelectorOrObservable === undefined || $bOxHY.isScheduler(resultSelectorOrObservable)) return new GenerateObservable(initialStateOrOptions, condition, iterate, $daec19cf19d9f936$var$selfSelector, resultSelectorOrObservable);
        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
    };
    /** @deprecated internal use only */ GenerateObservable.prototype._subscribe = function(subscriber) {
        var state = this.initialState;
        if (this.scheduler) return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
            subscriber: subscriber,
            iterate: this.iterate,
            condition: this.condition,
            resultSelector: this.resultSelector,
            state: state
        });
        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) break;
            try {
                state = iterate(state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
        }while (true);
    };
    GenerateObservable.dispatch = function(state) {
        var subscriber = state.subscriber, condition = state.condition;
        if (subscriber.closed) return;
        if (state.needIterate) try {
            state.state = state.iterate(state.state);
        } catch (err) {
            subscriber.error(err);
            return;
        }
        else state.needIterate = true;
        if (condition) {
            var conditionResult = void 0;
            try {
                conditionResult = condition(state.state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
            if (!conditionResult) {
                subscriber.complete();
                return;
            }
            if (subscriber.closed) return;
        }
        var value;
        try {
            value = state.resultSelector(state.state);
        } catch (err) {
            subscriber.error(err);
            return;
        }
        if (subscriber.closed) return;
        subscriber.next(value);
        if (subscriber.closed) return;
        return this.schedule(state);
    };
    return GenerateObservable;
}($fSYYZ.Observable);
module.exports.GenerateObservable = $daec19cf19d9f936$var$GenerateObservable;

});



parcelRegister("f31N5", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $niL7N = parcelRequire("niL7N");
$fSYYZ.Observable.if = $niL7N._if;

});
parcelRegister("niL7N", function(module, exports) {
$parcel$export(module.exports, "_if", () => $0460b3424ce77e11$export$3d19121892ad9076, (v) => $0460b3424ce77e11$export$3d19121892ad9076 = v);
var $0460b3424ce77e11$export$3d19121892ad9076;
"use strict";

var $dad0Y = parcelRequire("dad0Y");
$0460b3424ce77e11$export$3d19121892ad9076 = $dad0Y.IfObservable.create;

});
parcelRegister("dad0Y", function(module, exports) {
"use strict";
var $99564dfec8f2fa2a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $2Q6Ms = parcelRequire("2Q6Ms");

var $9u1V0 = parcelRequire("9u1V0");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $99564dfec8f2fa2a$var$IfObservable = function(_super) {
    $99564dfec8f2fa2a$var$__extends(IfObservable, _super);
    function IfObservable(condition, thenSource, elseSource) {
        _super.call(this);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
    }
    IfObservable.create = function(condition, thenSource, elseSource) {
        return new IfObservable(condition, thenSource, elseSource);
    };
    /** @deprecated internal use only */ IfObservable.prototype._subscribe = function(subscriber) {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        return new $99564dfec8f2fa2a$var$IfSubscriber(subscriber, condition, thenSource, elseSource);
    };
    return IfObservable;
}($fSYYZ.Observable);
module.exports.IfObservable = $99564dfec8f2fa2a$var$IfObservable;
var $99564dfec8f2fa2a$var$IfSubscriber = function(_super) {
    $99564dfec8f2fa2a$var$__extends(IfSubscriber, _super);
    function IfSubscriber(destination, condition, thenSource, elseSource) {
        _super.call(this, destination);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
        this.tryIf();
    }
    IfSubscriber.prototype.tryIf = function() {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        var result;
        try {
            result = condition();
            var source = result ? thenSource : elseSource;
            if (source) this.add($2Q6Ms.subscribeToResult(this, source));
            else this._complete();
        } catch (err) {
            this._error(err);
        }
    };
    return IfSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("8vquY", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hAZoq = parcelRequire("hAZoq");
$fSYYZ.Observable.interval = $hAZoq.interval;

});
parcelRegister("hAZoq", function(module, exports) {
$parcel$export(module.exports, "interval", () => $ccf56bd7bfbcafba$export$3174cdbf0a0cbc84, (v) => $ccf56bd7bfbcafba$export$3174cdbf0a0cbc84 = v);
var $ccf56bd7bfbcafba$export$3174cdbf0a0cbc84;
"use strict";

var $lTtSA = parcelRequire("lTtSA");
$ccf56bd7bfbcafba$export$3174cdbf0a0cbc84 = $lTtSA.IntervalObservable.create;

});
parcelRegister("lTtSA", function(module, exports) {
"use strict";
var $ff05e977c752790e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $f3TUk = parcelRequire("f3TUk");

var $fSYYZ = parcelRequire("fSYYZ");

var $gFD0E = parcelRequire("gFD0E");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $ff05e977c752790e$var$IntervalObservable = function(_super) {
    $ff05e977c752790e$var$__extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $gFD0E.async;
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!$f3TUk.isNumeric(period) || period < 0) this.period = 0;
        if (!scheduler || typeof scheduler.schedule !== 'function') this.scheduler = $gFD0E.async;
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */ IntervalObservable.create = function(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $gFD0E.async;
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function(state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) return;
        state.index += 1;
        this.schedule(state, period);
    };
    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index,
            subscriber: subscriber,
            period: period
        }));
    };
    return IntervalObservable;
}($fSYYZ.Observable);
module.exports.IntervalObservable = $ff05e977c752790e$var$IntervalObservable;

});
parcelRegister("f3TUk", function(module, exports) {
$parcel$export(module.exports, "isNumeric", () => $af7280e486777d51$export$e90fb89750dba83f, (v) => $af7280e486777d51$export$e90fb89750dba83f = v);
var $af7280e486777d51$export$e90fb89750dba83f;
"use strict";

var $5G96M = parcelRequire("5G96M");
function $af7280e486777d51$var$isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !$5G96M.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
$af7280e486777d51$export$e90fb89750dba83f = $af7280e486777d51$var$isNumeric;

});

parcelRegister("gFD0E", function(module, exports) {
$parcel$export(module.exports, "async", () => $c22ebc2d082ae879$export$12af436354f1a4f7, (v) => $c22ebc2d082ae879$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $c22ebc2d082ae879$export$12af436354f1a4f7;
"use strict";

var $ercxm = parcelRequire("ercxm");

var $leugC = parcelRequire("leugC");
$c22ebc2d082ae879$export$12af436354f1a4f7 = new $leugC.AsyncScheduler($ercxm.AsyncAction);

});




parcelRegister("ea502", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5S14C = parcelRequire("5S14C");
$fSYYZ.Observable.merge = $5S14C.merge;

});

parcelRegister("cPUQ4", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $8fzNb = parcelRequire("8fzNb");
$fSYYZ.Observable.race = $8fzNb.race;

});
parcelRegister("8fzNb", function(module, exports) {
"use strict";
var $601b7d10c95b5449$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5G96M = parcelRequire("5G96M");

var $iLZ0l = parcelRequire("iLZ0l");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
function $601b7d10c95b5449$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($5G96M.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $iLZ0l.ArrayObservable(observables).lift(new $601b7d10c95b5449$var$RaceOperator());
}
module.exports.race = $601b7d10c95b5449$var$race;
var $601b7d10c95b5449$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $601b7d10c95b5449$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $601b7d10c95b5449$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $601b7d10c95b5449$var$RaceSubscriber = function(_super) {
    $601b7d10c95b5449$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $2Q6Ms.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($9u1V0.OuterSubscriber);
module.exports.RaceSubscriber = $601b7d10c95b5449$var$RaceSubscriber;

});


parcelRegister("6wtQK", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $bmck6 = parcelRequire("bmck6");
$fSYYZ.Observable.never = $bmck6.never;

});
parcelRegister("bmck6", function(module, exports) {
$parcel$export(module.exports, "never", () => $844b4ee90a771a42$export$b3e22bcfd64c1022, (v) => $844b4ee90a771a42$export$b3e22bcfd64c1022 = v);
var $844b4ee90a771a42$export$b3e22bcfd64c1022;
"use strict";

var $bt8sG = parcelRequire("bt8sG");
$844b4ee90a771a42$export$b3e22bcfd64c1022 = $bt8sG.NeverObservable.create;

});
parcelRegister("bt8sG", function(module, exports) {
"use strict";
var $8598f775db383386$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $9fPei = parcelRequire("9fPei");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $8598f775db383386$var$NeverObservable = function(_super) {
    $8598f775db383386$var$__extends(NeverObservable, _super);
    function NeverObservable() {
        _super.call(this);
    }
    /**
     * Creates an Observable that emits no items to the Observer.
     *
     * <span class="informal">An Observable that never emits anything.</span>
     *
     * <img src="./img/never.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that emits
     * neither values nor errors nor the completion notification. It can be used
     * for testing purposes or for composing with other Observables. Please note
     * that by never emitting a complete notification, this Observable keeps the
     * subscription from being disposed automatically. Subscriptions need to be
     * manually disposed.
     *
     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
     * function info() {
     *   console.log('Will not be called');
     * }
     * var result = Rx.Observable.never().startWith(7);
     * result.subscribe(x => console.log(x), info, info);
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link of}
     * @see {@link throw}
     *
     * @return {Observable} A "never" Observable: never emits anything.
     * @static true
     * @name never
     * @owner Observable
     */ NeverObservable.create = function() {
        return new NeverObservable();
    };
    /** @deprecated internal use only */ NeverObservable.prototype._subscribe = function(subscriber) {
        $9fPei.noop();
    };
    return NeverObservable;
}($fSYYZ.Observable);
module.exports.NeverObservable = $8598f775db383386$var$NeverObservable;

});



parcelRegister("jw3ro", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $fyy56 = parcelRequire("fyy56");
$fSYYZ.Observable.of = $fyy56.of;

});

parcelRegister("5Iorn", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $2PUZN = parcelRequire("2PUZN");
$fSYYZ.Observable.onErrorResumeNext = $2PUZN.onErrorResumeNext;

});
parcelRegister("2PUZN", function(module, exports) {
$parcel$export(module.exports, "onErrorResumeNext", () => $210c8e5da23a3abb$export$5fba66d61591f42, (v) => $210c8e5da23a3abb$export$5fba66d61591f42 = v);
var $210c8e5da23a3abb$export$5fba66d61591f42;
"use strict";

var $3LIqA = parcelRequire("3LIqA");
$210c8e5da23a3abb$export$5fba66d61591f42 = $3LIqA.onErrorResumeNextStatic;

});
parcelRegister("3LIqA", function(module, exports) {
"use strict";
var $2be8394c6a0e09b2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $doqIY = parcelRequire("doqIY");

var $5G96M = parcelRequire("5G96M");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $2be8394c6a0e09b2$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $5G96M.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $2be8394c6a0e09b2$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $2be8394c6a0e09b2$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $2be8394c6a0e09b2$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $5G96M.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $doqIY.FromObservable(source, null).lift(new $2be8394c6a0e09b2$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $2be8394c6a0e09b2$var$onErrorResumeNextStatic;
var $2be8394c6a0e09b2$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2be8394c6a0e09b2$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $2be8394c6a0e09b2$var$OnErrorResumeNextSubscriber = function(_super) {
    $2be8394c6a0e09b2$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($2Q6Ms.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("aJoZJ", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $jx1AH = parcelRequire("jx1AH");
$fSYYZ.Observable.pairs = $jx1AH.pairs;

});
parcelRegister("jx1AH", function(module, exports) {
$parcel$export(module.exports, "pairs", () => $e382555284eb71a3$export$589748d90c221be3, (v) => $e382555284eb71a3$export$589748d90c221be3 = v);
var $e382555284eb71a3$export$589748d90c221be3;
"use strict";

var $gbaDp = parcelRequire("gbaDp");
$e382555284eb71a3$export$589748d90c221be3 = $gbaDp.PairsObservable.create;

});
parcelRegister("gbaDp", function(module, exports) {
"use strict";
var $bc75ec3840708bf5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");
function $bc75ec3840708bf5$var$dispatch(state) {
    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
    if (index === length) {
        subscriber.complete();
        return;
    }
    var key = keys[index];
    subscriber.next([
        key,
        obj[key]
    ]);
    state.index = index + 1;
    this.schedule(state);
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $bc75ec3840708bf5$var$PairsObservable = function(_super) {
    $bc75ec3840708bf5$var$__extends(PairsObservable, _super);
    function PairsObservable(obj, scheduler) {
        _super.call(this);
        this.obj = obj;
        this.scheduler = scheduler;
        this.keys = Object.keys(obj);
    }
    /**
     * Convert an object into an observable sequence of [key, value] pairs
     * using an optional IScheduler to enumerate the object.
     *
     * @example <caption>Converts a javascript object to an Observable</caption>
     * var obj = {
     *   foo: 42,
     *   bar: 56,
     *   baz: 78
     * };
     *
     * var source = Rx.Observable.pairs(obj);
     *
     * var subscription = source.subscribe(
     *   function (x) {
     *     console.log('Next: %s', x);
     *   },
     *   function (err) {
     *     console.log('Error: %s', err);
     *   },
     *   function () {
     *     console.log('Completed');
     *   });
     *
     * @param {Object} obj The object to inspect and turn into an
     * Observable sequence.
     * @param {Scheduler} [scheduler] An optional IScheduler to run the
     * enumeration of the input sequence on.
     * @returns {(Observable<Array<string | T>>)} An observable sequence of
     * [key, value] pairs from the object.
     */ PairsObservable.create = function(obj, scheduler) {
        return new PairsObservable(obj, scheduler);
    };
    /** @deprecated internal use only */ PairsObservable.prototype._subscribe = function(subscriber) {
        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
        var length = keys.length;
        if (scheduler) return scheduler.schedule($bc75ec3840708bf5$var$dispatch, 0, {
            obj: this.obj,
            keys: keys,
            length: length,
            index: 0,
            subscriber: subscriber
        });
        else {
            for(var idx = 0; idx < length; idx++){
                var key = keys[idx];
                subscriber.next([
                    key,
                    this.obj[key]
                ]);
            }
            subscriber.complete();
        }
    };
    return PairsObservable;
}($fSYYZ.Observable);
module.exports.PairsObservable = $bc75ec3840708bf5$var$PairsObservable;

});



parcelRegister("I6fgQ", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $dp85X = parcelRequire("dp85X");
$fSYYZ.Observable.range = $dp85X.range;

});

parcelRegister("cGEPL", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hrnMo = parcelRequire("hrnMo");
$fSYYZ.Observable.using = $hrnMo.using;

});
parcelRegister("hrnMo", function(module, exports) {
$parcel$export(module.exports, "using", () => $cb27676bc91dd751$export$fb1889ddede82380, (v) => $cb27676bc91dd751$export$fb1889ddede82380 = v);
var $cb27676bc91dd751$export$fb1889ddede82380;
"use strict";

var $imSFx = parcelRequire("imSFx");
$cb27676bc91dd751$export$fb1889ddede82380 = $imSFx.UsingObservable.create;

});
parcelRegister("imSFx", function(module, exports) {
"use strict";
var $d5f4b02e67d70a1b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $2Q6Ms = parcelRequire("2Q6Ms");

var $9u1V0 = parcelRequire("9u1V0");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $d5f4b02e67d70a1b$var$UsingObservable = function(_super) {
    $d5f4b02e67d70a1b$var$__extends(UsingObservable, _super);
    function UsingObservable(resourceFactory, observableFactory) {
        _super.call(this);
        this.resourceFactory = resourceFactory;
        this.observableFactory = observableFactory;
    }
    UsingObservable.create = function(resourceFactory, observableFactory) {
        return new UsingObservable(resourceFactory, observableFactory);
    };
    /** @deprecated internal use only */ UsingObservable.prototype._subscribe = function(subscriber) {
        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
        var resource;
        try {
            resource = resourceFactory();
            return new $d5f4b02e67d70a1b$var$UsingSubscriber(subscriber, resource, observableFactory);
        } catch (err) {
            subscriber.error(err);
        }
    };
    return UsingObservable;
}($fSYYZ.Observable);
module.exports.UsingObservable = $d5f4b02e67d70a1b$var$UsingObservable;
var $d5f4b02e67d70a1b$var$UsingSubscriber = function(_super) {
    $d5f4b02e67d70a1b$var$__extends(UsingSubscriber, _super);
    function UsingSubscriber(destination, resource, observableFactory) {
        _super.call(this, destination);
        this.resource = resource;
        this.observableFactory = observableFactory;
        destination.add(resource);
        this.tryUse();
    }
    UsingSubscriber.prototype.tryUse = function() {
        try {
            var source = this.observableFactory.call(this, this.resource);
            if (source) this.add($2Q6Ms.subscribeToResult(this, source));
        } catch (err) {
            this._error(err);
        }
    };
    return UsingSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("4Ckx2", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $iLme7 = parcelRequire("iLme7");
$fSYYZ.Observable.throw = $iLme7._throw;

});
parcelRegister("iLme7", function(module, exports) {
$parcel$export(module.exports, "_throw", () => $da8ddb8cbf3e28be$export$82a8af9b11518516, (v) => $da8ddb8cbf3e28be$export$82a8af9b11518516 = v);
var $da8ddb8cbf3e28be$export$82a8af9b11518516;
"use strict";

var $no1W8 = parcelRequire("no1W8");
$da8ddb8cbf3e28be$export$82a8af9b11518516 = $no1W8.ErrorObservable.create;

});
parcelRegister("no1W8", function(module, exports) {
"use strict";
var $0464ca00651d810a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $0464ca00651d810a$var$ErrorObservable = function(_super) {
    $0464ca00651d810a$var$__extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */ ErrorObservable.create = function(error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function(arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function(subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) return scheduler.schedule(ErrorObservable.dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
        else subscriber.error(error);
    };
    return ErrorObservable;
}($fSYYZ.Observable);
module.exports.ErrorObservable = $0464ca00651d810a$var$ErrorObservable;

});



parcelRegister("5kaVk", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $kA7Tg = parcelRequire("kA7Tg");
$fSYYZ.Observable.timer = $kA7Tg.timer;

});
parcelRegister("kA7Tg", function(module, exports) {
$parcel$export(module.exports, "timer", () => $efbd4a4c94015442$export$9dc4ecf953986f04, (v) => $efbd4a4c94015442$export$9dc4ecf953986f04 = v);
var $efbd4a4c94015442$export$9dc4ecf953986f04;
"use strict";

var $iDmhq = parcelRequire("iDmhq");
$efbd4a4c94015442$export$9dc4ecf953986f04 = $iDmhq.TimerObservable.create;

});
parcelRegister("iDmhq", function(module, exports) {
"use strict";
var $d90d26d9fbb651c2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $f3TUk = parcelRequire("f3TUk");

var $fSYYZ = parcelRequire("fSYYZ");

var $gFD0E = parcelRequire("gFD0E");

var $bOxHY = parcelRequire("bOxHY");

var $6CL4g = parcelRequire("6CL4g");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $d90d26d9fbb651c2$var$TimerObservable = function(_super) {
    $d90d26d9fbb651c2$var$__extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) dueTime = 0;
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if ($f3TUk.isNumeric(period)) this.period = Number(period) < 1 && 1 || Number(period);
        else if ($bOxHY.isScheduler(period)) scheduler = period;
        if (!$bOxHY.isScheduler(scheduler)) scheduler = $gFD0E.async;
        this.scheduler = scheduler;
        this.dueTime = $6CL4g.isDate(dueTime) ? +dueTime - this.scheduler.now() : dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */ TimerObservable.create = function(initialDelay, period, scheduler) {
        if (initialDelay === void 0) initialDelay = 0;
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function(state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) return;
        else if (period === -1) return subscriber.complete();
        state.index = index + 1;
        action.schedule(state, period);
    };
    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index,
            period: period,
            subscriber: subscriber
        });
    };
    return TimerObservable;
}($fSYYZ.Observable);
module.exports.TimerObservable = $d90d26d9fbb651c2$var$TimerObservable;

});
parcelRegister("6CL4g", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $4d2acd61d6e22bb9$export$871608497c498473, (v) => $4d2acd61d6e22bb9$export$871608497c498473 = v);
var $4d2acd61d6e22bb9$export$871608497c498473;
"use strict";
function $4d2acd61d6e22bb9$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$4d2acd61d6e22bb9$export$871608497c498473 = $4d2acd61d6e22bb9$var$isDate;

});




parcelRegister("19zxt", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $jgRtC = parcelRequire("jgRtC");
$fSYYZ.Observable.zip = $jgRtC.zip;

});
parcelRegister("jgRtC", function(module, exports) {
$parcel$export(module.exports, "zip", () => $e078fe531e4f5186$export$8901015135f2fb22, (v) => $e078fe531e4f5186$export$8901015135f2fb22 = v);
var $e078fe531e4f5186$export$8901015135f2fb22;
"use strict";

var $713Wo = parcelRequire("713Wo");
$e078fe531e4f5186$export$8901015135f2fb22 = $713Wo.zipStatic;

});
parcelRegister("713Wo", function(module, exports) {
"use strict";
var $51bbaefb276eecb9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iLZ0l = parcelRequire("iLZ0l");

var $5G96M = parcelRequire("5G96M");

var $8qR8S = parcelRequire("8qR8S");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");

var $7lPC2 = parcelRequire("7lPC2");
/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $51bbaefb276eecb9$var$zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function zipOperatorFunction(source) {
        return source.lift.call($51bbaefb276eecb9$var$zipStatic.apply(void 0, [
            source
        ].concat(observables)));
    };
}
module.exports.zip = $51bbaefb276eecb9$var$zip;
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */ function $51bbaefb276eecb9$var$zipStatic() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = observables[observables.length - 1];
    if (typeof project === 'function') observables.pop();
    return new $iLZ0l.ArrayObservable(observables).lift(new $51bbaefb276eecb9$var$ZipOperator(project));
}
module.exports.zipStatic = $51bbaefb276eecb9$var$zipStatic;
var $51bbaefb276eecb9$var$ZipOperator = function() {
    function ZipOperator(project) {
        this.project = project;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $51bbaefb276eecb9$var$ZipSubscriber(subscriber, this.project));
    };
    return ZipOperator;
}();
module.exports.ZipOperator = $51bbaefb276eecb9$var$ZipOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $51bbaefb276eecb9$var$ZipSubscriber = function(_super) {
    $51bbaefb276eecb9$var$__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, project, values) {
        if (values === void 0) values = Object.create(null);
        _super.call(this, destination);
        this.iterators = [];
        this.active = 0;
        this.project = typeof project === 'function' ? project : null;
        this.values = values;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ($5G96M.isArray(value)) iterators.push(new $51bbaefb276eecb9$var$StaticArrayIterator(value));
        else if (typeof value[$7lPC2.iterator] === 'function') iterators.push(new $51bbaefb276eecb9$var$StaticIterator(value[$7lPC2.iterator]()));
        else iterators.push(new $51bbaefb276eecb9$var$ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) this.add(iterator.subscribe(iterator, i));
            else this.active--; // not an observable
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.project) this._tryProject(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}($8qR8S.Subscriber);
module.exports.ZipSubscriber = $51bbaefb276eecb9$var$ZipSubscriber;
var $51bbaefb276eecb9$var$StaticIterator = function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}();
var $51bbaefb276eecb9$var$StaticArrayIterator = function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[$7lPC2.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $51bbaefb276eecb9$var$ZipBufferIterator = function(_super) {
    $51bbaefb276eecb9$var$__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        _super.call(this, destination);
        this.parent = parent;
        this.observable = observable;
        this.stillUnsubscribed = true;
        this.buffer = [];
        this.isComplete = false;
    }
    ZipBufferIterator.prototype[$7lPC2.iterator] = function() {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function(value, index) {
        return $2Q6Ms.subscribeToResult(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}($9u1V0.OuterSubscriber);

});



parcelRegister("1K6IC", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $6ZfAz = parcelRequire("6ZfAz");
$fSYYZ.Observable.ajax = $6ZfAz.ajax;

});
parcelRegister("6ZfAz", function(module, exports) {
$parcel$export(module.exports, "ajax", () => $5164883536cfe73f$export$e68fce4c5f453854, (v) => $5164883536cfe73f$export$e68fce4c5f453854 = v);
var $5164883536cfe73f$export$e68fce4c5f453854;
"use strict";

var $ekYoH = parcelRequire("ekYoH");
$5164883536cfe73f$export$e68fce4c5f453854 = $ekYoH.AjaxObservable.create;

});
parcelRegister("ekYoH", function(module, exports) {
"use strict";
var $a701c8a1e28cb270$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9Cdpe = parcelRequire("9Cdpe");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $fSYYZ = parcelRequire("fSYYZ");

var $8qR8S = parcelRequire("8qR8S");

var $a8ocL = parcelRequire("a8ocL");
function $a701c8a1e28cb270$var$getCORSRequest() {
    if ($9Cdpe.root.XMLHttpRequest) return new $9Cdpe.root.XMLHttpRequest();
    else if (!!$9Cdpe.root.XDomainRequest) return new $9Cdpe.root.XDomainRequest();
    else throw new Error('CORS is not supported by your browser');
}
function $a701c8a1e28cb270$var$getXMLHttpRequest() {
    if ($9Cdpe.root.XMLHttpRequest) return new $9Cdpe.root.XMLHttpRequest();
    else {
        var progId = void 0;
        try {
            var progIds = [
                'Msxml2.XMLHTTP',
                'Microsoft.XMLHTTP',
                'Msxml2.XMLHTTP.4.0'
            ];
            for(var i = 0; i < 3; i++)try {
                progId = progIds[i];
                new $9Cdpe.root.ActiveXObject(progId);
                break;
            } catch (e) {}
            return new $9Cdpe.root.ActiveXObject(progId);
        } catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function $a701c8a1e28cb270$var$ajaxGet(url, headers) {
    if (headers === void 0) headers = null;
    return new $a701c8a1e28cb270$var$AjaxObservable({
        method: 'GET',
        url: url,
        headers: headers
    });
}
module.exports.ajaxGet = $a701c8a1e28cb270$var$ajaxGet;
function $a701c8a1e28cb270$var$ajaxPost(url, body, headers) {
    return new $a701c8a1e28cb270$var$AjaxObservable({
        method: 'POST',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPost = $a701c8a1e28cb270$var$ajaxPost;
function $a701c8a1e28cb270$var$ajaxDelete(url, headers) {
    return new $a701c8a1e28cb270$var$AjaxObservable({
        method: 'DELETE',
        url: url,
        headers: headers
    });
}
module.exports.ajaxDelete = $a701c8a1e28cb270$var$ajaxDelete;
function $a701c8a1e28cb270$var$ajaxPut(url, body, headers) {
    return new $a701c8a1e28cb270$var$AjaxObservable({
        method: 'PUT',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPut = $a701c8a1e28cb270$var$ajaxPut;
function $a701c8a1e28cb270$var$ajaxPatch(url, body, headers) {
    return new $a701c8a1e28cb270$var$AjaxObservable({
        method: 'PATCH',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPatch = $a701c8a1e28cb270$var$ajaxPatch;
var $a701c8a1e28cb270$var$mapResponse = $a8ocL.map(function(x, index) {
    return x.response;
});
function $a701c8a1e28cb270$var$ajaxGetJSON(url, headers) {
    return $a701c8a1e28cb270$var$mapResponse(new $a701c8a1e28cb270$var$AjaxObservable({
        method: 'GET',
        url: url,
        responseType: 'json',
        headers: headers
    }));
}
module.exports.ajaxGetJSON = $a701c8a1e28cb270$var$ajaxGetJSON;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $a701c8a1e28cb270$var$AjaxObservable = function(_super) {
    $a701c8a1e28cb270$var$__extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function() {
                return this.crossDomain ? $a701c8a1e28cb270$var$getCORSRequest.call(this) : $a701c8a1e28cb270$var$getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') request.url = urlOrRequest;
        else {
            for(var prop in urlOrRequest)if (urlOrRequest.hasOwnProperty(prop)) request[prop] = urlOrRequest[prop];
        }
        this.request = request;
    }
    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function(subscriber) {
        return new $a701c8a1e28cb270$var$AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */ AjaxObservable.create = function() {
        var create = function(urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = $a701c8a1e28cb270$var$ajaxGet;
        create.post = $a701c8a1e28cb270$var$ajaxPost;
        create.delete = $a701c8a1e28cb270$var$ajaxDelete;
        create.put = $a701c8a1e28cb270$var$ajaxPut;
        create.patch = $a701c8a1e28cb270$var$ajaxPatch;
        create.getJSON = $a701c8a1e28cb270$var$ajaxGetJSON;
        return create;
    }();
    return AjaxObservable;
}($fSYYZ.Observable);
module.exports.AjaxObservable = $a701c8a1e28cb270$var$AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a701c8a1e28cb270$var$AjaxSubscriber = function(_super) {
    $a701c8a1e28cb270$var$__extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) headers['X-Requested-With'] = 'XMLHttpRequest';
        // ensure content type is set
        if (!('Content-Type' in headers) && !($9Cdpe.root.FormData && request.body instanceof $9Cdpe.root.FormData) && typeof request.body !== 'undefined') headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
        this.send();
    }
    AjaxSubscriber.prototype.next = function(e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new $a701c8a1e28cb270$var$AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function() {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = $3XqeD.tryCatch(createXHR).call(request);
        if (xhr === $h0Tv0.errorObject) this.error($h0Tv0.errorObject.e);
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) result = $3XqeD.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            else result = $3XqeD.tryCatch(xhr.open).call(xhr, method, url, async);
            if (result === $h0Tv0.errorObject) {
                this.error($h0Tv0.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ('withCredentials' in xhr) xhr.withCredentials = !!request.withCredentials;
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? $3XqeD.tryCatch(xhr.send).call(xhr, body) : $3XqeD.tryCatch(xhr.send).call(xhr);
            if (result === $h0Tv0.errorObject) {
                this.error($h0Tv0.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function(body, contentType) {
        if (!body || typeof body === 'string') return body;
        else if ($9Cdpe.root.FormData && body instanceof $9Cdpe.root.FormData) return body;
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) contentType = contentType.substring(0, splitIndex);
        }
        switch(contentType){
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function(key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
                }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function(xhr, headers) {
        for(var key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    };
    AjaxSubscriber.prototype.setupEvents = function(xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) progressSubscriber.error(e);
            subscriber.error(new $a701c8a1e28cb270$var$AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function(e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if ($9Cdpe.root.XDomainRequest) xhr.onprogress = xhrProgress_1;
                else xhr.upload.onprogress = xhrProgress_1;
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function(e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) progressSubscriber.error(e);
                subscriber.error(new $a701c8a1e28cb270$var$AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = this.responseType === 'text' ? this.response || this.responseText : this.response;
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) status_1 = response ? 200 : 0;
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) progressSubscriber.complete();
                    subscriber.next(e);
                    subscriber.complete();
                } else {
                    if (progressSubscriber) progressSubscriber.error(e);
                    subscriber.error(new $a701c8a1e28cb270$var$AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function() {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') xhr.abort();
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}($8qR8S.Subscriber);
module.exports.AjaxSubscriber = $a701c8a1e28cb270$var$AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */ var $a701c8a1e28cb270$var$AjaxResponse = function() {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $a701c8a1e28cb270$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}();
module.exports.AjaxResponse = $a701c8a1e28cb270$var$AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */ var $a701c8a1e28cb270$var$AjaxError = function(_super) {
    $a701c8a1e28cb270$var$__extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $a701c8a1e28cb270$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxError;
}(Error);
module.exports.AjaxError = $a701c8a1e28cb270$var$AjaxError;
function $a701c8a1e28cb270$var$parseXhrResponse(responseType, xhr) {
    switch(responseType){
        case 'json':
            if ('response' in xhr) //IE does not support json as responseType, parse it internally
            return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
            else // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return JSON.parse(xhr.responseText || 'null');
        case 'xml':
            return xhr.responseXML;
        case 'text':
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return 'response' in xhr ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */ var $a701c8a1e28cb270$var$AjaxTimeoutError = function(_super) {
    $a701c8a1e28cb270$var$__extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, 'ajax timeout', xhr, request);
    }
    return AjaxTimeoutError;
}($a701c8a1e28cb270$var$AjaxError);
module.exports.AjaxTimeoutError = $a701c8a1e28cb270$var$AjaxTimeoutError;

});



parcelRegister("awnCy", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $afL7Z = parcelRequire("afL7Z");
$fSYYZ.Observable.webSocket = $afL7Z.webSocket;

});
parcelRegister("afL7Z", function(module, exports) {
$parcel$export(module.exports, "webSocket", () => $776fdcb5d8959fa6$export$debf5095acd2163f, (v) => $776fdcb5d8959fa6$export$debf5095acd2163f = v);
var $776fdcb5d8959fa6$export$debf5095acd2163f;
"use strict";

var $54qeQ = parcelRequire("54qeQ");
$776fdcb5d8959fa6$export$debf5095acd2163f = $54qeQ.WebSocketSubject.create;

});
parcelRegister("54qeQ", function(module, exports) {
"use strict";
var $3b11ade12b890683$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $8qR8S = parcelRequire("8qR8S");

var $fSYYZ = parcelRequire("fSYYZ");

var $aBkDT = parcelRequire("aBkDT");

var $9Cdpe = parcelRequire("9Cdpe");

var $1PAG0 = parcelRequire("1PAG0");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $9Y7Ai = parcelRequire("9Y7Ai");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $3b11ade12b890683$var$WebSocketSubject = function(_super) {
    $3b11ade12b890683$var$__extends(WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
        if (urlConfigOrSource instanceof $fSYYZ.Observable) _super.call(this, destination, urlConfigOrSource);
        else {
            _super.call(this);
            this.WebSocketCtor = $9Cdpe.root.WebSocket;
            this._output = new $bTlA1.Subject();
            if (typeof urlConfigOrSource === 'string') this.url = urlConfigOrSource;
            else // WARNING: config object could override important members here.
            $9Y7Ai.assign(this, urlConfigOrSource);
            if (!this.WebSocketCtor) throw new Error('no WebSocket constructor can be found');
            this.destination = new $1PAG0.ReplaySubject();
        }
    }
    WebSocketSubject.prototype.resultSelector = function(e) {
        return JSON.parse(e.data);
    };
    /**
     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
     *
     * @example <caption>Wraps browser WebSocket</caption>
     *
     * let socket$ = Observable.webSocket('ws://localhost:8081');
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
     *
     * import { w3cwebsocket } from 'websocket';
     *
     * let socket$ = Observable.webSocket({
     *   url: 'ws://localhost:8081',
     *   WebSocketCtor: w3cwebsocket
     * });
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
     * @return {WebSocketSubject}
     * @static true
     * @name webSocket
     * @owner Observable
     */ WebSocketSubject.create = function(urlConfigOrSource) {
        return new WebSocketSubject(urlConfigOrSource);
    };
    WebSocketSubject.prototype.lift = function(operator) {
        var sock = new WebSocketSubject(this, this.destination);
        sock.operator = operator;
        return sock;
    };
    WebSocketSubject.prototype._resetState = function() {
        this.socket = null;
        if (!this.source) this.destination = new $1PAG0.ReplaySubject();
        this._output = new $bTlA1.Subject();
    };
    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
    WebSocketSubject.prototype.multiplex = function(subMsg, unsubMsg, messageFilter) {
        var self = this;
        return new $fSYYZ.Observable(function(observer) {
            var result = $3XqeD.tryCatch(subMsg)();
            if (result === $h0Tv0.errorObject) observer.error($h0Tv0.errorObject.e);
            else self.next(result);
            var subscription = self.subscribe(function(x) {
                var result = $3XqeD.tryCatch(messageFilter)(x);
                if (result === $h0Tv0.errorObject) observer.error($h0Tv0.errorObject.e);
                else if (result) observer.next(x);
            }, function(err) {
                return observer.error(err);
            }, function() {
                return observer.complete();
            });
            return function() {
                var result = $3XqeD.tryCatch(unsubMsg)();
                if (result === $h0Tv0.errorObject) observer.error($h0Tv0.errorObject.e);
                else self.next(result);
                subscription.unsubscribe();
            };
        });
    };
    WebSocketSubject.prototype._connectSocket = function() {
        var _this = this;
        var WebSocketCtor = this.WebSocketCtor;
        var observer = this._output;
        var socket = null;
        try {
            socket = this.protocol ? new WebSocketCtor(this.url, this.protocol) : new WebSocketCtor(this.url);
            this.socket = socket;
            if (this.binaryType) this.socket.binaryType = this.binaryType;
        } catch (e) {
            observer.error(e);
            return;
        }
        var subscription = new $aBkDT.Subscription(function() {
            _this.socket = null;
            if (socket && socket.readyState === 1) socket.close();
        });
        socket.onopen = function(e) {
            var openObserver = _this.openObserver;
            if (openObserver) openObserver.next(e);
            var queue = _this.destination;
            _this.destination = $8qR8S.Subscriber.create(function(x) {
                return socket.readyState === 1 && socket.send(x);
            }, function(e) {
                var closingObserver = _this.closingObserver;
                if (closingObserver) closingObserver.next(undefined);
                if (e && e.code) socket.close(e.code, e.reason);
                else observer.error(new TypeError("WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }"));
                _this._resetState();
            }, function() {
                var closingObserver = _this.closingObserver;
                if (closingObserver) closingObserver.next(undefined);
                socket.close();
                _this._resetState();
            });
            if (queue && queue instanceof $1PAG0.ReplaySubject) subscription.add(queue.subscribe(_this.destination));
        };
        socket.onerror = function(e) {
            _this._resetState();
            observer.error(e);
        };
        socket.onclose = function(e) {
            _this._resetState();
            var closeObserver = _this.closeObserver;
            if (closeObserver) closeObserver.next(e);
            if (e.wasClean) observer.complete();
            else observer.error(e);
        };
        socket.onmessage = function(e) {
            var result = $3XqeD.tryCatch(_this.resultSelector)(e);
            if (result === $h0Tv0.errorObject) observer.error($h0Tv0.errorObject.e);
            else observer.next(result);
        };
    };
    /** @deprecated internal use only */ WebSocketSubject.prototype._subscribe = function(subscriber) {
        var _this = this;
        var source = this.source;
        if (source) return source.subscribe(subscriber);
        if (!this.socket) this._connectSocket();
        var subscription = new $aBkDT.Subscription();
        subscription.add(this._output.subscribe(subscriber));
        subscription.add(function() {
            var socket = _this.socket;
            if (_this._output.observers.length === 0) {
                if (socket && socket.readyState === 1) socket.close();
                _this._resetState();
            }
        });
        return subscription;
    };
    WebSocketSubject.prototype.unsubscribe = function() {
        var _a = this, source = _a.source, socket = _a.socket;
        if (socket && socket.readyState === 1) {
            socket.close();
            this._resetState();
        }
        _super.prototype.unsubscribe.call(this);
        if (!source) this.destination = new $1PAG0.ReplaySubject();
    };
    return WebSocketSubject;
}($bTlA1.AnonymousSubject);
module.exports.WebSocketSubject = $3b11ade12b890683$var$WebSocketSubject;

});
parcelRegister("9Y7Ai", function(module, exports) {
$parcel$export(module.exports, "assign", () => $741f99c1e4d429d0$export$e6e34fd1f2686227, (v) => $741f99c1e4d429d0$export$e6e34fd1f2686227 = v);
var $741f99c1e4d429d0$export$b668effad3120ef4;
var $741f99c1e4d429d0$export$e4f7f8fe212de33b;
var $741f99c1e4d429d0$export$e6e34fd1f2686227;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");
function $741f99c1e4d429d0$var$assignImpl(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    var len = sources.length;
    for(var i = 0; i < len; i++){
        var source = sources[i];
        for(var k in source)if (source.hasOwnProperty(k)) target[k] = source[k];
    }
    return target;
}
$741f99c1e4d429d0$export$b668effad3120ef4 = $741f99c1e4d429d0$var$assignImpl;
function $741f99c1e4d429d0$var$getAssign(root) {
    return root.Object.assign || $741f99c1e4d429d0$var$assignImpl;
}
$741f99c1e4d429d0$export$e4f7f8fe212de33b = $741f99c1e4d429d0$var$getAssign;
$741f99c1e4d429d0$export$e6e34fd1f2686227 = $741f99c1e4d429d0$var$getAssign($9Cdpe.root);

});




parcelRegister("h6DNT", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $l4EOE = parcelRequire("l4EOE");
$fSYYZ.Observable.prototype.buffer = $l4EOE.buffer;

});
parcelRegister("l4EOE", function(module, exports) {
$parcel$export(module.exports, "buffer", () => $f579a1ded1d3a0ba$export$ab1029bcae9ddb4a, (v) => $f579a1ded1d3a0ba$export$ab1029bcae9ddb4a = v);
var $f579a1ded1d3a0ba$export$ab1029bcae9ddb4a;
"use strict";

var $4e1E9 = parcelRequire("4e1E9");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function $f579a1ded1d3a0ba$var$buffer(closingNotifier) {
    return $4e1E9.buffer(closingNotifier)(this);
}
$f579a1ded1d3a0ba$export$ab1029bcae9ddb4a = $f579a1ded1d3a0ba$var$buffer;

});
parcelRegister("4e1E9", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
exports.buffer = buffer;
var BufferOperator = function() {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var BufferSubscriber = function(_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add($2Q6Ms.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("7unGx", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $bfFn3 = parcelRequire("bfFn3");
$fSYYZ.Observable.prototype.bufferCount = $bfFn3.bufferCount;

});
parcelRegister("bfFn3", function(module, exports) {
$parcel$export(module.exports, "bufferCount", () => $83112fca149d7cc2$export$8916d2c8119541bb, (v) => $83112fca149d7cc2$export$8916d2c8119541bb = v);
var $83112fca149d7cc2$export$8916d2c8119541bb;
"use strict";

var $ezyFF = parcelRequire("ezyFF");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $83112fca149d7cc2$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return $ezyFF.bufferCount(bufferSize, startBufferEvery)(this);
}
$83112fca149d7cc2$export$8916d2c8119541bb = $83112fca149d7cc2$var$bufferCount;

});


parcelRegister("7VEUR", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $83pdG = parcelRequire("83pdG");
$fSYYZ.Observable.prototype.bufferTime = $83pdG.bufferTime;

});
parcelRegister("83pdG", function(module, exports) {
$parcel$export(module.exports, "bufferTime", () => $5dd22aa3867a8a34$export$d6b40c95035461c7, (v) => $5dd22aa3867a8a34$export$d6b40c95035461c7 = v);
var $5dd22aa3867a8a34$export$d6b40c95035461c7;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $bOxHY = parcelRequire("bOxHY");

var $6WyH7 = parcelRequire("6WyH7");
/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $5dd22aa3867a8a34$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $gFD0E.async;
    if ($bOxHY.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return $6WyH7.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
}
$5dd22aa3867a8a34$export$d6b40c95035461c7 = $5dd22aa3867a8a34$var$bufferTime;

});
parcelRegister("6WyH7", function(module, exports) {
"use strict";
var $50e31276058e13a2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gFD0E = parcelRequire("gFD0E");

var $8qR8S = parcelRequire("8qR8S");

var $bOxHY = parcelRequire("bOxHY");
/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $50e31276058e13a2$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $gFD0E.async;
    if ($bOxHY.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new $50e31276058e13a2$var$BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
module.exports.bufferTime = $50e31276058e13a2$var$bufferTime;
var $50e31276058e13a2$var$BufferTimeOperator = function() {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $50e31276058e13a2$var$BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}();
var $50e31276058e13a2$var$Context = function() {
    function Context() {
        this.buffer = [];
    }
    return Context;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $50e31276058e13a2$var$BufferTimeSubscriber = function(_super) {
    $50e31276058e13a2$var$__extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = scheduler.schedule($50e31276058e13a2$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        } else {
            var closeState = {
                subscriber: this,
                context: context
            };
            var creationState = {
                bufferTimeSpan: bufferTimeSpan,
                bufferCreationInterval: bufferCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(context.closeAction = scheduler.schedule($50e31276058e13a2$var$dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule($50e31276058e13a2$var$dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for(var i = 0; i < len; i++){
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) filledBufferContext = context;
        }
        if (filledBufferContext) this.onBufferFull(filledBufferContext);
    };
    BufferTimeSubscriber.prototype._error = function(err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function() {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while(contexts.length > 0){
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function() {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function(context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = this.scheduler.schedule($50e31276058e13a2$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function() {
        var context = new $50e31276058e13a2$var$Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function(context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) contexts.splice(contexts.indexOf(context), 1);
    };
    return BufferTimeSubscriber;
}($8qR8S.Subscriber);
function $50e31276058e13a2$var$dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) subscriber.closeContext(prevContext);
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function $50e31276058e13a2$var$dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule($50e31276058e13a2$var$dispatchBufferClose, bufferTimeSpan, {
            subscriber: subscriber,
            context: context
        }));
        action.schedule(state, bufferCreationInterval);
    }
}
function $50e31276058e13a2$var$dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}

});



parcelRegister("hZdSJ", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hsXdr = parcelRequire("hsXdr");
$fSYYZ.Observable.prototype.bufferToggle = $hsXdr.bufferToggle;

});
parcelRegister("hsXdr", function(module, exports) {
$parcel$export(module.exports, "bufferToggle", () => $03480c536534c589$export$91115bdd8709945f, (v) => $03480c536534c589$export$91115bdd8709945f = v);
var $03480c536534c589$export$91115bdd8709945f;
"use strict";

var $bTHFX = parcelRequire("bTHFX");
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $03480c536534c589$var$bufferToggle(openings, closingSelector) {
    return $bTHFX.bufferToggle(openings, closingSelector)(this);
}
$03480c536534c589$export$91115bdd8709945f = $03480c536534c589$var$bufferToggle;

});
parcelRegister("bTHFX", function(module, exports) {
"use strict";
var $8a96b5d5b64e017b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aBkDT = parcelRequire("aBkDT");

var $2Q6Ms = parcelRequire("2Q6Ms");

var $9u1V0 = parcelRequire("9u1V0");
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $8a96b5d5b64e017b$var$bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new $8a96b5d5b64e017b$var$BufferToggleOperator(openings, closingSelector));
    };
}
module.exports.bufferToggle = $8a96b5d5b64e017b$var$bufferToggle;
var $8a96b5d5b64e017b$var$BufferToggleOperator = function() {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8a96b5d5b64e017b$var$BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8a96b5d5b64e017b$var$BufferToggleSubscriber = function(_super) {
    $8a96b5d5b64e017b$var$__extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add($2Q6Ms.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for(var i = 0; i < len; i++)contexts[i].buffer.push(value);
    };
    BufferToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function(innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function(value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) this.trySubscribe(closingNotifier);
        } catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function(context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function(closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new $aBkDT.Subscription();
        var context = {
            buffer: buffer,
            subscription: subscription
        };
        contexts.push(context);
        var innerSubscription = $2Q6Ms.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) this.closeBuffer(context);
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("4aEZK", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $ee9Ch = parcelRequire("ee9Ch");
$fSYYZ.Observable.prototype.bufferWhen = $ee9Ch.bufferWhen;

});
parcelRegister("ee9Ch", function(module, exports) {
$parcel$export(module.exports, "bufferWhen", () => $a5b9d521a1d5a60f$export$9e55760d3282e08c, (v) => $a5b9d521a1d5a60f$export$9e55760d3282e08c = v);
var $a5b9d521a1d5a60f$export$9e55760d3282e08c;
"use strict";

var $7PyRa = parcelRequire("7PyRa");
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $a5b9d521a1d5a60f$var$bufferWhen(closingSelector) {
    return $7PyRa.bufferWhen(closingSelector)(this);
}
$a5b9d521a1d5a60f$export$9e55760d3282e08c = $a5b9d521a1d5a60f$var$bufferWhen;

});
parcelRegister("7PyRa", function(module, exports) {
"use strict";
var $5b385596fc7b1b95$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aBkDT = parcelRequire("aBkDT");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $5b385596fc7b1b95$var$bufferWhen(closingSelector) {
    return function(source) {
        return source.lift(new $5b385596fc7b1b95$var$BufferWhenOperator(closingSelector));
    };
}
module.exports.bufferWhen = $5b385596fc7b1b95$var$bufferWhen;
var $5b385596fc7b1b95$var$BufferWhenOperator = function() {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5b385596fc7b1b95$var$BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5b385596fc7b1b95$var$BufferWhenSubscriber = function(_super) {
    $5b385596fc7b1b95$var$__extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function() {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function() {
        if (this.subscribing) this.complete();
        else this.openBuffer();
    };
    BufferWhenSubscriber.prototype.openBuffer = function() {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) this.destination.next(buffer);
        this.buffer = [];
        var closingNotifier = $3XqeD.tryCatch(this.closingSelector)();
        if (closingNotifier === $h0Tv0.errorObject) this.error($h0Tv0.errorObject.e);
        else {
            closingSubscription = new $aBkDT.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add($2Q6Ms.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("eGN1M", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $8JXtA = parcelRequire("8JXtA");
$fSYYZ.Observable.prototype.catch = $8JXtA._catch;
$fSYYZ.Observable.prototype._catch = $8JXtA._catch;

});
parcelRegister("8JXtA", function(module, exports) {
$parcel$export(module.exports, "_catch", () => $65d0a97572d41d37$export$7f43fa37c3d8a0b3, (v) => $65d0a97572d41d37$export$7f43fa37c3d8a0b3 = v);
var $65d0a97572d41d37$export$7f43fa37c3d8a0b3;
"use strict";

var $8fIcg = parcelRequire("8fIcg");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */ function $65d0a97572d41d37$var$_catch(selector) {
    return $8fIcg.catchError(selector)(this);
}
$65d0a97572d41d37$export$7f43fa37c3d8a0b3 = $65d0a97572d41d37$var$_catch;

});
parcelRegister("8fIcg", function(module, exports) {
"use strict";
var $60220203e2942673$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $60220203e2942673$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $60220203e2942673$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $60220203e2942673$var$catchError;
var $60220203e2942673$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $60220203e2942673$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $60220203e2942673$var$CatchSubscriber = function(_super) {
    $60220203e2942673$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($2Q6Ms.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("9sfh1", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $dawoG = parcelRequire("dawoG");
$fSYYZ.Observable.prototype.combineAll = $dawoG.combineAll;

});
parcelRegister("dawoG", function(module, exports) {
$parcel$export(module.exports, "combineAll", () => $996556f27f4984d1$export$29ae691b7de52fe3, (v) => $996556f27f4984d1$export$29ae691b7de52fe3 = v);
var $996556f27f4984d1$export$29ae691b7de52fe3;
"use strict";

var $dMuCG = parcelRequire("dMuCG");
/**
 * Converts a higher-order Observable into a first-order Observable by waiting
 * for the outer Observable to complete, then applying {@link combineLatest}.
 *
 * <span class="informal">Flattens an Observable-of-Observables by applying
 * {@link combineLatest} when the Observable-of-Observables completes.</span>
 *
 * <img src="./img/combineAll.png" width="100%">
 *
 * Takes an Observable of Observables, and collects all Observables from it.
 * Once the outer Observable completes, it subscribes to all collected
 * Observables and combines their values using the {@link combineLatest}
 * strategy, such that:
 * - Every time an inner Observable emits, the output Observable emits.
 * - When the returned observable emits, it emits all of the latest values by:
 *   - If a `project` function is provided, it is called with each recent value
 *     from each inner Observable in whatever order they arrived, and the result
 *     of the `project` function is what is emitted by the output Observable.
 *   - If there is no `project` function, an array of all of the most recent
 *     values is emitted by the output Observable.
 *
 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev =>
 *   Rx.Observable.interval(Math.random()*2000).take(3)
 * ).take(2);
 * var result = higherOrder.combineAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 * @see {@link mergeAll}
 *
 * @param {function} [project] An optional function to map the most recent
 * values from each inner Observable into a new result. Takes each of the most
 * recent values from each collected inner Observable as arguments, in order.
 * @return {Observable} An Observable of projected results or arrays of recent
 * values.
 * @method combineAll
 * @owner Observable
 */ function $996556f27f4984d1$var$combineAll(project) {
    return $dMuCG.combineAll(project)(this);
}
$996556f27f4984d1$export$29ae691b7de52fe3 = $996556f27f4984d1$var$combineAll;

});
parcelRegister("dMuCG", function(module, exports) {
$parcel$export(module.exports, "combineAll", () => $a0878327b5091242$export$29ae691b7de52fe3, (v) => $a0878327b5091242$export$29ae691b7de52fe3 = v);
var $a0878327b5091242$export$29ae691b7de52fe3;
"use strict";

var $gVAew = parcelRequire("gVAew");
function $a0878327b5091242$var$combineAll(project) {
    return function(source) {
        return source.lift(new $gVAew.CombineLatestOperator(project));
    };
}
$a0878327b5091242$export$29ae691b7de52fe3 = $a0878327b5091242$var$combineAll;

});



parcelRegister("bnzpL", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $7LUIm = parcelRequire("7LUIm");
$fSYYZ.Observable.prototype.combineLatest = $7LUIm.combineLatest;

});
parcelRegister("7LUIm", function(module, exports) {
$parcel$export(module.exports, "combineLatest", () => $5a88ea84ce22d939$export$77fa7d86f5204e8a, (v) => $5a88ea84ce22d939$export$77fa7d86f5204e8a = v);
var $5a88ea84ce22d939$export$77fa7d86f5204e8a;
"use strict";

var $gVAew = parcelRequire("gVAew");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $5a88ea84ce22d939$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $gVAew.combineLatest.apply(void 0, observables)(this);
}
$5a88ea84ce22d939$export$77fa7d86f5204e8a = $5a88ea84ce22d939$var$combineLatest;

});


parcelRegister("atLdb", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $khZQz = parcelRequire("khZQz");
$fSYYZ.Observable.prototype.concat = $khZQz.concat;

});
parcelRegister("khZQz", function(module, exports) {
$parcel$export(module.exports, "concat", () => $ec555eaf81071370$export$ee1b3e54f0441b22, (v) => $ec555eaf81071370$export$ee1b3e54f0441b22 = v);
var $ec555eaf81071370$export$9343b684b018b33a;
var $ec555eaf81071370$export$ee1b3e54f0441b22;
"use strict";

var $3cyYk = parcelRequire("3cyYk");

var $jpGTf = parcelRequire("jpGTf");
$ec555eaf81071370$export$9343b684b018b33a = $jpGTf.concat;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $ec555eaf81071370$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $3cyYk.concat.apply(void 0, observables)(this);
}
$ec555eaf81071370$export$ee1b3e54f0441b22 = $ec555eaf81071370$var$concat;

});
parcelRegister("3cyYk", function(module, exports) {
$parcel$export(module.exports, "concat", () => $254d9eceef3b8d9f$export$ee1b3e54f0441b22, (v) => $254d9eceef3b8d9f$export$ee1b3e54f0441b22 = v);
var $254d9eceef3b8d9f$export$9343b684b018b33a;
var $254d9eceef3b8d9f$export$ee1b3e54f0441b22;
"use strict";

var $jpGTf = parcelRequire("jpGTf");

var $jpGTf = parcelRequire("jpGTf");
$254d9eceef3b8d9f$export$9343b684b018b33a = $jpGTf.concat;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $254d9eceef3b8d9f$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($jpGTf.concat.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$254d9eceef3b8d9f$export$ee1b3e54f0441b22 = $254d9eceef3b8d9f$var$concat;

});



parcelRegister("krlKV", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $1YFIw = parcelRequire("1YFIw");
$fSYYZ.Observable.prototype.concatAll = $1YFIw.concatAll;

});
parcelRegister("1YFIw", function(module, exports) {
$parcel$export(module.exports, "concatAll", () => $170bc12c0c6b67ca$export$b314777ae20abca9, (v) => $170bc12c0c6b67ca$export$b314777ae20abca9 = v);
var $170bc12c0c6b67ca$export$b314777ae20abca9;
"use strict";

var $dS4Ly = parcelRequire("dS4Ly");
/* tslint:enable:max-line-length */ /**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $170bc12c0c6b67ca$var$concatAll() {
    return $dS4Ly.concatAll()(this);
}
$170bc12c0c6b67ca$export$b314777ae20abca9 = $170bc12c0c6b67ca$var$concatAll;

});


parcelRegister("7OsES", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $iDiUl = parcelRequire("iDiUl");
$fSYYZ.Observable.prototype.concatMap = $iDiUl.concatMap;

});
parcelRegister("iDiUl", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $d90a893175357077$export$c28c8388be0ab31a, (v) => $d90a893175357077$export$c28c8388be0ab31a = v);
var $d90a893175357077$export$c28c8388be0ab31a;
"use strict";

var $6xf0A = parcelRequire("6xf0A");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $d90a893175357077$var$concatMap(project, resultSelector) {
    return $6xf0A.concatMap(project, resultSelector)(this);
}
$d90a893175357077$export$c28c8388be0ab31a = $d90a893175357077$var$concatMap;

});


parcelRegister("cAqrV", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $2kqkg = parcelRequire("2kqkg");
$fSYYZ.Observable.prototype.concatMapTo = $2kqkg.concatMapTo;

});
parcelRegister("2kqkg", function(module, exports) {
$parcel$export(module.exports, "concatMapTo", () => $1b21decaec61cde3$export$82fbd7a2841d2484, (v) => $1b21decaec61cde3$export$82fbd7a2841d2484 = v);
var $1b21decaec61cde3$export$82fbd7a2841d2484;
"use strict";

var $60MEq = parcelRequire("60MEq");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $1b21decaec61cde3$var$concatMapTo(innerObservable, resultSelector) {
    return $60MEq.concatMapTo(innerObservable, resultSelector)(this);
}
$1b21decaec61cde3$export$82fbd7a2841d2484 = $1b21decaec61cde3$var$concatMapTo;

});
parcelRegister("60MEq", function(module, exports) {
$parcel$export(module.exports, "concatMapTo", () => $46087b3ace27727a$export$82fbd7a2841d2484, (v) => $46087b3ace27727a$export$82fbd7a2841d2484 = v);
var $46087b3ace27727a$export$82fbd7a2841d2484;
"use strict";

var $6xf0A = parcelRequire("6xf0A");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $46087b3ace27727a$var$concatMapTo(innerObservable, resultSelector) {
    return $6xf0A.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$46087b3ace27727a$export$82fbd7a2841d2484 = $46087b3ace27727a$var$concatMapTo;

});



parcelRegister("80uDu", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $3Uqtw = parcelRequire("3Uqtw");
$fSYYZ.Observable.prototype.count = $3Uqtw.count;

});
parcelRegister("3Uqtw", function(module, exports) {
$parcel$export(module.exports, "count", () => $2d8b237b6c9ba228$export$85b9a36db797e02b, (v) => $2d8b237b6c9ba228$export$85b9a36db797e02b = v);
var $2d8b237b6c9ba228$export$85b9a36db797e02b;
"use strict";

var $9EKxB = parcelRequire("9EKxB");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function $2d8b237b6c9ba228$var$count(predicate) {
    return $9EKxB.count(predicate)(this);
}
$2d8b237b6c9ba228$export$85b9a36db797e02b = $2d8b237b6c9ba228$var$count;

});
parcelRegister("9EKxB", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("4bhYG", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $22SVH = parcelRequire("22SVH");
$fSYYZ.Observable.prototype.dematerialize = $22SVH.dematerialize;

});
parcelRegister("22SVH", function(module, exports) {
$parcel$export(module.exports, "dematerialize", () => $17d6608819b39ee9$export$ab9a5985b741fa7a, (v) => $17d6608819b39ee9$export$ab9a5985b741fa7a = v);
var $17d6608819b39ee9$export$ab9a5985b741fa7a;
"use strict";

var $6fPE8 = parcelRequire("6fPE8");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $17d6608819b39ee9$var$dematerialize() {
    return $6fPE8.dematerialize()(this);
}
$17d6608819b39ee9$export$ab9a5985b741fa7a = $17d6608819b39ee9$var$dematerialize;

});
parcelRegister("6fPE8", function(module, exports) {
"use strict";
var $48dc34b339fd6b29$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $48dc34b339fd6b29$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $48dc34b339fd6b29$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $48dc34b339fd6b29$var$dematerialize;
var $48dc34b339fd6b29$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $48dc34b339fd6b29$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $48dc34b339fd6b29$var$DeMaterializeSubscriber = function(_super) {
    $48dc34b339fd6b29$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("kFeFV", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $kGBXJ = parcelRequire("kGBXJ");
$fSYYZ.Observable.prototype.debounce = $kGBXJ.debounce;

});
parcelRegister("kGBXJ", function(module, exports) {
$parcel$export(module.exports, "debounce", () => $f0f52d72dbca08ae$export$61fc7d43ac8f84b0, (v) => $f0f52d72dbca08ae$export$61fc7d43ac8f84b0 = v);
var $f0f52d72dbca08ae$export$61fc7d43ac8f84b0;
"use strict";

var $7y17I = parcelRequire("7y17I");
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $f0f52d72dbca08ae$var$debounce(durationSelector) {
    return $7y17I.debounce(durationSelector)(this);
}
$f0f52d72dbca08ae$export$61fc7d43ac8f84b0 = $f0f52d72dbca08ae$var$debounce;

});
parcelRegister("7y17I", function(module, exports) {
"use strict";
var $57ec947d7c79fbce$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $57ec947d7c79fbce$var$debounce(durationSelector) {
    return function(source) {
        return source.lift(new $57ec947d7c79fbce$var$DebounceOperator(durationSelector));
    };
}
module.exports.debounce = $57ec947d7c79fbce$var$debounce;
var $57ec947d7c79fbce$var$DebounceOperator = function() {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $57ec947d7c79fbce$var$DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $57ec947d7c79fbce$var$DebounceSubscriber = function(_super) {
    $57ec947d7c79fbce$var$__extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function(value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) this._tryNext(value, result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function() {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function(value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = $2Q6Ms.subscribeToResult(this, duration);
        if (!subscription.closed) this.add(this.durationSubscription = subscription);
    };
    DebounceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("1S12b", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $ii6F1 = parcelRequire("ii6F1");
$fSYYZ.Observable.prototype.debounceTime = $ii6F1.debounceTime;

});
parcelRegister("ii6F1", function(module, exports) {
$parcel$export(module.exports, "debounceTime", () => $d50f131bb2400bd1$export$7843a4469d64c07e, (v) => $d50f131bb2400bd1$export$7843a4469d64c07e = v);
var $d50f131bb2400bd1$export$7843a4469d64c07e;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $bTpsd = parcelRequire("bTpsd");
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $d50f131bb2400bd1$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $bTpsd.debounceTime(dueTime, scheduler)(this);
}
$d50f131bb2400bd1$export$7843a4469d64c07e = $d50f131bb2400bd1$var$debounceTime;

});
parcelRegister("bTpsd", function(module, exports) {
"use strict";
var $8a889367087814e9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $gFD0E = parcelRequire("gFD0E");
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $8a889367087814e9$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return function(source) {
        return source.lift(new $8a889367087814e9$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $8a889367087814e9$var$debounceTime;
var $8a889367087814e9$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8a889367087814e9$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8a889367087814e9$var$DebounceTimeSubscriber = function(_super) {
    $8a889367087814e9$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($8a889367087814e9$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($8qR8S.Subscriber);
function $8a889367087814e9$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

});



parcelRegister("9TWxp", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $gAcc0 = parcelRequire("gAcc0");
$fSYYZ.Observable.prototype.defaultIfEmpty = $gAcc0.defaultIfEmpty;

});
parcelRegister("gAcc0", function(module, exports) {
$parcel$export(module.exports, "defaultIfEmpty", () => $c129775483c05e9a$export$e4ca6d7b7a6dcf9b, (v) => $c129775483c05e9a$export$e4ca6d7b7a6dcf9b = v);
var $c129775483c05e9a$export$e4ca6d7b7a6dcf9b;
"use strict";

var $7c96M = parcelRequire("7c96M");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $c129775483c05e9a$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return $7c96M.defaultIfEmpty(defaultValue)(this);
}
$c129775483c05e9a$export$e4ca6d7b7a6dcf9b = $c129775483c05e9a$var$defaultIfEmpty;

});
parcelRegister("7c96M", function(module, exports) {
"use strict";
var $53d0b81c35d80251$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $53d0b81c35d80251$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $53d0b81c35d80251$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $53d0b81c35d80251$var$defaultIfEmpty;
var $53d0b81c35d80251$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $53d0b81c35d80251$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $53d0b81c35d80251$var$DefaultIfEmptySubscriber = function(_super) {
    $53d0b81c35d80251$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("kYxIu", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $6I5sP = parcelRequire("6I5sP");
$fSYYZ.Observable.prototype.delay = $6I5sP.delay;

});
parcelRegister("6I5sP", function(module, exports) {
$parcel$export(module.exports, "delay", () => $4e2b172f82bc1550$export$1391212d75b2ee65, (v) => $4e2b172f82bc1550$export$1391212d75b2ee65 = v);
var $4e2b172f82bc1550$export$1391212d75b2ee65;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $dQaXZ = parcelRequire("dQaXZ");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function $4e2b172f82bc1550$var$delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $dQaXZ.delay(delay, scheduler)(this);
}
$4e2b172f82bc1550$export$1391212d75b2ee65 = $4e2b172f82bc1550$var$delay;

});
parcelRegister("dQaXZ", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gFD0E = parcelRequire("gFD0E");

var $6CL4g = parcelRequire("6CL4g");

var $8qR8S = parcelRequire("8qR8S");

var $hGDIR = parcelRequire("hGDIR");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    var absoluteDelay = $6CL4g.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($hGDIR.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($hGDIR.Notification.createComplete());
    };
    return DelaySubscriber;
}($8qR8S.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});



parcelRegister("iu70Q", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $3aRtj = parcelRequire("3aRtj");
$fSYYZ.Observable.prototype.delayWhen = $3aRtj.delayWhen;

});
parcelRegister("3aRtj", function(module, exports) {
$parcel$export(module.exports, "delayWhen", () => $24fbc8a398eca80a$export$286ca829307725c9, (v) => $24fbc8a398eca80a$export$286ca829307725c9 = v);
var $24fbc8a398eca80a$export$286ca829307725c9;
"use strict";

var $2QM38 = parcelRequire("2QM38");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $24fbc8a398eca80a$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    return $2QM38.delayWhen(delayDurationSelector, subscriptionDelay)(this);
}
$24fbc8a398eca80a$export$286ca829307725c9 = $24fbc8a398eca80a$var$delayWhen;

});
parcelRegister("2QM38", function(module, exports) {
"use strict";
var $2135b5bc36011e64$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $fSYYZ = parcelRequire("fSYYZ");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $2135b5bc36011e64$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $2135b5bc36011e64$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $2135b5bc36011e64$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $2135b5bc36011e64$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $2135b5bc36011e64$var$delayWhen;
var $2135b5bc36011e64$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2135b5bc36011e64$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2135b5bc36011e64$var$DelayWhenSubscriber = function(_super) {
    $2135b5bc36011e64$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $2Q6Ms.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($9u1V0.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2135b5bc36011e64$var$SubscriptionDelayObservable = function(_super) {
    $2135b5bc36011e64$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $2135b5bc36011e64$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($fSYYZ.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2135b5bc36011e64$var$SubscriptionDelaySubscriber = function(_super) {
    $2135b5bc36011e64$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("ho0n1", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $97JQ5 = parcelRequire("97JQ5");
$fSYYZ.Observable.prototype.distinct = $97JQ5.distinct;

});
parcelRegister("97JQ5", function(module, exports) {
$parcel$export(module.exports, "distinct", () => $6a4853365f36abb3$export$983a3b5fb2f7202e, (v) => $6a4853365f36abb3$export$983a3b5fb2f7202e = v);
var $6a4853365f36abb3$export$983a3b5fb2f7202e;
"use strict";

var $Ro605 = parcelRequire("Ro605");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $6a4853365f36abb3$var$distinct(keySelector, flushes) {
    return $Ro605.distinct(keySelector, flushes)(this);
}
$6a4853365f36abb3$export$983a3b5fb2f7202e = $6a4853365f36abb3$var$distinct;

});
parcelRegister("Ro605", function(module, exports) {
"use strict";
var $0a07a44593cb5b43$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");

var $fo0BT = parcelRequire("fo0BT");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $0a07a44593cb5b43$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $0a07a44593cb5b43$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $0a07a44593cb5b43$var$distinct;
var $0a07a44593cb5b43$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0a07a44593cb5b43$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0a07a44593cb5b43$var$DistinctSubscriber = function(_super) {
    $0a07a44593cb5b43$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $fo0BT.Set();
        if (flushes) this.add($2Q6Ms.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($9u1V0.OuterSubscriber);
module.exports.DistinctSubscriber = $0a07a44593cb5b43$var$DistinctSubscriber;

});
parcelRegister("fo0BT", function(module, exports) {
$parcel$export(module.exports, "Set", () => $b33992162e2e361a$export$bdf4ff5a442cbbc5, (v) => $b33992162e2e361a$export$bdf4ff5a442cbbc5 = v);
var $b33992162e2e361a$export$ac57f2e66ff143c0;
var $b33992162e2e361a$export$bdf4ff5a442cbbc5;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");
function $b33992162e2e361a$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$b33992162e2e361a$export$ac57f2e66ff143c0 = $b33992162e2e361a$var$minimalSetImpl;
$b33992162e2e361a$export$bdf4ff5a442cbbc5 = $9Cdpe.root.Set || $b33992162e2e361a$var$minimalSetImpl();

});




parcelRegister("cW5tW", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $2IRXC = parcelRequire("2IRXC");
$fSYYZ.Observable.prototype.distinctUntilChanged = $2IRXC.distinctUntilChanged;

});
parcelRegister("2IRXC", function(module, exports) {
$parcel$export(module.exports, "distinctUntilChanged", () => $1fb98c4ac45bc1c5$export$779c5fb865a0172e, (v) => $1fb98c4ac45bc1c5$export$779c5fb865a0172e = v);
var $1fb98c4ac45bc1c5$export$779c5fb865a0172e;
"use strict";

var $abyDa = parcelRequire("abyDa");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $1fb98c4ac45bc1c5$var$distinctUntilChanged(compare, keySelector) {
    return $abyDa.distinctUntilChanged(compare, keySelector)(this);
}
$1fb98c4ac45bc1c5$export$779c5fb865a0172e = $1fb98c4ac45bc1c5$var$distinctUntilChanged;

});
parcelRegister("abyDa", function(module, exports) {
"use strict";
var $76a5cb6dc8c337aa$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $76a5cb6dc8c337aa$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $76a5cb6dc8c337aa$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $76a5cb6dc8c337aa$var$distinctUntilChanged;
var $76a5cb6dc8c337aa$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $76a5cb6dc8c337aa$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $76a5cb6dc8c337aa$var$DistinctUntilChangedSubscriber = function(_super) {
    $76a5cb6dc8c337aa$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $3XqeD.tryCatch(this.keySelector)(value);
            if (key === $h0Tv0.errorObject) return this.destination.error($h0Tv0.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $3XqeD.tryCatch(this.compare)(this.key, key);
            if (result === $h0Tv0.errorObject) return this.destination.error($h0Tv0.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("jTiXh", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $evWRW = parcelRequire("evWRW");
$fSYYZ.Observable.prototype.distinctUntilKeyChanged = $evWRW.distinctUntilKeyChanged;

});
parcelRegister("evWRW", function(module, exports) {
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $a911a02059ff970d$export$571da16e28367bde, (v) => $a911a02059ff970d$export$571da16e28367bde = v);
var $a911a02059ff970d$export$571da16e28367bde;
"use strict";

var $9vibc = parcelRequire("9vibc");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $a911a02059ff970d$var$distinctUntilKeyChanged(key, compare) {
    return $9vibc.distinctUntilKeyChanged(key, compare)(this);
}
$a911a02059ff970d$export$571da16e28367bde = $a911a02059ff970d$var$distinctUntilKeyChanged;

});
parcelRegister("9vibc", function(module, exports) {
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $6eb51c6817f81455$export$571da16e28367bde, (v) => $6eb51c6817f81455$export$571da16e28367bde = v);
var $6eb51c6817f81455$export$571da16e28367bde;
"use strict";

var $abyDa = parcelRequire("abyDa");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $6eb51c6817f81455$var$distinctUntilKeyChanged(key, compare) {
    return $abyDa.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$6eb51c6817f81455$export$571da16e28367bde = $6eb51c6817f81455$var$distinctUntilKeyChanged;

});



parcelRegister("cc5mX", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $4SdHQ = parcelRequire("4SdHQ");
$fSYYZ.Observable.prototype.do = $4SdHQ._do;
$fSYYZ.Observable.prototype._do = $4SdHQ._do;

});
parcelRegister("4SdHQ", function(module, exports) {
$parcel$export(module.exports, "_do", () => $38c6d655640cd66b$export$6e1c2ce23f3c9991, (v) => $38c6d655640cd66b$export$6e1c2ce23f3c9991 = v);
var $38c6d655640cd66b$export$6e1c2ce23f3c9991;
"use strict";

var $epwkG = parcelRequire("epwkG");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */ function $38c6d655640cd66b$var$_do(nextOrObserver, error, complete) {
    return $epwkG.tap(nextOrObserver, error, complete)(this);
}
$38c6d655640cd66b$export$6e1c2ce23f3c9991 = $38c6d655640cd66b$var$_do;

});


parcelRegister("3GwHk", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hO10D = parcelRequire("hO10D");
$fSYYZ.Observable.prototype.exhaust = $hO10D.exhaust;

});
parcelRegister("hO10D", function(module, exports) {
$parcel$export(module.exports, "exhaust", () => $cf67e398aa6d9295$export$31039f1fbd797b9c, (v) => $cf67e398aa6d9295$export$31039f1fbd797b9c = v);
var $cf67e398aa6d9295$export$31039f1fbd797b9c;
"use strict";

var $g5QBi = parcelRequire("g5QBi");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $cf67e398aa6d9295$var$exhaust() {
    return $g5QBi.exhaust()(this);
}
$cf67e398aa6d9295$export$31039f1fbd797b9c = $cf67e398aa6d9295$var$exhaust;

});
parcelRegister("g5QBi", function(module, exports) {
"use strict";
var $bb75ea56a551bf21$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $bb75ea56a551bf21$var$exhaust() {
    return function(source) {
        return source.lift(new $bb75ea56a551bf21$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $bb75ea56a551bf21$var$exhaust;
var $bb75ea56a551bf21$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $bb75ea56a551bf21$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bb75ea56a551bf21$var$SwitchFirstSubscriber = function(_super) {
    $bb75ea56a551bf21$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($2Q6Ms.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("7KYcz", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $6RNn8 = parcelRequire("6RNn8");
$fSYYZ.Observable.prototype.exhaustMap = $6RNn8.exhaustMap;

});
parcelRegister("6RNn8", function(module, exports) {
$parcel$export(module.exports, "exhaustMap", () => $4ffdfd9a6d6d4a81$export$d70d492cd31004c0, (v) => $4ffdfd9a6d6d4a81$export$d70d492cd31004c0 = v);
var $4ffdfd9a6d6d4a81$export$d70d492cd31004c0;
"use strict";

var $16pqC = parcelRequire("16pqC");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $4ffdfd9a6d6d4a81$var$exhaustMap(project, resultSelector) {
    return $16pqC.exhaustMap(project, resultSelector)(this);
}
$4ffdfd9a6d6d4a81$export$d70d492cd31004c0 = $4ffdfd9a6d6d4a81$var$exhaustMap;

});
parcelRegister("16pqC", function(module, exports) {
"use strict";
var $0cda1388f6926941$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $0cda1388f6926941$var$exhaustMap(project, resultSelector) {
    return function(source) {
        return source.lift(new $0cda1388f6926941$var$SwitchFirstMapOperator(project, resultSelector));
    };
}
module.exports.exhaustMap = $0cda1388f6926941$var$exhaustMap;
var $0cda1388f6926941$var$SwitchFirstMapOperator = function() {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0cda1388f6926941$var$SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0cda1388f6926941$var$SwitchFirstMapSubscriber = function(_super) {
    $0cda1388f6926941$var$__extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function(value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add($2Q6Ms.subscribeToResult(this, result, value, index));
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstMapSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("ffqk3", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5YGiG = parcelRequire("5YGiG");
$fSYYZ.Observable.prototype.expand = $5YGiG.expand;

});
parcelRegister("5YGiG", function(module, exports) {
$parcel$export(module.exports, "expand", () => $45a35e5563e00802$export$9f77e0932fb78f72, (v) => $45a35e5563e00802$export$9f77e0932fb78f72 = v);
var $45a35e5563e00802$export$9f77e0932fb78f72;
"use strict";

var $5hyH5 = parcelRequire("5hyH5");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $45a35e5563e00802$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return $5hyH5.expand(project, concurrent, scheduler)(this);
}
$45a35e5563e00802$export$9f77e0932fb78f72 = $45a35e5563e00802$var$expand;

});
parcelRegister("5hyH5", function(module, exports) {
"use strict";
var $3d8973cb2c60b59e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $3d8973cb2c60b59e$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $3d8973cb2c60b59e$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $3d8973cb2c60b59e$var$expand;
var $3d8973cb2c60b59e$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3d8973cb2c60b59e$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $3d8973cb2c60b59e$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3d8973cb2c60b59e$var$ExpandSubscriber = function(_super) {
    $3d8973cb2c60b59e$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $3XqeD.tryCatch(this.project)(value, index);
            if (result === $h0Tv0.errorObject) destination.error($h0Tv0.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($2Q6Ms.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($9u1V0.OuterSubscriber);
module.exports.ExpandSubscriber = $3d8973cb2c60b59e$var$ExpandSubscriber;

});



parcelRegister("eUkxr", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $57KWv = parcelRequire("57KWv");
$fSYYZ.Observable.prototype.elementAt = $57KWv.elementAt;

});
parcelRegister("57KWv", function(module, exports) {
$parcel$export(module.exports, "elementAt", () => $3bb2050a3b45a608$export$91d69c7761a17bbc, (v) => $3bb2050a3b45a608$export$91d69c7761a17bbc = v);
var $3bb2050a3b45a608$export$91d69c7761a17bbc;
"use strict";

var $01nuO = parcelRequire("01nuO");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $3bb2050a3b45a608$var$elementAt(index, defaultValue) {
    return $01nuO.elementAt(index, defaultValue)(this);
}
$3bb2050a3b45a608$export$91d69c7761a17bbc = $3bb2050a3b45a608$var$elementAt;

});
parcelRegister("01nuO", function(module, exports) {
"use strict";
var $004251f139234568$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $9JK9X = parcelRequire("9JK9X");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $004251f139234568$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $004251f139234568$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $004251f139234568$var$elementAt;
var $004251f139234568$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $9JK9X.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $004251f139234568$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $004251f139234568$var$ElementAtSubscriber = function(_super) {
    $004251f139234568$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $9JK9X.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($8qR8S.Subscriber);

});
parcelRegister("9JK9X", function(module, exports) {
"use strict";
var $716c1f5e1b751886$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $716c1f5e1b751886$var$ArgumentOutOfRangeError = function(_super) {
    $716c1f5e1b751886$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $716c1f5e1b751886$var$ArgumentOutOfRangeError;

});




parcelRegister("bBFFm", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $lN4a0 = parcelRequire("lN4a0");
$fSYYZ.Observable.prototype.filter = $lN4a0.filter;

});

parcelRegister("kLrVY", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $gyllY = parcelRequire("gyllY");
$fSYYZ.Observable.prototype.finally = $gyllY._finally;
$fSYYZ.Observable.prototype._finally = $gyllY._finally;

});
parcelRegister("gyllY", function(module, exports) {
$parcel$export(module.exports, "_finally", () => $c0d062a48d534521$export$f6224470e4cea3fa, (v) => $c0d062a48d534521$export$f6224470e4cea3fa = v);
var $c0d062a48d534521$export$f6224470e4cea3fa;
"use strict";

var $eAvJP = parcelRequire("eAvJP");
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $c0d062a48d534521$var$_finally(callback) {
    return $eAvJP.finalize(callback)(this);
}
$c0d062a48d534521$export$f6224470e4cea3fa = $c0d062a48d534521$var$_finally;

});
parcelRegister("eAvJP", function(module, exports) {
"use strict";
var $a9ed0c058c965b37$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $aBkDT = parcelRequire("aBkDT");
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $a9ed0c058c965b37$var$finalize(callback) {
    return function(source) {
        return source.lift(new $a9ed0c058c965b37$var$FinallyOperator(callback));
    };
}
module.exports.finalize = $a9ed0c058c965b37$var$finalize;
var $a9ed0c058c965b37$var$FinallyOperator = function() {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a9ed0c058c965b37$var$FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a9ed0c058c965b37$var$FinallySubscriber = function(_super) {
    $a9ed0c058c965b37$var$__extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new $aBkDT.Subscription(callback));
    }
    return FinallySubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("6bTwL", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $cp9BJ = parcelRequire("cp9BJ");
$fSYYZ.Observable.prototype.find = $cp9BJ.find;

});
parcelRegister("cp9BJ", function(module, exports) {
$parcel$export(module.exports, "find", () => $907f45b76889f811$export$71aa6c912b956294, (v) => $907f45b76889f811$export$71aa6c912b956294 = v);
var $907f45b76889f811$export$71aa6c912b956294;
"use strict";

var $gxQ8U = parcelRequire("gxQ8U");
/* tslint:enable:max-line-length */ /**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $907f45b76889f811$var$find(predicate, thisArg) {
    return $gxQ8U.find(predicate, thisArg)(this);
}
$907f45b76889f811$export$71aa6c912b956294 = $907f45b76889f811$var$find;

});
parcelRegister("gxQ8U", function(module, exports) {
"use strict";
var $c0b82cde00339d3a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $c0b82cde00339d3a$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $c0b82cde00339d3a$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $c0b82cde00339d3a$var$find;
var $c0b82cde00339d3a$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $c0b82cde00339d3a$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $c0b82cde00339d3a$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c0b82cde00339d3a$var$FindValueSubscriber = function(_super) {
    $c0b82cde00339d3a$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($8qR8S.Subscriber);
module.exports.FindValueSubscriber = $c0b82cde00339d3a$var$FindValueSubscriber;

});



parcelRegister("2AXfq", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5xU7S = parcelRequire("5xU7S");
$fSYYZ.Observable.prototype.findIndex = $5xU7S.findIndex;

});
parcelRegister("5xU7S", function(module, exports) {
$parcel$export(module.exports, "findIndex", () => $409b924e53a3194e$export$de3a4d4a0d731119, (v) => $409b924e53a3194e$export$de3a4d4a0d731119 = v);
var $409b924e53a3194e$export$de3a4d4a0d731119;
"use strict";

var $lSZQd = parcelRequire("lSZQd");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $409b924e53a3194e$var$findIndex(predicate, thisArg) {
    return $lSZQd.findIndex(predicate, thisArg)(this);
}
$409b924e53a3194e$export$de3a4d4a0d731119 = $409b924e53a3194e$var$findIndex;

});
parcelRegister("lSZQd", function(module, exports) {
$parcel$export(module.exports, "findIndex", () => $feee9c77f8292a6f$export$de3a4d4a0d731119, (v) => $feee9c77f8292a6f$export$de3a4d4a0d731119 = v);
var $feee9c77f8292a6f$export$de3a4d4a0d731119;
"use strict";

var $gxQ8U = parcelRequire("gxQ8U");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $feee9c77f8292a6f$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $gxQ8U.FindValueOperator(predicate, source, true, thisArg));
    };
}
$feee9c77f8292a6f$export$de3a4d4a0d731119 = $feee9c77f8292a6f$var$findIndex;

});



parcelRegister("iwUFB", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hBpv3 = parcelRequire("hBpv3");
$fSYYZ.Observable.prototype.first = $hBpv3.first;

});
parcelRegister("hBpv3", function(module, exports) {
$parcel$export(module.exports, "first", () => $cd09ac1f3982e07c$export$43128fadae87b74a, (v) => $cd09ac1f3982e07c$export$43128fadae87b74a = v);
var $cd09ac1f3982e07c$export$43128fadae87b74a;
"use strict";

var $cLKXI = parcelRequire("cLKXI");
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $cd09ac1f3982e07c$var$first(predicate, resultSelector, defaultValue) {
    return $cLKXI.first(predicate, resultSelector, defaultValue)(this);
}
$cd09ac1f3982e07c$export$43128fadae87b74a = $cd09ac1f3982e07c$var$first;

});
parcelRegister("cLKXI", function(module, exports) {
"use strict";
var $94be4d8685e6b067$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $jUTRE = parcelRequire("jUTRE");
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $94be4d8685e6b067$var$first(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $94be4d8685e6b067$var$FirstOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.first = $94be4d8685e6b067$var$first;
var $94be4d8685e6b067$var$FirstOperator = function() {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $94be4d8685e6b067$var$FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $94be4d8685e6b067$var$FirstSubscriber = function(_super) {
    $94be4d8685e6b067$var$__extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else this._emit(value, index);
    };
    FirstSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this._emit(value, index);
    };
    FirstSubscriber.prototype._emit = function(value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function(value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        } else if (!this.hasCompleted) destination.error(new $jUTRE.EmptyError);
    };
    return FirstSubscriber;
}($8qR8S.Subscriber);

});
parcelRegister("jUTRE", function(module, exports) {
"use strict";
var $e7fe94ca8b3f9bf4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */ var $e7fe94ca8b3f9bf4$var$EmptyError = function(_super) {
    $e7fe94ca8b3f9bf4$var$__extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error);
module.exports.EmptyError = $e7fe94ca8b3f9bf4$var$EmptyError;

});




parcelRegister("3MI4L", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $ai2rL = parcelRequire("ai2rL");
$fSYYZ.Observable.prototype.groupBy = $ai2rL.groupBy;

});
parcelRegister("ai2rL", function(module, exports) {
$parcel$export(module.exports, "groupBy", () => $77dd7bb7a3668ab4$export$3f063810d7bf01bd, (v) => $77dd7bb7a3668ab4$export$3f063810d7bf01bd = v);
var $77dd7bb7a3668ab4$export$ff26824b3dc37d8c;
var $77dd7bb7a3668ab4$export$3f063810d7bf01bd;
"use strict";

var $89h2t = parcelRequire("89h2t");
$77dd7bb7a3668ab4$export$ff26824b3dc37d8c = $89h2t.GroupedObservable;
/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $77dd7bb7a3668ab4$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return $89h2t.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
}
$77dd7bb7a3668ab4$export$3f063810d7bf01bd = $77dd7bb7a3668ab4$var$groupBy;

});
parcelRegister("89h2t", function(module, exports) {
"use strict";
var $5eec618e9df2c234$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $aBkDT = parcelRequire("aBkDT");

var $fSYYZ = parcelRequire("fSYYZ");

var $bTlA1 = parcelRequire("bTlA1");

var $eQ8Sr = parcelRequire("eQ8Sr");

var $fjrRL = parcelRequire("fjrRL");
/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $5eec618e9df2c234$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function(source) {
        return source.lift(new $5eec618e9df2c234$var$GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
module.exports.groupBy = $5eec618e9df2c234$var$groupBy;
var $5eec618e9df2c234$var$GroupByOperator = function() {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5eec618e9df2c234$var$GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5eec618e9df2c234$var$GroupBySubscriber = function(_super) {
    $5eec618e9df2c234$var$__extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function(value) {
        var key;
        try {
            key = this.keySelector(value);
        } catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) groups = this.groups = typeof key === 'string' ? new $fjrRL.FastMap() : new $eQ8Sr.Map();
        var group = groups.get(key);
        var element;
        if (this.elementSelector) try {
            element = this.elementSelector(value);
        } catch (err) {
            this.error(err);
        }
        else element = value;
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new $bTlA1.Subject();
            groups.set(key, group);
            var groupedObservable = new $5eec618e9df2c234$var$GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new $5eec618e9df2c234$var$GroupedObservable(key, group));
                } catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new $5eec618e9df2c234$var$GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) group.next(element);
    };
    GroupBySubscriber.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function(key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) _super.prototype.unsubscribe.call(this);
        }
    };
    return GroupBySubscriber;
}($8qR8S.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5eec618e9df2c234$var$GroupDurationSubscriber = function(_super) {
    $5eec618e9df2c234$var$__extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this, group);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function(value) {
        this.complete();
    };
    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) parent.removeGroup(key);
    };
    return GroupDurationSubscriber;
}($8qR8S.Subscriber);
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */ var $5eec618e9df2c234$var$GroupedObservable = function(_super) {
    $5eec618e9df2c234$var$__extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function(subscriber) {
        var subscription = new $aBkDT.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) subscription.add(new $5eec618e9df2c234$var$InnerRefCountSubscription(refCountSubscription));
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}($fSYYZ.Observable);
module.exports.GroupedObservable = $5eec618e9df2c234$var$GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5eec618e9df2c234$var$InnerRefCountSubscription = function(_super) {
    $5eec618e9df2c234$var$__extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) parent.unsubscribe();
        }
    };
    return InnerRefCountSubscription;
}($aBkDT.Subscription);

});
parcelRegister("eQ8Sr", function(module, exports) {
$parcel$export(module.exports, "Map", () => $acdcced379ebec59$export$a5c7b93649eaf8f8, (v) => $acdcced379ebec59$export$a5c7b93649eaf8f8 = v);
var $acdcced379ebec59$export$a5c7b93649eaf8f8;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");

var $jid23 = parcelRequire("jid23");
$acdcced379ebec59$export$a5c7b93649eaf8f8 = $9Cdpe.root.Map || function() {
    return $jid23.MapPolyfill;
}();

});
parcelRegister("jid23", function(module, exports) {
$parcel$export(module.exports, "MapPolyfill", () => $e0b9cea6552f3bbc$export$dd450425f6b4a07, (v) => $e0b9cea6552f3bbc$export$dd450425f6b4a07 = v);
var $e0b9cea6552f3bbc$export$dd450425f6b4a07;
"use strict";
var $e0b9cea6552f3bbc$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function(key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function(key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        } else this._values[i] = value;
        return this;
    };
    MapPolyfill.prototype.delete = function(key) {
        var i = this._keys.indexOf(key);
        if (i === -1) return false;
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function() {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function(cb, thisArg) {
        for(var i = 0; i < this.size; i++)cb.call(thisArg, this._values[i], this._keys[i]);
    };
    return MapPolyfill;
}();
$e0b9cea6552f3bbc$export$dd450425f6b4a07 = $e0b9cea6552f3bbc$var$MapPolyfill;

});


parcelRegister("fjrRL", function(module, exports) {
$parcel$export(module.exports, "FastMap", () => $b25e3f01663f61c8$export$d3f0a24774bb4055, (v) => $b25e3f01663f61c8$export$d3f0a24774bb4055 = v);
var $b25e3f01663f61c8$export$d3f0a24774bb4055;
"use strict";
var $b25e3f01663f61c8$var$FastMap = function() {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function(key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function(key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function(key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function(cb, thisArg) {
        var values = this.values;
        for(var key in values)if (values.hasOwnProperty(key) && values[key] !== null) cb.call(thisArg, values[key], key);
    };
    FastMap.prototype.clear = function() {
        this.values = {};
    };
    return FastMap;
}();
$b25e3f01663f61c8$export$d3f0a24774bb4055 = $b25e3f01663f61c8$var$FastMap;

});




parcelRegister("9CTIf", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $k4kgj = parcelRequire("k4kgj");
$fSYYZ.Observable.prototype.ignoreElements = $k4kgj.ignoreElements;

});
parcelRegister("k4kgj", function(module, exports) {
$parcel$export(module.exports, "ignoreElements", () => $e9c3e5fb68e23d65$export$6953b97c7d866605, (v) => $e9c3e5fb68e23d65$export$6953b97c7d866605 = v);
var $e9c3e5fb68e23d65$export$6953b97c7d866605;
"use strict";

var $d1NAc = parcelRequire("d1NAc");
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $e9c3e5fb68e23d65$var$ignoreElements() {
    return $d1NAc.ignoreElements()(this);
}
$e9c3e5fb68e23d65$export$6953b97c7d866605 = $e9c3e5fb68e23d65$var$ignoreElements;

});
parcelRegister("d1NAc", function(module, exports) {
"use strict";
var $97c1d47e41aefb21$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $9fPei = parcelRequire("9fPei");
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $97c1d47e41aefb21$var$ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new $97c1d47e41aefb21$var$IgnoreElementsOperator());
    };
}
module.exports.ignoreElements = $97c1d47e41aefb21$var$ignoreElements;
var $97c1d47e41aefb21$var$IgnoreElementsOperator = function() {
    function IgnoreElementsOperator() {}
    IgnoreElementsOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $97c1d47e41aefb21$var$IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $97c1d47e41aefb21$var$IgnoreElementsSubscriber = function(_super) {
    $97c1d47e41aefb21$var$__extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function(unused) {
        $9fPei.noop();
    };
    return IgnoreElementsSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("1Lchw", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $03nkX = parcelRequire("03nkX");
$fSYYZ.Observable.prototype.isEmpty = $03nkX.isEmpty;

});
parcelRegister("03nkX", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $00a262282842ae59$export$dd1bc94b04021eeb, (v) => $00a262282842ae59$export$dd1bc94b04021eeb = v);
var $00a262282842ae59$export$dd1bc94b04021eeb;
"use strict";

var $9bxss = parcelRequire("9bxss");
/**
 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
 *
 * <img src="./img/isEmpty.png" width="100%">
 *
 * @return {Observable} An Observable that emits a Boolean.
 * @method isEmpty
 * @owner Observable
 */ function $00a262282842ae59$var$isEmpty() {
    return $9bxss.isEmpty()(this);
}
$00a262282842ae59$export$dd1bc94b04021eeb = $00a262282842ae59$var$isEmpty;

});
parcelRegister("9bxss", function(module, exports) {
"use strict";
var $01b9cab666e72e05$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
function $01b9cab666e72e05$var$isEmpty() {
    return function(source) {
        return source.lift(new $01b9cab666e72e05$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $01b9cab666e72e05$var$isEmpty;
var $01b9cab666e72e05$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $01b9cab666e72e05$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $01b9cab666e72e05$var$IsEmptySubscriber = function(_super) {
    $01b9cab666e72e05$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("7stYY", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $geUFP = parcelRequire("geUFP");
$fSYYZ.Observable.prototype.audit = $geUFP.audit;

});
parcelRegister("geUFP", function(module, exports) {
$parcel$export(module.exports, "audit", () => $bd29ea54b77830ff$export$d779b02e6b68c3e8, (v) => $bd29ea54b77830ff$export$d779b02e6b68c3e8 = v);
var $bd29ea54b77830ff$export$d779b02e6b68c3e8;
"use strict";

var $dAwhn = parcelRequire("dAwhn");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $bd29ea54b77830ff$var$audit(durationSelector) {
    return $dAwhn.audit(durationSelector)(this);
}
$bd29ea54b77830ff$export$d779b02e6b68c3e8 = $bd29ea54b77830ff$var$audit;

});
parcelRegister("dAwhn", function(module, exports) {
"use strict";
var $9e47ad22f8518430$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $9e47ad22f8518430$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $9e47ad22f8518430$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $9e47ad22f8518430$var$audit;
var $9e47ad22f8518430$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9e47ad22f8518430$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9e47ad22f8518430$var$AuditSubscriber = function(_super) {
    $9e47ad22f8518430$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $3XqeD.tryCatch(this.durationSelector)(value);
            if (duration === $h0Tv0.errorObject) this.destination.error($h0Tv0.errorObject.e);
            else {
                var innerSubscription = $2Q6Ms.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("a5gmV", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $lFgJL = parcelRequire("lFgJL");
$fSYYZ.Observable.prototype.auditTime = $lFgJL.auditTime;

});
parcelRegister("lFgJL", function(module, exports) {
$parcel$export(module.exports, "auditTime", () => $fc5a68f7e93e1a77$export$719c70722b10e5ff, (v) => $fc5a68f7e93e1a77$export$719c70722b10e5ff = v);
var $fc5a68f7e93e1a77$export$719c70722b10e5ff;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $3VGkX = parcelRequire("3VGkX");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $fc5a68f7e93e1a77$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $3VGkX.auditTime(duration, scheduler)(this);
}
$fc5a68f7e93e1a77$export$719c70722b10e5ff = $fc5a68f7e93e1a77$var$auditTime;

});
parcelRegister("3VGkX", function(module, exports) {
$parcel$export(module.exports, "auditTime", () => $2dc78939724d6af2$export$719c70722b10e5ff, (v) => $2dc78939724d6af2$export$719c70722b10e5ff = v);
var $2dc78939724d6af2$export$719c70722b10e5ff;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $dAwhn = parcelRequire("dAwhn");

var $kA7Tg = parcelRequire("kA7Tg");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $2dc78939724d6af2$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $dAwhn.audit(function() {
        return $kA7Tg.timer(duration, scheduler);
    });
}
$2dc78939724d6af2$export$719c70722b10e5ff = $2dc78939724d6af2$var$auditTime;

});



parcelRegister("iiJom", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $E0TIJ = parcelRequire("E0TIJ");
$fSYYZ.Observable.prototype.last = $E0TIJ.last;

});
parcelRegister("E0TIJ", function(module, exports) {
$parcel$export(module.exports, "last", () => $07846ecf558ec60e$export$4c7897fafd92b108, (v) => $07846ecf558ec60e$export$4c7897fafd92b108 = v);
var $07846ecf558ec60e$export$4c7897fafd92b108;
"use strict";

var $z0UIM = parcelRequire("z0UIM");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $07846ecf558ec60e$var$last(predicate, resultSelector, defaultValue) {
    return $z0UIM.last(predicate, resultSelector, defaultValue)(this);
}
$07846ecf558ec60e$export$4c7897fafd92b108 = $07846ecf558ec60e$var$last;

});
parcelRegister("z0UIM", function(module, exports) {
"use strict";
var $0693fa78f1b0c1e2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $jUTRE = parcelRequire("jUTRE");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $0693fa78f1b0c1e2$var$last(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $0693fa78f1b0c1e2$var$LastOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.last = $0693fa78f1b0c1e2$var$last;
var $0693fa78f1b0c1e2$var$LastOperator = function() {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $0693fa78f1b0c1e2$var$LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0693fa78f1b0c1e2$var$LastSubscriber = function(_super) {
    $0693fa78f1b0c1e2$var$__extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        } else destination.error(new $jUTRE.EmptyError);
    };
    return LastSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("eSAVQ", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5ZHlc = parcelRequire("5ZHlc");
$fSYYZ.Observable.prototype.let = $5ZHlc.letProto;
$fSYYZ.Observable.prototype.letBind = $5ZHlc.letProto;

});
parcelRegister("5ZHlc", function(module, exports) {
$parcel$export(module.exports, "letProto", () => $45d444da9af63a2c$export$50696b801ff96e66, (v) => $45d444da9af63a2c$export$50696b801ff96e66 = v);
var $45d444da9af63a2c$export$50696b801ff96e66;
"use strict";
/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */ function $45d444da9af63a2c$var$letProto(func) {
    return func(this);
}
$45d444da9af63a2c$export$50696b801ff96e66 = $45d444da9af63a2c$var$letProto;

});


parcelRegister("5aati", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $lIX4C = parcelRequire("lIX4C");
$fSYYZ.Observable.prototype.every = $lIX4C.every;

});
parcelRegister("lIX4C", function(module, exports) {
$parcel$export(module.exports, "every", () => $fd0b87cf762b139d$export$7ecc1a3b11b57dab, (v) => $fd0b87cf762b139d$export$7ecc1a3b11b57dab = v);
var $fd0b87cf762b139d$export$7ecc1a3b11b57dab;
"use strict";

var $6dvah = parcelRequire("6dvah");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $fd0b87cf762b139d$var$every(predicate, thisArg) {
    return $6dvah.every(predicate, thisArg)(this);
}
$fd0b87cf762b139d$export$7ecc1a3b11b57dab = $fd0b87cf762b139d$var$every;

});
parcelRegister("6dvah", function(module, exports) {
"use strict";
var $486c21a656a95b12$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $486c21a656a95b12$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $486c21a656a95b12$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $486c21a656a95b12$var$every;
var $486c21a656a95b12$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $486c21a656a95b12$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $486c21a656a95b12$var$EverySubscriber = function(_super) {
    $486c21a656a95b12$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("1dAP5", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $d6SrZ = parcelRequire("d6SrZ");
$fSYYZ.Observable.prototype.map = $d6SrZ.map;

});

parcelRegister("eJymB", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $1LCw2 = parcelRequire("1LCw2");
$fSYYZ.Observable.prototype.mapTo = $1LCw2.mapTo;

});
parcelRegister("1LCw2", function(module, exports) {
$parcel$export(module.exports, "mapTo", () => $14980ea5ee353316$export$e0eaf3a86c03b2ad, (v) => $14980ea5ee353316$export$e0eaf3a86c03b2ad = v);
var $14980ea5ee353316$export$e0eaf3a86c03b2ad;
"use strict";

var $d5CX7 = parcelRequire("d5CX7");
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $14980ea5ee353316$var$mapTo(value) {
    return $d5CX7.mapTo(value)(this);
}
$14980ea5ee353316$export$e0eaf3a86c03b2ad = $14980ea5ee353316$var$mapTo;

});
parcelRegister("d5CX7", function(module, exports) {
"use strict";
var $9879f52439ee0643$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $9879f52439ee0643$var$mapTo(value) {
    return function(source) {
        return source.lift(new $9879f52439ee0643$var$MapToOperator(value));
    };
}
module.exports.mapTo = $9879f52439ee0643$var$mapTo;
var $9879f52439ee0643$var$MapToOperator = function() {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9879f52439ee0643$var$MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9879f52439ee0643$var$MapToSubscriber = function(_super) {
    $9879f52439ee0643$var$__extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function(x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("1FiQt", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hOzx7 = parcelRequire("hOzx7");
$fSYYZ.Observable.prototype.materialize = $hOzx7.materialize;

});
parcelRegister("hOzx7", function(module, exports) {
$parcel$export(module.exports, "materialize", () => $cf82ab4da4db1051$export$76dbd6ffd832405d, (v) => $cf82ab4da4db1051$export$76dbd6ffd832405d = v);
var $cf82ab4da4db1051$export$76dbd6ffd832405d;
"use strict";

var $aucJm = parcelRequire("aucJm");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $cf82ab4da4db1051$var$materialize() {
    return $aucJm.materialize()(this);
}
$cf82ab4da4db1051$export$76dbd6ffd832405d = $cf82ab4da4db1051$var$materialize;

});
parcelRegister("aucJm", function(module, exports) {
"use strict";
var $7a2694c746e13415$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $hGDIR = parcelRequire("hGDIR");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $7a2694c746e13415$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $7a2694c746e13415$var$MaterializeOperator());
    };
}
module.exports.materialize = $7a2694c746e13415$var$materialize;
var $7a2694c746e13415$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7a2694c746e13415$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7a2694c746e13415$var$MaterializeSubscriber = function(_super) {
    $7a2694c746e13415$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($hGDIR.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($hGDIR.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($hGDIR.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("j1S14", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $cZSmg = parcelRequire("cZSmg");
$fSYYZ.Observable.prototype.max = $cZSmg.max;

});
parcelRegister("cZSmg", function(module, exports) {
$parcel$export(module.exports, "max", () => $976558ef6614e480$export$8960430cfd85939f, (v) => $976558ef6614e480$export$8960430cfd85939f = v);
var $976558ef6614e480$export$8960430cfd85939f;
"use strict";

var $jIwHI = parcelRequire("jIwHI");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $976558ef6614e480$var$max(comparer) {
    return $jIwHI.max(comparer)(this);
}
$976558ef6614e480$export$8960430cfd85939f = $976558ef6614e480$var$max;

});
parcelRegister("jIwHI", function(module, exports) {
$parcel$export(module.exports, "max", () => $e5ab7eba9ebb3c6d$export$8960430cfd85939f, (v) => $e5ab7eba9ebb3c6d$export$8960430cfd85939f = v);
var $e5ab7eba9ebb3c6d$export$8960430cfd85939f;
"use strict";

var $d2E9m = parcelRequire("d2E9m");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $e5ab7eba9ebb3c6d$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $d2E9m.reduce(max);
}
$e5ab7eba9ebb3c6d$export$8960430cfd85939f = $e5ab7eba9ebb3c6d$var$max;

});
parcelRegister("d2E9m", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $97ea9b3605d241fc$export$533b26079ad0b4b, (v) => $97ea9b3605d241fc$export$533b26079ad0b4b = v);
var $97ea9b3605d241fc$export$533b26079ad0b4b;
"use strict";

var $9PjKc = parcelRequire("9PjKc");

var $iPNgA = parcelRequire("iPNgA");

var $7c96M = parcelRequire("7c96M");

var $i11ER = parcelRequire("i11ER");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $97ea9b3605d241fc$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $i11ER.pipe($9PjKc.scan(accumulator, seed), $iPNgA.takeLast(1), $7c96M.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $i11ER.pipe($9PjKc.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $iPNgA.takeLast(1))(source);
    };
}
$97ea9b3605d241fc$export$533b26079ad0b4b = $97ea9b3605d241fc$var$reduce;

});
parcelRegister("9PjKc", function(module, exports) {
"use strict";
var $7278313b8baf6222$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $7278313b8baf6222$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $7278313b8baf6222$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $7278313b8baf6222$var$scan;
var $7278313b8baf6222$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7278313b8baf6222$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7278313b8baf6222$var$ScanSubscriber = function(_super) {
    $7278313b8baf6222$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($8qR8S.Subscriber);

});

parcelRegister("iPNgA", function(module, exports) {
"use strict";
var $db6334bc2d40c6b8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $9JK9X = parcelRequire("9JK9X");

var $fyVhl = parcelRequire("fyVhl");
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $db6334bc2d40c6b8$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $fyVhl.EmptyObservable();
        else return source.lift(new $db6334bc2d40c6b8$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $db6334bc2d40c6b8$var$takeLast;
var $db6334bc2d40c6b8$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $9JK9X.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $db6334bc2d40c6b8$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $db6334bc2d40c6b8$var$TakeLastSubscriber = function(_super) {
    $db6334bc2d40c6b8$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($8qR8S.Subscriber);

});





parcelRegister("aYRT6", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $8sfDR = parcelRequire("8sfDR");
$fSYYZ.Observable.prototype.merge = $8sfDR.merge;

});
parcelRegister("8sfDR", function(module, exports) {
$parcel$export(module.exports, "merge", () => $627d1269150f4b45$export$4950aa0f605343fb, (v) => $627d1269150f4b45$export$4950aa0f605343fb = v);
var $627d1269150f4b45$export$9f199afc30ae2269;
var $627d1269150f4b45$export$4950aa0f605343fb;
"use strict";

var $8nnVB = parcelRequire("8nnVB");

var $5S14C = parcelRequire("5S14C");
$627d1269150f4b45$export$9f199afc30ae2269 = $5S14C.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $627d1269150f4b45$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $8nnVB.merge.apply(void 0, observables)(this);
}
$627d1269150f4b45$export$4950aa0f605343fb = $627d1269150f4b45$var$merge;

});
parcelRegister("8nnVB", function(module, exports) {
$parcel$export(module.exports, "merge", () => $6193084f1ac93701$export$4950aa0f605343fb, (v) => $6193084f1ac93701$export$4950aa0f605343fb = v);
var $6193084f1ac93701$export$9f199afc30ae2269;
var $6193084f1ac93701$export$4950aa0f605343fb;
"use strict";

var $5S14C = parcelRequire("5S14C");

var $5S14C = parcelRequire("5S14C");
$6193084f1ac93701$export$9f199afc30ae2269 = $5S14C.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $6193084f1ac93701$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($5S14C.merge.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$6193084f1ac93701$export$4950aa0f605343fb = $6193084f1ac93701$var$merge;

});



parcelRegister("gKh21", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $jYNY5 = parcelRequire("jYNY5");
$fSYYZ.Observable.prototype.mergeAll = $jYNY5.mergeAll;

});
parcelRegister("jYNY5", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $e8ba61866231c058$export$18aef43295bbe906, (v) => $e8ba61866231c058$export$18aef43295bbe906 = v);
var $e8ba61866231c058$export$18aef43295bbe906;
"use strict";

var $44a5l = parcelRequire("44a5l");
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $e8ba61866231c058$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $44a5l.mergeAll(concurrent)(this);
}
$e8ba61866231c058$export$18aef43295bbe906 = $e8ba61866231c058$var$mergeAll;

});


parcelRegister("39D21", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $8ij3j = parcelRequire("8ij3j");
$fSYYZ.Observable.prototype.mergeMap = $8ij3j.mergeMap;
$fSYYZ.Observable.prototype.flatMap = $8ij3j.mergeMap;

});
parcelRegister("8ij3j", function(module, exports) {
$parcel$export(module.exports, "mergeMap", () => $018ef2b82d301ad2$export$6b9f6c0d32c093f9, (v) => $018ef2b82d301ad2$export$6b9f6c0d32c093f9 = v);
var $018ef2b82d301ad2$export$6b9f6c0d32c093f9;
"use strict";

var $5iPTs = parcelRequire("5iPTs");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $018ef2b82d301ad2$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $5iPTs.mergeMap(project, resultSelector, concurrent)(this);
}
$018ef2b82d301ad2$export$6b9f6c0d32c093f9 = $018ef2b82d301ad2$var$mergeMap;

});


parcelRegister("5YCSX", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hMZmb = parcelRequire("hMZmb");
$fSYYZ.Observable.prototype.flatMapTo = $hMZmb.mergeMapTo;
$fSYYZ.Observable.prototype.mergeMapTo = $hMZmb.mergeMapTo;

});
parcelRegister("hMZmb", function(module, exports) {
$parcel$export(module.exports, "mergeMapTo", () => $cf36838a70b04690$export$bd7cfc9a42b8a412, (v) => $cf36838a70b04690$export$bd7cfc9a42b8a412 = v);
var $cf36838a70b04690$export$bd7cfc9a42b8a412;
"use strict";

var $gr3E9 = parcelRequire("gr3E9");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $cf36838a70b04690$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $gr3E9.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
}
$cf36838a70b04690$export$bd7cfc9a42b8a412 = $cf36838a70b04690$var$mergeMapTo;

});
parcelRegister("gr3E9", function(module, exports) {
"use strict";
var $bf71ff1c0287ed38$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $bf71ff1c0287ed38$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $bf71ff1c0287ed38$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $bf71ff1c0287ed38$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $bf71ff1c0287ed38$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $bf71ff1c0287ed38$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $bf71ff1c0287ed38$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bf71ff1c0287ed38$var$MergeMapToSubscriber = function(_super) {
    $bf71ff1c0287ed38$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($2Q6Ms.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($9u1V0.OuterSubscriber);
module.exports.MergeMapToSubscriber = $bf71ff1c0287ed38$var$MergeMapToSubscriber;

});



parcelRegister("4LtqF", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $cA44S = parcelRequire("cA44S");
$fSYYZ.Observable.prototype.mergeScan = $cA44S.mergeScan;

});
parcelRegister("cA44S", function(module, exports) {
$parcel$export(module.exports, "mergeScan", () => $928c029311c1021d$export$c1fc905202bced53, (v) => $928c029311c1021d$export$c1fc905202bced53 = v);
var $928c029311c1021d$export$c1fc905202bced53;
"use strict";

var $eWsbb = parcelRequire("eWsbb");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $928c029311c1021d$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $eWsbb.mergeScan(accumulator, seed, concurrent)(this);
}
$928c029311c1021d$export$c1fc905202bced53 = $928c029311c1021d$var$mergeScan;

});
parcelRegister("eWsbb", function(module, exports) {
"use strict";
var $ae0c5754c3228519$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $2Q6Ms = parcelRequire("2Q6Ms");

var $9u1V0 = parcelRequire("9u1V0");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $ae0c5754c3228519$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $ae0c5754c3228519$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $ae0c5754c3228519$var$mergeScan;
var $ae0c5754c3228519$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ae0c5754c3228519$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $ae0c5754c3228519$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ae0c5754c3228519$var$MergeScanSubscriber = function(_super) {
    $ae0c5754c3228519$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $3XqeD.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $h0Tv0.errorObject) destination.error($h0Tv0.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($2Q6Ms.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($9u1V0.OuterSubscriber);
module.exports.MergeScanSubscriber = $ae0c5754c3228519$var$MergeScanSubscriber;

});



parcelRegister("grW3p", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $9xOY3 = parcelRequire("9xOY3");
$fSYYZ.Observable.prototype.min = $9xOY3.min;

});
parcelRegister("9xOY3", function(module, exports) {
$parcel$export(module.exports, "min", () => $6f2ebb3b224e236b$export$96ec731ed4dcb222, (v) => $6f2ebb3b224e236b$export$96ec731ed4dcb222 = v);
var $6f2ebb3b224e236b$export$96ec731ed4dcb222;
"use strict";

var $bNZmi = parcelRequire("bNZmi");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $6f2ebb3b224e236b$var$min(comparer) {
    return $bNZmi.min(comparer)(this);
}
$6f2ebb3b224e236b$export$96ec731ed4dcb222 = $6f2ebb3b224e236b$var$min;

});
parcelRegister("bNZmi", function(module, exports) {
$parcel$export(module.exports, "min", () => $8983ddd98e0d41aa$export$96ec731ed4dcb222, (v) => $8983ddd98e0d41aa$export$96ec731ed4dcb222 = v);
var $8983ddd98e0d41aa$export$96ec731ed4dcb222;
"use strict";

var $d2E9m = parcelRequire("d2E9m");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $8983ddd98e0d41aa$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $d2E9m.reduce(min);
}
$8983ddd98e0d41aa$export$96ec731ed4dcb222 = $8983ddd98e0d41aa$var$min;

});



parcelRegister("ejY3t", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $1QQiS = parcelRequire("1QQiS");
$fSYYZ.Observable.prototype.multicast = $1QQiS.multicast;

});
parcelRegister("1QQiS", function(module, exports) {
$parcel$export(module.exports, "multicast", () => $1593382c6f7bb64d$export$1364843af8d5a963, (v) => $1593382c6f7bb64d$export$1364843af8d5a963 = v);
var $1593382c6f7bb64d$export$1364843af8d5a963;
"use strict";

var $eZUXH = parcelRequire("eZUXH");
/* tslint:enable:max-line-length */ /**
 * Allows source Observable to be subscribed only once with a Subject of choice,
 * while still sharing its values between multiple subscribers.
 *
 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * `multicast` is an operator that works in two modes.
 *
 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
 *
 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
 * ConnectableObservable, use `refCount`.
 *
 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
 * as well, which should be the input stream modified by any operators you want. Note that in this
 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
 * but you want to subscribe to that Observable only once, this is the mode you would use.
 *
 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
 *
 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
 *
 * @example <caption>Use ConnectableObservable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const connectableSeconds = seconds.multicast(new Subject());
 *
 * connectableSeconds.subscribe(value => console.log('first: ' + value));
 * connectableSeconds.subscribe(value => console.log('second: ' + value));
 *
 * // At this point still nothing happens, even though we subscribed twice.
 *
 * connectableSeconds.connect();
 *
 * // From now on `seconds` are being logged to the console,
 * // twice per every second. `seconds` Observable was however only subscribed once,
 * // so under the hood Observable.interval had only one clock started.
 *
 * @example <caption>Use selector</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds
 *     .multicast(
 *         () => new Subject(),
 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
 *                                         // Because we are inside selector, `seconds` is subscribed once,
 *     )                                   // thus starting only one clock used internally by Observable.interval.
 *     .subscribe();
 *
 * @see {@link publish}
 * @see {@link publishLast}
 * @see {@link publishBehavior}
 * @see {@link publishReplay}
 * @see {@link share}
 * @see {@link shareReplay}
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
 * which the source sequence's elements will be multicast to the selector function input Observable or
 * ConnectableObservable returned by the operator.
 * @param {Function} [selector] - Optional selector function that can use the input stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the input source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
 *
 * @method multicast
 * @owner Observable
 */ function $1593382c6f7bb64d$var$multicast(subjectOrSubjectFactory, selector) {
    return $eZUXH.multicast(subjectOrSubjectFactory, selector)(this);
}
$1593382c6f7bb64d$export$1364843af8d5a963 = $1593382c6f7bb64d$var$multicast;

});
parcelRegister("eZUXH", function(module, exports) {
$parcel$export(module.exports, "multicast", () => $aeb2f2a03687ea56$export$1364843af8d5a963, (v) => $aeb2f2a03687ea56$export$1364843af8d5a963 = v);
var $aeb2f2a03687ea56$export$1364843af8d5a963;
var $aeb2f2a03687ea56$export$150d52413393bf2c;
"use strict";

var $4mMLC = parcelRequire("4mMLC");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */ function $aeb2f2a03687ea56$var$multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === 'function') return source.lift(new $aeb2f2a03687ea56$var$MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, $4mMLC.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
$aeb2f2a03687ea56$export$1364843af8d5a963 = $aeb2f2a03687ea56$var$multicast;
var $aeb2f2a03687ea56$var$MulticastOperator = function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();
$aeb2f2a03687ea56$export$150d52413393bf2c = $aeb2f2a03687ea56$var$MulticastOperator;

});
parcelRegister("4mMLC", function(module, exports) {
"use strict";
var $32df0ba03ea91984$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $fSYYZ = parcelRequire("fSYYZ");

var $8qR8S = parcelRequire("8qR8S");

var $aBkDT = parcelRequire("aBkDT");

var $9rQxt = parcelRequire("9rQxt");
/**
 * @class ConnectableObservable<T>
 */ var $32df0ba03ea91984$var$ConnectableObservable = function(_super) {
    $32df0ba03ea91984$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new $aBkDT.Subscription();
            connection.add(this.source.subscribe(new $32df0ba03ea91984$var$ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = $aBkDT.Subscription.EMPTY;
            } else this._connection = connection;
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $9rQxt.refCount()(this);
    };
    return ConnectableObservable;
}($fSYYZ.Observable);
module.exports.ConnectableObservable = $32df0ba03ea91984$var$ConnectableObservable;
var $32df0ba03ea91984$var$connectableProto = $32df0ba03ea91984$var$ConnectableObservable.prototype;
module.exports.connectableObservableDescriptor = {
    operator: {
        value: null
    },
    _refCount: {
        value: 0,
        writable: true
    },
    _subject: {
        value: null,
        writable: true
    },
    _connection: {
        value: null,
        writable: true
    },
    _subscribe: {
        value: $32df0ba03ea91984$var$connectableProto._subscribe
    },
    _isComplete: {
        value: $32df0ba03ea91984$var$connectableProto._isComplete,
        writable: true
    },
    getSubject: {
        value: $32df0ba03ea91984$var$connectableProto.getSubject
    },
    connect: {
        value: $32df0ba03ea91984$var$connectableProto.connect
    },
    refCount: {
        value: $32df0ba03ea91984$var$connectableProto.refCount
    }
};
var $32df0ba03ea91984$var$ConnectableSubscriber = function(_super) {
    $32df0ba03ea91984$var$__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}($bTlA1.SubjectSubscriber);
var $32df0ba03ea91984$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $32df0ba03ea91984$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $32df0ba03ea91984$var$RefCountSubscriber = function(_super) {
    $32df0ba03ea91984$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($8qR8S.Subscriber);

});
parcelRegister("9rQxt", function(module, exports) {
"use strict";
var $01c67117dbf98460$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
function $01c67117dbf98460$var$refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new $01c67117dbf98460$var$RefCountOperator(source));
    };
}
module.exports.refCount = $01c67117dbf98460$var$refCount;
var $01c67117dbf98460$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $01c67117dbf98460$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $01c67117dbf98460$var$RefCountSubscriber = function(_super) {
    $01c67117dbf98460$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($8qR8S.Subscriber);

});





parcelRegister("7F53D", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $iXCYU = parcelRequire("iXCYU");
$fSYYZ.Observable.prototype.observeOn = $iXCYU.observeOn;

});
parcelRegister("iXCYU", function(module, exports) {
$parcel$export(module.exports, "observeOn", () => $dcdbf990751f251a$export$9007f49c319d1ac7, (v) => $dcdbf990751f251a$export$9007f49c319d1ac7 = v);
var $dcdbf990751f251a$export$9007f49c319d1ac7;
"use strict";

var $auaKp = parcelRequire("auaKp");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $dcdbf990751f251a$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $auaKp.observeOn(scheduler, delay)(this);
}
$dcdbf990751f251a$export$9007f49c319d1ac7 = $dcdbf990751f251a$var$observeOn;

});


parcelRegister("lWjiv", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $kUMah = parcelRequire("kUMah");
$fSYYZ.Observable.prototype.onErrorResumeNext = $kUMah.onErrorResumeNext;

});
parcelRegister("kUMah", function(module, exports) {
$parcel$export(module.exports, "onErrorResumeNext", () => $f39e6621cb6538ea$export$5fba66d61591f42, (v) => $f39e6621cb6538ea$export$5fba66d61591f42 = v);
var $f39e6621cb6538ea$export$5fba66d61591f42;
"use strict";

var $3LIqA = parcelRequire("3LIqA");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $f39e6621cb6538ea$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    return $3LIqA.onErrorResumeNext.apply(void 0, nextSources)(this);
}
$f39e6621cb6538ea$export$5fba66d61591f42 = $f39e6621cb6538ea$var$onErrorResumeNext;

});


parcelRegister("cq5G1", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $cU0rL = parcelRequire("cU0rL");
$fSYYZ.Observable.prototype.pairwise = $cU0rL.pairwise;

});
parcelRegister("cU0rL", function(module, exports) {
$parcel$export(module.exports, "pairwise", () => $964b0fb53e5f8676$export$8f9d79d42bff1aac, (v) => $964b0fb53e5f8676$export$8f9d79d42bff1aac = v);
var $964b0fb53e5f8676$export$8f9d79d42bff1aac;
"use strict";

var $fFZyU = parcelRequire("fFZyU");
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $964b0fb53e5f8676$var$pairwise() {
    return $fFZyU.pairwise()(this);
}
$964b0fb53e5f8676$export$8f9d79d42bff1aac = $964b0fb53e5f8676$var$pairwise;

});
parcelRegister("fFZyU", function(module, exports) {
"use strict";
var $b69a704fce8cb8bb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $b69a704fce8cb8bb$var$pairwise() {
    return function(source) {
        return source.lift(new $b69a704fce8cb8bb$var$PairwiseOperator());
    };
}
module.exports.pairwise = $b69a704fce8cb8bb$var$pairwise;
var $b69a704fce8cb8bb$var$PairwiseOperator = function() {
    function PairwiseOperator() {}
    PairwiseOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b69a704fce8cb8bb$var$PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b69a704fce8cb8bb$var$PairwiseSubscriber = function(_super) {
    $b69a704fce8cb8bb$var$__extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function(value) {
        if (this.hasPrev) this.destination.next([
            this.prev,
            value
        ]);
        else this.hasPrev = true;
        this.prev = value;
    };
    return PairwiseSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("6WY02", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $qC88g = parcelRequire("qC88g");
$fSYYZ.Observable.prototype.partition = $qC88g.partition;

});
parcelRegister("qC88g", function(module, exports) {
$parcel$export(module.exports, "partition", () => $050001adff423256$export$b29f828819edca8d, (v) => $050001adff423256$export$b29f828819edca8d = v);
var $050001adff423256$export$b29f828819edca8d;
"use strict";

var $c69ly = parcelRequire("c69ly");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $050001adff423256$var$partition(predicate, thisArg) {
    return $c69ly.partition(predicate, thisArg)(this);
}
$050001adff423256$export$b29f828819edca8d = $050001adff423256$var$partition;

});
parcelRegister("c69ly", function(module, exports) {
$parcel$export(module.exports, "partition", () => $8ced4ba601a5b718$export$b29f828819edca8d, (v) => $8ced4ba601a5b718$export$b29f828819edca8d = v);
var $8ced4ba601a5b718$export$b29f828819edca8d;
"use strict";

var $3Y4uL = parcelRequire("3Y4uL");

var $6gAgO = parcelRequire("6gAgO");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $8ced4ba601a5b718$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $6gAgO.filter(predicate, thisArg)(source),
            $6gAgO.filter($3Y4uL.not(predicate, thisArg))(source)
        ];
    };
}
$8ced4ba601a5b718$export$b29f828819edca8d = $8ced4ba601a5b718$var$partition;

});
parcelRegister("3Y4uL", function(module, exports) {
$parcel$export(module.exports, "not", () => $2e3a765b1356f47a$export$6003a5f097c73977, (v) => $2e3a765b1356f47a$export$6003a5f097c73977 = v);
var $2e3a765b1356f47a$export$6003a5f097c73977;
"use strict";
function $2e3a765b1356f47a$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$2e3a765b1356f47a$export$6003a5f097c73977 = $2e3a765b1356f47a$var$not;

});




parcelRegister("2LLLC", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $fzbJz = parcelRequire("fzbJz");
$fSYYZ.Observable.prototype.pluck = $fzbJz.pluck;

});
parcelRegister("fzbJz", function(module, exports) {
$parcel$export(module.exports, "pluck", () => $b5533a035c71aae9$export$c44985b87d605eff, (v) => $b5533a035c71aae9$export$c44985b87d605eff = v);
var $b5533a035c71aae9$export$c44985b87d605eff;
"use strict";

var $4fHnI = parcelRequire("4fHnI");
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $b5533a035c71aae9$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    return $4fHnI.pluck.apply(void 0, properties)(this);
}
$b5533a035c71aae9$export$c44985b87d605eff = $b5533a035c71aae9$var$pluck;

});
parcelRegister("4fHnI", function(module, exports) {
$parcel$export(module.exports, "pluck", () => $318a36cc6507005e$export$c44985b87d605eff, (v) => $318a36cc6507005e$export$c44985b87d605eff = v);
var $318a36cc6507005e$export$c44985b87d605eff;
"use strict";

var $a8ocL = parcelRequire("a8ocL");
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $318a36cc6507005e$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return function(source) {
        return $a8ocL.map($318a36cc6507005e$var$plucker(properties, length))(source);
    };
}
$318a36cc6507005e$export$c44985b87d605eff = $318a36cc6507005e$var$pluck;
function $318a36cc6507005e$var$plucker(props, length) {
    var mapper = function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    };
    return mapper;
}

});



parcelRegister("fpBmy", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $luu6m = parcelRequire("luu6m");
$fSYYZ.Observable.prototype.publish = $luu6m.publish;

});
parcelRegister("luu6m", function(module, exports) {
$parcel$export(module.exports, "publish", () => $fa53bfd994175d4a$export$89b472e03be495df, (v) => $fa53bfd994175d4a$export$89b472e03be495df = v);
var $fa53bfd994175d4a$export$89b472e03be495df;
"use strict";

var $3c6DP = parcelRequire("3c6DP");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $fa53bfd994175d4a$var$publish(selector) {
    return $3c6DP.publish(selector)(this);
}
$fa53bfd994175d4a$export$89b472e03be495df = $fa53bfd994175d4a$var$publish;

});
parcelRegister("3c6DP", function(module, exports) {
$parcel$export(module.exports, "publish", () => $2537a4ea4ad5bb78$export$89b472e03be495df, (v) => $2537a4ea4ad5bb78$export$89b472e03be495df = v);
var $2537a4ea4ad5bb78$export$89b472e03be495df;
"use strict";

var $bTlA1 = parcelRequire("bTlA1");

var $eZUXH = parcelRequire("eZUXH");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $2537a4ea4ad5bb78$var$publish(selector) {
    return selector ? $eZUXH.multicast(function() {
        return new $bTlA1.Subject();
    }, selector) : $eZUXH.multicast(new $bTlA1.Subject());
}
$2537a4ea4ad5bb78$export$89b472e03be495df = $2537a4ea4ad5bb78$var$publish;

});



parcelRegister("slMhX", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $6Ibj2 = parcelRequire("6Ibj2");
$fSYYZ.Observable.prototype.publishBehavior = $6Ibj2.publishBehavior;

});
parcelRegister("6Ibj2", function(module, exports) {
$parcel$export(module.exports, "publishBehavior", () => $4e2f9f45fa03074e$export$16ae46fda9567053, (v) => $4e2f9f45fa03074e$export$16ae46fda9567053 = v);
var $4e2f9f45fa03074e$export$16ae46fda9567053;
"use strict";

var $3LSnj = parcelRequire("3LSnj");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $4e2f9f45fa03074e$var$publishBehavior(value) {
    return $3LSnj.publishBehavior(value)(this);
}
$4e2f9f45fa03074e$export$16ae46fda9567053 = $4e2f9f45fa03074e$var$publishBehavior;

});
parcelRegister("3LSnj", function(module, exports) {
$parcel$export(module.exports, "publishBehavior", () => $2beff0a619d27643$export$16ae46fda9567053, (v) => $2beff0a619d27643$export$16ae46fda9567053 = v);
var $2beff0a619d27643$export$16ae46fda9567053;
"use strict";

var $5YUlS = parcelRequire("5YUlS");

var $eZUXH = parcelRequire("eZUXH");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $2beff0a619d27643$var$publishBehavior(value) {
    return function(source) {
        return $eZUXH.multicast(new $5YUlS.BehaviorSubject(value))(source);
    };
}
$2beff0a619d27643$export$16ae46fda9567053 = $2beff0a619d27643$var$publishBehavior;

});
parcelRegister("5YUlS", function(module, exports) {
"use strict";
var $45ae44a4802a6b58$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $eDWrK = parcelRequire("eDWrK");
/**
 * @class BehaviorSubject<T>
 */ var $45ae44a4802a6b58$var$BehaviorSubject = function(_super) {
    $45ae44a4802a6b58$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $eDWrK.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($bTlA1.Subject);
module.exports.BehaviorSubject = $45ae44a4802a6b58$var$BehaviorSubject;

});




parcelRegister("jWkIz", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $brrbW = parcelRequire("brrbW");
$fSYYZ.Observable.prototype.publishReplay = $brrbW.publishReplay;

});
parcelRegister("brrbW", function(module, exports) {
$parcel$export(module.exports, "publishReplay", () => $85474f0487fe9c83$export$1f3342bf81d92d52, (v) => $85474f0487fe9c83$export$1f3342bf81d92d52 = v);
var $85474f0487fe9c83$export$1f3342bf81d92d52;
"use strict";

var $aPWBE = parcelRequire("aPWBE");
/* tslint:enable:max-line-length */ /**
 * @param bufferSize
 * @param windowTime
 * @param selectorOrScheduler
 * @param scheduler
 * @return {Observable<T> | ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */ function $85474f0487fe9c83$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    return $aPWBE.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
}
$85474f0487fe9c83$export$1f3342bf81d92d52 = $85474f0487fe9c83$var$publishReplay;

});
parcelRegister("aPWBE", function(module, exports) {
$parcel$export(module.exports, "publishReplay", () => $7e3c20cd25768c4b$export$1f3342bf81d92d52, (v) => $7e3c20cd25768c4b$export$1f3342bf81d92d52 = v);
var $7e3c20cd25768c4b$export$1f3342bf81d92d52;
"use strict";

var $1PAG0 = parcelRequire("1PAG0");

var $eZUXH = parcelRequire("eZUXH");
/* tslint:enable:max-line-length */ function $7e3c20cd25768c4b$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $1PAG0.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $eZUXH.multicast(function() {
            return subject;
        }, selector)(source);
    };
}
$7e3c20cd25768c4b$export$1f3342bf81d92d52 = $7e3c20cd25768c4b$var$publishReplay;

});



parcelRegister("4eGeb", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $4n5I6 = parcelRequire("4n5I6");
$fSYYZ.Observable.prototype.publishLast = $4n5I6.publishLast;

});
parcelRegister("4n5I6", function(module, exports) {
$parcel$export(module.exports, "publishLast", () => $32edbd5c319e90a7$export$42d9b6b38c68d989, (v) => $32edbd5c319e90a7$export$42d9b6b38c68d989 = v);
var $32edbd5c319e90a7$export$42d9b6b38c68d989;
"use strict";

var $hIwwO = parcelRequire("hIwwO");
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */ function $32edbd5c319e90a7$var$publishLast() {
    //TODO(benlesh): correct type-flow through here.
    return $hIwwO.publishLast()(this);
}
$32edbd5c319e90a7$export$42d9b6b38c68d989 = $32edbd5c319e90a7$var$publishLast;

});
parcelRegister("hIwwO", function(module, exports) {
$parcel$export(module.exports, "publishLast", () => $ce5fc72ce94f403a$export$42d9b6b38c68d989, (v) => $ce5fc72ce94f403a$export$42d9b6b38c68d989 = v);
var $ce5fc72ce94f403a$export$42d9b6b38c68d989;
"use strict";

var $16pOr = parcelRequire("16pOr");

var $eZUXH = parcelRequire("eZUXH");
function $ce5fc72ce94f403a$var$publishLast() {
    return function(source) {
        return $eZUXH.multicast(new $16pOr.AsyncSubject())(source);
    };
}
$ce5fc72ce94f403a$export$42d9b6b38c68d989 = $ce5fc72ce94f403a$var$publishLast;

});



parcelRegister("gz9r1", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $jRQFa = parcelRequire("jRQFa");
$fSYYZ.Observable.prototype.race = $jRQFa.race;

});
parcelRegister("jRQFa", function(module, exports) {
$parcel$export(module.exports, "race", () => $e76bd1509b2899f5$export$236c05de452bec2, (v) => $e76bd1509b2899f5$export$236c05de452bec2 = v);
var $e76bd1509b2899f5$export$dc3f181b77d95dcc;
var $e76bd1509b2899f5$export$236c05de452bec2;
"use strict";

var $5Osch = parcelRequire("5Osch");

var $8fzNb = parcelRequire("8fzNb");
$e76bd1509b2899f5$export$dc3f181b77d95dcc = $8fzNb.race;
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $e76bd1509b2899f5$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $5Osch.race.apply(void 0, observables)(this);
}
$e76bd1509b2899f5$export$236c05de452bec2 = $e76bd1509b2899f5$var$race;

});
parcelRegister("5Osch", function(module, exports) {
$parcel$export(module.exports, "race", () => $43b77e9a61ff38ba$export$236c05de452bec2, (v) => $43b77e9a61ff38ba$export$236c05de452bec2 = v);
var $43b77e9a61ff38ba$export$236c05de452bec2;
"use strict";

var $5G96M = parcelRequire("5G96M");

var $8fzNb = parcelRequire("8fzNb");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $43b77e9a61ff38ba$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $5G96M.isArray(observables[0])) observables = observables[0];
        return source.lift.call($8fzNb.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$43b77e9a61ff38ba$export$236c05de452bec2 = $43b77e9a61ff38ba$var$race;

});



parcelRegister("619O0", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $2RZ6G = parcelRequire("2RZ6G");
$fSYYZ.Observable.prototype.reduce = $2RZ6G.reduce;

});
parcelRegister("2RZ6G", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $216fee8b718817ee$export$533b26079ad0b4b, (v) => $216fee8b718817ee$export$533b26079ad0b4b = v);
var $216fee8b718817ee$export$533b26079ad0b4b;
"use strict";

var $d2E9m = parcelRequire("d2E9m");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $216fee8b718817ee$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return $d2E9m.reduce(accumulator, seed)(this);
    return $d2E9m.reduce(accumulator)(this);
}
$216fee8b718817ee$export$533b26079ad0b4b = $216fee8b718817ee$var$reduce;

});


parcelRegister("fkuNu", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $6rwhJ = parcelRequire("6rwhJ");
$fSYYZ.Observable.prototype.repeat = $6rwhJ.repeat;

});
parcelRegister("6rwhJ", function(module, exports) {
$parcel$export(module.exports, "repeat", () => $4b0e4ed5f5692a4b$export$76d90c956114f2c2, (v) => $4b0e4ed5f5692a4b$export$76d90c956114f2c2 = v);
var $4b0e4ed5f5692a4b$export$76d90c956114f2c2;
"use strict";

var $fAyAG = parcelRequire("fAyAG");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $4b0e4ed5f5692a4b$var$repeat(count) {
    if (count === void 0) count = -1;
    return $fAyAG.repeat(count)(this);
}
$4b0e4ed5f5692a4b$export$76d90c956114f2c2 = $4b0e4ed5f5692a4b$var$repeat;

});
parcelRegister("fAyAG", function(module, exports) {
"use strict";
var $b5950ccb3f0f3e2e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $fyVhl = parcelRequire("fyVhl");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $b5950ccb3f0f3e2e$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $fyVhl.EmptyObservable();
        else if (count < 0) return source.lift(new $b5950ccb3f0f3e2e$var$RepeatOperator(-1, source));
        else return source.lift(new $b5950ccb3f0f3e2e$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $b5950ccb3f0f3e2e$var$repeat;
var $b5950ccb3f0f3e2e$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b5950ccb3f0f3e2e$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b5950ccb3f0f3e2e$var$RepeatSubscriber = function(_super) {
    $b5950ccb3f0f3e2e$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("jNH9H", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $dVNCo = parcelRequire("dVNCo");
$fSYYZ.Observable.prototype.repeatWhen = $dVNCo.repeatWhen;

});
parcelRegister("dVNCo", function(module, exports) {
$parcel$export(module.exports, "repeatWhen", () => $a2471664d0010878$export$b39ac5b4ffd1415a, (v) => $a2471664d0010878$export$b39ac5b4ffd1415a = v);
var $a2471664d0010878$export$b39ac5b4ffd1415a;
"use strict";

var $ia4pH = parcelRequire("ia4pH");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $a2471664d0010878$var$repeatWhen(notifier) {
    return $ia4pH.repeatWhen(notifier)(this);
}
$a2471664d0010878$export$b39ac5b4ffd1415a = $a2471664d0010878$var$repeatWhen;

});
parcelRegister("ia4pH", function(module, exports) {
"use strict";
var $d38c95942097d15f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $d38c95942097d15f$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $d38c95942097d15f$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $d38c95942097d15f$var$repeatWhen;
var $d38c95942097d15f$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d38c95942097d15f$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d38c95942097d15f$var$RepeatWhenSubscriber = function(_super) {
    $d38c95942097d15f$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $bTlA1.Subject();
        var retries = $3XqeD.tryCatch(this.notifier)(this.notifications);
        if (retries === $h0Tv0.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $2Q6Ms.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("4P4PG", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $29jzL = parcelRequire("29jzL");
$fSYYZ.Observable.prototype.retry = $29jzL.retry;

});
parcelRegister("29jzL", function(module, exports) {
$parcel$export(module.exports, "retry", () => $190b9b67430ee326$export$9369b12211e1fce4, (v) => $190b9b67430ee326$export$9369b12211e1fce4 = v);
var $190b9b67430ee326$export$9369b12211e1fce4;
"use strict";

var $aNZ13 = parcelRequire("aNZ13");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $190b9b67430ee326$var$retry(count) {
    if (count === void 0) count = -1;
    return $aNZ13.retry(count)(this);
}
$190b9b67430ee326$export$9369b12211e1fce4 = $190b9b67430ee326$var$retry;

});
parcelRegister("aNZ13", function(module, exports) {
"use strict";
var $7dddcf7dd12400f2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $7dddcf7dd12400f2$var$retry(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new $7dddcf7dd12400f2$var$RetryOperator(count, source));
    };
}
module.exports.retry = $7dddcf7dd12400f2$var$retry;
var $7dddcf7dd12400f2$var$RetryOperator = function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7dddcf7dd12400f2$var$RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7dddcf7dd12400f2$var$RetrySubscriber = function(_super) {
    $7dddcf7dd12400f2$var$__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("9ah3j", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $1fxoU = parcelRequire("1fxoU");
$fSYYZ.Observable.prototype.retryWhen = $1fxoU.retryWhen;

});
parcelRegister("1fxoU", function(module, exports) {
$parcel$export(module.exports, "retryWhen", () => $0e9119e012c138e7$export$1281551253cfee02, (v) => $0e9119e012c138e7$export$1281551253cfee02 = v);
var $0e9119e012c138e7$export$1281551253cfee02;
"use strict";

var $cxRbl = parcelRequire("cxRbl");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $0e9119e012c138e7$var$retryWhen(notifier) {
    return $cxRbl.retryWhen(notifier)(this);
}
$0e9119e012c138e7$export$1281551253cfee02 = $0e9119e012c138e7$var$retryWhen;

});
parcelRegister("cxRbl", function(module, exports) {
"use strict";
var $9221d1f485b3ee25$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $9221d1f485b3ee25$var$retryWhen(notifier) {
    return function(source) {
        return source.lift(new $9221d1f485b3ee25$var$RetryWhenOperator(notifier, source));
    };
}
module.exports.retryWhen = $9221d1f485b3ee25$var$retryWhen;
var $9221d1f485b3ee25$var$RetryWhenOperator = function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9221d1f485b3ee25$var$RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9221d1f485b3ee25$var$RetryWhenSubscriber = function(_super) {
    $9221d1f485b3ee25$var$__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new $bTlA1.Subject();
                retries = $3XqeD.tryCatch(this.notifier)(errors);
                if (retries === $h0Tv0.errorObject) return _super.prototype.error.call(this, $h0Tv0.errorObject.e);
                retriesSubscription = $2Q6Ms.subscribeToResult(this, retries);
            } else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("1Qzd1", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $6ffdm = parcelRequire("6ffdm");
$fSYYZ.Observable.prototype.sample = $6ffdm.sample;

});
parcelRegister("6ffdm", function(module, exports) {
$parcel$export(module.exports, "sample", () => $48bff2111bc03fd8$export$4812e460280c6ef2, (v) => $48bff2111bc03fd8$export$4812e460280c6ef2 = v);
var $48bff2111bc03fd8$export$4812e460280c6ef2;
"use strict";

var $ktFkz = parcelRequire("ktFkz");
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $48bff2111bc03fd8$var$sample(notifier) {
    return $ktFkz.sample(notifier)(this);
}
$48bff2111bc03fd8$export$4812e460280c6ef2 = $48bff2111bc03fd8$var$sample;

});
parcelRegister("ktFkz", function(module, exports) {
"use strict";
var $ee86938605ce5cdd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $ee86938605ce5cdd$var$sample(notifier) {
    return function(source) {
        return source.lift(new $ee86938605ce5cdd$var$SampleOperator(notifier));
    };
}
module.exports.sample = $ee86938605ce5cdd$var$sample;
var $ee86938605ce5cdd$var$SampleOperator = function() {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function(subscriber, source) {
        var sampleSubscriber = new $ee86938605ce5cdd$var$SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add($2Q6Ms.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ee86938605ce5cdd$var$SampleSubscriber = function(_super) {
    $ee86938605ce5cdd$var$__extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("l91U6", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $fTO8t = parcelRequire("fTO8t");
$fSYYZ.Observable.prototype.sampleTime = $fTO8t.sampleTime;

});
parcelRegister("fTO8t", function(module, exports) {
$parcel$export(module.exports, "sampleTime", () => $b932e1f5e9e78ca1$export$fe33c7b2002d97b0, (v) => $b932e1f5e9e78ca1$export$fe33c7b2002d97b0 = v);
var $b932e1f5e9e78ca1$export$fe33c7b2002d97b0;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $8vhnd = parcelRequire("8vhnd");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $b932e1f5e9e78ca1$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $8vhnd.sampleTime(period, scheduler)(this);
}
$b932e1f5e9e78ca1$export$fe33c7b2002d97b0 = $b932e1f5e9e78ca1$var$sampleTime;

});
parcelRegister("8vhnd", function(module, exports) {
"use strict";
var $630eb2008f733f57$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $gFD0E = parcelRequire("gFD0E");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $630eb2008f733f57$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return function(source) {
        return source.lift(new $630eb2008f733f57$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $630eb2008f733f57$var$sampleTime;
var $630eb2008f733f57$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $630eb2008f733f57$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $630eb2008f733f57$var$SampleTimeSubscriber = function(_super) {
    $630eb2008f733f57$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($630eb2008f733f57$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($8qR8S.Subscriber);
function $630eb2008f733f57$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

});



parcelRegister("6Rwnw", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $l2GPE = parcelRequire("l2GPE");
$fSYYZ.Observable.prototype.scan = $l2GPE.scan;

});
parcelRegister("l2GPE", function(module, exports) {
$parcel$export(module.exports, "scan", () => $f51b027565659844$export$c87d910e63d22ed6, (v) => $f51b027565659844$export$c87d910e63d22ed6 = v);
var $f51b027565659844$export$c87d910e63d22ed6;
"use strict";

var $9PjKc = parcelRequire("9PjKc");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $f51b027565659844$var$scan(accumulator, seed) {
    if (arguments.length >= 2) return $9PjKc.scan(accumulator, seed)(this);
    return $9PjKc.scan(accumulator)(this);
}
$f51b027565659844$export$c87d910e63d22ed6 = $f51b027565659844$var$scan;

});


parcelRegister("ejt2r", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $8m6WB = parcelRequire("8m6WB");
$fSYYZ.Observable.prototype.sequenceEqual = $8m6WB.sequenceEqual;

});
parcelRegister("8m6WB", function(module, exports) {
$parcel$export(module.exports, "sequenceEqual", () => $6155c3c467f29411$export$d0a07e60ae428313, (v) => $6155c3c467f29411$export$d0a07e60ae428313 = v);
var $6155c3c467f29411$export$d0a07e60ae428313;
"use strict";

var $8i6Wf = parcelRequire("8i6Wf");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $6155c3c467f29411$var$sequenceEqual(compareTo, comparor) {
    return $8i6Wf.sequenceEqual(compareTo, comparor)(this);
}
$6155c3c467f29411$export$d0a07e60ae428313 = $6155c3c467f29411$var$sequenceEqual;

});
parcelRegister("8i6Wf", function(module, exports) {
"use strict";
var $6095630812ff86c7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $6095630812ff86c7$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $6095630812ff86c7$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $6095630812ff86c7$var$sequenceEqual;
var $6095630812ff86c7$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6095630812ff86c7$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $6095630812ff86c7$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6095630812ff86c7$var$SequenceEqualSubscriber = function(_super) {
    $6095630812ff86c7$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $6095630812ff86c7$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $3XqeD.tryCatch(comparor)(a, b);
                if (areEqual === $h0Tv0.errorObject) this.destination.error($h0Tv0.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($8qR8S.Subscriber);
module.exports.SequenceEqualSubscriber = $6095630812ff86c7$var$SequenceEqualSubscriber;
var $6095630812ff86c7$var$SequenceEqualCompareToSubscriber = function(_super) {
    $6095630812ff86c7$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("37wBt", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $4pgqI = parcelRequire("4pgqI");
$fSYYZ.Observable.prototype.share = $4pgqI.share;

});
parcelRegister("4pgqI", function(module, exports) {
$parcel$export(module.exports, "share", () => $33563de241f7d5c8$export$ed80d9de1d9df928, (v) => $33563de241f7d5c8$export$ed80d9de1d9df928 = v);
var $33563de241f7d5c8$export$ed80d9de1d9df928;
"use strict";

var $5rPGq = parcelRequire("5rPGq");
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $33563de241f7d5c8$var$share() {
    return $5rPGq.share()(this);
}
$33563de241f7d5c8$export$ed80d9de1d9df928 = $33563de241f7d5c8$var$share;

});
parcelRegister("5rPGq", function(module, exports) {
$parcel$export(module.exports, "share", () => $3f77909786e698b7$export$ed80d9de1d9df928, (v) => $3f77909786e698b7$export$ed80d9de1d9df928 = v);
var $3f77909786e698b7$export$ed80d9de1d9df928;
"use strict";

var $eZUXH = parcelRequire("eZUXH");

var $9rQxt = parcelRequire("9rQxt");

var $bTlA1 = parcelRequire("bTlA1");
function $3f77909786e698b7$var$shareSubjectFactory() {
    return new $bTlA1.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $3f77909786e698b7$var$share() {
    return function(source) {
        return $9rQxt.refCount()($eZUXH.multicast($3f77909786e698b7$var$shareSubjectFactory)(source));
    };
}
$3f77909786e698b7$export$ed80d9de1d9df928 = $3f77909786e698b7$var$share;

});



parcelRegister("d0r0I", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $3cBCS = parcelRequire("3cBCS");
$fSYYZ.Observable.prototype.shareReplay = $3cBCS.shareReplay;

});
parcelRegister("3cBCS", function(module, exports) {
$parcel$export(module.exports, "shareReplay", () => $254fadd3e8ecdb35$export$db61d692014e534e, (v) => $254fadd3e8ecdb35$export$db61d692014e534e = v);
var $254fadd3e8ecdb35$export$db61d692014e534e;
"use strict";

var $5iQVm = parcelRequire("5iQVm");
/**
 * @method shareReplay
 * @owner Observable
 */ function $254fadd3e8ecdb35$var$shareReplay(bufferSize, windowTime, scheduler) {
    return $5iQVm.shareReplay(bufferSize, windowTime, scheduler)(this);
}
$254fadd3e8ecdb35$export$db61d692014e534e = $254fadd3e8ecdb35$var$shareReplay;

});
parcelRegister("5iQVm", function(module, exports) {
$parcel$export(module.exports, "shareReplay", () => $3dc7afce846f9e37$export$db61d692014e534e, (v) => $3dc7afce846f9e37$export$db61d692014e534e = v);
var $3dc7afce846f9e37$export$db61d692014e534e;
"use strict";

var $1PAG0 = parcelRequire("1PAG0");
/**
 * @method shareReplay
 * @owner Observable
 */ function $3dc7afce846f9e37$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($3dc7afce846f9e37$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$3dc7afce846f9e37$export$db61d692014e534e = $3dc7afce846f9e37$var$shareReplay;
function $3dc7afce846f9e37$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $1PAG0.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}

});



parcelRegister("kT6Jb", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $7HT2g = parcelRequire("7HT2g");
$fSYYZ.Observable.prototype.single = $7HT2g.single;

});
parcelRegister("7HT2g", function(module, exports) {
$parcel$export(module.exports, "single", () => $59c73d703122c31f$export$863d7ca51b416cee, (v) => $59c73d703122c31f$export$863d7ca51b416cee = v);
var $59c73d703122c31f$export$863d7ca51b416cee;
"use strict";

var $ilSU2 = parcelRequire("ilSU2");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $59c73d703122c31f$var$single(predicate) {
    return $ilSU2.single(predicate)(this);
}
$59c73d703122c31f$export$863d7ca51b416cee = $59c73d703122c31f$var$single;

});
parcelRegister("ilSU2", function(module, exports) {
"use strict";
var $d5c4c6ba06361ae5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $jUTRE = parcelRequire("jUTRE");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $d5c4c6ba06361ae5$var$single(predicate) {
    return function(source) {
        return source.lift(new $d5c4c6ba06361ae5$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $d5c4c6ba06361ae5$var$single;
var $d5c4c6ba06361ae5$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d5c4c6ba06361ae5$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d5c4c6ba06361ae5$var$SingleSubscriber = function(_super) {
    $d5c4c6ba06361ae5$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $jUTRE.EmptyError);
    };
    return SingleSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("essAN", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $8vnsV = parcelRequire("8vnsV");
$fSYYZ.Observable.prototype.skip = $8vnsV.skip;

});
parcelRegister("8vnsV", function(module, exports) {
$parcel$export(module.exports, "skip", () => $63136bc0956c65f3$export$955fc4a6c4be454d, (v) => $63136bc0956c65f3$export$955fc4a6c4be454d = v);
var $63136bc0956c65f3$export$955fc4a6c4be454d;
"use strict";

var $49GtU = parcelRequire("49GtU");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $63136bc0956c65f3$var$skip(count) {
    return $49GtU.skip(count)(this);
}
$63136bc0956c65f3$export$955fc4a6c4be454d = $63136bc0956c65f3$var$skip;

});
parcelRegister("49GtU", function(module, exports) {
"use strict";
var $3068f4979de4694a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $3068f4979de4694a$var$skip(count) {
    return function(source) {
        return source.lift(new $3068f4979de4694a$var$SkipOperator(count));
    };
}
module.exports.skip = $3068f4979de4694a$var$skip;
var $3068f4979de4694a$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3068f4979de4694a$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3068f4979de4694a$var$SkipSubscriber = function(_super) {
    $3068f4979de4694a$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("1IH9O", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $iO1HI = parcelRequire("iO1HI");
$fSYYZ.Observable.prototype.skipLast = $iO1HI.skipLast;

});
parcelRegister("iO1HI", function(module, exports) {
$parcel$export(module.exports, "skipLast", () => $db0e37e56c7d88cb$export$635f6273df29ea1c, (v) => $db0e37e56c7d88cb$export$635f6273df29ea1c = v);
var $db0e37e56c7d88cb$export$635f6273df29ea1c;
"use strict";

var $gpvz2 = parcelRequire("gpvz2");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $db0e37e56c7d88cb$var$skipLast(count) {
    return $gpvz2.skipLast(count)(this);
}
$db0e37e56c7d88cb$export$635f6273df29ea1c = $db0e37e56c7d88cb$var$skipLast;

});
parcelRegister("gpvz2", function(module, exports) {
"use strict";
var $bf277720a7a35f86$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $9JK9X = parcelRequire("9JK9X");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $bf277720a7a35f86$var$skipLast(count) {
    return function(source) {
        return source.lift(new $bf277720a7a35f86$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $bf277720a7a35f86$var$skipLast;
var $bf277720a7a35f86$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $9JK9X.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $8qR8S.Subscriber(subscriber));
        else return source.subscribe(new $bf277720a7a35f86$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bf277720a7a35f86$var$SkipLastSubscriber = function(_super) {
    $bf277720a7a35f86$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("5DO4t", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $jj8ma = parcelRequire("jj8ma");
$fSYYZ.Observable.prototype.skipUntil = $jj8ma.skipUntil;

});
parcelRegister("jj8ma", function(module, exports) {
$parcel$export(module.exports, "skipUntil", () => $e0e6461c41d106ad$export$facc584867c26fde, (v) => $e0e6461c41d106ad$export$facc584867c26fde = v);
var $e0e6461c41d106ad$export$facc584867c26fde;
"use strict";

var $2TJZF = parcelRequire("2TJZF");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $e0e6461c41d106ad$var$skipUntil(notifier) {
    return $2TJZF.skipUntil(notifier)(this);
}
$e0e6461c41d106ad$export$facc584867c26fde = $e0e6461c41d106ad$var$skipUntil;

});
parcelRegister("2TJZF", function(module, exports) {
"use strict";
var $21c465340331295f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $21c465340331295f$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $21c465340331295f$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $21c465340331295f$var$skipUntil;
var $21c465340331295f$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $21c465340331295f$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $21c465340331295f$var$SkipUntilSubscriber = function(_super) {
    $21c465340331295f$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($2Q6Ms.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("ihsE6", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $jOaOd = parcelRequire("jOaOd");
$fSYYZ.Observable.prototype.skipWhile = $jOaOd.skipWhile;

});
parcelRegister("jOaOd", function(module, exports) {
$parcel$export(module.exports, "skipWhile", () => $e6bb12485d88064e$export$175dedd748069215, (v) => $e6bb12485d88064e$export$175dedd748069215 = v);
var $e6bb12485d88064e$export$175dedd748069215;
"use strict";

var $8PxWq = parcelRequire("8PxWq");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $e6bb12485d88064e$var$skipWhile(predicate) {
    return $8PxWq.skipWhile(predicate)(this);
}
$e6bb12485d88064e$export$175dedd748069215 = $e6bb12485d88064e$var$skipWhile;

});
parcelRegister("8PxWq", function(module, exports) {
"use strict";
var $66dd6a3230d27e2d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $66dd6a3230d27e2d$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $66dd6a3230d27e2d$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $66dd6a3230d27e2d$var$skipWhile;
var $66dd6a3230d27e2d$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $66dd6a3230d27e2d$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $66dd6a3230d27e2d$var$SkipWhileSubscriber = function(_super) {
    $66dd6a3230d27e2d$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("2iNoG", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $bDUjP = parcelRequire("bDUjP");
$fSYYZ.Observable.prototype.startWith = $bDUjP.startWith;

});
parcelRegister("bDUjP", function(module, exports) {
$parcel$export(module.exports, "startWith", () => $879f05fd8e2fa621$export$a4fe86229b0e9bdd, (v) => $879f05fd8e2fa621$export$a4fe86229b0e9bdd = v);
var $879f05fd8e2fa621$export$a4fe86229b0e9bdd;
"use strict";

var $dsNFs = parcelRequire("dsNFs");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $879f05fd8e2fa621$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return $dsNFs.startWith.apply(void 0, array)(this);
}
$879f05fd8e2fa621$export$a4fe86229b0e9bdd = $879f05fd8e2fa621$var$startWith;

});
parcelRegister("dsNFs", function(module, exports) {
$parcel$export(module.exports, "startWith", () => $9cd46adce377a920$export$a4fe86229b0e9bdd, (v) => $9cd46adce377a920$export$a4fe86229b0e9bdd = v);
var $9cd46adce377a920$export$a4fe86229b0e9bdd;
"use strict";

var $iLZ0l = parcelRequire("iLZ0l");

var $35Srn = parcelRequire("35Srn");

var $fyVhl = parcelRequire("fyVhl");

var $jpGTf = parcelRequire("jpGTf");

var $bOxHY = parcelRequire("bOxHY");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $9cd46adce377a920$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return function(source) {
        var scheduler = array[array.length - 1];
        if ($bOxHY.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len === 1) return $jpGTf.concat(new $35Srn.ScalarObservable(array[0], scheduler), source);
        else if (len > 1) return $jpGTf.concat(new $iLZ0l.ArrayObservable(array, scheduler), source);
        else return $jpGTf.concat(new $fyVhl.EmptyObservable(scheduler), source);
    };
}
$9cd46adce377a920$export$a4fe86229b0e9bdd = $9cd46adce377a920$var$startWith;

});



parcelRegister("ftnPc", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $LynhL = parcelRequire("LynhL");
$fSYYZ.Observable.prototype.subscribeOn = $LynhL.subscribeOn;

});
parcelRegister("LynhL", function(module, exports) {
$parcel$export(module.exports, "subscribeOn", () => $08ef0df99921b160$export$1eb44d8f5f64733b, (v) => $08ef0df99921b160$export$1eb44d8f5f64733b = v);
var $08ef0df99921b160$export$1eb44d8f5f64733b;
"use strict";

var $dHydE = parcelRequire("dHydE");
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */ function $08ef0df99921b160$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $dHydE.subscribeOn(scheduler, delay)(this);
}
$08ef0df99921b160$export$1eb44d8f5f64733b = $08ef0df99921b160$var$subscribeOn;

});
parcelRegister("dHydE", function(module, exports) {
$parcel$export(module.exports, "subscribeOn", () => $9f99d5bc2a4e2ad8$export$1eb44d8f5f64733b, (v) => $9f99d5bc2a4e2ad8$export$1eb44d8f5f64733b = v);
var $9f99d5bc2a4e2ad8$export$1eb44d8f5f64733b;
"use strict";

var $beTsm = parcelRequire("beTsm");
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */ function $9f99d5bc2a4e2ad8$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new $9f99d5bc2a4e2ad8$var$SubscribeOnOperator(scheduler, delay));
    };
}
$9f99d5bc2a4e2ad8$export$1eb44d8f5f64733b = $9f99d5bc2a4e2ad8$var$subscribeOn;
var $9f99d5bc2a4e2ad8$var$SubscribeOnOperator = function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new $beTsm.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

});
parcelRegister("beTsm", function(module, exports) {
"use strict";
var $82ec0504a260074b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $2SiZJ = parcelRequire("2SiZJ");

var $f3TUk = parcelRequire("f3TUk");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $82ec0504a260074b$var$SubscribeOnObservable = function(_super) {
    $82ec0504a260074b$var$__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = $2SiZJ.asap;
        _super.call(this);
        this.source = source;
        this.delayTime = delayTime;
        this.scheduler = scheduler;
        if (!$f3TUk.isNumeric(delayTime) || delayTime < 0) this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== 'function') this.scheduler = $2SiZJ.asap;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = $2SiZJ.asap;
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    /** @deprecated internal use only */ SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}($fSYYZ.Observable);
module.exports.SubscribeOnObservable = $82ec0504a260074b$var$SubscribeOnObservable;

});
parcelRegister("2SiZJ", function(module, exports) {
$parcel$export(module.exports, "asap", () => $217f5bd9891560b5$export$dc4d482300a341e1, (v) => $217f5bd9891560b5$export$dc4d482300a341e1 = v);
/**
 *
 * Asap Scheduler
 *
 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
 *
 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
 * code to end and then it will try to execute given task as fast as possible.
 *
 * `asap` scheduler will do its best to minimize time between end of currently executing code
 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
 * some (although minimal) unwanted delay.
 *
 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
 * that task will execute first. That being said, if you need to schedule task asynchronously, but
 * as soon as possible, `asap` scheduler is your best bet.
 *
 * @example <caption>Compare async and asap scheduler</caption>
 *
 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
 *
 * // Logs:
 * // "asap"
 * // "async"
 * // ... but 'asap' goes first!
 *
 * @static true
 * @name asap
 * @owner Scheduler
 */ var $217f5bd9891560b5$export$dc4d482300a341e1;
"use strict";

var $f81qe = parcelRequire("f81qe");

var $gfIpL = parcelRequire("gfIpL");
$217f5bd9891560b5$export$dc4d482300a341e1 = new $gfIpL.AsapScheduler($f81qe.AsapAction);

});
parcelRegister("f81qe", function(module, exports) {
"use strict";
var $b038b4c9987c31db$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $awKBM = parcelRequire("awKBM");

var $ercxm = parcelRequire("ercxm");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b038b4c9987c31db$var$AsapAction = function(_super) {
    $b038b4c9987c31db$var$__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If a microtask has already been scheduled, don't schedule another
        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
        // the current scheduled microtask id.
        return scheduler.scheduled || (scheduler.scheduled = $awKBM.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        // If the scheduler queue is empty, cancel the requested microtask and
        // set the scheduled flag to undefined so the next AsapAction will schedule
        // its own.
        if (scheduler.actions.length === 0) {
            $awKBM.Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AsapAction;
}($ercxm.AsyncAction);
module.exports.AsapAction = $b038b4c9987c31db$var$AsapAction;

});
parcelRegister("awKBM", function(module, exports) {
$parcel$export(module.exports, "Immediate", () => $7aa10bfbaee22568$export$9bf7f22d83f7b5af, (v) => $7aa10bfbaee22568$export$9bf7f22d83f7b5af = v);
/**
Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
*/ var $7aa10bfbaee22568$export$9dc12cb738f70fa0;
var $7aa10bfbaee22568$export$9bf7f22d83f7b5af;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");
var $7aa10bfbaee22568$var$ImmediateDefinition = function() {
    function ImmediateDefinition(root) {
        this.root = root;
        if (root.setImmediate && typeof root.setImmediate === 'function') {
            this.setImmediate = root.setImmediate.bind(root);
            this.clearImmediate = root.clearImmediate.bind(root);
        } else {
            this.nextHandle = 1;
            this.tasksByHandle = {};
            this.currentlyRunningATask = false;
            // Don't get fooled by e.g. browserify environments.
            if (this.canUseProcessNextTick()) // For Node.js before 0.9
            this.setImmediate = this.createProcessNextTickSetImmediate();
            else if (this.canUsePostMessage()) // For non-IE10 modern browsers
            this.setImmediate = this.createPostMessageSetImmediate();
            else if (this.canUseMessageChannel()) // For web workers, where supported
            this.setImmediate = this.createMessageChannelSetImmediate();
            else if (this.canUseReadyStateChange()) // For IE 6–8
            this.setImmediate = this.createReadyStateChangeSetImmediate();
            else // For older browsers
            this.setImmediate = this.createSetTimeoutSetImmediate();
            var ci = function clearImmediate(handle) {
                delete clearImmediate.instance.tasksByHandle[handle];
            };
            ci.instance = this;
            this.clearImmediate = ci;
        }
    }
    ImmediateDefinition.prototype.identify = function(o) {
        return this.root.Object.prototype.toString.call(o);
    };
    ImmediateDefinition.prototype.canUseProcessNextTick = function() {
        return this.identify(this.root.process) === '[object process]';
    };
    ImmediateDefinition.prototype.canUseMessageChannel = function() {
        return Boolean(this.root.MessageChannel);
    };
    ImmediateDefinition.prototype.canUseReadyStateChange = function() {
        var document = this.root.document;
        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
    };
    ImmediateDefinition.prototype.canUsePostMessage = function() {
        var root = this.root;
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `root.postMessage` means something completely different and can't be used for this purpose.
        if (root.postMessage && !root.importScripts) {
            var postMessageIsAsynchronous_1 = true;
            var oldOnMessage = root.onmessage;
            root.onmessage = function() {
                postMessageIsAsynchronous_1 = false;
            };
            root.postMessage('', '*');
            root.onmessage = oldOnMessage;
            return postMessageIsAsynchronous_1;
        }
        return false;
    };
    // This function accepts the same arguments as setImmediate, but
    // returns a function that requires no arguments.
    ImmediateDefinition.prototype.partiallyApplied = function(handler) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var fn = function result() {
            var _a = result, handler = _a.handler, args = _a.args;
            if (typeof handler === 'function') handler.apply(undefined, args);
            else new Function('' + handler)();
        };
        fn.handler = handler;
        fn.args = args;
        return fn;
    };
    ImmediateDefinition.prototype.addFromSetImmediateArguments = function(args) {
        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
        return this.nextHandle++;
    };
    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createPostMessageSetImmediate = function() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var root = this.root;
        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
        var onGlobalMessage = function globalMessageHandler(event) {
            var instance = globalMessageHandler.instance;
            if (event.source === root && typeof event.data === 'string' && event.data.indexOf(messagePrefix) === 0) instance.runIfPresent(+event.data.slice(messagePrefix.length));
        };
        onGlobalMessage.instance = this;
        root.addEventListener('message', onGlobalMessage, false);
        var fn = function setImmediate() {
            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.postMessage(messagePrefix + handle, '*');
            return handle;
        };
        fn.instance = this;
        fn.messagePrefix = messagePrefix;
        return fn;
    };
    ImmediateDefinition.prototype.runIfPresent = function(handle) {
        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
        // So if we're currently running a task, we'll need to delay this invocation.
        if (this.currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // 'too much recursion' error.
        this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
        else {
            var task = this.tasksByHandle[handle];
            if (task) {
                this.currentlyRunningATask = true;
                try {
                    task();
                } finally{
                    this.clearImmediate(handle);
                    this.currentlyRunningATask = false;
                }
            }
        }
    };
    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function() {
        var _this = this;
        var channel = new this.root.MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            _this.runIfPresent(handle);
        };
        var fn = function setImmediate() {
            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            channel.port2.postMessage(handle);
            return handle;
        };
        fn.channel = channel;
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var root = instance.root;
            var doc = root.document;
            var html = doc.documentElement;
            var handle = instance.addFromSetImmediateArguments(arguments);
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement('script');
            script.onreadystatechange = function() {
                instance.runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    return ImmediateDefinition;
}();
$7aa10bfbaee22568$export$9dc12cb738f70fa0 = $7aa10bfbaee22568$var$ImmediateDefinition;
$7aa10bfbaee22568$export$9bf7f22d83f7b5af = new $7aa10bfbaee22568$var$ImmediateDefinition($9Cdpe.root);

});


parcelRegister("gfIpL", function(module, exports) {
"use strict";
var $bd507fd74d5d72ef$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $leugC = parcelRequire("leugC");
var $bd507fd74d5d72ef$var$AsapScheduler = function(_super) {
    $bd507fd74d5d72ef$var$__extends(AsapScheduler, _super);
    function AsapScheduler() {
        _super.apply(this, arguments);
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}($leugC.AsyncScheduler);
module.exports.AsapScheduler = $bd507fd74d5d72ef$var$AsapScheduler;

});






parcelRegister("aLeMa", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $kCOAD = parcelRequire("kCOAD");
$fSYYZ.Observable.prototype.switch = $kCOAD._switch;
$fSYYZ.Observable.prototype._switch = $kCOAD._switch;

});
parcelRegister("kCOAD", function(module, exports) {
$parcel$export(module.exports, "_switch", () => $f03e995f87da2854$export$424b8b2ab9af2944, (v) => $f03e995f87da2854$export$424b8b2ab9af2944 = v);
var $f03e995f87da2854$export$424b8b2ab9af2944;
"use strict";

var $eRao4 = parcelRequire("eRao4");
/**
 * Converts a higher-order Observable into a first-order Observable by
 * subscribing to only the most recently emitted of those inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * previous inner Observable once a new one appears.</span>
 *
 * <img src="./img/switch.png" width="100%">
 *
 * `switch` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable subscribes to the inner Observable and
 * begins emitting the items emitted by that. So far, it behaves
 * like {@link mergeAll}. However, when a new inner Observable is emitted,
 * `switch` unsubscribes from the earlier-emitted inner Observable and
 * subscribes to the new inner Observable and begins emitting items from it. It
 * continues to behave like this for subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * // Each click event is mapped to an Observable that ticks every second
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var switched = higherOrder.switch();
 * // The outcome is that `switched` is essentially a timer that restarts
 * // on every click. The interval Observables from older clicks do not merge
 * // with the current interval Observable.
 * switched.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switchMap}
 * @see {@link switchMapTo}
 * @see {@link zipAll}
 *
 * @return {Observable<T>} An Observable that emits the items emitted by the
 * Observable most recently emitted by the source Observable.
 * @method switch
 * @name switch
 * @owner Observable
 */ function $f03e995f87da2854$var$_switch() {
    return $eRao4.switchAll()(this);
}
$f03e995f87da2854$export$424b8b2ab9af2944 = $f03e995f87da2854$var$_switch;

});
parcelRegister("eRao4", function(module, exports) {
$parcel$export(module.exports, "switchAll", () => $ad0e12a1289b0461$export$6a45284a4b0bf33a, (v) => $ad0e12a1289b0461$export$6a45284a4b0bf33a = v);
var $ad0e12a1289b0461$export$6a45284a4b0bf33a;
"use strict";

var $aE20L = parcelRequire("aE20L");

var $7tpsL = parcelRequire("7tpsL");
function $ad0e12a1289b0461$var$switchAll() {
    return $aE20L.switchMap($7tpsL.identity);
}
$ad0e12a1289b0461$export$6a45284a4b0bf33a = $ad0e12a1289b0461$var$switchAll;

});



parcelRegister("67dsu", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5Nymb = parcelRequire("5Nymb");
$fSYYZ.Observable.prototype.switchMap = $5Nymb.switchMap;

});

parcelRegister("7PQNG", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5Ot0W = parcelRequire("5Ot0W");
$fSYYZ.Observable.prototype.switchMapTo = $5Ot0W.switchMapTo;

});
parcelRegister("5Ot0W", function(module, exports) {
$parcel$export(module.exports, "switchMapTo", () => $43b820db56720cb2$export$a439dc30c845238, (v) => $43b820db56720cb2$export$a439dc30c845238 = v);
var $43b820db56720cb2$export$a439dc30c845238;
"use strict";

var $7sE6z = parcelRequire("7sE6z");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $43b820db56720cb2$var$switchMapTo(innerObservable, resultSelector) {
    return $7sE6z.switchMapTo(innerObservable, resultSelector)(this);
}
$43b820db56720cb2$export$a439dc30c845238 = $43b820db56720cb2$var$switchMapTo;

});
parcelRegister("7sE6z", function(module, exports) {
"use strict";
var $56ea41eab92f1c9a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $56ea41eab92f1c9a$var$switchMapTo(innerObservable, resultSelector) {
    return function(source) {
        return source.lift(new $56ea41eab92f1c9a$var$SwitchMapToOperator(innerObservable, resultSelector));
    };
}
module.exports.switchMapTo = $56ea41eab92f1c9a$var$switchMapTo;
var $56ea41eab92f1c9a$var$SwitchMapToOperator = function() {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $56ea41eab92f1c9a$var$SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $56ea41eab92f1c9a$var$SwitchMapToSubscriber = function(_super) {
    $56ea41eab92f1c9a$var$__extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function(value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $2Q6Ms.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("3HCxQ", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $2nCLI = parcelRequire("2nCLI");
$fSYYZ.Observable.prototype.take = $2nCLI.take;

});
parcelRegister("2nCLI", function(module, exports) {
$parcel$export(module.exports, "take", () => $1bbbcd6509f713a5$export$b7df5d561049483a, (v) => $1bbbcd6509f713a5$export$b7df5d561049483a = v);
var $1bbbcd6509f713a5$export$b7df5d561049483a;
"use strict";

var $Gjmd7 = parcelRequire("Gjmd7");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $1bbbcd6509f713a5$var$take(count) {
    return $Gjmd7.take(count)(this);
}
$1bbbcd6509f713a5$export$b7df5d561049483a = $1bbbcd6509f713a5$var$take;

});
parcelRegister("Gjmd7", function(module, exports) {
"use strict";
var $07f2f04d64195c13$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $9JK9X = parcelRequire("9JK9X");

var $fyVhl = parcelRequire("fyVhl");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $07f2f04d64195c13$var$take(count) {
    return function(source) {
        if (count === 0) return new $fyVhl.EmptyObservable();
        else return source.lift(new $07f2f04d64195c13$var$TakeOperator(count));
    };
}
module.exports.take = $07f2f04d64195c13$var$take;
var $07f2f04d64195c13$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $9JK9X.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $07f2f04d64195c13$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $07f2f04d64195c13$var$TakeSubscriber = function(_super) {
    $07f2f04d64195c13$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("lFgjx", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $1FMXx = parcelRequire("1FMXx");
$fSYYZ.Observable.prototype.takeLast = $1FMXx.takeLast;

});
parcelRegister("1FMXx", function(module, exports) {
$parcel$export(module.exports, "takeLast", () => $137f99166c4f52c3$export$1b47ad771ce5af5e, (v) => $137f99166c4f52c3$export$1b47ad771ce5af5e = v);
var $137f99166c4f52c3$export$1b47ad771ce5af5e;
"use strict";

var $iPNgA = parcelRequire("iPNgA");
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $137f99166c4f52c3$var$takeLast(count) {
    return $iPNgA.takeLast(count)(this);
}
$137f99166c4f52c3$export$1b47ad771ce5af5e = $137f99166c4f52c3$var$takeLast;

});


parcelRegister("dhUM1", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $3NnTp = parcelRequire("3NnTp");
$fSYYZ.Observable.prototype.takeUntil = $3NnTp.takeUntil;

});
parcelRegister("3NnTp", function(module, exports) {
$parcel$export(module.exports, "takeUntil", () => $2c387b494965d855$export$ac8dfd3a7ad06e80, (v) => $2c387b494965d855$export$ac8dfd3a7ad06e80 = v);
var $2c387b494965d855$export$ac8dfd3a7ad06e80;
"use strict";

var $71eJZ = parcelRequire("71eJZ");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value, the output Observable stops mirroring the source Observable
 * and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $2c387b494965d855$var$takeUntil(notifier) {
    return $71eJZ.takeUntil(notifier)(this);
}
$2c387b494965d855$export$ac8dfd3a7ad06e80 = $2c387b494965d855$var$takeUntil;

});
parcelRegister("71eJZ", function(module, exports) {
"use strict";
var $51c40fa0411b0690$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $51c40fa0411b0690$var$takeUntil(notifier) {
    return function(source) {
        return source.lift(new $51c40fa0411b0690$var$TakeUntilOperator(notifier));
    };
}
module.exports.takeUntil = $51c40fa0411b0690$var$takeUntil;
var $51c40fa0411b0690$var$TakeUntilOperator = function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $51c40fa0411b0690$var$TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $51c40fa0411b0690$var$TakeUntilSubscriber = function(_super) {
    $51c40fa0411b0690$var$__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add($2Q6Ms.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    return TakeUntilSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("jK7uq", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $eEGui = parcelRequire("eEGui");
$fSYYZ.Observable.prototype.takeWhile = $eEGui.takeWhile;

});
parcelRegister("eEGui", function(module, exports) {
$parcel$export(module.exports, "takeWhile", () => $aab5c24c31862f0d$export$9384c7afe4015e42, (v) => $aab5c24c31862f0d$export$9384c7afe4015e42 = v);
var $aab5c24c31862f0d$export$9384c7afe4015e42;
"use strict";

var $6jL2I = parcelRequire("6jL2I");
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $aab5c24c31862f0d$var$takeWhile(predicate) {
    return $6jL2I.takeWhile(predicate)(this);
}
$aab5c24c31862f0d$export$9384c7afe4015e42 = $aab5c24c31862f0d$var$takeWhile;

});
parcelRegister("6jL2I", function(module, exports) {
"use strict";
var $4999022bc722fa51$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $4999022bc722fa51$var$takeWhile(predicate) {
    return function(source) {
        return source.lift(new $4999022bc722fa51$var$TakeWhileOperator(predicate));
    };
}
module.exports.takeWhile = $4999022bc722fa51$var$takeWhile;
var $4999022bc722fa51$var$TakeWhileOperator = function() {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4999022bc722fa51$var$TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4999022bc722fa51$var$TakeWhileSubscriber = function(_super) {
    $4999022bc722fa51$var$__extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        } catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function(value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) destination.next(value);
        else destination.complete();
    };
    return TakeWhileSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("6tmYF", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $2zwm0 = parcelRequire("2zwm0");
$fSYYZ.Observable.prototype.throttle = $2zwm0.throttle;

});
parcelRegister("2zwm0", function(module, exports) {
$parcel$export(module.exports, "throttle", () => $1df7f2778fe7b612$export$de363e709c412c8a, (v) => $1df7f2778fe7b612$export$de363e709c412c8a = v);
var $1df7f2778fe7b612$export$de363e709c412c8a;
"use strict";

var $3MScT = parcelRequire("3MScT");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $1df7f2778fe7b612$var$throttle(durationSelector, config) {
    if (config === void 0) config = $3MScT.defaultThrottleConfig;
    return $3MScT.throttle(durationSelector, config)(this);
}
$1df7f2778fe7b612$export$de363e709c412c8a = $1df7f2778fe7b612$var$throttle;

});
parcelRegister("3MScT", function(module, exports) {
"use strict";
var $2c1fe72bda19a3ef$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
module.exports.defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $2c1fe72bda19a3ef$var$throttle(durationSelector, config) {
    if (config === void 0) config = module.exports.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $2c1fe72bda19a3ef$var$ThrottleOperator(durationSelector, config.leading, config.trailing));
    };
}
module.exports.throttle = $2c1fe72bda19a3ef$var$throttle;
var $2c1fe72bda19a3ef$var$ThrottleOperator = function() {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2c1fe72bda19a3ef$var$ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */ var $2c1fe72bda19a3ef$var$ThrottleSubscriber = function(_super) {
    $2c1fe72bda19a3ef$var$__extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
        this._leading = _leading;
        this._trailing = _trailing;
        this._hasTrailingValue = false;
    }
    ThrottleSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this._trailing) {
                this._hasTrailingValue = true;
                this._trailingValue = value;
            }
        } else {
            var duration = this.tryDurationSelector(value);
            if (duration) this.add(this.throttled = $2Q6Ms.subscribeToResult(this, duration));
            if (this._leading) {
                this.destination.next(value);
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            }
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function(value) {
        try {
            return this.durationSelector(value);
        } catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function() {
        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
        this._trailingValue = null;
        this._hasTrailingValue = false;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype._sendTrailing = function() {
        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
        if (throttled && _trailing && _hasTrailingValue) {
            destination.next(_trailingValue);
            this._trailingValue = null;
            this._hasTrailingValue = false;
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._sendTrailing();
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function() {
        this._sendTrailing();
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("1HNnq", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $9gSl7 = parcelRequire("9gSl7");
$fSYYZ.Observable.prototype.throttleTime = $9gSl7.throttleTime;

});
parcelRegister("9gSl7", function(module, exports) {
$parcel$export(module.exports, "throttleTime", () => $6bffc269f8ac046a$export$4efe28f192921dd4, (v) => $6bffc269f8ac046a$export$4efe28f192921dd4 = v);
var $6bffc269f8ac046a$export$4efe28f192921dd4;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $3MScT = parcelRequire("3MScT");

var $4z4yD = parcelRequire("4z4yD");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $6bffc269f8ac046a$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    if (config === void 0) config = $3MScT.defaultThrottleConfig;
    return $4z4yD.throttleTime(duration, scheduler, config)(this);
}
$6bffc269f8ac046a$export$4efe28f192921dd4 = $6bffc269f8ac046a$var$throttleTime;

});
parcelRegister("4z4yD", function(module, exports) {
"use strict";
var $352df75a0c85e86e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $gFD0E = parcelRequire("gFD0E");

var $3MScT = parcelRequire("3MScT");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $352df75a0c85e86e$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    if (config === void 0) config = $3MScT.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $352df75a0c85e86e$var$ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
    };
}
module.exports.throttleTime = $352df75a0c85e86e$var$throttleTime;
var $352df75a0c85e86e$var$ThrottleTimeOperator = function() {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $352df75a0c85e86e$var$ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $352df75a0c85e86e$var$ThrottleTimeSubscriber = function(_super) {
    $352df75a0c85e86e$var$__extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
        this._hasTrailingValue = false;
        this._trailingValue = null;
    }
    ThrottleTimeSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        } else {
            this.add(this.throttled = this.scheduler.schedule($352df75a0c85e86e$var$dispatchNext, this.duration, {
                subscriber: this
            }));
            if (this.leading) this.destination.next(value);
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function() {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}($8qR8S.Subscriber);
function $352df75a0c85e86e$var$dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}

});



parcelRegister("33t0w", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5oAGq = parcelRequire("5oAGq");
$fSYYZ.Observable.prototype.timeInterval = $5oAGq.timeInterval;

});
parcelRegister("5oAGq", function(module, exports) {
$parcel$export(module.exports, "TimeInterval", () => $3edba62b4937b9c4$export$8bb95198b45adaac, (v) => $3edba62b4937b9c4$export$8bb95198b45adaac = v);
$parcel$export(module.exports, "timeInterval", () => $3edba62b4937b9c4$export$1a539c8b2950ab40, (v) => $3edba62b4937b9c4$export$1a539c8b2950ab40 = v);
var $3edba62b4937b9c4$export$8bb95198b45adaac;
var $3edba62b4937b9c4$export$1a539c8b2950ab40;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $4wNaD = parcelRequire("4wNaD");
$3edba62b4937b9c4$export$8bb95198b45adaac = $4wNaD.TimeInterval;
/**
 * @param scheduler
 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timeInterval
 * @owner Observable
 */ function $3edba62b4937b9c4$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $4wNaD.timeInterval(scheduler)(this);
}
$3edba62b4937b9c4$export$1a539c8b2950ab40 = $3edba62b4937b9c4$var$timeInterval;

});
parcelRegister("4wNaD", function(module, exports) {
"use strict";
var $34c04ad4700a5fe2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $gFD0E = parcelRequire("gFD0E");
function $34c04ad4700a5fe2$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return function(source) {
        return source.lift(new $34c04ad4700a5fe2$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $34c04ad4700a5fe2$var$timeInterval;
var $34c04ad4700a5fe2$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $34c04ad4700a5fe2$var$TimeInterval;
var $34c04ad4700a5fe2$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $34c04ad4700a5fe2$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $34c04ad4700a5fe2$var$TimeIntervalSubscriber = function(_super) {
    $34c04ad4700a5fe2$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $34c04ad4700a5fe2$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("qmSA3", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $2CuUz = parcelRequire("2CuUz");
$fSYYZ.Observable.prototype.timeout = $2CuUz.timeout;

});
parcelRegister("2CuUz", function(module, exports) {
$parcel$export(module.exports, "timeout", () => $1e871bba62c550b0$export$83e74882c5df8fe1, (v) => $1e871bba62c550b0$export$83e74882c5df8fe1 = v);
var $1e871bba62c550b0$export$83e74882c5df8fe1;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $iJ84d = parcelRequire("iJ84d");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $1e871bba62c550b0$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $iJ84d.timeout(due, scheduler)(this);
}
$1e871bba62c550b0$export$83e74882c5df8fe1 = $1e871bba62c550b0$var$timeout;

});
parcelRegister("iJ84d", function(module, exports) {
"use strict";
var $da22afe00b400629$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gFD0E = parcelRequire("gFD0E");

var $6CL4g = parcelRequire("6CL4g");

var $8qR8S = parcelRequire("8qR8S");

var $xjW0u = parcelRequire("xjW0u");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $da22afe00b400629$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    var absoluteTimeout = $6CL4g.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $da22afe00b400629$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $xjW0u.TimeoutError()));
    };
}
module.exports.timeout = $da22afe00b400629$var$timeout;
var $da22afe00b400629$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $da22afe00b400629$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $da22afe00b400629$var$TimeoutSubscriber = function(_super) {
    $da22afe00b400629$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($8qR8S.Subscriber);

});
parcelRegister("xjW0u", function(module, exports) {
"use strict";
var $06428bc701064b94$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $06428bc701064b94$var$TimeoutError = function(_super) {
    $06428bc701064b94$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $06428bc701064b94$var$TimeoutError;

});




parcelRegister("3vHQZ", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hDxN3 = parcelRequire("hDxN3");
$fSYYZ.Observable.prototype.timeoutWith = $hDxN3.timeoutWith;

});
parcelRegister("hDxN3", function(module, exports) {
$parcel$export(module.exports, "timeoutWith", () => $cd704a396824d1c9$export$86fe999fba7953f2, (v) => $cd704a396824d1c9$export$86fe999fba7953f2 = v);
var $cd704a396824d1c9$export$86fe999fba7953f2;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $h8zVV = parcelRequire("h8zVV");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $cd704a396824d1c9$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $h8zVV.timeoutWith(due, withObservable, scheduler)(this);
}
$cd704a396824d1c9$export$86fe999fba7953f2 = $cd704a396824d1c9$var$timeoutWith;

});
parcelRegister("h8zVV", function(module, exports) {
"use strict";
var $c79f0e9e06950b42$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gFD0E = parcelRequire("gFD0E");

var $6CL4g = parcelRequire("6CL4g");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $c79f0e9e06950b42$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return function(source) {
        var absoluteTimeout = $6CL4g.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $c79f0e9e06950b42$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $c79f0e9e06950b42$var$timeoutWith;
var $c79f0e9e06950b42$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c79f0e9e06950b42$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c79f0e9e06950b42$var$TimeoutWithSubscriber = function(_super) {
    $c79f0e9e06950b42$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($2Q6Ms.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("gjHCM", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $hMlmk = parcelRequire("hMlmk");
$fSYYZ.Observable.prototype.timestamp = $hMlmk.timestamp;

});
parcelRegister("hMlmk", function(module, exports) {
$parcel$export(module.exports, "timestamp", () => $cf177cdc1780e5ed$export$fc00ee57782020aa, (v) => $cf177cdc1780e5ed$export$fc00ee57782020aa = v);
var $cf177cdc1780e5ed$export$fc00ee57782020aa;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $hpCBz = parcelRequire("hpCBz");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function $cf177cdc1780e5ed$var$timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $hpCBz.timestamp(scheduler)(this);
}
$cf177cdc1780e5ed$export$fc00ee57782020aa = $cf177cdc1780e5ed$var$timestamp;

});
parcelRegister("hpCBz", function(module, exports) {
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $a8ocL = parcelRequire("a8ocL");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $gFD0E.async;
    return $a8ocL.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;

});



parcelRegister("5who5", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $gEmaJ = parcelRequire("gEmaJ");
$fSYYZ.Observable.prototype.toArray = $gEmaJ.toArray;

});
parcelRegister("gEmaJ", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $c1f194b22bad6492$export$45b10814cc054894, (v) => $c1f194b22bad6492$export$45b10814cc054894 = v);
var $c1f194b22bad6492$export$45b10814cc054894;
"use strict";

var $b3JoI = parcelRequire("b3JoI");
/**
 * Collects all source emissions and emits them as an array when the source completes.
 *
 * <span class="informal">Get all values inside an array when the source completes</span>
 *
 * <img src="./img/toArray.png" width="100%">
 *
 * `toArray` will wait until the source Observable completes
 * before emitting the array containing all emissions.
 * When the source Observable errors no array will be emitted.
 *
 * @example <caption>Create array from input</caption>
 * const input = Rx.Observable.interval(100).take(4);
 *
 * input.toArray()
 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
 *
 * @see {@link buffer}
 *
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */ function $c1f194b22bad6492$var$toArray() {
    return $b3JoI.toArray()(this);
}
$c1f194b22bad6492$export$45b10814cc054894 = $c1f194b22bad6492$var$toArray;

});
parcelRegister("b3JoI", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $80d3308f8bfc4e64$export$45b10814cc054894, (v) => $80d3308f8bfc4e64$export$45b10814cc054894 = v);
var $80d3308f8bfc4e64$export$45b10814cc054894;
"use strict";

var $d2E9m = parcelRequire("d2E9m");
function $80d3308f8bfc4e64$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $80d3308f8bfc4e64$var$toArray() {
    return $d2E9m.reduce($80d3308f8bfc4e64$var$toArrayReducer, []);
}
$80d3308f8bfc4e64$export$45b10814cc054894 = $80d3308f8bfc4e64$var$toArray;

});



parcelRegister("gZSQK", function(module, exports) {
// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.

});

parcelRegister("gLr0q", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5cB4q = parcelRequire("5cB4q");
$fSYYZ.Observable.prototype.window = $5cB4q.window;

});
parcelRegister("5cB4q", function(module, exports) {
$parcel$export(module.exports, "window", () => $3c9ad429f00c3f2a$export$8291e5b88f90ce4, (v) => $3c9ad429f00c3f2a$export$8291e5b88f90ce4 = v);
var $3c9ad429f00c3f2a$export$8291e5b88f90ce4;
"use strict";

var $57u4K = parcelRequire("57u4K");
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function $3c9ad429f00c3f2a$var$window(windowBoundaries) {
    return $57u4K.window(windowBoundaries)(this);
}
$3c9ad429f00c3f2a$export$8291e5b88f90ce4 = $3c9ad429f00c3f2a$var$window;

});
parcelRegister("57u4K", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
exports.window = window;
var WindowOperator = function() {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) windowSubscriber.add($2Q6Ms.subscribeToResult(windowSubscriber, this.windowBoundaries));
        return sourceSubscription;
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var WindowSubscriber = function(_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new $bTlA1.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function() {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function() {
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var destination = this.destination;
        var newWindow = this.window = new $bTlA1.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("8Ijk8", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $bM7h9 = parcelRequire("bM7h9");
$fSYYZ.Observable.prototype.windowCount = $bM7h9.windowCount;

});
parcelRegister("bM7h9", function(module, exports) {
$parcel$export(module.exports, "windowCount", () => $8929d2326a18f40f$export$f3a19e933f377396, (v) => $8929d2326a18f40f$export$f3a19e933f377396 = v);
var $8929d2326a18f40f$export$f3a19e933f377396;
"use strict";

var $3OPBH = parcelRequire("3OPBH");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $8929d2326a18f40f$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return $3OPBH.windowCount(windowSize, startWindowEvery)(this);
}
$8929d2326a18f40f$export$f3a19e933f377396 = $8929d2326a18f40f$var$windowCount;

});
parcelRegister("3OPBH", function(module, exports) {
"use strict";
var $2c7e12b1e5f8f054$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8qR8S = parcelRequire("8qR8S");

var $bTlA1 = parcelRequire("bTlA1");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $2c7e12b1e5f8f054$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $2c7e12b1e5f8f054$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $2c7e12b1e5f8f054$var$windowCount;
var $2c7e12b1e5f8f054$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2c7e12b1e5f8f054$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2c7e12b1e5f8f054$var$WindowCountSubscriber = function(_super) {
    $2c7e12b1e5f8f054$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $bTlA1.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $bTlA1.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($8qR8S.Subscriber);

});



parcelRegister("gTWzI", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $2ImFm = parcelRequire("2ImFm");
$fSYYZ.Observable.prototype.windowTime = $2ImFm.windowTime;

});
parcelRegister("2ImFm", function(module, exports) {
$parcel$export(module.exports, "windowTime", () => $1fa145d6a12c3ba2$export$1284415effa79ee0, (v) => $1fa145d6a12c3ba2$export$1284415effa79ee0 = v);
var $1fa145d6a12c3ba2$export$1284415effa79ee0;
"use strict";

var $gFD0E = parcelRequire("gFD0E");

var $f3TUk = parcelRequire("f3TUk");

var $bOxHY = parcelRequire("bOxHY");

var $Sgxd2 = parcelRequire("Sgxd2");
function $1fa145d6a12c3ba2$var$windowTime(windowTimeSpan) {
    var scheduler = $gFD0E.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($bOxHY.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($bOxHY.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($f3TUk.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($bOxHY.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($f3TUk.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return $Sgxd2.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
}
$1fa145d6a12c3ba2$export$1284415effa79ee0 = $1fa145d6a12c3ba2$var$windowTime;

});
parcelRegister("Sgxd2", function(module, exports) {
"use strict";
var $0a31deb1b42a81c4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $gFD0E = parcelRequire("gFD0E");

var $8qR8S = parcelRequire("8qR8S");

var $f3TUk = parcelRequire("f3TUk");

var $bOxHY = parcelRequire("bOxHY");
function $0a31deb1b42a81c4$var$windowTime(windowTimeSpan) {
    var scheduler = $gFD0E.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($bOxHY.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($bOxHY.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($f3TUk.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($bOxHY.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($f3TUk.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $0a31deb1b42a81c4$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $0a31deb1b42a81c4$var$windowTime;
var $0a31deb1b42a81c4$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0a31deb1b42a81c4$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $0a31deb1b42a81c4$var$CountedSubject = function(_super) {
    $0a31deb1b42a81c4$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($bTlA1.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0a31deb1b42a81c4$var$WindowTimeSubscriber = function(_super) {
    $0a31deb1b42a81c4$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($0a31deb1b42a81c4$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($0a31deb1b42a81c4$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($0a31deb1b42a81c4$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $0a31deb1b42a81c4$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($8qR8S.Subscriber);
function $0a31deb1b42a81c4$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $0a31deb1b42a81c4$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($0a31deb1b42a81c4$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $0a31deb1b42a81c4$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

});



parcelRegister("39wDQ", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $kkwCr = parcelRequire("kkwCr");
$fSYYZ.Observable.prototype.windowToggle = $kkwCr.windowToggle;

});
parcelRegister("kkwCr", function(module, exports) {
$parcel$export(module.exports, "windowToggle", () => $eccefa57e1844554$export$3182be990e0eeaad, (v) => $eccefa57e1844554$export$3182be990e0eeaad = v);
var $eccefa57e1844554$export$3182be990e0eeaad;
"use strict";

var $4HJOP = parcelRequire("4HJOP");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $eccefa57e1844554$var$windowToggle(openings, closingSelector) {
    return $4HJOP.windowToggle(openings, closingSelector)(this);
}
$eccefa57e1844554$export$3182be990e0eeaad = $eccefa57e1844554$var$windowToggle;

});
parcelRegister("4HJOP", function(module, exports) {
"use strict";
var $36ceb839a6033b38$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $aBkDT = parcelRequire("aBkDT");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $36ceb839a6033b38$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $36ceb839a6033b38$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $36ceb839a6033b38$var$windowToggle;
var $36ceb839a6033b38$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $36ceb839a6033b38$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $36ceb839a6033b38$var$WindowToggleSubscriber = function(_super) {
    $36ceb839a6033b38$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $2Q6Ms.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $3XqeD.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $h0Tv0.errorObject) return this.error($h0Tv0.errorObject.e);
            else {
                var window_1 = new $bTlA1.Subject();
                var subscription = new $aBkDT.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $2Q6Ms.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("tnrSr", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $5Igp3 = parcelRequire("5Igp3");
$fSYYZ.Observable.prototype.windowWhen = $5Igp3.windowWhen;

});
parcelRegister("5Igp3", function(module, exports) {
$parcel$export(module.exports, "windowWhen", () => $428dc924c75e3fe4$export$6a5dea797879f644, (v) => $428dc924c75e3fe4$export$6a5dea797879f644 = v);
var $428dc924c75e3fe4$export$6a5dea797879f644;
"use strict";

var $26M4y = parcelRequire("26M4y");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $428dc924c75e3fe4$var$windowWhen(closingSelector) {
    return $26M4y.windowWhen(closingSelector)(this);
}
$428dc924c75e3fe4$export$6a5dea797879f644 = $428dc924c75e3fe4$var$windowWhen;

});
parcelRegister("26M4y", function(module, exports) {
"use strict";
var $18916e819b609ba4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $3XqeD = parcelRequire("3XqeD");

var $h0Tv0 = parcelRequire("h0Tv0");

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $18916e819b609ba4$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $18916e819b609ba4$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $18916e819b609ba4$var$windowWhen;
var $18916e819b609ba4$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $18916e819b609ba4$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $18916e819b609ba4$var$WindowSubscriber = function(_super) {
    $18916e819b609ba4$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $bTlA1.Subject();
        this.destination.next(window);
        var closingNotifier = $3XqeD.tryCatch(this.closingSelector)();
        if (closingNotifier === $h0Tv0.errorObject) {
            var err = $h0Tv0.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $2Q6Ms.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("6UIxa", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $i2x7Z = parcelRequire("i2x7Z");
$fSYYZ.Observable.prototype.withLatestFrom = $i2x7Z.withLatestFrom;

});
parcelRegister("i2x7Z", function(module, exports) {
$parcel$export(module.exports, "withLatestFrom", () => $d2221c6ab9dd2e23$export$d449030e5c10edf7, (v) => $d2221c6ab9dd2e23$export$d449030e5c10edf7 = v);
var $d2221c6ab9dd2e23$export$d449030e5c10edf7;
"use strict";

var $gUOpO = parcelRequire("gUOpO");
/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $d2221c6ab9dd2e23$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return $gUOpO.withLatestFrom.apply(void 0, args)(this);
}
$d2221c6ab9dd2e23$export$d449030e5c10edf7 = $d2221c6ab9dd2e23$var$withLatestFrom;

});
parcelRegister("gUOpO", function(module, exports) {
"use strict";
var $c508fbba1ad071d7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9u1V0 = parcelRequire("9u1V0");

var $2Q6Ms = parcelRequire("2Q6Ms");
/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $c508fbba1ad071d7$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === 'function') project = args.pop();
        var observables = args;
        return source.lift(new $c508fbba1ad071d7$var$WithLatestFromOperator(observables, project));
    };
}
module.exports.withLatestFrom = $c508fbba1ad071d7$var$withLatestFrom;
var $c508fbba1ad071d7$var$WithLatestFromOperator = function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c508fbba1ad071d7$var$WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c508fbba1ad071d7$var$WithLatestFromSubscriber = function(_super) {
    $c508fbba1ad071d7$var$__extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for(var i = 0; i < len; i++)this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            this.add($2Q6Ms.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}($9u1V0.OuterSubscriber);

});



parcelRegister("b0vRQ", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $4MMZI = parcelRequire("4MMZI");
$fSYYZ.Observable.prototype.zip = $4MMZI.zipProto;

});
parcelRegister("4MMZI", function(module, exports) {
$parcel$export(module.exports, "zipProto", () => $37c1a669f15888e7$export$ad1b5245dc53c655, (v) => $37c1a669f15888e7$export$ad1b5245dc53c655 = v);
var $37c1a669f15888e7$export$ad1b5245dc53c655;
"use strict";

var $713Wo = parcelRequire("713Wo");
/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $37c1a669f15888e7$var$zipProto() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $713Wo.zip.apply(void 0, observables)(this);
}
$37c1a669f15888e7$export$ad1b5245dc53c655 = $37c1a669f15888e7$var$zipProto;

});


parcelRegister("9pehG", function(module, exports) {
"use strict";

var $fSYYZ = parcelRequire("fSYYZ");

var $ensGJ = parcelRequire("ensGJ");
$fSYYZ.Observable.prototype.zipAll = $ensGJ.zipAll;

});
parcelRegister("ensGJ", function(module, exports) {
$parcel$export(module.exports, "zipAll", () => $a779778f34c00ccf$export$adddb6a2fa3864e9, (v) => $a779778f34c00ccf$export$adddb6a2fa3864e9 = v);
var $a779778f34c00ccf$export$adddb6a2fa3864e9;
"use strict";

var $2sxLS = parcelRequire("2sxLS");
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */ function $a779778f34c00ccf$var$zipAll(project) {
    return $2sxLS.zipAll(project)(this);
}
$a779778f34c00ccf$export$adddb6a2fa3864e9 = $a779778f34c00ccf$var$zipAll;

});
parcelRegister("2sxLS", function(module, exports) {
$parcel$export(module.exports, "zipAll", () => $1ca864930735c3fd$export$adddb6a2fa3864e9, (v) => $1ca864930735c3fd$export$adddb6a2fa3864e9 = v);
var $1ca864930735c3fd$export$adddb6a2fa3864e9;
"use strict";

var $713Wo = parcelRequire("713Wo");
function $1ca864930735c3fd$var$zipAll(project) {
    return function(source) {
        return source.lift(new $713Wo.ZipOperator(project));
    };
}
$1ca864930735c3fd$export$adddb6a2fa3864e9 = $1ca864930735c3fd$var$zipAll;

});



parcelRegister("djy06", function(module, exports) {
"use strict";
var $9b176c877d7eb486$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $hGDIR = parcelRequire("hGDIR");

var $d4uN5 = parcelRequire("d4uN5");

var $B2ijC = parcelRequire("B2ijC");

var $biyeq = parcelRequire("biyeq");

var $3Hw6c = parcelRequire("3Hw6c");
var $9b176c877d7eb486$var$defaultMaxFrame = 750;
var $9b176c877d7eb486$var$TestScheduler = function(_super) {
    $9b176c877d7eb486$var$__extends(TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
        _super.call(this, $3Hw6c.VirtualAction, $9b176c877d7eb486$var$defaultMaxFrame);
        this.assertDeepEqual = assertDeepEqual;
        this.hotObservables = [];
        this.coldObservables = [];
        this.flushTests = [];
    }
    TestScheduler.prototype.createTime = function(marbles) {
        var indexOf = marbles.indexOf('|');
        if (indexOf === -1) throw new Error('marble diagram for time should have a completion marker "|"');
        return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function(marbles, values, error) {
        if (marbles.indexOf('^') !== -1) throw new Error('cold observable cannot have subscription offset "^"');
        if (marbles.indexOf('!') !== -1) throw new Error('cold observable cannot have unsubscription marker "!"');
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var cold = new $d4uN5.ColdObservable(messages, this);
        this.coldObservables.push(cold);
        return cold;
    };
    TestScheduler.prototype.createHotObservable = function(marbles, values, error) {
        if (marbles.indexOf('!') !== -1) throw new Error('hot observable cannot have unsubscription marker "!"');
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var subject = new $B2ijC.HotObservable(messages, this);
        this.hotObservables.push(subject);
        return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function(observable, outerFrame) {
        var _this = this;
        var messages = [];
        observable.subscribe(function(value) {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $hGDIR.Notification.createNext(value)
            });
        }, function(err) {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $hGDIR.Notification.createError(err)
            });
        }, function() {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $hGDIR.Notification.createComplete()
            });
        });
        return messages;
    };
    TestScheduler.prototype.expectObservable = function(observable, unsubscriptionMarbles) {
        var _this = this;
        if (unsubscriptionMarbles === void 0) unsubscriptionMarbles = null;
        var actual = [];
        var flushTest = {
            actual: actual,
            ready: false
        };
        var unsubscriptionFrame = TestScheduler.parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
        var subscription;
        this.schedule(function() {
            subscription = observable.subscribe(function(x) {
                var value = x;
                // Support Observable-of-Observables
                if (x instanceof $fSYYZ.Observable) value = _this.materializeInnerObservable(value, _this.frame);
                actual.push({
                    frame: _this.frame,
                    notification: $hGDIR.Notification.createNext(value)
                });
            }, function(err) {
                actual.push({
                    frame: _this.frame,
                    notification: $hGDIR.Notification.createError(err)
                });
            }, function() {
                actual.push({
                    frame: _this.frame,
                    notification: $hGDIR.Notification.createComplete()
                });
            });
        }, 0);
        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) this.schedule(function() {
            return subscription.unsubscribe();
        }, unsubscriptionFrame);
        this.flushTests.push(flushTest);
        return {
            toBe: function(marbles, values, errorValue) {
                flushTest.ready = true;
                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
            }
        };
    };
    TestScheduler.prototype.expectSubscriptions = function(actualSubscriptionLogs) {
        var flushTest = {
            actual: actualSubscriptionLogs,
            ready: false
        };
        this.flushTests.push(flushTest);
        return {
            toBe: function(marbles) {
                var marblesArray = typeof marbles === 'string' ? [
                    marbles
                ] : marbles;
                flushTest.ready = true;
                flushTest.expected = marblesArray.map(function(marbles) {
                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
                });
            }
        };
    };
    TestScheduler.prototype.flush = function() {
        var hotObservables = this.hotObservables;
        while(hotObservables.length > 0)hotObservables.shift().setup();
        _super.prototype.flush.call(this);
        var readyFlushTests = this.flushTests.filter(function(test) {
            return test.ready;
        });
        while(readyFlushTests.length > 0){
            var test = readyFlushTests.shift();
            this.assertDeepEqual(test.actual, test.expected);
        }
    };
    TestScheduler.parseMarblesAsSubscriptions = function(marbles) {
        if (typeof marbles !== 'string') return new $biyeq.SubscriptionLog(Number.POSITIVE_INFINITY);
        var len = marbles.length;
        var groupStart = -1;
        var subscriptionFrame = Number.POSITIVE_INFINITY;
        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
        for(var i = 0; i < len; i++){
            var frame = i * this.frameTimeFactor;
            var c = marbles[i];
            switch(c){
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '^':
                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");
                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                case '!':
                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");
                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                default:
                    throw new Error("there can only be '^' and '!' markers in a subscription marble diagram. Found instead '" + c + '\'.');
            }
        }
        if (unsubscriptionFrame < 0) return new $biyeq.SubscriptionLog(subscriptionFrame);
        else return new $biyeq.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
    };
    TestScheduler.parseMarbles = function(marbles, values, errorValue, materializeInnerObservables) {
        if (materializeInnerObservables === void 0) materializeInnerObservables = false;
        if (marbles.indexOf('!') !== -1) throw new Error('conventional marble diagrams cannot have the unsubscription marker "!"');
        var len = marbles.length;
        var testMessages = [];
        var subIndex = marbles.indexOf('^');
        var frameOffset = subIndex === -1 ? 0 : subIndex * -this.frameTimeFactor;
        var getValue = typeof values !== 'object' ? function(x) {
            return x;
        } : function(x) {
            // Support Observable-of-Observables
            if (materializeInnerObservables && values[x] instanceof $d4uN5.ColdObservable) return values[x].messages;
            return values[x];
        };
        var groupStart = -1;
        for(var i = 0; i < len; i++){
            var frame = i * this.frameTimeFactor + frameOffset;
            var notification = void 0;
            var c = marbles[i];
            switch(c){
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '|':
                    notification = $hGDIR.Notification.createComplete();
                    break;
                case '^':
                    break;
                case '#':
                    notification = $hGDIR.Notification.createError(errorValue || 'error');
                    break;
                default:
                    notification = $hGDIR.Notification.createNext(getValue(c));
                    break;
            }
            if (notification) testMessages.push({
                frame: groupStart > -1 ? groupStart : frame,
                notification: notification
            });
        }
        return testMessages;
    };
    return TestScheduler;
}($3Hw6c.VirtualTimeScheduler);
module.exports.TestScheduler = $9b176c877d7eb486$var$TestScheduler;

});
parcelRegister("d4uN5", function(module, exports) {
"use strict";
var $98438880e692e889$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fSYYZ = parcelRequire("fSYYZ");

var $aBkDT = parcelRequire("aBkDT");

var $foEyA = parcelRequire("foEyA");

var $71Yrb = parcelRequire("71Yrb");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $98438880e692e889$var$ColdObservable = function(_super) {
    $98438880e692e889$var$__extends(ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
        _super.call(this, function(subscriber) {
            var observable = this;
            var index = observable.logSubscribedFrame();
            subscriber.add(new $aBkDT.Subscription(function() {
                observable.logUnsubscribedFrame(index);
            }));
            observable.scheduleMessages(subscriber);
            return subscriber;
        });
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    ColdObservable.prototype.scheduleMessages = function(subscriber) {
        var messagesLength = this.messages.length;
        for(var i = 0; i < messagesLength; i++){
            var message = this.messages[i];
            subscriber.add(this.scheduler.schedule(function(_a) {
                var message = _a.message, subscriber = _a.subscriber;
                message.notification.observe(subscriber);
            }, message.frame, {
                message: message,
                subscriber: subscriber
            }));
        }
    };
    return ColdObservable;
}($fSYYZ.Observable);
module.exports.ColdObservable = $98438880e692e889$var$ColdObservable;
$71Yrb.applyMixins($98438880e692e889$var$ColdObservable, [
    $foEyA.SubscriptionLoggable
]);

});
parcelRegister("foEyA", function(module, exports) {
$parcel$export(module.exports, "SubscriptionLoggable", () => $b3588ea09e7c5d00$export$b07abd1cdf2201bb, (v) => $b3588ea09e7c5d00$export$b07abd1cdf2201bb = v);
var $b3588ea09e7c5d00$export$b07abd1cdf2201bb;
"use strict";

var $biyeq = parcelRequire("biyeq");
var $b3588ea09e7c5d00$var$SubscriptionLoggable = function() {
    function SubscriptionLoggable() {
        this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function() {
        this.subscriptions.push(new $biyeq.SubscriptionLog(this.scheduler.now()));
        return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function(index) {
        var subscriptionLogs = this.subscriptions;
        var oldSubscriptionLog = subscriptionLogs[index];
        subscriptionLogs[index] = new $biyeq.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
}();
$b3588ea09e7c5d00$export$b07abd1cdf2201bb = $b3588ea09e7c5d00$var$SubscriptionLoggable;

});
parcelRegister("biyeq", function(module, exports) {
$parcel$export(module.exports, "SubscriptionLog", () => $839bedde75cd5207$export$63bb55968f4c7c1e, (v) => $839bedde75cd5207$export$63bb55968f4c7c1e = v);
var $839bedde75cd5207$export$63bb55968f4c7c1e;
"use strict";
var $839bedde75cd5207$var$SubscriptionLog = function() {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) unsubscribedFrame = Number.POSITIVE_INFINITY;
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}();
$839bedde75cd5207$export$63bb55968f4c7c1e = $839bedde75cd5207$var$SubscriptionLog;

});


parcelRegister("71Yrb", function(module, exports) {
$parcel$export(module.exports, "applyMixins", () => $51e782032c7175db$export$6ccb92ce135089b4, (v) => $51e782032c7175db$export$6ccb92ce135089b4 = v);
var $51e782032c7175db$export$6ccb92ce135089b4;
"use strict";
function $51e782032c7175db$var$applyMixins(derivedCtor, baseCtors) {
    for(var i = 0, len = baseCtors.length; i < len; i++){
        var baseCtor = baseCtors[i];
        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
        for(var j = 0, len2 = propertyKeys.length; j < len2; j++){
            var name_1 = propertyKeys[j];
            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
        }
    }
}
$51e782032c7175db$export$6ccb92ce135089b4 = $51e782032c7175db$var$applyMixins;

});


parcelRegister("B2ijC", function(module, exports) {
"use strict";
var $06f53c703691e840$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bTlA1 = parcelRequire("bTlA1");

var $aBkDT = parcelRequire("aBkDT");

var $foEyA = parcelRequire("foEyA");

var $71Yrb = parcelRequire("71Yrb");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $06f53c703691e840$var$HotObservable = function(_super) {
    $06f53c703691e840$var$__extends(HotObservable, _super);
    function HotObservable(messages, scheduler) {
        _super.call(this);
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    /** @deprecated internal use only */ HotObservable.prototype._subscribe = function(subscriber) {
        var subject = this;
        var index = subject.logSubscribedFrame();
        subscriber.add(new $aBkDT.Subscription(function() {
            subject.logUnsubscribedFrame(index);
        }));
        return _super.prototype._subscribe.call(this, subscriber);
    };
    HotObservable.prototype.setup = function() {
        var subject = this;
        var messagesLength = subject.messages.length;
        /* tslint:disable:no-var-keyword */ for(var i = 0; i < messagesLength; i++)(function() {
            var message = subject.messages[i];
            /* tslint:enable */ subject.scheduler.schedule(function() {
                message.notification.observe(subject);
            }, message.frame);
        })();
    };
    return HotObservable;
}($bTlA1.Subject);
module.exports.HotObservable = $06f53c703691e840$var$HotObservable;
$71Yrb.applyMixins($06f53c703691e840$var$HotObservable, [
    $foEyA.SubscriptionLoggable
]);

});

parcelRegister("3Hw6c", function(module, exports) {
"use strict";
var $2b1e4976f231a88a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ercxm = parcelRequire("ercxm");

var $leugC = parcelRequire("leugC");
var $2b1e4976f231a88a$var$VirtualTimeScheduler = function(_super) {
    $2b1e4976f231a88a$var$__extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        var _this = this;
        if (SchedulerAction === void 0) SchedulerAction = $2b1e4976f231a88a$var$VirtualAction;
        if (maxFrames === void 0) maxFrames = Number.POSITIVE_INFINITY;
        _super.call(this, SchedulerAction, function() {
            return _this.frame;
        });
        this.maxFrames = maxFrames;
        this.frame = 0;
        this.index = -1;
    }
    /**
     * Prompt the Scheduler to execute all of its queued actions, therefore
     * clearing its queue.
     * @return {void}
     */ VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while((action = actions.shift()) && (this.frame = action.delay) <= maxFrames){
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}($leugC.AsyncScheduler);
module.exports.VirtualTimeScheduler = $2b1e4976f231a88a$var$VirtualTimeScheduler;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2b1e4976f231a88a$var$VirtualAction = function(_super) {
    $2b1e4976f231a88a$var$__extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.index = index;
        this.active = true;
        this.index = scheduler.index = index;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (!this.id) return _super.prototype.schedule.call(this, state, delay);
        this.active = false;
        // If an action is rescheduled, we save allocations by mutating its state,
        // pushing it to the end of the scheduler queue, and recycling the action.
        // But since the VirtualTimeScheduler is used for testing, VirtualActions
        // must be immutable so they can be inspected later.
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}($ercxm.AsyncAction);
module.exports.VirtualAction = $2b1e4976f231a88a$var$VirtualAction;

});


parcelRegister("7Hi3W", function(module, exports) {
$parcel$export(module.exports, "animationFrame", () => $59aa8f672f04339d$export$1402cba6a733f33a, (v) => $59aa8f672f04339d$export$1402cba6a733f33a = v);
/**
 *
 * Animation Frame Scheduler
 *
 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
 *
 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
 * behaviour.
 *
 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
 * It makes sure scheduled task will happen just before next browser content repaint,
 * thus performing animations as efficiently as possible.
 *
 * @example <caption>Schedule div height animation</caption>
 * const div = document.querySelector('.some-div');
 *
 * Rx.Scheduler.schedule(function(height) {
 *   div.style.height = height + "px";
 *
 *   this.schedule(height + 1);  // `this` references currently executing Action,
 *                               // which we reschedule with new state
 * }, 0, 0);
 *
 * // You will see .some-div element growing in height
 *
 *
 * @static true
 * @name animationFrame
 * @owner Scheduler
 */ var $59aa8f672f04339d$export$1402cba6a733f33a;
"use strict";

var $dqXiz = parcelRequire("dqXiz");

var $iEM0N = parcelRequire("iEM0N");
$59aa8f672f04339d$export$1402cba6a733f33a = new $iEM0N.AnimationFrameScheduler($dqXiz.AnimationFrameAction);

});
parcelRegister("dqXiz", function(module, exports) {
"use strict";
var $9c7bb3884d6811e7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ercxm = parcelRequire("ercxm");

var $03Hks = parcelRequire("03Hks");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9c7bb3884d6811e7$var$AnimationFrameAction = function(_super) {
    $9c7bb3884d6811e7$var$__extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If an animation frame has already been requested, don't request another
        // one. If an animation frame hasn't been requested yet, request one. Return
        // the current animation frame request id.
        return scheduler.scheduled || (scheduler.scheduled = $03Hks.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        // If the scheduler queue is empty, cancel the requested animation frame and
        // set the scheduled flag to undefined so the next AnimationFrameAction will
        // request its own.
        if (scheduler.actions.length === 0) {
            $03Hks.AnimationFrame.cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AnimationFrameAction;
}($ercxm.AsyncAction);
module.exports.AnimationFrameAction = $9c7bb3884d6811e7$var$AnimationFrameAction;

});
parcelRegister("03Hks", function(module, exports) {
$parcel$export(module.exports, "AnimationFrame", () => $00b1e429b092fff4$export$1f3d5b43727c648a, (v) => $00b1e429b092fff4$export$1f3d5b43727c648a = v);
var $00b1e429b092fff4$export$5e49294fc1f79cc3;
var $00b1e429b092fff4$export$1f3d5b43727c648a;
"use strict";

var $9Cdpe = parcelRequire("9Cdpe");
var $00b1e429b092fff4$var$RequestAnimationFrameDefinition = function() {
    function RequestAnimationFrameDefinition(root) {
        if (root.requestAnimationFrame) {
            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
        } else if (root.mozRequestAnimationFrame) {
            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
        } else if (root.webkitRequestAnimationFrame) {
            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
        } else if (root.msRequestAnimationFrame) {
            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
        } else if (root.oRequestAnimationFrame) {
            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
        } else {
            this.cancelAnimationFrame = root.clearTimeout.bind(root);
            this.requestAnimationFrame = function(cb) {
                return root.setTimeout(cb, 1000 / 60);
            };
        }
    }
    return RequestAnimationFrameDefinition;
}();
$00b1e429b092fff4$export$5e49294fc1f79cc3 = $00b1e429b092fff4$var$RequestAnimationFrameDefinition;
$00b1e429b092fff4$export$1f3d5b43727c648a = new $00b1e429b092fff4$var$RequestAnimationFrameDefinition($9Cdpe.root);

});


parcelRegister("iEM0N", function(module, exports) {
"use strict";
var $d951348c93df9a9e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $leugC = parcelRequire("leugC");
var $d951348c93df9a9e$var$AnimationFrameScheduler = function(_super) {
    $d951348c93df9a9e$var$__extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        _super.apply(this, arguments);
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}($leugC.AsyncScheduler);
module.exports.AnimationFrameScheduler = $d951348c93df9a9e$var$AnimationFrameScheduler;

});


parcelRegister("3PjqI", function(module, exports) {
$parcel$export(module.exports, "audit", () => $2c9534dd8b7681cc$export$d779b02e6b68c3e8, (v) => $2c9534dd8b7681cc$export$d779b02e6b68c3e8 = v);
$parcel$export(module.exports, "auditTime", () => $2c9534dd8b7681cc$export$719c70722b10e5ff, (v) => $2c9534dd8b7681cc$export$719c70722b10e5ff = v);
$parcel$export(module.exports, "buffer", () => $2c9534dd8b7681cc$export$ab1029bcae9ddb4a, (v) => $2c9534dd8b7681cc$export$ab1029bcae9ddb4a = v);
$parcel$export(module.exports, "bufferCount", () => $2c9534dd8b7681cc$export$8916d2c8119541bb, (v) => $2c9534dd8b7681cc$export$8916d2c8119541bb = v);
$parcel$export(module.exports, "bufferTime", () => $2c9534dd8b7681cc$export$d6b40c95035461c7, (v) => $2c9534dd8b7681cc$export$d6b40c95035461c7 = v);
$parcel$export(module.exports, "bufferToggle", () => $2c9534dd8b7681cc$export$91115bdd8709945f, (v) => $2c9534dd8b7681cc$export$91115bdd8709945f = v);
$parcel$export(module.exports, "bufferWhen", () => $2c9534dd8b7681cc$export$9e55760d3282e08c, (v) => $2c9534dd8b7681cc$export$9e55760d3282e08c = v);
$parcel$export(module.exports, "catchError", () => $2c9534dd8b7681cc$export$3dede90624df3ba9, (v) => $2c9534dd8b7681cc$export$3dede90624df3ba9 = v);
$parcel$export(module.exports, "combineAll", () => $2c9534dd8b7681cc$export$29ae691b7de52fe3, (v) => $2c9534dd8b7681cc$export$29ae691b7de52fe3 = v);
$parcel$export(module.exports, "combineLatest", () => $2c9534dd8b7681cc$export$77fa7d86f5204e8a, (v) => $2c9534dd8b7681cc$export$77fa7d86f5204e8a = v);
$parcel$export(module.exports, "concat", () => $2c9534dd8b7681cc$export$ee1b3e54f0441b22, (v) => $2c9534dd8b7681cc$export$ee1b3e54f0441b22 = v);
$parcel$export(module.exports, "concatAll", () => $2c9534dd8b7681cc$export$b314777ae20abca9, (v) => $2c9534dd8b7681cc$export$b314777ae20abca9 = v);
$parcel$export(module.exports, "concatMap", () => $2c9534dd8b7681cc$export$c28c8388be0ab31a, (v) => $2c9534dd8b7681cc$export$c28c8388be0ab31a = v);
$parcel$export(module.exports, "concatMapTo", () => $2c9534dd8b7681cc$export$82fbd7a2841d2484, (v) => $2c9534dd8b7681cc$export$82fbd7a2841d2484 = v);
$parcel$export(module.exports, "count", () => $2c9534dd8b7681cc$export$85b9a36db797e02b, (v) => $2c9534dd8b7681cc$export$85b9a36db797e02b = v);
$parcel$export(module.exports, "debounce", () => $2c9534dd8b7681cc$export$61fc7d43ac8f84b0, (v) => $2c9534dd8b7681cc$export$61fc7d43ac8f84b0 = v);
$parcel$export(module.exports, "debounceTime", () => $2c9534dd8b7681cc$export$7843a4469d64c07e, (v) => $2c9534dd8b7681cc$export$7843a4469d64c07e = v);
$parcel$export(module.exports, "defaultIfEmpty", () => $2c9534dd8b7681cc$export$e4ca6d7b7a6dcf9b, (v) => $2c9534dd8b7681cc$export$e4ca6d7b7a6dcf9b = v);
$parcel$export(module.exports, "delay", () => $2c9534dd8b7681cc$export$1391212d75b2ee65, (v) => $2c9534dd8b7681cc$export$1391212d75b2ee65 = v);
$parcel$export(module.exports, "delayWhen", () => $2c9534dd8b7681cc$export$286ca829307725c9, (v) => $2c9534dd8b7681cc$export$286ca829307725c9 = v);
$parcel$export(module.exports, "dematerialize", () => $2c9534dd8b7681cc$export$ab9a5985b741fa7a, (v) => $2c9534dd8b7681cc$export$ab9a5985b741fa7a = v);
$parcel$export(module.exports, "distinct", () => $2c9534dd8b7681cc$export$983a3b5fb2f7202e, (v) => $2c9534dd8b7681cc$export$983a3b5fb2f7202e = v);
$parcel$export(module.exports, "distinctUntilChanged", () => $2c9534dd8b7681cc$export$779c5fb865a0172e, (v) => $2c9534dd8b7681cc$export$779c5fb865a0172e = v);
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $2c9534dd8b7681cc$export$571da16e28367bde, (v) => $2c9534dd8b7681cc$export$571da16e28367bde = v);
$parcel$export(module.exports, "elementAt", () => $2c9534dd8b7681cc$export$91d69c7761a17bbc, (v) => $2c9534dd8b7681cc$export$91d69c7761a17bbc = v);
$parcel$export(module.exports, "every", () => $2c9534dd8b7681cc$export$7ecc1a3b11b57dab, (v) => $2c9534dd8b7681cc$export$7ecc1a3b11b57dab = v);
$parcel$export(module.exports, "exhaust", () => $2c9534dd8b7681cc$export$31039f1fbd797b9c, (v) => $2c9534dd8b7681cc$export$31039f1fbd797b9c = v);
$parcel$export(module.exports, "exhaustMap", () => $2c9534dd8b7681cc$export$d70d492cd31004c0, (v) => $2c9534dd8b7681cc$export$d70d492cd31004c0 = v);
$parcel$export(module.exports, "expand", () => $2c9534dd8b7681cc$export$9f77e0932fb78f72, (v) => $2c9534dd8b7681cc$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "filter", () => $2c9534dd8b7681cc$export$3dea766d36a8935f, (v) => $2c9534dd8b7681cc$export$3dea766d36a8935f = v);
$parcel$export(module.exports, "finalize", () => $2c9534dd8b7681cc$export$578723aef62d92f5, (v) => $2c9534dd8b7681cc$export$578723aef62d92f5 = v);
$parcel$export(module.exports, "find", () => $2c9534dd8b7681cc$export$71aa6c912b956294, (v) => $2c9534dd8b7681cc$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "findIndex", () => $2c9534dd8b7681cc$export$de3a4d4a0d731119, (v) => $2c9534dd8b7681cc$export$de3a4d4a0d731119 = v);
$parcel$export(module.exports, "first", () => $2c9534dd8b7681cc$export$43128fadae87b74a, (v) => $2c9534dd8b7681cc$export$43128fadae87b74a = v);
$parcel$export(module.exports, "groupBy", () => $2c9534dd8b7681cc$export$3f063810d7bf01bd, (v) => $2c9534dd8b7681cc$export$3f063810d7bf01bd = v);
$parcel$export(module.exports, "ignoreElements", () => $2c9534dd8b7681cc$export$6953b97c7d866605, (v) => $2c9534dd8b7681cc$export$6953b97c7d866605 = v);
$parcel$export(module.exports, "isEmpty", () => $2c9534dd8b7681cc$export$dd1bc94b04021eeb, (v) => $2c9534dd8b7681cc$export$dd1bc94b04021eeb = v);
$parcel$export(module.exports, "last", () => $2c9534dd8b7681cc$export$4c7897fafd92b108, (v) => $2c9534dd8b7681cc$export$4c7897fafd92b108 = v);
$parcel$export(module.exports, "map", () => $2c9534dd8b7681cc$export$871de8747c9eaa88, (v) => $2c9534dd8b7681cc$export$871de8747c9eaa88 = v);
$parcel$export(module.exports, "mapTo", () => $2c9534dd8b7681cc$export$e0eaf3a86c03b2ad, (v) => $2c9534dd8b7681cc$export$e0eaf3a86c03b2ad = v);
$parcel$export(module.exports, "materialize", () => $2c9534dd8b7681cc$export$76dbd6ffd832405d, (v) => $2c9534dd8b7681cc$export$76dbd6ffd832405d = v);
$parcel$export(module.exports, "max", () => $2c9534dd8b7681cc$export$8960430cfd85939f, (v) => $2c9534dd8b7681cc$export$8960430cfd85939f = v);
$parcel$export(module.exports, "merge", () => $2c9534dd8b7681cc$export$4950aa0f605343fb, (v) => $2c9534dd8b7681cc$export$4950aa0f605343fb = v);
$parcel$export(module.exports, "mergeAll", () => $2c9534dd8b7681cc$export$18aef43295bbe906, (v) => $2c9534dd8b7681cc$export$18aef43295bbe906 = v);
$parcel$export(module.exports, "mergeMap", () => $2c9534dd8b7681cc$export$6b9f6c0d32c093f9, (v) => $2c9534dd8b7681cc$export$6b9f6c0d32c093f9 = v);
$parcel$export(module.exports, "flatMap", () => $2c9534dd8b7681cc$export$5b8affa63fc6df16, (v) => $2c9534dd8b7681cc$export$5b8affa63fc6df16 = v);
$parcel$export(module.exports, "mergeMapTo", () => $2c9534dd8b7681cc$export$bd7cfc9a42b8a412, (v) => $2c9534dd8b7681cc$export$bd7cfc9a42b8a412 = v);
$parcel$export(module.exports, "mergeScan", () => $2c9534dd8b7681cc$export$c1fc905202bced53, (v) => $2c9534dd8b7681cc$export$c1fc905202bced53 = v);
$parcel$export(module.exports, "min", () => $2c9534dd8b7681cc$export$96ec731ed4dcb222, (v) => $2c9534dd8b7681cc$export$96ec731ed4dcb222 = v);
$parcel$export(module.exports, "multicast", () => $2c9534dd8b7681cc$export$1364843af8d5a963, (v) => $2c9534dd8b7681cc$export$1364843af8d5a963 = v);
$parcel$export(module.exports, "observeOn", () => $2c9534dd8b7681cc$export$9007f49c319d1ac7, (v) => $2c9534dd8b7681cc$export$9007f49c319d1ac7 = v);
$parcel$export(module.exports, "onErrorResumeNext", () => $2c9534dd8b7681cc$export$5fba66d61591f42, (v) => $2c9534dd8b7681cc$export$5fba66d61591f42 = v);
$parcel$export(module.exports, "pairwise", () => $2c9534dd8b7681cc$export$8f9d79d42bff1aac, (v) => $2c9534dd8b7681cc$export$8f9d79d42bff1aac = v);
$parcel$export(module.exports, "partition", () => $2c9534dd8b7681cc$export$b29f828819edca8d, (v) => $2c9534dd8b7681cc$export$b29f828819edca8d = v);
$parcel$export(module.exports, "pluck", () => $2c9534dd8b7681cc$export$c44985b87d605eff, (v) => $2c9534dd8b7681cc$export$c44985b87d605eff = v);
$parcel$export(module.exports, "publish", () => $2c9534dd8b7681cc$export$89b472e03be495df, (v) => $2c9534dd8b7681cc$export$89b472e03be495df = v);
$parcel$export(module.exports, "publishBehavior", () => $2c9534dd8b7681cc$export$16ae46fda9567053, (v) => $2c9534dd8b7681cc$export$16ae46fda9567053 = v);
$parcel$export(module.exports, "publishLast", () => $2c9534dd8b7681cc$export$42d9b6b38c68d989, (v) => $2c9534dd8b7681cc$export$42d9b6b38c68d989 = v);
$parcel$export(module.exports, "publishReplay", () => $2c9534dd8b7681cc$export$1f3342bf81d92d52, (v) => $2c9534dd8b7681cc$export$1f3342bf81d92d52 = v);
$parcel$export(module.exports, "race", () => $2c9534dd8b7681cc$export$236c05de452bec2, (v) => $2c9534dd8b7681cc$export$236c05de452bec2 = v);
$parcel$export(module.exports, "reduce", () => $2c9534dd8b7681cc$export$533b26079ad0b4b, (v) => $2c9534dd8b7681cc$export$533b26079ad0b4b = v);
$parcel$export(module.exports, "repeat", () => $2c9534dd8b7681cc$export$76d90c956114f2c2, (v) => $2c9534dd8b7681cc$export$76d90c956114f2c2 = v);
$parcel$export(module.exports, "repeatWhen", () => $2c9534dd8b7681cc$export$b39ac5b4ffd1415a, (v) => $2c9534dd8b7681cc$export$b39ac5b4ffd1415a = v);
$parcel$export(module.exports, "retry", () => $2c9534dd8b7681cc$export$9369b12211e1fce4, (v) => $2c9534dd8b7681cc$export$9369b12211e1fce4 = v);
$parcel$export(module.exports, "retryWhen", () => $2c9534dd8b7681cc$export$1281551253cfee02, (v) => $2c9534dd8b7681cc$export$1281551253cfee02 = v);
$parcel$export(module.exports, "refCount", () => $2c9534dd8b7681cc$export$18d0766d894cba0c, (v) => $2c9534dd8b7681cc$export$18d0766d894cba0c = v);
$parcel$export(module.exports, "sample", () => $2c9534dd8b7681cc$export$4812e460280c6ef2, (v) => $2c9534dd8b7681cc$export$4812e460280c6ef2 = v);
$parcel$export(module.exports, "sampleTime", () => $2c9534dd8b7681cc$export$fe33c7b2002d97b0, (v) => $2c9534dd8b7681cc$export$fe33c7b2002d97b0 = v);
$parcel$export(module.exports, "scan", () => $2c9534dd8b7681cc$export$c87d910e63d22ed6, (v) => $2c9534dd8b7681cc$export$c87d910e63d22ed6 = v);
$parcel$export(module.exports, "sequenceEqual", () => $2c9534dd8b7681cc$export$d0a07e60ae428313, (v) => $2c9534dd8b7681cc$export$d0a07e60ae428313 = v);
$parcel$export(module.exports, "share", () => $2c9534dd8b7681cc$export$ed80d9de1d9df928, (v) => $2c9534dd8b7681cc$export$ed80d9de1d9df928 = v);
$parcel$export(module.exports, "shareReplay", () => $2c9534dd8b7681cc$export$db61d692014e534e, (v) => $2c9534dd8b7681cc$export$db61d692014e534e = v);
$parcel$export(module.exports, "single", () => $2c9534dd8b7681cc$export$863d7ca51b416cee, (v) => $2c9534dd8b7681cc$export$863d7ca51b416cee = v);
$parcel$export(module.exports, "skip", () => $2c9534dd8b7681cc$export$955fc4a6c4be454d, (v) => $2c9534dd8b7681cc$export$955fc4a6c4be454d = v);
$parcel$export(module.exports, "skipLast", () => $2c9534dd8b7681cc$export$635f6273df29ea1c, (v) => $2c9534dd8b7681cc$export$635f6273df29ea1c = v);
$parcel$export(module.exports, "skipUntil", () => $2c9534dd8b7681cc$export$facc584867c26fde, (v) => $2c9534dd8b7681cc$export$facc584867c26fde = v);
$parcel$export(module.exports, "skipWhile", () => $2c9534dd8b7681cc$export$175dedd748069215, (v) => $2c9534dd8b7681cc$export$175dedd748069215 = v);
$parcel$export(module.exports, "startWith", () => $2c9534dd8b7681cc$export$a4fe86229b0e9bdd, (v) => $2c9534dd8b7681cc$export$a4fe86229b0e9bdd = v);
$parcel$export(module.exports, "switchAll", () => $2c9534dd8b7681cc$export$6a45284a4b0bf33a, (v) => $2c9534dd8b7681cc$export$6a45284a4b0bf33a = v);
$parcel$export(module.exports, "switchMap", () => $2c9534dd8b7681cc$export$9f6ea8e48bc26eab, (v) => $2c9534dd8b7681cc$export$9f6ea8e48bc26eab = v);
$parcel$export(module.exports, "switchMapTo", () => $2c9534dd8b7681cc$export$a439dc30c845238, (v) => $2c9534dd8b7681cc$export$a439dc30c845238 = v);
$parcel$export(module.exports, "take", () => $2c9534dd8b7681cc$export$b7df5d561049483a, (v) => $2c9534dd8b7681cc$export$b7df5d561049483a = v);
$parcel$export(module.exports, "takeLast", () => $2c9534dd8b7681cc$export$1b47ad771ce5af5e, (v) => $2c9534dd8b7681cc$export$1b47ad771ce5af5e = v);
$parcel$export(module.exports, "takeUntil", () => $2c9534dd8b7681cc$export$ac8dfd3a7ad06e80, (v) => $2c9534dd8b7681cc$export$ac8dfd3a7ad06e80 = v);
$parcel$export(module.exports, "takeWhile", () => $2c9534dd8b7681cc$export$9384c7afe4015e42, (v) => $2c9534dd8b7681cc$export$9384c7afe4015e42 = v);
$parcel$export(module.exports, "tap", () => $2c9534dd8b7681cc$export$3f23594af5f37336, (v) => $2c9534dd8b7681cc$export$3f23594af5f37336 = v);
$parcel$export(module.exports, "throttle", () => $2c9534dd8b7681cc$export$de363e709c412c8a, (v) => $2c9534dd8b7681cc$export$de363e709c412c8a = v);
$parcel$export(module.exports, "throttleTime", () => $2c9534dd8b7681cc$export$4efe28f192921dd4, (v) => $2c9534dd8b7681cc$export$4efe28f192921dd4 = v);
$parcel$export(module.exports, "timeInterval", () => $2c9534dd8b7681cc$export$1a539c8b2950ab40, (v) => $2c9534dd8b7681cc$export$1a539c8b2950ab40 = v);
$parcel$export(module.exports, "timeout", () => $2c9534dd8b7681cc$export$83e74882c5df8fe1, (v) => $2c9534dd8b7681cc$export$83e74882c5df8fe1 = v);
$parcel$export(module.exports, "timeoutWith", () => $2c9534dd8b7681cc$export$86fe999fba7953f2, (v) => $2c9534dd8b7681cc$export$86fe999fba7953f2 = v);
$parcel$export(module.exports, "timestamp", () => $2c9534dd8b7681cc$export$fc00ee57782020aa, (v) => $2c9534dd8b7681cc$export$fc00ee57782020aa = v);
$parcel$export(module.exports, "toArray", () => $2c9534dd8b7681cc$export$45b10814cc054894, (v) => $2c9534dd8b7681cc$export$45b10814cc054894 = v);
$parcel$export(module.exports, "window", () => $2c9534dd8b7681cc$export$8291e5b88f90ce4, (v) => $2c9534dd8b7681cc$export$8291e5b88f90ce4 = v);
$parcel$export(module.exports, "windowCount", () => $2c9534dd8b7681cc$export$f3a19e933f377396, (v) => $2c9534dd8b7681cc$export$f3a19e933f377396 = v);
$parcel$export(module.exports, "windowTime", () => $2c9534dd8b7681cc$export$1284415effa79ee0, (v) => $2c9534dd8b7681cc$export$1284415effa79ee0 = v);
$parcel$export(module.exports, "windowToggle", () => $2c9534dd8b7681cc$export$3182be990e0eeaad, (v) => $2c9534dd8b7681cc$export$3182be990e0eeaad = v);
$parcel$export(module.exports, "windowWhen", () => $2c9534dd8b7681cc$export$6a5dea797879f644, (v) => $2c9534dd8b7681cc$export$6a5dea797879f644 = v);
$parcel$export(module.exports, "withLatestFrom", () => $2c9534dd8b7681cc$export$d449030e5c10edf7, (v) => $2c9534dd8b7681cc$export$d449030e5c10edf7 = v);
$parcel$export(module.exports, "zip", () => $2c9534dd8b7681cc$export$8901015135f2fb22, (v) => $2c9534dd8b7681cc$export$8901015135f2fb22 = v);
$parcel$export(module.exports, "zipAll", () => $2c9534dd8b7681cc$export$adddb6a2fa3864e9, (v) => $2c9534dd8b7681cc$export$adddb6a2fa3864e9 = v);
var $2c9534dd8b7681cc$export$d779b02e6b68c3e8;
var $2c9534dd8b7681cc$export$719c70722b10e5ff;
var $2c9534dd8b7681cc$export$ab1029bcae9ddb4a;
var $2c9534dd8b7681cc$export$8916d2c8119541bb;
var $2c9534dd8b7681cc$export$d6b40c95035461c7;
var $2c9534dd8b7681cc$export$91115bdd8709945f;
var $2c9534dd8b7681cc$export$9e55760d3282e08c;
var $2c9534dd8b7681cc$export$3dede90624df3ba9;
var $2c9534dd8b7681cc$export$29ae691b7de52fe3;
var $2c9534dd8b7681cc$export$77fa7d86f5204e8a;
var $2c9534dd8b7681cc$export$ee1b3e54f0441b22;
var $2c9534dd8b7681cc$export$b314777ae20abca9;
var $2c9534dd8b7681cc$export$c28c8388be0ab31a;
var $2c9534dd8b7681cc$export$82fbd7a2841d2484;
var $2c9534dd8b7681cc$export$85b9a36db797e02b;
var $2c9534dd8b7681cc$export$61fc7d43ac8f84b0;
var $2c9534dd8b7681cc$export$7843a4469d64c07e;
var $2c9534dd8b7681cc$export$e4ca6d7b7a6dcf9b;
var $2c9534dd8b7681cc$export$1391212d75b2ee65;
var $2c9534dd8b7681cc$export$286ca829307725c9;
var $2c9534dd8b7681cc$export$ab9a5985b741fa7a;
var $2c9534dd8b7681cc$export$983a3b5fb2f7202e;
var $2c9534dd8b7681cc$export$779c5fb865a0172e;
var $2c9534dd8b7681cc$export$571da16e28367bde;
var $2c9534dd8b7681cc$export$91d69c7761a17bbc;
var $2c9534dd8b7681cc$export$7ecc1a3b11b57dab;
var $2c9534dd8b7681cc$export$31039f1fbd797b9c;
var $2c9534dd8b7681cc$export$d70d492cd31004c0;
var $2c9534dd8b7681cc$export$9f77e0932fb78f72;
var $2c9534dd8b7681cc$export$3dea766d36a8935f;
var $2c9534dd8b7681cc$export$578723aef62d92f5;
var $2c9534dd8b7681cc$export$71aa6c912b956294;
var $2c9534dd8b7681cc$export$de3a4d4a0d731119;
var $2c9534dd8b7681cc$export$43128fadae87b74a;
var $2c9534dd8b7681cc$export$3f063810d7bf01bd;
var $2c9534dd8b7681cc$export$6953b97c7d866605;
var $2c9534dd8b7681cc$export$dd1bc94b04021eeb;
var $2c9534dd8b7681cc$export$4c7897fafd92b108;
var $2c9534dd8b7681cc$export$871de8747c9eaa88;
var $2c9534dd8b7681cc$export$e0eaf3a86c03b2ad;
var $2c9534dd8b7681cc$export$76dbd6ffd832405d;
var $2c9534dd8b7681cc$export$8960430cfd85939f;
var $2c9534dd8b7681cc$export$4950aa0f605343fb;
var $2c9534dd8b7681cc$export$18aef43295bbe906;
var $2c9534dd8b7681cc$export$6b9f6c0d32c093f9;
var $2c9534dd8b7681cc$export$5b8affa63fc6df16;
var $2c9534dd8b7681cc$export$bd7cfc9a42b8a412;
var $2c9534dd8b7681cc$export$c1fc905202bced53;
var $2c9534dd8b7681cc$export$96ec731ed4dcb222;
var $2c9534dd8b7681cc$export$1364843af8d5a963;
var $2c9534dd8b7681cc$export$9007f49c319d1ac7;
var $2c9534dd8b7681cc$export$5fba66d61591f42;
var $2c9534dd8b7681cc$export$8f9d79d42bff1aac;
var $2c9534dd8b7681cc$export$b29f828819edca8d;
var $2c9534dd8b7681cc$export$c44985b87d605eff;
var $2c9534dd8b7681cc$export$89b472e03be495df;
var $2c9534dd8b7681cc$export$16ae46fda9567053;
var $2c9534dd8b7681cc$export$42d9b6b38c68d989;
var $2c9534dd8b7681cc$export$1f3342bf81d92d52;
var $2c9534dd8b7681cc$export$236c05de452bec2;
var $2c9534dd8b7681cc$export$533b26079ad0b4b;
var $2c9534dd8b7681cc$export$76d90c956114f2c2;
var $2c9534dd8b7681cc$export$b39ac5b4ffd1415a;
var $2c9534dd8b7681cc$export$9369b12211e1fce4;
var $2c9534dd8b7681cc$export$1281551253cfee02;
var $2c9534dd8b7681cc$export$18d0766d894cba0c;
var $2c9534dd8b7681cc$export$4812e460280c6ef2;
var $2c9534dd8b7681cc$export$fe33c7b2002d97b0;
var $2c9534dd8b7681cc$export$c87d910e63d22ed6;
var $2c9534dd8b7681cc$export$d0a07e60ae428313;
var $2c9534dd8b7681cc$export$ed80d9de1d9df928;
var $2c9534dd8b7681cc$export$db61d692014e534e;
var $2c9534dd8b7681cc$export$863d7ca51b416cee;
var $2c9534dd8b7681cc$export$955fc4a6c4be454d;
var $2c9534dd8b7681cc$export$635f6273df29ea1c;
var $2c9534dd8b7681cc$export$facc584867c26fde;
var $2c9534dd8b7681cc$export$175dedd748069215;
var $2c9534dd8b7681cc$export$a4fe86229b0e9bdd;
var $2c9534dd8b7681cc$export$6a45284a4b0bf33a;
var $2c9534dd8b7681cc$export$9f6ea8e48bc26eab;
var $2c9534dd8b7681cc$export$a439dc30c845238;
var $2c9534dd8b7681cc$export$b7df5d561049483a;
var $2c9534dd8b7681cc$export$1b47ad771ce5af5e;
var $2c9534dd8b7681cc$export$ac8dfd3a7ad06e80;
var $2c9534dd8b7681cc$export$9384c7afe4015e42;
var $2c9534dd8b7681cc$export$3f23594af5f37336;
var $2c9534dd8b7681cc$export$de363e709c412c8a;
var $2c9534dd8b7681cc$export$4efe28f192921dd4;
var $2c9534dd8b7681cc$export$1a539c8b2950ab40;
var $2c9534dd8b7681cc$export$83e74882c5df8fe1;
var $2c9534dd8b7681cc$export$86fe999fba7953f2;
var $2c9534dd8b7681cc$export$fc00ee57782020aa;
var $2c9534dd8b7681cc$export$45b10814cc054894;
var $2c9534dd8b7681cc$export$8291e5b88f90ce4;
var $2c9534dd8b7681cc$export$f3a19e933f377396;
var $2c9534dd8b7681cc$export$1284415effa79ee0;
var $2c9534dd8b7681cc$export$3182be990e0eeaad;
var $2c9534dd8b7681cc$export$6a5dea797879f644;
var $2c9534dd8b7681cc$export$d449030e5c10edf7;
var $2c9534dd8b7681cc$export$8901015135f2fb22;
var $2c9534dd8b7681cc$export$adddb6a2fa3864e9;
"use strict";

var $dAwhn = parcelRequire("dAwhn");
$2c9534dd8b7681cc$export$d779b02e6b68c3e8 = $dAwhn.audit;

var $3VGkX = parcelRequire("3VGkX");
$2c9534dd8b7681cc$export$719c70722b10e5ff = $3VGkX.auditTime;

var $4e1E9 = parcelRequire("4e1E9");
$2c9534dd8b7681cc$export$ab1029bcae9ddb4a = $4e1E9.buffer;

var $ezyFF = parcelRequire("ezyFF");
$2c9534dd8b7681cc$export$8916d2c8119541bb = $ezyFF.bufferCount;

var $6WyH7 = parcelRequire("6WyH7");
$2c9534dd8b7681cc$export$d6b40c95035461c7 = $6WyH7.bufferTime;

var $bTHFX = parcelRequire("bTHFX");
$2c9534dd8b7681cc$export$91115bdd8709945f = $bTHFX.bufferToggle;

var $7PyRa = parcelRequire("7PyRa");
$2c9534dd8b7681cc$export$9e55760d3282e08c = $7PyRa.bufferWhen;

var $8fIcg = parcelRequire("8fIcg");
$2c9534dd8b7681cc$export$3dede90624df3ba9 = $8fIcg.catchError;

var $dMuCG = parcelRequire("dMuCG");
$2c9534dd8b7681cc$export$29ae691b7de52fe3 = $dMuCG.combineAll;

var $gVAew = parcelRequire("gVAew");
$2c9534dd8b7681cc$export$77fa7d86f5204e8a = $gVAew.combineLatest;

var $3cyYk = parcelRequire("3cyYk");
$2c9534dd8b7681cc$export$ee1b3e54f0441b22 = $3cyYk.concat;

var $dS4Ly = parcelRequire("dS4Ly");
$2c9534dd8b7681cc$export$b314777ae20abca9 = $dS4Ly.concatAll;

var $6xf0A = parcelRequire("6xf0A");
$2c9534dd8b7681cc$export$c28c8388be0ab31a = $6xf0A.concatMap;

var $60MEq = parcelRequire("60MEq");
$2c9534dd8b7681cc$export$82fbd7a2841d2484 = $60MEq.concatMapTo;

var $9EKxB = parcelRequire("9EKxB");
$2c9534dd8b7681cc$export$85b9a36db797e02b = $9EKxB.count;

var $7y17I = parcelRequire("7y17I");
$2c9534dd8b7681cc$export$61fc7d43ac8f84b0 = $7y17I.debounce;

var $bTpsd = parcelRequire("bTpsd");
$2c9534dd8b7681cc$export$7843a4469d64c07e = $bTpsd.debounceTime;

var $7c96M = parcelRequire("7c96M");
$2c9534dd8b7681cc$export$e4ca6d7b7a6dcf9b = $7c96M.defaultIfEmpty;

var $dQaXZ = parcelRequire("dQaXZ");
$2c9534dd8b7681cc$export$1391212d75b2ee65 = $dQaXZ.delay;

var $2QM38 = parcelRequire("2QM38");
$2c9534dd8b7681cc$export$286ca829307725c9 = $2QM38.delayWhen;

var $6fPE8 = parcelRequire("6fPE8");
$2c9534dd8b7681cc$export$ab9a5985b741fa7a = $6fPE8.dematerialize;

var $Ro605 = parcelRequire("Ro605");
$2c9534dd8b7681cc$export$983a3b5fb2f7202e = $Ro605.distinct;

var $abyDa = parcelRequire("abyDa");
$2c9534dd8b7681cc$export$779c5fb865a0172e = $abyDa.distinctUntilChanged;

var $9vibc = parcelRequire("9vibc");
$2c9534dd8b7681cc$export$571da16e28367bde = $9vibc.distinctUntilKeyChanged;

var $01nuO = parcelRequire("01nuO");
$2c9534dd8b7681cc$export$91d69c7761a17bbc = $01nuO.elementAt;

var $6dvah = parcelRequire("6dvah");
$2c9534dd8b7681cc$export$7ecc1a3b11b57dab = $6dvah.every;

var $g5QBi = parcelRequire("g5QBi");
$2c9534dd8b7681cc$export$31039f1fbd797b9c = $g5QBi.exhaust;

var $16pqC = parcelRequire("16pqC");
$2c9534dd8b7681cc$export$d70d492cd31004c0 = $16pqC.exhaustMap;

var $5hyH5 = parcelRequire("5hyH5");
$2c9534dd8b7681cc$export$9f77e0932fb78f72 = $5hyH5.expand;

var $6gAgO = parcelRequire("6gAgO");
$2c9534dd8b7681cc$export$3dea766d36a8935f = $6gAgO.filter;

var $eAvJP = parcelRequire("eAvJP");
$2c9534dd8b7681cc$export$578723aef62d92f5 = $eAvJP.finalize;

var $gxQ8U = parcelRequire("gxQ8U");
$2c9534dd8b7681cc$export$71aa6c912b956294 = $gxQ8U.find;

var $lSZQd = parcelRequire("lSZQd");
$2c9534dd8b7681cc$export$de3a4d4a0d731119 = $lSZQd.findIndex;

var $cLKXI = parcelRequire("cLKXI");
$2c9534dd8b7681cc$export$43128fadae87b74a = $cLKXI.first;

var $89h2t = parcelRequire("89h2t");
$2c9534dd8b7681cc$export$3f063810d7bf01bd = $89h2t.groupBy;

var $d1NAc = parcelRequire("d1NAc");
$2c9534dd8b7681cc$export$6953b97c7d866605 = $d1NAc.ignoreElements;

var $9bxss = parcelRequire("9bxss");
$2c9534dd8b7681cc$export$dd1bc94b04021eeb = $9bxss.isEmpty;

var $z0UIM = parcelRequire("z0UIM");
$2c9534dd8b7681cc$export$4c7897fafd92b108 = $z0UIM.last;

var $a8ocL = parcelRequire("a8ocL");
$2c9534dd8b7681cc$export$871de8747c9eaa88 = $a8ocL.map;

var $d5CX7 = parcelRequire("d5CX7");
$2c9534dd8b7681cc$export$e0eaf3a86c03b2ad = $d5CX7.mapTo;

var $aucJm = parcelRequire("aucJm");
$2c9534dd8b7681cc$export$76dbd6ffd832405d = $aucJm.materialize;

var $jIwHI = parcelRequire("jIwHI");
$2c9534dd8b7681cc$export$8960430cfd85939f = $jIwHI.max;

var $8nnVB = parcelRequire("8nnVB");
$2c9534dd8b7681cc$export$4950aa0f605343fb = $8nnVB.merge;

var $44a5l = parcelRequire("44a5l");
$2c9534dd8b7681cc$export$18aef43295bbe906 = $44a5l.mergeAll;

var $5iPTs = parcelRequire("5iPTs");
$2c9534dd8b7681cc$export$6b9f6c0d32c093f9 = $5iPTs.mergeMap;

var $5iPTs = parcelRequire("5iPTs");
$2c9534dd8b7681cc$export$5b8affa63fc6df16 = $5iPTs.mergeMap;

var $gr3E9 = parcelRequire("gr3E9");
$2c9534dd8b7681cc$export$bd7cfc9a42b8a412 = $gr3E9.mergeMapTo;

var $eWsbb = parcelRequire("eWsbb");
$2c9534dd8b7681cc$export$c1fc905202bced53 = $eWsbb.mergeScan;

var $bNZmi = parcelRequire("bNZmi");
$2c9534dd8b7681cc$export$96ec731ed4dcb222 = $bNZmi.min;

var $eZUXH = parcelRequire("eZUXH");
$2c9534dd8b7681cc$export$1364843af8d5a963 = $eZUXH.multicast;

var $auaKp = parcelRequire("auaKp");
$2c9534dd8b7681cc$export$9007f49c319d1ac7 = $auaKp.observeOn;

var $3LIqA = parcelRequire("3LIqA");
$2c9534dd8b7681cc$export$5fba66d61591f42 = $3LIqA.onErrorResumeNext;

var $fFZyU = parcelRequire("fFZyU");
$2c9534dd8b7681cc$export$8f9d79d42bff1aac = $fFZyU.pairwise;

var $c69ly = parcelRequire("c69ly");
$2c9534dd8b7681cc$export$b29f828819edca8d = $c69ly.partition;

var $4fHnI = parcelRequire("4fHnI");
$2c9534dd8b7681cc$export$c44985b87d605eff = $4fHnI.pluck;

var $3c6DP = parcelRequire("3c6DP");
$2c9534dd8b7681cc$export$89b472e03be495df = $3c6DP.publish;

var $3LSnj = parcelRequire("3LSnj");
$2c9534dd8b7681cc$export$16ae46fda9567053 = $3LSnj.publishBehavior;

var $hIwwO = parcelRequire("hIwwO");
$2c9534dd8b7681cc$export$42d9b6b38c68d989 = $hIwwO.publishLast;

var $aPWBE = parcelRequire("aPWBE");
$2c9534dd8b7681cc$export$1f3342bf81d92d52 = $aPWBE.publishReplay;

var $5Osch = parcelRequire("5Osch");
$2c9534dd8b7681cc$export$236c05de452bec2 = $5Osch.race;

var $d2E9m = parcelRequire("d2E9m");
$2c9534dd8b7681cc$export$533b26079ad0b4b = $d2E9m.reduce;

var $fAyAG = parcelRequire("fAyAG");
$2c9534dd8b7681cc$export$76d90c956114f2c2 = $fAyAG.repeat;

var $ia4pH = parcelRequire("ia4pH");
$2c9534dd8b7681cc$export$b39ac5b4ffd1415a = $ia4pH.repeatWhen;

var $aNZ13 = parcelRequire("aNZ13");
$2c9534dd8b7681cc$export$9369b12211e1fce4 = $aNZ13.retry;

var $cxRbl = parcelRequire("cxRbl");
$2c9534dd8b7681cc$export$1281551253cfee02 = $cxRbl.retryWhen;

var $9rQxt = parcelRequire("9rQxt");
$2c9534dd8b7681cc$export$18d0766d894cba0c = $9rQxt.refCount;

var $ktFkz = parcelRequire("ktFkz");
$2c9534dd8b7681cc$export$4812e460280c6ef2 = $ktFkz.sample;

var $8vhnd = parcelRequire("8vhnd");
$2c9534dd8b7681cc$export$fe33c7b2002d97b0 = $8vhnd.sampleTime;

var $9PjKc = parcelRequire("9PjKc");
$2c9534dd8b7681cc$export$c87d910e63d22ed6 = $9PjKc.scan;

var $8i6Wf = parcelRequire("8i6Wf");
$2c9534dd8b7681cc$export$d0a07e60ae428313 = $8i6Wf.sequenceEqual;

var $5rPGq = parcelRequire("5rPGq");
$2c9534dd8b7681cc$export$ed80d9de1d9df928 = $5rPGq.share;

var $5iQVm = parcelRequire("5iQVm");
$2c9534dd8b7681cc$export$db61d692014e534e = $5iQVm.shareReplay;

var $ilSU2 = parcelRequire("ilSU2");
$2c9534dd8b7681cc$export$863d7ca51b416cee = $ilSU2.single;

var $49GtU = parcelRequire("49GtU");
$2c9534dd8b7681cc$export$955fc4a6c4be454d = $49GtU.skip;

var $gpvz2 = parcelRequire("gpvz2");
$2c9534dd8b7681cc$export$635f6273df29ea1c = $gpvz2.skipLast;

var $2TJZF = parcelRequire("2TJZF");
$2c9534dd8b7681cc$export$facc584867c26fde = $2TJZF.skipUntil;

var $8PxWq = parcelRequire("8PxWq");
$2c9534dd8b7681cc$export$175dedd748069215 = $8PxWq.skipWhile;

var $dsNFs = parcelRequire("dsNFs");
$2c9534dd8b7681cc$export$a4fe86229b0e9bdd = $dsNFs.startWith;

var $eRao4 = parcelRequire("eRao4");
$2c9534dd8b7681cc$export$6a45284a4b0bf33a = $eRao4.switchAll;

var $aE20L = parcelRequire("aE20L");
$2c9534dd8b7681cc$export$9f6ea8e48bc26eab = $aE20L.switchMap;

var $7sE6z = parcelRequire("7sE6z");
$2c9534dd8b7681cc$export$a439dc30c845238 = $7sE6z.switchMapTo;

var $Gjmd7 = parcelRequire("Gjmd7");
$2c9534dd8b7681cc$export$b7df5d561049483a = $Gjmd7.take;

var $iPNgA = parcelRequire("iPNgA");
$2c9534dd8b7681cc$export$1b47ad771ce5af5e = $iPNgA.takeLast;

var $71eJZ = parcelRequire("71eJZ");
$2c9534dd8b7681cc$export$ac8dfd3a7ad06e80 = $71eJZ.takeUntil;

var $6jL2I = parcelRequire("6jL2I");
$2c9534dd8b7681cc$export$9384c7afe4015e42 = $6jL2I.takeWhile;

var $epwkG = parcelRequire("epwkG");
$2c9534dd8b7681cc$export$3f23594af5f37336 = $epwkG.tap;

var $3MScT = parcelRequire("3MScT");
$2c9534dd8b7681cc$export$de363e709c412c8a = $3MScT.throttle;

var $4z4yD = parcelRequire("4z4yD");
$2c9534dd8b7681cc$export$4efe28f192921dd4 = $4z4yD.throttleTime;

var $4wNaD = parcelRequire("4wNaD");
$2c9534dd8b7681cc$export$1a539c8b2950ab40 = $4wNaD.timeInterval;

var $iJ84d = parcelRequire("iJ84d");
$2c9534dd8b7681cc$export$83e74882c5df8fe1 = $iJ84d.timeout;

var $h8zVV = parcelRequire("h8zVV");
$2c9534dd8b7681cc$export$86fe999fba7953f2 = $h8zVV.timeoutWith;

var $hpCBz = parcelRequire("hpCBz");
$2c9534dd8b7681cc$export$fc00ee57782020aa = $hpCBz.timestamp;

var $b3JoI = parcelRequire("b3JoI");
$2c9534dd8b7681cc$export$45b10814cc054894 = $b3JoI.toArray;

var $57u4K = parcelRequire("57u4K");
$2c9534dd8b7681cc$export$8291e5b88f90ce4 = $57u4K.window;

var $3OPBH = parcelRequire("3OPBH");
$2c9534dd8b7681cc$export$f3a19e933f377396 = $3OPBH.windowCount;

var $Sgxd2 = parcelRequire("Sgxd2");
$2c9534dd8b7681cc$export$1284415effa79ee0 = $Sgxd2.windowTime;

var $4HJOP = parcelRequire("4HJOP");
$2c9534dd8b7681cc$export$3182be990e0eeaad = $4HJOP.windowToggle;

var $26M4y = parcelRequire("26M4y");
$2c9534dd8b7681cc$export$6a5dea797879f644 = $26M4y.windowWhen;

var $gUOpO = parcelRequire("gUOpO");
$2c9534dd8b7681cc$export$d449030e5c10edf7 = $gUOpO.withLatestFrom;

var $713Wo = parcelRequire("713Wo");
$2c9534dd8b7681cc$export$8901015135f2fb22 = $713Wo.zip;

var $2sxLS = parcelRequire("2sxLS");
$2c9534dd8b7681cc$export$adddb6a2fa3864e9 = $2sxLS.zipAll;

});


parcelRegister("id21D", function(module, exports) {
$parcel$export(module.exports, "completeSignupEpic", () => $89acada3d555d040$export$c3902030a5d4d47a);
$parcel$export(module.exports, "sendNewSignupLinkEpic", () => $89acada3d555d040$export$5566cb2a1dee7448);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $dZlRg = parcelRequire("dZlRg");

var $dSvQo = parcelRequire("dSvQo");
parcelRequire("l0dvx");
var $053zO = parcelRequire("053zO");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");

var $g4UBb = parcelRequire("g4UBb");
const $89acada3d555d040$export$c3902030a5d4d47a = (action$)=>{
    return action$.ofType((0, $053zO.COMPLETE_SIGNUP)).mergeMap((completeSignupAction)=>{
        const { jwtToken: jwtToken, fullName: fullName, password: password, email: email, contactAdminsFormEnabled: contactAdminsFormEnabled, continueParam: continueParam } = completeSignupAction.payload;
        return (0, $dZlRg.completeSignup)(jwtToken, fullName, password).flatMap(()=>{
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $053zO.completeSignupSuccess)()), (0, $fSYYZ.Observable).of((0, $uiV1X.loginAttempt)({
                email: email,
                password: password,
                continueParam: continueParam ?? null
            })));
        }).catch((error)=>{
            const parsedError = (0, $g4UBb.getDefaultSignUpError)(error, contactAdminsFormEnabled);
            return (0, $fSYYZ.Observable).of((0, $053zO.completeSignupFailure)(parsedError));
        });
    });
};
const $89acada3d555d040$export$5566cb2a1dee7448 = (action$)=>{
    return action$.ofType((0, $053zO.SEND_NEW_SIGNUP_LINK)).mergeMap((sendNewSignupLinkAction)=>{
        const { email: email, portalId: portalId } = sendNewSignupLinkAction.payload;
        return (0, $dSvQo.resendValidationEmail)(email, portalId, undefined).map(()=>{
            return (0, $053zO.sendNewSignupLinkSuccess)();
        }).catch((error)=>{
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $053zO.sendNewSignupLinkFailure)()), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("6p5HB", function(module, exports) {
$parcel$export(module.exports, "HANDLE_AJAX_ERROR", () => $b61dd2ef208168d4$export$a7c57e52be964b91);
$parcel$export(module.exports, "SHOW_ERROR_FLAG", () => $b61dd2ef208168d4$export$2b6b999b3eafcf24);
$parcel$export(module.exports, "SHOW_WARNING_FLAG", () => $b61dd2ef208168d4$export$4f0f0fac05b2a93f);
$parcel$export(module.exports, "SHOW_SUCCESS_FLAG", () => $b61dd2ef208168d4$export$c911d7565dd7a733);
$parcel$export(module.exports, "SHOW_BOLD_APPEARANCE_FLAG", () => $b61dd2ef208168d4$export$8eec0f3e4bc42e5c);
$parcel$export(module.exports, "DISMISS_FLAG", () => $b61dd2ef208168d4$export$1eb56620df104bf);
$parcel$export(module.exports, "handleAjaxError", () => $b61dd2ef208168d4$export$1245fce1755f5ec2);
$parcel$export(module.exports, "showErrorFlag", () => $b61dd2ef208168d4$export$dfa2148cdb92917d);
$parcel$export(module.exports, "showWarningFlag", () => $b61dd2ef208168d4$export$9475ea83c9ea0d1c);
$parcel$export(module.exports, "showSuccessFlag", () => $b61dd2ef208168d4$export$fef8478a2c810f18);
$parcel$export(module.exports, "showBoldAppearanceFlag", () => $b61dd2ef208168d4$export$4231a8f3b05ab067);
$parcel$export(module.exports, "dismissFlag", () => $b61dd2ef208168d4$export$900a08a292ad23cd);
const $b61dd2ef208168d4$export$a7c57e52be964b91 = 'state.ui.flags.HANDLE_AJAX_ERROR';
const $b61dd2ef208168d4$export$2b6b999b3eafcf24 = 'state.ui.flags.SHOW_ERROR_FLAG';
const $b61dd2ef208168d4$export$4f0f0fac05b2a93f = 'state.ui.flags.SHOW_WARNING_FLAG';
const $b61dd2ef208168d4$export$c911d7565dd7a733 = 'state.ui.flags.SHOW_SUCCESS_FLAG';
const $b61dd2ef208168d4$export$8eec0f3e4bc42e5c = 'state.ui.flags.SHOW_BOLD_APPEARANCE_FLAG';
const $b61dd2ef208168d4$export$1eb56620df104bf = 'state.ui.flags.DISMISS_FLAG';
const $b61dd2ef208168d4$export$1245fce1755f5ec2 = (error)=>({
        type: $b61dd2ef208168d4$export$a7c57e52be964b91,
        payload: {
            error: error
        }
    });
const $b61dd2ef208168d4$export$dfa2148cdb92917d = (titleMessage, descriptionMessage, actions = [], titleMessageValues, descriptionMessageValues)=>({
        type: $b61dd2ef208168d4$export$2b6b999b3eafcf24,
        payload: {
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            actions: actions,
            titleMessageValues: titleMessageValues,
            descriptionMessageValues: descriptionMessageValues
        }
    });
const $b61dd2ef208168d4$export$9475ea83c9ea0d1c = (titleMessage, descriptionMessage, actions = [], titleMessageValues, descriptionMessageValues)=>({
        type: $b61dd2ef208168d4$export$4f0f0fac05b2a93f,
        payload: {
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            actions: actions,
            titleMessageValues: titleMessageValues,
            descriptionMessageValues: descriptionMessageValues
        }
    });
const $b61dd2ef208168d4$export$fef8478a2c810f18 = (titleMessage, titleMessageValues, descriptionMessage, actions, descriptionMessageValues)=>({
        type: $b61dd2ef208168d4$export$c911d7565dd7a733,
        payload: {
            titleMessage: titleMessage,
            titleMessageValues: titleMessageValues,
            descriptionMessage: descriptionMessage,
            descriptionMessageValues: descriptionMessageValues,
            actions: actions
        }
    });
const $b61dd2ef208168d4$export$4231a8f3b05ab067 = (appearance, titleMessage, titleMessageValues, descriptionMessage, descriptionMessageValues, actions, dismissActionValue)=>({
        type: $b61dd2ef208168d4$export$8eec0f3e4bc42e5c,
        payload: {
            appearance: appearance,
            titleMessage: titleMessage,
            titleMessageValues: titleMessageValues,
            descriptionMessage: descriptionMessage,
            descriptionMessageValues: descriptionMessageValues,
            dismissActionValue: dismissActionValue,
            actions: actions
        }
    });
const $b61dd2ef208168d4$export$900a08a292ad23cd = (flagId)=>({
        type: $b61dd2ef208168d4$export$1eb56620df104bf,
        payload: {
            flagId: flagId
        }
    });

});

parcelRegister("dZlRg", function(module, exports) {
$parcel$export(module.exports, "completeSignup", () => $16b88be84898a7be$export$96271c6a96268661);

var $bhOdO = parcelRequire("bhOdO");

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $16b88be84898a7be$export$96271c6a96268661 = (token, fullName, password, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/complete-signup?jwt=${token}`;
    const body = $16b88be84898a7be$var$createBody(fullName, password);
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $breWd.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $bhOdO.Observable).throw(e);
    });
};
const $16b88be84898a7be$var$createBody = (fullName, password)=>{
    return JSON.stringify({
        fullName: fullName,
        password: password
    });
};

});

parcelRegister("dSvQo", function(module, exports) {
$parcel$export(module.exports, "signUp", () => $dd96e7d909c1c5ce$export$cf64224bcd829024);
$parcel$export(module.exports, "resendValidationEmail", () => $dd96e7d909c1c5ce$export$b53bc6c531462e2c);

var $breWd = parcelRequire("breWd");

var $jByYr = parcelRequire("jByYr");

var $7FSs7 = parcelRequire("7FSs7");
const $dd96e7d909c1c5ce$var$baseSignupBody = (email, portalId, redirectUrl)=>({
        email: email,
        signUpContext: {
            portalId: portalId,
            redirectUrl: redirectUrl,
            helpCenterAri: (0, $jByYr.getHelpCenterAri)()
        }
    });
const $dd96e7d909c1c5ce$export$cf64224bcd829024 = async (email, secondaryEmail, portalId, redirectUrl, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/signup`;
    const body = {
        ...$dd96e7d909c1c5ce$var$baseSignupBody(email, portalId, redirectUrl),
        secondaryEmail: secondaryEmail,
        usingNewUi: true
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $breWd.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).toPromise().catch((e)=>Promise.reject(e));
};
const $dd96e7d909c1c5ce$export$b53bc6c531462e2c = (email, portalId, redirectUrl, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/send-validation-email`;
    const body = $dd96e7d909c1c5ce$var$baseSignupBody(email, portalId, redirectUrl);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};

});

parcelRegister("l0dvx", function(module, exports) {
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_MODEL", () => (parcelRequire("053zO")).FETCH_COMPLETE_SIGNUP_MODEL);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_SUCCESS", () => (parcelRequire("053zO")).FETCH_COMPLETE_SIGNUP_SUCCESS);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_FAILURE", () => (parcelRequire("053zO")).FETCH_COMPLETE_SIGNUP_FAILURE);
$parcel$export(module.exports, "COMPLETE_SIGNUP", () => (parcelRequire("053zO")).COMPLETE_SIGNUP);
$parcel$export(module.exports, "COMPLETE_SIGNUP_FAILURE", () => (parcelRequire("053zO")).COMPLETE_SIGNUP_FAILURE);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK", () => (parcelRequire("053zO")).SEND_NEW_SIGNUP_LINK);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_SUCCESS", () => (parcelRequire("053zO")).SEND_NEW_SIGNUP_LINK_SUCCESS);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_FAILURE", () => (parcelRequire("053zO")).SEND_NEW_SIGNUP_LINK_FAILURE);
$parcel$export(module.exports, "fetchCompleteSignupModel", () => (parcelRequire("053zO")).fetchCompleteSignupModel);
$parcel$export(module.exports, "fetchCompleteSignupSuccess", () => (parcelRequire("053zO")).fetchCompleteSignupSuccess);
$parcel$export(module.exports, "fetchCompleteSignupFailure", () => (parcelRequire("053zO")).fetchCompleteSignupFailure);
$parcel$export(module.exports, "completeSignup", () => (parcelRequire("053zO")).completeSignup);
$parcel$export(module.exports, "completeSignupSuccess", () => (parcelRequire("053zO")).completeSignupSuccess);
$parcel$export(module.exports, "completeSignupFailure", () => (parcelRequire("053zO")).completeSignupFailure);
$parcel$export(module.exports, "sendNewSignupLink", () => (parcelRequire("053zO")).sendNewSignupLink);
$parcel$export(module.exports, "sendNewSignupLinkSuccess", () => (parcelRequire("053zO")).sendNewSignupLinkSuccess);
$parcel$export(module.exports, "sendNewSignupLinkFailure", () => (parcelRequire("053zO")).sendNewSignupLinkFailure);

var $053zO = parcelRequire("053zO");

});
parcelRegister("053zO", function(module, exports) {
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_MODEL", () => $f8fc50e12c69945e$export$a57d1f559f8199cb);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_SUCCESS", () => $f8fc50e12c69945e$export$c991c467f18c47c4);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_FAILURE", () => $f8fc50e12c69945e$export$af520912b7d6706d);
$parcel$export(module.exports, "COMPLETE_SIGNUP", () => $f8fc50e12c69945e$export$53ff245dddbf796c);
$parcel$export(module.exports, "COMPLETE_SIGNUP_FAILURE", () => $f8fc50e12c69945e$export$88f081a1fe475d4e);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK", () => $f8fc50e12c69945e$export$d76ccb8fbc57714);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_SUCCESS", () => $f8fc50e12c69945e$export$50cb33d74bd8c2e4);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_FAILURE", () => $f8fc50e12c69945e$export$10f6ec3c86fb611d);
$parcel$export(module.exports, "fetchCompleteSignupModel", () => $f8fc50e12c69945e$export$22acc17286f74b59);
$parcel$export(module.exports, "fetchCompleteSignupSuccess", () => $f8fc50e12c69945e$export$93e33f94b1c7e30b);
$parcel$export(module.exports, "fetchCompleteSignupFailure", () => $f8fc50e12c69945e$export$7559c63f3aa1d23b);
$parcel$export(module.exports, "completeSignup", () => $f8fc50e12c69945e$export$96271c6a96268661);
$parcel$export(module.exports, "completeSignupSuccess", () => $f8fc50e12c69945e$export$854f5c75b16a30e1);
$parcel$export(module.exports, "completeSignupFailure", () => $f8fc50e12c69945e$export$76e49af38e42140f);
$parcel$export(module.exports, "sendNewSignupLink", () => $f8fc50e12c69945e$export$bc99093a83dfa75);
$parcel$export(module.exports, "sendNewSignupLinkSuccess", () => $f8fc50e12c69945e$export$1277dcc40c57fab3);
$parcel$export(module.exports, "sendNewSignupLinkFailure", () => $f8fc50e12c69945e$export$f5f09020b407e701);

var $cWsyg = parcelRequire("cWsyg");
const $f8fc50e12c69945e$export$a57d1f559f8199cb = 'epic.model.FETCH_COMPLETE_SIGNUP_MODEL';
const $f8fc50e12c69945e$export$c991c467f18c47c4 = 'state.persisted.visit.portal.FETCH_COMPLETE_SIGNUP_SUCCESS';
const $f8fc50e12c69945e$export$af520912b7d6706d = 'state.persisted.visit.portal.FETCH_COMPLETE_SIGNUP_FAILURE';
const $f8fc50e12c69945e$export$53ff245dddbf796c = 'state.ui.invited.sign.up.COMPLETE_SIGNUP';
const $f8fc50e12c69945e$export$e7a1360e631dd35b = 'state.ui.invited.sign.up.COMPLETE_SIGNUP_SUCCESS';
const $f8fc50e12c69945e$export$88f081a1fe475d4e = 'state.ui.invited.sign.up.COMPLETE_SIGNUP_FAILURE';
const $f8fc50e12c69945e$export$d76ccb8fbc57714 = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK';
const $f8fc50e12c69945e$export$50cb33d74bd8c2e4 = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK_SUCCESS';
const $f8fc50e12c69945e$export$10f6ec3c86fb611d = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK_FAILURE';
const $f8fc50e12c69945e$export$22acc17286f74b59 = (0, $cWsyg.buildModelsActionCreator)($f8fc50e12c69945e$export$a57d1f559f8199cb, 'completeSignup');
const $f8fc50e12c69945e$export$93e33f94b1c7e30b = (completeSignupResponse)=>({
        type: $f8fc50e12c69945e$export$c991c467f18c47c4,
        payload: completeSignupResponse
    });
const $f8fc50e12c69945e$export$7559c63f3aa1d23b = (error)=>({
        type: $f8fc50e12c69945e$export$af520912b7d6706d,
        payload: {
            error: error
        }
    });
const $f8fc50e12c69945e$export$96271c6a96268661 = (jwtToken, fullName, password, email, contactAdminsFormEnabled, continueParam)=>({
        type: $f8fc50e12c69945e$export$53ff245dddbf796c,
        payload: {
            jwtToken: jwtToken,
            fullName: fullName,
            password: password,
            email: email,
            contactAdminsFormEnabled: contactAdminsFormEnabled,
            continueParam: continueParam
        }
    });
const $f8fc50e12c69945e$export$854f5c75b16a30e1 = ()=>({
        type: $f8fc50e12c69945e$export$e7a1360e631dd35b
    });
const $f8fc50e12c69945e$export$76e49af38e42140f = (error)=>({
        type: $f8fc50e12c69945e$export$88f081a1fe475d4e,
        payload: {
            error: error
        }
    });
const $f8fc50e12c69945e$export$bc99093a83dfa75 = (email, portalId)=>({
        type: $f8fc50e12c69945e$export$d76ccb8fbc57714,
        payload: {
            email: email,
            portalId: portalId
        }
    });
const $f8fc50e12c69945e$export$1277dcc40c57fab3 = ()=>({
        type: $f8fc50e12c69945e$export$50cb33d74bd8c2e4
    });
const $f8fc50e12c69945e$export$f5f09020b407e701 = ()=>({
        type: $f8fc50e12c69945e$export$10f6ec3c86fb611d
    });

});
parcelRegister("cWsyg", function(module, exports) {
$parcel$export(module.exports, "buildModelsActionCreator", () => $71d31fdc97fde57d$export$9f8a38b5e77ac29);
const $71d31fdc97fde57d$export$9f8a38b5e77ac29 = (actionType, type)=>(params = {}, options)=>({
            ...options ? {
                options: options
            } : {},
            type: actionType,
            payload: {
                type: type,
                params: params
            }
        });

});



parcelRegister("9T0nv", function(module, exports) {
$parcel$export(module.exports, "changeEmailInput", () => (parcelRequire("uiV1X")).changeEmailInput);
$parcel$export(module.exports, "checkLoginAction", () => (parcelRequire("uiV1X")).checkLoginAction);
$parcel$export(module.exports, "checkLoginActionSuccess", () => (parcelRequire("uiV1X")).checkLoginActionSuccess);
$parcel$export(module.exports, "checkLoginActionFailure", () => (parcelRequire("uiV1X")).checkLoginActionFailure);
$parcel$export(module.exports, "fetchLoginSuccess", () => (parcelRequire("uiV1X")).fetchLoginSuccess);
$parcel$export(module.exports, "fetchLoginFailure", () => (parcelRequire("uiV1X")).fetchLoginFailure);
$parcel$export(module.exports, "forgotPassword", () => (parcelRequire("uiV1X")).forgotPassword);
$parcel$export(module.exports, "createPassword", () => (parcelRequire("uiV1X")).createPassword);
$parcel$export(module.exports, "createPasswordSuccess", () => (parcelRequire("uiV1X")).createPasswordSuccess);
$parcel$export(module.exports, "forgotPasswordSuccess", () => (parcelRequire("uiV1X")).forgotPasswordSuccess);
$parcel$export(module.exports, "loginAttempt", () => (parcelRequire("uiV1X")).loginAttempt);
$parcel$export(module.exports, "loginAttemptSuccess", () => (parcelRequire("uiV1X")).loginAttemptSuccess);
$parcel$export(module.exports, "loginAttemptFailure", () => (parcelRequire("uiV1X")).loginAttemptFailure);
$parcel$export(module.exports, "resetLogin", () => (parcelRequire("uiV1X")).resetLogin);
$parcel$export(module.exports, "exitTestModeAction", () => (parcelRequire("uiV1X")).exitTestModeAction);
$parcel$export(module.exports, "caSsoTestModeFailure", () => (parcelRequire("uiV1X")).caSsoTestModeFailure);
$parcel$export(module.exports, "loginConsentFailure", () => (parcelRequire("uiV1X")).loginConsentFailure);
$parcel$export(module.exports, "CHANGE_EMAIL_INPUT", () => (parcelRequire("uiV1X")).CHANGE_EMAIL_INPUT);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION", () => (parcelRequire("uiV1X")).CHECK_LOGIN_ACTION);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_FAILURE", () => (parcelRequire("uiV1X")).CHECK_LOGIN_ACTION_FAILURE);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_SUCCESS", () => (parcelRequire("uiV1X")).CHECK_LOGIN_ACTION_SUCCESS);
$parcel$export(module.exports, "FETCH_LOGIN_FAILURE", () => (parcelRequire("uiV1X")).FETCH_LOGIN_FAILURE);
$parcel$export(module.exports, "FETCH_LOGIN_SUCCESS", () => (parcelRequire("uiV1X")).FETCH_LOGIN_SUCCESS);
$parcel$export(module.exports, "CREATE_PASSWORD", () => (parcelRequire("uiV1X")).CREATE_PASSWORD);
$parcel$export(module.exports, "CREATE_PASSWORD_SUCCESS", () => (parcelRequire("uiV1X")).CREATE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FORGOT_PASSWORD", () => (parcelRequire("uiV1X")).FORGOT_PASSWORD);
$parcel$export(module.exports, "FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("uiV1X")).FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FORGOT_PASSWORD_FAILURE", () => (parcelRequire("uiV1X")).FORGOT_PASSWORD_FAILURE);
$parcel$export(module.exports, "LOGIN_ATTEMPT", () => (parcelRequire("uiV1X")).LOGIN_ATTEMPT);
$parcel$export(module.exports, "LOGIN_ATTEMPT_SUCCESS", () => (parcelRequire("uiV1X")).LOGIN_ATTEMPT_SUCCESS);
$parcel$export(module.exports, "LOGIN_ATTEMPT_FAILURE", () => (parcelRequire("uiV1X")).LOGIN_ATTEMPT_FAILURE);
$parcel$export(module.exports, "RESET_LOGIN", () => (parcelRequire("uiV1X")).RESET_LOGIN);
$parcel$export(module.exports, "CA_SSO_TEST_MODE_FAILURE", () => (parcelRequire("uiV1X")).CA_SSO_TEST_MODE_FAILURE);
$parcel$export(module.exports, "LOGIN_CONSENT_FAILURE", () => (parcelRequire("uiV1X")).LOGIN_CONSENT_FAILURE);
$parcel$export(module.exports, "EXIT_TEST_MODE_ACTION", () => (parcelRequire("uiV1X")).EXIT_TEST_MODE_ACTION);

var $uiV1X = parcelRequire("uiV1X");

});
parcelRegister("uiV1X", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_SUCCESS", () => $12c9c6fef2dc74a9$export$839deb1eefe4e515);
$parcel$export(module.exports, "FETCH_LOGIN_FAILURE", () => $12c9c6fef2dc74a9$export$8cf8563c2d1c6683);
$parcel$export(module.exports, "CREATE_PASSWORD", () => $12c9c6fef2dc74a9$export$fe8137105dc1ed9);
$parcel$export(module.exports, "CREATE_PASSWORD_SUCCESS", () => $12c9c6fef2dc74a9$export$66c73e13cf8b697a);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION", () => $12c9c6fef2dc74a9$export$816b17d1322118b2);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_SUCCESS", () => $12c9c6fef2dc74a9$export$f5cb563064a027ff);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_FAILURE", () => $12c9c6fef2dc74a9$export$150db551ad2bf414);
$parcel$export(module.exports, "FORGOT_PASSWORD", () => $12c9c6fef2dc74a9$export$e479859894f5f058);
$parcel$export(module.exports, "FORGOT_PASSWORD_SUCCESS", () => $12c9c6fef2dc74a9$export$e70701c4dc1893e1);
$parcel$export(module.exports, "FORGOT_PASSWORD_FAILURE", () => $12c9c6fef2dc74a9$export$7e8a762ed2d6f2d2);
$parcel$export(module.exports, "LOGIN_ATTEMPT", () => $12c9c6fef2dc74a9$export$f3ad885eaa1b5f72);
$parcel$export(module.exports, "LOGIN_ATTEMPT_SUCCESS", () => $12c9c6fef2dc74a9$export$716c6a62442b28d7);
$parcel$export(module.exports, "LOGIN_ATTEMPT_FAILURE", () => $12c9c6fef2dc74a9$export$1c3cf2fdaea15601);
$parcel$export(module.exports, "RESET_LOGIN", () => $12c9c6fef2dc74a9$export$afec5a557a208da9);
$parcel$export(module.exports, "EXIT_TEST_MODE_ACTION", () => $12c9c6fef2dc74a9$export$98672ea6f23cc2ca);
$parcel$export(module.exports, "CHANGE_EMAIL_INPUT", () => $12c9c6fef2dc74a9$export$cbb84f780c133cae);
$parcel$export(module.exports, "CA_SSO_TEST_MODE_FAILURE", () => $12c9c6fef2dc74a9$export$82f99ffed31fea50);
$parcel$export(module.exports, "LOGIN_CONSENT_FAILURE", () => $12c9c6fef2dc74a9$export$daf9894dcc19911a);
$parcel$export(module.exports, "fetchLoginSuccess", () => $12c9c6fef2dc74a9$export$edced81742fba4bc);
$parcel$export(module.exports, "fetchLoginFailure", () => $12c9c6fef2dc74a9$export$d8cdd04268f89e8d);
$parcel$export(module.exports, "checkLoginAction", () => $12c9c6fef2dc74a9$export$a4840b835bebc845);
$parcel$export(module.exports, "checkLoginActionSuccess", () => $12c9c6fef2dc74a9$export$80f72fff3f8aebd3);
$parcel$export(module.exports, "checkLoginActionFailure", () => $12c9c6fef2dc74a9$export$ab186d6cbffedaab);
$parcel$export(module.exports, "loginAttempt", () => $12c9c6fef2dc74a9$export$bff2b4217ebde9c3);
$parcel$export(module.exports, "loginAttemptSuccess", () => $12c9c6fef2dc74a9$export$4b4199104faef544);
$parcel$export(module.exports, "loginAttemptFailure", () => $12c9c6fef2dc74a9$export$6df4ba6cdf3cad7f);
$parcel$export(module.exports, "forgotPassword", () => $12c9c6fef2dc74a9$export$66791fb2cfeec3e);
$parcel$export(module.exports, "createPassword", () => $12c9c6fef2dc74a9$export$2effc3102ad6a101);
$parcel$export(module.exports, "createPasswordSuccess", () => $12c9c6fef2dc74a9$export$dc17890d1692fbd);
$parcel$export(module.exports, "forgotPasswordSuccess", () => $12c9c6fef2dc74a9$export$e65d2e9031cf7578);
$parcel$export(module.exports, "resetLogin", () => $12c9c6fef2dc74a9$export$9a31ad345a1aa336);
$parcel$export(module.exports, "exitTestModeAction", () => $12c9c6fef2dc74a9$export$ba564c8e35ce769d);
$parcel$export(module.exports, "changeEmailInput", () => $12c9c6fef2dc74a9$export$c55ade57a8bbcea5);
$parcel$export(module.exports, "caSsoTestModeFailure", () => $12c9c6fef2dc74a9$export$cf9ecdd9f9c734b3);
$parcel$export(module.exports, "loginConsentFailure", () => $12c9c6fef2dc74a9$export$22b3a2f6203607fa);
const $12c9c6fef2dc74a9$export$839deb1eefe4e515 = 'state.ui.login.FETCH_LOGIN_SUCCESS';
const $12c9c6fef2dc74a9$export$8cf8563c2d1c6683 = 'state.ui.login.FETCH_LOGIN_FAILURE';
const $12c9c6fef2dc74a9$export$fe8137105dc1ed9 = 'state.ui.login.CREATE_PASSWORD';
const $12c9c6fef2dc74a9$export$66c73e13cf8b697a = 'state.ui.login.CREATE_PASSWORD_SUCCESS';
const $12c9c6fef2dc74a9$export$816b17d1322118b2 = 'state.ui.login.CHECK_LOGIN_ACTION';
const $12c9c6fef2dc74a9$export$f5cb563064a027ff = 'state.ui.login.CHECK_LOGIN_ACTION_SUCCESS';
const $12c9c6fef2dc74a9$export$150db551ad2bf414 = 'state.ui.login.CHECK_LOGIN_ACTION_FAILURE';
const $12c9c6fef2dc74a9$export$e479859894f5f058 = 'state.ui.login.FORGOT_PASSWORD';
const $12c9c6fef2dc74a9$export$e70701c4dc1893e1 = 'state.ui.login.FORGOT_PASSWORD_SUCCESS';
const $12c9c6fef2dc74a9$export$7e8a762ed2d6f2d2 = 'state.ui.login.FORGOT_PASSWORD_FAILURE';
const $12c9c6fef2dc74a9$export$f3ad885eaa1b5f72 = 'state.ui.login.LOGIN_ATTEMPT';
const $12c9c6fef2dc74a9$export$716c6a62442b28d7 = 'state.ui.login.LOGIN_ATTEMPT_SUCCESS';
const $12c9c6fef2dc74a9$export$1c3cf2fdaea15601 = 'state.ui.login.LOGIN_ATTEMPT_FAILURE';
const $12c9c6fef2dc74a9$export$afec5a557a208da9 = 'state.ui.login.RESET_LOGIN';
const $12c9c6fef2dc74a9$export$98672ea6f23cc2ca = 'state.ui.login.EXIT_TEST_MODE_ACTION';
const $12c9c6fef2dc74a9$export$cbb84f780c133cae = 'state.ui.login.CHANGE_EMAIL_INPUT';
const $12c9c6fef2dc74a9$export$82f99ffed31fea50 = 'state.ui.login.CA_SSO_TEST_MODE_FAILURE';
const $12c9c6fef2dc74a9$export$daf9894dcc19911a = 'state.ui.login.LOGIN_CONSENT_FAILURE';
const $12c9c6fef2dc74a9$export$edced81742fba4bc = (loginModel)=>({
        payload: loginModel,
        type: $12c9c6fef2dc74a9$export$839deb1eefe4e515
    });
const $12c9c6fef2dc74a9$export$d8cdd04268f89e8d = (error)=>({
        type: $12c9c6fef2dc74a9$export$8cf8563c2d1c6683,
        payload: {
            error: error
        }
    });
const $12c9c6fef2dc74a9$export$a4840b835bebc845 = (email, portalId, authData, createAnalyticsEvent)=>({
        type: $12c9c6fef2dc74a9$export$816b17d1322118b2,
        payload: {
            email: email,
            portalId: portalId,
            authData: authData,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $12c9c6fef2dc74a9$export$80f72fff3f8aebd3 = (action, authInfo)=>({
        type: $12c9c6fef2dc74a9$export$f5cb563064a027ff,
        payload: {
            action: action,
            authInfo: authInfo
        }
    });
const $12c9c6fef2dc74a9$export$ab186d6cbffedaab = (error)=>({
        type: $12c9c6fef2dc74a9$export$150db551ad2bf414,
        payload: {
            error: error
        }
    });
const $12c9c6fef2dc74a9$export$bff2b4217ebde9c3 = (payload)=>({
        payload: payload,
        type: $12c9c6fef2dc74a9$export$f3ad885eaa1b5f72
    });
const $12c9c6fef2dc74a9$export$4b4199104faef544 = (loginAttemptResponse)=>({
        type: $12c9c6fef2dc74a9$export$716c6a62442b28d7,
        payload: {
            loginAttemptResponse: loginAttemptResponse
        }
    });
const $12c9c6fef2dc74a9$export$6df4ba6cdf3cad7f = (error)=>({
        type: $12c9c6fef2dc74a9$export$1c3cf2fdaea15601,
        payload: {
            error: error
        }
    });
const $12c9c6fef2dc74a9$export$66791fb2cfeec3e = (resetUrl, email, redirectUrl)=>({
        type: $12c9c6fef2dc74a9$export$e479859894f5f058,
        payload: {
            resetUrl: resetUrl,
            email: email,
            redirectUrl: redirectUrl
        }
    });
const $12c9c6fef2dc74a9$export$2effc3102ad6a101 = (resetUrl, email)=>({
        type: $12c9c6fef2dc74a9$export$fe8137105dc1ed9,
        payload: {
            resetUrl: resetUrl,
            email: email
        }
    });
const $12c9c6fef2dc74a9$export$dc17890d1692fbd = ()=>({
        type: $12c9c6fef2dc74a9$export$66c73e13cf8b697a
    });
const $12c9c6fef2dc74a9$export$e65d2e9031cf7578 = ()=>({
        type: $12c9c6fef2dc74a9$export$e70701c4dc1893e1
    });
const $12c9c6fef2dc74a9$export$c82fc620622643dd = (error)=>({
        type: $12c9c6fef2dc74a9$export$7e8a762ed2d6f2d2,
        payload: {
            error: error
        }
    });
const $12c9c6fef2dc74a9$export$9a31ad345a1aa336 = (email = '')=>({
        type: $12c9c6fef2dc74a9$export$afec5a557a208da9,
        payload: {
            email: email
        }
    });
const $12c9c6fef2dc74a9$export$ba564c8e35ce769d = (email = '')=>({
        type: $12c9c6fef2dc74a9$export$98672ea6f23cc2ca,
        payload: {
            email: email
        }
    });
const $12c9c6fef2dc74a9$export$c55ade57a8bbcea5 = (email)=>({
        type: $12c9c6fef2dc74a9$export$cbb84f780c133cae,
        payload: {
            email: email
        }
    });
const $12c9c6fef2dc74a9$export$cf9ecdd9f9c734b3 = ()=>({
        type: $12c9c6fef2dc74a9$export$82f99ffed31fea50
    });
const $12c9c6fef2dc74a9$export$22b3a2f6203607fa = ()=>({
        type: $12c9c6fef2dc74a9$export$daf9894dcc19911a
    });

});


parcelRegister("g4UBb", function(module, exports) {
$parcel$export(module.exports, "getFirstMessageFromJiraError", () => $72db87bde136c875$export$63b892f0c5ffc91e);
$parcel$export(module.exports, "getJiraErrorOrDefault", () => $72db87bde136c875$export$c3183aaaea823e43);
$parcel$export(module.exports, "getDefaultError", () => $72db87bde136c875$export$7419e04ae130d87b);
$parcel$export(module.exports, "getJiraErrorResponse", () => $72db87bde136c875$export$93579a27d9d34c28);
$parcel$export(module.exports, "genericError", () => $72db87bde136c875$export$28cd364e99d3d2cb);
$parcel$export(module.exports, "getDefaultSignUpError", () => $72db87bde136c875$export$48e9b610f790f75b);
$parcel$export(module.exports, "getDefaultCheckLoginError", () => $72db87bde136c875$export$e35369cd8bc15322);
$parcel$export(module.exports, "isSsoTestModeError", () => $72db87bde136c875$export$ef531073403eb96);
$parcel$export(module.exports, "getUserProfileForgotPasswordFailedError", () => $72db87bde136c875$export$8258d31b06384bf2);

var $2qA3i = parcelRequire("2qA3i");

var $6GNhI = parcelRequire("6GNhI");
const $72db87bde136c875$export$ce1888b50106d3cd = (errorResponse)=>{
    const hasError = errorResponse && errorResponse.errors;
    return hasError ? errorResponse.errors.map((error)=>error && error.errorMessage) : [];
};
const $72db87bde136c875$export$63b892f0c5ffc91e = (errorResponse)=>{
    const errorMessages = $72db87bde136c875$export$ce1888b50106d3cd(errorResponse);
    return errorMessages.length > 0 ? errorMessages[0] : '';
};
const $72db87bde136c875$export$c3183aaaea823e43 = (error)=>{
    const jiraErrorMessage = $72db87bde136c875$export$63b892f0c5ffc91e(error.response);
    if (jiraErrorMessage.length > 0) return {
        errorMessage: jiraErrorMessage
    };
    return $72db87bde136c875$export$7419e04ae130d87b(error);
};
const $72db87bde136c875$export$93579a27d9d34c28 = (error)=>{
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (error.response && error.response.errors) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return error.response;
    return undefined;
};
const $72db87bde136c875$export$7419e04ae130d87b = (error)=>{
    if ($72db87bde136c875$var$isRateLimitedError(error)) return $72db87bde136c875$export$91ba33ab5aae4f04;
    if ($72db87bde136c875$var$isNetworkError(error)) return $72db87bde136c875$export$2b69dc41a4a4ae83();
    return $72db87bde136c875$export$28cd364e99d3d2cb;
};
const $72db87bde136c875$export$48e9b610f790f75b = (error, contactAdminsFormEnabled)=>{
    if ($72db87bde136c875$var$isNetworkError(error)) return $72db87bde136c875$export$2b69dc41a4a4ae83();
    return $72db87bde136c875$export$fb8509ea6df35a83(contactAdminsFormEnabled);
};
const $72db87bde136c875$export$e35369cd8bc15322 = (error)=>{
    const jiraErrorResponse = $72db87bde136c875$export$93579a27d9d34c28(error);
    if (jiraErrorResponse) {
        if ($72db87bde136c875$var$isSignupDomainBlockedError(error)) return $72db87bde136c875$export$7528741a99bb3a62;
        if ($72db87bde136c875$var$isEmailInvalidError(error)) return $72db87bde136c875$export$e97b837fddbca6b3;
    } else if ($72db87bde136c875$var$isNetworkError(error)) return $72db87bde136c875$export$2b69dc41a4a4ae83();
    return $72db87bde136c875$export$28cd364e99d3d2cb;
};
const $72db87bde136c875$export$ef531073403eb96 = (error)=>$72db87bde136c875$export$93579a27d9d34c28(error) && $72db87bde136c875$var$isSsoTestModeFailure(error);
const $72db87bde136c875$export$fb8509ea6df35a83 = (contactAdminsFormEnabled)=>{
    const noContactDescription = (0, $2qA3i.GenericSignUpErrorNoContactLinkDescription);
    const description = contactAdminsFormEnabled ? (0, $2qA3i.GenericSignUpErrorDescriptionUnified) : noContactDescription;
    return {
        description: description,
        title: (0, $2qA3i.GenericErrorTitle),
        action: $72db87bde136c875$var$getGenericErrorFlagActions()
    };
};
const $72db87bde136c875$var$isNetworkError = (errorResponse)=>errorResponse.status === 0;
const $72db87bde136c875$var$isSignupDomainBlockedError = (errorResponse)=>{
    var _errorResponse$respon, _errorResponse$respon2;
    return errorResponse.status === 403 && (((_errorResponse$respon = errorResponse.response) === null || _errorResponse$respon === void 0 ? void 0 : _errorResponse$respon.reasonKey) === 'sd.customer.management.rest.error.customer.account.signup.blocked' || ((_errorResponse$respon2 = errorResponse.response) === null || _errorResponse$respon2 === void 0 ? void 0 : _errorResponse$respon2.reasonKey) === 'customer-signup-domain-blocked');
};
const $72db87bde136c875$var$isEmailInvalidError = (errorResponse)=>{
    var _errorResponse$respon3;
    return errorResponse.status === 400 && ((_errorResponse$respon3 = errorResponse.response) === null || _errorResponse$respon3 === void 0 ? void 0 : _errorResponse$respon3.reasonKey) === 'signup.error.email.valid';
};
const $72db87bde136c875$var$isSsoTestModeFailure = (errorResponse)=>{
    var _errorResponse$respon4;
    return errorResponse.status === 400 && ((_errorResponse$respon4 = errorResponse.response) === null || _errorResponse$respon4 === void 0 ? void 0 : _errorResponse$respon4.reasonKey) === 'CA_SSO_TEST_MODE_NOT_ENABLED';
};
const $72db87bde136c875$var$isRateLimited = (errorResponse)=>errorResponse.status === 429;
const $72db87bde136c875$var$isRateLimitedError = (errorResponse)=>{
    var _errorResponse$respon5;
    return $72db87bde136c875$var$isRateLimited(errorResponse) && ((_errorResponse$respon5 = errorResponse.response) === null || _errorResponse$respon5 === void 0 ? void 0 : _errorResponse$respon5.reasonKey) === 'sd.email.signup.email.rate.limited';
};
const $72db87bde136c875$var$getGenericErrorFlagActions = ()=>({
        href: (0, $6GNhI.location)().href,
        content: (0, $2qA3i.GenericErrorRefreshPageAction)
    });
const $72db87bde136c875$export$2b69dc41a4a4ae83 = ()=>$72db87bde136c875$export$5bd59b549d90b63;
const $72db87bde136c875$export$5bd59b549d90b63 = {
    title: (0, $2qA3i.NoNetworkTitle),
    description: (0, $2qA3i.NoNetworkDescription)
};
const $72db87bde136c875$export$91ba33ab5aae4f04 = {
    title: (0, $2qA3i.GenericErrorTitle),
    description: (0, $2qA3i.SignupEmailResendRateLimitedDescription)
};
const $72db87bde136c875$export$7528741a99bb3a62 = {
    title: (0, $2qA3i.SignupDomainBlockedTitle),
    description: (0, $2qA3i.SignupDomainBlockedDescription)
};
const $72db87bde136c875$export$e97b837fddbca6b3 = {
    title: (0, $2qA3i.InvalidEmailTitle),
    description: (0, $2qA3i.InvalidEmailDescription)
};
const $72db87bde136c875$export$28cd364e99d3d2cb = {
    title: (0, $2qA3i.GenericErrorTitle),
    description: (0, $2qA3i.GenericErrorDescription),
    action: $72db87bde136c875$var$getGenericErrorFlagActions()
};
const $72db87bde136c875$var$genericUserProfileForgotPasswordFailedError = {
    title: (0, $2qA3i.UserProfileForgotPasswordFailedErrorTitle),
    description: (0, $2qA3i.UserProfileForgotPasswordFailedErrorDescription)
};
const $72db87bde136c875$export$3cd8f5c164dad65c = {
    title: (0, $2qA3i.UserProfileForgotPasswordRateLimitedErrorTitle),
    description: (0, $2qA3i.UserProfileForgotPasswordRateLimitedErrorDescription)
};
const $72db87bde136c875$export$8258d31b06384bf2 = (error)=>{
    if ($72db87bde136c875$var$isNetworkError(error)) return $72db87bde136c875$export$2b69dc41a4a4ae83();
    if ($72db87bde136c875$var$isRateLimited(error)) return $72db87bde136c875$export$3cd8f5c164dad65c;
    return $72db87bde136c875$var$genericUserProfileForgotPasswordFailedError;
};

});
parcelRegister("2qA3i", function(module, exports) {
$parcel$export(module.exports, "GenericErrorTitle", () => $2734cf0562c9ceca$export$e882af1f191f98ed);
$parcel$export(module.exports, "GenericErrorDescription", () => $2734cf0562c9ceca$export$435282e749b7e900);
$parcel$export(module.exports, "GenericSignUpErrorDescriptionUnified", () => $2734cf0562c9ceca$export$814e1ad271462eee);
$parcel$export(module.exports, "GenericSignUpErrorNoContactLinkDescription", () => $2734cf0562c9ceca$export$53a250c0a0614ddf);
$parcel$export(module.exports, "RefreshPageLinkText", () => $2734cf0562c9ceca$export$2c865db45566f3fc);
$parcel$export(module.exports, "TellUsAboutIssueLinkText", () => $2734cf0562c9ceca$export$4cd0b637ea791e58);
$parcel$export(module.exports, "LetUsKnowLinkText", () => $2734cf0562c9ceca$export$91b106f2d7a60f86);
$parcel$export(module.exports, "GenericErrorRefreshPageAction", () => $2734cf0562c9ceca$export$20483281c243b1a0);
$parcel$export(module.exports, "NoNetworkTitle", () => $2734cf0562c9ceca$export$b0cc5cbdc11d8431);
$parcel$export(module.exports, "SignupEmailResendRateLimitedDescription", () => $2734cf0562c9ceca$export$fdbfe2d9101e694);
$parcel$export(module.exports, "NoNetworkDescription", () => $2734cf0562c9ceca$export$d349948b740c510b);
$parcel$export(module.exports, "SignupDomainBlockedDescription", () => $2734cf0562c9ceca$export$f1af5cb5b09d8e91);
$parcel$export(module.exports, "SignupDomainBlockedTitle", () => $2734cf0562c9ceca$export$23a02d68ec91feaf);
$parcel$export(module.exports, "InvalidEmailTitle", () => $2734cf0562c9ceca$export$593b1e00f52b5f5e);
$parcel$export(module.exports, "InvalidEmailDescription", () => $2734cf0562c9ceca$export$82cbc81342a448dd);
$parcel$export(module.exports, "UserProfileForgotPasswordFailedErrorTitle", () => $2734cf0562c9ceca$export$6e2b8a076a84e30b);
$parcel$export(module.exports, "UserProfileForgotPasswordFailedErrorDescription", () => $2734cf0562c9ceca$export$eb78dd4efec095b1);
$parcel$export(module.exports, "UserProfileForgotPasswordRateLimitedErrorTitle", () => $2734cf0562c9ceca$export$17669172b666864);
$parcel$export(module.exports, "UserProfileForgotPasswordRateLimitedErrorDescription", () => $2734cf0562c9ceca$export$6daa483c0f823589);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("7NVEF")).default);

var $7NVEF = parcelRequire("7NVEF");

var $jqg2g = parcelRequire("jqg2g");
const $2734cf0562c9ceca$export$e882af1f191f98ed = (0, $jqg2g.default).genericErrorTitle;
const $2734cf0562c9ceca$export$435282e749b7e900 = (0, $jqg2g.default).genericErrorDescription;
const $2734cf0562c9ceca$export$814e1ad271462eee = (0, $jqg2g.default).genericSignUpErrorDescriptionUnified;
const $2734cf0562c9ceca$export$53a250c0a0614ddf = (0, $jqg2g.default).genericSignUpErrorNoContactLinkDescription;
const $2734cf0562c9ceca$export$2c865db45566f3fc = (0, $jqg2g.default).refreshPageLinkText;
const $2734cf0562c9ceca$export$4cd0b637ea791e58 = (0, $jqg2g.default).tellUsAboutIssueLinkText;
const $2734cf0562c9ceca$export$91b106f2d7a60f86 = (0, $jqg2g.default).letUsKnowLinkText;
const $2734cf0562c9ceca$export$20483281c243b1a0 = (0, $jqg2g.default).genericErrorRefreshPageAction;
const $2734cf0562c9ceca$export$b0cc5cbdc11d8431 = (0, $jqg2g.default).noNetworkTitle;
const $2734cf0562c9ceca$export$fdbfe2d9101e694 = (0, $jqg2g.default).signupEmailResendRateLimitedDescription;
const $2734cf0562c9ceca$export$d349948b740c510b = (0, $jqg2g.default).noNetworkDescription;
const $2734cf0562c9ceca$export$f1af5cb5b09d8e91 = (0, $jqg2g.default).blockedDescription;
const $2734cf0562c9ceca$export$23a02d68ec91feaf = (0, $jqg2g.default).blockedTitle;
const $2734cf0562c9ceca$export$593b1e00f52b5f5e = (0, $jqg2g.default).invalidEmailTitle;
const $2734cf0562c9ceca$export$82cbc81342a448dd = (0, $jqg2g.default).invalidEmailDescription;
const $2734cf0562c9ceca$export$6e2b8a076a84e30b = (0, $jqg2g.default).userProfileForgotPasswordFailedFlagTitle;
const $2734cf0562c9ceca$export$eb78dd4efec095b1 = (0, $jqg2g.default).userProfileForgotPasswordFailedFlagDescription;
const $2734cf0562c9ceca$export$17669172b666864 = (0, $jqg2g.default).userProfileForgotPasswordRateLimitedFlagTitle;
const $2734cf0562c9ceca$export$6daa483c0f823589 = (0, $jqg2g.default).userProfileForgotPasswordRateLimitedFlagDescription;

});
parcelRegister("7NVEF", function(module, exports) {
$parcel$export(module.exports, "default", () => $50a8ed201ac5e331$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $6p5HB = parcelRequire("6p5HB");
parcelRequire("fID7x");
var $h7rWn = parcelRequire("h7rWn");

var $fUQHJ = parcelRequire("fUQHJ");
const $50a8ed201ac5e331$var$selector = (0, $ehscL.createSelector)((state)=>(0, $h7rWn.getFlags)(state), (flags)=>({
        flags: flags
    }));
var $50a8ed201ac5e331$export$2e2bcd8739ae039 = (0, $jvoWT.default)($50a8ed201ac5e331$var$selector, {
    dismissFlagAction: (0, $6p5HB.dismissFlag)
})((0, $fUQHJ.default));

});
parcelRegister("ehscL", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $a6588819841e8971$export$595d22ed68ca2841, (v) => $a6588819841e8971$export$595d22ed68ca2841 = v);
var $a6588819841e8971$export$1e511d4a378977f5;
var $a6588819841e8971$export$281bff7f05488aa2;
var $a6588819841e8971$export$5943f4447f6ef248;
var $a6588819841e8971$export$75979cfcd91bf38f;
var $a6588819841e8971$export$595d22ed68ca2841;
'use strict';
$a6588819841e8971$export$1e511d4a378977f5 = true;
$a6588819841e8971$export$281bff7f05488aa2 = $a6588819841e8971$var$defaultMemoize;
$a6588819841e8971$export$5943f4447f6ef248 = $a6588819841e8971$var$createSelectorCreator;
$a6588819841e8971$export$75979cfcd91bf38f = $a6588819841e8971$var$createStructuredSelector;
function $a6588819841e8971$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $a6588819841e8971$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $a6588819841e8971$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a6588819841e8971$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$a6588819841e8971$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $a6588819841e8971$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $a6588819841e8971$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $a6588819841e8971$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $a6588819841e8971$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $a6588819841e8971$var$createSelector = $a6588819841e8971$export$595d22ed68ca2841 = $a6588819841e8971$var$createSelectorCreator($a6588819841e8971$var$defaultMemoize);
function $a6588819841e8971$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a6588819841e8971$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("fID7x", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => (parcelRequire("h7rWn")).getFlags);

var $h7rWn = parcelRequire("h7rWn");

});
parcelRegister("h7rWn", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => $2a3fdbe46996ee78$export$d5815430bcc75df0);
const $2a3fdbe46996ee78$export$d5815430bcc75df0 = (state)=>{
    return state.ui.flags.flags;
};

});


parcelRegister("fUQHJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f6e8c010058ef64$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("lTcni");
var $8pmPj = parcelRequire("8pmPj");
class $3f6e8c010058ef64$export$2e2bcd8739ae039 extends $8P7DW.Component {
    render() {
        const { flags: flags, dismissFlagAction: dismissFlagAction } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement((0, $8pmPj.default), {
            flags: flags,
            dismissFlagAction: dismissFlagAction
        });
    }
}

});
parcelRegister("lTcni", function(module, exports) {
$parcel$export(module.exports, "FlagGroupStateless", () => (parcelRequire("8pmPj")).default);

var $8pmPj = parcelRequire("8pmPj");

});
parcelRegister("8pmPj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebb6c4fcedd98f2c$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $l4a5B = parcelRequire("l4a5B");

var $hse4G = parcelRequire("hse4G");
var $gvxin = parcelRequire("gvxin");

var $4CMbU = parcelRequire("4CMbU");

var $ebnVy = parcelRequire("ebnVy");

var $joUCG = parcelRequire("joUCG");

var $gKWTh = parcelRequire("gKWTh");
const $ebb6c4fcedd98f2c$var$isSuccessFlagAction = (flagAction)=>{
    return 'contentNode' in flagAction && !!flagAction.contentNode;
};
class $ebb6c4fcedd98f2c$export$bf63ac67069f812 extends $8P7DW.Component {
    render() {
        const { flags: flags } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement((0, $gvxin.default), {
            onDismissed: this.handleFlagDismissed
        }, flags.map((flag)=>this.renderFlag(flag)));
    }
    constructor(...args){
        super(...args), this.handleFlagDismissed = (flagId)=>{
            this.props.dismissFlagAction(flagId);
        }, this.i18nFlagActions = (actions)=>{
            const { intl: intl } = this.props;
            return actions.map((action)=>{
                return $ebb6c4fcedd98f2c$var$isSuccessFlagAction(action) ? {
                    content: action.contentNode,
                    href: action === null || action === void 0 ? void 0 : action.href
                } : {
                    content: intl.formatMessage(action.content),
                    href: action.href
                };
            });
        }, this.getIcon = (flag)=>{
            switch(flag.type){
                case 'error':
                    return /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CMbU))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-danger, #BF2600)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'warning':
                    return /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKWTh))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-warning, #FF8B00)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'success':
                    return /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($joUCG))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-success, #36B37E)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'bold':
                    return /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebnVy))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-information, #42526E)",
                        label: "",
                        "aria-hidden": "true"
                    });
                default:
                    return /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CMbU))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-danger, #BF2600)",
                        label: "",
                        "aria-hidden": "true"
                    });
            }
        }, this.renderFlag = (flag)=>{
            const { intl: intl } = this.props;
            if (flag.type === 'bold') {
                const dismissAction = [];
                if (flag.dismissActionValue) dismissAction.push({
                    content: intl.formatMessage(flag.dismissActionValue),
                    onClick: ()=>{
                        this.handleFlagDismissed(flag.id);
                    }
                });
                return /*#__PURE__*/ $8P7DW.createElement((0, $hse4G.default), {
                    appearance: flag.appearance,
                    id: flag.id,
                    key: flag.id,
                    icon: this.getIcon(flag),
                    title: intl.formatMessage(flag.titleMessage, flag.titleMessageValues),
                    description: flag.descriptionMessage === undefined ? undefined : intl.formatMessage(flag.descriptionMessage, flag.descriptionMessageValues),
                    actions: [
                        ...flag.actions,
                        ...dismissAction
                    ]
                });
            }
            return /*#__PURE__*/ $8P7DW.createElement((0, $hse4G.default), {
                id: flag.id,
                key: flag.id,
                icon: this.getIcon(flag),
                title: intl.formatMessage(flag.titleMessage, flag.titleMessageValues),
                description: flag.descriptionMessage === undefined ? undefined : intl.formatMessage(flag.descriptionMessage, flag.descriptionMessageValues),
                actions: this.i18nFlagActions(flag.actions)
            });
        };
    }
}
var $ebb6c4fcedd98f2c$export$2e2bcd8739ae039 = (0, $l4a5B.default)($ebb6c4fcedd98f2c$export$bf63ac67069f812);

});
parcelRegister("hse4G", function(module, exports) {
$parcel$export(module.exports, "default", () => $9db358cf8155454a$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $aeYmt = parcelRequire("aeYmt");

var $5J6r2 = parcelRequire("5J6r2");

var $h5gSD = parcelRequire("h5gSD");

var $gvxin = parcelRequire("gvxin");
const $9db358cf8155454a$var$packageName = undefined;
const $9db358cf8155454a$var$packageVersion = undefined;
const $9db358cf8155454a$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $9db358cf8155454a$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $5J6r2.default), autoDismissSeconds: autoDismissSeconds = $9db358cf8155454a$export$66c3d409977b5615 } = props;
    const autoDismissTimer = (0, $8P7DW.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $gvxin.useFlagGroup)();
    const onDismissed = (0, $8P7DW.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $9db358cf8155454a$var$packageName,
        packageVersion: $9db358cf8155454a$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $8P7DW.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $8P7DW.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $8P7DW.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $8P7DW.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $h5gSD.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $9db358cf8155454a$export$2e2bcd8739ae039 = $9db358cf8155454a$var$AutoDismissFlag;

});
parcelRegister("h5gSD", function(module, exports) {
$parcel$export(module.exports, "default", () => $4afcb4545e008d6d$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v0.37.1 */ /* flag.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $aeYmt = parcelRequire("aeYmt");

var $6NJAV = parcelRequire("6NJAV");

var $5J6r2 = parcelRequire("5J6r2");

var $iqJis = parcelRequire("iqJis");

var $e6Qdr = parcelRequire("e6Qdr");

var $2CGHX = parcelRequire("2CGHX");
var $iPrfN = parcelRequire("iPrfN");
var $6E5P5 = parcelRequire("6E5P5");

var $dojiU = parcelRequire("dojiU");

var $goeKe = parcelRequire("goeKe");

var $fdTHy = parcelRequire("fdTHy");

var $gvxin = parcelRequire("gvxin");

var $184rM = parcelRequire("184rM");
var $91OWl = parcelRequire("91OWl");

var $fTnH3 = parcelRequire("fTnH3");
const $4afcb4545e008d6d$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    flagT26Shape: "_2rko1mok"
};
const $4afcb4545e008d6d$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $4afcb4545e008d6d$var$descriptionStyles = null;
const $4afcb4545e008d6d$var$iconWrapperStyles = null;
const $4afcb4545e008d6d$var$flagWrapperStyles = null;
const $4afcb4545e008d6d$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: undefined,
    packageVersion: undefined
};
const $4afcb4545e008d6d$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ const $4afcb4545e008d6d$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $goeKe.DEFAULT_APPEARANCE), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $5J6r2.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $5J6r2.default), onDismissed: onDismissedProp = (0, $5J6r2.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $8P7DW.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $gvxin.useFlagGroup)();
    const onDismissed = (0, $8P7DW.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $8P7DW.useState)(false);
    const onDismissedAnalytics = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$4afcb4545e008d6d$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $goeKe.DEFAULT_APPEARANCE);
    const toggleExpand = (0, $8P7DW.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $8P7DW.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $8P7DW.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$4afcb4545e008d6d$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$4afcb4545e008d6d$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $fTnH3.flagTextColor)[appearance];
    const iconColor = (0, $fTnH3.flagIconColor)[appearance];
    const iconGlyph = (0, $fTnH3.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $dojiU.default), {
        children: [
            title,
            description
        ]
    }) : undefined;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $8n1kL.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
            padding: "space.200",
            backgroundColor: (0, $fTnH3.flagBackgroundColor)[appearance],
            xcss: (0, $6NJAV.cx)($4afcb4545e008d6d$var$styles.flag, (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $4afcb4545e008d6d$var$styles.flagT26Shape),
            children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            [$4afcb4545e008d6d$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $8n1kL.default)([
                            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                        className: (0, $8n1kL.default)([
                            "_v5641hdc _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6E5P5.default), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $4afcb4545e008d6d$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $184rM.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $91OWl.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                            style: {
                                                color: (0, $fTnH3.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                            className: (0, $8n1kL.default)([
                                                "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fdTHy.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $4afcb4545e008d6d$export$2e2bcd8739ae039 = $4afcb4545e008d6d$var$Flag;

});
parcelRegister("6NJAV", function(module, exports) {
$parcel$export(module.exports, "cx", () => $491eb281ca2453cd$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ parcelRequire("8P7DW");

var $glXuY = parcelRequire("glXuY");
const $491eb281ca2453cd$var$strictApi = (0, $glXuY.createStrictAPI)();
const $491eb281ca2453cd$export$dbf350e5966cf602 = $491eb281ca2453cd$var$strictApi.css;
const $491eb281ca2453cd$export$eb1ecd84a24ee424 = $491eb281ca2453cd$var$strictApi.cssMap;
$491eb281ca2453cd$var$strictApi.cssMap;
const $491eb281ca2453cd$export$a274e22fb40f762e = $491eb281ca2453cd$var$strictApi.cx;
const $491eb281ca2453cd$var$XCSSProp = $491eb281ca2453cd$var$strictApi.XCSSProp;

});
parcelRegister("glXuY", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $be7cc2acb5c618bb$export$39716b4af53f4ad);

var $dIkIm = parcelRequire("dIkIm");

var $82a6z = parcelRequire("82a6z");
function $be7cc2acb5c618bb$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $dIkIm.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $dIkIm.createStrictSetupError)();
        },
        cx: $82a6z.cx,
        XCSSProp () {
            throw (0, $dIkIm.createStrictSetupError)();
        }
    };
}

});
parcelRegister("dIkIm", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $9fbf73e03ab8fbff$export$c4df1cb0c2b4d77c);
const $9fbf73e03ab8fbff$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $9fbf73e03ab8fbff$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("82a6z", function(module, exports) {
$parcel$export(module.exports, "cx", () => $5d965945dc60cfa4$export$a274e22fb40f762e);

var $8n1kL = parcelRequire("8n1kL");
const $5d965945dc60cfa4$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $8n1kL.default)(actualStyles);
};

});



parcelRegister("2CGHX", function(module, exports) {
$parcel$export(module.exports, "default", () => $b93bdfc67b78c01f$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.37.1 */ /* box.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $YDqMU = parcelRequire("YDqMU");
const $b93bdfc67b78c01f$var$baseStyles = null;
const $b93bdfc67b78c01f$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $b93bdfc67b78c01f$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $b93bdfc67b78c01f$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $b93bdfc67b78c01f$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $b93bdfc67b78c01f$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $b93bdfc67b78c01f$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $b93bdfc67b78c01f$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ const $b93bdfc67b78c01f$var$Box = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $8n1kL.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $b93bdfc67b78c01f$var$backgroundColorMap[backgroundColor],
            backgroundColor && $b93bdfc67b78c01f$var$isSurfaceToken(backgroundColor) && $b93bdfc67b78c01f$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $b93bdfc67b78c01f$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $b93bdfc67b78c01f$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $b93bdfc67b78c01f$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $b93bdfc67b78c01f$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $YDqMU.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
var $b93bdfc67b78c01f$export$2e2bcd8739ae039 = $b93bdfc67b78c01f$var$Box;
function $b93bdfc67b78c01f$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $b93bdfc67b78c01f$var$setSurfaceTokenMap;
}

});

parcelRegister("iPrfN", function(module, exports) {
$parcel$export(module.exports, "default", () => $80ad23fb8a8cf940$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.37.1 */ /* inline.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $6NJAV = parcelRequire("6NJAV");

var $3iEm8 = parcelRequire("3iEm8");
const $80ad23fb8a8cf940$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $80ad23fb8a8cf940$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        className: (0, $8n1kL.default)([
            $80ad23fb8a8cf940$var$styles.separator
        ]),
        children: children
    });
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $80ad23fb8a8cf940$var$Inline = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $gWgPx.jsx)($80ad23fb8a8cf940$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $8P7DW.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3iEm8.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $6NJAV.cx)(grow === 'hug' && $80ad23fb8a8cf940$var$styles.hug, grow === 'fill' && $80ad23fb8a8cf940$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$80ad23fb8a8cf940$var$Inline.displayName = 'Inline';
var $80ad23fb8a8cf940$export$2e2bcd8739ae039 = $80ad23fb8a8cf940$var$Inline;

});
parcelRegister("3iEm8", function(module, exports) {
$parcel$export(module.exports, "default", () => $62b6d6489745e6a3$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $62b6d6489745e6a3$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $62b6d6489745e6a3$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $62b6d6489745e6a3$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $62b6d6489745e6a3$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $62b6d6489745e6a3$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $62b6d6489745e6a3$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $62b6d6489745e6a3$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $62b6d6489745e6a3$var$Flex = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $8n1kL.default)([
            $62b6d6489745e6a3$var$styles.root,
            gap && $62b6d6489745e6a3$var$columnGapMap[gap],
            columnGap && $62b6d6489745e6a3$var$columnGapMap[columnGap],
            gap && $62b6d6489745e6a3$var$rowGapMap[gap],
            rowGap && $62b6d6489745e6a3$var$rowGapMap[rowGap],
            alignItems && $62b6d6489745e6a3$var$alignItemsMap[alignItems],
            direction && $62b6d6489745e6a3$var$flexDirectionMap[direction],
            justifyContent && $62b6d6489745e6a3$var$justifyContentMap[justifyContent],
            wrap && $62b6d6489745e6a3$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$62b6d6489745e6a3$var$Flex.displayName = 'Flex';
var $62b6d6489745e6a3$export$2e2bcd8739ae039 = $62b6d6489745e6a3$var$Flex;

});


parcelRegister("6E5P5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc8bbaa7a433937e$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.37.1 */ /* stack.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6NJAV = parcelRequire("6NJAV");

var $3iEm8 = parcelRequire("3iEm8");
const $fc8bbaa7a433937e$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $fc8bbaa7a433937e$var$Stack = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3iEm8.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $6NJAV.cx)(grow === 'hug' && $fc8bbaa7a433937e$var$styles.hug, grow === 'fill' && $fc8bbaa7a433937e$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$fc8bbaa7a433937e$var$Stack.displayName = 'Stack';
var $fc8bbaa7a433937e$export$2e2bcd8739ae039 = $fc8bbaa7a433937e$var$Stack;

});

parcelRegister("goeKe", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_APPEARANCE", () => $ba8af3e7d33ed858$export$d6830277b06edd6);
const $ba8af3e7d33ed858$export$d6830277b06edd6 = 'normal';

});

parcelRegister("fdTHy", function(module, exports) {
$parcel$export(module.exports, "default", () => $635cf73b86e8a364$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $iFxfe = parcelRequire("iFxfe");

var $iPrfN = parcelRequire("iPrfN");

var $goeKe = parcelRequire("goeKe");

var $fTnH3 = parcelRequire("fTnH3");
const $635cf73b86e8a364$var$buttonStyles = null;
const $635cf73b86e8a364$var$fontStyles = null;
const $635cf73b86e8a364$var$appearanceNormalButtonStyles = null;
const $635cf73b86e8a364$var$appearanceNormalActionsContainerStyles = null;
const $635cf73b86e8a364$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $goeKe.DEFAULT_APPEARANCE), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $goeKe.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        className: (0, $8n1kL.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iPrfN.default), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $iFxfe.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $fTnH3.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $fTnH3.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $fTnH3.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $fTnH3.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $8n1kL.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        appearance === (0, $goeKe.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$635cf73b86e8a364$export$2e2bcd8739ae039 = $635cf73b86e8a364$var$FlagActions;

});
parcelRegister("iFxfe", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6b4735f2e9dba50$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $kf6OT = parcelRequire("kf6OT");

var $fK6Kn = parcelRequire("fK6Kn");

var $iF6L5 = parcelRequire("iF6L5");

var $jO3zI = parcelRequire("jO3zI");

var $rc4GA = parcelRequire("rc4GA");

var $29HuL = parcelRequire("29HuL");

var $kmgdt = parcelRequire("kmgdt");
function $b6b4735f2e9dba50$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $b6b4735f2e9dba50$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $b6b4735f2e9dba50$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $rc4GA.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $8P7DW.useState)($b6b4735f2e9dba50$var$initial);
    const onMouseEnter = (0, $8P7DW.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $8P7DW.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $8P7DW.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $8P7DW.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $8P7DW.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $8P7DW.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $kmgdt.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kf6OT))).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $kmgdt.default).Consumer, {
                    mode: mode,
                    state: $b6b4735f2e9dba50$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $iF6L5.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $fK6Kn.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jO3zI.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $29HuL.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$b6b4735f2e9dba50$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $b6b4735f2e9dba50$export$2e2bcd8739ae039 = $b6b4735f2e9dba50$var$CustomThemeButton;

});
parcelRegister("kf6OT", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $6TjO8 = parcelRequire("6TjO8");
module.exports = Object.assign({}, $6TjO8, {
    themed: (propsToValues)=>(props)=>{
            const vals = typeof propsToValues === 'function' ? propsToValues(props) : propsToValues;
            return vals.light;
        }
});
if ($6TjO8.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("6TjO8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "getTheme", () => (parcelRequire("d7d96")).default);
$parcel$export(module.exports, "default", () => (parcelRequire("2Nl4L")).default);
$parcel$export(module.exports, "createTheme", () => (parcelRequire("2NMM2")).createTheme);
/*
   This file will become the new index for theme once the codemod is mature enough.
   For now we're keeping the index file to avoid having to do a major change.
   Once the codemod is done and all the AK modules have been codeshifted, we delete index.js and rename this file to index + update all the imports
*/ 
var $d7d96 = parcelRequire("d7d96");

var $2Nl4L = parcelRequire("2Nl4L");

var $2NMM2 = parcelRequire("2NMM2");

});
parcelRegister("d7d96", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc25f516394356dc$export$2e2bcd8739ae039);

var $jbqt2 = parcelRequire("jbqt2");
function $cc25f516394356dc$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $jbqt2.CHANNEL) in props.theme) return props.theme[0, $jbqt2.CHANNEL];
        else if ('mode' in props.theme && (0, $jbqt2.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $jbqt2.DEFAULT_THEME_MODE)
    };
}

});

parcelRegister("2Nl4L", function(module, exports) {
$parcel$export(module.exports, "default", () => $5adedfc2be1d60cc$export$2e2bcd8739ae039);

var $2NMM2 = parcelRequire("2NMM2");
// Create default global light theme
const $5adedfc2be1d60cc$var$dest = (0, $2NMM2.createTheme)(()=>({
        mode: 'light'
    }));
const $5adedfc2be1d60cc$var$Provider = $5adedfc2be1d60cc$var$dest.Provider;
const $5adedfc2be1d60cc$var$Consumer = $5adedfc2be1d60cc$var$dest.Consumer;
const $5adedfc2be1d60cc$export$7692396083754928 = $5adedfc2be1d60cc$var$dest.useTheme;
const $5adedfc2be1d60cc$var$Theme = {
    Provider: $5adedfc2be1d60cc$var$Provider,
    Consumer: $5adedfc2be1d60cc$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5adedfc2be1d60cc$export$2e2bcd8739ae039 = $5adedfc2be1d60cc$var$Theme;

});
parcelRegister("2NMM2", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $e00a975ee762f533$export$25d302a5b900a763);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
function $e00a975ee762f533$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $8P7DW.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $8P7DW.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
            children: children(tokens)
        });
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $8P7DW.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $8P7DW.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $gWgPx.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});




parcelRegister("jO3zI", function(module, exports) {
$parcel$export(module.exports, "default", () => $47d06dea76d42fc3$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $cjn3r = parcelRequire("cjn3r");
function $47d06dea76d42fc3$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $47d06dea76d42fc3$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
        size: size,
        label: ", Loading",
        appearance: $47d06dea76d42fc3$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("cjn3r", function(module, exports) {
$parcel$export(module.exports, "default", () => $101bbddba097bab4$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $9uKqY = parcelRequire("9uKqY");

var $a4Htr = parcelRequire("a4Htr");
/**
 * Returns the appropriate circle stroke color.
 */ function $101bbddba097bab4$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $101bbddba097bab4$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $101bbddba097bab4$var$loadIn = null;
const $101bbddba097bab4$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $101bbddba097bab4$var$useLayoutEffect = typeof window === 'undefined' ? (0, $8P7DW.useEffect) : (0, $8P7DW.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $101bbddba097bab4$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $a4Htr.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $101bbddba097bab4$var$getStrokeColor(appearance);
    const context = (0, $8P7DW.useContext)((0, $9uKqY.default));
    $101bbddba097bab4$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $8n1kL.default)([
            $101bbddba097bab4$var$styles.wrapperStyles,
            $101bbddba097bab4$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $8n1kL.default)([
                $101bbddba097bab4$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $8n1kL.default)([
                    $101bbddba097bab4$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $101bbddba097bab4$export$2e2bcd8739ae039 = $101bbddba097bab4$var$Spinner;

});
parcelRegister("a4Htr", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $e8833acce176d8c6$export$4e9f1640bbe7a1a8);
const $e8833acce176d8c6$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("rc4GA", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $66cce00bfa89988a$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $66cce00bfa89988a$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("29HuL", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $2a7634950c894e24$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $2a7634950c894e24$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("kmgdt", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf1156a7b1aa58be$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kf6OT = parcelRequire("kf6OT");

var $iD2nj = parcelRequire("iD2nj");
const $cf1156a7b1aa58be$var$Theme = (0, $kf6OT.createTheme)((themeProps)=>({
        buttonStyles: (0, $iD2nj.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cf1156a7b1aa58be$export$2e2bcd8739ae039 = $cf1156a7b1aa58be$var$Theme;

});
parcelRegister("iD2nj", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $5f8d63f20a7b84d2$export$31512de7fa606fa4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9j2sK = parcelRequire("9j2sK");
const $5f8d63f20a7b84d2$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $5f8d63f20a7b84d2$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $9j2sK.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $5f8d63f20a7b84d2$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});



parcelRegister("fTnH3", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $ae65ed222b543dec$export$59e42969c95d314);
$parcel$export(module.exports, "flagIconColor", () => $ae65ed222b543dec$export$7f70afe2167f8235);
$parcel$export(module.exports, "flagIconGlyph", () => $ae65ed222b543dec$export$73f08aee70487cd4);
$parcel$export(module.exports, "flagTextColor", () => $ae65ed222b543dec$export$f50075b2584087f);
$parcel$export(module.exports, "flagTextColorToken", () => $ae65ed222b543dec$export$13b42cd9d596bfe0);
$parcel$export(module.exports, "actionBackgroundColor", () => $ae65ed222b543dec$export$81ba6b63eedb299f);
$parcel$export(module.exports, "actionTextColor", () => $ae65ed222b543dec$export$7bcfe3cca4dd78b6);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $h82Rb = parcelRequire("h82Rb");

var $ebnVy = parcelRequire("ebnVy");

var $joUCG = parcelRequire("joUCG");

var $gKWTh = parcelRequire("gKWTh");
const $ae65ed222b543dec$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
const $ae65ed222b543dec$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};
const $ae65ed222b543dec$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebnVy))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebnVy))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($joUCG))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKWTh))), {
        label: ""
    })
};
const $ae65ed222b543dec$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
const $ae65ed222b543dec$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};
const $ae65ed222b543dec$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
const $ae65ed222b543dec$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});
parcelRegister("h82Rb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c78566573a65da66$var$_react = $c78566573a65da66$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $c78566573a65da66$var$_baseNew = $c78566573a65da66$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $c78566573a65da66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c78566573a65da66$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $c78566573a65da66$var$_react.default.createElement($c78566573a65da66$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$c78566573a65da66$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $c78566573a65da66$var$_default = module.exports.default = $c78566573a65da66$var$StatusErrorIcon;

});

parcelRegister("ebnVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a534a73df7c84099$var$_react = $a534a73df7c84099$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $a534a73df7c84099$var$_baseNew = $a534a73df7c84099$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $a534a73df7c84099$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a534a73df7c84099$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $a534a73df7c84099$var$_react.default.createElement($a534a73df7c84099$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$a534a73df7c84099$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $a534a73df7c84099$var$_default = module.exports.default = $a534a73df7c84099$var$StatusInformationIcon;

});

parcelRegister("joUCG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1fc2e5eef6b3ff1$var$_react = $e1fc2e5eef6b3ff1$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $e1fc2e5eef6b3ff1$var$_baseNew = $e1fc2e5eef6b3ff1$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $e1fc2e5eef6b3ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e1fc2e5eef6b3ff1$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $e1fc2e5eef6b3ff1$var$_react.default.createElement($e1fc2e5eef6b3ff1$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$e1fc2e5eef6b3ff1$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $e1fc2e5eef6b3ff1$var$_default = module.exports.default = $e1fc2e5eef6b3ff1$var$StatusSuccessIcon;

});

parcelRegister("gKWTh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c32e9fa861063b80$var$_react = $c32e9fa861063b80$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $c32e9fa861063b80$var$_baseNew = $c32e9fa861063b80$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $c32e9fa861063b80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c32e9fa861063b80$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $c32e9fa861063b80$var$_react.default.createElement($c32e9fa861063b80$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$c32e9fa861063b80$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $c32e9fa861063b80$var$_default = module.exports.default = $c32e9fa861063b80$var$StatusWarningIcon;

});



parcelRegister("gvxin", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $7b8e7fd1fce90e52$export$e91ea202abb66350);
$parcel$export(module.exports, "default", () => $7b8e7fd1fce90e52$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v0.37.1 */ /* flag-group.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $6NJAV = parcelRequire("6NJAV");

var $5J6r2 = parcelRequire("5J6r2");

var $cBwgz = parcelRequire("cBwgz");
var $buhve = parcelRequire("buhve");
var $31KvO = parcelRequire("31KvO");

var $e6Qdr = parcelRequire("e6Qdr");

var $1NJBM = parcelRequire("1NJBM");

var $2CGHX = parcelRequire("2CGHX");

var $2nrNX = parcelRequire("2nrNX");

var $dojiU = parcelRequire("dojiU");
const $7b8e7fd1fce90e52$export$1eee5ddc4f6d41c5 = 400;
const $7b8e7fd1fce90e52$var$defaultFlagGroupContext = {
    onDismissed: (0, $5J6r2.default),
    isDismissAllowed: false
};
const $7b8e7fd1fce90e52$export$c57ba665aaa722be = /*#__PURE__*/ (0, $8P7DW.createContext)($7b8e7fd1fce90e52$var$defaultFlagGroupContext);
function $7b8e7fd1fce90e52$export$e91ea202abb66350() {
    return (0, $8P7DW.useContext)($7b8e7fd1fce90e52$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $7b8e7fd1fce90e52$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $7b8e7fd1fce90e52$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $7b8e7fd1fce90e52$var$dismissAllowedStyles = null;
const $7b8e7fd1fce90e52$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ const $7b8e7fd1fce90e52$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $5J6r2.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $8P7DW.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $8P7DW.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, $e6Qdr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                xcss: (0, $6NJAV.cx)($7b8e7fd1fce90e52$var$groupStylesNew.root, index === 0 && $7b8e7fd1fce90e52$var$groupStylesNew.first, index === 1 && $7b8e7fd1fce90e52$var$groupStylesNew.second, index >= 2 && $7b8e7fd1fce90e52$var$groupStylesNew.nth, index >= 3 && $7b8e7fd1fce90e52$var$groupStylesNew.hidden),
                "data-vc-oob": true,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $buhve.default), {
                    enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)($7b8e7fd1fce90e52$export$c57ba665aaa722be.Provider, {
                        value: // Only the first flag should be able to be dismissed.
                        isDismissAllowed ? dismissFlagContext : $7b8e7fd1fce90e52$var$defaultFlagGroupContext,
                        children: flag
                    })
                })
            }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $31KvO.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8n1kL.default)([
                            $7b8e7fd1fce90e52$var$groupStyles.root,
                            index === 0 && $7b8e7fd1fce90e52$var$groupStyles.first,
                            index === 1 && $7b8e7fd1fce90e52$var$groupStyles.second,
                            index >= 1 && $7b8e7fd1fce90e52$var$groupStyles.nth,
                            index >= 2 && $7b8e7fd1fce90e52$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)($7b8e7fd1fce90e52$export$c57ba665aaa722be.Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : $7b8e7fd1fce90e52$var$defaultFlagGroupContext,
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const flags = /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $8n1kL.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)(LabelTag, {
                    children: label
                })
            }) : null,
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBwgz.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1NJBM.default), {
        zIndex: (0, $2nrNX.layers).flag(),
        children: flags
    });
};
var $7b8e7fd1fce90e52$export$2e2bcd8739ae039 = $7b8e7fd1fce90e52$var$FlagGroup;

});
parcelRegister("buhve", function(module, exports) {
$parcel$export(module.exports, "default", () => $94a6dc656b96e204$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v0.37.1 */ /* motion.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $jh41u = parcelRequire("jh41u");

var $dwVGB = parcelRequire("dwVGB");

var $cBwgz = parcelRequire("cBwgz");

var $81C2I = parcelRequire("81C2I");
const $94a6dc656b96e204$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw"
};
var $94a6dc656b96e204$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    return Reanimate;
}({});
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ const $94a6dc656b96e204$var$Motion = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation, isPaused: isPaused, onFinish: onFinishMotion, xcss: xcss, testId: testId }, ref)=>{
    const staggered = (0, $81C2I.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $cBwgz.useExitingPersistence)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const [state, setState] = (0, $8P7DW.useState)(appear ? 'entering' : 'idle');
    const reanimateRef = (0, $8P7DW.useRef)();
    const animationRef = (0, $8P7DW.useRef)();
    (0, $8P7DW.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $8P7DW.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === "exit_then_enter") {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = "enter";
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $8P7DW.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle, we don't need to do anything
        if (state === 'idle') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $jh41u.isReducedMotion)() || !exitingAnimation) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && exitingAnimation) {
            const duration = (0, $dwVGB.getDurationMs)((0, $dwVGB.resolveMotionToken)(exitingAnimation));
            animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), duration);
        } else if (state === 'entering' && enteringAnimation) {
            const duration = (0, $dwVGB.getDurationMs)((0, $dwVGB.resolveMotionToken)(enteringAnimation));
            animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), duration + delay);
        }
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        delay,
        paused
    ]);
    (0, $8P7DW.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === "exit_then_enter") setState('exiting');
                else if (value === "enter") setState('entering');
            }
        }));
    const style = {
        animation: state === 'exiting' ? `${exitingAnimation} forwards ${paused ? 'paused' : ''}` : state === 'entering' ? `${enteringAnimation} backwards ${paused ? 'paused' : ''}` : undefined
    };
    if (delay) style.animationDelay = `${delay}ms`;
    const hasAnimationStyles = state !== 'idle';
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $8n1kL.default)([
            hasAnimationStyles && $94a6dc656b96e204$var$styles.base,
            xcss
        ]),
        ref: staggered.ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: hasAnimationStyles ? style : undefined,
        "data-testid": testId,
        children: children
    });
});
var $94a6dc656b96e204$export$2e2bcd8739ae039 = $94a6dc656b96e204$var$Motion;

});
parcelRegister("dwVGB", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $ac692ea6068f0923$export$d0038b6e47881463);
$parcel$export(module.exports, "resolveMotionToken", () => $ac692ea6068f0923$export$82b92541889a035d);

var $lCTyY = parcelRequire("lCTyY");
const $ac692ea6068f0923$export$d0038b6e47881463 = (animation)=>{
    const match = animation.trim().match(/^(-?\d*\.?\d+)(ms|s)\b/);
    if (!match) return 0;
    const value = parseFloat(match[1]);
    const unit = match[2];
    return unit === 's' ? value * 1000 : value;
};
const $ac692ea6068f0923$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        const documentElement = (_getDocument = (0, $lCTyY.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});


parcelRegister("31KvO", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d1cbdd9512cc948$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $eWrxM = parcelRequire("eWrxM");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ const $6d1cbdd9512cc948$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eWrxM.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $6d1cbdd9512cc948$export$2e2bcd8739ae039 = $6d1cbdd9512cc948$var$SlideIn;

});


parcelRegister("184rM", function(module, exports) {
$parcel$export(module.exports, "default", () => $349d07923336d05f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $lRscM = parcelRequire("lRscM");

var $cDQfx = parcelRequire("cDQfx");

var $2aUM6 = parcelRequire("2aUM6");

var $b9hQ0 = parcelRequire("b9hQ0");

var $fTnH3 = parcelRequire("fTnH3");
const $349d07923336d05f$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0)));
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($2aUM6))) : (0, (/*@__PURE__*/$parcel$interopDefault($cDQfx)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lRscM.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)(ButtonIcon, {
                ...iconProps,
                size: "small",
                label: "",
                color: (0, $fTnH3.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $349d07923336d05f$var$DismissButton = /*#__PURE__*/ (0, $8P7DW.memo)($349d07923336d05f$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$349d07923336d05f$export$2e2bcd8739ae039 = $349d07923336d05f$var$DismissButton;

});
parcelRegister("lRscM", function(module, exports) {
$parcel$export(module.exports, "default", () => $2675cfd41febcde1$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $klxUK = parcelRequire("klxUK");

var $ea6bZ = parcelRequire("ea6bZ");

var $dojiU = parcelRequire("dojiU");

var $jiIHo = parcelRequire("jiIHo");

var $6ZVn7 = parcelRequire("6ZVn7");

var $ko9LV = parcelRequire("ko9LV");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $2675cfd41febcde1$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jiIHo.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6ZVn7.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ko9LV.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ea6bZ.default), {
        content: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) ?? label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $jiIHo.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    var _triggerProps$onClick;
                    onClick === null || onClick === void 0 || onClick(e, analyticsEvent);
                    (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
                },
                onMouseOver: (e)=>{
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: (e)=>{
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: (e)=>{
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: (e)=>{
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: (e)=>{
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: (e)=>{
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                ref: (0, $klxUK.default)([
                    ref,
                    triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6ZVn7.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ko9LV.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$2675cfd41febcde1$var$IconButton.displayName = 'IconButton';
var $2675cfd41febcde1$export$2e2bcd8739ae039 = $2675cfd41febcde1$var$IconButton;

});
parcelRegister("klxUK", function(module, exports) {
$parcel$export(module.exports, "default", () => $7739f3e337989779$export$2e2bcd8739ae039);
function $7739f3e337989779$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("jiIHo", function(module, exports) {
$parcel$export(module.exports, "default", () => $247517c310a1878e$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.37.1 */ /* button-base.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $6NJAV = parcelRequire("6NJAV");

var $klxUK = parcelRequire("klxUK");

var $d4WRD = parcelRequire("d4WRD");

var $fnhqr = parcelRequire("fnhqr");

var $e6Qdr = parcelRequire("e6Qdr");

var $bgvtM = parcelRequire("bgvtM");

var $dojiU = parcelRequire("dojiU");

var $feh23 = parcelRequire("feh23");

var $3adkF = parcelRequire("3adkF");

var $kc0Sq = parcelRequire("kc0Sq");

var $fyZkm = parcelRequire("fyZkm");
const $247517c310a1878e$var$LOADING_LABEL = ', Loading';
const $247517c310a1878e$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhkby5v _irr3by5v _1di6by5v",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const $247517c310a1878e$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $247517c310a1878e$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $247517c310a1878e$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $247517c310a1878e$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $247517c310a1878e$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $247517c310a1878e$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $247517c310a1878e$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $247517c310a1878e$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    const localRef = (0, $8P7DW.useRef)(null);
    const splitButtonContext = (0, $3adkF.useSplitButtonContext)();
    const loadingLabelId = (0, $fnhqr.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    const isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    const spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    const isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $d4WRD.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bgvtM.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $klxUK.default)([
            localRef,
            ref
        ]),
        xcss: (0, $6NJAV.cx)($247517c310a1878e$var$styles.base, (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $247517c310a1878e$var$styles.baseT26Shape, appearance === 'default' && $247517c310a1878e$var$defaultStyles.root, appearance === 'default' && isInteractive && $247517c310a1878e$var$defaultStyles.interactive, appearance === 'primary' && $247517c310a1878e$var$primaryStyles.root, appearance === 'primary' && isInteractive && $247517c310a1878e$var$primaryStyles.interactive, appearance === 'warning' && $247517c310a1878e$var$warningStyles.root, appearance === 'warning' && isInteractive && $247517c310a1878e$var$warningStyles.interactive, appearance === 'danger' && $247517c310a1878e$var$dangerStyles.root, appearance === 'danger' && isInteractive && $247517c310a1878e$var$dangerStyles.interactive, appearance === 'discovery' && $247517c310a1878e$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $247517c310a1878e$var$discoveryStyles.interactive, appearance === 'subtle' && $247517c310a1878e$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $247517c310a1878e$var$subtleStyles.interactive, $247517c310a1878e$var$styles.linkDecorationUnset, isSelected && $247517c310a1878e$var$selectedStyles.root, isSelected && isSplitButton && $247517c310a1878e$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $247517c310a1878e$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $247517c310a1878e$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $247517c310a1878e$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $247517c310a1878e$var$selectedStyles.discovery, isDisabled && $247517c310a1878e$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $247517c310a1878e$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $247517c310a1878e$var$defaultStyles.disabled, isCircle && !isSplitButton && $247517c310a1878e$var$styles.circle, spacing === 'compact' && $247517c310a1878e$var$styles.spacingCompact, spacing === 'compact' && (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $247517c310a1878e$var$styles.spacingCompactT26Shape, shouldFitContainer && $247517c310a1878e$var$styles.fullWidth, hasIconBefore && $247517c310a1878e$var$styles.buttonIconBefore, hasIconAfter && $247517c310a1878e$var$styles.buttonIconAfter, isIconButton && $247517c310a1878e$var$styles.iconButton, isIconButton && spacing === 'compact' && $247517c310a1878e$var$styles.iconButtonCompact, isLoading && $247517c310a1878e$var$styles.loading, isSplitButton && $247517c310a1878e$var$styles.splitButton, isNavigationSplitButton && $247517c310a1878e$var$styles.navigationSplitButton),
        isDisabled: (0, $e6Qdr.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled,
        ...(0, $e6Qdr.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-live': 'polite'
        },
        ...isLoading && (0, $e6Qdr.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$247517c310a1878e$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $kc0Sq.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $feh23.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                    className: (0, $8n1kL.default)([
                        $247517c310a1878e$var$styles.loadingOverlay
                    ]),
                    children: (0, $fyZkm.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                    id: loadingLabelId,
                    children: $247517c310a1878e$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $247517c310a1878e$export$2e2bcd8739ae039 = $247517c310a1878e$var$ButtonBase;

});
parcelRegister("bgvtM", function(module, exports) {
$parcel$export(module.exports, "default", () => $60dea9da9b9ddbe7$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.37.1 */ /* pressable.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $82a6z = parcelRequire("82a6z");

var $aeYmt = parcelRequire("aeYmt");

var $5JgbU = parcelRequire("5JgbU");

var $5J6r2 = parcelRequire("5J6r2");

var $9uKqY = parcelRequire("9uKqY");

var $h5g2M = parcelRequire("h5g2M");
const $60dea9da9b9ddbe7$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $60dea9da9b9ddbe7$var$Pressable = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $5J6r2.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $8P7DW.useContext)((0, $9uKqY.default));
    const handleClick = (0, $8P7DW.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $h5g2M.default), {
        // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
        as: "button",
        // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $5JgbU.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $82a6z.cx)($60dea9da9b9ddbe7$var$styles.root, isDisabled && $60dea9da9b9ddbe7$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});
var $60dea9da9b9ddbe7$export$2e2bcd8739ae039 = $60dea9da9b9ddbe7$var$Pressable;

});
parcelRegister("5JgbU", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $af1cf83b67e20661$export$95df08bae54cb4df);
function $af1cf83b67e20661$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        const ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("h5g2M", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d4c7bf84f386b2a$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $9d4c7bf84f386b2a$var$focusRingStyles = null;
const $9d4c7bf84f386b2a$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ const $9d4c7bf84f386b2a$var$Focusable = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $8n1kL.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $9d4c7bf84f386b2a$export$2e2bcd8739ae039 = $9d4c7bf84f386b2a$var$Focusable;

});


parcelRegister("feh23", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $68087d9cc15efa94$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $8P7DW = parcelRequire("8P7DW");
const $68087d9cc15efa94$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);

});

parcelRegister("3adkF", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $bbd8fd86b51f1527$export$47e2c6fdb142d947);

var $8P7DW = parcelRequire("8P7DW");

var $feh23 = parcelRequire("feh23");
const $bbd8fd86b51f1527$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $8P7DW.useContext)((0, $feh23.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("kc0Sq", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2f8031141192c11$export$2e2bcd8739ae039);
function $d2f8031141192c11$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $d2f8031141192c11$var$tabKeyCode = 9;
function $d2f8031141192c11$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $d2f8031141192c11$var$tabKeyCode) return;
    $d2f8031141192c11$var$abort(event);
}
function $d2f8031141192c11$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $d2f8031141192c11$var$abort,
        onMouseUpCapture: $d2f8031141192c11$var$abort,
        onKeyDownCapture: $d2f8031141192c11$var$onKey,
        onKeyUpCapture: $d2f8031141192c11$var$onKey,
        onTouchStartCapture: $d2f8031141192c11$var$abort,
        onTouchEndCapture: $d2f8031141192c11$var$abort,
        onPointerDownCapture: $d2f8031141192c11$var$abort,
        onPointerUpCapture: $d2f8031141192c11$var$abort,
        onClickCapture: $d2f8031141192c11$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $d2f8031141192c11$var$abort
    } : events;
}

});

parcelRegister("fyZkm", function(module, exports) {
$parcel$export(module.exports, "default", () => $b247ba4882124e77$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $cjn3r = parcelRequire("cjn3r");
function $b247ba4882124e77$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $b247ba4882124e77$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $b247ba4882124e77$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
        size: $b247ba4882124e77$var$getIconSpacing(spacing),
        appearance: $b247ba4882124e77$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("6ZVn7", function(module, exports) {
$parcel$export(module.exports, "default", () => $c542923f3f62f8ff$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");
parcelRequire("8P7DW");
const $c542923f3f62f8ff$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $c542923f3f62f8ff$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        className: (0, $8n1kL.default)([
            $c542923f3f62f8ff$var$styles.common,
            type === 'text' && $c542923f3f62f8ff$var$styles.text,
            type === 'icon' && $c542923f3f62f8ff$var$styles.icon,
            isLoading && $c542923f3f62f8ff$var$styles.fade
        ]),
        children: children
    });
};
var $c542923f3f62f8ff$export$2e2bcd8739ae039 = $c542923f3f62f8ff$var$Content;

});

parcelRegister("ko9LV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c51aa8985618e6d8$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");
function $c51aa8985618e6d8$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $c51aa8985618e6d8$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $c51aa8985618e6d8$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $e6Qdr.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $gWgPx.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $c51aa8985618e6d8$export$2e2bcd8739ae039 = $c51aa8985618e6d8$var$IconRenderer;

});


parcelRegister("2aUM6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19588e3ded91542a$var$_react = $19588e3ded91542a$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $19588e3ded91542a$var$_baseNew = $19588e3ded91542a$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $19588e3ded91542a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $19588e3ded91542a$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $19588e3ded91542a$var$_react.default.createElement($19588e3ded91542a$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$19588e3ded91542a$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $19588e3ded91542a$var$_default = module.exports.default = $19588e3ded91542a$var$ChevronUpIcon;

});

parcelRegister("b9hQ0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81de5f2a2af2fa56$var$_react = $81de5f2a2af2fa56$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $81de5f2a2af2fa56$var$_baseNew = $81de5f2a2af2fa56$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $81de5f2a2af2fa56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81de5f2a2af2fa56$var$CrossIcon = (props)=>/*#__PURE__*/ $81de5f2a2af2fa56$var$_react.default.createElement($81de5f2a2af2fa56$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$81de5f2a2af2fa56$var$CrossIcon.displayName = 'CrossIcon';
var $81de5f2a2af2fa56$var$_default = module.exports.default = $81de5f2a2af2fa56$var$CrossIcon;

});


parcelRegister("91OWl", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2b6e35020061060$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $cBwgz = parcelRequire("cBwgz");
var $bT4U6 = parcelRequire("bT4U6");

var $2CGHX = parcelRequire("2CGHX");
var $6E5P5 = parcelRequire("6E5P5");
const $a2b6e35020061060$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $a2b6e35020061060$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        xcss: $a2b6e35020061060$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBwgz.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bT4U6.default), {
                children: (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                        xcss: $a2b6e35020061060$var$styles.container,
                        ...props,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6E5P5.default), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a2b6e35020061060$export$2e2bcd8739ae039 = $a2b6e35020061060$var$Expander;

});



parcelRegister("4CMbU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35e017c96a1e97ad$var$_react = $35e017c96a1e97ad$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $35e017c96a1e97ad$var$_baseNew = $35e017c96a1e97ad$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $35e017c96a1e97ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35e017c96a1e97ad$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $35e017c96a1e97ad$var$_react.default.createElement($35e017c96a1e97ad$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$35e017c96a1e97ad$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $35e017c96a1e97ad$var$_default = module.exports.default = $35e017c96a1e97ad$var$CrossCircleIcon;

});





parcelRegister("jqg2g", function(module, exports) {
$parcel$export(module.exports, "default", () => $7028266d21c84e70$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $7028266d21c84e70$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    genericErrorTitle: {
        id: 'cv.generic.error.title',
        defaultMessage: 'Error',
        description: 'Title of the error panel shown when a generic error has occurred.'
    },
    genericErrorDescription: {
        id: 'cv.generic.error.description',
        defaultMessage: "We couldn't submit your request. Refresh the page and try again.",
        description: 'Message body of the error panel shown when a generic error has occurred.'
    },
    genericSignUpErrorDescriptionUnified: {
        id: 'cv.generic.sign.up.error.description.unified',
        defaultMessage: "We couldn't submit your request. Refresh the page and try again. If you continue to experience issues, {contactAdminLinkUnified}.",
        description: 'Message body of the error panel shown when a generic error has occurred when a customer is signing up.'
    },
    genericSignUpErrorNoContactLinkDescription: {
        id: 'cv.generic.sign.up.error.no.contact.link.description.unified',
        defaultMessage: "We couldn\u2019t submit your request. Refresh the page and try again.",
        description: 'Message body of the error panel shown when a generic error has occurred when a customer is signing up.'
    },
    refreshPageLinkText: {
        id: 'cv.generic.refresh.page.link.text',
        defaultMessage: 'refresh',
        description: 'Text shown for a refresh the page link.'
    },
    tellUsAboutIssueLinkText: {
        id: 'cv.generic.tell.about.issue.link.text',
        defaultMessage: 'tell us about this issue',
        description: 'Text shown for the tell us about this issue link, used to report errors.'
    },
    letUsKnowLinkText: {
        id: 'cv.generic.let.us.know.link.text',
        defaultMessage: 'let us know',
        description: 'Text shown for the let us know link, used to report errors.'
    },
    genericErrorRefreshPageAction: {
        id: 'cv.generic.error.refresh.page.action',
        defaultMessage: 'Refresh page',
        description: 'Label of the refresh page button on the error panel shown when a generic error has occurred.'
    },
    noNetworkTitle: {
        id: 'cv.no.network.title',
        defaultMessage: 'Check your connection',
        description: 'Title of the error panel shown when a network connection problem prevents an action from being performed.'
    },
    noNetworkDescription: {
        id: 'cv.no.network.description.unified',
        defaultMessage: "It looks like you've lost your internet connection. Check your network and try again later.",
        description: 'Message body of the error panel shown when a network connection problem prevents an action from being performed.'
    },
    signupEmailResendRateLimitedDescription: {
        defaultMessage: "There\u2019s an issue with sending the email at the moment. Try again later in 10 minutes",
        description: 'Message to notify the user that the sign up email has been rate limited',
        id: 'cv.sign.up.email.resend.rate.limited.description'
    },
    blockedTitle: {
        id: 'cv.signup.blocked.title',
        defaultMessage: 'Access Blocked',
        description: 'Title of the error panel shown when a blocked action occurs.'
    },
    blockedDescription: {
        id: 'cv.signup.blocked.description',
        defaultMessage: "The email isn't approved for access. Use another email and try again.",
        description: 'Message body of the error panel  shown when a blocked action occurs.'
    },
    invalidEmailTitle: {
        id: 'cv.signup.email.invalid.title',
        defaultMessage: 'Invalid Email',
        description: 'Title of the error panel shown when a invalid email is entered.'
    },
    invalidEmailDescription: {
        id: 'cv.signup.email.invalid.description',
        defaultMessage: 'You must specify a valid email address.',
        description: 'Message body of the error panel shown when a invalid email is entered.'
    },
    userProfileForgotPasswordFailedFlagTitle: {
        id: 'cv.user.profile.forgot.password.failed.flag.title',
        defaultMessage: "We're unable to send a link",
        description: 'Title for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordFailedFlagDescription: {
        id: 'cv.user.profile.forgot.password.failed.flag.description',
        defaultMessage: 'Something went wrong while trying to send you a reset password link. Try again.',
        description: 'Description for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordRateLimitedFlagTitle: {
        id: 'cv.user.profile.forgot.password.rate_limited.flag.title',
        defaultMessage: "We're unable to send a link",
        description: 'Title for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordRateLimitedFlagDescription: {
        id: 'cv.user.profile.forgot.password.rate_limited.flag.description',
        defaultMessage: 'Something went wrong while trying to send you a reset password link. Try again in a few minutes.',
        description: 'Description for the error flag shown when system fails to send email after user clicks on forgot password link'
    }
});

});




parcelRegister("20NcP", function(module, exports) {
$parcel$export(module.exports, "fetchCrossSiteArticleEpic", () => $2f4d82e0a8fedd7f$export$d67800395c791e52);

var $fSYYZ = parcelRequire("fSYYZ");

var $llKFQ = parcelRequire("llKFQ");
parcelRequire("gExuy");
var $4W5Ru = parcelRequire("4W5Ru");

var $fzPxB = parcelRequire("fzPxB");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");
const $2f4d82e0a8fedd7f$export$3361e9be8093ddcc = (response, articleId)=>{
    const parseAri = (0, $fzPxB.ConfluenceSpaceAri).parse(response.space.id);
    return {
        id: parseInt(articleId, 10),
        title: response.title,
        url: '',
        projects: response.projects.map((project)=>({
                projectId: parseInt(project.projectId, 10),
                portalId: parseInt(project.portalId, 10),
                projectAri: project.projectAri
            })),
        space: {
            key: response.space.key,
            id: parseInt(parseAri.spaceId, 10)
        },
        idInString: articleId,
        hostname: response.hostname
    };
};
const $2f4d82e0a8fedd7f$export$d67800395c791e52 = (action$)=>action$.ofType((0, $4W5Ru.FETCH_CROSS_SITE_ARTICLE)).mergeMap((action)=>{
        const { meta: meta, articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId } = action.payload;
        return (0, $llKFQ.fetchCrossSiteArticles)({
            articleId: articleId,
            projectId: projectId,
            crossSiteTenantId: crossSiteTenantId || ''
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent);
            const articleResponse = $2f4d82e0a8fedd7f$export$3361e9be8093ddcc(response, articleId);
            return (0, $4W5Ru.fetchArticleSuccess)(articleResponse);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $fonw6.isNetworkOrClientErrorCode)(error.status)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $4W5Ru.fetchArticleFailure)(articleId, error));
        });
    });

});
parcelRegister("llKFQ", function(module, exports) {
$parcel$export(module.exports, "fetchCrossSiteArticles", () => $a5e6f9d9ecacea0f$export$5cbd1a869c9b635a);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $jByYr = parcelRequire("jByYr");

var $h1yZX = parcelRequire("h1yZX");

var $4A0hH = parcelRequire("4A0hH");
var $b4JpE = parcelRequire("b4JpE");

var $9ypa9 = parcelRequire("9ypa9");

var $6t9NN = parcelRequire("6t9NN");
const $a5e6f9d9ecacea0f$export$5cbd1a869c9b635a = ({ articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId })=>{
    const cloudId = (0, $jByYr.getMeta)('tenant-id') || '';
    const activationId = (0, $jByYr.getMeta)('activation-id');
    const pageAri = (0, $4A0hH.ConfluencePageAri).create({
        siteId: crossSiteTenantId,
        pageId: articleId
    }).toString();
    const projectAri = projectId && (0, $b4JpE.JiraProjectAri).create({
        projectId: projectId.toString(),
        siteId: cloudId
    }).toString();
    const queryStringV2 = $h1yZX.stringify({
        projectAri: projectAri,
        articleAri: pageAri
    });
    const uri = `${(0, $6t9NN.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/jsm-portal/article-metadata?${queryStringV2}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        (0, $9ypa9.trackError)('categories.fetch.all.failed', {}, e);
        return (0, $fSYYZ.Observable).throw(e);
    });
};

});
parcelRegister("4A0hH", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAri", () => $355abeb05d1f8c01$export$3f931dd15d96caff);

var $cFYzQ = parcelRequire("cFYzQ");

var $jmrxw = parcelRequire("jmrxw");

var $6LWYQ = parcelRequire("6LWYQ");
// src/confluence/page/manifest.ts
var $355abeb05d1f8c01$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $cFYzQ.ConfluencePageAriResourceOwner),
    resourceType: (0, $cFYzQ.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $355abeb05d1f8c01$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $jmrxw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $355abeb05d1f8c01$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $355abeb05d1f8c01$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $355abeb05d1f8c01$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $355abeb05d1f8c01$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6LWYQ.AriParser).fromOpts(derivedOpts, $355abeb05d1f8c01$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6LWYQ.AriParser).fromString(maybeAri, $355abeb05d1f8c01$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("cFYzQ", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAriResourceOwner", () => $93a84dc0b718a957$export$da53e4f7db4c6a71);
$parcel$export(module.exports, "ConfluencePageAriResourceType", () => $93a84dc0b718a957$export$636fc622562a2c5b);
// src/confluence/page/types.ts
var $93a84dc0b718a957$export$da53e4f7db4c6a71 = "confluence", $93a84dc0b718a957$export$636fc622562a2c5b = "page";

});


parcelRegister("b4JpE", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAri", () => $81034b72dc67886d$export$75a0a0a7cb0a58ae);

var $3dCjm = parcelRequire("3dCjm");

var $jmrxw = parcelRequire("jmrxw");

var $6LWYQ = parcelRequire("6LWYQ");
// src/jira/project/manifest.ts
var $81034b72dc67886d$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $3dCjm.JiraProjectAriResourceOwner),
    resourceType: (0, $3dCjm.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $81034b72dc67886d$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $jmrxw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $81034b72dc67886d$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $81034b72dc67886d$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $81034b72dc67886d$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $81034b72dc67886d$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $6LWYQ.AriParser).fromOpts(derivedOpts, $81034b72dc67886d$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6LWYQ.AriParser).fromString(maybeAri, $81034b72dc67886d$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("3dCjm", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $25804dcf8eb81624$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $25804dcf8eb81624$export$736763838d3aa22e);
// src/jira/project/types.ts
var $25804dcf8eb81624$export$99d538a3b04916b1 = "jira", $25804dcf8eb81624$export$736763838d3aa22e = "project";

});


parcelRegister("6t9NN", function(module, exports) {
$parcel$export(module.exports, "APOLLO_STARGATE_CONTEXT_ROOT", () => $86b41b0a5b299c3e$export$f224912d4ec4705e);
const $86b41b0a5b299c3e$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';

});


parcelRegister("gExuy", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLE", () => (parcelRequire("4W5Ru")).FETCH_ARTICLE);
$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => (parcelRequire("4W5Ru")).FETCH_ARTICLE_FAILURE);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY", () => (parcelRequire("4W5Ru")).FETCH_ARTICLE_SPACE_KEY);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY_FAILURE", () => (parcelRequire("4W5Ru")).FETCH_ARTICLE_SPACE_KEY_FAILURE);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY_SUCCESS", () => (parcelRequire("4W5Ru")).FETCH_ARTICLE_SPACE_KEY_SUCCESS);
$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => (parcelRequire("4W5Ru")).FETCH_ARTICLE_SUCCESS);
$parcel$export(module.exports, "FETCH_CROSS_SITE_ARTICLE", () => (parcelRequire("4W5Ru")).FETCH_CROSS_SITE_ARTICLE);
$parcel$export(module.exports, "fetchArticle", () => (parcelRequire("4W5Ru")).fetchArticle);
$parcel$export(module.exports, "fetchArticleFailure", () => (parcelRequire("4W5Ru")).fetchArticleFailure);
$parcel$export(module.exports, "fetchArticleSpaceKey", () => (parcelRequire("4W5Ru")).fetchArticleSpaceKey);
$parcel$export(module.exports, "fetchArticleSpaceKeyFailure", () => (parcelRequire("4W5Ru")).fetchArticleSpaceKeyFailure);
$parcel$export(module.exports, "fetchArticleSpaceKeySuccess", () => (parcelRequire("4W5Ru")).fetchArticleSpaceKeySuccess);
$parcel$export(module.exports, "fetchArticleSuccess", () => (parcelRequire("4W5Ru")).fetchArticleSuccess);
$parcel$export(module.exports, "fetchCrossSiteArticle", () => (parcelRequire("4W5Ru")).fetchCrossSiteArticle);
parcelRequire("4W5Ru");

});
parcelRegister("4W5Ru", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLE", () => $7ae7498ca4a59f55$export$a55f0530be417648);
$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => $7ae7498ca4a59f55$export$2d213dcac7fc3339);
$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => $7ae7498ca4a59f55$export$862d1fc538bf047c);
$parcel$export(module.exports, "FETCH_CROSS_SITE_ARTICLE", () => $7ae7498ca4a59f55$export$ffd65713f8cf7ee0);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY", () => $7ae7498ca4a59f55$export$5ad5cd897e4bf515);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY_SUCCESS", () => $7ae7498ca4a59f55$export$3b80ee6a6cfa1792);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY_FAILURE", () => $7ae7498ca4a59f55$export$4ce7256daebadb2e);
$parcel$export(module.exports, "fetchArticle", () => $7ae7498ca4a59f55$export$b455945318d7989e);
$parcel$export(module.exports, "fetchCrossSiteArticle", () => $7ae7498ca4a59f55$export$9b8d6025673edc75);
$parcel$export(module.exports, "fetchArticleSuccess", () => $7ae7498ca4a59f55$export$6910c63a4b3017af);
$parcel$export(module.exports, "fetchArticleFailure", () => $7ae7498ca4a59f55$export$b135c19fc249d3ab);
$parcel$export(module.exports, "fetchArticleSpaceKey", () => $7ae7498ca4a59f55$export$1bb14e9adb3b68ac);
$parcel$export(module.exports, "fetchArticleSpaceKeySuccess", () => $7ae7498ca4a59f55$export$e5aa07ff7178b780);
$parcel$export(module.exports, "fetchArticleSpaceKeyFailure", () => $7ae7498ca4a59f55$export$5fc693c79f10bc4f);

var $cWsyg = parcelRequire("cWsyg");
const $7ae7498ca4a59f55$export$a55f0530be417648 = 'epic.model.FETCH_ARTICLE';
const $7ae7498ca4a59f55$export$2d213dcac7fc3339 = 'state.persisted.article.FETCH_ARTICLE_SUCCESS';
const $7ae7498ca4a59f55$export$862d1fc538bf047c = 'state.persisted.article.FETCH_ARTICLE_FAILURE';
const $7ae7498ca4a59f55$export$ffd65713f8cf7ee0 = 'epic.model.FETCH_CROSS_SITE_ARTICLE';
const $7ae7498ca4a59f55$export$5ad5cd897e4bf515 = 'epic.model.FETCH_ARTICLE_SPACE_KEY';
const $7ae7498ca4a59f55$export$3b80ee6a6cfa1792 = 'state.persisted.article.FETCH_ARTICLE_SPACE_KEY_SUCCESS';
const $7ae7498ca4a59f55$export$4ce7256daebadb2e = 'state.persisted.article.FETCH_ARTICLE_SPACE_KEY_FAILURE';
const $7ae7498ca4a59f55$export$b455945318d7989e = (payload, meta)=>({
        meta: meta,
        ...(0, $cWsyg.buildModelsActionCreator)($7ae7498ca4a59f55$export$a55f0530be417648, 'kbPage')(payload)
    });
const $7ae7498ca4a59f55$export$9b8d6025673edc75 = (params)=>{
    const { meta: meta, articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId } = params;
    return {
        type: $7ae7498ca4a59f55$export$ffd65713f8cf7ee0,
        payload: {
            articleId: articleId,
            projectId: projectId,
            crossSiteTenantId: crossSiteTenantId,
            meta: meta
        }
    };
};
const $7ae7498ca4a59f55$export$6910c63a4b3017af = (article)=>({
        type: $7ae7498ca4a59f55$export$2d213dcac7fc3339,
        payload: article
    });
const $7ae7498ca4a59f55$export$b135c19fc249d3ab = (id, error)=>({
        type: $7ae7498ca4a59f55$export$862d1fc538bf047c,
        payload: {
            id: id,
            error: error
        }
    });
const $7ae7498ca4a59f55$export$1bb14e9adb3b68ac = (articleId, meta)=>({
        meta: meta,
        type: $7ae7498ca4a59f55$export$5ad5cd897e4bf515,
        payload: {
            articleId: articleId
        }
    });
const $7ae7498ca4a59f55$export$e5aa07ff7178b780 = (article)=>({
        type: $7ae7498ca4a59f55$export$3b80ee6a6cfa1792,
        payload: article
    });
const $7ae7498ca4a59f55$export$5fc693c79f10bc4f = (id, error)=>({
        type: $7ae7498ca4a59f55$export$4ce7256daebadb2e,
        payload: {
            id: id,
            error: error
        }
    });

});


parcelRegister("fzPxB", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSpaceAri", () => $b5721ae20201c817$export$4e1bd9257e1b7213);

var $2t4FG = parcelRequire("2t4FG");

var $jmrxw = parcelRequire("jmrxw");

var $6LWYQ = parcelRequire("6LWYQ");
// src/confluence/space/manifest.ts
var $b5721ae20201c817$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $2t4FG.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $2t4FG.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $b5721ae20201c817$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $jmrxw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b5721ae20201c817$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $b5721ae20201c817$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b5721ae20201c817$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $b5721ae20201c817$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $6LWYQ.AriParser).fromOpts(derivedOpts, $b5721ae20201c817$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6LWYQ.AriParser).fromString(maybeAri, $b5721ae20201c817$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
};

});
parcelRegister("2t4FG", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSpaceAriResourceOwner", () => $1cc1e9d0336f2baf$export$204c4c730af505ce);
$parcel$export(module.exports, "ConfluenceSpaceAriResourceType", () => $1cc1e9d0336f2baf$export$7c78a678ea7a8ac7);
// src/confluence/space/types.ts
var $1cc1e9d0336f2baf$export$204c4c730af505ce = "confluence", $1cc1e9d0336f2baf$export$7c78a678ea7a8ac7 = "space";

});


parcelRegister("fonw6", function(module, exports) {
$parcel$export(module.exports, "isNetworkErrorCode", () => $a4e6c984133d6a21$export$1a5a4674dd906e7e);
$parcel$export(module.exports, "isClientErrorCode", () => $a4e6c984133d6a21$export$d31fd506ce75fa65);
$parcel$export(module.exports, "isNetworkOrClientErrorCode", () => $a4e6c984133d6a21$export$53ee51427129200c);
const $a4e6c984133d6a21$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $a4e6c984133d6a21$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $a4e6c984133d6a21$export$53ee51427129200c = (statusCode)=>$a4e6c984133d6a21$export$1a5a4674dd906e7e(statusCode) || $a4e6c984133d6a21$export$d31fd506ce75fa65(statusCode);

});


parcelRegister("4TajJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e056ba95d7254e44$export$2e2bcd8739ae039);
parcelRequire("durY1");
var $fPmNS = parcelRequire("fPmNS");

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("l6lPJ");
var $2ccck = parcelRequire("2ccck");

var $9Vr59 = parcelRequire("9Vr59");
const $e056ba95d7254e44$export$21d16fd7fed1f163 = (action$)=>{
    return action$.filter((action)=>// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        action.type.startsWith('epic.model') && action.type !== (0, $9Vr59.FETCH_HELP_CENTER_BRANDING_MODEL)).switchMap(()=>(0, $jTCFd.default)({
            type: 'xsrfToken',
            params: {}
        }))// jsd-customer-portal-models-without-backbone
    // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    .filter((response)=>!!response && (!!response.xsrfToken || !!response.env.xsrfToken))// jsd-customer-portal-models-without-backbone
    // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    .map((response)=>(0, $2ccck.updateXsrfAction)(response.xsrfToken || response.env.xsrfToken)).catch((_)=>(0, $fSYYZ.Observable).never());
};
var $e056ba95d7254e44$export$2e2bcd8739ae039 = (0, $fPmNS.combineEpics)($e056ba95d7254e44$export$21d16fd7fed1f163);

});
parcelRegister("jTCFd", function(module, exports) {
$parcel$export(module.exports, "default", () => $af78f48811f3a365$export$2e2bcd8739ae039);

var $jfZfM = parcelRequire("jfZfM");
function $af78f48811f3a365$export$2e2bcd8739ae039(request, options) {
    return (0, $jfZfM.fetchModel)(request, options);
}

});
parcelRegister("jfZfM", function(module, exports) {
$parcel$export(module.exports, "fetchModel", () => $e9ec6d354fd0643d$export$6146dff2e008af3d);

var $fSYYZ = parcelRequire("fSYYZ");

var $jByYr = parcelRequire("jByYr");

var $1We2B = parcelRequire("1We2B");

var $7RnGA = parcelRequire("7RnGA");

var $gKxW2 = parcelRequire("gKxW2");

var $1EFS8 = parcelRequire("1EFS8");

var $jjE9o = parcelRequire("jjE9o");

var $aIQ9W = parcelRequire("aIQ9W");

var $7FSs7 = parcelRequire("7FSs7");
const $e9ec6d354fd0643d$var$createBatchOperationalPayload = (modelType, batchingType)=>{
    return {
        action: batchingType,
        actionSubject: 'model-batched',
        source: 'unknownSource',
        attributes: {
            modelType: modelType
        }
    };
};
const $e9ec6d354fd0643d$var$mergeOrReplaceOptions = (obj1, obj2, modelType)=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    if (!obj1 || obj1.id !== obj2.id) {
        (0, $jjE9o.operationalEvent)($e9ec6d354fd0643d$var$createBatchOperationalPayload(modelType, 'model-replaced'));
        return obj2;
    }
    return (0, $1We2B.mergeWith)(obj1, obj2, (value, srcValue, key)=>{
        if (key === 'expand' && value) {
            (0, $jjE9o.operationalEvent)($e9ec6d354fd0643d$var$createBatchOperationalPayload(modelType, 'model-merged'));
            // We merge expand arrays if it is from the same type and they have the same id.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            return (0, $1We2B.uniq)(srcValue.concat(value));
        }
        return undefined;
    });
};
function $e9ec6d354fd0643d$var$fetchModels(requests) {
    const requestTypes = (0, $1We2B.uniq)(requests.map((request)=>request.type));
    // This will build up the request params. If the request type is the same and the id is different it will
    // replace the type params, else it will merge them together.
    // If it finds two expand arrays to merge together it will concat them together and ensure only unique values.
    const requestOptions = requests.reduce((obj, request)=>Object.keys(request.params || {}).length ? {
            ...obj,
            [request.type]: $e9ec6d354fd0643d$var$mergeOrReplaceOptions(obj[request.type], request.params, request.type)
        } : obj, {});
    const modelContext = {
        helpCenterAri: (0, $jByYr.getHelpCenterAri)(),
        clientBasePath: (0, $7FSs7.getBasePath)()
    };
    return (0, $7RnGA.requestModels)(requestTypes, requestOptions, modelContext).toPromise();
}
/**
 * A TS limitation results in this losing its arg type.
 * See: https://github.com/Microsoft/TypeScript/issues/29638
 *
 * As a work around we create another wrapping function and re-type it.
 */ const $e9ec6d354fd0643d$var$secondaryBatchedFetchModels = (0, $aIQ9W.default)($e9ec6d354fd0643d$var$fetchModels, 0);
const $e9ec6d354fd0643d$var$primaryBatchedFetchModels = (0, $aIQ9W.default)($e9ec6d354fd0643d$var$fetchModels, 0);
function $e9ec6d354fd0643d$export$6146dff2e008af3d(request, { type: type, disableBatching: disableBatching } = {
    type: 'primary',
    disableBatching: false
}) {
    const modelContext = {
        helpCenterAri: (0, $jByYr.getHelpCenterAri)(),
        clientBasePath: (0, $7FSs7.getBasePath)()
    };
    if ((0, $gKxW2.ModelsCache).getInstance().shouldCache(request.type)) {
        const cachedData = (0, $gKxW2.ModelsCache).getInstance().getFromCache(request);
        if (cachedData !== undefined) return (0, $fSYYZ.Observable).from(Promise.resolve(cachedData.response));
    }
    if (disableBatching) {
        const options = {
            [request.type]: request.params
        };
        return (0, $7RnGA.requestModels)([
            request.type
        ], options, modelContext);
    }
    const promise = type === 'secondary' ? $e9ec6d354fd0643d$var$secondaryBatchedFetchModels(request).then((successResult)=>$e9ec6d354fd0643d$export$8d0b7c1ef062bcaa(request, successResult)) : $e9ec6d354fd0643d$var$primaryBatchedFetchModels(request).then((successResult)=>$e9ec6d354fd0643d$export$8d0b7c1ef062bcaa(request, successResult));
    return (0, $fSYYZ.Observable).from(promise);
}
function $e9ec6d354fd0643d$export$8d0b7c1ef062bcaa(request, modelsResponse) {
    const requestType = request.type;
    if ((0, $gKxW2.ModelsCache).getInstance().shouldCache(requestType)) {
        if ((0, $1EFS8.default).checkGate('model_cache_save_full_response')) (0, $gKxW2.ModelsCache).getInstance().putToCache(request, modelsResponse);
        else (0, $gKxW2.ModelsCache).getInstance().putToCache(request, {
            [requestType]: modelsResponse[requestType]
        });
    }
    return modelsResponse;
}

});
parcelRegister("7RnGA", function(module, exports) {
$parcel$export(module.exports, "requestModels", () => $81e880068f30b501$export$be054e1f3ca89815);

var $breWd = parcelRequire("breWd");

var $jW99n = parcelRequire("jW99n");

var $fMDgb = parcelRequire("fMDgb");

var $fSYYZ = parcelRequire("fSYYZ");

var $HGACo = parcelRequire("HGACo");

var $1We2B = parcelRequire("1We2B");

var $3PjqI = parcelRequire("3PjqI");

var $1EFS8 = parcelRequire("1EFS8");

var $jjE9o = parcelRequire("jjE9o");

var $7FSs7 = parcelRequire("7FSs7");
const $81e880068f30b501$var$retryableStatusCodes = [
    429,
    500,
    502,
    503
];
const $81e880068f30b501$var$isRetryableStatusCode = (status)=>$81e880068f30b501$var$retryableStatusCodes.includes(status);
const $81e880068f30b501$var$MAX_RETRY_DELAY_MS = 30000;
const $81e880068f30b501$var$BASE_DELAY_MS = 10000;
const $81e880068f30b501$var$maxExpBackoffWithJitter = (retries, baseDelay, maxDelay)=>{
    const exponential = Math.pow(2, retries) * baseDelay;
    return Math.min(exponential, maxDelay) + Math.floor(Math.random() * 1000);
};
const $81e880068f30b501$var$NUMBER_OF_RETRIES = 2;
const $81e880068f30b501$var$createOperationalEvent = (models, numberOfRetries, success, status)=>{
    return {
        action: 'fetch',
        actionSubject: 'models',
        source: 'unknownSource',
        attributes: {
            models: models,
            numberOfRetries: numberOfRetries,
            success: success,
            status: status
        }
    };
};
const $81e880068f30b501$var$optionsNotAvailableInRestEndpoint = [
    'availableLanguages',
    'forgotPassword',
    'organisations',
    'portalsAndRequestTypes',
    'profileWebFragments',
    'sharedPortal',
    'timezones',
    'timezoneRegions',
    'xsrfToken',
    'portalsAndStatuses'
];
const $81e880068f30b501$var$setTimezoneMetaTag = (timezone)=>{
    const windowDocument = (0, $jW99n.default).getDataRef();
    if (!timezone || !windowDocument) return;
    let metaTimezone = (0, $jW99n.default).querySelector('meta[name="user-timezone"]');
    if (metaTimezone) metaTimezone.setAttribute('content', timezone === null || timezone === void 0 ? void 0 : timezone.id);
    else {
        metaTimezone = windowDocument.createElement('meta');
        metaTimezone.setAttribute('name', 'user-timezone');
        metaTimezone.setAttribute('content', timezone === null || timezone === void 0 ? void 0 : timezone.id);
        windowDocument.head.appendChild(metaTimezone);
    }
};
const $81e880068f30b501$var$addExtraImplicitDataRequirements = (types, options)=>{
    var _requestOptions$porta;
    const requestTypes = types.concat([]);
    // We want to clone child objects as well so we don't accidentally mutate them.
    // Not having it previously caused downstream actions to no longer have params after we deleted some propeties.
    const requestOptions = (0, $1We2B.cloneDeep)(options);
    if (requestTypes.includes('portal') && !requestTypes.includes('branding') && requestOptions.portal) {
        requestTypes.push('branding');
        requestOptions.branding = {
            id: requestOptions.portal.id
        };
    }
    // Implicitly add 'kbs' in portals requestOptions if fetchPortal is requested. // ref src/view/help-center/help-center-content/single-portal/index.tsx:15, projectId & isKbEnabled is considered to be present together
    if ((0, $1EFS8.default).checkGate('fetch_kbs_with_fetchportal_in_request_details') && requestTypes.includes('portal') && !((_requestOptions$porta = requestOptions.portal) !== null && _requestOptions$porta !== void 0 && (_requestOptions$porta = _requestOptions$porta.expand) !== null && _requestOptions$porta !== void 0 && _requestOptions$porta.includes('kbs'))) {
        var _requestOptions$porta2;
        (_requestOptions$porta2 = requestOptions.portal) === null || _requestOptions$porta2 === void 0 || (_requestOptions$porta2 = _requestOptions$porta2.expand) === null || _requestOptions$porta2 === void 0 || _requestOptions$porta2.push('kbs');
    }
    // Implicitly fetch portal if portalWebFragments defined portalId.
    if (requestTypes.includes('portalWebFragments') && requestOptions.portalWebFragments && requestOptions.portalWebFragments.portalId && !requestTypes.includes('portal')) {
        if ((0, $HGACo.isRemoveRedundantModelsCreateRequest)() && requestOptions.portalWebFragments.portalPage === (0, $fMDgb.REQUEST_CREATE)) requestOptions.portal = {
            id: requestOptions.portalWebFragments.portalId
        };
        else {
            requestTypes.push('portal');
            requestOptions.portal = {
                id: requestOptions.portalWebFragments.portalId
            };
        }
    }
    // Implicitly fetch request create if portalWebFragments defined portalId and requestTypeId.
    if (requestTypes.includes('portalWebFragments') && requestOptions.portalWebFragments && requestOptions.portalWebFragments.requestTypeId && requestOptions.portalWebFragments.portalPage === (0, $fMDgb.REQUEST_CREATE) && !requestTypes.includes('reqCreate')) {
        if ((0, $HGACo.isRemoveRedundantModelsCreateRequest)()) requestOptions.reqCreate = {
            portalId: requestOptions.portalWebFragments.portalId,
            id: requestOptions.portalWebFragments.requestTypeId
        };
        else {
            requestTypes.push('reqCreate');
            requestOptions.reqCreate = {
                portalId: requestOptions.portalWebFragments.portalId,
                id: requestOptions.portalWebFragments.requestTypeId
            };
        }
    }
    if (requestTypes.includes('portal') && requestOptions.portal) requestOptions.portalId = requestOptions.portal.id;
    return {
        requestTypes: requestTypes,
        requestOptions: requestOptions
    };
};
const $81e880068f30b501$var$adjustRequestOptions = (options)=>{
    const requestOptions = {
        ...options
    };
    for(const key in requestOptions){
        if (requestOptions.hasOwnProperty(key)) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        {
            if (requestOptions[key].portalId) // The backend needs this as a blanket rule.
            // If we run into any we add it onto the request options object.
            // Last one wins.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            requestOptions.portalId = requestOptions[key].portalId;
        }
    }
    for(const key in requestOptions)if ($81e880068f30b501$var$optionsNotAvailableInRestEndpoint.includes(key)) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    delete requestOptions[key];
    return requestOptions;
};
const $81e880068f30b501$var$getTraceId = (err)=>{
    let traceId = '';
    try {
        const { xhr: xhr } = err;
        traceId = xhr.getResponseHeader('Atl-Traceid') || '';
    } catch (e) {
        // oxlint-disable-next-line no-console
        console.warn('Failed to get traceId from error', e);
    }
    return traceId;
};
const $81e880068f30b501$var$getAllResponseHeaders = (err)=>{
    let headers = '';
    try {
        const { xhr: xhr } = err;
        headers = xhr.getAllResponseHeaders();
    } catch (e) {
        // oxlint-disable-next-line no-console
        console.warn('Failed to get headers from error', e);
    }
    return headers;
};
const $81e880068f30b501$export$a06581639cf24e1e = (modelsDescriptor, options, modelContext, context = (0, $7FSs7.contextPath))=>{
    const { requestOptions: requestOptions, requestTypes: requestTypes } = $81e880068f30b501$var$addExtraImplicitDataRequirements(modelsDescriptor, options);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(`${context}/rest/servicedesk/1/customer/models`, {
        options: $81e880068f30b501$var$adjustRequestOptions(requestOptions),
        models: requestTypes,
        context: modelContext
    }, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((response)=>response.response).catch((err)=>{
        const traceId = $81e880068f30b501$var$getTraceId(err);
        const responseHeaders = $81e880068f30b501$var$getAllResponseHeaders(err);
        return (0, $fSYYZ.Observable).throw(err.response ? {
            traceId: traceId,
            responseHeaders: responseHeaders,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            status: err.response.status,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            errorMessages: err.response.errorMessages,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            nextActionUrl: err.response.nextActionUrl,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            nextActionDisplayText: err.response.nextActionDisplayText
        } : {
            traceId: traceId,
            responseHeaders: responseHeaders,
            status: err.status,
            errorMessages: []
        });
    });
};
const $81e880068f30b501$var$requestModelsWithRetries = (modelsDescriptor, options, modelContext, context = (0, $7FSs7.contextPath))=>{
    const { requestOptions: requestOptions, requestTypes: requestTypes } = $81e880068f30b501$var$addExtraImplicitDataRequirements(modelsDescriptor, options);
    let retries = 0;
    return (0, $breWd.post)(`${context}/rest/servicedesk/1/customer/models`, {
        options: $81e880068f30b501$var$adjustRequestOptions(requestOptions),
        models: requestTypes,
        context: modelContext
    }, {
        'Content-Type': 'application/json'
    }).pipe((0, $3PjqI.retryWhen)((errors)=>errors.mergeMap((errorValue)=>{
            retries += 1;
            const status = errorValue.status;
            if (!$81e880068f30b501$var$isRetryableStatusCode(status) || retries > $81e880068f30b501$var$NUMBER_OF_RETRIES) return (0, $fSYYZ.Observable).throw(errorValue);
            return (0, $fSYYZ.Observable).of(errorValue).delay($81e880068f30b501$var$maxExpBackoffWithJitter(retries, $81e880068f30b501$var$BASE_DELAY_MS, $81e880068f30b501$var$MAX_RETRY_DELAY_MS));
        })), (0, $3PjqI.map)((response)=>{
        if (retries > 0) //only send event if there were retries to avoid sending too many events
        (0, $jjE9o.operationalEvent)($81e880068f30b501$var$createOperationalEvent(requestTypes, retries, true, undefined));
        //Update timezone meta tag when model response has user properties
        if (response.response) {
            var _modelResponse$user;
            const modelResponse = response.response;
            if (modelResponse !== null && modelResponse !== void 0 && (_modelResponse$user = modelResponse.user) !== null && _modelResponse$user !== void 0 && _modelResponse$user.timezone) {
                var _modelResponse$user2;
                $81e880068f30b501$var$setTimezoneMetaTag(modelResponse === null || modelResponse === void 0 || (_modelResponse$user2 = modelResponse.user) === null || _modelResponse$user2 === void 0 ? void 0 : _modelResponse$user2.timezone);
            }
        }
        return response.response;
    }), (0, $3PjqI.catchError)((err)=>{
        (0, $jjE9o.operationalEvent)($81e880068f30b501$var$createOperationalEvent(requestTypes, retries, false, err.status));
        const traceId = $81e880068f30b501$var$getTraceId(err);
        const responseHeaders = $81e880068f30b501$var$getAllResponseHeaders(err);
        return new (0, $fSYYZ.Observable)((observer)=>{
            observer.error(err.response ? {
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: err.response.status,
                errorMessages: err.response.errorMessages,
                nextActionUrl: err.response.nextActionUrl,
                nextActionDisplayText: err.response.nextActionDisplayText
            } : {
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: err.status,
                errorMessages: []
            });
        });
    }));
};
const $81e880068f30b501$export$be054e1f3ca89815 = (modelsDescriptor, options, modelContext, context = (0, $7FSs7.contextPath))=>{
    if ((0, $HGACo.isRetryMechanismTuningEnabled)()) return $81e880068f30b501$var$requestModelsWithRetries(modelsDescriptor, options, modelContext, context);
    return $81e880068f30b501$export$a06581639cf24e1e(modelsDescriptor, options, modelContext, context);
};

});
parcelRegister("fMDgb", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER", () => $3b6482fe80d11e93$export$8e46b442a40fd146);
$parcel$export(module.exports, "PORTAL_HOME", () => $3b6482fe80d11e93$export$e7639abf9d430473);
$parcel$export(module.exports, "REQUEST_CREATE", () => $3b6482fe80d11e93$export$722b80b55a1414f);
$parcel$export(module.exports, "REQUEST_DETAILS", () => $3b6482fe80d11e93$export$9e5185d6a2a60dc);
$parcel$export(module.exports, "REQUEST_LIST", () => $3b6482fe80d11e93$export$805e3047ef7cb33e);
$parcel$export(module.exports, "PROFILE", () => $3b6482fe80d11e93$export$91c3232a793620f2);
$parcel$export(module.exports, "PROFILE_PANEL", () => $3b6482fe80d11e93$export$b87ce3f352c7af33);
$parcel$export(module.exports, "REQUEST_CREATE_PANEL", () => $3b6482fe80d11e93$export$fcdaac8f3aa2d02e);
$parcel$export(module.exports, "HEADER", () => $3b6482fe80d11e93$export$526a1e214ba17198);
$parcel$export(module.exports, "SUB_HEADER", () => $3b6482fe80d11e93$export$9e49b02bf8c4161f);
$parcel$export(module.exports, "FOOTER", () => $3b6482fe80d11e93$export$d8d929c77d921e7d);
$parcel$export(module.exports, "DETAILS", () => $3b6482fe80d11e93$export$e094c4db500be584);
$parcel$export(module.exports, "DETAILS_SIDE_SECTION", () => $3b6482fe80d11e93$export$6c81f8b23c0dd1d2);
$parcel$export(module.exports, "ConnectFragment", () => $3b6482fe80d11e93$export$aa8ab018415f92e4);

var $8P7DW = parcelRequire("8P7DW");

var $iziiq = parcelRequire("iziiq");

var $cqt5Z = parcelRequire("cqt5Z");

var $kPehY = parcelRequire("kPehY");

var $8ECIG = parcelRequire("8ECIG");
const $3b6482fe80d11e93$export$8e46b442a40fd146 = 'HELP_CENTER';
const $3b6482fe80d11e93$export$e7639abf9d430473 = 'PORTAL';
const $3b6482fe80d11e93$export$722b80b55a1414f = 'CREATE_REQUEST';
const $3b6482fe80d11e93$export$9e5185d6a2a60dc = 'VIEW_REQUEST';
const $3b6482fe80d11e93$export$805e3047ef7cb33e = 'MY_REQUESTS';
const $3b6482fe80d11e93$export$91c3232a793620f2 = 'PROFILE';
const $3b6482fe80d11e93$export$b87ce3f352c7af33 = 'profilePagePanel';
const $3b6482fe80d11e93$export$fcdaac8f3aa2d02e = 'requestCreatePanel';
const $3b6482fe80d11e93$export$526a1e214ba17198 = 'headerPanels';
const $3b6482fe80d11e93$export$9e49b02bf8c4161f = 'subheaderPanels';
const $3b6482fe80d11e93$export$d8d929c77d921e7d = 'footerPanels';
const $3b6482fe80d11e93$export$e094c4db500be584 = 'detailsPanels';
const $3b6482fe80d11e93$export$6c81f8b23c0dd1d2 = 'optionPanels';
class $3b6482fe80d11e93$export$aa8ab018415f92e4 extends $8P7DW.Component {
    componentDidMount() {
        const { fetchConnectFragments: fetchConnectFragments, page: page, connectFragments: connectFragments, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = this.props;
        if (!connectFragments) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            requestKey: requestKey,
            portalPage: page
        });
        else this.fireConnectFragmentAnalytics();
        this.fireShowConnectBlockedAppsBanner();
    }
    componentDidUpdate(prevProps) {
        const { fetchConnectFragments: fetchConnectFragments, connectFragments: connectFragments, page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = this.props;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId || prevProps.portalId !== portalId;
        if (requestTypeUpdated) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            requestKey: requestKey,
            portalPage: page
        });
        if (!prevProps.connectFragments && connectFragments) this.fireConnectFragmentAnalytics();
        else if (prevProps.connectFragments && connectFragments) {
            const previouslyErrored = 'error' in prevProps.connectFragments;
            const currentlyErrored = 'error' in connectFragments;
            if (previouslyErrored !== currentlyErrored) this.fireConnectFragmentAnalytics();
        }
        if (prevProps.projectId !== this.props.projectId) this.fireShowConnectBlockedAppsBanner();
    }
    render() {
        const { connectFragments: connectFragments, className: className, location: location } = this.props;
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        return /*#__PURE__*/ $8P7DW.createElement((0, $8ECIG.default), {
            location: location,
            className: className,
            connectFragments: connectFragments
        });
    }
    constructor(...args){
        super(...args), this.fireShowConnectBlockedAppsBanner = ()=>{
            const { page: page, projectId: projectId } = this.props;
            if ((0, $kPehY.isConnectBlockedAppsRelevantPage)(page)) {
                this.props.resetBannerState(page);
                if (projectId) (0, $kPehY.fetchIsAnyConnectAppBlocked)({
                    projectId: projectId,
                    page: page
                }).then((isBlocked)=>{
                    if (isBlocked) this.props.showBanner(page);
                }).catch(()=>{
                // The error is already logged in the fetchIsAnyConnectAppBlocked function
                });
            }
        }, this.fireConnectFragmentAnalytics = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, connectFragments: connectFragments, location: location, portalId: portalId, requestTypeId: requestTypeId } = this.props;
            if (!createAnalyticsEvent || !connectFragments) return;
            const isError = 'error' in connectFragments;
            if (!isError && connectFragments.length === 0) return;
            const uniqueAppKeys = !isError ? (0, $cqt5Z.getUniqueAppKeysFromConnectFragments)(connectFragments) : [];
            const analyticsEvent = createAnalyticsEvent({
                portalId: portalId,
                requestTypeId: requestTypeId,
                location: location,
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                action: isError ? 'failed' : 'loaded',
                appKeys: uniqueAppKeys
            });
            analyticsEvent.fire();
        };
    }
}

});
parcelRegister("kPehY", function(module, exports) {
$parcel$export(module.exports, "isConnectBlockedAppsRelevantPage", () => $10b740ef37c277c7$export$aa2542e596000b48);
$parcel$export(module.exports, "fetchIsAnyConnectAppBlocked", () => $10b740ef37c277c7$export$40f1d90131a12a2);

var $breWd = parcelRequire("breWd");

var $9ypa9 = parcelRequire("9ypa9");

var $7FSs7 = parcelRequire("7FSs7");
const $10b740ef37c277c7$var$perProjectRequestCache = new Map();
const $10b740ef37c277c7$export$aa2542e596000b48 = (page)=>{
    const relevantConnectPages = [
        'PORTAL',
        'CREATE_REQUEST',
        'VIEW_REQUEST'
    ];
    return relevantConnectPages.includes(page);
};
const $10b740ef37c277c7$export$40f1d90131a12a2 = (context)=>{
    const uri = `${(0, $7FSs7.contextPath)}/rest/atlassian-connect/latest/addon-access`;
    const body = {
        context: context
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    const cacheKey = context.projectId.toString();
    let cachedRequest = $10b740ef37c277c7$var$perProjectRequestCache.get(cacheKey);
    if (!cachedRequest) {
        cachedRequest = (0, $breWd.post)(uri, body, headers).map(({ response: response })=>response.isAnyAppBlocked).catch((e)=>{
            (0, $9ypa9.trackError)('connect.blocked-apps.fetch.failed', {}, e);
            return Promise.reject(e);
        }).toPromise();
        $10b740ef37c277c7$var$perProjectRequestCache.set(cacheKey, cachedRequest);
    }
    return cachedRequest;
};

});

parcelRegister("8ECIG", function(module, exports) {
$parcel$export(module.exports, "default", () => $acfe36ef65e7772b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $aTaR3 = parcelRequire("aTaR3");
const $acfe36ef65e7772b$var$ConnectFragmentsDumb = ({ connectFragments: connectFragments, className: className, location: location })=>{
    if (!connectFragments || 'error' in connectFragments) return null;
    if (connectFragments.length) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    /*#__PURE__*/ $8P7DW.createElement($acfe36ef65e7772b$var$Root, {
        className: className
    }, connectFragments.map((fragment)=>/*#__PURE__*/ $8P7DW.createElement((0, $aTaR3.default), {
            key: fragment.key,
            fullKey: fragment.key,
            location: location,
            fragmentHtml: fragment.html
        }))));
    return null;
};
var $acfe36ef65e7772b$export$2e2bcd8739ae039 = $acfe36ef65e7772b$var$ConnectFragmentsDumb;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $acfe36ef65e7772b$var$Root = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-19x1uwk-0"
})`margin-top:${"var(--ds-space-400, 32px)"};`;

});
parcelRegister("2UsNA", function(module, exports) {
$parcel$export(module.exports, "css", () => $aed32489ab9daed0$export$dbf350e5966cf602);
$parcel$export(module.exports, "injectGlobal", () => $aed32489ab9daed0$export$efb9f5caaa2ca0c7);
$parcel$export(module.exports, "keyframes", () => $aed32489ab9daed0$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeProvider", () => $aed32489ab9daed0$export$d8964aec282183a3);
$parcel$export(module.exports, "withTheme", () => $aed32489ab9daed0$export$e8748c6a27b910dc);
$parcel$export(module.exports, "default", () => $aed32489ab9daed0$export$2e2bcd8739ae039);

var $9pmZe = parcelRequire("9pmZe");
const { css: $aed32489ab9daed0$export$dbf350e5966cf602, injectGlobal: $aed32489ab9daed0$export$efb9f5caaa2ca0c7, keyframes: $aed32489ab9daed0$export$d25ddfdf17c3ad3e, ThemeProvider: $aed32489ab9daed0$export$d8964aec282183a3, default: $aed32489ab9daed0$var$styled } = $9pmZe;
// Custom type definition for withTheme method for styled components so that
// we don't have to manually inject theme props in storybook
const $aed32489ab9daed0$export$e8748c6a27b910dc = (component)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $9pmZe.withTheme(component);
var $aed32489ab9daed0$export$2e2bcd8739ae039 = $aed32489ab9daed0$var$styled;

});
parcelRegister("9pmZe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "isStyledComponent", () => $6d98478425223683$export$7ba318d8d2f06c76);
$parcel$export(module.exports, "consolidateStreamedStyles", () => $6d98478425223683$export$953e7e0c06f2f28b);
$parcel$export(module.exports, "css", () => $6d98478425223683$export$dbf350e5966cf602);
$parcel$export(module.exports, "StyleSheetManager", () => $6d98478425223683$export$a473771da2f0ff7c);
$parcel$export(module.exports, "ServerStyleSheet", () => $6d98478425223683$export$ae8c7d15c8b89a20);
$parcel$export(module.exports, "ThemeProvider", () => $6d98478425223683$export$d8964aec282183a3);
$parcel$export(module.exports, "withTheme", () => $6d98478425223683$export$e8748c6a27b910dc);
$parcel$export(module.exports, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", () => $6d98478425223683$export$84079c323bb0915e);
$parcel$export(module.exports, "keyframes", () => $6d98478425223683$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "injectGlobal", () => $6d98478425223683$export$efb9f5caaa2ca0c7);
$parcel$export(module.exports, "default", () => $6d98478425223683$export$2e2bcd8739ae039);

var $aIrV2 = parcelRequire("aIrV2");

var $8P7DW = parcelRequire("8P7DW");

var $es58f = parcelRequire("es58f");

var $eWoAY = parcelRequire("eWoAY");

var $93Fg7 = parcelRequire("93Fg7");

var $arvh9 = parcelRequire("arvh9");

var $3a2df = parcelRequire("3a2df");

var $6nQJh = parcelRequire("6nQJh");
var $6d98478425223683$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $6d98478425223683$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $6d98478425223683$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $6d98478425223683$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $6d98478425223683$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $6d98478425223683$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $6d98478425223683$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var $6d98478425223683$var$isPlainObject = function(x) {
    return (typeof x === 'undefined' ? 'undefined' : $6d98478425223683$var$_typeof(x)) === 'object' && x.constructor === Object;
};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var $6d98478425223683$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $6d98478425223683$var$format() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c = void 0;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var $6d98478425223683$var$StyledComponentsError = function(_Error) {
    $6d98478425223683$var$inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        $6d98478425223683$var$classCallCheck(this, StyledComponentsError);
        for(var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)interpolations[_key2 - 1] = arguments[_key2];
        var _this;
        var _this = $6d98478425223683$var$possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
        return $6d98478425223683$var$possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var $6d98478425223683$var$objToCss = function objToCss(obj, prevKey) {
    var css = Object.keys(obj).filter(function(key) {
        var chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
    }).map(function(key) {
        if ($6d98478425223683$var$isPlainObject(obj[key])) return objToCss(obj[key], key);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aIrV2)))(key) + ': ' + obj[key] + ';';
    }).join(' ');
    return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};
var $6d98478425223683$var$flatten = function flatten(chunks, executionContext) {
    return chunks.reduce(function(ruleSet, chunk) {
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Handle other components */ if (chunk.hasOwnProperty('styledComponentId')) {
            // $FlowFixMe not sure how to make this pass
            ruleSet.push('.' + chunk.styledComponentId);
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === 'function') {
            if (executionContext) {
                var nextChunk = chunk(executionContext);
                /* Throw if a React Element was given styles */ if ((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(nextChunk)) {
                    var elementName = chunk.displayName || chunk.name;
                    throw new $6d98478425223683$var$StyledComponentsError(11, elementName);
                }
                ruleSet.push.apply(ruleSet, flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        /* Handle objects */ ruleSet.push(// $FlowFixMe have to add %checks somehow to isPlainObject
        $6d98478425223683$var$isPlainObject(chunk) ? $6d98478425223683$var$objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
};
// 
var $6d98478425223683$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var $6d98478425223683$var$stylisSplitter = new (0, (/*@__PURE__*/$parcel$interopDefault($es58f)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var $6d98478425223683$var$stylis = new (0, (/*@__PURE__*/$parcel$interopDefault($es58f)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var $6d98478425223683$var$parsingRules = [];
// eslint-disable-next-line consistent-return
var $6d98478425223683$var$returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = $6d98478425223683$var$parsingRules;
        $6d98478425223683$var$parsingRules = [];
        return parsedRules;
    }
};
var $6d98478425223683$var$parseRulesPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($eWoAY)))(function(rule) {
    $6d98478425223683$var$parsingRules.push(rule);
});
$6d98478425223683$var$stylis.use([
    $6d98478425223683$var$parseRulesPlugin,
    $6d98478425223683$var$returnRulesPlugin
]);
$6d98478425223683$var$stylisSplitter.use([
    $6d98478425223683$var$parseRulesPlugin,
    $6d98478425223683$var$returnRulesPlugin
]);
var $6d98478425223683$var$stringifyRules = function stringifyRules(rules, selector, prefix) {
    var flatCSS = rules.join('').replace($6d98478425223683$var$COMMENT_REGEX, ''); // replace JS comments
    var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
    return $6d98478425223683$var$stylis(prefix || !selector ? '' : selector, cssStr);
};
var $6d98478425223683$var$splitByRules = function splitByRules(css) {
    return $6d98478425223683$var$stylisSplitter('', css);
};
// 
function $6d98478425223683$export$7ba318d8d2f06c76(target) /* : %checks */ {
    return(// $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string');
}
// 
/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */ function $6d98478425223683$export$953e7e0c06f2f28b() {}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $6d98478425223683$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $6d98478425223683$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ var $6d98478425223683$var$generateAlphabeticName = function generateAlphabeticName(code) {
    var name = '';
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > $6d98478425223683$var$charsLength; x = Math.floor(x / $6d98478425223683$var$charsLength))name = $6d98478425223683$var$getAlphabeticChar(x % $6d98478425223683$var$charsLength) + name;
    return $6d98478425223683$var$getAlphabeticChar(x % $6d98478425223683$var$charsLength) + name;
};
// 
var $6d98478425223683$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $6d98478425223683$var$EMPTY_ARRAY = Object.freeze([]);
var $6d98478425223683$var$EMPTY_OBJECT = Object.freeze({});
// 
var $6d98478425223683$export$dbf350e5966cf602 = function(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (typeof styles === 'function' || $6d98478425223683$var$isPlainObject(styles)) // $FlowFixMe
    return $6d98478425223683$var$flatten($6d98478425223683$var$interleave($6d98478425223683$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return $6d98478425223683$var$flatten($6d98478425223683$var$interleave(styles, interpolations));
};
// 
var $6d98478425223683$var$SC_ATTR = (typeof $6nQJh !== 'undefined' && undefined, 'data-styled-components');
var $6d98478425223683$var$SC_STREAM_ATTR = 'data-styled-streamed';
var $6d98478425223683$var$CONTEXT_KEY = '__styled-components-stylesheet__';
var $6d98478425223683$var$IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
var $6d98478425223683$var$DISABLE_SPEEDY = false;
// 
var $6d98478425223683$var$SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var $6d98478425223683$var$extractComps = function(maybeCSS) {
    var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace($6d98478425223683$var$SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
/* eslint-disable camelcase, no-undef */ var $6d98478425223683$var$getNonce = function() {
    return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
// 
// Helper to call a given function, only once
var $6d98478425223683$var$once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb();
        }
    };
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var $6d98478425223683$var$addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var $6d98478425223683$var$resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var $6d98478425223683$var$hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var $6d98478425223683$var$stringifyNames = function stringifyNames(names) {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(' ') + ' ';
    return str.trim();
};
/* clones the nested names dictionary */ var $6d98478425223683$var$cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = $6d98478425223683$var$_extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var $6d98478425223683$var$sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = document.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = document.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new $6d98478425223683$var$StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var $6d98478425223683$var$safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var $6d98478425223683$var$deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var $6d98478425223683$var$makeTextMarker = function makeTextMarker(id) {
    return '\n/* sc-component-id: ' + id + ' */\n';
};
/* add up all numbers in array up until and including the index */ var $6d98478425223683$var$addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var $6d98478425223683$var$makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var el = document.createElement('style');
    el.setAttribute($6d98478425223683$var$SC_ATTR, '');
    var nonce = $6d98478425223683$var$getNonce();
    if (nonce) el.setAttribute('nonce', nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(document.createTextNode(''));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new $6d98478425223683$var$StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var $6d98478425223683$var$wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = $6d98478425223683$var$getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            $6d98478425223683$var$SC_ATTR + '="' + $6d98478425223683$var$stringifyNames(names) + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(' ');
        return '<style ' + htmlAttr + '>' + css() + '</style>';
    };
};
/* takes a css factory function and outputs an element factory */ var $6d98478425223683$var$wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[$6d98478425223683$var$SC_ATTR] = $6d98478425223683$var$stringifyNames(names), _props);
        var nonce = $6d98478425223683$var$getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement('style', $6d98478425223683$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var $6d98478425223683$var$getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var $6d98478425223683$var$makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        $6d98478425223683$var$resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = $6d98478425223683$var$sheetForTag(el);
        var insertIndex = $6d98478425223683$var$addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf('@import') !== -1) importRules.push(cssRule);
            else if ($6d98478425223683$var$safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        $6d98478425223683$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        var size = sizes[marker];
        var sheet = $6d98478425223683$var$sheetForTag(el);
        var removalIndex = $6d98478425223683$var$addUpUntilIndex(sizes, marker);
        $6d98478425223683$var$deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        $6d98478425223683$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var _sheetForTag = $6d98478425223683$var$sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += $6d98478425223683$var$makeTextMarker(id);
            var marker = markers[id];
            var end = $6d98478425223683$var$addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new $6d98478425223683$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $6d98478425223683$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $6d98478425223683$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $6d98478425223683$var$wrapAsElement(css, names),
        toHTML: $6d98478425223683$var$wrapAsHtmlTag(css, names)
    };
};
var $6d98478425223683$var$makeTextNode = function makeTextNode(id) {
    return document.createTextNode($6d98478425223683$var$makeTextMarker(id));
};
var $6d98478425223683$var$makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = $6d98478425223683$var$makeTextNode(id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf('@import') !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? '' : ' ';
                marker.appendData('' + rule + separator);
            }
        }
        $6d98478425223683$var$addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = $6d98478425223683$var$makeTextNode(id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        $6d98478425223683$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new $6d98478425223683$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $6d98478425223683$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $6d98478425223683$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $6d98478425223683$var$wrapAsElement(css, names),
        toHTML: $6d98478425223683$var$wrapAsHtmlTag(css, names)
    };
};
var $6d98478425223683$var$makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ''
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(' ');
        $6d98478425223683$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = '';
        $6d98478425223683$var$resetIdNames(names, id);
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += $6d98478425223683$var$makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = $6d98478425223683$var$cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTagInternal(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: $6d98478425223683$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $6d98478425223683$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: $6d98478425223683$var$wrapAsElement(css, names),
        toHTML: $6d98478425223683$var$wrapAsHtmlTag(css, names)
    };
    return tag;
};
var $6d98478425223683$var$makeServerTag = function makeServerTag() {
    return $6d98478425223683$var$makeServerTagInternal();
};
var $6d98478425223683$var$makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if ($6d98478425223683$var$IS_BROWSER && !forceServer) {
        var el = $6d98478425223683$var$makeStyleTag(target, tagEl, insertBefore);
        if ($6d98478425223683$var$DISABLE_SPEEDY) return $6d98478425223683$var$makeBrowserTag(el, getImportRuleTag);
        else return $6d98478425223683$var$makeSpeedyTag(el, getImportRuleTag);
    }
    return $6d98478425223683$var$makeServerTag();
};
/* wraps a given tag so that rehydration is performed once when necessary */ var $6d98478425223683$var$makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
    /* rehydration function that adds all rules to the new tag */ var rehydrate = $6d98478425223683$var$once(function() {
        /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
            var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
            var cssRules = $6d98478425223683$var$splitByRules(cssFromDOM);
            tag.insertRules(componentId, cssRules);
        }
        /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
            var el = els[_i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    });
    if (immediateRehydration) rehydrate();
    return $6d98478425223683$var$_extends({}, tag, {
        /* add rehydration hook to insertion methods */ insertMarker: function insertMarker(id) {
            rehydrate();
            return tag.insertMarker(id);
        },
        insertRules: function insertRules(id, cssRules, name) {
            rehydrate();
            return tag.insertRules(id, cssRules, name);
        }
    });
};
// 
var $6d98478425223683$var$SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var $6d98478425223683$var$MAX_SIZE = void 0;
if ($6d98478425223683$var$IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ $6d98478425223683$var$MAX_SIZE = $6d98478425223683$var$DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ $6d98478425223683$var$MAX_SIZE = -1;
var $6d98478425223683$var$sheetRunningId = 0;
var $6d98478425223683$var$master = void 0;
var $6d98478425223683$var$StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $6d98478425223683$var$IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $6d98478425223683$var$classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = $6d98478425223683$var$makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        $6d98478425223683$var$sheetRunningId += 1;
        this.id = $6d98478425223683$var$sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate() {
        if (!$6d98478425223683$var$IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll('style[' + $6d98478425223683$var$SC_ATTR + ']');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (nodesSize === 0) return this;
        for(var i = 0; i < nodesSize; i += 1){
            // $FlowFixMe: We can trust that all elements in this query are style elements
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute($6d98478425223683$var$SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute($6d98478425223683$var$SC_ATTR) || '').trim().split($6d98478425223683$var$SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0; j < elNamesSize; j += 1){
                var name = elNames[j];
                /* add rehydrated name to sheet to avoid readding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, $6d98478425223683$var$extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (extractedSize === 0) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        var rehydrationTag = $6d98478425223683$var$makeRehydrationTag(tag, els, extracted, isStreamed);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, $6d98478425223683$var$MAX_SIZE - extractedSize);
        this.tags.push(rehydrationTag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = rehydrationTag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $6d98478425223683$var$master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = $6d98478425223683$var$_extends({}, this.rehydratedNames);
        sheet.deferred = $6d98478425223683$var$_extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return $6d98478425223683$var$makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = $6d98478425223683$var$MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for injectGlobal to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join('');
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = 'sc-' + id + '-' + i;
            return (0, $8P7DW.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    $6d98478425223683$var$createClass(StyleSheet, null, [
        {
            key: 'master',
            get: function get$$1() {
                return $6d98478425223683$var$master || ($6d98478425223683$var$master = new StyleSheet().rehydrate());
            }
        },
        {
            key: 'instance',
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
var $6d98478425223683$var$_StyleSheetManager$ch;
var $6d98478425223683$export$a473771da2f0ff7c = function(_Component) {
    $6d98478425223683$var$inherits(StyleSheetManager, _Component);
    function StyleSheetManager() {
        $6d98478425223683$var$classCallCheck(this, StyleSheetManager);
        return $6d98478425223683$var$possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    StyleSheetManager.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[$6d98478425223683$var$CONTEXT_KEY] = this.sheetInstance, _ref;
    };
    StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
        if (this.props.sheet) this.sheetInstance = this.props.sheet;
        else if (this.props.target) this.sheetInstance = new $6d98478425223683$var$StyleSheet(this.props.target);
        else throw new $6d98478425223683$var$StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        /* eslint-disable react/prop-types */ // Flow v0.43.1 will report an error accessing the `children` property,
        // but v0.47.0 will not. It is necessary to use a type cast instead of
        // a "fixme" comment to satisfy both Flow versions.
        return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(this.props.children);
    };
    return StyleSheetManager;
}((0, $8P7DW.Component));
$6d98478425223683$export$a473771da2f0ff7c.childContextTypes = ($6d98478425223683$var$_StyleSheetManager$ch = {}, $6d98478425223683$var$_StyleSheetManager$ch[$6d98478425223683$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).instanceOf($6d98478425223683$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).instanceOf($6d98478425223683$export$ae8c7d15c8b89a20)
]).isRequired, $6d98478425223683$var$_StyleSheetManager$ch);
// 
var $6d98478425223683$export$ae8c7d15c8b89a20 = function() {
    function ServerStyleSheet() {
        $6d98478425223683$var$classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = $6d98478425223683$var$StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.closed = false;
    }
    ServerStyleSheet.prototype.complete = function complete() {
        if (!this.closed) {
            /* Remove closed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.closed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.closed) throw new $6d98478425223683$var$StyledComponentsError(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($6d98478425223683$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.complete();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.complete();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new $6d98478425223683$var$StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var $6d98478425223683$var$LIMIT = 200;
var $6d98478425223683$var$createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $6d98478425223683$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn('Over ' + $6d98478425223683$var$LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $6d98478425223683$var$determineTheme = function(props, fallbackTheme, defaultProps) {
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types */ var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
    /* eslint-enable */ return theme;
};
// 
var $6d98478425223683$var$escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var $6d98478425223683$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $6d98478425223683$var$escape(str) {
    return str// Replace all possible CSS selectors
    .replace($6d98478425223683$var$escapeRegex, '-')// Remove extraneous hyphens at the start and end
    .replace($6d98478425223683$var$dashesAtEnds, '');
}
// 
function $6d98478425223683$var$getComponentName(target) {
    return target.displayName || target.name || 'Component';
}
// 
function $6d98478425223683$var$isTag(target) /* : %checks */ {
    return typeof target === 'string';
}
// 
function $6d98478425223683$var$generateDisplayName(target) {
    return $6d98478425223683$var$isTag(target) ? 'styled.' + target : 'Styled(' + $6d98478425223683$var$getComponentName(target) + ')';
}
// 
/* eslint-disable max-len */ /**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */ /*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/ /* eslint-enable max-len */ var $6d98478425223683$var$ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */ var $6d98478425223683$var$ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var $6d98478425223683$var$ATTRIBUTE_NAME_CHAR = $6d98478425223683$var$ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var $6d98478425223683$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + $6d98478425223683$var$ATTRIBUTE_NAME_CHAR + ']*$'));
var $6d98478425223683$var$validAttr = function(name) {
    return $6d98478425223683$var$ATTRIBUTE_REGEX.test(name) || $6d98478425223683$var$isCustomAttribute(name.toLowerCase());
};
// 
function $6d98478425223683$var$hasInInheritanceChain(child, parent) {
    var target = child;
    while(target){
        target = Object.getPrototypeOf(target);
        if (target && target === parent) return true;
    }
    return false;
}
// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */ var $6d98478425223683$var$createBroadcast = function createBroadcast(initialState) {
    var listeners = {};
    var id = 0;
    var state = initialState;
    function publish(nextState) {
        state = nextState;
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(var key in listeners){
            var listener = listeners[key];
            if (listener === undefined) continue;
            listener(state);
        }
    }
    function subscribe(listener) {
        var currentId = id;
        listeners[currentId] = listener;
        id += 1;
        listener(state);
        return currentId;
    }
    function unsubscribe(unsubID) {
        listeners[unsubID] = undefined;
    }
    return {
        publish: publish,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $6d98478425223683$var$_contextShape, $6d98478425223683$var$_ThemeProvider$contex;
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var $6d98478425223683$var$CHANNEL = '__styled-components__';
var $6d98478425223683$var$CHANNEL_NEXT = $6d98478425223683$var$CHANNEL + 'next__';
var $6d98478425223683$var$CONTEXT_CHANNEL_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).shape({
    getTheme: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    unsubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func
});
var $6d98478425223683$var$contextShape = ($6d98478425223683$var$_contextShape = {}, $6d98478425223683$var$_contextShape[$6d98478425223683$var$CHANNEL] = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func, $6d98478425223683$var$_contextShape[$6d98478425223683$var$CHANNEL_NEXT] = $6d98478425223683$var$CONTEXT_CHANNEL_SHAPE, $6d98478425223683$var$_contextShape);
var $6d98478425223683$var$warnChannelDeprecated = void 0;
var $6d98478425223683$var$isFunction = function isFunction(test) {
    return typeof test === 'function';
};
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */ var $6d98478425223683$export$d8964aec282183a3 = function(_Component) {
    $6d98478425223683$var$inherits(ThemeProvider, _Component);
    function ThemeProvider() {
        $6d98478425223683$var$classCallCheck(this, ThemeProvider);
        var _this = $6d98478425223683$var$possibleConstructorReturn(this, _Component.call(this));
        _this.unsubscribeToOuterId = -1;
        _this.getTheme = _this.getTheme.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
        // with the outer theme
        var outerContext = this.context[$6d98478425223683$var$CHANNEL_NEXT];
        if (outerContext !== undefined) this.unsubscribeToOuterId = outerContext.subscribe(function(theme) {
            _this2.outerTheme = theme;
            if (_this2.broadcast !== undefined) _this2.publish(_this2.props.theme);
        });
        this.broadcast = $6d98478425223683$var$createBroadcast(this.getTheme());
    };
    ThemeProvider.prototype.getChildContext = function getChildContext() {
        var _this3 = this, _babelHelpers$extends;
        return $6d98478425223683$var$_extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[$6d98478425223683$var$CHANNEL_NEXT] = {
            getTheme: this.getTheme,
            subscribe: this.broadcast.subscribe,
            unsubscribe: this.broadcast.unsubscribe
        }, _babelHelpers$extends[$6d98478425223683$var$CHANNEL] = function(subscriber) {
            // Patch the old `subscribe` provide via `CHANNEL` for older clients.
            var unsubscribeId = _this3.broadcast.subscribe(subscriber);
            return function() {
                return _this3.broadcast.unsubscribe(unsubscribeId);
            };
        }, _babelHelpers$extends));
    };
    ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) this.publish(nextProps.theme);
    };
    ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeToOuterId !== -1) this.context[$6d98478425223683$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    };
    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if ($6d98478425223683$var$isFunction(theme)) {
            var mergedTheme = theme(this.outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : $6d98478425223683$var$_typeof(theme)) !== 'object') throw new $6d98478425223683$var$StyledComponentsError(8);
        return $6d98478425223683$var$_extends({}, this.outerTheme, theme);
    };
    ThemeProvider.prototype.publish = function publish(theme) {
        this.broadcast.publish(this.getTheme(theme));
    };
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(this.props.children);
    };
    return ThemeProvider;
}((0, $8P7DW.Component));
$6d98478425223683$export$d8964aec282183a3.childContextTypes = $6d98478425223683$var$contextShape;
$6d98478425223683$export$d8964aec282183a3.contextTypes = ($6d98478425223683$var$_ThemeProvider$contex = {}, $6d98478425223683$var$_ThemeProvider$contex[$6d98478425223683$var$CHANNEL_NEXT] = $6d98478425223683$var$CONTEXT_CHANNEL_SHAPE, $6d98478425223683$var$_ThemeProvider$contex);
var $6d98478425223683$var$_babelHelpers$extends;
// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var $6d98478425223683$var$STATIC_EXECUTION_CONTEXT = {};
var $6d98478425223683$var$modifiedContextShape = $6d98478425223683$var$_extends({}, $6d98478425223683$var$contextShape, ($6d98478425223683$var$_babelHelpers$extends = {}, $6d98478425223683$var$_babelHelpers$extends[$6d98478425223683$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).instanceOf($6d98478425223683$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).instanceOf($6d98478425223683$export$ae8c7d15c8b89a20)
]), $6d98478425223683$var$_babelHelpers$extends));
var $6d98478425223683$var$identifiers = {};
/* We depend on components having unique IDs */ var $6d98478425223683$var$generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : $6d98478425223683$var$escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = ($6d98478425223683$var$identifiers[displayName] || 0) + 1;
    $6d98478425223683$var$identifiers[displayName] = nr;
    var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};
var $6d98478425223683$var$warnExtendDeprecated = function warnExtendDeprecated() {};
// $FlowFixMe
var $6d98478425223683$var$BaseStyledComponent = function(_Component) {
    $6d98478425223683$var$inherits(BaseStyledComponent, _Component);
    function BaseStyledComponent() {
        var _temp, _this, _ret;
        $6d98478425223683$var$classCallCheck(this, BaseStyledComponent);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $6d98478425223683$var$possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.attrs = {}, _this.state = {
            theme: null,
            generatedClassName: ''
        }, _this.unsubscribeId = -1, _temp), $6d98478425223683$var$possibleConstructorReturn(_this, _ret);
    }
    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
        if (this.unsubscribeId !== -1) this.context[$6d98478425223683$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    };
    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
        var attrs = this.constructor.attrs;
        var context = $6d98478425223683$var$_extends({}, props, {
            theme: theme
        });
        if (attrs === undefined) return context;
        this.attrs = Object.keys(attrs).reduce(function(acc, key) {
            var attr = attrs[key];
            // eslint-disable-next-line no-param-reassign
            acc[key] = typeof attr === 'function' && !$6d98478425223683$var$hasInInheritanceChain(attr, (0, $8P7DW.Component)) ? attr(context) : attr;
            return acc;
        }, {});
        return $6d98478425223683$var$_extends({}, context, this.attrs);
    };
    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _constructor = this.constructor, attrs = _constructor.attrs, componentStyle = _constructor.componentStyle, warnTooManyClasses = _constructor.warnTooManyClasses;
        var styleSheet = this.context[$6d98478425223683$var$CONTEXT_KEY] || $6d98478425223683$var$StyleSheet.master;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && attrs === undefined) return componentStyle.generateAndInjectStyles($6d98478425223683$var$STATIC_EXECUTION_CONTEXT, styleSheet);
        else {
            var executionContext = this.buildExecutionContext(theme, props);
            var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
            return className;
        }
    };
    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var componentStyle = this.constructor.componentStyle;
        var styledContext = this.context[$6d98478425223683$var$CHANNEL_NEXT];
        // If this is a statically-styled component, we don't need to the theme
        // to generate or build styles.
        if (componentStyle.isStatic) {
            var generatedClassName = this.generateAndInjectStyles($6d98478425223683$var$STATIC_EXECUTION_CONTEXT, this.props);
            this.setState({
                generatedClassName: generatedClassName
            });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
        } else if (styledContext !== undefined) {
            var subscribe = styledContext.subscribe;
            this.unsubscribeId = subscribe(function(nextTheme) {
                // This will be called once immediately
                var theme = $6d98478425223683$var$determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
                var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
                _this2.setState({
                    theme: theme,
                    generatedClassName: generatedClassName
                });
            });
        } else {
            // eslint-disable-next-line react/prop-types
            var theme = this.props.theme || $6d98478425223683$var$EMPTY_OBJECT;
            var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
            this.setState({
                theme: theme,
                generatedClassName: _generatedClassName
            });
        }
    };
    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;
        // If this is a statically-styled component, we don't need to listen to
        // props changes to update styles
        var componentStyle = this.constructor.componentStyle;
        if (componentStyle.isStatic) return;
        this.setState(function(prevState) {
            var theme = $6d98478425223683$var$determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
            var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
            return {
                theme: theme,
                generatedClassName: generatedClassName
            };
        });
    };
    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeFromContext();
    };
    BaseStyledComponent.prototype.render = function render() {
        // eslint-disable-next-line react/prop-types
        var innerRef = this.props.innerRef;
        var generatedClassName = this.state.generatedClassName;
        var _constructor2 = this.constructor, styledComponentId = _constructor2.styledComponentId, target = _constructor2.target;
        var isTargetTag = $6d98478425223683$var$isTag(target);
        var className = [
            // eslint-disable-next-line react/prop-types
            this.props.className,
            styledComponentId,
            this.attrs.className,
            generatedClassName
        ].filter(Boolean).join(' ');
        var baseProps = $6d98478425223683$var$_extends({}, this.attrs, {
            className: className
        });
        if ($6d98478425223683$export$7ba318d8d2f06c76(target)) baseProps.innerRef = innerRef;
        else baseProps.ref = innerRef;
        var propsForElement = baseProps;
        var key = void 0;
        for(key in this.props)// Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || $6d98478425223683$var$validAttr(key))) propsForElement[key] = key === 'style' && key in this.attrs ? $6d98478425223683$var$_extends({}, this.attrs[key], this.props[key]) : this.props[key];
        return (0, $8P7DW.createElement)(target, propsForElement);
    };
    return BaseStyledComponent;
}((0, $8P7DW.Component));
var $6d98478425223683$var$_StyledComponent = function(ComponentStyle, constructWithOptions) {
    var createStyledComponent = function createStyledComponent(target, options, rules) {
        var _options$isClass = options.isClass, isClass = _options$isClass === undefined ? !$6d98478425223683$var$isTag(target) : _options$isClass, _options$displayName = options.displayName, displayName = _options$displayName === undefined ? $6d98478425223683$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? $6d98478425223683$var$generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? $6d98478425223683$var$BaseStyledComponent : _options$ParentCompon, extendingRules = options.rules, attrs = options.attrs;
        var styledComponentId = options.displayName && options.componentId ? $6d98478425223683$var$escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
        var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
        var StyledComponent = function(_ParentComponent) {
            $6d98478425223683$var$inherits(StyledComponent, _ParentComponent);
            function StyledComponent() {
                $6d98478425223683$var$classCallCheck(this, StyledComponent);
                return $6d98478425223683$var$possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
            }
            StyledComponent.withComponent = function withComponent(tag) {
                var previousComponentId = options.componentId, optionsToCopy = $6d98478425223683$var$objectWithoutProperties(options, [
                    'componentId'
                ]);
                var newComponentId = previousComponentId && previousComponentId + '-' + ($6d98478425223683$var$isTag(tag) ? tag : $6d98478425223683$var$escape($6d98478425223683$var$getComponentName(tag)));
                var newOptions = $6d98478425223683$var$_extends({}, optionsToCopy, {
                    componentId: newComponentId,
                    ParentComponent: StyledComponent
                });
                return createStyledComponent(tag, newOptions, rules);
            };
            $6d98478425223683$var$createClass(StyledComponent, null, [
                {
                    key: 'extend',
                    get: function get$$1() {
                        var rulesFromOptions = options.rules, parentComponentId = options.componentId, optionsToCopy = $6d98478425223683$var$objectWithoutProperties(options, [
                            'rules',
                            'componentId'
                        ]);
                        var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
                        var newOptions = $6d98478425223683$var$_extends({}, optionsToCopy, {
                            rules: newRules,
                            parentComponentId: parentComponentId,
                            ParentComponent: StyledComponent
                        });
                        $6d98478425223683$var$warnExtendDeprecated();
                        return constructWithOptions(createStyledComponent, target, newOptions);
                    }
                }
            ]);
            return StyledComponent;
        }(ParentComponent);
        StyledComponent.attrs = attrs;
        StyledComponent.componentStyle = componentStyle;
        StyledComponent.contextTypes = $6d98478425223683$var$modifiedContextShape;
        StyledComponent.displayName = displayName;
        StyledComponent.styledComponentId = styledComponentId;
        StyledComponent.target = target;
        if (isClass) (0, (/*@__PURE__*/$parcel$interopDefault($arvh9)))(StyledComponent, target, {
            // all SC-specific things should not be hoisted
            attrs: true,
            componentStyle: true,
            displayName: true,
            extend: true,
            styledComponentId: true,
            target: true,
            warnTooManyClasses: true,
            withComponent: true
        });
        return StyledComponent;
    };
    return createStyledComponent;
};
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $6d98478425223683$var$murmurhash(str) {
    var l = str.length | 0, h = l | 0, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
}
// 
var $6d98478425223683$var$areStylesCacheable = $6d98478425223683$var$IS_BROWSER;
var $6d98478425223683$var$isStaticRules = function isStaticRules(rules, attrs) {
    for(var i = 0, len = rules.length; i < len; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule)) return false;
        else if (typeof rule === 'function' && !$6d98478425223683$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs !== undefined) // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in attrs){
        if (typeof attrs[key] === 'function') return false;
    }
    return true;
};
var $6d98478425223683$var$isHMREnabled = null && false;
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $6d98478425223683$var$_ComponentStyle = function(nameGenerator, flatten, stringifyRules) {
    /* combines hashStr (murmurhash) and nameGenerator for convenience */ var generateRuleHash = function generateRuleHash(str) {
        return nameGenerator($6d98478425223683$var$murmurhash(str));
    };
    var ComponentStyle = function() {
        function ComponentStyle(rules, attrs, componentId) {
            $6d98478425223683$var$classCallCheck(this, ComponentStyle);
            this.rules = rules;
            this.isStatic = !$6d98478425223683$var$isHMREnabled && $6d98478425223683$var$isStaticRules(rules, attrs);
            this.componentId = componentId;
            if (!$6d98478425223683$var$StyleSheet.master.hasId(componentId)) {
                var placeholder = [];
                $6d98478425223683$var$StyleSheet.master.deferredInject(componentId, placeholder);
            }
        }
        /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
            var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
            if ($6d98478425223683$var$areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
            var flatCSS = flatten(this.rules, executionContext);
            var name = generateRuleHash(this.componentId + flatCSS.join(''));
            if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
            this.lastClassName = name;
            return name;
        };
        ComponentStyle.generateName = function generateName(str) {
            return generateRuleHash(str);
        };
        return ComponentStyle;
    }();
    return ComponentStyle;
};
// 
// Thanks to ReactDOMFactories for this handy list!
var $6d98478425223683$var$domElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    // SVG
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// 
var $6d98478425223683$var$_styled = function(styledComponent, constructWithOptions) {
    var styled = function styled(tag) {
        return constructWithOptions(styledComponent, tag);
    };
    // Shorthands for all valid HTML Elements
    $6d98478425223683$var$domElements.forEach(function(domElement) {
        styled[domElement] = styled(domElement);
    });
    return styled;
};
// 
var $6d98478425223683$var$replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, '');
};
var $6d98478425223683$var$_keyframes = function(nameGenerator, stringifyRules, css) {
    return function() {
        var styleSheet = $6d98478425223683$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var name = nameGenerator($6d98478425223683$var$murmurhash($6d98478425223683$var$replaceWhitespace(JSON.stringify(rules))));
        var id = 'sc-keyframes-' + name;
        if (!styleSheet.hasNameForId(id, name)) styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
        return name;
    };
};
// 
var $6d98478425223683$var$_injectGlobal = function(stringifyRules, css) {
    var injectGlobal = function injectGlobal() {
        var styleSheet = $6d98478425223683$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var hash = $6d98478425223683$var$murmurhash(JSON.stringify(rules));
        var id = 'sc-global-' + hash;
        if (!styleSheet.hasId(id)) styleSheet.inject(id, stringifyRules(rules));
    };
    return injectGlobal;
};
// 
var $6d98478425223683$var$_constructWithOptions = function(css) {
    var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $6d98478425223683$var$EMPTY_OBJECT;
        if (!(0, $3a2df.isValidElementType)(tag)) throw new $6d98478425223683$var$StyledComponentsError(1, String(tag));
        /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
        var templateFunction = function templateFunction() {
            return componentConstructor(tag, options, css.apply(undefined, arguments));
        };
        /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
            return constructWithOptions(componentConstructor, tag, $6d98478425223683$var$_extends({}, options, config));
        };
        templateFunction.attrs = function(attrs) {
            return constructWithOptions(componentConstructor, tag, $6d98478425223683$var$_extends({}, options, {
                attrs: $6d98478425223683$var$_extends({}, options.attrs || $6d98478425223683$var$EMPTY_OBJECT, attrs)
            }));
        };
        return templateFunction;
    };
    return constructWithOptions;
};
// 
var $6d98478425223683$export$e8748c6a27b910dc = function(Component$$1) {
    var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && // $FlowFixMe TODO: flow for prototype
    !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);
    // NOTE: We can't pass a ref to a stateless functional component
    var shouldSetInnerRef = $6d98478425223683$export$7ba318d8d2f06c76(Component$$1) || isStatelessFunctionalComponent;
    var WithTheme = function(_React$Component) {
        $6d98478425223683$var$inherits(WithTheme, _React$Component);
        function WithTheme() {
            var _temp, _this, _ret;
            $6d98478425223683$var$classCallCheck(this, WithTheme);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $6d98478425223683$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = $6d98478425223683$var$EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), $6d98478425223683$var$possibleConstructorReturn(_this, _ret);
        }
        // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
        WithTheme.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var defaultProps = this.constructor.defaultProps;
            var styledContext = this.context[$6d98478425223683$var$CHANNEL_NEXT];
            var themeProp = $6d98478425223683$var$determineTheme(this.props, undefined, defaultProps);
            if (styledContext === undefined && themeProp !== undefined) this.setState({
                theme: themeProp
            });
            else {
                var subscribe = styledContext.subscribe;
                this.unsubscribeId = subscribe(function(nextTheme) {
                    var theme = $6d98478425223683$var$determineTheme(_this2.props, nextTheme, defaultProps);
                    _this2.setState({
                        theme: theme
                    });
                });
            }
        };
        WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var defaultProps = this.constructor.defaultProps;
            this.setState(function(oldState) {
                var theme = $6d98478425223683$var$determineTheme(nextProps, oldState.theme, defaultProps);
                return {
                    theme: theme
                };
            });
        };
        WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.unsubscribeId !== -1) this.context[$6d98478425223683$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
        };
        WithTheme.prototype.render = function render() {
            var props = $6d98478425223683$var$_extends({
                theme: this.state.theme
            }, this.props);
            if (!shouldSetInnerRef) {
                props.ref = props.innerRef;
                delete props.innerRef;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component$$1, props);
        };
        return WithTheme;
    }((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component);
    WithTheme.contextTypes = $6d98478425223683$var$contextShape;
    WithTheme.displayName = 'WithTheme(' + $6d98478425223683$var$getComponentName(Component$$1) + ')';
    WithTheme.styledComponentId = 'withTheme';
    return (0, (/*@__PURE__*/$parcel$interopDefault($arvh9)))(WithTheme, Component$$1);
};
// 
/* eslint-disable */ var $6d98478425223683$export$84079c323bb0915e = {
    StyleSheet: $6d98478425223683$var$StyleSheet
};
/* Instantiate singletons */ var $6d98478425223683$var$ComponentStyle = $6d98478425223683$var$_ComponentStyle($6d98478425223683$var$generateAlphabeticName, $6d98478425223683$var$flatten, $6d98478425223683$var$stringifyRules);
var $6d98478425223683$var$constructWithOptions = $6d98478425223683$var$_constructWithOptions($6d98478425223683$export$dbf350e5966cf602);
var $6d98478425223683$var$StyledComponent = $6d98478425223683$var$_StyledComponent($6d98478425223683$var$ComponentStyle, $6d98478425223683$var$constructWithOptions);
/* Instantiate exported singletons */ var $6d98478425223683$export$d25ddfdf17c3ad3e = $6d98478425223683$var$_keyframes($6d98478425223683$var$generateAlphabeticName, $6d98478425223683$var$stringifyRules, $6d98478425223683$export$dbf350e5966cf602);
var $6d98478425223683$export$efb9f5caaa2ca0c7 = $6d98478425223683$var$_injectGlobal($6d98478425223683$var$stringifyRules, $6d98478425223683$export$dbf350e5966cf602);
var $6d98478425223683$var$styled = $6d98478425223683$var$_styled($6d98478425223683$var$StyledComponent, $6d98478425223683$var$constructWithOptions);
var $6d98478425223683$export$2e2bcd8739ae039 = $6d98478425223683$var$styled;

});
parcelRegister("aIrV2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ 'use strict';

var $ezcqb = parcelRequire("ezcqb");
var $7cd3ab94aa5813e0$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $7cd3ab94aa5813e0$var$hyphenateStyleName(string) {
    return $ezcqb(string).replace($7cd3ab94aa5813e0$var$msPattern, '-ms-');
}
module.exports = $7cd3ab94aa5813e0$var$hyphenateStyleName;

});
parcelRegister("ezcqb", function(module, exports) {
'use strict';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $a9adf82e42ce39e5$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $a9adf82e42ce39e5$var$hyphenate(string) {
    return string.replace($a9adf82e42ce39e5$var$_uppercasePattern, '-$1').toLowerCase();
}
module.exports = $a9adf82e42ce39e5$var$hyphenate;

});


parcelRegister("es58f", function(module, exports) {
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    module.exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    'use strict';
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = '';
    /* selector namespace */ var nscopealt = '';
    var nscope = '';
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = '' /* current character */ ;
        var chars = '' /* current buffer of characters */ ;
        var child = '' /* next buffer of characters */ ;
        var out = '' /* compiled body */ ;
        var children = '' /* compiled children */ ;
        var flat = '' /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, '');
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, '');
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join('');
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = '';
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + '{' + child + '}';
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                                        child = chars + '{' + child + '}';
                                        if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) child = '@' + webkit + child + '@' + child;
                                        else child = '@' + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, '');
                                }
                                else child = '';
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = '';
                        child = '';
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(' ', ':')).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = '\0\0';
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = '';
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += '\0';
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = '';
                                    break;
                                default:
                                    if (code !== SPACE) char = ' ';
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = '\\0';
                            break;
                        case FORMFEED:
                            char = '\\f';
                            break;
                        case VERTICALTAB:
                            char = '\\v';
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = '\f' + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += '\r';
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = '';
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + '\0';
                                            break;
                                        default:
                                            char = '\0' + char + (code === COMMA ? '' : '\0');
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(',').length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(',') + '{' + out + '}';
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, '$1' + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf('\f') > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ';';
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf('image-set(', 11) > 0) return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace('shrink', 'negative') + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + 'flex' + '-' + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf('-') + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, 'tb');
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, 'tb-rl');
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, 'lr');
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf('sticky', 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ';' + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
                return out + ';';
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace('-items', '');
                        return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                    // align-content
                    default:
                        return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ':' : '{');
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(':', 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = '', animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case 'infinite':
                                    case 'alternate':
                                    case 'backwards':
                                    case 'running':
                                    case 'normal':
                                    case 'forwards':
                                    case 'both':
                                    case 'none':
                                    case 'linear':
                                    case 'ease':
                                    case 'ease-in':
                                    case 'ease-out':
                                    case 'ease-in-out':
                                    case 'paused':
                                    case 'reverse':
                                    case 'alternate-reverse':
                                    case 'inherit':
                                    case 'initial':
                                    case 'unset':
                                    case 'step-start':
                                    case 'step-end':
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? '' : ',') + items.join(' ');
                }
        }
        out = declare + out + ';';
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = '';
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = '';
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = ' ';
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = '';
                    default:
                        if (size > 1 && element.indexOf(':') > 0) element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, '').trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === 'function') plugins[plugged++] = plugin;
                else if (typeof plugin === 'object') for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case 'keyframe':
                    keyed = value | 0;
                    break;
                case 'global':
                    escape = value | 0;
                    break;
                case 'cascade':
                    cascade = value | 0;
                    break;
                case 'compress':
                    compress = value | 0;
                    break;
                case 'semicolon':
                    semicolon = value | 0;
                    break;
                case 'preserve':
                    preserve = value | 0;
                    break;
                case 'prefix':
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== 'function') prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === 'string') input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== 'string') code = 0;
        }
        // reset
        key = '';
        nscope = '';
        nscopealt = '';
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis['use'] = use;
    stylis['set'] = set;
    if (options !== void 0) set(options);
    return stylis;
});

});

parcelRegister("eWoAY", function(module, exports) {
(function(factory) {
    module.exports = factory();
})(function() {
    'use strict';
    return function(insertRule) {
        var delimiter = '/*|*/';
        var needle = delimiter + '}';
        function toSheet(block) {
            if (block) try {
                insertRule(block + '}');
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), '';
                        default:
                            return content + (at === 0 ? delimiter : '');
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

});

parcelRegister("arvh9", function(module, exports) {
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $79a4afb3f7e9ffbf$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $79a4afb3f7e9ffbf$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $79a4afb3f7e9ffbf$var$defineProperty = Object.defineProperty;
var $79a4afb3f7e9ffbf$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $79a4afb3f7e9ffbf$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $79a4afb3f7e9ffbf$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $79a4afb3f7e9ffbf$var$getPrototypeOf = Object.getPrototypeOf;
var $79a4afb3f7e9ffbf$var$objectPrototype = $79a4afb3f7e9ffbf$var$getPrototypeOf && $79a4afb3f7e9ffbf$var$getPrototypeOf(Object);
function $79a4afb3f7e9ffbf$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($79a4afb3f7e9ffbf$var$objectPrototype) {
            var inheritedComponent = $79a4afb3f7e9ffbf$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $79a4afb3f7e9ffbf$var$objectPrototype) $79a4afb3f7e9ffbf$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $79a4afb3f7e9ffbf$var$getOwnPropertyNames(sourceComponent);
        if ($79a4afb3f7e9ffbf$var$getOwnPropertySymbols) keys = keys.concat($79a4afb3f7e9ffbf$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$79a4afb3f7e9ffbf$var$REACT_STATICS[key] && !$79a4afb3f7e9ffbf$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $79a4afb3f7e9ffbf$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $79a4afb3f7e9ffbf$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $79a4afb3f7e9ffbf$var$hoistNonReactStatics;

});



parcelRegister("aTaR3", function(module, exports) {
$parcel$export(module.exports, "default", () => $36a77dcb8a46ca49$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $iziiq = parcelRequire("iziiq");

var $cqt5Z = parcelRequire("cqt5Z");
class $36a77dcb8a46ca49$var$ConnectFragmentDumb extends $8P7DW.Component {
    render() {
        return /*#__PURE__*/ $8P7DW.createElement("div", {
            ref: this.onRef,
            dangerouslySetInnerHTML: {
                __html: this.props.fragmentHtml
            }
        });
    }
    constructor(...args){
        super(...args), this.componentDidMount = ()=>{
            const { onMount: onMount } = this.props;
            onMount && onMount();
        }, this.onRef = (element)=>{
            if (element) this.savedElement = element;
            this.executeConnectIFrameScripts();
        }, this.executeConnectIFrameScripts = ()=>{
            if (this.savedElement) {
                // We manually go through each script tag and then clone it so that it will execute
                const scriptTags = this.savedElement.querySelectorAll('script') || [];
                Array.prototype.forEach.call(scriptTags, (scriptTag)=>{
                    if (scriptTag.parentNode) {
                        // We create a new script tag and then append it to the parent node this way it will execute properly.
                        // Upgrading @atlaskit/platform; fix these violations.
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                        const newScript = document.createElement('script');
                        newScript.innerHTML = scriptTag.innerHTML;
                        scriptTag.parentNode.replaceChild(newScript, scriptTag);
                    }
                });
            }
        }, this.componentDidUpdate = ()=>{
            // If we don't call this, then Connect addon iframes are not rendered when a component is reloaded
            this.executeConnectIFrameScripts();
        };
    }
}
var $36a77dcb8a46ca49$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    componentName: 'ConnectFragment'
})((0, $k7ZVu.default)({
    onMount: (create, props)=>create({
            action: 'mounted',
            analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
            location: props.location ?? 'LocationUnknown',
            appKeys: [
                (0, $cqt5Z.getAppKeyFromFullKey)(props.fullKey)
            ]
        }).fire()
})($36a77dcb8a46ca49$var$ConnectFragmentDumb));

});




parcelRegister("aIQ9W", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e203f10b3b00a15$export$2e2bcd8739ae039);

var $1We2B = parcelRequire("1We2B");
const $6e203f10b3b00a15$var$defer = ()=>{
    let resolve;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let reject;
    const promise = new Promise((rslv, rjct)=>{
        resolve = rslv;
        reject = rjct;
    });
    return {
        promise: promise,
        resolve: // @ts-ignore
        resolve,
        reject: // @ts-ignore
        reject
    };
};
const $6e203f10b3b00a15$var$proxyFunction = (func, wait, options = {})=>{
    let arrArg = [];
    let deferred = $6e203f10b3b00a15$var$defer();
    const callThenResetArgs = (args)=>{
        try {
            const result = func(args);
            deferred.resolve(result);
        } catch (err) {
            deferred.reject(err);
        }
        arrArg = [];
        deferred = $6e203f10b3b00a15$var$defer();
    };
    // Suppressing existing violations for the testing-library/react plugin.
    // eslint-disable-next-line testing-library/await-async-utils
    const debouncedFunc = (0, $1We2B.debounce)(callThenResetArgs, wait, options);
    return (arg)=>{
        if (arg) arrArg = arrArg.concat(arg);
        debouncedFunc(arrArg);
        return deferred.promise;
    };
};
var $6e203f10b3b00a15$export$2e2bcd8739ae039 = $6e203f10b3b00a15$var$proxyFunction;

});



parcelRegister("l6lPJ", function(module, exports) {
$parcel$export(module.exports, "updateEnvAction", () => (parcelRequire("2ccck")).updateEnvAction);
$parcel$export(module.exports, "UPDATE_ENV", () => (parcelRequire("2ccck")).UPDATE_ENV);
$parcel$export(module.exports, "updateXsrfAction", () => (parcelRequire("2ccck")).updateXsrfAction);
$parcel$export(module.exports, "UPDATE_XSRF", () => (parcelRequire("2ccck")).UPDATE_XSRF);

var $2ccck = parcelRequire("2ccck");

});
parcelRegister("2ccck", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ENV", () => $db5f83f263185c1e$export$54fc9c8b94b5595f);
$parcel$export(module.exports, "UPDATE_XSRF", () => $db5f83f263185c1e$export$b024063085428a5d);
$parcel$export(module.exports, "updateEnvAction", () => $db5f83f263185c1e$export$b66da392cb9395e8);
$parcel$export(module.exports, "updateXsrfAction", () => $db5f83f263185c1e$export$1293ace05a0f6e97);
const $db5f83f263185c1e$export$54fc9c8b94b5595f = 'state.persisted.env.UPDATE_ENV';
const $db5f83f263185c1e$export$b024063085428a5d = 'state.persisted.env.UPDATE_XSRF';
const $db5f83f263185c1e$export$b66da392cb9395e8 = (env)=>({
        payload: env,
        type: $db5f83f263185c1e$export$54fc9c8b94b5595f
    });
const $db5f83f263185c1e$export$1293ace05a0f6e97 = (xsrf)=>({
        payload: xsrf,
        type: $db5f83f263185c1e$export$b024063085428a5d
    });

});


parcelRegister("9Vr59", function(module, exports) {
$parcel$export(module.exports, "FETCH_HELP_CENTER_MODEL", () => $5a46dce96382facc$export$5586a78b777598b9);
$parcel$export(module.exports, "INVALIDATE_HELP_CENTER_RELAY_STORE", () => $5a46dce96382facc$export$e3632d3a6ee981be);
$parcel$export(module.exports, "fetchHelpCenterAction", () => $5a46dce96382facc$export$61e2f9e78cb604c7);
$parcel$export(module.exports, "invalidateHelpCenterStoreAction", () => $5a46dce96382facc$export$d06ed959afe649d4);
$parcel$export(module.exports, "FETCH_HELP_CENTER_BRANDING_MODEL", () => $5a46dce96382facc$export$d8cc5374b8afc050);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => $5a46dce96382facc$export$42cfcdfd4935cc23);

var $cWsyg = parcelRequire("cWsyg");
const $5a46dce96382facc$export$5586a78b777598b9 = 'epic.model.FETCH_HELP_CENTER_MODEL';
const $5a46dce96382facc$export$e3632d3a6ee981be = 'epic.model.INVALIDATE_HELP_CENTER_RELAY_STORE';
const $5a46dce96382facc$export$61e2f9e78cb604c7 = (0, $cWsyg.buildModelsActionCreator)($5a46dce96382facc$export$5586a78b777598b9, 'sharedPortal');
const $5a46dce96382facc$export$d06ed959afe649d4 = ()=>({
        type: $5a46dce96382facc$export$e3632d3a6ee981be
    });
const $5a46dce96382facc$export$d8cc5374b8afc050 = 'epic.model.FETCH_HELP_CENTER_BRANDING_MODEL';
const $5a46dce96382facc$export$42cfcdfd4935cc23 = (0, $cWsyg.buildModelsActionCreator)($5a46dce96382facc$export$d8cc5374b8afc050, 'helpCenterBranding');

});


parcelRegister("3sdOx", function(module, exports) {
$parcel$export(module.exports, "fetchSpaceKeyEpic", () => $36768c4859f49943$export$6f464ce566402c7);

var $fSYYZ = parcelRequire("fSYYZ");

var $6UAAT = parcelRequire("6UAAT");
parcelRequire("gExuy");
var $4W5Ru = parcelRequire("4W5Ru");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");
const $36768c4859f49943$export$6f464ce566402c7 = (action$)=>{
    return action$.ofType((0, $4W5Ru.FETCH_ARTICLE_SPACE_KEY)).mergeMap((action)=>{
        const { meta: meta } = action;
        return (0, $6UAAT.fetchArticleSpaceKey)({
            articleId: action.payload.articleId
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $4W5Ru.fetchArticleSpaceKeySuccess)(response);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $fonw6.isNetworkOrClientErrorCode)(error.status)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $4W5Ru.fetchArticleSpaceKeyFailure)(action.payload.articleId, error));
        });
    });
};

});
parcelRegister("6UAAT", function(module, exports) {
$parcel$export(module.exports, "fetchArticleSpaceKey", () => $a7b406781e99587d$export$1bb14e9adb3b68ac);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $jByYr = parcelRequire("jByYr");

var $6t9NN = parcelRequire("6t9NN");

var $clS24 = parcelRequire("clS24");

var $9ypa9 = parcelRequire("9ypa9");
const $a7b406781e99587d$var$fetchArticleSpaceKeyEndpoint = (articleId)=>{
    const activationId = (0, $jByYr.getMeta)('activation-id');
    (0, $clS24.default)(activationId, 'Activation ID not available');
    return `${0, $6t9NN.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/article/${articleId || ''}`;
};
const $a7b406781e99587d$export$1bb14e9adb3b68ac = ({ articleId: articleId })=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)($a7b406781e99587d$var$fetchArticleSpaceKeyEndpoint(articleId), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        (0, $9ypa9.trackError)('article.space.key.fetch.failed', {}, e);
        return (0, $fSYYZ.Observable).throw(e);
    });
};

});


parcelRegister("5pHTi", function(module, exports) {
$parcel$export(module.exports, "handleAjaxErrorEpic", () => $6fda69ae25108f2a$export$91f7ef464c43cc97);

var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $g4UBb = parcelRequire("g4UBb");
const $6fda69ae25108f2a$export$91f7ef464c43cc97 = (action$)=>{
    return action$.ofType((0, $6p5HB.HANDLE_AJAX_ERROR)).mergeMap((handleAjaxErrorAction)=>{
        const { error: error } = handleAjaxErrorAction.payload;
        // TODO: Handle errors that come directly from the backend already translated (https://jdog.jira-dev.com/browse/JNW-236)
        const errorDescriptor = (0, $g4UBb.getDefaultError)(error);
        const genericAction = errorDescriptor.action === undefined ? undefined : [
            errorDescriptor.action
        ];
        const errorFlagAction = (0, $6p5HB.showErrorFlag)(errorDescriptor.title, errorDescriptor.description, genericAction);
        return (0, $fSYYZ.Observable).of(errorFlagAction);
    });
};

});

parcelRegister("hehn5", function(module, exports) {
$parcel$export(module.exports, "updateHelpCenterBrandingEpic", () => $ae803551327328c3$export$dbe2bc3705ae4647);
$parcel$export(module.exports, "updateHelpCenterBrandingEpicMutationSuccess", () => $ae803551327328c3$export$8d56a889e7db4abe);
$parcel$export(module.exports, "updateHelpCenterBrandingEpicMutationFailure", () => $ae803551327328c3$export$f0ef15072aa7d01f);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $1E402 = parcelRequire("1E402");

var $9Vr59 = parcelRequire("9Vr59");

var $fkG9z = parcelRequire("fkG9z");
parcelRequire("RlLTp");
var $6DnuY = parcelRequire("6DnuY");

var $e4PJI = parcelRequire("e4PJI");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");

var $e2yrc = parcelRequire("e2yrc");
const $ae803551327328c3$var$getAnnouncementBodyFromHCBrandingBody = (body, siteDefaultLanguageTag)=>{
    return {
        header: body.translations[siteDefaultLanguageTag].announcementHeader,
        message: body.translations[siteDefaultLanguageTag].announcementMessage
    };
};
/*
    Different APIs for admins and agents. Admins have permissions to update help center branding along
    with announcements so help center branding api is used. For the agents on the other hand announcement API is used.
    TODO: Separate out announcements from help center branding.
*/ const $ae803551327328c3$var$getUpdateBrandingPromise = (body, canAdministerJira, rawBrandingResponse)=>{
    return !canAdministerJira && rawBrandingResponse ? (0, $fkG9z.updateAnnouncement)($ae803551327328c3$var$getAnnouncementBodyFromHCBrandingBody(body, rawBrandingResponse.siteDefaultLanguageTag)) : (0, $fkG9z.updateBranding)(body);
};
const $ae803551327328c3$export$dbe2bc3705ae4647 = (action$, store)=>{
    return action$.ofType((0, $1E402.UPDATE_HELP_CENTER_BRANDING)).mergeMap((updateBrandingAction)=>{
        const { payload: payload, meta: meta } = updateBrandingAction;
        const { body: body } = payload;
        const state = store.getState();
        const canAdministerJira = state.persisted.user.canAdministerJIRA;
        const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        return $ae803551327328c3$var$getUpdateBrandingPromise(body, canAdministerJira, rawBrandingResponse).flatMap((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent);
            const modifiedResponse = rawBrandingResponse ? {
                ...rawBrandingResponse,
                ...response
            } : response;
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $6DnuY.updateHCBrandingModelAction)(modifiedResponse)), (0, $fSYYZ.Observable).of((0, $1E402.clearHCPreviewModelAction)()));
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && error.status >= 500) (0, $9ypa9.legacySendEvent)((0, $e2yrc.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $1E402.updateBrandingFailure)()), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error)));
        });
    });
};
const $ae803551327328c3$export$8d56a889e7db4abe = (action$, store)=>{
    return action$.ofType((0, $1E402.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS)).mergeMap((updateBrandingMutationSuccessAction)=>{
        const { response: response, meta: meta } = updateBrandingMutationSuccessAction;
        const state = store.getState();
        // const canAdministerJira = state.persisted.user.canAdministerJIRA;
        const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $e4PJI.updateThemeSideBarExperience).success();
        const modifiedResponse = rawBrandingResponse ? {
            ...rawBrandingResponse,
            ...response
        } : response;
        return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $6DnuY.updateHCBrandingModelAction)(modifiedResponse)), (0, $fSYYZ.Observable).of((0, $1E402.clearHCPreviewModelAction)()), (0, $fSYYZ.Observable).of((0, $9Vr59.invalidateHelpCenterStoreAction)()));
    });
};
const $ae803551327328c3$export$f0ef15072aa7d01f = (action$)=>{
    return action$.ofType((0, $1E402.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE)).mergeMap((updateBrandingMutationFailureAction)=>{
        const { error: error, meta: meta } = updateBrandingMutationFailureAction;
        //const state = store.getState();
        // const canAdministerJira = state.persisted.user.canAdministerJIRA;
        // const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        return (0, $fSYYZ.Observable).from(Promise.reject(error)).catch((err)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $fonw6.isNetworkOrClientErrorCode)(err.status)) (0, $9ypa9.legacySendEvent)((0, $e2yrc.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            if (!(0, $fonw6.isNetworkOrClientErrorCode)(err.status)) // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $e4PJI.updateThemeSideBarExperience).failure({
                metadata: {
                    error: err.message
                }
            });
            else // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $e4PJI.updateThemeSideBarExperience).success();
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $1E402.updateBrandingFailure)()), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(err)));
        });
    });
};

});
parcelRegister("1E402", function(module, exports) {
$parcel$export(module.exports, "UPDATE_HELP_CENTER_PREVIEW_MODEL", () => $3505db97c2d4dcde$export$f0cfe50b4b81e5e5);
$parcel$export(module.exports, "CLEAR_HELP_CENTER_PREVIEW_MODEL", () => $3505db97c2d4dcde$export$61f6f0f25aef37a);
$parcel$export(module.exports, "EDITING_HELP_CENTER", () => $3505db97c2d4dcde$export$429f706ec067751a);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING", () => $3505db97c2d4dcde$export$e49dc7a9374bb0ed);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS", () => $3505db97c2d4dcde$export$75be5b55c825c5f4);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE", () => $3505db97c2d4dcde$export$bb6272ebd92e455f);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_FAILURE", () => $3505db97c2d4dcde$export$d249354c8afb6e40);
$parcel$export(module.exports, "UPLOAD_START", () => $3505db97c2d4dcde$export$b03358de8b670bd6);
$parcel$export(module.exports, "UPLOAD_END", () => $3505db97c2d4dcde$export$56dfdb40a4995b23);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_SAVE_START", () => $3505db97c2d4dcde$export$d6b07b90ea00e758);
$parcel$export(module.exports, "editingHelpCenter", () => $3505db97c2d4dcde$export$8f5c235cd10e8248);
$parcel$export(module.exports, "updateHCPreviewModelAction", () => $3505db97c2d4dcde$export$52aab28d032a2b51);
$parcel$export(module.exports, "clearHCPreviewModelAction", () => $3505db97c2d4dcde$export$1044307c0b2e2fc4);
$parcel$export(module.exports, "updateBranding", () => $3505db97c2d4dcde$export$eb176b496ba6ad25);
$parcel$export(module.exports, "updateBrandingMutationSuccess", () => $3505db97c2d4dcde$export$e7ca67101719c569);
$parcel$export(module.exports, "updateBrandingMutationFailure", () => $3505db97c2d4dcde$export$4522a481460f5735);
$parcel$export(module.exports, "updateBrandingSaveStart", () => $3505db97c2d4dcde$export$676616ec28a47579);
$parcel$export(module.exports, "updateBrandingFailure", () => $3505db97c2d4dcde$export$be3ae179d979bebe);
$parcel$export(module.exports, "uploadStart", () => $3505db97c2d4dcde$export$34ff845ea9831833);
$parcel$export(module.exports, "uploadEnd", () => $3505db97c2d4dcde$export$f986c9a8af4f4565);
const $3505db97c2d4dcde$export$f0cfe50b4b81e5e5 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_PREVIEW_MODEL';
const $3505db97c2d4dcde$export$61f6f0f25aef37a = 'state.ui.help-center-preview.CLEAR_HELP_CENTER_PREVIEW_MODEL';
const $3505db97c2d4dcde$export$429f706ec067751a = 'state.ui.help-center-preview.EDITING_HELP_CENTER';
const $3505db97c2d4dcde$export$e49dc7a9374bb0ed = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING';
const $3505db97c2d4dcde$export$75be5b55c825c5f4 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS';
const $3505db97c2d4dcde$export$bb6272ebd92e455f = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE';
const $3505db97c2d4dcde$export$d249354c8afb6e40 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_FAILURE';
const $3505db97c2d4dcde$export$b03358de8b670bd6 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_UPLOAD_START';
const $3505db97c2d4dcde$export$56dfdb40a4995b23 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_UPLOAD_END';
const $3505db97c2d4dcde$export$d6b07b90ea00e758 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_SAVE_START';
const $3505db97c2d4dcde$export$8f5c235cd10e8248 = (isEditing)=>({
        type: $3505db97c2d4dcde$export$429f706ec067751a,
        payload: isEditing
    });
const $3505db97c2d4dcde$export$52aab28d032a2b51 = (previewPayload)=>({
        payload: previewPayload,
        type: $3505db97c2d4dcde$export$f0cfe50b4b81e5e5
    });
const $3505db97c2d4dcde$export$1044307c0b2e2fc4 = ()=>({
        type: $3505db97c2d4dcde$export$61f6f0f25aef37a
    });
const $3505db97c2d4dcde$export$eb176b496ba6ad25 = (body, meta = {})=>({
        meta: meta,
        type: $3505db97c2d4dcde$export$e49dc7a9374bb0ed,
        payload: {
            body: body
        }
    });
const $3505db97c2d4dcde$export$e7ca67101719c569 = (response, meta = {})=>({
        meta: meta,
        response: response,
        type: $3505db97c2d4dcde$export$75be5b55c825c5f4
    });
const $3505db97c2d4dcde$export$4522a481460f5735 = (error, meta = {})=>({
        meta: meta,
        error: error,
        type: $3505db97c2d4dcde$export$bb6272ebd92e455f
    });
const $3505db97c2d4dcde$export$676616ec28a47579 = ()=>({
        type: $3505db97c2d4dcde$export$d6b07b90ea00e758
    });
const $3505db97c2d4dcde$export$be3ae179d979bebe = ()=>({
        type: $3505db97c2d4dcde$export$d249354c8afb6e40
    });
const $3505db97c2d4dcde$export$34ff845ea9831833 = (fileCollection)=>({
        type: $3505db97c2d4dcde$export$b03358de8b670bd6,
        payload: {
            fileCollection: fileCollection
        }
    });
const $3505db97c2d4dcde$export$f986c9a8af4f4565 = (fileCollection)=>({
        type: $3505db97c2d4dcde$export$56dfdb40a4995b23,
        payload: {
            fileCollection: fileCollection
        }
    });

});

parcelRegister("fkG9z", function(module, exports) {
$parcel$export(module.exports, "BrandingTargetCollections", () => $d8e6a3b8fdb80ec1$export$b5e98a61473b07ad);
$parcel$export(module.exports, "getUploadTokenWithClientInfo", () => $d8e6a3b8fdb80ec1$export$1c22c9bf986a3d58);
$parcel$export(module.exports, "updateBranding", () => $d8e6a3b8fdb80ec1$export$eb176b496ba6ad25);
$parcel$export(module.exports, "updateAnnouncement", () => $d8e6a3b8fdb80ec1$export$159f65cfbafa86b5);

var $breWd = parcelRequire("breWd");

var $1We2B = parcelRequire("1We2B");

var $gKxW2 = parcelRequire("gKxW2");

var $7FSs7 = parcelRequire("7FSs7");
var $d8e6a3b8fdb80ec1$export$b5e98a61473b07ad = /*#__PURE__*/ function(BrandingTargetCollections) {
    BrandingTargetCollections["banner"] = "sd-banner-upload";
    BrandingTargetCollections["logo"] = "sd-logo-upload";
    return BrandingTargetCollections;
}({});
const $d8e6a3b8fdb80ec1$export$de87322aceb1e609 = async (targetCollection, context = (0, $7FSs7.contextPath))=>{
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(`${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/upload-token/${targetCollection}`, undefined, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    .map((ajaxResponse)=>ajaxResponse.response.token).toPromise();
};
const $d8e6a3b8fdb80ec1$export$1c22c9bf986a3d58 = async (targetCollection, context = (0, $7FSs7.contextPath))=>{
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(`${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/upload-media-token/${targetCollection}`, undefined, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).toPromise();
};
const $d8e6a3b8fdb80ec1$export$eb176b496ba6ad25 = (body, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/with-translations`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    (0, $gKxW2.ModelsCache).getInstance().del('helpCenterBranding');
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};
/*
    Map announcement response to help center branding response. Since we are using same epic and reducer for
    announcement API and help center branding API. TODO: A new epic for help center announcements.
*/ const $d8e6a3b8fdb80ec1$var$mapAnnouncementResponseToHelpCenterBrandingResponse = (ajaxResponse)=>{
    let modifiedTranslations = {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = ajaxResponse.response;
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    modifiedTranslations = (0, $1We2B.mapValues)(response.translations, (translation)=>({
            announcementHeader: translation.header,
            announcementMessage: translation.message
        }));
    return {
        translations: modifiedTranslations,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        userInitialAnnouncementHeader: response.header,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        userInitialAnnouncementMessageWiki: response.messageWiki
    };
};
const $d8e6a3b8fdb80ec1$export$159f65cfbafa86b5 = (body, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk-data/announcement/help-center`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    (0, $gKxW2.ModelsCache).getInstance().del('helpCenterBranding');
    return (0, $breWd.post)(uri, body, headers).map($d8e6a3b8fdb80ec1$var$mapAnnouncementResponseToHelpCenterBrandingResponse);
};

});

parcelRegister("RlLTp", function(module, exports) {
$parcel$export(module.exports, "updateHCBrandingModelAction", () => (parcelRequire("6DnuY")).updateHCBrandingModelAction);
$parcel$export(module.exports, "updateHelpCenterModelAction", () => (parcelRequire("6DnuY")).updateHelpCenterModelAction);
$parcel$export(module.exports, "updateHCBrandingLoaderAction", () => (parcelRequire("6DnuY")).updateHCBrandingLoaderAction);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MODEL", () => (parcelRequire("6DnuY")).UPDATE_HELP_CENTER_BRANDING_MODEL);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_LOADER", () => (parcelRequire("6DnuY")).UPDATE_HELP_CENTER_BRANDING_LOADER);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_MODEL", () => (parcelRequire("6DnuY")).UPDATE_HELP_CENTER_MODEL);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_THEME_COLOR", () => (parcelRequire("6DnuY")).UPDATE_HELP_CENTER_THEME_COLOR);

var $6DnuY = parcelRequire("6DnuY");

});
parcelRegister("6DnuY", function(module, exports) {
$parcel$export(module.exports, "UPDATE_HELP_CENTER_MODEL", () => $52a09e8965c13621$export$791f10ed5ca1afbc);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MODEL", () => $52a09e8965c13621$export$72877be1acecfff2);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_THEME_COLOR", () => $52a09e8965c13621$export$51eff4874ab833ce);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_LOADER", () => $52a09e8965c13621$export$749d9a3565d43c74);
$parcel$export(module.exports, "updateHelpCenterModelAction", () => $52a09e8965c13621$export$9c200ab172652613);
$parcel$export(module.exports, "updateHCBrandingModelAction", () => $52a09e8965c13621$export$765a61788077a43a);
$parcel$export(module.exports, "updateHCThemeColorAction", () => $52a09e8965c13621$export$8865f165e0e8e610);
$parcel$export(module.exports, "updateHCBrandingLoaderAction", () => $52a09e8965c13621$export$b9ec760cc662cf16);
const $52a09e8965c13621$export$791f10ed5ca1afbc = 'state.persisted.help-center.UPDATE_HELP_CENTER_MODEL';
const $52a09e8965c13621$export$72877be1acecfff2 = 'state.persisted.help-center.UPDATE_HELP_CENTER_BRANDING_MODEL';
const $52a09e8965c13621$export$51eff4874ab833ce = 'state.persisted.help-center.UPDATE_HELP_CENTER_THEME_COLOR';
const $52a09e8965c13621$export$749d9a3565d43c74 = 'state.persisted.help-center.UPDATE_HELP_CENTER_BRANDING_LOADER';
const $52a09e8965c13621$export$9c200ab172652613 = (modelResponse)=>({
        payload: modelResponse,
        type: $52a09e8965c13621$export$791f10ed5ca1afbc
    });
const $52a09e8965c13621$export$765a61788077a43a = (brandingResponse)=>({
        payload: brandingResponse,
        type: $52a09e8965c13621$export$72877be1acecfff2
    });
const $52a09e8965c13621$export$8865f165e0e8e610 = (themeColorResponse)=>({
        payload: themeColorResponse,
        type: $52a09e8965c13621$export$51eff4874ab833ce
    });
const $52a09e8965c13621$export$b9ec760cc662cf16 = (loaded)=>({
        payload: {
            loaded: loaded
        },
        type: $52a09e8965c13621$export$749d9a3565d43c74
    });

});


parcelRegister("e4PJI", function(module, exports) {
$parcel$export(module.exports, "updateAnnouncementSideBarExperience", () => $da7745d6681dc729$export$9202b582e9a7e7e5);
$parcel$export(module.exports, "updateLoginAnnouncementSideBarExperience", () => $da7745d6681dc729$export$bbfbb2132f16ad3e);
$parcel$export(module.exports, "updateThemeSideBarExperience", () => $da7745d6681dc729$export$d4df676089e680c5);

var $lQb0x = parcelRequire("lQb0x");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $da7745d6681dc729$export$9202b582e9a7e7e5 = new (0, $ghwxF.UFOExperience)((0, $lQb0x.updateAnnouncementSideBarExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $da7745d6681dc729$export$bbfbb2132f16ad3e = new (0, $ghwxF.UFOExperience)((0, $lQb0x.updateLoginAnnouncementSideBarExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $da7745d6681dc729$export$d4df676089e680c5 = new (0, $ghwxF.UFOExperience)((0, $lQb0x.updateThemeSideBarExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});
parcelRegister("lQb0x", function(module, exports) {
$parcel$export(module.exports, "ProductExperienceStart", () => $492d4b2a9c9d55cf$export$8c235a9c4b486599);
$parcel$export(module.exports, "externalLinksProductExperienceId", () => $492d4b2a9c9d55cf$export$df6053b3f6f8746e);
$parcel$export(module.exports, "yourApprovalExperienceId", () => $492d4b2a9c9d55cf$export$2748904bbde569a6);
$parcel$export(module.exports, "approvalStatusSectionExperienceId", () => $492d4b2a9c9d55cf$export$53d4142e5691fc30);
$parcel$export(module.exports, "publishLayoutExperienceId", () => $492d4b2a9c9d55cf$export$7706cfa126a5e293);
$parcel$export(module.exports, "topicsReorderExperienceId", () => $492d4b2a9c9d55cf$export$45f14e05062fc2ca);
$parcel$export(module.exports, "helpCenterTopicsProductExperienceId", () => $492d4b2a9c9d55cf$export$3bdaba26dccf5ee6);
$parcel$export(module.exports, "helpCenterViewHomePageExperienceId", () => $492d4b2a9c9d55cf$export$d165863a94dcab28);
$parcel$export(module.exports, "helpCenterTopicEditExperienceId", () => $492d4b2a9c9d55cf$export$d58e75689d75e480);
$parcel$export(module.exports, "helpCenterTopicViewExperienceId", () => $492d4b2a9c9d55cf$export$f1ae827b1686e4b6);
$parcel$export(module.exports, "viewHomepageExperienceId", () => $492d4b2a9c9d55cf$export$42633b810d73bab2);
$parcel$export(module.exports, "viewCustomPageExperienceId", () => $492d4b2a9c9d55cf$export$c25f92d477e645db);
$parcel$export(module.exports, "profileExperienceId", () => $492d4b2a9c9d55cf$export$6b7cf274ce127c6c);
$parcel$export(module.exports, "updateManageColumnsSidebarExperienceId", () => $492d4b2a9c9d55cf$export$1d4505191d749c3);
$parcel$export(module.exports, "editHomepageExperienceId", () => $492d4b2a9c9d55cf$export$f5b418a8fb4c2e52);
$parcel$export(module.exports, "editCustomPageExperienceId", () => $492d4b2a9c9d55cf$export$1a5dc88687c6c743);
$parcel$export(module.exports, "searchExperienceId", () => $492d4b2a9c9d55cf$export$8e695cad45fa9462);
$parcel$export(module.exports, "inlineSearchExperienceId", () => $492d4b2a9c9d55cf$export$ef4e3240bcfb0749);
$parcel$export(module.exports, "helpCenterReportingExperienceId", () => $492d4b2a9c9d55cf$export$a31e9803c7cf4e9c);
$parcel$export(module.exports, "helpCenterReportingContentGapExperienceId", () => $492d4b2a9c9d55cf$export$a49db1fcfecaa197);
$parcel$export(module.exports, "helpCentersManagementExperienceId", () => $492d4b2a9c9d55cf$export$28b0efc551538ce4);
$parcel$export(module.exports, "manageProjectsExperienceId", () => $492d4b2a9c9d55cf$export$8125d660e6f5341);
$parcel$export(module.exports, "managePagesExperienceId", () => $492d4b2a9c9d55cf$export$b3c36987f8f3e130);
$parcel$export(module.exports, "editHelpCenterExperienceId", () => $492d4b2a9c9d55cf$export$9d36a9a1a5392695);
$parcel$export(module.exports, "multiHCDropdownExperienceId", () => $492d4b2a9c9d55cf$export$814916ea7ef3fe17);
$parcel$export(module.exports, "avatarMenuExperienceId", () => $492d4b2a9c9d55cf$export$ccd2c0d87dacec5b);
$parcel$export(module.exports, "updateAnnouncementSideBarExperienceId", () => $492d4b2a9c9d55cf$export$afc2346bbf17f6dc);
$parcel$export(module.exports, "updateSinglePortalAnnouncementSideBarExperienceId", () => $492d4b2a9c9d55cf$export$ad5e73bffe8e8683);
$parcel$export(module.exports, "updateLoginAnnouncementSideBarExperienceId", () => $492d4b2a9c9d55cf$export$7b03636a868ec87a);
$parcel$export(module.exports, "updateThemeSideBarExperienceId", () => $492d4b2a9c9d55cf$export$3a07bc7f4f48662a);
$parcel$export(module.exports, "requestCreateEntitlementPickerExperienceId", () => $492d4b2a9c9d55cf$export$950826a562410f6a);
$parcel$export(module.exports, "csmContactsUFormPickerExperienceId", () => $492d4b2a9c9d55cf$export$eb5378d79d45e2ce);
$parcel$export(module.exports, "csmViewHomepageExperienceId", () => $492d4b2a9c9d55cf$export$cb86036c3a8f0a3d);

var $8y0tS = parcelRequire("8y0tS");
const $492d4b2a9c9d55cf$export$8c235a9c4b486599 = (props)=>{
    const { ufoExperience: ufoExperience } = props;
    (0, $8y0tS.useUFOComponentExperience)(ufoExperience);
    return null;
};
const $492d4b2a9c9d55cf$export$df6053b3f6f8746e = 'service-management.help-center.external-resources';
const $492d4b2a9c9d55cf$export$2748904bbde569a6 = 'service-management.help-center.your-approval';
const $492d4b2a9c9d55cf$export$53d4142e5691fc30 = 'service-management.help-center.approval-status-section';
const $492d4b2a9c9d55cf$export$7706cfa126a5e293 = 'service-management.help-center.publish.layout';
const $492d4b2a9c9d55cf$export$45f14e05062fc2ca = 'service-management.help-center.topics.reorder';
const $492d4b2a9c9d55cf$export$3bdaba26dccf5ee6 = 'service-management.help-center.topics';
const $492d4b2a9c9d55cf$export$d165863a94dcab28 = 'service-management.help-center.view.homepage';
const $492d4b2a9c9d55cf$export$d58e75689d75e480 = 'service-management.help-center.topic.edit';
const $492d4b2a9c9d55cf$export$f1ae827b1686e4b6 = 'service-management.help-center.topic.view';
const $492d4b2a9c9d55cf$export$42633b810d73bab2 = 'service-management.help-center.advanced.homepage.view';
const $492d4b2a9c9d55cf$export$c25f92d477e645db = 'service-management.help-center.custom.page.view';
const $492d4b2a9c9d55cf$export$6b7cf274ce127c6c = 'service-management.help-center.profile.view';
const $492d4b2a9c9d55cf$export$1d4505191d749c3 = 'service-management.help-center.update.manage-columns-sidebar-view';
const $492d4b2a9c9d55cf$export$f5b418a8fb4c2e52 = 'service-management.help-center.advanced.homepage.edit';
const $492d4b2a9c9d55cf$export$1a5dc88687c6c743 = 'service-management.help-center.custom.page.edit';
const $492d4b2a9c9d55cf$export$8e695cad45fa9462 = 'service-management.help-center.search';
const $492d4b2a9c9d55cf$export$ef4e3240bcfb0749 = 'service-management.help-center.inline-search';
const $492d4b2a9c9d55cf$export$a31e9803c7cf4e9c = 'service-management.help-center.help-center-reporting';
const $492d4b2a9c9d55cf$export$a49db1fcfecaa197 = 'service-management.help-center.help-center-reporting-content-gap';
const $492d4b2a9c9d55cf$export$28b0efc551538ce4 = 'service-management.help-center.help-centers-management';
const $492d4b2a9c9d55cf$export$8125d660e6f5341 = 'service-management.help-center.manage-projects';
const $492d4b2a9c9d55cf$export$b3c36987f8f3e130 = 'service-management.help-center.manage-pages';
const $492d4b2a9c9d55cf$export$9d36a9a1a5392695 = 'service-management.help-center.edit-details';
const $492d4b2a9c9d55cf$export$814916ea7ef3fe17 = 'service-management.help-center.multi-hc-dropdown';
const $492d4b2a9c9d55cf$export$ccd2c0d87dacec5b = 'service-management.help-center.avatar-menu';
const $492d4b2a9c9d55cf$export$afc2346bbf17f6dc = 'service-management.help-center.update.announcement-sidebar';
const $492d4b2a9c9d55cf$export$ad5e73bffe8e8683 = 'service-management.help-center.update.single-portal-announcement-sidebar';
const $492d4b2a9c9d55cf$export$7b03636a868ec87a = 'service-management.help-center.update.login-announcement-sidebar';
const $492d4b2a9c9d55cf$export$3a07bc7f4f48662a = 'service-management.help-center.update.theme-sidebar';
const $492d4b2a9c9d55cf$export$950826a562410f6a = 'service-management.help-center.request-create.jsm-cs-entitlement-custom-field-load';
const $492d4b2a9c9d55cf$export$a14ae97aa64fd38f = 'service-management.help-center.csm-help-center-form-picker';
const $492d4b2a9c9d55cf$export$eb5378d79d45e2ce = 'service-management.help-center.csm-contact-us-form-picker';
const $492d4b2a9c9d55cf$export$cb86036c3a8f0a3d = 'service-management.help-center.advanced.csm.homepage.view';

});
parcelRegister("8y0tS", function(module, exports) {
$parcel$export(module.exports, "useUFOComponentExperience", () => $36c7ab83d56cd90c$export$30ab340faaed55d4);

var $8P7DW = parcelRequire("8P7DW");
const $36c7ab83d56cd90c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $8P7DW.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $36c7ab83d56cd90c$export$30ab340faaed55d4 = (experience)=>{
    (0, $8P7DW.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $36c7ab83d56cd90c$var$useConstructor(()=>experience.start());
    return null;
};

});


parcelRegister("ghwxF", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $d4b9a44b64a93175$export$c00d22927c60484a);

var $9Ypx7 = parcelRequire("9Ypx7");
class $d4b9a44b64a93175$export$c00d22927c60484a extends (0, $9Ypx7.UFOAbstractExperience) {
}

});
parcelRegister("9Ypx7", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $a51bbb8f337684ea$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $gdnRs = parcelRequire("gdnRs");

var $e6Qdr = parcelRequire("e6Qdr");

var $gkZFD = parcelRequire("gkZFD");

var $5zXYv = parcelRequire("5zXYv");

var $ah7DZ = parcelRequire("ah7DZ");

var $gBFgd = parcelRequire("gBFgd");

var $782sr = parcelRequire("782sr");

var $8Jiir = parcelRequire("8Jiir");

var $1VCaI = parcelRequire("1VCaI");

var $4EHDH = parcelRequire("4EHDH");

var $cj4i7 = parcelRequire("cj4i7");

var $ed1VN = parcelRequire("ed1VN");

var $2lzZD = parcelRequire("2lzZD");
const $a51bbb8f337684ea$var$getPageVisibleState = ()=>{
    return !(0, $ah7DZ.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $1VCaI.PageVisibleState).VISIBLE : (0, $1VCaI.PageVisibleState).HIDDEN;
};
const $a51bbb8f337684ea$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $4EHDH.roundPerfNow)();
};
class $a51bbb8f337684ea$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $cj4i7.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.traceContext = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $1VCaI.PageVisibleState).MIXED;
            (0, $8Jiir.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $a51bbb8f337684ea$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $2lzZD.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $2lzZD.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $782sr.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $ed1VN.canTransition)(this.state, newState)) {
            (0, $782sr.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $cj4i7.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $a51bbb8f337684ea$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $gdnRs.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $a51bbb8f337684ea$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $gBFgd.getGlobalEventStream)().push((0, $gBFgd.unsubscribeEvent)((0, $1VCaI.SUBSCRIBE_ALL), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, $782sr.ufolog)('this.parent', this.parent);
                (0, $gBFgd.getGlobalEventStream)().push((0, $gBFgd.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $782sr.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $782sr.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $cj4i7.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $a51bbb8f337684ea$var$getPageVisibleState();
            (0, $8Jiir.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $782sr.ufolog)('subscribed', this.id);
                (0, $gBFgd.getGlobalEventStream)().push((0, $gBFgd.subscribeEvent)((0, $1VCaI.SUBSCRIBE_ALL), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $1VCaI.FMP_MARK) && name !== (0, $1VCaI.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $782sr.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $a51bbb8f337684ea$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $cj4i7.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $1VCaI.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $1VCaI.INLINE_RESPONSE_MARK), timestamp);
    }
    startTrace(experienceId) {
        if ((0, $e6Qdr.fg)('ufo_v1_tracing')) {
            let traceContext = (0, $gkZFD.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $gkZFD.generateTraceId)(),
                    spanId: (0, $gkZFD.generateSpanId)()
                };
                (0, $gkZFD.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $e6Qdr.fg)('ufo_v1_tracing')) (0, $gkZFD.clearActiveTrace)();
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $782sr.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $8Jiir.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $cj4i7.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $cj4i7.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $cj4i7.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $782sr.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $5zXYv.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig,
            ...(0, $e6Qdr.fg)('ufo_v1_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("5zXYv", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $43185eb368cd84b1$export$2295b861f318254a);
// temp solution until we can get it automated
const $43185eb368cd84b1$export$2295b861f318254a = '0.1.5';

});

parcelRegister("4EHDH", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $5debae14bbd3ff8f$export$5f490af6b2b115cf);
const $5debae14bbd3ff8f$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("cj4i7", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $ad48bf43556dda52$export$81b70111112841a0);
const $ad48bf43556dda52$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("ed1VN", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $3b2059179e211cc9$export$178881f329fdb81f);

var $cj4i7 = parcelRequire("cj4i7");
const $3b2059179e211cc9$var$UFOStateAvailableTransitions = {
    [(0, $cj4i7.UFOExperienceState).NOT_STARTED.id]: [
        (0, $cj4i7.UFOExperienceState).STARTED.id
    ],
    [(0, $cj4i7.UFOExperienceState).STARTED.id]: [
        (0, $cj4i7.UFOExperienceState).IN_PROGRESS.id,
        (0, $cj4i7.UFOExperienceState).BLOCKED.id,
        (0, $cj4i7.UFOExperienceState).SUCCEEDED.id,
        (0, $cj4i7.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $cj4i7.UFOExperienceState).FAILED.id,
        (0, $cj4i7.UFOExperienceState).ABORTED.id
    ],
    [(0, $cj4i7.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $cj4i7.UFOExperienceState).BLOCKED.id,
        (0, $cj4i7.UFOExperienceState).SUCCEEDED.id,
        (0, $cj4i7.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $cj4i7.UFOExperienceState).FAILED.id,
        (0, $cj4i7.UFOExperienceState).ABORTED.id
    ],
    [(0, $cj4i7.UFOExperienceState).BLOCKED.id]: [
        (0, $cj4i7.UFOExperienceState).RECOVERED.id,
        (0, $cj4i7.UFOExperienceState).ABORTED.id
    ],
    [(0, $cj4i7.UFOExperienceState).RECOVERED.id]: [
        (0, $cj4i7.UFOExperienceState).STARTED.id,
        (0, $cj4i7.UFOExperienceState).SUCCEEDED.id,
        (0, $cj4i7.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $cj4i7.UFOExperienceState).FAILED.id,
        (0, $cj4i7.UFOExperienceState).ABORTED.id
    ],
    [(0, $cj4i7.UFOExperienceState).SUCCEEDED.id]: [
        (0, $cj4i7.UFOExperienceState).STARTED.id
    ],
    [(0, $cj4i7.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $cj4i7.UFOExperienceState).SUCCEEDED.id,
        (0, $cj4i7.UFOExperienceState).FAILED.id,
        (0, $cj4i7.UFOExperienceState).ABORTED.id
    ],
    [(0, $cj4i7.UFOExperienceState).FAILED.id]: [
        (0, $cj4i7.UFOExperienceState).STARTED.id
    ],
    [(0, $cj4i7.UFOExperienceState).ABORTED.id]: [
        (0, $cj4i7.UFOExperienceState).STARTED.id
    ]
};
const $3b2059179e211cc9$export$178881f329fdb81f = (state1, state2)=>{
    return $3b2059179e211cc9$var$UFOStateAvailableTransitions[state1.id] && $3b2059179e211cc9$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});




parcelRegister("e2yrc", function(module, exports) {
$parcel$export(module.exports, "logErrorToFailureEvent", () => $30f631926c2f799c$export$7c2011d2dfcd2230);

var $HGACo = parcelRequire("HGACo");
const $30f631926c2f799c$export$7c2011d2dfcd2230 = (analyticsFailureEvent, error)=>{
    if (!(0, $HGACo.isUpdateAnalyticsFailureEventWithError)()) return analyticsFailureEvent;
    analyticsFailureEvent.update((payload)=>{
        var _errorMessages;
        return {
            ...payload,
            errorMessage: error.message || error.errorMessage || ((_errorMessages = error.errorMessages) === null || _errorMessages === void 0 ? void 0 : _errorMessages.join(',')),
            status: error.status || error.statusCode
        };
    });
    return analyticsFailureEvent;
};

});


parcelRegister("arBRl", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpEpic", () => $f3028c9535066b9d$export$ccd8cad10bc12583);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $7hZ8C = parcelRequire("7hZ8C");
parcelRequire("bRFjb");
var $lLqMr = parcelRequire("lLqMr");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");

var $g4UBb = parcelRequire("g4UBb");
const $f3028c9535066b9d$export$ccd8cad10bc12583 = (action$)=>{
    return action$.ofType((0, $lLqMr.INVITED_SIGN_UP)).mergeMap((invitedSignUpAction)=>{
        const { portalId: portalId, email: email, fullName: fullName, password: password, token: token, username: username, contactAdminsFormEnabled: contactAdminsFormEnabled, setPasswordJwt: setPasswordJwt } = invitedSignUpAction.payload;
        return (0, $7hZ8C.invitedSignUp)({
            portalId: portalId,
            email: email,
            fullName: fullName,
            password: password,
            token: token,
            username: username,
            setPasswordJwt: setPasswordJwt
        }).flatMap(()=>{
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $lLqMr.invitedSignUpSuccess)()), (0, $fSYYZ.Observable).of((0, $uiV1X.loginAttempt)({
                email: email,
                password: password,
                continueParam: null
            })));
        }).catch((error)=>{
            const parsedError = (0, $g4UBb.getDefaultSignUpError)(error, contactAdminsFormEnabled);
            return (0, $fSYYZ.Observable).of((0, $lLqMr.invitedSignUpFailure)(parsedError));
        });
    });
};

});
parcelRegister("7hZ8C", function(module, exports) {
$parcel$export(module.exports, "invitedSignUp", () => $6bc29d688e56fc80$export$3693303625071052);

var $bhOdO = parcelRequire("bhOdO");

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $6bc29d688e56fc80$export$3693303625071052 = (params)=>{
    const { portalId: portalId, email: email, fullName: fullName, password: password, token: token, username: username, setPasswordJwt: setPasswordJwt, context: context = (0, $7FSs7.contextPath) } = params;
    const uri = setPasswordJwt ? `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword?jwt=${setPasswordJwt}` : `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword`;
    const body = {
        fullName: fullName,
        password: password,
        username: username,
        email: email,
        ...token ? {
            token: token
        } : {}
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $breWd.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $bhOdO.Observable).throw(e);
    });
};

});

parcelRegister("bRFjb", function(module, exports) {
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_MODEL", () => (parcelRequire("lLqMr")).FETCH_VISIT_PORTAL_MODEL);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_SUCCESS", () => (parcelRequire("lLqMr")).FETCH_VISIT_PORTAL_SUCCESS);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_FAILURE", () => (parcelRequire("lLqMr")).FETCH_VISIT_PORTAL_FAILURE);
$parcel$export(module.exports, "INVITED_SIGN_UP", () => (parcelRequire("lLqMr")).INVITED_SIGN_UP);
$parcel$export(module.exports, "INVITED_SIGN_UP_FAILURE", () => (parcelRequire("lLqMr")).INVITED_SIGN_UP_FAILURE);
$parcel$export(module.exports, "fetchVisitPortalModel", () => (parcelRequire("lLqMr")).fetchVisitPortalModel);
$parcel$export(module.exports, "fetchVisitPortalSuccess", () => (parcelRequire("lLqMr")).fetchVisitPortalSuccess);
$parcel$export(module.exports, "fetchVisitPortalFailure", () => (parcelRequire("lLqMr")).fetchVisitPortalFailure);
$parcel$export(module.exports, "invitedSignUp", () => (parcelRequire("lLqMr")).invitedSignUp);
$parcel$export(module.exports, "invitedSignUpSuccess", () => (parcelRequire("lLqMr")).invitedSignUpSuccess);
$parcel$export(module.exports, "invitedSignUpFailure", () => (parcelRequire("lLqMr")).invitedSignUpFailure);

var $lLqMr = parcelRequire("lLqMr");

});
parcelRegister("lLqMr", function(module, exports) {
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_MODEL", () => $9e1c20d78b49d5b9$export$5aa92ec48cad67e1);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_SUCCESS", () => $9e1c20d78b49d5b9$export$cd1a8438490d4c7e);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_FAILURE", () => $9e1c20d78b49d5b9$export$7d63bf92ff546bd4);
$parcel$export(module.exports, "INVITED_SIGN_UP", () => $9e1c20d78b49d5b9$export$10a878c7005ffa23);
$parcel$export(module.exports, "INVITED_SIGN_UP_FAILURE", () => $9e1c20d78b49d5b9$export$fc43f808dcbef187);
$parcel$export(module.exports, "fetchVisitPortalModel", () => $9e1c20d78b49d5b9$export$6513e51a3bb59ea8);
$parcel$export(module.exports, "fetchVisitPortalSuccess", () => $9e1c20d78b49d5b9$export$fd6356a11ec803b4);
$parcel$export(module.exports, "fetchVisitPortalFailure", () => $9e1c20d78b49d5b9$export$4807fff848ef2c1a);
$parcel$export(module.exports, "invitedSignUp", () => $9e1c20d78b49d5b9$export$3693303625071052);
$parcel$export(module.exports, "invitedSignUpSuccess", () => $9e1c20d78b49d5b9$export$a2add4c6435cf561);
$parcel$export(module.exports, "invitedSignUpFailure", () => $9e1c20d78b49d5b9$export$7ae6305616bacef7);

var $cWsyg = parcelRequire("cWsyg");
const $9e1c20d78b49d5b9$export$5aa92ec48cad67e1 = 'epic.model.FETCH_VISIT_PORTAL_MODEL';
const $9e1c20d78b49d5b9$export$cd1a8438490d4c7e = 'state.persisted.visit.portal.FETCH_VISIT_PORTAL_SUCCESS';
const $9e1c20d78b49d5b9$export$7d63bf92ff546bd4 = 'state.persisted.visit.portal.FETCH_VISIT_PORTAL_FAILURE';
const $9e1c20d78b49d5b9$export$10a878c7005ffa23 = 'state.ui.invited.sign.up.INVITED_SIGN_UP';
const $9e1c20d78b49d5b9$export$6bf64c2d60f7e63d = 'state.ui.invited.sign.up.INVITED_SIGN_UP_SUCCESS';
const $9e1c20d78b49d5b9$export$fc43f808dcbef187 = 'state.ui.invited.sign.up.INVITED_SIGN_UP_FAILURE';
const $9e1c20d78b49d5b9$export$6513e51a3bb59ea8 = (0, $cWsyg.buildModelsActionCreator)($9e1c20d78b49d5b9$export$5aa92ec48cad67e1, 'visitPortal');
const $9e1c20d78b49d5b9$export$fd6356a11ec803b4 = (visitPortalResponse)=>({
        type: $9e1c20d78b49d5b9$export$cd1a8438490d4c7e,
        payload: visitPortalResponse
    });
const $9e1c20d78b49d5b9$export$4807fff848ef2c1a = (error)=>({
        type: $9e1c20d78b49d5b9$export$7d63bf92ff546bd4,
        payload: {
            error: error
        }
    });
const $9e1c20d78b49d5b9$export$3693303625071052 = (portalId, email, fullName, password, token, username, contactAdminsFormEnabled, setPasswordJwt)=>({
        type: $9e1c20d78b49d5b9$export$10a878c7005ffa23,
        payload: {
            portalId: portalId,
            email: email,
            fullName: fullName,
            password: password,
            token: token,
            username: username,
            contactAdminsFormEnabled: contactAdminsFormEnabled,
            setPasswordJwt: setPasswordJwt
        }
    });
const $9e1c20d78b49d5b9$export$a2add4c6435cf561 = ()=>({
        type: $9e1c20d78b49d5b9$export$6bf64c2d60f7e63d
    });
const $9e1c20d78b49d5b9$export$7ae6305616bacef7 = (error)=>({
        type: $9e1c20d78b49d5b9$export$fc43f808dcbef187,
        payload: {
            error: error
        }
    });

});



parcelRegister("9WGLz", function(module, exports) {
$parcel$export(module.exports, "fetchLinkedSpacesEpic", () => $6c071e5bb44ff2c4$export$fe4c3219e901f34f);

var $fSYYZ = parcelRequire("fSYYZ");

var $l2qNm = parcelRequire("l2qNm");
parcelRequire("4q6WZ");
var $lgI4C = parcelRequire("lgI4C");

var $9ypa9 = parcelRequire("9ypa9");
const $6c071e5bb44ff2c4$export$fe4c3219e901f34f = (action$)=>action$.ofType((0, $lgI4C.FETCH_LINKED_SPACES)).mergeMap((action)=>{
        const { meta: meta } = action.payload;
        return (0, $l2qNm.fetchLinkedSpaces)().map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $lgI4C.fetchLinkedSpacesSuccess)(response.linkedSpaces.map((space)=>space.spaceKey));
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) {
                const failureEvent = meta.analyticsFailureEvent.update((payload)=>({
                        ...payload,
                        status: error.status
                    }));
                (0, $9ypa9.legacySendEvent)(failureEvent);
            }
            return (0, $fSYYZ.Observable).of((0, $lgI4C.fetchLinkedSpacesFailure)(error));
        });
    });

});
parcelRegister("l2qNm", function(module, exports) {
$parcel$export(module.exports, "fetchLinkedSpaces", () => $01f438f0810a4cfe$export$1999596e4ea30c16);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $jByYr = parcelRequire("jByYr");

var $6t9NN = parcelRequire("6t9NN");

var $9ypa9 = parcelRequire("9ypa9");
const $01f438f0810a4cfe$export$1999596e4ea30c16 = ()=>{
    const activationId = (0, $jByYr.getMeta)('activation-id');
    const uri = `${(0, $6t9NN.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/jsm-portal/linked-spaces`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        return response;
    }).catch((e)=>{
        (0, $9ypa9.trackError)('linked-spaces.fetch.failed', {}, e);
        return (0, $fSYYZ.Observable).throw(e);
    });
};

});

parcelRegister("4q6WZ", function(module, exports) {
$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => (parcelRequire("lgI4C")).FETCH_LINKED_SPACES);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_SUCCESS", () => (parcelRequire("lgI4C")).FETCH_LINKED_SPACES_SUCCESS);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => (parcelRequire("lgI4C")).FETCH_LINKED_SPACES_FAILURE);
$parcel$export(module.exports, "fetchLinkedSpaces", () => (parcelRequire("lgI4C")).fetchLinkedSpaces);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => (parcelRequire("lgI4C")).fetchLinkedSpacesSuccess);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => (parcelRequire("lgI4C")).fetchLinkedSpacesFailure);

var $lgI4C = parcelRequire("lgI4C");

});
parcelRegister("lgI4C", function(module, exports) {
$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => $7e1d6201585f608f$export$3d78263a729bb91);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_SUCCESS", () => $7e1d6201585f608f$export$55cd199355628b5a);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => $7e1d6201585f608f$export$9c186423b974805a);
$parcel$export(module.exports, "fetchLinkedSpaces", () => $7e1d6201585f608f$export$1999596e4ea30c16);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => $7e1d6201585f608f$export$ad2cc5272eef487);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => $7e1d6201585f608f$export$e63a5f7249c4e5d6);
const $7e1d6201585f608f$export$3d78263a729bb91 = 'state.actions.linked-spaces.FETCH_LINKED_SPACES';
const $7e1d6201585f608f$export$55cd199355628b5a = 'state.actions.linked-spaces.FETCH_LINKED_SPACES_SUCCESS';
const $7e1d6201585f608f$export$9c186423b974805a = 'state.actions.linked-spaces.FETCH_LINKED_SPACES_FAILURE';
const $7e1d6201585f608f$export$1999596e4ea30c16 = (meta)=>({
        type: $7e1d6201585f608f$export$3d78263a729bb91,
        payload: {
            meta: meta
        }
    });
const $7e1d6201585f608f$export$ad2cc5272eef487 = (linkedSpaces)=>({
        type: $7e1d6201585f608f$export$55cd199355628b5a,
        payload: {
            linkedSpaces: linkedSpaces
        }
    });
const $7e1d6201585f608f$export$e63a5f7249c4e5d6 = (error)=>({
        type: $7e1d6201585f608f$export$9c186423b974805a,
        payload: {
            error: error
        }
    });

});



parcelRegister("QNd0j", function(module, exports) {
$parcel$export(module.exports, "checkLoginActionEpic", () => $1821b72db06f960e$export$f1b0b99279015d5e);

var $bhOdO = parcelRequire("bhOdO");

var $fSYYZ = parcelRequire("fSYYZ");

var $9VNXn = parcelRequire("9VNXn");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");
parcelRequire("6aA8L");
var $jJMqu = parcelRequire("jJMqu");

var $g4UBb = parcelRequire("g4UBb");

var $2SUMn = parcelRequire("2SUMn");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");

var $7FSs7 = parcelRequire("7FSs7");

var $g1L0m = parcelRequire("g1L0m");

var $jsmb9 = parcelRequire("jsmb9");
const $1821b72db06f960e$export$f1b0b99279015d5e = (action$)=>{
    return action$.ofType((0, $uiV1X.CHECK_LOGIN_ACTION)).mergeMap((checkLoginActionAction)=>{
        const { email: email, portalId: portalId, authData: authData, createAnalyticsEvent: createAnalyticsEvent } = checkLoginActionAction.payload;
        return (0, $2SUMn.fetchAwsWafToken)(createAnalyticsEvent).mergeMap((token)=>(0, $9VNXn.checkLoginAction)({
                email: email,
                authData: authData,
                awsWafToken: token
            })).flatMap((response)=>{
            const autoInfo = $1821b72db06f960e$var$extractAuthInfoFromResponse(response);
            const trackEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'enteredEmailAndClickedNext',
                actionSubject: 'jsmPortalUnifiedLogin',
                attributes: {
                    accountStage: autoInfo.accountStage,
                    authMethodTypes: Array.from(autoInfo.authMethods.keys())
                }
            });
            trackEvent && (0, $9ypa9.legacySendEvent)(trackEvent);
            if (response.action === (0, $g1L0m.LoginType).CUSTOMER_ACCOUNT_SIGNUP) return (0, $fSYYZ.Observable).of((0, $jJMqu.setSignupDataAction)(email, autoInfo)).do(()=>{
                // Make sure we set the signup state first before doing the transition
                (0, $bhOdO.Scheduler).async.schedule(()=>{
                    (0, $7FSs7.default).push((0, $jsmb9.getSignupUrl)(portalId ? Number.parseInt(portalId, 10) : undefined));
                }, 0);
            });
            return (0, $fSYYZ.Observable).of((0, $uiV1X.checkLoginActionSuccess)(response.action, autoInfo));
        }).catch((error)=>{
            if ((0, $g4UBb.isSsoTestModeError)(error)) return (0, $fSYYZ.Observable).of((0, $uiV1X.caSsoTestModeFailure)());
            const parsedError = (0, $g4UBb.getDefaultCheckLoginError)(error);
            return (0, $fSYYZ.Observable).of((0, $uiV1X.checkLoginActionFailure)(parsedError));
        });
    });
};
const $1821b72db06f960e$var$getAccountStage = (action)=>{
    switch(action){
        case (0, $g1L0m.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $g1L0m.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
            return (0, $g1L0m.AccountStageType).SIGNUP;
        case (0, $g1L0m.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        case (0, $g1L0m.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
        default:
            return (0, $g1L0m.AccountStageType).LOGIN;
    }
};
const $1821b72db06f960e$var$extractAuthInfoFromResponse = (payload)=>{
    const { action: action, methods: methods } = payload;
    const stage = $1821b72db06f960e$var$getAccountStage(action);
    if (methods.length === 0) // add observable
    // cleanup entire part when FF is cleaned up - Jira ticket
    switch(action){
        case (0, $g1L0m.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
        case (0, $g1L0m.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
            return {
                accountStage: stage,
                authMethods: new Map([
                    [
                        (0, $g1L0m.AuthMethodType).ATLASSIAN_ACCOUNT_SSO,
                        {}
                    ]
                ])
            };
        case (0, $g1L0m.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $g1L0m.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        default:
            return {
                accountStage: stage,
                authMethods: new Map([
                    [
                        (0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ]
                ])
            };
    }
    switch(action){
        case (0, $g1L0m.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
        case (0, $g1L0m.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
            return {
                accountStage: stage,
                authMethods: new Map(methods.map((method)=>{
                    return [
                        (0, $g1L0m.AuthMethodType).ATLASSIAN_ACCOUNT_SSO,
                        {
                            redirectLink: method.authUrl
                        }
                    ];
                }))
            };
        case (0, $g1L0m.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $g1L0m.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        default:
            return {
                accountStage: stage,
                authMethods: new Map(methods.map((method)=>{
                    if (method.authType === 'SSO') return [
                        (0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_SSO,
                        {
                            redirectLink: method.authUrl
                        }
                    ];
                    return [
                        (0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ];
                }))
            };
    }
};

});
parcelRegister("9VNXn", function(module, exports) {
$parcel$export(module.exports, "LoginAttemptErrorType", () => $e152fe105faaa784$export$d265801d14b9cbd6);
$parcel$export(module.exports, "checkLoginAction", () => $e152fe105faaa784$export$a4840b835bebc845);
$parcel$export(module.exports, "forgotPassword", () => $e152fe105faaa784$export$66791fb2cfeec3e);
$parcel$export(module.exports, "createPassword", () => $e152fe105faaa784$export$2effc3102ad6a101);
$parcel$export(module.exports, "loginV2", () => $e152fe105faaa784$export$c5789ac087856ec0);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $1EFS8 = parcelRequire("1EFS8");

var $jjE9o = parcelRequire("jjE9o");

var $hrPHR = parcelRequire("hrPHR");

var $7FSs7 = parcelRequire("7FSs7");

var $6GNhI = parcelRequire("6GNhI");

var $lut7F = parcelRequire("lut7F");

var $jsmb9 = parcelRequire("jsmb9");
const $e152fe105faaa784$var$IDENTITY_LOGIN_RETRY_DELAY_MS = 500;
const $e152fe105faaa784$var$IDENTITY_LOGIN_MAX_RETRIES = 1;
const $e152fe105faaa784$var$isRetryableError = (status)=>{
    // Retry on 5xx server errors or network errors (status 0)
    return status >= 500 || status === 0;
};
const $e152fe105faaa784$var$delay = (ms)=>{
    return new (0, $fSYYZ.Observable)((subscriber)=>{
        const timeoutId = setTimeout(()=>{
            subscriber.next();
            subscriber.complete();
        }, ms);
        return ()=>clearTimeout(timeoutId);
    });
};
var $e152fe105faaa784$export$d265801d14b9cbd6 = /*#__PURE__*/ function(LoginAttemptErrorType) {
    LoginAttemptErrorType[LoginAttemptErrorType["INVALID_CREDENTIALS"] = 0] = "INVALID_CREDENTIALS";
    LoginAttemptErrorType[LoginAttemptErrorType["ACCOUNT_LOCKED_ERROR"] = 1] = "ACCOUNT_LOCKED_ERROR";
    LoginAttemptErrorType[LoginAttemptErrorType["MISC_LOGIN_ERROR"] = 2] = "MISC_LOGIN_ERROR";
    return LoginAttemptErrorType;
}({});
const $e152fe105faaa784$var$createOperationalPayload = (actionSubject, attributes)=>{
    return {
        attributes: attributes,
        actionSubject: actionSubject,
        action: 'login',
        source: 'unknownSource'
    };
};
const $e152fe105faaa784$export$a4840b835bebc845 = (params)=>{
    const { email: email, authData: authData, awsWafToken: awsWafToken, context: context = (0, $7FSs7.contextPath) } = params;
    const uri = `${context}/rest/servicedesk/customer-management/1/twosteplogin/action`;
    const body = JSON.stringify({
        email: email,
        ...authData
    });
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...awsWafToken ? {
            'x-aws-waf-token': `${awsWafToken}`
        } : {},
        ...(0, $1EFS8.default).getExperiment('bypass_jsm_two_step_login_waf_challenge_js').value.value ? {
            'atl-jsm-login-challenge-bypass': true
        } : {}
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};
const $e152fe105faaa784$export$66791fb2cfeec3e = (resetUrl, email, redirectUrl)=>{
    const uri = (0, $jsmb9.prependWithSlashIfAbsent)(resetUrl);
    const body = $e152fe105faaa784$var$createBodyForForgotPassword(email, redirectUrl);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $breWd.post)(uri, body, headers);
};
const $e152fe105faaa784$export$2effc3102ad6a101 = (resetUrl, email)=>{
    const uri = (0, $jsmb9.prependWithSlashIfAbsent)(resetUrl);
    const body = $e152fe105faaa784$var$createBodyForForgotPassword(email);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $breWd.post)(uri, body, headers);
};
const $e152fe105faaa784$var$createBodyForForgotPassword = (usernameOrEmail, redirectUrl)=>{
    return JSON.stringify({
        usernameOrEmail: usernameOrEmail,
        redirectUrl: redirectUrl
    });
};
const $e152fe105faaa784$var$responseKeyToErrorType = (loginPayload)=>{
    if (loginPayload) switch(loginPayload.key){
        case 'invalid-user-credentials':
            return 0;
        case 'blocked-user-credentials':
            return 1;
        default:
    }
    return 2;
};
const $e152fe105faaa784$export$4030e1d1ae5ebd69 = (ajaxError)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const ajaxResponse = ajaxError.response;
    if (ajaxError.status === 403) {
        const errorType = $e152fe105faaa784$var$responseKeyToErrorType(ajaxResponse);
        if (errorType === 2) (0, $lut7F.reportError)(ajaxError, {
            message: JSON.stringify(ajaxResponse)
        });
        return {
            loginSucceeded: false,
            error: {
                errorType: errorType
            }
        };
    }
    (0, $lut7F.reportError)(ajaxError, {
        message: JSON.stringify(ajaxResponse)
    });
    throw ajaxError;
};
const $e152fe105faaa784$export$abbe0c285917a9df = ()=>`${(0, $6GNhI.origin)()}${(0, $7FSs7.getBaseName)()}${(0, $jsmb9.getHelpCenterUrl)()}`;
const $e152fe105faaa784$export$f7ebdb13a3e88fec = (params)=>{
    const { email: email, password: password, context: context = (0, $7FSs7.contextPath) } = params;
    const continueParam = params.continueParam ? params.continueParam : $e152fe105faaa784$export$abbe0c285917a9df();
    const uri = `${context}/jsd-login-v2/v2/customer/login/authenticate?continue=${continueParam}`;
    const body = {
        email: email,
        password: password
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    const envWithEdition = (0, $hrPHR.getEnv)();
    const edition = envWithEdition.edition;
    const fireSuccessEvent = (ajaxResponse, retryCount)=>{
        (0, $jjE9o.operationalEvent)($e152fe105faaa784$var$createOperationalPayload('identity', {
            success: true,
            status: ajaxResponse.status.toString(),
            traceId: ajaxResponse.xhr.getResponseHeader('atl-traceid') || 'unknown',
            ...edition ? {
                edition: edition
            } : {},
            retryCount: `${retryCount}`
        }));
    };
    const fireErrorEvent = (ajaxError, retryCount)=>{
        const response = ajaxError.response;
        (0, $jjE9o.operationalEvent)($e152fe105faaa784$var$createOperationalPayload('identity', {
            success: false,
            status: ajaxError.status.toString(),
            errorKey: (response === null || response === void 0 ? void 0 : response.key) || 'unknown',
            errorMessage: typeof (response === null || response === void 0 ? void 0 : response.context) === 'object' && response.context ? response.context.errorDetail || 'unknown' : 'unknown',
            traceId: ajaxError.xhr.getResponseHeader('atl-traceid') || 'unknown',
            ...edition ? {
                edition: edition
            } : {},
            retryCount: `${retryCount}`
        }));
    };
    const makeRequest = (retryCount)=>{
        return (0, $breWd.post)(uri, body, headers).do((ajaxResponse)=>fireSuccessEvent(ajaxResponse, retryCount), (ajaxError)=>{
            if (retryCount >= $e152fe105faaa784$var$IDENTITY_LOGIN_MAX_RETRIES || !$e152fe105faaa784$var$isRetryableError(ajaxError.status)) fireErrorEvent(ajaxError, retryCount);
        }).map(()=>({
                loginSucceeded: true,
                error: null
            })).catch((ajaxError)=>{
            if (retryCount < $e152fe105faaa784$var$IDENTITY_LOGIN_MAX_RETRIES && $e152fe105faaa784$var$isRetryableError(ajaxError.status)) return $e152fe105faaa784$var$delay($e152fe105faaa784$var$IDENTITY_LOGIN_RETRY_DELAY_MS).switchMap(()=>makeRequest(retryCount + 1));
            return (0, $fSYYZ.Observable).of($e152fe105faaa784$export$4030e1d1ae5ebd69(ajaxError));
        });
    };
    return makeRequest(0);
};
const $e152fe105faaa784$export$c5789ac087856ec0 = (email, password, continueParam)=>{
    return $e152fe105faaa784$export$f7ebdb13a3e88fec({
        email: email,
        password: password,
        continueParam: continueParam
    });
};

});
parcelRegister("jsmb9", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER_URL", () => $8f889870be383521$export$5b56ffbd3ae3f811);
$parcel$export(module.exports, "getLoginUrl", () => $8f889870be383521$export$8abe2e83e8d74da2);
$parcel$export(module.exports, "getLoginUrlForPortalId", () => $8f889870be383521$export$2c3bf2ac72f35daf);
$parcel$export(module.exports, "getLoginUrlForPortalIdAsString", () => $8f889870be383521$export$cf0d2e77a068eb02);
$parcel$export(module.exports, "getSignupUrl", () => $8f889870be383521$export$61811316248f3423);
$parcel$export(module.exports, "getRedirectUrlOrLoginUrlIfNotLoggedIn", () => $8f889870be383521$export$e1ec45c36436315e);
$parcel$export(module.exports, "stripBasename", () => $8f889870be383521$export$b69e3301ce081aa3);
$parcel$export(module.exports, "getLoginUrlForTestMode", () => $8f889870be383521$export$538cfa4687a1dbf1);
$parcel$export(module.exports, "parseLoginSignupRedirectUrlParams", () => $8f889870be383521$export$63db7ca0fb70fb36);
$parcel$export(module.exports, "getManageAtlassianAccountUrl", () => $8f889870be383521$export$ad959f16b2c52bb0);
$parcel$export(module.exports, "getEditAccountPreferenceUrl", () => $8f889870be383521$export$aa7a50c8d9783676);
$parcel$export(module.exports, "getHelpCenterUrl", () => $8f889870be383521$export$bb97e50e9203cc1d);
$parcel$export(module.exports, "getLearnMoreUrl", () => $8f889870be383521$export$54cf7883df84f437);
$parcel$export(module.exports, "getPortalUrl", () => $8f889870be383521$export$8f6fdb27182bf17e);
$parcel$export(module.exports, "getPortalUrlWithPortalIdAsString", () => $8f889870be383521$export$46b08aeb2d28084e);
$parcel$export(module.exports, "prependWithSlashIfAbsent", () => $8f889870be383521$export$1d7449e2f82591f7);
$parcel$export(module.exports, "parseIssueKeyFromUrl", () => $8f889870be383521$export$286b4bf70293043b);
$parcel$export(module.exports, "getNextgenSettingsRequestTypesUrl", () => $8f889870be383521$export$289b05216208b30f);
$parcel$export(module.exports, "getPortalGroupSettingsUrl", () => $8f889870be383521$export$902d92fe4f764798);
$parcel$export(module.exports, "getRequestTypeSettingsUrl", () => $8f889870be383521$export$521ab03a93b5e8f0);
$parcel$export(module.exports, "isForThisJiraTenant", () => $8f889870be383521$export$7517f177d0bcebc3);
$parcel$export(module.exports, "getMyPendingApprovalsUrl", () => $8f889870be383521$export$b7fb861bceb68e9e);
$parcel$export(module.exports, "isTestModeRequested", () => $8f889870be383521$export$87980cf49820be56);
$parcel$export(module.exports, "getSsoTestModeParamFromUrl", () => $8f889870be383521$export$a992d459a03ed45d);
$parcel$export(module.exports, "convertAbsoluteUrlToRelativeUrl", () => $8f889870be383521$export$71e894c24943ddb2);
$parcel$export(module.exports, "getUpdatedDisplayLink", () => $8f889870be383521$export$1f8744d5447339dc);
$parcel$export(module.exports, "getUpdatedDisplayLinkForArticleSearch", () => $8f889870be383521$export$6c23a56732080745);
$parcel$export(module.exports, "getBillingUrl", () => $8f889870be383521$export$776b50dd35ff8711);
$parcel$export(module.exports, "formatTitleForUrl", () => $8f889870be383521$export$4ff2caca9bc551ab);
$parcel$export(module.exports, "getDefaultDestination", () => $8f889870be383521$export$3621fe01f0e72eb7);
$parcel$export(module.exports, "getContinueParam", () => $8f889870be383521$export$46b6a16917b33fad);
$parcel$export(module.exports, "getRedirectUrlForSignupAndResetPasswordRequestParam", () => $8f889870be383521$export$c20e132b33b4b975);

var $h1yZX = parcelRequire("h1yZX");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $7FSs7 = parcelRequire("7FSs7");

var $2Np0t = parcelRequire("2Np0t");

var $6GNhI = parcelRequire("6GNhI");

var $g1L0m = parcelRequire("g1L0m");
const $8f889870be383521$export$5b56ffbd3ae3f811 = (0, $gk18s.isAdvancedHelpCenter)() || (0, $gk18s.isUnifiedHelpHelpCenter)() || (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) ? '/' : '/portals';
const $8f889870be383521$var$ATLASSIAN_ACCOUNT_URL = 'https://id.atlassian.com';
const $8f889870be383521$var$ATLASSIAN_ACCOUNT_STG_URL = 'https://id.stg.internal.atlassian.com';
const $8f889870be383521$var$envToAtlassianAccountUrlMap = new Map([
    [
        (0, $hrPHR.EnvType).LOCAL,
        $8f889870be383521$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $hrPHR.EnvType).DEV,
        $8f889870be383521$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $hrPHR.EnvType).STAGING,
        $8f889870be383521$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $hrPHR.EnvType).PROD,
        $8f889870be383521$var$ATLASSIAN_ACCOUNT_URL
    ]
]);
const $8f889870be383521$export$8abe2e83e8d74da2 = (loginOptions)=>{
    return $8f889870be383521$var$internalGetLoginUrl(loginOptions.isAbsolute, loginOptions.portalId, loginOptions.redirectUrl);
};
const $8f889870be383521$export$2c3bf2ac72f35daf = (portalId)=>{
    return portalId ? `/portal/${portalId}/user/login${(0, $6GNhI.search)()}` : `/user/login${(0, $6GNhI.search)()}`;
};
const $8f889870be383521$export$cf0d2e77a068eb02 = (portalIdAsString)=>{
    return $8f889870be383521$export$2c3bf2ac72f35daf($8f889870be383521$var$stringToNumberOrUndefined(portalIdAsString));
};
const $8f889870be383521$export$61811316248f3423 = (portalId)=>{
    return portalId ? `/portal/${portalId}/user/signup${(0, $6GNhI.search)()}` : `/user/signup${(0, $6GNhI.search)()}`;
};
const $8f889870be383521$export$e1ec45c36436315e = (redirectToLogin, url, portalId)=>{
    const strippedUrl = $8f889870be383521$export$b69e3301ce081aa3(url);
    if (redirectToLogin) return $8f889870be383521$var$internalGetLoginUrl(false, portalId, strippedUrl);
    return strippedUrl;
};
const $8f889870be383521$var$internalGetLoginUrl = (isAbsolute, portalId, redirectUrl)=>{
    const pathUrl = portalId ? `portal/${portalId}/user/login` : 'user/login';
    const portalUrl = isAbsolute ? `${(0, $7FSs7.getBaseName)()}/${pathUrl}` : `/${pathUrl}`;
    if (redirectUrl) {
        // trim leading slash if it is present
        const url = redirectUrl.replace(/^\/+/g, '');
        return (0, $2Np0t.addParamsToUrl)(portalUrl, {
            destination: url
        });
    }
    return portalUrl;
};
const $8f889870be383521$export$538cfa4687a1dbf1 = (loginOptions)=>{
    return (0, $2Np0t.addParamsToUrl)($8f889870be383521$var$internalGetLoginUrl(loginOptions.isAbsolute, loginOptions.portalId, loginOptions.redirectUrl), {
        [(0, $g1L0m.QUERY_PARAM_SSO_TEST)]: 'true'
    });
};
const $8f889870be383521$export$63db7ca0fb70fb36 = ()=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const parsedSearchQuery = $h1yZX.parse((0, $6GNhI.search)());
    return {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        destination: parsedSearchQuery.destination,
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        isAbsolute: parsedSearchQuery.absolute === 'true'
    };
};
const $8f889870be383521$export$ad959f16b2c52bb0 = ()=>{
    const url = '/plugins/servlet/redirectToProfile';
    return (0, $2Np0t.addParamsToUrl)(url, {
        target: 'profile-visibility'
    });
};
const $8f889870be383521$export$aa7a50c8d9783676 = ()=>{
    const url = '/plugins/servlet/redirectToProfile';
    return (0, $2Np0t.addParamsToUrl)(url, {
        target: 'edit-preference'
    });
};
const $8f889870be383521$export$bb97e50e9203cc1d = ()=>{
    return $8f889870be383521$export$5b56ffbd3ae3f811;
};
const $8f889870be383521$export$54cf7883df84f437 = ()=>{
    var _envToAtlassianAccoun;
    return (_envToAtlassianAccoun = $8f889870be383521$var$envToAtlassianAccountUrlMap.get((0, $hrPHR.getEnv)().environment)) === null || _envToAtlassianAccoun === void 0 ? void 0 : _envToAtlassianAccoun.concat('/manage-profile/apps');
};
const $8f889870be383521$export$8f6fdb27182bf17e = (portalId)=>{
    if (portalId) return `/portal/${portalId}`;
    return $8f889870be383521$export$bb97e50e9203cc1d();
};
const $8f889870be383521$export$46b08aeb2d28084e = (portalId)=>{
    if (portalId) return `/portal/${portalId}`;
    return $8f889870be383521$export$bb97e50e9203cc1d();
};
const $8f889870be383521$export$b69e3301ce081aa3 = (url)=>{
    if (url) {
        const pos = url.indexOf((0, $7FSs7.getRelativeBasePath)());
        if (pos >= 0) return url.substring(pos + (0, $7FSs7.getRelativeBasePath)().length);
    }
    return url;
};
const $8f889870be383521$export$1ca0042661bee534 = (parameters)=>{
    const queryParameters = [
        `page=${parameters.page}`
    ];
    if (parameters.reporter) queryParameters.push(`reporter=${parameters.reporter}`);
    if (parameters.statuses) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    queryParameters.push(`statuses=${parameters.statuses}`);
    return `/user/requests?${queryParameters.join('&')}`;
};
const $8f889870be383521$export$1d7449e2f82591f7 = (toPrepend)=>{
    if (toPrepend.startsWith('/')) return toPrepend;
    return `/${toPrepend}`;
};
const $8f889870be383521$var$stringToNumberOrUndefined = (toConvert)=>toConvert === undefined ? undefined : Number(toConvert);
const $8f889870be383521$export$286b4bf70293043b = (url)=>{
    const jiraUrlMatch = `${(0, $6GNhI.origin)()}/browse/([A-Z][A-Z0-9_]+-\\d+)`;
    const portalUrlMatch = `${(0, $6GNhI.origin)()}${(0, $7FSs7.getRelativeBasePath)()}/portal/\\d+/([A-Z][A-Z0-9_]+-\\d+)`;
    const jiraMatch = url.match(jiraUrlMatch);
    if (jiraMatch) return jiraMatch[1];
    const portalMatch = url.match(portalUrlMatch);
    return portalMatch === null ? null : portalMatch[1];
};
// eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
const $8f889870be383521$var$getNextgenSettingsUrl = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/settings`;
const $8f889870be383521$export$718bab188935b069 = (projectKey)=>`${$8f889870be383521$var$getNextgenSettingsUrl(projectKey)}/language`;
const $8f889870be383521$export$289b05216208b30f = (projectKey)=>`${$8f889870be383521$var$getNextgenSettingsUrl(projectKey)}/issuetypes`;
const $8f889870be383521$export$c38761508d5f074d = (projectKey, requestTypeId)=>`${$8f889870be383521$export$289b05216208b30f(projectKey)}/${requestTypeId}`;
const $8f889870be383521$export$902d92fe4f764798 = (projectKey)=>`${$8f889870be383521$var$getNextgenSettingsUrl(projectKey)}/portal-settings/portal-groups`;
const $8f889870be383521$export$521ab03a93b5e8f0 = (projectKey, requestTypeId)=>`${$8f889870be383521$var$getNextgenSettingsUrl(projectKey)}/request-types/category/service-requests/request-type/${requestTypeId}/request-form`;
const $8f889870be383521$export$7517f177d0bcebc3 = (url, jiraBaseUrl)=>{
    return url.startsWith(jiraBaseUrl);
};
const $8f889870be383521$export$b7fb861bceb68e9e = ()=>{
    return `/user/approvals?approvalQueryType=myPending&page=1`;
};
const $8f889870be383521$export$87980cf49820be56 = (ssoTest)=>{
    return ssoTest === 'true';
};
const $8f889870be383521$export$a992d459a03ed45d = (params)=>{
    return params.get((0, $g1L0m.QUERY_PARAM_SSO_TEST)) === 'true';
};
const $8f889870be383521$export$a1cbf2de32a9fd1 = (url)=>{
    if (decodeURIComponent(url).startsWith('//')) return false;
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $8f889870be383521$export$71e894c24943ddb2 = (url)=>{
    if ($8f889870be383521$export$a1cbf2de32a9fd1(url)) return url.replace(`${new URL(url).origin}`, '') || '/';
    return url;
};
const $8f889870be383521$export$1f8744d5447339dc = (displayLink)=>{
    const isBasicHCRegex = /\/servicedesk\/customer\/.+/;
    if ((0, $gk18s.isAdvancedHelpCenter)() && isBasicHCRegex.test(displayLink) && !$8f889870be383521$export$a1cbf2de32a9fd1(displayLink)) return displayLink.replace('/servicedesk/customer/', '/');
    return displayLink;
};
const $8f889870be383521$export$6c23a56732080745 = (displayLink)=>{
    if ((0, $gk18s.isAdvancedHelpCenter)() && displayLink.includes('/servicedesk/customer/') && $8f889870be383521$export$a1cbf2de32a9fd1(displayLink)) return displayLink.replace(/.+\/servicedesk\/customer\//, `${(0, $7FSs7.getRelativeBasePath)()}/`);
    return displayLink;
};
const $8f889870be383521$var$ADMIN_STAGING_URL = 'http://admin.stg.atlassian.com';
const $8f889870be383521$var$ADMIN_PROD_URL = 'https://admin.atlassian.com';
const $8f889870be383521$export$1cfdf9a01e3f7773 = ()=>window.location.host.includes('-dev.com') ? false : true;
const $8f889870be383521$export$995f5f30765d3edb = $8f889870be383521$export$1cfdf9a01e3f7773() ? $8f889870be383521$var$ADMIN_PROD_URL : $8f889870be383521$var$ADMIN_STAGING_URL;
const $8f889870be383521$export$776b50dd35ff8711 = (products, cloudId)=>{
    const baseUrl = `${$8f889870be383521$export$995f5f30765d3edb}/s/${cloudId}`;
    return products.length === 1 ? `${baseUrl}/billing/applications/change-edition/${products[0]}.ondemand` : `${baseUrl}/billing-preview`;
};
const $8f889870be383521$export$4ff2caca9bc551ab = (title)=>{
    return title.trim().replace(/[^a-zA-Z0-9]+/g, '+').replace(/^(?:\++)|(?:\++)$/g, '');
};
const $8f889870be383521$export$3621fe01f0e72eb7 = (portalId)=>{
    if (portalId) return `portal/${portalId}`;
    return $8f889870be383521$export$bb97e50e9203cc1d().replace(/\//g, '');
};
const $8f889870be383521$export$46b6a16917b33fad = (portalId)=>{
    const { destination: destination, isAbsolute: isAbsolute } = $8f889870be383521$export$63db7ca0fb70fb36();
    const prefix = destination && isAbsolute ? '' : `${(0, $6GNhI.origin)()}${(0, $7FSs7.getBaseName)()}/`;
    const continueParam = `${prefix}${destination || $8f889870be383521$export$3621fe01f0e72eb7(portalId)}`;
    return `${continueParam}`;
};
const $8f889870be383521$export$c20e132b33b4b975 = (baseUrl)=>{
    const { destination: destination } = $8f889870be383521$export$63db7ca0fb70fb36();
    if (destination && ($8f889870be383521$export$7517f177d0bcebc3(destination, baseUrl) || !$8f889870be383521$export$a1cbf2de32a9fd1(destination))) return destination;
    return undefined;
};

});
parcelRegister("g1L0m", function(module, exports) {
$parcel$export(module.exports, "AccountStageType", () => $f5dfbf516d24f26c$export$fcf6b116730276db);
$parcel$export(module.exports, "AuthMethodType", () => $f5dfbf516d24f26c$export$ccd4174b7ee5aaf9);
$parcel$export(module.exports, "LoginType", () => $f5dfbf516d24f26c$export$7ecae1a0f094da22);
$parcel$export(module.exports, "QUERY_PARAM_SSO_TEST", () => $f5dfbf516d24f26c$export$491b9d320a651537);
// eslint-disable-next-line no-shadow
var $f5dfbf516d24f26c$export$fcf6b116730276db = /*#__PURE__*/ function(AccountStageType) {
    AccountStageType["LOGIN"] = "LOGIN";
    AccountStageType["SIGNUP"] = "SIGNUP";
    return AccountStageType;
}({});
var $f5dfbf516d24f26c$export$ccd4174b7ee5aaf9 = /*#__PURE__*/ function(AuthMethodType) {
    AuthMethodType["CUSTOMER_ACCOUNT_PASSWORD"] = "CUSTOMER_ACCOUNT_PASSWORD";
    AuthMethodType["CUSTOMER_ACCOUNT_SSO"] = "CUSTOMER_ACCOUNT_SSO";
    AuthMethodType["ATLASSIAN_ACCOUNT_SSO"] = "ATLASSIAN_ACCOUNT_SSO";
    return AuthMethodType;
}({});
var $f5dfbf516d24f26c$export$7ecae1a0f094da22 = /*#__PURE__*/ function(LoginType) {
    LoginType["ATLASSIAN_ACCOUNT_LOGIN"] = "atlassian.account.login";
    LoginType["ATLASSIAN_ACCOUNT_SIGNUP"] = "atlassian.account.signup";
    LoginType["CUSTOMER_ACCOUNT_LOGIN"] = "customer.account.login";
    LoginType["CUSTOMER_ACCOUNT_SIGNUP"] = "customer.account.signup";
    return LoginType;
}({});
const $f5dfbf516d24f26c$export$491b9d320a651537 = 'sso_test';

});



parcelRegister("6aA8L", function(module, exports) {
$parcel$export(module.exports, "enableResendValidationEmailLink", () => (parcelRequire("jJMqu")).enableResendValidationEmailLink);
$parcel$export(module.exports, "resendValidationEmail", () => (parcelRequire("jJMqu")).resendValidationEmail);
$parcel$export(module.exports, "resendValidationEmailSuccess", () => (parcelRequire("jJMqu")).resendValidationEmailSuccess);
$parcel$export(module.exports, "resendValidationEmailFailure", () => (parcelRequire("jJMqu")).resendValidationEmailFailure);
$parcel$export(module.exports, "setSignupDataAction", () => (parcelRequire("jJMqu")).setSignupDataAction);
$parcel$export(module.exports, "ENABLE_RESEND_VALIDATION_EMAIL_LINK", () => (parcelRequire("jJMqu")).ENABLE_RESEND_VALIDATION_EMAIL_LINK);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL", () => (parcelRequire("jJMqu")).RESEND_VALIDATION_EMAIL);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_SUCCESS", () => (parcelRequire("jJMqu")).RESEND_VALIDATION_EMAIL_SUCCESS);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_FAILURE", () => (parcelRequire("jJMqu")).RESEND_VALIDATION_EMAIL_FAILURE);
$parcel$export(module.exports, "SET_SIGN_UP_DATA", () => (parcelRequire("jJMqu")).SET_SIGN_UP_DATA);

var $jJMqu = parcelRequire("jJMqu");

});
parcelRegister("jJMqu", function(module, exports) {
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL", () => $7da640014b030238$export$9186eb7b1196909f);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_SUCCESS", () => $7da640014b030238$export$54095a5808d614c5);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_FAILURE", () => $7da640014b030238$export$bb70263db5ecc48f);
$parcel$export(module.exports, "ENABLE_RESEND_VALIDATION_EMAIL_LINK", () => $7da640014b030238$export$1f3acfffff4b90ca);
$parcel$export(module.exports, "SET_SIGN_UP_DATA", () => $7da640014b030238$export$b5da7c907fc7ff71);
$parcel$export(module.exports, "resendValidationEmail", () => $7da640014b030238$export$b53bc6c531462e2c);
$parcel$export(module.exports, "resendValidationEmailSuccess", () => $7da640014b030238$export$5e093ceac56a577c);
$parcel$export(module.exports, "resendValidationEmailFailure", () => $7da640014b030238$export$49a7f6865c86a52a);
$parcel$export(module.exports, "enableResendValidationEmailLink", () => $7da640014b030238$export$bfd31929fb03dc3a);
$parcel$export(module.exports, "setSignupDataAction", () => $7da640014b030238$export$b9b1c14c91a0ee7a);
const $7da640014b030238$export$9186eb7b1196909f = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL';
const $7da640014b030238$export$54095a5808d614c5 = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL_SUCCESS';
const $7da640014b030238$export$bb70263db5ecc48f = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL_FAILURE';
const $7da640014b030238$export$1f3acfffff4b90ca = 'epic.persisted.signup.ENABLE_RESEND_VALIDATION_EMAIL_LINK';
const $7da640014b030238$export$b5da7c907fc7ff71 = 'epic.persisted.signup.SET_SIGN_UP_DATA';
const $7da640014b030238$export$b53bc6c531462e2c = (email, portalId, redirectUrl)=>({
        type: $7da640014b030238$export$9186eb7b1196909f,
        payload: {
            email: email,
            portalId: portalId,
            redirectUrl: redirectUrl
        }
    });
const $7da640014b030238$export$5e093ceac56a577c = ()=>({
        type: $7da640014b030238$export$54095a5808d614c5
    });
const $7da640014b030238$export$49a7f6865c86a52a = ()=>({
        type: $7da640014b030238$export$bb70263db5ecc48f
    });
const $7da640014b030238$export$bfd31929fb03dc3a = ()=>({
        type: $7da640014b030238$export$1f3acfffff4b90ca
    });
const $7da640014b030238$export$b9b1c14c91a0ee7a = (email, authInfo)=>({
        type: $7da640014b030238$export$b5da7c907fc7ff71,
        payload: {
            email: email,
            authInfo: authInfo
        }
    });

});


parcelRegister("2SUMn", function(module, exports) {
$parcel$export(module.exports, "fetchAwsWafToken", () => $defd6c858906c795$export$408b4a82d889c63b);

var $fSYYZ = parcelRequire("fSYYZ");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");
const $defd6c858906c795$export$408b4a82d889c63b = (createAnalyticsEvent)=>{
    try {
        if (typeof AwsWafIntegration !== 'undefined' && typeof AwsWafIntegration.getToken === 'function') return (0, $fSYYZ.Observable).from(AwsWafIntegration.getToken());
        $defd6c858906c795$var$sendFailToFetchWafTokenEvent("js.not.load", createAnalyticsEvent);
        return (0, $fSYYZ.Observable).of(undefined);
    } catch (error) {
        $defd6c858906c795$var$sendFailToFetchWafTokenEvent("unknown.error", createAnalyticsEvent);
        return (0, $fSYYZ.Observable).of(undefined);
    }
};
const $defd6c858906c795$var$sendFailToFetchWafTokenEvent = (failureType, createAnalyticsEvent)=>{
    const trackEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
        analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
        action: 'failed',
        actionSubject: 'fetchWafToken',
        attributes: {
            failureType: failureType
        }
    });
    trackEvent && (0, $9ypa9.legacySendEvent)(trackEvent);
};

});


parcelRegister("hIQoN", function(module, exports) {
$parcel$export(module.exports, "createPasswordEpic", () => $aace22f788c6e6a0$export$4f23d4ad55796890);

var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $9VNXn = parcelRequire("9VNXn");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");
const $aace22f788c6e6a0$export$4f23d4ad55796890 = (action$)=>{
    return action$.ofType((0, $uiV1X.CREATE_PASSWORD)).mergeMap((createPasswordAction)=>{
        const { resetUrl: resetUrl, email: email } = createPasswordAction.payload;
        return (0, $9VNXn.createPassword)(resetUrl, email).map(()=>{
            return (0, $uiV1X.createPasswordSuccess)();
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error));
        });
    });
};

});

parcelRegister("89KLv", function(module, exports) {
$parcel$export(module.exports, "exitTestModeEpic", () => $3430fc57e6502884$export$2da1b652de0f5c38);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");

var $7FSs7 = parcelRequire("7FSs7");

var $jsmb9 = parcelRequire("jsmb9");

var $87wgP = parcelRequire("87wgP");
const $3430fc57e6502884$export$2da1b652de0f5c38 = (action$)=>{
    return action$.ofType((0, $uiV1X.EXIT_TEST_MODE_ACTION)).mergeMap((exitTestModeAction)=>{
        const { email: email } = exitTestModeAction.payload;
        return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $uiV1X.resetLogin)(email)), (0, $fSYYZ.Observable).of((0, $6p5HB.showSuccessFlag)((0, $87wgP.default).exitTestModeSuccessFlagTitle, undefined, (0, $87wgP.default).exitTestModeSuccessFlagDescription, undefined, {
            emailAddress: email
        }))).do(()=>{
            (0, $7FSs7.default).push((0, $jsmb9.getLoginUrl)({
                isAbsolute: false,
                portalId: undefined
            }));
        });
    });
};

});
parcelRegister("87wgP", function(module, exports) {
$parcel$export(module.exports, "default", () => $39bea0a9133f1a04$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $39bea0a9133f1a04$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    exitTestModeSuccessFlagTitle: {
        defaultMessage: "You\u2019re out of single sign-on test mode",
        description: 'Message title for toast flag when the exit testMode action is successful.',
        id: 'cv.login.exit.test.mode.success.flag.title'
    },
    exitTestModeSuccessFlagDescription: {
        defaultMessage: 'Go to the Authentication page in your Jira settings to enable single sign-on for customers.',
        description: 'Message description for toast flag when the exit testMode action is successful.',
        id: 'cv.login.exit.test.mode.success.flag.description'
    }
});

});


parcelRegister("2zcfw", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $3ec2231b5b599dac$export$cb36b6e8b9a45314);

var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $9VNXn = parcelRequire("9VNXn");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");
const $3ec2231b5b599dac$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $uiV1X.FORGOT_PASSWORD)).mergeMap((forgotPasswordAction)=>{
        const { resetUrl: resetUrl, email: email, redirectUrl: redirectUrl } = forgotPasswordAction.payload;
        return (0, $9VNXn.forgotPassword)(resetUrl, email, redirectUrl).map(()=>{
            return (0, $uiV1X.forgotPasswordSuccess)();
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error));
        });
    });
};

});

parcelRegister("bsMZz", function(module, exports) {
$parcel$export(module.exports, "loginEpic", () => $49e33a0412527b91$export$da8045e9cad7ec9b);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $9VNXn = parcelRequire("9VNXn");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");
parcelRequire("6Fjys");
var $8ICBx = parcelRequire("8ICBx");

var $g4UBb = parcelRequire("g4UBb");
const $49e33a0412527b91$export$da8045e9cad7ec9b = (action$)=>{
    return action$.ofType((0, $uiV1X.LOGIN_ATTEMPT)).mergeMap((loginAction)=>{
        const { email: email, password: password, continueParam: continueParam } = loginAction.payload;
        const loginResponse = (0, $9VNXn.loginV2)(email, password, continueParam);
        return loginResponse.flatMap((response)=>{
            if (response.loginSucceeded) return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $uiV1X.loginAttemptSuccess)(response)), (0, $fSYYZ.Observable).of((0, $8ICBx.successfullyLoggedIn)()));
            return (0, $fSYYZ.Observable).of((0, $uiV1X.loginAttemptSuccess)(response));
        }).catch((error)=>{
            const parsedError = (0, $g4UBb.getDefaultError)(error);
            return (0, $fSYYZ.Observable).of((0, $uiV1X.loginAttemptFailure)(parsedError));
        });
    });
};

});

parcelRegister("4IszM", function(module, exports) {
$parcel$export(module.exports, "updateLoginAnnouncementsEpic", () => $f376dd670dc07e78$export$2bd3c7829bd01a9c);

var $8rTkC = parcelRequire("8rTkC");

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");
parcelRequire("71T39");
var $8WXPf = parcelRequire("8WXPf");

var $e4PJI = parcelRequire("e4PJI");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");

var $iIR14 = parcelRequire("iIR14");

var $e2yrc = parcelRequire("e2yrc");
const $f376dd670dc07e78$var$gqlMutationLoginAnnouncements = (action)=>{
    var _inputVariables$input, _inputVariables$input2;
    const { meta: meta, payload: payload } = action;
    const inputVariables = (0, $iIR14.mapLoginAnnouncementsPayloadToGqlInput)(payload);
    if (!((_inputVariables$input = inputVariables.input.nameTranslations) !== null && _inputVariables$input !== void 0 && _inputVariables$input.every((translation)=>translation.locale)) || !((_inputVariables$input2 = inputVariables.input.descriptionTranslations) !== null && _inputVariables$input2 !== void 0 && _inputVariables$input2.every((translation)=>translation.locale))) {
        // making sure that empty locale is not sent to the server
        const errorResponse = {
            status: (0, $8rTkC.HTTP).BAD_REQUEST
        };
        return (0, $fSYYZ.Observable).from(Promise.reject(errorResponse)).catch((error)=>{
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $8WXPf.updateLoginAnnouncementsFailure)(errorResponse)), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error)));
        });
    }
    return (0, $fSYYZ.Observable).from((0, $iIR14.updateLoginAnnouncementsData)(inputVariables).then((response)=>{
        var _response$helpCenter, _response$helpCenter2, _response$helpCenter3;
        if ((_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateLoginAnnouncement) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) // incase of mutation success, we get success as true and no errors
        return true;
        // we get success as false and errors in case of mutation failure
        const errorResponse = {
            errorMessages: ((_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.updateLoginAnnouncement) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.errors) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.map((error)=>error.message ?? '')) ?? [],
            status: ((_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.updateLoginAnnouncement) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.errors) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3[0]) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.extensions) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.statusCode) ?? (0, $8rTkC.HTTP).SERVER
        };
        return Promise.reject(errorResponse);
    })).flatMap(()=>{
        if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $e4PJI.updateLoginAnnouncementSideBarExperience).success();
        // unlink model mutation call, we do not get login announcements in response, hence using payload to call updateLoginAnnouncementsSuccess
        return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $8WXPf.updateLoginAnnouncementsSuccess)(payload)), (0, $fSYYZ.Observable).of((0, $8WXPf.resetLoginAnnouncements)()));
    }).catch((error)=>{
        if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $fonw6.isNetworkOrClientErrorCode)(error.status)) (0, $9ypa9.legacySendEvent)((0, $e2yrc.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
        if (!(0, $fonw6.isNetworkOrClientErrorCode)(error.status)) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $e4PJI.updateLoginAnnouncementSideBarExperience).failure({
            metadata: {
                error: error.message
            }
        });
        else // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $e4PJI.updateLoginAnnouncementSideBarExperience).success();
        // we are mapping the error, because mutation error in not always in form of AjaxError
        const errorResponse = {
            ...error,
            errorMessages: [
                error.message
            ],
            status: error.status ?? (0, $8rTkC.HTTP).SERVER
        };
        return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $8WXPf.updateLoginAnnouncementsFailure)(errorResponse)), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(errorResponse)));
    });
};
const $f376dd670dc07e78$export$2bd3c7829bd01a9c = (action$)=>{
    return action$.ofType((0, $8WXPf.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL)).mergeMap((action)=>{
        return $f376dd670dc07e78$var$gqlMutationLoginAnnouncements(action);
    });
};

});
parcelRegister("71T39", function(module, exports) {
$parcel$export(module.exports, "fetchLoginAnnouncementModel", () => (parcelRequire("8WXPf")).fetchLoginAnnouncementModel);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS", () => (parcelRequire("8WXPf")).FETCH_LOGIN_ANNOUNCEMENTS);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS", () => (parcelRequire("8WXPf")).FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_FAILURE", () => (parcelRequire("8WXPf")).FETCH_LOGIN_ANNOUNCEMENTS_FAILURE);
$parcel$export(module.exports, "fetchLoginAnnouncementsSuccess", () => (parcelRequire("8WXPf")).fetchLoginAnnouncementsSuccess);
$parcel$export(module.exports, "fetchLoginAnnouncementsFailure", () => (parcelRequire("8WXPf")).fetchLoginAnnouncementsFailure);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_MODEL", () => (parcelRequire("8WXPf")).UPDATE_LOGIN_ANNOUNCEMENTS_MODEL);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS", () => (parcelRequire("8WXPf")).UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE", () => (parcelRequire("8WXPf")).UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE", () => (parcelRequire("8WXPf")).UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE);
$parcel$export(module.exports, "RESET_LOGIN_ANNOUNCEMENTS", () => (parcelRequire("8WXPf")).RESET_LOGIN_ANNOUNCEMENTS);
$parcel$export(module.exports, "updateLoginAnnouncementsModel", () => (parcelRequire("8WXPf")).updateLoginAnnouncementsModel);
$parcel$export(module.exports, "updateLoginAnnouncementsSuccess", () => (parcelRequire("8WXPf")).updateLoginAnnouncementsSuccess);
$parcel$export(module.exports, "updateLoginAnnouncementsFailure", () => (parcelRequire("8WXPf")).updateLoginAnnouncementsFailure);
$parcel$export(module.exports, "updateLoginAnnouncementsUIState", () => (parcelRequire("8WXPf")).updateLoginAnnouncementsUIState);
$parcel$export(module.exports, "resetLoginAnnouncements", () => (parcelRequire("8WXPf")).resetLoginAnnouncements);

var $8WXPf = parcelRequire("8WXPf");

});
parcelRegister("8WXPf", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS", () => $446f044bc1404a83$export$dc62bc08b47f80d);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS", () => $446f044bc1404a83$export$b975358f73425401);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_FAILURE", () => $446f044bc1404a83$export$182afe1fbca9c1ad);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_MODEL", () => $446f044bc1404a83$export$ebcd8b9795616937);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE", () => $446f044bc1404a83$export$85451866d84a5811);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS", () => $446f044bc1404a83$export$bca8bb13b9278354);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE", () => $446f044bc1404a83$export$12b5ff9da9aaaa28);
$parcel$export(module.exports, "RESET_LOGIN_ANNOUNCEMENTS", () => $446f044bc1404a83$export$2ef132370a38839c);
$parcel$export(module.exports, "fetchLoginAnnouncementModel", () => $446f044bc1404a83$export$2510bc335620bfa4);
$parcel$export(module.exports, "fetchLoginAnnouncementsSuccess", () => $446f044bc1404a83$export$66b083401f2dd420);
$parcel$export(module.exports, "fetchLoginAnnouncementsFailure", () => $446f044bc1404a83$export$b7ec07a46de8ffd1);
$parcel$export(module.exports, "updateLoginAnnouncementsModel", () => $446f044bc1404a83$export$c139274c332846b7);
$parcel$export(module.exports, "updateLoginAnnouncementsSuccess", () => $446f044bc1404a83$export$1723ccec0130d524);
$parcel$export(module.exports, "updateLoginAnnouncementsFailure", () => $446f044bc1404a83$export$682d06bd9eef1572);
$parcel$export(module.exports, "updateLoginAnnouncementsUIState", () => $446f044bc1404a83$export$5b3b63a7f806c6d8);
$parcel$export(module.exports, "resetLoginAnnouncements", () => $446f044bc1404a83$export$c992a3f94eef7527);

var $cWsyg = parcelRequire("cWsyg");
const $446f044bc1404a83$export$dc62bc08b47f80d = 'epic.model.FETCH_LOGIN_ANNOUNCEMENTS';
const $446f044bc1404a83$export$b975358f73425401 = 'state.persisted.loginAnnouncements.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS';
const $446f044bc1404a83$export$182afe1fbca9c1ad = 'state.persisted.loginAnnouncements.FETCH_LOGIN_ANNOUNCEMENTS_FAILURE';
const $446f044bc1404a83$export$ebcd8b9795616937 = 'epic.login-announcements.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL';
const $446f044bc1404a83$export$85451866d84a5811 = 'state.ui.login-announcements.UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE';
const $446f044bc1404a83$export$bca8bb13b9278354 = 'state.persisted.loginAnnouncements.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS';
const $446f044bc1404a83$export$12b5ff9da9aaaa28 = 'state.persisted.loginAnnouncements.UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE';
const $446f044bc1404a83$export$2ef132370a38839c = 'state.ui.loginAnnouncements.RESET_LOGIN_ANNOUNCEMENTS';
const $446f044bc1404a83$export$2510bc335620bfa4 = (0, $cWsyg.buildModelsActionCreator)($446f044bc1404a83$export$dc62bc08b47f80d, 'loginAnnouncements');
const $446f044bc1404a83$export$66b083401f2dd420 = (loginAnnouncementsModel)=>({
        type: $446f044bc1404a83$export$b975358f73425401,
        payload: loginAnnouncementsModel
    });
const $446f044bc1404a83$export$b7ec07a46de8ffd1 = (error)=>({
        type: $446f044bc1404a83$export$182afe1fbca9c1ad,
        payload: {
            error: error
        }
    });
const $446f044bc1404a83$export$c139274c332846b7 = (loginAnnouncementsModel, meta)=>({
        meta: meta,
        type: $446f044bc1404a83$export$ebcd8b9795616937,
        payload: loginAnnouncementsModel
    });
const $446f044bc1404a83$export$1723ccec0130d524 = (loginAnnouncementsModel)=>({
        type: $446f044bc1404a83$export$bca8bb13b9278354,
        payload: loginAnnouncementsModel
    });
const $446f044bc1404a83$export$682d06bd9eef1572 = (error)=>({
        type: $446f044bc1404a83$export$12b5ff9da9aaaa28,
        payload: {
            error: error
        }
    });
const $446f044bc1404a83$export$5b3b63a7f806c6d8 = (loginAnnouncementsModel)=>({
        type: $446f044bc1404a83$export$85451866d84a5811,
        payload: loginAnnouncementsModel
    });
const $446f044bc1404a83$export$c992a3f94eef7527 = ()=>({
        type: $446f044bc1404a83$export$2ef132370a38839c
    });

});


parcelRegister("iIR14", function(module, exports) {
$parcel$export(module.exports, "updateLoginAnnouncementsData", () => $a5f25a247ceaa843$export$40a99b486fb0f5fd);
$parcel$export(module.exports, "mapLoginAnnouncementsPayloadToGqlInput", () => $a5f25a247ceaa843$export$85e7a57e62ad0fbc);

var $7H9aq = parcelRequire("7H9aq");

var $8iTFq = parcelRequire("8iTFq");

var $jByYr = parcelRequire("jByYr");

var $gyskF = parcelRequire("gyskF");
const $a5f25a247ceaa843$export$40a99b486fb0f5fd = (variables)=>{
    return new Promise((resolve, reject)=>{
        (0, $8iTFq.commitMutation)((0, $gyskF.getRelayEnvironment)(), {
            variables: variables,
            mutation: (0, $7H9aq.default),
            onCompleted: (response)=>{
                resolve(response);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
};
const $a5f25a247ceaa843$export$85e7a57e62ad0fbc = (payload)=>{
    const nameTranslations = [];
    const descriptionTranslations = [];
    // map payload to gql input
    Object.keys(payload.translatedLogInAnnouncements).forEach((locale)=>{
        nameTranslations.push({
            locale: locale,
            value: payload.translatedLogInAnnouncements[locale].header
        });
        descriptionTranslations.push({
            locale: locale,
            value: payload.translatedLogInAnnouncements[locale].message
        });
    });
    return {
        cloudId: (0, $jByYr.getCloudId)(),
        input: {
            nameTranslations: nameTranslations,
            descriptionTranslations: descriptionTranslations,
            helpCenterAri: (0, $jByYr.getHelpCenterAri)(),
            descriptionType: 'WIKI_MARKUP'
        }
    };
};

});
parcelRegister("7H9aq", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc1feda1b51d9e06$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a43a0b0a9899057b05221c5b213a09fa>>
 * @relayHash d08d5aad8dde8629cc060f7256c65f6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12622079dcdaf3db5d698493bb7d1443dbaf69551d80a2467f5a3d4c6a9a666c
const $fc1feda1b51d9e06$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterAnnouncementUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateLoginAnnouncement",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterAnnouncementUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateLoginAnnouncement",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12622079dcdaf3db5d698493bb7d1443dbaf69551d80a2467f5a3d4c6a9a666c",
            "metadata": {},
            "name": "loginAnnouncementsUpdateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$fc1feda1b51d9e06$var$node.hash = "a5dd7f4861ac93d9b41cc3104b2a0e6a";
var $fc1feda1b51d9e06$export$2e2bcd8739ae039 = $fc1feda1b51d9e06$var$node;

});



parcelRegister("d7Bhl", function(module, exports) {
$parcel$export(module.exports, "loginConsentEpic", () => $4660f08dfdab9ca2$export$90c588d343cf5f98);

var $fSYYZ = parcelRequire("fSYYZ");

var $hAX97 = parcelRequire("hAX97");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");
parcelRequire("9WXhk");
var $jrh30 = parcelRequire("jrh30");

var $7FSs7 = parcelRequire("7FSs7");

var $6GNhI = parcelRequire("6GNhI");

var $jsmb9 = parcelRequire("jsmb9");
const $4660f08dfdab9ca2$export$90c588d343cf5f98 = (action$)=>{
    return action$.ofType((0, $jrh30.LOGIN_CONSENT)).mergeMap((action)=>{
        const { param: param } = action.payload;
        return (0, $hAX97.loginConsent)(param).mergeMap(({ response: response })=>{
            (0, $6GNhI.replace)(response.uri);
            return (0, $fSYYZ.Observable).empty();
        }).catch(()=>{
            (0, $7FSs7.default).push((0, $jsmb9.getLoginUrl)({
                isAbsolute: false,
                portalId: undefined
            }));
            return (0, $fSYYZ.Observable).of((0, $uiV1X.loginConsentFailure)());
        });
    });
};

});
parcelRegister("hAX97", function(module, exports) {
$parcel$export(module.exports, "loginConsent", () => $6dccd274ffe3f434$export$fd88d7fe0deeba34);

var $breWd = parcelRequire("breWd");
const $6dccd274ffe3f434$export$fd88d7fe0deeba34 = (param)=>{
    const uri = `/jsd-login-v2/v2/customer/login/fedramp/consent${param}`;
    const body = {
        fedrampConsent: 'provided'
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $breWd.post)(uri, body, headers);
};

});

parcelRegister("9WXhk", function(module, exports) {
$parcel$export(module.exports, "loginConsentAction", () => (parcelRequire("jrh30")).loginConsentAction);
$parcel$export(module.exports, "LOGIN_CONSENT", () => (parcelRequire("jrh30")).LOGIN_CONSENT);

var $jrh30 = parcelRequire("jrh30");

});
parcelRegister("jrh30", function(module, exports) {
$parcel$export(module.exports, "LOGIN_CONSENT", () => $3ed435c2134e9cd5$export$12110c14f93a926f);
$parcel$export(module.exports, "loginConsentAction", () => $3ed435c2134e9cd5$export$684d17f74d8831a7);
const $3ed435c2134e9cd5$export$12110c14f93a926f = 'state.ui.LOGIN_CONSENT';
const $3ed435c2134e9cd5$export$684d17f74d8831a7 = (param)=>{
    return {
        payload: {
            param: param
        },
        type: $3ed435c2134e9cd5$export$12110c14f93a926f
    };
};

});



parcelRegister("cUiSx", function(module, exports) {
$parcel$export(module.exports, "logOutEpic", () => $8900358bf13848a6$export$c4456f69976aae9b);

var $fSYYZ = parcelRequire("fSYYZ");

var $gpIaW = parcelRequire("gpIaW");
parcelRequire("2tsrb");
var $7IL12 = parcelRequire("7IL12");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $9ypa9 = parcelRequire("9ypa9");

var $7FSs7 = parcelRequire("7FSs7");

var $hmGtR = parcelRequire("hmGtR");

var $6GNhI = parcelRequire("6GNhI");

var $jsmb9 = parcelRequire("jsmb9");

var $dMQwV = parcelRequire("dMQwV");
const $8900358bf13848a6$var$AA_LOGOUT_REDIRECT_URL = `/logout?dest-url=${encodeURIComponent(`${(0, $7FSs7.getRelativeBasePath)()}${(0, $jsmb9.getHelpCenterUrl)()}`)}`;
const $8900358bf13848a6$export$8931338e80b3349d = (state)=>{
    if ((0, $hx8zX.isAtlassianAccountManaged)(state)) // no need to call Jira to log out Atlassian accounts. Simply redirect to AA logout page
    return (0, $fSYYZ.Observable).of({
        logoutRedirectUrl: $8900358bf13848a6$var$AA_LOGOUT_REDIRECT_URL
    });
    return (0, $gpIaW.logoutUsingIdentity)(`${(0, $8Wisn.getBaseUrl)(state)}${$8900358bf13848a6$var$getAfterLogoutUrl(state)}`);
};
const $8900358bf13848a6$export$c4456f69976aae9b = (action$, store)=>{
    return action$.ofType((0, $dMQwV.LOG_OUT)).mergeMap(()=>{
        const state = store.getState();
        // Removing cached response of help-seeker-type on logout
        (0, $hmGtR.removeLocalStorageItem)('help-seeker-type');
        return $8900358bf13848a6$export$8931338e80b3349d(state).mergeMap((response)=>{
            // We do a full page load to the login or help center page to clear out the redux store and avoid
            // data for one user being seen by another if one logs out and another logs in in the same tab
            (0, $6GNhI.assign)($8900358bf13848a6$var$getLogoutDestination(state, response));
            return (0, $fSYYZ.Observable).empty();
        }).catch((error)=>{
            return $8900358bf13848a6$var$handleLogoutError(error);
        });
    });
};
function $8900358bf13848a6$var$handleLogoutError(error) {
    (0, $9ypa9.trackError)('session.logout.failed', {}, error);
    (0, $6GNhI.reload)();
    return (0, $fSYYZ.Observable).empty();
}
function $8900358bf13848a6$var$getAfterLogoutUrl(state) {
    if ((0, $8Wisn.getIsAnonymousEnabled)(state)) return (0, $jsmb9.getHelpCenterUrl)();
    return (0, $jsmb9.getLoginUrlForPortalId)((0, $7IL12.getPortalId)(state));
}
function $8900358bf13848a6$var$getLogoutDestination(state, logoutResponseBody) {
    if (logoutResponseBody && logoutResponseBody.logoutRedirectUrl) return logoutResponseBody.logoutRedirectUrl;
    return `${(0, $7FSs7.getBaseName)()}${$8900358bf13848a6$var$getAfterLogoutUrl(state)}`;
}

});
parcelRegister("gpIaW", function(module, exports) {
$parcel$export(module.exports, "logoutUsingIdentity", () => $b317dfda012bf2ab$export$7d7e0f6e9da553cb);

var $bhOdO = parcelRequire("bhOdO");

var $breWd = parcelRequire("breWd");

var $9ypa9 = parcelRequire("9ypa9");

var $jjE9o = parcelRequire("jjE9o");

var $7FSs7 = parcelRequire("7FSs7");
const $b317dfda012bf2ab$var$createOperationalPayload = (actionSubject, attributes)=>{
    return {
        attributes: attributes,
        actionSubject: actionSubject,
        action: 'logout',
        source: 'unknownSource'
    };
};
const $b317dfda012bf2ab$export$7d7e0f6e9da553cb = (redirectUrl, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/jsd-login-v2/v2/customer/logout?continue=${redirectUrl}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(uri).do((ajaxResponse)=>{
        (0, $jjE9o.operationalEvent)($b317dfda012bf2ab$var$createOperationalPayload('identity', {
            success: true,
            status: ajaxResponse.status.toString()
        }));
    }, (ajaxError)=>{
        var _ajaxError$response;
        (0, $jjE9o.operationalEvent)($b317dfda012bf2ab$var$createOperationalPayload('identity', {
            success: false,
            status: ajaxError.status.toString(),
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            errorKey: (_ajaxError$response = ajaxError.response) === null || _ajaxError$response === void 0 ? void 0 : _ajaxError$response.key
        }));
        (0, $9ypa9.trackError)('session.logout.failed', {}, ajaxError);
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $bhOdO.Observable).throw(e);
    });
};

});

parcelRegister("2tsrb", function(module, exports) {
$parcel$export(module.exports, "getPathname", () => (parcelRequire("7IL12")).getPathname);
$parcel$export(module.exports, "getPortalId", () => (parcelRequire("7IL12")).getPortalId);

var $7IL12 = parcelRequire("7IL12");

});
parcelRegister("7IL12", function(module, exports) {
$parcel$export(module.exports, "getPathname", () => $7df0f64e684d3345$export$b829272b1dcc6798);
$parcel$export(module.exports, "getPortalId", () => $7df0f64e684d3345$export$79c9b12a0a57147a);
const $7df0f64e684d3345$export$f71e6ac2c1d88be0 = (state)=>state.ui.context.portalId !== undefined && state.ui.context.portalId !== null && !isNaN(state.ui.context.portalId);
const $7df0f64e684d3345$export$b829272b1dcc6798 = (state)=>state.ui.context.pathname;
const $7df0f64e684d3345$export$6c570a1091322ad4 = (state)=>state.ui.context.routeName;
const $7df0f64e684d3345$export$79c9b12a0a57147a = (state)=>{
    if (!$7df0f64e684d3345$export$f71e6ac2c1d88be0(state)) return undefined;
    return state.ui.context.portalId;
};

});


parcelRegister("9e24t", function(module, exports) {
$parcel$export(module.exports, "getWacLink", () => (parcelRequire("8Wisn")).getWacLink);
$parcel$export(module.exports, "getHeadless", () => (parcelRequire("8Wisn")).getHeadless);
$parcel$export(module.exports, "getServiceDeskVersion", () => (parcelRequire("8Wisn")).getServiceDeskVersion);
$parcel$export(module.exports, "getXsrfToken", () => (parcelRequire("8Wisn")).getXsrfToken);
$parcel$export(module.exports, "getBaseUrl", () => (parcelRequire("8Wisn")).getBaseUrl);
$parcel$export(module.exports, "getContactLink", () => (parcelRequire("8Wisn")).getContactLink);
$parcel$export(module.exports, "getIsAnonymousEnabled", () => (parcelRequire("8Wisn")).getIsAnonymousEnabled);
$parcel$export(module.exports, "getFabricEmojiUrl", () => (parcelRequire("8Wisn")).getFabricEmojiUrl);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => (parcelRequire("8Wisn")).getJsmAIConfigEnabled);
$parcel$export(module.exports, "getJiraDisplayUrl", () => (parcelRequire("8Wisn")).getJiraDisplayUrl);

var $8Wisn = parcelRequire("8Wisn");

});
parcelRegister("8Wisn", function(module, exports) {
$parcel$export(module.exports, "getServiceDeskVersion", () => $60ca01aa02fabb6a$export$cf63d87096689a17);
$parcel$export(module.exports, "getWacLink", () => $60ca01aa02fabb6a$export$94833c7df37d6b17);
$parcel$export(module.exports, "getHeadless", () => $60ca01aa02fabb6a$export$915f62c9c01bc3d6);
$parcel$export(module.exports, "getXsrfToken", () => $60ca01aa02fabb6a$export$14407a25c57e1f92);
$parcel$export(module.exports, "getContactLink", () => $60ca01aa02fabb6a$export$a204de3b9df9c687);
$parcel$export(module.exports, "getIsAnonymousEnabled", () => $60ca01aa02fabb6a$export$10062cf4ec7decdd);
$parcel$export(module.exports, "getFabricEmojiUrl", () => $60ca01aa02fabb6a$export$81a8d16acc87f947);
$parcel$export(module.exports, "getBaseUrl", () => $60ca01aa02fabb6a$export$f654b28f82155665);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $60ca01aa02fabb6a$export$a90992f5204fc247);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $60ca01aa02fabb6a$export$9679fa5312e1354b);
const $60ca01aa02fabb6a$export$cf63d87096689a17 = (state)=>state.persisted.env.serviceDeskVersion;
const $60ca01aa02fabb6a$export$94833c7df37d6b17 = (state)=>state.persisted.env.wacLink;
const $60ca01aa02fabb6a$export$915f62c9c01bc3d6 = (state)=>state.persisted.env.headless;
const $60ca01aa02fabb6a$export$14407a25c57e1f92 = (state)=>state.persisted.env.xsrfToken;
const $60ca01aa02fabb6a$export$a204de3b9df9c687 = (state)=>state.persisted.env.contactLink;
const $60ca01aa02fabb6a$export$10062cf4ec7decdd = (state)=>state.persisted.env.anonymousEnabled;
const $60ca01aa02fabb6a$export$81a8d16acc87f947 = (state)=>state.persisted.env.fabricEmojiUrl;
const $60ca01aa02fabb6a$export$f654b28f82155665 = (state)=>state.persisted.env.baseUrl;
const $60ca01aa02fabb6a$export$a90992f5204fc247 = (state)=>{
    var _state$persisted$env$;
    return !!((_state$persisted$env$ = state.persisted.env.featuredValues) !== null && _state$persisted$env$ !== void 0 && _state$persisted$env$.jsmAiConfigEnabled);
};
const $60ca01aa02fabb6a$export$7972e6e7445f0142 = (state)=>state.persisted.env.helpCenterType;
const $60ca01aa02fabb6a$export$3b0fd0e16a94f75 = (state)=>state.persisted.env.hoistedProjectKey;
const $60ca01aa02fabb6a$export$9679fa5312e1354b = (state)=>state.persisted.env.jiraDisplayUrl;
const $60ca01aa02fabb6a$export$16e2ca57934a087e = (state)=>state.persisted.env.customerAccountAvailabilty;

});


parcelRegister("ax322", function(module, exports) {
$parcel$export(module.exports, "getLocale", () => (parcelRequire("hx8zX")).getLocale);
$parcel$export(module.exports, "getAvatar", () => (parcelRequire("hx8zX")).getAvatar);
$parcel$export(module.exports, "AvatarSizes", () => (parcelRequire("hx8zX")).AvatarSizes);
$parcel$export(module.exports, "isLoggedIn", () => (parcelRequire("hx8zX")).isLoggedIn);
$parcel$export(module.exports, "isUserLoaded", () => (parcelRequire("hx8zX")).isUserLoaded);
$parcel$export(module.exports, "getCanAdministerJIRA", () => (parcelRequire("hx8zX")).getCanAdministerJIRA);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => (parcelRequire("hx8zX")).getHasSiteAdministerAccess);
$parcel$export(module.exports, "getAgentForPortal", () => (parcelRequire("hx8zX")).getAgentForPortal);
$parcel$export(module.exports, "getAccountId", () => (parcelRequire("hx8zX")).getAccountId);
$parcel$export(module.exports, "getDisplayName", () => (parcelRequire("hx8zX")).getDisplayName);
$parcel$export(module.exports, "getAvatarSrc", () => (parcelRequire("hx8zX")).getAvatarSrc);
$parcel$export(module.exports, "getUserState", () => (parcelRequire("hx8zX")).getUserState);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => (parcelRequire("hx8zX")).isAtlassianAccountManaged);

var $hx8zX = parcelRequire("hx8zX");

});
parcelRegister("hx8zX", function(module, exports) {
$parcel$export(module.exports, "AvatarSizes", () => $71922b1f09dd7ada$export$a56a976854e036b3);
$parcel$export(module.exports, "isLoggedIn", () => $71922b1f09dd7ada$export$256a5a3564694cfc);
$parcel$export(module.exports, "isUserLoaded", () => $71922b1f09dd7ada$export$e184595b7ec7bf2a);
$parcel$export(module.exports, "getLocale", () => $71922b1f09dd7ada$export$180605366c04f0cd);
$parcel$export(module.exports, "getAvatar", () => $71922b1f09dd7ada$export$4832dff6e2fcc91f);
$parcel$export(module.exports, "getAvatarSrc", () => $71922b1f09dd7ada$export$35125d98e6f1484);
$parcel$export(module.exports, "getCanAdministerJIRA", () => $71922b1f09dd7ada$export$8c98af27b4458cd1);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => $71922b1f09dd7ada$export$c5f994129d97ed23);
$parcel$export(module.exports, "getAgentForPortal", () => $71922b1f09dd7ada$export$a163df73b48c15df);
$parcel$export(module.exports, "getAccountId", () => $71922b1f09dd7ada$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getDisplayName", () => $71922b1f09dd7ada$export$be63e0664592e141);
$parcel$export(module.exports, "getUserState", () => $71922b1f09dd7ada$export$531a2013799771e3);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => $71922b1f09dd7ada$export$9055c338585b9def);
var $71922b1f09dd7ada$export$a56a976854e036b3 = /*#__PURE__*/ function(AvatarSizes) {
    AvatarSizes["XSMALL"] = "xsmall";
    AvatarSizes["SMALL"] = "small";
    AvatarSizes["MEDIUM"] = "medium";
    AvatarSizes["LARGE"] = "large";
    AvatarSizes["XLARGE"] = "xlarge";
    return AvatarSizes;
}({});
const $71922b1f09dd7ada$export$256a5a3564694cfc = (state)=>state.persisted.user.isLoggedIn;
const $71922b1f09dd7ada$export$e184595b7ec7bf2a = (state)=>state.persisted.user.isLoaded;
const $71922b1f09dd7ada$export$180605366c04f0cd = (state)=>state.persisted.user.language.key;
const $71922b1f09dd7ada$export$4832dff6e2fcc91f = (state, size)=>{
    if (state.persisted.user.avatars && size) return state.persisted.user.avatars[size];
    return undefined;
};
const $71922b1f09dd7ada$export$35125d98e6f1484 = (state)=>$71922b1f09dd7ada$export$4832dff6e2fcc91f(state, "xlarge");
const $71922b1f09dd7ada$export$ee387765d0284f6c = (state)=>{
    return state.persisted.user.userRequests;
};
const $71922b1f09dd7ada$export$aa593f8d08aea763 = (state)=>{
    return state.persisted.user.userRequests.myRequestCount;
};
const $71922b1f09dd7ada$export$e088f15960c351f6 = (state)=>{
    return state.persisted.user.userRequests.pendingApprovalCount;
};
const $71922b1f09dd7ada$export$c0edbdc6282ca463 = (state)=>{
    return state.persisted.user.userRequests.approvalCount;
};
const $71922b1f09dd7ada$export$bf9a934424e2dbf1 = (state)=>state.persisted.user.customMenuLinks;
const $71922b1f09dd7ada$export$8c98af27b4458cd1 = (state)=>{
    return state.persisted.user.canAdministerJIRA;
};
const $71922b1f09dd7ada$export$c5f994129d97ed23 = (state)=>{
    return state.persisted.user.hasSiteAdministerAccess;
};
const $71922b1f09dd7ada$export$a163df73b48c15df = (state)=>{
    return state.persisted.user.agentForPortal;
};
const $71922b1f09dd7ada$export$c1e0336bde96e2dc = (state)=>{
    return state.persisted.user.accountId;
};
const $71922b1f09dd7ada$export$be63e0664592e141 = (state)=>{
    return state.persisted.user.displayName;
};
const $71922b1f09dd7ada$export$d29968a6889079e0 = (state)=>{
    return state.persisted.user.email;
};
const $71922b1f09dd7ada$export$531a2013799771e3 = (state)=>{
    return state.persisted.user;
};
const $71922b1f09dd7ada$export$9055c338585b9def = (state)=>{
    return state.persisted.user.atlassianAccountManaged;
};

});


parcelRegister("hmGtR", function(module, exports) {
$parcel$export(module.exports, "getLocalStorageItem", () => $0fa0e57c9a649cf4$export$93d719890ad66653);
$parcel$export(module.exports, "setLocalStorageItem", () => $0fa0e57c9a649cf4$export$5aa524d86254b4f);
$parcel$export(module.exports, "removeLocalStorageItem", () => $0fa0e57c9a649cf4$export$baf306891f1b93bd);

var $ir9tA = parcelRequire("ir9tA");

var $jkbTO = parcelRequire("jkbTO");
const $0fa0e57c9a649cf4$export$93d719890ad66653 = (key, errorHandler)=>{
    return (0, $jkbTO.safeAccessWithErrorHandler)(()=>(0, $ir9tA.AtlBrowserStorageLocal).getItem(key), errorHandler);
};
const $0fa0e57c9a649cf4$export$5aa524d86254b4f = (key, value, errorHandler)=>{
    return (0, $jkbTO.safeAccessWithErrorHandler)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $ir9tA.AtlBrowserStorageLocal).setItem(key, value);
    }, errorHandler);
};
const $0fa0e57c9a649cf4$export$baf306891f1b93bd = (key, errorHandler)=>{
    return (0, $jkbTO.safeAccessWithErrorHandler)(()=>(0, $ir9tA.AtlBrowserStorageLocal).removeItem(key), errorHandler);
};

});
parcelRegister("ir9tA", function(module, exports) {
$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $22440998aca9e4a9$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $22440998aca9e4a9$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $22440998aca9e4a9$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("gkonM")).WebStorageType);

var $e6Qdr = parcelRequire("e6Qdr");

var $5ROjv = parcelRequire("5ROjv");
var $7ca6J = parcelRequire("7ca6J");

var $gc3OY = parcelRequire("gc3OY");

var $hQwKE = parcelRequire("hQwKE");

var $1NYQF = parcelRequire("1NYQF");

var $gkonM = parcelRequire("gkonM");

var $9Tq1F = parcelRequire("9Tq1F");
var $gvFRs = parcelRequire("gvFRs");
var $ktQue = parcelRequire("ktQue");
class $22440998aca9e4a9$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $1NYQF.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $gc3OY.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStorageEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $5ROjv.getBscGlobalState)().webStorageEnabled) return true;
        (0, $gc3OY.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $gc3OY.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $9Tq1F.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        const isSetItemReturnsStatusEnabled = (0, $e6Qdr.fg)('platform_moonjelly_bsc_set_item_returns_status');
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            if (isSetItemReturnsStatusEnabled) return {
                status: (0, $hQwKE.Status).SUCCESS
            };
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $gc3OY.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            if (isSetItemReturnsStatusEnabled) return {
                status: (0, $hQwKE.Status).ERROR,
                error: new Error(`${this.storageType} is unavailable. Failed to set item ${key}`)
            };
            return;
        }
        const globalStateProduct = (0, $5ROjv.getBscGlobalState)().product;
        const itemSetResult = await (0, $gvFRs.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        (0, $gc3OY.Logger).debug(`${itemSetResult.status === (0, $hQwKE.Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
        if (isSetItemReturnsStatusEnabled) return itemSetResult;
        return;
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $gc3OY.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $ktQue.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        (0, $gc3OY.Logger).debug(`${itemSetStatus === (0, $hQwKE.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $gc3OY.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $7ca6J.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $22440998aca9e4a9$export$c8cc3ffd3f2c1d2f = new $22440998aca9e4a9$export$8e4a3cf07a10930b(globalThis.localStorage, (0, $gkonM.WebStorageType).LocalStorage);
const $22440998aca9e4a9$export$edbae459bdf957a5 = new $22440998aca9e4a9$export$8e4a3cf07a10930b(globalThis.sessionStorage, (0, $gkonM.WebStorageType).SessionStorage);
const $22440998aca9e4a9$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $gkonM.WebStorageType).LocalStorage]: $22440998aca9e4a9$export$c8cc3ffd3f2c1d2f,
        [(0, $gkonM.WebStorageType).SessionStorage]: $22440998aca9e4a9$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("5ROjv", function(module, exports) {
$parcel$export(module.exports, "getBscGlobalState", () => $8c83e937f714a224$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "__internalApplyInitialState", () => $8c83e937f714a224$export$725ef39b428c0dc2);
$parcel$export(module.exports, "__internalGetHasInitialized", () => $8c83e937f714a224$export$8835d45f445e6ba4);
$parcel$export(module.exports, "__internalGetProductGlobalState", () => $8c83e937f714a224$export$9dfdd17bbd03b460);
$parcel$export(module.exports, "__internalGetWebStorageControlsEnabledGlobalState", () => $8c83e937f714a224$export$d96c3b0fb6d35c5d);
$parcel$export(module.exports, "__internalGetIndexedDbControlsEnabledGlobalState", () => $8c83e937f714a224$export$c8554d68c78456d3);
$parcel$export(module.exports, "__internalGetAllowUncategorizedCookiesInOverridesGlobalState", () => $8c83e937f714a224$export$fa1f6ebb49ec4b30);
$parcel$export(module.exports, "__internalGetDisableIndexedDbConsentChecksGlobalState", () => $8c83e937f714a224$export$ea32fe1e8610fd3b);

var $hQwKE = parcelRequire("hQwKE");
let $8c83e937f714a224$var$analyticsEnabledGlobalState;
let $8c83e937f714a224$var$productGlobalState;
let $8c83e937f714a224$var$perimeterGlobalState;
let $8c83e937f714a224$var$webStorageControlsEnabledGlobalState;
let $8c83e937f714a224$var$indexedDbControlsEnabledGlobalState;
let $8c83e937f714a224$var$localConsentModeGlobalState;
let $8c83e937f714a224$var$packageDebugModeEnabledGlobalState;
let $8c83e937f714a224$var$allowUncategorizedCookiesInOverridesGlobalState;
let $8c83e937f714a224$var$disableIndexedDbConsentChecksGlobalState;
let $8c83e937f714a224$var$userIdGlobalState;
let $8c83e937f714a224$var$cloudIdGlobalState;
let $8c83e937f714a224$var$hasInitialized = false;
let $8c83e937f714a224$var$cookiesCacheLoader;
let $8c83e937f714a224$var$localStorageCacheLoader;
let $8c83e937f714a224$var$sessionStorageCacheLoader;
let $8c83e937f714a224$var$indexedDBCacheLoader;
let $8c83e937f714a224$var$loadCache = async (storageType)=>{
    var _cookiesCacheLoader, _localStorageCacheLoa, _sessionStorageCacheL, _indexedDBCacheLoader;
    switch(storageType){
        case (0, $hQwKE.CategoryStorageType).Cookies:
            return await ((_cookiesCacheLoader = $8c83e937f714a224$var$cookiesCacheLoader) === null || _cookiesCacheLoader === void 0 ? void 0 : _cookiesCacheLoader.loadStorageControlsData());
        case (0, $hQwKE.CategoryStorageType).LocalStorage:
            return await ((_localStorageCacheLoa = $8c83e937f714a224$var$localStorageCacheLoader) === null || _localStorageCacheLoa === void 0 ? void 0 : _localStorageCacheLoa.loadStorageControlsData());
        case (0, $hQwKE.CategoryStorageType).SessionStorage:
            return await ((_sessionStorageCacheL = $8c83e937f714a224$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL === void 0 ? void 0 : _sessionStorageCacheL.loadStorageControlsData());
        case (0, $hQwKE.CategoryStorageType).IndexedDB:
            return await ((_indexedDBCacheLoader = $8c83e937f714a224$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader === void 0 ? void 0 : _indexedDBCacheLoader.loadStorageControlsData());
        default:
            return undefined;
    }
};
const $8c83e937f714a224$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $8c83e937f714a224$var$analyticsEnabledGlobalState ?? true,
        product: $8c83e937f714a224$var$productGlobalState,
        perimeter: $8c83e937f714a224$var$perimeterGlobalState,
        webStorageEnabled: $8c83e937f714a224$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $8c83e937f714a224$var$indexedDbControlsEnabledGlobalState ?? false,
        localConsentMode: $8c83e937f714a224$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $8c83e937f714a224$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $8c83e937f714a224$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        disableIndexedDbConsentChecks: $8c83e937f714a224$var$disableIndexedDbConsentChecksGlobalState ?? false,
        cookiesCacheLoader: $8c83e937f714a224$var$cookiesCacheLoader,
        localStorageCacheLoader: $8c83e937f714a224$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $8c83e937f714a224$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $8c83e937f714a224$var$indexedDBCacheLoader,
        loadCache: $8c83e937f714a224$var$loadCache,
        hasInitialized: $8c83e937f714a224$var$hasInitialized,
        userId: $8c83e937f714a224$var$userIdGlobalState,
        cloudId: $8c83e937f714a224$var$cloudIdGlobalState
    };
};
const $8c83e937f714a224$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $8c83e937f714a224$var$loadCache = overrideLoadCache;
    if (overrideProduct) $8c83e937f714a224$var$productGlobalState = overrideProduct;
};
const $8c83e937f714a224$export$ac7c2edd09656c05 = ()=>{
    $8c83e937f714a224$var$analyticsEnabledGlobalState = undefined;
    $8c83e937f714a224$var$productGlobalState = undefined;
    $8c83e937f714a224$var$webStorageControlsEnabledGlobalState = undefined;
    $8c83e937f714a224$var$indexedDbControlsEnabledGlobalState = undefined;
    $8c83e937f714a224$var$localConsentModeGlobalState = undefined;
    $8c83e937f714a224$var$packageDebugModeEnabledGlobalState = undefined;
    $8c83e937f714a224$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $8c83e937f714a224$var$disableIndexedDbConsentChecksGlobalState = undefined;
    $8c83e937f714a224$var$userIdGlobalState = undefined;
    $8c83e937f714a224$var$cloudIdGlobalState = undefined;
    $8c83e937f714a224$var$cookiesCacheLoader = undefined;
    $8c83e937f714a224$var$localStorageCacheLoader = undefined;
    $8c83e937f714a224$var$sessionStorageCacheLoader = undefined;
    $8c83e937f714a224$var$indexedDBCacheLoader = undefined;
    $8c83e937f714a224$var$hasInitialized = false;
};
function $8c83e937f714a224$export$725ef39b428c0dc2(updates) {
    if (updates.productGlobalState !== undefined) $8c83e937f714a224$var$productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) $8c83e937f714a224$var$webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) $8c83e937f714a224$var$indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) $8c83e937f714a224$var$allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) $8c83e937f714a224$var$disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) $8c83e937f714a224$var$localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) $8c83e937f714a224$var$analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) $8c83e937f714a224$var$perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) $8c83e937f714a224$var$cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) $8c83e937f714a224$var$localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) $8c83e937f714a224$var$sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) $8c83e937f714a224$var$indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageDebugModeEnabledGlobalState !== undefined) $8c83e937f714a224$var$packageDebugModeEnabledGlobalState = updates.packageDebugModeEnabledGlobalState;
    if (updates.hasInitialized !== undefined) $8c83e937f714a224$var$hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) $8c83e937f714a224$var$cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) $8c83e937f714a224$var$userIdGlobalState = updates.userIdGlobalState;
}
function $8c83e937f714a224$export$8835d45f445e6ba4() {
    return $8c83e937f714a224$var$hasInitialized;
}
function $8c83e937f714a224$export$9dfdd17bbd03b460() {
    return $8c83e937f714a224$var$productGlobalState;
}
function $8c83e937f714a224$export$d96c3b0fb6d35c5d() {
    return $8c83e937f714a224$var$webStorageControlsEnabledGlobalState;
}
function $8c83e937f714a224$export$c8554d68c78456d3() {
    return $8c83e937f714a224$var$indexedDbControlsEnabledGlobalState;
}
function $8c83e937f714a224$export$fa1f6ebb49ec4b30() {
    return $8c83e937f714a224$var$allowUncategorizedCookiesInOverridesGlobalState;
}
function $8c83e937f714a224$export$ea32fe1e8610fd3b() {
    return $8c83e937f714a224$var$disableIndexedDbConsentChecksGlobalState;
}

});
parcelRegister("hQwKE", function(module, exports) {
$parcel$export(module.exports, "PreferenceCategory", () => $5b723613a11c8728$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $5b723613a11c8728$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $5b723613a11c8728$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $5b723613a11c8728$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $5b723613a11c8728$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $5b723613a11c8728$export$96e9906d6d93a972);
var $5b723613a11c8728$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $5b723613a11c8728$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $5b723613a11c8728$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $5b723613a11c8728$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $5b723613a11c8728$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $5b723613a11c8728$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $5b723613a11c8728$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var $5b723613a11c8728$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});


parcelRegister("7ca6J", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $5bf92db69165c0d9$export$48d7c418edadb60c);

var $jXNbL = parcelRequire("jXNbL");

var $e6Qdr = parcelRequire("e6Qdr");
const $5bf92db69165c0d9$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $e6Qdr.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $jXNbL.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});

parcelRegister("gc3OY", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $8b6589db1633ec7a$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $e6Qdr = parcelRequire("e6Qdr");

var $hamKY = parcelRequire("hamKY");

var $5ROjv = parcelRequire("5ROjv");

var $grnsh = parcelRequire("grnsh");
class $8b6589db1633ec7a$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${(0, $grnsh.LOG_PREFIX)}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${(0, $grnsh.LOG_PREFIX)}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            if ((0, $e6Qdr.fg)('platform_bsc_remove_error_event_sampling')) (0, $hamKY.sendUnsampledPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
            else (0, $hamKY.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${(0, $grnsh.LOG_PREFIX)}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
   * Logger for additional debugging of the package. Debug logs are only sent when the
   * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
   */ static debug(message, metadata) {
        if ((0, $5ROjv.getBscGlobalState)().packageDebugMode && (0, $e6Qdr.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${(0, $grnsh.LOG_PREFIX)}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});
parcelRegister("hamKY", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsClient", () => $917f66a36e8161cc$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $917f66a36e8161cc$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUnsampledPackageOperationalEvent", () => $917f66a36e8161cc$export$c986f0e7f985d67f);
$parcel$export(module.exports, "sendUIEvent", () => $917f66a36e8161cc$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $917f66a36e8161cc$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $917f66a36e8161cc$export$1ba525b8a711eaac);

var $jXNbL = parcelRequire("jXNbL");
var $b5UnP = parcelRequire("b5UnP");

var $e6Qdr = parcelRequire("e6Qdr");

var $5ROjv = parcelRequire("5ROjv");

var $grnsh = parcelRequire("grnsh");

var $1FioO = parcelRequire("1FioO");

var $9ivkU = parcelRequire("9ivkU");
const $917f66a36e8161cc$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $b5UnP.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $b5UnP.envType).DEV;
    return (0, $b5UnP.envType).PROD;
};
const $917f66a36e8161cc$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $917f66a36e8161cc$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $917f66a36e8161cc$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $917f66a36e8161cc$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $917f66a36e8161cc$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $917f66a36e8161cc$var$decorateEventAttributes = (attributes)=>{
    var _getBscGlobalState$pr;
    const { domain: domain, product: product } = $917f66a36e8161cc$export$fce3dd735e04d566();
    return {
        packageName: $1FioO.packageName,
        packageVersion: $1FioO.packageVersion,
        domain: domain,
        product: ((_getBscGlobalState$pr = (0, $5ROjv.getBscGlobalState)().product) === null || _getBscGlobalState$pr === void 0 ? void 0 : _getBscGlobalState$pr.toLowerCase()) ?? product,
        ...attributes && attributes
    };
};
const $917f66a36e8161cc$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $5ROjv.getBscGlobalState)().analyticsEnabled) {
                instance = new (0, $jXNbL.default)({
                    env: $917f66a36e8161cc$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, $5ROjv.getBscGlobalState)().cloudId) instance.setTenantInfo((0, $b5UnP.tenantType).CLOUD_ID, (0, $5ROjv.getBscGlobalState)().cloudId);
                if ((0, $5ROjv.getBscGlobalState)().userId) instance.setUserInfo((0, $b5UnP.userType).ATLASSIAN_ACCOUNT, (0, $5ROjv.getBscGlobalState)().userId ?? '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, $grnsh.LOG_PREFIX)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $5ROjv.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $917f66a36e8161cc$export$5bfe55348e7aebc1(properties) {
    (0, $9ivkU.withAnalyticsEventSampling)(properties.action, ()=>{
        var _getAnalyticsClient;
        return (_getAnalyticsClient = $917f66a36e8161cc$export$fde53e78fd93a54d()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $917f66a36e8161cc$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $917f66a36e8161cc$export$c986f0e7f985d67f(properties) {
    var _getAnalyticsClient2;
    (_getAnalyticsClient2 = $917f66a36e8161cc$export$fde53e78fd93a54d()) === null || _getAnalyticsClient2 === void 0 || _getAnalyticsClient2.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: $917f66a36e8161cc$var$decorateEventAttributes(properties.attributes)
    });
}
function $917f66a36e8161cc$export$1aecf263098db667(properties) {
    if ((0, $e6Qdr.fg)('platform_bsc_add_event_sampling')) (0, $9ivkU.withAnalyticsEventSampling)(properties.actionSubjectId, ()=>{
        var _getAnalyticsClient3;
        return (_getAnalyticsClient3 = $917f66a36e8161cc$export$fde53e78fd93a54d()) === null || _getAnalyticsClient3 === void 0 ? void 0 : _getAnalyticsClient3.sendUIEvent({
            ...properties,
            attributes: $917f66a36e8161cc$var$decorateEventAttributes(properties.attributes)
        });
    });
    else {
        var _getAnalyticsClient4;
        (_getAnalyticsClient4 = $917f66a36e8161cc$export$fde53e78fd93a54d()) === null || _getAnalyticsClient4 === void 0 || _getAnalyticsClient4.sendUIEvent({
            ...properties,
            attributes: $917f66a36e8161cc$var$decorateEventAttributes(properties.attributes)
        });
    }
}
function $917f66a36e8161cc$export$22a3b1671f38a193(properties) {
    if ((0, $e6Qdr.fg)('platform_bsc_add_event_sampling')) (0, $9ivkU.withAnalyticsEventSampling)(properties.name, ()=>{
        var _getAnalyticsClient5;
        return (_getAnalyticsClient5 = $917f66a36e8161cc$export$fde53e78fd93a54d()) === null || _getAnalyticsClient5 === void 0 ? void 0 : _getAnalyticsClient5.sendScreenEvent({
            ...properties,
            attributes: $917f66a36e8161cc$var$decorateEventAttributes(properties.attributes)
        });
    });
    else {
        var _getAnalyticsClient6;
        (_getAnalyticsClient6 = $917f66a36e8161cc$export$fde53e78fd93a54d()) === null || _getAnalyticsClient6 === void 0 || _getAnalyticsClient6.sendScreenEvent({
            ...properties,
            attributes: $917f66a36e8161cc$var$decorateEventAttributes(properties.attributes)
        });
    }
}
function $917f66a36e8161cc$export$1ba525b8a711eaac(properties) {
    if ((0, $e6Qdr.fg)('platform_bsc_add_event_sampling')) (0, $9ivkU.withAnalyticsEventSampling)(properties.actionSubject, ()=>{
        var _getAnalyticsClient7;
        return (_getAnalyticsClient7 = $917f66a36e8161cc$export$fde53e78fd93a54d()) === null || _getAnalyticsClient7 === void 0 ? void 0 : _getAnalyticsClient7.sendTrackEvent({
            ...properties,
            attributes: $917f66a36e8161cc$var$decorateEventAttributes(properties.attributes)
        });
    });
    else {
        var _getAnalyticsClient8;
        (_getAnalyticsClient8 = $917f66a36e8161cc$export$fde53e78fd93a54d()) === null || _getAnalyticsClient8 === void 0 || _getAnalyticsClient8.sendTrackEvent({
            ...properties,
            attributes: $917f66a36e8161cc$var$decorateEventAttributes(properties.attributes)
        });
    }
}

});
parcelRegister("grnsh", function(module, exports) {
$parcel$export(module.exports, "LOG_PREFIX", () => $dbd52915e9113965$export$5e28bf885ebebfa6);
const $dbd52915e9113965$export$5e28bf885ebebfa6 = '[browser-storage-controls]';

});

parcelRegister("1FioO", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $b8ce683dde027160$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $b8ce683dde027160$export$91546b032799aa40);
const $b8ce683dde027160$export$9345d7360ffe0722 = undefined ?? '';
const $b8ce683dde027160$export$91546b032799aa40 = undefined ?? '';

});

parcelRegister("9ivkU", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEventSampling", () => $906380133de60a23$export$67b6e87f323cb6ad);

var $hQwKE = parcelRequire("hQwKE");

var $5ROjv = parcelRequire("5ROjv");

var $4Pr1c = parcelRequire("4Pr1c");

var $7ca6J = parcelRequire("7ca6J");
const $906380133de60a23$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    bifrostLoadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    uncategorizedWebStorageItemSet: 10,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $906380133de60a23$var$localOnlySamplingKeys = [
    'loadStorageControlsError',
    'bifrostLoadStorageControlsError'
];
async function $906380133de60a23$var$loadSamplingConfig() {
    if ((0, $4Pr1c.cache).cachedSamplingConfig) return (0, $4Pr1c.cache).cachedSamplingConfig;
    if ((0, $7ca6J.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $5ROjv.getBscGlobalState)();
    const controlsData = await loadCache((0, $hQwKE.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
    (0, $4Pr1c.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $906380133de60a23$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($906380133de60a23$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $906380133de60a23$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $906380133de60a23$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $906380133de60a23$export$1138592b3c099377;
    const samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : $906380133de60a23$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $906380133de60a23$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $906380133de60a23$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $906380133de60a23$export$b286f5e8716d11ad(analyticsEventKey);
    $906380133de60a23$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("4Pr1c", function(module, exports) {
$parcel$export(module.exports, "cache", () => $70c67f65c0c2953b$export$69a3209f1a06c04d);

var $736fS = parcelRequire("736fS");
const $70c67f65c0c2953b$export$69a3209f1a06c04d = new (0, $736fS.CachedSamplingConfig)();

});
parcelRegister("736fS", function(module, exports) {
$parcel$export(module.exports, "CachedSamplingConfig", () => $aaef31f567577abc$export$b886edaf6623554a);
class $aaef31f567577abc$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});





parcelRegister("1NYQF", function(module, exports) {
$parcel$export(module.exports, "BSCIndexedDB", () => $a56ce8fe61860d58$export$36328b3bcbe4623a);

var $e6Qdr = parcelRequire("e6Qdr");

var $7ca6J = parcelRequire("7ca6J");
var $hamKY = parcelRequire("hamKY");

var $gc3OY = parcelRequire("gc3OY");
class $a56ce8fe61860d58$export$fde2a4e0e57f47e {
    static #_ = this.OPEN_DB_TIMEOUT_MS = 3000;
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $gc3OY.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $gc3OY.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $gc3OY.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $gc3OY.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $gc3OY.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $7ca6J.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        const openPromise = new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
        if ((0, $e6Qdr.fg)('cookies-bsc-timeout-for-indexeddb')) {
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject(new Error(`IndexedDB open timed out after ${$a56ce8fe61860d58$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS}ms`));
                }, $a56ce8fe61860d58$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS);
            });
            return Promise.race([
                openPromise,
                timeoutPromise
            ]);
        }
        return openPromise;
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $hamKY.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                return Promise.resolve({
                    atlSetItem: '',
                    id: recordKey
                }); // return empty AtlIndexedDBItem object to exit code
            }
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $gc3OY.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $hamKY.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                Promise.resolve(); // return void promise to exit code and not pass a null record
            }
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $gc3OY.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $a56ce8fe61860d58$export$36328b3bcbe4623a = new $a56ce8fe61860d58$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("gkonM", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $938ee2ca5dddac50$export$259e3a861f28589b);
var $938ee2ca5dddac50$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("9Tq1F", function(module, exports) {
$parcel$export(module.exports, "getStorageItem", () => $3b40ed0d9444cc3c$export$e612bb1301d659de);

var $hamKY = parcelRequire("hamKY");

var $gc3OY = parcelRequire("gc3OY");
const $3b40ed0d9444cc3c$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $hamKY.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("gvFRs", function(module, exports) {
$parcel$export(module.exports, "setStorageItem", () => $94c0e2b901c66975$export$5ee8760f703d9d62);

var $hamKY = parcelRequire("hamKY");

var $l8Zmx = parcelRequire("l8Zmx");

var $gc3OY = parcelRequire("gc3OY");

var $1NYQF = parcelRequire("1NYQF");

var $hQwKE = parcelRequire("hQwKE");

var $gkonM = parcelRequire("gkonM");
const $94c0e2b901c66975$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    // user belongs to an org that opted into cookies management and we should respect their preferences
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $l8Zmx.isProcessingAllowedByPreferences)({
        itemKey: itemKey,
        storageType: storageType === (0, $gkonM.WebStorageType).LocalStorage ? (0, $hQwKE.CategoryStorageType).LocalStorage : (0, $hQwKE.CategoryStorageType).SessionStorage,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $hamKY.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $1NYQF.BSCIndexedDB).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return {
                status: (0, $hQwKE.Status).SUCCESS
            };
        } else return {
            status: (0, $hQwKE.Status).BLOCKED
        };
    } catch (e) {
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return {
            status: (0, $hQwKE.Status).ERROR,
            error: e
        };
    }
};

});
parcelRegister("l8Zmx", function(module, exports) {
$parcel$export(module.exports, "getItemCategory", () => $9479bd9f27fd2c22$export$ec8ce5237293e4a4);
$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $9479bd9f27fd2c22$export$e7a3dca206fec6e2);
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var $ilbEc = parcelRequire("ilbEc");

var $hQwKE = parcelRequire("hQwKE");

var $5ROjv = parcelRequire("5ROjv");
const $9479bd9f27fd2c22$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $9479bd9f27fd2c22$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $9479bd9f27fd2c22$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName === null || productName === void 0 ? void 0 : productName.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else {
        // Find pattern match or null
        itemCategoryNumber = $9479bd9f27fd2c22$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
        if (itemCategoryNumber === null) itemCategoryNumber = $9479bd9f27fd2c22$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $hQwKE.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $hQwKE.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $hQwKE.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $hQwKE.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $hQwKE.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $9479bd9f27fd2c22$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $5ROjv.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $9479bd9f27fd2c22$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $9479bd9f27fd2c22$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    const itemCategory = await $9479bd9f27fd2c22$export$ec8ce5237293e4a4(itemKey, storageType, productName);
    if (itemCategory === (0, $hQwKE.PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $ilbEc.getPreferences)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback === null || allowedCallback === void 0 || allowedCallback();
    else blockedCallback === null || blockedCallback === void 0 || blockedCallback({
        itemHasCategory: itemCategory != null,
        itemCategory: itemCategory
    });
    return shouldProcessItem;
};

});
parcelRegister("ilbEc", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $e4c926a052cdb310$export$1de6a888ae076ff8);

var $5ROjv = parcelRequire("5ROjv");
var $7ca6J = parcelRequire("7ca6J");

var $9655j = parcelRequire("9655j");

var $cTskZ = parcelRequire("cTskZ");

var $eKc2n = parcelRequire("eKc2n");

var $68rNz = parcelRequire("68rNz");
async function $e4c926a052cdb310$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $5ROjv.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $eKc2n.getCookie)((0, $9655j.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $68rNz.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $cTskZ.getConsentToken)();
            if ((0, $7ca6J.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $68rNz.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $68rNz.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("9655j", function(module, exports) {
$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $b611a5eba1566419$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $b611a5eba1566419$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $b611a5eba1566419$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $b611a5eba1566419$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $b611a5eba1566419$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $b611a5eba1566419$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $b611a5eba1566419$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $b611a5eba1566419$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $b611a5eba1566419$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $b611a5eba1566419$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $b611a5eba1566419$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $b611a5eba1566419$export$31deaeaebce525bb);

var $hQwKE = parcelRequire("hQwKE");
const $b611a5eba1566419$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $b611a5eba1566419$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $b611a5eba1566419$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $b611a5eba1566419$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $b611a5eba1566419$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $b611a5eba1566419$export$37073d560ecebada = 'atl-testing-consents';
const $b611a5eba1566419$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $b611a5eba1566419$export$b28b5d760fe14a21 = {
    [(0, $hQwKE.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $hQwKE.PreferenceCategory).Functional]: true,
    [(0, $hQwKE.PreferenceCategory).Marketing]: true,
    [(0, $hQwKE.PreferenceCategory).Analytics]: true,
    [(0, $hQwKE.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $b611a5eba1566419$export$4a12f9e99971760a = {
    [(0, $hQwKE.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $hQwKE.PreferenceCategory).Functional]: false,
    [(0, $hQwKE.PreferenceCategory).Marketing]: false,
    [(0, $hQwKE.PreferenceCategory).Analytics]: false,
    [(0, $hQwKE.PreferenceCategory).Unknown]: false
};
const $b611a5eba1566419$export$f0fd1d13ec1d48f2 = {
    ...$b611a5eba1566419$export$4a12f9e99971760a,
    [(0, $hQwKE.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $b611a5eba1566419$export$f95182b7aa141c57 = '001';
const $b611a5eba1566419$export$1f25427b34f9c405 = '002';
const $b611a5eba1566419$export$31deaeaebce525bb = '003';

});

parcelRegister("cTskZ", function(module, exports) {
$parcel$export(module.exports, "getConsentToken", () => $d3b895fe7b5ff010$export$f1b8f2ca713fca08);

var $9655j = parcelRequire("9655j");

var $eKc2n = parcelRequire("eKc2n");

var $cyKF5 = parcelRequire("cyKF5");

var $fX4zd = parcelRequire("fX4zd");

var $8XhRY = parcelRequire("8XhRY");
const $d3b895fe7b5ff010$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $8XhRY.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $cyKF5.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $eKc2n.getCookie)((0, $9655j.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $fX4zd.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $fX4zd.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $fX4zd.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};

});
parcelRegister("eKc2n", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $70a482cbd07408b4$export$4be65e66cfa2648a);

var $8Bt4H = parcelRequire("8Bt4H");

var $e6Qdr = parcelRequire("e6Qdr");

var $hamKY = parcelRequire("hamKY");

var $gc3OY = parcelRequire("gc3OY");
function $70a482cbd07408b4$export$4be65e66cfa2648a(key) {
    if ((0, $e6Qdr.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).get();
    try {
        (0, $hamKY.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).get();
    } catch (e) {
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("cyKF5", function(module, exports) {
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $7e9f441f9995abaa$export$b5282052fc15e1ae);

var $9655j = parcelRequire("9655j");

var $eKc2n = parcelRequire("eKc2n");
const $7e9f441f9995abaa$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $eKc2n.getCookie)((0, $9655j.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("fX4zd", function(module, exports) {
$parcel$export(module.exports, "setConsentTokenCookie", () => $2d923a4ffca3e8b4$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $2d923a4ffca3e8b4$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $2d923a4ffca3e8b4$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $2d923a4ffca3e8b4$export$b3365240280cb3c3);

var $5iRib = parcelRequire("5iRib");
var $gc3OY = parcelRequire("gc3OY");

var $9655j = parcelRequire("9655j");

var $2BDRp = parcelRequire("2BDRp");

var $4DT4d = parcelRequire("4DT4d");
const $2d923a4ffca3e8b4$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $4DT4d.setStrictlyNecessaryCookie)((0, $9655j.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $gc3OY.Logger).debug(`Set Consent Token ${(0, $9655j.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $2d923a4ffca3e8b4$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $4DT4d.setStrictlyNecessaryCookie)((0, $9655j.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $gc3OY.Logger).debug(`set fallback consent token: ${(0, $9655j.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $2d923a4ffca3e8b4$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $2BDRp.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $5iRib.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $4DT4d.setStrictlyNecessaryCookie)((0, $9655j.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $gc3OY.Logger).debug(`set shouldShowBannerCookie: ${(0, $9655j.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $2d923a4ffca3e8b4$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $2d923a4ffca3e8b4$export$8e560d0760f733a2(consentToken);
    $2d923a4ffca3e8b4$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("5iRib", function(module, exports) {
$parcel$export(module.exports, "getBitValueFromBool", () => $0a496096e77e67d5$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $0a496096e77e67d5$export$27647458f3cf29d2);
const $0a496096e77e67d5$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $0a496096e77e67d5$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("2BDRp", function(module, exports) {
$parcel$export(module.exports, "getBannerVisibility", () => $f877b1a571f2b70a$export$bfdb9f82a9194c1e);

var $8Bt4H = parcelRequire("8Bt4H");

var $7ca6J = parcelRequire("7ca6J");

var $5iRib = parcelRequire("5iRib");

var $9655j = parcelRequire("9655j");

var $5Vfju = parcelRequire("5Vfju");

var $eKc2n = parcelRequire("eKc2n");

var $68rNz = parcelRequire("68rNz");
const $f877b1a571f2b70a$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $68rNz.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $f877b1a571f2b70a$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $f877b1a571f2b70a$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $5iRib.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $5Vfju.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $f877b1a571f2b70a$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $5Vfju.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $f877b1a571f2b70a$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $5Vfju.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $f877b1a571f2b70a$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $f877b1a571f2b70a$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $5iRib.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $5Vfju.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
            They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
            then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)
             UX Problem:
            Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
            But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
            is infrequent (either via Account Privacy Page or once this fallback expires in a year).
             Example:
            While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
            fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
            because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...
             We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
            to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
            persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.
             Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
            consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year
             Result: Show the banner again and hope we officially recapture consents this time around
          */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $f877b1a571f2b70a$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $5Vfju.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $f877b1a571f2b70a$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $5Vfju.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $f877b1a571f2b70a$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, $9655j.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    else fallbackConsentToken = (0, $7ca6J.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $f877b1a571f2b70a$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $5iRib.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $f877b1a571f2b70a$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $f877b1a571f2b70a$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("5Vfju", function(module, exports) {
$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $d6cdb40e4ab7989d$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $d6cdb40e4ab7989d$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $d6cdb40e4ab7989d$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $d6cdb40e4ab7989d$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $d6cdb40e4ab7989d$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $d6cdb40e4ab7989d$export$3387347b75450ae1);
$parcel$export(module.exports, "hasPrefetchedDataConsents", () => $d6cdb40e4ab7989d$export$7133f415a79804e8);
$parcel$export(module.exports, "StatusCodeError", () => $d6cdb40e4ab7989d$export$a79c0ea3d7c2444a);

var $5iRib = parcelRequire("5iRib");

var $9655j = parcelRequire("9655j");

var $eKc2n = parcelRequire("eKc2n");

var $hQwKE = parcelRequire("hQwKE");

var $gqq7m = parcelRequire("gqq7m");
const $d6cdb40e4ab7989d$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $9655j.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $d6cdb40e4ab7989d$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $9655j.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $d6cdb40e4ab7989d$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($d6cdb40e4ab7989d$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $d6cdb40e4ab7989d$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $d6cdb40e4ab7989d$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $d6cdb40e4ab7989d$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $d6cdb40e4ab7989d$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $5iRib.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $d6cdb40e4ab7989d$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $9655j.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $9655j.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $hQwKE.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $5iRib.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $5iRib.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $5iRib.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $d6cdb40e4ab7989d$export$42a0b3fb1e53e7b9 = (consents)=>{
    var _consents$find, _consents$find2, _consents$find3, _consents$find4;
    const version = (0, $9655j.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $5iRib.getBitValueFromBool)(!!((_consents$find = consents.find((key)=>key.key === (0, $gqq7m.ConsentHubKey).Functional)) !== null && _consents$find !== void 0 && _consents$find.granted));
    const analyticsConsent = (0, $5iRib.getBitValueFromBool)(!!((_consents$find2 = consents.find((key)=>key.key === (0, $gqq7m.ConsentHubKey).Analytics)) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
    const marketingConsent = (0, $5iRib.getBitValueFromBool)(!!((_consents$find3 = consents.find((key)=>key.key === (0, $gqq7m.ConsentHubKey).Marketing)) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
    const unknownConsent = (0, $5iRib.getBitValueFromBool)(!!((_consents$find4 = consents.find((key)=>key.key === (0, $gqq7m.ConsentHubKey).Unknown)) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $d6cdb40e4ab7989d$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $d6cdb40e4ab7989d$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $d6cdb40e4ab7989d$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $d6cdb40e4ab7989d$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $d6cdb40e4ab7989d$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $hQwKE.PreferenceCategory).StrictlyNecessary,
        (0, $hQwKE.PreferenceCategory).Functional,
        (0, $hQwKE.PreferenceCategory).Analytics,
        (0, $hQwKE.PreferenceCategory).Marketing,
        (0, $hQwKE.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $hQwKE.PreferenceCategory).StrictlyNecessary]: (0, $gqq7m.ConsentHubKey).StrictlyNecessary,
        [(0, $hQwKE.PreferenceCategory).Functional]: (0, $gqq7m.ConsentHubKey).Functional,
        [(0, $hQwKE.PreferenceCategory).Analytics]: (0, $gqq7m.ConsentHubKey).Analytics,
        [(0, $hQwKE.PreferenceCategory).Marketing]: (0, $gqq7m.ConsentHubKey).Marketing,
        [(0, $hQwKE.PreferenceCategory).Unknown]: (0, $gqq7m.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $d6cdb40e4ab7989d$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $d6cdb40e4ab7989d$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $d6cdb40e4ab7989d$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $d6cdb40e4ab7989d$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $d6cdb40e4ab7989d$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $d6cdb40e4ab7989d$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d6cdb40e4ab7989d$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("gqq7m", function(module, exports) {
$parcel$export(module.exports, "ConsentHubKey", () => $a3615acf721f4e7b$export$31140359b1e505cf);
var $a3615acf721f4e7b$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("68rNz", function(module, exports) {
$parcel$export(module.exports, "checkTokenVersionValidity", () => $1702ba4ce81aea71$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $1702ba4ce81aea71$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $1702ba4ce81aea71$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $1702ba4ce81aea71$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $1702ba4ce81aea71$export$7962405c3ca274b1);

var $5ROjv = parcelRequire("5ROjv");

var $5iRib = parcelRequire("5iRib");

var $9655j = parcelRequire("9655j");

var $5Vfju = parcelRequire("5Vfju");

var $hQwKE = parcelRequire("hQwKE");
const $1702ba4ce81aea71$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $9655j.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $9655j.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $9655j.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $9655j.V001_SCHEMA_KEY),
        (0, $9655j.V002_SCHEMA_KEY),
        (0, $9655j.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $1702ba4ce81aea71$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $9655j.V001_SCHEMA_KEY);
    return [
        version,
        (0, $5iRib.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $5iRib.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $5iRib.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $5iRib.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $1702ba4ce81aea71$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $hQwKE.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $hQwKE.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $hQwKE.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $hQwKE.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $hQwKE.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $1702ba4ce81aea71$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $9655j.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $hQwKE.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $hQwKE.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $hQwKE.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $hQwKE.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.PreferenceCategory).Functional]),
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.PreferenceCategory).Analytics]),
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.PreferenceCategory).Marketing]),
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.PreferenceCategory).Unknown]),
        (0, $5iRib.getBitValueFromBool)(isDefaultConsentBit),
        (0, $5iRib.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $5iRib.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $1702ba4ce81aea71$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $5Vfju.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$1702ba4ce81aea71$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $hQwKE.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $1702ba4ce81aea71$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $9655j.V003_SCHEMA_KEY);
    return [
        version,
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.PreferenceCategory).Functional]),
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.PreferenceCategory).Analytics]),
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.PreferenceCategory).Marketing]),
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.PreferenceCategory).Unknown]),
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $5iRib.getBitValueFromBool)(userPreferences[(0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $1702ba4ce81aea71$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $hQwKE.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $hQwKE.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $hQwKE.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $hQwKE.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $hQwKE.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $hQwKE.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $1702ba4ce81aea71$var$V002SpecificBitKeys = [
    (0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $hQwKE.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $hQwKE.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $hQwKE.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $hQwKE.ConsentPreferenceV2).ConsentedUnderFADP
];
const $1702ba4ce81aea71$var$V003SpecificBitKeys = [
    (0, $hQwKE.ContextualConsentProperty).ConsentsAreDefault,
    (0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated,
    (0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable
];
function $1702ba4ce81aea71$export$3199823fec979bd1(userPreferences) {
    if ((0, $5ROjv.getBscGlobalState)().localConsentMode) return $1702ba4ce81aea71$var$packPrefsVersion001(userPreferences);
    const isV002 = $1702ba4ce81aea71$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $1702ba4ce81aea71$var$packPrefsVersion002(userPreferences);
    const isV003 = $1702ba4ce81aea71$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $1702ba4ce81aea71$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $1702ba4ce81aea71$var$packPrefsVersion001(userPreferences);
}
function $1702ba4ce81aea71$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $5ROjv.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $9655j.V001_SCHEMA_KEY)) return $1702ba4ce81aea71$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $1702ba4ce81aea71$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $1702ba4ce81aea71$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $1702ba4ce81aea71$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $1702ba4ce81aea71$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $1702ba4ce81aea71$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $1702ba4ce81aea71$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $hQwKE.PrefetchedPreferenceState).INTERNAL) {
        if ($1702ba4ce81aea71$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $1702ba4ce81aea71$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $5Vfju.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $1702ba4ce81aea71$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $hQwKE.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("4DT4d", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $45d0d197adca60d7$export$93509ff9a62ee022);

var $8Bt4H = parcelRequire("8Bt4H");

var $e6Qdr = parcelRequire("e6Qdr");

var $hamKY = parcelRequire("hamKY");

var $gc3OY = parcelRequire("gc3OY");
const $45d0d197adca60d7$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $e6Qdr.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        (0, $hamKY.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("8XhRY", function(module, exports) {
$parcel$export(module.exports, "getValidConsentData", () => $cf605a11be9201af$export$c515de1cc9cebc71);

var $9655j = parcelRequire("9655j");

var $bh4gv = parcelRequire("bh4gv");

var $68rNz = parcelRequire("68rNz");
const $cf605a11be9201af$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $bh4gv.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $68rNz.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, $9655j.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("bh4gv", function(module, exports) {
$parcel$export(module.exports, "buildConsentPreferences", () => $f3d5bf7d573c6741$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $f3d5bf7d573c6741$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $f3d5bf7d573c6741$export$f8422650c3dec8b2);

var $gc3OY = parcelRequire("gc3OY");

var $5Vfju = parcelRequire("5Vfju");
const $f3d5bf7d573c6741$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $f3d5bf7d573c6741$var$POST_CONSENTS_URL = `${$f3d5bf7d573c6741$var$BASE_CONSENTS_URL}/user`;
const $f3d5bf7d573c6741$var$GET_CONSENTS_URL = `${$f3d5bf7d573c6741$var$POST_CONSENTS_URL}/consents/cookies`;
const $f3d5bf7d573c6741$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $5Vfju.serializeConsents)(consentData);
        const consentTimestamp = (0, $5Vfju.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $5Vfju.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $f3d5bf7d573c6741$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$f3d5bf7d573c6741$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $f3d5bf7d573c6741$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $f3d5bf7d573c6741$export$bd9f5bcbf9cd947c();
    }
};
const $f3d5bf7d573c6741$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $5Vfju.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $f3d5bf7d573c6741$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$f3d5bf7d573c6741$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $f3d5bf7d573c6741$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $5Vfju.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});






parcelRegister("ktQue", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $53f426d236726cb6$export$f1b0c189562aa9fd);

var $hamKY = parcelRequire("hamKY");

var $gc3OY = parcelRequire("gc3OY");

var $hQwKE = parcelRequire("hQwKE");

var $1NYQF = parcelRequire("1NYQF");
const $53f426d236726cb6$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $hamKY.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // Store the item as a record in our IDB service to track that we've seen it before.
        // That way, when we can confirm/deny that this has been set by our service when we check again.
        // If it fails for some reason, it will be caught before actually setting the item
        // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
        (0, $1NYQF.BSCIndexedDB).setRecord(itemKey).then(()=>{
        // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
        }).catch(()=>{
            (0, $hamKY.sendPackageOperationalEvent)({
                action: 'indexDbSetRecordError',
                attributes: eventAttributes
            });
        });
        browserStorage.setItem(itemKey, value);
        return (0, $hQwKE.Status).SUCCESS;
    } catch (e) {
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $hQwKE.Status).FAILED;
    }
};

});


parcelRegister("jkbTO", function(module, exports) {
$parcel$export(module.exports, "safeAccessWithErrorHandler", () => $d6f1b59c81fbbf67$export$d1415594ea5ec958);
const $d6f1b59c81fbbf67$export$d1415594ea5ec958 = (action, errorCase)=>{
    try {
        return action();
    } catch (err) {
        return errorCase && errorCase();
    }
};

});


parcelRegister("dMQwV", function(module, exports) {
$parcel$export(module.exports, "LOG_OUT", () => $a0279901db8c85bd$export$cb307dad255adf47);
$parcel$export(module.exports, "logOutAction", () => $a0279901db8c85bd$export$1a3865346be34527);
const $a0279901db8c85bd$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
const $a0279901db8c85bd$export$1a3865346be34527 = ()=>{
    return {
        type: $a0279901db8c85bd$export$cb307dad255adf47
    };
};

});


parcelRegister("gFQz2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3b90a6ab7db87d1$export$2e2bcd8739ae039);
parcelRequire("durY1");
var $fPmNS = parcelRequire("fPmNS");

var $vhVCW = parcelRequire("vhVCW");

var $kczjI = parcelRequire("kczjI");

var $1EFS8 = parcelRequire("1EFS8");

var $2WG3C = parcelRequire("2WG3C");

var $8GIAM = parcelRequire("8GIAM");

var $dRiXp = parcelRequire("dRiXp");

var $g5Gh7 = parcelRequire("g5Gh7");

var $2sagk = parcelRequire("2sagk");

var $7XbF2 = parcelRequire("7XbF2");

var $krCZJ = parcelRequire("krCZJ");

var $jGA0H = parcelRequire("jGA0H");

var $b67CP = parcelRequire("b67CP");

var $eZb1I = parcelRequire("eZb1I");

var $jpm2U = parcelRequire("jpm2U");

var $cd3Lh = parcelRequire("cd3Lh");

var $as35A = parcelRequire("as35A");

var $k2QNx = parcelRequire("k2QNx");

var $62zut = parcelRequire("62zut");

var $dmkFQ = parcelRequire("dmkFQ");

var $dC4A1 = parcelRequire("dC4A1");

var $fAruA = parcelRequire("fAruA");

var $fIxI7 = parcelRequire("fIxI7");

var $8782V = parcelRequire("8782V");

var $BGWcE = parcelRequire("BGWcE");

var $lnh4q = parcelRequire("lnh4q");

var $jZ8mq = parcelRequire("jZ8mq");

var $2wwAp = parcelRequire("2wwAp");
var // Need to force typescript to pick up the right combineEpics
$c3b90a6ab7db87d1$export$2e2bcd8739ae039 = (0, $fPmNS.combineEpics)((0, $jGA0H.helpCenterBrandingEpic), (0, $jGA0H.helpCenterEpic), (0, $jGA0H.invalidateHelpCenterBrandingEpic), (0, $62zut.portalEpic), (0, $62zut.portalUploadMediaTokenEpic), (0, $62zut.refreshPortalUploadMediaTokenBeforeExpiryEpic), (0, $vhVCW.default), (0, $k2QNx.organisationsEpic), (0, $dmkFQ.requestCreateEpic), (0, $fIxI7.requestTypeSuggestionEpic), (0, $2sagk.connectFragmentsEpic), (0, $eZb1I.default), (0, $b67CP.default), (0, $jZ8mq.unsubscribedConfirmationEpic), (0, $cd3Lh.loginEpic), (0, $as35A.loginAnnouncementsEpic), (0, $krCZJ.forgotPasswordEpic), (0, $dRiXp.fetchArticleEpic), (0, $dC4A1.requestDetailsEpic), (0, $fAruA.requestListEpic), (0, $8782V.requestsColumnSettingsEpic), (0, $8GIAM.approvalListEpic), (0, $jpm2U.languagesEpic), (0, $BGWcE.timezoneRegionsEpic), (0, $BGWcE.timezonesEpic), (0, $2sagk.profileConnectFragmentsEpic), (0, $2wwAp.visitPortalEpic), (0, $g5Gh7.completeSignupEpic), (0, $kczjI.default), (0, $7XbF2.featuredAndSortedPortalsEpic), (0, $2WG3C.aiAnswerFeedbackPageEpic), ...(0, $1EFS8.default).checkGate('ditto_uim_root_query_rest') ? [
    (0, $lnh4q.uiModificationsEpic)
] : []);

});
parcelRegister("vhVCW", function(module, exports) {
$parcel$export(module.exports, "default", () => $de46785b3c7d7a00$export$2e2bcd8739ae039);

var $fSYYZ = parcelRequire("fSYYZ");
parcelRequire("6Fjys");
var $8ICBx = parcelRequire("8ICBx");

var $jTCFd = parcelRequire("jTCFd");

var $2gQsf = parcelRequire("2gQsf");
const $de46785b3c7d7a00$var$epic = (action$)=>{
    return action$.ofType((0, $2gQsf.FETCH_USER_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).map((response)=>{
            // If we requested for a user model but never got one or got an empty user object we assume that the user is anonymous.
            if (!response.user || !response.user.accountId) return (0, $8ICBx.updateUserModelAnonymousAction)();
            return (0, $8ICBx.updateUserModelAction)(response.user);
        }).catch(()=>(0, $fSYYZ.Observable).never()));
};
var $de46785b3c7d7a00$export$2e2bcd8739ae039 = $de46785b3c7d7a00$var$epic;

});
parcelRegister("2gQsf", function(module, exports) {
$parcel$export(module.exports, "FETCH_USER_MODEL", () => $f58901132bd44c1f$export$d79dd8ba2ab60f61);
$parcel$export(module.exports, "fetchUserModelAction", () => $f58901132bd44c1f$export$d4f34f8f1b2704a8);

var $cWsyg = parcelRequire("cWsyg");
const $f58901132bd44c1f$export$d79dd8ba2ab60f61 = 'epic.model.FETCH_USER_MODEL';
const $f58901132bd44c1f$export$d4f34f8f1b2704a8 = (params = {})=>{
    const excludeRequestCountsParam = {
        ...params,
        fetchRequestCounts: false
    };
    return (0, $cWsyg.buildModelsActionCreator)($f58901132bd44c1f$export$d79dd8ba2ab60f61, 'user')(excludeRequestCountsParam);
};

});


parcelRegister("kczjI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a999c5d7fab68cf3$export$2e2bcd8739ae039);

var $fSYYZ = parcelRequire("fSYYZ");

var $8ICBx = parcelRequire("8ICBx");

var $jTCFd = parcelRequire("jTCFd");

var $7jGoV = parcelRequire("7jGoV");
const $a999c5d7fab68cf3$var$fetchUserRequestsCountsEpic = (action$)=>{
    return action$.ofType((0, $7jGoV.FETCH_USER_REQUESTS_COUNTS_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload, {
            type: 'secondary'
        }).filter((response)=>!!response.userRequestsCounts).map((response)=>(0, $8ICBx.updateUserRequestsCountsAction)(response.userRequestsCounts)).catch(()=>(0, $fSYYZ.Observable).never()));
};
var $a999c5d7fab68cf3$export$2e2bcd8739ae039 = $a999c5d7fab68cf3$var$fetchUserRequestsCountsEpic;

});
parcelRegister("7jGoV", function(module, exports) {
$parcel$export(module.exports, "FETCH_USER_REQUESTS_COUNTS_MODEL", () => $8dc5d70bd72e7b2f$export$dfecf710cdf030b1);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => $8dc5d70bd72e7b2f$export$71172847a48a08a6);

var $cWsyg = parcelRequire("cWsyg");
const $8dc5d70bd72e7b2f$export$dfecf710cdf030b1 = 'epic.model.FETCH_USER_REQUESTS_COUNTS_MODEL';
const $8dc5d70bd72e7b2f$export$71172847a48a08a6 = (0, $cWsyg.buildModelsActionCreator)($8dc5d70bd72e7b2f$export$dfecf710cdf030b1, 'userRequestsCounts');

});


parcelRegister("2WG3C", function(module, exports) {
$parcel$export(module.exports, "aiAnswerFeedbackPageEpic", () => $87a20eee54c08cc9$export$ceff4b1bfa1bc6ba);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("hQvsi");
var $cDjgl = parcelRequire("cDjgl");
const $87a20eee54c08cc9$export$ceff4b1bfa1bc6ba = (action$)=>{
    return action$.ofType((0, $cDjgl.FETCH_AI_ANSWER_FEEDBACK_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.aianswer).map((response)=>{
            return (0, $cDjgl.fetchAiAnswerFeedbackSuccess)(response.aianswer);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $cDjgl.fetchAiAnswerFeedbackFailure)(error));
        }));
};

});
parcelRegister("hQvsi", function(module, exports) {
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_MODEL", () => (parcelRequire("cDjgl")).FETCH_AI_ANSWER_FEEDBACK_MODEL);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_SUCCESS", () => (parcelRequire("cDjgl")).FETCH_AI_ANSWER_FEEDBACK_SUCCESS);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_FAILURE", () => (parcelRequire("cDjgl")).FETCH_AI_ANSWER_FEEDBACK_FAILURE);
$parcel$export(module.exports, "fetchAiAnswerFeedbackModel", () => (parcelRequire("cDjgl")).fetchAiAnswerFeedbackModel);
$parcel$export(module.exports, "fetchAiAnswerFeedbackSuccess", () => (parcelRequire("cDjgl")).fetchAiAnswerFeedbackSuccess);
$parcel$export(module.exports, "fetchAiAnswerFeedbackFailure", () => (parcelRequire("cDjgl")).fetchAiAnswerFeedbackFailure);

var $cDjgl = parcelRequire("cDjgl");

});
parcelRegister("cDjgl", function(module, exports) {
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_MODEL", () => $f6fdbadabe779f57$export$ae77fa01ad25f4c9);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_SUCCESS", () => $f6fdbadabe779f57$export$6f922337a7af3b9);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_FAILURE", () => $f6fdbadabe779f57$export$4daab78c9d39cdb5);
$parcel$export(module.exports, "fetchAiAnswerFeedbackModel", () => $f6fdbadabe779f57$export$4514f111c053f647);
$parcel$export(module.exports, "fetchAiAnswerFeedbackSuccess", () => $f6fdbadabe779f57$export$4da568a91bd226dc);
$parcel$export(module.exports, "fetchAiAnswerFeedbackFailure", () => $f6fdbadabe779f57$export$a1584ed81f70c36d);

var $cWsyg = parcelRequire("cWsyg");
const $f6fdbadabe779f57$export$ae77fa01ad25f4c9 = 'epic.model.FETCH_AI_ANSWER_FEEDBACK_MODEL';
const $f6fdbadabe779f57$export$6f922337a7af3b9 = 'state.persisted.ai.answer.feedback.FETCH_AI_ANSWER_FEEDBACK_SUCCESS';
const $f6fdbadabe779f57$export$4daab78c9d39cdb5 = 'state.persisted.ai.answer.feedback.FETCH_AI_ANSWER_FEEDBACK_FAILURE';
const $f6fdbadabe779f57$export$4514f111c053f647 = (0, $cWsyg.buildModelsActionCreator)($f6fdbadabe779f57$export$ae77fa01ad25f4c9, 'aianswer');
const $f6fdbadabe779f57$export$4da568a91bd226dc = (aiAnswerFeedbackResponse)=>({
        type: $f6fdbadabe779f57$export$6f922337a7af3b9,
        payload: aiAnswerFeedbackResponse
    });
const $f6fdbadabe779f57$export$a1584ed81f70c36d = (error)=>({
        type: $f6fdbadabe779f57$export$4daab78c9d39cdb5,
        payload: {
            error: error
        }
    });

});



parcelRegister("8GIAM", function(module, exports) {
$parcel$export(module.exports, "approvalListEpic", () => $e0bcf527a06e827d$export$77e5ddee619f2d69);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("jTmWg");
var $kN7vu = parcelRequire("kN7vu");
const $e0bcf527a06e827d$export$77e5ddee619f2d69 = (action$)=>{
    return action$.ofType((0, $kN7vu.FETCH_APPROVAL_LIST_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.approvalListFilter && !!response.approvalListFilter.requests).map((response)=>{
            return (0, $kN7vu.fetchApprovalListSuccess)(response.approvalListFilter);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $kN7vu.fetchApprovalListFailure)(error));
        }));
};

});
parcelRegister("jTmWg", function(module, exports) {
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_MODEL", () => (parcelRequire("kN7vu")).FETCH_APPROVAL_LIST_MODEL);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_SUCCESS", () => (parcelRequire("kN7vu")).FETCH_APPROVAL_LIST_SUCCESS);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_FAILURE", () => (parcelRequire("kN7vu")).FETCH_APPROVAL_LIST_FAILURE);
$parcel$export(module.exports, "fetchApprovalListModel", () => (parcelRequire("kN7vu")).fetchApprovalListModel);
$parcel$export(module.exports, "fetchApprovalListSuccess", () => (parcelRequire("kN7vu")).fetchApprovalListSuccess);
$parcel$export(module.exports, "fetchApprovalListFailure", () => (parcelRequire("kN7vu")).fetchApprovalListFailure);

var $kN7vu = parcelRequire("kN7vu");

});
parcelRegister("kN7vu", function(module, exports) {
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_MODEL", () => $781030f1187257f2$export$2e7343d23ce2e264);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_SUCCESS", () => $781030f1187257f2$export$42d9c935d4bfef61);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_FAILURE", () => $781030f1187257f2$export$132a25b8ba1cc94);
$parcel$export(module.exports, "fetchApprovalListModel", () => $781030f1187257f2$export$c4decf32e9c96894);
$parcel$export(module.exports, "fetchApprovalListSuccess", () => $781030f1187257f2$export$2ac6685d409334fa);
$parcel$export(module.exports, "fetchApprovalListFailure", () => $781030f1187257f2$export$9059cd838e20fcf6);

var $cWsyg = parcelRequire("cWsyg");
const $781030f1187257f2$export$2e7343d23ce2e264 = 'epic.model.FETCH_APPROVAL_LIST_MODEL';
const $781030f1187257f2$export$42d9c935d4bfef61 = 'state.persisted.approval.List.FETCH_APPROVAL_LIST_SUCCESS';
const $781030f1187257f2$export$132a25b8ba1cc94 = 'state.persisted.approval.List.FETCH_APPROVAL_LIST_FAILURE';
const $781030f1187257f2$export$c4decf32e9c96894 = (0, $cWsyg.buildModelsActionCreator)($781030f1187257f2$export$2e7343d23ce2e264, 'approvalListFilter');
const $781030f1187257f2$export$2ac6685d409334fa = (approvalListFilter)=>({
        type: $781030f1187257f2$export$42d9c935d4bfef61,
        payload: approvalListFilter
    });
const $781030f1187257f2$export$9059cd838e20fcf6 = (error)=>({
        type: $781030f1187257f2$export$132a25b8ba1cc94,
        payload: {
            error: error
        }
    });

});



parcelRegister("dRiXp", function(module, exports) {
$parcel$export(module.exports, "fetchArticleEpic", () => $d393f1bee1b4cb01$export$3c4e80b80ffa2c37);

var $fSYYZ = parcelRequire("fSYYZ");
parcelRequire("gExuy");
var $4W5Ru = parcelRequire("4W5Ru");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");

var $jTCFd = parcelRequire("jTCFd");
const $d393f1bee1b4cb01$export$3c4e80b80ffa2c37 = (action$)=>action$.ofType((0, $4W5Ru.FETCH_ARTICLE)).mergeMap((action)=>{
        const { meta: meta } = action;
        return (0, $jTCFd.default)(action.payload).filter((response)=>!!response.kbPage).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $4W5Ru.fetchArticleSuccess)(response.kbPage);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $fonw6.isNetworkOrClientErrorCode)(error.status)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $4W5Ru.fetchArticleFailure)(action.payload.params.id, error));
        });
    });

});

parcelRegister("g5Gh7", function(module, exports) {
$parcel$export(module.exports, "completeSignupEpic", () => $9088024909b5b3e0$export$c3902030a5d4d47a);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("l0dvx");
var $053zO = parcelRequire("053zO");
const $9088024909b5b3e0$export$c3902030a5d4d47a = (action$)=>{
    return action$.ofType((0, $053zO.FETCH_COMPLETE_SIGNUP_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.completeSignup && !!response.completeSignup.emailAddress).map((response)=>{
            return (0, $053zO.fetchCompleteSignupSuccess)(response.completeSignup);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $053zO.fetchCompleteSignupFailure)(error));
        }));
};

});

parcelRegister("2sagk", function(module, exports) {
$parcel$export(module.exports, "connectFragmentsEpic", () => $bec5d8429433bf3e$export$da9f118c732015e);
$parcel$export(module.exports, "profileConnectFragmentsEpic", () => $bec5d8429433bf3e$export$a3ede6811238e533);

var $fSYYZ = parcelRequire("fSYYZ");
parcelRequire("6TVgw");
var $ddmND = parcelRequire("ddmND");

var $jTCFd = parcelRequire("jTCFd");
const $bec5d8429433bf3e$export$da9f118c732015e = (action$)=>action$.ofType((0, $ddmND.FETCH_CONNECT_FRAGMENTS)).mergeMap((action)=>(0, $jTCFd.default)(action.payload, {
            type: action.payload.params.portalPage === 'CREATE_REQUEST' ? 'secondary' : 'primary'
        }).filter((response)=>!!response.portalWebFragments).map((response)=>{
            const { portalPage: portalPage, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = action.payload.params;
            return (0, $ddmND.fetchConnectFragmentsSuccess)({
                portalId: portalId,
                requestTypeId: requestTypeId,
                requestKey: requestKey,
                portalPageName: portalPage,
                connectFragments: response.portalWebFragments
            });
        }).catch((error)=>{
            const { portalPage: portalPage, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = action.payload.params;
            return (0, $fSYYZ.Observable).of((0, $ddmND.fetchConnectFragmentsFailure)({
                portalId: portalId,
                requestTypeId: requestTypeId,
                error: error,
                requestKey: requestKey,
                portalPageName: portalPage
            }));
        }));
const $bec5d8429433bf3e$export$a3ede6811238e533 = (action$)=>action$.ofType((0, $ddmND.FETCH_PROFILE_CONNECT_FRAGMENTS)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.profileWebFragments).map((response)=>{
            return (0, $ddmND.fetchProfileConnectFragmentsSuccess)(response.profileWebFragments);
        }).catch((error)=>(0, $fSYYZ.Observable).of((0, $ddmND.fetchProfileConnectFragmentsFailure)(error))));

});
parcelRegister("6TVgw", function(module, exports) {
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS", () => (parcelRequire("ddmND")).FETCH_CONNECT_FRAGMENTS);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_FAILURE", () => (parcelRequire("ddmND")).FETCH_CONNECT_FRAGMENTS_FAILURE);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_SUCCESS", () => (parcelRequire("ddmND")).FETCH_CONNECT_FRAGMENTS_SUCCESS);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS", () => (parcelRequire("ddmND")).FETCH_PROFILE_CONNECT_FRAGMENTS);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE", () => (parcelRequire("ddmND")).FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS", () => (parcelRequire("ddmND")).FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS);
$parcel$export(module.exports, "fetchConnectFragmentsSuccess", () => (parcelRequire("ddmND")).fetchConnectFragmentsSuccess);
$parcel$export(module.exports, "fetchConnectFragmentsFailure", () => (parcelRequire("ddmND")).fetchConnectFragmentsFailure);
$parcel$export(module.exports, "fetchProfileConnectFragmentsFailure", () => (parcelRequire("ddmND")).fetchProfileConnectFragmentsFailure);
$parcel$export(module.exports, "fetchProfileConnectFragmentsSuccess", () => (parcelRequire("ddmND")).fetchProfileConnectFragmentsSuccess);
$parcel$export(module.exports, "fetchConnectFragmentsAction", () => (parcelRequire("ddmND")).fetchConnectFragmentsAction);
$parcel$export(module.exports, "fetchProfileConnectFragmentsAction", () => (parcelRequire("ddmND")).fetchProfileConnectFragmentsAction);

var $ddmND = parcelRequire("ddmND");

});
parcelRegister("ddmND", function(module, exports) {
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_SUCCESS", () => $5b27d776fe20ec46$export$be3b6b321a4b2e30);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_FAILURE", () => $5b27d776fe20ec46$export$8c14498d55ee35d5);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS", () => $5b27d776fe20ec46$export$c4d0c4cc4d23ec29);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE", () => $5b27d776fe20ec46$export$ac33d6e70ef6394b);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS", () => $5b27d776fe20ec46$export$93b4a584ef971c3e);
$parcel$export(module.exports, "fetchConnectFragmentsAction", () => $5b27d776fe20ec46$export$bd274633ff57df1a);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS", () => $5b27d776fe20ec46$export$acefa59403de59c3);
$parcel$export(module.exports, "fetchProfileConnectFragmentsAction", () => $5b27d776fe20ec46$export$9b734d900be9577d);
$parcel$export(module.exports, "fetchConnectFragmentsSuccess", () => $5b27d776fe20ec46$export$2e62b6b504d95c08);
$parcel$export(module.exports, "fetchConnectFragmentsFailure", () => $5b27d776fe20ec46$export$ea99ad4f53065bdf);
$parcel$export(module.exports, "fetchProfileConnectFragmentsSuccess", () => $5b27d776fe20ec46$export$802082c6f9bfe7);
$parcel$export(module.exports, "fetchProfileConnectFragmentsFailure", () => $5b27d776fe20ec46$export$3b319d8313349388);

var $cWsyg = parcelRequire("cWsyg");
const $5b27d776fe20ec46$export$be3b6b321a4b2e30 = 'state.persisted.connect-addon.FETCH_CONNECT_FRAGMENTS_SUCCESS';
const $5b27d776fe20ec46$export$8c14498d55ee35d5 = 'state.persisted.connect-addon.FETCH_CONNECT_FRAGMENTS_FAILURE';
const $5b27d776fe20ec46$export$c4d0c4cc4d23ec29 = 'state.persisted.connect-addon.FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS';
const $5b27d776fe20ec46$export$ac33d6e70ef6394b = 'state.persisted.connect-addon.FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE';
const $5b27d776fe20ec46$export$93b4a584ef971c3e = 'epic.model.FETCH_CONNECT_FRAGMENTS';
const $5b27d776fe20ec46$export$bd274633ff57df1a = (0, $cWsyg.buildModelsActionCreator)($5b27d776fe20ec46$export$93b4a584ef971c3e, 'portalWebFragments');
const $5b27d776fe20ec46$export$acefa59403de59c3 = 'epic.model.FETCH_PROFILE_CONNECT_FRAGMENTS';
const $5b27d776fe20ec46$export$9b734d900be9577d = (0, $cWsyg.buildModelsActionCreator)($5b27d776fe20ec46$export$acefa59403de59c3, 'profileWebFragments');
const $5b27d776fe20ec46$export$2e62b6b504d95c08 = ({ portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, connectFragments: connectFragments, requestKey: requestKey })=>({
        type: $5b27d776fe20ec46$export$be3b6b321a4b2e30,
        payload: {
            portalPageName: portalPageName,
            portalId: portalId,
            requestTypeId: requestTypeId,
            connectFragments: connectFragments,
            requestKey: requestKey
        }
    });
const $5b27d776fe20ec46$export$ea99ad4f53065bdf = ({ portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, error: error, requestKey: requestKey })=>({
        type: $5b27d776fe20ec46$export$8c14498d55ee35d5,
        payload: {
            portalPageName: portalPageName,
            portalId: portalId,
            requestTypeId: requestTypeId,
            error: error,
            requestKey: requestKey
        }
    });
const $5b27d776fe20ec46$export$802082c6f9bfe7 = (fragments)=>({
        type: $5b27d776fe20ec46$export$c4d0c4cc4d23ec29,
        payload: {
            fragments: fragments
        }
    });
const $5b27d776fe20ec46$export$3b319d8313349388 = (error)=>({
        type: $5b27d776fe20ec46$export$ac33d6e70ef6394b,
        payload: {
            error: error
        }
    });

});



parcelRegister("7XbF2", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsEpic", () => $2bfd109c6d65e64c$export$482dd9b2afe107b5);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("9ueTd");
var $99eJc = parcelRequire("99eJc");

var $gk18s = parcelRequire("gk18s");

var $lK7wN = parcelRequire("lK7wN");
const $2bfd109c6d65e64c$var$emptyFeaturedAndSortedPortalsResponse = {
    portals: [],
    total: 0
};
const $2bfd109c6d65e64c$export$482dd9b2afe107b5 = (action$)=>{
    return action$.ofType((0, $99eJc.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL)).mergeMap((action)=>{
        const { isPortalReorderingSelected: isPortalReorderingSelected, ...params } = action.payload.params;
        if ((0, $gk18s.isKoshEnabledForDefaultHelpCenter)()) return (0, $fSYYZ.Observable).from((0, $lK7wN.fetchFeaturedAndSortedPortalsData)(params).toPromise().then((response)=>(0, $lK7wN.convertToFeaturedAndSortedPortalsResponse)(response))).flatMap((data)=>{
            return (0, $fSYYZ.Observable).of((0, $99eJc.fetchFeaturedAndSortedPortalsSuccess)(data || $2bfd109c6d65e64c$var$emptyFeaturedAndSortedPortalsResponse, action.payload.params));
        }).catch((error)=>{
            //if error while fetching sorted data, show error flag using ajax error payload
            if (action.payload.params.sortBy) return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $99eJc.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params)), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error)));
            //for featured /un-featured portals, let component handle the error state
            return (0, $fSYYZ.Observable).of((0, $99eJc.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params));
        });
        return (0, $jTCFd.default)({
            ...action.payload,
            params: params
        }).filter((response)=>!!response.featuredAndSortedPortals).flatMap((response)=>{
            return (0, $fSYYZ.Observable).of((0, $99eJc.fetchFeaturedAndSortedPortalsSuccess)(response.featuredAndSortedPortals || $2bfd109c6d65e64c$var$emptyFeaturedAndSortedPortalsResponse, action.payload.params));
        }).catch((error)=>{
            //if error while fetching sorted data, show error flag using ajax error payload
            if (action.payload.params.sortBy) return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $99eJc.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params)), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error)));
            //for featured /un-featured portals, let component handle the error state
            return (0, $fSYYZ.Observable).of((0, $99eJc.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params));
        });
    });
};

});
parcelRegister("9ueTd", function(module, exports) {
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS", () => (parcelRequire("99eJc")).FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsSuccess", () => (parcelRequire("99eJc")).fetchFeaturedAndSortedPortalsSuccess);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_MODEL", () => (parcelRequire("99eJc")).FETCH_FEATURED_AND_SORTED_PORTALS_MODEL);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsModel", () => (parcelRequire("99eJc")).fetchFeaturedAndSortedPortalsModel);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE", () => (parcelRequire("99eJc")).FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsFailure", () => (parcelRequire("99eJc")).fetchFeaturedAndSortedPortalsFailure);
$parcel$export(module.exports, "REORDER_FEATURED_PORTAL", () => (parcelRequire("99eJc")).REORDER_FEATURED_PORTAL);
$parcel$export(module.exports, "reorderFeaturedPortal", () => (parcelRequire("99eJc")).reorderFeaturedPortal);
$parcel$export(module.exports, "MARK_PORTAL_FEATURED", () => (parcelRequire("99eJc")).MARK_PORTAL_FEATURED);
$parcel$export(module.exports, "markPortalFeatured", () => (parcelRequire("99eJc")).markPortalFeatured);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS", () => (parcelRequire("99eJc")).UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS);
$parcel$export(module.exports, "updatePortalReorderSettingsSuccess", () => (parcelRequire("99eJc")).updatePortalReorderSettingsSuccess);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL", () => (parcelRequire("99eJc")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL);
$parcel$export(module.exports, "updatePortalReorderSettingsModel", () => (parcelRequire("99eJc")).updatePortalReorderSettingsModel);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS", () => (parcelRequire("99eJc")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS);
$parcel$export(module.exports, "updatePortalReorderSettingsModelSuccess", () => (parcelRequire("99eJc")).updatePortalReorderSettingsModelSuccess);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE", () => (parcelRequire("99eJc")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE);
$parcel$export(module.exports, "updatePortalReorderSettingsModelFailure", () => (parcelRequire("99eJc")).updatePortalReorderSettingsModelFailure);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_FAILURE", () => (parcelRequire("99eJc")).UPDATE_PORTAL_REORDER_SETTINGS_FAILURE);
$parcel$export(module.exports, "updatePortalReorderSettingsFailure", () => (parcelRequire("99eJc")).updatePortalReorderSettingsFailure);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS", () => (parcelRequire("99eJc")).RESET_PORTAL_REORDER_SETTINGS);
$parcel$export(module.exports, "resetPortalReorderSettings", () => (parcelRequire("99eJc")).resetPortalReorderSettings);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS_SUCCESS", () => (parcelRequire("99eJc")).RESET_PORTAL_REORDER_SETTINGS_SUCCESS);
$parcel$export(module.exports, "resetPortalReorderSettingsSuccess", () => (parcelRequire("99eJc")).resetPortalReorderSettingsSuccess);
$parcel$export(module.exports, "MARK_PORTAL_REORDER_SETTINGS_DIRTY", () => (parcelRequire("99eJc")).MARK_PORTAL_REORDER_SETTINGS_DIRTY);
$parcel$export(module.exports, "markPortalReorderSettingsDirty", () => (parcelRequire("99eJc")).markPortalReorderSettingsDirty);
$parcel$export(module.exports, "TOGGLE_PORTAL_VISIBILITY", () => (parcelRequire("99eJc")).TOGGLE_PORTAL_VISIBILITY);
$parcel$export(module.exports, "togglePortalVisibility", () => (parcelRequire("99eJc")).togglePortalVisibility);

var $99eJc = parcelRequire("99eJc");

});
parcelRegister("99eJc", function(module, exports) {
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_MODEL", () => $a1f87a9f79dd8b0c$export$8772f11deb28968a);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS", () => $a1f87a9f79dd8b0c$export$6ed163277f07d17a);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE", () => $a1f87a9f79dd8b0c$export$9198b985767ee6a9);
$parcel$export(module.exports, "MARK_PORTAL_FEATURED", () => $a1f87a9f79dd8b0c$export$c4ada71ac24d5427);
$parcel$export(module.exports, "REORDER_FEATURED_PORTAL", () => $a1f87a9f79dd8b0c$export$e78177131adb1a7a);
$parcel$export(module.exports, "TOGGLE_PORTAL_VISIBILITY", () => $a1f87a9f79dd8b0c$export$f04d3c0a6161427f);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL", () => $a1f87a9f79dd8b0c$export$68f1a628095e7df5);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS", () => $a1f87a9f79dd8b0c$export$aa2114acd4f820aa);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE", () => $a1f87a9f79dd8b0c$export$2d425395f1203ae4);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS", () => $a1f87a9f79dd8b0c$export$e6dde7e78d51edc9);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_FAILURE", () => $a1f87a9f79dd8b0c$export$d6299724cb4f13de);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS", () => $a1f87a9f79dd8b0c$export$47862f368a701d13);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS_SUCCESS", () => $a1f87a9f79dd8b0c$export$bce4411b856ef9e5);
$parcel$export(module.exports, "MARK_PORTAL_REORDER_SETTINGS_DIRTY", () => $a1f87a9f79dd8b0c$export$a90731f74ba59c30);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsModel", () => $a1f87a9f79dd8b0c$export$6ea18f901a4f825e);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsSuccess", () => $a1f87a9f79dd8b0c$export$6d3c5bcff4d8dcfc);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsFailure", () => $a1f87a9f79dd8b0c$export$9d041bf07bd04f34);
$parcel$export(module.exports, "markPortalFeatured", () => $a1f87a9f79dd8b0c$export$3b1a77584c9a6b81);
$parcel$export(module.exports, "togglePortalVisibility", () => $a1f87a9f79dd8b0c$export$89b8e7ec4e1c2d07);
$parcel$export(module.exports, "reorderFeaturedPortal", () => $a1f87a9f79dd8b0c$export$62b3d711c52e9aa2);
$parcel$export(module.exports, "updatePortalReorderSettingsModel", () => $a1f87a9f79dd8b0c$export$ff946f5ffd1293d7);
$parcel$export(module.exports, "updatePortalReorderSettingsModelSuccess", () => $a1f87a9f79dd8b0c$export$eeed66775c51f217);
$parcel$export(module.exports, "updatePortalReorderSettingsModelFailure", () => $a1f87a9f79dd8b0c$export$eb2d78b304e5909c);
$parcel$export(module.exports, "updatePortalReorderSettingsSuccess", () => $a1f87a9f79dd8b0c$export$8fabcd6d8271b790);
$parcel$export(module.exports, "updatePortalReorderSettingsFailure", () => $a1f87a9f79dd8b0c$export$4b50f99aebbcd6b7);
$parcel$export(module.exports, "resetPortalReorderSettings", () => $a1f87a9f79dd8b0c$export$4157bb81256cfd7f);
$parcel$export(module.exports, "markPortalReorderSettingsDirty", () => $a1f87a9f79dd8b0c$export$d0f9348a57407b6c);
$parcel$export(module.exports, "resetPortalReorderSettingsSuccess", () => $a1f87a9f79dd8b0c$export$5c52eef312473e8b);
const $a1f87a9f79dd8b0c$export$8772f11deb28968a = 'epic.model.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL';
const $a1f87a9f79dd8b0c$export$6ed163277f07d17a = 'state.persisted.featuredAndSortedPortals.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS';
const $a1f87a9f79dd8b0c$export$9198b985767ee6a9 = 'state.persisted.featuredAndSortedPortals.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE';
const $a1f87a9f79dd8b0c$export$c4ada71ac24d5427 = 'state.ui.featuredAndSortedPortals.MARK_PORTAL_FEATURED';
const $a1f87a9f79dd8b0c$export$e78177131adb1a7a = 'state.ui.featuredAndSortedPortals.REORDER_FEATURED_PORTAL';
const $a1f87a9f79dd8b0c$export$f04d3c0a6161427f = 'state.ui.featuredAndSortedPortals.TOGGLE_PORTAL_VISIBILITY';
const $a1f87a9f79dd8b0c$export$68f1a628095e7df5 = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL';
const $a1f87a9f79dd8b0c$export$aa2114acd4f820aa = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS';
const $a1f87a9f79dd8b0c$export$2d425395f1203ae4 = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE';
const $a1f87a9f79dd8b0c$export$e6dde7e78d51edc9 = 'state.persisted.featuredAndSortedPortals.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS';
const $a1f87a9f79dd8b0c$export$d6299724cb4f13de = 'state.ui.featuredAndSortedPortals.UPDATE_PORTAL_REORDER_SETTINGS_FAILURE';
const $a1f87a9f79dd8b0c$export$47862f368a701d13 = 'epic.portal-reorder-settings.RESET_PORTAL_REORDER_SETTINGS';
const $a1f87a9f79dd8b0c$export$bce4411b856ef9e5 = 'state.ui.featuredAndSortedPortals.RESET_PORTAL_REORDER_SETTINGS_SUCCESS';
const $a1f87a9f79dd8b0c$export$a90731f74ba59c30 = 'state.ui.featuredAndSortedPortals.MARK_PORTAL_REORDER_SETTINGS_DIRTY';
/* isPortalReorderingSelected is used to distinguish between the calls made to featuredAndSortedPortals model in case of help-seeker view from that of portal reordering screen view, inside the state reducers */ const $a1f87a9f79dd8b0c$var$buildModelsActionCreatorForFeaturedAndSortedPortals = (actionType, type)=>(params = {}, isPortalReorderingSelected)=>({
            type: actionType,
            payload: {
                type: type,
                params: {
                    ...params,
                    isPortalReorderingSelected: isPortalReorderingSelected
                }
            }
        });
const $a1f87a9f79dd8b0c$export$6ea18f901a4f825e = $a1f87a9f79dd8b0c$var$buildModelsActionCreatorForFeaturedAndSortedPortals($a1f87a9f79dd8b0c$export$8772f11deb28968a, 'featuredAndSortedPortals');
const $a1f87a9f79dd8b0c$export$6d3c5bcff4d8dcfc = (featuredAndSortedPortalsModel, requestParams)=>({
        requestParams: requestParams,
        type: $a1f87a9f79dd8b0c$export$6ed163277f07d17a,
        payload: featuredAndSortedPortalsModel
    });
const $a1f87a9f79dd8b0c$export$9d041bf07bd04f34 = (error, requestParams)=>({
        requestParams: requestParams,
        type: $a1f87a9f79dd8b0c$export$9198b985767ee6a9,
        payload: {
            error: error
        }
    });
const $a1f87a9f79dd8b0c$export$3b1a77584c9a6b81 = (id, isFeatured)=>({
        type: $a1f87a9f79dd8b0c$export$c4ada71ac24d5427,
        payload: {
            isFeatured: isFeatured,
            id: id
        }
    });
const $a1f87a9f79dd8b0c$export$89b8e7ec4e1c2d07 = (id, hiddenFromHomeScreen)=>({
        type: $a1f87a9f79dd8b0c$export$f04d3c0a6161427f,
        payload: {
            id: id,
            hiddenFromHomeScreen: hiddenFromHomeScreen
        }
    });
const $a1f87a9f79dd8b0c$export$62b3d711c52e9aa2 = (oldIndex, newIndex)=>({
        type: $a1f87a9f79dd8b0c$export$e78177131adb1a7a,
        payload: {
            oldIndex: oldIndex,
            newIndex: newIndex
        }
    });
const $a1f87a9f79dd8b0c$export$ff946f5ffd1293d7 = (meta)=>({
        meta: meta,
        type: $a1f87a9f79dd8b0c$export$68f1a628095e7df5
    });
const $a1f87a9f79dd8b0c$export$eeed66775c51f217 = (meta)=>({
        meta: meta,
        type: $a1f87a9f79dd8b0c$export$aa2114acd4f820aa
    });
const $a1f87a9f79dd8b0c$export$eb2d78b304e5909c = (meta, error)=>({
        meta: meta,
        error: error,
        type: $a1f87a9f79dd8b0c$export$2d425395f1203ae4
    });
const $a1f87a9f79dd8b0c$export$8fabcd6d8271b790 = (featuredPortalIds, sortBy, orderedPortalIds, hiddenPortalIds)=>({
        type: $a1f87a9f79dd8b0c$export$e6dde7e78d51edc9,
        payload: {
            featuredPortalIds: featuredPortalIds,
            sortBy: sortBy,
            orderedPortalIds: orderedPortalIds,
            hiddenPortalIds: hiddenPortalIds
        }
    });
const $a1f87a9f79dd8b0c$export$4b50f99aebbcd6b7 = (error)=>({
        type: $a1f87a9f79dd8b0c$export$d6299724cb4f13de,
        payload: {
            error: error
        }
    });
const $a1f87a9f79dd8b0c$export$4157bb81256cfd7f = (shouldRedirect)=>({
        type: $a1f87a9f79dd8b0c$export$47862f368a701d13,
        payload: {
            shouldRedirect: shouldRedirect
        }
    });
const $a1f87a9f79dd8b0c$export$d0f9348a57407b6c = ()=>({
        type: $a1f87a9f79dd8b0c$export$a90731f74ba59c30
    });
const $a1f87a9f79dd8b0c$export$5c52eef312473e8b = (featuredPortalIds, orderedPortalIds, sortBy)=>({
        type: $a1f87a9f79dd8b0c$export$bce4411b856ef9e5,
        payload: {
            featuredPortalIds: featuredPortalIds,
            orderedPortalIds: orderedPortalIds,
            sortBy: sortBy
        }
    });

});


parcelRegister("lK7wN", function(module, exports) {
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsData", () => $c3b80dae03098678$export$1e547feda5a72cb5);
$parcel$export(module.exports, "convertToFeaturedAndSortedPortalsResponse", () => $c3b80dae03098678$export$af9ca8a283fc9983);

var $1bRtP = parcelRequire("1bRtP");

var $bhOdO = parcelRequire("bhOdO");

var $8iTFq = parcelRequire("8iTFq");

var $jByYr = parcelRequire("jByYr");

var $gyskF = parcelRequire("gyskF");
const $c3b80dae03098678$export$1e547feda5a72cb5 = (params)=>{
    return (0, $8iTFq.fetchQuery)((0, $gyskF.getRelayEnvironment)(), (0, $1bRtP.default), {
        cloudId: (0, $jByYr.getCloudId)(),
        helpCenterAri: (0, $jByYr.getHelpCenterAri)(),
        sortOrder: $c3b80dae03098678$var$getSortIngParams(params.sortBy),
        portalsFilter: $c3b80dae03098678$var$getFilterParams(params.exploreAll)
    });
};
const $c3b80dae03098678$var$getFilterParams = (exploreAll)=>{
    if (exploreAll) return undefined;
    return {
        typeFilter: [
            'VISIBLE'
        ]
    };
};
const $c3b80dae03098678$var$getSortIngParams = (sortBy)=>{
    if (sortBy === 'ALPHABETICALLY') return 'NAME_ASCENDING';
    if (sortBy === 'POPULARITY') return 'POPULARITY';
    return undefined;
};
const $c3b80dae03098678$var$getSortIngValues = (sortBy)=>{
    if (sortBy === 'NAME_ASCENDING') return 'ALPHABETICALLY';
    if (sortBy === 'POPULARITY') return 'POPULARITY';
    return undefined;
};
const $c3b80dae03098678$export$af9ca8a283fc9983 = (response)=>{
    var _response$helpCenter;
    if (response === undefined) return undefined;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') {
        const extensions = data.extensions;
        const message = data.message;
        if (extensions && Array.isArray(extensions) && extensions.length > 0 && message) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const { statusCode: statusCode } = extensions[0];
            const xhr = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                status: statusCode,
                responseType: 'json',
                response: data
            };
            throw new (0, $bhOdO.AjaxError)(`${message} with status ${String(statusCode)}`, xhr, {});
        }
        throw new Error(message || '');
    }
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter') {
        const portals = data.portals;
        const { portalsList: portalsList } = portals || {
            portalsList: []
        };
        return {
            sortBy: $c3b80dae03098678$var$getSortIngValues(portals === null || portals === void 0 ? void 0 : portals.sortOrder),
            // Backend will return all the portals there is no pagination
            total: portalsList === null || portalsList === void 0 ? void 0 : portalsList.length,
            // This FF has been rolled out so this is always true
            isPortalHidingEnabled: true,
            portals: (portalsList === null || portalsList === void 0 ? void 0 : portalsList.map((portal)=>({
                    // right now id is number will have to verify while backend integration
                    id: parseInt(portal.id, 10),
                    key: portal.key || '',
                    name: portal.name || '',
                    description: portal.description || '',
                    logoUrl: portal.logoUrl || undefined,
                    rank: portal.rank || -1,
                    portalBaseUrl: portal.portalBaseUrl,
                    isFeatured: !!portal.isFeatured,
                    hiddenFromHomeScreen: !!portal.isHidden,
                    isPortalNotVisibleOnHelpCentre: false
                }))) || []
        };
    }
    return undefined;
};

});
parcelRegister("1bRtP", function(module, exports) {
$parcel$export(module.exports, "default", () => $8de8c57a00a5c95d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d849493470a62f53c7a36f89d8810125>>
 * @relayHash 25e6269361cd6efc34c09587ad76c352
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f39ee54689dc5a6ad3d842c0a754bc231a105713b5b09a391d0a41c535fcb10e
const $8de8c57a00a5c95d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalsFilter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortOrder"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "portalsFilter",
                "variableName": "portalsFilter"
            },
            {
                "kind": "Variable",
                "name": "sortOrder",
                "variableName": "sortOrder"
            }
        ],
        "concreteType": "HelpCenterPortals",
        "kind": "LinkedField",
        "name": "portals",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sortOrder"
            },
            {
                "concreteType": "HelpCenterPortal",
                "kind": "LinkedField",
                "name": "portalsList",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "logoUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "portalBaseUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isFeatured"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isHidden"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "rank"
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "featuredAndSortedPortalsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "featuredAndSortedPortalsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f39ee54689dc5a6ad3d842c0a754bc231a105713b5b09a391d0a41c535fcb10e",
            "metadata": {},
            "name": "featuredAndSortedPortalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8de8c57a00a5c95d$var$node.hash = "db239181519d00ccb6f4d7cba5dc3acd";
var $8de8c57a00a5c95d$export$2e2bcd8739ae039 = $8de8c57a00a5c95d$var$node;

});



parcelRegister("krCZJ", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $c50c4ead668b4590$export$cb36b6e8b9a45314);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("hXKIi");
var $6Dmyj = parcelRequire("6Dmyj");

var $2O4bV = parcelRequire("2O4bV");
const $c50c4ead668b4590$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $2O4bV.FETCH_FORGOT_PASSWORD_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.forgotPassword && !!response.forgotPassword.resetUrl).map((response)=>{
            return (0, $6Dmyj.fetchForgotPasswordModelSuccess)(response.forgotPassword);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $6Dmyj.fetchForgotPasswordModelFailure)(error));
        }));
};

});
parcelRegister("hXKIi", function(module, exports) {
$parcel$export(module.exports, "fetchForgotPasswordModelSuccess", () => (parcelRequire("6Dmyj")).fetchForgotPasswordModelSuccess);
$parcel$export(module.exports, "fetchForgotPasswordModelFailure", () => (parcelRequire("6Dmyj")).fetchForgotPasswordModelFailure);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("6Dmyj")).FETCH_FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_FAILURE", () => (parcelRequire("6Dmyj")).FETCH_FORGOT_PASSWORD_FAILURE);

var $6Dmyj = parcelRequire("6Dmyj");

});
parcelRegister("6Dmyj", function(module, exports) {
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_SUCCESS", () => $d0f8c6f206c587c4$export$78f743c8c0190142);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_FAILURE", () => $d0f8c6f206c587c4$export$aeb2acd4962d8ce9);
$parcel$export(module.exports, "fetchForgotPasswordModelSuccess", () => $d0f8c6f206c587c4$export$f5ac004adf4f85e3);
$parcel$export(module.exports, "fetchForgotPasswordModelFailure", () => $d0f8c6f206c587c4$export$d6a87818b7101f95);
const $d0f8c6f206c587c4$export$78f743c8c0190142 = 'state.persisted.forgot.password.FETCH_FORGOT_PASSWORD_SUCCESS';
const $d0f8c6f206c587c4$export$aeb2acd4962d8ce9 = 'state.persisted.forgot.password.FETCH_FORGOT_PASSWORD_FAILURE';
const $d0f8c6f206c587c4$export$f5ac004adf4f85e3 = (forgotPasswordModel)=>({
        payload: forgotPasswordModel,
        type: $d0f8c6f206c587c4$export$78f743c8c0190142
    });
const $d0f8c6f206c587c4$export$d6a87818b7101f95 = (error)=>({
        type: $d0f8c6f206c587c4$export$aeb2acd4962d8ce9,
        payload: {
            error: error
        }
    });

});


parcelRegister("2O4bV", function(module, exports) {
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_MODEL", () => $379840149f6c0df8$export$8908eff00e7804c6);
$parcel$export(module.exports, "fetchForgotPasswordModel", () => $379840149f6c0df8$export$41d4a614faed30ee);

var $cWsyg = parcelRequire("cWsyg");
const $379840149f6c0df8$export$8908eff00e7804c6 = 'epic.model.FETCH_FORGOT_PASSWORD_MODEL';
const $379840149f6c0df8$export$41d4a614faed30ee = (0, $cWsyg.buildModelsActionCreator)($379840149f6c0df8$export$8908eff00e7804c6, 'forgotPassword');

});


parcelRegister("jGA0H", function(module, exports) {
$parcel$export(module.exports, "helpCenterEpic", () => $b986b896db3feb98$export$5b8469c39769260e);
$parcel$export(module.exports, "invalidateHelpCenterBrandingEpic", () => $b986b896db3feb98$export$dc52639d81083812);
$parcel$export(module.exports, "helpCenterBrandingEpic", () => $b986b896db3feb98$export$10de7c69d36b21f6);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $8iTFq = parcelRequire("8iTFq");
parcelRequire("RlLTp");
var $6DnuY = parcelRequire("6DnuY");

var $1EFS8 = parcelRequire("1EFS8");

var $gk18s = parcelRequire("gk18s");

var $8uMLL = parcelRequire("8uMLL");

var $gyskF = parcelRequire("gyskF");

var $jTCFd = parcelRequire("jTCFd");

var $9Vr59 = parcelRequire("9Vr59");
const $b986b896db3feb98$export$5b8469c39769260e = (action$)=>{
    return action$.ofType((0, $9Vr59.FETCH_HELP_CENTER_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.sharedPortal).map((response)=>{
            return (0, $6DnuY.updateHelpCenterModelAction)(response.sharedPortal);
        })// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $fSYYZ.Observable).never()));
};
const $b986b896db3feb98$export$dc52639d81083812 = (action$)=>{
    return action$.ofType((0, $9Vr59.INVALIDATE_HELP_CENTER_RELAY_STORE)).mergeMap(()=>{
        // invalidate local cache of relay store for help center branding
        (0, $8iTFq.commitLocalUpdate)((0, $gyskF.getRelayEnvironment)(), (relayStore)=>{
            const root = relayStore.getRoot();
            const query = root.getLinkedRecord('helpCenter', {
                cloudId: (0, $jByYr.getCloudId)()
            });
            const helpCenter = query === null || query === void 0 ? void 0 : query.getLinkedRecord('helpCenterById', {
                helpCenterAri: (0, $jByYr.getHelpCenterAri)()
            });
            helpCenter === null || helpCenter === void 0 || helpCenter.invalidateRecord();
        });
        const noAction = (0, $fSYYZ.Observable).never();
        return noAction;
    });
};
const $b986b896db3feb98$export$10de7c69d36b21f6 = (action$)=>{
    return action$.ofType((0, $9Vr59.FETCH_HELP_CENTER_BRANDING_MODEL)).mergeMap((action)=>{
        const noAction = (0, $fSYYZ.Observable).never();
        if ((0, $HGACo.isDefaultHCUsingGqlBrandingCalls)() || (0, $gk18s.isKoshEnabledForDefaultHelpCenter)()) return (0, $fSYYZ.Observable).from((0, $8uMLL.fetchBrandingData)().toPromise().then((response)=>(0, $8uMLL.convertToHCBrandingResponse)(response))).filter((data)=>!!data).flatMap((data)=>{
            if (data) return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $6DnuY.updateHCBrandingModelAction)(data)), (0, $fSYYZ.Observable).of((0, $6DnuY.updateHCBrandingLoaderAction)(true)));
            throw new Error('No data');
        }).catch(()=>(0, $fSYYZ.Observable).of((0, $6DnuY.updateHCBrandingLoaderAction)(true)));
        if ((0, $1EFS8.default).checkGate('fix_banner_loading_in_approvals_page')) return (0, $fSYYZ.Observable).from((0, $jTCFd.default)(action.payload).filter((response)=>!!response.helpCenterBranding).flatMap((response)=>{
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $6DnuY.updateHCBrandingModelAction)(response.helpCenterBranding)), (0, $fSYYZ.Observable).of((0, $6DnuY.updateHCBrandingLoaderAction)(true)));
        }).catch((_)=>(0, $1EFS8.default).checkGate('jsm_multi_helpcenter_login_ssr_improvements') ? (0, $fSYYZ.Observable).of((0, $6DnuY.updateHCBrandingLoaderAction)(true)) : noAction));
        return (0, $jTCFd.default)(action.payload).filter((response)=>!!response.helpCenterBranding).map((response)=>{
            return (0, $6DnuY.updateHCBrandingModelAction)(response.helpCenterBranding);
        }).catch((_)=>(0, $1EFS8.default).checkGate('jsm_multi_helpcenter_login_ssr_improvements') ? (0, $fSYYZ.Observable).of((0, $6DnuY.updateHCBrandingLoaderAction)(true)) : noAction);
    });
};

});

parcelRegister("b67CP", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a462ebf5acdd154$export$2e2bcd8739ae039);

var $jpGTf = parcelRequire("jpGTf");
var $ilKjM = parcelRequire("ilKjM");
var $fSYYZ = parcelRequire("fSYYZ");

var $cBpu6 = parcelRequire("cBpu6");

var $9n3vl = parcelRequire("9n3vl");
parcelRequire("gPqcZ");
var $lx3a0 = parcelRequire("lx3a0");
parcelRequire("dh5YM");
var $azAoe = parcelRequire("azAoe");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");

var $hPLrQ = parcelRequire("hPLrQ");
const $5a462ebf5acdd154$var$categoryArticlesEpic = (action$)=>{
    return action$.ofType((0, $hPLrQ.FETCH_ARTICLES)).mergeMap((action)=>{
        const { projectId: projectId, categoryId: categoryId, portalId: portalId, categoryDataRequired: categoryDataRequired, meta: meta } = action.payload;
        if (categoryDataRequired) // parallelize categories request with articles, used on initial category page load, ensures we always have the necessary category data
        return (0, $ilKjM.forkJoin)((0, $9n3vl.fetchArticlesForCategory)({
            projectId: projectId,
            categoryId: categoryId
        }).map((articlesResponse)=>(0, $lx3a0.fetchArticlesSuccess)(articlesResponse, categoryId)).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $fonw6.isNetworkOrClientErrorCode)(error.statusCode)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $lx3a0.fetchArticlesFailure)(error, portalId, categoryId));
        }), (0, $cBpu6.fetchCategories)({
            projectId: projectId
        }).map((categoriesResponse)=>(0, $azAoe.fetchCategoriesSuccess)(categoriesResponse, portalId)).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $fonw6.isNetworkOrClientErrorCode)(error.statusCode)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $azAoe.fetchCategoriesFailure)(error, portalId));
        })).mergeMap(([articlesSuccessOrFailure, categoriesSuccessOrFailure])=>(0, $jpGTf.concat)((0, $fSYYZ.Observable).of(articlesSuccessOrFailure), (0, $fSYYZ.Observable).of(categoriesSuccessOrFailure)));
        return (0, $9n3vl.fetchArticlesForCategory)({
            projectId: projectId,
            categoryId: categoryId
        }).map((response)=>{
            return (0, $lx3a0.fetchArticlesSuccess)(response, categoryId);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $fonw6.isNetworkOrClientErrorCode)(error.statusCode)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $lx3a0.fetchArticlesFailure)(error, portalId, categoryId));
        });
    });
};
var $5a462ebf5acdd154$export$2e2bcd8739ae039 = $5a462ebf5acdd154$var$categoryArticlesEpic;

});
parcelRegister("cBpu6", function(module, exports) {
$parcel$export(module.exports, "fetchCategories", () => $1a0702abfa893883$export$416ec9f5729de215);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $jByYr = parcelRequire("jByYr");

var $6t9NN = parcelRequire("6t9NN");

var $9ypa9 = parcelRequire("9ypa9");

var $7FSs7 = parcelRequire("7FSs7");
const $1a0702abfa893883$var$mapApolloErrorResponse = (error)=>{
    return {
        statusCode: error.status,
        errorKey: '',
        errorMessage: error.message || ''
    };
};
const $1a0702abfa893883$export$416ec9f5729de215 = ({ projectId: projectId, contextPath: contextPath = (0, $7FSs7.contextPath) })=>{
    const activationId = (0, $jByYr.getMeta)('activation-id');
    const uri = `${contextPath}${(0, $6t9NN.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/project/${projectId}/category`;
    return (0, $breWd.get)(uri, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $9ypa9.trackError)('categories.fetch.all.failed', {}, e);
        return (0, $fSYYZ.Observable).throw($1a0702abfa893883$var$mapApolloErrorResponse(e));
    });
};

});

parcelRegister("9n3vl", function(module, exports) {
$parcel$export(module.exports, "fetchArticlesForCategory", () => $242f1abc74b9466a$export$b51ae2f6685b749);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $jByYr = parcelRequire("jByYr");

var $h1yZX = parcelRequire("h1yZX");

var $6t9NN = parcelRequire("6t9NN");

var $9ypa9 = parcelRequire("9ypa9");

var $7FSs7 = parcelRequire("7FSs7");

var $j8pzj = parcelRequire("j8pzj");
const $242f1abc74b9466a$var$errorKeyToMessage = {
    'jsd.apollo.error.category.not.found': (0, $j8pzj.default).categoryNotFound,
    'jsd.apollo.error.project.permission.no.view.project.permission': (0, $j8pzj.default).noPermission,
    'jsd.apollo.error.article.not.found': (0, $j8pzj.default).articleNotFound
};
const $242f1abc74b9466a$var$mapApolloErrorResponse = (error)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = error.response;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (response && response.errorKey && $242f1abc74b9466a$var$errorKeyToMessage[response.errorKey]) {
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const translatedMessage = $242f1abc74b9466a$var$errorKeyToMessage[response.errorKey];
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
        return {
            ...error.response,
            errorMessage: translatedMessage
        };
    }
    return {
        statusCode: error.status,
        errorKey: '',
        errorMessage: ''
    };
};
const $242f1abc74b9466a$export$b51ae2f6685b749 = ({ projectId: projectId, categoryId: categoryId, contextPath: contextPath = (0, $7FSs7.contextPath) })=>{
    const queryString = $h1yZX.stringify({
        limit: 100,
        orderBy: '+featured',
        expand: 'category'
    });
    const activationId = (0, $jByYr.getMeta)('activation-id');
    const uri = `${contextPath}${(0, $6t9NN.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/project/${projectId}/category/${categoryId}/article?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $9ypa9.trackError)('category.article.fetch.failed', {}, e);
        return (0, $fSYYZ.Observable).throw($242f1abc74b9466a$var$mapApolloErrorResponse(e));
    });
};

});
parcelRegister("j8pzj", function(module, exports) {
$parcel$export(module.exports, "default", () => $e87e81f3a2516c44$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $e87e81f3a2516c44$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    categoryNotFound: {
        id: 'cv.error.page.category.page.category.not.found',
        defaultMessage: "That category doesn't exist.",
        description: 'The error message shown when the category not found on the category page.'
    },
    articleNotFound: {
        id: 'cv.error.page.category.page.article.not.found',
        defaultMessage: "That article doesn't exist.",
        description: 'The error message shown when the requested article was not found on the category page.'
    },
    noPermission: {
        id: 'cv.error.page.category.page.no-permission',
        defaultMessage: 'You do not have permission to view this category. Ask an admin to check your permissions.',
        description: 'The error shown when the user does not have permission to add categories to the project.'
    },
    callToActionText: {
        id: 'cv.error.page.category.page.call.to.action',
        defaultMessage: 'Go back',
        description: 'Call to action message shown when an error occurs on the category page'
    }
});

});


parcelRegister("gPqcZ", function(module, exports) {
$parcel$export(module.exports, "fetchArticlesSuccess", () => (parcelRequire("lx3a0")).fetchArticlesSuccess);
$parcel$export(module.exports, "fetchArticlesFailure", () => (parcelRequire("lx3a0")).fetchArticlesFailure);

var $lx3a0 = parcelRequire("lx3a0");

});
parcelRegister("lx3a0", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLES_SUCCESS", () => $9d1ae8eeb6a8cb82$export$76b83d637130c0fa);
$parcel$export(module.exports, "FETCH_ARTICLES_FAILURE", () => $9d1ae8eeb6a8cb82$export$7c415676e9f98e60);
$parcel$export(module.exports, "fetchArticlesSuccess", () => $9d1ae8eeb6a8cb82$export$5a1d149417c43ad9);
$parcel$export(module.exports, "fetchArticlesFailure", () => $9d1ae8eeb6a8cb82$export$47896f258d652153);
const $9d1ae8eeb6a8cb82$export$76b83d637130c0fa = 'state.persisted.kb.articles.FETCH_ARTICLES_SUCCESS';
const $9d1ae8eeb6a8cb82$export$7c415676e9f98e60 = 'state.persisted.kb.articles.FETCH_ARTICLES_FAILURE';
const $9d1ae8eeb6a8cb82$export$5a1d149417c43ad9 = (response, categoryId)=>({
        type: $9d1ae8eeb6a8cb82$export$76b83d637130c0fa,
        payload: {
            response: response,
            categoryId: categoryId
        }
    });
const $9d1ae8eeb6a8cb82$export$47896f258d652153 = (error, portalId, categoryId)=>({
        type: $9d1ae8eeb6a8cb82$export$7c415676e9f98e60,
        payload: {
            error: error,
            portalId: portalId,
            categoryId: categoryId
        }
    });

});


parcelRegister("dh5YM", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => (parcelRequire("azAoe")).FETCH_CATEGORIES_SUCCESS);
$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => (parcelRequire("azAoe")).FETCH_CATEGORIES_FAILURE);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => (parcelRequire("azAoe")).fetchCategoriesSuccess);
$parcel$export(module.exports, "fetchCategoriesFailure", () => (parcelRequire("azAoe")).fetchCategoriesFailure);

var $azAoe = parcelRequire("azAoe");

});
parcelRegister("azAoe", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => $423586c53fea709a$export$8fe15054f89178e3);
$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => $423586c53fea709a$export$4425a101b60fad1);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => $423586c53fea709a$export$1372a078b0bbb728);
$parcel$export(module.exports, "fetchCategoriesFailure", () => $423586c53fea709a$export$10b1ac5b71f5513e);
const $423586c53fea709a$export$8fe15054f89178e3 = 'state.persisted.kb.categories.FETCH_CATEGORIES_SUCCESS';
const $423586c53fea709a$export$4425a101b60fad1 = 'state.persisted.kb.categories.FETCH_CATEGORIES_FAILURE';
const $423586c53fea709a$export$baa53a1870be4bc5 = {
    __NOT_SUPPORTED__: true
};
const $423586c53fea709a$export$1372a078b0bbb728 = (response, portalId)=>{
    if (Array.isArray(response)) return {
        type: $423586c53fea709a$export$8fe15054f89178e3,
        payload: {
            portalId: portalId,
            categories: response
        }
    };
    const isCategoriesSupported = response.categoriesSupported;
    return {
        type: $423586c53fea709a$export$8fe15054f89178e3,
        payload: {
            portalId: portalId,
            categories: isCategoriesSupported ? response.categories : $423586c53fea709a$export$baa53a1870be4bc5
        }
    };
};
const $423586c53fea709a$export$10b1ac5b71f5513e = (error, portalId)=>({
        type: $423586c53fea709a$export$4425a101b60fad1,
        payload: {
            error: error,
            portalId: portalId
        }
    });

});


parcelRegister("hPLrQ", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLES", () => $abfb9df7bc69ac4b$export$d5cdb0266add81c8);
$parcel$export(module.exports, "fetchArticlesAction", () => $abfb9df7bc69ac4b$export$43937e098a3fb347);
const $abfb9df7bc69ac4b$export$d5cdb0266add81c8 = 'epic.model.FETCH_KB_ARTICLES';
const $abfb9df7bc69ac4b$export$43937e098a3fb347 = (params)=>{
    const { projectId: projectId, portalId: portalId, categoryId: categoryId, categoryDataRequired: categoryDataRequired, meta: meta } = params;
    return {
        type: $abfb9df7bc69ac4b$export$d5cdb0266add81c8,
        payload: {
            projectId: projectId,
            portalId: portalId,
            categoryId: categoryId,
            categoryDataRequired: categoryDataRequired,
            meta: meta
        }
    };
};

});


parcelRegister("eZb1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fe76348aed16263$export$2e2bcd8739ae039);

var $fSYYZ = parcelRequire("fSYYZ");

var $cBpu6 = parcelRequire("cBpu6");
parcelRequire("dh5YM");
var $azAoe = parcelRequire("azAoe");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");

var $gZNYv = parcelRequire("gZNYv");
const $7fe76348aed16263$var$categoriesEpic = (action$)=>{
    return action$.ofType((0, $gZNYv.FETCH_CATEGORIES)).mergeMap((action)=>{
        const { portalId: portalId, projectId: projectId, meta: meta } = action.payload;
        return (0, $cBpu6.fetchCategories)({
            projectId: projectId
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $azAoe.fetchCategoriesSuccess)(response, portalId);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $fonw6.isNetworkOrClientErrorCode)(error.statusCode)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $azAoe.fetchCategoriesFailure)(error, portalId));
        });
    });
};
var $7fe76348aed16263$export$2e2bcd8739ae039 = $7fe76348aed16263$var$categoriesEpic;

});
parcelRegister("gZNYv", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES", () => $3377187f3a97ecad$export$cce9a7031b65f96c);
$parcel$export(module.exports, "fetchCategoriesAction", () => $3377187f3a97ecad$export$10813fa84276d50);
const $3377187f3a97ecad$export$cce9a7031b65f96c = 'epic.model.FETCH_KB_CATEGORIES';
const $3377187f3a97ecad$export$10813fa84276d50 = (projectId, portalId, meta)=>({
        type: $3377187f3a97ecad$export$cce9a7031b65f96c,
        payload: {
            projectId: projectId,
            portalId: portalId,
            meta: meta
        }
    });

});


parcelRegister("jpm2U", function(module, exports) {
$parcel$export(module.exports, "languagesEpic", () => $b074ad0ef8e29793$export$f18fac0a77b35e0d);

var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("jFxFC");
var $7YnYX = parcelRequire("7YnYX");

var $g4UBb = parcelRequire("g4UBb");
const $b074ad0ef8e29793$export$f18fac0a77b35e0d = (action$)=>{
    return action$.ofType((0, $7YnYX.FETCH_LANGUAGES_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.availableLanguages).map((response)=>{
            return (0, $7YnYX.fetchLanguagesSuccess)(response.availableLanguages || []);
        }).catch((_)=>{
            return (0, $fSYYZ.Observable).of((0, $6p5HB.showErrorFlag)((0, $g4UBb.genericError).title, (0, $g4UBb.genericError).description));
        }));
};

});
parcelRegister("jFxFC", function(module, exports) {
$parcel$export(module.exports, "FETCH_LANGUAGES_SUCCESS", () => (parcelRequire("7YnYX")).FETCH_LANGUAGES_SUCCESS);
$parcel$export(module.exports, "FETCH_LANGUAGES_MODEL", () => (parcelRequire("7YnYX")).FETCH_LANGUAGES_MODEL);
$parcel$export(module.exports, "fetchLanguagesSuccess", () => (parcelRequire("7YnYX")).fetchLanguagesSuccess);
$parcel$export(module.exports, "fetchLanguagesModel", () => (parcelRequire("7YnYX")).fetchLanguagesModel);

var $7YnYX = parcelRequire("7YnYX");

});
parcelRegister("7YnYX", function(module, exports) {
$parcel$export(module.exports, "FETCH_LANGUAGES_MODEL", () => $2cc6f1902521e4c9$export$50695c17a56afb1c);
$parcel$export(module.exports, "FETCH_LANGUAGES_SUCCESS", () => $2cc6f1902521e4c9$export$e4a250eae790b1c0);
$parcel$export(module.exports, "fetchLanguagesModel", () => $2cc6f1902521e4c9$export$93153c0d57b5d23f);
$parcel$export(module.exports, "fetchLanguagesSuccess", () => $2cc6f1902521e4c9$export$5ecfd42a9b3d2b31);

var $cWsyg = parcelRequire("cWsyg");
const $2cc6f1902521e4c9$export$50695c17a56afb1c = 'epic.model.FETCH_LANGUAGES_MODEL';
const $2cc6f1902521e4c9$export$e4a250eae790b1c0 = 'state.persisted.languages.FETCH_LANGUAGES_SUCCESS';
const $2cc6f1902521e4c9$export$93153c0d57b5d23f = (0, $cWsyg.buildModelsActionCreator)($2cc6f1902521e4c9$export$50695c17a56afb1c, 'availableLanguages');
const $2cc6f1902521e4c9$export$5ecfd42a9b3d2b31 = (languages)=>({
        type: $2cc6f1902521e4c9$export$e4a250eae790b1c0,
        payload: {
            languages: languages
        }
    });

});



parcelRegister("cd3Lh", function(module, exports) {
$parcel$export(module.exports, "loginEpic", () => $6c609de9b6ebf28a$export$da8045e9cad7ec9b);

var $9Y6sr = parcelRequire("9Y6sr");

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");

var $dUoD8 = parcelRequire("dUoD8");
const $6c609de9b6ebf28a$export$da8045e9cad7ec9b = (action$)=>{
    return action$.ofType((0, $dUoD8.FETCH_LOGIN_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.login && !(0, (/*@__PURE__*/$parcel$interopDefault($9Y6sr)))(response.login)).map((response)=>{
            return (0, $uiV1X.fetchLoginSuccess)(response.login);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $uiV1X.fetchLoginFailure)(error));
        }));
};

});
parcelRegister("9Y6sr", function(module, exports) {

var $2AfZ8 = parcelRequire("2AfZ8");

var $8vSaN = parcelRequire("8vSaN");

var $ireFH = parcelRequire("ireFH");

var $u1Zdx = parcelRequire("u1Zdx");

var $eG4u6 = parcelRequire("eG4u6");

var $eSjJt = parcelRequire("eSjJt");

var $c5V8J = parcelRequire("c5V8J");

var $89P5Q = parcelRequire("89P5Q");
/** `Object#toString` result references. */ var $741eb9ff9eb7c3d4$var$mapTag = '[object Map]', $741eb9ff9eb7c3d4$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $741eb9ff9eb7c3d4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $741eb9ff9eb7c3d4$var$hasOwnProperty = $741eb9ff9eb7c3d4$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $741eb9ff9eb7c3d4$var$isEmpty(value) {
    if (value == null) return true;
    if ($eG4u6(value) && ($u1Zdx(value) || typeof value == 'string' || typeof value.splice == 'function' || $eSjJt(value) || $89P5Q(value) || $ireFH(value))) return !value.length;
    var tag = $8vSaN(value);
    if (tag == $741eb9ff9eb7c3d4$var$mapTag || tag == $741eb9ff9eb7c3d4$var$setTag) return !value.size;
    if ($c5V8J(value)) return !$2AfZ8(value).length;
    for(var key in value){
        if ($741eb9ff9eb7c3d4$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $741eb9ff9eb7c3d4$var$isEmpty;

});

parcelRegister("dUoD8", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_MODEL", () => $4d20ef985d55305f$export$c7e01c95750f0d63);
$parcel$export(module.exports, "fetchLoginModel", () => $4d20ef985d55305f$export$6e443fe31e715257);

var $cWsyg = parcelRequire("cWsyg");
const $4d20ef985d55305f$export$c7e01c95750f0d63 = 'epic.model.FETCH_LOGIN_MODEL';
const $4d20ef985d55305f$export$6e443fe31e715257 = (0, $cWsyg.buildModelsActionCreator)($4d20ef985d55305f$export$c7e01c95750f0d63, 'login');

});


parcelRegister("as35A", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsEpic", () => $96a25dc24d8a85ec$export$8abec8cdaadd5d28);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("71T39");
var $8WXPf = parcelRequire("8WXPf");

var $gk18s = parcelRequire("gk18s");

var $lxeue = parcelRequire("lxeue");
const $96a25dc24d8a85ec$export$32d9db53927095d3 = {
    defaultLocale: '',
    translatedLoginAnnouncements: {}
};
const $96a25dc24d8a85ec$export$8abec8cdaadd5d28 = (action$)=>{
    return action$.ofType((0, $8WXPf.FETCH_LOGIN_ANNOUNCEMENTS)).mergeMap((action)=>{
        if ((0, $gk18s.isKoshEnabledForDefaultHelpCenter)()) return (0, $fSYYZ.Observable).from((0, $lxeue.fetchLoginAnnouncementsData)().toPromise().then((response)=>(0, $lxeue.convertToLoginAnnouncementsResponse)(response))).filter((data)=>Boolean(data)).map((data)=>{
            if (data) return (0, $8WXPf.fetchLoginAnnouncementsSuccess)(data);
            return (0, $8WXPf.fetchLoginAnnouncementsSuccess)($96a25dc24d8a85ec$export$32d9db53927095d3);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $8WXPf.fetchLoginAnnouncementsFailure)(error));
        });
        return (0, $jTCFd.default)(action.payload).filter((response)=>Boolean(response)).map((response)=>{
            if (response.loginAnnouncements) return (0, $8WXPf.fetchLoginAnnouncementsSuccess)(response.loginAnnouncements);
            return (0, $8WXPf.fetchLoginAnnouncementsSuccess)($96a25dc24d8a85ec$export$32d9db53927095d3);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $8WXPf.fetchLoginAnnouncementsFailure)(error));
        });
    });
};

});
parcelRegister("lxeue", function(module, exports) {
$parcel$export(module.exports, "fetchLoginAnnouncementsData", () => $883505b98020f05f$export$32c914da1ff32f72);
$parcel$export(module.exports, "convertToLoginAnnouncementsResponse", () => $883505b98020f05f$export$a8a0b51b62d54e0);

var $2ZIPW = parcelRequire("2ZIPW");

var $jByYr = parcelRequire("jByYr");

var $8iTFq = parcelRequire("8iTFq");

var $gyskF = parcelRequire("gyskF");
const $883505b98020f05f$export$32c914da1ff32f72 = ()=>{
    return (0, $8iTFq.fetchQuery)((0, $gyskF.getRelayEnvironment)(), (0, $2ZIPW.default), {
        cloudId: (0, $jByYr.getCloudId)(),
        helpCenterAri: (0, $jByYr.getHelpCenterAri)()
    });
};
const $883505b98020f05f$var$mergeNameAndDescriptionTranslations = (nameTranslationsRaw, descriptionTranslationsRaw)=>{
    const translatedLoginAnnouncements = {};
    nameTranslationsRaw === null || nameTranslationsRaw === void 0 || nameTranslationsRaw.forEach((translationName)=>{
        const locale = translationName.locale;
        const header = translationName.value;
        const targetDescriptionAnnouncement = descriptionTranslationsRaw === null || descriptionTranslationsRaw === void 0 ? void 0 : descriptionTranslationsRaw.find((translationDescription)=>translationDescription.locale === locale);
        translatedLoginAnnouncements[locale] = {
            header: header,
            message: (targetDescriptionAnnouncement === null || targetDescriptionAnnouncement === void 0 ? void 0 : targetDescriptionAnnouncement.value) || '',
            localeDisplayName: translationName.localeDisplayName
        };
    });
    return translatedLoginAnnouncements;
};
const $883505b98020f05f$export$a8a0b51b62d54e0 = (response)=>{
    var _response$helpCenter, _data$announcements;
    if (response === undefined) return null;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') return null;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter' && (_data$announcements = data.announcements) !== null && _data$announcements !== void 0 && (_data$announcements = _data$announcements.loginAnnouncements) !== null && _data$announcements !== void 0 && _data$announcements.length) {
        // Currently we only support one login announcement
        const targetLoginAnnouncement = data.announcements.loginAnnouncements[0];
        return {
            translatedLoginAnnouncements: $883505b98020f05f$var$mergeNameAndDescriptionTranslations(targetLoginAnnouncement.nameTranslationsRaw || [], targetLoginAnnouncement.descriptionTranslationsRaw || []),
            defaultLocale: data.siteDefaultLanguageTag || ''
        };
    }
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter' && data.siteDefaultLanguageTag) // case then loginAnnouncements array is empty but siteDefaultLanguageTag is present, we have to map default locale
    return {
        translatedLoginAnnouncements: {
            [data.siteDefaultLanguageTag]: {
                localeDisplayName: data.siteDefaultLanguageTag,
                header: '',
                message: ''
            }
        },
        defaultLocale: data.siteDefaultLanguageTag
    };
    return null;
};

});
parcelRegister("2ZIPW", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cc7be20d0822b0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e9a2845fdb0ebf85b6c1c8816fcdfced>>
 * @relayHash 71f2f66044bc8f8bd3ab026ad2505549
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00910c359e88e27b753f51cb8a569097d0d751c8ced7cfea7f2763072ff56f4b
const $0cc7be20d0822b0a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "siteDefaultLanguageTag"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "locale"
        },
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "loginAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "nameTranslationsRaw",
                        "plural": true,
                        "selections": v5 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "descriptionTranslationsRaw",
                        "plural": true,
                        "selections": v5 /*: any*/ 
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "00910c359e88e27b753f51cb8a569097d0d751c8ced7cfea7f2763072ff56f4b",
            "metadata": {},
            "name": "loginAnnouncementsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0cc7be20d0822b0a$var$node.hash = "76319886fc90231eee48f51d80798d47";
var $0cc7be20d0822b0a$export$2e2bcd8739ae039 = $0cc7be20d0822b0a$var$node;

});



parcelRegister("k2QNx", function(module, exports) {
$parcel$export(module.exports, "organisationsEpic", () => $5acf9a2071b49709$export$11ed7e95538202ff);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");

var $kkBq4 = parcelRequire("kkBq4");

var $1We2B = parcelRequire("1We2B");
parcelRequire("6qS41");
var $1AY2B = parcelRequire("1AY2B");
const $5acf9a2071b49709$export$11ed7e95538202ff = (action$)=>{
    return action$.ofType((0, $kkBq4.FETCH_ORGANISATIONS_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.organisations && !(0, $1We2B.isEmpty)(response.organisations)).map((response)=>{
            return (0, $1AY2B.updateOrganisationsModelAction)(response.organisations);
        })// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $fSYYZ.Observable).never()));
};
var $5acf9a2071b49709$export$2e2bcd8739ae039 = $5acf9a2071b49709$export$11ed7e95538202ff;

});
parcelRegister("kkBq4", function(module, exports) {
$parcel$export(module.exports, "FETCH_ORGANISATIONS_MODEL", () => $27178b6c398deeb7$export$b60557155cf3c6c0);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => $27178b6c398deeb7$export$cbdd5d7a098d34a2);

var $cWsyg = parcelRequire("cWsyg");
const $27178b6c398deeb7$export$b60557155cf3c6c0 = 'epic.model.FETCH_ORGANISATIONS_MODEL';
const $27178b6c398deeb7$export$cbdd5d7a098d34a2 = (0, $cWsyg.buildModelsActionCreator)($27178b6c398deeb7$export$b60557155cf3c6c0, 'organisations');

});

parcelRegister("6qS41", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ORGANISATIONS_MODEL", () => (parcelRequire("1AY2B")).UPDATE_ORGANISATIONS_MODEL);
$parcel$export(module.exports, "updateOrganisationsModelAction", () => (parcelRequire("1AY2B")).updateOrganisationsModelAction);

var $1AY2B = parcelRequire("1AY2B");

});
parcelRegister("1AY2B", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ORGANISATIONS_MODEL", () => $5e59432e57d6060f$export$1fb754e532426cdc);
$parcel$export(module.exports, "updateOrganisationsModelAction", () => $5e59432e57d6060f$export$72c2e60e3f358ed9);
const $5e59432e57d6060f$export$1fb754e532426cdc = 'state.persisted.organisations.UPDATE_ORGANISATIONS_MODEL';
const $5e59432e57d6060f$export$72c2e60e3f358ed9 = (organisations)=>({
        payload: organisations,
        type: $5e59432e57d6060f$export$1fb754e532426cdc
    });

});



parcelRegister("62zut", function(module, exports) {
$parcel$export(module.exports, "portalEpic", () => $e05d74cccac0213d$export$a9922bad2863d6ee);
$parcel$export(module.exports, "portalUploadMediaTokenEpic", () => $e05d74cccac0213d$export$a5051d4620a9cd24);
$parcel$export(module.exports, "refreshPortalUploadMediaTokenBeforeExpiryEpic", () => $e05d74cccac0213d$export$9bf2e8f39289e99a);

var $fSYYZ = parcelRequire("fSYYZ");

var $dPeQo = parcelRequire("dPeQo");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");

var $9ypa9 = parcelRequire("9ypa9");

var $jTCFd = parcelRequire("jTCFd");
const $e05d74cccac0213d$export$a9922bad2863d6ee = (action$)=>{
    return action$.ofType((0, $d727K.FETCH_PORTAL_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.portal && !!response.branding).map((response)=>{
            var _action$meta;
            if ((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(action.meta.analyticsSuccessEvent);
            return (0, $d727K.fetchPortalSuccess)(response.portal, response.branding);
        }).catch((error)=>{
            var _action$meta2;
            if ((_action$meta2 = action.meta) !== null && _action$meta2 !== void 0 && _action$meta2.analyticsFailureEvent && error.status !== 0) (0, $9ypa9.legacySendEvent)(action.meta.analyticsFailureEvent);
            const params = action.payload.params;
            return (0, $fSYYZ.Observable).of((0, $d727K.fetchPortalFailure)(params.id, error));
        }));
};
const $e05d74cccac0213d$export$a5051d4620a9cd24 = (action$)=>{
    return action$.ofType((0, $d727K.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION)).mergeMap((action)=>{
        const portalId = action.payload.portalId;
        return (0, $dPeQo.getUploadCredentialsObservable)(portalId).map((response)=>(0, $d727K.fetchPortalUploadMediaTokenSuccess)({
                ...response,
                tokenDurationInMins: (response.expiryEpoch - Date.now()) / 60000
            }, portalId)).catch(()=>{
            return (0, $fSYYZ.Observable).of((0, $d727K.fetchPortalUploadMediaTokenFailure)());
        });
    });
};
const $e05d74cccac0213d$export$9bf2e8f39289e99a = (action$)=>{
    return action$.ofType((0, $d727K.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS), (0, $d727K.FETCH_PORTAL_SUCCESS)).switchMap((action)=>{
        const uploadContext = action.payload.mediaApiUploadInformation;
        if (uploadContext && 'token' in uploadContext) {
            const mediaApiUploadToken = uploadContext;
            // gets the token duration in milliseconds minus 5 minute buffer for network calls/inactive tab throttling
            const wantsRefreshAt = mediaApiUploadToken.tokenDurationInMins * 60000 - 300000;
            const timeUntilRefresh = Math.max(1, wantsRefreshAt);
            const portalId = action.type === (0, $d727K.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS) ? action.payload.portalId : action.payload.id;
            if (portalId) return (0, $fSYYZ.Observable).of((0, $d727K.fetchPortalUploadMediaTokenAction)(Number(portalId))).delay(timeUntilRefresh);
        }
        return (0, $fSYYZ.Observable).empty();
    });
};

});
parcelRegister("dPeQo", function(module, exports) {
$parcel$export(module.exports, "getUploadCredentials", () => $2cc85ea9cacd5aae$export$1d8e51ec2b973100);
$parcel$export(module.exports, "getUploadCredentialsObservable", () => $2cc85ea9cacd5aae$export$42e3feb9754fda17);
$parcel$export(module.exports, "getCredentialsForMediaRequest", () => $2cc85ea9cacd5aae$export$ec7ab5d74f1f3c37);
$parcel$export(module.exports, "getUploadCredentialsForRequest", () => $2cc85ea9cacd5aae$export$766d1bd3b5e7fe1b);
$parcel$export(module.exports, "getReadCredentialsForRequest", () => $2cc85ea9cacd5aae$export$9748c08f8d568d41);

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $2cc85ea9cacd5aae$export$1d8e51ec2b973100 = (portalId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $2cc85ea9cacd5aae$export$42e3feb9754fda17 = (portalId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, headers).map((ajaxResponse)=>ajaxResponse.response);
};
const $2cc85ea9cacd5aae$export$ec7ab5d74f1f3c37 = (portalId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload/inline`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $2cc85ea9cacd5aae$export$766d1bd3b5e7fe1b = (portalId, requestId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/${requestId}/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $2cc85ea9cacd5aae$export$9748c08f8d568d41 = (portalId, requestId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/${requestId}/credentials/read`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, headers).map((response)=>response.response);
};

});

parcelRegister("eNGJq", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_MODEL", () => (parcelRequire("d727K")).FETCH_PORTAL_MODEL);
$parcel$export(module.exports, "FETCH_PORTAL_SUCCESS", () => (parcelRequire("d727K")).FETCH_PORTAL_SUCCESS);
$parcel$export(module.exports, "FETCH_PORTAL_FAILURE", () => (parcelRequire("d727K")).FETCH_PORTAL_FAILURE);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_MODEL", () => (parcelRequire("d727K")).UPDATE_PORTAL_ANNOUNCEMENT_MODEL);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS", () => (parcelRequire("d727K")).UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_FAILURE", () => (parcelRequire("d727K")).UPDATE_PORTAL_ANNOUNCEMENT_FAILURE);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE", () => (parcelRequire("d727K")).UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION", () => (parcelRequire("d727K")).FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS", () => (parcelRequire("d727K")).FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS);
$parcel$export(module.exports, "fetchPortalAction", () => (parcelRequire("d727K")).fetchPortalAction);
$parcel$export(module.exports, "fetchPortalSuccess", () => (parcelRequire("d727K")).fetchPortalSuccess);
$parcel$export(module.exports, "fetchPortalFailure", () => (parcelRequire("d727K")).fetchPortalFailure);
$parcel$export(module.exports, "updatePortalAnnouncementModel", () => (parcelRequire("d727K")).updatePortalAnnouncementModel);
$parcel$export(module.exports, "updatePortalAnnouncementSuccess", () => (parcelRequire("d727K")).updatePortalAnnouncementSuccess);
$parcel$export(module.exports, "updatePortalAnnouncementFailure", () => (parcelRequire("d727K")).updatePortalAnnouncementFailure);
$parcel$export(module.exports, "updatePortalAnnouncementsUIState", () => (parcelRequire("d727K")).updatePortalAnnouncementsUIState);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenAction", () => (parcelRequire("d727K")).fetchPortalUploadMediaTokenAction);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenSuccess", () => (parcelRequire("d727K")).fetchPortalUploadMediaTokenSuccess);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenFailure", () => (parcelRequire("d727K")).fetchPortalUploadMediaTokenFailure);

var $d727K = parcelRequire("d727K");

});
parcelRegister("d727K", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_MODEL", () => $6ff1497938a8848d$export$fca1c6628f14bdf2);
$parcel$export(module.exports, "FETCH_PORTAL_SUCCESS", () => $6ff1497938a8848d$export$b929cb285face2c);
$parcel$export(module.exports, "FETCH_PORTAL_FAILURE", () => $6ff1497938a8848d$export$d0378806ff79f20f);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_MODEL", () => $6ff1497938a8848d$export$f1992600da6904c6);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS", () => $6ff1497938a8848d$export$9181049110925f2a);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_FAILURE", () => $6ff1497938a8848d$export$d5fa92c7d79f8706);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION", () => $6ff1497938a8848d$export$6a473efc246ca86a);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS", () => $6ff1497938a8848d$export$eedf58a097d7a901);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE", () => $6ff1497938a8848d$export$c769ac1c1c5f67f5);
$parcel$export(module.exports, "fetchPortalAction", () => $6ff1497938a8848d$export$8262b38db2952a96);
$parcel$export(module.exports, "fetchPortalSuccess", () => $6ff1497938a8848d$export$c9cc1b81c69f8b54);
$parcel$export(module.exports, "fetchPortalFailure", () => $6ff1497938a8848d$export$bc631fe34431953a);
$parcel$export(module.exports, "updatePortalAnnouncementModel", () => $6ff1497938a8848d$export$a2c25b3a57d1e1e1);
$parcel$export(module.exports, "updatePortalAnnouncementSuccess", () => $6ff1497938a8848d$export$1cb4859b979a107e);
$parcel$export(module.exports, "updatePortalAnnouncementFailure", () => $6ff1497938a8848d$export$a71bb12efca5ed02);
$parcel$export(module.exports, "updatePortalAnnouncementsUIState", () => $6ff1497938a8848d$export$7f7bb35e246605cc);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenAction", () => $6ff1497938a8848d$export$82b91227c2617f7c);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenSuccess", () => $6ff1497938a8848d$export$977a37e5820c7d60);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenFailure", () => $6ff1497938a8848d$export$5531ab3802c122e6);

var $cWsyg = parcelRequire("cWsyg");
const $6ff1497938a8848d$export$fca1c6628f14bdf2 = 'epic.model.FETCH_PORTAL_MODEL';
const $6ff1497938a8848d$export$b929cb285face2c = 'state.persisted.portals.FETCH_PORTAL_SUCCESS';
const $6ff1497938a8848d$export$d0378806ff79f20f = 'state.persisted.portals.FETCH_PORTAL_FAILURE';
const $6ff1497938a8848d$export$f1992600da6904c6 = 'epic.portal-announcements.UPDATE_PORTAL_ANNOUNCEMENT_MODEL';
const $6ff1497938a8848d$export$9181049110925f2a = 'state.persisted.portals.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS';
const $6ff1497938a8848d$export$d5fa92c7d79f8706 = 'state.persisted.portals.UPDATE_PORTAL_ANNOUNCEMENT_FAILURE';
const $6ff1497938a8848d$export$6a473efc246ca86a = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION';
const $6ff1497938a8848d$export$eedf58a097d7a901 = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS';
const $6ff1497938a8848d$var$FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE';
const $6ff1497938a8848d$export$c769ac1c1c5f67f5 = 'state.ui.portal-announcements.UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE';
const $6ff1497938a8848d$export$8262b38db2952a96 = (payload, meta)=>({
        meta: meta,
        ...(0, $cWsyg.buildModelsActionCreator)($6ff1497938a8848d$export$fca1c6628f14bdf2, 'portal')(payload)
    });
const $6ff1497938a8848d$export$c9cc1b81c69f8b54 = (portalModel, portalBrandingResponse)=>{
    return {
        payload: {
            ...portalBrandingResponse,
            ...portalModel
        },
        type: $6ff1497938a8848d$export$b929cb285face2c
    };
};
const $6ff1497938a8848d$export$bc631fe34431953a = (portalId, error)=>({
        type: $6ff1497938a8848d$export$d0378806ff79f20f,
        payload: {
            portalId: portalId,
            error: error
        }
    });
const $6ff1497938a8848d$export$a2c25b3a57d1e1e1 = (portalId, portalAnnouncementModel, meta)=>({
        portalId: portalId,
        meta: meta,
        type: $6ff1497938a8848d$export$f1992600da6904c6,
        payload: portalAnnouncementModel
    });
const $6ff1497938a8848d$export$1cb4859b979a107e = (portalAnnouncementModel)=>({
        type: $6ff1497938a8848d$export$9181049110925f2a,
        payload: portalAnnouncementModel
    });
const $6ff1497938a8848d$export$a71bb12efca5ed02 = (error)=>({
        type: $6ff1497938a8848d$export$d5fa92c7d79f8706,
        payload: {
            error: error
        }
    });
const $6ff1497938a8848d$export$7f7bb35e246605cc = (portalAnnouncementModel)=>({
        type: $6ff1497938a8848d$export$c769ac1c1c5f67f5,
        payload: portalAnnouncementModel
    });
const $6ff1497938a8848d$export$82b91227c2617f7c = (portalId)=>({
        type: $6ff1497938a8848d$export$6a473efc246ca86a,
        payload: {
            portalId: portalId
        }
    });
const $6ff1497938a8848d$export$977a37e5820c7d60 = (mediaUploadToken, portalId)=>{
    return {
        type: $6ff1497938a8848d$export$eedf58a097d7a901,
        payload: {
            portalId: portalId,
            mediaApiUploadInformation: mediaUploadToken
        }
    };
};
const $6ff1497938a8848d$export$5531ab3802c122e6 = ()=>{
    return {
        type: $6ff1497938a8848d$var$FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE
    };
};

});



parcelRegister("dmkFQ", function(module, exports) {
$parcel$export(module.exports, "requestCreateEpic", () => $60bd5be8d12a9503$export$a2b66173a86c1319);

var $fSYYZ = parcelRequire("fSYYZ");

var $HGACo = parcelRequire("HGACo");

var $jTCFd = parcelRequire("jTCFd");

var $gSBQ1 = parcelRequire("gSBQ1");

var $dRMZ5 = parcelRequire("dRMZ5");
parcelRequire("1BaaY");
var $8bKnT = parcelRequire("8bKnT");

var $kwSZC = parcelRequire("kwSZC");

var $sKUlZ = parcelRequire("sKUlZ");
parcelRequire("3iEGo");
var $hPvsJ = parcelRequire("hPvsJ");
const $60bd5be8d12a9503$export$a2b66173a86c1319 = (action$)=>{
    return action$.ofType((0, $8bKnT.FETCH_REQUEST_CREATE_MODEL)).mergeMap((action)=>{
        const portalId = action.payload && action.payload.params && action.payload.params.portalId;
        const requestTypeId = action.payload && action.payload.params && action.payload.params.id;
        if ((0, $HGACo.isJsmPortalRovoIntegrationEnabled)()) return (0, $jTCFd.default)(action.payload).filter((response)=>!!response.reqCreate).mergeMap((response)=>{
            return $60bd5be8d12a9503$var$hydrateUrlParamOverrides(response.reqCreate, portalId, requestTypeId).then(({ requestCreateResponse: requestCreateResponse, hydratedUrlParamOverrides: hydratedUrlParamOverrides })=>(0, $8bKnT.fetchRequestCreateSuccess)({
                    ...requestCreateResponse,
                    hydratedUrlParamOverrides: hydratedUrlParamOverrides,
                    portalId: portalId
                }));
        }).catch((error)=>{
            const params = action.payload.params;
            return (0, $fSYYZ.Observable).of((0, $8bKnT.fetchRequestCreateFailure)(portalId, params.id, error));
        });
        return (0, $jTCFd.default)(action.payload).filter((response)=>!!response.reqCreate).map((response)=>{
            return (0, $8bKnT.fetchRequestCreateSuccess)({
                ...response.reqCreate,
                portalId: portalId,
                hydratedUrlParamOverrides: {}
            });
        }).catch((error)=>{
            const params = action.payload.params;
            return (0, $fSYYZ.Observable).of((0, $8bKnT.fetchRequestCreateFailure)(portalId, params.id, error));
        });
    });
};
/**
 * Builds a set of URL param overrides from the query parameters, and attempts to hydrate any overrides
 * for dynamic fields.
 *
 * This should never break the request create flow. If a dynamic field cannot be hydrated successfully (failed
 * API call), this function will proceed as though a URL override was not provided for that field.
 */ const $60bd5be8d12a9503$var$hydrateUrlParamOverrides = async (requestCreateResponse, portalId, requestTypeId)=>{
    const fieldStates = (0, $kwSZC.toFieldStates)(requestCreateResponse.fields);
    const fieldStatesMap = Object.fromEntries(fieldStates.map((fieldState)=>[
            fieldState.id,
            fieldState
        ]));
    const fieldValueOverrides = (0, $sKUlZ.parseFieldUrlParams)(fieldStates);
    const asyncFieldStatesWithDependencies = [];
    // This is a map used to store a representation of all current field values (including any hydrated ones)
    // so that it can be sent in the payload for CMDB queries. CMDB queries require this since AQL can filter
    // based on dependencies on other fields.
    const fieldValueMap = fieldStates.reduce((valueMap, field)=>{
        var _field$value;
        valueMap[field.id] = (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.toString();
        return valueMap;
    }, {});
    // Mapping all dynamic pre-fill fields to promises so they can be hydrated in parallel.
    // Fields with dependencies need to be mapped last so we can populate the fielValueMap
    // as much as possible. The only known field with dependencies at the moment are CMDB fields.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const asyncFieldValuePromises = fieldStates.map((fieldState)=>{
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                // We don't resolve CMDB fields immediately because they may have dependencies that need to be resolved first
                asyncFieldStatesWithDependencies.push(fieldState);
                return Promise.resolve({
                    fieldId: fieldState.id,
                    value: undefined
                });
            case 'userpicker':
                return $60bd5be8d12a9503$var$getUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'reporter':
                return $60bd5be8d12a9503$var$getUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'multiuserpicker':
                return $60bd5be8d12a9503$var$getMultiUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'organisationpicker':
                return $60bd5be8d12a9503$var$getOrganisationPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId, undefined, requestCreateResponse.userOrganisations);
            case 'entitlementpicker':
                // Entitlement picker value is just passed through as a string
                if (fieldValueOverrides[fieldState.id]) return Promise.resolve({
                    fieldId: fieldState.id,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    value: fieldValueOverrides[fieldState.id]
                });
                return Promise.resolve({
                    fieldId: fieldState.id,
                    value: undefined
                });
            case 'multiservicepicker':
                return $60bd5be8d12a9503$var$getMultiServicePickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            // The following are static fields which have been converted into options. They need to be converted
            // to a different format for the fieldValueMap
            case 'labelpicker':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].map((defaultLabel)=>defaultLabel.value).toString();
                return undefined;
            case 'select':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].value;
                return undefined;
            case 'multiselect':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].map((multiSelectOverride)=>multiSelectOverride.value).toString();
                return undefined;
            // All other static field types don't need to be hydrated or transformed, so we can store them
            // directly on fieldValueMap
            default:
                // TODO: Work out the format for cascading select data. This is currently also broken in the existing
                // CMDB field implementation so we're only being consistent with how cascading fields work in
                // Portal view.
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].toString();
                return undefined;
        }
    }).filter((loader)=>loader !== undefined);
    // When storing the hydrated results of dynamic fields, we need to keep asyncFieldValueOverrides in sync with
    // fieldValueMap. They need to store the same results, but in a different representation.
    const asyncFieldValueOverrides = await Promise.all(asyncFieldValuePromises).then((results)=>results.reduce((accumulator, result)=>{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            accumulator[result.fieldId] = result.value;
            if (result.value === undefined) return accumulator;
            const fieldType = fieldStatesMap[result.fieldId].type;
            switch(fieldType){
                case 'userpicker':
                case 'reporter':
                    {
                        const userValue = result.value;
                        fieldValueMap[result.fieldId] = userValue.accountId;
                        break;
                    }
                case 'multiuserpicker':
                    {
                        const userValues = result.value;
                        fieldValueMap[result.fieldId] = userValues.map((user)=>user.accountId).toString();
                        break;
                    }
                case 'organisationpicker':
                    {
                        const organisationValue = result.value;
                        fieldValueMap[result.fieldId] = organisationValue.id.toString();
                        break;
                    }
                case 'multiservicepicker':
                    {
                        const multiServiceValues = result.value;
                        if (multiServiceValues && multiServiceValues.length > 0) fieldValueMap[result.fieldId] = multiServiceValues.toString();
                        break;
                    }
                default:
                    break;
            }
            return accumulator;
        }, {}));
    // A for loop is needed because CMDB fields can depend on other CMDB fields. Hence we need to hydrate them one
    // at a time and make subsequent calls with an updated fieldValueMap.
    for (const fieldState of asyncFieldStatesWithDependencies){
        const fieldId = fieldState.id;
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                {
                    const cmdbPickerValue = // oxlint-disable-next-line no-await-in-loop
                    (await $60bd5be8d12a9503$var$getCmdbObjectLoader(fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap)).value;
                    asyncFieldValueOverrides[fieldId] = cmdbPickerValue;
                    if (cmdbPickerValue === undefined) break;
                    fieldValueMap[fieldId] = cmdbPickerValue.map((value)=>value.value).toString();
                    break;
                }
            default:
                break;
        }
    }
    const hydratedUrlParamOverrides = Object.fromEntries(Object.entries({
        ...fieldValueOverrides,
        ...asyncFieldValueOverrides
    }).filter(([, fieldValue])=>fieldValue !== undefined));
    return {
        requestCreateResponse: requestCreateResponse,
        hydratedUrlParamOverrides: hydratedUrlParamOverrides
    };
};
const $60bd5be8d12a9503$var$getMultiUserPickerLoader = (fieldState, fieldValueOverrides, portalId)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const multiUserPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof multiUserPickerQuery !== 'string') return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Split comma-separated user queries and search for each
    const userQueries = multiUserPickerQuery.split(',').map((query)=>query.trim()).filter((query)=>query.length > 0);
    if (userQueries.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const userSearchPromises = userQueries.map((query)=>(0, $dRMZ5.searchUser)({
            portalId: portalId,
            query: query,
            fieldName: fieldId,
            fieldConfigId: fieldState.fieldConfigId
        }).toPromise().then((userSearchResponse)=>{
            if (userSearchResponse.length === 0) return undefined;
            // Return the first matching user for this query
            const userResult = userSearchResponse[0];
            return {
                accountId: userResult.accountId,
                email: userResult.emailAddress,
                iconUrl: userResult.avatar,
                label: userResult.displayName,
                value: userResult.accountId
            };
        }).catch(()=>undefined));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Promise.all(userSearchPromises).then((results)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const users = results.filter((user)=>user !== undefined);
        return {
            fieldId: fieldState.id,
            value: users.length > 0 ? users : undefined
        };
    });
};
const $60bd5be8d12a9503$var$getUserPickerLoader = (fieldState, fieldValueOverrides, portalId)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const userPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof userPickerQuery !== 'string') return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    return (0, $dRMZ5.searchUser)({
        portalId: portalId,
        query: userPickerQuery,
        fieldName: fieldId,
        fieldConfigId: fieldState.fieldConfigId
    }).toPromise().then((userSearchResponse)=>{
        if (userSearchResponse.length === 0) return {
            fieldId: fieldId,
            value: undefined
        };
        const firstUserResult = userSearchResponse[0];
        return {
            fieldId: fieldState.id,
            value: {
                accountId: firstUserResult.accountId,
                email: firstUserResult.emailAddress,
                iconUrl: firstUserResult.avatar,
                label: firstUserResult.displayName,
                value: firstUserResult.accountId
            }
        };
    }).catch(()=>({
            fieldId: fieldId,
            value: undefined
        }));
};
const $60bd5be8d12a9503$var$getOrganisationPickerLoader = (fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap, userOrganisations)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const organisationPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof organisationPickerQuery !== 'string' || !userOrganisations) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Try to match the URL parameter against user's organisations
    // First, try to match by ID (if the query is numeric)
    const queryAsId = parseInt(organisationPickerQuery, 10);
    if (!isNaN(queryAsId)) {
        const matchedOrgById = userOrganisations.find((org)=>org.id === queryAsId);
        if (matchedOrgById) return Promise.resolve({
            fieldId: fieldId,
            value: {
                id: matchedOrgById.id,
                name: matchedOrgById.name,
                domain: ''
            }
        });
    }
    // Try to match by name (case-insensitive)
    const matchedOrgByName = userOrganisations.find((org)=>org.name.toLowerCase() === organisationPickerQuery.toLowerCase());
    if (matchedOrgByName) return Promise.resolve({
        fieldId: fieldId,
        value: {
            id: matchedOrgByName.id,
            name: matchedOrgByName.name,
            domain: ''
        }
    });
    // No matching organisation found
    return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
};
const $60bd5be8d12a9503$var$getMultiServicePickerLoader = async (fieldState, fieldValueOverrides)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const multiServicePickerQuery = fieldValueOverrides[fieldState.id];
    if (!multiServicePickerQuery) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Handle both single value and array of values
    let queries = [];
    if (Array.isArray(multiServicePickerQuery)) queries = multiServicePickerQuery;
    else if (typeof multiServicePickerQuery === 'string') queries = [
        multiServicePickerQuery
    ];
    if (queries.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    const matchedServiceIds = [];
    // For each query, try to find a matching service
    for (const query of queries)try {
        // Try to match by searching for the service name
        // oxlint-disable-next-line no-await-in-loop
        const result = await (0, $gSBQ1.fetchServices)(query);
        // Find exact or partial match by name
        let matchedService = result.services.find((service)=>service.label.toLowerCase() === query.toLowerCase());
        // If no exact match, try to match by ID
        if (!matchedService) matchedService = result.services.find((service)=>service.value === query);
        if (matchedService) matchedServiceIds.push(matchedService.value);
    } catch (error) {
        // If fetch fails, continue to next query
        // oxlint-disable-next-line no-console
        console.warn(`Failed to fetch services for query: ${query}`, error);
    }
    if (matchedServiceIds.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    return Promise.resolve({
        fieldId: fieldId,
        value: matchedServiceIds
    });
};
const $60bd5be8d12a9503$var$getCmdbObjectLoader = (fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const cmdbPickerQuery = fieldValueOverrides[fieldState.id];
    const abortController = new AbortController();
    const { signal: signal } = abortController;
    if (typeof cmdbPickerQuery === 'string') return $60bd5be8d12a9503$var$getSingleCmdbObjectLoader(signal, cmdbPickerQuery, fieldId, fieldValueMap, portalId, requestTypeId).then((cmdbResult)=>cmdbResult.value === undefined ? {
            fieldId: cmdbResult.fieldId,
            value: undefined
        } : {
            fieldId: cmdbResult.fieldId,
            value: [
                cmdbResult.value
            ]
        });
    if (Array.isArray(cmdbPickerQuery)) {
        const cmdbObjectPickerQueries = cmdbPickerQuery.filter((query)=>typeof query === 'string');
        const cmdbObjectPickerPromises = cmdbObjectPickerQueries.map((query)=>$60bd5be8d12a9503$var$getSingleCmdbObjectLoader(signal, query, fieldId, fieldValueMap, portalId, requestTypeId));
        return Promise.all(cmdbObjectPickerPromises).then((results)=>{
            const options = results.map((loaderResult)=>loaderResult.value).filter((option)=>option !== undefined);
            return {
                fieldId: fieldId,
                value: options.length === 0 ? undefined : options
            };
        });
    }
    return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
};
const $60bd5be8d12a9503$var$getSingleCmdbObjectLoader = (abortSignal, cmdbPickerQuery, fieldId, fieldValueMap, portalId, requestTypeId)=>{
    return (0, $hPvsJ.fetchCmdbObjectsWithSignal)(portalId, requestTypeId, fieldId, cmdbPickerQuery, Object.entries(fieldValueMap).filter(([_, fieldValue])=>!!fieldValue), abortSignal, 0).then((response)=>{
        const responseObjects = response.cmdbObjects;
        if (responseObjects.length === 0) return {
            fieldId: fieldId,
            value: undefined
        };
        const firstResult = responseObjects[0];
        return {
            fieldId: fieldId,
            value: {
                cmdbObject: firstResult,
                label: firstResult.label,
                value: firstResult.id
            }
        };
    }).catch(()=>({
            fieldId: fieldId,
            value: undefined
        }));
};

});
parcelRegister("gSBQ1", function(module, exports) {
$parcel$export(module.exports, "fetchServices", () => $497949fa25bff5ec$export$aaba171dbee0d63b);

var $breWd = parcelRequire("breWd");

var $jByYr = parcelRequire("jByYr");

var $7FSs7 = parcelRequire("7FSs7");
const $497949fa25bff5ec$export$6ad2d0b3772389f4 = `
    query GetServices($cloudId: String!, $nameContains: String!, $first: Int!, $after: String) {
        devOpsServices(cloudId: $cloudId, filter: { nameContains: $nameContains }, first: $first, after: $after) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
`;
const $497949fa25bff5ec$var$pageLimit = 20;
const $497949fa25bff5ec$export$aaba171dbee0d63b = async (inputValue, after)=>(0, $breWd.post)(`${(0, $7FSs7.contextPath)}/gateway/api/graphql`, JSON.stringify({
        query: $497949fa25bff5ec$export$6ad2d0b3772389f4,
        variables: {
            after: after,
            cloudId: (0, $jByYr.getMeta)('tenant-id'),
            nameContains: inputValue,
            first: $497949fa25bff5ec$var$pageLimit
        }
    }), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const res = response;
        const { data: { devOpsServices: { nodes: nodes, pageInfo: { hasNextPage: hasNextPage, endCursor: endCursor } } } } = res;
        return {
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            services: nodes.map(({ id: id, name: name })=>({
                    label: name,
                    value: id
                }))
        };
    }).toPromise();

});

parcelRegister("dRMZ5", function(module, exports) {
$parcel$export(module.exports, "searchUser", () => $15e85be54242b7d6$export$c6a60b910185c7f2);
$parcel$export(module.exports, "updateUserProfile", () => $15e85be54242b7d6$export$c92c4ec7a2418617);
$parcel$export(module.exports, "changePassword", () => $15e85be54242b7d6$export$99d837dc30eb1ef7);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $h1yZX = parcelRequire("h1yZX");

var $9ypa9 = parcelRequire("9ypa9");

var $7FSs7 = parcelRequire("7FSs7");
const $15e85be54242b7d6$export$c6a60b910185c7f2 = (userQuery, context = (0, $7FSs7.contextPath))=>{
    const query = {
        query: userQuery.query,
        fieldName: userQuery.fieldName,
        fieldConfigId: userQuery.fieldConfigId
    };
    const queryString = $h1yZX.stringify(query);
    const uri = `${context}/rest/servicedesk/1/customer/portal/${userQuery.portalId}/user-search?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return ajaxResponse.response;
    }).catch((e)=>{
        (0, $9ypa9.trackError)('finduser.fetch.failed', {}, e);
        return (0, $fSYYZ.Observable).throw(e);
    });
};
const $15e85be54242b7d6$export$c92c4ec7a2418617 = (displayName, languageKey, timezone, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/user`;
    const body = {
        displayName: displayName,
        languageKey: languageKey,
        timezone: timezone
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $fSYYZ.Observable).throw(e);
    });
};
const $15e85be54242b7d6$export$99d837dc30eb1ef7 = (currentPassword, newPassword, confirmNewPassword, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/user/password`;
    const body = {
        current: currentPassword,
        password: newPassword,
        confirm: confirmNewPassword
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $breWd.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $fSYYZ.Observable).throw(e);
    });
};

});

parcelRegister("1BaaY", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_MODEL", () => (parcelRequire("8bKnT")).FETCH_REQUEST_CREATE_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_SUCCESS", () => (parcelRequire("8bKnT")).FETCH_REQUEST_CREATE_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_FAILURE", () => (parcelRequire("8bKnT")).FETCH_REQUEST_CREATE_FAILURE);
$parcel$export(module.exports, "RESET_REQUEST_CREATE_STATE", () => (parcelRequire("8bKnT")).RESET_REQUEST_CREATE_STATE);
$parcel$export(module.exports, "PROFORMA_FORM_DIRTY", () => (parcelRequire("8bKnT")).PROFORMA_FORM_DIRTY);
$parcel$export(module.exports, "fetchRequestCreateAction", () => (parcelRequire("8bKnT")).fetchRequestCreateAction);
$parcel$export(module.exports, "fetchRequestCreateSuccess", () => (parcelRequire("8bKnT")).fetchRequestCreateSuccess);
$parcel$export(module.exports, "fetchRequestCreateFailure", () => (parcelRequire("8bKnT")).fetchRequestCreateFailure);
$parcel$export(module.exports, "proformaFormDirtyAction", () => (parcelRequire("8bKnT")).proformaFormDirtyAction);
$parcel$export(module.exports, "resetRequestCreateStateAction", () => (parcelRequire("8bKnT")).resetRequestCreateStateAction);

var $8bKnT = parcelRequire("8bKnT");

});
parcelRegister("8bKnT", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_MODEL", () => $009e3933655261b0$export$d4d8c69b4715e057);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_SUCCESS", () => $009e3933655261b0$export$372a19d33177b0bf);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_FAILURE", () => $009e3933655261b0$export$fee18c3aa48984ad);
$parcel$export(module.exports, "RESET_REQUEST_CREATE_STATE", () => $009e3933655261b0$export$8b4f4d20da5c4667);
$parcel$export(module.exports, "PROFORMA_FORM_DIRTY", () => $009e3933655261b0$export$b8bfd97914e38eff);
$parcel$export(module.exports, "fetchRequestCreateAction", () => $009e3933655261b0$export$466553923c00f94b);
$parcel$export(module.exports, "fetchRequestCreateSuccess", () => $009e3933655261b0$export$180824a15bbc742e);
$parcel$export(module.exports, "fetchRequestCreateFailure", () => $009e3933655261b0$export$fdc3fd637ad84f03);
$parcel$export(module.exports, "resetRequestCreateStateAction", () => $009e3933655261b0$export$4f2b3c2ed928ac62);
$parcel$export(module.exports, "proformaFormDirtyAction", () => $009e3933655261b0$export$b8e903edf5d19376);

var $cWsyg = parcelRequire("cWsyg");
const $009e3933655261b0$export$d4d8c69b4715e057 = 'epic.model.FETCH_REQUEST_CREATE_MODEL';
const $009e3933655261b0$export$372a19d33177b0bf = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_SUCCESS';
const $009e3933655261b0$export$fee18c3aa48984ad = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_FAILURE';
const $009e3933655261b0$export$8b4f4d20da5c4667 = 'state.persisted.reqCreate.RESET_REQUEST_CREATE_STATE';
const $009e3933655261b0$export$67e1c6172c207525 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_ACTION';
const $009e3933655261b0$export$9d7c65c6842f6093 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_SUCCESS';
const $009e3933655261b0$export$751581aefd0ecd0 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_FAILURE';
const $009e3933655261b0$export$b8bfd97914e38eff = 'state.persisted.reqCreate.PROFORMA_FORM_DIRTY';
const $009e3933655261b0$export$466553923c00f94b = (0, $cWsyg.buildModelsActionCreator)($009e3933655261b0$export$d4d8c69b4715e057, 'reqCreate');
const $009e3933655261b0$export$180824a15bbc742e = (requestCreateResponse)=>({
        payload: requestCreateResponse,
        type: $009e3933655261b0$export$372a19d33177b0bf
    });
const $009e3933655261b0$export$fdc3fd637ad84f03 = (portalId, requestCreateId, error)=>({
        type: $009e3933655261b0$export$fee18c3aa48984ad,
        payload: {
            portalId: portalId,
            requestCreateId: requestCreateId,
            error: error
        }
    });
const $009e3933655261b0$export$702e4cce91196841 = (portalId, requestCreateId)=>({
        type: $009e3933655261b0$export$67e1c6172c207525,
        payload: {
            portalId: portalId,
            requestCreateId: requestCreateId
        }
    });
const $009e3933655261b0$export$a6d0fa922519029e = (mediaApiUploadInformation, portalId, requestCreateId)=>{
    return {
        type: $009e3933655261b0$export$9d7c65c6842f6093,
        payload: {
            mediaApiUploadInformation: mediaApiUploadInformation,
            portalId: portalId,
            requestCreateId: requestCreateId
        }
    };
};
const $009e3933655261b0$export$e9635fc96da2dc14 = ()=>{
    return {
        type: $009e3933655261b0$export$751581aefd0ecd0
    };
};
const $009e3933655261b0$export$4f2b3c2ed928ac62 = ()=>{
    return {
        type: $009e3933655261b0$export$8b4f4d20da5c4667,
        payload: {}
    };
};
const $009e3933655261b0$export$b8e903edf5d19376 = (payload)=>{
    return {
        payload: payload,
        type: $009e3933655261b0$export$b8bfd97914e38eff
    };
};

});


parcelRegister("kwSZC", function(module, exports) {
$parcel$export(module.exports, "toFieldStates", () => $1fe9d23792535c5b$export$9144b5804cf423d6);

var $HGACo = parcelRequire("HGACo");

var $aLwb2 = parcelRequire("aLwb2");
var $dUEnu = parcelRequire("dUEnu");

var $1EFS8 = parcelRequire("1EFS8");

var $bhZAK = parcelRequire("bhZAK");
const $1fe9d23792535c5b$var$MAX_CMDB_OBJECTS_PER_FIELD = 20;
const $1fe9d23792535c5b$var$MAX_AFFECTED_SERVICES_PER_FIELD = 20;
const $1fe9d23792535c5b$export$9144b5804cf423d6 = (fields)=>{
    return fields.map((field)=>{
        const fieldType = field.fieldType;
        switch(fieldType){
            case 'text':
                return $1fe9d23792535c5b$var$toTextFieldState(field);
            case 'textarea':
                return $1fe9d23792535c5b$var$toTextAreaState(field);
            case 'checkbox':
                return $1fe9d23792535c5b$var$toCheckboxGroupState(field);
            case 'radio':
                return $1fe9d23792535c5b$var$toRadioGroupState(field);
            case 'date':
            case 'duedate':
                return $1fe9d23792535c5b$var$toDateState(field, fieldType);
            case 'datetime':
                return $1fe9d23792535c5b$var$toDateTimeState(field);
            case 'attachment':
                return $1fe9d23792535c5b$var$toAttachmentState(field);
            case 'reporter':
                return $1fe9d23792535c5b$var$toReporterState(field);
            case 'userpicker':
                return $1fe9d23792535c5b$var$toUserPickerState(field);
            case 'multiuserpicker':
                return $1fe9d23792535c5b$var$toMultiUserPickerState(field);
            case 'organduserpicker':
                if ((0, $1EFS8.default).checkGate('jsm_portal_combined_share_with_field')) return $1fe9d23792535c5b$var$toOrgAndUserPickerState(field);
                // When feature flag is off, treat as unknown (like before)
                return $1fe9d23792535c5b$var$toUnknownState(field);
            case 'labelpicker':
                return $1fe9d23792535c5b$var$toLabelPickerState(field);
            case 'select':
                return $1fe9d23792535c5b$var$toSelectState(field);
            case 'multiselect':
                return $1fe9d23792535c5b$var$toMultiSelectState(field);
            case 'organisationpicker':
                return $1fe9d23792535c5b$var$toOrganisationState(field);
            case 'assetspicker':
                return $1fe9d23792535c5b$var$toAssetsState(field);
            case 'multiservicepicker':
                return $1fe9d23792535c5b$var$toMultiServicePickerState(field);
            case 'cascadingselect':
                return $1fe9d23792535c5b$var$toCascadingSelect(field);
            case 'cmdbobjectpicker':
                return $1fe9d23792535c5b$var$toCmdbObjectPickerState(field);
            case 'entitlementpicker':
                return $1fe9d23792535c5b$var$toEntitlementPickerState(field);
            case 'forge':
                return $1fe9d23792535c5b$var$toForgeFieldState(field);
            default:
                return $1fe9d23792535c5b$var$toUnknownState(field);
        }
    });
};
/**
 * Parses defaultObjectAsJson and converts to an object if it can be parsed
 */ const $1fe9d23792535c5b$var$getDefaultObjectAsJsonFromField = (field)=>{
    const { defaultObjectAsJson: defaultObjectAsJson } = field;
    let defaultObj;
    try {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultObj = defaultObjectAsJson && JSON.parse(defaultObjectAsJson);
    } catch (e) {
    // Swallow the error here
    }
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return defaultObj;
};
// This extracts all the common field properties, normally the only difference between fields are
// type and value
const $1fe9d23792535c5b$var$extractCommonFieldProperties = (field)=>({
        id: field.fieldId,
        displayed: field.displayed,
        label: field.label,
        required: field.required,
        description: field.descriptionHtml,
        ...(0, $HGACo.isUiModificationsSupportEnabled)() ? {
            jiraFieldType: field.jiraFieldType
        } : {}
    });
const $1fe9d23792535c5b$var$toTextFieldState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject } = field;
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'text',
        value: defaultObject ? defaultObject : ''
    };
};
const $1fe9d23792535c5b$var$toTextAreaState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, rendererType: rendererType, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    const emptyDefaultValue = (0, $HGACo.isRichTextAreaEnabled)() && rendererType === 'atlassian-wiki-renderer' ? undefined : '';
    return {
        ...baseFieldProperties,
        rendererType: rendererType,
        fieldConfigId: fieldConfigId,
        type: 'textarea',
        value: defaultObject ? defaultObject : emptyDefaultValue
    };
};
const $1fe9d23792535c5b$var$toCheckboxGroupState = (field)=>{
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    const fieldValues = field.values || [];
    const checkboxItems = fieldValues.map((fieldValue)=>({
            label: fieldValue.label,
            value: fieldValue.value,
            checked: fieldValue.selected
        }));
    const checkedItems = checkboxItems.filter((item)=>!!item.checked);
    const value = checkedItems.map((item)=>item.value);
    return {
        ...baseFieldProperties,
        value: value,
        type: 'checkbox',
        items: checkboxItems
    };
};
const $1fe9d23792535c5b$var$toRadioGroupState = (field)=>{
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    const fieldValues = field.values || [];
    const radioGroupItems = fieldValues.map((item)=>({
            name: field.fieldId,
            label: item.label,
            value: item.value,
            selected: item.selected
        }));
    const selectedItem = radioGroupItems.find((item)=>!!item.selected);
    const value = selectedItem ? selectedItem.value : '';
    return {
        ...baseFieldProperties,
        value: value,
        items: radioGroupItems,
        type: 'radio'
    };
};
const $1fe9d23792535c5b$var$IsoDateFormat = /^\d{4}-\d{2}-\d{2}$/;
const $1fe9d23792535c5b$var$normalizeDateTimeFromJson = (field, isoFormat)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    let defaultDate = $1fe9d23792535c5b$var$getDefaultObjectAsJsonFromField(field);
    if (!defaultDate || !(0, $dUEnu.default)(new Date(defaultDate))) // This needs fallback to undefined so the datetime picker sets todays date
    // as the initial screen correctly, else it's 1970.
    return undefined;
    // Fix for the one-day-off issue with new Date()
    // Link: [DateTime Picker One Day Off Issue](https://hello.atlassian.net/wiki/x/zwTjxw)
    if (defaultDate.match($1fe9d23792535c5b$var$IsoDateFormat)) defaultDate = defaultDate.replace(/-/g, '/');
    return (0, $aLwb2.default)(new Date(defaultDate), isoFormat);
};
const $1fe9d23792535c5b$var$toDateState = (field, fieldType)=>{
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        defaultDate: $1fe9d23792535c5b$var$normalizeDateTimeFromJson(field, 'yyyy-MM-dd'),
        type: fieldType,
        value: $1fe9d23792535c5b$var$normalizeDateTimeFromJson(field, 'yyyy-MM-dd')
    };
};
const $1fe9d23792535c5b$var$toDateTimeState = (field)=>{
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        defaultDate: $1fe9d23792535c5b$var$normalizeDateTimeFromJson(field, "yyyy-MM-dd'T'HH:mm"),
        type: 'datetime',
        // We don't store timezone date, it's assumed the timezone will be the users timezone set in Jira.
        value: $1fe9d23792535c5b$var$normalizeDateTimeFromJson(field, "yyyy-MM-dd'T'HH:mm")
    };
};
const $1fe9d23792535c5b$var$toReporterState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'reporter',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultReporter: defaultObject,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: defaultObject ? defaultObject.id : undefined,
        fieldConfigId: fieldConfigId ? String(fieldConfigId) : ''
    };
};
const $1fe9d23792535c5b$var$toUserPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'userpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultUser: defaultObject,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: defaultObject ? defaultObject.id : undefined,
        fieldConfigId: fieldConfigId ? String(fieldConfigId) : ''
    };
};
const $1fe9d23792535c5b$var$toMultiUserPickerState = (field)=>{
    const defaultList = field.defaultList || [];
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'multiuserpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultUsers: defaultList,
        fieldConfigId: field.fieldConfigId ? String(field.fieldConfigId) : '',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        value: defaultList.map((u)=>u.id).join(',')
    };
};
const $1fe9d23792535c5b$var$toOrgAndUserPickerState = (field)=>{
    var _field$portalFieldCon, _field$portalFieldCon2;
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    const autoCompleteUrl = // portalFieldConfiguration is typed as any in the Field type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    field.autoCompleteUrl ?? ((_field$portalFieldCon = field.portalFieldConfiguration) === null || _field$portalFieldCon === void 0 ? void 0 : _field$portalFieldCon.autoCompleteUrl);
    // Extract shareWithOrgByDefault from portalFieldConfiguration, defaulting to true if not provided
    const shareWithOrgByDefault = ((_field$portalFieldCon2 = field.portalFieldConfiguration) === null || _field$portalFieldCon2 === void 0 ? void 0 : _field$portalFieldCon2.shareWithOrgByDefault) ?? true;
    return {
        ...baseFieldProperties,
        autoCompleteUrl: autoCompleteUrl,
        shareWithOrgByDefault: shareWithOrgByDefault,
        type: 'organduserpicker',
        fieldConfigId: field.fieldConfigId ? String(field.fieldConfigId) : '',
        // defaultObject is typed as any in the Field type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: field.defaultObject ? field.defaultObject.id : undefined
    };
};
const $1fe9d23792535c5b$var$toSelectState = (field)=>{
    const selectedValue = field.values ? field.values.find((v)=>v.selected) : undefined;
    const value = selectedValue && selectedValue.value;
    return {
        ...$1fe9d23792535c5b$var$extractCommonFieldProperties(field),
        value: value,
        type: 'select',
        options: field.values || [],
        defaultValue: selectedValue
    };
};
const $1fe9d23792535c5b$var$toMultiSelectState = (field)=>{
    const selectedValues = field.values ? field.values.filter((v)=>v.selected) : [];
    const values = selectedValues.map((v)=>v.value);
    return {
        ...$1fe9d23792535c5b$var$extractCommonFieldProperties(field),
        type: 'multiselect',
        options: field.values || [],
        defaultValue: selectedValues,
        value: values
    };
};
const $1fe9d23792535c5b$var$toLabelPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const value = field.defaultList || [];
    /**
   * The field id takes the form of customfield_xxxx where xxxx is the custom field id.
   *
   * The field id can also be "label" if it is the system label field.
   * In the case where the field is the system field we will consider the custom field id to be undefiend
   */ const fieldIdTokens = (field.fieldId || '').toLowerCase().split('customfield_');
    const customFieldId = fieldIdTokens.length > 1 ? fieldIdTokens[1] : undefined;
    return {
        ...$1fe9d23792535c5b$var$extractCommonFieldProperties(field),
        value: value,
        customFieldId: customFieldId,
        type: 'labelpicker',
        defaultLabels: value.map((labelStr)=>({
                label: labelStr,
                value: labelStr
            }))
    };
};
const $1fe9d23792535c5b$var$toCascadingSelect = (field)=>{
    const selectedGroup = field.values && field.values.find((v)=>v.selected);
    const selectedValue = selectedGroup && selectedGroup.children.find((v)=>v.selected);
    const value = selectedGroup && {
        primaryValue: selectedGroup.value,
        children: selectedValue && selectedValue.value
    };
    /**
   * UI Modifications requires defaultValue because it includes both labels and values for parent and child options,
   * whereas the value field only contains the values. This enables the getValueTransformer to properly
   * reconstruct the complete option data structure with value and labels.
   */ const defaultValue = selectedGroup ? {
        primaryValue: {
            label: selectedGroup.label,
            value: selectedGroup.value
        },
        children: selectedValue ? {
            label: selectedValue.label,
            value: selectedValue.value
        } : undefined
    } : undefined;
    const options = field.values ? field.values.map((v)=>({
            label: v.label,
            value: v.value,
            children: v.children
        })) : [];
    return {
        ...$1fe9d23792535c5b$var$extractCommonFieldProperties(field),
        options: options,
        value: value,
        type: 'cascadingselect',
        ...(0, $HGACo.cascadingSelectDefaultValueSupportEnabled)() ? {
            defaultValue: defaultValue
        } : {}
    };
};
const $1fe9d23792535c5b$var$toOrganisationState = (field)=>{
    var _field$portalFieldCon3;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { fieldConfigId: fieldConfigId, defaultObject: defaultObject } = field;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const shareWithOrgByDefault = ((_field$portalFieldCon3 = field.portalFieldConfiguration) === null || _field$portalFieldCon3 === void 0 ? void 0 : _field$portalFieldCon3.shareWithOrgByDefault) ?? true;
    return {
        ...$1fe9d23792535c5b$var$extractCommonFieldProperties(field),
        fieldConfigId: fieldConfigId,
        shareWithOrgByDefault: // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        shareWithOrgByDefault,
        type: 'organisationpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: defaultObject
    };
};
const $1fe9d23792535c5b$var$toAssetsState = (field)=>{
    const { fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        fieldConfigId: fieldConfigId,
        type: 'assetspicker'
    };
};
const $1fe9d23792535c5b$var$toMultiServicePickerState = (field)=>{
    var _field$portalFieldCon4;
    return {
        ...$1fe9d23792535c5b$var$extractCommonFieldProperties(field),
        type: 'multiservicepicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        limit: ((_field$portalFieldCon4 = field.portalFieldConfiguration) === null || _field$portalFieldCon4 === void 0 ? void 0 : _field$portalFieldCon4.limit) ?? $1fe9d23792535c5b$var$MAX_AFFECTED_SERVICES_PER_FIELD
    };
};
const $1fe9d23792535c5b$var$toAttachmentState = (field)=>{
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        value: [],
        type: 'attachment'
    };
};
const $1fe9d23792535c5b$var$toCmdbObjectPickerState = (field)=>{
    var _field$portalFieldCon5, _field$portalFieldCon6, _field$portalFieldCon7;
    return {
        ...$1fe9d23792535c5b$var$extractCommonFieldProperties(field),
        hasValidConfig: Boolean(field.portalFieldConfiguration),
        type: 'cmdbobjectpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        isMulti: field.portalFieldConfiguration ? field.portalFieldConfiguration.isMulti : false,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        filterAttributes: field.portalFieldConfiguration ? field.portalFieldConfiguration.filterAttributes : [],
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        limit: ((_field$portalFieldCon5 = field.portalFieldConfiguration) === null || _field$portalFieldCon5 === void 0 ? void 0 : _field$portalFieldCon5.limit) ?? $1fe9d23792535c5b$var$MAX_CMDB_OBJECTS_PER_FIELD,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        placeholderKeys: // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ((_field$portalFieldCon6 = field.portalFieldConfiguration) === null || _field$portalFieldCon6 === void 0 ? void 0 : _field$portalFieldCon6.placeholderKeys) ?? undefined,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        populateDefaultValue: // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ((_field$portalFieldCon7 = field.portalFieldConfiguration) === null || _field$portalFieldCon7 === void 0 ? void 0 : _field$portalFieldCon7.populateDefaultValue) ?? false
    };
};
const $1fe9d23792535c5b$var$toEntitlementPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject } = field;
    if ((0, $HGACo.isJsmPortalRovoIntegrationEnabled)()) return {
        ...$1fe9d23792535c5b$var$extractCommonFieldProperties(field),
        type: 'entitlementpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: defaultObject
    };
    return {
        ...$1fe9d23792535c5b$var$extractCommonFieldProperties(field),
        type: 'entitlementpicker'
    };
};
const $1fe9d23792535c5b$var$toForgeFieldState = (field)=>{
    var _field$forge, _forgeExtension$prope, _forgeExtension$prope2;
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    const forgeExtension = (_field$forge = field.forge) === null || _field$forge === void 0 ? void 0 : _field$forge.extension;
    const fieldType = forgeExtension === null || forgeExtension === void 0 || (_forgeExtension$prope = forgeExtension.properties) === null || _forgeExtension$prope === void 0 ? void 0 : _forgeExtension$prope.type;
    const collectionType = forgeExtension === null || forgeExtension === void 0 || (_forgeExtension$prope2 = forgeExtension.properties) === null || _forgeExtension$prope2 === void 0 ? void 0 : _forgeExtension$prope2.collection;
    // defaultObject is typed as any in the Field type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const defaultObject = field.defaultObject;
    const defaultList = field.defaultList || [];
    const { value: value, additionalProps: additionalProps } = (0, $bhZAK.forgeFieldParamsParser)(fieldType, collectionType, defaultObject, defaultList);
    if ((0, $HGACo.isForgeCustomFieldsOnPortalViewEnabled)()) return {
        value: value,
        ...baseFieldProperties,
        ...additionalProps,
        type: 'forge',
        extension: forgeExtension
    };
    return {
        ...baseFieldProperties,
        type: 'forge',
        jiraFieldType: field.jiraFieldType // TODO: remove as with ditto_uim_-_jsm_support_main FF cleanup
    };
};
const $1fe9d23792535c5b$var$toUnknownState = (field)=>{
    const baseFieldProperties = $1fe9d23792535c5b$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'unknown'
    };
};

});
parcelRegister("bhZAK", function(module, exports) {
$parcel$export(module.exports, "forgeFieldParamsParser", () => $5924fd08ed19c777$export$ba975bd6e357689d);

var $aLwb2 = parcelRequire("aLwb2");
const $5924fd08ed19c777$export$ba975bd6e357689d = (fieldType, collectionType, defaultObject, defaultList)=>{
    let value;
    let additionalProps = {};
    switch(fieldType){
        case 'string':
            if (collectionType === 'list') {
                value = defaultList;
                additionalProps = {
                    // String list is rendered as label picker
                    defaultLabels: value.map((labelStr)=>({
                            label: labelStr,
                            value: labelStr
                        }))
                };
            } else value = defaultObject;
            break;
        case 'number':
            value = defaultObject;
            break;
        case 'date':
            value = defaultObject ? (0, $aLwb2.default)(new Date(defaultObject), 'yyyy-MM-dd') : undefined;
            additionalProps = {
                defaultDate: value
            };
            break;
        case 'datetime':
            value = defaultObject ? (0, $aLwb2.default)(new Date(defaultObject), "yyyy-MM-dd'T'HH:mm") : undefined;
            additionalProps = {
                defaultDate: value
            };
            break;
        case 'user':
            if (collectionType === 'list') {
                value = defaultList.map((u)=>u.id).join(',');
                additionalProps = {
                    defaultUsers: defaultList
                };
            } else {
                value = defaultList && defaultList.length > 0 ? defaultList[0].id : undefined;
                additionalProps = {
                    defaultUser: defaultList[0]
                };
            }
            break;
        default:
            value = null;
            break;
    }
    return {
        value: value,
        additionalProps: additionalProps
    };
};

});


parcelRegister("sKUlZ", function(module, exports) {
$parcel$export(module.exports, "parseFieldUrlParams", () => $36d21aea10192dc1$export$23f65b7a085343aa);

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $h1yZX = parcelRequire("h1yZX");

var $iRgiu = parcelRequire("iRgiu");

var $jjE9o = parcelRequire("jjE9o");

var $6GNhI = parcelRequire("6GNhI");
const $36d21aea10192dc1$var$CASCADE_SELECT_ID_SUFFIX = ':1';
function $36d21aea10192dc1$export$23f65b7a085343aa(fields) {
    if (!fields || fields.length === 0) return {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const urlParams = (0, $h1yZX.parse)((0, $6GNhI.search)());
    if (!urlParams) return {};
    return fields.reduce((values, field)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const urlParamValue = urlParams[field.id];
        if (urlParamValue !== undefined) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const cascadeNestedSelectUrlParamValue = urlParams[`${field.id}${$36d21aea10192dc1$var$CASCADE_SELECT_ID_SUFFIX}`];
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            values[field.id] = $36d21aea10192dc1$var$parseUrlParamValue(field, urlParamValue, cascadeNestedSelectUrlParamValue);
            if (cascadeNestedSelectUrlParamValue) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            values[`${field.id}${$36d21aea10192dc1$var$CASCADE_SELECT_ID_SUFFIX}`] = cascadeNestedSelectUrlParamValue;
        }
        return values;
    }, {});
}
function $36d21aea10192dc1$var$parseUrlParamValue(field, urlParamValue, cascadeNestedSelectUrlParamValue) {
    $36d21aea10192dc1$var$firePrePopAnalyticsEvent(field);
    switch(field.type){
        case 'labelpicker':
            return $36d21aea10192dc1$var$parseLabelsUrlParam(urlParamValue);
        case 'checkbox':
            {
                const checkboxGroup = field;
                return $36d21aea10192dc1$var$parseCheckboxUrlParam(urlParamValue, checkboxGroup.items);
            }
        case 'select':
            {
                const select = field;
                return $36d21aea10192dc1$var$parseSelectUrlParam(urlParamValue, select.options);
            }
        case 'multiselect':
            {
                const multiSelect = field;
                return $36d21aea10192dc1$var$parseMultiSelectUrlParam(urlParamValue, multiSelect.options);
            }
        case 'cascadingselect':
            {
                const cascadingSelectState = field;
                return $36d21aea10192dc1$var$parseCascadingSelectUrlParam(cascadingSelectState.options, urlParamValue, cascadeNestedSelectUrlParamValue);
            }
        case 'textarea':
            if ((0, $HGACo.isRichTextAreaEnabled)() && field.rendererType === 'atlassian-wiki-renderer') return $36d21aea10192dc1$var$parseRichTextAreaUrlParam(urlParamValue);
            return urlParamValue;
        case 'multiuserpicker':
            return urlParamValue;
        default:
            // Dynamic fields are handled directly in hydrateUrlParamOverrides() since async calls need to be made
            return urlParamValue;
    }
}
function $36d21aea10192dc1$var$firePrePopAnalyticsEvent(field) {
    const actionSubjectId = field.id.startsWith('customfield') ? 'customfield' : field.id;
    (0, $jjE9o.operationalEvent)({
        actionSubjectId: actionSubjectId,
        action: 'prePopulated',
        actionSubject: 'field',
        source: (0, $8rTkC.ScreenName).REQUEST_CREATE,
        attributes: {
            fieldType: field.type
        }
    });
}
function $36d21aea10192dc1$var$parseLabelsUrlParam(labels) {
    if ($36d21aea10192dc1$var$isEmptyStringOrArray(labels)) return [];
    if (typeof labels === 'string') {
        const singleLabel = labels;
        return [
            {
                label: singleLabel,
                value: singleLabel
            }
        ];
    }
    const multipleLabels = labels;
    return multipleLabels.map((toConvert)=>({
            label: toConvert,
            value: toConvert
        }));
}
const $36d21aea10192dc1$var$isEmptyStringOrArray = (value)=>value.length === 0;
const $36d21aea10192dc1$var$parseSelectUrlParam = (urlParam, options)=>options.find((option)=>option.value === urlParam);
function $36d21aea10192dc1$var$parseCheckboxUrlParam(checkedUrlParam, items) {
    if ($36d21aea10192dc1$var$isEmptyStringOrArray(checkedUrlParam)) return [];
    if (typeof checkedUrlParam === 'string') {
        const checkedBoxValue = checkedUrlParam;
        const checkedBox = items.find((item)=>item.value === checkedBoxValue);
        return checkedBox ? [
            checkedBox.value
        ] : [];
    }
    const checkedBoxValues = checkedUrlParam;
    return items.filter((item)=>checkedBoxValues.includes(item.value)).map((item)=>item.value);
}
function $36d21aea10192dc1$var$parseMultiSelectUrlParam(selected, options) {
    if ($36d21aea10192dc1$var$isEmptyStringOrArray(selected)) return [];
    if (typeof selected === 'string') {
        const selection = selected;
        return options.filter((option)=>option.value === selection);
    }
    const selections = selected;
    return options.filter((option)=>selections.includes(option.value));
}
function $36d21aea10192dc1$var$parseCascadingSelectUrlParam(options, parentUrlParam, childUrlParam) {
    const parentOption = options.find((option)=>option.value === parentUrlParam);
    if (!parentOption) return null;
    const childOption = parentOption.children.find((option)=>option.value === childUrlParam);
    return {
        primaryValue: parentOption.value,
        children: childOption && childOption.value
    };
}
const $36d21aea10192dc1$var$parseRichTextAreaUrlParam = (urlParam)=>JSON.stringify((0, $iRgiu.plainTextToAdfParagraph)(urlParam));

});
parcelRegister("iRgiu", function(module, exports) {
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $e8ac885a7e630ed9$export$cf4bde415465976c);
$parcel$export(module.exports, "parseAdf", () => $e8ac885a7e630ed9$export$5659c60045974de9);
$parcel$export(module.exports, "plainTextToAdfParagraph", () => $e8ac885a7e630ed9$export$a5c4f0d0658bc780);
$parcel$export(module.exports, "getAccountIdsFromComment", () => $e8ac885a7e630ed9$export$f9672ae84945eb8e);

var $1CVmW = parcelRequire("1CVmW");

var $4zGZd = parcelRequire("4zGZd");

var $jsmb9 = parcelRequire("jsmb9");
const $e8ac885a7e630ed9$var$hardBreakNodeType = 'hardBreak';
const $e8ac885a7e630ed9$export$cf4bde415465976c = (adf)=>{
    if (adf && adf.content) return adf.content.every((content)=>{
        return $e8ac885a7e630ed9$var$isOnlyWhitespaceParagraphNode(content);
    });
    return false;
};
const $e8ac885a7e630ed9$var$isOnlyWhitespaceParagraphNode = (content)=>{
    if (content.type === 'paragraph') return content.content === undefined || content.content.length === 0 || content.content.every((innerContent)=>$e8ac885a7e630ed9$var$isOnlyWhitespaceTextNode(innerContent) || $e8ac885a7e630ed9$var$isHardBreakNode(innerContent));
    return false;
};
const $e8ac885a7e630ed9$var$isOnlyWhitespaceTextNode = (content)=>{
    if ((content === null || content === void 0 ? void 0 : content.type) === 'text') return content.text === undefined || content.text.match(/^\s*$/) !== null;
    return false;
};
const $e8ac885a7e630ed9$var$isHardBreakNode = (content)=>{
    return (content === null || content === void 0 ? void 0 : content.type) === $e8ac885a7e630ed9$var$hardBreakNodeType;
};
const $e8ac885a7e630ed9$export$5659c60045974de9 = (content)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const node = JSON.parse(content);
    /*
  With Editor and Media upgrade, we have a strongly typed renderer, which is causing some types
  to break. This (typecasting to DocNode['content']) should be fixed in a follow-up.
  */ node.content = $e8ac885a7e630ed9$var$removeSuffixFromNodes(node.content);
    return node;
};
const $e8ac885a7e630ed9$var$removeSuffixFromNodes = (nodes)=>{
    if (!nodes) return nodes;
    return nodes.map((node)=>{
        if (!node) return node;
        if (node.type === 'inlineCard' && node.attrs) node.attrs = $e8ac885a7e630ed9$var$updateInlineCardAttributes(node.attrs);
        if (node.content) node.content = $e8ac885a7e630ed9$var$removeSuffixFromNodes(node.content);
        return node;
    });
};
const $e8ac885a7e630ed9$export$a5c4f0d0658bc780 = (plainText)=>({
        version: 1,
        // Using static version number as this doesn't seem to change
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: plainText
                    }
                ]
            }
        ]
    });
const $e8ac885a7e630ed9$var$removedIcftFromUrlCache = {};
const $e8ac885a7e630ed9$var$updateInlineCardAttributes = (attributes)=>{
    if (attributes.url && (0, $jsmb9.parseIssueKeyFromUrl)(attributes.url)) {
        if (!$e8ac885a7e630ed9$var$removedIcftFromUrlCache[attributes.url]) {
            (0, $4zGZd.trackLegacyEvent)('servicedesk.customerview.util.adf.remove.icft.suffix', {});
            $e8ac885a7e630ed9$var$removedIcftFromUrlCache[attributes.url] = true;
        }
        attributes.url = $e8ac885a7e630ed9$var$removeICFTURLSuffix(attributes.url);
    }
    return attributes;
};
const $e8ac885a7e630ed9$var$removeICFTURLSuffix = (content)=>{
    return content.replace(/#icft=[A-Z][A-Z0-9_]+-\d+/gi, '');
};
const $e8ac885a7e630ed9$export$f9672ae84945eb8e = (adfText)=>{
    const accountIds = new Map();
    (0, $1CVmW.traverse)(adfText, {
        mention: (node)=>{
            var _node$attrs, _node$attrs2;
            /* text can be of form @user_name or user_name */ // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            let displayName = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.text;
            if (displayName) displayName = displayName.charAt(0) === '@' ? displayName.substring(1) : displayName;
            accountIds.set((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.id, displayName);
        }
    });
    return accountIds;
};

});
parcelRegister("1CVmW", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $6a769667061488ea$export$df3f009e3d155b20);
function $6a769667061488ea$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $6a769667061488ea$export$df3f009e3d155b20(adf, visitors) {
    if (!$6a769667061488ea$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $6a769667061488ea$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $6a769667061488ea$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $6a769667061488ea$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});



parcelRegister("3iEGo", function(module, exports) {
$parcel$export(module.exports, "fetchCmdbObjectsWithSignal", () => (parcelRequire("hPvsJ")).fetchCmdbObjectsWithSignal);

var $hPvsJ = parcelRequire("hPvsJ");

});
parcelRegister("hPvsJ", function(module, exports) {
$parcel$export(module.exports, "fetchCmdbObjectsWithSignal", () => $8560e2d2f8531763$export$d4d0e07838855f63);

var $HGACo = parcelRequire("HGACo");

var $klz3F = parcelRequire("klz3F");

var $7FSs7 = parcelRequire("7FSs7");
const $8560e2d2f8531763$export$d4d0e07838855f63 = (portalId, requestTypeId, fieldId, inputValue, fieldValueMap, signal, start)=>{
    const fieldValueMapObject = fieldValueMap.reduce((accumulator, field)=>{
        if (field[0] !== 'attachment') accumulator[field[0]] = field[1];
        return accumulator;
    }, {});
    const body = {
        query: inputValue,
        fieldValueMap: fieldValueMapObject
    };
    return (0, $HGACo.isFetchJsonUsedInCmdbObjectField)() ? (0, $klz3F.fetchJson)(`${(0, $7FSs7.contextPath)}/rest/servicedesk/cmdb/1/customer/portal/${portalId}/request/${requestTypeId}/field/${fieldId}/autocomplete?start=${start}`, {
        signal: signal,
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(({ results: results, total: total, hasNextPage: hasNextPage })=>({
            total: total,
            hasNextPage: hasNextPage,
            cmdbObjects: results
        })) : fetch(`${(0, $7FSs7.contextPath)}/rest/servicedesk/cmdb/1/customer/portal/${portalId}/request/${requestTypeId}/field/${fieldId}/autocomplete?start=${start}`, {
        signal: signal,
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json()).then(({ results: results, total: total, hasNextPage: hasNextPage })=>({
            total: total,
            hasNextPage: hasNextPage,
            cmdbObjects: results
        }));
};

});



parcelRegister("dC4A1", function(module, exports) {
$parcel$export(module.exports, "requestDetailsEpic", () => $6d57338d2bbc95b9$export$211ba11a17095531);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");
const $6d57338d2bbc95b9$export$211ba11a17095531 = (action$)=>{
    return action$.ofType((0, $jra4c.FETCH_REQUEST_DETAILS_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload, {
            type: 'secondary',
            disableBatching: true
        }).filter((response)=>!!response.reqDetails && !!response.reqDetails.issue).map((response)=>{
            return (0, $jra4c.fetchRequestDetailsSuccess)(response.reqDetails);
        }).catch((error)=>{
            const key = action.payload.params.key;
            return (0, $fSYYZ.Observable).of((0, $jra4c.fetchRequestDetailsFailure)(key, error));
        }));
};

});
parcelRegister("TCR46", function(module, exports) {
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION", () => (parcelRequire("jra4c")).CHANGE_SUBSCRIPTION);
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION_SUCCESS", () => (parcelRequire("jra4c")).CHANGE_SUBSCRIPTION_SUCCESS);
$parcel$export(module.exports, "CREATE_COMMENT", () => (parcelRequire("jra4c")).CREATE_COMMENT);
$parcel$export(module.exports, "CREATE_COMMENT_SUCCESS", () => (parcelRequire("jra4c")).CREATE_COMMENT_SUCCESS);
$parcel$export(module.exports, "CREATE_COMMENT_FAILURE", () => (parcelRequire("jra4c")).CREATE_COMMENT_FAILURE);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS", () => (parcelRequire("jra4c")).GET_MEDIA_READ_CREDENTIALS);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS_SUCCESS", () => (parcelRequire("jra4c")).GET_MEDIA_READ_CREDENTIALS_SUCCESS);
$parcel$export(module.exports, "DECIDE_APPROVAL", () => (parcelRequire("jra4c")).DECIDE_APPROVAL);
$parcel$export(module.exports, "DECIDE_APPROVAL_FAILURE", () => (parcelRequire("jra4c")).DECIDE_APPROVAL_FAILURE);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_MODEL", () => (parcelRequire("jra4c")).FETCH_REQUEST_DETAILS_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_SUCCESS", () => (parcelRequire("jra4c")).FETCH_REQUEST_DETAILS_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_FAILURE", () => (parcelRequire("jra4c")).FETCH_REQUEST_DETAILS_FAILURE);
$parcel$export(module.exports, "REMOVE_ORGANISATION", () => (parcelRequire("jra4c")).REMOVE_ORGANISATION);
$parcel$export(module.exports, "REMOVE_ORGANISATION_SUCCESS", () => (parcelRequire("jra4c")).REMOVE_ORGANISATION_SUCCESS);
$parcel$export(module.exports, "ADD_PARTICIPANTS_SUCCESS", () => (parcelRequire("jra4c")).ADD_PARTICIPANTS_SUCCESS);
$parcel$export(module.exports, "REMOVE_PARTICIPANT", () => (parcelRequire("jra4c")).REMOVE_PARTICIPANT);
$parcel$export(module.exports, "REMOVE_PARTICIPANT_SUCCESS", () => (parcelRequire("jra4c")).REMOVE_PARTICIPANT_SUCCESS);
$parcel$export(module.exports, "SHARE_REQUEST", () => (parcelRequire("jra4c")).SHARE_REQUEST);
$parcel$export(module.exports, "SHOW_TRANSITION_DIALOG", () => (parcelRequire("jra4c")).SHOW_TRANSITION_DIALOG);
$parcel$export(module.exports, "HIDE_TRANSITION_DIALOG", () => (parcelRequire("jra4c")).HIDE_TRANSITION_DIALOG);
$parcel$export(module.exports, "TRANSITION_REQUEST", () => (parcelRequire("jra4c")).TRANSITION_REQUEST);
$parcel$export(module.exports, "TRANSITION_REQUEST_FAILURE", () => (parcelRequire("jra4c")).TRANSITION_REQUEST_FAILURE);
$parcel$export(module.exports, "CLEAR_TRANSITION_REQUEST_FAILURE", () => (parcelRequire("jra4c")).CLEAR_TRANSITION_REQUEST_FAILURE);
$parcel$export(module.exports, "changeSubscription", () => (parcelRequire("jra4c")).changeSubscription);
$parcel$export(module.exports, "changeSubscriptionSuccess", () => (parcelRequire("jra4c")).changeSubscriptionSuccess);
$parcel$export(module.exports, "createCommentFailure", () => (parcelRequire("jra4c")).createCommentFailure);
$parcel$export(module.exports, "createComment", () => (parcelRequire("jra4c")).createComment);
$parcel$export(module.exports, "createCommentSuccess", () => (parcelRequire("jra4c")).createCommentSuccess);
$parcel$export(module.exports, "getReadCredentials", () => (parcelRequire("jra4c")).getReadCredentials);
$parcel$export(module.exports, "getReadCredentialsSuccess", () => (parcelRequire("jra4c")).getReadCredentialsSuccess);
$parcel$export(module.exports, "getReadCredentialsFailure", () => (parcelRequire("jra4c")).getReadCredentialsFailure);
$parcel$export(module.exports, "decideApproval", () => (parcelRequire("jra4c")).decideApproval);
$parcel$export(module.exports, "decideApprovalFailure", () => (parcelRequire("jra4c")).decideApprovalFailure);
$parcel$export(module.exports, "fetchRequestDetailsModel", () => (parcelRequire("jra4c")).fetchRequestDetailsModel);
$parcel$export(module.exports, "fetchRequestDetailsSuccess", () => (parcelRequire("jra4c")).fetchRequestDetailsSuccess);
$parcel$export(module.exports, "fetchRequestDetailsFailure", () => (parcelRequire("jra4c")).fetchRequestDetailsFailure);
$parcel$export(module.exports, "removeOrganisation", () => (parcelRequire("jra4c")).removeOrganisation);
$parcel$export(module.exports, "removeOrganisationSuccess", () => (parcelRequire("jra4c")).removeOrganisationSuccess);
$parcel$export(module.exports, "addParticipantsSuccess", () => (parcelRequire("jra4c")).addParticipantsSuccess);
$parcel$export(module.exports, "removeParticipant", () => (parcelRequire("jra4c")).removeParticipant);
$parcel$export(module.exports, "removeParticipantSuccess", () => (parcelRequire("jra4c")).removeParticipantSuccess);
$parcel$export(module.exports, "shareRequest", () => (parcelRequire("jra4c")).shareRequest);
$parcel$export(module.exports, "showTransitionDialog", () => (parcelRequire("jra4c")).showTransitionDialog);
$parcel$export(module.exports, "hideTransitionDialog", () => (parcelRequire("jra4c")).hideTransitionDialog);
$parcel$export(module.exports, "transitionRequest", () => (parcelRequire("jra4c")).transitionRequest);
$parcel$export(module.exports, "transitionRequestFailure", () => (parcelRequire("jra4c")).transitionRequestFailure);
$parcel$export(module.exports, "clearTransitionRequestFailure", () => (parcelRequire("jra4c")).clearTransitionRequestFailure);

var $jra4c = parcelRequire("jra4c");

});
parcelRegister("jra4c", function(module, exports) {
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION", () => $e4eb613104372200$export$c82a76c42259b55e);
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION_SUCCESS", () => $e4eb613104372200$export$aed2f68a180d5132);
$parcel$export(module.exports, "CREATE_COMMENT", () => $e4eb613104372200$export$b2aae42fb0a19db3);
$parcel$export(module.exports, "CREATE_COMMENT_SUCCESS", () => $e4eb613104372200$export$5e5d6c973a5c4e53);
$parcel$export(module.exports, "CREATE_COMMENT_FAILURE", () => $e4eb613104372200$export$423d075659092bbe);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS", () => $e4eb613104372200$export$6e57eb44a84791a7);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS_SUCCESS", () => $e4eb613104372200$export$710f501aa8462ae0);
$parcel$export(module.exports, "DECIDE_APPROVAL", () => $e4eb613104372200$export$17b4c1a883566436);
$parcel$export(module.exports, "DECIDE_APPROVAL_FAILURE", () => $e4eb613104372200$export$32a89de369c73827);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_MODEL", () => $e4eb613104372200$export$c6977262f615318f);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_SUCCESS", () => $e4eb613104372200$export$16e2b1f014063eb8);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_FAILURE", () => $e4eb613104372200$export$b793c4f327f63a76);
$parcel$export(module.exports, "REMOVE_ORGANISATION", () => $e4eb613104372200$export$8fb5a515e01e48c5);
$parcel$export(module.exports, "REMOVE_ORGANISATION_SUCCESS", () => $e4eb613104372200$export$74436d62ceb0e590);
$parcel$export(module.exports, "ADD_PARTICIPANTS_SUCCESS", () => $e4eb613104372200$export$85378bb183dca844);
$parcel$export(module.exports, "REMOVE_PARTICIPANT", () => $e4eb613104372200$export$fbce83858fb867fb);
$parcel$export(module.exports, "REMOVE_PARTICIPANT_SUCCESS", () => $e4eb613104372200$export$dfb1c2f386aee705);
$parcel$export(module.exports, "SHARE_REQUEST", () => $e4eb613104372200$export$5cf2f51c187a7d5f);
$parcel$export(module.exports, "SHOW_TRANSITION_DIALOG", () => $e4eb613104372200$export$7fb10a1857e0e02a);
$parcel$export(module.exports, "HIDE_TRANSITION_DIALOG", () => $e4eb613104372200$export$3a407eae5b6f60b);
$parcel$export(module.exports, "TRANSITION_REQUEST", () => $e4eb613104372200$export$a966f1a0c1a920e7);
$parcel$export(module.exports, "TRANSITION_REQUEST_FAILURE", () => $e4eb613104372200$export$fd4af480b5082555);
$parcel$export(module.exports, "CLEAR_TRANSITION_REQUEST_FAILURE", () => $e4eb613104372200$export$9e405a82dd6dd4e1);
$parcel$export(module.exports, "fetchRequestDetailsModel", () => $e4eb613104372200$export$5d6a7943e794d360);
$parcel$export(module.exports, "fetchRequestDetailsSuccess", () => $e4eb613104372200$export$f9b1366a7a60a8a);
$parcel$export(module.exports, "addParticipantsSuccess", () => $e4eb613104372200$export$524d371754c76f3c);
$parcel$export(module.exports, "fetchRequestDetailsFailure", () => $e4eb613104372200$export$5ef0f7883c2144b6);
$parcel$export(module.exports, "changeSubscription", () => $e4eb613104372200$export$99effa43b85cc1d1);
$parcel$export(module.exports, "changeSubscriptionSuccess", () => $e4eb613104372200$export$e91b59ae91b1c17d);
$parcel$export(module.exports, "decideApprovalFailure", () => $e4eb613104372200$export$8ab1e7354f0ec72f);
$parcel$export(module.exports, "decideApproval", () => $e4eb613104372200$export$5fffe31f8df4a90b);
$parcel$export(module.exports, "removeOrganisation", () => $e4eb613104372200$export$66d4278db03b2954);
$parcel$export(module.exports, "removeOrganisationSuccess", () => $e4eb613104372200$export$f8de82921adab699);
$parcel$export(module.exports, "removeParticipant", () => $e4eb613104372200$export$971a7382b074b466);
$parcel$export(module.exports, "removeParticipantSuccess", () => $e4eb613104372200$export$9be1ee8fbc799e1c);
$parcel$export(module.exports, "shareRequest", () => $e4eb613104372200$export$904a7ffbfa202969);
$parcel$export(module.exports, "showTransitionDialog", () => $e4eb613104372200$export$375ec276b5b0476c);
$parcel$export(module.exports, "hideTransitionDialog", () => $e4eb613104372200$export$69175c2908a46e20);
$parcel$export(module.exports, "transitionRequest", () => $e4eb613104372200$export$e72771314c1d54);
$parcel$export(module.exports, "transitionRequestFailure", () => $e4eb613104372200$export$18f56c137e75378a);
$parcel$export(module.exports, "clearTransitionRequestFailure", () => $e4eb613104372200$export$20cf1fa346e88708);
$parcel$export(module.exports, "createComment", () => $e4eb613104372200$export$2a15b079e3f46654);
$parcel$export(module.exports, "createCommentSuccess", () => $e4eb613104372200$export$e993efecfd9a08b4);
$parcel$export(module.exports, "createCommentFailure", () => $e4eb613104372200$export$5e212521c28e6663);
$parcel$export(module.exports, "getReadCredentials", () => $e4eb613104372200$export$c62f8329852c0c3e);
$parcel$export(module.exports, "getReadCredentialsSuccess", () => $e4eb613104372200$export$1c3602ad787f66de);
$parcel$export(module.exports, "getReadCredentialsFailure", () => $e4eb613104372200$export$c1fdee8bb31030c2);

var $cWsyg = parcelRequire("cWsyg");
const $e4eb613104372200$export$c82a76c42259b55e = 'state.persisted.request.details.CHANGE_SUBSCRIPTION';
const $e4eb613104372200$export$aed2f68a180d5132 = 'state.persisted.request.details.CHANGE_SUBSCRIPTION_SUCCESS';
const $e4eb613104372200$export$b2aae42fb0a19db3 = 'state.persisted.request.details.CREATE_COMMENT';
const $e4eb613104372200$export$5e5d6c973a5c4e53 = 'state.persisted.request.details.CREATE_COMMENT_SUCCESS';
const $e4eb613104372200$export$423d075659092bbe = 'state.persisted.request.details.CREATE_COMMENT_FAILURE';
const $e4eb613104372200$export$6e57eb44a84791a7 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS';
const $e4eb613104372200$export$710f501aa8462ae0 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS_SUCCESS';
const $e4eb613104372200$export$73373e74567a5c83 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS_FAILURE';
const $e4eb613104372200$export$17b4c1a883566436 = 'state.persisted.request.details.DECIDE_APPROVAL';
const $e4eb613104372200$export$32a89de369c73827 = 'state.persisted.request.details.DECIDE_APPROVAL_FAILURE';
const $e4eb613104372200$export$c6977262f615318f = 'epic.model.FETCH_REQUEST_DETAILS_MODEL';
const $e4eb613104372200$export$16e2b1f014063eb8 = 'state.persisted.request.details.FETCH_REQUEST_DETAILS_SUCCESS';
const $e4eb613104372200$export$b793c4f327f63a76 = 'state.persisted.request.details.FETCH_REQUEST_DETAILS_FAILURE';
const $e4eb613104372200$export$8fb5a515e01e48c5 = 'state.persisted.request.details.REMOVE_ORGANISATION';
const $e4eb613104372200$export$74436d62ceb0e590 = 'state.persisted.request.details.REMOVE_ORGANISATION_SUCCESS';
const $e4eb613104372200$export$85378bb183dca844 = 'state.persisted.request.details.ADD_PARTICIPANTS_SUCCESS';
const $e4eb613104372200$export$fbce83858fb867fb = 'state.persisted.request.details.REMOVE_PARTICIPANT';
const $e4eb613104372200$export$dfb1c2f386aee705 = 'state.persisted.request.details.REMOVE_PARTICIPANT_SUCCESS';
const $e4eb613104372200$export$5cf2f51c187a7d5f = 'state.persisted.request.details.SHARE_REQUEST';
const $e4eb613104372200$export$7fb10a1857e0e02a = 'state.ui.request.details.SHOW_TRANSITION_DIALOG';
const $e4eb613104372200$export$3a407eae5b6f60b = 'state.ui.request.details.HIDE_TRANSITION_DIALOG';
const $e4eb613104372200$export$a966f1a0c1a920e7 = 'state.persisted.request.details.TRANSITION_REQUEST';
const $e4eb613104372200$export$fd4af480b5082555 = 'state.persisted.request.details.TRANSITION_REQUEST_FAILURE';
const $e4eb613104372200$export$9e405a82dd6dd4e1 = 'state.persisted.request.details.CLEAR_TRANSITION_REQUEST';
const $e4eb613104372200$export$5d6a7943e794d360 = (0, $cWsyg.buildModelsActionCreator)($e4eb613104372200$export$c6977262f615318f, 'reqDetails');
const $e4eb613104372200$export$f9b1366a7a60a8a = (requestDetailsModel)=>({
        type: $e4eb613104372200$export$16e2b1f014063eb8,
        payload: requestDetailsModel
    });
const $e4eb613104372200$export$524d371754c76f3c = (requestKey, addParticipantsSuccessResponse, userMentionedDuringRequestCreation = false)=>({
        type: $e4eb613104372200$export$85378bb183dca844,
        payload: {
            requestKey: requestKey,
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation,
            addParticipantsSuccessResponse: addParticipantsSuccessResponse
        }
    });
const $e4eb613104372200$export$5ef0f7883c2144b6 = (requestKey, error)=>({
        type: $e4eb613104372200$export$b793c4f327f63a76,
        payload: {
            requestKey: requestKey,
            error: error
        }
    });
const $e4eb613104372200$export$99effa43b85cc1d1 = (requestKey, requestId, shouldSubscribe)=>({
        type: $e4eb613104372200$export$c82a76c42259b55e,
        payload: {
            requestKey: requestKey,
            requestId: requestId,
            shouldSubscribe: shouldSubscribe
        }
    });
const $e4eb613104372200$export$e91b59ae91b1c17d = (requestKey, shouldSubscribe)=>({
        type: $e4eb613104372200$export$aed2f68a180d5132,
        payload: {
            requestKey: requestKey,
            shouldSubscribe: shouldSubscribe
        }
    });
const $e4eb613104372200$export$8ab1e7354f0ec72f = ()=>({
        type: $e4eb613104372200$export$32a89de369c73827
    });
const $e4eb613104372200$export$5fffe31f8df4a90b = (portalId, requestKey, approvalId, approve, createAnalyticsEvent)=>({
        type: $e4eb613104372200$export$17b4c1a883566436,
        payload: {
            portalId: portalId,
            requestKey: requestKey,
            approvalId: approvalId,
            approve: approve,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $e4eb613104372200$export$66d4278db03b2954 = (requestKey, organisationId)=>({
        type: $e4eb613104372200$export$8fb5a515e01e48c5,
        payload: {
            requestKey: requestKey,
            organisationId: organisationId
        }
    });
const $e4eb613104372200$export$f8de82921adab699 = (requestKey, organisationId)=>({
        type: $e4eb613104372200$export$74436d62ceb0e590,
        payload: {
            requestKey: requestKey,
            organisationId: organisationId
        }
    });
const $e4eb613104372200$export$971a7382b074b466 = (requestKey, accountId)=>({
        type: $e4eb613104372200$export$fbce83858fb867fb,
        payload: {
            requestKey: requestKey,
            accountId: accountId
        }
    });
const $e4eb613104372200$export$9be1ee8fbc799e1c = (requestKey, accountId)=>({
        type: $e4eb613104372200$export$dfb1c2f386aee705,
        payload: {
            requestKey: requestKey,
            accountId: accountId
        }
    });
const $e4eb613104372200$export$904a7ffbfa202969 = (requestKey, organizations, emailAddresses, accountIds, isUserMentioned, mentionedUserName, userMentionedDuringRequestCreation)=>({
        type: $e4eb613104372200$export$5cf2f51c187a7d5f,
        payload: {
            requestKey: requestKey,
            organizations: organizations,
            emailAddresses: emailAddresses,
            accountIds: accountIds,
            isUserMentioned: isUserMentioned,
            mentionedUserName: mentionedUserName,
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation
        }
    });
const $e4eb613104372200$export$375ec276b5b0476c = (id)=>({
        type: $e4eb613104372200$export$7fb10a1857e0e02a,
        payload: {
            id: id
        }
    });
const $e4eb613104372200$export$69175c2908a46e20 = ()=>({
        type: $e4eb613104372200$export$3a407eae5b6f60b
    });
const $e4eb613104372200$export$e72771314c1d54 = (portalId, requestKey, transitionId, comment, createAnalyticsEvent)=>({
        type: $e4eb613104372200$export$a966f1a0c1a920e7,
        payload: {
            portalId: portalId,
            requestKey: requestKey,
            transitionId: transitionId,
            comment: comment,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $e4eb613104372200$export$18f56c137e75378a = (error)=>({
        type: $e4eb613104372200$export$fd4af480b5082555,
        payload: {
            error: error
        }
    });
const $e4eb613104372200$export$20cf1fa346e88708 = ()=>({
        type: $e4eb613104372200$export$9e405a82dd6dd4e1
    });
const $e4eb613104372200$export$2a15b079e3f46654 = (portalId, requestId, requestKey, comment, fileIds, xsrftoken, numberOfMentionedUsers, meta)=>({
        type: $e4eb613104372200$export$b2aae42fb0a19db3,
        payload: {
            portalId: portalId,
            requestId: requestId,
            requestKey: requestKey,
            comment: comment,
            fileIds: fileIds,
            xsrftoken: xsrftoken,
            numberOfMentionedUsers: numberOfMentionedUsers,
            meta: meta
        }
    });
const $e4eb613104372200$export$e993efecfd9a08b4 = (requestKey, response)=>({
        type: $e4eb613104372200$export$5e5d6c973a5c4e53,
        payload: {
            requestKey: requestKey,
            response: response
        }
    });
const $e4eb613104372200$export$5e212521c28e6663 = ()=>({
        type: $e4eb613104372200$export$423d075659092bbe,
        payload: {}
    });
const $e4eb613104372200$export$c62f8329852c0c3e = (portalId, requestId, requestKey)=>({
        type: $e4eb613104372200$export$6e57eb44a84791a7,
        payload: {
            portalId: portalId,
            requestId: requestId,
            requestKey: requestKey
        }
    });
const $e4eb613104372200$export$1c3602ad787f66de = (requestKey, response)=>({
        type: $e4eb613104372200$export$710f501aa8462ae0,
        payload: {
            requestKey: requestKey,
            response: response
        }
    });
const $e4eb613104372200$export$c1fdee8bb31030c2 = ()=>({
        type: $e4eb613104372200$export$73373e74567a5c83,
        payload: {}
    });

});



parcelRegister("fAruA", function(module, exports) {
$parcel$export(module.exports, "requestListEpic", () => $1d5fb29470649a0a$export$ab46e56cc8f700e6);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("2NENO");
var $leQln = parcelRequire("leQln");
const $1d5fb29470649a0a$export$ab46e56cc8f700e6 = (action$)=>{
    return action$.ofType((0, $leQln.FETCH_REQUEST_LIST_MODEL)).switchMap((action)=>{
        return (0, $jTCFd.default)(action.payload).filter((response)=>response.allReqFilter !== undefined && 'requestList' in response.allReqFilter && Array.isArray(response.allReqFilter.requestList)).flatMap((response)=>{
            const filter = action.payload.params.filter;
            // TypeScript's Observable.filter() does not narrow types, so response.allReqFilter
            // is still typed as RequestListResponse | undefined here even though the preceding
            // .filter() guarantees it is defined and has a valid requestList array.
            const requestListModel = response.allReqFilter;
            return (0, $fSYYZ.Observable).of((0, $leQln.fetchRequestListSuccess)({
                ...requestListModel,
                filter: filter
            }));
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $leQln.fetchRequestListFailure)(error));
        });
    });
};

});
parcelRegister("2NENO", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_LIST_MODEL", () => (parcelRequire("leQln")).FETCH_REQUEST_LIST_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_SUCCESS", () => (parcelRequire("leQln")).FETCH_REQUEST_LIST_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_FAILURE", () => (parcelRequire("leQln")).FETCH_REQUEST_LIST_FAILURE);
$parcel$export(module.exports, "MARK_INITIAL_PAGE_LOAD_RENDERED", () => (parcelRequire("leQln")).MARK_INITIAL_PAGE_LOAD_RENDERED);
$parcel$export(module.exports, "INVALIDATE_PAGES", () => (parcelRequire("leQln")).INVALIDATE_PAGES);
$parcel$export(module.exports, "fetchRequestListModel", () => (parcelRequire("leQln")).fetchRequestListModel);
$parcel$export(module.exports, "fetchRequestListSuccess", () => (parcelRequire("leQln")).fetchRequestListSuccess);
$parcel$export(module.exports, "fetchRequestListFailure", () => (parcelRequire("leQln")).fetchRequestListFailure);
$parcel$export(module.exports, "markInitialPageLoadRendered", () => (parcelRequire("leQln")).markInitialPageLoadRendered);
$parcel$export(module.exports, "invalidatePages", () => (parcelRequire("leQln")).invalidatePages);

var $leQln = parcelRequire("leQln");

});
parcelRegister("leQln", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_LIST_MODEL", () => $a1160f33f3237c14$export$7ee1e1fb4cf5db91);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_SUCCESS", () => $a1160f33f3237c14$export$f9ff6948957ba5c5);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_FAILURE", () => $a1160f33f3237c14$export$f5e5c834c1e2e455);
$parcel$export(module.exports, "MARK_INITIAL_PAGE_LOAD_RENDERED", () => $a1160f33f3237c14$export$4f7af1d62055a261);
$parcel$export(module.exports, "INVALIDATE_PAGES", () => $a1160f33f3237c14$export$d772cf5cfb44df9);
$parcel$export(module.exports, "fetchRequestListModel", () => $a1160f33f3237c14$export$decc5f94205f709e);
$parcel$export(module.exports, "invalidatePages", () => $a1160f33f3237c14$export$64b565f3a0ba7cb5);
$parcel$export(module.exports, "fetchRequestListSuccess", () => $a1160f33f3237c14$export$132d3416d8175125);
$parcel$export(module.exports, "fetchRequestListFailure", () => $a1160f33f3237c14$export$a842eadee8280475);
$parcel$export(module.exports, "markInitialPageLoadRendered", () => $a1160f33f3237c14$export$b643261c092a4f6);

var $cWsyg = parcelRequire("cWsyg");
const $a1160f33f3237c14$export$7ee1e1fb4cf5db91 = 'epic.model.FETCH_REQUEST_LIST_MODEL';
const $a1160f33f3237c14$export$f9ff6948957ba5c5 = 'state.persisted.request.List.FETCH_REQUEST_LIST_SUCCESS';
const $a1160f33f3237c14$export$f5e5c834c1e2e455 = 'state.persisted.request.List.FETCH_REQUEST_LIST_FAILURE';
const $a1160f33f3237c14$export$4f7af1d62055a261 = 'state.persisted.request.List.MARK_INITIAL_PAGE_LOAD_RENDERED';
const $a1160f33f3237c14$export$d772cf5cfb44df9 = 'state.persisted.request.List.INVALIDATE_PAGES';
const $a1160f33f3237c14$export$decc5f94205f709e = (0, $cWsyg.buildModelsActionCreator)($a1160f33f3237c14$export$7ee1e1fb4cf5db91, 'allReqFilter');
const $a1160f33f3237c14$export$64b565f3a0ba7cb5 = (currentPage)=>({
        type: $a1160f33f3237c14$export$d772cf5cfb44df9,
        payload: currentPage
    });
const $a1160f33f3237c14$export$132d3416d8175125 = (requestListModel)=>({
        type: $a1160f33f3237c14$export$f9ff6948957ba5c5,
        payload: requestListModel
    });
const $a1160f33f3237c14$export$a842eadee8280475 = (error)=>({
        type: $a1160f33f3237c14$export$f5e5c834c1e2e455,
        payload: {
            error: error
        }
    });
const $a1160f33f3237c14$export$b643261c092a4f6 = ()=>({
        type: $a1160f33f3237c14$export$4f7af1d62055a261
    });

});



parcelRegister("fIxI7", function(module, exports) {
$parcel$export(module.exports, "requestTypeSuggestionEpic", () => $c5494ee716673596$export$6dca1de129d1f3d9);

var $fSYYZ = parcelRequire("fSYYZ");
parcelRequire("2lLrg");
var $aweot = parcelRequire("aweot");

var $jTCFd = parcelRequire("jTCFd");
const $c5494ee716673596$export$6dca1de129d1f3d9 = (action$)=>{
    return action$.ofType((0, $aweot.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload, {
            type: 'secondary'
        }).filter((response)=>!!response.suggestedRequestTypes).map((response)=>(0, $aweot.fetchRequestTypeSuggestionSuccess)(response.suggestedRequestTypes))// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $fSYYZ.Observable).never()));
};

});
parcelRegister("2lLrg", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL", () => (parcelRequire("aweot")).FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS", () => (parcelRequire("aweot")).FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS);
$parcel$export(module.exports, "fetchRequestTypeSuggestionAction", () => (parcelRequire("aweot")).fetchRequestTypeSuggestionAction);
$parcel$export(module.exports, "fetchRequestTypeSuggestionSuccess", () => (parcelRequire("aweot")).fetchRequestTypeSuggestionSuccess);

var $aweot = parcelRequire("aweot");

});
parcelRegister("aweot", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL", () => $96f525a5d2bdc6e0$export$19c1cce5df18edab);
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS", () => $96f525a5d2bdc6e0$export$16165835dcce301e);
$parcel$export(module.exports, "fetchRequestTypeSuggestionAction", () => $96f525a5d2bdc6e0$export$2eae5c2f108f9b38);
$parcel$export(module.exports, "fetchRequestTypeSuggestionSuccess", () => $96f525a5d2bdc6e0$export$677aa00fa9ff8a57);

var $cWsyg = parcelRequire("cWsyg");
const $96f525a5d2bdc6e0$export$19c1cce5df18edab = 'epic.model.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL';
const $96f525a5d2bdc6e0$export$16165835dcce301e = 'state.persisted.request-type-suggestion.FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS';
const $96f525a5d2bdc6e0$export$2eae5c2f108f9b38 = (0, $cWsyg.buildModelsActionCreator)($96f525a5d2bdc6e0$export$19c1cce5df18edab, 'suggestedRequestTypes');
const $96f525a5d2bdc6e0$export$677aa00fa9ff8a57 = (requestTypeSuggestions)=>({
        payload: requestTypeSuggestions,
        type: $96f525a5d2bdc6e0$export$16165835dcce301e
    });

});



parcelRegister("8782V", function(module, exports) {
$parcel$export(module.exports, "requestsColumnSettingsEpic", () => $39d6887885dc28fb$export$3d5be110c2cef28d);

var $fSYYZ = parcelRequire("fSYYZ");

var $ktLIP = parcelRequire("ktLIP");

var $jTCFd = parcelRequire("jTCFd");
const $39d6887885dc28fb$export$3d5be110c2cef28d = (action$)=>{
    return action$.ofType((0, $ktLIP.FETCH_REQUESTS_COLUMN_SETTINGS_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.requestsColumnSettings).map((response)=>{
            return (0, $ktLIP.fetchRequestsColumnSettingsSuccess)(response.requestsColumnSettings || []);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $ktLIP.fetchRequestsColumnSettingsFailure)(error));
        }));
};

});
parcelRegister("ktLIP", function(module, exports) {
$parcel$export(module.exports, "CUSTOMIZING_REQUEST_LIST_COLUMN", () => $9c3c197e1cfaa29a$export$71e1a7c3232c719e);
$parcel$export(module.exports, "TOGGLE_COLUMN_RE_ORDER_WIDGET", () => $9c3c197e1cfaa29a$export$839cbba59bbe0238);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_MODEL", () => $9c3c197e1cfaa29a$export$abc90ee82ed578f);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_SUCCESS", () => $9c3c197e1cfaa29a$export$47e32c3c3500bef2);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_FAILURE", () => $9c3c197e1cfaa29a$export$10398b8018af3940);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_MODEL", () => $9c3c197e1cfaa29a$export$f90917a8f5386b09);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_SUCCESS", () => $9c3c197e1cfaa29a$export$e560350e06e586db);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_FAILURE", () => $9c3c197e1cfaa29a$export$79deac20d43b585c);
$parcel$export(module.exports, "RESET_CUSTOMIZE_REQUESTS_COLUMN_SETTINGS", () => $9c3c197e1cfaa29a$export$29dc39ddf284347c);
$parcel$export(module.exports, "REORDER_REQUEST_LIST_COLUMNS", () => $9c3c197e1cfaa29a$export$8d4d9dae0354b673);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_MODEL", () => $9c3c197e1cfaa29a$export$ff2ed1ddece23eaa);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_SUCCESS", () => $9c3c197e1cfaa29a$export$70626e2ee8f09144);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_FAILURE", () => $9c3c197e1cfaa29a$export$3fe3cdc959a8c16a);
$parcel$export(module.exports, "customizingRequestListColumn", () => $9c3c197e1cfaa29a$export$cef6e00d44beb902);
$parcel$export(module.exports, "toggleColumnReOrderWidget", () => $9c3c197e1cfaa29a$export$82755465bec7b53d);
$parcel$export(module.exports, "fetchRequestsColumnSettingsModel", () => $9c3c197e1cfaa29a$export$2ddd8f55c6e79cad);
$parcel$export(module.exports, "fetchRequestsColumnSettingsSuccess", () => $9c3c197e1cfaa29a$export$91fa974aae399c3e);
$parcel$export(module.exports, "fetchRequestsColumnSettingsFailure", () => $9c3c197e1cfaa29a$export$358a9b23c953cceb);
$parcel$export(module.exports, "updateRequestsColumnSettingsModel", () => $9c3c197e1cfaa29a$export$d283121346cbb92e);
$parcel$export(module.exports, "updateRequestsColumnSettingsSuccess", () => $9c3c197e1cfaa29a$export$46519305d1bd5dcc);
$parcel$export(module.exports, "updateRequestsColumnSettingsFailure", () => $9c3c197e1cfaa29a$export$a9e9b393ae51b9eb);
$parcel$export(module.exports, "resetCustomizeRequestsColumnSettings", () => $9c3c197e1cfaa29a$export$b835f37760c00124);
$parcel$export(module.exports, "reOrderRequestListColumns", () => $9c3c197e1cfaa29a$export$7401badd435f0b7c);
$parcel$export(module.exports, "updateOrderedRequestListColumnsModel", () => $9c3c197e1cfaa29a$export$bca82c1325293cdd);
$parcel$export(module.exports, "updateOrderedRequestListColumnsSuccess", () => $9c3c197e1cfaa29a$export$7e3f487fe57e88e3);
$parcel$export(module.exports, "updateOrderedRequestListColumnsFailure", () => $9c3c197e1cfaa29a$export$98a8373db0072493);

var $cWsyg = parcelRequire("cWsyg");
const $9c3c197e1cfaa29a$export$71e1a7c3232c719e = 'state.ui.requests.column.settings.CUSTOMIZING_REQUEST_LIST_COLUMN';
const $9c3c197e1cfaa29a$export$839cbba59bbe0238 = 'state.ui.requests.column.settings.TOGGLE_COLUMN_RE_ORDER_WIDGET';
const $9c3c197e1cfaa29a$export$abc90ee82ed578f = 'epic.model.FETCH_REQUESTS_COLUMN_SETTINGS_MODEL';
const $9c3c197e1cfaa29a$export$47e32c3c3500bef2 = 'state.persisted.requests.column.settings.FETCH_REQUESTS_COLUMN_SETTINGS_SUCCESS';
const $9c3c197e1cfaa29a$export$10398b8018af3940 = 'state.persisted.requests.column.settings.FETCH_REQUESTS_COLUMN_SETTINGS_FAILURE';
const $9c3c197e1cfaa29a$export$f90917a8f5386b09 = 'epic.requests-column-settings.UPDATE_REQUESTS_COLUMN_SETTINGS_MODEL';
const $9c3c197e1cfaa29a$export$e560350e06e586db = 'state.persisted.requests.column.settings.UPDATE_REQUESTS_COLUMN_SETTINGS_SUCCESS';
const $9c3c197e1cfaa29a$export$79deac20d43b585c = 'state.persisted.requests.column.settings.UPDATE_REQUESTS_COLUMN_SETTINGS_FAILURE';
const $9c3c197e1cfaa29a$export$29dc39ddf284347c = 'state.ui.requests.column.settings.RESET_CUSTOMIZE_REQUESTS_COLUMN_SETTINGS';
const $9c3c197e1cfaa29a$export$8d4d9dae0354b673 = 'state.ui.requests.column.settings.REORDER_REQUEST_LIST_COLUMNS';
const $9c3c197e1cfaa29a$export$ff2ed1ddece23eaa = 'epic.requests-column-settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_MODEL';
const $9c3c197e1cfaa29a$export$70626e2ee8f09144 = 'state.persisted.requests.column.settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_SUCCESS';
const $9c3c197e1cfaa29a$export$3fe3cdc959a8c16a = 'state.persisted.requests.column.settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_FAILURE';
const $9c3c197e1cfaa29a$export$cef6e00d44beb902 = (isCustomizing)=>({
        type: $9c3c197e1cfaa29a$export$71e1a7c3232c719e,
        payload: isCustomizing
    });
const $9c3c197e1cfaa29a$export$82755465bec7b53d = (isReOrdering)=>({
        type: $9c3c197e1cfaa29a$export$839cbba59bbe0238,
        payload: isReOrdering
    });
const $9c3c197e1cfaa29a$export$2ddd8f55c6e79cad = (0, $cWsyg.buildModelsActionCreator)($9c3c197e1cfaa29a$export$abc90ee82ed578f, 'requestsColumnSettings');
const $9c3c197e1cfaa29a$export$91fa974aae399c3e = (requestsColumnSettingsModel)=>({
        type: $9c3c197e1cfaa29a$export$47e32c3c3500bef2,
        payload: requestsColumnSettingsModel
    });
const $9c3c197e1cfaa29a$export$358a9b23c953cceb = (error)=>({
        type: $9c3c197e1cfaa29a$export$10398b8018af3940,
        payload: {
            error: error
        }
    });
const $9c3c197e1cfaa29a$export$d283121346cbb92e = (requestsColumnSettingsModel, meta)=>({
        meta: meta,
        type: $9c3c197e1cfaa29a$export$f90917a8f5386b09,
        payload: requestsColumnSettingsModel
    });
const $9c3c197e1cfaa29a$export$46519305d1bd5dcc = (requestsColumnSettingsModel)=>({
        type: $9c3c197e1cfaa29a$export$e560350e06e586db,
        payload: requestsColumnSettingsModel
    });
const $9c3c197e1cfaa29a$export$a9e9b393ae51b9eb = (error)=>({
        type: $9c3c197e1cfaa29a$export$79deac20d43b585c,
        payload: {
            error: error
        }
    });
const $9c3c197e1cfaa29a$export$b835f37760c00124 = ()=>({
        type: $9c3c197e1cfaa29a$export$29dc39ddf284347c
    });
const $9c3c197e1cfaa29a$export$7401badd435f0b7c = (newOrder)=>({
        type: $9c3c197e1cfaa29a$export$8d4d9dae0354b673,
        payload: newOrder
    });
const $9c3c197e1cfaa29a$export$bca82c1325293cdd = (newOrder, meta)=>{
    return {
        meta: meta,
        type: $9c3c197e1cfaa29a$export$ff2ed1ddece23eaa,
        payload: newOrder
    };
};
const $9c3c197e1cfaa29a$export$7e3f487fe57e88e3 = (requestsColumnSettings)=>({
        type: $9c3c197e1cfaa29a$export$70626e2ee8f09144,
        payload: requestsColumnSettings
    });
const $9c3c197e1cfaa29a$export$98a8373db0072493 = (error)=>({
        type: $9c3c197e1cfaa29a$export$3fe3cdc959a8c16a,
        payload: {
            error: error
        }
    });

});


parcelRegister("BGWcE", function(module, exports) {
$parcel$export(module.exports, "timezonesEpic", () => $8fe02374d5107b47$export$be7068db419e43b3);
$parcel$export(module.exports, "timezoneRegionsEpic", () => $8fe02374d5107b47$export$f2ed825e49baebf1);

var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("5vxR7");
var $aOx3T = parcelRequire("aOx3T");

var $g4UBb = parcelRequire("g4UBb");
const $8fe02374d5107b47$export$be7068db419e43b3 = (action$)=>{
    return action$.ofType((0, $aOx3T.FETCH_TIMEZONES_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.timezones).map((response)=>{
            return (0, $aOx3T.fetchTimezonesSuccess)(response.timezones || []);
        }).catch((_)=>{
            return (0, $fSYYZ.Observable).of((0, $6p5HB.showErrorFlag)((0, $g4UBb.genericError).title, (0, $g4UBb.genericError).description));
        }));
};
const $8fe02374d5107b47$export$f2ed825e49baebf1 = (action$)=>{
    return action$.ofType((0, $aOx3T.FETCH_TIMEZONE_REGIONS_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.timezoneRegions).map((response)=>{
            return (0, $aOx3T.fetchTimezoneRegionsSuccess)(response.timezoneRegions || []);
        }).catch((_)=>{
            return (0, $fSYYZ.Observable).of((0, $6p5HB.showErrorFlag)((0, $g4UBb.genericError).title, (0, $g4UBb.genericError).description));
        }));
};

});
parcelRegister("5vxR7", function(module, exports) {
$parcel$export(module.exports, "FETCH_TIMEZONES_MODEL", () => (parcelRequire("aOx3T")).FETCH_TIMEZONES_MODEL);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_MODEL", () => (parcelRequire("aOx3T")).FETCH_TIMEZONE_REGIONS_MODEL);
$parcel$export(module.exports, "FETCH_TIMEZONES_SUCCESS", () => (parcelRequire("aOx3T")).FETCH_TIMEZONES_SUCCESS);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_SUCCESS", () => (parcelRequire("aOx3T")).FETCH_TIMEZONE_REGIONS_SUCCESS);
$parcel$export(module.exports, "fetchTimezonesModel", () => (parcelRequire("aOx3T")).fetchTimezonesModel);
$parcel$export(module.exports, "fetchTimezoneRegionsModel", () => (parcelRequire("aOx3T")).fetchTimezoneRegionsModel);
$parcel$export(module.exports, "fetchTimezonesSuccess", () => (parcelRequire("aOx3T")).fetchTimezonesSuccess);
$parcel$export(module.exports, "fetchTimezoneRegionsSuccess", () => (parcelRequire("aOx3T")).fetchTimezoneRegionsSuccess);

var $aOx3T = parcelRequire("aOx3T");

});
parcelRegister("aOx3T", function(module, exports) {
$parcel$export(module.exports, "FETCH_TIMEZONES_MODEL", () => $0d163c0b629c3b6a$export$932af27e6d5887a0);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_MODEL", () => $0d163c0b629c3b6a$export$3b699f83ba8d2c06);
$parcel$export(module.exports, "FETCH_TIMEZONES_SUCCESS", () => $0d163c0b629c3b6a$export$6b053ef4439b07a6);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_SUCCESS", () => $0d163c0b629c3b6a$export$6932839fde3fd591);
$parcel$export(module.exports, "fetchTimezonesModel", () => $0d163c0b629c3b6a$export$f02c0cf38058cca0);
$parcel$export(module.exports, "fetchTimezoneRegionsModel", () => $0d163c0b629c3b6a$export$2ac437e497040cf4);
$parcel$export(module.exports, "fetchTimezoneRegionsSuccess", () => $0d163c0b629c3b6a$export$f577dd22c3538327);
$parcel$export(module.exports, "fetchTimezonesSuccess", () => $0d163c0b629c3b6a$export$219ccd71bd1012b);

var $cWsyg = parcelRequire("cWsyg");
const $0d163c0b629c3b6a$export$932af27e6d5887a0 = 'epic.model.FETCH_TIMEZONES_MODEL';
const $0d163c0b629c3b6a$export$3b699f83ba8d2c06 = 'epic.model.FETCH_TIMEZONE_REGIONS_MODEL';
const $0d163c0b629c3b6a$export$6b053ef4439b07a6 = 'state.persisted.timezone.FETCH_TIMEZONEs_SUCCESS';
const $0d163c0b629c3b6a$export$6932839fde3fd591 = 'state.persisted.timezone.FETCH_TIMEZONE_REGIONS_SUCCESS';
const $0d163c0b629c3b6a$export$f02c0cf38058cca0 = (0, $cWsyg.buildModelsActionCreator)($0d163c0b629c3b6a$export$932af27e6d5887a0, 'timezones');
const $0d163c0b629c3b6a$export$2ac437e497040cf4 = (0, $cWsyg.buildModelsActionCreator)($0d163c0b629c3b6a$export$3b699f83ba8d2c06, 'timezoneRegions');
const $0d163c0b629c3b6a$export$f577dd22c3538327 = (timezoneRegions)=>({
        type: $0d163c0b629c3b6a$export$6932839fde3fd591,
        payload: {
            timezoneRegions: timezoneRegions
        }
    });
const $0d163c0b629c3b6a$export$219ccd71bd1012b = (timezones)=>({
        type: $0d163c0b629c3b6a$export$6b053ef4439b07a6,
        payload: {
            timezones: timezones
        }
    });

});



parcelRegister("lnh4q", function(module, exports) {
$parcel$export(module.exports, "uiModificationsEpic", () => $dc2129baba58292b$export$b3e7540861af6314);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("kj8xu");
var $4iHZF = parcelRequire("4iHZF");
const $dc2129baba58292b$export$b3e7540861af6314 = (action$)=>{
    return action$.ofType((0, $4iHZF.FETCH_UI_MODIFICATIONS_MODEL)).mergeMap((action)=>{
        var _action$payload, _action$payload2;
        const portalId = (_action$payload = action.payload) === null || _action$payload === void 0 || (_action$payload = _action$payload.params) === null || _action$payload === void 0 ? void 0 : _action$payload.portalId;
        const requestTypeId = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 || (_action$payload2 = _action$payload2.params) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.requestTypeId;
        // Guard clause: ensure required params are defined
        // If params are missing, don't emit any action (nothing meaningful to store)
        if (portalId === undefined || requestTypeId === undefined) return (0, $fSYYZ.Observable).empty();
        return (0, $jTCFd.default)(action.payload).filter((response)=>{
            return !!response.uiModifications;
        }).mergeMap((response)=>{
            const uiModifications = response.uiModifications;
            // Check if the response contains an error object
            if ('error' in uiModifications && uiModifications.error) {
                const error = uiModifications.error;
                return (0, $fSYYZ.Observable).of((0, $4iHZF.fetchUiModificationsFailure)(portalId, requestTypeId, {
                    status: 500,
                    errorMessages: [
                        error.message || error.code || 'Unknown error'
                    ]
                }));
            }
            return (0, $fSYYZ.Observable).of((0, $4iHZF.fetchUiModificationsSuccess)(portalId, requestTypeId, uiModifications));
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $4iHZF.fetchUiModificationsFailure)(portalId, requestTypeId, error));
        });
    });
};

});
parcelRegister("kj8xu", function(module, exports) {
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_MODEL", () => (parcelRequire("4iHZF")).FETCH_UI_MODIFICATIONS_MODEL);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_SUCCESS", () => (parcelRequire("4iHZF")).FETCH_UI_MODIFICATIONS_SUCCESS);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_FAILURE", () => (parcelRequire("4iHZF")).FETCH_UI_MODIFICATIONS_FAILURE);
$parcel$export(module.exports, "fetchUiModificationsAction", () => (parcelRequire("4iHZF")).fetchUiModificationsAction);
$parcel$export(module.exports, "fetchUiModificationsSuccess", () => (parcelRequire("4iHZF")).fetchUiModificationsSuccess);
$parcel$export(module.exports, "fetchUiModificationsFailure", () => (parcelRequire("4iHZF")).fetchUiModificationsFailure);

var $4iHZF = parcelRequire("4iHZF");

});
parcelRegister("4iHZF", function(module, exports) {
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_MODEL", () => $f357f14ff5afcdf7$export$8dbb39b6146e28fc);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_SUCCESS", () => $f357f14ff5afcdf7$export$7165d2daf9f7546b);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_FAILURE", () => $f357f14ff5afcdf7$export$f2bc8b8032fa83f9);
$parcel$export(module.exports, "fetchUiModificationsAction", () => $f357f14ff5afcdf7$export$d5c10586cf66ad48);
$parcel$export(module.exports, "fetchUiModificationsSuccess", () => $f357f14ff5afcdf7$export$5811aa4798efe56f);
$parcel$export(module.exports, "fetchUiModificationsFailure", () => $f357f14ff5afcdf7$export$aa1b71ac6d05f568);

var $cWsyg = parcelRequire("cWsyg");
const $f357f14ff5afcdf7$export$8dbb39b6146e28fc = 'epic.model.FETCH_UI_MODIFICATIONS_MODEL';
const $f357f14ff5afcdf7$export$7165d2daf9f7546b = 'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_SUCCESS';
const $f357f14ff5afcdf7$export$f2bc8b8032fa83f9 = 'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_FAILURE';
const $f357f14ff5afcdf7$export$d5c10586cf66ad48 = (0, $cWsyg.buildModelsActionCreator)($f357f14ff5afcdf7$export$8dbb39b6146e28fc, 'uiModifications');
const $f357f14ff5afcdf7$export$5811aa4798efe56f = (portalId, requestTypeId, uiModifications)=>({
        type: $f357f14ff5afcdf7$export$7165d2daf9f7546b,
        payload: {
            portalId: portalId,
            requestTypeId: requestTypeId,
            uiModifications: uiModifications
        }
    });
const $f357f14ff5afcdf7$export$aa1b71ac6d05f568 = (portalId, requestTypeId, error)=>({
        type: $f357f14ff5afcdf7$export$f2bc8b8032fa83f9,
        payload: {
            portalId: portalId,
            requestTypeId: requestTypeId,
            error: error
        }
    });

});



parcelRegister("jZ8mq", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationEpic", () => $23ac735657a27fc5$export$a5c82ee4d4a62853);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("8Fqso");
var $04WFB = parcelRequire("04WFB");

var $fMDpd = parcelRequire("fMDpd");
const $23ac735657a27fc5$export$a5c82ee4d4a62853 = (action$)=>{
    return action$.ofType((0, $fMDpd.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.unsubscribedConfirmation && !!response.unsubscribedConfirmation.requestKey).map((response)=>{
            return (0, $04WFB.fetchUnsubscribedConfirmationSuccess)(response.unsubscribedConfirmation);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $04WFB.fetchUnsubscribedConfirmationFailure)(error));
        }));
};

});
parcelRegister("8Fqso", function(module, exports) {
$parcel$export(module.exports, "fetchUnsubscribedConfirmationSuccess", () => (parcelRequire("04WFB")).fetchUnsubscribedConfirmationSuccess);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationFailure", () => (parcelRequire("04WFB")).fetchUnsubscribedConfirmationFailure);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE", () => (parcelRequire("04WFB")).FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS", () => (parcelRequire("04WFB")).FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS);

var $04WFB = parcelRequire("04WFB");

});
parcelRegister("04WFB", function(module, exports) {
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS", () => $011681a5d70a9e6f$export$f72ddca71405b95d);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE", () => $011681a5d70a9e6f$export$ebaa1597e87c25cb);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationSuccess", () => $011681a5d70a9e6f$export$c1bfe5b0bc39b67c);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationFailure", () => $011681a5d70a9e6f$export$97f97477d437893);
const $011681a5d70a9e6f$export$f72ddca71405b95d = 'state.persisted.unsibscribedconfirmation.FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS';
const $011681a5d70a9e6f$export$ebaa1597e87c25cb = 'state.persisted.unsibscribedconfirmation.FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE';
const $011681a5d70a9e6f$export$c1bfe5b0bc39b67c = (unsubscribedConfirmationModel)=>({
        payload: unsubscribedConfirmationModel,
        type: $011681a5d70a9e6f$export$f72ddca71405b95d
    });
const $011681a5d70a9e6f$export$97f97477d437893 = (error)=>({
        type: $011681a5d70a9e6f$export$ebaa1597e87c25cb,
        payload: {
            error: error
        }
    });

});


parcelRegister("fMDpd", function(module, exports) {
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL", () => $8ed96902c5a12e6d$export$2e46ab911cbec5e7);
$parcel$export(module.exports, "fetchUnsubscribedConfirmation", () => $8ed96902c5a12e6d$export$4b67c7752a799aa6);

var $cWsyg = parcelRequire("cWsyg");
const $8ed96902c5a12e6d$export$2e46ab911cbec5e7 = 'epic.model.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL';
const $8ed96902c5a12e6d$export$4b67c7752a799aa6 = (0, $cWsyg.buildModelsActionCreator)($8ed96902c5a12e6d$export$2e46ab911cbec5e7, 'unsubscribedConfirmation');

});


parcelRegister("2wwAp", function(module, exports) {
$parcel$export(module.exports, "visitPortalEpic", () => $744da179cb387871$export$b0dd3b8f13c4a9ce);

var $fSYYZ = parcelRequire("fSYYZ");

var $jTCFd = parcelRequire("jTCFd");
parcelRequire("bRFjb");
var $lLqMr = parcelRequire("lLqMr");
const $744da179cb387871$export$b0dd3b8f13c4a9ce = (action$)=>{
    return action$.ofType((0, $lLqMr.FETCH_VISIT_PORTAL_MODEL)).mergeMap((action)=>(0, $jTCFd.default)(action.payload).filter((response)=>!!response.visitPortal && !!response.visitPortal.email).map((response)=>{
            return (0, $lLqMr.fetchVisitPortalSuccess)(response.visitPortal);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $lLqMr.fetchVisitPortalFailure)(error));
        }));
};

});


parcelRegister("7hmkV", function(module, exports) {
$parcel$export(module.exports, "updatePortalAnnouncementsEpic", () => $e2b80076b6663258$export$e4577247bf7a5bb1);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $4gOCH = parcelRequire("4gOCH");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");

var $9ypa9 = parcelRequire("9ypa9");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");

var $e2yrc = parcelRequire("e2yrc");
const $e2b80076b6663258$export$e4577247bf7a5bb1 = (action$)=>{
    return action$.ofType((0, $d727K.UPDATE_PORTAL_ANNOUNCEMENT_MODEL)).mergeMap((action)=>{
        const { meta: meta, portalId: portalId } = action;
        return (0, $4gOCH.updatePortalAnnouncements)(action.payload, portalId).flatMap((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.success();
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $d727K.updatePortalAnnouncementSuccess)(response)));
        }).catch((error)=>{
            if ((0, $fonw6.isNetworkOrClientErrorCode)(error.status)) // Filter out client errors
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.success();
            else {
                if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $9ypa9.legacySendEvent)((0, $e2yrc.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.failure({
                    metadata: {
                        error: (0, $9ypa9.getErrorData)(error)
                    }
                });
            }
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $d727K.updatePortalAnnouncementFailure)(error)), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("4gOCH", function(module, exports) {
$parcel$export(module.exports, "updatePortalAnnouncements", () => $9eb2da4d5d69651c$export$9e961f2770667246);

var $bhOdO = parcelRequire("bhOdO");

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $9eb2da4d5d69651c$export$9e961f2770667246 = (payload, portalId, context = (0, $7FSs7.contextPath))=>{
    const portalAnnouncementUpdateURI = `${context}/rest/servicedesk/1/servicedesk-data/announcement/portal/${portalId}`;
    const contentType = {
        'Content-Type': 'application/json'
    };
    return (0, $breWd.post)(portalAnnouncementUpdateURI, payload, contentType)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $bhOdO.Observable).throw(e));
};

});


parcelRegister("hd3jj", function(module, exports) {
$parcel$export(module.exports, "changeRequestSubscriptionEpic", () => $17575ec3925a2e39$export$43fea900952d51e2);

var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $gI9FT = parcelRequire("gI9FT");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");
const $17575ec3925a2e39$export$43fea900952d51e2 = (action$)=>{
    return action$.ofType((0, $jra4c.CHANGE_SUBSCRIPTION)).mergeMap((changeSubscriptionAction)=>{
        const { shouldSubscribe: shouldSubscribe, requestId: requestId, requestKey: requestKey } = changeSubscriptionAction.payload;
        const restCall = shouldSubscribe ? (0, $gI9FT.subscribe) : (0, $gI9FT.unsubscribe);
        return restCall(requestId).map(()=>{
            return (0, $jra4c.changeSubscriptionSuccess)(requestKey, shouldSubscribe);
        }).catch((error)=>{
            return (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("gI9FT", function(module, exports) {
$parcel$export(module.exports, "subscribe", () => $def37163b74b23a1$export$ec068583843480e7);
$parcel$export(module.exports, "unsubscribe", () => $def37163b74b23a1$export$f500693cef883ffd);

var $bhOdO = parcelRequire("bhOdO");

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $def37163b74b23a1$export$ec068583843480e7 = (requestId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/notification/subscription/${requestId}`;
    return (0, $breWd.put)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $bhOdO.Observable).throw(e);
    });
};
const $def37163b74b23a1$export$f500693cef883ffd = (requestId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/notification/subscription/${requestId}`;
    return (0, $breWd.doDelete)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $bhOdO.Observable).throw(e);
    });
};

});


parcelRegister("9JgMX", function(module, exports) {
$parcel$export(module.exports, "createCommentEpic", () => $5c0be08290f30919$export$3d130ce773bd2648);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $bNwqT = parcelRequire("bNwqT");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");

var $c2JSW = parcelRequire("c2JSW");
const $5c0be08290f30919$export$3d130ce773bd2648 = (action$)=>{
    return action$.ofType((0, $jra4c.CREATE_COMMENT)).mergeMap((createCommentAction)=>{
        const payload = createCommentAction.payload;
        return (0, $bNwqT.createComment)(payload.requestId, payload.comment, payload.fileIds, payload.xsrftoken).flatMap((createCommentResponse)=>{
            const { meta: meta, numberOfMentionedUsers: numberOfMentionedUsers } = payload;
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) {
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // oxlint-disable-next-line no-shadow
                meta === null || meta === void 0 || meta.analyticsSuccessEvent.update((payload)=>({
                        ...payload,
                        count: numberOfMentionedUsers || 0
                    }));
                (0, $9ypa9.legacySendEvent)(meta === null || meta === void 0 ? void 0 : meta.analyticsSuccessEvent);
            }
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $jra4c.createCommentSuccess)(payload.requestKey, createCommentResponse)), (0, $fSYYZ.Observable).of((0, $jra4c.getReadCredentials)(payload.portalId, payload.requestId, payload.requestKey)));
        }).catch((error)=>{
            const meta = payload.meta;
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent);
            const isShowErrorFlag = payload.numberOfMentionedUsers && payload.numberOfMentionedUsers > 0 && !(0, $fonw6.isNetworkErrorCode)(error.status);
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $jra4c.createCommentFailure)()), (0, $fSYYZ.Observable).of(isShowErrorFlag ? (0, $6p5HB.showErrorFlag)((0, $c2JSW.default).commentCreateWithMentionsFailedTitle, (0, $c2JSW.default).commentCreateWithMentionsFailedDescription) : (0, $6p5HB.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("bNwqT", function(module, exports) {
$parcel$export(module.exports, "createComment", () => $fa5e60f08e32310f$export$2a15b079e3f46654);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $7FSs7 = parcelRequire("7FSs7");
const $fa5e60f08e32310f$export$2a15b079e3f46654 = (issueId, comment, fileIds, xsrfToken, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/customer/comment`;
    const body = {
        issueId: issueId,
        comment: comment,
        fileIds: fileIds,
        xsrfToken: xsrfToken
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).catch((e)=>{
        return (0, $fSYYZ.Observable).throw(e);
    });
};

});

parcelRegister("c2JSW", function(module, exports) {
$parcel$export(module.exports, "default", () => $62cc9cfc0cb2db7a$export$2e2bcd8739ae039);
/* Note: these messages are not final */ 
var $7B9et = parcelRequire("7B9et");
var $62cc9cfc0cb2db7a$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    commentCreateWithMentionsFailedTitle: {
        defaultMessage: "We couldn\u2019t add this comment",
        description: 'Comment containing user mentions failed to create title',
        id: 'sd.comment.create.with.mentions.failed.title'
    },
    commentCreateWithMentionsFailedDescription: {
        defaultMessage: 'Try adding it again in a few minutes. ',
        description: 'Comment containing user mentions failed to create description',
        id: 'sd.comment.create.with.mentions.failed.description'
    }
});

});


parcelRegister("4mrSX", function(module, exports) {
$parcel$export(module.exports, "decideApprovalEpic", () => $c29f051c6b5b006d$export$d61d906dee97954f);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $HGACo = parcelRequire("HGACo");

var $6p5HB = parcelRequire("6p5HB");

var $1aGnM = parcelRequire("1aGnM");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");

var $lNR6b = parcelRequire("lNR6b");
const $c29f051c6b5b006d$var$isClientSideError = (error)=>error.status >= 400 && error.status < 500;
const $c29f051c6b5b006d$export$d61d906dee97954f = (action$)=>{
    return action$.ofType((0, $jra4c.DECIDE_APPROVAL)).mergeMap((decideApprovalAction)=>{
        const payload = decideApprovalAction.payload;
        const restCall = payload.approve ? (0, $1aGnM.approve)(payload.approvalId) : (0, $1aGnM.decline)(payload.approvalId);
        return restCall.map(()=>{
            var _payload$createAnalyt;
            const successEvent = (_payload$createAnalyt = payload.createAnalyticsEvent) === null || _payload$createAnalyt === void 0 ? void 0 : _payload$createAnalyt.call(payload, {
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                action: 'recorded'
            });
            if (successEvent) {
                successEvent.context.push({
                    componentName: 'approverDecision'
                });
                (0, $9ypa9.legacySendEvent)(successEvent);
            }
            return (0, $jra4c.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            });
        })// @ts-ignore
        .catch((error)=>{
            var _payload$createAnalyt2;
            const failEvent = (_payload$createAnalyt2 = payload.createAnalyticsEvent) === null || _payload$createAnalyt2 === void 0 ? void 0 : _payload$createAnalyt2.call(payload, {
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                statusCode: $c29f051c6b5b006d$var$isClientSideError(error) ? '4XX' : '5XX'
            });
            if (failEvent) {
                failEvent.context.push({
                    componentName: 'portalRequestDetailsScreen.answerApprovalService'
                });
                (0, $9ypa9.legacySendEvent)(failEvent);
            }
            if (error.status === 409) return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $jra4c.decideApprovalFailure)()), (0, $fSYYZ.Observable).of((0, $jra4c.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            })), (0, $fSYYZ.Observable).of((0, $6p5HB.showErrorFlag)((0, $lNR6b.default).conflictErrorTitle, (0, $HGACo.isItsmIssueRenamingEnabled)() ? (0, $lNR6b.default).conflictErrorDescriptionIssueTermRefresh : (0, $lNR6b.default).conflictErrorDescription)));
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $jra4c.decideApprovalFailure)()), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("1aGnM", function(module, exports) {
$parcel$export(module.exports, "approve", () => $282dcc6c1faab867$export$5ba7c78c9d5e2122);
$parcel$export(module.exports, "decline", () => $282dcc6c1faab867$export$ff9b5abb0defe452);

var $bhOdO = parcelRequire("bhOdO");

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $282dcc6c1faab867$export$5ba7c78c9d5e2122 = (approvalId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/approvals/1/customer/approval/${approvalId}/approve`;
    return (0, $breWd.post)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $bhOdO.Observable).throw(e);
    });
};
const $282dcc6c1faab867$export$ff9b5abb0defe452 = (approvalId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/approvals/1/customer/approval/${approvalId}/reject`;
    return (0, $breWd.post)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $bhOdO.Observable).throw(e);
    });
};

});

parcelRegister("lNR6b", function(module, exports) {
$parcel$export(module.exports, "default", () => $457f8388eb9eb9cf$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $457f8388eb9eb9cf$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    conflictErrorTitle: {
        defaultMessage: 'Error',
        description: 'Conflict error when user clicking a stale approval panel decision button.',
        id: 'sd.stale.approval.panel.conflict.title'
    },
    conflictErrorDescription: {
        defaultMessage: 'An approval response has already been submitted for this issue.',
        description: 'Conflict error when user clicking a stale approval panel decision button description',
        id: 'sd.stale.approval.panel.conflict.description'
    },
    conflictErrorDescriptionIssueTermRefresh: {
        defaultMessage: 'An approval response has already been submitted for this work item.',
        description: 'Conflict error when user clicking a stale approval panel decision button description',
        id: 'sd.stale.approval.panel.conflict.description-issue-term-refresh'
    }
});

});


parcelRegister("5c7tt", function(module, exports) {
$parcel$export(module.exports, "getMediaReadCredentialsEpic", () => $c57eb367e78b6a8b$export$248d895b14907a3);

var $fSYYZ = parcelRequire("fSYYZ");

var $dPeQo = parcelRequire("dPeQo");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");
const $c57eb367e78b6a8b$export$248d895b14907a3 = (action$)=>{
    return action$.ofType((0, $jra4c.GET_MEDIA_READ_CREDENTIALS)).mergeMap((getReadCredentialsAction)=>{
        const payload = getReadCredentialsAction.payload;
        return (0, $dPeQo.getReadCredentialsForRequest)(payload.portalId, payload.requestId).map((getReadCredentialsResponse)=>{
            return (0, $jra4c.getReadCredentialsSuccess)(payload.requestKey, getReadCredentialsResponse);
        }).catch((_)=>{
            return (0, $fSYYZ.Observable).of((0, $jra4c.getReadCredentialsFailure)());
        });
    });
};

});

parcelRegister("c2YsM", function(module, exports) {
$parcel$export(module.exports, "removeOrganisationEpic", () => $4724c81252bbabfa$export$b62b13475aa4d5e);

var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $dU4fS = parcelRequire("dU4fS");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");

var $koqiO = parcelRequire("koqiO");
const $4724c81252bbabfa$export$b62b13475aa4d5e = (action$)=>{
    return action$.ofType((0, $jra4c.REMOVE_ORGANISATION)).mergeMap((removeParticipantAction)=>{
        const { requestKey: requestKey, organisationId: organisationId } = removeParticipantAction.payload;
        return (0, $dU4fS.removeOrganisation)(requestKey, organisationId).map(()=>{
            return (0, $jra4c.removeOrganisationSuccess)(requestKey, organisationId);
        }).catch((error)=>{
            const isPermissionDenied = error.status === 403;
            return (0, $fSYYZ.Observable).of(isPermissionDenied ? (0, $6p5HB.showErrorFlag)((0, $koqiO.default).permissionDeniedErrorTitle, (0, $koqiO.default).permissionDeniedErrorDescription) : (0, $6p5HB.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("dU4fS", function(module, exports) {
$parcel$export(module.exports, "removeUsingAccountId", () => $16fc4037530f9050$export$d06c11dbdb4f724e);
$parcel$export(module.exports, "removeOrganisation", () => $16fc4037530f9050$export$66d4278db03b2954);
$parcel$export(module.exports, "search", () => $16fc4037530f9050$export$d76128d007d19019);
$parcel$export(module.exports, "addParticipants", () => $16fc4037530f9050$export$600fe12d720e6ff9);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $h1yZX = parcelRequire("h1yZX");

var $7FSs7 = parcelRequire("7FSs7");
const $16fc4037530f9050$export$d06c11dbdb4f724e = (requestKey, accountId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/removeParticipant`;
    const body = {
        accountId: accountId
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $breWd.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $fSYYZ.Observable).throw(e));
};
const $16fc4037530f9050$export$66d4278db03b2954 = (requestKey, organisationId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/removeOrganisation`;
    const body = {
        organisationId: organisationId
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $breWd.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $fSYYZ.Observable).throw(e));
};
const $16fc4037530f9050$export$d76128d007d19019 = (requestKey, query = '', context = (0, $7FSs7.contextPath))=>{
    const queryString = $h1yZX.stringify({
        q: query
    });
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/search?${queryString}`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response).catch((e)=>Promise.reject(e));
};
const $16fc4037530f9050$export$600fe12d720e6ff9 = (requestKey, accountIds, organizationIds, emailAddresses, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/add`;
    const body = {
        accountIds: accountIds,
        organisationIds: organizationIds,
        emails: emailAddresses
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.put)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};

});

parcelRegister("koqiO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4bb439a218afe32$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $b4bb439a218afe32$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    permissionDeniedErrorTitle: {
        defaultMessage: "You don't have permission to remove this request participant",
        description: 'Permission Denied while removing participants title',
        id: 'sd.remove.organization.permission.denied.title'
    },
    permissionDeniedErrorDescription: {
        defaultMessage: 'Ask your admin to remove this request participant.',
        description: 'Permission Denied while removing participants description',
        id: 'sd.remove.organization.permission.denied.description'
    }
});

});


parcelRegister("ejLoz", function(module, exports) {
$parcel$export(module.exports, "removeParticipantEpic", () => $67a1c776838020b6$export$3f20d6b824d24e4c);

var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $dU4fS = parcelRequire("dU4fS");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");

var $kGiTC = parcelRequire("kGiTC");
const $67a1c776838020b6$export$3f20d6b824d24e4c = (action$)=>{
    return action$.ofType((0, $jra4c.REMOVE_PARTICIPANT)).mergeMap((removeParticipantAction)=>{
        const { requestKey: requestKey, accountId: accountId } = removeParticipantAction.payload;
        return (0, $dU4fS.removeUsingAccountId)(requestKey, accountId).map(()=>{
            return (0, $jra4c.removeParticipantSuccess)(requestKey, accountId);
        }).catch((error)=>{
            const isPermissionDenied = error.status === 403;
            return (0, $fSYYZ.Observable).of(isPermissionDenied ? (0, $6p5HB.showErrorFlag)((0, $kGiTC.default).permissionDeniedErrorTitle, (0, $kGiTC.default).permissionDeniedErrorDescription) : (0, $6p5HB.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("kGiTC", function(module, exports) {
$parcel$export(module.exports, "default", () => $075a323cde5dbb57$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $075a323cde5dbb57$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    permissionDeniedErrorTitle: {
        defaultMessage: "You don't have permission to remove this request participant",
        description: 'Permission Denied while removing participants title',
        id: 'sd.remove.participants.permission.denied.title'
    },
    permissionDeniedErrorDescription: {
        defaultMessage: 'Ask your admin to remove this request participant.',
        description: 'Permission Denied while removing participants description',
        id: 'sd.remove.participants.permission.denied.description'
    }
});

});


parcelRegister("2XNFs", function(module, exports) {
$parcel$export(module.exports, "shareRequestEpic", () => $5885b5f87753f370$export$d11c340ce54e3cbb);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $dU4fS = parcelRequire("dU4fS");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");

var $hWdB8 = parcelRequire("hWdB8");
const $5885b5f87753f370$export$d11c340ce54e3cbb = (action$)=>action$.ofType((0, $jra4c.SHARE_REQUEST)).mergeMap((shareRequestAction)=>{
        const { requestKey: requestKey, organizations: organizations, emailAddresses: emailAddresses, accountIds: accountIds, isUserMentioned: isUserMentioned, mentionedUserName: mentionedUserName, userMentionedDuringRequestCreation: userMentionedDuringRequestCreation } = shareRequestAction.payload;
        return (0, $dU4fS.addParticipants)(requestKey, accountIds, organizations, emailAddresses).flatMap((response)=>{
            if (isUserMentioned) {
                const messageTitle = mentionedUserName ? (0, $hWdB8.default).requestSharedWithSingleMentionedUserSuccessTitle : (0, $hWdB8.default).requestSharedWithMentionedUsersSuccessTitle;
                const messageDescription = mentionedUserName ? (0, $hWdB8.default).requestSharedWithSingleMentionedUserSuccessDescription : (0, $hWdB8.default).requestSharedWithMentionedUsersSuccessDescription;
                const descriptionValues = mentionedUserName ? {
                    userName: mentionedUserName
                } : undefined;
                return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $jra4c.addParticipantsSuccess)(requestKey, response, userMentionedDuringRequestCreation)), (0, $fSYYZ.Observable).of((0, $6p5HB.showSuccessFlag)(messageTitle, undefined, messageDescription, undefined, descriptionValues)));
            }
            return (0, $fSYYZ.Observable).of((0, $jra4c.addParticipantsSuccess)(requestKey, response));
        }).catch((error)=>{
            const isShowErrorFlag = isUserMentioned;
            const messageTitle = mentionedUserName ? (0, $hWdB8.default).requestSharedWithSingleMentionedUserFailureTitle : (0, $hWdB8.default).requestSharedWithMentionedUsersFailureTitle;
            const messageDescription = mentionedUserName ? (0, $hWdB8.default).requestSharedWithSingleMentionedUserFailureDescription : (0, $hWdB8.default).requestSharedWithMentionedUsersFailureDescription;
            const descriptionValues = mentionedUserName ? {
                userName: mentionedUserName
            } : undefined;
            return (0, $fSYYZ.Observable).of(isShowErrorFlag ? (0, $6p5HB.showErrorFlag)(messageTitle, messageDescription, undefined, undefined, descriptionValues) : (0, $6p5HB.handleAjaxError)(error));
        });
    });

});
parcelRegister("hWdB8", function(module, exports) {
$parcel$export(module.exports, "default", () => $daf64f5668478dbd$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $daf64f5668478dbd$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    requestSharedWithSingleMentionedUserSuccessTitle: {
        defaultMessage: 'New request participant added',
        description: 'request shared with the single user mentioned in comment successfully title',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.success.title'
    },
    requestSharedWithSingleMentionedUserSuccessDescription: {
        defaultMessage: '{userName} has been added as a request participant to this request.',
        description: 'request shared with the single user mentioned in comment successfully description',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.success.description'
    },
    requestSharedWithMentionedUsersSuccessTitle: {
        defaultMessage: 'New request participants added',
        description: 'request shared with users mentioned in comment successfully title',
        id: 'sd.comment.create.request.shared.with.mentioned.users.success.title'
    },
    requestSharedWithMentionedUsersSuccessDescription: {
        defaultMessage: 'The users you mentioned have been added as request participants to this request.',
        description: 'request shared with users mentioned in comment successfully description',
        id: 'sd.comment.create.request.shared.with.mentioned.users.success.description'
    },
    requestSharedWithSingleMentionedUserFailureTitle: {
        defaultMessage: "We couldn\u2019t add this request participant",
        description: 'requests sharing with single user failed title',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.failure.title'
    },
    requestSharedWithSingleMentionedUserFailureDescription: {
        defaultMessage: "{userName} couldn\u2019t be added to this request. Try adding them again in a few minutes. ",
        description: 'request sharing with single user failed description',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.failure.description'
    },
    requestSharedWithMentionedUsersFailureTitle: {
        defaultMessage: "We couldn\u2019t add these request participants",
        description: 'requests sharing failed title',
        id: 'sd.comment.create.request.shared.with.mentioned.users.failure.title'
    },
    requestSharedWithMentionedUsersFailureDescription: {
        defaultMessage: "The users you mentioned couldn\u2019t be added to this request. Try adding them again in a few minutes. ",
        description: 'request sharing failed description',
        id: 'sd.comment.create.request.shared.with.mentioned.users.failure.description'
    }
});

});


parcelRegister("9Z0Uy", function(module, exports) {
$parcel$export(module.exports, "transitionRequestEpic", () => $7abfcf7725b290a0$export$2b9c3ffd3e776468);

var $fSYYZ = parcelRequire("fSYYZ");

var $k16Ib = parcelRequire("k16Ib");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");

var $g4UBb = parcelRequire("g4UBb");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
const $7abfcf7725b290a0$export$2b9c3ffd3e776468 = (action$, store)=>{
    return action$.ofType((0, $jra4c.TRANSITION_REQUEST)).mergeMap((transitionAction)=>{
        const payload = transitionAction.payload;
        return (0, $k16Ib.transition)(payload.requestKey, payload.transitionId, payload.comment).map(()=>{
            var _payload$createAnalyt;
            const successEvent = (_payload$createAnalyt = payload.createAnalyticsEvent) === null || _payload$createAnalyt === void 0 ? void 0 : _payload$createAnalyt.call(payload, {
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'updated',
                actionSubject: 'customerTransition',
                projectId: (0, $73V7l.getProjectId)(store.getState(), payload.portalId)
            });
            successEvent && (0, $9ypa9.legacySendEvent)(successEvent);
            return (0, $jra4c.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            });
        }).catch((error)=>{
            var _payload$createAnalyt2;
            const failEvent = (_payload$createAnalyt2 = payload.createAnalyticsEvent) === null || _payload$createAnalyt2 === void 0 ? void 0 : _payload$createAnalyt2.call(payload, {
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'customerTransition'
            });
            failEvent && (0, $9ypa9.legacySendEvent)(failEvent);
            return (0, $fSYYZ.Observable).of((0, $jra4c.transitionRequestFailure)((0, $g4UBb.getJiraErrorOrDefault)(error)));
        });
    });
};

});
parcelRegister("k16Ib", function(module, exports) {
$parcel$export(module.exports, "transition", () => $a5aa1cd90830e30f$export$66bb15e2994e6a26);

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $a5aa1cd90830e30f$export$66bb15e2994e6a26 = (issueKey, transitionId, comment, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/requests/transition`;
    const body = {
        issueKey: issueKey,
        transitionId: transitionId,
        comment: comment
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $breWd.put)(uri, body, headers);
};

});

parcelRegister("1X8UE", function(module, exports) {
$parcel$export(module.exports, "getPortalAnalyticAttributes", () => (parcelRequire("73V7l")).getPortalAnalyticAttributes);
$parcel$export(module.exports, "getName", () => (parcelRequire("73V7l")).getName);
$parcel$export(module.exports, "getLogoUrl", () => (parcelRequire("73V7l")).getLogoUrl);
$parcel$export(module.exports, "getDescription", () => (parcelRequire("73V7l")).getDescription);
$parcel$export(module.exports, "getCategories", () => (parcelRequire("73V7l")).getCategories);
$parcel$export(module.exports, "getCategory", () => (parcelRequire("73V7l")).getCategory);
$parcel$export(module.exports, "getIsKbEnabled", () => (parcelRequire("73V7l")).getIsKbEnabled);
$parcel$export(module.exports, "getIsKbServer", () => (parcelRequire("73V7l")).getIsKbServer);
$parcel$export(module.exports, "getIsPortalLoaded", () => (parcelRequire("73V7l")).getIsPortalLoaded);
$parcel$export(module.exports, "getProjectId", () => (parcelRequire("73V7l")).getProjectId);
$parcel$export(module.exports, "getProjectKey", () => (parcelRequire("73V7l")).getProjectKey);
$parcel$export(module.exports, "getPortalRequestGroups", () => (parcelRequire("73V7l")).getPortalRequestGroups);
$parcel$export(module.exports, "getPortalRequestTypes", () => (parcelRequire("73V7l")).getPortalRequestTypes);
$parcel$export(module.exports, "getPortalRequestType", () => (parcelRequire("73V7l")).getPortalRequestType);
$parcel$export(module.exports, "getPortalRequestTypesForRequestGroup", () => (parcelRequire("73V7l")).getPortalRequestTypesForRequestGroup);
$parcel$export(module.exports, "getPortalRequestTypesNotInRequestGroup", () => (parcelRequire("73V7l")).getPortalRequestTypesNotInRequestGroup);
$parcel$export(module.exports, "getPortal", () => (parcelRequire("73V7l")).getPortal);
$parcel$export(module.exports, "getPortalOrError", () => (parcelRequire("73V7l")).getPortalOrError);
$parcel$export(module.exports, "getPortalAnnouncement", () => (parcelRequire("73V7l")).getPortalAnnouncement);
$parcel$export(module.exports, "getCanAdministerProject", () => (parcelRequire("73V7l")).getCanAdministerProject);
$parcel$export(module.exports, "getIsProjectSimplified", () => (parcelRequire("73V7l")).getIsProjectSimplified);
$parcel$export(module.exports, "getPortalLink", () => (parcelRequire("73V7l")).getPortalLink);
$parcel$export(module.exports, "getRequestGroupsForRequestType", () => (parcelRequire("73V7l")).getRequestGroupsForRequestType);
$parcel$export(module.exports, "getIsRequestTypeBelongsToGroup", () => (parcelRequire("73V7l")).getIsRequestTypeBelongsToGroup);
$parcel$export(module.exports, "canCreateRequest", () => (parcelRequire("73V7l")).canCreateRequest);
$parcel$export(module.exports, "getPortalAnnouncementPersisted", () => (parcelRequire("73V7l")).getPortalAnnouncementPersisted);
$parcel$export(module.exports, "getPortalAnnouncementsUI", () => (parcelRequire("73V7l")).getPortalAnnouncementsUI);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("73V7l")).isSaveInProgress);
$parcel$export(module.exports, "isSaveFailed", () => (parcelRequire("73V7l")).isSaveFailed);
$parcel$export(module.exports, "getServiceDeskId", () => (parcelRequire("73V7l")).getServiceDeskId);
$parcel$export(module.exports, "getKbSuggestions", () => (parcelRequire("73V7l")).getKbSuggestions);
$parcel$export(module.exports, "getKbLinkDomainURLs", () => (parcelRequire("73V7l")).getKbLinkDomainURLs);
$parcel$export(module.exports, "getMediaApiUploadToken", () => (parcelRequire("73V7l")).getMediaApiUploadToken);
$parcel$export(module.exports, "getMediaApiError", () => (parcelRequire("73V7l")).getMediaApiError);

var $73V7l = parcelRequire("73V7l");

});
parcelRegister("73V7l", function(module, exports) {
$parcel$export(module.exports, "getPortalAnalyticAttributes", () => $49a9ba94469e52ee$export$c60f1a869d2c2c74);
$parcel$export(module.exports, "getPortal", () => $49a9ba94469e52ee$export$e16cb606b6ef4a60);
$parcel$export(module.exports, "getName", () => $49a9ba94469e52ee$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getLogoUrl", () => $49a9ba94469e52ee$export$976f80239b15365);
$parcel$export(module.exports, "getDescription", () => $49a9ba94469e52ee$export$67580b1c13935958);
$parcel$export(module.exports, "getIsPortalLoaded", () => $49a9ba94469e52ee$export$bf5e3f9152d94e3b);
$parcel$export(module.exports, "getPortalRequestGroups", () => $49a9ba94469e52ee$export$78d9d04100263c2d);
$parcel$export(module.exports, "getPortalRequestTypes", () => $49a9ba94469e52ee$export$64da133fb6380f70);
$parcel$export(module.exports, "getPortalRequestType", () => $49a9ba94469e52ee$export$d1bf58a210f1b84e);
$parcel$export(module.exports, "getPortalRequestTypesForRequestGroup", () => $49a9ba94469e52ee$export$4965f91d890eed3b);
$parcel$export(module.exports, "getRequestGroupsForRequestType", () => $49a9ba94469e52ee$export$5a1e358eca2c7b0a);
$parcel$export(module.exports, "getIsRequestTypeBelongsToGroup", () => $49a9ba94469e52ee$export$2f20ba1ff04c787e);
$parcel$export(module.exports, "getPortalRequestTypesNotInRequestGroup", () => $49a9ba94469e52ee$export$3e60634ba4e73f5f);
$parcel$export(module.exports, "getProjectKey", () => $49a9ba94469e52ee$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $49a9ba94469e52ee$export$89040d072f281f85);
$parcel$export(module.exports, "getPortalOrError", () => $49a9ba94469e52ee$export$aa66ead34639a340);
$parcel$export(module.exports, "getIsKbEnabled", () => $49a9ba94469e52ee$export$d56e4bff0fec91ad);
$parcel$export(module.exports, "getIsKbServer", () => $49a9ba94469e52ee$export$62e14b755e26ac1e);
$parcel$export(module.exports, "getKbLinkDomainURLs", () => $49a9ba94469e52ee$export$8f367c2862b9eaf4);
$parcel$export(module.exports, "getPortalAnnouncement", () => $49a9ba94469e52ee$export$78e1a2ab89c0908b);
$parcel$export(module.exports, "getCanAdministerProject", () => $49a9ba94469e52ee$export$2cdfb65eda98a530);
$parcel$export(module.exports, "getIsProjectSimplified", () => $49a9ba94469e52ee$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getCategories", () => $49a9ba94469e52ee$export$7a0f33e8df10bd94);
$parcel$export(module.exports, "getCategory", () => $49a9ba94469e52ee$export$410364bbb673ddbc);
$parcel$export(module.exports, "getPortalLink", () => $49a9ba94469e52ee$export$ed7921430af91c7c);
$parcel$export(module.exports, "canCreateRequest", () => $49a9ba94469e52ee$export$f609845398295f39);
$parcel$export(module.exports, "getPortalAnnouncementPersisted", () => $49a9ba94469e52ee$export$65fec43abdb7eb83);
$parcel$export(module.exports, "getPortalAnnouncementsUI", () => $49a9ba94469e52ee$export$bf2c3b9a218e4a01);
$parcel$export(module.exports, "isSaveInProgress", () => $49a9ba94469e52ee$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isSaveFailed", () => $49a9ba94469e52ee$export$3620a86b3ad94622);
$parcel$export(module.exports, "getServiceDeskId", () => $49a9ba94469e52ee$export$f65464f8f75f45bc);
$parcel$export(module.exports, "getKbSuggestions", () => $49a9ba94469e52ee$export$e8626520ddba5456);
$parcel$export(module.exports, "getMediaApiUploadToken", () => $49a9ba94469e52ee$export$b87c6f04552c18ef);
$parcel$export(module.exports, "getMediaApiError", () => $49a9ba94469e52ee$export$ddddbd1696231d6a);

var $1We2B = parcelRequire("1We2B");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");
const $49a9ba94469e52ee$export$c60f1a869d2c2c74 = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.analyticAttributes;
};
const $49a9ba94469e52ee$export$7d9f7e9c1c02b41e = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.name;
};
const $49a9ba94469e52ee$export$976f80239b15365 = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.logoUrl;
};
const $49a9ba94469e52ee$export$67580b1c13935958 = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.description;
};
const $49a9ba94469e52ee$export$bf5e3f9152d94e3b = (state, portalId)=>!!$49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
const $49a9ba94469e52ee$export$78d9d04100263c2d = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.reqGroups : [];
};
const $49a9ba94469e52ee$export$8a8ef1c92929d685 = (state, portalId, requestGroupId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    if (!portal) return undefined;
    const requestGroupWithId = portal.reqGroups.find((reqGroup)=>reqGroup.id === requestGroupId);
    return requestGroupWithId;
};
const $49a9ba94469e52ee$export$64da133fb6380f70 = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.reqTypes : [];
};
const $49a9ba94469e52ee$export$d1bf58a210f1b84e = (state, portalId, requestTypeId)=>{
    if ((0, $1We2B.isNil)(portalId) || (0, $1We2B.isNil)(requestTypeId)) return undefined;
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.reqTypes.find((reqType)=>reqType.id === String(requestTypeId));
};
const $49a9ba94469e52ee$export$4965f91d890eed3b = (state, portalId, requestGroupId)=>{
    const allRequestTypesInPortal = $49a9ba94469e52ee$export$64da133fb6380f70(state, portalId);
    const selectedRequestGroup = $49a9ba94469e52ee$export$8a8ef1c92929d685(state, portalId, requestGroupId);
    if (!selectedRequestGroup) return [];
    const { reqTypes: reqTypesIdsInSelectedGroup } = selectedRequestGroup;
    const requestTypesInGroup = reqTypesIdsInSelectedGroup// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((id)=>allRequestTypesInPortal.find((rt)=>rt.id === id)).filter(Boolean);
    return requestTypesInGroup;
};
const $49a9ba94469e52ee$export$5a1e358eca2c7b0a = ({ state: state, portalId: portalId, requestTypeId: requestTypeId })=>{
    const requestGroups = $49a9ba94469e52ee$export$78d9d04100263c2d(state, portalId);
    return requestGroups.filter((group)=>group.reqTypes.includes(String(requestTypeId)));
};
const $49a9ba94469e52ee$export$2f20ba1ff04c787e = (state, portalId, requestGroupId, requestTypeId)=>{
    const requestGroups = $49a9ba94469e52ee$export$5a1e358eca2c7b0a({
        state: state,
        portalId: portalId,
        requestTypeId: requestTypeId
    });
    return (requestGroups || []).filter((requestGroup)=>requestGroup.id === requestGroupId).length > 0;
};
const $49a9ba94469e52ee$export$3e60634ba4e73f5f = (state, portalId, requestGroupId)=>{
    const allRequestTypesInPortal = $49a9ba94469e52ee$export$64da133fb6380f70(state, portalId);
    const selectedRequestGroup = $49a9ba94469e52ee$export$8a8ef1c92929d685(state, portalId, requestGroupId);
    if (!selectedRequestGroup) return allRequestTypesInPortal;
    const { reqTypes: reqTypesIdsInSelectedGroup } = selectedRequestGroup;
    const requestTypesNotInSelectedGroup = allRequestTypesInPortal.filter(({ id: idInPortal })=>// only include request types that are not in the specified group
        !reqTypesIdsInSelectedGroup.some((idInGroup)=>idInGroup === idInPortal));
    return requestTypesNotInSelectedGroup;
};
const $49a9ba94469e52ee$export$667f2a0f99c75faa = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return !!portal && portal.projectKey && portal.projectKey.toUpperCase();
};
const $49a9ba94469e52ee$export$89040d072f281f85 = (state, portalId)=>{
    if ((0, $1We2B.isNil)(portalId)) return undefined;
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.projectId : undefined;
};
const $49a9ba94469e52ee$export$aa66ead34639a340 = (state, portalId)=>{
    if ((0, $1We2B.isNil)(portalId)) return undefined;
    return state.persisted.portals[portalId];
};
const $49a9ba94469e52ee$export$e16cb606b6ef4a60 = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$aa66ead34639a340(state, portalId);
    if (!portal || 'error' in portal) return undefined;
    return portal;
};
const $49a9ba94469e52ee$export$d56e4bff0fec91ad = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return !!portal && !!portal.knowledgeBase;
};
const $49a9ba94469e52ee$export$62e14b755e26ac1e = (state, portalId)=>{
    var _portal$knowledgeBase;
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return Boolean(portal === null || portal === void 0 || (_portal$knowledgeBase = portal.knowledgeBase) === null || _portal$knowledgeBase === void 0 || (_portal$knowledgeBase = _portal$knowledgeBase.kbLink) === null || _portal$knowledgeBase === void 0 ? void 0 : _portal$knowledgeBase.isServer);
};
const $49a9ba94469e52ee$export$8f367c2862b9eaf4 = (state, portalId)=>{
    var _portal$knowledgeBase2;
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return (portal === null || portal === void 0 || (_portal$knowledgeBase2 = portal.knowledgeBase) === null || _portal$knowledgeBase2 === void 0 ? void 0 : _portal$knowledgeBase2.kbLinkDomainURLs) || [];
};
const $49a9ba94469e52ee$export$78e1a2ab89c0908b = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.portalAnnouncement : undefined;
};
const $49a9ba94469e52ee$export$b88ee522e5c6bc90 = (state, portalId)=>{
    const portalAnnouncement = $49a9ba94469e52ee$export$78e1a2ab89c0908b(state, portalId);
    return !!portalAnnouncement && portalAnnouncement.canEditAnnouncement;
};
const $49a9ba94469e52ee$export$2cdfb65eda98a530 = (state, portalId)=>{
    const portalAnnouncement = $49a9ba94469e52ee$export$78e1a2ab89c0908b(state, portalId);
    return portalAnnouncement && portalAnnouncement.canAdministerProject;
};
const $49a9ba94469e52ee$export$5bde43fbba6edf90 = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.isProjectSimplified : undefined;
};
const $49a9ba94469e52ee$export$7a0f33e8df10bd94 = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        return 'error' in categoryOrError ? [] : categoryOrError;
    }
    return undefined;
};
const $49a9ba94469e52ee$export$410364bbb673ddbc = (state, portalId, categoryId)=>{
    if (!categoryId || !portalId) return undefined;
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        if (Array.isArray(categoryOrError)) return categoryOrError.find((category)=>category.id === categoryId);
        return categoryOrError;
    }
    return undefined;
};
const $49a9ba94469e52ee$export$ed7921430af91c7c = (state, portalId)=>{
    const requestGroups = $49a9ba94469e52ee$export$78d9d04100263c2d(state, portalId);
    // If the user has exactly 1 request group and request type, we link them directly to that form.
    // Otherwise we direct them to the request groups
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    let portalLink = `/portal/${portalId}/group/-1`;
    if (requestGroups.length === 1) {
        const [requestGroup] = requestGroups;
        if (requestGroup.reqTypes.length === 1) {
            const [requestTypeId] = requestGroup.reqTypes;
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            portalLink = `/portal/${portalId}/group/${requestGroup.id}/create/${requestTypeId}`;
        }
    }
    return portalLink;
};
const $49a9ba94469e52ee$export$f609845398295f39 = (state, portalId)=>{
    if ((0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType)) return false;
    return Object.keys($49a9ba94469e52ee$export$78d9d04100263c2d(state, Number(portalId))).length > 0;
};
const $49a9ba94469e52ee$export$65fec43abdb7eb83 = (state, payload)=>{
    const portalAnnouncement = $49a9ba94469e52ee$export$78e1a2ab89c0908b(state, payload === null || payload === void 0 ? void 0 : payload.portalId);
    return portalAnnouncement ? portalAnnouncement : undefined;
};
const $49a9ba94469e52ee$export$bf2c3b9a218e4a01 = (state)=>state.ui.portals.portalAnnouncementsResponse;
const $49a9ba94469e52ee$export$2b75ac2de7a23db1 = (state)=>state.ui.portals.isSaveInProgress;
const $49a9ba94469e52ee$export$3620a86b3ad94622 = (state)=>state.ui.portals.isSaveFailed;
const $49a9ba94469e52ee$export$f65464f8f75f45bc = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.serviceDeskId;
};
const $49a9ba94469e52ee$export$e8626520ddba5456 = (state, portalId)=>{
    var _portal$knowledgeBase3;
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    const kbSuggestions = portal && !('error' in portal) && ((_portal$knowledgeBase3 = portal.knowledgeBase) === null || _portal$knowledgeBase3 === void 0 ? void 0 : _portal$knowledgeBase3.kbArticleSuggestions);
    if (kbSuggestions === false || kbSuggestions === undefined) return [];
    return kbSuggestions;
};
const $49a9ba94469e52ee$export$b87c6f04552c18ef = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.mediaApiUploadToken;
};
const $49a9ba94469e52ee$export$ddddbd1696231d6a = (state, portalId)=>{
    const portal = $49a9ba94469e52ee$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.mediaApiError;
};

});



parcelRegister("lCiks", function(module, exports) {
$parcel$export(module.exports, "requestGroupsEpic", () => $fd4d4a1fdfd72787$export$194ec9e5a7b72182);
parcelRequire("durY1");
var $fPmNS = parcelRequire("fPmNS");

var $2u4XH = parcelRequire("2u4XH");

var $i6rzq = parcelRequire("i6rzq");

var $hfwvs = parcelRequire("hfwvs");

var $4mYZI = parcelRequire("4mYZI");
const $fd4d4a1fdfd72787$export$194ec9e5a7b72182 = (0, $fPmNS.combineEpics)((0, $2u4XH.addRequestGroupEpic), (0, $4mYZI.reorderRequestGroupEpic), (0, $hfwvs.removeRequestGroupEpic), (0, $i6rzq.getAllRequestGroupsEpic));

});
parcelRegister("2u4XH", function(module, exports) {
$parcel$export(module.exports, "addRequestGroupEpic", () => $3c74be88a4d1ca8d$export$8362a74d5020b3ae);

var $fSYYZ = parcelRequire("fSYYZ");

var $60AXd = parcelRequire("60AXd");
parcelRequire("b2kCx");
var $7I03W = parcelRequire("7I03W");
parcelRequire("4CT7s");
var $gQFbD = parcelRequire("gQFbD");

var $g4UBb = parcelRequire("g4UBb");

var $9ypa9 = parcelRequire("9ypa9");
const $3c74be88a4d1ca8d$export$8362a74d5020b3ae = (action$)=>{
    return action$.ofType((0, $7I03W.ADD_REQUEST_GROUP)).mergeMap((action)=>{
        const { projectId: projectId, portalId: portalId, groupName: groupName, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } = action.payload;
        return (0, $60AXd.addRequestGroup)(groupName, projectId).map((response)=>{
            if (analyticsEvent) {
                // Update the analytics event with newly created Request type group's ID as the actionSubjectId
                analyticsEvent.update((payload)=>({
                        ...payload,
                        actionSubjectId: response.id
                    }));
                (0, $9ypa9.legacySendEvent)(analyticsEvent);
            }
            return (0, $gQFbD.getRequestGroupsAction)(projectId, portalId);
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $9ypa9.legacySendEvent)(analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $7I03W.addRequestGroupFailedAction)((0, $g4UBb.getFirstMessageFromJiraError)(error.response), groupName));
        });
    });
};

});
parcelRegister("60AXd", function(module, exports) {
$parcel$export(module.exports, "addRequestGroup", () => $02c0fab37c2418b3$export$2a108ddc24673b82);
$parcel$export(module.exports, "updateRequestGroup", () => $02c0fab37c2418b3$export$6343ebb5dbd23e24);
$parcel$export(module.exports, "fetchAllRequestGroups", () => $02c0fab37c2418b3$export$1baf2ae38689e29e);

var $bhOdO = parcelRequire("bhOdO");

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $02c0fab37c2418b3$export$2a108ddc24673b82 = (name, projectId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    return (0, $breWd.post)(uri, {
        name: name
    }, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        // Rethrow error
        return (0, $bhOdO.Observable).throw(e);
    });
};
const $02c0fab37c2418b3$export$6343ebb5dbd23e24 = ({ name: name, projectId: projectId, requestGroupId: requestGroupId, context: context = (0, $7FSs7.contextPath) })=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}`;
    return (0, $breWd.put)(uri, {
        name: name
    }, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $bhOdO.Observable).throw(e));
};
const $02c0fab37c2418b3$export$1baf2ae38689e29e = (projectId, context = (0, $7FSs7.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    return (0, $breWd.get)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $bhOdO.Observable).throw(e));
};

});

parcelRegister("b2kCx", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_GROUP", () => (parcelRequire("7I03W")).ADD_REQUEST_GROUP);
$parcel$export(module.exports, "ADD_REQUEST_GROUP_FAILED", () => (parcelRequire("7I03W")).ADD_REQUEST_GROUP_FAILED);
$parcel$export(module.exports, "addRequestGroupAction", () => (parcelRequire("7I03W")).addRequestGroupAction);
$parcel$export(module.exports, "addRequestGroupFailedAction", () => (parcelRequire("7I03W")).addRequestGroupFailedAction);

var $7I03W = parcelRequire("7I03W");

});
parcelRegister("7I03W", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_GROUP", () => $f6abaacb9383df6c$export$8e1d62e25202aae2);
$parcel$export(module.exports, "ADD_REQUEST_GROUP_FAILED", () => $f6abaacb9383df6c$export$3098f04a186c7a1a);
$parcel$export(module.exports, "addRequestGroupAction", () => $f6abaacb9383df6c$export$207b3b17fddc56c6);
$parcel$export(module.exports, "addRequestGroupFailedAction", () => $f6abaacb9383df6c$export$668bfa1c007e18ef);
const $f6abaacb9383df6c$export$8e1d62e25202aae2 = 'epic.request-groups.ADD_REQUEST_GROUP';
const $f6abaacb9383df6c$export$3098f04a186c7a1a = 'epic.request-groups.ADD_REQUEST_GROUP_FAILED';
const $f6abaacb9383df6c$export$207b3b17fddc56c6 = (payload)=>({
        payload: payload,
        type: $f6abaacb9383df6c$export$8e1d62e25202aae2
    });
const $f6abaacb9383df6c$export$668bfa1c007e18ef = (message, groupNameThatCausedError)=>({
        payload: {
            message: message,
            groupNameThatCausedError: groupNameThatCausedError
        },
        type: $f6abaacb9383df6c$export$3098f04a186c7a1a
    });

});


parcelRegister("4CT7s", function(module, exports) {
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS", () => (parcelRequire("gQFbD")).GET_ALL_REQUEST_GROUPS);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_FAILURE", () => (parcelRequire("gQFbD")).GET_ALL_REQUEST_GROUPS_FAILURE);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_SUCCESS", () => (parcelRequire("gQFbD")).GET_ALL_REQUEST_GROUPS_SUCCESS);
$parcel$export(module.exports, "getRequestGroupsAction", () => (parcelRequire("gQFbD")).getRequestGroupsAction);
$parcel$export(module.exports, "getRequestGroupsFailure", () => (parcelRequire("gQFbD")).getRequestGroupsFailure);
$parcel$export(module.exports, "getRequestGroupsSuccess", () => (parcelRequire("gQFbD")).getRequestGroupsSuccess);
parcelRequire("gQFbD");

});
parcelRegister("gQFbD", function(module, exports) {
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS", () => $1fd41254cc4fc485$export$4385e1518ec9ee53);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_SUCCESS", () => $1fd41254cc4fc485$export$b61d00db9e210ef);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_FAILURE", () => $1fd41254cc4fc485$export$80b563f5e425073f);
$parcel$export(module.exports, "getRequestGroupsAction", () => $1fd41254cc4fc485$export$9c0c7a1030efe8de);
$parcel$export(module.exports, "getRequestGroupsSuccess", () => $1fd41254cc4fc485$export$c1f5fa36efe1c1c7);
$parcel$export(module.exports, "getRequestGroupsFailure", () => $1fd41254cc4fc485$export$a8d060d6575e9dfb);
const $1fd41254cc4fc485$export$4385e1518ec9ee53 = 'epic.request-groups.GET_ALL_REQUEST_GROUPS';
const $1fd41254cc4fc485$export$b61d00db9e210ef = 'epic.request-groups.GET_ALL_REQUEST_GROUPS_SUCCESS';
const $1fd41254cc4fc485$export$80b563f5e425073f = 'epic.request-groups.GET_ALL_REQUEST_GROUPS_FAILURE';
const $1fd41254cc4fc485$export$9c0c7a1030efe8de = (projectId, portalId)=>({
        payload: {
            projectId: projectId,
            portalId: portalId
        },
        type: $1fd41254cc4fc485$export$4385e1518ec9ee53
    });
const $1fd41254cc4fc485$export$c1f5fa36efe1c1c7 = (payload)=>({
        payload: payload,
        type: $1fd41254cc4fc485$export$b61d00db9e210ef
    });
const $1fd41254cc4fc485$export$a8d060d6575e9dfb = (payload)=>({
        payload: payload,
        type: $1fd41254cc4fc485$export$80b563f5e425073f
    });

});



parcelRegister("i6rzq", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsEpic", () => $a2038f4c6a3ef795$export$53dc813939b78da1);

var $bhOdO = parcelRequire("bhOdO");

var $60AXd = parcelRequire("60AXd");
parcelRequire("4CT7s");
var $gQFbD = parcelRequire("gQFbD");

var $g4UBb = parcelRequire("g4UBb");
const $a2038f4c6a3ef795$export$53dc813939b78da1 = (action$)=>action$.ofType((0, $gQFbD.GET_ALL_REQUEST_GROUPS)).mergeMap((action)=>{
        const { projectId: projectId, portalId: portalId } = action.payload;
        return (0, $60AXd.fetchAllRequestGroups)(projectId).map((requestGroups)=>(0, $gQFbD.getRequestGroupsSuccess)({
                portalId: portalId,
                requestGroups: requestGroups
            })).catch((e)=>{
            const errorMessage = (0, $g4UBb.getFirstMessageFromJiraError)(e.response);
            return (0, $bhOdO.Observable).of((0, $gQFbD.getRequestGroupsFailure)({
                errorMessage: errorMessage,
                projectId: projectId
            }));
        });
    });

});

parcelRegister("hfwvs", function(module, exports) {
$parcel$export(module.exports, "removeRequestGroupEpic", () => $2671c234ff13b193$export$7a528fd4d213cd7);

var $fSYYZ = parcelRequire("fSYYZ");

var $1D8VF = parcelRequire("1D8VF");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("ddw3s");
var $kx7wz = parcelRequire("kx7wz");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $9ypa9 = parcelRequire("9ypa9");
const $2671c234ff13b193$var$REQUEST_ID = 'com.atlassian.servicedesk.portal-ui:customize-portal-sidebar';
const $2671c234ff13b193$export$7a528fd4d213cd7 = (action$, store)=>{
    return action$.ofType((0, $kx7wz.REMOVE_REQUEST_GROUP)).mergeMap(({ payload: { portalId: portalId, deletedId: deletedId, onRemoveGroupSuccess: onRemoveGroupSuccess, onRemoveGroupError: onRemoveGroupError, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const state = store.getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const projectId = (0, $73V7l.getProjectId)(state, portalId);
        const requestGroups = (0, $73V7l.getPortalRequestGroups)(state, portalId);
        const newOrder = requestGroups.map(({ id: id })=>id).filter((id)=>id !== deletedId);
        // Perform the rest call to update groups
        return (0, $1D8VF.requestGroupReorder)({
            projectId: projectId,
            order: newOrder,
            id: $2671c234ff13b193$var$REQUEST_ID,
            deleted: [
                deletedId
            ],
            inline: true
        })// On success, refresh the model
        .map(()=>{
            analyticsEvent && (0, $9ypa9.legacySendEvent)(analyticsEvent);
            if (onRemoveGroupSuccess) onRemoveGroupSuccess();
            return (0, $d727K.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        })// On fail, clear the ui state to reverse optimistic update
        .catch(()=>{
            if (onRemoveGroupError) onRemoveGroupError();
            if (analyticsFailureEvent) (0, $9ypa9.legacySendEvent)(analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $kx7wz.removeRequestGroupFailedAction)());
        });
    });
};

});
parcelRegister("1D8VF", function(module, exports) {
$parcel$export(module.exports, "requestGroupReorder", () => $84dfaa041e9a94ba$export$e26022a90e227660);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $7FSs7 = parcelRequire("7FSs7");
const $84dfaa041e9a94ba$export$e26022a90e227660 = ({ id: id, deleted: deleted, order: order, inline: inline, projectId: projectId })=>{
    const uri = `${(0, $7FSs7.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    const body = {
        id: id,
        deleted: deleted,
        order: order,
        inline: inline
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.put)(uri, body, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        return (0, $fSYYZ.Observable).throw(e);
    });
};

});

parcelRegister("ddw3s", function(module, exports) {
$parcel$export(module.exports, "REMOVE_REQUEST_GROUP", () => (parcelRequire("kx7wz")).REMOVE_REQUEST_GROUP);
$parcel$export(module.exports, "removeRequestGroupAction", () => (parcelRequire("kx7wz")).removeRequestGroupAction);
$parcel$export(module.exports, "removeRequestGroupFailedAction", () => (parcelRequire("kx7wz")).removeRequestGroupFailedAction);

var $kx7wz = parcelRequire("kx7wz");

});
parcelRegister("kx7wz", function(module, exports) {
$parcel$export(module.exports, "REMOVE_REQUEST_GROUP", () => $03caad4ce33783c4$export$7aaaf575c1ef21c8);
$parcel$export(module.exports, "removeRequestGroupAction", () => $03caad4ce33783c4$export$fe2120d3bdfd11a7);
$parcel$export(module.exports, "removeRequestGroupFailedAction", () => $03caad4ce33783c4$export$35f1f33f6fdb929d);
const $03caad4ce33783c4$export$7aaaf575c1ef21c8 = 'epic.request-groups.REMOVE_REQUEST_GROUP';
const $03caad4ce33783c4$var$REMOVE_REQUEST_GROUP_FAILED = 'epic.request-groups.REMOVE_REQUEST_GROUP_FAILED';
const $03caad4ce33783c4$export$fe2120d3bdfd11a7 = (payload)=>{
    return {
        payload: payload,
        type: $03caad4ce33783c4$export$7aaaf575c1ef21c8
    };
};
const $03caad4ce33783c4$export$35f1f33f6fdb929d = ()=>{
    return {
        type: $03caad4ce33783c4$var$REMOVE_REQUEST_GROUP_FAILED
    };
};

});



parcelRegister("4mYZI", function(module, exports) {
$parcel$export(module.exports, "reorderRequestGroupEpic", () => $66d93af10054e106$export$691172c527fd88df);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $1D8VF = parcelRequire("1D8VF");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("by53g");
var $vgnrJ = parcelRequire("vgnrJ");
parcelRequire("4CT7s");
var $gQFbD = parcelRequire("gQFbD");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("bmVFm");
var $erAfl = parcelRequire("erAfl");

var $9ypa9 = parcelRequire("9ypa9");
const $66d93af10054e106$var$REQUEST_ID = 'com.atlassian.servicedesk.portal-ui:customize-portal-sidebar';
const $66d93af10054e106$export$691172c527fd88df = (action$, store)=>{
    return action$.ofType((0, $vgnrJ.UPDATE_REQUEST_GROUPS_ORDER))// User may perform updates (reorders and deletes) rapidly but we want to minimise unnecessary REST calls
    // We could debounce but we want ALL the analytics events so instead we buffer, get ALL the analytics events
    // and then just process the most recent event and if successful fire ALL analytics events
    .bufferTime(500).mergeMap((bufferedActions)=>{
        // First, create list of buffered analytic events (ALL will be fired if `update request groups` REST call is successful)
        const analyticsEvents = bufferedActions.map((action)=>action.payload.analyticsEvent).filter(Boolean);
        const analyticsFailureEvents = bufferedActions.map((action)=>action.payload.analyticsFailureEvent).filter(Boolean);
        // Second, pop the most recently published action
        const mostRecentAction = bufferedActions.pop();
        if (!mostRecentAction) return (0, $fSYYZ.Observable).empty();
        const { portalId: portalId, order: order } = mostRecentAction.payload;
        const state = store.getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const projectId = (0, $73V7l.getProjectId)(state, portalId);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const requestGroups = (0, $erAfl.getUIRequestGroups)(state, portalId);
        const deletedIds = requestGroups.map(({ id: id })=>id).filter((id)=>!order.includes(id));
        // Perform the rest call to update groups
        return (0, $1D8VF.requestGroupReorder)({
            projectId: projectId,
            order: order,
            deleted: deletedIds,
            id: $66d93af10054e106$var$REQUEST_ID,
            inline: true
        })// On success, refresh the model
        .mergeMap(()=>{
            // Success; fire ALL analytics events
            analyticsEvents.forEach((0, $9ypa9.legacySendEvent));
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $gQFbD.getRequestGroupsAction)(projectId, portalId)), (0, $fSYYZ.Observable).of((0, $d727K.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            })));
        })// On fail, clear the ui state to reverse optimistic update
        .catch((_)=>{
            analyticsFailureEvents.forEach((0, $9ypa9.legacySendEvent));
            return (0, $fSYYZ.Observable).of((0, $vgnrJ.clearRequestGroupsOrderAction)());
        });
    });
};

});
parcelRegister("by53g", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQUEST_GROUPS_ORDER", () => (parcelRequire("vgnrJ")).UPDATE_REQUEST_GROUPS_ORDER);
$parcel$export(module.exports, "CLEAR_REQUEST_GROUPS_ORDER", () => (parcelRequire("vgnrJ")).CLEAR_REQUEST_GROUPS_ORDER);
$parcel$export(module.exports, "CLEAR_ERROR_MESSAGE", () => (parcelRequire("vgnrJ")).CLEAR_ERROR_MESSAGE);
$parcel$export(module.exports, "CLEAR_REQUEST_TYPES_ORDER", () => (parcelRequire("vgnrJ")).CLEAR_REQUEST_TYPES_ORDER);
$parcel$export(module.exports, "updateRequestGroupsOrderAction", () => (parcelRequire("vgnrJ")).updateRequestGroupsOrderAction);
$parcel$export(module.exports, "clearRequestGroupsOrderAction", () => (parcelRequire("vgnrJ")).clearRequestGroupsOrderAction);
$parcel$export(module.exports, "clearErrorMessageAction", () => (parcelRequire("vgnrJ")).clearErrorMessageAction);
$parcel$export(module.exports, "clearRequestTypesOrderAction", () => (parcelRequire("vgnrJ")).clearRequestTypesOrderAction);

var $vgnrJ = parcelRequire("vgnrJ");

});
parcelRegister("vgnrJ", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQUEST_GROUPS_ORDER", () => $e26dfab8afcfd8c8$export$3206afd0265da736);
$parcel$export(module.exports, "CLEAR_REQUEST_GROUPS_ORDER", () => $e26dfab8afcfd8c8$export$cef961ec6e406565);
$parcel$export(module.exports, "CLEAR_ERROR_MESSAGE", () => $e26dfab8afcfd8c8$export$954b6cd4735c91da);
$parcel$export(module.exports, "CLEAR_REQUEST_TYPES_ORDER", () => $e26dfab8afcfd8c8$export$896c4eec286cc76c);
$parcel$export(module.exports, "updateRequestGroupsOrderAction", () => $e26dfab8afcfd8c8$export$c362b5f333b2372c);
$parcel$export(module.exports, "clearRequestGroupsOrderAction", () => $e26dfab8afcfd8c8$export$1a19c76107cb4b0c);
$parcel$export(module.exports, "clearErrorMessageAction", () => $e26dfab8afcfd8c8$export$a72b98a8de57346e);
$parcel$export(module.exports, "clearRequestTypesOrderAction", () => $e26dfab8afcfd8c8$export$8e8d01bbfddde092);
const $e26dfab8afcfd8c8$export$3206afd0265da736 = 'state.ui.portal-customisation.UPDATE_REQUEST_GROUPS_ORDER';
const $e26dfab8afcfd8c8$export$cef961ec6e406565 = 'state.ui.portal-customisation.CLEAR_REQUEST_GROUPS_ORDER';
const $e26dfab8afcfd8c8$export$954b6cd4735c91da = 'state.ui.portal-customisation.CLEAR_ERROR_MESSAGE';
const $e26dfab8afcfd8c8$export$896c4eec286cc76c = 'state.ui.portal-customisation.CLEAR_REQUEST_TYPES_ORDER';
const $e26dfab8afcfd8c8$export$c362b5f333b2372c = (payload)=>({
        payload: payload,
        type: $e26dfab8afcfd8c8$export$3206afd0265da736
    });
const $e26dfab8afcfd8c8$export$1a19c76107cb4b0c = ()=>({
        type: $e26dfab8afcfd8c8$export$cef961ec6e406565
    });
const $e26dfab8afcfd8c8$export$a72b98a8de57346e = ()=>({
        type: $e26dfab8afcfd8c8$export$954b6cd4735c91da
    });
const $e26dfab8afcfd8c8$export$8e8d01bbfddde092 = ()=>({
        type: $e26dfab8afcfd8c8$export$896c4eec286cc76c
    });

});


parcelRegister("bmVFm", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsWithRequestTypesForPortal", () => (parcelRequire("erAfl")).getAllRequestGroupsWithRequestTypesForPortal);
$parcel$export(module.exports, "getErrorMessage", () => (parcelRequire("erAfl")).getErrorMessage);
$parcel$export(module.exports, "getGroupNameThatCausedError", () => (parcelRequire("erAfl")).getGroupNameThatCausedError);
$parcel$export(module.exports, "getPortalCustomisationError", () => (parcelRequire("erAfl")).getPortalCustomisationError);
$parcel$export(module.exports, "getRequestGroupById", () => (parcelRequire("erAfl")).getRequestGroupById);
$parcel$export(module.exports, "getUIIsParentRequestGroupsLoading", () => (parcelRequire("erAfl")).getUIIsParentRequestGroupsLoading);
$parcel$export(module.exports, "getUIParentRequestGroupsForRequestType", () => (parcelRequire("erAfl")).getUIParentRequestGroupsForRequestType);
$parcel$export(module.exports, "getUIRequestGroups", () => (parcelRequire("erAfl")).getUIRequestGroups);
$parcel$export(module.exports, "getUIRequestGroupsOrder", () => (parcelRequire("erAfl")).getUIRequestGroupsOrder);
$parcel$export(module.exports, "getUIRequestGroupsWithRequestTypes", () => (parcelRequire("erAfl")).getUIRequestGroupsWithRequestTypes);
$parcel$export(module.exports, "getUIRequestTypesInRequestGroupById", () => (parcelRequire("erAfl")).getUIRequestTypesInRequestGroupById);
$parcel$export(module.exports, "getUIRequestTypesNotInRequestGroupById", () => (parcelRequire("erAfl")).getUIRequestTypesNotInRequestGroupById);
parcelRequire("erAfl");

});
parcelRegister("erAfl", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsWithRequestTypesForPortal", () => $0a76c93b6582d6ea$export$eafd9d6b190f9991);
$parcel$export(module.exports, "getErrorMessage", () => $0a76c93b6582d6ea$export$82f46aa4e6535a45);
$parcel$export(module.exports, "getRequestGroupById", () => $0a76c93b6582d6ea$export$c93f0b0a861dcf03);
$parcel$export(module.exports, "getUIRequestGroupsOrder", () => $0a76c93b6582d6ea$export$13689122403cb761);
$parcel$export(module.exports, "getUIRequestGroups", () => $0a76c93b6582d6ea$export$5b1cb606e38791c6);
$parcel$export(module.exports, "getUIRequestGroupsWithRequestTypes", () => $0a76c93b6582d6ea$export$5d023274645990b2);
$parcel$export(module.exports, "getUIRequestTypesInRequestGroupById", () => $0a76c93b6582d6ea$export$3257afc3359cfce);
$parcel$export(module.exports, "getUIParentRequestGroupsForRequestType", () => $0a76c93b6582d6ea$export$9abf85e04ff9329b);
$parcel$export(module.exports, "getUIIsParentRequestGroupsLoading", () => $0a76c93b6582d6ea$export$1863e442385dba5c);
$parcel$export(module.exports, "getPortalCustomisationError", () => $0a76c93b6582d6ea$export$7b32ab9a7ad364f3);
$parcel$export(module.exports, "getGroupNameThatCausedError", () => $0a76c93b6582d6ea$export$9f49200face9760d);
$parcel$export(module.exports, "getUIRequestTypesNotInRequestGroupById", () => $0a76c93b6582d6ea$export$5f6e3f684cf8395b);
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
/**
 *
 *  Persisted Portal Customisation state selectors
 *
 */ const $0a76c93b6582d6ea$var$withRequestTypesPopulated = (groupsWithTypes)=>(reqGroup)=>{
        const existingReqTypes = groupsWithTypes.find((rg)=>rg.id === reqGroup.id);
        return {
            ...reqGroup,
            reqTypes: !!existingReqTypes ? existingReqTypes.reqTypes : []
        };
    };
const $0a76c93b6582d6ea$export$25ec121fd14d9df3 = (state)=>state.persisted.portalCustomisation.allRequestGroups;
const $0a76c93b6582d6ea$export$514a0edc3b518db9 = (state, portalId)=>{
    const allRequestGroups = $0a76c93b6582d6ea$export$25ec121fd14d9df3(state);
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!(portalId && allRequestGroups && allRequestGroups[portalId])) return undefined;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return allRequestGroups[portalId];
};
const $0a76c93b6582d6ea$export$eafd9d6b190f9991 = (state, portalId)=>{
    const allRequestGroups = $0a76c93b6582d6ea$export$25ec121fd14d9df3(state);
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!(portalId && allRequestGroups && allRequestGroups[portalId])) return undefined;
    const groupsWithExistingRequestTypes = (0, $73V7l.getPortalRequestGroups)(state, portalId);
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    const requestGroupsWithRequestTypes = allRequestGroups[portalId].map($0a76c93b6582d6ea$var$withRequestTypesPopulated(groupsWithExistingRequestTypes));
    return requestGroupsWithRequestTypes;
};
const $0a76c93b6582d6ea$export$82f46aa4e6535a45 = (state)=>state.persisted.portalCustomisation.errorMessage;
const $0a76c93b6582d6ea$export$c93f0b0a861dcf03 = (state, portalId, requestGroupId)=>{
    const requestGroups = $0a76c93b6582d6ea$export$eafd9d6b190f9991(state, portalId);
    return !!requestGroups ? requestGroups.find((group)=>group.id === requestGroupId) : undefined;
};
const $0a76c93b6582d6ea$export$13689122403cb761 = (state)=>state.ui.portalCustomisation.requestGroupsOrder;
const $0a76c93b6582d6ea$export$f7da43c7a00426c = (state)=>state.ui.portalCustomisation.requestTypesOrder;
const $0a76c93b6582d6ea$export$5b1cb606e38791c6 = (state, portalId)=>state.ui.portalCustomisation.requestGroups || $0a76c93b6582d6ea$export$514a0edc3b518db9(state, portalId);
const $0a76c93b6582d6ea$export$5d023274645990b2 = (state, portalId)=>state.ui.portalCustomisation.requestGroups ? state.ui.portalCustomisation.requestGroups.map($0a76c93b6582d6ea$var$withRequestTypesPopulated((0, $73V7l.getPortalRequestGroups)(state, portalId))) : $0a76c93b6582d6ea$export$eafd9d6b190f9991(state, portalId);
const $0a76c93b6582d6ea$export$3257afc3359cfce = (state, portalId, requestGroupId)=>{
    let requestTypesInRequestGroup = state.ui.portalCustomisation.requestTypesInRequestGroup || (0, $73V7l.getPortalRequestTypesForRequestGroup)(state, portalId, requestGroupId);
    const requestTypesOrder = $0a76c93b6582d6ea$export$f7da43c7a00426c(state);
    if (requestTypesOrder) requestTypesInRequestGroup = requestTypesOrder.map((requestTypeId)=>requestTypesInRequestGroup.find((rt)=>Number(rt.id) === requestTypeId)).filter(Boolean);
    return requestTypesInRequestGroup;
};
const $0a76c93b6582d6ea$export$9abf85e04ff9329b = (state, portalId, requestTypeId)=>{
    const parentRequestGroups = state.ui.portalCustomisation.parentRequestGroups || (0, $73V7l.getRequestGroupsForRequestType)({
        state: state,
        portalId: portalId,
        requestTypeId: requestTypeId
    });
    return [
        ...parentRequestGroups
    ].sort((first, second)=>first.name.toLowerCase().localeCompare(second.name.toLowerCase()));
};
const $0a76c93b6582d6ea$export$1863e442385dba5c = (state)=>{
    return state.ui.portalCustomisation.isParentRequestGroupsLoading;
};
const $0a76c93b6582d6ea$export$7b32ab9a7ad364f3 = (state)=>state.ui.portalCustomisation.error;
const $0a76c93b6582d6ea$export$9f49200face9760d = (state)=>state.ui.portalCustomisation.groupNameThatCausedError;
const $0a76c93b6582d6ea$export$5f6e3f684cf8395b = (state, portalId, requestGroupId)=>{
    return state.ui.portalCustomisation.requestTypesNotInRequestGroup || (0, $73V7l.getPortalRequestTypesNotInRequestGroup)(state, portalId, requestGroupId);
};

});




parcelRegister("k4Ps4", function(module, exports) {
$parcel$export(module.exports, "addRequestTypeToRequestGroupEpic", () => $d24e17cabc2ceee0$export$7219fe759636c43a);

var $fSYYZ = parcelRequire("fSYYZ");

var $1We2B = parcelRequire("1We2B");

var $acB4r = parcelRequire("acB4r");
parcelRequire("9hqkU");
var $eT83r = parcelRequire("eT83r");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("bmVFm");
var $erAfl = parcelRequire("erAfl");

var $g4UBb = parcelRequire("g4UBb");

var $9ypa9 = parcelRequire("9ypa9");
const $d24e17cabc2ceee0$var$getAssociatedGroups = (requestType, requestGroup, requestGroups)=>{
    const associatedRequestGroups = (0, $1We2B.uniqBy)(requestGroups, 'id').filter((reqGroup)=>reqGroup.reqTypes.includes(requestType.id));
    // Add group association to request type if not already added
    if (!associatedRequestGroups.includes(requestGroup)) associatedRequestGroups.push(requestGroup);
    return associatedRequestGroups;
};
const $d24e17cabc2ceee0$var$getIconIdFromIconUrl = (iconUrl)=>iconUrl.substring(iconUrl.lastIndexOf('=') + 1, iconUrl.length);
const $d24e17cabc2ceee0$var$getSanitizedText = (html)=>{
    const stripHtmlTagsRegex = /(<([^>]+)>)/gi;
    return html.replace(stripHtmlTagsRegex, '');
};
const $d24e17cabc2ceee0$var$getSerializedRequestTypeWithRequestGroups = (requestType, requestGroup, requestGroups)=>({
        id: requestType.id,
        name: requestType.name,
        // Can remove after https://jdog.jira-dev.com/browse/JDW-292
        icon: $d24e17cabc2ceee0$var$getIconIdFromIconUrl(requestType.iconUrl),
        iconUrl: requestType.iconUrl,
        description: $d24e17cabc2ceee0$var$getSanitizedText(requestType.descriptionHtml),
        groups: $d24e17cabc2ceee0$var$getAssociatedGroups(requestType, requestGroup, requestGroups)
    });
const $d24e17cabc2ceee0$export$7219fe759636c43a = (action$, store)=>{
    return action$.ofType((0, $eT83r.ADD_REQUEST_TYPE_TO_REQUEST_GROUP)).mergeMap(({ payload: { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, requestGroup: requestGroup, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const state = store.getState();
        const requestGroups = (0, $erAfl.getAllRequestGroupsWithRequestTypesForPortal)(state, portalId) || [];
        return (0, $acB4r.setRequestGroupsForRequestType)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            updatedRequestTypeGroupId: requestGroup.id,
            requestGroupId: requestGroup.id,
            requestType: $d24e17cabc2ceee0$var$getSerializedRequestTypeWithRequestGroups(requestType, requestGroup, requestGroups)
        }).map(()=>{
            analyticsEvent && (0, $9ypa9.legacySendEvent)(analyticsEvent);
            return (0, $d727K.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $9ypa9.legacySendEvent)(analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $eT83r.addRequestTypeToRequestGroupFailedAction)((0, $g4UBb.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});
parcelRegister("acB4r", function(module, exports) {
$parcel$export(module.exports, "setRequestGroupsForRequestType", () => $305d1dd0b60c5d35$export$9067d57db9e6b38e);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $7FSs7 = parcelRequire("7FSs7");
const $305d1dd0b60c5d35$export$9067d57db9e6b38e = ({ isProjectSimplified: isProjectSimplified, requestType: requestType, updatedRequestTypeGroupId: updatedRequestTypeGroupId, requestGroupId: requestGroupId, projectId: projectId, context: context = (0, $7FSs7.contextPath) })=>{
    if (isProjectSimplified) {
        const nextGenUri = (groupId)=>`${context}/rest/servicedesk/1/simplified/${projectId}/request-type-groups/${groupId}/${requestType.id}`;
        const isAdded = requestType.groups.some(({ id: id })=>id === updatedRequestTypeGroupId);
        const httpMethod = isAdded ? (0, $breWd.put) : (0, $breWd.doDelete);
        return httpMethod(nextGenUri(updatedRequestTypeGroupId))// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .map(({ response: response })=>response).catch((e)=>{
            // Rethrow error
            return (0, $fSYYZ.Observable).throw(e);
        });
    }
    // In Classic:
    // The request type <-> group association is stored on a request type in the backend
    // We call the update request type endpoint with the request type in the body with the new group associsation
    const classicUri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestType.id}`;
    return (0, $breWd.put)(classicUri, requestType, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        // Rethrow error
        return (0, $fSYYZ.Observable).throw(e);
    });
};

});

parcelRegister("9hqkU", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP", () => (parcelRequire("eT83r")).ADD_REQUEST_TYPE_TO_REQUEST_GROUP);
$parcel$export(module.exports, "addRequestTypeToRequestGroupAction", () => (parcelRequire("eT83r")).addRequestTypeToRequestGroupAction);
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED", () => (parcelRequire("eT83r")).ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED);
$parcel$export(module.exports, "addRequestTypeToRequestGroupFailedAction", () => (parcelRequire("eT83r")).addRequestTypeToRequestGroupFailedAction);

var $eT83r = parcelRequire("eT83r");

});
parcelRegister("eT83r", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP", () => $1d32753e084812a6$export$eb48643df0521b0d);
$parcel$export(module.exports, "addRequestTypeToRequestGroupAction", () => $1d32753e084812a6$export$196767c05c5a3485);
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED", () => $1d32753e084812a6$export$e0f4630e32187ebc);
$parcel$export(module.exports, "addRequestTypeToRequestGroupFailedAction", () => $1d32753e084812a6$export$87cedd1ffa234cc5);
const $1d32753e084812a6$export$eb48643df0521b0d = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP';
const $1d32753e084812a6$export$196767c05c5a3485 = (payload)=>{
    return {
        payload: payload,
        type: $1d32753e084812a6$export$eb48643df0521b0d
    };
};
const $1d32753e084812a6$var$ADD_REQUEST_TYPE_TO_REQUEST_GROUP_SUCCEEDED = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_SUCCEEDED';
const $1d32753e084812a6$export$e0f4630e32187ebc = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED';
const $1d32753e084812a6$export$87cedd1ffa234cc5 = (message)=>({
        payload: {
            message: message
        },
        type: $1d32753e084812a6$export$e0f4630e32187ebc
    });

});



parcelRegister("aXxPo", function(module, exports) {
$parcel$export(module.exports, "createGroupWithRequestTypeEpic", () => $5ec0ed99f7144a60$export$2d5fcba5bbcf0933);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $60AXd = parcelRequire("60AXd");
parcelRequire("d8JBM");
var $1EpSd = parcelRequire("1EpSd");
parcelRequire("4CT7s");
var $gQFbD = parcelRequire("gQFbD");
parcelRequire("jD4Sf");
var $736bb = parcelRequire("736bb");

var $g4UBb = parcelRequire("g4UBb");

var $9ypa9 = parcelRequire("9ypa9");
const $5ec0ed99f7144a60$export$2d5fcba5bbcf0933 = (action$)=>{
    return action$.ofType((0, $1EpSd.CREATE_GROUP_WITH_REQUEST_TYPE)).mergeMap((action)=>{
        const { isProjectSimplified: isProjectSimplified, projectId: projectId, portalId: portalId, groupName: groupName, analyticsEventRequestGroupCreated: analyticsEventRequestGroupCreated, analyticsEventRequestGroupUpdated: analyticsEventRequestGroupUpdated, requestType: requestType, requestGroups: requestGroups, analyticsEventRequestGroupCreatedFailure: analyticsEventRequestGroupCreatedFailure, analyticsEventRequestGroupUpdatedFailure: analyticsEventRequestGroupUpdatedFailure } = action.payload;
        return (0, $60AXd.addRequestGroup)(groupName, projectId).mergeMap((response)=>{
            if (analyticsEventRequestGroupCreated) {
                // Update the analytics event with newly created Request type group's ID as the actionSubjectId
                analyticsEventRequestGroupCreated.update((payload)=>({
                        ...payload,
                        actionSubjectId: response.id
                    }));
                (0, $9ypa9.legacySendEvent)(analyticsEventRequestGroupCreated);
            }
            if (analyticsEventRequestGroupUpdated) // Update the analytics event with newly created Request type group's ID as the actionSubjectId
            analyticsEventRequestGroupUpdated.update((payload)=>({
                    ...payload,
                    actionSubjectId: response.id
                }));
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $gQFbD.getRequestGroupsAction)(projectId, portalId)), (0, $fSYYZ.Observable).of((0, $736bb.setRequestTypeGroupsAction)({
                isProjectSimplified: isProjectSimplified,
                portalId: portalId,
                projectId: projectId,
                requestType: requestType,
                updatedRequestTypeGroupId: response.id,
                analyticsEvent: analyticsEventRequestGroupUpdated,
                requestGroups: [
                    ...requestGroups,
                    response
                ]
            })));
        }).catch((error)=>{
            [
                analyticsEventRequestGroupCreatedFailure,
                analyticsEventRequestGroupUpdatedFailure
            ].filter((x)=>x).forEach((event)=>{
                (0, $9ypa9.legacySendEvent)(event);
            });
            return (0, $fSYYZ.Observable).of(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $1EpSd.createGroupWithRequestTypeFailedAction)((0, $g4UBb.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});
parcelRegister("d8JBM", function(module, exports) {
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE", () => (parcelRequire("1EpSd")).CREATE_GROUP_WITH_REQUEST_TYPE);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED", () => (parcelRequire("1EpSd")).CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_FAILED", () => (parcelRequire("1EpSd")).CREATE_GROUP_WITH_REQUEST_TYPE_FAILED);
$parcel$export(module.exports, "createGroupWithRequestTypeAction", () => (parcelRequire("1EpSd")).createGroupWithRequestTypeAction);
$parcel$export(module.exports, "createGroupWithRequestTypeFailedAction", () => (parcelRequire("1EpSd")).createGroupWithRequestTypeFailedAction);

var $1EpSd = parcelRequire("1EpSd");

});
parcelRegister("1EpSd", function(module, exports) {
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE", () => $bd68b8d6235f9c05$export$c69550447058b57a);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED", () => $bd68b8d6235f9c05$export$c456181637c5858e);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_FAILED", () => $bd68b8d6235f9c05$export$71c9976978aa32b4);
$parcel$export(module.exports, "createGroupWithRequestTypeAction", () => $bd68b8d6235f9c05$export$10336454f9456d40);
$parcel$export(module.exports, "createGroupWithRequestTypeFailedAction", () => $bd68b8d6235f9c05$export$729bba13ddb7a330);
const $bd68b8d6235f9c05$export$c69550447058b57a = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE';
const $bd68b8d6235f9c05$export$c456181637c5858e = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED';
const $bd68b8d6235f9c05$export$71c9976978aa32b4 = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE_FAILED';
const $bd68b8d6235f9c05$export$10336454f9456d40 = (payload)=>({
        payload: payload,
        type: $bd68b8d6235f9c05$export$c69550447058b57a
    });
const $bd68b8d6235f9c05$export$8bd250cf41846ec6 = ()=>({
        type: $bd68b8d6235f9c05$export$c456181637c5858e
    });
const $bd68b8d6235f9c05$export$729bba13ddb7a330 = (message)=>({
        payload: {
            message: message
        },
        type: $bd68b8d6235f9c05$export$71c9976978aa32b4
    });

});


parcelRegister("jD4Sf", function(module, exports) {
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS", () => (parcelRequire("736bb")).SET_REQUEST_TYPE_GROUPS);
$parcel$export(module.exports, "setRequestTypeGroupsAction", () => (parcelRequire("736bb")).setRequestTypeGroupsAction);
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS_FAILED", () => (parcelRequire("736bb")).SET_REQUEST_TYPE_GROUPS_FAILED);
$parcel$export(module.exports, "setRequestTypeGroupsFailedAction", () => (parcelRequire("736bb")).setRequestTypeGroupsFailedAction);

var $736bb = parcelRequire("736bb");

});
parcelRegister("736bb", function(module, exports) {
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS", () => $78cd9fe8c1915766$export$44dbc716b23b5565);
$parcel$export(module.exports, "setRequestTypeGroupsAction", () => $78cd9fe8c1915766$export$9d952046e09fb735);
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS_FAILED", () => $78cd9fe8c1915766$export$509c65d9f883a62a);
$parcel$export(module.exports, "setRequestTypeGroupsFailedAction", () => $78cd9fe8c1915766$export$337a82f6e04125f9);
const $78cd9fe8c1915766$export$44dbc716b23b5565 = 'state.ui.request-types.SET_REQUEST_TYPE_GROUPS';
const $78cd9fe8c1915766$export$9d952046e09fb735 = (payload)=>{
    return {
        payload: payload,
        type: $78cd9fe8c1915766$export$44dbc716b23b5565
    };
};
const $78cd9fe8c1915766$export$509c65d9f883a62a = 'state.ui.request-types.SET_REQUEST_TYPE_GROUPS_FAILED';
const $78cd9fe8c1915766$export$337a82f6e04125f9 = (message)=>({
        payload: {
            message: message
        },
        type: $78cd9fe8c1915766$export$509c65d9f883a62a
    });

});



parcelRegister("38VXc", function(module, exports) {
$parcel$export(module.exports, "deleteRequestTypeFromGroupEpic", () => $06c5c9c8676bcd8b$export$d1c43b1bbe33b61c);

var $fSYYZ = parcelRequire("fSYYZ");

var $7D2jP = parcelRequire("7D2jP");
parcelRequire("5H5gW");
var $f5yEh = parcelRequire("f5yEh");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("by53g");
var $vgnrJ = parcelRequire("vgnrJ");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $9ypa9 = parcelRequire("9ypa9");
const $06c5c9c8676bcd8b$export$d1c43b1bbe33b61c = (action$, store)=>{
    return action$.ofType((0, $f5yEh.DELETE_REQUEST_TYPE_FROM_GROUP)).mergeMap((action)=>{
        const state = store.getState();
        const { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, requestGroupId: requestGroupId, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } = action.payload;
        const updatedRequestGroups = (0, $73V7l.getRequestGroupsForRequestType)({
            state: state,
            portalId: portalId,
            requestTypeId: Number(requestType.id)
        }).filter((requestGroup)=>requestGroup.id !== requestGroupId);
        const body = {
            ...requestType,
            groups: updatedRequestGroups
        };
        return (0, $7D2jP.deleteRequestTypeFromGroup)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            requestGroupId: requestGroupId,
            requestType: body
        }).map(()=>{
            analyticsEvent && (0, $9ypa9.legacySendEvent)(analyticsEvent);
            return (0, $d727K.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch(()=>{
            if (analyticsFailureEvent) (0, $9ypa9.legacySendEvent)(analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $vgnrJ.clearRequestTypesOrderAction)());
        });
    });
};

});
parcelRegister("7D2jP", function(module, exports) {
$parcel$export(module.exports, "requestTypeReorder", () => $ee5d8c3b1b8f9182$export$f7d2151053714646);
$parcel$export(module.exports, "deleteRequestTypeFromGroup", () => $ee5d8c3b1b8f9182$export$4ef0a9afff40ad59);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $7FSs7 = parcelRequire("7FSs7");
const $ee5d8c3b1b8f9182$export$f7d2151053714646 = ({ projectId: projectId, requestTypeId: requestTypeId, requestGroupId: requestGroupId, body: body })=>{
    const uri = `${(0, $7FSs7.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeId}/move`;
    return (0, $breWd.post)(uri, body, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $fSYYZ.Observable).throw(e));
};
const $ee5d8c3b1b8f9182$export$4ef0a9afff40ad59 = ({ isProjectSimplified: isProjectSimplified, projectId: projectId, requestGroupId: requestGroupId, requestType: toUpdate })=>{
    const { id: requestTypeId } = toUpdate;
    if (isProjectSimplified) {
        const nextGenUri = `${(0, $7FSs7.contextPath)}/rest/servicedesk/1/simplified/${projectId}/request-type-groups/${requestGroupId}/${requestTypeId}`;
        return (0, $breWd.doDelete)(nextGenUri, undefined).map(({ response: response })=>response).catch((e)=>(0, $fSYYZ.Observable).throw(e));
    }
    const classicUri = `${(0, $7FSs7.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeId}`;
    return (0, $breWd.put)(classicUri, toUpdate, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $fSYYZ.Observable).throw(e));
};

});

parcelRegister("5H5gW", function(module, exports) {
$parcel$export(module.exports, "DELETE_REQUEST_TYPE_FROM_GROUP", () => (parcelRequire("f5yEh")).DELETE_REQUEST_TYPE_FROM_GROUP);
$parcel$export(module.exports, "deleteRequestTypeFromGroupAction", () => (parcelRequire("f5yEh")).deleteRequestTypeFromGroupAction);
parcelRequire("f5yEh");

});
parcelRegister("f5yEh", function(module, exports) {
$parcel$export(module.exports, "DELETE_REQUEST_TYPE_FROM_GROUP", () => $f480d4375162f40e$export$37d5cf3470d18d4a);
$parcel$export(module.exports, "deleteRequestTypeFromGroupAction", () => $f480d4375162f40e$export$dd2f56a17442f2c4);
const $f480d4375162f40e$export$37d5cf3470d18d4a = 'epic.request-types.DELETE_REQUEST_TYPE_FROM_GROUP';
const $f480d4375162f40e$export$dd2f56a17442f2c4 = (payload)=>({
        payload: payload,
        type: $f480d4375162f40e$export$37d5cf3470d18d4a
    });

});



parcelRegister("jGbgC", function(module, exports) {
$parcel$export(module.exports, "reorderRequestTypeEpic", () => $67b31a1035cd20e5$export$efb6288a30e93a3a);

var $fSYYZ = parcelRequire("fSYYZ");

var $7D2jP = parcelRequire("7D2jP");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("by53g");
var $vgnrJ = parcelRequire("vgnrJ");
parcelRequire("3GnbM");
var $asEDQ = parcelRequire("asEDQ");

var $9ypa9 = parcelRequire("9ypa9");
const $67b31a1035cd20e5$export$efb6288a30e93a3a = (action$)=>action$.ofType((0, $asEDQ.REORDER_REQUEST_TYPE)).mergeMap(({ payload: { portalId: portalId, projectId: projectId, requestTypeId: requestTypeId, requestGroupId: requestGroupId, fromIndex: fromIndex, toIndex: toIndex, requestTypes: requestTypes, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const body = $67b31a1035cd20e5$var$getReorderPayload({
            requestTypes: requestTypes,
            fromIndex: fromIndex,
            toIndex: toIndex,
            projectId: projectId,
            requestGroupId: requestGroupId
        });
        return (0, $7D2jP.requestTypeReorder)({
            requestTypeId: requestTypeId,
            projectId: projectId,
            requestGroupId: requestGroupId,
            body: body
        }).map(()=>{
            analyticsEvent && (0, $9ypa9.legacySendEvent)(analyticsEvent);
            return (0, $d727K.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch(()=>{
            if (analyticsFailureEvent) (0, $9ypa9.legacySendEvent)(analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $vgnrJ.clearRequestTypesOrderAction)());
        });
    });
// The POST endpoint for reordering request types expects the body payload of POST request to look like:
// { position: 'First' } - when dragging a request type to the top of the list
// and { after: [url + requestTypeId] } - where requestTypeId is the id of the request type which the dragged req type will be under.
function $67b31a1035cd20e5$var$getReorderPayload({ requestTypes: requestTypes, projectId: projectId, requestGroupId: requestGroupId, fromIndex: fromIndex, toIndex: toIndex }) {
    if (toIndex === 0) return {
        position: 'First'
    };
    let requestTypeAfter;
    if (toIndex < fromIndex) // if we're dragging UP the list we want it to set 'after' to the item above
    requestTypeAfter = requestTypes[toIndex - 1];
    else requestTypeAfter = requestTypes[toIndex];
    return {
        after: `/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeAfter.id}`
    };
}

});
parcelRegister("3GnbM", function(module, exports) {
$parcel$export(module.exports, "REORDER_REQUEST_TYPE", () => (parcelRequire("asEDQ")).REORDER_REQUEST_TYPE);
$parcel$export(module.exports, "reorderRequestTypeAction", () => (parcelRequire("asEDQ")).reorderRequestTypeAction);
parcelRequire("asEDQ");

});
parcelRegister("asEDQ", function(module, exports) {
$parcel$export(module.exports, "REORDER_REQUEST_TYPE", () => $96c60ee90c25c0c5$export$46dd7d5218860986);
$parcel$export(module.exports, "reorderRequestTypeAction", () => $96c60ee90c25c0c5$export$f0a9fcf0696aeebb);
const $96c60ee90c25c0c5$export$46dd7d5218860986 = 'epic.request-types.REORDER_REQUEST_TYPE';
const $96c60ee90c25c0c5$export$f0a9fcf0696aeebb = (payload)=>({
        payload: payload,
        type: $96c60ee90c25c0c5$export$46dd7d5218860986
    });

});



parcelRegister("7T5tP", function(module, exports) {
$parcel$export(module.exports, "setRequestTypeGroupsEpic", () => $cfc44e16b5acb69c$export$da9fdc969ff1b05d);

var $fSYYZ = parcelRequire("fSYYZ");

var $acB4r = parcelRequire("acB4r");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("jD4Sf");
var $736bb = parcelRequire("736bb");

var $g4UBb = parcelRequire("g4UBb");

var $9ypa9 = parcelRequire("9ypa9");
const $cfc44e16b5acb69c$var$getIconIdFromIconUrl = (iconUrl)=>iconUrl.substring(iconUrl.lastIndexOf('=') + 1, iconUrl.length);
const $cfc44e16b5acb69c$var$getSanitizedText = (html)=>{
    const stripHtmlTagsRegex = /(<([^>]+)>)/gi;
    return html.replace(stripHtmlTagsRegex, '');
};
const $cfc44e16b5acb69c$var$getSerializedRequestTypeWithRequestGroups = (requestType, requestGroups)=>({
        id: requestType.id,
        name: requestType.name,
        // Can remove after https://jdog.jira-dev.com/browse/JDW-292
        icon: $cfc44e16b5acb69c$var$getIconIdFromIconUrl(requestType.iconUrl),
        iconUrl: requestType.iconUrl,
        description: $cfc44e16b5acb69c$var$getSanitizedText(requestType.descriptionHtml),
        groups: requestGroups
    });
const $cfc44e16b5acb69c$export$da9fdc969ff1b05d = (action$)=>{
    return action$.ofType((0, $736bb.SET_REQUEST_TYPE_GROUPS)).mergeMap(({ payload: { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, updatedRequestTypeGroupId: updatedRequestTypeGroupId, requestGroups: requestGroups, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        return (0, $acB4r.setRequestGroupsForRequestType)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            updatedRequestTypeGroupId: updatedRequestTypeGroupId,
            requestGroupId: 'hidden',
            requestType: $cfc44e16b5acb69c$var$getSerializedRequestTypeWithRequestGroups(requestType, requestGroups)
        }).map(()=>{
            if (analyticsEvent) (0, $9ypa9.legacySendEvent)(analyticsEvent);
            return (0, $d727K.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $9ypa9.legacySendEvent)(analyticsFailureEvent);
            return (0, $fSYYZ.Observable).of((0, $736bb.setRequestTypeGroupsFailedAction)((0, $g4UBb.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});

parcelRegister("dXTIL", function(module, exports) {
$parcel$export(module.exports, "resendVerifyEmailEpic", () => $ef85eb6af70c8ef5$export$a8c26f01f6ef2d73);

var $fSYYZ = parcelRequire("fSYYZ");

var $HQzpg = parcelRequire("HQzpg");
parcelRequire("9gVYw");
var $ksbxD = parcelRequire("ksbxD");
const $ef85eb6af70c8ef5$export$a8c26f01f6ef2d73 = (action$)=>{
    return action$.ofType((0, $ksbxD.FETCH_RESEND_VERIFY_EMAIL)).mergeMap((action)=>{
        const { emailAddress: emailAddress, portalId: portalId } = action.payload.params;
        const errorResponse = {
            status: 503
        };
        return (0, $HQzpg.resendVerifyEmail)(emailAddress, portalId).map((response)=>{
            if (response.status === 204) return (0, $ksbxD.fetchResendVerificationSuccess)();
            return (0, $ksbxD.fetchResendVerificationFailure)(errorResponse);
        }).catch((error)=>(0, $fSYYZ.Observable).of((0, $ksbxD.fetchResendVerificationFailure)(error)));
    });
};

});
parcelRegister("HQzpg", function(module, exports) {
$parcel$export(module.exports, "resendVerifyEmail", () => $29c19c286792cb6a$export$da8af7e7b05b444);

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $29c19c286792cb6a$var$getResendVerifyEmailRequestBody = (email, portalId)=>({
        email: email,
        verificationContext: {
            portalId: portalId
        }
    });
const $29c19c286792cb6a$export$da8af7e7b05b444 = (email, portalId)=>{
    const uri = `${(0, $7FSs7.contextPath)}/rest/servicedesk/1/customer/pages/user/resend-verification-email`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const body = $29c19c286792cb6a$var$getResendVerifyEmailRequestBody(email, portalId);
    return (0, $breWd.post)(uri, body, headers);
};

});

parcelRegister("9gVYw", function(module, exports) {
$parcel$export(module.exports, "fetchResendVerifyEmailAction", () => (parcelRequire("ksbxD")).fetchResendVerifyEmailAction);
$parcel$export(module.exports, "fetchResendVerificationFailure", () => (parcelRequire("ksbxD")).fetchResendVerificationFailure);
$parcel$export(module.exports, "fetchResendVerificationSuccess", () => (parcelRequire("ksbxD")).fetchResendVerificationSuccess);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_FAILURE", () => (parcelRequire("ksbxD")).FETCH_RESEND_VERIFICATION_FAILURE);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_SUCCESS", () => (parcelRequire("ksbxD")).FETCH_RESEND_VERIFICATION_SUCCESS);
$parcel$export(module.exports, "FETCH_RESEND_VERIFY_EMAIL", () => (parcelRequire("ksbxD")).FETCH_RESEND_VERIFY_EMAIL);

var $ksbxD = parcelRequire("ksbxD");

});
parcelRegister("ksbxD", function(module, exports) {
$parcel$export(module.exports, "FETCH_RESEND_VERIFY_EMAIL", () => $3f83980d4847cb05$export$c41322ca6fdfdd1f);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_FAILURE", () => $3f83980d4847cb05$export$5d8d6d17a7bb9f46);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_SUCCESS", () => $3f83980d4847cb05$export$7517f0d1f77dd091);
$parcel$export(module.exports, "fetchResendVerifyEmailAction", () => $3f83980d4847cb05$export$33f84eb26dff7a8d);
$parcel$export(module.exports, "fetchResendVerificationSuccess", () => $3f83980d4847cb05$export$548d04925c9d810e);
$parcel$export(module.exports, "fetchResendVerificationFailure", () => $3f83980d4847cb05$export$ccba2c058636a09f);
const $3f83980d4847cb05$export$c41322ca6fdfdd1f = 'epic.verify-email.FETCH_RESEND_VERIFY_EMAIL';
const $3f83980d4847cb05$export$5d8d6d17a7bb9f46 = 'state.ui.resendVerifyEmail.FAILED';
const $3f83980d4847cb05$export$7517f0d1f77dd091 = 'state.ui.resendVerifyEmail.SUCCEEDED';
const $3f83980d4847cb05$export$33f84eb26dff7a8d = ({ emailAddress: emailAddress, portalId: portalId })=>{
    return {
        type: $3f83980d4847cb05$export$c41322ca6fdfdd1f,
        payload: {
            params: {
                emailAddress: emailAddress,
                portalId: portalId
            }
        }
    };
};
const $3f83980d4847cb05$export$548d04925c9d810e = ()=>({
        type: $3f83980d4847cb05$export$7517f0d1f77dd091
    });
const $3f83980d4847cb05$export$ccba2c058636a09f = (error)=>({
        type: $3f83980d4847cb05$export$5d8d6d17a7bb9f46,
        payload: {
            error: error
        }
    });

});



parcelRegister("cqrFQ", function(module, exports) {
$parcel$export(module.exports, "resetPasswordEpic", () => $a75acb9f127eb93f$export$eb399c940b1a806e);

var $fSYYZ = parcelRequire("fSYYZ");

var $96EVY = parcelRequire("96EVY");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");
parcelRequire("4eQmN");
var $6v1bD = parcelRequire("6v1bD");

var $g4UBb = parcelRequire("g4UBb");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");
const $a75acb9f127eb93f$export$eb399c940b1a806e = (action$)=>{
    return action$.ofType((0, $6v1bD.RESET_PASSWORD)).mergeMap((resetPasswordAction)=>{
        const { emailAddress: emailAddress, password: password, token: token, resetPasswordJwt: resetPasswordJwt, createAnalyticsEvent: createAnalyticsEvent, redirectUrl: redirectUrl } = resetPasswordAction.payload;
        return (0, $96EVY.resetPassword)({
            emailAddress: emailAddress,
            password: password,
            token: token,
            resetPasswordJwt: resetPasswordJwt
        }).map(()=>{
            return (0, $uiV1X.loginAttempt)({
                password: password,
                email: emailAddress,
                continueParam: redirectUrl ?? null
            });
        }).catch((error)=>{
            if (createAnalyticsEvent && error.status === 400) {
                const event = createAnalyticsEvent({
                    analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                    actionSubject: 'submitNewPassword',
                    action: 'failed'
                });
                (0, $9ypa9.legacySendEvent)(event);
            }
            return (0, $fSYYZ.Observable).of((0, $6v1bD.resetPasswordFailure)((0, $g4UBb.getDefaultError)(error)));
        });
    });
};

});
parcelRegister("96EVY", function(module, exports) {
$parcel$export(module.exports, "resetPassword", () => $faa783a4ba7d97d6$export$dc726c8e334dd814);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $7FSs7 = parcelRequire("7FSs7");
const $faa783a4ba7d97d6$export$dc726c8e334dd814 = (params)=>{
    const { emailAddress: emailAddress, password: password, resetPasswordJwt: resetPasswordJwt, token: token, context: context = (0, $7FSs7.contextPath) } = params;
    const uri = resetPasswordJwt ? `${context}/rest/servicedesk/1/customer/pages/user/resetpassword?jwt=${resetPasswordJwt}` : `${context}/rest/servicedesk/1/customer/pages/user/resetpassword`;
    const body = {
        emailAddress: emailAddress,
        password: password,
        ...token.length > 0 ? {
            token: token
        } : {}
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $breWd.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $fSYYZ.Observable).throw(e));
};

});

parcelRegister("4eQmN", function(module, exports) {
$parcel$export(module.exports, "RESET_PASSWORD", () => (parcelRequire("6v1bD")).RESET_PASSWORD);
$parcel$export(module.exports, "RESET_PASSWORD_FAILURE", () => (parcelRequire("6v1bD")).RESET_PASSWORD_FAILURE);
$parcel$export(module.exports, "resetPassword", () => (parcelRequire("6v1bD")).resetPassword);
$parcel$export(module.exports, "resetPasswordFailure", () => (parcelRequire("6v1bD")).resetPasswordFailure);

var $6v1bD = parcelRequire("6v1bD");

});
parcelRegister("6v1bD", function(module, exports) {
$parcel$export(module.exports, "RESET_PASSWORD", () => $40e5970b60a92849$export$bf768f070251ce56);
$parcel$export(module.exports, "RESET_PASSWORD_FAILURE", () => $40e5970b60a92849$export$682377d29726ee75);
$parcel$export(module.exports, "resetPassword", () => $40e5970b60a92849$export$dc726c8e334dd814);
$parcel$export(module.exports, "resetPasswordFailure", () => $40e5970b60a92849$export$70c45c9f946d241a);
const $40e5970b60a92849$export$bf768f070251ce56 = 'state.persisted.RESET_PASSWORD';
const $40e5970b60a92849$export$682377d29726ee75 = 'state.persisted.RESET_PASSWORD_FAILURE';
const $40e5970b60a92849$export$dc726c8e334dd814 = (emailAddress, password, token, resetPasswordJwt, createAnalyticsEvent, redirectUrl)=>({
        payload: {
            emailAddress: emailAddress,
            password: password,
            token: token,
            resetPasswordJwt: resetPasswordJwt,
            createAnalyticsEvent: createAnalyticsEvent,
            redirectUrl: redirectUrl
        },
        type: $40e5970b60a92849$export$bf768f070251ce56
    });
const $40e5970b60a92849$export$70c45c9f946d241a = (error)=>({
        payload: {
            error: error
        },
        type: $40e5970b60a92849$export$682377d29726ee75
    });

});



parcelRegister("erSSa", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf9f3b8a4f98ec02$export$2e2bcd8739ae039);
parcelRequire("durY1");
var $fPmNS = parcelRequire("fPmNS");

var $4RlTr = parcelRequire("4RlTr");

var $d2PvY = parcelRequire("d2PvY");

var $lLIGf = parcelRequire("lLIGf");
var $cf9f3b8a4f98ec02$export$2e2bcd8739ae039 = (0, $fPmNS.combineEpics)((0, $d2PvY.default), (0, $4RlTr.default), (0, $lLIGf.searchEpic), (0, $lLIGf.fetchSearchResultsEpic), (0, $lLIGf.fetchKbSearchResultsEpic));

});
parcelRegister("4RlTr", function(module, exports) {
$parcel$export(module.exports, "context", () => $d7918cec172af8c6$export$a078c61943f9dbbe);
$parcel$export(module.exports, "default", () => $d7918cec172af8c6$export$2e2bcd8739ae039);

var $fSYYZ = parcelRequire("fSYYZ");
parcelRequire("fzkqG");
var $6Tan6 = parcelRequire("6Tan6");

var $7FSs7 = parcelRequire("7FSs7");

var $2Np0t = parcelRequire("2Np0t");
const $d7918cec172af8c6$export$a078c61943f9dbbe = 'from-location';
const $d7918cec172af8c6$var$epic = (_, store)=>{
    return (0, $7FSs7.historyObservable).mergeMap(({ action: action })=>{
        const queryParams = $2Np0t.getAll();
        const hasQueryParams = queryParams && queryParams.hasOwnProperty && queryParams.hasOwnProperty('q');
        if (action === 'POP') {
            if (hasQueryParams) return (0, $fSYYZ.Observable).of($6Tan6.search(queryParams.q, {
                context: $d7918cec172af8c6$export$a078c61943f9dbbe,
                time: queryParams.time ? +queryParams.time : null
            }));
        }
        if (action === 'PUSH') {
            if (hasQueryParams) return (0, $fSYYZ.Observable).of($6Tan6.updateSearch(queryParams.q, {
                context: $d7918cec172af8c6$export$a078c61943f9dbbe,
                time: queryParams.time ? +queryParams.time : null
            }));
        }
        if (!hasQueryParams) {
            const state = store.getState();
            if (state.ui.search.shown) return (0, $fSYYZ.Observable).of($6Tan6.showSearch(false, {
                context: $d7918cec172af8c6$export$a078c61943f9dbbe
            }));
            return (0, $fSYYZ.Observable).empty();
        }
        return (0, $fSYYZ.Observable).empty();
    });
};
var $d7918cec172af8c6$export$2e2bcd8739ae039 = $d7918cec172af8c6$var$epic;

});
parcelRegister("fzkqG", function(module, exports) {
$parcel$export(module.exports, "SEARCH", () => (parcelRequire("6Tan6")).SEARCH);
$parcel$export(module.exports, "search", () => (parcelRequire("6Tan6")).search);
$parcel$export(module.exports, "resetSearch", () => (parcelRequire("6Tan6")).resetSearch);
$parcel$export(module.exports, "RESET_SEARCH", () => (parcelRequire("6Tan6")).RESET_SEARCH);
$parcel$export(module.exports, "SHOW_SEARCH", () => (parcelRequire("6Tan6")).SHOW_SEARCH);
$parcel$export(module.exports, "showSearch", () => (parcelRequire("6Tan6")).showSearch);
$parcel$export(module.exports, "CLEAR_SEARCH_RESULTS", () => (parcelRequire("6Tan6")).CLEAR_SEARCH_RESULTS);
$parcel$export(module.exports, "clearSearchResults", () => (parcelRequire("6Tan6")).clearSearchResults);
$parcel$export(module.exports, "FETCH_SEARCH_RESULTS", () => (parcelRequire("6Tan6")).FETCH_SEARCH_RESULTS);
$parcel$export(module.exports, "fetchSearchResultsAction", () => (parcelRequire("6Tan6")).fetchSearchResultsAction);
$parcel$export(module.exports, "FETCH_KB_SEARCH_RESULTS", () => (parcelRequire("6Tan6")).FETCH_KB_SEARCH_RESULTS);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS", () => (parcelRequire("6Tan6")).UPDATE_SEARCH_RESULTS);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS_BY_TYPE", () => (parcelRequire("6Tan6")).UPDATE_SEARCH_RESULTS_BY_TYPE);
$parcel$export(module.exports, "updateSearchResultsByType", () => (parcelRequire("6Tan6")).updateSearchResultsByType);
$parcel$export(module.exports, "UPDATE_SEARCH", () => (parcelRequire("6Tan6")).UPDATE_SEARCH);
$parcel$export(module.exports, "updateSearch", () => (parcelRequire("6Tan6")).updateSearch);

var $6Tan6 = parcelRequire("6Tan6");

});
parcelRegister("6Tan6", function(module, exports) {
$parcel$export(module.exports, "SHOW_SEARCH", () => $465e1e1e23d98f9a$export$c3d32479efe3cefd);
$parcel$export(module.exports, "SEARCH", () => $465e1e1e23d98f9a$export$a6b9aaee40d49fd0);
$parcel$export(module.exports, "RESET_SEARCH", () => $465e1e1e23d98f9a$export$1357260dfbbdd047);
$parcel$export(module.exports, "FETCH_KB_SEARCH_RESULTS", () => $465e1e1e23d98f9a$export$51c1b519f9597fb6);
$parcel$export(module.exports, "FETCH_SEARCH_RESULTS", () => $465e1e1e23d98f9a$export$ada24bdba9b1de5);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS", () => $465e1e1e23d98f9a$export$41015fa2c6363474);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS_BY_TYPE", () => $465e1e1e23d98f9a$export$83fbaab84674965e);
$parcel$export(module.exports, "CLEAR_SEARCH_RESULTS", () => $465e1e1e23d98f9a$export$e8fd6ac9f3290dd1);
$parcel$export(module.exports, "UPDATE_SEARCH", () => $465e1e1e23d98f9a$export$e88baa2479d0f7d);
$parcel$export(module.exports, "fetchSearchResultsAction", () => $465e1e1e23d98f9a$export$e6c9557a57e930cb);
$parcel$export(module.exports, "showSearch", () => $465e1e1e23d98f9a$export$6a74a1717b2c4c0);
$parcel$export(module.exports, "resetSearch", () => $465e1e1e23d98f9a$export$f4d94e8b97ed073f);
$parcel$export(module.exports, "search", () => $465e1e1e23d98f9a$export$d76128d007d19019);
$parcel$export(module.exports, "updateSearchResultsByType", () => $465e1e1e23d98f9a$export$d929024984f1b2ad);
$parcel$export(module.exports, "clearSearchResults", () => $465e1e1e23d98f9a$export$20893a65977b35d3);
$parcel$export(module.exports, "updateSearch", () => $465e1e1e23d98f9a$export$b14c90fc27f0b629);
const $465e1e1e23d98f9a$export$c3d32479efe3cefd = 'ui.search.SHOW_SEARCH';
const $465e1e1e23d98f9a$export$a6b9aaee40d49fd0 = 'ui.search.SEARCH';
const $465e1e1e23d98f9a$export$1357260dfbbdd047 = 'ui.search.RESET_SEARCH';
const $465e1e1e23d98f9a$export$51c1b519f9597fb6 = 'epic.search.FETCH_KB_SEARCH_RESULTS';
const $465e1e1e23d98f9a$export$ada24bdba9b1de5 = 'epic.search.FETCH_SEARCH_RESULTS';
const $465e1e1e23d98f9a$export$41015fa2c6363474 = 'ui.search.UPDATE_SEARCH_RESULTS';
const $465e1e1e23d98f9a$export$83fbaab84674965e = 'ui.search.UPDATE_SEARCH_RESULTS_BY_TYPE';
const $465e1e1e23d98f9a$export$e8fd6ac9f3290dd1 = 'ui.search.CLEAR_SEARCH_RESULTS';
const $465e1e1e23d98f9a$export$e88baa2479d0f7d = 'ui.search.UPDATE_SEARCH';
const $465e1e1e23d98f9a$export$e6c9557a57e930cb = (term, searchStartTime, meta)=>({
        payload: {
            term: term,
            searchStartTime: searchStartTime,
            meta: meta
        },
        type: $465e1e1e23d98f9a$export$ada24bdba9b1de5
    });
const $465e1e1e23d98f9a$export$6a74a1717b2c4c0 = (show, options = {})=>({
        payload: {
            show: show,
            ...options
        },
        type: $465e1e1e23d98f9a$export$c3d32479efe3cefd
    });
const $465e1e1e23d98f9a$export$f4d94e8b97ed073f = ()=>({
        type: $465e1e1e23d98f9a$export$1357260dfbbdd047
    });
const $465e1e1e23d98f9a$export$d76128d007d19019 = (term, { time: time = Date.now(), show: show = true, ...options } = {}, meta)=>({
        type: $465e1e1e23d98f9a$export$a6b9aaee40d49fd0,
        payload: {
            term: term,
            time: time,
            show: show,
            ...options,
            meta: meta
        }
    });
const $465e1e1e23d98f9a$export$1ef413033527da6d = ({ term: term, limit: limit, expandPortal: expandPortal, meta: meta, categoryIds: categoryIds, portalIds: portalIds })=>{
    return {
        type: $465e1e1e23d98f9a$export$51c1b519f9597fb6,
        payload: {
            term: term,
            limit: limit,
            expandPortal: expandPortal,
            categoryIds: categoryIds,
            portalIds: portalIds,
            meta: meta
        }
    };
};
//export type SearchType = 'portals' | 'requestTypes' | 'kbs';
const $465e1e1e23d98f9a$var$searchTypes = [
    'portals',
    'requestTypes',
    'kbs'
];
const $465e1e1e23d98f9a$export$d929024984f1b2ad = (searchResult, searchType)=>({
        searchType: searchType,
        type: $465e1e1e23d98f9a$export$83fbaab84674965e,
        payload: searchResult
    });
const $465e1e1e23d98f9a$export$20893a65977b35d3 = ()=>({
        type: $465e1e1e23d98f9a$export$e8fd6ac9f3290dd1
    });
const $465e1e1e23d98f9a$export$b14c90fc27f0b629 = (term, { time: time = Date.now(), show: show = true, ...options } = {})=>({
        type: $465e1e1e23d98f9a$export$e88baa2479d0f7d,
        payload: {
            term: term,
            time: time,
            show: show,
            ...options
        }
    });

});



parcelRegister("d2PvY", function(module, exports) {
$parcel$export(module.exports, "default", () => $acfdcbab38621b19$export$2e2bcd8739ae039);
parcelRequire("fzkqG");
var $6Tan6 = parcelRequire("6Tan6");

var $2Np0t = parcelRequire("2Np0t");

var $4RlTr = parcelRequire("4RlTr");
const $acfdcbab38621b19$var$isValidSearchAction = (action)=>(action.type === (0, $6Tan6.SHOW_SEARCH) || action.type === (0, $6Tan6.SEARCH) || action.type === (0, $6Tan6.UPDATE_SEARCH)) && action.payload.context !== (0, $4RlTr.context);
const $acfdcbab38621b19$var$setSearchQueryParams = (term, replaceRoute = false)=>{
    $2Np0t.set({
        q: term
    }, replaceRoute);
};
const $acfdcbab38621b19$var$epic = (action$, store)=>{
    return action$.filter($acfdcbab38621b19$var$isValidSearchAction).do((action)=>{
        if ((action.type === (0, $6Tan6.SEARCH) || action.type === (0, $6Tan6.UPDATE_SEARCH)) && action.payload.show) {
            const shouldReplaceRoute = $2Np0t.get('q') !== undefined;
            $acfdcbab38621b19$var$setSearchQueryParams(action.payload.term, shouldReplaceRoute);
            return;
        }
        if (action.type === (0, $6Tan6.SHOW_SEARCH)) {
            if (action.payload.show) {
                const state = store.getState();
                if (state.ui.search.term) {
                    $acfdcbab38621b19$var$setSearchQueryParams(state.ui.search.term);
                    return;
                }
                $acfdcbab38621b19$var$setSearchQueryParams('');
                return;
            }
            $acfdcbab38621b19$var$setSearchQueryParams(undefined);
        }
    }).ignoreElements();
};
var $acfdcbab38621b19$export$2e2bcd8739ae039 = $acfdcbab38621b19$var$epic;

});

parcelRegister("lLIGf", function(module, exports) {
$parcel$export(module.exports, "searchEpic", () => $c39099f6e97eb736$export$54e39fbf71be6145);
$parcel$export(module.exports, "fetchSearchResultsEpic", () => $c39099f6e97eb736$export$afbb5f5d68ce3b2b);
$parcel$export(module.exports, "fetchKbSearchResultsEpic", () => $c39099f6e97eb736$export$afb8d00d671f0126);
/**
 * Epic for performing the search request
 */ 
var $8rTkC = parcelRequire("8rTkC");

var $fSYYZ = parcelRequire("fSYYZ");
parcelRequire("fzkqG");
var $6Tan6 = parcelRequire("6Tan6");

var $6UbBF = parcelRequire("6UbBF");
const $c39099f6e97eb736$var$SEARCH_PROVIDERS = [
    (0, $6UbBF.KbSearchProvider),
    (0, $6UbBF.RequestTypeSearchProvider),
    (0, $6UbBF.PortalSearchProvider)
];
const $c39099f6e97eb736$export$54e39fbf71be6145 = (action$)=>{
    return action$.ofType((0, $6Tan6.SEARCH)).map((action)=>{
        const { meta: meta, term: query } = action.payload;
        if (!query || query.trim() === '') return (0, $6Tan6.clearSearchResults)();
        return (0, $6Tan6.fetchSearchResultsAction)(query, performance.now(), meta);
    });
};
const $c39099f6e97eb736$export$afbb5f5d68ce3b2b = (action$, store)=>{
    return action$.ofType((0, $6Tan6.FETCH_SEARCH_RESULTS)).debounceTime((0, $8rTkC.USER_TYPING_DEBOUNCE_TIME)).switchMap((fetchAction)=>{
        // This cast is necessary otherwise TS doesn't know that this action can only be a FetchSearchResultsAction
        const action = fetchAction;
        const state = store.getState();
        const { term: term, meta: meta } = action.payload;
        const observablesToWaitFor = $c39099f6e97eb736$var$SEARCH_PROVIDERS.map((provider)=>provider.execute(term, state, meta));
        return (0, $fSYYZ.Observable).from(observablesToWaitFor).mergeMap((observable)=>{
            return observable.map((response)=>(0, $6Tan6.updateSearchResultsByType)(response, Object.keys(response)[0]));
        });
    }).takeUntil(action$.ofType((0, $6Tan6.CLEAR_SEARCH_RESULTS))).repeat();
};
const $c39099f6e97eb736$export$afb8d00d671f0126 = (action$, store)=>{
    return action$.ofType((0, $6Tan6.FETCH_KB_SEARCH_RESULTS)).debounceTime((0, $8rTkC.USER_TYPING_DEBOUNCE_TIME)).switchMap((fetchAction)=>{
        const action = fetchAction;
        const state = store.getState();
        const { term: term, meta: meta, limit: limit, expandPortal: expandPortal, categoryIds: categoryIds, portalIds: portalIds } = action.payload;
        return (0, $6UbBF.KbSearchProvider).execute(term, state, meta, limit, expandPortal, categoryIds, portalIds).map((response)=>(0, $6Tan6.updateSearchResultsByType)(response, Object.keys(response)[0]));
    }).takeUntil(action$.ofType((0, $6Tan6.CLEAR_SEARCH_RESULTS))).repeat();
};

});
parcelRegister("6UbBF", function(module, exports) {
$parcel$export(module.exports, "KbSearchProvider", () => $50c925e7aff6ec0a$export$96508bc27743153d);
$parcel$export(module.exports, "RequestTypeSearchProvider", () => $50c925e7aff6ec0a$export$836cf63ac20b672f);
$parcel$export(module.exports, "PortalSearchProvider", () => $50c925e7aff6ec0a$export$c437cd06ecaa9215);

var $fSYYZ = parcelRequire("fSYYZ");

var $hldsh = parcelRequire("hldsh");
var $bss3b = parcelRequire("bss3b");
var $6tm15 = parcelRequire("6tm15");
parcelRequire("2tsrb");
var $7IL12 = parcelRequire("7IL12");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $9ypa9 = parcelRequire("9ypa9");

var $fonw6 = parcelRequire("fonw6");
const $50c925e7aff6ec0a$export$1e7a22c99c64fffc = 30;
const $50c925e7aff6ec0a$export$96508bc27743153d = {
    execute: (query, state, meta, resultLimit, expandPortal, categoryIds, portalIds)=>{
        const DEFAULT_MAX_KB_RESULTS_IN_SEARCH_MODAL = 8;
        return $50c925e7aff6ec0a$var$searchKbSuppressError(query.trim(), state, resultLimit || DEFAULT_MAX_KB_RESULTS_IN_SEARCH_MODAL, meta, expandPortal, categoryIds, portalIds);
    }
};
const $50c925e7aff6ec0a$var$searchKbSuppressError = (query, state, resultLimit, meta, expandPortal, categoryIds, portalIds)=>{
    const portalId = (0, $7IL12.getPortalId)(state);
    const projectId = (0, $73V7l.getProjectId)(state, portalId);
    if (portalId) {
        // If the portal model is available and the kb is disabled then we will not make the kb search request.
        // i.e. if there is no portal model we will still make a kb request regardless
        if ((0, $73V7l.getIsPortalLoaded)(state, portalId) && !(0, $73V7l.getIsKbEnabled)(state, portalId)) return (0, $fSYYZ.Observable).of({
            kbs: {
                articles: [],
                totalSize: 0
            }
        });
    } else if ((0, $ikoP4.getIsLoaded)(state) && !(0, $ikoP4.getIsKbEnabled)(state)) // We will only NOT make a KB search request if the help center is loaded and kb is disabled
    return (0, $fSYYZ.Observable).of({
        kbs: {
            articles: [],
            totalSize: 0
        }
    });
    const kbsQuery = {
        categoryIds: categoryIds,
        portalIds: portalIds,
        query: query,
        projectId: projectId,
        resultLimit: resultLimit,
        expandPortalName: expandPortal
    };
    return (0, $hldsh.searchKbs)(kbsQuery).map((response)=>{
        var _meta$analyticsSucces;
        if (meta !== null && meta !== void 0 && (_meta$analyticsSucces = meta.analyticsSuccessEvent) !== null && _meta$analyticsSucces !== void 0 && _meta$analyticsSucces.kb) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent.kb);
        return {
            kbs: response
        };
    }).catch((error)=>{
        var _meta$analyticsFailur;
        if (meta !== null && meta !== void 0 && (_meta$analyticsFailur = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur !== void 0 && _meta$analyticsFailur.kb && !(0, $fonw6.isNetworkOrClientErrorCode)(error.status)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent.kb);
        return (0, $fSYYZ.Observable).of({
            kbs: {
                articles: [],
                totalSize: 0
            }
        });
    });
};
const $50c925e7aff6ec0a$export$836cf63ac20b672f = {
    execute: (query, state, meta)=>{
        var _performance;
        const DEFAULT_MAX_RT_RESULTS = 5;
        const requestTypeQuery = {
            query: query,
            resultLimit: DEFAULT_MAX_RT_RESULTS,
            includeRequestTypesFromOtherPortals: true,
            serviceDeskId: (0, $7IL12.getPortalId)(state)
        };
        const start = (_performance = performance) === null || _performance === void 0 ? void 0 : _performance.now();
        return (0, $6tm15.searchRequestTypes)(requestTypeQuery).map((response)=>{
            var _meta$analyticsSucces2;
            const uiAnalyticsEvent = meta === null || meta === void 0 || (_meta$analyticsSucces2 = meta.analyticsSuccessEvent) === null || _meta$analyticsSucces2 === void 0 ? void 0 : _meta$analyticsSucces2.requestType;
            uiAnalyticsEvent === null || uiAnalyticsEvent === void 0 || uiAnalyticsEvent.update((payload)=>{
                var _performance2;
                return {
                    ...payload,
                    timeTaken: ((_performance2 = performance) === null || _performance2 === void 0 ? void 0 : _performance2.now()) - start
                };
            });
            if (uiAnalyticsEvent) (0, $9ypa9.legacySendEvent)(uiAnalyticsEvent);
            return {
                requestTypes: response
            };
        }).catch((error)=>{
            var _meta$analyticsFailur2;
            if (meta !== null && meta !== void 0 && (_meta$analyticsFailur2 = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur2 !== void 0 && _meta$analyticsFailur2.requestType && !(0, $fonw6.isNetworkOrClientErrorCode)(error.status)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent.requestType);
            return (0, $fSYYZ.Observable).of({
                requestTypes: []
            });
        });
    }
};
const $50c925e7aff6ec0a$export$c437cd06ecaa9215 = {
    execute: (query, state, meta)=>{
        const DEFAULT_MAX_PORTAL_RESULTS = 3;
        const portalQuery = {
            query: query,
            limit: DEFAULT_MAX_PORTAL_RESULTS,
            excludedPortalId: (0, $7IL12.getPortalId)(state)
        };
        return (0, $bss3b.searchPortals)(portalQuery).map((response)=>{
            var _meta$analyticsSucces3;
            if (meta !== null && meta !== void 0 && (_meta$analyticsSucces3 = meta.analyticsSuccessEvent) !== null && _meta$analyticsSucces3 !== void 0 && _meta$analyticsSucces3.portal) (0, $9ypa9.legacySendEvent)(meta.analyticsSuccessEvent.portal);
            return {
                portals: response
            };
        }).catch((error)=>{
            var _meta$analyticsFailur3;
            if (meta !== null && meta !== void 0 && (_meta$analyticsFailur3 = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur3 !== void 0 && _meta$analyticsFailur3.portal && !(0, $fonw6.isNetworkOrClientErrorCode)(error.status)) (0, $9ypa9.legacySendEvent)(meta.analyticsFailureEvent.portal);
            return (0, $fSYYZ.Observable).of({
                portals: []
            });
        });
    }
};

});
parcelRegister("hldsh", function(module, exports) {
$parcel$export(module.exports, "searchKbs", () => $214ebb3f8b216184$export$14f2b1f126d32b28);

var $breWd = parcelRequire("breWd");

var $jByYr = parcelRequire("jByYr");

var $h1yZX = parcelRequire("h1yZX");

var $6t9NN = parcelRequire("6t9NN");

var $1EFS8 = parcelRequire("1EFS8");
const $214ebb3f8b216184$export$14f2b1f126d32b28 = (kbsQuery)=>{
    const { projectId: projectId, query: query, resultLimit: resultLimit, expandPortalName: expandPortalName, categoryIds: categoryIds, portalIds: portalIds, labels: labels, requestTypeId: requestTypeId } = kbsQuery;
    const queryParams = {
        labels: labels,
        portalIds: portalIds,
        categoryIds: categoryIds,
        searchQuery: query,
        limit: resultLimit,
        expand: expandPortalName ? 'portal' : undefined
    };
    const queryString = $h1yZX.stringify(queryParams);
    let uri;
    const activationId = (0, $jByYr.getMeta)('activation-id');
    if (projectId) {
        if ((0, $1EFS8.default).checkGate('remove-linked-spaces-check-for-article-suggestions') && requestTypeId) uri = `${0, $6t9NN.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/request-type/${requestTypeId}/articles?${queryString}`;
        else uri = `${0, $6t9NN.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/articles?${queryString}`;
    } else uri = `${0, $6t9NN.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/articles?${queryString}`;
    return (0, $breWd.get)(uri, {
        'Content-Type': 'application/json'
    }).map((ajaxResponse)=>{
        const result = ajaxResponse.response;
        return {
            ...result,
            articles: result.articles.map((article)=>({
                    id: article.articleId,
                    name: article.articleTitle,
                    articleSnippet: article.articleSnippet,
                    pageVersion: article.articleVersion,
                    score: article.snippetScore,
                    isSmartSnippet: article.isSmartSnippet,
                    linkedPortals: article.linkedPortals,
                    sourceType: article.articleSource,
                    articleUrl: article.articleUrl
                }))
        };
    });
};

});

parcelRegister("bss3b", function(module, exports) {
$parcel$export(module.exports, "searchPortals", () => $19b5e047aee31018$export$89b85885f9d0f13);

var $breWd = parcelRequire("breWd");

var $1We2B = parcelRequire("1We2B");

var $h1yZX = parcelRequire("h1yZX");

var $7FSs7 = parcelRequire("7FSs7");
const $19b5e047aee31018$export$89b85885f9d0f13 = (portalsQuery)=>{
    const sanitizedQuery = (0, $1We2B.pickBy)(portalsQuery, (prop)=>!(0, $1We2B.isNil)(prop));
    const queryString = $h1yZX.stringify(sanitizedQuery);
    return (0, $breWd.get)(`${(0, $7FSs7.contextPath)}/rest/servicedesk/search/1/search/portals?${queryString}`).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.portals;
    });
};

});

parcelRegister("6tm15", function(module, exports) {
$parcel$export(module.exports, "searchRequestTypes", () => $0bf24997f73349d3$export$c3cad6e5e6fca0f1);

var $breWd = parcelRequire("breWd");

var $1We2B = parcelRequire("1We2B");

var $h1yZX = parcelRequire("h1yZX");

var $7FSs7 = parcelRequire("7FSs7");
const $0bf24997f73349d3$export$c3cad6e5e6fca0f1 = (requestTypesQuery)=>{
    const sanitizedQuery = (0, $1We2B.pickBy)(requestTypesQuery, (prop)=>!(0, $1We2B.isNil)(prop));
    const queryString = $h1yZX.stringify(sanitizedQuery);
    return (0, $breWd.get)(`${(0, $7FSs7.contextPath)}/rest/servicedesk/search/1/search/request-type?${queryString}`).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.requestTypes;
    });
};

});

parcelRegister("5uOWq", function(module, exports) {
$parcel$export(module.exports, "getLogoUrl", () => (parcelRequire("ikoP4")).getLogoUrl);
$parcel$export(module.exports, "getSharedPortalName", () => (parcelRequire("ikoP4")).getSharedPortalName);
$parcel$export(module.exports, "getThemeColor", () => (parcelRequire("ikoP4")).getThemeColor);
$parcel$export(module.exports, "getIsKbEnabled", () => (parcelRequire("ikoP4")).getIsKbEnabled);
$parcel$export(module.exports, "getIsLoaded", () => (parcelRequire("ikoP4")).getIsLoaded);
$parcel$export(module.exports, "getHelpCenterBanner", () => (parcelRequire("ikoP4")).getHelpCenterBanner);
$parcel$export(module.exports, "getHelpCenterTitleColor", () => (parcelRequire("ikoP4")).getHelpCenterTitleColor);
$parcel$export(module.exports, "getCanCustomize", () => (parcelRequire("ikoP4")).getCanCustomize);
$parcel$export(module.exports, "getHelpCenterState", () => (parcelRequire("ikoP4")).getHelpCenterState);
$parcel$export(module.exports, "getDefaultSiteLanguageTag", () => (parcelRequire("ikoP4")).getDefaultSiteLanguageTag);
$parcel$export(module.exports, "getHelpCenterStateTranslationPersisted", () => (parcelRequire("ikoP4")).getHelpCenterStateTranslationPersisted);
$parcel$export(module.exports, "getKbHelpCenterLinkDomainURLs", () => (parcelRequire("ikoP4")).getKbHelpCenterLinkDomainURLs);
$parcel$export(module.exports, "getHelpCenterBrandingLoader", () => (parcelRequire("ikoP4")).getHelpCenterBrandingLoader);
$parcel$export(module.exports, "getHelpCenterTopBarSplitFlag", () => (parcelRequire("ikoP4")).getHelpCenterTopBarSplitFlag);
$parcel$export(module.exports, "getHelpCenterPersistedTopBarSplitFlag", () => (parcelRequire("ikoP4")).getHelpCenterPersistedTopBarSplitFlag);
$parcel$export(module.exports, "getHelpCenterTopBarColor", () => (parcelRequire("ikoP4")).getHelpCenterTopBarColor);
$parcel$export(module.exports, "getHelpCenterTopBarTextColor", () => (parcelRequire("ikoP4")).getHelpCenterTopBarTextColor);

var $ikoP4 = parcelRequire("ikoP4");

});
parcelRegister("ikoP4", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterState", () => $3ad47ff9e01a0f22$export$85757b7e55ef3c9f);
$parcel$export(module.exports, "getLogoUrl", () => $3ad47ff9e01a0f22$export$976f80239b15365);
$parcel$export(module.exports, "getSharedPortalName", () => $3ad47ff9e01a0f22$export$bef10d4690ba4a95);
$parcel$export(module.exports, "getThemeColor", () => $3ad47ff9e01a0f22$export$e22c5d06d177c3fa);
$parcel$export(module.exports, "getIsLoaded", () => $3ad47ff9e01a0f22$export$c2ab4f36d4c3d60a);
$parcel$export(module.exports, "getIsKbEnabled", () => $3ad47ff9e01a0f22$export$d56e4bff0fec91ad);
$parcel$export(module.exports, "getDefaultSiteLanguageTag", () => $3ad47ff9e01a0f22$export$16e1b34e36aec9ef);
$parcel$export(module.exports, "getHelpCenterBanner", () => $3ad47ff9e01a0f22$export$3b3c747bea011f3c);
$parcel$export(module.exports, "getCanCustomize", () => $3ad47ff9e01a0f22$export$eb9b5e885139dc39);
$parcel$export(module.exports, "getHelpCenterTitleColor", () => $3ad47ff9e01a0f22$export$4b8ac8e47961f765);
$parcel$export(module.exports, "getHelpCenterBrandingLoader", () => $3ad47ff9e01a0f22$export$62574aae884b522a);
$parcel$export(module.exports, "getHelpCenterTopBarSplitFlag", () => $3ad47ff9e01a0f22$export$76facf9cf6c06c3);
$parcel$export(module.exports, "getHelpCenterPersistedTopBarSplitFlag", () => $3ad47ff9e01a0f22$export$8dce832817c5aeef);
$parcel$export(module.exports, "getHelpCenterTopBarColor", () => $3ad47ff9e01a0f22$export$734cf776f7b0100e);
$parcel$export(module.exports, "getHelpCenterTopBarTextColor", () => $3ad47ff9e01a0f22$export$eaa9a84fffbc3381);
$parcel$export(module.exports, "getKbHelpCenterLinkDomainURLs", () => $3ad47ff9e01a0f22$export$8b6136ed26edce36);
$parcel$export(module.exports, "getHelpCenterStateTranslationPersisted", () => $3ad47ff9e01a0f22$export$7a7dbec5ebf74e05);

var $1We2B = parcelRequire("1We2B");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
const $3ad47ff9e01a0f22$export$85757b7e55ef3c9f = (state)=>(0, $1We2B.mergeWith)({}, state.persisted.helpCenter, state.ui.helpCenterPreview, // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/ban-types
    (_, srcValue)=>{
        // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
        // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
        if (srcValue === undefined) return null;
        // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
        return undefined;
    });
const $3ad47ff9e01a0f22$var$getTranslation = (state, language)=>$3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).translations[language];
const $3ad47ff9e01a0f22$export$976f80239b15365 = (state)=>$3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).logoUrl;
const $3ad47ff9e01a0f22$export$bef10d4690ba4a95 = (state)=>{
    const userLocale = (0, $hx8zX.getLocale)(state);
    const translation = userLocale && $3ad47ff9e01a0f22$var$getTranslation(state, userLocale);
    if (translation && translation.sharedPortalName) return translation.sharedPortalName;
    return $3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).sharedPortalName;
};
const $3ad47ff9e01a0f22$export$e22c5d06d177c3fa = (state)=>$3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).themeColor;
const $3ad47ff9e01a0f22$export$c2ab4f36d4c3d60a = (state)=>state.persisted.helpCenter.isLoaded;
const $3ad47ff9e01a0f22$export$d56e4bff0fec91ad = (state)=>{
    return !!state.persisted.helpCenter.knowledgeBase;
};
const $3ad47ff9e01a0f22$export$f18b5fbfa1271f69 = (state)=>{
    return state.persisted.helpCenter.rawBrandingResponse;
};
const $3ad47ff9e01a0f22$export$16e1b34e36aec9ef = (state)=>{
    const rawBrandingResponse = $3ad47ff9e01a0f22$export$f18b5fbfa1271f69(state);
    return rawBrandingResponse !== undefined ? rawBrandingResponse.siteDefaultLanguageTag : undefined;
};
const $3ad47ff9e01a0f22$export$3b3c747bea011f3c = (state)=>$3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).helpCenterBannerUrl;
const $3ad47ff9e01a0f22$export$eb9b5e885139dc39 = (state)=>$3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).canCustomizeHelpCenter;
const $3ad47ff9e01a0f22$export$899cf8c7a36d20bc = (state)=>{
    const userLocale = (0, $hx8zX.getLocale)(state);
    const translation = userLocale && $3ad47ff9e01a0f22$var$getTranslation(state, userLocale);
    const helpCenterTitle = translation && translation.helpCenterTitle ? translation.helpCenterTitle : $3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).helpCenterTitle;
    return helpCenterTitle;
};
const $3ad47ff9e01a0f22$export$4b8ac8e47961f765 = (state)=>{
    return $3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).helpCenterTitleColor;
};
const $3ad47ff9e01a0f22$export$62574aae884b522a = (state)=>{
    return $3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).isBrandingLoaded;
};
const $3ad47ff9e01a0f22$export$76facf9cf6c06c3 = (state)=>{
    return $3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).hasTopBarBeenSplit;
};
const $3ad47ff9e01a0f22$export$8dce832817c5aeef = (state)=>{
    var _state$persisted$help;
    return (_state$persisted$help = state.persisted.helpCenter) === null || _state$persisted$help === void 0 ? void 0 : _state$persisted$help.hasTopBarBeenSplit;
};
const $3ad47ff9e01a0f22$export$734cf776f7b0100e = (state)=>{
    return $3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).topBarColor;
};
const $3ad47ff9e01a0f22$export$eaa9a84fffbc3381 = (state)=>{
    return $3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state).topBarTextColor;
};
const $3ad47ff9e01a0f22$export$33a08d7ce0f06d3 = (state)=>{
    const helpCenterState = $3ad47ff9e01a0f22$export$85757b7e55ef3c9f(state);
    const announcementHeader = helpCenterState.announcementHeader ? helpCenterState.announcementHeader : undefined;
    const announcementMessage = helpCenterState.announcementMessage ? helpCenterState.announcementMessage : undefined;
    return {
        announcementHeader: announcementHeader,
        announcementMessage: announcementMessage
    };
};
const $3ad47ff9e01a0f22$export$8b6136ed26edce36 = (state)=>{
    var _state$persisted$help2;
    return ((_state$persisted$help2 = state.persisted.helpCenter) === null || _state$persisted$help2 === void 0 || (_state$persisted$help2 = _state$persisted$help2.knowledgeBase) === null || _state$persisted$help2 === void 0 ? void 0 : _state$persisted$help2.kbLinkDomainURLs) || [];
};
const $3ad47ff9e01a0f22$export$7a7dbec5ebf74e05 = (state)=>{
    return state.persisted.helpCenter.translations ?? {};
};

});





parcelRegister("3K5ah", function(module, exports) {
$parcel$export(module.exports, "resendValidationEmailEpic", () => $539252be55d65bad$export$a58a5733508cf172);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $dSvQo = parcelRequire("dSvQo");
parcelRequire("6aA8L");
var $jJMqu = parcelRequire("jJMqu");

var $cBtE0 = parcelRequire("cBtE0");
const $539252be55d65bad$var$ENABLE_RESEND_VALIDATION_LINK_DELAY_IN_MS = 5000;
const $539252be55d65bad$export$a58a5733508cf172 = (action$)=>{
    return action$.ofType((0, $jJMqu.RESEND_VALIDATION_EMAIL)).mergeMap((transitionAction)=>{
        const { email: email, portalId: portalId, redirectUrl: redirectUrl } = transitionAction.payload;
        return (0, $dSvQo.resendValidationEmail)(email, portalId, redirectUrl).flatMap(()=>(0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $6p5HB.showSuccessFlag)((0, $cBtE0.default).emailSentSuccessMessage, {
                emailAddress: email
            })), (0, $fSYYZ.Observable).of((0, $jJMqu.resendValidationEmailSuccess)()), (0, $fSYYZ.Observable).of((0, $jJMqu.enableResendValidationEmailLink)()).delay($539252be55d65bad$var$ENABLE_RESEND_VALIDATION_LINK_DELAY_IN_MS))).catch((error)=>{
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $jJMqu.resendValidationEmailFailure)()), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error)), (0, $fSYYZ.Observable).of((0, $jJMqu.enableResendValidationEmailLink)()));
        });
    });
};

});
parcelRegister("cBtE0", function(module, exports) {
$parcel$export(module.exports, "default", () => $923b0d4dce08da31$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $923b0d4dce08da31$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    documentTitle: {
        defaultMessage: 'Verify your email',
        description: 'Title of the check your email page',
        id: 'cv.sign.up.check.email.document.title'
    },
    emailSentSuccessMessage: {
        defaultMessage: 'Email sent to {emailAddress}',
        description: 'email sent success message',
        id: 'cv.sign.up.check.email.resend.success.message'
    },
    checkEmailToFinishSignup: {
        defaultMessage: 'Check your email to set your password',
        description: 'check your email page title',
        id: 'cv.sign.up.check.your.email.to.signup'
    },
    emailSentHint: {
        defaultMessage: "We've sent information on how to set your password to {emailAddress}.",
        description: 'help text to explain that and email has been sent and that the user has to check his inbox',
        id: 'cv.sign.up.check.email.sub.title'
    },
    resendSignupLink: {
        defaultMessage: 'Resend password setup link',
        description: 'resend button label',
        id: 'cv.sign.up.resend.signup.link.button'
    }
});

});


parcelRegister("fw9vu", function(module, exports) {
$parcel$export(module.exports, "updateUserProfileEpic", () => $31fbaae26924088d$export$776b3daee68de137);
$parcel$export(module.exports, "validateAndSavePasswordChangeEpic", () => $31fbaae26924088d$export$dbb7ca6f3fcbf9c2);
$parcel$export(module.exports, "validateEpic", () => $31fbaae26924088d$export$4a45b80683fc2fca);
$parcel$export(module.exports, "changePasswordEpic", () => $31fbaae26924088d$export$2ab2d1c48dcca790);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $dMQwV = parcelRequire("dMQwV");

var $dRMZ5 = parcelRequire("dRMZ5");
parcelRequire("6Fjys");
var $8ICBx = parcelRequire("8ICBx");

var $g4UBb = parcelRequire("g4UBb");

var $a3Ha6 = parcelRequire("a3Ha6");

var $hVTZX = parcelRequire("hVTZX");
const $31fbaae26924088d$export$776b3daee68de137 = (action$)=>{
    return action$.ofType((0, $8ICBx.SAVE_USER_PROFILE)).mergeMap((updateUserProfileAction)=>{
        const { displayName: displayName, language: language, timezone: timezone } = updateUserProfileAction.payload;
        const languageKey = language === undefined ? undefined : language.originalKey;
        const timezoneId = timezone === undefined ? undefined : timezone.id;
        return (0, $dRMZ5.updateUserProfile)(displayName, languageKey, timezoneId).flatMap(()=>(0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $8ICBx.saveUserProfileSuccess)(displayName, language, timezone)), (0, $fSYYZ.Observable).of((0, $6p5HB.showSuccessFlag)((0, $hVTZX.default).profileDetailsUpdatedHeaderMessage, undefined, (0, $hVTZX.default).profileDetailsUpdatedBodyMessage)))).catch((error)=>(0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $8ICBx.saveUserProfileFailure)()), (0, $fSYYZ.Observable).of((0, $6p5HB.handleAjaxError)(error))));
    });
};
const $31fbaae26924088d$export$dbb7ca6f3fcbf9c2 = (action$)=>{
    return action$.ofType((0, $8ICBx.VALIDATE_AND_SAVE_PASSWORD_CHANGE)).mergeMap((validateAndSavePasswordChangeAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = validateAndSavePasswordChangeAction.payload;
        const validationErrors = $31fbaae26924088d$var$validate(currentPassword, newPassword, confirmPassword);
        const result = validationErrors || (0, $8ICBx.changePassword)(currentPassword, newPassword, confirmPassword);
        return (0, $fSYYZ.Observable).of(result);
    });
};
const $31fbaae26924088d$export$4a45b80683fc2fca = (action$)=>{
    return action$.ofType((0, $8ICBx.VALIDATE_PASSWORD)).mergeMap((validatePasswordAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = validatePasswordAction.payload;
        const validationErrors = $31fbaae26924088d$var$validate(currentPassword, newPassword, confirmPassword);
        const result = validationErrors || (0, $8ICBx.validatePasswordSuccess)();
        return (0, $fSYYZ.Observable).of(result);
    });
};
const $31fbaae26924088d$var$validate = (currentPassword, newPassword, confirmPassword)=>{
    const currentPasswordError = !currentPassword.trim() ? (0, $hVTZX.default).currentPasswordMissingError : undefined;
    let newPasswordError = !newPassword.trim() ? (0, $hVTZX.default).newPasswordMissingError : undefined;
    let confirmPasswordError = !confirmPassword.trim() ? (0, $hVTZX.default).confirmPasswordMissingError : undefined;
    if (!newPasswordError && newPassword.length < (0, $a3Ha6.MIN_PASSWORD_LENGTH_IN_CHARS)) newPasswordError = (0, $hVTZX.default).newPasswordTooShortError;
    if (!newPasswordError && newPassword.length > (0, $a3Ha6.MAX_PASSWORD_LENGTH_IN_CHARS)) newPasswordError = (0, $hVTZX.default).newPasswordTooLongError;
    if (!newPasswordError && !confirmPasswordError && confirmPassword !== newPassword) confirmPasswordError = (0, $hVTZX.default).confirmPasswordDoesNotMatchError;
    if (currentPasswordError || newPasswordError || confirmPasswordError) return (0, $8ICBx.changePasswordFailure)(currentPasswordError, newPasswordError, confirmPasswordError, undefined);
    return undefined;
};
const $31fbaae26924088d$export$2ab2d1c48dcca790 = (action$)=>{
    return action$.ofType((0, $8ICBx.CHANGE_PASSWORD)).mergeMap((receivedChangePasswordAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = receivedChangePasswordAction.payload;
        return (0, $dRMZ5.changePassword)(currentPassword, newPassword, confirmPassword).map(()=>{
            return (0, $dMQwV.logOutAction)();
        }).catch((error)=>{
            const jiraError = (0, $g4UBb.getJiraErrorResponse)(error);
            if (jiraError) return (0, $fSYYZ.Observable).of($31fbaae26924088d$var$getJiraErrorFailure(jiraError, error));
            return (0, $fSYYZ.Observable).of($31fbaae26924088d$var$getGenericErrorFailure(error));
        });
    });
};
const $31fbaae26924088d$var$getJiraErrorFailure = (jiraError, ajaxError)=>{
    const currentError = $31fbaae26924088d$var$getPasswordError(jiraError, 'current');
    const newError = $31fbaae26924088d$var$getPasswordError(jiraError, 'password');
    const confirmError = $31fbaae26924088d$var$getPasswordError(jiraError, 'confirm');
    if (currentError === undefined && newError === undefined && confirmError === undefined) return $31fbaae26924088d$var$getGenericErrorFailure(ajaxError);
    return (0, $8ICBx.changePasswordFailure)(currentError, newError, confirmError, undefined);
};
const $31fbaae26924088d$var$getPasswordError = (error, field)=>{
    return error.errors.filter((e)=>e.field === field).map((e)=>e.errorMessage)[0];
};
const $31fbaae26924088d$var$getGenericErrorFailure = (error)=>{
    return (0, $8ICBx.changePasswordFailure)(undefined, undefined, undefined, (0, $g4UBb.getDefaultError)(error));
};

});
parcelRegister("a3Ha6", function(module, exports) {
$parcel$export(module.exports, "MAX_FULL_NAME_LENGTH_IN_CHARS", () => $8c01aa21f7504482$export$abf6aa48eca27616);
$parcel$export(module.exports, "MAX_PASSWORD_LENGTH_IN_CHARS", () => $8c01aa21f7504482$export$778010a9ee5e9c9b);
$parcel$export(module.exports, "MIN_PASSWORD_LENGTH_IN_CHARS", () => $8c01aa21f7504482$export$5dbee9b10a861405);
$parcel$export(module.exports, "validateAll", () => $8c01aa21f7504482$export$d1393b0ce6100c11);
$parcel$export(module.exports, "validateFullName", () => $8c01aa21f7504482$export$8369f6c309ebe358);
$parcel$export(module.exports, "validatePassword", () => $8c01aa21f7504482$export$4d2a7159fda5dc93);

var $XQATe = parcelRequire("XQATe");
const $8c01aa21f7504482$export$abf6aa48eca27616 = 255;
const $8c01aa21f7504482$export$778010a9ee5e9c9b = 72;
const $8c01aa21f7504482$export$5dbee9b10a861405 = 8;
function $8c01aa21f7504482$export$d1393b0ce6100c11(fullName, password) {
    const fullNameError = $8c01aa21f7504482$export$8369f6c309ebe358(fullName);
    const passwordError = $8c01aa21f7504482$export$4d2a7159fda5dc93(password);
    if (fullNameError || passwordError) return {
        fullNameError: fullNameError,
        passwordError: passwordError
    };
    return undefined;
}
function $8c01aa21f7504482$export$8369f6c309ebe358(fullName) {
    const trimmedFullName = fullName.trim();
    if (trimmedFullName.length === 0) return (0, $XQATe.default).fullNameMissingError;
    if (trimmedFullName.length > $8c01aa21f7504482$export$abf6aa48eca27616) return (0, $XQATe.default).fullNameTooLongError;
    return undefined;
}
function $8c01aa21f7504482$export$4d2a7159fda5dc93(password) {
    if (password.trim().length === 0) return (0, $XQATe.default).passwordMissingError;
    if (password.length < $8c01aa21f7504482$export$5dbee9b10a861405) return (0, $XQATe.default).passwordTooShortError;
    if (password.length > $8c01aa21f7504482$export$778010a9ee5e9c9b) return (0, $XQATe.default).passwordTooLongError;
    return undefined;
}

});
parcelRegister("XQATe", function(module, exports) {
$parcel$export(module.exports, "default", () => $607993a0fcf71696$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $607993a0fcf71696$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    fullNameMissingError: {
        defaultMessage: 'You must enter a full name',
        description: 'Error message when the full name field is blank',
        id: 'cv.sign.up.full.name.empty.error'
    },
    fullNameTooLongError: {
        defaultMessage: 'Full name must be less than 255 characters',
        description: 'Error message when the full name field value is too long',
        id: 'cv.sign.up.full.name.too.long.error'
    },
    passwordMissingError: {
        defaultMessage: 'You must enter a password',
        description: 'Error message when the password field is blank',
        id: 'cv.sign.up.password.empty.error'
    },
    passwordTooShortError: {
        defaultMessage: 'Password is too short',
        description: 'Error message that will show under the password field if it is shorter than 8 characters.',
        id: 'cv.sign.up.password.too.short.error'
    },
    passwordTooLongError: {
        defaultMessage: 'Password may not contain more than {maxPasswordLength, plural, one {# character} other {# characters}}',
        description: 'Error message when the password field value is too long',
        id: 'cv.sign.up.password.too.long.error.old'
    }
});

});


parcelRegister("hVTZX", function(module, exports) {
$parcel$export(module.exports, "default", () => $738b4c60f1171d57$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $738b4c60f1171d57$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    currentPasswordMissingError: {
        defaultMessage: 'You must type your current password',
        description: 'error message when the current password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.current.error'
    },
    newPasswordMissingError: {
        defaultMessage: 'You must specify a new password',
        description: 'error message when the new password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.new.error'
    },
    newPasswordTooShortError: {
        defaultMessage: 'Password is too short',
        description: 'Error message that will show under the password field if it is shorter than 8 characters.',
        id: 'cv.user.profile.change.password.new.too.short.error'
    },
    newPasswordTooLongError: {
        defaultMessage: 'Password may not contain more than {maxPasswordLength, plural, one {# character} other {# characters}}',
        description: 'Error message when the password field value is too long',
        id: 'cv.user.profile.change.password.too.new.long.error'
    },
    confirmPasswordMissingError: {
        defaultMessage: 'You must re-type the new password',
        description: 'error message when the confirm new password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.confirm.error'
    },
    confirmPasswordDoesNotMatchError: {
        defaultMessage: 'Passwords do not match',
        description: 'error message when the confirmation password does not match the new password in the change password dialog',
        id: 'cv.user.profile.change.password.confirm.mismatch.error'
    },
    profileDetailsUpdatedHeaderMessage: {
        defaultMessage: 'Profile details updated',
        description: 'message header when the profile details are updated.',
        id: 'cv.user.profile.field.save.success.header'
    },
    profileDetailsUpdatedBodyMessage: {
        defaultMessage: 'Your changes may take up to five minutes to appear.',
        description: 'message body when the profile details are updated.',
        id: 'cv.user.profile.field.save.success.body'
    }
});

});


parcelRegister("5HqNJ", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $3518c13e8bed2234$export$cb36b6e8b9a45314);

var $jpGTf = parcelRequire("jpGTf");
var $fSYYZ = parcelRequire("fSYYZ");

var $6p5HB = parcelRequire("6p5HB");

var $9VNXn = parcelRequire("9VNXn");
parcelRequire("6Fjys");
var $8ICBx = parcelRequire("8ICBx");

var $g4UBb = parcelRequire("g4UBb");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");

var $aYsVR = parcelRequire("aYsVR");
const $3518c13e8bed2234$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $8ICBx.USER_PROFILE_FORGOT_PASSWORD)).mergeMap((forgotPasswordAction)=>{
        const { resetUrl: resetUrl, email: email, createAnalyticsEvent: createAnalyticsEvent } = forgotPasswordAction.payload;
        return (0, $9VNXn.forgotPassword)(resetUrl, email).flatMap(()=>{
            const successEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'sent',
                actionSubject: 'userProfileForgotPasswordLink'
            });
            successEvent && (0, $9ypa9.legacySendEvent)(successEvent);
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $8ICBx.forgotPasswordSuccess)()), (0, $fSYYZ.Observable).of((0, $6p5HB.showSuccessFlag)((0, $aYsVR.default).forgotPasswordSuccessFlagTitle, undefined, (0, $aYsVR.default).forgotPasswordSuccessFlagDescription, undefined, {
                emailAddress: email
            })));
        }).catch((error)=>{
            const failEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'userProfileForgotPasswordLink'
            });
            failEvent && (0, $9ypa9.legacySendEvent)(failEvent);
            const parsedError = (0, $g4UBb.getUserProfileForgotPasswordFailedError)(error);
            const errorAction = parsedError.action === undefined ? undefined : [
                parsedError.action
            ];
            return (0, $jpGTf.concat)((0, $fSYYZ.Observable).of((0, $8ICBx.forgotPasswordFailure)()), (0, $fSYYZ.Observable).of((0, $6p5HB.showErrorFlag)(parsedError.title, parsedError.description, errorAction)));
        });
    });
};

});
parcelRegister("aYsVR", function(module, exports) {
$parcel$export(module.exports, "default", () => $dca9949ad978490c$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $dca9949ad978490c$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    forgotPasswordSuccessFlagTitle: {
        defaultMessage: 'Check your email to reset your password',
        description: 'Message title for toast flag when the forgot password action is successful.',
        id: 'cv.user.profile.forgot.password.success.flag.title'
    },
    forgotPasswordSuccessFlagDescription: {
        defaultMessage: "We've sent a reset password link to {emailAddress}.",
        description: 'Message descritpion for toast flag when the forgot password action is successful.',
        id: 'cv.user.profile.forgot.password.success.flag.description'
    }
});

});



parcelRegister("WIQuk", function(module, exports) {
$parcel$export(module.exports, "getCombinedPersistedReducer", () => $7213ccd6e62c9d6b$export$1e1389697ca32ad5);
$parcel$export(module.exports, "default", () => $7213ccd6e62c9d6b$export$2e2bcd8739ae039);
parcelRequire("haxwJ");
var $02gNN = parcelRequire("02gNN");
parcelRequire("fRtnm");
var $kOOky = parcelRequire("kOOky");

var $1EFS8 = parcelRequire("1EFS8");
parcelRequire("1Oe11");
var $iZY63 = parcelRequire("iZY63");
parcelRequire("dAN6x");
var $6jsOW = parcelRequire("6jsOW");
parcelRequire("lfbDq");
var $heUii = parcelRequire("heUii");
parcelRequire("25oDP");
var $3Oew2 = parcelRequire("3Oew2");
parcelRequire("kg4Mf");
var $ax4PK = parcelRequire("ax4PK");
parcelRequire("9grr6");
var $8ApRA = parcelRequire("8ApRA");
parcelRequire("gou3k");
var $663j1 = parcelRequire("663j1");
parcelRequire("6ghQU");
var $2WELF = parcelRequire("2WELF");
parcelRequire("aNSoj");
var $7e7P5 = parcelRequire("7e7P5");
parcelRequire("4k1JJ");
var $j2oW4 = parcelRequire("j2oW4");
parcelRequire("1GPF1");
var $e7Rzo = parcelRequire("e7Rzo");
parcelRequire("le42D");
var $ikJcW = parcelRequire("ikJcW");
parcelRequire("2STkY");
var $3Nrzs = parcelRequire("3Nrzs");
parcelRequire("dEq0z");
var $g2Vaa = parcelRequire("g2Vaa");
parcelRequire("9MX7M");
var $eaDXW = parcelRequire("eaDXW");
parcelRequire("cRbGR");
var $oXeui = parcelRequire("oXeui");
parcelRequire("38xVE");
var $jzb0b = parcelRequire("jzb0b");
parcelRequire("1Ohn6");
var $8punt = parcelRequire("8punt");
parcelRequire("5vkrg");
var $3Dxn9 = parcelRequire("3Dxn9");
parcelRequire("ink0o");
var $lmeu7 = parcelRequire("lmeu7");
parcelRequire("1KrWF");
var $bCbpW = parcelRequire("bCbpW");
parcelRequire("hiifn");
var $ifuNK = parcelRequire("ifuNK");
parcelRequire("8jLm8");
var $6bKu0 = parcelRequire("6bKu0");
parcelRequire("lxqph");
var $4DH1E = parcelRequire("4DH1E");
parcelRequire("imME9");
var $e4c8o = parcelRequire("e4c8o");
parcelRequire("iM452");
var $dLgyA = parcelRequire("dLgyA");
parcelRequire("4p6id");
var $h831L = parcelRequire("h831L");
parcelRequire("2QgYJ");
var $9loq1 = parcelRequire("9loq1");
parcelRequire("jixj5");
var $lpCOk = parcelRequire("lpCOk");
parcelRequire("4YN96");
var $Wjpdg = parcelRequire("Wjpdg");
parcelRequire("65CEU");
var $h6lvR = parcelRequire("h6lvR");
parcelRequire("hptTk");
var $lUyAp = parcelRequire("lUyAp");
parcelRequire("163SR");
var $cIH0s = parcelRequire("cIH0s");
const $7213ccd6e62c9d6b$var$reducerCollection = {
    helpCenter: (0, $j2oW4.default),
    portals: (0, $8punt.default),
    user: (0, $Wjpdg.default),
    env: (0, $663j1.default),
    meta: (0, $oXeui.default),
    organisations: (0, $jzb0b.default),
    requestCreate: (0, $bCbpW.default),
    requestTypeSuggestion: (0, $4DH1E.default),
    connectFragments: (0, $8ApRA.default),
    kbArticles: (0, $e7Rzo.default),
    portalCustomisation: (0, $3Dxn9.portalCustomisationReducer),
    unsubscribedConfirmation: (0, $lpCOk.unsubscribedConfirmationReducer),
    login: (0, $g2Vaa.loginReducer),
    forgotPassword: (0, $7e7P5.forgotPasswordReducer),
    requestDetails: (0, $ifuNK.requestDetailsReducer),
    timezones: (0, $h831L.timezonesReducer),
    languages: (0, $ikJcW.languagesReducer),
    profileWebFragments: (0, $lmeu7.profileWebFragmentReducer),
    requestList: (0, $6bKu0.requestListReducer),
    approvalList: (0, $heUii.approvalListReducer),
    visitPortal: (0, $cIH0s.visitPortalReducer),
    resetPassword: (0, $e4c8o.resetPasswordReducer),
    completeSignup: (0, $ax4PK.completeSignupReducer),
    verifyEmail: (0, $lUyAp.verifyEmailReducer),
    signUp: (0, $dLgyA.signUpReducer),
    userRequestsCounts: (0, $h6lvR.default),
    anonymousApproval: (0, $6jsOW.anonymousApprovalReducer),
    featuredAndSortedPortals: (0, $2WELF.featuredAndSortedPortalsReducer),
    loginAnnouncements: (0, $eaDXW.loginAnnouncementsReducer),
    blockedAppsBanner: (0, $kOOky.default),
    aiAnswerFeedbackPage: (0, $iZY63.aiAnswerReducer),
    linkedSpaces: (0, $3Nrzs.default),
    branding: (0, $3Oew2.brandingReducer),
    ...(0, $1EFS8.default).checkGate('ditto_uim_root_query_rest') ? {
        uiModifications: (0, $9loq1.uiModificationsReducer)
    } : {}
};
const $7213ccd6e62c9d6b$export$1e1389697ca32ad5 = (asyncReducers)=>(0, $02gNN.default)({
        ...$7213ccd6e62c9d6b$var$reducerCollection,
        ...asyncReducers
    });
var $7213ccd6e62c9d6b$export$2e2bcd8739ae039 = (0, $02gNN.default)($7213ccd6e62c9d6b$var$reducerCollection);

});
parcelRegister("fRtnm", function(module, exports) {
$parcel$export(module.exports, "blockedAppsBannerReducer", () => (parcelRequire("kOOky")).default);

var $kOOky = parcelRequire("kOOky");

});
parcelRegister("kOOky", function(module, exports) {
$parcel$export(module.exports, "mapDispatchToPropsBanner", () => $590d09bce6766eea$export$de142fee58ebb9a8);
$parcel$export(module.exports, "mapConnectDispatchToPropsBanner", () => $590d09bce6766eea$export$b08e00302c3c215c);
$parcel$export(module.exports, "default", () => $590d09bce6766eea$export$2e2bcd8739ae039);
const $590d09bce6766eea$export$e872b6f4d4c58319 = 'state.persisted.blockedAppsBanner.SHOW_BANNER';
const $590d09bce6766eea$export$8c1102f190441ac3 = 'state.persisted.blockedAppsBanner.SHOW_CONNECT_BANNER';
const $590d09bce6766eea$export$c23ca0c98b7b93db = 'state.persisted.blockedAppsBanner.RESET_BANNER_STATE';
const $590d09bce6766eea$export$24e8a154ba80b759 = 'state.persisted.blockedAppsBanner.RESET_CONNECT_BANNER_STATE';
const $590d09bce6766eea$export$ad5fb8b7cdde24d7 = 'create_request';
const $590d09bce6766eea$export$e63cec9acfdad935 = 'view_request';
const $590d09bce6766eea$export$ac4d91f5203d82ae = 'portal';
const $590d09bce6766eea$var$defaultState = {
    create_request: false,
    portal: false,
    view_request: false,
    connect: {
        create_request: false,
        view_request: false,
        portal: false
    }
};
const $590d09bce6766eea$export$4a89ccf10a725e56 = (page)=>({
        type: $590d09bce6766eea$export$e872b6f4d4c58319,
        payload: {
            page: page
        }
    });
const $590d09bce6766eea$export$cf79152bba576f84 = (page)=>({
        type: $590d09bce6766eea$export$8c1102f190441ac3,
        payload: {
            page: page
        }
    });
const $590d09bce6766eea$export$4d7eca3346df6596 = (page)=>({
        type: $590d09bce6766eea$export$c23ca0c98b7b93db,
        payload: {
            page: page
        }
    });
const $590d09bce6766eea$export$9a8e10487635d611 = (page)=>({
        type: $590d09bce6766eea$export$24e8a154ba80b759,
        payload: {
            page: page
        }
    });
const $590d09bce6766eea$export$e04d0f37424da45e = (connectPageName)=>{
    switch(connectPageName){
        case 'PORTAL':
            return $590d09bce6766eea$export$ac4d91f5203d82ae;
        case 'CREATE_REQUEST':
            return $590d09bce6766eea$export$ad5fb8b7cdde24d7;
        case 'VIEW_REQUEST':
            return $590d09bce6766eea$export$e63cec9acfdad935;
        default:
            return null;
    }
};
const $590d09bce6766eea$export$912af6a6ce89d10c = (forgePageName)=>{
    let screen;
    switch(forgePageName){
        case 'create_request':
            screen = $590d09bce6766eea$export$ad5fb8b7cdde24d7;
            break;
        case 'portal':
            screen = $590d09bce6766eea$export$ac4d91f5203d82ae;
            break;
        case 'view_request':
            screen = $590d09bce6766eea$export$e63cec9acfdad935;
            break;
        default:
            screen = null;
    }
    return screen;
};
const $590d09bce6766eea$export$a1659b54bac3252a = ()=>{
    return {
        ...$590d09bce6766eea$var$defaultState
    };
};
const $590d09bce6766eea$export$de142fee58ebb9a8 = (dispatch)=>{
    return {
        showBanner: (forgePageName)=>{
            return dispatch($590d09bce6766eea$export$4a89ccf10a725e56($590d09bce6766eea$export$912af6a6ce89d10c(forgePageName)));
        },
        resetBannerState: (forgePageName)=>{
            return dispatch($590d09bce6766eea$export$4d7eca3346df6596($590d09bce6766eea$export$912af6a6ce89d10c(forgePageName)));
        }
    };
};
const $590d09bce6766eea$export$b08e00302c3c215c = {
    showBanner: (connectPageName)=>{
        return $590d09bce6766eea$export$cf79152bba576f84($590d09bce6766eea$export$e04d0f37424da45e(connectPageName));
    },
    resetBannerState: (connectPageName)=>{
        return $590d09bce6766eea$export$9a8e10487635d611($590d09bce6766eea$export$e04d0f37424da45e(connectPageName));
    }
};
function $590d09bce6766eea$export$2e2bcd8739ae039(currentState = $590d09bce6766eea$export$a1659b54bac3252a(), action) {
    const newState = {
        ...currentState
    };
    switch(action.type){
        case $590d09bce6766eea$export$e872b6f4d4c58319:
            {
                const screen = action.payload.page;
                if (screen) newState[screen] = true;
                return newState;
            }
        case $590d09bce6766eea$export$8c1102f190441ac3:
            {
                const screen = action.payload.page;
                if (screen) newState.connect = {
                    ...currentState.connect,
                    [screen]: true
                };
                return newState;
            }
        case $590d09bce6766eea$export$c23ca0c98b7b93db:
            {
                const screen = action.payload.page;
                if (screen) newState[screen] = false;
                return newState;
            }
        case $590d09bce6766eea$export$24e8a154ba80b759:
            {
                const screen = action.payload.page;
                if (screen) newState.connect = {
                    ...currentState.connect,
                    [screen]: false
                };
                return newState;
            }
        default:
            return currentState;
    }
}

});


parcelRegister("1Oe11", function(module, exports) {
$parcel$export(module.exports, "aiAnswerReducer", () => (parcelRequire("iZY63")).aiAnswerReducer);

var $iZY63 = parcelRequire("iZY63");

});
parcelRegister("iZY63", function(module, exports) {
$parcel$export(module.exports, "aiAnswerReducer", () => $99d0aab6c996d906$export$2a26170741a0330c);
parcelRequire("hQvsi");
var $cDjgl = parcelRequire("cDjgl");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $99d0aab6c996d906$var$defaultState = {
    feedback: '',
    issueKey: '',
    projectId: 0,
    initialError: undefined
};
const $99d0aab6c996d906$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.aiAnswerFeedbackPage) return initialModelState.aiAnswerFeedbackPage;
    return $99d0aab6c996d906$var$defaultState;
};
function $99d0aab6c996d906$export$2a26170741a0330c(state = $99d0aab6c996d906$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $cDjgl.FETCH_AI_ANSWER_FEEDBACK_SUCCESS:
            return $99d0aab6c996d906$var$handleFetchAiAnswerFeedbackSuccess(state, action);
        case 0, $cDjgl.FETCH_AI_ANSWER_FEEDBACK_FAILURE:
            return $99d0aab6c996d906$var$handleFetchAiAnswerFeedbackFailure(state, action);
        default:
            return state;
    }
}
function $99d0aab6c996d906$var$handleFetchAiAnswerFeedbackSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        feedback: response.feedback,
        issueKey: response.issueKey,
        projectId: response.projectId
    };
}
function $99d0aab6c996d906$var$handleFetchAiAnswerFeedbackFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});


parcelRegister("dAN6x", function(module, exports) {
$parcel$export(module.exports, "anonymousApprovalReducer", () => (parcelRequire("6jsOW")).anonymousApprovalReducer);

var $6jsOW = parcelRequire("6jsOW");

});
parcelRegister("6jsOW", function(module, exports) {
$parcel$export(module.exports, "anonymousApprovalReducer", () => $606bf51cbb310598$export$12846d9286d41238);

var $9EsDH = parcelRequire("9EsDH");
const $606bf51cbb310598$var$defaultState = {
    token: '',
    requestDetailsUrl: '',
    loggedIn: false,
    initialError: undefined
};
const $606bf51cbb310598$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.anonymousApproval) return initialModelState.anonymousApproval;
    return $606bf51cbb310598$var$defaultState;
};
const $606bf51cbb310598$export$12846d9286d41238 = (state = $606bf51cbb310598$export$53ac33307b5acee9(), _)=>state;

});


parcelRegister("lfbDq", function(module, exports) {
$parcel$export(module.exports, "approvalListReducer", () => (parcelRequire("heUii")).approvalListReducer);

var $heUii = parcelRequire("heUii");

});
parcelRegister("heUii", function(module, exports) {
$parcel$export(module.exports, "approvalListReducer", () => $37f057aef8fcf7d6$export$18397d0445d17954);
parcelRequire("jTmWg");
var $kN7vu = parcelRequire("kN7vu");

var $HGACo = parcelRequire("HGACo");
const $37f057aef8fcf7d6$var$emptyState = {
    totalResults: 0,
    resultsPerPage: 20,
    pages: {
        isInitialPageLoad: false
    },
    portalsRequestTypes: []
};
const $37f057aef8fcf7d6$var$defaultState = $37f057aef8fcf7d6$var$emptyState;
function $37f057aef8fcf7d6$export$18397d0445d17954(state = $37f057aef8fcf7d6$var$defaultState, action) {
    switch(action.type){
        case 0, $kN7vu.FETCH_APPROVAL_LIST_SUCCESS:
            return $37f057aef8fcf7d6$var$handleFetchApprovalListSuccess(state, action);
        default:
            return state;
    }
}
function $37f057aef8fcf7d6$var$handleFetchApprovalListSuccessInfiniteScroll(state, action) {
    const response = action.payload;
    if (!response) return state;
    const isReset = response.totalResults !== state.totalResults;
    const existingRows = state.allRows ?? [];
    // Deduplicate to prevent duplicate entries from race conditions or overlapping API calls
    const existingKeys = new Set(existingRows.map((row)=>row.key));
    const uniqueNewRows = response.requests.filter((row)=>!existingKeys.has(row.key));
    const newRows = isReset ? response.requests : [
        ...existingRows,
        ...uniqueNewRows
    ];
    return {
        ...state,
        approvalFilter: response.approvalFilterValue,
        portalId: response.portalId,
        requestTypeId: response.requestTypeId,
        resultsPerPage: response.resultsPerPage,
        totalResults: response.totalResults,
        nextToken: response.nextToken,
        allRows: newRows,
        pages: {
            isInitialPageLoad: false,
            [response.selectedPage]: response.requests
        },
        portalsRequestTypes: response.portalRequestTypes
    };
}
function $37f057aef8fcf7d6$var$handleFetchApprovalListSuccess(state, action) {
    if ((0, $HGACo.isApprovalListInfiniteScrollEnabled)()) return $37f057aef8fcf7d6$var$handleFetchApprovalListSuccessInfiniteScroll(state, action);
    const response = action.payload;
    if (response) {
        if (response.totalResults === state.totalResults) return {
            ...state,
            pages: {
                ...state.pages,
                [response.selectedPage]: response.requests
            }
        };
        return {
            approvalFilter: response.approvalFilterValue,
            portalId: response.portalId,
            requestTypeId: response.requestTypeId,
            resultsPerPage: response.resultsPerPage,
            totalResults: response.totalResults,
            pages: {
                isInitialPageLoad: false,
                [response.selectedPage]: response.requests
            },
            portalsRequestTypes: response.portalRequestTypes
        };
    }
    return state;
}

});


parcelRegister("25oDP", function(module, exports) {
$parcel$export(module.exports, "brandingReducer", () => (parcelRequire("3Oew2")).brandingReducer);

var $3Oew2 = parcelRequire("3Oew2");

});
parcelRegister("3Oew2", function(module, exports) {
$parcel$export(module.exports, "brandingReducer", () => $dff1ed443e3c2395$export$77a6a980433b33f5);

var $9EsDH = parcelRequire("9EsDH");
const $dff1ed443e3c2395$var$defaultState = {
    id: '',
    key: '',
    name: '',
    portalBaseUrl: ''
};
const $dff1ed443e3c2395$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.branding) return initialModelState.branding;
    return $dff1ed443e3c2395$var$defaultState;
};
const $dff1ed443e3c2395$export$77a6a980433b33f5 = (state = $dff1ed443e3c2395$export$53ac33307b5acee9(), _)=>state;

});


parcelRegister("kg4Mf", function(module, exports) {
$parcel$export(module.exports, "completeSignupReducer", () => (parcelRequire("ax4PK")).completeSignupReducer);

var $ax4PK = parcelRequire("ax4PK");

});
parcelRegister("ax4PK", function(module, exports) {
$parcel$export(module.exports, "completeSignupReducer", () => $7098c6763427778b$export$b5b8ee9188984cd7);
parcelRequire("l0dvx");
var $053zO = parcelRequire("053zO");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $7098c6763427778b$var$defaultState = {
    signupToken: '',
    emailAddress: '',
    validationOutcome: undefined,
    portalId: undefined,
    initialError: undefined
};
const $7098c6763427778b$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.completeSignup) return initialModelState.completeSignup;
    return $7098c6763427778b$var$defaultState;
};
function $7098c6763427778b$export$b5b8ee9188984cd7(state = $7098c6763427778b$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $053zO.FETCH_COMPLETE_SIGNUP_SUCCESS:
            return $7098c6763427778b$var$handleFetchCompleteSignupSuccess(state, action);
        case 0, $053zO.FETCH_COMPLETE_SIGNUP_FAILURE:
            return $7098c6763427778b$var$handleFetchCompleteSignupFailure(state, action);
        default:
            return state;
    }
}
function $7098c6763427778b$var$handleFetchCompleteSignupSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        signupToken: response.signupToken,
        emailAddress: response.emailAddress,
        validationOutcome: response.validationOutcome,
        portalId: response.portalId,
        redirectUrl: response.redirectUrl
    };
}
function $7098c6763427778b$var$handleFetchCompleteSignupFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                // We need to remove basename, see https://jdog.jira-dev.com/browse/FSD-2557
                callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});


parcelRegister("9grr6", function(module, exports) {
$parcel$export(module.exports, "connectFragmentsReducer", () => (parcelRequire("8ApRA")).default);
$parcel$export(module.exports, "generateKey", () => (parcelRequire("8ApRA")).generateKey);

var $8ApRA = parcelRequire("8ApRA");

});
parcelRegister("8ApRA", function(module, exports) {
$parcel$export(module.exports, "generateKey", () => $906c876843bd789e$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "default", () => $906c876843bd789e$export$2e2bcd8739ae039);
parcelRequire("6TVgw");
var $ddmND = parcelRequire("ddmND");

var $1EFS8 = parcelRequire("1EFS8");

var $9EsDH = parcelRequire("9EsDH");
const $906c876843bd789e$export$3a7728e868aa3ebd = (portalPageName, portalId, requestTypeId, requestKey)=>`${portalPageName}_${portalId || 'none'}_${requestTypeId || 'none'}${`_${requestKey || 'none'}`}`;
const $906c876843bd789e$export$a1659b54bac3252a = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    const { portal: portal, portalWebFragments: portalWebFragments, reqCreate: reqCreate } = initialModelState;
    const initialState = {
        HELP_CENTER_none_none: {},
        PORTAL_none_none: {},
        CREATE_REQUEST_none_none: {},
        REQUEST_DETAILS_none_none: {},
        PROFILE_none_none: {}
    };
    if ((0, $1EFS8.default).checkGate('preload_connect_fragments_data_for_request_create') && portal && portalWebFragments && reqCreate) {
        const { id: portalId } = portal;
        const { id: requestTypeId } = reqCreate;
        const { headerPanels: headerPanels, subheaderPanels: subheaderPanels, footerPanels: footerPanels, pagePanels: pagePanels } = portalWebFragments;
        const propertyPanels = pagePanels ? pagePanels.propertyPanels : [];
        return {
            ...initialState,
            [$906c876843bd789e$export$3a7728e868aa3ebd('CREATE_REQUEST', Number(portalId), requestTypeId, undefined)]: {
                headerPanels: headerPanels,
                subheaderPanels: subheaderPanels,
                footerPanels: footerPanels,
                propertyPanels: propertyPanels
            }
        };
    }
    return initialState;
};
const $906c876843bd789e$export$49d5fc8cba920a0 = $906c876843bd789e$export$a1659b54bac3252a();
function $906c876843bd789e$export$2e2bcd8739ae039(state = $906c876843bd789e$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $ddmND.FETCH_CONNECT_FRAGMENTS_SUCCESS:
            {
                const { portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, connectFragments: connectFragments, requestKey: requestKey } = action.payload;
                const { headerPanels: headerPanels, subheaderPanels: subheaderPanels, footerPanels: footerPanels, pagePanels: pagePanels } = connectFragments;
                const propertyPanels = pagePanels ? pagePanels.propertyPanels : [];
                return {
                    ...state,
                    [$906c876843bd789e$export$3a7728e868aa3ebd(portalPageName, portalId, requestTypeId, requestKey)]: {
                        headerPanels: headerPanels,
                        subheaderPanels: subheaderPanels,
                        footerPanels: footerPanels,
                        propertyPanels: propertyPanels
                    }
                };
            }
        case 0, $ddmND.FETCH_CONNECT_FRAGMENTS_FAILURE:
            {
                const { portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, error: error, requestKey: requestKey } = action.payload;
                return {
                    ...state,
                    [$906c876843bd789e$export$3a7728e868aa3ebd(portalPageName, portalId, requestTypeId, requestKey)]: {
                        error: error
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("gou3k", function(module, exports) {
$parcel$export(module.exports, "envReducer", () => (parcelRequire("663j1")).default);

var $663j1 = parcelRequire("663j1");

});
parcelRegister("663j1", function(module, exports) {
$parcel$export(module.exports, "default", () => $b250b055de607f60$export$2e2bcd8739ae039);
parcelRequire("l6lPJ");
var $2ccck = parcelRequire("2ccck");

var $hrPHR = parcelRequire("hrPHR");
const $b250b055de607f60$var$getStateFromEnvObject = (envObject)=>({
        headless: envObject.headless,
        wacLink: envObject.wacLink,
        xsrfToken: envObject.xsrfToken,
        baseUrl: envObject.baseUrl,
        mediaApiAppClientId: envObject.mediaApiAppClientId,
        mediaApiExternalUrl: envObject.mediaApiExternalUrl,
        serviceDeskVersion: envObject.serviceDeskVersion,
        featureFlags: envObject.featureFlags,
        contactLink: envObject.contactLink,
        anonymousEnabled: envObject.anonymousEnabled,
        fabricEmojiUrl: envObject.fabricEmojiUrl,
        jiraDisplayUrl: envObject.jiraDisplayUrl,
        helpCenterType: envObject.helpCenterType,
        featuredValues: envObject.featuredValues,
        hoistedProjectKey: envObject.hoistedProjectKey,
        customerAccountAvailabilty: envObject.customerAccountAvailabilty
    });
const $b250b055de607f60$var$defaultState = $b250b055de607f60$var$getStateFromEnvObject((0, $hrPHR.getEnv)());
function $b250b055de607f60$export$2e2bcd8739ae039(state = $b250b055de607f60$var$defaultState, action) {
    switch(action.type){
        case 0, $2ccck.UPDATE_ENV:
            {
                const newState = $b250b055de607f60$var$getStateFromEnvObject(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $2ccck.UPDATE_XSRF:
            return {
                ...state,
                xsrfToken: action.payload
            };
        default:
            return state;
    }
}

});


parcelRegister("6ghQU", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => (parcelRequire("2WELF")).featuredAndSortedPortalsReducer);

var $2WELF = parcelRequire("2WELF");

});
parcelRegister("2WELF", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => $c22e0f433180619b$export$be9fe934804fce97);
parcelRequire("9ueTd");
var $99eJc = parcelRequire("99eJc");
parcelRequire("9FfOm");
var $2CIj9 = parcelRequire("2CIj9");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $c22e0f433180619b$var$FEATURED_PORTALS_LIMIT = 15;
const $c22e0f433180619b$export$1c29b8ca59adcf6d = {
    portals: {},
    orderedPortalIds: [],
    sortBy: 'POPULARITY',
    limit: $c22e0f433180619b$var$FEATURED_PORTALS_LIMIT,
    total: 0,
    isPortalHidingEnabled: false
};
const $c22e0f433180619b$export$eb6ead3c9b4f1957 = (portals)=>{
    return portals.reduce((acc, portalSummary)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        acc[portalSummary.id] = {
            id: portalSummary.id,
            key: portalSummary.key,
            name: portalSummary.name,
            description: portalSummary.description,
            logoUrl: portalSummary.logoUrl,
            isFeatured: 'isFeatured' in portalSummary && portalSummary.isFeatured,
            rank: 'rank' in portalSummary && portalSummary.rank,
            isPortalNotVisibleOnHelpCentre: portalSummary.isPortalNotVisibleOnHelpCentre,
            hiddenFromHomeScreen: 'hiddenFromHomeScreen' in portalSummary && portalSummary.hiddenFromHomeScreen
        };
        return acc;
    }, {});
};
const $c22e0f433180619b$export$67c021876d6362b9 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.featuredAndSortedPortals) {
        const modelResponse = initialModelState.featuredAndSortedPortals;
        return {
            portals: $c22e0f433180619b$export$eb6ead3c9b4f1957(modelResponse.portals),
            orderedPortalIds: modelResponse.portals.map((portal)=>portal.id),
            sortBy: modelResponse.sortBy ? modelResponse.sortBy : 'POPULARITY',
            limit: modelResponse.limit ? modelResponse.limit : $c22e0f433180619b$var$FEATURED_PORTALS_LIMIT,
            total: modelResponse.total ? modelResponse.total : 0,
            isPortalHidingEnabled: modelResponse.isPortalHidingEnabled
        };
    }
    return $c22e0f433180619b$export$1c29b8ca59adcf6d;
};
const $c22e0f433180619b$var$defaultState = $c22e0f433180619b$export$67c021876d6362b9();
/**
 * This method is to return only those portals which are not already stored
 * This ensures that the rank and isFeatured values stored in existing data will not get overridden with new data missing these values
 */ const $c22e0f433180619b$var$getPortalsNotAlreadyStored = (storedPortals, portals)=>{
    return portals.filter((portal)=>!storedPortals[portal.id]);
};
const $c22e0f433180619b$var$updateFeaturedPortals = (state, updatedFeaturedPortalIds, updatedOrderedPortalIds, hiddenPortalIds)=>{
    const portals = {};
    updatedOrderedPortalIds.forEach((portalId)=>{
        portals[portalId] = {
            id: portalId,
            key: state.portals[portalId].key,
            name: state.portals[portalId].name,
            description: state.portals[portalId].description,
            logoUrl: state.portals[portalId].logoUrl,
            isPortalNotVisibleOnHelpCentre: state.portals[portalId].isPortalNotVisibleOnHelpCentre,
            isFeatured: false,
            hiddenFromHomeScreen: hiddenPortalIds.includes(portalId),
            rank: -1
        };
    });
    updatedFeaturedPortalIds.forEach((portalId, index)=>{
        portals[portalId] = {
            ...portals[portalId],
            isFeatured: true,
            rank: index
        };
    });
    return portals;
};
function $c22e0f433180619b$export$be9fe934804fce97(state = $c22e0f433180619b$var$defaultState, action) {
    switch(action.type){
        case 0, $99eJc.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS:
            return $c22e0f433180619b$var$handleFetchFeaturedAndSortedPortalsSuccess(action, state);
        case 0, $99eJc.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE:
            return $c22e0f433180619b$var$handleFetchFeaturedAndSortedPortalsFailure(action, state);
        case 0, $99eJc.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $c22e0f433180619b$var$handleUpdatePortalReorderSettingsSuccess(action, state);
        default:
            return state;
    }
}
const $c22e0f433180619b$var$handleFetchFeaturedAndSortedPortalsSuccess = (action, state)=>{
    const { portals: portals, sortBy: sortBy, limit: limit, total: total, isPortalHidingEnabled: isPortalHidingEnabled } = action.payload;
    /* On help seeker screen */ if (!action.requestParams.isPortalReorderingSelected) {
        /* On clicking exploreAll */ if (action.requestParams.exploreAll) return {
            ...state,
            portals: {
                ...state.portals,
                ...$c22e0f433180619b$export$eb6ead3c9b4f1957($c22e0f433180619b$var$getPortalsNotAlreadyStored(state.portals, portals))
            },
            orderedPortalIds: portals.map((portal)=>portal.id)
        };
        /* initial load */ return {
            ...state,
            isPortalHidingEnabled: isPortalHidingEnabled,
            portals: $c22e0f433180619b$export$eb6ead3c9b4f1957(portals),
            orderedPortalIds: portals.map((portal)=>portal.id),
            sortBy: sortBy ? sortBy : 'POPULARITY',
            limit: limit ? limit : $c22e0f433180619b$var$FEATURED_PORTALS_LIMIT,
            total: total ? total : 0,
            error: undefined
        };
    }
    /* On Portal reordering screen initial load */ if (!action.requestParams.sortBy) return {
        ...state,
        isPortalHidingEnabled: isPortalHidingEnabled,
        portals: $c22e0f433180619b$export$eb6ead3c9b4f1957(portals),
        orderedPortalIds: portals.map((portal)=>portal.id),
        sortBy: sortBy ? sortBy : 'POPULARITY',
        limit: limit ? limit : $c22e0f433180619b$var$FEATURED_PORTALS_LIMIT,
        total: total ? total : 0,
        error: undefined
    };
    return state;
};
const $c22e0f433180619b$var$handleFetchFeaturedAndSortedPortalsFailure = (action, state)=>{
    const { error: error } = action.payload;
    const errorObject = {
        status: error.status,
        message: (error.errorMessages || [])[0],
        callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
        callToActionText: error.nextActionDisplayText || ''
    };
    /* Error in both help center and portal reordering view initial loads */ if (!action.requestParams.sortBy) return {
        ...state,
        error: errorObject
    };
    return state;
};
const $c22e0f433180619b$var$handleUpdatePortalReorderSettingsSuccess = (action, state)=>{
    const { featuredPortalIds: featuredPortalIds, sortBy: sortBy, orderedPortalIds: orderedPortalIds, hiddenPortalIds: hiddenPortalIds } = action.payload;
    const portals = $c22e0f433180619b$var$updateFeaturedPortals(state, featuredPortalIds, orderedPortalIds, hiddenPortalIds);
    const total = Object.values(portals).filter((portal)=>!(0, $2CIj9.isHiddenPortal)(portal)).length;
    return {
        ...state,
        sortBy: sortBy,
        orderedPortalIds: orderedPortalIds,
        portals: portals,
        total: total
    };
};

});
parcelRegister("9FfOm", function(module, exports) {
$parcel$export(module.exports, "getFeaturedPortalsInSortedOrderByRank", () => (parcelRequire("2CIj9")).getFeaturedPortalsInSortedOrderByRank);
$parcel$export(module.exports, "isFeaturedPortal", () => (parcelRequire("2CIj9")).isFeaturedPortal);
$parcel$export(module.exports, "isHiddenPortal", () => (parcelRequire("2CIj9")).isHiddenPortal);
$parcel$export(module.exports, "getPortals", () => (parcelRequire("2CIj9")).getPortals);
$parcel$export(module.exports, "getSortBy", () => (parcelRequire("2CIj9")).getSortBy);
$parcel$export(module.exports, "getLimit", () => (parcelRequire("2CIj9")).getLimit);
$parcel$export(module.exports, "getIsDirty", () => (parcelRequire("2CIj9")).getIsDirty);
$parcel$export(module.exports, "getIsReorderingExperienceLoading", () => (parcelRequire("2CIj9")).getIsReorderingExperienceLoading);
$parcel$export(module.exports, "getIsSortedDataLoading", () => (parcelRequire("2CIj9")).getIsSortedDataLoading);
$parcel$export(module.exports, "getTotal", () => (parcelRequire("2CIj9")).getTotal);
$parcel$export(module.exports, "getfeaturedAndSortedPortalsError", () => (parcelRequire("2CIj9")).getfeaturedAndSortedPortalsError);
$parcel$export(module.exports, "getUIFeaturedPortalIds", () => (parcelRequire("2CIj9")).getUIFeaturedPortalIds);
$parcel$export(module.exports, "getUISortBy", () => (parcelRequire("2CIj9")).getUISortBy);
$parcel$export(module.exports, "getUIOrderedPortalIds", () => (parcelRequire("2CIj9")).getUIOrderedPortalIds);
$parcel$export(module.exports, "getPersistedOrderedPortalIds", () => (parcelRequire("2CIj9")).getPersistedOrderedPortalIds);
$parcel$export(module.exports, "getIsSaveInProgress", () => (parcelRequire("2CIj9")).getIsSaveInProgress);
$parcel$export(module.exports, "getDefaultViewLoading", () => (parcelRequire("2CIj9")).getDefaultViewLoading);
$parcel$export(module.exports, "getIsPortalReorderingDataLoaded", () => (parcelRequire("2CIj9")).getIsPortalReorderingDataLoaded);
$parcel$export(module.exports, "getUIHiddenPortalIds", () => (parcelRequire("2CIj9")).getUIHiddenPortalIds);
$parcel$export(module.exports, "getIsPortalHidingEnabled", () => (parcelRequire("2CIj9")).getIsPortalHidingEnabled);
$parcel$export(module.exports, "getTotalVisiblePortalCount", () => (parcelRequire("2CIj9")).getTotalVisiblePortalCount);
$parcel$export(module.exports, "getAllVisiblePortals", () => (parcelRequire("2CIj9")).getAllVisiblePortals);
$parcel$export(module.exports, "getDefaultViewPortals", () => (parcelRequire("2CIj9")).getDefaultViewPortals);
$parcel$export(module.exports, "getFeaturedPortalsUI", () => (parcelRequire("2CIj9")).getFeaturedPortalsUI);
$parcel$export(module.exports, "getUnFeaturedPortalsUI", () => (parcelRequire("2CIj9")).getUnFeaturedPortalsUI);

var $2CIj9 = parcelRequire("2CIj9");

});
parcelRegister("2CIj9", function(module, exports) {
$parcel$export(module.exports, "getFeaturedPortalsInSortedOrderByRank", () => $17a7108fdf0ba41f$export$92cc2a471200c3dd);
$parcel$export(module.exports, "isFeaturedPortal", () => $17a7108fdf0ba41f$export$4758cf9aa2bbe6ae);
$parcel$export(module.exports, "isHiddenPortal", () => $17a7108fdf0ba41f$export$40fc3a80f8881250);
$parcel$export(module.exports, "getPersistedOrderedPortalIds", () => $17a7108fdf0ba41f$export$22d41892c655b6a1);
$parcel$export(module.exports, "getUIFeaturedPortalIds", () => $17a7108fdf0ba41f$export$9d389d624d531812);
$parcel$export(module.exports, "getUIHiddenPortalIds", () => $17a7108fdf0ba41f$export$8bc764a453455857);
$parcel$export(module.exports, "getUIOrderedPortalIds", () => $17a7108fdf0ba41f$export$e907b47f94c1ad77);
$parcel$export(module.exports, "getUISortBy", () => $17a7108fdf0ba41f$export$3d2a08be86a3576b);
$parcel$export(module.exports, "getPortals", () => $17a7108fdf0ba41f$export$9fa4c2091a9d3b38);
$parcel$export(module.exports, "getSortBy", () => $17a7108fdf0ba41f$export$c7052c2989e7b681);
$parcel$export(module.exports, "getLimit", () => $17a7108fdf0ba41f$export$fb8ce379717a383d);
$parcel$export(module.exports, "getIsDirty", () => $17a7108fdf0ba41f$export$4b1964ee9ad6f220);
$parcel$export(module.exports, "getTotal", () => $17a7108fdf0ba41f$export$94860ac4a286a8d9);
$parcel$export(module.exports, "getfeaturedAndSortedPortalsError", () => $17a7108fdf0ba41f$export$9a33f9aea44dc01f);
$parcel$export(module.exports, "getIsReorderingExperienceLoading", () => $17a7108fdf0ba41f$export$8cc97acec2e1b274);
$parcel$export(module.exports, "getIsSortedDataLoading", () => $17a7108fdf0ba41f$export$20cc91a7c763745e);
$parcel$export(module.exports, "getIsSaveInProgress", () => $17a7108fdf0ba41f$export$3f495b2b37e734f1);
$parcel$export(module.exports, "getIsPortalReorderingDataLoaded", () => $17a7108fdf0ba41f$export$3e1f7fc063cfb951);
$parcel$export(module.exports, "getDefaultViewLoading", () => $17a7108fdf0ba41f$export$2b83ab3fa69f277d);
$parcel$export(module.exports, "getIsPortalHidingEnabled", () => $17a7108fdf0ba41f$export$6113b36bf23cc2fe);
$parcel$export(module.exports, "getAllVisiblePortals", () => $17a7108fdf0ba41f$export$30b34a0e1d7ec1fa);
$parcel$export(module.exports, "getDefaultViewPortals", () => $17a7108fdf0ba41f$export$35863edd27d88bac);
$parcel$export(module.exports, "getTotalVisiblePortalCount", () => $17a7108fdf0ba41f$export$22b4f0e1072fa163);
$parcel$export(module.exports, "getFeaturedPortalsUI", () => $17a7108fdf0ba41f$export$2650dad54aca58e1);
$parcel$export(module.exports, "getUnFeaturedPortalsUI", () => $17a7108fdf0ba41f$export$2834f451d5fc36b1);

var $ehscL = parcelRequire("ehscL");

var $gk18s = parcelRequire("gk18s");
const $17a7108fdf0ba41f$var$MAX_PORTAL_CARDS = 9;
const $17a7108fdf0ba41f$var$getPersistedPortals = (state)=>{
    return state.persisted.featuredAndSortedPortals.portals;
};
const $17a7108fdf0ba41f$var$nanToZero = (rank)=>rank || 0;
const $17a7108fdf0ba41f$export$92cc2a471200c3dd = (portals)=>{
    return Object.values(portals).filter((portal)=>$17a7108fdf0ba41f$export$4758cf9aa2bbe6ae(portal)).sort((portal1, portal2)=>$17a7108fdf0ba41f$var$nanToZero(portal1.rank) - $17a7108fdf0ba41f$var$nanToZero(portal2.rank));
};
const $17a7108fdf0ba41f$export$4758cf9aa2bbe6ae = (portal)=>'isFeatured' in portal && portal.isFeatured;
const $17a7108fdf0ba41f$export$40fc3a80f8881250 = (portal)=>'hiddenFromHomeScreen' in portal && !!portal.hiddenFromHomeScreen;
const $17a7108fdf0ba41f$export$50625c10d80bbff6 = (portal)=>'isFeatured' in portal && !portal.isFeatured;
const $17a7108fdf0ba41f$export$22d41892c655b6a1 = (state)=>{
    return state.persisted.featuredAndSortedPortals.orderedPortalIds;
};
const $17a7108fdf0ba41f$export$9d389d624d531812 = (state)=>{
    return state.ui.featuredAndSortedPortals.featuredPortalIds;
};
const $17a7108fdf0ba41f$export$8bc764a453455857 = (state)=>{
    return state.ui.featuredAndSortedPortals.hiddenPortalIds;
};
const $17a7108fdf0ba41f$export$e907b47f94c1ad77 = (state)=>{
    return state.ui.featuredAndSortedPortals.orderedPortalIds;
};
const $17a7108fdf0ba41f$export$3d2a08be86a3576b = (state)=>{
    return state.ui.featuredAndSortedPortals.sortBy;
};
const $17a7108fdf0ba41f$export$9fa4c2091a9d3b38 = (state)=>{
    return state.persisted.featuredAndSortedPortals.portals;
};
const $17a7108fdf0ba41f$export$c7052c2989e7b681 = (state)=>{
    return state.persisted.featuredAndSortedPortals.sortBy;
};
const $17a7108fdf0ba41f$export$fb8ce379717a383d = (state)=>{
    return state.persisted.featuredAndSortedPortals.limit;
};
const $17a7108fdf0ba41f$export$4b1964ee9ad6f220 = (state)=>{
    return state.ui.featuredAndSortedPortals.isDirty;
};
const $17a7108fdf0ba41f$export$94860ac4a286a8d9 = (state)=>{
    return state.persisted.featuredAndSortedPortals.total;
};
const $17a7108fdf0ba41f$export$9a33f9aea44dc01f = (state)=>{
    return state.persisted.featuredAndSortedPortals.error;
};
const $17a7108fdf0ba41f$export$8cc97acec2e1b274 = (state)=>{
    return state.ui.featuredAndSortedPortals.isReorderingExperienceLoading;
};
const $17a7108fdf0ba41f$export$20cc91a7c763745e = (state)=>{
    return state.ui.featuredAndSortedPortals.isSortedDataLoading;
};
const $17a7108fdf0ba41f$export$3f495b2b37e734f1 = (state)=>{
    return state.ui.featuredAndSortedPortals.isSaveInProgress;
};
const $17a7108fdf0ba41f$export$3e1f7fc063cfb951 = (state)=>{
    return state.ui.featuredAndSortedPortals.isPortalReorderingDataLoaded;
};
const $17a7108fdf0ba41f$export$2b83ab3fa69f277d = (state)=>{
    return state.ui.featuredAndSortedPortals.isDefaultViewLoading;
};
const $17a7108fdf0ba41f$export$2cff399032fd66c7 = (state)=>{
    return state.ui.featuredAndSortedPortals.isExpandedViewLoading;
};
const $17a7108fdf0ba41f$export$6113b36bf23cc2fe = (state)=>{
    return state.persisted.featuredAndSortedPortals.isPortalHidingEnabled;
};
const $17a7108fdf0ba41f$export$30b34a0e1d7ec1fa = (0, $ehscL.createSelector)($17a7108fdf0ba41f$var$getPersistedPortals, (persistedPortals)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return Object.values(persistedPortals).filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre);
});
const $17a7108fdf0ba41f$export$731766e21e298d5 = (0, $ehscL.createSelector)($17a7108fdf0ba41f$export$30b34a0e1d7ec1fa, (allVisiblePortals)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Object.values(allVisiblePortals).filter((portal)=>!$17a7108fdf0ba41f$export$40fc3a80f8881250(portal));
});
const $17a7108fdf0ba41f$export$35863edd27d88bac = (0, $ehscL.createSelector)($17a7108fdf0ba41f$var$getPersistedPortals, $17a7108fdf0ba41f$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    const featuredPortals = $17a7108fdf0ba41f$export$92cc2a471200c3dd(persistedPortals).filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre).filter((portal)=>!$17a7108fdf0ba41f$export$40fc3a80f8881250(portal));
    if (featuredPortals.length > 0) return featuredPortals;
    return persistedOrderedPortalIds.filter((portalId)=>!persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$17a7108fdf0ba41f$export$40fc3a80f8881250(portal)).slice(0, Math.min(persistedOrderedPortalIds.length, $17a7108fdf0ba41f$var$MAX_PORTAL_CARDS));
});
const $17a7108fdf0ba41f$export$22b4f0e1072fa163 = (0, $ehscL.createSelector)($17a7108fdf0ba41f$var$getPersistedPortals, $17a7108fdf0ba41f$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    if ((0, $gk18s.isKoshEnabledForDefaultHelpCenter)()) return persistedOrderedPortalIds.length;
    return persistedOrderedPortalIds.filter((portalId)=>!persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).length;
});
const $17a7108fdf0ba41f$export$7a3c1f03fc45a503 = (0, $ehscL.createSelector)($17a7108fdf0ba41f$var$getPersistedPortals, $17a7108fdf0ba41f$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.filter((portalId)=>{
        var _persistedPortals$por;
        return !((_persistedPortals$por = persistedPortals[portalId]) !== null && _persistedPortals$por !== void 0 && _persistedPortals$por.isPortalNotVisibleOnHelpCentre);
    }).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$17a7108fdf0ba41f$export$40fc3a80f8881250(portal)).length;
});
const $17a7108fdf0ba41f$export$7574c566fd98dead = (0, $ehscL.createSelector)($17a7108fdf0ba41f$var$getPersistedPortals, $17a7108fdf0ba41f$export$35863edd27d88bac, $17a7108fdf0ba41f$export$22d41892c655b6a1, (persistedPortals, defaultViewPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.filter((portalId)=>!defaultViewPortals.some((defaultViewPortal)=>portalId === defaultViewPortal.id) && !persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$17a7108fdf0ba41f$export$40fc3a80f8881250(portal));
});
const $17a7108fdf0ba41f$export$bf663b849d73b99a = (0, $ehscL.createSelector)($17a7108fdf0ba41f$var$getPersistedPortals, (persistedPortals)=>{
    return $17a7108fdf0ba41f$export$92cc2a471200c3dd(persistedPortals);
});
const $17a7108fdf0ba41f$export$e666136461a3c9a3 = (0, $ehscL.createSelector)($17a7108fdf0ba41f$export$bf663b849d73b99a, (featuredPortals)=>{
    return featuredPortals.filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre).length;
});
const $17a7108fdf0ba41f$export$2706ef7f7cb3a94c = (0, $ehscL.createSelector)($17a7108fdf0ba41f$var$getPersistedPortals, $17a7108fdf0ba41f$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.map((portalId)=>persistedPortals[portalId]).filter($17a7108fdf0ba41f$export$50625c10d80bbff6);
});
const $17a7108fdf0ba41f$export$2650dad54aca58e1 = (0, $ehscL.createSelector)($17a7108fdf0ba41f$export$9d389d624d531812, $17a7108fdf0ba41f$var$getPersistedPortals, $17a7108fdf0ba41f$export$8bc764a453455857, (uiFeaturedPortalIds, persistedPortals, uiHiddenPortalIds)=>{
    return uiFeaturedPortalIds.map((portalId)=>{
        const portal = persistedPortals[portalId];
        return {
            ...portal,
            isFeatured: true,
            rank: $17a7108fdf0ba41f$export$4758cf9aa2bbe6ae(portal) ? portal.rank : -1,
            hiddenFromHomeScreen: uiHiddenPortalIds.includes(portalId)
        };
    });
});
const $17a7108fdf0ba41f$export$2834f451d5fc36b1 = (0, $ehscL.createSelector)($17a7108fdf0ba41f$export$e907b47f94c1ad77, $17a7108fdf0ba41f$export$9d389d624d531812, $17a7108fdf0ba41f$var$getPersistedPortals, $17a7108fdf0ba41f$export$8bc764a453455857, (uiOrderedPortalIds, uiFeaturedPortalIds, persistedPortals, uiHiddenPortalIds)=>{
    return uiOrderedPortalIds.filter((portalId)=>!uiFeaturedPortalIds.includes(portalId)).map((portalId)=>({
            ...persistedPortals[portalId],
            isFeatured: false,
            rank: -1,
            hiddenFromHomeScreen: uiHiddenPortalIds.includes(portalId)
        }));
});

});




parcelRegister("aNSoj", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordReducer", () => (parcelRequire("7e7P5")).forgotPasswordReducer);

var $7e7P5 = parcelRequire("7e7P5");

});
parcelRegister("7e7P5", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordReducer", () => $ef95c093d1376c87$export$545b1c441fc64b70);

var $2O4bV = parcelRequire("2O4bV");
parcelRequire("hXKIi");
var $6Dmyj = parcelRequire("6Dmyj");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $ef95c093d1376c87$export$4ad260a5db9e01cf = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.forgotPassword) return {
        forgotPassword: initialModelState.forgotPassword
    };
    return {};
};
const $ef95c093d1376c87$var$defaultState = $ef95c093d1376c87$export$4ad260a5db9e01cf();
function $ef95c093d1376c87$export$545b1c441fc64b70(state = $ef95c093d1376c87$var$defaultState, action) {
    switch(action.type){
        case 0, $2O4bV.FETCH_FORGOT_PASSWORD_MODEL:
            if (state && 'error' in state) return {};
            return state;
        // We want to override the portal data if request create fails as well.
        case 0, $6Dmyj.FETCH_FORGOT_PASSWORD_FAILURE:
            {
                const fetchForgotPasswordFailureAction = action;
                const { error: error } = fetchForgotPasswordFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    error: errorObject
                };
            }
        case 0, $6Dmyj.FETCH_FORGOT_PASSWORD_SUCCESS:
            {
                const fetchPForgotPasswordSuccessAction = action;
                const response = fetchPForgotPasswordSuccessAction.payload;
                return {
                    forgotPassword: {
                        ...response
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("4k1JJ", function(module, exports) {
$parcel$export(module.exports, "helpcenterReducer", () => (parcelRequire("j2oW4")).default);

var $j2oW4 = parcelRequire("j2oW4");

});
parcelRegister("j2oW4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab33740e343f9b88$export$2e2bcd8739ae039);

var $HGACo = parcelRequire("HGACo");

var $4mb4P = parcelRequire("4mb4P");

var $1We2B = parcelRequire("1We2B");
parcelRequire("RlLTp");
var $6DnuY = parcelRequire("6DnuY");

var $1EFS8 = parcelRequire("1EFS8");

var $gk18s = parcelRequire("gk18s");

var $gk18s = parcelRequire("gk18s");

var $9EsDH = parcelRequire("9EsDH");
function $ab33740e343f9b88$var$reduceHCBrandingToState(helpCenterBrandingResponse) {
    const translationState = (0, $1We2B.mapValues)(helpCenterBrandingResponse.translations, (translation)=>({
            ...translation
        }));
    const isAdvancedHelpCenterThemingEnabled = (0, $HGACo.isCustomThemingEnabled)() && ((0, $gk18s.isAdvancedHelpCenter)() || (0, $gk18s.isDefaultHelpCenter)());
    const isDefaultNavColorAsBannerColorEnabled = (0, $1EFS8.default).checkGate('default_navigation_color_as_banner_color');
    const portalThemeColor = helpCenterBrandingResponse.portalThemeColor || '#0074e0';
    return {
        logoUrl: helpCenterBrandingResponse.logoUrl,
        logoMediaApiFileId: helpCenterBrandingResponse.logoId,
        sharedPortalName: helpCenterBrandingResponse.sharedPortalName,
        translations: translationState,
        helpCenterBannerUrl: helpCenterBrandingResponse.useDefaultBanner ? (0, (/*@__PURE__*/$parcel$interopDefault($4mb4P))) : helpCenterBrandingResponse.bannerMediaApiUrl,
        bannerMediaApiFileId: helpCenterBrandingResponse.bannerMediaApiFileId,
        canCustomizeHelpCenter: !!helpCenterBrandingResponse.canEditAnnouncement,
        helpCenterTitle: helpCenterBrandingResponse.helpCenterTitle,
        helpCenterTitleColor: helpCenterBrandingResponse.helpCenterTitleColor,
        ...(0, $HGACo.isUseHelpCenterRefresh)() ? {
            topBarColor: helpCenterBrandingResponse.topBarColor || (isDefaultNavColorAsBannerColorEnabled ? portalThemeColor : '#FFFFFF'),
            // fallback if BE fails to give this in model response
            topBarTextColor: helpCenterBrandingResponse.topBarTextColor || (isDefaultNavColorAsBannerColorEnabled ? helpCenterBrandingResponse.helpCenterTitleColor : '#172B4D'),
            hasTopBarBeenSplit: helpCenterBrandingResponse.hasTopBarBeenSplit ?? false
        } : {},
        rawBrandingResponse: helpCenterBrandingResponse,
        announcementHeader: helpCenterBrandingResponse.userInitialAnnouncementHeader,
        announcementMessage: helpCenterBrandingResponse.userInitialAnnouncementMessageWiki,
        useDefaultBanner: helpCenterBrandingResponse.useDefaultBanner,
        isLoaded: true,
        ...isAdvancedHelpCenterThemingEnabled ? {} : {
            themeColor: portalThemeColor
        }
    };
}
function $ab33740e343f9b88$var$reduceHelpCenterToState(helpCenterResponse) {
    const newState = helpCenterResponse.kbs && helpCenterResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            appLinkUrl: helpCenterResponse.kbs.appLinkUrl,
            kbLinkDomainURLs: helpCenterResponse.kbs.kbLinkDomainURLs
        }
    } : {};
    return {
        ...newState,
        isLoaded: true
    };
}
const $ab33740e343f9b88$var$getInitialBrandingState = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.helpCenterBranding) return $ab33740e343f9b88$var$reduceHCBrandingToState(initialModelState.helpCenterBranding);
    return undefined;
};
const $ab33740e343f9b88$var$getInitialHelpCenterState = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.sharedPortal) return $ab33740e343f9b88$var$reduceHelpCenterToState(initialModelState.sharedPortal);
    return undefined;
};
const $ab33740e343f9b88$var$getInitialIsBrandingLoadedFlag = ()=>{
    if ((0, $HGACo.isIncreasedFlexibilityEnabled)()) {
        const initialModelState = (0, $9EsDH.default)();
        if (initialModelState && initialModelState.helpCenterBranding) return true;
    }
    return false;
};
const $ab33740e343f9b88$var$getDefaultState = ()=>({
        sharedPortalName: '',
        helpCenterTitle: '',
        helpCenterTitleColor: '#FFFFFF',
        // do not tokenize as of now (this might fail on the polished methods)
        topBarColor: '#FFFFFF',
        // do not tokenize as of now (this might fail on the polished methods)
        topBarTextColor: '#0D1424',
        // do not tokenize as of now (this might fail on the polished methods)
        translations: {
            'en-US': {
                sharedPortalName: '',
                helpCenterTitle: '',
                localeDisplayName: ''
            }
        },
        canCustomizeHelpCenter: false,
        isLoaded: false,
        themeColor: '#0052CC',
        // do not tokenize as of now (this will fail on the polished methods)
        useDefaultBanner: true,
        ...$ab33740e343f9b88$var$getInitialHelpCenterState(),
        ...$ab33740e343f9b88$var$getInitialBrandingState(),
        isBrandingLoaded: $ab33740e343f9b88$var$getInitialIsBrandingLoadedFlag()
    });
function $ab33740e343f9b88$export$2e2bcd8739ae039(state = $ab33740e343f9b88$var$getDefaultState(), action) {
    switch(action.type){
        case 0, $6DnuY.UPDATE_HELP_CENTER_THEME_COLOR:
            return {
                ...state,
                ...action.payload
            };
        case 0, $6DnuY.UPDATE_HELP_CENTER_MODEL:
            {
                const newState = $ab33740e343f9b88$var$reduceHelpCenterToState(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $6DnuY.UPDATE_HELP_CENTER_BRANDING_MODEL:
            {
                const newState = $ab33740e343f9b88$var$reduceHCBrandingToState(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $6DnuY.UPDATE_HELP_CENTER_BRANDING_LOADER:
            return {
                ...state,
                isBrandingLoaded: action.payload.loaded
            };
        default:
            return state;
    }
}

});
parcelRegister("4mb4P", function(module, exports) {
module.exports = new URL("../images/default-banner.8e21c182.png", import.meta.url).toString();

});



parcelRegister("1GPF1", function(module, exports) {
$parcel$export(module.exports, "articlesReducer", () => (parcelRequire("e7Rzo")).default);

var $e7Rzo = parcelRequire("e7Rzo");

});
parcelRegister("e7Rzo", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1888f5eabf118fa$export$2e2bcd8739ae039);

var $hPLrQ = parcelRequire("hPLrQ");
parcelRequire("gExuy");
var $4W5Ru = parcelRequire("4W5Ru");

var $lx3a0 = parcelRequire("lx3a0");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $c1888f5eabf118fa$var$reduceArticle = (article)=>({
        editUrl: '',
        id: `${article.id}`,
        isFeatured: false,
        friendlyLastModified: '',
        lastModified: '',
        shareUrl: '',
        summaryExcerpt: '',
        title: article.title,
        titleExcerpt: article.title,
        viewCount: -1,
        viewUrl: article.url,
        projects: article.projects,
        space: article.space,
        hostname: article.hostname
    });
const $c1888f5eabf118fa$var$getArticleId = (article)=>article.idInString;
const $c1888f5eabf118fa$var$getInitialState = ()=>{
    const models = (0, $9EsDH.default)();
    return {
        articles: {},
        legacyArticles: models.kbPage ? {
            [$c1888f5eabf118fa$var$getArticleId(models.kbPage)]: $c1888f5eabf118fa$var$reduceArticle(models.kbPage)
        } : {}
    };
};
const $c1888f5eabf118fa$var$defaultState = $c1888f5eabf118fa$var$getInitialState();
function $c1888f5eabf118fa$export$2e2bcd8739ae039(state = $c1888f5eabf118fa$var$defaultState, action) {
    switch(action.type){
        case 0, $hPLrQ.FETCH_ARTICLES:
            {
                const { categoryId: categoryId } = action.payload;
                if (state.articles[categoryId] && 'error' in state.articles[categoryId]) {
                    const newState = {
                        ...state,
                        articles: {
                            ...state.articles
                        }
                    };
                    delete newState.articles[categoryId];
                    return newState;
                }
                return state;
            }
        case 0, $lx3a0.FETCH_ARTICLES_SUCCESS:
            {
                const { categoryId: categoryId, response: { results: articles } } = action.payload;
                return {
                    ...state,
                    articles: {
                        ...state.articles,
                        [categoryId]: {
                            articles: articles.map(({ featuredInCategories: featuredInCategories, ...article })=>({
                                    ...article,
                                    isFeatured: !!featuredInCategories && featuredInCategories.includes(categoryId)
                                }))
                        }
                    }
                };
            }
        case 0, $lx3a0.FETCH_ARTICLES_FAILURE:
            {
                const { portalId: portalId, categoryId: categoryId, error: apolloError } = action.payload;
                return {
                    ...state,
                    articles: {
                        ...state.articles,
                        [categoryId]: {
                            articles: [],
                            error: {
                                error: {
                                    status: apolloError.statusCode,
                                    message: apolloError.errorMessage,
                                    callToActionText: 'Go back',
                                    callToActionUrl: `/portal/${portalId}`
                                }
                            }
                        }
                    }
                };
            }
        case 0, $4W5Ru.FETCH_ARTICLE:
            {
                const { id: id } = action.payload.params;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        case 0, $4W5Ru.FETCH_ARTICLE_SPACE_KEY:
            {
                const { articleId: id } = action.payload;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        case 0, $4W5Ru.FETCH_ARTICLE_SUCCESS:
            {
                const articleId = action.payload.idInString;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [articleId]: $c1888f5eabf118fa$var$reduceArticle(action.payload)
                    }
                };
            }
        case 0, $4W5Ru.FETCH_ARTICLE_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [action.payload.id]: {
                            error: {
                                // We really only care about the first error message
                                // grab it and throw the rest away
                                status: error.status,
                                message: (error.errorMessages || [])[0],
                                // Remove basename from the URL, we don't need it as the basename
                                // is already set inside react router.
                                // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                                callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                                callToActionText: error.nextActionDisplayText || ''
                            }
                        }
                    }
                };
            }
        case 0, $4W5Ru.FETCH_CROSS_SITE_ARTICLE:
            {
                const { articleId: id } = action.payload;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        case 0, $4W5Ru.FETCH_ARTICLE_SPACE_KEY_SUCCESS:
            {
                const { spaceKey: spaceKey, id: id } = action.payload;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [id]: $c1888f5eabf118fa$var$reduceArticle({
                            ...action.payload,
                            space: {
                                key: spaceKey,
                                id: undefined
                            }
                        })
                    }
                };
            }
        case 0, $4W5Ru.FETCH_ARTICLE_SPACE_KEY_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [action.payload.id]: {
                            error: {
                                // We really only care about the first error message
                                // grab it and throw the rest away
                                status: error.status,
                                message: (error.errorMessages || [])[0],
                                // Remove basename from the URL, we don't need it as the basename
                                // is already set inside react router.
                                // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                                callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                                callToActionText: error.nextActionDisplayText || ''
                            }
                        }
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("le42D", function(module, exports) {
$parcel$export(module.exports, "languagesReducer", () => (parcelRequire("ikJcW")).languagesReducer);

var $ikJcW = parcelRequire("ikJcW");

});
parcelRegister("ikJcW", function(module, exports) {
$parcel$export(module.exports, "languagesReducer", () => $524fb87810710bbf$export$675c3b6bfa6435e6);
parcelRequire("jFxFC");
var $7YnYX = parcelRequire("7YnYX");

var $aB0yS = parcelRequire("aB0yS");

var $9EsDH = parcelRequire("9EsDH");
const $524fb87810710bbf$export$ef8b6f0b1af42002 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState) {
        const languages = initialModelState.availableLanguages === undefined ? [] : (0, $aB0yS.ensureConsistentResponses)(initialModelState.availableLanguages);
        return {
            languages: languages
        };
    }
    return {
        languages: []
    };
};
const $524fb87810710bbf$var$defaultState = $524fb87810710bbf$export$ef8b6f0b1af42002();
function $524fb87810710bbf$export$675c3b6bfa6435e6(state = $524fb87810710bbf$var$defaultState, action) {
    switch(action.type){
        case 0, $7YnYX.FETCH_LANGUAGES_SUCCESS:
            return $524fb87810710bbf$var$handleFetchLanguagesSuccess(state, action);
        default:
            return state;
    }
}
const $524fb87810710bbf$var$handleFetchLanguagesSuccess = (state, action)=>({
        ...state,
        languages: (0, $aB0yS.ensureConsistentResponses)(action.payload.languages)
    });

});
parcelRegister("aB0yS", function(module, exports) {
$parcel$export(module.exports, "ensureConsistentKey", () => $d3c2046166903da4$export$6117ad7803ddf800);
$parcel$export(module.exports, "ensureConsistentResponses", () => $d3c2046166903da4$export$131bf7a7b9860e71);
const $d3c2046166903da4$export$6117ad7803ddf800 = (localeKey)=>localeKey.replace('_', '-');
const $d3c2046166903da4$var$ensureConsistentResponse = (response)=>({
        key: $d3c2046166903da4$export$6117ad7803ddf800(response.key),
        originalKey: response.key,
        displayName: response.displayName
    });
const $d3c2046166903da4$export$131bf7a7b9860e71 = (responses)=>responses.map((response)=>$d3c2046166903da4$var$ensureConsistentResponse(response));

});



parcelRegister("2STkY", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("3Nrzs")).default);

var $3Nrzs = parcelRequire("3Nrzs");

});
parcelRegister("3Nrzs", function(module, exports) {
$parcel$export(module.exports, "default", () => $177347f12150e3f9$export$2e2bcd8739ae039);
parcelRequire("4q6WZ");
var $lgI4C = parcelRequire("lgI4C");
const $177347f12150e3f9$var$defaultState = {
    linkedSpaces: []
};
function $177347f12150e3f9$export$2e2bcd8739ae039(state = $177347f12150e3f9$var$defaultState, action) {
    switch(action.type){
        case 0, $lgI4C.FETCH_LINKED_SPACES:
            return {
                ...state,
                error: undefined
            };
        case 0, $lgI4C.FETCH_LINKED_SPACES_SUCCESS:
            {
                const { linkedSpaces: linkedSpaces } = action.payload;
                return {
                    ...state,
                    linkedSpaces: linkedSpaces || [],
                    error: undefined
                };
            }
        case 0, $lgI4C.FETCH_LINKED_SPACES_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    error: {
                        error: {
                            status: error.status,
                            message: error.message || 'Failed to fetch linked spaces',
                            callToActionText: '',
                            callToActionUrl: ''
                        }
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("dEq0z", function(module, exports) {
$parcel$export(module.exports, "loginReducer", () => (parcelRequire("g2Vaa")).loginReducer);

var $g2Vaa = parcelRequire("g2Vaa");

});
parcelRegister("g2Vaa", function(module, exports) {
$parcel$export(module.exports, "loginReducer", () => $2daf3810e01b45a4$export$3d13b312f34d11e5);

var $dUoD8 = parcelRequire("dUoD8");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $2daf3810e01b45a4$export$5b80378ff66478a5 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.login) return {
        login: initialModelState.login
    };
    return {};
};
const $2daf3810e01b45a4$var$defaultState = $2daf3810e01b45a4$export$5b80378ff66478a5();
function $2daf3810e01b45a4$export$3d13b312f34d11e5(state = $2daf3810e01b45a4$var$defaultState, action) {
    switch(action.type){
        case 0, $dUoD8.FETCH_LOGIN_MODEL:
            if (state && 'error' in state) return {};
            return state;
        // We want to override the portal data if request create fails as well.
        case 0, $uiV1X.FETCH_LOGIN_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error } = fetchPortalFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    error: errorObject
                };
            }
        case 0, $uiV1X.FETCH_LOGIN_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                const response = fetchPortalSuccessAction.payload;
                return {
                    login: {
                        ...response
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("9MX7M", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => (parcelRequire("eaDXW")).loginAnnouncementsReducer);

var $eaDXW = parcelRequire("eaDXW");

});
parcelRegister("eaDXW", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => $cceafa90bac23f54$export$14afe2784a94db4d);

var $1We2B = parcelRequire("1We2B");
parcelRequire("71T39");
var $8WXPf = parcelRequire("8WXPf");

var $9EsDH = parcelRequire("9EsDH");
const $cceafa90bac23f54$export$d383b838c87089ae = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.loginAnnouncements) return initialModelState.loginAnnouncements;
    return {
        defaultLocale: '',
        translatedLoginAnnouncements: {}
    };
};
const $cceafa90bac23f54$var$defaultState = $cceafa90bac23f54$export$d383b838c87089ae();
function $cceafa90bac23f54$export$14afe2784a94db4d(state = $cceafa90bac23f54$var$defaultState, action) {
    switch(action.type){
        case 0, $8WXPf.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS:
            return action.payload;
        case 0, $8WXPf.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS:
            {
                const { payload: payload } = action;
                if ((0, $1We2B.isEmpty)(payload)) return state;
                return {
                    defaultLocale: state.defaultLocale,
                    translatedLoginAnnouncements: Object.keys(payload.translatedLogInAnnouncements).reduce((acc, languageKey)=>{
                        var _state$translatedLogi;
                        return {
                            ...acc,
                            [languageKey]: {
                                header: payload.translatedLogInAnnouncements[languageKey].header,
                                message: payload.translatedLogInAnnouncements[languageKey].message,
                                localeDisplayName: (_state$translatedLogi = state.translatedLoginAnnouncements[languageKey]) === null || _state$translatedLogi === void 0 ? void 0 : _state$translatedLogi.localeDisplayName
                            }
                        };
                    }, {})
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("cRbGR", function(module, exports) {
$parcel$export(module.exports, "metaReducer", () => (parcelRequire("oXeui")).default);

var $oXeui = parcelRequire("oXeui");

});
parcelRegister("oXeui", function(module, exports) {
$parcel$export(module.exports, "default", () => $0207c41681a6e3b4$export$2e2bcd8739ae039);
parcelRequire("7qCFa");
var $emeJS = parcelRequire("emeJS");
const $0207c41681a6e3b4$var$defaultState = {};
function $0207c41681a6e3b4$export$2e2bcd8739ae039(state = $0207c41681a6e3b4$var$defaultState, action) {
    if (action.type === (0, $emeJS.UPDATE_META)) {
        const newState = action.payload;
        return {
            ...state,
            ...newState
        };
    }
    return state;
}

});
parcelRegister("7qCFa", function(module, exports) {
$parcel$export(module.exports, "updateMetaAction", () => (parcelRequire("emeJS")).updateMetaAction);
$parcel$export(module.exports, "UPDATE_META", () => (parcelRequire("emeJS")).UPDATE_META);

var $emeJS = parcelRequire("emeJS");

});
parcelRegister("emeJS", function(module, exports) {
$parcel$export(module.exports, "UPDATE_META", () => $016f66baf95d8b5e$export$7db07bf896c7e69b);
$parcel$export(module.exports, "updateMetaAction", () => $016f66baf95d8b5e$export$4a183f4e7a49f459);
const $016f66baf95d8b5e$export$7db07bf896c7e69b = 'state.persisted.env.UPDATE_META';
const $016f66baf95d8b5e$export$4a183f4e7a49f459 = (meta)=>({
        payload: meta,
        type: $016f66baf95d8b5e$export$7db07bf896c7e69b
    });

});




parcelRegister("38xVE", function(module, exports) {
$parcel$export(module.exports, "organisationsReducer", () => (parcelRequire("jzb0b")).default);

var $jzb0b = parcelRequire("jzb0b");

});
parcelRegister("jzb0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $442d1f887fa8c352$export$2e2bcd8739ae039);
parcelRequire("6qS41");
var $1AY2B = parcelRequire("1AY2B");

var $9EsDH = parcelRequire("9EsDH");
const $442d1f887fa8c352$var$emptyState = {
    organisations: []
};
const $442d1f887fa8c352$export$a7f9736258a0bacb = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.organisations) return {
        organisations: initialModelState.organisations.organisations
    };
    return $442d1f887fa8c352$var$emptyState;
};
const $442d1f887fa8c352$var$defaultState = $442d1f887fa8c352$export$a7f9736258a0bacb();
function $442d1f887fa8c352$export$2e2bcd8739ae039(state = $442d1f887fa8c352$var$defaultState, action) {
    switch(action.type){
        case 0, $1AY2B.UPDATE_ORGANISATIONS_MODEL:
            {
                const organisations = action.payload.organisations.map((org)=>({
                        id: org.id,
                        name: org.name
                    }));
                const newState = {
                    organisations: organisations
                };
                return {
                    ...state,
                    ...newState
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("1Ohn6", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => (parcelRequire("8punt")).default);

var $8punt = parcelRequire("8punt");

});
parcelRegister("8punt", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ccffe3f027564c4$export$2e2bcd8739ae039);

var $iuu95 = parcelRequire("iuu95");
parcelRequire("dh5YM");
var $azAoe = parcelRequire("azAoe");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("75g9S");
var $55yCA = parcelRequire("55yCA");
parcelRequire("1BaaY");
var $8bKnT = parcelRequire("8bKnT");

var $1EFS8 = parcelRequire("1EFS8");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $7ccffe3f027564c4$var$getMediaUploadToken = (mediaApiUploadInformation)=>{
    if ('token' in mediaApiUploadInformation) return {
        clientId: mediaApiUploadInformation.clientId,
        token: mediaApiUploadInformation.token,
        endpointUrl: mediaApiUploadInformation.endpointUrl,
        targetCollection: mediaApiUploadInformation.targetCollection,
        tokenDurationInMins: mediaApiUploadInformation.tokenDurationInMins
    };
    return undefined;
};
const $7ccffe3f027564c4$var$getMediaError = (mediaApiUploadInformation)=>{
    if ('error' in mediaApiUploadInformation) return mediaApiUploadInformation.error;
    return undefined;
};
function $7ccffe3f027564c4$var$reducePortalResponseToState(portalResponse, oldState = {}) {
    const portalId = parseInt(portalResponse.id, 10);
    const mediaApiUploadInformation = portalResponse.mediaApiUploadInformation;
    const mediaApiUploadToken = mediaApiUploadInformation && $7ccffe3f027564c4$var$getMediaUploadToken(mediaApiUploadInformation);
    const mediaApiError = mediaApiUploadInformation && $7ccffe3f027564c4$var$getMediaError(mediaApiUploadInformation);
    const newSinglePortalState = {
        mediaApiUploadToken: mediaApiUploadToken,
        mediaApiError: mediaApiError,
        id: portalId,
        name: portalResponse.name,
        logoUrl: portalResponse.logoUrl,
        description: portalResponse.description,
        projectKey: portalResponse.key,
        projectId: portalResponse.projectId,
        portalAnnouncement: portalResponse.portalAnnouncement,
        isProjectSimplified: portalResponse.isProjectSimplified,
        serviceDeskId: portalResponse.serviceDeskId,
        reqGroups: [],
        reqTypes: []
    };
    const categoriesData = portalResponse.categories;
    const categories = categoriesData !== null && categoriesData !== void 0 && categoriesData.categoriesSupported ? categoriesData.categories : undefined;
    const kbState = portalResponse.kbs && portalResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            kbLink: portalResponse.kbs.kbLink,
            kbLinkDomainURLs: portalResponse.kbs.kbLinkDomainURLs,
            kbCategories: categories
        }
    } : {};
    // If there is KB we try to maintain the previous categories
    if (!!kbState.knowledgeBase) {
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const existingPortal = oldState[portalId];
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const existingCategories = existingPortal && !('error' in existingPortal) && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        existingPortal.knowledgeBase && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        existingPortal.knowledgeBase.kbCategories;
        if (existingCategories) // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        kbState.knowledgeBase = {
            ...kbState.knowledgeBase,
            kbCategories: existingCategories
        };
    }
    const reqTypesState = portalResponse.reqTypes ? {
        reqTypes: portalResponse.reqTypes.map((reqtype)=>({
                id: reqtype.id,
                name: reqtype.name,
                // This is actually the description, not the intro.
                // The backend is wrecked.
                descriptionHtml: reqtype.introHtml,
                // This is actually the help text, not the description.
                // The backend is wrecked.
                helpTextHtml: reqtype.descriptionHtml,
                // Icon id here is required to pass backend validation of req type when removing from group
                // can remove once backend change JDW-292 is complete
                icon: reqtype.icon,
                iconUrl: reqtype.iconUrl || `${0, $7FSs7.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${reqtype.icon}`
            }))
    } : {};
    const orderMapping = portalResponse.orderMapping || {};
    const reqGroupsState = (portalResponse.reqGroups || []).map((reqGroup)=>({
            id: reqGroup.id,
            name: reqGroup.name,
            reqTypes: (orderMapping[reqGroup.id] || []).map(String)
        }));
    const { analyticsContext: analyticsContext } = portalResponse;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const oldPortalState = oldState[portalId];
    const analyticAttributesState = analyticsContext ? {
        analyticAttributes: {
            jsdRole: analyticsContext.jsdRole,
            initialProjectTemplate: analyticsContext.initialProjectTemplate,
            openAccess: analyticsContext.openAccess,
            publicSignup: analyticsContext.publicSignup,
            nextGenProject: analyticsContext.nextGenProject,
            demoProject: analyticsContext.demoProject,
            eapOptedIn: analyticsContext.eapOptedIn,
            jsdDwCohort: analyticsContext.jsdDwCohort,
            previousSupportedProjects: analyticsContext.previousSupportedProjects,
            supportedProjects: analyticsContext.supportedProjects
        }
    } : {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ...oldPortalState && oldPortalState.analyticAttributes ? // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        {
            analyticAttributes: oldPortalState.analyticAttributes
        } : {}
    };
    return {
        [portalId]: {
            ...newSinglePortalState,
            ...kbState,
            ...reqTypesState,
            ...analyticAttributesState,
            reqGroups: reqGroupsState
        }
    };
}
const $7ccffe3f027564c4$export$6189f5b9656c1eb4 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.portal) {
        if (initialModelState.branding) return $7ccffe3f027564c4$var$reducePortalResponseToState({
            ...initialModelState.branding,
            ...initialModelState.portal
        });
        return $7ccffe3f027564c4$var$reducePortalResponseToState({
            ...initialModelState.portal,
            logoUrl: undefined,
            theme: {}
        });
    }
    return {};
};
const $7ccffe3f027564c4$var$defaultState = $7ccffe3f027564c4$export$6189f5b9656c1eb4();
function $7ccffe3f027564c4$export$2e2bcd8739ae039(state = $7ccffe3f027564c4$var$defaultState, action) {
    switch(action.type){
        case 0, $d727K.FETCH_PORTAL_MODEL:
            {
                const fetchPortalAction = action;
                const portalId = fetchPortalAction.payload.params && fetchPortalAction.payload.params.id;
                if (portalId) {
                    const portal = state[portalId];
                    if (portal && 'error' in portal) {
                        const newState = {
                            ...state
                        };
                        delete newState[portalId];
                        return newState;
                    }
                }
                return state;
            }
        // We want to override the portal data if request create fails as well.
        case 0, $8bKnT.FETCH_REQUEST_CREATE_FAILURE:
        case 0, $d727K.FETCH_PORTAL_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error, portalId: portalId } = fetchPortalFailureAction.payload;
                return {
                    ...state,
                    [portalId]: {
                        error: {
                            // We really only care about the first error message
                            // grab it and throw the rest away
                            status: error.status,
                            message: (error.errorMessages || [])[0],
                            // Remove basename from the URL, we don't need it as the basename
                            // is already set inside react router.
                            // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                            callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                            callToActionText: error.nextActionDisplayText || '',
                            traceId: error.traceId,
                            responseHeaders: error.responseHeaders
                        }
                    }
                };
            }
        case 0, $d727K.FETCH_PORTAL_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                return {
                    ...state,
                    ...$7ccffe3f027564c4$var$reducePortalResponseToState(fetchPortalSuccessAction.payload, state)
                };
            }
        case 0, $azAoe.FETCH_CATEGORIES_SUCCESS:
            {
                const categoriesSuccessAction = action;
                const { portalId: portalId, categories: categories } = categoriesSuccessAction.payload;
                const portal = state[portalId];
                if (!portal || !('knowledgeBase' in portal)) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbCategories: categories
                        }
                    }
                };
            }
        case 0, $azAoe.FETCH_CATEGORIES_FAILURE:
            {
                const categoriesFailureAction = action;
                const { portalId: portalId, error: categoryError } = categoriesFailureAction.payload;
                const portal = state[portalId];
                if (!portal || !('knowledgeBase' in portal)) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbCategories: {
                                error: {
                                    status: categoryError.statusCode,
                                    message: categoryError.errorMessage,
                                    callToActionUrl: '/portal/',
                                    callToActionText: 'Go back'
                                }
                            }
                        }
                    }
                };
            }
        case 0, $d727K.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS:
            {
                const { payload: payload } = action;
                if (!payload) return state;
                const { portalId: portalId } = payload;
                const portal = state[portalId];
                const portalAnnouncement = payload ?? portal.portalAnnouncement;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        portalAnnouncement: portalAnnouncement
                    }
                };
            }
        case 0, $iuu95.FETCH_KB_SUGGESTIONS_SUCCESS:
            {
                const { kbArticleSuggestions: kbArticleSuggestions, portalId: portalId } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                if (!(0, $1EFS8.default).checkGate('remove-linked-spaces-check-for-article-suggestions')) {
                    if (!portal || !('knowledgeBase' in portal)) return state;
                } else if (!portal || 'error' in portal) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbArticleSuggestions: kbArticleSuggestions
                        }
                    }
                };
            }
        case 0, $55yCA.PROFORMA_FORM_LOADED:
            {
                const { portalId: portalId, proformaFormIsLoaded: proformaFormIsLoaded } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        proformaFormIsLoaded: proformaFormIsLoaded
                    }
                };
            }
        case 0, $d727K.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS:
            {
                const { portalId: portalId, mediaApiUploadInformation: mediaApiUploadInformation } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                if (portal && !('error' in portal)) return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        mediaApiUploadToken: $7ccffe3f027564c4$var$getMediaUploadToken(mediaApiUploadInformation)
                    }
                };
                return state;
            }
        default:
            return state;
    }
}

});
parcelRegister("iuu95", function(module, exports) {
$parcel$export(module.exports, "FETCH_KB_SUGGESTIONS_SUCCESS", () => $604867cfaca21cca$export$1b2c5db514ac0bd7);
$parcel$export(module.exports, "fetchKBSuggestionsSuccessAction", () => $604867cfaca21cca$export$ce6a80dfe554c3b6);
const $604867cfaca21cca$export$1b2c5db514ac0bd7 = 'epic.model.FETCH_KB_SUGGESTIONS';
const $604867cfaca21cca$export$ce6a80dfe554c3b6 = (params)=>{
    return {
        type: $604867cfaca21cca$export$1b2c5db514ac0bd7,
        payload: params
    };
};

});

parcelRegister("75g9S", function(module, exports) {
$parcel$export(module.exports, "fetchPortalAndRequestTypesModel", () => (parcelRequire("55yCA")).fetchPortalAndRequestTypesModel);
$parcel$export(module.exports, "fetchPortalsAndRequestTypesSuccess", () => (parcelRequire("55yCA")).fetchPortalsAndRequestTypesSuccess);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES", () => (parcelRequire("55yCA")).FETCH_PORTAL_AND_REQUEST_TYPES);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS", () => (parcelRequire("55yCA")).FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS);
$parcel$export(module.exports, "PROFORMA_FORM_LOADED", () => (parcelRequire("55yCA")).PROFORMA_FORM_LOADED);

var $55yCA = parcelRequire("55yCA");

});
parcelRegister("55yCA", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES", () => $1fa38315ab048c2d$export$172324766a8910d6);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS", () => $1fa38315ab048c2d$export$5f63fa3daf3ecef8);
$parcel$export(module.exports, "PROFORMA_FORM_LOADED", () => $1fa38315ab048c2d$export$4c0299a035f236e5);
$parcel$export(module.exports, "fetchPortalAndRequestTypesModel", () => $1fa38315ab048c2d$export$b4741ec41baec80b);
$parcel$export(module.exports, "fetchPortalsAndRequestTypesSuccess", () => $1fa38315ab048c2d$export$da57d2f9cae3a05f);

var $cWsyg = parcelRequire("cWsyg");
const $1fa38315ab048c2d$export$172324766a8910d6 = 'epic.model.FETCH_PORTAL_AND_REQUEST_TYPES';
const $1fa38315ab048c2d$export$5f63fa3daf3ecef8 = 'state.persisted.portals-and-request-types.FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS';
const $1fa38315ab048c2d$export$4c0299a035f236e5 = 'state.persisted.portals-and-request-types.PROFORMA_FORM_LOADED';
const $1fa38315ab048c2d$export$b4741ec41baec80b = (payload = {}, meta)=>({
        meta: meta,
        ...(0, $cWsyg.buildModelsActionCreator)($1fa38315ab048c2d$export$172324766a8910d6, 'portalsAndRequestTypes')(payload)
    });
const $1fa38315ab048c2d$export$da57d2f9cae3a05f = (portalsAndRequestTypesModel)=>({
        payload: portalsAndRequestTypesModel,
        type: $1fa38315ab048c2d$export$5f63fa3daf3ecef8
    });

});




parcelRegister("5vkrg", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => (parcelRequire("3Dxn9")).portalCustomisationReducer);

var $3Dxn9 = parcelRequire("3Dxn9");

});
parcelRegister("3Dxn9", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => $811a458aa63583a7$export$b5745e15c8a52df8);
parcelRequire("4CT7s");
var $gQFbD = parcelRequire("gQFbD");
const $811a458aa63583a7$export$49d5fc8cba920a0 = {
    allRequestGroups: {},
    errorMessage: undefined
};
function $811a458aa63583a7$export$b5745e15c8a52df8(state = $811a458aa63583a7$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $gQFbD.GET_ALL_REQUEST_GROUPS_SUCCESS:
            {
                const { portalId: portalId, requestGroups: requestGroups } = action.payload;
                return {
                    errorMessage: undefined,
                    allRequestGroups: {
                        ...state.allRequestGroups,
                        [portalId]: requestGroups
                    }
                };
            }
        case 0, $gQFbD.GET_ALL_REQUEST_GROUPS_FAILURE:
            {
                const { errorMessage: errorMessage } = action.payload;
                return {
                    ...state,
                    errorMessage: errorMessage
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("ink0o", function(module, exports) {
$parcel$export(module.exports, "profileWebFragmentReducer", () => (parcelRequire("lmeu7")).profileWebFragmentReducer);

var $lmeu7 = parcelRequire("lmeu7");

});
parcelRegister("lmeu7", function(module, exports) {
$parcel$export(module.exports, "profileWebFragmentReducer", () => $6cb38bb374e6086a$export$530037ab477140ce);
parcelRequire("6TVgw");
var $ddmND = parcelRequire("ddmND");

var $9EsDH = parcelRequire("9EsDH");
const $6cb38bb374e6086a$export$f9c142b09e8e12af = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.profileWebFragments) return {
        ...initialModelState.profileWebFragments
    };
    return {};
};
const $6cb38bb374e6086a$export$49d5fc8cba920a0 = $6cb38bb374e6086a$export$f9c142b09e8e12af();
const $6cb38bb374e6086a$var$handleFetchProfileConnectFragmentsSuccess = (state, action)=>({
        ...state,
        ...action.payload.fragments
    });
const $6cb38bb374e6086a$var$handleFetchProfileConnectFragmentsFailure = (state, action)=>({
        ...state,
        panels: action.payload
    });
function $6cb38bb374e6086a$export$530037ab477140ce(state = $6cb38bb374e6086a$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $ddmND.FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS:
            return $6cb38bb374e6086a$var$handleFetchProfileConnectFragmentsSuccess(state, action);
        case 0, $ddmND.FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE:
            return $6cb38bb374e6086a$var$handleFetchProfileConnectFragmentsFailure(state, action);
        default:
            return state;
    }
}

});


parcelRegister("1KrWF", function(module, exports) {
$parcel$export(module.exports, "requestCreateReducer", () => (parcelRequire("bCbpW")).default);

var $bCbpW = parcelRequire("bCbpW");

});
parcelRegister("bCbpW", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2f49edf6b1bca72$export$2e2bcd8739ae039);

var $HGACo = parcelRequire("HGACo");

var $sKUlZ = parcelRequire("sKUlZ");
parcelRequire("1BaaY");
var $8bKnT = parcelRequire("8bKnT");

var $kwSZC = parcelRequire("kwSZC");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");

var $vYPX4 = parcelRequire("vYPX4");

var $a50WM = parcelRequire("a50WM");
const $a2f49edf6b1bca72$var$buildStoreKey = (portalId, requestCreateId)=>`${portalId || 'undefined'}/${requestCreateId}`;
const $a2f49edf6b1bca72$var$convertHydratedFieldValuesToInitialValues = (hydratedUrlParamOverrides, fieldStates)=>{
    const fieldStateMap = Object.fromEntries(fieldStates.map((fieldState)=>[
            fieldState.id,
            fieldState
        ]));
    return Object.fromEntries(Object.entries(hydratedUrlParamOverrides).map(([fieldId, valueOverride])=>{
        const fieldState = fieldStateMap[fieldId];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let overrideValue; // Setting this so TS can pick up the correct return value type
        if (!fieldState) {
            overrideValue = [
                fieldId,
                null
            ];
            return overrideValue;
        }
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                overrideValue = [
                    fieldId,
                    valueOverride.map((value)=>value.value)
                ];
                break;
            case 'userpicker':
            case 'reporter':
                overrideValue = [
                    fieldId,
                    valueOverride.accountId
                ];
                break;
            case 'multiuserpicker':
                {
                    const users = valueOverride;
                    overrideValue = [
                        fieldId,
                        users.map((user)=>user.accountId).join(',')
                    ];
                    break;
                }
            case 'organisationpicker':
                overrideValue = [
                    fieldId,
                    valueOverride.id
                ];
                break;
            case 'entitlementpicker':
                overrideValue = [
                    fieldId,
                    valueOverride
                ];
                break;
            case 'multiservicepicker':
                {
                    const services = valueOverride;
                    overrideValue = [
                        fieldId,
                        services
                    ];
                    break;
                }
            default:
                overrideValue = [
                    fieldId,
                    valueOverride
                ];
        }
        return overrideValue;
    }).filter(([_, initialValue])=>initialValue !== null));
};
function $a2f49edf6b1bca72$var$reduceReqCreateResponseToState(reqCreateResponse) {
    var _reqCreateResponse$is, _reqCreateResponse$is2;
    const { hydratedUrlParamOverrides: hydratedUrlParamOverrides, portalId: portalId, id: requestCreateId } = reqCreateResponse;
    const storeId = $a2f49edf6b1bca72$var$buildStoreKey(portalId, requestCreateId);
    const { showRecaptcha: showRecaptcha, siteKey: siteKey, proformaTemplateForm: proformaTemplateForm, form: { name: name, intro: intro, instructions: instructions, descriptionHtml: descriptionHtml, icon: icon, iconUrl: iconUrl } } = reqCreateResponse;
    const form = {
        name: name,
        intro: intro,
        instructions: instructions,
        descriptionHtml: descriptionHtml,
        iconUrl: iconUrl || `${0, $7FSs7.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${icon}`,
        captchaEnabled: showRecaptcha,
        sitekey: siteKey
    };
    const kbState = reqCreateResponse.kbs && reqCreateResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            spaceKey: reqCreateResponse.kbs.kbLink.spaceKey,
            labels: reqCreateResponse.kbs.labels,
            projectKey: reqCreateResponse.kbs.projectKey
        }
    } : {};
    const dateFormat = (0, $a50WM.convertToDateFnsFormat)(reqCreateResponse.calendarParams.dateIfFormat);
    const dateTimeFormat = (0, $a50WM.convertToDateFnsFormat)(reqCreateResponse.calendarParams.dateTimeIfFormat);
    const firstDay = reqCreateResponse.calendarParams.firstDay;
    const useISO8601WeekNumbers = reqCreateResponse.calendarParams.useISO8601WeekNumbers;
    const fields = (0, $kwSZC.toFieldStates)(reqCreateResponse.fields);
    let initialFieldValues = fields.reduce((values, field)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        values[field.id] = field.value;
        return values;
    }, {});
    const { lastSavedFormData: lastSavedFormData } = reqCreateResponse;
    if (lastSavedFormData && lastSavedFormData.portalId === portalId && lastSavedFormData.requestId === requestCreateId) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    initialFieldValues = {
        ...initialFieldValues,
        ...lastSavedFormData.formInput
    };
    let urlParamFieldValueOverrides;
    if ((0, $HGACo.isJsmPortalRovoIntegrationEnabled)()) {
        const convertedHydratedValues = $a2f49edf6b1bca72$var$convertHydratedFieldValuesToInitialValues(hydratedUrlParamOverrides, fields);
        // When Rovo is enabled, only use hydrated values
        // The epic's hydrateUrlParamOverrides already handles the hydration and conversion
        urlParamFieldValueOverrides = convertedHydratedValues;
        if (Object.keys(urlParamFieldValueOverrides).length > 0) initialFieldValues = {
            ...initialFieldValues,
            ...urlParamFieldValueOverrides
        };
    } else {
        urlParamFieldValueOverrides = (0, $sKUlZ.parseFieldUrlParams)(fields);
        if (Object.keys(urlParamFieldValueOverrides).length > 0) initialFieldValues = {
            ...initialFieldValues,
            ...urlParamFieldValueOverrides
        };
    }
    const organisationsForCurrentUser = reqCreateResponse.userOrganisations;
    const requestCreateFormState = {
        form: form,
        fields: fields,
        initialFieldValues: initialFieldValues,
        urlParamFieldValueOverrides: urlParamFieldValueOverrides,
        dateFormat: dateFormat,
        dateTimeFormat: dateTimeFormat,
        organisationsForCurrentUser: organisationsForCurrentUser,
        firstDay: firstDay,
        useISO8601WeekNumbers: useISO8601WeekNumbers,
        proformaTemplateForm: proformaTemplateForm,
        id: reqCreateResponse.id,
        projectId: reqCreateResponse.projectId,
        issueType: (_reqCreateResponse$is = reqCreateResponse.issueType) === null || _reqCreateResponse$is === void 0 ? void 0 : _reqCreateResponse$is.name,
        issueTypeId: (_reqCreateResponse$is2 = reqCreateResponse.issueType) === null || _reqCreateResponse$is2 === void 0 ? void 0 : _reqCreateResponse$is2.id,
        canBrowseUsers: !!reqCreateResponse.canBrowseUsers,
        canCreateUsers: !!reqCreateResponse.canSubmitWithEmailAddress,
        projectHasProformaForms: !!reqCreateResponse.hasProformaForm,
        proforma: reqCreateResponse.proforma,
        proformaFormIsLoaded: false,
        proformaFormIsDirty: false
    };
    return {
        [storeId]: {
            ...requestCreateFormState,
            ...kbState,
            initialFieldValues: initialFieldValues
        }
    };
}
const $a2f49edf6b1bca72$export$f7e14415d5a64cdc = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.reqCreate) {
        const portalId = (0, $vYPX4.toNumber)(initialModelState.portal && initialModelState.portal.id);
        const initialState = $a2f49edf6b1bca72$var$reduceReqCreateResponseToState({
            portalId: portalId,
            ...initialModelState.reqCreate,
            hydratedUrlParamOverrides: {}
        });
        // When the jsm_portal_rovo_integration flag is on, pre-fill logic runs in the epic
        // asynchronously. If URL params are present for any field, we need to delay rendering
        // the form until the epic resolves and dispatches FETCH_REQUEST_CREATE_SUCCESS with the
        // hydrated values. Without this, Formik initialises with empty values before the epic
        // completes, and the pre-fill data has no effect.
        if ((0, $HGACo.isJsmPortalRovoIntegrationEnabled)()) {
            const storeKey = $a2f49edf6b1bca72$var$buildStoreKey(portalId, initialModelState.reqCreate.id);
            const formState = initialState[storeKey];
            if (formState) {
                const urlParamOverrides = (0, $sKUlZ.parseFieldUrlParams)(formState.fields);
                if (Object.keys(urlParamOverrides).length > 0) return {
                    [storeKey]: {
                        ...formState,
                        prefillPending: true
                    }
                };
            }
        }
        return initialState;
    }
    return {};
};
const $a2f49edf6b1bca72$var$defaultState = $a2f49edf6b1bca72$export$f7e14415d5a64cdc();
function $a2f49edf6b1bca72$export$2e2bcd8739ae039(state = $a2f49edf6b1bca72$var$defaultState, action) {
    switch(action.type){
        case 0, $8bKnT.FETCH_REQUEST_CREATE_MODEL:
            {
                const requestCreateId = action.payload.params && action.payload.params.id;
                const portalId = action.payload.params && action.payload.params.portalId;
                if (requestCreateId && portalId) {
                    const storeId = $a2f49edf6b1bca72$var$buildStoreKey(portalId, requestCreateId);
                    const requestCreate = state[storeId];
                    if (requestCreate && 'error' in requestCreate) {
                        const newState = {
                            ...state
                        };
                        delete newState[storeId];
                        return newState;
                    }
                }
                return state;
            }
        case 0, $8bKnT.FETCH_REQUEST_CREATE_FAILURE:
            {
                const { error: error, portalId: portalId, requestCreateId: requestCreateId } = action.payload;
                const storeId = $a2f49edf6b1bca72$var$buildStoreKey(portalId, requestCreateId);
                return {
                    ...state,
                    [storeId]: {
                        error: {
                            // We really only care about the first error message
                            // grab it and throw the rest away
                            status: error.status,
                            message: (error.errorMessages || [])[0],
                            traceId: error.traceId,
                            responseHeaders: error.responseHeaders,
                            // Remove basename from the URL, we don't need it as the basename
                            // is already set inside react router.
                            // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                            callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                            callToActionText: error.nextActionDisplayText || ''
                        }
                    }
                };
            }
        case 0, $8bKnT.FETCH_REQUEST_CREATE_SUCCESS:
            return {
                ...state,
                ...$a2f49edf6b1bca72$var$reduceReqCreateResponseToState(action.payload)
            };
        case 0, $8bKnT.PROFORMA_FORM_DIRTY:
            {
                const { portalId: portalId, requestTypeId: requestTypeId, isDirty: isDirty } = action.payload;
                const storeId = $a2f49edf6b1bca72$var$buildStoreKey(portalId, requestTypeId);
                if (!state[storeId]) return state;
                return {
                    ...state,
                    [storeId]: {
                        ...state[storeId],
                        proformaFormIsDirty: isDirty
                    }
                };
            }
        case 0, $8bKnT.RESET_REQUEST_CREATE_STATE:
            // Reset the state to the default initial state
            return $a2f49edf6b1bca72$export$f7e14415d5a64cdc();
        default:
            return state;
    }
}

});
parcelRegister("vYPX4", function(module, exports) {
$parcel$export(module.exports, "toNumber", () => $55e924d483952a84$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "toString", () => $55e924d483952a84$export$f84e8e69fd4488a5);
// This exists as a shorthand func to return a default value if the parsed
// string was somehow not a valid number.
const $55e924d483952a84$export$a0a81dc3380ce7d3 = (str, defaultValue)=>{
    if (typeof str === 'number') return str;
    if (str) {
        const parsedNumber = parseInt(str, 10);
        if (!isNaN(parsedNumber)) return parsedNumber;
    }
    return defaultValue;
};
const $55e924d483952a84$export$f84e8e69fd4488a5 = (num)=>{
    if (num) return String(num);
    return undefined;
};

});

parcelRegister("a50WM", function(module, exports) {
$parcel$export(module.exports, "convertToDateFnsFormat", () => $96fcb9d8575c2131$export$e007e5b3b423e0a6);
$parcel$export(module.exports, "splitDateTimeFormat", () => $96fcb9d8575c2131$export$b565d8b0afadc612);
/**
 * Utility to convert a subset of the unix date time format to data-fns.
 * Date-fns format: https://date-fns.org/v2.30.0/docs/format
 * Unix date time format: http://old-www.cs.dartmouth.edu/~cs50/data/tse/wikipedia/wiki/Date_(Unix).html#Formatting
 */ /**
 * This is a mapping of all equivalent time formats between unix and date-fns.
 *
 * There are a number of commented out unix time formats, these are the unix time formats that we don't support. There are no
 * direct equivalent for any of these between unix time format and date fns. I have left the closest matching date fns time format
 * for each of these keys if there are any, or I marked it as INCOMPATIBLE if there are no date fns that even remotely matches the
 * unix time format.
 */ const $96fcb9d8575c2131$var$UNIX_TO_DATE_FNS_MAPPING = {
    '%a': 'iii',
    '%A': 'iiii',
    '%d': 'dd',
    '%e': 'd',
    '%j': 'DDD',
    '%u': 'i',
    // '%w': 'd',
    // '%U': 'WW',
    // '%W': 'WW',
    '%V': 'II',
    '%m': 'MM',
    '%h': 'MMM',
    '%b': 'MMM',
    '%B': 'MMMM',
    '%y': 'yy',
    '%Y': 'yyyy',
    // '%g': 'YY',
    // '%G': 'YYYY',
    // '%C': 'INCOMPATIBLE',
    '%D': 'MM/dd/yy',
    // '%x': "INCOMPATIBLE",
    '%F': 'yyyy-MM-dd',
    '%l': 'h',
    '%I': 'hh',
    '%k': 'H',
    '%H': 'HH',
    '%p': 'a',
    '%P': 'aaaa',
    '%M': 'mm',
    '%s': 't',
    '%S': 'ss',
    // '%N': 'INCOMPATIBLE',
    '%r': 'hh:mm:ss',
    '%R': 'HH:mm',
    '%T': 'HH:mm:ss',
    // '%X': 'INCOMPATIBLE',
    // '%c': 'INCOMPATIBLE',
    '%z': 'xx'
};
/**
 * These are the date-fns characters that are associated with 'time', time in this case refers to hour, minute, second and timezone.
 * This is used by splitDateTimeFormat to determine which sections of a date format is associated with time and which are associated  * with day.
 * This list IS case sensitive as capital M is month and not minute, see https://date-fns.org/v2.30.0/docs/format for full list.
 */ const $96fcb9d8575c2131$var$LIST_OF_TIME_CHARS = [
    'h',
    // Hour
    'H',
    // Hour
    'm',
    // Minute (NOTE: capital M is month not minute)
    's',
    // Second
    'S',
    // Part of a second
    'a',
    // AM PM
    'xxx',
    // Timezone
    't',
    // Timestamp
    'T' // Timestamp
];
// eslint-disable-next-line no-useless-escape
const $96fcb9d8575c2131$var$unixTimeFormatTokenRegex = /\%\w/gi;
const $96fcb9d8575c2131$var$escapeRegExp = (literalString)=>literalString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string;
/**
 * Converts a unix date time format to its closest equivalent in date-fns format
 * @param unixDateTimeFormat The unix date time format you want to convert
 */ function $96fcb9d8575c2131$export$e007e5b3b423e0a6(unixDateTimeFormat) {
    let transformedString = unixDateTimeFormat;
    const incompatibleFormatString = [];
    const matches = unixDateTimeFormat.match($96fcb9d8575c2131$var$unixTimeFormatTokenRegex);
    if (matches) matches.forEach((match)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const equivalentDateFnsFunctionString = $96fcb9d8575c2131$var$UNIX_TO_DATE_FNS_MAPPING[match];
        if (equivalentDateFnsFunctionString) // Replaces all cases of the match with it's equivalent in date-fns time format
        transformedString = transformedString.replace(new RegExp($96fcb9d8575c2131$var$escapeRegExp(match), 'g'), equivalentDateFnsFunctionString);
        else incompatibleFormatString.push(match);
    });
    return transformedString;
}
/**
 * Naively splits a date fns time format between date and time components. It is split by matching each individual character
 * Naively in this case means that there is a distinct separate between date and time, i.e. they're not mixed in between each other.
 */ function $96fcb9d8575c2131$export$b565d8b0afadc612(dateFnsTimeFormat) {
    const matches = dateFnsTimeFormat.match(/\w/g);
    let lastMatchType;
    let indexOfMatchTypeChange = dateFnsTimeFormat.length;
    if (matches) {
        for (const match of matches){
            // We assume that any keys that are not time keys are used to represent date, date in this case refers to years, months, weeks and days
            const isTime = $96fcb9d8575c2131$var$LIST_OF_TIME_CHARS.includes(match);
            const matchType = isTime ? 'time' : 'date';
            if (!lastMatchType) lastMatchType = matchType;
            else if (matchType !== lastMatchType) {
                // If the match type has changed, i.e. from date -> time or from time -> date we will stop and use this match to
                // split the date time to date and time.
                indexOfMatchTypeChange = dateFnsTimeFormat.indexOf(match);
                break;
            }
        }
        if (lastMatchType === 'date') // If we went from date -> time
        return {
            dateFormat: dateFnsTimeFormat.slice(0, indexOfMatchTypeChange).trim(),
            timeFormat: dateFnsTimeFormat.slice(indexOfMatchTypeChange).trim()
        };
        // splitDateTimeFormat went from time -> date
        return {
            timeFormat: dateFnsTimeFormat.slice(0, indexOfMatchTypeChange).trim(),
            dateFormat: dateFnsTimeFormat.slice(indexOfMatchTypeChange).trim()
        };
    }
    return {
        timeFormat: 'hh:mm a',
        dateFormat: 'yyyy-MM-dd'
    };
}

});



parcelRegister("hiifn", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => (parcelRequire("ifuNK")).requestDetailsReducer);

var $ifuNK = parcelRequire("ifuNK");

});
parcelRegister("ifuNK", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => $e6c5aa56327f2896$export$dfa3e5ac1f5274b8);

var $1We2B = parcelRequire("1We2B");

var $1sDoB = parcelRequire("1sDoB");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $e6c5aa56327f2896$export$efef4e30b826ddbf = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.reqDetails) return {
        [initialModelState.reqDetails.key]: initialModelState.reqDetails
    };
    return {};
};
const $e6c5aa56327f2896$var$defaultState = $e6c5aa56327f2896$export$efef4e30b826ddbf();
function $e6c5aa56327f2896$export$dfa3e5ac1f5274b8(state = $e6c5aa56327f2896$var$defaultState, action) {
    switch(action.type){
        case 0, $jra4c.FETCH_REQUEST_DETAILS_MODEL:
            return $e6c5aa56327f2896$var$handleFetchRequestDetailsModel(state, action);
        case 0, $jra4c.FETCH_REQUEST_DETAILS_FAILURE:
            return $e6c5aa56327f2896$var$handleFetchRequestDetailsFailureAction(state, action);
        case 0, $jra4c.FETCH_REQUEST_DETAILS_SUCCESS:
            return $e6c5aa56327f2896$var$handleFetchRequestDetailsSuccessAction(state, action);
        case 0, $jra4c.CREATE_COMMENT_SUCCESS:
            return $e6c5aa56327f2896$var$handleCreateCommentSuccessAction(state, action);
        case 0, $jra4c.CHANGE_SUBSCRIPTION_SUCCESS:
            return $e6c5aa56327f2896$var$handleChangeSubscriptionSuccessAction(state, action);
        case 0, $jra4c.REMOVE_PARTICIPANT_SUCCESS:
            return $e6c5aa56327f2896$var$handleRemoveParticipant(state, action);
        case 0, $jra4c.REMOVE_ORGANISATION_SUCCESS:
            return $e6c5aa56327f2896$var$handleRemoveOrganisation(state, action);
        case 0, $jra4c.GET_MEDIA_READ_CREDENTIALS_SUCCESS:
            return $e6c5aa56327f2896$var$handleGetReadCredentialsSuccess(state, action);
        case 0, $jra4c.ADD_PARTICIPANTS_SUCCESS:
            return $e6c5aa56327f2896$var$handleAddParticipantsSuccess(state, action);
        default:
            return state;
    }
}
function $e6c5aa56327f2896$var$handleFetchRequestDetailsModel(state, action) {
    const requestKey = action.payload.params.key;
    if (requestKey) {
        const requestDetails = state[requestKey];
        if (requestDetails && 'error' in requestDetails) {
            const newState = {
                ...state
            };
            delete newState[requestKey];
            return newState;
        }
    }
    return state;
}
function $e6c5aa56327f2896$var$handleFetchRequestDetailsFailureAction(state, action) {
    const { requestKey: requestKey, error: error } = action.payload;
    const errorObject = {
        // We really only care about the first error message
        // grab it and throw the rest away
        status: error.status,
        message: (error.errorMessages || [])[0] || '',
        // Remove basename from the URL, we don't need it as the basename
        // is already set inside react router.
        // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
        callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
        callToActionText: error.nextActionDisplayText || ''
    };
    return {
        ...state,
        [requestKey]: {
            error: errorObject
        }
    };
}
function $e6c5aa56327f2896$var$populateWithPreexistingState(preExistingRequestDetails, response) {
    let preExistingProperties;
    if (preExistingRequestDetails && !('error' in preExistingRequestDetails)) {
        if (preExistingRequestDetails.userMentionedDuringRequestCreation) preExistingProperties = {
            participants: (0, $1We2B.uniqBy)([
                ...preExistingRequestDetails.participants,
                ...response.participants
            ], 'accountId'),
            userMentionedDuringRequestCreation: false
        };
    }
    return preExistingProperties;
}
function $e6c5aa56327f2896$var$handleFetchRequestDetailsSuccessAction(state, action) {
    const response = action.payload;
    const requestKey = response.key;
    const preExistingProperties = $e6c5aa56327f2896$var$populateWithPreexistingState(state[requestKey], response);
    return {
        ...state,
        [requestKey]: {
            ...response,
            ...preExistingProperties
        }
    };
}
function $e6c5aa56327f2896$var$handleChangeSubscriptionSuccessAction(state, action) {
    const { requestKey: requestKey, shouldSubscribe: shouldSubscribe } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) {
        let newSubscribeAction = (0, $1sDoB.SUBSCRIBE_ACTION_KEY);
        if (shouldSubscribe) newSubscribeAction = (0, $1sDoB.UNSUBSCRIBE_ACTION_KEY);
        return {
            ...state,
            [requestKey]: {
                ...requestDetails,
                subscribeAction: newSubscribeAction
            }
        };
    }
    return state;
}
function $e6c5aa56327f2896$var$handleCreateCommentSuccessAction(state, action) {
    const { requestKey: requestKey, response: response } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            issue: {
                ...requestDetails.issue,
                activityStream: [
                    ...requestDetails.issue.activityStream,
                    response.comment
                ],
                status: response.status
            }
        }
    };
    return state;
}
function $e6c5aa56327f2896$var$handleRemoveOrganisation(state, action) {
    const { requestKey: requestKey, organisationId: organisationId } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            organisations: requestDetails.organisations.filter((organisation)=>organisation.id !== organisationId),
            issue: {
                ...requestDetails.issue,
                organisations: requestDetails.issue.organisations.filter((organisation)=>organisation.id !== organisationId)
            }
        }
    };
    return state;
}
const $e6c5aa56327f2896$var$filterRemovedParticipant = (participants, removedUserAccountId)=>participants.filter((participant)=>participant.accountId !== removedUserAccountId);
function $e6c5aa56327f2896$var$handleRemoveParticipant(state, action) {
    const { requestKey: requestKey, accountId: accountId } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            participants: $e6c5aa56327f2896$var$filterRemovedParticipant(requestDetails.participants, accountId),
            issue: {
                ...requestDetails.issue,
                participants: $e6c5aa56327f2896$var$filterRemovedParticipant(requestDetails.issue.participants, accountId)
            }
        }
    };
    return state;
}
function $e6c5aa56327f2896$var$handleGetReadCredentialsSuccess(state, action) {
    const { requestKey: requestKey, response: response } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            readFileMediaCredentials: response
        }
    };
    return state;
}
function $e6c5aa56327f2896$var$handleAddParticipantsSuccess(state, action) {
    const { requestKey: requestKey, userMentionedDuringRequestCreation: userMentionedDuringRequestCreation, addParticipantsSuccessResponse: addParticipantsSuccessResponse } = action.payload;
    const requestDetails = state[requestKey];
    const { participants: updatedParticipants, organisations: updatedOrganisations } = addParticipantsSuccessResponse;
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            issue: {
                ...requestDetails.issue,
                participants: updatedParticipants,
                organisations: updatedOrganisations
            },
            participants: updatedParticipants,
            organisations: updatedOrganisations
        }
    };
    if (!requestDetails && userMentionedDuringRequestCreation) return {
        ...state,
        [requestKey]: {
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation,
            issue: {
                participants: updatedParticipants,
                activityStream: [],
                fields: []
            },
            participants: updatedParticipants,
            approvalStatus: []
        }
    };
    return state;
}

});
parcelRegister("1sDoB", function(module, exports) {
$parcel$export(module.exports, "SUBSCRIBE_ACTION_KEY", () => $21f63f79376ff2b0$export$2f3123aa49f16a3c);
$parcel$export(module.exports, "UNSUBSCRIBE_ACTION_KEY", () => $21f63f79376ff2b0$export$5a45f83be8b212b8);
const $21f63f79376ff2b0$export$2f3123aa49f16a3c = 'subscribe';
const $21f63f79376ff2b0$export$5a45f83be8b212b8 = 'unsubscribe';
const $21f63f79376ff2b0$export$f10e0fb31f869e32 = 'none';

});



parcelRegister("8jLm8", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => (parcelRequire("6bKu0")).requestListReducer);

var $6bKu0 = parcelRequire("6bKu0");

});
parcelRegister("6bKu0", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => $dabcb4f305dd1371$export$476a1a148617ffd3);
parcelRequire("2NENO");
var $leQln = parcelRequire("leQln");

var $9EsDH = parcelRequire("9EsDH");

var $HGACo = parcelRequire("HGACo");
const $dabcb4f305dd1371$var$emptyState = {
    totalResults: 0,
    resultsPerPage: 20,
    pages: {
        isInitialPageLoad: false
    }
};
const $dabcb4f305dd1371$export$c1708a8d295610ca = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.allReqFilter) {
        const { resultsPerPage: resultsPerPage, totalResults: totalResults, sortBy: sortBy, sortOrder: sortOrder, requestList: requestList, nextToken: nextToken } = initialModelState.allReqFilter;
        const baseState = {
            resultsPerPage: resultsPerPage,
            totalResults: totalResults,
            sortBy: sortBy,
            sortOrder: sortOrder,
            pages: {
                isInitialPageLoad: true,
                [initialModelState.allReqFilter.selectedPage]: requestList
            }
        };
        if ((0, $HGACo.isRequestListInfiniteScrollEnabled)()) {
            baseState.nextToken = nextToken;
            baseState.allRows = requestList ?? [];
            baseState.filter = (0, $HGACo.isEmptyStringFilterOnFirstReqListLoadEnabled)() ? initialModelState.allReqFilter.filter ?? '' : initialModelState.allReqFilter.filter;
        }
        return baseState;
    }
    return $dabcb4f305dd1371$var$emptyState;
};
const $dabcb4f305dd1371$var$defaultState = $dabcb4f305dd1371$export$c1708a8d295610ca();
function $dabcb4f305dd1371$export$476a1a148617ffd3(state = $dabcb4f305dd1371$var$defaultState, action) {
    switch(action.type){
        case 0, $leQln.FETCH_REQUEST_LIST_SUCCESS:
            return $dabcb4f305dd1371$var$handleFetchRequestListSuccess(state, action);
        case 0, $leQln.MARK_INITIAL_PAGE_LOAD_RENDERED:
            return $dabcb4f305dd1371$var$handleMarkInitialPageLoadRendered(state);
        case 0, $leQln.INVALIDATE_PAGES:
            return $dabcb4f305dd1371$var$handleInvalidatePages(state, action);
        default:
            return state;
    }
}
function $dabcb4f305dd1371$var$handleInvalidatePages(state, action) {
    const currentPage = action.payload;
    return {
        ...state,
        pages: {
            isInitialPageLoad: false,
            [currentPage]: state.pages[currentPage]
        }
    };
}
function $dabcb4f305dd1371$var$handleFetchRequestListSuccessInfiniteScroll(state, action) {
    const response = action.payload;
    if (!response) return state;
    const isReset = response.sortBy !== state.sortBy || response.sortOrder !== state.sortOrder || response.totalResults !== state.totalResults || response.filter !== state.filter;
    const existingRows = state.allRows ?? [];
    // Deduplicate to prevent duplicate entries from race conditions or overlapping API calls
    const existingKeys = new Set(existingRows.map((row)=>row.key));
    const uniqueNewRows = response.requestList.filter((row)=>!existingKeys.has(row.key));
    const newRows = isReset ? response.requestList : [
        ...existingRows,
        ...uniqueNewRows
    ];
    return {
        ...state,
        resultsPerPage: response.resultsPerPage,
        totalResults: response.totalResults,
        sortBy: response.sortBy,
        sortOrder: response.sortOrder,
        nextToken: response.nextToken,
        filter: response.filter,
        allRows: newRows,
        // The `pages` object (keyed by selectedPage) is only used by the non-infinite-scroll
        // pagination path. In the infinite scroll path, `allRows` is the canonical source of
        // truth for all fetched rows, so we do not populate `pages[selectedPage]` here.
        // Doing so would store stale page-indexed data that is never consumed by infinite
        // scroll consumers, and `selectedPage` is irrelevant in nextToken-based pagination.
        pages: {
            isInitialPageLoad: false
        }
    };
}
function $dabcb4f305dd1371$var$handleFetchRequestListSuccess(state, action) {
    if ((0, $HGACo.isRequestListInfiniteScrollEnabled)()) return $dabcb4f305dd1371$var$handleFetchRequestListSuccessInfiniteScroll(state, action);
    const response = action.payload;
    if (response) {
        if (response.totalResults === state.totalResults) {
            if (response.sortBy !== state.sortBy || response.sortOrder !== state.sortOrder) {
                if (response.selectedPage === 1) return {
                    ...state,
                    sortOrder: response.sortOrder,
                    sortBy: response.sortBy,
                    pages: {
                        isInitialPageLoad: false,
                        [response.selectedPage]: response.requestList
                    }
                };
            }
            return {
                ...state,
                pages: {
                    ...state.pages,
                    isInitialPageLoad: false,
                    [response.selectedPage]: response.requestList
                }
            };
        }
        return {
            resultsPerPage: response.resultsPerPage,
            totalResults: response.totalResults,
            sortBy: response.sortBy,
            sortOrder: response.sortOrder,
            pages: {
                isInitialPageLoad: false,
                [response.selectedPage]: response.requestList
            }
        };
    }
    return state;
}
const $dabcb4f305dd1371$var$handleMarkInitialPageLoadRendered = (state)=>({
        ...state,
        pages: {
            ...state.pages,
            isInitialPageLoad: false
        }
    });

});


parcelRegister("lxqph", function(module, exports) {
$parcel$export(module.exports, "requestTypeSuggestionReducer", () => (parcelRequire("4DH1E")).default);
/**
 * This should be normalized with the normal request type model at some point
 */ 
var $4DH1E = parcelRequire("4DH1E");

});
parcelRegister("4DH1E", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0cfdb8a5df34e6$export$2e2bcd8739ae039);
parcelRequire("2lLrg");
var $aweot = parcelRequire("aweot");

var $7FSs7 = parcelRequire("7FSs7");
const $5a0cfdb8a5df34e6$var$defaultState = {
    suggestions: [],
    isLoaded: false
};
function $5a0cfdb8a5df34e6$export$2e2bcd8739ae039(state = $5a0cfdb8a5df34e6$var$defaultState, action) {
    switch(action.type){
        case 0, $aweot.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL:
            // When we are making a new request for the request type model we will reset the state
            return {
                suggestions: [],
                isLoaded: false
            };
        case 0, $aweot.FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS:
            {
                const requestTypeSuggestions = action.payload.map((suggestion)=>{
                    const requestTypeId = parseInt(String(suggestion.id), 10);
                    return {
                        id: requestTypeId,
                        portalId: suggestion.cvId,
                        portalName: suggestion.portalName,
                        name: suggestion.name,
                        descriptionHtml: suggestion.descriptionHtml,
                        iconUrl: suggestion.iconUrl || `${0, $7FSs7.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${suggestion.icon}`
                    };
                });
                return {
                    suggestions: requestTypeSuggestions,
                    isLoaded: true
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("imME9", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => (parcelRequire("e4c8o")).resetPasswordReducer);

var $e4c8o = parcelRequire("e4c8o");

});
parcelRegister("e4c8o", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => $84ec90339ae88c58$export$b0c3be5071e95c02);

var $9EsDH = parcelRequire("9EsDH");
const $84ec90339ae88c58$var$defaultState = {
    emailAddress: undefined,
    username: undefined,
    resetPasswordJwt: undefined
};
const $84ec90339ae88c58$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.resetPassword) return {
        ...$84ec90339ae88c58$var$defaultState,
        ...initialModelState.resetPassword
    };
    return $84ec90339ae88c58$var$defaultState;
};
const $84ec90339ae88c58$export$b0c3be5071e95c02 = (state = $84ec90339ae88c58$export$53ac33307b5acee9())=>state;

});


parcelRegister("iM452", function(module, exports) {
$parcel$export(module.exports, "signUpReducer", () => (parcelRequire("dLgyA")).signUpReducer);

var $dLgyA = parcelRequire("dLgyA");

});
parcelRegister("dLgyA", function(module, exports) {
$parcel$export(module.exports, "signUpReducer", () => $1d13d44df0c0847d$export$a3d522c435cab174);
parcelRequire("6aA8L");
var $jJMqu = parcelRequire("jJMqu");

var $g1L0m = parcelRequire("g1L0m");

var $9EsDH = parcelRequire("9EsDH");
const $1d13d44df0c0847d$var$defaultState = {
    authInfo: {
        accountStage: (0, $g1L0m.AccountStageType).SIGNUP,
        authMethods: new Map([
            [
                (0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                {}
            ]
        ])
    },
    emailAddress: null,
    requestKey: null,
    requestSummary: null
};
const $1d13d44df0c0847d$var$getInitialState = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.signUp && initialModelState.signUp.emailAddress) return {
        ...$1d13d44df0c0847d$var$defaultState,
        ...initialModelState.signUp
    };
    return $1d13d44df0c0847d$var$defaultState;
};
const $1d13d44df0c0847d$export$a3d522c435cab174 = (state = $1d13d44df0c0847d$var$getInitialState(), action)=>{
    switch(action.type){
        case 0, $jJMqu.SET_SIGN_UP_DATA:
            return {
                ...state,
                emailAddress: action.payload.email,
                authInfo: action.payload.authInfo
            };
        default:
            return state;
    }
};

});


parcelRegister("4p6id", function(module, exports) {
$parcel$export(module.exports, "timezonesReducer", () => (parcelRequire("h831L")).timezonesReducer);

var $h831L = parcelRequire("h831L");

});
parcelRegister("h831L", function(module, exports) {
$parcel$export(module.exports, "timezonesReducer", () => $d10e9401a6bcce78$export$98e58b85fdd67f49);
parcelRequire("5vxR7");
var $aOx3T = parcelRequire("aOx3T");

var $9EsDH = parcelRequire("9EsDH");
const $d10e9401a6bcce78$export$84faa4a7b0294c11 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState) return {
        timezoneRegions: initialModelState.timezoneRegions || [],
        timezones: initialModelState.timezones || []
    };
    return {
        timezoneRegions: [],
        timezones: []
    };
};
const $d10e9401a6bcce78$var$defaultState = $d10e9401a6bcce78$export$84faa4a7b0294c11();
function $d10e9401a6bcce78$export$98e58b85fdd67f49(state = $d10e9401a6bcce78$var$defaultState, action) {
    switch(action.type){
        case 0, $aOx3T.FETCH_TIMEZONES_SUCCESS:
            return $d10e9401a6bcce78$var$handleFetchTimezonesSuccess(state, action);
        case 0, $aOx3T.FETCH_TIMEZONE_REGIONS_SUCCESS:
            return $d10e9401a6bcce78$var$handleFetchTimezoneRegionsSuccess(state, action);
        default:
            return state;
    }
}
const $d10e9401a6bcce78$var$handleFetchTimezonesSuccess = (state, action)=>({
        ...state,
        timezones: action.payload.timezones
    });
const $d10e9401a6bcce78$var$handleFetchTimezoneRegionsSuccess = (state, action)=>({
        ...state,
        timezoneRegions: action.payload.timezoneRegions
    });

});


parcelRegister("2QgYJ", function(module, exports) {
$parcel$export(module.exports, "uiModificationsReducer", () => (parcelRequire("9loq1")).uiModificationsReducer);

var $9loq1 = parcelRequire("9loq1");

});
parcelRegister("9loq1", function(module, exports) {
$parcel$export(module.exports, "uiModificationsReducer", () => $01c836d44b7baf75$export$821013f52f243078);
parcelRequire("kj8xu");
var $4iHZF = parcelRequire("4iHZF");
const $01c836d44b7baf75$var$buildStoreKey = (portalId, requestTypeId)=>`${portalId}/${requestTypeId}`;
const $01c836d44b7baf75$var$defaultState = {};
function $01c836d44b7baf75$export$821013f52f243078(state = $01c836d44b7baf75$var$defaultState, action) {
    switch(action.type){
        case 0, $4iHZF.FETCH_UI_MODIFICATIONS_SUCCESS:
            {
                const { portalId: portalId, requestTypeId: requestTypeId, uiModifications: uiModifications } = action.payload;
                const storeKey = $01c836d44b7baf75$var$buildStoreKey(portalId, requestTypeId);
                return {
                    [storeKey]: {
                        data: uiModifications,
                        error: undefined
                    }
                };
            }
        case 0, $4iHZF.FETCH_UI_MODIFICATIONS_FAILURE:
            {
                var _error$errorMessages;
                const { portalId: portalId, requestTypeId: requestTypeId, error: error } = action.payload;
                const storeKey = $01c836d44b7baf75$var$buildStoreKey(portalId, requestTypeId);
                return {
                    [storeKey]: {
                        data: undefined,
                        error: ((_error$errorMessages = error.errorMessages) === null || _error$errorMessages === void 0 ? void 0 : _error$errorMessages[0]) ?? 'Failed to fetch UI modifications'
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("jixj5", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationReducer", () => (parcelRequire("lpCOk")).unsubscribedConfirmationReducer);

var $lpCOk = parcelRequire("lpCOk");

});
parcelRegister("lpCOk", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationReducer", () => $7bf37f363f0707f2$export$ac175372d3d2c582);

var $fMDpd = parcelRequire("fMDpd");
parcelRequire("8Fqso");
var $04WFB = parcelRequire("04WFB");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $7bf37f363f0707f2$export$c8b25b5da8be069b = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.unsubscribedConfirmation) return {
        unsubscribedConfirmation: initialModelState.unsubscribedConfirmation
    };
    return {};
};
const $7bf37f363f0707f2$var$defaultState = $7bf37f363f0707f2$export$c8b25b5da8be069b();
function $7bf37f363f0707f2$export$ac175372d3d2c582(state = $7bf37f363f0707f2$var$defaultState, action) {
    switch(action.type){
        case 0, $fMDpd.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL:
            {
                const unsubscribedConfirmation = state.unsubscribedConfirmation;
                if (unsubscribedConfirmation && 'error' in unsubscribedConfirmation) return {};
                return state;
            }
        // We want to override the portal data if request create fails as well.
        case 0, $04WFB.FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error } = fetchPortalFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    ...state,
                    unsubscribedConfirmation: {
                        error: errorObject
                    }
                };
            }
        case 0, $04WFB.FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                const requestKey = fetchPortalSuccessAction.payload.requestKey;
                const unsubscribedConfirmation = {
                    requestKey: requestKey,
                    requestUrl: fetchPortalSuccessAction.payload.requestUrl,
                    summary: fetchPortalSuccessAction.payload.summary
                };
                return {
                    ...state,
                    unsubscribedConfirmation: unsubscribedConfirmation
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("4YN96", function(module, exports) {
$parcel$export(module.exports, "userReducer", () => (parcelRequire("Wjpdg")).default);

var $Wjpdg = parcelRequire("Wjpdg");

});
parcelRegister("Wjpdg", function(module, exports) {
$parcel$export(module.exports, "default", () => $5260ffad7c733513$export$2e2bcd8739ae039);
parcelRequire("6Fjys");
var $8ICBx = parcelRequire("8ICBx");

var $4yRg9 = parcelRequire("4yRg9");

var $aB0yS = parcelRequire("aB0yS");

var $9EsDH = parcelRequire("9EsDH");
function $5260ffad7c733513$var$reduceResponseToState(userResponse) {
    const state = {
        language: {
            key: (0, $aB0yS.ensureConsistentKey)(userResponse.language.key),
            originalKey: userResponse.language.key,
            displayName: userResponse.language.displayName
        },
        storedLanguage: {
            key: (0, $aB0yS.ensureConsistentKey)(userResponse.storedLanguage.key),
            originalKey: userResponse.storedLanguage.key,
            displayName: userResponse.storedLanguage.displayName
        },
        timezone: {
            id: userResponse.timezone.id,
            regionKey: userResponse.timezone.regionKey,
            city: userResponse.timezone.city,
            gmtOffset: userResponse.timezone.gmtOffset
        },
        avatars: userResponse.avatars,
        userRequests: {},
        isLoaded: true,
        isLoggedIn: !!userResponse.accountId,
        customMenuLinks: userResponse.customMenuLinks ? userResponse.customMenuLinks : [],
        canAdministerJIRA: userResponse.canAdministerJIRA,
        hasSiteAdministerAccess: userResponse.hasSiteAdministerAccess ?? false,
        agentForPortal: userResponse.agentForPortal,
        accountId: userResponse.accountId,
        displayName: userResponse.displayName,
        email: userResponse.email,
        atlassianAccountManaged: userResponse.atlassianAccountManaged,
        scimManaged: userResponse.scimManaged ?? false,
        externalCustomer: userResponse.externalCustomer
    };
    return state;
}
const $5260ffad7c733513$var$getLocale = ()=>$4yRg9.getMeta('user-locale') || '';
const $5260ffad7c733513$var$getInitialUserState = ()=>{
    const initialState = (0, $9EsDH.default)();
    if (initialState && initialState.user) return $5260ffad7c733513$var$reduceResponseToState(initialState.user);
    return undefined;
};
const $5260ffad7c733513$var$anonymousState = {
    language: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $aB0yS.ensureConsistentKey)($5260ffad7c733513$var$getLocale()),
        originalKey: $5260ffad7c733513$var$getLocale(),
        displayName: $5260ffad7c733513$var$getLocale()
    },
    storedLanguage: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $aB0yS.ensureConsistentKey)($5260ffad7c733513$var$getLocale()),
        originalKey: $5260ffad7c733513$var$getLocale(),
        displayName: $5260ffad7c733513$var$getLocale()
    },
    timezone: {
        id: 'JIRA',
        regionKey: 'JIRA',
        city: '',
        gmtOffset: ''
    },
    isLoaded: true,
    isLoggedIn: false,
    userRequests: {},
    canAdministerJIRA: false,
    hasSiteAdministerAccess: false,
    customMenuLinks: [],
    atlassianAccountManaged: false,
    scimManaged: false
};
const $5260ffad7c733513$var$defaultState = {
    language: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $aB0yS.ensureConsistentKey)($5260ffad7c733513$var$getLocale()),
        originalKey: $5260ffad7c733513$var$getLocale(),
        displayName: $5260ffad7c733513$var$getLocale()
    },
    storedLanguage: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $aB0yS.ensureConsistentKey)($5260ffad7c733513$var$getLocale()),
        originalKey: $5260ffad7c733513$var$getLocale(),
        displayName: $5260ffad7c733513$var$getLocale()
    },
    timezone: {
        id: 'JIRA',
        regionKey: 'JIRA',
        city: '',
        gmtOffset: ''
    },
    isLoaded: false,
    isLoggedIn: false,
    userRequests: {},
    canAdministerJIRA: false,
    hasSiteAdministerAccess: false,
    customMenuLinks: [],
    atlassianAccountManaged: false,
    scimManaged: false,
    // Initial user state spreads _last_ just in case there are things on the server that should
    // override initial (local) state.
    ...$5260ffad7c733513$var$getInitialUserState()
};
function $5260ffad7c733513$export$2e2bcd8739ae039(state = $5260ffad7c733513$var$defaultState, action) {
    switch(action.type){
        case 0, $8ICBx.UPDATE_USER_MODEL:
            {
                const userResponse = action.payload;
                const newState = $5260ffad7c733513$var$reduceResponseToState(userResponse);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $8ICBx.UPDATE_USER_TO_ANON:
            return {
                ...$5260ffad7c733513$var$anonymousState
            };
        case 0, $8ICBx.SAVE_USER_PROFILE_SUCCESS:
            return $5260ffad7c733513$var$handleUpdateUserProfileSuccessAction(state, action);
        case 0, $8ICBx.SUCCESSFULLY_LOGGED_IN:
            return $5260ffad7c733513$var$handleSuccessfullyLoggedIn(state);
        default:
            return state;
    }
}
function $5260ffad7c733513$var$handleUpdateUserProfileSuccessAction(state, action) {
    const displayName = action.payload.displayName || state.displayName;
    const language = action.payload.language || state.storedLanguage;
    const timezone = action.payload.timezone || state.timezone;
    return {
        ...state,
        displayName: displayName,
        timezone: timezone,
        storedLanguage: {
            key: (0, $aB0yS.ensureConsistentKey)(language.originalKey),
            originalKey: language.originalKey,
            displayName: language.displayName
        }
    };
}
const $5260ffad7c733513$var$handleSuccessfullyLoggedIn = (state)=>({
        ...state,
        isLoggedIn: true
    });

});


parcelRegister("65CEU", function(module, exports) {
$parcel$export(module.exports, "userRequestsCountsReducer", () => (parcelRequire("h6lvR")).default);

var $h6lvR = parcelRequire("h6lvR");

});
parcelRegister("h6lvR", function(module, exports) {
$parcel$export(module.exports, "default", () => $2be3ad051d1d0f28$export$2e2bcd8739ae039);
parcelRequire("6Fjys");
var $8ICBx = parcelRequire("8ICBx");
function $2be3ad051d1d0f28$export$2e2bcd8739ae039(state = {}, action) {
    switch(action.type){
        case 0, $8ICBx.UPDATE_USER_REQUESTS_COUNTS_MODEL:
            {
                const userRequestCountResponse = action.payload;
                return {
                    myRequestCount: userRequestCountResponse.allOpenRequestsCount,
                    pendingApprovalCount: userRequestCountResponse.pendingApprovalsCount,
                    approvalCount: userRequestCountResponse.approvalsCount
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("hptTk", function(module, exports) {
$parcel$export(module.exports, "verifyEmailReducer", () => (parcelRequire("lUyAp")).verifyEmailReducer);

var $lUyAp = parcelRequire("lUyAp");

});
parcelRegister("lUyAp", function(module, exports) {
$parcel$export(module.exports, "verifyEmailReducer", () => $77502dc1019b5298$export$681ecd52c505c479);

var $eZUWK = parcelRequire("eZUWK");

var $9EsDH = parcelRequire("9EsDH");
const $77502dc1019b5298$var$defaultState = {
    signupToken: '',
    emailAddress: '',
    validationOutcome: (0, $eZUWK.SUCCESSFUL_VERIFICATION_OUTCOMES).SUCCEEDED,
    portalName: null,
    portalId: null
};
const $77502dc1019b5298$export$681ecd52c505c479 = (state = $77502dc1019b5298$export$53ac33307b5acee9())=>state;
const $77502dc1019b5298$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.verifyEmail) return initialModelState.verifyEmail;
    return $77502dc1019b5298$var$defaultState;
};

});
parcelRegister("eZUWK", function(module, exports) {
$parcel$export(module.exports, "FAILED_VERIFICATION_OUTCOMES", () => $26c455a4eebce034$export$d054ec592d4dac6f);
$parcel$export(module.exports, "SUCCESSFUL_VERIFICATION_OUTCOMES", () => $26c455a4eebce034$export$a94c4b05d26d720a);
const $26c455a4eebce034$export$d054ec592d4dac6f = {
    IDENTITY_ERROR: 'IDENTITY_ERROR',
    TOKEN_INVALID: 'TOKEN_INVALID',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    PROCESSING_ERROR: 'PROCESSING_ERROR'
};
const $26c455a4eebce034$export$a94c4b05d26d720a = {
    SUCCEEDED: 'SUCCEEDED'
};

});



parcelRegister("163SR", function(module, exports) {
$parcel$export(module.exports, "visitPortalReducer", () => (parcelRequire("cIH0s")).visitPortalReducer);

var $cIH0s = parcelRequire("cIH0s");

});
parcelRegister("cIH0s", function(module, exports) {
$parcel$export(module.exports, "visitPortalReducer", () => $78713ac8c95365e5$export$8f27b2a880eeba34);
parcelRequire("bRFjb");
var $lLqMr = parcelRequire("lLqMr");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");
const $78713ac8c95365e5$var$defaultState = {
    loggedInBeforeCheck: false,
    email: '',
    portalName: '',
    initialError: undefined,
    setPasswordJwt: undefined
};
const $78713ac8c95365e5$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    if (initialModelState && initialModelState.visitPortal) return initialModelState.visitPortal;
    return $78713ac8c95365e5$var$defaultState;
};
function $78713ac8c95365e5$export$8f27b2a880eeba34(state = $78713ac8c95365e5$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $lLqMr.FETCH_VISIT_PORTAL_SUCCESS:
            return $78713ac8c95365e5$var$handleFetchVisitPortalSuccess(state, action);
        case 0, $lLqMr.FETCH_VISIT_PORTAL_FAILURE:
            return $78713ac8c95365e5$var$handleFetchVisitPortalFailure(state, action);
        default:
            return state;
    }
}
function $78713ac8c95365e5$var$handleFetchVisitPortalSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        loggedInBeforeCheck: response.loggedInBeforeCheck,
        email: response.email,
        portalName: response.portalName,
        setPasswordJwt: response.setPasswordJwt
    };
}
function $78713ac8c95365e5$var$handleFetchVisitPortalFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                // We need to remove basename, see https://jdog.jira-dev.com/browse/FSD-2557
                callToActionUrl: (error.nextActionUrl || '').replace((0, $7FSs7.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});



parcelRegister("9Epbp", function(module, exports) {
$parcel$export(module.exports, "default", () => $718558beb394db26$export$2e2bcd8739ae039);
parcelRequire("haxwJ");
var $02gNN = parcelRequire("02gNN");

var $WIQuk = parcelRequire("WIQuk");

var $bGZ6O = parcelRequire("bGZ6O");
var $718558beb394db26$export$2e2bcd8739ae039 = (0, $02gNN.default)({
    persisted: $WIQuk.default,
    ui: $bGZ6O.default
});

});
parcelRegister("bGZ6O", function(module, exports) {
$parcel$export(module.exports, "getCombinedUIReducer", () => $5880147b72c8fe9e$export$7d44d6add2bebf09);
$parcel$export(module.exports, "default", () => $5880147b72c8fe9e$export$2e2bcd8739ae039);
parcelRequire("haxwJ");
var $02gNN = parcelRequire("02gNN");
parcelRequire("4TPSo");
var $4AZnm = parcelRequire("4AZnm");
parcelRequire("bNyyt");
var $8HOO0 = parcelRequire("8HOO0");
parcelRequire("1nBFD");
var $htERk = parcelRequire("htERk");
parcelRequire("ada9s");
var $1Jw4q = parcelRequire("1Jw4q");
parcelRequire("5ZauS");
var $8Y7dL = parcelRequire("8Y7dL");
parcelRequire("5gUjS");
var $dCvts = parcelRequire("dCvts");
parcelRequire("7fcVp");
var $8xsZD = parcelRequire("8xsZD");
parcelRequire("jRWrm");
var $cHC5c = parcelRequire("cHC5c");
parcelRequire("7wl4s");
var $9i9TX = parcelRequire("9i9TX");
parcelRequire("k79Dj");
var $g5Y5M = parcelRequire("g5Y5M");
parcelRequire("bXD4o");
var $2qjVA = parcelRequire("2qjVA");
parcelRequire("fRjqJ");
var $9UuOw = parcelRequire("9UuOw");
parcelRequire("fP3qW");
var $1ztyh = parcelRequire("1ztyh");
parcelRequire("fAAX8");
var $7Ukwy = parcelRequire("7Ukwy");
parcelRequire("8cjQg");
var $hsbBM = parcelRequire("hsbBM");
parcelRequire("1Sm44");
var $0dYpU = parcelRequire("0dYpU");
parcelRequire("1SPmw");
var $5basB = parcelRequire("5basB");
parcelRequire("8DaBy");
var $7dg4W = parcelRequire("7dg4W");
parcelRequire("hBqQG");
var $bX3kL = parcelRequire("bX3kL");
parcelRequire("7pfUH");
var $kZChL = parcelRequire("kZChL");
parcelRequire("gGcDT");
var $2m4TN = parcelRequire("2m4TN");
const $5880147b72c8fe9e$var$reducerCollection = {
    context: (0, $1Jw4q.default),
    search: (0, $7dg4W.default),
    helpCenterPreview: (0, $cHC5c.default),
    portalCustomisation: (0, $1ztyh.default),
    requestDetails: (0, $7Ukwy.requestDetailsReducer),
    requestList: (0, $hsbBM.requestListReducer),
    approvalList: (0, $4AZnm.approvalistReducer),
    flags: (0, $8xsZD.flagsReducer),
    userProfile: (0, $2m4TN.userProfileReducer),
    login: (0, $g5Y5M.loginUiReducer),
    loginAnnouncements: (0, $2qjVA.loginAnnouncementsReducer),
    invitedSignUp: (0, $9i9TX.invitedSignUpUiReducer),
    resetPassword: (0, $5basB.resetPasswordReducer),
    completeSignup: (0, $htERk.completeSignupUiReducer),
    signUpCheckEmail: (0, $bX3kL.checkEmailUiReducer),
    featuredAndSortedPortals: (0, $8Y7dL.featuredAndSortedPortalsReducer),
    feedbackCollector: (0, $dCvts.feedbackCollectorReducer),
    portals: (0, $9UuOw.portalReducer),
    resendVerifyEmail: (0, $0dYpU.resendVerifyReducer),
    topics: (0, $kZChL.default),
    chatDetails: (0, $8HOO0.chatDetailsReducer)
};
const $5880147b72c8fe9e$export$7d44d6add2bebf09 = (asyncReducers)=>(0, $02gNN.default)({
        ...$5880147b72c8fe9e$var$reducerCollection,
        ...asyncReducers
    });
var $5880147b72c8fe9e$export$2e2bcd8739ae039 = (0, $02gNN.default)($5880147b72c8fe9e$var$reducerCollection);

});
parcelRegister("4TPSo", function(module, exports) {
$parcel$export(module.exports, "approvalistReducer", () => (parcelRequire("4AZnm")).approvalistReducer);

var $4AZnm = parcelRequire("4AZnm");

});
parcelRegister("4AZnm", function(module, exports) {
$parcel$export(module.exports, "approvalistReducer", () => $67659e868a1c1338$export$b467bcef5b3409ab);
parcelRequire("jTmWg");
var $kN7vu = parcelRequire("kN7vu");
const $67659e868a1c1338$var$defaultState = {
    isLoading: false
};
function $67659e868a1c1338$export$b467bcef5b3409ab(state = $67659e868a1c1338$var$defaultState, action) {
    switch(action.type){
        case 0, $kN7vu.FETCH_APPROVAL_LIST_MODEL:
            return $67659e868a1c1338$var$handleFetchApprovalListAction(state);
        case 0, $kN7vu.FETCH_APPROVAL_LIST_SUCCESS:
            return $67659e868a1c1338$var$handleFetchApprovalListSuccess(state);
        case 0, $kN7vu.FETCH_APPROVAL_LIST_FAILURE:
            return $67659e868a1c1338$var$handleFetchApprovalListFailure(state);
        default:
            return state;
    }
}
const $67659e868a1c1338$var$handleFetchApprovalListAction = (state)=>({
        ...state,
        isLoading: true
    });
const $67659e868a1c1338$var$handleFetchApprovalListSuccess = (state)=>({
        ...state,
        isLoading: false
    });
const $67659e868a1c1338$var$handleFetchApprovalListFailure = (state)=>({
        ...state,
        isLoading: false
    });

});


parcelRegister("bNyyt", function(module, exports) {
$parcel$export(module.exports, "chatDetailsReducer", () => (parcelRequire("8HOO0")).chatDetailsReducer);

var $8HOO0 = parcelRequire("8HOO0");

});
parcelRegister("8HOO0", function(module, exports) {
$parcel$export(module.exports, "chatDetailsReducer", () => $4e9caa47a3e8b138$export$38fe3740469ec1e6);
parcelRequire("aaYFd");
var $8QZqc = parcelRequire("8QZqc");
const $4e9caa47a3e8b138$export$29e68d440392d68e = {
    isChatSideBarOpen: false
};
function $4e9caa47a3e8b138$export$38fe3740469ec1e6(state = $4e9caa47a3e8b138$export$29e68d440392d68e, action) {
    if (action.type === (0, $8QZqc.OPEN_CHAT_SIDE_BAR)) return {
        ...state,
        isChatSideBarOpen: true
    };
    if (action.type === (0, $8QZqc.CLOSE_CHAT_SIDE_BAR)) return {
        ...state,
        isChatSideBarOpen: false
    };
    return state;
}

});
parcelRegister("aaYFd", function(module, exports) {
$parcel$export(module.exports, "OPEN_CHAT_SIDE_BAR", () => (parcelRequire("8QZqc")).OPEN_CHAT_SIDE_BAR);
$parcel$export(module.exports, "CLOSE_CHAT_SIDE_BAR", () => (parcelRequire("8QZqc")).CLOSE_CHAT_SIDE_BAR);
$parcel$export(module.exports, "openChatSideBar", () => (parcelRequire("8QZqc")).openChatSideBar);
$parcel$export(module.exports, "closeChatSideBar", () => (parcelRequire("8QZqc")).closeChatSideBar);

var $8QZqc = parcelRequire("8QZqc");

});
parcelRegister("8QZqc", function(module, exports) {
$parcel$export(module.exports, "OPEN_CHAT_SIDE_BAR", () => $f424da8df406fe12$export$dc5a6dd48e3ba8bf);
$parcel$export(module.exports, "CLOSE_CHAT_SIDE_BAR", () => $f424da8df406fe12$export$c4de34e9e1c374f8);
$parcel$export(module.exports, "openChatSideBar", () => $f424da8df406fe12$export$348d5042d1099e44);
$parcel$export(module.exports, "closeChatSideBar", () => $f424da8df406fe12$export$7fb0f09e601a69a9);
const $f424da8df406fe12$export$dc5a6dd48e3ba8bf = 'state.ui.chat-details.OPEN_CHAT_SIDE_BAR';
const $f424da8df406fe12$export$c4de34e9e1c374f8 = 'state.ui.chat-details.CLOSE_CHAT_SIDE_BAR';
const $f424da8df406fe12$export$348d5042d1099e44 = ()=>({
        type: $f424da8df406fe12$export$dc5a6dd48e3ba8bf
    });
const $f424da8df406fe12$export$7fb0f09e601a69a9 = ()=>({
        type: $f424da8df406fe12$export$c4de34e9e1c374f8
    });

});




parcelRegister("1nBFD", function(module, exports) {
$parcel$export(module.exports, "completeSignupUiReducer", () => (parcelRequire("htERk")).completeSignupUiReducer);

var $htERk = parcelRequire("htERk");

});
parcelRegister("htERk", function(module, exports) {
$parcel$export(module.exports, "completeSignupUiReducer", () => $c0dd176b719add87$export$11cdd5afa8f3d37e);
parcelRequire("l0dvx");
var $053zO = parcelRequire("053zO");
const $c0dd176b719add87$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    submitError: undefined,
    isNewSignupLinkBeingSent: false,
    newSignupLinkSuccessfullySent: false
};
function $c0dd176b719add87$export$11cdd5afa8f3d37e(state = $c0dd176b719add87$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $053zO.COMPLETE_SIGNUP:
            return $c0dd176b719add87$var$handleCompleteSignup(state);
        case 0, $053zO.COMPLETE_SIGNUP_FAILURE:
            return $c0dd176b719add87$var$handleCompleteSignupFailure(state, action);
        case 0, $053zO.SEND_NEW_SIGNUP_LINK:
            return $c0dd176b719add87$var$handleSendNewSignupLink(state);
        case 0, $053zO.SEND_NEW_SIGNUP_LINK_SUCCESS:
            return $c0dd176b719add87$var$handleSendNewSignupLinkSuccess(state);
        case 0, $053zO.SEND_NEW_SIGNUP_LINK_FAILURE:
            return $c0dd176b719add87$var$handleSendNewSignupLinkFailure(state);
        default:
            return state;
    }
}
const $c0dd176b719add87$var$handleCompleteSignup = (state)=>({
        ...state,
        isSubmitting: true,
        submitError: undefined
    });
const $c0dd176b719add87$var$handleCompleteSignupFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        submitError: action.payload.error
    });
const $c0dd176b719add87$var$handleSendNewSignupLink = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: true
    });
const $c0dd176b719add87$var$handleSendNewSignupLinkSuccess = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: false,
        newSignupLinkSuccessfullySent: true
    });
const $c0dd176b719add87$var$handleSendNewSignupLinkFailure = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: false
    });

});


parcelRegister("ada9s", function(module, exports) {
$parcel$export(module.exports, "contextReducer", () => (parcelRequire("1Jw4q")).default);

var $1Jw4q = parcelRequire("1Jw4q");

});
parcelRegister("1Jw4q", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d71c3c7529ef89d$export$2e2bcd8739ae039);
parcelRequire("5bAQY");
var $8Z7Xs = parcelRequire("8Z7Xs");

var $9EsDH = parcelRequire("9EsDH");

var $vYPX4 = parcelRequire("vYPX4");
const $9d71c3c7529ef89d$export$53ac33307b5acee9 = ()=>{
    var _initialModelState$po;
    const initialModelState = (0, $9EsDH.default)();
    const initialState = initialModelState !== null && initialModelState !== void 0 && initialModelState.portal ? {
        portalId: Number((_initialModelState$po = initialModelState.portal) === null || _initialModelState$po === void 0 ? void 0 : _initialModelState$po.id)
    } : {};
    return initialState;
};
const $9d71c3c7529ef89d$export$49d5fc8cba920a0 = $9d71c3c7529ef89d$export$53ac33307b5acee9();
function $9d71c3c7529ef89d$export$2e2bcd8739ae039(state = $9d71c3c7529ef89d$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $8Z7Xs.UPDATE_CONTEXT:
            {
                const { pathname: pathname, pathParams: pathParams, routeName: routeName } = action.payload;
                let portalId;
                if (pathParams) portalId = (0, $vYPX4.toNumber)(pathParams.portalId);
                return {
                    portalId: portalId,
                    pathname: pathname,
                    routeName: routeName
                };
            }
        case 0, $8Z7Xs.CLEAR_CONTEXT:
            return {};
        default:
            return state;
    }
}

});
parcelRegister("5bAQY", function(module, exports) {
$parcel$export(module.exports, "UPDATE_CONTEXT", () => (parcelRequire("8Z7Xs")).UPDATE_CONTEXT);
$parcel$export(module.exports, "updateContextAction", () => (parcelRequire("8Z7Xs")).updateContextAction);
$parcel$export(module.exports, "CLEAR_CONTEXT", () => (parcelRequire("8Z7Xs")).CLEAR_CONTEXT);
$parcel$export(module.exports, "clearContextAction", () => (parcelRequire("8Z7Xs")).clearContextAction);

var $8Z7Xs = parcelRequire("8Z7Xs");

});
parcelRegister("8Z7Xs", function(module, exports) {
$parcel$export(module.exports, "UPDATE_CONTEXT", () => $24f952baff3edf6a$export$5f26c565ccbc9352);
$parcel$export(module.exports, "CLEAR_CONTEXT", () => $24f952baff3edf6a$export$58f534967683dfbc);
$parcel$export(module.exports, "updateContextAction", () => $24f952baff3edf6a$export$42bc3ab9d92c16ac);
$parcel$export(module.exports, "clearContextAction", () => $24f952baff3edf6a$export$a40d7f795b5e0d7d);
const $24f952baff3edf6a$export$5f26c565ccbc9352 = 'state.ui.context.UPDATE_CONTEXT';
const $24f952baff3edf6a$export$58f534967683dfbc = 'state.ui.context.CLEAR_CONTEXT';
const $24f952baff3edf6a$export$42bc3ab9d92c16ac = (context)=>({
        type: $24f952baff3edf6a$export$5f26c565ccbc9352,
        payload: context
    });
const $24f952baff3edf6a$export$a40d7f795b5e0d7d = ()=>({
        type: $24f952baff3edf6a$export$58f534967683dfbc
    });

});




parcelRegister("5ZauS", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => (parcelRequire("8Y7dL")).featuredAndSortedPortalsReducer);

var $8Y7dL = parcelRequire("8Y7dL");

});
parcelRegister("8Y7dL", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => $58e3e29f0d8cc285$export$be9fe934804fce97);

var $1We2B = parcelRequire("1We2B");
parcelRequire("9ueTd");
var $99eJc = parcelRequire("99eJc");
parcelRequire("9FfOm");
var $2CIj9 = parcelRequire("2CIj9");

var $9EsDH = parcelRequire("9EsDH");
const $58e3e29f0d8cc285$export$aa8b8e485fe6d2cc = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    return {
        featuredPortalIds: [],
        orderedPortalIds: [],
        hiddenPortalIds: [],
        sortBy: 'POPULARITY',
        isDefaultViewLoading: !(initialModelState !== null && initialModelState !== void 0 && initialModelState.featuredAndSortedPortals),
        isExpandedViewLoading: false,
        isReorderingExperienceLoading: false,
        isSortedDataLoading: false,
        isDirty: false,
        isSaveInProgress: false,
        isPortalReorderingDataLoaded: false
    };
};
const $58e3e29f0d8cc285$export$95d7509c19bcb89a = (rank)=>rank || 0;
const $58e3e29f0d8cc285$var$defaultState = $58e3e29f0d8cc285$export$aa8b8e485fe6d2cc();
function $58e3e29f0d8cc285$export$be9fe934804fce97(state = $58e3e29f0d8cc285$var$defaultState, action) {
    switch(action.type){
        case 0, $99eJc.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL:
            return $58e3e29f0d8cc285$var$handleFetchFeaturedAndSortedPortalsAction(state, action);
        case 0, $99eJc.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS:
            return $58e3e29f0d8cc285$var$handleFetchFeaturedAndSortedPortalsSuccess(state, action);
        case 0, $99eJc.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE:
            return $58e3e29f0d8cc285$var$handleFetchFeaturedAndSortedPortalsFailure(state, action);
        case 0, $99eJc.MARK_PORTAL_FEATURED:
            return $58e3e29f0d8cc285$var$handleMarkPortalFeatured(state, action);
        case 0, $99eJc.TOGGLE_PORTAL_VISIBILITY:
            return $58e3e29f0d8cc285$var$handleTogglePortalVisibility(state, action);
        case 0, $99eJc.REORDER_FEATURED_PORTAL:
            return $58e3e29f0d8cc285$var$handleReorderFeaturedPortal(state, action);
        case 0, $99eJc.UPDATE_PORTAL_REORDER_SETTINGS_MODEL:
            return $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettings(state);
        case 0, $99eJc.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS:
            return $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettingsModelSuccess(state);
        case 0, $99eJc.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE:
            return $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettingsModelFailure(state);
        case 0, $99eJc.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettingsSuccess(state);
        case 0, $99eJc.UPDATE_PORTAL_REORDER_SETTINGS_FAILURE:
            return $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettingsFailure(state);
        case 0, $99eJc.RESET_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $58e3e29f0d8cc285$var$handleResetPortalReorderSettingsSuccess(state, action);
        case 0, $99eJc.MARK_PORTAL_REORDER_SETTINGS_DIRTY:
            return $58e3e29f0d8cc285$var$handleMarkPortalReorderSettingsDirty(state);
        default:
            return state;
    }
}
const $58e3e29f0d8cc285$var$handleFetchFeaturedAndSortedPortalsAction = (state, action)=>{
    if (action.payload.params.exploreAll) {
        /* On help seekers view, and clicked on exploreAll */ if (!action.payload.params.isPortalReorderingSelected) return {
            ...state,
            isExpandedViewLoading: true
        };
        /* on changing sorted preference on portal reordering screen */ if (action.payload.params.sortBy) return {
            ...state,
            isSortedDataLoading: true,
            sortBy: action.payload.params.sortBy ? action.payload.params.sortBy : 'POPULARITY'
        };
        /* on initial page load for portal reordering screen */ return {
            ...state,
            isReorderingExperienceLoading: true
        };
    }
    /* On help seekers view, initial loading for featured portals or top 6 sorted portals */ return {
        ...state,
        isDefaultViewLoading: true
    };
};
const $58e3e29f0d8cc285$var$handleFetchFeaturedAndSortedPortalsSuccess = (state, action)=>{
    if (!action.requestParams.isPortalReorderingSelected) {
        /* on Help seeker view - on clicking exploreAll */ if (action.requestParams.exploreAll) return {
            ...state,
            isExpandedViewLoading: false,
            isPortalReorderingDataLoaded: false
        };
        /* on Help seeker view - initial loading */ return {
            ...state,
            isDefaultViewLoading: false,
            isPortalReorderingDataLoaded: false
        };
    }
    /* on portal reordering screen - on changing sortBy option */ if (action.requestParams.sortBy) return {
        ...state,
        orderedPortalIds: action.payload.portals.map((portal)=>portal.id),
        isSortedDataLoading: false,
        sortBy: action.requestParams.sortBy || state.sortBy
    };
    /* on portal reordering screen - initial load */ return {
        ...state,
        featuredPortalIds: action.payload.portals.filter((0, $2CIj9.isFeaturedPortal)).sort((portal1, portal2)=>$58e3e29f0d8cc285$export$95d7509c19bcb89a(portal1.rank) - $58e3e29f0d8cc285$export$95d7509c19bcb89a(portal2.rank)).map((portal)=>portal.id),
        hiddenPortalIds: action.payload.portals.filter((0, $2CIj9.isHiddenPortal)).map((portal)=>portal.id),
        orderedPortalIds: action.payload.portals.map((portal)=>portal.id),
        isReorderingExperienceLoading: false,
        sortBy: action.payload.sortBy || state.sortBy,
        isPortalReorderingDataLoaded: true
    };
};
const $58e3e29f0d8cc285$var$handleFetchFeaturedAndSortedPortalsFailure = (state, action)=>{
    /* Error in  help seekers view*/ if (!action.requestParams.isPortalReorderingSelected) return {
        ...state,
        isExpandedViewLoading: false,
        isDefaultViewLoading: false
    };
    /* Error in portal reordering view */ return {
        ...state,
        isReorderingExperienceLoading: false,
        isSortedDataLoading: false
    };
};
const $58e3e29f0d8cc285$var$handleMarkPortalFeatured = (state, action)=>{
    const { id: id, isFeatured: isFeatured } = action.payload;
    const { featuredPortalIds: featuredPortalIds } = state;
    const updateFeaturedPortalIds = [
        ...featuredPortalIds
    ];
    if (isFeatured) updateFeaturedPortalIds.push(id);
    else (0, $1We2B.remove)(updateFeaturedPortalIds, (item)=>item === id);
    return {
        ...state,
        featuredPortalIds: updateFeaturedPortalIds,
        isDirty: true
    };
};
const $58e3e29f0d8cc285$var$handleTogglePortalVisibility = (state, action)=>{
    const { id: id, hiddenFromHomeScreen: hiddenFromHomeScreen } = action.payload;
    const { hiddenPortalIds: hiddenPortalIds } = state;
    const updatedHiddenPortalIds = [
        ...hiddenPortalIds
    ];
    if (hiddenFromHomeScreen) updatedHiddenPortalIds.push(id);
    else (0, $1We2B.remove)(updatedHiddenPortalIds, (item)=>item === id);
    return {
        ...state,
        hiddenPortalIds: (0, $1We2B.uniq)(updatedHiddenPortalIds),
        isDirty: true
    };
};
const $58e3e29f0d8cc285$var$reOrder = (list, startIndex, endIndex)=>{
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const $58e3e29f0d8cc285$var$handleReorderFeaturedPortal = (state, action)=>{
    const { oldIndex: oldIndex, newIndex: newIndex } = action.payload;
    return {
        ...state,
        featuredPortalIds: $58e3e29f0d8cc285$var$reOrder(state.featuredPortalIds, oldIndex, newIndex),
        isDirty: true
    };
};
const $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettings = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettingsModelSuccess = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettingsModelFailure = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettingsSuccess = (state)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: false
    };
};
const $58e3e29f0d8cc285$var$handleUpdatePortalReorderSettingsFailure = (state)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: true
    };
};
// Common logic for both Reset and Cancel action
const $58e3e29f0d8cc285$var$handleResetPortalReorderSettingsSuccess = (state, action)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: false,
        sortBy: action.payload.sortBy,
        featuredPortalIds: action.payload.featuredPortalIds,
        orderedPortalIds: action.payload.orderedPortalIds
    };
};
const $58e3e29f0d8cc285$var$handleMarkPortalReorderSettingsDirty = (state)=>{
    return {
        ...state,
        isDirty: true
    };
};

});


parcelRegister("5gUjS", function(module, exports) {
$parcel$export(module.exports, "feedbackCollectorReducer", () => (parcelRequire("dCvts")).feedbackCollectorReducer);

var $dCvts = parcelRequire("dCvts");

});
parcelRegister("dCvts", function(module, exports) {
$parcel$export(module.exports, "feedbackCollectorReducer", () => $358b0436e918094d$export$8085646591e2a0b2);
parcelRequire("64xva");
var $7kWEW = parcelRequire("7kWEW");

var $hrPHR = parcelRequire("hrPHR");
const $358b0436e918094d$var$addPortalPrefix = (featureName)=>{
    return 'JSM Portal '.concat(featureName);
};
const $358b0436e918094d$export$fe349eba520514db = {
    shouldOpenFeedbackWidget: false,
    showTypeField: false,
    additionalFields: {}
};
const $358b0436e918094d$var$defaultState = $358b0436e918094d$export$fe349eba520514db;
function $358b0436e918094d$export$8085646591e2a0b2(state = $358b0436e918094d$var$defaultState, action) {
    switch(action.type){
        case 0, $7kWEW.SHOW_FEEDACK_COLLECTOR:
            return $358b0436e918094d$var$handleFeedbackCollector(state, action);
        case 0, $7kWEW.HIDE_FEEDACK_COLLECTOR:
            return $358b0436e918094d$var$handleFeedbackCollector(state, action);
        case 0, $7kWEW.UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR:
            return $358b0436e918094d$var$handleUpdateAdditionalFieldsInFeedbackCollector(state, action);
        default:
            return state;
    }
}
const $358b0436e918094d$var$handleFeedbackCollector = (state, action)=>{
    if (action.type === (0, $7kWEW.HIDE_FEEDACK_COLLECTOR)) return {
        ...state,
        shouldOpenFeedbackWidget: false
    };
    const { showTypeField: showTypeField, CustomComponent: CustomComponent, featureName: featureName, env: env } = action.payload;
    const newState = {
        ...state,
        showTypeField: showTypeField,
        CustomComponent: CustomComponent,
        shouldOpenFeedbackWidget: true
    };
    if (env === (0, $hrPHR.EnvType).PROD) {
        newState.additionalFields = {
            // Do not change this field as this is an actual custom field in https://jira-feedback.atlassian.net. Changing this will break feedback collector in production.
            customfield_10076: $358b0436e918094d$var$addPortalPrefix(featureName)
        };
        return newState;
    }
    newState.additionalFields = {
        // Do not change this field as this is an actual custom field in https://arajpal.atlassian.net. Changing this will break feedback collector in staging.
        customfield_10094: $358b0436e918094d$var$addPortalPrefix(featureName)
    };
    return newState;
};
const $358b0436e918094d$var$handleUpdateAdditionalFieldsInFeedbackCollector = (state, action)=>{
    return {
        ...state,
        additionalFields: {
            ...state.additionalFields,
            ...action.payload.additionalFields
        }
    };
};

});
parcelRegister("64xva", function(module, exports) {
$parcel$export(module.exports, "SHOW_FEEDACK_COLLECTOR", () => (parcelRequire("7kWEW")).SHOW_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "showFeedbackCollector", () => (parcelRequire("7kWEW")).showFeedbackCollector);
$parcel$export(module.exports, "HIDE_FEEDACK_COLLECTOR", () => (parcelRequire("7kWEW")).HIDE_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "hideFeedbackCollector", () => (parcelRequire("7kWEW")).hideFeedbackCollector);
$parcel$export(module.exports, "UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR", () => (parcelRequire("7kWEW")).UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "updateAdditionalFieldsInFeedbackCollector", () => (parcelRequire("7kWEW")).updateAdditionalFieldsInFeedbackCollector);

var $7kWEW = parcelRequire("7kWEW");

});
parcelRegister("7kWEW", function(module, exports) {
$parcel$export(module.exports, "SHOW_FEEDACK_COLLECTOR", () => $53a39a9c9cfdfe94$export$e920d8568364aa72);
$parcel$export(module.exports, "HIDE_FEEDACK_COLLECTOR", () => $53a39a9c9cfdfe94$export$20dd51f415d7804e);
$parcel$export(module.exports, "UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR", () => $53a39a9c9cfdfe94$export$3366d0333401654a);
$parcel$export(module.exports, "showFeedbackCollector", () => $53a39a9c9cfdfe94$export$c759098e05f62ce0);
$parcel$export(module.exports, "hideFeedbackCollector", () => $53a39a9c9cfdfe94$export$92f2211d73785c9);
$parcel$export(module.exports, "updateAdditionalFieldsInFeedbackCollector", () => $53a39a9c9cfdfe94$export$41e78cf91821ccad);
const $53a39a9c9cfdfe94$export$e920d8568364aa72 = 'state.ui.feedback-collector.SHOW_FEEDACK_COLLECTOR';
const $53a39a9c9cfdfe94$export$20dd51f415d7804e = 'state.ui.feedback-collector.HIDE_FEEDACK_COLLECTOR';
const $53a39a9c9cfdfe94$export$3366d0333401654a = 'state.ui.feedback-collector.UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR';
const $53a39a9c9cfdfe94$export$c759098e05f62ce0 = (payload)=>({
        payload: payload,
        type: $53a39a9c9cfdfe94$export$e920d8568364aa72
    });
const $53a39a9c9cfdfe94$export$92f2211d73785c9 = ()=>({
        type: $53a39a9c9cfdfe94$export$20dd51f415d7804e
    });
const $53a39a9c9cfdfe94$export$41e78cf91821ccad = (additionalFields)=>({
        type: $53a39a9c9cfdfe94$export$3366d0333401654a,
        payload: {
            additionalFields: additionalFields
        }
    });

});




parcelRegister("7fcVp", function(module, exports) {
$parcel$export(module.exports, "flagsReducer", () => (parcelRequire("8xsZD")).flagsReducer);

var $8xsZD = parcelRequire("8xsZD");

});
parcelRegister("8xsZD", function(module, exports) {
$parcel$export(module.exports, "flagsReducer", () => $d9379c1061550e6b$export$64fc5b4c35b25733);

var $6p5HB = parcelRequire("6p5HB");
const $d9379c1061550e6b$var$MAX_FLAG_ID = 99999;
const $d9379c1061550e6b$var$defaultState = {
    flags: []
};
function $d9379c1061550e6b$export$64fc5b4c35b25733(state = $d9379c1061550e6b$var$defaultState, action) {
    switch(action.type){
        case 0, $6p5HB.SHOW_ERROR_FLAG:
            return $d9379c1061550e6b$var$handleShowErrorFlag(state, action);
        case 0, $6p5HB.SHOW_WARNING_FLAG:
            return $d9379c1061550e6b$var$handleShowWarningFlag(state, action);
        case 0, $6p5HB.SHOW_SUCCESS_FLAG:
            return $d9379c1061550e6b$var$handleShowSuccessFlag(state, action);
        case 0, $6p5HB.DISMISS_FLAG:
            return $d9379c1061550e6b$var$handleFlagDismissal(state, action);
        case 0, $6p5HB.SHOW_BOLD_APPEARANCE_FLAG:
            return $d9379c1061550e6b$var$handleShowBoldAppearanceFlag(state, action);
        default:
            return state;
    }
}
function $d9379c1061550e6b$var$handleShowErrorFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $d9379c1061550e6b$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'error'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $d9379c1061550e6b$var$handleShowWarningFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $d9379c1061550e6b$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'warning'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $d9379c1061550e6b$var$handleShowSuccessFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $d9379c1061550e6b$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'success'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $d9379c1061550e6b$var$handleShowBoldAppearanceFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $d9379c1061550e6b$var$generateFlagId(),
        appearance: action.payload.appearance,
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        dismissActionValue: action.payload.dismissActionValue,
        type: 'bold'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
const $d9379c1061550e6b$var$generateFlagId = ()=>// Integer between 0 and MAX_FLAG_ID
    Math.floor(Math.random() * Math.floor($d9379c1061550e6b$var$MAX_FLAG_ID));
function $d9379c1061550e6b$var$handleFlagDismissal(state, action) {
    const updatedFlags = state.flags.filter((flag)=>flag.id !== action.payload.flagId);
    return {
        ...state,
        flags: updatedFlags
    };
}

});


parcelRegister("jRWrm", function(module, exports) {
$parcel$export(module.exports, "helpcenterPreviewReducer", () => (parcelRequire("cHC5c")).default);

var $cHC5c = parcelRequire("cHC5c");

});
parcelRegister("cHC5c", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b9583eef97f8ebe$export$2e2bcd8739ae039);

var $1E402 = parcelRequire("1E402");

var $1We2B = parcelRequire("1We2B");
const $7b9583eef97f8ebe$var$getDefaultState = ()=>({
        isCustomizing: false,
        isSaveInProgress: false,
        translations: {},
        uploadsInProgress: {}
    });
function $7b9583eef97f8ebe$export$2e2bcd8739ae039(state = $7b9583eef97f8ebe$var$getDefaultState(), action) {
    switch(action.type){
        case $1E402.UPDATE_HELP_CENTER_PREVIEW_MODEL:
            {
                const newState = (0, $1We2B.mergeWith)({}, {
                    ...state
                }, {
                    ...action.payload
                }, // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // eslint-disable-next-line @typescript-eslint/ban-types
                (_, srcValue)=>{
                    // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
                    // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
                    if (srcValue === undefined) return null;
                    // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
                    return undefined;
                });
                return {
                    ...newState
                };
            }
        case $1E402.EDITING_HELP_CENTER:
            return {
                ...state,
                isCustomizing: action.payload
            };
        case $1E402.CLEAR_HELP_CENTER_PREVIEW_MODEL:
            return {
                translations: {},
                uploadsInProgress: {},
                isCustomizing: false,
                isSaveInProgress: false
            };
        case $1E402.UPDATE_HELP_CENTER_BRANDING:
            return {
                ...state,
                isSaveInProgress: true
            };
        case $1E402.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $1E402.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $1E402.UPDATE_HELP_CENTER_BRANDING_SAVE_START:
            return {
                ...state,
                isSaveInProgress: true
            };
        case $1E402.UPDATE_HELP_CENTER_BRANDING_FAILURE:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $1E402.UPLOAD_START:
            return {
                ...state,
                uploadsInProgress: {
                    ...state.uploadsInProgress,
                    [action.payload.fileCollection]: true
                }
            };
        case $1E402.UPLOAD_END:
            return {
                ...state,
                uploadsInProgress: {
                    ...state.uploadsInProgress,
                    [action.payload.fileCollection]: false
                }
            };
        default:
            return state;
    }
}

});


parcelRegister("7wl4s", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpUiReducer", () => (parcelRequire("9i9TX")).invitedSignUpUiReducer);

var $9i9TX = parcelRequire("9i9TX");

});
parcelRegister("9i9TX", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpUiReducer", () => $fc6e0860efd01c0c$export$cbd9046ae6d17b9c);
parcelRequire("bRFjb");
var $lLqMr = parcelRequire("lLqMr");
const $fc6e0860efd01c0c$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    error: undefined
};
function $fc6e0860efd01c0c$export$cbd9046ae6d17b9c(state = $fc6e0860efd01c0c$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $lLqMr.INVITED_SIGN_UP:
            return $fc6e0860efd01c0c$var$handleInvitedSignUp(state);
        case 0, $lLqMr.INVITED_SIGN_UP_FAILURE:
            return $fc6e0860efd01c0c$var$handleInvitedSignUpFailure(state, action);
        default:
            return state;
    }
}
const $fc6e0860efd01c0c$var$handleInvitedSignUp = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined
    });
const $fc6e0860efd01c0c$var$handleInvitedSignUpFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        error: action.payload.error
    });

});


parcelRegister("k79Dj", function(module, exports) {
$parcel$export(module.exports, "loginUiReducer", () => (parcelRequire("g5Y5M")).loginUiReducer);

var $g5Y5M = parcelRequire("g5Y5M");

});
parcelRegister("g5Y5M", function(module, exports) {
$parcel$export(module.exports, "loginUiReducer", () => $e4728b2e019c59d8$export$b52e2813f588ee78);
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");

var $g1L0m = parcelRequire("g1L0m");
const $e4728b2e019c59d8$export$49d5fc8cba920a0 = {
    email: '',
    atlassianAccountCheckPerformed: false,
    isSubmitting: false,
    isSendingForgotPasswordEmail: false,
    isSendingCreatePasswordEmail: false,
    authInfo: {
        accountStage: (0, $g1L0m.AccountStageType).LOGIN,
        authMethods: new Map([
            [
                (0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                {}
            ]
        ])
    },
    showPasswordConfirmation: false,
    showSsoTestModeErrorPage: false,
    showLoginConsentErrorPage: false
};
function $e4728b2e019c59d8$export$b52e2813f588ee78(state = $e4728b2e019c59d8$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $uiV1X.CHANGE_EMAIL_INPUT:
            return $e4728b2e019c59d8$var$handleChangeEmailInput(state, action);
        case 0, $uiV1X.CHECK_LOGIN_ACTION:
            return $e4728b2e019c59d8$var$handleCheckLoginActionAction(state);
        case 0, $uiV1X.CHECK_LOGIN_ACTION_SUCCESS:
            return $e4728b2e019c59d8$var$handleCheckLoginActionSuccess(state, action);
        case 0, $uiV1X.CHECK_LOGIN_ACTION_FAILURE:
            return $e4728b2e019c59d8$var$handleCheckLoginActionFailure(state, action);
        case 0, $uiV1X.CREATE_PASSWORD:
            return $e4728b2e019c59d8$var$handleCreatePassword(state);
        case 0, $uiV1X.FORGOT_PASSWORD:
            return $e4728b2e019c59d8$var$handleForgotPassword(state);
        case 0, $uiV1X.FORGOT_PASSWORD_FAILURE:
            return $e4728b2e019c59d8$var$handleForgotPasswordFailure(state);
        case 0, $uiV1X.FORGOT_PASSWORD_SUCCESS:
            return $e4728b2e019c59d8$var$handleForgotPasswordSuccess(state);
        case 0, $uiV1X.CREATE_PASSWORD_SUCCESS:
            return $e4728b2e019c59d8$var$handleCreatePasswordSuccess(state);
        case 0, $uiV1X.LOGIN_ATTEMPT:
            return $e4728b2e019c59d8$var$handleLoginAttempt(state);
        case 0, $uiV1X.LOGIN_ATTEMPT_SUCCESS:
            return $e4728b2e019c59d8$var$handleLoginAttemptSuccess(state, action);
        case 0, $uiV1X.LOGIN_ATTEMPT_FAILURE:
            return $e4728b2e019c59d8$var$handleLoginAttemptFailure(state, action);
        case 0, $uiV1X.CA_SSO_TEST_MODE_FAILURE:
            return $e4728b2e019c59d8$var$handleCaSsoTestModeFailure(state);
        case 0, $uiV1X.LOGIN_CONSENT_FAILURE:
            return $e4728b2e019c59d8$var$handleLoginConsentFailure(state);
        case 0, $uiV1X.RESET_LOGIN:
            return $e4728b2e019c59d8$var$resetLogin(action);
        default:
            return state;
    }
}
const $e4728b2e019c59d8$var$handleChangeEmailInput = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        email: action.payload.email
    });
const $e4728b2e019c59d8$var$handleCheckLoginActionAction = (state)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        error: undefined
    });
const $e4728b2e019c59d8$var$handleCheckLoginActionSuccess = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: true,
        authInfo: {
            ...state.authInfo,
            accountStage: action.payload.authInfo.accountStage,
            authMethods: action.payload.authInfo.authMethods
        },
        error: undefined
    });
const $e4728b2e019c59d8$var$handleCaSsoTestModeFailure = (state)=>({
        ...state,
        showSsoTestModeErrorPage: true
    });
const $e4728b2e019c59d8$var$handleLoginConsentFailure = (state)=>({
        ...state,
        showLoginConsentErrorPage: true
    });
const $e4728b2e019c59d8$var$handleCheckLoginActionFailure = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        error: action.payload.error
    });
const $e4728b2e019c59d8$var$handleCreatePassword = (state)=>({
        ...state,
        isSendingCreatePasswordEmail: true
    });
const $e4728b2e019c59d8$var$handleCreatePasswordSuccess = (state)=>({
        ...state,
        isSendingCreatePasswordEmail: false,
        showPasswordConfirmation: true
    });
const $e4728b2e019c59d8$var$handleForgotPassword = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: true
    });
const $e4728b2e019c59d8$var$handleForgotPasswordFailure = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: false
    });
const $e4728b2e019c59d8$var$handleForgotPasswordSuccess = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: false,
        showPasswordConfirmation: true
    });
const $e4728b2e019c59d8$var$handleLoginAttempt = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined,
        loginAttemptResponse: undefined
    });
function $e4728b2e019c59d8$var$handleLoginAttemptSuccess(state, action) {
    const { loginAttemptResponse: loginAttemptResponse } = action.payload;
    const defaultValues = {
        loginAttemptResponse: loginAttemptResponse,
        isSubmitting: false,
        error: undefined
    };
    if (loginAttemptResponse.loginSucceeded) return {
        ...state,
        ...defaultValues,
        email: '',
        atlassianAccountCheckPerformed: false
    };
    return {
        ...state,
        ...defaultValues
    };
}
const $e4728b2e019c59d8$var$handleLoginAttemptFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        loginAttemptResponse: undefined,
        error: action.payload.error
    });
const $e4728b2e019c59d8$var$resetLogin = (action)=>({
        ...$e4728b2e019c59d8$export$49d5fc8cba920a0,
        email: action.payload.email
    });

});


parcelRegister("bXD4o", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => (parcelRequire("2qjVA")).loginAnnouncementsReducer);

var $2qjVA = parcelRequire("2qjVA");

});
parcelRegister("2qjVA", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => $28564ebdedb53752$export$14afe2784a94db4d);
parcelRequire("71T39");
var $8WXPf = parcelRequire("8WXPf");

var $9EsDH = parcelRequire("9EsDH");
const $28564ebdedb53752$export$13a9a218541141cd = ()=>{
    const initialModelState = (0, $9EsDH.default)();
    return {
        loginAnnouncementsResponse: initialModelState !== null && initialModelState !== void 0 && initialModelState.loginAnnouncements ? initialModelState.loginAnnouncements : {
            defaultLocale: '',
            translatedLoginAnnouncements: {}
        },
        isLoading: false,
        isSaveInProgress: false,
        isSaveFailed: false
    };
};
const $28564ebdedb53752$var$doesContainLocaleDisplayName = (translatedLoginAnnouncement)=>{
    return 'localeDisplayName' in translatedLoginAnnouncement && !!translatedLoginAnnouncement.localeDisplayName;
};
const $28564ebdedb53752$export$49d5fc8cba920a0 = $28564ebdedb53752$export$13a9a218541141cd();
const $28564ebdedb53752$export$a85783f8b89d3dc8 = (payload, state)=>{
    return Object.keys(payload).reduce((acc, languageKey)=>{
        var _state$loginAnnouncem;
        const payloadForLanguageKey = payload[languageKey];
        return {
            ...acc,
            [languageKey]: {
                header: payloadForLanguageKey.header,
                message: payloadForLanguageKey.message,
                localeDisplayName: $28564ebdedb53752$var$doesContainLocaleDisplayName(payloadForLanguageKey) ? payloadForLanguageKey.localeDisplayName : (_state$loginAnnouncem = state.loginAnnouncementsResponse.translatedLoginAnnouncements[languageKey]) === null || _state$loginAnnouncem === void 0 ? void 0 : _state$loginAnnouncem.localeDisplayName
            }
        };
    }, {});
};
function $28564ebdedb53752$export$14afe2784a94db4d(state = $28564ebdedb53752$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $8WXPf.FETCH_LOGIN_ANNOUNCEMENTS:
            return $28564ebdedb53752$var$handleFetchLoginAnnouncements(state, true);
        case 0, $8WXPf.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS:
            return $28564ebdedb53752$var$handleFetchLoginAnnouncementsSuccess(state, action.payload, false);
        case 0, $8WXPf.FETCH_LOGIN_ANNOUNCEMENTS_FAILURE:
            return $28564ebdedb53752$var$handleFetchLoginAnnouncements(state, false);
        case 0, $8WXPf.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL:
            {
                const newState = {
                    ...state,
                    loginAnnouncementsResponse: {
                        ...state.loginAnnouncementsResponse,
                        translatedLoginAnnouncements: $28564ebdedb53752$export$a85783f8b89d3dc8(action.payload.translatedLogInAnnouncements, state)
                    },
                    isSaveInProgress: true,
                    isSaveFailed: false
                };
                return newState;
            }
        case 0, $8WXPf.UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE:
            return {
                ...state,
                isSaveFailed: true
            };
        case 0, $8WXPf.UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE:
            return {
                ...state,
                loginAnnouncementsResponse: {
                    ...state.loginAnnouncementsResponse,
                    translatedLoginAnnouncements: $28564ebdedb53752$export$a85783f8b89d3dc8(action.payload.translatedLogInAnnouncements, state)
                }
            };
        case 0, $8WXPf.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS:
        case 0, $8WXPf.RESET_LOGIN_ANNOUNCEMENTS:
        default:
            return {
                ...state,
                isSaveInProgress: false
            };
    }
}
const $28564ebdedb53752$var$handleFetchLoginAnnouncementsSuccess = (state, payload, isLoading)=>({
        ...state,
        isLoading: isLoading,
        loginAnnouncementsResponse: {
            ...state.loginAnnouncementsResponse,
            defaultLocale: payload.defaultLocale,
            translatedLoginAnnouncements: $28564ebdedb53752$export$a85783f8b89d3dc8(payload.translatedLoginAnnouncements, state)
        },
        isSaveFailed: false
    });
const $28564ebdedb53752$var$handleFetchLoginAnnouncements = (state, isLoading)=>({
        ...state,
        isLoading: isLoading,
        isSaveFailed: false
    });

});


parcelRegister("fRjqJ", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => (parcelRequire("9UuOw")).portalReducer);

var $9UuOw = parcelRequire("9UuOw");

});
parcelRegister("9UuOw", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => $a8ed281bb0e7813e$export$7b4acfe1c1a43b7c);

var $1We2B = parcelRequire("1We2B");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");

var $9EsDH = parcelRequire("9EsDH");
const $a8ed281bb0e7813e$export$db2e6bec0a5d318f = ()=>{
    var _initialModelState$po, _initialModelState$po2;
    const initialModelState = (0, $9EsDH.default)();
    return {
        portalAnnouncementsResponse: initialModelState !== null && initialModelState !== void 0 && (_initialModelState$po = initialModelState.portal) !== null && _initialModelState$po !== void 0 && _initialModelState$po.portalAnnouncement ? initialModelState === null || initialModelState === void 0 || (_initialModelState$po2 = initialModelState.portal) === null || _initialModelState$po2 === void 0 ? void 0 : _initialModelState$po2.portalAnnouncement : {
            canAdministerProject: false,
            canEditAnnouncement: false,
            defaultLanguageDisplayName: '',
            defaultLanguageHeader: '',
            defaultLanguageMessage: '',
            isUsingLanguageSupport: false,
            portalId: 0,
            portalProjectKey: '',
            userLanguageHeader: '',
            userLanguageMessageWiki: '',
            translations: {}
        },
        isLoading: false,
        isSaveInProgress: false,
        isSaveFailed: false
    };
};
const $a8ed281bb0e7813e$var$doesContainLocaleDisplayName = (translatedPortalAnnouncement)=>'localeDisplayName' in translatedPortalAnnouncement && !!translatedPortalAnnouncement.localeDisplayName;
const $a8ed281bb0e7813e$export$49d5fc8cba920a0 = $a8ed281bb0e7813e$export$db2e6bec0a5d318f();
const $a8ed281bb0e7813e$export$76e9a6f613765d59 = (payload, state)=>{
    if (payload && !(0, $1We2B.isEmpty)(payload)) return Object.keys(payload).reduce((acc, languageKey)=>{
        var _state$portalAnnounce;
        const payloadForLanguageKey = payload[languageKey];
        return {
            ...acc,
            [languageKey]: {
                header: payloadForLanguageKey.header,
                message: payloadForLanguageKey.message,
                localeDisplayName: $a8ed281bb0e7813e$var$doesContainLocaleDisplayName(payloadForLanguageKey) ? payloadForLanguageKey.localeDisplayName : (_state$portalAnnounce = state.portalAnnouncementsResponse.translations) === null || _state$portalAnnounce === void 0 || (_state$portalAnnounce = _state$portalAnnounce[languageKey]) === null || _state$portalAnnounce === void 0 ? void 0 : _state$portalAnnounce.localeDisplayName
            }
        };
    }, {});
    return {};
};
const $a8ed281bb0e7813e$var$handleFetchPortalSuccess = (state, payload, isLoading)=>({
        ...state,
        isLoading: isLoading,
        portalAnnouncementsResponse: {
            ...payload,
            defaultLanguageDisplayName: payload.defaultLanguageDisplayName,
            translations: $a8ed281bb0e7813e$export$76e9a6f613765d59(payload.translations, state)
        },
        isSaveFailed: false
    });
const $a8ed281bb0e7813e$var$handleFetchPortal = (state, isLoading)=>({
        ...state,
        isLoading: isLoading,
        isSaveFailed: false
    });
function $a8ed281bb0e7813e$export$7b4acfe1c1a43b7c(state = $a8ed281bb0e7813e$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $d727K.FETCH_PORTAL_MODEL:
            return $a8ed281bb0e7813e$var$handleFetchPortal(state, true);
        case 0, $d727K.FETCH_PORTAL_SUCCESS:
            return $a8ed281bb0e7813e$var$handleFetchPortalSuccess(state, action.payload.portalAnnouncement, false);
        case 0, $d727K.FETCH_PORTAL_FAILURE:
            return $a8ed281bb0e7813e$var$handleFetchPortal(state, false);
        case 0, $d727K.UPDATE_PORTAL_ANNOUNCEMENT_MODEL:
            {
                const newState = {
                    ...state,
                    portalAnnouncementsResponse: {
                        ...state.portalAnnouncementsResponse,
                        translations: $a8ed281bb0e7813e$export$76e9a6f613765d59(action.payload.translations, state)
                    },
                    isSaveInProgress: true,
                    isSaveFailed: false
                };
                return newState;
            }
        case 0, $d727K.UPDATE_PORTAL_ANNOUNCEMENT_FAILURE:
            return {
                ...state,
                isSaveFailed: true
            };
        case 0, $d727K.UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE:
            return {
                ...state,
                portalAnnouncementsResponse: {
                    ...state.portalAnnouncementsResponse,
                    ...action.payload,
                    translations: $a8ed281bb0e7813e$export$76e9a6f613765d59(action.payload.translations, state)
                }
            };
        case 0, $d727K.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS:
        default:
            return {
                ...state,
                isSaveInProgress: false
            };
    }
}

});


parcelRegister("fP3qW", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => (parcelRequire("1ztyh")).default);
$parcel$export(module.exports, "PLACEHOLDER_REQUEST_GROUP_ID", () => (parcelRequire("1ztyh")).PLACEHOLDER_REQUEST_GROUP_ID);

var $1ztyh = parcelRequire("1ztyh");

});
parcelRegister("1ztyh", function(module, exports) {
$parcel$export(module.exports, "PLACEHOLDER_REQUEST_GROUP_ID", () => $3710b778599474b6$export$1d5c0939993f01ba);
$parcel$export(module.exports, "default", () => $3710b778599474b6$export$2e2bcd8739ae039);
parcelRequire("b2kCx");
var $7I03W = parcelRequire("7I03W");
parcelRequire("9hqkU");
var $eT83r = parcelRequire("eT83r");
parcelRequire("d8JBM");
var $1EpSd = parcelRequire("1EpSd");
parcelRequire("5H5gW");
var $f5yEh = parcelRequire("f5yEh");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("by53g");
var $vgnrJ = parcelRequire("vgnrJ");
parcelRequire("3GnbM");
var $asEDQ = parcelRequire("asEDQ");
parcelRequire("4CT7s");
var $gQFbD = parcelRequire("gQFbD");
parcelRequire("jD4Sf");
var $736bb = parcelRequire("736bb");
parcelRequire("cNdJn");
var $5hxJj = parcelRequire("5hxJj");
const $3710b778599474b6$export$1d5c0939993f01ba = -1;
const $3710b778599474b6$var$getDefaultState = ()=>({
        requestGroups: undefined,
        requestGroupsOrder: undefined,
        requestTypesOrder: undefined,
        requestTypesInRequestGroup: undefined,
        requestTypesNotInRequestGroup: undefined,
        parentRequestGroups: undefined,
        error: undefined,
        groupNameThatCausedError: undefined,
        isParentRequestGroupsLoading: false
    });
function $3710b778599474b6$export$2e2bcd8739ae039(state = $3710b778599474b6$var$getDefaultState(), action) {
    switch(action.type){
        case 0, $vgnrJ.UPDATE_REQUEST_GROUPS_ORDER:
            return {
                ...state,
                requestGroupsOrder: action.payload.order
            };
        case 0, $7I03W.ADD_REQUEST_GROUP:
            {
                const newGroup = {
                    name: action.payload.groupName,
                    id: $3710b778599474b6$export$1d5c0939993f01ba // We don't have an id yet because the request hasn't completed, we put in a fake number temporarily. the groups here will get cleared when the persisted model is fetched
                };
                return {
                    ...state,
                    requestGroups: [
                        ...action.payload.existingGroups,
                        newGroup
                    ],
                    error: undefined,
                    groupNameThatCausedError: undefined
                };
            }
        case 0, $7I03W.ADD_REQUEST_GROUP_FAILED:
            return {
                ...state,
                requestGroups: undefined,
                error: action.payload.message,
                groupNameThatCausedError: action.payload.groupNameThatCausedError
            };
        case 0, $1EpSd.CREATE_GROUP_WITH_REQUEST_TYPE:
            return {
                ...state,
                isParentRequestGroupsLoading: true
            };
        case 0, $1EpSd.CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED:
            return {
                ...state,
                isParentRequestGroupsLoading: false
            };
        case 0, $1EpSd.CREATE_GROUP_WITH_REQUEST_TYPE_FAILED:
            return {
                ...state,
                isParentRequestGroupsLoading: false
            };
        case 0, $f5yEh.DELETE_REQUEST_TYPE_FROM_GROUP:
            {
                const { requestTypes: requestTypes, index: index } = action.payload;
                const requestTypeIds = requestTypes.map(({ id: requestTypeId })=>Number(requestTypeId));
                const udpatedRequestTypeIds = (0, $5hxJj.deleteFromList)(requestTypeIds, index);
                return {
                    ...state,
                    requestTypesInRequestGroup: undefined,
                    requestTypesNotInRequestGroup: undefined,
                    requestTypesOrder: udpatedRequestTypeIds
                };
            }
        case 0, $736bb.SET_REQUEST_TYPE_GROUPS:
            {
                const { requestGroups: requestGroups } = action.payload;
                return {
                    ...state,
                    parentRequestGroups: requestGroups
                };
            }
        case 0, $736bb.SET_REQUEST_TYPE_GROUPS_FAILED:
            return {
                ...state,
                parentRequestGroups: undefined
            };
        case 0, $asEDQ.REORDER_REQUEST_TYPE:
            {
                const { requestTypes: requestTypes, fromIndex: fromIndex, toIndex: toIndex } = action.payload;
                const requestTypeIds = requestTypes.map(({ id: requestTypeId })=>Number(requestTypeId));
                const updatedRequestTypeIds = (0, $5hxJj.reorderList)(requestTypeIds, fromIndex, toIndex);
                return {
                    ...state,
                    requestTypesOrder: updatedRequestTypeIds
                };
            }
        case 0, $d727K.FETCH_PORTAL_SUCCESS:
            return $3710b778599474b6$var$getDefaultState();
        case 0, $eT83r.ADD_REQUEST_TYPE_TO_REQUEST_GROUP:
            {
                const { requestType: requestType, requestTypesNotInRequestGroup: requestTypesNotInRequestGroup, requestTypesInRequestGroup: requestTypesInRequestGroup } = action.payload;
                // Remove request type from requestTypesNotInRequestGroup used for request type search options
                const optimisticRequestTypesNotInRequestGroup = requestTypesNotInRequestGroup.filter((requestTypeNotInRequestGroup)=>requestTypeNotInRequestGroup.id !== requestType.id);
                // Add request type as the last element of requestTypesInRequestGroup used to render request types in group
                const optimisticRequestTypesInRequestGroup = [
                    ...requestTypesInRequestGroup,
                    requestType
                ];
                // This will have the new request type as the last index (the order will then be persisted)
                const requestTypeIds = optimisticRequestTypesInRequestGroup.map(({ id: requestTypeId })=>Number(requestTypeId));
                return {
                    ...state,
                    requestTypesOrder: requestTypeIds,
                    requestTypesInRequestGroup: [
                        ...optimisticRequestTypesInRequestGroup
                    ],
                    requestTypesNotInRequestGroup: [
                        ...optimisticRequestTypesNotInRequestGroup
                    ],
                    error: undefined
                };
            }
        case 0, $eT83r.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED:
            return {
                ...state,
                requestTypesOrder: undefined,
                requestTypesInRequestGroup: undefined,
                requestTypesNotInRequestGroup: undefined,
                error: action.payload.message
            };
        case 0, $vgnrJ.CLEAR_REQUEST_TYPES_ORDER:
            return {
                ...state,
                requestGroups: undefined,
                requestTypesInRequestGroup: undefined,
                requestTypesNotInRequestGroup: undefined,
                error: undefined,
                requestTypesOrder: undefined
            };
        case 0, $vgnrJ.CLEAR_ERROR_MESSAGE:
            return {
                ...state,
                error: undefined,
                groupNameThatCausedError: undefined,
                requestTypesOrder: undefined
            };
        // Reset any errors and clear the UI state version of request groups so it can be populated with the newly persisted list as the new source of truth
        case 0, $vgnrJ.CLEAR_REQUEST_GROUPS_ORDER:
            return $3710b778599474b6$var$getDefaultState();
        // On successful edit clear UI state order, and use the newly persisted request groups state as the source of truth for the request groups list.
        case 0, $gQFbD.GET_ALL_REQUEST_GROUPS_SUCCESS:
            {
                const { requestGroups: requestGroups } = action.payload;
                return {
                    ...state,
                    requestGroups: requestGroups,
                    requestGroupsOrder: undefined
                };
            }
        default:
            return state;
    }
}

});
parcelRegister("cNdJn", function(module, exports) {
$parcel$export(module.exports, "deleteFromList", () => (parcelRequire("5hxJj")).deleteFromList);
$parcel$export(module.exports, "reorderList", () => (parcelRequire("5hxJj")).reorderList);
parcelRequire("5hxJj");

});
parcelRegister("5hxJj", function(module, exports) {
$parcel$export(module.exports, "reorderList", () => $1fbf2460d1307c6f$export$1c97eb4883130bfd);
$parcel$export(module.exports, "deleteFromList", () => $1fbf2460d1307c6f$export$e786ade68cfa1610);
/** Utility functions to assist managing drop events in React Beautiful DnD */ 
var $1We2B = parcelRequire("1We2B");
const $1fbf2460d1307c6f$export$1c97eb4883130bfd = (list, fromIndex, toIndex)=>{
    const newList = Array.from(list);
    if (!(0, $1We2B.isNil)(toIndex) && !(0, $1We2B.isNil)(fromIndex)) {
        newList.splice(fromIndex, 1);
        newList.splice(toIndex, 0, list[fromIndex]);
    }
    return newList;
};
const $1fbf2460d1307c6f$export$e786ade68cfa1610 = (list, index)=>{
    const newList = Array.from(list);
    if (!(0, $1We2B.isNil)(index)) newList.splice(index, 1);
    return newList;
};

});




parcelRegister("fAAX8", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => (parcelRequire("7Ukwy")).requestDetailsReducer);
$parcel$export(module.exports, "ApprovalDecision", () => (parcelRequire("7Ukwy")).ApprovalDecision);

var $7Ukwy = parcelRequire("7Ukwy");

});
parcelRegister("7Ukwy", function(module, exports) {
$parcel$export(module.exports, "ApprovalDecision", () => $819ac5759453f910$export$b84e6e5b33fd1d21);
$parcel$export(module.exports, "requestDetailsReducer", () => $819ac5759453f910$export$dfa3e5ac1f5274b8);
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");
var $819ac5759453f910$export$b84e6e5b33fd1d21 = /*#__PURE__*/ function(ApprovalDecision) {
    ApprovalDecision[ApprovalDecision["APPROVE"] = 0] = "APPROVE";
    ApprovalDecision[ApprovalDecision["DECLINE"] = 1] = "DECLINE";
    return ApprovalDecision;
}({});
const $819ac5759453f910$var$defaultState = {
    commentSubmitting: false,
    commentBeingSubmitted: undefined
};
function $819ac5759453f910$export$dfa3e5ac1f5274b8(state = $819ac5759453f910$var$defaultState, action) {
    switch(action.type){
        case 0, $jra4c.TRANSITION_REQUEST:
            return $819ac5759453f910$var$handleTransition(state, action);
        case 0, $jra4c.TRANSITION_REQUEST_FAILURE:
            return $819ac5759453f910$var$handleTransitionFailure(state, action);
        case 0, $jra4c.CLEAR_TRANSITION_REQUEST_FAILURE:
            return $819ac5759453f910$var$handleClearTransitionFailure(state);
        case 0, $jra4c.FETCH_REQUEST_DETAILS_SUCCESS:
            return $819ac5759453f910$var$defaultState;
        case 0, $jra4c.CREATE_COMMENT:
            return $819ac5759453f910$var$handleCommentCreate(state, action);
        case 0, $jra4c.CREATE_COMMENT_SUCCESS:
            return $819ac5759453f910$var$handleCommentCreateSuccess(state);
        case 0, $jra4c.CREATE_COMMENT_FAILURE:
            return $819ac5759453f910$var$handleCommentCreateFailure(state);
        case 0, $jra4c.SHOW_TRANSITION_DIALOG:
            return $819ac5759453f910$var$handleShowTransitionDialog(state, action);
        case 0, $jra4c.HIDE_TRANSITION_DIALOG:
            return $819ac5759453f910$var$handleHideTransitionDialog(state);
        case 0, $jra4c.DECIDE_APPROVAL:
            return $819ac5759453f910$var$handleDecideApproval(state, action);
        case 0, $jra4c.DECIDE_APPROVAL_FAILURE:
            return $819ac5759453f910$var$handleDecideApprovalFailure(state);
        default:
            return state;
    }
}
const $819ac5759453f910$var$handleShowTransitionDialog = (state, action)=>({
        ...state,
        visibleTransitionDialog: action.payload.id
    });
const $819ac5759453f910$var$handleHideTransitionDialog = (state)=>({
        ...state,
        visibleTransitionDialog: undefined
    });
const $819ac5759453f910$var$handleTransition = (state, action)=>({
        ...state,
        inProgressTransitionId: action.payload.transitionId,
        transitionFailure: undefined
    });
function $819ac5759453f910$var$handleDecideApproval(state, action) {
    const approvalDecision = action.payload.approve ? 0 : 1;
    return {
        ...state,
        inProgressApprovalAction: approvalDecision
    };
}
const $819ac5759453f910$var$handleDecideApprovalFailure = (state)=>({
        ...state,
        inProgressApprovalAction: undefined
    });
const $819ac5759453f910$var$handleTransitionFailure = (state, action)=>({
        ...state,
        inProgressTransitionId: undefined,
        transitionFailure: action.payload.error
    });
const $819ac5759453f910$var$handleClearTransitionFailure = (state)=>({
        ...state,
        transitionFailure: undefined
    });
const $819ac5759453f910$var$handleCommentCreate = (state, action)=>({
        ...state,
        commentSubmitting: true,
        commentBeingSubmitted: action.payload.comment
    });
const $819ac5759453f910$var$handleCommentCreateSuccess = (state)=>({
        ...state,
        commentSubmitting: false,
        commentBeingSubmitted: undefined
    });
const $819ac5759453f910$var$handleCommentCreateFailure = (state)=>({
        ...state,
        commentSubmitting: false
    });

});


parcelRegister("8cjQg", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => (parcelRequire("hsbBM")).requestListReducer);

var $hsbBM = parcelRequire("hsbBM");

});
parcelRegister("hsbBM", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => $d1377a18d1e2dbf2$export$476a1a148617ffd3);
parcelRequire("2NENO");
var $leQln = parcelRequire("leQln");
const $d1377a18d1e2dbf2$var$defaultState = {
    isLoading: false
};
function $d1377a18d1e2dbf2$export$476a1a148617ffd3(state = $d1377a18d1e2dbf2$var$defaultState, action) {
    switch(action.type){
        case 0, $leQln.FETCH_REQUEST_LIST_MODEL:
            return $d1377a18d1e2dbf2$var$handleFetchRequestListAction(state);
        case 0, $leQln.FETCH_REQUEST_LIST_SUCCESS:
            return $d1377a18d1e2dbf2$var$handleFetchRequestListSuccess(state);
        case 0, $leQln.FETCH_REQUEST_LIST_FAILURE:
            return $d1377a18d1e2dbf2$var$handleFetchRequestListFailure(state);
        default:
            return state;
    }
}
const $d1377a18d1e2dbf2$var$handleFetchRequestListAction = (state)=>({
        ...state,
        isLoading: true
    });
const $d1377a18d1e2dbf2$var$handleFetchRequestListSuccess = (state)=>({
        ...state,
        isLoading: false
    });
const $d1377a18d1e2dbf2$var$handleFetchRequestListFailure = (state)=>({
        ...state,
        isLoading: false
    });

});


parcelRegister("1Sm44", function(module, exports) {
$parcel$export(module.exports, "resendVerifyReducer", () => (parcelRequire("0dYpU")).resendVerifyReducer);

var $0dYpU = parcelRequire("0dYpU");

});
parcelRegister("0dYpU", function(module, exports) {
$parcel$export(module.exports, "resendVerifyReducer", () => $e3a3cb6d796e9f4f$export$92942a05b04ae72);
parcelRequire("9gVYw");
var $ksbxD = parcelRequire("ksbxD");

var $cCe7P = parcelRequire("cCe7P");
const $e3a3cb6d796e9f4f$export$49d5fc8cba920a0 = {
    value: (0, $cCe7P.ResendStatus).NONE
};
function $e3a3cb6d796e9f4f$export$92942a05b04ae72(state = $e3a3cb6d796e9f4f$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $ksbxD.FETCH_RESEND_VERIFY_EMAIL:
            return {
                value: (0, $cCe7P.ResendStatus).RESENDING
            };
        case 0, $ksbxD.FETCH_RESEND_VERIFICATION_SUCCESS:
            return {
                value: (0, $cCe7P.ResendStatus).SUCCEEDED
            };
        case 0, $ksbxD.FETCH_RESEND_VERIFICATION_FAILURE:
            return {
                errorStatus: action.payload.error,
                value: (0, $cCe7P.ResendStatus).FAILED
            };
        default:
            return state;
    }
}

});
parcelRegister("cCe7P", function(module, exports) {
$parcel$export(module.exports, "ResendStatus", () => $b744ebf296937584$export$167f7de0a3de3f78);
const $b744ebf296937584$export$167f7de0a3de3f78 = {
    NONE: 'NONE',
    RESENDING: 'RESENDING',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED'
};

});



parcelRegister("1SPmw", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => (parcelRequire("5basB")).resetPasswordReducer);

var $5basB = parcelRequire("5basB");

});
parcelRegister("5basB", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => $b27c1f51f79d4144$export$b0c3be5071e95c02);
parcelRequire("4eQmN");
var $6v1bD = parcelRequire("6v1bD");
const $b27c1f51f79d4144$var$defaultState = {
    isSubmitting: false
};
function $b27c1f51f79d4144$export$b0c3be5071e95c02(state = $b27c1f51f79d4144$var$defaultState, action) {
    switch(action.type){
        case 0, $6v1bD.RESET_PASSWORD:
            return $b27c1f51f79d4144$var$handleResetPassword(state);
        case 0, $6v1bD.RESET_PASSWORD_FAILURE:
            return $b27c1f51f79d4144$var$handleResetPasswordFailure(state, action);
        default:
            return state;
    }
}
const $b27c1f51f79d4144$var$handleResetPassword = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined
    });
const $b27c1f51f79d4144$var$handleResetPasswordFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        error: action.payload.error
    });

});


parcelRegister("8DaBy", function(module, exports) {
$parcel$export(module.exports, "searchReducer", () => (parcelRequire("7dg4W")).default);

var $7dg4W = parcelRequire("7dg4W");

});
parcelRegister("7dg4W", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d70cf4cf6c21924$export$2e2bcd8739ae039);
parcelRequire("fzkqG");
var $6Tan6 = parcelRequire("6Tan6");

var $7FSs7 = parcelRequire("7FSs7");

var $2Np0t = parcelRequire("2Np0t");
const $1d70cf4cf6c21924$var$generateDefaultSearchResults = ()=>{
    return {
        portals: [],
        requestTypes: [],
        knowledgeBase: {
            articles: [],
            totalSize: 0
        }
    };
};
const $1d70cf4cf6c21924$var$generateDefaultState = ()=>{
    const strings = $2Np0t.getAll();
    if (strings && strings.q !== undefined) return {
        shown: true,
        term: strings.q,
        time: strings.q_time ? +strings.q_time : undefined,
        hasError: false,
        isSearching: true,
        results: $1d70cf4cf6c21924$var$generateDefaultSearchResults(),
        isSearchingPortals: true,
        isSearchingKb: true,
        isSearchingRequestTypes: true
    };
    return {
        shown: false,
        term: '',
        portalIds: [],
        time: undefined,
        hasError: false,
        isSearching: false,
        results: $1d70cf4cf6c21924$var$generateDefaultSearchResults()
    };
};
const $1d70cf4cf6c21924$var$portalResponseToState = (portal)=>({
        id: portal.id,
        name: portal.name,
        iconUrl: portal.logoUrl
    });
const $1d70cf4cf6c21924$var$requestTypesResponseToState = (requestType)=>({
        id: requestType.id,
        portalId: requestType.cvId,
        name: requestType.name,
        portalName: requestType.portalName,
        iconUrl: requestType.iconUrl || `${0, $7FSs7.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${requestType.icon}`,
        searchMetaData: requestType.searchMetaData
    });
function $1d70cf4cf6c21924$export$2e2bcd8739ae039(state = $1d70cf4cf6c21924$var$generateDefaultState(), action) {
    switch(action.type){
        case 0, $6Tan6.SHOW_SEARCH:
            return {
                ...state,
                shown: action.payload.show,
                searchStartTime: undefined
            };
        case 0, $6Tan6.RESET_SEARCH:
            return {
                shown: false,
                term: '',
                time: undefined,
                hasError: false,
                isSearching: false,
                results: $1d70cf4cf6c21924$var$generateDefaultSearchResults()
            };
        case 0, $6Tan6.SEARCH:
            return {
                ...state,
                ...action.payload,
                isSearching: true,
                shown: action.payload.show,
                time: action.payload.term ? action.payload.time : undefined,
                isSearchingPortals: true,
                isSearchingKb: true,
                isSearchingRequestTypes: true
            };
        case 0, $6Tan6.FETCH_KB_SEARCH_RESULTS:
            return {
                ...state,
                isSearchingKb: true
            };
        case 0, $6Tan6.UPDATE_SEARCH_RESULTS:
            {
                const result = action.payload;
                const newResultState = {
                    portals: result.portals ? result.portals.map($1d70cf4cf6c21924$var$portalResponseToState) : [],
                    requestTypes: result.requestTypes ? result.requestTypes.map($1d70cf4cf6c21924$var$requestTypesResponseToState) : [],
                    knowledgeBase: $1d70cf4cf6c21924$var$mapKnowledgeBaseResponseToState(result)
                };
                return {
                    ...state,
                    results: newResultState,
                    isSearching: false
                };
            }
        case 0, $6Tan6.UPDATE_SEARCH_RESULTS_BY_TYPE:
            {
                var _newResultState;
                const { searchType: searchType, payload: result } = action;
                let newResultState;
                if (searchType === 'portals') newResultState = {
                    results: {
                        ...state.results,
                        portals: result.portals ? result.portals.map($1d70cf4cf6c21924$var$portalResponseToState) : []
                    },
                    isSearchingPortals: false
                };
                if (searchType === 'requestTypes') newResultState = {
                    results: {
                        ...state.results,
                        requestTypes: result.requestTypes ? result.requestTypes.map($1d70cf4cf6c21924$var$requestTypesResponseToState) : []
                    },
                    isSearchingRequestTypes: false
                };
                if (searchType === 'kbs') newResultState = {
                    results: {
                        ...state.results,
                        knowledgeBase: $1d70cf4cf6c21924$var$mapKnowledgeBaseResponseToState(result)
                    },
                    isSearchingKb: false
                };
                return {
                    ...state,
                    ...newResultState ?? {},
                    isSearching: ((_newResultState = newResultState) === null || _newResultState === void 0 ? void 0 : _newResultState.isSearchingKb) === false ? false : state.isSearching
                };
            }
        case 0, $6Tan6.CLEAR_SEARCH_RESULTS:
            return {
                ...state,
                isSearching: false,
                results: $1d70cf4cf6c21924$var$generateDefaultSearchResults(),
                searchStartTime: undefined
            };
        case 0, $6Tan6.FETCH_SEARCH_RESULTS:
            return {
                ...state,
                searchStartTime: action.payload.searchStartTime
            };
        case 0, $6Tan6.UPDATE_SEARCH:
            return {
                ...state,
                ...action.payload,
                isSearching: true,
                shown: action.payload.show,
                time: action.payload.term ? action.payload.time : undefined
            };
        default:
            return state;
    }
}
const $1d70cf4cf6c21924$var$mapKnowledgeBaseResponseToState = (result)=>{
    return result.kbs ? result.kbs : {
        articles: [],
        totalSize: 0
    };
};

});


parcelRegister("hBqQG", function(module, exports) {
$parcel$export(module.exports, "checkEmailUiReducer", () => (parcelRequire("bX3kL")).checkEmailUiReducer);

var $bX3kL = parcelRequire("bX3kL");

});
parcelRegister("bX3kL", function(module, exports) {
$parcel$export(module.exports, "checkEmailUiReducer", () => $d8de8fb5ed31c722$export$a518ffb70e2a23c8);
parcelRequire("6aA8L");
var $jJMqu = parcelRequire("jJMqu");
const $d8de8fb5ed31c722$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    resendValidationLinkDisabled: false
};
function $d8de8fb5ed31c722$export$a518ffb70e2a23c8(state = $d8de8fb5ed31c722$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $jJMqu.ENABLE_RESEND_VALIDATION_EMAIL_LINK:
            return $d8de8fb5ed31c722$var$handleEnableResendValidationLink(state);
        case 0, $jJMqu.RESEND_VALIDATION_EMAIL:
            return $d8de8fb5ed31c722$var$handleResendValidationEmail(state);
        case 0, $jJMqu.RESEND_VALIDATION_EMAIL_SUCCESS:
            return $d8de8fb5ed31c722$var$handleResendValidationEmailSuccess(state);
        case 0, $jJMqu.RESEND_VALIDATION_EMAIL_FAILURE:
            return $d8de8fb5ed31c722$var$handleResendValidationEmailFailure(state);
        default:
            return state;
    }
}
const $d8de8fb5ed31c722$var$handleEnableResendValidationLink = (state)=>({
        ...state,
        resendValidationLinkDisabled: false
    });
const $d8de8fb5ed31c722$var$handleResendValidationEmail = (state)=>({
        ...state,
        isSubmitting: true,
        resendValidationLinkDisabled: true
    });
const $d8de8fb5ed31c722$var$handleResendValidationEmailSuccess = (state)=>({
        ...state,
        isSubmitting: false
    });
const $d8de8fb5ed31c722$var$handleResendValidationEmailFailure = (state)=>({
        ...state,
        isSubmitting: false
    });

});


parcelRegister("7pfUH", function(module, exports) {
$parcel$export(module.exports, "topicsReducer", () => (parcelRequire("kZChL")).default);

var $kZChL = parcelRequire("kZChL");

});
parcelRegister("kZChL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0fab88c75fc01ef$export$2e2bcd8739ae039);
parcelRequire("8Zt4P");
var $7TIXF = parcelRequire("7TIXF");
const $a0fab88c75fc01ef$export$b81eca7e0c669bb0 = {
    fetchKey: 0
};
function $a0fab88c75fc01ef$export$2e2bcd8739ae039(state = $a0fab88c75fc01ef$export$b81eca7e0c669bb0, action) {
    if (action.type === (0, $7TIXF.UPDATE_TOPICS_FETCH_KEY)) return {
        ...state,
        fetchKey: state.fetchKey + 1
    };
    return state;
}

});
parcelRegister("8Zt4P", function(module, exports) {
$parcel$export(module.exports, "UPDATE_TOPICS_FETCH_KEY", () => (parcelRequire("7TIXF")).UPDATE_TOPICS_FETCH_KEY);

var $7TIXF = parcelRequire("7TIXF");

});
parcelRegister("7TIXF", function(module, exports) {
$parcel$export(module.exports, "UPDATE_TOPICS_FETCH_KEY", () => $5537d743bb95f762$export$9b3f2f1c719b0f8e);
const $5537d743bb95f762$export$9b3f2f1c719b0f8e = 'state.ui.topics.UPDATE_TOPICS_FETCH_KEY';
const $5537d743bb95f762$export$ff571764686d6022 = ()=>({
        type: $5537d743bb95f762$export$9b3f2f1c719b0f8e
    });

});




parcelRegister("gGcDT", function(module, exports) {
$parcel$export(module.exports, "userProfileReducer", () => (parcelRequire("2m4TN")).userProfileReducer);

var $2m4TN = parcelRequire("2m4TN");

});
parcelRegister("2m4TN", function(module, exports) {
$parcel$export(module.exports, "userProfileReducer", () => $60c6edadc892e09d$export$6a0a871f19e6c5f6);
parcelRequire("6Fjys");
var $8ICBx = parcelRequire("8ICBx");
const $60c6edadc892e09d$var$defaultState = {
    saveInProgress: false,
    changePasswordInProgress: false,
    showChangePasswordDialog: false,
    changePasswordErrors: {},
    saveUserProfileErrors: {},
    sendForgotPasswordEmailInProgress: false
};
function $60c6edadc892e09d$export$6a0a871f19e6c5f6(state = $60c6edadc892e09d$var$defaultState, action) {
    switch(action.type){
        case 0, $8ICBx.SAVE_USER_PROFILE:
            return $60c6edadc892e09d$var$handleSaveUserProfile(state);
        case 0, $8ICBx.SAVE_USER_PROFILE_FAILURE:
            return $60c6edadc892e09d$var$handleSaveUserProfileFailure(state);
        case 0, $8ICBx.SET_USER_PROFILE_VALIDATION_ERRORS:
            return $60c6edadc892e09d$var$handleSetUserProfileValidationErrors(state, action);
        case 0, $8ICBx.SAVE_USER_PROFILE_SUCCESS:
            return $60c6edadc892e09d$var$handleSaveUserProfileSuccess(state);
        case 0, $8ICBx.SHOW_CHANGE_PASSWORD_DIALOG:
            return $60c6edadc892e09d$var$handleShowChangePasswordDialog(state);
        case 0, $8ICBx.CLOSE_CHANGE_PASSWORD_DIALOG:
            return $60c6edadc892e09d$var$handleCloseChangePasswordDialog(state);
        case 0, $8ICBx.CHANGE_PASSWORD:
            return $60c6edadc892e09d$var$handleChangePassword(state);
        case 0, $8ICBx.CHANGE_PASSWORD_SUCCESS:
            return $60c6edadc892e09d$var$handleChangePasswordSuccess(state);
        case 0, $8ICBx.CHANGE_PASSWORD_FAILURE:
            return $60c6edadc892e09d$var$handleChangePasswordFailure(state, action);
        case 0, $8ICBx.VALIDATE_PASSWORD_SUCCESS:
            return $60c6edadc892e09d$var$handleValidatePasswordSuccess(state);
        case 0, $8ICBx.USER_PROFILE_FORGOT_PASSWORD:
            return $60c6edadc892e09d$var$handleForgotPassword(state);
        case 0, $8ICBx.USER_PROFILE_FORGOT_PASSWORD_FAILURE:
            return $60c6edadc892e09d$var$handleForgotPasswordFailure(state);
        case 0, $8ICBx.USER_PROFILE_FORGOT_PASSWORD_SUCCESS:
            return $60c6edadc892e09d$var$handleForgotPasswordSuccess(state);
        default:
            return state;
    }
}
const $60c6edadc892e09d$var$handleSaveUserProfile = (state)=>({
        ...state,
        saveInProgress: true
    });
const $60c6edadc892e09d$var$handleSaveUserProfileFailure = (state)=>({
        ...state,
        saveInProgress: false
    });
function $60c6edadc892e09d$var$handleSetUserProfileValidationErrors(state, action) {
    const { nameError: nameError, timezoneError: timezoneError } = action.payload;
    return {
        ...state,
        saveUserProfileErrors: {
            nameError: nameError,
            timezoneError: timezoneError
        }
    };
}
const $60c6edadc892e09d$var$handleSaveUserProfileSuccess = (state)=>({
        ...state,
        saveInProgress: false
    });
const $60c6edadc892e09d$var$handleShowChangePasswordDialog = (state)=>({
        ...state,
        showChangePasswordDialog: true
    });
const $60c6edadc892e09d$var$handleCloseChangePasswordDialog = (state)=>({
        ...state,
        showChangePasswordDialog: false,
        changePasswordErrors: {}
    });
const $60c6edadc892e09d$var$handleValidatePasswordSuccess = (state)=>({
        ...state,
        changePasswordErrors: {}
    });
const $60c6edadc892e09d$var$handleChangePassword = (state)=>({
        ...state,
        changePasswordInProgress: true,
        changePasswordErrors: {}
    });
const $60c6edadc892e09d$var$handleChangePasswordSuccess = (state)=>({
        ...state,
        showChangePasswordDialog: false,
        changePasswordInProgress: false,
        changePasswordErrors: {}
    });
const $60c6edadc892e09d$var$handleChangePasswordFailure = (state, action)=>({
        ...state,
        changePasswordInProgress: false,
        changePasswordErrors: {
            currentPasswordError: action.payload.currentPasswordError,
            newPasswordError: action.payload.newPasswordError,
            confirmPasswordError: action.payload.confirmPasswordError,
            generalError: action.payload.generalError
        }
    });
const $60c6edadc892e09d$var$handleForgotPassword = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: true,
        showChangePasswordDialog: true
    });
const $60c6edadc892e09d$var$handleForgotPasswordFailure = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: false,
        showChangePasswordDialog: true
    });
const $60c6edadc892e09d$var$handleForgotPasswordSuccess = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: false,
        showChangePasswordDialog: false
    });

});





parcelRegister("4GTRJ", function(module, exports) {
$parcel$export(module.exports, "HelpSeekerTypeProvider", () => $afae5eb9e00203e2$export$e70650df369196ac);

var $8P7DW = parcelRequire("8P7DW");

var $9RecE = parcelRequire("9RecE");

var $986n2 = parcelRequire("986n2");

var $1EFS8 = parcelRequire("1EFS8");

var $iziiq = parcelRequire("iziiq");
const $afae5eb9e00203e2$export$e70650df369196ac = ({ children: children })=>{
    const [helpSeekerTypeAttributes, setHelpSeekerTypeAttributes] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState({
        isUserDomainSameAsAdmin: (0, $9RecE.helpSeekerTypeAttributeValue).UNIDENTIFIED,
        isUserDomainInApprovedDomains: (0, $9RecE.helpSeekerTypeAttributeValue).UNIDENTIFIED
    });
    const config = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext((0, $986n2.AtlassianHelpConfigContext));
    const constructHelpSeekerTypeResponse = (isUserDomainSameAsAdmin, isUserDomainInApprovedDomains, isUserLoggedIn)=>({
            isUserDomainSameAsAdmin: isUserDomainSameAsAdmin,
            isUserDomainInApprovedDomains: isUserDomainInApprovedDomains,
            isUserLoggedIn: isUserLoggedIn
        });
    const evaluateHelpSeekerTypeAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback(()=>{
        if (config.accountType === 'customer') (0, $9RecE.getHelpSeekerTypeAttributes)().subscribe((response)=>{
            if ((0, $1EFS8.default).checkGate('csm-support-site-account-type-metric')) setHelpSeekerTypeAttributes({
                ...response,
                isUserLoggedIn: true
            });
            else setHelpSeekerTypeAttributes(response);
        });
        else if (config.accountType === 'atlassian') {
            if ((0, $1EFS8.default).checkGate('csm-support-site-account-type-metric')) setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $9RecE.helpSeekerTypeAttributeValue).YES, (0, $9RecE.helpSeekerTypeAttributeValue).YES, true));
            else setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $9RecE.helpSeekerTypeAttributeValue).YES, (0, $9RecE.helpSeekerTypeAttributeValue).YES));
        } else if ((0, $1EFS8.default).checkGate('csm-support-site-account-type-metric')) setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $9RecE.helpSeekerTypeAttributeValue).NO, (0, $9RecE.helpSeekerTypeAttributeValue).NO, false));
        else setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $9RecE.helpSeekerTypeAttributeValue).NO, (0, $9RecE.helpSeekerTypeAttributeValue).NO));
    }, [
        config
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        evaluateHelpSeekerTypeAttributes();
    }, [
        evaluateHelpSeekerTypeAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iziiq.AnalyticsContext), {
        attributes: helpSeekerTypeAttributes
    }, children);
};

});
parcelRegister("9RecE", function(module, exports) {
$parcel$export(module.exports, "helpSeekerTypeAttributeValue", () => $df5664c06a5a043b$export$5f93b09705cc6a59);
$parcel$export(module.exports, "getHelpSeekerTypeAttributes", () => $df5664c06a5a043b$export$ea5de7279b843e51);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $7FSs7 = parcelRequire("7FSs7");

var $hmGtR = parcelRequire("hmGtR");
const $df5664c06a5a043b$export$5f93b09705cc6a59 = Object.freeze({
    YES: 'Yes',
    NO: 'No',
    UNIDENTIFIED: 'Unidentified'
});
const $df5664c06a5a043b$export$ea5de7279b843e51 = (basePath = (0, $7FSs7.contextPath))=>{
    const uri = `${basePath}/rest/servicedesk/1/customer/analytics/help-seeker/type`;
    const localStorageHelpSeekerTypeResponse = (0, $hmGtR.getLocalStorageItem)('help-seeker-type');
    if (localStorageHelpSeekerTypeResponse) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $fSYYZ.Observable).of(JSON.parse(localStorageHelpSeekerTypeResponse));
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        (0, $hmGtR.setLocalStorageItem)('help-seeker-type', JSON.stringify(response));
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return response;
    }).catch(()=>{
        return (0, $fSYYZ.Observable).of({
            isUserDomainSameAsAdmin: $df5664c06a5a043b$export$5f93b09705cc6a59.UNIDENTIFIED,
            isUserDomainInApprovedDomains: $df5664c06a5a043b$export$5f93b09705cc6a59.UNIDENTIFIED
        });
    });
};

});

parcelRegister("986n2", function(module, exports) {
$parcel$export(module.exports, "AtlassianHelpConfigContext", () => $309c354f50c86040$export$15b13d6286254aba);
$parcel$export(module.exports, "default", () => $309c354f50c86040$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");
const $309c354f50c86040$export$eec32b9030a890bc = (config)=>({
        accountId: config.accountId,
        accountType: config.accountType,
        userLocale: config.userLocale,
        sdPluginVersion: config.sdPluginVersion || '',
        contextPath: config.contextPath,
        environment: config.environment,
        tenantId: config.tenantId,
        activationId: config.activationId,
        helpCenterARI: config.helpCenterARI
    });
const $309c354f50c86040$export$b5f4a66c86673938 = (config)=>({
        environment: config.environment,
        featureFlags: config.featureFlags || {},
        wacLink: config.wacLink,
        contactLink: config.contactLink,
        headless: config.headless || false,
        serviceDeskVersion: config.serviceDeskVersion || '',
        contextPath: config.contextPath,
        xsrfToken: config.xsrfToken || '',
        baseUrl: config.baseUrl,
        relativeBaseUrl: config.relativeBaseUrl,
        anonymousEnabled: config.anonymousEnabled || false,
        requestIntroEnabled: config.requestIntroEnabled || false,
        mediaApiExternalUrl: config.mediaApiExternalUrl || '',
        mediaApiAppClientId: config.mediaApiAppClientId || '',
        fabricEmojiUrl: config.fabricEmojiUrl || '',
        jiraDisplayUrl: config.jiraDisplayUrl,
        featuredValues: config.featuredValues || {},
        siteDefaultLanguageTag: config.siteDefaultLanguageTag || 'en-US',
        helpCenterType: config.helpCenterType || (0, $8rTkC.DEFAULT_HELP_CENTER_TYPE),
        hoistedProjectKey: config.hoistedProjectKey || undefined,
        helpCenterHomePageSlug: config.helpCenterHomePageSlug || '',
        customerAccountAvailabilty: config.customerAccountAvailabilty || (0, $8rTkC.DEFAULT_CUSTOMER_ACCOUNT_AVAILABILITY)
    });
const $309c354f50c86040$export$15b13d6286254aba = /*#__PURE__*/ $8P7DW.createContext({});
// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
// oxlint-disable-next-line no-shadow
const $309c354f50c86040$var$MetaDataProvider = ({ children: children, config: config, updateEnvAction: updateEnvAction, updateMetaAction: updateMetaAction })=>{
    // We can add React context here in the future once relay is introduced and get rid of reducers altogether
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // oxlint-disable-next-line no-shadow
    const Env = $309c354f50c86040$export$b5f4a66c86673938(config);
    const Meta = $309c354f50c86040$export$eec32b9030a890bc(config);
    $8P7DW.useMemo(()=>{
        updateMetaAction(Meta);
        updateEnvAction(Env);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        Env,
        Meta
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($309c354f50c86040$export$15b13d6286254aba.Provider, {
        value: config
    }, children);
};
var $309c354f50c86040$export$2e2bcd8739ae039 = $309c354f50c86040$var$MetaDataProvider;

});


parcelRegister("9llZ5", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => (parcelRequire("b7pji")).EngagementProviderWrapper);

var $b7pji = parcelRequire("b7pji");

});
parcelRegister("b7pji", function(module, exports) {
$parcel$export(module.exports, "EngagementProviderWrapper", () => $d3ead631c31fb8a3$export$a055f8fe7b78f866);

var $8P7DW = parcelRequire("8P7DW");

var $bRKFD = parcelRequire("bRKFD");
var $jzxjj = parcelRequire("jzxjj");

var $edC7N = parcelRequire("edC7N");

var $lut7F = parcelRequire("lut7F");
const $d3ead631c31fb8a3$export$a055f8fe7b78f866 = ({ config: config, analyticsClientInstance: analyticsClientInstance, children: children })=>{
    const epConfig = {
        environment: config.environment,
        cloudId: config.tenantId,
        aaid: config.accountId,
        locale: config.userLocale,
        product: 'jira',
        subProduct: 'serviceDesk',
        stargateUrl: '/gateway/api'
    };
    const renderOnError = (0, $8P7DW.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        id: 'engagement-provider-error',
        renderError: renderOnError,
        onError: (0, $lut7F.reportError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jzxjj.default), {
        config: epConfig,
        analyticsClientInstance: analyticsClientInstance,
        coordinationOptions: {
            enableChoreographer: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bRKFD.EngagementMessages), null), children)));
};

});
parcelRegister("bRKFD", function(module, exports) {
$parcel$export(module.exports, "EngagementMessages", () => $95a939ba678b1a6f$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $fNC70 = parcelRequire("fNC70");

var $aA7IK = parcelRequire("aA7IK");

var $9fVHa = parcelRequire("9fVHa");
class $95a939ba678b1a6f$export$2e2bcd8739ae039 extends (0, $8P7DW.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9fVHa.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aA7IK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fNC70.default), null));
    }
}

});
parcelRegister("fNC70", function(module, exports) {
$parcel$export(module.exports, "ContextualSurveyWithEvents", () => $7a871a9acf702562$export$42b694a35bb75eda);
$parcel$export(module.exports, "default", () => $7a871a9acf702562$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ContextualSurvey", () => (parcelRequire("lfC5i")).default);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $jVcUb = parcelRequire("jVcUb");

var $1S5XV = parcelRequire("1S5XV");

var $lfC5i = parcelRequire("lfC5i");
const $7a871a9acf702562$export$42b694a35bb75eda = (0, $jVcUb.default)((0, $lfC5i.default));
var $7a871a9acf702562$export$2e2bcd8739ae039 = (0, $1S5XV.default)($7a871a9acf702562$export$42b694a35bb75eda, 'contextualSurvey');

});
parcelRegister("jVcUb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e26b661260378f0$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $k7ZVu = parcelRequire("k7ZVu");
var $0e26b661260378f0$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $8P7DW.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $k7ZVu.default)()(EngagementEventsWrapper);
};

});

parcelRegister("1S5XV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cd45ed317801aff$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $93Fg7 = parcelRequire("93Fg7");
var $8cd45ed317801aff$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $8P7DW.Component) {
        static #_ = this.contextTypes = {
            subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
            setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func
        };
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
    }
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $8P7DW.useState)(null);
        const unsubscribeRef = (0, $8P7DW.useRef)(null);
        const removeConfigRef = (0, $8P7DW.useRef)(null);
        const canSubscribe = (0, $8P7DW.useCallback)(()=>{
            return context && !!(context !== null && context !== void 0 && context.subscribeEngagementState);
        }, [
            context
        ]);
        const canSetConfig = (0, $8P7DW.useCallback)(()=>{
            return context && !!(context !== null && context !== void 0 && context.setComponentConfig);
        }, [
            context
        ]);
        const onStoreChange = (0, $8P7DW.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $8P7DW.useCallback)(()=>{
            var _context$subscribeEng;
            return context === null || context === void 0 || (_context$subscribeEng = context.subscribeEngagementState) === null || _context$subscribeEng === void 0 ? void 0 : _context$subscribeEng.call(context, onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $8P7DW.useCallback)((propsToUse = props)=>{
            var _context$setComponent;
            return context === null || context === void 0 || (_context$setComponent = context.setComponentConfig) === null || _context$setComponent === void 0 ? void 0 : _context$setComponent.call(context, getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $8P7DW.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $8P7DW.useRef)(engagementId);
        const previousMessageType = (0, $8P7DW.useRef)(messageType);
        const previousOnMessageDisposition = (0, $8P7DW.useRef)(onMessageDisposition);
        (0, $8P7DW.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("lfC5i", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0e1ac9631d792d5$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $8P7DW = parcelRequire("8P7DW");

var $6ZbKN = parcelRequire("6ZbKN");

var $cgMJY = parcelRequire("cgMJY");

var $fxKyN = parcelRequire("fxKyN");

var $8hV2z = parcelRequire("8hV2z");
function $d0e1ac9631d792d5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6ZbKN.default), {
        shouldShow: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8hV2z.default), {
            markAsSeenAndFatigued: (0, $cgMJY.markAsSeenAndFatigued),
            sendUserResponse: (0, $cgMJY.sendUserResponse),
            getFlag: (0, $fxKyN.getFlag),
            setFlag: (0, $fxKyN.setFlag),
            ...props
        }));
}

});
parcelRegister("6ZbKN", function(module, exports) {
$parcel$export(module.exports, "default", () => $be2b94b15311c566$export$2e2bcd8739ae039);
/* SurveyMarshal.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $cBwgz = parcelRequire("cBwgz");

var $31KvO = parcelRequire("31KvO");
// 8px is the base unit in pixels
const $be2b94b15311c566$var$surveyOffset = "var(--ds-space-600, 48px)";
const $be2b94b15311c566$var$marshalLayoutStyles = null;
const $be2b94b15311c566$var$marshalMotionLayerStyles = null;
function $be2b94b15311c566$export$2e2bcd8739ae039(props) {
    const { children: children, shouldShow: shouldShow } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBwgz.default), {
        appear: true,
        children: shouldShow && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $31KvO.default), {
            enterFrom: "right",
            fade: "inout",
            duration: "medium",
            children: (motionProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    ref: motionProps.ref,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- motion keyframes
                    className: (0, $8n1kL.default)([
                        "_kqsw1n9t _1xi2oahv _94n5oahv",
                        "_1pbyni7l",
                        motionProps.className
                    ]),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- motion animation styles
                    style: motionProps.style,
                    children: children()
                })
        }, "contextual-survey-marshal")
    });
}

});

parcelRegister("cgMJY", function(module, exports) {
$parcel$export(module.exports, "getMessages", () => $5fa11cc8c677d80f$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $5fa11cc8c677d80f$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $5fa11cc8c677d80f$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $5fa11cc8c677d80f$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $5fa11cc8c677d80f$export$3683393f780c6905);
/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ 
var $1yZ7z = parcelRequire("1yZ7z");
const $5fa11cc8c677d80f$export$f4d1b02d312560f5 = '2';
async function $5fa11cc8c677d80f$export$8c20ab16ac9cf14f(_cloudId, _stargateUrl, _product, _locale) {
    return {
        messages: [],
        interval: 0
    };
}
var $5fa11cc8c677d80f$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $5fa11cc8c677d80f$var$choreographerPlugin;
async function $5fa11cc8c677d80f$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $5fa11cc8c677d80f$var$startMessageWithChoreographer(startMessageConfig, options);
    return $5fa11cc8c677d80f$var$startMessageWithCoordination(startMessageConfig);
}
async function $5fa11cc8c677d80f$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $5fa11cc8c677d80f$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $5fa11cc8c677d80f$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $5fa11cc8c677d80f$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$5fa11cc8c677d80f$var$choreographerPlugin) $5fa11cc8c677d80f$var$choreographerPlugin = new (0, $1yZ7z.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $5fa11cc8c677d80f$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$5fa11cc8c677d80f$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $5fa11cc8c677d80f$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$5fa11cc8c677d80f$var$choreographerPlugin) $5fa11cc8c677d80f$var$choreographerPlugin = new (0, $1yZ7z.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $5fa11cc8c677d80f$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$5fa11cc8c677d80f$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $5fa11cc8c677d80f$var$startMessageWithCoordination(_startMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $5fa11cc8c677d80f$var$stopMessageWithCoordination(_stopMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $5fa11cc8c677d80f$export$e1fd1449cf83c1f5(_cloudId, _stargateUrl, _messageId, _payload) {
    return Promise.resolve();
}
async function $5fa11cc8c677d80f$export$3683393f780c6905(_seenMessageConfig) {
    return Promise.resolve();
}

});
parcelRegister("1yZ7z", function(module, exports) {
$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $5b8494bbb52f1041$export$da23bd36e2d631b);

var $972RD = parcelRequire("972RD");

var $8H5jz = parcelRequire("8H5jz");

var $anqoP = parcelRequire("anqoP");

var $8vdy9 = parcelRequire("8vdy9");

var $3s4De = parcelRequire("3s4De");
const $5b8494bbb52f1041$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $5b8494bbb52f1041$export$da23bd36e2d631b extends (0, $3s4De.ChoreographerPlugin) {
    constructor(env, metaMetricsData = {}){
        super((0, $8H5jz.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
    /**
   * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
   * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
   * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
   * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
   * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
   * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
   * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
   * actually fired off, and will keep just the log entries from which we can derive some actual value.
   *
   * @param event OperationalEventPayload
   * @returns boolean
   */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $8H5jz.MessageAction).START || event.action !== (0, $8H5jz.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $972RD.Choreographer).getInstance().getCurrentMessage() ?? (0, $972RD.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $5b8494bbb52f1041$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $anqoP.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $8H5jz.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
     * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
     * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
     * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
     * will block the subsequest start request attempt altogether), by checking the Choreographer's
     * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
     * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
     */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $8vdy9.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $8H5jz.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
     * Dispatch the request to start the message, and return the response, which will
     * either be 'started' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $8H5jz.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $anqoP.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
     * Dispatch the request to stop the message, and return the response, which will
     * either be 'stopped' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $8H5jz.MessageDeliveryStatus).STOPPED;
    }
}

});
parcelRegister("972RD", function(module, exports) {
$parcel$export(module.exports, "Choreographer", () => $7100ebf0a9c53b0b$export$236158f15971c92e);

var $e6Qdr = parcelRequire("e6Qdr");

var $8H5jz = parcelRequire("8H5jz");

var $anqoP = parcelRequire("anqoP");

var $8vdy9 = parcelRequire("8vdy9");

var $7e0Px = parcelRequire("7e0Px");

var $7r8ab = parcelRequire("7r8ab");
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $7100ebf0a9c53b0b$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $7100ebf0a9c53b0b$var$singleton;
class $7100ebf0a9c53b0b$export$236158f15971c92e {
    /**
   * Static method to create and/or return a singleton of the choreographer API.
   *
   * @returns Shared instance of choreographer API.
   */ static getInstance() {
        const isWindowRegisteredSingleton = (0, $e6Qdr.fg)('post-office_choreographer_window_singleton');
        if (isWindowRegisteredSingleton) {
            var _window$postOffice;
            if (typeof window !== 'undefined' && (_window$postOffice = window.postOffice) !== null && _window$postOffice !== void 0 && (_window$postOffice = _window$postOffice.choreographer) !== null && _window$postOffice !== void 0 && _window$postOffice.singleton) return window.postOffice.choreographer.singleton;
            if (typeof window !== 'undefined') {
                var _window$postOffice2;
                window.postOffice = {
                    ...window.postOffice,
                    choreographer: {
                        ...(_window$postOffice2 = window.postOffice) === null || _window$postOffice2 === void 0 ? void 0 : _window$postOffice2.choreographer,
                        singleton: new this()
                    }
                };
                return window.postOffice.choreographer.singleton;
            }
        }
        if (!$7100ebf0a9c53b0b$var$singleton) $7100ebf0a9c53b0b$var$singleton = new this();
        return $7100ebf0a9c53b0b$var$singleton;
    }
    constructor(){
        this.shouldBeChoreographed = (productId, analyticsClient, metricsData = {}, props, coordinationOptions, toggleableProp)=>{
            var _this$state$seenTrans;
            /*
     * TODO: Remove this once we have enough transactional message data!!! This is a hacky TEMPORARY solution to get a sense
     * of how many transactional messages we are showing to users.
     *
     * We have to track which messages have been seen because shouldBeChoreographed is called on every rerender of
     * Choreographer-integrated components. So, if we log every call, we'll get an inaccurate number of transactional
     * messages that are actually being shown to users.
     *
     * Thus, we track which messages have been seen and only log the first time we see a transactional message.
     */ // Check if we should log the shouldBeChoreographed call
            const isTransactional = (props === null || props === void 0 ? void 0 : props.messageType) === (0, $8H5jz.MessageTypesEnum).TRANSACTIONAL;
            const isTransactionalLoggingEnabled = (0, $e6Qdr.fg)('post-office_choreographer_log_transactional_msg');
            const seen = (props === null || props === void 0 ? void 0 : props.messageId) && ((_this$state$seenTrans = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans === void 0 ? void 0 : _this$state$seenTrans.has(props.messageId));
            // If the component is toggleable, we only want to log the message if it is actually rendered
            const isRendered = !toggleableProp || toggleableProp && (props === null || props === void 0 ? void 0 : props[toggleableProp]);
            if (isTransactional && props !== null && props !== void 0 && props.messageId && isTransactionalLoggingEnabled && isRendered && !seen) {
                var _this$state$seenTrans2, _this$getCurrentMessa;
                // Mark the messageId as seen to prevent duplicate logging on rerenders
                if (!this.state.seenTransactionalMessages.has(productId)) this.state.seenTransactionalMessages.set(productId, new Set());
                (_this$state$seenTrans2 = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans2 === void 0 || _this$state$seenTrans2.add(props.messageId);
                const logger = new (0, $8vdy9.Logger)('messageStart', props.messageId, {
                    ...metricsData,
                    messageId: props.messageId,
                    currentMessageId: (_this$getCurrentMessa = this.getCurrentMessage()) === null || _this$getCurrentMessa === void 0 ? void 0 : _this$getCurrentMessa.messageId,
                    messageType: props.messageType
                }, analyticsClient);
                logger.requested();
            }
            // Call the original function that actually determines if a message should be choreographed
            return (0, $7e0Px.shouldBeChoreographed)(props, coordinationOptions);
        };
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false,
            seenTransactionalMessages: new Map()
        };
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
   * Enables the message queue, and logs which message everybody else is queueing up behind.
   *
   * @param productId Unique identifier for the product making the current startMessage request blocking others.
   * @param messageId Unique identifier for the messageId blocking others.
   */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
   * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
   * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
   * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
   * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
   * its startMessage request is processed.
   *
   * @param productId Unique identifier for the product making the current startMessage request being queued.
   * @param messageId Unique identifier for the messageId being queued.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
   * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
   * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
   * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
   * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
   * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
   */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
   * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
   * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
   * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
   * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
   * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
   *
   * @param [plugin] An optional plugin instance
   */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            var _this$state$currentMe, _this$state$currentMe2, _this$state$currentMe3, _this$state$currentMe4;
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $8H5jz.MessageAction).START;
            const logger = new (0, $8vdy9.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $anqoP.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: (_this$state$currentMe = this.state.currentMessage) === null || _this$state$currentMe === void 0 ? void 0 : _this$state$currentMe.productId,
                blockedByMessageId: (_this$state$currentMe2 = this.state.currentMessage) === null || _this$state$currentMe2 === void 0 ? void 0 : _this$state$currentMe2.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $8H5jz.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: (_this$state$currentMe3 = this.state.currentMessage) === null || _this$state$currentMe3 === void 0 ? void 0 : _this$state$currentMe3.productId,
                    blockedByMessageId: (_this$state$currentMe4 = this.state.currentMessage) === null || _this$state$currentMe4 === void 0 ? void 0 : _this$state$currentMe4.messageId
                }
            });
            resolve((0, $8H5jz.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
   * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param AnalyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        const isCustomTtlEnabled = (0, $e6Qdr.fg)('post-office_choreographer_custom_message_ttl');
        // If feature flag is off, always use default TTL
        if (!isCustomTtlEnabled) {
            this.state.messageTtl = setTimeout(()=>{
                if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
            }, $7100ebf0a9c53b0b$var$CHOREOGRAPHER_MESSAGE_TTL);
            return;
        }
        // If TTL is 0, disable TTL for this message
        if (messageTtl === 0) return;
        // Use provided TTL or default to CHOREOGRAPHER_MESSAGE_TTL
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, messageTtl ?? $7100ebf0a9c53b0b$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
   * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
   *
   * @param productId Unique identifier for the product being checked for a current message match.
   * @param messageId Unique identifier for the messageId being checked for a current message match.
   */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
   * Returns the currentMessage object.
   */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
   * Returns the queueingBehindMessage object.
   */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
   * Clears the timeout that was established for the currently-displayed message.
   */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
   * Disables all plugins that are currently registered with the choreographer when loaded in an iframe. For apps that
   * are shown within iframes (e.g. smart link embeds) we typically do not want to show in-product messages as they
   * may conflict with messages shown in parent frames.
   *
   * If called outside an iframe then this function is a noop.
   *
   * @returns A cleanup function to re-enable plugins, or `undefined` if the function was called outside an iframe.
   */ disableChoreographerForIframe() {
        // Exit if we're not in an iframe
        if (!(0, $7r8ab.isIframe)()) return;
        this.disablePlugins();
        // Cleanup function to re-enable plugins
        return ()=>this.enablePlugins();
    }
    /**
   * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
   *
   * @param [exceptFor] An optional plugin instance.
   */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
   * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
   */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
   * A callback used to remove a plugin from the list of subscribers for the choreographer service.
   *
   * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
   */ unregisterPlugin(productId) {
        var _this$state$currentMe5;
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (((_this$state$currentMe5 = this.state.currentMessage) === null || _this$state$currentMe5 === void 0 ? void 0 : _this$state$currentMe5.productId) === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
        this.state.seenTransactionalMessages.delete(productId);
    }
    /**
   * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
   *
   * @returns A value reflecting whether a message is currently being displayed on screen.
   */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
   * This function is intended for test cleanup purposes only, *not* to be called by external callers.
   *
   * @ignore
   * @param productId Unique identifier for the product whose messages are being requested
   * @returns A Map of IMessage objects, keyed by unique messageId strings.
   */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
   * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
   * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
   * or a message TTL timeout has expired.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin, messageTtl) {
        const debugLogger = new (0, $anqoP.DebugLogger)(productId, messageId);
        const actionSubject = (0, $8H5jz.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $8vdy9.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            var _message$start;
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $8H5jz.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $8H5jz.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                var _this$state$queueingB, _this$state$queueingB2;
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${(_this$state$queueingB = this.state.queueingBehindMessage) === null || _this$state$queueingB === void 0 ? void 0 : _this$state$queueingB.productId} ${(_this$state$queueingB2 = this.state.queueingBehindMessage) === null || _this$state$queueingB2 === void 0 ? void 0 : _this$state$queueingB2.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                var _this$state$currentMe6, _this$state$currentMe7, _this$state$currentMe8, _this$state$currentMe9;
                logger.blocked({
                    blockedByProductId: (_this$state$currentMe6 = this.state.currentMessage) === null || _this$state$currentMe6 === void 0 ? void 0 : _this$state$currentMe6.productId,
                    blockedByMessageId: (_this$state$currentMe7 = this.state.currentMessage) === null || _this$state$currentMe7 === void 0 ? void 0 : _this$state$currentMe7.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $8H5jz.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: (_this$state$currentMe8 = this.state.currentMessage) === null || _this$state$currentMe8 === void 0 ? void 0 : _this$state$currentMe8.productId,
                        blockedByMessageId: (_this$state$currentMe9 = this.state.currentMessage) === null || _this$state$currentMe9 === void 0 ? void 0 : _this$state$currentMe9.messageId
                    }
                });
                return (0, $8H5jz.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await ((_message$start = message.start) === null || _message$start === void 0 ? void 0 : _message$start.call(message)) ?? true;
            if (didStart) {
                var _message$onStart;
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                (_message$onStart = message.onStart) === null || _message$onStart === void 0 || _message$onStart.call(message);
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $8H5jz.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $8H5jz.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $8H5jz.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $8H5jz.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $8H5jz.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $8H5jz.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        const debugLogger = new (0, $anqoP.DebugLogger)(productId, messageId);
        const actionSubject = (0, $8H5jz.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $8vdy9.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            var _message$stop;
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $8H5jz.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $8H5jz.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await ((_message$stop = message.stop) === null || _message$stop === void 0 ? void 0 : _message$stop.call(message)) ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    var _message$onStop;
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    (_message$onStop = message.onStop) === null || _message$onStop === void 0 || _message$onStop.call(message);
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $8H5jz.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $8H5jz.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $8H5jz.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $8H5jz.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $8H5jz.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $8H5jz.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
   * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId Unique identifier to register as the product owner of this plugin.
   * @param plugin A plugin instance to be registered with the choreographer instance.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        this.state.seenTransactionalMessages.set(productId, new Set());
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
   * Validates that a message record is present and ready to be retrieved and/or manipulated.
   * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
   *
   * @param productId Unique identifier to retrieve map of IMessage objects.
   * @param messageId Unique identifier for the messageId to be retrieved.
   * @returns IMessage object for the requested productId/messageId combination.
   */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
   * Checks for the existance of a message record for a given productId/messageId combination.
   *
   * @param productId Unique identifier to check for a map of IMessage objects.
   * @param messageId Unique identifier to check for within the map of productId IMessage objects.
   * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
   */ hasMessageRecord(productId, messageId) {
        var _this$state$messages$, _this$state$messages$2;
        return Boolean((_this$state$messages$ = this.state.messages.get(productId)) === null || _this$state$messages$ === void 0 || (_this$state$messages$2 = _this$state$messages$.has) === null || _this$state$messages$2 === void 0 ? void 0 : _this$state$messages$2.call(_this$state$messages$, messageId));
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
   */ off(productId, messageId) {
        var _this$state$messages$3, _this$state$messages$4;
        (_this$state$messages$3 = this.state.messages.get(productId)) === null || _this$state$messages$3 === void 0 || (_this$state$messages$4 = _this$state$messages$3.delete) === null || _this$state$messages$4 === void 0 || _this$state$messages$4.call(_this$state$messages$3, messageId);
    }
    /**
   * This should only be used for test cleanup purposes.
   * Clears the seen transactional messages cache for a given productId.
   *
   * @param productId Unique identifier to clear the seen transactional messages cache for.
   */ clearSeenTransactionalMessages(productId) {
        var _this$state$seenTrans3;
        (_this$state$seenTrans3 = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans3 === void 0 || _this$state$seenTrans3.clear();
    }
}

});
parcelRegister("8H5jz", function(module, exports) {
$parcel$export(module.exports, "MessageDeliveryStatus", () => $e2ceb7675bc0f44e$export$f6a9504bc1305cf0);
$parcel$export(module.exports, "ProductIds", () => $e2ceb7675bc0f44e$export$7fb117db98868be6);
$parcel$export(module.exports, "MessageTypesEnum", () => $e2ceb7675bc0f44e$export$94e85cf3348f045a);
$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e2ceb7675bc0f44e$export$dbe9e38c9d6f26d0);
$parcel$export(module.exports, "MessageAction", () => $e2ceb7675bc0f44e$export$865c0eaaa43d90f8);
const $e2ceb7675bc0f44e$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $e2ceb7675bc0f44e$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered',
    // TEMPORARY: used to track when a transactional message is requested to be choreographed
    // when the choreographer is currently blocked.
    REQUESTED: 'requested'
};
var $e2ceb7675bc0f44e$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    ProductIds["LOOM"] = "loom";
    return ProductIds;
}({});
const $e2ceb7675bc0f44e$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e2ceb7675bc0f44e$export$dbe9e38c9d6f26d0 = [
    $e2ceb7675bc0f44e$export$94e85cf3348f045a.ENGAGEMENT,
    $e2ceb7675bc0f44e$export$94e85cf3348f045a.MARKETING
];
const $e2ceb7675bc0f44e$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $e2ceb7675bc0f44e$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};

});

parcelRegister("anqoP", function(module, exports) {
$parcel$export(module.exports, "DebugLogger", () => $0ad65ee57f905aad$export$21e6cc849c1dc1ab);
function $0ad65ee57f905aad$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $0ad65ee57f905aad$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($0ad65ee57f905aad$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $0ad65ee57f905aad$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($0ad65ee57f905aad$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $0ad65ee57f905aad$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
   * A function that takes an object of properties for each logging level
   * name, e.g. log.info and log.verbose, which are functions that take an
   * object of any key/value pairs, which will be merged with the productId
   * and the messageId values passed to the constructor, and output via
   * console.table.
   *
   * Example: debugLogger.log({
   *   info: { foo: true },
   *   verbose: {
   *     foo: true,
   *     bar: 123,
   *     baz 'abc',
   *     timestamp: performance.now()
   *   },
   * });
   *
   * @param messages Record<LoggingLevels, Record<string, unknown>> An object
   * keyed by the desired log-level, with each value being an object of any
   * key/value pairs to be output to console.table.
   */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $0ad65ee57f905aad$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
   * A function that takes an object of properties for each logging level
   * name, e.g. trace.info and trace.verbose, which are functions that take
   * a string to be used as the label for a stack trace via console.trace.
   *
   * Example: debugLogger.trace({
   *   info: 'This is a stack trace',
   *   verbose: `This is a stack trace with a much more verbose message which
   * contains data about the ${productId} and ${messageId} within my function,
   * invoked at ${performance.now()}ms`,
   * });
   *
   * @param messages Record<LoggingLevels, string> An object keyed by the
   * desired log-level, with each value being a string to be output as the
   * label to console.trace.
   */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $0ad65ee57f905aad$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}

});

parcelRegister("8vdy9", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $6af7c1b6a2d388ed$export$efa9a398d6368992);

var $8H5jz = parcelRequire("8H5jz");
class $6af7c1b6a2d388ed$export$efa9a398d6368992 {
    /**
   * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
   *
   * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
   * @param actionSubjectId Unique messageId to be logged with this even.
   * @param metricsData Additional data from plugin to be sent with event for metrics logging.
   * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
   * @param [plugin] An optional plugin instance.
   */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
    /**
   * Send operational event to the Analytics web client for logging/metrics.
   *
   * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
   */ sendOperationalEvent(action, additionalAttributes) {
        var _plugin$shouldLogEven;
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if ((plugin === null || plugin === void 0 || (_plugin$shouldLogEven = plugin.shouldLogEvent) === null || _plugin$shouldLogEven === void 0 ? void 0 : _plugin$shouldLogEven.call(plugin, event)) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $8H5jz.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $8H5jz.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $8H5jz.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $8H5jz.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $8H5jz.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
    requested(additionalAttributes) {
        this.sendOperationalEvent((0, $8H5jz.MessageDeliveryStatus).REQUESTED, additionalAttributes);
    }
}

});

parcelRegister("7e0Px", function(module, exports) {
$parcel$export(module.exports, "shouldBeChoreographed", () => $5c922abc5e07d86f$export$a8ba9111c7eec9ac);

var $8P7DW = parcelRequire("8P7DW");

var $8H5jz = parcelRequire("8H5jz");
const $5c922abc5e07d86f$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions === null || coordinationOptions === void 0 ? void 0 : coordinationOptions.enableChoreographer) && (props === null || props === void 0 ? void 0 : props.messageType) !== undefined && (0, $8H5jz.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $5c922abc5e07d86f$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $8P7DW.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $5c922abc5e07d86f$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $8P7DW.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props, toggleableProp)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};

});

parcelRegister("7r8ab", function(module, exports) {
$parcel$export(module.exports, "isIframe", () => $a89dfbc24c72b8b9$export$e6c5ffa684aac4d7);
/**
 * Returns `true` if window is currently nested within an iframe.
 */ function $a89dfbc24c72b8b9$export$e6c5ffa684aac4d7() {
    return window.self !== window.top;
}

});


parcelRegister("3s4De", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPlugin", () => $e04b8c5cffe03ec9$export$71324a662782c710);

var $jXNbL = parcelRequire("jXNbL");
var $b5UnP = parcelRequire("b5UnP");

var $972RD = parcelRequire("972RD");
class $e04b8c5cffe03ec9$export$71324a662782c710 {
    /**
   * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
   * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
   * between individual products for tracking purposes.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @param env The environment type for the product, to be used for analytics events.
   * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
   * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
   */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
     * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
     * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
     * .on, .onStart, and .onStop function registrations.
     *
     * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
     * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
     * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
     * in the plugin, and would continue blocking messages.
     *
     * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
     * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
     * whether or not an actual start or stop callback was registered by the consumer.
     */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
    /**
   * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
   */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
   * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
   * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
   * container to be present, or checks with some external API to tell it whether a message is being displayed, or
   * anything else. The logic is up to the consumer to implement, if something custom is desired.
   *
   * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
   */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
   * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
   */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
   * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
   */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
   * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ disable() {
        this.state.isDisabled = true;
    }
    /**
   * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ enable() {
        this.state.isDisabled = false;
    }
    /**
   * Returns the Analytics Web Client instance for this plugin.
   *
   * @returns AnalyticsWebClient instance
   */ getAnalyticsClient() {
        return this.analyticsClient;
    }
    /**
   * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
   * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
   *
   * @param messageId The messageId for the message to be started through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message start request
   * @param messageTtl Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use global default (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(messageId, additionalData = {}, messageTtl) {
        return (0, $972RD.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this, messageTtl);
    }
    /**
   * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
   *
   * @param messageId The messageId for the message to be stopped through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message stop request
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(messageId, additionalData = {}) {
        return (0, $972RD.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   */ on(messageId, options = {}) {
        return (0, $972RD.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   */ onStart(messageId, startCallback) {
        return (0, $972RD.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   */ onStop(messageId, stopCallback) {
        return (0, $972RD.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
   */ off(messageId) {
        return (0, $972RD.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    shouldBeChoreographed(props, coordinationOptions, toggleableProp // TODO: Remove this once we no longer need transactional logs
    ) {
        return (0, $972RD.Choreographer).getInstance().shouldBeChoreographed(this.state.productId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            productId: this.state.productId
        }, props, coordinationOptions, toggleableProp);
    }
    /**
   * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId) {
        return (0, $972RD.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
   * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
   *
   * @param env environment type used to create the analytics client
   * @returns AnalyticsWebClient instance
   */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $jXNbL.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $b5UnP.originType).WEB
        });
        return analyticsClient;
    }
}

});



parcelRegister("fxKyN", function(module, exports) {
$parcel$export(module.exports, "getFlag", () => $403c45f3994a95de$export$a19b74191e00c5e);
$parcel$export(module.exports, "setFlag", () => $403c45f3994a95de$export$5e165df1e30a1331);
/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ async function $403c45f3994a95de$export$a19b74191e00c5e(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return {
        status: false,
        lastSeenDate: ''
    };
}
async function $403c45f3994a95de$export$5e165df1e30a1331(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return Promise.resolve();
}

});

parcelRegister("8hV2z", function(module, exports) {
$parcel$export(module.exports, "default", () => $b02a7b7f48dbcff7$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $1rVlA = parcelRequire("1rVlA");
const $b02a7b7f48dbcff7$var$flagKey = 'atlassian_research_group_mailinglist_actioned';
class $b02a7b7f48dbcff7$export$2e2bcd8739ae039 extends (0, $8P7DW.PureComponent) {
    firePrimaryClickEvent() {
        this.props.fireClickEvent('primary');
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1rVlA.default), {
            onDismiss: this.onDismiss,
            getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
            onMailingListAnswer: this.onMailingListAnswer,
            onSubmit: this.onSubmit,
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.onDismiss = (onDismissArgs)=>{
            const { cloudId: cloudId, messageId: messageId, fireClickEvent: fireClickEvent, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, orgId: orgId, workspaceId: workspaceId } = this.props;
            if (onDismissArgs.trigger === (0, $1rVlA.DismissTrigger).Manual) markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            fireClickEvent('dismiss');
        }, this.getUserHasAnsweredMailingList = async ()=>{
            const { stargateUrl: stargateUrl, aaid: aaid, cloudId: cloudId, getFlag: getFlag } = this.props;
            try {
                await getFlag(stargateUrl, cloudId, $b02a7b7f48dbcff7$var$flagKey, aaid);
                return Promise.resolve(false);
            } catch  {
                return Promise.resolve(true);
            }
        }, this.onSubmit = async (formValues)=>{
            const { cloudId: cloudId, messageId: messageId, question: question, statement: statement, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, sendUserResponse: sendUserResponse, orgId: orgId, workspaceId: workspaceId } = this.props;
            const { canContact: canContact, feedbackScore: feedbackScore, writtenFeedback: writtenFeedback } = formValues;
            const payload = {
                responseType: 'ACCEPTANCE_SURVEY',
                properties: {
                    surveyTimestamp: Date.now(),
                    contextualQuestion: question,
                    contextualStatement: statement,
                    quantitativeResponse: feedbackScore,
                    qualitativeResponse: writtenFeedback,
                    contactable: canContact
                }
            };
            markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            this.firePrimaryClickEvent();
            // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
            return sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(()=>Promise.resolve());
        }, this.onMailingListAnswer = async (answer)=>{
            const { aaid: aaid, cloudId: cloudId, stargateUrl: stargateUrl, messageId: messageId, sendUserResponse: sendUserResponse, setFlag: setFlag } = this.props;
            const payload = {
                responseType: 'MAILING_LIST_RESPONSE',
                properties: {}
            };
            setFlag(stargateUrl, cloudId, $b02a7b7f48dbcff7$var$flagKey, aaid);
            if (!answer) return;
            return sendUserResponse(cloudId, stargateUrl, messageId, payload);
        };
    }
}

});
parcelRegister("1rVlA", function(module, exports) {
$parcel$export(module.exports, "DismissTrigger", () => $2a024aac85bfdbc2$export$151efc60ac534d42);
$parcel$export(module.exports, "default", () => $2a024aac85bfdbc2$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6waXS = parcelRequire("6waXS");

var $gRJs0 = parcelRequire("gRJs0");

var $kRG8X = parcelRequire("kRG8X");

var $aiHZi = parcelRequire("aiHZi");

var $fUm1R = parcelRequire("fUm1R");

var $bfUNn = parcelRequire("bfUNn");
var $2a024aac85bfdbc2$export$151efc60ac534d42 = /*#__PURE__*/ function(DismissTrigger) {
    DismissTrigger["AutoDismiss"] = "AUTO_DISMISS";
    DismissTrigger["Manual"] = "MANUAL";
    DismissTrigger["Finished"] = "FINISHED";
    DismissTrigger["Unmount"] = "UNMOUNT";
    return DismissTrigger;
}({});
const $2a024aac85bfdbc2$export$3e8963a077f85f25 = 8000;
var $2a024aac85bfdbc2$export$2e2bcd8739ae039 = ({ question: question, statement: statement, onDismiss: onDismiss, onSubmit: onSubmit, onMailingListAnswer: onMailingListAnswer, getUserHasAnsweredMailingList: getUserHasAnsweredMailingList, textLabel: textLabel = 'Why did you give that rating', textPlaceholder: textPlaceholder = 'Tell us why' })=>{
    const autoDisappearTimeoutRef = (0, $8P7DW.useRef)(null);
    // only allow a single dismiss for a component
    const isDismissedRef = (0, $8P7DW.useRef)(false);
    const tryDismiss = (0, $8P7DW.useCallback)((trigger)=>{
        // Already called dismiss once
        if (isDismissedRef.current) return;
        isDismissedRef.current = true;
        onDismissRef.current({
            trigger: trigger
        });
    }, []);
    const [currentStep, setCurrentStep] = (0, $8P7DW.useState)('SURVEY');
    const trySetCurrentStep = (0, $8P7DW.useCallback)((step)=>{
        // Already dismissed - cannot update the step
        if (isDismissedRef.current) return;
        setCurrentStep(step);
    }, [
        setCurrentStep
    ]);
    // using a ref so that we don't break all of our caches if a consumer is using an arrow function
    const onDismissRef = (0, $8P7DW.useRef)(onDismiss);
    (0, $8P7DW.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    // reset isDismissedRef.current on mount to be compatible with double render in react18 strict mode
    (0, $8P7DW.useEffect)(()=>{
        isDismissedRef.current = false;
    }, []);
    const tryClearTimeout = (0, $8P7DW.useCallback)(()=>{
        const id = autoDisappearTimeoutRef.current;
        if (id) {
            clearTimeout(id);
            autoDisappearTimeoutRef.current = null;
        }
    }, []);
    // Cleanup any auto dismiss after dismiss
    (0, $8P7DW.useEffect)(()=>{
        return function unmount() {
            tryClearTimeout();
            tryDismiss("UNMOUNT");
        };
    }, [
        tryClearTimeout,
        tryDismiss
    ]);
    const onSurveySubmit = (0, $8P7DW.useCallback)(async (formValues, _form, callback = ()=>{})=>{
        // Submitting form: Phase 1 complete
        await onSubmit(formValues);
        // Note: need to call callback just before we navigate away
        // It cleans up the form (required)
        // Optional Phase 2: Asking to join Atlassian Research Group
        // Only enter phase 2 if:
        // 1. not already dismissed; AND
        // 2. permission given to contact; AND
        // 3. user has previously not answered mailing list question (getUserHasAnsweredMailingList returns false)
        // Not entering phase 2: User has dismissed while the submit promise was resolving
        if (isDismissedRef.current) {
            callback();
            return;
        }
        // Not entering phase 2: no permission given to respond to feedback
        if (!formValues.canContact) {
            callback();
            trySetCurrentStep('POST_SURVEY_NO_CONSENT');
            return;
        }
        const userHasAnswered = await getUserHasAnsweredMailingList();
        callback();
        // Not entering phase 2: user has already answered this question
        if (userHasAnswered) {
            trySetCurrentStep('POST_SURVEY_HAS_SIGN_UP');
            return;
        }
        // Enter phase 2
        trySetCurrentStep('SIGN_UP_PROMPT');
    }, [
        getUserHasAnsweredMailingList,
        onSubmit,
        trySetCurrentStep
    ]);
    const onMailingListResponse = (0, $8P7DW.useCallback)(async (answer)=>{
        await onMailingListAnswer(answer);
        if (answer) {
            trySetCurrentStep('SIGN_UP_SUCCESS');
            return;
        }
        // We have already thanked to user, we can simply close
        tryDismiss("FINISHED");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tryDismiss,
        trySetCurrentStep
    ]);
    // Start the auto disappear when we are finished
    (0, $8P7DW.useEffect)(()=>{
        // Already dismissed
        if (isDismissedRef.current) return;
        // Timeout already scheduled
        if (autoDisappearTimeoutRef.current) return;
        if ([
            'SIGN_UP_SUCCESS',
            'POST_SURVEY_NO_CONSENT',
            'POST_SURVEY_HAS_SIGN_UP'
        ].includes(currentStep)) autoDisappearTimeoutRef.current = window.setTimeout(()=>tryDismiss("AUTO_DISMISS"), $2a024aac85bfdbc2$export$3e8963a077f85f25);
    }, [
        currentStep,
        tryDismiss
    ]);
    (0, $bfUNn.default)({
        onDismiss: ()=>tryDismiss("MANUAL")
    });
    const content = (()=>{
        if (currentStep === 'SURVEY') return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fUm1R.default), {
            question: question,
            statement: statement,
            textLabel: textLabel,
            textPlaceholder: textPlaceholder,
            onSubmit: onSurveySubmit
        });
        if (currentStep === 'SIGN_UP_PROMPT') return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gRJs0.default), {
            onAnswer: onMailingListResponse
        });
        if (currentStep === 'SIGN_UP_SUCCESS') return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $kRG8X.default), {});
        if (currentStep === 'POST_SURVEY_NO_CONSENT' || currentStep === 'POST_SURVEY_HAS_SIGN_UP') return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6waXS.default), {});
        return null;
    })();
    const manualDismiss = (0, $8P7DW.useCallback)(()=>{
        // clear any pending timers
        tryClearTimeout();
        tryDismiss("MANUAL");
    }, [
        tryDismiss,
        tryClearTimeout
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $aiHZi.default), {
        onDismiss: manualDismiss,
        children: content
    });
};

});
parcelRegister("6waXS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccb50381efcf570c$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $iqJis = parcelRequire("iqJis");

var $bYCjP = parcelRequire("bYCjP");
var $ccb50381efcf570c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $bYCjP.default), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
            size: "xsmall",
            children: "Thanks for your feedback"
        })
    });

});
parcelRegister("bYCjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $708b35c4d8b8c351$export$2e2bcd8739ae039);
/* SuccessContainer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $joUCG = parcelRequire("joUCG");
const $708b35c4d8b8c351$var$sectionStyles = null;
const $708b35c4d8b8c351$var$iconContainerStyles = null;
var $708b35c4d8b8c351$export$2e2bcd8739ae039 = ({ children: children })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("section", {
        className: (0, $8n1kL.default)([
            "_18u01jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    "_kqswstnw _154iv47k _1ltv1ejb"
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($joUCG))), {
                    spacing: "spacious",
                    label: "",
                    "aria-hidden": true,
                    color: "var(--ds-icon-success, #6A9A23)"
                })
            }),
            children
        ]
    });

});


parcelRegister("gRJs0", function(module, exports) {
$parcel$export(module.exports, "default", () => $27e6a6bb841c75c4$export$2e2bcd8739ae039);
/* SignUpPrompt.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $izQyW = parcelRequire("izQyW");

var $iqJis = parcelRequire("iqJis");

var $2XLqF = parcelRequire("2XLqF");

var $2CGHX = parcelRequire("2CGHX");
var $6E5P5 = parcelRequire("6E5P5");
var $9pb7J = parcelRequire("9pb7J");

var $bYCjP = parcelRequire("bYCjP");
const $27e6a6bb841c75c4$var$buttonContainerStyles = null;
var $27e6a6bb841c75c4$export$2e2bcd8739ae039 = ({ onAnswer: onAnswer })=>{
    const [pending, setPending] = (0, $8P7DW.useState)(null);
    const answeredWith = (0, $8P7DW.useCallback)(async (answer)=>{
        setPending(answer ? 'yes' : 'no');
        await onAnswer(answer);
    }, [
        setPending,
        onAnswer
    ]);
    const isDisabled = Boolean(pending);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $bYCjP.default), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                size: "xsmall",
                children: "Thanks for your feedback"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                paddingBlockStart: "space.150",
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6E5P5.default), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                            as: "p",
                            children: "Are you interested in participating in our research?"
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $9pb7J.default), {
                            as: "p",
                            children: [
                                "Sign up for the",
                                ' ',
                                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2XLqF.default), {
                                    href: "https://www.atlassian.com/research-group",
                                    target: "_blank",
                                    children: "Atlassian Research Group"
                                }),
                                ' ',
                                "and we may contact you in the future with research opportunities."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                className: (0, $8n1kL.default)([
                    "_19pkxy5q _1e0c1txw _1bahesu3 _pof3u2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                        appearance: "subtle",
                        onClick: ()=>answeredWith(false),
                        isDisabled: isDisabled,
                        isLoading: pending === 'no',
                        children: "No, thanks"
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                        appearance: "primary",
                        onClick: ()=>answeredWith(true),
                        isDisabled: isDisabled,
                        isLoading: pending === 'yes',
                        children: "Yes, sign me up"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("izQyW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f476ce8b585cb59f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $jiIHo = parcelRequire("jiIHo");

var $6ZVn7 = parcelRequire("6ZVn7");

var $ko9LV = parcelRequire("ko9LV");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $f476ce8b585cb59f$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $jiIHo.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: [
            iconBefore && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6ZVn7.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ko9LV.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6ZVn7.default), {
                isLoading: isLoading,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6ZVn7.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ko9LV.default), {
                    icon: iconAfter
                })
            })
        ]
    });
}));
$f476ce8b585cb59f$var$Button.displayName = 'Button';
var $f476ce8b585cb59f$export$2e2bcd8739ae039 = $f476ce8b585cb59f$var$Button;

});

parcelRegister("2XLqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b7b0b2943fcc49f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $6NJAV = parcelRequire("6NJAV");

var $e6Qdr = parcelRequire("e6Qdr");

var $hIZ30 = parcelRequire("hIZ30");
var $2CGHX = parcelRequire("2CGHX");
const $7b7b0b2943fcc49f$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $7b7b0b2943fcc49f$var$iconStyles = null;
const $7b7b0b2943fcc49f$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $hIZ30.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $6NJAV.cx)($7b7b0b2943fcc49f$var$styles.base, (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $7b7b0b2943fcc49f$var$styles.baseT26Shape, appearance === 'default' && $7b7b0b2943fcc49f$var$styles.defaultAppearance, appearance === 'subtle' && $7b7b0b2943fcc49f$var$styles.subtleAppearance, appearance === 'inverse' && $7b7b0b2943fcc49f$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7b7b0b2943fcc49f$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $2CGHX.default), {
                as: "span",
                xcss: $7b7b0b2943fcc49f$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $8n1kL.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7b7b0b2943fcc49f$var$Link = /*#__PURE__*/ (0, $8P7DW.forwardRef)($7b7b0b2943fcc49f$var$LinkWithoutRef);
var $7b7b0b2943fcc49f$export$2e2bcd8739ae039 = $7b7b0b2943fcc49f$var$Link;

});
parcelRegister("hIZ30", function(module, exports) {
$parcel$export(module.exports, "default", () => $08f1af473232349f$export$2e2bcd8739ae039);
/* anchor.tsx generated by @compiled/babel-plugin v0.37.1 */ /* anchor.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $82a6z = parcelRequire("82a6z");

var $clS24 = parcelRequire("clS24");

var $aeYmt = parcelRequire("aeYmt");

var $8PtDM = parcelRequire("8PtDM");

var $5J6r2 = parcelRequire("5J6r2");

var $fnhqr = parcelRequire("fnhqr");

var $9uKqY = parcelRequire("9uKqY");

var $dojiU = parcelRequire("dojiU");

var $h5g2M = parcelRequire("h5g2M");
const $08f1af473232349f$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $08f1af473232349f$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $08f1af473232349f$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $08f1af473232349f$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $5J6r2.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $8P7DW.useContext)((0, $9uKqY.default));
    const handleClick = (0, $8P7DW.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $fnhqr.useId)();
    const onClick = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $8PtDM.default)();
    const isExternal = typeof href === 'string' && $08f1af473232349f$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $08f1af473232349f$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $clS24.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $h5g2M.default), {
        // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $82a6z.cx)($08f1af473232349f$var$styles.root, $08f1af473232349f$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $08f1af473232349f$var$Anchor = /*#__PURE__*/ (0, $8P7DW.forwardRef)($08f1af473232349f$var$AnchorNoRef);
var $08f1af473232349f$export$2e2bcd8739ae039 = $08f1af473232349f$var$Anchor;

});
parcelRegister("8PtDM", function(module, exports) {
$parcel$export(module.exports, "default", () => $dba3cedbc42275aa$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $lRc3b = parcelRequire("lRc3b");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $dba3cedbc42275aa$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $8P7DW.useContext)((0, $lRc3b.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $dba3cedbc42275aa$export$2e2bcd8739ae039 = $dba3cedbc42275aa$var$useRouterLink;

});
parcelRegister("lRc3b", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $f5aab10094efd8aa$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $f5aab10094efd8aa$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $f5aab10094efd8aa$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $8P7DW.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $f5aab10094efd8aa$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)($f5aab10094efd8aa$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $f5aab10094efd8aa$export$2e2bcd8739ae039 = $f5aab10094efd8aa$var$RouterLinkProvider;

});




parcelRegister("9pb7J", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3a8fd0b6eb968a1$export$2e2bcd8739ae039);
/* text.tsx generated by @compiled/babel-plugin v0.37.1 */ /* text.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $clS24 = parcelRequire("clS24");

var $b7baD = parcelRequire("b7baD");

var $YDqMU = parcelRequire("YDqMU");
const $b3a8fd0b6eb968a1$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $b3a8fd0b6eb968a1$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $YDqMU.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($b3a8fd0b6eb968a1$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $b3a8fd0b6eb968a1$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
const $b3a8fd0b6eb968a1$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $b3a8fd0b6eb968a1$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const $b3a8fd0b6eb968a1$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $b3a8fd0b6eb968a1$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $b3a8fd0b6eb968a1$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $b3a8fd0b6eb968a1$var$Text = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $clS24.default)($b3a8fd0b6eb968a1$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $b7baD.useHasTextAncestor)();
    const color = $b3a8fd0b6eb968a1$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        id: id,
        className: (0, $8n1kL.default)([
            $b3a8fd0b6eb968a1$var$styles.root,
            size && $b3a8fd0b6eb968a1$var$fontSizeMap[size],
            color && $b3a8fd0b6eb968a1$var$textColorMap[color],
            maxLines && $b3a8fd0b6eb968a1$var$styles.truncation,
            maxLines === 1 && $b3a8fd0b6eb968a1$var$styles.breakAll,
            align && $b3a8fd0b6eb968a1$var$styles[`textAlign.${align}`],
            weight && $b3a8fd0b6eb968a1$var$fontWeightMap[weight],
            Component === 'em' && $b3a8fd0b6eb968a1$var$styles['as.em'],
            Component === 'strong' && $b3a8fd0b6eb968a1$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $b7baD.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
var $b3a8fd0b6eb968a1$export$2e2bcd8739ae039 = $b3a8fd0b6eb968a1$var$Text;

});
parcelRegister("b7baD", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $0bb3b885b04339a8$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $0bb3b885b04339a8$export$ae933c6cbe5643ad);

var $8P7DW = parcelRequire("8P7DW");
const $0bb3b885b04339a8$var$HasTextAncestorContext = /*#__PURE__*/ (0, $8P7DW.createContext)(false);
const $0bb3b885b04339a8$export$9322276ec105d055 = ()=>(0, $8P7DW.useContext)($0bb3b885b04339a8$var$HasTextAncestorContext);
const $0bb3b885b04339a8$export$ae933c6cbe5643ad = $0bb3b885b04339a8$var$HasTextAncestorContext.Provider;

});



parcelRegister("kRG8X", function(module, exports) {
$parcel$export(module.exports, "default", () => $bed2617a7d14b912$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $iqJis = parcelRequire("iqJis");

var $6E5P5 = parcelRequire("6E5P5");
var $9pb7J = parcelRequire("9pb7J");

var $bYCjP = parcelRequire("bYCjP");
var $bed2617a7d14b912$export$2e2bcd8739ae039 = ({})=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $bYCjP.default), {
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6E5P5.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                    size: "xsmall",
                    children: "Thanks for signing up"
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                    as: "p",
                    children: "We may reach out to you in the future to participate in additional research."
                })
            ]
        })
    });

});

parcelRegister("aiHZi", function(module, exports) {
$parcel$export(module.exports, "default", () => $6142ab9dffee769f$export$2e2bcd8739ae039);
/* SurveyContainer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $lRscM = parcelRequire("lRscM");

var $b9hQ0 = parcelRequire("b9hQ0");
const $6142ab9dffee769f$var$containerStyles = null;
const $6142ab9dffee769f$var$buttonWrapperStyles = null;
var $6142ab9dffee769f$export$2e2bcd8739ae039 = ({ children: children, onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        style: {},
        className: (0, $8n1kL.default)([
            "_2rkofajl _bfhk1bhr _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _16qs130s _1bsb1vif"
        ]),
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    "_kqswstnw _154ipxbi _1xi2pxbi"
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lRscM.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))),
                    label: "Dismiss",
                    appearance: "subtle",
                    onClick: onDismiss
                })
            }),
            children
        ]
    });
};

});

parcelRegister("fUm1R", function(module, exports) {
$parcel$export(module.exports, "default", () => $90c7ac84f2068446$export$2e2bcd8739ae039);
/* SurveyForm.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $iRXci = parcelRequire("iRXci");
var $gFwdR = parcelRequire("gFwdR");

var $iqJis = parcelRequire("iqJis");

var $zTiMK = parcelRequire("zTiMK");

var $6E5P5 = parcelRequire("6E5P5");
var $9pb7J = parcelRequire("9pb7J");

var $eDzJd = parcelRequire("eDzJd");

var $59gD4 = parcelRequire("59gD4");
const $90c7ac84f2068446$var$transitionBaseStyles = null;
const $90c7ac84f2068446$var$TRANSITION_DURATION = 200;
var $90c7ac84f2068446$export$2e2bcd8739ae039 = ({ question: question, statement: statement, textPlaceholder: textPlaceholder, textLabel: textLabel, onSubmit: onSubmit })=>{
    const [expanded, setExpanded] = (0, $8P7DW.useState)(false);
    const [canContactDefault, setCanContactDefault] = (0, $8P7DW.useState)(false);
    const hasAutoFilledCanContactRef = (0, $8P7DW.useRef)(false);
    const onScoreSelect = (0, $8P7DW.useCallback)(()=>{
        setExpanded(true);
    }, [
        setExpanded
    ]);
    // On the first type the user types some feedback we auto select
    // the option for allowing feedback. This automatic selection only
    // happens once. After that it is up to the user to control
    const onFeedbackChange = (0, $8P7DW.useCallback)(()=>{
        if (hasAutoFilledCanContactRef.current) return;
        hasAutoFilledCanContactRef.current = true;
        setCanContactDefault(true);
    }, []);
    const resizingHeightProps = (0, $zTiMK.useResizingHeight)({
        duration: ()=>$90c7ac84f2068446$var$TRANSITION_DURATION,
        timingFunction: ()=>'ease-in-out'
    });
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("section", {
        "aria-labelledby": "contextualSurveyQuestion",
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6E5P5.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                        id: "contextualSurveyQuestion",
                        size: "xsmall",
                        as: "h2",
                        children: question
                    }),
                    statement && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                        as: "p",
                        id: "contextualSurveyStatement",
                        children: statement
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iRXci.default), {
                onSubmit: onSubmit,
                children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gFwdR.default), {
                                name: "feedbackScore",
                                isDisabled: submitting,
                                isRequired: true,
                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $eDzJd.default), {
                                        ...fieldProps,
                                        onChange: (score)=>{
                                            fieldProps.onChange(score);
                                            onScoreSelect();
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                                ...resizingHeightProps,
                                className: (0, $8n1kL.default)([
                                    "_1reo15vq _18m915vq"
                                ]),
                                children: expanded ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $59gD4.SurveyFormExpandedFeedback), {
                                    canContactDefault: canContactDefault,
                                    onFeedbackChange: onFeedbackChange,
                                    submitting: submitting,
                                    textLabel: textLabel,
                                    textPlaceholder: textPlaceholder
                                }) : null
                            })
                        ]
                    })
            })
        ]
    });
};

});
parcelRegister("iRXci", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $576aebd0fa5f32c0$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $576aebd0fa5f32c0$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $576aebd0fa5f32c0$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v0.37.1 */ /* form.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8xGKi = parcelRequire("8xGKi");

var $aJ69w = parcelRequire("aJ69w");

var $bVVLH = parcelRequire("bVVLH");

var $iGjf2 = parcelRequire("iGjf2");

var $klxUK = parcelRequire("klxUK");

var $4DWzZ = parcelRequire("4DWzZ");
const $576aebd0fa5f32c0$export$c24727297075ec6a = /*#__PURE__*/ (0, $8P7DW.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $576aebd0fa5f32c0$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $8P7DW.createContext)(false);
const $576aebd0fa5f32c0$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $8P7DW.useRef)(null);
    const onSubmitRef = (0, $8P7DW.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $8P7DW.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $8xGKi.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($bVVLH)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($bVVLH)))(values, name, value);
                    }
                }
            }
        });
        (0, $aJ69w.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $4DWzZ.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $8P7DW.useState)({
        dirty: false,
        submitting: false
    });
    (0, $8P7DW.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $8P7DW.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $8P7DW.useCallback)((name)=>{
        const formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $8P7DW.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $klxUK.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $gWgPx.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $gWgPx.jsx)($576aebd0fa5f32c0$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($576aebd0fa5f32c0$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $576aebd0fa5f32c0$var$Form = (0, $iGjf2.default)($576aebd0fa5f32c0$var$FormBase);
var $576aebd0fa5f32c0$export$2e2bcd8739ae039 = $576aebd0fa5f32c0$var$Form;

});
parcelRegister("8xGKi", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $6382902fe28f8d03$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $6382902fe28f8d03$export$f681a8129d2e9d28);

var $cCnFQ = parcelRequire("cCnFQ");

var $911Xe = parcelRequire("911Xe");
//      
var $6382902fe28f8d03$var$charCodeOfDot = ".".charCodeAt(0);
var $6382902fe28f8d03$var$reEscapeChar = /\\(\\)?/g;
var $6382902fe28f8d03$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $6382902fe28f8d03$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $6382902fe28f8d03$var$charCodeOfDot) result.push("");
    string.replace($6382902fe28f8d03$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($6382902fe28f8d03$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $6382902fe28f8d03$var$keysCache = {};
var $6382902fe28f8d03$var$keysRegex = /[.[\]]+/;
var $6382902fe28f8d03$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($6382902fe28f8d03$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $6382902fe28f8d03$var$keysCache[key] = key.split($6382902fe28f8d03$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $6382902fe28f8d03$var$keysCache[key] = $6382902fe28f8d03$var$stringToPath(key);
    }
    return $6382902fe28f8d03$var$keysCache[key];
};
//      
var $6382902fe28f8d03$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $6382902fe28f8d03$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $6382902fe28f8d03$var$_toPropertyKey(arg) {
    var key = $6382902fe28f8d03$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6382902fe28f8d03$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6382902fe28f8d03$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $911Xe.default)(current, [
                key
            ].map($6382902fe28f8d03$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $cCnFQ.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $6382902fe28f8d03$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $6382902fe28f8d03$var$setInRecursor(state, 0, $6382902fe28f8d03$var$toPath(key), value1, destroyArrays);
};
var $6382902fe28f8d03$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $6382902fe28f8d03$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $6382902fe28f8d03$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $6382902fe28f8d03$export$c52e5867d5879e24(values, name);
    var error = $6382902fe28f8d03$export$c52e5867d5879e24(errors, name);
    if (error && error[$6382902fe28f8d03$export$735bebc8ffabf28a]) error = error[$6382902fe28f8d03$export$735bebc8ffabf28a];
    var submitError = submitErrors && $6382902fe28f8d03$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $6382902fe28f8d03$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($6382902fe28f8d03$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $6382902fe28f8d03$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $6382902fe28f8d03$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $6382902fe28f8d03$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$6382902fe28f8d03$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $6382902fe28f8d03$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $6382902fe28f8d03$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $6382902fe28f8d03$var$subscriptionFilter(result, state, previousState, subscription, $6382902fe28f8d03$export$41e855cb628c1b55, $6382902fe28f8d03$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $6382902fe28f8d03$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $6382902fe28f8d03$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $6382902fe28f8d03$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $6382902fe28f8d03$var$subscriptionFilter(result, state, previousState, subscription, $6382902fe28f8d03$export$f1ff97b9d1c7a3c3, $6382902fe28f8d03$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $6382902fe28f8d03$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$6382902fe28f8d03$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $6382902fe28f8d03$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $6382902fe28f8d03$export$83d89fbfd8236492 = "4.20.10";
var $6382902fe28f8d03$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $6382902fe28f8d03$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $6382902fe28f8d03$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $6382902fe28f8d03$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $6382902fe28f8d03$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $6382902fe28f8d03$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $6382902fe28f8d03$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $6382902fe28f8d03$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($6382902fe28f8d03$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $6382902fe28f8d03$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $cCnFQ.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $cCnFQ.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $6382902fe28f8d03$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $6382902fe28f8d03$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $cCnFQ.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $cCnFQ.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $cCnFQ.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $6382902fe28f8d03$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $6382902fe28f8d03$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $6382902fe28f8d03$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $6382902fe28f8d03$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $6382902fe28f8d03$export$e6bdf135a54e021b,
                    shallowEqual: $6382902fe28f8d03$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $cCnFQ.default)({}, state.formState.values)); // clone to avoid writing
            if ($6382902fe28f8d03$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($6382902fe28f8d03$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $6382902fe28f8d03$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $6382902fe28f8d03$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $cCnFQ.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $cCnFQ.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $6382902fe28f8d03$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $6382902fe28f8d03$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $6382902fe28f8d03$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$6382902fe28f8d03$export$735bebc8ffabf28a]) {
                    var existing = $6382902fe28f8d03$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$6382902fe28f8d03$export$735bebc8ffabf28a] = error[$6382902fe28f8d03$export$735bebc8ffabf28a];
                    merged = $6382902fe28f8d03$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$6382902fe28f8d03$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$6382902fe28f8d03$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $cCnFQ.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $6382902fe28f8d03$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $6382902fe28f8d03$var$notify(fieldSubscriber, fieldState, lastFieldState, $6382902fe28f8d03$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $6382902fe28f8d03$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $cCnFQ.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($6382902fe28f8d03$export$c52e5867d5879e24(formState.values, key), $6382902fe28f8d03$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($6382902fe28f8d03$export$c52e5867d5879e24(formState.values, key), $6382902fe28f8d03$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$6382902fe28f8d03$var$hasAnyError(formState.errors) && !(formState.submitErrors && $6382902fe28f8d03$var$hasAnyError(formState.submitErrors));
        var nextFormState = $6382902fe28f8d03$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $6382902fe28f8d03$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $6382902fe28f8d03$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $6382902fe28f8d03$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $6382902fe28f8d03$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $6382902fe28f8d03$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $6382902fe28f8d03$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $6382902fe28f8d03$var$notify(state.subscribers, nextFormState, lastFormState, $6382902fe28f8d03$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $cCnFQ.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($6382902fe28f8d03$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $cCnFQ.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $cCnFQ.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($6382902fe28f8d03$export$c52e5867d5879e24(formState.values, key), $6382902fe28f8d03$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $6382902fe28f8d03$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $6382902fe28f8d03$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $6382902fe28f8d03$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $6382902fe28f8d03$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $6382902fe28f8d03$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $6382902fe28f8d03$export$c52e5867d5879e24(state.formState.values, name) === $6382902fe28f8d03$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $6382902fe28f8d03$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $6382902fe28f8d03$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $6382902fe28f8d03$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $6382902fe28f8d03$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $6382902fe28f8d03$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $6382902fe28f8d03$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $cCnFQ.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $cCnFQ.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $cCnFQ.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $6382902fe28f8d03$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$6382902fe28f8d03$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $cCnFQ.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $6382902fe28f8d03$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $6382902fe28f8d03$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $6382902fe28f8d03$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $6382902fe28f8d03$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("aJ69w", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cf2e11daeb2c4d8$export$2e2bcd8739ae039);

var $8xGKi = parcelRequire("8xGKi");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $7cf2e11daeb2c4d8$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $7cf2e11daeb2c4d8$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($7cf2e11daeb2c4d8$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $7cf2e11daeb2c4d8$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $8xGKi.getIn)(errors, input.name);
    });
};
//      
var $7cf2e11daeb2c4d8$var$noop = function noop() {};
var $7cf2e11daeb2c4d8$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $7cf2e11daeb2c4d8$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $7cf2e11daeb2c4d8$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $7cf2e11daeb2c4d8$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $7cf2e11daeb2c4d8$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($7cf2e11daeb2c4d8$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$7cf2e11daeb2c4d8$export$2e2bcd8739ae039 = $7cf2e11daeb2c4d8$var$createDecorator;

});

parcelRegister("bVVLH", function(module, exports) {

var $eQSI7 = parcelRequire("eQSI7");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $8b01d42ec4230ca0$var$set(object, path, value) {
    return object == null ? object : $eQSI7(object, path, value);
}
module.exports = $8b01d42ec4230ca0$var$set;

});

parcelRegister("iGjf2", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d963d9b1ad24fdb$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $9d963d9b1ad24fdb$export$2e2bcd8739ae039 = (0, $8P7DW.forwardRef);

});

parcelRegister("4DWzZ", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $b6546ef348bc4496$export$fc06342dc8588d3b);

var $8xGKi = parcelRequire("8xGKi");
const $b6546ef348bc4496$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $8xGKi.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $8xGKi.getIn)(errors, input.name);
    });
};

});


parcelRegister("gFwdR", function(module, exports) {
$parcel$export(module.exports, "default", () => $77607f36010ce223$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $fnhqr = parcelRequire("fnhqr");

var $jgUqy = parcelRequire("jgUqy");

var $iRXci = parcelRequire("iRXci");

var $53Qft = parcelRequire("53Qft");

var $7jDi7 = parcelRequire("7jDi7");

var $jsz0v = parcelRequire("jsz0v");
const $77607f36010ce223$var$fieldWrapperStyles = null;
function $77607f36010ce223$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $77607f36010ce223$var$isFunction(x) {
    return typeof x === 'function';
}
function $77607f36010ce223$var$usePreviousRef(current) {
    const ref = (0, $8P7DW.useRef)(current);
    // will be updated on the next render
    (0, $8P7DW.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $77607f36010ce223$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $77607f36010ce223$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $8P7DW.useContext)((0, $iRXci.FormContext));
    const isDisabled = (0, $8P7DW.useContext)((0, $iRXci.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $77607f36010ce223$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $77607f36010ce223$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$77607f36010ce223$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $8P7DW.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $77607f36010ce223$var$usePreviousRef(state);
    (0, $8P7DW.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $77607f36010ce223$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($77607f36010ce223$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $fnhqr.useId)();
    const fieldId = (0, $8P7DW.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $8n1kL.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $53Qft.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jsz0v.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jgUqy.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $gWgPx.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $7jDi7.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7jDi7.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7jDi7.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7jDi7.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("jgUqy", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $c7f53bf7a8dccc99$export$3c4232819458a302);

var $8P7DW = parcelRequire("8P7DW");
const $c7f53bf7a8dccc99$export$3c4232819458a302 = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);

});

parcelRegister("53Qft", function(module, exports) {
$parcel$export(module.exports, "Label", () => $108f6dad5a61f6b2$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $108f6dad5a61f6b2$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $108f6dad5a61f6b2$var$fieldsetLabelStyles = null;
const $108f6dad5a61f6b2$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $108f6dad5a61f6b2$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("legend", {
        className: (0, $8n1kL.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("7jDi7", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $7b4c1e126047b0c2$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $7b4c1e126047b0c2$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $7b4c1e126047b0c2$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $7b4c1e126047b0c2$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $h82Rb = parcelRequire("h82Rb");

var $joUCG = parcelRequire("joUCG");

var $jgUqy = parcelRequire("jgUqy");
const $7b4c1e126047b0c2$var$messageStyles = null;
const $7b4c1e126047b0c2$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $7b4c1e126047b0c2$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $7b4c1e126047b0c2$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        className: (0, $8n1kL.default)([
            $7b4c1e126047b0c2$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $7b4c1e126047b0c2$var$messageIcons = {
    error: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($joUCG))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
const $7b4c1e126047b0c2$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $7b4c1e126047b0c2$var$messageIcons[appearance];
    const messageRef = (0, $8P7DW.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $8P7DW.useState)(false);
    const { isWrapper: isWrapper } = (0, $8P7DW.useContext)($7b4c1e126047b0c2$var$MessageWrapperContext);
    (0, $8P7DW.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $8n1kL.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $7b4c1e126047b0c2$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $gWgPx.jsx)($7b4c1e126047b0c2$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $7b4c1e126047b0c2$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $jgUqy.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gWgPx.jsx)($7b4c1e126047b0c2$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $7b4c1e126047b0c2$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $jgUqy.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gWgPx.jsx)($7b4c1e126047b0c2$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $7b4c1e126047b0c2$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $jgUqy.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $gWgPx.jsx)($7b4c1e126047b0c2$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $7b4c1e126047b0c2$var$MessageWrapperContext = /*#__PURE__*/ (0, $8P7DW.createContext)({
    isWrapper: false
});
const $7b4c1e126047b0c2$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)($7b4c1e126047b0c2$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});

parcelRegister("jsz0v", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ea07623b00c91f8$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $8ea07623b00c91f8$var$requiredIndicatorStyles = null;
function $8ea07623b00c91f8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $8n1kL.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("zTiMK", function(module, exports) {
$parcel$export(module.exports, "useResizingHeight", () => $077d5a83441766b0$export$da99457d6430d83);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $jh41u = parcelRequire("jh41u");

var $j1C0s = parcelRequire("j1C0s");

var $41dEz = parcelRequire("41dEz");

var $htHd6 = parcelRequire("htHd6");

var $1c0tT = parcelRequire("1c0tT");

var $kgdFP = parcelRequire("kgdFP");

var $1JkUK = parcelRequire("1JkUK");
const $077d5a83441766b0$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $41dEz.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $j1C0s.easeInOut) } = {})=>{
    const prevDimensions = (0, $8P7DW.useRef)();
    const [element, setElementRef] = (0, $1c0tT.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $htHd6.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $htHd6.useRequestAnimationFrame)();
    (0, $1JkUK.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jh41u.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $kgdFP.useLayoutEffect)(()=>{
        if ((0, $jh41u.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $077d5a83441766b0$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $077d5a83441766b0$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Fragment), {
        children: children(resizing)
    });
};

});
parcelRegister("j1C0s", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $ae4f23d5c4c5c6a6$export$c07234257a03d5e9);
$parcel$export(module.exports, "easeOut", () => $ae4f23d5c4c5c6a6$export$57636bb43b1ccbb0);
const $ae4f23d5c4c5c6a6$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $ae4f23d5c4c5c6a6$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $ae4f23d5c4c5c6a6$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $ae4f23d5c4c5c6a6$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $ae4f23d5c4c5c6a6$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $ae4f23d5c4c5c6a6$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $ae4f23d5c4c5c6a6$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});

parcelRegister("1c0tT", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $2e6dc29076ad4746$export$ff879f35a69d56b7);

var $8P7DW = parcelRequire("8P7DW");
const $2e6dc29076ad4746$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $8P7DW.useRef)(null);
    const setRef = (0, $8P7DW.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("1JkUK", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $d85c5d18bbb7e497$export$9e95200239cd148b);

var $8P7DW = parcelRequire("8P7DW");

var $kgdFP = parcelRequire("kgdFP");
const $d85c5d18bbb7e497$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $8P7DW.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $kgdFP.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("eDzJd", function(module, exports) {
$parcel$export(module.exports, "default", () => $41ebacc7a880fe53$export$2e2bcd8739ae039);
/* FeedbackScoreButtons.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $izQyW = parcelRequire("izQyW");

var $9pb7J = parcelRequire("9pb7J");

var $ea6bZ = parcelRequire("ea6bZ");
const $41ebacc7a880fe53$var$tooltipMessage = [
    'Strongly disagree',
    'Disagree',
    'Slightly disagree',
    'Neutral',
    'Slightly agree',
    'Agree',
    'Strongly agree'
];
const $41ebacc7a880fe53$var$buttonWrapperStyles = null;
const $41ebacc7a880fe53$var$descriptionWrapperStyles = null;
var $41ebacc7a880fe53$export$2e2bcd8739ae039 = ({ onChange: onChange, value: value })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    "_1e0c1txw _1bah1yb4 _zdxokb7n _v5ynkb7n _13lsf1ug _1o0a1h6o _pof3u2gc"
                ]),
                children: Array.from({
                    length: 7
                }, (_, i)=>{
                    const score = i + 1;
                    const isSelected = value === score;
                    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ea6bZ.default), {
                        content: $41ebacc7a880fe53$var$tooltipMessage[i],
                        hideTooltipOnClick: true,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                            onClick: ()=>onChange(score),
                            isSelected: isSelected,
                            "aria-pressed": isSelected,
                            "aria-describedby": "contextualSurveyStatement",
                            "aria-label": $41ebacc7a880fe53$var$tooltipMessage[i],
                            shouldFitContainer: true,
                            children: score
                        })
                    }, score);
                })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                "aria-hidden": true,
                className: (0, $8n1kL.default)([
                    "_1e0c1txw _19pku2gc _otyr1ejb _1bah1yb4 _nbgx1epz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "start",
                        children: "Strongly disagree"
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "center",
                        children: "Neutral"
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "end",
                        children: "Strongly agree"
                    })
                ]
            })
        ]
    });

});

parcelRegister("59gD4", function(module, exports) {
$parcel$export(module.exports, "SurveyFormExpandedFeedback", () => $e9ad6d556c48e041$export$103c6e57bfbd4a99);
/* SurveyFormExpandedFeedback.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $izQyW = parcelRequire("izQyW");

var $esBnn = parcelRequire("esBnn");

var $lp3MR = parcelRequire("lp3MR");
var $gFwdR = parcelRequire("gFwdR");
var $793wC = parcelRequire("793wC");

var $anGNL = parcelRequire("anGNL");
function $e9ad6d556c48e041$export$103c6e57bfbd4a99({ canContactDefault: canContactDefault, onFeedbackChange: onFeedbackChange, submitting: submitting, textLabel: textLabel, textPlaceholder: textPlaceholder }) {
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gFwdR.default), {
                name: "writtenFeedback",
                defaultValue: "",
                isDisabled: submitting,
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $anGNL.default), {
                        ...fieldProps,
                        "aria-label": textLabel,
                        placeholder: textPlaceholder,
                        onChange: (event)=>{
                            fieldProps.onChange(event);
                            onFeedbackChange();
                        }
                    })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lp3MR.default), {
                name: "canContact",
                isDisabled: submitting,
                defaultIsChecked: canContactDefault,
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $esBnn.default), {
                        ...fieldProps,
                        label: "Atlassian can contact me about this feedback"
                    })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $793wC.default), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                    type: "submit",
                    appearance: "primary",
                    isLoading: submitting,
                    children: "Submit"
                })
            })
        ]
    });
}

});
parcelRegister("esBnn", function(module, exports) {
$parcel$export(module.exports, "default", () => $67a4e5a5fa1c9fc6$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $aeYmt = parcelRequire("aeYmt");

var $klxUK = parcelRequire("klxUK");

var $2ONf8 = parcelRequire("2ONf8");

var $aELr5 = parcelRequire("aELr5");

var $1PriI = parcelRequire("1PriI");

var $gNNF2 = parcelRequire("gNNF2");
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ const $67a4e5a5fa1c9fc6$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $67a4e5a5fa1c9fc6$var$Checkbox = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $8P7DW.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $8P7DW.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $8P7DW.useRef)(null);
    const mergedRefs = (0, $klxUK.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $8P7DW.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $aELr5.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
                // It is necessary only for Safari. It allows to render focus styles.
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $8n1kL.default)([
                    $67a4e5a5fa1c9fc6$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2ONf8.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $1PriI.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gNNF2.default), {})
                ]
            })
        ]
    });
}));
$67a4e5a5fa1c9fc6$var$Checkbox.displayName = 'Checkbox';
var $67a4e5a5fa1c9fc6$export$2e2bcd8739ae039 = $67a4e5a5fa1c9fc6$var$Checkbox;

});
parcelRegister("2ONf8", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddfca6cd12930d11$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ const $ddfca6cd12930d11$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $ddfca6cd12930d11$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $ddfca6cd12930d11$var$CheckboxIcon = /*#__PURE__*/ (0, $8P7DW.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $8P7DW.useMemo)(()=>$ddfca6cd12930d11$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $8n1kL.default)([
            $ddfca6cd12930d11$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $8n1kL.default)([
                        $ddfca6cd12930d11$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
var $ddfca6cd12930d11$export$2e2bcd8739ae039 = $ddfca6cd12930d11$var$CheckboxIcon;

});

parcelRegister("aELr5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3932574c14f9319e$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
/**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ const $3932574c14f9319e$var$baseStyles = null;
const $3932574c14f9319e$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
const $3932574c14f9319e$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
const $3932574c14f9319e$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
const $3932574c14f9319e$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
const $3932574c14f9319e$var$disabledCheckedStyles = null;
function $3932574c14f9319e$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("label", {
        className: (0, $8n1kL.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1gmx _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("1PriI", function(module, exports) {
$parcel$export(module.exports, "default", () => $c21f856280c7884a$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $c21f856280c7884a$var$labelTextStyles = null;
function $c21f856280c7884a$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        className: (0, $8n1kL.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("gNNF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $87d7d743afd1722e$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $87d7d743afd1722e$var$requiredIndicatorStyles = null;
function $87d7d743afd1722e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "aria-hidden": true,
        className: (0, $8n1kL.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("lp3MR", function(module, exports) {
$parcel$export(module.exports, "default", () => $362a2b7e3356ee1f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $gFwdR = parcelRequire("gFwdR");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $362a2b7e3356ee1f$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $8P7DW.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gFwdR.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gFwdR.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
var $362a2b7e3356ee1f$export$2e2bcd8739ae039 = $362a2b7e3356ee1f$var$CheckboxField;

});

parcelRegister("793wC", function(module, exports) {
$parcel$export(module.exports, "default", () => $46352aab1fa60192$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $46352aab1fa60192$var$formFooterWrapperStyles = null;
const $46352aab1fa60192$var$justifyContentStyles = null;
function $46352aab1fa60192$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("footer", {
        className: (0, $8n1kL.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("anGNL", function(module, exports) {
$parcel$export(module.exports, "default", () => $12602033f2736c9f$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");
var $77UGK = parcelRequire("77UGK");

var $8P7DW = parcelRequire("8P7DW");

var $aeYmt = parcelRequire("aeYmt");

var $e6Qdr = parcelRequire("e6Qdr");
const $12602033f2736c9f$var$packageName = undefined;
const $12602033f2736c9f$var$packageVersion = undefined;
const $12602033f2736c9f$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $12602033f2736c9f$var$packageName,
    packageVersion: $12602033f2736c9f$var$packageVersion
};
const $12602033f2736c9f$var$lineHeightBase = 20;
const $12602033f2736c9f$var$lineHeightCompact = 16;
const $12602033f2736c9f$var$compactVerticalPadding = 2;
const $12602033f2736c9f$var$verticalPadding = 6;
const $12602033f2736c9f$var$transitionDuration = '0.2s';
const $12602033f2736c9f$var$borderWidth = 2;
const $12602033f2736c9f$var$baseStyles = null;
const $12602033f2736c9f$var$baseStylesT26Shape = null;
const $12602033f2736c9f$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $12602033f2736c9f$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $12602033f2736c9f$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $12602033f2736c9f$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $12602033f2736c9f$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $12602033f2736c9f$var$InnerTextArea = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const ourRef = (0, $8P7DW.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $8P7DW.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $12602033f2736c9f$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$12602033f2736c9f$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$12602033f2736c9f$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $8P7DW.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $12602033f2736c9f$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $8n1kL.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $12602033f2736c9f$var$appearanceStyles[appearance],
            $12602033f2736c9f$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $12602033f2736c9f$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $77UGK.default)($12602033f2736c9f$var$lineHeightCompact * minimumRows + $12602033f2736c9f$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $77UGK.default)($12602033f2736c9f$var$lineHeightBase * minimumRows + $12602033f2736c9f$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $12602033f2736c9f$var$TextArea = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)($12602033f2736c9f$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$12602033f2736c9f$var$TextArea.displayName = 'TextArea';
var $12602033f2736c9f$export$2e2bcd8739ae039 = $12602033f2736c9f$var$TextArea;

});
parcelRegister("77UGK", function(module, exports) {
$parcel$export(module.exports, "default", () => $530529012ea32229$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $530529012ea32229$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});




parcelRegister("bfUNn", function(module, exports) {
$parcel$export(module.exports, "default", () => $72b6384f3083515d$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $72b6384f3083515d$export$4e7f196112fea3c5 = 27;
function $72b6384f3083515d$var$bind(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function unbind() {
        target.removeEventListener(eventName, handler, options);
    };
}
function $72b6384f3083515d$var$shouldDismiss(target) {
    if (!target) return true;
    if (!(target instanceof HTMLElement)) return true;
    // Closest doesn't exist for ie11
    // Because we cannot be sure if in a text area - just don't allow dismissing
    if (!target.closest) return false;
    const inTextArea = Boolean(target.closest('textarea'));
    // Allow dismissing if not in a textarea
    return !inTextArea;
}
function $72b6384f3083515d$export$2e2bcd8739ae039({ onDismiss: onDismiss }) {
    const onDismissRef = (0, $8P7DW.useRef)(onDismiss);
    // Defensively accounting for consumer passing in a new function
    // each time. We just want to call the latest one
    (0, $8P7DW.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    (0, $8P7DW.useEffect)(()=>{
        let unbind;
        function onKeyDown(event) {
            if (event.keyCode !== $72b6384f3083515d$export$4e7f196112fea3c5) return;
            // Escape pressed
            // We don't want to close if the user is typing in the text area
            if (!$72b6384f3083515d$var$shouldDismiss(event.target)) return;
            if (unbind) // only want to call dismiss once
            unbind();
            onDismissRef.current();
        }
        unbind = $72b6384f3083515d$var$bind(window, 'keydown', // @ts-ignore: the typescript for this is lame
        onKeyDown, {
            passive: true
        });
        // double calls to unbind is fine
        return unbind;
    }, []);
}

});





parcelRegister("aA7IK", function(module, exports) {
$parcel$export(module.exports, "FlagWithEvents", () => $7b73a89d3578b6f5$export$8423d11067fbf579);
$parcel$export(module.exports, "default", () => $7b73a89d3578b6f5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Flag", () => (parcelRequire("bFCX7")).default);

var $jVcUb = parcelRequire("jVcUb");

var $1S5XV = parcelRequire("1S5XV");

var $bFCX7 = parcelRequire("bFCX7");
const $7b73a89d3578b6f5$export$8423d11067fbf579 = (0, $jVcUb.default)((0, $bFCX7.default));
var $7b73a89d3578b6f5$export$2e2bcd8739ae039 = (0, $1S5XV.default)($7b73a89d3578b6f5$export$8423d11067fbf579, 'flag');

});
parcelRegister("bFCX7", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e558235f957ec23$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $7PRFC = parcelRequire("7PRFC");

var $h5gSD = parcelRequire("h5gSD");
var $gvxin = parcelRequire("gvxin");

var $NOHe8 = parcelRequire("NOHe8");

var $5wcJE = parcelRequire("5wcJE");

var $84l0s = parcelRequire("84l0s");
class $9e558235f957ec23$export$2e2bcd8739ae039 extends (0, $8P7DW.Component) {
    static #_ = this.defaultProps = {
        fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($7PRFC))),
        primaryText: null,
        primaryAction: null,
        secondaryText: null,
        secondaryAction: null,
        icon: 'smallInfo'
    };
    onClickActionHandler(action) {
        if (action && action.type === (0, $NOHe8.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
    }
    render() {
        const { title: title, body: body, primaryText: primaryText, secondaryText: secondaryText, icon: icon } = this.props;
        const actions = [
            {
                content: primaryText,
                onClick: this.onPrimaryClick
            }
        ];
        if (secondaryText) actions.push({
            content: secondaryText,
            onClick: this.onSecondaryClick
        });
        const selectedIcon = (0, $84l0s.default)[icon];
        const FlagIconComponent = selectedIcon && selectedIcon.component;
        const FlagIcon = FlagIconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(FlagIconComponent, {
            label: selectedIcon.label,
            color: selectedIcon.color,
            spacing: "spacious"
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gvxin.default), {
            onDismissed: this.onDismiss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $h5gSD.default), {
            id: "engagement-flag",
            appearance: "normal",
            icon: FlagIcon,
            title: title,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5wcJE.default), {
                html: body
            }),
            actions: actions
        }));
    }
    constructor(...args){
        super(...args), this.onDismiss = ()=>{
            this.props.fireClickEvent('dismiss');
        }, this.onPrimaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, primaryAction: primaryAction } = this.props;
            fireClickEvent('primary');
            this.onClickActionHandler(primaryAction);
        }, this.onSecondaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, secondaryAction: secondaryAction } = this.props;
            fireClickEvent('secondary');
            this.onClickActionHandler(secondaryAction);
        };
    }
}

});
parcelRegister("NOHe8", function(module, exports) {
$parcel$export(module.exports, "buttonActionTypes", () => $9cef6e90d601a936$export$e7d79186651244da);
const $9cef6e90d601a936$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("5wcJE", function(module, exports) {
$parcel$export(module.exports, "default", () => $d60242380c987ef5$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
class $d60242380c987ef5$export$2e2bcd8739ae039 extends (0, $8P7DW.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("84l0s", function(module, exports) {
$parcel$export(module.exports, "default", () => $62e6ae3d809d8207$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-relative-package-imports, @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/entry-points, @atlassian/tangerine/import/no-parent-imports */ 
var $htAFR = parcelRequire("htAFR");

var $aflyD = parcelRequire("aflyD");

var $131To = parcelRequire("131To");

var $3EfHm = parcelRequire("3EfHm");

var $h82Rb = parcelRequire("h82Rb");

var $ebnVy = parcelRequire("ebnVy");

var $gKWTh = parcelRequire("gKWTh");
const $62e6ae3d809d8207$var$flagMapping = {
    success: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($htAFR))),
        label: 'success',
        color: "var(--ds-icon-success, #6A9A23)"
    },
    error: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))),
        label: 'error',
        color: "var(--ds-icon-danger, #C9372C)"
    },
    info: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ebnVy))),
        label: 'info',
        color: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gKWTh))),
        label: 'warning',
        color: "var(--ds-icon-warning, #E06C00)"
    },
    smallInfo: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ebnVy))),
        label: 'info',
        color: "var(--ds-icon-discovery, #AF59E1)"
    },
    comment: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($aflyD))),
        label: 'comment',
        color: "var(--ds-icon, #292A2E)"
    },
    download: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($131To))),
        label: 'download',
        color: "var(--ds-icon, #292A2E)"
    },
    feedback: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3EfHm))),
        label: 'comment',
        color: "var(--ds-icon, #292A2E)"
    }
};
var $62e6ae3d809d8207$export$2e2bcd8739ae039 = $62e6ae3d809d8207$var$flagMapping;

});
parcelRegister("htAFR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d66a24f642488d17115358045c30773>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb9197d602e00679$var$_react = $cb9197d602e00679$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $cb9197d602e00679$var$_baseNew = $cb9197d602e00679$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $cb9197d602e00679$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb9197d602e00679$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $cb9197d602e00679$var$_react.default.createElement($cb9197d602e00679$var$_baseNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$cb9197d602e00679$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $cb9197d602e00679$var$_default = module.exports.default = $cb9197d602e00679$var$CheckCircleIcon;

});

parcelRegister("aflyD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33181fb6c3dda951a22e3b4873cc95fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $775c0702eeffbd82$var$_react = $775c0702eeffbd82$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $775c0702eeffbd82$var$_baseNew = $775c0702eeffbd82$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $775c0702eeffbd82$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $775c0702eeffbd82$var$CommentIcon = (props)=>/*#__PURE__*/ $775c0702eeffbd82$var$_react.default.createElement($775c0702eeffbd82$var$_baseNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$775c0702eeffbd82$var$CommentIcon.displayName = 'CommentIcon';
var $775c0702eeffbd82$var$_default = module.exports.default = $775c0702eeffbd82$var$CommentIcon;

});

parcelRegister("131To", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::856226f5e73dfc11c44d43d912e311e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c378a0ef0ee80b3$var$_react = $0c378a0ef0ee80b3$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $0c378a0ef0ee80b3$var$_baseNew = $0c378a0ef0ee80b3$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $0c378a0ef0ee80b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c378a0ef0ee80b3$var$DownloadIcon = (props)=>/*#__PURE__*/ $0c378a0ef0ee80b3$var$_react.default.createElement($0c378a0ef0ee80b3$var$_baseNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$0c378a0ef0ee80b3$var$DownloadIcon.displayName = 'DownloadIcon';
var $0c378a0ef0ee80b3$var$_default = module.exports.default = $0c378a0ef0ee80b3$var$DownloadIcon;

});

parcelRegister("3EfHm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0442f8372c8ab0b117b1651de731ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a8148df54a1d905$var$_react = $2a8148df54a1d905$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $2a8148df54a1d905$var$_baseNew = $2a8148df54a1d905$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $2a8148df54a1d905$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a8148df54a1d905$var$FeedbackIcon = (props)=>/*#__PURE__*/ $2a8148df54a1d905$var$_react.default.createElement($2a8148df54a1d905$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$2a8148df54a1d905$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $2a8148df54a1d905$var$_default = module.exports.default = $2a8148df54a1d905$var$FeedbackIcon;

});




parcelRegister("9fVHa", function(module, exports) {
$parcel$export(module.exports, "ModalDialogWithEvents", () => $5d7286b220a6b86a$export$404a075b2b026e91);
$parcel$export(module.exports, "default", () => $5d7286b220a6b86a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ModalDialog", () => (parcelRequire("ajIg3")).default);

var $jVcUb = parcelRequire("jVcUb");

var $1S5XV = parcelRequire("1S5XV");

var $ajIg3 = parcelRequire("ajIg3");
const $5d7286b220a6b86a$export$404a075b2b026e91 = (0, $jVcUb.default)((0, $ajIg3.default));
var $5d7286b220a6b86a$export$2e2bcd8739ae039 = (0, $1S5XV.default)($5d7286b220a6b86a$export$404a075b2b026e91, 'modalDialog');

});
parcelRegister("ajIg3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d5061486271c48b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $6KCNM = parcelRequire("6KCNM");

var $NOHe8 = parcelRequire("NOHe8");

var $5wcJE = parcelRequire("5wcJE");
function $6d5061486271c48b$var$header() {
    return null;
}
class $6d5061486271c48b$export$2e2bcd8739ae039 extends (0, $8P7DW.Component) {
    getActionButton(action, text, onClick) {
        return {
            text: text,
            onClick: (e)=>{
                if (action.type === (0, $NOHe8.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
                onClick(e);
            }
        };
    }
    getActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (primaryAction && primaryText) actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
        if (secondaryAction && secondaryText) actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
        return actions;
    }
    getAdditionalModalProps() {
        const props = {};
        const { imageSrc: imageSrc } = this.props;
        if (imageSrc) props.image = imageSrc;
        else props.header = $6d5061486271c48b$var$header;
        return props;
    }
    render() {
        const { title: title, body: body } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6KCNM.default), {
            actions: this.getActions(),
            heading: title,
            ...this.getAdditionalModalProps()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5wcJE.default), {
            html: body
        }));
    }
    constructor(...args){
        super(...args), this.onPrimaryAction = ()=>{
            this.props.fireClickEvent('primary');
        }, this.onSecondaryAction = ()=>{
            this.props.fireClickEvent('secondary');
        };
    }
}

});
parcelRegister("6KCNM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6fe2c584c644ed6b$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $iFxfe = parcelRequire("iFxfe");
var $kmgdt = parcelRequire("kmgdt");

var $gtaKc = parcelRequire("gtaKc");
var $7KiOn = parcelRequire("7KiOn");
var $4pgQo = parcelRequire("4pgQo");

var $e3bZD = parcelRequire("e3bZD");

var $aPQZD = parcelRequire("aPQZD");
class $6fe2c584c644ed6b$export$2e2bcd8739ae039 extends (0, $8P7DW.Component) {
    render() {
        const { actions: _actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $4pgQo.useModal)();
            return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $e3bZD.ModalHeading), {
                id: titleId,
                children: heading
            });
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gtaKc.default), {
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest,
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)(Header, {}),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7KiOn.default), {
                    children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $e3bZD.ModalBody), {
                        children: [
                            heading && /*#__PURE__*/ (0, $gWgPx.jsx)(CustomHeader, {}),
                            children
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)(Footer, {})
            ]
        }));
    }
    constructor(...args){
        super(...args), this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $e3bZD.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        }, this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $kmgdt.default).Provider, {
                    value: (0, $aPQZD.modalButtonTheme),
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $e3bZD.ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight,
                        children: actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                            const variant = idx ? 'subtle-link' : 'primary';
                            return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $e3bZD.ModalActionItem), {
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iFxfe.default), {
                                    appearance: variant,
                                    autoFocus: !idx,
                                    ...rest,
                                    children: text
                                })
                            }, key || (typeof text === 'string' ? text : `${idx}`));
                        })
                    })
                }) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("gtaKc", function(module, exports) {
$parcel$export(module.exports, "default", () => $a39613023fdb4b3b$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $g2y1V = parcelRequire("g2y1V");
function $a39613023fdb4b3b$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $g2y1V.default), {
        ...props,
        isFullScreen: false
    });
}

});
parcelRegister("g2y1V", function(module, exports) {
$parcel$export(module.exports, "default", () => $10364dc88f6dfc9f$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $a6e46 = parcelRequire("a6e46");

var $LNry5 = parcelRequire("LNry5");

var $aeYmt = parcelRequire("aeYmt");

var $cBdFf = parcelRequire("cBdFf");

var $5J6r2 = parcelRequire("5J6r2");

var $l8Ymd = parcelRequire("l8Ymd");

var $egphw = parcelRequire("egphw");

var $buhve = parcelRequire("buhve");

var $bT4U6 = parcelRequire("bT4U6");

var $e6Qdr = parcelRequire("e6Qdr");

var $1NJBM = parcelRequire("1NJBM");

var $2nrNX = parcelRequire("2nrNX");

var $9Bp8K = parcelRequire("9Bp8K");

var $7ElSq = parcelRequire("7ElSq");

var $6vjQ2 = parcelRequire("6vjQ2");
const $10364dc88f6dfc9f$var$fillScreenStyles = null;
const $10364dc88f6dfc9f$var$allowlistElements = (element, callback)=>{
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $10364dc88f6dfc9f$var$InternalModalWrapper = (props)=>{
    const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $5J6r2.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen } = props;
    const calculatedStackIndex = (0, $9Bp8K.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    // When flag is true and a ref is not supplied, autofocus is true. See https://product-fabric.atlassian.net/browse/DSP-24307
    // When we remove boolean `autoFocus`, we won't have to worry about this
    const autoFocusLock = (0, $e6Qdr.fg)('platform_dst_autofocus-never-false-2') ? typeof autoFocus === 'boolean' : typeof autoFocus === 'boolean' ? autoFocus : false;
    const onCloseHandler = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $5J6r2.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: undefined,
        packageVersion: undefined
    });
    const onBlanketClicked = (0, $8P7DW.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    const allowListCallback = (0, $8P7DW.useCallback)((element)=>$10364dc88f6dfc9f$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    (0, $7ElSq.default)();
    (0, $egphw.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Modal dialog is conditionally rendered when visible, so when this runs it is always open.
        isOpen: true,
        // Passing a no-op for now, as there isn't a real use case for closing the modal dialog programmatically
        // by the OpenLayerObserver. The only current use case is closing layers when resizing the nav layout,
        // which cannot happen while a modal dialog is open.
        onClose: (0, $5J6r2.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBdFf.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6vjQ2.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen,
            children: children
        })
    });
    let returnFocus = true;
    let onDeactivation = (0, $5J6r2.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $l8Ymd.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1NJBM.default), {
            zIndex: (0, $2nrNX.layers).modal(),
            children: (0, $e6Qdr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $buhve.default), {
                enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    "aria-hidden": !isForeground,
                    className: (0, $8n1kL.default)([
                        "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
                    ]),
                    children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $a6e46.default), {
                        autoFocus: autoFocusLock,
                        returnFocus: returnFocus,
                        onDeactivation: onDeactivation,
                        whiteList: allowListCallback,
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LNry5))), {}),
                            shouldScrollInViewport ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $LNry5.TouchScrollable), {
                                children: modalDialogWithBlanket
                            }) : modalDialogWithBlanket
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bT4U6.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        ...fadeInProps,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: (0, $8n1kL.default)([
                            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $a6e46.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LNry5))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $LNry5.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
};
var $10364dc88f6dfc9f$export$2e2bcd8739ae039 = $10364dc88f6dfc9f$var$InternalModalWrapper;

});
parcelRegister("a6e46", function(module, exports) {
$parcel$export(module.exports, "default", () => $75a55ffbe3a9d484$export$2e2bcd8739ae039);

var $7cMfH = parcelRequire("7cMfH");

var $75a55ffbe3a9d484$export$2e2bcd8739ae039 = (0, $7cMfH.default);

});
parcelRegister("7cMfH", function(module, exports) {
$parcel$export(module.exports, "default", () => $53ef15482b8dc39d$export$2e2bcd8739ae039);

var $911Xe = parcelRequire("911Xe");

var $cCnFQ = parcelRequire("cCnFQ");

var $8P7DW = parcelRequire("8P7DW");

var $2rVdk = parcelRequire("2rVdk");

var $cjVnW = parcelRequire("cjVnW");
var $53ef15482b8dc39d$var$FocusLockCombination = /*#__PURE__*/ $8P7DW.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $8P7DW.createElement((0, $2rVdk.default), (0, $cCnFQ.default)({
        sideCar: (0, $cjVnW.default),
        ref: ref
    }, props));
});
var $53ef15482b8dc39d$var$_ref = (0, $2rVdk.default).propTypes || {}, $53ef15482b8dc39d$var$sideCar = $53ef15482b8dc39d$var$_ref.sideCar, $53ef15482b8dc39d$var$propTypes = (0, $911Xe.default)($53ef15482b8dc39d$var$_ref, [
    "sideCar"
]);
$53ef15482b8dc39d$var$FocusLockCombination.propTypes = {};
var $53ef15482b8dc39d$export$2e2bcd8739ae039 = $53ef15482b8dc39d$var$FocusLockCombination;

});
parcelRegister("2rVdk", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c8a7bea33594532$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");

var $8P7DW = parcelRequire("8P7DW");


var $4co8y = parcelRequire("4co8y");

var $b0nWD = parcelRequire("b0nWD");

var $8fTwx = parcelRequire("8fTwx");

var $4Iwox = parcelRequire("4Iwox");

var $1hLB2 = parcelRequire("1hLB2");
var $1c8a7bea33594532$var$emptyArray = [];
var $1c8a7bea33594532$var$FocusLock = /*#__PURE__*/ $8P7DW.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $8P7DW.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $8P7DW.useRef();
    var isActive = $8P7DW.useRef(false);
    var originalFocusedElement = $8P7DW.useRef(null);
    var _React$useState2 = $8P7DW.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $1c8a7bea33594532$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $8P7DW.useState({}), id = _React$useState3[0];
    var onActivation = $8P7DW.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $8P7DW.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $8P7DW.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $8P7DW.useCallback(function(event) {
        if (isActive.current) (0, $4Iwox.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $4Iwox.mediumBlur).useMedium;
    var setObserveNode = $8P7DW.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $cCnFQ.default)((_extends2 = {}, _extends2[$4co8y.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$4co8y.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $b0nWD.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $8P7DW.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $8P7DW.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $8fTwx.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $8P7DW.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $8fTwx.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $8P7DW.createElement(SideCar, {
        id: id,
        sideCar: (0, $4Iwox.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $8P7DW.createElement(Container, (0, $cCnFQ.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $8P7DW.createElement((0, $1hLB2.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $8P7DW.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $8fTwx.hiddenGuard)
    }));
});
$1c8a7bea33594532$var$FocusLock.propTypes = {};
var $1c8a7bea33594532$export$2e2bcd8739ae039 = $1c8a7bea33594532$var$FocusLock;

});
parcelRegister("4co8y", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $30eb017d32532e9b$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $30eb017d32532e9b$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $30eb017d32532e9b$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $30eb017d32532e9b$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $30eb017d32532e9b$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $30eb017d32532e9b$export$4f9a06cb7441a087 = 'data-focus-lock';
var $30eb017d32532e9b$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $30eb017d32532e9b$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $30eb017d32532e9b$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $30eb017d32532e9b$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("b0nWD", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $803244bdc2b2f565$export$74665b213cb5c4cf);

var $8P7DW = parcelRequire("8P7DW");

var $fOjcf = parcelRequire("fOjcf");

var $jlHRB = parcelRequire("jlHRB");
var $803244bdc2b2f565$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $8P7DW.useLayoutEffect : $8P7DW.useEffect;
var $803244bdc2b2f565$var$currentValues = new WeakMap();
function $803244bdc2b2f565$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $jlHRB.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $fOjcf.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $803244bdc2b2f565$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $803244bdc2b2f565$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $fOjcf.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $fOjcf.assignRef)(ref, current_1);
            });
        }
        $803244bdc2b2f565$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("fOjcf", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $b82a6a89bba1f3de$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $b82a6a89bba1f3de$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("jlHRB", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $e16200dc8f894170$export$25bec8c6f54ee79a);

var $8P7DW = parcelRequire("8P7DW");
function $e16200dc8f894170$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $8P7DW.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("8fTwx", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $602acb5584718ffa$export$b8c7b07253306600);

var $8P7DW = parcelRequire("8P7DW");

var $602acb5584718ffa$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $602acb5584718ffa$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $602acb5584718ffa$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $8P7DW.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $602acb5584718ffa$export$b8c7b07253306600
    }));
};
$602acb5584718ffa$var$InFocusGuard.propTypes = {};
var $602acb5584718ffa$export$2e2bcd8739ae039 = $602acb5584718ffa$var$InFocusGuard;

});

parcelRegister("4Iwox", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $36f4666314b815e6$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $36f4666314b815e6$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $36f4666314b815e6$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $36f4666314b815e6$export$892cbf28e5518020);

var $1UdaV = parcelRequire("1UdaV");
var $36f4666314b815e6$export$5733e022b1d538cb = (0, $1UdaV.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $36f4666314b815e6$export$b3e9a9312f73723c = (0, $1UdaV.createMedium)();
var $36f4666314b815e6$export$3a1d52767cbc07b8 = (0, $1UdaV.createMedium)();
var $36f4666314b815e6$export$892cbf28e5518020 = (0, $1UdaV.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("1UdaV", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $16353db7ee1a79c6$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $16353db7ee1a79c6$export$e13ec7dd7a14088d);

var $26Yns = parcelRequire("26Yns");
function $16353db7ee1a79c6$var$ItoI(a) {
    return a;
}
function $16353db7ee1a79c6$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $16353db7ee1a79c6$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $16353db7ee1a79c6$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $16353db7ee1a79c6$var$ItoI;
    return $16353db7ee1a79c6$var$innerCreateMedium(defaults, middleware);
}
function $16353db7ee1a79c6$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $16353db7ee1a79c6$var$innerCreateMedium(null);
    medium.options = (0, $26Yns.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("1hLB2", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $0efc4c9ab22c33f0$export$f5272e9b1168239c);

var $8P7DW = parcelRequire("8P7DW");
var $0efc4c9ab22c33f0$export$f5272e9b1168239c = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);

});


parcelRegister("cjVnW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f83c5e5be8f8c0b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");


var $7jPL5 = parcelRequire("7jPL5");

var $lPbQi = parcelRequire("lPbQi");
var $3sW1G = parcelRequire("3sW1G");
var $132Hv = parcelRequire("132Hv");
var $ciroK = parcelRequire("ciroK");
var $jFxbd = parcelRequire("jFxbd");parcelRequire("jaGI3");
var $7pRMw = parcelRequire("7pRMw");

var $frDl2 = parcelRequire("frDl2");

var $4Iwox = parcelRequire("4Iwox");
var $8f83c5e5be8f8c0b$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $8f83c5e5be8f8c0b$var$isFreeFocus = function isFreeFocus() {
    return $8f83c5e5be8f8c0b$var$focusOnBody() || (0, $jFxbd.focusIsHidden)();
};
var $8f83c5e5be8f8c0b$var$lastActiveTrap = null;
var $8f83c5e5be8f8c0b$var$lastActiveFocus = null;
var $8f83c5e5be8f8c0b$var$lastPortaledElement = null;
var $8f83c5e5be8f8c0b$var$focusWasOutsideWindow = false;
var $8f83c5e5be8f8c0b$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $8f83c5e5be8f8c0b$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($8f83c5e5be8f8c0b$var$lastActiveTrap.whiteList || $8f83c5e5be8f8c0b$var$defaultWhitelist)(activeElement);
};
var $8f83c5e5be8f8c0b$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $8f83c5e5be8f8c0b$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $8f83c5e5be8f8c0b$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $8f83c5e5be8f8c0b$var$lastPortaledElement && $8f83c5e5be8f8c0b$var$lastPortaledElement.portaledElement === element;
};
function $8f83c5e5be8f8c0b$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $8f83c5e5be8f8c0b$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($8f83c5e5be8f8c0b$var$focusWasOutsideWindow);
    return $8f83c5e5be8f8c0b$var$focusWasOutsideWindow === 'meanwhile';
};
var $8f83c5e5be8f8c0b$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $8f83c5e5be8f8c0b$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $8f83c5e5be8f8c0b$var$checkInHost(activeElement, area, area);
    });
};
var $8f83c5e5be8f8c0b$var$activateTrap = function activateTrap() {
    var result = false;
    if ($8f83c5e5be8f8c0b$var$lastActiveTrap) {
        var _lastActiveTrap = $8f83c5e5be8f8c0b$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $8f83c5e5be8f8c0b$var$lastPortaledElement && $8f83c5e5be8f8c0b$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $frDl2.extractRef)).filter(Boolean));
            if (!activeElement || $8f83c5e5be8f8c0b$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $8f83c5e5be8f8c0b$var$focusWasOutside(crossFrame) || !$8f83c5e5be8f8c0b$var$isFreeFocus() || !$8f83c5e5be8f8c0b$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $ciroK.focusInside)(workingArea) || activeElement && $8f83c5e5be8f8c0b$var$withinHost(activeElement, workingArea) || $8f83c5e5be8f8c0b$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$8f83c5e5be8f8c0b$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $7pRMw.moveFocusInside)(workingArea, $8f83c5e5be8f8c0b$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $8f83c5e5be8f8c0b$var$lastPortaledElement = {};
                        }
                    }
                    $8f83c5e5be8f8c0b$var$focusWasOutsideWindow = false;
                    $8f83c5e5be8f8c0b$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $3sW1G.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $8f83c5e5be8f8c0b$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $8f83c5e5be8f8c0b$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $8f83c5e5be8f8c0b$var$onTrap = function onTrap(event) {
    if ($8f83c5e5be8f8c0b$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $8f83c5e5be8f8c0b$var$onBlur = function onBlur() {
    return (0, $frDl2.deferAction)($8f83c5e5be8f8c0b$var$activateTrap);
};
var $8f83c5e5be8f8c0b$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $8f83c5e5be8f8c0b$var$recordPortal(currentNode, source);
};
var $8f83c5e5be8f8c0b$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $8f83c5e5be8f8c0b$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $8P7DW.createElement("div", {
        onBlur: $8f83c5e5be8f8c0b$var$onBlur,
        onFocus: $8f83c5e5be8f8c0b$var$onFocus
    }, children);
};
$8f83c5e5be8f8c0b$var$FocusTrap.propTypes = {};
var $8f83c5e5be8f8c0b$var$onWindowBlur = function onWindowBlur() {
    $8f83c5e5be8f8c0b$var$focusWasOutsideWindow = 'just';
    (0, $frDl2.deferAction)(function() {
        $8f83c5e5be8f8c0b$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $8f83c5e5be8f8c0b$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $8f83c5e5be8f8c0b$var$onTrap);
    document.addEventListener('focusout', $8f83c5e5be8f8c0b$var$onBlur);
    window.addEventListener('blur', $8f83c5e5be8f8c0b$var$onWindowBlur);
};
var $8f83c5e5be8f8c0b$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $8f83c5e5be8f8c0b$var$onTrap);
    document.removeEventListener('focusout', $8f83c5e5be8f8c0b$var$onBlur);
    window.removeEventListener('blur', $8f83c5e5be8f8c0b$var$onWindowBlur);
};
function $8f83c5e5be8f8c0b$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $8f83c5e5be8f8c0b$var$focusLockAPI = {
    moveFocusInside: (0, $7pRMw.moveFocusInside),
    focusInside: (0, $ciroK.focusInside),
    focusNextElement: (0, $132Hv.focusNextElement),
    focusPrevElement: (0, $132Hv.focusPrevElement),
    focusFirstElement: (0, $132Hv.focusFirstElement),
    focusLastElement: (0, $132Hv.focusLastElement),
    captureFocusRestore: (0, $lPbQi.captureFocusRestore)
};
function $8f83c5e5be8f8c0b$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$8f83c5e5be8f8c0b$var$lastActiveTrap) $8f83c5e5be8f8c0b$var$attachHandler();
    var lastTrap = $8f83c5e5be8f8c0b$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $8f83c5e5be8f8c0b$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $8f83c5e5be8f8c0b$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($8f83c5e5be8f8c0b$var$focusLockAPI);
        $8f83c5e5be8f8c0b$var$activateTrap(true);
        (0, $frDl2.deferAction)($8f83c5e5be8f8c0b$var$activateTrap);
    } else {
        $8f83c5e5be8f8c0b$var$detachHandler();
        $8f83c5e5be8f8c0b$var$lastActiveFocus = null;
    }
}
(0, $4Iwox.mediumFocus).assignSyncMedium($8f83c5e5be8f8c0b$var$onFocus);
(0, $4Iwox.mediumBlur).assignMedium($8f83c5e5be8f8c0b$var$onBlur);
(0, $4Iwox.mediumEffect).assignMedium(function(cb) {
    return cb($8f83c5e5be8f8c0b$var$focusLockAPI);
});
var $8f83c5e5be8f8c0b$export$2e2bcd8739ae039 = (0, $7jPL5.default)($8f83c5e5be8f8c0b$var$reducePropsToState, $8f83c5e5be8f8c0b$var$handleStateChangeOnClient)($8f83c5e5be8f8c0b$var$FocusWatcher);

});
parcelRegister("7jPL5", function(module, exports) {
$parcel$export(module.exports, "default", () => $554274eb75886765$export$2e2bcd8739ae039);

var $bhSWU = parcelRequire("bhSWU");

var $ceo2e = parcelRequire("ceo2e");

var $8P7DW = parcelRequire("8P7DW");
function $554274eb75886765$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $bhSWU.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $8P7DW.PureComponent));
        (0, $ceo2e.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $554274eb75886765$export$2e2bcd8739ae039 = $554274eb75886765$var$withSideEffect;

});

parcelRegister("lPbQi", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $fe378c0b41c361b2$export$d357db6e554ff59a);

var $fxBxj = parcelRequire("fxBxj");
function $fe378c0b41c361b2$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $fe378c0b41c361b2$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $fe378c0b41c361b2$var$weakRef(currentElement),
            parent: $fe378c0b41c361b2$var$weakRef(currentElement.parentElement),
            left: $fe378c0b41c361b2$var$weakRef(currentElement.previousElementSibling),
            right: $fe378c0b41c361b2$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $fe378c0b41c361b2$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $fe378c0b41c361b2$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $fxBxj.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $fe378c0b41c361b2$export$d357db6e554ff59a = function(targetElement) {
    var location = $fe378c0b41c361b2$export$5061a7725be48ff9(targetElement);
    return function() {
        return $fe378c0b41c361b2$var$restoreFocusTo(location);
    };
};

});
parcelRegister("fxBxj", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $b5070dffcfedc373$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $b5070dffcfedc373$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $b5070dffcfedc373$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $b5070dffcfedc373$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $b5070dffcfedc373$export$2344b14b097df817);

var $aUp0k = parcelRequire("aUp0k");

var $iRJlk = parcelRequire("iRJlk");

var $a6W3A = parcelRequire("a6W3A");

var $632Vr = parcelRequire("632Vr");
var $b5070dffcfedc373$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $aUp0k.toArray)(nodes).filter(function(node) {
        return (0, $iRJlk.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $iRJlk.notHiddenInput)(node);
    });
};
var $b5070dffcfedc373$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $aUp0k.toArray)(nodes).filter(function(node) {
        return (0, $iRJlk.isAutoFocusAllowedCached)(cache, node);
    });
};
var $b5070dffcfedc373$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $a6W3A.orderByTabIndex)($b5070dffcfedc373$export$6266a5cd5915dc33((0, $632Vr.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $b5070dffcfedc373$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $a6W3A.orderByTabIndex)($b5070dffcfedc373$export$6266a5cd5915dc33((0, $632Vr.getFocusables)(topNodes), visibilityCache), false);
};
var $b5070dffcfedc373$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $b5070dffcfedc373$export$6266a5cd5915dc33((0, $632Vr.getParentAutofocusables)(topNode), visibilityCache);
};
var $b5070dffcfedc373$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $b5070dffcfedc373$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $aUp0k.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $b5070dffcfedc373$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $b5070dffcfedc373$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("aUp0k", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $7f1287aa0458cd96$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $7f1287aa0458cd96$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $7f1287aa0458cd96$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $7f1287aa0458cd96$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $7f1287aa0458cd96$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $7f1287aa0458cd96$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("iRJlk", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $dbc05964541b5a97$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $dbc05964541b5a97$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $dbc05964541b5a97$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $dbc05964541b5a97$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $dbc05964541b5a97$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $dbc05964541b5a97$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $dbc05964541b5a97$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $dbc05964541b5a97$export$4e62c701997796c1);

var $4co8y = parcelRequire("4co8y");
var $dbc05964541b5a97$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $dbc05964541b5a97$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $dbc05964541b5a97$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $dbc05964541b5a97$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $dbc05964541b5a97$var$isVisibleUncached = function(node, checkParent) {
    return !node || $dbc05964541b5a97$var$isTopNode(node) || !$dbc05964541b5a97$var$isElementHidden(node) && !$dbc05964541b5a97$var$isInert(node) && checkParent($dbc05964541b5a97$var$getParentNode(node));
};
var $dbc05964541b5a97$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $dbc05964541b5a97$var$isVisibleUncached(node, $dbc05964541b5a97$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $dbc05964541b5a97$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$dbc05964541b5a97$var$isTopNode(node) ? $dbc05964541b5a97$export$b8550e27de209d85(node) ? checkParent($dbc05964541b5a97$var$getParentNode(node)) : false : true;
};
var $dbc05964541b5a97$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $dbc05964541b5a97$var$isAutoFocusAllowedUncached(node, $dbc05964541b5a97$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $dbc05964541b5a97$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $dbc05964541b5a97$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $dbc05964541b5a97$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $dbc05964541b5a97$export$9d74f6fbc6f469d0 = function(node) {
    return $dbc05964541b5a97$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $dbc05964541b5a97$export$8197b0ea56b3b055 = function(node) {
    return !(($dbc05964541b5a97$export$88a6ceeed5737ba3(node) || $dbc05964541b5a97$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $dbc05964541b5a97$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $4co8y.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $dbc05964541b5a97$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $dbc05964541b5a97$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $dbc05964541b5a97$export$602e5a0d338d7750 = function(node) {
    return !$dbc05964541b5a97$export$d94b8b58ec2f30eb(node);
};
var $dbc05964541b5a97$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("a6W3A", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $75c77fd2546ceba0$export$cb40ee071f0d5226);

var $aUp0k = parcelRequire("aUp0k");
var $75c77fd2546ceba0$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $75c77fd2546ceba0$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $75c77fd2546ceba0$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $aUp0k.toArray)(nodes).map(function(node, index) {
        var tabIndex = $75c77fd2546ceba0$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($75c77fd2546ceba0$export$350ee6c095d98996);
};

});

parcelRegister("632Vr", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $46754ada06f476d0$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $46754ada06f476d0$export$853fa94d922e78b9);

var $4co8y = parcelRequire("4co8y");

var $aUp0k = parcelRequire("aUp0k");

var $3PtNf = parcelRequire("3PtNf");
var $46754ada06f476d0$var$queryTabbables = (0, $3PtNf.tabbables).join(',');
var $46754ada06f476d0$var$queryGuardTabbables = "".concat($46754ada06f476d0$var$queryTabbables, ", [data-focus-guard]");
var $46754ada06f476d0$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $aUp0k.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $46754ada06f476d0$var$queryGuardTabbables : $46754ada06f476d0$var$queryTabbables) ? [
            child
        ] : [], $46754ada06f476d0$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $46754ada06f476d0$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $46754ada06f476d0$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $46754ada06f476d0$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $46754ada06f476d0$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $46754ada06f476d0$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $aUp0k.toArray)(parent.parentNode.querySelectorAll($46754ada06f476d0$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $46754ada06f476d0$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $4co8y.FOCUS_AUTO), "]"));
    return (0, $aUp0k.toArray)(parentFocus).map(function(node) {
        return $46754ada06f476d0$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("3PtNf", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $2c9d3edd5b2510d6$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $2c9d3edd5b2510d6$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("3sW1G", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $2860ff6cd0845cad$export$f89ac71e91767111);

var $koCGW = parcelRequire("koCGW");

var $iRJlk = parcelRequire("iRJlk");

var $hJTLj = parcelRequire("hJTLj");

var $a6W3A = parcelRequire("a6W3A");

var $632Vr = parcelRequire("632Vr");
var $2860ff6cd0845cad$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $koCGW.getAllAffectedNodes)(topNode).filter((0, $iRJlk.isNotAGuard));
    var commonParent = (0, $hJTLj.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $a6W3A.orderByTabIndex)((0, $632Vr.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $632Vr.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $iRJlk.isGuard)(node)
        };
    });
};

});
parcelRegister("koCGW", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $ed940fe874bf7cd9$export$7e87c4720b9b279b);

var $4co8y = parcelRequire("4co8y");

var $aUp0k = parcelRequire("aUp0k");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $ed940fe874bf7cd9$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $ed940fe874bf7cd9$var$getTopParent = function(node) {
    return node.parentNode ? $ed940fe874bf7cd9$var$getTopParent(node.parentNode) : node;
};
var $ed940fe874bf7cd9$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $aUp0k.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $4co8y.FOCUS_GROUP));
        acc.push.apply(acc, group ? $ed940fe874bf7cd9$var$filterNested((0, $aUp0k.toArray)($ed940fe874bf7cd9$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $4co8y.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $4co8y.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("hJTLj", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $cea1e4d8a28fba13$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $cea1e4d8a28fba13$export$8f99714c70a37db1);

var $fxBxj = parcelRequire("fxBxj");

var $aUp0k = parcelRequire("aUp0k");
var $cea1e4d8a28fba13$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $cea1e4d8a28fba13$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $cea1e4d8a28fba13$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $cea1e4d8a28fba13$var$getParents(nodeA);
    var parentsB = $cea1e4d8a28fba13$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $cea1e4d8a28fba13$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $aUp0k.asArray)(baseActiveElement);
    var leftEntries = (0, $aUp0k.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $cea1e4d8a28fba13$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $cea1e4d8a28fba13$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $fxBxj.contains)(common, topCommon)) topCommon = common;
                else topCommon = $cea1e4d8a28fba13$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $cea1e4d8a28fba13$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $fxBxj.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("132Hv", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $0c382a8bbc4e3d09$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $0c382a8bbc4e3d09$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $0c382a8bbc4e3d09$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $0c382a8bbc4e3d09$export$6a79073ddabfd6c3);

var $i9bDh = parcelRequire("i9bDh");

var $fxBxj = parcelRequire("fxBxj");

var $aUp0k = parcelRequire("aUp0k");
var $0c382a8bbc4e3d09$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $aUp0k.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $fxBxj.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $fxBxj.getTabbableNodes)(shards, new Map()) : (0, $fxBxj.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $0c382a8bbc4e3d09$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $fxBxj.getTabbableNodes)((0, $aUp0k.asArray)(shards), new Map()) : (0, $fxBxj.getFocusableNodes)((0, $aUp0k.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $0c382a8bbc4e3d09$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $0c382a8bbc4e3d09$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $0c382a8bbc4e3d09$var$defaultOptions(options);
    var solution = $0c382a8bbc4e3d09$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $i9bDh.focusOn)(target.node, newOptions.focusOptions);
};
var $0c382a8bbc4e3d09$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $0c382a8bbc4e3d09$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $0c382a8bbc4e3d09$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $0c382a8bbc4e3d09$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $0c382a8bbc4e3d09$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $0c382a8bbc4e3d09$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $i9bDh.focusOn)(node.node, options.focusOptions);
};
var $0c382a8bbc4e3d09$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $0c382a8bbc4e3d09$var$pickBoundary(scope, options, 'first');
};
var $0c382a8bbc4e3d09$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $0c382a8bbc4e3d09$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("i9bDh", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $d362173e1e259b90$export$c12b3da842c43a8);
var $d362173e1e259b90$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("ciroK", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $8f3c6b29ac98845c$export$20115f8da7baa6fa);

var $fxBxj = parcelRequire("fxBxj");

var $koCGW = parcelRequire("koCGW");

var $aUp0k = parcelRequire("aUp0k");

var $cNGcs = parcelRequire("cNGcs");
var $8f3c6b29ac98845c$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $8f3c6b29ac98845c$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $aUp0k.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $8f3c6b29ac98845c$var$focusInFrame(node, activeElement);
    }));
};
var $8f3c6b29ac98845c$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $cNGcs.getActiveElement)((0, $aUp0k.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $koCGW.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $fxBxj.contains)(node, activeElement) || $8f3c6b29ac98845c$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("cNGcs", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $951acbb06e0f3951$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $jnucH = parcelRequire("jnucH");
var $951acbb06e0f3951$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $951acbb06e0f3951$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $jnucH.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $951acbb06e0f3951$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("jnucH", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $e1b798234e75d88f$export$78d20aae35adef88);
var $e1b798234e75d88f$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("jFxbd", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $e51b957807364130$export$be6b21806d3fd485);

var $4co8y = parcelRequire("4co8y");

var $fxBxj = parcelRequire("fxBxj");

var $aUp0k = parcelRequire("aUp0k");

var $cNGcs = parcelRequire("cNGcs");
var $e51b957807364130$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $cNGcs.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $aUp0k.toArray)(inDocument.querySelectorAll("[".concat((0, $4co8y.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $fxBxj.contains)(node, activeElement);
    });
};

});

parcelRegister("jaGI3", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("7pRMw")).moveFocusInside);

var $4co8y = parcelRequire("4co8y");

var $ciroK = parcelRequire("ciroK");

var $jFxbd = parcelRequire("jFxbd");


var $3sW1G = parcelRequire("3sW1G");

var $7pRMw = parcelRequire("7pRMw");

var $lPbQi = parcelRequire("lPbQi");

var $132Hv = parcelRequire("132Hv");

var $fxBxj = parcelRequire("fxBxj");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $df5014bc82933b18$export$1a988e7317c65621 = $4co8y;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $df5014bc82933b18$var$deprecated_default_moveFocusInside = (0, $7pRMw.moveFocusInside);
var $df5014bc82933b18$export$2e2bcd8739ae039 //
 = $df5014bc82933b18$var$deprecated_default_moveFocusInside;

});
parcelRegister("7pRMw", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $5664961ffdcda5aa$export$cd599851e879a025);

var $i9bDh = parcelRequire("i9bDh");

var $devn1 = parcelRequire("devn1");
var $5664961ffdcda5aa$var$guardCount = 0;
var $5664961ffdcda5aa$var$lockDisabled = false;
var $5664961ffdcda5aa$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $devn1.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($5664961ffdcda5aa$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($5664961ffdcda5aa$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $5664961ffdcda5aa$var$lockDisabled = true;
            setTimeout(function() {
                $5664961ffdcda5aa$var$lockDisabled = false;
            }, 1);
            return;
        }
        $5664961ffdcda5aa$var$guardCount++;
        (0, $i9bDh.focusOn)(focusable.node, options.focusOptions);
        $5664961ffdcda5aa$var$guardCount--;
    }
};

});
parcelRegister("devn1", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $9a24eaae4210a5f2$export$305758c744b57f6f);

var $2LBdp = parcelRequire("2LBdp");

var $fxBxj = parcelRequire("fxBxj");

var $koCGW = parcelRequire("koCGW");

var $aUp0k = parcelRequire("aUp0k");

var $63C4j = parcelRequire("63C4j");

var $cNGcs = parcelRequire("cNGcs");

var $iRJlk = parcelRequire("iRJlk");

var $hJTLj = parcelRequire("hJTLj");
var $9a24eaae4210a5f2$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $iRJlk.isDefined));
};
var $9a24eaae4210a5f2$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $cNGcs.getActiveElement)((0, $aUp0k.asArray)(topNode).length > 0 ? document : (0, $aUp0k.getFirst)(topNode).ownerDocument);
    var entries = (0, $koCGW.getAllAffectedNodes)(topNode).filter((0, $iRJlk.isNotAGuard));
    var commonParent = (0, $hJTLj.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $fxBxj.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $iRJlk.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $fxBxj.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $9a24eaae4210a5f2$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $2LBdp.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $2LBdp.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $63C4j.pickAutofocus)(anyFocusable, innerTabbable, (0, $hJTLj.allParentAutofocusables)(entries, visibilityCache)) || (0, $63C4j.pickAutofocus)(anyFocusable, innerFocusables, (0, $hJTLj.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("2LBdp", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $203cd6b7f17900cc$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $203cd6b7f17900cc$export$65842178e9bb4205);

var $vpUDF = parcelRequire("vpUDF");

var $jbveg = parcelRequire("jbveg");

var $iRJlk = parcelRequire("iRJlk");
var $203cd6b7f17900cc$export$85710b12cf912438 = 'NEW_FOCUS';
var $203cd6b7f17900cc$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $iRJlk.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $203cd6b7f17900cc$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $203cd6b7f17900cc$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $vpUDF.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $jbveg.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $jbveg.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("vpUDF", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $05e6ff0dcbbd05a5$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $05e6ff0dcbbd05a5$export$4a5a72a7124e45f9);

var $iRJlk = parcelRequire("iRJlk");
var $05e6ff0dcbbd05a5$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $iRJlk.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $05e6ff0dcbbd05a5$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $iRJlk.isRadioElement)(node) && node.name) return $05e6ff0dcbbd05a5$var$findSelectedRadio(node, nodes);
    return node;
};
var $05e6ff0dcbbd05a5$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($05e6ff0dcbbd05a5$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("jbveg", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $df7744d5ba41e92e$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $df7744d5ba41e92e$export$e06728ee87c96122);

var $vpUDF = parcelRequire("vpUDF");
var $df7744d5ba41e92e$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $vpUDF.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $df7744d5ba41e92e$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $vpUDF.correctNode)(node, nodes));
};

});


parcelRegister("63C4j", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $46908d88cb0a56d0$export$cfb742983e257555);

var $fxBxj = parcelRequire("fxBxj");

var $jbveg = parcelRequire("jbveg");

var $iRJlk = parcelRequire("iRJlk");
var $46908d88cb0a56d0$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $iRJlk.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $46908d88cb0a56d0$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $fxBxj.filterAutoFocusable)(nodes.filter($46908d88cb0a56d0$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $jbveg.pickFirstFocus)(autoFocusable);
    return (0, $jbveg.pickFirstFocus)((0, $fxBxj.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("frDl2", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $b3e7e4630d3bdca6$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $b3e7e4630d3bdca6$export$c613fed06e332533);
function $b3e7e4630d3bdca6$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $b3e7e4630d3bdca6$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $b3e7e4630d3bdca6$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("LNry5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2jCyz = parcelRequire("2jCyz");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $08fabe5158f61b1c$var$_interopRequireDefault($2jCyz).default;
    }
});

var $eOCaK = parcelRequire("eOCaK");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $eOCaK.TouchScrollable;
    }
});
function $08fabe5158f61b1c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2jCyz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1afb43a38f68856f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8P7DW = parcelRequire("8P7DW");
var $1afb43a38f68856f$var$_react2 = $1afb43a38f68856f$var$_interopRequireDefault($8P7DW);

var $8Juqw = parcelRequire("8Juqw");

var $eOCaK = parcelRequire("eOCaK");

var $kAzWZ = parcelRequire("kAzWZ");
var $1afb43a38f68856f$var$_withLockSheet2 = $1afb43a38f68856f$var$_interopRequireDefault($kAzWZ);

var $fd4el = parcelRequire("fd4el");
var $1afb43a38f68856f$var$_withTouchListeners2 = $1afb43a38f68856f$var$_interopRequireDefault($fd4el);

var $lty1e = parcelRequire("lty1e");
function $1afb43a38f68856f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1afb43a38f68856f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1afb43a38f68856f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1afb43a38f68856f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1afb43a38f68856f$var$ScrollLock = function(_PureComponent) {
    $1afb43a38f68856f$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $1afb43a38f68856f$var$_classCallCheck(this, ScrollLock);
        return $1afb43a38f68856f$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $1afb43a38f68856f$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$8Juqw.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $1afb43a38f68856f$var$_react2.default.createElement($eOCaK.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($8P7DW.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $1afb43a38f68856f$var$compose = (0, $lty1e.pipe)($1afb43a38f68856f$var$_withTouchListeners2.default, $1afb43a38f68856f$var$_withLockSheet2.default);
var $1afb43a38f68856f$var$SheetLock = $1afb43a38f68856f$var$compose($1afb43a38f68856f$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $1afb43a38f68856f$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $1afb43a38f68856f$var$_react2.default.createElement($1afb43a38f68856f$var$SheetLock, props) : props.children;
};
$1afb43a38f68856f$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $1afb43a38f68856f$var$LockToggle;

});
parcelRegister("8Juqw", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("eOCaK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $ac93586c180112e6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ac93586c180112e6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8P7DW = parcelRequire("8P7DW");

var $8Juqw = parcelRequire("8Juqw");

var $lty1e = parcelRequire("lty1e");
function $ac93586c180112e6$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $ac93586c180112e6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ac93586c180112e6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ac93586c180112e6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $ac93586c180112e6$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $ac93586c180112e6$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $ac93586c180112e6$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $ac93586c180112e6$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $ac93586c180112e6$var$_possibleConstructorReturn(_this, _ret);
    }
    $ac93586c180112e6$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$8Juqw.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $lty1e.preventInertiaScroll, $lty1e.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $lty1e.allowTouchMove, $lty1e.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$8Juqw.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $lty1e.preventInertiaScroll, $lty1e.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $lty1e.allowTouchMove, $lty1e.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $ac93586c180112e6$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $8P7DW.cloneElement)(children, $ac93586c180112e6$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($8P7DW.PureComponent);

});
parcelRegister("lty1e", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $fa26b1d7bc1fc2ca$var$preventTouchMove;
module.exports.allowTouchMove = $fa26b1d7bc1fc2ca$var$allowTouchMove;
module.exports.preventInertiaScroll = $fa26b1d7bc1fc2ca$var$preventInertiaScroll;
module.exports.isTouchDevice = $fa26b1d7bc1fc2ca$var$isTouchDevice;
module.exports.camelToKebab = $fa26b1d7bc1fc2ca$var$camelToKebab;
module.exports.parse = $fa26b1d7bc1fc2ca$var$parse;
module.exports.getPadding = $fa26b1d7bc1fc2ca$var$getPadding;
module.exports.getWindowHeight = $fa26b1d7bc1fc2ca$var$getWindowHeight;
module.exports.getDocumentHeight = $fa26b1d7bc1fc2ca$var$getDocumentHeight;
module.exports.makeStyleTag = $fa26b1d7bc1fc2ca$var$makeStyleTag;
module.exports.injectStyles = $fa26b1d7bc1fc2ca$var$injectStyles;
module.exports.insertStyleTag = $fa26b1d7bc1fc2ca$var$insertStyleTag;

var $8Juqw = parcelRequire("8Juqw");
var $fa26b1d7bc1fc2ca$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $fa26b1d7bc1fc2ca$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $fa26b1d7bc1fc2ca$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $fa26b1d7bc1fc2ca$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $fa26b1d7bc1fc2ca$var$isTouchDevice() {
    if (!$8Juqw.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $fa26b1d7bc1fc2ca$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $fa26b1d7bc1fc2ca$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $fa26b1d7bc1fc2ca$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $fa26b1d7bc1fc2ca$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($fa26b1d7bc1fc2ca$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $fa26b1d7bc1fc2ca$var$getPadding() {
    if (!$8Juqw.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $fa26b1d7bc1fc2ca$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($8Juqw.canUseDOM) return window.innerHeight * multiplier;
}
function $fa26b1d7bc1fc2ca$var$getDocumentHeight() {
    if ($8Juqw.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $fa26b1d7bc1fc2ca$var$makeStyleTag() {
    if (!$8Juqw.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $fa26b1d7bc1fc2ca$var$injectStyles(tag, css) {
    if (!$8Juqw.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $fa26b1d7bc1fc2ca$var$insertStyleTag(tag) {
    if (!$8Juqw.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("kAzWZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $efd30e6d5650e286$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $efd30e6d5650e286$var$withLockSheet;

var $8P7DW = parcelRequire("8P7DW");
var $efd30e6d5650e286$var$_react2 = $efd30e6d5650e286$var$_interopRequireDefault($8P7DW);

var $lty1e = parcelRequire("lty1e");
function $efd30e6d5650e286$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $efd30e6d5650e286$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $efd30e6d5650e286$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $efd30e6d5650e286$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $efd30e6d5650e286$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $efd30e6d5650e286$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $efd30e6d5650e286$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $efd30e6d5650e286$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $lty1e.makeStyleTag)();
                if (!sheet) return;
                (0, $lty1e.injectStyles)(sheet, styles);
                (0, $lty1e.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $lty1e.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $lty1e.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $efd30e6d5650e286$var$_possibleConstructorReturn(_this, _ret);
        }
        $efd30e6d5650e286$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $efd30e6d5650e286$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($8P7DW.PureComponent);
}

});

parcelRegister("fd4el", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b12b59fcb6c073ab$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $b12b59fcb6c073ab$var$withTouchListeners;

var $8P7DW = parcelRequire("8P7DW");
var $b12b59fcb6c073ab$var$_react2 = $b12b59fcb6c073ab$var$_interopRequireDefault($8P7DW);

var $8Juqw = parcelRequire("8Juqw");

var $lty1e = parcelRequire("lty1e");
function $b12b59fcb6c073ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b12b59fcb6c073ab$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b12b59fcb6c073ab$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b12b59fcb6c073ab$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $b12b59fcb6c073ab$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $b12b59fcb6c073ab$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $b12b59fcb6c073ab$var$_classCallCheck(this, TouchProvider);
            return $b12b59fcb6c073ab$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $b12b59fcb6c073ab$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$8Juqw.canUseDOM || !(0, $lty1e.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $lty1e.preventTouchMove, $lty1e.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$8Juqw.canUseDOM || !(0, $lty1e.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $lty1e.preventTouchMove, $lty1e.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $b12b59fcb6c073ab$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($8P7DW.PureComponent);
}

});



parcelRegister("cBdFf", function(module, exports) {
$parcel$export(module.exports, "default", () => $4532f3e034a98f1d$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $aeYmt = parcelRequire("aeYmt");

var $5J6r2 = parcelRequire("5J6r2");
const $4532f3e034a98f1d$var$packageName = undefined;
const $4532f3e034a98f1d$var$packageVersion = undefined;
const $4532f3e034a98f1d$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $4532f3e034a98f1d$var$packageName,
    packageVersion: $4532f3e034a98f1d$var$packageVersion
};
const $4532f3e034a98f1d$var$baseStyles = null;
const $4532f3e034a98f1d$var$shouldAllowClickThroughStyles = null;
const $4532f3e034a98f1d$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ const $4532f3e034a98f1d$var$Blanket = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $5J6r2.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $8P7DW.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4532f3e034a98f1d$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $8P7DW.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $8P7DW.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $8n1kL.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk1i5c _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        children: children
    });
}));
$4532f3e034a98f1d$var$Blanket.displayName = 'Blanket';
var $4532f3e034a98f1d$export$2e2bcd8739ae039 = $4532f3e034a98f1d$var$Blanket;

});

parcelRegister("l8Ymd", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $a8af2872f2bb5b68$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $aPGOU = parcelRequire("aPGOU");

var $hIY19 = parcelRequire("hIY19");

var $ab8S0 = parcelRequire("ab8S0");

var $31mwP = parcelRequire("31mwP");
const $a8af2872f2bb5b68$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $8P7DW.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return ()=>{
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hIY19.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ab8S0.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
const $a8af2872f2bb5b68$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $8P7DW.useContext)((0, $hIY19.LevelContext));
    const parentNode = (0, $8P7DW.useContext)((0, $ab8S0.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $8P7DW.useRef)(new (0, $aPGOU.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $gWgPx.jsx)($a8af2872f2bb5b68$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $31mwP.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};

});
parcelRegister("aPGOU", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $e3ed567c1ca89175$export$da4f61fd78d35243);
class $e3ed567c1ca89175$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}

});

parcelRegister("hIY19", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $f93c3d17f6a1c53a$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $8P7DW = parcelRequire("8P7DW");
const $f93c3d17f6a1c53a$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $8P7DW.createContext)(0);

});

parcelRegister("ab8S0", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $da62097ece144148$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $8P7DW = parcelRequire("8P7DW");
const $da62097ece144148$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $8P7DW.createContext)({
    current: null
});

});

parcelRegister("31mwP", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $fb3e7bf6d332c804$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $8P7DW = parcelRequire("8P7DW");
const $fb3e7bf6d332c804$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $8P7DW.createContext)({
    current: null
});

});


parcelRegister("9Bp8K", function(module, exports) {
$parcel$export(module.exports, "default", () => $46e1175914a8dbed$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $VA7Bl = parcelRequire("VA7Bl");

var $fmYz8 = parcelRequire("fmYz8");

var $9lCbR = parcelRequire("9lCbR");

var $cBwgz = parcelRequire("cBwgz");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $46e1175914a8dbed$var$modalStackRegister = [];
function $46e1175914a8dbed$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $cBwgz.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $9lCbR.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $fmYz8.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $VA7Bl.default)(()=>{
        const newStackIndex = $46e1175914a8dbed$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $8P7DW.useEffect)(()=>{
        const currentStackIndex = $46e1175914a8dbed$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $46e1175914a8dbed$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $46e1175914a8dbed$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $46e1175914a8dbed$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $8P7DW.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $46e1175914a8dbed$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $46e1175914a8dbed$var$modalStackRegister.splice(currentStackIndex, 1);
                $46e1175914a8dbed$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("VA7Bl", function(module, exports) {
$parcel$export(module.exports, "default", () => $5bd4d6defb021602$export$2e2bcd8739ae039);

var $jGTO4 = parcelRequire("jGTO4");
function $5bd4d6defb021602$export$2e2bcd8739ae039(callback) {
    const ref = (0, $jGTO4.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("jGTO4", function(module, exports) {
$parcel$export(module.exports, "default", () => $90ec48891a271a13$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $90ec48891a271a13$var$uniqueReferencedValue = {};
function $90ec48891a271a13$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $8P7DW.useRef)($90ec48891a271a13$var$uniqueReferencedValue);
    if (ref.current === $90ec48891a271a13$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("fmYz8", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ed32e60db28442d$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $8ed32e60db28442d$export$2e2bcd8739ae039(value) {
    const ref = (0, $8P7DW.useRef)();
    (0, $8P7DW.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("9lCbR", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fcc757a2019683b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $3fcc757a2019683b$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $8P7DW.useState)(initialState);
    const valueRef = (0, $8P7DW.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("7ElSq", function(module, exports) {
$parcel$export(module.exports, "default", () => $8696266c11dc60d3$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $8696266c11dc60d3$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $8696266c11dc60d3$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $8P7DW.useState)(0);
    (0, $8P7DW.useLayoutEffect)(()=>{
        setScrollTopOffset($8696266c11dc60d3$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $8P7DW.useCallback)(()=>{
        if ($8696266c11dc60d3$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $8P7DW.useEffect)(()=>{
        return (0, $36kyW.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("6vjQ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0da544f11386d7f0$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.37.1 */ /* modal-dialog.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $6NJAV = parcelRequire("6NJAV");

var $klxUK = parcelRequire("klxUK");

var $d4WRD = parcelRequire("d4WRD");

var $fnhqr = parcelRequire("fnhqr");

var $BnUzk = parcelRequire("BnUzk");

var $buhve = parcelRequire("buhve");

var $bT4U6 = parcelRequire("bT4U6");

var $e6Qdr = parcelRequire("e6Qdr");
parcelRequire("jZTIs");
var $kwu91 = parcelRequire("kwu91");

var $dueQD = parcelRequire("dueQD");

var $Tzxql = parcelRequire("Tzxql");

var $k02VU = parcelRequire("k02VU");

var $k8nMG = parcelRequire("k8nMG");

var $hmfOv = parcelRequire("hmfOv");

var $5VcKs = parcelRequire("5VcKs");

var $cAZwz = parcelRequire("cAZwz");
const $0da544f11386d7f0$var$dialogWidth = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $5VcKs.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $5VcKs.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};
const $0da544f11386d7f0$var$dialogHeight = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};
const $0da544f11386d7f0$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $0da544f11386d7f0$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl",
    borderRadiusT26Shape: "_epkxpb1k",
    motion: "_4t3i1osq _c71l1kw7 _p12f1kw7 _1jyk1wug _yakv1kw7 _4lht1kw7",
    fullscreen: "_1jyk1osq"
};
const $0da544f11386d7f0$var$viewportScrollStyles = null;
const $0da544f11386d7f0$var$bodyScrollStyles = null;
const $0da544f11386d7f0$var$ModalDialog = (props)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: providedAutoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false } = props;
    const id = (0, $fnhqr.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    // https://product-fabric.atlassian.net/browse/DSP-24307
    // If flag and falsy, use true instead.
    // When we remove boolean `autoFocus`, we won't have to worry about this
    const autoFocus = !providedAutoFocus ? true : providedAutoFocus;
    (0, $8P7DW.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $kwu91.combine)((0, $k02VU.disableDraggingToCrossOriginIFramesForElement)(), (0, $hmfOv.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $k8nMG.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $d4WRD.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $Tzxql.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $8P7DW.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $BnUzk.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $BnUzk.useLayering)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cAZwz.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dueQD.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dueQD.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: (0, $e6Qdr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $buhve.default), {
                    enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
                    exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
                    onFinish: onMotionFinish,
                    xcss: (0, $6NJAV.cx)($0da544f11386d7f0$var$dialogStyles.motion, isFullScreen && $0da544f11386d7f0$var$dialogStyles.fullscreen),
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)("section", {
                        "aria-label": label,
                        ref: motionRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-width': $0da544f11386d7f0$var$dialogWidth(width),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-height': $0da544f11386d7f0$var$dialogHeight(height)
                        },
                        role: "dialog",
                        "aria-labelledby": label ? undefined : titleId,
                        "data-testid": defaultTestId,
                        "data-modal-stack": stackIndex,
                        tabIndex: -1,
                        "aria-modal": true,
                        "data-ds--level": currentLevel,
                        className: (0, $8n1kL.default)([
                            $0da544f11386d7f0$var$dialogStyles.root,
                            !isFullScreen && $0da544f11386d7f0$var$dialogStyles.borderRadius,
                            !isFullScreen && (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $0da544f11386d7f0$var$dialogStyles.borderRadiusT26Shape,
                            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
                        ]),
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bT4U6.default), {
                    /**
         * We don't want a 'slide in' for the full screen modals.
         */ entranceDirection: isFullScreen ? undefined : 'bottom',
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $klxUK.default)([
                                bottomFadeInProps.ref,
                                motionRef
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': $0da544f11386d7f0$var$dialogWidth(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': $0da544f11386d7f0$var$dialogHeight(height)
                            },
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                            className: (0, $8n1kL.default)([
                                $0da544f11386d7f0$var$dialogStyles.root,
                                !isFullScreen && $0da544f11386d7f0$var$dialogStyles.borderRadius,
                                !isFullScreen && (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $0da544f11386d7f0$var$dialogStyles.borderRadiusT26Shape,
                                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": defaultTestId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0da544f11386d7f0$export$2e2bcd8739ae039 = $0da544f11386d7f0$var$ModalDialog;

});
parcelRegister("BnUzk", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $d22dc21fec280086$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $d22dc21fec280086$export$c8b4d54e03dee6ed);

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $hIY19 = parcelRequire("hIY19");

var $ab8S0 = parcelRequire("ab8S0");

var $31mwP = parcelRequire("31mwP");
const $d22dc21fec280086$var$ESCAPE = 'Escape';
function $d22dc21fec280086$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $8P7DW.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $d22dc21fec280086$export$c8b4d54e03dee6ed();
    const onKeyDown = (0, $8P7DW.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $d22dc21fec280086$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $8P7DW.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $8P7DW.useEffect)(()=>{
        return (0, $36kyW.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $d22dc21fec280086$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $8P7DW.useContext)((0, $hIY19.LevelContext));
    const layerNode = (0, $8P7DW.useContext)((0, $ab8S0.LevelNodeContext));
    const rootNode = (0, $8P7DW.useContext)((0, $31mwP.RootNodeContext));
    const isLayerDisabled = (0, $8P7DW.useCallback)(()=>{
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $8P7DW.useCallback)(()=>rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});

parcelRegister("jZTIs", function(module, exports) {
$parcel$export(module.exports, "combine", () => (parcelRequire("kwu91")).combine);

var $kwu91 = parcelRequire("kwu91");

});
parcelRegister("kwu91", function(module, exports) {
$parcel$export(module.exports, "combine", () => $e1db36dd26fd96aa$export$1be1fc439b849fdf);
function $e1db36dd26fd96aa$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});


parcelRegister("dueQD", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $1bfc0312566f9a41$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $1bfc0312566f9a41$export$dece24112a937f92);

var $8P7DW = parcelRequire("8P7DW");
const $1bfc0312566f9a41$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $8P7DW.createContext)(null);
const $1bfc0312566f9a41$export$dece24112a937f92 = /*#__PURE__*/ (0, $8P7DW.createContext)(null);

});

parcelRegister("Tzxql", function(module, exports) {
$parcel$export(module.exports, "default", () => $baa5bafe3442d1a4$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $baa5bafe3442d1a4$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $8P7DW.useRef)(null);
    const onMotionFinish = (0, $8P7DW.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("k02VU", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $78b82995d2d7fadd$export$ec28e97c7d8b1b35);

var $36kyW = parcelRequire("36kyW");
parcelRequire("jZTIs");
var $kwu91 = parcelRequire("kwu91");
parcelRequire("6yS29");
var $kraAt = parcelRequire("kraAt");

var $CViuw = parcelRequire("CViuw");
function $78b82995d2d7fadd$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $36kyW.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $kraAt.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $kwu91.combine)(unbindEvents, unbindMonitor);
}
function $78b82995d2d7fadd$var$watchForInteractionStart({ start: start }) {
    return (0, $36kyW.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $78b82995d2d7fadd$var$api = (0, $CViuw.makeFixForAdapter)({
    watchForInteractionStart: $78b82995d2d7fadd$var$watchForInteractionStart,
    watchForInteractionEnd: $78b82995d2d7fadd$var$watchForInteractionEnd
});
function $78b82995d2d7fadd$export$ec28e97c7d8b1b35() {
    return $78b82995d2d7fadd$var$api.registerUsage();
}

});
parcelRegister("6yS29", function(module, exports) {
$parcel$export(module.exports, "draggable", () => (parcelRequire("kraAt")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("kraAt")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("kraAt")).monitorForElements);

var $kraAt = parcelRequire("kraAt");

});
parcelRegister("kraAt", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $adb0d686449f4b68$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $adb0d686449f4b68$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $adb0d686449f4b68$export$c746a5152d4ba26c);

var $36kyW = parcelRequire("36kyW");

var $ak1eP = parcelRequire("ak1eP");

var $c5QP3 = parcelRequire("c5QP3");

var $7pYVe = parcelRequire("7pYVe");

var $kwu91 = parcelRequire("kwu91");

var $7uTDU = parcelRequire("7uTDU");

var $9MNzu = parcelRequire("9MNzu");

var $1fm5X = parcelRequire("1fm5X");

var $dyH8I = parcelRequire("dyH8I");

var $57EOl = parcelRequire("57EOl");

var $fG7Zt = parcelRequire("fG7Zt");

var $cS5xW = parcelRequire("cS5xW");
const $adb0d686449f4b68$var$draggableRegistry = new WeakMap();
function $adb0d686449f4b68$var$addToRegistry(args) {
    $adb0d686449f4b68$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $adb0d686449f4b68$var$draggableRegistry.delete(args.element);
    };
}
const $adb0d686449f4b68$var$honeyPotFix = (0, $c5QP3.makeHoneyPotFix)();
const $adb0d686449f4b68$var$adapter = (0, $7pYVe.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $kwu91.combine)($adb0d686449f4b68$var$honeyPotFix.bindEvents(), (0, $36kyW.bind)(document, {
            type: 'dragstart',
            listener (event) {
                var _entry$getInitialData, _entry$getInitialData2;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $adb0d686449f4b68$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ const input = (0, $dyH8I.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $ak1eP.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ const nativeData = ((_entry$getInitialData = entry.getInitialDataForExternal) === null || _entry$getInitialData === void 0 ? void 0 : _entry$getInitialData.call(entry, feedback)) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $1fm5X.isAndroid)() && !event.dataTransfer.types.includes((0, $57EOl.textMediaType)) && !event.dataTransfer.types.includes((0, $fG7Zt.URLMediaType))) event.dataTransfer.setData((0, $57EOl.textMediaType), (0, $1fm5X.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $cS5xW.elementAdapterNativeDataKey), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: ((_entry$getInitialData2 = entry.getInitialData) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $adb0d686449f4b68$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $adb0d686449f4b68$var$honeyPotFix.getOnPostDispatch()
});
const $adb0d686449f4b68$export$e7140b68045b5036 = $adb0d686449f4b68$var$adapter.dropTarget;
const $adb0d686449f4b68$export$59a074bac4c54f54 = $adb0d686449f4b68$var$adapter.monitor;
function $adb0d686449f4b68$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $kwu91.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $adb0d686449f4b68$var$adapter.registerUsage(), $adb0d686449f4b68$var$addToRegistry(args), (0, $9MNzu.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $7uTDU.once)(cleanup);
}

});
parcelRegister("ak1eP", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $5f6ee812ad607d2a$export$81d0353f25f5dd);

var $54Caf = parcelRequire("54Caf");
function $5f6ee812ad607d2a$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $54Caf.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("54Caf", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $eb4d4e4fd86f5dbe$export$821bdcd739a2706b);

var $8MwCV = parcelRequire("8MwCV");
function $eb4d4e4fd86f5dbe$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $8MwCV.honeyPotDataAttribute));
}

});
parcelRegister("8MwCV", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", () => $1c272443d857119f$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $1c272443d857119f$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("c5QP3", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $4ce01a7abec4ab6a$export$8ecad27c959e89e0);

var $36kyW = parcelRequire("36kyW");

var $hkw3U = parcelRequire("hkw3U");

var $99Mfk = parcelRequire("99Mfk");

var $1ujau = parcelRequire("1ujau");

var $8MwCV = parcelRequire("8MwCV");
const $4ce01a7abec4ab6a$var$honeyPotSize = 2;
const $4ce01a7abec4ab6a$var$halfHoneyPotSize = $4ce01a7abec4ab6a$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $4ce01a7abec4ab6a$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $4ce01a7abec4ab6a$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $4ce01a7abec4ab6a$var$halfHoneyPotSize,
        y: point.y - $4ce01a7abec4ab6a$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4ce01a7abec4ab6a$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4ce01a7abec4ab6a$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $4ce01a7abec4ab6a$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $4ce01a7abec4ab6a$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $4ce01a7abec4ab6a$var$getHoneyPotRectFor({ client: client }) {
    const point = $4ce01a7abec4ab6a$var$preventGoingForwardsOffScreen($4ce01a7abec4ab6a$var$preventGoingBackwardsOffScreen($4ce01a7abec4ab6a$var$pullBackByHalfHoneyPotSize($4ce01a7abec4ab6a$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $4ce01a7abec4ab6a$var$honeyPotSize,
        height: $4ce01a7abec4ab6a$var$honeyPotSize
    });
}
function $4ce01a7abec4ab6a$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $4ce01a7abec4ab6a$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $4ce01a7abec4ab6a$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $8MwCV.honeyPotDataAttribute), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $1ujau.supportsPopover)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    let clientRect = $4ce01a7abec4ab6a$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        position: 'fixed',
        ...(0, $1ujau.supportsPopover)() ? // needs to come first as it has 'inset: unset' which
        // needs to be overridden by our top / left values
        (0, $99Mfk.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $hkw3U.maxZIndex)
        },
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        ...$4ce01a7abec4ab6a$var$getRectStyles({
            clientRect: clientRect
        })
    });
    document.body.appendChild(element);
    if ((0, $1ujau.supportsPopover)()) element.showPopover();
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ const unbindPointerMove = (0, $36kyW.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $4ce01a7abec4ab6a$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $4ce01a7abec4ab6a$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($4ce01a7abec4ab6a$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $36kyW.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $4ce01a7abec4ab6a$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $36kyW.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $4ce01a7abec4ab6a$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                const { input: input } = payload.location.current;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("hkw3U", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", () => $9b62c9639ee3ebe4$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $9b62c9639ee3ebe4$export$7d0a15ee70427305 = 2147483647;

});

parcelRegister("99Mfk", function(module, exports) {
$parcel$export(module.exports, "popoverResetUserAgentStyles", () => $52182cc88ec49328$export$74004cb910cdc478);
const $52182cc88ec49328$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent'
};

});

parcelRegister("1ujau", function(module, exports) {
$parcel$export(module.exports, "supportsPopover", () => $16eb3b59edf70957$export$1150b66d0ff92823);

var $7uTDU = parcelRequire("7uTDU");
const $16eb3b59edf70957$export$1150b66d0ff92823 = (0, $7uTDU.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

});
parcelRegister("7uTDU", function(module, exports) {
$parcel$export(module.exports, "once", () => $bb10412fc683a1ca$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $bb10412fc683a1ca$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});



parcelRegister("7pYVe", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $ef6ef63b142204eb$export$2aa3a33160990d96);

var $cMVJZ = parcelRequire("cMVJZ");

var $lzoRk = parcelRequire("lzoRk");

var $lT6hX = parcelRequire("lT6hX");

var $1qklf = parcelRequire("1qklf");
function $ef6ef63b142204eb$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $1qklf.makeMonitor)();
    const dropTargetAPI = (0, $lT6hX.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $cMVJZ.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $cMVJZ.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $lzoRk.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("cMVJZ", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $d88d91122dbf7d11$export$3efdceeb8ca25c51);

var $36kyW = parcelRequire("36kyW");

var $ak1eP = parcelRequire("ak1eP");

var $54Caf = parcelRequire("54Caf");

var $iJ6CH = parcelRequire("iJ6CH");

var $dvVsu = parcelRequire("dvVsu");

var $dyH8I = parcelRequire("dyH8I");

var $GxXdo = parcelRequire("GxXdo");
const $d88d91122dbf7d11$var$globalState = {
    isActive: false
};
function $d88d91122dbf7d11$var$canStart() {
    return !$d88d91122dbf7d11$var$globalState.isActive;
}
function $d88d91122dbf7d11$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $d88d91122dbf7d11$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $d88d91122dbf7d11$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$d88d91122dbf7d11$var$canStart()) return;
    const initial = $d88d91122dbf7d11$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $d88d91122dbf7d11$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $d88d91122dbf7d11$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $GxXdo.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $d88d91122dbf7d11$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $dyH8I.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $54Caf.isHoneyPotElement)(event.target) ? (0, $ak1eP.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $d88d91122dbf7d11$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $d88d91122dbf7d11$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $36kyW.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $iJ6CH.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $dyH8I.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $d88d91122dbf7d11$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $dyH8I.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $dvVsu.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $d88d91122dbf7d11$var$getNativeSetDragImage(event)
    });
}
function $d88d91122dbf7d11$var$setDropEffectOnEvent({ event: event, current: current }) {
    var _current$;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $d88d91122dbf7d11$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $dyH8I.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $d88d91122dbf7d11$export$3efdceeb8ca25c51 = {
    canStart: $d88d91122dbf7d11$var$canStart,
    start: $d88d91122dbf7d11$var$start
};

});
parcelRegister("iJ6CH", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $d40950962478ab81$export$57d220c74e84a273);

var $3XWgT = parcelRequire("3XWgT");

var $f9i1w = parcelRequire("f9i1w");

var $1DvPX = parcelRequire("1DvPX");

var $cLf1K = parcelRequire("cLf1K");
function $d40950962478ab81$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $f9i1w.isSafari)()) return (0, $1DvPX.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $3XWgT.isFirefox)()) return (0, $cLf1K.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("3XWgT", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $7134df60595e957b$export$b7d78993b74f766d);

var $7uTDU = parcelRequire("7uTDU");
const $7134df60595e957b$export$b7d78993b74f766d = (0, $7uTDU.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});

parcelRegister("f9i1w", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $35f530dd8380243e$export$95df08bae54cb4df);

var $7uTDU = parcelRequire("7uTDU");
const $35f530dd8380243e$export$95df08bae54cb4df = (0, $7uTDU.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("1DvPX", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $bbc7f4c4e557d105$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $bbc7f4c4e557d105$export$f21837c338005454);

var $36kyW = parcelRequire("36kyW");

var $f9i1w = parcelRequire("f9i1w");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $bbc7f4c4e557d105$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $bbc7f4c4e557d105$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $f9i1w.isSafari)()) return false;
    return dragEnter.hasOwnProperty($bbc7f4c4e557d105$var$symbols.isEnteringWindow);
}
function $bbc7f4c4e557d105$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $f9i1w.isSafari)()) return false;
    return dragLeave.hasOwnProperty($bbc7f4c4e557d105$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $f9i1w.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $36kyW.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$bbc7f4c4e557d105$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$bbc7f4c4e557d105$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("cLf1K", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $d8d351377b8eef74$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $d8d351377b8eef74$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $d8d351377b8eef74$export$e46810fef53b5b0e(eventTarget) {
    return $d8d351377b8eef74$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("dvVsu", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $8065249bd1af4f6c$export$ac5e5b0daf997b2);
function $8065249bd1af4f6c$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("dyH8I", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $91614d53eec6a563$export$7c112ceec8941e67);
function $91614d53eec6a563$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("GxXdo", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $81633d40921558a7$export$9f13ecc44e83d682);

var $a4Hdp = parcelRequire("a4Hdp");
const $81633d40921558a7$var$scheduleOnDrag = (0, $a4Hdp.default)((fn)=>fn());
const $81633d40921558a7$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $81633d40921558a7$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $81633d40921558a7$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $81633d40921558a7$var$dragStart.flush();
            $81633d40921558a7$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $81633d40921558a7$var$scheduleOnDrag(()=>{
                $81633d40921558a7$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $81633d40921558a7$var$dragStart.flush();
            $81633d40921558a7$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("a4Hdp", function(module, exports) {
$parcel$export(module.exports, "default", () => $755bccc811f6705c$export$2e2bcd8739ae039);
var $755bccc811f6705c$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $755bccc811f6705c$export$2e2bcd8739ae039 = $755bccc811f6705c$var$rafSchd;

});



parcelRegister("lzoRk", function(module, exports) {
$parcel$export(module.exports, "register", () => $53580ab018822c7a$export$6503ec6e8aabbaf);
const $53580ab018822c7a$var$ledger = new Map();
function $53580ab018822c7a$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $53580ab018822c7a$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $53580ab018822c7a$var$ledger.set(typeKey, initial);
    return initial;
}
function $53580ab018822c7a$export$6503ec6e8aabbaf(args) {
    const entry = $53580ab018822c7a$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $53580ab018822c7a$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("lT6hX", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $98e2944b83c0b821$export$47d10e7bd9c81890);

var $kwu91 = parcelRequire("kwu91");

var $7uTDU = parcelRequire("7uTDU");

var $9MNzu = parcelRequire("9MNzu");
function $98e2944b83c0b821$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $98e2944b83c0b821$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $kwu91.combine)((0, $9MNzu.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $7uTDU.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        var _args$getData, _args$getDropEffect;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = ((_args$getData = args.getData) === null || _args$getData === void 0 ? void 0 : _args$getData.call(args, feedback)) ?? {};
        const dropEffect = ((_args$getDropEffect = args.getDropEffect) === null || _args$getDropEffect === void 0 ? void 0 : _args$getDropEffect.call(args, feedback)) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            var _entry$eventName;
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                var _entry$onDropTargetCh;
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) {
                    var _entry$onDragLeave;
                    entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                }
            }
            for (const record of payload.location.current.dropTargets){
                var _entry$onDropTargetCh2, _entry$onDragEnter;
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry === null || entry === void 0 || (_entry$onDropTargetCh2 = entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(entry, args);
                entry === null || entry === void 0 || (_entry$onDragEnter = entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(entry, args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $98e2944b83c0b821$var$copyReverse(current);
        const actualCaptureOrdered = $98e2944b83c0b821$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $98e2944b83c0b821$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("9MNzu", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $9bbd1030ed471ba5$export$5dcb5c23b6ba980a);
function $9bbd1030ed471ba5$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("1qklf", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $aee95b941b0a2928$export$5dd4ed888d5b12ca);

var $7uTDU = parcelRequire("7uTDU");
function $aee95b941b0a2928$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $7uTDU.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) {
            var _monitor$eventName;
            // @ts-expect-error: I cannot get this type working!
            (_monitor$eventName = monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(monitor, payload);
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("1fm5X", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $8a2850350679501d$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $8a2850350679501d$export$aceb3ed8b7f7bd2c);

var $7uTDU = parcelRequire("7uTDU");
const $8a2850350679501d$export$a11b0059900ceec8 = (0, $7uTDU.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $8a2850350679501d$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("57EOl", function(module, exports) {
$parcel$export(module.exports, "textMediaType", () => $ac36dcbdc7e6e9f8$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $ac36dcbdc7e6e9f8$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("fG7Zt", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", () => $8d9b6a39dc5cbd97$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $8d9b6a39dc5cbd97$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("cS5xW", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $86766ec1cc25825b$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $86766ec1cc25825b$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("CViuw", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $13c783daa4634fe0$export$a74bff2507e6126b);
parcelRequire("jZTIs");
var $kwu91 = parcelRequire("kwu91");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $13c783daa4634fe0$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $13c783daa4634fe0$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $13c783daa4634fe0$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$13c783daa4634fe0$var$hasSameOrigin(window.location.href, iframe.src);
}
const $13c783daa4634fe0$var$registry = new Map();
function $13c783daa4634fe0$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($13c783daa4634fe0$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $13c783daa4634fe0$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $13c783daa4634fe0$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $13c783daa4634fe0$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $13c783daa4634fe0$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $kwu91.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $13c783daa4634fe0$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $13c783daa4634fe0$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("k8nMG", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $239881ef876c18af$export$27d79116d3a4e7d5);
parcelRequire("1PwWC");
var $ka1oC = parcelRequire("ka1oC");

var $CViuw = parcelRequire("CViuw");
function $239881ef876c18af$var$watchForInteractionStart({ start: start }) {
    return (0, $ka1oC.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $239881ef876c18af$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $ka1oC.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $239881ef876c18af$var$api = (0, $CViuw.makeFixForAdapter)({
    watchForInteractionStart: $239881ef876c18af$var$watchForInteractionStart,
    watchForInteractionEnd: $239881ef876c18af$var$watchForInteractionEnd
});
function $239881ef876c18af$export$27d79116d3a4e7d5() {
    return $239881ef876c18af$var$api.registerUsage();
}

});
parcelRegister("1PwWC", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("ka1oC")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("ka1oC")).dropTargetForExternal);

var $ka1oC = parcelRequire("ka1oC");

});
parcelRegister("ka1oC", function(module, exports) {
$parcel$export(module.exports, "dropTargetForExternal", () => $d52a187e15cca6de$export$9edc779df9a85289);
$parcel$export(module.exports, "monitorForExternal", () => $d52a187e15cca6de$export$bb1740f3194979c1);

var $36kyW = parcelRequire("36kyW");

var $7pYVe = parcelRequire("7pYVe");

var $1fm5X = parcelRequire("1fm5X");

var $gsNgE = parcelRequire("gsNgE");

var $dvVsu = parcelRequire("dvVsu");

var $57EOl = parcelRequire("57EOl");

var $cS5xW = parcelRequire("cS5xW");
function $d52a187e15cca6de$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $cS5xW.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $57EOl.textMediaType) && value === (0, $1fm5X.androidFallbackText)) return false;
    return true;
}
function $d52a187e15cca6de$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$d52a187e15cca6de$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $d52a187e15cca6de$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $d52a187e15cca6de$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $d52a187e15cca6de$var$didDragStartLocally = false;
const $d52a187e15cca6de$var$adapter = (0, $7pYVe.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $36kyW.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($d52a187e15cca6de$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $gsNgE.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $d52a187e15cca6de$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $d52a187e15cca6de$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$d52a187e15cca6de$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $d52a187e15cca6de$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $d52a187e15cca6de$var$adapter.dropTarget(args);
}
function $d52a187e15cca6de$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $d52a187e15cca6de$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $d52a187e15cca6de$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $d52a187e15cca6de$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $36kyW.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $dvVsu.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $36kyW.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $d52a187e15cca6de$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("gsNgE", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $d1f5283b781faa31$export$d1c6f249e893cdf4);

var $3XWgT = parcelRequire("3XWgT");

var $f9i1w = parcelRequire("f9i1w");

var $1DvPX = parcelRequire("1DvPX");

var $cLf1K = parcelRequire("cLf1K");
function $d1f5283b781faa31$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $f9i1w.isSafari)()) return (0, $1DvPX.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $3XWgT.isFirefox)()) return (0, $cLf1K.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("hmfOv", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $447ff8e6bef060c0$export$9c0606fcefb5d1e2);

var $36kyW = parcelRequire("36kyW");
parcelRequire("jZTIs");
var $kwu91 = parcelRequire("kwu91");
parcelRequire("eV2XM");
var $hKKgX = parcelRequire("hKKgX");

var $CViuw = parcelRequire("CViuw");
function $447ff8e6bef060c0$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $36kyW.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $hKKgX.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $kwu91.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $447ff8e6bef060c0$var$watchForInteractionStart({ start: start }) {
    return (0, $36kyW.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $447ff8e6bef060c0$var$api = (0, $CViuw.makeFixForAdapter)({
    watchForInteractionStart: $447ff8e6bef060c0$var$watchForInteractionStart,
    watchForInteractionEnd: $447ff8e6bef060c0$var$watchForInteractionEnd
});
function $447ff8e6bef060c0$export$9c0606fcefb5d1e2() {
    return $447ff8e6bef060c0$var$api.registerUsage();
}

});
parcelRegister("eV2XM", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("hKKgX")).monitorForTextSelection);

var $hKKgX = parcelRequire("hKKgX");

});
parcelRegister("hKKgX", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $f15130b5be47c663$export$2e178e3647f5e6e9);

var $36kyW = parcelRequire("36kyW");

var $c5QP3 = parcelRequire("c5QP3");

var $7pYVe = parcelRequire("7pYVe");

var $kwu91 = parcelRequire("kwu91");

var $f9i1w = parcelRequire("f9i1w");

var $8OZQj = parcelRequire("8OZQj");

var $57EOl = parcelRequire("57EOl");

var $cS5xW = parcelRequire("cS5xW");
function $f15130b5be47c663$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $f9i1w.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $57EOl.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $f15130b5be47c663$var$honeyPotFix = (0, $c5QP3.makeHoneyPotFix)();
const $f15130b5be47c663$var$adapter = (0, $7pYVe.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $kwu91.combine)($f15130b5be47c663$var$honeyPotFix.bindEvents(), (0, $36kyW.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $cS5xW.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $57EOl.textMediaType))) return;
                const target = $f15130b5be47c663$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $57EOl.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $8OZQj.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $f15130b5be47c663$var$honeyPotFix.getOnPostDispatch()
});
function $f15130b5be47c663$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $f15130b5be47c663$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $f15130b5be47c663$var$adapter.registerUsage();
})();
function $f15130b5be47c663$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $f15130b5be47c663$var$adapter.monitor(args);
}

});
parcelRegister("8OZQj", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", () => $ca3b46dd6d38d3da$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $ca3b46dd6d38d3da$export$338a9f6c7a1f02b0 = 'text/html';

});




parcelRegister("5VcKs", function(module, exports) {
$parcel$export(module.exports, "width", () => $f36b290b35581bc9$export$7e3df82ee760448c);
const $f36b290b35581bc9$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});

parcelRegister("cAZwz", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd6f91ea9ab670bb$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $j1C0s = parcelRequire("j1C0s");

var $41dEz = parcelRequire("41dEz");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $dd6f91ea9ab670bb$var$positionerStyles = null;
const $dd6f91ea9ab670bb$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
const $dd6f91ea9ab670bb$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $dd6f91ea9ab670bb$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $dd6f91ea9ab670bb$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $dd6f91ea9ab670bb$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $41dEz.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $j1C0s.easeInOut)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $8n1kL.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $dd6f91ea9ab670bb$var$stackStyles.stackTransition,
            stackIndex > 0 ? $dd6f91ea9ab670bb$var$stackStyles.stackTransform : $dd6f91ea9ab670bb$var$stackStyles.stackIdle,
            $dd6f91ea9ab670bb$var$scrollStyles[scrollBehavior]
        ]),
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dd6f91ea9ab670bb$export$2e2bcd8739ae039 = $dd6f91ea9ab670bb$var$Positioner;

});




parcelRegister("7KiOn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0335cdcf836f19f4$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");
parcelRequire("8P7DW");

var $LNry5 = parcelRequire("LNry5");

var $4pgQo = parcelRequire("4pgQo");

var $1hTMA = parcelRequire("1hTMA");

var $5NKIF = parcelRequire("5NKIF");
const $0335cdcf836f19f4$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $0335cdcf836f19f4$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $4pgQo.useModal)();
    const shouldScrollInViewport = (0, $5NKIF.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            $0335cdcf836f19f4$var$styles.root,
            hasInlinePadding && $0335cdcf836f19f4$var$styles.paddingInline
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $LNry5.TouchScrollable), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1hTMA.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                "data-testid": testId,
                className: (0, $8n1kL.default)([
                    $0335cdcf836f19f4$var$styles.root,
                    /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ $0335cdcf836f19f4$var$styles.paddingBlock,
                    hasInlinePadding && $0335cdcf836f19f4$var$styles.paddingInline
                ]),
                children: children
            })
        })
    });
};
var $0335cdcf836f19f4$export$2e2bcd8739ae039 = $0335cdcf836f19f4$var$ModalBody;

});
parcelRegister("4pgQo", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $6c8f76dc208c4160$export$33ffd74ebf07f060);

var $8P7DW = parcelRequire("8P7DW");

var $dueQD = parcelRequire("dueQD");
const $6c8f76dc208c4160$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $8P7DW.useContext)((0, $dueQD.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("1hTMA", function(module, exports) {
$parcel$export(module.exports, "default", () => $40dbdca70e9617bb$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* scroll-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $a4Hdp = parcelRequire("a4Hdp");

var $6NJAV = parcelRequire("6NJAV");

var $klxUK = parcelRequire("klxUK");

var $5J6r2 = parcelRequire("5J6r2");

var $VA7Bl = parcelRequire("VA7Bl");

var $h5g2M = parcelRequire("h5g2M");
const $40dbdca70e9617bb$var$keylineColor = "var(--ds-border, #0B120E24)";
const $40dbdca70e9617bb$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm21uh4",
    bottomKeyline: "_179r1uh4"
};
const $40dbdca70e9617bb$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $40dbdca70e9617bb$var$ScrollContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $8P7DW.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $8P7DW.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $8P7DW.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $8P7DW.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $8P7DW.useEffect)(()=>{
        const schedule = (0, $a4Hdp.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $VA7Bl.default)((0, $a4Hdp.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $40dbdca70e9617bb$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $40dbdca70e9617bb$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $8P7DW.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $36kyW.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $36kyW.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $5J6r2.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $h5g2M.default), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $klxUK.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $6NJAV.cx)($40dbdca70e9617bb$var$styles.base, showTopKeyline && $40dbdca70e9617bb$var$styles.topKeyline, showBottomKeyline && $40dbdca70e9617bb$var$styles.bottomKeyline),
        children: children
    });
});
$40dbdca70e9617bb$var$ScrollContainer.displayName = 'ScrollContainer';
var $40dbdca70e9617bb$export$2e2bcd8739ae039 = $40dbdca70e9617bb$var$ScrollContainer;

});

parcelRegister("5NKIF", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf85284a38829cea$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $dueQD = parcelRequire("dueQD");
function $bf85284a38829cea$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $8P7DW.useContext)((0, $dueQD.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("e3bZD", function(module, exports) {
$parcel$export(module.exports, "ModalBody", () => $9ca2bea383d5f388$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $9ca2bea383d5f388$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $9ca2bea383d5f388$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $9ca2bea383d5f388$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $9ca2bea383d5f388$export$c245e9f76e3299b1);
/* modal.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $2CGHX = parcelRequire("2CGHX");
const $9ca2bea383d5f388$var$modalBodyStyles = null;
const $9ca2bea383d5f388$var$modalHeadingStyles = null;
const $9ca2bea383d5f388$var$modalImageStyles = null;
const $9ca2bea383d5f388$var$modalActionContainerStyles = null;
const $9ca2bea383d5f388$var$modalActionContainerReversedStyles = null;
const $9ca2bea383d5f388$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
};
const $9ca2bea383d5f388$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $8n1kL.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ]),
        children: children
    });
const $9ca2bea383d5f388$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("h1", {
        id: id,
        className: (0, $8n1kL.default)([
            "_11c81af2 _syaz1kw7 _6rthu2gc"
        ]),
        children: children
    });
};
const $9ca2bea383d5f388$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ (0, $gWgPx.jsx)("img", {
        alt: alt,
        src: src,
        className: (0, $8n1kL.default)([
            "_1bsb1osq _4t3i1wug _5fbcfajl _1s1gfajl _j722idpf"
        ])
    });
const $9ca2bea383d5f388$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $8n1kL.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ]),
        children: children
    });
const $9ca2bea383d5f388$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        xcss: $9ca2bea383d5f388$var$modalActionItemStyles.root,
        children: children
    });

});

parcelRegister("aPQZD", function(module, exports) {
$parcel$export(module.exports, "spotlightButtonTheme", () => $878eab5529646ef9$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $878eab5529646ef9$export$d131eb21ba4cbd16);
const $878eab5529646ef9$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #17171708)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #080F214A)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #803FA5)",
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $878eab5529646ef9$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #964AC0)",
            hover: "var(--ds-background-discovery-bold-hovered, #803FA5)",
            active: "var(--ds-background-discovery-bold-pressed, #673286)",
            disabled: {
                light: "var(--ds-background-disabled, #17171708)",
                dark: "var(--ds-background-disabled, #17171708)"
            },
            selected: "var(--ds-background-selected-hovered, #CFE1FD)",
            focus: "var(--ds-background-discovery-bold-hovered, #803FA5)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $878eab5529646ef9$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $878eab5529646ef9$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$878eab5529646ef9$var$extract($878eab5529646ef9$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $878eab5529646ef9$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$878eab5529646ef9$var$extract($878eab5529646ef9$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});





parcelRegister("jzxjj", function(module, exports) {
$parcel$export(module.exports, "default", () => $43ba23e515a63f4a$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $k7ZVu = parcelRequire("k7ZVu");

var $6Xpch = parcelRequire("6Xpch");

var $3d3Kd = parcelRequire("3d3Kd");

var $jBcb7 = parcelRequire("jBcb7");
const $43ba23e515a63f4a$var$EngagementProviderWithEvents = (0, $k7ZVu.default)()((0, $jBcb7.EngagementProvider));
const $43ba23e515a63f4a$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($43ba23e515a63f4a$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $3d3Kd.default)(props.config)
    });
};
var $43ba23e515a63f4a$export$2e2bcd8739ae039 = (0, $6Xpch.default)($43ba23e515a63f4a$var$EngagementProviderWithDefaultStore);

});
parcelRegister("6Xpch", function(module, exports) {
$parcel$export(module.exports, "default", () => $c413355943413ffa$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $c413355943413ffa$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(PreventNestedInstancesContext.Consumer, null, (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(PreventNestedInstancesContext.Provider, {
                value: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, props))));
    };
}

});

parcelRegister("3d3Kd", function(module, exports) {
$parcel$export(module.exports, "store", () => $fb244a9ec8768131$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $fb244a9ec8768131$export$2e2bcd8739ae039);

var $77MDz = parcelRequire("77MDz");
parcelRequire("haxwJ");
var $14lC8 = parcelRequire("14lC8");

var $ep36p = parcelRequire("ep36p");

var $4GcnO = parcelRequire("4GcnO");

var $2Z41b = parcelRequire("2Z41b");

var $eC7qf = parcelRequire("eC7qf");
const $fb244a9ec8768131$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $fb244a9ec8768131$var$processMessagesCancellationToken = (0, $ep36p.createCancellationToken)();
function $fb244a9ec8768131$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($77MDz)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $fb244a9ec8768131$export$6f57813fe9f31bf9 = (0, $14lC8.default)((state = $fb244a9ec8768131$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $2Z41b.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $2Z41b.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $2Z41b.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $fb244a9ec8768131$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $2Z41b.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $2Z41b.RESET_STORE:
            return $fb244a9ec8768131$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $fb244a9ec8768131$export$2e2bcd8739ae039 = (config)=>{
    const state = $fb244a9ec8768131$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $fb244a9ec8768131$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $fb244a9ec8768131$var$processMessagesCancellationToken.isCancelled = true;
        $fb244a9ec8768131$var$processMessagesCancellationToken = (0, $ep36p.createCancellationToken)();
        $fb244a9ec8768131$export$6f57813fe9f31bf9.dispatch((0, $2Z41b.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $fb244a9ec8768131$export$6f57813fe9f31bf9.dispatch((0, $2Z41b.initialize)(newConfig));
    if ((0, $4GcnO.isMessagingEnabled)()) (0, $eC7qf.processMessages)($fb244a9ec8768131$export$6f57813fe9f31bf9, newConfig, $fb244a9ec8768131$var$processMessagesCancellationToken);
    return $fb244a9ec8768131$export$6f57813fe9f31bf9;
};

});
parcelRegister("77MDz", function(module, exports) {

var $lrTfh = parcelRequire("lrTfh");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $52feea2cfd463389$var$isEqual(value, other) {
    return $lrTfh(value, other);
}
module.exports = $52feea2cfd463389$var$isEqual;

});

parcelRegister("ep36p", function(module, exports) {
$parcel$export(module.exports, "createCancellationToken", () => $a6677ff9ecca36e9$export$eac027797b968991);
function $a6677ff9ecca36e9$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("4GcnO", function(module, exports) {
$parcel$export(module.exports, "isMessagingEnabled", () => $3f7ed4a21b8e4897$export$a77934ac158768dd);

var $1lG1b = parcelRequire("1lG1b");
function $3f7ed4a21b8e4897$export$a77934ac158768dd() {
    return !(0, $1lG1b.isFedRamp)();
}

});

parcelRegister("2Z41b", function(module, exports) {
$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $7dca0d7f8ca32289$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $7dca0d7f8ca32289$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $7dca0d7f8ca32289$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $7dca0d7f8ca32289$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $7dca0d7f8ca32289$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $7dca0d7f8ca32289$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $7dca0d7f8ca32289$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $7dca0d7f8ca32289$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $7dca0d7f8ca32289$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $7dca0d7f8ca32289$export$96105f873ade39d7);
const $7dca0d7f8ca32289$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $7dca0d7f8ca32289$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $7dca0d7f8ca32289$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $7dca0d7f8ca32289$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $7dca0d7f8ca32289$export$a9319af002a4c677 = 'SET_CURRENT';
const $7dca0d7f8ca32289$export$a20a1205b2a2b7e4 = ()=>({
        type: $7dca0d7f8ca32289$export$874c5149d7f0e3b8
    });
const $7dca0d7f8ca32289$export$2a47f398eeff8b01 = (config)=>({
        type: $7dca0d7f8ca32289$export$eacd3ec165715d8,
        config: config
    });
const $7dca0d7f8ca32289$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $7dca0d7f8ca32289$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $7dca0d7f8ca32289$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $7dca0d7f8ca32289$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $7dca0d7f8ca32289$export$96105f873ade39d7() {
    return {
        type: $7dca0d7f8ca32289$export$cb5041d68cb18859
    };
}

});

parcelRegister("eC7qf", function(module, exports) {
$parcel$export(module.exports, "processMessages", () => $c16b83e985a9a1a0$export$d2e92820f98a2592);

var $cgMJY = parcelRequire("cgMJY");

var $2Z41b = parcelRequire("2Z41b");

var $3d3Kd = parcelRequire("3d3Kd");
const $c16b83e985a9a1a0$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $c16b83e985a9a1a0$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $3d3Kd.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $cgMJY.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $c16b83e985a9a1a0$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $2Z41b.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $c16b83e985a9a1a0$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});


parcelRegister("jBcb7", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => $c1d02461729b5a63$export$83b8ae7ce7b4d59c);
/* eslint-disable max-lines */ 
var $8P7DW = parcelRequire("8P7DW");

var $3AXGs = parcelRequire("3AXGs");

var $Lg1FE = parcelRequire("Lg1FE");

var $93Fg7 = parcelRequire("93Fg7");

var $72qVa = parcelRequire("72qVa");

var $4C9Oe = parcelRequire("4C9Oe");
var $bP2rs = parcelRequire("bP2rs");

var $8H5jz = parcelRequire("8H5jz");
var $7e0Px = parcelRequire("7e0Px");

var $cgMJY = parcelRequire("cgMJY");

var $i8jxL = parcelRequire("i8jxL");

var $jBiDg = parcelRequire("jBiDg");

var $ip8aN = parcelRequire("ip8aN");

var $4GcnO = parcelRequire("4GcnO");

var $2Z41b = parcelRequire("2Z41b");

var $4F2rY = parcelRequire("4F2rY");
const $c1d02461729b5a63$var$MAX_EVENT_QUEUE_SIZE = 100;
const $c1d02461729b5a63$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $c1d02461729b5a63$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $c1d02461729b5a63$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $c1d02461729b5a63$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($3AXGs)))(payload, trigger);
    });
}
function $c1d02461729b5a63$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $4C9Oe.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $c1d02461729b5a63$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $c1d02461729b5a63$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $c1d02461729b5a63$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $cgMJY.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $cgMJY.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $c1d02461729b5a63$var$fireExposureEvent($c1d02461729b5a63$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $cgMJY.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions !== null && coordinationOptions !== void 0 && coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $8H5jz.MessageDeliveryStatus).STARTED : (0, $8H5jz.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $c1d02461729b5a63$var$fireExposureEvent($c1d02461729b5a63$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $2Z41b.setCurrent)(eventMapping));
        }
    } else {
        $c1d02461729b5a63$var$fireExposureEvent($c1d02461729b5a63$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $2Z41b.setCurrent)(eventMapping));
    }
}
class $c1d02461729b5a63$export$83b8ae7ce7b4d59c extends (0, $8P7DW.Component) {
    static #_ = this.componentConfig = new Map();
    static #_2 = this.childContextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func
    };
    static #_3 = this.defaultProps = {
        eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($72qVa)))
    };
    static #_4 = /*
   * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
   * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
   */ this.hasInitializedAtLeastOneEngagementProvider = false;
    constructor(props){
        super(props), this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$c1d02461729b5a63$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $jBiDg.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $c1d02461729b5a63$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $c1d02461729b5a63$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        }, this.onEvent = (event)=>{
            var _eventMapping$compone;
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $c1d02461729b5a63$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $ip8aN.default)({
                eventName: $c1d02461729b5a63$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $4GcnO.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $c1d02461729b5a63$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if ((_eventMapping$compone = eventMapping.component) !== null && _eventMapping$compone !== void 0 && _eventMapping$compone.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $c1d02461729b5a63$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $c1d02461729b5a63$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        }, this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $c1d02461729b5a63$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        }, this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        }, this.getComponentCoordinationOptions = (componentConfig)=>{
            var _this$props$coordinat;
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean((_this$props$coordinat = this.props.coordinationOptions) === null || _this$props$coordinat === void 0 ? void 0 : _this$props$coordinat.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig !== null && componentConfig !== void 0 && componentConfig.messageType ? // Use the component's individual choreographer configuration, if defined,
                // regardless of the EngagementProvider's coordinationOptions
                (0, $7e0Px.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        }, this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        }, this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $c1d02461729b5a63$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        }, this.removeComponentConfig = (configId)=>{
            if ($c1d02461729b5a63$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $c1d02461729b5a63$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $i8jxL.sendUIEvent).bind(null, analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $i8jxL.sendScreenEvent).bind(null, analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $i8jxL.sendOperationalEvent).bind(null, analyticsClientInstance);
        this.analyticsEventQueue = new (0, $4F2rY.default)($c1d02461729b5a63$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($Lg1FE)))(// TODO: create metric for this with Metal
        ()=>{});
    }
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $cgMJY.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $8H5jz.MessageDeliveryStatus).STOPPED : (0, $8H5jz.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $c1d02461729b5a63$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $2Z41b.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bP2rs.default), {
            channel: "*",
            onEvent: this.onEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bP2rs.default), {
            channel: "engagement",
            onEvent: this.onEngagementEvent
        }, this.props.children));
    }
}

});
parcelRegister("3AXGs", function(module, exports) {

var $6DGSm = parcelRequire("6DGSm");

var $fqBKL = parcelRequire("fqBKL");
/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */ function $29e307db91b6e08e$var$isMatch(object, source) {
    return object === source || $6DGSm(object, source, $fqBKL(source));
}
module.exports = $29e307db91b6e08e$var$isMatch;

});

parcelRegister("Lg1FE", function(module, exports) {

var $eKn4z = parcelRequire("eKn4z");
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $08e0d251ff2d9e62$var$once(func) {
    return $eKn4z(2, func);
}
module.exports = $08e0d251ff2d9e62$var$once;

});
parcelRegister("eKn4z", function(module, exports) {

var $fB6fn = parcelRequire("fB6fn");
/** Error message constants. */ var $abc7425a42394940$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $abc7425a42394940$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($abc7425a42394940$var$FUNC_ERROR_TEXT);
    n = $fB6fn(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
module.exports = $abc7425a42394940$var$before;

});
parcelRegister("fB6fn", function(module, exports) {

var $198BJ = parcelRequire("198BJ");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $b5af283fcac1845a$var$toInteger(value) {
    var result = $198BJ(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $b5af283fcac1845a$var$toInteger;

});
parcelRegister("198BJ", function(module, exports) {

var $lPeXJ = parcelRequire("lPeXJ");
/** Used as references for various `Number` constants. */ var $0d5d4ef97573502b$var$INFINITY = 1 / 0, $0d5d4ef97573502b$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $0d5d4ef97573502b$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $lPeXJ(value);
    if (value === $0d5d4ef97573502b$var$INFINITY || value === -$0d5d4ef97573502b$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $0d5d4ef97573502b$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $0d5d4ef97573502b$var$toFinite;

});
parcelRegister("lPeXJ", function(module, exports) {

var $7i9NB = parcelRequire("7i9NB");

var $j7DJp = parcelRequire("j7DJp");

var $jK5ch = parcelRequire("jK5ch");
/** Used as references for various `Number` constants. */ var $fe39f799e8a14bef$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $fe39f799e8a14bef$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $fe39f799e8a14bef$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $fe39f799e8a14bef$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $fe39f799e8a14bef$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $fe39f799e8a14bef$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($jK5ch(value)) return $fe39f799e8a14bef$var$NAN;
    if ($j7DJp(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $j7DJp(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $7i9NB(value);
    var isBinary = $fe39f799e8a14bef$var$reIsBinary.test(value);
    return isBinary || $fe39f799e8a14bef$var$reIsOctal.test(value) ? $fe39f799e8a14bef$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $fe39f799e8a14bef$var$reIsBadHex.test(value) ? $fe39f799e8a14bef$var$NAN : +value;
}
module.exports = $fe39f799e8a14bef$var$toNumber;

});
parcelRegister("7i9NB", function(module, exports) {

var $k3Gno = parcelRequire("k3Gno");
/** Used to match leading whitespace. */ var $54f1d0bcbd88a396$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $54f1d0bcbd88a396$var$baseTrim(string) {
    return string ? string.slice(0, $k3Gno(string) + 1).replace($54f1d0bcbd88a396$var$reTrimStart, '') : string;
}
module.exports = $54f1d0bcbd88a396$var$baseTrim;

});
parcelRegister("k3Gno", function(module, exports) {
/** Used to match a single whitespace character. */ var $03c4b9a31625d820$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $03c4b9a31625d820$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $03c4b9a31625d820$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $03c4b9a31625d820$var$trimmedEndIndex;

});







parcelRegister("72qVa", function(module, exports) {
'use strict';
module.exports = typeof self === 'object' && self.self === self && self || typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("i8jxL", function(module, exports) {
$parcel$export(module.exports, "sendScreenEvent", () => $13c5afcc44300d57$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $13c5afcc44300d57$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $13c5afcc44300d57$export$e5f89b51c6d4e36b);
function $13c5afcc44300d57$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $13c5afcc44300d57$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $13c5afcc44300d57$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("jBiDg", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $c96fc790cbc1d2a0$export$6c724a6ffa2dc3e1);
const $c96fc790cbc1d2a0$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $c96fc790cbc1d2a0$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $c96fc790cbc1d2a0$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $c96fc790cbc1d2a0$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $c96fc790cbc1d2a0$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $c96fc790cbc1d2a0$export$cda2203640e08931;
}

});

parcelRegister("ip8aN", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdb8b2fcd1067c15$export$2e2bcd8739ae039);
const $bdb8b2fcd1067c15$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $bdb8b2fcd1067c15$export$2e2bcd8739ae039 = $bdb8b2fcd1067c15$var$createCustomEvent;

});

parcelRegister("4F2rY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6efabc63843ad3b$export$2e2bcd8739ae039);
class $d6efabc63843ad3b$export$2e2bcd8739ae039 {
    constructor(maxSize){
        this.queue = [];
        this.maxSize = maxSize;
    }
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
}

});





parcelRegister("81vfS", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagProvider", () => (parcelRequire("liIpM")).default);

var $4tj32 = parcelRequire("4tj32");
parcelRequire("8DW6Q");
var $liIpM = parcelRequire("liIpM");

});
parcelRegister("4tj32", function(module, exports) {

var $8P7DW = parcelRequire("8P7DW");

var $1We2B = parcelRequire("1We2B");
parcelRequire("8DW6Q");
var $liIpM = parcelRequire("liIpM");
const $036b2f5c748892ff$var$FeatureFlag = ({ children: children, name: name, defaultValue: defaultValue, showIf: showIf = 'enabled' })=>{
    const flags = (0, $8P7DW.useContext)((0, $liIpM.FeatureFlagsContext));
    let value = defaultValue;
    if ((0, $1We2B.has)(flags, name)) value = !!flags[name];
    const shouldShow = showIf === 'enabled' ? value : !value;
    return shouldShow ? children : null;
};
var $036b2f5c748892ff$export$2e2bcd8739ae039 = $036b2f5c748892ff$var$FeatureFlag;

});
parcelRegister("8DW6Q", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagProvider", () => (parcelRequire("liIpM")).default);
$parcel$export(module.exports, "FeatureFlagsContext", () => (parcelRequire("liIpM")).FeatureFlagsContext);

var $liIpM = parcelRequire("liIpM");

});
parcelRegister("liIpM", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagsContext", () => $f3be3f63b91714d1$export$778f04ce1f3940a0);
$parcel$export(module.exports, "default", () => $f3be3f63b91714d1$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $f3be3f63b91714d1$export$778f04ce1f3940a0 = /*#__PURE__*/ $8P7DW.createContext({});
const $f3be3f63b91714d1$var$FeatureFlagProvider = ({ featureFlags: featureFlags, children: children })=>/*#__PURE__*/ $8P7DW.createElement($f3be3f63b91714d1$export$778f04ce1f3940a0.Provider, {
        value: featureFlags
    }, children);
var $f3be3f63b91714d1$export$2e2bcd8739ae039 = $f3be3f63b91714d1$var$FeatureFlagProvider;

});




parcelRegister("80NsQ", function(module, exports) {
$parcel$export(module.exports, "TFECacheProvider", () => (parcelRequire("kSAgc")).TFECacheProvider);

var $kSAgc = parcelRequire("kSAgc");

});
parcelRegister("kSAgc", function(module, exports) {
$parcel$export(module.exports, "TFECacheProvider", () => $57b849a8c4c8a3b0$export$55b822f5d1bfb2cf);

var $8P7DW = parcelRequire("8P7DW");

var $fDcSZ = parcelRequire("fDcSZ");

var $e4nGD = parcelRequire("e4nGD");

var $1VL3J = parcelRequire("1VL3J");

var $MmGmU = parcelRequire("MmGmU");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");

var $aIQ9W = parcelRequire("aIQ9W");
parcelRequire("guhTh");
var $knD7Z = parcelRequire("knD7Z");
const $57b849a8c4c8a3b0$var$FIVE_MINUTE_IN_SECONDS = 300;
const $57b849a8c4c8a3b0$var$batchedGetExtensions = (0, $aIQ9W.default)((0, $e4nGD.fetchTFExtensions), 0);
const $57b849a8c4c8a3b0$var$batchedGetExtensionsV2 = (0, $1VL3J.default)((0, $e4nGD.fetchTFExtensions), 0);
const $57b849a8c4c8a3b0$export$55b822f5d1bfb2cf = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const cacheRef = $8P7DW.useRef(new (0, (/*@__PURE__*/$parcel$interopDefault($fDcSZ)))({
        stdTTL: $57b849a8c4c8a3b0$var$FIVE_MINUTE_IN_SECONDS,
        checkperiod: $57b849a8c4c8a3b0$var$FIVE_MINUTE_IN_SECONDS * 0.5,
        useClones: false
    }));
    const getExtensionsByType = (type, page)=>{
        const extensionsByType = cacheRef.current.get(type);
        if (extensionsByType) return Promise.resolve({
            [type]: extensionsByType
        });
        const promise = $57b849a8c4c8a3b0$var$batchedGetExtensions(type);
        promise.then((fetchedExtensions)=>{
            const allFetchedExtensionsForCache = [];
            for(const property in fetchedExtensions)if (Object.prototype.hasOwnProperty.call(fetchedExtensions, property)) allFetchedExtensionsForCache.push({
                key: property,
                val: fetchedExtensions[property]
            });
            cacheRef.current.mset(allFetchedExtensionsForCache);
        }).catch((e)=>{
            (0, $9ypa9.trackError)('forge-tfe.setCache.failed', {}, e);
            const event = createAnalyticsEvent({
                action: 'failed',
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'fetchForgeTFE',
                attributes: {
                    page: page,
                    moduleType: type,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    statusCode: e.status,
                    error: JSON.stringify(e)
                }
            });
            event.context.push({
                componentName: 'fetchForgeTFE'
            });
            event.fire();
        });
        return promise;
    };
    const getExtensionsByTypeV2 = (type, resourceContext, page)=>{
        const { resourceId: resourceId } = resourceContext || {};
        const key = constructKey(resourceId, type);
        const extensionsByType = cacheRef.current.get(key);
        if (extensionsByType) return Promise.resolve({
            [type]: extensionsByType
        });
        const promise = $57b849a8c4c8a3b0$var$batchedGetExtensionsV2(type, resourceContext);
        promise.then((fetchedExtensions)=>{
            const allFetchedExtensionsForCache = [];
            for(const property in fetchedExtensions)if (Object.prototype.hasOwnProperty.call(fetchedExtensions, property)) allFetchedExtensionsForCache.push({
                key: constructKey(resourceId, property),
                val: fetchedExtensions[property]
            });
            cacheRef.current.mset(allFetchedExtensionsForCache);
        }).catch((e)=>{
            (0, $9ypa9.trackError)('forge-tfe.setCache.failed', {}, e);
            const event = createAnalyticsEvent({
                action: 'failed',
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'fetchForgeTFE',
                attributes: {
                    page: page,
                    moduleType: type,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    statusCode: e.status,
                    error: JSON.stringify(e)
                }
            });
            event.context.push({
                componentName: 'fetchForgeTFE'
            });
            event.fire();
        });
        return promise;
    };
    const constructKey = (resourceId, property)=>resourceId ? resourceId.concat('-'.concat(property)) : property;
    return /*#__PURE__*/ $8P7DW.createElement((0, $knD7Z.TFECacheContext).Provider, {
        value: {
            getExtensionsByType: getExtensionsByType,
            getExtensionsByTypeV2: getExtensionsByTypeV2
        }
    }, children);
};
var $57b849a8c4c8a3b0$export$2e2bcd8739ae039 = $57b849a8c4c8a3b0$export$55b822f5d1bfb2cf;

});
parcelRegister("e4nGD", function(module, exports) {
$parcel$export(module.exports, "fetchTFExtensions", () => $67d3c5a1625a3d22$export$d3cc23e3d22de5ea);

var $breWd = parcelRequire("breWd");

var $7ex17 = parcelRequire("7ex17");

var $9ypa9 = parcelRequire("9ypa9");

var $7FSs7 = parcelRequire("7FSs7");
const $67d3c5a1625a3d22$export$d3cc23e3d22de5ea = (types, resourceContext)=>{
    const uri = `${(0, $7FSs7.contextPath)}/rest/servicedesk/1/customer/servicedesk-data/forge/fetch-extensions`;
    let body;
    const { resourceType: resourceType } = resourceContext || {};
    if (resourceType === (0, $7ex17.RESOURCE_TYPE_ISSUE) || resourceType === (0, $7ex17.RESOURCE_TYPE_PROJECT)) body = {
        resourceContext: resourceContext,
        extensionTypes: types
    };
    else body = {
        extensionTypes: types
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    return (0, $breWd.post)(uri, body, headers).map(({ response: response })=>response.extensions).catch((e)=>{
        (0, $9ypa9.trackError)('forge-tfe.fetch.failed', {}, e);
        return Promise.reject(e);
    }).toPromise();
};

});
parcelRegister("7ex17", function(module, exports) {
$parcel$export(module.exports, "FORGE_HELP_CENTER", () => $dc1d0738375e3455$export$5fb35f580fb0ead9);
$parcel$export(module.exports, "FORGE_PORTAL_HOME", () => $dc1d0738375e3455$export$f54ea43d8fdbc220);
$parcel$export(module.exports, "FORGE_REQUEST_CREATE", () => $dc1d0738375e3455$export$7fba94cefb87c359);
$parcel$export(module.exports, "FORGE_REQUEST_DETAILS", () => $dc1d0738375e3455$export$bc84cd79c53ab7bc);
$parcel$export(module.exports, "FORGE_REQUEST_LIST", () => $dc1d0738375e3455$export$6089843c57d171a8);
$parcel$export(module.exports, "FORGE_PROFILE", () => $dc1d0738375e3455$export$6c0b0fa4877ce128);
$parcel$export(module.exports, "REQUEST_DETAIL_MAIN_SECTION_MODULE", () => $dc1d0738375e3455$export$a5069caad77a64d4);
$parcel$export(module.exports, "REQUEST_DETAIL_SIDE_SECTION_MODULE", () => $dc1d0738375e3455$export$6df357f715dfd2f4);
$parcel$export(module.exports, "PORTAL_HEADER_MODULE", () => $dc1d0738375e3455$export$463e8578e35a18ba);
$parcel$export(module.exports, "PORTAL_FOOTER_MODULE", () => $dc1d0738375e3455$export$70cbbad22fbf0821);
$parcel$export(module.exports, "PORTAL_SUBHEADER_MODULE", () => $dc1d0738375e3455$export$19ebf81efc141cb9);
$parcel$export(module.exports, "PROFILE_PANEL_MODULE", () => $dc1d0738375e3455$export$d47ce30c5cdcdaa7);
$parcel$export(module.exports, "USER_MENU_ACTION_SECTION_MODULE", () => $dc1d0738375e3455$export$b7f7df64576d21aa);
$parcel$export(module.exports, "REQUEST_VIEW_ACTION_MODULE", () => $dc1d0738375e3455$export$2cdcdb01b87d24f8);
$parcel$export(module.exports, "PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE", () => $dc1d0738375e3455$export$4df0942241cd5cc);
$parcel$export(module.exports, "HELP_CENTER_LAYOUT_ELEMENT_MODULE", () => $dc1d0738375e3455$export$9183c6a9b59c394c);
$parcel$export(module.exports, "CUSTOM_FIELD", () => $dc1d0738375e3455$export$522be55130e84de4);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE", () => $dc1d0738375e3455$export$96b7ba112deb79bf);
$parcel$export(module.exports, "UI_MODIFICATIONS", () => $dc1d0738375e3455$export$c1878e6e4b67d4ad);
$parcel$export(module.exports, "JIRA_MODULES", () => $dc1d0738375e3455$export$f9e7f55440c76553);
$parcel$export(module.exports, "USER_MENU_ACTION_COMPONENT", () => $dc1d0738375e3455$export$84b6b6a1a76815b6);
$parcel$export(module.exports, "REQUEST_VIEW_ACTION_COMPONENT", () => $dc1d0738375e3455$export$bec9cdaa83793785);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE", () => $dc1d0738375e3455$export$7c5d9a7c5f30e041);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT", () => $dc1d0738375e3455$export$39205aa8618a798);
$parcel$export(module.exports, "RESOURCE_TYPE_UNKNOWN", () => $dc1d0738375e3455$export$a62b153e8eb10906);
$parcel$export(module.exports, "TOP_LEVEL_COMPONENTS", () => $dc1d0738375e3455$export$fa9195e99a5ec8a7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $dc1d0738375e3455$export$2b8aeda236486576);
const $dc1d0738375e3455$export$5fb35f580fb0ead9 = 'help_center';
const $dc1d0738375e3455$export$f54ea43d8fdbc220 = 'portal';
const $dc1d0738375e3455$export$7fba94cefb87c359 = 'create_request';
const $dc1d0738375e3455$export$bc84cd79c53ab7bc = 'view_request';
const $dc1d0738375e3455$export$6089843c57d171a8 = 'my_requests';
const $dc1d0738375e3455$export$6c0b0fa4877ce128 = 'profile';
const $dc1d0738375e3455$export$a5069caad77a64d4 = 'jiraServiceManagement:portalRequestDetail';
const $dc1d0738375e3455$export$6df357f715dfd2f4 = 'jiraServiceManagement:portalRequestDetailPanel';
const $dc1d0738375e3455$export$463e8578e35a18ba = 'jiraServiceManagement:portalHeader';
const $dc1d0738375e3455$export$70cbbad22fbf0821 = 'jiraServiceManagement:portalFooter';
const $dc1d0738375e3455$export$19ebf81efc141cb9 = 'jiraServiceManagement:portalSubheader';
const $dc1d0738375e3455$export$d47ce30c5cdcdaa7 = 'jiraServiceManagement:portalProfilePanel';
const $dc1d0738375e3455$export$b7f7df64576d21aa = 'jiraServiceManagement:portalUserMenuAction';
const $dc1d0738375e3455$export$2cdcdb01b87d24f8 = 'jiraServiceManagement:portalRequestViewAction';
const $dc1d0738375e3455$export$4df0942241cd5cc = 'jiraServiceManagement:portalRequestCreatePropertyPanel';
const $dc1d0738375e3455$export$9183c6a9b59c394c = 'jiraServiceManagement:helpCenterLayoutElement';
const $dc1d0738375e3455$export$522be55130e84de4 = 'jira:customField';
const $dc1d0738375e3455$export$96b7ba112deb79bf = 'jira:customFieldType';
const $dc1d0738375e3455$export$c1878e6e4b67d4ad = 'jira:uiModifications';
const $dc1d0738375e3455$export$f9e7f55440c76553 = [
    $dc1d0738375e3455$export$522be55130e84de4,
    $dc1d0738375e3455$export$96b7ba112deb79bf,
    $dc1d0738375e3455$export$c1878e6e4b67d4ad
];
const $dc1d0738375e3455$export$84b6b6a1a76815b6 = 'PortalUserMenuAction';
const $dc1d0738375e3455$export$bec9cdaa83793785 = 'PortalRequestViewAction';
const $dc1d0738375e3455$export$7c5d9a7c5f30e041 = 'ISSUE';
const $dc1d0738375e3455$export$39205aa8618a798 = 'PROJECT';
const $dc1d0738375e3455$export$a62b153e8eb10906 = 'UNKNOWN';
const $dc1d0738375e3455$export$fa9195e99a5ec8a7 = {
    [$dc1d0738375e3455$export$a5069caad77a64d4]: 'PortalRequestDetail',
    [$dc1d0738375e3455$export$6df357f715dfd2f4]: 'PortalRequestDetailPanel',
    [$dc1d0738375e3455$export$463e8578e35a18ba]: 'PortalHeader',
    [$dc1d0738375e3455$export$70cbbad22fbf0821]: 'PortalFooter',
    [$dc1d0738375e3455$export$19ebf81efc141cb9]: 'PortalSubheader',
    [$dc1d0738375e3455$export$d47ce30c5cdcdaa7]: 'PortalProfilePanel',
    [$dc1d0738375e3455$export$4df0942241cd5cc]: 'PortalRequestCreatePropertyPanel'
};
const $dc1d0738375e3455$export$2b8aeda236486576 = 'edit';

});


parcelRegister("1VL3J", function(module, exports) {
$parcel$export(module.exports, "default", () => $b83abfcd2cda5e47$export$2e2bcd8739ae039);

var $1We2B = parcelRequire("1We2B");
const $b83abfcd2cda5e47$var$defer = ()=>{
    let resolve = ()=>{
        throw new Error('Resolve function not implememnted');
    };
    let reject = ()=>{
        throw new Error('Reject function not implemented');
    };
    const promise = new Promise((rslv, rjct)=>{
        resolve = rslv;
        reject = rjct;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
const $b83abfcd2cda5e47$var$proxyFunctionV2 = (func, wait, options = {})=>{
    const arrMap = new Map();
    const auxillaryMap = new Map();
    let deferred = $b83abfcd2cda5e47$var$defer();
    const callThenResetArgs = (arrMap1, auxillaryMap1)=>{
        try {
            const promiseArr = [];
            arrMap1.forEach((value, key)=>promiseArr.push(func(value, auxillaryMap1.get(key))));
            promiseArr.forEach((value)=>{
                deferred.resolve(value);
            });
        } catch (err) {
            deferred.reject(err);
        }
        arrMap.clear();
        auxillaryMap.clear();
        deferred = $b83abfcd2cda5e47$var$defer();
    };
    // Suppressing existing violations for the testing-library/react plugin.
    // eslint-disable-next-line testing-library/await-async-utils
    const debouncedFunc = (0, $1We2B.debounce)(callThenResetArgs, wait, options);
    return (arg, resourceContext)=>{
        const { resourceId: resourceId } = resourceContext || {};
        if (!resourceContext || resourceId === undefined) return deferred.promise;
        if (arrMap.has(resourceId)) {
            var _arrMap$get;
            if (!((_arrMap$get = arrMap.get(resourceId)) !== null && _arrMap$get !== void 0 && _arrMap$get.includes(arg))) {
                var _arrMap$get2;
                (_arrMap$get2 = arrMap.get(resourceId)) === null || _arrMap$get2 === void 0 || _arrMap$get2.push(arg);
            }
        } else {
            const arr = [];
            arr.push(arg);
            arrMap.set(resourceId, arr);
            auxillaryMap.set(resourceId, resourceContext);
        }
        debouncedFunc(arrMap, auxillaryMap);
        return deferred.promise;
    };
};
var $b83abfcd2cda5e47$export$2e2bcd8739ae039 = $b83abfcd2cda5e47$var$proxyFunctionV2;

});

parcelRegister("guhTh", function(module, exports) {
$parcel$export(module.exports, "TFECacheContext", () => (parcelRequire("knD7Z")).TFECacheContext);

var $knD7Z = parcelRequire("knD7Z");

});
parcelRegister("knD7Z", function(module, exports) {
$parcel$export(module.exports, "TFECacheContext", () => $0cf53b93909a96b3$export$2a99743cd152f1d4);

var $8P7DW = parcelRequire("8P7DW");

var $e4nGD = parcelRequire("e4nGD");

var $1VL3J = parcelRequire("1VL3J");

var $aIQ9W = parcelRequire("aIQ9W");
const $0cf53b93909a96b3$var$batchedGetExtensions = (0, $aIQ9W.default)((0, $e4nGD.fetchTFExtensions), 0);
const $0cf53b93909a96b3$var$batchedGetExtensionsV2 = (0, $1VL3J.default)((0, $e4nGD.fetchTFExtensions), 0);
const $0cf53b93909a96b3$export$2a99743cd152f1d4 = /*#__PURE__*/ $8P7DW.createContext({
    getExtensionsByType: $0cf53b93909a96b3$var$batchedGetExtensions,
    getExtensionsByTypeV2: $0cf53b93909a96b3$var$batchedGetExtensionsV2
});
$0cf53b93909a96b3$export$2a99743cd152f1d4.displayName = 'TFECacheContext';

});




parcelRegister("hGzcq", function(module, exports) {
$parcel$export(module.exports, "LazyPushingCustomizeSidebar", () => $4e3891b9620dcbe2$export$1ccd6783fcfdc887);
$parcel$export(module.exports, "SidebarPusher", () => (parcelRequire("lNFkx")).default);
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => (parcelRequire("gRzju")).CustomiseSidebarTriggerProvider);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => (parcelRequire("gRzju")).useCustomiseSidebarTriggerRef);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => (parcelRequire("gRzju")).useSetCustomiseSidebarTrigger);
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("knaHk");
var $lNFkx = parcelRequire("lNFkx");
parcelRequire("a4GOg");
var $gRzju = parcelRequire("gRzju");

const $4e3891b9620dcbe2$export$1ccd6783fcfdc887 = (0, $fGOkV.lazy)(()=>(parcelRequire("dHack")), {
    moduleId: "./src/view/common/pushing-customize-sidebar/pushing-customize-sidebar.tsx"
});

});
parcelRegister("knaHk", function(module, exports) {
$parcel$export(module.exports, "SidebarPusher", () => (parcelRequire("lNFkx")).default);
$parcel$export(module.exports, "PusherConsumer", () => (parcelRequire("lNFkx")).PusherConsumer);

var $lNFkx = parcelRequire("lNFkx");

});
parcelRegister("lNFkx", function(module, exports) {
$parcel$export(module.exports, "PusherConsumer", () => $70ce8d8014d0d48b$export$693eb5228d48f25d);
$parcel$export(module.exports, "default", () => $70ce8d8014d0d48b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $1p41U = parcelRequire("1p41U");

var $6t2I3 = parcelRequire("6t2I3");

var $b60z8 = parcelRequire("b60z8");

var $1We2B = parcelRequire("1We2B");

var $2oR5R = parcelRequire("2oR5R");
const $70ce8d8014d0d48b$var$PusherContext = /*#__PURE__*/ $8P7DW.createContext({
    onOpen: (0, $1We2B.noop),
    onClose: (0, $1We2B.noop)
});
const $70ce8d8014d0d48b$export$693eb5228d48f25d = $70ce8d8014d0d48b$var$PusherContext.Consumer;
class $70ce8d8014d0d48b$export$2e2bcd8739ae039 extends $8P7DW.Component {
    render() {
        const { children: children, className: className } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ $8P7DW.createElement($70ce8d8014d0d48b$var$PusherContext.Provider, {
            value: {
                onOpen: this.handleOpen,
                onClose: this.handleClose
            }
        }, /*#__PURE__*/ $8P7DW.createElement($70ce8d8014d0d48b$var$ContainerPusher, {
            className: className,
            isOpen: isOpen
        }, children));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false
        }, this.handleOpen = ()=>{
            this.setState({
                isOpen: true
            });
        }, this.handleClose = ()=>{
            this.setState({
                isOpen: false
            });
        };
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $70ce8d8014d0d48b$var$ContainerPusher = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-sak91x-0"
})`will-change:padding-right;transition:padding-right ${(props)=>props.isOpen ? $b60z8.timingFunctions.easeOut : $b60z8.timingFunctions.easeIn} ${(0, $2oR5R.EXPAND_TIME_MS)}ms;${(props)=>$6t2I3.applyIf(props.isOpen, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $2UsNA.css)`padding:${(0, $2oR5R.SIDEBAR_HEIGHT_SMALL_VIEWPORT)} 0 0 0;`)};${$1p41U.fromMedium.css`
        ${(props)=>$6t2I3.applyIf(props.isOpen, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $2UsNA.css)`padding:0 ${(0, $2oR5R.SIDEBAR_WIDTH_LARGE_VIEWPORT)} 0 0;`)};
    `};`;

});
parcelRegister("1p41U", function(module, exports) {
$parcel$export(module.exports, "fromCustom", () => $5ee4f7d6c8ca0a67$export$932b0cf23a178537);
$parcel$export(module.exports, "fromXSmall", () => $5ee4f7d6c8ca0a67$export$b7a79c964fba7552);
$parcel$export(module.exports, "fromSmall", () => $5ee4f7d6c8ca0a67$export$639a1bf83d3a4645);
$parcel$export(module.exports, "fromMedium", () => $5ee4f7d6c8ca0a67$export$e95a160cb61e118);
$parcel$export(module.exports, "fromLarge", () => $5ee4f7d6c8ca0a67$export$a37dde2f785d088f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $k1tWg = parcelRequire("k1tWg");
const $5ee4f7d6c8ca0a67$var$generateBreakpoint = (minSize, maxSize)=>{
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emMinSize = minSize / 16;
    const emMaxSize = maxSize && maxSize / 16;
    let mediaQuery;
    if (emMinSize && emMaxSize) mediaQuery = `(min-width: ${emMinSize}em) and (max-width: ${emMaxSize})`;
    else if (emMinSize) mediaQuery = `(min-width: ${emMinSize}em)`;
    else if (emMaxSize) mediaQuery = `(max-width: ${emMaxSize}em)`;
    const func = (strings, ...interpolations)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        (0, $2UsNA.css)`@media ${mediaQuery}{${(0, $2UsNA.css)(// @ts-expect-error -- css overloads doesn't like this, but this is the exact root type we allow, confirmed to work via Storybook
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        strings, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        ...interpolations)};}`;
    return {
        // So we get syntax highlighting easily.
        css: func
    };
};
const $5ee4f7d6c8ca0a67$export$932b0cf23a178537 = (minSize, maxSize)=>$5ee4f7d6c8ca0a67$var$generateBreakpoint(minSize, maxSize);
const $5ee4f7d6c8ca0a67$export$4da665ccee8caf55 = $5ee4f7d6c8ca0a67$var$generateBreakpoint(0, (0, $k1tWg.sizes).xxsmall);
const $5ee4f7d6c8ca0a67$export$9f4ec08b07b6fafc = $5ee4f7d6c8ca0a67$var$generateBreakpoint((0, $k1tWg.sizes).xxsmall);
const $5ee4f7d6c8ca0a67$export$b7a79c964fba7552 = $5ee4f7d6c8ca0a67$var$generateBreakpoint((0, $k1tWg.sizes).xsmall);
const $5ee4f7d6c8ca0a67$export$639a1bf83d3a4645 = $5ee4f7d6c8ca0a67$var$generateBreakpoint((0, $k1tWg.sizes).small);
const $5ee4f7d6c8ca0a67$export$e95a160cb61e118 = $5ee4f7d6c8ca0a67$var$generateBreakpoint((0, $k1tWg.sizes).medium);
const $5ee4f7d6c8ca0a67$export$a37dde2f785d088f = $5ee4f7d6c8ca0a67$var$generateBreakpoint((0, $k1tWg.sizes).large);
const $5ee4f7d6c8ca0a67$export$3621f41c276f9a6f = $5ee4f7d6c8ca0a67$var$generateBreakpoint((0, $k1tWg.sizes).xlarge);
const $5ee4f7d6c8ca0a67$export$86edc938645eb2d4 = $5ee4f7d6c8ca0a67$var$generateBreakpoint((0, $k1tWg.sizes).xxlarge);

});
parcelRegister("k1tWg", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $dfdcd392ccdb5ac4$export$c647cb0ee6e282fe);
const $dfdcd392ccdb5ac4$export$c647cb0ee6e282fe = {
    xxlarge: 1600,
    xlarge: 1440,
    large: 1280,
    medium: 960,
    small: 840,
    xsmall: 600,
    xxsmall: 480,
    tablet: 800
};

});


parcelRegister("6t2I3", function(module, exports) {
$parcel$export(module.exports, "focusRing", () => $81f313b505fc3ef9$export$8e24544ddba725ee);
$parcel$export(module.exports, "borderBox", () => $81f313b505fc3ef9$export$ed32643c9618a26);
$parcel$export(module.exports, "flexCenter", () => $81f313b505fc3ef9$export$6f9e4349aad79600);
$parcel$export(module.exports, "center", () => $81f313b505fc3ef9$export$3481c78889e8fbe8);
$parcel$export(module.exports, "breakWord", () => $81f313b505fc3ef9$export$7cb287253100bd3f);
$parcel$export(module.exports, "borderRadius", () => $81f313b505fc3ef9$export$7a57f79000377ca2);
$parcel$export(module.exports, "borderRadiusValue", () => $81f313b505fc3ef9$export$56a32ffee3e5ef01);
$parcel$export(module.exports, "clamp", () => $81f313b505fc3ef9$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "multiLineClamp", () => $81f313b505fc3ef9$export$6a2fc6dc0ea84acc);
$parcel$export(module.exports, "applyIf", () => $81f313b505fc3ef9$export$64120c40e5147be9);
$parcel$export(module.exports, "placeholder", () => $81f313b505fc3ef9$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "raiseUpOnHoverOrFocus", () => $81f313b505fc3ef9$export$44d27400011e4794);
$parcel$export(module.exports, "subtleThemeColorBackground", () => $81f313b505fc3ef9$export$b2d8a5f61fea402f);
$parcel$export(module.exports, "toolTipPrimitiveStyle", () => $81f313b505fc3ef9$export$2c414b247dcd2e5d);
$parcel$export(module.exports, "panelExpansionAnimationFix", () => $81f313b505fc3ef9$export$de6b6b015066ff26);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $9yRgH = parcelRequire("9yRgH");

var $4cxV2 = parcelRequire("4cxV2");

var $b60z8 = parcelRequire("b60z8");
/**
 * TODO: Replace with `import { focusRing, noFocusRing } from '@atlaskit/theme' when updating
 * to @atlaskit/theme@^7.x.x :-).
 */ const $81f313b505fc3ef9$var$atlaskitFocusRing = {
    focusRing: (color = "var(--ds-border-focused, #4C9AFF)", outlineWidth = 2)=>`
        &:focus {
          outline: none;
          box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
        }
      `,
    noFocusRing: ()=>`
        box-shadow: none;
      `
};
const $81f313b505fc3ef9$var$defaultFocusRing = $81f313b505fc3ef9$var$atlaskitFocusRing.focusRing();
const $81f313b505fc3ef9$var$noFocusRing = $81f313b505fc3ef9$var$atlaskitFocusRing.noFocusRing();
const $81f313b505fc3ef9$export$8e24544ddba725ee = {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    default: (0, $2UsNA.css)`&:focus-visible{${$81f313b505fc3ef9$var$defaultFocusRing};}&:focus:not(:focus-visible){outline:0;}`,
    none: $81f313b505fc3ef9$var$noFocusRing
};
const $81f313b505fc3ef9$export$ed32643c9618a26 = /*#__PURE__*/ (0, $2UsNA.css)`box-sizing:border-box;*{box-sizing:border-box;}`;
const $81f313b505fc3ef9$export$6f9e4349aad79600 = /*#__PURE__*/ (0, $2UsNA.css)`display:flex;align-items:center;justify-content:center;`;
const $81f313b505fc3ef9$export$3481c78889e8fbe8 = (position)=>(0, $2UsNA.css)`position:${position};top:50%;left:50%;transform:translate3d(-50%,-50%,0);`;
const $81f313b505fc3ef9$export$7cb287253100bd3f = /*#__PURE__*/ (0, $2UsNA.css)`white-space:pre-wrap;word-break:break-word;`;
const $81f313b505fc3ef9$export$7a57f79000377ca2 = /*#__PURE__*/ (0, $2UsNA.css)`border-radius:${"var(--ds-radius-small, 3px)"};`;
const $81f313b505fc3ef9$export$56a32ffee3e5ef01 = `${"var(--ds-radius-small, 0.25rem)"}`;
const $81f313b505fc3ef9$export$7d15b64cf5a3a4c4 = /*#__PURE__*/ (0, $2UsNA.css)`text-overflow:ellipsis;overflow:hidden;white-space:nowrap;`;
const $81f313b505fc3ef9$export$6a2fc6dc0ea84acc = (lines, lineHeight = $4cxV2.multiple(2.5).unitless)=>(0, $2UsNA.css)`display:-webkit-box;-webkit-line-clamp:${lines};-webkit-box-orient:vertical;max-height:${lineHeight * lines}px;overflow:hidden;`;
const $81f313b505fc3ef9$export$64120c40e5147be9 = (predicateResult, mixin)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $2UsNA.css)`${predicateResult ? mixin : ''};`;
const $81f313b505fc3ef9$export$c7187bbd1a7a9244 = (color)=>(0, $2UsNA.css)`&::-webkit-input-placeholder{color:${color};}&::-moz-placeholder{color:${color};opacity:1;}&::-ms-input-placeholder{color:${color};}&:-moz-placeholder{color:${color};opacity:1;}&:-ms-input-placeholder{color:${color};}`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $81f313b505fc3ef9$var$raiseUpOnHoverPsuedoElement = /*#__PURE__*/ (0, $2UsNA.css)`${$81f313b505fc3ef9$export$7a57f79000377ca2};content:'';position:absolute;top:0;left:0;right:0;bottom:0;transition:opacity ${$b60z8.speedMs.fast}ms ${$b60z8.timingFunctions.easeInOut};`;
const $81f313b505fc3ef9$export$44d27400011e4794 = (fromElevation = $9yRgH.e100, toElevation = $9yRgH.e200)=>(0, $2UsNA.css)`position:relative;transition:transform ${$b60z8.speedMs.fast}ms ${$b60z8.timingFunctions.easeInOut};&::before{${$81f313b505fc3ef9$var$raiseUpOnHoverPsuedoElement};${fromElevation};z-index:inherit;}&::after{${$81f313b505fc3ef9$var$raiseUpOnHoverPsuedoElement};${toElevation};opacity:0;z-index:inherit;}&:focus,&:hover{transform:translate3d(0,-2px,0);&::after{opacity:1;}&::before{opacity:0;}}`;
const $81f313b505fc3ef9$export$b2d8a5f61fea402f = /*#__PURE__*/ (0, $2UsNA.css)`background-image:linear-gradient(to right,rgba(255,255,255,0.85),rgba(255,255,255,0.85)),linear-gradient(to right,${(props)=>props.theme.color},${(props)=>props.theme.color});`;
// Overrides the @atlaskit/css-reset focus ring with our own
// wrapper that only shows it if you interact by keyboard.
(0, $2UsNA.injectGlobal)`a{${$81f313b505fc3ef9$export$8e24544ddba725ee.default};}`;
const $81f313b505fc3ef9$export$2c414b247dcd2e5d = /*#__PURE__*/ (0, $2UsNA.css)`color:${"var(--ds-text-inverse, #FFFFFF)"};background-color:${"var(--ds-text, #172B4D)"};padding:${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"};border-radius:${$81f313b505fc3ef9$export$7a57f79000377ca2};`;
const $81f313b505fc3ef9$export$de6b6b015066ff26 = /*#__PURE__*/ (0, $2UsNA.css)`> div > div{box-sizing:content-box;}.rah-animating{overflow:visible !important;filter:opacity(0.05);}`;

});
parcelRegister("9yRgH", function(module, exports) {
$parcel$export(module.exports, "e100", () => $d1acead68e89f87c$export$b390b459b8b8d8d0);
$parcel$export(module.exports, "e200", () => $d1acead68e89f87c$export$3c35fb2adfe0992);
$parcel$export(module.exports, "e400", () => $d1acead68e89f87c$export$3c7c047ca0ed675e);
$parcel$export(module.exports, "newElevationsFromDesignSystems", () => $d1acead68e89f87c$export$78129b34f80acd5f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $3xuD5 = parcelRequire("3xuD5");
const $d1acead68e89f87c$export$b390b459b8b8d8d0 = /*#__PURE__*/ (0, $2UsNA.css)`box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};z-index:${$3xuD5.card};`;
const $d1acead68e89f87c$export$3c35fb2adfe0992 = /*#__PURE__*/ (0, $2UsNA.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$3xuD5.dialog};`;
const $d1acead68e89f87c$export$f330dca4c33ed51f = /*#__PURE__*/ (0, $2UsNA.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 8px 16px -4px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$3xuD5.modal};`;
const $d1acead68e89f87c$export$3c7c047ca0ed675e = /*#__PURE__*/ (0, $2UsNA.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 12px 24px -6px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$3xuD5.panel};`;
const $d1acead68e89f87c$export$e6af781b0d301e56 = /*#__PURE__*/ (0, $2UsNA.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 20px 32px -8px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$3xuD5.flag};`;
const $d1acead68e89f87c$export$78129b34f80acd5f = {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    e100: (0, $2UsNA.css)`z-index:${$3xuD5.card};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};`,
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    e200: (0, $2UsNA.css)`z-index:${$3xuD5.dialog};box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};`
};

});
parcelRegister("3xuD5", function(module, exports) {
$parcel$export(module.exports, "modal", () => $a0c0d9dc03149805$export$96e4b36520c26a2c);
$parcel$export(module.exports, "card", () => $a0c0d9dc03149805$export$aa3e815946b80764);
$parcel$export(module.exports, "dialog", () => $a0c0d9dc03149805$export$518824cf31321346);
$parcel$export(module.exports, "panel", () => $a0c0d9dc03149805$export$21f42ab9b6679f44);
$parcel$export(module.exports, "flag", () => $a0c0d9dc03149805$export$42405f212471e8a2);
$parcel$export(module.exports, "layer", () => $a0c0d9dc03149805$export$50a222d9023da98b);
$parcel$export(module.exports, "pushingCustomizeSidebarSmall", () => $a0c0d9dc03149805$export$d937b725511051a5);
$parcel$export(module.exports, "pushingCustomizeSidebarLarge", () => $a0c0d9dc03149805$export$6d600c1f7c7bf904);
$parcel$export(module.exports, "pageInBannerLayout", () => $a0c0d9dc03149805$export$b3a6c753aad12c21);
$parcel$export(module.exports, "banner", () => $a0c0d9dc03149805$export$bb5ee47d9ea2348e);
$parcel$export(module.exports, "portalCardLayout", () => $a0c0d9dc03149805$export$1f2452f153db200);
$parcel$export(module.exports, "forgeLoadingComponent", () => $a0c0d9dc03149805$export$6bbd03fd9ab1103f);

var $jbqt2 = parcelRequire("jbqt2");
const $a0c0d9dc03149805$export$96e4b36520c26a2c = (0, $jbqt2.layers).modal();
const $a0c0d9dc03149805$export$aa3e815946b80764 = (0, $jbqt2.layers).card();
const $a0c0d9dc03149805$export$518824cf31321346 = (0, $jbqt2.layers).dialog();
const $a0c0d9dc03149805$export$21f42ab9b6679f44 = (0, $jbqt2.layers).navigation();
const $a0c0d9dc03149805$export$42405f212471e8a2 = (0, $jbqt2.layers).flag();
const $a0c0d9dc03149805$export$50a222d9023da98b = (0, $jbqt2.layers).layer();
const $a0c0d9dc03149805$export$4e6f96734dfe12f4 = (0, $jbqt2.layers).tooltip();
const $a0c0d9dc03149805$export$f2ea4ab276c3e3fa = 502; // This has to be > atlaskit blanket which has a z-index of 500 and smaller than the modal layer which is at 510
const $a0c0d9dc03149805$export$312cd8ab1e0faaaa = $a0c0d9dc03149805$export$f2ea4ab276c3e3fa;
const $a0c0d9dc03149805$export$cb3a20fdbbf963aa = $a0c0d9dc03149805$export$312cd8ab1e0faaaa + 1;
const $a0c0d9dc03149805$export$d937b725511051a5 = $a0c0d9dc03149805$export$cb3a20fdbbf963aa + 1;
const $a0c0d9dc03149805$export$6d600c1f7c7bf904 = $a0c0d9dc03149805$export$96e4b36520c26a2c - 50;
const $a0c0d9dc03149805$export$363009303e3f9227 = 1;
const $a0c0d9dc03149805$export$b339878b6d12ef6c = 2;
const $a0c0d9dc03149805$export$980027fe3bc5cfbc = 3;
const $a0c0d9dc03149805$export$b3a6c753aad12c21 = -1;
const $a0c0d9dc03149805$export$bb5ee47d9ea2348e = -2;
const $a0c0d9dc03149805$export$1f2452f153db200 = 0;
const $a0c0d9dc03149805$export$6bbd03fd9ab1103f = 500;

});


parcelRegister("4cxV2", function(module, exports) {
$parcel$export(module.exports, "unitless", () => $8deded6946f784e4$export$c6b9faa6b723d31a);
$parcel$export(module.exports, "multiple", () => $8deded6946f784e4$export$939ddaa3205df08e);
$parcel$export(module.exports, "SINGLE_LINE_PARAGRAPH_HEIGHT", () => $8deded6946f784e4$export$7a95f3449f53d741);
const $8deded6946f784e4$export$c6b9faa6b723d31a = 8;
const $8deded6946f784e4$export$91c0eda1d06bf008 = '8px';
const $8deded6946f784e4$export$939ddaa3205df08e = (multiplier)=>({
        px: `${multiplier * 8}px`,
        unitless: multiplier * 8,
        multiple: (additionalMultiplier)=>$8deded6946f784e4$export$939ddaa3205df08e(multiplier * additionalMultiplier)
    });
const $8deded6946f784e4$export$7a95f3449f53d741 = 20;

});

parcelRegister("b60z8", function(module, exports) {
$parcel$export(module.exports, "timingFunctions", () => $e90a88b210486e54$export$61210fa83792a81);
$parcel$export(module.exports, "speedMs", () => $e90a88b210486e54$export$e913427a0c9547b);
$parcel$export(module.exports, "fadeInOutTiming", () => $e90a88b210486e54$export$44a465aba7fd9c0a);
$parcel$export(module.exports, "fadeInOut", () => $e90a88b210486e54$export$6c232a6cba05a953);
$parcel$export(module.exports, "slideInOutFromTop", () => $e90a88b210486e54$export$cb4674081b5c3c03);
$parcel$export(module.exports, "slideInOutFromRight", () => $e90a88b210486e54$export$cb755d7f610bdc3b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");
const $e90a88b210486e54$export$61210fa83792a81 = {
    easeOut: 'ease-out',
    easeIn: 'ease-in',
    easeInOut: 'ease-in-out',
    // http://cubic-bezier.com/#.47,0,0,1.19
    easeInOutSpring: 'cubic-bezier(.79,.22,0,1.19)',
    linear: 'linear',
    // Same easing used in Atlaskit modal:
    // https://bitbucket.org/atlassian/atlaskit-mk-2/src/fd22974e576281b2f4d158b0a0df3badc4ed9ab2/packages/core/modal-dialog/src/components/Animation.js?at=master&fileviewer=file-view-default
    easeInOutQuad: 'cubic-bezier(0.23, 1, 0.32, 1)'
};
const $e90a88b210486e54$export$e913427a0c9547b = {
    superFast: 50,
    fast: 140,
    medium: 200,
    slow: 300
};
const $e90a88b210486e54$var$fadeInOutOpacityMap = {
    entering: 0,
    entered: 1,
    exiting: 0,
    exited: 0
};
const $e90a88b210486e54$export$44a465aba7fd9c0a = (ms, delay = 0)=>(0, $2UsNA.css)`transition:opacity ${ms}ms;transition-delay:${delay}ms;transition-timing-function:${$e90a88b210486e54$export$61210fa83792a81.easeOut};`;
const $e90a88b210486e54$export$6c232a6cba05a953 = (ms, delay = 0)=>(0, $2UsNA.css)`${$e90a88b210486e54$export$44a465aba7fd9c0a(ms, delay)};opacity:${(props)=>$e90a88b210486e54$var$fadeInOutOpacityMap[props.state]};`;
const $e90a88b210486e54$export$e83f174dbf56adcc = (ms = $e90a88b210486e54$export$e913427a0c9547b.fast)=>(0, $2UsNA.css)`transition:transform ${ms}ms;transition-timing-function:${$e90a88b210486e54$export$61210fa83792a81.easeInOut};transform:scale(1.1);`;
const $e90a88b210486e54$var$slideInOutFromTopTransformMap = {
    entering: 'translate3d(0, 0, 0)',
    entered: 'none',
    exiting: 'translate3d(0, -100%, 0)',
    exited: 'translate3d(0, -100%, 0)'
};
const $e90a88b210486e54$var$slideInOutFromRightTransformMap = {
    entering: 'translate3d(0, 0, 0)',
    entered: 'none',
    exiting: 'translate3d(100%, 0, 0)',
    exited: 'translate3d(100%, 0, 0)'
};
const $e90a88b210486e54$var$slideInOutTransitionMap = (ms)=>({
        /* This will ease out when entering, and ease-in when leaving. */ entering: `transform ${ms}ms ${$e90a88b210486e54$export$61210fa83792a81.easeOut}`,
        entered: `transform ${ms}ms ${$e90a88b210486e54$export$61210fa83792a81.easeOut}`,
        exiting: `transform ${ms}ms ${$e90a88b210486e54$export$61210fa83792a81.easeIn}`
    });
const $e90a88b210486e54$export$cb4674081b5c3c03 = (ms)=>(0, $2UsNA.css)`transition:${(props)=>{
        //@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $e90a88b210486e54$var$slideInOutTransitionMap(ms)[props.state];
    }};transform:${(props)=>$e90a88b210486e54$var$slideInOutFromTopTransformMap[props.state]};`;
const $e90a88b210486e54$export$cb755d7f610bdc3b = (ms)=>(0, $2UsNA.css)`transition:${(props)=>{
        //@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $e90a88b210486e54$var$slideInOutTransitionMap(ms)[props.state];
    }};transform:${(props)=>$e90a88b210486e54$var$slideInOutFromRightTransformMap[props.state]};`;

});


parcelRegister("2oR5R", function(module, exports) {
$parcel$export(module.exports, "EXPAND_TIME_MS", () => $69abf7e667bff294$export$a718feb2020f924e);
$parcel$export(module.exports, "SIDEBAR_WIDTH_LARGE_MULTIPLIER", () => $69abf7e667bff294$export$916ffa0b867d54d8);
$parcel$export(module.exports, "SIDEBAR_WIDTH_LARGE_VIEWPORT", () => $69abf7e667bff294$export$66e2a13bbb493bde);
$parcel$export(module.exports, "SIDEBAR_HEIGHT_SMALL_VIEWPORT", () => $69abf7e667bff294$export$3d0c478f72970318);
$parcel$export(module.exports, "SIDEBAR_FULL_HEIGHT_SMALL_VIEWPORT", () => $69abf7e667bff294$export$aea0de5dee32e42e);
$parcel$export(module.exports, "TAG_BUTTON_HEIGHT", () => $69abf7e667bff294$export$9aa6c06b2eb3bd9e);

var $4cxV2 = parcelRequire("4cxV2");

var $b60z8 = parcelRequire("b60z8");
const $69abf7e667bff294$export$a718feb2020f924e = $b60z8.speedMs.medium;
const $69abf7e667bff294$export$916ffa0b867d54d8 = 50;
const $69abf7e667bff294$export$66e2a13bbb493bde = $4cxV2.multiple($69abf7e667bff294$export$916ffa0b867d54d8).px;
const $69abf7e667bff294$export$3d0c478f72970318 = '40vh';
const $69abf7e667bff294$export$aea0de5dee32e42e = '100vh';
const $69abf7e667bff294$export$9aa6c06b2eb3bd9e = $4cxV2.unitless * 5;

});



parcelRegister("a4GOg", function(module, exports) {
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => (parcelRequire("gRzju")).CustomiseSidebarTriggerProvider);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => (parcelRequire("gRzju")).useCustomiseSidebarTriggerRef);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => (parcelRequire("gRzju")).useSetCustomiseSidebarTrigger);

var $gRzju = parcelRequire("gRzju");

});
parcelRegister("gRzju", function(module, exports) {
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => $c5996a37ac218d8c$export$80c1c1cfdf49ec8a);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => $c5996a37ac218d8c$export$2ffc1f557dddded2);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => $c5996a37ac218d8c$export$d2c4b172b3db92fb);

var $8P7DW = parcelRequire("8P7DW");
const $c5996a37ac218d8c$var$TriggerRefContext = /*#__PURE__*/ $8P7DW.createContext(null);
const $c5996a37ac218d8c$export$80c1c1cfdf49ec8a = ({ children: children })=>{
    const triggerRef = $8P7DW.useRef(null);
    const setTriggerElement = $8P7DW.useCallback((element)=>{
        // Using a mutable ref pattern since we can't reassign .current on a RefObject
        triggerRef.current = element;
    }, []);
    const value = $8P7DW.useMemo(()=>({
            triggerRef: triggerRef,
            setTriggerElement: setTriggerElement
        }), [
        setTriggerElement
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($c5996a37ac218d8c$var$TriggerRefContext.Provider, {
        value: value
    }, children);
};
const $c5996a37ac218d8c$export$2ffc1f557dddded2 = ()=>{
    const context = $8P7DW.useContext($c5996a37ac218d8c$var$TriggerRefContext);
    return context === null || context === void 0 ? void 0 : context.triggerRef;
};
const $c5996a37ac218d8c$export$d2c4b172b3db92fb = ()=>{
    const context = $8P7DW.useContext($c5996a37ac218d8c$var$TriggerRefContext);
    return context === null || context === void 0 ? void 0 : context.setTriggerElement;
};

});


parcelRegister("dHack", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("aNUjX").then(()=>parcelRequire('kjNIw'));

});


parcelRegister("jp3Ur", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("7bCNa")).default);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("1s1Af")).FabricChannel);

var $7bCNa = parcelRequire("7bCNa");

var $b6S0F = parcelRequire("b6S0F");

var $1s1Af = parcelRequire("1s1Af");

});
parcelRegister("7bCNa", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6a0a3083282b5ba$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $dAo8e = parcelRequire("dAo8e");

var $8JNuY = parcelRequire("8JNuY");

var $b6S0F = parcelRequire("b6S0F");

var $6671C = parcelRequire("6671C");

var $ac4hG = parcelRequire("ac4hG");

var $jBYD7 = parcelRequire("jBYD7");

var $auZXL = parcelRequire("auZXL");

var $eZ1xt = parcelRequire("eZ1xt");

var $kKqMj = parcelRequire("kKqMj");

var $ce20N = parcelRequire("ce20N");

var $gIMpa = parcelRequire("gIMpa");

var $kb886 = parcelRequire("kb886");

var $eBVtI = parcelRequire("eBVtI");

var $8OX7U = parcelRequire("8OX7U");

var $aXltE = parcelRequire("aXltE");

var $30iXG = parcelRequire("30iXG");

var $7riiZ = parcelRequire("7riiZ");

var $h2Y5y = parcelRequire("h2Y5y");

var $92Skn = parcelRequire("92Skn");

var $7Wjkv = parcelRequire("7Wjkv");
const $b6a0a3083282b5ba$var$listenerMap = {
    [(0, $1s1Af.FabricChannel).elements]: (0, $dAo8e.default),
    [(0, $1s1Af.FabricChannel).editor]: (0, $ac4hG.default),
    [(0, $1s1Af.FabricChannel).atlaskit]: (0, $8JNuY.default),
    [(0, $1s1Af.FabricChannel).navigation]: (0, $6671C.default),
    [(0, $1s1Af.FabricChannel).media]: (0, $jBYD7.default),
    [(0, $1s1Af.FabricChannel).peopleTeams]: (0, $auZXL.default),
    [(0, $1s1Af.FabricChannel).notifications]: (0, $eZ1xt.default),
    [(0, $1s1Af.FabricChannel).recentWork]: (0, $kKqMj.default),
    [(0, $1s1Af.FabricChannel).atlas]: (0, $ce20N.default),
    [(0, $1s1Af.FabricChannel).crossFlow]: (0, $gIMpa.default),
    [(0, $1s1Af.FabricChannel).linkingPlatform]: (0, $kb886.default),
    [(0, $1s1Af.FabricChannel).postOffice]: (0, $eBVtI.default),
    [(0, $1s1Af.FabricChannel).aiMate]: (0, $8OX7U.default),
    [(0, $1s1Af.FabricChannel).avp]: (0, $aXltE.default),
    [(0, $1s1Af.FabricChannel).growth]: (0, $30iXG.default),
    [(0, $1s1Af.FabricChannel).omniChannel]: (0, $7riiZ.default),
    [(0, $1s1Af.FabricChannel).townsquareHome]: (0, $h2Y5y.default),
    [(0, $1s1Af.FabricChannel).rovoExtension]: (0, $92Skn.default),
    [(0, $1s1Af.FabricChannel).teamworkGraph]: (0, $7Wjkv.default)
};
class $b6a0a3083282b5ba$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $b6S0F.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($b6a0a3083282b5ba$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$b6a0a3083282b5ba$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, $gWgPx.jsx)(Listener, {
                client: client,
                logger: this.logger,
                children: prev
            }), children);
        return listeners;
    }
}
var $b6a0a3083282b5ba$export$2e2bcd8739ae039 = $b6a0a3083282b5ba$var$FabricAnalyticsListeners;

});
parcelRegister("1s1Af", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $7356629c73eb51b3$export$8faa0b115ef0268b);
var $7356629c73eb51b3$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

});

parcelRegister("dAo8e", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_TAG", () => $e1555094e3984450$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $e1555094e3984450$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $bP2rs = parcelRequire("bP2rs");

var $1s1Af = parcelRequire("1s1Af");

var $gG465 = parcelRequire("gG465");
const $e1555094e3984450$export$ed71ae78997933a = 'fabricElements';
class $e1555094e3984450$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bP2rs.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $1s1Af.FabricChannel).elements,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $gG465.handleEvent)(event, $e1555094e3984450$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("gG465", function(module, exports) {
$parcel$export(module.exports, "handleEvent", () => $04f93906c1b72cf6$export$d6e5ca10785815df);

var $3TPHa = parcelRequire("3TPHa");

var $lmvKb = parcelRequire("lmvKb");
const $04f93906c1b72cf6$export$d6e5ca10785815df = (event, tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $lmvKb.processEventPayload)(event, tags);
    (0, $3TPHa.sendEvent)(logger, client)(payload);
};

});
parcelRegister("3TPHa", function(module, exports) {
$parcel$export(module.exports, "sendEvent", () => $0a3020ded8c6812c$export$7329bcdc3edcd90e);
const $0a3020ded8c6812c$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $0a3020ded8c6812c$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($0a3020ded8c6812c$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("lmvKb", function(module, exports) {
$parcel$export(module.exports, "processEventPayload", () => $e3a8298f38cb0492$export$c37d638b7f2ca192);

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $5VXGe = parcelRequire("5VXGe");
var $h9YZZ = parcelRequire("h9YZZ");

var $4BY1L = parcelRequire("4BY1L");

var $dAo8e = parcelRequire("dAo8e");

var $ac4hG = parcelRequire("ac4hG");
const $e3a8298f38cb0492$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(result, item), {});
const $e3a8298f38cb0492$var$fieldExtractor = (contextKey)=>$e3a8298f38cb0492$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $e3a8298f38cb0492$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $dAo8e.ELEMENTS_TAG:
            return 0, $h9YZZ.ELEMENTS_CONTEXT;
        case 0, $ac4hG.EDITOR_TAG:
            return 0, $5VXGe.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $e3a8298f38cb0492$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $9U53L.DEFAULT_SOURCE),
        ...event.payload
    };
    const contextKey = $e3a8298f38cb0492$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $e3a8298f38cb0492$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $9U53L.DEFAULT_SOURCE),
        ...fields,
        ...event.payload
    };
};
const $e3a8298f38cb0492$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $e3a8298f38cb0492$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $e3a8298f38cb0492$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $e3a8298f38cb0492$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$e3a8298f38cb0492$var$updatePayloadWithContext(primaryTag, event),
        tags: $e3a8298f38cb0492$var$addTags(tagsArray, event.payload.tags)
    };
};

});
parcelRegister("9U53L", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $d644617c574e4766$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $d644617c574e4766$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $d644617c574e4766$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $d644617c574e4766$export$12346a674644c156);
$parcel$export(module.exports, "DEFAULT_SOURCE", () => $d644617c574e4766$export$b055de0e665cb20c);
// same types defined in analytics-web-client but avoid creating dependency with that
const $d644617c574e4766$export$a1562d08625f5d7e = 'ui';
const $d644617c574e4766$export$947dac6c72b26f81 = 'track';
const $d644617c574e4766$export$f1d537d508d2945a = 'screen';
const $d644617c574e4766$export$12346a674644c156 = 'operational';
const $d644617c574e4766$export$b055de0e665cb20c = 'unknown';

});

parcelRegister("9EJQR", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("h9YZZ")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("h9YZZ")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("iCLnJ")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("iCLnJ")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("5VXGe")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("5VXGe")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => (parcelRequire("la6qA")).MEDIA_CONTEXT);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("kAghn")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("9eW6I")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("cnjpe")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("5MSJp")).ATLAS_CONTEXT);
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => (parcelRequire("hJMlW")).TOWNSQUARE_HOME_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("3BKsT")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("eVKQv")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("jqzNz")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("h4zO8")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("gVL3I")).GROWTH_CONTEXT);
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => (parcelRequire("cmIs0")).OMNI_CHANNEL_CONTEXT);
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => (parcelRequire("d3kiO")).ROVO_EXTENSION_CONTEXT);

var $h9YZZ = parcelRequire("h9YZZ");

var $iCLnJ = parcelRequire("iCLnJ");

var $5VXGe = parcelRequire("5VXGe");

var $la6qA = parcelRequire("la6qA");

var $kAghn = parcelRequire("kAghn");

var $9eW6I = parcelRequire("9eW6I");

var $cnjpe = parcelRequire("cnjpe");

var $5MSJp = parcelRequire("5MSJp");

var $hJMlW = parcelRequire("hJMlW");

var $3BKsT = parcelRequire("3BKsT");

var $eVKQv = parcelRequire("eVKQv");

var $jqzNz = parcelRequire("jqzNz");

var $h4zO8 = parcelRequire("h4zO8");

var $gVL3I = parcelRequire("gVL3I");

var $cmIs0 = parcelRequire("cmIs0");

var $d3kiO = parcelRequire("d3kiO");

});
parcelRegister("h9YZZ", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $e98fe28a321beb6e$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $e98fe28a321beb6e$export$3fe25500478a635c);

var $7U45i = parcelRequire("7U45i");
const $e98fe28a321beb6e$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $e98fe28a321beb6e$export$3fe25500478a635c = (0, $7U45i.default)($e98fe28a321beb6e$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("7U45i", function(module, exports) {
$parcel$export(module.exports, "default", () => $f132a0dc15f71aa7$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8gu7I = parcelRequire("8gu7I");
const $f132a0dc15f71aa7$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8gu7I.default), {
            data: newData,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
var $f132a0dc15f71aa7$export$2e2bcd8739ae039 = $f132a0dc15f71aa7$var$createNamespaceContext;

});


parcelRegister("iCLnJ", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $720d53200b19a448$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $720d53200b19a448$export$d0a82da1a0b94929);

var $7U45i = parcelRequire("7U45i");
const $720d53200b19a448$export$1fd3aad76a7c6788 = 'navigationCtx';
const $720d53200b19a448$export$d0a82da1a0b94929 = (0, $7U45i.default)($720d53200b19a448$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("5VXGe", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $992c37000d579970$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $992c37000d579970$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $992c37000d579970$export$629cada6c5e621e1);

var $7U45i = parcelRequire("7U45i");
const $992c37000d579970$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $992c37000d579970$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $992c37000d579970$export$629cada6c5e621e1 = (0, $7U45i.default)($992c37000d579970$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

parcelRegister("la6qA", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $cf7d022530757cc3$export$70df29c238ba7306);
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $cf7d022530757cc3$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("kAghn", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $34411883b77f4599$export$b326383bee6cb993);

var $7U45i = parcelRequire("7U45i");
const $34411883b77f4599$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $34411883b77f4599$export$4119ddb38ccbfb87 = (0, $7U45i.default)($34411883b77f4599$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("9eW6I", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $5b8f524b33b66fe6$export$da1befb791e93c7e);

var $7U45i = parcelRequire("7U45i");
const $5b8f524b33b66fe6$export$da1befb791e93c7e = 'NotificationsCtx';
const $5b8f524b33b66fe6$export$6f8e7ff1e3feafd7 = (0, $7U45i.default)($5b8f524b33b66fe6$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("cnjpe", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $851f0e374c4baba1$export$fc7a65795610cb71);

var $7U45i = parcelRequire("7U45i");
const $851f0e374c4baba1$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $851f0e374c4baba1$export$745926731087ebe2 = (0, $7U45i.default)($851f0e374c4baba1$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("5MSJp", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $06faf3ea85113719$export$4906017439f33fc0);

var $7U45i = parcelRequire("7U45i");
const $06faf3ea85113719$export$4906017439f33fc0 = 'atlasCtx';
const $06faf3ea85113719$export$43ebbe41370d4543 = (0, $7U45i.default)($06faf3ea85113719$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("hJMlW", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $a20370cd8df85d11$export$aa18ab4fff926c9e);

var $7U45i = parcelRequire("7U45i");
const $a20370cd8df85d11$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $a20370cd8df85d11$export$d283110f5d85c8f2 = (0, $7U45i.default)($a20370cd8df85d11$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});

parcelRegister("3BKsT", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $7e1401d596857e46$export$3240443bf2b83834);

var $7U45i = parcelRequire("7U45i");
const $7e1401d596857e46$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $7e1401d596857e46$export$6d568da622ce0a08 = (0, $7U45i.default)($7e1401d596857e46$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("eVKQv", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $f3da857a146cb664$export$ef0c05448f0f8f9);

var $7U45i = parcelRequire("7U45i");
const $f3da857a146cb664$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $f3da857a146cb664$export$dcd232f3be312f94 = (0, $7U45i.default)($f3da857a146cb664$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("jqzNz", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $d17f4eba3980103d$export$5c3a6fd8b96e8b66);

var $7U45i = parcelRequire("7U45i");
const $d17f4eba3980103d$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $d17f4eba3980103d$export$de3826c30468da26 = (0, $7U45i.default)($d17f4eba3980103d$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("h4zO8", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $1a33d4bf96e5ac3d$export$c2a811a4e42f4af5);

var $7U45i = parcelRequire("7U45i");
const $1a33d4bf96e5ac3d$export$c2a811a4e42f4af5 = 'avpCtx';
const $1a33d4bf96e5ac3d$export$da383e8879a25b03 = (0, $7U45i.default)($1a33d4bf96e5ac3d$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("gVL3I", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $d44c8020da21f9e0$export$82023f2f4bfb06c1);

var $7U45i = parcelRequire("7U45i");
const $d44c8020da21f9e0$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $d44c8020da21f9e0$export$84980182680018f = (0, $7U45i.default)($d44c8020da21f9e0$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});

parcelRegister("cmIs0", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $fed4c0a0ac67a73b$export$6d3c48fd1b3e4f3b);

var $7U45i = parcelRequire("7U45i");
const $fed4c0a0ac67a73b$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $fed4c0a0ac67a73b$export$e4e6df99270bbbb1 = (0, $7U45i.default)($fed4c0a0ac67a73b$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});

parcelRegister("d3kiO", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $d66591bfc717d3b1$export$fae437eb1dd9520c);

var $7U45i = parcelRequire("7U45i");
const $d66591bfc717d3b1$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $d66591bfc717d3b1$export$7fcecc25ee38fbef = (0, $7U45i.default)($d66591bfc717d3b1$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});


parcelRegister("ac4hG", function(module, exports) {
$parcel$export(module.exports, "EDITOR_TAG", () => $1b5f64660eb4b400$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $1b5f64660eb4b400$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $bP2rs = parcelRequire("bP2rs");

var $1s1Af = parcelRequire("1s1Af");

var $gG465 = parcelRequire("gG465");
const $1b5f64660eb4b400$export$a1d9dc589a29b3aa = 'editor';
const $1b5f64660eb4b400$export$8aa0d788f94a809 = 'fabricEditor';
class $1b5f64660eb4b400$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bP2rs.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $1s1Af.FabricChannel).editor,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $gG465.handleEvent)(event, [
                $1b5f64660eb4b400$export$a1d9dc589a29b3aa,
                $1b5f64660eb4b400$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("8JNuY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f842bf51bfb6399d$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $8Ahga = parcelRequire("8Ahga");

var $8femr = parcelRequire("8femr");
function $f842bf51bfb6399d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).atlaskit,
        processEvent: (0, $8Ahga.default)
    });
}

});
parcelRegister("8Ahga", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ca6300238bec1e$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");

var $8Dwiv = parcelRequire("8Dwiv");
const $d4ca6300238bec1e$var$ATLASKIT_TAG = 'atlaskit';
const $d4ca6300238bec1e$var$listenerVersion = undefined;
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $d4ca6300238bec1e$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $8Dwiv.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $8Dwiv.getExtraAttributes)(event);
    const components = (0, $8Dwiv.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $8Dwiv.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $d4ca6300238bec1e$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $8Dwiv.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($d4ca6300238bec1e$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $9U53L.UI_EVENT_TYPE)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $8Dwiv.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $9U53L.TRACK_EVENT_TYPE) || eventType === (0, $9U53L.OPERATIONAL_EVENT_TYPE) || eventType === (0, $9U53L.SCREEN_EVENT_TYPE)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("8Dwiv", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $c7597e573ee0f499$export$9b947b4502cd2705);
$parcel$export(module.exports, "getActionSubject", () => $c7597e573ee0f499$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getSources", () => $c7597e573ee0f499$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $c7597e573ee0f499$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $c7597e573ee0f499$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $c7597e573ee0f499$export$cd17d76da7967240);
$parcel$export(module.exports, "getPackageHierarchy", () => $c7597e573ee0f499$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $4BY1L = parcelRequire("4BY1L");
const $c7597e573ee0f499$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const $c7597e573ee0f499$export$6f40cdf6d42c018d = (event)=>{
    const overrides = $c7597e573ee0f499$export$9b947b4502cd2705('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const $c7597e573ee0f499$export$5f9bc633b116660f = (event)=>$c7597e573ee0f499$export$9b947b4502cd2705('source', event);
const $c7597e573ee0f499$export$4e811121b221213b = (event)=>$c7597e573ee0f499$export$9b947b4502cd2705('component', event);
const $c7597e573ee0f499$export$67c3590839ebecdd = (event)=>$c7597e573ee0f499$export$9b947b4502cd2705('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(result, extraAttributes), {});
const $c7597e573ee0f499$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $c7597e573ee0f499$export$18cd124b5098d330 = (event)=>$c7597e573ee0f499$export$9b947b4502cd2705('packageVersion', event);
function $c7597e573ee0f499$export$4e0b83da1896ebc7(event) {
    const packages = $c7597e573ee0f499$export$cd17d76da7967240(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});


parcelRegister("8femr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad68227ffd2afb65$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $bP2rs = parcelRequire("bP2rs");

var $3TPHa = parcelRequire("3TPHa");
class $ad68227ffd2afb65$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bP2rs.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $3TPHa.sendEvent)(logger, client)(payload);
        };
    }
}

});


parcelRegister("b6S0F", function(module, exports) {
$parcel$export(module.exports, "default", () => $54fb6cede57f2fa3$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $54fb6cede57f2fa3$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $54fb6cede57f2fa3$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $54fb6cede57f2fa3$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $54fb6cede57f2fa3$export$ffe0c436e29512cf.DEBUG && logLevel <= $54fb6cede57f2fa3$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $54fb6cede57f2fa3$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($54fb6cede57f2fa3$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($54fb6cede57f2fa3$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($54fb6cede57f2fa3$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($54fb6cede57f2fa3$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("6671C", function(module, exports) {
$parcel$export(module.exports, "default", () => $97ce0117509f2a12$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $3HyAI = parcelRequire("3HyAI");

var $8femr = parcelRequire("8femr");
function $97ce0117509f2a12$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).navigation,
        processEvent: (0, $3HyAI.default)
    });
}

});
parcelRegister("3HyAI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e002e3885926c1f9$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $iCLnJ = parcelRequire("iCLnJ");

var $ei5Mq = parcelRequire("ei5Mq");
const $e002e3885926c1f9$var$NAVIGATION_TAG = 'navigation';
const $e002e3885926c1f9$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $e002e3885926c1f9$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $iCLnJ.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $iCLnJ.NAVIGATION_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $iCLnJ.NAVIGATION_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $iCLnJ.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $iCLnJ.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $e002e3885926c1f9$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($e002e3885926c1f9$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("ei5Mq", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $bf8d88f63f71ec8c$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $bf8d88f63f71ec8c$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $bf8d88f63f71ec8c$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $bf8d88f63f71ec8c$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ 
var $4BY1L = parcelRequire("4BY1L");
const $bf8d88f63f71ec8c$var$extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const $bf8d88f63f71ec8c$export$5f9bc633b116660f = (event, contextName)=>$bf8d88f63f71ec8c$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
const $bf8d88f63f71ec8c$export$4e811121b221213b = (event, contextName)=>$bf8d88f63f71ec8c$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const $bf8d88f63f71ec8c$export$67c3590839ebecdd = (event, contextName)=>$bf8d88f63f71ec8c$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(result, extraAttributes), {});
const $bf8d88f63f71ec8c$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const $bf8d88f63f71ec8c$export$18cd124b5098d330 = (event, contextName)=>$bf8d88f63f71ec8c$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);

});



parcelRegister("jBYD7", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d6e3beed6c629cd$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $adJRZ = parcelRequire("adJRZ");

var $8femr = parcelRequire("8femr");
function $3d6e3beed6c629cd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).media,
        processEvent: (0, $adJRZ.processEvent)
    });
}

});
parcelRegister("adJRZ", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $0cd6ce225c24b464$export$22af68e3614bf024);

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $la6qA = parcelRequire("la6qA");

var $4BY1L = parcelRequire("4BY1L");

var $eKg28 = parcelRequire("eKg28");

var $8Dwiv = parcelRequire("8Dwiv");
const $0cd6ce225c24b464$var$listenerVersion = undefined;
function $0cd6ce225c24b464$var$getMediaContexts(event) {
    return (0, $8Dwiv.extractFromEventContext)((0, $la6qA.MEDIA_CONTEXT), event);
}
function $0cd6ce225c24b464$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $0cd6ce225c24b464$export$22af68e3614bf024(event) {
    const sources = (0, $8Dwiv.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $8Dwiv.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $8Dwiv.getExtraAttributes)(event);
    const mediaContexts = $0cd6ce225c24b464$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $8Dwiv.getComponents)(event);
    const mediaRegion = $0cd6ce225c24b464$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $8Dwiv.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $0cd6ce225c24b464$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("auZXL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f184b063e146bb4$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $87mMZ = parcelRequire("87mMZ");

var $8femr = parcelRequire("8femr");
function $5f184b063e146bb4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).peopleTeams,
        processEvent: (0, $87mMZ.default)
    });
}

});
parcelRegister("87mMZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $91e9a4a276871cff$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $kAghn = parcelRequire("kAghn");

var $ei5Mq = parcelRequire("ei5Mq");
const $91e9a4a276871cff$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $91e9a4a276871cff$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $91e9a4a276871cff$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $kAghn.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $kAghn.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $kAghn.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $kAghn.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $kAghn.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $91e9a4a276871cff$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($91e9a4a276871cff$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("eZ1xt", function(module, exports) {
$parcel$export(module.exports, "default", () => $67430399d332155a$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $gAyri = parcelRequire("gAyri");

var $8femr = parcelRequire("8femr");
function $67430399d332155a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).notifications,
        processEvent: (0, $gAyri.default)
    });
}

});
parcelRegister("gAyri", function(module, exports) {
$parcel$export(module.exports, "default", () => $5aa4ef743d238e67$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");

var $ei5Mq = parcelRequire("ei5Mq");
parcelRequire("9EJQR");
var $9eW6I = parcelRequire("9eW6I");

var $1s1Af = parcelRequire("1s1Af");
const $5aa4ef743d238e67$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $5aa4ef743d238e67$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $9eW6I.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $9eW6I.NOTIFICATIONS_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $9eW6I.NOTIFICATIONS_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $9eW6I.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $9eW6I.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $5aa4ef743d238e67$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $1s1Af.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("kKqMj", function(module, exports) {
$parcel$export(module.exports, "default", () => $92f3ef76eb624f0d$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $2HUgz = parcelRequire("2HUgz");

var $8femr = parcelRequire("8femr");
function $92f3ef76eb624f0d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).recentWork,
        processEvent: (0, $2HUgz.default)
    });
}

});
parcelRegister("2HUgz", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1f74e49de61af9a$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");

var $ei5Mq = parcelRequire("ei5Mq");
parcelRequire("9EJQR");
var $cnjpe = parcelRequire("cnjpe");

var $1s1Af = parcelRequire("1s1Af");
const $d1f74e49de61af9a$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $d1f74e49de61af9a$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $cnjpe.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $cnjpe.RECENT_WORK_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $cnjpe.RECENT_WORK_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $cnjpe.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $cnjpe.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $d1f74e49de61af9a$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $1s1Af.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("ce20N", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea3a31a525eee649$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $2SCZp = parcelRequire("2SCZp");

var $8femr = parcelRequire("8femr");
function $ea3a31a525eee649$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).atlas,
        processEvent: (0, $2SCZp.default)
    });
}

});
parcelRegister("2SCZp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f05444db45ac8145$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");

var $ei5Mq = parcelRequire("ei5Mq");
parcelRequire("9EJQR");
var $5MSJp = parcelRequire("5MSJp");
const $f05444db45ac8145$var$ATLAS_TAG = 'atlas';
const $f05444db45ac8145$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $f05444db45ac8145$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $5MSJp.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $5MSJp.ATLAS_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $5MSJp.ATLAS_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $5MSJp.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $5MSJp.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $f05444db45ac8145$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($f05444db45ac8145$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("gIMpa", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2836abd97a7690a$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $dyB20 = parcelRequire("dyB20");

var $8femr = parcelRequire("8femr");
function $c2836abd97a7690a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).crossFlow,
        processEvent: (0, $dyB20.default)
    });
}

});
parcelRegister("dyB20", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ac8e53c5bb943b3$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $9U53L = parcelRequire("9U53L");

var $eKg28 = parcelRequire("eKg28");
parcelRequire("9EJQR");
var $iCLnJ = parcelRequire("iCLnJ");

var $8Dwiv = parcelRequire("8Dwiv");

var $ei5Mq = parcelRequire("ei5Mq");
const $0ac8e53c5bb943b3$var$CROSS_FLOW_TAG = 'crossFlow';
var $0ac8e53c5bb943b3$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $8Dwiv.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $8Dwiv.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $ei5Mq.getExtraAttributes)(event, (0, $iCLnJ.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($0ac8e53c5bb943b3$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("kb886", function(module, exports) {
$parcel$export(module.exports, "default", () => $61b8d277e529f0ef$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $5qvLM = parcelRequire("5qvLM");

var $1s1Af = parcelRequire("1s1Af");

var $8femr = parcelRequire("8femr");
function $61b8d277e529f0ef$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).linkingPlatform,
        processEvent: (0, $5qvLM.default)
    });
}

});
parcelRegister("5qvLM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8249baee31a5e836$export$2e2bcd8739ae039);

var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $3BKsT = parcelRequire("3BKsT");

var $ei5Mq = parcelRequire("ei5Mq");

var $1s1Af = parcelRequire("1s1Af");
const $8249baee31a5e836$var$listenerVersion = undefined;
var $8249baee31a5e836$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $3BKsT.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $3BKsT.LINKING_PLATFORM_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $3BKsT.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $3BKsT.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $1s1Af.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $8249baee31a5e836$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("eBVtI", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb09e98a4f2090b4$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $55ldO = parcelRequire("55ldO");

var $8femr = parcelRequire("8femr");
function $cb09e98a4f2090b4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).postOffice,
        processEvent: (0, $55ldO.default)
    });
}

});
parcelRegister("55ldO", function(module, exports) {
$parcel$export(module.exports, "default", () => $046f6bf230a9b5ac$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $eVKQv = parcelRequire("eVKQv");

var $ei5Mq = parcelRequire("ei5Mq");

var $1s1Af = parcelRequire("1s1Af");
const $046f6bf230a9b5ac$var$POST_OFFICE_TAG = (0, $1s1Af.FabricChannel).postOffice;
const $046f6bf230a9b5ac$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $046f6bf230a9b5ac$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $eVKQv.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $eVKQv.POST_OFFICE_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $eVKQv.POST_OFFICE_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $eVKQv.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $eVKQv.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $046f6bf230a9b5ac$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($046f6bf230a9b5ac$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("8OX7U", function(module, exports) {
$parcel$export(module.exports, "default", () => $7935f78a1577cae0$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $9TtqA = parcelRequire("9TtqA");

var $8femr = parcelRequire("8femr");
function $7935f78a1577cae0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).aiMate,
        processEvent: (0, $9TtqA.default)
    });
}

});
parcelRegister("9TtqA", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c2a8da4ac495fb1$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $jqzNz = parcelRequire("jqzNz");

var $ei5Mq = parcelRequire("ei5Mq");
const $7c2a8da4ac495fb1$var$AI_MATE_TAG = 'aiMate';
const $7c2a8da4ac495fb1$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $7c2a8da4ac495fb1$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $jqzNz.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $jqzNz.AI_MATE_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $jqzNz.AI_MATE_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $jqzNz.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $jqzNz.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name, objectId: objectId, objectType: objectType, containerType: containerType, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $7c2a8da4ac495fb1$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($7c2a8da4ac495fb1$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags),
                ...objectId && {
                    objectId: objectId
                },
                ...objectType && {
                    objectType: objectType
                },
                ...containerType && {
                    containerType: containerType
                },
                ...containerId && {
                    containerId: containerId
                }
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("aXltE", function(module, exports) {
$parcel$export(module.exports, "default", () => $794148b8e2528ebc$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $14OHT = parcelRequire("14OHT");

var $8femr = parcelRequire("8femr");
function $794148b8e2528ebc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).avp,
        processEvent: (0, $14OHT.default)
    });
}

});
parcelRegister("14OHT", function(module, exports) {
$parcel$export(module.exports, "default", () => $b266fc759e8aff10$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $h4zO8 = parcelRequire("h4zO8");

var $ei5Mq = parcelRequire("ei5Mq");
const $b266fc759e8aff10$var$AVP_TAG = 'avp';
const $b266fc759e8aff10$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b266fc759e8aff10$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $h4zO8.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $h4zO8.AVP_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $h4zO8.AVP_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $h4zO8.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $h4zO8.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $b266fc759e8aff10$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))({}, ...event.context)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($b266fc759e8aff10$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("30iXG", function(module, exports) {
$parcel$export(module.exports, "default", () => $656133fadc990dfb$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $uCni4 = parcelRequire("uCni4");

var $8femr = parcelRequire("8femr");
function $656133fadc990dfb$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).growth,
        processEvent: (0, $uCni4.default)
    });
}

});
parcelRegister("uCni4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b35575ee84921bfb$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $gVL3I = parcelRequire("gVL3I");

var $ei5Mq = parcelRequire("ei5Mq");
const $b35575ee84921bfb$var$GROWTH_TAG = 'growth';
const $b35575ee84921bfb$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b35575ee84921bfb$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $gVL3I.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $gVL3I.GROWTH_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $gVL3I.GROWTH_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $gVL3I.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $gVL3I.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $b35575ee84921bfb$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($b35575ee84921bfb$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("7riiZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a5a5364af7edc1d$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $c5A0g = parcelRequire("c5A0g");

var $8femr = parcelRequire("8femr");
const $5a5a5364af7edc1d$var$OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).omniChannel,
        processEvent: (0, $c5A0g.default)
    });
};
var $5a5a5364af7edc1d$export$2e2bcd8739ae039 = $5a5a5364af7edc1d$var$OmniChannelAnalyticsListener;

});
parcelRegister("c5A0g", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa057b2186471443$export$2e2bcd8739ae039);

var $9U53L = parcelRequire("9U53L");
parcelRequire("9EJQR");
var $cmIs0 = parcelRequire("cmIs0");

var $ei5Mq = parcelRequire("ei5Mq");

var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $1s1Af = parcelRequire("1s1Af");
const $aa057b2186471443$var$listenerVersion = undefined;
var $aa057b2186471443$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $cmIs0.OMNI_CHANNEL_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $cmIs0.OMNI_CHANNEL_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $cmIs0.OMNI_CHANNEL_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $cmIs0.OMNI_CHANNEL_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $cmIs0.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $aa057b2186471443$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $1s1Af.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("h2Y5y", function(module, exports) {
$parcel$export(module.exports, "default", () => $550bae4624f3f711$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $82LSg = parcelRequire("82LSg");

var $8femr = parcelRequire("8femr");
function $550bae4624f3f711$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).townsquareHome,
        processEvent: (0, $82LSg.default)
    });
}

});
parcelRegister("82LSg", function(module, exports) {
$parcel$export(module.exports, "default", () => $263ae113eda02fa1$export$2e2bcd8739ae039);

var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");

var $ei5Mq = parcelRequire("ei5Mq");
parcelRequire("9EJQR");
var $hJMlW = parcelRequire("hJMlW");
const $263ae113eda02fa1$var$TOWNSQUARE_TAG = 'townsquare';
const $263ae113eda02fa1$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
const $263ae113eda02fa1$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $263ae113eda02fa1$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $hJMlW.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $hJMlW.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $hJMlW.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $hJMlW.TOWNSQUARE_HOME_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $hJMlW.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $263ae113eda02fa1$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($263ae113eda02fa1$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($263ae113eda02fa1$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("92Skn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ebfd026d8c19a89$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $aHvrw = parcelRequire("aHvrw");

var $8femr = parcelRequire("8femr");
function $4ebfd026d8c19a89$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).rovoExtension,
        processEvent: (0, $aHvrw.default)
    });
}

});
parcelRegister("aHvrw", function(module, exports) {
$parcel$export(module.exports, "default", () => $9591978e83beb94f$export$2e2bcd8739ae039);

var $eKg28 = parcelRequire("eKg28");

var $4BY1L = parcelRequire("4BY1L");

var $9U53L = parcelRequire("9U53L");

var $ei5Mq = parcelRequire("ei5Mq");
parcelRequire("9EJQR");
var $d3kiO = parcelRequire("d3kiO");
const $9591978e83beb94f$var$ROVO_EXTENSION_TAG = 'rovoExtension';
const $9591978e83beb94f$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $9591978e83beb94f$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $ei5Mq.getSources)(event, (0, $d3kiO.ROVO_EXTENSION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE);
    const extraAttributes = (0, $ei5Mq.getExtraAttributes)(event, (0, $d3kiO.ROVO_EXTENSION_CONTEXT));
    const components = (0, $ei5Mq.getComponents)(event, (0, $d3kiO.ROVO_EXTENSION_CONTEXT));
    const packages = (0, $ei5Mq.getPackageInfo)(event, (0, $d3kiO.ROVO_EXTENSION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $ei5Mq.getPackageInfo)(event, (0, $d3kiO.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $9U53L.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $9591978e83beb94f$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add($9591978e83beb94f$var$ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, $9U53L.UI_EVENT_TYPE:
        case 0, $9U53L.OPERATIONAL_EVENT_TYPE:
        case 0, $9U53L.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $9U53L.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("7Wjkv", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8e325e26a7671f7$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $1s1Af = parcelRequire("1s1Af");

var $3Ct2A = parcelRequire("3Ct2A");

var $8femr = parcelRequire("8femr");
function $a8e325e26a7671f7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8femr.default), {
        ...props,
        channel: (0, $1s1Af.FabricChannel).teamworkGraph,
        processEvent: (0, $3Ct2A.processEvent)
    });
}

});
parcelRegister("3Ct2A", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $3a4760fdb734011b$export$22af68e3614bf024);

var $9U53L = parcelRequire("9U53L");

var $4BY1L = parcelRequire("4BY1L");

var $eKg28 = parcelRequire("eKg28");

var $8Dwiv = parcelRequire("8Dwiv");
const $3a4760fdb734011b$var$listenerVersion = undefined;
function $3a4760fdb734011b$export$22af68e3614bf024(event) {
    const sources = (0, $8Dwiv.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))((0, $8Dwiv.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $8Dwiv.getExtraAttributes)(event);
    const tags = new Set(event.payload.tags || []);
    tags.add('teamworkGraph');
    const components = (0, $8Dwiv.getComponents)(event);
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(sources) || (0, $9U53L.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))({}, extraAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $8Dwiv.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $3a4760fdb734011b$var$listenerVersion
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});




parcelRegister("51Jlt", function(module, exports) {
$parcel$export(module.exports, "setAccountMetaTag", () => $28efe398d7233235$export$3ffe5752aad15e0d);

var $1We2B = parcelRequire("1We2B");

var $4L08H = parcelRequire("4L08H");

var $jByYr = parcelRequire("jByYr");
const $28efe398d7233235$export$3ffe5752aad15e0d = (isAtlassianManaged, accountId)=>{
    if (!accountId) return;
    const accountTypeMeta = (0, $jByYr.getMetaFromHTML)('ajs-account-type');
    const accountIdMeta = (0, $jByYr.getMetaFromHTML)('ajs-atlassian-account-id');
    if (!(0, $1We2B.isNil)(accountTypeMeta) && !(0, $1We2B.isNil)(accountIdMeta) && accountIdMeta === accountId) return;
    (0, $jByYr.setHTMLMeta)('ajs-atlassian-account-id', accountId);
    (0, $jByYr.setHTMLMeta)('account-id', accountId);
    if (isAtlassianManaged) (0, $jByYr.setHTMLMeta)('ajs-account-type', 'atlassian');
    else (0, $jByYr.setHTMLMeta)('ajs-account-type', 'customer');
    (0, $4L08H.updateUserInfo)(accountId);
};

});

parcelRegister("lmVcW", function(module, exports) {
$parcel$export(module.exports, "CustomDomainsAnalyticsProvider", () => $d0b812ecbfe432f9$export$8bf41bf02d1555eb);

var $8P7DW = parcelRequire("8P7DW");

var $iziiq = parcelRequire("iziiq");
const $d0b812ecbfe432f9$export$8bf41bf02d1555eb = ({ children: children, baseUrl: baseUrl })=>{
    const atlassianDomains = [
        'atlassian.net',
        'jira-dev.com',
        'atlassian.com',
        'jira.com',
        'atl-paas.net',
        'trello.com',
        'bitbucket.org'
    ];
    if (atlassianDomains.some((domain)=>baseUrl.toLowerCase().includes(domain))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iziiq.AnalyticsContext), {
        attributes: {
            isCustomDomain: false
        }
    }, children);
    const customDomain = new URL(baseUrl).hostname;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iziiq.AnalyticsContext), {
        attributes: {
            customDomain: customDomain,
            isCustomDomain: true
        }
    }, children);
};

});

parcelRegister("cwJhX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8668b5c257e22f6f$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $iziiq = parcelRequire("iziiq");
const $8668b5c257e22f6f$var$extractFlags = ()=>Object.entries($HGACo).reduce((acc, [key, value])=>{
        if (typeof value !== 'function') return acc;
        return {
            ...acc,
            [key]: value()
        };
    }, {});
const $8668b5c257e22f6f$var$FeatureFlagContext = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iziiq.AnalyticsContext), {
        attributes: $8668b5c257e22f6f$var$extractFlags()
    }, children);
var $8668b5c257e22f6f$export$2e2bcd8739ae039 = $8668b5c257e22f6f$var$FeatureFlagContext;

});

parcelRegister("eIXeQ", function(module, exports) {
$parcel$export(module.exports, "PortalAnalyticsContext", () => $f268808d00fdb7ce$export$156073b6afb2624e);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");
parcelRequire("2tsrb");
var $7IL12 = parcelRequire("7IL12");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $8g163 = parcelRequire("8g163");
const $f268808d00fdb7ce$var$selector = (state)=>{
    const portalId = (0, $7IL12.getPortalId)(state);
    const attributes = (0, $73V7l.getPortalAnalyticAttributes)(state, portalId);
    return {
        attributes: attributes
    };
};
const $f268808d00fdb7ce$export$156073b6afb2624e = (0, $jvoWT.default)($f268808d00fdb7ce$var$selector)((0, $8g163.default));

});
parcelRegister("8g163", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a7c62c034202035$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $iziiq = parcelRequire("iziiq");
const $0a7c62c034202035$var$PortalContext = ({ children: children, attributes: attributes })=>/*#__PURE__*/ $8P7DW.createElement((0, $iziiq.AnalyticsContext), {
        sourceName: "portalUnknown",
        sourceType: (0, $iziiq.ScreenTypes).SCREEN,
        attributes: {
            context: 'Portal',
            ...attributes
        }
    }, children);
var $0a7c62c034202035$export$2e2bcd8739ae039 = $0a7c62c034202035$var$PortalContext;

});


parcelRegister("gcZ9C", function(module, exports) {
$parcel$export(module.exports, "withCoordinationClient", () => $121ca5a3875a7034$export$eeb046361df75e84);
$parcel$export(module.exports, "default", () => $121ca5a3875a7034$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $jByYr = parcelRequire("jByYr");

var $jYRJU = parcelRequire("jYRJU");

var $lut7F = parcelRequire("lut7F");
const $121ca5a3875a7034$export$a91cdb60d3cc20e2 = /*#__PURE__*/ $8P7DW.createContext({
    coordinationClient: undefined
});

const $121ca5a3875a7034$var$CoordinationClientProvider = ({ cloudId: cloudId, children: children })=>{
    const [coordinationClient, setCoordinationClient] = $8P7DW.useState(undefined);
    $8P7DW.useEffect(()=>{
        (0, $jYRJU.promiseWithRetries)(()=>(parcelRequire("aFhco"))).then((module)=>{
            setCoordinationClient(new module.CoordinationClient(cloudId, '/gateway/api'));
        }).catch((error)=>{
            (0, $lut7F.reportError)(error);
        });
    }, [
        cloudId
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($121ca5a3875a7034$export$a91cdb60d3cc20e2.Provider, {
        value: {
            coordinationClient: coordinationClient
        }
    }, children);
};
const $121ca5a3875a7034$export$eeb046361df75e84 = (InnerComponent)=>{
    const Component = (props)=>{
        const { coordinationClient: coordinationClient } = $8P7DW.useContext($121ca5a3875a7034$export$a91cdb60d3cc20e2);
        return /*#__PURE__*/ $8P7DW.createElement(InnerComponent, {
            ...props,
            coordinationClient: coordinationClient
        });
    };
    return Component;
};
const $121ca5a3875a7034$var$mapStateToProps = ()=>{
    return {
        cloudId: (0, $jByYr.getMeta)('tenant-id')
    };
};
var $121ca5a3875a7034$export$2e2bcd8739ae039 = (0, $jvoWT.default)($121ca5a3875a7034$var$mapStateToProps)($121ca5a3875a7034$var$CoordinationClientProvider);

});
parcelRegister("jYRJU", function(module, exports) {
$parcel$export(module.exports, "promiseWithRetries", () => $588bc890e6149c6c$export$e27278bd94558912);
const $588bc890e6149c6c$var$DEFAULT_TIMEOUT_MS = 1000;
const $588bc890e6149c6c$var$DEFAULT_NUMBER_OF_RETRIES = 3;
const $588bc890e6149c6c$var$delay = (timeMs)=>new Promise((resolve)=>setTimeout(resolve, timeMs));
const $588bc890e6149c6c$export$e27278bd94558912 = (promise, config = {})=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { numberOfRetries: numberOfRetries = $588bc890e6149c6c$var$DEFAULT_NUMBER_OF_RETRIES, timeoutMs: timeoutMs = $588bc890e6149c6c$var$DEFAULT_TIMEOUT_MS, error: error = null } = config;
    if (numberOfRetries <= 0) return Promise.reject(error);
    return promise().catch((promiseError)=>$588bc890e6149c6c$var$delay(timeoutMs).then(()=>// Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            $588bc890e6149c6c$export$e27278bd94558912(promise, {
                ...config,
                numberOfRetries: numberOfRetries - 1,
                error: promiseError
            })));
};

});

parcelRegister("aFhco", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("lUtvv"),
    $j9MRt("kDWWL"),
    $j9MRt("35jUB")
]).then(()=>parcelRequire('kohZ2'));

});


parcelRegister("7PmZt", function(module, exports) {
$parcel$export(module.exports, "intlErrorMatch", () => $c96542d8addb4e36$export$c8d26e19aa1787d3);
const $c96542d8addb4e36$export$c8d26e19aa1787d3 = (intlError)=>{
    const match = intlError.match(/Missing message: "(.*)" for locale "(.*)", using default message as fallback./);
    let isNonFinal = false;
    const errorKey = match ? match[1] : null;
    if (errorKey) isNonFinal = [
        '.non-final',
        'nonFinal'
    ].some((checkString)=>errorKey.includes(checkString));
    return {
        errorKey: errorKey,
        isNonFinal: isNonFinal,
        errorLocale: match ? match[2] : null
    };
};

});

parcelRegister("dd3om", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb448686a1a1dab9$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $eM37y = parcelRequire("eM37y");
const $bb448686a1a1dab9$var$selector = (0, $ehscL.createSelector)((0, $hx8zX.getLocale), (locale)=>({
        locale: locale
    }));
var $bb448686a1a1dab9$export$2e2bcd8739ae039 = (0, $jvoWT.default)($bb448686a1a1dab9$var$selector)((0, $eM37y.DeferredWrmResourceProvider));

});
parcelRegister("eM37y", function(module, exports) {
$parcel$export(module.exports, "DeferredWrmResourceContext", () => $c5d08c02b5977f4b$export$266fd8d1fd8c9019);
$parcel$export(module.exports, "DeferredWrmResourceProvider", () => $c5d08c02b5977f4b$export$f1f3f896300d60a3);

var $8P7DW = parcelRequire("8P7DW");

var $1We2B = parcelRequire("1We2B");

var $91Rre = parcelRequire("91Rre");

var $6gThk = parcelRequire("6gThk");
const $c5d08c02b5977f4b$export$266fd8d1fd8c9019 = /*#__PURE__*/ $8P7DW.createContext({
    resourcesLoaded: false,
    setResourcesLoaded: (0, $1We2B.noop)
});
const $c5d08c02b5977f4b$var$DEFERRED_WRM_CONTEXT = [
    'deferred.customer.portal.wrm'
];
const $c5d08c02b5977f4b$var$getDeferredWrmContexts = (0, $91Rre.default)((locale)=>[
        ...$c5d08c02b5977f4b$var$DEFERRED_WRM_CONTEXT,
        `jira.webresources:calendar-${locale}`
    ]);
const $c5d08c02b5977f4b$export$f1f3f896300d60a3 = ({ children: children, locale: locale })=>{
    const [resourcesLoaded, setLoaded] = $8P7DW.useState(false);
    const setResourcesLoaded = $8P7DW.useCallback(()=>{
        setLoaded(true);
    }, [
        setLoaded
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($c5d08c02b5977f4b$export$266fd8d1fd8c9019.Provider, {
        value: {
            resourcesLoaded: resourcesLoaded,
            setResourcesLoaded: setResourcesLoaded
        }
    }, /*#__PURE__*/ $8P7DW.createElement((0, $6gThk.default), {
        onResourcesLoaded: setResourcesLoaded,
        resourceKeys: $c5d08c02b5977f4b$var$getDeferredWrmContexts(locale)
    }), children);
};

});
parcelRegister("91Rre", function(module, exports) {
$parcel$export(module.exports, "default", () => $a99e37e92e83e671$export$2e2bcd8739ae039);
/**
 * Copied from https://github.com/alexreardon/memoize-one/tree/master/src
 *
 *
 * Delete this folder when https://github.com/alexreardon/memoize-one/issues/37 is resolved and we can use the package directly
 * turning on esModuleInterop breaks a whole bunch of other tests, so for now this is the least intrusive workaround to get this utility
 *
 */ function $a99e37e92e83e671$var$areInputsEqual(newInputs, lastInputs) {
    // no checks needed if the inputs length has changed
    if (newInputs.length !== lastInputs.length) return false;
    // Using for loop for speed. It generally performs better than array.every
    // https://github.com/alexreardon/memoize-one/pull/59
    for(let i = 0; i < newInputs.length; i++){
        // using shallow equality check
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $a99e37e92e83e671$export$2e2bcd8739ae039(resultFn, isEqual = $a99e37e92e83e671$var$areInputsEqual) {
    let lastThis;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    // breaking cache when context (this) or arguments change
    function memoized(...newArgs) {
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        // Throwing during an assignment aborts the assignment: https://codepen.io/alexreardon/pen/RYKoaz
        // Doing the lastResult assignment first so that if it throws
        // nothing will be overwritten
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        // @typescript-eslint upgrade to v5.61.0
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

});

parcelRegister("6gThk", function(module, exports) {
$parcel$export(module.exports, "default", () => $d144fa8b73f66cdd$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $1We2B = parcelRequire("1We2B");

var $9ypa9 = parcelRequire("9ypa9");

var $jjE9o = parcelRequire("jjE9o");

var $hvt1h = parcelRequire("hvt1h");
const $d144fa8b73f66cdd$var$createScriptResource = (url)=>Object.assign(document.createElement('script'), {
        type: 'text/javascript',
        charset: 'utf-8',
        async: true,
        src: url
    });
const $d144fa8b73f66cdd$var$createCssResource = (url)=>Object.assign(document.createElement('link'), {
        rel: 'stylesheet',
        type: 'text/css',
        href: url
    });
const $d144fa8b73f66cdd$var$createResource = (resourceDescriptor)=>{
    const { resourceType: resourceType, url: url } = resourceDescriptor;
    if (resourceType === 'CSS') return $d144fa8b73f66cdd$var$createCssResource(url);
    return $d144fa8b73f66cdd$var$createScriptResource(url);
};
const $d144fa8b73f66cdd$var$loadResources = (0, $1We2B.once)((wrmResources, unparsedData)=>{
    window.WRM = {
        _unparsedData: {
            ...unparsedData
        }
    };
    const resources = wrmResources.map((resource)=>new Promise((resolve)=>{
            resource.onload = ()=>{
                resolve();
            };
            resource.onerror = (error)=>{
                (0, $9ypa9.trackError)(`deferred.wrm.resource.load.failed`, {}, error.message);
                (0, $jjE9o.operationalEvent)({
                    action: 'failed',
                    actionSubject: 'loadWrmResources',
                    source: 'unknownSource',
                    attributes: {
                        errorMessage: error.message
                    }
                });
            };
            document.head.appendChild(resource);
        }));
    return Promise.all(resources);
});
const $d144fa8b73f66cdd$var$WrmModuleLoader = ({ onResourcesLoaded: onResourcesLoaded, resourceKeys: resourceKeys })=>{
    const asyncWrmRequire = $8P7DW.useCallback(async ()=>{
        try {
            const { unparsedData: unparsedData, resources: resourceDescriptors } = await (0, $hvt1h.fetchWrmResourceDescriptors)(resourceKeys);
            const wrmResources = resourceDescriptors.map((resourceDescriptor)=>$d144fa8b73f66cdd$var$createResource(resourceDescriptor));
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $d144fa8b73f66cdd$var$loadResources(wrmResources, unparsedData).then(()=>{
                onResourcesLoaded();
            });
        } catch (e) {
            (0, $9ypa9.trackError)('fetchWrmResourceDescriptors.fetch.failed', {}, e);
            (0, $jjE9o.operationalEvent)({
                action: 'failed',
                actionSubject: 'fetchWrmResourceDescriptors',
                source: 'unknownSource',
                attributes: {
                    resourceKeys: resourceKeys,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    errorMessage: e.message
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (0, $hvt1h.fetchWrmResourceDescriptors)
    ]);
    $8P7DW.useEffect(()=>{
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        asyncWrmRequire();
    }, [
        asyncWrmRequire
    ]);
    return null;
};
var $d144fa8b73f66cdd$export$2e2bcd8739ae039 = $d144fa8b73f66cdd$var$WrmModuleLoader;

});
parcelRegister("hvt1h", function(module, exports) {
$parcel$export(module.exports, "fetchWrmResourceDescriptors", () => $d823089e3befb060$export$25121547929106be);

var $breWd = parcelRequire("breWd");

var $7FSs7 = parcelRequire("7FSs7");
const $d823089e3befb060$var$getRequestBody = ({ webResources: webResources = [], contexts: contexts = [], excludedContexts: excludedContexts = [], excludedWebResources: excludedWebResources = [] })=>({
        r: webResources,
        c: contexts,
        xc: excludedContexts,
        xr: excludedWebResources
    });
const $d823089e3befb060$export$25121547929106be = (resources)=>{
    const uri = `${(0, $7FSs7.contextPath)}/rest/webResources/1.0/resources`;
    const body = $d823089e3befb060$var$getRequestBody({
        contexts: resources
    });
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $breWd.post)(uri, body, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).toPromise().catch((e)=>Promise.reject(e));
};

});




parcelRegister("aAfp6", function(module, exports) {
$parcel$export(module.exports, "MetaDataProvider", () => (parcelRequire("eou6j")).default);

var $eou6j = parcelRequire("eou6j");

var $986n2 = parcelRequire("986n2");

});
parcelRegister("eou6j", function(module, exports) {
$parcel$export(module.exports, "default", () => $1247b5488513b911$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");
parcelRequire("l6lPJ");
var $2ccck = parcelRequire("2ccck");
parcelRequire("7qCFa");
var $emeJS = parcelRequire("emeJS");

var $986n2 = parcelRequire("986n2");
const $1247b5488513b911$var$mapDispatchToProps = {
    updateEnvAction: $2ccck.updateEnvAction,
    updateMetaAction: $emeJS.updateMetaAction
};
var $1247b5488513b911$export$2e2bcd8739ae039 = (0, $jvoWT.default)(null, $1247b5488513b911$var$mapDispatchToProps)((0, $986n2.default));

});



parcelRegister("5NIXX", function(module, exports) {
$parcel$export(module.exports, "GenericErrorPage", () => (parcelRequire("fuc2f")).default);

var $fuc2f = parcelRequire("fuc2f");

});
parcelRegister("fuc2f", function(module, exports) {
$parcel$export(module.exports, "default", () => $9149006c4d95eb83$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $kFMFl = parcelRequire("kFMFl");

var $7xip1 = parcelRequire("7xip1");

var $l4cjO = parcelRequire("l4cjO");

var $h89KC = parcelRequire("h89KC");

var $iqJis = parcelRequire("iqJis");

var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");

var $c7dQO = parcelRequire("c7dQO");
const $9149006c4d95eb83$var$GenericErrorPage = ({ title: title, message: message, hideFooter: hideFooter })=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $7xip1.Root), null, /*#__PURE__*/ $8P7DW.createElement((0, $7xip1.Container), null, /*#__PURE__*/ $8P7DW.createElement((0, $7xip1.PageErrorIcon), null), /*#__PURE__*/ $8P7DW.createElement((0, $7xip1.MessageContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
            space: "space.200",
            alignInline: "center"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
            size: "xlarge"
        }, title ? title : /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $kFMFl.default).errorTitle)), /*#__PURE__*/ $8P7DW.createElement((0, $7zDtY.default), {
            align: "center"
        }, message ? message : /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $kFMFl.default).errorMessage)))
    }, /*#__PURE__*/ $8P7DW.createElement((0, $7xip1.ErrorMessage), null, title ? title : /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $kFMFl.default).errorTitle)), /*#__PURE__*/ $8P7DW.createElement((0, $7xip1.HelpText), null, message ? message : /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $kFMFl.default).errorMessage))))), !hideFooter && /*#__PURE__*/ $8P7DW.createElement((0, $h89KC.Footer), null));
};
var $9149006c4d95eb83$export$2e2bcd8739ae039 = $9149006c4d95eb83$var$GenericErrorPage;

});
parcelRegister("kFMFl", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbbfca30731d6d60$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $cbbfca30731d6d60$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    errorTitle: {
        defaultMessage: "We're on it",
        description: 'Error title to show on the generic error page.',
        id: 'cv.portal.generic.error.page.error.title'
    },
    errorMessage: {
        defaultMessage: 'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
        description: 'Error message to show on the generic error page.',
        id: 'cv.portal.generic.error.page.error.message'
    }
});

});

parcelRegister("7xip1", function(module, exports) {
$parcel$export(module.exports, "Root", () => $56018339d9645730$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Container", () => $56018339d9645730$export$42a852a2b6b56249);
$parcel$export(module.exports, "ErrorMessage", () => $56018339d9645730$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "HelpText", () => $56018339d9645730$export$a67c0bc59081311a);
$parcel$export(module.exports, "MessageContainer", () => $56018339d9645730$export$616d763e306cba45);
$parcel$export(module.exports, "PageErrorIcon", () => $56018339d9645730$export$4e475cfbf52c9b29);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $kwRxA = parcelRequire("kwRxA");
const $56018339d9645730$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-16pz4j-0"
})`${$6t2I3.flexCenter};height:100%;flex:1 1 auto;flex-direction:column;`;
const $56018339d9645730$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-16pz4j-1"
})`${$6t2I3.flexCenter};flex:1 1 auto;flex-direction:column;margin-bottom:${"var(--ds-space-800, 64px)"};padding-bottom:${"var(--ds-space-100, 8px)"};`;
const $56018339d9645730$export$915e9e7bd4f0f96d = /*#__PURE__*/ (0, $2UsNA.default).h1.withConfig({
    componentId: "sc-16pz4j-2"
})`${$kBzhX.h800};`;
const $56018339d9645730$export$a67c0bc59081311a = /*#__PURE__*/ (0, $2UsNA.default).p.withConfig({
    componentId: "sc-16pz4j-3"
})`margin-top:${"var(--ds-space-200, 16px)"};`;
const $56018339d9645730$export$616d763e306cba45 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-16pz4j-4"
})`text-align:center;padding:0 ${"var(--ds-space-200, 16px)"};margin-top:${"var(--ds-space-300, 24px)"};max-width:${$4cxV2.multiple(53).px};`;
const $56018339d9645730$export$4e475cfbf52c9b29 = /*#__PURE__*/ (0, $2UsNA.default)((0, $kwRxA.default)).withConfig({
    componentId: "sc-16pz4j-5"
})`width:${$4cxV2.multiple(34).px};`;

});
parcelRegister("kBzhX", function(module, exports) {
$parcel$export(module.exports, "small", () => $062e5d98dca801ba$export$3c17b0e969a90510);
$parcel$export(module.exports, "regular", () => $062e5d98dca801ba$export$28a535dd448ffda4);
$parcel$export(module.exports, "medium", () => $062e5d98dca801ba$export$649ecc744817b5c7);
$parcel$export(module.exports, "mediumLarge", () => $062e5d98dca801ba$export$eab9f63b1324bb90);
$parcel$export(module.exports, "xsmall", () => $062e5d98dca801ba$export$53e73bcd5097e50d);
$parcel$export(module.exports, "h800", () => $062e5d98dca801ba$export$3953fb6fbd158d23);
$parcel$export(module.exports, "h700", () => $062e5d98dca801ba$export$e4f993a313607daa);
$parcel$export(module.exports, "h600", () => $062e5d98dca801ba$export$1e8b2acea3fb3119);
$parcel$export(module.exports, "h500", () => $062e5d98dca801ba$export$85aa43a9b9f06707);
$parcel$export(module.exports, "h400", () => $062e5d98dca801ba$export$fcb7764b80bd908f);
$parcel$export(module.exports, "h300", () => $062e5d98dca801ba$export$a0e59c3bbc05e815);
$parcel$export(module.exports, "h200", () => $062e5d98dca801ba$export$7ccf32eb2150ac7e);
$parcel$export(module.exports, "h100", () => $062e5d98dca801ba$export$dfc0e69214efdc3c);
/* eslint-disable @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css -- Disabled to upgrade atlaskit/theme */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");
const $062e5d98dca801ba$export$3c17b0e969a90510 = /*#__PURE__*/ (0, $2UsNA.css)`font-size:12px;`;
const $062e5d98dca801ba$export$28a535dd448ffda4 = /*#__PURE__*/ (0, $2UsNA.css)`font-size:14px;`;
const $062e5d98dca801ba$export$649ecc744817b5c7 = /*#__PURE__*/ (0, $2UsNA.css)`font-size:16px;`;
const $062e5d98dca801ba$export$eab9f63b1324bb90 = /*#__PURE__*/ (0, $2UsNA.css)`font-size:18px;`;
const $062e5d98dca801ba$export$53e73bcd5097e50d = /*#__PURE__*/ (0, $2UsNA.css)`font-size:11px;`;
const $062e5d98dca801ba$export$3953fb6fbd158d23 = /*#__PURE__*/ (0, $2UsNA.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.01em',
    marginTop: "var(--ds-space-500, 40px)",
    fontSize: '2.071em',
    fontStyle: 'inherit',
    lineHeight: 1.103
});
const $062e5d98dca801ba$export$e4f993a313607daa = /*#__PURE__*/ (0, $2UsNA.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    marginTop: "var(--ds-space-500, 40px)",
    fontSize: '1.714em',
    fontStyle: 'inherit',
    lineHeight: 1.167
});
const $062e5d98dca801ba$export$1e8b2acea3fb3119 = /*#__PURE__*/ (0, $2UsNA.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.008em',
    //eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/use-tokens-space
    marginTop: '28px',
    fontSize: '1.429em',
    fontStyle: 'inherit',
    lineHeight: 1.2
});
const $062e5d98dca801ba$export$85aa43a9b9f06707 = /*#__PURE__*/ (0, $2UsNA.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.006em',
    marginTop: "var(--ds-space-300, 24px)",
    fontSize: '1.143em',
    fontStyle: 'inherit',
    lineHeight: 1.25
});
const $062e5d98dca801ba$export$fcb7764b80bd908f = /*#__PURE__*/ (0, $2UsNA.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '1em',
    fontStyle: 'inherit',
    lineHeight: 1.143
});
const $062e5d98dca801ba$export$a0e59c3bbc05e815 = /*#__PURE__*/ (0, $2UsNA.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    marginTop: "var(--ds-space-250, 20px)",
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333,
    textTransform: 'uppercase'
});
const $062e5d98dca801ba$export$7ccf32eb2150ac7e = /*#__PURE__*/ (0, $2UsNA.css)({
    color: "var(--ds-text-subtlest, #6B778C)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333
});
const $062e5d98dca801ba$export$dfc0e69214efdc3c = /*#__PURE__*/ (0, $2UsNA.css)({
    color: "var(--ds-text-subtlest, #6B778C)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '0.786em',
    fontStyle: 'inherit',
    lineHeight: 1.455
});

});

parcelRegister("kwRxA", function(module, exports) {
$parcel$export(module.exports, "default", () => $593ee9f62100ceee$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $593ee9f62100ceee$var$SvgPageerrorreact = (props)=>/*#__PURE__*/ $8P7DW.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 244.1 215.54",
        ...props
    }, /*#__PURE__*/ $8P7DW.createElement("defs", null, /*#__PURE__*/ $8P7DW.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient",
        x1: 161.63,
        y1: 110.9,
        x2: 64.3,
        y2: 156.29,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 0,
        stopColor: "#ffd740"
    }), /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 1,
        stopColor: "#ffab00"
    })), /*#__PURE__*/ $8P7DW.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-2",
        x1: 14.8,
        y1: 230.34,
        x2: 229.01,
        y2: 16.13,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 0,
        stopColor: "#c1c7d0"
    }), /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 1,
        stopColor: "#fafbfc"
    })), /*#__PURE__*/ $8P7DW.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-3",
        x1: 44.97,
        y1: 136.36,
        x2: 187.42,
        y2: -6.09,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 0,
        stopColor: "#fafbfc",
        stopOpacity: 0.1
    }), /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 0.82,
        stopColor: "#ebecf0"
    })), /*#__PURE__*/ $8P7DW.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-4",
        x1: 68.71,
        y1: 188.85,
        x2: 148.65,
        y2: 108.91,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 0,
        stopColor: "#ebecf0",
        stopOpacity: 0.1
    }), /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 1,
        stopColor: "#ebecf0"
    })), /*#__PURE__*/ $8P7DW.createElement("clipPath", {
        id: "page_error_react_svg__clip-path"
    }, /*#__PURE__*/ $8P7DW.createElement("path", {
        id: "page_error_react_svg___Polygon_",
        "data-name": "<Polygon>",
        className: "page_error_react_svg__cls-2",
        d: "m133.8 70.82 47.32 82a10.81 10.81 0 0 1-9.36 16.18H77.11a10.81 10.81 0 0 1-9.36-16.21l47.32-82a10.81 10.81 0 0 1 18.73.03Z"
    })), /*#__PURE__*/ $8P7DW.createElement("clipPath", {
        id: "page_error_react_svg__clip-path-2"
    }, /*#__PURE__*/ $8P7DW.createElement("rect", {
        id: "page_error_react_svg___Rectangle_",
        "data-name": "<Rectangle>",
        className: "page_error_react_svg__cls-1",
        x: 36.6,
        y: 80.59,
        width: 170.61,
        height: 106.38,
        rx: 5.07,
        ry: 5.07
    })), /*#__PURE__*/ $8P7DW.createElement("style", null, ".page_error_react_svg__cls-1{fill:#fff}.page_error_react_svg__cls-2{fill:url(#page_error_react_svg__linear-gradient)}.page_error_react_svg__cls-7{fill:#253858}.page_error_react_svg__cls-15{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;stroke:#5e6c84}")), /*#__PURE__*/ $8P7DW.createElement("g", {
        style: {
            isolation: "isolate"
        }
    }, /*#__PURE__*/ $8P7DW.createElement("g", {
        id: "page_error_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $8P7DW.createElement("g", {
        id: "page_error_react_svg__Software"
    }, /*#__PURE__*/ $8P7DW.createElement("path", {
        id: "page_error_react_svg___Rectangle_2",
        "data-name": "<Rectangle>",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-2)"
        },
        d: "M0 30.92h243.81v184.62H0z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        style: {
            fill: "#ebecf0"
        },
        d: "M0 30.92h243.81v19.67H0z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M244.1 67.68c-69.18-6-108.85.91-132.52 8.71-4.66 1.53-10.66 3.75-20.52 6.35-35.63 9.41-68.6 9.94-90.77 8.93V50.59H244.1Z",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-3)",
            mixBlendMode: "multiply"
        }
    }), /*#__PURE__*/ $8P7DW.createElement("circle", {
        className: "page_error_react_svg__cls-7",
        cx: 15.69,
        cy: 40.69,
        r: 5.11
    }), /*#__PURE__*/ $8P7DW.createElement("circle", {
        cx: 32.37,
        cy: 40.69,
        r: 5.11,
        style: {
            fill: "#a5adba"
        }
    }), /*#__PURE__*/ $8P7DW.createElement("circle", {
        cx: 49.05,
        cy: 40.69,
        r: 5.11,
        style: {
            fill: "#0065ff"
        }
    }), /*#__PURE__*/ $8P7DW.createElement("rect", {
        id: "page_error_react_svg___Rectangle_3",
        "data-name": "<Rectangle>",
        className: "page_error_react_svg__cls-1",
        x: 36.6,
        y: 80.59,
        width: 170.61,
        height: 106.38,
        rx: 5.07,
        ry: 5.07
    }), /*#__PURE__*/ $8P7DW.createElement("g", {
        style: {
            clipPath: "url(#page_error_react_svg__clip-path-2)"
        }
    }, /*#__PURE__*/ $8P7DW.createElement("path", {
        id: "page_error_react_svg___Polygon_2",
        "data-name": "<Polygon>",
        d: "m118 78.83 47.32 82A10.81 10.81 0 0 1 156 177H61.36A10.81 10.81 0 0 1 52 160.8l47.32-82a10.81 10.81 0 0 1 18.68.03Z",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-4)",
            mixBlendMode: "multiply"
        }
    })), /*#__PURE__*/ $8P7DW.createElement("path", {
        id: "page_error_react_svg___Polygon_3",
        "data-name": "<Polygon>",
        className: "page_error_react_svg__cls-2",
        d: "m133.8 70.82 47.32 82a10.81 10.81 0 0 1-9.36 16.18H77.11a10.81 10.81 0 0 1-9.36-16.21l47.32-82a10.81 10.81 0 0 1 18.73.03Z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        className: "page_error_react_svg__cls-7",
        d: "m128.41 130.33 2.05-31.59a6.54 6.54 0 0 0-6.53-7 6.54 6.54 0 0 0-6.53 7l2.05 31.59a4.49 4.49 0 0 0 4.48 4.2 4.49 4.49 0 0 0 4.48-4.2ZM117.13 147.1a6.79 6.79 0 0 0 7.4 6.82 6.89 6.89 0 0 0-.64-13.76 6.87 6.87 0 0 0-6.76 6.94Z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M134.17 26.76 126.87.44a.6.6 0 0 0-1.17.05l-4.59 24.72-5.71-1.06a.6.6 0 0 0-.69.75L122 51.23a.6.6 0 0 0 1.17-.05l4.59-24.72 5.71 1.06a.6.6 0 0 0 .7-.76Z",
        style: {
            fill: "#ffc400"
        }
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "m108 41.19-10.73-8.43a.26.26 0 0 0-.4.32l5.44 11.26-2.62 1.27a.26.26 0 0 0 0 .45l10.71 8.42a.26.26 0 0 0 .4-.32l-5.49-11.26 2.62-1.27a.26.26 0 0 0 .07-.44Z",
        style: {
            fill: "#ffab00"
        }
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M157.26 36c-1.15 1.57-10.83-5.52-12-3.95s8.53 8.66 7.38 10.23-10.83-5.52-12-3.94 8.53 8.66 7.38 10.23-10.84-5.51-12-3.94 8.53 8.66 7.38 10.24",
        style: {
            stroke: "#344563",
            fill: "none",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        className: "page_error_react_svg__cls-15",
        d: "M162 63.22c-1.44 1.31-6.95-4.71-8.38-3.39s4.07 7.34 2.63 8.65-6.95-4.71-8.38-3.39c-.67.61.16 2.23 1.1 3.93M88 63.09c1.79.76 5-6.77 6.76-6s-1.37 8.28.42 9 5-6.77 6.76-6c.83.35.6 2.16.29 4.07"
    })))));
var $593ee9f62100ceee$export$2e2bcd8739ae039 = $593ee9f62100ceee$var$SvgPageerrorreact;

});


parcelRegister("h89KC", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $ac0bd1de37cd6787$export$a06f1c675e846f6f);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");

var $amVtx = parcelRequire("amVtx");
const $ac0bd1de37cd6787$var$selector = (0, $ehscL.createSelector)((0, $8Wisn.getWacLink), (linkTo)=>({
        linkTo: linkTo
    }));
const $ac0bd1de37cd6787$export$a06f1c675e846f6f = (0, $jvoWT.default)($ac0bd1de37cd6787$var$selector)((0, $amVtx.default));

});
parcelRegister("amVtx", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e647c6a7019525d$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $4QM8d = parcelRequire("4QM8d");

var $9OXgz = parcelRequire("9OXgz");

var $HGACo = parcelRequire("HGACo");

var $kBzhX = parcelRequire("kBzhX");

var $b60z8 = parcelRequire("b60z8");

var $dxZ6d = parcelRequire("dxZ6d");

var $l4cjO = parcelRequire("l4cjO");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");

var $8gu7I = parcelRequire("8gu7I");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $hbnwP = parcelRequire("hbnwP");

var $kJu2d = parcelRequire("kJu2d");
const $5e647c6a7019525d$var$EDIT_HOMEPAGE_ROUTE_NAME = 'edit-homepage';
const $5e647c6a7019525d$var$Footer = ({ linkTo: linkTo, className: className, isCSM: isCSM })=>{
    const [{ route: route }] = (0, $i9cdb.useRouter)();
    // isCSM check is used for generating correct footer in CSMRequest Type Previews
    const showCSMFooter = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) || isCSM;
    const renderCsmFooter = ()=>{
        // TODO: move contact us section to edit csm page, once page builder allows additional children components
        return (0, $HGACo.isCsmContactUsSectionEnabled)() && route.name === $5e647c6a7019525d$var$EDIT_HOMEPAGE_ROUTE_NAME ? /*#__PURE__*/ $8P7DW.createElement((0, $9OXgz.ContactUsSection), null) : null;
    };
    return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
        data: {
            source: 'footer'
        }
    }, /*#__PURE__*/ $8P7DW.createElement($5e647c6a7019525d$var$FooterContainer, {
        id: "portal-layout-footer",
        className: className,
        "data-testid": "portal-layout-footer"
    }, showCSMFooter ? renderCsmFooter() : /*#__PURE__*/ $8P7DW.createElement($5e647c6a7019525d$var$FooterLink, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation",
        target: "_blank",
        rel: "noopener noreferrer",
        href: linkTo,
        actionSubjectId: "waclink"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), {
        ...(0, $hbnwP.default).footer,
        values: {
            iconHtml: /*#__PURE__*/ $8P7DW.createElement($5e647c6a7019525d$var$FooterJsdIcon, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($dxZ6d))),
                alt: ""
            })
        }
    }))));
};
var $5e647c6a7019525d$export$2e2bcd8739ae039 = $5e647c6a7019525d$var$Footer;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5e647c6a7019525d$var$FooterContainer = /*#__PURE__*/ (0, $2UsNA.default).footer.withConfig({
    componentId: "sc-1d68q8x-0"
})`padding:${`var(--ds-space-600, ${`${(0, $kJu2d.footerPadding)}px`})`} 0;text-align:center;white-space:nowrap;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5e647c6a7019525d$var$FooterJsdIcon = /*#__PURE__*/ (0, $2UsNA.default).img.withConfig({
    componentId: "sc-1d68q8x-1"
})`object-fit:contain;height:${`var(--ds-space-250, ${`${(0, $kJu2d.footerJsdIconHeight)}px`})`};vertical-align:middle;opacity:0.5;transition:opacity ${$b60z8.timingFunctions.easeInOut} ${$b60z8.speedMs.fast}ms;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5e647c6a7019525d$var$FooterLink = /*#__PURE__*/ (0, $2UsNA.default)((0, $4QM8d.HtmlAnchor)).withConfig({
    componentId: "sc-1d68q8x-2"
})`${$kBzhX.small};color:${"var(--ds-text-subtlest, #5E6C84)"};cursor:pointer;:hover,:active{color:${"var(--ds-text-subtlest, #5E6C84)"};text-decoration:none;${$5e647c6a7019525d$var$FooterJsdIcon}{opacity:1;stop:first-child{stop-color:${"var(--ds-background-brand-bold-hovered, #0052CC)"};}stop:last-child{stop-color:${"var(--ds-background-brand-bold, #2684FF)"};}> g > g > path:last-child{fill:${"var(--ds-background-brand-bold, #2684FF)"};}}}`;

});
parcelRegister("4QM8d", function(module, exports) {
$parcel$export(module.exports, "HtmlAnchor", () => $8a0265dc708360fe$export$acca9dc24cfe2034);

var $8P7DW = parcelRequire("8P7DW");

var $frgWG = parcelRequire("frgWG");
const $8a0265dc708360fe$var$InstrumentedLink = ({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, ...anchorProps })=>{
    // Disabling existing violations, should be fixed when revisited.
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content
    return /*#__PURE__*/ $8P7DW.createElement("a", anchorProps);
};
const $8a0265dc708360fe$export$acca9dc24cfe2034 = (0, $frgWG.default)('link', {
    onClick: ()=>({
            action: 'clicked'
        })
})($8a0265dc708360fe$var$InstrumentedLink);

});
parcelRegister("frgWG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e614abe1a9a439e$export$2e2bcd8739ae039);

var $1We2B = parcelRequire("1We2B");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $iziiq = parcelRequire("iziiq");
/**
 * Will create and fire a UI event when the callback is called.
 * Works like the following:
 *
 * YOU NEED TO PASS IN PROPS UNFORTUNATELY SORRY LIMITATION W/ TYPESCRIPT!
 * This means your default props probably won't work. And your props won't be set correctly on the wrapped component.
 * JUST PASS IN TPROPS!
 */ const $1e614abe1a9a439e$var$withCreateFireUIAnalytics = (actionSubject, analyticsDefinition)=>{
    return (Component)=>{
        const mappedAnalyticsDefinition = (0, $1We2B.mapValues)(analyticsDefinition, (val)=>{
            return (create, props)=>{
                const payload = val(props);
                const event = create({
                    ...payload,
                    ...props.attributes,
                    actionSubjectId: props.actionSubjectId,
                    analyticsType: (0, $iziiq.UI_EVENT_TYPE)
                });
                event.fire();
                return event;
            };
        });
        const WrappedComponent = (0, $eS4yu.default)({
            componentName: actionSubject
        })(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $k7ZVu.default)(mappedAnalyticsDefinition)(Component));
        WrappedComponent.displayName = `withCreateFireUIAnalytics(${Component.displayName || Component.name})`;
        return WrappedComponent;
    };
};
var $1e614abe1a9a439e$export$2e2bcd8739ae039 = $1e614abe1a9a439e$var$withCreateFireUIAnalytics;

});


parcelRegister("9OXgz", function(module, exports) {
$parcel$export(module.exports, "ContactUsSection", () => $4ec4b9e0e93c6aef$export$919152da49f07ab);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $4ec4b9e0e93c6aef$export$919152da49f07ab = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("loDvG")), {
        moduleId: "./packages/common-utils/contact-us-section/src/contact-us-section.tsx"
    })
});

});
parcelRegister("gweXC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c49ecadb1bffd572$export$2e2bcd8739ae039);

var $HGACo = parcelRequire("HGACo");

var $lSlS4 = parcelRequire("lSlS4");

var $4vhTn = parcelRequire("4vhTn");
/**
 * This will generically handle async loading of components with a
 * loading, timeout, and errored states. If you need more specific
 * handling use react-loosely-lazy directly.
 *
 * Use the preload option if you want the component to start loading
 * immediately.
 */ const $c49ecadb1bffd572$var$withAsync = (options)=>{
    if ((0, $HGACo.isReact18LazyEnabled)()) return (0, $lSlS4.LazyLoadableComponent)(options);
    const LoadableComponent = (0, $4vhTn.default)({
        loader: options.loader,
        LoadingSkeleton: options.LoadingSkeleton,
        loadingPosition: options.loadingPosition,
        timeout: 5000
    });
    if (options.preload) LoadableComponent.preload();
    return LoadableComponent;
};
var $c49ecadb1bffd572$export$2e2bcd8739ae039 = $c49ecadb1bffd572$var$withAsync;

});
parcelRegister("lSlS4", function(module, exports) {
$parcel$export(module.exports, "LazyLoadableComponent", () => $ed0fa592b6560ab5$export$d778a2211489aeb2);

var $8P7DW = parcelRequire("8P7DW");

var $7PRFC = parcelRequire("7PRFC");

var $3R42Q = parcelRequire("3R42Q");

var $acnkv = parcelRequire("acnkv");

var $5RQPV = parcelRequire("5RQPV");
const $ed0fa592b6560ab5$export$d778a2211489aeb2 = (lazyOptions)=>{
    const Component = lazyOptions.lazyLoader;
    const renderError = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((error)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5RQPV.LoadingComponent), {
            error: error,
            LoadingSkeleton: lazyOptions.LoadingSkeleton
        });
    }, [
        lazyOptions.LoadingSkeleton
    ]);
    const LazyWrapperWithSuspense = (props)=>{
        if (!Component) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3R42Q.ErrorBoundaryAnalytics), {
            renderError: renderError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $acnkv.Fallback), lazyOptions)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, props)));
    };
    // TODO: Muskein, add preload capabilities. we don't have preload capability in react lazy world yet
    LazyWrapperWithSuspense.preload = (0, (/*@__PURE__*/$parcel$interopDefault($7PRFC)));
    return LazyWrapperWithSuspense;
};

});
parcelRegister("3R42Q", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryAnalytics", () => $6cd46f77213a2938$export$627f773fbbb39e);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $iziiq = parcelRequire("iziiq");

var $9ypa9 = parcelRequire("9ypa9");
class $6cd46f77213a2938$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error) {
        if (error.name !== 'ChunkLoadError') {
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent !== undefined) {
                // This analytics will help us to note any errors which were previously marked as chunk errors. This might get triggered multiple times if islooselyLazyJsErrorsToSentryEnabled is true.
                const analyticsEvent = createAnalyticsEvent({
                    analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                    action: 'failed',
                    errorMessage: error.message,
                    errorName: error.name,
                    stack: error.stack
                });
                const finalId = 'looselyLazyErrorBoundary';
                const finalPackage = 'looselyLazyPackage';
                const actionSubject = `${finalPackage}.${finalId}`;
                analyticsEvent.context.push({
                    componentName: actionSubject
                });
                analyticsEvent.fire();
            }
        }
        if ((0, $HGACo.islooselyLazyJsErrorsToSentryEnabled)()) {
            // Differentiate between a chunkLoadError and other JS error.
            if (error.name === 'ChunkLoadError') {
                var _this$props$onError, _this$props;
                (0, $9ypa9.trackError)('async.loader.failed', {}, error);
                (_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props, error);
            } else {
                var _this$props$onError2, _this$props2;
                (_this$props$onError2 = (_this$props2 = this.props).onError) === null || _this$props$onError2 === void 0 || _this$props$onError2.call(_this$props2, error);
                // this error will be caught by ScreenErrorBoundary at route level which will add it to sentry with packageName derived from route ScreenName
                throw error;
            }
        } else {
            var _this$props$onError3, _this$props3;
            (0, $9ypa9.trackError)('async.loader.failed', {}, error);
            (_this$props$onError3 = (_this$props3 = this.props).onError) === null || _this$props$onError3 === void 0 || _this$props$onError3.call(_this$props3, error);
        }
    }
    render() {
        const error = this.state.error;
        return error ? this.props.renderError(error) : this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
const $6cd46f77213a2938$export$627f773fbbb39e = (0, $eS4yu.default)()((0, $k7ZVu.default)()($6cd46f77213a2938$var$ErrorBoundary));

});

parcelRegister("acnkv", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $b644a04acc22ac87$export$fb8d7f40caaeea67);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $4peLG = parcelRequire("4peLG");

var $5RQPV = parcelRequire("5RQPV");
const $b644a04acc22ac87$export$fb8d7f40caaeea67 = (options)=>{
    let displayName = 'unknown';
    if ('lazyLoader' in options && (0, $HGACo.isReact18LazyEnabled)()) {
        var _options$lazyLoader;
        displayName = ((_options$lazyLoader = options.lazyLoader) === null || _options$lazyLoader === void 0 ? void 0 : _options$lazyLoader.name) || 'unknown';
    } else if ('loader' in options) displayName = options.loader.displayName || 'unknown';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
        name: displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5RQPV.LoadingComponent), {
        LoadingSkeleton: options.LoadingSkeleton,
        timeout: options.timeout
    }));
};

});
parcelRegister("4peLG", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e05044bc0f93bbe$export$2e2bcd8739ae039);

var $eG84e = parcelRequire("eG84e");
var $7e05044bc0f93bbe$export$2e2bcd8739ae039 = (0, $eG84e.default);

});
parcelRegister("eG84e", function(module, exports) {
$parcel$export(module.exports, "default", () => $26ad3421b2b62c71$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $cAaWV = parcelRequire("cAaWV");

var $18KuK = parcelRequire("18KuK");

var $8uTBY = parcelRequire("8uTBY");
const $26ad3421b2b62c71$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $8P7DW.useEffect) : (0, $8P7DW.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $26ad3421b2b62c71$var$useInteractionIdValue() {
    const interactionId = (0, $8P7DW.useContext)((0, $8uTBY.default));
    const [currentId, setCurrentId] = (0, $8P7DW.useState)((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
    $26ad3421b2b62c71$var$useLayoutEffectSAFE(()=>{
        setCurrentId((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
        const unsubscribe = (0, $8uTBY.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $26ad3421b2b62c71$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true, experimental: experimental = false }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $cAaWV.isUFOEnabled)();
    const currentInteractionId = $26ad3421b2b62c71$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $8P7DW.useContext)((0, $18KuK.default));
    $26ad3421b2b62c71$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: children
    }) : null;
}

});


parcelRegister("5RQPV", function(module, exports) {
$parcel$export(module.exports, "LoadingComponent", () => $c91c9799a6db8e65$export$7db30d367db7d20a);

var $8P7DW = parcelRequire("8P7DW");

var $5OWUX = parcelRequire("5OWUX");
const $c91c9799a6db8e65$export$7db30d367db7d20a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo(function LoadingComponent({ error: error, LoadingSkeleton: LoadingSkeleton, timeout: timeout, loadingPosition: loadingPosition }) {
    const [isTimedOut, setIsTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        let timer;
        if (timeout) timer = setTimeout(()=>{
            setIsTimedOut(true);
        }, timeout);
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, [
        timeout
    ]);
    if (LoadingSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(LoadingSkeleton, {
        isLoading: !error,
        error: error,
        loadingPosition: loadingPosition
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5OWUX.default), {
        isLoading: !error,
        error: error,
        loadingPosition: loadingPosition,
        timedOut: isTimedOut
    });
});

});
parcelRegister("5OWUX", function(module, exports) {
$parcel$export(module.exports, "ChunkLoadErrorMessage", () => $ace7a7ac0ac46ce7$export$7bbd51879bbec526);
$parcel$export(module.exports, "MarginTop", () => $ace7a7ac0ac46ce7$export$fead96407cda089b);
$parcel$export(module.exports, "SkeletonLoadingWrapper", () => $ace7a7ac0ac46ce7$export$48d1937c6c46b883);
$parcel$export(module.exports, "default", () => $ace7a7ac0ac46ce7$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $8rTkC = parcelRequire("8rTkC");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $l4cjO = parcelRequire("l4cjO");

var $h82Rb = parcelRequire("h82Rb");

var $cjn3r = parcelRequire("cjn3r");

var $eTz6H = parcelRequire("eTz6H");

var $4O8fD = parcelRequire("4O8fD");
const $ace7a7ac0ac46ce7$var$ICON_SIZE = $4cxV2.multiple(6);
const $ace7a7ac0ac46ce7$export$7bbd51879bbec526 = ()=>{
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
        label: "",
        size: "medium",
        spacing: "spacious"
    }), /*#__PURE__*/ $8P7DW.createElement($ace7a7ac0ac46ce7$var$Message, null, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $eTz6H.default).error)));
};
const $ace7a7ac0ac46ce7$export$fead96407cda089b = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-11ukfs2-0"
})`margin-top:${"var(--ds-space-025, 2px)"};`;
const $ace7a7ac0ac46ce7$export$48d1937c6c46b883 = (props)=>{
    let content;
    if (props.error) content = /*#__PURE__*/ $8P7DW.createElement($ace7a7ac0ac46ce7$export$7bbd51879bbec526, null);
    else content = /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $4O8fD.LoadingSkeletonFields), null), props.timedOut && /*#__PURE__*/ $8P7DW.createElement($ace7a7ac0ac46ce7$var$Message, null, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $eTz6H.default).timeout)));
    const Wrapper = props.loadingPosition === 'static' ? (0, $4O8fD.AbsoluteFillContainer) : $ace7a7ac0ac46ce7$var$Container;
    return /*#__PURE__*/ $8P7DW.createElement($ace7a7ac0ac46ce7$export$fead96407cda089b, null, /*#__PURE__*/ $8P7DW.createElement(Wrapper, null, content));
};
const $ace7a7ac0ac46ce7$var$Loading = (props)=>{
    let content;
    if (props.error) content = /*#__PURE__*/ $8P7DW.createElement($ace7a7ac0ac46ce7$export$7bbd51879bbec526, null);
    else content = /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $cjn3r.default), {
        interactionName: props.interactionName || 'help-center-unknown-loader',
        delay: (0, $8rTkC.SPINNER_DELAY),
        appearance: "inherit",
        size: $ace7a7ac0ac46ce7$var$ICON_SIZE.unitless
    }), props.timedOut && /*#__PURE__*/ $8P7DW.createElement($ace7a7ac0ac46ce7$var$Message, null, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $eTz6H.default).timeout)));
    const Wrapper = props.loadingPosition === 'static' ? (0, $4O8fD.AbsoluteFillContainer) : $ace7a7ac0ac46ce7$var$Container;
    return /*#__PURE__*/ $8P7DW.createElement(Wrapper, {
        "data-testid": "loading-container"
    }, content);
};
var $ace7a7ac0ac46ce7$export$2e2bcd8739ae039 = $ace7a7ac0ac46ce7$var$Loading;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ace7a7ac0ac46ce7$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-11ukfs2-1"
})`${$6t2I3.flexCenter};padding:${"var(--ds-space-100, 8px)"};flex-direction:column;pointer-events:none;flex:1 1 auto;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ace7a7ac0ac46ce7$var$Message = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-11ukfs2-2"
})`${$kBzhX.small};margin-top:${"var(--ds-space-100, 8px)"};`;

});
parcelRegister("eTz6H", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a78e532be450832$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $3a78e532be450832$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    error: {
        defaultMessage: 'There was a problem loading, please refresh and try again.',
        description: 'Error message shown when something could not be loaded.',
        id: 'cv.loading.component.error'
    },
    timeout: {
        defaultMessage: 'Taking longer than usual...',
        description: 'Message shown when loading is taking a long time.',
        id: 'cv.loading.component.timeout'
    }
});

});

parcelRegister("4O8fD", function(module, exports) {
$parcel$export(module.exports, "AbsoluteFillContainer", () => $5c9e9fe0a746dd28$export$c55b13eeae4b9470);
$parcel$export(module.exports, "LoadingSkeleton", () => $5c9e9fe0a746dd28$export$44c18d210d5de37b);
$parcel$export(module.exports, "FieldLoadingSkeleton", () => $5c9e9fe0a746dd28$export$e2529b450e72f74e);
$parcel$export(module.exports, "AvatarLoadingSkeleton", () => $5c9e9fe0a746dd28$export$281e083a77da722c);
$parcel$export(module.exports, "LoadingSkeletonFields", () => $5c9e9fe0a746dd28$export$1844a556d867ecb4);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $1We2B = parcelRequire("1We2B");
const $5c9e9fe0a746dd28$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ovlcu-0"
})`${$6t2I3.flexCenter};padding:${"var(--ds-space-100, 8px)"};flex-direction:column;pointer-events:none;flex:1 1 auto;`;
const $5c9e9fe0a746dd28$export$c55b13eeae4b9470 = /*#__PURE__*/ (0, $2UsNA.default)($5c9e9fe0a746dd28$export$42a852a2b6b56249).withConfig({
    componentId: "sc-3ovlcu-1"
})`position:absolute;top:0;left:0;right:0;bottom:0;`;
const $5c9e9fe0a746dd28$var$fromPositionX = -400;
const $5c9e9fe0a746dd28$var$toPositionX = 800;
const $5c9e9fe0a746dd28$var$shimmer = /*#__PURE__*/ (0, $2UsNA.keyframes)({
    '0%': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        backgroundPosition: `${$5c9e9fe0a746dd28$var$fromPositionX}px 0`
    },
    '100%': {
        backgroundPosition: `${$5c9e9fe0a746dd28$var$toPositionX}px 0`
    }
});
const $5c9e9fe0a746dd28$export$44c18d210d5de37b = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ovlcu-2"
})`${$6t2I3.borderRadius};height:${(props)=>`${props.height}px`};background-color:${(props)=>props.backgroundColor};background-image:linear-gradient( to right,${(props)=>props.backgroundColor} 10%,${"var(--ds-surface, #FFFFFF)"} 40%,${(props)=>props.backgroundColor} 50% );background-repeat:no-repeat;animation-duration:0.8s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:${$5c9e9fe0a746dd28$var$shimmer};animation-timing-function:ease-in;`;
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5c9e9fe0a746dd28$var$FieldSkeletonWrapper = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ovlcu-3"
})`${$6t2I3.borderRadius};border:${"var(--ds-border-width-selected, 2px)"} solid;border-color:${"var(--ds-border, #DFE1E6)"};`;
const $5c9e9fe0a746dd28$export$e2529b450e72f74e = ()=>/*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$var$FieldSkeletonWrapper, null, /*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$export$44c18d210d5de37b, {
        height: 150,
        backgroundColor: "var(--ds-skeleton-subtle, #FAFBFC)"
    }));
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5c9e9fe0a746dd28$var$AvatarSkeletonWrapper = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ovlcu-4"
})`min-width:${$4cxV2.multiple(4.5).px};border-radius:50%;overflow:hidden;`;
const $5c9e9fe0a746dd28$export$281e083a77da722c = ()=>/*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$var$AvatarSkeletonWrapper, null, /*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$export$44c18d210d5de37b, {
        height: 36,
        backgroundColor: "var(--ds-skeleton, #EBECF0)"
    }));
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5c9e9fe0a746dd28$var$TextFieldLoadingSkeletonWrapper = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ovlcu-5"
})`margin-top:${"var(--ds-space-500, 40px)"};margin-bottom:${"var(--ds-space-500, 40px)"};`;
const $5c9e9fe0a746dd28$export$66b8cea0c448285 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ovlcu-6"
})`width:100%;`;
const $5c9e9fe0a746dd28$export$37ec45a296aa56b5 = ({ shortText: shortText })=>{
    return /*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$var$TextFieldLoadingSkeletonWrapper, null, /*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$export$44c18d210d5de37b, {
        height: shortText ? $4cxV2.multiple(5).unitless : $4cxV2.multiple(22).unitless,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    }));
};
const $5c9e9fe0a746dd28$export$1844a556d867ecb4 = ()=>{
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$export$66b8cea0c448285, null, (0, $1We2B.range)(3).map((ndx)=>/*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$export$37ec45a296aa56b5, {
            key: ndx,
            shortText: true
        })), /*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$export$37ec45a296aa56b5, {
        shortText: false
    }), /*#__PURE__*/ $8P7DW.createElement($5c9e9fe0a746dd28$export$37ec45a296aa56b5, {
        shortText: true
    })));
};

});





parcelRegister("4vhTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a1109224f12a5fe$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("4PbDu");
var $3FFzY = parcelRequire("3FFzY");

var $3R42Q = parcelRequire("3R42Q");
var $acnkv = parcelRequire("acnkv");
var $5RQPV = parcelRequire("5RQPV");
const $7a1109224f12a5fe$var$LooselyLoadableWrapper = (options)=>{
    const Component = options.loader;
    const LazyComponent = (props)=>{
        const renderError = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((error)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5RQPV.LoadingComponent), {
                error: error,
                LoadingSkeleton: options.LoadingSkeleton
            });
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3R42Q.ErrorBoundaryAnalytics), {
            renderError: renderError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $acnkv.Fallback), options)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, props)));
    };
    LazyComponent.preload = options.loader.preload;
    return LazyComponent;
};
var $7a1109224f12a5fe$export$2e2bcd8739ae039 = $7a1109224f12a5fe$var$LooselyLoadableWrapper;

});


parcelRegister("loDvG", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("39huH").then(()=>parcelRequire('bjBY7'));

});


parcelRegister("dxZ6d", function(module, exports) {
module.exports = new URL("../images/jsd-icon.96c174f6.svg", import.meta.url).toString();

});

parcelRegister("hbnwP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5721c52a4e8997d$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $d5721c52a4e8997d$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    footer: {
        defaultMessage: 'Powered by {iconHtml} Jira Service Management',
        description: 'Message displayed in the webpage footer',
        id: 'sd.jsm.customerview.footer.powered.by.servicemanagement'
    },
    csmFooter: {
        defaultMessage: 'Powered by Jira Customer Service',
        description: 'Message displayed in the webpage footer',
        id: 'sd.jsm.customerview.footer.powered.by.atlassiancustomercollection.non-final'
    }
});

});

parcelRegister("kJu2d", function(module, exports) {
$parcel$export(module.exports, "footerPadding", () => $880215aaae19cabd$export$7d9aba7536a61853);
$parcel$export(module.exports, "footerJsdIconHeight", () => $880215aaae19cabd$export$220c44e1c3ab6f4);
$parcel$export(module.exports, "FOOTER_HEIGHT", () => $880215aaae19cabd$export$a2dd5f25b5a4e5d2);

var $4cxV2 = parcelRequire("4cxV2");
const $880215aaae19cabd$export$7d9aba7536a61853 = $4cxV2.multiple(6).unitless;
const $880215aaae19cabd$export$220c44e1c3ab6f4 = $4cxV2.multiple(2.5).unitless;
const $880215aaae19cabd$export$a2dd5f25b5a4e5d2 = $880215aaae19cabd$export$7d9aba7536a61853 * 2 + $880215aaae19cabd$export$220c44e1c3ab6f4;

});



parcelRegister("2IKBM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca923dc1b140f4ec$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $37U6z = parcelRequire("37U6z");

var $dqsXi = parcelRequire("dqsXi");
const $ca923dc1b140f4ec$var$flexGrowMap = {
    hug: (0, $37U6z.xcss)({
        flexGrow: 0
    }),
    fill: (0, $37U6z.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $ca923dc1b140f4ec$var$Stack = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, id: id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $ca923dc1b140f4ec$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $dqsXi.default), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$ca923dc1b140f4ec$var$Stack.displayName = 'Stack';
var $ca923dc1b140f4ec$export$2e2bcd8739ae039 = $ca923dc1b140f4ec$var$Stack;

});

parcelRegister("7zDtY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7a7d7596f9e209e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $clS24 = parcelRequire("clS24");

var $b7baD = parcelRequire("b7baD");

var $YDqMU = parcelRequire("YDqMU");

var $j4RVe = parcelRequire("j4RVe");
function $d7a7d7596f9e209e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d7a7d7596f9e209e$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $d7a7d7596f9e209e$var$resetStyles = {
    name: "eb2bs7",
    styles: "margin:0;overflow-wrap:anywhere"
};
const $d7a7d7596f9e209e$var$strongStyles = {
    name: "17rayov",
    styles: "font-weight:var(--ds-font-weight-bold, 653)"
};
const $d7a7d7596f9e209e$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $d7a7d7596f9e209e$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $d7a7d7596f9e209e$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $d7a7d7596f9e209e$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $d7a7d7596f9e209e$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $YDqMU.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $j4RVe.inverseColorMap).hasOwnProperty(surface)) return (0, $j4RVe.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $d7a7d7596f9e209e$var$Text = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $clS24.default)($d7a7d7596f9e209e$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $b7baD.useHasTextAncestor)();
    const color = $d7a7d7596f9e209e$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $8Z0o8.jsx)(Component, {
        ref: ref,
        css: [
            $d7a7d7596f9e209e$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $j4RVe.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $j4RVe.textColorStylesMap)[color],
            maxLines && $d7a7d7596f9e209e$var$truncationStyles,
            maxLines === 1 && $d7a7d7596f9e209e$var$wordBreakMap.breakAll,
            align && $d7a7d7596f9e209e$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $j4RVe.textWeightStylesMap)[weight],
            Component === 'em' && $d7a7d7596f9e209e$var$emStyles,
            Component === 'strong' && $d7a7d7596f9e209e$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $b7baD.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $d7a7d7596f9e209e$export$2e2bcd8739ae039 = $d7a7d7596f9e209e$var$Text;

});

parcelRegister("c7dQO", function(module, exports) {
$parcel$export(module.exports, "useIsCSMTypographyMigrationEnabled", () => $6de67e884ba65036$export$f77c7e452595da18);
$parcel$export(module.exports, "UseTypographyMigratedComponent", () => $6de67e884ba65036$export$527b88b630251664);

var $1EFS8 = parcelRequire("1EFS8");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");
const $6de67e884ba65036$export$f77c7e452595da18 = (useWhiteListedRouteNamesCheck = false)=>{
    if (useWhiteListedRouteNamesCheck) return (0, $1EFS8.default).checkGate('enable_typography_token_migration_for_csm') && (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    return (0, $1EFS8.default).checkGate('enable_typography_token_migration_for_csm') && (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
};
const $6de67e884ba65036$export$527b88b630251664 = (props)=>{
    const isCSMTypographyMigrationEnabled = $6de67e884ba65036$export$f77c7e452595da18();
    return isCSMTypographyMigrationEnabled ? props.migratedComponent : props.children;
};

});



parcelRegister("eT1JU", function(module, exports) {
$parcel$export(module.exports, "App", () => (parcelRequire("7Zfpv")).default);

var $7Zfpv = parcelRequire("7Zfpv");

});
parcelRegister("7Zfpv", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa611f027227513b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $1EFS8 = parcelRequire("1EFS8");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");

var $5JrSO = parcelRequire("5JrSO");
parcelRequire("2qA3i");
var $7NVEF = parcelRequire("7NVEF");
parcelRequire("2DAP0");
var $6Pl45 = parcelRequire("6Pl45");

var $aXSLq = parcelRequire("aXSLq");

var $gKWTh = parcelRequire("gKWTh");

var $5JQIe = parcelRequire("5JQIe");

var $e6Qdr = parcelRequire("e6Qdr");

var $iziiq = parcelRequire("iziiq");

var $gk18s = parcelRequire("gk18s");

var $gk18s = parcelRequire("gk18s");

var $8fLNY = parcelRequire("8fLNY");

var $gbM8r = parcelRequire("gbM8r");

var $7qmv5 = parcelRequire("7qmv5");

var $hrPHR = parcelRequire("hrPHR");

var $8XrTk = parcelRequire("8XrTk");

var $6hdgt = parcelRequire("6hdgt");
parcelRequire("jnlOI");
var $fK2Le = parcelRequire("fK2Le");

var $8y0tS = parcelRequire("8y0tS");

var $Gcr5d = parcelRequire("Gcr5d");

var $bm9XU = parcelRequire("bm9XU");

var $auztA = parcelRequire("auztA");

var $2qHaK = parcelRequire("2qHaK");

var $ftaVT = parcelRequire("ftaVT");
parcelRequire("im4RM");
var $kQnik = parcelRequire("kQnik");

var $7z6nO = parcelRequire("7z6nO");

var $kovSu = parcelRequire("kovSu");

var $3YDPc = parcelRequire("3YDPc");
var $fa611f027227513b$var$_window$JSD_CUSTOMER_;
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $fa611f027227513b$var$BUILD_KEY = (($fa611f027227513b$var$_window$JSD_CUSTOMER_ = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) === null || $fa611f027227513b$var$_window$JSD_CUSTOMER_ === void 0 ? void 0 : $fa611f027227513b$var$_window$JSD_CUSTOMER_.buildKey) || 'local';
const $fa611f027227513b$export$86fbec116b87613f = (props)=>{
    const { serviceDeskVersion: serviceDeskVersion } = props;
    const isHelpCentersManagementPath = (0, $gk18s.isHelpCentersManagement)();
    const shouldUseCsmRouter = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) || (0, $gk18s.isJcsOnlyRestrictedRoute)((0, $hrPHR.getEnv)().customerAccountAvailabilty);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    const shouldUseHubRouter = (0, $e6Qdr.fg)('enable-jsm-in-hubs') && (0, $hrPHR.getEnv)().helpCenterType === 'HELP_HUB';
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    (0, $8y0tS.useUFOComponentExperience)((0, $auztA.helpCenterViewHomePageExperience));
    (0, $8P7DW.useEffect)(()=>{
        if (!isHelpCentersManagementPath) {
            if (!(0, $8XrTk.hasValidHelpCenterARI)()) {
                (0, $gbM8r.fireAnalyticsForEmptyHelpCenterAri)();
                const traceId = (0, $hrPHR.getEnv)().traceId ?? '';
                // Disabling existing violations, should be fixed when revisited.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $auztA.helpCenterViewHomePageExperience).failure({
                    metadata: {
                        error: `Empty Help Center Ari, traceId: ${traceId}`
                    }
                });
            } else // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $auztA.helpCenterViewHomePageExperience).success();
        }
    }, [
        isHelpCentersManagementPath
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (!isHelpCentersManagementPath) {
            if (!(0, $jByYr.isValidLayoutAriPresent)()) (0, $7qmv5.fireAnalyticsForEmptyHelpCenterLayoutAri)();
        }
    }, [
        isHelpCentersManagementPath
    ]);
    const analyticData = {
        version: serviceDeskVersion,
        application: 'jira-servicedesk',
        buildKey: $fa611f027227513b$var$BUILD_KEY
    };
    const isAdvancedHelpCenterThemingEnabled = ((0, $gk18s.isAdvancedHelpCenter)() || (0, $gk18s.isDefaultHelpCenter)()) && (0, $HGACo.isCustomThemingEnabled)();
    const isCsmAccessControlSplitFgEnabled = (0, $HGACo.isCsmAccessControlSplitEnabled)();
    const getResourceRouter = $8P7DW.useCallback(()=>{
        if (shouldUseCsmRouter) {
            if (isCsmAccessControlSplitFgEnabled) return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $8P7DW.createElement((0, $Gcr5d.AppContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $bm9XU.CSMResourceRouterNew), null)) : /*#__PURE__*/ $8P7DW.createElement((0, $bm9XU.CSMResourceRouterNew), null);
            return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $8P7DW.createElement((0, $Gcr5d.AppContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $bm9XU.default), null)) : /*#__PURE__*/ $8P7DW.createElement((0, $bm9XU.default), null);
        }
        if (isHelpCentersManagementPath) return /*#__PURE__*/ $8P7DW.createElement((0, $2qHaK.default), null);
        if (shouldUseHubRouter) return /*#__PURE__*/ $8P7DW.createElement((0, $ftaVT.default), null);
        return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $8P7DW.createElement((0, $Gcr5d.AppContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $kovSu.default), null)) : /*#__PURE__*/ $8P7DW.createElement((0, $kovSu.default), null);
    }, [
        shouldUseCsmRouter,
        isHelpCentersManagementPath,
        shouldUseHubRouter,
        isAdvancedHelpCenterThemingEnabled,
        isCsmAccessControlSplitFgEnabled
    ]);
    if ((0, $1EFS8.default).checkGate('enable-portal-kit')) return /*#__PURE__*/ $8P7DW.createElement((0, $7z6nO.ForgePortalHeaderModule), null);
    return /*#__PURE__*/ $8P7DW.createElement((0, $5JQIe.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iziiq.AnalyticsContext), {
        attributes: analyticData
    }, /*#__PURE__*/ $8P7DW.createElement((0, $8fLNY.BrowserMetricsScreenTransitionStatusProvider), null, /*#__PURE__*/ $8P7DW.createElement((0, $kQnik.SSRSafeJSMCookieConsentBanner), null), (0, $6hdgt.isBrowserUnsupported)() && /*#__PURE__*/ $8P7DW.createElement((0, $aXSLq.default), {
        appearance: "warning",
        icon: /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKWTh))), {
            spacing: "spacious",
            label: ""
        })
    }, formatMessage((0, $3YDPc.default).unsupportedBrowser)), getResourceRouter(), /*#__PURE__*/ $8P7DW.createElement((0, $7NVEF.default), null), /*#__PURE__*/ $8P7DW.createElement((0, $5JrSO.FeedbackCollector), null), /*#__PURE__*/ $8P7DW.createElement((0, $fK2Le.Heartbeat), null), /*#__PURE__*/ $8P7DW.createElement((0, $6Pl45.MarkAppMounted), null))));
};
const $fa611f027227513b$var$selector = (0, $ehscL.createSelector)((0, $8Wisn.getServiceDeskVersion), (serviceDeskVersion)=>({
        serviceDeskVersion: serviceDeskVersion
    }));
var $fa611f027227513b$export$2e2bcd8739ae039 = (0, $jvoWT.default)($fa611f027227513b$var$selector)($fa611f027227513b$export$86fbec116b87613f);

});
parcelRegister("5JrSO", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollector", () => $882a3fc1562f45d6$export$fa63c8dd87ea8148);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $882a3fc1562f45d6$export$fa63c8dd87ea8148 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("cNXbA")), {
        moduleId: "./src/view/common/feedback-collector/hocs.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("cNXbA", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("d3buT"),
    $j9MRt("f4bu9")
]).then(()=>parcelRequire('aoTfJ'));

});


parcelRegister("2DAP0", function(module, exports) {
$parcel$export(module.exports, "MarkAppMounted", () => (parcelRequire("6Pl45")).MarkAppMounted);
$parcel$export(module.exports, "isAppMounted", () => (parcelRequire("6Pl45")).isAppMounted);

var $6Pl45 = parcelRequire("6Pl45");

});
parcelRegister("6Pl45", function(module, exports) {
$parcel$export(module.exports, "isAppMounted", () => $5ea5b92d26580fd6$export$495d224993f5c3c8);
$parcel$export(module.exports, "MarkAppMounted", () => $5ea5b92d26580fd6$export$2525a7fc0773bc4d);

var $8P7DW = parcelRequire("8P7DW");
let $5ea5b92d26580fd6$var$isMounted = false;
function $5ea5b92d26580fd6$var$setIsMounted(value) {
    $5ea5b92d26580fd6$var$isMounted = value;
}
const $5ea5b92d26580fd6$export$495d224993f5c3c8 = {
    /** Readonly value and is set only from MarkAppMounted */ get value () {
        return $5ea5b92d26580fd6$var$isMounted;
    }
};
const $5ea5b92d26580fd6$export$2525a7fc0773bc4d = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        $5ea5b92d26580fd6$var$setIsMounted(true);
    }, []);
    return null;
};

});


parcelRegister("aXSLq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a56cfe5e8e4cb6be$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $2CGHX = parcelRequire("2CGHX");
var $iPrfN = parcelRequire("iPrfN");
const $a56cfe5e8e4cb6be$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $a56cfe5e8e4cb6be$var$inlineStyles = {
    root: "_1ul9idpf"
};
const $a56cfe5e8e4cb6be$var$textStyles = {
    root: "_11c8fhey _1reo15vq _18m915vq _syaz12s4 _k48p1wq8 _1bto1l2s _o5721q9c _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha28stv _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43ds1r31 _p03c1r31 _oavv1r31 _oxk41r31 _1cay1r31"
};
const $a56cfe5e8e4cb6be$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $a56cfe5e8e4cb6be$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, #FBC828)",
    error: "var(--ds-background-danger-bold, #C9372C)",
    announcement: "var(--ds-background-neutral-bold, #292A2E)"
};
const $a56cfe5e8e4cb6be$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    announcement: "var(--ds-text-inverse, #FFFFFF)"
};
const $a56cfe5e8e4cb6be$var$containerStyles = {
    root: "_4t3i1wto _4cvr1h6o _1e0c1txw"
};
const $a56cfe5e8e4cb6be$var$iconWrapperStyles = {
    root: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s _1o9zidpf"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $a56cfe5e8e4cb6be$var$Banner = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $a56cfe5e8e4cb6be$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        xcss: $a56cfe5e8e4cb6be$var$containerStyles.root,
        backgroundColor: $a56cfe5e8e4cb6be$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $a56cfe5e8e4cb6be$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                    as: "span",
                    xcss: $a56cfe5e8e4cb6be$var$iconWrapperStyles.root,
                    style: {
                        fill: $a56cfe5e8e4cb6be$var$tokenBackgroundColors[appearanceType],
                        color: $a56cfe5e8e4cb6be$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                    style: {
                        [$a56cfe5e8e4cb6be$var$CSS_VAR_TEXT_COLOR]: $a56cfe5e8e4cb6be$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $8n1kL.default)([
                        $a56cfe5e8e4cb6be$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $a56cfe5e8e4cb6be$export$2e2bcd8739ae039 = $a56cfe5e8e4cb6be$var$Banner;

});

parcelRegister("5JQIe", function(module, exports) {
$parcel$export(module.exports, "TargetConsumer", () => $783e2b7f204e2ec8$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightConsumer", () => $783e2b7f204e2ec8$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $783e2b7f204e2ec8$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $hXXvg = parcelRequire("hXXvg");

var $5J6r2 = parcelRequire("5J6r2");

var $cBwgz = parcelRequire("cBwgz");
var $bT4U6 = parcelRequire("bT4U6");

var $1NJBM = parcelRequire("1NJBM");

var $ezlCa = parcelRequire("ezlCa");

var $6nQJh = parcelRequire("6nQJh");
const $783e2b7f204e2ec8$var$dest = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);
const $783e2b7f204e2ec8$export$f643dd64c1952cc8 = $783e2b7f204e2ec8$var$dest.Consumer;
const $783e2b7f204e2ec8$var$TargetProvider = $783e2b7f204e2ec8$var$dest.Provider;
const $783e2b7f204e2ec8$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $8P7DW.createContext)({
    opened: (0, $5J6r2.default),
    closed: (0, $5J6r2.default),
    targets: {}
});
const $783e2b7f204e2ec8$export$3503199acd121708 = $783e2b7f204e2ec8$export$7b5aa0f5b37a336d.Consumer;
const $783e2b7f204e2ec8$var$SpotlightStateProvider = $783e2b7f204e2ec8$export$7b5aa0f5b37a336d.Provider;
const $783e2b7f204e2ec8$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)(Wrapper, {
        children: children
    });
class $783e2b7f204e2ec8$export$2e2bcd8739ae039 extends (0, $8P7DW.PureComponent) {
    static #_ = this.defaultProps = {
        blanketIsTinted: true
    };
    componentDidMount() {
        typeof $6nQJh;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        const isActive = this.state.spotlightCount > 0;
        return /*#__PURE__*/ (0, $gWgPx.jsx)($783e2b7f204e2ec8$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)($783e2b7f204e2ec8$var$TargetProvider, {
                value: this.getTargetRef,
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)($783e2b7f204e2ec8$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment,
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBwgz.default), {
                            children: isActive && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bT4U6.default), {
                                duration: "medium",
                                children: ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $1NJBM.default), {
                                        zIndex: 700,
                                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ezlCa.default), {
                                            ref: ref,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                            className: className,
                                            style: style,
                                            isTinted: blanketIsTinted,
                                            onBlanketClicked: onBlanketClicked
                                        })
                                    })
                            })
                        }),
                        children
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, /*
   * When enabling React Streaming in Confluence, a
   * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
   * error happens.
   * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
   */ this.getTargetRef = (name)=>(element)=>{
                (0, $8P7DW.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $hXXvg.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}

});
parcelRegister("ezlCa", function(module, exports) {
$parcel$export(module.exports, "default", () => $51af0096a1eedeed$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
const $51af0096a1eedeed$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $51af0096a1eedeed$var$Blanket = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style, className: className }, ref)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ref: ref,
        role: "presentation",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8n1kL.default)([
            "_1r04idpf _v56414ka _kqsw1n9t _1pby1fw0",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #050C1F75)" : 'transparent'
        },
        onClick: onBlanketClicked
    });
});
var $51af0096a1eedeed$export$2e2bcd8739ae039 = $51af0096a1eedeed$var$Blanket;

});


parcelRegister("8fLNY", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricsScreenTransitionStatusContext", () => $1c04bd6a44726018$export$2b9bf691adcf6b30);
$parcel$export(module.exports, "BrowserMetricsScreenTransitionStatusProvider", () => $1c04bd6a44726018$export$71210ed9cdfad1f5);
$parcel$export(module.exports, "default", () => $1c04bd6a44726018$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $fAqaB = parcelRequire("fAqaB");

var $lKEMb = parcelRequire("lKEMb");
const $1c04bd6a44726018$export$2b9bf691adcf6b30 = /*#__PURE__*/ $8P7DW.createContext({
    preventBrowserMetricsTimerResetOnScreenMount: false,
    startBrowserMetricsTransitionToNewScreen: ()=>undefined,
    stopBrowserMetricsTransitionToNewScreen: ()=>undefined
});
class $1c04bd6a44726018$export$71210ed9cdfad1f5 extends $8P7DW.Component {
    render() {
        return /*#__PURE__*/ $8P7DW.createElement($1c04bd6a44726018$export$2b9bf691adcf6b30.Provider, {
            value: {
                preventBrowserMetricsTimerResetOnScreenMount: this.state.preventBrowserMetricsTimerResetOnScreenMount,
                startBrowserMetricsTransitionToNewScreen: this.startTransitionToNewScreen,
                stopBrowserMetricsTransitionToNewScreen: this.stopTransitionToNewScreen
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            preventBrowserMetricsTimerResetOnScreenMount: false
        }, /**
   * Explicitly start the browsermetrics timer,
   * and set state that will prevent the timer from being reset when we eventually transition to the new screen.
   */ this.startTransitionToNewScreen = (screenName)=>{
            (0, $lKEMb.devLog)('Browser metrics: starting timer for new screen before transition:', screenName);
            this.setState({
                preventBrowserMetricsTimerResetOnScreenMount: true
            });
            /**
     * Browser metrics v3 start page load
     */ (0, $fAqaB.startPageLoad)(screenName);
        }, /**
   * Stop measuring any transition that may have been started.
   * This must be called any time the transition does not go ahead, e.g. if there are errors in a form submission
   * This will also be called any time an AnalyticsScreen component is mounted,
   * so you won't need to call this yourself if the transition is successful
   */ this.stopTransitionToNewScreen = ()=>{
            this.setState({
                preventBrowserMetricsTimerResetOnScreenMount: false
            });
        };
    }
}
const $1c04bd6a44726018$var$withBrowserMetricsScreenTransitionStatus = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $8P7DW.createElement($1c04bd6a44726018$export$2b9bf691adcf6b30.Consumer, null, (value)=>/*#__PURE__*/ $8P7DW.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
var $1c04bd6a44726018$export$2e2bcd8739ae039 = $1c04bd6a44726018$var$withBrowserMetricsScreenTransitionStatus;

});

parcelRegister("gbM8r", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsForEmptyHelpCenterAri", () => $6b30940b276fceeb$export$ac08ed49e9190090);

var $jjE9o = parcelRequire("jjE9o");

var $hrPHR = parcelRequire("hrPHR");
const $6b30940b276fceeb$export$ac08ed49e9190090 = ()=>{
    const traceId = (0, $hrPHR.getEnv)().traceId;
    (0, $jjE9o.operationalEvent)({
        action: 'emptyHelpCenterAriReceived',
        actionSubject: 'help-center-ari',
        attributes: {
            traceId: traceId
        },
        source: 'HelpCenter'
    });
};

});

parcelRegister("7qmv5", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsForEmptyHelpCenterLayoutAri", () => $a0cb21643583698e$export$c36b085b938f36b6);

var $jjE9o = parcelRequire("jjE9o");

var $hrPHR = parcelRequire("hrPHR");
const $a0cb21643583698e$export$c36b085b938f36b6 = ()=>{
    const traceId = (0, $hrPHR.getEnv)().traceId;
    (0, $jjE9o.operationalEvent)({
        action: 'emptyHelpCenterLayoutAriReceived',
        actionSubject: 'help-center-layout-ari',
        attributes: {
            traceId: traceId
        },
        source: 'HelpCenter'
    });
};

});

parcelRegister("8XrTk", function(module, exports) {
$parcel$export(module.exports, "hasValidHelpCenterARI", () => $566319102c365b41$export$a15bc0aef789ec4c);

var $jByYr = parcelRequire("jByYr");
const $566319102c365b41$var$EMPTY_VALUES_LIST = [
    'undefined',
    'null'
];
const $566319102c365b41$export$a15bc0aef789ec4c = ()=>{
    const helpCenterAri = (0, $jByYr.getHelpCenterAri)();
    return Boolean(helpCenterAri) && !$566319102c365b41$var$EMPTY_VALUES_LIST.includes(helpCenterAri);
};

});

parcelRegister("6hdgt", function(module, exports) {
$parcel$export(module.exports, "isBrowserUnsupported", () => $64292b769fbe9c96$export$dfffa53722e06033);
$parcel$export(module.exports, "isOldSafari", () => $64292b769fbe9c96$export$572d6d0be4ae9ec5);
$parcel$export(module.exports, "isIE7", () => $64292b769fbe9c96$export$e7ef7234dd9b1f65);
/**
 * Unsupported browsers regex generated using command -
 * npx browserslist-useragent-regexp "Firefox 60 , Firefox 61, Firefox 68, Firefox 72, Safari 12, Safari 15, iOS 12, iOS 15".
 * All unsupported browser versions can be viewed on https://browserslist.dev/, using above query.
 * These browser versions do not support Intersection Observer API.
 * Safari > 12.0 and iOS > 12.1 supports this API but does not support "options.root" parameter to be a Document
 * */ const $64292b769fbe9c96$export$67d4cb90585439f7 = new RegExp(/Firefox\/(6[01]\.0|68\.0|72\.0)(\.\d+|)|Maci.+ Version\/(12\.0|15\.0)([,.]\d+|)( Mobile\/\w+|) Safari\/|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(12[._][01]|15[._][01])([._]\d+|)/);
const $64292b769fbe9c96$export$dfffa53722e06033 = (regex = $64292b769fbe9c96$export$67d4cb90585439f7)=>{
    if (!(navigator && navigator.userAgent)) return true;
    if (regex && regex.test) return regex.test(navigator.userAgent);
    return false;
};
function $64292b769fbe9c96$export$572d6d0be4ae9ec5() {
    const userAgentString = navigator.userAgent;
    const safariAgent = userAgentString.indexOf('Safari') > -1;
    // If the current browser is Safari
    if (safariAgent) {
        var _userAgentString$spli;
        const safariVersion = parseInt((_userAgentString$spli = userAgentString.split('Version/')) === null || _userAgentString$spli === void 0 || (_userAgentString$spli = _userAgentString$spli[1]) === null || _userAgentString$spli === void 0 ? void 0 : _userAgentString$spli.split(' Safari')[0], 10);
        // If the Safari version is less than 14
        if (safariVersion < 14) return true;
    }
    return false;
}
function $64292b769fbe9c96$export$e7ef7234dd9b1f65() {
    const userAgentString = navigator.userAgent;
    const msieAgent = userAgentString.indexOf('MSIE') > -1;
    // If the current browser is Internet Explorer
    if (msieAgent) {
        const ieVersion = parseInt(userAgentString.split('MSIE ')[1].split(';')[0], 10);
        // If the IE version is 7
        if (ieVersion === 7) return true;
    }
    return false;
}

});

parcelRegister("jnlOI", function(module, exports) {
$parcel$export(module.exports, "Heartbeat", () => (parcelRequire("fK2Le")).Heartbeat);

var $fK2Le = parcelRequire("fK2Le");

});
parcelRegister("fK2Le", function(module, exports) {
$parcel$export(module.exports, "Heartbeat", () => $4a6737df988fc8bc$export$38f39b921d5551c1);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $j20Mj = parcelRequire("j20Mj");

var $fogZd = parcelRequire("fogZd");
const $4a6737df988fc8bc$export$b5257641a9b528be = ()=>{
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    if (pathSegments.includes('login')) return;
    if (pathSegments.includes('helpcenter-management')) {
        window.location.href = `/servicedesk/customer/user/login`;
        return;
    }
    const path = window.location.pathname + window.location.search;
    const match = path.match(/\/portal\/(\d+)/);
    const portalId = match ? Number(match[1]) : undefined;
    const basePath = pathSegments.slice(0, 2).join('/');
    const loginBasePath = portalId ? `/${basePath}/portal/${portalId}/user/login` : `/${basePath}/user/login`;
    const destination = pathSegments.slice(2).join('/');
    window.location.href = `${loginBasePath}?destination=${encodeURIComponent(destination + window.location.search)}`;
};
const $4a6737df988fc8bc$export$461970fb9101e674 = ({ isLoggedIn: isLoggedIn })=>{
    return isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fogZd.AsyncHeartbeat), {
        idleTime: 1200000,
        onAuthenticationFailed: $4a6737df988fc8bc$export$b5257641a9b528be
    }) : null;
};
const $4a6737df988fc8bc$export$38f39b921d5551c1 = (0, $jvoWT.default)((state)=>{
    return {
        isLoggedIn: (0, $j20Mj.isLoggedIn)(state)
    };
})($4a6737df988fc8bc$export$461970fb9101e674);

});
parcelRegister("j20Mj", function(module, exports) {
$parcel$export(module.exports, "getAccountId", () => $1d628355ac7f53c7$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getEmail", () => $1d628355ac7f53c7$export$d29968a6889079e0);
$parcel$export(module.exports, "getDisplayName", () => $1d628355ac7f53c7$export$be63e0664592e141);
$parcel$export(module.exports, "isLoggedIn", () => $1d628355ac7f53c7$export$256a5a3564694cfc);
$parcel$export(module.exports, "getLocale", () => $1d628355ac7f53c7$export$180605366c04f0cd);
$parcel$export(module.exports, "getCanAdministerJIRA", () => $1d628355ac7f53c7$export$8c98af27b4458cd1);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => $1d628355ac7f53c7$export$c5f994129d97ed23);
$parcel$export(module.exports, "getCustomMenuLinks", () => $1d628355ac7f53c7$export$bf9a934424e2dbf1);
$parcel$export(module.exports, "getAvatarSrc", () => $1d628355ac7f53c7$export$35125d98e6f1484);
const $1d628355ac7f53c7$export$c1e0336bde96e2dc = (state)=>{
    return state.persisted.user.accountId;
};
const $1d628355ac7f53c7$export$d29968a6889079e0 = (state)=>{
    return state.persisted.user.email;
};
const $1d628355ac7f53c7$export$be63e0664592e141 = (state)=>{
    return state.persisted.user.displayName || state.persisted.user.email || '';
};
const $1d628355ac7f53c7$export$256a5a3564694cfc = (state)=>{
    return state.persisted.user.isLoggedIn;
};
const $1d628355ac7f53c7$export$180605366c04f0cd = (state)=>{
    return state.persisted.user.language.key;
};
const $1d628355ac7f53c7$export$8c98af27b4458cd1 = (state)=>{
    return state.persisted.user.canAdministerJIRA;
};
const $1d628355ac7f53c7$export$c5f994129d97ed23 = (state)=>{
    var _state$persisted$user;
    return ((_state$persisted$user = state.persisted.user) === null || _state$persisted$user === void 0 ? void 0 : _state$persisted$user.hasSiteAdministerAccess) || false;
};
const $1d628355ac7f53c7$export$bf9a934424e2dbf1 = (state)=>{
    return state.persisted.user.customMenuLinks;
};
const $1d628355ac7f53c7$export$35125d98e6f1484 = (state)=>{
    var _state$persisted$user2;
    return (_state$persisted$user2 = state.persisted.user.avatars) === null || _state$persisted$user2 === void 0 ? void 0 : _state$persisted$user2.xlarge;
};

});

parcelRegister("fogZd", function(module, exports) {
$parcel$export(module.exports, "AsyncHeartbeat", () => $09a36e8d0558a666$export$503c0e70c2bcbfc7);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $09a36e8d0558a666$export$503c0e70c2bcbfc7 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("iUYz6")), {
        moduleId: "../platform/packages/security/heartbeat/src/index.ts"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("iUYz6", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("eMGQO").then(()=>parcelRequire('cNRoU'));

});




parcelRegister("Gcr5d", function(module, exports) {
$parcel$export(module.exports, "AppContainer", () => $25a8425c6fcc6d47$export$7469f2cda7546515);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $25a8425c6fcc6d47$export$7469f2cda7546515 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("ecbrQ")), {
        moduleId: "./src/view/app-container/app-container.tsx"
    })
});

});
parcelRegister("ecbrQ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("bUNVE").then(()=>parcelRequire('9QSFn'));

});


parcelRegister("bm9XU", function(module, exports) {
$parcel$export(module.exports, "CSMResourceRouterNew", () => $2741c38630c2f762$export$a487b0571b6a921a);
$parcel$export(module.exports, "default", () => $2741c38630c2f762$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $2UsNA = parcelRequire("2UsNA");

var $HGACo = parcelRequire("HGACo");

var $3Z4c2 = parcelRequire("3Z4c2");

var $fOqPA = parcelRequire("fOqPA");

parcelRequire("9wocP");
var $jT4Pl = parcelRequire("jT4Pl");
var $3vYjO = parcelRequire("3vYjO");

var $iA1ui = parcelRequire("iA1ui");

var $igTQ0 = parcelRequire("igTQ0");

var $9fRhz = parcelRequire("9fRhz");

var $17jzp = parcelRequire("17jzp");

var $043tP = parcelRequire("043tP");

var $agSAc = parcelRequire("agSAc");

var $oBfFQ = parcelRequire("oBfFQ");

var $eeSjx = parcelRequire("eeSjx");

var $dqUt9 = parcelRequire("dqUt9");

var $4RbXM = parcelRequire("4RbXM");

var $5orRf = parcelRequire("5orRf");

var $dPlZw = parcelRequire("dPlZw");

var $7A2dq = parcelRequire("7A2dq");

var $lKYU4 = parcelRequire("lKYU4");

var $dQDRa = parcelRequire("dQDRa");

var $cX0wo = parcelRequire("cX0wo");

var $28TQC = parcelRequire("28TQC");

var $iC8fI = parcelRequire("iC8fI");

var $lhiUD = parcelRequire("lhiUD");

var $3eD0H = parcelRequire("3eD0H");

var $aN5rH = parcelRequire("aN5rH");

var $9uhKS = parcelRequire("9uhKS");

var $j52uk = parcelRequire("j52uk");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $9PD2z = parcelRequire("9PD2z");
parcelRequire("lzEbC");
var $1Glz5 = parcelRequire("1Glz5");

var $1EFS8 = parcelRequire("1EFS8");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $7FSs7 = parcelRequire("7FSs7");

var $fULfs = parcelRequire("fULfs");

var $kovSu = parcelRequire("kovSu");

var $idbbE = parcelRequire("idbbE");
parcelRequire("9QKIl");
var $9t02C = parcelRequire("9t02C");
var $8kP0u = parcelRequire("8kP0u");
// Check if enhanced article view feature gate is enabled
const $2741c38630c2f762$var$isEnhancedArticleViewEnabled = ()=>{
    return (0, $1EFS8.default).checkGate('jcs_enhanced_article_view');
};
// Helper function to determine which requests list route to use
const $2741c38630c2f762$var$getRequestsListRoute = ()=>{
    const isHubsEnabled = (0, $HGACo.isHubsEnabledInHelpCenter)();
    if (isHubsEnabled) return (0, $1Glz5.getCsmRequestsListRouteWithHubShell)();
    return 0, $dqUt9.csmRequestsListRoute;
};
const $2741c38630c2f762$var$getCustomPageRoutes = ()=>{
    return (0, $HGACo.isCustomPagesUiEnabled)() && (0, $hrPHR.getIsHCCustomizationEnabled)() ? [
        (0, $5orRf.getEditCustomPageRoute)(),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getHubCustompageRoute)() : (0, $fULfs.routeWithAiWidgetConfigResource)((0, $agSAc.getViewCustomPageRoute)())
    ] : [];
};
const $2741c38630c2f762$var$getAnonymousRoutes = ()=>{
    return [
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getLoginRouteWithHubShell)() : (0, $cX0wo.loginRoute),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getResetPasswordRouteWithHubShell)() : (0, $aN5rH.userResetPasswordRoute),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getSignupRouteWithHubShell)() : (0, $aN5rH.userSignupRoute),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCompleteSignupRouteWithHubShell)() : (0, $aN5rH.userCompleteSignupRoute),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCheckEmailRouteWithHubShell)() : (0, $aN5rH.userCheckMailRoute)
    ];
};
const $2741c38630c2f762$var$getActiveCsmRoutes = ()=>{
    return {
        activeViewArticleRoute: (0, $eeSjx.csmViewArticleRoute),
        activeKbPageRoute: (0, $eeSjx.csmViewKbPageRoute),
        activeCrossSiteArticleRoute: (0, $eeSjx.csmViewCrossSiteArticleRoute),
        activeUserProfileRoute: (0, $4RbXM.csmUserProfileRoute)
    };
};
const $2741c38630c2f762$var$getAccessAndAuthenticationRoutes = ()=>{
    return [
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getPortalAccessForbiddenRouteWithHubShell)() : (0, $28TQC.portalAccessForbiddenRoute),
        (0, $cX0wo.portalLoginRoute),
        (0, $aN5rH.portalSignupRoute),
        (0, $aN5rH.portalResetPasswordRoute),
        (0, $aN5rH.portalCompleteSignupRoute),
        (0, $aN5rH.portalInvitedSignupRoute)
    ];
};
const $2741c38630c2f762$var$getUserProfileRoute = ()=>{
    const { activeUserProfileRoute: activeUserProfileRoute } = $2741c38630c2f762$var$getActiveCsmRoutes();
    return (0, $fULfs.routeWithAiWidgetConfigResource)((0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmUserProfileRouteWithHubShell)() : activeUserProfileRoute);
};
const $2741c38630c2f762$var$getSearchAndArticleRoutes = ()=>{
    const { activeViewArticleRoute: activeViewArticleRoute, activeKbPageRoute: activeKbPageRoute, activeCrossSiteArticleRoute: activeCrossSiteArticleRoute } = $2741c38630c2f762$var$getActiveCsmRoutes();
    return [
        (0, $fULfs.routeWithAiWidgetConfigResource)(activeKbPageRoute),
        (0, $dQDRa.viewAllSearchResultsRoute),
        (0, $dQDRa.viewPortalAllSearchResultsRoute),
        (0, $dQDRa.viewPortalCategoryArticleRoute),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmViewPortalArticleRouteWithHubShell)() : (0, $dQDRa.viewPortalArticleRoute),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmViewCrossSitePortalArticleRouteWithHubShell)() : (0, $dQDRa.viewCrossSitePortalArticleRoute),
        (0, $fULfs.routeWithAiWidgetConfigResource)((0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmViewArticleRouteWithHubShell)() : activeViewArticleRoute),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmViewCrossSiteArticleRouteWithHubShell)() : activeCrossSiteArticleRoute
    ];
};
const $2741c38630c2f762$var$getContactUsRoute = ()=>{
    return (0, $fULfs.routeWithAiWidgetConfigResource)((0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmContactUsRouteWithHubShell)() : (0, $043tP.csmContactUsRoute));
};
const $2741c38630c2f762$export$30b4ff4634181478 = ()=>{
    const isAdvancedOrFlexiHCEnabled = (0, $gk18s.isAdvancedHelpCenter)() || (0, $gk18s.isFlexiHCEnabledInDefaultHC)();
    return [
        ...(0, $HGACo.isHubsEnabledInHelpCenter)() ? [
            (0, $1Glz5.getHubHomepageRoute)()
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $fULfs.routeWithAiWidgetConfigResource)((0, $iA1ui.getViewHomePageRoute)())
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $iA1ui.getEditHomePageRoute)()
        ] : [],
        ...(0, $HGACo.isEmailVerifiedSignalEnabled)() ? [
            (0, $j52uk.userVerifyEmailRoute)
        ] : [],
        (0, $igTQ0.aiAnswerRoute),
        (0, $17jzp.consentFormRoute),
        ...$2741c38630c2f762$var$getAnonymousRoutes(),
        ...$2741c38630c2f762$var$getAccessAndAuthenticationRoutes(),
        (0, $9t02C.requestFeedbackRoute),
        (0, $9t02C.unsubscribeRoute),
        (0, $lKYU4.getHelpCenterRoute)(),
        (0, $3eD0H.requestDetailsRoute),
        ...$2741c38630c2f762$var$getSearchAndArticleRoutes(),
        (0, $fULfs.routeWithAiWidgetConfigResource)($2741c38630c2f762$var$getRequestsListRoute()),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmRequestDetailsRouteWithHubShell)() : (0, $dqUt9.csmRequestDetailsRoute),
        (0, $9t02C.helpCenterRequestFeedbackRoute),
        (0, $9fRhz.approvalsRoute),
        (0, $lhiUD.requestApprovalRoute),
        $2741c38630c2f762$var$getUserProfileRoute(),
        (0, $dQDRa.viewPortalKnowledgeCategoryRoute),
        (0, $9t02C.anonymousRequestSuccessRoute),
        (0, $9t02C.getRequestCreateRoute)(),
        (0, $iC8fI.getPortalHomeRoutes)(),
        (0, $7A2dq.getEmbedCreateRequestRoute)(),
        (0, $7A2dq.embedSinglePortalRoute),
        (0, $7A2dq.embedKBArticleRoute),
        (0, $8kP0u.portalReorderRoute)(true),
        (0, $dPlZw.editTopicRoute),
        (0, $dPlZw.addTopicRoute),
        (0, $9uhKS.getViewTopicRoute)(),
        $2741c38630c2f762$var$getContactUsRoute(),
        ...$2741c38630c2f762$var$isEnhancedArticleViewEnabled() ? [
            (0, $fULfs.routeWithAiWidgetConfigResource)((0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmFolderRouteWithHubShell)() : (0, $oBfFQ.csmFolderRoute))
        ] : [],
        ...$2741c38630c2f762$var$getCustomPageRoutes(),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getNotFoundRouteWithHubShell)() : (0, $9t02C.notFoundErrorRoute)
    ];
};
const $2741c38630c2f762$export$8dfc12d998aeca9c = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $3Z4c2.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $3Z4c2.lightenColor)(themeColor);
    const routes = (0, $8P7DW.useMemo)(()=>{
        return $2741c38630c2f762$export$30b4ff4634181478();
    }, []);
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const location = window.location.pathname + window.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2UsNA.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3vYjO.Router), {
        routes: routes,
        history: (0, $7FSs7.default),
        isGlobal: false,
        plugins: [
            (0, $idbbE.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fOqPA.GlobalStyled), {
        isCsm: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9PD2z.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jT4Pl.RouteComponent), null)));
};
const $2741c38630c2f762$var$selectorOld = (0, $ehscL.createSelector)((0, $8Wisn.getHeadless), (0, $ikoP4.getThemeColor), (0, $ikoP4.getHelpCenterTitleColor), (headerless, themeColor, titleColor)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor
    }));
const $2741c38630c2f762$export$2f7745f2f5ab3897 = ({ externalCustomer: externalCustomer })=>{
    // Routes that are restricted to non external users when
    // base path is /servicedesk/customer and customerAccountAvailabilty is JCS_ONLY
    const isAdvancedOrFlexiHCEnabled = (0, $gk18s.isAdvancedHelpCenter)() || (0, $gk18s.isFlexiHCEnabledInDefaultHC)();
    const restrictedRoutes = [
        ...(0, $HGACo.isHubsEnabledInHelpCenter)() ? [
            (0, $1Glz5.getHubHomepageRoute)()
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $fULfs.routeWithAiWidgetConfigResource)((0, $iA1ui.getViewHomePageRoute)())
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $iA1ui.getEditHomePageRoute)()
        ] : [],
        ...(0, $HGACo.isEmailVerifiedSignalEnabled)() ? [
            (0, $j52uk.userVerifyEmailRoute)
        ] : [],
        (0, $igTQ0.aiAnswerRoute),
        (0, $17jzp.consentFormRoute),
        ...$2741c38630c2f762$var$getAnonymousRoutes(),
        ...$2741c38630c2f762$var$getAccessAndAuthenticationRoutes(),
        (0, $9t02C.requestFeedbackRoute),
        (0, $9t02C.unsubscribeRoute),
        (0, $lKYU4.getHelpCenterRoute)(),
        (0, $3eD0H.requestDetailsRoute),
        ...$2741c38630c2f762$var$getSearchAndArticleRoutes(),
        (0, $fULfs.routeWithAiWidgetConfigResource)($2741c38630c2f762$var$getRequestsListRoute()),
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmRequestDetailsRouteWithHubShell)() : (0, $dqUt9.csmRequestDetailsRoute),
        (0, $9t02C.helpCenterRequestFeedbackRoute),
        (0, $9fRhz.approvalsRoute),
        (0, $lhiUD.requestApprovalRoute),
        $2741c38630c2f762$var$getUserProfileRoute(),
        (0, $7A2dq.getEmbedCreateRequestRoute)(),
        (0, $7A2dq.embedSinglePortalRoute),
        (0, $7A2dq.embedKBArticleRoute),
        $2741c38630c2f762$var$getContactUsRoute(),
        ...$2741c38630c2f762$var$isEnhancedArticleViewEnabled() ? [
            (0, $fULfs.routeWithAiWidgetConfigResource)((0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getCsmFolderRouteWithHubShell)() : (0, $oBfFQ.csmFolderRoute))
        ] : [],
        ...$2741c38630c2f762$var$getCustomPageRoutes()
    ];
    return [
        ...(0, $gk18s.isJcsOnlyRestrictedRoute)((0, $hrPHR.getEnv)().customerAccountAvailabilty) && externalCustomer ? [] : restrictedRoutes,
        (0, $HGACo.isHubsEnabledInHelpCenter)() ? (0, $1Glz5.getNotFoundRouteWithHubShell)() : (0, $9t02C.notFoundErrorRoute)
    ];
};
const $2741c38630c2f762$export$7abc1d14de40c7e1 = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor, user: user } = props;
    const readableTextColorFromTheme = (0, $3Z4c2.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $3Z4c2.lightenColor)(themeColor);
    const routes = (0, $8P7DW.useMemo)(()=>{
        return $2741c38630c2f762$export$2f7745f2f5ab3897({
            externalCustomer: user === null || user === void 0 ? void 0 : user.externalCustomer
        });
    }, [
        user
    ]);
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const location = window.location.pathname + window.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    // If JCS_ONLY and accessing a JSM route (path starts with /servicedesk/customer) and the user is not external, redirect to JSM
    if ((0, $gk18s.isJcsOnlyRestrictedRoute)((0, $hrPHR.getEnv)().customerAccountAvailabilty) && !(user !== null && user !== void 0 && user.externalCustomer)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kovSu.default), null);
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2UsNA.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3vYjO.Router), {
        routes: routes,
        history: (0, $7FSs7.default),
        isGlobal: false,
        plugins: [
            (0, $idbbE.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fOqPA.GlobalStyled), {
        isCsm: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9PD2z.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jT4Pl.RouteComponent), null)));
};
const $2741c38630c2f762$var$selector = (0, $ehscL.createSelector)((0, $8Wisn.getHeadless), (0, $ikoP4.getThemeColor), (0, $ikoP4.getHelpCenterTitleColor), (state)=>(0, $hx8zX.getUserState)(state), (headerless, themeColor, titleColor, userState)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor,
        user: {
            externalCustomer: userState.externalCustomer
        }
    }));
const $2741c38630c2f762$export$a487b0571b6a921a = (0, $jvoWT.default)($2741c38630c2f762$var$selector)($2741c38630c2f762$export$7abc1d14de40c7e1);
var $2741c38630c2f762$export$2e2bcd8739ae039 = (0, $jvoWT.default)($2741c38630c2f762$var$selectorOld)($2741c38630c2f762$export$8dfc12d998aeca9c);

});
parcelRegister("3Z4c2", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $8efaa9305527d3cd$export$3d31854eb05903e0);
$parcel$export(module.exports, "lightenColor", () => $8efaa9305527d3cd$export$3abf4abc58accee2);

var $9fYaQ = parcelRequire("9fYaQ");
const $8efaa9305527d3cd$export$3d31854eb05903e0 = (color)=>{
    return (0, $9fYaQ.getLuminance)(color) > 0.5 ? "var(--ds-text, #172B4D)" : "var(--ds-text-inverse, #FFFFFF)";
};
const $8efaa9305527d3cd$export$3abf4abc58accee2 = (color)=>{
    return (0, $9fYaQ.transparentize)(0.8, color);
};

});
parcelRegister("9fYaQ", function(module, exports) {
$parcel$export(module.exports, "darken", () => $6bd4311257448441$export$4b073707ff63303);
$parcel$export(module.exports, "getLuminance", () => $6bd4311257448441$export$c852d90bf7403b62);
$parcel$export(module.exports, "lighten", () => $6bd4311257448441$export$c0816ed86df316af);
$parcel$export(module.exports, "transparentize", () => $6bd4311257448441$export$d11da87e55cc498f);

var $cCnFQ = parcelRequire("cCnFQ");

var $epx0f = parcelRequire("epx0f");
// @private
function $6bd4311257448441$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $6bd4311257448441$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $6bd4311257448441$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $6bd4311257448441$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $6bd4311257448441$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$6bd4311257448441$var$generateProperty(property, $6bd4311257448441$var$positionMap[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $6bd4311257448441$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $6bd4311257448441$var$generateStyles(property, valuesWithDefaults);
}
function $6bd4311257448441$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
/**
 * Returns a given CSS value minus its unit (or the original value if an invalid string is passed).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $6bd4311257448441$export$ef04e38dc423904(value) {
    var unitlessValue = parseFloat(value);
    if (isNaN(unitlessValue)) return value;
    return unitlessValue;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $6bd4311257448441$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$6bd4311257448441$var$endsWith(pxval, 'px')) throw new Error("Expected a string ending in \"px\" or a number passed as the first argument to " + to + "(), got \"" + pxval + "\" instead.");
            newPxval = $6bd4311257448441$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$6bd4311257448441$var$endsWith(base, 'px')) throw new Error("Expected a string ending in \"px\" or a number passed as the second argument to " + to + "(), got \"" + base + "\" instead.");
            newBase = $6bd4311257448441$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new Error("Passed invalid pixel value (\"" + pxval + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
        if (typeof newBase === 'string') throw new Error("Passed invalid base value (\"" + base + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
        return "" + newPxval / newBase + to;
    };
};
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $6bd4311257448441$export$c63c6f932822f543 = /*#__PURE__*/ $6bd4311257448441$var$pxtoFactory('em');
var $6bd4311257448441$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0]
 *   '--unit': getValueAndUnit('100px')[1]
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]}
 *   --unit: ${getValueAndUnit('100px')[1]}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 *   '--unit': 'px'
 * }
 */ function $6bd4311257448441$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($6bd4311257448441$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
var $6bd4311257448441$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $6bd4311257448441$var$getRatio(ratioName) {
    return $6bd4311257448441$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $6bd4311257448441$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 'perfectFourth';
    if (typeof steps !== 'number') throw new Error('Please provide a number of steps to the modularScale helper.');
    if (typeof ratio === 'string' && !$6bd4311257448441$var$ratioNames[ratio]) throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
    var realBase = typeof base === 'string' ? $6bd4311257448441$export$ef04e38dc423904(base) : base;
    var realRatio = typeof ratio === 'string' ? $6bd4311257448441$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new Error("Invalid value passed as base to modularScale, expected number or em string but got \"" + base + "\"");
    return realBase * Math.pow(realRatio, steps) + "em";
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $6bd4311257448441$export$fb1897a40d146f7f = /*#__PURE__*/ $6bd4311257448441$var$pxtoFactory('rem');
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $6bd4311257448441$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $6bd4311257448441$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $6bd4311257448441$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $6bd4311257448441$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $6bd4311257448441$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new Error('minScreen and maxScreen must be provided as stringified numbers with the same units.');
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || !fromSizeUnit || !toSizeUnit || fromSizeUnit !== toSizeUnit) throw new Error('fromSize and toSize must be provided as stringified numbers with the same units.');
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + fromSizeUnit + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $6bd4311257448441$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $6bd4311257448441$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $6bd4311257448441$export$a5b94313d6908893(width) {
    if (width === void 0) width = '100%';
    return {
        display: 'inline-block',
        maxWidth: width,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $6bd4311257448441$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new Error('expects either an array of objects or a single object with the properties prop, fromSize, and toSize.');
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = cssProp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _extends2, _extends3;
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var obj = _ref;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new Error('expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.');
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $cCnFQ.default)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $6bd4311257448441$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $cCnFQ.default)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $cCnFQ.default)({}, fallbacks, mediaQueries);
    } else {
        var _ref2, _ref3, _ref4;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new Error('expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.');
        return _ref4 = {}, _ref4[cssProp.prop] = cssProp.fromSize, _ref4["@media (min-width: " + minScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = $6bd4311257448441$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref2), _ref4["@media (min-width: " + maxScreen + ")"] = (_ref3 = {}, _ref3[cssProp.prop] = cssProp.toSize, _ref3), _ref4;
    }
}
function $6bd4311257448441$var$generateFileReferences(fontFilePath, fileFormats) {
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")";
    });
    return fileFontReferences.join(', ');
}
function $6bd4311257448441$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $6bd4311257448441$var$generateSources(fontFilePath, localFonts, fileFormats) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($6bd4311257448441$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($6bd4311257448441$var$generateFileReferences(fontFilePath, fileFormats));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $6bd4311257448441$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, localFonts = _ref.localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
    if (!fontFilePath && !localFonts) throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
    if (localFonts && !Array.isArray(localFonts)) throw new Error('fontFace expects localFonts to be an array.');
    if (!Array.isArray(fileFormats)) throw new Error('fontFace expects fileFormats to be an array.');
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $6bd4311257448441$var$generateSources(fontFilePath, localFonts, fileFormats),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        } // Removes undefined fields for cleaner css object.
    };
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $6bd4311257448441$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $6bd4311257448441$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $6bd4311257448441$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $6bd4311257448441$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
/**
 * CSS to style the placeholder pseudo-element.
 *
 * @deprecated - placeholder has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */ function $6bd4311257448441$export$c7187bbd1a7a9244(styles, parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    return _ref = {}, _ref[parent + "::-webkit-input-placeholder"] = (0, $cCnFQ.default)({}, styles), _ref[parent + ":-moz-placeholder"] = (0, $cCnFQ.default)({}, styles), _ref[parent + "::-moz-placeholder"] = (0, $cCnFQ.default)({}, styles), _ref[parent + ":-ms-input-placeholder"] = (0, $cCnFQ.default)({}, styles), _ref;
}
function $6bd4311257448441$var$_templateObject() {
    var data = (0, $epx0f.default)([
        "radial-gradient(",
        "",
        "",
        "",
        ")"
    ]);
    $6bd4311257448441$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $6bd4311257448441$var$parseFallback(colorStops) {
    return colorStops[0].split(' ')[0];
}
function $6bd4311257448441$var$constructGradientValue(literals) {
    var template = '';
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i]; // Adds leading coma if properties preceed color-stops
        if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
            template = template.slice(0, -1);
            template += ", " + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // No trailing space if color-stops is the only param provided
        } else if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) template += "" + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // Only adds substitution if it is defined
        else if (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) template += (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) + " ";
    }
    return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $6bd4311257448441$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, extent = _ref.extent, fallback = _ref.fallback, position = _ref.position, shape = _ref.shape;
    if (!colorStops || colorStops.length < 2) throw new Error('radialGradient requries at least 2 color-stops to properly render.');
    return {
        backgroundColor: fallback || $6bd4311257448441$var$parseFallback(colorStops),
        backgroundImage: $6bd4311257448441$var$constructGradientValue($6bd4311257448441$var$_templateObject(), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $6bd4311257448441$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new Error('Please supply a filename to retinaImage() as the first argument.');
     // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$6bd4311257448441$export$e79006618d7c6cc3()] = (0, $cCnFQ.default)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/**
 * CSS to style the selection pseudo-element.
 *
 * @deprecated - selection has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */ function $6bd4311257448441$export$7c69810f7b8835c9(styles, parent) {
    var _ref;
    if (parent === void 0) parent = '';
    return _ref = {}, _ref[parent + "::-moz-selection"] = (0, $cCnFQ.default)({}, styles), _ref[parent + "::selection"] = (0, $cCnFQ.default)({}, styles), _ref;
}
/* eslint-disable key-spacing */ var $6bd4311257448441$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
function $6bd4311257448441$var$getTimingFunction(functionName) {
    return $6bd4311257448441$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $6bd4311257448441$export$61210fa83792a81(timingFunction) {
    return $6bd4311257448441$var$getTimingFunction(timingFunction);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $6bd4311257448441$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6bd4311257448441$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
var $6bd4311257448441$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    switch(pointingDirection){
        case 'top':
            return "0 " + width[0] / 2 + width[1] + " " + height[0] + height[1] + " " + width[0] / 2 + width[1];
        case 'left':
            return "" + height[0] / 2 + height[1] + " " + width[0] + width[1] + " " + height[0] / 2 + height[1] + " 0";
        case 'bottom':
            return "" + height[0] + height[1] + " " + width[0] / 2 + width[1] + " 0 " + width[0] / 2 + width[1];
        case 'right':
            return "" + height[0] / 2 + height[1] + " 0 " + height[0] / 2 + height[1] + " " + width[0] + width[1];
        default:
            throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
    }
}; // needed for border-color
var $6bd4311257448441$var$reverseDirection = [
    'bottom',
    'left',
    'top',
    'right'
];
var $6bd4311257448441$var$NUMBER_AND_FLOAT = /(\d*\.?\d*)/;
/**
 * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent',
 *  'borderLeftColor': 'red !important',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $6bd4311257448441$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = [
        parseFloat(width),
        String(width).replace($6bd4311257448441$var$NUMBER_AND_FLOAT, '') || 'px'
    ];
    var heightAndUnit = [
        parseFloat(height),
        String(height).replace($6bd4311257448441$var$NUMBER_AND_FLOAT, '') || 'px'
    ];
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
    var reverseDirectionIndex = $6bd4311257448441$var$reverseDirection.indexOf(pointingDirection);
    return (0, $cCnFQ.default)({
        width: '0',
        height: '0',
        borderWidth: $6bd4311257448441$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit),
        borderStyle: 'solid'
    }, $6bd4311257448441$export$e7fb0694ba2404fc.apply(void 0, Array.from({
        length: 4
    }).map(function(_, index) {
        return index === reverseDirectionIndex ? foregroundColor : backgroundColor;
    })));
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $6bd4311257448441$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $6bd4311257448441$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $6bd4311257448441$var$convertToInt(red, green, blue) {
    return $6bd4311257448441$var$colorToInt(red) + "," + $6bd4311257448441$var$colorToInt(green) + "," + $6bd4311257448441$var$colorToInt(blue);
}
function $6bd4311257448441$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $6bd4311257448441$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
     // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = hue % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $6bd4311257448441$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
function $6bd4311257448441$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $6bd4311257448441$var$namedColorMap[normalizedColorName] ? "#" + $6bd4311257448441$var$namedColorMap[normalizedColorName] : color;
}
var $6bd4311257448441$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $6bd4311257448441$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $6bd4311257448441$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $6bd4311257448441$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $6bd4311257448441$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $6bd4311257448441$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var $6bd4311257448441$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var $6bd4311257448441$var$hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $6bd4311257448441$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    var normalizedColor = $6bd4311257448441$var$nameToHex(color);
    if (normalizedColor.match($6bd4311257448441$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($6bd4311257448441$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($6bd4311257448441$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($6bd4311257448441$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $6bd4311257448441$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $6bd4311257448441$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $6bd4311257448441$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $6bd4311257448441$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $6bd4311257448441$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + rgbColorString + ".");
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $6bd4311257448441$var$hslaRegex.exec(normalizedColor);
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $6bd4311257448441$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $6bd4311257448441$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + _rgbColorString + ".");
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4])
        };
    }
    throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
function $6bd4311257448441$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $6bd4311257448441$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $6bd4311257448441$var$rgbToHsl($6bd4311257448441$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $6bd4311257448441$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
function $6bd4311257448441$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $6bd4311257448441$var$colorToHex(color) {
    return $6bd4311257448441$var$numberToHex(Math.round(color * 255));
}
function $6bd4311257448441$var$convertToHex(red, green, blue) {
    return $6bd4311257448441$var$reduceHexValue("#" + $6bd4311257448441$var$colorToHex(red) + $6bd4311257448441$var$colorToHex(green) + $6bd4311257448441$var$colorToHex(blue));
}
function $6bd4311257448441$var$hslToHex(hue, saturation, lightness) {
    return $6bd4311257448441$var$hslToRgb(hue, saturation, lightness, $6bd4311257448441$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $6bd4311257448441$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $6bd4311257448441$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $6bd4311257448441$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $6bd4311257448441$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $6bd4311257448441$var$hslToHex(value, saturation, lightness) : "rgba(" + $6bd4311257448441$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $6bd4311257448441$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $6bd4311257448441$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $6bd4311257448441$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $6bd4311257448441$var$reduceHexValue("#" + $6bd4311257448441$var$numberToHex(value) + $6bd4311257448441$var$numberToHex(green) + $6bd4311257448441$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $6bd4311257448441$var$reduceHexValue("#" + $6bd4311257448441$var$numberToHex(value.red) + $6bd4311257448441$var$numberToHex(value.green) + $6bd4311257448441$var$numberToHex(value.blue));
    throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $6bd4311257448441$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $6bd4311257448441$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $6bd4311257448441$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $6bd4311257448441$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}
var $6bd4311257448441$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $6bd4311257448441$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $6bd4311257448441$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $6bd4311257448441$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
var $6bd4311257448441$var$errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $6bd4311257448441$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new Error($6bd4311257448441$var$errMsg);
    if ($6bd4311257448441$var$isRgba(color)) return $6bd4311257448441$export$4e46ac54fc82cf3b(color);
    if ($6bd4311257448441$var$isRgb(color)) return $6bd4311257448441$export$8972dc0e6ad9238f(color);
    if ($6bd4311257448441$var$isHsla(color)) return $6bd4311257448441$export$810b04175080204c(color);
    if ($6bd4311257448441$var$isHsl(color)) return $6bd4311257448441$export$8f4a7c0bb78e6ea8(color);
    throw new Error($6bd4311257448441$var$errMsg);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $6bd4311257448441$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $6bd4311257448441$var$curried(f, length, combined);
    };
} // eslint-disable-next-line no-redeclare
function $6bd4311257448441$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $6bd4311257448441$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $6bd4311257448441$var$adjustHue(degree, color) {
    var hslColor = $6bd4311257448441$export$1286688e1b3fde9c(color);
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, hslColor, {
        hue: (hslColor.hue + parseFloat(degree)) % 360
    }));
} // prettier-ignore
var $6bd4311257448441$export$2b372a09365374d6 = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$adjustHue);
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $6bd4311257448441$export$bd4f6f7e1823bc9e(color) {
    var hslColor = $6bd4311257448441$export$1286688e1b3fde9c(color);
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $6bd4311257448441$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $6bd4311257448441$var$darken(amount, color) {
    var hslColor = $6bd4311257448441$export$1286688e1b3fde9c(color);
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, hslColor, {
        lightness: $6bd4311257448441$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
} // prettier-ignore
var $6bd4311257448441$export$4b073707ff63303 = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$darken);
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $6bd4311257448441$var$desaturate(amount, color) {
    var hslColor = $6bd4311257448441$export$1286688e1b3fde9c(color);
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, hslColor, {
        saturation: $6bd4311257448441$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
} // prettier-ignore
var $6bd4311257448441$export$fb75607d98509d9 = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$desaturate);
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $6bd4311257448441$export$c852d90bf7403b62(color) {
    var rgbColor = $6bd4311257448441$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $6bd4311257448441$export$6f416a6db2dfcd5c(color) {
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, $6bd4311257448441$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $6bd4311257448441$export$6897c284b6f9f4dc(color) {
    // parse color string to rgb
    var value = $6bd4311257448441$export$2f48baff6995707a(color);
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $6bd4311257448441$var$lighten(amount, color) {
    var hslColor = $6bd4311257448441$export$1286688e1b3fde9c(color);
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, hslColor, {
        lightness: $6bd4311257448441$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
} // prettier-ignore
var $6bd4311257448441$export$c0816ed86df316af = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$lighten);
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $6bd4311257448441$var$mix(weight, color, otherColor) {
    var parsedColor1 = $6bd4311257448441$export$2f48baff6995707a(color);
    var color1 = (0, $cCnFQ.default)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $6bd4311257448441$export$2f48baff6995707a(otherColor);
    var color2 = (0, $cCnFQ.default)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1 // The formular is copied from the original Sass implementation:
    });
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
    };
    return $6bd4311257448441$export$4e46ac54fc82cf3b(mixedColor);
} // prettier-ignore
var $6bd4311257448441$export$2c9e8a9632a706b2 = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$mix);
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $6bd4311257448441$var$opacify(amount, color) {
    var parsedColor = $6bd4311257448441$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $cCnFQ.default)({}, parsedColor, {
        alpha: $6bd4311257448441$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $6bd4311257448441$export$4e46ac54fc82cf3b(colorWithAlpha);
} // prettier-ignore
var $6bd4311257448441$export$f4f50e3877dd0530 = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$opacify);
/**
 * Returns black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */ function $6bd4311257448441$export$61654c1796c44811(color) {
    return $6bd4311257448441$export$c852d90bf7403b62(color) > 0.179 ? '#000' : '#fff';
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $6bd4311257448441$var$saturate(amount, color) {
    var hslColor = $6bd4311257448441$export$1286688e1b3fde9c(color);
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, hslColor, {
        saturation: $6bd4311257448441$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
} // prettier-ignore
var $6bd4311257448441$export$5fcac96f5a87e3db = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$saturate);
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $6bd4311257448441$var$setHue(hue, color) {
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, $6bd4311257448441$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
} // prettier-ignore
var $6bd4311257448441$export$3bf58ce3e497a846 = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$setHue);
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $6bd4311257448441$var$setLightness(lightness, color) {
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, $6bd4311257448441$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
} // prettier-ignore
var $6bd4311257448441$export$7ef5d725337b805d = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$setLightness);
/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $6bd4311257448441$var$setSaturation(saturation, color) {
    return $6bd4311257448441$export$42fe740cdf79b2df((0, $cCnFQ.default)({}, $6bd4311257448441$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
} // prettier-ignore
var $6bd4311257448441$export$b40fe421ea7a4f7e = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$setSaturation);
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $6bd4311257448441$var$shade(percentage, color) {
    return $6bd4311257448441$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore
var $6bd4311257448441$export$3e32adda0df4ef5d = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$shade);
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $6bd4311257448441$var$tint(percentage, color) {
    return $6bd4311257448441$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore
var $6bd4311257448441$export$fc176dd65a27d98b = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$tint);
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $6bd4311257448441$var$transparentize(amount, color) {
    var parsedColor = $6bd4311257448441$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $cCnFQ.default)({}, parsedColor, {
        alpha: $6bd4311257448441$var$guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
    });
    return $6bd4311257448441$export$4e46ac54fc82cf3b(colorWithAlpha);
} // prettier-ignore
var $6bd4311257448441$export$d11da87e55cc498f = /*#__PURE__*/ $6bd4311257448441$var$curry($6bd4311257448441$var$transparentize);
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $6bd4311257448441$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
        if (Array.isArray(arg) && arg.length > 8) throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $6bd4311257448441$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $6bd4311257448441$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $6bd4311257448441$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $6bd4311257448441$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $6bd4311257448441$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $6bd4311257448441$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $6bd4311257448441$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $6bd4311257448441$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $6bd4311257448441$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $6bd4311257448441$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $6bd4311257448441$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6bd4311257448441$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $6bd4311257448441$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6bd4311257448441$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $6bd4311257448441$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $6bd4311257448441$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new Error('You must provide a template to this method.');
    if (states.length === 0) return $6bd4311257448441$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new Error('You passed an unsupported selector state to this method.');
        selectors.push($6bd4311257448441$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $6bd4311257448441$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $6bd4311257448441$var$template(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $6bd4311257448441$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $6bd4311257448441$var$statefulSelectors(states, $6bd4311257448441$var$template, $6bd4311257448441$var$stateMap);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $6bd4311257448441$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6bd4311257448441$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $6bd4311257448441$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $6bd4311257448441$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $6bd4311257448441$var$positionMap$1 = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $6bd4311257448441$export$5880b8b5730aff45(positionKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($6bd4311257448441$var$positionMap$1.indexOf(positionKeyword) >= 0) return (0, $cCnFQ.default)({
        position: positionKeyword
    }, $6bd4311257448441$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)));
    else {
        var firstValue = positionKeyword; // in this case position is actually the first value
        return $6bd4311257448441$export$4fc00c04dd60af95.apply(void 0, [
            '',
            firstValue
        ].concat(values));
    }
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $6bd4311257448441$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $6bd4311257448441$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $6bd4311257448441$var$template$1(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $6bd4311257448441$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $6bd4311257448441$var$statefulSelectors(states, $6bd4311257448441$var$template$1, $6bd4311257448441$var$stateMap$1);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same tranisition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $6bd4311257448441$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new Error('Property must be a string value.');
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}

});
parcelRegister("epx0f", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7dd003699ecc210$export$2e2bcd8739ae039);
function $a7dd003699ecc210$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}

});



parcelRegister("fOqPA", function(module, exports) {
$parcel$export(module.exports, "GlobalStyled", () => $db0ed1b01c933781$export$b606131378921a7b);
$parcel$export(module.exports, "NewGlobalBGColor", () => $db0ed1b01c933781$export$aa61b57bede93357);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");
parcelRequire("lMBOd");
var $3tfcE = parcelRequire("3tfcE");

var $je3Qr = parcelRequire("je3Qr");
const $db0ed1b01c933781$var$getLinkColorToken = (props)=>{
    if (props !== null && props !== void 0 && props.isCsm) {
        const generatedColors = (0, $je3Qr.generateThemeBranding)(props.theme.color);
        return `var(--ds-link, ${generatedColors.color900})`;
    }
    return `var(--ds-link, ${props.theme.color})`;
};
const $db0ed1b01c933781$export$b606131378921a7b = /*#__PURE__*/ (0, $2UsNA.default)((0, $3tfcE.default)).withConfig({
    componentId: "sc-15eor0s-0"
})`background-color:${"var(--ds-surface, #FFFFFF)"};font:${"var(--ds-font-body, normal 400 14px/1.42857142857143 -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"};a:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']),a:hover:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']){color:${(props)=>$db0ed1b01c933781$var$getLinkColorToken(props)};}h1,h2{letter-spacing:-0.001em;}:root{--ds-space-0:0;--ds-space-025:0.125rem;--ds-space-050:0.25rem;--ds-space-075:0.375rem;--ds-space-100:0.5rem;--ds-space-150:0.75rem;--ds-space-200:1rem;--ds-space-250:1.25rem;--ds-space-300:1.5rem;--ds-space-400:2rem;--ds-space-500:2.5rem;--ds-space-600:3rem;--ds-space-800:4rem;--ds-space-1000:5rem;--ds-font-family-monospace:'SFMono-Medium','SF Mono','Segoe UI Mono','Roboto Mono','Ubuntu Mono',Menlo,Consolas,Courier,monospace;--ds-font-family-sans:-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;--ds-font-size-050:11px;--ds-font-size-075:12px;--ds-font-size-100:14px;--ds-font-size-200:16px;--ds-font-size-300:20px;--ds-font-size-400:24px;--ds-font-size-500:29px;--ds-font-size-600:35px;--ds-font-weight-bold:700;--ds-font-weight-medium:500;--ds-font-weight-regular:400;--ds-font-weight-semibold:600;--ds-font-lineHeight-100:1rem;--ds-font-lineHeight-200:1.25rem;--ds-font-lineHeight-300:1.5rem;--ds-font-lineHeight-400:1.75rem;--ds-font-lineHeight-500:2rem;--ds-font-lineHeight-600:2.5rem;}`;
const $db0ed1b01c933781$export$aa61b57bede93357 = /*#__PURE__*/ (0, $2UsNA.default)((0, $3tfcE.default)).withConfig({
    componentId: "sc-15eor0s-1"
})`background-color:${"var(--ds-surface, #FFFFFF)"};`;

});
parcelRegister("lMBOd", function(module, exports) {
$parcel$export(module.exports, "BodyClassName", () => (parcelRequire("3tfcE")).default);

var $3tfcE = parcelRequire("3tfcE");

});
parcelRegister("3tfcE", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcdd422ca35588d8$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $jW99n = parcelRequire("jW99n");
class $dcdd422ca35588d8$export$2e2bcd8739ae039 extends $8P7DW.PureComponent {
    constructor(props){
        super(props);
        if (this.props.className) {
            const classes = this.props.className.split(' ');
            // IE 11 doesn't allow you to add multiple classes at once.
            classes.forEach((className)=>{
                (0, $jW99n.default).addClassName('body', className);
            });
        }
    }
    componentWillUnmount() {
        if (this.props.className) {
            const classes = this.props.className.split(' ');
            // IE 11 doesn't allow you to add multiple classes at once.
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            classes.forEach((className)=>document.body.classList.remove(className));
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.className !== this.props.className) {
            if (prevProps.className) {
                const prevClasses = prevProps.className.split(' ');
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                document.body.classList.remove(...prevClasses);
            }
            if (this.props.className) {
                const classes = this.props.className.split(' ');
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                document.body.classList.add(...classes);
            }
        }
    }
    render() {
        return null;
    }
}

});


parcelRegister("je3Qr", function(module, exports) {
$parcel$export(module.exports, "generateThemeBranding", () => $2188d37180ae150e$export$c1410db1c88d6e0f);

var $fNAwH = parcelRequire("fNAwH");

var $qeHja = parcelRequire("qeHja");
/**
 * Default primary color for CSM branding
 */ const $2188d37180ae150e$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR = '#B5B5B5';
const $2188d37180ae150e$export$c1410db1c88d6e0f = (primaryColour)=>(0, $fNAwH.generateColorRamps)((0, $qeHja.isValidHex)(primaryColour) ? primaryColour : $2188d37180ae150e$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR);

});
parcelRegister("fNAwH", function(module, exports) {
$parcel$export(module.exports, "generateColorRamps", () => $d4108a353cf819da$export$3a180ce5632a9d57);

var $dCiCK = parcelRequire("dCiCK");

var $iEky8 = parcelRequire("iEky8");

var $6KPSq = parcelRequire("6KPSq");

var $71Anl = parcelRequire("71Anl");
const $d4108a353cf819da$var$lowLuminanceContrastRatios = [
    1.12,
    1.33,
    2.03,
    2.73,
    3.33,
    4.27,
    5.2,
    6.62,
    12.46,
    14.25
];
const $d4108a353cf819da$var$highLuminanceContrastRatios = [
    1.08,
    1.24,
    1.55,
    1.99,
    2.45,
    3.34,
    4.64,
    6.1,
    10.19,
    12.6
];
const $d4108a353cf819da$export$b102e016d69678f3 = (themeRamp, brandColor)=>{
    // Iterate over themeRamp and find whichever color is closest to brandColor
    let closestColorIndex = 0;
    let closestColorDistance = null;
    themeRamp.forEach((value, index)=>{
        const distance = (0, $dCiCK.deltaE)((0, $dCiCK.hexToRgb)(value), (0, $dCiCK.hexToRgb)(brandColor));
        if (closestColorDistance === null || distance < closestColorDistance) {
            closestColorIndex = index;
            closestColorDistance = distance;
        }
    });
    return closestColorIndex;
};
const $d4108a353cf819da$export$253cd51ce7d49924 = (brandColor)=>{
    // Determine luminance
    const HSLBrandColorHue = (0, $dCiCK.hexToHSL)(brandColor)[0];
    const baseRgb = (0, $dCiCK.HSLToRGB)(HSLBrandColorHue, 100, 60);
    const isLowLuminance = (0, $dCiCK.relativeLuminanceW3C)(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
    // Choose right palette
    const themeRatios = isLowLuminance ? $d4108a353cf819da$var$lowLuminanceContrastRatios : $d4108a353cf819da$var$highLuminanceContrastRatios;
    const brandRgba = (0, $dCiCK.hexToRgbA)(brandColor);
    const hctColor = (0, $71Anl.Hct).fromInt((0, $iEky8.argbFromRgba)({
        r: brandRgba[0],
        g: brandRgba[1],
        b: brandRgba[2],
        a: brandRgba[3]
    }));
    const themeRamp = themeRatios.map((contrast)=>{
        const rgbaColor = (0, $iEky8.rgbaFromArgb)((0, $71Anl.Hct).from(hctColor.hue, hctColor.chroma, (0, $6KPSq.Contrast).darker(100, contrast) + 0.25 // Material's utils provide an offset
        ).toInt());
        return (0, $dCiCK.rgbToHex)(rgbaColor.r, rgbaColor.g, rgbaColor.b);
    });
    const closestColorIndex = $d4108a353cf819da$export$b102e016d69678f3(themeRamp, brandColor);
    // Replace closet color with brandColor
    const updatedThemeRamp = [
        ...themeRamp
    ];
    updatedThemeRamp[closestColorIndex] = brandColor;
    return updatedThemeRamp;
};
const $d4108a353cf819da$export$3a180ce5632a9d57 = (primaryColor)=>{
    const colors = $d4108a353cf819da$export$253cd51ce7d49924(primaryColor);
    return {
        color100: colors[0],
        color200: colors[1],
        color300: colors[2],
        color400: colors[3],
        color500: colors[4],
        color600: colors[5],
        color700: colors[6],
        color800: colors[7],
        color900: colors[8],
        color1000: colors[9]
    };
};

});
parcelRegister("dCiCK", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $4568385ea1d4e5f5$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $4568385ea1d4e5f5$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $4568385ea1d4e5f5$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $4568385ea1d4e5f5$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $4568385ea1d4e5f5$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $4568385ea1d4e5f5$export$e770b01b744f3745);
$parcel$export(module.exports, "deltaE", () => $4568385ea1d4e5f5$export$e8ddad763b4bebf9);

var $qeHja = parcelRequire("qeHja");
function $4568385ea1d4e5f5$export$34d09c4a771c46ef(r, g, b) {
    const chars = (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    return `#${chars}`;
}
function $4568385ea1d4e5f5$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $4568385ea1d4e5f5$export$b36dbdb4f463f05c(hex) {
    if (!(0, $qeHja.isValidHex)(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $4568385ea1d4e5f5$export$1212645cf40ebf71(hex)
    ];
}
function $4568385ea1d4e5f5$export$5a544e13ad4e1fa5(hex) {
    if (!(0, $qeHja.isValidHex)(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $4568385ea1d4e5f5$export$47ea145a83f50dc0(hex) {
    if (!(0, $qeHja.isValidHex)(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $4568385ea1d4e5f5$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $4568385ea1d4e5f5$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $4568385ea1d4e5f5$export$d061e26956a60b0a(foreground, background) {
    if (!(0, $qeHja.isValidHex)(foreground) || !(0, $qeHja.isValidHex)(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $4568385ea1d4e5f5$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $4568385ea1d4e5f5$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $4568385ea1d4e5f5$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $4568385ea1d4e5f5$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $4568385ea1d4e5f5$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $4568385ea1d4e5f5$var$rgbToLab(rgbA);
    let labB = $4568385ea1d4e5f5$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $4568385ea1d4e5f5$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});
parcelRegister("qeHja", function(module, exports) {
$parcel$export(module.exports, "isValidHex", () => $a9f5a4a030566292$export$944f75ec5697b362);
const $a9f5a4a030566292$export$944f75ec5697b362 = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);

});


parcelRegister("iEky8", function(module, exports) {
$parcel$export(module.exports, "argbFromLinrgb", () => $6255da01e4209280$export$7928ddf440518d19);
$parcel$export(module.exports, "argbFromXyz", () => $6255da01e4209280$export$cbbbbc8b222df20);
$parcel$export(module.exports, "linearized", () => $6255da01e4209280$export$dec6bcda7bf47f2c);
$parcel$export(module.exports, "argbFromLstar", () => $6255da01e4209280$export$ae8c227f6d0cbddb);
$parcel$export(module.exports, "yFromLstar", () => $6255da01e4209280$export$7f3071c4a5db05a0);
$parcel$export(module.exports, "lstarFromArgb", () => $6255da01e4209280$export$8b8f7ef2e0a71c61);
$parcel$export(module.exports, "lstarFromY", () => $6255da01e4209280$export$bfc0d1dd9c64ada2);
$parcel$export(module.exports, "whitePointD65", () => $6255da01e4209280$export$d4534a444c6526c3);
$parcel$export(module.exports, "rgbaFromArgb", () => $6255da01e4209280$export$fb1fd26c787a8662);
$parcel$export(module.exports, "argbFromRgba", () => $6255da01e4209280$export$9128c3a9233ad1fd);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.

var $bXvrO = parcelRequire("bXvrO");
/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $6255da01e4209280$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $6255da01e4209280$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $6255da01e4209280$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
function $6255da01e4209280$export$58a74b9f8e513b7b(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
function $6255da01e4209280$export$7928ddf440518d19(linrgb) {
    const r = $6255da01e4209280$export$777e26aa2ec02b1(linrgb[0]);
    const g = $6255da01e4209280$export$777e26aa2ec02b1(linrgb[1]);
    const b = $6255da01e4209280$export$777e26aa2ec02b1(linrgb[2]);
    return $6255da01e4209280$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Returns the alpha component of a color in ARGB format.
 */ function $6255da01e4209280$var$alphaFromArgb(argb) {
    return argb >> 24 & 255;
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $6255da01e4209280$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $6255da01e4209280$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $6255da01e4209280$var$blueFromArgb(argb) {
    return argb & 255;
}
function $6255da01e4209280$export$cbbbbc8b222df20(x, y, z) {
    const matrix = $6255da01e4209280$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $6255da01e4209280$export$777e26aa2ec02b1(linearR);
    const g = $6255da01e4209280$export$777e26aa2ec02b1(linearG);
    const b = $6255da01e4209280$export$777e26aa2ec02b1(linearB);
    return $6255da01e4209280$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $6255da01e4209280$var$xyzFromArgb(argb) {
    const r = $6255da01e4209280$export$dec6bcda7bf47f2c($6255da01e4209280$var$redFromArgb(argb));
    const g = $6255da01e4209280$export$dec6bcda7bf47f2c($6255da01e4209280$var$greenFromArgb(argb));
    const b = $6255da01e4209280$export$dec6bcda7bf47f2c($6255da01e4209280$var$blueFromArgb(argb));
    return $bXvrO.matrixMultiply([
        r,
        g,
        b
    ], $6255da01e4209280$var$SRGB_TO_XYZ);
}
function $6255da01e4209280$export$ae8c227f6d0cbddb(lstar) {
    const y = $6255da01e4209280$export$7f3071c4a5db05a0(lstar);
    const component = $6255da01e4209280$export$777e26aa2ec02b1(y);
    return $6255da01e4209280$export$58a74b9f8e513b7b(component, component, component);
}
function $6255da01e4209280$export$8b8f7ef2e0a71c61(argb) {
    const y = $6255da01e4209280$var$xyzFromArgb(argb)[1];
    return 116.0 * $6255da01e4209280$var$labF(y / 100.0) - 16.0;
}
function $6255da01e4209280$export$7f3071c4a5db05a0(lstar) {
    return 100.0 * $6255da01e4209280$var$labInvf((lstar + 16.0) / 116.0);
}
function $6255da01e4209280$export$bfc0d1dd9c64ada2(y) {
    return $6255da01e4209280$var$labF(y / 100.0) * 116.0 - 16.0;
}
function $6255da01e4209280$export$dec6bcda7bf47f2c(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
function $6255da01e4209280$export$777e26aa2ec02b1(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $bXvrO.clampInt(0, 255, Math.round(delinearized * 255.0));
}
function $6255da01e4209280$export$d4534a444c6526c3() {
    return $6255da01e4209280$var$WHITE_POINT_D65;
}
function $6255da01e4209280$export$fb1fd26c787a8662(argb) {
    const r = $6255da01e4209280$var$redFromArgb(argb);
    const g = $6255da01e4209280$var$greenFromArgb(argb);
    const b = $6255da01e4209280$var$blueFromArgb(argb);
    const a = $6255da01e4209280$var$alphaFromArgb(argb);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $6255da01e4209280$export$9128c3a9233ad1fd({ r: r, g: g, b: b, a: a }) {
    const rValue = $6255da01e4209280$var$clampComponent(r);
    const gValue = $6255da01e4209280$var$clampComponent(g);
    const bValue = $6255da01e4209280$var$clampComponent(b);
    const aValue = $6255da01e4209280$var$clampComponent(a);
    return aValue << 24 | rValue << 16 | gValue << 8 | bValue;
}
function $6255da01e4209280$var$clampComponent(value) {
    if (value < 0) return 0;
    if (value > 255) return 255;
    return value;
}
function $6255da01e4209280$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $6255da01e4209280$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}

});
parcelRegister("bXvrO", function(module, exports) {
$parcel$export(module.exports, "signum", () => $f2492d31ce199367$export$23e3e2011c250f0f);
$parcel$export(module.exports, "lerp", () => $f2492d31ce199367$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "clampInt", () => $f2492d31ce199367$export$d0498fe3d58e384f);
$parcel$export(module.exports, "clampDouble", () => $f2492d31ce199367$export$62d511a4580feff);
$parcel$export(module.exports, "sanitizeDegreesDouble", () => $f2492d31ce199367$export$7417613e514a9e72);
$parcel$export(module.exports, "matrixMultiply", () => $f2492d31ce199367$export$be586f9fe0391d67);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $f2492d31ce199367$export$23e3e2011c250f0f(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
function $f2492d31ce199367$export$3a89f8d6f6bf6c9f(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
function $f2492d31ce199367$export$d0498fe3d58e384f(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $f2492d31ce199367$export$62d511a4580feff(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $f2492d31ce199367$export$7417613e514a9e72(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
function $f2492d31ce199367$export$be586f9fe0391d67(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}

});


parcelRegister("6KPSq", function(module, exports) {
$parcel$export(module.exports, "Contrast", () => $f1428f9bf80b5181$export$656ae42051d0ca86);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace

var $iEky8 = parcelRequire("iEky8");

var $bXvrO = parcelRequire("bXvrO");
class $f1428f9bf80b5181$export$656ae42051d0ca86 {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $bXvrO.clampDouble(0.0, 100.0, toneA);
        toneB = $bXvrO.clampDouble(0.0, 100.0, toneB);
        return $f1428f9bf80b5181$export$656ae42051d0ca86.ratioOfYs($iEky8.yFromLstar(toneA), $iEky8.yFromLstar(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $iEky8.yFromLstar(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $f1428f9bf80b5181$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $iEky8.lstarFromY(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $iEky8.yFromLstar(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $f1428f9bf80b5181$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $iEky8.lstarFromY(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $f1428f9bf80b5181$export$656ae42051d0ca86.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $f1428f9bf80b5181$export$656ae42051d0ca86.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}

});

parcelRegister("71Anl", function(module, exports) {
$parcel$export(module.exports, "Hct", () => $90293c688b82d130$export$91d2e033b3924566);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $iEky8 = parcelRequire("iEky8");

var $bXvrO = parcelRequire("bXvrO");
class $90293c688b82d130$export$91d2e033b3924566 {
    static from(hue, chroma, tone) {
        return new $90293c688b82d130$export$91d2e033b3924566($90293c688b82d130$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $90293c688b82d130$export$91d2e033b3924566(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($90293c688b82d130$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($90293c688b82d130$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /**
   * Lightness. Ranges from 0 to 100.
   */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($90293c688b82d130$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    constructor(argb){
        this.argb = argb;
        const cam = $90293c688b82d130$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $iEky8.lstarFromArgb(argb);
        this.argb = argb;
    }
    setInternalState(argb) {
        const cam = $90293c688b82d130$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $iEky8.lstarFromArgb(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $90293c688b82d130$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $90293c688b82d130$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $90293c688b82d130$export$159586e3808c6277.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $90293c688b82d130$export$91d2e033b3924566.from(recastInVc.hue, recastInVc.chroma, $iEky8.lstarFromY(viewedInVc[1]));
        return recastHct;
    }
}
/**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $90293c688b82d130$var$Cam16 {
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $90293c688b82d130$var$Cam16.fromIntInViewingConditions(argb, $90293c688b82d130$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $iEky8.linearized(red);
        const greenL = $iEky8.linearized(green);
        const blueL = $iEky8.linearized(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $bXvrO.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $bXvrO.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $bXvrO.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $90293c688b82d130$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $90293c688b82d130$var$Cam16.fromJchInViewingConditions(j, c, h, $90293c688b82d130$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $90293c688b82d130$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $90293c688b82d130$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $90293c688b82d130$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $90293c688b82d130$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($90293c688b82d130$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $bXvrO.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $bXvrO.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $bXvrO.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $iEky8.argbFromXyz(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $bXvrO.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $bXvrO.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $bXvrO.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $90293c688b82d130$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $bXvrO.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $bXvrO.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $bXvrO.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
}
// This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $90293c688b82d130$var$HctSolver {
    static #_ = this.SCALED_DISCOUNT_FROM_LINRGB = [
        [
            0.001200833568784504,
            0.002389694492170889,
            0.0002795742885861124
        ],
        [
            0.0005891086651375999,
            0.0029785502573438758,
            0.0003270666104008398
        ],
        [
            0.00010146692491640572,
            0.0005364214359186694,
            0.0032979401770712076
        ]
    ];
    static #_2 = this.LINRGB_FROM_SCALED_DISCOUNT = [
        [
            1373.2198709594231,
            -1100.4251190754821,
            -7.278681089101213
        ],
        [
            -271.815969077903,
            559.6580465940733,
            -32.46047482791194
        ],
        [
            1.9622899599665666,
            -57.173814538844006,
            308.7233197812385
        ]
    ];
    static #_3 = this.Y_FROM_LINRGB = [
        0.2126,
        0.7152,
        0.0722
    ];
    static #_4 = this.CRITICAL_PLANES = [
        0.015176349177441876,
        0.045529047532325624,
        0.07588174588720938,
        0.10623444424209313,
        0.13658714259697685,
        0.16693984095186062,
        0.19729253930674434,
        0.2276452376616281,
        0.2579979360165119,
        0.28835063437139563,
        0.3188300904430532,
        0.350925934958123,
        0.3848314933096426,
        0.42057480301049466,
        0.458183274052838,
        0.4976837250274023,
        0.5391024159806381,
        0.5824650784040898,
        0.6277969426914107,
        0.6751227633498623,
        0.7244668422128921,
        0.775853049866786,
        0.829304845476233,
        0.8848452951698498,
        0.942497089126609,
        1.0022825574869039,
        1.0642236851973577,
        1.1283421258858297,
        1.1946592148522128,
        1.2631959812511864,
        1.3339731595349034,
        1.407011200216447,
        1.4823302800086415,
        1.5599503113873272,
        1.6398909516233677,
        1.7221716113234105,
        1.8068114625156377,
        1.8938294463134073,
        1.9832442801866852,
        2.075074464868551,
        2.1693382909216234,
        2.2660538449872063,
        2.36523901573795,
        2.4669114995532007,
        2.5710888059345764,
        2.6777882626779785,
        2.7870270208169257,
        2.898822059350997,
        3.0131901897720907,
        3.1301480604002863,
        3.2497121605402226,
        3.3718988244681087,
        3.4967242352587946,
        3.624204428461639,
        3.754355295633311,
        3.887192587735158,
        4.022731918402185,
        4.160988767090289,
        4.301978482107941,
        4.445716283538092,
        4.592217266055746,
        4.741496401646282,
        4.893568542229298,
        5.048448422192488,
        5.20615066083972,
        5.3666897647573375,
        5.5300801301023865,
        5.696336044816294,
        5.865471690767354,
        6.037501145825082,
        6.212438385869475,
        6.390297286737924,
        6.571091626112461,
        6.7548350853498045,
        6.941541251256611,
        7.131223617812143,
        7.323895587840543,
        7.5195704746346665,
        7.7182615035334345,
        7.919981813454504,
        8.124744458384042,
        8.332562408825165,
        8.543448553206703,
        8.757415699253682,
        8.974476575321063,
        9.194643831691977,
        9.417930041841839,
        9.644347703669503,
        9.873909240696694,
        10.106627003236781,
        10.342513269534024,
        10.58158024687427,
        10.8238400726681,
        11.069304815507364,
        11.317986476196008,
        11.569896988756009,
        11.825048221409341,
        12.083451977536606,
        12.345119996613247,
        12.610063955123938,
        12.878295467455942,
        13.149826086772048,
        13.42466730586372,
        13.702830557985108,
        13.984327217668513,
        14.269168601521828,
        14.55736596900856,
        14.848930523210871,
        15.143873411576273,
        15.44220572664832,
        15.743938506781891,
        16.04908273684337,
        16.35764934889634,
        16.66964922287304,
        16.985093187232053,
        17.30399201960269,
        17.62635644741625,
        17.95219714852476,
        18.281524751807332,
        18.614349837764564,
        18.95068293910138,
        19.290534541298456,
        19.633915083172692,
        19.98083495742689,
        20.331304511189067,
        20.685334046541502,
        21.042933821039977,
        21.404114048223256,
        21.76888489811322,
        22.137256497705877,
        22.50923893145328,
        22.884842241736916,
        23.264076429332462,
        23.6469514538663,
        24.033477234264016,
        24.42366364919083,
        24.817520537484558,
        25.21505769858089,
        25.61628489293138,
        26.021211842414342,
        26.429848230738664,
        26.842203703840827,
        27.258287870275353,
        27.678110301598522,
        28.10168053274597,
        28.529008062403893,
        28.96010235337422,
        29.39497283293396,
        29.83362889318845,
        30.276079891419332,
        30.722335150426627,
        31.172403958865512,
        31.62629557157785,
        32.08401920991837,
        32.54558406207592,
        33.010999283389665,
        33.4802739966603,
        33.953417292456834,
        34.430438229418264,
        34.911345834551085,
        35.39614910352207,
        35.88485700094671,
        36.37747846067349,
        36.87402238606382,
        37.37449765026789,
        37.87891309649659,
        38.38727753828926,
        38.89959975977785,
        39.41588851594697,
        39.93615253289054,
        40.460400508064545,
        40.98864111053629,
        41.520882981230194,
        42.05713473317016,
        42.597404951718396,
        43.141702194811224,
        43.6900349931913,
        44.24241185063697,
        44.798841244188324,
        45.35933162437017,
        45.92389141541209,
        46.49252901546552,
        47.065252796817916,
        47.64207110610409,
        48.22299226451468,
        48.808024568002054,
        49.3971762874833,
        49.9904556690408,
        50.587870934119984,
        51.189430279724725,
        51.79514187861014,
        52.40501387947288,
        53.0190544071392,
        53.637271562750364,
        54.259673423945976,
        54.88626804504493,
        55.517063457223934,
        56.15206766869424,
        56.79128866487574,
        57.43473440856916,
        58.08241284012621,
        58.734331877617365,
        59.39049941699807,
        60.05092333227251,
        60.715611475655585,
        61.38457167773311,
        62.057811747619894,
        62.7353394731159,
        63.417162620860914,
        64.10328893648692,
        64.79372614476921,
        65.48848194977529,
        66.18756403501224,
        66.89098006357258,
        67.59873767827808,
        68.31084450182222,
        69.02730813691093,
        69.74813616640164,
        70.47333615344107,
        71.20291564160104,
        71.93688215501312,
        72.67524319850172,
        73.41800625771542,
        74.16517879925733,
        74.9167682708136,
        75.67278210128072,
        76.43322770089146,
        77.1981124613393,
        77.96744375590167,
        78.74122893956174,
        79.51947534912904,
        80.30219030335869,
        81.08938110306934,
        81.88105503125999,
        82.67721935322541,
        83.4778813166706,
        84.28304815182372,
        85.09272707154808,
        85.90692527145302,
        86.72564993000343,
        87.54890820862819,
        88.3767072518277,
        89.2090541872801,
        90.04595612594655,
        90.88742016217518,
        91.73345337380438,
        92.58406282226491,
        93.43925555268066,
        94.29903859396902,
        95.16341895893969,
        96.03240364439274,
        96.9059996312159,
        97.78421388448044,
        98.6670533535366,
        99.55452497210776
    ];
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $bXvrO.signum(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $bXvrO.matrixMultiply(linrgb, $90293c688b82d130$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $90293c688b82d130$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $90293c688b82d130$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $90293c688b82d130$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $90293c688b82d130$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $90293c688b82d130$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $90293c688b82d130$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $90293c688b82d130$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $90293c688b82d130$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $90293c688b82d130$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $90293c688b82d130$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($90293c688b82d130$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($90293c688b82d130$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($90293c688b82d130$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $90293c688b82d130$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $90293c688b82d130$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $90293c688b82d130$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($90293c688b82d130$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $90293c688b82d130$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $90293c688b82d130$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $90293c688b82d130$var$HctSolver.criticalPlaneBelow($90293c688b82d130$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $90293c688b82d130$var$HctSolver.criticalPlaneAbove($90293c688b82d130$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $90293c688b82d130$var$HctSolver.criticalPlaneAbove($90293c688b82d130$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $90293c688b82d130$var$HctSolver.criticalPlaneBelow($90293c688b82d130$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $90293c688b82d130$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $90293c688b82d130$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $90293c688b82d130$var$HctSolver.hueOf(mid);
                    if ($90293c688b82d130$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $90293c688b82d130$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $bXvrO.signum(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $90293c688b82d130$export$159586e3808c6277.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $90293c688b82d130$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $90293c688b82d130$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $90293c688b82d130$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $bXvrO.matrixMultiply([
                rCScaled,
                gCScaled,
                bCScaled
            ], $90293c688b82d130$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $90293c688b82d130$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $90293c688b82d130$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $90293c688b82d130$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $iEky8.argbFromLinrgb(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $iEky8.argbFromLstar(lstar);
        hueDegrees = $bXvrO.sanitizeDegreesDouble(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $iEky8.yFromLstar(lstar);
        const exactAnswer = $90293c688b82d130$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $90293c688b82d130$var$HctSolver.bisectToLimit(y, hueRadians);
        return $iEky8.argbFromLinrgb(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $90293c688b82d130$var$Cam16.fromInt($90293c688b82d130$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
class $90293c688b82d130$export$159586e3808c6277 {
    static #_ = /**
   * sRGB-like viewing conditions.
   */ this.DEFAULT = $90293c688b82d130$export$159586e3808c6277.make();
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $iEky8.whitePointD65(), adaptingLuminance = 200.0 / Math.PI * $iEky8.yFromLstar(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $bXvrO.lerp(0.59, 0.69, (f - 0.9) * 10.0) : $bXvrO.lerp(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $iEky8.yFromLstar(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $90293c688b82d130$export$159586e3808c6277(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}

});




parcelRegister("iA1ui", function(module, exports) {
$parcel$export(module.exports, "getFlexiHelpCenterRoute", () => $2c02bb9cc667c1c6$export$21b2409877effae5);
$parcel$export(module.exports, "getViewHomePageRoute", () => $2c02bb9cc667c1c6$export$2601c63db4e9c5eb);
$parcel$export(module.exports, "getEditHomePageRoute", () => $2c02bb9cc667c1c6$export$ce4073fcfac7d40d);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $hxVai = parcelRequire("hxVai");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $hd1aJ = parcelRequire("hd1aJ");

var $kT9oZ = parcelRequire("kT9oZ");

var $gweXC = parcelRequire("gweXC");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("d5AiD");
var $hlVBC = parcelRequire("hlVBC");
parcelRequire("9QKIl");
var $9t02C = parcelRequire("9t02C");
parcelRequire("chjsC");
var $h2NCY = parcelRequire("h2NCY");
parcelRequire("i2Zru");
var $jBIAB = parcelRequire("jBIAB");
parcelRequire("1dZn3");
var $8m5pV = parcelRequire("8m5pV");
parcelRequire("20jeq");
var $2hE7u = parcelRequire("2hE7u");

var $1nQ48 = parcelRequire("1nQ48");

var $k7ZVu = parcelRequire("k7ZVu");

var $e6Qdr = parcelRequire("e6Qdr");

var $iziiq = parcelRequire("iziiq");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $bpyxC = parcelRequire("bpyxC");

var $cfbZK = parcelRequire("cfbZK");

var $dfRW3 = parcelRequire("dfRW3");

var $dHBPx = parcelRequire("dHBPx");
const $2c02bb9cc667c1c6$var$VIEW_HOMEPAGE_PATH = (0, $HGACo.isSlashOptionalInHelpCenterHomeRoute)() ? '(/)?' : '/';
const $2c02bb9cc667c1c6$var$EDIT_HOMEPAGE_PATH = '/edit';

const $2c02bb9cc667c1c6$var$AsyncViewHomepage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("5767l")), {
        moduleId: "./src/view/advanced-help-center/view-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hd1aJ.default), null)
});

const $2c02bb9cc667c1c6$var$AsyncCSMViewHomepage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("iKKGl")), {
        moduleId: "./src/view/customer-service/view-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hd1aJ.default), null)
});
const $2c02bb9cc667c1c6$export$21b2409877effae5 = (name = 'help-center', path = $2c02bb9cc667c1c6$var$VIEW_HOMEPAGE_PATH, screenName = (0, $8rTkC.ScreenName).VIEW_HOMEPAGE)=>{
    const viewHomePageSSRResources = (0, $HGACo.isRemoveNonCriticalResourceFromViewHomePageRouteEnabled)() ? [
        (0, $dHBPx.brandingResource),
        (0, $kT9oZ.ViewHomepageResource),
        (0, $kT9oZ.searchComponentVirtualAgentResource)
    ] : [
        (0, $dHBPx.brandingResource),
        (0, $dHBPx.featuredAndSortedPortalsResource),
        (0, $dHBPx.topicsResource),
        (0, $kT9oZ.ViewHomepageResource),
        (0, $kT9oZ.searchComponentVirtualAgentResource)
    ];
    return (0, $bpyxC.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $2c02bb9cc667c1c6$var$AsyncViewHomepage,
        /**
     * These resources can be removed once the individual elements data starts coming in the layout response
     */ resources: [
            (0, $kT9oZ.ViewHomepageResource),
            (0, $kT9oZ.searchComponentVirtualAgentResource)
        ]
    }, screenName, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true,
        hideSkipToMainContent: true
    });
};
const $2c02bb9cc667c1c6$export$fc52ccc4768cd164 = (name = 'help-center', path = $2c02bb9cc667c1c6$var$VIEW_HOMEPAGE_PATH, screenName = (0, $8rTkC.ScreenName).CSM_VIEW_HOMEPAGE)=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@atlaskit/platform/ensure-feature-flag-registration
    const KnowledgeCardsResource = (0, $e6Qdr.fg)('jcs_knowledge_cards') ? [
        (0, $kT9oZ.knowledgeCardsResource)
    ] : [];
    const viewHomePageSSRResources = [
        (0, $dHBPx.brandingResource),
        (0, $kT9oZ.ViewHomepageResource),
        ...KnowledgeCardsResource,
        (0, $kT9oZ.searchComponentVirtualAgentResource)
    ];
    return (0, $bpyxC.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $2c02bb9cc667c1c6$var$AsyncCSMViewHomepage,
        /**
     * These resources can be removed once the individual elements data starts coming in the layout response
     */ resources: [
            (0, $kT9oZ.ViewHomepageResource),
            ...KnowledgeCardsResource,
            (0, $kT9oZ.searchComponentVirtualAgentResource)
        ]
    }, screenName, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true
    });
};
const $2c02bb9cc667c1c6$export$2601c63db4e9c5eb = ()=>{
    if ((0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType)) return $2c02bb9cc667c1c6$export$fc52ccc4768cd164();
    return $2c02bb9cc667c1c6$export$21b2409877effae5();
};

const $2c02bb9cc667c1c6$export$ebbcccd382fe1f3b = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("gnCoW")), {
        moduleId: "./src/view/advanced-help-center/edit-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>(0, $HGACo.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hlVBC.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hd1aJ.default), {
            showActionBar: true
        })
});

const $2c02bb9cc667c1c6$export$400d7e0667f80c3f = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("3r5rR")), {
        moduleId: "./src/view/advanced-help-center/edit-homepage-v2/index.tsx"
    }),
    LoadingSkeleton: ()=>(0, $HGACo.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hlVBC.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hd1aJ.default), {
            showActionBar: true
        })
});
const $2c02bb9cc667c1c6$export$96880615462f6c7f = (props)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const WrappedComponent = (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: props.location.pathname
    }), (0, $h2NCY.default)({
        message: formatMessage((0, $1nQ48.authPageMessage)),
        callToActionText: formatMessage((0, $1nQ48.callToActionUrlText)),
        callToActionUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8m5pV.default), {
            path: $2c02bb9cc667c1c6$var$EDIT_HOMEPAGE_PATH,
            component: (0, $HGACo.isCustomPagesUiEnabled)() ? $2c02bb9cc667c1c6$export$400d7e0667f80c3f : $2c02bb9cc667c1c6$export$ebbcccd382fe1f3b,
            screenName: (0, $8rTkC.ScreenName).EDIT_HOMEPAGE,
            isFooterHidden: (0, $HGACo.isIncreasedFlexibilityEnabled)()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2hE7u.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, props));
};
const $2c02bb9cc667c1c6$export$ce4073fcfac7d40d = (name = 'edit-homepage', path = '/edit')=>{
    const baseResources = [
        (0, $HGACo.isCustomPagesUiEnabled)() ? (0, $dfRW3.EditHomepageV2Resource) : (0, $cfbZK.EditHomepageResource)
    ];
    const resources = // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && (0, $e6Qdr.fg)('jcs_knowledge_cards') ? [
        ...baseResources,
        (0, $kT9oZ.knowledgeCardsResource)
    ] : baseResources;
    const editHomePageRoute = {
        name: name,
        path: path,
        resources: resources,
        exact: true,
        component: (0, $hrPHR.getIsHCCustomizationEnabled)() && (0, $HGACo.isAdvancedCustomizationEditPageEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo($2c02bb9cc667c1c6$export$96880615462f6c7f) : (0, $iziiq.withAnalyticsContext)({
            componentName: 'notFoundPage'
        })(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        (0, $k7ZVu.default)({})((0, $9t02C.NotFoundPage)))
    };
    return editHomePageRoute;
};

});
parcelRegister("hd1aJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dd5ecab05442760$export$2e2bcd8739ae039);
/* flexible-homepage-loader.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $4O8fD = parcelRequire("4O8fD");

var $aw7IH = parcelRequire("aw7IH");
parcelRequire("3lHwv");
var $ffj9p = parcelRequire("ffj9p");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $4peLG = parcelRequire("4peLG");
const $2dd5ecab05442760$var$SECTION_HEIGHT = 232;
const $2dd5ecab05442760$var$FlexibleHomepageLoader = ({ showActionBar: showActionBar, removeHeader: removeHeader, sectionCount: sectionCount = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
        name: "flexible-homepage-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $2dd5ecab05442760$var$skeletonContainer
    }, showActionBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ffj9p.ActionBarStateless), {
        previewButtonDisabled: true,
        publishButtonDisabled: true
    }), !removeHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $2dd5ecab05442760$var$headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
        "data-testid": "flexible-hc-header-skeleton",
        height: (0, $aw7IH.HEADER_HEIGHT),
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), Array(sectionCount).fill(1).map((_, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($2dd5ecab05442760$var$SectionLoader, {
            key: `flexibleHCLoader_${index}`,
            "data-testid": "flexible-hc-section-skeleton",
            height: $2dd5ecab05442760$var$SECTION_HEIGHT,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        });
    })));
};
const $2dd5ecab05442760$var$skeletonContainer = (0, $37U6z.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
const $2dd5ecab05442760$var$headerContainer = (0, $37U6z.xcss)({
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2dd5ecab05442760$var$SectionLoader = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $4O8fD.LoadingSkeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_2rko12b0 _1bsb1osq _19pk1ejb _69lw94vn _9wd01ejb _n71h1ejb",
            __cmplp.className
        ])
    });
});
var $2dd5ecab05442760$export$2e2bcd8739ae039 = $2dd5ecab05442760$var$FlexibleHomepageLoader;

});
parcelRegister("aw7IH", function(module, exports) {
$parcel$export(module.exports, "BANNER_HEIGHT", () => $031b24f7bb93edaf$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $031b24f7bb93edaf$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "SEARCH_INPUT_FONT_SIZE", () => $031b24f7bb93edaf$export$1d74cef432cdcb55);
$parcel$export(module.exports, "FilterContainer", () => $031b24f7bb93edaf$export$2f96f6f204f87534);
$parcel$export(module.exports, "FormErrorContainer", () => $031b24f7bb93edaf$export$ae0c09a310b3720b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");
const $031b24f7bb93edaf$export$c09feb53ddd4034b = 300;
const $031b24f7bb93edaf$export$ed7cc0d417ee89e = $4cxV2.multiple(44);
const $031b24f7bb93edaf$export$cdb7fd9d999c7168 = $4cxV2.unitless * 7;
const $031b24f7bb93edaf$export$1d74cef432cdcb55 = $kBzhX.mediumLarge;
const $031b24f7bb93edaf$export$2f96f6f204f87534 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1pch1g4-0"
})`display:flex;flex-wrap:wrap;margin-top:${"var(--ds-space-negative-100, -8px)"};margin-right:${"var(--ds-space-negative-200, -16px)"};> *{flex-basis:0;margin-right:${"var(--ds-space-200, 16px)"};margin-top:${"var(--ds-space-100, 8px)"};min-width:${$4cxV2.multiple(27.5).px};flex-grow:1;}`;
const $031b24f7bb93edaf$export$ae0c09a310b3720b = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1pch1g4-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;

});

parcelRegister("3lHwv", function(module, exports) {
$parcel$export(module.exports, "ActionBarStateless", () => (parcelRequire("ffj9p")).ActionBarStateless);

var $ffj9p = parcelRequire("ffj9p");

});
parcelRegister("ffj9p", function(module, exports) {
$parcel$export(module.exports, "ActionBarStateless", () => $33a6b7b3c0a9a9ec$export$dc910ca71acdb8f0);
/* action-bar-stateless.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $8y05I = parcelRequire("8y05I");

var $gmupc = parcelRequire("gmupc");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("3Gzjf");
var $c9GjT = parcelRequire("c9GjT");

var $jQ8Ro = parcelRequire("jQ8Ro");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $9n5qG = parcelRequire("9n5qG");
const $33a6b7b3c0a9a9ec$export$cc312d5a7378bea1 = 'Help Centers customize page layout';
const $33a6b7b3c0a9a9ec$export$dc910ca71acdb8f0 = ({ isPageInBrandingPreviewMode: isPageInBrandingPreviewMode, isPublishing: isPublishing, onPublish: onPublish, onClose: onClose, publishButtonDisabled: publishButtonDisabled, previewButtonDisabled: previewButtonDisabled, children: children, isPageInPreviewMode: isPageInPreviewMode, togglePreviewMode: togglePreviewMode })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    if (isPageInBrandingPreviewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($33a6b7b3c0a9a9ec$var$ActionsWrapper, {
        isPageInBrandingPreviewMode: isPageInBrandingPreviewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c9GjT.BrandingPreviewBanner), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($33a6b7b3c0a9a9ec$var$ActionsWrapper, {
        id: "advance-customization-action-bar",
        isPageInBrandingPreviewMode: !!isPageInBrandingPreviewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($33a6b7b3c0a9a9ec$var$ButtonContainer, null, !isPageInPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $33a6b7b3c0a9a9ec$var$buttonGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($33a6b7b3c0a9a9ec$var$ButtonWrapper, {
        actionSubjectId: "backToHomePage",
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $9n5qG.default).backToSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gmupc.default), {
        showIcon: true,
        showTypeField: true,
        featureName: $33a6b7b3c0a9a9ec$export$cc312d5a7378bea1,
        buttonLabel: (0, $9n5qG.default).giveFeedback,
        analyticsSubjectId: "customizePageLayoutFeedbackButton"
    })), isPageInPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($33a6b7b3c0a9a9ec$var$PreviewButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jQ8Ro.default), {
        appearance: "info",
        title: formatMessage((0, $9n5qG.default).previewMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($33a6b7b3c0a9a9ec$var$ButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.Button), {
        isDisabled: previewButtonDisabled,
        actionSubjectId: "preview",
        appearance: "default",
        onClick: togglePreviewMode
    }, isPageInPreviewMode ? formatMessage((0, $9n5qG.default).exitPreview) : formatMessage((0, $9n5qG.default).preview)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($33a6b7b3c0a9a9ec$var$ActionButton, {
        appearance: "primary",
        actionSubjectId: "publish",
        isDisabled: publishButtonDisabled,
        onClick: onPublish,
        isLoading: isPublishing
    }, formatMessage((0, $9n5qG.default).publish)))), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $33a6b7b3c0a9a9ec$var$ButtonWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $8y05I.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_18u0xmi2",
            __cmplp.className
        ])
    });
});
const $33a6b7b3c0a9a9ec$var$ButtonGroup = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $33a6b7b3c0a9a9ec$var$buttonGroup = (0, $37U6z.xcss)({
    display: 'flex',
    flexDirection: 'row',
    gap: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $33a6b7b3c0a9a9ec$var$ActionButton = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $8y05I.LoadingButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $33a6b7b3c0a9a9ec$var$ActionsWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPageInBrandingPreviewMode: isPageInBrandingPreviewMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt46hdp _154iidpf _1ltvidpf _1bsb1osq _kqsw1if8 _16qsfihs _vchhusvi _1pbyaft6",
            __cmplp.isPageInBrandingPreviewMode ? "_bfhkb7r6" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $33a6b7b3c0a9a9ec$var$ButtonContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $33a6b7b3c0a9a9ec$var$PreviewButtonWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _lcxvglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8y05I", function(module, exports) {
$parcel$export(module.exports, "Button", () => $58442264fc14793e$export$353f5b6fc5456de1);
$parcel$export(module.exports, "IconButton", () => $58442264fc14793e$export$c25acd513dcc8062);
$parcel$export(module.exports, "LoadingButton", () => $58442264fc14793e$export$4ec83e90d030b2f3);
$parcel$export(module.exports, "ThemedButton", () => $58442264fc14793e$export$f67fb575035cc7d0);

var $8P7DW = parcelRequire("8P7DW");

var $8gu7I = parcelRequire("8gu7I");

var $ifRQf = parcelRequire("ifRQf");

var $iFxfe = parcelRequire("iFxfe");

var $5l93E = parcelRequire("5l93E");

var $lRscM = parcelRequire("lRscM");
const $58442264fc14793e$export$353f5b6fc5456de1 = /*#__PURE__*/ $8P7DW.memo(/*#__PURE__*/ $8P7DW.forwardRef(function Button({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $8P7DW.createElement((0, $ifRQf.default), {
        ...props,
        ref: ref
    }));
}));
const $58442264fc14793e$export$c25acd513dcc8062 = /*#__PURE__*/ $8P7DW.memo(/*#__PURE__*/ $8P7DW.forwardRef(function IconButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $8P7DW.createElement((0, $lRscM.default), {
        ...props,
        ref: ref
    }));
}));
const $58442264fc14793e$export$4ec83e90d030b2f3 = /*#__PURE__*/ $8P7DW.memo(/*#__PURE__*/ $8P7DW.forwardRef(function LoadingButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $8P7DW.createElement((0, $5l93E.default), {
        ...props,
        ref: ref
    }));
}));
const $58442264fc14793e$export$f67fb575035cc7d0 = /*#__PURE__*/ $8P7DW.memo(/*#__PURE__*/ $8P7DW.forwardRef(function ThemedButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iFxfe.default), {
        ...props,
        ref: ref
    }));
}));

});
parcelRegister("5l93E", function(module, exports) {
$parcel$export(module.exports, "default", () => $abd9dadf69604df7$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $ifRQf = parcelRequire("ifRQf");

var $jO3zI = parcelRequire("jO3zI");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $abd9dadf69604df7$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jO3zI.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$abd9dadf69604df7$var$LoadingButton.displayName = 'LoadingButton';
var $abd9dadf69604df7$export$2e2bcd8739ae039 = $abd9dadf69604df7$var$LoadingButton;

});


parcelRegister("gmupc", function(module, exports) {
$parcel$export(module.exports, "default", () => $52a2a619037ad446$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $6p5HB = parcelRequire("6p5HB");

var $l4a5B = parcelRequire("l4a5B");
parcelRequire("64xva");
var $7kWEW = parcelRequire("7kWEW");
parcelRequire("fID7x");
var $h7rWn = parcelRequire("h7rWn");

var $hrPHR = parcelRequire("hrPHR");

var $6bYwY = parcelRequire("6bYwY");
const $52a2a619037ad446$var$selector = (0, $ehscL.createSelector)((0, $h7rWn.getFlags), (0, $hrPHR.getEnv), (flags, env)=>({
        flags: flags,
        env: env.environment
    }));
const $52a2a619037ad446$var$mapDispatchToProps = {
    showFeedbackCollector: $7kWEW.showFeedbackCollector,
    dismissFlag: $6p5HB.dismissFlag
};
var $52a2a619037ad446$export$2e2bcd8739ae039 = (0, $jvoWT.default)($52a2a619037ad446$var$selector, $52a2a619037ad446$var$mapDispatchToProps)((0, $l4a5B.default)((0, $6bYwY.FeedbackCollectorButton)));

});
parcelRegister("6bYwY", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollectorButton", () => $03b05ae2da3b8547$export$b39479f42d974760);

var $8P7DW = parcelRequire("8P7DW");

var $8y05I = parcelRequire("8y05I");

var $jShty = parcelRequire("jShty");

var $3EfHm = parcelRequire("3EfHm");

var $bKNUr = parcelRequire("bKNUr");
const $03b05ae2da3b8547$export$b39479f42d974760 = ({ intl: intl, env: env, flags: flags, showIcon: showIcon, featureName: featureName, showTypeField: showTypeField, buttonLabel: buttonLabel, analyticsSubjectId: analyticsSubjectId, dismissFlagMessage: dismissFlagMessage, dismissFlag: dismissFlag, showFeedbackCollector: showFeedbackCollector, appearance: appearance = 'subtle', spacing: spacing = 'default', useTheme: useTheme = false, useSideNavButton: useSideNavButton = false })=>{
    const openFeedbackCollector = $8P7DW.useCallback(()=>{
        const showFeedbackCollectorPayload = {
            env: env,
            showTypeField: showTypeField,
            featureName: featureName,
            shouldOpenFeedbackWidget: true
        };
        if (dismissFlagMessage) {
            const successFlag = flags.filter(// @ts-ignore TS(2532) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Object is possibly 'undefined'.
            (flag)=>flag.titleMessage.defaultMessage.localeCompare(dismissFlagMessage.defaultMessage) === 0)[0];
            successFlag && dismissFlag(successFlag.id);
        }
        showFeedbackCollector(showFeedbackCollectorPayload);
    }, [
        env,
        showTypeField,
        featureName,
        dismissFlagMessage,
        flags,
        dismissFlag,
        showFeedbackCollector
    ]);
    if (useSideNavButton) return /*#__PURE__*/ $8P7DW.createElement((0, $bKNUr.default), {
        iconBefore: showIcon ? /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3EfHm))), {
            spacing: "spacious",
            label: ""
        }) : undefined,
        onClick: openFeedbackCollector
    }, intl.formatMessage(buttonLabel));
    const ButtonComponent = useTheme ? (0, $jShty.ThemedButton) : (0, $8y05I.Button);
    return /*#__PURE__*/ $8P7DW.createElement(ButtonComponent, {
        iconBefore: showIcon ? /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3EfHm))), {
            spacing: "spacious",
            label: "feedback"
        }) : undefined,
        appearance: appearance,
        onClick: openFeedbackCollector,
        actionSubjectId: analyticsSubjectId,
        spacing: spacing
    }, intl.formatMessage(buttonLabel));
};

});
parcelRegister("jShty", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $aa2de371afae7d8a$export$f67fb575035cc7d0);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $8y05I = parcelRequire("8y05I");

var $9fYaQ = parcelRequire("9fYaQ");

var $je3Qr = parcelRequire("je3Qr");
const $aa2de371afae7d8a$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $2UsNA.withTheme)(({ innerRef: innerRef, ...props })=>/*#__PURE__*/ $8P7DW.createElement((0, $8y05I.ThemedButton), {
        ...props,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, ...styles } = currentTheme(themeProps);
            let customTheme;
            if (props.appearance === 'primary' && !props.isDisabled) {
                const backgroundColor = {
                    default: props.theme.color,
                    focus: props.theme.color,
                    hover: (0, $9fYaQ.lighten)(0.05, props.theme.color),
                    active: (0, $9fYaQ.darken)(0.05, props.theme.color)
                };
                customTheme = {
                    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    // Suppressing existing violation. Please fix this.
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    backgroundColor: props.overrideThemeColor || backgroundColor[themeProps.state],
                    color: `${props.theme.readableTextColor} !important` // we need to add !important here for buttons with the href attribute
                };
            }
            if (props.appearance === 'link') {
                const primaryColor = props.overrideThemeColor || props.theme.color;
                const generatedThemeVariations = (0, $je3Qr.generateThemeBranding)(primaryColor);
                customTheme = {
                    color: `${generatedThemeVariations.color900} !important`
                };
            }
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...customTheme
                },
                ...styles
            };
        }
    }));

});

parcelRegister("bKNUr", function(module, exports) {
$parcel$export(module.exports, "default", () => $84d8d583e4e9de5f$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $6vx98 = parcelRequire("6vx98");

var $ivYWB = parcelRequire("ivYWB");
const $84d8d583e4e9de5f$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhksm61 _1a391k8s _racp1k8s _30l3azsu _irr31dpa _ppn2azsu _183jfcek",
    selectedStyles: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g"
};
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $84d8d583e4e9de5f$var$ButtonItem = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $ivYWB.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6vx98.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8n1kL.default)([
            $84d8d583e4e9de5f$var$styles.root,
            props.isSelected && $84d8d583e4e9de5f$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $84d8d583e4e9de5f$export$2e2bcd8739ae039 = $84d8d583e4e9de5f$var$ButtonItem;

});
parcelRegister("6vx98", function(module, exports) {
$parcel$export(module.exports, "default", () => $6181972cb6eb3486$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $9uKqY = parcelRequire("9uKqY");

var $cA7Yr = parcelRequire("cA7Yr");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $6181972cb6eb3486$var$ButtonItem = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $8P7DW.useContext)((0, $9uKqY.default));
    const handleClick = (0, $8P7DW.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cA7Yr.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $gWgPx.jsx)("button", {
                "data-testid": testId,
                // This is intentionally placed before the `...rest` spread to prevent overriding existing usages of `aria-current`,
                // which are already being passed to the button element.
                "aria-current": isSelected ? 'true' : undefined,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            })
    });
}));
var $6181972cb6eb3486$export$2e2bcd8739ae039 = $6181972cb6eb3486$var$ButtonItem;

});
parcelRegister("cA7Yr", function(module, exports) {
$parcel$export(module.exports, "default", () => $610d097c5561fb33$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $iPrfN = parcelRequire("iPrfN");

var $kFogY = parcelRequire("kFogY");
const $610d097c5561fb33$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        ...props
    });
const $610d097c5561fb33$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g"
};
const $610d097c5561fb33$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
const $610d097c5561fb33$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $610d097c5561fb33$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $8P7DW.useContext)((0, $kFogY.SpacingContext));
    const selectionStyle = (0, $8P7DW.useContext)((0, $kFogY.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $8n1kL.default)([
                (0, $8n1kL.default)([
                    $610d097c5561fb33$var$styles.root,
                    $610d097c5561fb33$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $610d097c5561fb33$var$styles.unselected,
                    !isDisabled && isSelected && $610d097c5561fb33$var$styles.selected,
                    !isDisabled && isSelected && $610d097c5561fb33$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $610d097c5561fb33$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $610d097c5561fb33$var$styles.selectedNotch,
                    isDisabled && $610d097c5561fb33$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $610d097c5561fb33$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`,
                children: [
                    iconBefore && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && `${testId}--icon-before`,
                        className: (0, $8n1kL.default)([
                            $610d097c5561fb33$var$styles.beforeAfterElement
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                        className: (0, $8n1kL.default)([
                            $610d097c5561fb33$var$styles.content
                        ]),
                        children: [
                            $610d097c5561fb33$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, $8n1kL.default)([
                                    $610d097c5561fb33$var$styles.title,
                                    shouldTitleWrap ? $610d097c5561fb33$var$styles.wordBreak : $610d097c5561fb33$var$styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                                "data-item-description": true,
                                className: (0, $8n1kL.default)([
                                    $610d097c5561fb33$var$styles.description,
                                    isDisabled && $610d097c5561fb33$var$styles.disabledDescription,
                                    shouldDescriptionWrap && $610d097c5561fb33$var$styles.wordBreak,
                                    !shouldDescriptionWrap && $610d097c5561fb33$var$styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && `${testId}--icon-after`,
                        className: (0, $8n1kL.default)([
                            $610d097c5561fb33$var$styles.beforeAfterElement
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    })();
};
var $610d097c5561fb33$export$2e2bcd8739ae039 = $610d097c5561fb33$var$MenuItemPrimitive;

});
parcelRegister("kFogY", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $930d2c2e4481c1d3$export$443076ec7ebce042);
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $930d2c2e4481c1d3$export$9ca534b70725964d);

var $8P7DW = parcelRequire("8P7DW");
const $930d2c2e4481c1d3$export$443076ec7ebce042 = /*#__PURE__*/ (0, $8P7DW.createContext)('cozy');
const $930d2c2e4481c1d3$export$9ca534b70725964d = /*#__PURE__*/ (0, $8P7DW.createContext)('border');

});



parcelRegister("ivYWB", function(module, exports) {
$parcel$export(module.exports, "useShouldNestedElementRender", () => $553033f9ae21a4e7$export$37e8646a1abfc3e6);

var $8P7DW = parcelRequire("8P7DW");

var $fqy5e = parcelRequire("fqy5e");
const $553033f9ae21a4e7$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $8P7DW.useContext)((0, $fqy5e.NestedContext));
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});
parcelRegister("fqy5e", function(module, exports) {
$parcel$export(module.exports, "NestedContext", () => $ce04eb6e7eb24fa7$export$46b2c2071c8c725a);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $8P7DW = parcelRequire("8P7DW");
const $ce04eb6e7eb24fa7$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);

});





parcelRegister("3Gzjf", function(module, exports) {
$parcel$export(module.exports, "BrandingPreviewBanner", () => (parcelRequire("c9GjT")).BrandingPreviewBanner);

var $c9GjT = parcelRequire("c9GjT");

});
parcelRegister("c9GjT", function(module, exports) {
$parcel$export(module.exports, "BrandingPreviewBanner", () => $de3bf71e4e08b765$export$f6521d01859545a5);
/* branding-preview-banner.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $5jYgE = parcelRequire("5jYgE");

var $elt7A = parcelRequire("elt7A");

var $9VErS = parcelRequire("9VErS");
const $de3bf71e4e08b765$export$f6521d01859545a5 = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($de3bf71e4e08b765$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($de3bf71e4e08b765$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elt7A))), {
        label: "watch-icon",
        size: "small",
        spacing: "compact"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("span", null, formatMessage((0, $9VErS.default).brandingPreviewText)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $de3bf71e4e08b765$var$Wrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt412x7 _1e0c1txw _1bah1h6o _syaz15cr",
            __cmplp.className
        ])
    });
});
const $de3bf71e4e08b765$var$IconWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt4otz2 _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("elt7A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4381d46d56f0396feef6421a091c8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7199dbdd57c3cb6$var$_react = $a7199dbdd57c3cb6$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $a7199dbdd57c3cb6$var$_baseNew = $a7199dbdd57c3cb6$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $a7199dbdd57c3cb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7199dbdd57c3cb6$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $a7199dbdd57c3cb6$var$_react.default.createElement($a7199dbdd57c3cb6$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$a7199dbdd57c3cb6$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $a7199dbdd57c3cb6$var$_default = module.exports.default = $a7199dbdd57c3cb6$var$EyeOpenIcon;

});

parcelRegister("9VErS", function(module, exports) {
$parcel$export(module.exports, "default", () => $fac774ccc0cf41fd$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $fac774ccc0cf41fd$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    brandingPreviewText: {
        defaultMessage: 'You are currently previewing your global branding changes',
        description: 'Global Branding Preview Banner Text',
        id: 'cv.branding.preview.banner.text.non-final'
    }
});

});



parcelRegister("jQ8Ro", function(module, exports) {
$parcel$export(module.exports, "default", () => $514182acbb624a8c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $fnhqr = parcelRequire("fnhqr");

var $c2L1U = parcelRequire("c2L1U");

var $2CGHX = parcelRequire("2CGHX");
var $iPrfN = parcelRequire("iPrfN");
var $bgvtM = parcelRequire("bgvtM");
var $9pb7J = parcelRequire("9pb7J");

var $j6BMy = parcelRequire("j6BMy");
const $514182acbb624a8c$var$styles = {
    contentStyles: "_1reo1wug _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _p12flti4 _c71llti4",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _y2mv1w7i",
    pressableStyles: "_2rko1qi0 _11c8fhey _1rjcze3t _18zrze3t _1e0c116y _bfhksm61 _syazazsu _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $514182acbb624a8c$var$iconColor = {
    connectivity: "_x5v91ft0",
    confirmation: "_x5v94pcx",
    info: "_x5v9qm1h",
    warning: "_x5v9ervl",
    error: "_x5v9s4qr"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $514182acbb624a8c$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $8P7DW.useState)(false);
    const id = (0, $fnhqr.useId)();
    const toggleDialog = (0, $8P7DW.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $8P7DW.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            $514182acbb624a8c$var$styles.rootStyles,
            $514182acbb624a8c$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $c2L1U.default), {
            onClose: onCloseDialog,
            content: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                    xcss: $514182acbb624a8c$var$styles.contentStyles,
                    children: children
                }),
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--popup`,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $bgvtM.default), {
                    ...triggerProps,
                    ref: ref,
                    id: id,
                    "data-ds--inline-message--button": true,
                    onClick: toggleDialog,
                    testId: testId && `${testId}--button`,
                    xcss: $514182acbb624a8c$var$styles.pressableStyles,
                    "aria-expanded": isOpen,
                    children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
                        as: "span",
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $j6BMy.default), {
                                isOpen: isOpen,
                                appearance: appearance,
                                label: iconLabel,
                                spacing: spacing
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
                                as: "span",
                                space: "space.100",
                                children: [
                                    title && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                                        weight: "medium",
                                        testId: testId && `${testId}--title`,
                                        children: title
                                    }),
                                    secondaryText && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                                        weight: "medium",
                                        color: "color.text.subtlest",
                                        maxLines: 1,
                                        testId: testId && `${testId}--text`,
                                        children: secondaryText
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $514182acbb624a8c$export$2e2bcd8739ae039 = $514182acbb624a8c$var$InlineMessage;

});
parcelRegister("c2L1U", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c316d2c991ccd1a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("cqrss")).Popup);

var $cqrss = parcelRequire("cqrss");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0c316d2c991ccd1a$export$2e2bcd8739ae039 = (0, $cqrss.Popup);

});
parcelRegister("cqrss", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $f8f9800ed6ea32eb$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fnhqr = parcelRequire("fnhqr");

var $l8Ymd = parcelRequire("l8Ymd");

var $egphw = parcelRequire("egphw");

var $cBwgz = parcelRequire("cBwgz");

var $e6Qdr = parcelRequire("e6Qdr");

var $2wPsV = parcelRequire("2wPsV");
var $fhoPB = parcelRequire("fhoPB");

var $1NJBM = parcelRequire("1NJBM");

var $2CGHX = parcelRequire("2CGHX");

var $iqi7e = parcelRequire("iqi7e");

var $cwVy8 = parcelRequire("cwVy8");

var $jnXAg = parcelRequire("jnXAg");

var $kVAdJ = parcelRequire("kVAdJ");
const $f8f9800ed6ea32eb$var$defaultLayer = 400;
const $f8f9800ed6ea32eb$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $f8f9800ed6ea32eb$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $8P7DW.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $f8f9800ed6ea32eb$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
    const [triggerRef, setTriggerRef] = (0, $8P7DW.useState)(null);
    const getMergedTriggerRef = (0, $jnXAg.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $kVAdJ.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $fnhqr.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $cwVy8.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $8P7DW.useCallback)(()=>{
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $egphw.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    const renderPopperWrapper = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $l8Ymd.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqi7e.default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $2wPsV.Manager), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fhoPB.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $e6Qdr.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $e6Qdr.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            !(0, $e6Qdr.fg)('platform-dst-motion-uplift') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1NJBM.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            })),
            (0, $e6Qdr.fg)('platform-dst-motion-uplift') && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBwgz.default), {
                children: isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1NJBM.default), {
                    zIndex: zIndex,
                    children: renderPopperWrapper
                }))
            })
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        xcss: $f8f9800ed6ea32eb$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
});

});
parcelRegister("fhoPB", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $b1fbb48440097da6$export$e0be378c32fb70a7);

var $8P7DW = parcelRequire("8P7DW");

var $6gUVR = parcelRequire("6gUVR");

var $2wPsV = parcelRequire("2wPsV");

var $h44BJ = parcelRequire("h44BJ");
function $b1fbb48440097da6$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $8P7DW.useContext((0, $2wPsV.ManagerReferenceNodeSetterContext));
    var refHandler = $8P7DW.useCallback(function(node) {
        (0, $h44BJ.setRef)(innerRef, node);
        (0, $h44BJ.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $8P7DW.useEffect(function() {
        return function() {
            return (0, $h44BJ.setRef)(innerRef, null);
        };
    }, []);
    $8P7DW.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6gUVR)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $h44BJ.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("6gUVR", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $49106643603259a3$var$__DEV__ = false;
var $49106643603259a3$var$warning = function() {};
if ($49106643603259a3$var$__DEV__) {
    var $49106643603259a3$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $49106643603259a3$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $49106643603259a3$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $49106643603259a3$var$warning;

});


parcelRegister("iqi7e", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a46e5b29c9bea21$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $BnUzk = parcelRequire("BnUzk");

var $buhve = parcelRequire("buhve");

var $e6Qdr = parcelRequire("e6Qdr");

var $cenhL = parcelRequire("cenhL");

var $4nY1U = parcelRequire("4nY1U");

var $1Rllc = parcelRequire("1Rllc");

var $8DNK4 = parcelRequire("8DNK4");
const $9a46e5b29c9bea21$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $9a46e5b29c9bea21$var$fullWidthStyles = null;
const $9a46e5b29c9bea21$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    rootT26Shape: "_2rko1mok",
    rootLayer: "_1pby1nn1",
    fullWidth: "_1bsb1osq"
};
const $9a46e5b29c9bea21$var$scrollableStyles = null;
const $9a46e5b29c9bea21$var$blanketStyles = null;
const $9a46e5b29c9bea21$var$modalStyles = null;
const $9a46e5b29c9bea21$var$newModalStyles = null;
const $9a46e5b29c9bea21$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
const $9a46e5b29c9bea21$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
const $9a46e5b29c9bea21$var$DefaultPopupComponent = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: _isReferenceHidden, shouldFitViewport: shouldFitViewport, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8n1kL.default)([
            $9a46e5b29c9bea21$var$wrapperStyles.root,
            (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $9a46e5b29c9bea21$var$wrapperStyles.rootT26Shape,
            appearance === 'UNSAFE_modal-below-sm' && !(0, $e6Qdr.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            appearance === 'UNSAFE_modal-below-sm' && (0, $e6Qdr.fg)('platform_dst_nav4_flyout_menu_slots_close_button') && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: !(0, $e6Qdr.fg)('platform-dst-motion-uplift') ? ref : undefined,
        children: children
    });
});
function $9a46e5b29c9bea21$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
popupComponent: PopupContainer = $9a46e5b29c9bea21$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
    const [popupRef, setPopupRef] = (0, $8P7DW.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $8P7DW.useState)(null);
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $8DNK4.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $1Rllc.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $BnUzk.useLayering)();
    const mergedModifiers = (0, $8P7DW.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cenhL.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
            const popupContainer = /*#__PURE__*/ (0, $gWgPx.jsx)(PopupContainer, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $8n1kL.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, $e6Qdr.fg)('platform-design-system-apply-popup-wrapper-focus') && $9a46e5b29c9bea21$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: !(0, $e6Qdr.fg)('platform-dst-motion-uplift') ? (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                } : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: (0, $e6Qdr.fg)('platform-dst-motion-uplift') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // using tabIndex={-1} would cause a bug where Safari focuses
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                shouldFitViewport: shouldFitViewport,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4nY1U.RepositionOnUpdate), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            const container = /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                // using tabIndex={-1} would cause a bug where Safari focuses
                // first on the browser address bar when using keyboard
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                "data-testid": `${testId}--container`,
                className: (0, $8n1kL.default)([
                    $9a46e5b29c9bea21$var$wrapperStyles.rootLayer,
                    shouldFitContainer && $9a46e5b29c9bea21$var$wrapperStyles.fullWidth
                ]),
                children: placement === 'auto' || placement === 'auto-start' || placement === 'auto-end' ? popupContainer : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $buhve.default), {
                    enteringAnimation: $9a46e5b29c9bea21$var$placementMap[placement].enter,
                    exitingAnimation: $9a46e5b29c9bea21$var$placementMap[placement].exit,
                    children: popupContainer
                })
            });
            return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
                children: [
                    (0, $e6Qdr.fg)('platform-dst-motion-uplift') ? container : popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        className: (0, $8n1kL.default)([
                            "_1r04idpf _kqsw1n9t _bfhk1i5c"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9a46e5b29c9bea21$export$2e2bcd8739ae039 = $9a46e5b29c9bea21$var$PopperWrapper;

});
parcelRegister("4nY1U", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $ed880d7b3f4ceda8$export$51eddd7655ca235a);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $ed880d7b3f4ceda8$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $8P7DW.useRef)(true);
    (0, $8P7DW.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Fragment), {
        children: children
    });
};

});

parcelRegister("1Rllc", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $26de0f54d7d4e6ad$export$92dae2778ae88f9d);

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $5J6r2 = parcelRequire("5J6r2");

var $BnUzk = parcelRequire("BnUzk");

var $e6Qdr = parcelRequire("e6Qdr");

var $fp1aI = parcelRequire("fp1aI");

var $liwZj = parcelRequire("liwZj");
const $26de0f54d7d4e6ad$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $BnUzk.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $liwZj.useAnimationFrame)();
    const mouseDownTarget = (0, $8P7DW.useRef)(null);
    (0, $8P7DW.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $5J6r2.default;
        const closePopup = (event)=>{
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    currentLevel = ((_event$target$closest = event.target.closest(`[data-ds--level]`)) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level')) ?? null;
                }
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $e6Qdr.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    const layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, `[data-ds--level]`);
                    if (layeredElement) {
                        const closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $fp1aI.isInteractiveElement)(document.activeElement) && (0, $e6Qdr.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            const key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $e6Qdr.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                const eventTarget = event.target instanceof HTMLElement ? event.target : null;
                const layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                const levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $e6Qdr.fg)('platform_dst_popup-disable-focuslock')) {
                const { shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let unbind = (0, $5J6r2.default);
        if ((0, $e6Qdr.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $36kyW.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $36kyW.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $5J6r2.default);
        unbindBlur = (0, $36kyW.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $e6Qdr.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("fp1aI", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $3da7e141ba8a352c$export$3dee5e4542c672d9);
const $3da7e141ba8a352c$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $3da7e141ba8a352c$export$3dee5e4542c672d9 = (element)=>{
    if ($3da7e141ba8a352c$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("liwZj", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $2fad7f8b40082ef3$export$641fa9c94086b46e);

var $8P7DW = parcelRequire("8P7DW");
const $2fad7f8b40082ef3$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $8P7DW.useRef)([]);
    const requestFrame = (0, $8P7DW.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $8P7DW.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $8P7DW.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("8DNK4", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $8c9fa345778c4e1e$export$10c5169755ce7bd7);

var $8P7DW = parcelRequire("8P7DW");

var $00AQ5 = parcelRequire("00AQ5");

var $5J6r2 = parcelRequire("5J6r2");

var $BnUzk = parcelRequire("BnUzk");

var $e6Qdr = parcelRequire("e6Qdr");

var $liwZj = parcelRequire("liwZj");
const $8c9fa345778c4e1e$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $liwZj.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $BnUzk.useLayering)();
    (0, $8P7DW.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $5J6r2.default;
        if (shouldDisableFocusTrap && (0, $e6Qdr.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $5J6r2.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $e6Qdr.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($00AQ5)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});
parcelRegister("00AQ5", function(module, exports) {

var $2KLmu = parcelRequire("2KLmu");
var $000075febb53f660$var$listeningFocusTrap = null;
function $000075febb53f660$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $000075febb53f660$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($000075febb53f660$var$listeningFocusTrap) $000075febb53f660$var$listeningFocusTrap.pause();
        $000075febb53f660$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        $000075febb53f660$var$tryFocus(firstFocusNode());
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $000075febb53f660$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $000075febb53f660$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $000075febb53f660$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $000075febb53f660$var$tryFocus(lastTabbableNode);
            return $000075febb53f660$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $000075febb53f660$var$tryFocus(firstTabbableNode);
        $000075febb53f660$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $2KLmu(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $000075febb53f660$var$tryFocus(lastTabbableNode);
        $000075febb53f660$var$tryFocus(firstTabbableNode);
    }
}
function $000075febb53f660$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $000075febb53f660$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $000075febb53f660$var$focusTrap;

});
parcelRegister("2KLmu", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $20149db07b385e09$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $20149db07b385e09$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});




parcelRegister("cwVy8", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $27ef06e00fa4c6cc$export$4065aef1d79a5730);

var $8P7DW = parcelRequire("8P7DW");

var $6JY8y = parcelRequire("6JY8y");
function $27ef06e00fa4c6cc$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const mq = (0, $6JY8y.UNSAFE_useMediaQuery)('below.sm', (e)=>{
        setIsSmallViewport(!!e.matches);
    });
    const [isSmallViewport, setIsSmallViewport] = (0, $8P7DW.useState)(!!(mq !== null && mq !== void 0 && mq.matches));
    const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("6JY8y", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $67eaf51e68e06a60$export$49e55ae2c03d6045);

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $15YGb = parcelRequire("15YGb");
var $67eaf51e68e06a60$var$_window, $67eaf51e68e06a60$var$_window$matchMedia, $67eaf51e68e06a60$var$_window2, $67eaf51e68e06a60$var$_window2$matchMedia, $67eaf51e68e06a60$var$_window3, $67eaf51e68e06a60$var$_window3$matchMedia, $67eaf51e68e06a60$var$_window4, $67eaf51e68e06a60$var$_window4$matchMedia, $67eaf51e68e06a60$var$_window5, $67eaf51e68e06a60$var$_window5$matchMedia, $67eaf51e68e06a60$var$_window6, $67eaf51e68e06a60$var$_window6$matchMedia, $67eaf51e68e06a60$var$_window7, $67eaf51e68e06a60$var$_window7$matchMedia, $67eaf51e68e06a60$var$_window8, $67eaf51e68e06a60$var$_window8$matchMedia, $67eaf51e68e06a60$var$_window9, $67eaf51e68e06a60$var$_window9$matchMedia, $67eaf51e68e06a60$var$_window0, $67eaf51e68e06a60$var$_window0$matchMedia, $67eaf51e68e06a60$var$_window1, $67eaf51e68e06a60$var$_window1$matchMedia;
const $67eaf51e68e06a60$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window = window) === null || $67eaf51e68e06a60$var$_window === void 0 || ($67eaf51e68e06a60$var$_window$matchMedia = $67eaf51e68e06a60$var$_window.matchMedia) === null || $67eaf51e68e06a60$var$_window$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window$matchMedia.call($67eaf51e68e06a60$var$_window, (0, $15YGb.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window2 = window) === null || $67eaf51e68e06a60$var$_window2 === void 0 || ($67eaf51e68e06a60$var$_window2$matchMedia = $67eaf51e68e06a60$var$_window2.matchMedia) === null || $67eaf51e68e06a60$var$_window2$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window2$matchMedia.call($67eaf51e68e06a60$var$_window2, (0, $15YGb.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window3 = window) === null || $67eaf51e68e06a60$var$_window3 === void 0 || ($67eaf51e68e06a60$var$_window3$matchMedia = $67eaf51e68e06a60$var$_window3.matchMedia) === null || $67eaf51e68e06a60$var$_window3$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window3$matchMedia.call($67eaf51e68e06a60$var$_window3, (0, $15YGb.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window4 = window) === null || $67eaf51e68e06a60$var$_window4 === void 0 || ($67eaf51e68e06a60$var$_window4$matchMedia = $67eaf51e68e06a60$var$_window4.matchMedia) === null || $67eaf51e68e06a60$var$_window4$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window4$matchMedia.call($67eaf51e68e06a60$var$_window4, (0, $15YGb.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window5 = window) === null || $67eaf51e68e06a60$var$_window5 === void 0 || ($67eaf51e68e06a60$var$_window5$matchMedia = $67eaf51e68e06a60$var$_window5.matchMedia) === null || $67eaf51e68e06a60$var$_window5$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window5$matchMedia.call($67eaf51e68e06a60$var$_window5, (0, $15YGb.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window6 = window) === null || $67eaf51e68e06a60$var$_window6 === void 0 || ($67eaf51e68e06a60$var$_window6$matchMedia = $67eaf51e68e06a60$var$_window6.matchMedia) === null || $67eaf51e68e06a60$var$_window6$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window6$matchMedia.call($67eaf51e68e06a60$var$_window6, (0, $15YGb.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window7 = window) === null || $67eaf51e68e06a60$var$_window7 === void 0 || ($67eaf51e68e06a60$var$_window7$matchMedia = $67eaf51e68e06a60$var$_window7.matchMedia) === null || $67eaf51e68e06a60$var$_window7$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window7$matchMedia.call($67eaf51e68e06a60$var$_window7, (0, $15YGb.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window8 = window) === null || $67eaf51e68e06a60$var$_window8 === void 0 || ($67eaf51e68e06a60$var$_window8$matchMedia = $67eaf51e68e06a60$var$_window8.matchMedia) === null || $67eaf51e68e06a60$var$_window8$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window8$matchMedia.call($67eaf51e68e06a60$var$_window8, (0, $15YGb.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window9 = window) === null || $67eaf51e68e06a60$var$_window9 === void 0 || ($67eaf51e68e06a60$var$_window9$matchMedia = $67eaf51e68e06a60$var$_window9.matchMedia) === null || $67eaf51e68e06a60$var$_window9$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window9$matchMedia.call($67eaf51e68e06a60$var$_window9, (0, $15YGb.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window0 = window) === null || $67eaf51e68e06a60$var$_window0 === void 0 || ($67eaf51e68e06a60$var$_window0$matchMedia = $67eaf51e68e06a60$var$_window0.matchMedia) === null || $67eaf51e68e06a60$var$_window0$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window0$matchMedia.call($67eaf51e68e06a60$var$_window0, (0, $15YGb.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($67eaf51e68e06a60$var$_window1 = window) === null || $67eaf51e68e06a60$var$_window1 === void 0 || ($67eaf51e68e06a60$var$_window1$matchMedia = $67eaf51e68e06a60$var$_window1.matchMedia) === null || $67eaf51e68e06a60$var$_window1$matchMedia === void 0 ? void 0 : $67eaf51e68e06a60$var$_window1$matchMedia.call($67eaf51e68e06a60$var$_window1, (0, $15YGb.media).below.xl.replace('@media ', '').trim())
};
const $67eaf51e68e06a60$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $8P7DW.useRef)(listener);
    (0, $8P7DW.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $67eaf51e68e06a60$var$queries[queryString];
    (0, $8P7DW.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $36kyW.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("15YGb", function(module, exports) {
$parcel$export(module.exports, "media", () => $4dc0740022bb27e0$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $4dc0740022bb27e0$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("jnXAg", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $00ad399a7895d59f$export$7cc5c058dd769dff);

var $8P7DW = parcelRequire("8P7DW");

var $hXXvg = parcelRequire("hXXvg");
const $00ad399a7895d59f$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $8P7DW.useState)(()=>(0, $hXXvg.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("kVAdJ", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $7ea415b712b90045$export$5d3a2de79e07b376);

var $8P7DW = parcelRequire("8P7DW");

var $hXXvg = parcelRequire("hXXvg");
const $7ea415b712b90045$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $8P7DW.useState)(()=>(0, $hXXvg.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("j6BMy", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d64213f3254966b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $b3usr = parcelRequire("b3usr");
const $2d64213f3254966b$var$iconColor = {
    connectivity: "_syaz1ft0",
    confirmation: "_syaz4pcx",
    info: "_syazqm1h",
    warning: "_syazervl",
    error: "_syazs4qr"
};
const $2d64213f3254966b$var$iconWrapperStyles = null;
const $2d64213f3254966b$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $2d64213f3254966b$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $b3usr.typesMapping);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $8n1kL.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o",
            $2d64213f3254966b$var$iconColor[appearance],
            isOpen && "_syaz1kum"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            spacing: spacing
        })
    });
};
var $2d64213f3254966b$export$2e2bcd8739ae039 = $2d64213f3254966b$var$SelectedIcon;

});
parcelRegister("b3usr", function(module, exports) {
$parcel$export(module.exports, "typesMapping", () => $86b2e00ce0687ffc$export$4d111645c0b39d5d);

var $h82Rb = parcelRequire("h82Rb");

var $ebnVy = parcelRequire("ebnVy");

var $joUCG = parcelRequire("joUCG");

var $gKWTh = parcelRequire("gKWTh");
const $86b2e00ce0687ffc$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKWTh))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($joUCG))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebnVy))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKWTh))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("9n5qG", function(module, exports) {
$parcel$export(module.exports, "default", () => $79f04d5c1f5432b0$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $79f04d5c1f5432b0$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    backToSettings: {
        defaultMessage: 'Cancel',
        description: 'Action label for back button in layout builder screen',
        id: 'cv.portal.customization.action.cancel.help.center.settings'
    },
    giveFeedback: {
        defaultMessage: 'Give feedback',
        description: 'The text for give feedback button for layout builder screen',
        id: 'cv.portal.customization.action.give.feedback.help.center.settings'
    },
    publish: {
        defaultMessage: 'Publish',
        description: 'Label for publish button',
        id: 'cv.portal.customization.action.publish.layout.label'
    },
    preview: {
        defaultMessage: 'Preview',
        description: 'Label for preview button',
        id: 'cv.portal.customization.action.preview.layout.label'
    },
    previewMessage: {
        defaultMessage: 'This is a preview of the changes you made to the page layout.',
        description: 'Message displayed when user is previewing layout changes',
        id: 'cv.portal.customization.action.preview.layout.message'
    },
    exitPreview: {
        defaultMessage: 'Back',
        description: 'Label for exit preview button',
        id: 'cv.portal.customization.action.exit.preview.layout.label'
    }
});

});




parcelRegister("kT9oZ", function(module, exports) {
$parcel$export(module.exports, "ViewHomepageResource", () => $2356c49a09c7475b$export$6527e8b974db86ba);
$parcel$export(module.exports, "searchComponentVirtualAgentResource", () => $2356c49a09c7475b$export$b92a87df2da13e74);
$parcel$export(module.exports, "knowledgeCardsResource", () => $2356c49a09c7475b$export$ce8dea937649cc84);

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $6EUuB = parcelRequire("6EUuB");

var $hdLj1 = parcelRequire("hdLj1");

var $bnS5P = parcelRequire("bnS5P");

var $1EFS8 = parcelRequire("1EFS8");

var $e6Qdr = parcelRequire("e6Qdr");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $byuiX = parcelRequire("byuiX");

var $gvmEi = parcelRequire("gvmEi");

var $7w67y = parcelRequire("7w67y");
const $2356c49a09c7475b$export$6527e8b974db86ba = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) ? (0, $byuiX.createRelayResource)({
    type: 'VIEW_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $hdLj1.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}) : (0, $byuiX.createRelayResource)({
    type: 'VIEW_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $6EUuB.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $2356c49a09c7475b$export$b92a87df2da13e74 = (0, $e6Qdr.fg)('helpcenter_search_api_changes') ? (0, $byuiX.createRelayResource)({
    type: 'HELP_CENTER_SEARCH_VIRTUAL_AGENT',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, isUserLoggedIn: isUserLoggedIn })=>{
        const isLoggedIn = (0, $1EFS8.default).checkGate('jsd-search-router-login-logic-removal') ? Boolean((0, $jByYr.getMeta)('ajs-atlassian-account-id')) : isUserLoggedIn;
        return {
            parameters: (0, $7w67y.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                isVaOnHcGAEnabled: (0, $HGACo.isVAOnHelpCenterGAEnabled)() && isLoggedIn
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}) : (0, $byuiX.createRelayResource)({
    type: 'HELP_CENTER_SEARCH_VIRTUAL_AGENT',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, isUserLoggedIn: isUserLoggedIn })=>{
        const isLoggedIn = (0, $1EFS8.default).checkGate('jsd-search-router-login-logic-removal') ? Boolean((0, $jByYr.getMeta)('ajs-atlassian-account-id')) : isUserLoggedIn;
        return {
            parameters: (0, $bnS5P.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                isVaOnHcGAEnabled: (0, $HGACo.isVAOnHelpCenterGAEnabled)() && isLoggedIn
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $2356c49a09c7475b$var$MAX_ITEMS_PER_PAGE = 9;
const $2356c49a09c7475b$var$SELECTED_CONTENT_TYPE = 'FOLDER';
const $2356c49a09c7475b$export$ce8dea937649cc84 = (0, $byuiX.createRelayResource)({
    type: 'KNOWLEDGE_CARDS',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $gvmEi.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                first: $2356c49a09c7475b$var$MAX_ITEMS_PER_PAGE,
                input: {
                    contentTypes: [
                        $2356c49a09c7475b$var$SELECTED_CONTENT_TYPE
                    ],
                    topLevelArticlesOnly: true
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("6EUuB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca0da3d185987a7d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad13935a0e593ac5f50550f6657a2215>>
 * @relayHash fa719725403f4bc1ff9fcf3963fd7531
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b26287f48d375f663a90706c430c6c76696991a26001b463cbad9ab4ffac35a7
const $ca0da3d185987a7d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterAnnouncements",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canEditHomePageAnnouncement"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v17 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v18 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v19 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v14 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v24 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewHomepageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            v10 /*: any*/ ,
                                            v7 /*: any*/ 
                                        ],
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "helpLayout.layout"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewHomepageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v10 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v10 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v11 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b26287f48d375f663a90706c430c6c76696991a26001b463cbad9ab4ffac35a7",
            "metadata": {},
            "name": "viewHomepageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ca0da3d185987a7d$var$node.hash = "2bcab35a024f85aecee6a272f8d5db60";
var $ca0da3d185987a7d$export$2e2bcd8739ae039 = $ca0da3d185987a7d$var$node;

});

parcelRegister("hdLj1", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f083de7e264f37e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<968c862a199577167462936270256f63>>
 * @relayHash 8b0f29d54437fd2608fdac24f24a6af5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13e1ecc5af939dd54aa03c79aac2b2aa7db3ef2beb857285f1e5e3f08aecbbd0
const $3f083de7e264f37e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterAnnouncements",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canEditHomePageAnnouncement"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v17 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v18 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v19 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v14 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v24 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewHomepageForCsmQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            v10 /*: any*/ ,
                                            v7 /*: any*/ 
                                        ],
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "helpLayout.layout"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewHomepageForCsmQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v10 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v10 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v11 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "13e1ecc5af939dd54aa03c79aac2b2aa7db3ef2beb857285f1e5e3f08aecbbd0",
            "metadata": {},
            "name": "viewHomepageForCsmQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3f083de7e264f37e$var$node.hash = "28f3627fe858658455d724b7497a4521";
var $3f083de7e264f37e$export$2e2bcd8739ae039 = $3f083de7e264f37e$var$node;

});

parcelRegister("bnS5P", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d604bc677513c4e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50d668b5e0358cbccab3d89c352c8e5d>>
 * @relayHash 8f1826e2b5128402f612ebed9cd3ead7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cef3402a4dba2853f871dc4054dde3db258a73cfca1f1548f7ba65bb695e7773
const $0d604bc677513c4e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVaOnHcGAEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v5 = {
        "condition": "isVaOnHcGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "VirtualAgentQueryApi",
                "kind": "LinkedField",
                "name": "virtualAgent",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "containerId",
                                "variableName": "helpCenterAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "virtualAgentAvailability"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "searchLoaderVirtualAgentEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "searchLoaderVirtualAgentEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        "params": {
            "id": "cef3402a4dba2853f871dc4054dde3db258a73cfca1f1548f7ba65bb695e7773",
            "metadata": {},
            "name": "searchLoaderVirtualAgentEnabledQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0d604bc677513c4e$var$node.hash = "e02588c503555d8e364b2427c266c0f8";
var $0d604bc677513c4e$export$2e2bcd8739ae039 = $0d604bc677513c4e$var$node;

});

parcelRegister("byuiX", function(module, exports) {
$parcel$export(module.exports, "createRelayResource", () => $92b844c6e0626a37$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $92b844c6e0626a37$export$42ca7b248c7aaee);

var $HGACo = parcelRequire("HGACo");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $5U6in = parcelRequire("5U6in");
var $hgkVf = parcelRequire("hgkVf");

var $8iTFq = parcelRequire("8iTFq");

var $gyskF = parcelRequire("gyskF");
const $92b844c6e0626a37$export$1cc887c62079ea32 = ({ type: type, getQuery: getQuery })=>(0, $5U6in.createResource)({
        type: `RELAY_RESOURCE_TYPE_${type}`,
        getKey: (routerContext, customContext)=>{
            const { variables: variables, parameters: parameters, isResourceDisabled: isResourceDisabled = false } = getQuery(routerContext, customContext);
            if ((0, $HGACo.isUiModificationsSupportEnabled)()) {
                if (isResourceDisabled) return 'RELAY_RESOURCE_DISABLED';
            }
            //@ts-ignore this key does not really matter since max-age is set to zero. This util is a polyfill and will be done away with once we adopt Relay entry points.
            const request = (0, $8iTFq.getRequest)(parameters);
            const params = request.params;
            const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            const { variables: variables, parameters: parameters, options: options, isResourceDisabled: isResourceDisabled = false } = getQuery(routerContext, customContext);
            if ((0, $HGACo.isUiModificationsSupportEnabled)()) {
                if (isResourceDisabled) return Promise.resolve(null);
            }
            const queryReference = (0, $h3cOB.loadQuery)((0, $gyskF.getRelayEnvironment)(), parameters, variables || {}, options);
            return Promise.resolve(queryReference);
        },
        maxAge: 0
    });
const $92b844c6e0626a37$export$42ca7b248c7aaee = (resource)=>{
    const { refresh: refresh, data: queryReference } = (0, $hgkVf.useResource)(resource);
    return {
        queryReference: queryReference,
        refresh: refresh
    };
};

});

parcelRegister("gvmEi", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c505970636c0aa0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b6f6dbd1681ca1d42a1ec73be684eec>>
 * @relayHash 10b69689782954059882eb09ef4d57fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5864f7018b462ff3f6fd7d2ad7be4a9770ae48754be56a727be507a5efe02f3d
const $5c505970636c0aa0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v5 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v6 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "contentTypes": [
                    "FOLDER"
                ],
                "topLevelArticlesOnly": true
            }
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainKnowledgeCardsSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "knowledgeCards_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainKnowledgeCardsSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "contentType"
                                                },
                                                {
                                                    "concreteType": "HelpObjectStoreArticleURLInfo",
                                                    "kind": "LinkedField",
                                                    "name": "urlInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shareUrl"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                }
                                            ],
                                            "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "filters": [
                        "helpCenterAri",
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "KnowledgeCards__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "5864f7018b462ff3f6fd7d2ad7be4a9770ae48754be56a727be507a5efe02f3d",
            "metadata": {},
            "name": "mainKnowledgeCardsSearchArticlesForSupportSiteQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5c505970636c0aa0$var$node.hash = "6c76d43cb2ea636092c206f2999e6c64";
var $5c505970636c0aa0$export$2e2bcd8739ae039 = $5c505970636c0aa0$var$node;

});

parcelRegister("7w67y", function(module, exports) {
$parcel$export(module.exports, "default", () => $e320f04cf3f4c7d1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a96e41df1aef4129c92711b4e9bae867>>
 * @relayHash 078d7490b0e32c04c06ec9ee114c1d15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da
const $e320f04cf3f4c7d1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVaOnHcGAEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v5 = {
        "condition": "isVaOnHcGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "VirtualAgentQueryApi",
                "kind": "LinkedField",
                "name": "virtualAgent",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "containerId",
                                "variableName": "helpCenterAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "virtualAgentAvailability"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        "params": {
            "id": "03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da",
            "metadata": {},
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e320f04cf3f4c7d1$var$node.hash = "fb84e9b37fd41dce66a7b8b53fc81357";
var $e320f04cf3f4c7d1$export$2e2bcd8739ae039 = $e320f04cf3f4c7d1$var$node;

});


parcelRegister("d5AiD", function(module, exports) {
$parcel$export(module.exports, "FlexibleEditpageLoader", () => (parcelRequire("hlVBC")).default);

var $hlVBC = parcelRequire("hlVBC");

});
parcelRegister("hlVBC", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d4ae9f4c75960ae$export$2e2bcd8739ae039);
/* flexible-edit-page-loader.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $4O8fD = parcelRequire("4O8fD");

var $aw7IH = parcelRequire("aw7IH");
parcelRequire("3lHwv");
var $ffj9p = parcelRequire("ffj9p");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $4peLG = parcelRequire("4peLG");
const $3d4ae9f4c75960ae$var$SECTION_HEIGHT = 232;
const $3d4ae9f4c75960ae$var$FlexibleEditpageLoader = ({ showActionBar: showActionBar, removeHeader: removeHeader, sectionCount: sectionCount = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
        name: "flexible-edit-page-loader"
    }, showActionBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ffj9p.ActionBarStateless), {
        previewButtonDisabled: true,
        publishButtonDisabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $3d4ae9f4c75960ae$var$container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        as: "main",
        xcss: $3d4ae9f4c75960ae$var$skeletonContainerWithSidebar,
        style: {
            marginRight: '340px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $3d4ae9f4c75960ae$var$layoutBuilderWrapper
    }, !removeHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $3d4ae9f4c75960ae$var$headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
        "data-testid": "flexible-hc-header-skeleton",
        height: (0, $aw7IH.HEADER_HEIGHT),
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), Array(sectionCount).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $3d4ae9f4c75960ae$var$sectionLoader,
            key: `flexibleHCLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            "data-testid": "flexible-hc-section-skeleton",
            height: $3d4ae9f4c75960ae$var$SECTION_HEIGHT,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        as: "aside",
        xcss: $3d4ae9f4c75960ae$var$sidebarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $3d4ae9f4c75960ae$var$breadcrumbContainer
    }, Array(3).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $3d4ae9f4c75960ae$var$breadCrumbItem,
            key: `breadCrumbLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3d4ae9f4c75960ae$var$SidePanelLoader, {
            "data-testid": "flexible-hc-section-skeleton",
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })))), Array(4).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: [
                $3d4ae9f4c75960ae$var$configWrapper,
                index === 0 && $3d4ae9f4c75960ae$var$configWrapper24PxWidth,
                index === 3 && $3d4ae9f4c75960ae$var$configWrapper146PxWidth
            ],
            key: `ConfigPanelLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3d4ae9f4c75960ae$var$SidePanelLoader, {
            "data-testid": "flexible-hc-section-skeleton",
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))))));
};
const $3d4ae9f4c75960ae$var$skeletonContainerWithSidebar = (0, $37U6z.xcss)({
    position: 'relative',
    padding: 'space.150',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: 'elevation.surface.hovered',
    alignItems: 'center',
    overflowY: 'auto',
    height: 'calc(100vh - 56px)'
});
const $3d4ae9f4c75960ae$var$headerContainer = (0, $37U6z.xcss)({
    width: '100%'
});
const $3d4ae9f4c75960ae$var$container = (0, $37U6z.xcss)({
    display: 'flex',
    justifyContent: 'stretch',
    flex: '1 1 auto'
});
const $3d4ae9f4c75960ae$var$sidebarWrapper = (0, $37U6z.xcss)({
    flex: 0,
    position: 'fixed',
    right: 'space.0',
    width: '340px',
    backgroundColor: 'elevation.surface',
    zIndex: 'navigation',
    minHeight: '-webkit-fill-available',
    boxShadow: 'elevation.shadow.overlay',
    height: 'calc(100vh - 56px)'
});
const $3d4ae9f4c75960ae$var$layoutBuilderWrapper = (0, $37U6z.xcss)({
    position: 'relative',
    width: '100%',
    borderRadius: 'radius.large',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised',
    overflow: 'visible'
});
const $3d4ae9f4c75960ae$var$sectionLoader = (0, $37U6z.xcss)({
    padding: 'space.400',
    borderRadius: 'radius.large'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3d4ae9f4c75960ae$var$SidePanelLoader = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $4O8fD.LoadingSkeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $3d4ae9f4c75960ae$var$breadcrumbContainer = (0, $37U6z.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    textAlign: 'left',
    padding: 'space.100',
    borderBottomColor: 'color.border',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid'
});
const $3d4ae9f4c75960ae$var$breadCrumbItem = (0, $37U6z.xcss)({
    width: '84px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    margin: 'space.100'
});
const $3d4ae9f4c75960ae$var$configWrapper = (0, $37U6z.xcss)({
    width: '100%',
    height: 'space.250',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 'space.300',
    paddingBottom: 'space.0'
});
const $3d4ae9f4c75960ae$var$configWrapper24PxWidth = (0, $37U6z.xcss)({
    width: '72px'
});
const $3d4ae9f4c75960ae$var$configWrapper146PxWidth = (0, $37U6z.xcss)({
    width: '194px'
});
var $3d4ae9f4c75960ae$export$2e2bcd8739ae039 = $3d4ae9f4c75960ae$var$FlexibleEditpageLoader;

});


parcelRegister("9QKIl", function(module, exports) {
$parcel$export(module.exports, "anonymousRequestSuccessRoute", () => (parcelRequire("9t02C")).anonymousRequestSuccessRoute);
$parcel$export(module.exports, "getRequestCreateRoute", () => (parcelRequire("9t02C")).getRequestCreateRoute);
$parcel$export(module.exports, "helpCenterRequestFeedbackRoute", () => (parcelRequire("9t02C")).helpCenterRequestFeedbackRoute);
$parcel$export(module.exports, "notFoundErrorRoute", () => (parcelRequire("9t02C")).notFoundErrorRoute);
$parcel$export(module.exports, "NotFoundPage", () => (parcelRequire("9t02C")).NotFoundPage);
$parcel$export(module.exports, "portalReorderRoute", () => (parcelRequire("8kP0u")).portalReorderRoute);
$parcel$export(module.exports, "RenderCreateAnonymousSuccess", () => (parcelRequire("9t02C")).RenderCreateAnonymousSuccess);
$parcel$export(module.exports, "RenderRequestCreateForHubs", () => (parcelRequire("9t02C")).RenderRequestCreateForHubs);
$parcel$export(module.exports, "requestFeedbackRoute", () => (parcelRequire("9t02C")).requestFeedbackRoute);
$parcel$export(module.exports, "unsubscribeRoute", () => (parcelRequire("9t02C")).unsubscribeRoute);
$parcel$export(module.exports, "userProfileRoute", () => (parcelRequire("9t02C")).userProfileRoute);
parcelRequire("9t02C");

});
parcelRegister("9t02C", function(module, exports) {
$parcel$export(module.exports, "RenderRequestCreateForHubs", () => $005835cb69e50406$export$a877efa523a67c07);
$parcel$export(module.exports, "RenderCreateAnonymousSuccess", () => $005835cb69e50406$export$1d1b8e06f48bd2d4);
$parcel$export(module.exports, "userProfileRoute", () => $005835cb69e50406$export$abc0ddbfeed2cc26);
$parcel$export(module.exports, "NotFoundPage", () => $005835cb69e50406$export$31641b61980e511f);
$parcel$export(module.exports, "getRequestCreateRoute", () => $005835cb69e50406$export$b0cc27459efb2ff4);
$parcel$export(module.exports, "anonymousRequestSuccessRoute", () => $005835cb69e50406$export$ea05b9ec1342627e);
$parcel$export(module.exports, "requestFeedbackRoute", () => $005835cb69e50406$export$a3cf9a79f03e97df);
$parcel$export(module.exports, "helpCenterRequestFeedbackRoute", () => $005835cb69e50406$export$45634ebe4da270df);
$parcel$export(module.exports, "unsubscribeRoute", () => $005835cb69e50406$export$7dfcaf0a6ac7c9fe);
$parcel$export(module.exports, "notFoundErrorRoute", () => $005835cb69e50406$export$5443dabb022476b2);
$parcel$export(module.exports, "portalReorderRoute", () => (parcelRequire("8kP0u")).portalReorderRoute);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $4acrp = parcelRequire("4acrp");

var $HGACo = parcelRequire("HGACo");

var $fBOCW = parcelRequire("fBOCW");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
parcelRequire("9i6OK");
var $3szzY = parcelRequire("3szzY");

var $4JEE5 = parcelRequire("4JEE5");

var $gJQFt = parcelRequire("gJQFt");

var $eZZtS = parcelRequire("eZZtS");

var $hfoxB = parcelRequire("hfoxB");

var $cchjQ = parcelRequire("cchjQ");

var $7g874 = parcelRequire("7g874");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $iziiq = parcelRequire("iziiq");

var $g2qf8 = parcelRequire("g2qf8");

var $bpyxC = parcelRequire("bpyxC");

var $90Qb9 = parcelRequire("90Qb9");

var $8kP0u = parcelRequire("8kP0u");
const $005835cb69e50406$var$portalRoutePrefix = '/portal/:portalId(\\d+)';
const $005835cb69e50406$export$4340468daf4d707e = ()=>{
    const [routerState] = (0, $i9cdb.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $g2qf8.default), {
        screenName: (0, $8rTkC.ScreenName).REQUEST_CREATE,
        screenId: routerState.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3szzY.default), {
        screenName: (0, $8rTkC.ScreenName).REQUEST_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $90Qb9.UiModificationsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gJQFt.RequestCreatePage), routerState))));
};
const $005835cb69e50406$export$a877efa523a67c07 = ()=>{
    const [routerState] = (0, $i9cdb.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $g2qf8.default), {
        screenName: (0, $8rTkC.ScreenName).REQUEST_CREATE,
        screenId: routerState.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3szzY.default), {
        screenName: (0, $8rTkC.ScreenName).REQUEST_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $90Qb9.UiModificationsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eZZtS.RequestCreatePageForHubs), routerState))));
};
const $005835cb69e50406$export$1d1b8e06f48bd2d4 = ()=>{
    const [routerState] = (0, $i9cdb.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $g2qf8.default), {
        screenName: (0, $8rTkC.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3szzY.default), {
        screenName: (0, $8rTkC.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4JEE5.RequestCreateAnonymousSuccess), routeContext)));
};
const $005835cb69e50406$export$abc0ddbfeed2cc26 = (0, $bpyxC.createRouteWithLayout)({
    name: 'user-profile',
    path: '/user/profile',
    exact: true,
    resources: [],
    component: (0, $7g874.UserProfile)
}, (0, $8rTkC.ScreenName).USER_PROFILE, {
    hideSearchButton: false,
    paperAppearance: 'normal',
    fadeInSearchModal: true
});
const $005835cb69e50406$export$31641b61980e511f = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    createAnalyticsEvent && createAnalyticsEvent({
        action: 'rendered',
        analyticsType: (0, $iziiq.UI_EVENT_TYPE)
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4acrp.default), {
        error: {
            status: (0, $8rTkC.HTTP).NOT_FOUND,
            message: '',
            callToActionUrl: '',
            callToActionText: ''
        }
    }, '');
};
const $005835cb69e50406$export$b0cc27459efb2ff4 = ()=>(0, $bpyxC.createRouteWithLayout)({
        name: 'request-create',
        path: '/portal/:portalId/create/:requestTypeId',
        exact: true,
        component: $005835cb69e50406$export$4340468daf4d707e,
        resources: (0, $HGACo.isUiModificationsSupportEnabled)() && !(0, $1EFS8.default).checkGate('ditto_uim_root_query_rest') ? [
            (0, $fBOCW.UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE)
        ] : []
    }, (0, $8rTkC.ScreenName).REQUEST_CREATE, {
        fadeInSearchModal: true,
        paperAppearance: 'xxwide'
    });
const $005835cb69e50406$export$ea05b9ec1342627e = (0, $bpyxC.createRouteWithLayout)({
    name: 'request-create-anonymous-success',
    path: '/portal/:portalId/create/:requestTypeId/confirm',
    exact: true,
    component: $005835cb69e50406$export$1d1b8e06f48bd2d4,
    resources: []
}, (0, $8rTkC.ScreenName).KNOWLEDGE_CATEGORY, {
    fadeInSearchModal: true
});
const $005835cb69e50406$export$a3cf9a79f03e97df = (0, $bpyxC.createRouteWithLayout)({
    name: 'request-feedback',
    path: `${$005835cb69e50406$var$portalRoutePrefix}/:requestKey/feedback`,
    exact: true,
    component: (0, $hfoxB.RequestFeedback),
    resources: []
}, (0, $8rTkC.ScreenName).FEEDBACK, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $005835cb69e50406$export$45634ebe4da270df = (0, $bpyxC.createRouteWithLayout)({
    name: 'request-feedback',
    path: `/user/requests/:requestKey/feedback`,
    exact: true,
    component: (0, $hfoxB.RequestFeedback),
    resources: []
}, (0, $8rTkC.ScreenName).FEEDBACK, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $005835cb69e50406$export$7dfcaf0a6ac7c9fe = (0, $bpyxC.createRouteWithLayout)({
    name: 'unsubscribeRoute',
    path: `${$005835cb69e50406$var$portalRoutePrefix}/:requestKey/unsubscribe`,
    exact: true,
    component: (0, $cchjQ.Unsubscribe),
    resources: []
}, (0, $8rTkC.ScreenName).UNSUBSCRIBE, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $005835cb69e50406$export$5443dabb022476b2 = (0, $bpyxC.createRouteWithLayout)({
    name: 'not-found-error-page',
    path: '(.*)',
    exact: true,
    component: (0, $eS4yu.default)({
        componentName: 'notFoundPage'
    })((0, $k7ZVu.default)({})($005835cb69e50406$export$31641b61980e511f)),
    resources: []
}, (0, $8rTkC.ScreenName).ERROR_NOT_FOUND, {
    paperAppearance: 'normal',
    fadeInSearchModal: true
});

});
parcelRegister("4acrp", function(module, exports) {
$parcel$export(module.exports, "withErrorPage", () => $927857029aa66d28$export$60ebd61e40e72272);
$parcel$export(module.exports, "default", () => $927857029aa66d28$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $4aGFs = parcelRequire("4aGFs");

var $8rTkC = parcelRequire("8rTkC");

var $gzPDp = parcelRequire("gzPDp");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $9Nmb7 = parcelRequire("9Nmb7");

var $cbTZz = parcelRequire("cbTZz");

var $l4a5B = parcelRequire("l4a5B");
parcelRequire("1n2hY");
var $4fSTF = parcelRequire("4fSTF");

var $iqJis = parcelRequire("iqJis");

var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $gk18s = parcelRequire("gk18s");

var $c7dQO = parcelRequire("c7dQO");

var $hrPHR = parcelRequire("hrPHR");

var $bFb5j = parcelRequire("bFb5j");

var $kCCWm = parcelRequire("kCCWm");
const $927857029aa66d28$var$isUnhandledError = (statusCode)=>{
    // We want to report on any 5xx errors for the experience tracker.
    return `${statusCode}`.startsWith('5');
};
const $927857029aa66d28$export$5d56d6fe10c95f05 = ({ error: error, intl: intl })=>{
    let Icon;
    let heading = '';
    let description = '';
    const isCSMHelpCenterEnabled = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    switch(error.status){
        case (0, $8rTkC.HTTP).FORBIDDEN:
            heading = intl.formatMessage((0, $kCCWm.default).permissionDenied);
            description = intl.formatMessage((0, $kCCWm.default).permissionDeniedMessage);
            Icon = (0, $cbTZz.default);
            break;
        case (0, $8rTkC.HTTP).NOT_FOUND:
            heading = intl.formatMessage(isCSMHelpCenterEnabled ? (0, $kCCWm.default).notFoundV2 : (0, $kCCWm.default).notFound);
            description = intl.formatMessage(isCSMHelpCenterEnabled ? (0, $kCCWm.default).notFoundMessageV2 : (0, $kCCWm.default).notFoundMessage);
            Icon = (0, $9Nmb7.default);
            break;
        case (0, $8rTkC.HTTP).OFFLINE:
            heading = intl.formatMessage((0, $kCCWm.default).offlineHeading);
            description = intl.formatMessage((0, $kCCWm.default).offlineMessage);
            Icon = (0, $9Nmb7.default);
            break;
        case (0, $8rTkC.HTTP).SERVER:
        default:
            heading = intl.formatMessage((0, $kCCWm.default).genericHeading);
            description = intl.formatMessage((0, $kCCWm.default).genericMessage);
            Icon = (0, $9Nmb7.default);
            break;
    }
    if (error.message) // If there is a message with the error we override it.
    description = typeof error.message === 'string' ? error.message : intl.formatMessage(error.message);
    if (error.heading) heading = typeof error.heading === 'string' ? error.heading : intl.formatMessage(error.heading);
    return {
        heading: heading,
        description: description,
        Icon: Icon
    };
};
const $927857029aa66d28$export$c120a0e80fd44ca6 = ({ error: error, children: children, intl: intl, config: config })=>{
    if (!!error) {
        const { Icon: Icon, heading: heading, description: description } = $927857029aa66d28$export$5d56d6fe10c95f05({
            error: error,
            intl: intl
        });
        // failure logging to be avoided only if the traceId is absent and the config is set to exclude empty traceId logs
        const shouldLogFailure = error.traceId ? true : !(config !== null && config !== void 0 && config.isEmptyTraceIdLogExcluded);
        const shouldRenderExperienceFailure = $927857029aa66d28$var$isUnhandledError(error.status) && shouldLogFailure;
        return /*#__PURE__*/ $8P7DW.createElement((0, $gzPDp.default), {
            title: description
        }, /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.PaperContent), null, /*#__PURE__*/ $8P7DW.createElement($927857029aa66d28$var$Container, null, /*#__PURE__*/ $8P7DW.createElement($927857029aa66d28$var$IconContainer, null, /*#__PURE__*/ $8P7DW.createElement(Icon, null)), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
            migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
                space: "space.100",
                alignInline: "center",
                xcss: $927857029aa66d28$var$errorMessageContainerStyle
            }, /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
                size: "medium",
                as: "div"
            }, heading), /*#__PURE__*/ $8P7DW.createElement((0, $7zDtY.default), {
                align: "center"
            }, description))
        }, /*#__PURE__*/ $8P7DW.createElement($927857029aa66d28$export$f69c19e57285b83a, null, heading), /*#__PURE__*/ $8P7DW.createElement($927857029aa66d28$var$Description, null, description)), error.status !== (0, $8rTkC.HTTP).OFFLINE && /*#__PURE__*/ $8P7DW.createElement((0, $bFb5j.ErrorLink), {
            callToActionUrl: error.callToActionUrl
        }, error.callToActionText), shouldRenderExperienceFailure && /*#__PURE__*/ $8P7DW.createElement((0, $4aGFs.ExperienceFailure), {
            location: "error-page",
            errorMessage: description,
            traceId: error.traceId,
            responseHeaders: error.responseHeaders,
            status: error.status
        }))));
    }
    return $8P7DW.Children.only(children);
};
const $927857029aa66d28$var$IntlErrorPage = (0, $l4a5B.default)($927857029aa66d28$export$c120a0e80fd44ca6);
const $927857029aa66d28$export$60ebd61e40e72272 = (WrappedComponent, config)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $8P7DW.createElement($927857029aa66d28$var$IntlErrorPage, {
            ...props,
            error: props.error,
            config: config
        }, /*#__PURE__*/ $8P7DW.createElement(WrappedComponent, props));
var $927857029aa66d28$export$2e2bcd8739ae039 = $927857029aa66d28$var$IntlErrorPage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $927857029aa66d28$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-a8w8t7-0"
})`display:flex;flex-flow:column wrap;align-items:center;margin-top:${"var(--ds-space-600, 48px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $927857029aa66d28$var$IconContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-a8w8t7-1"
})`width:${$4cxV2.multiple(14).px};margin-bottom:${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $927857029aa66d28$var$Description = /*#__PURE__*/ (0, $2UsNA.default).p.withConfig({
    componentId: "sc-a8w8t7-2"
})`${$kBzhX.regular};max-width:100%;margin:0 0 ${"var(--ds-space-100, 8px)"} 0;text-align:center;`;
const $927857029aa66d28$export$f69c19e57285b83a = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-a8w8t7-3"
})`${$kBzhX.h600};max-width:100%;margin:0 0 ${"var(--ds-space-100, 8px)"} 0;`;
const $927857029aa66d28$var$errorMessageContainerStyle = (0, $37U6z.xcss)({
    marginBlockEnd: 'space.100'
});

});
parcelRegister("4aGFs", function(module, exports) {
$parcel$export(module.exports, "withExperienceNotifier", () => $49203c795d24cc51$export$43b8ee6172152b23);
$parcel$export(module.exports, "ExperienceSuccess", () => $49203c795d24cc51$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceFailure", () => $49203c795d24cc51$export$eed1d73ebdd8c7ab);

var $8P7DW = parcelRequire("8P7DW");

var $bbLAR = parcelRequire("bbLAR");
// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
// eslint-disable-next-line react/display-name
const $49203c795d24cc51$var$createExperienceNotifier = (type)=>(props)=>/*#__PURE__*/ $8P7DW.createElement((0, $bbLAR.default), {
            ...props,
            type: type
        });
const $49203c795d24cc51$export$43b8ee6172152b23 = (experienceLocation)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const Component = WrappedComponent;
            return /*#__PURE__*/ $8P7DW.createElement((0, $bbLAR.default), {
                type: "CAN_SUCCEED_OR_FAIL",
                location: experienceLocation
            }, (notify)=>/*#__PURE__*/ $8P7DW.createElement(Component, {
                    ...props,
                    ...notify
                }));
        };
const $49203c795d24cc51$export$4962f3898bd5c829 = $49203c795d24cc51$var$createExperienceNotifier('IMMEDIATE_SUCCESS');
const $49203c795d24cc51$export$eed1d73ebdd8c7ab = $49203c795d24cc51$var$createExperienceNotifier('IMMEDIATE_FAILURE');

});
parcelRegister("bbLAR", function(module, exports) {
$parcel$export(module.exports, "default", () => $086cbdb58ded3251$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $6hdgt = parcelRequire("6hdgt");

var $cLBxy = parcelRequire("cLBxy");
class $086cbdb58ded3251$export$2e2bcd8739ae039 extends $8P7DW.Component {
    static #_ = this.contextType = (0, $cLBxy.ExperienceContext);
    componentDidMount() {
        const { type: type, location: location, errorMessage: errorMessage, traceId: traceId, responseHeaders: responseHeaders, status: status } = this.props;
        if (type !== 'CAN_FAIL') this.context.onPending();
        if (type === 'IMMEDIATE_FAILURE') this.onFailure(errorMessage || location, traceId, responseHeaders, status);
        else if (type === 'IMMEDIATE_SUCCESS') this.onSuccess();
    // Otherwise we wait for the child to either throw an error or call `onExperienceSuccess`.
    }
    componentWillUnmount() {
        // If this component is being unmounted and still hasn't notified - assume it was successful.
        if (this.props.type !== 'CAN_FAIL') this.onSuccess();
    }
    componentDidCatch(error) {
        const { name: name, message: message } = error;
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
        const isIE7Browser = (0, $e6Qdr.fg)('filter_ie7_for_request_create_errors') && (0, $6hdgt.isIE7)();
        if (!isIE7Browser) this.context.onFailure({
            errorMessage: message,
            errorName: name,
            traceId: this.props.traceId,
            unhandledError: true,
            errorLocation: this.props.location
        });
        // We're deliberately rethrow the error here because we don't want to interfere with
        // any error handling the container app may have in place. This app exists only to track
        // error/success metrics; we don't want to interfere with the app that's actually rendering UI.
        throw error;
    }
    render() {
        const { children: children } = this.props;
        const markup = typeof children === 'function' ? children({
            notifySuccess: this.onSuccess,
            notifyFailure: this.onFailure
        }) : children;
        return markup || null;
    }
    constructor(...args){
        super(...args), this.hasSignalledSuccess = false, this.onSuccess = ()=>{
            // This guards against the possibility of the child calling `onExperienceSuccess` repeatedly.
            if (!this.hasSignalledSuccess) {
                this.hasSignalledSuccess = true;
                this.context.onSuccess();
            }
        }, this.onFailure = (errorMessage, traceId, responseHeaders, status)=>{
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
            const isIE7Browser = (0, $e6Qdr.fg)('filter_ie7_for_request_create_errors') && (0, $6hdgt.isIE7)();
            if (!isIE7Browser) this.context.onFailure({
                errorMessage: errorMessage,
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: status,
                errorName: 'NotifyFailure',
                unhandledError: false,
                errorLocation: this.props.location
            });
        };
    }
}
const $086cbdb58ded3251$export$eed1d73ebdd8c7ab = ({ experience: experience, config: config })=>{
    $8P7DW.useEffect(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        experience.failure(config);
    }, [
        experience,
        config
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null);
};

});
parcelRegister("cLBxy", function(module, exports) {
$parcel$export(module.exports, "ExperienceContext", () => $0f1cf9d06f0ce105$export$fb99266658f5da06);
$parcel$export(module.exports, "default", () => $0f1cf9d06f0ce105$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $1We2B = parcelRequire("1We2B");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $gk18s = parcelRequire("gk18s");

var $4nHTn = parcelRequire("4nHTn");

var $hrPHR = parcelRequire("hrPHR");
const $0f1cf9d06f0ce105$export$fb99266658f5da06 = /*#__PURE__*/ $8P7DW.createContext({
    onFailure: (0, $1We2B.noop),
    onPending: (0, $1We2B.noop),
    onSuccess: (0, $1We2B.noop)
});
class $0f1cf9d06f0ce105$export$c90b54e658fc4d7c extends $8P7DW.Component {
    static #_ = this.checkNotifiersInterval = 1000;
    static #_2 = this.defaultProps = {
        isExperienceReady: true
    };
    componentDidMount() {
        this.checkAndStartTimer();
        this.trackExperience('taskStart');
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    checkAndStartTimer() {
        if (this.notifierHasBegunPending && this.props.isExperienceReady) this.startTimer();
    }
    componentDidCatch(error) {
        const { name: name, message: message } = error;
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackFailure({
            errorMessage: message,
            errorName: name,
            unhandledError: true,
            errorLocation: this.props.name
        });
        // We're deliberately rethrow the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = window.setTimeout(()=>{
            if (this.pendingCount === 0) this.trackSuccess();
        }, $0f1cf9d06f0ce105$export$c90b54e658fc4d7c.checkNotifiersInterval);
    }
    trackSuccess() {
        this.trackExperience('taskSuccess');
    }
    trackFailure(failure) {
        this.trackExperience('taskFail', failure);
    }
    trackExperience(action, errorFailure) {
        if (this.hasTrackedExperience) // Ignore any follow up tracking fired after the experience has been tracked.
        return;
        const { createAnalyticsEvent: createAnalyticsEvent, experienceId: experienceId } = this.props;
        let { name: name } = this.props;
        // Adding the check to avoid firing Premium SLA event for CSM help center
        // This check will be removed once CSM is migrated to SSR
        if ((0, $HGACo.isCsmPremiumSlaDisabledFlagEnabled)() && (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType)) switch(name){
            case (0, $8rTkC.ExperienceName).HELP_CENTER:
                name = (0, $8rTkC.ExperienceName).HELP_CENTER_CSM;
                break;
            case (0, $8rTkC.ExperienceName).REQUEST_CREATE:
                name = (0, $8rTkC.ExperienceName).REQUEST_CREATE_CSM;
                break;
            default:
                return;
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const event = createAnalyticsEvent({});
        switch(action){
            case 'taskFail':
                (0, $4nHTn.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    error: errorFailure
                }, event);
                break;
            case 'taskSuccess':
                (0, $4nHTn.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId
                }, event);
                break;
            case 'taskStart':
            default:
                (0, $4nHTn.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId
                }, event);
                break;
        }
        if (action !== 'taskStart') this.hasTrackedExperience = true;
    }
    render() {
        return /*#__PURE__*/ $8P7DW.createElement($0f1cf9d06f0ce105$export$fb99266658f5da06.Provider, {
            value: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), /**
   * This value is needed so the timer doesn't start until
   * at least one notifier has been turned on.
   */ this.notifierHasBegunPending = false, this.timerId = undefined, this.pendingCount = 0, this.hasTrackedExperience = false, /**
   * Called when a descendant experience notifier is waiting to see if it is successful or not.
   */ this.onPending = ()=>{
            this.pendingCount += 1;
            this.notifierHasBegunPending = true;
            this.checkAndStartTimer();
        }, /**
   * Called when a descendant experience notifier successfully loaded.
   * ALL descendant experience notifiers need to successfully load for a SUCCESS
   * to be considered.
   */ this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, /**
   * Called when a descendant experience notifier failed to load.
   * This caused the entire experience to FAIL.
   */ this.onFailure = (failure)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackFailure(failure);
        };
    }
}
var // Use "componentName" as a drop-in replacement for "actionSubject"
// analytics-web-react getEvent() currently only supports TRACK events
// setting it directly.
$0f1cf9d06f0ce105$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    componentName: 'ui'
})((0, $k7ZVu.default)()($0f1cf9d06f0ce105$export$c90b54e658fc4d7c));

});
parcelRegister("4nHTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6dcb5c4643e177e$export$2e2bcd8739ae039);

var $HGACo = parcelRequire("HGACo");

var $8LbZn = parcelRequire("8LbZn");
var $17wqU = parcelRequire("17wqU");

var $iziiq = parcelRequire("iziiq");
const $c6dcb5c4643e177e$var$createAnalyticsPayload = ({ name: name, action: action, experienceId: experienceId, ...rest })=>{
    const error = 'error' in rest ? rest.error : undefined;
    return {
        action: action,
        task: name,
        taskId: experienceId,
        reason: error && error.errorMessage,
        ...error
    };
};
var $c6dcb5c4643e177e$export$2e2bcd8739ae039 = (experienceDescription, analyticsEvent)=>{
    const payload = $c6dcb5c4643e177e$var$createAnalyticsPayload(experienceDescription);
    if ((0, $HGACo.isMigrateToAnalyticsBridgeEnabled)()) {
        const { action: action, ...rest } = payload;
        (0, $8LbZn.fireAnalytics)(analyticsEvent, (0, $17wqU.OPERATIONAL_EVENT_TYPE), {
            action: action,
            attributes: rest
        });
    } else {
        analyticsEvent.update(payload);
        (0, $iziiq.fireAnalyticsEvent)({
            payload: payload,
            analyticsEvent: analyticsEvent,
            type: (0, $iziiq.EventTypes).OPERATIONAL
        });
    }
};

});
parcelRegister("8LbZn", function(module, exports) {
$parcel$export(module.exports, "fireAnalytics", () => $4e8f6c76de40e9de$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $4e8f6c76de40e9de$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $4e8f6c76de40e9de$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $4e8f6c76de40e9de$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $4e8f6c76de40e9de$export$6f46fb37ad7d962b);

var $eKg28 = parcelRequire("eKg28");

var $17wqU = parcelRequire("17wqU");

var $eVPF4 = parcelRequire("eVPF4");
const $4e8f6c76de40e9de$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $17wqU.ANALYTICS_BRIDGE_CHANNEL));
};
const $4e8f6c76de40e9de$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eKg28)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $4e8f6c76de40e9de$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $eVPF4.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $4e8f6c76de40e9de$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $4e8f6c76de40e9de$export$34ac71ce24cddec2(event, (0, $17wqU.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $4e8f6c76de40e9de$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $eVPF4.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $4e8f6c76de40e9de$export$34ac71ce24cddec2(event, (0, $17wqU.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $4e8f6c76de40e9de$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $eVPF4.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $4e8f6c76de40e9de$export$34ac71ce24cddec2(event, (0, $17wqU.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $4e8f6c76de40e9de$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $eVPF4.getImperativeAnalyticsDataFromArguments)(rest);
    $4e8f6c76de40e9de$export$34ac71ce24cddec2(event, (0, $17wqU.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};

});
parcelRegister("eVPF4", function(module, exports) {
$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $091c5e6436967a3d$export$e6baab532ef8c6bf);
const $091c5e6436967a3d$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $091c5e6436967a3d$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $091c5e6436967a3d$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $091c5e6436967a3d$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $091c5e6436967a3d$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $091c5e6436967a3d$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $091c5e6436967a3d$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $091c5e6436967a3d$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $091c5e6436967a3d$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $091c5e6436967a3d$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $091c5e6436967a3d$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $091c5e6436967a3d$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});






parcelRegister("gzPDp", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7225be2cd2c782b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $LjMa7 = parcelRequire("LjMa7");

var $l4a5B = parcelRequire("l4a5B");

var $bkGAV = parcelRequire("bkGAV");
const $e7225be2cd2c782b$export$dd5ad0b65cf665da = ({ children: children, title: title, intl: intl, ignoreBaseTitle: ignoreBaseTitle })=>{
    let documentTitle = intl.formatMessage((0, $bkGAV.default).defaultTitle);
    if (ignoreBaseTitle && title) documentTitle = title;
    else if (title) documentTitle = intl.formatMessage((0, $bkGAV.default).baseTitle, {
        title: title
    });
    return /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($LjMa7))), {
        title: documentTitle
    }, children);
};
var $e7225be2cd2c782b$export$2e2bcd8739ae039 = (0, $l4a5B.default)($e7225be2cd2c782b$export$dd5ad0b65cf665da);

});
parcelRegister("LjMa7", function(module, exports) {
'use strict';

var $8P7DW = parcelRequire("8P7DW");

var $93Fg7 = parcelRequire("93Fg7");

var $ggNUB = parcelRequire("ggNUB");
function $08e3baf6f02233e5$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $08e3baf6f02233e5$var$handleStateChangeOnClient(title) {
    var nextTitle = title || '';
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $08e3baf6f02233e5$var$DocumentTitle() {}
$08e3baf6f02233e5$var$DocumentTitle.prototype = Object.create($8P7DW.Component.prototype);
$08e3baf6f02233e5$var$DocumentTitle.displayName = 'DocumentTitle';
$08e3baf6f02233e5$var$DocumentTitle.propTypes = {
    title: $93Fg7.string.isRequired
};
$08e3baf6f02233e5$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $8P7DW.Children.only(this.props.children);
    else return null;
};
module.exports = $ggNUB($08e3baf6f02233e5$var$reducePropsToState, $08e3baf6f02233e5$var$handleStateChangeOnClient)($08e3baf6f02233e5$var$DocumentTitle);

});
parcelRegister("ggNUB", function(module, exports) {
'use strict';
function $bd84db6dce329757$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $8P7DW = parcelRequire("8P7DW");
var $bd84db6dce329757$var$React__default = $bd84db6dce329757$var$_interopDefault($8P7DW);

var $bd84db6dce329757$var$shallowEqual = $bd84db6dce329757$var$_interopDefault((parcelRequire("kgwL3")));
function $bd84db6dce329757$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bd84db6dce329757$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $bd84db6dce329757$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $bd84db6dce329757$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $bd84db6dce329757$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$bd84db6dce329757$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $bd84db6dce329757$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($8P7DW.Component);
        $bd84db6dce329757$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $bd84db6dce329757$var$_defineProperty(SideEffect, "canUseDOM", $bd84db6dce329757$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $bd84db6dce329757$var$withSideEffect;

});
parcelRegister("kgwL3", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("bkGAV", function(module, exports) {
$parcel$export(module.exports, "default", () => $97d3b56d293b7a50$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $97d3b56d293b7a50$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    defaultTitle: {
        defaultMessage: 'Jira Service Management',
        description: 'Default document page title',
        id: 'cv.jsm.document.page.title.default'
    },
    baseTitle: {
        defaultMessage: '{title} - Jira Service Management',
        description: 'Base document page title appended to custom document titles.',
        id: 'cv.jsm.document.page.title.base'
    }
});

});


parcelRegister("9Nmb7", function(module, exports) {
$parcel$export(module.exports, "default", () => $038d0346435de9ac$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $038d0346435de9ac$var$SvgErrorreact = (props)=>/*#__PURE__*/ $8P7DW.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 163.28 218",
        ...props
    }, /*#__PURE__*/ $8P7DW.createElement("defs", null, /*#__PURE__*/ $8P7DW.createElement("linearGradient", {
        id: "error_react_svg__linear-gradient",
        x1: 133.86,
        y1: 136.43,
        x2: -2.79,
        y2: 200.15,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 0,
        stopColor: "#ffd740"
    }), /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 1,
        stopColor: "#ffab00"
    })), /*#__PURE__*/ $8P7DW.createElement("clipPath", {
        id: "error_react_svg__clip-path"
    }, /*#__PURE__*/ $8P7DW.createElement("path", {
        id: "error_react_svg___Polygon_",
        "data-name": "<Polygon>",
        className: "error_react_svg__cls-1",
        d: "m94.78 80.16 66.44 115.08A15.17 15.17 0 0 1 148.08 218H15.2a15.17 15.17 0 0 1-13.14-22.76L68.5 80.16a15.17 15.17 0 0 1 26.28 0Z"
    })), /*#__PURE__*/ $8P7DW.createElement("style", null, ".error_react_svg__cls-1{fill:url(#error_react_svg__linear-gradient)}.error_react_svg__cls-2{fill:#253858}.error_react_svg__cls-6{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;stroke:#5e6c84}")), /*#__PURE__*/ $8P7DW.createElement("g", {
        id: "error_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $8P7DW.createElement("g", {
        id: "error_react_svg__Software"
    }, /*#__PURE__*/ $8P7DW.createElement("path", {
        id: "error_react_svg___Polygon_2",
        "data-name": "<Polygon>",
        className: "error_react_svg__cls-1",
        d: "m94.78 80.16 66.44 115.08A15.17 15.17 0 0 1 148.08 218H15.2a15.17 15.17 0 0 1-13.14-22.76L68.5 80.16a15.17 15.17 0 0 1 26.28 0Z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        className: "error_react_svg__cls-2",
        d: "m87.22 163.71 2.88-44.35a9.18 9.18 0 0 0-9.16-9.78 9.18 9.18 0 0 0-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89 6.3 6.3 0 0 0 6.28-5.89ZM71.38 187.25a9.53 9.53 0 0 0 10.39 9.58 9.68 9.68 0 0 0-.9-19.32 9.64 9.64 0 0 0-9.49 9.74Z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M91.7 27.17 84.29.45A.61.61 0 0 0 83.1.5l-4.66 25.1-5.8-1.08a.61.61 0 0 0-.7.76L79.35 52a.61.61 0 0 0 1.19 0l4.66-25.1 5.8 1.03a.61.61 0 0 0 .7-.76Z",
        style: {
            fill: "#ffc400"
        }
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "m65.12 41.81-10.88-8.55a.27.27 0 0 0-.41.33L59.36 45l-2.66 1.31a.27.27 0 0 0 0 .45l10.87 8.55a.27.27 0 0 0 .41-.33l-5.57-11.43 2.66-1.29a.27.27 0 0 0 .05-.45Z",
        style: {
            fill: "#ffab00"
        }
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M115.15 36.6c-1.17 1.59-11-5.6-12.16-4s8.66 8.79 7.5 10.39-11-5.6-12.17-4 8.66 8.79 7.49 10.39-11-5.6-12.17-4 8.66 8.79 7.49 10.39",
        style: {
            stroke: "#344563",
            fill: "none",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        className: "error_react_svg__cls-6",
        d: "M119.92 64.19c-1.46 1.33-7.05-4.78-8.51-3.44s4.13 7.45 2.67 8.78-7.05-4.78-8.51-3.44c-.68.62.16 2.27 1.11 4M44.8 64c1.82.77 5-6.87 6.86-6.1s-1.39 8.4.43 9.17 5-6.87 6.86-6.1c.85.36.61 2.19.29 4.13"
    }))));
var $038d0346435de9ac$export$2e2bcd8739ae039 = $038d0346435de9ac$var$SvgErrorreact;

});

parcelRegister("cbTZz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b188e1d1253c852e$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $b188e1d1253c852e$var$SvgLockreact = (props)=>/*#__PURE__*/ $8P7DW.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 168.837 221.487",
        ...props
    }, /*#__PURE__*/ $8P7DW.createElement("defs", null, /*#__PURE__*/ $8P7DW.createElement("linearGradient", {
        id: "lock_react_svg__linear-gradient",
        x1: 49.42,
        y1: 59.767,
        x2: 122.662,
        y2: 59.767,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 0,
        stopColor: "#0065ff"
    }), /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 0.219,
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 0.6,
        stopColor: "#2780ff"
    }), /*#__PURE__*/ $8P7DW.createElement("stop", {
        offset: 1,
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ $8P7DW.createElement("style", null, ".lock_react_svg__cls-2{fill:#de350b}.lock_react_svg__cls-3{fill:#ff5630}")), /*#__PURE__*/ $8P7DW.createElement("g", {
        id: "lock_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $8P7DW.createElement("g", {
        id: "lock_react_svg__Objects"
    }, /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M122.662 119.535H49.42V36.62a36.621 36.621 0 0 1 73.242 0zm-61.242-12h49.242V36.62a24.621 24.621 0 0 0-49.242 0z",
        fill: "url(#lock_react_svg__linear-gradient)"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        className: "lock_react_svg__cls-2",
        d: "M160.324 111.17a65.496 65.496 0 0 1-5.657-46.117l.002-.009a5.053 5.053 0 0 0-4.904-6.273H19.072a5.053 5.053 0 0 0-4.904 6.273l.002.006a66.149 66.149 0 0 1-5.785 46.367 75.49 75.49 0 0 0 65.21 110.047h17.866a75.491 75.491 0 0 0 68.863-110.294z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        className: "lock_react_svg__cls-3",
        d: "m154.667 65.053.002-.009a5.053 5.053 0 0 0-4.904-6.273H36.94a5.053 5.053 0 0 0-4.904 6.273l.001.006a66.15 66.15 0 0 1-5.784 46.367 75.485 75.485 0 1 0 134.072-.247 65.496 65.496 0 0 1-5.657-46.117z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        id: "lock_react_svg___Path_",
        "data-name": "<Path>",
        d: "M93.352 213.6q-.845 0-1.697-.02a67.603 67.603 0 0 1-58.396-98.539A74.376 74.376 0 0 0 40.47 66.66h105.762a73.488 73.488 0 0 0 7.098 48.16 67.6 67.6 0 0 1-59.975 98.78z",
        fill: "#ff7452"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        className: "lock_react_svg__cls-3",
        d: "M90.007 176.885a16.308 16.308 0 0 1-16.115-18.82l2.23-14.32A24.148 24.148 0 0 1 92.21 102.69c.382-.017.766-.026 1.144-.026a24.15 24.15 0 0 1 17.229 41.08l2.23 14.32a16.31 16.31 0 0 1-16.114 18.82z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        id: "lock_react_svg___Path_2",
        "data-name": "<Path>",
        className: "lock_react_svg__cls-2",
        d: "M108.481 126.824a15.061 15.061 0 0 1-4.83 11.067 7.222 7.222 0 0 0-2.122 6.412l2.36 15.154a7.278 7.278 0 0 1-7.192 8.398h-6.69a7.278 7.278 0 0 1-7.192-8.398l2.388-15.332a7.232 7.232 0 0 0-2.269-6.345 15.064 15.064 0 0 1-4.69-11.753 15.13 15.13 0 0 1 30.237.797z"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M82.815 159.457a7.256 7.256 0 1 0 14.333 0l-2.36-15.154a7.221 7.221 0 0 1 2.122-6.412 15.104 15.104 0 0 0-6.945-25.804 15.268 15.268 0 0 0-11.722 13.94 15.063 15.063 0 0 0 4.691 11.753 7.232 7.232 0 0 1 2.268 6.345z",
        fill: "#344563"
    }))));
var $b188e1d1253c852e$export$2e2bcd8739ae039 = $b188e1d1253c852e$var$SvgLockreact;

});

parcelRegister("1n2hY", function(module, exports) {
$parcel$export(module.exports, "Paper", () => (parcelRequire("69uY5")).default);
$parcel$export(module.exports, "PaperContent", () => (parcelRequire("4fSTF")).PaperContent);
$parcel$export(module.exports, "SmallPaddingPaperContent", () => (parcelRequire("4fSTF")).SmallPaddingPaperContent);

var $69uY5 = parcelRequire("69uY5");

var $4fSTF = parcelRequire("4fSTF");

});
parcelRegister("69uY5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb0f624410a2d4cb$export$2e2bcd8739ae039);
/* paper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
parcelRequire("boTjn");
var $drpd4 = parcelRequire("drpd4");
parcelRequire("gp4SE");
var $jQ8lB = parcelRequire("jQ8lB");

var $4fSTF = parcelRequire("4fSTF");
const $fb0f624410a2d4cb$var$SkipToMainContent = ({ children: children })=>/*#__PURE__*/ $8P7DW.createElement((0, $jQ8lB.MainContentSkipLinkWrapper), null, /*#__PURE__*/ $8P7DW.createElement($fb0f624410a2d4cb$var$MainContentSkipLink, null, children));
// We want to delay fade in until after the paper transition is complete
const $fb0f624410a2d4cb$var$FadeContent = (0, $drpd4.default)({
    fadeInTime: (0, $4fSTF.paperTransitionTime),
    delay: (0, $4fSTF.paperTransitionTime)
})((0, $4fSTF.Content));
class $fb0f624410a2d4cb$var$Paper extends $8P7DW.Component {
    render() {
        const { children: children, pageKey: pageKey, isCSM: isCSM } = this.props;
        const hide = this.props.appearance === 'none';
        const appearance = this.props.appearance || 'normal';
        if (appearance === 'note') return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.PaperBackground), {
            appearance: "none",
            hide: true
        }), /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.NoteContent), {
            appearance: appearance,
            hide: hide
        }, /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.NoteBackground), null, children), /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.StyledFooter), null)));
        return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.PaperBackground), {
            appearance: appearance,
            hide: hide
        }), /*#__PURE__*/ $8P7DW.createElement($fb0f624410a2d4cb$var$FadeContent, {
            appearance: appearance,
            hide: hide,
            key: pageKey
        }, /*#__PURE__*/ $8P7DW.createElement($fb0f624410a2d4cb$var$SkipToMainContent, null, children, /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.StyledFooter), {
            isCSM: isCSM
        }))));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $fb0f624410a2d4cb$var$MainContentSkipLink = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _2lx21bp4 _1tke1osq",
            __cmplp.className
        ])
    });
});
var $fb0f624410a2d4cb$export$2e2bcd8739ae039 = $fb0f624410a2d4cb$var$Paper;

});
parcelRegister("boTjn", function(module, exports) {
$parcel$export(module.exports, "withFadeIn", () => (parcelRequire("drpd4")).default);

var $drpd4 = parcelRequire("drpd4");

});
parcelRegister("drpd4", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c6e2aeb2064b97b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $b60z8 = parcelRequire("b60z8");

var $av4AB = parcelRequire("av4AB");
parcelRequire("2DAP0");
var $6Pl45 = parcelRequire("6Pl45");

var $hrPHR = parcelRequire("hrPHR");
const $0c6e2aeb2064b97b$var$withFadeIn = (options)=>(WrappedComponent)=>{
        const defaultOptions = {
            fadeInTime: $b60z8.speedMs.slow,
            delay: 0
        };
        const mergedOptions = {
            ...defaultOptions,
            ...options
        };
        // eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        const ComponentWithFadeIn = /*#__PURE__*/ (0, $2UsNA.default)(WrappedComponent).withConfig({
            componentId: "sc-1uyl3wn-0"
        })`${$b60z8.fadeInOut(mergedOptions.fadeInTime, mergedOptions.delay)};`;
        const ReturnComponent = (props)=>{
            const shouldSkipTransition = $8P7DW.useMemo(()=>!(0, $6Pl45.isAppMounted).value, []);
            /**
     * In server side rendering -  component should appear
     * on First time load from SSR - component should appear
     * on next time onwards - component should transition
     * on client only - component should transition
     */ const shouldTransitOnMount = ()=>{
                // Invalid report.
                // eslint-disable-next-line testing-library/render-result-naming-convention
                const isPageServerSideRendered = (0, $hrPHR.getIsPageServerSideRendered)();
                if (isPageServerSideRendered && shouldSkipTransition) return false;
                return true;
            };
            return /*#__PURE__*/ $8P7DW.createElement((0, $av4AB.default), {
                in: true,
                timeout: 0,
                mountOnEnter: true,
                appear: shouldTransitOnMount()
            }, (state)=>// Spreading props blows type checking up for some reason. Why??
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                /*#__PURE__*/ $8P7DW.createElement(ComponentWithFadeIn, {
                    ...props,
                    state: state
                }));
        };
        return ReturnComponent;
    };
var $0c6e2aeb2064b97b$export$2e2bcd8739ae039 = $0c6e2aeb2064b97b$var$withFadeIn;

});
parcelRegister("av4AB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a505bf9a715c818$export$2e2bcd8739ae039, (v) => $7a505bf9a715c818$export$2e2bcd8739ae039 = v);
var $7a505bf9a715c818$export$1e511d4a378977f5;
var $7a505bf9a715c818$export$2e2bcd8739ae039;
var $7a505bf9a715c818$export$4aacc83d4d59139f;
var $7a505bf9a715c818$export$78e9e6e3e014d60a;
var $7a505bf9a715c818$export$df38205c966be359;
var $7a505bf9a715c818$export$84cbff306f539230;
var $7a505bf9a715c818$export$bb38bb9a1161268;
"use strict";
$7a505bf9a715c818$export$1e511d4a378977f5 = true;
$7a505bf9a715c818$export$2e2bcd8739ae039 = $7a505bf9a715c818$export$4aacc83d4d59139f = $7a505bf9a715c818$export$78e9e6e3e014d60a = $7a505bf9a715c818$export$df38205c966be359 = $7a505bf9a715c818$export$84cbff306f539230 = $7a505bf9a715c818$export$bb38bb9a1161268 = void 0;

var $7a505bf9a715c818$var$PropTypes = $7a505bf9a715c818$var$_interopRequireWildcard((parcelRequire("93Fg7")));

var $7a505bf9a715c818$var$_react = $7a505bf9a715c818$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $7a505bf9a715c818$var$_reactDom = $7a505bf9a715c818$var$_interopRequireDefault((parcelRequire("6Q1OD")));

var $9NRTB = parcelRequire("9NRTB");

function $7a505bf9a715c818$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7a505bf9a715c818$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $7a505bf9a715c818$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7a505bf9a715c818$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $7a505bf9a715c818$var$UNMOUNTED = 'unmounted';
$7a505bf9a715c818$export$bb38bb9a1161268 = $7a505bf9a715c818$var$UNMOUNTED;
var $7a505bf9a715c818$var$EXITED = 'exited';
$7a505bf9a715c818$export$84cbff306f539230 = $7a505bf9a715c818$var$EXITED;
var $7a505bf9a715c818$var$ENTERING = 'entering';
$7a505bf9a715c818$export$df38205c966be359 = $7a505bf9a715c818$var$ENTERING;
var $7a505bf9a715c818$var$ENTERED = 'entered';
$7a505bf9a715c818$export$78e9e6e3e014d60a = $7a505bf9a715c818$var$ENTERED;
var $7a505bf9a715c818$var$EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $7a505bf9a715c818$export$4aacc83d4d59139f = $7a505bf9a715c818$var$EXITING;
var $7a505bf9a715c818$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $7a505bf9a715c818$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $7a505bf9a715c818$var$EXITED;
                _this.appearStatus = $7a505bf9a715c818$var$ENTERING;
            } else initialStatus = $7a505bf9a715c818$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $7a505bf9a715c818$var$UNMOUNTED;
        else initialStatus = $7a505bf9a715c818$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $7a505bf9a715c818$var$UNMOUNTED) return {
            status: $7a505bf9a715c818$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $7a505bf9a715c818$var$ENTERING && status !== $7a505bf9a715c818$var$ENTERED) nextStatus = $7a505bf9a715c818$var$ENTERING;
            } else if (status === $7a505bf9a715c818$var$ENTERING || status === $7a505bf9a715c818$var$ENTERED) nextStatus = $7a505bf9a715c818$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $7a505bf9a715c818$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $7a505bf9a715c818$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $7a505bf9a715c818$var$EXITED) this.setState({
            status: $7a505bf9a715c818$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $7a505bf9a715c818$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $7a505bf9a715c818$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $7a505bf9a715c818$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $7a505bf9a715c818$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $7a505bf9a715c818$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $7a505bf9a715c818$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $7a505bf9a715c818$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $7a505bf9a715c818$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = $7a505bf9a715c818$var$_react.default.Children.only(children);
        return $7a505bf9a715c818$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($7a505bf9a715c818$var$_react.default.Component);
$7a505bf9a715c818$var$Transition.contextTypes = {
    transitionGroup: $7a505bf9a715c818$var$PropTypes.object
};
$7a505bf9a715c818$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$7a505bf9a715c818$var$Transition.propTypes = {};
function $7a505bf9a715c818$var$noop() {}
$7a505bf9a715c818$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $7a505bf9a715c818$var$noop,
    onEntering: $7a505bf9a715c818$var$noop,
    onEntered: $7a505bf9a715c818$var$noop,
    onExit: $7a505bf9a715c818$var$noop,
    onExiting: $7a505bf9a715c818$var$noop,
    onExited: $7a505bf9a715c818$var$noop
};
$7a505bf9a715c818$var$Transition.UNMOUNTED = 0;
$7a505bf9a715c818$var$Transition.EXITED = 1;
$7a505bf9a715c818$var$Transition.ENTERING = 2;
$7a505bf9a715c818$var$Transition.ENTERED = 3;
$7a505bf9a715c818$var$Transition.EXITING = 4;
var $7a505bf9a715c818$var$_default = (0, $9NRTB.polyfill)($7a505bf9a715c818$var$Transition);
$7a505bf9a715c818$export$2e2bcd8739ae039 = $7a505bf9a715c818$var$_default;

});
parcelRegister("9NRTB", function(module, exports) {
$parcel$export(module.exports, "polyfill", () => $72327f3a35bd9ee7$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $72327f3a35bd9ee7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $72327f3a35bd9ee7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $72327f3a35bd9ee7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$72327f3a35bd9ee7$var$componentWillMount.__suppressDeprecationWarning = true;
$72327f3a35bd9ee7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$72327f3a35bd9ee7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $72327f3a35bd9ee7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $72327f3a35bd9ee7$var$componentWillMount;
        prototype.componentWillReceiveProps = $72327f3a35bd9ee7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $72327f3a35bd9ee7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});




parcelRegister("gp4SE", function(module, exports) {
$parcel$export(module.exports, "MainContentSkipLinkWrapper", () => (parcelRequire("jQ8lB")).MainContentSkipLinkWrapper);

var $jQ8lB = parcelRequire("jQ8lB");

});
parcelRegister("jQ8lB", function(module, exports) {
$parcel$export(module.exports, "MainContentSkipLinkWrapper", () => $dfa0c8bf1af3d9cc$export$505b93f76cb5cb5c);

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");

var $j9fRu = parcelRequire("j9fRu");

var $9F8PP = parcelRequire("9F8PP");
const $dfa0c8bf1af3d9cc$export$505b93f76cb5cb5c = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $j9fRu.default), {
        id: "main",
        skipLinkTitle: formatMessage((0, $9F8PP.default).skipToMainA11yLabel),
        testId: "main"
    }, children);
};

});
parcelRegister("j9fRu", function(module, exports) {
$parcel$export(module.exports, "default", () => $510edba5803a9457$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $jh41u = parcelRequire("jh41u");

var $j1C0s = parcelRequire("j1C0s");

var $k2Ig6 = parcelRequire("k2Ig6");

var $24eKl = parcelRequire("24eKl");

var $9toUq = parcelRequire("9toUq");

var $cOX58 = parcelRequire("cOX58");
var $43fXs = parcelRequire("43fXs");

var $7QrIq = parcelRequire("7QrIq");
function $510edba5803a9457$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $510edba5803a9457$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $8Z0o8.css)((0, $jh41u.prefersReducedMotion)());
const $510edba5803a9457$var$mainStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $k2Ig6.TRANSITION_DURATION)}ms ${(0, $j1C0s.easeOut)} 0s`
});
const $510edba5803a9457$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $510edba5803a9457$var$flyoutStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $k2Ig6.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $k2Ig6.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $k2Ig6.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $510edba5803a9457$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $43fXs.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $24eKl.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $8P7DW.useContext)((0, $cOX58.SidebarResizeContext));
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $7QrIq.default), null, ({ className: className })=>/*#__PURE__*/ (0, $8Z0o8.jsx)("main", {
            "data-testid": testId,
            css: [
                $510edba5803a9457$var$mainStyles,
                isDragging && $510edba5803a9457$var$draggingStyles,
                isFlyoutOpen && !isFixed && $510edba5803a9457$var$flyoutStyles,
                $510edba5803a9457$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $9toUq.getPageLayoutSlotSelector)('main')
        }, children));
};
var $510edba5803a9457$export$2e2bcd8739ae039 = $510edba5803a9457$var$Main;

});
parcelRegister("k2Ig6", function(module, exports) {
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", () => $03267c52da49b1bd$export$a30f2e00489a8957);
$parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", () => $03267c52da49b1bd$export$3a6a779d9181047c);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", () => $03267c52da49b1bd$export$b6744d31294864fd);
$parcel$export(module.exports, "LEFT_PANEL", () => $03267c52da49b1bd$export$344062f7cfc9528e);
$parcel$export(module.exports, "RIGHT_PANEL", () => $03267c52da49b1bd$export$c7139cc2d6110b5f);
$parcel$export(module.exports, "BANNER", () => $03267c52da49b1bd$export$238d30785c4bca84);
$parcel$export(module.exports, "TOP_NAVIGATION", () => $03267c52da49b1bd$export$bec6dca2e63de4ae);
$parcel$export(module.exports, "CONTENT", () => $03267c52da49b1bd$export$d1213e82613ff4df);
$parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", () => $03267c52da49b1bd$export$4a98ee0bd1ae362);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $03267c52da49b1bd$export$539e68c09584883a);
$parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $03267c52da49b1bd$export$46acf8758e9e2636);
$parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $03267c52da49b1bd$export$70740f5ad8360a78);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", () => $03267c52da49b1bd$export$991d5285ad765a3d);
$parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", () => $03267c52da49b1bd$export$d6e7e8af042815bb);
$parcel$export(module.exports, "TRANSITION_DURATION", () => $03267c52da49b1bd$export$3749e1104328fde4);
$parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", () => $03267c52da49b1bd$export$451e84a45a9e4a75);
$parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", () => $03267c52da49b1bd$export$802bb2c050f3db5c);
$parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", () => $03267c52da49b1bd$export$5e5e1875c3fd8f4f);
$parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", () => $03267c52da49b1bd$export$5253dd9707b8c3ba);
$parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", () => $03267c52da49b1bd$export$206a08f7f8beb554);
$parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", () => $03267c52da49b1bd$export$659ee746b31b360d);
$parcel$export(module.exports, "LEFT_PANEL_WIDTH", () => $03267c52da49b1bd$export$f963aecf2d4465bd);
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $03267c52da49b1bd$export$750459958906793);
$parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", () => $03267c52da49b1bd$export$f897e1ed9f8ed251);
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $03267c52da49b1bd$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $03267c52da49b1bd$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", () => $03267c52da49b1bd$export$d2fa14f05b61e66);
// dimension vars
const $03267c52da49b1bd$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $03267c52da49b1bd$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $03267c52da49b1bd$export$c103b605cd368aed = 'rightSidebarWidth';
const $03267c52da49b1bd$export$fa34f417972d6341 = 'rightPanelWidth';
const $03267c52da49b1bd$export$3a6a779d9181047c = 'topNavigationHeight';
const $03267c52da49b1bd$export$bcd94a6a792e7f96 = 'bannerHeight';
const $03267c52da49b1bd$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $03267c52da49b1bd$export$344062f7cfc9528e = 'left-panel';
const $03267c52da49b1bd$export$c7139cc2d6110b5f = 'right-panel';
const $03267c52da49b1bd$export$238d30785c4bca84 = 'banner';
const $03267c52da49b1bd$export$bec6dca2e63de4ae = 'top-navigation';
const $03267c52da49b1bd$export$d1213e82613ff4df = 'content';
const $03267c52da49b1bd$export$be83e7118304b28e = 56;
const $03267c52da49b1bd$export$4a98ee0bd1ae362 = 56;
const $03267c52da49b1bd$export$539e68c09584883a = 240;
const $03267c52da49b1bd$export$b92df8810d2fcd01 = 280;
const $03267c52da49b1bd$export$c3e41153b9288bcf = 368;
const $03267c52da49b1bd$export$c4d6152f86ea28f6 = 368;
const $03267c52da49b1bd$export$46acf8758e9e2636 = 20;
const $03267c52da49b1bd$export$70740f5ad8360a78 = 16;
const $03267c52da49b1bd$export$991d5285ad765a3d = 240;
const $03267c52da49b1bd$export$6949d4f32b161684 = 200;
const $03267c52da49b1bd$export$d6e7e8af042815bb = 350;
const $03267c52da49b1bd$export$3749e1104328fde4 = 300;
const $03267c52da49b1bd$export$1074d925b0b82be5 = 200;
const $03267c52da49b1bd$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $03267c52da49b1bd$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $03267c52da49b1bd$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $03267c52da49b1bd$export$70c702a8c5895f03 = 'data-grab-area-line';
const $03267c52da49b1bd$export$48a43f91e4becf4e = 'data-grab-area';
const $03267c52da49b1bd$export$dac2fb31a9f6844d = 'data-resize-button';
const $03267c52da49b1bd$export$9ecd22db14e6c70e = 'data-resize-control';
const $03267c52da49b1bd$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $03267c52da49b1bd$export$206a08f7f8beb554 = 'Skip to:';
const $03267c52da49b1bd$export$659ee746b31b360d = 'data-layout-container';
const $03267c52da49b1bd$export$f963aecf2d4465bd = `var(--${$03267c52da49b1bd$export$cbfb0f5b2869b17b}, 0px)`;
const $03267c52da49b1bd$export$750459958906793 = `var(--${$03267c52da49b1bd$export$fa34f417972d6341}, 0px)`;
const $03267c52da49b1bd$export$f897e1ed9f8ed251 = `var(--${$03267c52da49b1bd$export$a30f2e00489a8957}, 0px)`;
const $03267c52da49b1bd$export$b44ab66843c05a69 = `var(--${$03267c52da49b1bd$export$c103b605cd368aed}, 0px)`;
const $03267c52da49b1bd$export$aeff86a16f13529 = `var(--${$03267c52da49b1bd$export$3a6a779d9181047c}, 0px)`;
const $03267c52da49b1bd$export$ed7cc0d417ee89e = `var(--${$03267c52da49b1bd$export$bcd94a6a792e7f96}, 0px)`;
const $03267c52da49b1bd$export$d2fa14f05b61e66 = `var(--${$03267c52da49b1bd$export$b6744d31294864fd}, ${$03267c52da49b1bd$export$991d5285ad765a3d}px)`;

});

parcelRegister("24eKl", function(module, exports) {
$parcel$export(module.exports, "default", () => $daf910195d65db1d$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $k2Ig6 = parcelRequire("k2Ig6");
const $daf910195d65db1d$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $k2Ig6.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $daf910195d65db1d$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $8P7DW.useState)($daf910195d65db1d$var$getIsDragging);
    (0, $8P7DW.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($daf910195d65db1d$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $k2Ig6.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $daf910195d65db1d$export$2e2bcd8739ae039 = $daf910195d65db1d$var$useIsSidebarDragging;

});

parcelRegister("9toUq", function(module, exports) {
$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $98feb256f6ae8076$export$f8355a2df0f4a946);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $98feb256f6ae8076$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $98feb256f6ae8076$export$74732e47915c7839);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $98feb256f6ae8076$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $98feb256f6ae8076$export$218ece2c32b7db0e);

var $k2Ig6 = parcelRequire("k2Ig6");

var $4rn1o = parcelRequire("4rn1o");
const $98feb256f6ae8076$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $4rn1o.default)().getItem((0, $k2Ig6.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $4rn1o.default)().setItem((0, $k2Ig6.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $98feb256f6ae8076$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $4rn1o.default)().getItem((0, $k2Ig6.PAGE_LAYOUT_LS_KEY)) || '{}');
    return storageValue[key];
};
const $98feb256f6ae8076$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $4rn1o.default)().getItem((0, $k2Ig6.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $4rn1o.default)().setItem((0, $k2Ig6.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};
const $98feb256f6ae8076$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $98feb256f6ae8076$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $98feb256f6ae8076$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $k2Ig6.LEFT_PANEL_WIDTH)}`), 10) || 0;
};
const $98feb256f6ae8076$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $k2Ig6.DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, $k2Ig6.DEFAULT_LEFT_SIDEBAR_WIDTH));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $98feb256f6ae8076$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $k2Ig6.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
    });
const $98feb256f6ae8076$export$218ece2c32b7db0e = (slotName)=>`[${0, $k2Ig6.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;

});
parcelRegister("4rn1o", function(module, exports) {
$parcel$export(module.exports, "default", () => $70f33dd05689fbfb$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $70f33dd05689fbfb$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch  {
        return false;
    }
};
const $70f33dd05689fbfb$var$safeLocalStorage = ()=>{
    if ($70f33dd05689fbfb$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $70f33dd05689fbfb$export$2e2bcd8739ae039 = $70f33dd05689fbfb$var$safeLocalStorage;

});


parcelRegister("cOX58", function(module, exports) {
$parcel$export(module.exports, "SidebarResizeContext", () => $6b80f0f59a58edd7$export$aa5a712eea4c2ae8);

var $8P7DW = parcelRequire("8P7DW");

var $5J6r2 = parcelRequire("5J6r2");
const $6b80f0f59a58edd7$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $6b80f0f59a58edd7$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $8P7DW.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $5J6r2.default),
    collapseLeftSidebar: (0, $5J6r2.default),
    leftSidebarState: $6b80f0f59a58edd7$var$leftSidebarState,
    setLeftSidebarState: (0, $5J6r2.default),
    toggleLeftSidebar: (0, $5J6r2.default)
});
const $6b80f0f59a58edd7$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $8P7DW.useContext)($6b80f0f59a58edd7$export$aa5a712eea4c2ae8);
    return context;
};
const $6b80f0f59a58edd7$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $8P7DW.useContext)($6b80f0f59a58edd7$export$aa5a712eea4c2ae8);
    (0, $8P7DW.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("43fXs", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $aeee9300a453bc67$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $aeee9300a453bc67$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $aeee9300a453bc67$export$89d9323301efc7d6);

var $8P7DW = parcelRequire("8P7DW");

var $5J6r2 = parcelRequire("5J6r2");
const $aeee9300a453bc67$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $8P7DW.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $5J6r2.default),
    unregisterSkipLink: (0, $5J6r2.default)
});
const $aeee9300a453bc67$export$c9d9cb2ee9590f87 = ()=>(0, $8P7DW.useContext)($aeee9300a453bc67$export$4c5cc3b14c7678a);
const $aeee9300a453bc67$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $aeee9300a453bc67$export$c9d9cb2ee9590f87();
    (0, $8P7DW.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("7QrIq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6aeb5941338ccb1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8Z0o8 = parcelRequire("8Z0o8");
const $6aeb5941338ccb1e$var$focusStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${"var(--ds-border-focused, #4688EC)"}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $6aeb5941338ccb1e$var$sidebarFocusStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${"var(--ds-border-focused, #4688EC)"}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $6aeb5941338ccb1e$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8Z0o8.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($6aeb5941338ccb1e$var$sidebarFocusStyles) : css($6aeb5941338ccb1e$var$focusStyles)
        }));
};
var $6aeb5941338ccb1e$export$2e2bcd8739ae039 = $6aeb5941338ccb1e$var$SlotFocusRing;

});


parcelRegister("9F8PP", function(module, exports) {
$parcel$export(module.exports, "default", () => $b79a83d1151db266$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $b79a83d1151db266$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    skipToMainA11yLabel: {
        defaultMessage: 'Skip to Main Content',
        description: 'A11y Label for Skip to Main Content',
        id: 'sd.view.common.skip.links.main-content-skip-link.a11y-label'
    }
});

});



parcelRegister("4fSTF", function(module, exports) {
$parcel$export(module.exports, "paperTransitionTime", () => $687fca20ff27caf1$export$c04d9b45b952bb2f);
$parcel$export(module.exports, "Content", () => $687fca20ff27caf1$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "NoteContent", () => $687fca20ff27caf1$export$fe2e0d4376bdc305);
$parcel$export(module.exports, "NoteBackground", () => $687fca20ff27caf1$export$8eb56b799bce002f);
$parcel$export(module.exports, "SmallPaddingPaperContent", () => $687fca20ff27caf1$export$80c4326e65e7230d);
$parcel$export(module.exports, "PaperContent", () => $687fca20ff27caf1$export$bf9cd54d94ffe52b);
$parcel$export(module.exports, "PaperBackground", () => $687fca20ff27caf1$export$69bd0e70980f4e9f);
$parcel$export(module.exports, "StyledFooter", () => $687fca20ff27caf1$export$61905ae62c7860fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $1p41U = parcelRequire("1p41U");

var $9yRgH = parcelRequire("9yRgH");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $b60z8 = parcelRequire("b60z8");

var $3xuD5 = parcelRequire("3xuD5");

var $aw7IH = parcelRequire("aw7IH");

var $h89KC = parcelRequire("h89KC");
// This is the width of the paper without any scaling
// It's fixed at 1000px for easy calculation.
const $687fca20ff27caf1$var$PAPER_WIDTH_BASIS = $4cxV2.multiple(125);
// 800px is normal width
const $687fca20ff27caf1$var$PAPER_NORMAL_WIDTH = $687fca20ff27caf1$var$PAPER_WIDTH_BASIS.multiple(0.8).unitless;
// 1000px is wide width
const $687fca20ff27caf1$var$PAPER_WIDE_WIDTH = $687fca20ff27caf1$var$PAPER_WIDTH_BASIS.multiple(1).unitless;
// 1100px is extra wide width
const $687fca20ff27caf1$var$PAPER_XWIDE_WIDTH = $687fca20ff27caf1$var$PAPER_WIDTH_BASIS.multiple(1.1).unitless;
// 1200px is extra wide width
const $687fca20ff27caf1$var$PAPER_XXWIDE_WIDTH = $687fca20ff27caf1$var$PAPER_WIDTH_BASIS.multiple(1.2).unitless;
const $687fca20ff27caf1$var$PAPER_NOTE_WIDTH = $687fca20ff27caf1$var$PAPER_WIDTH_BASIS.multiple(0.48).unitless;
const $687fca20ff27caf1$var$PAPER_PADDING_TOP = "var(--ds-space-300, 24px)";
const $687fca20ff27caf1$var$PAPER_PADDING_RIGHT_MOBILE = "var(--ds-space-400, 32px)";
const $687fca20ff27caf1$var$PAPER_PADDING_LEFT_MOBILE = "var(--ds-space-400, 32px)";
const $687fca20ff27caf1$var$PAPER_PADDING_RIGHT_DESKTOP = $4cxV2.multiple(13.5).unitless;
const $687fca20ff27caf1$var$PAPER_PADDING_LEFT_DESKTOP = $4cxV2.multiple(11).unitless;
const $687fca20ff27caf1$var$PAPER_PADDING_SMALL = "var(--ds-space-600, 48px)";
const $687fca20ff27caf1$var$PAPER_NOTE_HEIGHT = $4cxV2.multiple(52).unitless;
const $687fca20ff27caf1$var$PAPER_NOTE_MARGIN_TOP = $4cxV2.multiple(20).unitless - (0, $aw7IH.HEADER_HEIGHT);
const $687fca20ff27caf1$export$c04d9b45b952bb2f = $b60z8.speedMs.slow;
const $687fca20ff27caf1$var$getContentWidth = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $687fca20ff27caf1$var$PAPER_XXWIDE_WIDTH;
        case 'xwide':
            return $687fca20ff27caf1$var$PAPER_XWIDE_WIDTH;
        case 'wide':
            return $687fca20ff27caf1$var$PAPER_WIDE_WIDTH;
        case 'note':
            return $687fca20ff27caf1$var$PAPER_NOTE_WIDTH;
        default:
            return $687fca20ff27caf1$var$PAPER_NORMAL_WIDTH;
    }
};
const $687fca20ff27caf1$var$getScale = (appearance)=>$687fca20ff27caf1$var$getContentWidth(appearance) / $687fca20ff27caf1$var$PAPER_WIDTH_BASIS.unitless;
const $687fca20ff27caf1$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $2UsNA.default).main.withConfig({
    componentId: "sc-1jc43ym-0"
})`box-sizing:border-box;display:flex;flex-direction:column;flex:1 1 auto;margin:${"var(--ds-space-0, 0px)"} auto;width:100%;max-width:${(props)=>props.hide ? '100%' : `${$687fca20ff27caf1$var$getContentWidth(props.appearance)}px`};min-height:100%;${$1p41U.fromCustom($687fca20ff27caf1$var$PAPER_NOTE_WIDTH).css`
        min-height: ${(props)=>props.appearance === 'note' ? `${$687fca20ff27caf1$var$PAPER_NOTE_HEIGHT}px` : '100%'};
        margin-top: ${(props)=>props.appearance === 'note' ? `${$687fca20ff27caf1$var$PAPER_NOTE_MARGIN_TOP}px` : '0'};
    `};`;
const $687fca20ff27caf1$export$fe2e0d4376bdc305 = /*#__PURE__*/ (0, $2UsNA.default)($687fca20ff27caf1$export$7c6e2c02157bb7d2).attrs({
    appearance: 'note'
}).withConfig({
    componentId: "sc-1jc43ym-1"
})`align-self:flex-start;max-width:${(props)=>props.hide ? '100%' : `${$687fca20ff27caf1$var$getContentWidth(props.appearance)}px`};`;
const $687fca20ff27caf1$export$8eb56b799bce002f = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1jc43ym-2"
})`${$9yRgH.e100};border-radius:${$4cxV2.multiple(0.375).px};background-color:${"var(--ds-surface, #FFFFFF)"};min-height:inherit;`;
const $687fca20ff27caf1$export$80c4326e65e7230d = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1jc43ym-3"
})`display:flex;flex-direction:column;flex:1 1 auto;padding-top:${$687fca20ff27caf1$var$PAPER_PADDING_TOP};padding-left:${$687fca20ff27caf1$var$PAPER_PADDING_LEFT_MOBILE};padding-right:${$687fca20ff27caf1$var$PAPER_PADDING_RIGHT_MOBILE};height:${(props)=>props.takeFullHeight ? '100%' : 'auto'};${$1p41U.fromCustom($687fca20ff27caf1$var$PAPER_NORMAL_WIDTH).css`
        /* We use padding top/left/right so we can override more easily */
        padding-left: ${$687fca20ff27caf1$var$PAPER_PADDING_SMALL};
        padding-right: ${$687fca20ff27caf1$var$PAPER_PADDING_SMALL};
    `};`;
const $687fca20ff27caf1$export$49f7b90a0c83f2b0 = /*#__PURE__*/ (0, $2UsNA.css)`padding-top:${$687fca20ff27caf1$var$PAPER_PADDING_TOP};padding-left:${$687fca20ff27caf1$var$PAPER_PADDING_LEFT_MOBILE};padding-right:${$687fca20ff27caf1$var$PAPER_PADDING_RIGHT_MOBILE};${$1p41U.fromCustom($687fca20ff27caf1$var$PAPER_NORMAL_WIDTH).css`
        /* We use padding top/left/right so we can override more easily */
        padding-left: ${$687fca20ff27caf1$var$PAPER_PADDING_LEFT_DESKTOP}px;
        padding-right: ${$687fca20ff27caf1$var$PAPER_PADDING_RIGHT_DESKTOP}px;
    `};`;
const $687fca20ff27caf1$export$bf9cd54d94ffe52b = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1jc43ym-4"
})`display:flex;flex-direction:column;flex:1 1 auto;${$687fca20ff27caf1$export$49f7b90a0c83f2b0};height:${(props)=>props.takeFullHeight ? '100%' : 'auto'};`;
const $687fca20ff27caf1$export$69bd0e70980f4e9f = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1jc43ym-5"
})`position:absolute;width:${$687fca20ff27caf1$var$PAPER_WIDTH_BASIS.px};height:inherit;right:0;bottom:0;top:0;left:50%;${$6t2I3.borderRadius};border-bottom-left-radius:0;border-bottom-right-radius:0;background-color:${"var(--ds-surface, #FFFFFF)"};box-shadow:${`var(--ds-shadow-overlay, ${`0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"} -${$4cxV2.multiple(0.5).px} ${'rgba(9, 30, 66, 0.25)'}, 0 0 1px ${'rgba(9, 30, 66, 0.31)'}`})`};z-index:${$3xuD5.pageInBannerLayout};transition:transform ${$b60z8.timingFunctions.easeInOutQuad} ${$687fca20ff27caf1$export$c04d9b45b952bb2f}ms;transform:${(props)=>`translate3d(-50%, ${props.hide ? '100%' : '0'}, 0) scale3d(${$687fca20ff27caf1$var$getScale(props.appearance)}, 1, 1)`};${$1p41U.fromCustom($687fca20ff27caf1$var$PAPER_NOTE_WIDTH).css`
        height: ${(props)=>props.appearance === 'note' ? `${$687fca20ff27caf1$var$PAPER_NOTE_HEIGHT}px` : 'inherit'};
        top: ${(props)=>props.appearance === 'note' ? `${$687fca20ff27caf1$var$PAPER_NOTE_MARGIN_TOP}px` : '0'};
    `};`;
const $687fca20ff27caf1$export$61905ae62c7860fb = /*#__PURE__*/ (0, $2UsNA.default)((0, $h89KC.Footer)).withConfig({
    componentId: "sc-1jc43ym-6"
})`left:0;right:0;height:${$4cxV2.multiple(6).px};padding:${"var(--ds-space-600, 48px)"} 0 ${"var(--ds-space-100, 8px)"} 0;display:flex;align-items:center;justify-content:center;`;

});



parcelRegister("bFb5j", function(module, exports) {
$parcel$export(module.exports, "ErrorLink", () => $178b7c94a8663fe0$export$d2c8415987899609);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $4QM8d = parcelRequire("4QM8d");

var $04X5p = parcelRequire("04X5p");

var $7FSs7 = parcelRequire("7FSs7");

var $bXs4i = parcelRequire("bXs4i");
const $178b7c94a8663fe0$export$d2c8415987899609 = ({ callToActionUrl: callToActionUrl, children: children })=>{
    if (callToActionUrl.includes((0, $bXs4i.LOGIN_ROUTE))) return /*#__PURE__*/ $8P7DW.createElement($178b7c94a8663fe0$export$f13d6b6525b315e0, {
        actionSubjectId: "redirectToLogin",
        href: (0, $7FSs7.getRelativeBasePath)() + callToActionUrl
    }, children);
    return /*#__PURE__*/ $8P7DW.createElement($178b7c94a8663fe0$export$a6c7ac8248d6e38a, {
        actionSubjectId: "callToAction",
        to: callToActionUrl
    }, children);
};
$178b7c94a8663fe0$export$d2c8415987899609.displayName = 'ErrorLink';
const $178b7c94a8663fe0$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $2UsNA.default)((0, $04X5p.default)).withConfig({
    componentId: "sc-1mmbyta-0"
})`text-align:center;`;
const $178b7c94a8663fe0$export$f13d6b6525b315e0 = /*#__PURE__*/ (0, $2UsNA.default)((0, $4QM8d.HtmlAnchor)).withConfig({
    componentId: "sc-1mmbyta-1"
})`text-align:center;`;

});
parcelRegister("04X5p", function(module, exports) {
$parcel$export(module.exports, "default", () => $2581e7c0ca3702d6$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $cS6Xr = parcelRequire("cS6Xr");
const $2581e7c0ca3702d6$export$1d567c320f4763bc = /*#__PURE__*/ (0, $2UsNA.css)`color:${(props)=>`var(--ds-link, ${props.theme.color})`};&:hover{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2581e7c0ca3702d6$var$ThemedLink = /*#__PURE__*/ (0, $2UsNA.default)((0, $cS6Xr.Link)).withConfig({
    componentId: "sc-1tr99za-0"
})`${$2581e7c0ca3702d6$export$1d567c320f4763bc};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$2581e7c0ca3702d6$export$2e2bcd8739ae039 = $2581e7c0ca3702d6$var$ThemedLink;

});
parcelRegister("cS6Xr", function(module, exports) {
$parcel$export(module.exports, "Link", () => $b5f00f89de8e5c7b$export$a6c7ac8248d6e38a);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("9wocP");
var $cKYBS = parcelRequire("cKYBS");

var $frgWG = parcelRequire("frgWG");

var $dc8j0 = parcelRequire("dc8j0");
const $b5f00f89de8e5c7b$var$InstrumentedLink = ({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, ...props })=>{
    const { to: to, target: target, ...rest } = props;
    if (typeof to === 'string') return /*#__PURE__*/ $8P7DW.createElement((0, $dc8j0.default), {
        to: to,
        target: target,
        ...rest
    });
    return /*#__PURE__*/ $8P7DW.createElement((0, $cKYBS.default), props);
};
const $b5f00f89de8e5c7b$export$a6c7ac8248d6e38a = (0, $frgWG.default)('link', {
    onClick: ()=>({
            action: 'clicked'
        })
})($b5f00f89de8e5c7b$var$InstrumentedLink);

});
parcelRegister("dc8j0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6384d41b0c9e465e$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $02U4x = parcelRequire("02U4x");
parcelRequire("9wocP");
var $cKYBS = parcelRequire("cKYBS");
var $21W2d = parcelRequire("21W2d");

const $6384d41b0c9e465e$export$d3010bc2e9cc1386 = (to, currentLocation)=>{
    // @ts-ignore the location provided by RRR is compatible with history location
    return (0, $02U4x.createLocation)(to, null, undefined, currentLocation);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6384d41b0c9e465e$var$isModifiedEvent = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
/**
 * In server side rendering we use memory history, which doesn't have the base name. hence append basename manually
 */ function $6384d41b0c9e465e$var$getHref(history, location) {
    return history.createHref(location);
}
/**
 * React resource router doesn't support baseUrl if the "to" property is a string.
 * We have to introduce this wrapper to workaround it otherwise the migration's surface area become too large.
 * Moving forward we should use "route" instead of string for the link component since it is better supported.
 *
 *  @deprecated this component shouldn't be used directly.
 */ const $6384d41b0c9e465e$var$BaseUrlRespectLink = (props)=>{
    const { to: to, onClick: onClick, history: history, location: location, ...rest } = props;
    const toAsLocation = $6384d41b0c9e465e$export$d3010bc2e9cc1386(to, location);
    const href = toAsLocation ? $6384d41b0c9e465e$var$getHref(history, toAsLocation) : '';
    const wrappedOnClick = (0, $8P7DW.useCallback)((e)=>{
        try {
            onClick && onClick(e);
        } catch (ex) {
            e.preventDefault();
            throw ex;
        }
        if (!e.defaultPrevented && (// onClick prevented default
        e.button === 0 || e.keyCode === 13) && // ignore everything but left clicks or enter
        (!props.target || props.target === '_self') && // let browser handle "target=_blank" etc.
        !$6384d41b0c9e465e$var$isModifiedEvent(e) // ignore clicks with modifier keys
        ) {
            e.preventDefault();
            const method = props.replace ? history.replace : history.push;
            method(toAsLocation);
        }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Disabling existing violation, should be fixed when revisited.
    return /*#__PURE__*/ $8P7DW.createElement((0, $cKYBS.default), {
        href: href,
        ...rest,
        onClick: wrappedOnClick
    });
};
const $6384d41b0c9e465e$var$BaseUrlRespectLinkWithRouter = (props)=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $21W2d.RouterSubscriber), null, (// @ts-ignore access private `history` store property
    { location: location, history: history })=>// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        /*#__PURE__*/ $8P7DW.createElement($6384d41b0c9e465e$var$BaseUrlRespectLink, {
            location: location,
            history: history,
            ...props
        }));
};
var $6384d41b0c9e465e$export$2e2bcd8739ae039 = $6384d41b0c9e465e$var$BaseUrlRespectLinkWithRouter;

});



parcelRegister("bXs4i", function(module, exports) {
$parcel$export(module.exports, "PORTAL_ROUTE_PREFIX", () => $fc242c271acc1e7c$export$2b06f7190715126f);
$parcel$export(module.exports, "LOGIN_ROUTE", () => $fc242c271acc1e7c$export$9f22ab6dfd3d5ec5);
$parcel$export(module.exports, "PROJECT_NAME", () => $fc242c271acc1e7c$export$cb77c55dd12a845e);
$parcel$export(module.exports, "anonymousScreenLayout", () => $fc242c271acc1e7c$export$205bfffc91265169);
const $fc242c271acc1e7c$export$2b06f7190715126f = '/portal/:portalId(\\d+)';
const $fc242c271acc1e7c$export$9f22ab6dfd3d5ec5 = '/user/login';
const $fc242c271acc1e7c$export$cb77c55dd12a845e = 'jira-servicedesk.ondemand';
const $fc242c271acc1e7c$export$205bfffc91265169 = Object.freeze({
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});

});


parcelRegister("kCCWm", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e171c299de54ff3$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $8e171c299de54ff3$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    permissionDenied: {
        defaultMessage: 'No Access',
        description: 'Message to show when user does not have the permission to access the portal.',
        id: 'cv.portal.permission.denied.error'
    },
    permissionDeniedMessage: {
        defaultMessage: "Sorry you're not allowed to see this.",
        description: 'Message to show when user does not have the permission to access the portal.',
        id: 'cv.portal.permission.denied.message'
    },
    notFound: {
        defaultMessage: 'Not Found',
        description: 'Heading to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.error'
    },
    notFoundMessage: {
        defaultMessage: 'We are having trouble finding that. Check the details and try again.',
        description: 'Message to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.message'
    },
    notFoundV2: {
        defaultMessage: 'Site not found',
        description: 'Heading to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.error.v2'
    },
    notFoundMessageV2: {
        defaultMessage: "We couldn\u2019t find the site. Check the details and try again.",
        description: 'Message to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.message.v2'
    },
    genericHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.error-page.generic.error.heading'
    },
    genericMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.error-page.generic.error.message'
    },
    offlineHeading: {
        defaultMessage: "You're disconnected from the internet",
        description: 'Title for the error message when the user was offline when trying to view a page',
        id: 'cv.portal.error-page.offline.heading'
    },
    offlineMessage: {
        defaultMessage: 'The internet may be out to lunch. Check your network connection and try again.',
        description: 'Title for the error message when the user was offline when trying to view a page',
        id: 'cv.portal.error-page.offline.message'
    }
});

});


parcelRegister("fBOCW", function(module, exports) {
$parcel$export(module.exports, "UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE", () => $15050ad71de8da3b$export$ac0ed14b86f6f7e1);

var $jByYr = parcelRequire("jByYr");

var $7DCEi = parcelRequire("7DCEi");

var $byuiX = parcelRequire("byuiX");

var $esvX7 = parcelRequire("esvX7");
const $15050ad71de8da3b$export$ac0ed14b86f6f7e1 = (0, $byuiX.createRelayResource)({
    type: 'UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE',
    getQuery: ({ match: match }, { cloudId: cloudId, accountType: accountType })=>{
        const { portalId: portalId, requestTypeId: requestTypeId } = match.params;
        return {
            parameters: (0, $esvX7.default),
            variables: {
                cloudId: cloudId,
                uiModificationsContext: {
                    viewType: 'JSMRequestCreate',
                    portalId: portalId ?? '',
                    requestTypeId: requestTypeId ? (0, $7DCEi.JiraServicedeskRequestTypeAri).create({
                        requestTypeId: requestTypeId,
                        activationId: (0, $jByYr.getActivationId)()
                    }).toString() : ''
                },
                forgeExtensionRenderingContext: {
                    portalId: match.params.portalId ?? ''
                }
            },
            options: {
                fetchPolicy: 'network-only'
            },
            /**
       * Covers the case for `/portal/:portalId` and `/portal/:portalId/group/:requestGroupId` without the `requestTypeId` parameter.
       */ isResourceDisabled: !portalId || !requestTypeId || accountType !== 'atlassian'
        };
    }
});

});
parcelRegister("7DCEi", function(module, exports) {
$parcel$export(module.exports, "JiraServicedeskRequestTypeAri", () => $58fa27cb2bb81911$export$eb8f42c57b94089e);

var $1Yr2p = parcelRequire("1Yr2p");

var $jmrxw = parcelRequire("jmrxw");

var $6LWYQ = parcelRequire("6LWYQ");
// src/jira-servicedesk/request-type/manifest.ts
var $58fa27cb2bb81911$var$jiraServicedeskRequestTypeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $1Yr2p.JiraServicedeskRequestTypeAriResourceOwner),
    resourceType: (0, $1Yr2p.JiraServicedeskRequestTypeAriResourceType),
    resourceIdSlug: "activation/{activationId}/{requestTypeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        requestTypeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-servicedesk/request-type/index.ts
var $58fa27cb2bb81911$export$eb8f42c57b94089e = class _JiraServicedeskRequestTypeAri extends (0, $jmrxw.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._requestTypeId = opts.resourceIdSegmentValues.requestTypeId;
    }
    get activationId() {
        return this._activationId;
    }
    get requestTypeId() {
        return this._requestTypeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $58fa27cb2bb81911$var$jiraServicedeskRequestTypeAriStaticOpts.qualifier,
            platformQualifier: $58fa27cb2bb81911$var$jiraServicedeskRequestTypeAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $58fa27cb2bb81911$var$jiraServicedeskRequestTypeAriStaticOpts.resourceOwner,
            resourceType: $58fa27cb2bb81911$var$jiraServicedeskRequestTypeAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.requestTypeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                requestTypeId: opts.requestTypeId
            }
        }, ariOpts = (0, $6LWYQ.AriParser).fromOpts(derivedOpts, $58fa27cb2bb81911$var$jiraServicedeskRequestTypeAriStaticOpts);
        return new _JiraServicedeskRequestTypeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6LWYQ.AriParser).fromString(maybeAri, $58fa27cb2bb81911$var$jiraServicedeskRequestTypeAriStaticOpts);
        return new _JiraServicedeskRequestTypeAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            requestTypeId: this.requestTypeId
        };
    }
};

});
parcelRegister("1Yr2p", function(module, exports) {
$parcel$export(module.exports, "JiraServicedeskRequestTypeAriResourceOwner", () => $17005e3083b0c5b0$export$3bb883071b0c8c1a);
$parcel$export(module.exports, "JiraServicedeskRequestTypeAriResourceType", () => $17005e3083b0c5b0$export$185a855be42467b5);
// src/jira-servicedesk/request-type/types.ts
var $17005e3083b0c5b0$export$3bb883071b0c8c1a = "jira-servicedesk", $17005e3083b0c5b0$export$185a855be42467b5 = "request-type";

});


parcelRegister("esvX7", function(module, exports) {
$parcel$export(module.exports, "default", () => $69bb8b5a9bed56b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a52901e462b4acff072267b0adc3686>>
 * @relayHash 1ab5a3c31c93d15066415c7122f4c697
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e45293f8a27ead7abd3ce9b719eca0f4e86961473ff018b8fd9a39c723ca81a9
const $69bb8b5a9bed56b5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "forgeExtensionRenderingContext"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "uiModificationsContext"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rootUiModificationsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "forgeExtensionRenderingContext",
                            "variableName": "forgeExtensionRenderingContext"
                        },
                        {
                            "kind": "Variable",
                            "name": "uiModificationsContext",
                            "variableName": "uiModificationsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "fragment_AtlassianUiModificationsCore_RootFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rootUiModificationsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "uiModificationsContext"
                                }
                            ],
                            "concreteType": "JiraAppUiModifications",
                            "kind": "LinkedField",
                            "name": "uiModifications",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appEnvId"
                                },
                                {
                                    "concreteType": "JiraUiModification",
                                    "kind": "LinkedField",
                                    "name": "uiModifications",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraForgeQuery",
                            "kind": "LinkedField",
                            "name": "forge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "uiModificationsExtensions",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "context",
                                            "variableName": "forgeExtensionRenderingContext"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "jira:uiModifications"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraForgeExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appVersion"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "installationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentKey"
                                        },
                                        {
                                            "concreteType": "JiraForgeExtensionLicense",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "active"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportEntitlementNumber"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "trialEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subscriptionEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEvaluation"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "billingPeriod"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementSlug"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "capabilitySet"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "properties"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        },
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "JiraForgeAppEgressDeclaration",
                                            "kind": "LinkedField",
                                            "name": "egress",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "addresses"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inScopeEUD"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraForgeInstallationConfigExtension",
                                            "kind": "LinkedField",
                                            "name": "installationConfig",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "consentUrl"
                                        },
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "enabled"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e45293f8a27ead7abd3ce9b719eca0f4e86961473ff018b8fd9a39c723ca81a9",
            "metadata": {},
            "name": "rootUiModificationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$69bb8b5a9bed56b5$var$node.hash = "9036ea3b10c5003976e51018f89bdc35";
var $69bb8b5a9bed56b5$export$2e2bcd8739ae039 = $69bb8b5a9bed56b5$var$node;

});


parcelRegister("9i6OK", function(module, exports) {
$parcel$export(module.exports, "ScreenErrorBoundary", () => (parcelRequire("3szzY")).default);

var $3szzY = parcelRequire("3szzY");

});
parcelRegister("3szzY", function(module, exports) {
$parcel$export(module.exports, "default", () => $afbcae61b9fa4c63$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $edC7N = parcelRequire("edC7N");
const $afbcae61b9fa4c63$var$ScreenErrorBoundary = ({ screenName: screenName, children: children, renderError: renderError })=>// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    /*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
        packageName: screenName,
        id: `${screenName}Screen`,
        renderError: renderError
    }, children);
var $afbcae61b9fa4c63$export$2e2bcd8739ae039 = $afbcae61b9fa4c63$var$ScreenErrorBoundary;

});


parcelRegister("4JEE5", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAnonymousSuccess", () => $f893a603e647e4db$export$c343a4f818004f01);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $f893a603e647e4db$export$c343a4f818004f01 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("ggS0N")), {
        moduleId: "./src/view/request-create-anonymous-success/request-create-anonymous-success.tsx"
    })
});

});
parcelRegister("ggS0N", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("eMUIc").then(()=>parcelRequire('fIB1z'));

});


parcelRegister("gJQFt", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePage", () => $516341de6714feb1$export$cf665508b87b4a0f);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $516341de6714feb1$var$loader = (0, $fGOkV.lazyForPaint)(()=>{
    return (parcelRequire("9G1VT"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-page/hocs.tsx"
});
const $516341de6714feb1$export$cf665508b87b4a0f = (0, $gweXC.default)({
    loader: $516341de6714feb1$var$loader
});

});
parcelRegister("9G1VT", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("kYF11").then(()=>parcelRequire('1a35Q'));

});


parcelRegister("eZZtS", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePageForHubs", () => $a83b4ce9d3c2cfcc$export$43b5a631464c5e8e);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $a83b4ce9d3c2cfcc$var$loader = (0, $fGOkV.lazyForPaint)(()=>{
    return (parcelRequire("agSMj"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-page/hub-variant/hub-variant.tsx"
});
const $a83b4ce9d3c2cfcc$export$43b5a631464c5e8e = (0, $gweXC.default)({
    loader: $a83b4ce9d3c2cfcc$var$loader
});

});
parcelRegister("agSMj", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("1j2Ac"),
    $j9MRt("kZXFN"),
    $j9MRt("fVo08"),
    $j9MRt("TcRZT"),
    $j9MRt("gUXUg"),
    $j9MRt("4Bauu"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("hcxtc"),
    $j9MRt("hMKE4"),
    $j9MRt("huqUq"),
    $j9MRt("76kjZ")
]).then(()=>parcelRequire('dyISv'));

});


parcelRegister("hfoxB", function(module, exports) {
$parcel$export(module.exports, "RequestFeedback", () => $2cb11deb56562b96$export$3dcde5242ce8b346);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $2cb11deb56562b96$export$3dcde5242ce8b346 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("63pJc")), {
        moduleId: "./src/view/request-feedback/hocs.tsx"
    })
});

});
parcelRegister("63pJc", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("29FOP").then(()=>parcelRequire('agwom'));

});


parcelRegister("cchjQ", function(module, exports) {
$parcel$export(module.exports, "Unsubscribe", () => $d9b044319f6a76d2$export$cf424b9d16eab6b0);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $d9b044319f6a76d2$export$cf424b9d16eab6b0 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("fscVd")), {
        moduleId: "./src/view/unsubscribe/hocs.tsx"
    })
});

});
parcelRegister("fscVd", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("iB8e9").then(()=>parcelRequire('1zNZv'));

});


parcelRegister("7g874", function(module, exports) {
$parcel$export(module.exports, "UserProfile", () => $e3c658044f13090e$export$b7b58f2e100445f7);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $e3c658044f13090e$var$loader = (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("jjMRl")), {
    moduleId: "./src/view/user-profile/hocs.tsx"
});
const $e3c658044f13090e$export$b7b58f2e100445f7 = (0, $gweXC.default)({
    loader: $e3c658044f13090e$var$loader
});

});
parcelRegister("jjMRl", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("a8P1D").then(()=>parcelRequire('kbEit'));

});


parcelRegister("g2qf8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cdceabcf1ebca57$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $iziiq = parcelRequire("iziiq");

var $fAqaB = parcelRequire("fAqaB");

var $8fLNY = parcelRequire("8fLNY");

var $86q7M = parcelRequire("86q7M");

var $lKEMb = parcelRequire("lKEMb");
class $3cdceabcf1ebca57$var$PortalScreenWithBrowserMetrics extends $8P7DW.Component {
    constructor(props){
        super(props), this.state = {
            screenWasHidden: false
        }, this.startTimer = (screenName)=>{
            const { preventBrowserMetricsTimerResetOnScreenMount: preventBrowserMetricsTimerResetOnScreenMount, stopBrowserMetricsTransitionToNewScreen: stopBrowserMetricsTransitionToNewScreen } = this.props;
            if (!preventBrowserMetricsTimerResetOnScreenMount) {
                (0, $lKEMb.devLog)('Browser metrics: starting timer for screen:', screenName);
                /**
       * Browser metrics v3 start page load
       */ (0, $fAqaB.startPageLoad)(screenName);
            } else stopBrowserMetricsTransitionToNewScreen();
        }, this.handleVisibilityChange = ()=>{
            this.setState({
                screenWasHidden: true
            });
        };
        this.startTimer(props.screenName);
    }
    // this must be called before post-mount and post-update lifecycle methods
    // to ensure it is called before `endTimer` is called.
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { screenName: screenName, screenId: screenId } = this.props;
        if (nextProps.screenName !== screenName || nextProps.screenId !== screenId) {
            this.setState({
                screenWasHidden: false
            });
            this.startTimer(nextProps.screenName);
        }
    }
    componentDidMount() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    render() {
        const { screenName: screenName, children: children, screenId: screenId } = this.props;
        // We need to set the screen name to undefined if the window visibility changed
        // so the browser metrics event never gets fired.
        // If the user changes tabs while the page is loading, the time to load is calculated incorrectly.
        // So we're discarding these events as a workaround. See FSD-3537.
        const screenNameForBrowserMetrics = this.state.screenWasHidden ? undefined : screenName;
        return /*#__PURE__*/ $8P7DW.createElement((0, $86q7M.ScreenNameProvider), {
            params: {
                screenId: screenId,
                screenName: screenNameForBrowserMetrics
            }
        }, /*#__PURE__*/ $8P7DW.createElement((0, $iziiq.AnalyticsContext), {
            sourceName: screenName,
            sourceType: (0, $iziiq.ScreenTypes).SCREEN
        }, children));
    }
}
/**
 * Establishes a new screen for analytics and browsermetrics purposes.
 * Will set analytics context, and start a browsermetrics timer for the screen.
 * @param screenName the name of the screen, fired in the event
 * @param screenId an optional further identifier for cases when a user can navigate between two
 * different screens with the same name, e.g. two request create screens for different request types
 */ const $3cdceabcf1ebca57$var$AnalyticsScreen = (props)=>{
    const { screenName: screenName, children: children, screenId: screenId } = props;
    return /*#__PURE__*/ $8P7DW.createElement((0, $8fLNY.BrowserMetricsScreenTransitionStatusContext).Consumer, null, (value)=>/*#__PURE__*/ $8P7DW.createElement($3cdceabcf1ebca57$var$PortalScreenWithBrowserMetrics, {
            screenName: screenName,
            screenId: screenId,
            preventBrowserMetricsTimerResetOnScreenMount: value.preventBrowserMetricsTimerResetOnScreenMount,
            stopBrowserMetricsTransitionToNewScreen: value.stopBrowserMetricsTransitionToNewScreen
        }, children));
};
var $3cdceabcf1ebca57$export$2e2bcd8739ae039 = $3cdceabcf1ebca57$var$AnalyticsScreen;

});
parcelRegister("86q7M", function(module, exports) {
$parcel$export(module.exports, "ScreenNameProvider", () => $ae6bd0284d0c0e68$export$e037354b8fc39c88);
$parcel$export(module.exports, "clearScreenName", () => $ae6bd0284d0c0e68$export$d4736a6a534144a);
$parcel$export(module.exports, "default", () => $ae6bd0284d0c0e68$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $ae6bd0284d0c0e68$var$ScreenNameContext = /*#__PURE__*/ $8P7DW.createContext({
    screenName: undefined
});
const $ae6bd0284d0c0e68$export$e037354b8fc39c88 = (props)=>/*#__PURE__*/ $8P7DW.createElement($ae6bd0284d0c0e68$var$ScreenNameContext.Provider, {
        value: props.params
    }, props.children);
const $ae6bd0284d0c0e68$export$d4736a6a534144a = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $8P7DW.createElement($ae6bd0284d0c0e68$var$ScreenNameContext.Provider, {
            value: {
                screenName: undefined
            }
        }, /*#__PURE__*/ $8P7DW.createElement(WrappedComponent, props));
const $ae6bd0284d0c0e68$var$withScreenName = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $8P7DW.createElement($ae6bd0284d0c0e68$var$ScreenNameContext.Consumer, null, (value)=>/*#__PURE__*/ $8P7DW.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
var $ae6bd0284d0c0e68$export$2e2bcd8739ae039 = $ae6bd0284d0c0e68$var$withScreenName;

});


parcelRegister("bpyxC", function(module, exports) {
$parcel$export(module.exports, "createRouteWithLayout", () => $8dc995650757696c$export$64cff199c78ee95d);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("9wocP");
var $bDnSZ = parcelRequire("bDnSZ");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");
parcelRequire("3ibrT");
var $lHAZd = parcelRequire("lHAZd");
const $8dc995650757696c$var$selector = (0, $ehscL.createSelector)((0, $8Wisn.getHeadless), (headerless)=>({
        headerless: headerless
    }));
const $8dc995650757696c$export$64cff199c78ee95d = (route, screenName, layoutProps)=>{
    const { path: path, component: component } = route;
    const LayoutRouteComponent = (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lHAZd.BannerWithPaperLayoutRoute), {
            path: path,
            component: component,
            layoutProps: {
                headerless: props.headerless,
                ...layoutProps
            },
            screenName: screenName
        });
    };
    return {
        ...route,
        component: (0, $bDnSZ.withRouter)((0, $jvoWT.default)($8dc995650757696c$var$selector)(LayoutRouteComponent))
    };
};

});
parcelRegister("3ibrT", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutRoute", () => (parcelRequire("lHAZd")).BannerWithPaperLayoutRoute);

var $lHAZd = parcelRequire("lHAZd");

});
parcelRegister("lHAZd", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutRoute", () => $0024886aa2b8cdad$export$fd1a0cfe11934244);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $HGACo = parcelRequire("HGACo");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("kIzxQ");
var $fsoF0 = parcelRequire("fsoF0");

var $1EFS8 = parcelRequire("1EFS8");

var $4peLG = parcelRequire("4peLG");

var $bz96n = parcelRequire("bz96n");
parcelRequire("aF744");
var $6tXMg = parcelRequire("6tXMg");
parcelRequire("dMDto");
var $eOHXx = parcelRequire("eOHXx");
parcelRequire("ebTjc");
var $datZD = parcelRequire("datZD");
const $0024886aa2b8cdad$export$75ef22cdda92e1da = (props)=>{
    const { children: children, helpCenterBanner: helpCenterBanner, ...restProps } = props;
    const [initialBannerUrl] = $8P7DW.useState(helpCenterBanner);
    // Use the useCachedUrl hook to handle the banner URL
    const { cachedBannerUrl: cachedBannerUrl, isLoading: isBannerImageLoading } = (0, $bz96n.useCachedUrl)(helpCenterBanner);
    if ((0, $HGACo.isUseHelpCenterRefresh)()) return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, (0, $1EFS8.default).checkGate('add_ufo_holds_to_help_center_banner') && /*#__PURE__*/ $8P7DW.createElement((0, $4peLG.default), {
        name: "banner-with-paper-layout-image-loader",
        hold: isBannerImageLoading
    }), (0, $1EFS8.default).checkGate('jsm_help_center_branding_image_improvement') && initialBannerUrl && /*#__PURE__*/ $8P7DW.createElement("link", {
        rel: "preload",
        as: "fetch",
        href: initialBannerUrl,
        crossOrigin: "anonymous"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $6tXMg.default), {
        ...restProps,
        helpCenterBanner: cachedBannerUrl || undefined
    }, children));
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, (0, $1EFS8.default).checkGate('add_ufo_holds_to_help_center_banner') && /*#__PURE__*/ $8P7DW.createElement((0, $4peLG.default), {
        name: "banner-with-paper-layout-image-loader",
        hold: isBannerImageLoading
    }), /*#__PURE__*/ $8P7DW.createElement((0, $eOHXx.default), {
        ...restProps,
        helpCenterBanner: cachedBannerUrl || undefined
    }, children));
};
const $0024886aa2b8cdad$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getHelpCenterBanner), (0, $fsoF0.getShown), (0, $ikoP4.getHelpCenterBrandingLoader), (helpCenterBanner, searchShown, isBrandingLoaded)=>({
        helpCenterBanner: helpCenterBanner,
        searchShown: searchShown,
        isBrandingLoaded: isBrandingLoaded
    }));
const $0024886aa2b8cdad$var$ConnectedBannerWithPaperLayout = (0, $jvoWT.default)($0024886aa2b8cdad$var$selector)($0024886aa2b8cdad$export$75ef22cdda92e1da);
const $0024886aa2b8cdad$export$fd1a0cfe11934244 = (0, $datZD.default)($0024886aa2b8cdad$var$ConnectedBannerWithPaperLayout);
var $0024886aa2b8cdad$export$2e2bcd8739ae039 = $0024886aa2b8cdad$var$ConnectedBannerWithPaperLayout;

});
parcelRegister("kIzxQ", function(module, exports) {
$parcel$export(module.exports, "getShown", () => (parcelRequire("fsoF0")).getShown);
$parcel$export(module.exports, "getTerm", () => (parcelRequire("fsoF0")).getTerm);

var $fsoF0 = parcelRequire("fsoF0");

});
parcelRegister("fsoF0", function(module, exports) {
$parcel$export(module.exports, "getShown", () => $1820295f3542e941$export$75d5ea8092347462);
$parcel$export(module.exports, "getTerm", () => $1820295f3542e941$export$3947fb2f9e53bfd);
const $1820295f3542e941$export$75d5ea8092347462 = (state)=>state.ui.search.shown;
const $1820295f3542e941$export$3947fb2f9e53bfd = (state)=>state.ui.search.term;

});


parcelRegister("bz96n", function(module, exports) {
$parcel$export(module.exports, "useCachedUrl", () => $93879fc06401459e$export$6c4a7056bc19c165);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $17wqU = parcelRequire("17wqU");

var $iziiq = parcelRequire("iziiq");

var $cXeeg = parcelRequire("cXeeg");
const $93879fc06401459e$export$6c4a7056bc19c165 = function(inputUrl) {
    const [cachedBannerUrl, setCachedBannerUrl] = (0, $8P7DW.useState)();
    const [isLoading, setIsLoading] = (0, $8P7DW.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    (0, $8P7DW.useEffect)(()=>{
        if (!!inputUrl && inputUrl.startsWith('blob:')) {
            setCachedBannerUrl(inputUrl);
            setIsLoading(false);
        } else if (!!inputUrl) (0, $cXeeg.getObjectURLFromMediaURLWithCaching)(inputUrl).then((url)=>{
            setCachedBannerUrl(url);
            setIsLoading(false);
        }).catch((error)=>{
            setIsLoading(false);
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'useCachedUrl',
                attributes: {
                    errorMessage: error.message
                }
            }).fire((0, $17wqU.ANALYTICS_BRIDGE_CHANNEL));
        });
        else {
            setCachedBannerUrl(null);
            setIsLoading(false);
        }
    }, [
        createAnalyticsEvent,
        inputUrl,
        setCachedBannerUrl
    ]);
    return {
        cachedBannerUrl: cachedBannerUrl,
        isLoading: isLoading
    };
};

});
parcelRegister("cXeeg", function(module, exports) {
$parcel$export(module.exports, "getObjectURLFromMediaURLWithCaching", () => $45c951d0044b3f2c$export$183e77d363d2e63e);

var $h1yZX = parcelRequire("h1yZX");

var $1EFS8 = parcelRequire("1EFS8");

var $c8JSl = parcelRequire("c8JSl");
const $45c951d0044b3f2c$var$PARAM_KEY_TOKEN = 'token';
const $45c951d0044b3f2c$var$PARAM_KEY_MAX_AGE = 'max-age';
const $45c951d0044b3f2c$var$PARAM_KEY_HEIGHT = 'height';
const $45c951d0044b3f2c$var$DEFAULT_PARAM_VALUE_MAX_AGE = '31536000'; // maximum value for max-age supported by media services
const $45c951d0044b3f2c$var$HEIGHT_MAX_PARAM_VALUE = '4096'; // maximum value for height supported by media services
const $45c951d0044b3f2c$var$MAX_RETRIES = 5;
const $45c951d0044b3f2c$var$MS_BETWEEN_TRIES = 500;
const $45c951d0044b3f2c$var$USE_ASYNC = true;
// A local cache for the blob URLs to avoid polluting blob storage
const $45c951d0044b3f2c$var$BLOB_CACHE = {};
const $45c951d0044b3f2c$var$BLOB_FUTURE_CACHE = {};
const $45c951d0044b3f2c$export$183e77d363d2e63e = (completeUrl, msBetweenTries = $45c951d0044b3f2c$var$MS_BETWEEN_TRIES)=>{
    return (0, $1EFS8.default).checkGate('jsm_help_center_branding_image_improvement') ? $45c951d0044b3f2c$var$internalGetObjectURLFromMediaURLWithCachingAndRace(completeUrl, msBetweenTries) : $45c951d0044b3f2c$var$internalGetObjectURLFromMediaURLWithCaching(completeUrl, msBetweenTries);
};
const $45c951d0044b3f2c$var$internalGetObjectURLFromMediaURLWithCaching = (completeUrl, msBetweenTries = $45c951d0044b3f2c$var$MS_BETWEEN_TRIES, tryNumber = 1)=>{
    // Suppressing existing violation. Please fix this.
    const { url: url, token: token } = $45c951d0044b3f2c$var$parseUrl(completeUrl);
    // if we already created a blob url for this url, just finish.
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if ($45c951d0044b3f2c$var$BLOB_CACHE[url]) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    return Promise.resolve($45c951d0044b3f2c$var$BLOB_CACHE[url]);
    const req = new XMLHttpRequest();
    req.open('GET', url, $45c951d0044b3f2c$var$USE_ASYNC);
    req.responseType = 'arraybuffer';
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    token && req.setRequestHeader('Authorization', `Bearer ${token}`);
    return new Promise((resolve, reject)=>{
        req.onload = ()=>{
            if (req.status === 200) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const blobUrl = (0, $c8JSl.createObjectURLFromResponse)(req.response, req.getResponseHeader('content-type'));
                // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                $45c951d0044b3f2c$var$BLOB_CACHE[url] = blobUrl;
                resolve(blobUrl);
            } else reject(req.statusText);
        };
        req.onerror = ()=>{
            if (req.status === 404 && tryNumber < $45c951d0044b3f2c$var$MAX_RETRIES) $45c951d0044b3f2c$var$wait(msBetweenTries).then(()=>$45c951d0044b3f2c$var$internalGetObjectURLFromMediaURLWithCaching(completeUrl, msBetweenTries, tryNumber + 1)).then(resolve, reject);
            else reject(req.statusText);
        };
        req.send();
    });
};
const $45c951d0044b3f2c$var$internalGetObjectURLFromMediaURLWithCachingAndRace = (completeUrl, msBetweenTries = $45c951d0044b3f2c$var$MS_BETWEEN_TRIES, tryNumber = 1)=>{
    const { url: url, token: token } = $45c951d0044b3f2c$var$parseUrl(completeUrl);
    if (tryNumber > $45c951d0044b3f2c$var$MAX_RETRIES) throw Error(`failed to load ${url} after ${$45c951d0044b3f2c$var$MAX_RETRIES} retries. Giving up.`);
    // during initial call: if we already requested a blob url for this url just return from cache
    if (tryNumber === 1 && $45c951d0044b3f2c$var$BLOB_FUTURE_CACHE[url] !== undefined) return $45c951d0044b3f2c$var$BLOB_FUTURE_CACHE[url];
    const preloadAbort = new AbortController();
    const cacheableFetch = fetch(url, {
        headers: token ? {
            Authorization: `Bearer ${token}`
        } : {}
    }).then((response)=>{
        if (response.ok) {
            preloadAbort.abort('cache was faster');
            return response.blob().then((blob)=>URL.createObjectURL(blob));
        }
        throw new Error(response.statusText);
    });
    const preloadableFetch = fetch(completeUrl, {
        signal: preloadAbort.signal
    }).then((response)=>{
        if (response.ok) return response.blob().then((blob)=>URL.createObjectURL(blob));
        throw new Error(response.statusText);
    });
    const racePromise = Promise.any([
        cacheableFetch,
        preloadableFetch
    ]).catch(()=>{
        return $45c951d0044b3f2c$var$wait(msBetweenTries).then(()=>$45c951d0044b3f2c$var$internalGetObjectURLFromMediaURLWithCachingAndRace(completeUrl, msBetweenTries, tryNumber + 1));
    });
    $45c951d0044b3f2c$var$BLOB_FUTURE_CACHE[url] = racePromise;
    return racePromise;
};
const $45c951d0044b3f2c$var$parseUrl = (completeUrl)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { url: url, query: query } = $h1yZX.parseUrl(completeUrl);
    // parse the url and token
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const mediaApiJwt = query[$45c951d0044b3f2c$var$PARAM_KEY_TOKEN];
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    delete query[$45c951d0044b3f2c$var$PARAM_KEY_TOKEN];
    // prepare the query string
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query[$45c951d0044b3f2c$var$PARAM_KEY_MAX_AGE] = $45c951d0044b3f2c$var$DEFAULT_PARAM_VALUE_MAX_AGE;
    // ensure no cropping/fitting/scaling of the image until we release the cropper
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query[$45c951d0044b3f2c$var$PARAM_KEY_HEIGHT] = $45c951d0044b3f2c$var$HEIGHT_MAX_PARAM_VALUE;
    const parsedUrl = `${url}?${$h1yZX.stringify(query)}`;
    return {
        url: parsedUrl,
        token: mediaApiJwt
    };
};
const $45c951d0044b3f2c$export$d2adf65b87e47523 = ()=>{
    Object.keys($45c951d0044b3f2c$var$BLOB_CACHE).forEach((cachedItem)=>{
        delete $45c951d0044b3f2c$var$BLOB_CACHE[cachedItem];
    });
    Object.keys($45c951d0044b3f2c$var$BLOB_FUTURE_CACHE).forEach((cachedItem)=>{
        delete $45c951d0044b3f2c$var$BLOB_FUTURE_CACHE[cachedItem];
    });
};
const $45c951d0044b3f2c$var$wait = (msBetweenTries)=>new Promise((r)=>setTimeout(r, msBetweenTries));

});
parcelRegister("c8JSl", function(module, exports) {
$parcel$export(module.exports, "createObjectURLFromResponse", () => $740f5d9b7fc89a23$export$c1dfa855638dae6c);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $740f5d9b7fc89a23$export$c1dfa855638dae6c = (response, contentType)=>{
    const arrayBuffer = [
        response
    ];
    const blob = new Blob(arrayBuffer, {
        type: contentType
    });
    return URL.createObjectURL(blob);
};

});



parcelRegister("aF744", function(module, exports) {
$parcel$export(module.exports, "BannerWithGridLayoutDumb", () => (parcelRequire("6tXMg")).default);

var $6tXMg = parcelRequire("6tXMg");

});
parcelRegister("6tXMg", function(module, exports) {
$parcel$export(module.exports, "default", () => $67edd095b5e68ab0$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");
parcelRequire("lMBOd");
var $3tfcE = parcelRequire("3tfcE");
parcelRequire("1Sfks");
var $17mEh = parcelRequire("17mEh");
parcelRequire("hGzcq");
var $lNFkx = parcelRequire("lNFkx");
parcelRequire("5431H");
var $bHMxE = parcelRequire("bHMxE");

var $cJncc = parcelRequire("cJncc");

var $1EFS8 = parcelRequire("1EFS8");

var $9qqCD = parcelRequire("9qqCD");
var $cM8t6 = parcelRequire("cM8t6");

var $bHMxE = parcelRequire("bHMxE");
parcelRequire("eAkv4");
var $l6xVB = parcelRequire("l6xVB");
parcelRequire("cyQYS");
var $c8pDc = parcelRequire("c8pDc");
const $67edd095b5e68ab0$var$PageLayoutContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cM8t6.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9qqCD.default), null, children));
/**
 * Paper in this context is the floating paper that is ontop of the banner.
 * Banner will have the background image chosen by the admin as well as the
 * theme color as background color.
 */ const $67edd095b5e68ab0$var$BannerWithGridLayoutDumb = ({ children: children, paperAppearance: paperAppearance, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, searchShown: searchShown, prefetchBrandingModel: prefetchBrandingModel, hideBanner: hideBanner, isCSM: isCSM, hideSkipToMainContent: hideSkipToMainContent })=>{
    const showCompressedBanner = ![
        'none',
        'note'
    ].includes(paperAppearance || 'normal');
    const BannerWithLayoutHeaderComponent = (0, $1EFS8.default).checkGate('request_create_perf_improvement_part_one') ? (0, $bHMxE.BannerWithLayoutHeaderMemoizedHOC) : (0, $bHMxE.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($67edd095b5e68ab0$var$PageLayoutContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($67edd095b5e68ab0$var$SidebarPusherRoot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($67edd095b5e68ab0$export$36525627ce333d44, {
        flipKey: searchShown,
        portalKey: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($67edd095b5e68ab0$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3tfcE.default), {
        className: "px-paper-layout"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(BannerWithLayoutHeaderComponent, {
        isAnonymous: isAnonymous,
        removeHeader: removeHeader,
        headerless: headerless,
        hideSearchButton: hideSearchButton,
        helpCenterBanner: helpCenterBanner,
        hideBanner: hideBanner,
        prefetchBrandingModel: prefetchBrandingModel,
        renderForPaperLayout: !showCompressedBanner
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l6xVB.default), {
        appearance: paperAppearance
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c8pDc.default), {
        appearance: paperAppearance,
        isCSM: isCSM,
        hideSkipToMainContent: hideSkipToMainContent
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cJncc.AutoHeightBody), null)))));
};
var $67edd095b5e68ab0$export$2e2bcd8739ae039 = $67edd095b5e68ab0$var$BannerWithGridLayoutDumb;
const $67edd095b5e68ab0$var$CONTAINER_MIN_HEIGHT = '100vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $67edd095b5e68ab0$var$SidebarPusherRoot = /*#__PURE__*/ (0, $2UsNA.default)((0, $lNFkx.default)).withConfig({
    componentId: "sc-kh8qt6-0"
})`display:flex;flex-direction:column;width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $67edd095b5e68ab0$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-kh8qt6-1"
})`display:flex;flex-direction:column;min-height:${$67edd095b5e68ab0$var$CONTAINER_MIN_HEIGHT};`;
const $67edd095b5e68ab0$export$36525627ce333d44 = /*#__PURE__*/ (0, $2UsNA.default)((0, $17mEh.Flipper)).withConfig({
    componentId: "sc-kh8qt6-2"
})`display:flex;flex-direction:column;`;

});
parcelRegister("1Sfks", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => (parcelRequire("17mEh")).Flipper);

var $17mEh = parcelRequire("17mEh");

});
parcelRegister("17mEh", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => $acdd67a3d37faa8f$export$3e759dc50fe56038);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("2U5lF");
var $8AhC2 = parcelRequire("8AhC2");
var $aWmfx = parcelRequire("aWmfx");
const $acdd67a3d37faa8f$export$3e759dc50fe56038 = (props)=>/*#__PURE__*/ $8P7DW.createElement((0, $aWmfx.default), {
        ...props,
        spring: {
            stiffness: 600,
            damping: 40
        }
    }, props.children);
const $acdd67a3d37faa8f$export$c3816ea9cb166de0 = (props)=>/*#__PURE__*/ $8P7DW.createElement((0, $8AhC2.default), props, props.children);

});
parcelRegister("2U5lF", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => (parcelRequire("aWmfx")).default);
$parcel$export(module.exports, "Flipped", () => (parcelRequire("8AhC2")).default);

var $aWmfx = parcelRequire("aWmfx");

var $8AhC2 = parcelRequire("8AhC2");

var $ela33 = parcelRequire("ela33");
var // for umd build
$21d4f5cf0da9d79e$export$2e2bcd8739ae039 = {
    Flipper: (0, $aWmfx.default),
    Flipped: (0, $8AhC2.default),
    ExitContainer: (0, $ela33.default)
};

});
parcelRegister("aWmfx", function(module, exports) {
$parcel$export(module.exports, "FlipContext", () => $7f70947b28355c7b$export$aa77f7b4e64b9ea9);
$parcel$export(module.exports, "PortalContext", () => $7f70947b28355c7b$export$60d741e20e0aa309);
$parcel$export(module.exports, "default", () => $7f70947b28355c7b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");


var $1VKiW = parcelRequire("1VKiW");

var $cMXVh = parcelRequire("cMXVh");
function $7f70947b28355c7b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7f70947b28355c7b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7f70947b28355c7b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7f70947b28355c7b$export$aa77f7b4e64b9ea9 = (0, $8P7DW.createContext)("flip");
var $7f70947b28355c7b$export$60d741e20e0aa309 = (0, $8P7DW.createContext)("portal");
var $7f70947b28355c7b$var$Flipper = function(_Component) {
    $7f70947b28355c7b$var$_inherits(Flipper, _Component);
    function Flipper(props) {
        $7f70947b28355c7b$var$_classCallCheck(this, Flipper);
        var _this = $7f70947b28355c7b$var$_possibleConstructorReturn(this, _Component.call(this, props));
        _this.inProgressAnimations = {};
        _this.flipCallbacks = {};
        return _this;
    }
    Flipper.prototype.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
        if (prevProps.flipKey !== this.props.flipKey) return (0, $cMXVh.getFlippedElementPositionsBeforeUpdate)({
            element: this.el,
            // if onExit callbacks exist here, we'll cache the DOM node
            flipCallbacks: this.flipCallbacks,
            inProgressAnimations: this.inProgressAnimations,
            portalKey: this.props.portalKey
        });
        return null;
    };
    Flipper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, cachedData) {
        if (this.props.flipKey !== prevProps.flipKey) (0, $1VKiW.default)({
            cachedFlipChildrenPositions: cachedData.flippedElementPositions,
            cachedOrderedFlipIds: cachedData.cachedOrderedFlipIds,
            containerEl: this.el,
            inProgressAnimations: this.inProgressAnimations,
            flipCallbacks: this.flipCallbacks,
            applyTransformOrigin: this.props.applyTransformOrigin,
            spring: this.props.spring,
            debug: this.props.debug,
            portalKey: this.props.portalKey,
            staggerConfig: this.props.staggerConfig,
            handleEnterUpdateDelete: this.props.handleEnterUpdateDelete,
            decisionData: {
                prev: prevProps.decisionData,
                current: this.props.decisionData
            }
        });
    };
    Flipper.prototype.render = function render() {
        var _this2 = this;
        var _props = this.props, element = _props.element, className = _props.className, portalKey = _props.portalKey;
        var Element = element;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($7f70947b28355c7b$export$60d741e20e0aa309.Provider, {
            value: portalKey
        }, (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($7f70947b28355c7b$export$aa77f7b4e64b9ea9.Provider, {
            value: this.flipCallbacks
        }, (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Element, {
            className: className,
            ref: function ref(el) {
                return _this2.el = el;
            }
        }, this.props.children)));
    };
    return Flipper;
}((0, $8P7DW.Component));
$7f70947b28355c7b$var$Flipper.propTypes = {};
$7f70947b28355c7b$var$Flipper.defaultProps = {
    applyTransformOrigin: true,
    element: "div"
};
var $7f70947b28355c7b$export$2e2bcd8739ae039 = $7f70947b28355c7b$var$Flipper;

});
parcelRegister("1VKiW", function(module, exports) {
$parcel$export(module.exports, "default", () => $167f086f308a68fc$export$2e2bcd8739ae039);

var $aR4wj = parcelRequire("aR4wj");

var $6eaHl = parcelRequire("6eaHl");

var $cMXVh = parcelRequire("cMXVh");

var $3oH7P = parcelRequire("3oH7P");

var $eVPal = parcelRequire("eVPal");
var $167f086f308a68fc$var$createScopedSelector = function createScopedSelector(element, portalKey) {
    if (portalKey) return function(selector) {
        return document.querySelectorAll("[" + $3oH7P.DATA_PORTAL_KEY + "=" + portalKey + "]" + selector);
    };
    else return function(selector) {
        return element.querySelectorAll(selector);
    };
};
var $167f086f308a68fc$var$createGetElementFunc = function createGetElementFunc(element, portalKey) {
    // this should only ever return 1 element
    return function(id) {
        return $167f086f308a68fc$var$createScopedSelector(element, portalKey)("[" + $3oH7P.DATA_FLIP_ID + "=\"" + id + "\"]")[0];
    };
};
var $167f086f308a68fc$var$onFlipKeyUpdate = function onFlipKeyUpdate(_ref) {
    var _ref$cachedOrderedFli = _ref.cachedOrderedFlipIds, cachedOrderedFlipIds = _ref$cachedOrderedFli === undefined ? [] : _ref$cachedOrderedFli, _ref$inProgressAnimat = _ref.inProgressAnimations, inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat, _ref$cachedFlipChildr = _ref.cachedFlipChildrenPositions, cachedFlipChildrenPositions = _ref$cachedFlipChildr === undefined ? {} : _ref$cachedFlipChildr, _ref$flipCallbacks = _ref.flipCallbacks, flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks, containerEl = _ref.containerEl, applyTransformOrigin = _ref.applyTransformOrigin, spring = _ref.spring, debug = _ref.debug, portalKey = _ref.portalKey, _ref$staggerConfig = _ref.staggerConfig, staggerConfig = _ref$staggerConfig === undefined ? {} : _ref$staggerConfig, _ref$decisionData = _ref.decisionData, decisionData = _ref$decisionData === undefined ? {} : _ref$decisionData, handleEnterUpdateDelete = _ref.handleEnterUpdateDelete;
    var newFlipChildrenPositions = (0, $cMXVh.getFlippedElementPositionsAfterUpdate)({
        element: containerEl,
        portalKey: portalKey
    });
    var scopedSelector = $167f086f308a68fc$var$createScopedSelector(containerEl, portalKey);
    var getElement = $167f086f308a68fc$var$createGetElementFunc(containerEl, portalKey);
    var isFlipped = function isFlipped(id) {
        return cachedFlipChildrenPositions[id] && newFlipChildrenPositions[id];
    };
    var unflippedIds = Object.keys(cachedFlipChildrenPositions).concat(Object.keys(newFlipChildrenPositions)).filter(function(id) {
        return !isFlipped(id);
    });
    var baseArgs = {
        flipCallbacks: flipCallbacks,
        getElement: getElement,
        cachedFlipChildrenPositions: cachedFlipChildrenPositions,
        newFlipChildrenPositions: newFlipChildrenPositions,
        inProgressAnimations: inProgressAnimations
    };
    var _animateUnflippedElem = (0, $aR4wj.default)((0, $eVPal.assign)({}, baseArgs, {
        unflippedIds: unflippedIds
    })), hideEnteringElements = _animateUnflippedElem.hideEnteringElements, animateEnteringElements = _animateUnflippedElem.animateEnteringElements, animateExitingElements = _animateUnflippedElem.animateExitingElements;
    var flippedIds = cachedOrderedFlipIds.filter(isFlipped);
    var animateFlippedElementsArgs = (0, $eVPal.assign)({}, baseArgs, {
        flippedIds: flippedIds,
        applyTransformOrigin: applyTransformOrigin,
        spring: spring,
        debug: debug,
        staggerConfig: staggerConfig,
        decisionData: decisionData,
        scopedSelector: scopedSelector
    });
    // the function handles putting flipped elements back in their original positions
    // and returns another function to actually call flip
    var flip = (0, $6eaHl.default)(animateFlippedElementsArgs);
    if (handleEnterUpdateDelete) handleEnterUpdateDelete({
        hideEnteringElements: hideEnteringElements,
        animateEnteringElements: animateEnteringElements,
        animateExitingElements: animateExitingElements,
        animateFlippedElements: flip
    });
    else {
        hideEnteringElements();
        animateExitingElements().then(animateEnteringElements);
        flip();
    }
};
var $167f086f308a68fc$export$2e2bcd8739ae039 = $167f086f308a68fc$var$onFlipKeyUpdate;

});
parcelRegister("aR4wj", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e725c38e0b10588$export$2e2bcd8739ae039);
var $7e725c38e0b10588$var$animateUnflippedElements = function animateUnflippedElements(_ref) {
    var unflippedIds = _ref.unflippedIds, flipCallbacks = _ref.flipCallbacks, getElement = _ref.getElement, newFlipChildrenPositions = _ref.newFlipChildrenPositions, cachedFlipChildrenPositions = _ref.cachedFlipChildrenPositions, inProgressAnimations = _ref.inProgressAnimations;
    var enteringElements = unflippedIds.filter(function(id) {
        return newFlipChildrenPositions[id] && flipCallbacks[id];
    });
    var exitingElementIds = unflippedIds.filter(function(id) {
        return cachedFlipChildrenPositions[id] && flipCallbacks[id] && flipCallbacks[id].onExit;
    });
    var hideEnteringElements = function hideEnteringElements() {
        enteringElements.forEach(function(id) {
            if (flipCallbacks[id] && flipCallbacks[id].onAppear) {
                var element = getElement(id);
                element.style.opacity = "0";
            }
        });
    };
    var animateEnteringElements = function animateEnteringElements() {
        enteringElements.forEach(function(id, i) {
            var element = getElement(id);
            if (flipCallbacks[id] && flipCallbacks[id].onAppear) flipCallbacks[id].onAppear(element, i);
        });
    };
    var closureResolve = void 0;
    var promiseToReturn = new Promise(function(resolve, reject) {
        closureResolve = resolve;
    });
    var fragmentTuples = [];
    var exitingElementCount = 0;
    var onExitCallbacks = exitingElementIds.map(function(id, i) {
        var _cachedFlipChildrenPo = cachedFlipChildrenPositions[id].domData, element = _cachedFlipChildrenPo.element, parent = _cachedFlipChildrenPo.parent, _cachedFlipChildrenPo2 = _cachedFlipChildrenPo.childPosition, top = _cachedFlipChildrenPo2.top, left = _cachedFlipChildrenPo2.left, width = _cachedFlipChildrenPo2.width, height = _cachedFlipChildrenPo2.height;
        // insert back into dom
        if (getComputedStyle(parent).position === "static") parent.style.position = "relative";
        element.style.transform = "matrix(1, 0, 0, 1, 0, 0)";
        element.style.position = "absolute";
        element.style.top = top + "px";
        element.style.left = left + "px";
        // taken out of the dom flow, the element might have lost these dimensions
        element.style.height = height + "px";
        element.style.width = width + "px";
        var fragmentTuple = fragmentTuples.filter(function(t) {
            return t[0] === parent;
        })[0];
        if (!fragmentTuple) {
            fragmentTuple = [
                parent,
                document.createDocumentFragment()
            ];
            fragmentTuples.push(fragmentTuple);
        }
        fragmentTuple[1].appendChild(element);
        exitingElementCount += 1;
        var stop = function stop() {
            try {
                parent.removeChild(element);
                exitingElementCount -= 1;
                if (exitingElementCount === 0) closureResolve();
            } catch (DOMException) {
            // the element is already gone
            }
        };
        inProgressAnimations[id] = {
            stop: stop
        };
        return function() {
            return flipCallbacks[id].onExit(element, i, stop);
        };
    });
    // now append all the fragments from the onExit callbacks
    // (we use fragments for performance)
    fragmentTuples.forEach(function(t) {
        var parent = t[0];
        var fragment = t[1];
        parent.appendChild(fragment);
    });
    if (!onExitCallbacks.length) closureResolve();
    var animateExitingElements = function animateExitingElements() {
        onExitCallbacks.forEach(function(c) {
            return c();
        });
        return promiseToReturn;
    };
    return {
        hideEnteringElements: hideEnteringElements,
        animateEnteringElements: animateEnteringElements,
        animateExitingElements: animateExitingElements
    };
};
var $7e725c38e0b10588$export$2e2bcd8739ae039 = $7e725c38e0b10588$var$animateUnflippedElements;

});

parcelRegister("6eaHl", function(module, exports) {
$parcel$export(module.exports, "default", () => $488c5948d1223ec4$export$2e2bcd8739ae039);

var $lQJnF = parcelRequire("lQJnF");

var $2jEGu = parcelRequire("2jEGu");

var $eVPal = parcelRequire("eVPal");

var $3oH7P = parcelRequire("3oH7P");

var $hYZAn = parcelRequire("hYZAn");

var $ev01S = parcelRequire("ev01S");
var $488c5948d1223ec4$export$3bb3cb1a74f66649 = function convertMatrix3dArrayTo2dArray(matrix) {
    return [
        0,
        1,
        4,
        5,
        12,
        13
    ].map(function(index) {
        return matrix[index];
    });
};
var $488c5948d1223ec4$export$ae3bd8c5261b681e = function convertMatrix2dArrayToString(matrix) {
    return "matrix(" + matrix.join(", ") + ")";
};
var $488c5948d1223ec4$export$7fd64b870f6a7bb9 = function invertTransformsForChildren(_ref) {
    var invertedChildren = _ref.invertedChildren, matrix = _ref.matrix, body = _ref.body;
    invertedChildren.forEach(function(_ref2) {
        var child = _ref2[0], childFlipConfig = _ref2[1];
        if (!body.contains(child)) return;
        var scaleX = matrix[0];
        var scaleY = matrix[3];
        var translateX = matrix[4];
        var translateY = matrix[5];
        var inverseVals = {
            translateX: 0,
            translateY: 0,
            scaleX: 1,
            scaleY: 1
        };
        var transformString = "";
        if (childFlipConfig.translate) {
            inverseVals.translateX = -translateX / scaleX;
            inverseVals.translateY = -translateY / scaleY;
            transformString += "translate(" + inverseVals.translateX + "px, " + inverseVals.translateY + "px)";
        }
        if (childFlipConfig.scale) {
            inverseVals.scaleX = 1 / scaleX;
            inverseVals.scaleY = 1 / scaleY;
            transformString += " scale(" + inverseVals.scaleX + ", " + inverseVals.scaleY + ")";
        }
        child.style.transform = transformString;
    });
};
var $488c5948d1223ec4$export$ca4fe190a8429f9e = function createApplyStylesFunc(_ref3) {
    var element = _ref3.element, invertedChildren = _ref3.invertedChildren, body = _ref3.body;
    return function(_ref4) {
        var matrix = _ref4.matrix, opacity = _ref4.opacity, forceMinVals = _ref4.forceMinVals;
        if ((0, $eVPal.isNumber)(opacity)) element.style.opacity = opacity;
        if (forceMinVals) {
            element.style.minHeight = "1px";
            element.style.minWidth = "1px";
        }
        if (!matrix) return;
        var stringTransform = $488c5948d1223ec4$export$ae3bd8c5261b681e(matrix);
        // keep a tiny, (hopefully) invisible rotateZ transform on the element to try to
        // prevent Chrome from pixel-snapping when scale transforms
        // are removed
        stringTransform = stringTransform === "matrix(1, 0, 0, 1, 0, 0)" ? "matrix(1, 0.00001, -0.00001, 1, 0, 0)" : stringTransform;
        element.style.transform = stringTransform;
        if (invertedChildren) $488c5948d1223ec4$export$7fd64b870f6a7bb9({
            invertedChildren: invertedChildren,
            matrix: matrix,
            body: body
        });
    };
};
var $488c5948d1223ec4$export$90503d75ca6e7d46 = function rectInViewport(_ref5) {
    var top = _ref5.top, bottom = _ref5.bottom, left = _ref5.left, right = _ref5.right;
    return top < window.innerHeight && bottom > 0 && left < window.innerWidth && right > 0;
};
var $488c5948d1223ec4$var$getInvertedChildren = function getInvertedChildren(element, id) {
    return (0, $eVPal.toArray)(element.querySelectorAll("[" + $3oH7P.DATA_INVERSE_FLIP_ID + "=\"" + id + "\"]"));
};
var $488c5948d1223ec4$export$3ec95ebfc77511bd = function tweenProp(start, end, position) {
    return start + (end - start) * position;
};
var $488c5948d1223ec4$var$animateFlippedElements = function animateFlippedElements(_ref6) {
    var flippedIds = _ref6.flippedIds, flipCallbacks = _ref6.flipCallbacks, inProgressAnimations = _ref6.inProgressAnimations, cachedFlipChildrenPositions = _ref6.cachedFlipChildrenPositions, newFlipChildrenPositions = _ref6.newFlipChildrenPositions, applyTransformOrigin = _ref6.applyTransformOrigin, spring = _ref6.spring, getElement = _ref6.getElement, debug = _ref6.debug, staggerConfig = _ref6.staggerConfig, decisionData = _ref6.decisionData, scopedSelector = _ref6.scopedSelector;
    var body = document.querySelector("body");
    // the stuff below is used so we can return a promise that resolves when all FLIP animations have
    // completed
    var closureResolve = void 0;
    var flipCompletedPromise = new Promise(function(resolve, reject) {
        closureResolve = resolve;
    });
    var withInitFuncs = void 0;
    var completedAnimationIds = [];
    if (debug) // eslint-disable-next-line no-console
    console.error('[react-flip-toolkit]\nThe "debug" prop is set to true. All FLIP animations will return at the beginning of the transition.');
    var duplicateFlipIds = (0, $eVPal.getDuplicateValsAsStrings)(flippedIds);
    if (duplicateFlipIds.length) // eslint-disable-next-line no-console
    console.error("[react-flip-toolkit]\nThere are currently multiple elements with the same flipId on the page.\nThe animation will only work if each Flipped component has a unique flipId.\nDuplicate flipId" + (duplicateFlipIds.length > 1 ? "s" : "") + ": " + duplicateFlipIds.join("\n"));
    var flipDataArray = flippedIds// take all the measurements we need
    // and return an object with animation functions + necessary data
    .map(function(id) {
        var prevRect = cachedFlipChildrenPositions[id].rect;
        var currentRect = newFlipChildrenPositions[id].rect;
        var prevOpacity = cachedFlipChildrenPositions[id].opacity;
        var currentOpacity = newFlipChildrenPositions[id].opacity;
        var needsForcedMinVals = currentRect.width < 1 || currentRect.height < 1;
        // don't animate elements outside of the user's viewport
        if (!$488c5948d1223ec4$export$90503d75ca6e7d46(prevRect) && !$488c5948d1223ec4$export$90503d75ca6e7d46(currentRect)) return false;
        // it's never going to be visible, so dont animate it
        if (prevRect.width === 0 && currentRect.width === 0 || prevRect.height === 0 && currentRect.height === 0) return false;
        var element = getElement(id);
        // this might happen if we are rapidly adding & removing elements(?)
        if (!element) return false;
        var flipConfig = JSON.parse(element.dataset.flipConfig);
        var springConfig = (0, $2jEGu.getSpringConfig)({
            flipperSpring: spring,
            flippedSpring: flipConfig.spring
        });
        var stagger = flipConfig.stagger === true ? "default" : flipConfig.stagger;
        var toReturn = {
            element: element,
            id: id,
            stagger: stagger,
            springConfig: springConfig,
            noOp: true
        };
        if (flipCallbacks[id] && flipCallbacks[id].shouldFlip) {
            var elementShouldFlip = flipCallbacks[id].shouldFlip(decisionData.prev, decisionData.current);
            // this element wont be animated, but its children might be
            if (!elementShouldFlip) return toReturn;
        }
        // don't animate elements that didn't change
        // but we might want to animate children
        if (prevRect.left === currentRect.left && prevRect.top === currentRect.top && prevRect.width === currentRect.width && prevRect.height === currentRect.height && prevOpacity === currentOpacity) // this element wont be animated, but its children might be
        return toReturn;
        toReturn.noOp = false;
        var currentTransform = $lQJnF.parse(newFlipChildrenPositions[id].transform);
        var toVals = {
            matrix: currentTransform
        };
        var fromVals = {};
        var transformsArray = [
            currentTransform
        ];
        // we're only going to animate the values that the child wants animated
        if (flipConfig.translate) {
            transformsArray.push($lQJnF.translateX(prevRect.left - currentRect.left));
            transformsArray.push($lQJnF.translateY(prevRect.top - currentRect.top));
        }
        // going any smaller than 1px breaks transitions in Chrome
        if (flipConfig.scale) {
            transformsArray.push($lQJnF.scaleX(Math.max(prevRect.width, 1) / Math.max(currentRect.width, 1)));
            transformsArray.push($lQJnF.scaleY(Math.max(prevRect.height, 1) / Math.max(currentRect.height, 1)));
        }
        if (flipConfig.opacity) {
            fromVals.opacity = prevOpacity;
            toVals.opacity = currentOpacity;
        }
        var invertedChildren = [];
        if (!flipCallbacks[id] || !flipCallbacks[id].shouldInvert || flipCallbacks[id].shouldInvert(decisionData.prev, decisionData.current)) invertedChildren = $488c5948d1223ec4$var$getInvertedChildren(element, id).map(function(c) {
            return [
                c,
                JSON.parse(c.dataset.flipConfig)
            ];
        });
        fromVals.matrix = $488c5948d1223ec4$export$3bb3cb1a74f66649(transformsArray.reduce($lQJnF.multiply));
        toVals.matrix = $488c5948d1223ec4$export$3bb3cb1a74f66649(toVals.matrix);
        var applyStyles = $488c5948d1223ec4$export$ca4fe190a8429f9e({
            element: element,
            invertedChildren: invertedChildren,
            body: body
        });
        var onComplete = void 0;
        if (flipCallbacks[id] && flipCallbacks[id].onComplete) {
            // must cache or else this could cause an error
            var cachedOnComplete = flipCallbacks[id].onComplete;
            onComplete = function onComplete() {
                return cachedOnComplete(element, decisionData.prev, decisionData.current);
            };
        }
        // this should be called when animation ends naturally
        // but also when it is interrupted
        // when it is called, the animation has already been cancelled
        var onAnimationEnd = function onAnimationEnd() {
            delete inProgressAnimations[id];
            (0, $eVPal.isFunction)(onComplete) && onComplete();
            if (needsForcedMinVals && element) {
                element.style.minHeight = "";
                element.style.minWidth = "";
            }
            completedAnimationIds.push(id);
            if (completedAnimationIds.length >= withInitFuncs.length) // we can theoretically call multiple times since a promise only resolves 1x
            // but that shouldnt happen
            closureResolve();
        };
        var animateOpacity = (0, $eVPal.isNumber)(fromVals.opacity) && fromVals.opacity !== toVals.opacity;
        var onStartCalled = false;
        var getOnUpdateFunc = function getOnUpdateFunc(stop) {
            inProgressAnimations[id] = {
                stop: stop,
                onComplete: onComplete
            };
            return function(spring) {
                //trigger the user provided onStart function
                if (!onStartCalled) {
                    onStartCalled = true;
                    if (flipCallbacks[id] && flipCallbacks[id].onStart) flipCallbacks[id].onStart(element, decisionData.prev, decisionData.current);
                }
                var currentValue = spring.getCurrentValue();
                if (!body.contains(element)) {
                    stop();
                    return;
                }
                var vals = {};
                vals.matrix = fromVals.matrix.map(function(fromVal, index) {
                    return $488c5948d1223ec4$export$3ec95ebfc77511bd(fromVal, toVals.matrix[index], currentValue);
                });
                if (animateOpacity) vals.opacity = $488c5948d1223ec4$export$3ec95ebfc77511bd(fromVals.opacity, toVals.opacity, currentValue);
                applyStyles(vals);
            };
        };
        var initializeFlip = function initializeFlip() {
            // before animating, immediately apply FLIP styles to prevent flicker
            applyStyles({
                matrix: fromVals.matrix,
                opacity: animateOpacity && fromVals.opacity,
                forceMinVals: needsForcedMinVals
            });
            // and batch any other style updates if necessary
            if (flipConfig.transformOrigin) element.style.transformOrigin = flipConfig.transformOrigin;
            else if (applyTransformOrigin) element.style.transformOrigin = "0 0";
            invertedChildren.forEach(function(_ref7) {
                var child = _ref7[0], childFlipConfig = _ref7[1];
                if (childFlipConfig.transformOrigin) child.style.transformOrigin = childFlipConfig.transformOrigin;
                else if (applyTransformOrigin) child.style.transformOrigin = "0 0";
            });
        };
        return (0, $eVPal.assign)({}, toReturn, {
            stagger: stagger,
            springConfig: springConfig,
            getOnUpdateFunc: getOnUpdateFunc,
            initializeFlip: initializeFlip,
            onAnimationEnd: onAnimationEnd
        });
    }).filter(function(x) {
        return x;
    });
    // we use this array to compare with completed animations
    // to decide when all animations are completed
    withInitFuncs = flipDataArray.filter(function(_ref8) {
        var initializeFlip = _ref8.initializeFlip;
        return Boolean(initializeFlip);
    });
    //  put items back in place
    withInitFuncs.forEach(function(_ref9) {
        var initializeFlip = _ref9.initializeFlip;
        return initializeFlip();
    });
    if (debug) return;
    var flipDict = flipDataArray.reduce(function(acc, curr) {
        acc[curr.id] = curr;
        return acc;
    }, {});
    // this function modifies flipDataArray in-place
    // by removing references to non-direct children
    // to enable recursive stagger
    var _filterFlipDescendant = (0, $hYZAn.default)({
        flipDict: flipDict,
        flippedIds: flippedIds,
        scopedSelector: scopedSelector
    }), topLevelChildren = _filterFlipDescendant.topLevelChildren;
    return function() {
        // there are no active FLIP animations, so immediately resolve the
        // returned promise
        if (!withInitFuncs.length) closureResolve();
        (0, $ev01S.default)({
            topLevelChildren: topLevelChildren,
            flipDict: flipDict,
            staggerConfig: staggerConfig
        });
        return flipCompletedPromise;
    };
};
var $488c5948d1223ec4$export$2e2bcd8739ae039 = $488c5948d1223ec4$var$animateFlippedElements;

});
parcelRegister("lQJnF", function(module, exports) {
$parcel$export(module.exports, "multiply", () => $fe81a7f79362fb61$export$2060d2db72cce88f);
$parcel$export(module.exports, "parse", () => $fe81a7f79362fb61$export$98e6a39c04603d36);
$parcel$export(module.exports, "scaleX", () => $fe81a7f79362fb61$export$55295ade51f88202);
$parcel$export(module.exports, "scaleY", () => $fe81a7f79362fb61$export$2092e2a44ac13bb2);
$parcel$export(module.exports, "translateX", () => $fe81a7f79362fb61$export$5667f2d3f182f284);
$parcel$export(module.exports, "translateY", () => $fe81a7f79362fb61$export$a1f0f3245f0cf0a4);
/*! @license Rematrix v0.2.3

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
*/ /**
 * @module Rematrix
 */ /**
 * Transformation matrices in the browser come in two flavors:
 *
 *  - `matrix` using 6 values (short)
 *  - `matrix3d` using 16 values (long)
 *
 * This utility follows this [conversion guide](https://goo.gl/EJlUQ1)
 * to expand short form matrices to their equivalent long form.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $fe81a7f79362fb61$export$d9468344d3651243(source) {
    if (source.constructor !== Array) throw new TypeError('Expected array.');
    if (source.length === 16) return source;
    if (source.length === 6) {
        var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
        matrix[0] = source[0];
        matrix[1] = source[1];
        matrix[4] = source[2];
        matrix[5] = source[3];
        matrix[12] = source[4];
        matrix[13] = source[5];
        return matrix;
    }
    throw new RangeError('Expected array with either 6 or 16 values.');
}
/**
 * Returns a matrix representing no transformation. The product of any matrix
 * multiplied by the identity matrix will be the original matrix.
 *
 * > **Tip:** Similar to how `5 * 1 === 5`, where `1` is the identity.
 *
 * @return {array}
 */ function $fe81a7f79362fb61$export$f0954fd7d5368655() {
    var matrix = [];
    for(var i = 0; i < 16; i++)i % 5 == 0 ? matrix.push(1) : matrix.push(0);
    return matrix;
}
/**
 * Returns a matrix describing the inverse transformation of the source
 * matrix. The product of any matrix multiplied by its inverse will be the
 * identity matrix.
 *
 * > **Tip:** Similar to how `5 * (1/5) === 1`, where `1/5` is the inverse.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $fe81a7f79362fb61$export$70ae2c07e401031b(source) {
    var m = $fe81a7f79362fb61$export$d9468344d3651243(source);
    var s0 = m[0] * m[5] - m[4] * m[1];
    var s1 = m[0] * m[6] - m[4] * m[2];
    var s2 = m[0] * m[7] - m[4] * m[3];
    var s3 = m[1] * m[6] - m[5] * m[2];
    var s4 = m[1] * m[7] - m[5] * m[3];
    var s5 = m[2] * m[7] - m[6] * m[3];
    var c5 = m[10] * m[15] - m[14] * m[11];
    var c4 = m[9] * m[15] - m[13] * m[11];
    var c3 = m[9] * m[14] - m[13] * m[10];
    var c2 = m[8] * m[15] - m[12] * m[11];
    var c1 = m[8] * m[14] - m[12] * m[10];
    var c0 = m[8] * m[13] - m[12] * m[9];
    var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
    if (isNaN(determinant) || determinant === Infinity) throw new Error('Inverse determinant attempted to divide by zero.');
    return [
        (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
        (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
        (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
        (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
        (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
        (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
        (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
        (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
        (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
        (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
        (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
        (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
        (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
        (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
        (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
        (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
    ];
}
/**
 * Returns a 4x4 matrix describing the combined transformations
 * of both arguments.
 *
 * > **Note:** Order is very important. For example, rotating 45°
 * along the Z-axis, followed by translating 500 pixels along the
 * Y-axis... is not the same as translating 500 pixels along the
 * Y-axis, followed by rotating 45° along on the Z-axis.
 *
 * @param  {array} m - Accepts both short and long form matrices.
 * @param  {array} x - Accepts both short and long form matrices.
 * @return {array}
 */ function $fe81a7f79362fb61$export$2060d2db72cce88f(m, x) {
    var fm = $fe81a7f79362fb61$export$d9468344d3651243(m);
    var fx = $fe81a7f79362fb61$export$d9468344d3651243(x);
    var product = [];
    for(var i = 0; i < 4; i++){
        var row = [
            fm[i],
            fm[i + 4],
            fm[i + 8],
            fm[i + 12]
        ];
        for(var j = 0; j < 4; j++){
            var k = j * 4;
            var col = [
                fx[k],
                fx[k + 1],
                fx[k + 2],
                fx[k + 3]
            ];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
        }
    }
    return product;
}
/**
 * Attempts to return a 4x4 matrix describing the CSS transform
 * matrix passed in, but will return the identity matrix as a
 * fallback.
 *
 * **Tip:** In virtually all cases, this method is used to convert
 * a CSS matrix (retrieved as a `string` from computed styles) to
 * its equivalent array format.
 *
 * @param  {string} source - String containing a valid CSS `matrix` or `matrix3d` property.
 * @return {array}
 */ function $fe81a7f79362fb61$export$98e6a39c04603d36(source) {
    if (typeof source === 'string') {
        var match = source.match(/matrix(3d)?\(([^)]+)\)/);
        if (match) {
            var raw = match[2].split(', ').map(parseFloat);
            return $fe81a7f79362fb61$export$d9468344d3651243(raw);
        }
    }
    return $fe81a7f79362fb61$export$f0954fd7d5368655();
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $fe81a7f79362fb61$export$bb628a54ab399bc9(angle) {
    return $fe81a7f79362fb61$export$ea6eae3365de5b9c(angle);
}
/**
 * Returns a 4x4 matrix describing X-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $fe81a7f79362fb61$export$a59c8716592e09af(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[5] = matrix[10] = Math.cos(theta);
    matrix[6] = matrix[9] = Math.sin(theta);
    matrix[9] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $fe81a7f79362fb61$export$cf71e4d4ca4d1cfd(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[0] = matrix[10] = Math.cos(theta);
    matrix[2] = matrix[8] = Math.sin(theta);
    matrix[2] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $fe81a7f79362fb61$export$ea6eae3365de5b9c(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[0] = matrix[5] = Math.cos(theta);
    matrix[1] = matrix[4] = Math.sin(theta);
    matrix[4] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D scaling. The first argument
 * is used for both X and Y-axis scaling, unless an optional
 * second argument is provided to explicitly define Y-axis scaling.
 *
 * @param  {number} scalar    - Decimal multiplier.
 * @param  {number} [scalarY] - Decimal multiplier.
 * @return {array}
 */ function $fe81a7f79362fb61$export$dcdf75081b88279d(scalar, scalarY) {
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[0] = scalar;
    matrix[5] = typeof scalarY === 'number' ? scalarY : scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $fe81a7f79362fb61$export$55295ade51f88202(scalar) {
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[0] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $fe81a7f79362fb61$export$2092e2a44ac13bb2(scalar) {
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[5] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $fe81a7f79362fb61$export$13034b1ece9569d5(scalar) {
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[10] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing shear. The first argument
 * defines X-axis shearing, and an optional second argument
 * defines Y-axis shearing.
 *
 * @param  {number} angleX   - Measured in degrees.
 * @param  {number} [angleY] - Measured in degrees.
 * @return {array}
 */ function $fe81a7f79362fb61$export$dd2d5a892675faf1(angleX, angleY) {
    var thetaX = Math.PI / 180 * angleX;
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[4] = Math.tan(thetaX);
    if (angleY) {
        var thetaY = Math.PI / 180 * angleY;
        matrix[1] = Math.tan(thetaY);
    }
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis shear.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $fe81a7f79362fb61$export$e446fc4c2803fd1b(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[4] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis shear.
 *
 * @param  {number} angle - Measured in degrees
 * @return {array}
 */ function $fe81a7f79362fb61$export$1649e48e73861f36(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[1] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D translation. The first
 * argument defines X-axis translation, and an optional second
 * argument defines Y-axis translation.
 *
 * @param  {number} distanceX   - Measured in pixels.
 * @param  {number} [distanceY] - Measured in pixels.
 * @return {array}
 */ function $fe81a7f79362fb61$export$d73ee8ef04f5226a(distanceX, distanceY) {
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[12] = distanceX;
    if (distanceY) matrix[13] = distanceY;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $fe81a7f79362fb61$export$5667f2d3f182f284(distance) {
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[12] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $fe81a7f79362fb61$export$a1f0f3245f0cf0a4(distance) {
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[13] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $fe81a7f79362fb61$export$6e43fd17fc519956(distance) {
    var matrix = $fe81a7f79362fb61$export$f0954fd7d5368655();
    matrix[14] = distance;
    return matrix;
}

});

parcelRegister("2jEGu", function(module, exports) {
$parcel$export(module.exports, "getSpringConfig", () => $1afcea3411b436f1$export$29bc3b1ca84e38c8);

var $eVPal = parcelRequire("eVPal");
var $1afcea3411b436f1$export$31bbaa982ba04c49 = {
    noWobble: {
        stiffness: 200,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    veryGentle: {
        stiffness: 130,
        damping: 17
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 260,
        damping: 26
    }
};
var $1afcea3411b436f1$export$29bc3b1ca84e38c8 = function getSpringConfig() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, flipperSpring = _ref.flipperSpring, flippedSpring = _ref.flippedSpring;
    var normalizeSpring = function normalizeSpring(spring) {
        if ((0, $eVPal.isObject)(spring)) return spring;
        else if ($1afcea3411b436f1$export$31bbaa982ba04c49[spring]) return $1afcea3411b436f1$export$31bbaa982ba04c49[spring];
        else return {};
    };
    return (0, $eVPal.assign)({}, $1afcea3411b436f1$export$31bbaa982ba04c49.noWobble, normalizeSpring(flipperSpring), normalizeSpring(flippedSpring));
};

});
parcelRegister("eVPal", function(module, exports) {
$parcel$export(module.exports, "isNumber", () => $adee140a732ec151$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $adee140a732ec151$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isObject", () => $adee140a732ec151$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "toArray", () => $adee140a732ec151$export$45b10814cc054894);
$parcel$export(module.exports, "getDuplicateValsAsStrings", () => $adee140a732ec151$export$b118174c74c51022);
$parcel$export(module.exports, "assign", () => $adee140a732ec151$export$e6e34fd1f2686227);
var $adee140a732ec151$export$7e4aa119212bc614 = function isNumber(x) {
    return typeof x === "number";
};
var $adee140a732ec151$export$f6e2535fb5126e54 = function isFunction(x) {
    return typeof x === "function";
};
var $adee140a732ec151$export$a6cdc56e425d0d0a = function isObject(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
};
var $adee140a732ec151$export$45b10814cc054894 = function toArray(arrayLike) {
    return Array.prototype.slice.apply(arrayLike);
};
var $adee140a732ec151$export$b118174c74c51022 = function getDuplicateValsAsStrings(arr) {
    var obj = arr.reduce(function(acc, curr) {
        acc[curr] = acc[curr] ? acc[curr] + 1 : 1;
        return acc;
    }, {});
    return Object.keys(obj).filter(function(val) {
        return obj[val] > 1;
    });
};
var $adee140a732ec151$export$e6e34fd1f2686227 = function assign(target) {
    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    args.forEach(function(arg) {
        if (!arg) return;
        // Skip over if undefined or null
        for(var nextKey in arg)// Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(arg, nextKey)) target[nextKey] = arg[nextKey];
    });
    return target;
};

});


parcelRegister("3oH7P", function(module, exports) {
$parcel$export(module.exports, "DATA_FLIP_ID", () => $279510c3cdfcd38e$export$4e7d89757a685662);
$parcel$export(module.exports, "DATA_INVERSE_FLIP_ID", () => $279510c3cdfcd38e$export$6e4fe3c088b4bf3f);
$parcel$export(module.exports, "DATA_FLIP_CONFIG", () => $279510c3cdfcd38e$export$94198d9f80ac9749);
$parcel$export(module.exports, "DATA_PORTAL_KEY", () => $279510c3cdfcd38e$export$a5965b078f441f7e);
$parcel$export(module.exports, "DATA_EXIT_CONTAINER", () => $279510c3cdfcd38e$export$ee2a39d85d3284e4);
var $279510c3cdfcd38e$export$4e7d89757a685662 = "data-flip-id";
var $279510c3cdfcd38e$export$6e4fe3c088b4bf3f = "data-inverse-flip-id";
var $279510c3cdfcd38e$export$49e62738b103b74e = "data-flip-component-id";
var $279510c3cdfcd38e$export$94198d9f80ac9749 = "data-flip-config";
var $279510c3cdfcd38e$export$a5965b078f441f7e = "data-portal-key";
var $279510c3cdfcd38e$export$ee2a39d85d3284e4 = "data-exit-container";

});

parcelRegister("hYZAn", function(module, exports) {
$parcel$export(module.exports, "default", () => $d177cfeb758b00d5$export$2e2bcd8739ae039);

var $eVPal = parcelRequire("eVPal");

var $3oH7P = parcelRequire("3oH7P");
// scoped selector makes sure we're querying inside the right Flipper
// container, either internally or with the right portal key
var $d177cfeb758b00d5$var$selectFlipChildIds = function selectFlipChildIds(scopedSelector, selector, flippedIds) {
    var childIds = (0, $eVPal.toArray)(scopedSelector(selector)).map(function(el) {
        return el.dataset.flipId;
    });
    // now return an array ordered by the original order in the DOM
    return flippedIds.filter(function(id) {
        return childIds.indexOf(id) > -1;
    });
};
var $d177cfeb758b00d5$var$baseSelector = "[" + $3oH7P.DATA_FLIP_ID + "]";
var $d177cfeb758b00d5$export$2e2bcd8739ae039 = function(_ref) {
    var flipDict = _ref.flipDict, flippedIds = _ref.flippedIds, scopedSelector = _ref.scopedSelector;
    var levelToChildren = {};
    var buildHierarchy = function buildHierarchy(selector, level, oldResult) {
        var newSelector = selector + " " + $d177cfeb758b00d5$var$baseSelector;
        // make sure this is scoped to the Flipper element in case there are
        // mulitiple Flipper elements on the page
        var newResult = $d177cfeb758b00d5$var$selectFlipChildIds(scopedSelector, newSelector, flippedIds);
        var oldLevelChildren = oldResult.filter(function(id) {
            return newResult.indexOf(id) === -1;
        });
        levelToChildren[level] = oldLevelChildren;
        oldLevelChildren.forEach(function(childId) {
            if (flipDict[childId]) flipDict[childId].level = level;
        });
        if (newResult.length !== 0) buildHierarchy(newSelector, level + 1, newResult);
    };
    // the top level selectChildFlipIds should use the scopedSelector,
    buildHierarchy($d177cfeb758b00d5$var$baseSelector, 0, $d177cfeb758b00d5$var$selectFlipChildIds(scopedSelector, $d177cfeb758b00d5$var$baseSelector, flippedIds));
    // now make sure childIds in each flippedData contains only direct children
    // since to enable nested stagger  we want each parent to be able to kick off
    // the animations only for its direct children
    Object.keys(flipDict).forEach(function(flipId) {
        var data = flipDict[flipId];
        // scop by parent element
        data.childIds = $d177cfeb758b00d5$var$selectFlipChildIds(function(selector) {
            return data.element.querySelectorAll(selector);
        }, $d177cfeb758b00d5$var$baseSelector, flippedIds);
        data.childIds = data.childIds.filter(function(id) {
            return levelToChildren[data.level + 1] && levelToChildren[data.level + 1].indexOf(id) > -1;
        });
    });
    return {
        topLevelChildren: levelToChildren["0"]
    };
};

});

parcelRegister("ev01S", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8e3fbc2643ffccc$export$2e2bcd8739ae039);

var $hfQH4 = parcelRequire("hfQH4");
var $a8e3fbc2643ffccc$var$initiateImmediateAnimations = function initiateImmediateAnimations(immediate) {
    if (!immediate) return;
    immediate.forEach(function(flipped) {
        (0, $hfQH4.createSpring)(flipped);
        initiateImmediateAnimations(flipped.immediate);
    });
};
var $a8e3fbc2643ffccc$export$5e8092f8b030bcec = function createCallTree(_ref) {
    var flipDict = _ref.flipDict, topLevelChildren = _ref.topLevelChildren, initiateStaggeredAnimations = _ref.initiateStaggeredAnimations;
    //build a data struct to run the springs
    var tree = {
        root: {
            staggeredChildren: {},
            immediateChildren: []
        }
    };
    var appendChild = function appendChild(parent, childId) {
        var flipData = flipDict[childId];
        // might have been filtered (e.g. because it was off screen)
        if (!flipData) return;
        if (flipData.stagger) parent.staggeredChildren[flipData.stagger] ? parent.staggeredChildren[flipData.stagger].push(flipData) : parent.staggeredChildren[flipData.stagger] = [
            flipData
        ];
        else parent.immediateChildren.push(flipData);
        // only when the spring is first activated, activate the child animations as well
        // this enables nested stagger
        flipData.onSpringActivate = function() {
            $a8e3fbc2643ffccc$var$initiateImmediateAnimations(flipData.immediateChildren);
            initiateStaggeredAnimations(flipData.staggeredChildren);
        };
        flipData.staggeredChildren = {};
        flipData.immediateChildren = [];
        flipData.childIds.forEach(function(childId) {
            return appendChild(flipData, childId);
        });
    };
    // create the nested structure
    topLevelChildren.forEach(function(c) {
        appendChild(tree.root, c);
    });
    return tree;
};
var $a8e3fbc2643ffccc$export$2e2bcd8739ae039 = function(_ref2) {
    var staggerConfig = _ref2.staggerConfig, flipDict = _ref2.flipDict, topLevelChildren = _ref2.topLevelChildren;
    var initiateStaggeredAnimations = function initiateStaggeredAnimations(staggered) {
        if (!staggered || !Object.keys(staggered).length) return;
        Object.keys(staggered).forEach(function(staggerKey) {
            return (0, $hfQH4.staggeredSprings)(staggered[staggerKey], staggerConfig[staggerKey]);
        });
    };
    var tree = $a8e3fbc2643ffccc$export$5e8092f8b030bcec({
        flipDict: flipDict,
        topLevelChildren: topLevelChildren,
        initiateStaggeredAnimations: initiateStaggeredAnimations
    });
    $a8e3fbc2643ffccc$var$initiateImmediateAnimations(tree.root.immediateChildren);
    initiateStaggeredAnimations(tree.root.staggeredChildren);
};

});
parcelRegister("hfQH4", function(module, exports) {
$parcel$export(module.exports, "createSpring", () => $c8fcb63aa74e1fad$export$d1f8fcb84651afa9);
$parcel$export(module.exports, "staggeredSprings", () => $c8fcb63aa74e1fad$export$ac7d870a005a890f);
parcelRequire("l2rJq");
var $bzJV3 = parcelRequire("bzJV3");
// this should get created only 1x
var $c8fcb63aa74e1fad$var$springSystem = new (0, $bzJV3.default)();
var $c8fcb63aa74e1fad$export$1c192fd9ecdd1c80 = function createSuspendedSpring(_ref) {
    var _ref$springConfig = _ref.springConfig, stiffness = _ref$springConfig.stiffness, damping = _ref$springConfig.damping, overshootClamping = _ref$springConfig.overshootClamping, noOp = _ref.noOp, onSpringActivate = _ref.onSpringActivate, getOnUpdateFunc = _ref.getOnUpdateFunc, onAnimationEnd = _ref.onAnimationEnd;
    if (noOp) return;
    var spring = $c8fcb63aa74e1fad$var$springSystem.createSpring(stiffness, damping);
    spring.setOvershootClampingEnabled(!!overshootClamping);
    spring.addListener({
        onSpringActivate: onSpringActivate,
        onSpringUpdate: getOnUpdateFunc(spring.destroy.bind(spring)),
        onSpringAtRest: function onSpringAtRest() {
            // prevent SpringSystem from caching unused springs
            spring.destroy();
            onAnimationEnd();
        }
    });
    return spring;
};
var $c8fcb63aa74e1fad$export$d1f8fcb84651afa9 = function createSpring(flipped) {
    var spring = $c8fcb63aa74e1fad$export$1c192fd9ecdd1c80(flipped);
    if (spring) spring.setEndValue(1);
    else // even if it was a noop,
    // we still need to call onSpringActivate in case it calls
    // cascading flip initiation functions
    flipped.onSpringActivate();
};
var $c8fcb63aa74e1fad$export$ac7d870a005a890f = function staggeredSprings(flippedArray) {
    var staggerConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!flippedArray || !flippedArray.length) return;
    if (staggerConfig.reverse) flippedArray.reverse();
    var normalizedSpeed = staggerConfig.speed ? 1 + Math.max(Math.min(staggerConfig.speed, 0), 1) : 1.1;
    var nextThreshold = 1 / Math.max(Math.min(flippedArray.length, 100), 10);
    var springFuncs = flippedArray.filter(function(flipped) {
        return !flipped.noOp;
    }).map(function(flipped, i) {
        var cachedGetOnUpdate = flipped.getOnUpdateFunc;
        // modify the update function to adjust
        // the end value of the trailing Flipped component
        flipped.getOnUpdateFunc = function(stop) {
            var onUpdate = cachedGetOnUpdate(stop);
            return function(spring) {
                var currentValue = spring.getCurrentValue();
                if (currentValue > nextThreshold) springFuncs[i + 1] && springFuncs[i + 1].setEndValue(Math.min(currentValue * normalizedSpeed, 1));
                // now call the actual update function
                onUpdate(spring);
            };
        };
        return flipped;
    }).map(function(flipped) {
        return $c8fcb63aa74e1fad$export$1c192fd9ecdd1c80(flipped);
    });
    springFuncs[0] && springFuncs[0].setEndValue(1);
};

});
parcelRegister("l2rJq", function(module, exports) {
$parcel$export(module.exports, "SpringSystem", () => (parcelRequire("bzJV3")).default);
/**
 *  Copyright (c) 2013, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 *      
 */ 
var $bzJV3 = parcelRequire("bzJV3");

var $a1W0w = parcelRequire("a1W0w");

});
parcelRegister("bzJV3", function(module, exports) {
$parcel$export(module.exports, "default", () => $86d695386a02e65b$export$2e2bcd8739ae039);

var $cn4ia = parcelRequire("cn4ia");

var $3fEMs = parcelRequire("3fEMs");

var $a1W0w = parcelRequire("a1W0w");
function $86d695386a02e65b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * A set of Springs that all run on the same physics
 * timing loop. To get started with a Rebound animation, first
 * create a new SpringSystem and then add springs to it.
 * @public
 */ var $86d695386a02e65b$var$SpringSystem = function() {
    function SpringSystem(looper) {
        $86d695386a02e65b$var$_classCallCheck(this, SpringSystem);
        this.looper = looper || new (0, $cn4ia.AnimationLooper)();
        this.looper.springSystem = this;
        this.listeners = [];
        this._activeSprings = [];
        this._idleSpringIndices = [];
        this._isIdle = true;
        this._lastTimeMillis = -1;
        this._springRegistry = {};
    }
    /**
   * Add a new spring to this SpringSystem. This Spring will now be solved for
   * during the physics iteration loop. By default the spring will use the
   * default Origami spring config with 40 tension and 7 friction, but you can
   * also provide your own values here.
   * @public
   */ SpringSystem.prototype.createSpring = function createSpring(tension, friction) {
        return this.createSpringWithConfig({
            tension: tension,
            friction: friction
        });
    };
    /**
   * Add a spring with the provided SpringConfig.
   * @public
   */ SpringSystem.prototype.createSpringWithConfig = function createSpringWithConfig(springConfig) {
        var spring = new (0, $3fEMs.default)(this);
        this.registerSpring(spring);
        spring.setSpringConfig(springConfig);
        return spring;
    };
    /**
   * Check if a SpringSystem is idle or active. If all of the Springs in the
   * SpringSystem are at rest, i.e. the physics forces have reached equilibrium,
   * then this method will return true.
   * @public
   */ SpringSystem.prototype.getIsIdle = function getIsIdle() {
        return this._isIdle;
    };
    /**
   * Manually add a spring to this system. This is called automatically
   * if a Spring is created with SpringSystem#createSpring.
   *
   * This method sets the spring up in the registry so that it can be solved
   * in the solver loop.
   * @public
   */ SpringSystem.prototype.registerSpring = function registerSpring(spring) {
        this._springRegistry[spring.getId()] = spring;
    };
    /**
   * Deregister a spring with this SpringSystem. The SpringSystem will
   * no longer consider this Spring during its integration loop once
   * this is called. This is normally done automatically for you when
   * you call Spring#destroy.
   * @public
   */ SpringSystem.prototype.deregisterSpring = function deregisterSpring(spring) {
        (0, $a1W0w.removeFirst)(this._activeSprings, spring);
        delete this._springRegistry[spring.getId()];
    };
    SpringSystem.prototype.advance = function advance(time, deltaTime) {
        while(this._idleSpringIndices.length > 0)this._idleSpringIndices.pop();
        for(var i = 0, len = this._activeSprings.length; i < len; i++){
            var spring = this._activeSprings[i];
            // note from alex: had to add this otherwise deleting springs caused errors
            if (!spring) return;
            if (spring.systemShouldAdvance()) spring.advance(time / 1000.0, deltaTime / 1000.0);
            else this._idleSpringIndices.push(this._activeSprings.indexOf(spring));
        }
        while(this._idleSpringIndices.length > 0){
            var idx = this._idleSpringIndices.pop();
            idx >= 0 && this._activeSprings.splice(idx, 1);
        }
    };
    /**
   * This is the main solver loop called to move the simulation
   * forward through time. Before each pass in the solver loop
   * onBeforeIntegrate is called on an any listeners that have
   * registered themeselves with the SpringSystem. This gives you
   * an opportunity to apply any constraints or adjustments to
   * the springs that should be enforced before each iteration
   * loop. Next the advance method is called to move each Spring in
   * the systemShouldAdvance forward to the current time. After the
   * integration step runs in advance, onAfterIntegrate is called
   * on any listeners that have registered themselves with the
   * SpringSystem. This gives you an opportunity to run any post
   * integration constraints or adjustments on the Springs in the
   * SpringSystem.
   * @public
   */ SpringSystem.prototype.loop = function loop(currentTimeMillis) {
        var listener = void 0;
        if (this._lastTimeMillis === -1) this._lastTimeMillis = currentTimeMillis - 1;
        var ellapsedMillis = currentTimeMillis - this._lastTimeMillis;
        this._lastTimeMillis = currentTimeMillis;
        var i = 0;
        var len = this.listeners.length;
        for(i = 0; i < len; i++){
            listener = this.listeners[i];
            listener.onBeforeIntegrate && listener.onBeforeIntegrate(this);
        }
        this.advance(currentTimeMillis, ellapsedMillis);
        if (this._activeSprings.length === 0) {
            this._isIdle = true;
            this._lastTimeMillis = -1;
        }
        for(i = 0; i < len; i++){
            listener = this.listeners[i];
            listener.onAfterIntegrate && listener.onAfterIntegrate(this);
        }
        if (!this._isIdle) this.looper.run();
    };
    /**
   * Used to notify the SpringSystem that a Spring has become displaced.
   * The system responds by starting its solver loop up if it is currently idle.
   */ SpringSystem.prototype.activateSpring = function activateSpring(springId) {
        var spring = this._springRegistry[springId];
        if (this._activeSprings.indexOf(spring) === -1) this._activeSprings.push(spring);
        if (this.getIsIdle()) {
            this._isIdle = false;
            this.looper.run();
        }
    };
    return SpringSystem;
}();
var $86d695386a02e65b$export$2e2bcd8739ae039 = $86d695386a02e65b$var$SpringSystem;

});
parcelRegister("cn4ia", function(module, exports) {
$parcel$export(module.exports, "AnimationLooper", () => $901af6528a11b37e$export$253af54c72735e05);

var $a1W0w = parcelRequire("a1W0w");
function $901af6528a11b37e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $901af6528a11b37e$export$253af54c72735e05 = function() {
    function AnimationLooper() {
        $901af6528a11b37e$var$_classCallCheck(this, AnimationLooper);
    }
    AnimationLooper.prototype.run = function run() {
        var _this = this;
        (0, $a1W0w.onFrame)(function() {
            _this.springSystem.loop((0, $a1W0w.performanceNow)());
        });
    };
    return AnimationLooper;
}();

});
parcelRegister("a1W0w", function(module, exports) {
$parcel$export(module.exports, "onFrame", () => $74d6fe73d6cb4571$export$1241ca3c22b48b34);
$parcel$export(module.exports, "performanceNow", () => $74d6fe73d6cb4571$export$fb4230f160368c88);
$parcel$export(module.exports, "removeFirst", () => $74d6fe73d6cb4571$export$2529f734547e2830);

var $1RKk1 = parcelRequire("1RKk1");
var $74d6fe73d6cb4571$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $74d6fe73d6cb4571$export$1241ca3c22b48b34(func) {
    return (0, $1RKk1.default)(func);
}
var $74d6fe73d6cb4571$var$start = Date.now();
var $74d6fe73d6cb4571$export$fb4230f160368c88 = (typeof performance === "undefined" ? "undefined" : $74d6fe73d6cb4571$var$_typeof(performance)) === "object" && typeof performance.now === "function" ? function() {
    return performance.now();
} : function() {
    return Date.now() - $74d6fe73d6cb4571$var$start;
};
function $74d6fe73d6cb4571$export$2529f734547e2830(array, item) {
    var idx = array.indexOf(item);
    idx !== -1 && array.splice(idx, 1);
}

});
parcelRegister("1RKk1", function(module, exports) {
$parcel$export(module.exports, "default", () => $15beac4037273558$export$2e2bcd8739ae039);
/**
 *  Copyright (c) 2013, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 *
 */ var $15beac4037273558$var$_onFrame = void 0;
if (typeof window !== "undefined") $15beac4037273558$var$_onFrame = window.requestAnimationFrame;
$15beac4037273558$var$_onFrame = $15beac4037273558$var$_onFrame || function(callback) {
    window.setTimeout(callback, 1000 / 60);
};
var $15beac4037273558$export$2e2bcd8739ae039 = $15beac4037273558$var$_onFrame;

});



parcelRegister("3fEMs", function(module, exports) {
$parcel$export(module.exports, "default", () => $25e267f68cc336c2$export$2e2bcd8739ae039);

var $a1W0w = parcelRequire("a1W0w");
function $25e267f68cc336c2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $25e267f68cc336c2$var$PhysicsState = function PhysicsState() {
    $25e267f68cc336c2$var$_classCallCheck(this, PhysicsState);
    this.position = 0;
    this.velocity = 0;
};
/**
 * Provides a model of a classical spring acting to
 * resolve a body to equilibrium. Springs have configurable
 * tension which is a force multipler on the displacement of the
 * spring from its rest point or `endValue` as defined by [Hooke's
 * law](http://en.wikipedia.org/wiki/Hooke's_law). Springs also have
 * configurable friction, which ensures that they do not oscillate
 * infinitely. When a Spring is displaced by updating it's resting
 * or `currentValue`, the SpringSystems that contain that Spring
 * will automatically start looping to solve for equilibrium. As each
 * timestep passes, `SpringListener` objects attached to the Spring
 * will be notified of the updates providing a way to drive an
 * animation off of the spring's resolution curve.
 * @public
 */ var $25e267f68cc336c2$var$Spring = function() {
    function Spring(springSystem) {
        $25e267f68cc336c2$var$_classCallCheck(this, Spring);
        this._id = "s" + Spring._ID++;
        this._springSystem = springSystem;
        this.listeners = [];
        this._startValue = 0;
        this._currentState = new $25e267f68cc336c2$var$PhysicsState();
        this._displacementFromRestThreshold = 0.001;
        this._endValue = 0;
        this._overshootClampingEnabled = false;
        this._previousState = new $25e267f68cc336c2$var$PhysicsState();
        this._restSpeedThreshold = 0.001;
        this._tempState = new $25e267f68cc336c2$var$PhysicsState();
        this._timeAccumulator = 0;
        this._wasAtRest = true;
    }
    Spring.prototype.getId = function getId() {
        return this._id;
    };
    /**
   * Remove a Spring from simulation and clear its listeners.
   * @public
   */ Spring.prototype.destroy = function destroy() {
        this.listeners = [];
        this._springSystem.deregisterSpring(this);
    };
    /**
   * Set the configuration values for this Spring. A SpringConfig
   * contains the tension and friction values used to solve for the
   * equilibrium of the Spring in the physics loop.
   * @public
   */ Spring.prototype.setSpringConfig = function setSpringConfig(springConfig) {
        this._springConfig = springConfig;
        return this;
    };
    /**
   * Retrieve the current value of the Spring.
   * @public
   */ Spring.prototype.getCurrentValue = function getCurrentValue() {
        return this._currentState.position;
    };
    /**
   * Get the absolute distance of the Spring from a given state value
   */ Spring.prototype.getDisplacementDistanceForState = function getDisplacementDistanceForState(state) {
        return Math.abs(this._endValue - state.position);
    };
    /**
   * Set the endValue or resting position of the spring. If this
   * value is different than the current value, the SpringSystem will
   * be notified and will begin running its solver loop to resolve
   * the Spring to equilibrium. Any listeners that are registered
   * for onSpringEndStateChange will also be notified of this update
   * immediately.
   * @public
   */ Spring.prototype.setEndValue = function setEndValue(endValue) {
        if (this._endValue === endValue && this.isAtRest()) return this;
        this._startValue = this.getCurrentValue();
        this._endValue = endValue;
        this._springSystem.activateSpring(this.getId());
        for(var i = 0, len = this.listeners.length; i < len; i++){
            var listener = this.listeners[i];
            var onChange = listener.onSpringEndStateChange;
            onChange && onChange(this);
        }
        return this;
    };
    /**
   * Set the current velocity of the Spring, in pixels per second. As
   * previously mentioned, this can be useful when you are performing
   * a direct manipulation gesture. When a UI element is released you
   * may call setVelocity on its animation Spring so that the Spring
   * continues with the same velocity as the gesture ended with. The
   * friction, tension, and displacement of the Spring will then
   * govern its motion to return to rest on a natural feeling curve.
   * @public
   */ Spring.prototype.setVelocity = function setVelocity(velocity) {
        if (velocity === this._currentState.velocity) return this;
        this._currentState.velocity = velocity;
        this._springSystem.activateSpring(this.getId());
        return this;
    };
    /**
   * Enable overshoot clamping. This means that the Spring will stop
   * immediately when it reaches its resting position regardless of
   * any existing momentum it may have. This can be useful for certain
   * types of animations that should not oscillate such as a scale
   * down to 0 or alpha fade.
   * @public
   */ Spring.prototype.setOvershootClampingEnabled = function setOvershootClampingEnabled(enabled) {
        this._overshootClampingEnabled = enabled;
        return this;
    };
    /**
   * Check if the Spring has gone past its end point by comparing
   * the direction it was moving in when it started to the current
   * position and end value.
   * @public
   */ Spring.prototype.isOvershooting = function isOvershooting() {
        var start = this._startValue;
        var end = this._endValue;
        return this._springConfig.tension > 0 && (start < end && this.getCurrentValue() > end || start > end && this.getCurrentValue() < end);
    };
    /**
   * The main solver method for the Spring. It takes
   * the current time and delta since the last time step and performs
   * an RK4 integration to get the new position and velocity state
   * for the Spring based on the tension, friction, velocity, and
   * displacement of the Spring.
   * @public
   */ Spring.prototype.advance = function advance(time, realDeltaTime) {
        var isAtRest = this.isAtRest();
        if (isAtRest && this._wasAtRest) return;
        var adjustedDeltaTime = realDeltaTime;
        if (realDeltaTime > Spring.MAX_DELTA_TIME_SEC) adjustedDeltaTime = Spring.MAX_DELTA_TIME_SEC;
        this._timeAccumulator += adjustedDeltaTime;
        var tension = this._springConfig.tension;
        var friction = this._springConfig.friction;
        var position = this._currentState.position;
        var velocity = this._currentState.velocity;
        var tempPosition = this._tempState.position;
        var tempVelocity = this._tempState.velocity;
        var aVelocity = void 0;
        var aAcceleration = void 0;
        var bVelocity = void 0;
        var bAcceleration = void 0;
        var cVelocity = void 0;
        var cAcceleration = void 0;
        var dVelocity = void 0;
        var dAcceleration = void 0;
        var dxdt = void 0;
        var dvdt = void 0;
        while(this._timeAccumulator >= Spring.SOLVER_TIMESTEP_SEC){
            this._timeAccumulator -= Spring.SOLVER_TIMESTEP_SEC;
            if (this._timeAccumulator < Spring.SOLVER_TIMESTEP_SEC) {
                this._previousState.position = position;
                this._previousState.velocity = velocity;
            }
            aVelocity = velocity;
            aAcceleration = tension * (this._endValue - tempPosition) - friction * velocity;
            tempPosition = position + aVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            tempVelocity = velocity + aAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            bVelocity = tempVelocity;
            bAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            tempPosition = position + bVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            tempVelocity = velocity + bAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            cVelocity = tempVelocity;
            cAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            tempPosition = position + cVelocity * Spring.SOLVER_TIMESTEP_SEC;
            tempVelocity = velocity + cAcceleration * Spring.SOLVER_TIMESTEP_SEC;
            dVelocity = tempVelocity;
            dAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            dxdt = 1.0 / 6.0 * (aVelocity + 2.0 * (bVelocity + cVelocity) + dVelocity);
            dvdt = 1.0 / 6.0 * (aAcceleration + 2.0 * (bAcceleration + cAcceleration) + dAcceleration);
            position += dxdt * Spring.SOLVER_TIMESTEP_SEC;
            velocity += dvdt * Spring.SOLVER_TIMESTEP_SEC;
        }
        this._tempState.position = tempPosition;
        this._tempState.velocity = tempVelocity;
        this._currentState.position = position;
        this._currentState.velocity = velocity;
        if (this._timeAccumulator > 0) this._interpolate(this._timeAccumulator / Spring.SOLVER_TIMESTEP_SEC);
        if (this.isAtRest() || this._overshootClampingEnabled && this.isOvershooting()) {
            if (this._springConfig.tension > 0) {
                this._startValue = this._endValue;
                this._currentState.position = this._endValue;
            } else {
                this._endValue = this._currentState.position;
                this._startValue = this._endValue;
            }
            this.setVelocity(0);
            isAtRest = true;
        }
        var notifyActivate = false;
        if (this._wasAtRest) {
            this._wasAtRest = false;
            notifyActivate = true;
        }
        var notifyAtRest = false;
        if (isAtRest) {
            this._wasAtRest = true;
            notifyAtRest = true;
        }
        this.notifyPositionUpdated(notifyActivate, notifyAtRest);
    };
    Spring.prototype.notifyPositionUpdated = function notifyPositionUpdated(notifyActivate, notifyAtRest) {
        for(var i = 0, len = this.listeners.length; i < len; i++){
            var listener = this.listeners[i];
            if (notifyActivate && listener.onSpringActivate) listener.onSpringActivate(this);
            if (listener.onSpringUpdate) listener.onSpringUpdate(this);
            if (notifyAtRest && listener.onSpringAtRest) listener.onSpringAtRest(this);
        }
    };
    /**
   * Check if the SpringSystem should advance. Springs are advanced
   * a final frame after they reach equilibrium to ensure that the
   * currentValue is exactly the requested endValue regardless of the
   * displacement threshold.
   * @public
   */ Spring.prototype.systemShouldAdvance = function systemShouldAdvance() {
        return !this.isAtRest() || !this.wasAtRest();
    };
    Spring.prototype.wasAtRest = function wasAtRest() {
        return this._wasAtRest;
    };
    /**
   * Check if the Spring is atRest meaning that it's currentValue and
   * endValue are the same and that it has no velocity. The previously
   * described thresholds for speed and displacement define the bounds
   * of this equivalence check. If the Spring has 0 tension, then it will
   * be considered at rest whenever its absolute velocity drops below the
   * restSpeedThreshold.
   * @public
   */ Spring.prototype.isAtRest = function isAtRest() {
        return Math.abs(this._currentState.velocity) < this._restSpeedThreshold && (this.getDisplacementDistanceForState(this._currentState) <= this._displacementFromRestThreshold || this._springConfig.tension === 0);
    };
    Spring.prototype._interpolate = function _interpolate(alpha) {
        this._currentState.position = this._currentState.position * alpha + this._previousState.position * (1 - alpha);
        this._currentState.velocity = this._currentState.velocity * alpha + this._previousState.velocity * (1 - alpha);
    };
    Spring.prototype.addListener = function addListener(newListener) {
        this.listeners.push(newListener);
        return this;
    };
    Spring.prototype.removeListener = function removeListener(listenerToRemove) {
        (0, $a1W0w.removeFirst)(this.listeners, listenerToRemove);
        return this;
    };
    return Spring;
}();
$25e267f68cc336c2$var$Spring._ID = 0;
$25e267f68cc336c2$var$Spring.MAX_DELTA_TIME_SEC = 0.064;
$25e267f68cc336c2$var$Spring.SOLVER_TIMESTEP_SEC = 0.001;
var $25e267f68cc336c2$export$2e2bcd8739ae039 = $25e267f68cc336c2$var$Spring;

});






parcelRegister("cMXVh", function(module, exports) {
$parcel$export(module.exports, "getFlippedElementPositionsBeforeUpdate", () => $94f8732d23071479$export$45700a1d2c971fdb);
$parcel$export(module.exports, "getFlippedElementPositionsAfterUpdate", () => $94f8732d23071479$export$df23be7918af8adb);

var $eVPal = parcelRequire("eVPal");

var $3oH7P = parcelRequire("3oH7P");
var $94f8732d23071479$var$cancelInProgressAnimations = function cancelInProgressAnimations(inProgressAnimations) {
    Object.keys(inProgressAnimations).forEach(function(id) {
        if (inProgressAnimations[id].stop) inProgressAnimations[id].stop();
        delete inProgressAnimations[id];
    });
};
var $94f8732d23071479$var$addTupleToObject = function addTupleToObject(acc, curr) {
    var _assign;
    return (0, $eVPal.assign)(acc, (_assign = {}, _assign[curr[0]] = curr[1], _assign));
};
var $94f8732d23071479$export$b087c5eb899bb598 = function getAllElements(element, portalKey) {
    if (portalKey) return (0, $eVPal.toArray)(document.querySelectorAll("[" + $3oH7P.DATA_PORTAL_KEY + "=\"" + portalKey + "\"]"));
    else return (0, $eVPal.toArray)(element.querySelectorAll("[" + $3oH7P.DATA_FLIP_ID + "]"));
};
var $94f8732d23071479$export$45700a1d2c971fdb = function getFlippedElementPositionsBeforeUpdate(_ref) {
    var element = _ref.element, _ref$flipCallbacks = _ref.flipCallbacks, flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks, _ref$inProgressAnimat = _ref.inProgressAnimations, inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat, portalKey = _ref.portalKey;
    var flippedElements = $94f8732d23071479$export$b087c5eb899bb598(element, portalKey);
    var inverseFlippedElements = (0, $eVPal.toArray)(element.querySelectorAll("[" + $3oH7P.DATA_INVERSE_FLIP_ID + "]"));
    var childIdsToParentBCRs = {};
    var parentBCRs = [];
    var childIdsToParents = {};
    // this is for exit animations so we can re-insert exiting elements in the
    // DOM later
    flippedElements.filter(function(el) {
        return flipCallbacks && flipCallbacks[el.dataset.flipId] && flipCallbacks[el.dataset.flipId].onExit;
    }).forEach(function(el) {
        var parent = el.parentNode;
        // this won't work for IE11
        if (el.closest) {
            var exitContainer = el.closest("[" + $3oH7P.DATA_EXIT_CONTAINER + "]");
            if (exitContainer) parent = exitContainer;
        }
        var bcrIndex = parentBCRs.findIndex(function(n) {
            return n[0] === parent;
        });
        if (bcrIndex === -1) {
            parentBCRs.push([
                parent,
                parent.getBoundingClientRect()
            ]);
            bcrIndex = parentBCRs.length - 1;
        }
        childIdsToParentBCRs[el.dataset.flipId] = parentBCRs[bcrIndex][1];
        childIdsToParents[el.dataset.flipId] = parent;
    });
    var flippedElementPositions = flippedElements.map(function(child) {
        var domData = {};
        var childBCR = child.getBoundingClientRect();
        // only cache extra data for exit animations
        // if the element has an onExit listener
        if (flipCallbacks && flipCallbacks[child.dataset.flipId] && flipCallbacks[child.dataset.flipId].onExit) {
            var parentBCR = childIdsToParentBCRs[child.dataset.flipId];
            (0, $eVPal.assign)(domData, {
                element: child,
                parent: childIdsToParents[child.dataset.flipId],
                childPosition: {
                    top: childBCR.top - parentBCR.top,
                    left: childBCR.left - parentBCR.left,
                    width: childBCR.width,
                    height: childBCR.height
                }
            });
        }
        return [
            child.dataset.flipId,
            {
                rect: childBCR,
                opacity: parseFloat(window.getComputedStyle(child).opacity),
                domData: domData
            }
        ];
    }).reduce($94f8732d23071479$var$addTupleToObject, {});
    // do this at the very end since we want to cache positions of elements
    // while they are mid-transition
    $94f8732d23071479$var$cancelInProgressAnimations(inProgressAnimations);
    flippedElements.concat(inverseFlippedElements).forEach(function(el) {
        el.style.transform = "";
        el.style.opacity = "";
    });
    return {
        flippedElementPositions: flippedElementPositions,
        cachedOrderedFlipIds: flippedElements.map(function(el) {
            return el.dataset.flipId;
        })
    };
};
var $94f8732d23071479$export$df23be7918af8adb = function getFlippedElementPositionsAfterUpdate(_ref2) {
    var element = _ref2.element, portalKey = _ref2.portalKey;
    return $94f8732d23071479$export$b087c5eb899bb598(element, portalKey).map(function(child) {
        var computedStyle = window.getComputedStyle(child);
        var rect = child.getBoundingClientRect();
        return [
            child.dataset.flipId,
            {
                rect: rect,
                opacity: parseFloat(computedStyle.opacity),
                domData: {},
                transform: computedStyle.transform
            }
        ];
    }).reduce($94f8732d23071479$var$addTupleToObject, {});
};

});



parcelRegister("8AhC2", function(module, exports) {
$parcel$export(module.exports, "default", () => $63ff58fc9521ccae$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $93Fg7 = parcelRequire("93Fg7");

var $aWmfx = parcelRequire("aWmfx");

var $3oH7P = parcelRequire("3oH7P");

var $eVPal = parcelRequire("eVPal");
var $63ff58fc9521ccae$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $63ff58fc9521ccae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $63ff58fc9521ccae$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $63ff58fc9521ccae$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $63ff58fc9521ccae$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $63ff58fc9521ccae$var$customPropCheck = function customPropCheck(props, propName) {
    if (props.flipId && props.inverseFlipId) return new Error('Please only provide one of the two: "FlipId" or "inverseFlipID"');
    else if (props.flipId === undefined && props.inverseFlipId === undefined) return new Error("Must provide either a \"FlipId\" or an \"InverseFlipId\" prop");
    else if (props[propName] && typeof props[propName] !== "string") return new Error(propName + " must be a string");
};
var $63ff58fc9521ccae$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func
    ]).isRequired,
    inverseFlipId: $63ff58fc9521ccae$var$customPropCheck,
    flipId: $63ff58fc9521ccae$var$customPropCheck,
    opacity: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).bool,
    translate: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).bool,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).bool,
    transformOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).string,
    spring: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).object
    ]),
    onStart: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    onAppear: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    shouldFlip: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    shouldInvert: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    onExit: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func,
    portalKey: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).string,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).bool
    ])
};
function $63ff58fc9521ccae$export$c3816ea9cb166de0(_ref) {
    var _dataAttributes;
    var children = _ref.children, flipId = _ref.flipId, inverseFlipId = _ref.inverseFlipId, portalKey = _ref.portalKey, rest = $63ff58fc9521ccae$var$_objectWithoutProperties(_ref, [
        "children",
        "flipId",
        "inverseFlipId",
        "portalKey"
    ]);
    var child = children;
    var isFunctionAsChildren = typeof child === 'function';
    if (!isFunctionAsChildren) try {
        child = (0, $8P7DW.Children).only(children);
    } catch (e) {
        throw new Error("Each Flipped component must wrap a single child");
    }
    // if nothing is being animated, assume everything is being animated
    if (!rest.scale && !rest.translate && !rest.opacity) (0, $eVPal.assign)(rest, {
        translate: true,
        scale: true,
        opacity: true
    });
    var dataAttributes = (_dataAttributes = {}, _dataAttributes[$3oH7P.DATA_FLIP_ID] = flipId, _dataAttributes[$3oH7P.DATA_INVERSE_FLIP_ID] = inverseFlipId, _dataAttributes[$3oH7P.DATA_FLIP_CONFIG] = JSON.stringify(rest), _dataAttributes);
    if (portalKey) dataAttributes[$3oH7P.DATA_PORTAL_KEY] = portalKey;
    return isFunctionAsChildren ? child(dataAttributes) : (0, $8P7DW.cloneElement)(child, dataAttributes);
}
var $63ff58fc9521ccae$var$FlippedWithContext = function(_Component) {
    $63ff58fc9521ccae$var$_inherits(FlippedWithContext, _Component);
    function FlippedWithContext() {
        $63ff58fc9521ccae$var$_classCallCheck(this, FlippedWithContext);
        return $63ff58fc9521ccae$var$_possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    FlippedWithContext.prototype.render = function render() {
        var _props = this.props, children = _props.children, flipId = _props.flipId, shouldFlip = _props.shouldFlip, shouldInvert = _props.shouldInvert, onAppear = _props.onAppear, onStart = _props.onStart, onComplete = _props.onComplete, onExit = _props.onExit, rest = $63ff58fc9521ccae$var$_objectWithoutProperties(_props, [
            "children",
            "flipId",
            "shouldFlip",
            "shouldInvert",
            "onAppear",
            "onStart",
            "onComplete",
            "onExit"
        ]);
        if (rest.inverseFlipId) return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($63ff58fc9521ccae$export$c3816ea9cb166de0, rest, children);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aWmfx.PortalContext).Consumer, null, function(portalKey) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aWmfx.FlipContext).Consumer, null, function(data) {
                // if there is no surrounding Flipper component,
                // we don't want to throw an error, so check
                // that data exists and is not the default string
                if ((0, $eVPal.isObject)(data)) data[flipId] = {
                    shouldFlip: shouldFlip,
                    shouldInvert: shouldInvert,
                    onAppear: onAppear,
                    onStart: onStart,
                    onComplete: onComplete,
                    onExit: onExit
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($63ff58fc9521ccae$export$c3816ea9cb166de0, $63ff58fc9521ccae$var$_extends({
                    flipId: flipId
                }, rest, {
                    portalKey: portalKey
                }), children);
            });
        });
    };
    return FlippedWithContext;
}((0, $8P7DW.Component));
$63ff58fc9521ccae$var$FlippedWithContext.propTypes = {};
var $63ff58fc9521ccae$export$2e2bcd8739ae039 = $63ff58fc9521ccae$var$FlippedWithContext;

});

parcelRegister("ela33", function(module, exports) {
$parcel$export(module.exports, "default", () => $a70ad237c49fba60$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $3oH7P = parcelRequire("3oH7P");
var $a70ad237c49fba60$var$ExitContainer = function ExitContainer(_ref) {
    var _cloneElement;
    var children = _ref.children;
    return (0, $8P7DW.cloneElement)(children, (_cloneElement = {}, _cloneElement[0, $3oH7P.DATA_EXIT_CONTAINER] = true, _cloneElement));
};
var $a70ad237c49fba60$export$2e2bcd8739ae039 = $a70ad237c49fba60$var$ExitContainer;

});




parcelRegister("5431H", function(module, exports) {
$parcel$export(module.exports, "BannerWithLayoutHeader", () => (parcelRequire("bHMxE")).default);

var $bHMxE = parcelRequire("bHMxE");

});
parcelRegister("bHMxE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6405ca986fc68b1b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BannerWithLayoutHeaderMemoizedHOC", () => $6405ca986fc68b1b$export$f0da0221ee5515ac);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $1Do2l = parcelRequire("1Do2l");
const $6405ca986fc68b1b$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getThemeColor), (0, $ikoP4.getHelpCenterBrandingLoader), (0, $ikoP4.getHelpCenterTopBarSplitFlag), (themeColor, isBrandingLoaded, hasTopBarBeenSplit)=>({
        themeColor: themeColor,
        isBrandingLoaded: isBrandingLoaded,
        hasTopBarBeenSplit: hasTopBarBeenSplit
    }));
const $6405ca986fc68b1b$var$ConnectedBannerWithLayoutHeader = (0, $jvoWT.default)($6405ca986fc68b1b$var$selector)((0, $1Do2l.BannerWithLayoutHeader));
var $6405ca986fc68b1b$export$2e2bcd8739ae039 = $6405ca986fc68b1b$var$ConnectedBannerWithLayoutHeader;
const $6405ca986fc68b1b$export$f0da0221ee5515ac = (0, $jvoWT.default)($6405ca986fc68b1b$var$selector)((0, $1Do2l.BannerWithLayoutHeaderMemoized));

});
parcelRegister("1Do2l", function(module, exports) {
$parcel$export(module.exports, "BannerWithLayoutHeader", () => $5d92231125345ec0$export$dc6fa5f6f452943b);
$parcel$export(module.exports, "BannerWithLayoutHeaderMemoized", () => $5d92231125345ec0$export$2e33b09d9c57faa1);
/* banner-with-layout-header.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $HGACo = parcelRequire("HGACo");

var $4O8fD = parcelRequire("4O8fD");

var $4cxV2 = parcelRequire("4cxV2");

var $aw7IH = parcelRequire("aw7IH");
parcelRequire("hFv0W");
var $gnTu9 = parcelRequire("gnTu9");
parcelRequire("20jeq");
var $2hE7u = parcelRequire("2hE7u");

var $1EFS8 = parcelRequire("1EFS8");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $4peLG = parcelRequire("4peLG");
const $5d92231125345ec0$export$ed7cc0d417ee89e = $4cxV2.unitless * 23; // 184
const $5d92231125345ec0$export$6ba969052247c298 = $4cxV2.unitless * 23 + (0, $aw7IH.HEADER_HEIGHT); // 240
const $5d92231125345ec0$export$87562042682a224f = $4cxV2.unitless * 37; // 296
const $5d92231125345ec0$export$f6510fb522c3cc26 = 300;
const $5d92231125345ec0$export$5c538a381f9a90ef = $4cxV2.unitless * 22; // 176
const $5d92231125345ec0$var$BANNER_WITH_REDUCED_HEIGHT = 152;
const $5d92231125345ec0$export$60963c14ec4e3ee7 = 'layout-banner';
const $5d92231125345ec0$export$dc6fa5f6f452943b = ({ themeColor: themeColor, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, isBrandingLoaded: isBrandingLoaded, hideBanner: hideBanner, prefetchBrandingModel: prefetchBrandingModel, hasTopBarBeenSplit: hasTopBarBeenSplit, renderForPaperLayout: renderForPaperLayout })=>{
    const isVisualRefreshReducedSizeEnabled = (0, $1EFS8.default).checkGate('visual_refresh_reduced_banner_height');
    // Update CSS variable when helpCenterBanner changes
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty('--banner-bg-image', helpCenterBanner ? `url(${helpCenterBanner})` : 'none');
    }, [
        helpCenterBanner
    ]);
    let updatedBannerHeight = hasTopBarBeenSplit ? $5d92231125345ec0$export$ed7cc0d417ee89e : $5d92231125345ec0$export$6ba969052247c298;
    if (isVisualRefreshReducedSizeEnabled) updatedBannerHeight = hasTopBarBeenSplit ? $5d92231125345ec0$export$ed7cc0d417ee89e : $5d92231125345ec0$var$BANNER_WITH_REDUCED_HEIGHT;
    if (renderForPaperLayout) updatedBannerHeight = hasTopBarBeenSplit ? $5d92231125345ec0$export$f6510fb522c3cc26 : $5d92231125345ec0$export$87562042682a224f + (0, $aw7IH.HEADER_HEIGHT); // in login page we render paper layout
    if ((0, $HGACo.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) {
        updatedBannerHeight = $5d92231125345ec0$export$5c538a381f9a90ef;
        if (isVisualRefreshReducedSizeEnabled) updatedBannerHeight = $5d92231125345ec0$var$BANNER_WITH_REDUCED_HEIGHT;
    }
    const bannerCustomProp = {
        style: {
            height: `${updatedBannerHeight}px`,
            backgroundColor: themeColor,
            backgroundImage: 'var(--banner-bg-image)',
            borderRadius: hasTopBarBeenSplit ? "var(--ds-radius-large, 8px)" : 'initial'
        }
    };
    const showBannerWithLoader = ()=>{
        if (hideBanner) return null;
        if ((0, $HGACo.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: isVisualRefreshReducedSizeEnabled ? $5d92231125345ec0$var$bannerContainerStyleWithReducedHeight : $5d92231125345ec0$var$bannerContainerStyle
        }, isBrandingLoaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            "data-testId": $5d92231125345ec0$export$60963c14ec4e3ee7,
            xcss: $5d92231125345ec0$var$bannerStyle,
            ...bannerCustomProp
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: updatedBannerHeight,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
        const bannerContainerCustomPropPaperLayout = {
            style: {
                height: `${updatedBannerHeight + (hasTopBarBeenSplit ? 16 : 0) * 2}px`,
                top: renderForPaperLayout && hasTopBarBeenSplit ? `${0, $aw7IH.HEADER_HEIGHT}px` : 'initial',
                bottom: renderForPaperLayout ? 'initial' : 0,
                paddingTop: hasTopBarBeenSplit ? "var(--ds-space-200, 16px)" : "var(--ds-space-0, 0px)",
                paddingBottom: hasTopBarBeenSplit ? "var(--ds-space-200, 16px)" : "var(--ds-space-0, 0px)",
                paddingLeft: hasTopBarBeenSplit ? "var(--ds-space-400, 32px)" : "var(--ds-space-0, 0px)",
                paddingRight: hasTopBarBeenSplit ? "var(--ds-space-400, 32px)" : "var(--ds-space-0, 0px)"
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5d92231125345ec0$var$BannerContainer, {
            ...bannerContainerCustomPropPaperLayout,
            "data-testid": 'BannerContainer'
        }, !isBrandingLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: updatedBannerHeight,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })), isBrandingLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5d92231125345ec0$var$BannerStyleWithImage, {
            "data-testid": $5d92231125345ec0$export$60963c14ec4e3ee7,
            ...bannerCustomProp
        }));
    };
    let containerHeight = renderForPaperLayout ? (0, $aw7IH.HEADER_HEIGHT) : $5d92231125345ec0$export$6ba969052247c298;
    if (isVisualRefreshReducedSizeEnabled) containerHeight = renderForPaperLayout ? (0, $aw7IH.HEADER_HEIGHT) : $5d92231125345ec0$var$BANNER_WITH_REDUCED_HEIGHT;
    if ((0, $HGACo.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) {
        containerHeight = (0, $aw7IH.HEADER_HEIGHT) + $5d92231125345ec0$export$5c538a381f9a90ef + 32;
        if (isVisualRefreshReducedSizeEnabled) containerHeight = (0, $aw7IH.HEADER_HEIGHT) + $5d92231125345ec0$var$BANNER_WITH_REDUCED_HEIGHT + 32;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5d92231125345ec0$var$Container, {
        "data-testid": 'outer-BannerContainer',
        style: {
            height: removeHeader || headerless || hideBanner ? 'auto' : `${containerHeight}px`
        }
    }, showBannerWithLoader(), prefetchBrandingModel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2hE7u.default), {
        isAnonymous: isAnonymous
    }) : null, !removeHeader && !headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5d92231125345ec0$var$HeaderContainerStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gnTu9.default), {
        isAnonymous: isAnonymous,
        logoTextColor: "banner",
        hideSearchButton: hideSearchButton,
        showThemedBackground: false,
        isModelCallPrefetched: prefetchBrandingModel
    })), !removeHeader && headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5d92231125345ec0$var$EmptyHeader, {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            height: `${(0, $aw7IH.HEADER_HEIGHT)}px`
        }
    }));
};
const $5d92231125345ec0$export$2e33b09d9c57faa1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo($5d92231125345ec0$export$dc6fa5f6f452943b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $5d92231125345ec0$var$Container = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5d92231125345ec0$var$BannerStyleWithImage = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1bsb1osq _4t3i1osq _1lrw1dfr _12vemgnk _ouxl1ssb _bfhk1pom _1itk8q6q",
            __cmplp.className
        ])
    });
});
const $5d92231125345ec0$var$BannerContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_kqswstnw _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $5d92231125345ec0$var$bannerContainerStyle = (0, $37U6z.xcss)({
    position: 'absolute',
    width: '100%',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.400',
    paddingRight: 'space.400',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    bottom: 'space.0',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    height: `${$5d92231125345ec0$export$5c538a381f9a90ef + 32}px`
});
const $5d92231125345ec0$var$bannerContainerStyleWithReducedHeight = (0, $37U6z.xcss)({
    position: 'absolute',
    width: '100%',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.400',
    paddingRight: 'space.400',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    bottom: 'space.0',
    height: `${$5d92231125345ec0$var$BANNER_WITH_REDUCED_HEIGHT + 32}px`
});
const $5d92231125345ec0$var$bannerStyle = (0, $37U6z.xcss)({
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: 'radius.large',
    backgroundColor: 'color.background.brand.bold'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $5d92231125345ec0$var$HeaderContainerStyle = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_kqswh2mm _1pbykuz3",
            __cmplp.className
        ])
    });
});
const $5d92231125345ec0$var$EmptyHeader = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFv0W", function(module, exports) {
$parcel$export(module.exports, "Header", () => (parcelRequire("gnTu9")).default);

var $gnTu9 = parcelRequire("gnTu9");

});
parcelRegister("gnTu9", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62283dda1c4fd99$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $2gQsf = parcelRequire("2gQsf");

var $4O8fD = parcelRequire("4O8fD");

var $9Vr59 = parcelRequire("9Vr59");

var $kkBq4 = parcelRequire("kkBq4");

var $7jGoV = parcelRequire("7jGoV");
parcelRequire("2tsrb");
var $7IL12 = parcelRequire("7IL12");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("fpXO3");
var $20jec = parcelRequire("20jec");
parcelRequire("kBppU");
var $1OgwN = parcelRequire("1OgwN");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
parcelRequire("4Jtl9");
var $lMHED = parcelRequire("lMHED");

var $aw7IH = parcelRequire("aw7IH");

var $4peLG = parcelRequire("4peLG");

var $gk18s = parcelRequire("gk18s");

var $jsmb9 = parcelRequire("jsmb9");
parcelRequire("bSSGe");
var $kUr9B = parcelRequire("kUr9B");
const $d62283dda1c4fd99$var$getHeaderLoginUrl = (state)=>{
    const portalId = (0, $7IL12.getPortalId)(state);
    return (0, $jsmb9.getLoginUrl)({
        portalId: portalId,
        isAbsolute: true,
        redirectUrl: (0, $7IL12.getPathname)(state)
    });
};
const $d62283dda1c4fd99$var$userRequestsSelector = (state)=>{
    return (0, $lMHED.getUserRequestsCounts)(state);
};
const $d62283dda1c4fd99$var$selector = (0, $ehscL.createSelector)((0, $hx8zX.isLoggedIn), $d62283dda1c4fd99$var$getHeaderLoginUrl, (0, $hx8zX.isUserLoaded), (0, $20jec.isCustomizing), $d62283dda1c4fd99$var$userRequestsSelector, (0, $1OgwN.getOrganisations), (0, $8Wisn.getIsAnonymousEnabled), (0, $ikoP4.getHelpCenterBrandingLoader), (0, $ikoP4.getHelpCenterTopBarColor), (0, $ikoP4.getHelpCenterTopBarSplitFlag), (0, $ikoP4.getLogoUrl), (0, $ikoP4.getSharedPortalName), (userLoggedIn, loginUrl, userLoaded, customizing, userRequest, organisations, anonymousEnabled, isBrandingLoaded, topBarColor, hasTopBarBeenSplit, logoUrl, name)=>({
        userLoggedIn: userLoggedIn,
        loginUrl: loginUrl,
        userRequest: userRequest,
        organisations: organisations,
        anonymousEnabled: anonymousEnabled,
        name: name,
        isBrandingLoaded: isBrandingLoaded,
        isUserLoaded: userLoaded,
        isCustomizing: customizing,
        headerBackgroundColor: hasTopBarBeenSplit ? topBarColor : undefined,
        logoUrl: logoUrl ?? undefined
    }));
class $d62283dda1c4fd99$var$Header extends $8P7DW.Component {
    componentDidMount() {
        if (!this.props.isModelCallPrefetched) {
            if (!(0, $gk18s.isHelpCentersManagement)()) this.props.fetchBranding();
            if (!this.props.isAnonymous) {
                this.props.fetchUser();
                this.props.fetchOrganisations();
                this.props.fetchUserRequestsCounts();
            }
        }
    }
    componentDidUpdate(prevProps) {
        // If we haven't loaded the user yet and we've moved from an
        // anonymous route to a normal route, go fetch the user.
        if (!this.props.isUserLoaded && prevProps.isAnonymous && !this.props.isAnonymous && !this.props.isModelCallPrefetched) {
            this.props.fetchUser();
            this.props.fetchUserRequestsCounts();
        }
    }
    render() {
        if ((0, $gk18s.isKoshEnabledForDefaultHelpCenter)() && !(0, $gk18s.isHelpCentersManagement)()) {
            if (this.props.isBrandingLoaded) return /*#__PURE__*/ $8P7DW.createElement((0, $kUr9B.default), this.props);
            return /*#__PURE__*/ $8P7DW.createElement((0, $4peLG.default), {
                name: "header-loader"
            }, /*#__PURE__*/ $8P7DW.createElement((0, $4O8fD.LoadingSkeleton), {
                "data-testid": "header-skeleton",
                height: (0, $aw7IH.HEADER_HEIGHT),
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        }
        return /*#__PURE__*/ $8P7DW.createElement((0, $kUr9B.default), this.props);
    }
}
var $d62283dda1c4fd99$export$2e2bcd8739ae039 = (0, $jvoWT.default)($d62283dda1c4fd99$var$selector, {
    fetchBranding: (0, $9Vr59.fetchHelpCenterBrandingAction),
    fetchUser: (0, $2gQsf.fetchUserModelAction),
    fetchOrganisations: (0, $kkBq4.fetchOrganisationsModelAction),
    fetchUserRequestsCounts: (0, $7jGoV.fetchUserRequestsCountsAction)
})($d62283dda1c4fd99$var$Header);

});
parcelRegister("fpXO3", function(module, exports) {
$parcel$export(module.exports, "isAnyUploadInProgress", () => (parcelRequire("20jec")).isAnyUploadInProgress);
$parcel$export(module.exports, "isCustomizing", () => (parcelRequire("20jec")).isCustomizing);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("20jec")).isSaveInProgress);
$parcel$export(module.exports, "isUploadInProgress", () => (parcelRequire("20jec")).isUploadInProgress);
parcelRequire("20jec");

});
parcelRegister("20jec", function(module, exports) {
$parcel$export(module.exports, "isCustomizing", () => $0bcb8610d95b6339$export$ce3eed7c98304744);
$parcel$export(module.exports, "isSaveInProgress", () => $0bcb8610d95b6339$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isUploadInProgress", () => $0bcb8610d95b6339$export$cf866b9449681342);
$parcel$export(module.exports, "isAnyUploadInProgress", () => $0bcb8610d95b6339$export$4dfd840e8ddac89d);
const $0bcb8610d95b6339$export$ce3eed7c98304744 = (state)=>state.ui.helpCenterPreview.isCustomizing;
const $0bcb8610d95b6339$export$2b75ac2de7a23db1 = (state)=>state.ui.helpCenterPreview.isSaveInProgress;
const $0bcb8610d95b6339$export$cf866b9449681342 = (state, fileCollection)=>!!state.ui.helpCenterPreview.uploadsInProgress[fileCollection];
const $0bcb8610d95b6339$export$4dfd840e8ddac89d = (state)=>{
    const { uploadsInProgress: uploadsInProgress } = state.ui.helpCenterPreview;
    return Object.keys(uploadsInProgress).find((uploadKey)=>uploadsInProgress[uploadKey]) !== undefined;
};

});


parcelRegister("kBppU", function(module, exports) {
$parcel$export(module.exports, "getOrganisations", () => (parcelRequire("1OgwN")).getOrganisations);

var $1OgwN = parcelRequire("1OgwN");

});
parcelRegister("1OgwN", function(module, exports) {
$parcel$export(module.exports, "getOrganisations", () => $66a2a9a5d05dd546$export$17495f9c20464b8);
const $66a2a9a5d05dd546$export$17495f9c20464b8 = (state)=>state.persisted.organisations.organisations;

});


parcelRegister("4Jtl9", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => (parcelRequire("lMHED")).getUserRequestsCounts);

var $lMHED = parcelRequire("lMHED");

});
parcelRegister("lMHED", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => $2c8553955bfc1530$export$be73da9c8fdefffb);
const $2c8553955bfc1530$export$be73da9c8fdefffb = (state)=>{
    return state.persisted.userRequestsCounts;
};

});


parcelRegister("bSSGe", function(module, exports) {
$parcel$export(module.exports, "DumbHeader", () => (parcelRequire("kUr9B")).default);

var $kUr9B = parcelRequire("kUr9B");

});
parcelRegister("kUr9B", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae5411d55f3ce320$export$2e2bcd8739ae039);
/* header-dumb.tsx generated by @compiled/babel-plugin v0.37.1 */ /** @jsxFrag React.Fragment */ 
var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $2UsNA = parcelRequire("2UsNA");

var $cS6Xr = parcelRequire("cS6Xr");

var $8y05I = parcelRequire("8y05I");

var $edC7N = parcelRequire("edC7N");

var $HGACo = parcelRequire("HGACo");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $l4cjO = parcelRequire("l4cjO");
var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("cmfC3");
var $7c012 = parcelRequire("7c012");

var $aw7IH = parcelRequire("aw7IH");
parcelRequire("4008n");
var $bgu9V = parcelRequire("bgu9V");

var $8gu7I = parcelRequire("8gu7I");

var $ku7ln = parcelRequire("ku7ln");

var $1EFS8 = parcelRequire("1EFS8");

var $e6Qdr = parcelRequire("e6Qdr");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $4peLG = parcelRequire("4peLG");

var $Gx7Pc = parcelRequire("Gx7Pc");
parcelRequire("eem3A");
var $59NqE = parcelRequire("59NqE");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $eN7Hl = parcelRequire("eN7Hl");

var $jsmb9 = parcelRequire("jsmb9");
parcelRequire("eTJoQ");
var $bwfgf = parcelRequire("bwfgf");
parcelRequire("9rAg7");
var $dcwyo = parcelRequire("dcwyo");
parcelRequire("7vUpt");
var $eDzYi = parcelRequire("eDzYi");

var $hzTaT = parcelRequire("hzTaT");
const $ae5411d55f3ce320$var$isCompiledCssEnabled = ()=>(0, $1EFS8.default).checkGate('help_center_login_compiled_css');
const $ae5411d55f3ce320$var$Header = ({ isAnonymous: isAnonymous, isUserLoaded: isUserLoaded, userLoggedIn: userLoggedIn, loginUrl: loginUrl, logoTextColor: logoTextColor, hideSearchButton: hideSearchButton, anonymousEnabled: anonymousEnabled, showThemedBackground: showThemedBackground, disableAllHeaderLinks: disableAllHeaderLinks, headerBackgroundColor: headerBackgroundColor, logoUrl: logoUrl, name: name })=>{
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const showPortalLink = isCSM ? !!logoUrl : true;
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const defaultLoginUrl = `/user/login?destination=${(0, $jsmb9.getHelpCenterUrl)().replace(/\//g, '')}`;
    const authenticatedNavLinks = $8P7DW.useMemo(()=>/*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, (0, $HGACo.isVirtualAgentHeaderButtonEnabled)() && !isCSM && /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$NavItem, {
            role: "listitem"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
            packageName: 'viewLayoutHeaderDumb',
            id: 'virtualAgentHeaderButton'
        }, /*#__PURE__*/ $8P7DW.createElement($8P7DW.Suspense, {
            fallback: null
        }, /*#__PURE__*/ $8P7DW.createElement((0, $eDzYi.default), {
            portalId: portalId ?? ''
        })))), (0, $HGACo.isHelpCenterNewDropdownEnabled)() && /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$NavItem, null, /*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
            packageName: 'viewLayoutHeaderDumb',
            id: 'customizeMenu'
        }, /*#__PURE__*/ $8P7DW.createElement((0, $dcwyo.default), {
            disableCustomiseMenu: disableAllHeaderLinks
        }))), isCSM && /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$NavItem, {
            role: "listitem"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
            packageName: "viewLayoutHeaderDumb",
            id: "CsmRequestsHeaderLink"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
            xcss: $ae5411d55f3ce320$var$requestsLinkStyles
        }, /*#__PURE__*/ $8P7DW.createElement((0, $Gx7Pc.CsmRequestsHeaderLink), null)))), /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$NavItem, null, /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
            data: {
                actionSubjectId: 'navbarAvatar'
            }
        }, /*#__PURE__*/ $8P7DW.createElement((0, $59NqE.default), {
            disableAvatarMenu: disableAllHeaderLinks
        })))), [
        disableAllHeaderLinks,
        isCSM,
        portalId
    ]);
    const unauthenticatedNavLinks = /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$NavItem, {
        role: "listitem"
    }, /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$export$7d5b37ae6eb004e5, null, /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$LoginButton, {
        href: loginUrl ? loginUrl : defaultLoginUrl,
        actionSubjectId: "navbarLogin"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $hzTaT.default).login))));
    const anonymousAccessNotEnbledAndUserNotLoggedIn = !(!!anonymousEnabled || !!userLoggedIn);
    let portalLinkUrl;
    let portalLinkAriaLabel;
    if (isAnonymous || anonymousAccessNotEnbledAndUserNotLoggedIn) {
        portalLinkUrl = defaultLoginUrl;
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
        portalLinkAriaLabel = formatMessage((0, $e6Qdr.fg)('banana-a11y-changes') ? (0, $hzTaT.default).helpCenter : (0, $hzTaT.default).login);
    } else {
        portalLinkUrl = (0, $jsmb9.getHelpCenterUrl)();
        portalLinkAriaLabel = (0, $1EFS8.default).checkGate('fix_logo_aria_label') && name ? name : formatMessage((0, $hzTaT.default).helpCenter);
    }
    const LogoComponent = (0, $1EFS8.default).checkGate('request_create_perf_improvement_part_one') ? (0, $7c012.LogoMemoizedHOC) : (0, $7c012.default);
    return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
        data: {
            source: 'navbar'
        }
    }, /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$Root, {
        showThemedBackground: Boolean(showThemedBackground),
        headerBackgroundColor: headerBackgroundColor
    }, showPortalLink && /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$PortalLink, {
        to: portalLinkUrl,
        logoTextColor: logoTextColor,
        actionSubjectId: "navbarHelpCenter",
        disabled: Boolean(disableAllHeaderLinks),
        tabIndex: disableAllHeaderLinks ? -1 : undefined,
        "aria-label": portalLinkAriaLabel
    }, /*#__PURE__*/ $8P7DW.createElement($8P7DW.Suspense, {
        fallback: /*#__PURE__*/ $8P7DW.createElement((0, $4peLG.default), {
            name: "header-dumb-logo-fallback"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $ku7ln.default), {
            appearance: "square",
            size: "medium"
        }))
    }, /*#__PURE__*/ $8P7DW.createElement(LogoComponent, null))), /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$Nav, null, /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$NavList, {
        role: "list"
    }, isUserLoaded && /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, hideSearchButton || /*#__PURE__*/ $8P7DW.createElement($ae5411d55f3ce320$var$NavItem, {
        role: "listitem"
    }, (0, $e6Qdr.fg)('helpcenter_search_api_changes') ? /*#__PURE__*/ $8P7DW.createElement((0, $bwfgf.default), {
        trigger: "icon",
        disableSearch: disableAllHeaderLinks
    }) : /*#__PURE__*/ $8P7DW.createElement((0, $bgu9V.default), {
        trigger: "icon",
        disableSearch: disableAllHeaderLinks
    })), userLoggedIn ? authenticatedNavLinks : unauthenticatedNavLinks)))));
};
var $ae5411d55f3ce320$export$2e2bcd8739ae039 = $ae5411d55f3ce320$var$Header;
const $ae5411d55f3ce320$var$rootStyles = null;
const $ae5411d55f3ce320$var$refreshRootStyles = null;
const $ae5411d55f3ce320$var$RootCompiled = (props)=>{
    let backgroundColor;
    if (props.headerBackgroundColor) backgroundColor = props.headerBackgroundColor;
    else backgroundColor = props.showThemedBackground ? props.themeColor : '';
    return /*#__PURE__*/ $8P7DW.createElement("header", {
        style: {
            backgroundColor: backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            height: `${(0, $aw7IH.HEADER_HEIGHT)}px`
        },
        className: (0, $8n1kL.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bah1yb4 _4cvr1h6o _u5f3u2gc _19bvu2gc",
            (0, $HGACo.isUseHelpCenterRefresh)() && "_19bvpxbi"
        ])
    }, props.children);
};
const $ae5411d55f3ce320$var$RootCompiledConnected = (0, $jvoWT.default)((state)=>{
    return {
        themeColor: (0, $ikoP4.getThemeColor)(state)
    };
})($ae5411d55f3ce320$var$RootCompiled);
// Nav line height set to 0 so it is correctly vertically aligned.
const $ae5411d55f3ce320$var$NAV_LINE_HEIGHT = 0;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ae5411d55f3ce320$var$RootStyled = /*#__PURE__*/ (0, $2UsNA.default).header.withConfig({
    componentId: "sc-l83nge-0"
})`display:flex;justify-content:space-between;align-items:center;${()=>{
    if ((0, $HGACo.isUseHelpCenterRefresh)()) return `
                padding-left: ${"var(--ds-space-200, 16px)"};
            `;
    return `
            padding-left: ${"var(--ds-space-100, 8px)"};
            `;
}} padding-right:${"var(--ds-space-100, 8px)"};height:${(0, $aw7IH.HEADER_HEIGHT)}px;overflow:hidden;${(props)=>{
    if (props.headerBackgroundColor) return props.headerBackgroundColor ? `background-color: ${props.headerBackgroundColor}` : '';
    return props.showThemedBackground ? `background-color: ${props.theme.color}` : '';
}}`;
const $ae5411d55f3ce320$var$Root = (0, $eN7Hl.componentWithCondition)($ae5411d55f3ce320$var$isCompiledCssEnabled, $ae5411d55f3ce320$var$RootCompiledConnected, $ae5411d55f3ce320$var$RootStyled);
const $ae5411d55f3ce320$var$navStyles = null;
const $ae5411d55f3ce320$var$NavCompiled = (props)=>/*#__PURE__*/ $8P7DW.createElement("nav", {
        className: (0, $8n1kL.default)([
            "_vwz4idpf _18u01wug"
        ])
    }, props.children);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve,rulesdir/styled-component-order
const $ae5411d55f3ce320$var$NavStyled = /*#__PURE__*/ (0, $2UsNA.default).nav.withConfig({
    componentId: "sc-l83nge-1"
})`line-height:${$ae5411d55f3ce320$var$NAV_LINE_HEIGHT};margin-left:auto;`;
const $ae5411d55f3ce320$var$Nav = (0, $eN7Hl.componentWithCondition)($ae5411d55f3ce320$var$isCompiledCssEnabled, $ae5411d55f3ce320$var$NavCompiled, $ae5411d55f3ce320$var$NavStyled);
const $ae5411d55f3ce320$var$navListStyles = null;
const $ae5411d55f3ce320$var$NavListCompiled = (props)=>/*#__PURE__*/ $8P7DW.createElement("div", {
        role: props.role,
        className: (0, $8n1kL.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o"
        ])
    }, props.children);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ae5411d55f3ce320$var$NavListStyled = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-l83nge-2"
})`margin:0;padding:0;display:flex;align-items:center;`;
const $ae5411d55f3ce320$var$NavList = (0, $eN7Hl.componentWithCondition)($ae5411d55f3ce320$var$isCompiledCssEnabled, $ae5411d55f3ce320$var$NavListCompiled, $ae5411d55f3ce320$var$NavListStyled);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ae5411d55f3ce320$var$NavItem = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-l83nge-3"
})`display:inline;margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ae5411d55f3ce320$var$LoginButton = /*#__PURE__*/ (0, $2UsNA.default)((props)=>/*#__PURE__*/ $8P7DW.createElement((0, $8y05I.Button), props)).withConfig({
    componentId: "sc-l83nge-4"
})`&&{padding-left:${"var(--ds-space-150, 12px)"};padding-right:${"var(--ds-space-150, 12px)"};}`;
const $ae5411d55f3ce320$export$7d5b37ae6eb004e5 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-l83nge-5"
})`${$6t2I3.subtleThemeColorBackground};border:${"var(--ds-border-width-selected, 2px)"} ${"var(--ds-border-inverse, #FFFFFF)"} solid;border-radius:${$4cxV2.multiple(2).px};margin-left:${"var(--ds-space-100, 8px)"};`;
const $ae5411d55f3ce320$var$PortalLinkCompiled = (props)=>{
    const { logoTextColor: logoTextColor, disabled: disabled, themeColor: themeColor, titleColor: titleColor, children: children, ...linkProps } = props;
    return /*#__PURE__*/ $8P7DW.createElement((0, $cS6Xr.Link), {
        to: linkProps.to,
        actionSubjectId: linkProps.actionSubjectId,
        tabIndex: linkProps.tabIndex,
        "aria-label": linkProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: 'cv-exclude-from-customisation',
        style: {
            pointerEvents: disabled ? 'none' : 'auto',
            color: logoTextColor === 'banner' ? titleColor : `var(--ds-link, ${themeColor})`
        },
        // @ts-ignore
        disabled: disabled
    }, children);
};
const $ae5411d55f3ce320$var$PortalLinkCompiledConnected = (0, $jvoWT.default)((state)=>({
        themeColor: (0, $ikoP4.getThemeColor)(state),
        titleColor: (0, $ikoP4.getHelpCenterTitleColor)(state)
    }))($ae5411d55f3ce320$var$PortalLinkCompiled);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ae5411d55f3ce320$var$PortalLinkStyled = /*#__PURE__*/ (0, $2UsNA.default)(({ logoTextColor: logoTextColor, ...props })=>// eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Disabling existing violation, should be fixed when revisited.
    /*#__PURE__*/ $8P7DW.createElement((0, $cS6Xr.Link), props)).attrs({
    className: 'cv-exclude-from-customisation'
}).withConfig({
    componentId: "sc-l83nge-6"
})`color:${(props)=>props.logoTextColor === 'banner' ? props.theme.titleColor : `var(--ds-link, ${props.theme.color})`};&:hover{color:${(props)=>props.logoTextColor === 'banner' ? props.theme.titleColor : `var(--ds-link, ${props.theme.color})`};}pointer-events:${(props)=>props.disabled ? 'none' : 'auto'};`;
const $ae5411d55f3ce320$var$PortalLink = (0, $eN7Hl.componentWithCondition)($ae5411d55f3ce320$var$isCompiledCssEnabled, $ae5411d55f3ce320$var$PortalLinkCompiledConnected, $ae5411d55f3ce320$var$PortalLinkStyled);
const $ae5411d55f3ce320$var$requestsLinkStyles = (0, $37U6z.xcss)({
    marginInlineEnd: 'space.075'
});

});
parcelRegister("cmfC3", function(module, exports) {
$parcel$export(module.exports, "Logo", () => (parcelRequire("7c012")).default);
$parcel$export(module.exports, "LogoMemoizedHOC", () => (parcelRequire("7c012")).LogoMemoizedHOC);

var $7c012 = parcelRequire("7c012");

});
parcelRegister("7c012", function(module, exports) {
$parcel$export(module.exports, "LogoMemoizedHOC", () => $f961a824bd6322b6$export$299f731b9b12cd90);
$parcel$export(module.exports, "default", () => $f961a824bd6322b6$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $kt2Og = parcelRequire("kt2Og");
const $f961a824bd6322b6$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getLogoUrl), (0, $ikoP4.getSharedPortalName), (0, $ikoP4.getHelpCenterTopBarTextColor), (0, $ikoP4.getHelpCenterTopBarSplitFlag), (url, name, topBarTextColor, hasTopBarBeenSplit)=>({
        url: url,
        name: name,
        topBarTextColor: hasTopBarBeenSplit ? topBarTextColor : undefined
    }));
const $f961a824bd6322b6$export$299f731b9b12cd90 = (0, $jvoWT.default)($f961a824bd6322b6$var$selector)((0, $kt2Og.LogoMemoized));
var $f961a824bd6322b6$export$2e2bcd8739ae039 = (0, $jvoWT.default)($f961a824bd6322b6$var$selector)((0, $kt2Og.Logo));

});
parcelRegister("kt2Og", function(module, exports) {
$parcel$export(module.exports, "Logo", () => $ada0bba6b7a83727$export$e6ff31bff12b7ff4);
$parcel$export(module.exports, "LogoMemoized", () => $ada0bba6b7a83727$export$acb5f09fe495ae97);

var $d6L8k = parcelRequire("d6L8k");

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $alAP8 = parcelRequire("alAP8");

var $h3cOB = parcelRequire("h3cOB");

var $1EFS8 = parcelRequire("1EFS8");

var $4peLG = parcelRequire("4peLG");

var $gk18s = parcelRequire("gk18s");

var $cXeeg = parcelRequire("cXeeg");
parcelRequire("aDyXO");
var $jfdfy = parcelRequire("jfdfy");
const $ada0bba6b7a83727$export$e6ff31bff12b7ff4 = ({ url: url, name: name, topBarTextColor: topBarTextColor })=>{
    var _helpCenter$helpCente, _helpCenter$helpCente2;
    const isFetchingData = (0, $HGACo.isCustomThemingEnabled)();
    const [defaultLogoUrl] = $8P7DW.useState(url);
    const [stateUrl, setStateUrl] = $8P7DW.useState('');
    const [shouldHoldUFO, setShouldHoldUFO] = $8P7DW.useState(true);
    const { helpCenter: helpCenter } = (0, $h3cOB.useLazyLoadQuery)((0, $d6L8k.default), {
        cloudId: (0, $jByYr.getCloudId)(),
        helpCenterAri: (0, $jByYr.getHelpCenterAri)(),
        skip: !isFetchingData
    });
    const advancedName = (helpCenter === null || helpCenter === void 0 || (_helpCenter$helpCente = helpCenter.helpCenterById) === null || _helpCenter$helpCente === void 0 || (_helpCenter$helpCente = _helpCenter$helpCente.name) === null || _helpCenter$helpCente === void 0 ? void 0 : _helpCenter$helpCente.default) || name;
    const advancedUrl = helpCenter === null || helpCenter === void 0 || (_helpCenter$helpCente2 = helpCenter.helpCenterById) === null || _helpCenter$helpCente2 === void 0 || (_helpCenter$helpCente2 = _helpCenter$helpCente2.helpCenterBranding) === null || _helpCenter$helpCente2 === void 0 || (_helpCenter$helpCente2 = _helpCenter$helpCente2.logo) === null || _helpCenter$helpCente2 === void 0 ? void 0 : _helpCenter$helpCente2.url;
    $8P7DW.useEffect(()=>{
        if (!isFetchingData && url && !url.startsWith('blob:')) (0, $cXeeg.getObjectURLFromMediaURLWithCaching)(url).then(setStateUrl).catch(()=>setStateUrl('')).finally(()=>setShouldHoldUFO(false));
        else {
            setStateUrl(url || '');
            setShouldHoldUFO(false);
        }
    }, [
        url,
        isFetchingData
    ]);
    const isHelpCentersManagementPage = (0, $gk18s.isHelpCentersManagement)();
    const getUrl = $8P7DW.useCallback(()=>{
        if (isFetchingData) return advancedUrl;
        if (isHelpCentersManagementPage) return 0, (/*@__PURE__*/$parcel$interopDefault($alAP8));
        return stateUrl;
    }, [
        advancedUrl,
        isFetchingData,
        isHelpCentersManagementPage,
        stateUrl
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, shouldHoldUFO && /*#__PURE__*/ $8P7DW.createElement((0, $4peLG.default), {
        name: "help-center-common-logo"
    }), (0, $1EFS8.default).checkGate('jsm_help_center_branding_image_improvement') && defaultLogoUrl && /*#__PURE__*/ $8P7DW.createElement("link", {
        rel: "preload",
        as: "fetch",
        href: defaultLogoUrl,
        crossOrigin: "anonymous"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $jfdfy.default), {
        url: getUrl(),
        name: advancedName,
        topBarTextColor: topBarTextColor
    }));
};
const $ada0bba6b7a83727$export$acb5f09fe495ae97 = /*#__PURE__*/ $8P7DW.memo($ada0bba6b7a83727$export$e6ff31bff12b7ff4);

});
parcelRegister("d6L8k", function(module, exports) {
$parcel$export(module.exports, "default", () => $99b192afcb6b74c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f060de2d1966f4c4a15ca291d45ae43f>>
 * @relayHash 89b5ac4560edc5779e88acaa2f693808
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d0682ac128b1814b5e2ef5bed041589a8703b625dc2193d4eaf2b90ded3e360
const $99b192afcb6b74c7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "logoQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "logoQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4d0682ac128b1814b5e2ef5bed041589a8703b625dc2193d4eaf2b90ded3e360",
            "metadata": {},
            "name": "logoQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$99b192afcb6b74c7$var$node.hash = "50f3d8eb5808e1ee69db4f8e639d0b3e";
var $99b192afcb6b74c7$export$2e2bcd8739ae039 = $99b192afcb6b74c7$var$node;

});

parcelRegister("alAP8", function(module, exports) {
module.exports = new URL("../images/atlassian-icon.632e3804.png", import.meta.url).toString();

});

parcelRegister("aDyXO", function(module, exports) {
$parcel$export(module.exports, "LogoStateless", () => (parcelRequire("jfdfy")).default);

var $jfdfy = parcelRequire("jfdfy");

});
parcelRegister("jfdfy", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5232c6d0431797c$export$2e2bcd8739ae039);
/* logo-stateless.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $4cxV2 = parcelRequire("4cxV2");

var $1EFS8 = parcelRequire("1EFS8");
const $e5232c6d0431797c$var$isCompiledCssEnabled = ()=>(0, $1EFS8.default).checkGate('help_center_login_compiled_css');
const $e5232c6d0431797c$var$LogoStateless = ({ url: url, name: name, topBarTextColor: topBarTextColor })=>{
    if ($e5232c6d0431797c$var$isCompiledCssEnabled()) {
        const compiledContent = url ? /*#__PURE__*/ $8P7DW.createElement("img", {
            src: url,
            alt: name,
            style: {
                height: `${$e5232c6d0431797c$var$imageHeight}px`
            }
        }) : /*#__PURE__*/ $8P7DW.createElement("span", null, name);
        return /*#__PURE__*/ $8P7DW.createElement("div", {
            style: {
                height: `${$e5232c6d0431797c$var$imageHeight}px`,
                color: topBarTextColor || 'inherit'
            },
            className: (0, $8n1kL.default)([
                "_1e0c116y _4cvr1h6o _1bah1h6o _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _k48p1pd9"
            ])
        }, compiledContent);
    }
    const content = url ? /*#__PURE__*/ $8P7DW.createElement($e5232c6d0431797c$var$ImageStyled, {
        src: url,
        alt: name
    }) : /*#__PURE__*/ $8P7DW.createElement("span", null, name);
    return /*#__PURE__*/ $8P7DW.createElement($e5232c6d0431797c$var$RootStyled, {
        topBarTextColor: topBarTextColor
    }, content);
};
var $e5232c6d0431797c$export$2e2bcd8739ae039 = $e5232c6d0431797c$var$LogoStateless;
const $e5232c6d0431797c$var$imageHeight = $4cxV2.unitless * 5;
// Compiled CSS styles
const $e5232c6d0431797c$var$rootCompiledStyles = null;
// Styled-components version (legacy)
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e5232c6d0431797c$var$RootStyled = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-prcwi5-0"
})`height:${$e5232c6d0431797c$var$imageHeight}px;display:inline-flex;align-items:center;justify-content:center;padding:${"var(--ds-space-075, 6px)"};font-weight:600;color:${(props)=>props.topBarTextColor || 'inherit'};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e5232c6d0431797c$var$ImageStyled = /*#__PURE__*/ (0, $2UsNA.default).img.withConfig({
    componentId: "sc-prcwi5-1"
})`height:${$e5232c6d0431797c$var$imageHeight}px;`;

});





parcelRegister("4008n", function(module, exports) {
$parcel$export(module.exports, "Search", () => (parcelRequire("bgu9V")).default);

var $bgu9V = parcelRequire("bgu9V");

});
parcelRegister("bgu9V", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6fad38880039a21$export$2e2bcd8739ae039);

var $bnS5P = parcelRequire("bnS5P");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $kT9oZ = parcelRequire("kT9oZ");

var $hWt0u = parcelRequire("hWt0u");

var $9Vr59 = parcelRequire("9Vr59");
parcelRequire("4PbDu");
var $3FFzY = parcelRequire("3FFzY");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("fzkqG");
var $6Tan6 = parcelRequire("6Tan6");
parcelRequire("kIzxQ");
var $fsoF0 = parcelRequire("fsoF0");
parcelRequire("16xwA");
var $gXexd = parcelRequire("gXexd");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $auVp4 = parcelRequire("auVp4");

var $byuiX = parcelRequire("byuiX");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");
parcelRequire("ikBUv");
var $d82Wh = parcelRequire("d82Wh");
parcelRequire("dHHa4");
var $bPEbW = parcelRequire("bPEbW");
parcelRequire("lQBpH");
var $52sI9 = parcelRequire("52sI9");
parcelRequire("4t3KQ");
var $7jPBK = parcelRequire("7jPBK");
const $c6fad38880039a21$export$4b85d3515bd863a5 = ({ term: term, trigger: trigger, isOpen: isOpen, onSearch: onSearch, onClose: onClose, onOpen: onOpen, resetSearch: resetSearch, fetchHelpCenter: fetchHelpCenter, fetchPortals: fetchPortals, disableSearch: disableSearch, isVSAOnHCEnabled: isVSAOnHCEnabled })=>{
    const searchButtonRef = (0, $8P7DW.useRef)(null);
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    (0, $8P7DW.useEffect)(()=>{
        if ((0, $iwSnV.isSinglePortalSearch)(portalId)) fetchPortals({
            id: (0, $iwSnV.getPortalIdAsNumber)(portalId),
            expand: [
                'kbs',
                'reqTypes',
                'reqGroups',
                'orderMapping'
            ]
        });
    }, [
        portalId,
        fetchHelpCenter,
        fetchPortals
    ]);
    const onReturnFocus = (0, $8P7DW.useCallback)((_)=>{
        //FocusLock trap is still active due to that we deffer setting focus with zero-timeout
        setTimeout(()=>{
            var _searchButtonRef$curr;
            searchButtonRef === null || searchButtonRef === void 0 || (_searchButtonRef$curr = searchButtonRef.current) === null || _searchButtonRef$curr === void 0 || _searchButtonRef$curr.focus();
        }, 0);
        return true;
    }, []);
    (0, $8P7DW.useEffect)(()=>()=>{
            resetSearch();
        }, [
        resetSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $52sI9.default), {
        isOpen: isOpen,
        term: term,
        portalId: portalId,
        onSearch: onSearch,
        onClose: onClose,
        onReturnFocus: onReturnFocus,
        isVSAOnHCEnabled: isVSAOnHCEnabled
    }), trigger === 'icon' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gXexd.default), {
        ref: searchButtonRef,
        shown: isOpen,
        onClick: onOpen,
        disableSearch: disableSearch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $d82Wh.InlineResultsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7jPBK.default), {
        term: term,
        disableSearch: disableSearch,
        isVSAOnHCEnabled: !!isVSAOnHCEnabled
    }))));
};
const $c6fad38880039a21$var$SearchWithVirtualAgentAvailability = (props)=>{
    var _data$helpCenter, _data$helpCenter2, _data$virtualAgent;
    const { queryReference: queryReference, ...rest } = props;
    const data = (0, $h3cOB.usePreloadedQuery)((0, $bnS5P.default), props.queryReference);
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($c6fad38880039a21$export$4b85d3515bd863a5, rest);
    const isVirtualAgentEnabled = ((_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.virtualAgentEnabled) ?? false;
    const isVirtualAgentAvailable = (0, $HGACo.isVAOnHelpCenterGAEnabled)() ? ((_data$virtualAgent = data.virtualAgent) === null || _data$virtualAgent === void 0 ? void 0 : _data$virtualAgent.virtualAgentAvailability) ?? false : true;
    const isVSAOnHCEnabled = isVirtualAgentEnabled && isVirtualAgentAvailable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($c6fad38880039a21$export$4b85d3515bd863a5, {
        isVSAOnHCEnabled: isVSAOnHCEnabled,
        ...rest
    });
};
const $c6fad38880039a21$export$ab176425b2a52b00 = (props)=>{
    const { queryReference: queryReference } = (0, $byuiX.useRelayResource)((0, $kT9oZ.searchComponentVirtualAgentResource));
    const renderError = (0, $8P7DW.useCallback)(()=>{
        // We fallback to non-VSA search if there is an error occurs in this loader, All the other errors should be handled by the SearchErrorBoundary default renderError
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bPEbW.default), {
            id: "help-center-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($c6fad38880039a21$export$4b85d3515bd863a5, props));
    }, [
        props
    ]);
    if (!queryReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bPEbW.default), {
        id: "help-center-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($c6fad38880039a21$export$4b85d3515bd863a5, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bPEbW.default), {
        id: "help-center-search",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($c6fad38880039a21$export$4b85d3515bd863a5, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($c6fad38880039a21$var$SearchWithVirtualAgentAvailability, {
        queryReference: queryReference,
        ...props
    })));
};
const $c6fad38880039a21$var$selector = (0, $ehscL.createSelector)((0, $fsoF0.getShown), (0, $fsoF0.getTerm), (shown, term)=>({
        term: term,
        isOpen: shown
    }));
const $c6fad38880039a21$var$ConnectedSearch = (0, $jvoWT.default)($c6fad38880039a21$var$selector, {
    onOpen: ()=>(0, $6Tan6.showSearch)(true),
    onClose: ()=>(0, $6Tan6.showSearch)(false),
    onSearch: (term)=>(0, $6Tan6.updateSearch)(term, {}),
    resetSearch: (0, $6Tan6.resetSearch),
    fetchPortals: (0, $d727K.fetchPortalAction),
    fetchHelpCenter: (0, $9Vr59.fetchHelpCenterAction)
})((0, $auVp4.PortalAnalyticsModal)((0, $8rTkC.ScreenName).HELP_CENTER_SEARCH)(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
(0, $hWt0u.default)((0, $eS4yu.default)({
    component: (0, $8rTkC.ScreenName).HELP_CENTER_SEARCH
})((0, $k7ZVu.default)()($c6fad38880039a21$export$ab176425b2a52b00)))));
var $c6fad38880039a21$export$2e2bcd8739ae039 = $c6fad38880039a21$var$ConnectedSearch;

});
parcelRegister("hWt0u", function(module, exports) {
$parcel$export(module.exports, "PathParamsProvider", () => $053bfca94e55764f$export$ebcbd875f0707321);
$parcel$export(module.exports, "withPathParamProvider", () => $053bfca94e55764f$export$e8aa4f1b1a2e784c);
$parcel$export(module.exports, "default", () => $053bfca94e55764f$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
const $053bfca94e55764f$var$RouteParamContext = /*#__PURE__*/ $8P7DW.createContext({});
const $053bfca94e55764f$export$ebcbd875f0707321 = (props)=>/*#__PURE__*/ $8P7DW.createElement($053bfca94e55764f$var$RouteParamContext.Provider, {
        value: props.params
    }, props.children);
const $053bfca94e55764f$var$withPathParams = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $8P7DW.createElement($053bfca94e55764f$var$RouteParamContext.Consumer, null, (value)=>/*#__PURE__*/ $8P7DW.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
const $053bfca94e55764f$export$e8aa4f1b1a2e784c = (Component)=>{
    // eslint-disable-next-line react/display-name
    return (props)=>{
        const [{ match: match }] = (0, $i9cdb.useRouter)();
        return /*#__PURE__*/ $8P7DW.createElement($053bfca94e55764f$export$ebcbd875f0707321, {
            params: match.params
        }, /*#__PURE__*/ $8P7DW.createElement(Component, props));
    };
};
var $053bfca94e55764f$export$2e2bcd8739ae039 = $053bfca94e55764f$var$withPathParams;

});

parcelRegister("16xwA", function(module, exports) {
$parcel$export(module.exports, "SearchButton", () => (parcelRequire("gXexd")).default);

var $gXexd = parcelRequire("gXexd");

});
parcelRegister("gXexd", function(module, exports) {
$parcel$export(module.exports, "default", () => $63676f9b737073bb$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $ifRQf = parcelRequire("ifRQf");

var $kDg5W = parcelRequire("kDg5W");
const $63676f9b737073bb$export$690bcf3a1f1e9f2f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(({ onClick: onClick, disableSearch: disableSearch }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($63676f9b737073bb$var$StyledSearchIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ifRQf.default), {
        isDisabled: disableSearch,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        style: {
            borderRadius: '50%'
        },
        ref: ref,
        onClick: onClick,
        appearance: "subtle",
        shouldFitContainer: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kDg5W))), {
            spacing: "spacious",
            label: "Search",
            color: "var(--ds-icon, #42526E)"
        }),
        analyticsContext: {
            actionSubjectId: 'navbarSearch'
        }
    }));
});
$63676f9b737073bb$export$690bcf3a1f1e9f2f.displayName = 'SearchButton';
var $63676f9b737073bb$export$2e2bcd8739ae039 = $63676f9b737073bb$export$690bcf3a1f1e9f2f;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $63676f9b737073bb$var$StyledSearchIconContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-tktwuw-0"
})`display:flex;height:${"var(--ds-space-400, 32px)"};width:${"var(--ds-space-400, 32px)"};align-items:stretch;background-color:${"var(--ds-surface-overlay, #EBECF0)"};border-radius:50%;flex-direction:column;justify-content:center;transform:translateZ(0);transition:transform 200ms,opacity 200ms;box-shadow:${"var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-border-inverse, #FFFFFF)"};border:none;margin:${"var(--ds-space-150, 12px)"};padding:0;cursor:pointer;`;

});
parcelRegister("kDg5W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f053ef4687c94054$var$_react = $f053ef4687c94054$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $f053ef4687c94054$var$_baseNew = $f053ef4687c94054$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $f053ef4687c94054$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f053ef4687c94054$var$SearchIcon = (props)=>/*#__PURE__*/ $f053ef4687c94054$var$_react.default.createElement($f053ef4687c94054$var$_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$f053ef4687c94054$var$SearchIcon.displayName = 'SearchIcon';
var $f053ef4687c94054$var$_default = module.exports.default = $f053ef4687c94054$var$SearchIcon;

});



parcelRegister("auVp4", function(module, exports) {
$parcel$export(module.exports, "PortalAnalyticsInlineDialog", () => $695717d6264279fd$export$4de18d88452d7a08);
$parcel$export(module.exports, "PortalAnalyticsModal", () => $695717d6264279fd$export$e80acabac337720d);
$parcel$export(module.exports, "PortalAnalyticsDrawer", () => $695717d6264279fd$export$3b1f159f4ab6aaae);

var $iziiq = parcelRequire("iziiq");

var $86q7M = parcelRequire("86q7M");
function $695717d6264279fd$var$screenWithoutBrowserMetrics(name, sourceType, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attributes) {
    const analyticsWrapper = (0, $iziiq.withAnalyticsContext)({
        sourceType: sourceType,
        sourceName: name,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        attributes: {
            ...attributes,
            context: 'Portal'
        }
    });
    return (component)=>(0, $86q7M.clearScreenName)(analyticsWrapper(component));
}
const $695717d6264279fd$export$4de18d88452d7a08 = (name, attributes)=>$695717d6264279fd$var$screenWithoutBrowserMetrics(name, (0, $iziiq.ScreenTypes).INLINE_DIALOG, attributes);
const $695717d6264279fd$export$e80acabac337720d = (name, attributes)=>$695717d6264279fd$var$screenWithoutBrowserMetrics(name, (0, $iziiq.ScreenTypes).MODAL, attributes);
const $695717d6264279fd$export$3b1f159f4ab6aaae = (name, attributes)=>$695717d6264279fd$var$screenWithoutBrowserMetrics(name, (0, $iziiq.ScreenTypes).DRAWER, attributes);

});

parcelRegister("ibkPE", function(module, exports) {
$parcel$export(module.exports, "ALL_RESULTS_COUNT", () => (parcelRequire("fhQ61")).ALL_RESULTS_COUNT);
$parcel$export(module.exports, "DEFAULT_RESULTS_COUNT", () => (parcelRequire("fhQ61")).DEFAULT_RESULTS_COUNT);
$parcel$export(module.exports, "INITIAL_ARTICLES_COUNT", () => (parcelRequire("fhQ61")).INITIAL_ARTICLES_COUNT);
$parcel$export(module.exports, "INITIAL_PORTALS_COUNT", () => (parcelRequire("fhQ61")).INITIAL_PORTALS_COUNT);
$parcel$export(module.exports, "INITIAL_REQUEST_FORMS_COUNT", () => (parcelRequire("fhQ61")).INITIAL_REQUEST_FORMS_COUNT);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => (parcelRequire("fhQ61")).SEARCH_QUERY_DEBOUNCE_TIME);
$parcel$export(module.exports, "SHOW_MORE_RESULTS_COUNT", () => (parcelRequire("fhQ61")).SHOW_MORE_RESULTS_COUNT);
$parcel$export(module.exports, "DropdownOptionList", () => (parcelRequire("k0cKu")).DropdownOptionList);
$parcel$export(module.exports, "Img", () => (parcelRequire("k0cKu")).Img);
$parcel$export(module.exports, "InlineResultLink", () => (parcelRequire("k0cKu")).InlineResultLink);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => (parcelRequire("k0cKu")).InlineResultsHeadingWrapper);
$parcel$export(module.exports, "LinkContainer", () => (parcelRequire("k0cKu")).LinkContainer);
$parcel$export(module.exports, "ResultList", () => (parcelRequire("k0cKu")).ResultList);
$parcel$export(module.exports, "ResultTitle", () => (parcelRequire("k0cKu")).ResultTitle);
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => (parcelRequire("k0cKu")).SEARCH_BAR_HEIGHT);
$parcel$export(module.exports, "formatText", () => (parcelRequire("iwSnV")).formatText);
$parcel$export(module.exports, "formatToCleanText", () => (parcelRequire("iwSnV")).formatToCleanText);
$parcel$export(module.exports, "getIdsArray", () => (parcelRequire("iwSnV")).getIdsArray);
$parcel$export(module.exports, "getPortalIdAsNumber", () => (parcelRequire("iwSnV")).getPortalIdAsNumber);
$parcel$export(module.exports, "isSinglePortalSearch", () => (parcelRequire("iwSnV")).isSinglePortalSearch);
$parcel$export(module.exports, "isValidSearchTerm", () => (parcelRequire("iwSnV")).isValidSearchTerm);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => (parcelRequire("iwSnV")).sendSearchOperationalAnalyticEvents);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => (parcelRequire("iwSnV")).sendSearchUIAnalyticEvents);
$parcel$export(module.exports, "useQueryParams", () => (parcelRequire("iwSnV")).useQueryParams);
$parcel$export(module.exports, "useVisibilityState", () => (parcelRequire("iwSnV")).useVisibilityState);
parcelRequire("fhQ61");
parcelRequire("k0cKu");
parcelRequire("iwSnV");

});
parcelRegister("fhQ61", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_RESULTS_COUNT", () => $b7b95b6befb52f2b$export$f14c45907e18a763);
$parcel$export(module.exports, "INITIAL_ARTICLES_COUNT", () => $b7b95b6befb52f2b$export$49754c91e8c4555b);
$parcel$export(module.exports, "INITIAL_REQUEST_FORMS_COUNT", () => $b7b95b6befb52f2b$export$5c16d76778f8ba6d);
$parcel$export(module.exports, "INITIAL_PORTALS_COUNT", () => $b7b95b6befb52f2b$export$de93546541b3e2e);
$parcel$export(module.exports, "SHOW_MORE_RESULTS_COUNT", () => $b7b95b6befb52f2b$export$897393da5c49885d);
$parcel$export(module.exports, "ALL_RESULTS_COUNT", () => $b7b95b6befb52f2b$export$7652aee25e1c7c1e);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => $b7b95b6befb52f2b$export$95aa4d213e66754b);
const $b7b95b6befb52f2b$export$f14c45907e18a763 = 31;
const $b7b95b6befb52f2b$export$49754c91e8c4555b = 11;
const $b7b95b6befb52f2b$export$5c16d76778f8ba6d = 5;
const $b7b95b6befb52f2b$export$de93546541b3e2e = 3;
const $b7b95b6befb52f2b$export$897393da5c49885d = 30;
const $b7b95b6befb52f2b$export$7652aee25e1c7c1e = 30;
const $b7b95b6befb52f2b$export$95aa4d213e66754b = 300;

});

parcelRegister("k0cKu", function(module, exports) {
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => $fad279689a57d5f5$export$9ac4f4162406e081);
$parcel$export(module.exports, "LinkContainer", () => $fad279689a57d5f5$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "ResultTitle", () => $fad279689a57d5f5$export$d971b98a124cabfc);
$parcel$export(module.exports, "ResultList", () => $fad279689a57d5f5$export$7ebf7682ef098fb8);
$parcel$export(module.exports, "Img", () => $fad279689a57d5f5$export$cc7b5f925acc71d3);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => $fad279689a57d5f5$export$a8317adc66cb9be6);
$parcel$export(module.exports, "InlineResultLink", () => $fad279689a57d5f5$export$5a34ff55d4e5e484);
$parcel$export(module.exports, "DropdownOptionList", () => $fad279689a57d5f5$export$b5e293376cc6b1ce);
/* styled.tsx generated by @compiled/babel-plugin v0.37.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $2UsNA = parcelRequire("2UsNA");

var $cS6Xr = parcelRequire("cS6Xr");

var $6t2I3 = parcelRequire("6t2I3");
const $fad279689a57d5f5$export$9ac4f4162406e081 = "var(--ds-space-1000, 80px)";
const $fad279689a57d5f5$export$f99233281efd08a0 = /*#__PURE__*/ (0, $2UsNA.default).h3.withConfig({
    componentId: "sc-19gahx3-0"
})`${$6t2I3.clamp};margin:0;font-weight:normal;font-size:${"var(--ds-space-200, 16px)"};`;
const $fad279689a57d5f5$export$10c56fa12fda26f9 = /*#__PURE__*/ (0, $2UsNA.default).p.withConfig({
    componentId: "sc-19gahx3-1"
})`color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-100, 8px)"};padding-right:${"var(--ds-space-200, 16px)"};${$6t2I3.multiLineClamp(3, 20)};`;
const $fad279689a57d5f5$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $2UsNA.default)((0, $cS6Xr.Link)).withConfig({
    componentId: "sc-19gahx3-2"
})`display:flex;border-radius:${"var(--ds-radius-small, 3px)"};${$6t2I3.raiseUpOnHoverOrFocus()};background-color:${"var(--ds-surface-raised, #FFFFFF)"};padding:${"var(--ds-space-200, 16px)"};margin:${"var(--ds-space-100, 8px)"} 0 0;&:hover,&:focus{background:${"var(--ds-surface-raised, #FFFFFF)"};text-decoration:none;}&:hover h3,&:focus h3{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
const $fad279689a57d5f5$export$d971b98a124cabfc = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_ca0qpxbi _19pkze3t _1p1dangw _1wybutpp _k48p8n31 _syaz117m",
            __cmplp.className
        ])
    });
});
const $fad279689a57d5f5$export$7ebf7682ef098fb8 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $fad279689a57d5f5$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt4pxbi _1bsb1epz",
            __cmplp.className
        ])
    });
});
const $fad279689a57d5f5$export$a8317adc66cb9be6 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});
const $fad279689a57d5f5$export$5a34ff55d4e5e484 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $cS6Xr.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_4bfu1snc _1hmsagmp _ajmmvv82 _zulputpp _1reo15vq _18m915vq _1rjc12x7 _18zrpxbi _1e0c1txw _2lx2vrvc _1bsb1osq _syazwm8e _4cvr1h6o _vchhusvi _80omtlke _49pcnqa1 _1hvwdkaa _nt75xr8a _irr34mfv _1di61dty",
            __cmplp.className
        ])
    });
});
const $fad279689a57d5f5$export$b5e293376cc6b1ce = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1pfhu2gc _1eg6idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iwSnV", function(module, exports) {
$parcel$export(module.exports, "formatText", () => $29e4d330dd06a9fd$export$905fe28a7c283e1d);
$parcel$export(module.exports, "formatToCleanText", () => $29e4d330dd06a9fd$export$519cc8c1640d01b8);
$parcel$export(module.exports, "useQueryParams", () => $29e4d330dd06a9fd$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "isSinglePortalSearch", () => $29e4d330dd06a9fd$export$3bdd4cf348080703);
$parcel$export(module.exports, "getPortalIdAsNumber", () => $29e4d330dd06a9fd$export$c36431be801010b);
$parcel$export(module.exports, "isValidSearchTerm", () => $29e4d330dd06a9fd$export$34d09b0baed7315d);
$parcel$export(module.exports, "getIdsArray", () => $29e4d330dd06a9fd$export$b78190df63b1b0c4);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => $29e4d330dd06a9fd$export$c8b38685f22f1bb2);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => $29e4d330dd06a9fd$export$653243929c3168a8);
$parcel$export(module.exports, "useVisibilityState", () => $29e4d330dd06a9fd$export$54299a3c81f5425);

var $8P7DW = parcelRequire("8P7DW");

var $u1Zdx = parcelRequire("u1Zdx");

var $5kYxc = parcelRequire("5kYxc");

var $gSAAy = parcelRequire("gSAAy");

var $gKQQC = parcelRequire("gKQQC");

var $7upu0 = parcelRequire("7upu0");

var $h1yZX = parcelRequire("h1yZX");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
const $29e4d330dd06a9fd$export$437ad40c783f9f71 = (queryStringParams)=>{
    const { portalIds: selectedPortalIds } = queryStringParams;
    if (!selectedPortalIds) return [];
    return Array.isArray(selectedPortalIds) ? selectedPortalIds : [
        selectedPortalIds
    ];
};
const $29e4d330dd06a9fd$export$596cf762087ae00e = (queryStringParams)=>{
    const { categoryIds: selectedCategoryIds } = queryStringParams;
    if (!selectedCategoryIds) return [];
    return Array.isArray(selectedCategoryIds) ? selectedCategoryIds : [
        selectedCategoryIds
    ];
};
const $29e4d330dd06a9fd$export$905fe28a7c283e1d = (text = '', term = '')=>(0, $7upu0.default)(text, term).replace(/@@@hl@@@/g, '<strong>').replace(/@@@endhl@@@/g, '</strong>');
const $29e4d330dd06a9fd$export$519cc8c1640d01b8 = (text = '', term = '')=>(0, $7upu0.default)(text, term).replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $29e4d330dd06a9fd$export$b37ee0d76c6d2fbc = ()=>{
    const [{ location: location }, _] = (0, $i9cdb.useRouter)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $8P7DW.useMemo)(()=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1yZX))).parse(location.search);
    }, [
        location.search
    ]);
    const portalIds = (0, $8P7DW.useMemo)(()=>$29e4d330dd06a9fd$export$437ad40c783f9f71(queryStringParams), [
        queryStringParams
    ]);
    const categoryIds = (0, $8P7DW.useMemo)(()=>$29e4d330dd06a9fd$export$596cf762087ae00e(queryStringParams), [
        queryStringParams
    ]);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...queryStringParams,
        portalIds: portalIds,
        categoryIds: categoryIds
    };
};
const $29e4d330dd06a9fd$export$3bdd4cf348080703 = (portalId)=>portalId !== undefined && $29e4d330dd06a9fd$export$c36431be801010b(portalId) !== 0;
const $29e4d330dd06a9fd$export$34d09b0baed7315d = (term)=>Boolean(term && term.trim() !== '');
const $29e4d330dd06a9fd$export$c36431be801010b = (portalId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($gKQQC)))(portalId);
};
const $29e4d330dd06a9fd$export$b78190df63b1b0c4 = (ids)=>{
    if (ids) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5kYxc)))(ids) || (0, (/*@__PURE__*/$parcel$interopDefault($gSAAy)))(ids)) return [
            ids.toString()
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($u1Zdx)))(ids) ? ids : [];
    }
    return [];
};
const $29e4d330dd06a9fd$export$c8b38685f22f1bb2 = (eventProperties, createAnalyticsEvent, portalId)=>{
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'UI',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $29e4d330dd06a9fd$export$653243929c3168a8 = (eventProperties, createAnalyticsEvent, portalId)=>{
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'OPERATIONAL',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $29e4d330dd06a9fd$export$54299a3c81f5425 = ()=>{
    const [isHovered, setIsHovered] = (0, $8P7DW.useState)(false);
    const [isFocused, setIsFocused] = (0, $8P7DW.useState)(false);
    const [isShortcutIconVisible, setIsShortcutIconVisible] = (0, $8P7DW.useState)(false);
    return {
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsShortcutIconVisible: setIsShortcutIconVisible,
        isShortcutIconVisible: isHovered || isFocused || isShortcutIconVisible
    };
};

});
parcelRegister("5kYxc", function(module, exports) {

var $8t6rv = parcelRequire("8t6rv");

var $b6nDQ = parcelRequire("b6nDQ");
/** `Object#toString` result references. */ var $3e2dc6dfa94dca99$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $3e2dc6dfa94dca99$var$isNumber(value) {
    return typeof value == 'number' || $b6nDQ(value) && $8t6rv(value) == $3e2dc6dfa94dca99$var$numberTag;
}
module.exports = $3e2dc6dfa94dca99$var$isNumber;

});

parcelRegister("gSAAy", function(module, exports) {

var $8t6rv = parcelRequire("8t6rv");

var $u1Zdx = parcelRequire("u1Zdx");

var $b6nDQ = parcelRequire("b6nDQ");
/** `Object#toString` result references. */ var $c49e123bbda8ced7$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $c49e123bbda8ced7$var$isString(value) {
    return typeof value == 'string' || !$u1Zdx(value) && $b6nDQ(value) && $8t6rv(value) == $c49e123bbda8ced7$var$stringTag;
}
module.exports = $c49e123bbda8ced7$var$isString;

});

parcelRegister("gKQQC", function(module, exports) {

var $eRtrt = parcelRequire("eRtrt");

var $fB6fn = parcelRequire("fB6fn");
/** Used as references for various `Number` constants. */ var $c329efa78f36708c$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */ function $c329efa78f36708c$var$toSafeInteger(value) {
    return value ? $eRtrt($fB6fn(value), -$c329efa78f36708c$var$MAX_SAFE_INTEGER, $c329efa78f36708c$var$MAX_SAFE_INTEGER) : value === 0 ? value : 0;
}
module.exports = $c329efa78f36708c$var$toSafeInteger;

});
parcelRegister("eRtrt", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $ad1cda80c47d111f$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $ad1cda80c47d111f$var$baseClamp;

});


parcelRegister("7upu0", function(module, exports) {
$parcel$export(module.exports, "default", () => $643d342c1e1038de$export$2e2bcd8739ae039);

var $1We2B = parcelRequire("1We2B");
function $643d342c1e1038de$export$2e2bcd8739ae039(textHtml, keyword) {
    const escapedTextHtml = (0, $1We2B.escape)(textHtml);
    if (keyword) {
        const dynamicRegex = new RegExp(`([^_\\s,-]*)${(0, $1We2B.escapeRegExp)((0, $1We2B.escape)(keyword))}([^_\\s,-]*)`, 'gi');
        return escapedTextHtml.replace(dynamicRegex, (match)=>{
            return `<strong>${match}</strong>`;
        });
    }
    return escapedTextHtml;
}

});



parcelRegister("ikBUv", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => (parcelRequire("d82Wh")).InlineResultsContextProvider);
$parcel$export(module.exports, "useInlineResultsContext", () => (parcelRequire("d82Wh")).useInlineResultsContext);

var $d82Wh = parcelRequire("d82Wh");

});
parcelRegister("d82Wh", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => $e81d0d7621ecdde5$export$55d16b7f4336c4d7);
$parcel$export(module.exports, "useInlineResultsContext", () => $e81d0d7621ecdde5$export$243a7c3fd4b96b3e);

var $8P7DW = parcelRequire("8P7DW");
const $e81d0d7621ecdde5$var$InlineResultsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(null);
const $e81d0d7621ecdde5$export$55d16b7f4336c4d7 = ({ children: children })=>{
    const [resultsCount, setResultsCount] = (0, $8P7DW.useState)(null);
    const updateSearchResultsCount = (0, $8P7DW.useCallback)((resourceType, resourceCount)=>setResultsCount((state)=>({
                ...state,
                [resourceType]: resourceCount
            })), [
        setResultsCount
    ]);
    const clearSearchResultsCount = (0, $8P7DW.useCallback)(()=>setResultsCount(null), [
        setResultsCount
    ]);
    const contextValue = (0, $8P7DW.useMemo)(()=>({
            resultsCount: resultsCount,
            clearSearchResultsCount: clearSearchResultsCount,
            updateSearchResultsCount: updateSearchResultsCount
        }), [
        resultsCount,
        clearSearchResultsCount,
        updateSearchResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($e81d0d7621ecdde5$var$InlineResultsContext.Provider, {
        value: contextValue
    }, children);
};
const $e81d0d7621ecdde5$export$243a7c3fd4b96b3e = ()=>{
    const context = (0, $8P7DW.useContext)($e81d0d7621ecdde5$var$InlineResultsContext);
    if (!context) throw new Error('useInlineResultsContext must be used within InlineResultsContextProvider');
    return context;
};

});


parcelRegister("dHHa4", function(module, exports) {
$parcel$export(module.exports, "SearchErrorBoundary", () => (parcelRequire("bPEbW")).default);

var $bPEbW = parcelRequire("bPEbW");

});
parcelRegister("bPEbW", function(module, exports) {
$parcel$export(module.exports, "default", () => $5eaad8eedbe85634$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $edC7N = parcelRequire("edC7N");

var $1We2B = parcelRequire("1We2B");

var $gk18s = parcelRequire("gk18s");

var $86q7M = parcelRequire("86q7M");

var $hrPHR = parcelRequire("hrPHR");

var $klz3F = parcelRequire("klz3F");
parcelRequire("04PhR");
var $kcOMm = parcelRequire("kcOMm");

var $gvqx2 = parcelRequire("gvqx2");
const $5eaad8eedbe85634$var$SearchErrorBoundary = ({ screenName: screenName, id: id, children: children, renderError: renderError })=>{
    /**
   * If any error unrecoverable occurs inside search
   * 1. It should fail the entire experience - UFO
   * 2. Return null by default
   * 3. Send error payload to sentry and analytics - through ErrorBoundary
   * 4. Pass reason for the failure using UFO
   */ const markExperienceFailed = (0, $8P7DW.useCallback)((error)=>{
        if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) {
            const metadata = {
                id: id,
                error: error === null || error === void 0 ? void 0 : error.message,
                failureEvent: screenName
            };
            (0, $gvqx2.searchExperience).failure({
                metadata: metadata
            }).then((0, $1We2B.noop)).catch((0, $1We2B.noop));
            if ((0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType)) (0, $gvqx2.csmSearchExperience).failure({
                metadata: metadata
            }).then((0, $1We2B.noop)).catch((0, $1We2B.noop));
            (0, $gvqx2.inlineSearchExperience).failure({
                metadata: metadata
            }).then((0, $1We2B.noop)).catch((0, $1We2B.noop));
        }
    }, [
        id,
        screenName
    ]);
    const defaultRenderError = (0, $8P7DW.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kcOMm.default), null);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: screenName,
        id: id,
        renderError: renderError ? renderError : defaultRenderError,
        onError: markExperienceFailed
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(children));
};
var $5eaad8eedbe85634$export$2e2bcd8739ae039 = (0, $86q7M.default)($5eaad8eedbe85634$var$SearchErrorBoundary);

});
parcelRegister("04PhR", function(module, exports) {
$parcel$export(module.exports, "SearchResultError", () => (parcelRequire("kcOMm")).default);

var $kcOMm = parcelRequire("kcOMm");

});
parcelRegister("kcOMm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3072728323246bf9$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $04X5p = parcelRequire("04X5p");

var $2CgpM = parcelRequire("2CgpM");

var $5jYgE = parcelRequire("5jYgE");

var $iqJis = parcelRequire("iqJis");

var $2IKBM = parcelRequire("2IKBM");

var $jsmb9 = parcelRequire("jsmb9");
parcelRequire("ibkPE");
var $k0cKu = parcelRequire("k0cKu");

var $iaTgB = parcelRequire("iaTgB");
const $3072728323246bf9$var$SearchResultError = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k0cKu.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2CgpM)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "xsmall"
    }, formatMessage((0, $iaTgB.default).searchErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("p", {
        style: {
            textAlign: 'center'
        }
    }, formatMessage((0, $iaTgB.default).searchErrorText, {
        helpCenterLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $04X5p.default), {
            to: (0, $jsmb9.getHelpCenterUrl)(),
            actionSubjectId: "helpCenterLink"
        }, formatMessage((0, $iaTgB.default).helpCenter))
    })));
};
var $3072728323246bf9$export$2e2bcd8739ae039 = $3072728323246bf9$var$SearchResultError;

});
parcelRegister("2CgpM", function(module, exports) {
module.exports = new URL("../images/search-modal-error.b0f67bec.svg", import.meta.url).toString();

});

parcelRegister("iaTgB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a86878f94ef8dd7d$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $a86878f94ef8dd7d$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    searchErrorTitle: {
        defaultMessage: 'We couldn\u2019t load your search results',
        description: 'Text to tell the user that there was an error while conducting a search',
        id: 'cv.search.error.title'
    },
    searchErrorText: {
        defaultMessage: 'Refresh the page and try again. Or go back to the { helpCenterLink }.',
        description: 'Text to tell the user how to proceed after there is an error while searching',
        id: 'cv.search.error.message'
    },
    helpCenter: {
        defaultMessage: 'help center',
        description: 'Text to render help center link',
        id: 'cv.search.error.help-center'
    }
});

});



parcelRegister("gvqx2", function(module, exports) {
$parcel$export(module.exports, "searchExperience", () => $6956c32362d6f54e$export$478fc2b872b7df27);
$parcel$export(module.exports, "csmSearchExperience", () => $6956c32362d6f54e$export$c32ff69c6cd0bb0b);
$parcel$export(module.exports, "inlineSearchExperience", () => $6956c32362d6f54e$export$e3eaed2128f58e6a);

var $lQb0x = parcelRequire("lQb0x");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $6956c32362d6f54e$export$478fc2b872b7df27 = new (0, $ghwxF.UFOExperience)((0, $lQb0x.searchExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageLoad
});
const $6956c32362d6f54e$export$c32ff69c6cd0bb0b = new (0, $ghwxF.UFOExperience)('csm-help-center-search', {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $6956c32362d6f54e$export$e3eaed2128f58e6a = new (0, $ghwxF.UFOExperience)((0, $lQb0x.inlineSearchExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});



parcelRegister("lQBpH", function(module, exports) {
$parcel$export(module.exports, "SearchModal", () => (parcelRequire("52sI9")).default);

var $52sI9 = parcelRequire("52sI9");

});
parcelRegister("52sI9", function(module, exports) {
$parcel$export(module.exports, "default", () => $00b70fa6d7b9a51f$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $jByYr = parcelRequire("jByYr");

var $cuAVQ = parcelRequire("cuAVQ");

var $h1yZX = parcelRequire("h1yZX");

var $fmVHO = parcelRequire("fmVHO");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $cBdFf = parcelRequire("cBdFf");

var $bT4U6 = parcelRequire("bT4U6");

var $1NJBM = parcelRequire("1NJBM");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $ktwNU = parcelRequire("ktwNU");
var $2Mjg8 = parcelRequire("2Mjg8");
var $2IKBM = parcelRequire("2IKBM");
var $37U6z = parcelRequire("37U6z");

var $2nrNX = parcelRequire("2nrNX");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $an0gU = parcelRequire("an0gU");

var $gjhiH = parcelRequire("gjhiH");

var $5H4LN = parcelRequire("5H4LN");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");
var $k0cKu = parcelRequire("k0cKu");
parcelRequire("izDZr");
var $7n80L = parcelRequire("7n80L");
parcelRequire("1x6ab");
var $hwVTW = parcelRequire("hwVTW");
parcelRequire("5NkV1");
var $lhxXd = parcelRequire("lhxXd");

var $4575H = parcelRequire("4575H");
function $00b70fa6d7b9a51f$var$deriveVirtualAgentAvailable(forProject, scope, isVSAOnHCEnabled) {
    const forPortal = scope === 'portal' && forProject;
    const forHelpCenter = scope === 'helpCenter' && Boolean(isVSAOnHCEnabled);
    return Boolean(forPortal || forHelpCenter);
}
const $00b70fa6d7b9a51f$var$SearchModal = ({ isOpen: isOpen, term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, isLoggedIn: isLoggedIn, portalId: portalId, projectId: projectId, onSearch: onSearch, onClose: onClose, onReturnFocus: onReturnFocus })=>{
    const cloudId = (0, $jByYr.getCloudId)();
    const scope = portalId ? 'portal' : 'helpCenter';
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const showSearchResults = (0, $iwSnV.isValidSearchTerm)(term);
    const { isVirtualAgentEnabled: isVirtualAgentAvailableForProject } = (0, $an0gU.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const isVirtualAgentAvailable = $00b70fa6d7b9a51f$var$deriveVirtualAgentAvailable(isVirtualAgentAvailableForProject, scope, isVSAOnHCEnabled);
    const showFilters = !isCSM;
    const onKeyUp = (0, $8P7DW.useCallback)((event)=>{
        if (event.key === 'Escape') onClose();
    }, [
        onClose
    ]);
    const [{ location: location }, { replace: replace }] = (0, $i9cdb.useRouter)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $iwSnV.useQueryParams)();
    const { portalIds: portalIds, categoryIds: categoryIds } = queryStringParams;
    const portalIdAsNumber = (0, $iwSnV.getPortalIdAsNumber)(portalId);
    const showCategoryFilter = (0, $iwSnV.isSinglePortalSearch)(portalIdAsNumber);
    const onServiceDeskFilterChange = (0, $8P7DW.useCallback)((options)=>{
        const selectedPortalIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($h1yZX))).stringify({
            ...queryStringParams,
            portalIds: selectedPortalIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const onCategoryFilterChange = (0, $8P7DW.useCallback)((options)=>{
        const selectedCategoryIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($h1yZX))).stringify({
            ...queryStringParams,
            categoryIds: selectedCategoryIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const filtersRow = showFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        xcss: $00b70fa6d7b9a51f$var$filterStyles
    }, showCategoryFilter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5H4LN.default), {
        onChange: onCategoryFilterChange,
        portalId: portalIdAsNumber,
        projectId: projectId,
        categoryIds: categoryIds
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4575H.default), {
        onChange: onServiceDeskFilterChange,
        portalIds: portalIds
    }));
    const resultsContent = showSearchResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), null, isVirtualAgentAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $00b70fa6d7b9a51f$var$virtualBannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gjhiH.VirtualAgentBanner), {
        cloudId: cloudId,
        portalId: portalId
    })), filtersRow), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lhxXd.SearchResult), {
        term: term
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7n80L.SearchResultNone), {
        term: term
    });
    const renderResults = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
            gap: "space.200",
            templateColumns: "1fr",
            alignItems: "center",
            xcss: $00b70fa6d7b9a51f$var$responsiveStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null), resultsContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bT4U6.default), {
        duration: "small",
        entranceDirection: "bottom"
    }, (fadeInProps)=>isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1NJBM.default), {
            zIndex: (0, $2nrNX.layers).dialog()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
            ...fadeInProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            style: {
                width: '100vw',
                height: '100vh',
                position: 'fixed',
                top: '0px',
                left: '0px'
            },
            role: "dialog",
            "aria-modal": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fmVHO.default), {
            autoFocus: true,
            returnFocus: onReturnFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cuAVQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cBdFf.default), {
            shouldAllowClickThrough: false,
            isTinted: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $37U6z.xcss)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                height: `calc(100% - ${(0, $k0cKu.SEARCH_BAR_HEIGHT)})`
            }),
            onKeyUp: onKeyUp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hwVTW.SearchBar), {
            term: term,
            onChange: onSearch,
            onClose: onClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            id: "dynamic-search-result",
            "aria-live": "polite",
            "aria-atomic": "true",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $37U6z.xcss)({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                top: (0, $k0cKu.SEARCH_BAR_HEIGHT),
                backgroundColor: 'elevation.surface.overlay',
                paddingTop: 'space.300',
                paddingBottom: 'space.200',
                overflow: 'auto'
            })
        }, renderResults())))))));
};
var $00b70fa6d7b9a51f$export$2e2bcd8739ae039 = (0, $jvoWT.default)((0, $ehscL.createSelector)((0, $hx8zX.isLoggedIn), (state, { portalId: portalId })=>({
        portalId: portalId,
        projectId: (0, $73V7l.getProjectId)(state, (0, $iwSnV.getPortalIdAsNumber)(portalId))
    }), (isLoggedIn, { portalId: portalId, projectId: projectId })=>({
        isLoggedIn: isLoggedIn,
        portalId: portalId,
        projectId: projectId
    })))($00b70fa6d7b9a51f$var$SearchModal);
const $00b70fa6d7b9a51f$var$virtualBannerStyles = (0, $37U6z.xcss)({
    marginBottom: 'space.200'
});
const $00b70fa6d7b9a51f$var$filterStyles = (0, $37U6z.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.300'
});
const $00b70fa6d7b9a51f$var$responsiveStyles = (0, $37U6z.xcss)({
    [(0, $2Mjg8.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $2Mjg8.media).above.md]: {
        gridTemplateColumns: '1fr 965px 1fr',
        marginLeft: 'space.0',
        marginRight: 'space.0'
    }
});

});
parcelRegister("cuAVQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $456efe6b6b20eac4$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");
parcelRequire("lMBOd");
var $3tfcE = parcelRequire("3tfcE");

var $3HlRJ = parcelRequire("3HlRJ");
const $456efe6b6b20eac4$export$38d08b04f5a0ce72 = /*#__PURE__*/ (0, $2UsNA.default)((0, $3tfcE.default)).withConfig({
    componentId: "sc-1eshvn8-0"
})`overflow:hidden;position:relative;box-sizing:border-box;padding-right:${(props)=>props.scrollbarWidth}px;`;
class $456efe6b6b20eac4$export$2e2bcd8739ae039 extends $8P7DW.Component {
    componentDidMount() {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        if (!document.body) return;
        const scrollbarWidth = (0, $3HlRJ.windowInnerWidth)() - (0, $3HlRJ.bodyClientWidth)();
        this.setState({
            scrollbarWidth: scrollbarWidth,
            show: true
        });
    }
    render() {
        return this.state.show ? /*#__PURE__*/ $8P7DW.createElement($456efe6b6b20eac4$export$38d08b04f5a0ce72, {
            scrollbarWidth: this.state.scrollbarWidth
        }) : null;
    }
    constructor(...args){
        super(...args), this.state = {
            scrollbarWidth: 0,
            show: false
        };
    }
}

});
parcelRegister("3HlRJ", function(module, exports) {
$parcel$export(module.exports, "windowInnerWidth", () => $5208ef6f0410756f$export$c2f81cb82ec2bad8);
$parcel$export(module.exports, "bodyClientWidth", () => $5208ef6f0410756f$export$d31820d1c745406f);
const $5208ef6f0410756f$export$c2f81cb82ec2bad8 = ()=>window.innerWidth;
const $5208ef6f0410756f$export$d31820d1c745406f = ()=>document.body.clientWidth;

});


parcelRegister("fmVHO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b305ac3590843693$export$2e2bcd8739ae039);

var $6BJ0T = parcelRequire("6BJ0T");

var $b305ac3590843693$export$2e2bcd8739ae039 = (0, $6BJ0T.default);

});
parcelRegister("6BJ0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cf91d8589ad2533$export$2e2bcd8739ae039);

var $911Xe = parcelRequire("911Xe");

var $cCnFQ = parcelRequire("cCnFQ");

var $8P7DW = parcelRequire("8P7DW");

var $25VfD = parcelRequire("25VfD");

var $1L8M7 = parcelRequire("1L8M7");
var $4cf91d8589ad2533$var$FocusLockCombination = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $25VfD.default), (0, $cCnFQ.default)({
        sideCar: (0, $1L8M7.default),
        ref: ref
    }, props));
});
var $4cf91d8589ad2533$var$_ref = (0, $25VfD.default).propTypes || {}, $4cf91d8589ad2533$var$sideCar = $4cf91d8589ad2533$var$_ref.sideCar, $4cf91d8589ad2533$var$propTypes = (0, $911Xe.default)($4cf91d8589ad2533$var$_ref, [
    "sideCar"
]);
$4cf91d8589ad2533$var$FocusLockCombination.propTypes = {};
var $4cf91d8589ad2533$export$2e2bcd8739ae039 = $4cf91d8589ad2533$var$FocusLockCombination;

});
parcelRegister("25VfD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1868754a9eb62752$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");

var $8P7DW = parcelRequire("8P7DW");


var $4co8y = parcelRequire("4co8y");

var $b0nWD = parcelRequire("b0nWD");

var $bKnY0 = parcelRequire("bKnY0");

var $1tiyC = parcelRequire("1tiyC");

var $kuIEP = parcelRequire("kuIEP");
var $1868754a9eb62752$var$emptyArray = [];
var $1868754a9eb62752$var$FocusLock = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $8P7DW.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $8P7DW.useRef)();
    var isActive = (0, $8P7DW.useRef)(false);
    var originalFocusedElement = (0, $8P7DW.useRef)(null);
    var _useState2 = (0, $8P7DW.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $1868754a9eb62752$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $8P7DW.useState)({}), id = _useState3[0];
    var onActivation = (0, $8P7DW.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $8P7DW.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $8P7DW.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $8P7DW.useCallback)(function(event) {
        if (isActive.current) (0, $1tiyC.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $1tiyC.mediumBlur).useMedium;
    var setObserveNode = (0, $8P7DW.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $cCnFQ.default)((_extends2 = {}, _extends2[0, $4co8y.FOCUS_DISABLED] = disabled && 'disabled', _extends2[0, $4co8y.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $b0nWD.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $8P7DW.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $bKnY0.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $bKnY0.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(SideCar, {
        id: id,
        sideCar: (0, $1tiyC.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Container, (0, $cCnFQ.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kuIEP.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $bKnY0.hiddenGuard)
    }));
});
$1868754a9eb62752$var$FocusLock.propTypes = {};
var $1868754a9eb62752$export$2e2bcd8739ae039 = $1868754a9eb62752$var$FocusLock;

});
parcelRegister("bKnY0", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $88d694e3333c3e7a$export$b8c7b07253306600);

var $8P7DW = parcelRequire("8P7DW");

var $88d694e3333c3e7a$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $88d694e3333c3e7a$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $88d694e3333c3e7a$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $88d694e3333c3e7a$export$b8c7b07253306600
    }));
};
$88d694e3333c3e7a$var$InFocusGuard.propTypes = {};
var $88d694e3333c3e7a$export$2e2bcd8739ae039 = $88d694e3333c3e7a$var$InFocusGuard;

});

parcelRegister("1tiyC", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $1126e4fef9872ddd$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $1126e4fef9872ddd$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $1126e4fef9872ddd$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $1126e4fef9872ddd$export$892cbf28e5518020);

var $1UdaV = parcelRequire("1UdaV");
var $1126e4fef9872ddd$export$5733e022b1d538cb = (0, $1UdaV.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $1126e4fef9872ddd$export$b3e9a9312f73723c = (0, $1UdaV.createMedium)();
var $1126e4fef9872ddd$export$3a1d52767cbc07b8 = (0, $1UdaV.createMedium)();
var $1126e4fef9872ddd$export$892cbf28e5518020 = (0, $1UdaV.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});

parcelRegister("kuIEP", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $eeb9400bdd63191a$export$f5272e9b1168239c);

var $8P7DW = parcelRequire("8P7DW");
var $eeb9400bdd63191a$export$f5272e9b1168239c = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);

});


parcelRegister("1L8M7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1480fcc8ddf4e279$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");


var $7jPL5 = parcelRequire("7jPL5");

var $lPbQi = parcelRequire("lPbQi");
var $3sW1G = parcelRequire("3sW1G");
var $132Hv = parcelRequire("132Hv");
var $ciroK = parcelRequire("ciroK");
var $jFxbd = parcelRequire("jFxbd");
var $fxBxj = parcelRequire("fxBxj");parcelRequire("jaGI3");
var $7pRMw = parcelRequire("7pRMw");

var $biy7U = parcelRequire("biy7U");

var $1tiyC = parcelRequire("1tiyC");
var $1480fcc8ddf4e279$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $1480fcc8ddf4e279$var$isFreeFocus = function isFreeFocus() {
    return $1480fcc8ddf4e279$var$focusOnBody() || (0, $jFxbd.focusIsHidden)();
};
var $1480fcc8ddf4e279$var$lastActiveTrap = null;
var $1480fcc8ddf4e279$var$lastActiveFocus = null;
var $1480fcc8ddf4e279$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $1480fcc8ddf4e279$var$lastPortaledElement = null;
var $1480fcc8ddf4e279$var$focusWasOutsideWindow = false;
var $1480fcc8ddf4e279$var$windowFocused = false;
var $1480fcc8ddf4e279$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $1480fcc8ddf4e279$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($1480fcc8ddf4e279$var$lastActiveTrap.whiteList || $1480fcc8ddf4e279$var$defaultWhitelist)(activeElement);
};
var $1480fcc8ddf4e279$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $1480fcc8ddf4e279$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $1480fcc8ddf4e279$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $1480fcc8ddf4e279$var$lastPortaledElement && $1480fcc8ddf4e279$var$lastPortaledElement.portaledElement === element;
};
function $1480fcc8ddf4e279$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $1480fcc8ddf4e279$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($1480fcc8ddf4e279$var$focusWasOutsideWindow);
    return $1480fcc8ddf4e279$var$focusWasOutsideWindow === 'meanwhile';
};
var $1480fcc8ddf4e279$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $1480fcc8ddf4e279$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $1480fcc8ddf4e279$var$checkInHost(activeElement, area, area);
    });
};
var $1480fcc8ddf4e279$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $fxBxj.getFocusableNodes)(nodes, new Map());
};
var $1480fcc8ddf4e279$var$isNotFocusable = function isNotFocusable(node) {
    return !$1480fcc8ddf4e279$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $1480fcc8ddf4e279$var$activateTrap = function activateTrap() {
    var result = false;
    if ($1480fcc8ddf4e279$var$lastActiveTrap) {
        var _lastActiveTrap = $1480fcc8ddf4e279$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $1480fcc8ddf4e279$var$lastPortaledElement && $1480fcc8ddf4e279$var$lastPortaledElement.portaledElement;
        if ($1480fcc8ddf4e279$var$focusOnBody() && $1480fcc8ddf4e279$var$lastActiveFocus && $1480fcc8ddf4e279$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($1480fcc8ddf4e279$var$lastActiveFocus) || $1480fcc8ddf4e279$var$isNotFocusable($1480fcc8ddf4e279$var$lastActiveFocus)) {
                var newTarget = $1480fcc8ddf4e279$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $biy7U.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$1480fcc8ddf4e279$var$focusWasOutside(crossFrame) || !noFocusGuards || !$1480fcc8ddf4e279$var$lastActiveFocus || $1480fcc8ddf4e279$var$windowFocused) return false;
                var nodes = $1480fcc8ddf4e279$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $1480fcc8ddf4e279$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $1480fcc8ddf4e279$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$1480fcc8ddf4e279$var$isFreeFocus() || !$1480fcc8ddf4e279$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $ciroK.focusInside)(workingArea) || activeElement && $1480fcc8ddf4e279$var$withinHost(activeElement, workingArea) || $1480fcc8ddf4e279$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$1480fcc8ddf4e279$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $7pRMw.moveFocusInside)(workingArea, $1480fcc8ddf4e279$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $1480fcc8ddf4e279$var$lastPortaledElement = {};
                        }
                    }
                    $1480fcc8ddf4e279$var$lastActiveFocus = document && document.activeElement;
                    if ($1480fcc8ddf4e279$var$lastActiveFocus !== document.body) $1480fcc8ddf4e279$var$tryRestoreFocus = (0, $lPbQi.captureFocusRestore)($1480fcc8ddf4e279$var$lastActiveFocus);
                    $1480fcc8ddf4e279$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $3sW1G.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $1480fcc8ddf4e279$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $1480fcc8ddf4e279$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $1480fcc8ddf4e279$var$onTrap = function onTrap(event) {
    if ($1480fcc8ddf4e279$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $1480fcc8ddf4e279$var$onBlur = function onBlur() {
    return (0, $biy7U.deferAction)($1480fcc8ddf4e279$var$activateTrap);
};
var $1480fcc8ddf4e279$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $1480fcc8ddf4e279$var$recordPortal(currentNode, source);
};
var $1480fcc8ddf4e279$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $1480fcc8ddf4e279$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        onBlur: $1480fcc8ddf4e279$var$onBlur,
        onFocus: $1480fcc8ddf4e279$var$onFocus
    }, children);
};
$1480fcc8ddf4e279$var$FocusTrap.propTypes = {};
var $1480fcc8ddf4e279$var$onWindowFocus = function onWindowFocus() {
    $1480fcc8ddf4e279$var$windowFocused = true;
};
var $1480fcc8ddf4e279$var$onWindowBlur = function onWindowBlur() {
    $1480fcc8ddf4e279$var$windowFocused = false;
    $1480fcc8ddf4e279$var$focusWasOutsideWindow = 'just';
    (0, $biy7U.deferAction)(function() {
        $1480fcc8ddf4e279$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $1480fcc8ddf4e279$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $1480fcc8ddf4e279$var$onTrap);
    document.addEventListener('focusout', $1480fcc8ddf4e279$var$onBlur);
    window.addEventListener('focus', $1480fcc8ddf4e279$var$onWindowFocus);
    window.addEventListener('blur', $1480fcc8ddf4e279$var$onWindowBlur);
};
var $1480fcc8ddf4e279$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $1480fcc8ddf4e279$var$onTrap);
    document.removeEventListener('focusout', $1480fcc8ddf4e279$var$onBlur);
    window.removeEventListener('focus', $1480fcc8ddf4e279$var$onWindowFocus);
    window.removeEventListener('blur', $1480fcc8ddf4e279$var$onWindowBlur);
};
function $1480fcc8ddf4e279$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $1480fcc8ddf4e279$var$focusLockAPI = {
    moveFocusInside: (0, $7pRMw.moveFocusInside),
    focusInside: (0, $ciroK.focusInside),
    focusNextElement: (0, $132Hv.focusNextElement),
    focusPrevElement: (0, $132Hv.focusPrevElement),
    focusFirstElement: (0, $132Hv.focusFirstElement),
    focusLastElement: (0, $132Hv.focusLastElement),
    captureFocusRestore: (0, $lPbQi.captureFocusRestore)
};
function $1480fcc8ddf4e279$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$1480fcc8ddf4e279$var$lastActiveTrap) $1480fcc8ddf4e279$var$attachHandler();
    var lastTrap = $1480fcc8ddf4e279$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $1480fcc8ddf4e279$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $1480fcc8ddf4e279$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($1480fcc8ddf4e279$var$focusLockAPI);
        $1480fcc8ddf4e279$var$activateTrap(true);
        (0, $biy7U.deferAction)($1480fcc8ddf4e279$var$activateTrap);
    } else {
        $1480fcc8ddf4e279$var$detachHandler();
        $1480fcc8ddf4e279$var$lastActiveFocus = null;
    }
}
(0, $1tiyC.mediumFocus).assignSyncMedium($1480fcc8ddf4e279$var$onFocus);
(0, $1tiyC.mediumBlur).assignMedium($1480fcc8ddf4e279$var$onBlur);
(0, $1tiyC.mediumEffect).assignMedium(function(cb) {
    return cb($1480fcc8ddf4e279$var$focusLockAPI);
});
var $1480fcc8ddf4e279$export$2e2bcd8739ae039 = (0, $7jPL5.default)($1480fcc8ddf4e279$var$reducePropsToState, $1480fcc8ddf4e279$var$handleStateChangeOnClient)($1480fcc8ddf4e279$var$FocusWatcher);

});
parcelRegister("biy7U", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $839bd8ff9d068d68$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $839bd8ff9d068d68$export$c613fed06e332533);
function $839bd8ff9d068d68$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $839bd8ff9d068d68$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $839bd8ff9d068d68$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("55x6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $9187687e1addaab7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $j4RVe = parcelRequire("j4RVe");

var $37U6z = parcelRequire("37U6z");
function $9187687e1addaab7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9187687e1addaab7$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $9187687e1addaab7$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $9187687e1addaab7$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $9187687e1addaab7$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $9187687e1addaab7$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $9187687e1addaab7$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $9187687e1addaab7$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $9187687e1addaab7$var$baseStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$9187687e1addaab7$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$9187687e1addaab7$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$9187687e1addaab7$var$gridTemplateRowsVar})`
});
const $9187687e1addaab7$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $9187687e1addaab7$var$Grid = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $37U6z.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $8P7DW.useMemo)(()=>({
            [$9187687e1addaab7$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$9187687e1addaab7$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$9187687e1addaab7$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $9187687e1addaab7$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $j4RVe.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $j4RVe.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $j4RVe.spaceStylesMap).rowGap[rowGap],
            alignItems && $9187687e1addaab7$var$alignItemsMap[alignItems],
            alignContent && $9187687e1addaab7$var$alignContentMap[alignContent],
            justifyContent && $9187687e1addaab7$var$justifyContentMap[justifyContent],
            autoFlow && $9187687e1addaab7$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$9187687e1addaab7$var$Grid.displayName = 'Grid';
var $9187687e1addaab7$export$2e2bcd8739ae039 = $9187687e1addaab7$var$Grid;

});

parcelRegister("2Mjg8", function(module, exports) {
$parcel$export(module.exports, "media", () => $f5b89dae9d263889$export$987d49ffe1b0900f);
$parcel$export(module.exports, "UNSAFE_media", () => $f5b89dae9d263889$export$c881183ca713c214);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $f5b89dae9d263889$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
const $f5b89dae9d263889$export$c881183ca713c214 = $f5b89dae9d263889$export$987d49ffe1b0900f;

});

parcelRegister("an0gU", function(module, exports) {
$parcel$export(module.exports, "useVirtualAgentAvailability", () => $0308dac82eecf8a3$export$4cf57cfa614a5585);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $iziiq = parcelRequire("iziiq");

var $klz3F = parcelRequire("klz3F");
const $0308dac82eecf8a3$var$initialState = {
    isVirtualAgentAvailable: false,
    isVirtualAgentEnabled: false,
    isLoading: true
};
const $0308dac82eecf8a3$var$reducer = (state, action)=>{
    switch(action.type){
        case 'RESET':
            return {
                ...$0308dac82eecf8a3$var$initialState,
                isLoading: false
            };
        case 'LOAD_AVAILABLITY':
            return $0308dac82eecf8a3$var$initialState;
        case 'SET_AVAILABILITY':
            return {
                isVirtualAgentAvailable: action.isVirtualAgentAvailable,
                isVirtualAgentEnabled: action.isVirtualAgentEnabled,
                isLoading: false
            };
        default:
            return state;
    }
};
const $0308dac82eecf8a3$export$4cf57cfa614a5585 = ({ isLoggedIn: isLoggedIn, projectId: projectId, cloudId: cloudId, baseUrl: baseUrl = '' })=>{
    const [{ isVirtualAgentAvailable: isVirtualAgentAvailable, isVirtualAgentEnabled: isVirtualAgentEnabled, isLoading: isLoading }, dispatch] = (0, $8P7DW.useReducer)($0308dac82eecf8a3$var$reducer, $0308dac82eecf8a3$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    (0, $8P7DW.useEffect)(()=>{
        const canAccess = isLoggedIn;
        if (!canAccess) {
            dispatch({
                type: 'RESET'
            });
            return;
        }
        if (projectId === undefined) {
            dispatch({
                type: 'LOAD_AVAILABLITY'
            });
            return;
        }
        dispatch({
            type: 'LOAD_AVAILABLITY'
        });
        (0, $klz3F.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${encodeURIComponent(cloudId)}/public/api/v1/virtualagent/byprojectid/${encodeURIComponent(projectId)}/availability`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            dispatch({
                type: 'SET_AVAILABILITY',
                isVirtualAgentAvailable: true,
                isVirtualAgentEnabled: response.isVirtualAgentEnabled
            });
        }).catch((err)=>{
            dispatch({
                type: 'SET_AVAILABILITY',
                isVirtualAgentAvailable: false,
                isVirtualAgentEnabled: false
            });
            if ('status' in err && typeof err.status === 'number' && err.status === 403) // AI is disabled or the user lacks permission, so this is not an error
            return;
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'virtualAgentAvailability',
                attributes: {
                    error: err.message
                }
            }).fire();
        });
    }, [
        createAnalyticsEvent,
        baseUrl,
        isLoggedIn,
        cloudId,
        projectId
    ]);
    return {
        isVirtualAgentAvailable: isVirtualAgentAvailable,
        isLoading: isLoading,
        isVirtualAgentEnabled: isVirtualAgentEnabled
    };
};

});

parcelRegister("gjhiH", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBanner", () => $c1258269a14cc589$export$c79d8d330f0b0297);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");

var $MmGmU = parcelRequire("MmGmU");

var $ifRQf = parcelRequire("ifRQf");

var $iqJis = parcelRequire("iqJis");

var $aflyD = parcelRequire("aflyD");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $37U6z = parcelRequire("37U6z");

var $iziiq = parcelRequire("iziiq");

var $aQXm8 = parcelRequire("aQXm8");

var $iPKGX = parcelRequire("iPKGX");
const $c1258269a14cc589$export$c79d8d330f0b0297 = ({ cloudId: cloudId, portalId: portalId })=>{
    const scope = portalId ? 'portal' : 'helpCenter';
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const [, { push: push }] = (0, $i9cdb.useRouter)();
    const chatWithVirtualAgentForPortal = (0, $8P7DW.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/66942
        createAnalyticsEvent({
            analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'chatWithVAButton'
        }).fire();
        if (portalId) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push(`/portal/${portalId}/conversation`);
    }, [
        push,
        portalId,
        createAnalyticsEvent
    ]);
    const chatWithVirtualAgentForHelpCenter = (0, $8P7DW.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'chatWithVAButtonOnHelpCenter'
        }).fire();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        push,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $c1258269a14cc589$var$containerStyles,
        role: "status",
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        spread: "space-between",
        space: "space.100",
        xcss: $c1258269a14cc589$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $iPKGX.default).virtualAgentBannerHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($c1258269a14cc589$var$Message, null, formatMessage((0, $iPKGX.default).virtualServiceAgentEAPBannerDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ifRQf.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aflyD))), {
            label: ""
        }),
        appearance: "primary",
        onClick: scope === 'portal' ? chatWithVirtualAgentForPortal : chatWithVirtualAgentForHelpCenter
    }, formatMessage((0, $iPKGX.default).buttonTextV2))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), {
        customData: {
            name: 'virtualAgentBanner',
            attributes: {
                cloudId: cloudId,
                portalId: portalId,
                state: 'visible'
            }
        }
    }));
};
const $c1258269a14cc589$var$containerStyles = (0, $37U6z.xcss)({
    background: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    padding: 'space.300',
    borderRadius: 'radius.small'
});
const $c1258269a14cc589$var$contentStyles = (0, $37U6z.xcss)({
    alignItems: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c1258269a14cc589$var$Message = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aQXm8", function(module, exports) {
$parcel$export(module.exports, "FireScreenEventOnMount", () => $b723dfe175ecbee4$export$787df3507b9eb1ae);

var $hbULj = parcelRequire("hbULj");

var $86q7M = parcelRequire("86q7M");
const $b723dfe175ecbee4$export$787df3507b9eb1ae = (0, $86q7M.default)((0, $hbULj.FireScreenEventOnMountStateless));
// Manually set the display name for sensible snapshots
$b723dfe175ecbee4$export$787df3507b9eb1ae.displayName = 'FireScreenEventOnMount';

});
parcelRegister("hbULj", function(module, exports) {
$parcel$export(module.exports, "FireScreenEventOnMountStateless", () => $f7f10f80067f3c64$export$641a363dc7c73107);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $8LbZn = parcelRequire("8LbZn");
var $3e28j = parcelRequire("3e28j");
var $17wqU = parcelRequire("17wqU");

var $iziiq = parcelRequire("iziiq");

var $brLzz = parcelRequire("brLzz");

var $lKEMb = parcelRequire("lKEMb");

var $fAqaB = parcelRequire("fAqaB");

var $jjE9o = parcelRequire("jjE9o");
class $f7f10f80067f3c64$export$641a363dc7c73107 extends $8P7DW.Component {
    render() {
        if ((0, $HGACo.isMigrateToAnalyticsBridgeEnabled)()) // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return /*#__PURE__*/ $8P7DW.createElement((0, $3e28j.MountEvent), {
            onMount: this.onMount,
            key: `${this.props.screenName}-${this.props.screenId}`
        });
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return /*#__PURE__*/ $8P7DW.createElement((0, $iziiq.MountEvent), {
            onMount: this.onMount,
            key: `${this.props.screenName}-${this.props.screenId}`
        });
    }
    constructor(...args){
        super(...args), this.endBrowserMetricsV3 = (screenName)=>{
            const { customData: customData } = this.props;
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const metric = (0, $brLzz.default)[screenName];
            /**
     * This is used to support the previously created performance mark
     */ (0, $fAqaB.perfMark)('second.data.loaded');
            (0, $lKEMb.devLog)('Browser Metrics v3: ending timer and firing event for screen:', screenName);
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            metric.stop({
                customData: customData
            });
        }, this.onMount = (analyticsEvent)=>{
            const { screenName: screenName } = this.props;
            if ((0, $HGACo.isMigrateToAnalyticsBridgeEnabled)()) (0, $8LbZn.fireScreenAnalytics)(analyticsEvent, (0, $jjE9o.AnalyticsTrackActions).VIEWED);
            else (0, $iziiq.fireAnalyticsEvent)({
                analyticsEvent: analyticsEvent,
                type: (0, $iziiq.EventTypes).SCREEN
            });
            /**
     * Fire jsm-ui viewed event along with screen event
     * 1. This is done to for anti abuse spam work to detect human or bot spam
     * 2. We are firing this instead of `ui viewed` because that event is used for overall Atlassian MAU calculations.
     * 3. Event registration -> https://data-portal.internal.atlassian.com/analytics/registry/59264?tabIndex=Details
     */ const uiAnalyticsEvent = analyticsEvent.clone();
            if ((0, $HGACo.isMigrateToAnalyticsBridgeEnabled)()) (0, $8LbZn.fireAnalytics)(uiAnalyticsEvent, (0, $17wqU.UI_EVENT_TYPE), {
                actionSubject: 'jsm-ui',
                action: (0, $jjE9o.AnalyticsTrackActions).VIEWED
            });
            else {
                // The componentName is used as actionSubject in the analytics event
                uiAnalyticsEvent.context.push({
                    componentName: 'jsm-ui'
                });
                (0, $iziiq.fireAnalyticsEvent)({
                    analyticsEvent: uiAnalyticsEvent,
                    type: (0, $iziiq.EventTypes).UI,
                    payload: {}
                });
            }
            /**
     * Trigger Stop timer for for Page load metric only if
     * 1. screenName exists
     * 2. metrics is instrumented for that screen
     * 3. BM3 feature flag is enabled
     */ if (screenName && (0, $brLzz.isPageLoadInstrumented)(screenName)) this.endBrowserMetricsV3(screenName);
        };
    }
}

});
parcelRegister("3e28j", function(module, exports) {
$parcel$export(module.exports, "MountEvent", () => $743a36607d88b276$export$2c6963927dbc68f1);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $k7ZVu = parcelRequire("k7ZVu");
class $743a36607d88b276$var$MountEventComponent extends (0, $8P7DW.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $743a36607d88b276$var$MountEventComponentWithHOC = (0, $k7ZVu.default)()($743a36607d88b276$var$MountEventComponent);
const $743a36607d88b276$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)($743a36607d88b276$var$MountEventComponentWithHOC, {
        ...props
    });

});



parcelRegister("iPKGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3d682a0ec4c4441$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $c3d682a0ec4c4441$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    virtualAgentBannerHeading: {
        defaultMessage: 'Spend less time hunting for the right request form',
        description: 'Heading in section message displayed when user is on the portal and virtual service agent search is turned on.',
        id: 'virtual-agent.virtual-agent-banner-heading'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    virtualServiceAgentEAPBannerDescription: {
        defaultMessage: 'Ask any question and give our AI-powered virtual service agent a try.',
        description: 'Desription in section message displayed when user is on the portal and virtual service agent search is turned on for EAP.',
        id: 'virtual-agent.virtual-service-agent-EAP-banner-description'
    },
    iconAlt: {
        defaultMessage: 'Atlassian Intelligence',
        description: 'Alternative text for Atlassian Intelligence logo.',
        id: 'virtual-agent.virtual-agent-banner-icon-alt'
    },
    buttonTextV2: {
        defaultMessage: 'Chat with virtual service agent',
        description: 'Text for button which will take the user to the virtual agent conversation page.',
        id: 'virtual-agent.virtual-agent-banner-button-text-v-2'
    }
});

});


parcelRegister("5H4LN", function(module, exports) {
$parcel$export(module.exports, "default", () => $221dfd7a3fd36c63$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $gZNYv = parcelRequire("gZNYv");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $67iMu = parcelRequire("67iMu");
const $221dfd7a3fd36c63$var$selector = (0, $ehscL.createSelector)((state, props)=>(0, $73V7l.getCategories)(state, props.portalId), (maybeCategories)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories
    };
});
const $221dfd7a3fd36c63$var$CategoryFilter = (0, $jvoWT.default)($221dfd7a3fd36c63$var$selector, {
    fetchCategories: (0, $gZNYv.fetchCategoriesAction)
})((0, $67iMu.default));
var $221dfd7a3fd36c63$export$2e2bcd8739ae039 = $221dfd7a3fd36c63$var$CategoryFilter;

});
parcelRegister("67iMu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6313ac3decd4134$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("hjLj6");
var $8h2EC = parcelRequire("8h2EC");

var $hCUBS = parcelRequire("hCUBS");
const $f6313ac3decd4134$var$CategoryFilter = ({ portalId: portalId, fetchCategories: fetchCategories, categories: categories, categoryIds: categoryIds, onChange: onChange, projectId: projectId })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [values, _] = $8P7DW.useState(categoryIds ?? []);
    $8P7DW.useEffect(()=>{
        if (!projectId || !portalId) return;
        fetchCategories(projectId, portalId);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectId,
        portalId
    ]);
    const options = $8P7DW.useMemo(()=>{
        return categories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories
    ]);
    const preSelectedOptions = $8P7DW.useMemo(()=>{
        const preselectedCategories = categories.filter((category)=>values.find((id)=>id === category.id));
        return preselectedCategories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories,
        values
    ]);
    return categories.length > 1 ? /*#__PURE__*/ $8P7DW.createElement((0, $8h2EC.default), {
        fieldId: "category_filter",
        fieldLabel: formatMessage((0, $hCUBS.default).categoryFilter),
        testId: "categoryFilter",
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange
    }) : null;
};
var $f6313ac3decd4134$export$2e2bcd8739ae039 = $f6313ac3decd4134$var$CategoryFilter;

});
parcelRegister("hjLj6", function(module, exports) {
$parcel$export(module.exports, "SimplePicker", () => (parcelRequire("8h2EC")).default);

var $8h2EC = parcelRequire("8h2EC");

});
parcelRegister("8h2EC", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ecb7c85e15e37d6$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $1H1C6 = parcelRequire("1H1C6");

var $1We2B = parcelRequire("1We2B");

var $8gu7I = parcelRequire("8gu7I");
const $0ecb7c85e15e37d6$export$a250605dcad5aca0 = (str, toMatch)=>{
    if (!str) return false;
    return toMatch ? str.toLowerCase().includes(toMatch.toLowerCase()) : true;
};
const $0ecb7c85e15e37d6$export$60d56ed3961c839c = (0, $1We2B.memoize)((options, searchText)=>{
    if ((0, $1We2B.isEmpty)(searchText)) return options;
    const filteredOptions = [];
    for (const option of options)if ($0ecb7c85e15e37d6$export$a250605dcad5aca0(option.label, searchText)) filteredOptions.push(option);
    return filteredOptions;
}, (...args)=>JSON.stringify(args));
const $0ecb7c85e15e37d6$var$Picker = ({ options: options, preSelectedOptions: preSelectedOptions, onChange: onChange, fieldId: fieldId, testId: testId, fieldLabel: fieldLabel })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const [selectedValues, setSelectedValues] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(preSelectedOptions ?? []);
    const onPickerTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback(()=>{
        setIsOpen(true);
    }, []);
    const onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback(()=>{
        setIsOpen(false);
    }, []);
    const onFilterChange = (0, $8P7DW.useCallback)((selectedOptions)=>{
        onChange(selectedOptions);
        setSelectedValues(selectedOptions);
    }, [
        onChange
    ]);
    const onFilterClearValues = (0, $8P7DW.useCallback)(()=>{
        onChange([]);
        setSelectedValues([]);
    }, [
        onChange
    ]);
    const onLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((search, _enableFullList, _showFullList, _showMore, _lastOption, cb)=>{
        const filteredOptions = $0ecb7c85e15e37d6$export$60d56ed3961c839c(options, search);
        cb({
            options: filteredOptions,
            totalCount: filteredOptions.length
        });
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: fieldId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1H1C6.default), {
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        isOpen: isOpen,
        value: selectedValues,
        enablePagination: false,
        onOpen: onOpen,
        onClose: onClose,
        onChange: onFilterChange,
        onLoadOptions: onLoadOptions,
        onClearValues: onFilterClearValues,
        onPickerTriggerClick: onPickerTriggerClick,
        testId: testId
    }));
};
var $0ecb7c85e15e37d6$export$2e2bcd8739ae039 = $0ecb7c85e15e37d6$var$Picker;

});
parcelRegister("1H1C6", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a7a3f31b44777ef$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $e1jjh = parcelRequire("e1jjh");
var $fB0xT = parcelRequire("fB0xT");
var $kvIaU = parcelRequire("kvIaU");
const $0a7a3f31b44777ef$var$PaginatedFilter = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose, value: value, fieldId: fieldId, fieldLabel: fieldLabel, onChange: onChange, onLoadOptions: onLoadOptions, onClearValues: onClearValues, onPickerTriggerClick: onPickerTriggerClick, testId: testId, enablePagination: enablePagination = true } = props;
    const paginationConfig = enablePagination ? {
        enableFullList: false
    } : undefined;
    const onTrigger = $8P7DW.useCallback(({ ref: ref })=>{
        return /*#__PURE__*/ $8P7DW.createElement((0, $kvIaU.default), {
            hasValues: value.length > 0,
            onClick: onPickerTriggerClick,
            isSelected: isOpen,
            isInvalid: value.some((val)=>val.invalid),
            ref: ref,
            testId: testId
        }, (0, $fB0xT.formatLabel)(fieldLabel, value));
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        value,
        onOpen,
        isOpen,
        fieldLabel,
        onPickerTriggerClick
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($0a7a3f31b44777ef$var$PaginatedFilterWrapper, null, /*#__PURE__*/ $8P7DW.createElement((0, $e1jjh.Picker), {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        value: value,
        pagination: paginationConfig,
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        onChange: onChange,
        onLoadOptions: onLoadOptions,
        onTrigger: onTrigger,
        onClearValues: onClearValues
    }));
};
var $0a7a3f31b44777ef$export$2e2bcd8739ae039 = $0a7a3f31b44777ef$var$PaginatedFilter;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0a7a3f31b44777ef$var$PaginatedFilterWrapper = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-6q3nln-0"
})`display:flex;`;

});
parcelRegister("e1jjh", function(module, exports) {
$parcel$export(module.exports, "Picker", () => $e9a5e1d1924ff490$export$ba25329847403e11);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $c2L1U = parcelRequire("c2L1U");

var $2GTZ1 = parcelRequire("2GTZ1");

var $iWOJr = parcelRequire("iWOJr");

var $ic1zO = parcelRequire("ic1zO");

var $eIfQt = parcelRequire("eIfQt");
const $e9a5e1d1924ff490$export$ba25329847403e11 = ({ ariaLabel: ariaLabel, isOpen: isOpen, value: value, onClose: onClose, onClearValues: onClearValues, fieldId: fieldId, fieldLabel: fieldLabel, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, formatOptionLabel: formatOptionLabel = (0, $ic1zO.default), onLoadOptions: onLoadOptions, pagination: pagination, PopupComponent: PopupComponent, onTrigger: onTrigger, initiallyAddSelectedFirst: initiallyAddSelectedFirst = true, showFooter: showFooter = true, popupProps: popupProps })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2GTZ1.PaginatedPickerIntlProvider), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $c2L1U.default), {
            placement: "bottom-start",
            isOpen: isOpen,
            onClose: onClose,
            popupComponent: PopupComponent,
            shouldRenderToParent: true,
            trigger: onTrigger,
            autoFocus: false,
            content: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $eIfQt.DialogInner), {
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iWOJr.default), {
                        field: {
                            isRemovable: false,
                            label: fieldLabel || '',
                            invalidLabel: fieldInvalidLabel,
                            type: 'Filter',
                            key: fieldId,
                            defaultOptionsLabel: 'defaultOptionsLabel',
                            defaultOptions: true,
                            cacheOptions: false,
                            inputValue: 'string',
                            enableShowMore: true,
                            pagination: pagination,
                            loadOptions: onLoadOptions
                        },
                        onChange: onChange,
                        value: value,
                        formatOptionLabel: formatOptionLabel,
                        onClear: onClearValues,
                        initiallyAddSelectedFirst: initiallyAddSelectedFirst,
                        showFooter: showFooter,
                        ariaLabel: ariaLabel
                    })
                }),
            ...popupProps
        }, fieldId)
    });

});
parcelRegister("2GTZ1", function(module, exports) {
$parcel$export(module.exports, "PaginatedPickerIntlProvider", () => $97a430bb53e1a6ee$export$b61655080b0a1f32);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $33yvY = parcelRequire("33yvY");
var $k7INq = parcelRequire("k7INq");

var $aj1Ft = parcelRequire("aj1Ft");
const $97a430bb53e1a6ee$var$i18n = $aj1Ft;
const $97a430bb53e1a6ee$var$getCodesFromLocale = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
const $97a430bb53e1a6ee$export$b61655080b0a1f32 = ({ children: children })=>{
    const intl = (0, $k7INq.default)();
    const { language: language, country: country } = $97a430bb53e1a6ee$var$getCodesFromLocale(intl.locale.toString());
    const messages = $97a430bb53e1a6ee$var$i18n[`${language}_${country}`] || $97a430bb53e1a6ee$var$i18n[language] || $97a430bb53e1a6ee$var$i18n.en;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $33yvY.default), {
        messages: messages,
        locale: intl.locale,
        children: children
    });
};

});
parcelRegister("33yvY", function(module, exports) {
$parcel$export(module.exports, "default", () => $239c6cd38debb1fb$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $26Yns = parcelRequire("26Yns");

var $8yAcb = parcelRequire("8yAcb");

var $8P7DW = parcelRequire("8P7DW");

var $cs9kf = parcelRequire("cs9kf");

var $3SD6z = parcelRequire("3SD6z");

var $gKOzK = parcelRequire("gKOzK");
function $239c6cd38debb1fb$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $239c6cd38debb1fb$var$IntlProvider = /** @class */ function(_super) {
    (0, $26Yns.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $8yAcb.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $gKOzK.createIntl)($239c6cd38debb1fb$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $239c6cd38debb1fb$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $239c6cd38debb1fb$var$processIntlConfig(props);
        if (!(0, $cs9kf.shallowEqual)(prevConfig, config)) return {
            intl: (0, $gKOzK.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $cs9kf.invariantIntlContext)(this.state.intl);
        return $8P7DW.createElement((0, $3SD6z.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $cs9kf.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($8P7DW.PureComponent);
var $239c6cd38debb1fb$export$2e2bcd8739ae039 = $239c6cd38debb1fb$var$IntlProvider;

});
parcelRegister("8yAcb", function(module, exports) {
$parcel$export(module.exports, "filterProps", () => $63ad9362089dced3$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $63ad9362089dced3$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $63ad9362089dced3$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $63ad9362089dced3$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $63ad9362089dced3$export$4ee1db8ce44a209b);

var $26Yns = parcelRequire("26Yns");
parcelRequire("kNyDE");
var $lfVWV = parcelRequire("lfVWV");

var $cJBSa = parcelRequire("cJBSa");

var $c4tEl = parcelRequire("c4tEl");
function $63ad9362089dced3$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $63ad9362089dced3$var$defaultErrorHandler = function(error) {};
var $63ad9362089dced3$var$defaultWarnHandler = function(warning) {};
var $63ad9362089dced3$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $63ad9362089dced3$var$defaultErrorHandler,
    onWarn: $63ad9362089dced3$var$defaultWarnHandler
};
function $63ad9362089dced3$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $63ad9362089dced3$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $63ad9362089dced3$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $63ad9362089dced3$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $cJBSa.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $63ad9362089dced3$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $cJBSa.strategies).variadic
    });
    var getNumberFormat = (0, $cJBSa.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $63ad9362089dced3$var$createFastMemoizeCache(cache.number),
        strategy: (0, $cJBSa.strategies).variadic
    });
    var getPluralRules = (0, $cJBSa.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $26Yns.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $63ad9362089dced3$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $cJBSa.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $cJBSa.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $lfVWV.IntlMessageFormat)(message, locales, overrideFormats, (0, $26Yns.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $63ad9362089dced3$var$createFastMemoizeCache(cache.message),
            strategy: (0, $cJBSa.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $cJBSa.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $63ad9362089dced3$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $cJBSa.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $cJBSa.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $63ad9362089dced3$var$createFastMemoizeCache(cache.list),
            strategy: (0, $cJBSa.strategies).variadic
        }),
        getDisplayNames: (0, $cJBSa.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $63ad9362089dced3$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $cJBSa.strategies).variadic
        })
    };
}
function $63ad9362089dced3$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $c4tEl.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("kNyDE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("3PDgH")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("3PDgH")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("k5JFP")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("lfVWV")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $lfVWV = parcelRequire("lfVWV");
parcelRequire("3PDgH");
parcelRequire("k5JFP");
var $f24340c18a000fe0$export$2e2bcd8739ae039 = (0, $lfVWV.IntlMessageFormat);

});
parcelRegister("lfVWV", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $f797f33c65d8564d$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $26Yns = parcelRequire("26Yns");

var $1f6I3 = parcelRequire("1f6I3");

var $kU1BW = parcelRequire("kU1BW");

var $k5JFP = parcelRequire("k5JFP");
// -- MessageFormat --------------------------------------------------------
function $f797f33c65d8564d$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $f797f33c65d8564d$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $f797f33c65d8564d$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $26Yns.__assign)({}, defaultConfig));
}
function $f797f33c65d8564d$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $f797f33c65d8564d$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $1f6I3.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $f797f33c65d8564d$var$createFastMemoizeCache(cache.number),
            strategy: (0, $1f6I3.strategies).variadic
        }),
        getDateTimeFormat: (0, $1f6I3.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $f797f33c65d8564d$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $1f6I3.strategies).variadic
        }),
        getPluralRules: (0, $1f6I3.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $26Yns.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $f797f33c65d8564d$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $1f6I3.strategies).variadic
        })
    };
}
var $f797f33c65d8564d$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $k5JFP.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $k5JFP.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $26Yns.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $26Yns.__assign)((0, $26Yns.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $f797f33c65d8564d$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $f797f33c65d8564d$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $kU1BW.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("1f6I3", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $0e7c658f0753a793$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $0e7c658f0753a793$export$c5491a8691a23b9e);
//
// Main
//
function $0e7c658f0753a793$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $0e7c658f0753a793$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $0e7c658f0753a793$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $0e7c658f0753a793$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $0e7c658f0753a793$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $0e7c658f0753a793$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $0e7c658f0753a793$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $0e7c658f0753a793$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $0e7c658f0753a793$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $0e7c658f0753a793$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $0e7c658f0753a793$var$monadic : $0e7c658f0753a793$var$variadic;
    return $0e7c658f0753a793$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $0e7c658f0753a793$var$strategyVariadic(fn, options) {
    return $0e7c658f0753a793$var$assemble(fn, this, $0e7c658f0753a793$var$variadic, options.cache.create(), options.serializer);
}
function $0e7c658f0753a793$var$strategyMonadic(fn, options) {
    return $0e7c658f0753a793$var$assemble(fn, this, $0e7c658f0753a793$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $0e7c658f0753a793$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $0e7c658f0753a793$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$0e7c658f0753a793$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$0e7c658f0753a793$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $0e7c658f0753a793$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $0e7c658f0753a793$var$ObjectWithoutPrototypeCache();
    }
};
var $0e7c658f0753a793$export$c5491a8691a23b9e = {
    variadic: $0e7c658f0753a793$var$strategyVariadic,
    monadic: $0e7c658f0753a793$var$strategyMonadic
};

});

parcelRegister("kU1BW", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("7ykAY")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("7ykAY")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("7ykAY")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("7ykAY")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("7ykAY")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("7ykAY")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("7ykAY")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("7ykAY")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("7ykAY")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("7ykAY")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("7ykAY")).isTimeElement);
$parcel$export(module.exports, "parse", () => $f37a498188a3bdef$export$98e6a39c04603d36);

var $26Yns = parcelRequire("26Yns");

var $8TxwY = parcelRequire("8TxwY");

var $imjt0 = parcelRequire("imjt0");

var $7ykAY = parcelRequire("7ykAY");
function $f37a498188a3bdef$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $7ykAY.isSelectElement)(el) || (0, $7ykAY.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $f37a498188a3bdef$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $7ykAY.isNumberElement)(el) && (0, $7ykAY.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $7ykAY.isDateElement)(el) || (0, $7ykAY.isTimeElement)(el)) && (0, $7ykAY.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $7ykAY.isTagElement)(el)) $f37a498188a3bdef$var$pruneLocation(el.children);
    });
}
function $f37a498188a3bdef$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $26Yns.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $imjt0.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $8TxwY.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $f37a498188a3bdef$var$pruneLocation(result.val);
    return result.val;
}
var $f37a498188a3bdef$export$d3c1bfa0f7d806e9 = (0, $imjt0.Parser);

});
parcelRegister("8TxwY", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $679d784eefa29695$export$896afd8541959ee5);
var $679d784eefa29695$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($679d784eefa29695$export$896afd8541959ee5 || ($679d784eefa29695$export$896afd8541959ee5 = {}));

});

parcelRegister("imjt0", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $d5d961c7f784a38b$export$7acfa6ed01010e37);

var $26Yns = parcelRequire("26Yns");

var $8TxwY = parcelRequire("8TxwY");

var $7ykAY = parcelRequire("7ykAY");

var $1byhg = parcelRequire("1byhg");
parcelRequire("k1MU7");
var $1TSY1 = parcelRequire("1TSY1");
var $aK0Pn = parcelRequire("aK0Pn");

var $isMpU = parcelRequire("isMpU");
var $d5d961c7f784a38b$var$_a;
var $d5d961c7f784a38b$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $1byhg.SPACE_SEPARATOR_REGEX).source, "*"));
var $d5d961c7f784a38b$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $1byhg.SPACE_SEPARATOR_REGEX).source, "*$"));
function $d5d961c7f784a38b$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $d5d961c7f784a38b$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $d5d961c7f784a38b$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $d5d961c7f784a38b$var$hasNativeFromEntries = !!Object.fromEntries;
var $d5d961c7f784a38b$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $d5d961c7f784a38b$var$hasTrimStart = !!String.prototype.trimStart;
var $d5d961c7f784a38b$var$hasTrimEnd = !!String.prototype.trimEnd;
var $d5d961c7f784a38b$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $d5d961c7f784a38b$var$isSafeInteger = $d5d961c7f784a38b$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $d5d961c7f784a38b$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $d5d961c7f784a38b$var$re = $d5d961c7f784a38b$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $d5d961c7f784a38b$var$REGEX_SUPPORTS_U_AND_Y = (($d5d961c7f784a38b$var$_a = $d5d961c7f784a38b$var$re.exec('a')) === null || $d5d961c7f784a38b$var$_a === void 0 ? void 0 : $d5d961c7f784a38b$var$_a[0]) === 'a';
} catch (_) {
    $d5d961c7f784a38b$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $d5d961c7f784a38b$var$startsWith = $d5d961c7f784a38b$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $d5d961c7f784a38b$var$fromCodePoint = $d5d961c7f784a38b$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $d5d961c7f784a38b$var$fromEntries = // native
$d5d961c7f784a38b$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $d5d961c7f784a38b$var$codePointAt = $d5d961c7f784a38b$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $d5d961c7f784a38b$var$trimStart = $d5d961c7f784a38b$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($d5d961c7f784a38b$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $d5d961c7f784a38b$var$trimEnd = $d5d961c7f784a38b$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($d5d961c7f784a38b$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $d5d961c7f784a38b$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $d5d961c7f784a38b$var$matchIdentifierAtIndex;
if ($d5d961c7f784a38b$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $d5d961c7f784a38b$var$IDENTIFIER_PREFIX_RE_1 = $d5d961c7f784a38b$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $d5d961c7f784a38b$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $d5d961c7f784a38b$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $d5d961c7f784a38b$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$d5d961c7f784a38b$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $d5d961c7f784a38b$var$codePointAt(s, index);
        if (c === undefined || $d5d961c7f784a38b$var$_isWhiteSpace(c) || $d5d961c7f784a38b$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $d5d961c7f784a38b$var$fromCodePoint.apply(void 0, match);
};
var $d5d961c7f784a38b$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $7ykAY.TYPE).pound,
                    location: $d5d961c7f784a38b$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $8TxwY.ErrorKind).UNMATCHED_CLOSING_TAG, $d5d961c7f784a38b$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $d5d961c7f784a38b$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $7ykAY.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $d5d961c7f784a38b$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$d5d961c7f784a38b$var$_isAlpha(this.char())) return this.error((0, $8TxwY.ErrorKind).INVALID_TAG, $d5d961c7f784a38b$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $8TxwY.ErrorKind).UNMATCHED_CLOSING_TAG, $d5d961c7f784a38b$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $8TxwY.ErrorKind).INVALID_TAG, $d5d961c7f784a38b$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $7ykAY.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $d5d961c7f784a38b$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $8TxwY.ErrorKind).UNCLOSED_TAG, $d5d961c7f784a38b$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $8TxwY.ErrorKind).INVALID_TAG, $d5d961c7f784a38b$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $d5d961c7f784a38b$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $d5d961c7f784a38b$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $7ykAY.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$d5d961c7f784a38b$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $d5d961c7f784a38b$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $d5d961c7f784a38b$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $8TxwY.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $8TxwY.ErrorKind).EMPTY_ARGUMENT, $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $8TxwY.ErrorKind).MALFORMED_ARGUMENT, $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $8TxwY.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $7ykAY.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $8TxwY.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $8TxwY.ErrorKind).MALFORMED_ARGUMENT, $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $d5d961c7f784a38b$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $d5d961c7f784a38b$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $8TxwY.ErrorKind).EXPECT_ARGUMENT_TYPE, $d5d961c7f784a38b$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $d5d961c7f784a38b$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $8TxwY.ErrorKind).EXPECT_ARGUMENT_STYLE, $d5d961c7f784a38b$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $d5d961c7f784a38b$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $d5d961c7f784a38b$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $d5d961c7f784a38b$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $7ykAY.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $8TxwY.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $isMpU.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $7ykAY.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $1TSY1.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $7ykAY.TYPE).date : (0, $7ykAY.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $7ykAY.TYPE).number : argType === 'date' ? (0, $7ykAY.TYPE).date : (0, $7ykAY.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $8TxwY.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $d5d961c7f784a38b$var$createLocation(typeEndPosition_1, (0, $26Yns.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $8TxwY.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $d5d961c7f784a38b$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $8TxwY.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $8TxwY.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $7ykAY.TYPE).select,
                        value: value,
                        options: $d5d961c7f784a38b$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $7ykAY.TYPE).plural,
                        value: value,
                        options: $d5d961c7f784a38b$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $8TxwY.ErrorKind).INVALID_ARGUMENT_TYPE, $d5d961c7f784a38b$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $8TxwY.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $8TxwY.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $d5d961c7f784a38b$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $aK0Pn.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $8TxwY.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $7ykAY.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $aK0Pn.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $8TxwY.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $8TxwY.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $d5d961c7f784a38b$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $8TxwY.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $8TxwY.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $8TxwY.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $8TxwY.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $d5d961c7f784a38b$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $d5d961c7f784a38b$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $8TxwY.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $8TxwY.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $d5d961c7f784a38b$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $8TxwY.ErrorKind).MISSING_OTHER_CLAUSE, $d5d961c7f784a38b$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $d5d961c7f784a38b$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$d5d961c7f784a38b$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $d5d961c7f784a38b$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($d5d961c7f784a38b$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $d5d961c7f784a38b$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $d5d961c7f784a38b$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $d5d961c7f784a38b$var$_isAlphaOrSlash(codepoint) {
    return $d5d961c7f784a38b$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $d5d961c7f784a38b$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $d5d961c7f784a38b$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $d5d961c7f784a38b$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("7ykAY", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $57fbaf2b493716e9$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $57fbaf2b493716e9$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $57fbaf2b493716e9$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $57fbaf2b493716e9$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $57fbaf2b493716e9$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $57fbaf2b493716e9$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $57fbaf2b493716e9$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $57fbaf2b493716e9$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $57fbaf2b493716e9$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $57fbaf2b493716e9$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $57fbaf2b493716e9$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $57fbaf2b493716e9$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $57fbaf2b493716e9$export$7680c41f1a55f4cf);
var $57fbaf2b493716e9$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($57fbaf2b493716e9$export$b87f371cbc396fcf || ($57fbaf2b493716e9$export$b87f371cbc396fcf = {}));
var $57fbaf2b493716e9$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($57fbaf2b493716e9$export$906452485466fa53 || ($57fbaf2b493716e9$export$906452485466fa53 = {}));
function $57fbaf2b493716e9$export$cfa10c5697238752(el) {
    return el.type === $57fbaf2b493716e9$export$b87f371cbc396fcf.literal;
}
function $57fbaf2b493716e9$export$4f55724281bdfaf9(el) {
    return el.type === $57fbaf2b493716e9$export$b87f371cbc396fcf.argument;
}
function $57fbaf2b493716e9$export$e11187b219e191e1(el) {
    return el.type === $57fbaf2b493716e9$export$b87f371cbc396fcf.number;
}
function $57fbaf2b493716e9$export$32d811605da75f40(el) {
    return el.type === $57fbaf2b493716e9$export$b87f371cbc396fcf.date;
}
function $57fbaf2b493716e9$export$34ec46f596b1702f(el) {
    return el.type === $57fbaf2b493716e9$export$b87f371cbc396fcf.time;
}
function $57fbaf2b493716e9$export$dcfe1c11d168b5a1(el) {
    return el.type === $57fbaf2b493716e9$export$b87f371cbc396fcf.select;
}
function $57fbaf2b493716e9$export$6c796d116f0a4fbc(el) {
    return el.type === $57fbaf2b493716e9$export$b87f371cbc396fcf.plural;
}
function $57fbaf2b493716e9$export$c0ece297bdd0c082(el) {
    return el.type === $57fbaf2b493716e9$export$b87f371cbc396fcf.pound;
}
function $57fbaf2b493716e9$export$5c83de34745812b(el) {
    return el.type === $57fbaf2b493716e9$export$b87f371cbc396fcf.tag;
}
function $57fbaf2b493716e9$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $57fbaf2b493716e9$export$906452485466fa53.number);
}
function $57fbaf2b493716e9$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $57fbaf2b493716e9$export$906452485466fa53.dateTime);
}
function $57fbaf2b493716e9$export$f0ac572c1121c662(value) {
    return {
        type: $57fbaf2b493716e9$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $57fbaf2b493716e9$export$425e864b0ba114f1(value, style) {
    return {
        type: $57fbaf2b493716e9$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("1byhg", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $0dd16854b42a7d56$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $0dd16854b42a7d56$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $0dd16854b42a7d56$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("k1MU7", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("1TSY1")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("aK0Pn")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("aK0Pn")).parseNumberSkeletonFromString);
parcelRequire("1TSY1");
parcelRequire("aK0Pn");

});
parcelRegister("1TSY1", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $162590d1425b6cc6$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $162590d1425b6cc6$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $162590d1425b6cc6$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($162590d1425b6cc6$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("aK0Pn", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $7d1ed79cd694902d$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $7d1ed79cd694902d$export$47c6f8480bda3e11);

var $26Yns = parcelRequire("26Yns");

var $eGF5g = parcelRequire("eGF5g");
function $7d1ed79cd694902d$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $eGF5g.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $7d1ed79cd694902d$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $7d1ed79cd694902d$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $7d1ed79cd694902d$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $7d1ed79cd694902d$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $7d1ed79cd694902d$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $7d1ed79cd694902d$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($7d1ed79cd694902d$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $7d1ed79cd694902d$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $7d1ed79cd694902d$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$7d1ed79cd694902d$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $7d1ed79cd694902d$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $7d1ed79cd694902d$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $7d1ed79cd694902d$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $7d1ed79cd694902d$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, all), $7d1ed79cd694902d$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, all), $7d1ed79cd694902d$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($7d1ed79cd694902d$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($7d1ed79cd694902d$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($7d1ed79cd694902d$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($7d1ed79cd694902d$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), $7d1ed79cd694902d$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($7d1ed79cd694902d$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), $7d1ed79cd694902d$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $7d1ed79cd694902d$var$parseSign(token.stem);
        if (signOpts) result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $7d1ed79cd694902d$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("eGF5g", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $ab14db514e6e7c62$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $ab14db514e6e7c62$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("isMpU", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $d710661aa769c53a$export$29c5368be8904d27);

var $b6FZn = parcelRequire("b6FZn");
function $d710661aa769c53a$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $d710661aa769c53a$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $d710661aa769c53a$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $b6FZn.timeData)[regionTag || ''] || (0, $b6FZn.timeData)[languageTag || ''] || (0, $b6FZn.timeData)["".concat(languageTag, "-001")] || (0, $b6FZn.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("b6FZn", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $8160d35ae4e2be18$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $8160d35ae4e2be18$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("k5JFP", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $ea07b41dd595f585$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $ea07b41dd595f585$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $ea07b41dd595f585$export$275d4a3bb5f66fda);
parcelRequire("kU1BW");
var $7ykAY = parcelRequire("7ykAY");

var $3PDgH = parcelRequire("3PDgH");
var $ea07b41dd595f585$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($ea07b41dd595f585$export$49694c2877b44c57 || ($ea07b41dd595f585$export$49694c2877b44c57 = {}));
function $ea07b41dd595f585$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $ea07b41dd595f585$export$49694c2877b44c57.literal || part.type !== $ea07b41dd595f585$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $ea07b41dd595f585$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $ea07b41dd595f585$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $7ykAY.isLiteralElement)(els[0])) return [
        {
            type: $ea07b41dd595f585$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $7ykAY.isLiteralElement)(el)) {
            result.push({
                type: $ea07b41dd595f585$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $7ykAY.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $ea07b41dd595f585$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $3PDgH.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $7ykAY.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $ea07b41dd595f585$export$49694c2877b44c57.literal : $ea07b41dd595f585$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $7ykAY.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $7ykAY.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $ea07b41dd595f585$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7ykAY.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $7ykAY.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $ea07b41dd595f585$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7ykAY.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $7ykAY.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $ea07b41dd595f585$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7ykAY.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$ea07b41dd595f585$export$df0c12a2d414a163(formatFn)) throw new (0, $3PDgH.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $ea07b41dd595f585$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $ea07b41dd595f585$export$49694c2877b44c57.literal : $ea07b41dd595f585$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $7ykAY.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $3PDgH.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ea07b41dd595f585$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $7ykAY.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $3PDgH.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $3PDgH.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $3PDgH.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ea07b41dd595f585$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $ea07b41dd595f585$var$mergeLiteral(result);
}

});
parcelRegister("3PDgH", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $2ca498640d09cb74$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $2ca498640d09cb74$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $2ca498640d09cb74$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $2ca498640d09cb74$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $2ca498640d09cb74$export$8bfc137e4d23fdf0);

var $26Yns = parcelRequire("26Yns");
var $2ca498640d09cb74$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($2ca498640d09cb74$export$d4e71bc0b80dc0fb || ($2ca498640d09cb74$export$d4e71bc0b80dc0fb = {}));
var $2ca498640d09cb74$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $2ca498640d09cb74$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $2ca498640d09cb74$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($2ca498640d09cb74$export$7369836851cc1329);
var $2ca498640d09cb74$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $2ca498640d09cb74$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($2ca498640d09cb74$export$7369836851cc1329);
var $2ca498640d09cb74$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $2ca498640d09cb74$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($2ca498640d09cb74$export$7369836851cc1329);

});




parcelRegister("cJBSa", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $945710b6c99e4cfa$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $945710b6c99e4cfa$export$c5491a8691a23b9e);
//
// Main
//
function $945710b6c99e4cfa$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $945710b6c99e4cfa$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $945710b6c99e4cfa$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $945710b6c99e4cfa$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $945710b6c99e4cfa$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $945710b6c99e4cfa$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $945710b6c99e4cfa$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $945710b6c99e4cfa$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $945710b6c99e4cfa$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $945710b6c99e4cfa$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $945710b6c99e4cfa$var$monadic : $945710b6c99e4cfa$var$variadic;
    return $945710b6c99e4cfa$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $945710b6c99e4cfa$var$strategyVariadic(fn, options) {
    return $945710b6c99e4cfa$var$assemble(fn, this, $945710b6c99e4cfa$var$variadic, options.cache.create(), options.serializer);
}
function $945710b6c99e4cfa$var$strategyMonadic(fn, options) {
    return $945710b6c99e4cfa$var$assemble(fn, this, $945710b6c99e4cfa$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $945710b6c99e4cfa$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $945710b6c99e4cfa$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$945710b6c99e4cfa$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$945710b6c99e4cfa$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $945710b6c99e4cfa$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $945710b6c99e4cfa$var$ObjectWithoutPrototypeCache();
    }
};
var $945710b6c99e4cfa$export$c5491a8691a23b9e = {
    variadic: $945710b6c99e4cfa$var$strategyVariadic,
    monadic: $945710b6c99e4cfa$var$strategyMonadic
};

});

parcelRegister("c4tEl", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $8c9cdb9418954b32$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $8c9cdb9418954b32$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $8c9cdb9418954b32$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $8c9cdb9418954b32$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $8c9cdb9418954b32$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $8c9cdb9418954b32$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $8c9cdb9418954b32$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $8c9cdb9418954b32$export$2ddcb436d0aa3688);

var $26Yns = parcelRequire("26Yns");
var $8c9cdb9418954b32$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($8c9cdb9418954b32$export$557d6acb76e8a244 || ($8c9cdb9418954b32$export$557d6acb76e8a244 = {}));
var $8c9cdb9418954b32$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $8c9cdb9418954b32$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $8c9cdb9418954b32$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($8c9cdb9418954b32$export$c016d36112f6ddf8);
var $8c9cdb9418954b32$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $8c9cdb9418954b32$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($8c9cdb9418954b32$export$c016d36112f6ddf8);
var $8c9cdb9418954b32$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $8c9cdb9418954b32$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($8c9cdb9418954b32$export$c016d36112f6ddf8);
var $8c9cdb9418954b32$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $8c9cdb9418954b32$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($8c9cdb9418954b32$export$c016d36112f6ddf8);
var $8c9cdb9418954b32$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($8c9cdb9418954b32$export$e3b7eee1dbc44895);
var $8c9cdb9418954b32$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $26Yns.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $8c9cdb9418954b32$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($8c9cdb9418954b32$export$c016d36112f6ddf8);

});


parcelRegister("cs9kf", function(module, exports) {
$parcel$export(module.exports, "invariantIntlContext", () => $910f556c14510fca$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $910f556c14510fca$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $910f556c14510fca$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $910f556c14510fca$export$d36bdfa510afb180);

var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $8XGMf = parcelRequire("8XGMf");

var $8yAcb = parcelRequire("8yAcb");
function $910f556c14510fca$export$45c4bbf6e55bba1f(intl) {
    (0, $8XGMf.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $910f556c14510fca$export$b52f8d6fc0d47415 = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, (0, $8yAcb.DEFAULT_INTL_CONFIG)), {
    textComponent: $8P7DW.Fragment
});
function $910f556c14510fca$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($8P7DW.Children.toArray(parts));
    };
}
function $910f556c14510fca$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("8XGMf", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $01af0c73d62c3f61$export$f5708dca728d7177);

var $26Yns = parcelRequire("26Yns");

var $8uoWc = parcelRequire("8uoWc");
function $01af0c73d62c3f61$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $01af0c73d62c3f61$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $01af0c73d62c3f61$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $01af0c73d62c3f61$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $01af0c73d62c3f61$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $01af0c73d62c3f61$export$3fae2929ed23c202(map, pl, field) {
    return $01af0c73d62c3f61$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $01af0c73d62c3f61$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $01af0c73d62c3f61$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $01af0c73d62c3f61$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $01af0c73d62c3f61$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $01af0c73d62c3f61$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $01af0c73d62c3f61$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $01af0c73d62c3f61$export$a99e4aaac79eeead = (0, $8uoWc.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $8uoWc.strategies).variadic
});
var $01af0c73d62c3f61$export$b479a1a2d8754359 = (0, $8uoWc.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $8uoWc.strategies).variadic
});
var $01af0c73d62c3f61$export$569bb3095db8432e = (0, $8uoWc.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $26Yns.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $8uoWc.strategies).variadic
});
var $01af0c73d62c3f61$export$e124bc7d23dd0e5a = (0, $8uoWc.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $26Yns.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $8uoWc.strategies).variadic
});
var $01af0c73d62c3f61$export$a1209f8c6068edc3 = (0, $8uoWc.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $26Yns.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $8uoWc.strategies).variadic
});

});
parcelRegister("8uoWc", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $62e4782aef496c37$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $62e4782aef496c37$export$c5491a8691a23b9e);
//
// Main
//
function $62e4782aef496c37$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $62e4782aef496c37$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $62e4782aef496c37$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $62e4782aef496c37$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $62e4782aef496c37$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $62e4782aef496c37$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $62e4782aef496c37$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $62e4782aef496c37$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $62e4782aef496c37$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $62e4782aef496c37$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $62e4782aef496c37$var$monadic : $62e4782aef496c37$var$variadic;
    return $62e4782aef496c37$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $62e4782aef496c37$var$strategyVariadic(fn, options) {
    return $62e4782aef496c37$var$assemble(fn, this, $62e4782aef496c37$var$variadic, options.cache.create(), options.serializer);
}
function $62e4782aef496c37$var$strategyMonadic(fn, options) {
    return $62e4782aef496c37$var$assemble(fn, this, $62e4782aef496c37$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $62e4782aef496c37$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $62e4782aef496c37$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$62e4782aef496c37$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$62e4782aef496c37$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $62e4782aef496c37$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $62e4782aef496c37$var$ObjectWithoutPrototypeCache();
    }
};
var $62e4782aef496c37$export$c5491a8691a23b9e = {
    variadic: $62e4782aef496c37$var$strategyVariadic,
    monadic: $62e4782aef496c37$var$strategyMonadic
};

});



parcelRegister("3SD6z", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $2d34bfb3894b3be0$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $2d34bfb3894b3be0$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $2d34bfb3894b3be0$export$2e2bcd8739ae039);

var $26Yns = parcelRequire("26Yns");

var $fG5y9 = parcelRequire("fG5y9");

var $8P7DW = parcelRequire("8P7DW");

var $cs9kf = parcelRequire("cs9kf");
function $2d34bfb3894b3be0$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $2d34bfb3894b3be0$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $8P7DW.createContext(null)) : $8P7DW.createContext(null);
var $2d34bfb3894b3be0$var$IntlConsumer = $2d34bfb3894b3be0$var$IntlContext.Consumer, $2d34bfb3894b3be0$var$IntlProvider = $2d34bfb3894b3be0$var$IntlContext.Provider;
var $2d34bfb3894b3be0$export$2881499e37b75b9a = $2d34bfb3894b3be0$var$IntlProvider;
var $2d34bfb3894b3be0$export$841858b892ce1f4c = $2d34bfb3894b3be0$var$IntlContext;
function $2d34bfb3894b3be0$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $8P7DW.createElement($2d34bfb3894b3be0$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $cs9kf.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $8P7DW.createElement(WrappedComponent, (0, $26Yns.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($2d34bfb3894b3be0$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($fG5y9)))(// @ts-expect-error
    $8P7DW.forwardRef(function(props, ref) {
        return $8P7DW.createElement(WithIntl, (0, $26Yns.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fG5y9)))(WithIntl, WrappedComponent);
}

});

parcelRegister("gKOzK", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $c3282c7e1ae86c14$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $26Yns = parcelRequire("26Yns");

var $3KyTC = parcelRequire("3KyTC");
var $fs8pg = parcelRequire("fs8pg");

var $8P7DW = parcelRequire("8P7DW");

var $cs9kf = parcelRequire("cs9kf");

var $k5JFP = parcelRequire("k5JFP");
function $c3282c7e1ae86c14$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $k5JFP.isFormatXMLElementFn)(v) ? (0, $cs9kf.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $c3282c7e1ae86c14$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $c3282c7e1ae86c14$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $fs8pg.formatMessage).apply(void 0, (0, $26Yns.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $8P7DW.Children.toArray(chunks);
    return chunks;
};
var $c3282c7e1ae86c14$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $26Yns.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $c3282c7e1ae86c14$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $3KyTC.createIntl)((0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, (0, $cs9kf.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, coreIntl), {
        formatMessage: $c3282c7e1ae86c14$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $c3282c7e1ae86c14$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("3KyTC", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $2bb0bc9a3e514623$export$7e4cbedfdd7b4c0d);

var $26Yns = parcelRequire("26Yns");

var $8yAcb = parcelRequire("8yAcb");

var $c4tEl = parcelRequire("c4tEl");

var $dEGhO = parcelRequire("dEGhO");

var $hpAY9 = parcelRequire("hpAY9");

var $afbFY = parcelRequire("afbFY");

var $7dx7P = parcelRequire("7dx7P");

var $fs8pg = parcelRequire("fs8pg");

var $bvKEx = parcelRequire("bvKEx");

var $jPgj6 = parcelRequire("jPgj6");
function $2bb0bc9a3e514623$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $2bb0bc9a3e514623$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $2bb0bc9a3e514623$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $2bb0bc9a3e514623$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $8yAcb.createFormatters)(cache);
    var resolvedConfig = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, (0, $8yAcb.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $c4tEl.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $c4tEl.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $c4tEl.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $2bb0bc9a3e514623$var$verifyConfigMessages(resolvedConfig);
    return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $dEGhO.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $dEGhO.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $hpAY9.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $afbFY.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $afbFY.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $afbFY.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $afbFY.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $afbFY.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $7dx7P.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $fs8pg.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $fs8pg.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $bvKEx.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $bvKEx.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $jPgj6.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("dEGhO", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $9f0fcff3aa7e494c$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $9f0fcff3aa7e494c$export$6871080848f10b2f);

var $c4tEl = parcelRequire("c4tEl");

var $8yAcb = parcelRequire("8yAcb");
var $9f0fcff3aa7e494c$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $9f0fcff3aa7e494c$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $8yAcb.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $8yAcb.filterProps)(options, $9f0fcff3aa7e494c$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $9f0fcff3aa7e494c$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $9f0fcff3aa7e494c$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $c4tEl.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $9f0fcff3aa7e494c$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $9f0fcff3aa7e494c$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $c4tEl.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("hpAY9", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $cad172c5cfd78ad7$export$b4ea3b48dcf921f6);

var $8yAcb = parcelRequire("8yAcb");

var $3PDgH = parcelRequire("3PDgH");

var $c4tEl = parcelRequire("c4tEl");
var $cad172c5cfd78ad7$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $cad172c5cfd78ad7$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $8yAcb.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $8yAcb.filterProps)(options, $cad172c5cfd78ad7$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $cad172c5cfd78ad7$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $3PDgH.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $3PDgH.ErrorCode).MISSING_INTL_API));
    try {
        return $cad172c5cfd78ad7$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $c4tEl.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("afbFY", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $77545cb8c2790a4c$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $77545cb8c2790a4c$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $77545cb8c2790a4c$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $77545cb8c2790a4c$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $77545cb8c2790a4c$export$af6e5d7a5c73edeb);

var $26Yns = parcelRequire("26Yns");

var $8yAcb = parcelRequire("8yAcb");

var $c4tEl = parcelRequire("c4tEl");
var $77545cb8c2790a4c$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $77545cb8c2790a4c$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $8yAcb.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $8yAcb.filterProps)(options, $77545cb8c2790a4c$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $77545cb8c2790a4c$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $77545cb8c2790a4c$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $c4tEl.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $77545cb8c2790a4c$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $77545cb8c2790a4c$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $c4tEl.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $77545cb8c2790a4c$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $8yAcb.filterProps)(options, $77545cb8c2790a4c$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $c4tEl.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $77545cb8c2790a4c$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $77545cb8c2790a4c$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $c4tEl.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $77545cb8c2790a4c$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $77545cb8c2790a4c$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $c4tEl.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("7dx7P", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $5413714c73dfbbc7$export$bbbd05c900f3568d);

var $8yAcb = parcelRequire("8yAcb");

var $c4tEl = parcelRequire("c4tEl");

var $3PDgH = parcelRequire("3PDgH");
var $5413714c73dfbbc7$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $5413714c73dfbbc7$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $3PDgH.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $3PDgH.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8yAcb.filterProps)(options, $5413714c73dfbbc7$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $c4tEl.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("fs8pg", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $b3fffde2dff1ef96$export$25868d1e8e76735f);

var $26Yns = parcelRequire("26Yns");

var $8XGMf = parcelRequire("8XGMf");
parcelRequire("kNyDE");
var $lfVWV = parcelRequire("lfVWV");

var $c4tEl = parcelRequire("c4tEl");
parcelRequire("7Hpkh");
var $6APy4 = parcelRequire("6APy4");
function $b3fffde2dff1ef96$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $26Yns.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $b3fffde2dff1ef96$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $26Yns.__assign)((0, $26Yns.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $b3fffde2dff1ef96$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $lfVWV.IntlMessageFormat).formats;
    return (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, mfFormats), f1), {
        date: $b3fffde2dff1ef96$var$deepMergeOptions($b3fffde2dff1ef96$var$setTimeZoneInOptions(mfFormats.date, timeZone), $b3fffde2dff1ef96$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $b3fffde2dff1ef96$var$deepMergeOptions($b3fffde2dff1ef96$var$setTimeZoneInOptions(mfFormats.time, timeZone), $b3fffde2dff1ef96$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $b3fffde2dff1ef96$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $8XGMf.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $6APy4.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, defaultRichTextElements), values || {});
    formats = $b3fffde2dff1ef96$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $b3fffde2dff1ef96$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $c4tEl.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $c4tEl.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $26Yns.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $c4tEl.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $c4tEl.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});
parcelRegister("7Hpkh", function(module, exports) {
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("6APy4")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("6APy4")).isDateTimeSkeleton);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("6APy4")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("6APy4")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("6APy4")).isPluralElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("6APy4")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("6APy4")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("6APy4")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("6APy4")).TYPE);

var $26Yns = parcelRequire("26Yns");

var $6FDy9 = parcelRequire("6FDy9");

var $4Hox9 = parcelRequire("4Hox9");

var $6APy4 = parcelRequire("6APy4");
function $59b031cd42bc1eb4$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $6APy4.isSelectElement)(el) || (0, $6APy4.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $59b031cd42bc1eb4$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $6APy4.isNumberElement)(el) && (0, $6APy4.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $6APy4.isDateElement)(el) || (0, $6APy4.isTimeElement)(el)) && (0, $6APy4.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $6APy4.isTagElement)(el)) $59b031cd42bc1eb4$var$pruneLocation(el.children);
    });
}
function $59b031cd42bc1eb4$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $26Yns.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $4Hox9.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $6FDy9.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $59b031cd42bc1eb4$var$pruneLocation(result.val);
    return result.val;
}
var $59b031cd42bc1eb4$export$d3c1bfa0f7d806e9 = (0, $4Hox9.Parser);

});
parcelRegister("6FDy9", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $0140dbdfb15a8f5d$export$896afd8541959ee5);
var $0140dbdfb15a8f5d$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($0140dbdfb15a8f5d$export$896afd8541959ee5 || ($0140dbdfb15a8f5d$export$896afd8541959ee5 = {}));

});

parcelRegister("4Hox9", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $36be35727301b1fe$export$7acfa6ed01010e37);

var $26Yns = parcelRequire("26Yns");

var $6FDy9 = parcelRequire("6FDy9");

var $6APy4 = parcelRequire("6APy4");

var $hfUG0 = parcelRequire("hfUG0");
parcelRequire("k1MU7");
var $1TSY1 = parcelRequire("1TSY1");
var $aK0Pn = parcelRequire("aK0Pn");

var $fst5E = parcelRequire("fst5E");
var $36be35727301b1fe$var$_a;
var $36be35727301b1fe$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $hfUG0.SPACE_SEPARATOR_REGEX).source, "*"));
var $36be35727301b1fe$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $hfUG0.SPACE_SEPARATOR_REGEX).source, "*$"));
function $36be35727301b1fe$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $36be35727301b1fe$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $36be35727301b1fe$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $36be35727301b1fe$var$hasNativeFromEntries = !!Object.fromEntries;
var $36be35727301b1fe$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $36be35727301b1fe$var$hasTrimStart = !!String.prototype.trimStart;
var $36be35727301b1fe$var$hasTrimEnd = !!String.prototype.trimEnd;
var $36be35727301b1fe$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $36be35727301b1fe$var$isSafeInteger = $36be35727301b1fe$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $36be35727301b1fe$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $36be35727301b1fe$var$re = $36be35727301b1fe$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $36be35727301b1fe$var$REGEX_SUPPORTS_U_AND_Y = (($36be35727301b1fe$var$_a = $36be35727301b1fe$var$re.exec('a')) === null || $36be35727301b1fe$var$_a === void 0 ? void 0 : $36be35727301b1fe$var$_a[0]) === 'a';
} catch (_) {
    $36be35727301b1fe$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $36be35727301b1fe$var$startsWith = $36be35727301b1fe$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $36be35727301b1fe$var$fromCodePoint = $36be35727301b1fe$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $36be35727301b1fe$var$fromEntries = // native
$36be35727301b1fe$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $36be35727301b1fe$var$codePointAt = $36be35727301b1fe$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $36be35727301b1fe$var$trimStart = $36be35727301b1fe$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($36be35727301b1fe$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $36be35727301b1fe$var$trimEnd = $36be35727301b1fe$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($36be35727301b1fe$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $36be35727301b1fe$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $36be35727301b1fe$var$matchIdentifierAtIndex;
if ($36be35727301b1fe$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $36be35727301b1fe$var$IDENTIFIER_PREFIX_RE_1 = $36be35727301b1fe$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $36be35727301b1fe$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $36be35727301b1fe$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $36be35727301b1fe$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$36be35727301b1fe$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $36be35727301b1fe$var$codePointAt(s, index);
        if (c === undefined || $36be35727301b1fe$var$_isWhiteSpace(c) || $36be35727301b1fe$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $36be35727301b1fe$var$fromCodePoint.apply(void 0, match);
};
var $36be35727301b1fe$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $6APy4.TYPE).pound,
                    location: $36be35727301b1fe$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $6FDy9.ErrorKind).UNMATCHED_CLOSING_TAG, $36be35727301b1fe$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $36be35727301b1fe$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $6APy4.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $36be35727301b1fe$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$36be35727301b1fe$var$_isAlpha(this.char())) return this.error((0, $6FDy9.ErrorKind).INVALID_TAG, $36be35727301b1fe$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $6FDy9.ErrorKind).UNMATCHED_CLOSING_TAG, $36be35727301b1fe$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $6FDy9.ErrorKind).INVALID_TAG, $36be35727301b1fe$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $6APy4.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $36be35727301b1fe$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $6FDy9.ErrorKind).UNCLOSED_TAG, $36be35727301b1fe$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $6FDy9.ErrorKind).INVALID_TAG, $36be35727301b1fe$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $36be35727301b1fe$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $36be35727301b1fe$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $6APy4.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$36be35727301b1fe$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $36be35727301b1fe$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $36be35727301b1fe$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $6FDy9.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $6FDy9.ErrorKind).EMPTY_ARGUMENT, $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $6FDy9.ErrorKind).MALFORMED_ARGUMENT, $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $6FDy9.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $6APy4.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $6FDy9.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $6FDy9.ErrorKind).MALFORMED_ARGUMENT, $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $36be35727301b1fe$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $36be35727301b1fe$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $6FDy9.ErrorKind).EXPECT_ARGUMENT_TYPE, $36be35727301b1fe$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $36be35727301b1fe$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $6FDy9.ErrorKind).EXPECT_ARGUMENT_STYLE, $36be35727301b1fe$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $36be35727301b1fe$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $36be35727301b1fe$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $36be35727301b1fe$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $6APy4.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $6FDy9.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $fst5E.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $6APy4.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $1TSY1.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $6APy4.TYPE).date : (0, $6APy4.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $6APy4.TYPE).number : argType === 'date' ? (0, $6APy4.TYPE).date : (0, $6APy4.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $6FDy9.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $36be35727301b1fe$var$createLocation(typeEndPosition_1, (0, $26Yns.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $6FDy9.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $36be35727301b1fe$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $6FDy9.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $6FDy9.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $6APy4.TYPE).select,
                        value: value,
                        options: $36be35727301b1fe$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $6APy4.TYPE).plural,
                        value: value,
                        options: $36be35727301b1fe$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $6FDy9.ErrorKind).INVALID_ARGUMENT_TYPE, $36be35727301b1fe$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $6FDy9.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $6FDy9.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $36be35727301b1fe$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $aK0Pn.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $6FDy9.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $6APy4.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $aK0Pn.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $6FDy9.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $6FDy9.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $36be35727301b1fe$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $6FDy9.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $6FDy9.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $6FDy9.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $6FDy9.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $36be35727301b1fe$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $36be35727301b1fe$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $6FDy9.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $6FDy9.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $36be35727301b1fe$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $6FDy9.ErrorKind).MISSING_OTHER_CLAUSE, $36be35727301b1fe$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $36be35727301b1fe$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$36be35727301b1fe$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $36be35727301b1fe$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($36be35727301b1fe$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $36be35727301b1fe$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $36be35727301b1fe$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $36be35727301b1fe$var$_isAlphaOrSlash(codepoint) {
    return $36be35727301b1fe$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $36be35727301b1fe$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $36be35727301b1fe$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $36be35727301b1fe$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("6APy4", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $4cce17519780826b$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $4cce17519780826b$export$906452485466fa53);
$parcel$export(module.exports, "isNumberElement", () => $4cce17519780826b$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $4cce17519780826b$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $4cce17519780826b$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $4cce17519780826b$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $4cce17519780826b$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isTagElement", () => $4cce17519780826b$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $4cce17519780826b$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $4cce17519780826b$export$7680c41f1a55f4cf);
var $4cce17519780826b$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($4cce17519780826b$export$b87f371cbc396fcf || ($4cce17519780826b$export$b87f371cbc396fcf = {}));
var $4cce17519780826b$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($4cce17519780826b$export$906452485466fa53 || ($4cce17519780826b$export$906452485466fa53 = {}));
function $4cce17519780826b$export$cfa10c5697238752(el) {
    return el.type === $4cce17519780826b$export$b87f371cbc396fcf.literal;
}
function $4cce17519780826b$export$4f55724281bdfaf9(el) {
    return el.type === $4cce17519780826b$export$b87f371cbc396fcf.argument;
}
function $4cce17519780826b$export$e11187b219e191e1(el) {
    return el.type === $4cce17519780826b$export$b87f371cbc396fcf.number;
}
function $4cce17519780826b$export$32d811605da75f40(el) {
    return el.type === $4cce17519780826b$export$b87f371cbc396fcf.date;
}
function $4cce17519780826b$export$34ec46f596b1702f(el) {
    return el.type === $4cce17519780826b$export$b87f371cbc396fcf.time;
}
function $4cce17519780826b$export$dcfe1c11d168b5a1(el) {
    return el.type === $4cce17519780826b$export$b87f371cbc396fcf.select;
}
function $4cce17519780826b$export$6c796d116f0a4fbc(el) {
    return el.type === $4cce17519780826b$export$b87f371cbc396fcf.plural;
}
function $4cce17519780826b$export$c0ece297bdd0c082(el) {
    return el.type === $4cce17519780826b$export$b87f371cbc396fcf.pound;
}
function $4cce17519780826b$export$5c83de34745812b(el) {
    return el.type === $4cce17519780826b$export$b87f371cbc396fcf.tag;
}
function $4cce17519780826b$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $4cce17519780826b$export$906452485466fa53.number);
}
function $4cce17519780826b$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $4cce17519780826b$export$906452485466fa53.dateTime);
}
function $4cce17519780826b$export$f0ac572c1121c662(value) {
    return {
        type: $4cce17519780826b$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $4cce17519780826b$export$425e864b0ba114f1(value, style) {
    return {
        type: $4cce17519780826b$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("hfUG0", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $c8ffcd2f02b93074$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $c8ffcd2f02b93074$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $c8ffcd2f02b93074$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("fst5E", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $b4100936bfa8f2b2$export$29c5368be8904d27);

var $3bn27 = parcelRequire("3bn27");
function $b4100936bfa8f2b2$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $b4100936bfa8f2b2$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $b4100936bfa8f2b2$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $3bn27.timeData)[regionTag || ''] || (0, $3bn27.timeData)[languageTag || ''] || (0, $3bn27.timeData)["".concat(languageTag, "-001")] || (0, $3bn27.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("3bn27", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $25144418295eb7f5$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $25144418295eb7f5$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});





parcelRegister("bvKEx", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $8616c73790f58850$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $8616c73790f58850$export$6f284aad1934db69);

var $26Yns = parcelRequire("26Yns");

var $8yAcb = parcelRequire("8yAcb");

var $3PDgH = parcelRequire("3PDgH");

var $c4tEl = parcelRequire("c4tEl");
var $8616c73790f58850$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $8616c73790f58850$var$now = Date.now();
function $8616c73790f58850$var$generateToken(i) {
    return "".concat($8616c73790f58850$var$now, "_").concat(i, "_").concat($8616c73790f58850$var$now);
}
function $8616c73790f58850$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $8616c73790f58850$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $8616c73790f58850$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $3PDgH.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $3PDgH.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8yAcb.filterProps)(options, $8616c73790f58850$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $8616c73790f58850$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $26Yns.__assign)((0, $26Yns.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $c4tEl.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("jPgj6", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $e6ef6df9c5446adb$export$62fe1a4d9e891fa2);

var $8yAcb = parcelRequire("8yAcb");

var $3PDgH = parcelRequire("3PDgH");

var $c4tEl = parcelRequire("c4tEl");
var $e6ef6df9c5446adb$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $e6ef6df9c5446adb$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $3PDgH.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $3PDgH.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8yAcb.filterProps)(options, $e6ef6df9c5446adb$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $c4tEl.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});




parcelRegister("k7INq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea6735aea19870ee$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $cs9kf = parcelRequire("cs9kf");

var $3SD6z = parcelRequire("3SD6z");
function $ea6735aea19870ee$export$2e2bcd8739ae039() {
    var intl = $8P7DW.useContext((0, $3SD6z.Context));
    (0, $cs9kf.invariantIntlContext)(intl);
    return intl;
}

});

parcelRegister("aj1Ft", function(module, exports) {
$parcel$export(module.exports, "cs", () => (parcelRequire("1YdUu")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("7Ujvp")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("atnnV")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("l4TLN")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("b45z8")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("iMNly")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("c44X3")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("3pMiw")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("jPbTx")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("iZH5A")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("fwNik")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("44aM1")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("4iZ8b")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("3vdpE")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("2Zz4S")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("j7ZZo")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("fyC1s")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("hb7GE")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("ffAcI")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("gRcow")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("3VMfr")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("gay8O")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("Suwbb")).default);
$parcel$export(module.exports, "zh", () => (parcelRequire("f1h0p")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("5mgpU")).default);

var $1YdUu = parcelRequire("1YdUu");

var $7Ujvp = parcelRequire("7Ujvp");

var $atnnV = parcelRequire("atnnV");

var $l4TLN = parcelRequire("l4TLN");

var $b45z8 = parcelRequire("b45z8");

var $iMNly = parcelRequire("iMNly");

var $c44X3 = parcelRequire("c44X3");

var $3pMiw = parcelRequire("3pMiw");

var $jPbTx = parcelRequire("jPbTx");

var $iZH5A = parcelRequire("iZH5A");

var $fwNik = parcelRequire("fwNik");

var $44aM1 = parcelRequire("44aM1");

var $4iZ8b = parcelRequire("4iZ8b");

var $3vdpE = parcelRequire("3vdpE");

var $2Zz4S = parcelRequire("2Zz4S");

var $j7ZZo = parcelRequire("j7ZZo");

var $fyC1s = parcelRequire("fyC1s");

var $hb7GE = parcelRequire("hb7GE");

var $ffAcI = parcelRequire("ffAcI");

var $gRcow = parcelRequire("gRcow");

var $3VMfr = parcelRequire("3VMfr");

var $gay8O = parcelRequire("gay8O");

var $Suwbb = parcelRequire("Suwbb");

var $f1h0p = parcelRequire("f1h0p");

var $5mgpU = parcelRequire("5mgpU");

});
parcelRegister("1YdUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $df5e9ace4db24ea1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $daVCe = parcelRequire("daVCe");
var $df5e9ace4db24ea1$export$2e2bcd8739ae039 = (0, $daVCe.default);

});
parcelRegister("daVCe", function(module, exports) {
$parcel$export(module.exports, "default", () => $7916415f017235c2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $7916415f017235c2$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Zru\u0161it v\xfdb\u011Br",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Na\u010D\xedt\xe1n\xed\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Zobrazit v\xedce",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} z\xa0{totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nebyly nalezeny \u017E\xe1dn\xe9 shody",
    'paginated-picker.async-select.select.option.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.select.option.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.select.search-placeholder': 'Vyhledat',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Zobrazit \xfapln\xfd seznam"
};

});


parcelRegister("7Ujvp", function(module, exports) {
$parcel$export(module.exports, "default", () => $21925c0594b66cc7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $cproA = parcelRequire("cproA");
var $21925c0594b66cc7$export$2e2bcd8739ae039 = (0, $cproA.default);

});
parcelRegister("cproA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fae89307393b6bd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $3fae89307393b6bd$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Ryd valgte',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Indl\xe6ser ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mere',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} af {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ingen match fundet',
    'paginated-picker.async-select.select.option.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.select.option.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8g",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis hele listen'
};

});


parcelRegister("atnnV", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cbc367909dfbd4d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $cOZye = parcelRequire("cOZye");
var $2cbc367909dfbd4d$export$2e2bcd8739ae039 = (0, $cOZye.default);

});
parcelRegister("cOZye", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bdbac891e8c14ac$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $4bdbac891e8c14ac$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Auswahl l\xf6schen",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4dt\xa0...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mehr anzeigen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} von {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Keine Treffer gefunden',
    'paginated-picker.async-select.select.option.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.select.option.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.select.search-placeholder': 'Suchen',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Vollst\xe4ndige Liste anzeigen"
};

});


parcelRegister("l4TLN", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4dfe034acc764d8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $kMvrj = parcelRequire("kMvrj");
var $b4dfe034acc764d8$export$2e2bcd8739ae039 = (0, $kMvrj.default);

});
parcelRegister("kMvrj", function(module, exports) {
$parcel$export(module.exports, "default", () => $d279712358d58852$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $d279712358d58852$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};

});


parcelRegister("b45z8", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7cd5d7bfceeaaca$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $jGfHm = parcelRequire("jGfHm");
var $a7cd5d7bfceeaaca$export$2e2bcd8739ae039 = (0, $jGfHm.default);

});
parcelRegister("jGfHm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9515cb0522180b91$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $9515cb0522180b91$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};

});


parcelRegister("iMNly", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd28db3bbf1ca3ee$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iDnOh = parcelRequire("iDnOh");
var $bd28db3bbf1ca3ee$export$2e2bcd8739ae039 = (0, $iDnOh.default);

});
parcelRegister("iDnOh", function(module, exports) {
$parcel$export(module.exports, "default", () => $155f68bceaac7313$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $155f68bceaac7313$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u2063\u2062Clear selection\u206E\x9d\u206B\u2060\u206D\x8f\u206B\u200C\u200D\u206C\x9d\u206E\u200C\u206B\u206D\u200C\u206C\u206F\u206F\u206B\u206E\x81\u2060\u206F\u206A\u200D\x8d\u206D\u200C\x8d\u2060\u061C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u2063\u2062Couldn't retrieve data\x81\u206A\u206D\u2060\u2061\u206F\x8d\u206E\u2060\x8d\u2060\u206C\u206E\u2061\u206E\x90\u206E\u200C\u200D\x81\u200D\u206F\u206C\u206D\x8d\u206B\x81\u206A\x8d\u200D\u206A\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u2063\u2062Click to retry\u206A\u200C\u206C\x8d\x9d\u206D\u2060\u200C\u206C\u206F\u206A\u206B\u206D\u206B\x8f\u206F\u206F\u206D\u206F\x8f\u206B\u206C\u2061\u061C\u206F\u061C\x8f\u206F\u200D\u2060\u206D\u206D\u2063\u2064",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u2063\u2062Loading...\u200D\u206C\u206E\x8f\u061C\u206D\u206D\u206B\u206D\x9d\u200D\x9d\u2061\x8f\u061C\u200C\x9d\u2060\x90\u2060\x90\u200C\u2061\u2061\x8d\x8f\x81\x8f\u2060\u206E\u206C\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u2063\u2062Show more\u206E\x81\x8f\u2060\x8d\u206A\u2061\u2060\x8d\x8d\x90\x8f\x8f\u200C\x90\u061C\x8f\u206A\x9d\u206C\u206F\x8d\u206D\u206D\u206F\u061C\x8d\x9d\u206C\u206B\u200D\u206D\u2063\u2064",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u2063\u2062{itemsCount} of {totalCount}\u206D\u206B\u061C\u206C\x8f\u206F\u206F\x8d\x90\u061C\u2060\u061C\u206D\u206C\x8f\u200D\x9d\u2060\u206E\x8f\u200D\u200C\u200D\u206F\u206D\u206A\x8d\x8d\u206C\u2060\x81\x8d\u2063\u2064",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u2063\u2062No matches found\u061C\x9d\x81\u2060\u206E\u200C\u200D\u206E\u206F\x9d\x8f\u206F\u206A\u200C\u2061\u206A\u2060\u200C\u2060\x9d\u206E\x90\x8d\u206C\x8d\u206E\x9d\u200C\u206A\x81\x9d\u206C\u2063\u2064",
    'paginated-picker.async-select.select.option.error-message': "\u2063\u2062Couldn't retrieve data\u206C\u206E\x90\u2060\x8d\u200C\u061C\u2061\u2061\x90\u206F\u206B\u200D\u200D\x9d\u206C\u206E\u206D\u200D\x9d\u206B\u206D\u206B\u206D\u206E\u206F\x90\x81\u200C\u206A\u206C\u206D\u2063\u2064",
    'paginated-picker.async-select.select.option.retry-message': "\u2063\u2062Click to retry\x8f\u206C\u200C\x81\u061C\u206E\u061C\u206B\u206C\x9d\u206D\u206C\u206F\u206F\u206C\u206E\x8d\u200C\u200D\x90\u206D\x8d\u206F\u206B\x81\u2060\u206F\x8d\u206E\u206A\x90\u206A\u2063\u2064",
    'paginated-picker.async-select.select.search-placeholder': "\u2063\u2062Search\u200D\u206D\x90\u061C\u200D\u206A\u206E\x90\u206A\u206C\u206F\u061C\u200C\u206A\x90\u206D\x81\u206C\x9d\u061C\u200D\u200D\x8f\u206D\u206D\x8d\x8f\u206E\x9d\u2060\u206F\u2060\u2063\u2064",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u2063\u2062Show full list\x90\u206D\u2061\u206E\u206A\u206B\u061C\u206C\u206B\u206E\u206A\u206E\u206D\x9d\u2061\x8f\x9d\u206B\u2060\u200D\x9d\u2061\u206B\u206B\u206A\x90\x81\u206C\x81\u200C\u206D\u200D\u2063\u2064"
};

});


parcelRegister("c44X3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a84449468c8a341e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $laP0X = parcelRequire("laP0X");
var $a84449468c8a341e$export$2e2bcd8739ae039 = (0, $laP0X.default);

});
parcelRegister("laP0X", function(module, exports) {
$parcel$export(module.exports, "default", () => $4879ffbb915b55e7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $4879ffbb915b55e7$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Borrar selecci\xf3n",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Cargando\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Mostrar m\xe1s",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No se han encontrado coincidencias',
    'paginated-picker.async-select.select.option.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.select.option.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.select.search-placeholder': 'Buscar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};

});


parcelRegister("3pMiw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4852f4a8e65d3ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1AMsA = parcelRequire("1AMsA");
var $d4852f4a8e65d3ed$export$2e2bcd8739ae039 = (0, $1AMsA.default);

});
parcelRegister("1AMsA", function(module, exports) {
$parcel$export(module.exports, "default", () => $09d643af4b46c33e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $09d643af4b46c33e$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Tyhjenn\xe4 valinta",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Ladataan...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "N\xe4yt\xe4 lis\xe4\xe4",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ei hakutuloksia',
    'paginated-picker.async-select.select.option.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.select.option.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.select.search-placeholder': 'Hae',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "N\xe4yt\xe4 koko luettelo"
};

});


parcelRegister("jPbTx", function(module, exports) {
$parcel$export(module.exports, "default", () => $1350e090ac99e739$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7C3jx = parcelRequire("7C3jx");
var $1350e090ac99e739$export$2e2bcd8739ae039 = (0, $7C3jx.default);

});
parcelRegister("7C3jx", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5fedd0d403feee3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $b5fedd0d403feee3$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Effacer la s\xe9lection",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Chargement en cours\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Afficher plus',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} sur {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "R\xe9sultats introuvables",
    'paginated-picker.async-select.select.option.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.select.option.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.select.search-placeholder': 'Rechercher',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Afficher toute la liste'
};

});


parcelRegister("iZH5A", function(module, exports) {
$parcel$export(module.exports, "default", () => $c70baa448984af0e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $a0ZyH = parcelRequire("a0ZyH");
var $c70baa448984af0e$export$2e2bcd8739ae039 = (0, $a0ZyH.default);

});
parcelRegister("a0ZyH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d30679d831d00097$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $d30679d831d00097$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Kijel\xf6l\xe9s megsz\xfcntet\xe9se",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Bet\xf6lt\xe9s\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "T\xf6bb",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nincs egyez\xe9s",
    'paginated-picker.async-select.select.option.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.select.option.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.select.search-placeholder': "Keres\xe9s",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Teljes lista megjelen\xedt\xe9se"
};

});


parcelRegister("fwNik", function(module, exports) {
$parcel$export(module.exports, "default", () => $62c809f98444eeb0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $i07lC = parcelRequire("i07lC");
var $62c809f98444eeb0$export$2e2bcd8739ae039 = (0, $i07lC.default);

});
parcelRegister("i07lC", function(module, exports) {
$parcel$export(module.exports, "default", () => $6170216eb1960759$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $6170216eb1960759$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Cancella selezione',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Caricamento in corso...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mostra altro',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} di {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nessuna corrispondenza trovata',
    'paginated-picker.async-select.select.option.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.select.option.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.select.search-placeholder': 'Ricerca',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Mostra l'elenco completo"
};

});


parcelRegister("44aM1", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc38964b38c3a7d0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6jZXO = parcelRequire("6jZXO");
var $fc38964b38c3a7d0$export$2e2bcd8739ae039 = (0, $6jZXO.default);

});
parcelRegister("6jZXO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3c2d5fecd9095e9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $b3c2d5fecd9095e9$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u9078\u629E\u3092\u89E3\u9664",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u8868\u793A\u3092\u5897\u3084\u3059",
    'paginated-picker.async-select.pagination-details.of-total-count': "{totalCount} \u4EF6\u4E2D {itemsCount} \u4EF6",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u4E00\u81F4\u3059\u308B\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.select.search-placeholder': "\u691C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u30EA\u30B9\u30C8\u5168\u4F53\u3092\u8868\u793A"
};

});


parcelRegister("4iZ8b", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0275e5f26c7af17$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $bGqEh = parcelRequire("bGqEh");
var $d0275e5f26c7af17$export$2e2bcd8739ae039 = (0, $bGqEh.default);

});
parcelRegister("bGqEh", function(module, exports) {
$parcel$export(module.exports, "default", () => $74403ccf6ad555cd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $74403ccf6ad555cd$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\uC120\uD0DD \uD56D\uBAA9 \uC9C0\uC6B0\uAE30",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\uB85C\uB4DC \uC911...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\uB354 \uBCF4\uAE30",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\uC77C\uCE58\uD558\uB294 \uD56D\uBAA9 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.select.search-placeholder': "\uAC80\uC0C9",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\uC804\uCCB4 \uBAA9\uB85D \uD45C\uC2DC"
};

});


parcelRegister("3vdpE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0a4ec4005b5886b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $Bqp08 = parcelRequire("Bqp08");
var $e0a4ec4005b5886b$export$2e2bcd8739ae039 = (0, $Bqp08.default);

});
parcelRegister("Bqp08", function(module, exports) {
$parcel$export(module.exports, "default", () => $daa6b3d0cb810715$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $daa6b3d0cb810715$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Fjern valg',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Laster\xa0\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Finner ingen treff',
    'paginated-picker.async-select.select.option.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.select.option.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis fullstendig liste'
};

});


parcelRegister("2Zz4S", function(module, exports) {
$parcel$export(module.exports, "default", () => $44cbe210a3fef9d1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6yEbw = parcelRequire("6yEbw");
var $44cbe210a3fef9d1$export$2e2bcd8739ae039 = (0, $6yEbw.default);

});
parcelRegister("6yEbw", function(module, exports) {
$parcel$export(module.exports, "default", () => $39a49d052d9bb361$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $39a49d052d9bb361$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Selectie wissen',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Laden...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Meer tonen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} van {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Geen overeenkomsten gevonden',
    'paginated-picker.async-select.select.option.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.select.option.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.select.search-placeholder': 'Zoeken',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Volledige lijst weergeven'
};

});


parcelRegister("j7ZZo", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d0005dd5f99cde4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $2kjgG = parcelRequire("2kjgG");
var $5d0005dd5f99cde4$export$2e2bcd8739ae039 = (0, $2kjgG.default);

});
parcelRegister("2kjgG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1bc76cc2b945d3a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $e1bc76cc2b945d3a$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Wyczy\u015B\u0107 wyb\xf3r",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0141adowanie...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Poka\u017C wi\u0119cej",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} z {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nie znaleziono dopasowa\u0144",
    'paginated-picker.async-select.select.option.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.select.option.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.select.search-placeholder': 'Szukaj',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Poka\u017C pe\u0142n\u0105 list\u0119"
};

});


parcelRegister("fyC1s", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ea0790e2f3952ba$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $i0sV8 = parcelRequire("i0sV8");
var $4ea0790e2f3952ba$export$2e2bcd8739ae039 = (0, $i0sV8.default);

});
parcelRegister("i0sV8", function(module, exports) {
$parcel$export(module.exports, "default", () => $408c0582e10b746a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $408c0582e10b746a$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Limpar sele\xe7\xe3o",
    'paginated-picker.async-select.menu-list.error-message.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Carregando...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Ver mais',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nenhuma correspond\xeancia encontrada",
    'paginated-picker.async-select.select.option.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.select.option.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.select.search-placeholder': 'Pesquisar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};

});


parcelRegister("hb7GE", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ba97c17a8b9d80d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $cuk9r = parcelRequire("cuk9r");
var $8ba97c17a8b9d80d$export$2e2bcd8739ae039 = (0, $cuk9r.default);

});
parcelRegister("cuk9r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a904331f48b6b075$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $a904331f48b6b075$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0438\u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0438\u0441\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});


parcelRegister("ffAcI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8933cf7945978c5f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $ALYst = parcelRequire("ALYst");
var $8933cf7945978c5f$export$2e2bcd8739ae039 = (0, $ALYst.default);

});
parcelRegister("ALYst", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1de4b65303f9342$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $a1de4b65303f9342$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Rensa urval',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4ser in ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Visa mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Inga tr\xe4ffar hittades",
    'paginated-picker.async-select.select.option.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.select.option.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf6k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Visa fullst\xe4ndig lista"
};

});


parcelRegister("gRcow", function(module, exports) {
$parcel$export(module.exports, "default", () => $4aa11f5dac7cb35b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $l2Sio = parcelRequire("l2Sio");
var $4aa11f5dac7cb35b$export$2e2bcd8739ae039 = (0, $l2Sio.default);

});
parcelRegister("l2Sio", function(module, exports) {
$parcel$export(module.exports, "default", () => $2812db00d902cad5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $2812db00d902cad5$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0E25\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0E08\u0E32\u0E01 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
    'paginated-picker.async-select.select.option.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.select.option.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.select.search-placeholder': "\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
};

});


parcelRegister("3VMfr", function(module, exports) {
$parcel$export(module.exports, "default", () => $5115adc0952e695c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $cAJcZ = parcelRequire("cAJcZ");
var $5115adc0952e695c$export$2e2bcd8739ae039 = (0, $cAJcZ.default);

});
parcelRegister("cAJcZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $18ffb1403897ea4d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $18ffb1403897ea4d$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Se\xe7imi temizle",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Y\xfckleniyor...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Daha fazla g\xf6ster",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "E\u015Fle\u015Fme bulunamad\u0131",
    'paginated-picker.async-select.select.option.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.select.option.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.select.search-placeholder': 'Ara',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Tam listeyi g\xf6ster"
};

});


parcelRegister("gay8O", function(module, exports) {
$parcel$export(module.exports, "default", () => $d91580ff8b12d11a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $f3qUc = parcelRequire("f3qUc");
var $d91580ff8b12d11a$export$2e2bcd8739ae039 = (0, $f3qUc.default);

});
parcelRegister("f3qUc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f2c4b589c48e0d8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $3f2c4b589c48e0d8$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0448\u0443\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});


parcelRegister("Suwbb", function(module, exports) {
$parcel$export(module.exports, "default", () => $429d23ce2f94c0ff$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $c3pbJ = parcelRequire("c3pbJ");
var $429d23ce2f94c0ff$export$2e2bcd8739ae039 = (0, $c3pbJ.default);

});
parcelRegister("c3pbJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $095766454a7975a9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $095766454a7975a9$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "X\xf3a m\u1EE5c \u0111\xe3 ch\u1ECDn",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0110ang t\u1EA3i...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Hi\u1EC3n th\u1ECB th\xeam",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xf9 h\u1EE3p n\xe0o",
    'paginated-picker.async-select.select.option.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.select.option.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.select.search-placeholder': "T\xecm ki\u1EBFm",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Hi\u1EC3n th\u1ECB danh s\xe1ch \u0111\u1EA7y \u0111\u1EE7"
};

});


parcelRegister("f1h0p", function(module, exports) {
$parcel$export(module.exports, "default", () => $168d030b816375bb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iCuY5 = parcelRequire("iCuY5");
var $168d030b816375bb$export$2e2bcd8739ae039 = (0, $iCuY5.default);

});
parcelRegister("iCuY5", function(module, exports) {
$parcel$export(module.exports, "default", () => $04405034f32573a0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $04405034f32573a0$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u7A7A\u9009\u62E9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u52A0\u8F7D...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u663E\u793A\u66F4\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u672A\u627E\u5230\u5339\u914D\u9879",
    'paginated-picker.async-select.select.option.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.select.option.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u663E\u793A\u5B8C\u6574\u5217\u8868"
};

});


parcelRegister("5mgpU", function(module, exports) {
$parcel$export(module.exports, "default", () => $45c46abbe9058a1c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fCWfY = parcelRequire("fCWfY");
var $45c46abbe9058a1c$export$2e2bcd8739ae039 = (0, $fCWfY.default);

});
parcelRegister("fCWfY", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b2ba3af1e765917$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $5b2ba3af1e765917$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u9664\u9078\u53D6\u5167\u5BB9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u8F09\u5165...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u986F\u793A\u8F03\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u7B2C {itemsCount} \u500B\uFF0C\u5171 {totalCount} \u500B",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u627E\u4E0D\u5230\u76F8\u7B26\u9805\u76EE",
    'paginated-picker.async-select.select.option.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.select.option.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u5C0B",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u986F\u793A\u5B8C\u6574\u6E05\u55AE"
};

});




parcelRegister("iWOJr", function(module, exports) {
$parcel$export(module.exports, "default", () => $183820c8209e00b0$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $5BFdk = parcelRequire("5BFdk");

var $bnvlN = parcelRequire("bnvlN");
parcelRequire("kw1Aj");
var $6A2cj = parcelRequire("6A2cj");

var $lJoiq = parcelRequire("lJoiq");

var $chIjS = parcelRequire("chIjS");

var $4DeoM = parcelRequire("4DeoM");

var $511tG = parcelRequire("511tG");

var $j6iva = parcelRequire("j6iva");

var $d4ebN = parcelRequire("d4ebN");
const $183820c8209e00b0$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $183820c8209e00b0$var$paginatedComponents = {
    ...(0, $511tG.selectComponents),
    MenuList: $chIjS.MenuList
};
const $183820c8209e00b0$var$ProxyBaseSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(({ selectOptions: selectOptions, ...props }, ref)=>{
    return selectOptions ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $511tG.LocalBaseSelect), {
        ...props,
        options: selectOptions,
        ref: ref
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $511tG.LocalBaseSelect), {
        ...props,
        ref: ref
    });
});
$183820c8209e00b0$var$ProxyBaseSelect.displayName = 'ProxyBaseSelect';
const $183820c8209e00b0$var$AsyncSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef((props, ref)=>{
    const baseSelectProps = (0, $6A2cj.default)(props);
    return /*#__PURE__*/ (0, $gWgPx.jsx)($183820c8209e00b0$var$ProxyBaseSelect, {
        ...props,
        ...baseSelectProps,
        ref: ref
    });
});
$183820c8209e00b0$var$AsyncSelect.displayName = 'AsyncSelect';
/**
 * Adds option to the list of options if its value isn't currently in the Set of keys
 */ const $183820c8209e00b0$var$addUniqueOptions = (keys, options, option)=>{
    if (option.optionType === 'group') {
        const groupOptions = [];
        option.options.forEach((groupOption)=>{
            $183820c8209e00b0$var$addUniqueOptions(keys, groupOptions, groupOption);
        });
        options.push({
            ...option,
            options: groupOptions
        });
        return;
    }
    // Add single options:
    if (!keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
};
const $183820c8209e00b0$var$generateOptions = (selectedValues, newOptions, addSelectedFirst, previousOptions)=>{
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) selectedValues.forEach((option)=>{
        $183820c8209e00b0$var$addUniqueOptions(optionKeys, options, option);
    });
    previousOptions === null || previousOptions === void 0 || previousOptions.forEach((option)=>{
        $183820c8209e00b0$var$addUniqueOptions(optionKeys, options, option);
    });
    newOptions.forEach((option)=>{
        $183820c8209e00b0$var$addUniqueOptions(optionKeys, options, option);
    });
    return options;
};
const $183820c8209e00b0$var$getLastCursorOption = (options)=>(0, (/*@__PURE__*/$parcel$interopDefault($bnvlN)))(options, (option)=>'cursor' in option && !!option.cursor);
// Needed to disable filtering from react-select
const $183820c8209e00b0$var$noFilterOptions = ()=>true;
const $183820c8209e00b0$var$noLoadOptions = ()=>Promise.resolve();
const $183820c8209e00b0$export$54319cf8344f1691 = (options)=>options.map((option)=>option.optionType === 'group' ? option.options.length : 1).reduce((sumSoFar, count)=>sumSoFar + count, 0);
const $183820c8209e00b0$export$fccf54b4cac6e0b3 = ({ ariaLabel: ariaLabel, field: field, value: value, onChange: onChange, onClear: onClear, initiallyAddSelectedFirst: initiallyAddSelectedFirst, showFooter: showFooter, ...restProps })=>{
    var _field$pagination;
    const selectRef = (0, $8P7DW.useRef)(null);
    const [page, setPage] = (0, $8P7DW.useState)(0);
    const [isLoading, setIsLoading] = (0, $8P7DW.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = (0, $8P7DW.useState)(false);
    const [inputValue, setInputValue] = (0, $8P7DW.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $8P7DW.useState)([]);
    const [enableFullList, setEnableFullList] = (0, $8P7DW.useState)(((_field$pagination = field.pagination) === null || _field$pagination === void 0 ? void 0 : _field$pagination.enableFullList) ?? false);
    const [totalCount, setTotalCount] = (0, $8P7DW.useState)(null);
    const [error, setError] = (0, $8P7DW.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const getTotalCountWithFunctions = (0, $8P7DW.useCallback)((newTotalCount)=>{
        var _field$pagination2;
        if (newTotalCount === null || !((_field$pagination2 = field.pagination) !== null && _field$pagination2 !== void 0 && (_field$pagination2 = _field$pagination2.keywordValues) !== null && _field$pagination2 !== void 0 && _field$pagination2.length)) return newTotalCount;
        const { pagination: { keywordValues: keywordValues } } = field;
        const newTotalCountWithKeywords = newTotalCount + value.filter((option)=>keywordValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $183820c8209e00b0$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $183820c8209e00b0$var$MAX_TOTAL_COUNT;
    }, [
        field,
        value
    ]);
    const checkIfError = (0, $8P7DW.useCallback)((_search, options, onRetry)=>{
        if (options.some((option)=>option.optionType === 'error')) {
            setError({
                isError: true,
                error: null,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $8P7DW.useCallback)((search)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        setIsLoading(true);
        loadOptions(search, enableFullList, false, false, undefined, ({ options: options, totalCount: newTotalCount })=>{
            if (checkIfError(search, options, ()=>handleLoadOptions(search))) return;
            setLoadedOptions($183820c8209e00b0$var$generateOptions(value, options, initiallyAddSelectedFirst));
            setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsLoading(false);
        });
    }, [
        field,
        enableFullList,
        checkIfError,
        value,
        initiallyAddSelectedFirst,
        getTotalCountWithFunctions
    ]);
    const handleShowMore = (0, $8P7DW.useCallback)((showFullList = false, isRetry = false)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        let originalLoadedOptions;
        if (showFullList) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, showFullList, true, $183820c8209e00b0$var$getLastCursorOption(loadedOptions), ({ options: options, totalCount: newTotalCount })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(showFullList, true);
            })) return;
            setPage(page + 1);
            setEnableFullList(false);
            setLoadedOptions($183820c8209e00b0$var$generateOptions(value, options, showFullList, originalLoadedOptions));
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsPaginationLoading(false);
            setIsLoading(false);
        });
    }, [
        field,
        loadedOptions,
        inputValue,
        checkIfError,
        value,
        page,
        getTotalCountWithFunctions
    ]);
    const handleShowFullList = (0, $8P7DW.useCallback)(()=>{
        handleShowMore(true, false);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $8P7DW.useCallback)((newInputValue)=>{
        const { onInputChange: onInputChange } = field;
        setEnableFullList(false);
        setPage(0);
        setInputValue(newInputValue);
        setTotalCount(null);
        setLoadedOptions([]);
        handleLoadOptions(newInputValue);
        onInputChange && onInputChange();
    }, [
        field,
        handleLoadOptions
    ]);
    const handleOnChange = (0, $8P7DW.useCallback)((options, action)=>{
        let selectData;
        if ('option' in action) {
            const actionOption = action.option;
            if (actionOption && 'value' in actionOption) selectData = {
                selectedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($5BFdk)))(loadedOptions, (option)=>'value' in option && option.value === actionOption.value)
            };
        }
        onChange === null || onChange === void 0 || onChange(options, action, selectData);
    }, [
        onChange,
        loadedOptions
    ]);
    const handleClear = (0, $8P7DW.useCallback)(()=>{
        onClear === null || onClear === void 0 || onClear();
        // Focus the search input after clearing
        setTimeout(()=>{
            var _selectRef$current;
            (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 || _selectRef$current.focus();
        }, 0);
    }, [
        onClear
    ]);
    // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $8P7DW.useEffect)(()=>{
        handleLoadOptions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsCount = totalCount === null ? 0 : $183820c8209e00b0$export$54319cf8344f1691(loadedOptions);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)($183820c8209e00b0$var$AsyncSelect, {
                ref: selectRef,
                ariaLabel: ariaLabel,
                cacheOptions: field.cacheOptions,
                components: $183820c8209e00b0$var$paginatedComponents,
                defaultOptions: field.defaultOptions,
                defaultOptionsLabel: field.defaultOptionsLabel,
                inputValue: inputValue,
                loadOptions: $183820c8209e00b0$var$noLoadOptions,
                onInputChange: handleInputChange,
                onMenuScrollToBottom: field.onMenuScrollToBottom,
                onMenuScrollToTop: field.onMenuScrollToTop,
                placeholder: field.placeholder,
                fieldKey: field.key,
                fieldLabel: field.label,
                fieldInvalidLabel: field.invalidLabel,
                selectOptions: loadedOptions,
                onFilterOption: $183820c8209e00b0$var$noFilterOptions,
                menuListProps: {
                    error: error,
                    type: field.key,
                    handleShowMore: handleShowMore,
                    isLoading: isLoading,
                    isPaginationLoading: isPaginationLoading,
                    showShowMoreButton: totalCount !== null && loadedOptionsCount < totalCount
                },
                onChange: handleOnChange,
                value: value,
                ...restProps
            }),
            (showFooter || !showFooter && !!value.length) && field.pagination && !isLoading && !!(loadedOptions !== null && loadedOptions !== void 0 && loadedOptions.length) && !error.isError && /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $d4ebN.Footer), {
                children: [
                    !value.length && enableFullList && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $j6iva.ShowFullListButton), {
                        type: field.key,
                        onShowFullList: handleShowFullList
                    }),
                    !!value.length && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lJoiq.ClearSelectedItemsButton), {
                        onClear: handleClear,
                        type: field.key
                    }),
                    showFooter && !enableFullList && totalCount !== null && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4DeoM.PaginationDetails), {
                        itemsCount: loadedOptionsCount,
                        totalCount: totalCount
                    })
                ]
            })
        ]
    });
};
var $183820c8209e00b0$export$2e2bcd8739ae039 = $183820c8209e00b0$export$fccf54b4cac6e0b3;

});
parcelRegister("5BFdk", function(module, exports) {

var $bD57f = parcelRequire("bD57f");

var $2b4jE = parcelRequire("2b4jE");

var $fB6fn = parcelRequire("fB6fn");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $415060b1913755e5$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $415060b1913755e5$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $fB6fn(fromIndex);
    if (index < 0) index = $415060b1913755e5$var$nativeMax(length + index, 0);
    return $bD57f(array, $2b4jE(predicate, 3), index);
}
module.exports = $415060b1913755e5$var$findIndex;

});

parcelRegister("bnvlN", function(module, exports) {

var $fpIAr = parcelRequire("fpIAr");

var $cAUZD = parcelRequire("cAUZD");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $848a29420b714a5f$var$findLast = $fpIAr($cAUZD);
module.exports = $848a29420b714a5f$var$findLast;

});
parcelRegister("fpIAr", function(module, exports) {

var $2b4jE = parcelRequire("2b4jE");

var $eG4u6 = parcelRequire("eG4u6");

var $4ztaZ = parcelRequire("4ztaZ");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $b38bc6d1e90115e8$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$eG4u6(collection)) {
            var iteratee = $2b4jE(predicate, 3);
            collection = $4ztaZ(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $b38bc6d1e90115e8$var$createFind;

});

parcelRegister("cAUZD", function(module, exports) {

var $bD57f = parcelRequire("bD57f");

var $2b4jE = parcelRequire("2b4jE");

var $fB6fn = parcelRequire("fB6fn");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $92b50e77e7e47f3e$var$nativeMax = Math.max, $92b50e77e7e47f3e$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $92b50e77e7e47f3e$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $fB6fn(fromIndex);
        index = fromIndex < 0 ? $92b50e77e7e47f3e$var$nativeMax(length + index, 0) : $92b50e77e7e47f3e$var$nativeMin(index, length - 1);
    }
    return $bD57f(array, $2b4jE(predicate, 3), index, true);
}
module.exports = $92b50e77e7e47f3e$var$findLastIndex;

});


parcelRegister("kw1Aj", function(module, exports) {
$parcel$export(module.exports, "default", () => $c18b248d15e1b26e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("6A2cj")).default);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $dL6c3 = parcelRequire("dL6c3");

var $6A2cj = parcelRequire("6A2cj");

var $ZSWqE = parcelRequire("ZSWqE");
const $c18b248d15e1b26e$var$AsyncSelect = /*#__PURE__*/ (0, $8P7DW.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $6A2cj.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $ZSWqE.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dL6c3.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c18b248d15e1b26e$export$2e2bcd8739ae039 = $c18b248d15e1b26e$var$AsyncSelect;

});
parcelRegister("dL6c3", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d6f539bbc45020d$export$2e2bcd8739ae039);
/* select.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $ddwWi = parcelRequire("ddwWi");

var $5JgbU = parcelRequire("5JgbU");

var $5J6r2 = parcelRequire("5J6r2");

var $e6Qdr = parcelRequire("e6Qdr");

var $eub38 = parcelRequire("eub38");

var $goA3W = parcelRequire("goA3W");

var $lBvbm = parcelRequire("lBvbm");

var $dWIs3 = parcelRequire("dWIs3");

var $h2Ohb = parcelRequire("h2Ohb");

var $5GBJ9 = parcelRequire("5GBJ9");

var $dgzm0 = parcelRequire("dgzm0");

var $labMK = parcelRequire("labMK");

var $1KXqR = parcelRequire("1KXqR");

var $h2GlC = parcelRequire("h2GlC");

var $j5TAI = parcelRequire("j5TAI");

var $ksvdP = parcelRequire("ksvdP");

var $9fpoh = parcelRequire("9fpoh");

var $bxRcO = parcelRequire("bxRcO");

var $9DJ5e = parcelRequire("9DJ5e");

var $LCqac = parcelRequire("LCqac");
const $0d6f539bbc45020d$var$noop = (0, $5J6r2.default);
function $0d6f539bbc45020d$var$notNullish(item) {
    return item != null;
}
function $0d6f539bbc45020d$var$scrollIntoView(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $bxRcO.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $bxRcO.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $0d6f539bbc45020d$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch  {
        return false;
    }
}
function $0d6f539bbc45020d$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ const $0d6f539bbc45020d$var$filterUnsupportedSelectors = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
const $0d6f539bbc45020d$var$elemBeforeCSS = null;
const $0d6f539bbc45020d$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $0d6f539bbc45020d$var$isTouchCapable(),
    captureMenuScroll: !$0d6f539bbc45020d$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5GBJ9.createFilter)(),
    formatGroupLabel: (0, $eub38.formatGroupLabel),
    getOptionLabel: (0, $eub38.getOptionLabel),
    getOptionValue: (0, $eub38.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $eub38.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$0d6f539bbc45020d$var$isMobileDevice(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $0d6f539bbc45020d$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $0d6f539bbc45020d$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $0d6f539bbc45020d$var$isOptionSelected(props, option, selectValue);
    const label = $0d6f539bbc45020d$var$getOptionLabel(props, option);
    const value = $0d6f539bbc45020d$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $0d6f539bbc45020d$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$0d6f539bbc45020d$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$0d6f539bbc45020d$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $0d6f539bbc45020d$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $0d6f539bbc45020d$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($0d6f539bbc45020d$var$notNullish);
}
function $0d6f539bbc45020d$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $0d6f539bbc45020d$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $0d6f539bbc45020d$var$buildFocusableOptions(props, selectValue) {
    return $0d6f539bbc45020d$var$buildFocusableOptionsFromCategorizedOptions($0d6f539bbc45020d$var$buildCategorizedOptions(props, selectValue));
}
function $0d6f539bbc45020d$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$0d6f539bbc45020d$var$shouldHideSelectedOptions(props) || !isSelected) && $0d6f539bbc45020d$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $0d6f539bbc45020d$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $0d6f539bbc45020d$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $0d6f539bbc45020d$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    var _focusableOptionsWith;
    const focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find((option)=>option.data === focusedOption)) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
const $0d6f539bbc45020d$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $0d6f539bbc45020d$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $0d6f539bbc45020d$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $0d6f539bbc45020d$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $0d6f539bbc45020d$var$getOptionValue(props, option);
    return selectValue.some((i)=>$0d6f539bbc45020d$var$getOptionValue(props, i) === candidate);
}
function $0d6f539bbc45020d$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $0d6f539bbc45020d$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $0d6f539bbc45020d$var$instanceId = 1;
class $0d6f539bbc45020d$export$2e2bcd8739ae039 extends (0, $8P7DW.Component) {
    static #_ = this.defaultProps = $0d6f539bbc45020d$export$9c21a3269931e1e6;
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $h2GlC.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $h2GlC.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $9DJ5e.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $9DJ5e.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $LCqac.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $LCqac.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $LCqac.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $0d6f539bbc45020d$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $0d6f539bbc45020d$var$buildFocusableOptionsWithIds($0d6f539bbc45020d$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $dgzm0.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $0d6f539bbc45020d$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $0d6f539bbc45020d$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = {
                boxSizing: 'border-box'
            };
            const custom = this.props.styles[key];
            if (custom) return $0d6f539bbc45020d$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        }, this.getClassNames = (key, props)=>{
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        }, this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $goA3W.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$0d6f539bbc45020d$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$0d6f539bbc45020d$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (_)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $1KXqR.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $e6Qdr.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $0d6f539bbc45020d$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$0d6f539bbc45020d$var$instanceId);
        this.state.selectValue = (0, $labMK.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $0d6f539bbc45020d$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $labMK.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $0d6f539bbc45020d$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $0d6f539bbc45020d$var$buildFocusableOptionsWithIds($0d6f539bbc45020d$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $0d6f539bbc45020d$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $0d6f539bbc45020d$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $0d6f539bbc45020d$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $LCqac.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $0d6f539bbc45020d$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            $0d6f539bbc45020d$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $5JgbU.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            var _this$inputRef;
            (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) {
                    var _this$inputRef2;
                    (_this$inputRef2 = this.inputRef) === null || _this$inputRef2 === void 0 || _this$inputRef2.setAttribute('aria-label', normalizedLabel);
                } else {
                    var _this$inputRef3;
                    (_this$inputRef3 = this.inputRef) === null || _this$inputRef3 === void 0 || _this$inputRef3.removeAttribute('aria-label');
                }
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options === null || options === void 0 ? void 0 : options.find((option)=>{
            var _groupCandidate$optio;
            const groupCandidate = option;
            return ((_groupCandidate$optio = groupCandidate.options) === null || _groupCandidate$optio === void 0 ? void 0 : _groupCandidate$optio.some(isOptionFocused)) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = (groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) ?? 0;
            const totalLength = options === null || options === void 0 ? void 0 : options.reduce((acc, currentGroup)=>{
                var _group$options;
                const group = currentGroup;
                acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData === null || groupData === void 0 ? void 0 : groupData.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options === null || options === void 0 ? void 0 : options.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $0d6f539bbc45020d$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $0d6f539bbc45020d$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $0d6f539bbc45020d$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        var _this$props$component;
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        }
        // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
        // and no custom Option component is provided (custom Option components may already
        // render elemBefore themselves, causing it to appear twice)
        if (context === 'menu' && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option) && (0, $e6Qdr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const elemBefore = data.elemBefore;
            if (elemBefore) {
                const label = this.getOptionLabel(data);
                return /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                    className: (0, $8n1kL.default)([
                        "_zulpu2gc _1e0c1txw _4cvr1h6o"
                    ]),
                    children: [
                        elemBefore,
                        /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                            children: label
                        })
                    ]
                });
            }
        }
        return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            ...!this.props.isSearchable && (0, $e6Qdr.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                'aria-autocomplete': 'both'
            },
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && !(0, $e6Qdr.fg)('select_issearchable_aria-readonly_fix') && {
                'aria-readonly': true
            },
            ...this.calculateDescription()
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lBvbm.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: $0d6f539bbc45020d$var$noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, $gWgPx.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $8P7DW.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $8P7DW.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $gWgPx.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value')
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $gWgPx.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $gWgPx.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $gWgPx.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $8P7DW.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $8P7DW.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $gWgPx.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $gWgPx.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...this.props['UNSAFE_is_experimental_generic'] && {
                        role: 'listitem'
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $h2Ohb.default), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $gWgPx.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9fpoh.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>{
                            var _this$inputRef4, _this$inputRef5;
                            return /*#__PURE__*/ (0, $gWgPx.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': ((_this$inputRef4 = this.inputRef) === null || _this$inputRef4 === void 0 ? void 0 : _this$inputRef4.id) || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $5JgbU.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': ((_this$inputRef5 = this.inputRef) === null || _this$inputRef5 === void 0 ? void 0 : _this$inputRef5.id) || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            });
                        }
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $gWgPx.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ksvdP.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $gWgPx.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dWIs3.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $gWgPx.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $gWgPx.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $ddwWi.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $j5TAI.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("ddwWi", function(module, exports) {
$parcel$export(module.exports, "isAppleDevice", () => $2c9db855b6d96608$export$e1865c3bedcd822b);
function $2c9db855b6d96608$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $2c9db855b6d96608$var$isIPhone() {
    return $2c9db855b6d96608$var$testPlatform(/^iPhone/i);
}
function $2c9db855b6d96608$var$isIPad() {
    return $2c9db855b6d96608$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $2c9db855b6d96608$var$isMac() && navigator.maxTouchPoints > 1;
}
function $2c9db855b6d96608$var$isMac() {
    return $2c9db855b6d96608$var$testPlatform(/^Mac/i);
}
function $2c9db855b6d96608$var$isIOS() {
    return $2c9db855b6d96608$var$isIPhone() || $2c9db855b6d96608$var$isIPad();
}
function $2c9db855b6d96608$export$e1865c3bedcd822b() {
    return $2c9db855b6d96608$var$isMac() || $2c9db855b6d96608$var$isIOS();
}

});

parcelRegister("eub38", function(module, exports) {
$parcel$export(module.exports, "formatGroupLabel", () => $80814593044dc923$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $80814593044dc923$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $80814593044dc923$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $80814593044dc923$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $80814593044dc923$export$f4da216a6ca54656 = (group)=>group.label;
const $80814593044dc923$export$dac6ace3020563ca = (option)=>option.label;
const $80814593044dc923$export$40be908210c5a79c = (option)=>option.value;
const $80814593044dc923$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("goA3W", function(module, exports) {
$parcel$export(module.exports, "components", () => $78dd8de68121a98f$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $78dd8de68121a98f$export$71abc632aa29e6fe);

var $4RHuV = parcelRequire("4RHuV");

var $67Q7j = parcelRequire("67Q7j");

var $2zJQ5 = parcelRequire("2zJQ5");

var $kXfIO = parcelRequire("kXfIO");

var $eUvj9 = parcelRequire("eUvj9");

var $9oaf5 = parcelRequire("9oaf5");

var $j4p1V = parcelRequire("j4p1V");

var $1LxCF = parcelRequire("1LxCF");

var $ckT60 = parcelRequire("ckT60");

var $83qfG = parcelRequire("83qfG");

var $3zeJF = parcelRequire("3zeJF");

var $3FkmM = parcelRequire("3FkmM");

var $ck2M2 = parcelRequire("ck2M2");

var $8WFMs = parcelRequire("8WFMs");

var $9uDwq = parcelRequire("9uDwq");

var $TLili = parcelRequire("TLili");

var $kiSw4 = parcelRequire("kiSw4");

var $7I3Hf = parcelRequire("7I3Hf");

var $5XFSX = parcelRequire("5XFSX");

var $fxnld = parcelRequire("fxnld");

var $dWGr5 = parcelRequire("dWGr5");

var $6YFjC = parcelRequire("6YFjC");
const $78dd8de68121a98f$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $1LxCF.ClearIndicator),
    Control: (0, $eUvj9.default),
    DropdownIndicator: (0, $ckT60.DropdownIndicator),
    Group: (0, $9oaf5.default),
    GroupHeading: (0, $j4p1V.GroupHeading),
    IndicatorsContainer: (0, $4RHuV.IndicatorsContainer),
    Input: (0, $3zeJF.default),
    LoadingIndicator: (0, $83qfG.LoadingIndicator),
    Menu: (0, $3FkmM.default),
    MenuList: (0, $ck2M2.MenuList),
    MenuPortal: (0, $TLili.MenuPortal),
    LoadingMessage: (0, $8WFMs.LoadingMessage),
    NoOptionsMessage: (0, $9uDwq.NoOptionsMessage),
    MultiValue: (0, $kiSw4.default),
    MultiValueContainer: (0, $67Q7j.MultiValueContainer),
    MultiValueLabel: (0, $7I3Hf.MultiValueLabel),
    MultiValueRemove: (0, $5XFSX.MultiValueRemove),
    Option: (0, $fxnld.default),
    Placeholder: (0, $dWGr5.default),
    SelectContainer: (0, $2zJQ5.SelectContainer),
    SingleValue: (0, $6YFjC.default),
    ValueContainer: (0, $kXfIO.ValueContainer)
};
const $78dd8de68121a98f$export$71abc632aa29e6fe = (props)=>({
        ...$78dd8de68121a98f$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("4RHuV", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $013b7b2b66e2f1a3$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* indicators-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $7rFBw = parcelRequire("7rFBw");
const $013b7b2b66e2f1a3$var$indicatorContainerStyles = null;
const $013b7b2b66e2f1a3$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $82a6z.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("7rFBw", function(module, exports) {
$parcel$export(module.exports, "getStyleProps", () => $44ee9fc34247dc4d$export$26417cabd806a658);
const $44ee9fc34247dc4d$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};

});


parcelRegister("67Q7j", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $ab7ae3e72bb6667f$export$cf9cf2a30a59265c);
/* multi-value-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* multi-value-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");
const $ab7ae3e72bb6667f$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const $ab7ae3e72bb6667f$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $ab7ae3e72bb6667f$var$multiValueStyles.root,
            isDisabled && $ab7ae3e72bb6667f$var$multiValueStyles.disabled,
            isFocused && $ab7ae3e72bb6667f$var$multiValueStyles.focused,
            (0, $82a6z.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};

});

parcelRegister("2zJQ5", function(module, exports) {
$parcel$export(module.exports, "SelectContainer", () => $b023f8c0b5d0be9b$export$446eebadefe1123b);
/* select-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* select-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $7rFBw = parcelRequire("7rFBw");
const $b023f8c0b5d0be9b$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
const $b023f8c0b5d0be9b$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $7rFBw.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $b023f8c0b5d0be9b$var$containerStyles.default,
            isRtl && $b023f8c0b5d0be9b$var$containerStyles.rtl,
            isDisabled && $b023f8c0b5d0be9b$var$containerStyles.disabled,
            (0, $82a6z.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};

});

parcelRegister("kXfIO", function(module, exports) {
$parcel$export(module.exports, "ValueContainer", () => $9d858325f447816d$export$4dc9f58ad9a1a000);
/* value-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* value-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $e6Qdr = parcelRequire("e6Qdr");

var $7rFBw = parcelRequire("7rFBw");
const $9d858325f447816d$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
const $9d858325f447816d$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    const ffTagUplifts = (0, $e6Qdr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const tagUpliftMultiVertical = ffTagUplifts && isMulti;
    const tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $9d858325f447816d$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $9d858325f447816d$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $9d858325f447816d$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $9d858325f447816d$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $9d858325f447816d$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $9d858325f447816d$var$valueContainerStyles.flex,
            tagUpliftChipRow && $9d858325f447816d$var$valueContainerStyles.flexWithGap,
            (0, $82a6z.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};

});

parcelRegister("eUvj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $48ab61b445893e3d$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.37.1 */ /* control.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $e6Qdr = parcelRequire("e6Qdr");

var $7rFBw = parcelRequire("7rFBw");
const $48ab61b445893e3d$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
const $48ab61b445893e3d$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $48ab61b445893e3d$var$styles.default,
            (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $48ab61b445893e3d$var$styles.defaultT26Shape,
            isDisabled && $48ab61b445893e3d$var$styles.disabled,
            isInvalid && $48ab61b445893e3d$var$styles.invalid,
            isCompact && $48ab61b445893e3d$var$styles.compact,
            appearance === 'subtle' && $48ab61b445893e3d$var$styles.subtle,
            appearance === 'subtle' && isFocused && $48ab61b445893e3d$var$styles.subtleFocused,
            isFocused && $48ab61b445893e3d$var$styles.focused,
            appearance === 'none' && $48ab61b445893e3d$var$styles.none,
            (0, $82a6z.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$48ab61b445893e3d$export$2e2bcd8739ae039 = $48ab61b445893e3d$var$Control;

});

parcelRegister("9oaf5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0e1527f2898f8f3$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.37.1 */ /* group.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $7rFBw = parcelRequire("7rFBw");
const $d0e1527f2898f8f3$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
const $d0e1527f2898f8f3$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $d0e1527f2898f8f3$var$styles.root,
            (0, $82a6z.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $gWgPx.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                children: children
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0e1527f2898f8f3$export$2e2bcd8739ae039 = $d0e1527f2898f8f3$var$Group;

});

parcelRegister("j4p1V", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $cbe57f5a62da7d51$export$85c8b41a3cd87edc);
/* group-heading.tsx generated by @compiled/babel-plugin v0.37.1 */ /* group-heading.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $7rFBw = parcelRequire("7rFBw");

var $bpGj6 = parcelRequire("bpGj6");
const $cbe57f5a62da7d51$var$headingStyles = null;
const $cbe57f5a62da7d51$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $bpGj6.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $82a6z.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};

});
parcelRegister("bpGj6", function(module, exports) {
$parcel$export(module.exports, "cleanCommonProps", () => $bf573a959f8f011f$export$8e9fd4287627890c);
// Clean Common Props
// ==============================
const $bf573a959f8f011f$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: // not listed in commonProps documentation, needs to be removed to allow Emotion to generate classNames
    clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: // not listed in commonProps documentation
    selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};

});


parcelRegister("1LxCF", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $eaf64c733fd7fcaa$export$ecf9cf59142dd54a);
/* clear-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ /* clear-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $4CMbU = parcelRequire("4CMbU");

var $bgvtM = parcelRequire("bgvtM");

var $7rFBw = parcelRequire("7rFBw");
const $eaf64c733fd7fcaa$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
const $eaf64c733fd7fcaa$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
const $eaf64c733fd7fcaa$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $eaf64c733fd7fcaa$var$clearIndicatorStyles.default,
            isCompact && $eaf64c733fd7fcaa$var$clearIndicatorStyles.compact,
            (0, $82a6z.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bgvtM.default), {
            xcss: $eaf64c733fd7fcaa$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4CMbU))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
};

});

parcelRegister("ckT60", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $29e1d0c80cda4390$export$ec98719d3db7f2e4);
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ /* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $cDQfx = parcelRequire("cDQfx");

var $iPrfN = parcelRequire("iPrfN");

var $7rFBw = parcelRequire("7rFBw");
const $29e1d0c80cda4390$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
const $29e1d0c80cda4390$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
const $29e1d0c80cda4390$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $29e1d0c80cda4390$var$dropdownStyles.default,
            isDisabled && $29e1d0c80cda4390$var$dropdownStyles.disabled,
            isCompact && $29e1d0c80cda4390$var$dropdownStyles.compact,
            (0, $82a6z.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iPrfN.default), {
            as: "span",
            xcss: $29e1d0c80cda4390$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
};

});

parcelRegister("83qfG", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $ae1e0db584f081bf$export$7c20be4c1d342248);
/* loading-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ /* loading-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $cjn3r = parcelRequire("cjn3r");

var $7rFBw = parcelRequire("7rFBw");
const $ae1e0db584f081bf$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
const $ae1e0db584f081bf$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $ae1e0db584f081bf$var$loadingIndicatorStyles.default,
            isCompact && $ae1e0db584f081bf$var$loadingIndicatorStyles.compact,
            (0, $82a6z.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
            size: "small"
        })
    });
};

});

parcelRegister("3zeJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $949c889df3f15ba8$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.37.1 */ /* input.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $e6Qdr = parcelRequire("e6Qdr");

var $7rFBw = parcelRequire("7rFBw");

var $bpGj6 = parcelRequire("bpGj6");
const $949c889df3f15ba8$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $949c889df3f15ba8$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $949c889df3f15ba8$var$nativeInputStylesOld = null;
const $949c889df3f15ba8$var$nativeInputStyles = null;
const $949c889df3f15ba8$var$hidden = null;
const $949c889df3f15ba8$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss, isMulti: isMulti } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $bpGj6.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'input', {
        'input-container': true
    });
    const ffTagUplifts = (0, $e6Qdr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $e6Qdr.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $949c889df3f15ba8$var$inputStyles.root,
            isMulti && ffTagUplifts && $949c889df3f15ba8$var$inputStyles.labellingFFStyles,
            isDisabled && $949c889df3f15ba8$var$inputStyles.disabled,
            (0, $82a6z.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $8n1kL.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $949c889df3f15ba8$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $949c889df3f15ba8$var$inputStylesOld.labellingFFStyles,
            isDisabled && $949c889df3f15ba8$var$inputStylesOld.disabled,
            (0, $82a6z.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $8n1kL.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$949c889df3f15ba8$export$2e2bcd8739ae039 = $949c889df3f15ba8$var$Input;

});

parcelRegister("3FkmM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b46e4ca44e0e570$export$2e2bcd8739ae039);
/* menu.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $e6Qdr = parcelRequire("e6Qdr");

var $7rFBw = parcelRequire("7rFBw");
const $3b46e4ca44e0e570$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
const $3b46e4ca44e0e570$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $3b46e4ca44e0e570$var$menuStyles.root,
            $3b46e4ca44e0e570$var$menuStyles[placement],
            (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $3b46e4ca44e0e570$var$menuStyles.rootT26Shape,
            (0, $82a6z.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3b46e4ca44e0e570$export$2e2bcd8739ae039 = $3b46e4ca44e0e570$var$Menu;

});

parcelRegister("ck2M2", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $6e85ed0217ff4b6b$export$d4c4e98c5044dc8);
/* menu-list.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu-list.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $7rFBw = parcelRequire("7rFBw");
const $6e85ed0217ff4b6b$var$menuListStyles = null;
const $6e85ed0217ff4b6b$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $82a6z.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};

});

parcelRegister("8WFMs", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $055e31b40f7dba4b$export$e928a71d039d3102);
/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu-loading-message.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $9pb7J = parcelRequire("9pb7J");

var $7rFBw = parcelRequire("7rFBw");
const $055e31b40f7dba4b$var$noticeStyles = null;
const $055e31b40f7dba4b$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $82a6z.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};

});

parcelRegister("9uDwq", function(module, exports) {
$parcel$export(module.exports, "NoOptionsMessage", () => $5ea1cde167fbe518$export$d58b72b7d3c4072c);
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $9pb7J = parcelRequire("9pb7J");

var $7rFBw = parcelRequire("7rFBw");
const $5ea1cde167fbe518$var$noticeStyles = null;
const $5ea1cde167fbe518$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $82a6z.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};

});

parcelRegister("TLili", function(module, exports) {
$parcel$export(module.exports, "MenuPortal", () => $cfb02cd11f8be028$export$793392f970497feb);
/* menu-portal.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu-portal.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $b3n8D = parcelRequire("b3n8D");

var $6Q1OD = parcelRequire("6Q1OD");

var $7rFBw = parcelRequire("7rFBw");

var $jAV1Z = parcelRequire("jAV1Z");
function $cfb02cd11f8be028$var$getBoundingClientObj(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
const $cfb02cd11f8be028$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $cfb02cd11f8be028$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
const $cfb02cd11f8be028$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $8P7DW.useRef)(null);
    const cleanupRef = (0, $8P7DW.useRef)(null);
    const [placement, setPortalPlacement] = (0, $8P7DW.useState)($cfb02cd11f8be028$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $8P7DW.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $8P7DW.useState)(null);
    const updateComputedPosition = (0, $8P7DW.useCallback)(()=>{
        if (!controlElement) return;
        const rect = $cfb02cd11f8be028$var$getBoundingClientObj(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $8P7DW.useLayoutEffect)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $8P7DW.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $b3n8D.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $8P7DW.useLayoutEffect)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $8P7DW.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $cfb02cd11f8be028$var$menuPortalStyles.root,
            (0, $82a6z.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jAV1Z.PortalPlacementContext).Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $6Q1OD.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

});
parcelRegister("b3n8D", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", () => $80c1ec5341b11ac4$export$deee3a793edee05f);

var $kz1BE = parcelRequire("kz1BE");
var $ghTRd = parcelRequire("ghTRd");

var $ghTRd = parcelRequire("ghTRd");

var $gkOZJ = parcelRequire("gkOZJ");
function $80c1ec5341b11ac4$var$getCssDimensions(element) {
    const css = (0, $gkOZJ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $gkOZJ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $ghTRd.round)(width) !== offsetWidth || (0, $ghTRd.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $80c1ec5341b11ac4$var$unwrapElement(element) {
    return !(0, $gkOZJ.isElement)(element) ? element.contextElement : element;
}
function $80c1ec5341b11ac4$var$getScale(element) {
    const domElement = $80c1ec5341b11ac4$var$unwrapElement(element);
    if (!(0, $gkOZJ.isHTMLElement)(domElement)) return (0, $ghTRd.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $80c1ec5341b11ac4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $ghTRd.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $ghTRd.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $80c1ec5341b11ac4$var$noOffsets = /*#__PURE__*/ (0, $ghTRd.createCoords)(0);
function $80c1ec5341b11ac4$var$getVisualOffsets(element) {
    const win = (0, $gkOZJ.getWindow)(element);
    if (!(0, $gkOZJ.isWebKit)() || !win.visualViewport) return $80c1ec5341b11ac4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $80c1ec5341b11ac4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $gkOZJ.getWindow)(element)) return false;
    return isFixed;
}
function $80c1ec5341b11ac4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $80c1ec5341b11ac4$var$unwrapElement(element);
    let scale = (0, $ghTRd.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $gkOZJ.isElement)(offsetParent)) scale = $80c1ec5341b11ac4$var$getScale(offsetParent);
        } else scale = $80c1ec5341b11ac4$var$getScale(element);
    }
    const visualOffsets = $80c1ec5341b11ac4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $80c1ec5341b11ac4$var$getVisualOffsets(domElement) : (0, $ghTRd.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $gkOZJ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $gkOZJ.isElement)(offsetParent) ? (0, $gkOZJ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $gkOZJ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $80c1ec5341b11ac4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $gkOZJ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $gkOZJ.getWindow)(currentIFrame);
            currentIFrame = (0, $gkOZJ.getFrameElement)(currentWin);
        }
    }
    return (0, $ghTRd.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $80c1ec5341b11ac4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $gkOZJ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $80c1ec5341b11ac4$var$getBoundingClientRect((0, $gkOZJ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $80c1ec5341b11ac4$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $80c1ec5341b11ac4$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $80c1ec5341b11ac4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $gkOZJ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $gkOZJ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $ghTRd.createCoords)(1);
    const offsets = (0, $ghTRd.createCoords)(0);
    const isOffsetParentAnElement = (0, $gkOZJ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gkOZJ.getNodeName)(offsetParent) !== 'body' || (0, $gkOZJ.isOverflowElement)(documentElement)) scroll = (0, $gkOZJ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $80c1ec5341b11ac4$var$getBoundingClientRect(offsetParent);
            scale = $80c1ec5341b11ac4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $80c1ec5341b11ac4$var$getHTMLOffset(documentElement, scroll) : (0, $ghTRd.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $80c1ec5341b11ac4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $80c1ec5341b11ac4$var$getDocumentRect(element) {
    const html = (0, $gkOZJ.getDocumentElement)(element);
    const scroll = (0, $gkOZJ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $ghTRd.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $ghTRd.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $80c1ec5341b11ac4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $gkOZJ.getComputedStyle)(body).direction === 'rtl') x += (0, $ghTRd.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $80c1ec5341b11ac4$var$SCROLLBAR_MAX = 25;
function $80c1ec5341b11ac4$var$getViewportRect(element, strategy) {
    const win = (0, $gkOZJ.getWindow)(element);
    const html = (0, $gkOZJ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $gkOZJ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $80c1ec5341b11ac4$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $80c1ec5341b11ac4$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $80c1ec5341b11ac4$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $80c1ec5341b11ac4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $80c1ec5341b11ac4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $gkOZJ.isHTMLElement)(element) ? $80c1ec5341b11ac4$var$getScale(element) : (0, $ghTRd.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $80c1ec5341b11ac4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $80c1ec5341b11ac4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $80c1ec5341b11ac4$var$getDocumentRect((0, $gkOZJ.getDocumentElement)(element));
    else if ((0, $gkOZJ.isElement)(clippingAncestor)) rect = $80c1ec5341b11ac4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $80c1ec5341b11ac4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $ghTRd.rectToClientRect)(rect);
}
function $80c1ec5341b11ac4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $gkOZJ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $gkOZJ.isElement)(parentNode) || (0, $gkOZJ.isLastTraversableNode)(parentNode)) return false;
    return (0, $gkOZJ.getComputedStyle)(parentNode).position === 'fixed' || $80c1ec5341b11ac4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $80c1ec5341b11ac4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $gkOZJ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $gkOZJ.isElement)(el) && (0, $gkOZJ.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $gkOZJ.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $gkOZJ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $gkOZJ.isElement)(currentNode) && !(0, $gkOZJ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $gkOZJ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $gkOZJ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $gkOZJ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $80c1ec5341b11ac4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $gkOZJ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $80c1ec5341b11ac4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $gkOZJ.isTopLayer)(element) ? [] : $80c1ec5341b11ac4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $80c1ec5341b11ac4$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $80c1ec5341b11ac4$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $ghTRd.max)(rect.top, top);
        right = (0, $ghTRd.min)(rect.right, right);
        bottom = (0, $ghTRd.min)(rect.bottom, bottom);
        left = (0, $ghTRd.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $80c1ec5341b11ac4$var$getDimensions(element) {
    const { width: width, height: height } = $80c1ec5341b11ac4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $80c1ec5341b11ac4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $gkOZJ.isHTMLElement)(offsetParent);
    const documentElement = (0, $gkOZJ.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $80c1ec5341b11ac4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $ghTRd.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $80c1ec5341b11ac4$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gkOZJ.getNodeName)(offsetParent) !== 'body' || (0, $gkOZJ.isOverflowElement)(documentElement)) scroll = (0, $gkOZJ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $80c1ec5341b11ac4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $80c1ec5341b11ac4$var$getHTMLOffset(documentElement, scroll) : (0, $ghTRd.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $80c1ec5341b11ac4$var$isStaticPositioned(element) {
    return (0, $gkOZJ.getComputedStyle)(element).position === 'static';
}
function $80c1ec5341b11ac4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $gkOZJ.isHTMLElement)(element) || (0, $gkOZJ.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $gkOZJ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $80c1ec5341b11ac4$var$getOffsetParent(element, polyfill) {
    const win = (0, $gkOZJ.getWindow)(element);
    if ((0, $gkOZJ.isTopLayer)(element)) return win;
    if (!(0, $gkOZJ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $gkOZJ.getParentNode)(element);
        while(svgOffsetParent && !(0, $gkOZJ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $gkOZJ.isElement)(svgOffsetParent) && !$80c1ec5341b11ac4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $gkOZJ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $80c1ec5341b11ac4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $gkOZJ.isTableElement)(offsetParent) && $80c1ec5341b11ac4$var$isStaticPositioned(offsetParent))offsetParent = $80c1ec5341b11ac4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $gkOZJ.isLastTraversableNode)(offsetParent) && $80c1ec5341b11ac4$var$isStaticPositioned(offsetParent) && !(0, $gkOZJ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $gkOZJ.getContainingBlock)(element) || win;
}
const $80c1ec5341b11ac4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $80c1ec5341b11ac4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $80c1ec5341b11ac4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $80c1ec5341b11ac4$var$isRTL(element) {
    return (0, $gkOZJ.getComputedStyle)(element).direction === 'rtl';
}
const $80c1ec5341b11ac4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $80c1ec5341b11ac4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $gkOZJ.getDocumentElement,
    getClippingRect: $80c1ec5341b11ac4$var$getClippingRect,
    getOffsetParent: $80c1ec5341b11ac4$var$getOffsetParent,
    getElementRects: $80c1ec5341b11ac4$var$getElementRects,
    getClientRects: $80c1ec5341b11ac4$var$getClientRects,
    getDimensions: $80c1ec5341b11ac4$var$getDimensions,
    getScale: $80c1ec5341b11ac4$var$getScale,
    isElement: $gkOZJ.isElement,
    isRTL: $80c1ec5341b11ac4$var$isRTL
};
function $80c1ec5341b11ac4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $80c1ec5341b11ac4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $gkOZJ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $ghTRd.floor)(top);
        const insetRight = (0, $ghTRd.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $ghTRd.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $ghTRd.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $ghTRd.max)(0, (0, $ghTRd.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$80c1ec5341b11ac4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $80c1ec5341b11ac4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $80c1ec5341b11ac4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $gkOZJ.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $gkOZJ.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $80c1ec5341b11ac4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $80c1ec5341b11ac4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $80c1ec5341b11ac4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$80c1ec5341b11ac4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $80c1ec5341b11ac4$export$37b6bde19b108ecc = (0, $kz1BE.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $80c1ec5341b11ac4$export$cc800923e997bb8 = (0, $kz1BE.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $80c1ec5341b11ac4$export$91fb6ecbd551914 = (0, $kz1BE.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $80c1ec5341b11ac4$export$fba63a578e423eb = (0, $kz1BE.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $80c1ec5341b11ac4$export$8a83211c878a3f1f = (0, $kz1BE.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $80c1ec5341b11ac4$export$346677f925de839c = (0, $kz1BE.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $80c1ec5341b11ac4$export$fe8985bb6374093c = (0, $kz1BE.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $80c1ec5341b11ac4$export$f2120bbfa5450bd2 = (0, $kz1BE.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $80c1ec5341b11ac4$export$18c8ad048e32c7d5 = (0, $kz1BE.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $80c1ec5341b11ac4$export$7bf07e38f3dc4b69 = (0, $kz1BE.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $80c1ec5341b11ac4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $80c1ec5341b11ac4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $kz1BE.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("kz1BE", function(module, exports) {
$parcel$export(module.exports, "detectOverflow", () => $ef88527e711727b7$export$37b6bde19b108ecc);
$parcel$export(module.exports, "computePosition", () => $ef88527e711727b7$export$48a53dcb22e581d0);
$parcel$export(module.exports, "arrow", () => $ef88527e711727b7$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $ef88527e711727b7$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $ef88527e711727b7$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $ef88527e711727b7$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $ef88527e711727b7$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $ef88527e711727b7$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $ef88527e711727b7$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $ef88527e711727b7$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $ef88527e711727b7$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("ghTRd")).rectToClientRect);

var $ghTRd = parcelRequire("ghTRd");
function $ef88527e711727b7$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $ghTRd.getSideAxis)(placement);
    const alignmentAxis = (0, $ghTRd.getAlignmentAxis)(placement);
    const alignLength = (0, $ghTRd.getAxisLength)(alignmentAxis);
    const side = (0, $ghTRd.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $ghTRd.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $ef88527e711727b7$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $ghTRd.evaluate)(options, state);
    const paddingObject = (0, $ghTRd.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $ghTRd.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $ghTRd.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $ef88527e711727b7$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $ef88527e711727b7$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $ef88527e711727b7$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $ef88527e711727b7$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $ef88527e711727b7$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $ef88527e711727b7$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $ef88527e711727b7$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $ghTRd.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $ghTRd.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $ghTRd.getAlignmentAxis)(placement);
            const length = (0, $ghTRd.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $ghTRd.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $ghTRd.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $ghTRd.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $ghTRd.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $ef88527e711727b7$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $ghTRd.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $ghTRd.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $ghTRd.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $ghTRd.getAlignment)(placement) === alignment || (autoAlignment ? (0, $ghTRd.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $ef88527e711727b7$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $ghTRd.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $ghTRd.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $ghTRd.placements) ? $ef88527e711727b7$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $ghTRd.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $ghTRd.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $ghTRd.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $ghTRd.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $ef88527e711727b7$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $ghTRd.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $ghTRd.getSide)(placement);
            const initialSideAxis = (0, $ghTRd.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $ghTRd.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $ghTRd.getOppositePlacement)(initialPlacement)
            ] : (0, $ghTRd.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $ghTRd.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $ghTRd.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $ghTRd.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $ghTRd.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $ghTRd.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $ef88527e711727b7$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $ef88527e711727b7$var$isAnySideFullyClipped(overflow) {
    return (0, $ghTRd.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $ef88527e711727b7$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $ghTRd.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $ef88527e711727b7$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $ef88527e711727b7$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $ef88527e711727b7$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $ef88527e711727b7$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $ef88527e711727b7$var$getBoundingRect(rects) {
    const minX = (0, $ghTRd.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $ghTRd.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $ghTRd.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $ghTRd.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $ef88527e711727b7$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $ghTRd.rectToClientRect)($ef88527e711727b7$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $ef88527e711727b7$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $ghTRd.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $ef88527e711727b7$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $ghTRd.rectToClientRect)($ef88527e711727b7$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $ghTRd.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $ghTRd.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $ghTRd.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $ghTRd.getSide)(placement) === 'left';
                    const maxRight = (0, $ghTRd.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $ghTRd.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $ef88527e711727b7$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $ef88527e711727b7$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $ghTRd.getSide)(placement);
    const alignment = (0, $ghTRd.getAlignment)(placement);
    const isVertical = (0, $ghTRd.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $ef88527e711727b7$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $ghTRd.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $ef88527e711727b7$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $ef88527e711727b7$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $ef88527e711727b7$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $ghTRd.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $ghTRd.getSideAxis)((0, $ghTRd.getSide)(placement));
            const mainAxis = (0, $ghTRd.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $ghTRd.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $ghTRd.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $ef88527e711727b7$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $ghTRd.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $ghTRd.getSideAxis)(placement);
            const mainAxis = (0, $ghTRd.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $ghTRd.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $ef88527e711727b7$var$originSides.has((0, $ghTRd.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $ef88527e711727b7$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $ghTRd.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $ghTRd.getSide)(placement);
            const alignment = (0, $ghTRd.getAlignment)(placement);
            const isYAxis = (0, $ghTRd.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $ghTRd.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $ghTRd.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $ghTRd.max)(overflow.left, 0);
                const xMax = (0, $ghTRd.max)(overflow.right, 0);
                const yMin = (0, $ghTRd.max)(overflow.top, 0);
                const yMax = (0, $ghTRd.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $ghTRd.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $ghTRd.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("ghTRd", function(module, exports) {
$parcel$export(module.exports, "sides", () => $bdb98ff7c6294cf8$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $bdb98ff7c6294cf8$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $bdb98ff7c6294cf8$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $bdb98ff7c6294cf8$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $bdb98ff7c6294cf8$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $bdb98ff7c6294cf8$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $bdb98ff7c6294cf8$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $bdb98ff7c6294cf8$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $bdb98ff7c6294cf8$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $bdb98ff7c6294cf8$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $bdb98ff7c6294cf8$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $bdb98ff7c6294cf8$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $bdb98ff7c6294cf8$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $bdb98ff7c6294cf8$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $bdb98ff7c6294cf8$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $bdb98ff7c6294cf8$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $bdb98ff7c6294cf8$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $bdb98ff7c6294cf8$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $bdb98ff7c6294cf8$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $bdb98ff7c6294cf8$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $bdb98ff7c6294cf8$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $bdb98ff7c6294cf8$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $bdb98ff7c6294cf8$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $bdb98ff7c6294cf8$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $bdb98ff7c6294cf8$export$803cd8101b6c182b = /*#__PURE__*/ $bdb98ff7c6294cf8$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $bdb98ff7c6294cf8$export$27b07d8a310ed8b5[0], side + "-" + $bdb98ff7c6294cf8$export$27b07d8a310ed8b5[1]), []);
const $bdb98ff7c6294cf8$export$96ec731ed4dcb222 = Math.min;
const $bdb98ff7c6294cf8$export$8960430cfd85939f = Math.max;
const $bdb98ff7c6294cf8$export$2077e0241d6afd3c = Math.round;
const $bdb98ff7c6294cf8$export$a3fe094919f356fd = Math.floor;
const $bdb98ff7c6294cf8$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $bdb98ff7c6294cf8$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $bdb98ff7c6294cf8$export$7d15b64cf5a3a4c4(start, value, end) {
    return $bdb98ff7c6294cf8$export$8960430cfd85939f(start, $bdb98ff7c6294cf8$export$96ec731ed4dcb222(value, end));
}
function $bdb98ff7c6294cf8$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $bdb98ff7c6294cf8$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $bdb98ff7c6294cf8$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $bdb98ff7c6294cf8$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $bdb98ff7c6294cf8$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $bdb98ff7c6294cf8$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $bdb98ff7c6294cf8$export$2b57e0052a6d6d4c(placement) {
    return $bdb98ff7c6294cf8$export$8a000a963141ac32($bdb98ff7c6294cf8$export$f28e8f882010718a(placement));
}
function $bdb98ff7c6294cf8$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $bdb98ff7c6294cf8$export$f0989780f32bfcda(placement);
    const alignmentAxis = $bdb98ff7c6294cf8$export$2b57e0052a6d6d4c(placement);
    const length = $bdb98ff7c6294cf8$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $bdb98ff7c6294cf8$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $bdb98ff7c6294cf8$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $bdb98ff7c6294cf8$export$496432a3699e50b1(placement) {
    const oppositePlacement = $bdb98ff7c6294cf8$export$9c5e28bad23365fa(placement);
    return [
        $bdb98ff7c6294cf8$export$2b182c584985588b(placement),
        oppositePlacement,
        $bdb98ff7c6294cf8$export$2b182c584985588b(oppositePlacement)
    ];
}
function $bdb98ff7c6294cf8$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $bdb98ff7c6294cf8$var$lrPlacement = [
    'left',
    'right'
];
const $bdb98ff7c6294cf8$var$rlPlacement = [
    'right',
    'left'
];
const $bdb98ff7c6294cf8$var$tbPlacement = [
    'top',
    'bottom'
];
const $bdb98ff7c6294cf8$var$btPlacement = [
    'bottom',
    'top'
];
function $bdb98ff7c6294cf8$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $bdb98ff7c6294cf8$var$rlPlacement : $bdb98ff7c6294cf8$var$lrPlacement;
            return isStart ? $bdb98ff7c6294cf8$var$lrPlacement : $bdb98ff7c6294cf8$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $bdb98ff7c6294cf8$var$tbPlacement : $bdb98ff7c6294cf8$var$btPlacement;
        default:
            return [];
    }
}
function $bdb98ff7c6294cf8$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $bdb98ff7c6294cf8$export$f0989780f32bfcda(placement);
    let list = $bdb98ff7c6294cf8$var$getSideList($bdb98ff7c6294cf8$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($bdb98ff7c6294cf8$export$2b182c584985588b));
    }
    return list;
}
function $bdb98ff7c6294cf8$export$9c5e28bad23365fa(placement) {
    const side = $bdb98ff7c6294cf8$export$3c915306cb7fc97a(placement);
    return $bdb98ff7c6294cf8$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $bdb98ff7c6294cf8$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $bdb98ff7c6294cf8$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $bdb98ff7c6294cf8$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $bdb98ff7c6294cf8$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("gkOZJ", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $be461214b3037caf$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $be461214b3037caf$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $be461214b3037caf$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $be461214b3037caf$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $be461214b3037caf$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $be461214b3037caf$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $be461214b3037caf$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $be461214b3037caf$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $be461214b3037caf$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $be461214b3037caf$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $be461214b3037caf$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $be461214b3037caf$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $be461214b3037caf$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $be461214b3037caf$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $be461214b3037caf$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $be461214b3037caf$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $be461214b3037caf$export$7bf1f8740e3e34af);
function $be461214b3037caf$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $be461214b3037caf$export$651544f548703224(node) {
    if ($be461214b3037caf$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $be461214b3037caf$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $be461214b3037caf$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($be461214b3037caf$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $be461214b3037caf$export$8ee0fc9ee280b4ee(value) {
    if (!$be461214b3037caf$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $be461214b3037caf$export$38b2d434cce3ea22(value).Node;
}
function $be461214b3037caf$export$45a5e7f76e0caa8d(value) {
    if (!$be461214b3037caf$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $be461214b3037caf$export$38b2d434cce3ea22(value).Element;
}
function $be461214b3037caf$export$1b3bfaa9684536aa(value) {
    if (!$be461214b3037caf$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $be461214b3037caf$export$38b2d434cce3ea22(value).HTMLElement;
}
function $be461214b3037caf$export$af51f0f06c0f328a(value) {
    if (!$be461214b3037caf$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $be461214b3037caf$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $be461214b3037caf$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $be461214b3037caf$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $be461214b3037caf$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($be461214b3037caf$export$651544f548703224(element));
}
function $be461214b3037caf$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $be461214b3037caf$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $be461214b3037caf$var$containRe = /paint|layout|strict|content/;
const $be461214b3037caf$var$isNotNone = (value)=>!!value && value !== 'none';
let $be461214b3037caf$var$isWebKitValue;
function $be461214b3037caf$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $be461214b3037caf$export$45a5e7f76e0caa8d(elementOrCss) ? $be461214b3037caf$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $be461214b3037caf$var$isNotNone(css.transform) || $be461214b3037caf$var$isNotNone(css.translate) || $be461214b3037caf$var$isNotNone(css.scale) || $be461214b3037caf$var$isNotNone(css.rotate) || $be461214b3037caf$var$isNotNone(css.perspective) || !$be461214b3037caf$export$78551043582a6a98() && ($be461214b3037caf$var$isNotNone(css.backdropFilter) || $be461214b3037caf$var$isNotNone(css.filter)) || $be461214b3037caf$var$willChangeRe.test(css.willChange || '') || $be461214b3037caf$var$containRe.test(css.contain || '');
}
function $be461214b3037caf$export$940d8225183e1404(element) {
    let currentNode = $be461214b3037caf$export$4e12058fc4d51d56(element);
    while($be461214b3037caf$export$1b3bfaa9684536aa(currentNode) && !$be461214b3037caf$export$d1162fb0b6d4cd51(currentNode)){
        if ($be461214b3037caf$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($be461214b3037caf$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $be461214b3037caf$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $be461214b3037caf$export$78551043582a6a98() {
    if ($be461214b3037caf$var$isWebKitValue == null) $be461214b3037caf$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $be461214b3037caf$var$isWebKitValue;
}
function $be461214b3037caf$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($be461214b3037caf$export$651544f548703224(node));
}
function $be461214b3037caf$export$3735103072e4a80(element) {
    return $be461214b3037caf$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $be461214b3037caf$export$dc8fc79fa2800137(element) {
    if ($be461214b3037caf$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $be461214b3037caf$export$4e12058fc4d51d56(node) {
    if ($be461214b3037caf$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $be461214b3037caf$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $be461214b3037caf$export$e495491855dc5418(node);
    return $be461214b3037caf$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $be461214b3037caf$export$7cd01a57c8ca906c(node) {
    const parentNode = $be461214b3037caf$export$4e12058fc4d51d56(node);
    if ($be461214b3037caf$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($be461214b3037caf$export$1b3bfaa9684536aa(parentNode) && $be461214b3037caf$export$989e911fa9af580a(parentNode)) return parentNode;
    return $be461214b3037caf$export$7cd01a57c8ca906c(parentNode);
}
function $be461214b3037caf$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $be461214b3037caf$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $be461214b3037caf$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $be461214b3037caf$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $be461214b3037caf$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $be461214b3037caf$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $be461214b3037caf$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $be461214b3037caf$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("jAV1Z", function(module, exports) {
$parcel$export(module.exports, "PortalPlacementContext", () => $52e9b127325c4707$export$e001f626511a0ead);

var $8P7DW = parcelRequire("8P7DW");
const $52e9b127325c4707$export$e001f626511a0ead = /*#__PURE__*/ (0, $8P7DW.createContext)(null);

});


parcelRegister("kiSw4", function(module, exports) {
$parcel$export(module.exports, "default", () => $633dd6f68d64f644$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.37.1 */ /* multi-value.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $e6Qdr = parcelRequire("e6Qdr");

var $3HrSo = parcelRequire("3HrSo");

var $7rFBw = parcelRequire("7rFBw");

var $7I3Hf = parcelRequire("7I3Hf");
const $633dd6f68d64f644$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
// Tag-like color styles
const $633dd6f68d64f644$var$tagLikeColorStyles = {
    gray: "_119b8yml",
    blue: "_119b1w55",
    green: "_119b1crs",
    red: "_119b16y8",
    yellow: "_119bfeiv",
    purple: "_119b1hqq",
    lime: "_119bnf89",
    magenta: "_119buwd0",
    orange: "_119b1b2s",
    teal: "_119b1h3o"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- match TagNew border color logic
const $633dd6f68d64f644$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
const $633dd6f68d64f644$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const $633dd6f68d64f644$var$getMultiValueLabelText = (children, data)=>{
    if (typeof children === 'string') return children;
    const label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
const $633dd6f68d64f644$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const labelText = $633dd6f68d64f644$var$getMultiValueLabelText(children, data);
    const isPlainLabel = typeof children === 'string';
    const ffTagUplifts = (0, $e6Qdr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const { css: containerCss, className: containerClassName } = (0, $7rFBw.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $7rFBw.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $7rFBw.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    const hasCustomLabel = Label !== (0, $7I3Hf.MultiValueLabel);
    // Plain labels: use Tag with fillContainer so it truncates like tag-like structure.
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel) {
        const { elemBefore: elemBefore, color: tagColor } = data ?? {};
        return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $8n1kL.default)([
                $633dd6f68d64f644$var$multiValueTagWrapperStyles.root,
                (0, $82a6z.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3HrSo.default), {
                text: labelText,
                isRemovable: !isDisabled,
                removeButtonLabel: `${labelText}, remove`,
                onBeforeRemoveAction: ()=>{
                    var _removeProps$onClick;
                    (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                    return false;
                },
                color: tagColor ?? 'gray',
                elemBefore: elemBefore,
                hasMargin: false
            })
        });
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts) {
        const colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
            "data-multi-value-tag-like": "true",
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $8n1kL.default)([
                $633dd6f68d64f644$var$multiValueTagLikeStyles.root,
                $633dd6f68d64f644$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $633dd6f68d64f644$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $633dd6f68d64f644$var$tagLikeColorStyles.green,
                colorKey === 'red' && $633dd6f68d64f644$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $633dd6f68d64f644$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $633dd6f68d64f644$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $633dd6f68d64f644$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $633dd6f68d64f644$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $633dd6f68d64f644$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $633dd6f68d64f644$var$tagLikeColorStyles.teal,
                "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _u8p61h4e _hg5mr3uz _1easrqqc",
                isDisabled && $633dd6f68d64f644$var$multiValueTagLikeStyles.disabled,
                isFocused && $633dd6f68d64f644$var$multiValueTagLikeStyles.focused,
                (0, $82a6z.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    className: (0, $8n1kL.default)([
                        $633dd6f68d64f644$var$multiValueTagLikeStyles.labelWrapper
                    ]),
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)(Label, {
                        data: data,
                        innerProps: {
                            style: labelCss,
                            className: labelClassName
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: labelClassName,
                        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                        selectProps: selectProps,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)(Remove, {
                    data: data,
                    innerProps: {
                        style: removeCss,
                        className: removeClassName,
                        role: 'button',
                        tabIndex: -1,
                        'aria-label': `${labelText || 'option'}, remove`,
                        ...removeProps
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: removeClassName,
                    isDisabled: isDisabled,
                    selectProps: selectProps
                })
            ]
        });
    }
    // FF off → default styles
    return /*#__PURE__*/ (0, $gWgPx.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${labelText || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$633dd6f68d64f644$export$2e2bcd8739ae039 = $633dd6f68d64f644$var$MultiValue;

});
parcelRegister("3HrSo", function(module, exports) {
$parcel$export(module.exports, "default", () => $26aef444e59795b2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $9yUAD = parcelRequire("9yUAD");

var $klxUK = parcelRequire("klxUK");

var $5J6r2 = parcelRequire("5J6r2");

var $eT7pr = parcelRequire("eT7pr");

var $cBwgz = parcelRequire("cBwgz");
var $4akUv = parcelRequire("4akUv");

var $e6Qdr = parcelRequire("e6Qdr");

var $7bEe7 = parcelRequire("7bEe7");

var $br21J = parcelRequire("br21J");

var $hGyIy = parcelRequire("hGyIy");

var $8qpee = parcelRequire("8qpee");

var $8hzdg = parcelRequire("8hzdg");

var $6sl31 = parcelRequire("6sl31");
const $26aef444e59795b2$var$textLinkCssVar = '--ds-ctl';
const $26aef444e59795b2$var$textDefaultCssVar = '--ds-ct';
const $26aef444e59795b2$var$textActiveCssVar = '--ds-ctp';
const $26aef444e59795b2$var$backgroundHoverCssVar = '--ds-cbh';
const $26aef444e59795b2$var$backgroundActiveCssVar = '--ds-cba';
var $26aef444e59795b2$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($26aef444e59795b2$var$TagStatus || {});
const $26aef444e59795b2$var$packageName = undefined;
const $26aef444e59795b2$var$packageVersion = undefined;
const $26aef444e59795b2$var$defaultBeforeRemoveAction = ()=>true;
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ const $26aef444e59795b2$var$removingStyles = null;
const $26aef444e59795b2$var$RemovableTagComponent = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $26aef444e59795b2$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $5J6r2.default), linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, hasMargin: hasMargin = true, swatchBefore: swatchBefore, ...rest }, ref)=>{
    const [status, setStatus] = (0, $8P7DW.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $8P7DW.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $9yUAD.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $26aef444e59795b2$var$packageName,
            packageVersion: $26aef444e59795b2$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $8P7DW.useCallback)(()=>{
        setStatus("removed");
    }, []);
    const handleRemoveRequest = (0, $8P7DW.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(text);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const onKeyPress = (0, $8P7DW.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $8P7DW.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $8P7DW.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $8P7DW.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $8P7DW.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6sl31.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $e6Qdr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $8qpee.getLozengeAppearance)(color);
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eT7pr.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest,
            children: text
        });
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $e6Qdr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $7bEe7.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7bEe7.default), {
            ref: ref,
            color: newColor,
            text: text,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        });
    }
    // Original implementation
    const content = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8hzdg.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$26aef444e59795b2$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$26aef444e59795b2$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$26aef444e59795b2$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$26aef444e59795b2$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$26aef444e59795b2$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBwgz.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4akUv.default), {
            onFinish: handleRemoveComplete,
            children: (motion)=>{
                return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $br21J.default), {
                    ref: (0, $klxUK.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hGyIy.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $8n1kL.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
                    ])
                });
            }
        }, "atlaskit-removable-tag-legacy-shrink-out")
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $26aef444e59795b2$var$RemovableTag = /*#__PURE__*/ (0, $8P7DW.memo)($26aef444e59795b2$var$RemovableTagComponent);
var $26aef444e59795b2$export$2e2bcd8739ae039 = $26aef444e59795b2$var$RemovableTag;

});
parcelRegister("9yUAD", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $ce894b0f0246f589$export$53c2b9c37c40e0d8);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $19XqD = parcelRequire("19XqD");
const $ce894b0f0246f589$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const methodRef = (0, $19XqD.useTrackedRef)(method);
    const payloadRef = (0, $19XqD.useTrackedRef)(payload);
    return (0, $8P7DW.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("eT7pr", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc181f15dc5b2dc1$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $e6Qdr = parcelRequire("e6Qdr");

var $3orZf = parcelRequire("3orZf");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $dc181f15dc5b2dc1$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $dc181f15dc5b2dc1$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $dc181f15dc5b2dc1$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $dc181f15dc5b2dc1$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $dc181f15dc5b2dc1$var$LegacyLozenge = /*#__PURE__*/ (0, $8P7DW.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $8P7DW.useMemo)(()=>$dc181f15dc5b2dc1$var$appearanceTypes.includes(appearance) || $dc181f15dc5b2dc1$var$newSemanticColors.includes(appearance) ? $dc181f15dc5b2dc1$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            $dc181f15dc5b2dc1$var$styles.container,
            $dc181f15dc5b2dc1$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $dc181f15dc5b2dc1$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $dc181f15dc5b2dc1$var$styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
            style: {
                color: style === null || style === void 0 ? void 0 : style.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $8n1kL.default)([
                $dc181f15dc5b2dc1$var$styles.text,
                (0, $e6Qdr.fg)('platform-lozenge-custom-letterspacing') && $dc181f15dc5b2dc1$var$styles.customLetterspacing,
                $dc181f15dc5b2dc1$var$styles[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
});
$dc181f15dc5b2dc1$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ const $dc181f15dc5b2dc1$var$LozengeWrapper = /*#__PURE__*/ (0, $8P7DW.memo)((props)=>{
    if ((0, $e6Qdr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3orZf.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)($dc181f15dc5b2dc1$var$LegacyLozenge, {
        ...props
    });
});
$dc181f15dc5b2dc1$var$LozengeWrapper.displayName = 'Lozenge';
var $dc181f15dc5b2dc1$export$2e2bcd8739ae039 = $dc181f15dc5b2dc1$var$LozengeWrapper;

});
parcelRegister("3orZf", function(module, exports) {
$parcel$export(module.exports, "default", () => $feadfd317119bbb3$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $3Vr7T = parcelRequire("3Vr7T");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $feadfd317119bbb3$var$Lozenge = ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3Vr7T.default), {
        ...baseProps,
        children: children
    });
};
$feadfd317119bbb3$var$Lozenge.displayName = 'Lozenge';
var $feadfd317119bbb3$export$2e2bcd8739ae039 = $feadfd317119bbb3$var$Lozenge;

});
parcelRegister("3Vr7T", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b955586e5aa21e2$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.37.1 */ /* lozenge-base.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $2SIoy = parcelRequire("2SIoy");

var $6NJAV = parcelRequire("6NJAV");

var $cDQfx = parcelRequire("cDQfx");

var $lGzmI = parcelRequire("lGzmI");

var $e6Qdr = parcelRequire("e6Qdr");

var $galRw = parcelRequire("galRw");

var $cjn3r = parcelRequire("cjn3r");

var $ifgam = parcelRequire("ifgam");

var $4hEoM = parcelRequire("4hEoM");
// Get the pressed background color for the selected lozenge dropdown trigger
const $9b955586e5aa21e2$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $9b955586e5aa21e2$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'metric.semantic.success': "_1bn8d6jc _4ayg1wl5",
    'metric.semantic.warning': "_1bn8bkku _4aygzr32",
    'metric.semantic.danger': "_1bn8jkmi _4ayg1r4b",
    'metric.semantic.information': "_1bn8ar1y _4ayg1c1j",
    'metric.semantic.neutral': "_1bn814je _4ayg1fkg _iymy8hz0 _16burnys",
    'metric.semantic.discovery': "_1bn85usi _4ayg18vq",
    'metric.inverse': "_1bn8vuon _4aygvuon",
    'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
    'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
    'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
    'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
    'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
    'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
    'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
    'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
    'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
    'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
    'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
    'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
    iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha",
    containerSelected: "_1xe213kw",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadge: "_1ftrbpke",
    containerBadgeInteractive: "_1axm1bqy"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const $9b955586e5aa21e2$var$LozengeBase = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const [resizing, setResizing] = (0, $8P7DW.useState)(false);
    const onFinishMotion = ()=>setResizing(false);
    const resizingWidth = (0, $lGzmI.useResizingWidth)({
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    const isInitialRender = (0, $8P7DW.useRef)(true);
    const isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $4hEoM.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $4hEoM.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $4hEoM.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    const metricBadgeAppearance = resolvedTrailingMetricAppearance === 'inverse' ? 'inverse' : resolvedTrailingMetricAppearance != null && resolvedTrailingMetricAppearance.startsWith('accent-') ? 'neutral' : resolvedTrailingMetricAppearance ?? 'neutral';
    const metricStyleKey = resolvedTrailingMetricAppearance === 'inverse' ? 'metric.inverse' : resolvedTrailingMetricAppearance != null && !resolvedTrailingMetricAppearance.startsWith('accent-') ? `metric.semantic.${(0, $4hEoM.getThemeStyles)(resolvedTrailingMetricAppearance).key}` : 'metric.semantic.neutral';
    const commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        maxWidth: maxWidthIsPc ? maxWidth : '100%'
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $8P7DW.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $e6Qdr.fg)('platform-dst-motion-uplift');
    const innerContent = /*#__PURE__*/ (0, $gWgPx.jsxs)("span", {
        style: {
            // When maxWidth is a percentage, constrain the content wrapper
            // so text truncation works correctly within the flex layout
            maxWidth: maxWidthIsPc ? '100%' : undefined
        },
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $8n1kL.default)([
            $9b955586e5aa21e2$var$styles.content,
            spacing === 'spacious' && $9b955586e5aa21e2$var$styles.contentSpacious,
            isLoading && $9b955586e5aa21e2$var$styles.loadingContent
        ]),
        children: [
            iconBefore && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifgam.default), {
                size: spacing === 'spacious' ? 'medium' : 'small',
                icon: iconBefore,
                color: resolvedColor,
                testId: testId && `${testId}--icon`
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                style: {
                    maxWidth: maxWidthIsPc ? undefined : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
                    color: style === null || style === void 0 ? void 0 : style.color
                },
                "data-testid": testId && `${testId}--text`,
                className: (0, $8n1kL.default)([
                    $9b955586e5aa21e2$var$styles.text,
                    enableMotionFG && resizing ? $9b955586e5aa21e2$var$styles.textClip : $9b955586e5aa21e2$var$styles.textEllipsis,
                    spacing === 'spacious' && $9b955586e5aa21e2$var$styles.textSpacious
                ]),
                children: children
            }),
            hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                "data-lozenge-metric-wrapper": true,
                "data-testid": testId && `${testId}--metric`,
                className: (0, $8n1kL.default)([
                    $9b955586e5aa21e2$var$styles.metricBadgeWrapper
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2SIoy.default), {
                    appearance: metricBadgeAppearance,
                    children: trailingMetric
                })
            }),
            isInteractive && /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
                label: "",
                size: "small",
                color: 'currentColor',
                testId: testId && `${testId}--chevron`
            })
        ]
    });
    if (isInteractive) return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $galRw.default), {
        ref: ref,
        xcss: (0, $6NJAV.cx)($9b955586e5aa21e2$var$styles.container, (0, $e6Qdr.fg)('platform-dst-motion-uplift') && $9b955586e5aa21e2$var$styles.motionContainer, spacing === 'spacious' && $9b955586e5aa21e2$var$styles.containerSpacious, !isSelected && $9b955586e5aa21e2$var$styles.iconBorderFilter, !isLoading && $9b955586e5aa21e2$var$styles.iconBorderInteractiveFilter, $9b955586e5aa21e2$var$styles[colorStyleKey], !isLoading && $9b955586e5aa21e2$var$styles[interactiveStyleKey], isSelected && $9b955586e5aa21e2$var$styles.containerSelected, hasTrailingMetric && $9b955586e5aa21e2$var$styles.containerBadge, hasTrailingMetric && $9b955586e5aa21e2$var$styles.containerBadgeInteractive, hasTrailingMetric && $9b955586e5aa21e2$var$styles[metricStyleKey]),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'oklch(from var(--border-color) calc(l * var(--border-pressed-l-factor)) c h) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $9b955586e5aa21e2$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        children: [
            innerContent,
            isLoading && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                className: (0, $8n1kL.default)([
                    $9b955586e5aa21e2$var$styles.loadingOverlay
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                    size: spacing === 'spacious' ? 'small' : 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            $9b955586e5aa21e2$var$styles.container,
            spacing === 'spacious' && $9b955586e5aa21e2$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $9b955586e5aa21e2$var$styles.containerBadgePadding,
            $9b955586e5aa21e2$var$styles[colorStyleKey],
            hasTrailingMetric && $9b955586e5aa21e2$var$styles[metricStyleKey],
            $9b955586e5aa21e2$var$styles.iconBorderFilter,
            $9b955586e5aa21e2$var$styles.containerBadge
        ]),
        children: innerContent
    });
}));
var $9b955586e5aa21e2$export$2e2bcd8739ae039 = $9b955586e5aa21e2$var$LozengeBase;

});
parcelRegister("2SIoy", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c07309b7c20a50b$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $e6Qdr = parcelRequire("e6Qdr");

var $9pb7J = parcelRequire("9pb7J");

var $29ZQ6 = parcelRequire("29ZQ6");

var $jqeH0 = parcelRequire("jqeH0");

var $sz9w8 = parcelRequire("sz9w8");

var $bLnbl = parcelRequire("bLnbl");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $7c07309b7c20a50b$var$neutral300 = '#DDDEE1';
const $7c07309b7c20a50b$var$red300 = '#FD9891';
const $7c07309b7c20a50b$var$blue300 = '#8FB8F6';
const $7c07309b7c20a50b$var$neutral1000 = '#292A2E';
const $7c07309b7c20a50b$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
const $7c07309b7c20a50b$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && typeof max === 'number' ? (0, $bLnbl.formatValueWithNegativeSupport)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $7c07309b7c20a50b$var$Badge = /*#__PURE__*/ (0, $8P7DW.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $e6Qdr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        const newAppearance = (0, $29ZQ6.appearanceMapping)[appearance];
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $sz9w8.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId,
            children: children
        });
    }
    const oldAppearance = (0, $jqeH0.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $8n1kL.default)([
            $7c07309b7c20a50b$var$styles.root,
            $7c07309b7c20a50b$var$styles[oldAppearance]
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $7c07309b7c20a50b$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $7c07309b7c20a50b$export$2e2bcd8739ae039 = $7c07309b7c20a50b$var$Badge;

});
parcelRegister("29ZQ6", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $12f4237fa8b0a215$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $12f4237fa8b0a215$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral'
};

});

parcelRegister("jqeH0", function(module, exports) {
$parcel$export(module.exports, "appearanceMappingToOld", () => $8fe42dda081c4e78$export$16f8cc7ac3541e83);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $8fe42dda081c4e78$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default'
};

});

parcelRegister("sz9w8", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee5993bb61f32bf5$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $9pb7J = parcelRequire("9pb7J");

var $dAZOa = parcelRequire("dAZOa");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
const $ee5993bb61f32bf5$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $ee5993bb61f32bf5$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $dAZOa.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */ const $ee5993bb61f32bf5$var$BadgeNew = /*#__PURE__*/ (0, $8P7DW.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $8n1kL.default)([
            $ee5993bb61f32bf5$var$stylesNew.root,
            $ee5993bb61f32bf5$var$stylesNew[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $ee5993bb61f32bf5$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $ee5993bb61f32bf5$export$2e2bcd8739ae039 = $ee5993bb61f32bf5$var$BadgeNew;

});
parcelRegister("dAZOa", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $7b7cc235cbb6e5d1$export$7c4d25c0c3217d8c);
function $7b7cc235cbb6e5d1$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $7b7cc235cbb6e5d1$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $7b7cc235cbb6e5d1$var$getSafeValue(value);
    const safeMax = $7b7cc235cbb6e5d1$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("bLnbl", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $6acf46009f315799$export$4b844743568d5983);
function $6acf46009f315799$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $6acf46009f315799$export$4b844743568d5983(value, max) {
    const safeValue = $6acf46009f315799$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $6acf46009f315799$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("lGzmI", function(module, exports) {
$parcel$export(module.exports, "useResizingWidth", () => $0047aa4bc0a64797$export$84c726b6114f53f8);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $jh41u = parcelRequire("jh41u");

var $htHd6 = parcelRequire("htHd6");

var $1c0tT = parcelRequire("1c0tT");

var $kgdFP = parcelRequire("kgdFP");

var $1JkUK = parcelRequire("1JkUK");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $0047aa4bc0a64797$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
const $0047aa4bc0a64797$export$84c726b6114f53f8 = ({ duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $8P7DW.useRef)();
    const [element, setElementRef] = (0, $1c0tT.useElementRef)();
    const setTimeout = (0, $htHd6.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $htHd6.useRequestAnimationFrame)();
    (0, $1JkUK.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jh41u.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $kgdFP.useLayoutEffect)(()=>{
        if ((0, $jh41u.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination width first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.width === prevDimensions.current.width) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        const newStyles = {
            width: `${prevDimensions.current.width}px`,
            willChange: 'width',
            transitionProperty: 'width',
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        Object.assign(element.style, newStyles);
        const resolvedDuration = $0047aa4bc0a64797$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.width = `${nextDimensions.width}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $0047aa4bc0a64797$export$5146a620d339842f = ({ children: children, ...props })=>{
    const resizing = $0047aa4bc0a64797$export$84c726b6114f53f8(props);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: children(resizing)
    });
};

});

parcelRegister("galRw", function(module, exports) {
$parcel$export(module.exports, "default", () => $3da1bdd72d798ca6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $aeYmt = parcelRequire("aeYmt");

var $5J6r2 = parcelRequire("5J6r2");

var $9uKqY = parcelRequire("9uKqY");

var $j4RVe = parcelRequire("j4RVe");

var $37U6z = parcelRequire("37U6z");
function $3da1bdd72d798ca6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $3da1bdd72d798ca6$var$focusRingStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $j4RVe.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $j4RVe.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $j4RVe.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $j4RVe.borderWidthMap)['border.width']} solid`
        }
    }
});
const $3da1bdd72d798ca6$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $3da1bdd72d798ca6$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $3da1bdd72d798ca6$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $3da1bdd72d798ca6$var$Pressable = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $5J6r2.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $8P7DW.useContext)((0, $9uKqY.default));
    const handleClick = (0, $8P7DW.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $37U6z.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $3da1bdd72d798ca6$var$baseStyles,
            $3da1bdd72d798ca6$var$focusRingStyles,
            isDisabled ? $3da1bdd72d798ca6$var$disabledStyles : $3da1bdd72d798ca6$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $j4RVe.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $j4RVe.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $j4RVe.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $j4RVe.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $j4RVe.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $j4RVe.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $j4RVe.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $j4RVe.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var $3da1bdd72d798ca6$export$2e2bcd8739ae039 = $3da1bdd72d798ca6$var$Pressable;

});

parcelRegister("ifgam", function(module, exports) {
$parcel$export(module.exports, "default", () => $002f2548bc691828$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $2CGHX = parcelRequire("2CGHX");
// Map lozenge colors to appropriate icon colors
const $002f2548bc691828$var$getIconColor = (color)=>{
    // For semantic colors, use corresponding semantic icon colors
    switch(color){
        case 'success':
            return "var(--ds-icon-success, #6A9A23)";
        case 'warning':
            return "var(--ds-icon-warning, #E06C00)";
        case 'danger':
            return "var(--ds-icon-danger, #C9372C)";
        case 'information':
            return "var(--ds-icon-information, #357DE8)";
        case 'neutral':
            return "var(--ds-icon-subtlest, #6B6E76)";
        case 'discovery':
            return "var(--ds-icon-discovery, #AF59E1)";
        // For accent colors, use corresponding accent icon colors
        case 'accent-red':
            return "var(--ds-icon-accent-red, #C9372C)";
        case 'accent-orange':
            return "var(--ds-icon-accent-orange, #E06C00)";
        case 'accent-yellow':
            return "var(--ds-icon-accent-yellow, #B38600)";
        case 'accent-lime':
            return "var(--ds-icon-accent-lime, #6A9A23)";
        case 'accent-green':
            return "var(--ds-icon-accent-green, #22A06B)";
        case 'accent-teal':
            return "var(--ds-icon-accent-teal, #2898BD)";
        case 'accent-blue':
            return "var(--ds-icon-accent-blue, #357DE8)";
        case 'accent-purple':
            return "var(--ds-icon-accent-purple, #AF59E1)";
        case 'accent-magenta':
            return "var(--ds-icon-accent-magenta, #CD519D)";
        case 'accent-gray':
            return "var(--ds-icon-accent-gray, #7D818A)";
        default:
            return "var(--ds-icon-subtlest, #6B6E76)";
    }
};
const $002f2548bc691828$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
const $002f2548bc691828$export$32ff197eed95e568 = ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $002f2548bc691828$var$getIconColor(color);
    return (0, $e6Qdr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        xcss: $002f2548bc691828$var$styles.motion,
        style: {
            color: iconColor
        },
        children: /*#__PURE__*/ (0, $gWgPx.jsx)(Icon, {
            label: "",
            size: size,
            testId: testId
        })
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var $002f2548bc691828$export$2e2bcd8739ae039 = $002f2548bc691828$export$32ff197eed95e568;

});

parcelRegister("4hEoM", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $cdb70971d101b39c$export$acf5d2b7dc999bda);
$parcel$export(module.exports, "getThemeStyles", () => $cdb70971d101b39c$export$a3fc04b8551e006a);
// Map legacy appearance to new color values
const $cdb70971d101b39c$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $cdb70971d101b39c$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $cdb70971d101b39c$var$legacyAppearanceMap[appearance] ?? appearance;
};
const $cdb70971d101b39c$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});




parcelRegister("4akUv", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc6fd3b34134f2eb$export$2e2bcd8739ae039);

var $jh41u = parcelRequire("jh41u");

var $41dEz = parcelRequire("41dEz");

var $htHd6 = parcelRequire("htHd6");

var $1c0tT = parcelRequire("1c0tT");

var $kgdFP = parcelRequire("kgdFP");

var $cBwgz = parcelRequire("cBwgz");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $dc6fd3b34134f2eb$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $1c0tT.useElementRef)();
    const exiting = (0, $cBwgz.useExitingPersistence)();
    const requestAnimationFrame = (0, $htHd6.useRequestAnimationFrame)();
    const setTimeout = (0, $htHd6.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $kgdFP.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $jh41u.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $41dEz.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $41dEz.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $dc6fd3b34134f2eb$export$2e2bcd8739ae039 = $dc6fd3b34134f2eb$var$ShrinkOut;

});

parcelRegister("7bEe7", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => $d5ac25b2d459a5f9$export$3351a8d90bcc13aa);
$parcel$export(module.exports, "default", () => $d5ac25b2d459a5f9$export$2e2bcd8739ae039);
/* tag-new.tsx generated by @compiled/babel-plugin v0.37.1 */ /* tag-new.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $cDQfx = parcelRequire("cDQfx");

var $bgvtM = parcelRequire("bgvtM");

var $cjn3r = parcelRequire("cjn3r");

var $39oJd = parcelRequire("39oJd");

var $1BdGL = parcelRequire("1BdGL");
// CSS variable name for icon color - must be used as literal string in cssMap due to Compiled CSS static analysis
const $d5ac25b2d459a5f9$var$iconColorVar = '--ds-tag-icon';
const $d5ac25b2d459a5f9$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};
const $d5ac25b2d459a5f9$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// Border and icon color styles - each color sets CSS variables for its token values
const $d5ac25b2d459a5f9$var$colorStyles = {
    gray: "_119b8yml _1ib21diz",
    blue: "_119b1w55 _1ib26txe",
    green: "_119b1crs _1ib217hp",
    red: "_119b16y8 _1ib2nbxb",
    yellow: "_119bfeiv _1ib21oqg",
    purple: "_119b1hqq _1ib2uq3u",
    lime: "_119bnf89 _1ib28645",
    magenta: "_119buwd0 _1ib2v8hk",
    orange: "_119b1b2s _1ib21j6y",
    teal: "_119b1h3o _1ib28uof"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ // Border + icon filter styles - base state
const $d5ac25b2d459a5f9$var$borderIconFilterStyles = {
    root: "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _m71tr3uz _168qx19p _wi6h1o1e _4uq11yqs _u8p61h4e _hg5mr3uz _1t75u67f _1f28f1ug _189qkb7n _1easrqqc _1knhjbtf"
};
// Border + icon filter styles - interactive states (hover/pressed)
const $d5ac25b2d459a5f9$var$borderIconInteractiveFilterStyles = {
    root: "_18dicjiy _hyog26zw _ylgq1r5k _bg3q9by0 _fdt01r5k _46v5hwvj _1iel6xdd _111i1h4e _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _196p1btq _18mn783i _4cvxpc7y _zqoikzix _q4zt1ij0 _ba351r2o _75gvn2k3 _kgu3swso _ui3h1vs5 _1r84p7hp"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ const $d5ac25b2d459a5f9$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ const $d5ac25b2d459a5f9$var$TagNewComponent = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function TagNew({ color: color = 'gray', text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, swatchBefore: swatchBefore, ...other }, ref) {
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $39oJd.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $8P7DW.useCallback)(()=>{
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(text);
    }, [
        onAfterRemoveAction,
        text
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $39oJd.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $39oJd.useButtonInteraction)();
    const removeButton = (0, $39oJd.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: text,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    const tagContent = /*#__PURE__*/ (0, $gWgPx.jsxs)("span", {
        ...other,
        ref: ref,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $8n1kL.default)([
            $d5ac25b2d459a5f9$var$styles.baseStyles,
            !hasMargin && $d5ac25b2d459a5f9$var$styles.noMarginStyles,
            $d5ac25b2d459a5f9$var$colorStyles[color],
            $d5ac25b2d459a5f9$var$borderIconFilterStyles.root,
            isLink && $d5ac25b2d459a5f9$var$styles.interactiveBaseStyles,
            isLink && $d5ac25b2d459a5f9$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $d5ac25b2d459a5f9$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $d5ac25b2d459a5f9$var$styles.interactiveHoverStyles,
            isRemovable && $d5ac25b2d459a5f9$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $d5ac25b2d459a5f9$var$styles.childFocusRingStyles
        ]),
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $39oJd.LinkWrapper), {
                isLink: isLink,
                href: href,
                LinkComponent: LinkComponent,
                testId: testId,
                linkHandlers: linkHandlers,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1BdGL.default), {
                        colorKey: color,
                        swatchBefore: swatchBefore
                    }),
                    elemBefore && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                        className: (0, $8n1kL.default)([
                            $d5ac25b2d459a5f9$var$styles.beforeStyles
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $8n1kL.default)([
                            $d5ac25b2d459a5f9$var$styles.textStyles
                        ]),
                        children: text
                    })
                ]
            }),
            removeButton && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                className: (0, $8n1kL.default)([
                    $d5ac25b2d459a5f9$var$styles.afterStyles
                ]),
                children: removeButton
            })
        ]
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $39oJd.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        children: tagContent
    });
});
const $d5ac25b2d459a5f9$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function TagDropdownTrigger({ color: color = 'gray', text: text, elemBefore: elemBefore, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, isSelected: isSelected = false, isLoading: isLoading = false, analyticsContext: _analyticsContext, hasChevron: hasChevron = true, swatchBefore: swatchBefore, ...other }, ref) {
    const resolvedColor = $d5ac25b2d459a5f9$export$3351a8d90bcc13aa[color] || 'gray';
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $bgvtM.default), {
        ref: ref,
        // @ts-expect-error paddingInline is 0.1875rem
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $82a6z.cx)($d5ac25b2d459a5f9$var$styles.baseStyles, !hasMargin && $d5ac25b2d459a5f9$var$styles.noMarginStyles, $d5ac25b2d459a5f9$var$colorStyles[resolvedColor], $d5ac25b2d459a5f9$var$borderIconFilterStyles.root, $d5ac25b2d459a5f9$var$borderIconInteractiveFilterStyles.root, isSelected && $d5ac25b2d459a5f9$var$dropdownStyles.selected),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        },
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "data-testid": testId,
        ...other,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsxs)("span", {
                className: (0, $8n1kL.default)([
                    $d5ac25b2d459a5f9$var$dropdownStyles.content,
                    isLoading && $d5ac25b2d459a5f9$var$dropdownStyles.loadingContent
                ]),
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1BdGL.default), {
                        colorKey: resolvedColor,
                        swatchBefore: swatchBefore
                    }),
                    elemBefore && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                        className: (0, $8n1kL.default)([
                            $d5ac25b2d459a5f9$var$styles.beforeStyles,
                            isSelected && $d5ac25b2d459a5f9$var$styles.beforeStylesSelected
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $8n1kL.default)([
                            $d5ac25b2d459a5f9$var$styles.textStyles,
                            isSelected && $d5ac25b2d459a5f9$var$styles.textStylesSelected
                        ]),
                        children: text
                    }),
                    hasChevron && /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
                        label: "",
                        size: "small",
                        color: 'currentColor',
                        testId: testId && `${testId}--chevron`
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                className: (0, $8n1kL.default)([
                    $d5ac25b2d459a5f9$var$dropdownStyles.loadingOverlay
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                    size: 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
});
/**
 * __Tag new__
 */ const $d5ac25b2d459a5f9$var$TagNew = /*#__PURE__*/ (0, $8P7DW.memo)($d5ac25b2d459a5f9$var$TagNewComponent);
var $d5ac25b2d459a5f9$export$2e2bcd8739ae039 = $d5ac25b2d459a5f9$var$TagNew;

});
parcelRegister("39oJd", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", () => $9c4aad9bfdb8121d$export$f26019543e9f862f);
$parcel$export(module.exports, "useLink", () => $9c4aad9bfdb8121d$export$dcf14c9974fe2767);
$parcel$export(module.exports, "useButtonInteraction", () => $9c4aad9bfdb8121d$export$84acd183858d8235);
$parcel$export(module.exports, "useRemoveButton", () => $9c4aad9bfdb8121d$export$97d8be09cd53869b);
$parcel$export(module.exports, "RemovableWrapper", () => $9c4aad9bfdb8121d$export$898a500849bb5cf4);
$parcel$export(module.exports, "LinkWrapper", () => $9c4aad9bfdb8121d$export$ce4b6a469c26f53f);
/* shared.tsx generated by @compiled/babel-plugin v0.37.1 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $5J6r2 = parcelRequire("5J6r2");

var $2XLqF = parcelRequire("2XLqF");

var $cBwgz = parcelRequire("cBwgz");
var $4akUv = parcelRequire("4akUv");

var $6sl31 = parcelRequire("6sl31");
const $9c4aad9bfdb8121d$export$203775b632e10448 = '--ds-tag-icon';
const $9c4aad9bfdb8121d$export$7d6deb4aa4b5840e = '--tag-border-token';
const $9c4aad9bfdb8121d$export$df7ff9c2f76bffcd = '--tag-icon-token';
var $9c4aad9bfdb8121d$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});
const $9c4aad9bfdb8121d$export$279e7025ed114474 = ()=>true;
const $9c4aad9bfdb8121d$export$8793edee2d425525 = (0, $5J6r2.default);
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ const $9c4aad9bfdb8121d$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
const $9c4aad9bfdb8121d$var$motionWrapperStyles = null;
function $9c4aad9bfdb8121d$export$f26019543e9f862f(onBeforeRemoveAction) {
    const [status, setStatus] = (0, $8P7DW.useState)("showing");
    const handleRemoveRequest = (0, $8P7DW.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction ?? $9c4aad9bfdb8121d$export$279e7025ed114474;
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus("removed");
    }, [
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $8P7DW.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $8P7DW.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $8P7DW.useCallback)(()=>setStatus("showing"), []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}
function $9c4aad9bfdb8121d$export$dcf14c9974fe2767(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent ?? (0, $2XLqF.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}
function $9c4aad9bfdb8121d$export$84acd183858d8235() {
    const [isLinkHovered, setIsLinkHovered] = (0, $8P7DW.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $8P7DW.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $8P7DW.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $8P7DW.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, $8P7DW.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, $8P7DW.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, $8P7DW.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}
function $9c4aad9bfdb8121d$export$97d8be09cd53869b({ isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: shape = 'default', buttonHandlers: buttonHandlers }) {
    const handleFocus = (0, $8P7DW.useCallback)(()=>{
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, $8P7DW.useCallback)(()=>{
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $8P7DW.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6sl31.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}
function $9c4aad9bfdb8121d$export$898a500849bb5cf4({ isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children }) {
    if (isRemovable) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBwgz.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4akUv.default), {
            onFinish: onShrinkOutExitComplete ? (phase)=>{
                if (phase === 'exiting') onShrinkOutExitComplete();
            } : undefined,
            children: (motion)=>/*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                    ref: motion.ref,
                    className: (0, $8n1kL.default)([
                        "_1e0c116y"
                    ]),
                    children: children
                })
        }, $9c4aad9bfdb8121d$var$removableShrinkOutChildKey)
    });
    return children;
}
function $9c4aad9bfdb8121d$export$ce4b6a469c26f53f({ isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, $gWgPx.jsx)(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur,
        children: children
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Fragment), {
        children: children
    });
}

});
parcelRegister("6sl31", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d1c41218be4941b$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.37.1 */ /* remove-button.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $6NJAV = parcelRequire("6NJAV");

var $b9hQ0 = parcelRequire("b9hQ0");

var $bgvtM = parcelRequire("bgvtM");
const $8d1c41218be4941b$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf"
};
const $8d1c41218be4941b$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $8d1c41218be4941b$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: shape = 'default' })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bgvtM.default), {
        xcss: (0, $6NJAV.cx)($8d1c41218be4941b$var$removeButtonStyles.root, shape === 'circle' && $8d1c41218be4941b$var$removeButtonStyles.circle, $8d1c41218be4941b$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8d1c41218be4941b$export$2e2bcd8739ae039 = $8d1c41218be4941b$var$RemoveButton;

});


parcelRegister("1BdGL", function(module, exports) {
$parcel$export(module.exports, "default", () => $02897fc58a9c9ea9$export$2e2bcd8739ae039);
/* swatch-before.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $02897fc58a9c9ea9$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
const $02897fc58a9c9ea9$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $02897fc58a9c9ea9$export$2e2bcd8739ae039({ colorKey: colorKey, swatchBefore: swatchBefore }) {
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        className: (0, $8n1kL.default)([
            $02897fc58a9c9ea9$var$tagSwatchBeforeStyles.swatch,
            $02897fc58a9c9ea9$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $8n1kL.default)([
            $02897fc58a9c9ea9$var$tagSwatchBeforeStyles.swatch
        ])
    });
}

});


parcelRegister("br21J", function(module, exports) {
$parcel$export(module.exports, "default", () => $02412b3e473f8db2$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
const $02412b3e473f8db2$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const $02412b3e473f8db2$var$baseStyles = null;
const $02412b3e473f8db2$var$interactiveStyles = null;
const $02412b3e473f8db2$var$focusRingStyles = null;
const $02412b3e473f8db2$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8n1kL.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $02412b3e473f8db2$var$borderColors[color],
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$02412b3e473f8db2$export$2e2bcd8739ae039 = $02412b3e473f8db2$var$BaseTag;

});

parcelRegister("hGyIy", function(module, exports) {
$parcel$export(module.exports, "default", () => $cecdb6be40385789$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $cecdb6be40385789$var$beforeElementStyles = null;
const $cecdb6be40385789$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        className: (0, $8n1kL.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cecdb6be40385789$export$2e2bcd8739ae039 = $cecdb6be40385789$var$Before;

});

parcelRegister("8qpee", function(module, exports) {
$parcel$export(module.exports, "getLozengeAppearance", () => $8e2a3b38de08d3d6$export$4d9e331cafeacb9d);
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ const $8e2a3b38de08d3d6$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $8e2a3b38de08d3d6$export$4d9e331cafeacb9d(color) {
    return $8e2a3b38de08d3d6$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

});

parcelRegister("8hzdg", function(module, exports) {
$parcel$export(module.exports, "default", () => $64e01620be4a61b8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $64e01620be4a61b8$var$baseStyles = null;
const $64e01620be4a61b8$var$linkStyles = null;
const $64e01620be4a61b8$var$hasAfterStyles = null;
const $64e01620be4a61b8$var$Content = ({ isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $gWgPx.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $8n1kL.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        className: (0, $8n1kL.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$64e01620be4a61b8$export$2e2bcd8739ae039 = $64e01620be4a61b8$var$Content;

});


parcelRegister("7I3Hf", function(module, exports) {
$parcel$export(module.exports, "MultiValueLabel", () => $0ecada61e26f2996$export$544aeea2a5ce08ee);
/* multi-value-label.tsx generated by @compiled/babel-plugin v0.37.1 */ /* multi-value-label.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");
const $0ecada61e26f2996$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
const $0ecada61e26f2996$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $0ecada61e26f2996$var$multiValueLabelStyles.root,
            isDisabled && $0ecada61e26f2996$var$multiValueLabelStyles.disabled,
            hasEllipsis && $0ecada61e26f2996$var$multiValueLabelStyles.ellipsis,
            (0, $82a6z.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};

});


parcelRegister("5XFSX", function(module, exports) {
$parcel$export(module.exports, "MultiValueRemove", () => $9205958e6fac5b0b$export$8e1fd1a40e7a2f4a);
/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.37.1 */ /* multi-value-remove.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $b9hQ0 = parcelRequire("b9hQ0");
const $9205958e6fac5b0b$var$disabledStyles = null;
const $9205958e6fac5b0b$var$enabledStyles = null;
const $9205958e6fac5b0b$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $9205958e6fac5b0b$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $9205958e6fac5b0b$var$multiValueRemoveStyles.root,
            isFocused && $9205958e6fac5b0b$var$multiValueRemoveStyles.focused,
            (0, $82a6z.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $8n1kL.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
}

});

parcelRegister("fxnld", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad31652dfd8c4c00$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.37.1 */ /* option.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $7rFBw = parcelRequire("7rFBw");
const $ad31652dfd8c4c00$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
const $ad31652dfd8c4c00$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $ad31652dfd8c4c00$var$optionStyles.root,
            isFocused && $ad31652dfd8c4c00$var$optionStyles.focused,
            isSelected && $ad31652dfd8c4c00$var$optionStyles.selected,
            isFocused && isSelected && $ad31652dfd8c4c00$var$optionStyles.focusedSelected,
            isDisabled && $ad31652dfd8c4c00$var$optionStyles.disabled,
            (0, $82a6z.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ad31652dfd8c4c00$export$2e2bcd8739ae039 = $ad31652dfd8c4c00$var$Option;

});

parcelRegister("dWGr5", function(module, exports) {
$parcel$export(module.exports, "default", () => $217bdffd12e4a675$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.37.1 */ /* placeholder.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $7rFBw = parcelRequire("7rFBw");
const $217bdffd12e4a675$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
const $217bdffd12e4a675$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $217bdffd12e4a675$var$placeholderStyles.root,
            isDisabled && $217bdffd12e4a675$var$placeholderStyles.disabled,
            (0, $82a6z.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$217bdffd12e4a675$export$2e2bcd8739ae039 = $217bdffd12e4a675$var$Placeholder;

});

parcelRegister("6YFjC", function(module, exports) {
$parcel$export(module.exports, "default", () => $db790b63e404249b$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.37.1 */ /* single-value.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $82a6z = parcelRequire("82a6z");

var $7rFBw = parcelRequire("7rFBw");
const $db790b63e404249b$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
const $db790b63e404249b$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $7rFBw.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $8n1kL.default)([
            $db790b63e404249b$var$styles.root,
            isDisabled && $db790b63e404249b$var$styles.disalbed,
            (0, $82a6z.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db790b63e404249b$export$2e2bcd8739ae039 = $db790b63e404249b$var$SingleValue;

});


parcelRegister("lBvbm", function(module, exports) {
$parcel$export(module.exports, "default", () => $861e4ef27c1ab1e9$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $861e4ef27c1ab1e9$var$removeProps = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $861e4ef27c1ab1e9$var$dummyInputStyles = null;
function $861e4ef27c1ab1e9$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = $861e4ef27c1ab1e9$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
        ref: innerRef,
        className: (0, $8n1kL.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("dWIs3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6538a8db7251435b$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $91FN1 = parcelRequire("91FN1");

var $d3H7U = parcelRequire("d3H7U");
const $6538a8db7251435b$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $8P7DW.useMemo)(()=>({
            ...(0, $91FN1.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $8P7DW.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $8P7DW.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $d3H7U.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $d3H7U.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6538a8db7251435b$export$2e2bcd8739ae039 = $6538a8db7251435b$var$LiveRegion;

});
parcelRegister("91FN1", function(module, exports) {
$parcel$export(module.exports, "defaultAriaLiveMessages", () => $1e4b5e0ef40fe863$export$a7265767c78f9bae);
const $1e4b5e0ef40fe863$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("d3H7U", function(module, exports) {
$parcel$export(module.exports, "default", () => $05f99d891d185a3a$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.37.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $05f99d891d185a3a$var$styles = null;
const $05f99d891d185a3a$var$A11yText = (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8n1kL.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $05f99d891d185a3a$export$2e2bcd8739ae039 = $05f99d891d185a3a$var$A11yText;

});


parcelRegister("h2Ohb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0621ad5208a38622$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $5J6r2 = parcelRequire("5J6r2");

var $jAV1Z = parcelRequire("jAV1Z");
const $0621ad5208a38622$var$noop = (0, $5J6r2.default);
function $0621ad5208a38622$var$getScrollParent(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $0621ad5208a38622$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $0621ad5208a38622$var$normalizedHeight(el) {
    if ($0621ad5208a38622$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $0621ad5208a38622$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($0621ad5208a38622$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $0621ad5208a38622$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $0621ad5208a38622$var$getScrollTop(el) {
    if ($0621ad5208a38622$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $0621ad5208a38622$var$animatedScrollTo(element, to, duration = 200, callback = $0621ad5208a38622$var$noop) {
    const start = $0621ad5208a38622$var$getScrollTop(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $0621ad5208a38622$var$easeOutCubic(currentTime, start, change, duration);
        $0621ad5208a38622$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $0621ad5208a38622$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = $0621ad5208a38622$var$getScrollParent(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : $0621ad5208a38622$var$normalizedHeight(scrollParent);
    const scrollTop = $0621ad5208a38622$var$getScrollTop(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $0621ad5208a38622$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $0621ad5208a38622$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $0621ad5208a38622$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $0621ad5208a38622$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $0621ad5208a38622$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $0621ad5208a38622$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $0621ad5208a38622$var$MenuPlacer = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $8P7DW.useContext)((0, $jAV1Z.PortalPlacementContext)) || {};
    const ref = (0, $8P7DW.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $8P7DW.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $8P7DW.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $8P7DW.useLayoutEffect)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $0621ad5208a38622$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $0621ad5208a38622$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
var $0621ad5208a38622$export$2e2bcd8739ae039 = $0621ad5208a38622$var$MenuPlacer;

});

parcelRegister("5GBJ9", function(module, exports) {
$parcel$export(module.exports, "createFilter", () => $616e20d4908f661b$export$5d81789ff4aeccdf);

var $hXXvg = parcelRequire("hXXvg");

var $bLhYb = parcelRequire("bLhYb");
const $616e20d4908f661b$var$memoizedStripDiacriticsForInput = (0, $hXXvg.default)((0, $bLhYb.stripDiacritics));
const $616e20d4908f661b$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $616e20d4908f661b$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $616e20d4908f661b$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $616e20d4908f661b$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $616e20d4908f661b$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $616e20d4908f661b$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $616e20d4908f661b$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $bLhYb.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("bLhYb", function(module, exports) {
$parcel$export(module.exports, "stripDiacritics", () => $bb57b68322f5fdc6$export$b5bee4b27048330b);
const $bb57b68322f5fdc6$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $bb57b68322f5fdc6$var$anyDiacritic = new RegExp('[' + $bb57b68322f5fdc6$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $bb57b68322f5fdc6$var$diacriticToBase = {};
for(let i = 0; i < $bb57b68322f5fdc6$var$diacritics.length; i++){
    let diacritic = $bb57b68322f5fdc6$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$bb57b68322f5fdc6$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $bb57b68322f5fdc6$export$b5bee4b27048330b = (str)=>{
    return str.replace($bb57b68322f5fdc6$var$anyDiacritic, (match)=>$bb57b68322f5fdc6$var$diacriticToBase[match]);
};

});


parcelRegister("dgzm0", function(module, exports) {
$parcel$export(module.exports, "classNames", () => $e43e554ee8df6095$export$ce4ab0c55987d1ff);
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $e43e554ee8df6095$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e43e554ee8df6095$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$e43e554ee8df6095$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}

});

parcelRegister("labMK", function(module, exports) {
$parcel$export(module.exports, "cleanValue", () => $fe53432d8896e5a5$export$33f062f47f21a01);
const $fe53432d8896e5a5$export$33f062f47f21a01 = (value)=>{
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};

});

parcelRegister("1KXqR", function(module, exports) {
$parcel$export(module.exports, "isDocumentElement", () => $e970612b6b6efe84$export$d8a62a489b442872);
function $e970612b6b6efe84$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}

});

parcelRegister("h2GlC", function(module, exports) {
$parcel$export(module.exports, "multiValueAsValue", () => $0947763666b70db6$export$d1ca752ec761b95b);
function $0947763666b70db6$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}

});

parcelRegister("j5TAI", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $06218dbf7724d456$export$17baa7c95b6ba1b8);

var $egphw = parcelRequire("egphw");
function $06218dbf7724d456$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $egphw.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("ksvdP", function(module, exports) {
$parcel$export(module.exports, "default", () => $54ff491aa23e26bf$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $5J6r2 = parcelRequire("5J6r2");
const $54ff491aa23e26bf$var$styles = null;
const $54ff491aa23e26bf$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $gWgPx.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8n1kL.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $5J6r2.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$54ff491aa23e26bf$export$2e2bcd8739ae039 = $54ff491aa23e26bf$var$RequiredInput;

});

parcelRegister("9fpoh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4839fbe473d57a9$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $2yaus = parcelRequire("2yaus");

var $5Y868 = parcelRequire("5Y868");
const $d4839fbe473d57a9$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $d4839fbe473d57a9$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $2yaus.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $5Y868.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                onClick: $d4839fbe473d57a9$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("2yaus", function(module, exports) {
$parcel$export(module.exports, "default", () => $13c356a181b05ad8$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $juQsf = parcelRequire("juQsf");
const $13c356a181b05ad8$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $13c356a181b05ad8$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $8P7DW.useRef)(false);
    const isTop = (0, $8P7DW.useRef)(false);
    const touchStart = (0, $8P7DW.useRef)(0);
    const scrollTarget = (0, $8P7DW.useRef)(null);
    const handleEventDelta = (0, $8P7DW.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $13c356a181b05ad8$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $8P7DW.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $8P7DW.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $8P7DW.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $8P7DW.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $juQsf.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $8P7DW.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});
parcelRegister("juQsf", function(module, exports) {
$parcel$export(module.exports, "supportsPassiveEvents", () => $bd8475abdb532dd7$export$b0622a6911dbeaf5);
// ==============================
// Passive Event Detector
// ==============================

var $5J6r2 = parcelRequire("5J6r2");
const $bd8475abdb532dd7$var$noop = (0, $5J6r2.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $bd8475abdb532dd7$var$passiveOptionAccessed = false;
const $bd8475abdb532dd7$var$options = {
    get passive () {
        return $bd8475abdb532dd7$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $bd8475abdb532dd7$var$w = typeof window !== 'undefined' ? window : {};
if ($bd8475abdb532dd7$var$w.addEventListener && $bd8475abdb532dd7$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $bd8475abdb532dd7$var$w.addEventListener('p', $bd8475abdb532dd7$var$noop, $bd8475abdb532dd7$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $bd8475abdb532dd7$var$w.removeEventListener('p', $bd8475abdb532dd7$var$noop, false);
}
const $bd8475abdb532dd7$export$b0622a6911dbeaf5 = $bd8475abdb532dd7$var$passiveOptionAccessed;

});


parcelRegister("5Y868", function(module, exports) {
$parcel$export(module.exports, "default", () => $766ac4906cdc87d1$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $766ac4906cdc87d1$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $766ac4906cdc87d1$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $766ac4906cdc87d1$var$preventTouchMove(e) {
    e.preventDefault();
}
function $766ac4906cdc87d1$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $766ac4906cdc87d1$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $766ac4906cdc87d1$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $766ac4906cdc87d1$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $766ac4906cdc87d1$var$activeScrollLocks = 0;
const $766ac4906cdc87d1$var$listenerOptions = {
    capture: false,
    passive: false
};
function $766ac4906cdc87d1$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $8P7DW.useRef)({});
    const scrollTarget = (0, $8P7DW.useRef)(null);
    const addScrollLock = (0, $8P7DW.useCallback)((touchScrollTarget)=>{
        if (!$766ac4906cdc87d1$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $766ac4906cdc87d1$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $766ac4906cdc87d1$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($766ac4906cdc87d1$var$LOCK_STYLES).forEach((key)=>{
                const val = $766ac4906cdc87d1$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $766ac4906cdc87d1$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $766ac4906cdc87d1$var$preventTouchMove, $766ac4906cdc87d1$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $766ac4906cdc87d1$var$preventInertiaScroll, $766ac4906cdc87d1$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $766ac4906cdc87d1$var$allowTouchMove, $766ac4906cdc87d1$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $766ac4906cdc87d1$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $8P7DW.useCallback)((touchScrollTarget)=>{
        if (!$766ac4906cdc87d1$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $766ac4906cdc87d1$var$activeScrollLocks = Math.max($766ac4906cdc87d1$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $766ac4906cdc87d1$var$activeScrollLocks < 1) $766ac4906cdc87d1$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $766ac4906cdc87d1$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $766ac4906cdc87d1$var$preventTouchMove, $766ac4906cdc87d1$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $766ac4906cdc87d1$var$preventInertiaScroll, $766ac4906cdc87d1$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $766ac4906cdc87d1$var$allowTouchMove, $766ac4906cdc87d1$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("bxRcO", function(module, exports) {
$parcel$export(module.exports, "scrollTo", () => $bd5991d7ed527f62$export$3f99968195accfaf);

var $1KXqR = parcelRequire("1KXqR");
function $bd5991d7ed527f62$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $1KXqR.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}

});

parcelRegister("9DJ5e", function(module, exports) {
$parcel$export(module.exports, "singleValueAsValue", () => $a1dbb64dff632bc8$export$dea4763e29237f4c);
function $a1dbb64dff632bc8$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}

});

parcelRegister("LCqac", function(module, exports) {
$parcel$export(module.exports, "valueTernary", () => $470c1edf1f68fd02$export$40fb9515c784cc3b);
function $470c1edf1f68fd02$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}

});


parcelRegister("6A2cj", function(module, exports) {
$parcel$export(module.exports, "default", () => $80643cca1e1ee201$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $80643cca1e1ee201$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $80643cca1e1ee201$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $8P7DW.useRef)(undefined);
    const mounted = (0, $8P7DW.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $8P7DW.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $8P7DW.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $8P7DW.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $8P7DW.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $8P7DW.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $8P7DW.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $8P7DW.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $8P7DW.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $8P7DW.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $8P7DW.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $8P7DW.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $8P7DW.useCallback)((newValue, actionMeta)=>{
        const inputValue = $80643cca1e1ee201$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("ZSWqE", function(module, exports) {
$parcel$export(module.exports, "default", () => $52b00127dc644e21$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $52b00127dc644e21$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $8P7DW.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $8P7DW.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $8P7DW.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $8P7DW.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $8P7DW.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $8P7DW.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $8P7DW.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("lJoiq", function(module, exports) {
$parcel$export(module.exports, "ClearSelectedItemsButton", () => $8c0c60b59e1c5383$export$1d4b7cda9e589b53);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");

var $ifRQf = parcelRequire("ifRQf");

var $6m1kv = parcelRequire("6m1kv");
const $8c0c60b59e1c5383$export$1d4b7cda9e589b53 = ({ onClear: onClear /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClearSelectedItems = (0, $8P7DW.useCallback)(()=>{
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchClearSelectedItems',
        //   createAnalyticsEvent,
        //   type,
        // });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
            ...(0, $6m1kv.default).clearAllSelectedItemsButtonText
        })
    });
};
var $8c0c60b59e1c5383$export$2e2bcd8739ae039 = $8c0c60b59e1c5383$export$1d4b7cda9e589b53;

});
parcelRegister("fiikg", function(module, exports) {
$parcel$export(module.exports, "default", () => $02df97c074d725ac$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $cs9kf = parcelRequire("cs9kf");

var $k7INq = parcelRequire("k7INq");
function $02df97c074d725ac$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $26Yns.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $26Yns.__rest)(nextProps, [
        "values"
    ]);
    return (0, $cs9kf.shallowEqual)(nextValues, values) && (0, $cs9kf.shallowEqual)(otherProps, nextOtherProps);
}
function $02df97c074d725ac$var$FormattedMessage(props) {
    var intl = (0, $k7INq.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $8P7DW.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $8P7DW.createElement(Component, null, $8P7DW.Children.toArray(nodes));
    return $8P7DW.createElement($8P7DW.Fragment, null, nodes);
}
$02df97c074d725ac$var$FormattedMessage.displayName = 'FormattedMessage';
var $02df97c074d725ac$var$MemoizedFormattedMessage = $8P7DW.memo($02df97c074d725ac$var$FormattedMessage, $02df97c074d725ac$var$areEqual);
$02df97c074d725ac$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $02df97c074d725ac$export$2e2bcd8739ae039 = $02df97c074d725ac$var$MemoizedFormattedMessage;

});

parcelRegister("6m1kv", function(module, exports) {
$parcel$export(module.exports, "default", () => $431493fa2caed1db$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $431493fa2caed1db$var$_default_1 = (0, $6K2Gm.defineMessages)({
    clearAllSelectedItemsButtonText: {
        id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
        defaultMessage: 'Clear selection',
        description: 'Clicking this button will unselect all the selected items in the dropdown'
    }
});
var $431493fa2caed1db$export$2e2bcd8739ae039 = $431493fa2caed1db$var$_default_1;

});
parcelRegister("6K2Gm", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $4e891e9d8ef6d112$export$1adfeb024f5185b);
$parcel$export(module.exports, "FormattedDate", () => $4e891e9d8ef6d112$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedNumber", () => $4e891e9d8ef6d112$export$db80edc1e6b2f63d);

var $j60ab = parcelRequire("j60ab");

var $3SD6z = parcelRequire("3SD6z");

var $k7INq = parcelRequire("k7INq");

var $33yvY = parcelRequire("33yvY");

var $gKOzK = parcelRequire("gKOzK");

var $5Txl8 = parcelRequire("5Txl8");

var $f8HJx = parcelRequire("f8HJx");

var $fiikg = parcelRequire("fiikg");

var $e2JVa = parcelRequire("e2JVa");

var $8yAcb = parcelRequire("8yAcb");
var $c4tEl = parcelRequire("c4tEl");
function $4e891e9d8ef6d112$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $4e891e9d8ef6d112$export$747d244ee58120dd(msg) {
    return msg;
}
var $4e891e9d8ef6d112$export$40ae3194919d16b = (0, $j60ab.createFormattedComponent)('formatDate');
var $4e891e9d8ef6d112$export$5b390a54f8a846f7 = (0, $j60ab.createFormattedComponent)('formatTime');
var $4e891e9d8ef6d112$export$db80edc1e6b2f63d = (0, $j60ab.createFormattedComponent)('formatNumber');
var $4e891e9d8ef6d112$export$f52b44e459e6e71d = (0, $j60ab.createFormattedComponent)('formatList');
var $4e891e9d8ef6d112$export$c2336ea5aaab92fa = (0, $j60ab.createFormattedComponent)('formatDisplayName');
var $4e891e9d8ef6d112$export$7fdc7d2c91ce149b = (0, $j60ab.createFormattedDateTimePartsComponent)('formatDate');
var $4e891e9d8ef6d112$export$ec35873761676c2a = (0, $j60ab.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("j60ab", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $de6eb446c832ebc8$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $de6eb446c832ebc8$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $de6eb446c832ebc8$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $de6eb446c832ebc8$export$b37e14176d001dec);

var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");
var $de6eb446c832ebc8$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($de6eb446c832ebc8$var$DisplayName || ($de6eb446c832ebc8$var$DisplayName = {}));
var $de6eb446c832ebc8$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($de6eb446c832ebc8$var$DisplayNameParts || ($de6eb446c832ebc8$var$DisplayNameParts = {}));
var $de6eb446c832ebc8$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $k7INq.default)();
    var value = props.value, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$de6eb446c832ebc8$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $de6eb446c832ebc8$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $k7INq.default)();
    var value = props.value, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$de6eb446c832ebc8$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $de6eb446c832ebc8$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $k7INq.default)();
        var value = props.value, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $de6eb446c832ebc8$var$DisplayNameParts[name];
    return ComponentParts;
}
function $de6eb446c832ebc8$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $k7INq.default)();
        var value = props.value, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $8P7DW.Fragment;
        return $8P7DW.createElement(Text, null, formattedValue);
    };
    Component.displayName = $de6eb446c832ebc8$var$DisplayName[name];
    return Component;
}

});

parcelRegister("5Txl8", function(module, exports) {
$parcel$export(module.exports, "default", () => $44abf36c792846e1$export$2e2bcd8739ae039);

var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $8XGMf = parcelRequire("8XGMf");

var $k7INq = parcelRequire("k7INq");
var $44abf36c792846e1$var$MINUTE = 60;
var $44abf36c792846e1$var$HOUR = 3600;
var $44abf36c792846e1$var$DAY = 86400;
function $44abf36c792846e1$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $44abf36c792846e1$var$MINUTE) return 'second';
    if (absValue < $44abf36c792846e1$var$HOUR) return 'minute';
    if (absValue < $44abf36c792846e1$var$DAY) return 'hour';
    return 'day';
}
function $44abf36c792846e1$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $44abf36c792846e1$var$MINUTE;
        case 'hour':
            return $44abf36c792846e1$var$HOUR;
        default:
            return $44abf36c792846e1$var$DAY;
    }
}
function $44abf36c792846e1$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $44abf36c792846e1$var$MINUTE;
        default:
            return value * $44abf36c792846e1$var$HOUR;
    }
}
var $44abf36c792846e1$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $44abf36c792846e1$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $44abf36c792846e1$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $44abf36c792846e1$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $k7INq.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $26Yns.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $8P7DW.createElement(Text, null, formattedRelativeTime);
    return $8P7DW.createElement($8P7DW.Fragment, null, formattedRelativeTime);
};
var $44abf36c792846e1$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $26Yns.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $8XGMf.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $44abf36c792846e1$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $8P7DW.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $8P7DW.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $8P7DW.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($44abf36c792846e1$var$canIncrement(unit) ? $44abf36c792846e1$var$valueToSeconds(value, unit) : 0);
    }
    $8P7DW.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$44abf36c792846e1$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $44abf36c792846e1$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $44abf36c792846e1$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($44abf36c792846e1$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $44abf36c792846e1$var$selectUnit(currentValueInSeconds);
        var unitDuration = $44abf36c792846e1$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $8P7DW.createElement($44abf36c792846e1$var$SimpleFormattedRelativeTime, (0, $26Yns.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$44abf36c792846e1$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $44abf36c792846e1$export$2e2bcd8739ae039 = $44abf36c792846e1$var$FormattedRelativeTime;

});

parcelRegister("f8HJx", function(module, exports) {
$parcel$export(module.exports, "default", () => $b05986f20218e13a$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");
var $b05986f20218e13a$var$FormattedPlural = function(props) {
    var _a = (0, $k7INq.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $8P7DW.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$b05986f20218e13a$var$FormattedPlural.displayName = 'FormattedPlural';
var $b05986f20218e13a$export$2e2bcd8739ae039 = $b05986f20218e13a$var$FormattedPlural;

});

parcelRegister("e2JVa", function(module, exports) {
$parcel$export(module.exports, "default", () => $a394df899f92fbdb$export$2e2bcd8739ae039);

var $26Yns = parcelRequire("26Yns");

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");
var $a394df899f92fbdb$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $k7INq.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $26Yns.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $8P7DW.Fragment;
    return $8P7DW.createElement(Text, null, formattedValue);
};
$a394df899f92fbdb$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $a394df899f92fbdb$export$2e2bcd8739ae039 = $a394df899f92fbdb$var$FormattedDateTimeRange;

});




parcelRegister("chIjS", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $fbcb6032d3a52920$export$d4c4e98c5044dc8);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $goA3W = parcelRequire("goA3W");

var $cjn3r = parcelRequire("cjn3r");

var $bq7Il = parcelRequire("bq7Il");

var $5W2sY = parcelRequire("5W2sY");

var $fPL8x = parcelRequire("fPL8x");

var $9QDEB = parcelRequire("9QDEB");
const $fbcb6032d3a52920$export$d4c4e98c5044dc8 = (props)=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const [clickCount, setClickCount] = (0, $8P7DW.useState)(1);
    const { selectProps: { //@ts-ignore react-select unsupported props
    menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, showShowMoreButton: showShowMoreButton } } } = props;
    const handleOnShowMore = (0, $8P7DW.useCallback)(()=>{
        setClickCount(clickCount + 1);
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchShowMore',
        //   createAnalyticsEvent,
        //   type,
        //   clickCount,
        // });
        handleShowMore();
    }, [
        clickCount,
        handleShowMore
    ]);
    if (isLoading && clickCount > 1) setClickCount(1);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $goA3W.components).MenuList, {
        ...props,
        children: isLoading ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $5W2sY.LoadingMessage), {}) : isError ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bq7Il.default), {
            onRetry: onRetry
        }) : /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
            children: [
                props.children,
                isPaginationLoading ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9QDEB.LoadingWrapper), {
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {})
                }) : showShowMoreButton && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fPL8x.default), {
                    onShowMore: handleOnShowMore
                })
            ]
        })
    });
};
var $fbcb6032d3a52920$export$2e2bcd8739ae039 = $fbcb6032d3a52920$export$d4c4e98c5044dc8;

});
parcelRegister("bq7Il", function(module, exports) {
$parcel$export(module.exports, "default", () => $03a02cc86c8aaf06$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");

var $ifRQf = parcelRequire("ifRQf");

var $h82Rb = parcelRequire("h82Rb");

var $gel9g = parcelRequire("gel9g");

var $7HWeV = parcelRequire("7HWeV");
const $03a02cc86c8aaf06$var$ErrorMessage = ({ onRetry: onRetry })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClick = (0, $8P7DW.useCallback)(()=>{
        onRetry === null || onRetry === void 0 || onRetry();
    // fireOperationalAnalytics(
    //   createAnalyticsEvent({}),
    //   'refinementBarSelectRetry clicked',
    // );
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gel9g.StyledBox), {
        height: 144,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gel9g.StyledBox), {
                height: 72,
                iconSize: 72,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
                    spacing: "spacious",
                    color: "var(--ds-icon-subtle, #505258)",
                    label: ""
                })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gel9g.StyledText), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                    ...(0, $7HWeV.default).errorMessage
                })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                onClick: onClick,
                appearance: "link",
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                    ...(0, $7HWeV.default).retryMessage
                })
            })
        ]
    });
};
var $03a02cc86c8aaf06$export$2e2bcd8739ae039 = $03a02cc86c8aaf06$var$ErrorMessage;

});
parcelRegister("gel9g", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicatorWrapper", () => $28a160f7ff685927$export$30c615a45297e297);
$parcel$export(module.exports, "StyledBox", () => $28a160f7ff685927$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $28a160f7ff685927$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $28a160f7ff685927$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $28a160f7ff685927$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $28a160f7ff685927$export$6833d6d22987ee7f);
$parcel$export(module.exports, "StyledInvalidCheckboxOption", () => $28a160f7ff685927$export$e786733cafde97b9);
/* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766 */ 
var $9pmZe = parcelRequire("9pmZe");
const $28a160f7ff685927$export$30c615a45297e297 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-12oo4m7-0"
})({
    marginRight: "var(--ds-space-025, 2px)",
    textAlign: 'center',
    width: '32px'
});
const $28a160f7ff685927$export$d675f139b342d51a = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-12oo4m7-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${props.height || 128}px`,
        justifyContent: 'center'
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ iconSize: iconSize })=>iconSize ? `svg {
          width: ${iconSize}px;
          height: ${iconSize}px;
        }` : '');
const $28a160f7ff685927$export$31ea92f3997410dd = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-12oo4m7-2"
})({
    font: "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginTop: "var(--ds-space-100, 8px)"
});
const $28a160f7ff685927$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-12oo4m7-3"
})({
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    display: 'flex',
    padding: "var(--ds-space-050, 4px)"
});
const $28a160f7ff685927$export$94756becb802e330 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-12oo4m7-4"
})({
    cursor: 'pointer',
    color: "var(--ds-text-subtlest, #6B6E76)",
    '&:hover, &:focus': {
        color: "var(--ds-text-subtle, #505258)"
    }
});
const $28a160f7ff685927$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-12oo4m7-5"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.displayFlag ? 'block' : 'none'
    }));
const $28a160f7ff685927$export$e786733cafde97b9 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-12oo4m7-6"
})({
    backgroundColor: "var(--ds-background-danger, #FFECEB)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        backgroundColor: 'inherit !important'
    }
});

});

parcelRegister("7HWeV", function(module, exports) {
$parcel$export(module.exports, "default", () => $48ae9722d011ab42$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $48ae9722d011ab42$var$_default_1 = (0, $6K2Gm.defineMessages)({
    errorMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.error-message',
        defaultMessage: "Couldn't retrieve data",
        description: 'The text for when an error occurs when loading options'
    },
    retryMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.retry-message',
        defaultMessage: 'Click to retry',
        description: 'The text for button to reload options'
    }
});
var $48ae9722d011ab42$export$2e2bcd8739ae039 = $48ae9722d011ab42$var$_default_1;

});


parcelRegister("5W2sY", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $c3d9206dc6dc23c6$export$e928a71d039d3102);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");

var $cjn3r = parcelRequire("cjn3r");

var $gel9g = parcelRequire("gel9g");

var $hH3sF = parcelRequire("hH3sF");
const $c3d9206dc6dc23c6$export$e928a71d039d3102 = ()=>/*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gel9g.StyledBox), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gel9g.StyledBox), {
                height: 72,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                    size: "large"
                })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gel9g.StyledText), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                    ...(0, $hH3sF.default).loadingMessage
                })
            })
        ]
    });

});
parcelRegister("hH3sF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3faaba4a53809019$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $3faaba4a53809019$var$_default_1 = (0, $6K2Gm.defineMessages)({
    loadingMessage: {
        id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
        defaultMessage: 'Loading...',
        description: 'The text for when options are being loaded in dropdown'
    }
});
var $3faaba4a53809019$export$2e2bcd8739ae039 = $3faaba4a53809019$var$_default_1;

});


parcelRegister("fPL8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $4705b25eef9a5d7d$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");

var $ifRQf = parcelRequire("ifRQf");

var $aQFms = parcelRequire("aQFms");
const $4705b25eef9a5d7d$var$ShowMoreButton = ({ onShowMore: onShowMore })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
        onClick: onShowMore,
        appearance: "link",
        testId: "paginated-picker.ui.async-select.menu-list.show-more-button",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
            ...(0, $aQFms.default).showMoreButtonText
        })
    });
var $4705b25eef9a5d7d$export$2e2bcd8739ae039 = $4705b25eef9a5d7d$var$ShowMoreButton;

});
parcelRegister("aQFms", function(module, exports) {
$parcel$export(module.exports, "default", () => $c864d758f4f92ee1$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $c864d758f4f92ee1$var$_default_1 = (0, $6K2Gm.defineMessages)({
    showMoreButtonText: {
        id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
        defaultMessage: 'Show more',
        description: 'Clicking this button will load more items into the dropdown'
    }
});
var $c864d758f4f92ee1$export$2e2bcd8739ae039 = $c864d758f4f92ee1$var$_default_1;

});


parcelRegister("9QDEB", function(module, exports) {
$parcel$export(module.exports, "LoadingWrapper", () => $47ad3184a54d3bd3$export$43a792a870d28db2);

var $9pmZe = parcelRequire("9pmZe");
const $47ad3184a54d3bd3$export$43a792a870d28db2 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-8ouqtd-0"
})({
    display: 'flex',
    justifyContent: 'center',
    margin: `${"var(--ds-space-050, 4px)"} 0`
});

});


parcelRegister("4DeoM", function(module, exports) {
$parcel$export(module.exports, "PaginationDetails", () => $8f7dd2b15fc55b30$export$33eb0288c0936a84);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");

var $6Pqz5 = parcelRequire("6Pqz5");

var $2qMv5 = parcelRequire("2qMv5");
const $8f7dd2b15fc55b30$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2qMv5.PaginationDetailsStyled), {
        "data-testid": "paginated-picker.ui.async-select.pagination-details",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
            ...(0, $6Pqz5.default).ofTotalCount,
            values: {
                itemsCount: itemsCount,
                totalCount: totalCount
            }
        })
    });
var $8f7dd2b15fc55b30$export$2e2bcd8739ae039 = $8f7dd2b15fc55b30$export$33eb0288c0936a84;

});
parcelRegister("6Pqz5", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e0d613a84232a60$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $9e0d613a84232a60$var$_default_1 = (0, $6K2Gm.defineMessages)({
    ofTotalCount: {
        id: 'paginated-picker.async-select.pagination-details.of-total-count',
        defaultMessage: '{itemsCount} of {totalCount}',
        description: 'Total count of items.'
    }
});
var $9e0d613a84232a60$export$2e2bcd8739ae039 = $9e0d613a84232a60$var$_default_1;

});

parcelRegister("2qMv5", function(module, exports) {
$parcel$export(module.exports, "PaginationDetailsStyled", () => $ac3d73562df9da8f$export$fff9218028c24180);

var $9pmZe = parcelRequire("9pmZe");
const $ac3d73562df9da8f$export$fff9218028c24180 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-2jljtl-0"
})({
    flex: 1,
    textAlign: 'right',
    margin: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-subtlest, #6B6E76)"
});

});


parcelRegister("511tG", function(module, exports) {
$parcel$export(module.exports, "selectComponents", () => $e9bfb3c5aeaccde8$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "LocalBaseSelect", () => $e9bfb3c5aeaccde8$export$51cc13ac81e51592);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");
var $k7INq = parcelRequire("k7INq");

var $hXj3O = parcelRequire("hXj3O");

var $1ritC = parcelRequire("1ritC");

var $12Y44 = parcelRequire("12Y44");

var $9BJPk = parcelRequire("9BJPk");

var $4kvmu = parcelRequire("4kvmu");

var $dgnpG = parcelRequire("dgnpG");

var $ijs6G = parcelRequire("ijs6G");
const $e9bfb3c5aeaccde8$export$c34d65c0f5a1c617 = {
    Control: $12Y44.Control,
    DropdownIndicator: $9BJPk.DropdownIndicator,
    LoadingIndicator: null,
    Menu: $4kvmu.Menu,
    Option: $ijs6G.Option
};
const $e9bfb3c5aeaccde8$var$onIsOptionDisabled = (option)=>'error' in option ? !!option.error : false;
const $e9bfb3c5aeaccde8$export$51cc13ac81e51592 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef(({ onFilterOption: onFilterOption, placeholder: placeholder, ...restProps }, ref)=>{
    const intl = (0, $k7INq.default)();
    const { ariaLabel: ariaLabelProp, onInputChange: onInputChangeProp, inputValue: inputValueProp } = restProps;
    const [inputValue, setInputValue] = (0, $8P7DW.useState)(inputValueProp || '');
    const onInputChange = (0, $8P7DW.useCallback)((newValue, actionMeta)=>{
        /**
     * Do not clear the filter input value when an input is selected or blurred.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if ([
            (0, $1ritC.MetaActions).setValue,
            (0, $1ritC.MetaActions).inputBlur,
            (0, $1ritC.MetaActions).menuClose
        ].includes(actionMeta.action) && !newValue.length) return;
        onInputChangeProp === null || onInputChangeProp === void 0 || onInputChangeProp(newValue, actionMeta);
        setInputValue(newValue);
    }, [
        onInputChangeProp
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hXj3O.default), {
        ...restProps,
        ref: ref,
        label: ariaLabelProp || intl.formatMessage((0, $dgnpG.default).searchPlaceholder),
        autoFocus: true,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: false,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: true,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        noOptionsMessage: ()=>intl.formatMessage((0, $dgnpG.default).noOptionsMessage),
        onInputChange: onInputChange,
        isOptionDisabled: $e9bfb3c5aeaccde8$var$onIsOptionDisabled,
        filterOption: onFilterOption,
        placeholder: placeholder ?? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
            ...(0, $dgnpG.default).searchPlaceholder
        })
    });
});
$e9bfb3c5aeaccde8$export$51cc13ac81e51592.displayName = 'LocalBaseSelect';

});
parcelRegister("hXj3O", function(module, exports) {
$parcel$export(module.exports, "SelectWithoutAnalytics", () => $f5cb78dd2ece6054$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $f5cb78dd2ece6054$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5yo3H = parcelRequire("5yo3H");
var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $kw1Aj = parcelRequire("kw1Aj");

var $echec = parcelRequire("echec");
const $f5cb78dd2ece6054$var$packageName = undefined;
const $f5cb78dd2ece6054$var$packageVersion = undefined;
const $f5cb78dd2ece6054$export$d1de3b251ccaa8a3 = (0, $echec.default)((0, $kw1Aj.default));
const $f5cb78dd2ece6054$var$createAndFireEventOnAtlaskit = (0, $5yo3H.default)('atlaskit');
const $f5cb78dd2ece6054$var$Select = (0, $eS4yu.default)({
    componentName: 'select',
    packageName: $f5cb78dd2ece6054$var$packageName,
    packageVersion: $f5cb78dd2ece6054$var$packageVersion
})((0, $k7ZVu.default)({
    onChange: $f5cb78dd2ece6054$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $f5cb78dd2ece6054$var$packageName,
            packageVersion: $f5cb78dd2ece6054$var$packageVersion
        }
    })
})($f5cb78dd2ece6054$export$d1de3b251ccaa8a3));
var $f5cb78dd2ece6054$export$2e2bcd8739ae039 = $f5cb78dd2ece6054$var$Select;

});
parcelRegister("5yo3H", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed216be874b0ed61$export$2e2bcd8739ae039);
var $ed216be874b0ed61$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("echec", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cc2bfa819697073$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
function $7cc2bfa819697073$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: // TODO: set to true when cleaning up validationState prop so it has a default value
        onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $8P7DW.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $8P7DW.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>{
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: ()=>{
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            }), []);
        return /*#__PURE__*/ (0, $gWgPx.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});


parcelRegister("1ritC", function(module, exports) {
$parcel$export(module.exports, "MetaActions", () => $d0e8946eb97cd923$export$50531cf3046c5956);
const $d0e8946eb97cd923$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("12Y44", function(module, exports) {
$parcel$export(module.exports, "Control", () => $34695b224b48e89a$export$7a7fa4424cb20976);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $gel9g = parcelRequire("gel9g");
const $34695b224b48e89a$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gel9g.StyledControl), {
        ...innerProps,
        ref: innerRef,
        children: children
    });
};

});

parcelRegister("9BJPk", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $1212dd6a4805d3c5$export$ec98719d3db7f2e4);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4CMbU = parcelRequire("4CMbU");

var $kDg5W = parcelRequire("kDg5W");

var $goA3W = parcelRequire("goA3W");

var $gel9g = parcelRequire("gel9g");
const $1212dd6a4805d3c5$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $goA3W.components).DropdownIndicator, {
        ...props,
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gel9g.DropdownIndicatorWrapper), {
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gel9g.DisplayWrapper), {
                    displayFlag: !!props.selectProps.inputValue,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gel9g.CloseIconWrapper), {
                        onClick: (event)=>{
                            var _props$selectProps$on, _props$selectProps;
                            event.preventDefault();
                            (_props$selectProps$on = (_props$selectProps = props.selectProps).onInputChange) === null || _props$selectProps$on === void 0 || _props$selectProps$on.call(_props$selectProps, '', {
                                action: 'input-change',
                                prevInputValue: props.selectProps.inputValue
                            });
                        },
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4CMbU))), {
                            color: "currentColor",
                            label: "",
                            size: "small"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gel9g.DisplayWrapper), {
                    displayFlag: !props.selectProps.inputValue,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kDg5W))), {
                        color: "currentColor",
                        label: ""
                    })
                })
            ]
        })
    });

});

parcelRegister("4kvmu", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $3a27b3c7f8f63436$export$d9b273488cd8ce6f);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $3a27b3c7f8f63436$export$d9b273488cd8ce6f = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps,
        children: children
    });

});

parcelRegister("dgnpG", function(module, exports) {
$parcel$export(module.exports, "default", () => $03cee1d46740104a$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $03cee1d46740104a$var$_default_1 = (0, $6K2Gm.defineMessages)({
    noOptionsMessage: {
        id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
        defaultMessage: 'No matches found',
        description: 'The text for when no matches are found in dropdown'
    },
    searchPlaceholder: {
        id: 'paginated-picker.async-select.select.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in search input indicating that the user can search'
    }
});
var $03cee1d46740104a$export$2e2bcd8739ae039 = $03cee1d46740104a$var$_default_1;

});

parcelRegister("ijs6G", function(module, exports) {
$parcel$export(module.exports, "Option", () => $038467c03c5666c1$export$36d18380658d5d20);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $h82Rb = parcelRequire("h82Rb");

var $jb1K8 = parcelRequire("jb1K8");

var $ea6bZ = parcelRequire("ea6bZ");

var $gel9g = parcelRequire("gel9g");
const $038467c03c5666c1$export$36d18380658d5d20 = (props)=>{
    var _props$data;
    if ((_props$data = props.data) !== null && _props$data !== void 0 && _props$data.invalid) return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gel9g.StyledInvalidCheckboxOption), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jb1K8.CheckboxOption), {
                ...props
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ea6bZ.default), {
                content: props.selectProps.fieldInvalidLabel,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
                    label: "Test",
                    color: "var(--ds-icon-danger, #C9372C)"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jb1K8.CheckboxOption), {
        ...props
    });
};

});
parcelRegister("jb1K8", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $7d1c38dc54812b80$export$d40cc97ecda916f9);
/* input-options.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $7d1c38dc54812b80$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    disabled: "_syaz1gmx"
};
// the primary color represents the outer or background element
const $7d1c38dc54812b80$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #17171708)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
const $7d1c38dc54812b80$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $7d1c38dc54812b80$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $7d1c38dc54812b80$var$baseIconStyles = null;
const $7d1c38dc54812b80$var$baseOptionStyles = null;
const $7d1c38dc54812b80$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $8P7DW.useState)(false);
    const onMouseDown = (0, $8P7DW.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $8P7DW.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $8P7DW.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8n1kL.default)([
            $7d1c38dc54812b80$var$optionStyles.default,
            isFocused && $7d1c38dc54812b80$var$optionStyles.focused,
            isDisabled && $7d1c38dc54812b80$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $7d1c38dc54812b80$var$iconStyles.inherit : $7d1c38dc54812b80$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $gWgPx.jsx)(Icon, {
                    label: "",
                    primaryColor: $7d1c38dc54812b80$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $7d1c38dc54812b80$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $7d1c38dc54812b80$var$svgStyles = null;
const $7d1c38dc54812b80$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $8n1kL.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $7d1c38dc54812b80$var$RadioIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $8n1kL.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $7d1c38dc54812b80$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)($7d1c38dc54812b80$var$ControlOption, {
        Icon: $7d1c38dc54812b80$var$CheckboxIcon,
        ...props
    });
const $7d1c38dc54812b80$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $gWgPx.jsx)($7d1c38dc54812b80$var$ControlOption, {
        Icon: $7d1c38dc54812b80$var$RadioIcon,
        ...props
    });

});



parcelRegister("j6iva", function(module, exports) {
$parcel$export(module.exports, "ShowFullListButton", () => $3775059ec0413c8e$export$bf0956d66cd7566b);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");

var $ifRQf = parcelRequire("ifRQf");

var $cv5eF = parcelRequire("cv5eF");
const $3775059ec0413c8e$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const handleShowFullList = (0, $8P7DW.useCallback)(()=>{
        // const analyticsEvent = createAnalyticsEvent({
        //   eventType: 'UI',
        //   action: 'expanded',
        //   actionSubject: 'filterSearch',
        //   actionSubjectId: 'refinementBarFilterSearch',
        // });
        //
        // const attributes: Attributes = {
        //   fieldType: type,
        // };
        //
        // fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        onShowFullList
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
            ...(0, $cv5eF.default).showFullListButtonText
        })
    });
};
var $3775059ec0413c8e$export$2e2bcd8739ae039 = $3775059ec0413c8e$export$bf0956d66cd7566b;

});
parcelRegister("cv5eF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a4cb653c9786d69$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $1a4cb653c9786d69$var$_default_1 = (0, $6K2Gm.defineMessages)({
    showFullListButtonText: {
        id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
        defaultMessage: 'Show full list',
        description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
    }
});
var $1a4cb653c9786d69$export$2e2bcd8739ae039 = $1a4cb653c9786d69$var$_default_1;

});


parcelRegister("d4ebN", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $9a177c604733bfef$export$a06f1c675e846f6f);

var $9pmZe = parcelRequire("9pmZe");
const $9a177c604733bfef$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-1bj6bqn-0"
})({
    borderTop: `${"var(--ds-border, #0B120E24)"} solid ${"var(--ds-border-width-selected, 2px)"}}`,
    paddingTop: "var(--ds-space-050, 4px)",
    paddingBottom: "var(--ds-space-050, 4px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});

});


parcelRegister("ic1zO", function(module, exports) {
$parcel$export(module.exports, "default", () => $0632880d4712bf77$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $5OCae = parcelRequire("5OCae");

var $ktYEe = parcelRequire("ktYEe");

var $3Pt3y = parcelRequire("3Pt3y");
const $0632880d4712bf77$var$formatOptionLabel = (option)=>{
    if (option.optionType === 'option') return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ktYEe.IconOptionLabel), {
        option: option
    });
    if (option.optionType === 'avatar') return option.hideAvatar === true ? option.label : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $5OCae.AvatarOptionLabel), {
        avatarOption: option
    });
    if (option.optionType === 'lozenge') return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3Pt3y.LozengeOptionLabel), {
        lozengeOption: option
    });
    // eslint-disable-next-line no-console
    console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {});
};
var $0632880d4712bf77$export$2e2bcd8739ae039 = $0632880d4712bf77$var$formatOptionLabel;

});
parcelRegister("5OCae", function(module, exports) {
$parcel$export(module.exports, "AvatarOptionLabel", () => $99bedac7dc5777d8$export$fe00f602c942368a);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $hIXV0 = parcelRequire("hIXV0");

var $coUKh = parcelRequire("coUKh");
const $99bedac7dc5777d8$export$fe00f602c942368a = ({ avatarOption: avatarOption })=>/*#__PURE__*/ (0, $gWgPx.jsxs)((0, $coUKh.StyledOption), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hIXV0.default), {
                src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
                size: "xsmall",
                appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $coUKh.StyledChild), {
                children: avatarOption.label
            })
        ]
    });

});
parcelRegister("coUKh", function(module, exports) {
$parcel$export(module.exports, "StyledChild", () => $b3583fc29a292b62$export$8133811dea85f484);
$parcel$export(module.exports, "StyledOption", () => $b3583fc29a292b62$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledItem", () => $b3583fc29a292b62$export$7c16ae7705e422c4);
$parcel$export(module.exports, "StyledChildIcon", () => $b3583fc29a292b62$export$c23e66fb1706d7dd);
$parcel$export(module.exports, "StyledOptionIcon", () => $b3583fc29a292b62$export$20da797b837461ca);

var $9pmZe = parcelRequire("9pmZe");
const $b3583fc29a292b62$export$8133811dea85f484 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-3nijrx-0"
})({
    margin: "var(--ds-space-050, 4px)",
    minWidth: 0
});
const $b3583fc29a292b62$export$844bee7de236d7ec = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-3nijrx-1"
})({
    alignItems: 'center',
    display: 'flex'
});
const $b3583fc29a292b62$export$7c16ae7705e422c4 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-3nijrx-2"
})({
    display: 'flex'
});
const $b3583fc29a292b62$export$c23e66fb1706d7dd = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-3nijrx-3"
})({
    marginLeft: "var(--ds-space-100, 8px)"
});
const $b3583fc29a292b62$export$20da797b837461ca = /*#__PURE__*/ (0, $9pmZe.default).img.withConfig({
    componentId: "sc-3nijrx-4"
})({
    borderRadius: "var(--ds-radius-full, 9999px)",
    height: '16px',
    width: '16px',
    display: 'flex',
    margin: "var(--ds-space-025, 2px)"
});

});


parcelRegister("ktYEe", function(module, exports) {
$parcel$export(module.exports, "IconOptionLabel", () => $98ec347bee5cb783$export$914fa095fc1e0a45);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $coUKh = parcelRequire("coUKh");
const $98ec347bee5cb783$export$914fa095fc1e0a45 = ({ option: option })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $coUKh.StyledOption), {
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $coUKh.StyledItem), {
            children: [
                option.icon !== undefined && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $coUKh.StyledOptionIcon), {
                    src: option.icon,
                    alt: option.label
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $coUKh.StyledChildIcon), {
                    children: option.label
                })
            ]
        })
    });

});

parcelRegister("3Pt3y", function(module, exports) {
$parcel$export(module.exports, "LozengeOptionLabel", () => $5463cfe90019d968$export$5f70fe304106fcb1);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $eT7pr = parcelRequire("eT7pr");

var $coUKh = parcelRequire("coUKh");
const $5463cfe90019d968$export$5f70fe304106fcb1 = ({ lozengeOption: lozengeOption })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $coUKh.StyledOption), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $coUKh.StyledChild), {
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $coUKh.StyledItem), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eT7pr.default), {
                    appearance: lozengeOption.appearance,
                    isBold: lozengeOption.isBold,
                    maxWidth: lozengeOption.maxWidth,
                    children: lozengeOption.label
                })
            })
        })
    });

});


parcelRegister("eIfQt", function(module, exports) {
$parcel$export(module.exports, "DialogInner", () => $f2eccc28fe2968e2$export$999ca5bf223f627);

var $9pmZe = parcelRequire("9pmZe");
const $f2eccc28fe2968e2$export$999ca5bf223f627 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-mzm5tv-0"
})({
    minWidth: '220px'
});

});


parcelRegister("fB0xT", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $d6b066fd3571596b$export$957d7daebd899f12);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $2SIoy = parcelRequire("2SIoy");

var $9pb7J = parcelRequire("9pb7J");

var $jHsUY = parcelRequire("jHsUY");
const $d6b066fd3571596b$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : !!value;
const $d6b066fd3571596b$export$957d7daebd899f12 = (label = '', value)=>{
    if (!value || !$d6b066fd3571596b$export$96bdbc84526f3739(value)) return label;
    const [firstValue, ...otherValues] = value.map((v)=>v.label ?? '');
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $jHsUY.Container), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $9pb7J.default), {
                as: "strong",
                color: "inherit",
                children: [
                    label,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $jHsUY.LabelValueWrapper), {
                children: [
                    firstValue,
                    otherValues.length > 0 && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jHsUY.BadgeWrapper), {
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2SIoy.default), {
                            children: `+${otherValues.length}`
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("jHsUY", function(module, exports) {
$parcel$export(module.exports, "BadgeWrapper", () => $9adcf2d9086ac6b9$export$1a37a8b7ddf809ac);
$parcel$export(module.exports, "Container", () => $9adcf2d9086ac6b9$export$42a852a2b6b56249);
$parcel$export(module.exports, "LabelValueWrapper", () => $9adcf2d9086ac6b9$export$8f3477ca2c4ba51a);

var $9pmZe = parcelRequire("9pmZe");
const $9adcf2d9086ac6b9$export$1a37a8b7ddf809ac = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-1abwl2h-0"
})({
    display: 'inline-flex',
    marginLeft: "var(--ds-space-050, 4px)",
    opacity: 0.5
});
const $9adcf2d9086ac6b9$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-1abwl2h-1"
})({
    display: 'inline-flex',
    alignItems: 'center'
});
const $9adcf2d9086ac6b9$export$8f3477ca2c4ba51a = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-1abwl2h-2"
})({
    marginLeft: "var(--ds-space-050, 4px)",
    display: 'inline-flex',
    alignItems: 'center'
});

});


parcelRegister("kvIaU", function(module, exports) {
$parcel$export(module.exports, "default", () => $171404c7a2ebe836$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $izQyW = parcelRequire("izQyW");

var $cDQfx = parcelRequire("cDQfx");

var $e6Qdr = parcelRequire("e6Qdr");

var $2CGHX = parcelRequire("2CGHX");

var $2GTZ1 = parcelRequire("2GTZ1");

var $viXmR = parcelRequire("viXmR");

var $jkDa1 = parcelRequire("jkDa1");

var $18JL5 = parcelRequire("18JL5");
const $171404c7a2ebe836$var$textPadding = {
    root: "_u5f3utpp"
};
const $171404c7a2ebe836$export$d7b370c39c0de454 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, hideSelectedIndicator: hideSelectedIndicator, triggerIcon: triggerIcon, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId, isDisabled: isDisabled, ariaLabel: ariaLabel }, ref)=>{
    if (isLoading) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2GTZ1.PaginatedPickerIntlProvider), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jkDa1.LoadingStateAnimationWrapper), {
            children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $izQyW.default), {
                isSelected: !hideSelectedIndicator && isSelected,
                iconBefore: triggerIcon,
                testId: testId,
                children: [
                    children,
                    ":"
                ]
            })
        })
    });
    const afterTriggerIcon = onClear ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $18JL5.StyledClose), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $viXmR.ClearButton), {
            onClick: (e)=>{
                e.stopPropagation();
                onClear === null || onClear === void 0 || onClear();
            },
            label: "Remove criteria"
        })
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
        color: "currentColor",
        label: "",
        size: "small"
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2GTZ1.PaginatedPickerIntlProvider), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $18JL5.ButtonWrapper), {
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                appearance: isInvalid ? 'danger' : 'default',
                isSelected: !hideSelectedIndicator && (isSelected || hasValues),
                iconBefore: triggerIcon,
                iconAfter: ()=>afterTriggerIcon,
                onClick: onClick,
                ref: ref,
                testId: testId,
                "aria-expanded": isSelected,
                isDisabled: isDisabled,
                "aria-label": ariaLabel && (0, $e6Qdr.fg)('jsm-accessibility-fixes') ? ariaLabel : undefined,
                children: onClear ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                    xcss: $171404c7a2ebe836$var$textPadding.root,
                    children: children
                }) : children
            })
        })
    });
});
var $171404c7a2ebe836$export$2e2bcd8739ae039 = $171404c7a2ebe836$export$d7b370c39c0de454;

});
parcelRegister("viXmR", function(module, exports) {
$parcel$export(module.exports, "ClearButton", () => $89a33a5df96cfdd9$export$13ec83e50bf04290);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $b9hQ0 = parcelRequire("b9hQ0");

var $1IJl1 = parcelRequire("1IJl1");
const $89a33a5df96cfdd9$export$13ec83e50bf04290 = ({ label: label, ...props })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $1IJl1.StyledClearButton), {
        ...props,
        "data-testid": "paginated-picker.ui.clear-button",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))), {
            color: "currentColor",
            label: label,
            size: "small"
        })
    });
$89a33a5df96cfdd9$export$13ec83e50bf04290.defaultProps = {
    isSelected: false,
    type: 'button'
};
var $89a33a5df96cfdd9$export$2e2bcd8739ae039 = $89a33a5df96cfdd9$export$13ec83e50bf04290;

});
parcelRegister("1IJl1", function(module, exports) {
$parcel$export(module.exports, "StyledClearButton", () => $fec4a971286925f9$export$969a0501aa28855a);

var $9pmZe = parcelRequire("9pmZe");
const $fec4a971286925f9$export$969a0501aa28855a = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-m9cwqf-0"
})({
    background: 0,
    border: 0,
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    color: "var(--ds-text-subtlest, #6B6E76)",
    cursor: 'pointer',
    height: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    outline: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    marginLeft: "var(--ds-space-025, 2px)",
    transition: 'background-color 200ms opacity 200ms',
    width: "var(--ds-space-300, 24px)",
    '&:hover, &:focus': {
        color: "var(--ds-text-subtle, #505258)"
    }
});

});


parcelRegister("jkDa1", function(module, exports) {
$parcel$export(module.exports, "LoadingStateAnimationWrapper", () => $2ad199b039868e01$export$c7a90a9f6120efb7);

var $9pmZe = parcelRequire("9pmZe");
const $2ad199b039868e01$export$c7a90a9f6120efb7 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-13besx7-0"
})({
    position: 'relative',
    animation: 'flickerAnimation 2s infinite',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes flickerAnimation': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 0.5
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 1
        }
    }
});

});

parcelRegister("18JL5", function(module, exports) {
$parcel$export(module.exports, "ButtonWrapper", () => $d61a9969931bfda9$export$d53c836cccbb0d90);
$parcel$export(module.exports, "StyledClose", () => $d61a9969931bfda9$export$cd8104a6ec6bb897);

var $9pmZe = parcelRequire("9pmZe");
const $d61a9969931bfda9$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-1bg0ktc-0"
})({
    position: 'relative'
});
const $d61a9969931bfda9$export$cd8104a6ec6bb897 = /*#__PURE__*/ (0, $9pmZe.default).div.withConfig({
    componentId: "sc-1bg0ktc-1"
})({
    background: 0,
    border: 0,
    height: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    outline: 0,
    padding: 0,
    position: 'absolute',
    right: "var(--ds-space-negative-050, -4px)",
    top: '50%',
    marginTop: "var(--ds-space-negative-150, -12px)",
    width: "var(--ds-space-300, 24px)"
});

});





parcelRegister("hCUBS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0e9d14130f9632d$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $d0e9d14130f9632d$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    categoryFilter: {
        defaultMessage: 'Category',
        description: 'Title of the category picker',
        id: 'sd.all.articles.result.category.filter.name'
    }
});

});



parcelRegister("izDZr", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => (parcelRequire("7n80L")).SearchResultNone);

var $7n80L = parcelRequire("7n80L");

});
parcelRegister("7n80L", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => $514531a79ab1ef6c$export$149a2f9a7f0755fb);

var $8P7DW = parcelRequire("8P7DW");

var $1vm2y = parcelRequire("1vm2y");

var $jgxNN = parcelRequire("jgxNN");

var $5jYgE = parcelRequire("5jYgE");

var $iqJis = parcelRequire("iqJis");

var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");

var $dfS0m = parcelRequire("dfS0m");
parcelRequire("ibkPE");
var $k0cKu = parcelRequire("k0cKu");

var $gvqx2 = parcelRequire("gvqx2");

var $fyoIi = parcelRequire("fyoIi");
const $514531a79ab1ef6c$export$149a2f9a7f0755fb = ({ term: term })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const showEmptyQueryState = term === '';
    const emptyQueryContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k0cKu.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1vm2y))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $fyoIi.default).noSearchQueryTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        align: "center"
    }, formatMessage((0, $fyoIi.default).noSearchQueryBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $gvqx2.searchExperience)
    }));
    const noResultsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k0cKu.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jgxNN))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $fyoIi.default).noSearchResultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        align: "center"
    }, formatMessage((0, $fyoIi.default).noSearchResultBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $gvqx2.searchExperience)
    }));
    return showEmptyQueryState ? emptyQueryContent : noResultsContent;
};

});
parcelRegister("1vm2y", function(module, exports) {
module.exports = new URL("../images/empty-search-query.f4548b48.svg", import.meta.url).toString();

});

parcelRegister("jgxNN", function(module, exports) {
module.exports = new URL("../images/empty-search-results.00e234d0.svg", import.meta.url).toString();

});

parcelRegister("dfS0m", function(module, exports) {
$parcel$export(module.exports, "ExperienceSuccess", () => $531fb7399c45e470$export$4962f3898bd5c829);

var $8P7DW = parcelRequire("8P7DW");
const $531fb7399c45e470$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $8P7DW.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("fyoIi", function(module, exports) {
$parcel$export(module.exports, "default", () => $4da54bf7f866b74e$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $4da54bf7f866b74e$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    noSearchResultTitle: {
        defaultMessage: 'We couldn\u2019t find a match for your search',
        description: 'Text to tell the user that there was no search results found after they have conducted a search',
        id: 'cv.search.none.no-search-result-title'
    },
    noSearchResultText: {
        defaultMessage: 'We couldn\u2019t find any matches for \u2018{ term }\u2019. Check your search for typos, or try another search term.',
        description: 'Title text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-text'
    },
    noSearchResultBody: {
        defaultMessage: 'Check your search for typos, or try another search term.',
        description: 'Body text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-body'
    },
    noSearchQueryTitle: {
        defaultMessage: 'Looking for something?',
        description: 'Title text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-title'
    },
    noSearchQueryBody: {
        defaultMessage: 'Enter your search term above to get started.',
        description: 'Body text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-body'
    }
});

});



parcelRegister("1x6ab", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => (parcelRequire("hwVTW")).SearchBar);

var $hwVTW = parcelRequire("hwVTW");

});
parcelRegister("hwVTW", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => $990c020a3c48352c$export$79d13b60110f33be);

var $8P7DW = parcelRequire("8P7DW");

var $67PZi = parcelRequire("67PZi");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");

var $k7ZVu = parcelRequire("k7ZVu");

var $b9hQ0 = parcelRequire("b9hQ0");

var $kDg5W = parcelRequire("kDg5W");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $ktwNU = parcelRequire("ktwNU");
var $37U6z = parcelRequire("37U6z");

var $2Mjg8 = parcelRequire("2Mjg8");

var $gFpea = parcelRequire("gFpea");

var $2Np0t = parcelRequire("2Np0t");
parcelRequire("ibkPE");
var $k0cKu = parcelRequire("k0cKu");
var $iwSnV = parcelRequire("iwSnV");

var $3jhAL = parcelRequire("3jhAL");
const $990c020a3c48352c$export$79d13b60110f33be = ({ term: term, onChange: onChange, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [backButtonText, setBackButtonText] = (0, $8P7DW.useState)();
    const searchBarRef = (0, $8P7DW.useRef)(null);
    (0, $8P7DW.useEffect)(()=>{
        let observer;
        const currentSearchBarRefRef = searchBarRef.current;
        if (window.ResizeObserver) {
            observer = new window.ResizeObserver((entries)=>{
                for (const entry of entries)setBackButtonText(entry.contentRect.width < 768 ? '' : undefined);
            });
            if (currentSearchBarRefRef) observer.observe(currentSearchBarRefRef);
        }
        return ()=>{
            if (currentSearchBarRefRef) observer.unobserve(currentSearchBarRefRef);
        };
    }, []);
    const onSearchTermChange = (0, $8P7DW.useCallback)((e)=>{
        onChange(e.target.value);
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'changed',
            actionSubject: 'searchTermValue',
            actionSubjectId: 'searchTerm'
        }).fire();
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'rendered',
            actionSubject: 'searchBarTextField',
            actionSubjectId: 'searchBar'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { goBack: goBack, push: push } = (0, $dKPjT.useRouterActions)();
    const onBackButtonClick = (0, $8P7DW.useCallback)(()=>{
        goBack();
    }, [
        goBack
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $iwSnV.useQueryParams)();
    const onCrossIconClick = (0, $8P7DW.useCallback)(()=>{
        onChange('');
        push((0, $2Np0t.addParamsToUrl)('', {
            ...queryStringParams,
            q: ''
        }));
    }, [
        onChange,
        push,
        queryStringParams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        xcss: $990c020a3c48352c$var$containerStyles,
        ref: searchBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        gap: "space.200",
        templateColumns: "25fr 50fr 25fr",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $990c020a3c48352c$var$backButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $67PZi.default), {
        text: backButtonText,
        actionSubjectId: "closeSearch",
        onClick: onBackButtonClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $990c020a3c48352c$var$textFieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gFpea.default), {
        id: "search-bar-input",
        value: term,
        name: formatMessage((0, $3jhAL.default).inputLabel),
        "aria-label": formatMessage((0, $3jhAL.default).inputPlaceholder),
        onChange: onSearchTermChange,
        placeholder: formatMessage((0, $3jhAL.default).inputPlaceholder),
        "aria-describedby": "dynamic-search-result",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $990c020a3c48352c$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kDg5W))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: "button",
            xcss: $990c020a3c48352c$var$crossIconStyles,
            onClick: onCrossIconClick,
            "aria-label": formatMessage((0, $3jhAL.default).clearSearch)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null)));
};
const $990c020a3c48352c$var$containerStyles = (0, $37U6z.xcss)({
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    width: '100vw',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    height: (0, $k0cKu.SEARCH_BAR_HEIGHT),
    backgroundColor: 'elevation.surface.overlay',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: "var(--ds-border, #EBECF0)",
    zIndex: 'modal'
});
const $990c020a3c48352c$var$backButtonStyles = (0, $37U6z.xcss)({
    [(0, $2Mjg8.media).above.xxs]: {
        marginLeft: 'space.050'
    },
    [(0, $2Mjg8.media).above.xs]: {
        marginLeft: 'space.100'
    },
    [(0, $2Mjg8.media).above.sm]: {
        marginLeft: 'space.200'
    }
});
const $990c020a3c48352c$var$textFieldStyles = (0, $37U6z.xcss)({
    height: 'space.500',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    background: 'transparent',
    [(0, $2Mjg8.media).above.xxs]: {
        width: '348px'
    },
    [(0, $2Mjg8.media).above.xs]: {
        width: '432px'
    },
    [(0, $2Mjg8.media).above.sm]: {
        width: '692px'
    },
    [(0, $2Mjg8.media).above.md]: {
        width: '965px'
    }
});
const $990c020a3c48352c$var$searchIconStyles = (0, $37U6z.xcss)({
    padding: 'space.100'
});
const $990c020a3c48352c$var$crossIconStyles = (0, $37U6z.xcss)({
    background: 'transparent',
    cursor: 'pointer'
});
var $990c020a3c48352c$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($990c020a3c48352c$export$79d13b60110f33be);

});
parcelRegister("67PZi", function(module, exports) {
$parcel$export(module.exports, "default", () => $e973f5339195346b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $8y05I = parcelRequire("8y05I");

var $5jYgE = parcelRequire("5jYgE");

var $6YKjX = parcelRequire("6YKjX");

var $bAm5h = parcelRequire("bAm5h");
const $e973f5339195346b$var$BackButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { onClick: onClick, actionSubjectId: actionSubjectId, text: text } = props;
    const backButtonText = text ? text : formatMessage((0, $bAm5h.default).backButtonText);
    return /*#__PURE__*/ $8P7DW.createElement((0, $8y05I.Button), {
        appearance: "subtle",
        actionSubjectId: actionSubjectId,
        onClick: onClick,
        "aria-label": backButtonText,
        iconBefore: /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6YKjX))), {
            label: "",
            size: "small",
            spacing: "compact",
            color: "var(--ds-icon, #42526E)"
        }),
        "data-test-id": "back-button"
    }, backButtonText);
};
var $e973f5339195346b$export$2e2bcd8739ae039 = $e973f5339195346b$var$BackButton;

});
parcelRegister("6YKjX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2156d9d42c2a1cee4be11481dce76dec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $514c4705d2c94673$var$_react = $514c4705d2c94673$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $514c4705d2c94673$var$_baseNew = $514c4705d2c94673$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $514c4705d2c94673$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $514c4705d2c94673$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $514c4705d2c94673$var$_react.default.createElement($514c4705d2c94673$var$_baseNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$514c4705d2c94673$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $514c4705d2c94673$var$_default = module.exports.default = $514c4705d2c94673$var$ArrowLeftIcon;

});

parcelRegister("bAm5h", function(module, exports) {
$parcel$export(module.exports, "default", () => $d020a25712fc237f$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $d020a25712fc237f$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    backButtonText: {
        defaultMessage: 'Back',
        description: 'Back button text',
        id: 'sd.common.back-button.text'
    }
});

});


parcelRegister("gFpea", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddfd5fa319417229$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $aeYmt = parcelRequire("aeYmt");

var $e6Qdr = parcelRequire("e6Qdr");
const $ddfd5fa319417229$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $ddfd5fa319417229$var$inputMediaDisabled = null;
const $ddfd5fa319417229$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $ddfd5fa319417229$var$disabledStyle = {
    standard: "_1h6dby5v _bfhkby5v _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
const $ddfd5fa319417229$var$invalidStyle = null;
const $ddfd5fa319417229$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
const $ddfd5fa319417229$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
const $ddfd5fa319417229$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
const $ddfd5fa319417229$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $ddfd5fa319417229$var$getMaxWidth = (width)=>!width ? `100%` : width in $ddfd5fa319417229$var$widthMap ? `${$ddfd5fa319417229$var$widthMap[width]}px` : `${+width}px`;
const $ddfd5fa319417229$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $ddfd5fa319417229$var$containerStyles = null;
const $ddfd5fa319417229$var$containerStylesT26Shape = null;
const $ddfd5fa319417229$var$inputDisabledStyle = null;
const $ddfd5fa319417229$var$inputCompactStyle = null;
const $ddfd5fa319417229$var$inputMonospacedStyle = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textfield uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $ddfd5fa319417229$var$inputStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ddfd5fa319417229$var$Textfield = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $8P7DW.useRef)(null);
    const handleOnFocus = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ddfd5fa319417229$var$analyticsParams
    });
    const handleOnBlur = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ddfd5fa319417229$var$analyticsParams
    });
    const handleOnMouseDown = (0, $8P7DW.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $8P7DW.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$ddfd5fa319417229$var$getMaxWidth(width)}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8n1kL.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnqfajl",
            (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && "_1tnq1qi0",
            $ddfd5fa319417229$var$getContainerTextBgAndBorderColor[appearance],
            $ddfd5fa319417229$var$containerStyleAppearance[appearance],
            !isDisabled && $ddfd5fa319417229$var$focusWithinStyle[appearance],
            !isDisabled && $ddfd5fa319417229$var$hoverStyle[appearance],
            isDisabled && $ddfd5fa319417229$var$containerMedia.disabled,
            isDisabled && $ddfd5fa319417229$var$disabledStyle[appearance],
            isInvalid && $ddfd5fa319417229$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                // TODO: When removing legacy theming fix this.
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $8n1kL.default)([
                    "_19itidpf _11c81d4k _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _1tn2fhey _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    isMonospaced && "_ect4zzfg _14mdzzfg",
                    isCompact && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isDisabled && "_syaz1gmx _1idr1gmx",
                    isDisabled && "_1fnx18qt"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $ddfd5fa319417229$export$2e2bcd8739ae039 = $ddfd5fa319417229$var$Textfield;

});

parcelRegister("3jhAL", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c558a2651cde35c$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $3c558a2651cde35c$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    inputPlaceholder: {
        defaultMessage: 'Search for help resources',
        description: 'Placeholder message for the search bar describing what they can look for',
        id: 'cv.search.search-bar.input.placeholder'
    },
    close: {
        defaultMessage: 'Close search',
        description: 'Label for the close button which closes the search overlay',
        id: 'cv.search.search-bar.close'
    },
    inputLabel: {
        defaultMessage: 'Search bar input',
        description: 'Label message for the search bar input',
        id: 'cv.search.search-bar.input-label'
    },
    searchIconLabel: {
        defaultMessage: 'Search icon',
        description: 'Label message for the search bar input icon',
        id: 'cv.search.search-bar.search-icon-label'
    },
    clearSearch: {
        defaultMessage: 'Clear search',
        description: 'Label for the button that clears the search input',
        id: 'cv.search.search-bar.clear-search'
    }
});

});



parcelRegister("5NkV1", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => (parcelRequire("lhxXd")).SearchResult);

var $lhxXd = parcelRequire("lhxXd");

});
parcelRegister("lhxXd", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $a88bfee88fcd5458$export$a2def421b23768aa);

var $7atRE = parcelRequire("7atRE");

var $3Lszu = parcelRequire("3Lszu");

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");
parcelRequire("4PbDu");
var $3FFzY = parcelRequire("3FFzY");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $55x6k = parcelRequire("55x6k");
var $2Mjg8 = parcelRequire("2Mjg8");
var $2IKBM = parcelRequire("2IKBM");
var $37U6z = parcelRequire("37U6z");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $6lTuV = parcelRequire("6lTuV");

var $4BXjO = parcelRequire("4BXjO");
parcelRequire("bYESi");
var $jcz1U = parcelRequire("jcz1U");
parcelRequire("ibkPE");
var $fhQ61 = parcelRequire("fhQ61");
var $iwSnV = parcelRequire("iwSnV");

var $gvqx2 = parcelRequire("gvqx2");
parcelRequire("ghVjE");
var $lJCiS = parcelRequire("lJCiS");
parcelRequire("izDZr");
var $7n80L = parcelRequire("7n80L");
parcelRequire("4mi7c");
var $g0eKE = parcelRequire("g0eKE");
parcelRequire("iyj8w");
var $l1WVL = parcelRequire("l1WVL");
const $a88bfee88fcd5458$export$e9a269813a6315a4 = ({ term: term, articlesData: articlesData, portalsData: portalsData, requestFormData: requestFormData, showAllResults: showAllResults, updateResultsCount: updateResultsCount })=>{
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const onlyRenderArticles = isCSM;
    const renderArticles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jcz1U.default), {
            term: term,
            result: articlesData,
            showAllResults: showAllResults,
            updateResultsCount: updateResultsCount
        });
    const renderPortals = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $g0eKE.default), {
            term: term,
            result: portalsData,
            updateResultsCount: updateResultsCount
        });
    const renderRequestForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l1WVL.default), {
            term: term,
            result: requestFormData,
            updateResultsCount: updateResultsCount
        });
    if (onlyRenderArticles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lJCiS.ArticleResultsLoader), null)
    }, renderArticles());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $a88bfee88fcd5458$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lJCiS.ArticleResultsLoader), null)
    }, renderArticles()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lJCiS.SidePanelResultsLoader), null)
    }, renderRequestForms()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lJCiS.SidePanelResultsLoader), null)
    }, renderPortals())));
};
function $a88bfee88fcd5458$var$useParallelQuery(cloudId, queryTerm, portalIds, categoryIds, resultLimit, helpCenterAri) {
    const ARTICLES_AND_PORTALS_QUERY = (0, $3Lszu.default);
    const REQUEST_FORM_QUERY = (0, $7atRE.default);
    const articlesAndPortalsData = (0, $h3cOB.useLazyLoadQuery)(ARTICLES_AND_PORTALS_QUERY, {
        cloudId: cloudId,
        queryTerm: queryTerm,
        portalIds: portalIds,
        categoryIds: categoryIds,
        resultLimit: resultLimit,
        helpCenterAri: helpCenterAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    const requestFormData = (0, $h3cOB.useLazyLoadQuery)(REQUEST_FORM_QUERY, {
        cloudId: cloudId,
        queryTerm: queryTerm,
        portalIds: portalIds,
        resultLimit: resultLimit
    }, {
        fetchPolicy: 'store-or-network'
    });
    return {
        articlesFragment: articlesAndPortalsData.helpObjectStore,
        portalsFragment: articlesAndPortalsData.helpObjectStore,
        requestFormFragment: requestFormData.helpObjectStore
    };
}
const $a88bfee88fcd5458$var$useExtractSearchParameters = ({ showAllResults: showAllResults, CSMPortalId: CSMPortalId })=>{
    const cloudId = (0, $8P7DW.useMemo)(()=>(0, $jByYr.getCloudId)(), []);
    const { portalIds: portalIds, categoryIds: categoryIds, resultLimit: resultLimit = (0, $fhQ61.DEFAULT_RESULTS_COUNT) } = (0, $iwSnV.useQueryParams)();
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const getSelectedPortalIds = ()=>{
        if (CSMPortalId) return (0, $iwSnV.getIdsArray)(CSMPortalId);
        if ((0, $iwSnV.isSinglePortalSearch)(portalId)) return (0, $iwSnV.getIdsArray)(portalId);
        return (0, $iwSnV.getIdsArray)(portalIds);
    };
    return {
        cloudId: cloudId,
        portalIds: portalIds,
        categoryIds: categoryIds,
        portalId: portalId,
        getSelectedPortalIds: getSelectedPortalIds,
        resultLimit: showAllResults ? (0, $fhQ61.ALL_RESULTS_COUNT) : resultLimit
    };
};
const $a88bfee88fcd5458$var$ParallelQueryWrapperOnResource = ({ term: term, updateResultsCount: updateResultsCount, showAllResults: showAllResults, searchParams: searchParams })=>{
    const { articlesFragment: articlesFragment, portalsFragment: portalsFragment, requestFormFragment: requestFormFragment } = $a88bfee88fcd5458$var$useParallelQuery(searchParams.cloudId, term, searchParams.getSelectedPortalIds(), searchParams.categoryIds, searchParams.resultLimit, (0, $HGACo.isProjectMappingInHelpCenterEnabled)() ? (0, $jByYr.getHelpCenterAri)() : undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($a88bfee88fcd5458$export$e9a269813a6315a4, {
        term: term,
        articlesData: articlesFragment,
        portalsData: portalsFragment,
        requestFormData: requestFormFragment,
        showAllResults: showAllResults,
        updateResultsCount: updateResultsCount
    });
};
const $a88bfee88fcd5458$export$a2def421b23768aa = ({ term: term, showAllResults: showAllResults })=>{
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const CSMPortalId = isCSM ? (0, $hrPHR.getEnv)().hoistedPortalId : undefined;
    const searchParams = $a88bfee88fcd5458$var$useExtractSearchParameters({
        showAllResults: showAllResults,
        CSMPortalId: CSMPortalId
    });
    const [totalCount, setTotalCount] = (0, $8P7DW.useState)(-1);
    const resultsCount = (0, $8P7DW.useRef)(-1);
    const callBackCount = (0, $8P7DW.useRef)(0);
    const debouncedTerm = (0, $4BXjO.default)(term, (0, $fhQ61.SEARCH_QUERY_DEBOUNCE_TIME));
    // Every time this callback will be called, that resource will increment callBackCount through acknowledgement
    const updateResultsCount = (0, $8P7DW.useCallback)((count, acknowledgement)=>{
        if (resultsCount.current < 0) resultsCount.current = 0;
        resultsCount.current += count;
        if (acknowledgement) callBackCount.current += acknowledgement;
        // Update state only when articles, portals and requestForms all have updated the results
        if (callBackCount.current === 3) {
            // Since callbackCount will persist across states, setting it back to 0
            callBackCount.current = 0;
            setTotalCount(resultsCount.current);
        }
    }, []);
    (0, $6lTuV.useIsoMorphicLayoutEffect)(()=>{
        // Reset count to initial state on term change
        resultsCount.current = -1;
        setTotalCount(-1);
        callBackCount.current = 0;
    }, [
        debouncedTerm
    ]);
    (0, $8P7DW.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        isCSM && (0, $gvqx2.csmSearchExperience).start();
        return ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            isCSM && (0, $gvqx2.csmSearchExperience).abort();
        };
    }, [
        debouncedTerm,
        isCSM
    ]);
    (0, $8P7DW.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $gvqx2.searchExperience).start();
        return ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $gvqx2.searchExperience).abort();
        };
    }, [
        debouncedTerm
    ]);
    const isEmptyResultsState = totalCount === 0;
    const isEmptyQueryState = debouncedTerm === '';
    const showEmptyState = isEmptyQueryState || isEmptyResultsState;
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lJCiS.NewSearchResultsLoader), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: fallback
    }, showEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7n80L.SearchResultNone), {
        term: debouncedTerm
    }), !isEmptyResultsState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($a88bfee88fcd5458$var$ParallelQueryWrapperOnResource, {
        term: debouncedTerm,
        searchParams: searchParams,
        showAllResults: showAllResults,
        updateResultsCount: updateResultsCount
    }));
};
const $a88bfee88fcd5458$var$responsiveStyles = (0, $37U6z.xcss)({
    [(0, $2Mjg8.media).above.xxs]: {
        gridTemplateColumns: '1fr'
    },
    [(0, $2Mjg8.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});

});
parcelRegister("7atRE", function(module, exports) {
$parcel$export(module.exports, "default", () => $520d9da84f0a9018$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b22341ca9f13699f5d5a5cab717d4a3c>>
 * @relayHash 84089950a098de741b9cc8fe7be37f4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID af1dedc24d118e6831ee24c6433181b68321c163ef93c3578dd8d71d3a98b3be
const $520d9da84f0a9018$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resultLimit"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultRequestFormQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v6 /*: any*/ ,
                        "concreteType": "HelpObjectStoreQueryApi",
                        "kind": "LinkedField",
                        "name": "helpObjectStore",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "requestFormsFragment"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "helpObjectStore"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "searchResultRequestFormQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpObjectStoreQueryApi",
                    "kind": "LinkedField",
                    "name": "helpObjectStore",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "alias": "requestForms",
                            "args": [
                                {
                                    "fields": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "entityType",
                                            "value": "REQUEST_FORM"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "helpCenterAri",
                                            "variableName": "helpCenterAri"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "portalIds",
                                            "variableName": "portalIds"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "queryTerm",
                                            "variableName": "queryTerm"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "resultLimit",
                                            "variableName": "resultLimit"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "searchInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "searchHelpObjects",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "isExternal"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "searchBackend"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "searchAlgorithm"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "entityType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "iconUrl"
                                        }
                                    ],
                                    "type": "HelpObjectStoreSearchResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "HelpObjectStoreQueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "af1dedc24d118e6831ee24c6433181b68321c163ef93c3578dd8d71d3a98b3be",
            "metadata": {},
            "name": "searchResultRequestFormQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$520d9da84f0a9018$var$node.hash = "767d90ed3aed24eab0f0598281dd235e";
var $520d9da84f0a9018$export$2e2bcd8739ae039 = $520d9da84f0a9018$var$node;

});

parcelRegister("3Lszu", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b773c485a1aee1f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<658ab6b719bbdb54900d8a2fd7ea5d15>>
 * @relayHash c66d23ed128edfd59ce7e96679d3138b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bdcb9c6579487db95aaa69bef286db9f90fd990a7cc1d82088e3def474d64ef
const $5b773c485a1aee1f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "categoryIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resultLimit"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v10 = {
        "kind": "Variable",
        "name": "portalIds",
        "variableName": "portalIds"
    }, v11 = {
        "kind": "Variable",
        "name": "queryTerm",
        "variableName": "queryTerm"
    }, v12 = {
        "kind": "Variable",
        "name": "resultLimit",
        "variableName": "resultLimit"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isExternal"
    }, v14 = {
        "kind": "ScalarField",
        "name": "searchBackend"
    }, v15 = {
        "kind": "ScalarField",
        "name": "id"
    }, v16 = {
        "kind": "ScalarField",
        "name": "title"
    }, v17 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v18 = {
        "kind": "ScalarField",
        "name": "searchAlgorithm"
    }, v19 = {
        "kind": "ScalarField",
        "name": "entityType"
    }, v20 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreQueryError"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v15 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultArticlesAndPortalsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v7 /*: any*/ ,
                        "concreteType": "HelpObjectStoreQueryApi",
                        "kind": "LinkedField",
                        "name": "helpObjectStore",
                        "plural": false,
                        "selections": [
                            v8 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "articlesFragment"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "portalsFragment"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "helpObjectStore"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "searchResultArticlesAndPortalsQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpObjectStoreQueryApi",
                    "kind": "LinkedField",
                    "name": "helpObjectStore",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "alias": "articles",
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "categoryIds",
                                            "variableName": "categoryIds"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "entityType",
                                            "value": "ARTICLE"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "searchInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "searchHelpObjects",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "containerDisplayName"
                                        }
                                    ],
                                    "type": "HelpObjectStoreSearchResult"
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "portals",
                            "args": [
                                {
                                    "fields": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "entityType",
                                            "value": "PORTAL"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "searchInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "searchHelpObjects",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ],
                                    "type": "HelpObjectStoreSearchResult"
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4bdcb9c6579487db95aaa69bef286db9f90fd990a7cc1d82088e3def474d64ef",
            "metadata": {},
            "name": "searchResultArticlesAndPortalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5b773c485a1aee1f$var$node.hash = "dcb6be9a06f88e55999bb3fc69693157";
var $5b773c485a1aee1f$export$2e2bcd8739ae039 = $5b773c485a1aee1f$var$node;

});

parcelRegister("6lTuV", function(module, exports) {
$parcel$export(module.exports, "useMounted", () => $5ad520ddecc389dd$export$bce3bfec9f56c837);
$parcel$export(module.exports, "usePrevious", () => $5ad520ddecc389dd$export$5cae361ad82dce8b);
$parcel$export(module.exports, "useIsoMorphicLayoutEffect", () => $5ad520ddecc389dd$export$3d58f1da4ac28ebc);

var $8P7DW = parcelRequire("8P7DW");
function $5ad520ddecc389dd$export$bce3bfec9f56c837() {
    const referenceToMounted = $8P7DW.useRef(false);
    $8P7DW.useEffect(()=>{
        if (!referenceToMounted.current) referenceToMounted.current = true;
        return ()=>{
            if (referenceToMounted.current) referenceToMounted.current = false;
        };
    }, []);
    return referenceToMounted.current;
}
function $5ad520ddecc389dd$export$5cae361ad82dce8b(value) {
    const referenceToValue = $8P7DW.useRef();
    $8P7DW.useEffect(()=>{
        referenceToValue.current = value;
    }, [
        value
    ]);
    return referenceToValue.current;
}
const $5ad520ddecc389dd$export$3d58f1da4ac28ebc = (0, $8P7DW.useLayoutEffect);

});

parcelRegister("4BXjO", function(module, exports) {
$parcel$export(module.exports, "default", () => $88b1c691b6a53caa$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
/**
 * If the 'value' changes multiple times in quick succession, within the specified 'delay' time frame,
 * the 'debouncedValue' only changes once and equals the latest 'value'
 */ const $88b1c691b6a53caa$var$useDebouncedValue = (value, delay)=>{
    const [debouncedValue, setDebouncedValue] = (0, $8P7DW.useState)(value);
    // useEffect schedules an update to 'debouncedValue' after the delay
    // if the 'value' changes before the delay, the previous timeout is cleared, and a new one is started
    (0, $8P7DW.useEffect)(()=>{
        const timeoutID = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(timeoutID);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};
var $88b1c691b6a53caa$export$2e2bcd8739ae039 = $88b1c691b6a53caa$var$useDebouncedValue;

});

parcelRegister("bYESi", function(module, exports) {
$parcel$export(module.exports, "Articles", () => (parcelRequire("jcz1U")).default);

var $jcz1U = parcelRequire("jcz1U");

});
parcelRegister("jcz1U", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb963b33134f6b8d$export$2e2bcd8739ae039);

var $k0w2a = parcelRequire("k0w2a");

var $8P7DW = parcelRequire("8P7DW");

var $jShty = parcelRequire("jShty");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $k7ZVu = parcelRequire("k7ZVu");

var $iqJis = parcelRequire("iqJis");

var $cDQfx = parcelRequire("cDQfx");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $dfS0m = parcelRequire("dfS0m");
parcelRequire("7aE76");
var $44NVk = parcelRequire("44NVk");
parcelRequire("ibkPE");
var $fhQ61 = parcelRequire("fhQ61");
var $k0cKu = parcelRequire("k0cKu");
var $iwSnV = parcelRequire("iwSnV");

var $gvqx2 = parcelRequire("gvqx2");
parcelRequire("izDZr");
var $7n80L = parcelRequire("7n80L");

var $5cfZt = parcelRequire("5cfZt");
const $cb963b33134f6b8d$export$b9fde6c411c336c6 = ({ result: result, term: term, showAllResults: showAllResults, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $k0w2a.default), result);
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $iwSnV.useQueryParams)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { resultLimit: resultLimit = showAllResults ? (0, $fhQ61.ALL_RESULTS_COUNT) : (0, $fhQ61.INITIAL_ARTICLES_COUNT) } = queryStringParams;
    // We fetch one more than the required count, i.e. (4+1 or 8+1), to identify if there are any more results
    // but will show only 4, 8 or max 30 results
    const [numberOfResultsShown, setNumberOfResultsShown] = (0, $8P7DW.useState)(showAllResults ? (0, $fhQ61.ALL_RESULTS_COUNT) : resultLimit - 1);
    const showMoreArticlesButton = numberOfResultsShown < 30 && data.articles.length > numberOfResultsShown;
    const slicedArticles = data.articles.slice(0, numberOfResultsShown);
    const showSection = slicedArticles.length > 0;
    (0, $8P7DW.useEffect)(()=>{
        setNumberOfResultsShown(resultLimit - 1);
    }, [
        resultLimit
    ]);
    (0, $8P7DW.useEffect)(()=>{
        let externalResourcesCount = 0;
        let firstPartySearchPlatformResourcesCount = 0;
        let hasError = false;
        let errorMessage;
        slicedArticles.forEach((resource)=>{
            if (resource) {
                const { __typename: __typename, isExternal: isExternal, searchBackend: searchBackend, message: message } = resource;
                if (__typename === 'HelpObjectStoreSearchResult') {
                    if (isExternal) externalResourcesCount += 1;
                    if (searchBackend === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
                    if (message && !errorMessage) {
                        hasError = true;
                        errorMessage = message;
                    }
                }
            }
        });
        if (showSection && hasError) (0, $iwSnV.sendSearchOperationalAnalyticEvents)({
            hasError: hasError,
            errorMessage: errorMessage,
            action: portalId ? 'KBArticleSinglePortalSearch failed' : 'KBArticleHomePageSearch failed'
        }, createAnalyticsEvent, portalId);
        if (showSection && !hasError) {
            (0, $iwSnV.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'article',
                resourceCount: slicedArticles.length
            }, createAnalyticsEvent, portalId);
            (0, $iwSnV.sendSearchOperationalAnalyticEvents)({
                action: portalId ? 'KBArticleSinglePortalSearch success' : 'KBArticleHomePageSearch success'
            }, createAnalyticsEvent, portalId);
        }
    // adding slicedArticles to deps array causes multiple 'rendered' events to be fired
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        term,
        showSection,
        slicedArticles.length,
        createAnalyticsEvent,
        portalId,
        numberOfResultsShown
    ]);
    (0, $8P7DW.useEffect)(()=>{
        updateResultsCount(slicedArticles.length, 1);
    }, [
        term,
        slicedArticles.length,
        updateResultsCount
    ]);
    const onShowMoreClick = (0, $8P7DW.useCallback)(()=>{
        if (numberOfResultsShown <= 30) setNumberOfResultsShown(numberOfResultsShown + ((0, $fhQ61.SHOW_MORE_RESULTS_COUNT) - resultLimit));
    }, [
        numberOfResultsShown,
        resultLimit
    ]);
    if (!showSection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7n80L.SearchResultNone), {
        term: term
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "xxsmall"
    }, formatMessage((0, $5cfZt.default).articles)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k0cKu.ResultList), null, slicedArticles.map((resource, index)=>{
        if ((resource === null || resource === void 0 ? void 0 : resource.__typename) === 'HelpObjectStoreSearchResult') {
            const itemOrder = index + 1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("li", {
                key: itemOrder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $44NVk.default), {
                itemOrder: itemOrder,
                term: term,
                showAllResults: showAllResults,
                result: resource
            }));
        }
        return null;
    })), showMoreArticlesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jShty.ThemedButton), {
        "data-test-id": "show-more-button",
        appearance: "link",
        actionSubjectId: "showMoreButton",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
            size: "small",
            spacing: "spacious",
            label: formatMessage((0, $5cfZt.default).showMoreIcon)
        }),
        onClick: onShowMoreClick
    }, formatMessage((0, $5cfZt.default).showMore))), isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $gvqx2.csmSearchExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $gvqx2.searchExperience)
    }));
};
var $cb963b33134f6b8d$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($cb963b33134f6b8d$export$b9fde6c411c336c6);

});
parcelRegister("k0w2a", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a2b39cfaab7ac03$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ade24a913542fcfc03bb6c44c81e480>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2a2b39cfaab7ac03$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "categoryIds"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "helpCenterAri"
        },
        {
            "kind": "RootArgument",
            "name": "portalIds"
        },
        {
            "kind": "RootArgument",
            "name": "queryTerm"
        },
        {
            "kind": "RootArgument",
            "name": "resultLimit"
        }
    ],
    "kind": "Fragment",
    "name": "articlesFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "articles",
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "categoryIds",
                                "variableName": "categoryIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "entityType",
                                "value": "ARTICLE"
                            },
                            {
                                "kind": "Variable",
                                "name": "helpCenterAri",
                                "variableName": "helpCenterAri"
                            },
                            {
                                "kind": "Variable",
                                "name": "portalIds",
                                "variableName": "portalIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "queryTerm",
                                "variableName": "queryTerm"
                            },
                            {
                                "kind": "Variable",
                                "name": "resultLimit",
                                "variableName": "resultLimit"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "searchInput"
                    }
                ],
                "kind": "LinkedField",
                "name": "searchHelpObjects",
                "plural": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                "action": "THROW",
                                "path": "articles.__typename"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "isExternal"
                                },
                                "action": "THROW",
                                "path": "articles.isExternal"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "searchBackend"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "articleItemFragment"
                            }
                        ],
                        "type": "HelpObjectStoreSearchResult"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "HelpObjectStoreQueryError"
                    }
                ]
            },
            "action": "THROW",
            "path": "articles"
        }
    ],
    "type": "HelpObjectStoreQueryApi"
};
$2a2b39cfaab7ac03$var$node.hash = "0fd69884410027b8cf6238f3c721758b";
var $2a2b39cfaab7ac03$export$2e2bcd8739ae039 = $2a2b39cfaab7ac03$var$node;

});

parcelRegister("7aE76", function(module, exports) {
$parcel$export(module.exports, "ArticleItem", () => (parcelRequire("44NVk")).default);

var $44NVk = parcelRequire("44NVk");

});
parcelRegister("44NVk", function(module, exports) {
$parcel$export(module.exports, "default", () => $25f9611519066f52$export$2e2bcd8739ae039);

var $9WE6n = parcelRequire("9WE6n");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $cS6Xr = parcelRequire("cS6Xr");

var $HGACo = parcelRequire("HGACo");

var $f73iJ = parcelRequire("f73iJ");

var $loEqA = parcelRequire("loEqA");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $k7ZVu = parcelRequire("k7ZVu");

var $c1US4 = parcelRequire("c1US4");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $6GVst = parcelRequire("6GVst");

var $jsmb9 = parcelRequire("jsmb9");
parcelRequire("hHpfl");
var $2O8g2 = parcelRequire("2O8g2");

var $5cfZt = parcelRequire("5cfZt");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");
parcelRequire("2h6kr");
var $74xSA = parcelRequire("74xSA");
const $25f9611519066f52$export$3a909d935747d7f7 = ({ itemOrder: itemOrder, result: result, term: term, showAllResults: showAllResults, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $9WE6n.default), result);
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const portalIdAsNumber = (0, $iwSnV.getPortalIdAsNumber)(portalId);
    const { title: title, description: description, displayLink: displayLink, isExternal: isExternal, id: id, searchBackend: searchBackend, searchAlgorithm: searchAlgorithm } = data;
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1US4))), {
        label: formatMessage((0, $5cfZt.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $iwSnV.formatText)(title, term) : '';
    const highlightedDescription = description ? (0, $iwSnV.formatText)(description, term) : '';
    const resourceDisplayLink = (0, $iwSnV.isSinglePortalSearch)(portalIdAsNumber) && showAllResults ? `/portal/${portalIdAsNumber}/article/${id}` : (0, $jsmb9.getUpdatedDisplayLinkForArticleSearch)(displayLink);
    const linkProps = (0, $6GVst.urlRefsAndTarget)({
        displayLink: resourceDisplayLink,
        isAnExternalResource: isExternal
    });
    (0, $8P7DW.useEffect)(()=>{
        (0, $iwSnV.sendSearchUIAnalyticEvents)({
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm,
            action: 'list-item-rendered',
            resourceType: 'article'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        portalId,
        searchAlgorithm,
        searchBackend
    ]);
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $iwSnV.useVisibilityState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        key: id,
        role: "listitem",
        xcss: $25f9611519066f52$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: "search-page-result"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        columnGap: "space.150",
        templateAreas: [
            'icon heading header-right',
            'icon subheading-left header-right',
            '. body body'
        ],
        templateColumns: "auto 1fr auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $25f9611519066f52$var$iconAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $74xSA.default), {
        result: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $25f9611519066f52$var$headingAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cS6Xr.Link), {
        key: id,
        href: resourceDisplayLink,
        actionSubjectId: isExternal ? 'external-article-link' : 'article-link',
        "data-test-id": "result-link-container",
        attributes: {
            itemOrder: itemOrder,
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(highlightedTitle) : (0, $f73iJ.sanitize)(highlightedTitle)
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: [
            $25f9611519066f52$var$subheadingLeftAreaStyles,
            $25f9611519066f52$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2O8g2.default), {
        result: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: isShortcutIconVisible ? $25f9611519066f52$var$headerRightAreaStylesVisible : $25f9611519066f52$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $25f9611519066f52$var$bodyAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("p", {
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(highlightedDescription) : (0, $f73iJ.sanitize)(highlightedDescription)
        }
    })))));
};
const $25f9611519066f52$var$ConnectedArticleItem = (0, $jvoWT.default)((state)=>{
    return {
        isLoggedIn: (0, $hx8zX.isLoggedIn)(state),
        themeColor: (0, $ikoP4.getThemeColor)(state)
    };
})($25f9611519066f52$export$3a909d935747d7f7);
var $25f9611519066f52$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($25f9611519066f52$var$ConnectedArticleItem);
const $25f9611519066f52$var$containerStyles = (0, $37U6z.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $25f9611519066f52$var$iconAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'icon',
    width: 'size.300',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    textDecoration: 'none'
});
const $25f9611519066f52$var$headingAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-large, normal)"
});
const $25f9611519066f52$var$subheadingStyles = (0, $37U6z.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $25f9611519066f52$var$subheadingLeftAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $25f9611519066f52$var$headerRightAreaStylesInVisible = (0, $37U6z.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $25f9611519066f52$var$headerRightAreaStylesVisible = (0, $37U6z.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $25f9611519066f52$var$bodyAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});

});
parcelRegister("9WE6n", function(module, exports) {
$parcel$export(module.exports, "default", () => $386f361b910fe94b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63fa11c5d5f9cc114afd96aa76db5d7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $386f361b910fe94b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "articleItemFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "__typename"
            },
            "action": "THROW",
            "path": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "description"
            },
            "action": "THROW",
            "path": "description"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW",
            "path": "displayLink"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW",
            "path": "isExternal"
        },
        {
            "kind": "ScalarField",
            "name": "searchBackend"
        },
        {
            "kind": "ScalarField",
            "name": "searchAlgorithm"
        },
        {
            "kind": "FragmentSpread",
            "name": "resourceIconFragment"
        },
        {
            "kind": "FragmentSpread",
            "name": "articleMetadataFragment"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$386f361b910fe94b$var$node.hash = "5d7a00f2cc5ab5ae9593661ae477e1bc";
var $386f361b910fe94b$export$2e2bcd8739ae039 = $386f361b910fe94b$var$node;

});

parcelRegister("f73iJ", function(module, exports) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("loEqA", function(module, exports) {


module.exports = window.DOMPurify || (window.DOMPurify = (parcelRequire("33QAo")).default || (parcelRequire("33QAo")));

});
parcelRegister("33QAo", function(module, exports) {
/*! @license DOMPurify 3.4.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.0/LICENSE */ 'use strict';
const { entries: $23aa715ed5e02c5e$var$entries, setPrototypeOf: $23aa715ed5e02c5e$var$setPrototypeOf, isFrozen: $23aa715ed5e02c5e$var$isFrozen, getPrototypeOf: $23aa715ed5e02c5e$var$getPrototypeOf, getOwnPropertyDescriptor: $23aa715ed5e02c5e$var$getOwnPropertyDescriptor } = Object;
let { freeze: $23aa715ed5e02c5e$var$freeze, seal: $23aa715ed5e02c5e$var$seal, create: $23aa715ed5e02c5e$var$create } = Object; // eslint-disable-line import/no-mutable-exports
let { apply: $23aa715ed5e02c5e$var$apply, construct: $23aa715ed5e02c5e$var$construct } = typeof Reflect !== 'undefined' && Reflect;
if (!$23aa715ed5e02c5e$var$freeze) $23aa715ed5e02c5e$var$freeze = function freeze(x) {
    return x;
};
if (!$23aa715ed5e02c5e$var$seal) $23aa715ed5e02c5e$var$seal = function seal(x) {
    return x;
};
if (!$23aa715ed5e02c5e$var$apply) $23aa715ed5e02c5e$var$apply = function apply(func, thisArg) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return func.apply(thisArg, args);
};
if (!$23aa715ed5e02c5e$var$construct) $23aa715ed5e02c5e$var$construct = function construct(Func) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return new Func(...args);
};
const $23aa715ed5e02c5e$var$arrayForEach = $23aa715ed5e02c5e$var$unapply(Array.prototype.forEach);
const $23aa715ed5e02c5e$var$arrayLastIndexOf = $23aa715ed5e02c5e$var$unapply(Array.prototype.lastIndexOf);
const $23aa715ed5e02c5e$var$arrayPop = $23aa715ed5e02c5e$var$unapply(Array.prototype.pop);
const $23aa715ed5e02c5e$var$arrayPush = $23aa715ed5e02c5e$var$unapply(Array.prototype.push);
const $23aa715ed5e02c5e$var$arraySplice = $23aa715ed5e02c5e$var$unapply(Array.prototype.splice);
const $23aa715ed5e02c5e$var$stringToLowerCase = $23aa715ed5e02c5e$var$unapply(String.prototype.toLowerCase);
const $23aa715ed5e02c5e$var$stringToString = $23aa715ed5e02c5e$var$unapply(String.prototype.toString);
const $23aa715ed5e02c5e$var$stringMatch = $23aa715ed5e02c5e$var$unapply(String.prototype.match);
const $23aa715ed5e02c5e$var$stringReplace = $23aa715ed5e02c5e$var$unapply(String.prototype.replace);
const $23aa715ed5e02c5e$var$stringIndexOf = $23aa715ed5e02c5e$var$unapply(String.prototype.indexOf);
const $23aa715ed5e02c5e$var$stringTrim = $23aa715ed5e02c5e$var$unapply(String.prototype.trim);
const $23aa715ed5e02c5e$var$objectHasOwnProperty = $23aa715ed5e02c5e$var$unapply(Object.prototype.hasOwnProperty);
const $23aa715ed5e02c5e$var$regExpTest = $23aa715ed5e02c5e$var$unapply(RegExp.prototype.test);
const $23aa715ed5e02c5e$var$typeErrorCreate = $23aa715ed5e02c5e$var$unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */ function $23aa715ed5e02c5e$var$unapply(func) {
    return function(thisArg) {
        if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $23aa715ed5e02c5e$var$apply(func, thisArg, args);
    };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */ function $23aa715ed5e02c5e$var$unconstruct(Func) {
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $23aa715ed5e02c5e$var$construct(Func, args);
    };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */ function $23aa715ed5e02c5e$var$addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $23aa715ed5e02c5e$var$stringToLowerCase;
    if ($23aa715ed5e02c5e$var$setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    $23aa715ed5e02c5e$var$setPrototypeOf(set, null);
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === 'string') {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!$23aa715ed5e02c5e$var$isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */ function $23aa715ed5e02c5e$var$cleanArray(array) {
    for(let index = 0; index < array.length; index++){
        const isPropertyExist = $23aa715ed5e02c5e$var$objectHasOwnProperty(array, index);
        if (!isPropertyExist) array[index] = null;
    }
    return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */ function $23aa715ed5e02c5e$var$clone(object) {
    const newObject = $23aa715ed5e02c5e$var$create(null);
    for (const [property, value] of $23aa715ed5e02c5e$var$entries(object)){
        const isPropertyExist = $23aa715ed5e02c5e$var$objectHasOwnProperty(object, property);
        if (isPropertyExist) {
            if (Array.isArray(value)) newObject[property] = $23aa715ed5e02c5e$var$cleanArray(value);
            else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = $23aa715ed5e02c5e$var$clone(value);
            else newObject[property] = value;
        }
    }
    return newObject;
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */ function $23aa715ed5e02c5e$var$lookupGetter(object, prop) {
    while(object !== null){
        const desc = $23aa715ed5e02c5e$var$getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return $23aa715ed5e02c5e$var$unapply(desc.get);
            if (typeof desc.value === 'function') return $23aa715ed5e02c5e$var$unapply(desc.value);
        }
        object = $23aa715ed5e02c5e$var$getPrototypeOf(object);
    }
    function fallbackValue() {
        return null;
    }
    return fallbackValue;
}
const $23aa715ed5e02c5e$var$html$1 = $23aa715ed5e02c5e$var$freeze([
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'search',
    'section',
    'select',
    'shadow',
    'slot',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr'
]);
const $23aa715ed5e02c5e$var$svg$1 = $23aa715ed5e02c5e$var$freeze([
    'svg',
    'a',
    'altglyph',
    'altglyphdef',
    'altglyphitem',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'circle',
    'clippath',
    'defs',
    'desc',
    'ellipse',
    'enterkeyhint',
    'exportparts',
    'filter',
    'font',
    'g',
    'glyph',
    'glyphref',
    'hkern',
    'image',
    'inputmode',
    'line',
    'lineargradient',
    'marker',
    'mask',
    'metadata',
    'mpath',
    'part',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialgradient',
    'rect',
    'stop',
    'style',
    'switch',
    'symbol',
    'text',
    'textpath',
    'title',
    'tref',
    'tspan',
    'view',
    'vkern'
]);
const $23aa715ed5e02c5e$var$svgFilters = $23aa715ed5e02c5e$var$freeze([
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence'
]);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const $23aa715ed5e02c5e$var$svgDisallowed = $23aa715ed5e02c5e$var$freeze([
    'animate',
    'color-profile',
    'cursor',
    'discard',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignobject',
    'hatch',
    'hatchpath',
    'mesh',
    'meshgradient',
    'meshpatch',
    'meshrow',
    'missing-glyph',
    'script',
    'set',
    'solidcolor',
    'unknown',
    'use'
]);
const $23aa715ed5e02c5e$var$mathMl$1 = $23aa715ed5e02c5e$var$freeze([
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'mprescripts'
]);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const $23aa715ed5e02c5e$var$mathMlDisallowed = $23aa715ed5e02c5e$var$freeze([
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none'
]);
const $23aa715ed5e02c5e$var$text = $23aa715ed5e02c5e$var$freeze([
    '#text'
]);
const $23aa715ed5e02c5e$var$html = $23aa715ed5e02c5e$var$freeze([
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'exportparts',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inert',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'part',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'slot',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns',
    'slot'
]);
const $23aa715ed5e02c5e$var$svg = $23aa715ed5e02c5e$var$freeze([
    'accent-height',
    'accumulate',
    'additive',
    'alignment-baseline',
    'amplitude',
    'ascent',
    'attributename',
    'attributetype',
    'azimuth',
    'basefrequency',
    'baseline-shift',
    'begin',
    'bias',
    'by',
    'class',
    'clip',
    'clippathunits',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'diffuseconstant',
    'direction',
    'display',
    'divisor',
    'dur',
    'edgemode',
    'elevation',
    'end',
    'exponent',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'filterunits',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyph-name',
    'glyphref',
    'gradientunits',
    'gradienttransform',
    'height',
    'href',
    'id',
    'image-rendering',
    'in',
    'in2',
    'intercept',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kerning',
    'keypoints',
    'keysplines',
    'keytimes',
    'lang',
    'lengthadjust',
    'letter-spacing',
    'kernelmatrix',
    'kernelunitlength',
    'lighting-color',
    'local',
    'marker-end',
    'marker-mid',
    'marker-start',
    'markerheight',
    'markerunits',
    'markerwidth',
    'maskcontentunits',
    'maskunits',
    'max',
    'mask',
    'mask-type',
    'media',
    'method',
    'mode',
    'min',
    'name',
    'numoctaves',
    'offset',
    'operator',
    'opacity',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'paint-order',
    'path',
    'pathlength',
    'patterncontentunits',
    'patterntransform',
    'patternunits',
    'points',
    'preservealpha',
    'preserveaspectratio',
    'primitiveunits',
    'r',
    'rx',
    'ry',
    'radius',
    'refx',
    'refy',
    'repeatcount',
    'repeatdur',
    'restart',
    'result',
    'rotate',
    'scale',
    'seed',
    'shape-rendering',
    'slope',
    'specularconstant',
    'specularexponent',
    'spreadmethod',
    'startoffset',
    'stddeviation',
    'stitchtiles',
    'stop-color',
    'stop-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke',
    'stroke-width',
    'style',
    'surfacescale',
    'systemlanguage',
    'tabindex',
    'tablevalues',
    'targetx',
    'targety',
    'transform',
    'transform-origin',
    'text-anchor',
    'text-decoration',
    'text-rendering',
    'textlength',
    'type',
    'u1',
    'u2',
    'unicode',
    'values',
    'viewbox',
    'visibility',
    'version',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'width',
    'word-spacing',
    'wrap',
    'writing-mode',
    'xchannelselector',
    'ychannelselector',
    'x',
    'x1',
    'x2',
    'xmlns',
    'y',
    'y1',
    'y2',
    'z',
    'zoomandpan'
]);
const $23aa715ed5e02c5e$var$mathMl = $23aa715ed5e02c5e$var$freeze([
    'accent',
    'accentunder',
    'align',
    'bevelled',
    'close',
    'columnalign',
    'columnlines',
    'columnspacing',
    'columnspan',
    'denomalign',
    'depth',
    'dir',
    'display',
    'displaystyle',
    'encoding',
    'fence',
    'frame',
    'height',
    'href',
    'id',
    'largeop',
    'length',
    'linethickness',
    'lquote',
    'lspace',
    'mathbackground',
    'mathcolor',
    'mathsize',
    'mathvariant',
    'maxsize',
    'minsize',
    'movablelimits',
    'notation',
    'numalign',
    'open',
    'rowalign',
    'rowlines',
    'rowspacing',
    'rowspan',
    'rspace',
    'rquote',
    'scriptlevel',
    'scriptminsize',
    'scriptsizemultiplier',
    'selection',
    'separator',
    'separators',
    'stretchy',
    'subscriptshift',
    'supscriptshift',
    'symmetric',
    'voffset',
    'width',
    'xmlns'
]);
const $23aa715ed5e02c5e$var$xml = $23aa715ed5e02c5e$var$freeze([
    'xlink:href',
    'xml:id',
    'xlink:title',
    'xml:space',
    'xmlns:xlink'
]);
// eslint-disable-next-line unicorn/better-regex
const $23aa715ed5e02c5e$var$MUSTACHE_EXPR = $23aa715ed5e02c5e$var$seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
const $23aa715ed5e02c5e$var$ERB_EXPR = $23aa715ed5e02c5e$var$seal(/<%[\w\W]*|[\w\W]*%>/gm);
const $23aa715ed5e02c5e$var$TMPLIT_EXPR = $23aa715ed5e02c5e$var$seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
const $23aa715ed5e02c5e$var$DATA_ATTR = $23aa715ed5e02c5e$var$seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const $23aa715ed5e02c5e$var$ARIA_ATTR = $23aa715ed5e02c5e$var$seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const $23aa715ed5e02c5e$var$IS_ALLOWED_URI = $23aa715ed5e02c5e$var$seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const $23aa715ed5e02c5e$var$IS_SCRIPT_OR_DATA = $23aa715ed5e02c5e$var$seal(/^(?:\w+script|data):/i);
const $23aa715ed5e02c5e$var$ATTR_WHITESPACE = $23aa715ed5e02c5e$var$seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const $23aa715ed5e02c5e$var$DOCTYPE_NAME = $23aa715ed5e02c5e$var$seal(/^html$/i);
const $23aa715ed5e02c5e$var$CUSTOM_ELEMENT = $23aa715ed5e02c5e$var$seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var $23aa715ed5e02c5e$var$EXPRESSIONS = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ARIA_ATTR: $23aa715ed5e02c5e$var$ARIA_ATTR,
    ATTR_WHITESPACE: $23aa715ed5e02c5e$var$ATTR_WHITESPACE,
    CUSTOM_ELEMENT: $23aa715ed5e02c5e$var$CUSTOM_ELEMENT,
    DATA_ATTR: $23aa715ed5e02c5e$var$DATA_ATTR,
    DOCTYPE_NAME: $23aa715ed5e02c5e$var$DOCTYPE_NAME,
    ERB_EXPR: $23aa715ed5e02c5e$var$ERB_EXPR,
    IS_ALLOWED_URI: $23aa715ed5e02c5e$var$IS_ALLOWED_URI,
    IS_SCRIPT_OR_DATA: $23aa715ed5e02c5e$var$IS_SCRIPT_OR_DATA,
    MUSTACHE_EXPR: $23aa715ed5e02c5e$var$MUSTACHE_EXPR,
    TMPLIT_EXPR: $23aa715ed5e02c5e$var$TMPLIT_EXPR
});
/* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const $23aa715ed5e02c5e$var$NODE_TYPE = {
    element: 1,
    text: 3,
    // Deprecated
    progressingInstruction: 7,
    comment: 8,
    document: 9
};
const $23aa715ed5e02c5e$var$getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const $23aa715ed5e02c5e$var$_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
    }
};
const $23aa715ed5e02c5e$var$_createHooksMap = function _createHooksMap() {
    return {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
    };
};
function $23aa715ed5e02c5e$var$createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $23aa715ed5e02c5e$var$getGlobal();
    const DOMPurify = (root)=>$23aa715ed5e02c5e$var$createDOMPurify(root);
    DOMPurify.version = '3.4.0';
    DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== $23aa715ed5e02c5e$var$NODE_TYPE.document || !window1.Element) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    let { document: document } = window1;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
    const ElementPrototype = Element.prototype;
    const cloneNode = $23aa715ed5e02c5e$var$lookupGetter(ElementPrototype, 'cloneNode');
    const remove = $23aa715ed5e02c5e$var$lookupGetter(ElementPrototype, 'remove');
    const getNextSibling = $23aa715ed5e02c5e$var$lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = $23aa715ed5e02c5e$var$lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = $23aa715ed5e02c5e$var$lookupGetter(ElementPrototype, 'parentNode');
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        const template = document.createElement('template');
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
    const { importNode: importNode } = originalDocument;
    let hooks = $23aa715ed5e02c5e$var$_createHooksMap();
    /**
   * Expose whether this browser supports running the full DOMPurify.
   */ DOMPurify.isSupported = typeof $23aa715ed5e02c5e$var$entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = $23aa715ed5e02c5e$var$EXPRESSIONS;
    let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = $23aa715ed5e02c5e$var$EXPRESSIONS;
    /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */ /* allowed element names */ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = $23aa715ed5e02c5e$var$addToSet({}, [
        ...$23aa715ed5e02c5e$var$html$1,
        ...$23aa715ed5e02c5e$var$svg$1,
        ...$23aa715ed5e02c5e$var$svgFilters,
        ...$23aa715ed5e02c5e$var$mathMl$1,
        ...$23aa715ed5e02c5e$var$text
    ]);
    /* Allowed attribute names */ let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = $23aa715ed5e02c5e$var$addToSet({}, [
        ...$23aa715ed5e02c5e$var$html,
        ...$23aa715ed5e02c5e$var$svg,
        ...$23aa715ed5e02c5e$var$mathMl,
        ...$23aa715ed5e02c5e$var$xml
    ]);
    /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */ let CUSTOM_ELEMENT_HANDLING = Object.seal($23aa715ed5e02c5e$var$create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
    /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal($23aa715ed5e02c5e$var$create(null, {
        tagCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        }
    }));
    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */ let SAFE_FOR_TEMPLATES = false;
    /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */ let SAFE_FOR_XML = true;
    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */ let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */ let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */ let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = $23aa715ed5e02c5e$var$addToSet({}, [
        'annotation-xml',
        'audio',
        'colgroup',
        'desc',
        'foreignobject',
        'head',
        'iframe',
        'math',
        'mi',
        'mn',
        'mo',
        'ms',
        'mtext',
        'noembed',
        'noframes',
        'noscript',
        'plaintext',
        'script',
        'style',
        'svg',
        'template',
        'thead',
        'title',
        'video',
        'xmp'
    ]);
    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = $23aa715ed5e02c5e$var$addToSet({}, [
        'audio',
        'video',
        'img',
        'source',
        'image',
        'track'
    ]);
    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = $23aa715ed5e02c5e$var$addToSet({}, [
        'alt',
        'class',
        'for',
        'id',
        'label',
        'name',
        'pattern',
        'placeholder',
        'role',
        'summary',
        'title',
        'value',
        'style',
        'xmlns'
    ]);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = $23aa715ed5e02c5e$var$addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], $23aa715ed5e02c5e$var$stringToString);
    let MATHML_TEXT_INTEGRATION_POINTS = $23aa715ed5e02c5e$var$addToSet({}, [
        'mi',
        'mo',
        'mn',
        'ms',
        'mtext'
    ]);
    let HTML_INTEGRATION_POINTS = $23aa715ed5e02c5e$var$addToSet({}, [
        'annotation-xml'
    ]);
    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = $23aa715ed5e02c5e$var$addToSet({}, [
        'title',
        'style',
        'font',
        'a',
        'script'
    ]);
    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        'application/xhtml+xml',
        'text/html'
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;
    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */ // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (CONFIG && CONFIG === cfg) return;
        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
        /* Shield configuration object from prototype pollution */ cfg = $23aa715ed5e02c5e$var$clone(cfg);
        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
        // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? $23aa715ed5e02c5e$var$stringToString : $23aa715ed5e02c5e$var$stringToLowerCase;
        /* Set configuration parameters */ ALLOWED_TAGS = $23aa715ed5e02c5e$var$objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? $23aa715ed5e02c5e$var$addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = $23aa715ed5e02c5e$var$objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? $23aa715ed5e02c5e$var$addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
        ALLOWED_NAMESPACES = $23aa715ed5e02c5e$var$objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? $23aa715ed5e02c5e$var$addToSet({}, cfg.ALLOWED_NAMESPACES, $23aa715ed5e02c5e$var$stringToString) : DEFAULT_ALLOWED_NAMESPACES;
        URI_SAFE_ATTRIBUTES = $23aa715ed5e02c5e$var$objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? $23aa715ed5e02c5e$var$addToSet($23aa715ed5e02c5e$var$clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
        DATA_URI_TAGS = $23aa715ed5e02c5e$var$objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? $23aa715ed5e02c5e$var$addToSet($23aa715ed5e02c5e$var$clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
        FORBID_CONTENTS = $23aa715ed5e02c5e$var$objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? $23aa715ed5e02c5e$var$addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
        FORBID_TAGS = $23aa715ed5e02c5e$var$objectHasOwnProperty(cfg, 'FORBID_TAGS') ? $23aa715ed5e02c5e$var$addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : $23aa715ed5e02c5e$var$clone({});
        FORBID_ATTR = $23aa715ed5e02c5e$var$objectHasOwnProperty(cfg, 'FORBID_ATTR') ? $23aa715ed5e02c5e$var$addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : $23aa715ed5e02c5e$var$clone({});
        USE_PROFILES = $23aa715ed5e02c5e$var$objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
        IN_PLACE = cfg.IN_PLACE || false; // Default false
        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || $23aa715ed5e02c5e$var$IS_ALLOWED_URI;
        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
        MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
        HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
        CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || $23aa715ed5e02c5e$var$create(null);
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        /* Parse profile info */ if (USE_PROFILES) {
            ALLOWED_TAGS = $23aa715ed5e02c5e$var$addToSet({}, $23aa715ed5e02c5e$var$text);
            ALLOWED_ATTR = $23aa715ed5e02c5e$var$create(null);
            if (USE_PROFILES.html === true) {
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_TAGS, $23aa715ed5e02c5e$var$html$1);
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_ATTR, $23aa715ed5e02c5e$var$html);
            }
            if (USE_PROFILES.svg === true) {
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_TAGS, $23aa715ed5e02c5e$var$svg$1);
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_ATTR, $23aa715ed5e02c5e$var$svg);
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_ATTR, $23aa715ed5e02c5e$var$xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_TAGS, $23aa715ed5e02c5e$var$svgFilters);
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_ATTR, $23aa715ed5e02c5e$var$svg);
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_ATTR, $23aa715ed5e02c5e$var$xml);
            }
            if (USE_PROFILES.mathMl === true) {
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_TAGS, $23aa715ed5e02c5e$var$mathMl$1);
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_ATTR, $23aa715ed5e02c5e$var$mathMl);
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_ATTR, $23aa715ed5e02c5e$var$xml);
            }
        }
        /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
     * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
        EXTRA_ELEMENT_HANDLING.attributeCheck = null;
        /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
            if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
            else {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = $23aa715ed5e02c5e$var$clone(ALLOWED_TAGS);
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
        }
        if (cfg.ADD_ATTR) {
            if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
            else {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = $23aa715ed5e02c5e$var$clone(ALLOWED_ATTR);
                $23aa715ed5e02c5e$var$addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
        }
        if (cfg.ADD_URI_SAFE_ATTR) $23aa715ed5e02c5e$var$addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        if (cfg.FORBID_CONTENTS) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $23aa715ed5e02c5e$var$clone(FORBID_CONTENTS);
            $23aa715ed5e02c5e$var$addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        if (cfg.ADD_FORBID_CONTENTS) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $23aa715ed5e02c5e$var$clone(FORBID_CONTENTS);
            $23aa715ed5e02c5e$var$addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) $23aa715ed5e02c5e$var$addToSet(ALLOWED_TAGS, [
            'html',
            'head',
            'body'
        ]);
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
            $23aa715ed5e02c5e$var$addToSet(ALLOWED_TAGS, [
                'tbody'
            ]);
            delete FORBID_TAGS.tbody;
        }
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw $23aa715ed5e02c5e$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw $23aa715ed5e02c5e$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
            // Overwrite existing TrustedTypes policy.
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
            // Sign local variables required by `sanitize`.
            emptyHTML = trustedTypesPolicy.createHTML('');
        } else {
            // Uninitialized policy, attempt to initialize the internal dompurify policy.
            if (trustedTypesPolicy === undefined) trustedTypesPolicy = $23aa715ed5e02c5e$var$_createTrustedTypesPolicy(trustedTypes, currentScript);
            // If creating the internal policy succeeded sign internal variables.
            if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
        }
        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if ($23aa715ed5e02c5e$var$freeze) $23aa715ed5e02c5e$var$freeze(cfg);
        CONFIG = cfg;
    };
    /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */ const ALL_SVG_TAGS = $23aa715ed5e02c5e$var$addToSet({}, [
        ...$23aa715ed5e02c5e$var$svg$1,
        ...$23aa715ed5e02c5e$var$svgFilters,
        ...$23aa715ed5e02c5e$var$svgDisallowed
    ]);
    const ALL_MATHML_TAGS = $23aa715ed5e02c5e$var$addToSet({}, [
        ...$23aa715ed5e02c5e$var$mathMl$1,
        ...$23aa715ed5e02c5e$var$mathMlDisallowed
    ]);
    /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */ const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element);
        // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.
        if (!parent || !parent.tagName) parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
        };
        const tagName = $23aa715ed5e02c5e$var$stringToLowerCase(element.tagName);
        const parentTagName = $23aa715ed5e02c5e$var$stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
        if (element.namespaceURI === SVG_NAMESPACE) {
            // The only way to switch from HTML namespace to SVG
            // is via <svg>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
            // The only way to switch from MathML to SVG is via`
            // svg if parent is either <annotation-xml> or MathML
            // text integration points.
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            // We only allow elements that are defined in SVG
            // spec. All others are disallowed in SVG namespace.
            return Boolean(ALL_SVG_TAGS[tagName]);
        }
        if (element.namespaceURI === MATHML_NAMESPACE) {
            // The only way to switch from HTML namespace to MathML
            // is via <math>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
            // The only way to switch from SVG to MathML is via
            // <math> and HTML integration points
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
            // We only allow elements that are defined in MathML
            // spec. All others are disallowed in MathML namespace.
            return Boolean(ALL_MATHML_TAGS[tagName]);
        }
        if (element.namespaceURI === HTML_NAMESPACE) {
            // The only way to switch from SVG to HTML is via
            // HTML integration points, and from MathML to HTML
            // is via MathML text integration points
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
            // We disallow tags that are specific for MathML
            // or SVG and should never appear in HTML namespace
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        }
        // For XHTML and XML documents that support custom namespaces
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
        // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.
        return false;
    };
    /**
   * _forceRemove
   *
   * @param node a DOM node
   */ const _forceRemove = function _forceRemove(node) {
        $23aa715ed5e02c5e$var$arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            getParentNode(node).removeChild(node);
        } catch (_) {
            remove(node);
        }
    };
    /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */ const _removeAttribute = function _removeAttribute(name, element) {
        try {
            $23aa715ed5e02c5e$var$arrayPush(DOMPurify.removed, {
                attribute: element.getAttributeNode(name),
                from: element
            });
        } catch (_) {
            $23aa715ed5e02c5e$var$arrayPush(DOMPurify.removed, {
                attribute: null,
                from: element
            });
        }
        element.removeAttribute(name);
        // We void attribute values for unremovable "is" attributes
        if (name === 'is') {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(element);
            } catch (_) {}
            else try {
                element.setAttribute(name, '');
            } catch (_) {}
        }
    };
    /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */ const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */ let doc = null;
        let leadingWhitespace = null;
        if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
        else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = $23aa715ed5e02c5e$var$stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
        /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */ if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, 'template', null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {
            // Syntax error if dirtyPayload is invalid xml
            }
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */ const _createNodeIterator = function _createNodeIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */ const _isClobbered = function _isClobbered(element) {
        return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
    };
    /**
   * Checks whether the given object is a DOM node.
   *
   * @param value object to check whether it's a DOM node
   * @return true is object is a DOM node
   */ const _isNode = function _isNode(value) {
        return typeof Node === 'function' && value instanceof Node;
    };
    function _executeHooks(hooks, currentNode, data) {
        $23aa715ed5e02c5e$var$arrayForEach(hooks, (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    }
    /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */ const _sanitizeElements = function _sanitizeElements(currentNode) {
        let content = null;
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
        /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });
        /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && $23aa715ed5e02c5e$var$regExpTest(/<[/\w!]/g, currentNode.innerHTML) && $23aa715ed5e02c5e$var$regExpTest(/<[/\w!]/g, currentNode.textContent)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === $23aa715ed5e02c5e$var$NODE_TYPE.progressingInstruction) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === $23aa715ed5e02c5e$var$NODE_TYPE.comment && $23aa715ed5e02c5e$var$regExpTest(/<[/\w]/g, currentNode.data)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
            /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $23aa715ed5e02c5e$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
            }
            /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    for(let i = childCount - 1; i >= 0; --i){
                        const childClone = cloneNode(childNodes[i], true);
                        childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                        parentNode.insertBefore(childClone, getNextSibling(currentNode));
                    }
                }
            }
            _forceRemove(currentNode);
            return true;
        }
        /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && $23aa715ed5e02c5e$var$regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === $23aa715ed5e02c5e$var$NODE_TYPE.text) {
            /* Get the element's text content */ content = currentNode.textContent;
            $23aa715ed5e02c5e$var$arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                content = $23aa715ed5e02c5e$var$stringReplace(content, expr, ' ');
            });
            if (currentNode.textContent !== content) {
                $23aa715ed5e02c5e$var$arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
        return false;
    };
    /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */ // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
        /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && $23aa715ed5e02c5e$var$regExpTest(DATA_ATTR, lcName)) ;
        else if (ALLOW_ARIA_ATTR && $23aa715ed5e02c5e$var$regExpTest(ARIA_ATTR, lcName)) ;
        else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
        else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
            if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $23aa715ed5e02c5e$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && $23aa715ed5e02c5e$var$regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $23aa715ed5e02c5e$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
            else return false;
        /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
        else if ($23aa715ed5e02c5e$var$regExpTest(IS_ALLOWED_URI$1, $23aa715ed5e02c5e$var$stringReplace(value, ATTR_WHITESPACE, ''))) ;
        else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && $23aa715ed5e02c5e$var$stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
        else if (ALLOW_UNKNOWN_PROTOCOLS && !$23aa715ed5e02c5e$var$regExpTest(IS_SCRIPT_OR_DATA, $23aa715ed5e02c5e$var$stringReplace(value, ATTR_WHITESPACE, ''))) ;
        else if (value) return false;
        return true;
    };
    /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
        return tagName !== 'annotation-xml' && $23aa715ed5e02c5e$var$stringMatch(tagName, CUSTOM_ELEMENT);
    };
    /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
        const { attributes: attributes } = currentNode;
        /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
        const hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR,
            forceKeepAttr: undefined
        };
        let l = attributes.length;
        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
            const attr = attributes[l];
            const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
            const lcName = transformCaseFunc(name);
            const initValue = attrValue;
            let value = name === 'value' ? initValue : $23aa715ed5e02c5e$var$stringTrim(initValue);
            /* Execute a hook if present */ hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
            _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
            value = hookEvent.attrValue;
            /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode);
                // Prefix the value and later re-create the attribute with the sanitized value
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && $23aa715ed5e02c5e$var$regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && $23aa715ed5e02c5e$var$stringMatch(value, 'href')) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && $23aa715ed5e02c5e$var$regExpTest(/\/>/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) $23aa715ed5e02c5e$var$arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                value = $23aa715ed5e02c5e$var$stringReplace(value, expr, ' ');
            });
            /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
            if (!_isValidAttribute(lcTag, lcName, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                if (namespaceURI) ;
                else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                    case 'TrustedHTML':
                        value = trustedTypesPolicy.createHTML(value);
                        break;
                    case 'TrustedScriptURL':
                        value = trustedTypesPolicy.createScriptURL(value);
                        break;
                }
            }
            /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                if (_isClobbered(currentNode)) _forceRemove(currentNode);
                else $23aa715ed5e02c5e$var$arrayPop(DOMPurify.removed);
            } catch (_) {
                _removeAttribute(name, currentNode);
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
    };
    /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
        let shadowNode = null;
        const shadowIterator = _createNodeIterator(fragment);
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
            /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
            /* Check attributes next */ _sanitizeAttributes(shadowNode);
            /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM2(shadowNode.content);
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body = null;
        let importedNode = null;
        let currentNode = null;
        let returnNode = null;
        /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = '<!-->';
        /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
            if (typeof dirty.toString === 'function') {
                dirty = dirty.toString();
                if (typeof dirty !== 'string') throw $23aa715ed5e02c5e$var$typeErrorCreate('dirty is not a string, aborting');
            } else throw $23aa715ed5e02c5e$var$typeErrorCreate('toString is not a function');
        }
        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
        /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
        /* Clean up removed elements */ DOMPurify.removed = [];
        /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
        if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
            if (dirty.nodeName) {
                const tagName = transformCaseFunc(dirty.nodeName);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw $23aa715ed5e02c5e$var$typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
            }
        } else if (dirty instanceof Node) {
            /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */ body = _initDocument('<!---->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === $23aa715ed5e02c5e$var$NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
            else if (importedNode.nodeName === 'HTML') body = importedNode;
            else // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
        } else {
            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /* Initialize the document to work on */ body = _initDocument(dirty);
            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
        /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
        /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
            /* Sanitize tags and elements */ _sanitizeElements(currentNode);
            /* Check attributes next */ _sanitizeAttributes(currentNode);
            /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM2(currentNode.content);
        }
        /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
        /* Return sanitized string or DOM */ if (RETURN_DOM) {
            if (SAFE_FOR_TEMPLATES) {
                body.normalize();
                let html = body.innerHTML;
                $23aa715ed5e02c5e$var$arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    html = $23aa715ed5e02c5e$var$stringReplace(html, expr, ' ');
                });
                body.innerHTML = html;
            }
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */ returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && $23aa715ed5e02c5e$var$regExpTest($23aa715ed5e02c5e$var$DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) $23aa715ed5e02c5e$var$arrayForEach([
            MUSTACHE_EXPR,
            ERB_EXPR,
            TMPLIT_EXPR
        ], (expr)=>{
            serializedHTML = $23aa715ed5e02c5e$var$stringReplace(serializedHTML, expr, ' ');
        });
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _parseConfig(cfg);
        SET_CONFIG = true;
    };
    DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
    };
    DOMPurify.isValidAttribute = function(tag, attr, value) {
        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') return;
        $23aa715ed5e02c5e$var$arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function(entryPoint, hookFunction) {
        if (hookFunction !== undefined) {
            const index = $23aa715ed5e02c5e$var$arrayLastIndexOf(hooks[entryPoint], hookFunction);
            return index === -1 ? undefined : $23aa715ed5e02c5e$var$arraySplice(hooks[entryPoint], index, 1)[0];
        }
        return $23aa715ed5e02c5e$var$arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function(entryPoint) {
        hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function() {
        hooks = $23aa715ed5e02c5e$var$_createHooksMap();
    };
    return DOMPurify;
}
var $23aa715ed5e02c5e$var$purify = $23aa715ed5e02c5e$var$createDOMPurify();
module.exports = $23aa715ed5e02c5e$var$purify;

});


parcelRegister("c1US4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37ca97229df724c6f3bb2fd1042c4b60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c21b16ec4cd509b$var$_react = $8c21b16ec4cd509b$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $8c21b16ec4cd509b$var$_baseNew = $8c21b16ec4cd509b$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $8c21b16ec4cd509b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shortcut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c21b16ec4cd509b$var$ShortcutIcon = (props)=>/*#__PURE__*/ $8c21b16ec4cd509b$var$_react.default.createElement($8c21b16ec4cd509b$var$_baseNew.default, Object.assign({
        name: "ShortcutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.25 2.25V0h1.5v2.25H16v1.5h-2.25V6h-1.5V3.75H10v-1.5zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5H15V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$8c21b16ec4cd509b$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $8c21b16ec4cd509b$var$_default = module.exports.default = $8c21b16ec4cd509b$var$ShortcutIcon;

});

parcelRegister("6GVst", function(module, exports) {
$parcel$export(module.exports, "typeMap", () => $c933600cbcaf064d$export$ca0f3793b4450a5d);
$parcel$export(module.exports, "isExternalResource", () => $c933600cbcaf064d$export$fe3f86d8e6082cf);
$parcel$export(module.exports, "isThirdPartyArticle", () => $c933600cbcaf064d$export$97275da1bf1c8425);
$parcel$export(module.exports, "urlRefsAndTarget", () => $c933600cbcaf064d$export$a54b3eec1418fa47);

var $1EFS8 = parcelRequire("1EFS8");

var $7FSs7 = parcelRequire("7FSs7");
const $c933600cbcaf064d$export$ca0f3793b4450a5d = {
    REQUEST_FORM: 'REQUEST_FORM',
    ARTICLE: 'ARTICLE',
    EXTERNAL_RESOURCE: 'ati:cloud:jira-servicedesk:external-resource'
};
const $c933600cbcaf064d$export$fe3f86d8e6082cf = (entityKey)=>{
    return entityKey === $c933600cbcaf064d$export$ca0f3793b4450a5d.EXTERNAL_RESOURCE;
};
const $c933600cbcaf064d$export$97275da1bf1c8425 = (sourceType)=>{
    return (0, $1EFS8.default).checkGate('3p-integration-enabled_t5ysh') && !!sourceType && [
        'GOOGLE_DRIVE',
        'SHAREPOINT',
        'EXTERNAL_RESOURCES'
    ].includes(sourceType);
};
const $c933600cbcaf064d$var$getUrlForRouter = (displayLink)=>{
    return displayLink.startsWith('/') ? displayLink.replace((0, $7FSs7.getRelativeBasePath)(), '') : displayLink.replace(`${location.origin}${(0, $7FSs7.getRelativeBasePath)()}`, '');
};
const $c933600cbcaf064d$export$a54b3eec1418fa47 = ({ displayLink: displayLink, isAnExternalResource: isAnExternalResource })=>isAnExternalResource ? {
        href: displayLink,
        target: '_blank'
    } : {
        to: $c933600cbcaf064d$var$getUrlForRouter(displayLink),
        target: '_self'
    };

});

parcelRegister("hHpfl", function(module, exports) {
$parcel$export(module.exports, "ArticleMetadata", () => (parcelRequire("2O8g2")).default);

var $2O8g2 = parcelRequire("2O8g2");

});
parcelRegister("2O8g2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7022805eddc28a3$export$2e2bcd8739ae039);

var $8oUbz = parcelRequire("8oUbz");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
parcelRequire("fMSDi");
var $2YHJe = parcelRequire("2YHJe");

var $6Hfjm = parcelRequire("6Hfjm");

var $1ESfd = parcelRequire("1ESfd");
const $f7022805eddc28a3$export$9f18a4080cf334b5 = ({ isLoggedIn: isLoggedIn, result: result })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $8oUbz.default), result);
    const { id: id, displayLink: displayLink, isExternal: isExternal, containerDisplayName: containerDisplayName } = data;
    const { data: { source: source } } = (0, $2YHJe.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const confluencePageText = containerDisplayName ? formatMessage((0, $1ESfd.default).confluencePage, {
        value: containerDisplayName
    }) : '';
    const showSeparator = source && containerDisplayName;
    const externalResourceText = `${source ? source : ''} ${showSeparator ? `\u{2022}` : ''} ${containerDisplayName ? containerDisplayName : ''}`;
    const metaData = !isExternal ? confluencePageText : externalResourceText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        key: id
    }, metaData);
};
const $f7022805eddc28a3$var$ConnectedArticleMetadata = (0, $jvoWT.default)((state)=>{
    return {
        isLoggedIn: (0, $hx8zX.isLoggedIn)(state)
    };
})($f7022805eddc28a3$export$9f18a4080cf334b5);
var $f7022805eddc28a3$export$2e2bcd8739ae039 = $f7022805eddc28a3$var$ConnectedArticleMetadata;

});
parcelRegister("8oUbz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c254915e6fcc01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eb7e2dfb05658aa616f662a4f7a433d6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f0c254915e6fcc01$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "articleMetadataFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW",
            "path": "displayLink"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW",
            "path": "isExternal"
        },
        {
            "kind": "ScalarField",
            "name": "containerDisplayName"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$f0c254915e6fcc01$var$node.hash = "243125c226275a9fa5bff8db86192050";
var $f0c254915e6fcc01$export$2e2bcd8739ae039 = $f0c254915e6fcc01$var$node;

});

parcelRegister("fMSDi", function(module, exports) {
$parcel$export(module.exports, "useExternalLink", () => (parcelRequire("2YHJe")).useExternalLink);

var $2YHJe = parcelRequire("2YHJe");

});
parcelRegister("2YHJe", function(module, exports) {
$parcel$export(module.exports, "useExternalLink", () => $c188a5a3e592a532$export$408a40e8acea91be);

var $8P7DW = parcelRequire("8P7DW");

var $45QxO = parcelRequire("45QxO");

var $5ezvE = parcelRequire("5ezvE");

var $aIQ9W = parcelRequire("aIQ9W");
const $c188a5a3e592a532$export$2c4a28c399ed5beb = (urls)=>{
    return (0, $5ezvE.fetchObjectsFromUrls)(urls).toPromise().then((response)=>{
        return urls.reduce((ref, url, index)=>({
                ...ref,
                [url]: response[index]
            }), {});
    });
};
const $c188a5a3e592a532$var$batchedFetchIcon = (0, $aIQ9W.default)($c188a5a3e592a532$export$2c4a28c399ed5beb, 0);
const $c188a5a3e592a532$export$7666a60147fbe378 = {};
const $c188a5a3e592a532$var$addExternalLinkToCache = (key, value)=>{
    $c188a5a3e592a532$export$7666a60147fbe378[key] = value;
};
function $c188a5a3e592a532$export$408a40e8acea91be({ isLoggedIn: isLoggedIn, link: url }) {
    const initialState = (0, $8P7DW.useMemo)(()=>({
            name: null,
            iconUrl: null,
            source: null
        }), []);
    const [data, setData] = (0, $8P7DW.useState)(initialState);
    const [isLoading, setIsLoading] = (0, $8P7DW.useState)(true);
    const markDataLoaded = (key, value)=>{
        setIsLoading(false);
        setData(value);
        $c188a5a3e592a532$var$addExternalLinkToCache(key, value);
    };
    (0, $8P7DW.useEffect)(()=>{
        let href = url;
        if (!isLoggedIn) {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * Try to parse the url and extract out the href
     * if it fails return null as the icon url
     */ try {
            href = new URL(url).href;
        } catch (error) {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * Origin is null for other supported url forms like `tel:` and `mail:`
     * return null so that ui can fallback to default icons
     */ if (new URL(url).origin === 'null') {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * check is there is already entry in cache
     * if yes, return the icon url
     * else, make a call to object resolver service
     */ if (Object.keys($c188a5a3e592a532$export$7666a60147fbe378).includes(href)) {
            setData($c188a5a3e592a532$export$7666a60147fbe378[href]);
            setIsLoading(false);
        } else $c188a5a3e592a532$var$batchedFetchIcon(href).then((response)=>{
            var _response$href, _response$href2, _response$href3;
            const source = (_response$href = response[href]) === null || _response$href === void 0 || (_response$href = _response$href.body.data) === null || _response$href === void 0 || (_response$href = _response$href.generator) === null || _response$href === void 0 ? void 0 : _response$href.name;
            /**
         * ORS returns old Confluence icon
         * Until the icon is updated in ORS we should use the new icon from assets
         */ const iconUrl = source === 'Confluence' ? (0, (/*@__PURE__*/$parcel$interopDefault($45QxO))) : (_response$href2 = response[href]) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.body) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.data) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.generator) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.icon) === null || _response$href2 === void 0 ? void 0 : _response$href2.url;
            markDataLoaded(href, {
                iconUrl: iconUrl,
                source: source,
                name: (_response$href3 = response[href]) === null || _response$href3 === void 0 || (_response$href3 = _response$href3.body.data) === null || _response$href3 === void 0 ? void 0 : _response$href3.name
            });
        }).catch(()=>{
            return null;
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        initialState,
        isLoggedIn,
        url
    ]);
    return {
        data: data,
        isLoading: isLoading
    };
}

});
parcelRegister("45QxO", function(module, exports) {
module.exports = new URL("../images/confluence-icon.3f9a0ccd.svg", import.meta.url).toString();

});

parcelRegister("5ezvE", function(module, exports) {
$parcel$export(module.exports, "fetchObjectsFromUrls", () => $9b49fcfc12f57fe5$export$bf4b9b9bdb5d08c9);

var $bhOdO = parcelRequire("bhOdO");

var $breWd = parcelRequire("breWd");
const $9b49fcfc12f57fe5$export$bf4b9b9bdb5d08c9 = (urls)=>{
    return (0, $breWd.post)('/gateway/api/object-resolver/resolve/batch', urls.map((url)=>({
            resourceUrl: url
        })), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $bhOdO.Observable).throw(e));
};

});



parcelRegister("1ESfd", function(module, exports) {
$parcel$export(module.exports, "default", () => $a137de41d4589846$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $a137de41d4589846$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    confluencePage: {
        defaultMessage: 'Confluence page in {value}',
        description: 'Confluence page metadata text',
        id: 'cv.search.articles.metadata'
    }
});

});



parcelRegister("5cfZt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac55d6d764f47bc1$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $ac55d6d764f47bc1$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    showMore: {
        defaultMessage: 'Show more',
        description: 'Text on show more results button',
        id: 'cv.search.articles.show-more'
    },
    showMoreIcon: {
        defaultMessage: 'Show more icon',
        description: 'Text for label on show more results icon',
        id: 'cv.search.articles.show-more-icon'
    },
    shortcutIcon: {
        defaultMessage: 'Shortcut icon',
        description: 'Text for label on shortcut icon',
        id: 'cv.search.articles.shortcut-icon'
    },
    articles: {
        defaultMessage: 'Self-help resources',
        description: 'Text for section resource type in search results',
        id: 'cv.search.articles.articles'
    }
});

});

parcelRegister("2h6kr", function(module, exports) {
$parcel$export(module.exports, "ResourceIcon", () => (parcelRequire("74xSA")).default);

var $74xSA = parcelRequire("74xSA");

});
parcelRegister("74xSA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f68d1b7e6c89d69$export$2e2bcd8739ae039);

var $4RK7B = parcelRequire("4RK7B");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $iSvee = parcelRequire("iSvee");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
parcelRequire("fMSDi");
var $2YHJe = parcelRequire("2YHJe");

var $aflyD = parcelRequire("aflyD");

var $a9GGo = parcelRequire("a9GGo");

var $f1STa = parcelRequire("f1STa");

var $6591d = parcelRequire("6591d");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");
const $3f68d1b7e6c89d69$export$99eb8fbf40c7d2bc = ({ isLoggedIn: isLoggedIn, themeColor: themeColor, result: result })=>{
    const data = (0, $h3cOB.useFragment)((0, $4RK7B.default), result);
    const { entityType: entityType, displayLink: displayLink, iconUrl: iconUrl, isExternal: isExternal } = data;
    const { data: { iconUrl: externalResourceIconUrl }, isLoading: isIconLoading } = (0, $2YHJe.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const isValidResourceIconUrl = !!iconUrl && iconUrl !== '';
    const isValidExternalResourceIconUrl = !!externalResourceIconUrl && externalResourceIconUrl !== '';
    const getDefaultIcon = (0, $8P7DW.useMemo)(()=>{
        switch(entityType){
            case 'ARTICLE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1STa))), {
                    label: "",
                    testId: "article-icon",
                    spacing: "spacious"
                });
            case 'REQUEST_FORM':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9GGo))), {
                    label: "",
                    testId: "request-form-icon",
                    spacing: "spacious"
                });
            case 'PORTAL':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6591d))), {
                    label: "",
                    testId: "portal-icon",
                    spacing: "spacious"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aflyD))), {
                    label: "",
                    testId: "question-icon",
                    spacing: "spacious"
                });
        }
    }, [
        entityType
    ]);
    const getExternalResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iSvee.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidExternalResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: "img",
            xcss: $3f68d1b7e6c89d69$var$imgStyles,
            testId: "external-resource-icon",
            src: externalResourceIconUrl,
            alt: ""
        });
        return getDefaultIcon;
    };
    const getResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iSvee.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: "img",
            xcss: $3f68d1b7e6c89d69$var$imgStyles,
            testId: "resource-icon",
            src: iconUrl,
            alt: ""
        });
        return getDefaultIcon;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $3f68d1b7e6c89d69$var$imgStyles,
        style: {
            color: themeColor
        }
    }, isExternal ? getExternalResourceIcon() : getResourceIcon());
};
const $3f68d1b7e6c89d69$var$ConnectedResourceIcon = (0, $jvoWT.default)((state)=>{
    return {
        isLoggedIn: (0, $hx8zX.isLoggedIn)(state),
        themeColor: (0, $ikoP4.getThemeColor)(state)
    };
})($3f68d1b7e6c89d69$export$99eb8fbf40c7d2bc);
var $3f68d1b7e6c89d69$export$2e2bcd8739ae039 = $3f68d1b7e6c89d69$var$ConnectedResourceIcon;
const $3f68d1b7e6c89d69$var$imgStyles = (0, $37U6z.xcss)({
    width: 'size.200',
    height: 'size.200',
    objectFit: 'contain'
});

});
parcelRegister("4RK7B", function(module, exports) {
$parcel$export(module.exports, "default", () => $877872eb2cd2ed47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d35163187222f20e007ada54f5c825e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $877872eb2cd2ed47$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "resourceIconFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "entityType"
            },
            "action": "THROW",
            "path": "entityType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW",
            "path": "displayLink"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            "action": "THROW",
            "path": "iconUrl"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW",
            "path": "isExternal"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$877872eb2cd2ed47$var$node.hash = "61adf56879f78dbab16536f41b38d4cf";
var $877872eb2cd2ed47$export$2e2bcd8739ae039 = $877872eb2cd2ed47$var$node;

});

parcelRegister("iSvee", function(module, exports) {
$parcel$export(module.exports, "SkeletonItem", () => $00514fb3571b3634$export$fbc0ea7debdb77e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");
const $00514fb3571b3634$var$shimmer = /*#__PURE__*/ (0, $2UsNA.keyframes)({
    '0%': {
        backgroundPosition: '-300px 0'
    },
    '100%': {
        backgroundPosition: '1000px 0'
    }
});
const $00514fb3571b3634$export$fbc0ea7debdb77e = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1p3akxf-0"
})`animation-duration:1.2s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:${$00514fb3571b3634$var$shimmer};animation-timing-function:linear;background-color:${"var(--ds-skeleton, #F4F5F7)"};background-image:linear-gradient( to right,${"var(--ds-skeleton, #F4F5F7)"} 10%,${"var(--ds-skeleton-subtle, #EBECF0)"} 20%,${"var(--ds-skeleton, #F4F5F7)"} 30% );background-repeat:no-repeat;border-radius:${({ isCircle: isCircle })=>isCircle ? '50%' : "var(--ds-radius-small, 4px)"};height:${({ height: height })=>height};width:${({ width: width })=>width};`;

});

parcelRegister("a9GGo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0eaf91608b1fc1f9ea14632557d8241d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $764bda8c5e800d3d$var$_react = $764bda8c5e800d3d$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $764bda8c5e800d3d$var$_baseNew = $764bda8c5e800d3d$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $764bda8c5e800d3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $764bda8c5e800d3d$var$DashboardIcon = (props)=>/*#__PURE__*/ $764bda8c5e800d3d$var$_react.default.createElement($764bda8c5e800d3d$var$_baseNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$764bda8c5e800d3d$var$DashboardIcon.displayName = 'DashboardIcon';
var $764bda8c5e800d3d$var$_default = module.exports.default = $764bda8c5e800d3d$var$DashboardIcon;

});

parcelRegister("f1STa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a80f298c9d6e0d96eff1b09e3e1e4079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af1186c75bcd7b23$var$_react = $af1186c75bcd7b23$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $af1186c75bcd7b23$var$_baseNew = $af1186c75bcd7b23$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $af1186c75bcd7b23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af1186c75bcd7b23$var$PageIcon = (props)=>/*#__PURE__*/ $af1186c75bcd7b23$var$_react.default.createElement($af1186c75bcd7b23$var$_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$af1186c75bcd7b23$var$PageIcon.displayName = 'PageIcon';
var $af1186c75bcd7b23$var$_default = module.exports.default = $af1186c75bcd7b23$var$PageIcon;

});

parcelRegister("6591d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c3928c64a97db38eb981c4055c674e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46da349cf4fbdde4$var$_react = $46da349cf4fbdde4$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $46da349cf4fbdde4$var$_baseNew = $46da349cf4fbdde4$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $46da349cf4fbdde4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46da349cf4fbdde4$var$ScreenIcon = (props)=>/*#__PURE__*/ $46da349cf4fbdde4$var$_react.default.createElement($46da349cf4fbdde4$var$_baseNew.default, Object.assign({
        name: "ScreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$46da349cf4fbdde4$var$ScreenIcon.displayName = 'ScreenIcon';
var $46da349cf4fbdde4$var$_default = module.exports.default = $46da349cf4fbdde4$var$ScreenIcon;

});







parcelRegister("ghVjE", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => (parcelRequire("lJCiS")).ArticleResultsLoader);
$parcel$export(module.exports, "SidePanelResultsLoader", () => (parcelRequire("lJCiS")).SidePanelResultsLoader);
$parcel$export(module.exports, "NewSearchResultsLoader", () => (parcelRequire("lJCiS")).NewSearchResultsLoader);

var $lJCiS = parcelRequire("lJCiS");

});
parcelRegister("lJCiS", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => $af7c99346fa1a106$export$777dd415ac1ad4be);
$parcel$export(module.exports, "SidePanelResultsLoader", () => $af7c99346fa1a106$export$9575789db02c1cec);
$parcel$export(module.exports, "NewSearchResultsLoader", () => $af7c99346fa1a106$export$eccdfdc6bb2f83ed);

var $8P7DW = parcelRequire("8P7DW");

var $4O8fD = parcelRequire("4O8fD");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $ktwNU = parcelRequire("ktwNU");
var $2Mjg8 = parcelRequire("2Mjg8");
var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");
parcelRequire("ibkPE");
var $k0cKu = parcelRequire("k0cKu");
const $af7c99346fa1a106$export$777dd415ac1ad4be = ()=>{
    const articleItemLoader = (0, $8P7DW.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $af7c99346fa1a106$var$headingAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const resourceIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $af7c99346fa1a106$var$iconAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $af7c99346fa1a106$var$loadingIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 24,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const metadataContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: [
                    $af7c99346fa1a106$var$subheadingLeftAreaStyles,
                    $af7c99346fa1a106$var$subheadingStyles
                ],
                testId: "article-metadata-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $af7c99346fa1a106$var$metadataLoadingStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const shortcutIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: [
                    $af7c99346fa1a106$var$headerRightAreaStylesVisible
                ],
                testId: "shortcut-icon-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const descriptionContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $af7c99346fa1a106$var$bodyAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            role: "listitem",
            xcss: $af7c99346fa1a106$var$containerStyles,
            testId: "article-item-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
            columnGap: "space.150",
            templateAreas: [
                'icon heading header-right',
                'icon subheading-left header-right',
                '. body body'
            ],
            templateColumns: "auto 1fr auto"
        }, resourceIconContainer(), linkContainer(), metadataContainer(), shortcutIconContainer(), descriptionContainer())));
    }, []);
    const articlesListLoader = (0, $8P7DW.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $af7c99346fa1a106$var$containerStyles,
            testId: "articles-list-loader"
        }, articleItemLoader, articleItemLoader, articleItemLoader, articleItemLoader);
    }, [
        articleItemLoader
    ]);
    const sectionHeadingLoader = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, sectionHeadingLoader(), articlesListLoader, articlesListLoader);
};
const $af7c99346fa1a106$export$9575789db02c1cec = ()=>{
    const resourceIconContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $af7c99346fa1a106$var$iconAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $af7c99346fa1a106$var$sidePanelIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            height: 24,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    const descriptionContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $af7c99346fa1a106$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $af7c99346fa1a106$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))));
    };
    const sidePaneItemLoader = (0, $8P7DW.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $af7c99346fa1a106$var$sidePaneLinkContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
                xcss: $af7c99346fa1a106$var$sidePaneLinkStyles,
                space: "space.100"
            }, resourceIconContainer(), descriptionContainer()));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $af7c99346fa1a106$var$sidePanelItemStyles
        }, linkContainer());
    }, []);
    const sidePanelLoader = (0, $8P7DW.useMemo)(()=>{
        const resultTitle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $af7c99346fa1a106$var$sidePanelStyles
        }, resultTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k0cKu.ResultList), null, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader));
    }, [
        sidePaneItemLoader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        testId: "side-panel-results-loader",
        xcss: $af7c99346fa1a106$var$sidePanelContainerStyles
    }, sidePanelLoader);
};
const $af7c99346fa1a106$export$eccdfdc6bb2f83ed = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $af7c99346fa1a106$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($af7c99346fa1a106$export$777dd415ac1ad4be, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($af7c99346fa1a106$export$9575789db02c1cec, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($af7c99346fa1a106$export$9575789db02c1cec, null)));
};
const $af7c99346fa1a106$export$628e0e0af087a588 = ({ numberOfSections: numberOfSections })=>{
    const resultTitle = (0, $8P7DW.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k0cKu.ResultTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })), []);
    const linkContainer = (0, $8P7DW.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k0cKu.LinkContainer), {
            actionSubjectId: "loading-link-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $af7c99346fa1a106$var$searchResultLinkStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            height: 65,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    }, []);
    // Generate sections based on numberOfSections
    const sections = (0, $8P7DW.useMemo)(()=>{
        const sectionsArray = [];
        for(let i = 0; i < numberOfSections; i++)sectionsArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, resultTitle, linkContainer, linkContainer));
        return sectionsArray;
    }, [
        linkContainer,
        numberOfSections,
        resultTitle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        testId: "search-results-loader"
    }, sections);
};
const $af7c99346fa1a106$var$containerStyles = (0, $37U6z.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $af7c99346fa1a106$var$iconAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'icon',
    width: 'size.200',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right'
});
const $af7c99346fa1a106$var$headingAreaStyles = (0, $37U6z.xcss)({
    width: '200px',
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-large, normal)"
});
const $af7c99346fa1a106$var$subheadingStyles = (0, $37U6z.xcss)({
    width: '350px',
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $af7c99346fa1a106$var$subheadingLeftAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $af7c99346fa1a106$var$headerRightAreaStylesVisible = (0, $37U6z.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $af7c99346fa1a106$var$responsiveStyles = (0, $37U6z.xcss)({
    [(0, $2Mjg8.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        width: '100%'
    },
    [(0, $2Mjg8.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});
const $af7c99346fa1a106$var$bodyAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $af7c99346fa1a106$var$loadingIconStyles = (0, $37U6z.xcss)({
    width: '100%'
});
const $af7c99346fa1a106$var$metadataLoadingStyles = (0, $37U6z.xcss)({
    width: '100%'
});
const $af7c99346fa1a106$var$sidePanelIconStyles = (0, $37U6z.xcss)({
    width: 'size.200'
});
const $af7c99346fa1a106$var$sidePanelDescriptionStyles = (0, $37U6z.xcss)({
    width: '100%'
});
const $af7c99346fa1a106$var$sidePaneLinkContainerStyles = (0, $37U6z.xcss)({
    width: '100%',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $af7c99346fa1a106$var$sidePaneLinkStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $af7c99346fa1a106$var$sidePanelItemStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $af7c99346fa1a106$var$sidePanelContainerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    minWidth: '320px',
    width: '100%',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100'
});
const $af7c99346fa1a106$var$sidePanelStyles = (0, $37U6z.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
const $af7c99346fa1a106$var$searchResultLinkStyles = (0, $37U6z.xcss)({
    width: '100%',
    overflow: 'hidden',
    pointerEvents: 'none'
});

});


parcelRegister("4mi7c", function(module, exports) {
$parcel$export(module.exports, "Portals", () => (parcelRequire("g0eKE")).default);

var $g0eKE = parcelRequire("g0eKE");

});
parcelRegister("g0eKE", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7da2fbc6d9e9904$export$2e2bcd8739ae039);

var $kuwxi = parcelRequire("kuwxi");

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $k7ZVu = parcelRequire("k7ZVu");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $2Mjg8 = parcelRequire("2Mjg8");
var $37U6z = parcelRequire("37U6z");

var $dfS0m = parcelRequire("dfS0m");
parcelRequire("ibkPE");
var $fhQ61 = parcelRequire("fhQ61");
var $k0cKu = parcelRequire("k0cKu");
var $iwSnV = parcelRequire("iwSnV");

var $gvqx2 = parcelRequire("gvqx2");
parcelRequire("3FcpN");
var $2HugZ = parcelRequire("2HugZ");

var $7M30n = parcelRequire("7M30n");
const $a7da2fbc6d9e9904$export$7083bd6220bb1bc7 = ({ result: result, term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $kuwxi.default), result);
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const slicedPortals = data.portals.slice(0, (0, $fhQ61.INITIAL_PORTALS_COUNT));
    const showSection = slicedPortals.length > 0;
    (0, $8P7DW.useEffect)(()=>{
        let externalResourcesCount = 0;
        let firstPartySearchPlatformResourcesCount = 0;
        let hasError = false;
        let errorMessage;
        slicedPortals.forEach((resource)=>{
            if (resource) {
                const { __typename: __typename, isExternal: isExternal, searchBackend: searchBackend, message: message } = resource;
                if (__typename === 'HelpObjectStoreSearchResult') {
                    if (isExternal) externalResourcesCount += 1;
                    if (searchBackend === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
                    if (message && !errorMessage) {
                        hasError = true;
                        errorMessage = message;
                    }
                }
            }
        });
        if (showSection && hasError) (0, $iwSnV.sendSearchOperationalAnalyticEvents)({
            hasError: hasError,
            errorMessage: errorMessage,
            action: 'portalSearchFailed'
        }, createAnalyticsEvent, portalId);
        if (showSection && !hasError) {
            (0, $iwSnV.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'portal',
                resourceCount: slicedPortals.length
            }, createAnalyticsEvent, portalId);
            (0, $iwSnV.sendSearchOperationalAnalyticEvents)({
                action: 'portalSearchSucceeded'
            }, createAnalyticsEvent, portalId);
        }
    // adding slicedPortals to deps array causes multiple 'rendered' events to be fired
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        term,
        showSection,
        slicedPortals.length,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $8P7DW.useEffect)(()=>{
        updateResultsCount(slicedPortals.length, 1);
    }, [
        term,
        slicedPortals.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $a7da2fbc6d9e9904$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $a7da2fbc6d9e9904$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "xxsmall"
    }, formatMessage((0, $7M30n.default).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k0cKu.ResultList), null, slicedPortals.map((resource, index)=>{
        if ((resource === null || resource === void 0 ? void 0 : resource.__typename) === 'HelpObjectStoreSearchResult') {
            const itemOrder = index + 1;
            const key = resource.id;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("li", {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2HugZ.default), {
                itemOrder: itemOrder,
                term: term,
                result: resource
            }));
        }
        return null;
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $gvqx2.searchExperience)
    }));
};
const $a7da2fbc6d9e9904$var$containerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $2Mjg8.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $2Mjg8.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $a7da2fbc6d9e9904$var$headingStyles = (0, $37U6z.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $a7da2fbc6d9e9904$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($a7da2fbc6d9e9904$export$7083bd6220bb1bc7);

});
parcelRegister("kuwxi", function(module, exports) {
$parcel$export(module.exports, "default", () => $46a5b2efd9b1d28f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<712beb9772e710d1648651a7ece77bfa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $46a5b2efd9b1d28f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "helpCenterAri"
        },
        {
            "kind": "RootArgument",
            "name": "portalIds"
        },
        {
            "kind": "RootArgument",
            "name": "queryTerm"
        },
        {
            "kind": "RootArgument",
            "name": "resultLimit"
        }
    ],
    "kind": "Fragment",
    "name": "portalsFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "portals",
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "entityType",
                                "value": "PORTAL"
                            },
                            {
                                "kind": "Variable",
                                "name": "helpCenterAri",
                                "variableName": "helpCenterAri"
                            },
                            {
                                "kind": "Variable",
                                "name": "portalIds",
                                "variableName": "portalIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "queryTerm",
                                "variableName": "queryTerm"
                            },
                            {
                                "kind": "Variable",
                                "name": "resultLimit",
                                "variableName": "resultLimit"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "searchInput"
                    }
                ],
                "kind": "LinkedField",
                "name": "searchHelpObjects",
                "plural": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                "action": "THROW",
                                "path": "portals.__typename"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                "action": "THROW",
                                "path": "portals.id"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "isExternal"
                                },
                                "action": "THROW",
                                "path": "portals.isExternal"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "searchBackend"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "portalItemFragment"
                            }
                        ],
                        "type": "HelpObjectStoreSearchResult"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "HelpObjectStoreQueryError"
                    }
                ]
            },
            "action": "THROW",
            "path": "portals"
        }
    ],
    "type": "HelpObjectStoreQueryApi"
};
$46a5b2efd9b1d28f$var$node.hash = "6df6301d2505c868184d8976da29ebbc";
var $46a5b2efd9b1d28f$export$2e2bcd8739ae039 = $46a5b2efd9b1d28f$var$node;

});

parcelRegister("3FcpN", function(module, exports) {
$parcel$export(module.exports, "PortalItem", () => (parcelRequire("2HugZ")).default);

var $2HugZ = parcelRequire("2HugZ");

});
parcelRegister("2HugZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b083ccdaf582f728$export$2e2bcd8739ae039);

var $2do4L = parcelRequire("2do4L");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $cS6Xr = parcelRequire("cS6Xr");

var $HGACo = parcelRequire("HGACo");

var $f73iJ = parcelRequire("f73iJ");

var $loEqA = parcelRequire("loEqA");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $k7ZVu = parcelRequire("k7ZVu");

var $c1US4 = parcelRequire("c1US4");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $6GVst = parcelRequire("6GVst");

var $5cfZt = parcelRequire("5cfZt");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");
parcelRequire("2h6kr");
var $74xSA = parcelRequire("74xSA");
const $b083ccdaf582f728$export$dd92e87a60cfa662 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $2do4L.default), result);
    const { title: title, displayLink: displayLink, isExternal: isExternal, id: id, searchBackend: searchBackend, searchAlgorithm: searchAlgorithm } = data;
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $iwSnV.useVisibilityState)();
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1US4))), {
        label: formatMessage((0, $5cfZt.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $iwSnV.formatText)(title, term) : '';
    const linkProps = (0, $6GVst.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: isExternal
    });
    (0, $8P7DW.useEffect)(()=>{
        (0, $iwSnV.sendSearchUIAnalyticEvents)({
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm,
            action: 'list-item-rendered',
            resourceType: 'portal'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        portalId,
        searchAlgorithm,
        searchBackend
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $b083ccdaf582f728$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        xcss: $b083ccdaf582f728$var$headingStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $74xSA.default), {
        result: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cS6Xr.Link), {
        key: id,
        actionSubjectId: isExternal ? 'external-portal-link' : 'portal-link',
        "data-test-id": "result-link-container",
        attributes: {
            itemOrder: itemOrder,
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(highlightedTitle) : (0, $f73iJ.sanitize)(highlightedTitle)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: isShortcutIconVisible ? $b083ccdaf582f728$var$headerRightAreaStylesVisible : $b083ccdaf582f728$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon)));
};
const $b083ccdaf582f728$var$ConnectedPortalItem = (0, $jvoWT.default)((state)=>{
    return {
        themeColor: (0, $ikoP4.getThemeColor)(state)
    };
})($b083ccdaf582f728$export$dd92e87a60cfa662);
var $b083ccdaf582f728$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($b083ccdaf582f728$var$ConnectedPortalItem);
const $b083ccdaf582f728$var$containerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $b083ccdaf582f728$var$headingStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $b083ccdaf582f728$var$headerRightAreaStylesInVisible = (0, $37U6z.xcss)({
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $b083ccdaf582f728$var$headerRightAreaStylesVisible = (0, $37U6z.xcss)({
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start'
});

});
parcelRegister("2do4L", function(module, exports) {
$parcel$export(module.exports, "default", () => $45024cfb26bf666c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b678771d514945c9f8c35b197b0530c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45024cfb26bf666c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalItemFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "__typename"
            },
            "action": "THROW",
            "path": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW",
            "path": "displayLink"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW",
            "path": "isExternal"
        },
        {
            "kind": "ScalarField",
            "name": "searchBackend"
        },
        {
            "kind": "ScalarField",
            "name": "searchAlgorithm"
        },
        {
            "kind": "FragmentSpread",
            "name": "resourceIconFragment"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$45024cfb26bf666c$var$node.hash = "5c3ae01d5eb661e9c21aaedc4bbe3399";
var $45024cfb26bf666c$export$2e2bcd8739ae039 = $45024cfb26bf666c$var$node;

});



parcelRegister("7M30n", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3d7aa61e8a3e136$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $f3d7aa61e8a3e136$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    portals: {
        defaultMessage: 'Portals',
        description: 'Text for section resource type in search results',
        id: 'cv.search.portals.portals'
    }
});

});



parcelRegister("iyj8w", function(module, exports) {
$parcel$export(module.exports, "RequestForms", () => (parcelRequire("l1WVL")).default);

var $l1WVL = parcelRequire("l1WVL");

});
parcelRegister("l1WVL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9f3a70983fdf439$export$2e2bcd8739ae039);

var $8r6iV = parcelRequire("8r6iV");

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $k7ZVu = parcelRequire("k7ZVu");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $2Mjg8 = parcelRequire("2Mjg8");
var $37U6z = parcelRequire("37U6z");

var $dfS0m = parcelRequire("dfS0m");
parcelRequire("ibkPE");
var $fhQ61 = parcelRequire("fhQ61");
var $k0cKu = parcelRequire("k0cKu");
var $iwSnV = parcelRequire("iwSnV");

var $gvqx2 = parcelRequire("gvqx2");
parcelRequire("dTLsO");
var $byGlM = parcelRequire("byGlM");

var $dwE56 = parcelRequire("dwE56");
const $f9f3a70983fdf439$export$d7562fc7136a7ea2 = ({ result: result, term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $8r6iV.default), result);
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const slicedRequestForms = data.requestForms.slice(0, (0, $fhQ61.INITIAL_REQUEST_FORMS_COUNT));
    const showSection = slicedRequestForms.length > 0;
    (0, $8P7DW.useEffect)(()=>{
        let externalResourcesCount = 0;
        let firstPartySearchPlatformResourcesCount = 0;
        let hasError = false;
        let errorMessage;
        slicedRequestForms.forEach((resource)=>{
            if (resource) {
                const { __typename: __typename, isExternal: isExternal, searchBackend: searchBackend, message: message } = resource;
                if (__typename === 'HelpObjectStoreSearchResult') {
                    if (isExternal) externalResourcesCount += 1;
                    if (searchBackend === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
                    if (message && !errorMessage) {
                        hasError = true;
                        errorMessage = message;
                    }
                }
            }
        });
        if (showSection && hasError) (0, $iwSnV.sendSearchOperationalAnalyticEvents)({
            hasError: hasError,
            errorMessage: errorMessage,
            action: 'requestTypeSearchFailed'
        }, createAnalyticsEvent, portalId);
        if (showSection && !hasError) {
            (0, $iwSnV.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'request-form',
                resourceCount: slicedRequestForms.length
            }, createAnalyticsEvent, portalId);
            (0, $iwSnV.sendSearchOperationalAnalyticEvents)({
                action: 'requestTypeSearchSucceeded'
            }, createAnalyticsEvent, portalId);
        }
    // adding slicedRequestForms to deps array causes multiple 'rendered' events to be fired
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        term,
        showSection,
        slicedRequestForms.length,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $8P7DW.useEffect)(()=>{
        updateResultsCount(slicedRequestForms.length, 1);
    }, [
        term,
        slicedRequestForms.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $f9f3a70983fdf439$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $f9f3a70983fdf439$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "xxsmall"
    }, formatMessage((0, $dwE56.default).requestForms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k0cKu.ResultList), null, slicedRequestForms.map((resource, index)=>{
        if ((resource === null || resource === void 0 ? void 0 : resource.__typename) === 'HelpObjectStoreSearchResult') {
            const itemOrder = index + 1;
            const key = resource.id;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("li", {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $byGlM.default), {
                itemOrder: itemOrder,
                term: term,
                result: resource
            }));
        }
        return null;
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $gvqx2.searchExperience)
    }));
};
const $f9f3a70983fdf439$var$containerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $2Mjg8.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $2Mjg8.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $f9f3a70983fdf439$var$headingStyles = (0, $37U6z.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $f9f3a70983fdf439$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($f9f3a70983fdf439$export$d7562fc7136a7ea2);

});
parcelRegister("8r6iV", function(module, exports) {
$parcel$export(module.exports, "default", () => $62ac2a9ca3d2b05c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14befefc9b0316e8aec383e0aa94107c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $62ac2a9ca3d2b05c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "helpCenterAri"
        },
        {
            "kind": "RootArgument",
            "name": "portalIds"
        },
        {
            "kind": "RootArgument",
            "name": "queryTerm"
        },
        {
            "kind": "RootArgument",
            "name": "resultLimit"
        }
    ],
    "kind": "Fragment",
    "name": "requestFormsFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "requestForms",
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "entityType",
                                "value": "REQUEST_FORM"
                            },
                            {
                                "kind": "Variable",
                                "name": "helpCenterAri",
                                "variableName": "helpCenterAri"
                            },
                            {
                                "kind": "Variable",
                                "name": "portalIds",
                                "variableName": "portalIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "queryTerm",
                                "variableName": "queryTerm"
                            },
                            {
                                "kind": "Variable",
                                "name": "resultLimit",
                                "variableName": "resultLimit"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "searchInput"
                    }
                ],
                "kind": "LinkedField",
                "name": "searchHelpObjects",
                "plural": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                "action": "THROW",
                                "path": "requestForms.__typename"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                "action": "THROW",
                                "path": "requestForms.id"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "isExternal"
                                },
                                "action": "THROW",
                                "path": "requestForms.isExternal"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "searchBackend"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "requestFormItemFragment"
                            }
                        ],
                        "type": "HelpObjectStoreSearchResult"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "HelpObjectStoreQueryError"
                    }
                ]
            },
            "action": "THROW",
            "path": "requestForms"
        }
    ],
    "type": "HelpObjectStoreQueryApi"
};
$62ac2a9ca3d2b05c$var$node.hash = "907bab99aedb457184f08cf767ca109e";
var $62ac2a9ca3d2b05c$export$2e2bcd8739ae039 = $62ac2a9ca3d2b05c$var$node;

});

parcelRegister("dTLsO", function(module, exports) {
$parcel$export(module.exports, "RequestFormItem", () => (parcelRequire("byGlM")).default);

var $byGlM = parcelRequire("byGlM");

});
parcelRegister("byGlM", function(module, exports) {
$parcel$export(module.exports, "default", () => $de0361af5457b286$export$2e2bcd8739ae039);

var $eX2Qe = parcelRequire("eX2Qe");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $cS6Xr = parcelRequire("cS6Xr");

var $HGACo = parcelRequire("HGACo");

var $f73iJ = parcelRequire("f73iJ");

var $loEqA = parcelRequire("loEqA");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $k7ZVu = parcelRequire("k7ZVu");

var $c1US4 = parcelRequire("c1US4");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $6GVst = parcelRequire("6GVst");

var $5cfZt = parcelRequire("5cfZt");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");
parcelRequire("2h6kr");
var $74xSA = parcelRequire("74xSA");
const $de0361af5457b286$export$c5555d4e61cdd47a = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $eX2Qe.default), result);
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $iwSnV.useVisibilityState)();
    const { title: title, displayLink: displayLink, isExternal: isExternal, id: id, searchBackend: searchBackend, searchAlgorithm: searchAlgorithm } = data;
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1US4))), {
        label: formatMessage((0, $5cfZt.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $iwSnV.formatText)(title, term) : '';
    const linkProps = (0, $6GVst.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: isExternal
    });
    (0, $8P7DW.useEffect)(()=>{
        (0, $iwSnV.sendSearchUIAnalyticEvents)({
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm,
            action: 'list-item-rendered',
            resourceType: 'request-form'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        portalId,
        searchAlgorithm,
        searchBackend
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $de0361af5457b286$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        xcss: $de0361af5457b286$var$headingStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $74xSA.default), {
        result: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cS6Xr.Link), {
        key: id,
        actionSubjectId: isExternal ? 'external-request-form-link' : 'request-form-link',
        "data-test-id": "result-link-container",
        attributes: {
            itemOrder: itemOrder,
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(highlightedTitle) : (0, $f73iJ.sanitize)(highlightedTitle)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: isShortcutIconVisible ? $de0361af5457b286$var$headerRightAreaStylesVisible : $de0361af5457b286$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon)));
};
const $de0361af5457b286$var$ConnectedRequestFormItem = (0, $jvoWT.default)((state)=>{
    return {
        themeColor: (0, $ikoP4.getThemeColor)(state)
    };
})($de0361af5457b286$export$c5555d4e61cdd47a);
var $de0361af5457b286$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($de0361af5457b286$var$ConnectedRequestFormItem);
const $de0361af5457b286$var$containerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $de0361af5457b286$var$headingStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $de0361af5457b286$var$headerRightAreaStylesInVisible = (0, $37U6z.xcss)({
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $de0361af5457b286$var$headerRightAreaStylesVisible = (0, $37U6z.xcss)({
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start'
});

});
parcelRegister("eX2Qe", function(module, exports) {
$parcel$export(module.exports, "default", () => $4786ac82d4226c5e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<26e8a67b7c486d83428b2f05859f3b8d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4786ac82d4226c5e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "requestFormItemFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "__typename"
            },
            "action": "THROW",
            "path": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW",
            "path": "displayLink"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW",
            "path": "isExternal"
        },
        {
            "kind": "ScalarField",
            "name": "searchBackend"
        },
        {
            "kind": "ScalarField",
            "name": "searchAlgorithm"
        },
        {
            "kind": "FragmentSpread",
            "name": "resourceIconFragment"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$4786ac82d4226c5e$var$node.hash = "10cdab9f2a7c89157e22f583e930228c";
var $4786ac82d4226c5e$export$2e2bcd8739ae039 = $4786ac82d4226c5e$var$node;

});



parcelRegister("dwE56", function(module, exports) {
$parcel$export(module.exports, "default", () => $f16dcffd9545f4c0$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $f16dcffd9545f4c0$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    requestForms: {
        defaultMessage: 'Request forms',
        description: 'Text for section resource type in search results',
        id: 'cv.search.request-forms.request-forms'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Text for portal name in description',
        id: 'cv.search.request-forms.portal'
    }
});

});





parcelRegister("4575H", function(module, exports) {
$parcel$export(module.exports, "default", () => $f098df58bfc29b72$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("9ueTd");
var $99eJc = parcelRequire("99eJc");
parcelRequire("9FfOm");
var $2CIj9 = parcelRequire("2CIj9");

var $f2ugL = parcelRequire("f2ugL");
const $f098df58bfc29b72$var$selector = (0, $ehscL.createSelector)((0, $2CIj9.getAllVisiblePortals), (0, $2CIj9.getfeaturedAndSortedPortalsError), (portals, featuredAndSortedPortalsError)=>({
        featuredAndSortedPortalsError: featuredAndSortedPortalsError,
        portals: portals
    }));
var $f098df58bfc29b72$export$2e2bcd8739ae039 = (0, $jvoWT.default)($f098df58bfc29b72$var$selector, {
    fetchPortals: (0, $99eJc.fetchFeaturedAndSortedPortalsModel)
})((0, $f2ugL.default));

});
parcelRegister("f2ugL", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a1ac6fca284afdb$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("hjLj6");
var $8h2EC = parcelRequire("8h2EC");

var $41V50 = parcelRequire("41V50");
const $8a1ac6fca284afdb$var$ServiceDeskFilter = ({ portals: portals, portalIds: portalIds, fetchPortals: fetchPortals, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [values, _] = $8P7DW.useState(portalIds ?? []);
    $8P7DW.useEffect(()=>{
        fetchPortals({
            exploreAll: true,
            sortBy: 'POPULARITY'
        }, false);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const options = $8P7DW.useMemo(()=>{
        return portals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals
    ]);
    const preSelectedOptions = $8P7DW.useMemo(()=>{
        const preselectedPortals = portals.filter((portal)=>values.find((id)=>id === portal.id.toString()));
        return preselectedPortals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals,
        values
    ]);
    return portals.length > 1 ? /*#__PURE__*/ $8P7DW.createElement((0, $8h2EC.default), {
        fieldId: "servicedesk_filter",
        fieldLabel: formatMessage((0, $41V50.default).portal),
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange,
        testId: "serviceDeskFilter"
    }) : null;
};
var $8a1ac6fca284afdb$export$2e2bcd8739ae039 = $8a1ac6fca284afdb$var$ServiceDeskFilter;

});
parcelRegister("41V50", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9fbf8ad6c03a480$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $f9fbf8ad6c03a480$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    serviceDeskFilter: {
        defaultMessage: 'Service desk',
        description: 'Title of the service desk picker',
        id: 'sd.all.articles.result.servicedesk.filter.name'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Title of the portal picker',
        id: 'cv.search.servicedesk-filter.portal'
    }
});

});





parcelRegister("4t3KQ", function(module, exports) {
$parcel$export(module.exports, "SearchTextboxV2", () => (parcelRequire("7jPBK")).default);

var $7jPBK = parcelRequire("7jPBK");

});
parcelRegister("7jPBK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b44eea3a205230dd$export$2e2bcd8739ae039);
/* search-textbox-v2.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $cSPKC = parcelRequire("cSPKC");

var $1We2B = parcelRequire("1We2B");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
var $i9cdb = parcelRequire("i9cdb");
parcelRequire("9E7e6");
var $2Ixwx = parcelRequire("2Ixwx");

var $8E60W = parcelRequire("8E60W");

var $kvQ5d = parcelRequire("kvQ5d");

var $aw7IH = parcelRequire("aw7IH");
parcelRequire("6gxqq");
var $eIvjU = parcelRequire("eIvjU");

var $MmGmU = parcelRequire("MmGmU");
var $eS4yu = parcelRequire("eS4yu");

var $1EFS8 = parcelRequire("1EFS8");

var $kDg5W = parcelRequire("kDg5W");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $37U6z = parcelRequire("37U6z");

var $iD9mC = parcelRequire("iD9mC");

var $iziiq = parcelRequire("iziiq");

var $300Z2 = parcelRequire("300Z2");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $klz3F = parcelRequire("klz3F");

var $cxNwq = parcelRequire("cxNwq");

var $1RqZd = parcelRequire("1RqZd");

var $5Tbbx = parcelRequire("5Tbbx");

var $fMfsf = parcelRequire("fMfsf");

var $aGBfH = parcelRequire("aGBfH");

var $hpFT3 = parcelRequire("hpFT3");

var $7QDmV = parcelRequire("7QDmV");

var $8952j = parcelRequire("8952j");

var $4zFmR = parcelRequire("4zFmR");

var $gbUep = parcelRequire("gbUep");

var $kZVLE = parcelRequire("kZVLE");

var $iLwZc = parcelRequire("iLwZc");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");
parcelRequire("ikBUv");
var $d82Wh = parcelRequire("d82Wh");

var $cNzk5 = parcelRequire("cNzk5");

var $9fvLZ = parcelRequire("9fvLZ");
const $b44eea3a205230dd$var$usePopularPortalsWithVA = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const [popularPortalsWithVA, setPopularPortalsWithVA] = (0, $8P7DW.useState)([]);
    const [isFetching, setIsFetching] = (0, $8P7DW.useState)(false);
    const cloudId = (0, $8P7DW.useMemo)(()=>(0, $jByYr.getCloudId)(), []);
    const fetchData = (0, $8P7DW.useCallback)(async ()=>{
        setIsFetching(true);
        try {
            const { mostPopularVAsPortalData: mostPopularVAsPortalData } = await (0, $klz3F.fetchJson)(`/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v1/virtualagent/mostPopularVAs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    helpCenterId: (0, $jByYr.getHelpCenterAri)()
                })
            });
            setPopularPortalsWithVA(mostPopularVAsPortalData);
        } catch (error) {
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.UI_EVENT_TYPE),
                action: 'failed',
                actionSubjectId: 'fetchPopularPortalsWithVA'
            }).fire();
        } finally{
            setIsFetching(false);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        setIsFetching,
        setPopularPortalsWithVA
    ]);
    return {
        isFetching: isFetching,
        popularPortalsWithVA: popularPortalsWithVA,
        fetchData: fetchData
    };
};
const $b44eea3a205230dd$var$SearchPopupContentWithRef = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function SearchPopupContent(searchPopupContentProps, ref) {
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { setSearchBoxWidth: setSearchBoxWidth, searchBarRef: searchBarRef, isChoiceOpen: isChoiceOpen, isVirtualAgentEnabled: isVirtualAgentEnabled, openChoicesIfPresent: openChoicesIfPresent, handleKeyDown: handleKeyDown, handleInputChange: handleInputChange, inputValue: inputValue, disableSearch: disableSearch, isFetchingResults: isFetchingResults, visibleResultsCount: visibleResultsCount, ...triggerProps } = searchPopupContentProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        ...triggerProps,
        ref: ref,
        xcss: $b44eea3a205230dd$var$searchBoxWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iD9mC.WidthObserver), {
        setWidth: setSearchBoxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $b44eea3a205230dd$var$searchBoxStyles,
        style: {
            // We need to manually use different token fallbacks here because the contrast isn't good enough with the default ones, while Portal is not yet using tokens. xcss doesn't allow specifying a token(...) as a value hence needing to use style prop
            // These should be removed once Portal has finished migrating to using tokens
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            borderColor: "var(--ds-border-input, #dee0e4)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            backgroundColor: "var(--ds-background-input, white)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($b44eea3a205230dd$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kDg5W))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #6B778C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($b44eea3a205230dd$var$Input, {
        "data-testid": "search-textbox-v2",
        type: "text",
        autoComplete: "off",
        innerRef: searchBarRef,
        autoFocus: isChoiceOpen,
        spellCheck: false,
        isAiAnswersEnabled: isVirtualAgentEnabled,
        "aria-label": isVirtualAgentEnabled ? formatMessage((0, $9fvLZ.default).inputAriaLabel) : formatMessage((0, $9fvLZ.default).inputAriaLabelNoAI),
        placeholder: isVirtualAgentEnabled ? formatMessage((0, $9fvLZ.default).inputPlaceholder) : formatMessage((0, $9fvLZ.default).inputPlaceholderNoAI),
        onClick: ()=>openChoicesIfPresent(),
        onFocus: (event)=>{
            // When coming from another focus element (meaning tabbing forwards or backwards)
            // We can't always open choices because that would trigger if you're in the popup menu and press 'Escape'
            // This focuses the text input so by re-opening the menu we'd be causing another A11Y issue
            if (event.relatedTarget != null) openChoicesIfPresent();
        },
        onChange: handleInputChange,
        onKeyDown: handleKeyDown,
        value: inputValue,
        disabled: disableSearch,
        // eslint-disable-next-line @atlassian/a11y/aria-props -- ATLAS-88210
        "aria-description": formatMessage((0, $9fvLZ.default).ariaDescription)
    }), (0, $iwSnV.isValidSearchTerm)(inputValue) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, isVirtualAgentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $b44eea3a205230dd$var$askAiHintStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        space: "space.100",
        alignBlock: "center"
    }, formatMessage((0, $9fvLZ.default).askTheVirtualServiceAgent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cSPKC))),
        alt: (0, $1EFS8.default).checkGate('ff_a11y_hc_alt_text') ? '' : formatMessage((0, $9fvLZ.default).enter)
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, (isFetchingResults || visibleResultsCount !== 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $b44eea3a205230dd$var$askAiHintStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        space: "space.100",
        alignBlock: "center"
    }, formatMessage((0, $9fvLZ.default).search), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cSPKC))),
        alt: (0, $1EFS8.default).checkGate('ff_a11y_hc_alt_text') ? '' : formatMessage((0, $9fvLZ.default).enter)
    }))))))));
});
const $b44eea3a205230dd$var$SearchTextboxV2 = ({ term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, disableSearch: disableSearch })=>{
    const searchBarRef = (0, $8P7DW.useRef)(null);
    const [isChoiceOpen, setIsChoiceOpen] = (0, $8P7DW.useState)(false);
    const [inputValue, setInputValue] = (0, $8P7DW.useState)(term);
    const [searchBoxWidth, setSearchBoxWidth] = (0, $8P7DW.useState)();
    const [{ location: location }, { push: push }] = (0, $i9cdb.useRouter)();
    const { startNewConversation: startNewConversation } = (0, $8E60W.useConversationActions)();
    const { sendMessage: sendMessage } = (0, $2Ixwx.useSendMessage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { resultsCount: resultsCount } = (0, $d82Wh.useInlineResultsContext)();
    const environment = (0, $h3cOB.useRelayEnvironment)();
    const { popularPortalsWithVA: popularPortalsWithVA, fetchData: fetchPopularPortalsWithVA, isFetching: isFetchingPopularPortalsWithVA } = $b44eea3a205230dd$var$usePopularPortalsWithVA();
    const { setSubscriptionDisposer: setSubscriptionDisposer } = (0, $gbUep.useSubscriptionAction)();
    (0, $8P7DW.useEffect)(()=>{
        if (isVSAOnHCEnabled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchPopularPortalsWithVA();
    }, [
        isVSAOnHCEnabled,
        fetchPopularPortalsWithVA
    ]);
    const { createConversationWithMessage: createConversationWithMessage } = (0, $fMfsf.useCreateConversationWithMessage)();
    const openChoicesIfPresent = (0, $8P7DW.useCallback)(()=>{
        setIsChoiceOpen(isVSAOnHCEnabled || (0, $iwSnV.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen,
        isVSAOnHCEnabled
    ]);
    const handleInputChange = (0, $8P7DW.useCallback)((event)=>{
        const newQuery = event.target.value;
        setInputValue(newQuery);
        setIsChoiceOpen((0, $iwSnV.isValidSearchTerm)(newQuery));
    }, [
        setInputValue,
        setIsChoiceOpen
    ]);
    const onSeeSearchResults = (0, $8P7DW.useCallback)(()=>{
        if (!(0, $iwSnV.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $iziiq.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'allResults',
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }).fire();
        push(`${location.pathname}?q=${inputValue.trim()}`);
    }, [
        inputValue,
        createAnalyticsEvent,
        push,
        location.pathname
    ]);
    const onAskAtlassianIntelligence = (0, $8P7DW.useCallback)(async ()=>{
        if (!(0, $iwSnV.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $iziiq.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'askAtlassianIntelligence',
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }).fire();
        if ((0, $HGACo.isOmnichannelEnabledForHC)()) {
            if ((0, $HGACo.isOmnichannelCombinedAPIEnabledForHC)()) {
                const subscriptionId = await (0, $4zFmR.generateUniqueSubscriptionID)({
                    environment: environment
                });
                const omniChannelMetaData = await (0, $hpFT3.fetchOmnichannelMeta)(environment);
                await (0, $aGBfH.updateOmniChannelConversationMetaPromise)({
                    environment: environment,
                    subscriptionId: subscriptionId,
                    draftMessage: !omniChannelMetaData.connectionId ? inputValue.trim() : undefined,
                    isConversationClosed: false,
                    isConversationExpired: false,
                    disableInput: false,
                    isReplyPending: false,
                    subscriptionTriggered: true,
                    subscriptionStatus: 'TRIGGERED'
                });
                const disposable = (0, $7QDmV.establishSubscriptionToOmnichannel)({
                    environment: environment,
                    subscriptionId: subscriptionId
                });
                setSubscriptionDisposer(disposable);
                if (omniChannelMetaData.connectionId) createConversationWithMessage({
                    subscriptionId: subscriptionId,
                    workspaceAri: (0, $jByYr.getWorkspaceAri)(),
                    conversationContextAri: (0, $jByYr.getHelpCenterAri)(),
                    isTestConversation: false,
                    message: inputValue.trim(),
                    connectionId: omniChannelMetaData.connectionId
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $5Tbbx.initialIntentMessageHCExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $8952j.omnichannelPageLoadExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $5Tbbx.initialAIMessageHCExperience).start();
            } else await (0, $aGBfH.updateOmniChannelConversationMetaPromise)({
                environment: environment,
                draftMessage: inputValue.trim()
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            push('/conversation');
            return;
        }
        if (isVSAOnHCEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $1RqZd.initialIntentMessageExperience).start();
            sendMessage(inputValue.trim());
        } else {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $iLwZc.initialAIAnswerExperience).start();
            startNewConversation(inputValue.trim());
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        inputValue,
        createAnalyticsEvent,
        isVSAOnHCEnabled,
        push,
        environment,
        setSubscriptionDisposer,
        createConversationWithMessage,
        sendMessage,
        startNewConversation
    ]);
    const visibleResultsCount = ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm) || 0);
    const isFetchingResults = !((0, $1We2B.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) && (0, $1We2B.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) && (0, $1We2B.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm));
    const handleKeyDown = (0, $8P7DW.useCallback)((event)=>{
        const canShowSearchResults = isFetchingResults || visibleResultsCount > 0;
        if (event.key === 'Enter') {
            if (!!isVSAOnHCEnabled) {
                if ((event.metaKey || !(0, $eIvjU.isMacOs)() && event.ctrlKey) && canShowSearchResults) onSeeSearchResults();
                else // eslint-disable-next-line @typescript-eslint/no-floating-promises
                onAskAtlassianIntelligence();
            } else if (canShowSearchResults) // If the search results are still fetched, resultsCount will be null
            onSeeSearchResults();
        }
    }, [
        visibleResultsCount,
        isFetchingResults,
        isVSAOnHCEnabled,
        onAskAtlassianIntelligence,
        onSeeSearchResults
    ]);
    (0, $8P7DW.useEffect)(()=>{
        setIsChoiceOpen((0, $iwSnV.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen
    ]);
    const [requestIdParam] = (0, $iyRi5.usePathParam)('requestId');
    (0, $8P7DW.useEffect)(()=>{
        var _searchBarRef$current;
        if ((0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && requestIdParam) return;
        (_searchBarRef$current = searchBarRef.current) === null || _searchBarRef$current === void 0 || _searchBarRef$current.focus();
    }, [
        requestIdParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, isVSAOnHCEnabled && (0, $HGACo.isOmnichannelEnabledForHC)() && (0, $HGACo.isOmnichannelCombinedAPIEnabledForHC)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kZVLE.OmnichannelClientConnection), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cNzk5.SearchPromptPopup), {
        isOpen: isChoiceOpen,
        isFetchingPopularPortalsWithVA: isFetchingPopularPortalsWithVA,
        popularPortalsWithVA: popularPortalsWithVA,
        onClose: ()=>setIsChoiceOpen(false),
        searchBoxWidth: searchBoxWidth,
        searchQuery: inputValue,
        onSelectSearchResults: onSeeSearchResults,
        isAiAnswersEnabled: !!isVSAOnHCEnabled,
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($b44eea3a205230dd$var$SearchPopupContentWithRef, {
                ...triggerProps,
                setSearchBoxWidth: setSearchBoxWidth,
                searchBarRef: searchBarRef,
                isChoiceOpen: isChoiceOpen,
                isVirtualAgentEnabled: !!isVSAOnHCEnabled,
                openChoicesIfPresent: openChoicesIfPresent,
                handleKeyDown: handleKeyDown,
                handleInputChange: handleInputChange,
                inputValue: inputValue,
                disableSearch: disableSearch,
                isFetchingResults: isFetchingResults,
                visibleResultsCount: visibleResultsCount
            });
        }
    }));
};
$b44eea3a205230dd$var$SearchTextboxV2.displayName = 'SearchTextboxV2';
const $b44eea3a205230dd$var$WrappedComponent = (0, $cxNwq.withHelpCenterConversationStateContainer)($b44eea3a205230dd$var$SearchTextboxV2);
const $b44eea3a205230dd$var$SearchTextBoxV2withConversationContainers = (props)=>{
    const contextId = (0, $jByYr.getHelpCenterAri)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($b44eea3a205230dd$var$WrappedComponent, {
        ...props,
        contextId: contextId
    });
};
var $b44eea3a205230dd$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    component: (0, $8rTkC.ScreenName).HELP_CENTER_SEARCH
})($b44eea3a205230dd$var$SearchTextBoxV2withConversationContainers);
const $b44eea3a205230dd$var$searchBoxWrapperStyles = (0, $37U6z.xcss)({
    position: 'relative'
});
const $b44eea3a205230dd$var$searchBoxStyles = (0, $37U6z.xcss)({
    backgroundColor: 'color.background.input',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border.input',
    borderRadius: 'radius.small',
    ':focus-within': {
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineColor: 'color.border.focused'
    }
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b44eea3a205230dd$var$Input = /*#__PURE__*/ (0, $2UsNA.default).input.withConfig({
    componentId: "sc-5r9sil-0"
})`${(0, $aw7IH.SEARCH_INPUT_FONT_SIZE)};${$6t2I3.placeholder("var(--ds-text-subtlest, #6B778C)")};background-color:${"var(--ds-background-input, white)"};border-radius:${"var(--ds-radius-small, 3px)"};padding:${$4cxV2.multiple(2.125).px}  ${(props)=>props.isAiAnswersEnabled ? '148px' : "var(--ds-space-600, 48px)"} ${$4cxV2.multiple(2.125).px} ${"var(--ds-space-050, 4px)"};flex-grow:1;border:0;outline:none;color:${"var(--ds-text, #172B4D)"};@media not all and (min-width:30rem){${(0, $HGACo.isUseHelpCenterRefresh)() ? `padding-right: ${"var(--ds-space-050, 4px)"};` : ''}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b44eea3a205230dd$var$SearchIconWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt4119w _4t3i1osq _1ltvidpf _154iidpf _94n5idpf _1e0c1txw _4cvr1h6o _1wpz1h6o _u5f31b66",
            __cmplp.className
        ])
    });
});
const $b44eea3a205230dd$var$askAiHintStyles = (0, $37U6z.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    position: 'absolute',
    padding: 'space.150',
    right: 'space.0',
    color: 'color.text.subtle',
    top: 'space.0',
    bottom: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 11
});

});
parcelRegister("cSPKC", function(module, exports) {
module.exports = new URL("../images/enter-icon.6e72b8c1.svg", import.meta.url).toString();

});

parcelRegister("9E7e6", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => (parcelRequire("2Ixwx")).useSendMessage);
$parcel$export(module.exports, "useIsGenerating", () => (parcelRequire("4H1b1")).useIsGenerating);
$parcel$export(module.exports, "useIsInputEnabled", () => (parcelRequire("hs071")).useIsInputEnabled);
$parcel$export(module.exports, "useHasMessages", () => (parcelRequire("8ENrl")).useHasMessages);
$parcel$export(module.exports, "useStopGenerating", () => (parcelRequire("9oYzA")).useStopGenerating);
$parcel$export(module.exports, "useGetMaxChars", () => (parcelRequire("7K6Fh")).useGetMaxChars);
$parcel$export(module.exports, "useIsInputShown", () => (parcelRequire("3fBnU")).useIsInputShown);
$parcel$export(module.exports, "useClearConversation", () => (parcelRequire("futSv")).useClearConversation);
$parcel$export(module.exports, "useHandOffConversation", () => (parcelRequire("6JoTi")).useHandOffConversation);

var $2Ixwx = parcelRequire("2Ixwx");

var $4H1b1 = parcelRequire("4H1b1");

var $hs071 = parcelRequire("hs071");

var $8ENrl = parcelRequire("8ENrl");

var $9oYzA = parcelRequire("9oYzA");

var $7K6Fh = parcelRequire("7K6Fh");

var $3fBnU = parcelRequire("3fBnU");

var $futSv = parcelRequire("futSv");

var $6JoTi = parcelRequire("6JoTi");

});
parcelRegister("2Ixwx", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => $5bc9f4874f0a446c$export$fe8707b58c509543);

var $1RqZd = parcelRequire("1RqZd");

var $gNBgO = parcelRequire("gNBgO");

var $iLwZc = parcelRequire("iLwZc");

var $056SR = parcelRequire("056SR");

var $86E3j = parcelRequire("86E3j");

var $8E60W = parcelRequire("8E60W");
const $5bc9f4874f0a446c$export$fe8707b58c509543 = ()=>{
    const provider = (0, $056SR.useProvider)();
    const { sendMessage: sendVirtualAgentMessage } = (0, $gNBgO.useSendMessage)();
    const { addHelpseekerMessage: addAIAnswersMessage } = (0, $8E60W.useActions)();
    const sendMessage = (message)=>{
        provider === (0, $86E3j.ConversationProvider).AI_ANSWERS ? addAIAnswersMessage(message) : sendVirtualAgentMessage(message);
        if (provider === (0, $86E3j.ConversationProvider).AI_ANSWERS) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $iLwZc.AIAnswerExperience).start();
        else // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $1RqZd.intentAnswerExperience).start();
    };
    return {
        sendMessage: sendMessage
    };
};

});
parcelRegister("1RqZd", function(module, exports) {
$parcel$export(module.exports, "intentAnswerExperience", () => $fab7966d3355ac20$export$b0aa4ee2c3e0b407);
$parcel$export(module.exports, "initialIntentMessageExperience", () => $fab7966d3355ac20$export$1bc905fb9e119ab8);

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $fab7966d3355ac20$var$intentAnswerExperienceId = 'service-management.help-center.virtual-agent.intent-message';
const $fab7966d3355ac20$var$initialIntentMessageExperienceId = 'service-management.help-center.virtual-agent.intent-initial-message-reply';
const $fab7966d3355ac20$export$b0aa4ee2c3e0b407 = new (0, $ghwxF.UFOExperience)($fab7966d3355ac20$var$intentAnswerExperienceId, {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $fab7966d3355ac20$export$1bc905fb9e119ab8 = new (0, $ghwxF.UFOExperience)($fab7966d3355ac20$var$initialIntentMessageExperienceId, {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("gNBgO", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => $45d44e3fd217a7a2$export$fe8707b58c509543);

var $koYWm = parcelRequire("koYWm");

var $gRDet = parcelRequire("gRDet");

var $fOX04 = parcelRequire("fOX04");
const $45d44e3fd217a7a2$export$fe8707b58c509543 = ()=>{
    const { addMessage: addMessage, addJiraFieldMessage: addJiraFieldMessage } = (0, $fOX04.useActions)();
    const jiraField = (0, $fOX04.useFieldFromLastMessage)();
    const baseUrl = (0, $fOX04.useBaseUrl)();
    const [{ data: requestTypeFields }] = (0, $koYWm.useRequestTypeFields)({
        baseUrl: baseUrl
    });
    const sendMessage = (message)=>{
        if (jiraField && (0, $gRDet.isTextField)(jiraField.fieldId, requestTypeFields)) addJiraFieldMessage(jiraField.fieldId, message);
        else addMessage(message);
    };
    return {
        sendMessage: sendMessage
    };
};

});
parcelRegister("koYWm", function(module, exports) {
$parcel$export(module.exports, "useRequestTypeFields", () => $6eb2c93d05df60ac$export$6fa5557c101e4783);

var $8P7DW = parcelRequire("8P7DW");

var $klz3F = parcelRequire("klz3F");

var $9Incl = parcelRequire("9Incl");
const $6eb2c93d05df60ac$export$6fa5557c101e4783 = ({ baseUrl: baseUrl = '' })=>{
    const { setRequestTypeFieldsMap: setRequestTypeFieldsMap, setIsLoading: setIsLoading, setError: setError } = (0, $9Incl.useActions)();
    const fieldStore = (0, $9Incl.useStore)();
    const requestTypeFieldPromise = (0, $9Incl.useRequestTypeFieldPromise)();
    const getRequestTypeFieldsEndpoint = (0, $8P7DW.useCallback)((projectId, requestTypeId)=>{
        if (!requestTypeId) return '';
        const projectIdentifier = `projectId:${projectId}`;
        return `${baseUrl}/rest/servicedeskapi/servicedesk/${encodeURIComponent(projectIdentifier)}/requesttype/${encodeURIComponent(requestTypeId)}/field`;
    }, [
        baseUrl
    ]);
    const convertedRequestTypeFieldMap = (0, $8P7DW.useCallback)((response)=>{
        return new Map(response === null || response === void 0 ? void 0 : response.requestTypeFields.map((field)=>[
                field.fieldId,
                field
            ]));
    }, []);
    const fetchRequestTypeFields = (0, $8P7DW.useCallback)(async (projectId, requestTypeId)=>{
        try {
            if (!requestTypeId) throw new Error('requestTypeId is undefined');
            const response = await (0, $klz3F.fetchJson)(getRequestTypeFieldsEndpoint(projectId, requestTypeId), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const convertedMap = convertedRequestTypeFieldMap(response);
            setRequestTypeFieldsMap(convertedMap);
            return convertedMap;
        } catch (err) {
            setError(err);
            return undefined;
        }
    }, [
        getRequestTypeFieldsEndpoint,
        convertedRequestTypeFieldMap,
        setRequestTypeFieldsMap,
        setError
    ]);
    const cacheIsInvalid = (0, $8P7DW.useCallback)((projectId, requestTypeId)=>{
        if (!fieldStore.cacheIds) return true;
        return projectId !== fieldStore.cacheIds.projectId || requestTypeId !== fieldStore.cacheIds.requestTypeId;
    }, [
        fieldStore.cacheIds
    ]);
    const fetchFieldsOrUseCache = (0, $8P7DW.useCallback)(async (projectId, requestTypeId)=>{
        if (cacheIsInvalid(projectId, requestTypeId)) {
            const request = fetchRequestTypeFields(projectId, requestTypeId);
            setIsLoading({
                projectId: projectId,
                requestTypeId: requestTypeId
            }, request);
            return request;
        }
        return requestTypeFieldPromise;
    }, [
        cacheIsInvalid,
        fetchRequestTypeFields,
        requestTypeFieldPromise,
        setIsLoading
    ]);
    return [
        {
            loading: fieldStore.loading,
            data: fieldStore.requestTypeFieldsMap,
            error: fieldStore.error
        },
        {
            fetchRequestTypeFields: fetchFieldsOrUseCache
        }
    ];
};

});
parcelRegister("9Incl", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $fa16efddfcb534d3$export$6ccbb43953eebf8);
$parcel$export(module.exports, "useActions", () => $fa16efddfcb534d3$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useRequestTypeFieldPromise", () => $fa16efddfcb534d3$export$c9a90d3a86a18942);

var $6xLCs = parcelRequire("6xLCs");
var $kUoOn = parcelRequire("kUoOn");

var $02UU5 = parcelRequire("02UU5");
const $fa16efddfcb534d3$var$initialState = {
    loading: false,
    cacheIds: undefined,
    requestTypeFieldsMap: new Map()
};
const $fa16efddfcb534d3$export$b6b2c03d619b3cc5 = (0, $kUoOn.createStore)({
    initialState: $fa16efddfcb534d3$var$initialState,
    actions: $02UU5.actions,
    name: 'requestTypeFields'
});
const $fa16efddfcb534d3$export$6ccbb43953eebf8 = (0, $6xLCs.createStateHook)($fa16efddfcb534d3$export$b6b2c03d619b3cc5);
const $fa16efddfcb534d3$export$bc923229a7fa61e7 = (0, $6xLCs.createActionsHook)($fa16efddfcb534d3$export$b6b2c03d619b3cc5);
const $fa16efddfcb534d3$export$c9a90d3a86a18942 = (0, $6xLCs.createStateHook)($fa16efddfcb534d3$export$b6b2c03d619b3cc5, {
    selector: (state)=>state.inFlightRequest ? state.inFlightRequest : state.requestTypeFieldsMap
});

});
parcelRegister("02UU5", function(module, exports) {
$parcel$export(module.exports, "actions", () => $1d49d8b925193243$export$e324594224ef24da);

var $khAYd = parcelRequire("khAYd");
const $1d49d8b925193243$var$setRequestTypeFieldsMap = (requestTypeFieldsMap)=>({ setState: setState })=>{
        setState({
            requestTypeFieldsMap: requestTypeFieldsMap,
            error: undefined,
            inFlightRequest: undefined,
            loading: false
        });
    };
const $1d49d8b925193243$var$setIsLoading = (cacheIds, inFlightRequest)=>({ setState: setState })=>{
        setState({
            cacheIds: cacheIds,
            inFlightRequest: inFlightRequest,
            loading: true
        });
    };
const $1d49d8b925193243$var$setError = (e)=>({ setState: setState })=>{
        const error = e instanceof Error ? e : new Error('Unknown error');
        (0, $khAYd.sendErrorEvent)({
            error: error,
            actionSubject: 'fetchRequestTypeFields'
        });
        setState({
            error: error,
            loading: false
        });
    };
const $1d49d8b925193243$export$e324594224ef24da = {
    setRequestTypeFieldsMap: $1d49d8b925193243$var$setRequestTypeFieldsMap,
    setIsLoading: $1d49d8b925193243$var$setIsLoading,
    setError: $1d49d8b925193243$var$setError
};

});
parcelRegister("khAYd", function(module, exports) {
$parcel$export(module.exports, "sendUIEvent", () => $9c0d8e496ea38cbc$export$1aecf263098db667);
$parcel$export(module.exports, "sendTrackEvent", () => $9c0d8e496ea38cbc$export$1ba525b8a711eaac);
$parcel$export(module.exports, "sendErrorEvent", () => $9c0d8e496ea38cbc$export$c9036e6c0dcd8835);

var $17wqU = parcelRequire("17wqU");

var $4L08H = parcelRequire("4L08H");
const $9c0d8e496ea38cbc$var$getVASource = ()=>{
    return `virtualAgent${0, $17wqU.SCREEN}`;
};
const $9c0d8e496ea38cbc$export$1aecf263098db667 = (event)=>{
    const analyticsClient = (0, $4L08H.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendUIEvent({
        ...event,
        source: $9c0d8e496ea38cbc$var$getVASource()
    }).catch((error)=>{
        throw new Error(`Failure to send UI analytics event ${error}`);
    });
};
const $9c0d8e496ea38cbc$export$22a3b1671f38a193 = ({ name: name, attributes: attributes })=>{
    const event = {
        name: name,
        attributes: {
            ...attributes,
            source: $9c0d8e496ea38cbc$var$getVASource()
        }
    };
    const analyticsClient = (0, $4L08H.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendScreenEvent(event).catch((error)=>{
        throw new Error(`Failure to send screen analytics event ${error}`);
    });
};
const $9c0d8e496ea38cbc$export$1ba525b8a711eaac = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    const analyticsClient = (0, $4L08H.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendTrackEvent({
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        source: $9c0d8e496ea38cbc$var$getVASource()
    }).catch((error)=>{
        throw new Error(`Failure to send track analytics event ${error}`);
    });
};
const $9c0d8e496ea38cbc$export$e5f89b51c6d4e36b = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    $9c0d8e496ea38cbc$var$sendOperationalOrErrorAnalyticsEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        action: 'success'
    });
};
const $9c0d8e496ea38cbc$export$c9036e6c0dcd8835 = ({ error: error, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    $9c0d8e496ea38cbc$var$sendOperationalOrErrorAnalyticsEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: 'failed',
        attributes: {
            ...attributes,
            error: error
        }
    });
};
const $9c0d8e496ea38cbc$var$sendOperationalOrErrorAnalyticsEvent = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, action: action, attributes: attributes })=>{
    const analyticsClient = (0, $4L08H.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendOperationalEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes,
        source: $9c0d8e496ea38cbc$var$getVASource()
    }).catch((err)=>{
        throw new Error(`Failure to send operational analytics event ${err}`);
    });
};

});




parcelRegister("gRDet", function(module, exports) {
$parcel$export(module.exports, "SHORT_TEXT_FIELD_TYPE", () => $beecc6a7a3885320$export$4351cd1d22652b1a);
$parcel$export(module.exports, "PARAGRAPH_FIELD_TYPE", () => $beecc6a7a3885320$export$a66f2119b5091b7e);
$parcel$export(module.exports, "SINGLE_SELECT_FIELD_TYPE", () => $beecc6a7a3885320$export$dbe52b9d883d2625);
$parcel$export(module.exports, "DATE_PICKER_FIELD_TYPE", () => $beecc6a7a3885320$export$4a9ce2f29e91e07);
$parcel$export(module.exports, "getFieldType", () => $beecc6a7a3885320$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isTextField", () => $beecc6a7a3885320$export$1cda748695867c48);
const $beecc6a7a3885320$export$4351cd1d22652b1a = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $beecc6a7a3885320$export$a66f2119b5091b7e = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $beecc6a7a3885320$export$dbe52b9d883d2625 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $beecc6a7a3885320$export$4a9ce2f29e91e07 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $beecc6a7a3885320$export$b9089a6e41ed43aa = (fieldId, data)=>{
    const field = data.get(fieldId);
    if (!field) return undefined;
    if ('custom' in field.jiraSchema) return field.jiraSchema.custom;
    return undefined;
};
const $beecc6a7a3885320$export$1cda748695867c48 = (fieldId, data)=>{
    const fieldType = $beecc6a7a3885320$export$b9089a6e41ed43aa(fieldId, data);
    return fieldType === $beecc6a7a3885320$export$4351cd1d22652b1a || fieldType === $beecc6a7a3885320$export$a66f2119b5091b7e;
};

});

parcelRegister("fOX04", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $a8e0f57d4a0f79c9$export$4d17e2d9c5348842);
$parcel$export(module.exports, "useIsLoading", () => $a8e0f57d4a0f79c9$export$4dface15d86304a4);
$parcel$export(module.exports, "useError", () => $a8e0f57d4a0f79c9$export$5027865de34f9ec6);
$parcel$export(module.exports, "useBaseUrl", () => $a8e0f57d4a0f79c9$export$d791fbc58bd47703);
$parcel$export(module.exports, "useFieldFromLastMessage", () => $a8e0f57d4a0f79c9$export$c011746629259c11);
$parcel$export(module.exports, "useIsLastMessage", () => $a8e0f57d4a0f79c9$export$cd2e50d12ce4b586);
$parcel$export(module.exports, "useConversationHasMessages", () => $a8e0f57d4a0f79c9$export$400cd0867e25f460);
$parcel$export(module.exports, "useActions", () => $a8e0f57d4a0f79c9$export$bc923229a7fa61e7);

var $6xLCs = parcelRequire("6xLCs");
var $kUoOn = parcelRequire("kUoOn");

var $ftbKG = parcelRequire("ftbKG");

var $lYBfq = parcelRequire("lYBfq");

var $fEJ50 = parcelRequire("fEJ50");
const $a8e0f57d4a0f79c9$var$initialState = {
    conversationProvider: {
        sendMessage: ()=>Promise.reject(new Error('No conversation provider')),
        startConversation: ()=>Promise.reject(new Error('No conversation provider'))
    },
    messages: []
};
const $a8e0f57d4a0f79c9$var$store = (0, $kUoOn.createStore)({
    actions: $ftbKG.actions,
    initialState: $a8e0f57d4a0f79c9$var$initialState,
    name: 'Conversation',
    containedBy: (0, $lYBfq.ConversationStateContainer),
    handlers: {
        onInit: ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
                setState({
                    conversationProvider: conversationProvider,
                    portalId: portalId,
                    projectId: projectId,
                    contextId: contextId,
                    baseUrl: baseUrl,
                    isTestConversation: isTestConversation,
                    handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
                });
            },
        onContainerUpdate: ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
                setState({
                    conversationProvider: conversationProvider,
                    portalId: portalId,
                    projectId: projectId,
                    contextId: contextId,
                    baseUrl: baseUrl,
                    isTestConversation: isTestConversation,
                    handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
                });
            }
    }
});
const $a8e0f57d4a0f79c9$export$4d17e2d9c5348842 = (0, $6xLCs.createStateHook)($a8e0f57d4a0f79c9$var$store, {
    selector: (state)=>state.messages
});
const $a8e0f57d4a0f79c9$export$4dface15d86304a4 = (0, $6xLCs.createStateHook)($a8e0f57d4a0f79c9$var$store, {
    selector: (state)=>state.isLoading
});
const $a8e0f57d4a0f79c9$export$5027865de34f9ec6 = (0, $6xLCs.createStateHook)($a8e0f57d4a0f79c9$var$store, {
    selector: (state)=>state.error
});
const $a8e0f57d4a0f79c9$export$d791fbc58bd47703 = (0, $6xLCs.createStateHook)($a8e0f57d4a0f79c9$var$store, {
    selector: (state)=>state.baseUrl
});
const $a8e0f57d4a0f79c9$export$de966b4845cf82cc = (0, $6xLCs.createStateHook)($a8e0f57d4a0f79c9$var$store, {
    selector: (0, $fEJ50.getAppendicesFromLastMessage)
});
const $a8e0f57d4a0f79c9$export$c011746629259c11 = (0, $6xLCs.createStateHook)($a8e0f57d4a0f79c9$var$store, {
    selector: (0, $fEJ50.getJiraFieldFromLastMessage)
});
const $a8e0f57d4a0f79c9$export$314d3fbd2eb8690 = (0, $6xLCs.createStateHook)($a8e0f57d4a0f79c9$var$store, {
    selector: (0, $fEJ50.getLastHelpseekerMessage)
});
const $a8e0f57d4a0f79c9$export$cd2e50d12ce4b586 = (0, $6xLCs.createStateHook)($a8e0f57d4a0f79c9$var$store, {
    selector: (0, $fEJ50.getIsLastMessage)
});
const $a8e0f57d4a0f79c9$export$400cd0867e25f460 = (0, $6xLCs.createStateHook)($a8e0f57d4a0f79c9$var$store, {
    selector: (state)=>state.messages.length > 0
});
const $a8e0f57d4a0f79c9$export$bc923229a7fa61e7 = (0, $6xLCs.createActionsHook)($a8e0f57d4a0f79c9$var$store);

});
parcelRegister("ftbKG", function(module, exports) {
$parcel$export(module.exports, "actions", () => $35285d2a42dc2851$export$e324594224ef24da);

var $b189k = parcelRequire("b189k");

var $2EYSk = parcelRequire("2EYSk");

var $kkilj = parcelRequire("kkilj");

var $j3TPh = parcelRequire("j3TPh");

var $d5w88 = parcelRequire("d5w88");

var $ijnFO = parcelRequire("ijnFO");
const $35285d2a42dc2851$export$e324594224ef24da = {
    addMessage: $2EYSk.addMessage,
    selectOption: $ijnFO.selectOption,
    clearConversation: $kkilj.clearConversation,
    addJiraFieldMessage: $b189k.addJiraFieldMessage,
    retryLastHelpseekerMessage: $d5w88.retryLastHelpseekerMessage,
    resetState: $j3TPh.resetState
};

});
parcelRegister("b189k", function(module, exports) {
$parcel$export(module.exports, "addJiraFieldMessage", () => $dfb20ffac5cd6ce5$export$73f4cb8f39bccbbf);

var $1RqZd = parcelRequire("1RqZd");

var $doTbE = parcelRequire("doTbE");

var $6sVcU = parcelRequire("6sVcU");
const $dfb20ffac5cd6ce5$export$73f4cb8f39bccbbf = (fieldId, value, messageContent)=>({ dispatch: dispatch })=>{
        const helpseekerMessage = dispatch((0, $doTbE.constructHelpseekerMessage)({
            authorType: 'HELPSEEKER',
            content: messageContent || value,
            jiraField: {
                fieldId: fieldId,
                value: value
            }
        }));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $1RqZd.intentAnswerExperience).start();
        return dispatch((0, $6sVcU.sendHelpseekerMessage)(helpseekerMessage));
    };

});
parcelRegister("doTbE", function(module, exports) {
$parcel$export(module.exports, "constructHelpseekerMessage", () => $fc8ab058cdafc6a6$export$8ea190576bc1c325);

var $2xcKg = parcelRequire("2xcKg");

var $k7W4q = parcelRequire("k7W4q");
var $a260T = parcelRequire("a260T");
const $fc8ab058cdafc6a6$export$8ea190576bc1c325 = (messageBody)=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId } = getState();
        const helpseekerMessage = {
            message: {
                ...messageBody,
                content: (0, $k7W4q.doc)((0, $a260T.paragraph)(messageBody.content))
            },
            id: `client::${(0, $2xcKg.v4)()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || ''
        };
        // add user message
        setState({
            isLoading: true,
            messages: [
                ...messages,
                helpseekerMessage
            ]
        });
        return helpseekerMessage;
    };

});
parcelRegister("2xcKg", function(module, exports) {

var $1gsuJ = parcelRequire("1gsuJ");

var $b8HGo = parcelRequire("b8HGo");
var $1d888cc63eafdbed$var$uuid = $b8HGo;
$1d888cc63eafdbed$var$uuid.v1 = $1gsuJ;
$1d888cc63eafdbed$var$uuid.v4 = $b8HGo;
module.exports = $1d888cc63eafdbed$var$uuid;

});
parcelRegister("1gsuJ", function(module, exports) {

var $4J3G6 = parcelRequire("4J3G6");

var $8feGe = parcelRequire("8feGe");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $0ebd63888ea49404$var$_nodeId;
var $0ebd63888ea49404$var$_clockseq;
// Previous uuid creation time
var $0ebd63888ea49404$var$_lastMSecs = 0;
var $0ebd63888ea49404$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $0ebd63888ea49404$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $0ebd63888ea49404$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $0ebd63888ea49404$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $4J3G6();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $0ebd63888ea49404$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $0ebd63888ea49404$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $0ebd63888ea49404$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $0ebd63888ea49404$var$_lastMSecs + (nsecs - $0ebd63888ea49404$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $0ebd63888ea49404$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $0ebd63888ea49404$var$_lastMSecs = msecs;
    $0ebd63888ea49404$var$_lastNSecs = nsecs;
    $0ebd63888ea49404$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $8feGe(b);
}
module.exports = $0ebd63888ea49404$var$v1;

});
parcelRegister("4J3G6", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $370e37cc37f4ee72$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($370e37cc37f4ee72$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $370e37cc37f4ee72$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $370e37cc37f4ee72$var$getRandomValues($370e37cc37f4ee72$var$rnds8);
        return $370e37cc37f4ee72$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $370e37cc37f4ee72$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $370e37cc37f4ee72$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $370e37cc37f4ee72$var$rnds;
    };
}

});

parcelRegister("8feGe", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $600b1c998c74d065$var$byteToHex = [];
for(var $600b1c998c74d065$var$i = 0; $600b1c998c74d065$var$i < 256; ++$600b1c998c74d065$var$i)$600b1c998c74d065$var$byteToHex[$600b1c998c74d065$var$i] = ($600b1c998c74d065$var$i + 0x100).toString(16).substr(1);
function $600b1c998c74d065$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $600b1c998c74d065$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $600b1c998c74d065$var$bytesToUuid;

});


parcelRegister("b8HGo", function(module, exports) {

var $4J3G6 = parcelRequire("4J3G6");

var $8feGe = parcelRequire("8feGe");
function $81c2538dbbde144c$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $4J3G6)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $8feGe(rnds);
}
module.exports = $81c2538dbbde144c$var$v4;

});


parcelRegister("k7W4q", function(module, exports) {
$parcel$export(module.exports, "doc", () => $664c1b0a6b45ea27$export$2a111da947c407d2);
const $664c1b0a6b45ea27$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("a260T", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $e7c0a29674ce7ef4$export$9c206ddddb32a9b);

var $7iG7S = parcelRequire("7iG7S");
const $e7c0a29674ce7ef4$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $7iG7S.createTextNodes)(content)
    });

});
parcelRegister("7iG7S", function(module, exports) {
$parcel$export(module.exports, "createTextNodes", () => $587d61be464d920a$export$3a269a5941b62f04);

var $k82Dg = parcelRequire("k82Dg");
function $587d61be464d920a$export$3a269a5941b62f04(nodes) {
    return nodes.map($587d61be464d920a$export$72b9432ea0656b50);
}
function $587d61be464d920a$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $k82Dg.text)(str) : str;
}

});
parcelRegister("k82Dg", function(module, exports) {
$parcel$export(module.exports, "text", () => $c6285f1a072a4932$export$6f093cfa640b7166);
const $c6285f1a072a4932$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});




parcelRegister("6sVcU", function(module, exports) {
$parcel$export(module.exports, "sendHelpseekerMessage", () => $665a6862ef2b2dc9$export$78d52c3c7b67d769);

var $1We2B = parcelRequire("1We2B");

var $iLwZc = parcelRequire("iLwZc");

var $khAYd = parcelRequire("khAYd");

var $1RqZd = parcelRequire("1RqZd");

var $kq8FW = parcelRequire("kq8FW");
const $665a6862ef2b2dc9$export$78d52c3c7b67d769 = (message)=>({ getState: getState, setState: setState, dispatch: dispatch }, { conversationProvider: conversationProvider, handleHandOff: handleHandOff })=>{
        const { conversationId: conversationId, portalId: portalId, projectId: projectId, contextId: contextId, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent, abortController: abortController } = getState();
        if (!conversationId || !abortController) {
            dispatch((0, $kq8FW.sendMessageErrorHandler)());
            return;
        }
        conversationProvider.sendMessage(message, abortController.signal).then(async (response)=>{
            var _last;
            // https://data-portal.internal.atlassian.com/analytics/registry/65969
            (0, $khAYd.sendTrackEvent)({
                action: 'sent',
                actionSubject: 'conversationMessage',
                actionSubjectId: conversationId,
                attributes: {
                    conversationId: conversationId,
                    contextId: contextId,
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString(),
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString()
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $1RqZd.initialIntentMessageExperience).success();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $1RqZd.intentAnswerExperience).success();
            if (handleEscalateFromVirtualAgent && response.length && response[response.length - 1].conversationState === 'escalated') {
                handleEscalateFromVirtualAgent();
                return;
            }
            if ((_last = (0, $1We2B.last)(response)) !== null && _last !== void 0 && _last.shouldHandoff) {
                const { messages: messages } = getState();
                if (handleHandOff) await handleHandOff(messages, conversationId, contextId);
                const metricMetaData = {
                    contextId: contextId,
                    conversationId: conversationId,
                    handOff: true,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                };
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $1RqZd.intentAnswerExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $1RqZd.initialIntentMessageExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $iLwZc.AIAnswerExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $iLwZc.initialAIAnswerExperience).start();
                return;
            }
            for(let i = 0; i < response.length; i++)setTimeout(()=>{
                const { messages: newMessages } = getState();
                setState({
                    messages: newMessages.concat(response[i])
                });
            }, 500 * i); // 500ms delay between each message
        }).catch(()=>{
            dispatch((0, $kq8FW.sendMessageErrorHandler)());
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $1RqZd.initialIntentMessageExperience).failure();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $1RqZd.intentAnswerExperience).failure();
        }).finally(()=>setState({
                isLoading: false
            }));
    };

});
parcelRegister("iLwZc", function(module, exports) {
$parcel$export(module.exports, "AIAnswerExperience", () => $09bc03d8b3249bb6$export$1b78ddffe984ff3a);
$parcel$export(module.exports, "initialAIAnswerExperience", () => $09bc03d8b3249bb6$export$7cb0088260227065);

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $09bc03d8b3249bb6$var$AIAnswerExperienceId = 'service-management.help-center.ai-message';
const $09bc03d8b3249bb6$var$initialAIAnswerExperienceId = 'service-management.help-center.ai-initial-message-reply';
const $09bc03d8b3249bb6$export$1b78ddffe984ff3a = new (0, $ghwxF.UFOExperience)($09bc03d8b3249bb6$var$AIAnswerExperienceId, {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $09bc03d8b3249bb6$export$7cb0088260227065 = new (0, $ghwxF.UFOExperience)($09bc03d8b3249bb6$var$initialAIAnswerExperienceId, {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("kq8FW", function(module, exports) {
$parcel$export(module.exports, "sendMessageErrorHandler", () => $4aa0f0b74741f9c4$export$30fe8f944e81bd35);

var $2xcKg = parcelRequire("2xcKg");

var $khAYd = parcelRequire("khAYd");
const $4aa0f0b74741f9c4$export$30fe8f944e81bd35 = ()=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId, portalId: portalId, projectId: projectId, contextId: contextId } = getState();
        // https://data-portal.internal.atlassian.com/analytics/registry/65971
        (0, $khAYd.sendTrackEvent)({
            action: 'failed',
            actionSubject: 'conversationSendMessage',
            actionSubjectId: conversationId || '',
            attributes: {
                conversationId: conversationId,
                contextId: contextId,
                portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString(),
                projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString()
            }
        });
        const errorMessage = {
            id: `client::${(0, $2xcKg.v4)()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || '',
            message: {
                authorType: 'ERROR'
            }
        };
        setState({
            messages: [
                ...messages,
                errorMessage
            ]
        });
    };

});



parcelRegister("2EYSk", function(module, exports) {
$parcel$export(module.exports, "addMessage", () => $24d18d2b062afb7f$export$16fdb433d434f08);

var $doTbE = parcelRequire("doTbE");

var $6sVcU = parcelRequire("6sVcU");

var $8Dag9 = parcelRequire("8Dag9");
const $24d18d2b062afb7f$export$180697e5b334e664 = (message)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { conversationId: conversationId } = getState();
        try {
            const helpseekerMessage = dispatch((0, $doTbE.constructHelpseekerMessage)({
                authorType: 'HELPSEEKER',
                content: message
            }));
            // start new conversation if no conversation id
            if (!conversationId) {
                const newConversationId = await dispatch((0, $8Dag9.startConversation)(helpseekerMessage));
                if (!newConversationId) throw new Error('A conversation id for this conversation already exists.');
                helpseekerMessage.conversationChannelId = newConversationId;
            }
            return dispatch((0, $6sVcU.sendHelpseekerMessage)(helpseekerMessage));
        } catch (error) {
            setState({
                isLoading: false
            });
            return undefined;
        }
    };
const $24d18d2b062afb7f$export$16fdb433d434f08 = (message)=>({ dispatch: dispatch })=>{
        dispatch($24d18d2b062afb7f$export$180697e5b334e664(message)).catch(()=>{
            return undefined;
        });
    };

});
parcelRegister("8Dag9", function(module, exports) {
$parcel$export(module.exports, "startConversation", () => $84ea17347efc270b$export$263d31a093aceb09);

var $iLwZc = parcelRequire("iLwZc");

var $khAYd = parcelRequire("khAYd");

var $1RqZd = parcelRequire("1RqZd");
const $84ea17347efc270b$export$263d31a093aceb09 = (helpseekerMessage)=>async ({ getState: getState, setState: setState }, { conversationProvider: conversationProvider, handleHandOff: handleHandOff })=>{
        const { projectId: projectId, portalId: portalId, contextId: contextId } = getState();
        const abortController = new AbortController();
        setState({
            abortController: abortController
        });
        const handleError = (error)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/65973
            (0, $khAYd.sendTrackEvent)({
                action: 'failed',
                actionSubject: 'startConversation',
                attributes: {
                    contextId: contextId,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                }
            });
            setState({
                error: error
            });
            throw new Error(error);
        };
        try {
            const response = await conversationProvider.startConversation(abortController.signal, helpseekerMessage === null || helpseekerMessage === void 0 ? void 0 : helpseekerMessage.message);
            if (abortController.signal.aborted) return undefined;
            if (!(response !== null && response !== void 0 && response.id)) throw Error('No conversation id.');
            // https://data-portal.internal.atlassian.com/analytics/registry/65970
            (0, $khAYd.sendTrackEvent)({
                action: 'started',
                actionSubject: 'conversation',
                actionSubjectId: response.id,
                attributes: {
                    contextId: contextId,
                    conversationId: response.id,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                }
            });
            if (response.shouldHandoff && handleHandOff) {
                const messages = helpseekerMessage ? [
                    helpseekerMessage
                ] : [];
                const metricMetaData = {
                    contextId: contextId,
                    handOff: true,
                    conversationId: response.id,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                };
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $1RqZd.intentAnswerExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $1RqZd.initialIntentMessageExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $iLwZc.AIAnswerExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $iLwZc.initialAIAnswerExperience).start();
                return handleHandOff(messages, response.id, contextId);
            }
            setState({
                conversationId: response.id
            });
            return response.id;
        } catch (error) {
            if (error instanceof Error) return handleError(error.message);
            return handleError('Failed to start conversation.');
        }
    };

});


parcelRegister("kkilj", function(module, exports) {
$parcel$export(module.exports, "clearConversation", () => $af4714808b0413e0$export$2c9f6ca76cd8a6bc);

var $khAYd = parcelRequire("khAYd");
const $af4714808b0413e0$export$2c9f6ca76cd8a6bc = ()=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId, abortController: abortController } = getState();
        if (!messages.length && !conversationId) return;
        // https://data-portal.internal.atlassian.com/analytics/registry/69030
        (0, $khAYd.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'clearConversationButton'
        });
        if (abortController) abortController.abort();
        setState({
            messages: [],
            conversationId: undefined,
            isLoading: false,
            abortController: undefined
        });
    };

});

parcelRegister("j3TPh", function(module, exports) {
$parcel$export(module.exports, "resetState", () => $deaeaf81419942c6$export$8e84bad0b35de9e8);
const $deaeaf81419942c6$export$8e84bad0b35de9e8 = ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
        setState({
            conversationProvider: conversationProvider,
            portalId: portalId,
            projectId: projectId,
            contextId: contextId,
            baseUrl: baseUrl,
            isTestConversation: isTestConversation,
            handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
        });
    };

});

parcelRegister("d5w88", function(module, exports) {
$parcel$export(module.exports, "retryLastHelpseekerMessage", () => $526588748a767b59$export$f34b435044a39700);

var $2xcKg = parcelRequire("2xcKg");

var $fEJ50 = parcelRequire("fEJ50");

var $6sVcU = parcelRequire("6sVcU");
const $526588748a767b59$export$f34b435044a39700 = ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const state = getState();
        const lastMessage = (0, $fEJ50.getLastHelpseekerMessage)(state);
        if (!lastMessage) return;
        const retryMessage = {
            ...lastMessage,
            id: `client::${(0, $2xcKg.v4)()}`,
            timeCreated: new Date().toISOString()
        };
        setState({
            isLoading: true,
            messages: [
                ...state.messages,
                retryMessage
            ]
        });
        dispatch((0, $6sVcU.sendHelpseekerMessage)(retryMessage));
    };

});
parcelRegister("fEJ50", function(module, exports) {
$parcel$export(module.exports, "getAppendicesFromLastMessage", () => $33ec0acadaf03e05$export$3d8caa938a084e16);
$parcel$export(module.exports, "getJiraFieldFromLastMessage", () => $33ec0acadaf03e05$export$84b2c2cda37f9350);
$parcel$export(module.exports, "getLastHelpseekerMessage", () => $33ec0acadaf03e05$export$1596bd9bbfc2b67c);
$parcel$export(module.exports, "getIsLastMessage", () => $33ec0acadaf03e05$export$660eeeb2ec021068);

var $1We2B = parcelRequire("1We2B");
const $33ec0acadaf03e05$export$3d8caa938a084e16 = (state)=>{
    const lastMessage = (0, $1We2B.last)(state.messages);
    if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.message.authorType) === 'AGENT') return lastMessage.message.appendices;
    return undefined;
};
const $33ec0acadaf03e05$export$84b2c2cda37f9350 = (state)=>{
    const lastMessage = (0, $1We2B.last)(state.messages);
    if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.message.authorType) !== 'AGENT' || !(lastMessage !== null && lastMessage !== void 0 && lastMessage.message.appendices)) return undefined;
    const jiraField = lastMessage.message.appendices.find((appendix)=>appendix.type === 'JIRA_FIELD');
    return jiraField;
};
const $33ec0acadaf03e05$export$1596bd9bbfc2b67c = (state)=>(0, $1We2B.findLast)(state.messages, (message)=>message.message.authorType === 'HELPSEEKER');
const $33ec0acadaf03e05$export$660eeeb2ec021068 = (state, messageId)=>{
    var _findLast;
    return messageId === ((_findLast = (0, $1We2B.findLast)(state.messages)) === null || _findLast === void 0 ? void 0 : _findLast.id);
};

});


parcelRegister("ijnFO", function(module, exports) {
$parcel$export(module.exports, "selectOption", () => $c68f5515525d60c3$export$f6a817e077493ad8);

var $1RqZd = parcelRequire("1RqZd");

var $doTbE = parcelRequire("doTbE");

var $6sVcU = parcelRequire("6sVcU");
const $c68f5515525d60c3$export$f6a817e077493ad8 = (option)=>({ dispatch: dispatch })=>{
        const helpseekerMessage = dispatch((0, $doTbE.constructHelpseekerMessage)({
            authorType: 'HELPSEEKER',
            optionId: option.id,
            content: option.label || ''
        }));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $1RqZd.intentAnswerExperience).start();
        return dispatch((0, $6sVcU.sendHelpseekerMessage)(helpseekerMessage));
    };

});


parcelRegister("lYBfq", function(module, exports) {
$parcel$export(module.exports, "ConversationStateContainer", () => $f7403b004dc86885$export$2d1cf1e83cc748b3);

var $iOIPr = parcelRequire("iOIPr");
const $f7403b004dc86885$export$2d1cf1e83cc748b3 = (0, $iOIPr.createContainer)();

});



parcelRegister("056SR", function(module, exports) {
$parcel$export(module.exports, "useProvider", () => $0cb70fdc8cf487c7$export$693cdb10cec23617);
$parcel$export(module.exports, "useIsRouting", () => $0cb70fdc8cf487c7$export$f2eec64eca530862);
$parcel$export(module.exports, "useActions", () => $0cb70fdc8cf487c7$export$bc923229a7fa61e7);

var $6xLCs = parcelRequire("6xLCs");
var $kUoOn = parcelRequire("kUoOn");

var $86E3j = parcelRequire("86E3j");

var $j9M4l = parcelRequire("j9M4l");

var $jm9Ta = parcelRequire("jm9Ta");
const $0cb70fdc8cf487c7$var$initialState = {
    provider: (0, $86E3j.ConversationProvider).VIRTUAL_AGENT,
    contextId: '',
    isRouting: false
};
const $0cb70fdc8cf487c7$var$store = (0, $kUoOn.createStore)({
    initialState: $0cb70fdc8cf487c7$var$initialState,
    actions: {
        setProvider: $j9M4l.setProvider,
        resetState: $j9M4l.resetState
    },
    name: 'VIRTUAL_AGENT_ROUTING',
    containedBy: (0, $jm9Ta.RoutingStateContainer),
    handlers: {
        onInit: ()=>({ setState: setState }, { contextId: contextId })=>{
                setState({
                    contextId: contextId
                });
            }
    }
});
const $0cb70fdc8cf487c7$export$693cdb10cec23617 = (0, $6xLCs.createStateHook)($0cb70fdc8cf487c7$var$store, {
    selector: (state)=>state.provider
});
const $0cb70fdc8cf487c7$export$f2eec64eca530862 = (0, $6xLCs.createStateHook)($0cb70fdc8cf487c7$var$store, {
    selector: (state)=>state.isRouting
});
const $0cb70fdc8cf487c7$export$bc923229a7fa61e7 = (0, $6xLCs.createActionsHook)($0cb70fdc8cf487c7$var$store);

});
parcelRegister("86E3j", function(module, exports) {
$parcel$export(module.exports, "ASSISTANT_MESSAGE_STATUS", () => $211936d8e3ccf021$export$75eb63d2758dd11a);
$parcel$export(module.exports, "FeedbackType", () => $211936d8e3ccf021$export$d4c0482bf980ef26);
$parcel$export(module.exports, "ChannelMessageTypes", () => $211936d8e3ccf021$export$2468909fd00fe251);
$parcel$export(module.exports, "ConversationProvider", () => $211936d8e3ccf021$export$1c69fe0757d799c5);
var $211936d8e3ccf021$export$75eb63d2758dd11a = /*#__PURE__*/ function(ASSISTANT_MESSAGE_STATUS) {
    ASSISTANT_MESSAGE_STATUS["IDLE"] = "idle";
    ASSISTANT_MESSAGE_STATUS["LOADING_RESPONSE"] = "loadingResponse";
    ASSISTANT_MESSAGE_STATUS["AWAITING_RESPONSE"] = "awaitingResponse";
    ASSISTANT_MESSAGE_STATUS["TYPING_RESPONSE"] = "typingResponse";
    ASSISTANT_MESSAGE_STATUS["ABORTED_RESPONSE"] = "abortedResponse";
    ASSISTANT_MESSAGE_STATUS["SYNCED_RESPONSE"] = "syncedResponse";
    return ASSISTANT_MESSAGE_STATUS;
}({});
var $211936d8e3ccf021$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["POSITIVE"] = "positive";
    FeedbackType["NEGATIVE"] = "negative";
    return FeedbackType;
}({});
var $211936d8e3ccf021$export$2468909fd00fe251 = /*#__PURE__*/ function(ChannelMessageTypes) {
    ChannelMessageTypes["CHANNEL_FAILURE"] = "CHANNEL_FAILURE";
    ChannelMessageTypes["CHANNEL_EXPIRY"] = "CHANNEL_EXPIRY";
    ChannelMessageTypes["CHANNEL_CONVERSATION_OVER"] = "CHANNEL_CONVERSATION_OVER";
    return ChannelMessageTypes;
}({});
const $211936d8e3ccf021$export$1c69fe0757d799c5 = {
    VIRTUAL_AGENT: 'VIRTUAL_AGENT',
    AI_ANSWERS: 'AI_ANSWERS'
};

});

parcelRegister("j9M4l", function(module, exports) {
$parcel$export(module.exports, "setProvider", () => $918924abb4bb59e5$export$1572b3eade6662f9);
$parcel$export(module.exports, "resetState", () => $918924abb4bb59e5$export$8e84bad0b35de9e8);

var $86E3j = parcelRequire("86E3j");
const $918924abb4bb59e5$export$1572b3eade6662f9 = (provider)=>({ setState: setState })=>setState({
            provider: provider
        });
const $918924abb4bb59e5$export$8e84bad0b35de9e8 = ()=>({ setState: setState }, { contextId: contextId })=>{
        setState({
            contextId: contextId,
            provider: (0, $86E3j.ConversationProvider).VIRTUAL_AGENT,
            isRouting: false
        });
    };

});

parcelRegister("jm9Ta", function(module, exports) {
$parcel$export(module.exports, "RoutingStateContainer", () => $e41b5d92366c049b$export$92282a62d0a1b5d4);

var $iOIPr = parcelRequire("iOIPr");
const $e41b5d92366c049b$export$92282a62d0a1b5d4 = (0, $iOIPr.createContainer)();

});


parcelRegister("8E60W", function(module, exports) {
$parcel$export(module.exports, "useConversation", () => $ef98d096988f3dcd$export$626f7ff9a7747889);
$parcel$export(module.exports, "useConversationId", () => $ef98d096988f3dcd$export$27499dbe4de0e477);
$parcel$export(module.exports, "useConversationActions", () => $ef98d096988f3dcd$export$325b6e88f398f098);
$parcel$export(module.exports, "useIsTesting", () => $ef98d096988f3dcd$export$6747b41fb9e7b49a);
$parcel$export(module.exports, "useFeedbackCollectorConfig", () => $ef98d096988f3dcd$export$f0e236cf8822a84c);
$parcel$export(module.exports, "useIsChannelErrorPresent", () => $ef98d096988f3dcd$export$adfa38c4df66c906);
$parcel$export(module.exports, "getMessageFeedback", () => $ef98d096988f3dcd$export$ee9551cc487e053e);
$parcel$export(module.exports, "getCsatScore", () => $ef98d096988f3dcd$export$df253d0caf8deb0d);
$parcel$export(module.exports, "getLastMessageId", () => $ef98d096988f3dcd$export$63f3452801f9da26);
$parcel$export(module.exports, "useIsLastAssistantMessageGenerated", () => $ef98d096988f3dcd$export$dbf2a467a43e692a);
$parcel$export(module.exports, "useActions", () => $ef98d096988f3dcd$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useIsLastMessageFromHelpSeeker", () => $ef98d096988f3dcd$export$c095b9ac465c114e);
$parcel$export(module.exports, "useIsFeedbackSkipped", () => $ef98d096988f3dcd$export$d82a5ee85cfb7890);
$parcel$export(module.exports, "useIsCsatSkipped", () => $ef98d096988f3dcd$export$df5c667a37af1373);

var $6xLCs = parcelRequire("6xLCs");
var $kUoOn = parcelRequire("kUoOn");

var $86E3j = parcelRequire("86E3j");

var $67R6p = parcelRequire("67R6p");

var $bnIuT = parcelRequire("bnIuT");
const $ef98d096988f3dcd$var$store = (0, $kUoOn.createStore)({
    initialState: $bnIuT.initialState,
    actions: {
        fetchChannelId: $67R6p.fetchChannelId,
        startNewConversation: $67R6p.startNewConversation,
        onPipelineChange: $67R6p.onPipelineChange,
        setTesting: $67R6p.setTesting,
        setConversationScrollBarWidth: $67R6p.setConversationScrollBarWidth,
        recordFeedbackForConversation: $67R6p.recordFeedbackForConversation,
        refetchConversation: $67R6p.refetchConversation,
        addHelpseekerMessage: $67R6p.addHelpseekerMessage,
        addHelpseekerMessageOnlyForUI: $67R6p.addHelpseekerMessageOnlyForUI,
        addFeedbackResponseOnlyForUI: $67R6p.addFeedbackResponseOnlyForUI,
        addRetryMessageOnlyForUI: $67R6p.addRetryMessageOnlyForUI,
        setFeedbackCollectorConfig: $67R6p.setFeedbackCollectorConfig,
        clearConversation: $67R6p.clearConversation,
        abortConversation: $67R6p.abortConversation,
        takeOverConversationFromVA: $67R6p.takeOverConversationFromVA,
        addCsatResponseOnlyForUI: $67R6p.addCsatResponseOnlyForUI
    },
    name: 'CONVERSE'
});
const $ef98d096988f3dcd$export$626f7ff9a7747889 = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state)=>state.conversation
});
const $ef98d096988f3dcd$export$27499dbe4de0e477 = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state)=>{
        var _state$conversation;
        return (_state$conversation = state.conversation) === null || _state$conversation === void 0 ? void 0 : _state$conversation.conversationId;
    }
});
const $ef98d096988f3dcd$export$325b6e88f398f098 = (0, $6xLCs.createActionsHook)($ef98d096988f3dcd$var$store);
const $ef98d096988f3dcd$export$6747b41fb9e7b49a = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state)=>state.isTesting
});
const $ef98d096988f3dcd$export$f0e236cf8822a84c = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state)=>state.feedbackCollectorConfig
});
const $ef98d096988f3dcd$var$findBotOrAssistantMessage = (messageId)=>(chatMessage)=>{
        return chatMessage && chatMessage.userType === (0, $bnIuT.ASSISTANT_USER_TYPE) && chatMessage.messageMetadata.messageId === messageId;
    };
const $ef98d096988f3dcd$export$adfa38c4df66c906 = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state)=>{
        if (!state.conversation) return false;
        const lastMessage = state.conversation.history.slice(-1)[0];
        return (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.userType) === 'channelMessage';
    }
});
const $ef98d096988f3dcd$export$ee9551cc487e053e = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation2;
        const message = (_state$conversation2 = state.conversation) === null || _state$conversation2 === void 0 ? void 0 : _state$conversation2.history.find($ef98d096988f3dcd$var$findBotOrAssistantMessage(messageId));
        return message ? message === null || message === void 0 ? void 0 : message.messageMetadata.messageFeedback : undefined;
    }
});
const $ef98d096988f3dcd$export$df253d0caf8deb0d = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation3;
        const message = (_state$conversation3 = state.conversation) === null || _state$conversation3 === void 0 ? void 0 : _state$conversation3.history.find($ef98d096988f3dcd$var$findBotOrAssistantMessage(messageId));
        return message ? message.messageMetadata.csatScore : undefined;
    }
});
const $ef98d096988f3dcd$var$findHelpSeekerOrAssistantMessage = (chatMessage)=>{
    return chatMessage && (chatMessage.userType === (0, $bnIuT.ASSISTANT_USER_TYPE) || chatMessage.userType === (0, $bnIuT.HELP_SEEKER_USER_TYPE));
};
const $ef98d096988f3dcd$export$63f3452801f9da26 = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state)=>{
        var _state$conversation4;
        const message = (_state$conversation4 = state.conversation) === null || _state$conversation4 === void 0 ? void 0 : _state$conversation4.history.filter($ef98d096988f3dcd$var$findHelpSeekerOrAssistantMessage).at(-1);
        return message && 'messageMetadata' in message ? message.messageMetadata.messageId : undefined;
    }
});
const $ef98d096988f3dcd$export$dbf2a467a43e692a = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state)=>{
        const { conversation: conversation, isLoading: isLoading } = state;
        const lastMessage = conversation === null || conversation === void 0 ? void 0 : conversation.history.slice(-1)[0];
        const storeAbortController = conversation === null || conversation === void 0 ? void 0 : conversation.storeAbortController;
        if (lastMessage && lastMessage.userType === (0, $bnIuT.ASSISTANT_USER_TYPE) && storeAbortController) {
            const { messageMetadata: { status: status } } = lastMessage;
            if (!status) return false;
            return [
                (0, $86E3j.ASSISTANT_MESSAGE_STATUS).IDLE,
                (0, $86E3j.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
            ].indexOf(status) !== -1 && !isLoading;
        }
        return true;
    }
});
const $ef98d096988f3dcd$export$bc923229a7fa61e7 = (0, $6xLCs.createActionsHook)($ef98d096988f3dcd$var$store);
const $ef98d096988f3dcd$export$c095b9ac465c114e = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state)=>{
        var _state$conversation5, _state$conversation6;
        return(// After first message, conversation is an object but has no history
        // To stop the user from sending another message here, we are waiting for history array to be filled
        ((_state$conversation5 = state.conversation) === null || _state$conversation5 === void 0 ? void 0 : _state$conversation5.history.length) === 0 || ((_state$conversation6 = state.conversation) === null || _state$conversation6 === void 0 || (_state$conversation6 = _state$conversation6.history.slice(-1)[0]) === null || _state$conversation6 === void 0 ? void 0 : _state$conversation6.userType) === (0, $bnIuT.HELP_SEEKER_USER_TYPE));
    }
});
const $ef98d096988f3dcd$export$d82a5ee85cfb7890 = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation7;
        const message = (_state$conversation7 = state.conversation) === null || _state$conversation7 === void 0 ? void 0 : _state$conversation7.history.find($ef98d096988f3dcd$var$findBotOrAssistantMessage(messageId));
        return message ? message === null || message === void 0 ? void 0 : message.messageMetadata.isFeedbackSkipped : undefined;
    }
});
const $ef98d096988f3dcd$export$df5c667a37af1373 = (0, $6xLCs.createHook)($ef98d096988f3dcd$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation8;
        const message = (_state$conversation8 = state.conversation) === null || _state$conversation8 === void 0 ? void 0 : _state$conversation8.history.find($ef98d096988f3dcd$var$findBotOrAssistantMessage(messageId));
        return message ? message.messageMetadata.isCsatSkipped : undefined;
    }
});

});
parcelRegister("67R6p", function(module, exports) {
$parcel$export(module.exports, "fetchChannelId", () => $38357226fb04ea94$export$92b5f8fb222eed7e);
$parcel$export(module.exports, "startNewConversation", () => $38357226fb04ea94$export$ec10fd022bf0d0a1);
$parcel$export(module.exports, "addHelpseekerMessageOnlyForUI", () => $38357226fb04ea94$export$7d26299426387884);
$parcel$export(module.exports, "onPipelineChange", () => $38357226fb04ea94$export$5690758dea68962c);
$parcel$export(module.exports, "setTesting", () => $38357226fb04ea94$export$c0371739272785cf);
$parcel$export(module.exports, "setConversationScrollBarWidth", () => $38357226fb04ea94$export$3549374a7ffc1e0f);
$parcel$export(module.exports, "recordFeedbackForConversation", () => $38357226fb04ea94$export$d775316ddbd97650);
$parcel$export(module.exports, "refetchConversation", () => $38357226fb04ea94$export$f84e8215cf018fc2);
$parcel$export(module.exports, "addHelpseekerMessage", () => $38357226fb04ea94$export$39e5a890dd0d70ff);
$parcel$export(module.exports, "addFeedbackResponseOnlyForUI", () => $38357226fb04ea94$export$8bc7344bcdeb6569);
$parcel$export(module.exports, "addCsatResponseOnlyForUI", () => $38357226fb04ea94$export$193f22ef45a60fb9);
$parcel$export(module.exports, "addRetryMessageOnlyForUI", () => $38357226fb04ea94$export$2024ac9dac025c83);
$parcel$export(module.exports, "setFeedbackCollectorConfig", () => $38357226fb04ea94$export$5e2723610064e2d9);
$parcel$export(module.exports, "clearConversation", () => $38357226fb04ea94$export$2c9f6ca76cd8a6bc);
$parcel$export(module.exports, "abortConversation", () => $38357226fb04ea94$export$882bd6a6d00830a0);
$parcel$export(module.exports, "takeOverConversationFromVA", () => $38357226fb04ea94$export$9ff6f230516497d2);
/* eslint-disable @typescript-eslint/require-await */ 
var $HGACo = parcelRequire("HGACo");

var $k7W4q = parcelRequire("k7W4q");
var $a260T = parcelRequire("a260T");

var $300Z2 = parcelRequire("300Z2");
var $gxLiU = parcelRequire("gxLiU");

var $iLwZc = parcelRequire("iLwZc");

var $86E3j = parcelRequire("86E3j");

var $57tpL = parcelRequire("57tpL");

var $gjq18 = parcelRequire("gjq18");

var $7wNYU = parcelRequire("7wNYU");

var $aiQwE = parcelRequire("aiQwE");

var $3obBJ = parcelRequire("3obBJ");

var $jS2et = parcelRequire("jS2et");

var $kVmcK = parcelRequire("kVmcK");

var $fbLft = parcelRequire("fbLft");

var $2qLA3 = parcelRequire("2qLA3");

var $9TbQq = parcelRequire("9TbQq");

var $deo79 = parcelRequire("deo79");

var $kvQ5d = parcelRequire("kvQ5d");

var $bnIuT = parcelRequire("bnIuT");
const $38357226fb04ea94$var$CHANNEL_EXPIRY_TIME = 300000; // 5mins
const $38357226fb04ea94$var$ONE_DAY = 86400000; // 24 Hours
const $38357226fb04ea94$var$getChannelExpiryTime = ()=>{
    return (0, $HGACo.isAiAnswer24HourTimeoutEnabled)() ? $38357226fb04ea94$var$ONE_DAY : $38357226fb04ea94$var$CHANNEL_EXPIRY_TIME;
};
const $38357226fb04ea94$export$92b5f8fb222eed7e = (vaConversationId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        try {
            var _getState$conversatio;
            const channelId = await (0, $57tpL.getChannelId)();
            const history = ((_getState$conversatio = getState().conversation) === null || _getState$conversatio === void 0 ? void 0 : _getState$conversatio.history) || [];
            dispatch($38357226fb04ea94$var$resetTimer(channelId));
            if (channelId) setState({
                isLoading: false,
                conversation: {
                    conversationId: channelId,
                    externalConversationId: vaConversationId,
                    history: [
                        ...history
                    ]
                }
            });
            else throw new Error('No channel id!');
        } catch (e) {
            await dispatch($38357226fb04ea94$var$addChannelMessage((0, $86E3j.ChannelMessageTypes).CHANNEL_EXPIRY));
        }
    };
const $38357226fb04ea94$var$resetTimer = (channelId, timer = $38357226fb04ea94$var$getChannelExpiryTime())=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const currentTimer = getState().activeTimer;
        const analyticsClient = (0, $9TbQq.getAnalyticsWebClient)();
        if (currentTimer) clearTimeout(currentTimer);
        const activeTimer = setTimeout(()=>{
            dispatch($38357226fb04ea94$var$cleanFollowUps());
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            dispatch($38357226fb04ea94$var$addChannelMessage((0, $86E3j.ChannelMessageTypes).CHANNEL_EXPIRY));
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.sendTrackEvent({
                source: 'uhConversationScreen',
                action: 'expired',
                actionSubject: 'conversation',
                attributes: {
                    conversationId: channelId,
                    ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
                }
            });
        }, timer);
        setState({
            activeTimer: activeTimer
        });
    };
const $38357226fb04ea94$export$ec10fd022bf0d0a1 = (term)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        setState({
            isLoading: true,
            conversation: {
                conversationId: null,
                history: []
            }
        });
        await dispatch($38357226fb04ea94$export$92b5f8fb222eed7e());
        const conversation = getState().conversation;
        if (conversation && conversation.conversationId) {
            dispatch($38357226fb04ea94$export$7d26299426387884(term));
            /**
     * Mark conversation start when the first conversation message is sent
     */ setState({
                conversationStartTime: Date.now()
            });
            dispatch($38357226fb04ea94$var$fetchConversation(term));
        }
    };
const $38357226fb04ea94$export$5690758dea68962c = (pipeline)=>async ({ setState: setState })=>{
        setState({
            pipeline: pipeline
        });
    };
const $38357226fb04ea94$export$c0371739272785cf = (isTesting)=>async ({ setState: setState })=>{
        setState({
            isTesting: isTesting
        });
    };
const $38357226fb04ea94$export$3549374a7ffc1e0f = (conversationScrollBarWidth)=>({ setState: setState })=>{
        setState({
            ui: {
                conversationScrollBarWidth: conversationScrollBarWidth
            }
        });
    };
const $38357226fb04ea94$var$addChannelMessage = (type)=>({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            conversationId: null,
            history: [
                ...conversation.history.map((message)=>{
                    if (message.userType === (0, $bnIuT.ASSISTANT_USER_TYPE) && !message.messageMetadata.isFeedbackSkipped && !message.messageMetadata.messageFeedback) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isFeedbackSkipped: true
                        }
                    };
                    if (message.userType === (0, $bnIuT.ASSISTANT_USER_TYPE) && !message.messageMetadata.isCsatSkipped && !message.messageMetadata.csatScore) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isCsatSkipped: true
                        }
                    };
                    return message;
                }),
                {
                    userType: 'channelMessage',
                    messageType: type
                }
            ]
        };
        setState({
            conversation: conversation,
            isLoading: false
        });
    };
const $38357226fb04ea94$export$d775316ddbd97650 = (id, { feedbackLabel: feedbackLabel, feedbackType: feedbackType, detailedFeedback: detailedFeedback })=>async ({ getState: getState, setState: setState })=>{
        const analyticsClient = (0, $9TbQq.getAnalyticsWebClient)();
        const conversation = getState().conversation;
        if (!conversation || !conversation.conversationId) throw new Error('No conversation!');
        (0, $gjq18.storeFeedback)({
            feedbackLabel: feedbackLabel,
            channelId: conversation.conversationId,
            messageId: id,
            feedback: feedbackType === (0, $86E3j.FeedbackType).POSITIVE ? 'LIKE' : 'DISLIKE'
        }).catch(()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.sendTrackEvent({
                source: 'uhAiMateFeedbackRequest',
                action: 'feedbackRequestFailed',
                actionSubject: 'feedback',
                actionSubjectId: conversation.conversationId || '',
                attributes: {
                    isAiMate: true,
                    ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
                }
            });
        });
        const updatedConversationHistory = conversation.history.map((message)=>{
            if (message.userType === (0, $bnIuT.ASSISTANT_USER_TYPE)) {
                const { messageId: messageId } = message.messageMetadata;
                if (messageId && messageId === id) return {
                    ...message,
                    messageMetadata: {
                        ...message.messageMetadata,
                        messageFeedback: {
                            feedbackType: feedbackType,
                            feedbackLabel: feedbackLabel,
                            detailedFeedback: detailedFeedback
                        }
                    }
                };
            }
            return message;
        });
        const updatedConversation = {
            ...conversation,
            history: updatedConversationHistory
        };
        setState({
            conversation: updatedConversation
        });
    };
const $38357226fb04ea94$var$getDefaultErrorState = (conversation)=>{
    let updatedConversationHistory = conversation.history;
    const lastMessageUserType = conversation.history[conversation.history.length - 1].userType;
    if (lastMessageUserType === (0, $bnIuT.ASSISTANT_USER_TYPE)) updatedConversationHistory = updatedConversationHistory.slice(0, -1);
    return {
        ...conversation,
        history: [
            ...updatedConversationHistory,
            {
                userType: 'error'
            }
        ]
    };
};
const $38357226fb04ea94$export$f84e8215cf018fc2 = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        var _helpSeekerMessages$m;
        const conversation = getState().conversation;
        if (!conversation || !conversation.conversationId) return;
        const history = conversation.history;
        const helpSeekerMessages = history.filter((chatMessage)=>chatMessage.userType === (0, $bnIuT.HELP_SEEKER_USER_TYPE));
        const term = (_helpSeekerMessages$m = helpSeekerMessages[helpSeekerMessages.length - 1].messageMetadata) === null || _helpSeekerMessages$m === void 0 ? void 0 : _helpSeekerMessages$m.originalQuery;
        if (term) dispatch($38357226fb04ea94$var$fetchConversation(term));
    };
const $38357226fb04ea94$var$fetchConversation = (message)=>async ({ getState: getState, setState: setState })=>{
        var _metadata, _metadata2, _metadata3, _metadata4, _metadata5, _metadata6, _metadata7;
        const { conversation: conversation } = getState();
        const analyticsClient = (0, $9TbQq.getAnalyticsWebClient)();
        if (!conversation || !conversation.conversationId) throw new Error('No conversation!');
        if (conversation.storeAbortController) // Silently aborting if there is another operation in progress
        return;
        try {
            const { storeAbortController: storeAbortController } = (0, $2qLA3.createStoreAbortController)();
            setState({
                isLoading: true
            });
            (0, $deo79.sendUIEventForAskedQuestion)(analyticsClient, conversation.conversationId, conversation.history.length, message.length, conversation.externalConversationId);
            const answerId = (0, $7wNYU.genIntId)();
            let assistantMessage = (0, $aiQwE.initialAssistantMessage)(answerId);
            let generator;
            let isAnswerPartAnalyticsFired = false;
            let isFallbackMessage = false;
            const startTime = performance.now();
            let finishTime;
            try {
                generator = await (0, $57tpL.sendMessageStream)(message, conversation.conversationId, storeAbortController);
            } catch (e) {
                setState({
                    conversation: $38357226fb04ea94$var$getDefaultErrorState(conversation)
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                analyticsClient.sendTrackEvent({
                    source: 'uhAiMateRequest',
                    action: 'streaming_fetch_failed',
                    actionSubject: 'conversation',
                    actionSubjectId: conversation.conversationId,
                    attributes: {
                        isAiMate: true,
                        ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $iLwZc.initialAIAnswerExperience).failure();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $iLwZc.AIAnswerExperience).failure();
                return;
            }
            if (!generator) return;
            setState({
                conversation: {
                    ...(0, $fbLft.addAssistantMessage)(assistantMessage, conversation),
                    storeAbortController: storeAbortController
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $iLwZc.initialAIAnswerExperience).success();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $iLwZc.AIAnswerExperience).success();
            for await (const streamMessage of generator){
                if (storeAbortController.signal.aborted) break;
                const { conversation: recentConversation } = getState();
                if (!recentConversation || !recentConversation.conversationId) return;
                const { type: type, content: content } = (0, $gxLiU.getUHUpdatedMessage)(streamMessage, assistantMessage.aiMateConversationResponse.message) ?? {
                    type: ''
                };
                let metadata;
                let updatedConversation;
                let totalSources;
                let totalRequestForms;
                let totalHelpDesks;
                switch(type){
                    case 'FOLLOW_UP_QUERIES':
                        setState({
                            conversation: (0, $fbLft.updateFollowUpMessage)(recentConversation, content)
                        });
                        break;
                    case 'CONTENT_SEARCH':
                        assistantMessage = (0, $fbLft.updateKeywords)(assistantMessage, content);
                        assistantMessage = (0, $fbLft.updateAssistantMessageStatusToLoadingResponse)(assistantMessage);
                        setState({
                            conversation: (0, $fbLft.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        break;
                    case 'ANALYSING_STATE':
                        assistantMessage = (0, $fbLft.updateSources)(assistantMessage, content);
                        setState({
                            conversation: (0, $fbLft.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        break;
                    case 'ANSWER_PART':
                        assistantMessage = (0, $fbLft.updateMessage)(assistantMessage, content);
                        assistantMessage = (0, $fbLft.updateAssistantMessageStatusToTypingResponse)(assistantMessage);
                        setState({
                            conversation: (0, $fbLft.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        setState({
                            isLoading: false
                        });
                        !isAnswerPartAnalyticsFired && (0, $deo79.sendTrackEventForAnswerStreamingStarted)(analyticsClient, conversation.conversationId, performance.now() - startTime, conversation.externalConversationId);
                        isAnswerPartAnalyticsFired = true;
                        break;
                    case 'FINAL_RESPONSE':
                        metadata = content === null || content === void 0 ? void 0 : content.message_metadata;
                        isFallbackMessage = !!((_metadata = metadata) !== null && _metadata !== void 0 && _metadata.isFallbackMessage);
                        assistantMessage = (0, $fbLft.updateFinalMessage)(assistantMessage, content, isFallbackMessage);
                        if (isFallbackMessage) {
                            var _assistantMessage$aiM, _assistantMessage$mes;
                            const retryMessage = $38357226fb04ea94$var$getRetryMessage((_assistantMessage$aiM = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM === void 0 || (_assistantMessage$aiM = _assistantMessage$aiM.message) === null || _assistantMessage$aiM === void 0 || (_assistantMessage$aiM = _assistantMessage$aiM.message_metadata) === null || _assistantMessage$aiM === void 0 ? void 0 : _assistantMessage$aiM.originalQuery, (_assistantMessage$mes = assistantMessage.messageMetadata) === null || _assistantMessage$mes === void 0 ? void 0 : _assistantMessage$mes.messageId, isFallbackMessage);
                            updatedConversation = (0, $fbLft.replaceLastAssistantMessage)(retryMessage, recentConversation);
                        } else updatedConversation = (0, $fbLft.replaceLastAssistantMessage)(assistantMessage, recentConversation);
                        setState({
                            conversation: updatedConversation
                        });
                        finishTime = performance.now();
                        totalSources = (0, $kVmcK.getTotalSources)(content);
                        totalHelpDesks = (0, $3obBJ.getTotalHelpDesks)(content);
                        totalRequestForms = (0, $jS2et.getTotalRequestForms)(content);
                        (0, $deo79.sendTrackEventForFetchedResponse)(analyticsClient, finishTime - startTime, (_metadata2 = metadata) === null || _metadata2 === void 0 ? void 0 : _metadata2.confidenceScore, (_metadata3 = metadata) === null || _metadata3 === void 0 ? void 0 : _metadata3.isFallbackMessage, (_metadata4 = metadata) === null || _metadata4 === void 0 ? void 0 : _metadata4.isConfluenceLicensedUser, (_metadata5 = metadata) === null || _metadata5 === void 0 ? void 0 : _metadata5.isVagueQuery, (_metadata6 = metadata) === null || _metadata6 === void 0 ? void 0 : _metadata6.searchResultCount, (_metadata7 = metadata) === null || _metadata7 === void 0 ? void 0 : _metadata7.totalSearchResultCount, recentConversation.conversationId, totalSources, totalHelpDesks, totalRequestForms, assistantMessage.messageMetadata.messageId, recentConversation.externalConversationId);
                        break;
                    case 'ERROR':
                        setState({
                            conversation: $38357226fb04ea94$var$getDefaultErrorState(recentConversation)
                        });
                        (0, $deo79.sendTrackEventForFailure)(analyticsClient, recentConversation.conversationId, false, recentConversation.externalConversationId);
                        break;
                    default:
                        break;
                }
            }
        } finally{
            const { conversation: currentConversation } = getState();
            setState({
                conversation: currentConversation ? {
                    ...currentConversation,
                    storeAbortController: undefined
                } : null,
                isLoading: false
            });
        }
    };
const $38357226fb04ea94$export$39e5a890dd0d70ff = (term)=>async ({ getState: getState, dispatch: dispatch })=>{
        var _getState$conversatio2;
        dispatch($38357226fb04ea94$var$resetTimer((_getState$conversatio2 = getState().conversation) === null || _getState$conversatio2 === void 0 ? void 0 : _getState$conversatio2.conversationId));
        dispatch($38357226fb04ea94$var$cleanFollowUps());
        dispatch($38357226fb04ea94$export$7d26299426387884(term));
        dispatch($38357226fb04ea94$var$fetchConversation(term));
    };
const $38357226fb04ea94$var$cleanFollowUps = ()=>({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            ...conversation,
            history: conversation.history.filter((item)=>item.userType !== 'followUp')
        };
        setState({
            conversation: conversation
        });
    };
const $38357226fb04ea94$export$7d26299426387884 = (term)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            ...conversation,
            history: [
                ...conversation.history.map((message)=>{
                    if (message.userType === (0, $bnIuT.ASSISTANT_USER_TYPE) && !message.messageMetadata.isFeedbackSkipped && !message.messageMetadata.messageFeedback) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isFeedbackSkipped: true
                        }
                    };
                    if (message.userType === (0, $bnIuT.ASSISTANT_USER_TYPE) && !message.messageMetadata.isCsatSkipped && !message.messageMetadata.csatScore) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isCsatSkipped: true
                        }
                    };
                    return message;
                }),
                {
                    userType: 'helpseeker',
                    messageContentAdf: (0, $k7W4q.doc)((0, $a260T.paragraph)(term)),
                    messageMetadata: {
                        originalQuery: term
                    }
                }
            ]
        };
        setState({
            conversation: conversation
        });
    };
const $38357226fb04ea94$export$8bc7344bcdeb6569 = (response, id, isResolved)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        const responseObject = {
            userType: 'feedbackResponse',
            messageContentAdf: (0, $k7W4q.doc)((0, $a260T.paragraph)(response))
        };
        const newHistory = [
            ...conversation.history
        ];
        newHistory.splice(indexOfAssistantMessage + 1, 0, responseObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
        if (isResolved) {
            dispatch($38357226fb04ea94$var$addCsatDropdownMessageOnlyForUI(indexOfAssistantMessage, id));
            if ((0, $HGACo.isVAFollowupQueryOnlyForPositiveResponseEnabled)()) {
                var _getState$conversatio3;
                dispatch($38357226fb04ea94$var$cleanFollowUps());
                dispatch($38357226fb04ea94$var$resetTimer((_getState$conversatio3 = getState().conversation) === null || _getState$conversatio3 === void 0 ? void 0 : _getState$conversatio3.conversationId, $38357226fb04ea94$var$ONE_DAY));
            }
        }
    };
const $38357226fb04ea94$export$193f22ef45a60fb9 = (response, id)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        conversation.history[indexOfAssistantMessage].messageMetadata.csatScore = response.id;
        const helpseekerResponseObject = {
            userType: 'feedbackResponse',
            messageContentAdf: (0, $k7W4q.doc)((0, $a260T.paragraph)(response.label))
        };
        // the CSAT response will be shown after, Feedback Response: 'Yes' and CSAT Dropdown Message, so we have to hop 3 indices
        const targetIndex = indexOfAssistantMessage + 3;
        const newHistory = [
            ...conversation.history
        ];
        if ((0, $HGACo.isVAFollowupQueryOnlyForPositiveResponseEnabled)()) {
            const closeConversationObject = {
                userType: 'channelMessage',
                messageType: (0, $86E3j.ChannelMessageTypes).CHANNEL_CONVERSATION_OVER
            };
            newHistory.splice(targetIndex, 0, helpseekerResponseObject, closeConversationObject);
        } else newHistory.splice(targetIndex, 0, helpseekerResponseObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $38357226fb04ea94$var$addCsatDropdownMessageOnlyForUI = (indexOfAssistantMessage, messageId)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const csatDropdownMessageObject = {
            userType: 'csatDropdown',
            messageMetadata: {
                messageId: messageId
            }
        };
        const newHistory = [
            ...conversation.history
        ];
        // the CSAT Dropdown will be shown after, Feedback Response: 'Yes', so we have to hop 2 indices
        newHistory.splice(indexOfAssistantMessage + 2, 0, csatDropdownMessageObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $38357226fb04ea94$var$getRetryMessage = (originalQuery, messageId, isFallbackMessage)=>({
        userType: 'retry',
        messageMetadata: {
            originalQuery: originalQuery,
            messageId: messageId,
            isFallbackMessage: isFallbackMessage
        }
    });
const $38357226fb04ea94$export$2024ac9dac025c83 = (id)=>async ({ getState: getState, setState: setState })=>{
        var _assistantMessage$aiM2, _assistantMessage$aiM3;
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        const relativeFeedbackResponseIndex = conversation.history.slice(indexOfAssistantMessage).findIndex((message)=>message.userType === 'feedbackResponse');
        const feedbackResponseIndex = relativeFeedbackResponseIndex === -1 ? -1 : relativeFeedbackResponseIndex + indexOfAssistantMessage;
        if (feedbackResponseIndex === -1) return;
        const assistantMessage = conversation.history[indexOfAssistantMessage];
        const messageObject = $38357226fb04ea94$var$getRetryMessage(assistantMessage === null || assistantMessage === void 0 || (_assistantMessage$aiM2 = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM2 === void 0 || (_assistantMessage$aiM2 = _assistantMessage$aiM2.message) === null || _assistantMessage$aiM2 === void 0 || (_assistantMessage$aiM2 = _assistantMessage$aiM2.message_metadata) === null || _assistantMessage$aiM2 === void 0 ? void 0 : _assistantMessage$aiM2.originalQuery, id, assistantMessage === null || assistantMessage === void 0 || (_assistantMessage$aiM3 = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM3 === void 0 || (_assistantMessage$aiM3 = _assistantMessage$aiM3.message) === null || _assistantMessage$aiM3 === void 0 || (_assistantMessage$aiM3 = _assistantMessage$aiM3.message_metadata) === null || _assistantMessage$aiM3 === void 0 ? void 0 : _assistantMessage$aiM3.isFallbackMessage);
        const newHistory = [
            ...conversation.history
        ];
        newHistory.splice(feedbackResponseIndex + 1, 0, messageObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $38357226fb04ea94$export$5e2723610064e2d9 = (isVisible, messageId)=>async ({ getState: getState, setState: setState })=>{
        const { messageId: existingMessageId } = getState().feedbackCollectorConfig;
        setState({
            feedbackCollectorConfig: {
                isVisible: isVisible,
                messageId: messageId || existingMessageId
            }
        });
    };
const $38357226fb04ea94$export$2c9f6ca76cd8a6bc = ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { activeTimer: activeTimer, conversation: conversation } = getState();
        const analyticsClient = (0, $9TbQq.getAnalyticsWebClient)();
        const { conversationId: conversationId, externalConversationId: externalConversationId } = conversation || {};
        if (activeTimer) clearTimeout(activeTimer);
        if (conversationId) {
            dispatch($38357226fb04ea94$export$882bd6a6d00830a0());
            (0, $deo79.sendUIEventForClearConversation)(analyticsClient, conversationId, externalConversationId);
        }
        setState({
            ...(0, $bnIuT.initialState)
        });
    };
const $38357226fb04ea94$export$882bd6a6d00830a0 = ()=>async ({ setState: setState, getState: getState })=>{
        const { conversation: conversation } = getState();
        if (!conversation || !conversation.conversationId || !conversation.storeAbortController) return;
        const lastAssistantMessage = conversation.history.slice(-1);
        if (lastAssistantMessage !== null && lastAssistantMessage !== void 0 && lastAssistantMessage.length && lastAssistantMessage[0].userType === (0, $bnIuT.ASSISTANT_USER_TYPE)) {
            const abortedMessage = (0, $fbLft.updateAbortedAssistantMessage)(lastAssistantMessage[0]);
            setState({
                conversation: (0, $fbLft.replaceLastAssistantMessage)(abortedMessage, conversation),
                isLoading: false
            });
            conversation.storeAbortController.abort();
        }
    };
const $38357226fb04ea94$export$9ff6f230516497d2 = (vaConversationId, history)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _history$find;
        setState({
            isLoading: true
        });
        await dispatch($38357226fb04ea94$export$92b5f8fb222eed7e(vaConversationId));
        const { conversation: conversation } = getState();
        if (!conversation) throw new Error('No conversation!');
        const originalQuery = ((_history$find = history.find((message)=>message.userType === 'helpseeker')) === null || _history$find === void 0 || (_history$find = _history$find.messageMetadata) === null || _history$find === void 0 ? void 0 : _history$find.originalQuery) || '';
        setState({
            conversationStartTime: Date.now(),
            conversation: {
                ...conversation,
                history: history
            }
        });
        dispatch($38357226fb04ea94$var$fetchConversation(originalQuery));
    };

});
parcelRegister("300Z2", function(module, exports) {
$parcel$export(module.exports, "ExperienceType", () => $9c3500d333219775$export$7814caf20640a89e);
var $9c3500d333219775$export$7814caf20640a89e = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["UNIFIED_HELP"] = "unified-help";
    return ExperienceType;
}({});

});

parcelRegister("gxLiU", function(module, exports) {
$parcel$export(module.exports, "getUHUpdatedMessage", () => $8b04f22585942fe5$export$ed355c3a875c71ab);

var $1HSMS = parcelRequire("1HSMS");

var $bOcz1 = parcelRequire("bOcz1");
const $8b04f22585942fe5$export$ed355c3a875c71ab = (streamMessage, currentMessage)=>{
    if ((0, $bOcz1.isUHTraceContentSearch)(streamMessage)) {
        var _streamMessage$messag;
        return {
            type: 'CONTENT_SEARCH',
            content: ((_streamMessage$messag = streamMessage.message) === null || _streamMessage$messag === void 0 ? void 0 : _streamMessage$messag.formulated_query) || ''
        };
    }
    if ((0, $bOcz1.isUHTraceAnalyzingState)(streamMessage)) {
        var _streamMessage$messag2;
        return {
            type: 'ANALYSING_STATE',
            content: ((_streamMessage$messag2 = streamMessage.message) === null || _streamMessage$messag2 === void 0 ? void 0 : _streamMessage$messag2.sources) || ''
        };
    }
    if ((0, $1HSMS.isStreamAnswerPart)(streamMessage)) return {
        type: 'ANSWER_PART',
        content: {
            ...currentMessage,
            content: currentMessage.content.toString() + streamMessage.message.content
        }
    };
    if ((0, $1HSMS.isStreamResponse)(streamMessage)) return {
        type: 'FINAL_RESPONSE',
        content: {
            ...streamMessage.message.message
        }
    };
    if ((0, $1HSMS.isStreamError)(streamMessage)) return {
        type: 'ERROR'
    };
    if ((0, $1HSMS.isFollowUpMessage)(streamMessage)) {
        var _streamMessage$messag3;
        return {
            type: 'FOLLOW_UP_QUERIES',
            content: ((_streamMessage$messag3 = streamMessage.message.follow_ups) === null || _streamMessage$messag3 === void 0 ? void 0 : _streamMessage$messag3.map((f)=>f.text)) ?? []
        };
    }
    return null;
};

});
parcelRegister("1HSMS", function(module, exports) {
$parcel$export(module.exports, "isHumanMessage", () => $7769ad542dab33fa$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isStreamResponse", () => $7769ad542dab33fa$export$b4631726cbc1440a);
$parcel$export(module.exports, "isAgentResponse", () => $7769ad542dab33fa$export$a6e5100ca2770191);
$parcel$export(module.exports, "isStreamError", () => $7769ad542dab33fa$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAnswerPart", () => $7769ad542dab33fa$export$e45102edbc73b240);
$parcel$export(module.exports, "isFollowUpMessage", () => $7769ad542dab33fa$export$aeae5b4fda357302);

var $i35fb = parcelRequire("i35fb");

var $04Lep = parcelRequire("04Lep");
const $7769ad542dab33fa$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $7769ad542dab33fa$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $7769ad542dab33fa$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
var $7769ad542dab33fa$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $7769ad542dab33fa$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $7769ad542dab33fa$export$77c9504201bdfdea = 'PROMPT_TILE';
const $7769ad542dab33fa$export$fb661125ffb29bd6 = (message)=>{
    return $7769ad542dab33fa$export$a69fab2afb88c2eb(message) || $7769ad542dab33fa$export$6f965deda7f0960c(message) || $7769ad542dab33fa$export$b4631726cbc1440a(message);
};
const $7769ad542dab33fa$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $7769ad542dab33fa$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $7769ad542dab33fa$export$a6e5100ca2770191 = (message)=>message instanceof Object && $7769ad542dab33fa$export$6f965deda7f0960c(message.message);
const $7769ad542dab33fa$export$5c1c15675df13ae5 = (message)=>{
    var _message$message;
    return $7769ad542dab33fa$export$b4631726cbc1440a(message) && ((_message$message = message.message) === null || _message$message === void 0 || (_message$message = _message$message.message) === null || _message$message === void 0 ? void 0 : _message$message.async_status) === 'IN_PROGRESS';
};
const $7769ad542dab33fa$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $7769ad542dab33fa$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $7769ad542dab33fa$export$1e1cf807ece63df4 = (message)=>{
    var _message$message2;
    return $7769ad542dab33fa$export$d422a2733a3b5def(message) && ((_message$message2 = message.message) === null || _message$message2 === void 0 ? void 0 : _message$message2.message_template) === $7769ad542dab33fa$export$c424fe9570a5f2d9;
};
const $7769ad542dab33fa$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $7769ad542dab33fa$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $7769ad542dab33fa$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $7769ad542dab33fa$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $7769ad542dab33fa$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $7769ad542dab33fa$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $7769ad542dab33fa$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $7769ad542dab33fa$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $7769ad542dab33fa$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $7769ad542dab33fa$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $7769ad542dab33fa$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $7769ad542dab33fa$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $7769ad542dab33fa$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $7769ad542dab33fa$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $7769ad542dab33fa$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $7769ad542dab33fa$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $7769ad542dab33fa$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $7769ad542dab33fa$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $7769ad542dab33fa$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $7769ad542dab33fa$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $7769ad542dab33fa$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $7769ad542dab33fa$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $7769ad542dab33fa$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $7769ad542dab33fa$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $7769ad542dab33fa$export$b00dd9d0560e29d2 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $7769ad542dab33fa$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $7769ad542dab33fa$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $7769ad542dab33fa$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($7769ad542dab33fa$export$7898cc38956b9052(message) || $7769ad542dab33fa$export$bb608d13a1268633(message));
const $7769ad542dab33fa$export$d95e474df0d530df = (message)=>{
    var _message$message3;
    return message instanceof Object && message.type === 'TRACE' && ((_message$message3 = message.message) === null || _message$message3 === void 0 ? void 0 : _message$message3.message_template) === 'MEMORY_UPDATE';
};
const $7769ad542dab33fa$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($7769ad542dab33fa$export$46e0fb5e4b019a49(message)) return false;
    if ($7769ad542dab33fa$export$cde91b49af35d559(message)) return false;
    if ($7769ad542dab33fa$export$6f74311d40862a9f(message)) return false;
    if ($7769ad542dab33fa$export$b65c73c7e2d8d96f(message)) return false;
    if ($7769ad542dab33fa$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $7769ad542dab33fa$export$682514f3a8131b98 = (message)=>{
    var _message$message4;
    return message instanceof Object && message.type === 'TRACE' && ((_message$message4 = message.message) === null || _message$message4 === void 0 ? void 0 : _message$message4.message_template) === 'THINK_DEEPER_TRIGGERED';
};
const $7769ad542dab33fa$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $7769ad542dab33fa$export$6275ff996073145e = (message)=>{
    var _data$message;
    if (!$7769ad542dab33fa$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray((_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.content);
};
const $7769ad542dab33fa$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $7769ad542dab33fa$export$b8391261162989d9 = (message)=>{
    var _message$message_meta, _message$message_meta2;
    return $7769ad542dab33fa$export$6f965deda7f0960c(message) && ((message === null || message === void 0 || (_message$message_meta = message.message_metadata) === null || _message$message_meta === void 0 ? void 0 : _message$message_meta.is_action_execution) ?? false) && (message === null || message === void 0 || (_message$message_meta2 = message.message_metadata) === null || _message$message_meta2 === void 0 ? void 0 : _message$message_meta2.action_execution_result) === 'SUCCESS';
};
const $7769ad542dab33fa$export$1060c4fa97e34fa7 = (payloadContext)=>{
    var _payloadContext$resol;
    return (payloadContext === null || payloadContext === void 0 || (_payloadContext$resol = payloadContext.resolution) === null || _payloadContext$resol === void 0 ? void 0 : _payloadContext$resol.type) === 'cancel';
};
const $7769ad542dab33fa$export$6ce1ccc24e75456f = (error)=>{
    var _error$errorAttribute;
    return (0, $04Lep.isApiError)(error) && ((_error$errorAttribute = error.errorAttributes) === null || _error$errorAttribute === void 0 ? void 0 : _error$errorAttribute.errorCode) === $7769ad542dab33fa$export$5945515082cc2cbf;
};
const $7769ad542dab33fa$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $7769ad542dab33fa$export$bc96a6a479480590 = (error)=>(0, $04Lep.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $7769ad542dab33fa$export$f8b1b75846492611 = (error)=>(0, $04Lep.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $i35fb.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $7769ad542dab33fa$export$d263dc5d64f36d48 = (error)=>{
    var _error$detail;
    return error instanceof Object && (error === null || error === void 0 || (_error$detail = error.detail) === null || _error$detail === void 0 ? void 0 : _error$detail.type) === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $7769ad542dab33fa$export$c424fe9570a5f2d9;
};
const $7769ad542dab33fa$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
function $7769ad542dab33fa$export$4af48296a8d61cec(payloadContext) {
    var _payloadContext$resol2;
    return (payloadContext === null || payloadContext === void 0 || (_payloadContext$resol2 = payloadContext.resolution) === null || _payloadContext$resol2 === void 0 ? void 0 : _payloadContext$resol2.type) === 'confirm';
}

});
parcelRegister("i35fb", function(module, exports) {
$parcel$export(module.exports, "ASSISTANCE_SERVICE_ERROR_CODES", () => $d43c1a62707e75eb$export$1106bf31edf2a9b8);
const $d43c1a62707e75eb$export$e8114853eca81277 = 'ai-mate';
const $d43c1a62707e75eb$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $d43c1a62707e75eb$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};

});

parcelRegister("04Lep", function(module, exports) {
$parcel$export(module.exports, "ApiError", () => $d5b1f91532ce94f1$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $d5b1f91532ce94f1$export$89d83cc97c52a37);
$parcel$export(module.exports, "mapErrorToApiError", () => $d5b1f91532ce94f1$export$3c02d1a328d4d808);
class $d5b1f91532ce94f1$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $d5b1f91532ce94f1$export$89d83cc97c52a37 = (error)=>error instanceof $d5b1f91532ce94f1$export$f2e832acab1bdd79;
const $d5b1f91532ce94f1$export$3c02d1a328d4d808 = (error)=>{
    if ($d5b1f91532ce94f1$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $d5b1f91532ce94f1$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("bOcz1", function(module, exports) {
$parcel$export(module.exports, "isUHTraceContentSearch", () => $926cee75452ede6c$export$a9fb9dc1a9b2c5ba);
$parcel$export(module.exports, "isUHTraceAnalyzingState", () => $926cee75452ede6c$export$b7ca9806367cbd80);
const $926cee75452ede6c$export$a9fb9dc1a9b2c5ba = (message)=>message.type === 'TRACE' && message.message.message_template === 'CONTENT_SEARCH';
const $926cee75452ede6c$export$b7ca9806367cbd80 = (message)=>message.type === 'TRACE' && message.message.message_template === 'ANALYSING_STATE';

});


parcelRegister("57tpL", function(module, exports) {
$parcel$export(module.exports, "getChannelId", () => $e99dd55d57030789$export$98f3eb54b6f833b6);
$parcel$export(module.exports, "sendMessageStream", () => $e99dd55d57030789$export$5dd6208dff317c60);

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $300Z2 = parcelRequire("300Z2");

var $gk18s = parcelRequire("gk18s");

var $9TbQq = parcelRequire("9TbQq");

var $kvQ5d = parcelRequire("kvQ5d");

var $bMHyg = parcelRequire("bMHyg");

var $k6Alp = parcelRequire("k6Alp");
const $e99dd55d57030789$var$commonHeaders = {
    'X-Experience-Id': 'unified-help',
    'X-Product': 'jsm'
};
const $e99dd55d57030789$var$helpcenterSlugHeader = {
    'X-Helpcenter-Slug': (0, $gk18s.getSlugForHelpCenter)() ?? ''
};
const $e99dd55d57030789$var$getChannelIdPath = ()=>{
    return (0, $jByYr.getMeta)('ajs-account-type') === 'customer' && (0, $HGACo.isUnifiedHelpAddFilterForCustomerAccounts)() ? `/gateway/api/assist/ca/chat/v1/channel` : `/gateway/api/assist/chat/v1/channel`;
};
const $e99dd55d57030789$var$getMessageStreamPath = (channelId)=>{
    return (0, $jByYr.getMeta)('ajs-account-type') === 'customer' && (0, $HGACo.isUnifiedHelpAddFilterForCustomerAccounts)() ? `/gateway/api/assist/ca/chat/v1/channel/${channelId}/message/stream` : `/gateway/api/assist/chat/v1/channel/${channelId}/message/stream`;
};
const $e99dd55d57030789$export$98f3eb54b6f833b6 = async ()=>{
    const analyticsClient = (0, $9TbQq.getAnalyticsWebClient)();
    let channelId = null;
    try {
        const channelResponse = await (0, $bMHyg.fetchJson)($e99dd55d57030789$var$getChannelIdPath(), 'POST', {
            body: JSON.stringify({}),
            headers: $e99dd55d57030789$var$commonHeaders
        });
        channelId = channelResponse.id;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsClient.sendTrackEvent({
            source: 'uhAiMateRequest',
            action: 'fetched',
            actionSubject: 'channelId',
            actionSubjectId: channelId,
            attributes: {
                ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
            }
        });
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsClient.sendTrackEvent({
            source: 'uhAiMateRequest',
            action: 'fetch_failed',
            actionSubject: 'channelId',
            attributes: {
                ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
            }
        });
        channelId = null;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'portalHomeScreen',
        action: 'initiated',
        actionSubject: 'aiInteraction',
        actionSubjectId: channelId ?? '',
        attributes: {
            aiFeatureName: 'aiAnswer',
            aiInteractionID: channelId,
            aiInteractionType: 'conversationId',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        }
    });
    return channelId;
};
const $e99dd55d57030789$export$5dd6208dff317c60 = async (content, channelId, abortController)=>{
    const body = {
        content: content,
        recipient_agent_named_id: 'unified_help_agent'
    };
    const options = {
        method: 'POST',
        headers: {
            ...$e99dd55d57030789$var$commonHeaders,
            'content-type': 'application/json;charset=UTF-8',
            ...$e99dd55d57030789$var$helpcenterSlugHeader,
            'X-Helpcenter-Ari': (0, $jByYr.getHelpCenterAri)()
        },
        body: JSON.stringify(body),
        signal: abortController.signal
    };
    return (0, $k6Alp.fetchStream)($e99dd55d57030789$var$getMessageStreamPath(channelId), options);
};

});
parcelRegister("9TbQq", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $6dcdd8eb888345af$export$e9ba7ef9458d1a4a);
//import AnalyticsClient, { envType, originType, userType, tenantType } from '@atlassiansox/analytics-web-client';
//@ts-ignore
//import Cookie from 'js-cookie';
//import { getMeta } from '@helpcenter/meta';

var $4L08H = parcelRequire("4L08H");
const $6dcdd8eb888345af$export$e9ba7ef9458d1a4a = ()=>(0, $4L08H.getAnalyticsWebClient)().getInstance();

});

parcelRegister("kvQ5d", function(module, exports) {
$parcel$export(module.exports, "getProductIdentifierAttributes", () => $211dd860c6389456$export$414440f1585883f4);

var $jByYr = parcelRequire("jByYr");
const $211dd860c6389456$export$414440f1585883f4 = (experienceId)=>({
        experienceId: experienceId,
        helpcenterId: (0, $jByYr.getHelpCenterAri)().split('/').pop()
    });

});

parcelRegister("bMHyg", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $539b3e0814790a06$export$6d71b655afe1638d);
const $539b3e0814790a06$export$6d71b655afe1638d = async (input, method, options)=>{
    const response = await fetch(input, {
        method: method,
        ...options,
        headers: {
            ...options === null || options === void 0 ? void 0 : options.headers,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw {
        error: new Error(`Request failed: ${response.status} ${response.statusText}`),
        status: response.status
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const data = await response.json();
    return data;
};

});

parcelRegister("k6Alp", function(module, exports) {
$parcel$export(module.exports, "fetchStream", () => $971f8377d2857638$export$93163a9030575d92);

var $b9JY6 = parcelRequire("b9JY6");
const $971f8377d2857638$export$93163a9030575d92 = async (path, options)=>{
    const response = await fetch(path, options);
    return (0, $b9JY6.readJsonStream)(response);
};

});
parcelRegister("b9JY6", function(module, exports) {
$parcel$export(module.exports, "readJsonStream", () => $bbc7dd53c0daec0d$export$1f24b2b263bcfa75);

var $8rWUe = parcelRequire("8rWUe");
async function* $bbc7dd53c0daec0d$export$1f24b2b263bcfa75(response) {
    const reader = (0, $8rWUe.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                yield JSON.parse(chunk);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("8rWUe", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $741900bab051d37b$export$f6383c3ea1307da9);
const $741900bab051d37b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});




parcelRegister("gjq18", function(module, exports) {
$parcel$export(module.exports, "storeFeedback", () => $98e610c62cc8baaa$export$f3438d7da4ca94e9);

var $7VEFw = parcelRequire("7VEFw");
const $98e610c62cc8baaa$var$commonHeaders = {
    'X-Experience-Id': 'unified-help',
    'X-Product': 'jsm'
};
const $98e610c62cc8baaa$export$f3438d7da4ca94e9 = async ({ channelId: channelId, messageId: messageId, feedback: feedback, feedbackLabel: feedbackLabel })=>{
    if (!messageId) return;
    await (0, $7VEFw.fetchNothing)(`/gateway/api/assist/chat/v1/channel/${channelId}/message/${messageId}/feedback`, 'PUT', {
        headers: {
            ...$98e610c62cc8baaa$var$commonHeaders,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            feedback_value: feedback,
            feedback_message: feedbackLabel
        })
    });
};

});
parcelRegister("7VEFw", function(module, exports) {
$parcel$export(module.exports, "fetchNothing", () => $d69d2dce02df6ee7$export$734eba776b437e7e);
const $d69d2dce02df6ee7$export$734eba776b437e7e = async (input, method, options)=>{
    const response = await fetch(input, {
        method: method,
        ...options,
        credentials: 'same-origin'
    });
    if (!response.ok) throw new Error(`Request failed: ${response.status} ${response.statusText}`);
};

});


parcelRegister("7wNYU", function(module, exports) {
$parcel$export(module.exports, "genIntId", () => $3cfb0c470cf29c3d$export$99db4f5154ec67b);
const $3cfb0c470cf29c3d$export$99db4f5154ec67b = ()=>Math.floor(Math.random() * 1000000);

});

parcelRegister("aiQwE", function(module, exports) {
$parcel$export(module.exports, "initialAssistantMessage", () => $fcc9b398427abe2d$export$b1cea82f2a755388);

var $86E3j = parcelRequire("86E3j");
const $fcc9b398427abe2d$export$b1cea82f2a755388 = (answerId)=>({
        aiMateConversationResponse: {
            message: {
                id: String(answerId),
                time_created: '',
                user_ari: '',
                role: 'assistant',
                content: '',
                plugin_invocations: []
            }
        },
        userType: 'assistant',
        messageMetadata: {
            status: (0, $86E3j.ASSISTANT_MESSAGE_STATUS).AWAITING_RESPONSE,
            messageId: answerId.toString()
        }
    });

});

parcelRegister("3obBJ", function(module, exports) {
$parcel$export(module.exports, "getTotalHelpDesks", () => $f9109bafb02a7198$export$826b9b61b3b7d76d);
const $f9109bafb02a7198$export$826b9b61b3b7d76d = (message)=>{
    var _message$appendices;
    return (message === null || message === void 0 || (_message$appendices = message.appendices) === null || _message$appendices === void 0 || (_message$appendices = _message$appendices.filter((appendix)=>appendix.type === 'helpDesk')) === null || _message$appendices === void 0 ? void 0 : _message$appendices.length) ?? 0;
};

});

parcelRegister("jS2et", function(module, exports) {
$parcel$export(module.exports, "getTotalRequestForms", () => $66170d7a8b865306$export$859320f8ebb3caf3);
const $66170d7a8b865306$export$859320f8ebb3caf3 = (message)=>{
    var _message$appendices;
    return (message === null || message === void 0 || (_message$appendices = message.appendices) === null || _message$appendices === void 0 || (_message$appendices = _message$appendices.filter((appendix)=>appendix.type === 'requestForm')) === null || _message$appendices === void 0 ? void 0 : _message$appendices.length) ?? 0;
};

});

parcelRegister("kVmcK", function(module, exports) {
$parcel$export(module.exports, "getTotalSources", () => $dca000f120ad1881$export$75f436fca26bdba1);
const $dca000f120ad1881$export$75f436fca26bdba1 = (message)=>{
    var _message$sources;
    return (message === null || message === void 0 || (_message$sources = message.sources) === null || _message$sources === void 0 ? void 0 : _message$sources.length) ?? 0;
};

});

parcelRegister("fbLft", function(module, exports) {
$parcel$export(module.exports, "updateKeywords", () => $2bee438d71879b83$export$9c6f66d1d405561d);
$parcel$export(module.exports, "updateSources", () => $2bee438d71879b83$export$6c4da287bd77d75c);
$parcel$export(module.exports, "updateMessage", () => $2bee438d71879b83$export$829153c748a07de7);
$parcel$export(module.exports, "updateFinalMessage", () => $2bee438d71879b83$export$95204cf9f69c856a);
$parcel$export(module.exports, "addAssistantMessage", () => $2bee438d71879b83$export$ce06e1b90807a0c0);
$parcel$export(module.exports, "replaceLastAssistantMessage", () => $2bee438d71879b83$export$a1def0348b9f1873);
$parcel$export(module.exports, "updateFollowUpMessage", () => $2bee438d71879b83$export$9143429366a9249);
$parcel$export(module.exports, "updateAssistantMessageStatusToTypingResponse", () => $2bee438d71879b83$export$e1c963c90a5d08ee);
$parcel$export(module.exports, "updateAssistantMessageStatusToLoadingResponse", () => $2bee438d71879b83$export$c2814dbaf6592faa);
$parcel$export(module.exports, "updateAbortedAssistantMessage", () => $2bee438d71879b83$export$5d7bc912c91053cd);

var $86E3j = parcelRequire("86E3j");

var $bnIuT = parcelRequire("bnIuT");
const $2bee438d71879b83$export$9c6f66d1d405561d = (assistantMessage, keywords = '')=>({
        ...assistantMessage,
        messageMetadata: {
            loadingState: {
                ...assistantMessage.messageMetadata.loadingState,
                keywords: keywords.split('|')
            }
        }
    });
const $2bee438d71879b83$export$6c4da287bd77d75c = (assistantMessage, sources)=>({
        ...assistantMessage,
        messageMetadata: {
            loadingState: {
                ...assistantMessage.messageMetadata.loadingState,
                sources: sources
            }
        }
    });
const $2bee438d71879b83$export$829153c748a07de7 = (assistantMessage, message)=>({
        ...assistantMessage,
        aiMateConversationResponse: {
            message: message
        }
    });
const $2bee438d71879b83$export$95204cf9f69c856a = (assistantMessage, message, isFallbackMessage)=>({
        ...assistantMessage,
        aiMateConversationResponse: {
            message: message
        },
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            isFallbackMessage: isFallbackMessage,
            messageId: message.id.toString(),
            status: (0, $86E3j.ASSISTANT_MESSAGE_STATUS).IDLE,
            showFeedback: !isFallbackMessage
        }
    });
const $2bee438d71879b83$export$ce06e1b90807a0c0 = (assistantMessage, conversation)=>({
        ...conversation,
        history: [
            ...conversation.history,
            assistantMessage
        ]
    });
const $2bee438d71879b83$export$a1def0348b9f1873 = (message, conversation)=>{
    const updatedConversationHistory = conversation.history[conversation.history.length - 1].userType === (0, $bnIuT.ASSISTANT_USER_TYPE) ? conversation.history.slice(0, -1) : conversation.history;
    return {
        ...conversation,
        history: [
            ...updatedConversationHistory,
            message
        ]
    };
};
const $2bee438d71879b83$export$9143429366a9249 = (conversation, queries)=>({
        ...conversation,
        history: [
            ...conversation.history,
            {
                queries: queries,
                userType: 'followUp'
            }
        ]
    });
const $2bee438d71879b83$export$e1c963c90a5d08ee = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $86E3j.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE
        }
    });
const $2bee438d71879b83$export$c2814dbaf6592faa = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $86E3j.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE
        }
    });
const $2bee438d71879b83$export$5d7bc912c91053cd = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $86E3j.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
        }
    });

});
parcelRegister("bnIuT", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $54f073345fc84b6e$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "ASSISTANT_USER_TYPE", () => $54f073345fc84b6e$export$93622d3dc67e9e9b);
$parcel$export(module.exports, "HELP_SEEKER_USER_TYPE", () => $54f073345fc84b6e$export$fa4d1d4ff5355f70);
const $54f073345fc84b6e$export$d4c72bab9d6cc13a = {
    isLoading: false,
    conversation: null,
    searchAll: false,
    pipeline: '',
    isTesting: false,
    feedbackCollectorConfig: {
        isVisible: false,
        messageId: undefined
    },
    activeTimer: null,
    ui: {
        conversationScrollBarWidth: '0px'
    }
};
const $54f073345fc84b6e$export$93622d3dc67e9e9b = 'assistant';
const $54f073345fc84b6e$export$fa4d1d4ff5355f70 = 'helpseeker';

});


parcelRegister("2qLA3", function(module, exports) {
$parcel$export(module.exports, "createStoreAbortController", () => $5b59bac238b7b749$export$cb6128fc3a3c8081);
const $5b59bac238b7b749$export$cb6128fc3a3c8081 = ()=>{
    const abortController = new AbortController();
    const abort = ()=>{
        abortController.abort();
    };
    const signal = abortController.signal;
    return {
        storeAbortController: {
            abort: abort,
            signal: signal
        }
    };
};

});

parcelRegister("deo79", function(module, exports) {
$parcel$export(module.exports, "sendUIEventForAskedQuestion", () => $b9f7e3623fd703bb$export$2bf225029007d9aa);
$parcel$export(module.exports, "sendUIEventForClearConversation", () => $b9f7e3623fd703bb$export$e33202cdfb6e8294);
$parcel$export(module.exports, "sendTrackEventForAnswerStreamingStarted", () => $b9f7e3623fd703bb$export$1ad079e189e166f0);
$parcel$export(module.exports, "sendTrackEventForFetchedResponse", () => $b9f7e3623fd703bb$export$b13699b81838287b);
$parcel$export(module.exports, "sendTrackEventForFailure", () => $b9f7e3623fd703bb$export$d40db612c63a38bf);
$parcel$export(module.exports, "sendUIEventForFollowUpSelection", () => $b9f7e3623fd703bb$export$6d1d2cd3a3ab5d10);

var $300Z2 = parcelRequire("300Z2");

var $kvQ5d = parcelRequire("kvQ5d");
const $b9f7e3623fd703bb$export$2bf225029007d9aa = (analyticsClient, conversationId, totalMessageCount, messageLength, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'uhConversationScreen',
        action: 'asked',
        actionSubject: 'question',
        attributes: {
            conversationId: conversationId,
            messageLength: messageLength,
            totalMessageCount: totalMessageCount,
            externalConversationId: externalConversationId,
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $b9f7e3623fd703bb$export$e33202cdfb6e8294 = (analyticsClient, conversationId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'conversationScreen',
        action: 'clear',
        actionSubject: 'conversation',
        attributes: {
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $b9f7e3623fd703bb$export$1ad079e189e166f0 = (analyticsClient, conversationId, messageLatency, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: 'started',
        actionSubject: 'streaming',
        attributes: {
            messageLatency: messageLatency,
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $b9f7e3623fd703bb$export$b13699b81838287b = (analyticsClient, messageLatency, confidenceScore, isFallbackMessage, isConfluenceLicensedUser, isVagueQuery, searchResultCount, totalSearchResultCount, conversationId, totalSources, totalHelpDesk, totalRequestForm, messageId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: 'fetched',
        actionSubject: 'conversation',
        actionSubjectId: conversationId,
        attributes: {
            externalConversationId: externalConversationId,
            messageLatency: messageLatency,
            confidenceScore: confidenceScore,
            isFallbackMessage: isFallbackMessage,
            isConfluenceLicensedUser: isConfluenceLicensedUser,
            isVagueQuery: isVagueQuery,
            searchResultCount: searchResultCount,
            totalSearchResultCount: totalSearchResultCount,
            totalSources: totalSources,
            totalHelpDesk: totalHelpDesk,
            totalRequestForm: totalRequestForm,
            messageId: messageId,
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $b9f7e3623fd703bb$export$d40db612c63a38bf = (analyticsClient, channelId, isRateLimitingError, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: isRateLimitingError ? 'rateLimited' : 'fetch_failed',
        actionSubject: 'conversation',
        actionSubjectId: channelId,
        attributes: {
            externalConversationId: externalConversationId,
            isAiMate: true,
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $b9f7e3623fd703bb$export$6d1d2cd3a3ab5d10 = (analyticsClient, conversationId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'conversationScreen',
        action: 'selected',
        actionSubject: 'followUpQuery',
        attributes: {
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }
    });
};

});




parcelRegister("4H1b1", function(module, exports) {
$parcel$export(module.exports, "useIsGenerating", () => $ed94eb34a112375d$export$d04302655294f9a5);

var $056SR = parcelRequire("056SR");

var $86E3j = parcelRequire("86E3j");

var $8E60W = parcelRequire("8E60W");
const $ed94eb34a112375d$export$d04302655294f9a5 = ()=>{
    const provider = (0, $056SR.useProvider)();
    const [isLastAssistantMessageGenerated] = (0, $8E60W.useIsLastAssistantMessageGenerated)();
    if (!provider || provider === (0, $86E3j.ConversationProvider).VIRTUAL_AGENT) return false;
    return !isLastAssistantMessageGenerated;
};

});

parcelRegister("hs071", function(module, exports) {
$parcel$export(module.exports, "useIsInputEnabled", () => $53e07f06774645bb$export$335460cd33393c4b);

var $056SR = parcelRequire("056SR");

var $86E3j = parcelRequire("86E3j");

var $8E60W = parcelRequire("8E60W");
const $53e07f06774645bb$export$335460cd33393c4b = ()=>{
    const provider = (0, $056SR.useProvider)();
    const isRouting = (0, $056SR.useIsRouting)();
    const [isLastMessageFromHelpSeeker] = (0, $8E60W.useIsLastMessageFromHelpSeeker)();
    const [isLastAssistantMessageGenerated] = (0, $8E60W.useIsLastAssistantMessageGenerated)();
    if (isRouting) return false;
    if (!provider || provider === (0, $86E3j.ConversationProvider).VIRTUAL_AGENT) return true;
    return isLastAssistantMessageGenerated && !isLastMessageFromHelpSeeker;
};

});

parcelRegister("8ENrl", function(module, exports) {
$parcel$export(module.exports, "useHasMessages", () => $5c84dc398582e141$export$cd077d7865053739);

var $fOX04 = parcelRequire("fOX04");

var $056SR = parcelRequire("056SR");

var $86E3j = parcelRequire("86E3j");

var $8E60W = parcelRequire("8E60W");
const $5c84dc398582e141$export$cd077d7865053739 = ()=>{
    const provider = (0, $056SR.useProvider)();
    const [AIAnswersConversation] = (0, $8E60W.useConversation)();
    const VAMessages = (0, $fOX04.useMessages)();
    if (provider === (0, $86E3j.ConversationProvider).VIRTUAL_AGENT) return VAMessages.length > 0;
    return !!AIAnswersConversation;
};

});

parcelRegister("9oYzA", function(module, exports) {
$parcel$export(module.exports, "useStopGenerating", () => $672d8ba85c1553c2$export$177960b8f80ddb1c);

var $056SR = parcelRequire("056SR");

var $8E60W = parcelRequire("8E60W");
const $672d8ba85c1553c2$export$177960b8f80ddb1c = ()=>{
    const provider = (0, $056SR.useProvider)();
    const { abortConversation: abortConversation } = (0, $8E60W.useActions)();
    const stopGenerating = ()=>{
        if (provider === 'AI_ANSWERS') abortConversation();
    };
    return {
        stopGenerating: stopGenerating
    };
};

});

parcelRegister("7K6Fh", function(module, exports) {
$parcel$export(module.exports, "useGetMaxChars", () => $be37e2e530416f9a$export$6fdff492f3dfb4bb);

var $e9OCy = parcelRequire("e9OCy");

var $056SR = parcelRequire("056SR");

var $86E3j = parcelRequire("86E3j");

var $ik8tM = parcelRequire("ik8tM");
const $be37e2e530416f9a$export$6fdff492f3dfb4bb = ()=>{
    const provider = (0, $056SR.useProvider)();
    const { getJiraFieldMaxChars: getJiraFieldMaxChars } = (0, $e9OCy.useGetJiraFieldMaxChars)();
    const getMaxChars = ()=>{
        if (provider === (0, $86E3j.ConversationProvider).VIRTUAL_AGENT) {
            const maxJiraFieldChars = getJiraFieldMaxChars();
            if (maxJiraFieldChars) return maxJiraFieldChars;
        }
        return 0, $ik8tM.MAX_CHARS;
    };
    return {
        getMaxChars: getMaxChars
    };
};

});
parcelRegister("e9OCy", function(module, exports) {
$parcel$export(module.exports, "useGetJiraFieldMaxChars", () => $24f2777bd5835d3f$export$1c551de6ec5f7e66);

var $24YjJ = parcelRequire("24YjJ");

var $koYWm = parcelRequire("koYWm");

var $gRDet = parcelRequire("gRDet");

var $fOX04 = parcelRequire("fOX04");
const $24f2777bd5835d3f$export$1c551de6ec5f7e66 = ()=>{
    const jiraField = (0, $fOX04.useFieldFromLastMessage)();
    const baseUrl = (0, $fOX04.useBaseUrl)();
    const [{ data: requestTypeFields }] = (0, $koYWm.useRequestTypeFields)({
        baseUrl: baseUrl
    });
    const fieldType = jiraField && (0, $gRDet.getFieldType)(jiraField.fieldId, requestTypeFields);
    const getJiraFieldMaxChars = ()=>{
        if (fieldType === (0, $gRDet.SHORT_TEXT_FIELD_TYPE)) return 0, $24YjJ.MAX_SHORT_TEXT_FIELD_CHARS;
        if (fieldType === (0, $gRDet.PARAGRAPH_FIELD_TYPE)) return 0, $24YjJ.MAX_PARAGRAPH_FIELD_CHARS;
        return undefined;
    };
    return {
        getJiraFieldMaxChars: getJiraFieldMaxChars
    };
};

});
parcelRegister("24YjJ", function(module, exports) {
$parcel$export(module.exports, "MAX_SHORT_TEXT_FIELD_CHARS", () => $9245803a8ab38e20$export$91e0b38c91e2cd5c);
$parcel$export(module.exports, "MAX_PARAGRAPH_FIELD_CHARS", () => $9245803a8ab38e20$export$44efb9aa2d3aca69);
$parcel$export(module.exports, "CONVERSATION_TIME_OUT", () => $9245803a8ab38e20$export$2efd43ac8eb281e1);
const $9245803a8ab38e20$export$91e0b38c91e2cd5c = 250;
const $9245803a8ab38e20$export$44efb9aa2d3aca69 = 1000;
const $9245803a8ab38e20$export$2efd43ac8eb281e1 = 120000; // 2 minutes

});


parcelRegister("ik8tM", function(module, exports) {
$parcel$export(module.exports, "PIPELINE_LOCAL_STORAGE_KEY", () => $0087feb7a7aa8278$export$1d9b669fd4b51619);
$parcel$export(module.exports, "DEFAULT_PIPELINE", () => $0087feb7a7aa8278$export$dfea82974f95546a);
$parcel$export(module.exports, "LINK_CLICKED_EVENT", () => $0087feb7a7aa8278$export$c3919a87590ab58a);
$parcel$export(module.exports, "MAX_CHARS", () => $0087feb7a7aa8278$export$3fd15502aa7f615e);
const $0087feb7a7aa8278$export$1d9b669fd4b51619 = 'pipeline';
const $0087feb7a7aa8278$export$dfea82974f95546a = 'DEFAULT_PIPELINE';
const $0087feb7a7aa8278$export$478ff1f86cdd0b2 = 480;
const $0087feb7a7aa8278$export$90f94aac6f3ac32d = 744;
const $0087feb7a7aa8278$export$460a6c74e2815558 = 1440;
const $0087feb7a7aa8278$export$d7ccb212e23ab442 = 1025;
const $0087feb7a7aa8278$export$ba668ebd2a2d0856 = 1200;
const $0087feb7a7aa8278$export$c3919a87590ab58a = 'link clicked';
const $0087feb7a7aa8278$export$3fd15502aa7f615e = 1000;

});


parcelRegister("3fBnU", function(module, exports) {
$parcel$export(module.exports, "useIsInputShown", () => $cb07f766b8e9dd55$export$ae7b9f18d03cb232);

var $056SR = parcelRequire("056SR");

var $8E60W = parcelRequire("8E60W");
const $cb07f766b8e9dd55$export$ae7b9f18d03cb232 = ()=>{
    const provider = (0, $056SR.useProvider)();
    const [isChannelErrorPresent] = (0, $8E60W.useIsChannelErrorPresent)();
    if (provider === 'AI_ANSWERS') return !isChannelErrorPresent;
    return true;
};

});

parcelRegister("futSv", function(module, exports) {
$parcel$export(module.exports, "useClearConversation", () => $cd53c9eac42ced1f$export$6dc4e5ebda459b3);

var $fOX04 = parcelRequire("fOX04");

var $056SR = parcelRequire("056SR");

var $86E3j = parcelRequire("86E3j");

var $8E60W = parcelRequire("8E60W");
const $cd53c9eac42ced1f$export$6dc4e5ebda459b3 = ()=>{
    const { clearConversation: clearAIAnswerConversation } = (0, $8E60W.useActions)();
    const { clearConversation: clearVirtualAgentConversation } = (0, $fOX04.useActions)();
    const { setProvider: setProvider } = (0, $056SR.useActions)();
    const clearConversation = ()=>{
        clearAIAnswerConversation();
        clearVirtualAgentConversation();
        setProvider((0, $86E3j.ConversationProvider).VIRTUAL_AGENT);
    };
    return {
        clearConversation: clearConversation
    };
};

});

parcelRegister("6JoTi", function(module, exports) {
$parcel$export(module.exports, "useHandOffConversation", () => $f68a977a7e46d55e$export$ad87f5d1da6cbafb);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $1CVmW = parcelRequire("1CVmW");

var $4L08H = parcelRequire("4L08H");

var $056SR = parcelRequire("056SR");

var $86E3j = parcelRequire("86E3j");

var $8E60W = parcelRequire("8E60W");
const $f68a977a7e46d55e$export$ad87f5d1da6cbafb = ()=>{
    const { setProvider: setProvider } = (0, $056SR.useActions)();
    const { takeOverConversationFromVA: takeOverConversationFromVA } = (0, $8E60W.useActions)();
    const analyticsClient = (0, $4L08H.getAnalyticsWebClient)().getInstance();
    const sendHandOffAnalyticsEvent = (0, $8P7DW.useCallback)((conversationId, contextId)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/70690
        analyticsClient.sendTrackEvent({
            action: 'rejected',
            actionSubject: 'inferIntent',
            actionSubjectId: 'globalInferIntentFast',
            attributes: {
                conversationId: conversationId,
                contextId: contextId
            },
            source: (0, $8rTkC.ScreenName).CONVERSATION_PAGE
        }).catch((error)=>{
            throw new Error(`Failure to send track analytics event ${error}`);
        });
    }, [
        analyticsClient
    ]);
    const handleHandOff = (0, $8P7DW.useCallback)(async (vaMessages, conversationId, contextId)=>{
        sendHandOffAnalyticsEvent(conversationId, contextId);
        if (!vaMessages.length || vaMessages[0].message.authorType !== 'HELPSEEKER') throw Error('Cannot hand off conversation without a helpseeker message');
        const history = vaMessages.map($f68a977a7e46d55e$var$transformVAMessageToAIAnswersMessage).filter((message)=>message !== null);
        await takeOverConversationFromVA(conversationId, history);
        setProvider((0, $86E3j.ConversationProvider).AI_ANSWERS);
    }, [
        sendHandOffAnalyticsEvent,
        setProvider,
        takeOverConversationFromVA
    ]);
    return {
        handleHandOff: handleHandOff
    };
};
const $f68a977a7e46d55e$var$extractMessageContent = (message)=>{
    let originalContent = '';
    (0, $1CVmW.traverse)(message.content, {
        text: (node)=>{
            originalContent += node.text;
        }
    });
    return originalContent;
};
const $f68a977a7e46d55e$var$transformVAMessageToAIAnswersMessage = (message, index)=>{
    switch(message.message.authorType){
        case 'HELPSEEKER':
            return {
                userType: 'helpseeker',
                messageContentAdf: message.message.content,
                messageMetadata: {
                    ...index === 0 ? {
                        originalQuery: $f68a977a7e46d55e$var$extractMessageContent(message.message)
                    } : {}
                }
            };
        case 'AGENT':
            return {
                userType: 'assistant',
                aiMateConversationResponse: {
                    message: {
                        content: $f68a977a7e46d55e$var$parseMessageContent(message.message),
                        role: 'assistant',
                        id: String(index),
                        //
                        time_created: message.timeCreated,
                        user_ari: '',
                        plugin_invocations: []
                    }
                },
                messageMetadata: {
                    status: (0, $86E3j.ASSISTANT_MESSAGE_STATUS).SYNCED_RESPONSE
                }
            };
        default:
            return null;
    }
};
const $f68a977a7e46d55e$var$parseMessageContent = (message)=>{
    if (message.contentMimetype === 'application/json+adf') return JSON.parse(message.content);
    return message.content;
};

});


parcelRegister("6gxqq", function(module, exports) {
$parcel$export(module.exports, "ElementKeyMap", () => (parcelRequire("eIvjU")).ElementKeyMap);
$parcel$export(module.exports, "isMacOs", () => (parcelRequire("eIvjU")).isMacOs);
parcelRequire("eIvjU");

});
parcelRegister("eIvjU", function(module, exports) {
$parcel$export(module.exports, "ElementKeyMap", () => $c1b0cfaf66ece036$export$6fa2af2018b3f7a3);
$parcel$export(module.exports, "isMacOs", () => $c1b0cfaf66ece036$export$c5e71f489eb3970b);
// oxlint-disable-next-line no-shadow
var $c1b0cfaf66ece036$export$6fa2af2018b3f7a3 = /*#__PURE__*/ function(ElementKeyMap) {
    ElementKeyMap["IMAGE"] = "HelpLayoutImageAtomicElement";
    ElementKeyMap["HEADING"] = "HelpLayoutHeadingAtomicElement";
    ElementKeyMap["PARAGRAPH"] = "HelpLayoutParagraphAtomicElement";
    ElementKeyMap["EDITOR"] = "HelpLayoutEditorElement";
    ElementKeyMap["SEARCH"] = "HelpLayoutSearchAtomicElement";
    ElementKeyMap["LINK_CARD"] = "HelpLayoutLinkCardCompositeElement";
    return ElementKeyMap;
}({});
const $c1b0cfaf66ece036$export$c5e71f489eb3970b = ()=>navigator.userAgent.includes('Mac');

});


parcelRegister("iD9mC", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", () => $bc3f7d73b0985a62$export$b2ad68b9bc407b80);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $ftDnF = parcelRequire("ftDnF");
const $bc3f7d73b0985a62$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo((props)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ftDnF.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $bc3f7d73b0985a62$export$2e2bcd8739ae039 = $bc3f7d73b0985a62$export$b2ad68b9bc407b80;

});
parcelRegister("ftDnF", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $3d340fb293413798$export$ff983d2a2b6112ea);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $4lbHQ = parcelRequire("4lbHQ");
const $3d340fb293413798$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $4lbHQ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("4lbHQ", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $0620ef94f3e66262$export$2f62ee6831462844);

var $8P7DW = parcelRequire("8P7DW");
function $0620ef94f3e66262$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("cxNwq", function(module, exports) {
$parcel$export(module.exports, "withHelpCenterConversationStateContainer", () => $4e431c3398dce92c$export$8bee59b293b5a56c);

var $8P7DW = parcelRequire("8P7DW");

var $jByYr = parcelRequire("jByYr");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
var $hDCsk = parcelRequire("hDCsk");
var $i9cdb = parcelRequire("i9cdb");

var $6lTuV = parcelRequire("6lTuV");

var $056SR = parcelRequire("056SR");

var $hUzQU = parcelRequire("hUzQU");
parcelRequire("9E7e6");
var $futSv = parcelRequire("futSv");
var $6JoTi = parcelRequire("6JoTi");

var $d4GeM = parcelRequire("d4GeM");

var $hM6Fr = parcelRequire("hM6Fr");

var $lYBfq = parcelRequire("lYBfq");

var $fOX04 = parcelRequire("fOX04");
const $4e431c3398dce92c$export$8bee59b293b5a56c = (WrappedComponent)=>{
    const WithConversationStateContainer = (props)=>{
        const { contextId: contextId } = props;
        const [isTestConversationParam] = (0, $hDCsk.useQueryParam)('isTestConversation');
        const [portalId] = (0, $iyRi5.usePathParam)('portalId');
        const isTestConversation = isTestConversationParam === 'true';
        const { handleHandOff: handleHandOff } = (0, $6JoTi.useHandOffConversation)();
        const conversationProvider = (0, $d4GeM.useVirtualAgentConversationV2Provider)({
            isTestConversation: isTestConversation,
            contextId: contextId,
            cloudId: (0, $jByYr.getCloudId)(),
            channelType: portalId ? (0, $hM6Fr.ChannelType).Portal : (0, $hM6Fr.ChannelType).HelpCenter
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lYBfq.ConversationStateContainer), {
            conversationProvider: conversationProvider,
            contextId: contextId,
            handleHandOff: handleHandOff,
            isTestConversation: isTestConversation,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($4e431c3398dce92c$var$GlobalConversationStateManager, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, props));
    };
    return (0, $hUzQU.withRoutingStateContainer)(WithConversationStateContainer);
};
/*
 * With react-sweet-state, we can not persistence the state of the store when there is no consumer, in this case, we have to
 * use a global state to preserve the state of the store when the consumer is unmounted, and use this component to reset
 * the state of the store when the user navigates away from the conversation page.
 */ const $4e431c3398dce92c$var$GlobalConversationStateManager = ()=>{
    const [routerState] = (0, $i9cdb.useRouter)();
    const { resetState: resetState } = (0, $056SR.useActions)();
    const { clearConversation: clearConversation } = (0, $futSv.useClearConversation)();
    const { resetState: resetVAState } = (0, $fOX04.useActions)();
    (0, $6lTuV.useIsoMorphicLayoutEffect)(()=>{
        if (routerState.location.pathname !== '/conversation') {
            clearConversation();
            resetState();
            resetVAState();
        }
    }, [
        routerState.location.pathname,
        resetState,
        resetVAState,
        clearConversation
    ]);
    return null;
};

});
parcelRegister("hUzQU", function(module, exports) {
$parcel$export(module.exports, "withRoutingStateContainer", () => $95886a220af9ddbd$export$fcbcda437b73d924);

var $8P7DW = parcelRequire("8P7DW");

var $jm9Ta = parcelRequire("jm9Ta");
const $95886a220af9ddbd$export$fcbcda437b73d924 = (WrappedComponent)=>{
    const WithRoutingStateContainer = (props)=>{
        const { contextId: contextId } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jm9Ta.RoutingStateContainer), {
            contextId: contextId,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, props));
    };
    return WithRoutingStateContainer;
};

});

parcelRegister("d4GeM", function(module, exports) {
$parcel$export(module.exports, "useVirtualAgentConversationV2Provider", () => $1f1b92ed44953c3f$export$2e4d3c305d19e2ad);

var $8P7DW = parcelRequire("8P7DW");

var $klz3F = parcelRequire("klz3F");

var $hM6Fr = parcelRequire("hM6Fr");
const $1f1b92ed44953c3f$export$2e4d3c305d19e2ad = ({ contextId: contextId, cloudId: cloudId, isTestConversation: isTestConversation, channelType: channelType, baseUrl: baseUrl = '' })=>{
    const startConversation = (0, $8P7DW.useCallback)(async (abortSignal, message)=>{
        try {
            const requestMessage = message ? {
                message: {
                    content: JSON.stringify(message.content)
                }
            } : null;
            const response = await (0, $klz3F.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v2/web/conversation`, {
                signal: abortSignal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    channelType: channelType,
                    contextId: contextId,
                    createdAt: new Date().toISOString(),
                    isTestConversation: isTestConversation === true,
                    ...requestMessage
                }),
                method: 'POST'
            });
            return response;
        } catch (error) {
            if (error instanceof DOMException) // TODO: add analytics for this
            return undefined;
            throw error;
        }
    }, [
        baseUrl,
        cloudId,
        isTestConversation,
        channelType,
        contextId
    ]);
    const sendMessage = (0, $8P7DW.useCallback)(async (message, abortSignal)=>{
        try {
            const response = await (0, $klz3F.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v2/web/conversation/message`, {
                signal: abortSignal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    externalSource: channelType === (0, $hM6Fr.ChannelType).HelpCenter ? (0, $hM6Fr.ExternalSource).Orchestrator : (0, $hM6Fr.ExternalSource).Portal,
                    message: {
                        content: JSON.stringify(message.message.content),
                        optionId: message.message.optionId,
                        jiraField: message.message.jiraField
                    },
                    timeCreated: message.timeCreated,
                    conversationChannelId: message.conversationChannelId
                }),
                method: 'POST'
            });
            return response;
        } catch (error) {
            if (error instanceof DOMException) // TODO: add analytics for this
            return [];
            throw error;
        }
    }, [
        baseUrl,
        channelType,
        cloudId
    ]);
    return (0, $8P7DW.useMemo)(()=>({
            startConversation: startConversation,
            sendMessage: sendMessage
        }), [
        sendMessage,
        startConversation
    ]);
};

});
parcelRegister("hM6Fr", function(module, exports) {
$parcel$export(module.exports, "ChannelType", () => $5d64a0f2beeaba43$export$36655de2868043ae);
$parcel$export(module.exports, "ExternalSource", () => $5d64a0f2beeaba43$export$ffc19e40a21f08eb);
const $5d64a0f2beeaba43$export$36655de2868043ae = {
    Portal: 'JSM_PORTAL',
    HelpCenter: 'JSM_HELP_CENTER',
    Widget: 'JSM_WIDGET'
};
const $5d64a0f2beeaba43$export$ffc19e40a21f08eb = {
    Portal: 'JSM_PORTAL',
    Orchestrator: 'JSM_ORCHESTRATOR'
};

});



parcelRegister("5Tbbx", function(module, exports) {
$parcel$export(module.exports, "initialIntentMessageHCExperience", () => $e343ce8c42807f0d$export$f0696c364409ed69);
$parcel$export(module.exports, "initialAIMessageHCExperience", () => $e343ce8c42807f0d$export$25016be9b5cc2f74);
$parcel$export(module.exports, "omnichannelGreetingMessageExperience", () => $e343ce8c42807f0d$export$c63387a0d6893aba);

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $e343ce8c42807f0d$export$f0696c364409ed69 = new (0, $ghwxF.UFOExperience)('service-management.help-center.omnichannel-v2.initial-message', {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $e343ce8c42807f0d$export$25016be9b5cc2f74 = new (0, $ghwxF.UFOExperience)('service-management.help-center.omnichannel-v2.initial-message.ai', {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $e343ce8c42807f0d$export$c63387a0d6893aba = new (0, $ghwxF.UFOExperience)('service-management.help-center.omnichannel.greeting-message', {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("fMfsf", function(module, exports) {
$parcel$export(module.exports, "useCreateConversationWithMessage", () => $46d910da15e7a780$export$d1fc804b2f86fc4);

var $8pVQu = parcelRequire("8pVQu");

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $h3cOB = parcelRequire("h3cOB");

var $8iTFq = parcelRequire("8iTFq");

var $k7W4q = parcelRequire("k7W4q");
var $a260T = parcelRequire("a260T");

var $5Tbbx = parcelRequire("5Tbbx");

var $1IQPi = parcelRequire("1IQPi");

var $aGBfH = parcelRequire("aGBfH");

var $hpFT3 = parcelRequire("hpFT3");

var $zH1y1 = parcelRequire("zH1y1");
const $46d910da15e7a780$export$d1fc804b2f86fc4 = ()=>{
    const [commitMutation, isLoading] = (0, $h3cOB.useMutation)((0, $8pVQu.default));
    const environment = (0, $h3cOB.useRelayEnvironment)();
    const handleMutationError = (0, $8P7DW.useCallback)(({ message: message, nodeId: nodeId, connectionId: connectionId, subscriptionId: subscriptionId })=>{
        (0, $aGBfH.updateOmniChannelConversationMeta)({
            environment: environment,
            isReplyPending: false
        });
        if (!(0, $HGACo.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $hpFT3.deleteNodeFromConnection)({
            environment: environment,
            connectionId: connectionId,
            nodeId: nodeId
        });
        const metadata = {
            connectionId: connectionId,
            subscriptionId: subscriptionId
        };
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $zH1y1.createConversationWithMessageExperience).failure({
            metadata: metadata
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $5Tbbx.initialIntentMessageHCExperience).abort({
            metadata: metadata
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $5Tbbx.initialAIMessageHCExperience).abort({
            metadata: metadata
        });
        (0, $1IQPi.addMessageToConnection)({
            message: message,
            environment: environment,
            connectionId: connectionId,
            authorType: 'CombinedAPIError'
        });
    }, [
        environment
    ]);
    const createConversationWithMessage = (0, $8P7DW.useCallback)(({ workspaceAri: workspaceAri, conversationContextAri: conversationContextAri, connectionId: connectionId, onError: onError, message: message, subscriptionId: subscriptionId, isTestConversation: isTestConversation = false })=>{
        const nodeId = (0, $8iTFq.generateUniqueClientID)();
        const content = JSON.stringify((0, $k7W4q.doc)((0, $a260T.paragraph)(message)));
        (0, $hpFT3.addOptimisticResponseToConnection)({
            environment: environment,
            nodeId: nodeId,
            content: content,
            connectionId: connectionId,
            message: message
        });
        (0, $aGBfH.updateOmniChannelConversationMeta)({
            environment: environment,
            isReplyPending: true
        });
        (0, $hpFT3.updateMessageStatusToHelpseeker)({
            environment: environment
        });
        (0, $hpFT3.resetTimer)({
            environment: environment
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $zH1y1.createConversationWithMessageExperience).start();
        if ((0, $HGACo.isOmnichannelGreetingAPIEnabled)()) (0, $hpFT3.addGreetingMessageToConnection)({
            environment: environment,
            connectionId: connectionId,
            nodeId: (0, $8iTFq.generateUniqueClientID)()
        });
        return commitMutation({
            onCompleted: (response)=>{
                var _response$jsmChat, _response$jsmChat2, _response$jsmChat3, _responseData$convers, _responseData$convers3;
                if (!(response !== null && response !== void 0 && (_response$jsmChat = response.jsmChat) !== null && _response$jsmChat !== void 0 && (_response$jsmChat = _response$jsmChat.initializeAndSendMessage) !== null && _response$jsmChat !== void 0 && _response$jsmChat.success) || !(response !== null && response !== void 0 && (_response$jsmChat2 = response.jsmChat) !== null && _response$jsmChat2 !== void 0 && (_response$jsmChat2 = _response$jsmChat2.initializeAndSendMessage) !== null && _response$jsmChat2 !== void 0 && (_response$jsmChat2 = _response$jsmChat2.initializeAndSendMessageResponse) !== null && _response$jsmChat2 !== void 0 && _response$jsmChat2.conversationId)) {
                    handleMutationError({
                        nodeId: nodeId,
                        message: message,
                        connectionId: connectionId,
                        subscriptionId: subscriptionId
                    });
                    return;
                }
                const responseData = (_response$jsmChat3 = response.jsmChat) === null || _response$jsmChat3 === void 0 || (_response$jsmChat3 = _response$jsmChat3.initializeAndSendMessage) === null || _response$jsmChat3 === void 0 ? void 0 : _response$jsmChat3.initializeAndSendMessageResponse;
                (0, $aGBfH.updateOmniChannelConversationMeta)({
                    environment: environment,
                    workspaceAri: workspaceAri,
                    conversationContextAri: conversationContextAri,
                    conversationId: responseData === null || responseData === void 0 ? void 0 : responseData.conversationId
                });
                (0, $hpFT3.clearTimer)(environment);
                if (responseData.conversationId && (_responseData$convers = responseData.conversation) !== null && _responseData$convers !== void 0 && (_responseData$convers = _responseData$convers.node) !== null && _responseData$convers !== void 0 && _responseData$convers.id) {
                    var _responseData$convers2;
                    (0, $hpFT3.updateRelayRecordId)({
                        environment: environment,
                        nodeId: nodeId,
                        newId: (_responseData$convers2 = responseData.conversation) === null || _responseData$convers2 === void 0 || (_responseData$convers2 = _responseData$convers2.node) === null || _responseData$convers2 === void 0 ? void 0 : _responseData$convers2.id
                    });
                }
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $zH1y1.createConversationWithMessageExperience).success({
                    metadata: {
                        subscriptionId: subscriptionId,
                        conversationId: (_responseData$convers3 = responseData.conversation) === null || _responseData$convers3 === void 0 || (_responseData$convers3 = _responseData$convers3.node) === null || _responseData$convers3 === void 0 ? void 0 : _responseData$convers3.id
                    }
                });
            },
            onError: (error)=>{
                handleMutationError({
                    nodeId: nodeId,
                    message: message,
                    connectionId: connectionId,
                    subscriptionId: subscriptionId
                });
                onError === null || onError === void 0 || onError(error);
            },
            variables: {
                workspaceAri: workspaceAri,
                conversationContextAri: conversationContextAri,
                subscriptionId: subscriptionId,
                isTestChannel: isTestConversation,
                message: content
            }
        });
    }, [
        commitMutation,
        environment,
        handleMutationError
    ]);
    return {
        isLoading: isLoading,
        createConversationWithMessage: createConversationWithMessage
    };
};

});
parcelRegister("8pVQu", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f4641b34d399528$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1917c13834322be3ebbaa2316f845978>>
 * @relayHash 6466481040e3141b45532075b56408d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b1dd5c9d9a158a325624ebe4af55ee2c9f41049eb71382692b4f832b9fa0f694
const $9f4641b34d399528$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "conversationContextAri"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isTestChannel"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "message"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subscriptionId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "channelExperienceId",
                    "value": "HELPCENTER"
                },
                {
                    "kind": "Variable",
                    "name": "conversationContextAri",
                    "variableName": "conversationContextAri"
                },
                {
                    "kind": "Variable",
                    "name": "isTestChannel",
                    "variableName": "isTestChannel"
                },
                {
                    "kind": "Variable",
                    "name": "message",
                    "variableName": "message"
                },
                {
                    "kind": "Variable",
                    "name": "subscriptionId",
                    "variableName": "subscriptionId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workspaceAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "concreteType": "JsmChatInitializeAndSendMessageResponse",
        "kind": "LinkedField",
        "name": "initializeAndSendMessageResponse",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "conversationId"
            },
            {
                "concreteType": "JsmChatMessageEdge",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsmChatCreateWebConversationMessage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "content"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "authorType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "contentType"
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "createConversationWithMessageMutation",
            "selections": [
                {
                    "concreteType": "JsmChatMutation",
                    "kind": "LinkedField",
                    "name": "jsmChat",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JsmChatInitializeAndSendMessagePayload",
                            "kind": "LinkedField",
                            "name": "initializeAndSendMessage",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "createConversationWithMessageMutation",
            "selections": [
                {
                    "concreteType": "JsmChatMutation",
                    "kind": "LinkedField",
                    "name": "jsmChat",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JsmChatInitializeAndSendMessagePayload",
                            "kind": "LinkedField",
                            "name": "initializeAndSendMessage",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b1dd5c9d9a158a325624ebe4af55ee2c9f41049eb71382692b4f832b9fa0f694",
            "metadata": {},
            "name": "createConversationWithMessageMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9f4641b34d399528$var$node.hash = "b29d0beea262991f003cc1fee9761127";
var $9f4641b34d399528$export$2e2bcd8739ae039 = $9f4641b34d399528$var$node;

});

parcelRegister("1IQPi", function(module, exports) {
$parcel$export(module.exports, "addMessageToConnection", () => $286573615f9a9c21$export$8dbc74cf18f1a65e);
$parcel$export(module.exports, "addNodeToConnection", () => $286573615f9a9c21$export$7163757da5dc49f0);
$parcel$export(module.exports, "addNodeToCurrentConnection", () => $286573615f9a9c21$export$d88c7883f045ee5);

var $8iTFq = parcelRequire("8iTFq");

var $2xcKg = parcelRequire("2xcKg");
const $286573615f9a9c21$export$8dbc74cf18f1a65e = ({ environment: environment, connectionId: connectionId, message: message, authorType: authorType })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const nodeId = `client:jsmChat:conversation:${(0, $2xcKg.v4)()}:customMessage:node`;
        const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
        node.setValue(nodeId, 'id');
        node.setValue(authorType, 'authorType');
        if (message) node.setValue(message, 'content');
        node.setValue('ADF', 'contentType');
        node.setValue(null, 'appendices');
        const newEdge = (0, $8iTFq.ConnectionHandler).createEdge(store, connection, node, 'JsmChatMessageEdge');
        (0, $8iTFq.ConnectionHandler).insertEdgeAfter(connection, newEdge);
    });
};
const $286573615f9a9c21$export$7163757da5dc49f0 = ({ store: store, recordId: recordId, connectionId: connectionId, edgeName: edgeName })=>{
    const connection = store.get(connectionId);
    if (!connection) return;
    const node = store.get(recordId);
    if (!node) return;
    const newEdge = (0, $8iTFq.ConnectionHandler).createEdge(store, connection, node, edgeName);
    (0, $8iTFq.ConnectionHandler).insertEdgeAfter(connection, newEdge);
};
const $286573615f9a9c21$export$d88c7883f045ee5 = ({ store: store, connectionId: connectionId, recordId: recordId })=>{
    const connection = store.get(connectionId);
    if (!connection) return;
    const node = store.get(recordId);
    if (!node) return;
    const newEdge = (0, $8iTFq.ConnectionHandler).createEdge(store, connection, node, 'JsmChatMessageEdge');
    (0, $8iTFq.ConnectionHandler).insertEdgeAfter(connection, newEdge);
};

});

parcelRegister("aGBfH", function(module, exports) {
$parcel$export(module.exports, "updateOmniChannelConversationMeta", () => $f63bccd74dafd02c$export$8c33322c5b64f409);
$parcel$export(module.exports, "updateOmniChannelConversationMetaPromise", () => $f63bccd74dafd02c$export$b90325dd8c9d560b);

var $8iTFq = parcelRequire("8iTFq");
const $f63bccd74dafd02c$export$8c33322c5b64f409 = ({ environment: environment, ...remainingParams })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        Object.keys(remainingParams).forEach((key)=>{
            jsmChatQuery.setValue(remainingParams[key], key);
        });
    });
};
const $f63bccd74dafd02c$export$b90325dd8c9d560b = ({ environment: environment, ...remainingParams })=>{
    return new Promise((resolve)=>{
        (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            Object.keys(remainingParams).forEach((key)=>{
                jsmChatQuery.setValue(remainingParams[key], key);
            });
            resolve(undefined);
        });
    });
};

});

parcelRegister("hpFT3", function(module, exports) {
$parcel$export(module.exports, "cleanFollowups", () => $5f4a651a646e775b$export$8ce7049bbf52d43c);
$parcel$export(module.exports, "createFollowupMessageNode", () => $5f4a651a646e775b$export$2e2870a1f1e8fe34);
$parcel$export(module.exports, "generateAIResponseNodeId", () => $5f4a651a646e775b$export$de38df1b227321b8);
$parcel$export(module.exports, "addOptimisticResponseToConnection", () => $5f4a651a646e775b$export$fbc4600ca9d78672);
$parcel$export(module.exports, "deleteNodeFromConnection", () => $5f4a651a646e775b$export$7da93f9af6d9769b);
$parcel$export(module.exports, "updateRelayRecordId", () => $5f4a651a646e775b$export$1424edefd4c57a66);
$parcel$export(module.exports, "addInteractionMessageToConnection", () => $5f4a651a646e775b$export$8c802e3a762f0d7b);
$parcel$export(module.exports, "convertInteractionMessageToErrorMessage", () => $5f4a651a646e775b$export$e868b53e9633f590);
$parcel$export(module.exports, "resetTimer", () => $5f4a651a646e775b$export$148d61ea341bbff7);
$parcel$export(module.exports, "clearTimer", () => $5f4a651a646e775b$export$4ffebd63913d6ea0);
$parcel$export(module.exports, "updateLastAIConversationAbortStatus", () => $5f4a651a646e775b$export$3c299bb7936c424a);
$parcel$export(module.exports, "updateMessageStatusToHelpseeker", () => $5f4a651a646e775b$export$c179851fb8c72922);
$parcel$export(module.exports, "getInteractionMetaFromNode", () => $5f4a651a646e775b$export$9a8b1bfde220a901);
$parcel$export(module.exports, "getLastHelpSeekerMessage", () => $5f4a651a646e775b$export$7d3bdcb2e57adde1);
$parcel$export(module.exports, "setDraftMessage", () => $5f4a651a646e775b$export$ae6e25e430bcd18b);
$parcel$export(module.exports, "handleActionParamFromSubscription", () => $5f4a651a646e775b$export$55d3e467a155fb59);
$parcel$export(module.exports, "fetchOmnichannelMeta", () => $5f4a651a646e775b$export$b0fec83cc7daf9d0);
$parcel$export(module.exports, "getConnectionIdFromStore", () => $5f4a651a646e775b$export$dd1db642ae57c18e);
$parcel$export(module.exports, "addGreetingMessageToConnection", () => $5f4a651a646e775b$export$18db76d681ccfece);

var $8iTFq = parcelRequire("8iTFq");

var $86E3j = parcelRequire("86E3j");

var $21MZc = parcelRequire("21MZc");

var $5Tbbx = parcelRequire("5Tbbx");

var $8Hu2S = parcelRequire("8Hu2S");

var $b7fXP = parcelRequire("b7fXP");

var $1IQPi = parcelRequire("1IQPi");
const $5f4a651a646e775b$export$8ce7049bbf52d43c = ({ environment: environment, connectionId: connectionId })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        edges.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('authorType');
            if (authorType === 'Followup_Message') (0, $8iTFq.ConnectionHandler).deleteNode(connection, node.getDataID());
        });
    });
};
const $5f4a651a646e775b$export$2e2870a1f1e8fe34 = (content, store)=>{
    const nodeId = (0, $8iTFq.generateUniqueClientID)();
    const followupNode = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    followupNode.setValue(nodeId, 'id');
    followupNode.setValue('Followup_Message', 'authorType');
    followupNode.setValue(JSON.stringify(content), 'content');
    return nodeId;
};
const $5f4a651a646e775b$export$de38df1b227321b8 = (id)=>{
    return `client::jsmChat::aiResponse::${id}`;
};
const $5f4a651a646e775b$export$50d7b649a01ab7a5 = ({ content: content, store: store, nodeId: nodeId, message: message })=>{
    const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    node.setValue(nodeId, 'id');
    node.setValue('Reporter', 'authorType');
    node.setValue(content, 'content');
    node.setValue('ADF', 'contentType');
    node.setValue(null, 'appendices');
    node.setValue(message, 'message');
    return node;
};
const $5f4a651a646e775b$export$fbc4600ca9d78672 = ({ environment: environment, connectionId: connectionId, content: content, nodeId: nodeId, message: message })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        $5f4a651a646e775b$export$50d7b649a01ab7a5({
            content: content,
            store: store,
            nodeId: nodeId,
            message: message
        });
        (0, $1IQPi.addNodeToConnection)({
            store: store,
            connectionId: connectionId,
            recordId: nodeId,
            edgeName: 'JsmChatMessageEdge'
        });
    });
};
const $5f4a651a646e775b$export$7da93f9af6d9769b = ({ environment: environment, connectionId: connectionId, nodeId: nodeId })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        edges.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('id');
            if (authorType === nodeId) {
                (0, $8iTFq.ConnectionHandler).deleteNode(connection, node.getDataID());
                store.delete(node.getDataID());
            }
        });
    });
};
const $5f4a651a646e775b$export$1424edefd4c57a66 = ({ environment: environment, nodeId: nodeId, newId: newId })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (node) node.setValue(newId, 'id');
    });
};
const $5f4a651a646e775b$export$8c802e3a762f0d7b = ({ environment: environment, message: message, nodeId: nodeId, connectionId: connectionId, interactionMeta: interactionMeta })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const node = $5f4a651a646e775b$export$50d7b649a01ab7a5({
            store: store,
            nodeId: nodeId,
            message: interactionMeta.message,
            content: message
        });
        node.setValue('InteractionMessage', 'authorType');
        node.setValue(JSON.stringify(interactionMeta), 'interactionFieldMeta');
        (0, $1IQPi.addNodeToConnection)({
            store: store,
            connectionId: connectionId,
            recordId: nodeId,
            edgeName: 'JsmChatMessageEdge'
        });
    });
};
const $5f4a651a646e775b$export$e868b53e9633f590 = ({ nodeId: nodeId, environment: environment, message: message })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (node) {
            node.setValue('InteractionError', 'authorType');
            node.setValue(message, 'content');
        }
    });
};
const $5f4a651a646e775b$export$148d61ea341bbff7 = ({ environment: environment, expiry: expiry = (0, $21MZc.CHANNEL_EXPIRY_TIME_24HRS), channelMessage: channelMessage = (0, $86E3j.ChannelMessageTypes).CHANNEL_EXPIRY })=>{
    $5f4a651a646e775b$export$4ffebd63913d6ea0(environment);
    const timer = setTimeout(()=>{
        (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const connectionId = jsmChatQuery.getValue('connectionId');
            if (!connectionId) return;
            const channelMessageNode = $5f4a651a646e775b$export$3c157ef8b8581f8d(store, channelMessage);
            (0, $1IQPi.addNodeToConnection)({
                store: store,
                connectionId: connectionId,
                recordId: channelMessageNode.getDataID(),
                edgeName: 'JsmChatMessageEdge'
            });
            jsmChatQuery.setValue(true, 'isConversationExpired');
            const connection = store.get(connectionId);
            if (!connection) return;
            const edges = connection.getLinkedRecords('edges');
            if (!edges) return;
            edges.forEach((edge)=>{
                const node = edge.getLinkedRecord('node');
                if (!node) return;
                const authorType = node.getValue('authorType');
                if (authorType === 'Followup_Message') (0, $8iTFq.ConnectionHandler).deleteNode(connection, node.getDataID());
            });
        });
    }, expiry);
    $5f4a651a646e775b$export$6467bd9f4ef23cb9(environment, timer);
};
const $5f4a651a646e775b$export$6467bd9f4ef23cb9 = (environment, timer)=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(timer, 'timer');
    });
};
const $5f4a651a646e775b$export$4ffebd63913d6ea0 = (environment)=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const timerId = jsmChatQuery.getValue('timer') ?? 0;
        clearTimeout(timerId);
    });
};
const $5f4a651a646e775b$export$3c157ef8b8581f8d = (store, type)=>{
    const nodeId = (0, $8iTFq.generateUniqueClientID)();
    const channelMessageNode = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    channelMessageNode.setValue(nodeId, 'id');
    channelMessageNode.setValue('ChannelMessage', 'authorType');
    channelMessageNode.setValue(type, 'content');
    return channelMessageNode;
};
const $5f4a651a646e775b$export$3c299bb7936c424a = ({ environment: environment, status: status })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const connectionId = jsmChatQuery.getValue('connectionId');
        if (!connectionId) return;
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        for (const edge of edges.reverse()){
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('authorType');
            if (authorType === 'Assistant_Message') {
                const assistantMessageNode = node === null || node === void 0 ? void 0 : node.getOrCreateLinkedRecord('assistantMessage', 'JsmChatAssistantMessage');
                assistantMessageNode.setValue(status, 'isAborted');
                return;
            }
        }
    });
};
const $5f4a651a646e775b$export$c179851fb8c72922 = ({ environment: environment })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue((0, $8Hu2S.HelpSeekerMessageStatus).IDLE, 'aiAnswerStatus');
    });
};
const $5f4a651a646e775b$export$4941c3f3a49f3f68 = ({ environment: environment, nodeId: nodeId, action: action })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (!node) return;
        node.setValue(action, 'action');
    });
};
const $5f4a651a646e775b$export$9a8b1bfde220a901 = ({ environment: environment, nodeId: nodeId })=>{
    return new Promise((resolve, reject)=>{
        (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
            const node = store.get(nodeId);
            if (!node) {
                reject(new Error('No Node found'));
                return;
            }
            const interactionMeta = node === null || node === void 0 ? void 0 : node.getValue('interactionFieldMeta');
            if (!interactionMeta) {
                reject(new Error('No InteractionMeta found'));
                return;
            }
            resolve((0, $b7fXP.parseJson)(interactionMeta));
        });
    });
};
const $5f4a651a646e775b$export$7d3bdcb2e57adde1 = ({ environment: environment })=>{
    return new Promise((resolve, reject)=>{
        (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const connectionId = jsmChatQuery.getValue('connectionId');
            if (!connectionId) {
                reject(new Error('No ConnectionID Found'));
                return;
            }
            const connection = store.get(connectionId);
            if (!connection) {
                reject(new Error('No Connection Found'));
                return;
            }
            const edges = connection.getLinkedRecords('edges');
            if (!edges) {
                reject(new Error('No Messages Found'));
                return;
            }
            for (const edge of edges.reverse()){
                const node = edge.getLinkedRecord('node');
                const authorType = node === null || node === void 0 ? void 0 : node.getValue('authorType');
                if (authorType === 'Reporter') {
                    resolve(node === null || node === void 0 ? void 0 : node.getValue('message'));
                    return;
                }
            }
        });
    });
};
const $5f4a651a646e775b$export$ae6e25e430bcd18b = ({ environment: environment, message: message })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(message, 'draftMessage');
    });
};
const $5f4a651a646e775b$export$55d3e467a155fb59 = ({ action: action, environment: environment, nodeId: nodeId, connectionId: connectionId })=>{
    // oxlint-disable-next-line default-case
    switch(action){
        case 'REDIRECT_TO_SEARCH':
            $5f4a651a646e775b$export$4941c3f3a49f3f68({
                environment: environment,
                nodeId: nodeId,
                action: action
            });
            break;
        case 'CLOSE_CONVERSATION':
            $5f4a651a646e775b$export$148d61ea341bbff7({
                environment: environment,
                expiry: 0,
                channelMessage: (0, $86E3j.ChannelMessageTypes).CHANNEL_CONVERSATION_OVER
            });
            break;
        case 'DISABLE_INPUT':
            if (connectionId) {
                $5f4a651a646e775b$export$8ce7049bbf52d43c({
                    environment: environment,
                    connectionId: connectionId
                });
                $5f4a651a646e775b$export$ede71f104937b4ea(environment, true);
            }
            break;
    }
};
const $5f4a651a646e775b$export$ede71f104937b4ea = (environment, status)=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(status, 'disableInput');
    });
};
const $5f4a651a646e775b$export$b0fec83cc7daf9d0 = (environment)=>{
    return new Promise((resolve, reject)=>{
        (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            if (!root) reject(new Error('No Root Found'));
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const conversationId = jsmChatQuery.getValue('conversationId');
            const connectionId = jsmChatQuery.getValue('connectionId');
            const conversationContextAri = jsmChatQuery.getValue('conversationContextAri');
            const hasMessage = jsmChatQuery.getValue('hasMessage');
            const isReplyPending = jsmChatQuery.getValue('isReplyPending');
            const aiAnswerStatus = jsmChatQuery.getValue('aiAnswerStatus');
            const draftMessage = jsmChatQuery.getValue('draftMessage');
            const isConversationExpired = jsmChatQuery.getValue('isConversationExpired');
            const isConversationClosed = jsmChatQuery.getValue('isConversationClosed');
            const disableInput = jsmChatQuery.getValue('disableInput');
            const subscriptionId = jsmChatQuery.getValue('subscriptionId');
            const greetingMessage = jsmChatQuery.getValue('greetingMessage');
            const subscriptionTriggered = jsmChatQuery.getValue('subscriptionTriggered');
            subscriptionTriggered;
            resolve({
                conversationId: conversationId,
                connectionId: connectionId,
                conversationContextAri: conversationContextAri,
                hasMessage: hasMessage,
                isReplyPending: isReplyPending,
                aiAnswerStatus: aiAnswerStatus,
                draftMessage: draftMessage,
                isConversationExpired: isConversationExpired,
                isConversationClosed: isConversationClosed,
                disableInput: disableInput,
                subscriptionId: subscriptionId,
                greetingMessage: greetingMessage,
                subscriptionTriggered: subscriptionTriggered
            });
        });
    });
};
const $5f4a651a646e775b$export$dd1db642ae57c18e = (store)=>{
    const root = store.getRoot();
    const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
    return jsmChatQuery.getValue('connectionId');
};
const $5f4a651a646e775b$export$87805a37c19b2fb7 = ({ content: content, store: store, nodeId: nodeId, authorType: authorType })=>{
    const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    node.setValue(nodeId, 'id');
    node.setValue(authorType, 'authorType');
    node.setValue(content, 'content');
    node.setValue('ADF', 'contentType');
    node.setValue(null, 'appendices');
    return node;
};
const $5f4a651a646e775b$export$18db76d681ccfece = ({ environment: environment, connectionId: connectionId, nodeId: nodeId })=>{
    (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const content = jsmChatQuery.getValue('greetingMessage') ?? '';
        const isGreetingMessageAdded = jsmChatQuery.getValue('isGreetingMessageAdded') ?? false;
        if (!isGreetingMessageAdded) {
            const authorType = content !== '' ? 'VirtualAgent' : 'GreetingMessage';
            $5f4a651a646e775b$export$87805a37c19b2fb7({
                content: content,
                store: store,
                nodeId: nodeId,
                authorType: authorType
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $5Tbbx.omnichannelGreetingMessageExperience).success({
                metadata: {
                    connectionId: connectionId,
                    conversationId: jsmChatQuery.getValue('conversationId') ?? ''
                }
            });
            (0, $1IQPi.addNodeToConnection)({
                store: store,
                connectionId: connectionId,
                recordId: nodeId,
                edgeName: 'JsmChatMessageEdge'
            });
            jsmChatQuery.setValue(true, 'isGreetingMessageAdded');
        }
    });
};

});
parcelRegister("21MZc", function(module, exports) {
$parcel$export(module.exports, "MAX_CHARS", () => $1c4c98f61333f466$export$3fd15502aa7f615e);
$parcel$export(module.exports, "CHANNEL_EXPIRY_TIME_24HRS", () => $1c4c98f61333f466$export$76a18595b547627f);
const $1c4c98f61333f466$export$3fd15502aa7f615e = 1000; // Used in Input component
const $1c4c98f61333f466$export$10482ada0e471d1d = 300000; // 5mins
const $1c4c98f61333f466$export$76a18595b547627f = 86400000; // 24 Hrs

});

parcelRegister("8Hu2S", function(module, exports) {
$parcel$export(module.exports, "HelpSeekerMessageStatus", () => $84ef46c093f3046c$export$2cdf090c2d29ef5f);
var $84ef46c093f3046c$export$2cdf090c2d29ef5f = /*#__PURE__*/ function(HelpSeekerMessageStatus) {
    HelpSeekerMessageStatus["IDLE"] = "helpseeker_idle";
    return HelpSeekerMessageStatus;
}({});

});

parcelRegister("b7fXP", function(module, exports) {
$parcel$export(module.exports, "parseJson", () => $36cf9cf465a24cbd$export$18c43dcebf00e571);
$parcel$export(module.exports, "isMessageGenerated", () => $36cf9cf465a24cbd$export$c2e15cdb6fbfcd43);

var $86E3j = parcelRequire("86E3j");

var $8Hu2S = parcelRequire("8Hu2S");
const $36cf9cf465a24cbd$export$18c43dcebf00e571 = (value)=>{
    try {
        return typeof value === 'string' ? JSON.parse(value) : undefined;
    } catch (e) {
        return undefined;
    }
};
const $36cf9cf465a24cbd$export$c2e15cdb6fbfcd43 = (status)=>{
    if (!status) return true;
    if (status === (0, $8Hu2S.HelpSeekerMessageStatus).IDLE) return true;
    return [
        (0, $86E3j.ASSISTANT_MESSAGE_STATUS).IDLE,
        (0, $86E3j.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
    ].indexOf(status) !== -1;
};

});


parcelRegister("zH1y1", function(module, exports) {
$parcel$export(module.exports, "createConversationWithMessageExperience", () => $b9d72b1c267f489f$export$bcb43460f5483389);

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $b9d72b1c267f489f$var$createConversationWithMessageExperienceId = 'service-management.help-center.omnichannel.combined-api';
const $b9d72b1c267f489f$export$bcb43460f5483389 = new (0, $ghwxF.UFOExperience)($b9d72b1c267f489f$var$createConversationWithMessageExperienceId, {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("7QDmV", function(module, exports) {
$parcel$export(module.exports, "establishSubscriptionToOmnichannel", () => $d9c3e5e1bd7d72d8$export$190438bc49e7cd0e);

var $2PFKc = parcelRequire("2PFKc");

var $HGACo = parcelRequire("HGACo");

var $8iTFq = parcelRequire("8iTFq");

var $6MsBn = parcelRequire("6MsBn");

var $khAYd = parcelRequire("khAYd");

var $5Tbbx = parcelRequire("5Tbbx");

var $b7fXP = parcelRequire("b7fXP");

var $1IQPi = parcelRequire("1IQPi");

var $1IO79 = parcelRequire("1IO79");

var $aGBfH = parcelRequire("aGBfH");

var $hpFT3 = parcelRequire("hpFT3");

var $8952j = parcelRequire("8952j");
const $d9c3e5e1bd7d72d8$var$SubscriptionGL = (0, $2PFKc.default);
const $d9c3e5e1bd7d72d8$export$190438bc49e7cd0e = ({ environment: environment, subscriptionId: subscriptionId })=>{
    const metadata = {
        subscriptionId: subscriptionId
    };
    (0, $8952j.subscriptionConnectionExperience).start();
    return (0, $8iTFq.requestSubscription)(environment, {
        onError: (error)=>{
            if ((0, $HGACo.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $aGBfH.updateOmniChannelConversationMeta)({
                environment: environment,
                subscriptionStatus: 'FAILED'
            });
            (0, $5Tbbx.initialAIMessageHCExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $5Tbbx.initialIntentMessageHCExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $8952j.subscriptionConnectionExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $khAYd.sendErrorEvent)({
                error: error,
                actionSubject: 'omnichannelSubscription',
                attributes: {
                    ...metadata
                }
            });
        },
        onNext: (data)=>{
            var _data$jsmChat, _data$jsmChat2, _data$jsmChat6, _node$content;
            if ((data === null || data === void 0 || (_data$jsmChat = data.jsmChat) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.updateConversation) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.result) === null || _data$jsmChat === void 0 ? void 0 : _data$jsmChat.__typename) === 'JsmChatWebSubscriptionEstablishedPayload') {
                if ((0, $HGACo.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $aGBfH.updateOmniChannelConversationMeta)({
                    environment: environment,
                    subscriptionStatus: 'ACTIVE'
                });
                (0, $8952j.subscriptionConnectionExperience).success({
                    metadata: metadata
                });
                return;
            }
            if ((data === null || data === void 0 || (_data$jsmChat2 = data.jsmChat) === null || _data$jsmChat2 === void 0 || (_data$jsmChat2 = _data$jsmChat2.updateConversation) === null || _data$jsmChat2 === void 0 || (_data$jsmChat2 = _data$jsmChat2.result) === null || _data$jsmChat2 === void 0 ? void 0 : _data$jsmChat2.__typename) === 'JsmChatWebConversationUpdateQueryError') {
                var _data$jsmChat3, _data$jsmChat4, _data$jsmChat5;
                (0, $khAYd.sendErrorEvent)({
                    error: new Error((data === null || data === void 0 || (_data$jsmChat3 = data.jsmChat) === null || _data$jsmChat3 === void 0 || (_data$jsmChat3 = _data$jsmChat3.updateConversation) === null || _data$jsmChat3 === void 0 || (_data$jsmChat3 = _data$jsmChat3.result) === null || _data$jsmChat3 === void 0 ? void 0 : _data$jsmChat3.message) ?? 'Payload Error in Subscription'),
                    actionSubject: 'omnichannelSubscription',
                    attributes: {
                        ...metadata
                    }
                });
                (0, $5Tbbx.initialIntentMessageHCExperience).failure({
                    metadata: {
                        ...metadata,
                        error: (data === null || data === void 0 || (_data$jsmChat4 = data.jsmChat) === null || _data$jsmChat4 === void 0 || (_data$jsmChat4 = _data$jsmChat4.updateConversation) === null || _data$jsmChat4 === void 0 || (_data$jsmChat4 = _data$jsmChat4.result) === null || _data$jsmChat4 === void 0 ? void 0 : _data$jsmChat4.message) ?? 'Payload Error in Subscription'
                    }
                });
                (0, $5Tbbx.initialAIMessageHCExperience).failure({
                    metadata: {
                        ...metadata,
                        error: (data === null || data === void 0 || (_data$jsmChat5 = data.jsmChat) === null || _data$jsmChat5 === void 0 || (_data$jsmChat5 = _data$jsmChat5.updateConversation) === null || _data$jsmChat5 === void 0 || (_data$jsmChat5 = _data$jsmChat5.result) === null || _data$jsmChat5 === void 0 ? void 0 : _data$jsmChat5.message) ?? 'Payload Error in Subscription'
                    }
                });
            }
            if (!(data !== null && data !== void 0 && (_data$jsmChat6 = data.jsmChat) !== null && _data$jsmChat6 !== void 0 && (_data$jsmChat6 = _data$jsmChat6.updateConversation) !== null && _data$jsmChat6 !== void 0 && _data$jsmChat6.conversation)) {
                (0, $aGBfH.updateOmniChannelConversationMeta)({
                    environment: environment,
                    isReplyPending: false
                });
                return;
            }
            const node = data.jsmChat.updateConversation.conversation.node;
            if (!node) return;
            const recordId = (0, $6MsBn.getRelayDataId)(node === null || node === void 0 ? void 0 : node.id, 'JsmChatCreateWebConversationMessage');
            const action = data.jsmChat.updateConversation.action;
            (0, $hpFT3.handleActionParamFromSubscription)({
                action: action,
                environment: environment,
                connectionId: undefined,
                nodeId: recordId
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((_node$content = node.content) !== null && _node$content !== void 0 && _node$content.aiResponse) {
                var _node$content2;
                (0, $5Tbbx.initialAIMessageHCExperience).success({
                    metadata: metadata
                });
                (0, $5Tbbx.initialIntentMessageHCExperience).abort({
                    metadata: {
                        ...metadata,
                        actionSubject: 'aiReceived'
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                const aiResponse = (_node$content2 = node.content) === null || _node$content2 === void 0 ? void 0 : _node$content2.aiResponse;
                const aiResponseNodeId = (0, $hpFT3.generateAIResponseNodeId)(recordId);
                (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
                    let aiResponseNode = store.get(aiResponseNodeId);
                    if (!aiResponseNode) {
                        aiResponseNode = store.create(aiResponseNodeId, 'JsmChatCreateWebConversationMessage');
                        aiResponseNode.setValue(aiResponseNodeId, 'id');
                        aiResponseNode.setValue('Assistant_Message', 'authorType');
                        const connectionId = (0, $hpFT3.getConnectionIdFromStore)(store);
                        if (connectionId) (0, $1IQPi.addNodeToCurrentConnection)({
                            store: store,
                            connectionId: connectionId,
                            recordId: aiResponseNodeId
                        });
                    }
                    store.delete(recordId);
                });
                const streamingMessages = (0, $b7fXP.parseJson)(aiResponse);
                streamingMessages === null || streamingMessages === void 0 || streamingMessages.forEach((streamingMessage)=>{
                    (0, $1IO79.updateStreamingMessageInStore)({
                        environment: environment,
                        streamingMessage: streamingMessage,
                        connectionId: undefined,
                        recordId: aiResponseNodeId
                    });
                });
            } else {
                if (!action || action !== 'GREETING_MESSAGE') {
                    (0, $5Tbbx.initialIntentMessageHCExperience).success({
                        metadata: metadata
                    });
                    (0, $5Tbbx.initialAIMessageHCExperience).abort({
                        metadata: {
                            ...metadata,
                            actionSubject: 'intentReceived'
                        }
                    });
                }
                (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
                    const connectionId = (0, $hpFT3.getConnectionIdFromStore)(store);
                    if (connectionId) (0, $1IQPi.addNodeToConnection)({
                        store: store,
                        connectionId: connectionId,
                        recordId: recordId,
                        edgeName: 'JsmChatMessageEdge'
                    });
                });
            }
            if (!action || action !== 'GREETING_MESSAGE') (0, $aGBfH.updateOmniChannelConversationMeta)({
                environment: environment,
                isReplyPending: false
            });
        },
        subscription: $d9c3e5e1bd7d72d8$var$SubscriptionGL,
        variables: {
            conversationId: subscriptionId
        }
    });
};

});
parcelRegister("2PFKc", function(module, exports) {
$parcel$export(module.exports, "default", () => $5afaa0b040061b5a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5956b646f76dbe26389d9c820aea4b94>>
 * @relayHash 66ceed11481c815b912f0ffeaa5b68cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d34ae9e8c9280f0a73c58fb2cb42bc0412029875ab15059a0b814fd3380e50d0
const $5afaa0b040061b5a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = [
        {
            "concreteType": "JsmChatSubscription",
            "kind": "LinkedField",
            "name": "jsmChat",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "conversationId",
                            "variableName": "conversationId"
                        }
                    ],
                    "concreteType": "JsmChatWebSubscriptionResponse",
                    "kind": "LinkedField",
                    "name": "updateConversation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "result",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JsmChatWebSubscriptionEstablishedPayload"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "JsmChatWebConversationUpdateQueryError"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "concreteType": "JsmChatMessageEdge",
                            "kind": "LinkedField",
                            "name": "conversation",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "authorType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "content"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "contentType"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "appendices",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "requestTypeId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jiraProjectId"
                                                        }
                                                    ],
                                                    "type": "JsmChatJiraFieldAppendix"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JsmChatAppendixActionItem",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JsmChatAppendixRedirectAction",
                                                                    "kind": "LinkedField",
                                                                    "name": "redirectAction",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "baseUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "query"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JsmChatOptionAppendix"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "placeholder"
                                                        },
                                                        {
                                                            "concreteType": "JsmChatAppendixActionItem",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JsmChatDropdownAppendix"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "communicationChannelSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "communicationChannelSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "d34ae9e8c9280f0a73c58fb2cb42bc0412029875ab15059a0b814fd3380e50d0",
            "metadata": {},
            "name": "communicationChannelSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$5afaa0b040061b5a$var$node.hash = "44da5305c7ec49b7ef2bab1de243b217";
var $5afaa0b040061b5a$export$2e2bcd8739ae039 = $5afaa0b040061b5a$var$node;

});

parcelRegister("1IO79", function(module, exports) {
$parcel$export(module.exports, "updateStreamingMessageInStore", () => $51b89a26ea55ac34$export$648f4e23156d6dfe);

var $HGACo = parcelRequire("HGACo");

var $h3cOB = parcelRequire("h3cOB");

var $gxLiU = parcelRequire("gxLiU");

var $86E3j = parcelRequire("86E3j");

var $8Hu2S = parcelRequire("8Hu2S");

var $b7fXP = parcelRequire("b7fXP");

var $1IQPi = parcelRequire("1IQPi");

var $hpFT3 = parcelRequire("hpFT3");
const $51b89a26ea55ac34$var$getMessageMetaFromStore = (assistantMessage, recordId)=>{
    const DEFAULT_ASSISNTANT_MESSAGE = {
        status: (0, $86E3j.ASSISTANT_MESSAGE_STATUS).AWAITING_RESPONSE,
        messageId: recordId
    };
    if (!assistantMessage) return DEFAULT_ASSISNTANT_MESSAGE;
    const messageMeta = assistantMessage === null || assistantMessage === void 0 ? void 0 : assistantMessage.getValue('message_metaData');
    try {
        return (0, $b7fXP.parseJson)(messageMeta) ?? DEFAULT_ASSISNTANT_MESSAGE;
    } catch  {
        return DEFAULT_ASSISNTANT_MESSAGE;
    }
};
const $51b89a26ea55ac34$export$648f4e23156d6dfe = ({ environment: environment, recordId: recordId, streamingMessage: streamingMessage })=>{
    (0, $h3cOB.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(recordId);
        const assistantMessageNode = node === null || node === void 0 ? void 0 : node.getOrCreateLinkedRecord('assistantMessage', 'JsmChatAssistantMessage');
        const messageContent = (assistantMessageNode === null || assistantMessageNode === void 0 ? void 0 : assistantMessageNode.getValue('content')) ?? '';
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const connectionId = jsmChatQuery.getValue('connectionId');
        const { type: type, content: content } = (0, $gxLiU.getUHUpdatedMessage)(streamingMessage, {
            content: messageContent,
            role: '',
            id: '0',
            time_created: '',
            user_ari: '',
            plugin_invocations: []
        }) ?? {
            type: ''
        };
        const metaData = $51b89a26ea55ac34$var$getMessageMetaFromStore(assistantMessageNode, recordId);
        // AI Conversation can be aborted from `stopGenerating` CTA in Input Box
        const abortStatus = assistantMessageNode === null || assistantMessageNode === void 0 ? void 0 : assistantMessageNode.getValue('isAborted');
        if (abortStatus) {
            metaData.status = (0, $86E3j.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE;
            jsmChatQuery.setValue((0, $86E3j.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE, 'aiAnswerStatus');
            assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
            return;
        }
        switch(type){
            case 'FOLLOW_UP_QUERIES':
                if ((0, $HGACo.isFollowupEnabledForPortal)()) {
                    const nodeId = (0, $hpFT3.createFollowupMessageNode)(content, store);
                    (0, $1IQPi.addNodeToConnection)({
                        store: store,
                        connectionId: connectionId,
                        recordId: nodeId,
                        edgeName: 'JsmChatMessageEdge'
                    });
                }
                break;
            case 'CONTENT_SEARCH':
                metaData.keywords = content.split('|');
                metaData.status = (0, $86E3j.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                jsmChatQuery.setValue((0, $86E3j.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE, 'aiAnswerStatus');
                break;
            case 'ANALYSING_STATE':
                metaData.sources = content;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                break;
            case 'ANSWER_PART':
                metaData.status = (0, $86E3j.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(content.content, 'content');
                jsmChatQuery.setValue((0, $86E3j.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE, 'aiAnswerStatus');
                break;
            case 'FINAL_RESPONSE':
                {
                    var _aiMetaData$message_m;
                    const aiMetaData = content;
                    metaData.status = (0, $86E3j.ASSISTANT_MESSAGE_STATUS).IDLE;
                    metaData.messageId = aiMetaData.id.toString();
                    const isFallbackMessage = !!((_aiMetaData$message_m = aiMetaData.message_metadata) !== null && _aiMetaData$message_m !== void 0 && _aiMetaData$message_m.isFallbackMessage);
                    metaData.showFeedback = !isFallbackMessage;
                    metaData.isFallbackMessage = isFallbackMessage;
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(content.plugin_invocations), 'pluginInvocation');
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(aiMetaData), 'aiMateConversationResponse');
                    jsmChatQuery.setValue((0, $86E3j.ASSISTANT_MESSAGE_STATUS).IDLE, 'aiAnswerStatus');
                    if (isFallbackMessage) {
                        node === null || node === void 0 || node.setValue('Init', 'authorType');
                        jsmChatQuery.setValue((0, $8Hu2S.HelpSeekerMessageStatus).IDLE, 'aiAnswerStatus');
                    }
                    break;
                }
            case 'ERROR':
                node === null || node === void 0 || node.setValue('Assistant_Error', 'authorType');
                jsmChatQuery.setValue((0, $86E3j.ASSISTANT_MESSAGE_STATUS).IDLE, 'aiAnswerStatus');
                node === null || node === void 0 || node.setValue(null, 'content');
                break;
            default:
                break;
        }
    });
};

});

parcelRegister("8952j", function(module, exports) {
$parcel$export(module.exports, "subscriptionConnectionExperience", () => $ff4c11452c0bd5da$export$1c1eb834db2f7128);
$parcel$export(module.exports, "omnichannelPageLoadExperience", () => $ff4c11452c0bd5da$export$4feb855a2be04fbe);

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $ff4c11452c0bd5da$export$1c1eb834db2f7128 = new (0, $ghwxF.UFOExperience)('service-management.help-center.omnichannel-v2.subscription-connection', {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $ff4c11452c0bd5da$export$4feb855a2be04fbe = new (0, $ghwxF.UFOExperience)('service-management.help-center.omnichannel-v2.page-load', {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("4zFmR", function(module, exports) {
$parcel$export(module.exports, "generateUniqueSubscriptionID", () => $afcf4bb62a5f400d$export$b84750da6cd46f95);

var $jByYr = parcelRequire("jByYr");

var $8iTFq = parcelRequire("8iTFq");

var $2xcKg = parcelRequire("2xcKg");
const $afcf4bb62a5f400d$export$b84750da6cd46f95 = ({ environment: environment })=>{
    return new Promise((resolve)=>{
        (0, $8iTFq.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const subscriptionId = jsmChatQuery.getValue('subscriptionId');
            if (!subscriptionId) {
                const newSubscriptionID = `ari:cloud:conversational-help:${(0, $jByYr.getCloudId)()}:conversation/${(0, $2xcKg.v4)()}`;
                jsmChatQuery.setValue(newSubscriptionID, 'subscriptionId');
                jsmChatQuery.setValue(null, 'connectionId');
                resolve(newSubscriptionID);
            }
            resolve(subscriptionId);
        });
    });
};

});

parcelRegister("gbUep", function(module, exports) {
$parcel$export(module.exports, "useSubscriptionStore", () => $9e448bc8d28e0acf$export$554946cac481f18a);
$parcel$export(module.exports, "useSubscriptionAction", () => $9e448bc8d28e0acf$export$b9e415294ecd1592);

var $6xLCs = parcelRequire("6xLCs");
var $kUoOn = parcelRequire("kUoOn");

var $eKZzu = parcelRequire("eKZzu");
const $9e448bc8d28e0acf$var$initialState = {
    subscription: {
        dispose: ()=>undefined
    }
};
const $9e448bc8d28e0acf$var$store = (0, $kUoOn.createStore)({
    actions: $eKZzu.actions,
    initialState: $9e448bc8d28e0acf$var$initialState,
    name: 'OmnichannelSubscriptionStore'
});
const $9e448bc8d28e0acf$export$554946cac481f18a = (0, $6xLCs.createHook)($9e448bc8d28e0acf$var$store);
const $9e448bc8d28e0acf$export$b9e415294ecd1592 = (0, $6xLCs.createActionsHook)($9e448bc8d28e0acf$var$store);

});
parcelRegister("eKZzu", function(module, exports) {
$parcel$export(module.exports, "actions", () => $48ac7825fe2bdd46$export$e324594224ef24da);

var $dHwVL = parcelRequire("dHwVL");
const $48ac7825fe2bdd46$export$e324594224ef24da = {
    setSubscriptionDisposer: $dHwVL.setSubscriptionDisposer
};

});
parcelRegister("dHwVL", function(module, exports) {
$parcel$export(module.exports, "setSubscriptionDisposer", () => $7abba619928a43ab$export$398a2526d7502a0f);
const $7abba619928a43ab$export$398a2526d7502a0f = (disposable)=>({ setState: setState })=>{
        setState({
            subscription: disposable
        });
    };

});



parcelRegister("kZVLE", function(module, exports) {
$parcel$export(module.exports, "OmnichannelClientConnection", () => $3e47323c41e9136b$export$ca9674c8e6a24427);

var $c1kfl = parcelRequire("c1kfl");

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $edC7N = parcelRequire("edC7N");

var $1We2B = parcelRequire("1We2B");
parcelRequire("4PbDu");
var $3FFzY = parcelRequire("3FFzY");

var $h3cOB = parcelRequire("h3cOB");

var $frzzF = parcelRequire("frzzF");

var $aGBfH = parcelRequire("aGBfH");

var $dfS0m = parcelRequire("dfS0m");
var $8y0tS = parcelRequire("8y0tS");

var $4zFmR = parcelRequire("4zFmR");

var $32O9g = parcelRequire("32O9g");
const $3e47323c41e9136b$export$8bbd1b8324c70f51 = ()=>{
    var _data$jsmChat;
    const metaData = (0, $frzzF.useOmnichannelMetaQuery)();
    const subscriptionId = metaData.subscriptionId;
    (0, $8y0tS.useUFOComponentExperience)((0, $32O9g.omnichannelGetConversationExperience));
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $c1kfl.default), {
        conversationId: subscriptionId ?? '',
        isEmptyConversation: !subscriptionId
    });
    const newConnectionId = (_data$jsmChat = data.jsmChat) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.getWebConversation) === null || _data$jsmChat === void 0 ? void 0 : _data$jsmChat.__id;
    const environment = (0, $h3cOB.useRelayEnvironment)();
    (0, $8P7DW.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $4zFmR.generateUniqueSubscriptionID)({
            environment: environment
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $32O9g.omnichannelGetConversationExperience).start();
    }, [
        environment
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (newConnectionId && metaData.connectionId !== newConnectionId) (0, $aGBfH.updateOmniChannelConversationMeta)({
            environment: environment,
            connectionId: newConnectionId
        });
    }, [
        environment,
        metaData.connectionId,
        newConnectionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $32O9g.omnichannelGetConversationExperience)
    });
};
const $3e47323c41e9136b$export$ca9674c8e6a24427 = ({ renderError: renderError })=>{
    const onError = (0, $8P7DW.useCallback)((error)=>{
        (0, $32O9g.omnichannelGetConversationExperience).failure({
            metadata: {
                error: error === null || error === void 0 ? void 0 : error.message,
                statusCode: error === null || error === void 0 ? void 0 : error.status
            }
        }).then((0, $1We2B.noop)).catch((0, $1We2B.noop));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: (0, $8rTkC.ScreenName).CONVERSATION_PAGE,
        id: "omnichannel-helpcenter-conversation",
        onError: onError,
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3e47323c41e9136b$export$8bbd1b8324c70f51, null)));
};

});
parcelRegister("c1kfl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b09703bf5b926565$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47e37617394df2da9c06213ecddd0adf>>
 * @relayHash f6c352f48eeebb85cf0c9fbc89dbddb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e8801d6cc9f23bf8354598a09093970032c0e0c52119c549c1b54f759bd1319
const $b09703bf5b926565$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEmptyConversation"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v6 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "last",
            "value": 1
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "content"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "omnichannelClientConnectionQuery",
            "selections": [
                {
                    "condition": "isEmptyConversation",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JsmChatQuery",
                            "kind": "LinkedField",
                            "name": "jsmChat",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "getWebConversation",
                                    "args": [
                                        v1 /*: any*/ 
                                    ],
                                    "concreteType": "JsmChatMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "__Connection__getWebConversation_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsmChatMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "messageRendererFragment"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "omnichannelClientConnectionQuery",
            "selections": [
                {
                    "condition": "isEmptyConversation",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JsmChatQuery",
                            "kind": "LinkedField",
                            "name": "jsmChat",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JsmChatMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "getWebConversation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsmChatMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "authorType"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "action"
                                                                },
                                                                {
                                                                    "concreteType": "JsmChatAssistantMessage",
                                                                    "kind": "LinkedField",
                                                                    "name": "assistantMessage",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pluginInvocation"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "aiMateConversationResponse"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message_metaData"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "appendices",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJsmChatConversationAppendixAction"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JsmChatAppendixActionItem",
                                                                            "kind": "LinkedField",
                                                                            "name": "options",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatDropdownAppendix"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "requestTypeId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraProjectId"
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatJiraFieldAppendix"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JsmChatAppendixActionItem",
                                                                            "kind": "LinkedField",
                                                                            "name": "options",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JsmChatAppendixRedirectAction",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "redirectAction",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "baseUrl"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "query"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatOptionAppendix"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "conversationId"
                                    ],
                                    "handle": "connection",
                                    "key": "Connection__getWebConversation",
                                    "kind": "LinkedHandle",
                                    "name": "getWebConversation"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4e8801d6cc9f23bf8354598a09093970032c0e0c52119c549c1b54f759bd1319",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "backward",
                        "path": [
                            "jsmChat",
                            "getWebConversation"
                        ]
                    }
                ]
            },
            "name": "omnichannelClientConnectionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b09703bf5b926565$var$node.hash = "8ddd798333f81ebc8a31a378348e8046";
var $b09703bf5b926565$export$2e2bcd8739ae039 = $b09703bf5b926565$var$node;

});

parcelRegister("frzzF", function(module, exports) {
$parcel$export(module.exports, "useOmnichannelMetaQuery", () => $62198edb1515c75c$export$bc28f1e9de226671);

var $gj6SG = parcelRequire("gj6SG");

var $h3cOB = parcelRequire("h3cOB");
const $62198edb1515c75c$export$bc28f1e9de226671 = ()=>{
    var _data$jsmChatConversa, _data$jsmChatConversa2, _data$jsmChatConversa3, _data$jsmChatConversa4, _data$jsmChatConversa5, _data$jsmChatConversa6, _data$jsmChatConversa7, _data$jsmChatConversa8, _data$jsmChatConversa9, _data$jsmChatConversa0, _data$jsmChatConversa1, _data$jsmChatConversa10, _data$jsmChatConversa11;
    const data = (0, $h3cOB.useClientQuery)((0, $gj6SG.default), {});
    return {
        conversationId: data === null || data === void 0 || (_data$jsmChatConversa = data.jsmChatConversationMeta) === null || _data$jsmChatConversa === void 0 ? void 0 : _data$jsmChatConversa.conversationId,
        conversationContextAri: data === null || data === void 0 || (_data$jsmChatConversa2 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa2 === void 0 ? void 0 : _data$jsmChatConversa2.conversationContextAri,
        workspaceAri: data === null || data === void 0 || (_data$jsmChatConversa3 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa3 === void 0 ? void 0 : _data$jsmChatConversa3.workspaceAri,
        connectionId: data === null || data === void 0 || (_data$jsmChatConversa4 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa4 === void 0 ? void 0 : _data$jsmChatConversa4.connectionId,
        isReplyPending: !!(data !== null && data !== void 0 && (_data$jsmChatConversa5 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa5 !== void 0 && _data$jsmChatConversa5.isReplyPending),
        isConversationExpired: !!(data !== null && data !== void 0 && (_data$jsmChatConversa6 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa6 !== void 0 && _data$jsmChatConversa6.isConversationExpired),
        aiAnswerStatus: data === null || data === void 0 || (_data$jsmChatConversa7 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa7 === void 0 ? void 0 : _data$jsmChatConversa7.aiAnswerStatus,
        isConversationClosed: !!(data !== null && data !== void 0 && (_data$jsmChatConversa8 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa8 !== void 0 && _data$jsmChatConversa8.isConversationClosed),
        draftMessage: data === null || data === void 0 || (_data$jsmChatConversa9 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa9 === void 0 ? void 0 : _data$jsmChatConversa9.draftMessage,
        disableInput: !!(data !== null && data !== void 0 && (_data$jsmChatConversa0 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa0 !== void 0 && _data$jsmChatConversa0.disableInput),
        subscriptionId: data === null || data === void 0 || (_data$jsmChatConversa1 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa1 === void 0 ? void 0 : _data$jsmChatConversa1.subscriptionId,
        subscriptionTriggered: !!(data !== null && data !== void 0 && (_data$jsmChatConversa10 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa10 !== void 0 && _data$jsmChatConversa10.subscriptionTriggered),
        subscriptionStatus: (data === null || data === void 0 || (_data$jsmChatConversa11 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa11 === void 0 ? void 0 : _data$jsmChatConversa11.subscriptionStatus) ?? 'NONE'
    };
};

});
parcelRegister("gj6SG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c03ed20f8d71d6e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ed135da50fd0b9a2ac8dd02369b4b6cd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c03ed20f8d71d6e7$var$node = function() {
    var v0 = [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "concreteType": "JsmChatConversationMeta",
                    "kind": "LinkedField",
                    "name": "jsmChatConversationMeta",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "conversationId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "conversationContextAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "workspaceAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "connectionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReplyPending"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isConversationExpired"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "aiAnswerStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isConversationClosed"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "draftMessage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "disableInput"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionTriggered"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionStatus"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "omnichannelMetaQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "omnichannelMetaQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "9615b9f4fbe1d3c4564d22bfc3ed4951",
            "id": null,
            "metadata": {},
            "name": "omnichannelMetaQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c03ed20f8d71d6e7$var$node.hash = "96778225e661ec1b102bb65714d88315";
var $c03ed20f8d71d6e7$export$2e2bcd8739ae039 = $c03ed20f8d71d6e7$var$node;

});


parcelRegister("32O9g", function(module, exports) {
$parcel$export(module.exports, "omnichannelGetConversationExperience", () => $c804a905422b3a4d$export$3ca91a525bd30f3f);

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $c804a905422b3a4d$var$omnichannelGetConversationExperienceId = 'service-management.help-center.omnichannel.get-conversation';
const $c804a905422b3a4d$export$3ca91a525bd30f3f = new (0, $ghwxF.UFOExperience)($c804a905422b3a4d$var$omnichannelGetConversationExperienceId, {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("cNzk5", function(module, exports) {
$parcel$export(module.exports, "SearchPromptPopup", () => $d2bcc2b1124fc80a$export$392e007cdca1b718);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
var $3FFzY = parcelRequire("3FFzY");
var $1ZbH0 = parcelRequire("1ZbH0");

const $d2bcc2b1124fc80a$export$48d2544cca703af5 = (0, $fGOkV.lazy)(()=>(parcelRequire("6pUHP")).then((module)=>module.SearchPromptPopup), {
    moduleId: "./src/view/search/search-prompt-popup/search-prompt-popup.tsx"
});
const $d2bcc2b1124fc80a$export$392e007cdca1b718 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, props.trigger({
            ref: null,
            'aria-expanded': false,
            'aria-haspopup': false
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1ZbH0.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($d2bcc2b1124fc80a$export$48d2544cca703af5, props)));
};

});
parcelRegister("6pUHP", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("e6pqN").then(()=>parcelRequire('8iQHm'));

});


parcelRegister("9fvLZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $eefefb11246d374d$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $eefefb11246d374d$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    clearLabel: {
        defaultMessage: 'Reset search',
        description: 'Label for icon that clears the search term',
        id: 'search.input.clear'
    },
    inputAriaLabel: {
        defaultMessage: 'Question or search terms',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.ai'
    },
    inputPlaceholder: {
        defaultMessage: 'Ask a question or search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputAriaLabelNoAI: {
        defaultMessage: 'Search for information',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.no-ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputPlaceholderNoAI: {
        defaultMessage: 'Search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.no-ai'
    },
    askTheVirtualServiceAgent: {
        defaultMessage: 'Ask the virtual service agent',
        description: 'Hint to the user to initiate the virtual service agent conversation',
        id: 'search.input.placeholder.ai.ask-the-virtual-service-agent'
    },
    enter: {
        defaultMessage: 'Enter',
        description: 'Enter key from the keyboard',
        id: 'search.see.search.results.key.enter.non-final'
    },
    search: {
        defaultMessage: 'Search',
        description: 'Hint to the user to press enter to go to search results page',
        id: 'search.input.hint'
    },
    ariaDescription: {
        defaultMessage: 'Typing letters in the search input updates the search results in below data table',
        description: 'description for screen reader users when they focus on the search bar ',
        id: 'search.input.aria-description'
    }
});

});





parcelRegister("Gx7Pc", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsHeaderLink", () => $8b4194eea4d7a374$export$45f0a19e0c7c461b);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $8rTkC = parcelRequire("8rTkC");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $bSyu3 = parcelRequire("bSyu3");

var $bAdLA = parcelRequire("bAdLA");

var $lpRGa = parcelRequire("lpRGa");

var $2RbtH = parcelRequire("2RbtH");
const $8b4194eea4d7a374$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getHelpCenterTopBarTextColor), (primaryColor)=>({
        primaryColor: primaryColor
    }));
const $8b4194eea4d7a374$var$CsmRequestsHeaderLinkDumb = ({ primaryColor: primaryColor })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { push: push, baseUrl: baseUrl } = (0, $lpRGa.useLinkPush)();
    const href = baseUrl + (0, $8rTkC.RoutePath).CSM_REQUESTS_LIST_PATH;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bSyu3.default), {
        shape: "circle",
        href: href,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("span", {
                style: {
                    color: primaryColor
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAdLA))), iconProps)),
        label: formatMessage((0, $2RbtH.default).requests),
        onClick: (event)=>{
            push((0, $8rTkC.RoutePath).CSM_REQUESTS_LIST_PATH, event);
        }
    });
};
const $8b4194eea4d7a374$export$45f0a19e0c7c461b = (0, $jvoWT.default)($8b4194eea4d7a374$var$selector, {})($8b4194eea4d7a374$var$CsmRequestsHeaderLinkDumb);

});
parcelRegister("bSyu3", function(module, exports) {
$parcel$export(module.exports, "default", () => $eabfae300b439706$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.37.1 */ /* link.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6NJAV = parcelRequire("6NJAV");

var $klxUK = parcelRequire("klxUK");

var $d4WRD = parcelRequire("d4WRD");

var $e6Qdr = parcelRequire("e6Qdr");

var $hIZ30 = parcelRequire("hIZ30");

var $ea6bZ = parcelRequire("ea6bZ");

var $dojiU = parcelRequire("dojiU");

var $6ZVn7 = parcelRequire("6ZVn7");

var $ko9LV = parcelRequire("ko9LV");
const $eabfae300b439706$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhkby5v _syaz1gmx _aetrglyw _irr3by5v _30l31gmx _1di6by5v _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko1rr0"
};
const $eabfae300b439706$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $eabfae300b439706$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $eabfae300b439706$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $eabfae300b439706$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $eabfae300b439706$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $eabfae300b439706$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $8P7DW.useRef)(null);
    (0, $d4WRD.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ea6bZ.default), {
        content: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) ?? label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $hIZ30.default), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: (e)=>{
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: (e)=>{
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: (e)=>{
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: (e)=>{
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: (e)=>{
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    var _triggerProps$onClick;
                    onClick === null || onClick === void 0 || onClick(event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: (0, $klxUK.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $6NJAV.cx)($eabfae300b439706$var$styles.base, (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $eabfae300b439706$var$styles.baseT26Shape, appearance === 'default' && $eabfae300b439706$var$defaultStyles.root, appearance === 'primary' && $eabfae300b439706$var$primaryStyles.root, appearance === 'discovery' && $eabfae300b439706$var$discoveryStyles.root, appearance === 'subtle' && $eabfae300b439706$var$subtleStyles.root, $eabfae300b439706$var$styles.linkDecorationUnset, isSelected && $eabfae300b439706$var$selectedStyles.root, isSelected && appearance === 'discovery' && $eabfae300b439706$var$selectedStyles.discovery, isDisabled && $eabfae300b439706$var$styles.disabled, $eabfae300b439706$var$styles.iconButton, spacing === 'compact' && $eabfae300b439706$var$styles.spacingCompact, shape === 'circle' && $eabfae300b439706$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6ZVn7.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ko9LV.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hIZ30.default), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $klxUK.default)([
            localRef,
            ref
        ]),
        xcss: (0, $6NJAV.cx)($eabfae300b439706$var$styles.base, (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $eabfae300b439706$var$styles.baseT26Shape, appearance === 'default' && $eabfae300b439706$var$defaultStyles.root, appearance === 'primary' && $eabfae300b439706$var$primaryStyles.root, appearance === 'discovery' && $eabfae300b439706$var$discoveryStyles.root, appearance === 'subtle' && $eabfae300b439706$var$subtleStyles.root, $eabfae300b439706$var$styles.linkDecorationUnset, isSelected && $eabfae300b439706$var$selectedStyles.root, isSelected && appearance === 'discovery' && $eabfae300b439706$var$selectedStyles.discovery, isDisabled && $eabfae300b439706$var$styles.disabled, $eabfae300b439706$var$styles.iconButton, spacing === 'compact' && $eabfae300b439706$var$styles.spacingCompact, shape === 'circle' && $eabfae300b439706$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6ZVn7.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ko9LV.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                    children: label
                })
            ]
        })
    });
};
// Workarounds to support generic types with forwardRef + memo
const $eabfae300b439706$var$WithRef = /*#__PURE__*/ (0, $8P7DW.forwardRef)($eabfae300b439706$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $eabfae300b439706$var$LinkIconButton = /*#__PURE__*/ (0, $8P7DW.memo)($eabfae300b439706$var$WithRef);
var $eabfae300b439706$export$2e2bcd8739ae039 = $eabfae300b439706$var$LinkIconButton;

});

parcelRegister("bAdLA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e354977285efce08ec10c33c7aa547f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86edbc3974ec60d4$var$_react = $86edbc3974ec60d4$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $86edbc3974ec60d4$var$_baseNew = $86edbc3974ec60d4$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $86edbc3974ec60d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86edbc3974ec60d4$var$InboxIcon = (props)=>/*#__PURE__*/ $86edbc3974ec60d4$var$_react.default.createElement($86edbc3974ec60d4$var$_baseNew.default, Object.assign({
        name: "InboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$86edbc3974ec60d4$var$InboxIcon.displayName = 'InboxIcon';
var $86edbc3974ec60d4$var$_default = module.exports.default = $86edbc3974ec60d4$var$InboxIcon;

});

parcelRegister("lpRGa", function(module, exports) {
$parcel$export(module.exports, "useLinkPush", () => $5bbd550d5653f791$export$52eec4f7709b743e);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");

var $MmGmU = parcelRequire("MmGmU");

var $iziiq = parcelRequire("iziiq");

var $hrPHR = parcelRequire("hrPHR");
const $5bbd550d5653f791$export$52eec4f7709b743e = ()=>{
    var _env$baseUrl;
    const env = (0, $hrPHR.getEnv)();
    const { push: push } = (0, $dKPjT.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const linkPush = (0, $8P7DW.useCallback)((targetUrl, event, analyticsAttributes)=>{
        if (analyticsAttributes) createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            analyticsType: (0, $iziiq.UI_EVENT_TYPE),
            ...analyticsAttributes
        }).fire();
        if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        push(targetUrl);
    }, [
        push,
        createAnalyticsEvent
    ]);
    return {
        push: linkPush,
        baseUrl: (_env$baseUrl = env.baseUrl) === null || _env$baseUrl === void 0 ? void 0 : _env$baseUrl.replace(/\/+$/, '')
    };
};

});

parcelRegister("2RbtH", function(module, exports) {
$parcel$export(module.exports, "default", () => $69b0d4dff973a340$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $69b0d4dff973a340$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    requests: {
        id: 'csm-requests-header-link.requests',
        defaultMessage: 'Requests',
        description: 'Link to the requests list page'
    }
});

});


parcelRegister("eem3A", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuV2", () => (parcelRequire("59NqE")).default);
parcelRequire("mVU7b");
var $59NqE = parcelRequire("59NqE");

});
parcelRegister("mVU7b", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuV2", () => (parcelRequire("59NqE")).default);

var $59NqE = parcelRequire("59NqE");

});
parcelRegister("59NqE", function(module, exports) {
$parcel$export(module.exports, "default", () => $dabaace2e84c0ca9$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("e4veD");
var $h8NEF = parcelRequire("h8NEF");

var $TPT2R = parcelRequire("TPT2R");

var $hJJMO = parcelRequire("hJJMO");

var $dMqdi = parcelRequire("dMqdi");

var $eD321 = parcelRequire("eD321");

var $aw0dO = parcelRequire("aw0dO");

var $j20Mj = parcelRequire("j20Mj");

var $kSg9e = parcelRequire("kSg9e");

var $1E402 = parcelRequire("1E402");

var $ktLIP = parcelRequire("ktLIP");

var $iyMX3 = parcelRequire("iyMX3");
parcelRequire("6pzmF");
var $9Cd6D = parcelRequire("9Cd6D");
const $dabaace2e84c0ca9$var$getCustomMenuLinksProps = (state)=>{
    const customMenuLinks = (0, $j20Mj.getCustomMenuLinks)(state);
    return customMenuLinks.map((menuLink)=>{
        return {
            id: menuLink.id,
            key: menuLink.key,
            label: menuLink.label,
            href: menuLink.href,
            styleClass: menuLink.styleClass
        };
    });
};
const $dabaace2e84c0ca9$var$selector = (0, $ehscL.createSelector)((state)=>{
    var _getPortalAnnouncemen;
    const portalId = (0, $TPT2R.getPortalId)(state);
    const routeName = (0, $TPT2R.getRoutename)(state);
    const portal = {
        id: portalId,
        name: (0, $eD321.getName)(state, portalId),
        canEditAnnouncement: Boolean((_getPortalAnnouncemen = (0, $eD321.getPortalAnnouncement)(state, portalId)) === null || _getPortalAnnouncemen === void 0 ? void 0 : _getPortalAnnouncemen.canEditAnnouncement),
        isProjectAdmin: Boolean((0, $eD321.getCanAdministerProject)(state, portalId)),
        isProjectSimplified: Boolean((0, $eD321.getIsProjectSimplified)(state, portalId))
    };
    const areCustomerServiceSettingsLinksAvailable = (0, $hJJMO.getHelpCenterType)(state) === (0, $iyMX3.CUSTOMER_SERVICE_HELP_CENTER_TYPE) && !!(0, $hJJMO.getHoistedProjectKey)(state);
    return {
        portal: portal,
        routeName: routeName,
        areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable,
        avatarSrc: (0, $j20Mj.getAvatarSrc)(state),
        displayName: (0, $j20Mj.getDisplayName)(state),
        email: (0, $j20Mj.getEmail)(state),
        customMenuLinks: $dabaace2e84c0ca9$var$getCustomMenuLinksProps(state),
        canAdministerJIRA: (0, $j20Mj.getCanAdministerJIRA)(state),
        canCustomiseHelpCenter: (0, $dMqdi.getCanCustomize)(state),
        pendingApprovalCount: (0, $kSg9e.getUserRequestsCounts)(state).pendingApprovalCount,
        myRequestCount: (0, $kSg9e.getUserRequestsCounts)(state).myRequestCount,
        defaultColumnSettings: (0, $aw0dO.getRequestsColumnSettings)(state),
        approvalCount: (0, $kSg9e.getUserRequestsCounts)(state).approvalCount,
        jsmAIConfigEnabled: (0, $hJJMO.getJsmAIConfigEnabled)(state),
        hoistedProjectKey: (0, $hJJMO.getHoistedProjectKey)(state),
        jiraDisplayUrl: (0, $hJJMO.getJiraDisplayUrl)(state),
        hasSiteAdministerAccess: (0, $j20Mj.getHasSiteAdministerAccess)(state)
    };
}, ({ portal: portal, areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable, avatarSrc: avatarSrc, displayName: displayName, email: email, customMenuLinks: customMenuLinks, canAdministerJIRA: canAdministerJIRA, canCustomiseHelpCenter: canCustomiseHelpCenter, routeName: routeName, defaultColumnSettings: defaultColumnSettings, pendingApprovalCount: pendingApprovalCount, myRequestCount: myRequestCount, approvalCount: approvalCount, jsmAIConfigEnabled: jsmAIConfigEnabled, hoistedProjectKey: hoistedProjectKey, jiraDisplayUrl: jiraDisplayUrl, hasSiteAdministerAccess: hasSiteAdministerAccess })=>({
        portal: portal,
        routeName: routeName,
        areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable,
        avatarSrc: avatarSrc,
        displayName: displayName,
        email: email,
        customMenuLinks: customMenuLinks,
        canAdministerJIRA: canAdministerJIRA,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        pendingApprovalCount: pendingApprovalCount,
        approvalCount: approvalCount,
        defaultColumnSettings: defaultColumnSettings,
        myRequestCount: myRequestCount,
        jsmAIConfigEnabled: jsmAIConfigEnabled,
        hoistedProjectKey: hoistedProjectKey,
        jiraDisplayUrl: jiraDisplayUrl,
        hasSiteAdministerAccess: hasSiteAdministerAccess
    }));
var $dabaace2e84c0ca9$export$2e2bcd8739ae039 = (0, $jvoWT.default)($dabaace2e84c0ca9$var$selector, {
    onLogoutClick: (0, $h8NEF.logOutAction),
    openHelpCenterCustomizationSidebar: ()=>(0, $1E402.editingHelpCenter)(true),
    openRequestListCustomizationSidebar: ()=>(0, $ktLIP.customizingRequestListColumn)(true)
})((0, $9Cd6D.default));

});
parcelRegister("e4veD", function(module, exports) {
$parcel$export(module.exports, "fetchCategoriesAction", () => (parcelRequire("jNLTF")).fetchCategoriesAction);
$parcel$export(module.exports, "fetchHelpCenterAction", () => (parcelRequire("f8ImP")).fetchHelpCenterAction);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => (parcelRequire("f8ImP")).fetchHelpCenterBrandingAction);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => (parcelRequire("3QRuE")).fetchOrganisationsModelAction);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => (parcelRequire("3E63q")).fetchUserRequestsCountsAction);
$parcel$export(module.exports, "logOutAction", () => (parcelRequire("h8NEF")).logOutAction);
parcelRequire("eJvuf");

});
parcelRegister("eJvuf", function(module, exports) {
$parcel$export(module.exports, "fetchHelpCenterAction", () => (parcelRequire("f8ImP")).fetchHelpCenterAction);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => (parcelRequire("f8ImP")).fetchHelpCenterBrandingAction);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => (parcelRequire("3QRuE")).fetchOrganisationsModelAction);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => (parcelRequire("3E63q")).fetchUserRequestsCountsAction);
$parcel$export(module.exports, "fetchCategoriesAction", () => (parcelRequire("jNLTF")).fetchCategoriesAction);
$parcel$export(module.exports, "logOutAction", () => (parcelRequire("h8NEF")).logOutAction);

var $f8ImP = parcelRequire("f8ImP");

var $3QRuE = parcelRequire("3QRuE");

var $3E63q = parcelRequire("3E63q");

var $jNLTF = parcelRequire("jNLTF");

var $h8NEF = parcelRequire("h8NEF");

});
parcelRegister("f8ImP", function(module, exports) {
$parcel$export(module.exports, "fetchHelpCenterAction", () => $c071f13087c63328$export$61e2f9e78cb604c7);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => $c071f13087c63328$export$42cfcdfd4935cc23);

var $4jNsO = parcelRequire("4jNsO");
const $c071f13087c63328$export$5586a78b777598b9 = 'epic.model.FETCH_HELP_CENTER_MODEL';
const $c071f13087c63328$export$d8cc5374b8afc050 = 'epic.model.FETCH_HELP_CENTER_BRANDING_MODEL';
const $c071f13087c63328$export$61e2f9e78cb604c7 = (0, $4jNsO.buildModelsActionCreator)($c071f13087c63328$export$5586a78b777598b9, 'sharedPortal');
const $c071f13087c63328$export$42cfcdfd4935cc23 = (0, $4jNsO.buildModelsActionCreator)($c071f13087c63328$export$d8cc5374b8afc050, 'helpCenterBranding');

});
parcelRegister("4jNsO", function(module, exports) {
$parcel$export(module.exports, "buildModelsActionCreator", () => $50587cf0594714c8$export$9f8a38b5e77ac29);
const $50587cf0594714c8$export$9f8a38b5e77ac29 = (actionType, type)=>(params = {}, options)=>({
            ...options ? {
                options: options
            } : {},
            type: actionType,
            payload: {
                type: type,
                params: params
            }
        });

});


parcelRegister("3QRuE", function(module, exports) {
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => $d9ebc199421ab0ca$export$cbdd5d7a098d34a2);

var $4jNsO = parcelRequire("4jNsO");
const $d9ebc199421ab0ca$export$b60557155cf3c6c0 = 'epic.model.FETCH_ORGANISATIONS_MODEL';
const $d9ebc199421ab0ca$export$cbdd5d7a098d34a2 = (0, $4jNsO.buildModelsActionCreator)($d9ebc199421ab0ca$export$b60557155cf3c6c0, 'organisations');

});

parcelRegister("3E63q", function(module, exports) {
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => $9e1703bbe6538c6b$export$71172847a48a08a6);

var $4jNsO = parcelRequire("4jNsO");
const $9e1703bbe6538c6b$export$dfecf710cdf030b1 = 'epic.model.FETCH_USER_REQUESTS_COUNTS_MODEL';
const $9e1703bbe6538c6b$export$71172847a48a08a6 = (0, $4jNsO.buildModelsActionCreator)($9e1703bbe6538c6b$export$dfecf710cdf030b1, 'userRequestsCounts');

});

parcelRegister("jNLTF", function(module, exports) {
$parcel$export(module.exports, "fetchCategoriesAction", () => $feb6c37159c70279$export$10813fa84276d50);
const $feb6c37159c70279$export$cce9a7031b65f96c = 'epic.model.FETCH_KB_CATEGORIES';
const $feb6c37159c70279$export$10813fa84276d50 = (projectId, portalId, meta)=>({
        type: $feb6c37159c70279$export$cce9a7031b65f96c,
        payload: {
            projectId: projectId,
            portalId: portalId,
            meta: meta
        }
    });

});

parcelRegister("h8NEF", function(module, exports) {
$parcel$export(module.exports, "logOutAction", () => $0584e01c277f7343$export$1a3865346be34527);
const $0584e01c277f7343$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
const $0584e01c277f7343$export$1a3865346be34527 = ()=>{
    return {
        type: $0584e01c277f7343$export$cb307dad255adf47
    };
};

});



parcelRegister("TPT2R", function(module, exports) {
$parcel$export(module.exports, "getPortalId", () => $9141b066214d8b85$export$79c9b12a0a57147a);
$parcel$export(module.exports, "getRoutename", () => $9141b066214d8b85$export$6c570a1091322ad4);
const $9141b066214d8b85$export$f71e6ac2c1d88be0 = (state)=>{
    var _state$ui, _state$ui2, _state$ui3;
    return ((_state$ui = state.ui) === null || _state$ui === void 0 ? void 0 : _state$ui.context.portalId) !== undefined && ((_state$ui2 = state.ui) === null || _state$ui2 === void 0 ? void 0 : _state$ui2.context.portalId) !== null && !isNaN(((_state$ui3 = state.ui) === null || _state$ui3 === void 0 ? void 0 : _state$ui3.context.portalId) || NaN);
};
const $9141b066214d8b85$export$79c9b12a0a57147a = (state)=>{
    var _state$ui4;
    if (!$9141b066214d8b85$export$f71e6ac2c1d88be0(state)) return undefined;
    return (_state$ui4 = state.ui) === null || _state$ui4 === void 0 ? void 0 : _state$ui4.context.portalId;
};
const $9141b066214d8b85$export$6c570a1091322ad4 = (state)=>{
    var _state$ui5;
    return (_state$ui5 = state.ui) === null || _state$ui5 === void 0 ? void 0 : _state$ui5.context.routeName;
};

});

parcelRegister("hJJMO", function(module, exports) {
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $dd7a3eabb6a94e36$export$a90992f5204fc247);
$parcel$export(module.exports, "getHelpCenterType", () => $dd7a3eabb6a94e36$export$7972e6e7445f0142);
$parcel$export(module.exports, "getHoistedProjectKey", () => $dd7a3eabb6a94e36$export$3b0fd0e16a94f75);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $dd7a3eabb6a94e36$export$9679fa5312e1354b);
const $dd7a3eabb6a94e36$export$a90992f5204fc247 = (state)=>{
    var _state$persisted$env$;
    return !!((_state$persisted$env$ = state.persisted.env.featuredValues) !== null && _state$persisted$env$ !== void 0 && _state$persisted$env$.jsmAiConfigEnabled);
};
const $dd7a3eabb6a94e36$export$7972e6e7445f0142 = (state)=>state.persisted.env.helpCenterType;
const $dd7a3eabb6a94e36$export$3b0fd0e16a94f75 = (state)=>state.persisted.env.hoistedProjectKey;
const $dd7a3eabb6a94e36$export$9679fa5312e1354b = (state)=>state.persisted.env.jiraDisplayUrl;

});

parcelRegister("dMqdi", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterBanner", () => $6273c11662c13ea5$export$3b3c747bea011f3c);
$parcel$export(module.exports, "getThemeColor", () => $6273c11662c13ea5$export$e22c5d06d177c3fa);
$parcel$export(module.exports, "getSharedPortalName", () => $6273c11662c13ea5$export$bef10d4690ba4a95);
$parcel$export(module.exports, "getCanCustomize", () => $6273c11662c13ea5$export$eb9b5e885139dc39);

var $1We2B = parcelRequire("1We2B");

var $j20Mj = parcelRequire("j20Mj");
const $6273c11662c13ea5$export$85757b7e55ef3c9f = (state)=>{
    var _state$ui;
    return (0, $1We2B.mergeWith)({}, state.persisted.helpCenter, (_state$ui = state.ui) === null || _state$ui === void 0 ? void 0 : _state$ui.helpCenterPreview, // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
    // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
    (_, srcValue)=>{
        if (srcValue === undefined) return null;
        // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
        return undefined;
    });
};
const $6273c11662c13ea5$export$3b3c747bea011f3c = (state)=>{
    return $6273c11662c13ea5$export$85757b7e55ef3c9f(state).helpCenterBannerUrl;
};
const $6273c11662c13ea5$export$e22c5d06d177c3fa = (state)=>{
    return $6273c11662c13ea5$export$85757b7e55ef3c9f(state).themeColor;
};
const $6273c11662c13ea5$var$getTranslation = (state, language)=>$6273c11662c13ea5$export$85757b7e55ef3c9f(state).translations[language];
const $6273c11662c13ea5$export$bef10d4690ba4a95 = (state)=>{
    const userLocale = (0, $j20Mj.getLocale)(state);
    const translation = userLocale && $6273c11662c13ea5$var$getTranslation(state, userLocale);
    if (translation && translation.sharedPortalName) return translation.sharedPortalName;
    return $6273c11662c13ea5$export$85757b7e55ef3c9f(state).sharedPortalName;
};
const $6273c11662c13ea5$export$eb9b5e885139dc39 = (state)=>{
    return $6273c11662c13ea5$export$85757b7e55ef3c9f(state).canCustomizeHelpCenter;
};

});

parcelRegister("eD321", function(module, exports) {
$parcel$export(module.exports, "getPortalOrError", () => $608948ed16101feb$export$aa66ead34639a340);
$parcel$export(module.exports, "getProjectId", () => $608948ed16101feb$export$89040d072f281f85);
$parcel$export(module.exports, "getName", () => $608948ed16101feb$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getPortalAnnouncement", () => $608948ed16101feb$export$78e1a2ab89c0908b);
$parcel$export(module.exports, "getCanAdministerProject", () => $608948ed16101feb$export$2cdfb65eda98a530);
$parcel$export(module.exports, "getIsProjectSimplified", () => $608948ed16101feb$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getCategories", () => $608948ed16101feb$export$7a0f33e8df10bd94);

var $1We2B = parcelRequire("1We2B");
const $608948ed16101feb$export$baa53a1870be4bc5 = {
    __NOT_SUPPORTED__: true
};
const $608948ed16101feb$export$aa66ead34639a340 = (state, portalId)=>{
    if ((0, $1We2B.isNil)(portalId)) return undefined;
    return state.persisted.portals[portalId];
};
const $608948ed16101feb$export$e16cb606b6ef4a60 = (state, portalId)=>{
    const portal = $608948ed16101feb$export$aa66ead34639a340(state, portalId);
    if (!portal || 'error' in portal) return undefined;
    return portal;
};
const $608948ed16101feb$export$89040d072f281f85 = (state, portalId)=>{
    if ((0, $1We2B.isNil)(portalId)) return undefined;
    const portal = $608948ed16101feb$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.projectId : undefined;
};
const $608948ed16101feb$export$7d9f7e9c1c02b41e = (state, portalId)=>{
    const portal = $608948ed16101feb$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.name : undefined;
};
const $608948ed16101feb$export$78e1a2ab89c0908b = (state, portalId)=>{
    const portal = $608948ed16101feb$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.portalAnnouncement : undefined;
};
const $608948ed16101feb$export$2cdfb65eda98a530 = (state, portalId)=>{
    const portalAnnouncement = $608948ed16101feb$export$78e1a2ab89c0908b(state, portalId);
    return portalAnnouncement ? portalAnnouncement.canAdministerProject : false;
};
const $608948ed16101feb$export$5bde43fbba6edf90 = (state, portalId)=>{
    const portal = $608948ed16101feb$export$e16cb606b6ef4a60(state, portalId);
    return portal ? !!portal.isProjectSimplified : false;
};
const $608948ed16101feb$export$7a0f33e8df10bd94 = (state, portalId)=>{
    const portal = $608948ed16101feb$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        return 'error' in categoryOrError ? [] : categoryOrError;
    }
    return undefined;
};

});

parcelRegister("aw0dO", function(module, exports) {
$parcel$export(module.exports, "getRequestsColumnSettings", () => $6eed4d78551fdf1b$export$a5e47ac90fcdaee8);
/**
 * Request column settings selectors for accessing column configuration.
 * These selectors are designed to avoid cyclic dependencies.
 */ /**
 * Get the full requests column settings state (includes columns and statusFilter).
 */ const $6eed4d78551fdf1b$var$getRequestsColumnSettingsState = (state)=>{
    return state.persisted.requestsColumnSettings || {
        columns: [],
        statusFilter: undefined
    };
};
const $6eed4d78551fdf1b$export$a5e47ac90fcdaee8 = (state)=>{
    const settingsState = $6eed4d78551fdf1b$var$getRequestsColumnSettingsState(state);
    return settingsState.columns || [];
};

});

parcelRegister("kSg9e", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => $ae7c34d0331c88cc$export$be73da9c8fdefffb);
const $ae7c34d0331c88cc$export$be73da9c8fdefffb = (state)=>{
    return state.persisted.userRequestsCounts;
};

});

parcelRegister("iyMX3", function(module, exports) {
$parcel$export(module.exports, "CUSTOMER_SERVICE_HELP_CENTER_TYPE", () => $dd5306ac53e7f34b$export$fc172486e4a9f1fa);
const $dd5306ac53e7f34b$export$fc172486e4a9f1fa = 'CUSTOMER_SERVICE';

});

parcelRegister("6pzmF", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuDumbV2", () => (parcelRequire("9Cd6D")).default);

var $9Cd6D = parcelRequire("9Cd6D");

});
parcelRegister("9Cd6D", function(module, exports) {
$parcel$export(module.exports, "default", () => $502eb40fd88fd5e4$export$2e2bcd8739ae039);
/* avatar-menu-dumb-v2.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
var $77UGK = parcelRequire("77UGK");

var $1pfMV = parcelRequire("1pfMV");

var $8y05I = parcelRequire("8y05I");
var $cS6Xr = parcelRequire("cS6Xr");

var $4QM8d = parcelRequire("4QM8d");

var $ft9Vs = parcelRequire("ft9Vs");

var $Vw3JS = parcelRequire("Vw3JS");

var $6ecLQ = parcelRequire("6ecLQ");

var $8rTkC = parcelRequire("8rTkC");

var $kM5Oy = parcelRequire("kM5Oy");

var $edC7N = parcelRequire("edC7N");

var $HGACo = parcelRequire("HGACo");

var $iucai = parcelRequire("iucai");

var $7ex17 = parcelRequire("7ex17");

var $dW1Qd = parcelRequire("dW1Qd");

var $eVq2A = parcelRequire("eVq2A");

var $jByYr = parcelRequire("jByYr");

var $iQzn3 = parcelRequire("iQzn3");

var $lqUyf = parcelRequire("lqUyf");

var $4cxV2 = parcelRequire("4cxV2");

var $k1tWg = parcelRequire("k1tWg");

var $1P98q = parcelRequire("1P98q");

var $80D2y = parcelRequire("80D2y");

var $l4cjO = parcelRequire("l4cjO");
var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");

var $8gu7I = parcelRequire("8gu7I");
var $MmGmU = parcelRequire("MmGmU");

var $2pAfo = parcelRequire("2pAfo");

var $hIXV0 = parcelRequire("hIXV0");

var $izQyW = parcelRequire("izQyW");

var $1EFS8 = parcelRequire("1EFS8");

var $krExN = parcelRequire("krExN");

var $eT7pr = parcelRequire("eT7pr");

var $lkatq = parcelRequire("lkatq");
var $rV4PT = parcelRequire("rV4PT");
var $3rCJZ = parcelRequire("3rCJZ");
var $7qJSw = parcelRequire("7qJSw");

var $33zHl = parcelRequire("33zHl");

var $5JQIe = parcelRequire("5JQIe");
var $1P5py = parcelRequire("1P5py");
var $4MINV = parcelRequire("4MINV");

var $c2L1U = parcelRequire("c2L1U");

var $6Hfjm = parcelRequire("6Hfjm");
var $galRw = parcelRequire("galRw");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $jbqt2 = parcelRequire("jbqt2");

var $8vv1J = parcelRequire("8vv1J");

var $iziiq = parcelRequire("iziiq");

var $cLmLE = parcelRequire("cLmLE");

var $1lG1b = parcelRequire("1lG1b");

var $81QBf = parcelRequire("81QBf");

var $i4z8R = parcelRequire("i4z8R");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $7FSs7 = parcelRequire("7FSs7");

var $fsZf3 = parcelRequire("fsZf3");

var $e2jLh = parcelRequire("e2jLh");

var $jsmb9 = parcelRequire("jsmb9");

var $7oVxX = parcelRequire("7oVxX");
parcelRequire("aaA3R");
var $tJpW6 = parcelRequire("tJpW6");

var $dfS0m = parcelRequire("dfS0m");
var $8y0tS = parcelRequire("8y0tS");
parcelRequire("gFqUR");
var $7tWhk = parcelRequire("7tWhk");

var $jQoUV = parcelRequire("jQoUV");

var $etUNo = parcelRequire("etUNo");

var $6IS8o = parcelRequire("6IS8o");

var $jtSmi = parcelRequire("jtSmi");

var $kYNPD = parcelRequire("kYNPD");

var $djZwh = parcelRequire("djZwh");

var $24wGE = parcelRequire("24wGE");

var $bvpLK = parcelRequire("bvpLK");
const $502eb40fd88fd5e4$export$c0b4c34c7506f4d = ()=>(0, $1EFS8.default).checkGate('jsm_help_center_one-click_rovo_agent');
const $502eb40fd88fd5e4$var$isAvatarMenuFocusVisibleStylesEnabled = ()=>(0, $1EFS8.default).checkGate('ff_a11y_hc_focus_indicator');
let $502eb40fd88fd5e4$var$multiHcDropdownQueryReference = null;
const $502eb40fd88fd5e4$export$e0ae4b37130667df = ({ onClose: onClose })=>{
    const { data: { extensionTitles: extensionTitles }, methods: { setExtensionToDisplay: onClick } } = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext((0, $dW1Qd.ForgeModalContext));
    const forgeActionLinkOnClick = (id, onClickApp)=>()=>{
            onClose('navBarForgeApp');
            return onClickApp(id);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, extensionTitles.map(({ id: id, title: title })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            id: id,
            key: `forge-title_${id}`,
            component: $502eb40fd88fd5e4$var$CustomButton,
            actionSubjectId: "navBarForgeApp",
            onClick: forgeActionLinkOnClick(id, onClick)
        }, title);
    }));
};
const $502eb40fd88fd5e4$var$menuBottomSection = (onClose, isHelpCenterManagementScreen, onLogoutClick)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), {
        hasSeparator: true
    }, isHelpCenterManagementScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        actionSubjectId: "navbarProfile",
        key: `bottom-menu-management-screen-navbarProfile`,
        component: $502eb40fd88fd5e4$var$CustomAnchor,
        href: '/servicedesk/customer/user/profile',
        onClick: ()=>onClose('navbarProfile'),
        "data-test-id": "profile-link",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).profile)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        key: `bottom-menu-navbarProfile`,
        component: $502eb40fd88fd5e4$var$CustomLink,
        to: '/user/profile',
        actionSubjectId: "navbarProfile",
        onClick: ()=>onClose('navbarProfile'),
        "data-test-id": "profile-link",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).profile)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: 'navbarLogout'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        component: $502eb40fd88fd5e4$var$CustomButton,
        actionSubjectId: "navbarLogout",
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": 'logout',
        onClick: onLogoutClick,
        "data-test-id": "logout-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).logout))));
};
const $502eb40fd88fd5e4$var$logoutLink = (onLogoutClick)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: 'navbarLogout'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        component: $502eb40fd88fd5e4$var$CustomButton,
        actionSubjectId: "navbarLogout",
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": 'logout',
        onClick: onLogoutClick,
        "data-test-id": "logout-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).logout))));
};
const $502eb40fd88fd5e4$export$a552d0e5a7a35aad = ({ customMenuLinks: customMenuLinks, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("span", {
        "data-test-id": "custom-menu-link"
    }, customMenuLinks.map((menuLink)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
            key: `custom-menu-link_${menuLink.key || ''}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            actionSubjectId: 'custom-menu-link',
            component: $502eb40fd88fd5e4$var$CustomAnchor,
            href: menuLink.href,
            onClick: ()=>onClose('custom-menu-link'),
            "data-test-id": "custom-menu-link",
            key: `custom-menu-link-id_${menuLink.id || ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menuLink.label))));
const $502eb40fd88fd5e4$var$buildCustomMenuLinks = (customMenuLinks, onClose)=>{
    return customMenuLinks.map((menuLink)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
            key: `build-custom-menu-link_${menuLink.key || ''}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            actionSubjectId: 'custom-menu-link',
            component: $502eb40fd88fd5e4$var$CustomAnchor,
            "data-test-id": "custom-menu-link",
            key: `custom-menu-link-id_${menuLink.id || ''}`,
            onClick: ()=>onClose('custom-menu-link'),
            href: menuLink.href,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menuLink.label)));
};
const $502eb40fd88fd5e4$var$TopMenu = (myRequestCount, onClose, pendingApprovalCount, approvalCount, isHelpCenterManagementScreen)=>{
    const customizeMenu = [
        {
            onClick: ()=>onClose('navbarUserRequests'),
            link: isHelpCenterManagementScreen ? '/servicedesk/customer/user/requests?reporter=all&statuses=open' : '/user/requests?reporter=all&statuses=open',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).requests),
            actionSubjectId: 'navbarUserRequests',
            iconAfter: myRequestCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ft9Vs.default), null, myRequestCount) : undefined,
            isVisible: !(0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType),
            dataTestId: 'requests-link'
        },
        {
            onClick: ()=>onClose('navbarUserApprovals'),
            link: isHelpCenterManagementScreen ? '/servicedesk/customer/user/approvals' : '/user/approvals',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).approvals),
            actionSubjectId: 'navbarUserApprovals',
            iconAfter: pendingApprovalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ft9Vs.default), null, pendingApprovalCount) : undefined,
            isVisible: approvalCount > 0 || pendingApprovalCount > 0,
            dataTestId: 'approvals-link'
        },
        {
            onClick: ()=>onClose('navbarProfile'),
            link: isHelpCenterManagementScreen ? '/servicedesk/customer/user/profile' : '/user/profile',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).profile),
            actionSubjectId: 'navbarProfile',
            isVisible: !(0, $HGACo.isHelpCenterNewDropdownEnabled)(),
            dataTestId: 'profile-link'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, isHelpCenterManagementScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            actionSubjectId: menu.actionSubjectId,
            key: `top-menu-management-screen_${menu.actionSubjectId}`,
            component: $502eb40fd88fd5e4$var$CustomAnchor,
            href: menu.link,
            onClick: menu.onClick,
            iconAfter: menu.iconAfter,
            "data-test-id": menu.dataTestId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            key: `top-menu_${menu.actionSubjectId}`,
            component: $502eb40fd88fd5e4$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            iconAfter: menu.iconAfter,
            "data-test-id": menu.dataTestId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
    }));
};
const $502eb40fd88fd5e4$var$RenderMultiHcDropdown = ({ setDescription: setDescription, setTitle: setTitle, setModalOpen: setModalOpen, showMultiHCChangeBoardingSpotlight: showMultiHCChangeBoardingSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const onCreateHcClick = ()=>{
        setTitle(formatMessage((0, $djZwh.default).onboardingTitleHCClick));
        setDescription(formatMessage((0, $djZwh.default).onboardingDescriptionCreateOrHcClickWithLink));
        setModalOpen(true);
    };
    const onHelpCenterClick = ()=>{
        setTitle(formatMessage((0, $djZwh.default).onboardingTitleHCClick));
        setDescription(formatMessage((0, $djZwh.default).onboardingDescriptionCreateOrHcClickWithLink));
        setModalOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $rV4PT.default), {
        id: "atlassian-navigation-hc-selection-dialog-heading"
    }, formatMessage((0, $djZwh.default).helpCenter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $502eb40fd88fd5e4$var$MultiHcDropdownContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jQoUV.MultiHcDropdown), {
        onCreateHcClick: onCreateHcClick,
        onHelpCenterClick: onHelpCenterClick,
        showMultiHCChangeBoardingSpotlight: showMultiHCChangeBoardingSpotlight,
        queryRef: $502eb40fd88fd5e4$var$multiHcDropdownQueryReference
    })));
};
const $502eb40fd88fd5e4$var$CustomMenuItems = ({ menu: menu })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        component: menu.component ?? $502eb40fd88fd5e4$var$CustomLink,
        to: menu.link,
        actionSubjectId: menu.actionSubjectId,
        onClick: menu.onClick,
        testId: menu.testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
            appearance: "new"
        }, formatMessage((0, $djZwh.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
            appearance: "new"
        }, formatMessage((0, $djZwh.default).newLozenge)), menu.isPremium && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
            appearance: "new"
        }, formatMessage((0, $djZwh.default).premiumLozenge)))
    }, menu.label), menu.actionSubjectId === 'createHelpCenter' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8vv1J.FireUIAnalytics), {
        action: "viewed",
        actionSubject: menu.actionSubjectId
    }));
};
const $502eb40fd88fd5e4$var$CustomPressable = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $galRw.default), {
        componentName: "link",
        xcss: $502eb40fd88fd5e4$var$customPressableStyles,
        ...rest
    }, children);
const $502eb40fd88fd5e4$var$EditPageLayoutWithPopUp = ({ menu: menu })=>{
    const [isOpen, setIsOpen] = (0, $8P7DW.useState)(false);
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const contentCallback = (0, $8P7DW.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $502eb40fd88fd5e4$var$pageLayoutPremiumPopUp
        }, menu.messageDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, formatMessage(menu.messageDescription)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
            data: {
                actionSubjectId: 'flexibleHelpCenterTryLink'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $izQyW.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($krExN))),
            appearance: "discovery",
            onClick: ()=>{
                createAnalyticsEvent({
                    actionSubjectId: 'flexibleHelpCenterTryLink',
                    action: 'clicked',
                    actionSubject: 'button',
                    analyticsType: (0, $iziiq.UI_EVENT_TYPE)
                }).fire();
                window.open((0, $jsmb9.getBillingUrl)([
                    'jira-servicedesk'
                ], (0, $jByYr.getCloudId)()), '_blank');
            }
        }, formatMessage((0, $djZwh.default).pageLayoutTryItNowButton)))));
    }, [
        createAnalyticsEvent,
        formatMessage,
        menu.messageDescription
    ]);
    const triggerCallback = (0, $8P7DW.useCallback)((triggerProps)=>{
        return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            ...triggerProps,
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') setIsOpen((state)=>!state);
            },
            onClick: ()=>{
                setIsOpen((state)=>!state);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$CustomMenuItems, {
            menu: {
                ...menu,
                onClick: (event)=>{
                    event.preventDefault();
                }
            }
        })));
    }, [
        menu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c2L1U.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left-start",
        content: contentCallback,
        trigger: triggerCallback
    });
};
const $502eb40fd88fd5e4$var$PremiumBenefitsModalRenderer = ({ menu: menu })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: (0, $8rTkC.ScreenName).HELP_CENTER,
        id: `help-center-${menu.pbmTouchpointId}`,
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $81QBf.PremiumBenefitModalTrigger), {
        cloudId: (0, $jByYr.getCloudId)(),
        product: "jira-service-management",
        variantId: "help-center-customization",
        touchpointId: menu.pbmTouchpointId,
        edition: (0, $hrPHR.getEnv)().edition ?? 'unknown'
    }, ({ ref: ref, props: triggerProps })=>// CustomItem doesn't forward testId to custom components, so we add it to the Box wrapper
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            ref: ref,
            ...triggerProps,
            testId: menu.testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
            data: {
                actionSubjectId: menu.actionSubjectId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$CustomMenuItems, {
            menu: {
                ...menu,
                component: $502eb40fd88fd5e4$var$CustomPressable
            }
        })))));
};
const $502eb40fd88fd5e4$var$ListItemWrapper = ({ children: children })=>{
    if ((0, $1EFS8.default).checkGate('ff_a11y_hc_list_markup')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        as: "li",
        xcss: $502eb40fd88fd5e4$var$listItemStyles
    }, children);
    return children;
};
const $502eb40fd88fd5e4$export$7ed443719af866bf = ({ customizeMenu: customizeMenu = [] })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [showVaReportingOnboardingSpotlight, setShowVaReportingOnboardingSpotlight] = (0, $8P7DW.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.isAnchor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            component: $502eb40fd88fd5e4$var$CustomAnchor,
            href: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
                appearance: "new"
            }, formatMessage((0, $djZwh.default).beta)),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
        if (menu.showSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$ListItemWrapper, {
            key: `customize-menu_spotlight_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lqUyf.default), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1P5py.default), {
                name: (0, $8rTkC.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
                key: `customize-menu_${menu.actionSubjectId}`,
                component: $502eb40fd88fd5e4$var$CustomLink,
                to: menu.link,
                actionSubjectId: menu.actionSubjectId,
                onClick: menu.onClick,
                testId: menu.testId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "cv-exclude-from-customisation",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
                    appearance: "new"
                }, formatMessage((0, $djZwh.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
                    appearance: "new"
                }, formatMessage((0, $djZwh.default).newLozenge)))
            }, menu.label))), showVaReportingOnboardingSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4MINV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kM5Oy.default), {
            messageId: (0, $8rTkC.EngagementMessages).ONBOARD_VA_REPORTING,
            key: (0, $8rTkC.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1P98q.VaOnboardingSpotlight), {
            setShowVaReportingOnboardingSpotlight: setShowVaReportingOnboardingSpotlight
        })))));
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$ListItemWrapper, {
            key: `customize-menu_custom_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(menu.customRenderer, {
            menu: menu
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            component: $502eb40fd88fd5e4$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
                appearance: "new"
            }, formatMessage((0, $djZwh.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
                appearance: "new"
            }, formatMessage((0, $djZwh.default).newLozenge))),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
    }));
};
const $502eb40fd88fd5e4$var$CustomizeLinks = (onClose, openHelpCenterCustomizationSidebar, canAdministerJIRA, routeName, basePath, areCustomerServiceSettingsLinksAvailable, showAvatarMenuItemsUpsells, hoistedProjectKey, jiraDisplayUrl, isServiceHub)=>{
    const isHomePage = routeName === 'help-center' || routeName === 'view-homepage';
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const isSmallScreen = window.innerWidth < (0, $k1tWg.sizes).xsmall;
    const customizeMenu = [
        {
            link: `${basePath}?customize=true&experience=login-announcement`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).signIn),
            actionSubjectId: 'navbarLoginAnnouncement',
            isVisible: isHomePage && canAdministerJIRA && !isSmallScreen && !(0, $HGACo.isHelpCenterNewDropdownEnabled)(),
            onClick: ()=>onClick('navbarLoginAnnouncement'),
            testId: 'login-announcement-link'
        },
        {
            link: `${basePath}?customize=true&experience=help-center-announcement`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).announcement),
            actionSubjectId: 'navbarAnnouncement',
            isVisible: isHomePage && !isSmallScreen && !(0, $HGACo.isHelpCenterNewDropdownEnabled)(),
            onClick: ()=>onClick('navbarAnnouncement'),
            testId: 'announcement-link'
        },
        {
            link: `${basePath}?customize=true&experience=theme`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).look),
            actionSubjectId: 'navbarLookAndFeel',
            isVisible: isHomePage && canAdministerJIRA && !(0, $HGACo.isHelpCenterNewDropdownEnabled)(),
            onClick: ()=>onClick('navbarLookAndFeel'),
            testId: 'look-and-feel-link'
        },
        {
            link: '/settings/portal-reorder',
            label: (0, $HGACo.isAdvancedCustomizationEditPageEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).topicsAndPortals) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).pageLayout),
            actionSubjectId: 'navbarPortalReorder',
            isVisible: isHomePage && canAdministerJIRA && !isSmallScreen && !(0, $HGACo.isHelpCenterNewDropdownEnabled)(),
            onClick: ()=>onClick('navbarPortalReorder'),
            testId: 'topics-link'
        },
        {
            link: '/edit',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).pageLayout),
            actionSubjectId: 'navbarHideAndReorder',
            isVisible: (0, $HGACo.isAdvancedCustomizationEditPageEnabled)() && isHomePage && canAdministerJIRA && !isSmallScreen && !(0, $HGACo.isHelpCenterNewDropdownEnabled)() && !(0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && showAvatarMenuItemsUpsells,
            onClick: ()=>onClick('navbarHideAndReorder'),
            testId: 'hide-and-reorder-link',
            customRenderer: (0, $hrPHR.getIsHCCustomizationEnabled)() ? undefined : $502eb40fd88fd5e4$var$EditPageLayoutWithPopUp,
            isBeta: true,
            messageDescription: (0, $djZwh.default).pageLayoutPremiumDescription
        }
    ];
    if ((0, $HGACo.isJsmCsMasterFlagEnabled)()) {
        const helpCenterId = (0, $cLmLE.HelpHelpCenterAri).parse((0, $jByYr.getHelpCenterAri)()).helpCenterId;
        const isVisible = areCustomerServiceSettingsLinksAvailable && !!jiraDisplayUrl && !!hoistedProjectKey && !!helpCenterId && (isHomePage || isServiceHub) && canAdministerJIRA;
        const additionalMenuItems = [
            {
                isVisible: isVisible,
                isAnchor: true,
                link: `${jiraDisplayUrl ?? ''}/jira/helpcenter/projects/${hoistedProjectKey ?? ''}/settings/${helpCenterId}/details`,
                label: (0, $HGACo.isJcsprojectTypeM3Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).customerHubSettings) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).helpCenterSettings),
                actionSubjectId: 'helpCenterSettings',
                testId: 'help-center-settings'
            }
        ];
        customizeMenu.push(...additionalMenuItems);
    }
    const onClick = (actionSubjectId)=>{
        onClose(actionSubjectId);
        openHelpCenterCustomizationSidebar();
    };
    const hideSection = ()=>customizeMenu.every((item)=>!item.isVisible);
    if (hideSection()) return null;
    return (0, $HGACo.isHelpCenterNewDropdownEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$export$7ed443719af866bf, {
        customizeMenu: customizeMenu
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$export$7ed443719af866bf, {
        customizeMenu: customizeMenu
    }));
};
const $502eb40fd88fd5e4$var$RenderHCSection = ({ setTitle: setTitle, setDescription: setDescription, setModalOpen: setModalOpen, onClick: onClick, showAvatarMenuItemsUpsells: showAvatarMenuItemsUpsells, hasSiteAdministerAccess: hasSiteAdministerAccess })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse((0, $jByYr.getHelpCenterAri)());
    const manageHelpCenterPagesCustomRenderer = (0, $8P7DW.useCallback)(()=>{
        if ((0, $hrPHR.getIsHCCustomizationEnabled)()) return undefined;
        if ((0, $fsZf3.isPremiumUpsellExperimentEnabled)({
            hasSiteAdministerAccess: hasSiteAdministerAccess,
            isHCCustomizationEnabled: (0, $hrPHR.getIsHCCustomizationEnabled)()
        })) return $502eb40fd88fd5e4$var$PremiumBenefitsModalRenderer;
        return $502eb40fd88fd5e4$var$EditPageLayoutWithPopUp;
    }, [
        hasSiteAdministerAccess
    ]);
    const customizeMenu = [
        {
            link: `${(0, $8rTkC.HELP_CENTERS_MANAGEMENT_BASE_PATH)}`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).manageHc),
            actionSubjectId: 'manageHelpCenter',
            isVisible: true,
            onClick: ()=>onClick('manageHelpCenter'),
            testId: 'manage-hc-link'
        },
        {
            link: (0, $hrPHR.getIsMultiHCEnabled)() ? `${0, $8rTkC.HELP_CENTERS_MANAGEMENT_BASE_PATH}?create=true` : '#',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).createHc),
            actionSubjectId: 'createHelpCenter',
            isVisible: showAvatarMenuItemsUpsells,
            pbmTouchpointId: 'portal-avatar-menu-create-help-center',
            customRenderer: (0, $fsZf3.isPremiumUpsellExperimentEnabled)({
                hasSiteAdministerAccess: hasSiteAdministerAccess,
                isHCCustomizationEnabled: (0, $hrPHR.getIsHCCustomizationEnabled)()
            }) ? $502eb40fd88fd5e4$var$PremiumBenefitsModalRenderer : undefined,
            onClick: (0, $hrPHR.getIsMultiHCEnabled)() || (0, $fsZf3.isPremiumUpsellExperimentEnabled)({
                hasSiteAdministerAccess: hasSiteAdministerAccess,
                isHCCustomizationEnabled: (0, $hrPHR.getIsHCCustomizationEnabled)()
            }) ? ()=>onClick('createHelpCenter') : ()=>{
                onClick('createHelpCenter');
                setTitle(formatMessage((0, $djZwh.default).onboardingTitleHCClick));
                setDescription(formatMessage((0, $djZwh.default).onboardingDescriptionCreateOrHcClickWithLink));
                setModalOpen(true);
            },
            testId: 'create-hc-link',
            isPremium: !(0, $hrPHR.getIsHCCustomizationEnabled)()
        },
        ...(0, $HGACo.isCustomPagesUiEnabled)() ? [
            {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).managePages),
                actionSubjectId: 'manageHelpCenterPages',
                isVisible: showAvatarMenuItemsUpsells,
                pbmTouchpointId: 'portal-avatar-menu-landing-pages',
                onClick: ()=>onClick('manageHelpCenterPages'),
                testId: 'manage-hc-pages',
                link: `${(0, $8rTkC.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/pages`,
                isPremium: !(0, $hrPHR.getIsHCCustomizationEnabled)(),
                customRenderer: manageHelpCenterPagesCustomRenderer(),
                showSpotlight: false,
                messageDescription: (0, $djZwh.default).landingPagesNonPremiumDescription
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $rV4PT.default), {
        id: "avatar-menu-hc-section-heading"
    }, formatMessage((0, $djZwh.default).helpCenter)), customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(menu.customRenderer, {
            menu: menu
        }), menu.actionSubjectId === 'manageHelpCenterPages' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8vv1J.FireUIAnalytics), {
            action: "viewed",
            actionSubject: menu.actionSubjectId
        })));
        const renderMenuItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$ListItemWrapper, {
                key: `hc-section-menu_${menu.actionSubjectId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
                component: $502eb40fd88fd5e4$var$CustomAnchor,
                href: menu.link,
                actionSubjectId: menu.actionSubjectId,
                onClick: menu.onClick,
                testId: menu.testId,
                iconAfter: menu.isPremium && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
                    appearance: "new"
                }, formatMessage((0, $djZwh.default).premiumLozenge)),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "cv-exclude-from-customisation"
            }, menu.label), menu.actionSubjectId === 'createHelpCenter' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8vv1J.FireUIAnalytics), {
                action: "viewed",
                actionSubject: menu.actionSubjectId
            })));
        if (menu.showSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lqUyf.default), {
            delay: 100,
            key: menu.actionSubjectId
        }, ()=>renderMenuItem());
        return renderMenuItem();
    }));
};
const $502eb40fd88fd5e4$var$PortalLinks = ({ onClose: onClose, canCustomiseHelpCenter: canCustomiseHelpCenter, portal: portal })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    if (!portal) return null;
    const { isProjectSimplified: isProjectSimplified, isProjectAdmin: isProjectAdmin, canEditAnnouncement: canEditAnnouncement } = portal;
    const shouldRenderAsPortalAnnouncement = ()=>{
        // for simplified projects, render side bar as announcement for agents with permission
        if (isProjectSimplified && !isProjectAdmin && canEditAnnouncement) return true;
        // in classic projects render sidebar as announcement for users who can't modify helpcenter, but can edit announcements
        if (!isProjectSimplified && !canCustomiseHelpCenter && canEditAnnouncement) return true;
        return false;
    };
    const customizeMenu = [
        {
            link: '?customize=true&experience=add-announcement',
            onClick: ()=>onClose('navbarPortalAnnouncement'),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).portalAnnouncement),
            actionSubjectId: 'navbarPortalAnnouncement',
            isVisible: canEditAnnouncement || shouldRenderAsPortalAnnouncement()
        },
        {
            link: '?customize=true&experience=request-groups',
            onClick: ()=>onClose('navbarRequestTypeGroup'),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).portalRequestTypeGroup),
            actionSubjectId: 'navbarRequestTypeGroup',
            isVisible: isProjectAdmin && isProjectSimplified && !shouldRenderAsPortalAnnouncement()
        }
    ];
    const showHeading = customizeMenu.some((menu)=>menu.isVisible);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), null, showHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $rV4PT.default), null, formatMessage((0, $djZwh.default).portal)), customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            key: `portal-link_${menu.actionSubjectId}`,
            component: $502eb40fd88fd5e4$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label);
    }));
};
const $502eb40fd88fd5e4$var$RequestList = (onClose, openRequestListCustomizationSidebar)=>{
    const onClick = (actionSubjectId)=>{
        onClose(actionSubjectId);
        openRequestListCustomizationSidebar();
    };
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $rV4PT.default), null, formatMessage((0, $djZwh.default).requestListHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        component: $502eb40fd88fd5e4$var$CustomButton,
        actionSubjectId: "navbarUserRequestListCustomize",
        "aria-label": formatMessage((0, $djZwh.default).customizeRequestList),
        onClick: ()=>onClick('navbarUserRequestListCustomize'),
        "data-test-id": "requests-list-page-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).customizeRequestList)));
};
const $502eb40fd88fd5e4$var$UserProfileConnectActionLinks = (0, $7oVxX.withDeferredWrmLoaded)($502eb40fd88fd5e4$export$a552d0e5a7a35aad, (0, $6ecLQ.initializeConnect));
const $502eb40fd88fd5e4$var$AvatarMenuDumbV2 = (props)=>{
    // Reading the from useRouter even thought we are getting from props because
    // there is an unneccessary rerender happening in the component which is causing the Engagement client
    // to make an unnecessary start call
    const [{ route: route }] = (0, $i9cdb.useRouter)();
    const { name: currentRouteName } = route;
    const isHomepage = (props === null || props === void 0 ? void 0 : props.routeName) === 'help-center' || (props === null || props === void 0 ? void 0 : props.routeName) === 'view-homepage';
    (0, $8y0tS.useUFOComponentExperience)((0, $kYNPD.avatarMenuExperience));
    const isHelpCenterManagementScreen = (0, $7FSs7.getRelativeBasePath)() === (0, $8rTkC.HELP_CENTERS_MANAGEMENT_BASE_PATH);
    const basePath = (0, $gk18s.isAdvancedHelpCenter)() ? '/' : '/portals';
    const [isOpen, setIsOpen] = (0, $8P7DW.useState)(!!props.isOpen);
    const [showMultiHCChangeBoardingSpotlight, setShowMultiHCChangeBoardingSpotlight] = (0, $8P7DW.useState)(false);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $tJpW6.useQueryParams)();
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const prevSpotlightRef = (0, $8P7DW.useRef)(false);
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const isSmallScreen = window.innerWidth < (0, $k1tWg.sizes).xsmall;
    (0, $8P7DW.useEffect)(()=>{
        // if customize is true and experience is not set, open the sidebar
        if (!(0, $HGACo.isHelpCenterNewDropdownEnabled)() && customize === 'true' && !experience) setIsOpen(true);
        if (showMultiHCChangeBoardingSpotlight) {
            setIsOpen(true);
            prevSpotlightRef.current = true;
        }
        if (!showMultiHCChangeBoardingSpotlight && prevSpotlightRef.current) {
            setIsOpen(false);
            prevSpotlightRef.current = false;
        }
    }, [
        customize,
        experience,
        showMultiHCChangeBoardingSpotlight
    ]);
    const env = (0, $h3cOB.useRelayEnvironment)();
    (0, $8P7DW.useEffect)(()=>{
        if (props.canAdministerJIRA && !isSmallScreen && !isHelpCenterManagementScreen && !(0, $HGACo.isHelpCenterNewDropdownEnabled)()) $502eb40fd88fd5e4$var$multiHcDropdownQueryReference = (0, $h3cOB.loadQuery)(env, (0, $6IS8o.default), {
            SORT_ORDER: $etUNo.SORT_ORDER,
            NUMBER_OF_HELP_CENTERS_PER_FETCH: $etUNo.NUMBER_OF_HELP_CENTERS_PER_FETCH,
            cloudId: (0, $jByYr.getCloudId)(),
            workspaceAri: (0, $jByYr.getWorkspaceAri)()
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        env,
        isHelpCenterManagementScreen,
        isSmallScreen,
        props.canAdministerJIRA
    ]);
    const onOpenChange = (0, $8P7DW.useCallback)((open)=>{
        if (showMultiHCChangeBoardingSpotlight) return;
        setIsOpen(open);
        // if customize is true and experience is not set, clear customize from the queryParam
        if (!open && customize === 'true' && !experience) (0, $e2jLh.clearSidebarExperienceAndCustomize)();
    }, [
        customize,
        experience,
        showMultiHCChangeBoardingSpotlight
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const onItemClick = (actionSubjectId)=>{
        if (actionSubjectId && createAnalyticsEvent) createAnalyticsEvent({
            actionSubjectId: actionSubjectId,
            action: 'clicked',
            actionSubject: 'avatarMenu',
            version: '2',
            analyticsType: (0, $iziiq.UI_EVENT_TYPE)
        }).fire();
        setIsOpen(false);
    };
    const [openModal, setModalOpen] = (0, $8P7DW.useState)(false);
    // This state is used to track if the landing pages changeboarding spotlight has been viewed so that the avatar menu is not opened again on state change within same session of seeing change boarding spotlight.
    const [_, setAvatarMenuOpenedOnceForChangeboarding] = (0, $8P7DW.useState)(false);
    const [title, setTitle] = (0, $8P7DW.useState)('');
    const [description, setDescription] = (0, $8P7DW.useState)('');
    const content = ()=>{
        const { myRequestCount: myRequestCount, customMenuLinks: customMenuLinks, onLogoutClick: onLogoutClick, openHelpCenterCustomizationSidebar: openHelpCenterCustomizationSidebar, openRequestListCustomizationSidebar: openRequestListCustomizationSidebar, routeName: routeName, pendingApprovalCount: pendingApprovalCount, approvalCount: approvalCount, canAdministerJIRA: canAdministerJIRA, hasSiteAdministerAccess: hasSiteAdministerAccess, canCustomiseHelpCenter: canCustomiseHelpCenter, defaultColumnSettings: defaultColumnSettings, portal: portal, jsmAIConfigEnabled: jsmAIConfigEnabled, avatarSrc: avatarSrc, displayName: displayName, email: email, hoistedProjectKey: hoistedProjectKey, areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable, jiraDisplayUrl: jiraDisplayUrl } = props;
        const isServiceHub = !!((0, $HGACo.isJsmCsMasterFlagEnabled)() && hoistedProjectKey);
        let virtualAgentAllowed;
        if ((0, $1EFS8.default).checkGate('use_frontend_feature_encoding_sdk_help_center')) virtualAgentAllowed = (0, $1pfMV.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent');
        else virtualAgentAllowed = Boolean((0, $HGACo.isVAOnHelpCenterGAEnabled)() ? !(0, $1lG1b.isFedRamp)() : jsmAIConfigEnabled);
        const showAvatarMenuItemsUpsells = (0, $hrPHR.getIsHCCustomizationEnabled)() || Boolean(hasSiteAdministerAccess);
        const showVirtualAgentMenu = !(0, $HGACo.isHideVsaEndpointsEnabled)() && canAdministerJIRA && !isServiceHub && !isSmallScreen && !(0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && virtualAgentAllowed && !(0, $fsZf3.isPremiumUpsellExperimentEnabled)({
            hasSiteAdministerAccess: hasSiteAdministerAccess,
            isHCCustomizationEnabled: (0, $hrPHR.getIsHCCustomizationEnabled)()
        });
        // Feature gate: jsm_help_center_one-click_rovo_agent
        // Rovo Agent menu is independent of VSA settings
        const rovoAgentAllowed = (0, $1EFS8.default).checkGate('use_frontend_feature_encoding_sdk_help_center') ? (0, $1pfMV.isFeatureEnabled)('jira-service-management', 'jsm-help-center-rovo-agent') : !(0, $1lG1b.isFedRamp)() && $502eb40fd88fd5e4$export$c0b4c34c7506f4d();
        const showRovoAgentMenu = canAdministerJIRA && !isServiceHub && !isSmallScreen && !(0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && rovoAgentAllowed;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$Wrapper, {
            "aria-label": formatMessage((0, $djZwh.default).tooltip),
            "data-testid": "avatar-menu-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3rCJZ.default), {
            maxHeight: $502eb40fd88fd5e4$var$maxHeight,
            spacing: 'cozy'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7tWhk.AccountDetails), {
            avatarSrc: avatarSrc,
            displayName: displayName,
            email: email
        }), $502eb40fd88fd5e4$var$TopMenu(myRequestCount || 0, onItemClick, pendingApprovalCount || 0, approvalCount || 0, isHelpCenterManagementScreen), !isHelpCenterManagementScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, !(0, $HGACo.isHelpCenterNewDropdownEnabled)() && !isSmallScreen && canAdministerJIRA && !isServiceHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$RenderMultiHcDropdown, {
            setTitle: setTitle,
            setDescription: setDescription,
            setModalOpen: setModalOpen,
            showMultiHCChangeBoardingSpotlight: showMultiHCChangeBoardingSpotlight
        }), (0, $HGACo.isHelpCenterNewDropdownEnabled)() && canAdministerJIRA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), {
            hasSeparator: !isSmallScreen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: (0, $1EFS8.default).checkGate('ff_a11y_hc_list_markup') ? 'ul' : 'div',
            xcss: $502eb40fd88fd5e4$var$listItemStyles,
            key: "help-center-menu",
            // @ts-ignore - aria-label is valid for ul elements
            "aria-label": formatMessage((0, $djZwh.default).helpCenterMenuOptions)
        }, !isSmallScreen && !isServiceHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$RenderHCSection, {
            showAvatarMenuItemsUpsells: showAvatarMenuItemsUpsells,
            setTitle: setTitle,
            setDescription: setDescription,
            setModalOpen: setModalOpen,
            onClick: onItemClick,
            hasSiteAdministerAccess: hasSiteAdministerAccess
        }), canCustomiseHelpCenter && (isHomepage || isServiceHub) && $502eb40fd88fd5e4$var$CustomizeLinks(onItemClick, openHelpCenterCustomizationSidebar, canAdministerJIRA, routeName, basePath, areCustomerServiceSettingsLinksAvailable, showAvatarMenuItemsUpsells, hoistedProjectKey, jiraDisplayUrl, isServiceHub), showRovoAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$ListItemWrapper, {
            key: "customize-menu_rovo_agent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $24wGE.RovoAgentMenu), {
            onClose: onItemClick,
            component: $502eb40fd88fd5e4$var$CustomAnchor
        })), showVirtualAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$ListItemWrapper, {
            key: "customize-menu_virtual_agent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bvpLK.VirtualAgentMenu), {
            onClose: onItemClick,
            component: $502eb40fd88fd5e4$var$CustomAnchor
        })))), canCustomiseHelpCenter && isHomepage && !(0, $HGACo.isHelpCenterNewDropdownEnabled)() && $502eb40fd88fd5e4$var$CustomizeLinks(onItemClick, openHelpCenterCustomizationSidebar, canAdministerJIRA, routeName, basePath, areCustomerServiceSettingsLinksAvailable, showAvatarMenuItemsUpsells, hoistedProjectKey, jiraDisplayUrl), !(0, $HGACo.isHelpCenterNewDropdownEnabled)() && showRovoAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $24wGE.RovoAgentMenu), {
            onClose: onItemClick,
            component: $502eb40fd88fd5e4$var$CustomAnchor
        }), !(0, $HGACo.isHelpCenterNewDropdownEnabled)() && showVirtualAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bvpLK.VirtualAgentMenu), {
            onClose: onItemClick,
            component: $502eb40fd88fd5e4$var$CustomAnchor
        }), routeName === 'portal-home' && !(0, $HGACo.isHelpCenterNewDropdownEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$PortalLinks, {
            onClose: onItemClick,
            canCustomiseHelpCenter: canCustomiseHelpCenter,
            portal: portal,
            jsmAIConfigEnabled: jsmAIConfigEnabled,
            canAdministerJIRA: canAdministerJIRA
        }), routeName === 'requests-list' && canAdministerJIRA && Boolean(defaultColumnSettings === null || defaultColumnSettings === void 0 ? void 0 : defaultColumnSettings.length) && !(0, $HGACo.isHelpCenterNewDropdownEnabled)() && $502eb40fd88fd5e4$var$RequestList(onItemClick, openRequestListCustomizationSidebar), customMenuLinks && customMenuLinks.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), {
            hasSeparator: customMenuLinks && customMenuLinks.length > 0
        }, (0, $HGACo.isWrmOptimizationsEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$UserProfileConnectActionLinks, {
            customMenuLinks: customMenuLinks,
            onClose: onItemClick
        }) : $502eb40fd88fd5e4$var$buildCustomMenuLinks(customMenuLinks, onItemClick)) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$export$e0ae4b37130667df, {
            onClose: onItemClick
        })), (0, $HGACo.isHelpCenterNewDropdownEnabled)() && $502eb40fd88fd5e4$var$menuBottomSection(onItemClick, isHelpCenterManagementScreen, onLogoutClick), !(0, $HGACo.isHelpCenterNewDropdownEnabled)() && $502eb40fd88fd5e4$var$logoutLink(onLogoutClick)), displayName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
            experience: (0, $kYNPD.avatarMenuExperience)
        }));
    };
    const handleUpgradeModalNext = (0, $8P7DW.useCallback)(()=>{
        setModalOpen(false);
        window.open((0, $jsmb9.getBillingUrl)([
            'jira-servicedesk'
        ], (0, $jByYr.getCloudId)()), '_blank');
    }, []);
    const Trigger = (0, $8P7DW.useCallback)((triggerProps)=>{
        const { avatarSrc: avatarSrc, disableAvatarMenu: disableAvatarMenu = false, pendingApprovalCount: pendingApprovalCount = 0, myRequestCount: myRequestCount = 0 } = props;
        const totalRequests = pendingApprovalCount + myRequestCount;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, !((0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && (0, $HGACo.isJsmCsMasterFlagEnabled)()) && totalRequests > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$StyledAvatarBadge, null, totalRequests), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$ProfileContainer, {
            disabled: disableAvatarMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1P5py.default), {
            name: (0, $8rTkC.EngagementMessagesTarget).CHANGE_BOARDING_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2pAfo.Profile), {
            ...triggerProps,
            isDisabled: disableAvatarMenu,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hIXV0.default), {
                src: avatarSrc,
                borderColor: "var(--ds-border-inverse, #FFFFFF)"
            }),
            isSelected: isOpen,
            onClick: ()=>{
                onOpenChange(!isOpen);
            },
            "aria-label": formatMessage((0, $djZwh.default).tooltip),
            tooltip: formatMessage((0, $djZwh.default).tooltip),
            testId: "user-avatar-container-2"
        })), !isSmallScreen && !(0, $HGACo.isHelpCenterNewDropdownEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, (currentRouteName === 'help-center' || currentRouteName === 'view-homepage') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kM5Oy.default), {
            messageId: (0, $8rTkC.EngagementMessages).CHANGE_BOARD_ADMINS_FREE_AND_STANDARD_EDITION
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $Vw3JS.ChangeBoardingSingleSpotlight), {
            target: (0, $8rTkC.EngagementMessagesTarget).CHANGE_BOARDING_SPOTLIGHT,
            analyticsSubject: "freeStandardAdminsChangeBoarding",
            messageId: (0, $8rTkC.EngagementMessages).CHANGE_BOARD_ADMINS_FREE_AND_STANDARD_EDITION,
            headingText: formatMessage((0, $djZwh.default).freeStandardAdminsChangeBoardingHeading),
            contentText: formatMessage((0, $djZwh.default).freeStandardAdminsChangeBoardingContent),
            buttonText: formatMessage((0, $djZwh.default).freeStandardAdminsChangeBoardingButton),
            dialogPlacement: "bottom left",
            targetBgColor: "var(--ds-background-discovery-bold, #6554C0)",
            targetRadius: 50,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($80D2y)))
        })), currentRouteName === 'portal-home' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kM5Oy.default), {
            messageId: (0, $8rTkC.EngagementMessages).CHANGE_BOARD_ADMINS_SINGLE_PORTAL_SCREEN
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $Vw3JS.ChangeBoardingSingleSpotlight), {
            target: (0, $8rTkC.EngagementMessagesTarget).CHANGE_BOARDING_SPOTLIGHT,
            analyticsSubject: "singlePortalScreenAdminsChangeBoarding",
            messageId: (0, $8rTkC.EngagementMessages).CHANGE_BOARD_ADMINS_SINGLE_PORTAL_SCREEN,
            headingText: formatMessage((0, $djZwh.default).singlePortalScreenAdminsChangeBoardingHeading),
            contentText: formatMessage((0, $djZwh.default).singlePortalScreenAdminsChangeBoardingContent),
            buttonText: formatMessage((0, $djZwh.default).singlePortalScreenAdminsChangeBoardingButton),
            dialogPlacement: "bottom left",
            targetBgColor: "var(--ds-background-discovery-bold, #6554C0)",
            targetRadius: 50,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($80D2y)))
        })), (currentRouteName === 'help-center' || currentRouteName === 'view-homepage') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kM5Oy.default), {
            messageId: (0, $8rTkC.EngagementMessages).CHANGE_BOARD_ADMINS_PREMIUM_ENTERPRISE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iQzn3.PremiumEnterpriseAdminsChangeBoarding), {
            setShowMultiHCChangeBoardingSpotlight: setShowMultiHCChangeBoardingSpotlight
        })))));
    }, [
        props,
        isOpen,
        formatMessage,
        isSmallScreen,
        currentRouteName,
        onOpenChange
    ]);
    const renderDropdownMenu = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5JQIe.default), {
            blanketIsTinted: true,
            onBlanketClicked: ()=>setAvatarMenuOpenedOnceForChangeboarding(true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $i4z8R.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c2L1U.default), {
            isOpen: isOpen,
            shouldRenderToParent: true,
            onClose: ()=>onOpenChange(false),
            placement: "bottom-end",
            zIndex: (0, $jbqt2.layers).modal(),
            content: content,
            trigger: Trigger,
            // This is required to close the open menu when clicking outside of the menu
            // A complex use case hence attaching a video of the same https://www.loom.com/share/95aa9f0112dd4e028194397e8dfeabea?sid=ef970902-843d-4b62-a578-3ec0f1f1b273
            // shouldUseCaptureOnOutsideClick
            key: 'avatar-menu-dumb-v2-popup'
        })));
    };
    const renderError = (0, $8P7DW.useCallback)((error)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kYNPD.AvatarMenuExperienceFailure), {
            message: error.message
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        onError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($502eb40fd88fd5e4$var$AvatarMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eVq2A.ForgeModalContextProvider), {
        type: (0, $7ex17.USER_MENU_ACTION_SECTION_MODULE)
    }, renderDropdownMenu(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iucai.ForgeActionModule), {
        type: (0, $7ex17.USER_MENU_ACTION_SECTION_MODULE),
        componentName: (0, $7ex17.USER_MENU_ACTION_COMPONENT)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $33zHl.default), null, openModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jtSmi.UpgradeModal), {
        onNext: handleUpgradeModalNext,
        onClose: ()=>setModalOpen(false),
        title: title,
        description: description
    })));
};
$502eb40fd88fd5e4$var$AvatarMenuDumbV2.defaultProps = {
    customMenuLinks: []
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $502eb40fd88fd5e4$var$AvatarMenuContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_u5f3u2gc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$NoUnderlineLink = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $cS6Xr.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$Wrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1tvnsw3": (0, $77UGK.default)($4cxV2.multiple(29.25).px),
            "--_1rpxolo": (0, $77UGK.default)($4cxV2.multiple(100).px)
        },
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1ul94vv4 _p12f15fr _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$StyledAvatarBadge = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $ft9Vs.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_kqswstnw _1ltvidpf _94n5idpf _1pby1kze",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$CustomLinkBase = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = $502eb40fd88fd5e4$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_syaz261p _b8xz168b",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$CustomLinkWithFocus = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = $502eb40fd88fd5e4$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_syaz261p _b8xz168b",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$CustomLink = $502eb40fd88fd5e4$var$isAvatarMenuFocusVisibleStylesEnabled() ? $502eb40fd88fd5e4$var$CustomLinkWithFocus : $502eb40fd88fd5e4$var$CustomLinkBase;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $502eb40fd88fd5e4$var$CustomButton = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $8y05I.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_11q7261p _ca0qc4v4 _u5f31gpt _n3tdc4v4 _19bv1gpt _syaz16l4 _1bsbaq80 _4cvr1s23 _j6xtkjgq _1du2kjgq _19lckjgq _1x4lkjgq _utpwkjgq _9h8h16l4 _f8pj16l4 _30l316l4 _ysv716l4 _105316l4",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$CustomAnchorBase = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $4QM8d.HtmlAnchor), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz261p _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$CustomAnchorWithFocus = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $4QM8d.HtmlAnchor), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz261p _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1 _b8xz168b",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$CustomAnchor = $502eb40fd88fd5e4$var$isAvatarMenuFocusVisibleStylesEnabled() ? $502eb40fd88fd5e4$var$CustomAnchorWithFocus : $502eb40fd88fd5e4$var$CustomAnchorBase;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $502eb40fd88fd5e4$var$ProfileContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "",
            __cmplp.disabled ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $502eb40fd88fd5e4$var$maxHeight = `calc(100vh - ${$4cxV2.multiple(24).px}`;
const $502eb40fd88fd5e4$var$MultiHcDropdownContainer = (0, $37U6z.xcss)({
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.250',
    paddingTop: 'space.100'
});
const $502eb40fd88fd5e4$var$pageLayoutPremiumPopUp = (0, $37U6z.xcss)({
    padding: 'space.200',
    maxWidth: '256px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 'radius.xlarge',
    gap: 'space.100'
});
const $502eb40fd88fd5e4$var$customPressableStyles = (0, $37U6z.xcss)({
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.100',
    paddingInline: 'space.200',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $502eb40fd88fd5e4$var$listItemStyles = (0, $37U6z.xcss)({
    listStyleType: 'none',
    padding: 'space.0',
    margin: 'space.0'
});
var $502eb40fd88fd5e4$export$2e2bcd8739ae039 = $502eb40fd88fd5e4$var$AvatarMenuDumbV2;

});
parcelRegister("ft9Vs", function(module, exports) {
$parcel$export(module.exports, "default", () => $845c5bc4994dc118$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");
// This is the current styling of Badge in AtlasKit. It
// has been duplicated here since AtlasKit does not allow
// color styling at the moment.
// Changed to use atlaskit/badge once https://ecosystem.atlassian.net/browse/AK-4187 resolved
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $845c5bc4994dc118$var$ThemedBadge = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1s9354m-0"
})`background-color:${(props)=>`var(--ds-background-selected-bold, ${props.theme.color})`};border-radius:2em;color:${(props)=>props.theme.readableTextColor};display:inline-block;font-size:12px;font-weight:normal;line-height:1;min-width:1px;padding:0.16666666666667em ${"var(--ds-space-075, 6px)"};text-align:center;`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$845c5bc4994dc118$export$2e2bcd8739ae039 = $845c5bc4994dc118$var$ThemedBadge;

});

parcelRegister("Vw3JS", function(module, exports) {
$parcel$export(module.exports, "ChangeBoardingSingleSpotlight", () => $1dcfe1f5c4f85847$export$5c8339440f10c2f);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $1dcfe1f5c4f85847$export$5c8339440f10c2f = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("iSwfm")), {
        moduleId: "./packages/common-utils/change-boarding-single-spotlight/src/change-boarding-single-spotlight.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("iSwfm", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("lUtvv"),
    $j9MRt("5Ucgr")
]).then(()=>parcelRequire('koRzL'));

});


parcelRegister("6ecLQ", function(module, exports) {
$parcel$export(module.exports, "initializeConnect", () => $b1767e6975c4bdb2$export$36d45daa6a4925b8);
$parcel$export(module.exports, "ConnectFragment", () => $b1767e6975c4bdb2$export$aa8ab018415f92e4);
$parcel$export(module.exports, "ConnectFragmentDumb", () => $b1767e6975c4bdb2$export$3cdf4f8c52fabf27);
$parcel$export(module.exports, "ConnectFragmentsDumb", () => $b1767e6975c4bdb2$export$93e3ab580ab70dd6);

var $HGACo = parcelRequire("HGACo");

var $1We2B = parcelRequire("1We2B");

var $9ypa9 = parcelRequire("9ypa9");

var $jjE9o = parcelRequire("jjE9o");

var $51UkY = parcelRequire("51UkY");

var $glMVg = parcelRequire("glMVg");

var $7oVxX = parcelRequire("7oVxX");

var $aTaR3 = parcelRequire("aTaR3");

var $8ECIG = parcelRequire("8ECIG");

var $8MtY2 = parcelRequire("8MtY2");

var $fMDgb = parcelRequire("fMDgb");
const $b1767e6975c4bdb2$export$36d45daa6a4925b8 = (0, $1We2B.once)(()=>{
    try {
        (0, $51UkY.awaitGlobal)('connectHost', (0, $glMVg.default));
    } catch (e) {
        (0, $9ypa9.trackError)('connect.fragment.init.failed', {}, e);
        (0, $jjE9o.operationalEvent)({
            action: 'failed',
            actionSubject: 'connectFragmentInit',
            source: 'unknownSource',
            attributes: {
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                errorMessage: e.message
            }
        });
    }
});
const $b1767e6975c4bdb2$export$aa8ab018415f92e4 = (0, $HGACo.isWrmOptimizationsEnabled)() ? (0, $7oVxX.withDeferredWrmLoaded)((0, $8MtY2.default), $b1767e6975c4bdb2$export$36d45daa6a4925b8) : (0, $8MtY2.default);
const $b1767e6975c4bdb2$export$3cdf4f8c52fabf27 = (0, $HGACo.isWrmOptimizationsEnabled)() ? (0, $7oVxX.withDeferredWrmLoaded)((0, $aTaR3.default), $b1767e6975c4bdb2$export$36d45daa6a4925b8) : (0, $aTaR3.default);
const $b1767e6975c4bdb2$export$93e3ab580ab70dd6 = (0, $HGACo.isWrmOptimizationsEnabled)() ? (0, $7oVxX.withDeferredWrmLoaded)((0, $8ECIG.default), $b1767e6975c4bdb2$export$36d45daa6a4925b8) : (0, $8ECIG.default);

});
parcelRegister("7oVxX", function(module, exports) {
$parcel$export(module.exports, "withDeferredWrmLoaded", () => $f4237e8ced32b307$export$ae0e017d29ba244d);

var $8P7DW = parcelRequire("8P7DW");

var $eM37y = parcelRequire("eM37y");
const $f4237e8ced32b307$export$ae0e017d29ba244d = (Component, onLoad)=>{
    const ComponentWithDeferredWrmLoaded = (props)=>{
        const { resourcesLoaded: resourcesLoaded } = $8P7DW.useContext((0, $eM37y.DeferredWrmResourceContext));
        $8P7DW.useEffect(()=>{
            if (resourcesLoaded) onLoad();
        }, [
            resourcesLoaded
        ]);
        if (!resourcesLoaded) return null;
        return /*#__PURE__*/ $8P7DW.createElement(Component, props);
    };
    return ComponentWithDeferredWrmLoaded;
};

});

parcelRegister("8MtY2", function(module, exports) {
$parcel$export(module.exports, "default", () => $341105af6139b53f$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("6TVgw");
var $ddmND = parcelRequire("ddmND");

var $kOOky = parcelRequire("kOOky");
parcelRequire("evz8b");
var $XzrkF = parcelRequire("XzrkF");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $fMDgb = parcelRequire("fMDgb");
const $341105af6139b53f$var$selector = (0, $ehscL.createSelector)((state, componentProps)=>{
    const { page: page, location: location, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = componentProps;
    const projectId = state ? (0, $73V7l.getProjectId)(state, portalId) : undefined;
    const connectFragments = (0, $XzrkF.getConnectAddonPanels)({
        state: state,
        location: location,
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey,
        pageName: page
    });
    return {
        connectFragments: connectFragments,
        projectId: projectId
    };
}, (props)=>props);
const $341105af6139b53f$var$ConnectFragmentWithAnalytics = (0, $eS4yu.default)({
    componentName: 'ConnectFragment'
})((0, $k7ZVu.default)({})((0, $fMDgb.ConnectFragment)));
var $341105af6139b53f$export$2e2bcd8739ae039 = (0, $jvoWT.default)($341105af6139b53f$var$selector, {
    fetchConnectFragments: (0, $ddmND.fetchConnectFragmentsAction),
    ...(0, $kOOky.mapConnectDispatchToPropsBanner)
})($341105af6139b53f$var$ConnectFragmentWithAnalytics);

});
parcelRegister("evz8b", function(module, exports) {
$parcel$export(module.exports, "getConnectAddonPanels", () => (parcelRequire("XzrkF")).getConnectAddonPanels);
$parcel$export(module.exports, "getProfileConnectAddonPanels", () => (parcelRequire("XzrkF")).getProfileConnectAddonPanels);
$parcel$export(module.exports, "getProfileConnectAddonActions", () => (parcelRequire("XzrkF")).getProfileConnectAddonActions);
$parcel$export(module.exports, "getRequestSpecificConnectAddonPanels", () => (parcelRequire("XzrkF")).getRequestSpecificConnectAddonPanels);

var $XzrkF = parcelRequire("XzrkF");

});
parcelRegister("XzrkF", function(module, exports) {
$parcel$export(module.exports, "getConnectAddonPanels", () => $d60f4d60f406debc$export$be753636105743d4);
$parcel$export(module.exports, "getRequestSpecificConnectAddonPanels", () => $d60f4d60f406debc$export$5d04f04eeff342cb);
$parcel$export(module.exports, "getProfileConnectAddonPanels", () => $d60f4d60f406debc$export$e91bb9a5dede3485);
$parcel$export(module.exports, "getProfileConnectAddonActions", () => $d60f4d60f406debc$export$43a1e23f8855f249);
parcelRequire("9grr6");
var $8ApRA = parcelRequire("8ApRA");
const $d60f4d60f406debc$export$be753636105743d4 = ({ state: state, pageName: pageName, location: location, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>{
    switch(location){
        case 'detailsPanels':
        case 'optionPanels':
            return $d60f4d60f406debc$export$5d04f04eeff342cb({
                state: state,
                location: location,
                requestKey: requestKey
            });
        default:
            {
                const page = state.persisted.connectFragments[(0, $8ApRA.generateKey)(pageName, portalId, requestTypeId, requestKey)];
                // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return page && page[location];
            }
    }
};
const $d60f4d60f406debc$export$5d04f04eeff342cb = ({ state: state, location: location, requestKey: requestKey })=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestDetailsForKey = requestKey && state && state.persisted && state.persisted.requestDetails[requestKey];
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return requestDetailsForKey ? requestDetailsForKey[location] : [];
};
const $d60f4d60f406debc$export$e91bb9a5dede3485 = (state)=>{
    return state.persisted.profileWebFragments.panels;
};
const $d60f4d60f406debc$export$43a1e23f8855f249 = (state)=>{
    return state.persisted.profileWebFragments.actions;
};

});




parcelRegister("kM5Oy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4eb7ab791844f4b7$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $8Voe7 = parcelRequire("8Voe7");

var $gcZ9C = parcelRequire("gcZ9C");
const $4eb7ab791844f4b7$export$25215e4c8f710ceb = ({ coordinationClient: coordinationClient, messageId: messageId, children: children })=>{
    if (!coordinationClient) return null;
    return /*#__PURE__*/ $8P7DW.createElement((0, $8Voe7.default), {
        client: coordinationClient,
        messageId: messageId
    }, children);
};
var $4eb7ab791844f4b7$export$2e2bcd8739ae039 = (0, $gcZ9C.withCoordinationClient)($4eb7ab791844f4b7$export$25215e4c8f710ceb);

});
parcelRegister("8Voe7", function(module, exports) {
$parcel$export(module.exports, "default", () => $87cfffc0b96a7d9a$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
class $87cfffc0b96a7d9a$export$2e2bcd8739ae039 extends (0, $8P7DW.PureComponent) {
    static #_ = this.defaultProps = {
        fallback: null
    };
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $8P7DW.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args), this.state = {
            shouldRenderChildren: false
        }, this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}

});


parcelRegister("iucai", function(module, exports) {
$parcel$export(module.exports, "ForgeActionModule", () => $dbabd26d7124005a$export$3f817dccc12b0bb3);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $dbabd26d7124005a$export$3f817dccc12b0bb3 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("8Pa2r")), {
        moduleId: "./packages/common-utils/forge-action/src/forge-action.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("8Pa2r", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("ivo6R"),
    $j9MRt("89Zim")
]).then(()=>parcelRequire('72ew0'));

});


parcelRegister("dW1Qd", function(module, exports) {
$parcel$export(module.exports, "ForgeModalContext", () => $ae013e91c6afa6ef$export$7ec9d631dd0c629a);
$parcel$export(module.exports, "ForgeModalContextConsumer", () => $ae013e91c6afa6ef$export$15f67e1b244563e3);

var $8P7DW = parcelRequire("8P7DW");

var $1We2B = parcelRequire("1We2B");
const $ae013e91c6afa6ef$export$7ec9d631dd0c629a = /*#__PURE__*/ $8P7DW.createContext({
    data: {
        extensions: new Map(),
        extensionToDisplay: '',
        extensionTitles: []
    },
    methods: {
        setExtensionToDisplay: (0, $1We2B.noop)
    }
});
$ae013e91c6afa6ef$export$7ec9d631dd0c629a.displayName = 'ForgeModalContext';
const $ae013e91c6afa6ef$export$15f67e1b244563e3 = $ae013e91c6afa6ef$export$7ec9d631dd0c629a.Consumer;

});

parcelRegister("eVq2A", function(module, exports) {
$parcel$export(module.exports, "ForgeModalContextProvider", () => $51ce0a1aa9c93601$export$35485b69e4da19ba);

var $4O8fD = parcelRequire("4O8fD");

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $51ce0a1aa9c93601$export$35485b69e4da19ba = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("6fmJ2")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/modal-context-provider/modal-context-provider.tsx"
    }),
    LoadingSkeleton: (0, $4O8fD.AvatarLoadingSkeleton)
});

});
parcelRegister("6fmJ2", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("b5oYa").then(()=>parcelRequire('bxSci'));

});


parcelRegister("iQzn3", function(module, exports) {
$parcel$export(module.exports, "PremiumEnterpriseAdminsChangeBoarding", () => $588ea2c1fe182088$export$d90117757fa3104c);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $588ea2c1fe182088$export$d90117757fa3104c = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("2y8bw")), {
        moduleId: "./packages/common-utils/premium-enterprise-admins-changeboarding/src/premium-enterprise-admins-changeboarding.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("2y8bw", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("lUtvv"),
    $j9MRt("8S602")
]).then(()=>parcelRequire('34nOL'));

});


parcelRegister("lqUyf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9c7c0fde37e3466$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
class $b9c7c0fde37e3466$export$2e2bcd8739ae039 extends $8P7DW.Component {
    componentDidMount() {
        const renderNextAnimationFrame = ()=>{
            window.requestAnimationFrame(()=>{
                window.requestAnimationFrame(()=>{
                    this.setState({
                        render: true
                    });
                });
            });
        };
        if (this.props.delay) window.setTimeout(renderNextAnimationFrame, this.props.delay);
        else renderNextAnimationFrame();
    }
    render() {
        return this.state.render ? this.props.children() : null;
    }
    constructor(...args){
        super(...args), this.state = {
            render: false
        };
    }
}

});

parcelRegister("1P98q", function(module, exports) {
$parcel$export(module.exports, "VaOnboardingSpotlight", () => $c840f9bf5b341f02$export$9900d5bc23cb734);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $c840f9bf5b341f02$export$9900d5bc23cb734 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("9ZZw5")), {
        moduleId: "./packages/common-utils/va-reporting-onboarding/src/va-reporting-onboarding.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("9ZZw5", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("01B4C"),
    $j9MRt("lUtvv"),
    $j9MRt("lO6bW")
]).then(()=>parcelRequire('1UKJy'));

});


parcelRegister("80D2y", function(module, exports) {
module.exports = new URL("../images/change-boarding.2c0ac862.svg", import.meta.url).toString();

});

parcelRegister("2pAfo", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $bab633e661ce9e36$export$5120f2d0b8d4cab8);

var $8P7DW = parcelRequire("8P7DW");

var $hFFbP = parcelRequire("hFFbP");
const $bab633e661ce9e36$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hFFbP.IconButton), {
        component: component,
        href: href,
        icon: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    }));
});
var // This exists only to extract props.
// eslint-disable-next-line import/no-anonymous-default-export
$bab633e661ce9e36$export$2e2bcd8739ae039 = (_props)=>{};

});
parcelRegister("hFFbP", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $4ff8979b9dc22679$export$c25acd513dcc8062);

var $8P7DW = parcelRequire("8P7DW");

var $iFxfe = parcelRequire("iFxfe");

var $ea6bZ = parcelRequire("ea6bZ");

var $4mriZ = parcelRequire("4mriZ");

var $4iCt5 = parcelRequire("4iCt5");
const $4ff8979b9dc22679$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $4mriZ.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iFxfe.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $4iCt5.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ea6bZ.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled
    }, button);
    return button;
});

});
parcelRegister("4mriZ", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $786dec3dc2e39c7d$export$93d4e7f90805808f);

var $8P7DW = parcelRequire("8P7DW");

var $hcRiR = parcelRequire("hcRiR");
const $786dec3dc2e39c7d$export$93d4e7f90805808f = ()=>(0, $8P7DW.useContext)((0, $hcRiR.ThemeContext));

});
parcelRegister("hcRiR", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $a6c2e8d18bd17b98$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeProvider", () => $a6c2e8d18bd17b98$export$d8964aec282183a3);

var $8P7DW = parcelRequire("8P7DW");

var $71yMi = parcelRequire("71yMi");
const $a6c2e8d18bd17b98$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $8P7DW.createContext)((0, $71yMi.defaultTheme));
const $a6c2e8d18bd17b98$export$d8964aec282183a3 = $a6c2e8d18bd17b98$export$2c657da244d00bd6.Provider;

});
parcelRegister("71yMi", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", () => $32a034cd10f2bbd6$export$164de7ab8df77ef0);

var $5wGSn = parcelRequire("5wGSn");

var $3faEY = parcelRequire("3faEY");
const $32a034cd10f2bbd6$export$eeee8619e1b91cb0 = (0, $3faEY.generateTheme)({
    name: (0, $5wGSn.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});
const $32a034cd10f2bbd6$export$164de7ab8df77ef0 = $32a034cd10f2bbd6$export$eeee8619e1b91cb0;

});
parcelRegister("5wGSn", function(module, exports) {
$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $f8f5f4992671a677$export$77823bc9863eaa03);
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $f8f5f4992671a677$export$2491e13b198e597d);
const $f8f5f4992671a677$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $f8f5f4992671a677$var$defaultThemeCopy = JSON.parse(JSON.stringify($f8f5f4992671a677$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$f8f5f4992671a677$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$f8f5f4992671a677$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $f8f5f4992671a677$export$77823bc9863eaa03 = $f8f5f4992671a677$var$defaultThemeCopy;
const $f8f5f4992671a677$export$2491e13b198e597d = 'atlassian';
var $f8f5f4992671a677$export$2e2bcd8739ae039 = $f8f5f4992671a677$var$defaultTheme;

});

parcelRegister("3faEY", function(module, exports) {
$parcel$export(module.exports, "generateTheme", () => $6949d8d3a8152839$export$2e4ecffaca289a18);

var $5wGSn = parcelRequire("5wGSn");

var $2GMLd = parcelRequire("2GMLd");
const $6949d8d3a8152839$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $6949d8d3a8152839$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $6949d8d3a8152839$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $2GMLd.hexToRGBA)(backgroundColor, 0.65) : (0, $2GMLd.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $2GMLd.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $2GMLd.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $2GMLd.hexToRGBA)(backgroundColor, 0.8) : (0, $2GMLd.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $2GMLd.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $2GMLd.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $2GMLd.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $2GMLd.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $2GMLd.getBoxShadow)('transparent')
        }
    };
};
const $6949d8d3a8152839$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $2GMLd.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $6949d8d3a8152839$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $2GMLd.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $5wGSn.DEFAULT_THEME_NAME)) return 0, $5wGSn.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $6949d8d3a8152839$var$generateButtonCSSStates($6949d8d3a8152839$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $6949d8d3a8152839$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $6949d8d3a8152839$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $2GMLd.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $2GMLd.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $2GMLd.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $2GMLd.getBoxShadow)((0, $2GMLd.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $2GMLd.getContrastColor)(0.1, $6949d8d3a8152839$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});
parcelRegister("2GMLd", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", () => $64d1f2f45a115c15$export$7229be6d7219ee6a);
$parcel$export(module.exports, "getBoxShadow", () => $64d1f2f45a115c15$export$bba5a971afe05444);
$parcel$export(module.exports, "generateTextColor", () => $64d1f2f45a115c15$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $64d1f2f45a115c15$export$77a1051494882576);

var $6e6Au = parcelRequire("6e6Au");
const $64d1f2f45a115c15$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $6e6Au.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $64d1f2f45a115c15$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $64d1f2f45a115c15$var$hex = '[a-z0-9]';
const $64d1f2f45a115c15$var$shortHandHexColorPattern = new RegExp(`#(${$64d1f2f45a115c15$var$hex})(${$64d1f2f45a115c15$var$hex})(${$64d1f2f45a115c15$var$hex})`, 'i');
const $64d1f2f45a115c15$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $64d1f2f45a115c15$var$isShortHexColor = (color)=>color && color.length === 4;
const $64d1f2f45a115c15$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$64d1f2f45a115c15$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $64d1f2f45a115c15$var$completeTriplet = (colors)=>`#${$64d1f2f45a115c15$var$repeat(colors[1], 6)}`;
const $64d1f2f45a115c15$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $64d1f2f45a115c15$export$db8d2130677f868c = (color)=>{
    if ($64d1f2f45a115c15$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($64d1f2f45a115c15$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($64d1f2f45a115c15$var$isTriplet(colors)) return $64d1f2f45a115c15$var$completeTriplet(colors);
            else return $64d1f2f45a115c15$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $64d1f2f45a115c15$export$10a10e7cd1193377 = (color)=>{
    const converted = $64d1f2f45a115c15$export$db8d2130677f868c(color);
    return (0, $6e6Au.default).contrastRatio(converted).hex;
};
const $64d1f2f45a115c15$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$64d1f2f45a115c15$export$7229be6d7219ee6a((0, $6e6Au.default).contrast(contrastValue, color).hex, opacityValue);

});
parcelRegister("6e6Au", function(module, exports) {
$parcel$export(module.exports, "default", () => $012b80a957d438fb$export$2e2bcd8739ae039);
function $012b80a957d438fb$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $012b80a957d438fb$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $012b80a957d438fb$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $012b80a957d438fb$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $012b80a957d438fb$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $012b80a957d438fb$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $012b80a957d438fb$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $012b80a957d438fb$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $012b80a957d438fb$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $012b80a957d438fb$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $012b80a957d438fb$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $012b80a957d438fb$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $012b80a957d438fb$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $012b80a957d438fb$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $012b80a957d438fb$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $012b80a957d438fb$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $012b80a957d438fb$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $012b80a957d438fb$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $012b80a957d438fb$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $012b80a957d438fb$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $012b80a957d438fb$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $012b80a957d438fb$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $012b80a957d438fb$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $012b80a957d438fb$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $012b80a957d438fb$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $012b80a957d438fb$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $012b80a957d438fb$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $012b80a957d438fb$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $012b80a957d438fb$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $012b80a957d438fb$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $012b80a957d438fb$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $012b80a957d438fb$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $012b80a957d438fb$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $012b80a957d438fb$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $012b80a957d438fb$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $012b80a957d438fb$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $012b80a957d438fb$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $012b80a957d438fb$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $012b80a957d438fb$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $012b80a957d438fb$var$fromHex_1 = $012b80a957d438fb$var$fromHex, $012b80a957d438fb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $012b80a957d438fb$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $012b80a957d438fb$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $012b80a957d438fb$var$fromRgb_1 = $012b80a957d438fb$var$fromRgb, $012b80a957d438fb$var$fromCssRgb_1 = $012b80a957d438fb$var$fromCssRgb, $012b80a957d438fb$var$fromHsl_1 = $012b80a957d438fb$var$fromHsl, $012b80a957d438fb$var$fromCssHsl_1 = $012b80a957d438fb$var$fromCssHsl, $012b80a957d438fb$var$fromHsv_1 = $012b80a957d438fb$var$fromHsv, $012b80a957d438fb$var$fromCmyk_1 = $012b80a957d438fb$var$fromCmyk, $012b80a957d438fb$var$fromYiq_1 = $012b80a957d438fb$var$fromYiq, $012b80a957d438fb$var$fromXYZ_1 = $012b80a957d438fb$var$fromXYZ, $012b80a957d438fb$var$fromxyY_1 = $012b80a957d438fb$var$fromxyY, $012b80a957d438fb$var$fromLms_1 = $012b80a957d438fb$var$fromLms, $012b80a957d438fb$var$fromCieLab_1 = $012b80a957d438fb$var$fromCieLab, $012b80a957d438fb$var$fromCieLuv_1 = $012b80a957d438fb$var$fromCieLuv, $012b80a957d438fb$var$fromCieLch_1 = $012b80a957d438fb$var$fromCieLch, $012b80a957d438fb$var$fromHsluv = $012b80a957d438fb$var$fromCieLch$1, $012b80a957d438fb$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $012b80a957d438fb$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $012b80a957d438fb$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $012b80a957d438fb$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $012b80a957d438fb$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $012b80a957d438fb$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $012b80a957d438fb$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $012b80a957d438fb$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $012b80a957d438fb$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $012b80a957d438fb$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $012b80a957d438fb$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $012b80a957d438fb$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $012b80a957d438fb$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $012b80a957d438fb$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $012b80a957d438fb$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $012b80a957d438fb$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $012b80a957d438fb$var$fromHsluv
    }
}, $012b80a957d438fb$var$adapt_1 = $012b80a957d438fb$var$adapt, $012b80a957d438fb$var$adjacent_1 = $012b80a957d438fb$var$adjacent, $012b80a957d438fb$var$brightness_1 = $012b80a957d438fb$var$brightness, $012b80a957d438fb$var$complementary_1 = $012b80a957d438fb$var$complementary, $012b80a957d438fb$var$contrast_1 = $012b80a957d438fb$var$contrast, $012b80a957d438fb$var$contrastRatio_1 = $012b80a957d438fb$var$contrastRatio, $012b80a957d438fb$var$convert_1 = $012b80a957d438fb$var$convert, $012b80a957d438fb$var$difference_1 = $012b80a957d438fb$var$difference, $012b80a957d438fb$var$fade_1 = $012b80a957d438fb$var$fade, $012b80a957d438fb$var$greyscale_1 = $012b80a957d438fb$var$greyscale, $012b80a957d438fb$var$hue_1 = $012b80a957d438fb$var$hue, $012b80a957d438fb$var$invert_1 = $012b80a957d438fb$var$invert, $012b80a957d438fb$var$invertLightness_1 = $012b80a957d438fb$var$invertLightness, $012b80a957d438fb$var$mid_1 = $012b80a957d438fb$var$mid, $012b80a957d438fb$var$multiply_1 = $012b80a957d438fb$var$multiply, $012b80a957d438fb$var$saturation_1 = $012b80a957d438fb$var$saturation, $012b80a957d438fb$var$sepia_1 = $012b80a957d438fb$var$sepia, $012b80a957d438fb$var$shade_1 = $012b80a957d438fb$var$shade, $012b80a957d438fb$var$temperature_1 = $012b80a957d438fb$var$temperature, $012b80a957d438fb$var$tetrad_1 = $012b80a957d438fb$var$tetrad, $012b80a957d438fb$var$triad_1 = $012b80a957d438fb$var$triad, $012b80a957d438fb$var$index$2 = {
    adapt: $012b80a957d438fb$var$adapt_1,
    adjacent: $012b80a957d438fb$var$adjacent_1,
    brightness: $012b80a957d438fb$var$brightness_1,
    complementary: $012b80a957d438fb$var$complementary_1,
    contrast: $012b80a957d438fb$var$contrast_1,
    contrastRatio: $012b80a957d438fb$var$contrastRatio_1,
    convert: $012b80a957d438fb$var$convert_1,
    difference: $012b80a957d438fb$var$difference_1,
    fade: $012b80a957d438fb$var$fade_1,
    greyscale: $012b80a957d438fb$var$greyscale_1,
    hue: $012b80a957d438fb$var$hue_1,
    invert: $012b80a957d438fb$var$invert_1,
    invertLightness: $012b80a957d438fb$var$invertLightness_1,
    mid: $012b80a957d438fb$var$mid_1,
    multiply: $012b80a957d438fb$var$multiply_1,
    saturation: $012b80a957d438fb$var$saturation_1,
    sepia: $012b80a957d438fb$var$sepia_1,
    shade: $012b80a957d438fb$var$shade_1,
    temperature: $012b80a957d438fb$var$temperature_1,
    tetrad: $012b80a957d438fb$var$tetrad_1,
    triad: $012b80a957d438fb$var$triad_1
}, $012b80a957d438fb$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $012b80a957d438fb$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $012b80a957d438fb$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($012b80a957d438fb$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $012b80a957d438fb$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($012b80a957d438fb$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $012b80a957d438fb$var$api_1 = $012b80a957d438fb$var$api, $012b80a957d438fb$var$helpers = {
    getIlluminant: function(r) {
        return $012b80a957d438fb$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $012b80a957d438fb$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $012b80a957d438fb$var$index)if ($012b80a957d438fb$var$index.hasOwnProperty(e) && $012b80a957d438fb$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $012b80a957d438fb$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $012b80a957d438fb$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $012b80a957d438fb$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $012b80a957d438fb$var$constants, s));
            default:
                return null;
        }
    }
}, $012b80a957d438fb$var$helpers_1 = $012b80a957d438fb$var$helpers, $012b80a957d438fb$var$dependencies = {
    conversions: $012b80a957d438fb$var$index,
    operations: $012b80a957d438fb$var$index$2,
    helpers: $012b80a957d438fb$var$helpers_1
}, $012b80a957d438fb$var$entry = $012b80a957d438fb$var$api_1($012b80a957d438fb$var$dependencies, $012b80a957d438fb$var$constants);
var $012b80a957d438fb$export$2e2bcd8739ae039 = $012b80a957d438fb$var$entry;

});






parcelRegister("4iCt5", function(module, exports) {
$parcel$export(module.exports, "getIconButtonTheme", () => $8beb982e421fb95c$export$f32bddcb857301f3);
const $8beb982e421fb95c$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("krExN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a9109095f0a9b69c0b01202dc3ed5e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03d751ab2f076413$var$_react = $03d751ab2f076413$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $03d751ab2f076413$var$_baseNew = $03d751ab2f076413$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $03d751ab2f076413$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03d751ab2f076413$var$EditionsIcon = (props)=>/*#__PURE__*/ $03d751ab2f076413$var$_react.default.createElement($03d751ab2f076413$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$03d751ab2f076413$var$EditionsIcon.displayName = 'EditionsIcon';
var $03d751ab2f076413$var$_default = module.exports.default = $03d751ab2f076413$var$EditionsIcon;

});

parcelRegister("lkatq", function(module, exports) {
$parcel$export(module.exports, "default", () => $5708405eb3296536$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $9uKqY = parcelRequire("9uKqY");

var $cA7Yr = parcelRequire("cA7Yr");
const $5708405eb3296536$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $5708405eb3296536$var$CustomItem = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $8P7DW.useContext)((0, $9uKqY.default));
    const handleClick = (0, $8P7DW.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cA7Yr.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $5708405eb3296536$var$preventEvent
                },
                onMouseDown: isDisabled ? $5708405eb3296536$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $5708405eb3296536$var$preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled,
                children: children
            })
    });
}));
var $5708405eb3296536$export$2e2bcd8739ae039 = $5708405eb3296536$var$CustomItem;

});

parcelRegister("rV4PT", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb6eeac7ac8c9a6a$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $fb6eeac7ac8c9a6a$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $fb6eeac7ac8c9a6a$var$HeadingItem = /*#__PURE__*/ (0, $8P7DW.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8n1kL.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ]),
        ...rest,
        children: children
    });
});
var $fb6eeac7ac8c9a6a$export$2e2bcd8739ae039 = $fb6eeac7ac8c9a6a$var$HeadingItem;

});

parcelRegister("3rCJZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0301b8b6d9049ef7$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $kFogY = parcelRequire("kFogY");
const $0301b8b6d9049ef7$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $0301b8b6d9049ef7$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $kFogY.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $kFogY.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $8n1kL.default)([
                    "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
                    UNSAFE_className
                ]),
                "aria-label": menuLabel,
                ...rest
            })
        })
    });
var $0301b8b6d9049ef7$export$2e2bcd8739ae039 = $0301b8b6d9049ef7$var$MenuGroup;

});

parcelRegister("7qJSw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5931b82c3a861f$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $rV4PT = parcelRequire("rV4PT");
const $0c5931b82c3a861f$var$itemHeadingTopMargin = 20;
const $0c5931b82c3a861f$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $0c5931b82c3a861f$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $0c5931b82c3a861f$var$skeletonHeadingHeight = 8;
const $0c5931b82c3a861f$var$skeletonHeadingMarginOffset = 3;
const $0c5931b82c3a861f$var$skeletonHeadingTopMargin = $0c5931b82c3a861f$var$itemHeadingTopMargin + ($0c5931b82c3a861f$var$itemHeadingContentHeight - $0c5931b82c3a861f$var$skeletonHeadingHeight) - $0c5931b82c3a861f$var$skeletonHeadingMarginOffset;
const $0c5931b82c3a861f$var$sectionPaddingTopBottom = 6;
const $0c5931b82c3a861f$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $0c5931b82c3a861f$var$Section = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ (0, $gWgPx.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, $8P7DW.Children).map((0, $8P7DW.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $gWgPx.jsx)("li", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index))
    }) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $rV4PT.default), {
                testId: testId && `${testId}--heading`,
                "aria-hidden": true,
                // @ts-expect-error
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, $8n1kL.default)([
                    isSideNavSection && $0c5931b82c3a861f$var$styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8n1kL.default)([
            $0c5931b82c3a861f$var$styles.root,
            isScrollable ? $0c5931b82c3a861f$var$styles.scrollable : $0c5931b82c3a861f$var$styles.unscrollable,
            hasSeparator ? $0c5931b82c3a861f$var$styles.thinSeparator : $0c5931b82c3a861f$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    });
});
var $0c5931b82c3a861f$export$2e2bcd8739ae039 = $0c5931b82c3a861f$var$Section;

});

parcelRegister("33zHl", function(module, exports) {
$parcel$export(module.exports, "default", () => $10f45139940a4066$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $cBwgz = parcelRequire("cBwgz");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $10f45139940a4066$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBwgz.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
var $10f45139940a4066$export$2e2bcd8739ae039 = $10f45139940a4066$var$ModalTransition;

});

parcelRegister("1P5py", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a04751840b6799b$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $7t30w = parcelRequire("7t30w");

var $5JQIe = parcelRequire("5JQIe");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $5a04751840b6799b$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $5JQIe.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef === null || getTargetRef === void 0 ? void 0 : getTargetRef(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7t30w.default), {
                name: name,
                hasNodeResolver: !(0, $e6Qdr.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$5a04751840b6799b$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $5a04751840b6799b$export$2e2bcd8739ae039 = $5a04751840b6799b$var$SpotlightTarget;

});
parcelRegister("7t30w", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc00a50ed052a5ff$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $aoo6d = parcelRequire("aoo6d");
const $dc00a50ed052a5ff$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $dc00a50ed052a5ff$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $8P7DW.useRef)(null);
    (0, $8P7DW.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) {
            var _divRef$current;
            targetRef((_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.firstElementChild);
        }
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aoo6d))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        ref: divRef,
        className: (0, $8n1kL.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$dc00a50ed052a5ff$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $dc00a50ed052a5ff$export$2e2bcd8739ae039 = $dc00a50ed052a5ff$var$NodeResolverSpotlightTarget;

});
parcelRegister("aoo6d", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $79SBy = parcelRequire("79SBy");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $790ed6e01c13106f$var$_interopRequireDefault($79SBy).default;
    }
});
function $790ed6e01c13106f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("79SBy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5363bb0a4f542b4a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");
function $5363bb0a4f542b4a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5363bb0a4f542b4a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5363bb0a4f542b4a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5363bb0a4f542b4a$var$NodeResolver = function(_Component) {
    $5363bb0a4f542b4a$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $5363bb0a4f542b4a$var$_classCallCheck(this, NodeResolver);
        return $5363bb0a4f542b4a$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $5363bb0a4f542b4a$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $6Q1OD.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($8P7DW.Component);
module.exports.default = $5363bb0a4f542b4a$var$NodeResolver;

});




parcelRegister("4MINV", function(module, exports) {
$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $25a0c276bac46992$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $25a0c276bac46992$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $5J6r2 = parcelRequire("5J6r2");
const $25a0c276bac46992$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $8P7DW.createContext)({
    isOpen: true,
    onExited: (0, $5J6r2.default)
});
// checks if children exist and are truthy
const $25a0c276bac46992$var$hasChildren = (children)=>{
    var _React$Children$map;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.count(children) > 0 && (((_React$Children$map = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map(children || false, (child)=>!!child)) === null || _React$Children$map === void 0 || (_React$Children$map = _React$Children$map.filter(Boolean)) === null || _React$Children$map === void 0 ? void 0 : _React$Children$map.length) || 0) > 0;
};
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $25a0c276bac46992$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $25a0c276bac46992$var$hasChildren(previousChildren) && !$25a0c276bac46992$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, $gWgPx.jsx)($25a0c276bac46992$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $25a0c276bac46992$var$hasChildren(this.props.children)
            },
            children: this.state.currentChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $25a0c276bac46992$export$7d63b19b854c2fe8 = $25a0c276bac46992$var$SpotlightTransitionContext.Consumer;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$25a0c276bac46992$export$2e2bcd8739ae039 = $25a0c276bac46992$var$SpotlightTransition;

});

parcelRegister("8vv1J", function(module, exports) {
$parcel$export(module.exports, "FireUIAnalytics", () => $58872b3ce4acc2bb$export$1f3555c9be6c5e08);
$parcel$export(module.exports, "FireTrackAnalytics", () => $58872b3ce4acc2bb$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireScreenAnalytics", () => $58872b3ce4acc2bb$export$2ccf161b817b43b);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $k7ZVu = parcelRequire("k7ZVu");

var $17wqU = parcelRequire("17wqU");

var $8LbZn = parcelRequire("8LbZn");
const $58872b3ce4acc2bb$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $58872b3ce4acc2bb$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $58872b3ce4acc2bb$var$FireComponent extends (0, $8P7DW.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $58872b3ce4acc2bb$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $58872b3ce4acc2bb$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8LbZn.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $58872b3ce4acc2bb$var$WithAnalytics = (0, $k7ZVu.default)()($58872b3ce4acc2bb$var$FireComponent);
const $58872b3ce4acc2bb$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)($58872b3ce4acc2bb$var$WithAnalytics, {
        ...props,
        type: (0, $17wqU.UI_EVENT_TYPE)
    });
const $58872b3ce4acc2bb$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)($58872b3ce4acc2bb$var$WithAnalytics, {
        ...props,
        type: (0, $17wqU.TRACK_EVENT_TYPE)
    });
const $58872b3ce4acc2bb$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)($58872b3ce4acc2bb$var$WithAnalytics, {
        ...props,
        type: (0, $17wqU.OPERATIONAL_EVENT_TYPE)
    });
const $58872b3ce4acc2bb$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, $gWgPx.jsx)($58872b3ce4acc2bb$var$WithAnalytics, {
        ...props,
        type: (0, $17wqU.SCREEN_EVENT_TYPE),
        eventName: "screen viewed"
    });

});

parcelRegister("cLmLE", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAri", () => $94ab88fcf761132f$export$a75f3c98d930b258);

var $f3tnO = parcelRequire("f3tnO");

var $jmrxw = parcelRequire("jmrxw");

var $6LWYQ = parcelRequire("6LWYQ");
// src/help/help-center/manifest.ts
var $94ab88fcf761132f$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $f3tnO.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $f3tnO.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/help/help-center/index.ts
var $94ab88fcf761132f$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $jmrxw.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $94ab88fcf761132f$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $94ab88fcf761132f$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $94ab88fcf761132f$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $94ab88fcf761132f$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $6LWYQ.AriParser).fromOpts(derivedOpts, $94ab88fcf761132f$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6LWYQ.AriParser).fromString(maybeAri, $94ab88fcf761132f$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("f3tnO", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $af5dedab98638471$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $af5dedab98638471$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $af5dedab98638471$export$a4af98a27b4568ee = "help", $af5dedab98638471$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("81QBf", function(module, exports) {
$parcel$export(module.exports, "PremiumBenefitModalTrigger", () => $7b30f23657797a45$export$6f0c4c8beb8e608a);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");

var $i4z8R = parcelRequire("i4z8R");

var $acPbP = parcelRequire("acPbP");

var $58Vjn = parcelRequire("58Vjn");

var $9P9Ji = parcelRequire("9P9Ji");

var $fDBmw = parcelRequire("fDBmw");

var $bsh8H = parcelRequire("bsh8H");

var $gN8If = parcelRequire("gN8If");

var $ab22O = parcelRequire("ab22O");

var $cAMvy = parcelRequire("cAMvy");

var $dsT7Z = parcelRequire("dsT7Z");
const $7b30f23657797a45$var$PremiumBenefitModalTriggerBase = ({ cloudId: cloudId, product: product, children: children, variantId: variantId, touchpointId: touchpointId, edition: edition, ...pressableProps })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fDBmw.useAnalytics)();
    const { onClick: originalOnClick, ...restPressableProps } = pressableProps;
    const handleOnClick = (0, $8P7DW.useCallback)((e, analyticsEvent)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                touchpointId: touchpointId,
                product: product,
                edition: edition,
                variantId: variantId
            }
        });
        // Call the original onClick if it exists
        originalOnClick === null || originalOnClick === void 0 || originalOnClick(e, analyticsEvent);
    }, [
        sendAnalyticsEvent,
        variantId,
        touchpointId,
        product,
        edition,
        originalOnClick
    ]);
    const handleOnClose = (0, $8P7DW.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismiss',
            actionSubject: 'modal',
            actionSubjectId: 'editionBenefitsModal',
            attributes: {
                touchpointId: touchpointId,
                product: product,
                edition: edition,
                variantId: variantId
            }
        });
    }, [
        sendAnalyticsEvent,
        variantId,
        touchpointId,
        product,
        edition
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $acPbP.ModalTrigger), {
                entryPoint: (0, $dsT7Z.premiumEditionBenefitsModalEntryPoint),
                entryPointParams: {
                    cloudId: cloudId,
                    product: product
                },
                entryPointProps: {
                    variantId: variantId,
                    touchpointId: touchpointId,
                    edition: edition,
                    onClose: handleOnClose
                },
                modalProps: (0, $bsh8H.MODAL_CONFIG),
                children: ({ ref: ref })=>children ? children({
                        ref: ref,
                        props: {
                            ...restPressableProps,
                            onClick: handleOnClick
                        }
                    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $58Vjn.DiscoveryCTAButton), {
                        ref: ref,
                        buttonStyle: "default",
                        ...restPressableProps,
                        onClick: handleOnClick,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                            ...(0, $cAMvy.messages).buttonTriggerTryItFree
                        })
                    })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9P9Ji.UiViewedEvent), {
                actionSubject: "modalTrigger",
                actionSubjectId: "editionBenefitsModalTrigger",
                attributes: {
                    touchpointId: touchpointId,
                    product: product,
                    edition: edition,
                    variantId: variantId
                }
            })
        ]
    });
};
const $7b30f23657797a45$export$6f0c4c8beb8e608a = ({ cloudId: cloudId, product: product, children: children, variantId: variantId, touchpointId: touchpointId, edition: edition, useInternalModalContextProvider: useInternalModalContextProvider, ...pressableProps })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ab22O.ErrorBoundary), {
        variantId: variantId,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gN8If.IntlProvider), {
            children: useInternalModalContextProvider ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $i4z8R.ModalContextProvider), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)($7b30f23657797a45$var$PremiumBenefitModalTriggerBase, {
                    cloudId: cloudId,
                    product: product,
                    children: children,
                    variantId: variantId,
                    touchpointId: touchpointId,
                    edition: edition,
                    ...pressableProps
                })
            }) : /*#__PURE__*/ (0, $gWgPx.jsx)($7b30f23657797a45$var$PremiumBenefitModalTriggerBase, {
                cloudId: cloudId,
                product: product,
                children: children,
                variantId: variantId,
                touchpointId: touchpointId,
                edition: edition,
                ...pressableProps
            })
        })
    });
};

});
parcelRegister("i4z8R", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $bc58a8985f76b882$export$7c9538f5f3c365e9);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $33zHl = parcelRequire("33zHl");

var $1BV22 = parcelRequire("1BV22");
const $bc58a8985f76b882$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $8P7DW.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $8P7DW.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $bc58a8985f76b882$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $8P7DW.useRef)(1);
    const [modals, setModals] = (0, $8P7DW.useState)([]);
    const modalContext = (0, $8P7DW.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $1BV22.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $33zHl.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $gWgPx.jsx)($bc58a8985f76b882$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}

});
parcelRegister("1BV22", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $315095d3619950ab$export$ab57792b9b6974a6);

var $8P7DW = parcelRequire("8P7DW");
const $315095d3619950ab$export$ab57792b9b6974a6 = (0, $8P7DW.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});

});


parcelRegister("acPbP", function(module, exports) {
$parcel$export(module.exports, "ModalTrigger", () => $048ada6082256c2f$export$fb10b32cfe19f1e);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $h3cOB = parcelRequire("h3cOB");

var $b0nWD = parcelRequire("b0nWD");

var $jJBf1 = parcelRequire("jJBf1");

var $gtaKc = parcelRequire("gtaKc");
var $7KiOn = parcelRequire("7KiOn");
var $fCWQD = parcelRequire("fCWQD");
var $9euwv = parcelRequire("9euwv");
var $gMGo9 = parcelRequire("gMGo9");

var $6E5P5 = parcelRequire("6E5P5");

var $4XKaS = parcelRequire("4XKaS");

var $1BV22 = parcelRequire("1BV22");

var $2qZWF = parcelRequire("2qZWF");

var $2v83k = parcelRequire("2v83k");

var $1I66f = parcelRequire("1I66f");
const $048ada6082256c2f$var$emptyEntryPointParams = {};
const $048ada6082256c2f$var$emptyEntryPointProps = {};
function $048ada6082256c2f$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus = true }) {
    const { openModal: openModal } = (0, $8P7DW.useContext)((0, $1BV22.ModalContext));
    const environmentProvider = (0, $1I66f.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $4XKaS.useEntryPointConfig)();
    const metricName = (0, $8P7DW.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $8P7DW.useCallback)(()=>(0, $h3cOB.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $048ada6082256c2f$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $8P7DW.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                var _entryPointProps$onCl;
                entryPointProps === null || entryPointProps === void 0 || (_entryPointProps$onCl = entryPointProps.onClose) === null || _entryPointProps$onCl === void 0 || _entryPointProps$onCl.call(entryPointProps, extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9euwv.default), {
                        children: title ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gMGo9.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6E5P5.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jJBf1.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $7KiOn.default), {
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jJBf1.default), {}),
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jJBf1.default), {}),
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jJBf1.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fCWQD.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2v83k.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $gWgPx.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError === null || onError === void 0 || onError({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $gWgPx.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $048ada6082256c2f$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gtaKc.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? (modalProps === null || modalProps === void 0 ? void 0 : modalProps.shouldCloseOnOverlayClick),
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? (modalProps === null || modalProps === void 0 ? void 0 : modalProps.shouldCloseOnEscapePress),
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $2qZWF.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $b0nWD.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("jJBf1", function(module, exports) {
$parcel$export(module.exports, "default", () => $886c7e1710908bdb$export$2e2bcd8739ae039);
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $886c7e1710908bdb$var$skeletonItemElemSize = 20;
const $886c7e1710908bdb$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $886c7e1710908bdb$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a bug when using
 * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
 */ const $886c7e1710908bdb$var$shimmerStyles = null;
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $886c7e1710908bdb$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $8n1kL.default)([
            $886c7e1710908bdb$var$styles.root,
            (hasAvatar || hasIcon) && $886c7e1710908bdb$var$styles.beforeElement,
            hasAvatar && $886c7e1710908bdb$var$styles.avatar,
            hasIcon && $886c7e1710908bdb$var$styles.icon,
            width ? $886c7e1710908bdb$var$styles.customWidth : $886c7e1710908bdb$var$styles.defaultWidth,
            isSideNavSkeleton && $886c7e1710908bdb$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $886c7e1710908bdb$export$2e2bcd8739ae039 = $886c7e1710908bdb$var$SkeletonItem;

});

parcelRegister("fCWQD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8d5567a24b388885$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $4pgQo = parcelRequire("4pgQo");
const $8d5567a24b388885$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $8d5567a24b388885$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $4pgQo.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ]),
        children: children
    });
};
var $8d5567a24b388885$export$2e2bcd8739ae039 = $8d5567a24b388885$var$ModalFooter;

});

parcelRegister("9euwv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7231648b81165964$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");
parcelRequire("8P7DW");

var $3iEm8 = parcelRequire("3iEm8");

var $cdPbd = parcelRequire("cdPbd");

var $4pgQo = parcelRequire("4pgQo");
const $7231648b81165964$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $7231648b81165964$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $4pgQo.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            $7231648b81165964$var$styles.header
        ]),
        children: shouldShowCloseButton ? /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $3iEm8.default), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $7231648b81165964$var$styles.flex,
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3iEm8.default), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cdPbd.CloseButton), {
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3iEm8.default), {
                    justifyContent: "start",
                    alignItems: "center",
                    xcss: $7231648b81165964$var$styles.titleContainer,
                    children: children
                })
            ]
        }) : children
    });
};
var $7231648b81165964$export$2e2bcd8739ae039 = $7231648b81165964$var$ModalHeader;

});
parcelRegister("cdPbd", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $bd146a81d080f483$export$de65de8213222d10);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $lRscM = parcelRequire("lRscM");

var $b9hQ0 = parcelRequire("b9hQ0");
const $bd146a81d080f483$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $lRscM.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });

});


parcelRegister("gMGo9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2540c7ea82c532c6$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $h82Rb = parcelRequire("h82Rb");

var $gKWTh = parcelRequire("gKWTh");

var $4pgQo = parcelRequire("4pgQo");
const $2540c7ea82c532c6$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $2540c7ea82c532c6$var$iconStyles = null;
const $2540c7ea82c532c6$var$titleStyles = null;
const $2540c7ea82c532c6$var$textStyles = null;
const $2540c7ea82c532c6$var$truncatedTextStyles = null;
const $2540c7ea82c532c6$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))) : (0, (/*@__PURE__*/$parcel$interopDefault($gKWTh)));
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        className: (0, $8n1kL.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)(Icon, {
            label: appearance,
            color: $2540c7ea82c532c6$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $2540c7ea82c532c6$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $4pgQo.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $gWgPx.jsx)($2540c7ea82c532c6$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $8n1kL.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _11c81af2 _1ul9idpf _slp31hna",
                    !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
var $2540c7ea82c532c6$export$2e2bcd8739ae039 = $2540c7ea82c532c6$var$ModalTitle;

});

parcelRegister("4XKaS", function(module, exports) {
$parcel$export(module.exports, "useEntryPointConfig", () => $b743db2afca5c9d4$export$dfa96f26176fa91f);

var $ki2OF = parcelRequire("ki2OF");

var $bZZgp = parcelRequire("bZZgp");
const $b743db2afca5c9d4$var$DefaultUFOSegmentComponent = (0, $bZZgp.default);
const $b743db2afca5c9d4$var$entryPointConfig = {
    PlaceholderComponent: (0, $ki2OF.default),
    UFOSegmentComponent: $b743db2afca5c9d4$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $b743db2afca5c9d4$export$93a6801f9db838c4(overrides) {
    Object.assign($b743db2afca5c9d4$var$entryPointConfig, overrides);
    return $b743db2afca5c9d4$var$entryPointConfig;
}
function $b743db2afca5c9d4$export$dfa96f26176fa91f() {
    return $b743db2afca5c9d4$var$entryPointConfig;
}

});
parcelRegister("ki2OF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7da2525938549fc9$export$2e2bcd8739ae039);

var $75WdT = parcelRequire("75WdT");
var $7da2525938549fc9$export$2e2bcd8739ae039 = (0, $75WdT.default);

});
parcelRegister("75WdT", function(module, exports) {
$parcel$export(module.exports, "default", () => $19be4114e11214bc$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $4peLG = parcelRequire("4peLG");

var $2Hw1M = parcelRequire("2Hw1M");
var $kCfS2 = parcelRequire("kCfS2");
function $19be4114e11214bc$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $8P7DW.useContext)((0, $kCfS2.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2Hw1M.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}

});
parcelRegister("2Hw1M", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $568bc28c1f5e7398$export$256c542058532d6f);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $568bc28c1f5e7398$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $568bc28c1f5e7398$var$LazySuspenseContext = /*#__PURE__*/ (0, $8P7DW.createContext)({
    fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $568bc28c1f5e7398$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext($568bc28c1f5e7398$var$LazySuspenseContext);
    (0, $8P7DW.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$568bc28c1f5e7398$var$DynamicFallback.displayName = 'DynamicFallback';
const $568bc28c1f5e7398$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $8P7DW.useState)(null);
    const mountedRef = (0, $8P7DW.useRef)(false);
    (0, $8P7DW.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $8P7DW.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $gWgPx.jsx)($568bc28c1f5e7398$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $gWgPx.jsx)($568bc28c1f5e7398$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $568bc28c1f5e7398$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$568bc28c1f5e7398$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("kCfS2", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $475be5fd6e9a8b54$export$9ba3fe09d15de47b);

var $8P7DW = parcelRequire("8P7DW");
const $475be5fd6e9a8b54$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $8P7DW.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});




parcelRegister("2qZWF", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $3352a075f9982a92$export$1ff47f24e06a5d2d);

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $bxb2K = parcelRequire("bxb2K");
function $3352a075f9982a92$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $8P7DW.useRef)(null);
    const eventListeners = (0, $8P7DW.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $bxb2K.useEntryPointPreload)(load);
    const clickListener = (0, $8P7DW.useMemo)(()=>{
        return ()=>{
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $8P7DW.useMemo)(()=>{
        return ()=>{
            eagerLoad();
        };
    }, [
        eagerLoad
    ]);
    const cleanUpEventListeners = (0, $8P7DW.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $8P7DW.useCallback)((element, type, callback)=>{
        const unbind = (0, $36kyW.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $8P7DW.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $8P7DW.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}

});
parcelRegister("bxb2K", function(module, exports) {
$parcel$export(module.exports, "useEntryPointPreload", () => $06d2ce27e9eadd0d$export$57effc2a5e3611f);

var $8P7DW = parcelRequire("8P7DW");
const $06d2ce27e9eadd0d$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $06d2ce27e9eadd0d$var$TIME_TO_INTENT = 200;
function $06d2ce27e9eadd0d$export$57effc2a5e3611f(load) {
    return (0, $8P7DW.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            var _request$preload;
            clearPreloadTimeouts();
            (_request$preload = request.preload) === null || _request$preload === void 0 || _request$preload.dispose();
        };
        const loadReference = ()=>{
            var _request$preload2;
            if (request.load) return request.load;
            const reference = ((_request$preload2 = request.preload) === null || _request$preload2 === void 0 ? void 0 : _request$preload2.reference) ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    var _request$preload3;
                    delete request.preloadMaxAgeTimeout;
                    (_request$preload3 = request.preload) === null || _request$preload3 === void 0 || _request$preload3.dispose();
                }, $06d2ce27e9eadd0d$var$PRELOAD_MAX_AGE);
            }, $06d2ce27e9eadd0d$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
}

});


parcelRegister("2v83k", function(module, exports) {
$parcel$export(module.exports, "InternalEntryPointContainer", () => $10917bad547878a3$export$5d4dc37edd8a3adb);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $dCWA1 = parcelRequire("dCWA1");

var $h3cOB = parcelRequire("h3cOB");

var $9It0a = parcelRequire("9It0a");

var $3hZD0 = parcelRequire("3hZD0");

var $4XKaS = parcelRequire("4XKaS");
function $10917bad547878a3$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4XKaS.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $9It0a.useUFOReportError)();
    const onError = (0, $8P7DW.useCallback)((error, errorInfo)=>{
        onErrorLocal === null || onErrorLocal === void 0 || onErrorLocal({
            error: error,
            errorInfo: errorInfo
        });
        (0, $3hZD0.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) ?? 'Unknown error',
            errorStack: (error === null || error === void 0 ? void 0 : error.stack) ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $8P7DW.useCallback)(({ error: error })=>{
        const onClose = (runtimeProps === null || runtimeProps === void 0 ? void 0 : runtimeProps.onClose) ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dCWA1.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $h3cOB.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $10917bad547878a3$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4XKaS.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($10917bad547878a3$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}

});
parcelRegister("9It0a", function(module, exports) {
$parcel$export(module.exports, "useUFOReportError", () => $15eb02a18a076507$export$75d40f522062f923);

var $18KuK = parcelRequire("18KuK");

var $9TwI7 = parcelRequire("9TwI7");
function $15eb02a18a076507$export$75d40f522062f923() {
    const ufoContext = (0, $18KuK.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, $9TwI7.getActiveInteraction)();
        if (interaction !== null && interaction !== void 0 && interaction.id) (0, $9TwI7.addError)(interaction.id, error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, $9TwI7.addErrorToAll)(error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
}

});

parcelRegister("3hZD0", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $f169e41adb25d3fb$export$b33b857ad1d9900e);

var $e6Qdr = parcelRequire("e6Qdr");
const $f169e41adb25d3fb$var$buffer = [];
let $f169e41adb25d3fb$var$push = (payload)=>{
    $f169e41adb25d3fb$var$buffer.push(payload);
};
function $f169e41adb25d3fb$export$b33b857ad1d9900e(payload) {
    $f169e41adb25d3fb$var$push(payload);
}
function $f169e41adb25d3fb$export$abd5747ea77ecab9(handler) {
    if ((0, $e6Qdr.fg)('moving_jira_entry-points_api_under_platform')) {
        $f169e41adb25d3fb$var$push = handler;
        $f169e41adb25d3fb$var$buffer.forEach((payload)=>handler(payload));
        $f169e41adb25d3fb$var$buffer.length = 0;
    }
}

});


parcelRegister("1I66f", function(module, exports) {
$parcel$export(module.exports, "AtlassianRelayEnvironmentProvider", () => $2af1598e45c2630e$export$6c22afad970ad5ac);
$parcel$export(module.exports, "ConditionalRelayEnvironmentProvider", () => $2af1598e45c2630e$export$2f6292af3d34630d);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $2af1598e45c2630e$export$e237a628f59c9f4e);

var $8P7DW = parcelRequire("8P7DW");

var $h3cOB = parcelRequire("h3cOB");

var $dgYZM = parcelRequire("dgYZM");
function $2af1598e45c2630e$export$6c22afad970ad5ac({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $h3cOB.RelayEnvironmentProvider), {
        environment: (0, $dgYZM.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__)
    }, children);
}
const $2af1598e45c2630e$export$43b1f3e917d65526 = $2af1598e45c2630e$export$6c22afad970ad5ac;
const $2af1598e45c2630e$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $8P7DW.useContext)((0, $h3cOB.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($2af1598e45c2630e$export$6c22afad970ad5ac, null, children);
};
function $2af1598e45c2630e$export$e237a628f59c9f4e() {
    const environment = (0, $h3cOB.useRelayEnvironment)();
    return (0, $8P7DW.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("dgYZM", function(module, exports) {
$parcel$export(module.exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", () => $32b711772e73e9d8$export$df54517d175e6d6b);

var $e6Qdr = parcelRequire("e6Qdr");

var $jHrvS = parcelRequire("jHrvS");

var $7GemC = parcelRequire("7GemC");

var $jDRQ1 = parcelRequire("jDRQ1");
const $32b711772e73e9d8$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $32b711772e73e9d8$export$4a639ebead870a0c = new (0, $jDRQ1.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $32b711772e73e9d8$export$df54517d175e6d6b = (0, $jHrvS.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $32b711772e73e9d8$var$getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                var _response$extensions;
                const requestId = response === null || response === void 0 || (_response$extensions = response.extensions) === null || _response$extensions === void 0 || (_response$extensions = _response$extensions.gateway) === null || _response$extensions === void 0 ? void 0 : _response$extensions.request_id;
                (0, $7GemC.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $e6Qdr.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $7GemC.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $32b711772e73e9d8$export$4a639ebead870a0c,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.__SERVER__.
        // __SERVER__ is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});

});
parcelRegister("7GemC", function(module, exports) {
$parcel$export(module.exports, "captureErrors", () => $018d49cb3e8b2d7a$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isStepUpAuthError", () => $018d49cb3e8b2d7a$export$60fba4117567a49b);

var $gdnRs = parcelRequire("gdnRs");
const $018d49cb3e8b2d7a$var$errorCollector = new Map();
const $018d49cb3e8b2d7a$export$da396ad2a542b095 = 120000; // 2min
const $018d49cb3e8b2d7a$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $018d49cb3e8b2d7a$var$errorCollector.delete(key);
    }, $018d49cb3e8b2d7a$export$da396ad2a542b095);
};
const $018d49cb3e8b2d7a$export$c211170518c6d0f6 = (key = (0, $gdnRs.v4)())=>{
    $018d49cb3e8b2d7a$var$errorCollector.set(key, []);
    $018d49cb3e8b2d7a$var$scheduleCleanup(key);
    return key;
};
const $018d49cb3e8b2d7a$export$e0491a0d974dadfa = (key)=>{
    const errors = $018d49cb3e8b2d7a$var$errorCollector.get(key);
    $018d49cb3e8b2d7a$var$errorCollector.delete(key);
    return errors || [];
};
const $018d49cb3e8b2d7a$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $018d49cb3e8b2d7a$var$errorCollector.forEach((value, key)=>{
        $018d49cb3e8b2d7a$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $018d49cb3e8b2d7a$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
const $018d49cb3e8b2d7a$export$60fba4117567a49b = (errors)=>{
    var _stepUpError$extensio;
    const stepUpError = errors.find((error)=>{
        var _error$extensions, _error$extensions2;
        return error.message.startsWith('Step-up authentication is required.') && ((_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode) === 303 && ((_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.stepUpUrl);
    });
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: (stepUpError === null || stepUpError === void 0 || (_stepUpError$extensio = stepUpError.extensions) === null || _stepUpError$extensio === void 0 ? void 0 : _stepUpError$extensio.stepUpUrl) ?? undefined
    };
};

});

parcelRegister("jDRQ1", function(module, exports) {
$parcel$export(module.exports, "SSRQueryResponseCache", () => $3385aad5680fc9f0$export$be21c283b097d175);

var $8iTFq = parcelRequire("8iTFq");
function $3385aad5680fc9f0$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $8iTFq.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $3385aad5680fc9f0$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $3385aad5680fc9f0$export$be21c283b097d175 extends (0, $8iTFq.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        var _window, _window2, _window3;
        super({
            size: size,
            ttl: ttl
        });
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : ((_window = window) === null || _window === void 0 || (_window = _window.SPA_STATE) === null || _window === void 0 ? void 0 : _window[cacheName]) || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.SKELETON_NAVIGATION) === null || _window2 === void 0 ? void 0 : _window2[cacheName]) || ((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.__PLATFORM_SSR_AGG_CACHE__) === null || _window3 === void 0 ? void 0 : _window3[cacheName]) || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback === null || timeoutCallback === void 0 || timeoutCallback(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $3385aad5680fc9f0$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}

});




parcelRegister("58Vjn", function(module, exports) {
$parcel$export(module.exports, "DiscoveryCTAButton", () => $7b6bdbe3cb70ac4c$export$1f81fec3cd5490ae);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6NJAV = parcelRequire("6NJAV");

var $krExN = parcelRequire("krExN");

var $e6Qdr = parcelRequire("e6Qdr");

var $2CGHX = parcelRequire("2CGHX");
var $iPrfN = parcelRequire("iPrfN");
var $bgvtM = parcelRequire("bgvtM");
const $7b6bdbe3cb70ac4c$var$styles = {
    base: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko12b0 _v5649dqc _1e0c116y _u5f3utpp _19bvu2gc _ca0qidpf _n3tdidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _o5721q9c",
    baseT26Shape: "_2rko1qi0",
    defaultSpacing: "_1tkezwfg",
    compactSpacing: "_1tke1tcg",
    default: "_syaz15cr _bfhkya33 _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31af5 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _1di66cze",
    inverted: "_189ee4h9 _1dqonqa1 _1h6d1hqq _syazdv2p _bfhkvuon _9oik1r31 _1bnxglyw _jf4cnqa1 _irr3kca2 _30l3dv2p _1nrm1r31 _c2waglyw _1iohnqa1 _1di61jbm",
    subtle: "_bfhksm61 _syazqmo9 _o5721q9c _irr3kca2 _1di61jbm",
    contentContainer: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    iconContainer: "_1e0c1txw _1bsb1tcg _4t3i1tcg _1bah1h6o _4cvr1h6o"
};
const $7b6bdbe3cb70ac4c$export$1f81fec3cd5490ae = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ buttonStyle: buttonStyle, children: children, spacing: spacing, ...buttonProps }, ref)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bgvtM.default), {
        ref: ref,
        ...buttonProps,
        xcss: (0, $6NJAV.cx)($7b6bdbe3cb70ac4c$var$styles.base, (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $7b6bdbe3cb70ac4c$var$styles.baseT26Shape, buttonStyle === 'default' && $7b6bdbe3cb70ac4c$var$styles.default, buttonStyle === 'inverted' && $7b6bdbe3cb70ac4c$var$styles.inverted, buttonStyle === 'subtle' && $7b6bdbe3cb70ac4c$var$styles.subtle, spacing === 'compact' ? $7b6bdbe3cb70ac4c$var$styles.compactSpacing : $7b6bdbe3cb70ac4c$var$styles.defaultSpacing),
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $2CGHX.default), {
            xcss: $7b6bdbe3cb70ac4c$var$styles.contentContainer,
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                    xcss: $7b6bdbe3cb70ac4c$var$styles.iconContainer,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($krExN))), {
                        label: ""
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iPrfN.default), {
                    children: children
                })
            ]
        })
    });
});

});

parcelRegister("9P9Ji", function(module, exports) {
$parcel$export(module.exports, "UiViewedEvent", () => $19ee68ea1d82f2f0$export$d0a9edec5c713764);

var $8P7DW = parcelRequire("8P7DW");

var $fDBmw = parcelRequire("fDBmw");
function $19ee68ea1d82f2f0$export$d0a9edec5c713764({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fDBmw.useAnalytics)();
    const hasSent = (0, $8P7DW.useRef)(false);
    (0, $8P7DW.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});
parcelRegister("fDBmw", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $72616262d0c55d7f$export$e955abb82869dc84);
$parcel$export(module.exports, "useOperationalAnalytics", () => $72616262d0c55d7f$export$18e9461e904f638a);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("jp3Ur");
var $1s1Af = parcelRequire("1s1Af");

var $hlZhv = parcelRequire("hlZhv");
var $MmGmU = parcelRequire("MmGmU");
const $72616262d0c55d7f$export$85183a312807388d = (0, $1s1Af.FabricChannel).growth;
const $72616262d0c55d7f$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-benefits-modal',
    source: 'editionBenefitsModal'
};
const $72616262d0c55d7f$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $72616262d0c55d7f$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const sendAnalyticsEvent = (0, $8P7DW.useCallback)((payload)=>{
        if (payload instanceof (0, $hlZhv.default)) {
            const contextAttributes = $72616262d0c55d7f$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...payload.payload.attributes,
                    ...$72616262d0c55d7f$export$38cd8db2db178f58
                }
            }).fire($72616262d0c55d7f$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    ...$72616262d0c55d7f$export$38cd8db2db178f58
                }
            });
            const contextAttributes = $72616262d0c55d7f$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($72616262d0c55d7f$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
};
function $72616262d0c55d7f$export$18e9461e904f638a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    return (0, $8P7DW.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...$72616262d0c55d7f$export$38cd8db2db178f58,
                ...attributes
            }
        });
        const contextAttributes = $72616262d0c55d7f$export$d97c97ed77ff09e8(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire($72616262d0c55d7f$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
}

});


parcelRegister("bsh8H", function(module, exports) {
$parcel$export(module.exports, "MODAL_CONFIG", () => $cce71d6bd4bb0c20$export$310af821ace1b0a4);
$parcel$export(module.exports, "SERVICE_COLLECTION_PRICING_PAGE_URL", () => $cce71d6bd4bb0c20$export$73d1ac3f0d282717);
$parcel$export(module.exports, "JSM_PRICING_PAGE_URL", () => $cce71d6bd4bb0c20$export$f3616073c30968f9);
$parcel$export(module.exports, "INCIDENTS_SLACK_INTEGRATION_VIDEO_URL", () => $cce71d6bd4bb0c20$export$6a49267b3da8f732);
const $cce71d6bd4bb0c20$export$310af821ace1b0a4 = {
    width: 'x-large',
    autoFocus: false,
    shouldScrollInViewport: true
};
const $cce71d6bd4bb0c20$export$73d1ac3f0d282717 = 'https://www.atlassian.com/collections/service/pricing';
const $cce71d6bd4bb0c20$export$fe159292463016ac = '/admin/billing';
const $cce71d6bd4bb0c20$export$5911f793141d3670 = 'https://support.atlassian.com/subscriptions-and-billing/docs/cancel-a-subscription/';
const $cce71d6bd4bb0c20$export$f3616073c30968f9 = 'http://www.atlassian.com/software/jira/service-management/product-pricing';
const $cce71d6bd4bb0c20$export$6a49267b3da8f732 = `https://www.youtube.com/embed/cljyGRFV2fo?rel=0&modestbranding=1`;

});

parcelRegister("gN8If", function(module, exports) {
$parcel$export(module.exports, "IntlProvider", () => $d3d0fc98830f704d$export$480518999dfc4151);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $iaiGc = parcelRequire("iaiGc");

var $bG2c5 = parcelRequire("bG2c5");

var $9XcZz = parcelRequire("9XcZz");

var $2fXuP = parcelRequire("2fXuP");
const $d3d0fc98830f704d$var$defaultMessagesWithStandardBenefits = {
    ...(0, $9XcZz.defaultLocale),
    ...(0, $2fXuP.standardBenefitsFallbackMessages),
    ...(0, $bG2c5.examplesSectionFallbackMessages)
};
const $d3d0fc98830f704d$export$480518999dfc4151 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iaiGc.default), {
        defaultMessages: $d3d0fc98830f704d$var$defaultMessagesWithStandardBenefits,
        loaderFn: (0, $9XcZz.fetchMessagesForLocale),
        children: children
    });
};

});
parcelRegister("iaiGc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e70ededd3686d3bf$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $33yvY = parcelRequire("33yvY");

var $fskSz = parcelRequire("fskSz");

var $iZwEp = parcelRequire("iZwEp");
function $e70ededd3686d3bf$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $iZwEp.useSafeIntl)();
    const messages = (0, $fskSz.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $8P7DW.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $33yvY.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});
parcelRegister("fskSz", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $c6000b4946166be5$export$4d17e2d9c5348842);

var $8P7DW = parcelRequire("8P7DW");

var $2yCFd = parcelRequire("2yCFd");

var $04G7a = parcelRequire("04G7a");
const $c6000b4946166be5$export$4d17e2d9c5348842 = (0, $2yCFd.functionWithFG)('navx-4615-fix-async-intl-for-gsn', $c6000b4946166be5$var$useMessagesNEW, $c6000b4946166be5$var$useMessagesOLD);
function $c6000b4946166be5$var$useMessagesNEW(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $8P7DW.useState)((0, $04G7a.NEW_DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $8P7DW.useRef)(localeState.locale);
    (0, $8P7DW.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}
function $c6000b4946166be5$var$useMessagesOLD(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $8P7DW.useState)((0, $04G7a.DEFAULT_LOCALE_STATE));
    (0, $8P7DW.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
}

});
parcelRegister("2yCFd", function(module, exports) {
$parcel$export(module.exports, "functionWithFG", () => $5ab2955bf87387ed$export$53903226fff06fbb);

var $e6Qdr = parcelRequire("e6Qdr");

var $bt6cj = parcelRequire("bt6cj");
const $5ab2955bf87387ed$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $bt6cj.functionWithCondition)(()=>(0, $e6Qdr.fg)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("bt6cj", function(module, exports) {
$parcel$export(module.exports, "functionWithCondition", () => $9e711f80f3afb601$export$af3c0e82a18fc057);
$parcel$export(module.exports, "functionUnionWithCondition", () => $9e711f80f3afb601$export$c41c28c1d883fcd5);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $9e711f80f3afb601$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $9e711f80f3afb601$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $9e711f80f3afb601$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});


parcelRegister("04G7a", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $5c585eda7547a0f1$export$79618bef82c02d4c);
$parcel$export(module.exports, "NEW_DEFAULT_LOCALE_STATE", () => $5c585eda7547a0f1$export$c568080b217d81ad);
const $5c585eda7547a0f1$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
const $5c585eda7547a0f1$export$c568080b217d81ad = {
    locale: 'en-US',
    messages: undefined
};

});


parcelRegister("iZwEp", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $629a52626f283589$export$f752ac21ea3960a5);

var $8P7DW = parcelRequire("8P7DW");

var $gKOzK = parcelRequire("gKOzK");
var $8yAcb = parcelRequire("8yAcb");
var $3SD6z = parcelRequire("3SD6z");

var $e6Qdr = parcelRequire("e6Qdr");

var $04G7a = parcelRequire("04G7a");
// Prevents memory leaks
const $629a52626f283589$var$cache = (0, $8yAcb.createIntlCache)();
const $629a52626f283589$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $8P7DW.useContext)((0, $3SD6z.Context));
    if (!context) {
        const defaultState = (0, $e6Qdr.fg)('navx-4615-fix-async-intl-for-gsn') ? (0, $04G7a.NEW_DEFAULT_LOCALE_STATE) : (0, $04G7a.DEFAULT_LOCALE_STATE);
        return (0, $gKOzK.createIntl)(defaultState, $629a52626f283589$var$cache);
    }
    return context;
};

});


parcelRegister("bG2c5", function(module, exports) {
$parcel$export(module.exports, "examplesSectionFallbackMessages", () => $d3f0720f811cf7ef$export$7ea3822e86d2fcfd);

var $bDspw = parcelRequire("bDspw");
function $d3f0720f811cf7ef$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $d3f0720f811cf7ef$export$7ea3822e86d2fcfd = Object.fromEntries(Object.values((0, $bDspw.examplesSectionMessages)).filter($d3f0720f811cf7ef$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("bDspw", function(module, exports) {
$parcel$export(module.exports, "examplesSectionMessages", () => $ce18d60368154fb8$export$1edce390ed9bf8d2);

var $6K2Gm = parcelRequire("6K2Gm");
const $ce18d60368154fb8$export$1edce390ed9bf8d2 = (0, $6K2Gm.defineMessages)({
    incidentsVideoIframeTitle: {
        id: '@atlassian/edition-benefits-modal.examples-section.incidents-video.iframe-title',
        defaultMessage: 'YouTube video player',
        description: 'Accessible title for the incidents Slack integration YouTube embed iframe'
    },
    illustrationHelpCenterCustomization: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.help-center-customization',
        defaultMessage: 'Help Center Customization Illustration',
        description: 'Alt text for the help center customization example image'
    },
    illustrationRovoServiceAgentsServiceTeams: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.rovo-service-agents-service-teams',
        defaultMessage: 'Rovo Service Agents Ops Team Illustration',
        description: 'Alt text for the Rovo Service Agents example image (service teams)'
    },
    illustrationRovoServiceAgentsOpsTeam: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.rovo-service-agents-ops-team',
        defaultMessage: 'Rovo Ops Agent Illustration',
        description: 'Alt text for the Rovo Ops Agent example image'
    },
    illustrationKnowledgeBaseServiceTeams: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.knowledge-base-service-teams',
        defaultMessage: 'Rovo Service Agents Ops Team Illustration',
        description: 'Alt text for the knowledge base example image (service teams)'
    },
    illustrationKnowledgeBaseOpsTeam: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.knowledge-base-ops-team',
        defaultMessage: 'Assets Ops Team Illustration',
        description: 'Alt text for the assets / knowledge example image (ops team)'
    },
    illustrationAutomationRules: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.automation-rules',
        defaultMessage: 'Automation Rules Service Team Illustration',
        description: 'Alt text for the automation rules example image (service and ops teams)'
    },
    illustrationUnlimitedAgents: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.unlimited-agents',
        defaultMessage: 'Unlimited Agents Service Team Illustration',
        description: 'Alt text for the unlimited agents example image (service and ops teams)'
    },
    illustrationAICustomerServiceAgentsCSMTeam: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.ai-customer-service-agents-csm-team',
        defaultMessage: 'AI Customer Service Agents Illustration',
        description: 'Alt text for the AI customer service agents example image (csm teams)'
    },
    illustrationRovoSupportCompanionCSMTeam: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.rovo-support-companion-csm-team',
        defaultMessage: 'Rovo Support Companion Illustration',
        description: 'Alt text for the Rovo Support Companion example image (csm teams)'
    },
    illustrationAICustomerServiceFormsCSMTeam: {
        id: '@atlassian/edition-benefits-modal.examples-section.illustration.ai-customer-service-forms-csm-team',
        defaultMessage: 'AI Customer Service Forms Illustration',
        description: 'Alt text for the AI customer service forms example image (csm teams)'
    }
});

});


parcelRegister("9XcZz", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $2659f623c161e383$export$d7f512c98c859244);
$parcel$export(module.exports, "fetchMessagesForLocale", () => $2659f623c161e383$export$2b153a2030b0feb2);

var $exhXO = parcelRequire("exhXO");

var $h0bli = parcelRequire("h0bli");
const $2659f623c161e383$export$d7f512c98c859244 = (0, $h0bli.default);
const $2659f623c161e383$var$localeMap = {
    pt: 'pt_BR',
    'pt-PT': 'pt_BR',
    'en-AU': 'en_GB'
};
const $2659f623c161e383$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($2659f623c161e383$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (!targetLocale) throw new Error('No mapped locale');
        const messages = await (0, $exhXO.locales)[targetLocale]();
        return messages.default;
    } catch  {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await (0, $exhXO.locales)[parentLocale]();
        return messages.default;
    } catch  {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return $2659f623c161e383$export$d7f512c98c859244;
};

});
parcelRegister("exhXO", function(module, exports) {
$parcel$export(module.exports, "locales", () => $0ffa1e61dc974f63$export$df1c34db1371eeed);





























const $0ffa1e61dc974f63$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("dfqvJ")),
    da: ()=>(parcelRequire("9QWHh")),
    de: ()=>(parcelRequire("2bMdK")),
    en_GB: ()=>(parcelRequire("6yDn2")),
    en_ZZ: ()=>(parcelRequire("izjDm")),
    en: ()=>Promise.resolve((parcelRequire("h0bli"))),
    es: ()=>(parcelRequire("5AohI")),
    fi: ()=>(parcelRequire("dbrcx")),
    fr: ()=>(parcelRequire("8W9wj")),
    hr: ()=>(parcelRequire("iNbMc")),
    hu: ()=>(parcelRequire("5th5S")),
    it: ()=>(parcelRequire("56Egt")),
    ja: ()=>(parcelRequire("2FJNe")),
    ko: ()=>(parcelRequire("66ReP")),
    nb: ()=>(parcelRequire("jXbxN")),
    nl: ()=>(parcelRequire("82Gy4")),
    pl: ()=>(parcelRequire("57227")),
    pt_BR: ()=>(parcelRequire("6p8a6")),
    ru: ()=>(parcelRequire("504iZ")),
    sl: ()=>(parcelRequire("4vHKd")),
    sr_RS: ()=>(parcelRequire("1IM3I")),
    sr_YR: ()=>(parcelRequire("h9d7z")),
    sv: ()=>(parcelRequire("bn26m")),
    th: ()=>(parcelRequire("gb475")),
    tr: ()=>(parcelRequire("57VxG")),
    uk: ()=>(parcelRequire("gM6z1")),
    vi: ()=>(parcelRequire("dCRQ1")),
    zh_TW: ()=>(parcelRequire("iJoXZ")),
    zh: ()=>(parcelRequire("8Bujw"))
};

});
parcelRegister("dfqvJ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("8Aot0").then(()=>parcelRequire('iHbJl'));

});

parcelRegister("9QWHh", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("8PNTz").then(()=>parcelRequire('1c2D3'));

});

parcelRegister("2bMdK", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("dFUeq").then(()=>parcelRequire('1NAEt'));

});

parcelRegister("6yDn2", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("iGdNx").then(()=>parcelRequire('e0Vg8'));

});

parcelRegister("izjDm", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("gmaw4").then(()=>parcelRequire('8C4ed'));

});

parcelRegister("h0bli", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c46efea2de65e1bc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $lMViu = parcelRequire("lMViu");
var $c46efea2de65e1bc$export$2e2bcd8739ae039 = (0, $lMViu.default);

});
parcelRegister("lMViu", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3627916a2b0bbc2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $d3627916a2b0bbc2$export$2e2bcd8739ae039 = {
    '@atlassian/edition-benefits-modal.benefits-section.button.maybe-later': 'Maybe later',
    '@atlassian/edition-benefits-modal.benefits-section.button.try-it-free': 'Try it free',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1': '<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2': '<strong>Customize your help center</strong> to match your brand.',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3': '<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1': 'Coordinate fast with <strong>automatically created Slack channels</strong> with the right people',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2': 'Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3': '<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident',
    '@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization': 'Try advanced Help Center customization with Premium',
    '@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration': 'Resolve incidents with AI in Slack, try Premium now',
    '@atlassian/edition-benefits-modal.benefits-section.link.pricing': 'See more Premium features and pricing',
    '@atlassian/edition-benefits-modal.benefits-section.subtitle': "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    '@atlassian/edition-benefits-modal.button-trigger.open-modal': 'Open modal',
    '@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free': 'Try it free'
};

});


parcelRegister("5AohI", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("8Zmk2").then(()=>parcelRequire('uWQSI'));

});

parcelRegister("dbrcx", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("5RPHO").then(()=>parcelRequire('3fsG0'));

});

parcelRegister("8W9wj", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("nKLED").then(()=>parcelRequire('ho6Ed'));

});

parcelRegister("iNbMc", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("4v5gH").then(()=>parcelRequire('6SfWR'));

});

parcelRegister("5th5S", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("CveGA").then(()=>parcelRequire('2EPJP'));

});

parcelRegister("56Egt", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("ic7vo").then(()=>parcelRequire('B9gps'));

});

parcelRegister("2FJNe", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("1bPzk").then(()=>parcelRequire('8fXzk'));

});

parcelRegister("66ReP", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("1n1aI").then(()=>parcelRequire('9J3oD'));

});

parcelRegister("jXbxN", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("WDWF8").then(()=>parcelRequire('kK24j'));

});

parcelRegister("82Gy4", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("iCSot").then(()=>parcelRequire('dOItY'));

});

parcelRegister("57227", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("bUfNy").then(()=>parcelRequire('kqWEo'));

});

parcelRegister("6p8a6", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("6Nzh2").then(()=>parcelRequire('dla43'));

});

parcelRegister("504iZ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("hh1eA").then(()=>parcelRequire('iRQmn'));

});

parcelRegister("4vHKd", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("dQcYp").then(()=>parcelRequire('2u6oC'));

});

parcelRegister("1IM3I", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("liaho").then(()=>parcelRequire('lKbDd'));

});

parcelRegister("h9d7z", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("jUEc2").then(()=>parcelRequire('8YsgC'));

});

parcelRegister("bn26m", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("gtcr9").then(()=>parcelRequire('ifbLz'));

});

parcelRegister("gb475", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("lMJ3U").then(()=>parcelRequire('hoBl9'));

});

parcelRegister("57VxG", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("lkVax").then(()=>parcelRequire('gsdcF'));

});

parcelRegister("gM6z1", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("jMzZu").then(()=>parcelRequire('iNOrf'));

});

parcelRegister("dCRQ1", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("ep83u").then(()=>parcelRequire('2NsLo'));

});

parcelRegister("iJoXZ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("u50rK").then(()=>parcelRequire('7sfm4'));

});

parcelRegister("8Bujw", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("ene0W").then(()=>parcelRequire('eVmeA'));

});



parcelRegister("2fXuP", function(module, exports) {
$parcel$export(module.exports, "standardBenefitsFallbackMessages", () => $e5e55001951678c7$export$188a81d8a9b070a0);

var $6eSMf = parcelRequire("6eSMf");
function $e5e55001951678c7$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $e5e55001951678c7$export$188a81d8a9b070a0 = Object.fromEntries(Object.values((0, $6eSMf.standardMessages)).filter($e5e55001951678c7$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("6eSMf", function(module, exports) {
$parcel$export(module.exports, "standardMessages", () => $468c0d909ecc93c5$export$e196fa8d430d87b);

var $6K2Gm = parcelRequire("6K2Gm");
const $468c0d909ecc93c5$export$e196fa8d430d87b = (0, $6K2Gm.defineMessages)({
    standardBenefitsModalTitle: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.title',
        defaultMessage: 'Explore your trial',
        description: 'Title for the standard benefits modal'
    },
    standardBenefitsModalBillingContent: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content',
        defaultMessage: 'Add your payment details by {date} to continue using {edition}. {plansLink}',
        description: "Billing content for the standard benefits modal. {plansLink} is the \u201CSee all plans\u201D link to pricing."
    },
    standardBenefitsModalBillingContentNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-no-date',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. {plansLink}',
        description: 'Billing content when billing date is unavailable. {edition} is the plan name; {plansLink} is the plans link.'
    },
    standardBenefitsModalBillingPlansLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-plans-link',
        defaultMessage: 'See all plans.',
        description: "Link label for the billing line \u201CSee all plans\u201D in the standard benefits modal"
    },
    standardBenefitsModalBillingContentPaymentEntered: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered',
        defaultMessage: "You won\u2019t be charged until your next billing date on {billingDate}. {plansLink} or {cancelLink}",
        description: 'Billing line when payment details are on file. {billingDate} is the next billing date; {plansLink} and {cancelLink} are inline links.'
    },
    standardBenefitsModalBillingContentPaymentEnteredNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered-no-date',
        defaultMessage: 'You won\u2019t be charged until your next billing date. {plansLink} or {cancelLink}',
        description: 'Billing line when payment is on file but billing date is unavailable. {plansLink} and {cancelLink} are inline links.'
    },
    standardBenefitsModalBillingSeePlansLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-see-plans-link',
        defaultMessage: 'See plans',
        description: "Link label \u201CSee plans\u201D in the payment-entered billing line"
    },
    standardBenefitsModalBillingCancelAnytimeLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-cancel-anytime-link',
        defaultMessage: 'cancel anytime.',
        description: "Link label \u201Ccancel anytime.\u201D in the payment-entered billing line"
    },
    standardBenefitsModalAddPaymentDetailsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.add-payment-details',
        defaultMessage: 'Add payment details',
        description: 'Text for the add payment details button in the standard benefits modal'
    },
    standardBenefitsModalExploreRovoServiceAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-service-agent',
        defaultMessage: 'Explore Rovo Service agent',
        description: 'Text for the explore Rovo Service agent button in the standard benefits modal'
    },
    standardBenefitsModalExploreKnowledgeBaseButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-knowledge-base',
        defaultMessage: 'Explore Knowledge base',
        description: 'Text for the explore Knowledge base primary button when that feature is selected'
    },
    standardBenefitsModalExploreAutomationsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-automations',
        defaultMessage: 'Explore Automations',
        description: 'Text for the explore Automations primary button when that feature is selected'
    },
    standardBenefitsModalInviteMoreAgentsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.invite-more-agents',
        defaultMessage: 'Invite more agents',
        description: 'Text for the invite more agents primary button when unlimited agents is selected'
    },
    // CTA — CSM
    standardBenefitsModalExploreCustomerServiceAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-customer-service-agent',
        defaultMessage: 'Explore Customer service agent',
        description: 'Primary CTA when Customer service agent feature is selected (CSM)'
    },
    standardBenefitsModalExploreRovoSupportCompanionButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-support-companion',
        defaultMessage: 'Explore Rovo Support Companion',
        description: 'Primary CTA when Rovo Support Companion feature is selected (CSM)'
    },
    standardBenefitsModalExploreAiEnabledFormsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-ai-enabled-forms',
        defaultMessage: 'Explore AI enabled Forms',
        description: 'Primary CTA when AI enabled Forms feature is selected (CSM)'
    },
    // CTA — Ops
    standardBenefitsModalExploreRovoOpsAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-ops-agent',
        defaultMessage: 'Explore Rovo Ops agent',
        description: 'Primary CTA when Rovo Ops agent feature is selected (Ops)'
    },
    standardBenefitsModalExploreAssetsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-assets',
        defaultMessage: 'Explore Assets',
        description: 'Primary CTA when Assets feature is selected (Ops)'
    },
    // Feature: Service Teams
    serviceTeamsFeatureRovoAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.rovo-service-agents.description',
        defaultMessage: 'Use AI-powered <strong>Rovo Service agent</strong> to resolve requests faster',
        description: 'Description for the Rovo Service Agents feature'
    },
    serviceTeamsFeatureKnowledgeBaseDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.knowledge-base.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written Knowledge Base articles</strong>',
        description: 'Description for the Knowledge Base feature'
    },
    serviceTeamsFeatureAutomationRulesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.automation-rules.description',
        defaultMessage: 'Keep your requests moving with <strong>10x Automation rule runs</strong>',
        description: 'Description for the Automation Rules feature'
    },
    serviceTeamsFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.unlimited-agents.description',
        defaultMessage: '<strong>Unlimited agents</strong> to support your customer needs',
        description: 'Description for the Unlimited Agents feature'
    },
    // Feature: CSM
    csmFeatureCustomerServiceAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.customer-service-agent.description',
        defaultMessage: 'Use AI powered <strong>Customer service agent</strong> to deflect common requests',
        description: 'Description for the Customer service agent feature (CSM)'
    },
    csmFeatureRovoSupportCompanionDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.rovo-support-companion.description',
        defaultMessage: 'Use <strong>Rovo Support Companion</strong> to help your human agents resolve requests faster',
        description: 'Description for the Rovo Support Companion feature (CSM)'
    },
    csmFeatureAiEnabledFormsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.ai-enabled-forms.description',
        defaultMessage: 'Create <strong>AI enabled Forms</strong> to automatically convert customer chats into requests in your queue',
        description: 'Description for the AI enabled Forms feature (CSM)'
    },
    csmFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.unlimited-agents.description',
        defaultMessage: '<strong>Unlimited agents</strong> to support your customer needs',
        description: 'Description for the Unlimited agents feature (CSM)'
    },
    // Feature: Ops
    opsFeatureRovoOpsAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.rovo-ops-agent.description',
        defaultMessage: 'Use AI-powered <strong>Rovo Ops agent</strong> to get AI summaries and next steps for incidents',
        description: 'Description for the Rovo Ops agent feature (Ops)'
    },
    opsFeatureAssetsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.assets.description',
        defaultMessage: 'See impacted business critical objects for rapid root cause analysis with <strong>Assets</strong>',
        description: 'Description for the Assets feature (Ops)'
    },
    opsFeatureAutomationRulesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.automation-rules.description',
        defaultMessage: 'Move forward faster with <strong>10x Automation rule runs</strong>',
        description: 'Description for the Automation rule runs feature (Ops)'
    },
    opsFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.unlimited-agents.description',
        defaultMessage: '<strong>Unlimited agents</strong> to support your customer needs',
        description: 'Description for the Unlimited agents feature (Ops)'
    }
});

});



parcelRegister("ab22O", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $94076041184a351d$export$e926676385687eaf);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $dCWA1 = parcelRequire("dCWA1");

var $18KuK = parcelRequire("18KuK");

var $9TwI7 = parcelRequire("9TwI7");

var $2rGVm = parcelRequire("2rGVm");
const $94076041184a351d$export$e926676385687eaf = ({ children: children, variantId: variantId })=>{
    const handleOnError = (0, $2rGVm.useErrorAnalytics)({
        variantId: variantId
    });
    const ufoContext = (0, $18KuK.useInteractionContext)();
    const onError = (0, $8P7DW.useCallback)((error, errorInfo)=>{
        const interaction = (0, $9TwI7.getActiveInteraction)();
        handleOnError(error, errorInfo);
        if (interaction && ufoContext) (0, $9TwI7.addError)(interaction === null || interaction === void 0 ? void 0 : interaction.id, error.name, ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack, 'interaction error', error.message, error.stack);
        else (0, $9TwI7.addErrorToAll)(`ErrorBoundary:edition-benefits-modal${variantId ? `:${variantId}` : ''}`, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, 'interaction error', error.message);
    }, [
        handleOnError,
        variantId,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dCWA1.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {}),
        children: children
    });
};

});
parcelRegister("2rGVm", function(module, exports) {
$parcel$export(module.exports, "useErrorAnalytics", () => $476d38c33aaa4163$export$e2d4523bbccd2343);

var $8P7DW = parcelRequire("8P7DW");

var $fDBmw = parcelRequire("fDBmw");
/**
 * Errors which we ignore from SLO reporting to ensure we're only reporting on actionable errors
 */ const $476d38c33aaa4163$var$nonSLOErrors = [
    /**
 * These occur when the fetch request fails (usually due to network being offline)
 */ /failed to fetch/i,
    /**
 * These occur when the fetch request fails due to a server response (e.g. 401)
 */ /Error server response:/i
];
function $476d38c33aaa4163$var$isSLOError(error) {
    // Just checks that none of our non-SLO errors match the error
    return !$476d38c33aaa4163$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $476d38c33aaa4163$export$e2d4523bbccd2343({ variantId: variantId } = {}) {
    const sendOperationalEvent = (0, $fDBmw.useOperationalAnalytics)();
    return (0, $8P7DW.useCallback)((error, errorInfo)=>{
        sendOperationalEvent({
            action: 'failed',
            actionSubject: '@atlassian/edition-benefits-modal.edition-benefits-modal',
            attributes: {
                variantId: variantId,
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                componentStack: errorInfo.componentStack,
                isSLOError: $476d38c33aaa4163$var$isSLOError(error)
            }
        });
    }, [
        sendOperationalEvent,
        variantId
    ]);
}

});


parcelRegister("cAMvy", function(module, exports) {
$parcel$export(module.exports, "messages", () => $de0ff8524e5af426$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $de0ff8524e5af426$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    benefitsSectionButtonMaybeLater: {
        id: '@atlassian/edition-benefits-modal.benefits-section.button.maybe-later',
        defaultMessage: 'Maybe later',
        description: 'Text for maybe later button'
    },
    benefitsSectionButtonTryItFree: {
        id: '@atlassian/edition-benefits-modal.benefits-section.button.try-it-free',
        defaultMessage: 'Try it free',
        description: 'Text for try it free button'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1',
        defaultMessage: '<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.',
        description: 'Text for first feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2',
        defaultMessage: '<strong>Customise your help center</strong> to match your brand.',
        description: 'Text for second feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3',
        defaultMessage: '<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.',
        description: 'Text for third feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1',
        defaultMessage: 'Coordinate fast with <strong>automatically created Slack channels</strong> with the right people',
        description: 'Text for first feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2',
        defaultMessage: 'Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>',
        description: 'Text for second feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3',
        defaultMessage: '<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident',
        description: 'Text for third feature in incidents-slack-integration variant'
    },
    benefitsSectionHeadingHelpCenterCustomization: {
        id: '@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization',
        defaultMessage: 'Try advanced Help Center customisation with Premium',
        description: 'Heading for help-center-customization variant'
    },
    benefitsSectionHeadingIncidentsSlackIntegration: {
        id: '@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration',
        defaultMessage: 'Resolve incidents with AI in Slack, try Premium now',
        description: 'Heading for incidents-slack-integration variant'
    },
    benefitsSectionLinkPricing: {
        id: '@atlassian/edition-benefits-modal.benefits-section.link.pricing',
        defaultMessage: 'See more Premium features and pricing',
        description: 'Text for pricing link'
    },
    benefitsSectionSubtitle: {
        id: '@atlassian/edition-benefits-modal.benefits-section.subtitle',
        defaultMessage: "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
        description: 'Subtitle text for the benefits section'
    },
    buttonTriggerOpenModal: {
        id: '@atlassian/edition-benefits-modal.button-trigger.open-modal',
        defaultMessage: 'Open modal',
        description: 'Text for the button that opens the edition benefits modal'
    },
    buttonTriggerTryItFree: {
        id: '@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free',
        defaultMessage: 'Try it free',
        description: 'Button text for to trigger opening the premium benefits modal'
    }
});

});

parcelRegister("dsT7Z", function(module, exports) {
$parcel$export(module.exports, "premiumEditionBenefitsModalEntryPoint", () => $732129090ba543e5$export$262ed5b18480f6c7);

var $grxtw = parcelRequire("grxtw");

var $5I31Q = parcelRequire("5I31Q");

var $fwnrq = parcelRequire("fwnrq");

var $94tkG = parcelRequire("94tkG");

const $732129090ba543e5$export$262ed5b18480f6c7 = (0, $5I31Q.createEntryPoint)({
    root: (0, $grxtw.JSResourceForInteraction)(()=>(parcelRequire("fIwaT")).then((mod)=>mod.PremiumBenefitsModal), {
        moduleId: 'edition-benefits-modal-premium-benefits-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, product: product })=>({
            queries: {
                premiumBenefitsModalQuery: {
                    parameters: (0, $94tkG.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: (0, $fwnrq.getHamsKey)(product)
                    }
                }
            },
            extraProps: {
                product: product
            }
        })
});

});
parcelRegister("grxtw", function(module, exports) {
$parcel$export(module.exports, "JSResourceForInteraction", () => $e88ad9f6c26e831d$export$e83743682263315a);

var $6KdvW = parcelRequire("6KdvW");

var $2LldG = parcelRequire("2LldG");

var $5sYub = parcelRequire("5sYub");
const $e88ad9f6c26e831d$var$cache = (0, $6KdvW.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $e88ad9f6c26e831d$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $e88ad9f6c26e831d$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$e88ad9f6c26e831d$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    return $e88ad9f6c26e831d$var$cache.get(opts.moduleId, ()=>(0, $2LldG.PreloadableJSResource)(()=>(0, $5sYub.postTask)(loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}

});
parcelRegister("6KdvW", function(module, exports) {
$parcel$export(module.exports, "createCache", () => $75adf8ac6ba69c17$export$cf6fa0bbcc94b912);
function $75adf8ac6ba69c17$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("2LldG", function(module, exports) {
$parcel$export(module.exports, "PreloadableJSResource", () => $764fd94719f0547c$export$4fe5fba5bb1d3c09);

var $hRsv2 = parcelRequire("hRsv2");
function $764fd94719f0547c$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $hRsv2.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("hRsv2", function(module, exports) {
$parcel$export(module.exports, "JSResource", () => $c934281f44e9f73b$export$148e45a6d4b4d65);

var $bUYgG = parcelRequire("bUYgG");

var $h98yZ = parcelRequire("h98yZ");

var $914Ez = parcelRequire("914Ez");
function $c934281f44e9f73b$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $h98yZ.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $h98yZ.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners){
                var _listener$onError;
                (_listener$onError = listener.onError) === null || _listener$onError === void 0 || _listener$onError.call(listener, error);
            }
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $bUYgG.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $h98yZ.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $914Ez.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError === null || onError === void 0 || onError(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("bUYgG", function(module, exports) {
$parcel$export(module.exports, "generateId", () => $ba4e010a27a998ae$export$567fc7097e064344);
let $ba4e010a27a998ae$var$id = 100000;
function $ba4e010a27a998ae$export$567fc7097e064344() {
    $ba4e010a27a998ae$var$id += 1;
    return $ba4e010a27a998ae$var$id.toString();
}

});

parcelRegister("h98yZ", function(module, exports) {
$parcel$export(module.exports, "eventEmitter", () => $f74d05e28f50497f$export$10dc3edfc20c8ff);
function $f74d05e28f50497f$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $f74d05e28f50497f$export$10dc3edfc20c8ff = $f74d05e28f50497f$var$createEventEmitter();

});

parcelRegister("914Ez", function(module, exports) {
$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $27283d98f8d3263d$export$3b514faac3ba993c);
function $27283d98f8d3263d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("5sYub", function(module, exports) {
$parcel$export(module.exports, "postTask", () => $ee530140296efe6d$export$13c9d02ca54955a3);
async function $ee530140296efe6d$var$toPromise(callback) {
    return callback();
}
function $ee530140296efe6d$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $ee530140296efe6d$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $ee530140296efe6d$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("cnJIo")).then(()=>$ee530140296efe6d$var$getScheduler(globalThis).postTask(callback, options));
        return $ee530140296efe6d$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("cnJIo", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("288Ec").then(()=>parcelRequire('7Agu5'));

});



parcelRegister("5I31Q", function(module, exports) {
$parcel$export(module.exports, "createEntryPoint", () => $cc00d1b42f083005$export$fa00dd5c1a75592f);
/* eslint-disable @typescript-eslint/ban-types */ function $cc00d1b42f083005$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("fwnrq", function(module, exports) {
$parcel$export(module.exports, "getHamsKey", () => $57b1777848b348e4$export$291d012eb0744b34);
const $57b1777848b348e4$var$ProductKeyToHAMSMap = {
    ['jira']: 'jira-software',
    ['jira-service-management']: 'jira-servicedesk',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['confluence']: 'confluence',
    ['jira-customer-service']: 'jira-customer-service'
};
const $57b1777848b348e4$export$291d012eb0744b34 = (product)=>{
    return $57b1777848b348e4$var$ProductKeyToHAMSMap[product];
};

});

parcelRegister("94tkG", function(module, exports) {
$parcel$export(module.exports, "default", () => $acee65c6422277c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44ff296de468af74b9f11bf27cf6d4b4>>
 * @relayHash 0364ebf04a149c5cd5b923316a2324ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845

var $8iTFq = parcelRequire("8iTFq");
const $acee65c6422277c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "premiumBenefitsModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "premiumBenefitsModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845",
            "metadata": {},
            "name": "premiumBenefitsModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$acee65c6422277c4$var$node.hash = "0854408facd8d9c64a16089df4b3226a";
(0, $8iTFq.PreloadableQueryRegistry).set($acee65c6422277c4$var$node.params.id, $acee65c6422277c4$var$node);
var $acee65c6422277c4$export$2e2bcd8739ae039 = $acee65c6422277c4$var$node;

});

parcelRegister("fIwaT", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("1kNIV"),
    $j9MRt("8nske"),
    $j9MRt("9hBNq"),
    $j9MRt("70snJ"),
    $j9MRt("hVSoa"),
    $j9MRt("2uSYg")
]).then(()=>parcelRequire('ePtrN'));

});



parcelRegister("fsZf3", function(module, exports) {
$parcel$export(module.exports, "isPremiumUpsellExperimentEnabled", () => $321e0e7312ea394d$export$c62fce3d3e7c8a8b);

var $1EFS8 = parcelRequire("1EFS8");
const $321e0e7312ea394d$export$c62fce3d3e7c8a8b = ({ hasSiteAdministerAccess: hasSiteAdministerAccess, isHCCustomizationEnabled: isHCCustomizationEnabled })=>{
    if (!hasSiteAdministerAccess || isHCCustomizationEnabled) return false;
    // Main Experiment
    return (0, $1EFS8.default).getExperimentValue('jsmgrowth-296_improving_premium_upsell_in_portal', 'isEnabled', false);
};

});

parcelRegister("e2jLh", function(module, exports) {
$parcel$export(module.exports, "clearSidebarExperienceAndCustomize", () => $26f8f94b37f67138$export$4367df47a43e5f96);

var $2Np0t = parcelRequire("2Np0t");
const $26f8f94b37f67138$export$47b19daccaa881f2 = ()=>{
    return (0, $2Np0t.get)('experience');
};
const $26f8f94b37f67138$export$4367df47a43e5f96 = ()=>{
    (0, $2Np0t.set)({
        customize: undefined,
        experience: undefined
    });
};

});

parcelRegister("aaA3R", function(module, exports) {
$parcel$export(module.exports, "ARTICLES_RESULT_LIMIT", () => (parcelRequire("kywYl")).ARTICLES_RESULT_LIMIT);
$parcel$export(module.exports, "INITIAL_ARTICLES_LIMIT", () => (parcelRequire("kywYl")).INITIAL_ARTICLES_LIMIT);
$parcel$export(module.exports, "PORTALS_RESULT_LIMIT", () => (parcelRequire("kywYl")).PORTALS_RESULT_LIMIT);
$parcel$export(module.exports, "REQUEST_FORMS_NEW_LIMIT", () => (parcelRequire("kywYl")).REQUEST_FORMS_NEW_LIMIT);
$parcel$export(module.exports, "REQUEST_FORMS_RESULT_LIMIT", () => (parcelRequire("kywYl")).REQUEST_FORMS_RESULT_LIMIT);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => (parcelRequire("kywYl")).SEARCH_QUERY_DEBOUNCE_TIME);
$parcel$export(module.exports, "DropdownOptionList", () => (parcelRequire("bT2e1")).DropdownOptionList);
$parcel$export(module.exports, "Img", () => (parcelRequire("bT2e1")).Img);
$parcel$export(module.exports, "InlineResultLink", () => (parcelRequire("bT2e1")).InlineResultLink);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => (parcelRequire("bT2e1")).InlineResultsHeadingWrapper);
$parcel$export(module.exports, "ResultList", () => (parcelRequire("bT2e1")).ResultList);
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => (parcelRequire("bT2e1")).SEARCH_BAR_HEIGHT);
$parcel$export(module.exports, "formatText", () => (parcelRequire("tJpW6")).formatText);
$parcel$export(module.exports, "formatToCleanText", () => (parcelRequire("tJpW6")).formatToCleanText);
$parcel$export(module.exports, "getIdsArray", () => (parcelRequire("tJpW6")).getIdsArray);
$parcel$export(module.exports, "getPortalIdAsNumber", () => (parcelRequire("tJpW6")).getPortalIdAsNumber);
$parcel$export(module.exports, "isSinglePortalSearch", () => (parcelRequire("tJpW6")).isSinglePortalSearch);
$parcel$export(module.exports, "isValidSearchTerm", () => (parcelRequire("tJpW6")).isValidSearchTerm);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => (parcelRequire("tJpW6")).sendSearchOperationalAnalyticEvents);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => (parcelRequire("tJpW6")).sendSearchUIAnalyticEvents);
$parcel$export(module.exports, "useQueryParams", () => (parcelRequire("tJpW6")).useQueryParams);
$parcel$export(module.exports, "useVisibilityState", () => (parcelRequire("tJpW6")).useVisibilityState);
parcelRequire("kywYl");
parcelRequire("bT2e1");
parcelRequire("tJpW6");

});
parcelRegister("kywYl", function(module, exports) {
$parcel$export(module.exports, "ARTICLES_RESULT_LIMIT", () => $9d0fc03ac4cb4821$export$38c99458b97d4d4);
$parcel$export(module.exports, "PORTALS_RESULT_LIMIT", () => $9d0fc03ac4cb4821$export$d687c15f4e8fd960);
$parcel$export(module.exports, "REQUEST_FORMS_RESULT_LIMIT", () => $9d0fc03ac4cb4821$export$fc1850b34254ac28);
$parcel$export(module.exports, "INITIAL_ARTICLES_LIMIT", () => $9d0fc03ac4cb4821$export$f63f00916950640a);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => $9d0fc03ac4cb4821$export$95aa4d213e66754b);
$parcel$export(module.exports, "REQUEST_FORMS_NEW_LIMIT", () => $9d0fc03ac4cb4821$export$16da0cbbeac3310c);
const $9d0fc03ac4cb4821$export$38c99458b97d4d4 = 30;
const $9d0fc03ac4cb4821$export$d687c15f4e8fd960 = 5;
const $9d0fc03ac4cb4821$export$fc1850b34254ac28 = 5;
const $9d0fc03ac4cb4821$export$f63f00916950640a = 10;
const $9d0fc03ac4cb4821$export$95aa4d213e66754b = 300;
const $9d0fc03ac4cb4821$export$16da0cbbeac3310c = 15;

});

parcelRegister("bT2e1", function(module, exports) {
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => $35e2fa89509b4ba8$export$9ac4f4162406e081);
$parcel$export(module.exports, "ResultList", () => $35e2fa89509b4ba8$export$7ebf7682ef098fb8);
$parcel$export(module.exports, "Img", () => $35e2fa89509b4ba8$export$cc7b5f925acc71d3);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => $35e2fa89509b4ba8$export$a8317adc66cb9be6);
$parcel$export(module.exports, "InlineResultLink", () => $35e2fa89509b4ba8$export$5a34ff55d4e5e484);
$parcel$export(module.exports, "DropdownOptionList", () => $35e2fa89509b4ba8$export$b5e293376cc6b1ce);
/* styled.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $cS6Xr = parcelRequire("cS6Xr");
const $35e2fa89509b4ba8$export$9ac4f4162406e081 = "var(--ds-space-1000, 80px)";
const $35e2fa89509b4ba8$export$7ebf7682ef098fb8 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $35e2fa89509b4ba8$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt4pxbi _1bsb1epz",
            __cmplp.className
        ])
    });
});
const $35e2fa89509b4ba8$export$a8317adc66cb9be6 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});
const $35e2fa89509b4ba8$export$5a34ff55d4e5e484 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $cS6Xr.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_4bfu1snc _1hmsagmp _ajmmvv82 _zulputpp _1reo15vq _18m915vq _1rjc12x7 _18zrpxbi _1e0c1txw _2lx2vrvc _1bsb1osq _syazwm8e _4cvr1h6o _vchhusvi _80omtlke _49pcnqa1 _1hvwdkaa _nt75xr8a _irr34mfv _1di61dty",
            __cmplp.className
        ])
    });
});
const $35e2fa89509b4ba8$export$b5e293376cc6b1ce = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1pfhu2gc _1eg6idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("tJpW6", function(module, exports) {
$parcel$export(module.exports, "formatText", () => $70457fdaab721f38$export$905fe28a7c283e1d);
$parcel$export(module.exports, "formatToCleanText", () => $70457fdaab721f38$export$519cc8c1640d01b8);
$parcel$export(module.exports, "useQueryParams", () => $70457fdaab721f38$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "isSinglePortalSearch", () => $70457fdaab721f38$export$3bdd4cf348080703);
$parcel$export(module.exports, "getPortalIdAsNumber", () => $70457fdaab721f38$export$c36431be801010b);
$parcel$export(module.exports, "isValidSearchTerm", () => $70457fdaab721f38$export$34d09b0baed7315d);
$parcel$export(module.exports, "getIdsArray", () => $70457fdaab721f38$export$b78190df63b1b0c4);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => $70457fdaab721f38$export$c8b38685f22f1bb2);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => $70457fdaab721f38$export$653243929c3168a8);
$parcel$export(module.exports, "useVisibilityState", () => $70457fdaab721f38$export$54299a3c81f5425);

var $8P7DW = parcelRequire("8P7DW");

var $u1Zdx = parcelRequire("u1Zdx");

var $5kYxc = parcelRequire("5kYxc");

var $gSAAy = parcelRequire("gSAAy");

var $gKQQC = parcelRequire("gKQQC");

var $7upu0 = parcelRequire("7upu0");

var $h1yZX = parcelRequire("h1yZX");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
const $70457fdaab721f38$export$437ad40c783f9f71 = (queryStringParams)=>{
    const { portalIds: selectedPortalIds } = queryStringParams;
    if (!selectedPortalIds) return [];
    return Array.isArray(selectedPortalIds) ? selectedPortalIds : [
        selectedPortalIds
    ];
};
const $70457fdaab721f38$export$596cf762087ae00e = (queryStringParams)=>{
    const { categoryIds: selectedCategoryIds } = queryStringParams;
    if (!selectedCategoryIds) return [];
    return Array.isArray(selectedCategoryIds) ? selectedCategoryIds : [
        selectedCategoryIds
    ];
};
const $70457fdaab721f38$export$905fe28a7c283e1d = (text = '', term = '')=>(0, $7upu0.default)(text, term).replace(/@@@hl@@@/g, '<strong>').replace(/@@@endhl@@@/g, '</strong>');
const $70457fdaab721f38$export$519cc8c1640d01b8 = (text = '', term = '')=>(0, $7upu0.default)(text, term).replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $70457fdaab721f38$export$b37ee0d76c6d2fbc = ()=>{
    const [{ location: location }, _] = (0, $i9cdb.useRouter)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $8P7DW.useMemo)(()=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (0, (/*@__PURE__*/$parcel$interopDefault($h1yZX))).parse(location.search);
    }, [
        location.search
    ]);
    const portalIds = (0, $8P7DW.useMemo)(()=>$70457fdaab721f38$export$437ad40c783f9f71(queryStringParams), [
        queryStringParams
    ]);
    const categoryIds = (0, $8P7DW.useMemo)(()=>$70457fdaab721f38$export$596cf762087ae00e(queryStringParams), [
        queryStringParams
    ]);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...queryStringParams,
        portalIds: portalIds,
        categoryIds: categoryIds
    };
};
const $70457fdaab721f38$export$3bdd4cf348080703 = (portalId)=>portalId !== undefined && $70457fdaab721f38$export$c36431be801010b(portalId) !== 0;
const $70457fdaab721f38$export$34d09b0baed7315d = (term)=>Boolean(term && term.trim() !== '');
const $70457fdaab721f38$export$c36431be801010b = (portalId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($gKQQC)))(portalId);
};
const $70457fdaab721f38$export$b78190df63b1b0c4 = (ids)=>{
    if (ids) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5kYxc)))(ids) || (0, (/*@__PURE__*/$parcel$interopDefault($gSAAy)))(ids)) return [
            ids.toString()
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($u1Zdx)))(ids) ? ids : [];
    }
    return [];
};
const $70457fdaab721f38$export$c8b38685f22f1bb2 = (eventProperties, createAnalyticsEvent, portalId, isInlineResult)=>{
    if (isInlineResult) eventProperties.actionSubjectId = 'inlineResult';
    else eventProperties.actionSubjectId = portalId ? 'singlePortal' : 'portalHomePage';
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'UI',
        actionSubjectId: eventProperties.actionSubjectId,
        ...eventProperties
    }).fire();
};
const $70457fdaab721f38$export$653243929c3168a8 = (eventProperties, createAnalyticsEvent, portalId)=>{
    const statusCode = eventProperties.statusCode;
    if (statusCode !== 403 && statusCode !== 429) createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'OPERATIONAL',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $70457fdaab721f38$export$54299a3c81f5425 = ()=>{
    const [isHovered, setIsHovered] = (0, $8P7DW.useState)(false);
    const [isFocused, setIsFocused] = (0, $8P7DW.useState)(false);
    const [isShortcutIconVisible, setIsShortcutIconVisible] = (0, $8P7DW.useState)(false);
    return {
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsShortcutIconVisible: setIsShortcutIconVisible,
        isShortcutIconVisible: isHovered || isFocused || isShortcutIconVisible
    };
};

});


parcelRegister("gFqUR", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => (parcelRequire("7tWhk")).AccountDetails);

var $7tWhk = parcelRequire("7tWhk");

});
parcelRegister("7tWhk", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $ba139e4c06d37182$export$66e04d0aacdb3b2);
/* account-details.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $hIXV0 = parcelRequire("hIXV0");

var $lSyMY = parcelRequire("lSyMY");
var $7qJSw = parcelRequire("7qJSw");
const $ba139e4c06d37182$export$66e04d0aacdb3b2 = ({ avatarSrc: avatarSrc, displayName: displayName, email: email })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba139e4c06d37182$var$NonInteractiveLinkItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba139e4c06d37182$var$ProfileWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba139e4c06d37182$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hIXV0.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba139e4c06d37182$var$DetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba139e4c06d37182$var$DisplayName, null, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("small", null, email)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ba139e4c06d37182$var$NonInteractiveLinkItem = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $lSyMY.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_lcxvglyw _syaz261p",
            __cmplp.className
        ])
    });
});
const $ba139e4c06d37182$var$ProfileWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $ba139e4c06d37182$var$AvatarWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $ba139e4c06d37182$var$DisplayName = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_vwz4gktf",
            __cmplp.className
        ])
    });
});
const $ba139e4c06d37182$var$DetailsWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_2lx29ee3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lSyMY", function(module, exports) {
$parcel$export(module.exports, "default", () => $170332ed963cd8d3$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8PtDM = parcelRequire("8PtDM");

var $9uKqY = parcelRequire("9uKqY");

var $cA7Yr = parcelRequire("cA7Yr");
const $170332ed963cd8d3$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $170332ed963cd8d3$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $170332ed963cd8d3$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $170332ed963cd8d3$var$LinkItem = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $8PtDM.default)();
    const interactionContext = (0, $8P7DW.useContext)((0, $9uKqY.default));
    const handleClick = (0, $8P7DW.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $170332ed963cd8d3$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $170332ed963cd8d3$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cA7Yr.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // @ts-expect-error
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $170332ed963cd8d3$var$preventEvent
                },
                onMouseDown: isDisabled ? $170332ed963cd8d3$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $170332ed963cd8d3$var$preventEvent : handleClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled,
                ref: ref,
                children: children
            })
    });
}));
var $170332ed963cd8d3$export$2e2bcd8739ae039 = $170332ed963cd8d3$var$LinkItem;

});



parcelRegister("jQoUV", function(module, exports) {
$parcel$export(module.exports, "MultiHcDropdown", () => $da5fe20b4a9d7a9b$export$75412c9c343a009c);

var $8P7DW = parcelRequire("8P7DW");

var $4O8fD = parcelRequire("4O8fD");

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
const $da5fe20b4a9d7a9b$var$MultiHcDropdownLoader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
        height: 32,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    });

const $da5fe20b4a9d7a9b$export$75412c9c343a009c = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("1Vera")), {
        moduleId: "./packages/help-center/layout/menu/src/ui/multi-hc-dropdown/hocs.tsx"
    }),
    LoadingSkeleton: $da5fe20b4a9d7a9b$var$MultiHcDropdownLoader
});

});
parcelRegister("1Vera", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("5WsnM"),
    $j9MRt("89jbA"),
    $j9MRt("gtoLy")
]).then(()=>parcelRequire('1ZfIc'));

});


parcelRegister("etUNo", function(module, exports) {
$parcel$export(module.exports, "NUMBER_OF_HELP_CENTERS_PER_FETCH", () => $883d873fb3d15b94$export$81026eacb893b971);
$parcel$export(module.exports, "SORT_ORDER", () => $883d873fb3d15b94$export$d33cb9b119034d29);
$parcel$export(module.exports, "CHARACTER_LIMIT_MULTI_HC_DROPDOWN_ITEMS", () => $883d873fb3d15b94$export$b3969bb8735636e7);
const $883d873fb3d15b94$export$81026eacb893b971 = 10;
const $883d873fb3d15b94$export$d33cb9b119034d29 = 'CREATED_DATE_ASCENDING';
const $883d873fb3d15b94$export$b3969bb8735636e7 = 21;

});

parcelRegister("6IS8o", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff1a85e48f979fbe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51e6867d62017f7b4b806fe7fc07edf8>>
 * @relayHash c39ffef39d091e344d77f10f76720b3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43cfbf151f39e5746cb83275969c024702202a1fc44972200ae5cce2f2fd3089
const $ff1a85e48f979fbe$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "NUMBER_OF_HELP_CENTERS_PER_FETCH"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "SORT_ORDER"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "NUMBER_OF_HELP_CENTERS_PER_FETCH"
        },
        {
            "kind": "Variable",
            "name": "sortOrder",
            "variableName": "SORT_ORDER"
        },
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "multiHcDropdownContentComponentQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "NUMBER_OF_HELP_CENTERS_PER_FETCH",
                            "variableName": "NUMBER_OF_HELP_CENTERS_PER_FETCH"
                        },
                        {
                            "kind": "Variable",
                            "name": "SORT_ORDER",
                            "variableName": "SORT_ORDER"
                        },
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "multiHcDropdownPaginatedFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "multiHcDropdownContentComponentQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterName",
                                                            "kind": "LinkedField",
                                                            "name": "name",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "default"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "slug"
                                                        }
                                                    ],
                                                    "type": "HelpCenter"
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "filters": [
                                "workspaceAri",
                                "sortOrder"
                            ],
                            "handle": "connection",
                            "key": "multiHcDropdownContentFragment_helpCenters",
                            "kind": "LinkedHandle",
                            "name": "helpCenters"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "43cfbf151f39e5746cb83275969c024702202a1fc44972200ae5cce2f2fd3089",
            "metadata": {},
            "name": "multiHcDropdownContentComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff1a85e48f979fbe$var$node.hash = "29fda4db4acf34a38aedc1fa8b96de91";
var $ff1a85e48f979fbe$export$2e2bcd8739ae039 = $ff1a85e48f979fbe$var$node;

});

parcelRegister("jtSmi", function(module, exports) {
$parcel$export(module.exports, "UpgradeModal", () => $08a6b860751c4b12$export$72c362f751994d32);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $08a6b860751c4b12$export$72c362f751994d32 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("eEBMz")), {
        moduleId: "./packages/help-center/layout/menu/src/ui/upgrade-modal/upgrade-modal.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("eEBMz", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("28vTc").then(()=>parcelRequire('heVad'));

});


parcelRegister("kYNPD", function(module, exports) {
$parcel$export(module.exports, "avatarMenuExperience", () => $c5fcbf1a2506ebfb$export$90a7234d224ce2c4);
$parcel$export(module.exports, "AvatarMenuExperienceFailure", () => $c5fcbf1a2506ebfb$export$2d5d3fcf414ca903);

var $8P7DW = parcelRequire("8P7DW");

var $lQb0x = parcelRequire("lQb0x");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $c5fcbf1a2506ebfb$export$90a7234d224ce2c4 = new (0, $ghwxF.UFOExperience)((0, $lQb0x.avatarMenuExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $c5fcbf1a2506ebfb$export$2d5d3fcf414ca903 = (props)=>{
    (0, $8P7DW.useEffect)(()=>{
        // Since experience failure function is returning a promise, just executing it without waiting for it to resolve
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        $c5fcbf1a2506ebfb$export$90a7234d224ce2c4.failure({
            metadata: props
        });
    }, [
        props
    ]);
    return null;
};

});

parcelRegister("djZwh", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dcb4fea8d2fff00$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $7dcb4fea8d2fff00$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    requests: {
        defaultMessage: 'Requests',
        description: 'Requests item in menu',
        id: 'avatar.menu.v2.header.requests'
    },
    requestListHeading: {
        defaultMessage: 'REQUESTS LIST',
        description: 'Requests list header in menu request subsection',
        id: 'avatar.menu.v2.header.requests-list'
    },
    customizeRequestList: {
        defaultMessage: 'Manage columns',
        description: 'Manage columns item in menu request subsection',
        id: 'avatar.menu.v2.header.manage-column'
    },
    approvals: {
        defaultMessage: 'Approvals',
        description: 'Approvals item in menu',
        id: 'avatar.menu.v2.header.approvals'
    },
    profile: {
        defaultMessage: 'Profile',
        description: 'Profile item in menu',
        id: 'avatar.menu.v2.header.profile'
    },
    logout: {
        defaultMessage: 'Log out',
        description: 'Log out button in menu',
        id: 'avatar.menu.v2.logout'
    },
    pageLayout: {
        defaultMessage: 'Page layout',
        description: 'Topics and Portals in avatar drop-down menu',
        id: 'avatar.menu.v2.topic'
    },
    beta: {
        defaultMessage: 'Beta',
        description: 'Beta lozenge for flexi HC in avatar drop-down menu',
        id: 'avatar.menu.v2.label.beta'
    },
    newLozenge: {
        defaultMessage: 'New',
        description: 'BeNewta lozenge in avatar drop-down menu',
        id: 'avatar.menu.v2.label.newLozenge'
    },
    topicsAndPortals: {
        defaultMessage: 'Topics and portals',
        description: 'Topics and Portals in avatar drop-down menu when advanced customization enabled',
        id: 'avatar.menu.v2.topics.and.portals'
    },
    look: {
        defaultMessage: 'Look and feel',
        description: 'look and feel item in menu',
        id: 'avatar.menu.v2.look'
    },
    announcement: {
        defaultMessage: 'Announcements',
        description: 'announcement item in menu',
        id: 'avatar.menu.v2.announcement'
    },
    signIn: {
        defaultMessage: 'Log in message',
        description: 'sign in message item in menu',
        id: 'avatar.menu.v2.signIn'
    },
    helpCenterSettings: {
        defaultMessage: 'Service hub settings',
        description: 'Service hub settings navigation item',
        id: 'avatar.menu.v2.helpCenterSettings'
    },
    customerHubSettings: {
        defaultMessage: 'Customer experience settings',
        description: 'Customer experience settings navigation item',
        id: 'avatar.menu.v2.customerHubSettings'
    },
    tooltip: {
        defaultMessage: 'Profile and settings',
        description: 'tooltip on avatar',
        id: 'avatar.profile.v2.tooltip'
    },
    reporting: {
        defaultMessage: 'Performance',
        description: 'Navigates to Reporting page',
        id: 'avatar.menu.v2.reporting'
    },
    virtualServiceAgent: {
        defaultMessage: 'Virtual service agent',
        description: 'Navigates to virtual service agent page',
        id: 'avatar.menu.v2.virtualServiceAgent'
    },
    portalAnnouncement: {
        defaultMessage: 'Announcements',
        description: 'announcement item in menu portal subsection',
        id: 'avatar.menu.v2.portalAnnouncement'
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Portal groups',
        description: 'portal groups item in menu portal subsection',
        id: 'avatar.menu.v2.requestTypeGroup'
    },
    portal: {
        defaultMessage: 'PORTAL',
        description: 'Portal heading for menu portal subsection',
        id: 'avatar.menu.v2.portal.section'
    },
    helpCenter: {
        defaultMessage: 'HELP CENTER',
        description: 'Help Center heading for menu multi hc subsection',
        id: 'avatar.menu.v2.helpCenter.section'
    },
    onboardingDescriptionCreateOrHcClickWithLink: {
        defaultMessage: 'Upgrade to Jira Service Management Premium to create and manage multiple help centers on your site and ',
        description: 'Upgrade modal description a help center is clicked or create a help center is clicked',
        id: 'uh.home.downgrade.modal.description.create.or.hc.with.link'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    onboardingTitleHCClick: {
        defaultMessage: 'Serve different audiences with multiple help centers',
        description: 'Upgrade modal title when help center is clicked',
        id: 'uh.home.downgrade.modal.title.hc'
    },
    freeStandardAdminsChangeBoardingHeading: {
        defaultMessage: 'Your help center settings have moved here',
        description: 'Heading text for Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.heading'
    },
    freeStandardAdminsChangeBoardingContent: {
        defaultMessage: 'Manage profile settings, view your requests, and customize your help center from here.',
        description: 'Content for topics Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.content'
    },
    freeStandardAdminsChangeBoardingButton: {
        defaultMessage: 'OK',
        description: 'Button text for Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.button'
    },
    singlePortalScreenAdminsChangeBoardingHeading: {
        defaultMessage: 'Your portal settings have moved here',
        description: 'Heading text for Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.heading.'
    },
    singlePortalScreenAdminsChangeBoardingContent: {
        defaultMessage: 'Access your requests, profile settings, and customize the portal experience from here',
        description: 'Content for topics Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.content'
    },
    singlePortalScreenAdminsChangeBoardingButton: {
        defaultMessage: 'OK',
        description: 'Button text for Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.button'
    },
    manageHc: {
        defaultMessage: 'View all help centers',
        description: 'Message for navigating to hc-management screen in avatar menu',
        id: 'avatar.menu.v2.manageHc'
    },
    managePages: {
        defaultMessage: 'Landing pages',
        description: 'Message for navigating to landing pages screen in avatar menu',
        id: 'avatar.menu.v2.help.center.pages'
    },
    rovoAgent: {
        defaultMessage: 'Rovo Agent',
        description: 'Label for create cutomized rovo agent button in avatar menue which is used to create a customized rovo agent',
        id: 'avatar.menu.v2.rovoAgent'
    },
    createHc: {
        defaultMessage: 'Create a help center',
        description: 'Label for create help center button in avatar menu which is used to navigate to the help center management page',
        id: 'avatar.menu.v2.createHc'
    },
    pageLayoutPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to edit sections in your home page layout.',
        description: 'Description for premium suggestion of feature Page Layout',
        id: 'avatar.menu.v2.pageLayout.premium.description'
    },
    pageLayoutTryItNowButton: {
        defaultMessage: 'Try it now',
        description: 'Button to try the premium feature Page Layout',
        id: 'avatar.menu.v2.pageLayout.premium.try.it.now.button'
    },
    premiumLozenge: {
        defaultMessage: 'Premium',
        description: 'Premium lozenge in avatar drop-down menu',
        id: 'avatar.menu.v2.label.premium.lozenge'
    },
    landingPagesNonPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to create landing pages in a help center.',
        description: 'Non premium description for landing pages',
        id: 'avatar.menu.v2.landing.pages.non.premium.customer.description'
    },
    helpCenterMenuOptions: {
        defaultMessage: 'Help center menu options',
        description: 'Aria label for help center menu navigation list',
        id: 'avatar.menu.v2.helpCenter.menu.options'
    }
});

});

parcelRegister("24wGE", function(module, exports) {
$parcel$export(module.exports, "RovoAgentMenu", () => $0d715dbf7e828e7d$export$6cf91bfbf0fffa69);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $jByYr = parcelRequire("jByYr");

var $l4cjO = parcelRequire("l4cjO");
var $5jYgE = parcelRequire("5jYgE");

var $eT7pr = parcelRequire("eT7pr");

var $lkatq = parcelRequire("lkatq");

var $cLmLE = parcelRequire("cLmLE");

var $djZwh = parcelRequire("djZwh");
const $0d715dbf7e828e7d$export$6cf91bfbf0fffa69 = ({ onClose: onClose, component: component })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse((0, $jByYr.getHelpCenterAri)());
    const handleClick = ()=>onClose('navBarRovoAgent');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        key: "customize-menu_navBarRovoAgent",
        component: component,
        href: `${(0, $8rTkC.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/rovo-agent`,
        actionSubjectId: "navBarRovoAgent",
        onClick: handleClick,
        testId: "rovo-agent-link",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
            appearance: "new"
        }, formatMessage((0, $djZwh.default).newLozenge)),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).rovoAgent));
};

});

parcelRegister("bvpLK", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentMenu", () => $e64a351bcb1a094a$export$3d3173207fec7a12);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $kM5Oy = parcelRequire("kM5Oy");

var $jByYr = parcelRequire("jByYr");

var $lqUyf = parcelRequire("lqUyf");

var $1P98q = parcelRequire("1P98q");

var $l4cjO = parcelRequire("l4cjO");

var $lkatq = parcelRequire("lkatq");

var $1P5py = parcelRequire("1P5py");
var $4MINV = parcelRequire("4MINV");

var $cLmLE = parcelRequire("cLmLE");

var $djZwh = parcelRequire("djZwh");
const $e64a351bcb1a094a$export$3d3173207fec7a12 = ({ onClose: onClose, component: component })=>{
    const [showVaReportingOnboardingSpotlight, setShowVaReportingOnboardingSpotlight] = (0, $8P7DW.useState)(true);
    const { helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse((0, $jByYr.getHelpCenterAri)());
    const handleClick = ()=>onClose('navBarVirtualAgent');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lqUyf.default), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1P5py.default), {
            name: (0, $8rTkC.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT,
            key: "navBarVirtualAgent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            key: `customize-menu_navBarVirtualAgent`,
            component: component,
            href: `${(0, $8rTkC.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/virtual-agent`,
            actionSubjectId: "navBarVirtualAgent",
            onClick: handleClick,
            testId: "virtual-agent-link",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $djZwh.default).virtualServiceAgent)))), showVaReportingOnboardingSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4MINV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kM5Oy.default), {
        messageId: (0, $8rTkC.EngagementMessages).ONBOARD_VA_REPORTING,
        key: (0, $8rTkC.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1P98q.VaOnboardingSpotlight), {
        setShowVaReportingOnboardingSpotlight: setShowVaReportingOnboardingSpotlight
    }))));
};

});






parcelRegister("eN7Hl", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $dc15e95abfce786d$export$6e8ea24b15199873);

var $8P7DW = parcelRequire("8P7DW");
function $dc15e95abfce786d$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("eTJoQ", function(module, exports) {
$parcel$export(module.exports, "Search", () => (parcelRequire("bwfgf")).default);

var $bwfgf = parcelRequire("bwfgf");

});
parcelRegister("bwfgf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1fabdbd004bb712$export$2e2bcd8739ae039);

var $7w67y = parcelRequire("7w67y");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("e4veD");
var $f8ImP = parcelRequire("f8ImP");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $kT9oZ = parcelRequire("kT9oZ");

var $hWt0u = parcelRequire("hWt0u");
parcelRequire("4PbDu");
var $3FFzY = parcelRequire("3FFzY");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("fzkqG");
var $6Tan6 = parcelRequire("6Tan6");
parcelRequire("kIzxQ");
var $fsoF0 = parcelRequire("fsoF0");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
parcelRequire("16xwA");
var $gXexd = parcelRequire("gXexd");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $auVp4 = parcelRequire("auVp4");

var $6lTuV = parcelRequire("6lTuV");

var $byuiX = parcelRequire("byuiX");
parcelRequire("aaA3R");
var $tJpW6 = parcelRequire("tJpW6");
parcelRequire("jBWQO");
var $hR556 = parcelRequire("hR556");
parcelRequire("j0ZFp");
var $kxnZR = parcelRequire("kxnZR");
parcelRequire("k2Ntl");
var $8DQRs = parcelRequire("8DQRs");
parcelRequire("8J2ga");
var $1O3IA = parcelRequire("1O3IA");
const $e1fabdbd004bb712$export$4b85d3515bd863a5 = ({ term: term, trigger: trigger, isOpen: isOpen, onSearch: onSearch, onClose: onClose, onOpen: onOpen, resetSearch: resetSearch, fetchHelpCenter: fetchHelpCenter, fetchPortals: fetchPortals, disableSearch: disableSearch, isVSAOnHCEnabled: isVSAOnHCEnabled })=>{
    const searchButtonRef = (0, $8P7DW.useRef)(null);
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    (0, $8P7DW.useEffect)(()=>{
        if ((0, $tJpW6.isSinglePortalSearch)(portalId)) fetchPortals({
            id: (0, $tJpW6.getPortalIdAsNumber)(portalId),
            expand: [
                'kbs',
                'reqTypes',
                'reqGroups',
                'orderMapping'
            ]
        });
    }, [
        portalId,
        fetchHelpCenter,
        fetchPortals
    ]);
    const onReturnFocus = (0, $8P7DW.useCallback)((_)=>{
        //FocusLock trap is still active due to that we deffer setting focus with zero-timeout
        setTimeout(()=>{
            var _searchButtonRef$curr;
            searchButtonRef === null || searchButtonRef === void 0 || (_searchButtonRef$curr = searchButtonRef.current) === null || _searchButtonRef$curr === void 0 || _searchButtonRef$curr.focus();
        }, 0);
        return true;
    }, []);
    (0, $8P7DW.useEffect)(()=>()=>{
            resetSearch();
        }, [
        resetSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8DQRs.default), {
        isOpen: isOpen,
        term: term,
        portalId: portalId,
        onSearch: onSearch,
        onClose: onClose,
        onReturnFocus: onReturnFocus,
        isVSAOnHCEnabled: isVSAOnHCEnabled
    }), trigger === 'icon' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gXexd.default), {
        ref: searchButtonRef,
        shown: isOpen,
        onClick: onOpen,
        disableSearch: disableSearch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hR556.InlineResultsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1O3IA.default), {
        term: term,
        disableSearch: disableSearch,
        isVSAOnHCEnabled: !!isVSAOnHCEnabled
    }))));
};
const $e1fabdbd004bb712$var$SearchWithVirtualAgentAvailability = (props)=>{
    var _data$helpCenter, _data$helpCenter2, _data$virtualAgent;
    const { queryReference: queryReference, ...rest } = props;
    const data = (0, $h3cOB.usePreloadedQuery)((0, $7w67y.default), props.queryReference);
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($e1fabdbd004bb712$export$4b85d3515bd863a5, rest);
    const isVirtualAgentEnabled = ((_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.virtualAgentEnabled) ?? false;
    const isVirtualAgentAvailable = (0, $HGACo.isVAOnHelpCenterGAEnabled)() ? ((_data$virtualAgent = data.virtualAgent) === null || _data$virtualAgent === void 0 ? void 0 : _data$virtualAgent.virtualAgentAvailability) ?? false : true;
    const isVSAOnHCEnabled = isVirtualAgentEnabled && isVirtualAgentAvailable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($e1fabdbd004bb712$export$4b85d3515bd863a5, {
        isVSAOnHCEnabled: isVSAOnHCEnabled,
        ...rest
    });
};
const $e1fabdbd004bb712$export$ab176425b2a52b00 = (props)=>{
    const { userLoggedIn: userLoggedIn } = props;
    const { queryReference: queryReference, refresh: refresh } = (0, $byuiX.useRelayResource)((0, $kT9oZ.searchComponentVirtualAgentResource));
    const prevUserLoggedInState = (0, $6lTuV.usePrevious)(userLoggedIn);
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        if ((0, $1EFS8.default).checkGate('jsd-search-router-login-logic-removal') && !prevUserLoggedInState && userLoggedIn) // fire refresh only if user has logged in same session, e.g., Portal only customer login
        refresh();
    }, [
        prevUserLoggedInState,
        userLoggedIn,
        refresh
    ]);
    const renderError = (0, $8P7DW.useCallback)(()=>{
        // We fallback to non-VSA search if there is an error occurs in this loader, All the other errors should be handled by the SearchErrorBoundary default renderError
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kxnZR.default), {
            id: "help-center-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($e1fabdbd004bb712$export$4b85d3515bd863a5, props));
    }, [
        props
    ]);
    if (!queryReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kxnZR.default), {
        id: "help-center-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($e1fabdbd004bb712$export$4b85d3515bd863a5, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kxnZR.default), {
        id: "help-center-search",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($e1fabdbd004bb712$export$4b85d3515bd863a5, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($e1fabdbd004bb712$var$SearchWithVirtualAgentAvailability, {
        queryReference: queryReference,
        ...props
    })));
};
const $e1fabdbd004bb712$var$selector = (0, $ehscL.createSelector)((0, $fsoF0.getShown), (0, $fsoF0.getTerm), (0, $hx8zX.isLoggedIn), (shown, term, userLoggedIn)=>({
        term: term,
        userLoggedIn: userLoggedIn,
        isOpen: shown
    }));
const $e1fabdbd004bb712$var$ConnectedSearch = (0, $jvoWT.default)($e1fabdbd004bb712$var$selector, {
    onOpen: ()=>(0, $6Tan6.showSearch)(true),
    onClose: ()=>(0, $6Tan6.showSearch)(false),
    onSearch: (term)=>(0, $6Tan6.updateSearch)(term, {}),
    resetSearch: (0, $6Tan6.resetSearch),
    fetchPortals: (0, $d727K.fetchPortalAction),
    fetchHelpCenter: (0, $f8ImP.fetchHelpCenterAction)
})((0, $auVp4.PortalAnalyticsModal)((0, $8rTkC.ScreenName).HELP_CENTER_SEARCH)(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
(0, $hWt0u.default)((0, $eS4yu.default)({
    component: (0, $8rTkC.ScreenName).HELP_CENTER_SEARCH
})((0, $k7ZVu.default)()($e1fabdbd004bb712$export$ab176425b2a52b00)))));
var $e1fabdbd004bb712$export$2e2bcd8739ae039 = $e1fabdbd004bb712$var$ConnectedSearch;

});
parcelRegister("jBWQO", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => (parcelRequire("hR556")).InlineResultsContextProvider);
$parcel$export(module.exports, "useInlineResultsContext", () => (parcelRequire("hR556")).useInlineResultsContext);

var $hR556 = parcelRequire("hR556");

});
parcelRegister("hR556", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => $8dcca149735f2ecb$export$55d16b7f4336c4d7);
$parcel$export(module.exports, "useInlineResultsContext", () => $8dcca149735f2ecb$export$243a7c3fd4b96b3e);

var $8P7DW = parcelRequire("8P7DW");
const $8dcca149735f2ecb$var$InlineResultsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(null);
const $8dcca149735f2ecb$export$55d16b7f4336c4d7 = ({ children: children })=>{
    const [resultsCount, setResultsCount] = (0, $8P7DW.useState)(null);
    const updateSearchResultsCount = (0, $8P7DW.useCallback)((resourceType, resourceCount)=>setResultsCount((state)=>({
                ...state,
                [resourceType]: resourceCount
            })), [
        setResultsCount
    ]);
    const clearSearchResultsCount = (0, $8P7DW.useCallback)(()=>setResultsCount(null), [
        setResultsCount
    ]);
    const contextValue = (0, $8P7DW.useMemo)(()=>({
            resultsCount: resultsCount,
            clearSearchResultsCount: clearSearchResultsCount,
            updateSearchResultsCount: updateSearchResultsCount
        }), [
        resultsCount,
        clearSearchResultsCount,
        updateSearchResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($8dcca149735f2ecb$var$InlineResultsContext.Provider, {
        value: contextValue
    }, children);
};
const $8dcca149735f2ecb$export$243a7c3fd4b96b3e = ()=>{
    const context = (0, $8P7DW.useContext)($8dcca149735f2ecb$var$InlineResultsContext);
    if (!context) throw new Error('useInlineResultsContext must be used within InlineResultsContextProvider');
    return context;
};

});


parcelRegister("j0ZFp", function(module, exports) {
$parcel$export(module.exports, "SearchErrorBoundary", () => (parcelRequire("kxnZR")).default);

var $kxnZR = parcelRequire("kxnZR");

});
parcelRegister("kxnZR", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5ca45bf1a74b07d$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $edC7N = parcelRequire("edC7N");

var $1We2B = parcelRequire("1We2B");

var $gk18s = parcelRequire("gk18s");

var $86q7M = parcelRequire("86q7M");

var $hrPHR = parcelRequire("hrPHR");

var $klz3F = parcelRequire("klz3F");
parcelRequire("ksF2K");
var $3O67x = parcelRequire("3O67x");

var $fUHLQ = parcelRequire("fUHLQ");
const $a5ca45bf1a74b07d$var$SearchErrorBoundary = ({ screenName: screenName, id: id, children: children, renderError: renderError })=>{
    /**
   * If any error unrecoverable occurs inside search
   * 1. It should fail the entire experience - UFO
   * 2. Return null by default
   * 3. Send error payload to sentry and analytics - through ErrorBoundary
   * 4. Pass reason for the failure using UFO
   */ const markExperienceFailed = (0, $8P7DW.useCallback)((error)=>{
        if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) {
            const metadata = {
                id: id,
                error: error === null || error === void 0 ? void 0 : error.message,
                failureEvent: screenName
            };
            (0, $fUHLQ.searchExperience).failure({
                metadata: metadata
            }).then((0, $1We2B.noop)).catch((0, $1We2B.noop));
            if ((0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType)) (0, $fUHLQ.csmSearchExperience).failure({
                metadata: metadata
            }).then((0, $1We2B.noop)).catch((0, $1We2B.noop));
            (0, $fUHLQ.inlineSearchExperience).failure({
                metadata: metadata
            }).then((0, $1We2B.noop)).catch((0, $1We2B.noop));
        }
    }, [
        id,
        screenName
    ]);
    const defaultRenderError = (0, $8P7DW.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3O67x.default), null);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: screenName,
        id: id,
        renderError: renderError ? renderError : defaultRenderError,
        onError: markExperienceFailed
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(children));
};
var $a5ca45bf1a74b07d$export$2e2bcd8739ae039 = (0, $86q7M.default)($a5ca45bf1a74b07d$var$SearchErrorBoundary);

});
parcelRegister("ksF2K", function(module, exports) {
$parcel$export(module.exports, "SearchResultError", () => (parcelRequire("3O67x")).default);

var $3O67x = parcelRequire("3O67x");

});
parcelRegister("3O67x", function(module, exports) {
$parcel$export(module.exports, "default", () => $84173ef133c32c9a$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $04X5p = parcelRequire("04X5p");

var $2CgpM = parcelRequire("2CgpM");

var $5jYgE = parcelRequire("5jYgE");

var $iqJis = parcelRequire("iqJis");

var $2IKBM = parcelRequire("2IKBM");

var $jsmb9 = parcelRequire("jsmb9");
parcelRequire("aaA3R");
var $bT2e1 = parcelRequire("bT2e1");

var $3YnuX = parcelRequire("3YnuX");
const $84173ef133c32c9a$var$SearchResultError = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bT2e1.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2CgpM)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "xsmall"
    }, formatMessage((0, $3YnuX.default).searchErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("p", {
        style: {
            textAlign: 'center'
        }
    }, formatMessage((0, $3YnuX.default).searchErrorText, {
        helpCenterLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $04X5p.default), {
            to: (0, $jsmb9.getHelpCenterUrl)(),
            actionSubjectId: "helpCenterLink"
        }, formatMessage((0, $3YnuX.default).helpCenter))
    })));
};
var $84173ef133c32c9a$export$2e2bcd8739ae039 = $84173ef133c32c9a$var$SearchResultError;

});
parcelRegister("3YnuX", function(module, exports) {
$parcel$export(module.exports, "default", () => $58781799ced0a189$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $58781799ced0a189$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    searchErrorTitle: {
        defaultMessage: 'We couldn\u2019t load your search results',
        description: 'Text to tell the user that there was an error while conducting a search',
        id: 'cv.search.error.title'
    },
    searchErrorText: {
        defaultMessage: 'Refresh the page and try again. Or go back to the { helpCenterLink }.',
        description: 'Text to tell the user how to proceed after there is an error while searching',
        id: 'cv.search.error.message'
    },
    helpCenter: {
        defaultMessage: 'help center',
        description: 'Text to render help center link',
        id: 'cv.search.error.help-center'
    }
});

});



parcelRegister("fUHLQ", function(module, exports) {
$parcel$export(module.exports, "searchExperience", () => $adc288eb9fcc4826$export$478fc2b872b7df27);
$parcel$export(module.exports, "csmSearchExperience", () => $adc288eb9fcc4826$export$c32ff69c6cd0bb0b);
$parcel$export(module.exports, "inlineSearchExperience", () => $adc288eb9fcc4826$export$e3eaed2128f58e6a);

var $lQb0x = parcelRequire("lQb0x");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $adc288eb9fcc4826$export$478fc2b872b7df27 = new (0, $ghwxF.UFOExperience)((0, $lQb0x.searchExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageLoad
});
const $adc288eb9fcc4826$export$c32ff69c6cd0bb0b = new (0, $ghwxF.UFOExperience)('csm-help-center-search', {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $adc288eb9fcc4826$export$e3eaed2128f58e6a = new (0, $ghwxF.UFOExperience)((0, $lQb0x.inlineSearchExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});



parcelRegister("k2Ntl", function(module, exports) {
$parcel$export(module.exports, "SearchModal", () => (parcelRequire("8DQRs")).default);

var $8DQRs = parcelRequire("8DQRs");

});
parcelRegister("8DQRs", function(module, exports) {
$parcel$export(module.exports, "default", () => $433ca808a64426e2$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $eD321 = parcelRequire("eD321");

var $j20Mj = parcelRequire("j20Mj");

var $jByYr = parcelRequire("jByYr");

var $cuAVQ = parcelRequire("cuAVQ");

var $h1yZX = parcelRequire("h1yZX");

var $fmVHO = parcelRequire("fmVHO");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");

var $cBdFf = parcelRequire("cBdFf");

var $bT4U6 = parcelRequire("bT4U6");

var $1NJBM = parcelRequire("1NJBM");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $ktwNU = parcelRequire("ktwNU");
var $2Mjg8 = parcelRequire("2Mjg8");
var $2IKBM = parcelRequire("2IKBM");
var $37U6z = parcelRequire("37U6z");

var $2nrNX = parcelRequire("2nrNX");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $an0gU = parcelRequire("an0gU");

var $gjhiH = parcelRequire("gjhiH");

var $6L3qX = parcelRequire("6L3qX");
parcelRequire("aaA3R");
var $tJpW6 = parcelRequire("tJpW6");
var $bT2e1 = parcelRequire("bT2e1");
parcelRequire("d70uv");
var $frDPg = parcelRequire("frDPg");
parcelRequire("deuNn");
var $dq97Q = parcelRequire("dq97Q");
parcelRequire("2nr8U");
var $7xwor = parcelRequire("7xwor");

var $cel5H = parcelRequire("cel5H");
const $433ca808a64426e2$var$SearchModal = ({ isOpen: isOpen, term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, isLoggedIn: isLoggedIn, portalId: portalId, projectId: projectId, onSearch: onSearch, onClose: onClose, onReturnFocus: onReturnFocus })=>{
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const showSearchResults = (0, $tJpW6.isValidSearchTerm)(term);
    const scope = portalId ? 'portal' : 'helpCenter';
    const cloudId = (0, $jByYr.getCloudId)();
    const { isVirtualAgentEnabled: isVirtualAgentAvailableForProject } = (0, $an0gU.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const isVirtualAgentAvailableForPortal = scope === 'portal' && isVirtualAgentAvailableForProject;
    const isVirtualAgentAvailableForHelpCenter = scope === 'helpCenter' && isVSAOnHCEnabled;
    const isVirtualAgentAvailable = isVirtualAgentAvailableForPortal || isVirtualAgentAvailableForHelpCenter;
    const onKeyUp = (0, $8P7DW.useCallback)((event)=>{
        if (event.key === 'Escape') onClose();
    }, [
        onClose
    ]);
    const [{ location: location }, { replace: replace }] = (0, $i9cdb.useRouter)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $tJpW6.useQueryParams)();
    const { portalIds: portalIds, categoryIds: categoryIds } = queryStringParams;
    const portalIdAsNumber = (0, $tJpW6.getPortalIdAsNumber)(portalId);
    const showCategoryFilter = (0, $tJpW6.isSinglePortalSearch)(portalIdAsNumber);
    const onServiceDeskFilterChange = (0, $8P7DW.useCallback)((options)=>{
        const selectedPortalIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($h1yZX))).stringify({
            ...queryStringParams,
            portalIds: selectedPortalIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const onCategoryFilterChange = (0, $8P7DW.useCallback)((options)=>{
        const selectedCategoryIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($h1yZX))).stringify({
            ...queryStringParams,
            categoryIds: selectedCategoryIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const renderResults = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
            gap: "space.200",
            templateColumns: "1fr",
            alignItems: "center",
            xcss: $433ca808a64426e2$var$responsiveStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null), showSearchResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), null, isVirtualAgentAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $433ca808a64426e2$var$virtualBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gjhiH.VirtualAgentBanner), {
            cloudId: cloudId,
            portalId: portalId
        })), !isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
            xcss: $433ca808a64426e2$var$filterStyles
        }, showCategoryFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6L3qX.default), {
            onChange: onCategoryFilterChange,
            portalId: portalIdAsNumber,
            projectId: projectId,
            categoryIds: categoryIds
        }), !showCategoryFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cel5H.default), {
            onChange: onServiceDeskFilterChange,
            portalIds: portalIds
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7xwor.SearchResult), {
            term: term
        })) : // Show empty query state if invalid search term
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $frDPg.SearchResultNone), {
            term: term
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bT4U6.default), {
        duration: "small",
        entranceDirection: "bottom"
    }, (fadeInProps)=>isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1NJBM.default), {
            zIndex: (0, $2nrNX.layers).dialog()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
            ...fadeInProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            style: {
                width: '100vw',
                height: '100vh',
                position: 'fixed',
                top: '0px',
                left: '0px'
            },
            role: "dialog",
            "aria-modal": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fmVHO.default), {
            autoFocus: true,
            returnFocus: onReturnFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cuAVQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cBdFf.default), {
            shouldAllowClickThrough: false,
            isTinted: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $37U6z.xcss)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                height: `calc(100% - ${(0, $bT2e1.SEARCH_BAR_HEIGHT)})`
            }),
            onKeyUp: onKeyUp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dq97Q.SearchBar), {
            term: term,
            onChange: onSearch,
            onClose: onClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            id: "dynamic-search-result",
            "aria-live": "polite",
            "aria-atomic": "true",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $37U6z.xcss)({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                top: (0, $bT2e1.SEARCH_BAR_HEIGHT),
                backgroundColor: 'elevation.surface.overlay',
                paddingTop: 'space.300',
                paddingBottom: 'space.200',
                overflow: 'auto'
            })
        }, renderResults())))))));
};
var $433ca808a64426e2$export$2e2bcd8739ae039 = (0, $jvoWT.default)((0, $ehscL.createSelector)((0, $j20Mj.isLoggedIn), (state, { portalId: portalId })=>({
        portalId: portalId,
        projectId: (0, $eD321.getProjectId)(state, (0, $tJpW6.getPortalIdAsNumber)(portalId))
    }), (isLoggedIn, { portalId: portalId, projectId: projectId })=>({
        isLoggedIn: isLoggedIn,
        portalId: portalId,
        projectId: projectId
    })))($433ca808a64426e2$var$SearchModal);
const $433ca808a64426e2$var$virtualBannerStyles = (0, $37U6z.xcss)({
    marginBottom: 'space.200'
});
const $433ca808a64426e2$var$filterStyles = (0, $37U6z.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.300'
});
const $433ca808a64426e2$var$responsiveStyles = (0, $37U6z.xcss)({
    [(0, $2Mjg8.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $2Mjg8.media).above.md]: {
        gridTemplateColumns: '1fr 965px 1fr',
        marginLeft: 'space.0',
        marginRight: 'space.0'
    }
});

});
parcelRegister("6L3qX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3440856bf5df3f3e$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("e4veD");
var $jNLTF = parcelRequire("jNLTF");

var $eD321 = parcelRequire("eD321");

var $d6yno = parcelRequire("d6yno");
const $3440856bf5df3f3e$var$selector = (0, $ehscL.createSelector)((state, props)=>(0, $eD321.getCategories)(state, props.portalId), (maybeCategories)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories
    };
});
const $3440856bf5df3f3e$var$CategoryFilter = (0, $jvoWT.default)($3440856bf5df3f3e$var$selector, {
    fetchCategories: (0, $jNLTF.fetchCategoriesAction)
})((0, $d6yno.default));
var $3440856bf5df3f3e$export$2e2bcd8739ae039 = $3440856bf5df3f3e$var$CategoryFilter;

});
parcelRegister("d6yno", function(module, exports) {
$parcel$export(module.exports, "default", () => $27c553b41308e293$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("8DNDe");
var $gOsrD = parcelRequire("gOsrD");

var $gxCbg = parcelRequire("gxCbg");
const $27c553b41308e293$var$CategoryFilter = ({ portalId: portalId, fetchCategories: fetchCategories, categories: categories, categoryIds: categoryIds, onChange: onChange, projectId: projectId })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [values, _] = $8P7DW.useState(categoryIds ?? []);
    $8P7DW.useEffect(()=>{
        if (!projectId || !portalId) return;
        fetchCategories(projectId, portalId);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectId,
        portalId
    ]);
    const options = $8P7DW.useMemo(()=>{
        return categories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories
    ]);
    const preSelectedOptions = $8P7DW.useMemo(()=>{
        const preselectedCategories = categories.filter((category)=>values.find((id)=>id === category.id));
        return preselectedCategories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories,
        values
    ]);
    return categories.length > 1 ? /*#__PURE__*/ $8P7DW.createElement((0, $gOsrD.default), {
        fieldId: "category_filter",
        fieldLabel: formatMessage((0, $gxCbg.default).categoryFilter),
        testId: "categoryFilter",
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange
    }) : null;
};
var $27c553b41308e293$export$2e2bcd8739ae039 = $27c553b41308e293$var$CategoryFilter;

});
parcelRegister("8DNDe", function(module, exports) {
$parcel$export(module.exports, "SimplePicker", () => (parcelRequire("gOsrD")).default);

var $gOsrD = parcelRequire("gOsrD");

});
parcelRegister("gOsrD", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1c7b30426d6076$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $1H1C6 = parcelRequire("1H1C6");

var $1We2B = parcelRequire("1We2B");

var $8gu7I = parcelRequire("8gu7I");
const $9b1c7b30426d6076$export$a250605dcad5aca0 = (str, toMatch)=>{
    if (!str) return false;
    return toMatch ? str.toLowerCase().includes(toMatch.toLowerCase()) : true;
};
const $9b1c7b30426d6076$export$60d56ed3961c839c = (0, $1We2B.memoize)((options, searchText)=>{
    if ((0, $1We2B.isEmpty)(searchText)) return options;
    const filteredOptions = [];
    for (const option of options)if ($9b1c7b30426d6076$export$a250605dcad5aca0(option.label, searchText)) filteredOptions.push(option);
    return filteredOptions;
}, (...args)=>JSON.stringify(args));
const $9b1c7b30426d6076$var$Picker = ({ options: options, preSelectedOptions: preSelectedOptions, onChange: onChange, fieldId: fieldId, testId: testId, fieldLabel: fieldLabel })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const [selectedValues, setSelectedValues] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(preSelectedOptions ?? []);
    const onPickerTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback(()=>{
        setIsOpen(true);
    }, []);
    const onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback(()=>{
        setIsOpen(false);
    }, []);
    const onFilterChange = (0, $8P7DW.useCallback)((selectedOptions)=>{
        onChange(selectedOptions);
        setSelectedValues(selectedOptions);
    }, [
        onChange
    ]);
    const onFilterClearValues = (0, $8P7DW.useCallback)(()=>{
        onChange([]);
        setSelectedValues([]);
    }, [
        onChange
    ]);
    const onLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((search, _enableFullList, _showFullList, _showMore, _lastOption, cb)=>{
        const filteredOptions = $9b1c7b30426d6076$export$60d56ed3961c839c(options, search);
        cb({
            options: filteredOptions,
            totalCount: filteredOptions.length
        });
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: fieldId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1H1C6.default), {
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        isOpen: isOpen,
        value: selectedValues,
        enablePagination: false,
        onOpen: onOpen,
        onClose: onClose,
        onChange: onFilterChange,
        onLoadOptions: onLoadOptions,
        onClearValues: onFilterClearValues,
        onPickerTriggerClick: onPickerTriggerClick,
        testId: testId
    }));
};
var $9b1c7b30426d6076$export$2e2bcd8739ae039 = $9b1c7b30426d6076$var$Picker;

});


parcelRegister("gxCbg", function(module, exports) {
$parcel$export(module.exports, "default", () => $115c047e0b22dbd6$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $115c047e0b22dbd6$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    categoryFilter: {
        defaultMessage: 'Category',
        description: 'Title of the category picker',
        id: 'sd.all.articles.result.category.filter.name'
    }
});

});



parcelRegister("d70uv", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => (parcelRequire("frDPg")).SearchResultNone);

var $frDPg = parcelRequire("frDPg");

});
parcelRegister("frDPg", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => $31abb0ec467189b8$export$149a2f9a7f0755fb);

var $8P7DW = parcelRequire("8P7DW");

var $1vm2y = parcelRequire("1vm2y");

var $jgxNN = parcelRequire("jgxNN");

var $5jYgE = parcelRequire("5jYgE");

var $iqJis = parcelRequire("iqJis");

var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");

var $dfS0m = parcelRequire("dfS0m");
parcelRequire("aaA3R");
var $bT2e1 = parcelRequire("bT2e1");

var $fUHLQ = parcelRequire("fUHLQ");

var $1eVve = parcelRequire("1eVve");
const $31abb0ec467189b8$export$149a2f9a7f0755fb = ({ term: term })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    if (term === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bT2e1.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1vm2y))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $1eVve.default).noSearchQueryTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        align: "center"
    }, formatMessage((0, $1eVve.default).noSearchQueryBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $fUHLQ.searchExperience)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bT2e1.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jgxNN))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $1eVve.default).noSearchResultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        align: "center"
    }, formatMessage((0, $1eVve.default).noSearchResultBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $fUHLQ.searchExperience)
    }));
};

});
parcelRegister("1eVve", function(module, exports) {
$parcel$export(module.exports, "default", () => $955144242e163b8f$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $955144242e163b8f$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    noSearchResultTitle: {
        defaultMessage: 'We couldn\u2019t find a match for your search',
        description: 'Text to tell the user that there was no search results found after they have conducted a search',
        id: 'cv.search.none.no-search-result-title'
    },
    noSearchResultText: {
        defaultMessage: 'We couldn\u2019t find any matches for \u2018{ term }\u2019. Check your search for typos, or try another search term.',
        description: 'Title text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-text'
    },
    noSearchResultBody: {
        defaultMessage: 'Check your search for typos, or try another search term.',
        description: 'Body text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-body'
    },
    noSearchQueryTitle: {
        defaultMessage: 'Looking for something?',
        description: 'Title text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-title'
    },
    noSearchQueryBody: {
        defaultMessage: 'Enter your search term above to get started.',
        description: 'Body text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-body'
    }
});

});



parcelRegister("deuNn", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => (parcelRequire("dq97Q")).SearchBar);

var $dq97Q = parcelRequire("dq97Q");

});
parcelRegister("dq97Q", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => $2452b99aa6d1b554$export$79d13b60110f33be);

var $8P7DW = parcelRequire("8P7DW");

var $67PZi = parcelRequire("67PZi");

var $1We2B = parcelRequire("1We2B");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");

var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $b9hQ0 = parcelRequire("b9hQ0");

var $kDg5W = parcelRequire("kDg5W");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $ktwNU = parcelRequire("ktwNU");
var $37U6z = parcelRequire("37U6z");

var $2Mjg8 = parcelRequire("2Mjg8");

var $gFpea = parcelRequire("gFpea");

var $2Np0t = parcelRequire("2Np0t");
parcelRequire("aaA3R");
var $bT2e1 = parcelRequire("bT2e1");
var $kywYl = parcelRequire("kywYl");
var $tJpW6 = parcelRequire("tJpW6");

var $9Pyg2 = parcelRequire("9Pyg2");
const $2452b99aa6d1b554$export$79d13b60110f33be = ({ term: term, onChange: onChange, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [backButtonText, setBackButtonText] = (0, $8P7DW.useState)();
    const searchBarRef = (0, $8P7DW.useRef)(null);
    const [searchQuery, setSearchQuery] = (0, $8P7DW.useState)(term);
    (0, $8P7DW.useEffect)(()=>{
        let observer;
        const currentSearchBarRefRef = searchBarRef.current;
        if (window.ResizeObserver) {
            observer = new window.ResizeObserver((entries)=>{
                for (const entry of entries)setBackButtonText(entry.contentRect.width < 768 ? '' : undefined);
            });
            if (currentSearchBarRefRef) observer.observe(currentSearchBarRefRef);
        }
        return ()=>{
            if (currentSearchBarRefRef) observer.unobserve(currentSearchBarRefRef);
        };
    }, []);
    const debouncedOnChangeMethod = (0, $8P7DW.useMemo)(()=>(0, $1We2B.debounce)((value)=>{
            onChange(value);
        }, (0, $kywYl.SEARCH_QUERY_DEBOUNCE_TIME)), [
        onChange
    ]);
    const onSearchTermChange = (0, $8P7DW.useCallback)((e)=>{
        setSearchQuery(e.target.value);
        if ((0, $1EFS8.default).checkGate('debounce_change_in_portal_search')) debouncedOnChangeMethod(e.target.value);
        else onChange(e.target.value);
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'changed',
            actionSubject: 'searchTermValue',
            actionSubjectId: 'searchTerm'
        }).fire();
    }, [
        createAnalyticsEvent,
        debouncedOnChangeMethod,
        onChange
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'rendered',
            actionSubject: 'searchBarTextField',
            actionSubjectId: 'searchBar'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { goBack: goBack, push: push } = (0, $dKPjT.useRouterActions)();
    const onBackButtonClick = (0, $8P7DW.useCallback)(()=>{
        goBack();
    }, [
        goBack
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $tJpW6.useQueryParams)();
    const onCrossIconClick = (0, $8P7DW.useCallback)(()=>{
        setSearchQuery('');
        onChange('');
        push((0, $2Np0t.addParamsToUrl)('', {
            ...queryStringParams,
            q: ''
        }));
    }, [
        onChange,
        push,
        queryStringParams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        xcss: $2452b99aa6d1b554$var$containerStyles,
        ref: searchBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        gap: "space.200",
        templateColumns: "25fr 50fr 25fr",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $2452b99aa6d1b554$var$backButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $67PZi.default), {
        text: backButtonText,
        actionSubjectId: "closeSearch",
        onClick: onBackButtonClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $2452b99aa6d1b554$var$textFieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gFpea.default), {
        id: "search-bar-input",
        value: searchQuery,
        name: formatMessage((0, $9Pyg2.default).inputLabel),
        "aria-label": formatMessage((0, $9Pyg2.default).inputPlaceholder),
        onChange: onSearchTermChange,
        placeholder: formatMessage((0, $9Pyg2.default).inputPlaceholder),
        "aria-describedby": "dynamic-search-result",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $2452b99aa6d1b554$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kDg5W))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: "button",
            "aria-label": formatMessage((0, $9Pyg2.default).clearLabel),
            xcss: $2452b99aa6d1b554$var$crossIconStyles,
            onClick: onCrossIconClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))), {
            label: formatMessage((0, $9Pyg2.default).clearLabel),
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        // Disabling existing violations, should be fixed when revisited.
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null)));
};
const $2452b99aa6d1b554$var$containerStyles = (0, $37U6z.xcss)({
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    width: '100vw',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    height: (0, $bT2e1.SEARCH_BAR_HEIGHT),
    backgroundColor: 'elevation.surface.overlay',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: "var(--ds-border, #EBECF0)",
    zIndex: 'modal'
});
const $2452b99aa6d1b554$var$backButtonStyles = (0, $37U6z.xcss)({
    [(0, $2Mjg8.media).above.xxs]: {
        marginLeft: 'space.050'
    },
    [(0, $2Mjg8.media).above.xs]: {
        marginLeft: 'space.100'
    },
    [(0, $2Mjg8.media).above.sm]: {
        marginLeft: 'space.200'
    }
});
const $2452b99aa6d1b554$var$textFieldStyles = (0, $37U6z.xcss)({
    height: 'space.500',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    background: 'transparent',
    [(0, $2Mjg8.media).above.xxs]: {
        width: '348px'
    },
    [(0, $2Mjg8.media).above.xs]: {
        width: '432px'
    },
    [(0, $2Mjg8.media).above.sm]: {
        width: '692px'
    },
    [(0, $2Mjg8.media).above.md]: {
        width: '965px'
    }
});
const $2452b99aa6d1b554$var$searchIconStyles = (0, $37U6z.xcss)({
    padding: 'space.100'
});
const $2452b99aa6d1b554$var$crossIconStyles = (0, $37U6z.xcss)({
    background: 'transparent',
    cursor: 'pointer'
});
var $2452b99aa6d1b554$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($2452b99aa6d1b554$export$79d13b60110f33be);

});
parcelRegister("9Pyg2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e11e461c4c1b3938$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $e11e461c4c1b3938$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    inputPlaceholder: {
        defaultMessage: 'Search for help resources',
        description: 'Placeholder message for the search bar describing what they can look for',
        id: 'cv.search.search-bar.input.placeholder'
    },
    close: {
        defaultMessage: 'Close search',
        description: 'Label for the close button which closes the search overlay',
        id: 'cv.search.search-bar.close'
    },
    inputLabel: {
        defaultMessage: 'Search bar input',
        description: 'Label message for the search bar input',
        id: 'cv.search.search-bar.input-label'
    },
    searchIconLabel: {
        defaultMessage: 'Search icon',
        description: 'Label message for the search bar input icon',
        id: 'cv.search.search-bar.search-icon-label'
    },
    clearLabel: {
        defaultMessage: 'clear',
        description: 'Label for the clear button which clears the search input',
        id: 'cv.search.search-bar.clear-label'
    }
});

});



parcelRegister("2nr8U", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => (parcelRequire("7xwor")).SearchResult);

var $7xwor = parcelRequire("7xwor");

});
parcelRegister("7xwor", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $812cddf64e5f2f79$export$a2def421b23768aa);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("4PbDu");
var $3FFzY = parcelRequire("3FFzY");

var $55x6k = parcelRequire("55x6k");
var $2Mjg8 = parcelRequire("2Mjg8");
var $2IKBM = parcelRequire("2IKBM");
var $37U6z = parcelRequire("37U6z");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $6lTuV = parcelRequire("6lTuV");

var $4BXjO = parcelRequire("4BXjO");
parcelRequire("evsTD");
var $eApcr = parcelRequire("eApcr");
parcelRequire("aaA3R");
var $kywYl = parcelRequire("kywYl");

var $fUHLQ = parcelRequire("fUHLQ");
parcelRequire("2r6VX");
var $arQfg = parcelRequire("arQfg");
parcelRequire("d70uv");
var $frDPg = parcelRequire("frDPg");
parcelRequire("dkMB5");
var $61YNb = parcelRequire("61YNb");
parcelRequire("jlR0o");
var $cJNey = parcelRequire("cJNey");
const $812cddf64e5f2f79$export$e9a269813a6315a4 = ({ term: term, updateResultsCount: updateResultsCount })=>{
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const onlyRenderArticles = isCSM;
    if (onlyRenderArticles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $arQfg.ArticleResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eApcr.default), {
        term: term,
        updateResultsCount: updateResultsCount
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $812cddf64e5f2f79$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $arQfg.ArticleResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eApcr.default), {
        term: term,
        updateResultsCount: updateResultsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $arQfg.SidePanelResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cJNey.default), {
        term: term,
        updateResultsCount: updateResultsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $arQfg.SidePanelResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $61YNb.default), {
        term: term,
        updateResultsCount: updateResultsCount
    }))));
};
const $812cddf64e5f2f79$export$a2def421b23768aa = ({ term: term })=>{
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const [totalCount, setTotalCount] = (0, $8P7DW.useState)(-1);
    const resultsCount = (0, $8P7DW.useRef)(-1);
    const callBackCount = (0, $8P7DW.useRef)(0);
    const debouncedTerm = (0, $4BXjO.default)(term, (0, $kywYl.SEARCH_QUERY_DEBOUNCE_TIME));
    // Every time this callback will be called, that resource will increment callBackCount through acknowledgement
    const updateResultsCount = (0, $8P7DW.useCallback)((count, acknowledgement)=>{
        if (resultsCount.current < 0) resultsCount.current = 0;
        resultsCount.current += count;
        if (acknowledgement) callBackCount.current += acknowledgement;
        // Update state only when articles, portals and requestForms all have updated the results
        if (callBackCount.current === 3) {
            // Since callbackCount will persist across states, setting it back to 0
            callBackCount.current = 0;
            setTotalCount(resultsCount.current);
        }
    }, []);
    (0, $6lTuV.useIsoMorphicLayoutEffect)(()=>{
        // Reset count to initial state on term change
        resultsCount.current = -1;
        setTotalCount(-1);
        callBackCount.current = 0;
    }, [
        debouncedTerm
    ]);
    (0, $8P7DW.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        isCSM ? (0, $fUHLQ.csmSearchExperience).start() : (0, $fUHLQ.searchExperience).start();
        return ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            isCSM ? (0, $fUHLQ.csmSearchExperience).abort() : (0, $fUHLQ.searchExperience).abort();
        };
    }, [
        debouncedTerm,
        isCSM
    ]);
    const isEmptyResultsState = totalCount === 0;
    const isEmptyQueryState = debouncedTerm === '';
    const showEmptyState = isEmptyQueryState || isEmptyResultsState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $arQfg.SearchResultsLoader), null)
    }, showEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $frDPg.SearchResultNone), {
        term: debouncedTerm
    }), !isEmptyResultsState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($812cddf64e5f2f79$export$e9a269813a6315a4, {
        term: term,
        updateResultsCount: updateResultsCount
    }));
};
const $812cddf64e5f2f79$var$responsiveStyles = (0, $37U6z.xcss)({
    [(0, $2Mjg8.media).above.xxs]: {
        gridTemplateColumns: '1fr'
    },
    [(0, $2Mjg8.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});

});
parcelRegister("evsTD", function(module, exports) {
$parcel$export(module.exports, "Articles", () => (parcelRequire("eApcr")).default);

var $eApcr = parcelRequire("eApcr");

});
parcelRegister("eApcr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d057b4ce841db26$export$2e2bcd8739ae039);

var $l7EoK = parcelRequire("l7EoK");

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $jShty = parcelRequire("jShty");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $iqJis = parcelRequire("iqJis");

var $cDQfx = parcelRequire("cDQfx");

var $e6Qdr = parcelRequire("e6Qdr");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $ip32B = parcelRequire("ip32B");

var $dfS0m = parcelRequire("dfS0m");
parcelRequire("bJwZZ");
var $iL7zj = parcelRequire("iL7zj");
parcelRequire("aaA3R");
var $kywYl = parcelRequire("kywYl");
var $tJpW6 = parcelRequire("tJpW6");
var $bT2e1 = parcelRequire("bT2e1");

var $fUHLQ = parcelRequire("fUHLQ");
parcelRequire("d70uv");
var $frDPg = parcelRequire("frDPg");

var $kignK = parcelRequire("kignK");
const $6d057b4ce841db26$export$b9fde6c411c336c6 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const CSMPortalId = isCSM ? (0, $hrPHR.getEnv)().hoistedPortalId : undefined;
    const { portalIds: portalIds, categoryIds: categoryIds } = (0, $tJpW6.useQueryParams)();
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const getSelectedPortalIds = ()=>{
        if (CSMPortalId) return (0, $tJpW6.getIdsArray)(CSMPortalId);
        if ((0, $tJpW6.isSinglePortalSearch)(portalId)) return (0, $tJpW6.getIdsArray)(portalId);
        return (0, $tJpW6.getIdsArray)(portalIds);
    };
    const cloudId = (0, $jByYr.getCloudId)();
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $l7EoK.default), {
        cloudId: cloudId,
        categoryIds: categoryIds,
        queryTerm: term,
        portalIds: getSelectedPortalIds(),
        helpCenterAri: (0, $HGACo.isProjectMappingInHelpCenterEnabled)() ? (0, $jByYr.getHelpCenterAri)() : undefined,
        limit: (0, $kywYl.ARTICLES_RESULT_LIMIT),
        highlight: true,
        isSourceSystemEnabled: (0, $1EFS8.default).checkGate('3p-integration-enabled_t5ysh') || (0, $1EFS8.default).checkGate('kb-cross-site-enabled')
    });
    const [numberOfResultsShown, setNumberOfResultsShown] = (0, $8P7DW.useState)((0, $kywYl.INITIAL_ARTICLES_LIMIT));
    const articles = (0, $8P7DW.useMemo)(()=>{
        var _data$helpObjectStore;
        return ((_data$helpObjectStore = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStoreArticleSearchResults' ? data.helpObjectStore_searchArticles.results : [];
    }, [
        data.helpObjectStore_searchArticles
    ]);
    const numOfResults = articles.length;
    const hasMoreResults = numOfResults > numberOfResultsShown;
    const showMoreArticlesButton = numberOfResultsShown < 30 && hasMoreResults;
    const slicedArticles = articles.slice(0, numberOfResultsShown) || [];
    const showSection = numOfResults > 0;
    const sourceSystem = (0, $8P7DW.useMemo)(()=>articles.reduce((records, item)=>{
            const currentSourceSystem = item.sourceSystem;
            const value = currentSourceSystem ? records[currentSourceSystem] ?? 0 : 0;
            return {
                ...records,
                ...currentSourceSystem && {
                    [currentSourceSystem]: value + 1
                }
            };
        }, {}), [
        articles
    ]);
    (0, $8P7DW.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStoreArticleSearchResults') {
            let externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchArticles.results.forEach((article)=>{
                if (article) {
                    const { metadata: metadata } = article;
                    const { searchStrategy: searchStrategy } = metadata;
                    const isExternal = article.sourceSystem === 'EXTERNAL';
                    if (isExternal) externalResourcesCount += 1;
                    if (searchStrategy === 'CONTENT_SEARCH') firstPartySearchPlatformResourcesCount += 1;
                }
            });
            (0, $tJpW6.sendSearchOperationalAnalyticEvents)({
                sourceSystem: sourceSystem,
                action: portalId ? 'KBArticleSinglePortalSearch success' : 'KBArticleHomePageSearch success',
                resourceCount: data.helpObjectStore_searchArticles.results.length,
                totalCount: data.helpObjectStore_searchArticles.totalCount
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $tJpW6.sendSearchUIAnalyticEvents)({
                sourceSystem: sourceSystem,
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'article',
                resourceCount: data.helpObjectStore_searchArticles.results.length,
                totalCount: data.helpObjectStore_searchArticles.totalCount
            }, createAnalyticsEvent, portalId);
        }
    }, [
        showSection,
        createAnalyticsEvent,
        portalId,
        sourceSystem,
        data
    ]);
    (0, $8P7DW.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchArticles;
            (0, $tJpW6.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                action: portalId ? 'KBArticleSinglePortalSearch failed' : 'KBArticleHomePageSearch failed',
                statusCode: extensions.length > 0 ? extensions[0].statusCode : undefined,
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $8P7DW.useEffect)(()=>{
        updateResultsCount(slicedArticles.length, 1);
    }, [
        term,
        slicedArticles.length,
        updateResultsCount
    ]);
    const onShowMoreClick = ()=>{
        if (numberOfResultsShown < 30) setNumberOfResultsShown((0, $kywYl.ARTICLES_RESULT_LIMIT));
    };
    if (!showSection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $frDPg.SearchResultNone), {
        term: term
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "xxsmall",
        as: (0, $1EFS8.default).checkGate('ff_a11y_hc_heading') ? 'h2' : undefined
    }, formatMessage((0, $kignK.default).articles)), (0, $e6Qdr.fg)('3p-integration-enabled_t5ysh') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ip32B.ThirdPartyCardConnector), {
        type: "card",
        connectors: [
            'googleDrive',
            'sharepoint'
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bT2e1.ResultList), {
        role: "list"
    }, slicedArticles.map((resource, index)=>{
        const itemOrder = index + 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("li", {
            key: itemOrder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iL7zj.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    })), showMoreArticlesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jShty.ThemedButton), {
        "data-test-id": "show-more-button",
        appearance: "link",
        actionSubjectId: "showMoreButton",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
            size: "small",
            spacing: "spacious",
            label: formatMessage((0, $kignK.default).showMoreIcon)
        }),
        onClick: onShowMoreClick
    }, formatMessage((0, $kignK.default).showMore))), isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $fUHLQ.csmSearchExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $fUHLQ.searchExperience)
    }));
};
var $6d057b4ce841db26$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($6d057b4ce841db26$export$b9fde6c411c336c6);

});
parcelRegister("l7EoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c654601a96c101f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c206c6cbd3c29ece0f77568582f1a876>>
 * @relayHash 0d77121bf6717adbc116ac50a5fadabf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b62240a7619322882f8f23d6f0911bdbc6f9542e80e88756d3b426e4aad97b8b
const $6c654601a96c101f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "categoryIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "highlight"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSourceSystemEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalIds"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "categoryIds",
            "variableName": "categoryIds"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "highlight",
            "variableName": "highlight"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "portalIds",
            "variableName": "portalIds"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "HelpObjectStoreArticleMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "sourceSystem"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v15 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "articlesSearchQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpObjectStoreArticleSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isSourceSystemEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "isSourceSystemEnabled",
                                                    "variableName": "isSourceSystemEnabled"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "articleItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreArticleSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "articlesSearchQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpObjectStoreArticleSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "ari"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "containerName"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreArticleSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b62240a7619322882f8f23d6f0911bdbc6f9542e80e88756d3b426e4aad97b8b",
            "metadata": {},
            "name": "articlesSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6c654601a96c101f$var$node.hash = "21465f36d9753aacb064065974751749";
var $6c654601a96c101f$export$2e2bcd8739ae039 = $6c654601a96c101f$var$node;

});

parcelRegister("ip32B", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyCardConnector", () => $b497ed191bc9f77f$export$3ebb74b46e82b89e);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $b497ed191bc9f77f$export$3ebb74b46e82b89e = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazy)(()=>(parcelRequire("dkD8H")), {
        moduleId: "./packages/help-center/thirdparty-connectors/src/ui/connectors/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("dkD8H", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("cG5g2").then(()=>parcelRequire('ZKm2S'));

});


parcelRegister("bJwZZ", function(module, exports) {
$parcel$export(module.exports, "ArticleItem", () => (parcelRequire("iL7zj")).default);

var $iL7zj = parcelRequire("iL7zj");

});
parcelRegister("iL7zj", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d9f738236ee1d66$export$2e2bcd8739ae039);

var $axQfp = parcelRequire("axQfp");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $cS6Xr = parcelRequire("cS6Xr");

var $dMqdi = parcelRequire("dMqdi");

var $j20Mj = parcelRequire("j20Mj");

var $HGACo = parcelRequire("HGACo");

var $f73iJ = parcelRequire("f73iJ");

var $loEqA = parcelRequire("loEqA");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $c1US4 = parcelRequire("c1US4");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $je3Qr = parcelRequire("je3Qr");

var $gk18s = parcelRequire("gk18s");

var $kVBdI = parcelRequire("kVBdI");

var $hrPHR = parcelRequire("hrPHR");

var $6GVst = parcelRequire("6GVst");
parcelRequire("bxFou");
var $2zWBU = parcelRequire("2zWBU");

var $kignK = parcelRequire("kignK");
parcelRequire("aaA3R");
var $tJpW6 = parcelRequire("tJpW6");
parcelRequire("3VgFF");
var $499Sb = parcelRequire("499Sb");
const $4d9f738236ee1d66$export$3a909d935747d7f7 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $axQfp.default), result);
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const { title: title, excerpt: excerpt, displayLink: displayLink, metadata: metadata, ari: ari, sourceSystem: sourceSystem } = data;
    const { searchStrategy: searchStrategy } = metadata;
    const isExternal = sourceSystem === 'EXTERNAL';
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1US4))), {
        label: formatMessage((0, $kignK.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $tJpW6.formatText)(title, term) : '';
    const highlightedDescription = excerpt ? (0, $tJpW6.formatText)(excerpt, term) : '';
    const displayLinkWithSource = (0, $kVBdI.addSourceToUrl)(displayLink, 'search', (0, $kVBdI.is3pOrExternalSource)(sourceSystem));
    const linkProps = (0, $6GVst.urlRefsAndTarget)({
        displayLink: displayLinkWithSource,
        isAnExternalResource: (0, $kVBdI.is3pOrExternalSource)(sourceSystem)
    });
    (0, $8P7DW.useEffect)(()=>{
        (0, $tJpW6.sendSearchUIAnalyticEvents)({
            sourceSystem: sourceSystem,
            ari: ari,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'article'
        }, createAnalyticsEvent, portalId);
    }, [
        ari,
        createAnalyticsEvent,
        portalId,
        searchStrategy,
        sourceSystem
    ]);
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $tJpW6.useVisibilityState)();
    const isJcsSearchExperienceEnabled = (0, $1EFS8.default).checkGate('jcs_search_experience');
    const disableMetadata = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && isJcsSearchExperienceEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        key: ari,
        xcss: $4d9f738236ee1d66$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: "search-page-result"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        columnGap: "space.150",
        templateAreas: [
            'icon heading header-right',
            'icon subheading-left header-right',
            '. body body'
        ],
        templateColumns: "auto 1fr auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $4d9f738236ee1d66$var$iconAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $499Sb.default), {
        displayLink: displayLink,
        entityType: "ARTICLE",
        sourceSystem: sourceSystem,
        isExternal: isExternal,
        variant: "tile"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $4d9f738236ee1d66$var$headingAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cS6Xr.Link), {
        key: ari,
        actionSubjectId: isExternal ? 'external-article-link' : 'article-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            ari: ari,
            itemOrder: itemOrder,
            searchStrategy: searchStrategy,
            sourceSystem: sourceSystem,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("span", {
        style: {
            color: (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $je3Qr.generateThemeBranding)(themeColor).color900 : themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(highlightedTitle) : (0, $f73iJ.sanitize)(highlightedTitle)
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: [
            $4d9f738236ee1d66$var$subheadingLeftAreaStyles,
            $4d9f738236ee1d66$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, !disableMetadata && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2zWBU.default), {
        result: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: isShortcutIconVisible ? $4d9f738236ee1d66$var$headerRightAreaStylesVisible : $4d9f738236ee1d66$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: disableMetadata ? $4d9f738236ee1d66$var$jcsBodyAreaStyles : $4d9f738236ee1d66$var$bodyAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("p", {
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(highlightedDescription) : (0, $f73iJ.sanitize)(highlightedDescription)
        }
    })))));
};
const $4d9f738236ee1d66$var$ConnectedArticleItem = (0, $jvoWT.default)((state)=>{
    return {
        isLoggedIn: (0, $j20Mj.isLoggedIn)(state),
        themeColor: (0, $dMqdi.getThemeColor)(state)
    };
})($4d9f738236ee1d66$export$3a909d935747d7f7);
var $4d9f738236ee1d66$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($4d9f738236ee1d66$var$ConnectedArticleItem);
const $4d9f738236ee1d66$var$containerStyles = (0, $37U6z.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $4d9f738236ee1d66$var$iconAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'icon',
    width: 'size.300',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    textDecoration: 'none'
});
const $4d9f738236ee1d66$var$headingAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-large, normal)"
});
const $4d9f738236ee1d66$var$subheadingStyles = (0, $37U6z.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $4d9f738236ee1d66$var$subheadingLeftAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $4d9f738236ee1d66$var$headerRightAreaStylesInVisible = (0, $37U6z.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $4d9f738236ee1d66$var$headerRightAreaStylesVisible = (0, $37U6z.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $4d9f738236ee1d66$var$bodyAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $4d9f738236ee1d66$var$jcsBodyAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'body',
    marginTop: 'space.0',
    overflowWrap: 'break-word'
});

});
parcelRegister("axQfp", function(module, exports) {
$parcel$export(module.exports, "default", () => $83cb62a58e339415$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8345c9367554c48f0812bfe943392679>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83cb62a58e339415$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSourceSystemEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "articleItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "excerpt"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "condition": "isSourceSystemEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "sourceSystem"
                }
            ]
        },
        {
            "concreteType": "HelpObjectStoreArticleMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "articleMetadataFragmentV2"
        }
    ],
    "type": "HelpObjectStoreArticleSearchResult"
};
$83cb62a58e339415$var$node.hash = "7da1cbe6e7f48ee2d870a75fe8f1d82c";
var $83cb62a58e339415$export$2e2bcd8739ae039 = $83cb62a58e339415$var$node;

});

parcelRegister("kVBdI", function(module, exports) {
$parcel$export(module.exports, "addSourceToUrl", () => $0573aa9606ba9e0f$export$cae9c63f58ebbe6f);
$parcel$export(module.exports, "is3pOrExternalSource", () => $0573aa9606ba9e0f$export$d1565b01286b6c95);

var $1EFS8 = parcelRequire("1EFS8");

var $2Np0t = parcelRequire("2Np0t");
const $0573aa9606ba9e0f$export$cae9c63f58ebbe6f = (url, source, shouldReturnUrlWithoutSource = false)=>{
    if (shouldReturnUrlWithoutSource || !(0, $1EFS8.default).checkGate('jsm_kb_source_value_in_query_param')) return url;
    return (0, $2Np0t.addParamsToUrl)(url, {
        source: source
    });
};
const $0573aa9606ba9e0f$export$d1565b01286b6c95 = (sourceSystem)=>{
    return sourceSystem === 'EXTERNAL' || sourceSystem === 'SHAREPOINT' || sourceSystem === 'GOOGLE_DRIVE';
};

});

parcelRegister("bxFou", function(module, exports) {
$parcel$export(module.exports, "ArticleMetadata", () => (parcelRequire("2zWBU")).default);

var $2zWBU = parcelRequire("2zWBU");

});
parcelRegister("2zWBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $91aa0dc8e6c14972$export$2e2bcd8739ae039);

var $4GI9P = parcelRequire("4GI9P");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $j20Mj = parcelRequire("j20Mj");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("fMSDi");
var $2YHJe = parcelRequire("2YHJe");

var $6Hfjm = parcelRequire("6Hfjm");

var $cttH7 = parcelRequire("cttH7");
const $91aa0dc8e6c14972$export$9f18a4080cf334b5 = ({ isLoggedIn: isLoggedIn, result: result })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $4GI9P.default), result);
    const { ari: ari, displayLink: displayLink, sourceSystem: sourceSystem, containerName: containerName } = data;
    const isExternal = sourceSystem === 'EXTERNAL';
    const { data: { source: source } } = (0, $2YHJe.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const confluencePageText = containerName ? formatMessage((0, $cttH7.default).confluencePage, {
        value: containerName
    }) : '';
    const showSeparator = source && containerName;
    const externalResourceParts = [
        source || '',
        showSeparator ? "\u2022" : '',
        containerName || ''
    ].filter(Boolean);
    const externalResourceText = externalResourceParts.join(' ');
    const metaData = !isExternal ? confluencePageText : externalResourceText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        key: ari
    }, metaData);
};
const $91aa0dc8e6c14972$var$ConnectedArticleMetadata = (0, $jvoWT.default)((state)=>{
    return {
        isLoggedIn: (0, $j20Mj.isLoggedIn)(state)
    };
})($91aa0dc8e6c14972$export$9f18a4080cf334b5);
var $91aa0dc8e6c14972$export$2e2bcd8739ae039 = $91aa0dc8e6c14972$var$ConnectedArticleMetadata;

});
parcelRegister("4GI9P", function(module, exports) {
$parcel$export(module.exports, "default", () => $01ecf77d5c60902c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25a1801c2a2c6bc1b192956029316c4f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $01ecf77d5c60902c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "articleMetadataFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "kind": "ScalarField",
            "name": "containerName"
        },
        {
            "kind": "ScalarField",
            "name": "sourceSystem"
        }
    ],
    "type": "HelpObjectStoreArticleSearchResult"
};
$01ecf77d5c60902c$var$node.hash = "4c3cfc8aeff9894de53a0b5480f56516";
var $01ecf77d5c60902c$export$2e2bcd8739ae039 = $01ecf77d5c60902c$var$node;

});

parcelRegister("cttH7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ded84ccb2642203e$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $ded84ccb2642203e$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    confluencePage: {
        defaultMessage: 'Confluence page in {value}',
        description: 'Confluence page metadata text',
        id: 'cv.search.articles.metadata'
    }
});

});



parcelRegister("kignK", function(module, exports) {
$parcel$export(module.exports, "default", () => $827cd52d7d7d656e$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $827cd52d7d7d656e$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    showMore: {
        defaultMessage: 'Show more',
        description: 'Text on show more results button',
        id: 'cv.search.articles.show-more'
    },
    showMoreIcon: {
        defaultMessage: 'Show more icon',
        description: 'Text for label on show more results icon',
        id: 'cv.search.articles.show-more-icon'
    },
    shortcutIcon: {
        defaultMessage: 'Shortcut icon',
        description: 'Text for label on shortcut icon',
        id: 'cv.search.articles.shortcut-icon'
    },
    articles: {
        defaultMessage: 'Self-help resources',
        description: 'Text for section resource type in search results',
        id: 'cv.search.articles.articles'
    }
});

});

parcelRegister("3VgFF", function(module, exports) {
$parcel$export(module.exports, "ResourceIcon", () => (parcelRequire("499Sb")).default);

var $499Sb = parcelRequire("499Sb");

});
parcelRegister("499Sb", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c41188792a670a8$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $dMqdi = parcelRequire("dMqdi");

var $j20Mj = parcelRequire("j20Mj");

var $iSvee = parcelRequire("iSvee");
parcelRequire("fMSDi");
var $2YHJe = parcelRequire("2YHJe");

var $1EFS8 = parcelRequire("1EFS8");

var $2KLAA = parcelRequire("2KLAA");

var $aflyD = parcelRequire("aflyD");

var $a9GGo = parcelRequire("a9GGo");

var $f1STa = parcelRequire("f1STa");

var $6591d = parcelRequire("6591d");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $je3Qr = parcelRequire("je3Qr");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $jwKos = parcelRequire("jwKos");
const $3c41188792a670a8$export$99eb8fbf40c7d2bc = ({ entityType: entityType, displayLink: displayLink, isLoggedIn: isLoggedIn, isExternal: isExternal, themeColor: themeColor, iconUrl: iconUrl, sourceSystem: sourceSystem, variant: variant = 'default' })=>{
    const { data: { iconUrl: externalResourceIconUrl }, isLoading: isIconLoading } = (0, $2YHJe.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const isValidResourceIconUrl = !!iconUrl;
    const isValidExternalResourceIconUrl = !!externalResourceIconUrl && externalResourceIconUrl !== '';
    const getDefaultIcon = (0, $8P7DW.useMemo)(()=>{
        switch(entityType){
            case 'ARTICLE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1STa))), {
                    label: "",
                    testId: "article-icon",
                    spacing: "spacious"
                });
            case 'REQUEST_FORM':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a9GGo))), {
                    label: "",
                    testId: "request-form-icon",
                    spacing: "spacious"
                });
            case 'PORTAL':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6591d))), {
                    label: "",
                    testId: "portal-icon",
                    spacing: "spacious"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aflyD))), {
                    label: "",
                    testId: "question-icon",
                    spacing: "spacious"
                });
        }
    }, [
        entityType
    ]);
    const getThirdPartyIcon = (0, $8P7DW.useMemo)(()=>{
        if (sourceSystem === 'SHAREPOINT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jwKos.IntegrationProviderMeta).sharepoint.icon, {
            label: "sharepoint"
        });
        if (sourceSystem === 'GOOGLE_DRIVE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jwKos.IntegrationProviderMeta).googleDrive.icon, {
            label: "googledrive"
        });
        return null;
    }, [
        sourceSystem
    ]);
    const getThirdPartyIconComponent = (0, $8P7DW.useMemo)(()=>{
        if (sourceSystem === 'SHAREPOINT') return (0, $jwKos.IntegrationProviderMeta).sharepoint.icon;
        if (sourceSystem === 'GOOGLE_DRIVE') return (0, $jwKos.IntegrationProviderMeta).googleDrive.icon;
        return null;
    }, [
        sourceSystem
    ]);
    const shouldUseArticleIconTile = (0, $1EFS8.default).checkGate('jsm_kb_team_26_changes') && variant === 'tile' && entityType === 'ARTICLE' && !isExternal && !isIconLoading && !isValidResourceIconUrl;
    const getExternalResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iSvee.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidExternalResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: "img",
            xcss: $3c41188792a670a8$var$imgStyles,
            testId: "external-resource-icon",
            src: externalResourceIconUrl,
            alt: ""
        });
        return getDefaultIcon;
    };
    const getResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iSvee.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            as: "img",
            xcss: $3c41188792a670a8$var$imgStyles,
            testId: "resource-icon",
            src: iconUrl,
            alt: ""
        });
        return getThirdPartyIcon ?? getDefaultIcon;
    };
    if (shouldUseArticleIconTile) {
        const ThirdPartyIconInTile = ({ label: label })=>{
            if (getThirdPartyIcon) return getThirdPartyIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1STa))), {
                label: label
            });
        };
        const IconComponent = getThirdPartyIconComponent ? ThirdPartyIconInTile : (0, (/*@__PURE__*/$parcel$interopDefault($f1STa)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $3c41188792a670a8$var$iconTileStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2KLAA.IconTile), {
            appearance: "blue",
            icon: IconComponent,
            label: "Article icon",
            size: "medium",
            testId: "article-icon-tile"
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $3c41188792a670a8$var$imgStyles,
        style: {
            color: (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $je3Qr.generateThemeBranding)(themeColor).color900 : themeColor
        }
    }, isExternal ? getExternalResourceIcon() : getResourceIcon());
};
const $3c41188792a670a8$var$ConnectedResourceIcon = (0, $jvoWT.default)((state)=>{
    return {
        isLoggedIn: (0, $j20Mj.isLoggedIn)(state),
        themeColor: (0, $dMqdi.getThemeColor)(state)
    };
})($3c41188792a670a8$export$99eb8fbf40c7d2bc);
var $3c41188792a670a8$export$2e2bcd8739ae039 = $3c41188792a670a8$var$ConnectedResourceIcon;
const $3c41188792a670a8$var$imgStyles = (0, $37U6z.xcss)({
    width: 'size.200',
    height: 'size.200',
    objectFit: 'contain'
});
const $3c41188792a670a8$var$iconTileStyles = (0, $37U6z.xcss)({
    width: 'size.300',
    height: 'size.300',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("2KLAA", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $2Im1x = parcelRequire("2Im1x");

const $2014cadb3a3b2b6f$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
     * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
     *
     * This provides a lightweight replacement for the legacy Icon component that
     * was removed in DSP-24550. Instead of wrapping the glyph in a span with
     * complex styling, it simply renders the glyph component directly, passing
     * through relevant props.
     *
     * This is NOT a public API — it exists solely to unblock the removal of
     * deprecated icon APIs from @atlaskit/icon.
     */ const React = (parcelRequire("8P7DW"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $2Im1x, {
    default: $2014cadb3a3b2b6f$var$_inlined0
});
if ($2Im1x.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("2Im1x", function(module, exports) {
$parcel$export(module.exports, "IconNew", () => (parcelRequire("hLU7q")).default);
$parcel$export(module.exports, "size", () => (parcelRequire("8sO5w")).sizeMap);
$parcel$export(module.exports, "sizes", () => (parcelRequire("8sO5w")).sizes);
$parcel$export(module.exports, "Skeleton", () => (parcelRequire("dyIze")).default);
$parcel$export(module.exports, "IconTile", () => (parcelRequire("biFIz")).default);

var $hLU7q = parcelRequire("hLU7q");

var $8sO5w = parcelRequire("8sO5w");

var $dyIze = parcelRequire("dyIze");

var $biFIz = parcelRequire("biFIz");

});
parcelRegister("8sO5w", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $0aa0dc3f6890a85a$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "sizeMap", () => $0aa0dc3f6890a85a$export$7bd66fc94c81bf84);
const $0aa0dc3f6890a85a$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $0aa0dc3f6890a85a$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $0aa0dc3f6890a85a$export$62ad7b0c781000e9 = {
    small: {
        width: $0aa0dc3f6890a85a$export$c647cb0ee6e282fe.small,
        height: $0aa0dc3f6890a85a$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $0aa0dc3f6890a85a$export$c647cb0ee6e282fe.medium,
        height: $0aa0dc3f6890a85a$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $0aa0dc3f6890a85a$export$c647cb0ee6e282fe.large,
        height: $0aa0dc3f6890a85a$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $0aa0dc3f6890a85a$export$c647cb0ee6e282fe.xlarge,
        height: $0aa0dc3f6890a85a$export$c647cb0ee6e282fe.xlarge
    }
};

});

parcelRegister("dyIze", function(module, exports) {
$parcel$export(module.exports, "default", () => $a69274533801709c$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $a69274533801709c$var$skeletonStyles = null;
const $a69274533801709c$var$subtleOpacityStyles = null;
const $a69274533801709c$var$strongOpacityStyles = null;
const $a69274533801709c$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
/**
 * __Skeleton__
 */ const $a69274533801709c$var$Skeleton = /*#__PURE__*/ (0, $8P7DW.memo)(function Skeleton({ testId: testId, size: size = 'medium', color: color = 'currentColor', weight: weight = 'normal' }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId,
        style: {
            backgroundColor: color
        },
        className: (0, $8n1kL.default)([
            "_2rko1qll _1e0c1o8l",
            weight === 'strong' ? "_tzy4clii" : "_tzy4nh7s",
            $a69274533801709c$var$sizeStyles[size]
        ])
    });
});
var $a69274533801709c$export$2e2bcd8739ae039 = $a69274533801709c$var$Skeleton;

});

parcelRegister("biFIz", function(module, exports) {
$parcel$export(module.exports, "default", () => $355066f8c29de268$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $cl2CI = parcelRequire("cl2CI");

var $6JJKW = parcelRequire("6JJKW");
// Color mapping for size 16 standalone icons that will no longer be tiles
const $355066f8c29de268$var$appearanceToIconColorMap = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
function $355066f8c29de268$export$2e2bcd8739ae039({ appearance: appearance, icon: Icon, label: label, size: size, testId: testId, shape: shape, UNSAFE_circleReplacementComponent: UNSAFE_circleReplacementComponent }) {
    if (UNSAFE_circleReplacementComponent && shape === 'circle' && ((0, $e6Qdr.fg)('platform_dst_icon_tile_circle_replacement') || (0, $e6Qdr.fg)('platform_dst_icon_tile_circle_replacement_stage2'))) return UNSAFE_circleReplacementComponent;
    if (shape !== 'circle' && ((0, $e6Qdr.fg)('platform_dst_new_icon_tile') || (0, $e6Qdr.fg)('platform_dst_new_icon_tile_stage2'))) {
        // Handle size 16 - render icon directly without Tile
        if (size === '16') return /*#__PURE__*/ (0, $gWgPx.jsx)(Icon, {
            color: $355066f8c29de268$var$appearanceToIconColorMap[appearance],
            label: label,
            testId: testId
        });
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cl2CI.default), {
            appearance: appearance,
            icon: Icon,
            label: label,
            shape: shape,
            size: size,
            testId: testId
        });
    }
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6JJKW.default), {
        appearance: appearance,
        icon: Icon,
        label: label,
        shape: shape,
        size: size,
        testId: testId
    });
}

});
parcelRegister("cl2CI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f13db73e59a757ea$export$2e2bcd8739ae039);
/* icon-tile-new.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $3gcSj = parcelRequire("3gcSj");
const $f13db73e59a757ea$var$sizeCrossCompatibleMap = {
    // Size mapping from old pixel sizes to new t-shirt sizes
    '16': 'xsmall',
    // Not used
    '24': 'small',
    '32': 'medium',
    '40': 'large',
    '48': 'xlarge',
    xsmall: 'xsmall',
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
// Icon color mapping for Tile-based icons
const $f13db73e59a757ea$var$iconColorMap = {
    blue: "_syaz6txe",
    blueBold: "_syaz1q3r",
    gray: "_syazdgkc",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syaz1q3r",
    lime: "_syaz8645",
    limeBold: "_syaz1q3r",
    magenta: "_syazv8hk",
    magentaBold: "_syaz1q3r",
    orange: "_syaz1j6y",
    orangeBold: "_syaz1q3r",
    purple: "_syazuq3u",
    purpleBold: "_syaz1q3r",
    red: "_syaznbxb",
    redBold: "_syaz1q3r",
    teal: "_syaz8uof",
    tealBold: "_syaz1q3r",
    yellow: "_syaz1oqg",
    yellowBold: "_syaz1q3r"
};
// Background color mapping for Tile component
const $f13db73e59a757ea$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $f13db73e59a757ea$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'small', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3gcSj.default), {
        size: $f13db73e59a757ea$var$sizeCrossCompatibleMap[size],
        backgroundColor: $f13db73e59a757ea$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
            className: (0, $8n1kL.default)([
                $f13db73e59a757ea$var$iconColorMap[appearance]
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: "",
                shouldScale: true
            })
        })
    });
}

});
parcelRegister("3gcSj", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b2fa9f976708f6d$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $5b2fa9f976708f6d$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $5b2fa9f976708f6d$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $5b2fa9f976708f6d$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $5b2fa9f976708f6d$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
};
function $5b2fa9f976708f6d$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $8n1kL.default)([
            $5b2fa9f976708f6d$var$styles.root,
            $5b2fa9f976708f6d$var$sizeMap[size],
            isInset ? $5b2fa9f976708f6d$var$styles.inset : $5b2fa9f976708f6d$var$styles.nonInset,
            isInset && $5b2fa9f976708f6d$var$insetSizeMap[size],
            $5b2fa9f976708f6d$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $5b2fa9f976708f6d$var$styles.border
        ]),
        children: children
    });
}

});


parcelRegister("6JJKW", function(module, exports) {
$parcel$export(module.exports, "default", () => $60353cdf7ff022fb$export$2e2bcd8739ae039);
/* icon-tile-old.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $60353cdf7ff022fb$var$sizeCrossCompatibleMap = {
    // Size mapping from new t-shirt sizes to old pixel sizes
    xsmall: '20',
    small: '24',
    medium: '32',
    large: '40',
    xlarge: '48',
    '16': '16',
    '24': '24',
    '32': '32',
    '40': '40',
    '48': '48'
};
const $60353cdf7ff022fb$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '20': "_1bsbgktf _4t3igktf",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $60353cdf7ff022fb$var$appearanceMap = {
    grayBold: "_bfhk1i45 _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhk16e3 _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkya33 _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhk1qg1 _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk7qp0 _syaz1diz",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhk165s _syaz1j6y",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk1dy8 _syaz6txe",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1nm4 _syazuq3u",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk1773 _syaz1oqg"
};
const $60353cdf7ff022fb$var$shapeMap = {
    square: "_2rko12b0",
    circle: "_2rko1rr0"
};
const $60353cdf7ff022fb$var$iconTileStyles = null;
function $60353cdf7ff022fb$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $60353cdf7ff022fb$var$appearanceMap[appearance],
            $60353cdf7ff022fb$var$sizeMap[$60353cdf7ff022fb$var$sizeCrossCompatibleMap[size]],
            $60353cdf7ff022fb$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});




parcelRegister("jwKos", function(module, exports) {
$parcel$export(module.exports, "getThirdPartyConnectionStatusEndpoint", () => $22d01a26b0daa817$export$b6b331ef111f4609);
$parcel$export(module.exports, "IntegrationProviderMeta", () => $22d01a26b0daa817$export$3b0a1c80b07fd43a);

var $d8MMu = parcelRequire("d8MMu");

var $d2tDX = parcelRequire("d2tDX");
const $22d01a26b0daa817$export$b6b331ef111f4609 = ()=>`/gateway/api/third-party-configuration/connected-data-sources`;
const $22d01a26b0daa817$export$3b0a1c80b07fd43a = {
    sharepoint: {
        name: 'SharePoint',
        icon: (0, $d2tDX.default),
        integrationId: 'ari:cloud:platform::integration/microsoft',
        type: 'sharepoint-connector'
    },
    googleDrive: {
        name: 'Google Drive',
        icon: (0, $d8MMu.default),
        integrationId: 'ari:cloud:platform::integration/google',
        type: 'google-drive-connector'
    }
};

});
parcelRegister("d8MMu", function(module, exports) {
$parcel$export(module.exports, "default", () => $49ad9a462d4436ca$export$2e2bcd8739ae039);
/* google-drive-icon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $49ad9a462d4436ca$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $49ad9a462d4436ca$var$GoogleDriveIconGlyph = ({ ariaLabel: ariaLabel, testId: testId, size: size })=>/*#__PURE__*/ $8P7DW.createElement("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        "aria-label": ariaLabel,
        className: (0, $8n1kL.default)([
            size && $49ad9a462d4436ca$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
        fill: "#3777E3"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
        fill: "#FFCF63"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
        fill: "#11A861"
    }));
/**
 * __GoogleDriveIcon__
 */ const $49ad9a462d4436ca$var$GoogleDriveIcon = ({ label: label, testId: testId })=>/*#__PURE__*/ $8P7DW.createElement($49ad9a462d4436ca$var$GoogleDriveIconGlyph, {
        ariaLabel: label,
        testId: testId
    });
var $49ad9a462d4436ca$export$2e2bcd8739ae039 = $49ad9a462d4436ca$var$GoogleDriveIcon;

});

parcelRegister("d2tDX", function(module, exports) {
$parcel$export(module.exports, "default", () => $950e31f8d17a6f00$export$2e2bcd8739ae039);
/* sharepoint-icon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $950e31f8d17a6f00$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $950e31f8d17a6f00$var$SharePointIconGlyph = ({ ariaLabel: ariaLabel, testId: testId, size: size })=>/*#__PURE__*/ $8P7DW.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        "aria-label": ariaLabel,
        className: (0, $8n1kL.default)([
            size && $950e31f8d17a6f00$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $8P7DW.createElement("g", {
        clipPath: "url(#clip0_271_181641)"
    }, /*#__PURE__*/ $8P7DW.createElement("g", {
        clipPath: "url(#clip1_271_181641)"
    }, /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        opacity: "0.1",
        d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
        fill: "black"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        opacity: "0.2",
        d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        opacity: "0.2",
        d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        opacity: "0.2",
        d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
        fill: "#04868B"
    }), /*#__PURE__*/ $8P7DW.createElement("path", {
        d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
        fill: "white"
    }))), /*#__PURE__*/ $8P7DW.createElement("defs", null, /*#__PURE__*/ $8P7DW.createElement("clipPath", {
        id: "clip0_271_181641"
    }, /*#__PURE__*/ $8P7DW.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    })), /*#__PURE__*/ $8P7DW.createElement("clipPath", {
        id: "clip1_271_181641"
    }, /*#__PURE__*/ $8P7DW.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    }))));
/**
 * __SharePointIcon__
 */ const $950e31f8d17a6f00$var$SharePointIcon = ({ label: label, testId: testId })=>/*#__PURE__*/ $8P7DW.createElement($950e31f8d17a6f00$var$SharePointIconGlyph, {
        ariaLabel: label,
        testId: testId
    });
var $950e31f8d17a6f00$export$2e2bcd8739ae039 = $950e31f8d17a6f00$var$SharePointIcon;

});








parcelRegister("2r6VX", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => (parcelRequire("arQfg")).ArticleResultsLoader);
$parcel$export(module.exports, "SidePanelResultsLoader", () => (parcelRequire("arQfg")).SidePanelResultsLoader);
$parcel$export(module.exports, "NewSearchResultsLoader", () => (parcelRequire("arQfg")).SearchResultsLoader);

var $arQfg = parcelRequire("arQfg");

});
parcelRegister("arQfg", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => $3bd32a0d1f36e797$export$777dd415ac1ad4be);
$parcel$export(module.exports, "SidePanelResultsLoader", () => $3bd32a0d1f36e797$export$9575789db02c1cec);
$parcel$export(module.exports, "SearchResultsLoader", () => $3bd32a0d1f36e797$export$628e0e0af087a588);

var $8P7DW = parcelRequire("8P7DW");

var $4O8fD = parcelRequire("4O8fD");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $ktwNU = parcelRequire("ktwNU");
var $2Mjg8 = parcelRequire("2Mjg8");
var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");
parcelRequire("aaA3R");
var $bT2e1 = parcelRequire("bT2e1");
const $3bd32a0d1f36e797$export$777dd415ac1ad4be = ()=>{
    const articleItemLoader = (0, $8P7DW.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $3bd32a0d1f36e797$var$headingAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const resourceIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $3bd32a0d1f36e797$var$iconAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $3bd32a0d1f36e797$var$loadingIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 24,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const metadataContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: [
                    $3bd32a0d1f36e797$var$subheadingLeftAreaStyles,
                    $3bd32a0d1f36e797$var$subheadingStyles
                ],
                testId: "article-metadata-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $3bd32a0d1f36e797$var$metadataLoadingStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const shortcutIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: [
                    $3bd32a0d1f36e797$var$headerRightAreaStylesVisible
                ],
                testId: "shortcut-icon-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const descriptionContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $3bd32a0d1f36e797$var$bodyAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            role: "listitem",
            xcss: $3bd32a0d1f36e797$var$containerStyles,
            testId: "article-item-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
            columnGap: "space.150",
            templateAreas: [
                'icon heading header-right',
                'icon subheading-left header-right',
                '. body body'
            ],
            templateColumns: "auto 1fr auto"
        }, resourceIconContainer(), linkContainer(), metadataContainer(), shortcutIconContainer(), descriptionContainer())));
    }, []);
    const articlesListLoader = (0, $8P7DW.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            role: "list",
            xcss: $3bd32a0d1f36e797$var$containerStyles,
            testId: "articles-list-loader"
        }, articleItemLoader, articleItemLoader, articleItemLoader, articleItemLoader);
    }, [
        articleItemLoader
    ]);
    const sectionHeadingLoader = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, sectionHeadingLoader(), articlesListLoader, articlesListLoader);
};
const $3bd32a0d1f36e797$export$9575789db02c1cec = ()=>{
    const resourceIconContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $3bd32a0d1f36e797$var$iconAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $3bd32a0d1f36e797$var$sidePanelIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            height: 24,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    const descriptionContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $3bd32a0d1f36e797$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $3bd32a0d1f36e797$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))));
    };
    const sidePaneItemLoader = (0, $8P7DW.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                xcss: $3bd32a0d1f36e797$var$sidePaneLinkContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
                xcss: $3bd32a0d1f36e797$var$sidePaneLinkStyles,
                space: "space.100"
            }, resourceIconContainer(), descriptionContainer()));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $3bd32a0d1f36e797$var$sidePanelItemStyles
        }, linkContainer());
    }, []);
    const sidePanelLoader = (0, $8P7DW.useMemo)(()=>{
        const resultTitle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $3bd32a0d1f36e797$var$sidePanelStyles
        }, resultTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bT2e1.ResultList), {
            role: "list"
        }, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader));
    }, [
        sidePaneItemLoader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        testId: "side-panel-results-loader",
        xcss: $3bd32a0d1f36e797$var$sidePanelContainerStyles
    }, sidePanelLoader);
};
const $3bd32a0d1f36e797$export$628e0e0af087a588 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $3bd32a0d1f36e797$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3bd32a0d1f36e797$export$777dd415ac1ad4be, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3bd32a0d1f36e797$export$9575789db02c1cec, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3bd32a0d1f36e797$export$9575789db02c1cec, null)));
};
const $3bd32a0d1f36e797$var$containerStyles = (0, $37U6z.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $3bd32a0d1f36e797$var$iconAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'icon',
    width: 'size.200',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right'
});
const $3bd32a0d1f36e797$var$headingAreaStyles = (0, $37U6z.xcss)({
    width: '200px',
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-large, normal)"
});
const $3bd32a0d1f36e797$var$subheadingStyles = (0, $37U6z.xcss)({
    width: '350px',
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $3bd32a0d1f36e797$var$subheadingLeftAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $3bd32a0d1f36e797$var$headerRightAreaStylesVisible = (0, $37U6z.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $3bd32a0d1f36e797$var$responsiveStyles = (0, $37U6z.xcss)({
    [(0, $2Mjg8.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        width: '100%'
    },
    [(0, $2Mjg8.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});
const $3bd32a0d1f36e797$var$bodyAreaStyles = (0, $37U6z.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $3bd32a0d1f36e797$var$loadingIconStyles = (0, $37U6z.xcss)({
    width: '100%'
});
const $3bd32a0d1f36e797$var$metadataLoadingStyles = (0, $37U6z.xcss)({
    width: '100%'
});
const $3bd32a0d1f36e797$var$sidePanelIconStyles = (0, $37U6z.xcss)({
    width: 'size.200'
});
const $3bd32a0d1f36e797$var$sidePanelDescriptionStyles = (0, $37U6z.xcss)({
    width: '100%'
});
const $3bd32a0d1f36e797$var$sidePaneLinkContainerStyles = (0, $37U6z.xcss)({
    width: '100%',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $3bd32a0d1f36e797$var$sidePaneLinkStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $3bd32a0d1f36e797$var$sidePanelItemStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $3bd32a0d1f36e797$var$sidePanelContainerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    minWidth: '320px',
    width: '100%',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100'
});
const $3bd32a0d1f36e797$var$sidePanelStyles = (0, $37U6z.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});

});


parcelRegister("dkMB5", function(module, exports) {
$parcel$export(module.exports, "Portals", () => (parcelRequire("61YNb")).default);

var $61YNb = parcelRequire("61YNb");

});
parcelRegister("61YNb", function(module, exports) {
$parcel$export(module.exports, "default", () => $35e559b958539674$export$2e2bcd8739ae039);

var $dKHkJ = parcelRequire("dKHkJ");

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $2Mjg8 = parcelRequire("2Mjg8");
var $37U6z = parcelRequire("37U6z");

var $dfS0m = parcelRequire("dfS0m");
parcelRequire("aaA3R");
var $kywYl = parcelRequire("kywYl");
var $bT2e1 = parcelRequire("bT2e1");
var $tJpW6 = parcelRequire("tJpW6");

var $fUHLQ = parcelRequire("fUHLQ");
parcelRequire("bp7rS");
var $6EVlE = parcelRequire("6EVlE");

var $jDfX6 = parcelRequire("jDfX6");
const $35e559b958539674$export$7083bd6220bb1bc7 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const cloudId = (0, $jByYr.getCloudId)();
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $dKHkJ.default), {
        cloudId: cloudId,
        queryTerm: term,
        helpCenterAri: (0, $HGACo.isProjectMappingInHelpCenterEnabled)() ? (0, $jByYr.getHelpCenterAri)() : undefined,
        limit: (0, $kywYl.PORTALS_RESULT_LIMIT)
    });
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const portals = ((_data$helpObjectStore = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStorePortalSearchResults' ? data.helpObjectStore_searchPortals.results : [];
    const showSection = portals.length > 0;
    (0, $8P7DW.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStorePortalSearchResults') {
            const externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchPortals.results.forEach((portal)=>{
                if (portal.metadata.searchStrategy === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
            });
            (0, $tJpW6.sendSearchOperationalAnalyticEvents)({
                action: 'portalSearchSucceeded',
                resourceCount: data.helpObjectStore_searchPortals.results.length
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $tJpW6.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'portal',
                resourceCount: data.helpObjectStore_searchPortals.results.length
            }, createAnalyticsEvent, portalId);
        }
    }, [
        term,
        showSection,
        data,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $8P7DW.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchPortals;
            const statusCode = extensions.length > 0 ? extensions[0].statusCode : undefined;
            const is4XXFailure = statusCode && statusCode >= 400 && statusCode < 500 ? true : false;
            (0, $tJpW6.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                is4XXFailure: is4XXFailure,
                statusCode: statusCode,
                action: 'portalSearchFailed',
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $8P7DW.useEffect)(()=>{
        updateResultsCount(portals.length, 1);
    }, [
        term,
        portals.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $35e559b958539674$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $35e559b958539674$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "xxsmall",
        as: (0, $1EFS8.default).checkGate('ff_a11y_hc_heading') ? 'h2' : undefined
    }, formatMessage((0, $jDfX6.default).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bT2e1.ResultList), {
        role: "list"
    }, portals.map((resource, index)=>{
        const itemOrder = index + 1;
        const key = resource.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("li", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6EVlE.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $fUHLQ.searchExperience)
    }));
};
const $35e559b958539674$var$containerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $2Mjg8.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $2Mjg8.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $35e559b958539674$var$headingStyles = (0, $37U6z.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $35e559b958539674$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($35e559b958539674$export$7083bd6220bb1bc7);

});
parcelRegister("dKHkJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad5b56825bfa3b14$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6b497a8ef05445b05df590e950283c5>>
 * @relayHash b4c5cb2add64b92e5fa0a81f307c32d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9f8850f70c76ffcbcce7f2698b51dd8a8d50e7e457be551f94df33714abf2a1
const $ad5b56825bfa3b14$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "concreteType": "HelpObjectStorePortalMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "portalsSearchQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStorePortalSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "portalItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStorePortalSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "portalsSearchQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStorePortalSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStorePortalSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9f8850f70c76ffcbcce7f2698b51dd8a8d50e7e457be551f94df33714abf2a1",
            "metadata": {},
            "name": "portalsSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ad5b56825bfa3b14$var$node.hash = "5fbada5df4e3a5676426867e2805de0f";
var $ad5b56825bfa3b14$export$2e2bcd8739ae039 = $ad5b56825bfa3b14$var$node;

});

parcelRegister("bp7rS", function(module, exports) {
$parcel$export(module.exports, "PortalItem", () => (parcelRequire("6EVlE")).default);

var $6EVlE = parcelRequire("6EVlE");

});
parcelRegister("6EVlE", function(module, exports) {
$parcel$export(module.exports, "default", () => $0df63a2d10bbf644$export$2e2bcd8739ae039);

var $7wYBw = parcelRequire("7wYBw");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $cS6Xr = parcelRequire("cS6Xr");

var $dMqdi = parcelRequire("dMqdi");

var $HGACo = parcelRequire("HGACo");

var $f73iJ = parcelRequire("f73iJ");

var $loEqA = parcelRequire("loEqA");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $6GVst = parcelRequire("6GVst");
parcelRequire("aaA3R");
var $tJpW6 = parcelRequire("tJpW6");
parcelRequire("3VgFF");
var $499Sb = parcelRequire("499Sb");
const $0df63a2d10bbf644$export$dd92e87a60cfa662 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const data = (0, $h3cOB.useFragment)((0, $7wYBw.default), result);
    const { title: title, displayLink: displayLink, id: id, metadata: metadata } = data;
    const { searchStrategy: searchStrategy } = metadata;
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const { setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $tJpW6.useVisibilityState)();
    const highlightedTitle = title ? (0, $tJpW6.formatText)(title, term) : '';
    const linkProps = (0, $6GVst.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: false
    });
    (0, $8P7DW.useEffect)(()=>{
        (0, $tJpW6.sendSearchUIAnalyticEvents)({
            id: id,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'portal'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        id,
        portalId,
        searchStrategy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $0df63a2d10bbf644$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        xcss: [
            $0df63a2d10bbf644$var$headingStyles,
            (0, $1EFS8.default).checkGate('ff_a11y_hc_focus_indicator') && $0df63a2d10bbf644$var$headingAlignmentStyles
        ],
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $499Sb.default), {
        entityType: "PORTAL",
        displayLink: displayLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cS6Xr.Link), {
        key: id,
        actionSubjectId: 'portal-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            id: id,
            itemOrder: itemOrder,
            searchAlgorithm: searchStrategy,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(highlightedTitle) : (0, $f73iJ.sanitize)(highlightedTitle)
        }
    })))));
};
const $0df63a2d10bbf644$var$ConnectedPortalItem = (0, $jvoWT.default)((state)=>{
    return {
        themeColor: (0, $dMqdi.getThemeColor)(state)
    };
})($0df63a2d10bbf644$export$dd92e87a60cfa662);
var $0df63a2d10bbf644$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($0df63a2d10bbf644$var$ConnectedPortalItem);
const $0df63a2d10bbf644$var$containerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $0df63a2d10bbf644$var$headingStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $0df63a2d10bbf644$var$headingAlignmentStyles = (0, $37U6z.xcss)({
    alignItems: 'center'
});

});
parcelRegister("7wYBw", function(module, exports) {
$parcel$export(module.exports, "default", () => $8597bc55d540e4f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<401e38e258ab2a07d01ca48a65a435ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8597bc55d540e4f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "concreteType": "HelpObjectStorePortalMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        }
    ],
    "type": "HelpObjectStorePortalSearchResult"
};
$8597bc55d540e4f0$var$node.hash = "e844983974d9732ca3ef706885375f3f";
var $8597bc55d540e4f0$export$2e2bcd8739ae039 = $8597bc55d540e4f0$var$node;

});



parcelRegister("jDfX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $98ee4a43df50d5df$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $98ee4a43df50d5df$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    portals: {
        defaultMessage: 'Portals',
        description: 'Text for section resource type in search results',
        id: 'cv.search.portals.portals'
    }
});

});



parcelRegister("jlR0o", function(module, exports) {
$parcel$export(module.exports, "RequestForms", () => (parcelRequire("cJNey")).default);

var $cJNey = parcelRequire("cJNey");

});
parcelRegister("cJNey", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1d545955deebb43$export$2e2bcd8739ae039);

var $fvlkf = parcelRequire("fvlkf");

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $2Mjg8 = parcelRequire("2Mjg8");
var $37U6z = parcelRequire("37U6z");

var $dfS0m = parcelRequire("dfS0m");
parcelRequire("aaA3R");
var $kywYl = parcelRequire("kywYl");
var $bT2e1 = parcelRequire("bT2e1");
var $tJpW6 = parcelRequire("tJpW6");

var $fUHLQ = parcelRequire("fUHLQ");
parcelRequire("OohdS");
var $cNe48 = parcelRequire("cNe48");

var $8dDHG = parcelRequire("8dDHG");
const $f1d545955deebb43$export$d7562fc7136a7ea2 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const cloudId = (0, $jByYr.getCloudId)();
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $fvlkf.default), {
        cloudId: cloudId,
        portalId: portalId,
        queryTerm: term,
        helpCenterAri: (0, $HGACo.isProjectMappingInHelpCenterEnabled)() ? (0, $jByYr.getHelpCenterAri)() : undefined,
        limit: (0, $1EFS8.default).checkGate('jsm_request_type_limit_update_spike') ? (0, $kywYl.REQUEST_FORMS_NEW_LIMIT) : (0, $kywYl.REQUEST_FORMS_RESULT_LIMIT)
    });
    const requestForms = ((_data$helpObjectStore = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStoreRequestTypeSearchResults' ? data.helpObjectStore_searchRequestTypes.results : [];
    const showSection = requestForms.length > 0;
    (0, $8P7DW.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStoreRequestTypeSearchResults') {
            let externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchRequestTypes.results.forEach((requestForm)=>{
                const { metadata: metadata } = requestForm;
                const { isExternal: isExternal, searchStrategy: searchStrategy } = metadata;
                if (isExternal) externalResourcesCount += 1;
                if (searchStrategy === 'SEARCH_PLATFORM_KEYWORD_BASED') firstPartySearchPlatformResourcesCount += 1;
            });
            (0, $tJpW6.sendSearchOperationalAnalyticEvents)({
                action: 'requestTypeSearchSucceeded',
                resourceCount: data.helpObjectStore_searchRequestTypes.results.length
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $tJpW6.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'request-form',
                resourceCount: data.helpObjectStore_searchRequestTypes.results.length
            }, createAnalyticsEvent, portalId);
        }
    }, [
        term,
        showSection,
        data,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $8P7DW.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchRequestTypes;
            const statusCode = extensions.length > 0 ? extensions[0].statusCode : undefined;
            const is4XXFailure = statusCode && statusCode >= 400 && statusCode < 500 ? true : false;
            (0, $tJpW6.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                statusCode: statusCode,
                is4XXFailure: is4XXFailure,
                action: 'requestTypeSearchFailed',
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $8P7DW.useEffect)(()=>{
        updateResultsCount(requestForms.length, 1);
    }, [
        term,
        requestForms.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $f1d545955deebb43$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $f1d545955deebb43$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "xxsmall",
        as: (0, $1EFS8.default).checkGate('ff_a11y_hc_heading') ? 'h2' : undefined
    }, formatMessage((0, $8dDHG.default).requestForms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bT2e1.ResultList), {
        role: "list"
    }, requestForms.map((resource, index)=>{
        const itemOrder = index + 1;
        const key = resource.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("li", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cNe48.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $fUHLQ.searchExperience)
    }));
};
const $f1d545955deebb43$var$containerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $2Mjg8.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $2Mjg8.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $f1d545955deebb43$var$headingStyles = (0, $37U6z.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $f1d545955deebb43$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($f1d545955deebb43$export$d7562fc7136a7ea2);

});
parcelRegister("fvlkf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b51ee45eeb7b17f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a9c2efbdbf9053859b5350d1c69e40b>>
 * @relayHash 4db5964fda1ef7ad6bb403c6a9420d56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9
const $b51ee45eeb7b17f7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "portalId",
            "variableName": "portalId"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpObjectStoreRequestTypeMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "requestFormsSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "requestFormItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreRequestTypeSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "requestFormsSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreRequestTypeSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9",
            "metadata": {},
            "name": "requestFormsSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b51ee45eeb7b17f7$var$node.hash = "6a4749a62d9236563bcbeca7d18c02eb";
var $b51ee45eeb7b17f7$export$2e2bcd8739ae039 = $b51ee45eeb7b17f7$var$node;

});

parcelRegister("OohdS", function(module, exports) {
$parcel$export(module.exports, "RequestFormItem", () => (parcelRequire("cNe48")).default);

var $cNe48 = parcelRequire("cNe48");

});
parcelRegister("cNe48", function(module, exports) {
$parcel$export(module.exports, "default", () => $402a8b1e03a1eae9$export$2e2bcd8739ae039);

var $g8T0i = parcelRequire("g8T0i");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $cS6Xr = parcelRequire("cS6Xr");

var $dMqdi = parcelRequire("dMqdi");

var $HGACo = parcelRequire("HGACo");

var $f73iJ = parcelRequire("f73iJ");

var $loEqA = parcelRequire("loEqA");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $c1US4 = parcelRequire("c1US4");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $6GVst = parcelRequire("6GVst");

var $kignK = parcelRequire("kignK");
parcelRequire("aaA3R");
var $tJpW6 = parcelRequire("tJpW6");
parcelRequire("3VgFF");
var $499Sb = parcelRequire("499Sb");
const $402a8b1e03a1eae9$export$c5555d4e61cdd47a = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $g8T0i.default), result);
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $tJpW6.useVisibilityState)();
    const { title: title, displayLink: displayLink, id: id, metadata: metadata } = data;
    const { isExternal: isExternal, searchStrategy: searchStrategy } = metadata;
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1US4))), {
        label: formatMessage((0, $kignK.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $tJpW6.formatText)(title, term) : '';
    const linkProps = (0, $6GVst.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: isExternal
    });
    (0, $8P7DW.useEffect)(()=>{
        (0, $tJpW6.sendSearchUIAnalyticEvents)({
            id: id,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'request-form'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        id,
        portalId,
        searchStrategy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $402a8b1e03a1eae9$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        xcss: [
            $402a8b1e03a1eae9$var$headingStyles,
            (0, $1EFS8.default).checkGate('ff_a11y_hc_focus_indicator') && $402a8b1e03a1eae9$var$headingAlignmentStyles
        ],
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $499Sb.default), {
        entityType: "REQUEST_FORM",
        displayLink: displayLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cS6Xr.Link), {
        key: id,
        actionSubjectId: isExternal ? 'external-request-form-link' : 'request-form-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            id: id,
            itemOrder: itemOrder,
            searchAlgorithm: searchStrategy,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(highlightedTitle) : (0, $f73iJ.sanitize)(highlightedTitle)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: isShortcutIconVisible ? $402a8b1e03a1eae9$var$headerRightAreaStylesVisible : $402a8b1e03a1eae9$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon)));
};
const $402a8b1e03a1eae9$var$ConnectedRequestFormItem = (0, $jvoWT.default)((state)=>{
    return {
        themeColor: (0, $dMqdi.getThemeColor)(state)
    };
})($402a8b1e03a1eae9$export$c5555d4e61cdd47a);
var $402a8b1e03a1eae9$export$2e2bcd8739ae039 = (0, $k7ZVu.default)()($402a8b1e03a1eae9$var$ConnectedRequestFormItem);
const $402a8b1e03a1eae9$var$containerStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $402a8b1e03a1eae9$var$headingStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $402a8b1e03a1eae9$var$headingAlignmentStyles = (0, $37U6z.xcss)({
    alignItems: 'center'
});
const $402a8b1e03a1eae9$var$headerRightAreaStylesInVisible = (0, $37U6z.xcss)({
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $402a8b1e03a1eae9$var$headerRightAreaStylesVisible = (0, $37U6z.xcss)({
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start'
});

});
parcelRegister("g8T0i", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab017f53d2bdd192$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32278cf5dc0e7086ec41d31040a6e7d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab017f53d2bdd192$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "requestFormItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "concreteType": "HelpObjectStoreRequestTypeMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isExternal"
                },
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        }
    ],
    "type": "HelpObjectStoreRequestTypeSearchResult"
};
$ab017f53d2bdd192$var$node.hash = "3676027039798345dde34e2948999172";
var $ab017f53d2bdd192$export$2e2bcd8739ae039 = $ab017f53d2bdd192$var$node;

});



parcelRegister("8dDHG", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ed9e40d060a3a43$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $8ed9e40d060a3a43$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    requestForms: {
        defaultMessage: 'Request forms',
        description: 'Text for section resource type in search results',
        id: 'cv.search.request-forms.request-forms'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Text for portal name in description',
        id: 'cv.search.request-forms.portal'
    }
});

});





parcelRegister("cel5H", function(module, exports) {
$parcel$export(module.exports, "default", () => $d26c7b03c881cf02$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("9ueTd");
var $99eJc = parcelRequire("99eJc");
parcelRequire("9FfOm");
var $2CIj9 = parcelRequire("2CIj9");

var $5wstg = parcelRequire("5wstg");
const $d26c7b03c881cf02$var$selector = (0, $ehscL.createSelector)((0, $2CIj9.getAllVisiblePortals), (0, $2CIj9.getfeaturedAndSortedPortalsError), (portals, featuredAndSortedPortalsError)=>({
        featuredAndSortedPortalsError: featuredAndSortedPortalsError,
        portals: portals
    }));
var $d26c7b03c881cf02$export$2e2bcd8739ae039 = (0, $jvoWT.default)($d26c7b03c881cf02$var$selector, {
    fetchPortals: (0, $99eJc.fetchFeaturedAndSortedPortalsModel)
})((0, $5wstg.default));

});
parcelRegister("5wstg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7aee1323b909c42$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("8DNDe");
var $gOsrD = parcelRequire("gOsrD");

var $j9dmN = parcelRequire("j9dmN");
const $a7aee1323b909c42$var$ServiceDeskFilter = ({ portals: portals, portalIds: portalIds, fetchPortals: fetchPortals, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [values, _] = $8P7DW.useState(portalIds ?? []);
    $8P7DW.useEffect(()=>{
        fetchPortals({
            exploreAll: true,
            sortBy: 'POPULARITY'
        }, false);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const options = $8P7DW.useMemo(()=>{
        return portals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals
    ]);
    const preSelectedOptions = $8P7DW.useMemo(()=>{
        const preselectedPortals = portals.filter((portal)=>values.find((id)=>id === portal.id.toString()));
        return preselectedPortals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals,
        values
    ]);
    return portals.length > 1 ? /*#__PURE__*/ $8P7DW.createElement((0, $gOsrD.default), {
        fieldId: "servicedesk_filter",
        fieldLabel: formatMessage((0, $j9dmN.default).portal),
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange,
        testId: "serviceDeskFilter"
    }) : null;
};
var $a7aee1323b909c42$export$2e2bcd8739ae039 = $a7aee1323b909c42$var$ServiceDeskFilter;

});
parcelRegister("j9dmN", function(module, exports) {
$parcel$export(module.exports, "default", () => $01b16df1e78743ea$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $01b16df1e78743ea$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    serviceDeskFilter: {
        defaultMessage: 'Service desk',
        description: 'Title of the service desk picker',
        id: 'sd.all.articles.result.servicedesk.filter.name'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Title of the portal picker',
        id: 'cv.search.servicedesk-filter.portal'
    }
});

});





parcelRegister("8J2ga", function(module, exports) {
$parcel$export(module.exports, "SearchTextboxV2", () => (parcelRequire("1O3IA")).default);

var $1O3IA = parcelRequire("1O3IA");

});
parcelRegister("1O3IA", function(module, exports) {
$parcel$export(module.exports, "default", () => $47c3003d0a8a426d$export$2e2bcd8739ae039);
/* search-textbox-v2.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $cSPKC = parcelRequire("cSPKC");

var $1We2B = parcelRequire("1We2B");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
var $i9cdb = parcelRequire("i9cdb");
parcelRequire("9E7e6");
var $2Ixwx = parcelRequire("2Ixwx");

var $8E60W = parcelRequire("8E60W");

var $kvQ5d = parcelRequire("kvQ5d");

var $aw7IH = parcelRequire("aw7IH");
parcelRequire("6gxqq");
var $eIvjU = parcelRequire("eIvjU");

var $MmGmU = parcelRequire("MmGmU");
var $eS4yu = parcelRequire("eS4yu");

var $1EFS8 = parcelRequire("1EFS8");

var $kDg5W = parcelRequire("kDg5W");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $37U6z = parcelRequire("37U6z");

var $iD9mC = parcelRequire("iD9mC");

var $iziiq = parcelRequire("iziiq");

var $300Z2 = parcelRequire("300Z2");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $klz3F = parcelRequire("klz3F");

var $cxNwq = parcelRequire("cxNwq");

var $1RqZd = parcelRequire("1RqZd");

var $5Tbbx = parcelRequire("5Tbbx");

var $fMfsf = parcelRequire("fMfsf");

var $aGBfH = parcelRequire("aGBfH");

var $hpFT3 = parcelRequire("hpFT3");

var $7QDmV = parcelRequire("7QDmV");

var $8952j = parcelRequire("8952j");

var $4zFmR = parcelRequire("4zFmR");

var $gbUep = parcelRequire("gbUep");

var $kZVLE = parcelRequire("kZVLE");

var $iLwZc = parcelRequire("iLwZc");
parcelRequire("aaA3R");
var $tJpW6 = parcelRequire("tJpW6");
parcelRequire("jBWQO");
var $hR556 = parcelRequire("hR556");

var $k9pD5 = parcelRequire("k9pD5");

var $ehIuP = parcelRequire("ehIuP");
const $47c3003d0a8a426d$var$usePopularPortalsWithVA = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const [popularPortalsWithVA, setPopularPortalsWithVA] = (0, $8P7DW.useState)([]);
    const [isFetching, setIsFetching] = (0, $8P7DW.useState)(false);
    const cloudId = (0, $8P7DW.useMemo)(()=>(0, $jByYr.getCloudId)(), []);
    const fetchData = (0, $8P7DW.useCallback)(async ()=>{
        setIsFetching(true);
        try {
            const { mostPopularVAsPortalData: mostPopularVAsPortalData } = await (0, $klz3F.fetchJson)(`/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v1/virtualagent/mostPopularVAs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    helpCenterId: (0, $jByYr.getHelpCenterAri)()
                })
            });
            setPopularPortalsWithVA(mostPopularVAsPortalData);
        } catch (error) {
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.UI_EVENT_TYPE),
                action: 'failed',
                actionSubjectId: 'fetchPopularPortalsWithVA'
            }).fire();
        } finally{
            setIsFetching(false);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        setIsFetching,
        setPopularPortalsWithVA
    ]);
    return {
        isFetching: isFetching,
        popularPortalsWithVA: popularPortalsWithVA,
        fetchData: fetchData
    };
};
// Extracted component to reduce duplication
const $47c3003d0a8a426d$var$SearchHintWithEnterIcon = ({ message: message, enterAltText: enterAltText, isVisible: isVisible })=>{
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $47c3003d0a8a426d$var$askAiHintStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        space: "space.100",
        alignBlock: "center"
    }, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cSPKC))),
        alt: (0, $1EFS8.default).checkGate('ff_a11y_hc_alt_text') ? '' : enterAltText
    })));
};
const $47c3003d0a8a426d$var$SearchPopupContentWithRef = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function SearchPopupContent(searchPopupContentProps, ref) {
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { setSearchBoxWidth: setSearchBoxWidth, searchBarRef: searchBarRef, isChoiceOpen: isChoiceOpen, isVirtualAgentEnabled: isVirtualAgentEnabled, openChoicesIfPresent: openChoicesIfPresent, handleKeyDown: handleKeyDown, handleInputChange: handleInputChange, inputValue: inputValue, disableSearch: disableSearch, isFetchingResults: isFetchingResults, visibleResultsCount: visibleResultsCount, ...triggerProps } = searchPopupContentProps;
    const isShapeThemeDefaultEnabled = (0, $1EFS8.default).checkGate('platform-dst-shape-theme-default');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        ...triggerProps,
        ref: ref,
        xcss: $47c3003d0a8a426d$var$searchBoxWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iD9mC.WidthObserver), {
        setWidth: setSearchBoxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: [
            $47c3003d0a8a426d$var$searchBoxStyles,
            isShapeThemeDefaultEnabled && $47c3003d0a8a426d$var$searchBoxShapeThemeStyles
        ],
        style: {
            // We need to manually use different token fallbacks here because the contrast isn't good enough with the default ones, while Portal is not yet using tokens. xcss doesn't allow specifying a token(...) as a value hence needing to use style prop
            // These should be removed once Portal has finished migrating to using tokens
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            borderColor: "var(--ds-border-input, #dee0e4)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            backgroundColor: "var(--ds-background-input, white)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($47c3003d0a8a426d$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kDg5W))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #6B778C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($47c3003d0a8a426d$var$Input, {
        "data-testid": "search-textbox-v2",
        type: "text",
        autoComplete: "off",
        innerRef: searchBarRef,
        autoFocus: isChoiceOpen,
        spellCheck: false,
        isAiAnswersEnabled: isVirtualAgentEnabled,
        "aria-label": isVirtualAgentEnabled ? formatMessage((0, $ehIuP.default).inputAriaLabel) : formatMessage((0, $ehIuP.default).inputAriaLabelNoAI),
        placeholder: isVirtualAgentEnabled ? formatMessage((0, $ehIuP.default).inputPlaceholder) : formatMessage((0, $ehIuP.default).inputPlaceholderNoAI),
        onClick: ()=>openChoicesIfPresent(),
        onFocus: (event)=>{
            // When coming from another focus element (meaning tabbing forwards or backwards)
            // We can't always open choices because that would trigger if you're in the popup menu and press 'Escape'
            // This focuses the text input so by re-opening the menu we'd be causing another A11Y issue
            if (event.relatedTarget != null) openChoicesIfPresent();
        },
        onChange: handleInputChange,
        onKeyDown: handleKeyDown,
        value: inputValue,
        disabled: disableSearch,
        // eslint-disable-next-line @atlassian/a11y/aria-props -- ATLAS-88210
        "aria-description": formatMessage((0, $ehIuP.default).ariaDescription)
    }), (0, $tJpW6.isValidSearchTerm)(inputValue) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($47c3003d0a8a426d$var$SearchHintWithEnterIcon, {
        message: isVirtualAgentEnabled ? formatMessage((0, $ehIuP.default).askTheVirtualServiceAgent) : formatMessage((0, $ehIuP.default).search),
        enterAltText: formatMessage((0, $ehIuP.default).enter),
        isVisible: isVirtualAgentEnabled || isFetchingResults || visibleResultsCount !== 0
    }))));
});
const $47c3003d0a8a426d$var$SearchTextboxV2 = ({ term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, disableSearch: disableSearch })=>{
    const searchBarRef = (0, $8P7DW.useRef)(null);
    const [isChoiceOpen, setIsChoiceOpen] = (0, $8P7DW.useState)(false);
    const [inputValue, setInputValue] = (0, $8P7DW.useState)(term);
    const [searchBoxWidth, setSearchBoxWidth] = (0, $8P7DW.useState)();
    const [{ location: location }, { push: push }] = (0, $i9cdb.useRouter)();
    const { startNewConversation: startNewConversation } = (0, $8E60W.useConversationActions)();
    const { sendMessage: sendMessage } = (0, $2Ixwx.useSendMessage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { resultsCount: resultsCount } = (0, $hR556.useInlineResultsContext)();
    const environment = (0, $h3cOB.useRelayEnvironment)();
    const { popularPortalsWithVA: popularPortalsWithVA, fetchData: fetchPopularPortalsWithVA, isFetching: isFetchingPopularPortalsWithVA } = $47c3003d0a8a426d$var$usePopularPortalsWithVA();
    const { setSubscriptionDisposer: setSubscriptionDisposer } = (0, $gbUep.useSubscriptionAction)();
    (0, $8P7DW.useEffect)(()=>{
        if (isVSAOnHCEnabled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchPopularPortalsWithVA();
    }, [
        isVSAOnHCEnabled,
        fetchPopularPortalsWithVA
    ]);
    const { createConversationWithMessage: createConversationWithMessage } = (0, $fMfsf.useCreateConversationWithMessage)();
    const openChoicesIfPresent = (0, $8P7DW.useCallback)(()=>{
        setIsChoiceOpen(isVSAOnHCEnabled || (0, $tJpW6.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen,
        isVSAOnHCEnabled
    ]);
    const handleInputChange = (0, $8P7DW.useCallback)((event)=>{
        const newQuery = event.target.value;
        setInputValue(newQuery);
        setIsChoiceOpen((0, $tJpW6.isValidSearchTerm)(newQuery));
    }, [
        setInputValue,
        setIsChoiceOpen
    ]);
    const onSeeSearchResults = (0, $8P7DW.useCallback)(()=>{
        if (!(0, $tJpW6.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $iziiq.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'allResults',
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }).fire();
        push(`${location.pathname}?q=${inputValue.trim()}`);
    }, [
        inputValue,
        createAnalyticsEvent,
        push,
        location.pathname
    ]);
    const onAskAtlassianIntelligence = (0, $8P7DW.useCallback)(async ()=>{
        if (!(0, $tJpW6.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $iziiq.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'askAtlassianIntelligence',
            ...(0, $kvQ5d.getProductIdentifierAttributes)((0, $300Z2.ExperienceType).UNIFIED_HELP)
        }).fire();
        if ((0, $HGACo.isOmnichannelEnabledForHC)()) {
            if ((0, $HGACo.isOmnichannelCombinedAPIEnabledForHC)()) {
                const subscriptionId = await (0, $4zFmR.generateUniqueSubscriptionID)({
                    environment: environment
                });
                const omniChannelMetaData = await (0, $hpFT3.fetchOmnichannelMeta)(environment);
                await (0, $aGBfH.updateOmniChannelConversationMetaPromise)({
                    environment: environment,
                    subscriptionId: subscriptionId,
                    draftMessage: !omniChannelMetaData.connectionId ? inputValue.trim() : undefined,
                    isConversationClosed: false,
                    isConversationExpired: false,
                    disableInput: false,
                    isReplyPending: false,
                    subscriptionTriggered: true,
                    subscriptionStatus: 'TRIGGERED'
                });
                const disposable = (0, $7QDmV.establishSubscriptionToOmnichannel)({
                    environment: environment,
                    subscriptionId: subscriptionId
                });
                setSubscriptionDisposer(disposable);
                if (omniChannelMetaData.connectionId) createConversationWithMessage({
                    subscriptionId: subscriptionId,
                    workspaceAri: (0, $jByYr.getWorkspaceAri)(),
                    conversationContextAri: (0, $jByYr.getHelpCenterAri)(),
                    isTestConversation: false,
                    message: inputValue.trim(),
                    connectionId: omniChannelMetaData.connectionId
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $5Tbbx.initialIntentMessageHCExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $8952j.omnichannelPageLoadExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $5Tbbx.initialAIMessageHCExperience).start();
            } else await (0, $aGBfH.updateOmniChannelConversationMetaPromise)({
                environment: environment,
                draftMessage: inputValue.trim()
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            push('/conversation');
            return;
        }
        if (isVSAOnHCEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $1RqZd.initialIntentMessageExperience).start();
            sendMessage(inputValue.trim());
        } else {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $iLwZc.initialAIAnswerExperience).start();
            startNewConversation(inputValue.trim());
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        inputValue,
        createAnalyticsEvent,
        isVSAOnHCEnabled,
        push,
        environment,
        setSubscriptionDisposer,
        createConversationWithMessage,
        sendMessage,
        startNewConversation
    ]);
    const visibleResultsCount = ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm) || 0);
    const isFetchingResults = !((0, $1We2B.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) && (0, $1We2B.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) && (0, $1We2B.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm));
    const handleKeyDown = (0, $8P7DW.useCallback)((event)=>{
        const canShowSearchResults = isFetchingResults || visibleResultsCount > 0;
        if ((0, $1EFS8.default).checkGate('jsm_hc_search_composing_fix') && event.nativeEvent.isComposing) return;
        if (event.key === 'Enter') {
            if (!!isVSAOnHCEnabled) {
                if ((event.metaKey || !(0, $eIvjU.isMacOs)() && event.ctrlKey) && canShowSearchResults) onSeeSearchResults();
                else // eslint-disable-next-line @typescript-eslint/no-floating-promises
                onAskAtlassianIntelligence();
            } else if (canShowSearchResults) // If the search results are still fetched, resultsCount will be null
            onSeeSearchResults();
        }
    }, [
        visibleResultsCount,
        isFetchingResults,
        isVSAOnHCEnabled,
        onAskAtlassianIntelligence,
        onSeeSearchResults
    ]);
    (0, $8P7DW.useEffect)(()=>{
        setIsChoiceOpen((0, $tJpW6.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen
    ]);
    const [requestIdParam] = (0, $iyRi5.usePathParam)('requestId');
    (0, $8P7DW.useEffect)(()=>{
        var _searchBarRef$current;
        if ((0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && requestIdParam) return;
        (_searchBarRef$current = searchBarRef.current) === null || _searchBarRef$current === void 0 || _searchBarRef$current.focus();
    }, [
        requestIdParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, isVSAOnHCEnabled && (0, $HGACo.isOmnichannelEnabledForHC)() && (0, $HGACo.isOmnichannelCombinedAPIEnabledForHC)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kZVLE.OmnichannelClientConnection), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $k9pD5.SearchPromptPopup), {
        isOpen: isChoiceOpen,
        isFetchingPopularPortalsWithVA: isFetchingPopularPortalsWithVA,
        popularPortalsWithVA: popularPortalsWithVA,
        onClose: ()=>setIsChoiceOpen(false),
        searchBoxWidth: searchBoxWidth,
        searchQuery: inputValue,
        onSelectSearchResults: onSeeSearchResults,
        isAiAnswersEnabled: !!isVSAOnHCEnabled,
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($47c3003d0a8a426d$var$SearchPopupContentWithRef, {
                ...triggerProps,
                setSearchBoxWidth: setSearchBoxWidth,
                searchBarRef: searchBarRef,
                isChoiceOpen: isChoiceOpen,
                isVirtualAgentEnabled: !!isVSAOnHCEnabled,
                openChoicesIfPresent: openChoicesIfPresent,
                handleKeyDown: handleKeyDown,
                handleInputChange: handleInputChange,
                inputValue: inputValue,
                disableSearch: disableSearch,
                isFetchingResults: isFetchingResults,
                visibleResultsCount: visibleResultsCount
            });
        }
    }));
};
$47c3003d0a8a426d$var$SearchTextboxV2.displayName = 'SearchTextboxV2';
const $47c3003d0a8a426d$var$WrappedComponent = (0, $cxNwq.withHelpCenterConversationStateContainer)($47c3003d0a8a426d$var$SearchTextboxV2);
const $47c3003d0a8a426d$var$SearchTextBoxV2withConversationContainers = (props)=>{
    const contextId = (0, $jByYr.getHelpCenterAri)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($47c3003d0a8a426d$var$WrappedComponent, {
        ...props,
        contextId: contextId
    });
};
var $47c3003d0a8a426d$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    component: (0, $8rTkC.ScreenName).HELP_CENTER_SEARCH
})($47c3003d0a8a426d$var$SearchTextBoxV2withConversationContainers);
const $47c3003d0a8a426d$var$searchBoxWrapperStyles = (0, $37U6z.xcss)({
    position: 'relative'
});
const $47c3003d0a8a426d$var$searchBoxStyles = (0, $37U6z.xcss)({
    backgroundColor: 'color.background.input',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border.input',
    borderRadius: 'radius.small',
    ':focus-within': {
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineColor: 'color.border.focused'
    }
});
const $47c3003d0a8a426d$var$searchBoxShapeThemeStyles = (0, $37U6z.xcss)({
    borderRadius: 'radius.medium'
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $47c3003d0a8a426d$var$Input = /*#__PURE__*/ (0, $2UsNA.default).input.withConfig({
    componentId: "sc-d7rq06-0"
})`${(0, $aw7IH.SEARCH_INPUT_FONT_SIZE)};${$6t2I3.placeholder("var(--ds-text-subtlest, #6B778C)")};background-color:${"var(--ds-background-input, white)"};${()=>(0, $1EFS8.default).checkGate('platform-dst-shape-theme-default') ? `border-radius: ${"var(--ds-radius-medium, 6px)"};` : ''} padding:${$4cxV2.multiple(2.125).px}  ${(props)=>props.isAiAnswersEnabled ? '148px' : "var(--ds-space-600, 48px)"} ${$4cxV2.multiple(2.125).px} ${"var(--ds-space-050, 4px)"};flex-grow:1;border:0;outline:none;color:${"var(--ds-text, #172B4D)"};@media not all and (min-width:30rem){${(0, $HGACo.isUseHelpCenterRefresh)() ? `padding-right: ${"var(--ds-space-050, 4px)"};` : ''}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $47c3003d0a8a426d$var$SearchIconWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt4119w _4t3i1osq _1ltvidpf _154iidpf _94n5idpf _1e0c1txw _4cvr1h6o _1wpz1h6o _u5f31b66",
            __cmplp.className
        ])
    });
});
const $47c3003d0a8a426d$var$askAiHintStyles = (0, $37U6z.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    position: 'absolute',
    padding: 'space.150',
    right: 'space.0',
    color: 'color.text.subtle',
    top: 'space.0',
    bottom: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 11
});

});
parcelRegister("k9pD5", function(module, exports) {
$parcel$export(module.exports, "SearchPromptPopup", () => $6d2c9d7d03c1d86e$export$392e007cdca1b718);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
var $3FFzY = parcelRequire("3FFzY");
var $1ZbH0 = parcelRequire("1ZbH0");

const $6d2c9d7d03c1d86e$export$48d2544cca703af5 = (0, $fGOkV.lazy)(()=>(parcelRequire("isdoT")).then((module)=>module.SearchPromptPopup), {
    moduleId: "./packages/help-center/search/src/search-prompt-popup/search-prompt-popup.tsx"
});
const $6d2c9d7d03c1d86e$export$392e007cdca1b718 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, props.trigger({
            ref: null,
            'aria-expanded': false,
            'aria-haspopup': false
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1ZbH0.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($6d2c9d7d03c1d86e$export$48d2544cca703af5, props)));
};

});
parcelRegister("isdoT", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("6c0z0").then(()=>parcelRequire('8n27i'));

});


parcelRegister("ehIuP", function(module, exports) {
$parcel$export(module.exports, "default", () => $93c12cf2d0b89f48$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $93c12cf2d0b89f48$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    clearLabel: {
        defaultMessage: 'Reset search',
        description: 'Label for icon that clears the search term',
        id: 'search.input.clear'
    },
    inputAriaLabel: {
        defaultMessage: 'Question or search terms',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.ai'
    },
    inputPlaceholder: {
        defaultMessage: 'Ask a question or search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputAriaLabelNoAI: {
        defaultMessage: 'Search for information',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.no-ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputPlaceholderNoAI: {
        defaultMessage: 'Search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.no-ai'
    },
    askTheVirtualServiceAgent: {
        defaultMessage: 'Ask the virtual service agent',
        description: 'Hint to the user to initiate the virtual service agent conversation',
        id: 'search.input.placeholder.ai.ask-the-virtual-service-agent'
    },
    enter: {
        defaultMessage: 'Enter',
        description: 'Enter key from the keyboard',
        id: 'search.see.search.results.key.enter.non-final'
    },
    search: {
        defaultMessage: 'Search',
        description: 'Hint to the user to press enter to go to search results page',
        id: 'search.input.hint'
    },
    ariaDescription: {
        defaultMessage: 'Typing letters in the search input updates the search results in below data table',
        description: 'description for screen reader users when they focus on the search bar ',
        id: 'search.input.aria-description'
    }
});

});





parcelRegister("9rAg7", function(module, exports) {
$parcel$export(module.exports, "CustomiseMenu", () => (parcelRequire("dcwyo")).default);

var $dcwyo = parcelRequire("dcwyo");

});
parcelRegister("dcwyo", function(module, exports) {
$parcel$export(module.exports, "default", () => $6357767fcfebc466$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $1E402 = parcelRequire("1E402");

var $ktLIP = parcelRequire("ktLIP");
parcelRequire("2tsrb");
var $7IL12 = parcelRequire("7IL12");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("h7ovm");
var $fq3ya = parcelRequire("fq3ya");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
parcelRequire("8s5NV");
var $4XBD0 = parcelRequire("4XBD0");
const $6357767fcfebc466$var$selector = (0, $ehscL.createSelector)((state)=>{
    var _getPortalAnnouncemen;
    const portalId = (0, $7IL12.getPortalId)(state);
    const portal = {
        id: portalId,
        name: (0, $73V7l.getName)(state, portalId),
        canEditAnnouncement: Boolean((_getPortalAnnouncemen = (0, $73V7l.getPortalAnnouncement)(state, portalId)) === null || _getPortalAnnouncemen === void 0 ? void 0 : _getPortalAnnouncemen.canEditAnnouncement),
        isProjectAdmin: Boolean((0, $73V7l.getCanAdministerProject)(state, portalId)),
        isProjectSimplified: Boolean((0, $73V7l.getIsProjectSimplified)(state, portalId))
    };
    return {
        portal: portal,
        canAdministerJIRA: (0, $hx8zX.getCanAdministerJIRA)(state),
        hasSiteAdministerAccess: (0, $hx8zX.getHasSiteAdministerAccess)(state),
        canCustomiseHelpCenter: (0, $ikoP4.getCanCustomize)(state),
        defaultColumnSettings: (0, $fq3ya.getRequestsColumnSettings)(state),
        jsmAIConfigEnabled: (0, $8Wisn.getJsmAIConfigEnabled)(state),
        projectKey: (0, $73V7l.getProjectKey)(state, portalId)
    };
}, ({ portal: portal, canAdministerJIRA: canAdministerJIRA, hasSiteAdministerAccess: hasSiteAdministerAccess, canCustomiseHelpCenter: canCustomiseHelpCenter, defaultColumnSettings: defaultColumnSettings, jsmAIConfigEnabled: jsmAIConfigEnabled, projectKey: projectKey })=>({
        portal: portal,
        canAdministerJIRA: canAdministerJIRA,
        hasSiteAdministerAccess: hasSiteAdministerAccess,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        defaultColumnSettings: defaultColumnSettings,
        jsmAIConfigEnabled: jsmAIConfigEnabled,
        projectKey: projectKey
    }));
var $6357767fcfebc466$export$2e2bcd8739ae039 = (0, $jvoWT.default)($6357767fcfebc466$var$selector, {
    openHelpCenterCustomizationSidebar: ()=>(0, $1E402.editingHelpCenter)(true),
    openRequestListCustomizationSidebar: ()=>(0, $ktLIP.customizingRequestListColumn)(true)
})((0, $4XBD0.default));

});
parcelRegister("h7ovm", function(module, exports) {
$parcel$export(module.exports, "getEnabledRequestsColumnSettings", () => (parcelRequire("fq3ya")).getEnabledRequestsColumnSettings);
$parcel$export(module.exports, "getRequestsColumnSettings", () => (parcelRequire("fq3ya")).getRequestsColumnSettings);
$parcel$export(module.exports, "getStatusFilter", () => (parcelRequire("fq3ya")).getStatusFilter);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("fq3ya")).isSaveInProgress);
$parcel$export(module.exports, "isCustomizing", () => (parcelRequire("fq3ya")).isCustomizing);
$parcel$export(module.exports, "getOrderedRequestsColumnSettings", () => (parcelRequire("fq3ya")).getOrderedRequestsColumnSettings);
$parcel$export(module.exports, "isReOrdering", () => (parcelRequire("fq3ya")).isReOrdering);

var $fq3ya = parcelRequire("fq3ya");

});
parcelRegister("fq3ya", function(module, exports) {
$parcel$export(module.exports, "getRequestsColumnSettings", () => $af701a351f3569ec$export$a5e47ac90fcdaee8);
$parcel$export(module.exports, "getStatusFilter", () => $af701a351f3569ec$export$118cb57d68780367);
$parcel$export(module.exports, "getEnabledRequestsColumnSettings", () => $af701a351f3569ec$export$821f60d0d1e0f967);
$parcel$export(module.exports, "isSaveInProgress", () => $af701a351f3569ec$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isCustomizing", () => $af701a351f3569ec$export$ce3eed7c98304744);
$parcel$export(module.exports, "isReOrdering", () => $af701a351f3569ec$export$f63ec727b3081523);
$parcel$export(module.exports, "getOrderedRequestsColumnSettings", () => $af701a351f3569ec$export$3e30ecdbb6a12b60);

var $ehscL = parcelRequire("ehscL");

var $jjE9o = parcelRequire("jjE9o");
const $af701a351f3569ec$export$29021bb8222c3223 = (state)=>{
    return state.persisted.requestsColumnSettings || {
        columns: [],
        statusFilter: undefined
    };
};
const $af701a351f3569ec$export$a5e47ac90fcdaee8 = (state)=>{
    const settingsState = $af701a351f3569ec$export$29021bb8222c3223(state);
    return settingsState.columns || [];
};
const $af701a351f3569ec$export$118cb57d68780367 = (state)=>{
    const settingsState = $af701a351f3569ec$export$29021bb8222c3223(state);
    return settingsState.statusFilter;
};
const $af701a351f3569ec$export$821f60d0d1e0f967 = (0, $ehscL.createSelector)($af701a351f3569ec$export$a5e47ac90fcdaee8, (requestsColumnSettings)=>{
    return requestsColumnSettings.filter((column)=>column.isEnabled);
});
const $af701a351f3569ec$export$20bb0d907fbbe433 = (state)=>{
    if (!state.ui.requestsColumnSettings) return true;
    return Boolean(state.ui.requestsColumnSettings.isLoading);
};
const $af701a351f3569ec$export$2b75ac2de7a23db1 = (state)=>{
    var _state$ui$requestsCol;
    return Boolean((_state$ui$requestsCol = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol === void 0 ? void 0 : _state$ui$requestsCol.isSaveInProgress);
};
const $af701a351f3569ec$export$ce3eed7c98304744 = (state)=>{
    var _state$ui$requestsCol2;
    return Boolean((_state$ui$requestsCol2 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol2 === void 0 ? void 0 : _state$ui$requestsCol2.isCustomizing);
};
const $af701a351f3569ec$export$f63ec727b3081523 = (state)=>{
    var _state$ui$requestsCol3;
    return Boolean((_state$ui$requestsCol3 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol3 === void 0 ? void 0 : _state$ui$requestsCol3.isReOrdering);
};
const $af701a351f3569ec$export$c7b5b7c6c2c6936 = (state)=>{
    var _state$ui$requestsCol4;
    return (_state$ui$requestsCol4 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol4 === void 0 ? void 0 : _state$ui$requestsCol4.columnsOrder;
};
const $af701a351f3569ec$export$3e30ecdbb6a12b60 = (0, $ehscL.createSelector)($af701a351f3569ec$export$821f60d0d1e0f967, $af701a351f3569ec$export$c7b5b7c6c2c6936, (enabledColumnSettings, columnsOrder)=>{
    if (columnsOrder && columnsOrder.length > 0) return columnsOrder.map((index)=>enabledColumnSettings === null || enabledColumnSettings === void 0 ? void 0 : enabledColumnSettings[index]);
    const filteredColumns = enabledColumnSettings.filter((column)=>column.order);
    if (filteredColumns.length > 0) return filteredColumns.sort((a, b)=>{
        if (a.order && b.order) return a.order - b.order;
        return 1;
    });
    /*
   * We fire analytics when enabledColumnSettings is not empty (to filter out noise) and filteredColumns
   * is empty implying that order is prop is undefined for all the columns. This is an erroneous state
   * since we expect at least one column to have order prop defined. If this happens, we return enabledColumnSettings
   * as is.
   */ if (enabledColumnSettings && enabledColumnSettings.length > 0) (0, $jjE9o.operationalEvent)({
        action: 'emptyOrderedRequestColumnSettingsReceived',
        actionSubject: 'request-list-filters-and-table',
        source: 'RequestList'
    });
    return enabledColumnSettings;
});

});


parcelRegister("8s5NV", function(module, exports) {
$parcel$export(module.exports, "CustomiseMenuDumb", () => (parcelRequire("4XBD0")).default);

var $4XBD0 = parcelRequire("4XBD0");

});
parcelRegister("4XBD0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8918bdfeafc1169b$export$2e2bcd8739ae039);
/* customise-menu-dumb.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $8y05I = parcelRequire("8y05I");
var $cS6Xr = parcelRequire("cS6Xr");

var $Vw3JS = parcelRequire("Vw3JS");

var $8rTkC = parcelRequire("8rTkC");

var $kM5Oy = parcelRequire("kM5Oy");

var $edC7N = parcelRequire("edC7N");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $4cxV2 = parcelRequire("4cxV2");

var $k1tWg = parcelRequire("k1tWg");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
parcelRequire("hGzcq");
var $gRzju = parcelRequire("gRzju");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");

var $8gu7I = parcelRequire("8gu7I");
var $MmGmU = parcelRequire("MmGmU");

var $1EFS8 = parcelRequire("1EFS8");

var $c1axT = parcelRequire("c1axT");

var $eT7pr = parcelRequire("eT7pr");

var $lkatq = parcelRequire("lkatq");
var $3rCJZ = parcelRequire("3rCJZ");
var $7qJSw = parcelRequire("7qJSw");

var $5JQIe = parcelRequire("5JQIe");
var $1P5py = parcelRequire("1P5py");

var $c2L1U = parcelRequire("c2L1U");

var $6Hfjm = parcelRequire("6Hfjm");
var $galRw = parcelRequire("galRw");
var $37U6z = parcelRequire("37U6z");

var $jbqt2 = parcelRequire("jbqt2");

var $8vv1J = parcelRequire("8vv1J");

var $iziiq = parcelRequire("iziiq");

var $81QBf = parcelRequire("81QBf");

var $i4z8R = parcelRequire("i4z8R");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $7FSs7 = parcelRequire("7FSs7");

var $fsZf3 = parcelRequire("fsZf3");
parcelRequire("jzN5z");
var $eRD7p = parcelRequire("eRD7p");

var $h1FqG = parcelRequire("h1FqG");

var $ivn4x = parcelRequire("ivn4x");
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $8918bdfeafc1169b$var$isSmallScreen = window.innerWidth < (0, $k1tWg.sizes).xsmall;
const $8918bdfeafc1169b$var$CustomPressable = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $galRw.default), {
        componentName: "link",
        xcss: $8918bdfeafc1169b$var$customPressableStyles,
        ...rest
    }, children);
};
const $8918bdfeafc1169b$var$PremiumBenefitsModalRenderer = ({ menu: menu })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: (0, $8rTkC.ScreenName).HELP_CENTER,
        id: "help-center-customise-menu-edit-page-layout",
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $81QBf.PremiumBenefitModalTrigger), {
        cloudId: (0, $jByYr.getCloudId)(),
        product: "jira-service-management",
        variantId: "help-center-customization",
        touchpointId: "portal-customise-menu-edit-page-layout",
        edition: (0, $hrPHR.getEnv)().edition ?? 'unknown'
    }, ({ ref: ref, props: triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            ref: ref,
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
            data: {
                actionSubjectId: menu.actionSubjectId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            component: $8918bdfeafc1169b$var$CustomPressable,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.iconAfter,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label)))));
};
const $8918bdfeafc1169b$var$CustomizeLinks = (onClose, openHelpCenterCustomizationSidebar, canAdministerJIRA, showEditLayoutButton, isHomePage, basePath, handleHideSpotlight, hasSiteAdministerAccess)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const isCsmHelpCenter = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    const showPortalReorderButton = !isCsmHelpCenter && isHomePage && canAdministerJIRA && !$8918bdfeafc1169b$var$isSmallScreen;
    const navbarHideAndReorderCustomRenderer = (0, $8P7DW.useCallback)(()=>{
        if ((0, $hrPHR.getIsHCCustomizationEnabled)()) return undefined;
        if ((0, $fsZf3.isPremiumUpsellExperimentEnabled)({
            hasSiteAdministerAccess: hasSiteAdministerAccess,
            isHCCustomizationEnabled: (0, $hrPHR.getIsHCCustomizationEnabled)()
        })) return $8918bdfeafc1169b$var$PremiumBenefitsModalRenderer;
        return 0, $h1FqG.default;
    }, [
        hasSiteAdministerAccess
    ]);
    const customizeMenu = [
        {
            link: `${basePath}?customize=true&experience=help-center-announcement`,
            label: formatMessage((0, $ivn4x.default).announcement),
            actionSubjectId: 'navbarAnnouncement',
            isVisible: isHomePage && !$8918bdfeafc1169b$var$isSmallScreen,
            onClick: ()=>onClick('navbarAnnouncement'),
            testId: 'announcement-link'
        },
        {
            link: `${basePath}?customize=true&experience=theme`,
            label: formatMessage((0, $ivn4x.default).look),
            actionSubjectId: 'navbarLookAndFeel',
            isVisible: isHomePage && canAdministerJIRA,
            onClick: ()=>onClick('navbarLookAndFeel'),
            testId: 'look-and-feel-link'
        },
        {
            link: `${basePath}?customize=true&experience=login-announcement`,
            label: formatMessage((0, $ivn4x.default).logInMessage),
            actionSubjectId: 'navbarLoginAnnouncement',
            isVisible: isHomePage && canAdministerJIRA && !$8918bdfeafc1169b$var$isSmallScreen,
            onClick: ()=>onClick('navbarLoginAnnouncement'),
            testId: 'login-announcement-link'
        },
        {
            link: '/settings/portal-reorder',
            label: (0, $HGACo.isAdvancedCustomizationEditPageEnabled)() ? formatMessage((0, $ivn4x.default).topicsAndPortals) : formatMessage((0, $ivn4x.default).pageLayout),
            actionSubjectId: 'navbarPortalReorder',
            isVisible: showPortalReorderButton,
            onClick: ()=>onClick('navbarPortalReorder'),
            testId: 'topics-link'
        },
        {
            link: '/edit',
            label: formatMessage((0, $ivn4x.default).pageLayout),
            actionSubjectId: 'navbarHideAndReorder',
            isVisible: showEditLayoutButton,
            onClick: ()=>onClick('navbarHideAndReorder', !(0, $hrPHR.getIsHCCustomizationEnabled)() && (0, $fsZf3.isPremiumUpsellExperimentEnabled)({
                    hasSiteAdministerAccess: hasSiteAdministerAccess,
                    isHCCustomizationEnabled: (0, $hrPHR.getIsHCCustomizationEnabled)()
                })),
            testId: 'hide-and-reorder-link',
            showSpotlight: true,
            customRenderer: navbarHideAndReorderCustomRenderer(),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, (0, $hrPHR.getIsHCCustomizationEnabled)() ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
                appearance: "new"
            }, formatMessage((0, $ivn4x.default).premium)))
        }
    ];
    const onClick = (actionSubjectId, closeSidebar)=>{
        onClose(actionSubjectId);
        if (!closeSidebar) openHelpCenterCustomizationSidebar();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(menu.customRenderer, {
            key: `customize-menu_${menu.actionSubjectId}`,
            menu: menu
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1P5py.default), {
            name: (0, $8rTkC.EngagementMessagesTarget).CHANGE_BOARDING_CUSTOMISE_BUTTON_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            key: `customize-menu_${menu.actionSubjectId}`,
            component: $8918bdfeafc1169b$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.iconAfter,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label)), menu.showSpotlight && (0, $HGACo.isCustomiseDropDownChangeBoardingEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kM5Oy.default), {
            messageId: (0, $8rTkC.EngagementMessages).CHANGE_BOARD_CUSTOMISE_BUTTON
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $Vw3JS.ChangeBoardingSingleSpotlight), {
            target: (0, $8rTkC.EngagementMessagesTarget).CHANGE_BOARDING_CUSTOMISE_BUTTON_SPOTLIGHT,
            analyticsSubject: "customiseButtonChangeBoarding",
            messageId: (0, $8rTkC.EngagementMessages).CHANGE_BOARD_CUSTOMISE_BUTTON,
            contentText: formatMessage((0, $ivn4x.default).changeBoardingText),
            buttonText: formatMessage((0, $ivn4x.default).changeBoardingButtonText),
            dialogPlacement: "bottom right",
            targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
            onHideSpotlight: handleHideSpotlight
        })));
    }));
};
const $8918bdfeafc1169b$var$PortalLinks = ({ onClose: onClose, canCustomiseHelpCenter: canCustomiseHelpCenter, portal: portal, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    if (!portal) return null;
    const { isProjectSimplified: isProjectSimplified, isProjectAdmin: isProjectAdmin, canEditAnnouncement: canEditAnnouncement } = portal;
    const shouldRenderAsPortalAnnouncement = ()=>{
        // for simplified projects, render side bar as announcement for agents with permission
        if (isProjectSimplified && !isProjectAdmin && canEditAnnouncement) return true;
        // in classic projects render sidebar as announcement for users who can't modify helpcenter, but can edit announcements
        if (!isProjectSimplified && !canCustomiseHelpCenter && canEditAnnouncement) return true;
        return false;
    };
    const shouldRenderConfigurePortal = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length) && (0, $HGACo.isCortopv2ExperimentEnabledWithExposure)(true);
    const shouldRenderCustomizeRequestTypes = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length) && (0, $HGACo.isCortopv2ExperimentEnabledWithExposure)(true);
    const shouldRenderCustomizePortalGroups = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length) && (0, $HGACo.isCortopv2ExperimentEnabledWithExposure)(true);
    const customizeMenu = [
        {
            link: '?customize=true&experience=add-announcement',
            onClick: ()=>onClose('navbarPortalAnnouncement'),
            label: formatMessage((0, $ivn4x.default).portalAnnouncement),
            actionSubjectId: 'navbarPortalAnnouncement',
            isVisible: canEditAnnouncement || shouldRenderAsPortalAnnouncement()
        },
        {
            link: '?customize=true&experience=request-groups',
            onClick: ()=>onClose('navbarRequestTypeGroup'),
            label: formatMessage((0, $ivn4x.default).portalRequestTypeGroup),
            actionSubjectId: 'navbarRequestTypeGroup',
            isVisible: isProjectAdmin && isProjectSimplified && !shouldRenderAsPortalAnnouncement()
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/portal-settings`,
            onClick: ()=>onClose('navbarConfigurePortal'),
            label: formatMessage((0, $ivn4x.default).configurePortal),
            actionSubjectId: 'navbarConfigurePortal',
            isVisible: shouldRenderConfigurePortal(),
            target: '_blank'
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/${isProjectSimplified ? 'issuetypes' : 'request-types'}/`,
            onClick: ()=>onClose('navbarCustomizeRequestTypes'),
            label: formatMessage((0, $ivn4x.default).customizeRequestTypes),
            actionSubjectId: 'navbarCustomizeRequestTypes',
            isVisible: shouldRenderCustomizeRequestTypes(),
            target: '_blank'
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/portal-settings/portal-groups`,
            onClick: ()=>onClose('navbarManagePortalGroups'),
            label: formatMessage((0, $ivn4x.default).managePortalGroups),
            actionSubjectId: 'navbarManagePortalGroups',
            isVisible: shouldRenderCustomizePortalGroups(),
            target: '_blank'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), null, customizeMenu.map(({ isVisible: isVisible, actionSubjectId: actionSubjectId, onClick: onClick, link: link, href: href, label: label, target: target })=>{
        if (!isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            key: `portal-link_${actionSubjectId}`,
            component: $8918bdfeafc1169b$var$CustomLink,
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            ...link ? {
                to: link
            } : {},
            ...href ? {
                href: href
            } : {},
            testId: `portal-link_${actionSubjectId}`,
            // Made this check of menu.target === '_blank' to avoid the eslint error
            target: target === '_blank' ? '_blank' : '_self',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, label);
    }));
};
const $8918bdfeafc1169b$var$CustomPageLinks = ({ showEditCustomPages: showEditCustomPages })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [{ match: match }] = (0, $i9cdb.useRouter)();
    const pageId = match.params.id || '';
    const customizeMenu = [
        {
            link: `/page/edit/${pageId}`,
            label: formatMessage((0, $ivn4x.default).pageLayout),
            actionSubjectId: 'navbarEditCustomPage',
            isVisible: showEditCustomPages
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
            key: `custom-page-link_${menu.actionSubjectId}`,
            component: $8918bdfeafc1169b$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label);
    }));
};
const $8918bdfeafc1169b$var$RequestList = (onClose, openRequestListCustomizationSidebar)=>{
    const onClick = (actionSubjectId)=>{
        onClose(actionSubjectId);
        openRequestListCustomizationSidebar();
    };
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        component: $8918bdfeafc1169b$var$CustomButton,
        actionSubjectId: "navbarUserRequestListCustomize",
        "aria-label": formatMessage((0, $ivn4x.default).customizeRequestList),
        onClick: ()=>onClick('navbarUserRequestListCustomize'),
        "data-test-id": "requests-list-page-link"
    }, formatMessage((0, $ivn4x.default).customizeRequestList)));
};
const $8918bdfeafc1169b$var$CustomiseMenu = (props)=>{
    const [{ route: route }] = (0, $i9cdb.useRouter)();
    const { name: routeName } = route;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $iwSnV.useQueryParams)();
    (0, $8P7DW.useEffect)(()=>{
        // if customize is true and experience is not set, open the customise menu
        if (customize === 'true' && !experience) setIsOpen(true);
    }, [
        customize,
        experience
    ]);
    const isHomepage = routeName === 'help-center' || routeName === 'view-homepage';
    const isCustomPage = routeName === (0, $8rTkC.RouteName).VIEW_CUSTOM_PAGE;
    const showEditCustomPageButton = (0, $HGACo.isCustomPagesUiEnabled)() && props.canAdministerJIRA && !$8918bdfeafc1169b$var$isSmallScreen && isCustomPage;
    const showEditLayoutButtonUpsell = (0, $hrPHR.getIsHCCustomizationEnabled)() || (props.hasSiteAdministerAccess ?? false);
    const showEditLayoutButton = (0, $HGACo.isAdvancedCustomizationEditPageEnabled)() && isHomepage && props.canAdministerJIRA && !$8918bdfeafc1169b$var$isSmallScreen && showEditLayoutButtonUpsell;
    const isHelpCenterManagementScreen = (0, $7FSs7.getRelativeBasePath)() === (0, $8rTkC.HELP_CENTERS_MANAGEMENT_BASE_PATH);
    const basePath = (0, $gk18s.isAdvancedHelpCenter)() ? '/' : '/portals';
    const [isOpen, setIsOpen] = (0, $8P7DW.useState)(!!props.isOpen);
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const handleHideSpotlight = (0, $8P7DW.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const onOpenChange = (0, $8P7DW.useCallback)((open)=>{
        setIsOpen(open);
    }, []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const setCustomiseSidebarTrigger = (0, $gRzju.useSetCustomiseSidebarTrigger)();
    const onItemClick = (actionSubjectId)=>{
        if (actionSubjectId && createAnalyticsEvent) createAnalyticsEvent({
            actionSubjectId: actionSubjectId,
            action: 'clicked',
            actionSubject: 'customizeMenu',
            analyticsType: (0, $iziiq.UI_EVENT_TYPE)
        }).fire();
        setIsOpen(false);
    };
    const allowRouteList = [
        'help-center',
        'view-homepage',
        'portal-home',
        'requests-list',
        (0, $HGACo.isCustomPagesUiEnabled)() ? (0, $8rTkC.RouteName).VIEW_CUSTOM_PAGE : undefined
    ];
    const hideCustomizeButton = ()=>{
        var _props$portal, _props$portal2;
        return !allowRouteList.includes(routeName) || isHelpCenterManagementScreen || isHomepage && !props.canCustomiseHelpCenter || //Hide for Agents with Edit Permission in mobile view
        isHomepage && props.canCustomiseHelpCenter && !props.canAdministerJIRA && $8918bdfeafc1169b$var$isSmallScreen || routeName === 'portal-home' && !((_props$portal = props.portal) !== null && _props$portal !== void 0 && _props$portal.isProjectAdmin || (_props$portal2 = props.portal) !== null && _props$portal2 !== void 0 && _props$portal2.canEditAnnouncement) || routeName === 'requests-list' && !props.canAdministerJIRA || (0, $HGACo.isCustomPagesUiEnabled)() && isCustomPage && !props.canAdministerJIRA;
    };
    const content = ()=>{
        const { openHelpCenterCustomizationSidebar: openHelpCenterCustomizationSidebar, openRequestListCustomizationSidebar: openRequestListCustomizationSidebar, canAdministerJIRA: canAdministerJIRA, canCustomiseHelpCenter: canCustomiseHelpCenter, defaultColumnSettings: defaultColumnSettings, portal: portal, projectKey: projectKey, hasSiteAdministerAccess: hasSiteAdministerAccess } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $8918bdfeafc1169b$var$popupContainerStyles,
            "aria-label": formatMessage((0, $ivn4x.default).customizeAriaLabel),
            testId: 'customize-menu-content',
            ...(0, $1EFS8.default).checkGate('ff_a11y_hc_role') && {
                role: 'group'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3rCJZ.default), {
            maxHeight: $8918bdfeafc1169b$var$maxHeight,
            spacing: 'cozy'
        }, !isHelpCenterManagementScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, canCustomiseHelpCenter && isHomepage && $8918bdfeafc1169b$var$CustomizeLinks(onItemClick, openHelpCenterCustomizationSidebar, canAdministerJIRA, showEditLayoutButton, isHomepage, basePath, handleHideSpotlight, hasSiteAdministerAccess), routeName === 'portal-home' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($8918bdfeafc1169b$var$PortalLinks, {
            onClose: onItemClick,
            canCustomiseHelpCenter: canCustomiseHelpCenter,
            portal: portal,
            projectKey: projectKey
        }), routeName === 'requests-list' && canAdministerJIRA && Boolean(defaultColumnSettings === null || defaultColumnSettings === void 0 ? void 0 : defaultColumnSettings.length) && $8918bdfeafc1169b$var$RequestList(onItemClick, openRequestListCustomizationSidebar), isCustomPage && showEditCustomPageButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($8918bdfeafc1169b$var$CustomPageLinks, {
            showEditCustomPages: showEditCustomPageButton
        }))), showEditLayoutButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8vv1J.FireUIAnalytics), {
            action: "viewed",
            actionSubject: "editPageLayout"
        }));
    };
    const Trigger = (0, $8P7DW.useCallback)(({ ref: ref, ...triggerProps })=>{
        const combinedRef = (element)=>{
            if (typeof ref === 'function') ref(element);
            else if (ref && typeof ref === 'object' && 'current' in ref) ref.current = element;
            setCustomiseSidebarTrigger === null || setCustomiseSidebarTrigger === void 0 || setCustomiseSidebarTrigger(element);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eRD7p.default), {
            label: formatMessage((0, $ivn4x.default).customizeBtnLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c1axT))), {
                label: "customise",
                size: "small",
                spacing: "spacious"
            }),
            disabled: props.disableCustomiseMenu,
            onClick: ()=>{
                onOpenChange(!isOpen);
                createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'navbarCustomise',
                    analyticsType: (0, $iziiq.UI_EVENT_TYPE)
                }).fire();
            },
            forwardedRef: combinedRef,
            ...triggerProps
        }));
    }, [
        formatMessage,
        props.disableCustomiseMenu,
        onOpenChange,
        isOpen,
        createAnalyticsEvent,
        setCustomiseSidebarTrigger
    ]);
    const renderDropdownMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5JQIe.default), {
            blanketIsTinted: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $i4z8R.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c2L1U.default), {
            isOpen: isOpen,
            onClose: ()=>onOpenChange(false),
            placement: "bottom-end",
            shouldRenderToParent: true,
            zIndex: (0, $jbqt2.layers).modal(),
            content: content,
            trigger: Trigger,
            key: 'customise-menu-dumb-popup'
        })));
    if (hideCustomizeButton()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $8918bdfeafc1169b$var$CustomiseBtnWrapperStyles
    }, renderDropdownMenu());
};
const $8918bdfeafc1169b$var$CustomiseBtnWrapperStyles = (0, $37U6z.xcss)({
    marginRight: 'space.100',
    marginLeft: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8918bdfeafc1169b$var$NoUnderlineLink = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $cS6Xr.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $8918bdfeafc1169b$var$popupContainerStyles = (0, $37U6z.xcss)({
    minWidth: '234px',
    maxWidth: '800px',
    color: 'color.text'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8918bdfeafc1169b$var$CustomLinkBase = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = $8918bdfeafc1169b$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_syaz261p",
            __cmplp.className
        ])
    });
});
const $8918bdfeafc1169b$var$CustomLinkWithFocus = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = $8918bdfeafc1169b$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_syaz261p _1y3i1r31 _92x4glyw _109f1o36 _b8xz168b",
            __cmplp.className
        ])
    });
});
const $8918bdfeafc1169b$var$CustomLink = (0, $1EFS8.default).checkGate('ff_a11y_hc_focus_indicator') ? $8918bdfeafc1169b$var$CustomLinkWithFocus : $8918bdfeafc1169b$var$CustomLinkBase;
const $8918bdfeafc1169b$var$customPressableStyles = (0, $37U6z.xcss)({
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.100',
    paddingInline: 'space.200',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8918bdfeafc1169b$var$CustomButton = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = (0, $8y05I.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_11q7261p _ca0qc4v4 _u5f31gpt _n3tdc4v4 _19bv1gpt _syaz16l4 _1bsbaq80 _4cvr1s23 _j6xtkjgq _1du2kjgq _19lckjgq _1x4lkjgq _utpwkjgq _9h8h16l4 _f8pj16l4 _30l316l4 _ysv716l4 _105316l4",
            __cmplp.className
        ])
    });
});
const $8918bdfeafc1169b$var$maxHeight = `calc(100vh - ${$4cxV2.multiple(24).px}`;
var $8918bdfeafc1169b$export$2e2bcd8739ae039 = $8918bdfeafc1169b$var$CustomiseMenu;

});
parcelRegister("c1axT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b33f6cea30c30d4bb688045632d4c251>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bfdc22d967923f1$var$_react = $8bfdc22d967923f1$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $8bfdc22d967923f1$var$_baseNew = $8bfdc22d967923f1$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $8bfdc22d967923f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBrush".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bfdc22d967923f1$var$PaintBrushIcon = (props)=>/*#__PURE__*/ $8bfdc22d967923f1$var$_react.default.createElement($8bfdc22d967923f1$var$_baseNew.default, Object.assign({
        name: "PaintBrushIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5.75A.75.75 0 0 1 3.25 0h9.5a.75.75 0 0 1 .75.75V9a2 2 0 0 1-2 2H10v3a2 2 0 1 1-4 0v-3H4.5a2 2 0 0 1-2-2zM7.5 11v3a.5.5 0 0 0 1 0v-3zM4 1.5v5h8v-5h-1.5V4H9V1.5H7V3H5.5V1.5zM12 8H4v1a.5.5 0 0 0 .5.5h7A.5.5 0 0 0 12 9z" clip-rule="evenodd"/>`
    }, props));
$8bfdc22d967923f1$var$PaintBrushIcon.displayName = 'PaintBrushIcon';
var $8bfdc22d967923f1$var$_default = module.exports.default = $8bfdc22d967923f1$var$PaintBrushIcon;

});

parcelRegister("jzN5z", function(module, exports) {
$parcel$export(module.exports, "DynamicThemingButton", () => (parcelRequire("eRD7p")).default);

var $eRD7p = parcelRequire("eRD7p");

});
parcelRegister("eRD7p", function(module, exports) {
$parcel$export(module.exports, "default", () => $425ca8070a0bfbc2$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $dqsXi = parcelRequire("dqsXi");
var $37U6z = parcelRequire("37U6z");

var $6Hfjm = parcelRequire("6Hfjm");

var $7zDtY = parcelRequire("7zDtY");
function $425ca8070a0bfbc2$var$DynamicThemingButton({ label: label, ariaLabel: ariaLabel, themeColor: themeColor, disabled: disabled, icon: icon, onClick: onClick, forwardedRef: forwardedRef, textColor: textColor, customStyles: customStyles = {}, ...customProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        ...customProps,
        ref: forwardedRef,
        disabled: disabled,
        "aria-label": ariaLabel ? ariaLabel : label,
        as: "button",
        onClick: onClick,
        xcss: $425ca8070a0bfbc2$var$buttonStyles,
        style: {
            backgroundImage: `linear-gradient(
                to right,
                rgba(255, 255, 255, 0.8),
                rgba(255, 255, 255, 0.8)
            ),
            linear-gradient(to right, ${themeColor}, ${themeColor})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dqsXi.default), {
        gap: "space.050",
        alignItems: "center"
    }, icon, textColor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        color: textColor,
        as: "span"
    }, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        as: "span"
    }, label)));
}
const $425ca8070a0bfbc2$var$buttonStyles = (0, $37U6z.xcss)({
    position: 'relative',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    borderRadius: 'radius.full',
    borderColor: 'color.border.inverse',
    borderWidth: 'border.width.selected',
    borderStyle: 'solid',
    color: 'color.text',
    cursor: 'pointer',
    height: '36px',
    '::after': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        bottom: 'space.0',
        left: 'space.0',
        borderRadius: 'radius.full',
        background: `${"var(--ds-interaction-hovered, rgba(9, 30, 66, 0.60))"}`,
        opacity: 0,
        pointerEvents: 'none'
    },
    ':hover::after': {
        opacity: 0.6,
        transition: 'opacity 200ms'
    },
    ':active': {
        transform: 'scale(0.97)',
        transition: 'transform 50ms'
    },
    ':disabled': {
        pointerEvents: 'none'
    }
});
const $425ca8070a0bfbc2$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getThemeColor), (themeColor)=>({
        themeColor: themeColor
    }));
var $425ca8070a0bfbc2$export$2e2bcd8739ae039 = (0, $jvoWT.default)($425ca8070a0bfbc2$var$selector, {})($425ca8070a0bfbc2$var$DynamicThemingButton);

});


parcelRegister("h1FqG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1de4cd338d71dc8d$export$2e2bcd8739ae039);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

var $1de4cd338d71dc8d$export$2e2bcd8739ae039 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("2SImD")), {
        moduleId: "./src/view/layout/edit-page-layout-with-popup/edit-page-layout-with-popup.tsx"
    })
});

});
parcelRegister("2SImD", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("4GyCo").then(()=>parcelRequire('bw7QO'));

});


parcelRegister("ivn4x", function(module, exports) {
$parcel$export(module.exports, "default", () => $30f8ce8a61532c80$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $30f8ce8a61532c80$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    customizeBtnLabel: {
        defaultMessage: 'Customize',
        description: 'Button label for customize button beside avatar menu in header to open list of customization options in a popup',
        id: 'customize.menu.header.customizeBtnLabel'
    },
    customizeRequestList: {
        defaultMessage: 'Manage columns',
        description: 'Manage columns item in customize menu in request list screen',
        id: 'customize.menu.header.manage-column'
    },
    pageLayout: {
        defaultMessage: 'Edit page layout',
        description: 'Edit page layout item in customize drop-down menu',
        id: 'customize.menu.header.pageLayout'
    },
    beta: {
        defaultMessage: 'Beta',
        description: 'Beta lozenge for flexi HC in customize drop-down menu',
        id: 'customize.menu.header.label.beta'
    },
    premium: {
        defaultMessage: 'Premium',
        description: 'Premium lozenge for flexi HC in customize drop-down menu',
        id: 'customize.menu.header.label.premium'
    },
    changeBoardingText: {
        defaultMessage: 'Make your help content stand out. Reorder or hide sections, and customize your home page with rich content for different audiences.',
        description: 'Text for describing the change boarding of customize button',
        id: 'customize.menu.header.pageLayout.change.board'
    },
    changeBoardingButtonText: {
        defaultMessage: 'OK',
        description: 'Text to close the change boarding of the customize button',
        id: 'customize.menu.header.pageLayout.change.board.ok'
    },
    topicsAndPortals: {
        defaultMessage: 'Manage topics and portals',
        description: 'Manage Topics and Portals item in customize drop-down menu when advanced customization enabled',
        id: 'customize.menu.header.topicsAndPortals'
    },
    look: {
        defaultMessage: 'Customize look and feel',
        description: 'Customize look and feel item in customize menu',
        id: 'customize.menu.header.look'
    },
    announcement: {
        defaultMessage: 'Manage announcements',
        description: 'Announcement item in customize menu',
        id: 'customize.menu.header.announcement'
    },
    logInMessage: {
        defaultMessage: 'Add login page message',
        description: 'Add login page message item in customize menu',
        id: 'customize.menu.header.logInMessage'
    },
    customizeAriaLabel: {
        defaultMessage: 'Customization options',
        description: 'Aria label for screen readers while opening customize pop up menu from customize button in header',
        id: 'customize.menu.header.customizeAriaLabel'
    },
    portalAnnouncement: {
        defaultMessage: 'Manage announcements',
        description: 'Manage announcement item in customize menu in portal screen',
        id: 'customize.menu.header.portalAnnouncement'
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Organize portal groups',
        description: 'Organize portal groups item in customize menu for portal screen',
        id: 'customize.menu.header.requestTypeGroup'
    },
    pageLayoutPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to edit sections in your home page layout.',
        description: 'Description for premium suggestion of feature Page Layout',
        id: 'customize.menu.header.pageLayout.premium.description'
    },
    pageLayoutTryButton: {
        defaultMessage: 'Try it now',
        description: 'Button to try the premium feature Page Layout',
        id: 'customize.menu.header.pageLayout.premium.try.button'
    },
    configurePortal: {
        defaultMessage: 'Configure portal',
        description: 'Configure portal item in customize menu for portal screen',
        id: 'customize.menu.header.configurePortal'
    },
    customizeRequestTypes: {
        defaultMessage: 'Customize request types',
        description: 'Customize request types item in customize menu for portal screen',
        id: 'customize.menu.header.customizeRequestTypes'
    },
    managePortalGroups: {
        defaultMessage: 'Manage portal groups',
        description: 'Manage portal groups item in customize menu for portal screen',
        id: 'customize.menu.header.managePortalGroups'
    }
});

});





parcelRegister("7vUpt", function(module, exports) {
$parcel$export(module.exports, "VirtualServiceAgentHeader", () => (parcelRequire("eDzYi")).default);

var $eDzYi = parcelRequire("eDzYi");

});
parcelRegister("eDzYi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0993a97ae097590$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("aaYFd");
var $8QZqc = parcelRequire("8QZqc");
parcelRequire("6SWKp");
var $gT7Rx = parcelRequire("gT7Rx");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");
parcelRequire("eB4k2");
var $hIwC3 = parcelRequire("hIwC3");
const $b0993a97ae097590$var$selector = (0, $ehscL.createSelector)((state, { portalId: portalId })=>{
    const isJiraAdmin = Boolean((0, $hx8zX.getCanAdministerJIRA)(state));
    const projectId = portalId && (0, $73V7l.getProjectId)(state, (0, $iwSnV.getPortalIdAsNumber)(portalId));
    const isChatSideBarOpen = (0, $gT7Rx.isChatSideBarOpen)(state);
    const isProjectAdmin = (0, $73V7l.getCanAdministerProject)(state, (0, $iwSnV.getPortalIdAsNumber)(portalId));
    return {
        isJiraAdmin: isJiraAdmin,
        projectId: projectId,
        isChatSideBarOpen: isChatSideBarOpen,
        isProjectAdmin: isProjectAdmin
    };
}, ({ isJiraAdmin: isJiraAdmin, projectId: projectId, isChatSideBarOpen: isChatSideBarOpen, isProjectAdmin: isProjectAdmin })=>({
        isJiraAdmin: isJiraAdmin,
        projectId: projectId,
        isChatSideBarOpen: isChatSideBarOpen,
        isProjectAdmin: isProjectAdmin
    }));
const $b0993a97ae097590$var$mapDispatchToProps = {
    openChatSideBar: $8QZqc.openChatSideBar,
    closeChatSideBar: $8QZqc.closeChatSideBar
};
var $b0993a97ae097590$export$2e2bcd8739ae039 = (0, $jvoWT.default)($b0993a97ae097590$var$selector, $b0993a97ae097590$var$mapDispatchToProps)((0, $hIwC3.default));

});
parcelRegister("6SWKp", function(module, exports) {
$parcel$export(module.exports, "isChatSideBarOpen", () => (parcelRequire("gT7Rx")).isChatSideBarOpen);

var $gT7Rx = parcelRequire("gT7Rx");

});
parcelRegister("gT7Rx", function(module, exports) {
$parcel$export(module.exports, "isChatSideBarOpen", () => $68399e42a2e8ff94$export$d16875019bc5532b);
const $68399e42a2e8ff94$export$d16875019bc5532b = (state)=>state.ui.chatDetails.isChatSideBarOpen;

});


parcelRegister("eB4k2", function(module, exports) {
$parcel$export(module.exports, "VirtualServiceAgentHeaderDumb", () => (parcelRequire("hIwC3")).default);

var $hIwC3 = parcelRequire("hIwC3");

});
parcelRegister("hIwC3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5df53a8120f23a9d$export$2e2bcd8739ae039);

var $baqVE = parcelRequire("baqVE");

var $8cRjV = parcelRequire("8cRjV");

var $8P7DW = parcelRequire("8P7DW");

var $1pfMV = parcelRequire("1pfMV");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
var $i9cdb = parcelRequire("i9cdb");

var $MmGmU = parcelRequire("MmGmU");

var $1EFS8 = parcelRequire("1EFS8");

var $edpmG = parcelRequire("edpmG");

var $bQ8UI = parcelRequire("bQ8UI");
var $17wqU = parcelRequire("17wqU");

var $cLmLE = parcelRequire("cLmLE");

var $1lG1b = parcelRequire("1lG1b");

var $aQXm8 = parcelRequire("aQXm8");

var $7FSs7 = parcelRequire("7FSs7");

var $an0gU = parcelRequire("an0gU");
parcelRequire("jzN5z");
var $eRD7p = parcelRequire("eRD7p");

var $3zzC4 = parcelRequire("3zzC4");
const $5df53a8120f23a9d$var$VirtualServiceAgentButton = ({ onClick: onClick, label: label, isChatSideBarOpen: isChatSideBarOpen })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bQ8UI.ContextWrapper), {
        sourceName: (0, $8rTkC.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $17wqU.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eRD7p.default), {
        customStyles: isChatSideBarOpen ? {
            borderColor: "var(--ds-border-focused, #0C66E4)",
            borderWidth: "var(--ds-border-width, 1px)",
            color: "var(--ds-text-accent-blue, #0C66E4)" // this is for the icon color
        } : {},
        label: label,
        textColor: isChatSideBarOpen ? 'color.text.accent.blue' : undefined,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($edpmG))), {
            label: formatMessage((0, $3zzC4.default).virtualServiceAgent)
        }),
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), null));
};
const $5df53a8120f23a9d$var$VirtualServiceAgentHeaderForPortal = ({ cloudId: cloudId, portalId: portalId, projectId: projectId, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBar, closeChatSideBar: closeChatSideBar, isProjectAdmin: isProjectAdmin })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [{ route: route }] = (0, $i9cdb.useRouter)();
    const { isVirtualAgentEnabled: isVirtualAgentAvailableForProject } = (0, $an0gU.useVirtualAgentAvailability)({
        cloudId: cloudId,
        projectId: projectId,
        isLoggedIn: true // this component has a check to only show for logged in users
    });
    const handleVirtualAgentMenuClick = ()=>{
        createAnalyticsEvent({
            analyticsType: (0, $17wqU.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'virtualServiceAgentChatButton',
            attributes: {
                source: 'portal'
            }
        }).fire();
        if ((0, $HGACo.isVsaAdoptionPortalChatSideBarEnabled)() && route.name === 'portal-home' && !isProjectAdmin) {
            if (isChatSideBarOpen) closeChatSideBar === null || closeChatSideBar === void 0 || closeChatSideBar();
            else openChatSideBar === null || openChatSideBar === void 0 || openChatSideBar();
        } else (0, $7FSs7.default).push(`/portal/${portalId}/conversation`);
    };
    if (isVirtualAgentAvailableForProject && (0, $HGACo.isVsaAdoptionHeaderChatButtonEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bQ8UI.ContextWrapper), {
        sourceName: (0, $8rTkC.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $17wqU.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5df53a8120f23a9d$var$VirtualServiceAgentButton, {
        onClick: handleVirtualAgentMenuClick,
        label: formatMessage((0, $3zzC4.default).chat),
        isChatSideBarOpen: isChatSideBarOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), null));
    return null;
};
const $5df53a8120f23a9d$var$VirtualServiceAgentHeaderForHelpCenter = ({ cloudId: cloudId })=>{
    var _virtualAgentEnabledD, _virtualAgentEnabledD2;
    const helpCenterAri = (0, $jByYr.getHelpCenterAri)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const virtualAgentEnabledData = (0, $h3cOB.useLazyLoadQuery)((0, $8cRjV.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const isVirtualAgentEnabled = (virtualAgentEnabledData === null || virtualAgentEnabledData === void 0 || (_virtualAgentEnabledD = virtualAgentEnabledData.helpCenter) === null || _virtualAgentEnabledD === void 0 || (_virtualAgentEnabledD = _virtualAgentEnabledD.helpCenterById) === null || _virtualAgentEnabledD === void 0 ? void 0 : _virtualAgentEnabledD.__typename) === 'HelpCenter' && virtualAgentEnabledData.helpCenter.helpCenterById.virtualAgentEnabled;
    const isVirtualAgentAvailable = (virtualAgentEnabledData === null || virtualAgentEnabledData === void 0 || (_virtualAgentEnabledD2 = virtualAgentEnabledData.virtualAgent) === null || _virtualAgentEnabledD2 === void 0 ? void 0 : _virtualAgentEnabledD2.virtualAgentAvailability) ?? false;
    const isHelpSeekerWithVSAEnabled = (0, $HGACo.isVsaAdoptionHeaderChatButtonEnabled)() && isVirtualAgentAvailable && isVirtualAgentEnabled;
    const handleVirtualAgentMenuClick = ()=>{
        createAnalyticsEvent({
            analyticsType: (0, $17wqU.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'virtualServiceAgentChatButton',
            attributes: {
                source: 'help-center'
            }
        }).fire();
        (0, $7FSs7.default).push(`/conversation`);
    };
    if (isHelpSeekerWithVSAEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bQ8UI.ContextWrapper), {
        sourceName: (0, $8rTkC.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $17wqU.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5df53a8120f23a9d$var$VirtualServiceAgentButton, {
        onClick: handleVirtualAgentMenuClick,
        label: formatMessage((0, $3zzC4.default).chat)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), null));
    return null;
};
const $5df53a8120f23a9d$var$VirtualServiceAgentHeaderForAdmin = ({ cloudId: cloudId, isJiraAdmin: isJiraAdmin })=>{
    var _virtualAgentEnabledD3;
    const helpCenterAri = (0, $jByYr.getHelpCenterAri)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const virtualAgentEnabledData = (0, $h3cOB.useLazyLoadQuery)((0, $baqVE.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const isVirtualAgentEnabled = (virtualAgentEnabledData === null || virtualAgentEnabledData === void 0 || (_virtualAgentEnabledD3 = virtualAgentEnabledData.helpCenter) === null || _virtualAgentEnabledD3 === void 0 || (_virtualAgentEnabledD3 = _virtualAgentEnabledD3.helpCenterById) === null || _virtualAgentEnabledD3 === void 0 ? void 0 : _virtualAgentEnabledD3.__typename) === 'HelpCenter' && virtualAgentEnabledData.helpCenter.helpCenterById.virtualAgentEnabled;
    const usesFeatureEncodingSdk = (0, $1EFS8.default).checkGate('use_frontend_feature_encoding_sdk_help_center');
    const adminWithoutVSAEnabled = isJiraAdmin && !isVirtualAgentEnabled && (usesFeatureEncodingSdk ? (0, $1pfMV.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent') : !(0, $1lG1b.isFedRamp)());
    const handleVirtualAgentMenuClick = ()=>{
        createAnalyticsEvent({
            analyticsType: (0, $17wqU.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'virtualServiceAgentButton',
            attributes: {
                source: 'admin'
            }
        }).fire();
        const { helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse(helpCenterAri);
        window.location.href = `${window.location.origin}${0, $8rTkC.HELP_CENTERS_MANAGEMENT_BASE_PATH}/${helpCenterId}/virtual-agent`;
    };
    if (adminWithoutVSAEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bQ8UI.ContextWrapper), {
        sourceName: (0, $8rTkC.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $17wqU.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5df53a8120f23a9d$var$VirtualServiceAgentButton, {
        onClick: handleVirtualAgentMenuClick,
        label: formatMessage((0, $3zzC4.default).virtualServiceAgent)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), null));
    return null;
};
const $5df53a8120f23a9d$var$VirtualServiceAgentHeaderDumbWrapper = ({ isJiraAdmin: isJiraAdmin, projectId: projectId, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBar, closeChatSideBar: closeChatSideBar, isProjectAdmin: isProjectAdmin })=>{
    const cloudId = (0, $jByYr.getCloudId)();
    const [portalId] = (0, $iyRi5.usePathParam)('portalId');
    if ((0, $HGACo.isHideVsaEndpointsEnabled)()) return null;
    if (isJiraAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5df53a8120f23a9d$var$VirtualServiceAgentHeaderForAdmin, {
        cloudId: cloudId,
        isJiraAdmin: true
    });
    // at this point all the users are help seekers and are logged in
    // we have no special checks for project admins, they continue to see the button in the header just like help seekers would
    if (portalId) {
        // this is different that portalId && projectId because we don't want to render the
        // button for a help seeker in portal if projectId is not present
        // if we do && it would get into the the help center header
        // we want it to explicitly render null if projectId is not present but portalId is present
        // better to not render anything in this case than to render the button that redirects to the help center conversation page
        if (projectId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5df53a8120f23a9d$var$VirtualServiceAgentHeaderForPortal, {
            cloudId: cloudId,
            portalId: portalId,
            projectId: projectId,
            isChatSideBarOpen: isChatSideBarOpen,
            openChatSideBar: openChatSideBar,
            closeChatSideBar: closeChatSideBar,
            isProjectAdmin: isProjectAdmin
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5df53a8120f23a9d$var$VirtualServiceAgentHeaderForHelpCenter, {
        cloudId: cloudId
    });
};
var $5df53a8120f23a9d$export$2e2bcd8739ae039 = $5df53a8120f23a9d$var$VirtualServiceAgentHeaderDumbWrapper;

});
parcelRegister("baqVE", function(module, exports) {
$parcel$export(module.exports, "default", () => $a323f80f5c60e01c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a667f6d7661f5df232a1ea702de1e81a>>
 * @relayHash c5303cbd99f5030deeec59f886b004b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8306c73b12cbb2fd42063f0cdc6ebda1c4dc6066b8a39cfe989704e07c87159a
const $a323f80f5c60e01c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "virtualServiceAgentHeaderDumbAdminQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "virtualServiceAgentHeaderDumbAdminQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8306c73b12cbb2fd42063f0cdc6ebda1c4dc6066b8a39cfe989704e07c87159a",
            "metadata": {},
            "name": "virtualServiceAgentHeaderDumbAdminQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a323f80f5c60e01c$var$node.hash = "df656a96c8dae6a7e885b60eda19f0f6";
var $a323f80f5c60e01c$export$2e2bcd8739ae039 = $a323f80f5c60e01c$var$node;

});

parcelRegister("8cRjV", function(module, exports) {
$parcel$export(module.exports, "default", () => $430f456f5213eddb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f799ca9a470356d3f9274384f544dca>>
 * @relayHash 75458db796a70398a51779635b8c2433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 25f1b41bf2ec626b2ef8a3ffd2c0b9de551e7d64a42397225ada96dd8440972e
const $430f456f5213eddb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "containerId",
                        "variableName": "helpCenterAri"
                    }
                ],
                "kind": "ScalarField",
                "name": "virtualAgentAvailability"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        "params": {
            "id": "25f1b41bf2ec626b2ef8a3ffd2c0b9de551e7d64a42397225ada96dd8440972e",
            "metadata": {},
            "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$430f456f5213eddb$var$node.hash = "e1e97ac63a001c8e98b3e9b2c21c9fc4";
var $430f456f5213eddb$export$2e2bcd8739ae039 = $430f456f5213eddb$var$node;

});

parcelRegister("bQ8UI", function(module, exports) {
$parcel$export(module.exports, "ContextWrapper", () => $17d603cf4e419388$export$34282a1f95511a11);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $6uLHU = parcelRequire("6uLHU");

var $ljlVI = parcelRequire("ljlVI");

var $8gu7I = parcelRequire("8gu7I");
const $17d603cf4e419388$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ljlVI)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6uLHU))));
};
const $17d603cf4e419388$export$34282a1f95511a11 = (props)=>{
    const data = $17d603cf4e419388$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8gu7I.default), {
        data: data,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
            children: props.children
        })
    });
};

});

parcelRegister("3zzC4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a513041cada2b661$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $a513041cada2b661$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    virtualServiceAgent: {
        defaultMessage: 'Virtual service agent',
        description: 'Text message for virtual service agent header button',
        id: 'virtual-service-agent-header.virtual-service-agent.title'
    },
    chat: {
        defaultMessage: 'Chat',
        description: 'Text message for chat header button',
        id: 'virtual-service-agent-header.chat.title'
    }
});

});





parcelRegister("hzTaT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a599ae584b8b94e3$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $a599ae584b8b94e3$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    login: {
        defaultMessage: 'Log in',
        description: 'Text message for header in Customer Portal when a user is not logged in',
        id: 'cv.login.title'
    },
    helpCenter: {
        defaultMessage: 'Help Center',
        description: 'Text message for header in Customer Portal when a user is logged in',
        id: 'cv.help.center.title'
    }
});

});





parcelRegister("20jeq", function(module, exports) {
$parcel$export(module.exports, "PrefetchBrandingModel", () => (parcelRequire("2hE7u")).default);

var $2hE7u = parcelRequire("2hE7u");

});
parcelRegister("2hE7u", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd17e893160533fd$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $2gQsf = parcelRequire("2gQsf");

var $9Vr59 = parcelRequire("9Vr59");

var $kkBq4 = parcelRequire("kkBq4");

var $7jGoV = parcelRequire("7jGoV");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $412Rg = parcelRequire("412Rg");
const $dd17e893160533fd$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getHelpCenterBrandingLoader), (0, $hx8zX.isUserLoaded), (isBrandingLoaded, userLoaded)=>({
        isBrandingLoaded: isBrandingLoaded,
        isUserLoaded: userLoaded
    }));
var $dd17e893160533fd$export$2e2bcd8739ae039 = (0, $jvoWT.default)($dd17e893160533fd$var$selector, {
    fetchBranding: (0, $9Vr59.fetchHelpCenterBrandingAction),
    fetchUser: (0, $2gQsf.fetchUserModelAction),
    fetchOrganisations: (0, $kkBq4.fetchOrganisationsModelAction),
    fetchUserRequestsCounts: (0, $7jGoV.fetchUserRequestsCountsAction)
})((0, $412Rg.PrefetchBrandingModel));

});
parcelRegister("412Rg", function(module, exports) {
$parcel$export(module.exports, "PrefetchBrandingModel", () => $77eca3068317bf26$export$f08bae07abcc5a9d);

var $8P7DW = parcelRequire("8P7DW");

var $gk18s = parcelRequire("gk18s");
class $77eca3068317bf26$export$f08bae07abcc5a9d extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    componentDidMount() {
        if (!(0, $gk18s.isHelpCentersManagement)() && !this.props.isBrandingLoaded) this.props.fetchBranding();
        if (!this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchOrganisations();
            this.props.fetchUserRequestsCounts();
        }
    }
    componentDidUpdate(prevProps) {
        // If we haven't loaded the user yet and we've moved from an
        // anonymous route to a normal route, go fetch the user.
        if (!this.props.isUserLoaded && prevProps.isAnonymous && !this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchUserRequestsCounts();
        }
    }
    render() {
        return null;
    }
}

});






parcelRegister("cJncc", function(module, exports) {
$parcel$export(module.exports, "AutoHeightBody", () => $931a11a87010b588$export$9a6247d807712c45);
$parcel$export(module.exports, "StyledFooter", () => $931a11a87010b588$export$61905ae62c7860fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $cS6Xr = parcelRequire("cS6Xr");
parcelRequire("lMBOd");
var $3tfcE = parcelRequire("3tfcE");

var $h89KC = parcelRequire("h89KC");
const $931a11a87010b588$export$9a6247d807712c45 = /*#__PURE__*/ (0, $2UsNA.default)((0, $3tfcE.default)).withConfig({
    componentId: "sc-vv1aut-0"
})`min-height:100%;height:auto !important;position:relative;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $931a11a87010b588$var$stickyBottom = /*#__PURE__*/ (0, $2UsNA.css)`position:absolute;bottom:0;left:50%;transform:translateX(-50%);`;
const $931a11a87010b588$export$61905ae62c7860fb = /*#__PURE__*/ (0, $2UsNA.default)((0, $h89KC.Footer)).withConfig({
    componentId: "sc-vv1aut-1"
})`${(props)=>props.sticky ? $931a11a87010b588$var$stickyBottom : ''};`;
const $931a11a87010b588$export$2598938b3673d496 = /*#__PURE__*/ (0, $2UsNA.default)((0, $cS6Xr.Link)).withConfig({
    componentId: "sc-vv1aut-2"
})`text-decoration:none;&:focus,&:hover,&:visited,&:link,&:active{text-decoration:none;}`;

});

parcelRegister("9qqCD", function(module, exports) {
$parcel$export(module.exports, "default", () => $41760037e1340e0e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8Z0o8 = parcelRequire("8Z0o8");

var $k2Ig6 = parcelRequire("k2Ig6");
const $41760037e1340e0e$var$contentStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $k2Ig6.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $41760037e1340e0e$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        "data-testid": testId,
        css: $41760037e1340e0e$var$contentStyles
    }, children);
};
var $41760037e1340e0e$export$2e2bcd8739ae039 = $41760037e1340e0e$var$Content;

});

parcelRegister("cM8t6", function(module, exports) {
$parcel$export(module.exports, "default", () => $5dbc06af2c8d46d7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $2Mjg8 = parcelRequire("2Mjg8");

var $k2Ig6 = parcelRequire("k2Ig6");

var $kUVRa = parcelRequire("kUVRa");
var $gjBgN = parcelRequire("gjBgN");

var $5gMQ7 = parcelRequire("5gMQ7");
const $5dbc06af2c8d46d7$var$pageLayoutSelector = {
    [(0, $k2Ig6.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $5dbc06af2c8d46d7$var$gridTemplateAreasMobile = `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $k2Ig6.LEFT_PANEL)} ${(0, $k2Ig6.BANNER)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $k2Ig6.LEFT_PANEL)} ${(0, $k2Ig6.TOP_NAVIGATION)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $k2Ig6.LEFT_PANEL)} ${(0, $k2Ig6.CONTENT)}"
 `;
const $5dbc06af2c8d46d7$var$gridTemplateAreas = `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $k2Ig6.LEFT_PANEL)} ${(0, $k2Ig6.BANNER)} ${(0, $k2Ig6.RIGHT_PANEL)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $k2Ig6.LEFT_PANEL)} ${(0, $k2Ig6.TOP_NAVIGATION)} ${(0, $k2Ig6.RIGHT_PANEL)}"
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $k2Ig6.LEFT_PANEL)} ${(0, $k2Ig6.CONTENT)} ${(0, $k2Ig6.RIGHT_PANEL)}"
 `;
const $5dbc06af2c8d46d7$var$gridStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $5dbc06af2c8d46d7$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $k2Ig6.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $k2Ig6.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $k2Ig6.BANNER_HEIGHT)} ${(0, $k2Ig6.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $5dbc06af2c8d46d7$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $2Mjg8.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $5dbc06af2c8d46d7$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $k2Ig6.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $5dbc06af2c8d46d7$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $k2Ig6.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $gjBgN.SkipLinksController), null, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $5gMQ7.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        ...$5dbc06af2c8d46d7$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $5dbc06af2c8d46d7$var$gridStyles,
            $5dbc06af2c8d46d7$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $kUVRa.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $5dbc06af2c8d46d7$export$2e2bcd8739ae039 = $5dbc06af2c8d46d7$var$PageLayout;

});
parcelRegister("kUVRa", function(module, exports) {
$parcel$export(module.exports, "SidebarResizeController", () => $e6db46c62f6a8984$export$850bd1bba41f1448);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $5J6r2 = parcelRequire("5J6r2");

var $jh41u = parcelRequire("jh41u");

var $44mPq = parcelRequire("44mPq");

var $k2Ig6 = parcelRequire("k2Ig6");

var $9toUq = parcelRequire("9toUq");

var $cOX58 = parcelRequire("cOX58");
const $e6db46c62f6a8984$var$handleDataAttributesAndCb = (callback = (0, $5J6r2.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $k2Ig6.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $e6db46c62f6a8984$var$leftSidebarSelector = (0, $9toUq.getPageLayoutSlotCSSSelector)('left-sidebar');
const $e6db46c62f6a8984$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $8P7DW.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $8P7DW.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $8P7DW.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $8P7DW.useRef)(null);
    const mobileMediaQuery = (0, $44mPq.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $8P7DW.useCallback)(()=>{
        var _transition$current2, _transition$current3;
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current;
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $k2Ig6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            (_transition$current = transition.current) === null || _transition$current === void 0 || _transition$current.complete();
            $e6db46c62f6a8984$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        ((_transition$current2 = transition.current) === null || _transition$current2 === void 0 ? void 0 : _transition$current2.action) === 'expand') return;
        // flush existing transition
        (_transition$current3 = transition.current) === null || _transition$current3 === void 0 || _transition$current3.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $k2Ig6.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $e6db46c62f6a8984$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($e6db46c62f6a8984$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $jh41u.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $36kyW.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') {
                    var _transition$current4;
                    (_transition$current4 = transition.current) === null || _transition$current4 === void 0 || _transition$current4.complete();
                }
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $8P7DW.useCallback)((_event, collapseWithoutTransition)=>{
        var _transition$current6, _transition$current7;
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current5;
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $k2Ig6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            (_transition$current5 = transition.current) === null || _transition$current5 === void 0 || _transition$current5.complete();
            $e6db46c62f6a8984$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        ((_transition$current6 = transition.current) === null || _transition$current6 === void 0 ? void 0 : _transition$current6.action) === 'collapse') return;
        // flush existing transition
        (_transition$current7 = transition.current) === null || _transition$current7 === void 0 || _transition$current7.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $k2Ig6.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $k2Ig6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $e6db46c62f6a8984$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($e6db46c62f6a8984$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $jh41u.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $36kyW.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') {
                    var _transition$current8;
                    (_transition$current8 = transition.current) === null || _transition$current8 === void 0 || _transition$current8.complete();
                }
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
   * Conditionally toggle the expanding or collapsing the sidebars.
   * This supports our mobile flyout mode as well.
   */ const toggleLeftSidebar = (0, $8P7DW.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $8P7DW.useEffect)(function mount() {
        return function unmount() {
            var _transition$current9;
            (_transition$current9 = transition.current) === null || _transition$current9 === void 0 || _transition$current9.abort();
        };
    }, []);
    const context = (0, $8P7DW.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: // Technically this isn't quite true, but with mobile it's a bit safer if apps are using this to roll their own collapse/expand
            expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cOX58.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});
parcelRegister("44mPq", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $6cec28a39c43cd2a$export$49e55ae2c03d6045);

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $aXi2w = parcelRequire("aXi2w");

var $2Mjg8 = parcelRequire("2Mjg8");
var $6cec28a39c43cd2a$var$_window, $6cec28a39c43cd2a$var$_window$matchMedia, $6cec28a39c43cd2a$var$_window2, $6cec28a39c43cd2a$var$_window2$matchMedia, $6cec28a39c43cd2a$var$_window3, $6cec28a39c43cd2a$var$_window3$matchMedia, $6cec28a39c43cd2a$var$_window4, $6cec28a39c43cd2a$var$_window4$matchMedia, $6cec28a39c43cd2a$var$_window5, $6cec28a39c43cd2a$var$_window5$matchMedia, $6cec28a39c43cd2a$var$_window6, $6cec28a39c43cd2a$var$_window6$matchMedia, $6cec28a39c43cd2a$var$_window7, $6cec28a39c43cd2a$var$_window7$matchMedia, $6cec28a39c43cd2a$var$_window8, $6cec28a39c43cd2a$var$_window8$matchMedia, $6cec28a39c43cd2a$var$_window9, $6cec28a39c43cd2a$var$_window9$matchMedia, $6cec28a39c43cd2a$var$_window0, $6cec28a39c43cd2a$var$_window0$matchMedia, $6cec28a39c43cd2a$var$_window1, $6cec28a39c43cd2a$var$_window1$matchMedia;
const $6cec28a39c43cd2a$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window = window) === null || $6cec28a39c43cd2a$var$_window === void 0 || ($6cec28a39c43cd2a$var$_window$matchMedia = $6cec28a39c43cd2a$var$_window.matchMedia) === null || $6cec28a39c43cd2a$var$_window$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window$matchMedia.call($6cec28a39c43cd2a$var$_window, (0, $2Mjg8.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window2 = window) === null || $6cec28a39c43cd2a$var$_window2 === void 0 || ($6cec28a39c43cd2a$var$_window2$matchMedia = $6cec28a39c43cd2a$var$_window2.matchMedia) === null || $6cec28a39c43cd2a$var$_window2$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window2$matchMedia.call($6cec28a39c43cd2a$var$_window2, (0, $2Mjg8.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window3 = window) === null || $6cec28a39c43cd2a$var$_window3 === void 0 || ($6cec28a39c43cd2a$var$_window3$matchMedia = $6cec28a39c43cd2a$var$_window3.matchMedia) === null || $6cec28a39c43cd2a$var$_window3$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window3$matchMedia.call($6cec28a39c43cd2a$var$_window3, (0, $2Mjg8.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window4 = window) === null || $6cec28a39c43cd2a$var$_window4 === void 0 || ($6cec28a39c43cd2a$var$_window4$matchMedia = $6cec28a39c43cd2a$var$_window4.matchMedia) === null || $6cec28a39c43cd2a$var$_window4$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window4$matchMedia.call($6cec28a39c43cd2a$var$_window4, (0, $2Mjg8.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window5 = window) === null || $6cec28a39c43cd2a$var$_window5 === void 0 || ($6cec28a39c43cd2a$var$_window5$matchMedia = $6cec28a39c43cd2a$var$_window5.matchMedia) === null || $6cec28a39c43cd2a$var$_window5$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window5$matchMedia.call($6cec28a39c43cd2a$var$_window5, (0, $2Mjg8.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window6 = window) === null || $6cec28a39c43cd2a$var$_window6 === void 0 || ($6cec28a39c43cd2a$var$_window6$matchMedia = $6cec28a39c43cd2a$var$_window6.matchMedia) === null || $6cec28a39c43cd2a$var$_window6$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window6$matchMedia.call($6cec28a39c43cd2a$var$_window6, (0, $2Mjg8.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window7 = window) === null || $6cec28a39c43cd2a$var$_window7 === void 0 || ($6cec28a39c43cd2a$var$_window7$matchMedia = $6cec28a39c43cd2a$var$_window7.matchMedia) === null || $6cec28a39c43cd2a$var$_window7$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window7$matchMedia.call($6cec28a39c43cd2a$var$_window7, (0, $2Mjg8.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window8 = window) === null || $6cec28a39c43cd2a$var$_window8 === void 0 || ($6cec28a39c43cd2a$var$_window8$matchMedia = $6cec28a39c43cd2a$var$_window8.matchMedia) === null || $6cec28a39c43cd2a$var$_window8$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window8$matchMedia.call($6cec28a39c43cd2a$var$_window8, (0, $2Mjg8.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window9 = window) === null || $6cec28a39c43cd2a$var$_window9 === void 0 || ($6cec28a39c43cd2a$var$_window9$matchMedia = $6cec28a39c43cd2a$var$_window9.matchMedia) === null || $6cec28a39c43cd2a$var$_window9$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window9$matchMedia.call($6cec28a39c43cd2a$var$_window9, (0, $2Mjg8.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window0 = window) === null || $6cec28a39c43cd2a$var$_window0 === void 0 || ($6cec28a39c43cd2a$var$_window0$matchMedia = $6cec28a39c43cd2a$var$_window0.matchMedia) === null || $6cec28a39c43cd2a$var$_window0$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window0$matchMedia.call($6cec28a39c43cd2a$var$_window0, (0, $2Mjg8.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($6cec28a39c43cd2a$var$_window1 = window) === null || $6cec28a39c43cd2a$var$_window1 === void 0 || ($6cec28a39c43cd2a$var$_window1$matchMedia = $6cec28a39c43cd2a$var$_window1.matchMedia) === null || $6cec28a39c43cd2a$var$_window1$matchMedia === void 0 ? void 0 : $6cec28a39c43cd2a$var$_window1$matchMedia.call($6cec28a39c43cd2a$var$_window1, (0, $2Mjg8.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $6cec28a39c43cd2a$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $8P7DW.useRef)(listener);
    (0, $8P7DW.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $6cec28a39c43cd2a$var$queries[queryString];
    (0, $aXi2w.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $36kyW.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("aXi2w", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $2b87ddf36f09741e$export$e5c5a5f917a5871c);

var $8P7DW = parcelRequire("8P7DW");
const $2b87ddf36f09741e$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $8P7DW.useEffect) : (0, $8P7DW.useLayoutEffect);

});



parcelRegister("gjBgN", function(module, exports) {
$parcel$export(module.exports, "SkipLinksController", () => $de34d0ffa23313e3$export$da7be99d6a868f3d);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $k2Ig6 = parcelRequire("k2Ig6");

var $43fXs = parcelRequire("43fXs");
const $de34d0ffa23313e3$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $k2Ig6.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
   * If they are tied it is because one (or both) is
   * a custom skiplink with a set index.
   *
   * Give the custom skiplink priority.
   */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $de34d0ffa23313e3$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $8P7DW.useState)([]);
    const registerSkipLink = (0, $8P7DW.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($de34d0ffa23313e3$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $8P7DW.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $43fXs.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("5gMQ7", function(module, exports) {
$parcel$export(module.exports, "SkipLinkWrapper", () => $b134a67fa44e32f2$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8Z0o8 = parcelRequire("8Z0o8");

var $2XLqF = parcelRequire("2XLqF");

var $j1C0s = parcelRequire("j1C0s");
var $jh41u = parcelRequire("jh41u");

var $k2Ig6 = parcelRequire("k2Ig6");

var $43fXs = parcelRequire("43fXs");
function $b134a67fa44e32f2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $b134a67fa44e32f2$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $8Z0o8.css)((0, $jh41u.prefersReducedMotion)());
const $b134a67fa44e32f2$var$skipLinkStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    margin: "var(--ds-space-250, 20px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    border: 'none',
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $j1C0s.easeOut)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $b134a67fa44e32f2$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $b134a67fa44e32f2$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $b134a67fa44e32f2$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $b134a67fa44e32f2$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $b134a67fa44e32f2$var$assignIndex(num + 1, arr);
};
const $b134a67fa44e32f2$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $43fXs.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
            const listIndex = $b134a67fa44e32f2$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $k2Ig6.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!(skipLinksLabel !== null && skipLinksLabel !== void 0 && skipLinksLabel.match(/^\s+$/));
    const label = skipLinksLabel || (0, $k2Ig6.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $b134a67fa44e32f2$var$skipLinkStyles,
            $b134a67fa44e32f2$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $8Z0o8.jsx)("p", {
        css: $b134a67fa44e32f2$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $8Z0o8.jsx)("ol", {
        css: $b134a67fa44e32f2$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $8Z0o8.jsx)($b134a67fa44e32f2$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle))));
};
const $b134a67fa44e32f2$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $b134a67fa44e32f2$var$handleBlur);
};
const $b134a67fa44e32f2$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $b134a67fa44e32f2$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $b134a67fa44e32f2$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("li", {
        css: $b134a67fa44e32f2$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $2XLqF.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $b134a67fa44e32f2$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("eAkv4", function(module, exports) {
$parcel$export(module.exports, "AnnouncementBanner", () => (parcelRequire("l6xVB")).default);

var $l6xVB = parcelRequire("l6xVB");

});
parcelRegister("l6xVB", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ec7f451ab4dbef9$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $2UsNA = parcelRequire("2UsNA");

var $c30HB = parcelRequire("c30HB");

var $HGACo = parcelRequire("HGACo");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
parcelRequire("2tsrb");
var $7IL12 = parcelRequire("7IL12");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("1n2hY");
var $4fSTF = parcelRequire("4fSTF");

var $1EFS8 = parcelRequire("1EFS8");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $4peLG = parcelRequire("4peLG");

var $c8pDc = parcelRequire("c8pDc");
const $2ec7f451ab4dbef9$var$Announcement = ({ announcement: announcement, hasTopBarBeenSplit: hasTopBarBeenSplit, isPortalLoaded: isPortalLoaded, appearance: contentAppearance })=>{
    const [{ route: route }] = (0, $i9cdb.useRouter)();
    const { name: name } = route;
    const whiteListedRouteNames = [
        'portal-home',
        'request-create'
    ];
    const AnnouncementInnerContainerDeprecated = /*#__PURE__*/ (0, $8P7DW.memo)(({ children: children })=>{
        const hide = contentAppearance === 'none';
        const appearance = contentAppearance || 'normal';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c8pDc.GridContentWrapper), {
            appearance: appearance,
            hide: hide
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($2ec7f451ab4dbef9$var$PaperInnerContainer, {
            "data-testid": "paper-inner-container"
        }, children));
    });
    AnnouncementInnerContainerDeprecated.displayName = 'AnnouncementInnerContainer';
    const AnnouncementInnerContainer = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>{
        const Component = ({ children: children })=>{
            const hide = contentAppearance === 'none';
            const appearance = contentAppearance || 'normal';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c8pDc.GridContentWrapper), {
                appearance: appearance,
                hide: hide
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($2ec7f451ab4dbef9$var$PaperInnerContainer, {
                "data-testid": "paper-inner-container"
            }, children));
        };
        Component.displayName = 'AnnouncementInnerContainer';
        return Component;
    }, [
        contentAppearance
    ]);
    if ((0, $HGACo.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, !isPortalLoaded && !announcement && whiteListedRouteNames.includes(name) && (0, $1EFS8.default).checkGate('add_ufo_holds_to_request_create_form') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
        name: "grid-announcement-banner-loading"
    }), !!announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $2ec7f451ab4dbef9$var$announcementContainer,
        testId: 'increased-flexibility-container'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c30HB.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: (0, $1EFS8.default).checkGate('help_center_ttvc_hydration_resolve') ? AnnouncementInnerContainer : AnnouncementInnerContainerDeprecated
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, !isPortalLoaded && !announcement && whiteListedRouteNames.includes(name) && (0, $1EFS8.default).checkGate('add_ufo_holds_to_request_create_form') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
        name: "grid-announcement-banner-loading"
    }), !!announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c30HB.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: (0, $1EFS8.default).checkGate('help_center_ttvc_hydration_resolve') ? AnnouncementInnerContainer : AnnouncementInnerContainerDeprecated
    }));
};
const $2ec7f451ab4dbef9$var$selector = (0, $ehscL.createSelector)((state)=>{
    const portalId = (0, $7IL12.getPortalId)(state);
    const portal = (0, $73V7l.getPortal)(state, portalId);
    const announcement = (0, $73V7l.getPortalAnnouncement)(state, portalId);
    return {
        announcement: announcement,
        isPortalLoaded: Boolean(portal)
    };
}, (0, $ikoP4.getHelpCenterTopBarSplitFlag), ({ announcement: announcement, isPortalLoaded: isPortalLoaded }, hasTopBarBeenSplit)=>{
    return {
        announcement: announcement,
        hasTopBarBeenSplit: hasTopBarBeenSplit,
        isPortalLoaded: isPortalLoaded
    };
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $2ec7f451ab4dbef9$var$PaperInnerContainer = /*#__PURE__*/ (0, $2UsNA.default)((0, $4fSTF.PaperContent)).withConfig({
    componentId: "sc-117mmoe-0"
})({
    paddingTop: 0
});
const $2ec7f451ab4dbef9$var$announcementContainer = (0, $37U6z.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100',
    marginLeft: 'space.400',
    marginRight: 'space.400',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    // make sure extra margin is not added in case announcement is not present
    ':empty': {
        display: 'none'
    }
});
var $2ec7f451ab4dbef9$export$2e2bcd8739ae039 = (0, $jvoWT.default)($2ec7f451ab4dbef9$var$selector)($2ec7f451ab4dbef9$var$Announcement);

});
parcelRegister("c30HB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f09b6660fd69b1e$export$2e2bcd8739ae039);

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $8fI3l = parcelRequire("8fI3l");
var $6f09b6660fd69b1e$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    componentName: 'banner'
})((0, $k7ZVu.default)()((0, $8fI3l.default)));

});
parcelRegister("8fI3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf0510235c64d9ac$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $4cxV2 = parcelRequire("4cxV2");

var $iziiq = parcelRequire("iziiq");

var $hb5oz = parcelRequire("hb5oz");

var $ioEDQ = parcelRequire("ioEDQ");
/**
 * This is used for the clamping logic inside the announcement.
 * It is VERY brittle and WILL break if you change font-size/line-height
 * inside the announcement. Watch out!
 */ const $cf0510235c64d9ac$var$SINGLE_LINE_TITLE_HEIGHT = 23;
/**
 * This component will have big problems if/when we do SSR. Be careful out there.
 */ class $cf0510235c64d9ac$var$AnnouncementBanner extends $8P7DW.Component {
    static #_ = this.defaultProps = {
        InnerContainerComponent: $8P7DW.Fragment
    };
    componentDidMount() {
        // On mount we will calculate the height of the header/message and set isExpandable accordingly.
        // This will only be set once (on mount) - if we eventually want to dynamically update this we
        // will want to implement a componentDidUpdate() method, check if header/message changed, and
        // recalculate.
        this.calculateIfExpandable();
    }
    fireAnalytics(action) {
        const { createAnalyticsEvent: createAnalyticsEvent, actionSubjectId: actionSubjectId } = this.props;
        const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
        if (createAnalyticsEvent) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubjectId: actionSubjectId,
                action: action,
                analyticsType: (0, $iziiq.UI_EVENT_TYPE),
                attributes: {
                    messageCharCount: messageCharCount,
                    titleCharCount: headerCharCount
                }
            });
            analyticsEvent.fire();
        }
    }
    calculateIfExpandable() {
        let isExpandable = false;
        // If advanced customization is enabled and the layout is in edit mode, the banner should not be expandable.
        if (this.props.isLayoutInEditMode) {
            this.setState({
                isExpandable: false,
                isExpanded: true
            });
            return;
        }
        if (this.headerRef || this.messageRef) {
            const headerHeight = this.headerRef && (0, $hb5oz.getBoundingBox)(this.headerRef).height || 0;
            const messageHeight = this.messageRef && (0, $hb5oz.getBoundingBox)(this.messageRef).height || 0;
            const headerOverOneLine = headerHeight > $cf0510235c64d9ac$var$SINGLE_LINE_TITLE_HEIGHT;
            const messageOverOneLine = messageHeight > (0, $4cxV2.SINGLE_LINE_PARAGRAPH_HEIGHT);
            isExpandable = headerOverOneLine || messageOverOneLine;
        }
        // The announcement banner is expanded by default.
        this.setState({
            isExpandable: isExpandable,
            isExpanded: true
        });
    }
    render() {
        const { header: header, messageHtml: messageHtml, InnerContainerComponent: InnerContainerComponent, removeBgColor: removeBgColor, isLayoutInEditMode: isLayoutInEditMode, isLayoutInPreviewMode: isLayoutInPreviewMode, removePadding: removePadding } = this.props;
        const { isExpanded: isExpanded, isExpandable: isExpandable } = this.state;
        return /*#__PURE__*/ $8P7DW.createElement((0, $ioEDQ.default), {
            header: header,
            isExpanded: isExpanded,
            isExpandable: isExpandable,
            messageHtml: messageHtml,
            onHeaderRef: this.onHeaderRef,
            onMessageRef: this.onMessageRef,
            expandBanner: this.expandBanner,
            shrinkBanner: this.collapseBanner,
            InnerContainerComponent: InnerContainerComponent,
            removeBgColor: removeBgColor,
            isCursorGrab: isLayoutInEditMode && isLayoutInPreviewMode === false,
            removePadding: removePadding
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // We expand the announcement banner initially so we can calculate if it is expandable or not on mount.
            isExpanded: true,
            isExpandable: false
        }, this.onHeaderRef = (refNode)=>{
            this.headerRef = refNode;
            this.calculateIfExpandable();
        }, this.onMessageRef = (refNode)=>{
            this.messageRef = refNode;
            this.calculateIfExpandable();
        }, this.expandBanner = ()=>{
            const { onExpandClicked: onExpandClicked } = this.props;
            const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
            onExpandClicked && onExpandClicked(headerCharCount, messageCharCount);
            this.fireAnalytics('expanded');
            this.setState({
                isExpanded: true
            });
        }, this.collapseBanner = ()=>{
            const { onCollapseClicked: onCollapseClicked } = this.props;
            const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
            onCollapseClicked && onCollapseClicked(headerCharCount, messageCharCount);
            this.fireAnalytics('collapsed');
            this.setState({
                isExpanded: false
            });
        }, /**
   * This will return char counts for the header and message. It uses inner text so it can ignore
   * HTML markup in the calculation.
   */ this.getAnnouncementCharCounts = ()=>{
            const headerCharCount = this.headerRef && this.headerRef.innerText ? this.headerRef.innerText.length : undefined;
            const messageCharCount = this.messageRef && this.messageRef.innerText ? this.messageRef.innerText.length : undefined;
            return {
                headerCharCount: headerCharCount,
                messageCharCount: messageCharCount
            };
        };
    }
}
var $cf0510235c64d9ac$export$2e2bcd8739ae039 = $cf0510235c64d9ac$var$AnnouncementBanner;

});
parcelRegister("hb5oz", function(module, exports) {
$parcel$export(module.exports, "getBoundingBox", () => $de3efc89019d02bf$export$895c5e634403eaa7);
$parcel$export(module.exports, "getElementHeight", () => $de3efc89019d02bf$export$8e0f1520ce23a388);
$parcel$export(module.exports, "blur", () => $de3efc89019d02bf$export$2cc7ff91bcacba5e);
$parcel$export(module.exports, "focus", () => $de3efc89019d02bf$export$d7ddd398f22d79ef);
const $de3efc89019d02bf$export$895c5e634403eaa7 = (element)=>element.getBoundingClientRect();
const $de3efc89019d02bf$export$8e0f1520ce23a388 = (element)=>element.clientHeight;
function $de3efc89019d02bf$export$2cc7ff91bcacba5e(id) {
    const element = document.getElementById(id);
    if (element) element.blur();
}
function $de3efc89019d02bf$export$d7ddd398f22d79ef(id) {
    const element = document.getElementById(id);
    if (element) element.focus();
}

});

parcelRegister("ioEDQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $659a7c47b573b9eb$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $2Doj8 = parcelRequire("2Doj8");

var $1p41U = parcelRequire("1p41U");

var $kBzhX = parcelRequire("kBzhX");

var $6t2I3 = parcelRequire("6t2I3");

var $b60z8 = parcelRequire("b60z8");

var $l4a5B = parcelRequire("l4a5B");

var $cDQfx = parcelRequire("cDQfx");

var $2aUM6 = parcelRequire("2aUM6");

var $g90EH = parcelRequire("g90EH");
class $659a7c47b573b9eb$export$76695f5f5a9db4b2 extends $8P7DW.Component {
    renderChevrons() {
        const { isExpandable: isExpandable, isExpanded: isExpanded, intl: intl } = this.props;
        if (isExpandable) return /*#__PURE__*/ $8P7DW.createElement($659a7c47b573b9eb$export$281662cd1c27e560, {
            type: "button",
            "aria-expanded": isExpanded,
            "aria-controls": "announcement-message",
            "aria-label": intl.formatMessage((0, $g90EH.default).view),
            onClick: this.handleClick,
            "data-testid": "view-announcement-btn"
        }, isExpanded ? /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2aUM6))), {
            size: "small",
            spacing: "spacious",
            testId: "chevronUpIcon",
            label: ""
        }) : /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
            size: "small",
            spacing: "spacious",
            testId: "chevronDownIcon",
            label: ""
        }));
        return null;
    }
    render() {
        const { isExpanded: isExpanded, header: header, messageHtml: messageHtml, onMessageRef: onMessageRef, onHeaderRef: onHeaderRef, className: className, InnerContainerComponent: InnerContainerComponent, removeBgColor: removeBgColor, isCursorGrab: isCursorGrab, removePadding: removePadding } = this.props;
        const rootProps = {
            role: 'region',
            'aria-labelledby': 'announcement-header',
            skipFocus: true
        };
        if (!!header || !!messageHtml) return /*#__PURE__*/ $8P7DW.createElement($659a7c47b573b9eb$export$be92b6f5f03c0fe9, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            removeBgColor: removeBgColor,
            isExpanded: isExpanded,
            isCursorGrab: isCursorGrab,
            ...rootProps
        }, /*#__PURE__*/ $8P7DW.createElement(InnerContainerComponent, null, /*#__PURE__*/ $8P7DW.createElement($659a7c47b573b9eb$var$Container, {
            removePadding: removePadding
        }, /*#__PURE__*/ $8P7DW.createElement($659a7c47b573b9eb$export$758c5636f09cf302, {
            onClick: this.stopPropagationForLinks,
            onKeyDown: this.stopPropagationForLinks
        }, header && /*#__PURE__*/ $8P7DW.createElement($659a7c47b573b9eb$export$f99233281efd08a0, {
            id: "announcement-header",
            "data-testid": "announcement-banner-header",
            innerRef: onHeaderRef,
            isExpanded: isExpanded
        }, header), messageHtml && /*#__PURE__*/ $8P7DW.createElement($659a7c47b573b9eb$export$f69c19e57285b83a, {
            id: "announcement-message",
            innerRef: onMessageRef,
            isExpanded: isExpanded,
            dangerouslySetInnerHTML: {
                __html: messageHtml
            }
        })), this.renderChevrons())));
        return null;
    }
    constructor(...args){
        super(...args), this.handleClick = ()=>{
            const { isExpanded: isExpanded, shrinkBanner: shrinkBanner, expandBanner: expandBanner } = this.props;
            isExpanded ? shrinkBanner() : expandBanner();
        }, /**
   * This will stop propagation for any anchor element clicked or key pressed.
   * If we see a need for this elsewhere - this could be a good generic component with minimal lines
   * of code.
   */ this.stopPropagationForLinks = (e)=>{
            const target = e.target;
            if (target.tagName === 'A') e.stopPropagation();
        };
    }
}
var $659a7c47b573b9eb$export$2e2bcd8739ae039 = (0, $l4a5B.default)($659a7c47b573b9eb$export$76695f5f5a9db4b2);
/**
 * Watch out! Changing anything that will affect height (fontsize, padding, etc) in here will
 * break the clamping logic inside announcement-banner.tsx (look for SINGLE_LINE_TITLE_HEIGHT).
 * If you change anything here make sure it still works!
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $659a7c47b573b9eb$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-sxf8hv-0"
})`display:flex;justify-content:space-between;padding-top:${(props)=>props.removePadding ? 'initial' : "var(--ds-space-300, 24px)"};padding-bottom:${(props)=>props.removePadding ? 'initial' : "var(--ds-space-300, 24px)"};`;
const $659a7c47b573b9eb$export$f2e4196c0d2b5bb8 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-sxf8hv-1"
})`flex-shrink:0;${$1p41U.fromSmall.css`
        /* Apply margin from mobile, when on a small viewport we want a bit of padding between the right edge and the icon. */
        margin-left: ${"var(--ds-space-100, 8px)"};
    `};svg{transition:background-color ${$b60z8.speedMs.fast}ms ${$b60z8.timingFunctions.easeInOut},${$b60z8.speedMs.fast}ms ${$b60z8.timingFunctions.easeInOut};border-radius:50%;}`;
const $659a7c47b573b9eb$export$281662cd1c27e560 = /*#__PURE__*/ (0, $2UsNA.default).button.withConfig({
    componentId: "sc-sxf8hv-2"
})`flex-shrink:0;border:none;background:transparent;align-self:flex-start;cursor:pointer;${$1p41U.fromSmall.css`
        /* Apply margin from mobile, when on a small viewport we want a bit of padding between the right edge and the icon. */
        margin-left: ${"var(--ds-space-100, 8px)"};
    `};svg{transition:background-color ${$b60z8.speedMs.fast}ms ${$b60z8.timingFunctions.easeInOut},${$b60z8.speedMs.fast}ms ${$b60z8.timingFunctions.easeInOut};border-radius:50%;}&:focus-visible,&:hover{svg{background-color:${"var(--ds-background-input, #172B4D)"};color:${"var(--ds-text-inverse, #FFFFFF)"};opacity:0.7;}}`;
const $659a7c47b573b9eb$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $2UsNA.default)((0, $2Doj8.default)).withConfig({
    componentId: "sc-sxf8hv-3"
})`${$6t2I3.borderRadius};${(props)=>$6t2I3.applyIf(!props.removeBgColor, $6t2I3.subtleThemeColorBackground)};${$kBzhX.regular};display:block;width:100%;text-align:left;transition:color ${$b60z8.speedMs.fast}ms ${$b60z8.timingFunctions.easeInOut};color:${"var(--ds-text, #172B4D)"};box-sizing:border-box;overflow:hidden;&:focus-visible,&:hover ${$659a7c47b573b9eb$export$f2e4196c0d2b5bb8}{svg{background-color:${"var(--ds-background-input, #172B4D)"};color:${"var(--ds-text-inverse, #FFFFFF)"};opacity:0.7;}}`;
const $659a7c47b573b9eb$export$f99233281efd08a0 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-sxf8hv-4"
})`${$kBzhX.medium};${(props)=>$6t2I3.applyIf(!props.isExpanded, $6t2I3.clamp)};margin-bottom:${"var(--ds-space-100, 8px)"};font-weight:600;`;
const $659a7c47b573b9eb$export$f69c19e57285b83a = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-sxf8hv-5"
})`${(props)=>$6t2I3.applyIf(!props.isExpanded, $6t2I3.multiLineClamp(1))}`;
const $659a7c47b573b9eb$export$758c5636f09cf302 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-sxf8hv-6"
})`display:flex;flex-direction:column;width:100%;overflow:hidden;flex-shrink:0;`;

});
parcelRegister("2Doj8", function(module, exports) {
$parcel$export(module.exports, "default", () => $65f4a55b5628d213$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $4UgGL = parcelRequire("4UgGL");
class $65f4a55b5628d213$export$2e2bcd8739ae039 extends $8P7DW.Component {
    render() {
        const { children: children, disabled: disabled, isExpanded: isExpanded, isCursorGrab: isCursorGrab, role: role, skipFocus: skipFocus, className: className = '' } = this.props;
        const skipFocusStyle = skipFocus ? ' no-focus' : '';
        const fakeBtnClassName = className + skipFocusStyle;
        return /*#__PURE__*/ $8P7DW.createElement((0, $4UgGL.default), {
            "data-testid": "fake-button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: fakeBtnClassName,
            role: role || 'button',
            tabIndex: disabled || skipFocus ? -1 : 0,
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            "aria-disabled": disabled,
            "aria-hidden": disabled,
            "aria-expanded": isExpanded ? true : false,
            isCursorGrab: isCursorGrab
        }, children);
    }
    constructor(...args){
        super(...args), this.stopPropagationForLinks = (e)=>{
            const target = e.target;
            if (target.tagName === 'A') {
                e.stopPropagation();
                return true;
            }
            return false;
        }, this.handleKeyDown = (e)=>{
            const { onClick: onClick } = this.props;
            if (this.stopPropagationForLinks(e)) return;
            if (e.key === 'Enter') onClick && onClick(e);
            else if (e.key === ' ') // Prevent default so scrolling doesn't happen when we press spacebar.
            e.preventDefault();
        }, this.handleClick = (e)=>{
            if (this.stopPropagationForLinks(e)) return;
            this.props.onClick && this.props.onClick(e);
        }, this.handleKeyUp = (e)=>{
            const { onClick: onClick } = this.props;
            if (this.stopPropagationForLinks(e)) return;
            if (e.key === ' ') onClick && onClick(e);
        };
    }
}

});
parcelRegister("4UgGL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f328ddfd6dc61466$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $6t2I3 = parcelRequire("6t2I3");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f328ddfd6dc61466$var$FakeButtonContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1kveg5f-0"
})`${$6t2I3.focusRing.default};display:inline-block;${(props)=>props.skipFocus ? 'cursor: default' : 'cursor: pointer'};&.no-focus,&[aria-disabled='true']{${$6t2I3.focusRing.none};${(props)=>props.isCursorGrab ? 'cursor: grab' : 'cursor: default'};}`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$f328ddfd6dc61466$export$2e2bcd8739ae039 = $f328ddfd6dc61466$var$FakeButtonContainer;

});


parcelRegister("g90EH", function(module, exports) {
$parcel$export(module.exports, "default", () => $89de7d0c2fb2e561$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $89de7d0c2fb2e561$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    expand: {
        defaultMessage: 'Expand announcement',
        description: 'Label for shrinking the announcement.',
        id: 'sd.common.announcement.expand'
    },
    shrink: {
        defaultMessage: 'Shrink announcement',
        description: 'Label for shrinking the announcement.',
        id: 'sd.common.announcement.shrink'
    },
    view: {
        defaultMessage: 'View announcement',
        description: 'Label for viewing the announcement.',
        id: 'sd.common.announcement.view'
    }
});

});




parcelRegister("c8pDc", function(module, exports) {
$parcel$export(module.exports, "SkipToMainContent", () => $0860ef4b2efaf987$export$5a2051bae734c99d);
$parcel$export(module.exports, "GridContentWrapper", () => $0860ef4b2efaf987$export$2e1fb94eeb76eca0);
$parcel$export(module.exports, "default", () => $0860ef4b2efaf987$export$2e2bcd8739ae039);
/* grid-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $37U6z = parcelRequire("37U6z");
parcelRequire("gp4SE");
var $jQ8lB = parcelRequire("jQ8lB");

var $4fSTF = parcelRequire("4fSTF");

var $1DBYk = parcelRequire("1DBYk");
const $0860ef4b2efaf987$export$5a2051bae734c99d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jQ8lB.MainContentSkipLinkWrapper), null, (0, $e6Qdr.fg)('do_not_use_banner_colour_for_hyperlinks') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        testId: "skip-to-main-content",
        xcss: $0860ef4b2efaf987$var$mainContentSkipLinkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        className: (0, $8n1kL.default)([
            "_43ds1ohs _oxk41ohs"
        ])
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        testId: "skip-to-main-content",
        xcss: $0860ef4b2efaf987$var$mainContentSkipLinkStyles
    }, children));
const $0860ef4b2efaf987$export$2e1fb94eeb76eca0 = ({ children: children, appearance: appearance, hide: hide })=>{
    const gridWidth = (0, $1DBYk.getContentWidth)(appearance);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        testId: "grid-content-wrapper",
        xcss: $0860ef4b2efaf987$var$staticWrapperStyles,
        style: {
            maxWidth: hide ? '100%' : gridWidth
        }
    }, children);
};
const $0860ef4b2efaf987$var$GridContainer = ({ children: children, isCSM: isCSM, hideSkipToMainContent: hideSkipToMainContent, appearance: contentAppearance })=>{
    const hide = contentAppearance === 'none';
    const appearance = contentAppearance || 'normal';
    if (appearance === 'note') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $0860ef4b2efaf987$var$noteContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4fSTF.NoteContent), {
        appearance: appearance,
        hide: hide,
        "data-testid": "note-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4fSTF.NoteBackground), {
        "data-testid": "note-background"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4fSTF.StyledFooter), null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        as: "section",
        xcss: $0860ef4b2efaf987$var$sectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($0860ef4b2efaf987$export$2e1fb94eeb76eca0, {
        appearance: appearance,
        hide: hide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        xcss: $0860ef4b2efaf987$var$gridContainerStyles,
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        xcss: $0860ef4b2efaf987$var$gridItemStyles
    }, hideSkipToMainContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4fSTF.StyledFooter), {
        isCSM: isCSM
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($0860ef4b2efaf987$export$5a2051bae734c99d, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4fSTF.StyledFooter), {
        isCSM: isCSM
    }))))));
};
const $0860ef4b2efaf987$var$wrapperStyles = null;
const $0860ef4b2efaf987$var$sectionStyles = (0, $37U6z.xcss)({
    flex: 1
});
const $0860ef4b2efaf987$var$staticWrapperStyles = (0, $37U6z.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    margin: '0 auto'
});
const $0860ef4b2efaf987$var$gridContainerStyles = (0, $37U6z.xcss)({
    flex: 1,
    gridTemplateColumns: 'repeat(12, 1fr)'
});
const $0860ef4b2efaf987$var$gridItemStyles = (0, $37U6z.xcss)({
    gridColumn: 'span 12'
});
const $0860ef4b2efaf987$var$mainContentSkipLinkStyles = (0, $37U6z.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
const $0860ef4b2efaf987$var$noteContainerStyles = (0, $37U6z.xcss)({
    position: 'relative',
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
});
var $0860ef4b2efaf987$export$2e2bcd8739ae039 = $0860ef4b2efaf987$var$GridContainer;

});
parcelRegister("1DBYk", function(module, exports) {
$parcel$export(module.exports, "getContentWidth", () => $2c258e93e6d062d4$export$f61abf052f87399f);
// 800px is normal width
const $2c258e93e6d062d4$var$GRID_NORMAL_WIDTH = '800px';
// 1000px is wide width
const $2c258e93e6d062d4$var$GRID_WIDE_WIDTH = '1000px';
// 1100px is extra wide width
const $2c258e93e6d062d4$var$GRID_XWIDE_WIDTH = '1100px';
// 1200px is extra wide width
const $2c258e93e6d062d4$var$GRID_XXWIDE_WIDTH = '1200px';
const $2c258e93e6d062d4$var$GRID_NOTE_WIDTH = '480px';
const $2c258e93e6d062d4$export$f61abf052f87399f = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $2c258e93e6d062d4$var$GRID_XXWIDE_WIDTH;
        case 'xwide':
            return $2c258e93e6d062d4$var$GRID_XWIDE_WIDTH;
        case 'wide':
            return $2c258e93e6d062d4$var$GRID_WIDE_WIDTH;
        case 'note':
            return $2c258e93e6d062d4$var$GRID_NOTE_WIDTH;
        default:
            return $2c258e93e6d062d4$var$GRID_NORMAL_WIDTH;
    }
};

});




parcelRegister("cyQYS", function(module, exports) {
$parcel$export(module.exports, "GridContainer", () => (parcelRequire("c8pDc")).default);
$parcel$export(module.exports, "SkipToMainContent", () => (parcelRequire("c8pDc")).SkipToMainContent);

var $c8pDc = parcelRequire("c8pDc");

});



parcelRegister("dMDto", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutDumb", () => (parcelRequire("eOHXx")).default);

var $eOHXx = parcelRequire("eOHXx");

});
parcelRegister("eOHXx", function(module, exports) {
$parcel$export(module.exports, "default", () => $93020a761d2e0e99$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $4O8fD = parcelRequire("4O8fD");

var $3xuD5 = parcelRequire("3xuD5");
parcelRequire("lMBOd");
var $3tfcE = parcelRequire("3tfcE");
parcelRequire("1Sfks");
var $17mEh = parcelRequire("17mEh");
parcelRequire("hGzcq");
var $lNFkx = parcelRequire("lNFkx");

var $aw7IH = parcelRequire("aw7IH");
parcelRequire("hFv0W");
var $gnTu9 = parcelRequire("gnTu9");
parcelRequire("1n2hY");
var $69uY5 = parcelRequire("69uY5");
parcelRequire("20jeq");
var $2hE7u = parcelRequire("2hE7u");

var $cJncc = parcelRequire("cJncc");

var $9qqCD = parcelRequire("9qqCD");
var $cM8t6 = parcelRequire("cM8t6");

var $4peLG = parcelRequire("4peLG");

var $gk18s = parcelRequire("gk18s");
const $93020a761d2e0e99$var$PageLayoutContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cM8t6.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9qqCD.default), null, children));
/**
 * Paper in this context is the floating paper that is ontop of the banner.
 * Banner will have the background image chosen by the admin as well as the
 * theme color as background color.
 */ const $93020a761d2e0e99$var$BannerWithPaperLayoutDumb = ({ children: children, paperAppearance: paperAppearance, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, path: path, searchShown: searchShown, isBrandingLoaded: isBrandingLoaded, prefetchBrandingModel: prefetchBrandingModel, hideBanner: hideBanner, isCSM: isCSM })=>{
    const showBannerWithLoader = ()=>{
        if (isBrandingLoaded) return !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($93020a761d2e0e99$var$Banner, {
            imageSrc: helpCenterBanner
        });
        return !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($93020a761d2e0e99$var$LoadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4O8fD.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: (0, $aw7IH.BANNER_HEIGHT).unitless,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($93020a761d2e0e99$var$PageLayoutContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($93020a761d2e0e99$var$SidebarPusherRoot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($93020a761d2e0e99$export$36525627ce333d44, {
        flipKey: searchShown,
        portalKey: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($93020a761d2e0e99$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3tfcE.default), {
        className: "px-paper-layout"
    }), (0, $gk18s.isKoshEnabledForDefaultHelpCenter)() ? showBannerWithLoader() : !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($93020a761d2e0e99$var$Banner, {
        imageSrc: helpCenterBanner
    }), prefetchBrandingModel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2hE7u.default), {
        isAnonymous: isAnonymous
    }) : null, !removeHeader && !headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gnTu9.default), {
        isAnonymous: isAnonymous,
        logoTextColor: "banner",
        hideSearchButton: hideSearchButton,
        showThemedBackground: false,
        isModelCallPrefetched: prefetchBrandingModel
    }), !removeHeader && headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($93020a761d2e0e99$var$EmptyHeader, {
        "data-testid": "empty-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($93020a761d2e0e99$var$PaperContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $69uY5.default), {
        appearance: paperAppearance,
        pageKey: path,
        isCSM: isCSM
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cJncc.AutoHeightBody), null)))));
};
var $93020a761d2e0e99$export$2e2bcd8739ae039 = $93020a761d2e0e99$var$BannerWithPaperLayoutDumb;
const $93020a761d2e0e99$var$CONTAINER_MIN_HEIGHT = '100vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $93020a761d2e0e99$var$SidebarPusherRoot = /*#__PURE__*/ (0, $2UsNA.default)((0, $lNFkx.default)).withConfig({
    componentId: "sc-ku2ur3-0"
})`display:flex;flex-direction:column;width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $93020a761d2e0e99$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ku2ur3-1"
})`position:relative;overflow-x:hidden;display:flex;flex-direction:column;min-height:${$93020a761d2e0e99$var$CONTAINER_MIN_HEIGHT};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $93020a761d2e0e99$var$PaperContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ku2ur3-2"
})`position:relative;display:flex;flex:1 1 auto;overflow:hidden;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $93020a761d2e0e99$var$Banner = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ku2ur3-3"
})`position:absolute;top:0;left:0;right:0;height:${(0, $aw7IH.BANNER_HEIGHT).px};z-index:${$3xuD5.banner};background-color:${(props)=>`var(--ds-background-brand-bold, ${props.theme.color})`};background-image:${(props)=>!!props.imageSrc ? `url(${props.imageSrc})` : 'none'};background-size:cover;background-repeat:no-repeat;background-position:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $93020a761d2e0e99$var$LoadingContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ku2ur3-4"
})`position:absolute;top:0;left:0;right:0;height:${(0, $aw7IH.BANNER_HEIGHT).px};z-index:${$3xuD5.banner};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $93020a761d2e0e99$var$EmptyHeader = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ku2ur3-5"
})`height:${(0, $aw7IH.HEADER_HEIGHT)}px;width:100%;`;
const $93020a761d2e0e99$export$36525627ce333d44 = /*#__PURE__*/ (0, $2UsNA.default)((0, $17mEh.Flipper)).withConfig({
    componentId: "sc-ku2ur3-6"
})`display:flex;flex-direction:column;`;

});


parcelRegister("ebTjc", function(module, exports) {
$parcel$export(module.exports, "withLayoutRoute", () => (parcelRequire("datZD")).default);

var $datZD = parcelRequire("datZD");

});
parcelRegister("datZD", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f80a42150f3e125$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $hWt0u = parcelRequire("hWt0u");

var $h1yZX = parcelRequire("h1yZX");
parcelRequire("9wocP");
var $21W2d = parcelRequire("21W2d");
parcelRequire("8nQ9l");
var $6aykf = parcelRequire("6aykf");

var $9vFpu = parcelRequire("9vFpu");

var $g2qf8 = parcelRequire("g2qf8");
parcelRequire("9i6OK");
var $3szzY = parcelRequire("3szzY");
parcelRequire("lqgOy");
var $8UFeG = parcelRequire("8UFeG");
/**
 * This will return a component which will pass the Layout and children into a <Route />.
 * It will capture all path params and set them into redux, as well as providing them to withPathParams() higher order component.
 * @param Layout Layout component we're wrapping.
 */ function $6f80a42150f3e125$var$withLayoutRoute(Layout) {
    return class LayoutRoute extends $8P7DW.Component {
        render() {
            const LayoutWithChildren = this.LayoutWithChildren;
            return /*#__PURE__*/ $8P7DW.createElement((0, $21W2d.RouterSubscriber), null, (routerState)=>{
                return /*#__PURE__*/ $8P7DW.createElement(LayoutWithChildren, routerState);
            });
        }
        constructor(...args){
            super(...args), // Create an instance Component to pass down react router props to ChildrenComponent as well block
            // any extraneous rendering from query params updating.
            this.LayoutWithChildren = (0, $8UFeG.default)((innerRouteProps)=>{
                const { renderError: renderError, layoutProps: layoutProps, path: path, isFooterHidden: isFooterHidden, screenName: screenName, component: ChildrenComponent } = this.props;
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const query = $h1yZX.parse(innerRouteProps.location.search);
                const component = /*#__PURE__*/ $8P7DW.createElement((0, $hWt0u.PathParamsProvider), {
                    params: innerRouteProps.match.params
                }, /*#__PURE__*/ $8P7DW.createElement((0, $9vFpu.OnboardingProvider), {
                    query: query
                }, /*#__PURE__*/ $8P7DW.createElement(Layout, {
                    ...layoutProps,
                    path: path,
                    isFooterHidden: isFooterHidden
                }, /*#__PURE__*/ $8P7DW.createElement((0, $3szzY.default), {
                    screenName: screenName,
                    renderError: renderError
                }, /*#__PURE__*/ $8P7DW.createElement(ChildrenComponent, innerRouteProps)))), /*#__PURE__*/ $8P7DW.createElement((0, $6aykf.default), innerRouteProps));
                return screenName ? /*#__PURE__*/ $8P7DW.createElement((0, $g2qf8.default), {
                    screenName: screenName,
                    screenId: innerRouteProps.match.url
                }, component) : component;
            }, ()=>this.props.reRenderOnQueryParameterChanges || []);
        }
    };
}
var $6f80a42150f3e125$export$2e2bcd8739ae039 = $6f80a42150f3e125$var$withLayoutRoute;

});
parcelRegister("8nQ9l", function(module, exports) {
$parcel$export(module.exports, "ContextSetter", () => (parcelRequire("6aykf")).default);

var $6aykf = parcelRequire("6aykf");

});
parcelRegister("6aykf", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c01e85561a02523$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");
parcelRequire("5bAQY");
var $8Z7Xs = parcelRequire("8Z7Xs");
class $8c01e85561a02523$export$28f8b4e4081c59b0 extends $8P7DW.Component {
    updateContextAction(props) {
        const { location: location, match: match, route: route } = props;
        const pathParams = match && match.params || {};
        const pathname = location && location.pathname;
        const routeName = route.name;
        props.updateContextAction({
            pathParams: pathParams,
            pathname: pathname,
            routeName: routeName
        });
    }
    // eslint-disable-next-line react/no-deprecated
    componentWillUpdate(nextProps) {
        this.updateContextAction(nextProps);
    }
    // We use componentDidMount (instead of componentWillMount) here because we need the mount method to be
    // called after all the previous ContextSetters have been unmounted.
    componentDidMount() {
        this.updateContextAction(this.props);
    }
    componentWillUnmount() {
        this.props.clearContextAction();
    }
    render() {
        return null;
    }
}
var $8c01e85561a02523$export$2e2bcd8739ae039 = (0, $jvoWT.default)(null, {
    updateContextAction: $8Z7Xs.updateContextAction,
    clearContextAction: $8Z7Xs.clearContextAction
})($8c01e85561a02523$export$28f8b4e4081c59b0);

});


parcelRegister("9vFpu", function(module, exports) {
$parcel$export(module.exports, "OnboardingProvider", () => $e69810cc64209a8f$export$54ba648a75d332de);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $hWt0u = parcelRequire("hWt0u");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $vYPX4 = parcelRequire("vYPX4");

var $4oCHg = parcelRequire("4oCHg");
const $e69810cc64209a8f$var$mapStateToProps = (state, props)=>({
        projectId: (0, $73V7l.getProjectId)(state, (0, $vYPX4.toNumber)(props.portalId)),
        showRequestTypeOnboarding: (0, $73V7l.getCanAdministerProject)(state, (0, $vYPX4.toNumber)(props.portalId))
    });
const $e69810cc64209a8f$export$54ba648a75d332de = (0, $hWt0u.default)((0, $jvoWT.default)($e69810cc64209a8f$var$mapStateToProps)((0, $4oCHg.default)));

});
parcelRegister("4oCHg", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d90fb91397d53f3$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $bfWbh = parcelRequire("bfWbh");
const $7d90fb91397d53f3$export$19b38316c9e7b045 = /*#__PURE__*/ $8P7DW.createContext({
    isLoading: true,
    isRequestCreated: false,
    isDemoProject: false
});
const $7d90fb91397d53f3$export$87a388960a322f14 = $7d90fb91397d53f3$export$19b38316c9e7b045.Consumer;
class $7d90fb91397d53f3$export$2e2bcd8739ae039 extends $8P7DW.Component {
    async componentDidMount() {
        await this.fetchOnboarding();
    }
    async componentDidUpdate(prevProps) {
        const projectIdChanged = prevProps.projectId !== this.props.projectId;
        if (projectIdChanged) await this.fetchOnboarding();
    }
    render() {
        const { children: children, query: query } = this.props;
        const { isLoading: isLoading, isDemoProject: isDemoProject } = this.state;
        const isRequestCreated = !!query.created;
        return /*#__PURE__*/ $8P7DW.createElement($7d90fb91397d53f3$export$19b38316c9e7b045.Provider, {
            value: {
                isLoading: isLoading,
                isDemoProject: isDemoProject,
                isRequestCreated: isRequestCreated
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isLoading: true,
            isDemoProject: false
        }, /**
   * fetchOnboarding()
   * This method should fetch all onboarding and then set the results appropriately.
   * Remember: Only one onboarding should be shown at a time.
   */ this.fetchOnboarding = async ()=>{
            // Extend this later to fetch all onboarding sources.
            const { projectId: projectId, showRequestTypeOnboarding: showRequestTypeOnboarding } = this.props;
            if (!projectId) return;
            let newState = {};
            if (showRequestTypeOnboarding) {
                const isDemoProject = await (0, $bfWbh.getIsDemoProject)(projectId);
                newState = {
                    ...newState,
                    isDemoProject: isDemoProject,
                    isLoading: false
                };
            }
            this.setState(newState);
        };
    }
}

});
parcelRegister("bfWbh", function(module, exports) {
$parcel$export(module.exports, "getIsDemoProject", () => $b01dee53c88f75b6$export$2156daeb7d24c1fc);

var $breWd = parcelRequire("breWd");

var $fSYYZ = parcelRequire("fSYYZ");

var $7FSs7 = parcelRequire("7FSs7");
const $b01dee53c88f75b6$export$2156daeb7d24c1fc = (projectId)=>{
    const uri = `${(0, $7FSs7.contextPath)}/rest/internal/latest/frontendconfig/properties?projectId=${projectId}&project=isDemo`;
    return (0, $breWd.get)(uri).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (ajaxResponse.response && ajaxResponse.response.project) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return !!ajaxResponse.response.project.isDemo;
        return false;
    }).catch(()=>(0, $fSYYZ.Observable).of(false)).toPromise();
};

});



parcelRegister("lqgOy", function(module, exports) {
$parcel$export(module.exports, "withIgnoreQueryParamUpdates", () => (parcelRequire("8UFeG")).default);

var $8UFeG = parcelRequire("8UFeG");

});
parcelRegister("8UFeG", function(module, exports) {
$parcel$export(module.exports, "default", () => $50e63a7875db5b3b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $1We2B = parcelRequire("1We2B");

var $h1yZX = parcelRequire("h1yZX");
/**
 * Higher order component which implements a shouldComponentUpdate() to block re-rendering if only the query
 * param updated from the react router props.
 * @param renderChild Render function that will return JSX.
 * @param whiteListedQueryParametersSupplier
 */ const $50e63a7875db5b3b$var$withIgnoreQueryParamUpdates = (renderChild, whiteListedQueryParametersSupplier)=>{
    return class GeneratedLayout extends $8P7DW.Component {
        areWhiteListedQueryParametersDifferent(search, nextSearch) {
            const whiteListedQueryParameters = whiteListedQueryParametersSupplier();
            if (whiteListedQueryParameters.length > 0) {
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedSearch = $h1yZX.parse(search);
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedNextSearch = $h1yZX.parse(nextSearch);
                let i = 0;
                for(i; i < whiteListedQueryParameters.length; i++){
                    const whiteListedProp = whiteListedQueryParameters[i];
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const value = parsedSearch[whiteListedProp];
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const nextValue = parsedNextSearch[whiteListedProp];
                    if (value !== nextValue) return true;
                }
            }
            return false;
        }
        shouldComponentUpdate(nextProps) {
            const { location: location, ...remainingProps } = this.props;
            const { location: nextLocation, ...remainingNextProps } = nextProps;
            const nonQueryLocationChanged = GeneratedLayout.hasNonQueryLocationChanged(location, nextLocation);
            if (nonQueryLocationChanged) return true;
            if (!(0, $1We2B.isEqual)(remainingProps, remainingNextProps)) return true;
            return this.areWhiteListedQueryParametersDifferent(location.search, nextLocation.search);
        }
        static hasNonQueryLocationChanged(location, nextLocation) {
            const { search: search, ...remainingLocationProps } = location;
            const { search: nextSearch, ...remainingNextLocationProps } = nextLocation;
            // If any props other than query parameter changed then we will update
            return !(0, $1We2B.isEqual)(remainingLocationProps, remainingNextLocationProps);
        }
        render() {
            return renderChild(this.props);
        }
    };
};
var $50e63a7875db5b3b$export$2e2bcd8739ae039 = $50e63a7875db5b3b$var$withIgnoreQueryParamUpdates;

});







parcelRegister("90Qb9", function(module, exports) {
$parcel$export(module.exports, "UiModificationsContainer", () => $7abae2ec001c55db$export$1834060b93715de7);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $94fTc = parcelRequire("94fTc");

var $9Qkcz = parcelRequire("9Qkcz");

var $93HXx = parcelRequire("93HXx");
const $7abae2ec001c55db$export$1834060b93715de7 = ({ children: children })=>{
    return (0, $HGACo.isUiModificationsSupportEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $94fTc.BaseUiModificationsContainer), {
        scope: (0, $9Qkcz.REQUEST_CREATE_VIEW_TYPE),
        viewType: (0, $9Qkcz.REQUEST_CREATE_VIEW_TYPE),
        viewConfiguration: (0, $93HXx.RequestCreateViewConfiguration)
    }, children) : children;
};

});
parcelRegister("94fTc", function(module, exports) {
$parcel$export(module.exports, "BaseUiModificationsContainer", () => $3f4dad57954176fc$export$8b7a045f60eb9797);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $2t9fp = parcelRequire("2t9fp");

var $fsioz = parcelRequire("fsioz");

var $ck2Cv = parcelRequire("ck2Cv");
const $3f4dad57954176fc$export$8b7a045f60eb9797 = ({ children: children, scope: scope, viewType: viewType, viewConfiguration: viewConfiguration })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    (0, $ck2Cv.useLoadViewConfiguration)(viewType, viewConfiguration);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fsioz.LoadedUiModificationsContainer), {
        scope: scope,
        viewType: viewType,
        createAnalyticsEvent: createAnalyticsEvent,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2t9fp.UiModificationContextContainer), {
            scope: scope,
            children: children
        })
    });
};

});
parcelRegister("2t9fp", function(module, exports) {
$parcel$export(module.exports, "store", () => $67c321ab6a4d3b8a$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $67c321ab6a4d3b8a$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $67c321ab6a4d3b8a$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $67c321ab6a4d3b8a$export$5eb9c167b683d125);

var $6xLCs = parcelRequire("6xLCs");
var $iOIPr = parcelRequire("iOIPr");
var $kUoOn = parcelRequire("kUoOn");
const $67c321ab6a4d3b8a$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $67c321ab6a4d3b8a$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($67c321ab6a4d3b8a$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $67c321ab6a4d3b8a$export$6f57813fe9f31bf9 = (0, $kUoOn.createStore)({
    name: 'issue-adjustments-context',
    initialState: $67c321ab6a4d3b8a$var$initialState,
    actions: $67c321ab6a4d3b8a$export$e324594224ef24da
});
const $67c321ab6a4d3b8a$export$a12f82a132dee079 = (0, $6xLCs.createHook)($67c321ab6a4d3b8a$export$6f57813fe9f31bf9);
const $67c321ab6a4d3b8a$export$358ad850b2f6d6fe = (0, $6xLCs.createStateHook)($67c321ab6a4d3b8a$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $67c321ab6a4d3b8a$export$4f2729981f4b81d2 = (0, $6xLCs.createActionsHook)($67c321ab6a4d3b8a$export$6f57813fe9f31bf9);
const $67c321ab6a4d3b8a$export$5eb9c167b683d125 = (0, $iOIPr.createContainer)($67c321ab6a4d3b8a$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("fsioz", function(module, exports) {
$parcel$export(module.exports, "LoadedUiModificationsContainer", () => $ed0dc9c84aa6219d$export$b087a12fbb84e8ac);

var $iOIPr = parcelRequire("iOIPr");

var $2FT8E = parcelRequire("2FT8E");
const $ed0dc9c84aa6219d$export$b087a12fbb84e8ac = (0, $iOIPr.createContainer)((0, $2FT8E.store), {
    displayName: 'LoadedUiModificationsContainer',
    onInit: ()=>({ setState: setState }, { viewType: viewType })=>{
            setState({
                viewType: viewType
            });
        }
});

});
parcelRegister("2FT8E", function(module, exports) {
$parcel$export(module.exports, "store", () => $8f3a9ff6cf77b386$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedFields", () => $8f3a9ff6cf77b386$export$c76e674a29843e21);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $8f3a9ff6cf77b386$export$cb9a014ec14556d8);

var $6xLCs = parcelRequire("6xLCs");
var $kUoOn = parcelRequire("kUoOn");

var $cfFsG = parcelRequire("cfFsG");

var $b2Xwe = parcelRequire("b2Xwe");

var $l9IKv = parcelRequire("l9IKv");

var $jOpRb = parcelRequire("jOpRb");

var $kmsWD = parcelRequire("kmsWD");

var $jRy6Y = parcelRequire("jRy6Y");

var $gRAqR = parcelRequire("gRAqR");

var $1kpAn = parcelRequire("1kpAn");

var $3jb5H = parcelRequire("3jb5H");

var $1Tgpf = parcelRequire("1Tgpf");

var $deRJB = parcelRequire("deRJB");

var $6cPsS = parcelRequire("6cPsS");

var $c4zfy = parcelRequire("c4zfy");

var $kmwwJ = parcelRequire("kmwwJ");

var $a7gy0 = parcelRequire("a7gy0");
const $8f3a9ff6cf77b386$var$name = 'issue-adjustments';
const $8f3a9ff6cf77b386$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $8f3a9ff6cf77b386$var$triggerFieldInitializationKey, viewType: $8f3a9ff6cf77b386$var$scopedViewType, numberOfSupportedFields: $8f3a9ff6cf77b386$var$numberOfSupportedFields, ...$8f3a9ff6cf77b386$var$stateForResetAllFields } = $8f3a9ff6cf77b386$export$d4c72bab9d6cc13a;
const $8f3a9ff6cf77b386$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $1Tgpf.processChange,
    setFieldValue: $6cPsS.setFieldValue,
    initializeField: $jRy6Y.initializeField,
    initializeFields: $jRy6Y.initializeFields,
    startFieldsInitialisationTimeout: $kmsWD.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $kmsWD.successFieldsInitalisation,
    registerFields: $deRJB.registerFields,
    unregisterFields: $deRJB.unregisterFields,
    updateFields: $kmwwJ.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($8f3a9ff6cf77b386$var$stateForResetAllFields);
        },
    setError: $jOpRb.setError,
    resetError: $jOpRb.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
   * This is used to block onInit for specific case like Issue View background refresh loading.
   */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $cfFsG.setAppErrors,
    resetAppErrors: $cfFsG.resetAppErrors,
    addAppsErrors: $cfFsG.addAppsErrors,
    initializeNoScreenTab: $gRAqR.initializeNoScreenTab,
    initializeScreenTabs: $1kpAn.initializeScreenTabs,
    updateScreenTabs: $a7gy0.updateScreenTabs,
    updateActiveScreenTab: $c4zfy.updateActiveScreenTab,
    detectAppliedChangesConflicts: $b2Xwe.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $l9IKv.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $l9IKv.collectFieldsAppliedChangesHistory,
    setNotification: $3jb5H.setNotification,
    resetNotification: $3jb5H.resetNotification
};
const $8f3a9ff6cf77b386$export$6f57813fe9f31bf9 = (0, $kUoOn.createStore)({
    name: $8f3a9ff6cf77b386$var$name,
    initialState: $8f3a9ff6cf77b386$export$d4c72bab9d6cc13a,
    actions: $8f3a9ff6cf77b386$export$e324594224ef24da
});
const $8f3a9ff6cf77b386$export$37792a602e748c08 = (0, $6xLCs.createHook)($8f3a9ff6cf77b386$export$6f57813fe9f31bf9);
const $8f3a9ff6cf77b386$var$stableEmptyFieldFromIframe = {};
const $8f3a9ff6cf77b386$export$c76e674a29843e21 = (0, $6xLCs.createHook)($8f3a9ff6cf77b386$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $8f3a9ff6cf77b386$export$df4b0714e8177e0e = (0, $6xLCs.createHook)($8f3a9ff6cf77b386$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>{
        var _state$appliedChanges;
        return ((_state$appliedChanges = state.appliedChanges) === null || _state$appliedChanges === void 0 ? void 0 : _state$appliedChanges[fieldId]) || $8f3a9ff6cf77b386$var$stableEmptyFieldFromIframe;
    }
});
const $8f3a9ff6cf77b386$export$cb9a014ec14556d8 = (0, $6xLCs.createActionsHook)($8f3a9ff6cf77b386$export$6f57813fe9f31bf9);
const $8f3a9ff6cf77b386$export$677b3e34bd14c681 = (0, $6xLCs.createHook)($8f3a9ff6cf77b386$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("cfFsG", function(module, exports) {
$parcel$export(module.exports, "setAppErrors", () => $0fb2d65b8f208107$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $0fb2d65b8f208107$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $0fb2d65b8f208107$export$24c821207687a907);
const $0fb2d65b8f208107$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $0fb2d65b8f208107$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $0fb2d65b8f208107$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("b2Xwe", function(module, exports) {
$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $bed03c087f9550c8$export$90d94f20d157e756);

var $5UAqR = parcelRequire("5UAqR");

var $4NzXn = parcelRequire("4NzXn");

var $cfFsG = parcelRequire("cfFsG");

var $3jb5H = parcelRequire("3jb5H");

var $9wqK3 = parcelRequire("9wqK3");
const $bed03c087f9550c8$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $bed03c087f9550c8$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $bed03c087f9550c8$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $bed03c087f9550c8$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $bed03c087f9550c8$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId === null || appliedChangesHistoryChangeId === void 0 ? void 0 : appliedChangesHistoryChangeId.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $4NzXn.ON_INIT_CHANGE_ID) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $9wqK3.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $cfFsG.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $3jb5H.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("5UAqR", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $1a274d9bfd7070f0$export$a1fb57756f0de62b);

var $5yo3H = parcelRequire("5yo3H");

var $17wqU = parcelRequire("17wqU");

var $gqRjh = parcelRequire("gqRjh");
const $1a274d9bfd7070f0$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5yo3H.default)((0, $gqRjh.UI_MODIFICATIONS_ANALYTICS_CHANNEL))({
        ...eventPayload,
        analyticsType: (0, $17wqU.OPERATIONAL_EVENT_TYPE)
    })(createAnalyticsEvent);
};

});
parcelRegister("gqRjh", function(module, exports) {
$parcel$export(module.exports, "UI_MODIFICATIONS_ANALYTICS_CHANNEL", () => $f51f39476e27f276$export$8280e5c6104c5b40);
const $f51f39476e27f276$export$8280e5c6104c5b40 = 'ui-modifications';

});


parcelRegister("4NzXn", function(module, exports) {
$parcel$export(module.exports, "ON_INIT_CHANGE_ID", () => $289e71ae4db876be$export$415cc1afa6445f90);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $289e71ae4db876be$export$811b7f067a43b422);
const $289e71ae4db876be$export$415cc1afa6445f90 = 'onInitChangeId';
const $289e71ae4db876be$export$811b7f067a43b422 = 'jira:uiModifications';

});

parcelRegister("3jb5H", function(module, exports) {
$parcel$export(module.exports, "setNotification", () => $41ff675609f1efd8$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $41ff675609f1efd8$export$caafa3945f199bc7);
const $41ff675609f1efd8$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $41ff675609f1efd8$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("9wqK3", function(module, exports) {
$parcel$export(module.exports, "collectConflicts", () => $aa0fb5364825eee2$export$a06103ec99e4e394);

var $lPrAe = parcelRequire("lPrAe");

var $5O2np = parcelRequire("5O2np");

var $2FW0J = parcelRequire("2FW0J");

var $jLISL = parcelRequire("jLISL");
const $aa0fb5364825eee2$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $aa0fb5364825eee2$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $jLISL.SCREEN_TABS_HISTORY_TYPE)) return {
            type: (0, $5O2np.MULTIPLE_APPS_CONFLICT),
            cause: (0, $5O2np.MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$aa0fb5364825eee2$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $2FW0J.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $5O2np.MULTIPLE_APPS_CONFLICT),
            cause: (0, $5O2np.MULTIPLE_APPS_CONFLICT_CAUSE_FIELD),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$aa0fb5364825eee2$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $aa0fb5364825eee2$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($lPrAe)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $aa0fb5364825eee2$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
parcelRegister("lPrAe", function(module, exports) {

var $8Qvsd = parcelRequire("8Qvsd");

var $1DMpo = parcelRequire("1DMpo");

var $8Jtp8 = parcelRequire("8Jtp8");

var $7lN7R = parcelRequire("7lN7R");

var $fISzQ = parcelRequire("fISzQ");

var $jV0ha = parcelRequire("jV0ha");

var $5acs0 = parcelRequire("5acs0");

var $fpBIt = parcelRequire("fpBIt");
/** Used to compose bitmasks for cloning. */ var $fe43c1e7b1160c36$var$CLONE_DEEP_FLAG = 1, $fe43c1e7b1160c36$var$CLONE_FLAT_FLAG = 2, $fe43c1e7b1160c36$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $fe43c1e7b1160c36$var$omit = $5acs0(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $8Qvsd(paths, function(path) {
        path = $7lN7R(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $fISzQ(object, $fpBIt(object), result);
    if (isDeep) result = $1DMpo(result, $fe43c1e7b1160c36$var$CLONE_DEEP_FLAG | $fe43c1e7b1160c36$var$CLONE_FLAT_FLAG | $fe43c1e7b1160c36$var$CLONE_SYMBOLS_FLAG, $jV0ha);
    var length = paths.length;
    while(length--)$8Jtp8(result, paths[length]);
    return result;
});
module.exports = $fe43c1e7b1160c36$var$omit;

});
parcelRegister("1DMpo", function(module, exports) {

var $h0gnZ = parcelRequire("h0gnZ");

var $1aXAW = parcelRequire("1aXAW");

var $c8U2B = parcelRequire("c8U2B");

var $eG16F = parcelRequire("eG16F");

var $jP4bE = parcelRequire("jP4bE");

var $7Qql0 = parcelRequire("7Qql0");

var $yPhrz = parcelRequire("yPhrz");

var $9YSEj = parcelRequire("9YSEj");

var $3xCjA = parcelRequire("3xCjA");

var $jEh55 = parcelRequire("jEh55");

var $fpBIt = parcelRequire("fpBIt");

var $8vSaN = parcelRequire("8vSaN");

var $jANEp = parcelRequire("jANEp");

var $1i9VN = parcelRequire("1i9VN");

var $4mZYy = parcelRequire("4mZYy");

var $u1Zdx = parcelRequire("u1Zdx");

var $eSjJt = parcelRequire("eSjJt");

var $cpRgQ = parcelRequire("cpRgQ");

var $j7DJp = parcelRequire("j7DJp");

var $bRZti = parcelRequire("bRZti");

var $4ztaZ = parcelRequire("4ztaZ");

var $gLcp5 = parcelRequire("gLcp5");
/** Used to compose bitmasks for cloning. */ var $131efbe47c5662a4$var$CLONE_DEEP_FLAG = 1, $131efbe47c5662a4$var$CLONE_FLAT_FLAG = 2, $131efbe47c5662a4$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $131efbe47c5662a4$var$argsTag = '[object Arguments]', $131efbe47c5662a4$var$arrayTag = '[object Array]', $131efbe47c5662a4$var$boolTag = '[object Boolean]', $131efbe47c5662a4$var$dateTag = '[object Date]', $131efbe47c5662a4$var$errorTag = '[object Error]', $131efbe47c5662a4$var$funcTag = '[object Function]', $131efbe47c5662a4$var$genTag = '[object GeneratorFunction]', $131efbe47c5662a4$var$mapTag = '[object Map]', $131efbe47c5662a4$var$numberTag = '[object Number]', $131efbe47c5662a4$var$objectTag = '[object Object]', $131efbe47c5662a4$var$regexpTag = '[object RegExp]', $131efbe47c5662a4$var$setTag = '[object Set]', $131efbe47c5662a4$var$stringTag = '[object String]', $131efbe47c5662a4$var$symbolTag = '[object Symbol]', $131efbe47c5662a4$var$weakMapTag = '[object WeakMap]';
var $131efbe47c5662a4$var$arrayBufferTag = '[object ArrayBuffer]', $131efbe47c5662a4$var$dataViewTag = '[object DataView]', $131efbe47c5662a4$var$float32Tag = '[object Float32Array]', $131efbe47c5662a4$var$float64Tag = '[object Float64Array]', $131efbe47c5662a4$var$int8Tag = '[object Int8Array]', $131efbe47c5662a4$var$int16Tag = '[object Int16Array]', $131efbe47c5662a4$var$int32Tag = '[object Int32Array]', $131efbe47c5662a4$var$uint8Tag = '[object Uint8Array]', $131efbe47c5662a4$var$uint8ClampedTag = '[object Uint8ClampedArray]', $131efbe47c5662a4$var$uint16Tag = '[object Uint16Array]', $131efbe47c5662a4$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $131efbe47c5662a4$var$cloneableTags = {};
$131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$argsTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$arrayTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$arrayBufferTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$dataViewTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$boolTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$dateTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$float32Tag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$float64Tag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$int8Tag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$int16Tag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$int32Tag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$mapTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$numberTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$objectTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$regexpTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$setTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$stringTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$symbolTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$uint8Tag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$uint8ClampedTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$uint16Tag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$uint32Tag] = true;
$131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$errorTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$funcTag] = $131efbe47c5662a4$var$cloneableTags[$131efbe47c5662a4$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $131efbe47c5662a4$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $131efbe47c5662a4$var$CLONE_DEEP_FLAG, isFlat = bitmask & $131efbe47c5662a4$var$CLONE_FLAT_FLAG, isFull = bitmask & $131efbe47c5662a4$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$j7DJp(value)) return value;
    var isArr = $u1Zdx(value);
    if (isArr) {
        result = $jANEp(value);
        if (!isDeep) return $yPhrz(value, result);
    } else {
        var tag = $8vSaN(value), isFunc = tag == $131efbe47c5662a4$var$funcTag || tag == $131efbe47c5662a4$var$genTag;
        if ($eSjJt(value)) return $7Qql0(value, isDeep);
        if (tag == $131efbe47c5662a4$var$objectTag || tag == $131efbe47c5662a4$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $4mZYy(value);
            if (!isDeep) return isFlat ? $3xCjA(value, $jP4bE(result, value)) : $9YSEj(value, $eG16F(result, value));
        } else {
            if (!$131efbe47c5662a4$var$cloneableTags[tag]) return object ? value : {};
            result = $1i9VN(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $h0gnZ);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($bRZti(value)) value.forEach(function(subValue) {
        result.add($131efbe47c5662a4$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($cpRgQ(value)) value.forEach(function(subValue, key) {
        result.set(key, $131efbe47c5662a4$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $fpBIt : $jEh55 : isFlat ? $gLcp5 : $4ztaZ;
    var props = isArr ? undefined : keysFunc(value);
    $1aXAW(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $c8U2B(result, key, $131efbe47c5662a4$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $131efbe47c5662a4$var$baseClone;

});
parcelRegister("1aXAW", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $0db4f3e589024eca$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $0db4f3e589024eca$var$arrayEach;

});

parcelRegister("eG16F", function(module, exports) {

var $fISzQ = parcelRequire("fISzQ");

var $4ztaZ = parcelRequire("4ztaZ");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $aaf5d8a893a8bac1$var$baseAssign(object, source) {
    return object && $fISzQ(source, $4ztaZ(source), object);
}
module.exports = $aaf5d8a893a8bac1$var$baseAssign;

});

parcelRegister("jP4bE", function(module, exports) {

var $fISzQ = parcelRequire("fISzQ");

var $gLcp5 = parcelRequire("gLcp5");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e6e6072d1b1502a7$var$baseAssignIn(object, source) {
    return object && $fISzQ(source, $gLcp5(source), object);
}
module.exports = $e6e6072d1b1502a7$var$baseAssignIn;

});

parcelRegister("9YSEj", function(module, exports) {

var $fISzQ = parcelRequire("fISzQ");

var $f4Un0 = parcelRequire("f4Un0");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $74441bdf0bae13ed$var$copySymbols(source, object) {
    return $fISzQ(source, $f4Un0(source), object);
}
module.exports = $74441bdf0bae13ed$var$copySymbols;

});

parcelRegister("3xCjA", function(module, exports) {

var $fISzQ = parcelRequire("fISzQ");

var $9rivZ = parcelRequire("9rivZ");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $29422cb2952a5a88$var$copySymbolsIn(source, object) {
    return $fISzQ(source, $9rivZ(source), object);
}
module.exports = $29422cb2952a5a88$var$copySymbolsIn;

});

parcelRegister("jANEp", function(module, exports) {
/** Used for built-in method references. */ var $e437e4bc42441249$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e437e4bc42441249$var$hasOwnProperty = $e437e4bc42441249$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $e437e4bc42441249$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $e437e4bc42441249$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $e437e4bc42441249$var$initCloneArray;

});

parcelRegister("1i9VN", function(module, exports) {

var $pY1cd = parcelRequire("pY1cd");

var $7H4l4 = parcelRequire("7H4l4");

var $jnCWI = parcelRequire("jnCWI");

var $3Y3TV = parcelRequire("3Y3TV");

var $e5SPB = parcelRequire("e5SPB");
/** `Object#toString` result references. */ var $0f0f2d0541095c57$var$boolTag = '[object Boolean]', $0f0f2d0541095c57$var$dateTag = '[object Date]', $0f0f2d0541095c57$var$mapTag = '[object Map]', $0f0f2d0541095c57$var$numberTag = '[object Number]', $0f0f2d0541095c57$var$regexpTag = '[object RegExp]', $0f0f2d0541095c57$var$setTag = '[object Set]', $0f0f2d0541095c57$var$stringTag = '[object String]', $0f0f2d0541095c57$var$symbolTag = '[object Symbol]';
var $0f0f2d0541095c57$var$arrayBufferTag = '[object ArrayBuffer]', $0f0f2d0541095c57$var$dataViewTag = '[object DataView]', $0f0f2d0541095c57$var$float32Tag = '[object Float32Array]', $0f0f2d0541095c57$var$float64Tag = '[object Float64Array]', $0f0f2d0541095c57$var$int8Tag = '[object Int8Array]', $0f0f2d0541095c57$var$int16Tag = '[object Int16Array]', $0f0f2d0541095c57$var$int32Tag = '[object Int32Array]', $0f0f2d0541095c57$var$uint8Tag = '[object Uint8Array]', $0f0f2d0541095c57$var$uint8ClampedTag = '[object Uint8ClampedArray]', $0f0f2d0541095c57$var$uint16Tag = '[object Uint16Array]', $0f0f2d0541095c57$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $0f0f2d0541095c57$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $0f0f2d0541095c57$var$arrayBufferTag:
            return $pY1cd(object);
        case $0f0f2d0541095c57$var$boolTag:
        case $0f0f2d0541095c57$var$dateTag:
            return new Ctor(+object);
        case $0f0f2d0541095c57$var$dataViewTag:
            return $7H4l4(object, isDeep);
        case $0f0f2d0541095c57$var$float32Tag:
        case $0f0f2d0541095c57$var$float64Tag:
        case $0f0f2d0541095c57$var$int8Tag:
        case $0f0f2d0541095c57$var$int16Tag:
        case $0f0f2d0541095c57$var$int32Tag:
        case $0f0f2d0541095c57$var$uint8Tag:
        case $0f0f2d0541095c57$var$uint8ClampedTag:
        case $0f0f2d0541095c57$var$uint16Tag:
        case $0f0f2d0541095c57$var$uint32Tag:
            return $e5SPB(object, isDeep);
        case $0f0f2d0541095c57$var$mapTag:
            return new Ctor;
        case $0f0f2d0541095c57$var$numberTag:
        case $0f0f2d0541095c57$var$stringTag:
            return new Ctor(object);
        case $0f0f2d0541095c57$var$regexpTag:
            return $jnCWI(object);
        case $0f0f2d0541095c57$var$setTag:
            return new Ctor;
        case $0f0f2d0541095c57$var$symbolTag:
            return $3Y3TV(object);
    }
}
module.exports = $0f0f2d0541095c57$var$initCloneByTag;

});
parcelRegister("7H4l4", function(module, exports) {

var $pY1cd = parcelRequire("pY1cd");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $599fea2b61a3b7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $pY1cd(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $599fea2b61a3b7e8$var$cloneDataView;

});

parcelRegister("jnCWI", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $e1be60305a64f0ab$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $e1be60305a64f0ab$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $e1be60305a64f0ab$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $e1be60305a64f0ab$var$cloneRegExp;

});

parcelRegister("3Y3TV", function(module, exports) {

var $2LyK3 = parcelRequire("2LyK3");
/** Used to convert symbols to primitives and strings. */ var $2e3a005a650c6fdd$var$symbolProto = $2LyK3 ? $2LyK3.prototype : undefined, $2e3a005a650c6fdd$var$symbolValueOf = $2e3a005a650c6fdd$var$symbolProto ? $2e3a005a650c6fdd$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $2e3a005a650c6fdd$var$cloneSymbol(symbol) {
    return $2e3a005a650c6fdd$var$symbolValueOf ? Object($2e3a005a650c6fdd$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $2e3a005a650c6fdd$var$cloneSymbol;

});


parcelRegister("cpRgQ", function(module, exports) {

var $dP9rm = parcelRequire("dP9rm");

var $iiVLm = parcelRequire("iiVLm");

var $fIN6M = parcelRequire("fIN6M");
/* Node.js helper references. */ var $90a12445add3aaf2$var$nodeIsMap = $fIN6M && $fIN6M.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $90a12445add3aaf2$var$isMap = $90a12445add3aaf2$var$nodeIsMap ? $iiVLm($90a12445add3aaf2$var$nodeIsMap) : $dP9rm;
module.exports = $90a12445add3aaf2$var$isMap;

});
parcelRegister("dP9rm", function(module, exports) {

var $8vSaN = parcelRequire("8vSaN");

var $b6nDQ = parcelRequire("b6nDQ");
/** `Object#toString` result references. */ var $a1075c6b09d82dcb$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $a1075c6b09d82dcb$var$baseIsMap(value) {
    return $b6nDQ(value) && $8vSaN(value) == $a1075c6b09d82dcb$var$mapTag;
}
module.exports = $a1075c6b09d82dcb$var$baseIsMap;

});


parcelRegister("bRZti", function(module, exports) {

var $lx2KL = parcelRequire("lx2KL");

var $iiVLm = parcelRequire("iiVLm");

var $fIN6M = parcelRequire("fIN6M");
/* Node.js helper references. */ var $8a4453ea12bfb105$var$nodeIsSet = $fIN6M && $fIN6M.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $8a4453ea12bfb105$var$isSet = $8a4453ea12bfb105$var$nodeIsSet ? $iiVLm($8a4453ea12bfb105$var$nodeIsSet) : $lx2KL;
module.exports = $8a4453ea12bfb105$var$isSet;

});
parcelRegister("lx2KL", function(module, exports) {

var $8vSaN = parcelRequire("8vSaN");

var $b6nDQ = parcelRequire("b6nDQ");
/** `Object#toString` result references. */ var $faced0c568364b71$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $faced0c568364b71$var$baseIsSet(value) {
    return $b6nDQ(value) && $8vSaN(value) == $faced0c568364b71$var$setTag;
}
module.exports = $faced0c568364b71$var$baseIsSet;

});



parcelRegister("8Jtp8", function(module, exports) {

var $7lN7R = parcelRequire("7lN7R");

var $eKg28 = parcelRequire("eKg28");

var $2gkYb = parcelRequire("2gkYb");

var $1DDv1 = parcelRequire("1DDv1");
/** Used for built-in method references. */ var $65b955c882e1d8a2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $65b955c882e1d8a2$var$hasOwnProperty = $65b955c882e1d8a2$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $65b955c882e1d8a2$var$baseUnset(object, path) {
    path = $7lN7R(path, object);
    // Prevent prototype pollution, see: https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    var index = -1, length = path.length;
    if (!length) return true;
    var isRootPrimitive = object == null || typeof object !== 'object' && typeof object !== 'function';
    while(++index < length){
        var key = path[index];
        // skip non-string keys (e.g., Symbols, numbers)
        if (typeof key !== 'string') continue;
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$65b955c882e1d8a2$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block "constructor.prototype" chains
        if (key === 'constructor' && index + 1 < length && typeof path[index + 1] === 'string' && path[index + 1] === 'prototype') {
            // Allow ONLY when the path starts at a primitive root, e.g., _.unset(0, 'constructor.prototype.a')
            if (isRootPrimitive && index === 0) continue;
            return false;
        }
    }
    var obj = $2gkYb(object, path);
    return obj == null || delete obj[$1DDv1($eKg28(path))];
}
module.exports = $65b955c882e1d8a2$var$baseUnset;

});
parcelRegister("2gkYb", function(module, exports) {

var $29blh = parcelRequire("29blh");

var $jydVe = parcelRequire("jydVe");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $1a5d5789df260d4c$var$parent(object, path) {
    return path.length < 2 ? object : $29blh(object, $jydVe(path, 0, -1));
}
module.exports = $1a5d5789df260d4c$var$parent;

});
parcelRegister("jydVe", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $e3bbfdf1f27a8c24$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $e3bbfdf1f27a8c24$var$baseSlice;

});



parcelRegister("jV0ha", function(module, exports) {

var $9G25R = parcelRequire("9G25R");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $03bdfe294369b20d$var$customOmitClone(value) {
    return $9G25R(value) ? undefined : value;
}
module.exports = $03bdfe294369b20d$var$customOmitClone;

});

parcelRegister("5acs0", function(module, exports) {

var $aFboM = parcelRequire("aFboM");

var $cw0V9 = parcelRequire("cw0V9");

var $g3T4p = parcelRequire("g3T4p");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $3c278b64977aa783$var$flatRest(func) {
    return $g3T4p($cw0V9(func, undefined, $aFboM), func + '');
}
module.exports = $3c278b64977aa783$var$flatRest;

});


parcelRegister("5O2np", function(module, exports) {
$parcel$export(module.exports, "SCREENTABS_VALIDATION_ERROR", () => $c3ddd4f9eeffe3cd$export$fd26696d109785a0);
$parcel$export(module.exports, "FIELD_VALIDATION_ERROR", () => $c3ddd4f9eeffe3cd$export$d1996cb46a690190);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT", () => $c3ddd4f9eeffe3cd$export$2a3fdceaae2188d5);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT_CAUSE_FIELD", () => $c3ddd4f9eeffe3cd$export$e4ac32edd5da2ee7);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS", () => $c3ddd4f9eeffe3cd$export$877da1000325f8b5);
const $c3ddd4f9eeffe3cd$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $c3ddd4f9eeffe3cd$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $c3ddd4f9eeffe3cd$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $c3ddd4f9eeffe3cd$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $c3ddd4f9eeffe3cd$export$e4ac32edd5da2ee7 = 'FIELD';
const $c3ddd4f9eeffe3cd$export$877da1000325f8b5 = 'SCREENTABS';

});

parcelRegister("2FW0J", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $6ec0135175bf86c5$export$e1cc7da28a1c4bb7);
const $6ec0135175bf86c5$var$SET_NAME_METHOD = 'setName';
const $6ec0135175bf86c5$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $6ec0135175bf86c5$var$SET_VISIBLE_METHOD = 'setVisible';
const $6ec0135175bf86c5$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $6ec0135175bf86c5$var$SET_VALUE_METHOD = 'setValue';
const $6ec0135175bf86c5$var$SET_REQUIRED_METHOD = 'setRequired';
const $6ec0135175bf86c5$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $6ec0135175bf86c5$export$8325709d137b2606 = {
    fieldName: $6ec0135175bf86c5$var$SET_NAME_METHOD,
    description: $6ec0135175bf86c5$var$SET_DESCRIPTION_METHOD,
    isVisible: $6ec0135175bf86c5$var$SET_VISIBLE_METHOD,
    isReadOnly: $6ec0135175bf86c5$var$SET_READ_ONLY_METHOD,
    value: $6ec0135175bf86c5$var$SET_VALUE_METHOD,
    isRequired: $6ec0135175bf86c5$var$SET_REQUIRED_METHOD,
    optionsVisibility: $6ec0135175bf86c5$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $6ec0135175bf86c5$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $6ec0135175bf86c5$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

parcelRegister("jLISL", function(module, exports) {
$parcel$export(module.exports, "SCREEN_TABS_HISTORY_TYPE", () => $c839f7e674d4af70$export$f674b7a3bbd94b5);
$parcel$export(module.exports, "FIELD_HISTORY_TYPE", () => $c839f7e674d4af70$export$4a9f236a0db33834);
const $c839f7e674d4af70$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $c839f7e674d4af70$export$4a9f236a0db33834 = 'FIELD';

});



parcelRegister("l9IKv", function(module, exports) {
$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $9b971395ce291ea3$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $9b971395ce291ea3$export$7d0f534e5b16dcc9);

var $jLISL = parcelRequire("jLISL");

var $gqFqt = parcelRequire("gqFqt");
const $9b971395ce291ea3$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    var _appliedChangesHistor;
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = ((_appliedChangesHistor = appliedChangesHistoryChangeId.apps) === null || _appliedChangesHistor === void 0 ? void 0 : _appliedChangesHistor[appId]) ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $9b971395ce291ea3$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $9b971395ce291ea3$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $jLISL.SCREEN_TABS_HISTORY_TYPE)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $9b971395ce291ea3$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gqFqt.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $9b971395ce291ea3$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gqFqt", function(module, exports) {
$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $bb36a55a97f4e18b$export$8a23b3e9a1749620);

var $jLISL = parcelRequire("jLISL");
const $bb36a55a97f4e18b$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $jLISL.FIELD_HISTORY_TYPE)
        };
        return acc;
    }, {});
};
const $bb36a55a97f4e18b$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $bb36a55a97f4e18b$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("jOpRb", function(module, exports) {
$parcel$export(module.exports, "setError", () => $46e696a6e4e5e2f6$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $46e696a6e4e5e2f6$export$7e5930c6217b1d4e);
const $46e696a6e4e5e2f6$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $46e696a6e4e5e2f6$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("kmsWD", function(module, exports) {
$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $55f67873eadf5df3$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $55f67873eadf5df3$export$cf768a695e83eefa);

var $5UAqR = parcelRequire("5UAqR");

var $3aXNe = parcelRequire("3aXNe");

var $jOpRb = parcelRequire("jOpRb");
const $55f67873eadf5df3$var$getTimeout = ()=>50000;
const $55f67873eadf5df3$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $55f67873eadf5df3$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $55f67873eadf5df3$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($55f67873eadf5df3$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $55f67873eadf5df3$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $55f67873eadf5df3$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($55f67873eadf5df3$var$isFieldInitialisationComplete(status) || (0, $3aXNe.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $jOpRb.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $55f67873eadf5df3$var$getTimeout(),
                fieldsInitializationTime: $55f67873eadf5df3$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $55f67873eadf5df3$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { status: status } = getState().fieldsInitialization;
        if ($55f67873eadf5df3$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $55f67873eadf5df3$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("3aXNe", function(module, exports) {
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $a1b17f53cc297174$export$4cadeedb8c3f31f7);

var $lJS87 = parcelRequire("lJS87");
const $a1b17f53cc297174$export$4cadeedb8c3f31f7 = (0, $lJS87.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jRy6Y", function(module, exports) {
$parcel$export(module.exports, "initializeField", () => $a8b2938a8a51d85e$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a8b2938a8a51d85e$export$4a6b4707110b0552);

var $5lYGT = parcelRequire("5lYGT");
const $a8b2938a8a51d85e$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $5lYGT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a8b2938a8a51d85e$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $5lYGT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("5lYGT", function(module, exports) {
$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $5bffa3fef03e2c10$export$50806045b617d116);

var $cP8g6 = parcelRequire("cP8g6");

var $8MVOi = parcelRequire("8MVOi");
const $5bffa3fef03e2c10$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        var _getSupportedFieldCon;
        const valueTransformer = (_getSupportedFieldCon = (0, $8MVOi.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.internalToPublicTransformers.value;
        if (valueTransformer) /**
       * We trust that the internal field data is in the correct shape.
       * Data that is in the incorrect shape will result in error events
       * being logged for further investigation. In this error case we will
       * pass `null` as the value to unblock onInit for the apps
       *
       * The `fieldRenderer` passed to the `valueTransformer` is used only for
       * rich text fields and will be `undefined` for most of the executions
       */ value = valueTransformer(internalFieldValue, fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cP8g6.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("cP8g6", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $4ca47adbebaea9b5$export$a27c21aa3ed8f0f1);
parcelRequire("euslt");
var $9Lbe3 = parcelRequire("9Lbe3");

var $kbMmZ = parcelRequire("kbMmZ");
const $4ca47adbebaea9b5$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $4ca47adbebaea9b5$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $kbMmZ.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $9Lbe3.default)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $4ca47adbebaea9b5$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("euslt", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("9Lbe3")).default);
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => (parcelRequire("9Lbe3")).initialiseErrorAnalyticsClient);

var $68ePD = parcelRequire("68ePD");

var $9Lbe3 = parcelRequire("9Lbe3");

var $bpOTY = parcelRequire("bpOTY");

});
parcelRegister("68ePD", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $e4d3c55de846295f$export$f5282963edea4a68);

var $hPpEf = parcelRequire("hPpEf");
const $e4d3c55de846295f$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $hPpEf.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $e4d3c55de846295f$export$f5282963edea4a68 = (location, error, details = {})=>(0, $hPpEf.default).captureException(location, error, details);

});
parcelRegister("hPpEf", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ee00d5037f4725f$export$2e2bcd8739ae039);
// This is the only file that should directly import Raven.

var $9dPOl = parcelRequire("9dPOl");
var $jOQ1l = parcelRequire("jOQ1l");
var $3Gufo = parcelRequire("3Gufo");

var $lEwQx = parcelRequire("lEwQx");
var $ebqzh = parcelRequire("ebqzh");
var $bdnM4 = parcelRequire("bdnM4");
var $1pMlN = parcelRequire("1pMlN");

var $cw4ow = parcelRequire("cw4ow");
const $3ee00d5037f4725f$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($cw4ow)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $3ee00d5037f4725f$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $3ee00d5037f4725f$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $3ee00d5037f4725f$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $3ee00d5037f4725f$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $jOQ1l.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $3ee00d5037f4725f$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$3ee00d5037f4725f$var$getFilteredIntegrations(integrations),
                new $ebqzh.Dedupe(),
                new $bdnM4.ExtraErrorData(),
                new $1pMlN.Transaction(),
                new $lEwQx.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $3Gufo.init({
        ...defaultConfig,
        ...config
    });
    try {
        $9dPOl.setExtras(getExtraContext());
    } catch (e) {
        $9dPOl.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $3ee00d5037f4725f$var$tags = [
    'packageName',
    'teamName'
];
const $3ee00d5037f4725f$var$captureException = (location, error, details)=>{
    $9dPOl.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($3ee00d5037f4725f$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $9dPOl.captureException(error);
};
const $3ee00d5037f4725f$var$sentryErrorHandler = {
    installGlobalHandler: $3ee00d5037f4725f$var$installGlobalHandler,
    captureException: $3ee00d5037f4725f$var$captureException
};
var $3ee00d5037f4725f$export$2e2bcd8739ae039 = $3ee00d5037f4725f$var$sentryErrorHandler;

});
parcelRegister("lEwQx", function(module, exports) {
$parcel$export(module.exports, "CaptureConsole", () => $fc36d0020d1106b3$export$25a43cb5b5c58c08);
parcelRequire("5kSOS");
var $lnK9y = parcelRequire("lnK9y");
var $xohzt = parcelRequire("xohzt");
var $bz0KW = parcelRequire("bz0KW");
var $dLLy5 = parcelRequire("dLLy5");
var $3BpUd = parcelRequire("3BpUd");
var $fc36d0020d1106b3$var$global = (0, $bz0KW.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $fc36d0020d1106b3$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $lnK9y.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $fc36d0020d1106b3$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $fc36d0020d1106b3$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $xohzt.fill)($fc36d0020d1106b3$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $3BpUd.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $dLLy5.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $dLLy5.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($fc36d0020d1106b3$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

});

parcelRegister("ebqzh", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $a536b39ac79ec879$export$688d98c249d31ad3);
parcelRequire("5kSOS");
var $lnK9y = parcelRequire("lnK9y");

var $ilSsD = parcelRequire("ilSsD");
/** Deduplication filter */ var $a536b39ac79ec879$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($a536b39ac79ec879$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $ilSsD.IS_DEBUG_BUILD) && (0, $lnK9y.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $a536b39ac79ec879$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($a536b39ac79ec879$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($a536b39ac79ec879$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $a536b39ac79ec879$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$a536b39ac79ec879$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a536b39ac79ec879$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $a536b39ac79ec879$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $a536b39ac79ec879$var$_getExceptionFromEvent(previousEvent);
    var currentException = $a536b39ac79ec879$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$a536b39ac79ec879$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$a536b39ac79ec879$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $a536b39ac79ec879$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $a536b39ac79ec879$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $a536b39ac79ec879$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $a536b39ac79ec879$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $a536b39ac79ec879$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $a536b39ac79ec879$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("ilSsD", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $d5c46ef1c5e4d30b$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $d5c46ef1c5e4d30b$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("bdnM4", function(module, exports) {
$parcel$export(module.exports, "ExtraErrorData", () => $82a359b04937a59f$export$56d961ef3a52a072);

var $26Yns = parcelRequire("26Yns");
parcelRequire("5kSOS");
var $7svr9 = parcelRequire("7svr9");
var $lnK9y = parcelRequire("lnK9y");
var $gyIda = parcelRequire("gyIda");

var $ilSsD = parcelRequire("ilSsD");
/** Patch toString calls to return proper name for wrapped functions */ var $82a359b04937a59f$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $26Yns.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $7svr9.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $26Yns.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $gyIda.normalize)(errorData, this._options.depth);
            if ((0, $7svr9.isPlainObject)(normalizedErrorData)) contexts = (0, $26Yns.__assign)((0, $26Yns.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $26Yns.__assign)({}, normalizedErrorData), _a));
            return (0, $26Yns.__assign)((0, $26Yns.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $26Yns.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $7svr9.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $26Yns.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $7svr9.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $ilSsD.IS_DEBUG_BUILD) && (0, $lnK9y.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

});

parcelRegister("1pMlN", function(module, exports) {
$parcel$export(module.exports, "Transaction", () => $107da1a7f93d2a3b$export$febc5573c75cefb0);
/** Add node transaction to the event */ var $107da1a7f93d2a3b$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

});



parcelRegister("9Lbe3", function(module, exports) {
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => $ed7ef5acca55d901$export$d4079397f9611138);
$parcel$export(module.exports, "default", () => $ed7ef5acca55d901$export$2e2bcd8739ae039);

var $9Y6sr = parcelRequire("9Y6sr");

var $ljlVI = parcelRequire("ljlVI");

var $8hleO = parcelRequire("8hleO");
var $8LbZn = parcelRequire("8LbZn");

var $68ePD = parcelRequire("68ePD");
let $ed7ef5acca55d901$var$analyticsClient;
const $ed7ef5acca55d901$export$d4079397f9611138 = (client)=>{
    $ed7ef5acca55d901$var$analyticsClient = client;
};
const $ed7ef5acca55d901$export$bf406c01a195b215 = ()=>{
    $ed7ef5acca55d901$var$analyticsClient = undefined;
};
const $ed7ef5acca55d901$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $8hleO.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($ljlVI)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9Y6sr))));
        if (event && event.context) {
            const fullEvent = (0, $8hleO.extractAWCDataFromEvent)(event);
            (0, $68ePD.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $68ePD.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $8LbZn.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($ed7ef5acca55d901$var$analyticsClient && $ed7ef5acca55d901$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $ed7ef5acca55d901$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $68ePD.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $ed7ef5acca55d901$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $ed7ef5acca55d901$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $ed7ef5acca55d901$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $ed7ef5acca55d901$export$2e2bcd8739ae039 = $ed7ef5acca55d901$var$fireErrorAnalytics;

});

parcelRegister("bpOTY", function(module, exports) {

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $k7ZVu = parcelRequire("k7ZVu");

var $9Lbe3 = parcelRequire("9Lbe3");
class $573ae0177a1596d0$var$CatchAndReportErrors extends (0, $8P7DW.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $9Lbe3.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
            children: children
        });
    }
}
const $573ae0177a1596d0$var$reportingErrorBoundary = (0, $k7ZVu.default)()($573ae0177a1596d0$var$CatchAndReportErrors);
var $573ae0177a1596d0$export$2e2bcd8739ae039 = $573ae0177a1596d0$var$reportingErrorBoundary;

});


parcelRegister("kbMmZ", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $2b2c43f10a9c1587$export$e19f9f08a6d79fd2);

var $3WMXd = parcelRequire("3WMXd");
const $2b2c43f10a9c1587$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $2b2c43f10a9c1587$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $2b2c43f10a9c1587$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $2b2c43f10a9c1587$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $2b2c43f10a9c1587$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $2b2c43f10a9c1587$export$89a175d4190df42e = 'Invoke value functions failed:';
const $2b2c43f10a9c1587$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $2b2c43f10a9c1587$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $2b2c43f10a9c1587$var$BAD_REQUEST = 400;
const $2b2c43f10a9c1587$var$REQUEST_TIMEOUT = 408;
const $2b2c43f10a9c1587$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $2b2c43f10a9c1587$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>{
        var _error$stack;
        return Boolean(typeof error === 'object' && error.name === 'TimeoutError' && ((_error$stack = error.stack) === null || _error$stack === void 0 ? void 0 : _error$stack.includes(timedOutResource)));
    };
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $2b2c43f10a9c1587$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = (match === null || match === void 0 ? void 0 : match[1]) ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $2b2c43f10a9c1587$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($2b2c43f10a9c1587$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $2b2c43f10a9c1587$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($2b2c43f10a9c1587$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $2b2c43f10a9c1587$var$BAD_REQUEST;
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $2b2c43f10a9c1587$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $2b2c43f10a9c1587$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($2b2c43f10a9c1587$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($2b2c43f10a9c1587$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $3WMXd.isClientFetchError)(error)) return $2b2c43f10a9c1587$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("3WMXd", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $64686ca354a26899$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $64686ca354a26899$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $64686ca354a26899$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $64686ca354a26899$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $64686ca354a26899$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $64686ca354a26899$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($64686ca354a26899$export$3876cb851aa46193.includes(error.name) || $64686ca354a26899$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($64686ca354a26899$export$3876cb851aa46193.includes(error.cause.name) || $64686ca354a26899$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("8MVOi", function(module, exports) {
$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $f1b06d9836abc323$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $f1b06d9836abc323$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $f1b06d9836abc323$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $f1b06d9836abc323$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $f1b06d9836abc323$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $f1b06d9836abc323$export$ef45e4471aa21b27);

var $cP8g6 = parcelRequire("cP8g6");

var $ck2Cv = parcelRequire("ck2Cv");
const $f1b06d9836abc323$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $f1b06d9836abc323$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $ck2Cv.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $f1b06d9836abc323$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $f1b06d9836abc323$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$f1b06d9836abc323$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cP8g6.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $f1b06d9836abc323$export$e4330d77fd93d1de = (viewType)=>$f1b06d9836abc323$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $f1b06d9836abc323$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $f1b06d9836abc323$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $f1b06d9836abc323$export$20eabd2b3ada6bf3(viewType) {
    return $f1b06d9836abc323$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $f1b06d9836abc323$export$b768d6a95f7a930(context) {
    return $f1b06d9836abc323$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $f1b06d9836abc323$export$b0297573c90085aa(viewType) {
    return $f1b06d9836abc323$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $f1b06d9836abc323$export$c0728caa743a409e(viewType) {
    return $f1b06d9836abc323$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $f1b06d9836abc323$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $f1b06d9836abc323$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("ck2Cv", function(module, exports) {
$parcel$export(module.exports, "getViewConfiguration", () => $8759168405e3d287$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $8759168405e3d287$export$f0022a21ccd1f6be);

var $8P7DW = parcelRequire("8P7DW");
const $8759168405e3d287$var$VIEW_CONFIGURATIONS = new Map();
const $8759168405e3d287$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$8759168405e3d287$var$VIEW_CONFIGURATIONS.has(viewType)) $8759168405e3d287$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $8759168405e3d287$export$176b6e68da08ffa2 = (viewType)=>$8759168405e3d287$var$VIEW_CONFIGURATIONS.get(viewType);
const $8759168405e3d287$export$e8091eff40c4f16e = ()=>{
    $8759168405e3d287$var$VIEW_CONFIGURATIONS.clear();
};
const $8759168405e3d287$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    /**
   * Uses useMemo to load view configuration during the first render, before mount.
   */ (0, $8P7DW.useMemo)(()=>{
        $8759168405e3d287$export$cda1ad403b37fe70(viewType, new configurationClass());
    }, [
        viewType,
        configurationClass
    ]);
};

});




parcelRegister("gRAqR", function(module, exports) {
$parcel$export(module.exports, "initializeNoScreenTab", () => $603ac5f120c299f7$export$93459ad9bfd6c380);
const $603ac5f120c299f7$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("1kpAn", function(module, exports) {
$parcel$export(module.exports, "initializeScreenTabs", () => $0d12a65c16d4dde3$export$7f7be235f64f029b);
const $0d12a65c16d4dde3$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs === null || internalScreenTabs === void 0 ? void 0 : internalScreenTabs.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("1Tgpf", function(module, exports) {
$parcel$export(module.exports, "processChange", () => $f5353bfdf1354a53$export$352dfcce04d66748);

var $8HgEs = parcelRequire("8HgEs");

var $8MVOi = parcelRequire("8MVOi");

var $g3d9P = parcelRequire("g3d9P");
const $f5353bfdf1354a53$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        var _internalFormMetadata, _getSupportedFieldCon;
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = (_internalFormMetadata = internalFormMetadata[fieldId]) === null || _internalFormMetadata === void 0 ? void 0 : _internalFormMetadata.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (_getSupportedFieldCon = (0, $8MVOi.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $g3d9P.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
   * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
   * Otherwise, UIM app may not be notified about every single change.
   */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($8HgEs)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("8HgEs", function(module, exports) {

var $bDVqc = parcelRequire("bDVqc");
/** Used to generate unique IDs. */ var $654f418205d00906$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $654f418205d00906$var$uniqueId(prefix) {
    var id = ++$654f418205d00906$var$idCounter;
    return $bDVqc(prefix) + id;
}
module.exports = $654f418205d00906$var$uniqueId;

});

parcelRegister("g3d9P", function(module, exports) {
$parcel$export(module.exports, "calculateNextFormValue", () => $494e5ecc3dbb8f32$export$25441a03bb8f1cb0);

var $77MDz = parcelRequire("77MDz");

var $5lYGT = parcelRequire("5lYGT");
const $494e5ecc3dbb8f32$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    var _formData$fieldId;
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $5lYGT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = (_formData$fieldId = formData[fieldId]) === null || _formData$fieldId === void 0 ? void 0 : _formData$fieldId.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($77MDz)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("deRJB", function(module, exports) {
$parcel$export(module.exports, "registerFields", () => $120d18ffe459be9f$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $120d18ffe459be9f$export$1ca69a85bb7273de);

var $lPrAe = parcelRequire("lPrAe");

var $cw4ow = parcelRequire("cw4ow");
const $120d18ffe459be9f$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($cw4ow)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $120d18ffe459be9f$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($lPrAe)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("6cPsS", function(module, exports) {
$parcel$export(module.exports, "setFieldValue", () => $c3020631640ec73a$export$6556d46d2662453c);

var $g3d9P = parcelRequire("g3d9P");
const $c3020631640ec73a$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
   * We can set new field value only if the field was initialized.
   * This checks the field metedata that indicates the successfull initialization.
   */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $g3d9P.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("c4zfy", function(module, exports) {
$parcel$export(module.exports, "updateActiveScreenTab", () => $27e9e89de7285175$export$21363496760d39cd);
const $27e9e89de7285175$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("kmwwJ", function(module, exports) {
$parcel$export(module.exports, "updateFields", () => $fb21bbcbae1b973c$export$cceae62fd4d1ef0a);

var $9Y6sr = parcelRequire("9Y6sr");

var $5UAqR = parcelRequire("5UAqR");

var $l1rhI = parcelRequire("l1rhI");

var $6jxX5 = parcelRequire("6jxX5");

var $1Zkoy = parcelRequire("1Zkoy");

var $h520b = parcelRequire("h520b");

var $3XkQN = parcelRequire("3XkQN");

var $1pjMs = parcelRequire("1pjMs");

var $kv1q2 = parcelRequire("kv1q2");

var $cfFsG = parcelRequire("cfFsG");

var $l9IKv = parcelRequire("l9IKv");

var $dATPs = parcelRequire("dATPs");
const $fb21bbcbae1b973c$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, lastProcessedChange: lastProcessedChange } = getState();
        let isSameFieldValueChanged = false;
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $h520b.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $cfFsG.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $l1rhI.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY)]: internalMetadata.allowedValues,
                [(0, $l1rhI.LOOKUP_SOURCE_USERS_ASYNC_DATA)]: lookupDataFromApi[0, $l1rhI.LOOKUP_SOURCE_USERS_ASYNC_DATA],
                [(0, $l1rhI.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA)]: lookupDataFromApi[0, $l1rhI.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $dATPs.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $kv1q2.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3XkQN.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            isSameFieldValueChanged = (0, $6jxX5.checkSameFieldValueChanged)(fieldsChanges, lastProcessedChange, changeId);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges,
                isSameFieldValueChanged: isSameFieldValueChanged
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($9Y6sr)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9Y6sr)))(errorsByField)) throw new (0, $1Zkoy.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $1pjMs.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $l9IKv.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
parcelRegister("l1rhI", function(module, exports) {
$parcel$export(module.exports, "LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY", () => $1ad515855fc5a407$export$a1cacdcf198da901);
$parcel$export(module.exports, "LOOKUP_SOURCE_USERS_ASYNC_DATA", () => $1ad515855fc5a407$export$3a106242c8f57ac2);
$parcel$export(module.exports, "LOOKUP_SOURCE_PROJECTS_ASYNC_DATA", () => $1ad515855fc5a407$export$e10d4d251d909c59);
$parcel$export(module.exports, "AUTOMATIC_ID", () => $1ad515855fc5a407$export$f5d5f6bb902f1027);
const $1ad515855fc5a407$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $1ad515855fc5a407$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $1ad515855fc5a407$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $1ad515855fc5a407$export$f5d5f6bb902f1027 = '-1';
const $1ad515855fc5a407$export$106087dcfd4fb129 = 100;

});

parcelRegister("6jxX5", function(module, exports) {
$parcel$export(module.exports, "checkSameFieldValueChanged", () => $b3bfa62b357e6879$export$4027d961191df7c3);
function $b3bfa62b357e6879$export$4027d961191df7c3(fieldsChanges, lastProcessedChange, changeId) {
    if (fieldsChanges && (lastProcessedChange === null || lastProcessedChange === void 0 ? void 0 : lastProcessedChange.changeId) === changeId) {
        const fid = lastProcessedChange === null || lastProcessedChange === void 0 ? void 0 : lastProcessedChange.fieldId;
        const change = fieldsChanges[fid];
        return !!change && change.hasOwnProperty('value');
    }
    return false;
}

});

parcelRegister("1Zkoy", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $6c1a13d967f1c238$export$9e8b5e552e255163);

var $1mKkC = parcelRequire("1mKkC");
class $6c1a13d967f1c238$export$9e8b5e552e255163 extends (0, $1mKkC.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("1mKkC", function(module, exports) {
$parcel$export(module.exports, "UiModificationsValidationError", () => $d0350f9c90178d45$export$6e8165c81a6a65df);
class $d0350f9c90178d45$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("h520b", function(module, exports) {
$parcel$export(module.exports, "fieldWasRegistered", () => $d6f530df6f20f61d$export$fbe9157c12cb4e7b);
const $d6f530df6f20f61d$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>{
    var _registeredFields$app;
    return !!((_registeredFields$app = registeredFields[appId]) !== null && _registeredFields$app !== void 0 && (_registeredFields$app = _registeredFields$app[changeId]) !== null && _registeredFields$app !== void 0 && _registeredFields$app.includes(fieldId));
};

});

parcelRegister("3XkQN", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $27058c6022c4be74$export$460820f27643954e);

var $8MVOi = parcelRequire("8MVOi");
const $27058c6022c4be74$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $8MVOi.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("1pjMs", function(module, exports) {
$parcel$export(module.exports, "prepareErrorsArray", () => $be2f9d92bcda4389$export$e1fce51bc5be90b7);
const $be2f9d92bcda4389$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("kv1q2", function(module, exports) {
$parcel$export(module.exports, "transformFieldToIframe", () => $4de65bdb315638f5$export$aa453854f74fab);

var $cP8g6 = parcelRequire("cP8g6");

var $8MVOi = parcelRequire("8MVOi");
const $4de65bdb315638f5$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $8MVOi.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cP8g6.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.optionsVisibility) try {
        const lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cP8g6.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("dATPs", function(module, exports) {
$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $7ef00c1340f0ee25$export$d14f85c01e334a1);

var $9Y6sr = parcelRequire("9Y6sr");

var $9aVeJ = parcelRequire("9aVeJ");

var $8MVOi = parcelRequire("8MVOi");

var $5O2np = parcelRequire("5O2np");

var $2FW0J = parcelRequire("2FW0J");

var $51jVV = parcelRequire("51jVV");

var $dTaN4 = parcelRequire("dTaN4");
const $7ef00c1340f0ee25$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    const fieldConfiguration = (0, $8MVOi.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $51jVV.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $51jVV.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $9aVeJ.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $5O2np.FIELD_VALIDATION_ERROR),
                        method: (0, $2FW0J.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $dTaN4.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9Y6sr)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $dTaN4.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("9aVeJ", function(module, exports) {
$parcel$export(module.exports, "FieldValueLookupError", () => $aca040b5789ae646$export$73c2f0689b6c4a5a);
class $aca040b5789ae646$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("51jVV", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $a7df98f456bd3a5b$export$ee79e3ab53b8db79);
const $a7df98f456bd3a5b$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("dTaN4", function(module, exports) {
$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $806e9191b9ba34f6$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $806e9191b9ba34f6$export$ddd005554aecd409);
const $806e9191b9ba34f6$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $806e9191b9ba34f6$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("a7gy0", function(module, exports) {
$parcel$export(module.exports, "updateScreenTabs", () => $4dd24be637068d38$export$131c67fd312b8a11);

var $evV2F = parcelRequire("evV2F");

var $7sHUD = parcelRequire("7sHUD");

var $l9IKv = parcelRequire("l9IKv");

var $1fppa = parcelRequire("1fppa");
const $4dd24be637068d38$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $1fppa.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $1fppa.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $l9IKv.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $evV2F.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $1fppa.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $7sHUD.toScreenTabsValidationError))
        });
    };

});
parcelRegister("evV2F", function(module, exports) {
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $1b49bc5ce48c51d6$export$faf1f1824ee0a136);

var $1mKkC = parcelRequire("1mKkC");
class $1b49bc5ce48c51d6$export$faf1f1824ee0a136 extends (0, $1mKkC.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("7sHUD", function(module, exports) {
$parcel$export(module.exports, "toScreenTabsValidationError", () => $54e72fbe3a376fb3$export$b2675440ade984fb);

var $5O2np = parcelRequire("5O2np");
const $54e72fbe3a376fb3$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $5O2np.SCREENTABS_VALIDATION_ERROR)
    });

});

parcelRegister("1fppa", function(module, exports) {
$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $c0c8ee925fece526$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $c0c8ee925fece526$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $c0c8ee925fece526$export$62d63af83dac7315);
const $c0c8ee925fece526$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $c0c8ee925fece526$var$isValidScreenTabId = (internalScreenTabs, id)=>$c0c8ee925fece526$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $c0c8ee925fece526$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $c0c8ee925fece526$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $c0c8ee925fece526$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$c0c8ee925fece526$var$isValidScreenTabId(internalScreenTabs, id) && $c0c8ee925fece526$var$isValidScreenTabIsVisible(isVisible) && $c0c8ee925fece526$var$isValidScreenTabIsActive(isActive);
const $c0c8ee925fece526$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($c0c8ee925fece526$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $c0c8ee925fece526$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($c0c8ee925fece526$var$isValidScreenTabIsActive(isActive) && isActive && $c0c8ee925fece526$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $c0c8ee925fece526$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    var _screenTabsInternalUp;
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof ((_screenTabsInternalUp = screenTabsInternalUpdated[0]) === null || _screenTabsInternalUp === void 0 ? void 0 : _screenTabsInternalUp.isActive) !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $c0c8ee925fece526$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$c0c8ee925fece526$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($c0c8ee925fece526$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($c0c8ee925fece526$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $c0c8ee925fece526$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    screenTabsFromApp.forEach((tab)=>{
        if (!$c0c8ee925fece526$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$c0c8ee925fece526$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$c0c8ee925fece526$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$c0c8ee925fece526$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($c0c8ee925fece526$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($c0c8ee925fece526$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("9Qkcz", function(module, exports) {
$parcel$export(module.exports, "REQUEST_CREATE_VIEW_TYPE", () => $a22a38237be1cf48$export$f5706508058e3b54);
const $a22a38237be1cf48$export$f5706508058e3b54 = 'JSMRequestCreate';

});

parcelRegister("93HXx", function(module, exports) {
$parcel$export(module.exports, "RequestCreateViewConfiguration", () => $81e5e20101690d25$export$4193c77f3bdf79ba);

var $3uvNM = parcelRequire("3uvNM");

var $hXXvg = parcelRequire("hXXvg");

var $1EFS8 = parcelRequire("1EFS8");

var $l1rhI = parcelRequire("l1rhI");

var $g2Pgd = parcelRequire("g2Pgd");

var $2dOdd = parcelRequire("2dOdd");

var $eVj0v = parcelRequire("eVj0v");

var $6wLn7 = parcelRequire("6wLn7");

var $dWc7u = parcelRequire("dWc7u");

var $8Z0nB = parcelRequire("8Z0nB");

var $ktqPw = parcelRequire("ktqPw");

var $dUHPW = parcelRequire("dUHPW");

var $6iKXS = parcelRequire("6iKXS");

var $aX2eV = parcelRequire("aX2eV");

var $hnD3A = parcelRequire("hnD3A");

var $b0BQW = parcelRequire("b0BQW");

var $atL5x = parcelRequire("atL5x");

var $lp7oK = parcelRequire("lp7oK");

var $eNzDF = parcelRequire("eNzDF");

var $lkMEg = parcelRequire("lkMEg");

var $bmDvS = parcelRequire("bmDvS");

var $fBJ0B = parcelRequire("fBJ0B");

var $jLx2t = parcelRequire("jLx2t");
const $81e5e20101690d25$export$b3302682bd74b905 = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_embedded_request_page');
const $81e5e20101690d25$export$97cf619b5c503901 = ()=>(0, $1EFS8.default).checkGate('uim_jsm_textfield_support');
const $81e5e20101690d25$export$3d9060e51ab7079e = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_multi_select_support');
const $81e5e20101690d25$export$5377338157c93a4a = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_number_field_support');
const $81e5e20101690d25$export$ca4e8050793caa6 = ()=>(0, $1EFS8.default).checkGate('uim_jsm_duedate_support');
const $81e5e20101690d25$export$a3127feadc5f63ef = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_datetime_field_support');
const $81e5e20101690d25$export$682d85ee096f07a9 = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_textarea_support');
const $81e5e20101690d25$export$120971fff910541d = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_description_support');
const $81e5e20101690d25$export$b738c6acf33d051a = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_cascading_select_support');
const $81e5e20101690d25$export$1df7079ae40c80e4 = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_datepicker_field_support');
const $81e5e20101690d25$export$fe4ccb1b2f4366aa = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_labels_support');
const $81e5e20101690d25$export$d16c700a701ab994 = ()=>(0, $1EFS8.default).checkGate('ditto_uim_jsm_user_picker_support');
class $81e5e20101690d25$export$4193c77f3bdf79ba {
    getAnalytics() {
        return this.analytics;
    }
    /**
   * On other views in Jira, we check if we support a specific project type available from execution context
   * Here, in JSM, there is nothing specific available from Execution Context that we should check
   */ isExecutionContextSupported() {
        return true;
    }
    getConsentMessage() {
        return (0, $fBJ0B.default).obligatoryUimRequestCreateConsentMessage;
    }
    getSupportedTriggerPointsConfiguration() {
        if ($81e5e20101690d25$export$b3302682bd74b905()) return new Set([
            (0, $8Z0nB.DEFAULT),
            (0, $8Z0nB.EMBEDDED_REQUEST_CREATE)
        ]);
        return new Set([
            (0, $8Z0nB.DEFAULT)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $dWc7u.stopTTI,
            cancelTTI: $dWc7u.cancelTTI,
            markIframeLoad: $dWc7u.markIframeLoad,
            markFieldsRegistered: $dWc7u.markFieldsRegistered,
            markOnInitResolved: $dWc7u.markOnInitResolved
        };
        /**
   * memoizeOne is used to avoid recreating the config objects.
   */ this.getSupportedFieldsConfiguration = (0, $hXXvg.default)(()=>{
            const commonFieldValidators = (0, $g2Pgd.getCommonFieldValidators)();
            return {
                [(0, $8Z0nB.SUMMARY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $eVj0v.validateSingleLineTextValue)
                    },
                    publicToInternalTransformers: {},
                    internalToPublicTransformers: {
                        value: (0, $eNzDF.singleLineTextFieldGetValueTransformer)
                    },
                    emitChangeOn: 'blur',
                    modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($3uvNM)))
                },
                [(0, $8Z0nB.SELECT_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $2dOdd.selectSetValueValidator),
                        optionsVisibility: (0, $6wLn7.validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, $lp7oK.selectSetValueTransformer),
                        optionsVisibility: (0, $lp7oK.transformSelectSetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, $lp7oK.selectGetValueTransformer),
                        optionsVisibility: (0, $lp7oK.transformSelectGetOptionsVisibility)
                    },
                    lookupSource: (0, $l1rhI.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                    initializeFieldPropertyMapping: {
                        allowedValues: 'options',
                        value: 'defaultValue'
                    },
                    propertyMapping: {
                        optionsVisibility: 'options'
                    },
                    emitChangeOn: 'change',
                    modifyValueToBasic: (0, $lp7oK.modifySelectValueToBasic)
                },
                ...$81e5e20101690d25$export$97cf619b5c503901() && {
                    [(0, $8Z0nB.TEXT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $eVj0v.validateSingleLineTextValue)
                        },
                        publicToInternalTransformers: {},
                        internalToPublicTransformers: {
                            value: (0, $eNzDF.singleLineTextFieldGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($3uvNM)))
                    }
                },
                ...$81e5e20101690d25$export$5377338157c93a4a() && {
                    [(0, $8Z0nB.NUMBER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $b0BQW.validateNumberValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $b0BQW.transformNumberToInternalValue)
                        },
                        internalToPublicTransformers: {
                            value: (0, $b0BQW.transformNumberToPublicValue)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($3uvNM)))
                    }
                },
                ...$81e5e20101690d25$export$3d9060e51ab7079e() && {
                    [(0, $8Z0nB.MULTI_SELECT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $hnD3A.validateMultiCheckboxSetValue),
                            optionsVisibility: (0, $6wLn7.validateSetOptionsVisibilityRule)
                        },
                        publicToInternalTransformers: {
                            value: (0, $hnD3A.multiCheckboxSetValueTransformer),
                            optionsVisibility: (0, $hnD3A.multiCheckboxSetOptionsVisibilityTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $hnD3A.multiCheckboxGetValueTransformer),
                            optionsVisibility: (0, $hnD3A.multiCheckboxGetOptionsVisibilityTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $l1rhI.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'options',
                            value: 'defaultValue'
                        },
                        propertyMapping: {
                            optionsVisibility: 'options'
                        },
                        modifyValueToBasic: (0, $hnD3A.modifyMultiSelectValueToBasic)
                    }
                },
                [(0, $8Z0nB.PRIORITY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $atL5x.validatePrioritySetValue),
                        optionsVisibility: (0, $jLx2t.validateSetOptionsVisibility)
                    },
                    publicToInternalTransformers: {
                        value: (0, $atL5x.prioritySetValueTransformer),
                        optionsVisibility: (0, $atL5x.prioritySetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, $atL5x.priorityGetValueTransformer),
                        optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3uvNM)))
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $l1rhI.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                    initializeFieldPropertyMapping: {
                        allowedValues: 'options',
                        value: 'defaultValue'
                    },
                    propertyMapping: {
                        optionsVisibility: 'options'
                    },
                    modifyValueToBasic: (0, $atL5x.modifyPriorityValueToBasic)
                },
                ...$81e5e20101690d25$export$ca4e8050793caa6() && {
                    [(0, $8Z0nB.DUE_DATE_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $dUHPW.datePickerSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $dUHPW.datePickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $dUHPW.datePickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($3uvNM)))
                    }
                },
                ...$81e5e20101690d25$export$a3127feadc5f63ef() && {
                    [(0, $8Z0nB.DATETIME_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $6iKXS.validateDateTimePickerSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $6iKXS.transformDateTimePickerSetValue)
                        },
                        internalToPublicTransformers: {
                            value: (0, $6iKXS.transformDateTimePickerGetValue)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($3uvNM)))
                    }
                },
                ...$81e5e20101690d25$export$682d85ee096f07a9() && {
                    [(0, $8Z0nB.TEXT_AREA_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $lkMEg.validateTextAreaValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $lkMEg.textAreaSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $lkMEg.textAreaGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($3uvNM)))
                    }
                },
                ...$81e5e20101690d25$export$120971fff910541d() && {
                    [(0, $8Z0nB.DESCRIPTION_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $lkMEg.validateTextAreaValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $lkMEg.textAreaSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $lkMEg.textAreaGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($3uvNM)))
                    }
                },
                ...$81e5e20101690d25$export$b738c6acf33d051a() && {
                    [(0, $8Z0nB.CASCADING_SELECT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $ktqPw.validateCascadingSelectSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $ktqPw.transformSetValueCascadingSelect)
                        },
                        internalToPublicTransformers: {
                            value: (0, $ktqPw.transformGetValueCascadingSelect)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $l1rhI.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'options',
                            value: 'defaultValue'
                        },
                        modifyValueToBasic: (0, $ktqPw.transformValueToBasicCascadingSelect)
                    }
                },
                ...$81e5e20101690d25$export$1df7079ae40c80e4() && {
                    [(0, $8Z0nB.DATEPICKER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $dUHPW.datePickerSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $dUHPW.datePickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $dUHPW.datePickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($3uvNM)))
                    }
                },
                ...$81e5e20101690d25$export$fe4ccb1b2f4366aa() && {
                    [(0, $8Z0nB.LABELS_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $aX2eV.labelsSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $aX2eV.labelsSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $aX2eV.labelsGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        initializeFieldPropertyMapping: {
                            value: 'defaultLabels'
                        },
                        modifyValueToBasic: (0, $aX2eV.modifyLabelsValueToBasic)
                    }
                },
                ...$81e5e20101690d25$export$d16c700a701ab994() && {
                    [(0, $8Z0nB.USER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $bmDvS.validateUserPickerSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $bmDvS.userPickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $bmDvS.userPickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $l1rhI.LOOKUP_SOURCE_USERS_ASYNC_DATA),
                        initializeFieldPropertyMapping: {
                            value: 'defaultUser'
                        },
                        modifyValueToBasic: (0, $bmDvS.modifyUserPickerValueToBasic)
                    }
                }
            };
        });
        this.getSupportedFieldTypes = (0, $hXXvg.default)(()=>{
            const supportedFieldTypes = [
                (0, $8Z0nB.SUMMARY_TYPE),
                (0, $8Z0nB.SELECT_CF_TYPE),
                (0, $8Z0nB.USER_CF_TYPE),
                (0, $8Z0nB.TEXT_CF_TYPE),
                (0, $8Z0nB.TEXT_AREA_CF_TYPE),
                (0, $8Z0nB.DESCRIPTION_TYPE),
                (0, $8Z0nB.NUMBER_CF_TYPE),
                (0, $8Z0nB.MULTI_SELECT_CF_TYPE),
                (0, $8Z0nB.PRIORITY_TYPE),
                (0, $8Z0nB.DATETIME_CF_TYPE),
                (0, $8Z0nB.DUE_DATE_TYPE),
                (0, $8Z0nB.CASCADING_SELECT_CF_TYPE),
                (0, $8Z0nB.DATEPICKER_CF_TYPE),
                (0, $8Z0nB.LABELS_TYPE)
            ];
            return supportedFieldTypes;
        });
        // Note: should be removed by bumping @atlassian/ui-modifications-core to the next minor version. Behavior will default to being true.
        this.isScreenTabsSupportEnabled = ()=>true;
    }
}

});
parcelRegister("g2Pgd", function(module, exports) {
$parcel$export(module.exports, "getCommonFieldValidators", () => $ce6e09ae3cc4f632$export$68248012b0fecf7d);
const $ce6e09ae3cc4f632$export$68248012b0fecf7d = ()=>({
        fieldName: (value)=>typeof value === 'string',
        isVisible: (value)=>typeof value === 'boolean',
        description: $ce6e09ae3cc4f632$export$b5ccb7b3af83de7e,
        isReadOnly: (value, { isReadOnlyBySystem: isReadOnlyBySystem })=>typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem),
        isRequired: (value, { isRequiredBySystem: isRequiredBySystem })=>typeof value === 'boolean' && (value || !value && !isRequiredBySystem)
    });
const $ce6e09ae3cc4f632$export$b5ccb7b3af83de7e = async (value)=>{
    if (typeof value !== 'string') return false;
    return true;
};

});

parcelRegister("2dOdd", function(module, exports) {
$parcel$export(module.exports, "selectSetValueValidator", () => $3695062a31c6d368$export$c02b1c2a574ca4c7);

var $bo2nr = parcelRequire("bo2nr");

var $b78Ww = parcelRequire("b78Ww");
const $3695062a31c6d368$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $b78Ww.isNotEmptyString)(value);
const $3695062a31c6d368$export$f22935386c756879 = (value)=>value === null || (0, $b78Ww.isNotEmptyString)(value) && (0, $bo2nr.isAriResourceIdValid)(value);

});
parcelRegister("bo2nr", function(module, exports) {
$parcel$export(module.exports, "isAriResourceIdValid", () => $b301ab2ecd2b957e$export$4d1e9901084f3bf6);

var $9HbRb = parcelRequire("9HbRb");
const $b301ab2ecd2b957e$var$CLOUD_ID_MOCK = 'cloud-id';
const $b301ab2ecd2b957e$var$ACTIVATION_ID_MOCK = 'activation-id';
const $b301ab2ecd2b957e$var$FIELD_ID_MOCK = 'field-1';
const $b301ab2ecd2b957e$export$4d1e9901084f3bf6 = (optionId)=>{
    try {
        (0, $9HbRb.JiraIssueFieldOptionAri).create({
            siteId: $b301ab2ecd2b957e$var$CLOUD_ID_MOCK,
            activationId: $b301ab2ecd2b957e$var$ACTIVATION_ID_MOCK,
            fieldId: $b301ab2ecd2b957e$var$FIELD_ID_MOCK,
            optionId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("9HbRb", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $70f153b6ba323a23$export$e3bc1ec22f941fbe);

var $aHCFZ = parcelRequire("aHCFZ");

var $jmrxw = parcelRequire("jmrxw");

var $6LWYQ = parcelRequire("6LWYQ");
// src/jira/issue-field-option/manifest.ts
var $70f153b6ba323a23$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aHCFZ.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $aHCFZ.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $70f153b6ba323a23$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $jmrxw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $70f153b6ba323a23$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $70f153b6ba323a23$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $70f153b6ba323a23$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $70f153b6ba323a23$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $6LWYQ.AriParser).fromOpts(derivedOpts, $70f153b6ba323a23$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6LWYQ.AriParser).fromString(maybeAri, $70f153b6ba323a23$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("aHCFZ", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $7cabebd857f7c705$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $7cabebd857f7c705$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $7cabebd857f7c705$export$eb4f4cf0880fe5a8 = "jira", $7cabebd857f7c705$export$4bec333360908e78 = "issue-field-option";

});



parcelRegister("b78Ww", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyString", () => $72323349d3f3b397$export$582443c7ead02173);
const $72323349d3f3b397$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';

});


parcelRegister("eVj0v", function(module, exports) {
$parcel$export(module.exports, "validateSingleLineTextValue", () => $3877714e56236c26$export$88db43fe998a9953);
const $3877714e56236c26$export$88db43fe998a9953 = (value)=>typeof value === 'string';

});

parcelRegister("6wLn7", function(module, exports) {
$parcel$export(module.exports, "validateSetOptionsVisibilityRule", () => $e9645680300d69cb$export$cb8a43658ea03ec7);

var $j7DJp = parcelRequire("j7DJp");

var $b78Ww = parcelRequire("b78Ww");
const $e9645680300d69cb$export$cb8a43658ea03ec7 = (optionsVisibility)=>(0, (/*@__PURE__*/$parcel$interopDefault($j7DJp)))(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every((0, $b78Ww.isNotEmptyString));

});

parcelRegister("dWc7u", function(module, exports) {
$parcel$export(module.exports, "startScreenTTIWithUIModifications", () => $c02b938a076b0247$export$750bc2c2ef1a94b6);
$parcel$export(module.exports, "stopTTI", () => $c02b938a076b0247$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $c02b938a076b0247$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $c02b938a076b0247$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $c02b938a076b0247$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $c02b938a076b0247$export$d86f4868694f2aa7);

var $ewGAZ = parcelRequire("ewGAZ");
const $c02b938a076b0247$export$376630eeb367a07a = (0, $ewGAZ.metrics).interaction({
    key: 'request-create-tti-with-ui-modifications',
    timings: [
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $c02b938a076b0247$export$750bc2c2ef1a94b6 = ()=>{
    $c02b938a076b0247$export$376630eeb367a07a.start();
};
const $c02b938a076b0247$export$30ca4c461fab486c = (customData)=>{
    $c02b938a076b0247$export$376630eeb367a07a.stop({
        customData: customData
    });
};
const $c02b938a076b0247$export$27f2445288b528c = ()=>{
    $c02b938a076b0247$export$376630eeb367a07a.cancel();
};
const $c02b938a076b0247$export$7a2709fc1e33401a = ()=>{
    $c02b938a076b0247$export$376630eeb367a07a.mark('iframe-load');
};
const $c02b938a076b0247$export$cf3893335c93e33b = ()=>{
    $c02b938a076b0247$export$376630eeb367a07a.mark('fields-registered');
};
const $c02b938a076b0247$export$d86f4868694f2aa7 = ()=>{
    $c02b938a076b0247$export$376630eeb367a07a.mark('oninit-resolved');
};

});

parcelRegister("8Z0nB", function(module, exports) {
$parcel$export(module.exports, "SUMMARY_TYPE", () => $a12c5ea4bfbf0ee1$export$907219511d14ba3d);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $a12c5ea4bfbf0ee1$export$22ac48a51c014e4b);
$parcel$export(module.exports, "USER_CF_TYPE", () => $a12c5ea4bfbf0ee1$export$c491a4b98394028e);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $a12c5ea4bfbf0ee1$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $a12c5ea4bfbf0ee1$export$39cd48613b53ce2f);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $a12c5ea4bfbf0ee1$export$c5d13ea26562d57a);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $a12c5ea4bfbf0ee1$export$34740f8d07d23ac0);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $a12c5ea4bfbf0ee1$export$c7faa96db185cfc6);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $a12c5ea4bfbf0ee1$export$42d097f7b1622ef1);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $a12c5ea4bfbf0ee1$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $a12c5ea4bfbf0ee1$export$5e7324042f1d6b31);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $a12c5ea4bfbf0ee1$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "DATEPICKER_CF_TYPE", () => $a12c5ea4bfbf0ee1$export$69c9cc9ff399807f);
$parcel$export(module.exports, "LABELS_TYPE", () => $a12c5ea4bfbf0ee1$export$43b6e33ec70f2272);
$parcel$export(module.exports, "DEFAULT", () => $a12c5ea4bfbf0ee1$export$e6952b12ade67489);
$parcel$export(module.exports, "EMBEDDED_REQUEST_CREATE", () => $a12c5ea4bfbf0ee1$export$75d9313789677296);
const $a12c5ea4bfbf0ee1$export$907219511d14ba3d = 'summary';
const $a12c5ea4bfbf0ee1$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $a12c5ea4bfbf0ee1$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $a12c5ea4bfbf0ee1$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $a12c5ea4bfbf0ee1$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $a12c5ea4bfbf0ee1$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $a12c5ea4bfbf0ee1$export$34740f8d07d23ac0 = 'priority';
const $a12c5ea4bfbf0ee1$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $a12c5ea4bfbf0ee1$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $a12c5ea4bfbf0ee1$export$b159f8b8f27aae4c = 'duedate';
const $a12c5ea4bfbf0ee1$export$5e7324042f1d6b31 = 'description';
const $a12c5ea4bfbf0ee1$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $a12c5ea4bfbf0ee1$export$69c9cc9ff399807f = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $a12c5ea4bfbf0ee1$export$43b6e33ec70f2272 = 'labels';
const $a12c5ea4bfbf0ee1$export$e6952b12ade67489 = 'default';
const $a12c5ea4bfbf0ee1$export$75d9313789677296 = 'embedded-request-create';

});

parcelRegister("ktqPw", function(module, exports) {
$parcel$export(module.exports, "validateCascadingSelectSetValue", () => $99a1c18e24e3bbcf$export$2d586ab6ce4d7126);
$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $99a1c18e24e3bbcf$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $99a1c18e24e3bbcf$export$47e9770ed0d1c344);
$parcel$export(module.exports, "normalizeCascadingSelectValue", () => $99a1c18e24e3bbcf$export$e9eb61f6a3bc0438);
$parcel$export(module.exports, "transformValueToBasicCascadingSelect", () => $99a1c18e24e3bbcf$export$4fe225ca7554ff11);

var $9aVeJ = parcelRequire("9aVeJ");

var $b78Ww = parcelRequire("b78Ww");

var $1EFS8 = parcelRequire("1EFS8");
const $99a1c18e24e3bbcf$var$findCascadingSelectLookupValues = (lookupData, parentId, childId)=>{
    const foundOption = lookupData.find((currentOption)=>currentOption.value === parentId);
    if (!foundOption) throw new (0, $9aVeJ.FieldValueLookupError)();
    const childOption = childId !== null && foundOption.children ? foundOption.children.find((child)=>child.value === childId) || null : null;
    const value = {
        parent: foundOption,
        children: childOption
    };
    return value;
};
const $99a1c18e24e3bbcf$export$2d586ab6ce4d7126 = (value)=>{
    return value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $b78Ww.isNotEmptyString)(value.parentId) && ((0, $b78Ww.isNotEmptyString)(value.childId) || value.childId === null);
};
const $99a1c18e24e3bbcf$export$905a8d55c641a71e = (value, lookupData)=>{
    if (value === null || value.parentId === null) return null;
    const cascadingSelectValue = $99a1c18e24e3bbcf$var$findCascadingSelectLookupValues(lookupData, value.parentId, value.childId);
    return {
        primaryValue: cascadingSelectValue.parent,
        children: cascadingSelectValue.children
    };
};
const $99a1c18e24e3bbcf$export$47e9770ed0d1c344 = (cascadingValue)=>{
    if (!cascadingValue || (0, $1EFS8.default).checkGate('ditto_fix_getvalue_empty_state') && !cascadingValue.primaryValue) return null;
    const { primaryValue: primaryValue, children: children } = cascadingValue;
    return {
        parent: {
            id: primaryValue.value,
            value: primaryValue.label
        },
        child: children ? {
            id: children.value,
            value: children.label
        } : null
    };
};
const $99a1c18e24e3bbcf$export$e9eb61f6a3bc0438 = (value)=>{
    var _children, _value$primaryValue;
    if (!value) return {
        primaryValue: null,
        children: null
    };
    // If it's already NestedFieldValueType (string-based primaryValue)
    if (typeof value.primaryValue === 'string' || value.primaryValue === null) return value;
    // If it's object-based, extract string values
    const childrenValue = (_children = value.children) === null || _children === void 0 ? void 0 : _children.value;
    return {
        primaryValue: ((_value$primaryValue = value.primaryValue) === null || _value$primaryValue === void 0 ? void 0 : _value$primaryValue.value) || null,
        children: childrenValue || null
    };
};
const $99a1c18e24e3bbcf$export$4fe225ca7554ff11 = (value)=>{
    var _value$primaryValue2, _value$children;
    if (!value) return {
        primaryValue: null,
        children: null
    };
    return {
        primaryValue: ((_value$primaryValue2 = value.primaryValue) === null || _value$primaryValue2 === void 0 ? void 0 : _value$primaryValue2.value) || null,
        children: ((_value$children = value.children) === null || _value$children === void 0 ? void 0 : _value$children.value) || null
    };
};

});

parcelRegister("dUHPW", function(module, exports) {
$parcel$export(module.exports, "datePickerSetValueValidator", () => $90386a75aa63d27b$export$c003579a97a2459e);
$parcel$export(module.exports, "datePickerSetValueTransformer", () => $90386a75aa63d27b$export$cfb5350c1b8d2150);
$parcel$export(module.exports, "datePickerGetValueTransformer", () => $90386a75aa63d27b$export$e844c6ac3a5cbef7);

var $aLwb2 = parcelRequire("aLwb2");
var $dUEnu = parcelRequire("dUEnu");
var $d8hcI = parcelRequire("d8hcI");
var $5fMoj = parcelRequire("5fMoj");
// Date picker accepts only date string in format yyyy-MM-dd, so we need to validate it
// The date format is consistent with API contract
const $90386a75aa63d27b$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    // `parse` doesn't respect strict format, see known issue https://github.com/date-fns/date-fns/issues/942
    // where format yyyy-MM-dd date 2022-10-2 is parsed successfully but shouldn't
    if (typeof date !== 'string' || dateFormat.length !== date.length) return false;
    const parsedDate = (0, $d8hcI.default)(date, dateFormat, new Date());
    return (0, $dUEnu.default)(parsedDate);
};
const $90386a75aa63d27b$export$c003579a97a2459e = (value)=>value === null || $90386a75aa63d27b$var$dateHasExpectedFormat(value);
const $90386a75aa63d27b$export$cfb5350c1b8d2150 = (publicValue)=>publicValue === null ? '' : publicValue;
const $90386a75aa63d27b$export$e844c6ac3a5cbef7 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $5fMoj.default)(value);
    if ((0, $dUEnu.default)(parsedDate)) return (0, $aLwb2.default)(parsedDate, 'yyyy-MM-dd');
    return null;
};

});
parcelRegister("d8hcI", function(module, exports) {
$parcel$export(module.exports, "default", () => $98f95e147e39d0b0$export$2e2bcd8739ae039);

var $1Vgto = parcelRequire("1Vgto");

var $7kJ8D = parcelRequire("7kJ8D");

var $2WLy2 = parcelRequire("2WLy2");

var $j72dC = parcelRequire("j72dC");

var $bNvBk = parcelRequire("bNvBk");

var $6MqXb = parcelRequire("6MqXb");

var $9Xddg = parcelRequire("9Xddg");

var $7idWn = parcelRequire("7idWn");

var $jM2Hx = parcelRequire("jM2Hx");

var $gucCl = parcelRequire("gucCl");

var $vJNuT = parcelRequire("vJNuT");

var $77Dbc = parcelRequire("77Dbc");

var $1YSvX = parcelRequire("1YSvX");

var $a0pIq = parcelRequire("a0pIq");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $98f95e147e39d0b0$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $98f95e147e39d0b0$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $98f95e147e39d0b0$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $98f95e147e39d0b0$var$doubleQuoteRegExp = /''/g;
var $98f95e147e39d0b0$var$notWhitespaceRegExp = /\S/;
var $98f95e147e39d0b0$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $98f95e147e39d0b0$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $vJNuT.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $a0pIq.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $2WLy2.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $gucCl.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $gucCl.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $bNvBk.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $77Dbc.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($98f95e147e39d0b0$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $9Xddg.default)) {
            var longFormatter = (0, $9Xddg.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($98f95e147e39d0b0$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $7kJ8D.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $jM2Hx.isProtectedWeekYearToken)(token)) (0, $jM2Hx.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $jM2Hx.isProtectedDayOfYearToken)(token)) (0, $jM2Hx.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $1YSvX.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($98f95e147e39d0b0$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $98f95e147e39d0b0$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $1Vgto.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $98f95e147e39d0b0$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $bNvBk.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $j72dC.default)(date, (0, $7idWn.default)(date));
    var flags = {};
    var _iterator2 = (0, $7kJ8D.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $6MqXb.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $98f95e147e39d0b0$var$cleanEscapedString(input) {
    return input.match($98f95e147e39d0b0$var$escapedStringRegExp)[1].replace($98f95e147e39d0b0$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("7kJ8D", function(module, exports) {
$parcel$export(module.exports, "default", () => $556d6a2e8fc87534$export$2e2bcd8739ae039);

var $l4iiM = parcelRequire("l4iiM");
function $556d6a2e8fc87534$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $l4iiM.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("l4iiM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5682b0f53c3043e$export$2e2bcd8739ae039);

var $4GqY3 = parcelRequire("4GqY3");
function $f5682b0f53c3043e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $4GqY3.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $4GqY3.default)(r, a) : void 0;
    }
}

});
parcelRegister("4GqY3", function(module, exports) {
$parcel$export(module.exports, "default", () => $369000df81ded3ec$export$2e2bcd8739ae039);
function $369000df81ded3ec$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("6MqXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $4efc22339d14ab3c$export$2e2bcd8739ae039);
function $4efc22339d14ab3c$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("77Dbc", function(module, exports) {
$parcel$export(module.exports, "ValueSetter", () => $52f7941a67aad422$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $52f7941a67aad422$export$5aaf7ff7f09ea4ee);

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $ceo2e = parcelRequire("ceo2e");
var $52f7941a67aad422$var$TIMEZONE_UNIT_PRIORITY = 10;
var $52f7941a67aad422$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $1OhKn.default)(this, Setter);
        (0, $ceo2e.default)(this, "priority", void 0);
        (0, $ceo2e.default)(this, "subPriority", 0);
    }
    (0, $7Hkjs.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $52f7941a67aad422$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $hGVCw.default)(ValueSetter, _Setter);
    var _super = (0, $lKHOE.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $1OhKn.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $7Hkjs.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($52f7941a67aad422$export$81d53e3678089a6);
var $52f7941a67aad422$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $hGVCw.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $lKHOE.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $1OhKn.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this2), "priority", $52f7941a67aad422$var$TIMEZONE_UNIT_PRIORITY);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $7Hkjs.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($52f7941a67aad422$export$81d53e3678089a6);

});
parcelRegister("hGVCw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce130e219b8b7e3a$export$2e2bcd8739ae039);

var $lK6UL = parcelRequire("lK6UL");
function $ce130e219b8b7e3a$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $lK6UL.default)(t, e);
}

});

parcelRegister("lKHOE", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd5fe1c66264e093$export$2e2bcd8739ae039);

var $iqSQA = parcelRequire("iqSQA");

var $1k96P = parcelRequire("1k96P");

var $ktoJH = parcelRequire("ktoJH");
function $fd5fe1c66264e093$export$2e2bcd8739ae039(t) {
    var r = (0, $1k96P.default)();
    return function() {
        var e, o = (0, $iqSQA.default)(t);
        if (r) {
            var s = (0, $iqSQA.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $ktoJH.default)(this, e);
    };
}

});
parcelRegister("iqSQA", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6b5333bb7bd19f5$export$2e2bcd8739ae039);
function $d6b5333bb7bd19f5$export$2e2bcd8739ae039(t) {
    return $d6b5333bb7bd19f5$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d6b5333bb7bd19f5$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1k96P", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f6eb9990b3009fb$export$2e2bcd8739ae039);
function $0f6eb9990b3009fb$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0f6eb9990b3009fb$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("ktoJH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee79b429a629597c$export$2e2bcd8739ae039);

var $1Vgto = parcelRequire("1Vgto");

var $hWoqU = parcelRequire("hWoqU");
function $ee79b429a629597c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $1Vgto.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hWoqU.default)(t);
}

});


parcelRegister("1OhKn", function(module, exports) {
$parcel$export(module.exports, "default", () => $15183a25e3efed29$export$2e2bcd8739ae039);
function $15183a25e3efed29$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("7Hkjs", function(module, exports) {
$parcel$export(module.exports, "default", () => $59ac4e417f235106$export$2e2bcd8739ae039);

var $cYerE = parcelRequire("cYerE");
function $59ac4e417f235106$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $cYerE.default)(o.key), o);
    }
}
function $59ac4e417f235106$export$2e2bcd8739ae039(e, r, t) {
    return r && $59ac4e417f235106$var$_defineProperties(e.prototype, r), t && $59ac4e417f235106$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});


parcelRegister("1YSvX", function(module, exports) {
$parcel$export(module.exports, "parsers", () => $1715ae775dcbd862$export$19131010e7fd8373);

var $insSz = parcelRequire("insSz");

var $dQAOz = parcelRequire("dQAOz");

var $2YLIS = parcelRequire("2YLIS");

var $eaJHZ = parcelRequire("eaJHZ");

var $eIND5 = parcelRequire("eIND5");

var $029JV = parcelRequire("029JV");

var $3hbIZ = parcelRequire("3hbIZ");

var $2OsCZ = parcelRequire("2OsCZ");

var $hzyhn = parcelRequire("hzyhn");

var $8Dtsr = parcelRequire("8Dtsr");

var $lpWc2 = parcelRequire("lpWc2");

var $db4IQ = parcelRequire("db4IQ");

var $GkG01 = parcelRequire("GkG01");

var $aSXsX = parcelRequire("aSXsX");

var $j9kwx = parcelRequire("j9kwx");

var $5xwmv = parcelRequire("5xwmv");

var $eX66r = parcelRequire("eX66r");

var $4yKiV = parcelRequire("4yKiV");

var $8vrTJ = parcelRequire("8vrTJ");

var $lE8me = parcelRequire("lE8me");

var $cNg2O = parcelRequire("cNg2O");

var $i0P2R = parcelRequire("i0P2R");

var $apQpj = parcelRequire("apQpj");

var $bJF3z = parcelRequire("bJF3z");

var $6HnLS = parcelRequire("6HnLS");

var $9Wy36 = parcelRequire("9Wy36");

var $cWswi = parcelRequire("cWswi");

var $hMbvW = parcelRequire("hMbvW");

var $01Noq = parcelRequire("01Noq");

var $1xGxp = parcelRequire("1xGxp");

var $kDc6f = parcelRequire("kDc6f");
var $1715ae775dcbd862$export$19131010e7fd8373 = {
    G: new (0, $insSz.EraParser)(),
    y: new (0, $dQAOz.YearParser)(),
    Y: new (0, $2YLIS.LocalWeekYearParser)(),
    R: new (0, $eaJHZ.ISOWeekYearParser)(),
    u: new (0, $eIND5.ExtendedYearParser)(),
    Q: new (0, $029JV.QuarterParser)(),
    q: new (0, $3hbIZ.StandAloneQuarterParser)(),
    M: new (0, $2OsCZ.MonthParser)(),
    L: new (0, $hzyhn.StandAloneMonthParser)(),
    w: new (0, $8Dtsr.LocalWeekParser)(),
    I: new (0, $lpWc2.ISOWeekParser)(),
    d: new (0, $db4IQ.DateParser)(),
    D: new (0, $GkG01.DayOfYearParser)(),
    E: new (0, $aSXsX.DayParser)(),
    e: new (0, $j9kwx.LocalDayParser)(),
    c: new (0, $5xwmv.StandAloneLocalDayParser)(),
    i: new (0, $eX66r.ISODayParser)(),
    a: new (0, $4yKiV.AMPMParser)(),
    b: new (0, $8vrTJ.AMPMMidnightParser)(),
    B: new (0, $lE8me.DayPeriodParser)(),
    h: new (0, $cNg2O.Hour1to12Parser)(),
    H: new (0, $i0P2R.Hour0to23Parser)(),
    K: new (0, $apQpj.Hour0To11Parser)(),
    k: new (0, $bJF3z.Hour1To24Parser)(),
    m: new (0, $6HnLS.MinuteParser)(),
    s: new (0, $9Wy36.SecondParser)(),
    S: new (0, $cWswi.FractionOfSecondParser)(),
    X: new (0, $hMbvW.ISOTimezoneWithZParser)(),
    x: new (0, $01Noq.ISOTimezoneParser)(),
    t: new (0, $1xGxp.TimestampSecondsParser)(),
    T: new (0, $kDc6f.TimestampMillisecondsParser)()
};

});
parcelRegister("insSz", function(module, exports) {
$parcel$export(module.exports, "EraParser", () => $d610c6c357759ac0$export$8e5a1d3f85a9688);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");
var $d610c6c357759ac0$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(EraParser, _Parser);
    var _super = (0, $lKHOE.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $1OhKn.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 140);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $2PGCO.Parser));

});
parcelRegister("2PGCO", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $210168a17615a475$export$7acfa6ed01010e37);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $ceo2e = parcelRequire("ceo2e");

var $77Dbc = parcelRequire("77Dbc");
var $210168a17615a475$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $1OhKn.default)(this, Parser);
        (0, $ceo2e.default)(this, "incompatibleTokens", void 0);
        (0, $ceo2e.default)(this, "priority", void 0);
        (0, $ceo2e.default)(this, "subPriority", void 0);
    }
    (0, $7Hkjs.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $77Dbc.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("dQAOz", function(module, exports) {
$parcel$export(module.exports, "YearParser", () => $a14cb04b77764645$export$48d352de7cd4a988);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $a14cb04b77764645$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(YearParser, _Parser);
    var _super = (0, $lKHOE.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $1OhKn.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 130);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $gKhUr.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $gKhUr.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $2PGCO.Parser));

});
parcelRegister("gKhUr", function(module, exports) {
$parcel$export(module.exports, "mapValue", () => $c30ed5a55c7689b4$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $c30ed5a55c7689b4$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $c30ed5a55c7689b4$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $c30ed5a55c7689b4$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $c30ed5a55c7689b4$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $c30ed5a55c7689b4$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $c30ed5a55c7689b4$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $c30ed5a55c7689b4$export$3d50627710b84d75);

var $90rr6 = parcelRequire("90rr6");

var $6h2xQ = parcelRequire("6h2xQ");
function $c30ed5a55c7689b4$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $c30ed5a55c7689b4$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $90rr6.millisecondsInHour) + minutes * (0, $90rr6.millisecondsInMinute) + seconds * (0, $90rr6.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $c30ed5a55c7689b4$export$d931c43c4608a164(dateString) {
    return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388((0, $6h2xQ.numericPatterns).anyDigitsSigned, dateString);
}
function $c30ed5a55c7689b4$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388((0, $6h2xQ.numericPatterns).singleDigit, dateString);
        case 2:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388((0, $6h2xQ.numericPatterns).twoDigits, dateString);
        case 3:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388((0, $6h2xQ.numericPatterns).threeDigits, dateString);
        case 4:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388((0, $6h2xQ.numericPatterns).fourDigits, dateString);
        default:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $c30ed5a55c7689b4$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388((0, $6h2xQ.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388((0, $6h2xQ.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388((0, $6h2xQ.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388((0, $6h2xQ.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $c30ed5a55c7689b4$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $c30ed5a55c7689b4$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $c30ed5a55c7689b4$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $c30ed5a55c7689b4$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("90rr6", function(module, exports) {
$parcel$export(module.exports, "millisecondsInMinute", () => $68e9656696b13ca4$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $68e9656696b13ca4$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $68e9656696b13ca4$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $68e9656696b13ca4$export$dfd9b671c89acc8e = 7;
var $68e9656696b13ca4$export$3913210603d8e9ae = 365.2425;
var $68e9656696b13ca4$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $68e9656696b13ca4$export$91246f0b9bd9beff = 60000;
var $68e9656696b13ca4$export$7f72910d6dfd237a = 3600000;
var $68e9656696b13ca4$export$397c2d5776aa9055 = 1000;
var $68e9656696b13ca4$export$4dec998e48f9c246 = -$68e9656696b13ca4$export$81caae6e1cc7a622;
var $68e9656696b13ca4$export$f2f5ae5a8e2d8f9f = 60;
var $68e9656696b13ca4$export$3c58128db900d44e = 3;
var $68e9656696b13ca4$export$80d7e435f744f319 = 12;
var $68e9656696b13ca4$export$4db7641526e3241f = 4;
var $68e9656696b13ca4$export$698aec755e92c695 = 3600;
var $68e9656696b13ca4$export$a77c1a7ebebe2a5a = 60;
var $68e9656696b13ca4$export$815a9362476d2fe3 = $68e9656696b13ca4$export$698aec755e92c695 * 24;
var $68e9656696b13ca4$export$34804a017b31e2fe = $68e9656696b13ca4$export$815a9362476d2fe3 * 7;
var $68e9656696b13ca4$export$7271e9e3478110d1 = $68e9656696b13ca4$export$815a9362476d2fe3 * $68e9656696b13ca4$export$3913210603d8e9ae;
var $68e9656696b13ca4$export$8e6600bbdee7dabb = $68e9656696b13ca4$export$7271e9e3478110d1 / 12;
var $68e9656696b13ca4$export$be1dccf2de902d31 = $68e9656696b13ca4$export$8e6600bbdee7dabb * 3;

});

parcelRegister("6h2xQ", function(module, exports) {
$parcel$export(module.exports, "numericPatterns", () => $49164df9ec09ee34$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $49164df9ec09ee34$export$a7ee192b982af9c1);
var $49164df9ec09ee34$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $49164df9ec09ee34$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("2YLIS", function(module, exports) {
$parcel$export(module.exports, "LocalWeekYearParser", () => $22b6341c6ef5ebf4$export$b8ef38dfcf05d5db);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");

var $kBtdq = parcelRequire("kBtdq");

var $4N9Ow = parcelRequire("4N9Ow");
var $22b6341c6ef5ebf4$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $lKHOE.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $1OhKn.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 130);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $gKhUr.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $kBtdq.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $gKhUr.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $4N9Ow.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $4N9Ow.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $2PGCO.Parser));

});

parcelRegister("eaJHZ", function(module, exports) {
$parcel$export(module.exports, "ISOWeekYearParser", () => $02a9a2e9d5d7d6c9$export$951d1df011fde06f);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");

var $9u5Tc = parcelRequire("9u5Tc");
var $02a9a2e9d5d7d6c9$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $lKHOE.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $1OhKn.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 130);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $gKhUr.parseNDigitsSigned)(4, dateString);
                return (0, $gKhUr.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $9u5Tc.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $2PGCO.Parser));

});

parcelRegister("eIND5", function(module, exports) {
$parcel$export(module.exports, "ExtendedYearParser", () => $ab7bac22b030b7d9$export$bad9d2ea38e8f1a);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $ab7bac22b030b7d9$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(ExtendedYearParser, _Parser);
    var _super = (0, $lKHOE.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $1OhKn.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 130);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $gKhUr.parseNDigitsSigned)(4, dateString);
                return (0, $gKhUr.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $2PGCO.Parser));

});

parcelRegister("029JV", function(module, exports) {
$parcel$export(module.exports, "QuarterParser", () => $0067be1fb4ae7435$export$5cb0f701186dde1d);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $0067be1fb4ae7435$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(QuarterParser, _Parser);
    var _super = (0, $lKHOE.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $1OhKn.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 120);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $2PGCO.Parser));

});

parcelRegister("3hbIZ", function(module, exports) {
$parcel$export(module.exports, "StandAloneQuarterParser", () => $262c0dec6deb1d42$export$300c0c2990e20e6d);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $262c0dec6deb1d42$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $lKHOE.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $1OhKn.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 120);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $2PGCO.Parser));

});

parcelRegister("2OsCZ", function(module, exports) {
$parcel$export(module.exports, "MonthParser", () => $20c6752ca98dc60a$export$400dd8b40ef138a3);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $gKhUr = parcelRequire("gKhUr");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");
var $20c6752ca98dc60a$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(MonthParser, _Parser);
    var _super = (0, $lKHOE.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $1OhKn.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 110);
        return _this;
    }
    (0, $7Hkjs.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $gKhUr.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $2PGCO.Parser));

});

parcelRegister("hzyhn", function(module, exports) {
$parcel$export(module.exports, "StandAloneMonthParser", () => $ccb04bb2a7cfcdbf$export$1d7eaa53eaa5deba);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $ccb04bb2a7cfcdbf$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $lKHOE.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $1OhKn.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 110);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $gKhUr.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $2PGCO.Parser));

});

parcelRegister("8Dtsr", function(module, exports) {
$parcel$export(module.exports, "LocalWeekParser", () => $6498d0f1e3a6157f$export$c4005ffc174e07c0);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");

var $f4fyz = parcelRequire("f4fyz");

var $4N9Ow = parcelRequire("4N9Ow");
var $6498d0f1e3a6157f$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(LocalWeekParser, _Parser);
    var _super = (0, $lKHOE.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $1OhKn.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 100);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $4N9Ow.default)((0, $f4fyz.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $2PGCO.Parser));

});
parcelRegister("f4fyz", function(module, exports) {
$parcel$export(module.exports, "default", () => $af834bf780cfaccd$export$2e2bcd8739ae039);

var $gucCl = parcelRequire("gucCl");

var $bNvBk = parcelRequire("bNvBk");

var $ZUXIX = parcelRequire("ZUXIX");

var $vJNuT = parcelRequire("vJNuT");
function $af834bf780cfaccd$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $vJNuT.default)(2, arguments);
    var date = (0, $bNvBk.default)(dirtyDate);
    var week = (0, $gucCl.default)(dirtyWeek);
    var diff = (0, $ZUXIX.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("lpWc2", function(module, exports) {
$parcel$export(module.exports, "ISOWeekParser", () => $f97912b89b351d91$export$6fc8dbedd560a6af);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");

var $7jnyV = parcelRequire("7jnyV");

var $9u5Tc = parcelRequire("9u5Tc");
var $f97912b89b351d91$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(ISOWeekParser, _Parser);
    var _super = (0, $lKHOE.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $1OhKn.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 100);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $9u5Tc.default)((0, $7jnyV.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $2PGCO.Parser));

});
parcelRegister("7jnyV", function(module, exports) {
$parcel$export(module.exports, "default", () => $552c95c240124825$export$2e2bcd8739ae039);

var $gucCl = parcelRequire("gucCl");

var $bNvBk = parcelRequire("bNvBk");

var $fvN1a = parcelRequire("fvN1a");

var $vJNuT = parcelRequire("vJNuT");
function $552c95c240124825$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $vJNuT.default)(2, arguments);
    var date = (0, $bNvBk.default)(dirtyDate);
    var isoWeek = (0, $gucCl.default)(dirtyISOWeek);
    var diff = (0, $fvN1a.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("db4IQ", function(module, exports) {
$parcel$export(module.exports, "DateParser", () => $997ff73147e1d290$export$e8d4b28a20981dd2);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $gKhUr = parcelRequire("gKhUr");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");
var $997ff73147e1d290$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $997ff73147e1d290$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $997ff73147e1d290$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(DateParser, _Parser);
    var _super = (0, $lKHOE.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $1OhKn.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 90);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "subPriority", 1);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $gKhUr.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $997ff73147e1d290$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $997ff73147e1d290$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $2PGCO.Parser));

});

parcelRegister("GkG01", function(module, exports) {
$parcel$export(module.exports, "DayOfYearParser", () => $07f3f64351e5df33$export$6cfe0d613455f615);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $07f3f64351e5df33$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(DayOfYearParser, _Parser);
    var _super = (0, $lKHOE.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $1OhKn.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 90);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "subpriority", 1);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $gKhUr.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $2PGCO.Parser));

});

parcelRegister("aSXsX", function(module, exports) {
$parcel$export(module.exports, "DayParser", () => $7ecd1339af1b150c$export$1b03c8b76262f7bd);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gZ3io = parcelRequire("gZ3io");
var $7ecd1339af1b150c$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(DayParser, _Parser);
    var _super = (0, $lKHOE.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $1OhKn.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 90);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $gZ3io.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $2PGCO.Parser));

});
parcelRegister("gZ3io", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5d4e648de0868dd$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");

var $gucCl = parcelRequire("gucCl");

var $a0pIq = parcelRequire("a0pIq");
function $c5d4e648de0868dd$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $vJNuT.default)(2, arguments);
    var defaultOptions = (0, $a0pIq.getDefaultOptions)();
    var weekStartsOn = (0, $gucCl.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bNvBk.default)(dirtyDate);
    var day = (0, $gucCl.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("j9kwx", function(module, exports) {
$parcel$export(module.exports, "LocalDayParser", () => $df0ec72f03f8b7df$export$44d1c127ab42c480);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");

var $gZ3io = parcelRequire("gZ3io");
var $df0ec72f03f8b7df$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(LocalDayParser, _Parser);
    var _super = (0, $lKHOE.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $1OhKn.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 90);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $gKhUr.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $gZ3io.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $2PGCO.Parser));

});

parcelRegister("5xwmv", function(module, exports) {
$parcel$export(module.exports, "StandAloneLocalDayParser", () => $4089234101377845$export$e447a647caaaec1d);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");

var $gZ3io = parcelRequire("gZ3io");
var $4089234101377845$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $lKHOE.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $1OhKn.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 90);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $gKhUr.mapValue)((0, $gKhUr.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $gKhUr.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $gZ3io.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $2PGCO.Parser));

});

parcelRegister("eX66r", function(module, exports) {
$parcel$export(module.exports, "ISODayParser", () => $ae2b4f43ec64ec61$export$693fb1e525095b2a);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");

var $KtnX1 = parcelRequire("KtnX1");
var $ae2b4f43ec64ec61$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(ISODayParser, _Parser);
    var _super = (0, $lKHOE.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $1OhKn.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 90);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $gKhUr.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $gKhUr.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $gKhUr.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $gKhUr.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $KtnX1.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $2PGCO.Parser));

});
parcelRegister("KtnX1", function(module, exports) {
$parcel$export(module.exports, "default", () => $08bb174d66bcf6a0$export$2e2bcd8739ae039);

var $bNvBk = parcelRequire("bNvBk");

var $vJNuT = parcelRequire("vJNuT");

var $gucCl = parcelRequire("gucCl");
function $08bb174d66bcf6a0$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $vJNuT.default)(2, arguments);
    var day = (0, $gucCl.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $bNvBk.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("4yKiV", function(module, exports) {
$parcel$export(module.exports, "AMPMParser", () => $351e4179e9f1a6f2$export$8d1e08492351df91);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $351e4179e9f1a6f2$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(AMPMParser, _Parser);
    var _super = (0, $lKHOE.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $1OhKn.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 80);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $gKhUr.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $2PGCO.Parser));

});

parcelRegister("8vrTJ", function(module, exports) {
$parcel$export(module.exports, "AMPMMidnightParser", () => $6316dbeecbc428b5$export$73ca2bd0a17d273);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $6316dbeecbc428b5$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $lKHOE.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $1OhKn.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 80);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $gKhUr.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $2PGCO.Parser));

});

parcelRegister("lE8me", function(module, exports) {
$parcel$export(module.exports, "DayPeriodParser", () => $fc23d104a3225f1c$export$bb9212adf05373db);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $fc23d104a3225f1c$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(DayPeriodParser, _Parser);
    var _super = (0, $lKHOE.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $1OhKn.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 80);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $gKhUr.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $2PGCO.Parser));

});

parcelRegister("cNg2O", function(module, exports) {
$parcel$export(module.exports, "Hour1to12Parser", () => $950681b1910442ad$export$8a04050a727a1756);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $950681b1910442ad$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(Hour1to12Parser, _Parser);
    var _super = (0, $lKHOE.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $1OhKn.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 70);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $2PGCO.Parser));

});

parcelRegister("i0P2R", function(module, exports) {
$parcel$export(module.exports, "Hour0to23Parser", () => $d1cfd297fc8517df$export$e56f4dea2c3e56dd);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $d1cfd297fc8517df$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(Hour0to23Parser, _Parser);
    var _super = (0, $lKHOE.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $1OhKn.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 70);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $2PGCO.Parser));

});

parcelRegister("apQpj", function(module, exports) {
$parcel$export(module.exports, "Hour0To11Parser", () => $7954e42af7da4991$export$cbbe855312f87d77);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $7954e42af7da4991$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(Hour0To11Parser, _Parser);
    var _super = (0, $lKHOE.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $1OhKn.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 70);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $2PGCO.Parser));

});

parcelRegister("bJF3z", function(module, exports) {
$parcel$export(module.exports, "Hour1To24Parser", () => $88b3bea3ecca7a5b$export$6008046d2b34b6a5);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $88b3bea3ecca7a5b$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(Hour1To24Parser, _Parser);
    var _super = (0, $lKHOE.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $1OhKn.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 70);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $2PGCO.Parser));

});

parcelRegister("6HnLS", function(module, exports) {
$parcel$export(module.exports, "MinuteParser", () => $4e0932b8704574d2$export$2b52670d9e2be53);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $4e0932b8704574d2$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(MinuteParser, _Parser);
    var _super = (0, $lKHOE.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $1OhKn.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 60);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $2PGCO.Parser));

});

parcelRegister("9Wy36", function(module, exports) {
$parcel$export(module.exports, "SecondParser", () => $73d3f13e554873fe$export$94d46d540cf1366a);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $73d3f13e554873fe$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(SecondParser, _Parser);
    var _super = (0, $lKHOE.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $1OhKn.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 50);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $gKhUr.parseNumericPattern)((0, $6h2xQ.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $gKhUr.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $2PGCO.Parser));

});

parcelRegister("cWswi", function(module, exports) {
$parcel$export(module.exports, "FractionOfSecondParser", () => $96c1064a0ae1b083$export$b8e6f8b2d70893b1);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $96c1064a0ae1b083$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $lKHOE.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $1OhKn.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 30);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $gKhUr.mapValue)((0, $gKhUr.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $2PGCO.Parser));

});

parcelRegister("hMbvW", function(module, exports) {
$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $cf0fd9d52a5d7ea8$export$104d901d49fea29b);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $cf0fd9d52a5d7ea8$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $lKHOE.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $1OhKn.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 10);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $2PGCO.Parser));

});

parcelRegister("01Noq", function(module, exports) {
$parcel$export(module.exports, "ISOTimezoneParser", () => $0056688a3a28d1d2$export$12910e5204b52b9);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $6h2xQ = parcelRequire("6h2xQ");

var $gKhUr = parcelRequire("gKhUr");
var $0056688a3a28d1d2$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $lKHOE.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $1OhKn.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 10);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $7Hkjs.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $gKhUr.parseTimezonePattern)((0, $6h2xQ.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $2PGCO.Parser));

});

parcelRegister("1xGxp", function(module, exports) {
$parcel$export(module.exports, "TimestampSecondsParser", () => $11f9dea76fc62a89$export$2cd8bf877a05e96);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $11f9dea76fc62a89$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $lKHOE.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $1OhKn.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 40);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $7Hkjs.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $gKhUr.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $2PGCO.Parser));

});

parcelRegister("kDc6f", function(module, exports) {
$parcel$export(module.exports, "TimestampMillisecondsParser", () => $f050d5f44518e930$export$6d8f69c6906d6368);

var $1OhKn = parcelRequire("1OhKn");

var $7Hkjs = parcelRequire("7Hkjs");

var $hWoqU = parcelRequire("hWoqU");

var $hGVCw = parcelRequire("hGVCw");

var $lKHOE = parcelRequire("lKHOE");

var $ceo2e = parcelRequire("ceo2e");

var $2PGCO = parcelRequire("2PGCO");

var $gKhUr = parcelRequire("gKhUr");
var $f050d5f44518e930$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $hGVCw.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $lKHOE.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $1OhKn.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "priority", 20);
        (0, $ceo2e.default)((0, $hWoqU.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $7Hkjs.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $gKhUr.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $2PGCO.Parser));

});



parcelRegister("5fMoj", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d33e3f5ca92ec6e$export$2e2bcd8739ae039);

var $90rr6 = parcelRequire("90rr6");

var $vJNuT = parcelRequire("vJNuT");

var $gucCl = parcelRequire("gucCl");
function $3d33e3f5ca92ec6e$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $vJNuT.default)(1, arguments);
    var additionalDigits = (0, $gucCl.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $3d33e3f5ca92ec6e$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $3d33e3f5ca92ec6e$var$parseYear(dateStrings.date, additionalDigits);
        date = $3d33e3f5ca92ec6e$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $3d33e3f5ca92ec6e$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $3d33e3f5ca92ec6e$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $3d33e3f5ca92ec6e$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $3d33e3f5ca92ec6e$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $3d33e3f5ca92ec6e$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $3d33e3f5ca92ec6e$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $3d33e3f5ca92ec6e$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($3d33e3f5ca92ec6e$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($3d33e3f5ca92ec6e$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($3d33e3f5ca92ec6e$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $3d33e3f5ca92ec6e$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $3d33e3f5ca92ec6e$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $3d33e3f5ca92ec6e$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($3d33e3f5ca92ec6e$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $3d33e3f5ca92ec6e$var$parseDateUnit(captures[1]);
    var month = $3d33e3f5ca92ec6e$var$parseDateUnit(captures[2]) - 1;
    var day = $3d33e3f5ca92ec6e$var$parseDateUnit(captures[3]);
    var week = $3d33e3f5ca92ec6e$var$parseDateUnit(captures[4]);
    var dayOfWeek = $3d33e3f5ca92ec6e$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$3d33e3f5ca92ec6e$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $3d33e3f5ca92ec6e$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$3d33e3f5ca92ec6e$var$validateDate(year, month, day) || !$3d33e3f5ca92ec6e$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $3d33e3f5ca92ec6e$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $3d33e3f5ca92ec6e$var$parseTime(timeString) {
    var captures = timeString.match($3d33e3f5ca92ec6e$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $3d33e3f5ca92ec6e$var$parseTimeUnit(captures[1]);
    var minutes = $3d33e3f5ca92ec6e$var$parseTimeUnit(captures[2]);
    var seconds = $3d33e3f5ca92ec6e$var$parseTimeUnit(captures[3]);
    if (!$3d33e3f5ca92ec6e$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $90rr6.millisecondsInHour) + minutes * (0, $90rr6.millisecondsInMinute) + seconds * 1000;
}
function $3d33e3f5ca92ec6e$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $3d33e3f5ca92ec6e$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($3d33e3f5ca92ec6e$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$3d33e3f5ca92ec6e$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $90rr6.millisecondsInHour) + minutes * (0, $90rr6.millisecondsInMinute));
}
function $3d33e3f5ca92ec6e$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $3d33e3f5ca92ec6e$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $3d33e3f5ca92ec6e$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $3d33e3f5ca92ec6e$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($3d33e3f5ca92ec6e$var$daysInMonths[month] || ($3d33e3f5ca92ec6e$var$isLeapYearIndex(year) ? 29 : 28));
}
function $3d33e3f5ca92ec6e$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($3d33e3f5ca92ec6e$var$isLeapYearIndex(year) ? 366 : 365);
}
function $3d33e3f5ca92ec6e$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $3d33e3f5ca92ec6e$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $3d33e3f5ca92ec6e$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});


parcelRegister("6iKXS", function(module, exports) {
$parcel$export(module.exports, "validateDateTimePickerSetValue", () => $b662d6b40d30e189$export$7930ddff407505cc);
$parcel$export(module.exports, "transformDateTimePickerSetValue", () => $b662d6b40d30e189$export$e81204f19744e19f);
$parcel$export(module.exports, "transformDateTimePickerGetValue", () => $b662d6b40d30e189$export$4cb6c79fda4a9c74);

var $aLwb2 = parcelRequire("aLwb2");
var $jEWjA = parcelRequire("jEWjA");
var $dUEnu = parcelRequire("dUEnu");
var $5fMoj = parcelRequire("5fMoj");
// Date time picker accepts only date string in format YYYY-MM-DDThh:mm:ssTZD
const $b662d6b40d30e189$var$formatString = "yyyy-MM-dd'T'HH:mmxxx";
const $b662d6b40d30e189$export$a886f5166a4d311e = (fullDate)=>{
    if (typeof fullDate !== 'string') return false;
    return (0, $jEWjA.default)(fullDate, $b662d6b40d30e189$var$formatString) && (0, $dUEnu.default)((0, $5fMoj.default)(fullDate));
};
const $b662d6b40d30e189$export$7930ddff407505cc = (value)=>{
    return value === null || $b662d6b40d30e189$export$a886f5166a4d311e(value);
};
const $b662d6b40d30e189$export$e81204f19744e19f = (publicValue)=>{
    return publicValue === null ? '' : publicValue;
};
const $b662d6b40d30e189$export$4cb6c79fda4a9c74 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $5fMoj.default)(value);
    if ((0, $dUEnu.default)(parsedDate)) return (0, $aLwb2.default)(parsedDate, $b662d6b40d30e189$var$formatString);
    return null;
};

});
parcelRegister("jEWjA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4fefce6046c2c4c$export$2e2bcd8739ae039);

var $d8hcI = parcelRequire("d8hcI");

var $dUEnu = parcelRequire("dUEnu");

var $vJNuT = parcelRequire("vJNuT");
function $e4fefce6046c2c4c$export$2e2bcd8739ae039(dateString, formatString, options) {
    (0, $vJNuT.default)(2, arguments);
    return (0, $dUEnu.default)((0, $d8hcI.default)(dateString, formatString, new Date(), options));
}

});


parcelRegister("aX2eV", function(module, exports) {
$parcel$export(module.exports, "labelsSetValueValidator", () => $82c1853803d772cc$export$e67b5652c846b5f);
$parcel$export(module.exports, "labelsSetValueTransformer", () => $82c1853803d772cc$export$861e9d180b68fea1);
$parcel$export(module.exports, "labelsGetValueTransformer", () => $82c1853803d772cc$export$b0b12fd0b1cd9d3a);
$parcel$export(module.exports, "modifyLabelsValueToBasic", () => $82c1853803d772cc$export$627e5994af99713c);
const $82c1853803d772cc$export$e67b5652c846b5f = (value)=>Array.isArray(value) && value.every((label)=>typeof label === 'string' && label !== '');
const $82c1853803d772cc$export$861e9d180b68fea1 = (publicValue)=>publicValue.map((label)=>({
            label: label,
            value: label
        }));
const $82c1853803d772cc$export$b0b12fd0b1cd9d3a = (internalValue)=>internalValue.map(({ value: value })=>value);
const $82c1853803d772cc$export$627e5994af99713c = (data)=>{
    if (Array.isArray(data)) return data.map((item)=>item.value);
    return [];
};

});

parcelRegister("hnD3A", function(module, exports) {
$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $940df6a726e8bae3$export$56639f1c650d9ba5);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $940df6a726e8bae3$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $940df6a726e8bae3$export$6d15ce1cc0bdffe7);
$parcel$export(module.exports, "multiCheckboxSetOptionsVisibilityTransformer", () => $940df6a726e8bae3$export$e9bad46ddf6f220a);
$parcel$export(module.exports, "multiCheckboxGetOptionsVisibilityTransformer", () => $940df6a726e8bae3$export$2873e4aff600baf0);
$parcel$export(module.exports, "modifyMultiSelectValueToBasic", () => $940df6a726e8bae3$export$1c5664946e66ba46);

var $bo2nr = parcelRequire("bo2nr");

var $b78Ww = parcelRequire("b78Ww");
const $940df6a726e8bae3$export$106087dcfd4fb129 = 100;
const $940df6a726e8bae3$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.length <= $940df6a726e8bae3$export$106087dcfd4fb129 && value.every((0, $b78Ww.isNotEmptyString));
const $940df6a726e8bae3$export$45b7d122d1400fe0 = (value)=>Array.isArray(value) && value.length <= $940df6a726e8bae3$export$106087dcfd4fb129 && value.every((val)=>(0, $b78Ww.isNotEmptyString)(val) && (0, $bo2nr.isAriResourceIdValid)(val));
const $940df6a726e8bae3$export$9ba1ee83cc9456ba = (optionIds, options)=>{
    const selectedOptions = options.filter((option)=>optionIds.includes(option.value));
    return selectedOptions;
};
const $940df6a726e8bae3$export$6d15ce1cc0bdffe7 = (selectedOptionData)=>{
    return selectedOptionData.map((option)=>{
        return {
            id: option.value,
            value: option === null || option === void 0 ? void 0 : option.label
        };
    });
};
const $940df6a726e8bae3$export$e9bad46ddf6f220a = (optionsVisibility, lookupValues)=>{
    return lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>optionsVisibility.isVisible ? optionsVisibility.options.includes(value) : !optionsVisibility.options.includes(value));
};
const $940df6a726e8bae3$export$2873e4aff600baf0 = (optionsVisibility, lookupValues)=>{
    const filteredLookupValues = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>optionsVisibility.isVisible ? optionsVisibility.options.includes(value) : !optionsVisibility.options.includes(value));
    return {
        options: (filteredLookupValues === null || filteredLookupValues === void 0 ? void 0 : filteredLookupValues.map(({ value: value })=>value)) ?? [],
        isVisible: optionsVisibility.isVisible
    };
};
const $940df6a726e8bae3$export$1c5664946e66ba46 = (selectedOptions)=>(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0 ? selectedOptions.map((option)=>option.value) : [];

});

parcelRegister("b0BQW", function(module, exports) {
$parcel$export(module.exports, "validateNumberValue", () => $4aad36ddb251a967$export$aeb074bfcd7963bd);
$parcel$export(module.exports, "transformNumberToInternalValue", () => $4aad36ddb251a967$export$bdbd8c4d6c9c2efe);
$parcel$export(module.exports, "transformNumberToPublicValue", () => $4aad36ddb251a967$export$8bdc28b51a4acc44);
const $4aad36ddb251a967$export$aeb074bfcd7963bd = (value)=>value === null || typeof value === 'number';
const $4aad36ddb251a967$export$bdbd8c4d6c9c2efe = (publicValue)=>publicValue === null ? '' : String(publicValue);
const $4aad36ddb251a967$export$8bdc28b51a4acc44 = (internalValue)=>[
        undefined,
        ''
    ].includes(internalValue) ? null : Number(internalValue);

});

parcelRegister("atL5x", function(module, exports) {
$parcel$export(module.exports, "validatePrioritySetValue", () => $a18f2f1a46574f03$export$feb916d6d9ca4953);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $a18f2f1a46574f03$export$c6ef424ead917b72);
$parcel$export(module.exports, "prioritySetOptionsVisibility", () => $a18f2f1a46574f03$export$28c18b75fec0308d);
$parcel$export(module.exports, "priorityGetValueTransformer", () => $a18f2f1a46574f03$export$a3dcdeebcccb44cd);
$parcel$export(module.exports, "modifyPriorityValueToBasic", () => $a18f2f1a46574f03$export$8be86fe3b85cdd48);

var $b78Ww = parcelRequire("b78Ww");
const $a18f2f1a46574f03$export$feb916d6d9ca4953 = (value)=>(0, $b78Ww.isNotEmptyString)(value);
const $a18f2f1a46574f03$export$c6ef424ead917b72 = (optionId, options)=>{
    const option = options === null || options === void 0 ? void 0 : options.find((item)=>item.value === optionId);
    return option;
};
const $a18f2f1a46574f03$export$28c18b75fec0308d = ({ options: options, isVisible: isVisible }, lookupValues)=>{
    return lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>isVisible ? options.includes(value) : !options.includes(value));
};
const $a18f2f1a46574f03$export$a3dcdeebcccb44cd = (data)=>{
    if (!data) return null;
    return {
        id: data.value,
        name: data.label
    };
};
const $a18f2f1a46574f03$export$8be86fe3b85cdd48 = (data)=>data === null || data === void 0 ? void 0 : data.value;

});

parcelRegister("lp7oK", function(module, exports) {
$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $a8f9b987d72b8e90$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $a8f9b987d72b8e90$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueTransformer", () => $a8f9b987d72b8e90$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $a8f9b987d72b8e90$export$fd4db924c90bd0e2);
$parcel$export(module.exports, "modifySelectValueToBasic", () => $a8f9b987d72b8e90$export$24495edee70b381);
const $a8f9b987d72b8e90$export$81990085f8ab114b = ({ options: options, isVisible: isVisible }, lookupValues)=>lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>isVisible ? options.includes(value) : !options.includes(value));
const $a8f9b987d72b8e90$export$7c7ca81813eb0f65 = ({ options: options, isVisible: isVisible }, lookupValues)=>({
        isVisible: isVisible,
        options: options.filter((option)=>lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.some((val)=>val.value === option))
    });
const $a8f9b987d72b8e90$export$136c42b919fdec83 = (optionId, options)=>{
    if (optionId === null) return null;
    const option = options === null || options === void 0 ? void 0 : options.find((item)=>item.value === optionId);
    return option;
};
const $a8f9b987d72b8e90$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};
const $a8f9b987d72b8e90$export$24495edee70b381 = (selectedOption)=>{
    if (selectedOption === null) return null;
    return selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value;
};

});

parcelRegister("eNzDF", function(module, exports) {
$parcel$export(module.exports, "singleLineTextFieldGetValueTransformer", () => $337ff371b67d4eae$export$161c77b6b09fc494);
const $337ff371b67d4eae$export$161c77b6b09fc494 = (internalValue)=>internalValue !== undefined ? internalValue : '';

});

parcelRegister("lkMEg", function(module, exports) {
$parcel$export(module.exports, "validateTextAreaValue", () => $727b8cff3afc4c0e$export$af1bd7b4775c21f5);
$parcel$export(module.exports, "textAreaGetValueTransformer", () => $727b8cff3afc4c0e$export$f8779084d2efe971);
$parcel$export(module.exports, "textAreaSetValueTransformer", () => $727b8cff3afc4c0e$export$b26179f27360223b);

var $bzqwo = parcelRequire("bzqwo");

var $iRgiu = parcelRequire("iRgiu");

var $6OhPG = parcelRequire("6OhPG");

var $1EFS8 = parcelRequire("1EFS8");
const $727b8cff3afc4c0e$export$c7bf565312b59b06 = 'atlassian-wiki-renderer';
const $727b8cff3afc4c0e$export$af1bd7b4775c21f5 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    if (fieldRenderer === $727b8cff3afc4c0e$export$c7bf565312b59b06) {
        var _extra$currentField;
        return (0, $6OhPG.isValidADF)({
            newValue: value,
            currentValue: (_extra$currentField = extra.currentField) === null || _extra$currentField === void 0 ? void 0 : _extra$currentField.value
        });
    }
    return Promise.resolve(typeof value === 'string');
};
const $727b8cff3afc4c0e$export$f8779084d2efe971 = (value, fieldRenderer)=>{
    if (value === undefined || (0, $1EFS8.default).checkGate('ditto_fix_getvalue_empty_state') && !value) return fieldRenderer === $727b8cff3afc4c0e$export$c7bf565312b59b06 ? (0, $bzqwo.getEmptyADF)() : '';
    try {
        return (0, $iRgiu.parseAdf)(value);
    } catch (e) {
        return value;
    }
};
const $727b8cff3afc4c0e$export$b26179f27360223b = (value)=>{
    // Check if value is string, if not convert it to string
    if (typeof value === 'string') return value;
    return JSON.stringify(value);
};

});
parcelRegister("bzqwo", function(module, exports) {
$parcel$export(module.exports, "getEmptyADF", () => $f4b1187ff1d052c1$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
const $f4b1187ff1d052c1$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});

parcelRegister("6OhPG", function(module, exports) {
$parcel$export(module.exports, "isValidADF", () => $e6a3d07cbe12c85d$export$94ea512f7afe62e4);

var $hb3g8 = parcelRequire("hb3g8");

var $77MDz = parcelRequire("77MDz");

var $k7W4q = parcelRequire("k7W4q");

var $1CVmW = parcelRequire("1CVmW");

const $e6a3d07cbe12c85d$var$getADFValidator = async ()=>{
    const { validator: validator } = await (parcelRequire("96zC8"));
    return validator;
};
const $e6a3d07cbe12c85d$var$validateAdfExternalUrls = (adf)=>{
    try {
        (0, $1CVmW.traverse)(adf, {
            media: (node)=>{
                var _node$attrs, _node$attrs2;
                if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.type) === 'external' && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.url) !== undefined) throw new Error('Cannot contain external images');
            },
            blockCard: ()=>{
                throw new Error('Cannot contain blockCard');
            },
            embedCard: ()=>{
                throw new Error('Cannot contain embedCard');
            }
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $e6a3d07cbe12c85d$export$6f13dd7501a16a00 = (newValue, currentValue)=>{
    // If there is no user input or defaultValue set, we just validate the `externalValue` directly
    if (!currentValue || !currentValue.content.length) return $e6a3d07cbe12c85d$var$validateAdfExternalUrls(newValue);
    // Find the diff nodes between the new value and the current value
    const foundDiffNodes = (0, (/*@__PURE__*/$parcel$interopDefault($hb3g8)))(newValue.content, currentValue.content, (0, (/*@__PURE__*/$parcel$interopDefault($77MDz))));
    // Format `foundDiffNodes` into a valid ADF doc
    const formattedDiffAdf = (0, $k7W4q.doc)(...foundDiffNodes);
    return $e6a3d07cbe12c85d$var$validateAdfExternalUrls(formattedDiffAdf);
};
const $e6a3d07cbe12c85d$export$94ea512f7afe62e4 = async ({ newValue: newValue, currentValue: currentValue })=>{
    const validator = await $e6a3d07cbe12c85d$var$getADFValidator();
    const validate = validator();
    try {
        const isValidAdfNewValue = // Additionaly to ADF validator it chekcs version property since ADF validator checks only existance of it.
        Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
        const isValidAdf = isValidAdfNewValue && $e6a3d07cbe12c85d$export$6f13dd7501a16a00(newValue, currentValue);
        return isValidAdf;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("hb3g8", function(module, exports) {

var $8b9Jh = parcelRequire("8b9Jh");

var $4EmqQ = parcelRequire("4EmqQ");

var $1cUsb = parcelRequire("1cUsb");

var $7yLOE = parcelRequire("7yLOE");

var $eKg28 = parcelRequire("eKg28");
/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */ var $c815fdf536db6dcf$var$differenceWith = $1cUsb(function(array, values) {
    var comparator = $eKg28(values);
    if ($7yLOE(comparator)) comparator = undefined;
    return $7yLOE(array) ? $8b9Jh(array, $4EmqQ(values, 1, $7yLOE, true), undefined, comparator) : [];
});
module.exports = $c815fdf536db6dcf$var$differenceWith;

});
parcelRegister("8b9Jh", function(module, exports) {

var $2tHRa = parcelRequire("2tHRa");

var $2UH9P = parcelRequire("2UH9P");

var $5b81o = parcelRequire("5b81o");

var $8Qvsd = parcelRequire("8Qvsd");

var $iiVLm = parcelRequire("iiVLm");

var $3tkIe = parcelRequire("3tkIe");
/** Used as the size to enable large array optimizations. */ var $5f46e5dee3a32a11$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $5f46e5dee3a32a11$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $2UH9P, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $8Qvsd(values, $iiVLm(iteratee));
    if (comparator) {
        includes = $5b81o;
        isCommon = false;
    } else if (values.length >= $5f46e5dee3a32a11$var$LARGE_ARRAY_SIZE) {
        includes = $3tkIe;
        isCommon = false;
        values = new $2tHRa(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $5f46e5dee3a32a11$var$baseDifference;

});


parcelRegister("96zC8", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("g97eC").then(()=>parcelRequire('gaLLC'));

});



parcelRegister("bmDvS", function(module, exports) {
$parcel$export(module.exports, "validateUserPickerSetValue", () => $52a4dbc71d8b6500$export$3dc07da29c05fcd);
$parcel$export(module.exports, "userPickerSetValueTransformer", () => $52a4dbc71d8b6500$export$890d33cc39835486);
$parcel$export(module.exports, "userPickerGetValueTransformer", () => $52a4dbc71d8b6500$export$e87b0f36be178543);
$parcel$export(module.exports, "modifyUserPickerValueToBasic", () => $52a4dbc71d8b6500$export$ef961f8b571be395);

var $9aVeJ = parcelRequire("9aVeJ");
var $bxCcT = parcelRequire("bxCcT");

var $b78Ww = parcelRequire("b78Ww");

var $1EFS8 = parcelRequire("1EFS8");
/**
 * Finds a user in the lookup data by their account ID.
 *
 * @param lookupData - Array of users to search through
 * @param accountId - The account ID to search for
 * @returns The matching user object or null if not found
 */ const $52a4dbc71d8b6500$var$findUserLookupValue = (lookupData, accountId)=>{
    if (!lookupData || !Array.isArray(lookupData)) return null;
    return lookupData.find((user)=>user.accountId === accountId) || null;
};
const $52a4dbc71d8b6500$export$3dc07da29c05fcd = (value)=>value === null || (0, $b78Ww.isNotEmptyString)(value) && (0, $bxCcT.isNotAutomaticId)(value);
const $52a4dbc71d8b6500$export$890d33cc39835486 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundUser = $52a4dbc71d8b6500$var$findUserLookupValue(lookupValues || [], value);
    if (!foundUser) throw new (0, $9aVeJ.FieldValueLookupError)(`Could not find user with accountId: ${value}`);
    return {
        label: foundUser.name,
        email: '',
        // Email not available in LookupUser, update this once we have a way to get the email
        iconUrl: foundUser.picture,
        accountId: foundUser.accountId,
        value: foundUser.accountId
    };
};
const $52a4dbc71d8b6500$export$e87b0f36be178543 = (value)=>{
    if (!value || (0, $1EFS8.default).checkGate('ditto_fix_getvalue_empty_state') && !value.accountId) return null;
    return {
        accountId: value.accountId
    };
};
const $52a4dbc71d8b6500$export$ef961f8b571be395 = (value)=>{
    if (!value) return null;
    return value.accountId;
};

});
parcelRegister("bxCcT", function(module, exports) {
$parcel$export(module.exports, "isNotAutomaticId", () => $985efc6d9dbd665d$export$ab4c3a3c49d7add);

var $l1rhI = parcelRequire("l1rhI");
const $985efc6d9dbd665d$export$ab4c3a3c49d7add = (value)=>value !== (0, $l1rhI.AUTOMATIC_ID);

});


parcelRegister("fBJ0B", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd6ac08f5f3cbec9$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var // TODO: to be refined in https://ecosystem-platform.atlassian.net/browse/UIM-2463
$cd6ac08f5f3cbec9$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    obligatoryUimRequestCreateConsentMessage: {
        id: 'ui-modifications-fields-configuration.common.utils.views.request-create.obligatory-uim-request-create-consent-message',
        defaultMessage: 'You must allow "{appTitle}" to access your Atlassian products to create this work item.',
        description: 'When a user opens a context the first time, we require that they give consent for their data otherwise they cannot get the UIM`s applied'
    }
});

});

parcelRegister("jLx2t", function(module, exports) {
$parcel$export(module.exports, "validateSetOptionsVisibility", () => $be8096eab9917559$export$973aead813665e25);

var $6wLn7 = parcelRequire("6wLn7");
const $be8096eab9917559$export$914c7f5212c4c649 = (optionsVisibility)=>optionsVisibility.options.length <= 100;
const $be8096eab9917559$export$973aead813665e25 = (optionsVisibility)=>(0, $6wLn7.validateSetOptionsVisibilityRule)(optionsVisibility) && $be8096eab9917559$export$914c7f5212c4c649(optionsVisibility);

});



parcelRegister("8kP0u", function(module, exports) {
$parcel$export(module.exports, "portalReorderRoute", () => $541ba77e298b3084$export$f321c3c48e8f4288);
parcelRequire("9wocP");
var $bDnSZ = parcelRequire("bDnSZ");

var $1nQ48 = parcelRequire("1nQ48");

var $dMjkv = parcelRequire("dMjkv");
const $541ba77e298b3084$export$f321c3c48e8f4288 = (shouldLoadHelpEditTopicsResource = false)=>{
    const resources = [];
    if (shouldLoadHelpEditTopicsResource) resources.push((0, $dMjkv.helpEditTopicsResource));
    resources.push((0, $dMjkv.hiddenSectionWarningResource));
    return {
        resources: resources,
        path: '/settings/portal-reorder',
        exact: true,
        component: (0, $bDnSZ.withRouter)((0, $1nQ48.PortalReorderingRoute)),
        name: 'portal-reorder'
    };
};

});
parcelRegister("1nQ48", function(module, exports) {
$parcel$export(module.exports, "PortalReorderingRoute", () => $ec8c72304d8d9a9c$export$d8bb1160246519d9);
$parcel$export(module.exports, "callToActionUrlText", () => $ec8c72304d8d9a9c$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $ec8c72304d8d9a9c$export$5342e2a00fe6d647);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $hxVai = parcelRequire("hxVai");

var $8rTkC = parcelRequire("8rTkC");

var $gweXC = parcelRequire("gweXC");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("chjsC");
var $h2NCY = parcelRequire("h2NCY");
parcelRequire("i2Zru");
var $jBIAB = parcelRequire("jBIAB");
parcelRequire("1dZn3");
var $8m5pV = parcelRequire("8m5pV");

var $dmx2F = parcelRequire("dmx2F");
parcelRequire("bxgNh");
var $6hIVP = parcelRequire("6hIVP");

const $ec8c72304d8d9a9c$export$73a0508c941788d6 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("5rBOI")), {
        moduleId: "./src/view/portal-reorder-experience/hocs.tsx"
    }),
    LoadingSkeleton: (0, $6hIVP.default),
    loadingPosition: 'fill-container'
});
const $ec8c72304d8d9a9c$var$PORTAL_REORDERING_PATH = '/settings/portal-reorder';
const $ec8c72304d8d9a9c$export$d8bb1160246519d9 = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const WrappedComponent = (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: $ec8c72304d8d9a9c$var$PORTAL_REORDERING_PATH
    }), (0, $h2NCY.default)({
        message: formatMessage((0, $dmx2F.default).authPageMessage),
        callToActionText: formatMessage((0, $dmx2F.default).callToActionUrlText),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8m5pV.default), {
            path: $ec8c72304d8d9a9c$var$PORTAL_REORDERING_PATH,
            component: $ec8c72304d8d9a9c$export$73a0508c941788d6,
            screenName: (0, $8rTkC.ScreenName).PORTAL_REORDER_SETTINGS
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, null);
};
$ec8c72304d8d9a9c$export$d8bb1160246519d9.displayName = 'PortalReorderingRoute';
const $ec8c72304d8d9a9c$export$d96795d242b62963 = (0, $dmx2F.default).callToActionUrlText;
const $ec8c72304d8d9a9c$export$5342e2a00fe6d647 = (0, $dmx2F.default).authPageMessage;

});
parcelRegister("chjsC", function(module, exports) {
$parcel$export(module.exports, "withOnlyJiraAdmin", () => (parcelRequire("h2NCY")).default);

var $h2NCY = parcelRequire("h2NCY");

});
parcelRegister("h2NCY", function(module, exports) {
$parcel$export(module.exports, "default", () => $53d7b220e5db3470$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $8rTkC = parcelRequire("8rTkC");

var $4acrp = parcelRequire("4acrp");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
parcelRequire("3ibrT");
var $lHAZd = parcelRequire("lHAZd");
const $53d7b220e5db3470$var$selector = (0, $ehscL.createSelector)((0, $hx8zX.getCanAdministerJIRA), (canAdministerJira)=>({
        canAdministerJira: canAdministerJira
    }));
const $53d7b220e5db3470$var$connector = (0, $jvoWT.default)($53d7b220e5db3470$var$selector, null);
const $53d7b220e5db3470$var$withOnlyJiraAdmin = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { canAdministerJira: canAdministerJira } = props;
            if (canAdministerJira) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $8P7DW.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $8P7DW.createElement((0, $lHAZd.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $8P7DW.createElement((0, $4acrp.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $8rTkC.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        const ConnectedComponent = $53d7b220e5db3470$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyJiraAdmin';
        return ConnectedComponent;
    };
var $53d7b220e5db3470$export$2e2bcd8739ae039 = $53d7b220e5db3470$var$withOnlyJiraAdmin;

});


parcelRegister("i2Zru", function(module, exports) {
$parcel$export(module.exports, "withOnlyLoggedIn", () => (parcelRequire("jBIAB")).default);

var $jBIAB = parcelRequire("jBIAB");

});
parcelRegister("jBIAB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f7fac22a2c39f4e$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $3Wo8f = parcelRequire("3Wo8f");

var $jsmb9 = parcelRequire("jsmb9");
const $6f7fac22a2c39f4e$var$selector = (0, $ehscL.createSelector)((0, $hx8zX.isLoggedIn), (isLoggedIn)=>({
        isLoggedIn: isLoggedIn
    }));
const $6f7fac22a2c39f4e$var$connector = (0, $jvoWT.default)($6f7fac22a2c39f4e$var$selector, null);
const $6f7fac22a2c39f4e$var$withOnlyLoggedIn = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isLoggedIn: isLoggedIn } = props;
            if (isLoggedIn) // @ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $8P7DW.createElement(WrappedComponent, props);
            const { redirectUrl: redirectUrl } = options;
            const loginUrl = (0, $jsmb9.getLoginUrl)({
                redirectUrl: redirectUrl,
                isAbsolute: false
            });
            return /*#__PURE__*/ $8P7DW.createElement((0, $3Wo8f.Redirect), {
                to: loginUrl
            });
        };
        const ConnectedComponent = $6f7fac22a2c39f4e$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyLoggedIn';
        return ConnectedComponent;
    };
var $6f7fac22a2c39f4e$export$2e2bcd8739ae039 = $6f7fac22a2c39f4e$var$withOnlyLoggedIn;

});
parcelRegister("3Wo8f", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $20df8a9f413cde38$export$2d8d895a0a0f636e);
$parcel$export(module.exports, "PushRedirectWithState", () => $20df8a9f413cde38$export$e3f5537ca0fe1626);
$parcel$export(module.exports, "PushRedirect", () => $20df8a9f413cde38$export$74676119665a0bf8);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("9wocP");
var $7mb2c = parcelRequire("7mb2c");
var $bDnSZ = parcelRequire("bDnSZ");
const $20df8a9f413cde38$export$2d8d895a0a0f636e = (props)=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $7mb2c.Redirect), props);
};
const $20df8a9f413cde38$export$e3f5537ca0fe1626 = (0, $bDnSZ.withRouter)(({ history: history, to: to, state: state })=>{
    (0, $8P7DW.useEffect)(()=>{
        // @ts-ignore the history is provided by the router
        history.push(to, state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        to,
        state
    ]);
    return null;
});
const $20df8a9f413cde38$export$74676119665a0bf8 = (0, $bDnSZ.withRouter)(({ history: history, to: to })=>{
    (0, $8P7DW.useEffect)(()=>{
        // @ts-ignore the history is provided by the router
        history.push(to);
    }, [
        history,
        to
    ]);
    return null;
});

});



parcelRegister("1dZn3", function(module, exports) {
$parcel$export(module.exports, "SplashLayoutRoute", () => (parcelRequire("8m5pV")).default);
parcelRequire("8kPni");
var $8m5pV = parcelRequire("8m5pV");

});
parcelRegister("8kPni", function(module, exports) {
$parcel$export(module.exports, "SplashLayoutRoute", () => (parcelRequire("8m5pV")).default);

var $8m5pV = parcelRequire("8m5pV");

});
parcelRegister("8m5pV", function(module, exports) {
$parcel$export(module.exports, "default", () => $560946e4bdd338a0$export$2e2bcd8739ae039);
/* splash-layout.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $9qqCD = parcelRequire("9qqCD");
var $cM8t6 = parcelRequire("cM8t6");
parcelRequire("gp4SE");
var $jQ8lB = parcelRequire("jQ8lB");

var $cJncc = parcelRequire("cJncc");
parcelRequire("ebTjc");
var $datZD = parcelRequire("datZD");
const $560946e4bdd338a0$export$2400592c1982dcfe = ({ children: children, isFooterHidden: isFooterHidden })=>/*#__PURE__*/ $8P7DW.createElement((0, $cM8t6.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $9qqCD.default), null, /*#__PURE__*/ $8P7DW.createElement($560946e4bdd338a0$var$StyledContent, null, /*#__PURE__*/ $8P7DW.createElement("main", null, /*#__PURE__*/ $8P7DW.createElement((0, $jQ8lB.MainContentSkipLinkWrapper), null, children)), !isFooterHidden && /*#__PURE__*/ $8P7DW.createElement((0, $cJncc.StyledFooter), {
        sticky: false
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $560946e4bdd338a0$var$StyledContent = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
var $560946e4bdd338a0$export$2e2bcd8739ae039 = (0, $datZD.default)($560946e4bdd338a0$export$2400592c1982dcfe);

});



parcelRegister("dmx2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $c694d8f1b84ef281$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $c694d8f1b84ef281$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    limitErrorFlagTitle: {
        defaultMessage: "You\u2019ve already featured {limit, plural, one {# portal} other {# portals}}",
        description: 'Limit error flag title',
        id: 'cv.portal.reordering.experience.limit.error.title.v2'
    },
    limitErrorFlagDescription: {
        defaultMessage: 'Remove a portal from the featured section to add another one.',
        description: 'Limit error flag description',
        id: 'cv.portal.reordering.experience.limit.error.description.v2'
    },
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal reordering',
        id: 'cv.portal.reordering.experience.un.auth.action.message'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to help center',
        description: 'Call to action text for unauthorized page of portal reordering',
        id: 'cv.portal.reordering.experience.un.auth.action.text'
    },
    portalSectionHeader: {
        defaultMessage: 'Portals',
        description: 'This section divides the topic from the service desk edit section',
        id: 'cv.portal.reordering.experience.service.desk.section.header.text'
    },
    publishTopicsErrorTitle: {
        defaultMessage: "We couldn\u2019t publish your changes",
        description: 'Title of the message shown when publishing fails',
        id: 'cv.portal.reordering.experience.topics.publish.error.title'
    },
    publishTopicsErrorDescription: {
        defaultMessage: 'Refresh the page and try publishing again.',
        description: 'Description of the message shown shown when publishing fails',
        id: 'cv.portal.reordering.experience.topics.publish.error.description'
    },
    portalsHiddenWarningTitle: {
        defaultMessage: 'Portals are hidden from your home page',
        description: 'Warning title when the portals section is hidden.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.title'
    },
    portalsHiddenWarningDescription: {
        defaultMessage: 'The portals section on your home page is hidden. Edit page layout to show portals on the home page.',
        description: 'Warning description when the portals section is hidden.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.description'
    },
    editPageLayoutAction: {
        defaultMessage: 'Edit page layout',
        description: 'Action to show the portals section.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.action'
    }
});

});

parcelRegister("bxgNh", function(module, exports) {
$parcel$export(module.exports, "PortalReorderExperienceLoader", () => (parcelRequire("6hIVP")).default);

var $6hIVP = parcelRequire("6hIVP");

});
parcelRegister("6hIVP", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd99fa61a2de6a74$export$2e2bcd8739ae039);
/* portal-reorder-experience-loader.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $5OWUX = parcelRequire("5OWUX");

var $1We2B = parcelRequire("1We2B");

var $l4a5B = parcelRequire("l4a5B");
parcelRequire("kwadB");
var $a7192 = parcelRequire("a7192");
parcelRequire("hELvu");
var $iToix = parcelRequire("iToix");
parcelRequire("iuwpd");
var $dVBtd = parcelRequire("dVBtd");

var $13rAb = parcelRequire("13rAb");

var $6QRWc = parcelRequire("6QRWc");
const $fd99fa61a2de6a74$export$1b7c65f90ce5d7ad = (props)=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $13rAb.Wrapper), null, /*#__PURE__*/ $8P7DW.createElement((0, $iToix.default), {
        isDirty: false,
        openPublishPrompt: (0, $1We2B.noop),
        openCancelPrompt: (0, $1We2B.noop)
    }), /*#__PURE__*/ $8P7DW.createElement((0, $13rAb.ExperienceContainer), null, props.error ? /*#__PURE__*/ $8P7DW.createElement($fd99fa61a2de6a74$var$LoaderContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $5OWUX.ChunkLoadErrorMessage), null)) : /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement($fd99fa61a2de6a74$var$FeaturedPortalsWrapper, null, /*#__PURE__*/ $8P7DW.createElement("h2", null, props.intl.formatMessage((0, $6QRWc.default).featuredPortalsTitle)), /*#__PURE__*/ $8P7DW.createElement((0, $13rAb.CardsContainer), null, Array.from({
        length: 3
    }).map((_, index)=>/*#__PURE__*/ $8P7DW.createElement((0, $a7192.default), {
            key: index,
            isFeatured: true
        })))), /*#__PURE__*/ $8P7DW.createElement($fd99fa61a2de6a74$var$UnFeaturedPortalsWrapper, null, /*#__PURE__*/ $8P7DW.createElement((0, $dVBtd.default), {
        isDisabled: true,
        value: "POPULARITY",
        onChange: (0, $1We2B.noop)
    }), /*#__PURE__*/ $8P7DW.createElement((0, $13rAb.CardsContainer), null, Array.from({
        length: 9
    }).map((_, index)=>/*#__PURE__*/ $8P7DW.createElement((0, $a7192.default), {
            key: index,
            isFeatured: true
        })))))));
};
var $fd99fa61a2de6a74$export$2e2bcd8739ae039 = (0, $l4a5B.default)($fd99fa61a2de6a74$export$1b7c65f90ce5d7ad);
const $fd99fa61a2de6a74$var$LOADER_MIN_HEIGHT = '75vh';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $fd99fa61a2de6a74$var$LoaderContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1tken9zg",
            __cmplp.className
        ])
    });
});
const $fd99fa61a2de6a74$var$UnFeaturedPortalsWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});
const $fd99fa61a2de6a74$var$FeaturedPortalsWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_n7zl1dd9 _19pkpxbi _13jwangw _1n46ze3t _1gnpu2gc _7e5b1jfw _1advidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kwadB", function(module, exports) {
$parcel$export(module.exports, "ProjectCardSkeleton", () => (parcelRequire("a7192")).default);

var $a7192 = parcelRequire("a7192");

});
parcelRegister("a7192", function(module, exports) {
$parcel$export(module.exports, "default", () => $e388e9f7f373e12b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $iSvee = parcelRequire("iSvee");

var $4cxV2 = parcelRequire("4cxV2");

var $iZBCz = parcelRequire("iZBCz");

var $glueQ = parcelRequire("glueQ");

var $32tao = parcelRequire("32tao");
parcelRequire("iiDlL");
var $hDvTi = parcelRequire("hDvTi");
parcelRequire("66Daz");
var $dTPQP = parcelRequire("dTPQP");
parcelRequire("eymra");
var $hDvTi = parcelRequire("hDvTi");
var $eymra = parcelRequire("eymra");
const $e388e9f7f373e12b$var$ProjectsCardSkeleton = ({ isBasic: isBasic, isFeatured: isFeatured })=>{
    return /*#__PURE__*/ $8P7DW.createElement($e388e9f7f373e12b$var$Root, {
        "data-testid": 'project-card-skeleton'
    }, /*#__PURE__*/ $8P7DW.createElement((0, $hDvTi.Container), {
        hasIcon: true
    }, !isBasic && isFeatured && /*#__PURE__*/ $8P7DW.createElement($e388e9f7f373e12b$var$ActionsLeft, null, /*#__PURE__*/ $8P7DW.createElement((0, $dTPQP.DragHandlerWrapper), null, /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZBCz))), {
        label: "drag-handler",
        size: "medium",
        spacing: "spacious"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $hDvTi.IconContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: $4cxV2.multiple(6).px,
        height: $4cxV2.multiple(6).px
    })), /*#__PURE__*/ $8P7DW.createElement((0, $hDvTi.Content), null, /*#__PURE__*/ $8P7DW.createElement($e388e9f7f373e12b$var$NameWrapper, null, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: $4cxV2.multiple(11).px,
        height: (0, $eymra.titleSkeletonHeight)
    })), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: $4cxV2.multiple(18).px,
        height: "14px"
    })), !isBasic && /*#__PURE__*/ $8P7DW.createElement($e388e9f7f373e12b$var$Actions, null, isFeatured ? /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($glueQ))), {
        label: "star-filled-icon",
        size: "medium"
    })) : /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($32tao))), {
        label: "start-icon",
        size: "medium"
    }))));
};
var $e388e9f7f373e12b$export$2e2bcd8739ae039 = $e388e9f7f373e12b$var$ProjectsCardSkeleton;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e388e9f7f373e12b$var$Root = /*#__PURE__*/ (0, $2UsNA.default).li.withConfig({
    componentId: "sc-12n7yik-0"
})`${(0, $hDvTi.cardStyle)} ${(0, $dTPQP.cardGutterStyle)} border:solid ${"var(--ds-border-width, 1px)"} ${"var(--ds-border, #DFE1E6)"};background-color:${"var(--ds-surface-raised, #FFFFFF)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e388e9f7f373e12b$var$NameWrapper = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-12n7yik-1"
})`margin-bottom:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e388e9f7f373e12b$var$Actions = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-12n7yik-2"
})`display:flex;flex-direction:column;align-items:center;position:absolute;color:${"var(--ds-skeleton, #F4F5F7)"};top:${"var(--ds-space-100, 8px)"};right:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e388e9f7f373e12b$var$ActionsLeft = /*#__PURE__*/ (0, $2UsNA.default)($e388e9f7f373e12b$var$Actions).withConfig({
    componentId: "sc-12n7yik-3"
})`position:initial;width:${$4cxV2.multiple(5).px};margin-top:-${$4cxV2.multiple(6).px};`;

});
parcelRegister("iZBCz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::976c79b56a8fa85b795a69d54376c6cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd3b1b44bf92e0ba$var$_react = $dd3b1b44bf92e0ba$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $dd3b1b44bf92e0ba$var$_baseNew = $dd3b1b44bf92e0ba$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $dd3b1b44bf92e0ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd3b1b44bf92e0ba$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $dd3b1b44bf92e0ba$var$_react.default.createElement($dd3b1b44bf92e0ba$var$_baseNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$dd3b1b44bf92e0ba$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $dd3b1b44bf92e0ba$var$_default = module.exports.default = $dd3b1b44bf92e0ba$var$DragHandleVerticalIcon;

});

parcelRegister("glueQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::230a74b5beecd6089e40fb6fd34c20ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be661034d40e4b35$var$_react = $be661034d40e4b35$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $be661034d40e4b35$var$_baseNew = $be661034d40e4b35$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $be661034d40e4b35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be661034d40e4b35$var$StarStarredIcon = (props)=>/*#__PURE__*/ $be661034d40e4b35$var$_react.default.createElement($be661034d40e4b35$var$_baseNew.default, Object.assign({
        name: "StarStarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$be661034d40e4b35$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $be661034d40e4b35$var$_default = module.exports.default = $be661034d40e4b35$var$StarStarredIcon;

});

parcelRegister("32tao", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1160d31b57f6ed551c99a3d7adfc3c7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23682ee911cbe8f8$var$_react = $23682ee911cbe8f8$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $23682ee911cbe8f8$var$_baseNew = $23682ee911cbe8f8$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $23682ee911cbe8f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23682ee911cbe8f8$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $23682ee911cbe8f8$var$_react.default.createElement($23682ee911cbe8f8$var$_baseNew.default, Object.assign({
        name: "StarUnstarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$23682ee911cbe8f8$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $23682ee911cbe8f8$var$_default = module.exports.default = $23682ee911cbe8f8$var$StarUnstarredIcon;

});

parcelRegister("iiDlL", function(module, exports) {
$parcel$export(module.exports, "PortalCard", () => (parcelRequire("heqId")).default);
$parcel$export(module.exports, "PortalName", () => (parcelRequire("hDvTi")).PortalName);
$parcel$export(module.exports, "cardStyle", () => (parcelRequire("hDvTi")).cardStyle);
$parcel$export(module.exports, "PortalCardContainer", () => (parcelRequire("hDvTi")).Container);

var $heqId = parcelRequire("heqId");

var $hDvTi = parcelRequire("hDvTi");

});
parcelRegister("heqId", function(module, exports) {
$parcel$export(module.exports, "default", () => $005da13bbd71a54b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $kFYzS = parcelRequire("kFYzS");

var $HGACo = parcelRequire("HGACo");

var $fX00j = parcelRequire("fX00j");

var $1p41U = parcelRequire("1p41U");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $b60z8 = parcelRequire("b60z8");

var $3xuD5 = parcelRequire("3xuD5");

var $f73iJ = parcelRequire("f73iJ");

var $loEqA = parcelRequire("loEqA");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");
parcelRequire("lt2dp");
var $8tYIv = parcelRequire("8tYIv");

var $8gu7I = parcelRequire("8gu7I");
var $MmGmU = parcelRequire("MmGmU");

var $iziiq = parcelRequire("iziiq");

var $hrPHR = parcelRequire("hrPHR");

var $6GNhI = parcelRequire("6GNhI");

var $hDvTi = parcelRequire("hDvTi");
var $005da13bbd71a54b$var$_customPurify$addHook, $005da13bbd71a54b$var$_customPurifyIsomorph;
const $005da13bbd71a54b$export$6448f23ea2cffe7b = (0, (/*@__PURE__*/$parcel$interopDefault($f73iJ)))();
const $005da13bbd71a54b$export$292d791731e624a3 = $loEqA;
($005da13bbd71a54b$var$_customPurify$addHook = $005da13bbd71a54b$export$6448f23ea2cffe7b.addHook) === null || $005da13bbd71a54b$var$_customPurify$addHook === void 0 || $005da13bbd71a54b$var$_customPurify$addHook.call($005da13bbd71a54b$export$6448f23ea2cffe7b, 'afterSanitizeAttributes', (node)=>{
    if (node.tagName === 'A' || node.tagName === 'BUTTON' || node.tagName === 'INPUT') node.setAttribute('tabIndex', '-1');
});
($005da13bbd71a54b$var$_customPurifyIsomorph = $005da13bbd71a54b$export$292d791731e624a3.addHook) === null || $005da13bbd71a54b$var$_customPurifyIsomorph === void 0 || $005da13bbd71a54b$var$_customPurifyIsomorph.call($005da13bbd71a54b$export$292d791731e624a3, 'afterSanitizeAttributes', (node)=>{
    if (node.tagName === 'A' || node.tagName === 'BUTTON' || node.tagName === 'INPUT') node.setAttribute('tabIndex', '-1');
});
const $005da13bbd71a54b$var$PortalCard = ({ onClick: onClick, index: index, id: id, portalName: portalName, description: description, portalUrl: portalUrl, iconUrl: iconUrl, openInNewTab: openInNewTab })=>{
    const [isPageInEditMode] = (0, $8tYIv.useIsPageInEditMode)();
    const { push: push } = (0, $dKPjT.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const hasIcon = !!iconUrl;
    const hasPortalUrl = !!portalUrl;
    const hasDescription = !!description;
    const hasOnlyPortalName = !description && !iconUrl;
    const memoizedOnClick = $8P7DW.useCallback(()=>{
        const event = createAnalyticsEvent({
            analyticsType: (0, $iziiq.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'portal'
        });
        event.context.push({
            componentName: 'link',
            attributes: {
                index: index,
                hasIcon: hasIcon,
                hasPortalUrl: hasPortalUrl,
                hasDescription: hasDescription,
                portalId: id
            }
        });
        event.fire();
        if (openInNewTab) {
            const { baseUrl: baseUrl } = (0, $hrPHR.getEnv)();
            (0, $6GNhI.open)(`${baseUrl}${portalUrl}`, '_blank');
        } else push(portalUrl);
        onClick && onClick(index);
    }, [
        createAnalyticsEvent,
        index,
        hasIcon,
        hasPortalUrl,
        hasDescription,
        id,
        push,
        portalUrl,
        onClick,
        openInNewTab
    ]);
    let sanitizedDescription = '';
    if ((0, $HGACo.isIsomorphicDompurifyLibUsed)()) sanitizedDescription = $005da13bbd71a54b$export$292d791731e624a3.sanitize(description || '');
    else sanitizedDescription = $005da13bbd71a54b$export$6448f23ea2cffe7b.sanitize(description || '');
    const content = /*#__PURE__*/ $8P7DW.createElement($005da13bbd71a54b$var$Container, {
        hasIcon: hasIcon
    }, !!iconUrl && /*#__PURE__*/ $8P7DW.createElement($005da13bbd71a54b$var$IconContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $kFYzS.default), {
        src: iconUrl,
        alt: '',
        draggable: "false"
    })), /*#__PURE__*/ $8P7DW.createElement($005da13bbd71a54b$var$Content, null, /*#__PURE__*/ $8P7DW.createElement($005da13bbd71a54b$var$PortalName, {
        hasOnlyPortalName: hasOnlyPortalName,
        title: portalName
    }, portalName), !!description && /*#__PURE__*/ $8P7DW.createElement($005da13bbd71a54b$var$Description, {
        title: description,
        dangerouslySetInnerHTML: {
            __html: sanitizedDescription
        }
    })));
    const portalCardContent = /*#__PURE__*/ $8P7DW.createElement($005da13bbd71a54b$var$CardRoot, {
        "aria-label": portalName,
        onClick: memoizedOnClick,
        "data-test-id": `portal:${portalName}`,
        role: "link"
    }, content);
    return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
        data: {
            attributes: {
                index: index,
                hasIcon: hasIcon,
                hasPortalUrl: hasPortalUrl,
                hasDescription: hasDescription,
                portalId: id
            }
        }
    }, isPageInEditMode ? /*#__PURE__*/ $8P7DW.createElement($005da13bbd71a54b$var$RootWhenEditingLayout, null, content) : portalCardContent);
};
var $005da13bbd71a54b$export$2e2bcd8739ae039 = $005da13bbd71a54b$var$PortalCard;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $005da13bbd71a54b$var$PortalName = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ob3s3l-0"
})`${$kBzhX.h400};max-width:100%;margin-top:0;margin-bottom:${"var(--ds-space-050, 4px)"};${(props)=>{
    const lines = props.hasOnlyPortalName ? 3 : 1;
    const lineHeight = $4cxV2.multiple(2).unitless;
    return $6t2I3.multiLineClamp(lines, lineHeight);
}};${$1p41U.fromXSmall.css`
        ${$kBzhX.h500};
        margin-top: 0;
        margin-bottom: ${"var(--ds-space-100, 8px)"};
        max-height: ${(props)=>props.hasOnlyPortalName ? $4cxV2.multiple(7.5).px : $4cxV2.multiple(2.5).px};
    `};&{color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $005da13bbd71a54b$var$Description = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ob3s3l-1"
})`${$kBzhX.xsmall};${$6t2I3.multiLineClamp(3, $4cxV2.multiple(2.25).unitless)};max-width:100%;color:${"var(--ds-text, #172B4D)"};line-height:${$4cxV2.multiple(2.25).px};${$1p41U.fromXSmall.css`
        ${$kBzhX.regular};
        line-height: ${$4cxV2.multiple(2.5).px};
        max-height: ${$4cxV2.multiple(7.5).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $005da13bbd71a54b$var$Content = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ob3s3l-2"
})`overflow:hidden;width:100%;height:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $005da13bbd71a54b$var$CardRoot = /*#__PURE__*/ (0, $2UsNA.default)((0, $fX00j.InteractiveElement)).withConfig({
    componentId: "sc-ob3s3l-3"
})`${(0, $hDvTi.cardStyle)} ${$6t2I3.raiseUpOnHoverOrFocus()};background-color:${"var(--ds-surface-raised, #FFFFFF)"};transition:transform ${$b60z8.speedMs.fast}ms ${$b60z8.timingFunctions.easeInOut};&:hover,&:focus{z-index:${$3xuD5.portalCardLayout};text-decoration:none;}cursor:pointer;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $005da13bbd71a54b$var$RootWhenEditingLayout = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ob3s3l-4"
})`${(0, $hDvTi.cardStyle)} box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};background-color:${"var(--ds-surface-raised, #FFFFFF)"};transition:transform ${$b60z8.speedMs.fast}ms ${$b60z8.timingFunctions.easeInOut};&:hover,&:focus{z-index:${$3xuD5.portalCardLayout};text-decoration:none;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $005da13bbd71a54b$var$IconContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ob3s3l-5"
})`${$6t2I3.flexCenter};height:${$4cxV2.multiple(5).px};width:${$4cxV2.multiple(5).px};flex-shrink:0;margin-right:${"var(--ds-space-200, 16px)"};${$1p41U.fromXSmall.css`
        height: ${$4cxV2.multiple(6).px};
        width: ${$4cxV2.multiple(6).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $005da13bbd71a54b$var$largePadding = /*#__PURE__*/ (0, $2UsNA.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"};${$1p41U.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-400, 32px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $005da13bbd71a54b$var$smallPadding = /*#__PURE__*/ (0, $2UsNA.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"};${$1p41U.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $005da13bbd71a54b$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-ob3s3l-6"
})`display:flex;width:100%;height:100%;box-sizing:border-box;align-items:center;justify-content:flex-start;${(props)=>props.hasIcon ? $005da13bbd71a54b$var$smallPadding : $005da13bbd71a54b$var$largePadding};`;

});
parcelRegister("kFYzS", function(module, exports) {
$parcel$export(module.exports, "default", () => $94cf5a20954e2658$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $94cf5a20954e2658$var$AutoScaledImage = /*#__PURE__*/ (0, $2UsNA.default).img.withConfig({
    componentId: "sc-1gbtcy6-0"
})`height:100%;width:${({ inheritWidth: inheritWidth })=>inheritWidth ? 'inherit' : '100%'};object-fit:${(props)=>props.objectFit || 'contain'};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$94cf5a20954e2658$export$2e2bcd8739ae039 = $94cf5a20954e2658$var$AutoScaledImage;

});

parcelRegister("fX00j", function(module, exports) {
$parcel$export(module.exports, "InteractiveElement", () => $8bed29f4a405d27a$export$c0db965635c41eb6);

var $8P7DW = parcelRequire("8P7DW");
const $8bed29f4a405d27a$export$c0db965635c41eb6 = ({ onClick: onClick, children: children, role: role = 'button', tagName: TagName = 'div', ...props })=>{
    const handleKeyDown = (0, $8P7DW.useCallback)((event)=>{
        // Runs onClick on space and enter key press for accessibility
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(TagName, {
        tabIndex: 0,
        role: role,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        ...props
    }, children);
};
var $8bed29f4a405d27a$export$2e2bcd8739ae039 = $8bed29f4a405d27a$export$c0db965635c41eb6;

});

parcelRegister("lt2dp", function(module, exports) {
$parcel$export(module.exports, "useConfigPanelUI", () => (parcelRequire("8tYIv")).useConfigPanelUI);
$parcel$export(module.exports, "useDeletedModulesCount", () => (parcelRequire("8tYIv")).useDeletedModulesCount);
$parcel$export(module.exports, "useElementRenderer", () => (parcelRequire("8tYIv")).useElementRenderer);
$parcel$export(module.exports, "useIsDirty", () => (parcelRequire("8tYIv")).useIsDirty);
$parcel$export(module.exports, "useIsPageInBrandingPreviewMode", () => (parcelRequire("8tYIv")).useIsPageInBrandingPreviewMode);
$parcel$export(module.exports, "useIsPageInEditMode", () => (parcelRequire("8tYIv")).useIsPageInEditMode);
$parcel$export(module.exports, "useIsPageInPreviewMode", () => (parcelRequire("8tYIv")).useIsPageInPreviewMode);
$parcel$export(module.exports, "useIsPublishDisabled", () => (parcelRequire("8tYIv")).useIsPublishDisabled);
$parcel$export(module.exports, "useIsPublishing", () => (parcelRequire("8tYIv")).useIsPublishing);
$parcel$export(module.exports, "useLayoutActions", () => (parcelRequire("8tYIv")).useLayoutActions);
$parcel$export(module.exports, "useLayoutConfig", () => (parcelRequire("8tYIv")).useLayoutConfig);
$parcel$export(module.exports, "useLayoutIds", () => (parcelRequire("8tYIv")).useLayoutIds);
$parcel$export(module.exports, "useMediaConfig", () => (parcelRequire("8tYIv")).useMediaConfig);
$parcel$export(module.exports, "usePageType", () => (parcelRequire("8tYIv")).usePageType);
$parcel$export(module.exports, "useReorderedModulesCount", () => (parcelRequire("8tYIv")).useReorderedModulesCount);
$parcel$export(module.exports, "useSectionPicker", () => (parcelRequire("8tYIv")).useSectionPicker);
$parcel$export(module.exports, "useSelectedPrimitive", () => (parcelRequire("8tYIv")).useSelectedPrimitive);
parcelRequire("8tYIv");

});
parcelRegister("8tYIv", function(module, exports) {
$parcel$export(module.exports, "LayoutBuilderContainer", () => $fe9f0b2091168274$export$b4aab0ffc58aaa5);
$parcel$export(module.exports, "useIsPageInEditMode", () => $fe9f0b2091168274$export$7be577f8255e624c);
$parcel$export(module.exports, "useIsPageInPreviewMode", () => $fe9f0b2091168274$export$20672b722d2aa4d4);
$parcel$export(module.exports, "useSectionPicker", () => $fe9f0b2091168274$export$1672d32e0a0e6fce);
$parcel$export(module.exports, "useSelectedPrimitive", () => $fe9f0b2091168274$export$66366b49ee6cbaa2);
$parcel$export(module.exports, "useIsPublishing", () => $fe9f0b2091168274$export$b9b3eff0a656013d);
$parcel$export(module.exports, "useIsPublishDisabled", () => $fe9f0b2091168274$export$122ac12905cb91a9);
$parcel$export(module.exports, "useIsDirty", () => $fe9f0b2091168274$export$9b9cd7e7602f602f);
$parcel$export(module.exports, "useMediaConfig", () => $fe9f0b2091168274$export$7f746b47c356effa);
$parcel$export(module.exports, "useIsPageInBrandingPreviewMode", () => $fe9f0b2091168274$export$dbe8a2a3e19e92cf);
$parcel$export(module.exports, "useLayoutConfig", () => $fe9f0b2091168274$export$6bc9f3ef36ce1121);
$parcel$export(module.exports, "useLayoutIds", () => $fe9f0b2091168274$export$5fb152f2612e3297);
$parcel$export(module.exports, "useElementRenderer", () => $fe9f0b2091168274$export$68c713430d820919);
$parcel$export(module.exports, "useDeletedModulesCount", () => $fe9f0b2091168274$export$2056c520eb48ec8b);
$parcel$export(module.exports, "useReorderedModulesCount", () => $fe9f0b2091168274$export$4010704f08b334ba);
$parcel$export(module.exports, "useConfigPanelUI", () => $fe9f0b2091168274$export$7eebf066d70abd18);
$parcel$export(module.exports, "usePageType", () => $fe9f0b2091168274$export$4ca74c2ebe5e7020);
$parcel$export(module.exports, "useLayoutActions", () => $fe9f0b2091168274$export$1069bba51f142634);

var $HGACo = parcelRequire("HGACo");

var $iOIPr = parcelRequire("iOIPr");
var $6xLCs = parcelRequire("6xLCs");
var $kUoOn = parcelRequire("kUoOn");
var $8Mxh4 = parcelRequire("8Mxh4");

var $hrPHR = parcelRequire("hrPHR");

var $f8kjw = parcelRequire("f8kjw");

var $gy1IC = parcelRequire("gy1IC");
if ((0, $hrPHR.getEnv)().environment !== (0, $hrPHR.EnvType).PROD) (0, $8Mxh4.default).devtools = true;
const $fe9f0b2091168274$export$c78554af6dbb181d = ()=>{
    return (0, $HGACo.isIncreasedFlexibilityEnabled)() ? {
        hideCatalogue: false,
        canAddNewSections: true,
        canAddNewSubSections: false,
        canInteractWithSubSections: false,
        canInteractWithElements: true,
        canDeleteSections: true,
        newSectionCanOnlyAddEditor: true
    } : {
        hideCatalogue: true,
        canAddNewSections: true,
        canAddNewSubSections: false,
        canInteractWithSubSections: false,
        canInteractWithElements: false,
        canDeleteSections: true,
        newSectionCanOnlyAddEditor: true
    };
};
const $fe9f0b2091168274$var$emptyLayoutId = {
    sectionId: undefined,
    elementId: undefined
};
const $fe9f0b2091168274$export$1cb7963f0d33db7c = {
    HelpLayoutHeroElement: $fe9f0b2091168274$var$emptyLayoutId,
    HelpLayoutAnnouncementElement: $fe9f0b2091168274$var$emptyLayoutId,
    HelpLayoutTopicsListElement: $fe9f0b2091168274$var$emptyLayoutId,
    HelpLayoutKnowledgeCardsElement: $fe9f0b2091168274$var$emptyLayoutId,
    HelpLayoutPortalsListElement: $fe9f0b2091168274$var$emptyLayoutId,
    HelpLayoutSuggestedRequestFormsListElement: $fe9f0b2091168274$var$emptyLayoutId,
    HelpLayoutForgeElement: [],
    HelpLayoutConnectElement: []
};
const $fe9f0b2091168274$export$d4c72bab9d6cc13a = {
    layoutIds: $fe9f0b2091168274$export$1cb7963f0d33db7c,
    isPageInEditMode: false,
    isPageInPreviewMode: false,
    isPageInBrandingPreviewMode: false,
    isPublishing: false,
    isPublishDisabled: true,
    isDirty: false,
    mediaConfig: {},
    deletedModulesCount: 0,
    reorderedModulesCount: 0,
    screenName: undefined,
    experience: undefined,
    traceId: undefined,
    events: {
        selected: undefined,
        hovered: undefined,
        dragged: undefined,
        sectionPickerId: undefined
    },
    configPanel: {
        ui: null
    },
    config: $fe9f0b2091168274$export$c78554af6dbb181d()
};
const $fe9f0b2091168274$export$6f57813fe9f31bf9 = (0, $kUoOn.createStore)({
    initialState: $fe9f0b2091168274$export$d4c72bab9d6cc13a,
    actions: $f8kjw.actions,
    name: 'LayoutBuilderStore'
});
const $fe9f0b2091168274$export$13f23e293cec2ec3 = ()=>({ setState: setState }, { configPanelUI: configPanelUI, editMode: editMode, ElementRenderer: ElementRenderer, screenName: screenName, experience: experience, traceId: traceId, mediaConfig: mediaConfig, pageType: pageType, config: config = {}, events: events = {} })=>{
        setState({
            events: events,
            mediaConfig: mediaConfig,
            ElementRenderer: ElementRenderer,
            screenName: screenName,
            experience: experience,
            traceId: traceId,
            pageType: (0, $HGACo.isCustomPagesUiEnabled)() ? pageType : undefined,
            isPageInEditMode: editMode,
            isPageInPreviewMode: false,
            config: {
                ...$fe9f0b2091168274$export$c78554af6dbb181d(),
                ...config
            },
            configPanel: {
                ui: configPanelUI
            }
        });
    };
const $fe9f0b2091168274$export$b4aab0ffc58aaa5 = (0, $iOIPr.createContainer)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    onInit: $fe9f0b2091168274$export$13f23e293cec2ec3,
    displayName: 'LayoutBuilderContainer'
});
const $fe9f0b2091168274$export$7be577f8255e624c = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getIsPageInEditMode)
});
const $fe9f0b2091168274$export$20672b722d2aa4d4 = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getIsPageInPreviewMode)
});
const $fe9f0b2091168274$export$1672d32e0a0e6fce = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getSectionPickerId)
});
const $fe9f0b2091168274$export$66366b49ee6cbaa2 = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getSelectedPrimitive)
});
const $fe9f0b2091168274$export$b9b3eff0a656013d = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getIsPublishing)
});
const $fe9f0b2091168274$export$122ac12905cb91a9 = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getIsPublishDisabled)
});
const $fe9f0b2091168274$export$9b9cd7e7602f602f = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getIsDirty)
});
const $fe9f0b2091168274$export$7f746b47c356effa = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getMediaConfig)
});
const $fe9f0b2091168274$export$dbe8a2a3e19e92cf = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getIsPageInBrandingPreviewMode)
});
const $fe9f0b2091168274$export$6bc9f3ef36ce1121 = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getLayoutConfig)
});
const $fe9f0b2091168274$export$5fb152f2612e3297 = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getLayoutIds)
});
const $fe9f0b2091168274$export$68c713430d820919 = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getElementRenderer)
});
const $fe9f0b2091168274$export$2056c520eb48ec8b = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (state)=>state.deletedModulesCount
});
const $fe9f0b2091168274$export$4010704f08b334ba = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (state)=>state.reorderedModulesCount
});
const $fe9f0b2091168274$export$7eebf066d70abd18 = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (0, $gy1IC.getConfigPanelUI)
});
const $fe9f0b2091168274$export$4ca74c2ebe5e7020 = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageType
});
const $fe9f0b2091168274$export$1069bba51f142634 = (0, $6xLCs.createHook)($fe9f0b2091168274$export$6f57813fe9f31bf9);

});
parcelRegister("f8kjw", function(module, exports) {
$parcel$export(module.exports, "actions", () => $3b1dd00291a0e3cb$export$e324594224ef24da);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");
parcelRequire("eVjSG");
var $h5G7a = parcelRequire("h5G7a");
const $3b1dd00291a0e3cb$export$eed4cbff0d0952a0 = ()=>({ getState: getState, setState: setState })=>{
        var _currentState$events$, _currentState$events$2;
        const currentState = getState();
        const pageDataId = (_currentState$events$ = currentState.events.selected) === null || _currentState$events$ === void 0 || (_currentState$events$ = _currentState$events$.path[0]) === null || _currentState$events$ === void 0 ? void 0 : _currentState$events$.dataId;
        setState({
            events: {
                hovered: undefined,
                selected: (0, $HGACo.isIncreasedFlexibilityEnabled)() && pageDataId ? {
                    dataId: pageDataId,
                    path: ((_currentState$events$2 = currentState.events.selected) === null || _currentState$events$2 === void 0 ? void 0 : _currentState$events$2.path.slice(0, 1)) || []
                } : undefined,
                sectionPickerId: undefined
            },
            configPanel: {
                ui: (0, $HGACo.isIncreasedFlexibilityEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $h5G7a.ConfigPanelEmptyState), null)
            }
        });
    };
const $3b1dd00291a0e3cb$export$2b82c83704d16f1e = (dataId, path)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                selected: {
                    dataId: dataId,
                    path: path
                }
            }
        });
    };
const $3b1dd00291a0e3cb$export$63f1a53b56db7e60 = (dataId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                hovered: dataId
            }
        });
    };
const $3b1dd00291a0e3cb$export$703359b98869d7ca = (dataId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                dragged: dataId
            }
        });
    };
const $3b1dd00291a0e3cb$export$f03c06073cab57c8 = (sectionId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                hovered: undefined,
                selected: undefined,
                sectionPickerId: sectionId
            }
        });
    };
const $3b1dd00291a0e3cb$export$7cc839743e7817e1 = (isPublishing)=>({ setState: setState })=>{
        setState({
            isPublishing: isPublishing
        });
    };
const $3b1dd00291a0e3cb$export$e1757f155540af7b = (isPublishDisabled)=>({ setState: setState })=>{
        setState({
            isPublishDisabled: isPublishDisabled
        });
    };
const $3b1dd00291a0e3cb$export$12e1d22d39b53fc8 = (isDirty)=>({ setState: setState })=>{
        setState({
            isDirty: isDirty
        });
    };
const $3b1dd00291a0e3cb$export$8170ce9a15707844 = (isPageInBrandingPreviewMode)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isPageInBrandingPreviewMode: isPageInBrandingPreviewMode
        });
    };
const $3b1dd00291a0e3cb$export$6c5886565b08070e = (sectionId, elementId, typename)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (typename === 'HelpLayoutForgeElement' || typename === 'HelpLayoutConnectElement') {
            const updatedLayoutIds = {
                ...currentState.layoutIds
            };
            updatedLayoutIds[typename] = [
                ...updatedLayoutIds[typename] || [],
                {
                    sectionId: sectionId,
                    elementId: elementId
                }
            ];
            setState({
                ...currentState,
                layoutIds: updatedLayoutIds
            });
            return;
        }
        setState({
            ...currentState,
            layoutIds: {
                ...currentState.layoutIds,
                [typename]: {
                    sectionId: sectionId,
                    elementId: elementId
                }
            }
        });
    };
const $3b1dd00291a0e3cb$export$18ae1b41966470b5 = ()=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentPreviewMode = currentState.isPageInPreviewMode;
        setState({
            ...currentState,
            isPageInPreviewMode: !currentPreviewMode
        });
    };
const $3b1dd00291a0e3cb$export$59e3de019265ab87 = (deletedModulesCount)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            deletedModulesCount: deletedModulesCount
        });
    };
const $3b1dd00291a0e3cb$export$dd986587ada0d176 = (ui)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            configPanel: {
                ui: ui
            }
        });
    };
const $3b1dd00291a0e3cb$export$de05f3d90acd4969 = (reorderedModulesCount)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            reorderedModulesCount: reorderedModulesCount
        });
    };
const $3b1dd00291a0e3cb$export$20a1a9b113e6ba3a = (mediaConfig)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            mediaConfig: mediaConfig
        });
    };
const $3b1dd00291a0e3cb$export$e324594224ef24da = {
    markPageSelected: $3b1dd00291a0e3cb$export$eed4cbff0d0952a0,
    markSelected: $3b1dd00291a0e3cb$export$2b82c83704d16f1e,
    markHovered: $3b1dd00291a0e3cb$export$63f1a53b56db7e60,
    markDragged: $3b1dd00291a0e3cb$export$703359b98869d7ca,
    markSectionDialogOpen: $3b1dd00291a0e3cb$export$f03c06073cab57c8,
    markIsPublishing: $3b1dd00291a0e3cb$export$7cc839743e7817e1,
    markIsPublishDisabled: $3b1dd00291a0e3cb$export$e1757f155540af7b,
    markIsDirty: $3b1dd00291a0e3cb$export$12e1d22d39b53fc8,
    markBrandingPreviewMode: $3b1dd00291a0e3cb$export$8170ce9a15707844,
    setLayoutId: $3b1dd00291a0e3cb$export$6c5886565b08070e,
    togglePreviewMode: $3b1dd00291a0e3cb$export$18ae1b41966470b5,
    setDeletedModulesCount: $3b1dd00291a0e3cb$export$59e3de019265ab87,
    setReorderedModulesCount: $3b1dd00291a0e3cb$export$de05f3d90acd4969,
    setMediaConfig: $3b1dd00291a0e3cb$export$20a1a9b113e6ba3a,
    setConfigPanelUI: $3b1dd00291a0e3cb$export$dd986587ada0d176
};

});
parcelRegister("eVjSG", function(module, exports) {
$parcel$export(module.exports, "ConfigPanelEmptyState", () => (parcelRequire("h5G7a")).ConfigPanelEmptyState);

var $h5G7a = parcelRequire("h5G7a");

});
parcelRegister("h5G7a", function(module, exports) {
$parcel$export(module.exports, "ConfigPanelEmptyState", () => $448b7ce9a1f2d84a$export$2fdc624ef67f147b);

var $8P7DW = parcelRequire("8P7DW");

var $iqzlA = parcelRequire("iqzlA");

var $5jYgE = parcelRequire("5jYgE");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $iYPGp = parcelRequire("iYPGp");
const $448b7ce9a1f2d84a$export$2fdc624ef67f147b = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "medium",
        as: "h3"
    }, formatMessage((0, $iYPGp.default).emptyConfigPanelHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $448b7ce9a1f2d84a$var$emptyConfigPanelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iqzlA))),
        alt: formatMessage((0, $iYPGp.default).emptyConfigPanelImageAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        align: "center",
        as: "p"
    }, formatMessage((0, $iYPGp.default).emptyConfigPanelText, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("b", null, chunks)
    }))));
};
const $448b7ce9a1f2d84a$var$emptyConfigPanelStyles = (0, $37U6z.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 'space.400',
    gap: 'space.200'
});

});
parcelRegister("iqzlA", function(module, exports) {
module.exports = new URL("../images/config-panel-default.4e21e8e2.svg", import.meta.url).toString();

});

parcelRegister("iYPGp", function(module, exports) {
$parcel$export(module.exports, "default", () => $62363a0045304c7e$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $62363a0045304c7e$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    emptyConfigPanelHeading: {
        defaultMessage: 'Edit page layout',
        description: 'Heading to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.heading'
    },
    emptyConfigPanelText: {
        defaultMessage: 'Pages are made of horizontal blocks called <b>sections</b> to which you can add <b>rich content.</b> Select an existing section or add a new one to get started.',
        description: 'Text to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.text'
    },
    emptyConfigPanelImageAltText: {
        defaultMessage: 'The config panel is empty',
        description: 'Alt text for image to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.image.alt'
    }
});

});




parcelRegister("gy1IC", function(module, exports) {
$parcel$export(module.exports, "getIsPageInEditMode", () => $cd0b75edfeb6a026$export$31efc24b85422f28);
$parcel$export(module.exports, "getIsPageInPreviewMode", () => $cd0b75edfeb6a026$export$b16c6dd5c9190b1a);
$parcel$export(module.exports, "getSectionPickerId", () => $cd0b75edfeb6a026$export$c00ca6bc45704b1a);
$parcel$export(module.exports, "getSelectedPrimitive", () => $cd0b75edfeb6a026$export$12c45f99974b2f6);
$parcel$export(module.exports, "getIsPublishing", () => $cd0b75edfeb6a026$export$114b0b1eb879caeb);
$parcel$export(module.exports, "getIsPublishDisabled", () => $cd0b75edfeb6a026$export$8626e45ed1d507a4);
$parcel$export(module.exports, "getIsDirty", () => $cd0b75edfeb6a026$export$4b1964ee9ad6f220);
$parcel$export(module.exports, "getMediaConfig", () => $cd0b75edfeb6a026$export$e0c7d660f7459c46);
$parcel$export(module.exports, "getIsPageInBrandingPreviewMode", () => $cd0b75edfeb6a026$export$5f742d52a7bee27e);
$parcel$export(module.exports, "getLayoutConfig", () => $cd0b75edfeb6a026$export$61bd5e607ff26d43);
$parcel$export(module.exports, "getLayoutIds", () => $cd0b75edfeb6a026$export$c3b66d8cabe26730);
$parcel$export(module.exports, "getElementRenderer", () => $cd0b75edfeb6a026$export$21591c7e677a0342);
$parcel$export(module.exports, "getConfigPanelUI", () => $cd0b75edfeb6a026$export$eab87a6b2cabf1fe);
const $cd0b75edfeb6a026$export$31efc24b85422f28 = (state)=>state.isPageInEditMode;
const $cd0b75edfeb6a026$export$b16c6dd5c9190b1a = (state)=>state.isPageInPreviewMode;
const $cd0b75edfeb6a026$export$c00ca6bc45704b1a = (state)=>state.events.sectionPickerId;
const $cd0b75edfeb6a026$export$12c45f99974b2f6 = (state)=>state.events.selected;
const $cd0b75edfeb6a026$export$114b0b1eb879caeb = (state)=>state.isPublishing;
const $cd0b75edfeb6a026$export$8626e45ed1d507a4 = (state)=>state.isPublishDisabled;
const $cd0b75edfeb6a026$export$4b1964ee9ad6f220 = (state)=>state.isDirty;
const $cd0b75edfeb6a026$export$e0c7d660f7459c46 = (state)=>state.mediaConfig;
const $cd0b75edfeb6a026$export$5f742d52a7bee27e = (state)=>state.isPageInBrandingPreviewMode;
const $cd0b75edfeb6a026$export$61bd5e607ff26d43 = (state)=>state.config;
const $cd0b75edfeb6a026$export$c3b66d8cabe26730 = (state)=>state.layoutIds;
const $cd0b75edfeb6a026$export$21591c7e677a0342 = (state)=>state.ElementRenderer;
const $cd0b75edfeb6a026$export$eab87a6b2cabf1fe = (state)=>state.configPanel.ui;

});



parcelRegister("hDvTi", function(module, exports) {
$parcel$export(module.exports, "PortalName", () => $954d5b35662aaca1$export$388673bc95b650ac);
$parcel$export(module.exports, "Description", () => $954d5b35662aaca1$export$393edc798c47379d);
$parcel$export(module.exports, "Content", () => $954d5b35662aaca1$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "cardStyle", () => $954d5b35662aaca1$export$20fbd02c8b16da77);
$parcel$export(module.exports, "IconContainer", () => $954d5b35662aaca1$export$8f314e512d92575f);
$parcel$export(module.exports, "Container", () => $954d5b35662aaca1$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $1p41U = parcelRequire("1p41U");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $3xuD5 = parcelRequire("3xuD5");
const $954d5b35662aaca1$export$388673bc95b650ac = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ics84-0"
})`${$kBzhX.h400};max-width:100%;margin-top:0;margin-bottom:${"var(--ds-space-050, 4px)"};${(props)=>{
    const lines = props.hasOnlyPortalName ? 3 : 1;
    const lineHeight = $4cxV2.multiple(2).unitless;
    return $6t2I3.multiLineClamp(lines, lineHeight);
}};${$1p41U.fromXSmall.css`
        ${$kBzhX.h500};
        margin-top: 0;
        margin-bottom: ${"var(--ds-space-100, 8px)"};
        max-height: ${(props)=>props.hasOnlyPortalName ? $4cxV2.multiple(7.5).px : $4cxV2.multiple(2.5).px};
    `};&{color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};}`;
const $954d5b35662aaca1$export$393edc798c47379d = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ics84-1"
})`${$kBzhX.xsmall};${$6t2I3.multiLineClamp(3, $4cxV2.multiple(2.25).unitless)};max-width:100%;color:${"var(--ds-text, #172B4D)"};line-height:${$4cxV2.multiple(2.25).px};${$1p41U.fromXSmall.css`
        ${$kBzhX.regular};
        line-height: ${$4cxV2.multiple(2.5).px};
        max-height: ${$4cxV2.multiple(7.5).px};
    `};`;
const $954d5b35662aaca1$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ics84-2"
})`overflow:hidden;width:100%;height:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;`;
const $954d5b35662aaca1$export$20fbd02c8b16da77 = /*#__PURE__*/ (0, $2UsNA.css)`${$6t2I3.borderRadius};${$6t2I3.focusRing.default};box-sizing:border-box;display:block;position:relative;height:${$4cxV2.multiple(14).px};width:${$4cxV2.multiple(33).px};z-index:${$3xuD5.portalCardLayout};${$1p41U.fromXSmall.css`
    height: ${$4cxV2.multiple(18).px};
    width: ${$4cxV2.multiple(42).px};
`};`;
const $954d5b35662aaca1$export$8f314e512d92575f = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ics84-3"
})`${$6t2I3.flexCenter};height:${$4cxV2.multiple(5).px};width:${$4cxV2.multiple(5).px};flex-shrink:0;margin-right:${"var(--ds-space-200, 16px)"};${$1p41U.fromXSmall.css`
        height: ${$4cxV2.multiple(6).px};
        width: ${$4cxV2.multiple(6).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $954d5b35662aaca1$var$largePadding = /*#__PURE__*/ (0, $2UsNA.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"};${$1p41U.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-400, 32px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $954d5b35662aaca1$var$smallPadding = /*#__PURE__*/ (0, $2UsNA.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"};${$1p41U.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"};
    `};`;
const $954d5b35662aaca1$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-3ics84-4"
})`display:flex;width:100%;height:100%;box-sizing:border-box;align-items:center;justify-content:flex-start;${(props)=>props.hasIcon ? $954d5b35662aaca1$var$smallPadding : $954d5b35662aaca1$var$largePadding};`;

});



parcelRegister("66Daz", function(module, exports) {
$parcel$export(module.exports, "ProjectCard", () => (parcelRequire("73vVc")).default);
$parcel$export(module.exports, "Overlay", () => (parcelRequire("dTPQP")).Overlay);
$parcel$export(module.exports, "DragHandlerWrapper", () => (parcelRequire("dTPQP")).DragHandlerWrapper);
$parcel$export(module.exports, "cardGutterStyle", () => (parcelRequire("dTPQP")).cardGutterStyle);
$parcel$export(module.exports, "Root", () => (parcelRequire("dTPQP")).Root);
$parcel$export(module.exports, "Wrapper", () => (parcelRequire("dTPQP")).Wrapper);

var $73vVc = parcelRequire("73vVc");

var $dTPQP = parcelRequire("dTPQP");

});
parcelRegister("73vVc", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd976eba93e196f9$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");
parcelRequire("9FfOm");
var $2CIj9 = parcelRequire("2CIj9");

var $dTPQP = parcelRequire("dTPQP");
const $dd976eba93e196f9$var$mapStateToProps = (state)=>{
    return {
        isPortalHidingEnabled: (0, $2CIj9.getIsPortalHidingEnabled)(state)
    };
};
var $dd976eba93e196f9$export$2e2bcd8739ae039 = (0, $jvoWT.default)($dd976eba93e196f9$var$mapStateToProps)((0, $dTPQP.default));

});
parcelRegister("dTPQP", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $26e8b606fbe9438b$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "Root", () => $26e8b606fbe9438b$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "DragHandlerWrapper", () => $26e8b606fbe9438b$export$5761cab24db81fb9);
$parcel$export(module.exports, "ScreenReaderInstruction", () => $26e8b606fbe9438b$export$a5ddd0c37fc6764f);
$parcel$export(module.exports, "default", () => $26e8b606fbe9438b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "cardGutterStyle", () => $26e8b606fbe9438b$export$c83f43d52281dc9d);
$parcel$export(module.exports, "Overlay", () => $26e8b606fbe9438b$export$c6fdb837b070b4ff);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $kFYzS = parcelRequire("kFYzS");

var $1p41U = parcelRequire("1p41U");

var $9yRgH = parcelRequire("9yRgH");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");

var $3xuD5 = parcelRequire("3xuD5");

var $l4a5B = parcelRequire("l4a5B");
parcelRequire("5HuF4");
var $2Mg2Y = parcelRequire("2Mg2Y");

var $iZBCz = parcelRequire("iZBCz");

var $elt7A = parcelRequire("elt7A");

var $3ZNUN = parcelRequire("3ZNUN");

var $glueQ = parcelRequire("glueQ");

var $32tao = parcelRequire("32tao");
parcelRequire("iiDlL");
var $hDvTi = parcelRequire("hDvTi");

var $hDvTi = parcelRequire("hDvTi");

var $0u4yn = parcelRequire("0u4yn");
const $26e8b606fbe9438b$export$bacf8f04493bf68c = ({ id: id, name: name, description: description, iconUrl: iconUrl, isFeatured: isFeatured, isDropped: isDropped, className: className, intl: intl, hiddenFromHomeScreen: hiddenFromHomeScreen, hideActionButtons: hideActionButtons, isPortalHidingEnabled: isPortalHidingEnabled, onToggleFeatured: onToggleFeatured, onToggleVisibility: onToggleVisibility })=>{
    const hasIcon = !!iconUrl;
    const hasOnlyPortalName = !description && !iconUrl;
    const onFeaturedStarClick = $8P7DW.useCallback(()=>{
        onToggleFeatured && onToggleFeatured(id, !isFeatured);
    }, [
        id,
        isFeatured,
        onToggleFeatured
    ]);
    const onVisibilityIconClick = $8P7DW.useCallback(()=>{
        onToggleVisibility && onToggleVisibility(id, !hiddenFromHomeScreen);
    }, [
        id,
        hiddenFromHomeScreen,
        onToggleVisibility
    ]);
    const rootProps = isFeatured ? {
        isDropped: isDropped,
        isFeatured: true
    } : {
        isFeatured: false
    };
    const featuredProjectToolTip = intl.formatMessage((0, $0u4yn.default).featuredProjectTooltip);
    const unFeaturedProjectToolTip = intl.formatMessage((0, $0u4yn.default).unFeaturedProjectTooltip);
    const visibleProjectTooltip = intl.formatMessage((0, $0u4yn.default).visibleProjectTooltip);
    const hiddenProjectTooltip = intl.formatMessage((0, $0u4yn.default).hiddenProjectTooltip);
    const featureToolTip = {
        highlightedMessage: featuredProjectToolTip,
        unHighlightedMessage: unFeaturedProjectToolTip
    };
    const featureAriaLabel = {
        highlightedLabel: featuredProjectToolTip,
        unHighlightedLabel: unFeaturedProjectToolTip
    };
    const visibilityToolTip = {
        highlightedMessage: visibleProjectTooltip,
        unHighlightedMessage: hiddenProjectTooltip
    };
    const visibilityAriaLabel = {
        highlightedLabel: visibleProjectTooltip,
        unHighlightedLabel: hiddenProjectTooltip
    };
    const ariaAttributes = isFeatured ? {
        tabIndex: 0,
        role: 'button',
        'aria-labelledby': `project-card-content-${id}`,
        'aria-roledescription': 'Draggable item',
        'aria-describedby': 'featured-portals-screen-reader-description'
    } : {};
    return /*#__PURE__*/ $8P7DW.createElement($26e8b606fbe9438b$export$e6dfd72ab29f8598, {
        "data-test-id": isFeatured ? `featured-card-${id}` : null,
        "data-testid": isFeatured ? `featured-card-${id}` : 'unfeatured-card',
        ...className ? {
            className: className
        } : {},
        ...ariaAttributes
    }, /*#__PURE__*/ $8P7DW.createElement($26e8b606fbe9438b$export$be92b6f5f03c0fe9, rootProps, /*#__PURE__*/ $8P7DW.createElement($26e8b606fbe9438b$var$Container, {
        hasIcon: hasIcon,
        isDraggable: isFeatured
    }, isFeatured && /*#__PURE__*/ $8P7DW.createElement($26e8b606fbe9438b$export$5761cab24db81fb9, null, /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZBCz))), {
        label: "drag-handler",
        size: "medium",
        spacing: "spacious"
    })), hasIcon && /*#__PURE__*/ $8P7DW.createElement((0, $hDvTi.IconContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $kFYzS.default), {
        src: iconUrl,
        alt: "icon"
    })), /*#__PURE__*/ $8P7DW.createElement((0, $hDvTi.Content), {
        id: `project-card-content-${id}`
    }, /*#__PURE__*/ $8P7DW.createElement($26e8b606fbe9438b$var$ProjectName, {
        hasOnlyPortalName: hasOnlyPortalName,
        title: name
    }, name), !!description && /*#__PURE__*/ $8P7DW.createElement((0, $hDvTi.Description), {
        title: description,
        dangerouslySetInnerHTML: {
            __html: description
        }
    })), !hideActionButtons && /*#__PURE__*/ $8P7DW.createElement($26e8b606fbe9438b$var$Actions, null, isPortalHidingEnabled && (!isFeatured || hiddenFromHomeScreen) && /*#__PURE__*/ $8P7DW.createElement((0, $2Mg2Y.default), {
        isHighlighted: !hiddenFromHomeScreen,
        highlightHandler: onVisibilityIconClick,
        toolTip: visibilityToolTip,
        ariaLabel: visibilityAriaLabel,
        actionSubjectId: hiddenFromHomeScreen ? 'hiddenCard' : 'visibleCard',
        icon: {
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            HighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3ZNUN))),
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            UnHighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($elt7A)))
        }
    }), (!isPortalHidingEnabled || !hiddenFromHomeScreen) && /*#__PURE__*/ $8P7DW.createElement((0, $2Mg2Y.default), {
        isHighlighted: isFeatured,
        highlightHandler: onFeaturedStarClick,
        toolTip: featureToolTip,
        ariaLabel: featureAriaLabel,
        actionSubjectId: isFeatured ? 'featuredCard' : 'unFeaturedCard',
        icon: {
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            HighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($glueQ))),
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            UnHighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($32tao)))
        },
        color: {
            highlightedColor: "var(--ds-background-accent-yellow-subtler, #FFC400)"
        }
    })))));
};
const $26e8b606fbe9438b$export$a5ddd0c37fc6764f = ({ intl: intl })=>/*#__PURE__*/ $8P7DW.createElement($26e8b606fbe9438b$var$SortableCardDescription, {
        id: "featured-portals-screen-reader-description"
    }, intl.formatMessage((0, $0u4yn.default).screenReaderInstructionsForReordering));
var $26e8b606fbe9438b$export$2e2bcd8739ae039 = /*#__PURE__*/ $8P7DW.memo((0, $l4a5B.default)($26e8b606fbe9438b$export$bacf8f04493bf68c));
const $26e8b606fbe9438b$export$c83f43d52281dc9d = /*#__PURE__*/ (0, $2UsNA.css)`margin:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"};${$1p41U.fromLarge.css`
margin: ${"var(--ds-space-200, 16px)"} ${$4cxV2.multiple(4.75).px};
`}`;
const $26e8b606fbe9438b$var$rootBackgroundColor = (props)=>props.isDropped ? "var(--ds-surface-raised-pressed, #DEEBFF)" : "var(--ds-surface-raised, #FFFFFF)";
const $26e8b606fbe9438b$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1tkctfp-0"
})`${(0, $hDvTi.cardStyle)} ${(props)=>props.isFeatured ? $6t2I3.raiseUpOnHoverOrFocus((0, $9yRgH.newElevationsFromDesignSystems).e100, (0, $9yRgH.newElevationsFromDesignSystems).e200) : (0, $9yRgH.newElevationsFromDesignSystems).e100};${(props)=>$6t2I3.applyIf(!Boolean(props.isFeatured), 'z-index: 0;')} background-color:${$26e8b606fbe9438b$var$rootBackgroundColor};user-select:none;${(props)=>props.isFeatured && !props.isDropped && (0, $2UsNA.css)({
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #F4F5F7)"
        }
    })};&:hover,&:focus{z-index:${$3xuD5.portalCardLayout};text-decoration:none;}&::after{cursor:${(props)=>{
    return props.isFeatured ? 'grab' : 'auto';
}};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $26e8b606fbe9438b$var$Actions = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1tkctfp-1"
})`display:flex;flex-direction:row;align-items:center;position:absolute;top:${"var(--ds-space-100, 8px)"};right:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $26e8b606fbe9438b$var$Container = /*#__PURE__*/ (0, $2UsNA.default)((0, $hDvTi.Container)).withConfig({
    componentId: "sc-1tkctfp-2"
})`padding-right:${$4cxV2.multiple(5.5).px};${({ isDraggable: isDraggable })=>isDraggable ? `padding-left: ${"var(--ds-space-500, 40px)"}` : ''};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $26e8b606fbe9438b$var$ProjectName = /*#__PURE__*/ (0, $2UsNA.default)((0, $hDvTi.PortalName)).withConfig({
    componentId: "sc-1tkctfp-3"
})`color:${"var(--ds-text, #172B4D)"};`;
const $26e8b606fbe9438b$var$boxShadow = `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} rgba(0, 0, 0, 0.15)`;
const $26e8b606fbe9438b$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $2UsNA.default).li.withConfig({
    componentId: "sc-1tkctfp-4"
})`${$26e8b606fbe9438b$export$c83f43d52281dc9d} touch-action:none;list-style:none;&:focus{${$6t2I3.focusRing.default};& ${$26e8b606fbe9438b$export$be92b6f5f03c0fe9}{&:hover{transform:translate3d(0,0,0);}}}&.sortable-helper{cursor:grabbing !important;pointer-events:auto !important;list-style:none;${$26e8b606fbe9438b$export$be92b6f5f03c0fe9}{background-color:${$26e8b606fbe9438b$var$rootBackgroundColor};&::after{cursor:grabbing;}&:hover{cursor:grabbing;background-color:${"var(--ds-surface-raised, #FFFFFF)"};}box-shadow:${`var(--ds-shadow-overlay, ${$26e8b606fbe9438b$var$boxShadow})`};}}`;
const $26e8b606fbe9438b$export$5761cab24db81fb9 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1tkctfp-5"
})`left:${"var(--ds-space-050, 4px)"};position:absolute;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $26e8b606fbe9438b$var$SortableCardDescription = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1tkctfp-6"
})`display:none;`;
const $26e8b606fbe9438b$export$c6fdb837b070b4ff = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1tkctfp-7"
})`${(0, $hDvTi.cardStyle)} ${$26e8b606fbe9438b$export$c83f43d52281dc9d} background-color:${(props)=>props.show ? "var(--ds-background-selected-hovered, #B3D4FF)" : "var(--ds-surface-raised, transparent)"};opacity:0.3;transition:all 0.2s;`;

});
parcelRegister("5HuF4", function(module, exports) {
$parcel$export(module.exports, "Highlighter", () => (parcelRequire("2Mg2Y")).default);

var $2Mg2Y = parcelRequire("2Mg2Y");

});
parcelRegister("2Mg2Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $96ba313eee14a9aa$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $8y05I = parcelRequire("8y05I");

var $3xuD5 = parcelRequire("3xuD5");

var $ea6bZ = parcelRequire("ea6bZ");
const $96ba313eee14a9aa$export$7cc17c9bd3240823 = ({ isHighlighted: isHighlighted, highlightHandler: highlightHandler, toolTip: toolTip, ariaLabel: ariaLabel, actionSubjectId: actionSubjectId, icon: icon, color: color })=>{
    const toolTipMessage = isHighlighted ? toolTip.highlightedMessage : toolTip.unHighlightedMessage;
    const ariaLabelContent = isHighlighted ? ariaLabel.highlightedLabel : ariaLabel.unHighlightedLabel;
    const { HighlightedIcon: HighlightedIcon, UnHighlightedIcon: UnHighlightedIcon } = icon;
    return /*#__PURE__*/ $8P7DW.createElement($96ba313eee14a9aa$var$HighlighterButtonContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $ea6bZ.default), {
        content: toolTipMessage,
        position: "top",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $8y05I.Button), {
        type: "button",
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "project-card-action-button",
        onClick: highlightHandler,
        actionSubjectId: actionSubjectId,
        iconBefore: isHighlighted ? /*#__PURE__*/ $8P7DW.createElement(HighlightedIcon, {
            label: ariaLabelContent,
            color: color === null || color === void 0 ? void 0 : color.highlightedColor,
            size: "medium"
        }) : /*#__PURE__*/ $8P7DW.createElement(UnHighlightedIcon, {
            label: ariaLabelContent,
            color: color === null || color === void 0 ? void 0 : color.unHighlightedColor,
            size: "medium"
        })
    })));
};
var $96ba313eee14a9aa$export$2e2bcd8739ae039 = /*#__PURE__*/ $8P7DW.memo($96ba313eee14a9aa$export$7cc17c9bd3240823);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $96ba313eee14a9aa$var$HighlighterButtonContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1h5r30-0"
})`background:transparent;border:0;cursor:pointer;z-index:${(0, $3xuD5.layer)};`;

});


parcelRegister("3ZNUN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5543a1bcdfd8c47fe735784b0d385448>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e8dc9ac913f8919$var$_react = $2e8dc9ac913f8919$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $2e8dc9ac913f8919$var$_baseNew = $2e8dc9ac913f8919$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $2e8dc9ac913f8919$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e8dc9ac913f8919$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $2e8dc9ac913f8919$var$_react.default.createElement($2e8dc9ac913f8919$var$_baseNew.default, Object.assign({
        name: "EyeOpenFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$2e8dc9ac913f8919$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $2e8dc9ac913f8919$var$_default = module.exports.default = $2e8dc9ac913f8919$var$EyeOpenFilledIcon;

});

parcelRegister("0u4yn", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f4c452536148886$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $0f4c452536148886$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    featuredProjectTooltip: {
        defaultMessage: 'Remove from featured section',
        description: 'Tootip message when hovered on remove from featured button',
        id: 'cv.portal.reordering.experience.featured.card.tooltip'
    },
    unFeaturedProjectTooltip: {
        defaultMessage: 'Feature this portal',
        description: 'Tootip message when hovered on feature portal button',
        id: 'cv.portal.reordering.experience.unfeatured.card.tooltip'
    },
    visibleProjectTooltip: {
        defaultMessage: 'Hide from home page',
        description: 'Tootip message when hovered on hide button',
        id: 'cv.portal.reordering.experience.shown.card.tooltip.non-final'
    },
    hiddenProjectTooltip: {
        defaultMessage: 'Show on home page',
        description: 'Tootip message when hovered on show project button',
        id: 'cv.portal.reordering.experience.hidden.card.tooltip.non-final'
    },
    screenReaderInstructionsForReordering: {
        defaultMessage: 'Press space to pick up a portal. Use the up and down arrow keys to move it to a new position. Press space or enter to drop it in a new position, or press escape to cancel',
        description: 'message to be readout by screen reader when a project card is focused',
        id: 'cv.portal.reordering.experience.screen.reader.instruction'
    }
});

});




parcelRegister("eymra", function(module, exports) {
$parcel$export(module.exports, "titleSkeletonHeight", () => $e7a88526457b9926$export$627219b6093d39c1);
$parcel$export(module.exports, "IconContainer", () => (parcelRequire("hDvTi")).IconContainer);
$parcel$export(module.exports, "Content", () => (parcelRequire("hDvTi")).Content);
$parcel$export(module.exports, "Container", () => (parcelRequire("hDvTi")).Container);

var $hDvTi = parcelRequire("hDvTi");
const $e7a88526457b9926$export$627219b6093d39c1 = '21px';

});



parcelRegister("hELvu", function(module, exports) {
$parcel$export(module.exports, "ActionBarWithButtonsStateless", () => (parcelRequire("iToix")).default);

var $iToix = parcelRequire("iToix");

});
parcelRegister("iToix", function(module, exports) {
$parcel$export(module.exports, "default", () => $f30c157da611ce5a$export$2e2bcd8739ae039);
/* action-bar-with-buttons-stateless.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
var $77UGK = parcelRequire("77UGK");

var $8y05I = parcelRequire("8y05I");

var $4cxV2 = parcelRequire("4cxV2");

var $l4a5B = parcelRequire("l4a5B");

var $jp1Tm = parcelRequire("jp1Tm");

var $iqJis = parcelRequire("iqJis");

var $1P5py = parcelRequire("1P5py");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $dOef8 = parcelRequire("dOef8");
const $f30c157da611ce5a$export$f749d3fa2628ac53 = ({ intl: intl, isDirty: isDirty, openCancelPrompt: openCancelPrompt, openPublishPrompt: openPublishPrompt })=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $1P5py.default), {
        name: "portal-reordering-action-buttons"
    }, /*#__PURE__*/ $8P7DW.createElement($f30c157da611ce5a$var$ButtonContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $jp1Tm.default), null, /*#__PURE__*/ $8P7DW.createElement((0, $8y05I.Button), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "portal-reordering-cancel-button",
        onClick: openCancelPrompt,
        actionSubjectId: "cancelPortalsReorder",
        "data-test-id": "cancel-portal-reorder-experience-action-bar"
    }, intl.formatMessage((0, $dOef8.default).cancelButtonLabel)), /*#__PURE__*/ $8P7DW.createElement((0, $8y05I.Button), {
        appearance: "primary",
        isDisabled: !isDirty,
        onClick: openPublishPrompt,
        actionSubjectId: "publishPortalsReorder",
        "data-test-id": "publish-portal-reorder-experience-action-bar"
    }, intl.formatMessage((0, $dOef8.default).publishButtonLabel)))));
};
class $f30c157da611ce5a$export$ec006b65f267cb6c extends $8P7DW.Component {
    renderHeading() {
        const { intl: intl } = this.props;
        if ((0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType)) return intl.formatMessage((0, $dOef8.default).actionBarTitleCSM);
        return intl.formatMessage((0, $dOef8.default).actionBarTitleNew);
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement($f30c157da611ce5a$var$Wrapper, null, /*#__PURE__*/ $8P7DW.createElement($f30c157da611ce5a$var$PageHeaderWrapper, null, /*#__PURE__*/ $8P7DW.createElement($f30c157da611ce5a$var$PageHeader, null, /*#__PURE__*/ $8P7DW.createElement($f30c157da611ce5a$var$Title, null, /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
            size: "medium",
            as: "div"
        }, this.renderHeading())), /*#__PURE__*/ $8P7DW.createElement($f30c157da611ce5a$export$f749d3fa2628ac53, this.props)), children));
    }
}
var $f30c157da611ce5a$export$2e2bcd8739ae039 = (0, $l4a5B.default)($f30c157da611ce5a$export$ec006b65f267cb6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f30c157da611ce5a$var$Wrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "header", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_16qs1viy _1pby16oo _154iidpf _1ltvidpf _1bsb1osq _kqsw1n9t _bfhk1bhr _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $f30c157da611ce5a$var$PageHeaderWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1jphezo": (0, $77UGK.default)($4cxV2.multiple(145).px)
        },
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt4zdiv _1bsb1osq _1bah1h6o _1gvm1xkz",
            __cmplp.className
        ])
    });
});
const $f30c157da611ce5a$var$ButtonContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_b2vlsk": (0, $77UGK.default)($4cxV2.multiple(96).px)
        },
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt41b66 _p12feuys",
            __cmplp.className
        ])
    });
});
const $f30c157da611ce5a$var$Title = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_19pkidpf _otyrpxbi _19zoidpf",
            __cmplp.className
        ])
    });
});
const $f30c157da611ce5a$var$PageHeader = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_18s8r2fv _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1yb4 _tyxhvrvc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jp1Tm", function(module, exports) {
$parcel$export(module.exports, "default", () => $53b527bafc3ec6de$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");
function $53b527bafc3ec6de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $53b527bafc3ec6de$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $53b527bafc3ec6de$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $53b527bafc3ec6de$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("dOef8", function(module, exports) {
$parcel$export(module.exports, "default", () => $16350a312cb9acbb$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $16350a312cb9acbb$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    actionBarTitle: {
        defaultMessage: 'Edit home page layout',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title'
    },
    actionBarTitleNew: {
        defaultMessage: 'Manage topics and portals',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title.topics.portals'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    actionBarTitleCSM: {
        defaultMessage: 'Manage topics',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title-csm.topics.portals'
    },
    cancelButtonLabel: {
        defaultMessage: 'Cancel',
        description: 'Label of cancel button of portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.button.cancel'
    },
    publishButtonLabel: {
        defaultMessage: 'Publish layout',
        description: 'Label of publish button of portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.button.publish'
    }
});

});



parcelRegister("iuwpd", function(module, exports) {
$parcel$export(module.exports, "SortByFilter", () => (parcelRequire("dVBtd")).default);

var $dVBtd = parcelRequire("dVBtd");

});
parcelRegister("dVBtd", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c69348c1b91cf7b$export$2e2bcd8739ae039);
/* sort-by-filter.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
var $77UGK = parcelRequire("77UGK");

var $llpuV = parcelRequire("llpuV");

var $4cxV2 = parcelRequire("4cxV2");

var $l4a5B = parcelRequire("l4a5B");

var $iqJis = parcelRequire("iqJis");

var $1P5py = parcelRequire("1P5py");

var $dacwD = parcelRequire("dacwD");
const $4c69348c1b91cf7b$var$selectCustomStyle = {
    container: (provided)=>({
            ...provided,
            marginLeft: "var(--ds-space-200, 16px)",
            width: $4cxV2.multiple(18).px
        })
};
const $4c69348c1b91cf7b$export$38d77f5667d0a049 = ({ intl: intl, isDisabled: isDisabled, value: value, shouldHideLabel: shouldHideLabel, onChange: onChange })=>{
    const sortBySelectOptions = {
        ALPHABETICALLY: intl.formatMessage((0, $dacwD.default).alphabeticOption),
        POPULARITY: intl.formatMessage((0, $dacwD.default).popularityOption)
    };
    const options = Object.entries(sortBySelectOptions).map(([key, label])=>({
            label: label,
            value: key
        }));
    const sortByChange = $8P7DW.useCallback((option)=>{
        if (option && option.value !== value) onChange(option.value);
    }, [
        onChange,
        value
    ]);
    return /*#__PURE__*/ $8P7DW.createElement((0, $1P5py.default), {
        name: "sort-by-filter"
    }, /*#__PURE__*/ $8P7DW.createElement($4c69348c1b91cf7b$var$FilterWrapper, null, /*#__PURE__*/ $8P7DW.createElement($4c69348c1b91cf7b$var$FilterContent, null, !shouldHideLabel && /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ $8P7DW.createElement("label", {
        htmlFor: "sort-by-filter"
    }, intl.formatMessage((0, $dacwD.default).sortByFilterLabel))), /*#__PURE__*/ $8P7DW.createElement((0, $llpuV.Select), {
        classNamePrefix: "portal-reorder-experience-sort-by-filter",
        actionSubjectId: "sortByFilter",
        value: {
            value: value,
            label: sortBySelectOptions[value]
        },
        options: options,
        styles: $4c69348c1b91cf7b$var$selectCustomStyle,
        isSearchable: false,
        isDisabled: isDisabled,
        onChange: sortByChange,
        inputId: "sort-by-filter",
        instanceId: "sort-by-filter"
    }))));
};
var $4c69348c1b91cf7b$export$2e2bcd8739ae039 = /*#__PURE__*/ $8P7DW.memo((0, $l4a5B.default)($4c69348c1b91cf7b$export$38d77f5667d0a049));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4c69348c1b91cf7b$var$FilterWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8vhf38": (0, $77UGK.default)($4cxV2.multiple(28).px)
        },
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1bsb1sn1 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _18u0mgjw",
            __cmplp.className
        ])
    });
});
const $4c69348c1b91cf7b$var$FilterContent = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1e0c1txw _4cvr1h6o _18u01jfw _89vyidpf _5rvhidpf _32nkidpf _wws0idpf _nw4oangw _1t2qnoz8 _r5bjidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("llpuV", function(module, exports) {
$parcel$export(module.exports, "Select", () => $3be92c2f1a4ff3d6$export$ef9b1a59e592288f);

var $8P7DW = parcelRequire("8P7DW");

var $8gu7I = parcelRequire("8gu7I");

var $hXj3O = parcelRequire("hXj3O");
class $3be92c2f1a4ff3d6$export$ef9b1a59e592288f extends $8P7DW.PureComponent {
    render() {
        const { actionSubjectId: actionSubjectId, ...selectProps } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
            data: {
                actionSubjectId: actionSubjectId
            }
        }, /*#__PURE__*/ $8P7DW.createElement((0, $hXj3O.default), selectProps));
    }
}

});

parcelRegister("dacwD", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c0213c1913f9e34$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $4c0213c1913f9e34$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    sortByFilterLabel: {
        defaultMessage: 'Sort by',
        description: 'Label for the sort by filter',
        id: 'cv.portal.reordering.experience.sortBy.filter.label'
    },
    popularityOption: {
        defaultMessage: 'Popularity',
        description: 'Label for the sort by popularity option',
        id: 'cv.portal.reordering.experience.sortBy.filter.popularity.label'
    },
    alphabeticOption: {
        defaultMessage: 'Name: A to Z',
        description: 'Label for the sort by alphabetical option',
        id: 'cv.portal.reordering.experience.sortBy.filter.alphabetical.label'
    }
});

});



parcelRegister("13rAb", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $9923633c16e4bb91$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "ExperienceContainer", () => $9923633c16e4bb91$export$4d17725865d2ba3c);
$parcel$export(module.exports, "CardsContainer", () => $9923633c16e4bb91$export$8e547173d545e862);
/* styled.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
var $77UGK = parcelRequire("77UGK");

var $4cxV2 = parcelRequire("4cxV2");

var $kJu2d = parcelRequire("kJu2d");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9923633c16e4bb91$var$HEADER_HEIGHT = `${$4cxV2.multiple(10).px}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9923633c16e4bb91$var$WRAPPER_MIN_HEIGHT = `calc(100vh - ${(0, $kJu2d.FOOTER_HEIGHT)}px - ${$9923633c16e4bb91$var$HEADER_HEIGHT})`;
const $9923633c16e4bb91$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ans5n9": (0, $77UGK.default)($9923633c16e4bb91$var$WRAPPER_MIN_HEIGHT)
        },
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1yt41r39 _1tke1j5i _138y1jfw",
            __cmplp.className
        ])
    });
});
const $9923633c16e4bb91$export$4d17725865d2ba3c = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ebxqrc": (0, $77UGK.default)($4cxV2.multiple(42).px),
            "--_1l8apj8": (0, $77UGK.default)($4cxV2.multiple(90).px),
            "--_1jphezo": (0, $77UGK.default)($4cxV2.multiple(145).px)
        },
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _kqswh2mm _19pk1ejb _p12ffptw _hclcjj99 _1gvm1xkz",
            __cmplp.className
        ])
    });
});
const $9923633c16e4bb91$export$8e547173d545e862 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $8P7DW.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1aqg72h": (0, $77UGK.default)($4cxV2.multiple(-5).px)
        },
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_18s81u5k _19itg9nf _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1n261g80 _kqswh2mm _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6QRWc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c12c5dec4d32d67$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $4c12c5dec4d32d67$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    featuredPortalsTitle: {
        defaultMessage: 'Featured',
        description: 'Title for featured portals loader section',
        id: 'cv.portal.reordering.experience.loader.featured.portals.title'
    }
});

});



parcelRegister("5rBOI", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("bP7WA"),
    $j9MRt("ldNUV"),
    $j9MRt("hW26E"),
    $j9MRt("30Nqg"),
    $j9MRt("dQPji"),
    $j9MRt("kzYkG"),
    $j9MRt("k9PE9"),
    $j9MRt("gkNMi"),
    $j9MRt("g80Ab"),
    $j9MRt("7ODJv"),
    $j9MRt("kB8ya"),
    $j9MRt("lboCs"),
    $j9MRt("fYkxp"),
    $j9MRt("7bBqD"),
    $j9MRt("89gdp"),
    $j9MRt("acv5N"),
    $j9MRt("jg1nc"),
    $j9MRt("bvf9Q"),
    $j9MRt("7UfmT"),
    $j9MRt("cszhl"),
    $j9MRt("gQa5R"),
    $j9MRt("3XUZk"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("af7lu")
]).then(()=>parcelRequire('dSYEf'));

});


parcelRegister("dMjkv", function(module, exports) {
$parcel$export(module.exports, "helpEditTopicsResource", () => $029edd427ed497cb$export$8b5129935a2eae3c);
$parcel$export(module.exports, "hiddenSectionWarningResource", () => $029edd427ed497cb$export$79066689501876c);

var $l5Hnb = parcelRequire("l5Hnb");

var $6pOxX = parcelRequire("6pOxX");

var $byuiX = parcelRequire("byuiX");
const $029edd427ed497cb$export$8b5129935a2eae3c = (0, $byuiX.createRelayResource)({
    type: 'EDIT_TOPICS',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>({
            parameters: (0, $l5Hnb.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});
const $029edd427ed497cb$export$79066689501876c = (0, $byuiX.createRelayResource)({
    type: 'HIDDEN_LAYOUT_SECTION_WARNING',
    getQuery: (_, { cloudId: cloudId, layoutAri: layoutAri })=>({
            parameters: (0, $6pOxX.default),
            variables: {
                cloudId: cloudId,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("l5Hnb", function(module, exports) {
$parcel$export(module.exports, "default", () => $47ef711491e0a37a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<879aa06a5376ce493e5a2a0176e2f83f>>
 * @relayHash 2b93fcbc8c19a342658c7aff002a8cd2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 14bdc72513794c74130122dbd5c9ab89491bd3dc5b3c409327e6af76a3e179e1
const $47ef711491e0a37a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "topicId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v12 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "topicsEditQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "sortableTopicsContainerFragment"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "hiddenTopicsExpandedFragment"
                                        },
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "editableTopicFragment"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "topicsEditQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 3
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "ari"
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpCenterHelpObject"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpObjectStoreIcon",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "icon",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrlV2"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpObjectStoreRequestForm"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreArticle"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreChannel"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "items(first:3)"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "order"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "14bdc72513794c74130122dbd5c9ab89491bd3dc5b3c409327e6af76a3e179e1",
            "metadata": {},
            "name": "topicsEditQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$47ef711491e0a37a$var$node.hash = "97da98f191d43af2454fb49459cb154a";
var $47ef711491e0a37a$export$2e2bcd8739ae039 = $47ef711491e0a37a$var$node;

});

parcelRegister("6pOxX", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0463bcee782ef5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aadfe144099beb4ff8ce18e7151741d1>>
 * @relayHash 186c8bbb9834e8623ccdc1e2f59099c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78
const $c0463bcee782ef5f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "layoutAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v3 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hidden"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hiddenLayoutSectionWarningQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v2 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "HelpLayoutSectionConnection",
                                                "kind": "LinkedField",
                                                "name": "sections",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "HelpLayoutSectionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSection",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v3 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "HelpLayoutSubsection",
                                                                        "kind": "LinkedField",
                                                                        "name": "subsections",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "elements",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v4 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "helpLayout.layout"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hiddenLayoutSectionWarningQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayout"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78",
            "metadata": {},
            "name": "hiddenLayoutSectionWarningQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c0463bcee782ef5f$var$node.hash = "f2fd5d711a9bee2d942b12cdd41c9d79";
var $c0463bcee782ef5f$export$2e2bcd8739ae039 = $c0463bcee782ef5f$var$node;

});





parcelRegister("cfbZK", function(module, exports) {
$parcel$export(module.exports, "EditHomepageResource", () => $e42426e30cba81b8$export$d2163513c58dfe58);

var $8hjWT = parcelRequire("8hjWT");

var $byuiX = parcelRequire("byuiX");
const $e42426e30cba81b8$export$d2163513c58dfe58 = (0, $byuiX.createRelayResource)({
    type: 'EDIT_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $8hjWT.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("8hjWT", function(module, exports) {
$parcel$export(module.exports, "default", () => $03a281fe9aa0ebe7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b1cec29e18a1832c8451899c2a1aac7>>
 * @relayHash bf70531d03392c3e26645e9b0157e94e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c121d529b1a3e379a0c9538e95aa54b96761a6bbc7f64da2ea612987667af130
const $03a281fe9aa0ebe7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v7 = {
        "alias": "layoutId",
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpLayoutSubsectionConfig",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "span"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "adf"
    }, v10 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v11 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v12 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "url"
    }, v15 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v20 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "useLayoutServiceVisualConfigData",
                "selections": v21 /*: any*/ ,
                "argumentDefinitions": []
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "useGlobalSettings"
    }, v24 = [
        v22 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "expandButtonTextColor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "forgeElementPage"
    }, v27 = {
        "kind": "ScalarField",
        "name": "forgeElementType"
    }, v28 = {
        "kind": "ScalarField",
        "name": "connectElementPage"
    }, v29 = {
        "kind": "ScalarField",
        "name": "connectElementType"
    }, v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v32 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v34 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v35 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v36 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v37 = [
        v33 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v38 = {
        "args": v32 /*: any*/ ,
        "concreteType": "HelpLayoutMediaConfig",
        "kind": "LinkedField",
        "name": "mediaConfig",
        "plural": false,
        "selections": v37 /*: any*/ 
    }, v39 = [
        v14 /*: any*/ ,
        v13 /*: any*/ 
    ], v40 = {
        "kind": "ScalarField",
        "name": "id"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v42 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v43 = {
        "kind": "ScalarField",
        "name": "key"
    }, v44 = {
        "kind": "ScalarField",
        "name": "name"
    }, v45 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v46 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v47 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v48 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v42 /*: any*/ ,
            v43 /*: any*/ 
        ]
    }, v49 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v50 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": v39 /*: any*/ 
    }, v51 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v52 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHomepageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalBrandingSettingsPanelFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "helpCenter.mediaConfig"
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutBuilderFragment"
                                            },
                                            {
                                                "kind": "InlineDataFragmentSpread",
                                                "name": "useLayoutServiceFragment",
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpLayoutSectionConnection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSectionEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "HelpLayoutSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "HelpLayoutSubsection",
                                                                                "kind": "LinkedField",
                                                                                "name": "subsections",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v8 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "elements",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v5 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceEditorElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v9 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutEditorElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceHeroElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v23 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutHeroElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceAnnouncementElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceTopicsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutTopicsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceListOfPortalsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v25 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceSuggestedRequestFormsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceForgeElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v26 /*: any*/ ,
                                                                                                            v27 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutForgeElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceConnectElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v28 /*: any*/ ,
                                                                                                            v29 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutConnectElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceBreadcrumbElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutBreadcrumbElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceKnowledgeCardsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutKnowledgeCardsElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v22 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v22 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v31 /*: any*/ 
                                                ],
                                                "argumentDefinitions": []
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "helpLayout.layout"
                        },
                        v38 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "elementsCatalogueFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHomepageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": v39 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v41 /*: any*/ 
                            ]
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v37 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v40 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v36 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v42 /*: any*/ ,
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v40 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v15 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v44 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v45 /*: any*/ ,
                                                                                                v46 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v40 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v49 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v40 /*: any*/ ,
                                                                                                v46 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v47 /*: any*/ ,
                                                                                        v40 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v49 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "message"
                                                                                        },
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v45 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v47 /*: any*/ ,
                                                                                        v40 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v49 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v40 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v44 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v48 /*: any*/ ,
                                                                                        v51 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        v51 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        v51 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "extensions",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "statusCode"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v41 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v51 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutKnowledgeCardsElement"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v40 /*: any*/ ,
                                                                        v51 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v31 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v40 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v41 /*: any*/ 
                            ]
                        },
                        v38 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v42 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v32 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v36 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c121d529b1a3e379a0c9538e95aa54b96761a6bbc7f64da2ea612987667af130",
            "metadata": {},
            "name": "editHomepageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$03a281fe9aa0ebe7$var$node.hash = "826e1f151f2c931c855bc4dd14afdcd5";
var $03a281fe9aa0ebe7$export$2e2bcd8739ae039 = $03a281fe9aa0ebe7$var$node;

});


parcelRegister("dfRW3", function(module, exports) {
$parcel$export(module.exports, "EditHomepageV2Resource", () => $ffd1cfb0fea038ce$export$3e8c7fe01574cb7a);

var $8Wfk2 = parcelRequire("8Wfk2");

var $byuiX = parcelRequire("byuiX");
const $ffd1cfb0fea038ce$export$3e8c7fe01574cb7a = (0, $byuiX.createRelayResource)({
    type: 'EDIT_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $8Wfk2.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("8Wfk2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8995210f377d77f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4461cfdefaa836daf1f2e9ed852b8798>>
 * @relayHash d7aba98409382962b95cd1b6ad4c030e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 72cb11ba575d602770da19ffbde0752acf9e3a741cacf5a048bd6a80ff94e6f9
const $f8995210f377d77f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v7 = {
        "alias": "layoutId",
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpLayoutSubsectionConfig",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "span"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "adf"
    }, v10 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v11 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v12 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "url"
    }, v15 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v20 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "useLayoutServiceVisualConfigData",
                "selections": v21 /*: any*/ ,
                "argumentDefinitions": []
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "useGlobalSettings"
    }, v24 = [
        v22 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "expandButtonTextColor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "forgeElementPage"
    }, v27 = {
        "kind": "ScalarField",
        "name": "forgeElementType"
    }, v28 = {
        "kind": "ScalarField",
        "name": "connectElementPage"
    }, v29 = {
        "kind": "ScalarField",
        "name": "connectElementType"
    }, v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v32 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v33 = [
        v14 /*: any*/ ,
        v13 /*: any*/ 
    ], v34 = {
        "kind": "ScalarField",
        "name": "id"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v36 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v37 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v38 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v39 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v40 = [
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v42 = {
        "kind": "ScalarField",
        "name": "key"
    }, v43 = {
        "kind": "ScalarField",
        "name": "name"
    }, v44 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v45 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v46 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v47 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v42 /*: any*/ 
        ]
    }, v48 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v49 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": v33 /*: any*/ 
    }, v50 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v51 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHomepageV2Query",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalBrandingSettingsPanelFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "helpCenter.mediaConfig"
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "pageBuilderFragment"
                                            },
                                            {
                                                "kind": "InlineDataFragmentSpread",
                                                "name": "useLayoutServiceFragment",
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpLayoutSectionConnection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSectionEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "HelpLayoutSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "HelpLayoutSubsection",
                                                                                "kind": "LinkedField",
                                                                                "name": "subsections",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v8 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "elements",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v5 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceEditorElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v9 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutEditorElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceHeroElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v23 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutHeroElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceAnnouncementElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceTopicsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutTopicsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceListOfPortalsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v25 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceSuggestedRequestFormsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceForgeElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v26 /*: any*/ ,
                                                                                                            v27 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutForgeElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceConnectElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v28 /*: any*/ ,
                                                                                                            v29 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutConnectElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceBreadcrumbElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutBreadcrumbElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceKnowledgeCardsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutKnowledgeCardsElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v22 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v22 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v31 /*: any*/ 
                                                ],
                                                "argumentDefinitions": []
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "helpLayout.layout"
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "pageBuilderMediaConfigFragment"
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "elementsCatalogueFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHomepageV2Query",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": v33 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v34 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ ,
                                                                                                v42 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v15 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v44 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v34 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                v43 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "message"
                                                                                        },
                                                                                        v47 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v49 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v47 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "extensions",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "statusCode"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v42 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutKnowledgeCardsElement"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v34 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v31 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v41 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v32 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v39 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "72cb11ba575d602770da19ffbde0752acf9e3a741cacf5a048bd6a80ff94e6f9",
            "metadata": {},
            "name": "editHomepageV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f8995210f377d77f$var$node.hash = "e0721cb9391648dbc1c11cc1f7260767";
var $f8995210f377d77f$export$2e2bcd8739ae039 = $f8995210f377d77f$var$node;

});


parcelRegister("dHBPx", function(module, exports) {
$parcel$export(module.exports, "brandingResource", () => $a5123b6b990588b5$export$407a6849bf62b25c);
$parcel$export(module.exports, "featuredAndSortedPortalsResource", () => $a5123b6b990588b5$export$19af4b0b8cda6b11);
$parcel$export(module.exports, "topicsResource", () => $a5123b6b990588b5$export$b08096b7aea23d43);
/*
These resources are a temporary solution to help with the server side rendering of multi help center home page.
This module will not be needed, once we move to the Flexible home page built on top of the Layout system.
*/ 
var $9Vr59 = parcelRequire("9Vr59");

var $5dezq = parcelRequire("5dezq");
parcelRequire("9wocP");
var $5U6in = parcelRequire("5U6in");

var $8iTFq = parcelRequire("8iTFq");
parcelRequire("9ueTd");
var $99eJc = parcelRequire("99eJc");

var $4pPvN = parcelRequire("4pPvN");

var $1bRtP = parcelRequire("1bRtP");

var $d1iVz = parcelRequire("d1iVz");

var $byuiX = parcelRequire("byuiX");
const $a5123b6b990588b5$export$407a6849bf62b25c = (0, $5U6in.createResource)({
    type: 'RELAY_HELP_CENTER_BRANDING',
    getKey: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const request = (0, $8iTFq.getRequest)((0, $d1iVz.default));
        const params = request.params;
        return `${String(params.id)}${JSON.stringify({
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        })}`;
    },
    getData: ()=>{
        (0, $5dezq.store).dispatch((0, $9Vr59.fetchHelpCenterBrandingAction)());
        return Promise.resolve(null);
    }
});
const $a5123b6b990588b5$export$19af4b0b8cda6b11 = (0, $5U6in.createResource)({
    type: 'RELAY_HELP_CENTER_PORTALS',
    getKey: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const request = (0, $8iTFq.getRequest)((0, $1bRtP.default));
        const params = request.params;
        return `${String(params.id)}${JSON.stringify({
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        })}`;
    },
    getData: ()=>{
        (0, $5dezq.store).dispatch((0, $99eJc.fetchFeaturedAndSortedPortalsModel)({}, false));
        return Promise.resolve(null);
    }
});
const $a5123b6b990588b5$export$b08096b7aea23d43 = (0, $byuiX.createRelayResource)({
    type: 'HELP_CENTER_TOPICS',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $4pPvN.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("4pPvN", function(module, exports) {
$parcel$export(module.exports, "default", () => $f949b7eb1b9f601b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<445cd3ab0ea1c8b264236aace9d250fd>>
 * @relayHash da0c9595f56db7cf97a352c0fe8277b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b7883769238bba805019b6324fac9ba641e017f9e265528d401031a571fd364
const $f949b7eb1b9f601b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "topicId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v12 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "topicsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "topicFragment"
                                                },
                                                {
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "topicsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpCenterHelpObject"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpObjectStoreIcon",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "icon",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrlV2"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpObjectStoreRequestForm"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreArticle"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreChannel"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "ari"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b7883769238bba805019b6324fac9ba641e017f9e265528d401031a571fd364",
            "metadata": {},
            "name": "topicsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f949b7eb1b9f601b$var$node.hash = "6c3fee571c0b47bf0526627e402d85f8";
var $f949b7eb1b9f601b$export$2e2bcd8739ae039 = $f949b7eb1b9f601b$var$node;

});


parcelRegister("5767l", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("hu7Yg"),
    $j9MRt("bP7WA"),
    $j9MRt("30Nqg"),
    $j9MRt("gkNMi"),
    $j9MRt("kB8ya"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("6ib1g")
]).then(()=>parcelRequire('9CtHY'));

});

parcelRegister("iKKGl", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("hu7Yg"),
    $j9MRt("bP7WA"),
    $j9MRt("30Nqg"),
    $j9MRt("gkNMi"),
    $j9MRt("kB8ya"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("iRDPh")
]).then(()=>parcelRequire('59AWP'));

});

parcelRegister("gnCoW", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("bP7WA"),
    $j9MRt("ldNUV"),
    $j9MRt("hW26E"),
    $j9MRt("30Nqg"),
    $j9MRt("dQPji"),
    $j9MRt("k9PE9"),
    $j9MRt("gkNMi"),
    $j9MRt("g80Ab"),
    $j9MRt("7ODJv"),
    $j9MRt("kB8ya"),
    $j9MRt("lboCs"),
    $j9MRt("fYkxp"),
    $j9MRt("7bBqD"),
    $j9MRt("acv5N"),
    $j9MRt("jg1nc"),
    $j9MRt("5WsnM"),
    $j9MRt("bvf9Q"),
    $j9MRt("7UfmT"),
    $j9MRt("cszhl"),
    $j9MRt("gQa5R"),
    $j9MRt("3XUZk"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("lKHBD")
]).then(()=>parcelRequire('8gNI6'));

});

parcelRegister("3r5rR", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("bP7WA"),
    $j9MRt("ldNUV"),
    $j9MRt("hW26E"),
    $j9MRt("30Nqg"),
    $j9MRt("dQPji"),
    $j9MRt("k9PE9"),
    $j9MRt("gkNMi"),
    $j9MRt("g80Ab"),
    $j9MRt("7ODJv"),
    $j9MRt("kB8ya"),
    $j9MRt("lboCs"),
    $j9MRt("fYkxp"),
    $j9MRt("7bBqD"),
    $j9MRt("acv5N"),
    $j9MRt("jg1nc"),
    $j9MRt("5WsnM"),
    $j9MRt("bvf9Q"),
    $j9MRt("7UfmT"),
    $j9MRt("cszhl"),
    $j9MRt("gQa5R"),
    $j9MRt("3XUZk"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("5EhCD")
]).then(()=>parcelRequire('dFPcG'));

});


parcelRegister("igTQ0", function(module, exports) {
$parcel$export(module.exports, "aiAnswerRoute", () => $3992731faf84dd86$export$aa89d187b9409394);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $4acrp = parcelRequire("4acrp");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
parcelRequire("9i6OK");
var $3szzY = parcelRequire("3szzY");

var $kr2aD = parcelRequire("kr2aD");

var $d0pKQ = parcelRequire("d0pKQ");

var $g2qf8 = parcelRequire("g2qf8");

var $7FSs7 = parcelRequire("7FSs7");

var $bpyxC = parcelRequire("bpyxC");

var $bXs4i = parcelRequire("bXs4i");
const $3992731faf84dd86$var$RenderAiAnswerRoute = ()=>{
    const [routerState] = (0, $i9cdb.useRouter)();
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $g2qf8.default), {
        screenName: (0, $8rTkC.ScreenName).AI_ANSWER,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3szzY.default), {
        screenName: (0, $8rTkC.ScreenName).AI_ANSWER,
        renderError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4acrp.default), {
                error: {
                    status: 500,
                    message: formatMessage((0, $d0pKQ.default).genericErrorMessage),
                    callToActionUrl: '/servicedesk/customer/portals'.replace((0, $7FSs7.getBaseName)(), ''),
                    callToActionText: formatMessage((0, $d0pKQ.default).genericRedirectMessage)
                }
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kr2aD.AiAnswerFeedbackPage), null)));
};
const $3992731faf84dd86$var$route = {
    name: (0, $8rTkC.ScreenName).AI_ANSWER,
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/:requestKey/aianswer`,
    exact: true,
    component: $3992731faf84dd86$var$RenderAiAnswerRoute
};
const $3992731faf84dd86$var$screenName = (0, $8rTkC.ScreenName).AI_ANSWER;
const $3992731faf84dd86$export$aa89d187b9409394 = (0, $bpyxC.createRouteWithLayout)($3992731faf84dd86$var$route, $3992731faf84dd86$var$screenName, (0, $bXs4i.anonymousScreenLayout));

});
parcelRegister("kr2aD", function(module, exports) {
$parcel$export(module.exports, "AiAnswerFeedbackPage", () => $54998b390df27f00$export$589a347fe318e529);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $54998b390df27f00$export$589a347fe318e529 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("jZKqb")), {
        moduleId: "./packages/virtual-agent/ai-answer/src/ui/ai-answer-feedback-page/hocs.tsx"
    })
});

});
parcelRegister("jZKqb", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("d3buT"),
    $j9MRt("GDiqm")
]).then(()=>parcelRequire('cf94l'));

});


parcelRegister("d0pKQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $686728d5ea81d244$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $686728d5ea81d244$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    helpfulPageHeading: {
        id: 'ai-answer.feedback-form.helpful-page-heading',
        defaultMessage: 'Awesome!',
        description: 'Heading for the feedback form helpful page'
    },
    helpfulPageSubHeading: {
        id: 'ai-answer.feedback-form.helpful-page-sub-heading',
        defaultMessage: 'Glad we could help.',
        description: 'Subheading for the feedback form helpful page'
    },
    nonHelpfulPageHeading: {
        id: 'ai-answer.feedback-form.non-helpful-page-heading',
        defaultMessage: "Sorry, it wasn\u2019t helpful.",
        description: 'Heading for the feedback form non-helpful page'
    },
    nonHelpfulPageSubHeading: {
        id: 'ai-answer.feedback-form.non-helpful-page-sub-heading',
        defaultMessage: "We're working on your request.",
        description: 'Subheading for the feedback form non-helpful page'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    additionalFeedbackCTALabel: {
        id: 'ai-answer.feedback-form.additional-feedback-label',
        defaultMessage: 'Give additional feedback',
        description: 'Label for the additional feedback button'
    },
    feedbackTitle: {
        id: 'ai-answer.feedback-form.feedback-title',
        defaultMessage: 'Help us improve',
        description: 'Feedback dialog title'
    },
    sendFeedbackLabel: {
        defaultMessage: 'Send Feedback',
        description: 'Feedback dialog Submit button label',
        id: 'ai-answer.feedback-form.feedback-submit-button-label'
    },
    cancelLabel: {
        defaultMessage: 'Cancel',
        description: 'Feedback dialog cancel button label',
        id: 'ai-answer.feedback-form.feedback-cancel-button-label'
    },
    contactLabel: {
        defaultMessage: 'Contact me for more details about this feedback',
        description: 'Feedback dialog can contact label',
        id: 'ai-answer.feedback-form.feedback-can-contact-label'
    },
    summary: {
        defaultMessage: 'Summary',
        description: 'Feedback dialog summary label',
        id: 'ai-answer.feedback-form.feedback-summary'
    },
    subHeading: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Feedback dialog sub heading',
        id: 'ai-answer.feedback-form.feedback-sub-heading'
    },
    genericErrorMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'ai-answer.feedback-form.generic-heading'
    },
    genericRedirectMessage: {
        defaultMessage: 'Go to the portal.',
        description: 'Generic redirect link message when something could not be loaded',
        id: 'ai-answer.feedback-form.generic-redirect-message'
    },
    summaryPlaceholder: {
        defaultMessage: "Let us know what's on your mind",
        description: 'Message which will be shown inside the summary text field',
        id: 'ai-answer.feedback-form.feedback-summary-placeholder'
    },
    enrolInResearchLabel: {
        defaultMessage: "I'd like to participate in product research",
        description: 'Message which will be shown next to the enrol in research checkbox',
        id: 'ai-answer.feedback-form.feedback-enrol-in-research-label'
    }
});

});


parcelRegister("9fRhz", function(module, exports) {
$parcel$export(module.exports, "approvalsRoute", () => $7acaab8633bcb48c$export$ee55f71d9820cd66);

var $8rTkC = parcelRequire("8rTkC");

var $ln5Af = parcelRequire("ln5Af");

var $bpyxC = parcelRequire("bpyxC");
const $7acaab8633bcb48c$var$route = {
    name: 'user-approvals',
    path: `/user/approvals`,
    exact: true,
    component: (0, $ln5Af.ApprovalList)
};
const $7acaab8633bcb48c$var$screenName = (0, $8rTkC.ScreenName).APPROVAL_LIST;
const $7acaab8633bcb48c$var$paperAppearance = 'wide';
const $7acaab8633bcb48c$var$layoutProps = {
    paperAppearance: $7acaab8633bcb48c$var$paperAppearance,
    fadeInSearchModal: true
};
const $7acaab8633bcb48c$export$ee55f71d9820cd66 = (0, $bpyxC.createRouteWithLayout)($7acaab8633bcb48c$var$route, $7acaab8633bcb48c$var$screenName, $7acaab8633bcb48c$var$layoutProps);

});
parcelRegister("ln5Af", function(module, exports) {
$parcel$export(module.exports, "ApprovalList", () => $d20eda03e460375b$export$dfa534f59b1c1487);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $d20eda03e460375b$export$dfa534f59b1c1487 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("d7TAp")), {
        moduleId: "./src/view/approval-list/approval-list.tsx"
    })
});

});
parcelRegister("d7TAp", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("7S76Y").then(()=>parcelRequire('7sdbA'));

});



parcelRegister("17jzp", function(module, exports) {
$parcel$export(module.exports, "consentFormRoute", () => $15e347bf443f2543$export$f978586bc0d52692);

var $8rTkC = parcelRequire("8rTkC");

var $tp9p7 = parcelRequire("tp9p7");

var $bpyxC = parcelRequire("bpyxC");
const $15e347bf443f2543$var$consentForm = {
    resources: [],
    name: 'consent-form',
    path: `/user/consent`,
    exact: true,
    component: (0, $tp9p7.ConsentForm)
};
const $15e347bf443f2543$var$layoutProps = {
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'normal',
    fadeInSearchModal: true
};
const $15e347bf443f2543$export$f978586bc0d52692 = (0, $bpyxC.createRouteWithLayout)($15e347bf443f2543$var$consentForm, (0, $8rTkC.ScreenName).CONSENT_FORM_PAGE, $15e347bf443f2543$var$layoutProps);

});
parcelRegister("tp9p7", function(module, exports) {
$parcel$export(module.exports, "ConsentForm", () => $4246d23b6989520e$export$723d7f2fb08b9d80);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $4246d23b6989520e$export$723d7f2fb08b9d80 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("iS8Wg")), {
        moduleId: "./src/view/consent-form/hocs.tsx"
    })
});

});
parcelRegister("iS8Wg", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("cJ0jy").then(()=>parcelRequire('eBl3d'));

});



parcelRegister("043tP", function(module, exports) {
$parcel$export(module.exports, "csmContactUsRoute", () => $c29d142f310a38fa$export$3979346dcb7ef96d);

var $8rTkC = parcelRequire("8rTkC");

var $BWJ5p = parcelRequire("BWJ5p");

var $eC4tX = parcelRequire("eC4tX");

var $bpyxC = parcelRequire("bpyxC");
const $c29d142f310a38fa$var$contactUs = {
    resources: [
        (0, $eC4tX.mediaUploadCredentialsResource)
    ],
    name: (0, $8rTkC.RouteName).CSM_CONTACT_US_PAGE,
    path: (0, $8rTkC.RoutePath).CSM_CONTACT_US_PATH,
    exact: true,
    component: (0, $BWJ5p.CsmContactUs)
};
const $c29d142f310a38fa$var$layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
};
const $c29d142f310a38fa$export$3979346dcb7ef96d = (0, $bpyxC.createRouteWithLayout)($c29d142f310a38fa$var$contactUs, (0, $8rTkC.ScreenName).CSM_CONTACT_US, $c29d142f310a38fa$var$layoutProps);

});
parcelRegister("BWJ5p", function(module, exports) {
$parcel$export(module.exports, "CsmContactUs", () => $c081c2a986835b80$export$961253a0ef353f1);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $c081c2a986835b80$export$961253a0ef353f1 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("6HKdo")), {
        moduleId: "./packages/customer-service/csm-contact-us/src/ui/csm-contact-us.tsx"
    })
});

});
parcelRegister("6HKdo", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("gRGGD"),
    $j9MRt("iEFkY"),
    $j9MRt("2HGZt"),
    $j9MRt("1j2Ac"),
    $j9MRt("fSmVB"),
    $j9MRt("8lt3h"),
    $j9MRt("217Xp"),
    $j9MRt("TRkIS"),
    $j9MRt("7UfmT"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("hcxtc"),
    $j9MRt("lN4QY")
]).then(()=>parcelRequire('ejxak'));

});


parcelRegister("eC4tX", function(module, exports) {
$parcel$export(module.exports, "mediaUploadCredentialsResource", () => $c1cd5554ae4a078d$export$fac4b16282dd90f6);

var $jByYr = parcelRequire("jByYr");
parcelRequire("9wocP");
var $5U6in = parcelRequire("5U6in");

var $cLmLE = parcelRequire("cLmLE");

var $klz3F = parcelRequire("klz3F");
const $c1cd5554ae4a078d$export$fac4b16282dd90f6 = (0, $5U6in.createResource)({
    type: 'MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
    getKey: ()=>`media-upload-credentials`,
    getData: async ()=>{
        const { helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse((0, $jByYr.getHelpCenterAri)());
        return (0, $klz3F.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/media/credentials/upload`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});


parcelRegister("agSAc", function(module, exports) {
$parcel$export(module.exports, "getViewCustomPageRoute", () => $ff50c626b85d969f$export$3dddbf9f405aac5c);

var $8rTkC = parcelRequire("8rTkC");

var $5rqJJ = parcelRequire("5rqJJ");

var $bpyxC = parcelRequire("bpyxC");
parcelRequire("flVqy");
var $2WGOs = parcelRequire("2WGOs");

var $dHBPx = parcelRequire("dHBPx");
const $ff50c626b85d969f$export$3dddbf9f405aac5c = (name = (0, $8rTkC.RouteName).VIEW_CUSTOM_PAGE, path = (0, $8rTkC.RoutePath).VIEW_CUSTOM_PAGE)=>{
    const viewCustomPageSSRResources = [
        (0, $dHBPx.brandingResource),
        (0, $5rqJJ.ViewCustomPageResource)
    ];
    return (0, $bpyxC.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: (0, $2WGOs.ViewCustomPageWithAiAgent),
        resources: [
            (0, $5rqJJ.ViewCustomPageResource)
        ]
    }, (0, $8rTkC.ScreenName).VIEW_CUSTOM_PAGE, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true
    });
};

});
parcelRegister("5rqJJ", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPageResource", () => $b29c3497f01d5a63$export$15c85a1b3a2577c9);

var $jByYr = parcelRequire("jByYr");

var $78eL2 = parcelRequire("78eL2");

var $byuiX = parcelRequire("byuiX");

var $2CA7P = parcelRequire("2CA7P");
const $b29c3497f01d5a63$export$15c85a1b3a2577c9 = (0, $byuiX.createRelayResource)({
    type: 'VIEW_CUSTOM_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.id || '';
        const helpCenterPageAri = (0, $78eL2.HelpPageAri).create({
            pageId: pageId,
            activationId: (0, $jByYr.getActivationId)()
        }).toString();
        return {
            parameters: (0, $2CA7P.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                helpCenterPageAri: helpCenterPageAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("78eL2", function(module, exports) {
$parcel$export(module.exports, "HelpPageAri", () => $5314ba50c56e2ffa$export$7855a3c68b5a0b04);

var $gTetz = parcelRequire("gTetz");

var $jmrxw = parcelRequire("jmrxw");

var $6LWYQ = parcelRequire("6LWYQ");
// src/help/page/manifest.ts
var $5314ba50c56e2ffa$var$helpPageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $gTetz.HelpPageAriResourceOwner),
    resourceType: (0, $gTetz.HelpPageAriResourceType),
    resourceIdSlug: "{activationId}/{pageId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        pageId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/page/index.ts
var $5314ba50c56e2ffa$export$7855a3c68b5a0b04 = class _HelpPageAri extends (0, $jmrxw.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get activationId() {
        return this._activationId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5314ba50c56e2ffa$var$helpPageAriStaticOpts.qualifier,
            platformQualifier: $5314ba50c56e2ffa$var$helpPageAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $5314ba50c56e2ffa$var$helpPageAriStaticOpts.resourceOwner,
            resourceType: $5314ba50c56e2ffa$var$helpPageAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.pageId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6LWYQ.AriParser).fromOpts(derivedOpts, $5314ba50c56e2ffa$var$helpPageAriStaticOpts);
        return new _HelpPageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6LWYQ.AriParser).fromString(maybeAri, $5314ba50c56e2ffa$var$helpPageAriStaticOpts);
        return new _HelpPageAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("gTetz", function(module, exports) {
$parcel$export(module.exports, "HelpPageAriResourceOwner", () => $c4bd0300f9cd1918$export$b6fe1f05324d51ea);
$parcel$export(module.exports, "HelpPageAriResourceType", () => $c4bd0300f9cd1918$export$e6c9af890e88f3eb);
// src/help/page/types.ts
var $c4bd0300f9cd1918$export$b6fe1f05324d51ea = "help", $c4bd0300f9cd1918$export$e6c9af890e88f3eb = "page";

});


parcelRegister("2CA7P", function(module, exports) {
$parcel$export(module.exports, "default", () => $4dc083fb62323736$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6d95ad1a91420eb386b3338cac4aaae1>>
 * @relayHash c861f57f9505f1475c34ec347b6d0154
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6df252a72d27e6ec759fb1d06cbf197e906cf500939b19e801effdc2b8b80dcc
const $4dc083fb62323736$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterPageAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterPageAri",
            "variableName": "helpCenterPageAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v8 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "concreteType": "HelpCenterPageDescription",
        "kind": "LinkedField",
        "name": "description",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "handleQueryErrorFragment"
            }
        ],
        "type": "QueryError"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterPageAri"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "QueryError"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "key"
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v21 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v23 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v18 /*: any*/ 
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v25 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v27 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v28 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewCustomPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "helpCenter.helpCenterPageById.name"
                                        },
                                        v9 /*: any*/ 
                                    ],
                                    "type": "HelpCenterPage"
                                },
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v12 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layoutByParentId",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    v11 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "helpLayout.layoutByParentId"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewCustomPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ],
                                    "type": "HelpCenterPage"
                                },
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layoutByParentId",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v6 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v13 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v24 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v16 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v25 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                },
                                                                v6 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v25 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v17 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6df252a72d27e6ec759fb1d06cbf197e906cf500939b19e801effdc2b8b80dcc",
            "metadata": {},
            "name": "viewCustomPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4dc083fb62323736$var$node.hash = "d0659d1b7fe16e9e5da9353dc29804e6";
var $4dc083fb62323736$export$2e2bcd8739ae039 = $4dc083fb62323736$var$node;

});


parcelRegister("flVqy", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPage", () => (parcelRequire("2WGOs")).ViewCustomPage);
$parcel$export(module.exports, "ViewCustomPageWithAiAgent", () => (parcelRequire("2WGOs")).ViewCustomPageWithAiAgent);
$parcel$export(module.exports, "EditCustomPage", () => (parcelRequire("h3yeO")).EditCustomPage);

var $2WGOs = parcelRequire("2WGOs");

var $h3yeO = parcelRequire("h3yeO");

});
parcelRegister("2WGOs", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPage", () => $fee375a61ed2b577$export$445268d8b5206a5d);
$parcel$export(module.exports, "ViewCustomPageWithAiAgent", () => $fee375a61ed2b577$export$e4a1d2bae0fd7812);

var $8P7DW = parcelRequire("8P7DW");

var $hd1aJ = parcelRequire("hd1aJ");

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $fee375a61ed2b577$export$445268d8b5206a5d = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("cVOFP")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/view-custom-page/view-custom-page.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hd1aJ.default), null)
});

const $fee375a61ed2b577$export$e4a1d2bae0fd7812 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("6mEu7")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/view-custom-page/csm-variants/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hd1aJ.default), null)
});

});
parcelRegister("cVOFP", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("hu7Yg"),
    $j9MRt("bP7WA"),
    $j9MRt("30Nqg"),
    $j9MRt("gkNMi"),
    $j9MRt("kB8ya"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("dkpSX")
]).then(()=>parcelRequire('idoHV'));

});

parcelRegister("6mEu7", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("hu7Yg"),
    $j9MRt("bP7WA"),
    $j9MRt("30Nqg"),
    $j9MRt("gkNMi"),
    $j9MRt("kB8ya"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("dkpSX"),
    $j9MRt("4hbNL")
]).then(()=>parcelRequire('bJJqq'));

});


parcelRegister("h3yeO", function(module, exports) {
$parcel$export(module.exports, "EditCustomPage", () => $be9848325afbafb3$export$7fc1d63603c0df32);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $hd1aJ = parcelRequire("hd1aJ");

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("d5AiD");
var $hlVBC = parcelRequire("hlVBC");

const $be9848325afbafb3$export$7fc1d63603c0df32 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("kSURY")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/edit-custom-page/edit-custom-page.tsx"
    }),
    LoadingSkeleton: ()=>(0, $HGACo.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hlVBC.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hd1aJ.default), {
            showActionBar: true
        })
});

});
parcelRegister("kSURY", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("bP7WA"),
    $j9MRt("ldNUV"),
    $j9MRt("hW26E"),
    $j9MRt("30Nqg"),
    $j9MRt("dQPji"),
    $j9MRt("k9PE9"),
    $j9MRt("gkNMi"),
    $j9MRt("g80Ab"),
    $j9MRt("7ODJv"),
    $j9MRt("kB8ya"),
    $j9MRt("lboCs"),
    $j9MRt("fYkxp"),
    $j9MRt("7bBqD"),
    $j9MRt("acv5N"),
    $j9MRt("jg1nc"),
    $j9MRt("5WsnM"),
    $j9MRt("bvf9Q"),
    $j9MRt("7UfmT"),
    $j9MRt("cszhl"),
    $j9MRt("gQa5R"),
    $j9MRt("3XUZk"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("jSA9x")
]).then(()=>parcelRequire('7opto'));

});




parcelRegister("oBfFQ", function(module, exports) {
$parcel$export(module.exports, "csmFolderRoute", () => $99dd7c74723016fc$export$27c939ab49e382d2);

var $8rTkC = parcelRequire("8rTkC");

var $8ak37 = parcelRequire("8ak37");

var $a373Q = parcelRequire("a373Q");

var $lspLZ = parcelRequire("lspLZ");

var $bpyxC = parcelRequire("bpyxC");
const $99dd7c74723016fc$var$folder = {
    resources: [
        (0, $lspLZ.CsmFolderResource),
        (0, $a373Q.CsmEmptyFolderResource)
    ],
    name: (0, $8rTkC.RouteName).CSM_FOLDER_PAGE,
    path: (0, $8rTkC.RoutePath).CSM_FOLDER_PATH,
    exact: true,
    component: (0, $8ak37.CsmFolder)
};
const $99dd7c74723016fc$var$layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
};
const $99dd7c74723016fc$export$27c939ab49e382d2 = (0, $bpyxC.createRouteWithLayout)($99dd7c74723016fc$var$folder, (0, $8rTkC.ScreenName).CSM_FOLDER, $99dd7c74723016fc$var$layoutProps);

});
parcelRegister("8ak37", function(module, exports) {
$parcel$export(module.exports, "CsmFolder", () => $320de83241740287$export$56c9caef0ff41b5c);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $320de83241740287$export$56c9caef0ff41b5c = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("4uVeD")), {
        moduleId: "./packages/customer-service/csm-folder/src/ui/csm-folder.tsx"
    })
});

});
parcelRegister("4uVeD", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("3B1TD").then(()=>parcelRequire('s73KB'));

});


parcelRegister("a373Q", function(module, exports) {
$parcel$export(module.exports, "CsmEmptyFolderResource", () => $d96f8aa22df3dd1f$export$acacebd3c63c516);

var $byuiX = parcelRequire("byuiX");

var $1Fn7I = parcelRequire("1Fn7I");

var $d8fTi = parcelRequire("d8fTi");
const $d96f8aa22df3dd1f$export$acacebd3c63c516 = (0, $byuiX.createRelayResource)({
    type: 'CSM_FOLDER',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.folderId || '';
        return {
            parameters: (0, $1Fn7I.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                first: (0, $d8fTi.MAX_ITEMS_PER_PAGE),
                input: {
                    articleIds: [
                        pageId
                    ]
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("1Fn7I", function(module, exports) {
$parcel$export(module.exports, "default", () => $decd1b056b5ed7bc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<119d4c7c93b2242d501d4f9d4c12d305>>
 * @relayHash be67b91b3b5b3d2fbcf3fcc898595c20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365
const $decd1b056b5ed7bc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "emptyStateQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "emptyStateRenderer_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "emptyStateQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "helpCenterAri",
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "EmptyStateRenderer__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365",
            "metadata": {},
            "name": "emptyStateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$decd1b056b5ed7bc$var$node.hash = "0f924812359a442723962628434695a3";
var $decd1b056b5ed7bc$export$2e2bcd8739ae039 = $decd1b056b5ed7bc$var$node;

});

parcelRegister("d8fTi", function(module, exports) {
$parcel$export(module.exports, "MAX_ITEMS_PER_PAGE", () => $0948856d1d6b2e80$export$e7a0dcb737d8e4ee);
const $0948856d1d6b2e80$export$e7a0dcb737d8e4ee = 24;

});


parcelRegister("lspLZ", function(module, exports) {
$parcel$export(module.exports, "CsmFolderResource", () => $c5d66f56c59ddba9$export$c37e0f6e8d7653a0);

var $byuiX = parcelRequire("byuiX");

var $bsBcW = parcelRequire("bsBcW");

var $d8fTi = parcelRequire("d8fTi");
const $c5d66f56c59ddba9$var$ANCESTORS = 'ANCESTORS';
const $c5d66f56c59ddba9$export$c37e0f6e8d7653a0 = (0, $byuiX.createRelayResource)({
    type: 'CSM_FOLDER',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.folderId || '';
        return {
            parameters: (0, $bsBcW.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                first: (0, $d8fTi.MAX_ITEMS_PER_PAGE),
                input: {
                    parentId: Number(pageId),
                    expand: [
                        $c5d66f56c59ddba9$var$ANCESTORS
                    ]
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("bsBcW", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc31426158ffb936$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7f923e40c24ecec1165895895281b1f>>
 * @relayHash ccd2cd57b96d01e796a5305915df0306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7bcbd9ccb0157071106ad1f289719ca9ee0c599161c648ce22c5d3f7ff53c17
const $dc31426158ffb936$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "mainCsmFolderItemsRenderer_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "contentType"
                                                },
                                                {
                                                    "concreteType": "HelpObjectStoreArticleRelative",
                                                    "kind": "LinkedField",
                                                    "name": "ancestors",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpObjectStoreArticleURLInfo",
                                                    "kind": "LinkedField",
                                                    "name": "urlInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shareUrl"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "helpCenterAri",
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "CsmFolderItemsRenderer__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "e7bcbd9ccb0157071106ad1f289719ca9ee0c599161c648ce22c5d3f7ff53c17",
            "metadata": {},
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dc31426158ffb936$var$node.hash = "4e2df91a41eb5d8ce8ae2f48a0e1068e";
var $dc31426158ffb936$export$2e2bcd8739ae039 = $dc31426158ffb936$var$node;

});



parcelRegister("eeSjx", function(module, exports) {
$parcel$export(module.exports, "csmViewKbPageRoute", () => $d0718bb94a496191$export$ef20b2dba68d2a8);
$parcel$export(module.exports, "csmViewArticleRoute", () => $d0718bb94a496191$export$b346ad0264655ca1);
$parcel$export(module.exports, "csmViewCrossSiteArticleRoute", () => $d0718bb94a496191$export$cfb51b854559f2b3);

var $8rTkC = parcelRequire("8rTkC");

var $cq5Wa = parcelRequire("cq5Wa");

var $bpyxC = parcelRequire("bpyxC");
const $d0718bb94a496191$var$viewKbPage = {
    resources: [],
    name: 'view-kb-page',
    path: '/kb/view/:pageId',
    exact: true,
    component: (0, $cq5Wa.CsmArticle)
};
const $d0718bb94a496191$var$viewArticle = {
    resources: [],
    name: 'view-kb-article',
    path: `/article/:articleId`,
    exact: true,
    component: (0, $cq5Wa.CsmArticle)
};
const $d0718bb94a496191$var$viewCrossSiteArticle = {
    resources: [],
    name: 'view-kb-cross-site-article',
    path: `/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $cq5Wa.CsmArticle)
};
const $d0718bb94a496191$var$layoutProps = {
    paperAppearance: 'xxwide',
    fadeInSearchModal: true
};
const $d0718bb94a496191$export$ef20b2dba68d2a8 = (0, $bpyxC.createRouteWithLayout)($d0718bb94a496191$var$viewKbPage, (0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE, $d0718bb94a496191$var$layoutProps);
const $d0718bb94a496191$export$b346ad0264655ca1 = (0, $bpyxC.createRouteWithLayout)($d0718bb94a496191$var$viewArticle, (0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE, $d0718bb94a496191$var$layoutProps);
const $d0718bb94a496191$export$cfb51b854559f2b3 = (0, $bpyxC.createRouteWithLayout)($d0718bb94a496191$var$viewCrossSiteArticle, (0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE, $d0718bb94a496191$var$layoutProps);

});
parcelRegister("cq5Wa", function(module, exports) {
$parcel$export(module.exports, "CsmArticle", () => $6ea849a7e5c1276d$export$630a6bc855af0b24);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $6ea849a7e5c1276d$export$630a6bc855af0b24 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("74H6N")), {
        moduleId: "./src/view/article/csm-variants/csm-variants.tsx"
    })
});

});
parcelRegister("74H6N", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("i1pvz"),
    $j9MRt("eC2J7"),
    $j9MRt("jn9Mo")
]).then(()=>parcelRequire('dNsnz'));

});



parcelRegister("dqUt9", function(module, exports) {
$parcel$export(module.exports, "csmRequestsListRoute", () => $eca565bc561860ee$export$416674a9ebdb2ee0);
$parcel$export(module.exports, "csmRequestDetailsRoute", () => $eca565bc561860ee$export$c1779627ae2c6baa);

var $8rTkC = parcelRequire("8rTkC");

var $2L0mo = parcelRequire("2L0mo");

var $c126o = parcelRequire("c126o");

var $14pm9 = parcelRequire("14pm9");

var $5Fbq4 = parcelRequire("5Fbq4");

var $1ZM2A = parcelRequire("1ZM2A");

var $5q2af = parcelRequire("5q2af");

var $kpgiM = parcelRequire("kpgiM");

var $bpyxC = parcelRequire("bpyxC");
const $eca565bc561860ee$export$416674a9ebdb2ee0 = (0, $bpyxC.createRouteWithLayout)({
    name: (0, $8rTkC.RouteName).CSM_REQUESTS_LIST_PAGE,
    path: (0, $8rTkC.RoutePath).CSM_REQUESTS_LIST_PATH,
    exact: true,
    component: (0, $5q2af.CsmRequestsList),
    resources: [
        (0, $kpgiM.csmRequestsListQueryResource)
    ]
}, (0, $8rTkC.ScreenName).CSM_REQUESTS_LIST, {
    isAnonymous: false,
    paperAppearance: 'xxwide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
});
const $eca565bc561860ee$export$c1779627ae2c6baa = (0, $bpyxC.createRouteWithLayout)({
    name: (0, $8rTkC.RouteName).CSM_REQUEST_DETAILS_PAGE,
    path: (0, $8rTkC.RoutePath).CSM_REQUEST_DETAILS_PATH,
    exact: true,
    component: (0, $1ZM2A.AsyncCsmRequestDetails),
    resources: [
        (0, $2L0mo.csmRequestDetailsQueryResource),
        (0, $5Fbq4.requestConversationResource),
        (0, $c126o.mediaReadCredentialsResource),
        (0, $14pm9.mediaUploadCredentialsResource)
    ]
}, (0, $8rTkC.ScreenName).CSM_REQUEST_DETAILS, {
    isAnonymous: false,
    paperAppearance: 'xxwide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true,
    hideBanner: true
});

});
parcelRegister("2L0mo", function(module, exports) {
$parcel$export(module.exports, "csmRequestDetailsQueryResource", () => $03ab787ad64e2963$export$54cc49ad6240b8cc);

var $jByYr = parcelRequire("jByYr");

var $byuiX = parcelRequire("byuiX");

var $7Io7L = parcelRequire("7Io7L");
const $03ab787ad64e2963$export$54cc49ad6240b8cc = (0, $byuiX.createRelayResource)({
    type: 'CSM_REQUEST_DETAILS_QUERY',
    getQuery: ({ match: { params: { requestKey: requestKey } } }, { cloudId: cloudId })=>({
            parameters: (0, $7Io7L.default),
            variables: {
                cloudId: cloudId,
                issueKey: requestKey ?? '',
                helpCenterId: (0, $jByYr.getMeta)('help-center-ari') ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("7Io7L", function(module, exports) {
$parcel$export(module.exports, "default", () => $80b8382df669812b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6d3a0c8e2028433c4ecc4f6fe2c02141>>
 * @relayHash f9d0b90da3fc5ded2446408a12ea4e88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43ba1f1f42df9ff9b2fe51ffd0f591e132b204d251b4582bec9fa29cdab19c8b
const $80b8382df669812b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterId",
            "variableName": "helpCenterId"
        },
        {
            "kind": "Variable",
            "name": "issueKey",
            "variableName": "issueKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "question"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmRequestDetailsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "requestByIssueKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_csmRequestDetails"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "formView_csmRequestDetails"
                                                }
                                            ],
                                            "type": "CustomerServiceRequest"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_csmCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "customerService.requestByIssueKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "customerService"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmRequestDetailsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "requestByIssueKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "summary"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "createdOn"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "externalStatus"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCategoryName"
                                        },
                                        {
                                            "concreteType": "CustomerServiceRequestParticipant",
                                            "kind": "LinkedField",
                                            "name": "participants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "accountId"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "CustomerServiceRequestFormDataConnection",
                                            "kind": "LinkedField",
                                            "name": "formData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CustomerServiceRequestFormDataEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "textAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "adfAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryRichTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "multiSelectTextAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryMultiSelectField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fileIds"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryAttachmentField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceRequest"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "43ba1f1f42df9ff9b2fe51ffd0f591e132b204d251b4582bec9fa29cdab19c8b",
            "metadata": {},
            "name": "csmRequestDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$80b8382df669812b$var$node.hash = "0d1145658682357d33bf4a6df047b2d0";
var $80b8382df669812b$export$2e2bcd8739ae039 = $80b8382df669812b$var$node;

});


parcelRegister("c126o", function(module, exports) {
$parcel$export(module.exports, "mediaReadCredentialsResource", () => $f9bb84178ab28177$export$bb777640a2b36f94);

var $jByYr = parcelRequire("jByYr");
parcelRequire("9wocP");
var $5U6in = parcelRequire("5U6in");

var $cLmLE = parcelRequire("cLmLE");

var $klz3F = parcelRequire("klz3F");
const $f9bb84178ab28177$export$bb777640a2b36f94 = (0, $5U6in.createResource)({
    type: 'MEDIA_READ_CREDENTIALS_RESOURCE',
    getKey: ()=>`media-read-credentials`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse((0, $jByYr.getHelpCenterAri)());
        return (0, $klz3F.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${match.params.requestKey || ''}/media/credentials/read`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});

parcelRegister("14pm9", function(module, exports) {
$parcel$export(module.exports, "mediaUploadCredentialsResource", () => $5d666785095289ff$export$fac4b16282dd90f6);

var $jByYr = parcelRequire("jByYr");
parcelRequire("9wocP");
var $5U6in = parcelRequire("5U6in");

var $cLmLE = parcelRequire("cLmLE");

var $klz3F = parcelRequire("klz3F");
const $5d666785095289ff$export$fac4b16282dd90f6 = (0, $5U6in.createResource)({
    type: 'CSM_MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
    getKey: ()=>`csm-media-upload-credentials`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse((0, $jByYr.getHelpCenterAri)());
        return (0, $klz3F.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${match.params.requestKey || ''}/media/credentials/upload`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 600000 // 10 minutes
});

});

parcelRegister("5Fbq4", function(module, exports) {
$parcel$export(module.exports, "requestConversationResource", () => $48c9e86b3a4a00c4$export$9062b1d7764a6617);

var $jByYr = parcelRequire("jByYr");
parcelRequire("9wocP");
var $5U6in = parcelRequire("5U6in");

var $cLmLE = parcelRequire("cLmLE");

var $klz3F = parcelRequire("klz3F");
const $48c9e86b3a4a00c4$export$9062b1d7764a6617 = (0, $5U6in.createResource)({
    type: 'REQUEST_CONVERSATION_RESOURCE',
    getKey: ()=>`request-conversation`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse((0, $jByYr.getHelpCenterAri)());
        return (0, $klz3F.fetchJson)(`/gateway/api/jsm/csm/api/v1/request/form/helpcenter/${helpCenterId}/conversation/history?issueIdOrKey=${match.params.requestKey || ''}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});

parcelRegister("1ZM2A", function(module, exports) {
$parcel$export(module.exports, "AsyncCsmRequestDetails", () => $d2cf75c1e86dfb1d$export$c654e93ddb89d705);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $d2cf75c1e86dfb1d$export$c654e93ddb89d705 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("9zKaR")), {
        moduleId: "./packages/customer-service/csm-request-details/src/ui/csm-request-details.tsx"
    })
});

});
parcelRegister("9zKaR", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("gUYyZ"),
    $j9MRt("i98k0"),
    $j9MRt("ib7z2"),
    $j9MRt("k2Hyb"),
    $j9MRt("hMKE4"),
    $j9MRt("ikoh2"),
    $j9MRt("2nM2o")
]).then(()=>parcelRequire('2zIWk'));

});


parcelRegister("5q2af", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsList", () => $c22fb84733b28b68$export$790b773cc5ea9295);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $c22fb84733b28b68$export$790b773cc5ea9295 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("2ltJ0")), {
        moduleId: "./packages/customer-service/csm-requests-list/src/ui/csm-requests-list.tsx"
    })
});

});
parcelRegister("2ltJ0", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("cVF3D"),
    $j9MRt("i98k0"),
    $j9MRt("8ZeM9"),
    $j9MRt("eyo81")
]).then(()=>parcelRequire('gAoUW'));

});


parcelRegister("kpgiM", function(module, exports) {
$parcel$export(module.exports, "csmRequestsListQueryResource", () => $9cc01f97ce850a6c$export$a6363e566cdd7bae);

var $jByYr = parcelRequire("jByYr");

var $byuiX = parcelRequire("byuiX");

var $hzaQB = parcelRequire("hzaQB");

var $e1Zrl = parcelRequire("e1Zrl");
const $9cc01f97ce850a6c$export$a6363e566cdd7bae = (0, $byuiX.createRelayResource)({
    type: 'CSM_REQUESTS_LIST_QUERY',
    getQuery: (_, { cloudId: cloudId })=>({
            parameters: (0, $e1Zrl.default),
            variables: {
                cloudId: cloudId,
                accountId: (0, $jByYr.getMeta)('account-id') ?? '',
                helpCenterId: (0, $jByYr.getMeta)('help-center-ari') ?? '',
                count: (0, $hzaQB.PAGINATION_SIZE)
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("hzaQB", function(module, exports) {
$parcel$export(module.exports, "PAGINATION_SIZE", () => $7334411cc1e06ed7$export$cb638d1fae624fbf);
const $7334411cc1e06ed7$export$cb638d1fae624fbf = 30;

});

parcelRegister("e1Zrl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b28f5c968d0c1655$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91b6b5e0cc30aee7119919d76a4b97e5>>
 * @relayHash ed9f3c4cfea6f6c20358f2ae65e3d29e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1e37cd49b1df6d32185c52133be1fa26641a13cc45bdfd3a4cb263364dcd56d2
const $b28f5c968d0c1655$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v5 = {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v8 = {
        "kind": "Variable",
        "name": "helpCenterId",
        "variableName": "helpCenterId"
    }, v9 = [
        v6 /*: any*/ 
    ], v10 = [
        v8 /*: any*/ 
    ], v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "CustomerServiceExternalStatus",
                "kind": "LinkedField",
                "name": "externalStatuses",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "externalLabel"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraStatusIds"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "statusCategory"
                    }
                ]
            }
        ],
        "type": "CustomerServiceExternalStatusesResponse"
    }, v12 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ ,
            v13 /*: any*/ 
        ],
        "type": "QueryError"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v8 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmRequestsListQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "requestsTable_csmRequestsList"
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "externalStatusesByHelpCenterId",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmRequestsListQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v5 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v16 /*: any*/ ,
                                            "concreteType": "CustomerServiceRequestConnection",
                                            "kind": "LinkedField",
                                            "name": "requests",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CustomerServiceRequestEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceRequest",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "externalStatus"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusCategoryName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createdOn"
                                                                },
                                                                v17 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v16 /*: any*/ ,
                                            "filters": [
                                                "helpCenterId",
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "requestsTable_requests",
                                            "kind": "LinkedHandle",
                                            "name": "requests"
                                        }
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v17 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "externalStatusesByHelpCenterId",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1e37cd49b1df6d32185c52133be1fa26641a13cc45bdfd3a4cb263364dcd56d2",
            "metadata": {},
            "name": "csmRequestsListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b28f5c968d0c1655$var$node.hash = "cb6332bdb26c3936c3393e7e0eb0eafc";
var $b28f5c968d0c1655$export$2e2bcd8739ae039 = $b28f5c968d0c1655$var$node;

});



parcelRegister("4RbXM", function(module, exports) {
$parcel$export(module.exports, "csmUserProfileRoute", () => $6790ae48b9c0f829$export$e41fe4b9d1161823);

var $8rTkC = parcelRequire("8rTkC");

var $cLu28 = parcelRequire("cLu28");

var $bpyxC = parcelRequire("bpyxC");
const $6790ae48b9c0f829$var$viewUserProfilePage = {
    name: 'user-profile',
    path: '/user/profile',
    exact: true,
    resources: [],
    component: (0, $cLu28.CsmUserProfile)
};
const $6790ae48b9c0f829$export$e41fe4b9d1161823 = (0, $bpyxC.createRouteWithLayout)($6790ae48b9c0f829$var$viewUserProfilePage, (0, $8rTkC.ScreenName).USER_PROFILE, {
    hideSearchButton: false,
    paperAppearance: 'normal',
    fadeInSearchModal: true
});

});
parcelRegister("cLu28", function(module, exports) {
$parcel$export(module.exports, "CsmUserProfile", () => $59fa64927af25766$export$3d0c667f8fc698fc);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $59fa64927af25766$export$3d0c667f8fc698fc = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("442LO")), {
        moduleId: "./src/view/user-profile/csm-variants/csm-variants.tsx"
    })
});

});
parcelRegister("442LO", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("a8P1D"),
    $j9MRt("9R0Kw")
]).then(()=>parcelRequire('iFW9z'));

});



parcelRegister("5orRf", function(module, exports) {
$parcel$export(module.exports, "getViewCustomPageRoute", () => $88ba116e899c3f6f$export$3dddbf9f405aac5c);
$parcel$export(module.exports, "getEditCustomPageRoute", () => $88ba116e899c3f6f$export$c998bed8122ef3dd);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $hxVai = parcelRequire("hxVai");

var $8rTkC = parcelRequire("8rTkC");

var $avmm4 = parcelRequire("avmm4");

var $5rqJJ = parcelRequire("5rqJJ");

var $HGACo = parcelRequire("HGACo");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("chjsC");
var $h2NCY = parcelRequire("h2NCY");
parcelRequire("i2Zru");
var $jBIAB = parcelRequire("jBIAB");
parcelRequire("1dZn3");
var $8m5pV = parcelRequire("8m5pV");
parcelRequire("20jeq");
var $2hE7u = parcelRequire("2hE7u");

var $1nQ48 = parcelRequire("1nQ48");

var $bpyxC = parcelRequire("bpyxC");
parcelRequire("flVqy");
var $h3yeO = parcelRequire("h3yeO");
var $2WGOs = parcelRequire("2WGOs");

var $dHBPx = parcelRequire("dHBPx");
const $88ba116e899c3f6f$export$3dddbf9f405aac5c = (name = (0, $8rTkC.RouteName).VIEW_CUSTOM_PAGE, path = (0, $8rTkC.RoutePath).VIEW_CUSTOM_PAGE)=>{
    const viewCustomPageSSRResources = [
        (0, $dHBPx.brandingResource),
        (0, $5rqJJ.ViewCustomPageResource)
    ];
    return (0, $bpyxC.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: (0, $2WGOs.ViewCustomPage),
        resources: [
            (0, $5rqJJ.ViewCustomPageResource)
        ]
    }, (0, $8rTkC.ScreenName).VIEW_CUSTOM_PAGE, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true,
        hideSkipToMainContent: true
    });
};
const $88ba116e899c3f6f$export$366de07628c8a4b = (props)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const WrappedComponent = (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: props.location.pathname
    }), (0, $h2NCY.default)({
        message: formatMessage((0, $1nQ48.authPageMessage)),
        callToActionText: formatMessage((0, $1nQ48.callToActionUrlText)),
        callToActionUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8m5pV.default), {
            path: (0, $8rTkC.RoutePath).EDIT_CUSTOM_PAGE,
            component: (0, $h3yeO.EditCustomPage),
            screenName: (0, $8rTkC.ScreenName).EDIT_CUSTOM_PAGE,
            isFooterHidden: (0, $HGACo.isIncreasedFlexibilityEnabled)()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2hE7u.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, props));
};
const $88ba116e899c3f6f$export$c998bed8122ef3dd = (name = (0, $8rTkC.RouteName).EDIT_CUSTOM_PAGE, path = (0, $8rTkC.RoutePath).EDIT_CUSTOM_PAGE)=>{
    const editHomePageRoute = {
        name: name,
        path: path,
        exact: true,
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo($88ba116e899c3f6f$export$366de07628c8a4b),
        resources: [
            (0, $avmm4.EditCustomPageResource)
        ]
    };
    return editHomePageRoute;
};

});
parcelRegister("avmm4", function(module, exports) {
$parcel$export(module.exports, "EditCustomPageResource", () => $f2e6eea3f6c87234$export$bb1f5be367194159);

var $jByYr = parcelRequire("jByYr");

var $78eL2 = parcelRequire("78eL2");

var $byuiX = parcelRequire("byuiX");

var $67p5V = parcelRequire("67p5V");
const $f2e6eea3f6c87234$export$bb1f5be367194159 = (0, $byuiX.createRelayResource)({
    type: 'EDIT_CUSTOM_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.id;
        if (!pageId) throw Error('No page id for custom page.');
        const helpCenterPageAri = (0, $78eL2.HelpPageAri).create({
            pageId: pageId,
            activationId: (0, $jByYr.getActivationId)()
        }).toString();
        return {
            parameters: (0, $67p5V.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                helpCenterPageAri: helpCenterPageAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("67p5V", function(module, exports) {
$parcel$export(module.exports, "default", () => $8343c8fc0ceea1bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c33598dfe395467c6daf5d8e2a21bbd>>
 * @relayHash 95226f555e4cd9efaf3e2ef17f32be57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f09b7daae44197c6ccb5b6c0f121cea2ab89565a6fb603321045725549e0fe99
const $8343c8fc0ceea1bb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterPageAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterPageAri",
            "variableName": "helpCenterPageAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "HelpCenterPage"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "handleQueryErrorFragment"
            }
        ],
        "type": "QueryError"
    }, v10 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = [
        v10 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterPageAri"
        }
    ], v13 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "message"
    }, v15 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            v15 /*: any*/ 
        ],
        "type": "QueryError"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v19 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v20 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v22 = [
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v24 = {
        "kind": "ScalarField",
        "name": "key"
    }, v25 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v26 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v28 = {
        "kind": "ClientExtension",
        "selections": [
            v27 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "url"
    }, v31 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v33 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v34 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v35 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v36 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v39 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v40 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v41 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v36 /*: any*/ ,
            v40 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            v34 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v42 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v43 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v44 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v29 /*: any*/ 
        ]
    }, v45 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            v34 /*: any*/ ,
            v35 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editCustomPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v11 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "helpCenter.mediaConfig"
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "HelpLayoutQueryApi",
                        "kind": "LinkedField",
                        "name": "helpLayout",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v12 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "layoutByParentId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "pageBuilderFragment"
                                                }
                                            ],
                                            "type": "HelpLayout"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "helpLayout.layoutByParentId"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "HelpLayoutMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "mediaConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "pageBuilderMediaConfigFragment"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "helpLayout.mediaConfig"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "elementTypes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "elementsCatalogueFragment"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "helpLayout"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editCustomPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v7 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layoutByParentId",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v13 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v28 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v38 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v5 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v8 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v34 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                v40 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v37 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v15 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v28 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutKnowledgeCardsElement"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "layoutId",
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v28 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v23 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f09b7daae44197c6ccb5b6c0f121cea2ab89565a6fb603321045725549e0fe99",
            "metadata": {},
            "name": "editCustomPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8343c8fc0ceea1bb$var$node.hash = "6e84c1f16a5f50c7d720c8e513a5328b";
var $8343c8fc0ceea1bb$export$2e2bcd8739ae039 = $8343c8fc0ceea1bb$var$node;

});



parcelRegister("dPlZw", function(module, exports) {
$parcel$export(module.exports, "TOPIC_BASE_PATH", () => $58a67f3b173513c9$export$fcfe7b179287e200);
$parcel$export(module.exports, "editTopicRoute", () => $58a67f3b173513c9$export$60c0f814fe4b3a12);
$parcel$export(module.exports, "addTopicRoute", () => $58a67f3b173513c9$export$9d8f7fd5bc61f52f);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $hxVai = parcelRequire("hxVai");

var $8rTkC = parcelRequire("8rTkC");

var $l4a5B = parcelRequire("l4a5B");
parcelRequire("9wocP");
var $bDnSZ = parcelRequire("bDnSZ");

var $iY001 = parcelRequire("iY001");
parcelRequire("chjsC");
var $h2NCY = parcelRequire("h2NCY");
parcelRequire("i2Zru");
var $jBIAB = parcelRequire("jBIAB");
parcelRequire("1dZn3");
var $8m5pV = parcelRequire("8m5pV");

var $1nQ48 = parcelRequire("1nQ48");

var $ePqxg = parcelRequire("ePqxg");
const $58a67f3b173513c9$export$fcfe7b179287e200 = `/topic`;
const $58a67f3b173513c9$var$ADD_TOPIC_PATH = `${$58a67f3b173513c9$export$fcfe7b179287e200}/add`;
const $58a67f3b173513c9$var$EDIT_TOPIC_PATH = `${$58a67f3b173513c9$export$fcfe7b179287e200}/edit/:id`;
const $58a67f3b173513c9$export$7285959833dc0185 = (0, $l4a5B.default)((props)=>{
    const WrappedComponent = (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: props.location.pathname
    }), (0, $h2NCY.default)({
        message: props.intl.formatMessage((0, $1nQ48.authPageMessage)),
        callToActionText: props.intl.formatMessage((0, $1nQ48.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8m5pV.default), {
            path: $58a67f3b173513c9$var$EDIT_TOPIC_PATH,
            component: (0, $iY001.EditTopicPage),
            screenName: (0, $8rTkC.ScreenName).EDIT_TOPIC
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, props);
});
const $58a67f3b173513c9$export$60c0f814fe4b3a12 = {
    name: (0, $8rTkC.ScreenName).EDIT_TOPIC,
    path: $58a67f3b173513c9$var$EDIT_TOPIC_PATH,
    exact: true,
    component: (0, $bDnSZ.withRouter)($58a67f3b173513c9$export$7285959833dc0185),
    resources: [
        (0, $ePqxg.editTopicResource)
    ]
};
const $58a67f3b173513c9$export$9d8f7fd5bc61f52f = {
    name: (0, $8rTkC.ScreenName).EDIT_TOPIC,
    path: $58a67f3b173513c9$var$ADD_TOPIC_PATH,
    exact: true,
    component: (0, $bDnSZ.withRouter)($58a67f3b173513c9$export$7285959833dc0185),
    resources: [
        (0, $ePqxg.editTopicResource)
    ]
};

});
parcelRegister("iY001", function(module, exports) {
$parcel$export(module.exports, "EditTopicPage", () => $cfca3c18c9fc8107$export$167706eed2563765);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

var $7EQh9 = parcelRequire("7EQh9");

const $cfca3c18c9fc8107$export$167706eed2563765 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("kpXTM")).then((module)=>{
            const { registerHelpObjectEpicsAndReducers: registerHelpObjectEpicsAndReducers } = module;
            registerHelpObjectEpicsAndReducers();
            return module.default;
        }), {
        moduleId: "./src/topics/src/ui/edit-topic/main.tsx"
    }),
    LoadingSkeleton: (0, $7EQh9.EditTopicLoader)
});

});
parcelRegister("7EQh9", function(module, exports) {
$parcel$export(module.exports, "EditTopicLoader", () => $27ec922a76228a22$export$c00c0ab43fa4f914);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $5OWUX = parcelRequire("5OWUX");
var $4O8fD = parcelRequire("4O8fD");

var $4cxV2 = parcelRequire("4cxV2");

var $6Hfjm = parcelRequire("6Hfjm");

var $cjn3r = parcelRequire("cjn3r");

var $9D3hq = parcelRequire("9D3hq");
const $27ec922a76228a22$export$c00c0ab43fa4f914 = (props)=>{
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, props.error ? /*#__PURE__*/ $8P7DW.createElement($27ec922a76228a22$var$LoaderContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $5OWUX.ChunkLoadErrorMessage), null)) : /*#__PURE__*/ $8P7DW.createElement((0, $9D3hq.Container), null, /*#__PURE__*/ $8P7DW.createElement((0, $9D3hq.TopicContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingInline: "space.500"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $9D3hq.SpinnerWrapper), null, /*#__PURE__*/ $8P7DW.createElement((0, $cjn3r.default), {
        size: 'medium'
    })))), /*#__PURE__*/ $8P7DW.createElement((0, $9D3hq.HelpObjectContainer), null, /*#__PURE__*/ $8P7DW.createElement($27ec922a76228a22$var$Row, null, /*#__PURE__*/ $8P7DW.createElement((0, $4O8fD.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), /*#__PURE__*/ $8P7DW.createElement($27ec922a76228a22$var$Row, null, /*#__PURE__*/ $8P7DW.createElement((0, $4O8fD.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), /*#__PURE__*/ $8P7DW.createElement($27ec922a76228a22$var$Row, null, /*#__PURE__*/ $8P7DW.createElement((0, $4O8fD.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })))));
};
const $27ec922a76228a22$var$LOADER_MIN_HEIGHT = '75vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $27ec922a76228a22$var$LoaderContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-16axg55-0"
})`min-height:${$27ec922a76228a22$var$LOADER_MIN_HEIGHT};display:flex;align-items:center;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $27ec922a76228a22$var$Row = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-16axg55-1"
})`margin-top:${"var(--ds-space-200, 16px)"};width:${$4cxV2.multiple(50).px};`;

});
parcelRegister("9D3hq", function(module, exports) {
$parcel$export(module.exports, "Container", () => $5449cb86fcbd8887$export$42a852a2b6b56249);
$parcel$export(module.exports, "TopicContainer", () => $5449cb86fcbd8887$export$3906a519f454d518);
$parcel$export(module.exports, "HelpObjectContainer", () => $5449cb86fcbd8887$export$7e8e7bb92ce298ab);
$parcel$export(module.exports, "SpinnerWrapper", () => $5449cb86fcbd8887$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $6t2I3 = parcelRequire("6t2I3");

var $kJu2d = parcelRequire("kJu2d");
const $5449cb86fcbd8887$var$topicContainerWidth = '70%';
const $5449cb86fcbd8887$var$topicContainerMinHeight = `calc(100vh - ${(0, $kJu2d.FOOTER_HEIGHT)}px)`;
const $5449cb86fcbd8887$var$helpObjectContainerWidth = '30%';
const $5449cb86fcbd8887$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-7u94c0-0"
})`display:flex;flex-wrap:wrap;justify-content:space-between;border-bottom:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #EBECF0)"};`;
const $5449cb86fcbd8887$export$3906a519f454d518 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-7u94c0-1"
})`width:${$5449cb86fcbd8887$var$topicContainerWidth};padding:${"var(--ds-space-400, 32px)"} ${"var(--ds-space-1000, 80px)"};background-color:${"var(--ds-surface, #FFFFFF)"};border-right:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #EBECF0)"};box-sizing:border-box;min-height:${$5449cb86fcbd8887$var$topicContainerMinHeight};`;
const $5449cb86fcbd8887$export$7e8e7bb92ce298ab = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-7u94c0-2"
})`width:${$5449cb86fcbd8887$var$helpObjectContainerWidth};box-sizing:border-box;padding:${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"};`;
const $5449cb86fcbd8887$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-7u94c0-3"
})`${$6t2I3.flexCenter};margin-top:${"var(--ds-space-400, 32px)"};`;

});


parcelRegister("kpXTM", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("gR3jJ"),
    $j9MRt("kB8ya"),
    $j9MRt("j5SwK"),
    $j9MRt("cDUzg"),
    $j9MRt("4ZqDM")
]).then(()=>parcelRequire('dnuey'));

});


parcelRegister("ePqxg", function(module, exports) {
$parcel$export(module.exports, "editTopicResource", () => $85be9094ca49c7b0$export$414824bab2e11c29);

var $l5Hnb = parcelRequire("l5Hnb");

var $byuiX = parcelRequire("byuiX");
const $85be9094ca49c7b0$export$414824bab2e11c29 = (0, $byuiX.createRelayResource)({
    type: 'EDIT_TOPIC',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>({
            parameters: (0, $l5Hnb.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});


parcelRegister("7A2dq", function(module, exports) {
$parcel$export(module.exports, "getEmbedCreateRequestRoute", () => $64d2bc946ba68ce1$export$ed25ec64c8131f29);
$parcel$export(module.exports, "embedSinglePortalRoute", () => $64d2bc946ba68ce1$export$f8f6af866fe5eb29);
$parcel$export(module.exports, "embedKBArticleRoute", () => $64d2bc946ba68ce1$export$50b320f40299497c);
$parcel$export(module.exports, "embedFeaturedPortalsRoute", () => $64d2bc946ba68ce1$export$89cf0aa4f08ce120);
$parcel$export(module.exports, "embedLoginSuccessRoute", () => $64d2bc946ba68ce1$export$a493105cf7e63414);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $fBOCW = parcelRequire("fBOCW");

var $4cxV2 = parcelRequire("4cxV2");

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
var $bDnSZ = parcelRequire("bDnSZ");
parcelRequire("8nQ9l");
var $6aykf = parcelRequire("6aykf");
parcelRequire("9i6OK");
var $3szzY = parcelRequire("3szzY");

var $1EFS8 = parcelRequire("1EFS8");

var $g2qf8 = parcelRequire("g2qf8");
const $64d2bc946ba68ce1$export$2e9e2f006c89796d = (WrappedComponent, screenName)=>{
    const ComponentWithEmbeddedPage = (props)=>{
        const [routerState] = (0, $i9cdb.useRouter)();
        const { basePath: basePath, ...routeContext } = routerState;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $g2qf8.default), {
            screenName: screenName,
            screenId: routeContext.match.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3szzY.default), {
            screenName: screenName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($64d2bc946ba68ce1$var$EmbedComponentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6aykf.default), routeContext), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, {
            isEmbeddedRoute: true,
            ...routeContext,
            ...props
        }))));
    };
    return ComponentWithEmbeddedPage;
};

// Route for embeddable request create page
const $64d2bc946ba68ce1$var$AsyncEmbedCreateRequestPage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("fvT1s")), {
        moduleId: "./src/view/request-create-page/embed-request-create-page/index.tsx"
    })
});
const $64d2bc946ba68ce1$export$ed25ec64c8131f29 = ()=>({
        name: 'embed-request-create',
        path: `/embeds/portal/:portalId/create/:requestTypeId`,
        exact: true,
        component: (0, $bDnSZ.withRouter)($64d2bc946ba68ce1$export$2e9e2f006c89796d($64d2bc946ba68ce1$var$AsyncEmbedCreateRequestPage, (0, $8rTkC.ScreenName).EMBED_REQUEST_CREATE)),
        resources: (0, $HGACo.isUiModificationsSupportEnabled)() && !(0, $1EFS8.default).checkGate('ditto_uim_root_query_rest') ? [
            (0, $fBOCW.UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE)
        ] : []
    });

// Route for embeddable single portal page
const $64d2bc946ba68ce1$var$AsyncEmbedSinglePortalPage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("j3BqR")), {
        moduleId: "./src/view/help-center/help-center-content/embed-single-portal/index.tsx"
    })
});
const $64d2bc946ba68ce1$export$f8f6af866fe5eb29 = {
    name: 'embed-single-portal',
    path: `/embeds/portal/:portalId`,
    exact: true,
    component: (0, $bDnSZ.withRouter)($64d2bc946ba68ce1$export$2e9e2f006c89796d($64d2bc946ba68ce1$var$AsyncEmbedSinglePortalPage, (0, $8rTkC.ScreenName).EMBED_SINGLE_PORTAL))
};

// Route for embeddable knowledge base article page
const $64d2bc946ba68ce1$var$AsyncEmbedKBArticlePage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("9WPnV")), {
        moduleId: "./src/view/article/embed-kb-article/index.tsx"
    })
});
const $64d2bc946ba68ce1$export$50b320f40299497c = {
    name: 'embed-kb-article',
    path: `/embeds/portal/:portalId/:topic?/:categoryId?/:article/:articleId`,
    exact: true,
    component: (0, $bDnSZ.withRouter)($64d2bc946ba68ce1$export$2e9e2f006c89796d($64d2bc946ba68ce1$var$AsyncEmbedKBArticlePage, (0, $8rTkC.ScreenName).EMBED_KB_ARTICLE))
};

// Route for embeddable featured portals page
const $64d2bc946ba68ce1$var$AsyncEmbedFeaturedPortalsPage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("ke1kN")), {
        moduleId: "./src/view/help-center/embed-featured-portals/index.tsx"
    })
});
const $64d2bc946ba68ce1$export$89cf0aa4f08ce120 = {
    name: 'embed-featured-portals',
    path: `/embeds/portals`,
    exact: true,
    component: (0, $bDnSZ.withRouter)($64d2bc946ba68ce1$export$2e9e2f006c89796d($64d2bc946ba68ce1$var$AsyncEmbedFeaturedPortalsPage, (0, $8rTkC.ScreenName).EMBED_FEATURED_PORTALS))
};

// Route for embedded login success page
const $64d2bc946ba68ce1$var$AsyncEmbedLoginSuccessPage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("afxG1")), {
        moduleId: "./src/view/login/embed-login-success/index.tsx"
    })
});
const $64d2bc946ba68ce1$export$a493105cf7e63414 = {
    name: 'embed-login-success',
    path: `/embeds/login-success`,
    exact: true,
    component: (0, $bDnSZ.withRouter)($64d2bc946ba68ce1$export$2e9e2f006c89796d($64d2bc946ba68ce1$var$AsyncEmbedLoginSuccessPage, (0, $8rTkC.ScreenName).EMBED_LOGIN_SUCCESS))
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $64d2bc946ba68ce1$var$EmbedComponentWrapper = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-168unha-0"
})`display:flex;flex-direction:column;min-height:100%;border:${$4cxV2.multiple(1 / 8).px} solid ${"var(--ds-border-bold, #EBECF0)"};border-radius:${$4cxV2.multiple(3 / 8).px};box-sizing:border-box;`;

});
parcelRegister("fvT1s", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("9IlFU").then(()=>parcelRequire('hrgWl'));

});

parcelRegister("j3BqR", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("bP7WA"),
    $j9MRt("3WBzd")
]).then(()=>parcelRequire('doc9a'));

});

parcelRegister("9WPnV", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("f356x").then(()=>parcelRequire('biEov'));

});

parcelRegister("ke1kN", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("hcxtc"),
    $j9MRt("hZrfC")
]).then(()=>parcelRequire('7B1ek'));

});

parcelRegister("afxG1", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("l7PAB").then(()=>parcelRequire('lb8BG'));

});


parcelRegister("lKYU4", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterRoute", () => $95dc90e82b7b321a$export$4e7002b7e4a938bc);

var $8rTkC = parcelRequire("8rTkC");

var $iA1ui = parcelRequire("iA1ui");
const $95dc90e82b7b321a$export$4e7002b7e4a938bc = ()=>{
    const name = 'help-center';
    const path = '/portals';
    const screenName = (0, $8rTkC.ScreenName).HELP_CENTER;
    return (0, $iA1ui.getFlexiHelpCenterRoute)(name, path, screenName);
};

});

parcelRegister("dQDRa", function(module, exports) {
$parcel$export(module.exports, "viewKbPageRoute", () => $9d820a309af19769$export$7770cb0c6ff06b3a);
$parcel$export(module.exports, "viewAllSearchResultsRoute", () => $9d820a309af19769$export$b9392cfe93dd18c7);
$parcel$export(module.exports, "viewPortalAllSearchResultsRoute", () => $9d820a309af19769$export$ecf8460d0ec6e97);
$parcel$export(module.exports, "viewPortalKnowledgeCategoryRoute", () => $9d820a309af19769$export$4704dfed5640c7f);
$parcel$export(module.exports, "viewPortalCategoryArticleRoute", () => $9d820a309af19769$export$c875ec1eb313d3e6);
$parcel$export(module.exports, "viewPortalArticleRoute", () => $9d820a309af19769$export$ad9d4a1dd23783b4);
$parcel$export(module.exports, "viewArticleRoute", () => $9d820a309af19769$export$95b4792c2f78259d);
$parcel$export(module.exports, "viewCrossSitePortalArticleRoute", () => $9d820a309af19769$export$d549c8909c9cf794);
$parcel$export(module.exports, "viewCrossSiteArticleRoute", () => $9d820a309af19769$export$10ea759d4b0b4d21);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");
var $bDnSZ = parcelRequire("bDnSZ");

var $5cu7I = parcelRequire("5cu7I");
parcelRequire("8nQ9l");
var $6aykf = parcelRequire("6aykf");

var $ca84v = parcelRequire("ca84v");
parcelRequire("9i6OK");
var $3szzY = parcelRequire("3szzY");

var $e6Qdr = parcelRequire("e6Qdr");

var $g2qf8 = parcelRequire("g2qf8");

var $bpyxC = parcelRequire("bpyxC");

var $bXs4i = parcelRequire("bXs4i");

const $9d820a309af19769$var$AllSearchResultsV1 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("3z1nF")), {
        moduleId: "./src/view/search/all-results/index.tsx"
    })
});

const $9d820a309af19769$var$AllSearchResults = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("9DavY")), {
        moduleId: "./packages/help-center/search/src/all-results/index.tsx"
    })
});
const $9d820a309af19769$var$RenderKnowledgeCategoryRoute = ()=>{
    const [routerState] = (0, $i9cdb.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ $8P7DW.createElement((0, $g2qf8.default), {
        screenName: (0, $8rTkC.ScreenName).KNOWLEDGE_CATEGORY,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ $8P7DW.createElement((0, $3szzY.default), {
        screenName: (0, $8rTkC.ScreenName).KNOWLEDGE_CATEGORY
    }, /*#__PURE__*/ $8P7DW.createElement((0, $ca84v.KnowledgeCategory), routeContext)));
};
const $9d820a309af19769$var$RenderArticlesSearchRoute = ()=>{
    const [routerState] = (0, $i9cdb.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ $8P7DW.createElement((0, $g2qf8.default), {
        screenName: (0, $8rTkC.ScreenName).KNOWLEDGE_ALL_SEARCH_RESULTS,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ $8P7DW.createElement((0, $3szzY.default), {
        screenName: (0, $8rTkC.ScreenName).KNOWLEDGE_ALL_SEARCH_RESULTS
    }, /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $6aykf.default), routeContext), (0, $e6Qdr.fg)('helpcenter_search_api_changes') ? /*#__PURE__*/ $8P7DW.createElement($9d820a309af19769$var$AllSearchResults, routeContext) : /*#__PURE__*/ $8P7DW.createElement($9d820a309af19769$var$AllSearchResultsV1, routeContext))));
};
const $9d820a309af19769$export$319de0a85a85b4cd = (isArticleView)=>{
    return isArticleView ? 'xxwide' : 'xwide';
};
const $9d820a309af19769$var$viewKbPage = {
    resources: [],
    name: 'view-kb-page',
    path: '/kb/view/:pageId',
    exact: true,
    component: (0, $5cu7I.Article)
};
const $9d820a309af19769$var$portalKnowledgeCategory = {
    resources: [],
    name: 'view-portal-kb-category',
    path: `/portal/:portalId/topic/:categoryId`,
    exact: true,
    component: $9d820a309af19769$var$RenderKnowledgeCategoryRoute
};
const $9d820a309af19769$var$viewPortalCategoryArticle = {
    resources: [],
    name: 'view-portal-kb-category-article',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/topic/:categoryId/article/:articleId`,
    exact: true,
    component: (0, $5cu7I.Article)
};
const $9d820a309af19769$var$viewPortalArticle = {
    resources: [],
    name: 'view-portal-kb-article',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/article/:articleId`,
    exact: true,
    component: (0, $5cu7I.Article)
};
const $9d820a309af19769$var$viewArticle = {
    resources: [],
    name: 'view-kb-article',
    path: `/article/:articleId`,
    exact: true,
    component: (0, $5cu7I.Article)
};
const $9d820a309af19769$var$viewCrossSitePortalArticle = {
    resources: [],
    name: 'view-portal-cross-site-kb-article',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $5cu7I.Article)
};
const $9d820a309af19769$var$viewCrossSiteArticle = {
    resources: [],
    name: 'view-kb-cross-site-article',
    path: `/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $5cu7I.Article)
};
const $9d820a309af19769$var$viewAllSearchResults = {
    resources: [],
    name: 'view-all-search-results',
    path: `/articles/search`,
    exact: true,
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration,@atlaskit/platform/no-module-level-eval
    component: (0, $e6Qdr.fg)('helpcenter_search_api_changes') ? $9d820a309af19769$var$AllSearchResults : $9d820a309af19769$var$AllSearchResultsV1
};
const $9d820a309af19769$var$viewPortalAllSearchResults = {
    resources: [],
    name: 'view-portal-all-search-results',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/articles/search`,
    exact: true,
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration,@atlaskit/platform/no-module-level-eval
    component: (0, $e6Qdr.fg)('helpcenter_search_api_changes') ? $9d820a309af19769$var$AllSearchResults : $9d820a309af19769$var$AllSearchResultsV1
};
const $9d820a309af19769$var$categoryLayoutProps = {
    paperAppearance: $9d820a309af19769$export$319de0a85a85b4cd(false),
    fadeInSearchModal: true
};
const $9d820a309af19769$var$layoutProps = {
    paperAppearance: $9d820a309af19769$export$319de0a85a85b4cd(true),
    fadeInSearchModal: true
};
const $9d820a309af19769$export$7770cb0c6ff06b3a = (0, $bpyxC.createRouteWithLayout)($9d820a309af19769$var$viewKbPage, (0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE, $9d820a309af19769$var$layoutProps);
const $9d820a309af19769$export$b9392cfe93dd18c7 = {
    ...$9d820a309af19769$var$viewAllSearchResults,
    component: (0, $bDnSZ.withRouter)($9d820a309af19769$var$RenderArticlesSearchRoute)
};
const $9d820a309af19769$export$ecf8460d0ec6e97 = {
    ...$9d820a309af19769$var$viewPortalAllSearchResults,
    component: (0, $bDnSZ.withRouter)($9d820a309af19769$var$RenderArticlesSearchRoute)
};
const $9d820a309af19769$export$4704dfed5640c7f = (0, $bpyxC.createRouteWithLayout)($9d820a309af19769$var$portalKnowledgeCategory, (0, $8rTkC.ScreenName).KNOWLEDGE_CATEGORY, $9d820a309af19769$var$categoryLayoutProps);
const $9d820a309af19769$export$c875ec1eb313d3e6 = (0, $bpyxC.createRouteWithLayout)($9d820a309af19769$var$viewPortalCategoryArticle, (0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE, $9d820a309af19769$var$layoutProps);
const $9d820a309af19769$export$ad9d4a1dd23783b4 = (0, $bpyxC.createRouteWithLayout)($9d820a309af19769$var$viewPortalArticle, (0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE, $9d820a309af19769$var$layoutProps);
const $9d820a309af19769$export$95b4792c2f78259d = (0, $bpyxC.createRouteWithLayout)($9d820a309af19769$var$viewArticle, (0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE, $9d820a309af19769$var$layoutProps);
const $9d820a309af19769$export$d549c8909c9cf794 = (0, $bpyxC.createRouteWithLayout)($9d820a309af19769$var$viewCrossSitePortalArticle, (0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE, $9d820a309af19769$var$layoutProps);
const $9d820a309af19769$export$10ea759d4b0b4d21 = (0, $bpyxC.createRouteWithLayout)($9d820a309af19769$var$viewCrossSiteArticle, (0, $8rTkC.ScreenName).KNOWLEDGE_ARTICLE, $9d820a309af19769$var$layoutProps);

});
parcelRegister("5cu7I", function(module, exports) {
$parcel$export(module.exports, "Article", () => $5e2ac9d8e6d84436$export$89693000420c0acd);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $5e2ac9d8e6d84436$export$89693000420c0acd = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("afrKN")), {
        moduleId: "./src/view/article/hocs.tsx"
    })
});

});
parcelRegister("afrKN", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("eC2J7"),
    $j9MRt("i1pvz")
]).then(()=>parcelRequire('ckKlO'));

});


parcelRegister("ca84v", function(module, exports) {
$parcel$export(module.exports, "KnowledgeCategory", () => $8188414c54c029fc$export$b0a220e8bdf61c72);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $1EFS8 = parcelRequire("1EFS8");

var $hPLrQ = parcelRequire("hPLrQ");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("e4gcm");
var $4bhdn = parcelRequire("4bhdn");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $cqS4G = parcelRequire("cqS4G");
const $8188414c54c029fc$var$mapStateToProps = (state, props)=>{
    let portalId;
    let categoryId;
    if (props.match.params) {
        portalId = Number(props.match.params.portalId);
        categoryId = props.match.params.categoryId;
    }
    const showRequestCreateButton = (0, $73V7l.canCreateRequest)(state, portalId);
    const portal = (0, $73V7l.getPortalOrError)(state, portalId);
    const portalName = (0, $73V7l.getName)(state, portalId);
    const projectId = (0, $73V7l.getProjectId)(state, portalId);
    const shouldFetchPortalOnMount = !portal;
    const portalLink = (0, $73V7l.getPortalLink)(state, portalId);
    const categoryOrError = (0, $73V7l.getCategory)(state, portalId, categoryId);
    const articlesOrError = (0, $4bhdn.getArticles)(state, categoryId);
    const category = !!categoryOrError && 'name' in categoryOrError ? categoryOrError : undefined;
    // we show a different loading spinner specifically for articles,
    // this way we can still display the user the category information and the bread-crumbs as soon as we have that data
    const isArticlesLoading = !articlesOrError;
    const portalError = !!portal && 'error' in portal ? portal : undefined;
    const articleFetchError = !!articlesOrError && 'error' in articlesOrError ? articlesOrError : undefined;
    let error;
    if (!!portalError) error = portalError;
    // any errors that occur when fetching categories will be available in articleFetchError
    // as the two calls are combined on initial page load
    if (!!articleFetchError && !isArticlesLoading) error = articleFetchError;
    const portalOnlyPageLoading = (0, $1EFS8.default).checkGate('help_center_kb_category_page_portal_only_loading');
    let isLoading = !portal || !categoryOrError && !error;
    if (portalOnlyPageLoading) isLoading = !portal;
    const articles = Array.isArray(articlesOrError) ? articlesOrError : undefined;
    return {
        portalId: portalId,
        categoryId: categoryId,
        projectId: projectId,
        category: category,
        articles: articles,
        portalName: portalName,
        isLoading: isLoading,
        isArticlesLoading: isArticlesLoading,
        shouldFetchPortalOnMount: shouldFetchPortalOnMount,
        portalLink: portalLink,
        showRequestCreateButton: showRequestCreateButton,
        error: error ? error.error : undefined
    };
};
const $8188414c54c029fc$export$b0a220e8bdf61c72 = (0, $jvoWT.default)($8188414c54c029fc$var$mapStateToProps, {
    fetchPortal: (0, $d727K.fetchPortalAction),
    fetchArticles: (0, $hPLrQ.fetchArticlesAction)
})((0, $cqS4G.default));

});
parcelRegister("e4gcm", function(module, exports) {
$parcel$export(module.exports, "getArticle", () => (parcelRequire("4bhdn")).getArticle);
$parcel$export(module.exports, "getArticles", () => (parcelRequire("4bhdn")).getArticles);
$parcel$export(module.exports, "getArticleTitle", () => (parcelRequire("4bhdn")).getArticleTitle);
parcelRequire("4bhdn");

});
parcelRegister("4bhdn", function(module, exports) {
$parcel$export(module.exports, "getArticles", () => $18f75044f9ff5591$export$59baee6c0c5ecafe);
$parcel$export(module.exports, "getArticle", () => $18f75044f9ff5591$export$f8c0d0a39b0d7d4e);
$parcel$export(module.exports, "getArticleTitle", () => $18f75044f9ff5591$export$7aa4b20764201f2f);
const $18f75044f9ff5591$export$59baee6c0c5ecafe = (state, categoryId)=>{
    if (!categoryId) return undefined;
    const articleState = state.persisted.kbArticles;
    if (articleState.articles[categoryId] && articleState.articles[categoryId].error) return articleState.articles[categoryId].error;
    return articleState.articles[categoryId] ? articleState.articles[categoryId].articles : undefined;
};
const $18f75044f9ff5591$export$f8c0d0a39b0d7d4e = (state, id)=>!!id ? state.persisted.kbArticles.legacyArticles[id] : undefined;
const $18f75044f9ff5591$export$7aa4b20764201f2f = (state, id)=>{
    const article = $18f75044f9ff5591$export$f8c0d0a39b0d7d4e(state, id);
    if (!article || 'error' in article) return undefined;
    return article.title;
};

});


parcelRegister("cqS4G", function(module, exports) {
$parcel$export(module.exports, "default", () => $65c25976133a3e84$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $gzPDp = parcelRequire("gzPDp");

var $4acrp = parcelRequire("4acrp");

var $l4a5B = parcelRequire("l4a5B");
parcelRequire("72LHL");
var $4Em1B = parcelRequire("4Em1B");
parcelRequire("jhiA9");
var $fmBB5 = parcelRequire("fmBB5");
parcelRequire("1n2hY");
var $4fSTF = parcelRequire("4fSTF");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $iziiq = parcelRequire("iziiq");
parcelRequire("aFamU");
var $km9xC = parcelRequire("km9xC");

var $gmuFJ = parcelRequire("gmuFJ");
class $65c25976133a3e84$export$b0a220e8bdf61c72 extends $8P7DW.Component {
    componentDidMount() {
        const { shouldFetchPortalOnMount: shouldFetchPortalOnMount, fetchPortal: fetchPortal, fetchArticles: fetchArticles, portalId: portalId, projectId: projectId, categoryId: categoryId, category: category } = this.props;
        if (shouldFetchPortalOnMount && portalId) fetchPortal({
            id: portalId,
            expand: [
                'reqTypes',
                'reqGroups',
                'orderMapping',
                'kbs'
            ]
        });
        if (portalId && projectId && categoryId) {
            const meta = this.getFailureAnalyticsEvent();
            fetchArticles({
                projectId: projectId,
                portalId: portalId,
                categoryId: categoryId,
                meta: meta,
                categoryDataRequired: !category
            });
        }
    }
    componentDidUpdate(prevProps) {
        const { fetchArticles: fetchArticles, portalId: portalId, projectId: projectId, categoryId: categoryId, category: category } = this.props;
        const shouldFetchArticles = !prevProps.projectId && projectId;
        if (shouldFetchArticles && projectId && portalId && categoryId) {
            const meta = this.getFailureAnalyticsEvent();
            fetchArticles({
                projectId: projectId,
                portalId: portalId,
                categoryId: categoryId,
                meta: meta,
                categoryDataRequired: !category
            });
        }
    }
    renderInnerContent() {
        const { category: category, articles: articles, portalId: portalId, isArticlesLoading: isArticlesLoading, portalName: portalName, portalLink: portalLink, showRequestCreateButton: showRequestCreateButton } = this.props;
        if (!category || !portalId || !portalName) return null;
        const attributes = (articles || []).reduce((attr, article)=>({
                featured: attr.featured + (article.isFeatured ? 1 : 0),
                total: attr.total + 1
            }), {
            featured: 0,
            total: 0
        });
        return /*#__PURE__*/ $8P7DW.createElement((0, $iziiq.AnalyticsContext), {
            attributes: attributes
        }, /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.PaperContent), null, /*#__PURE__*/ $8P7DW.createElement((0, $fmBB5.default), {
            subHeading: category.name,
            description: category.description,
            portalId: portalId,
            categoryId: category.id
        }), /*#__PURE__*/ $8P7DW.createElement((0, $km9xC.default), {
            portalLink: portalLink,
            portalId: portalId,
            portalName: portalName,
            categoryId: category.id,
            articles: articles,
            showRequestCreateButton: showRequestCreateButton,
            isLoading: isArticlesLoading
        })));
    }
    render() {
        const { category: category, portalName: portalName, intl: intl, isLoading: isLoading } = this.props;
        const pageTitle = category && portalName ? intl.formatMessage((0, $gmuFJ.default).categoryDocumentTitle, {
            portalName: portalName,
            categoryName: category.name
        }) : undefined;
        return /*#__PURE__*/ $8P7DW.createElement((0, $gzPDp.default), {
            title: pageTitle
        }, /*#__PURE__*/ $8P7DW.createElement((0, $4Em1B.default), {
            isLoading: isLoading
        }, this.renderInnerContent()));
    }
    constructor(...args){
        super(...args), this.getFailureAnalyticsEvent = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'articlesFetch failed',
                    analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE)
                })
            };
        };
    }
}
var $65c25976133a3e84$export$2e2bcd8739ae039 = (0, $4acrp.withErrorPage)((0, $l4a5B.default)((0, $eS4yu.default)({
    componentName: 'KbCategory'
})((0, $k7ZVu.default)()($65c25976133a3e84$export$b0a220e8bdf61c72))));

});
parcelRegister("72LHL", function(module, exports) {
$parcel$export(module.exports, "LoadingContainer", () => (parcelRequire("4Em1B")).default);

var $4Em1B = parcelRequire("4Em1B");

});
parcelRegister("4Em1B", function(module, exports) {
$parcel$export(module.exports, "default", () => $cad07f5b1a4f44d4$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $5OWUX = parcelRequire("5OWUX");

var $4peLG = parcelRequire("4peLG");
class $cad07f5b1a4f44d4$export$2e2bcd8739ae039 extends $8P7DW.Component {
    static #_ = this.defaultProps = {
        loadingPosition: 'fill-container'
    };
    render() {
        const { children: children, loadingPosition: loadingPosition, isLoading: isLoading, interactionName: interactionName, enableUFOHold: enableUFOHold, ufoHoldName: ufoHoldName } = this.props;
        const loader = /*#__PURE__*/ $8P7DW.createElement((0, $5OWUX.default), {
            isLoading: true,
            loadingPosition: loadingPosition,
            interactionName: interactionName
        });
        if (!isLoading) return children;
        return enableUFOHold ? /*#__PURE__*/ $8P7DW.createElement((0, $4peLG.default), {
            name: ufoHoldName
        }, loader) : loader;
    }
}

});


parcelRegister("jhiA9", function(module, exports) {
$parcel$export(module.exports, "PaperHeader", () => (parcelRequire("fmBB5")).default);

var $fmBB5 = parcelRequire("fmBB5");

});
parcelRegister("fmBB5", function(module, exports) {
$parcel$export(module.exports, "default", () => $241caa3872ee5b45$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $kFYzS = parcelRequire("kFYzS");
parcelRequire("gJuJ7");
var $g4GDy = parcelRequire("g4GDy");

var $gVqTI = parcelRequire("gVqTI");

var $iqJis = parcelRequire("iqJis");

var $c7dQO = parcelRequire("c7dQO");
const $241caa3872ee5b45$var$headerDescription = (description, dangerouslyAllowHtmlInDescription)=>dangerouslyAllowHtmlInDescription ? /*#__PURE__*/ $8P7DW.createElement((0, $gVqTI.Description), {
        dangerouslySetInnerHTML: {
            __html: description
        }
    }) : /*#__PURE__*/ $8P7DW.createElement((0, $gVqTI.Description), null, description);
const $241caa3872ee5b45$var$PaperHeader = ({ subHeading: subHeading, description: description, logoUrl: logoUrl, showRequestsInBreadcrumbs: showRequestsInBreadcrumbs, dangerouslyAllowHtmlInDescription: dangerouslyAllowHtmlInDescription, dataTestId: dataTestId, ...props })=>{
    return /*#__PURE__*/ $8P7DW.createElement("div", {
        "data-testid": dataTestId
    }, /*#__PURE__*/ $8P7DW.createElement((0, $g4GDy.default), {
        ...props,
        showRequests: showRequestsInBreadcrumbs
    }), /*#__PURE__*/ $8P7DW.createElement((0, $gVqTI.SubHeadingContainer), null, !!logoUrl && /*#__PURE__*/ $8P7DW.createElement((0, $gVqTI.IconContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $kFYzS.default), {
        src: logoUrl,
        alt: ""
    })), /*#__PURE__*/ $8P7DW.createElement("div", null, /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
            size: "large",
            as: "h1"
        }, subHeading)
    }, /*#__PURE__*/ $8P7DW.createElement((0, $gVqTI.SubHeading), null, subHeading)))), !!description && $241caa3872ee5b45$var$headerDescription(description, dangerouslyAllowHtmlInDescription));
};
var $241caa3872ee5b45$export$2e2bcd8739ae039 = $241caa3872ee5b45$var$PaperHeader;

});
parcelRegister("gJuJ7", function(module, exports) {
$parcel$export(module.exports, "BreadCrumbs", () => (parcelRequire("g4GDy")).default);

var $g4GDy = parcelRequire("g4GDy");

});
parcelRegister("g4GDy", function(module, exports) {
$parcel$export(module.exports, "default", () => $66f5db82b7a20403$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $hWt0u = parcelRequire("hWt0u");
parcelRequire("kdXIP");
var $g9lFj = parcelRequire("g9lFj");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("e4gcm");
var $4bhdn = parcelRequire("4bhdn");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $vYPX4 = parcelRequire("vYPX4");
parcelRequire("j08Tj");
var $gNgLh = parcelRequire("gNgLh");
const $66f5db82b7a20403$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getSharedPortalName), (state, props)=>{
    return (0, $73V7l.getName)(state, (0, $vYPX4.toNumber)(props.portalId)) ?? (0, $g9lFj.getPortalNameFromBranding)(state);
}, (state, props)=>{
    const category = (0, $73V7l.getCategory)(state, (0, $vYPX4.toNumber)(props.portalId), props.categoryId);
    return !!category && 'name' in category ? category.name : undefined;
}, (state, props)=>{
    return (0, $4bhdn.getArticleTitle)(state, props.articleId);
}, (sharedPortalName, portalName, categoryName, articleTitle)=>({
        sharedPortalName: sharedPortalName,
        portalName: portalName,
        categoryName: categoryName,
        articleTitle: articleTitle
    }));
const $66f5db82b7a20403$export$5646050d516e06bc = (0, $jvoWT.default)($66f5db82b7a20403$var$selector)((0, $gNgLh.default));
var $66f5db82b7a20403$export$2e2bcd8739ae039 = (0, $hWt0u.default)($66f5db82b7a20403$export$5646050d516e06bc);

});
parcelRegister("kdXIP", function(module, exports) {
$parcel$export(module.exports, "getPortalNameFromBranding", () => (parcelRequire("g9lFj")).getPortalNameFromBranding);

var $g9lFj = parcelRequire("g9lFj");

});
parcelRegister("g9lFj", function(module, exports) {
$parcel$export(module.exports, "getPortalNameFromBranding", () => $c797cdcaa91acbfc$export$b81ba060d3a3afb3);
const $c797cdcaa91acbfc$export$b81ba060d3a3afb3 = (state)=>{
    var _state$persisted$bran;
    if ((_state$persisted$bran = state.persisted.branding) !== null && _state$persisted$bran !== void 0 && _state$persisted$bran.name) return state.persisted.branding.name;
    return undefined;
};

});


parcelRegister("j08Tj", function(module, exports) {
$parcel$export(module.exports, "BreadCrumbsDumb", () => (parcelRequire("gNgLh")).default);

var $gNgLh = parcelRequire("gNgLh");

});
parcelRegister("gNgLh", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcbd39b57f823a99$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $6RJZN = parcelRequire("6RJZN");

var $l4a5B = parcelRequire("l4a5B");

var $iycTY = parcelRequire("iycTY");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $jsmb9 = parcelRequire("jsmb9");

var $6haLy = parcelRequire("6haLy");
const $bcbd39b57f823a99$export$a1a3354a8b2c8731 = ({ sharedPortalName: sharedPortalName, portalName: portalName, categoryName: categoryName, articleTitle: articleTitle, portalId: portalId, categoryId: categoryId, articleId: articleId, showRequests: showRequests, intl: intl, requestKey: requestKey, requestUrl: requestUrl, additionalBreadCrumbs: additionalBreadCrumbs })=>{
    const requestCreateBreadcrumb = showRequests ? intl.formatMessage((0, $6haLy.default).raiseRequestBreadcrumb) : undefined;
    const isCSM = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    return /*#__PURE__*/ $8P7DW.createElement((0, $iycTY.default), {
        label: intl.formatMessage((0, $6haLy.default).breadcrumbsLabel)
    }, /*#__PURE__*/ $8P7DW.createElement((0, $6RJZN.default), {
        to: (0, $jsmb9.getHelpCenterUrl)(),
        name: !isCSM ? sharedPortalName : intl.formatMessage((0, $6haLy.default).breadcrumbsHome),
        isFirstCrumb: true,
        actionSubjectId: "helpCenterBreadcrumb"
    }, !isCSM && portalId !== undefined && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    /*#__PURE__*/ $8P7DW.createElement((0, $6RJZN.default), {
        to: `/portal/${portalId}`,
        name: portalName,
        actionSubjectId: "portalBreadcrumb"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $6RJZN.default), {
        to: requestUrl || '',
        name: requestKey,
        actionSubjectId: "requestBreadcrumb",
        testId: "requestKey"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $6RJZN.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        to: `/portal/${portalId}/group/-1`,
        name: requestCreateBreadcrumb,
        actionSubjectId: "requestCreateBreadcrumb"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $6RJZN.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/topic/${categoryId}`,
        name: categoryName,
        actionSubjectId: "categoryBreadcrumb"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $6RJZN.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/topic/${categoryId}/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    })), /*#__PURE__*/ $8P7DW.createElement((0, $6RJZN.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    })), /*#__PURE__*/ $8P7DW.createElement((0, $6RJZN.default), {
        to: `/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    }), additionalBreadCrumbs === null || additionalBreadCrumbs === void 0 ? void 0 : additionalBreadCrumbs.map((breadCrumb)=>breadCrumb)));
};
var $bcbd39b57f823a99$export$2e2bcd8739ae039 = (0, $l4a5B.default)($bcbd39b57f823a99$export$a1a3354a8b2c8731);

});
parcelRegister("6RJZN", function(module, exports) {
$parcel$export(module.exports, "default", () => $f22339677c9c6aa0$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $4QM8d = parcelRequire("4QM8d");

var $cS6Xr = parcelRequire("cS6Xr");

var $fj3fY = parcelRequire("fj3fY");

var $kBzhX = parcelRequire("kBzhX");

var $04X5p = parcelRequire("04X5p");

var $1EFS8 = parcelRequire("1EFS8");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $c7dQO = parcelRequire("c7dQO");
/**
 * This is a nestable bread crumb component, it will render the first component with a valid name.
 * It itself will also not render if the name is not valid.
 */ const $f22339677c9c6aa0$var$BreadCrumbDumb = ({ name: name, to: to, children: children, isFirstCrumb: isFirstCrumb, actionSubjectId: actionSubjectId, testId: testId, tabIndex: tabIndex, onClick: onClick, disableTheme: disableTheme = false })=>{
    const isCSMTypographyMigrationEnabled = (0, $c7dQO.useIsCSMTypographyMigrationEnabled)();
    if (!name) return null;
    let child;
    $8P7DW.Children.forEach(children, (element)=>{
        // Short circuit if there is already a match
        if (child) return;
        if (element && /*#__PURE__*/ $8P7DW.isValidElement(element)) {
            const { name: childName } = element.props;
            if (childName) child = element;
        }
    });
    let linkComponent;
    if (to.startsWith('/')) {
        let RootLinkComponent = disableTheme ? $f22339677c9c6aa0$var$RootLinkDisabledTheme : $f22339677c9c6aa0$var$RootLink;
        if (isCSMTypographyMigrationEnabled) RootLinkComponent = disableTheme ? $f22339677c9c6aa0$var$RootLinkDisabledTheme : $f22339677c9c6aa0$var$RootLinkWithToken;
        linkComponent = /*#__PURE__*/ $8P7DW.createElement(RootLinkComponent, {
            to: to,
            actionSubjectId: actionSubjectId,
            "data-test-id": testId,
            "aria-current": child ? 'false' : 'page',
            tabIndex: tabIndex,
            onClick: onClick
        }, name);
    } else {
        let ExternalLinkComponent = disableTheme ? $f22339677c9c6aa0$var$ExternalLinkDisabledTheme : $f22339677c9c6aa0$var$ExternalLink;
        if (isCSMTypographyMigrationEnabled) ExternalLinkComponent = disableTheme ? $f22339677c9c6aa0$var$ExternalLinkDisabledTheme : $f22339677c9c6aa0$var$ExternalLinkWithToken;
        const externalLinkProps = {
            tabIndex: tabIndex,
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            href: to,
            'data-test-id': testId
        };
        if ((0, $1EFS8.default).checkGate('add-aria-current-to-breadcrumbs')) externalLinkProps['aria-current'] = child ? false : 'page';
        linkComponent = /*#__PURE__*/ $8P7DW.createElement(ExternalLinkComponent, externalLinkProps, name);
    }
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        as: 'li',
        xcss: [
            $f22339677c9c6aa0$var$breadCrumbContainer,
            isFirstCrumb ? undefined : $f22339677c9c6aa0$var$breadCrumbSeparator
        ]
    }, linkComponent), child);
};
var $f22339677c9c6aa0$export$2e2bcd8739ae039 = $f22339677c9c6aa0$var$BreadCrumbDumb;
const $f22339677c9c6aa0$var$breadCrumbContainer = (0, $37U6z.xcss)({
    display: 'flex',
    listStyle: 'none',
    alignItems: 'center',
    margin: 'space.0'
});
const $f22339677c9c6aa0$var$breadCrumbSeparator = (0, $37U6z.xcss)({
    '::before': {
        width: '8px',
        flexShrink: 0,
        content: '"/"',
        paddingBlock: 'space.0',
        paddingInline: 'space.075',
        textAlign: 'center',
        lineHeight: '1.5em',
        color: 'color.text'
    }
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f22339677c9c6aa0$var$RootLink = /*#__PURE__*/ (0, $2UsNA.default)((0, $04X5p.default)).withConfig({
    componentId: "sc-1t2enhc-0"
})`${$kBzhX.h200};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f22339677c9c6aa0$var$RootLinkWithToken = /*#__PURE__*/ (0, $2UsNA.default)((0, $04X5p.default)).withConfig({
    componentId: "sc-1t2enhc-1"
})`font:${"var(--ds-font-body, normal 400 0.875rem/1.25rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f22339677c9c6aa0$var$ExternalLink = /*#__PURE__*/ (0, $2UsNA.default)((0, $fj3fY.default)).withConfig({
    componentId: "sc-1t2enhc-2"
})`${$kBzhX.h200};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f22339677c9c6aa0$var$ExternalLinkWithToken = /*#__PURE__*/ (0, $2UsNA.default)((0, $fj3fY.default)).withConfig({
    componentId: "sc-1t2enhc-3"
})`font:${"var(--ds-font-body, normal 400 0.875rem/1.25rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $f22339677c9c6aa0$var$RootLinkDisabledTheme = /*#__PURE__*/ (0, $2UsNA.default)((0, $cS6Xr.Link)).withConfig({
    componentId: "sc-1t2enhc-4"
})`margin:0;color:unset !important;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $f22339677c9c6aa0$var$ExternalLinkDisabledTheme = /*#__PURE__*/ (0, $2UsNA.default)((0, $4QM8d.HtmlAnchor)).withConfig({
    componentId: "sc-1t2enhc-5"
})`margin:0;color:unset !important;`;

});
parcelRegister("fj3fY", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0eced5cda59dab2$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $4QM8d = parcelRequire("4QM8d");
const $b0eced5cda59dab2$export$1d567c320f4763bc = /*#__PURE__*/ (0, $2UsNA.css)`color:${(props)=>`var(--ds-link, ${props.theme.color})`};&:hover{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b0eced5cda59dab2$var$ExternalThemedLink = /*#__PURE__*/ (0, $2UsNA.default)((0, $4QM8d.HtmlAnchor)).withConfig({
    componentId: "sc-ckmeb1-0"
})`${$b0eced5cda59dab2$export$1d567c320f4763bc};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$b0eced5cda59dab2$export$2e2bcd8739ae039 = $b0eced5cda59dab2$var$ExternalThemedLink;

});


parcelRegister("iycTY", function(module, exports) {
$parcel$export(module.exports, "default", () => $e97ba97d5cdb66cc$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $aeYmt = parcelRequire("aeYmt");

var $klxUK = parcelRequire("klxUK");

var $5J6r2 = parcelRequire("5J6r2");

var $67QJj = parcelRequire("67QJj");

var $eeCED = parcelRequire("eeCED");
const $e97ba97d5cdb66cc$var$defaultMaxItems = 8;
const $e97ba97d5cdb66cc$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $e97ba97d5cdb66cc$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $e97ba97d5cdb66cc$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children;
const $e97ba97d5cdb66cc$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: undefined,
    packageVersion: undefined
};
const $e97ba97d5cdb66cc$var$noop = (0, $5J6r2.default);
const $e97ba97d5cdb66cc$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $e97ba97d5cdb66cc$var$breadcrumbStyles = null;
const $e97ba97d5cdb66cc$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $e97ba97d5cdb66cc$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $e97ba97d5cdb66cc$var$noop, analyticsContext: analyticsContext, label: label = $e97ba97d5cdb66cc$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $e97ba97d5cdb66cc$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $8P7DW.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $8P7DW.useState)(false);
    const wrapperRef = (0, $8P7DW.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $e97ba97d5cdb66cc$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $8P7DW.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($e97ba97d5cdb66cc$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $eeCED.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$e97ba97d5cdb66cc$var$analyticsAttributes
    });
    const childrenArray = $e97ba97d5cdb66cc$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $67QJj.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $gWgPx.jsx)("nav", {
        "aria-label": label,
        ref: (0, $klxUK.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("ol", {
            "data-testid": testId,
            className: (0, $8n1kL.default)([
                "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $e97ba97d5cdb66cc$var$Breadcrumbs = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $gWgPx.jsx)($e97ba97d5cdb66cc$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    })));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e97ba97d5cdb66cc$export$2e2bcd8739ae039 = $e97ba97d5cdb66cc$var$Breadcrumbs;

});
parcelRegister("67QJj", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc5d1af7ab5189fa$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $5J6r2 = parcelRequire("5J6r2");

var $bgvtM = parcelRequire("bgvtM");
const $cc5d1af7ab5189fa$var$noop = (0, $5J6r2.default);
const $cc5d1af7ab5189fa$var$itemWrapperStyles = null;
const $cc5d1af7ab5189fa$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo"
};
const $cc5d1af7ab5189fa$var$EllipsisItem = /*#__PURE__*/ (0, $8P7DW.memo)(({ label: label, onClick: onClick = $cc5d1af7ab5189fa$var$noop, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)("li", {
        className: (0, $8n1kL.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bgvtM.default), {
            "aria-label": label,
            onClick: onClick,
            xcss: $cc5d1af7ab5189fa$var$styles.root,
            testId: testId,
            children: "\u2026"
        })
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cc5d1af7ab5189fa$export$2e2bcd8739ae039 = $cc5d1af7ab5189fa$var$EllipsisItem;

});

parcelRegister("eeCED", function(module, exports) {
$parcel$export(module.exports, "useOnRevealed", () => $0168812ab10ae825$export$e9c4922b2ecf808a);

var $8P7DW = parcelRequire("8P7DW");

var $fmYz8 = parcelRequire("fmYz8");
function $0168812ab10ae825$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $fmYz8.default)(isExpanded);
    (0, $8P7DW.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("6haLy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c763e64de9104ead$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $c763e64de9104ead$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    breadcrumbsLabel: {
        id: 'cv.portal.breadcrumbs.container',
        defaultMessage: 'Breadcrumbs'
    },
    raiseRequestBreadcrumb: {
        defaultMessage: 'Raise a request',
        description: 'Breadcrumb item to go to select a request group of a portal',
        id: 'cv.portal.breadcrumbs.raise.request'
    },
    breadcrumbsHome: {
        defaultMessage: 'Home',
        description: 'Generic label for the first entry of the breadcrumbs for Service hub',
        id: 'cv.portal.breadcrumbs.home'
    }
});

});





parcelRegister("gVqTI", function(module, exports) {
$parcel$export(module.exports, "IconContainer", () => $513aa0946849c89f$export$8f314e512d92575f);
$parcel$export(module.exports, "SubHeadingContainer", () => $513aa0946849c89f$export$c8db0106bd269e8c);
$parcel$export(module.exports, "SubHeading", () => $513aa0946849c89f$export$210dc657affc8afd);
$parcel$export(module.exports, "Description", () => $513aa0946849c89f$export$393edc798c47379d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $1p41U = parcelRequire("1p41U");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");
const $513aa0946849c89f$var$ICON_SIZE_MOBILE = $4cxV2.multiple(4.5).unitless;
const $513aa0946849c89f$var$ICON_SIZE_DESKTOP = $4cxV2.multiple(6.25).unitless;
const $513aa0946849c89f$var$MARGIN_RIGHT = "var(--ds-space-200, 16px)";
const $513aa0946849c89f$var$SUBHEADING_MARGIN_TOP_MOBILE = "var(--ds-space-200, 16px)";
const $513aa0946849c89f$var$SUBHEADING_MARGIN_TOP_DESKTOP = "var(--ds-space-100, 8px)";
const $513aa0946849c89f$var$DESCRIPTION_MARGIN_TOP_MOBILE = "var(--ds-space-100, 8px)";
const $513aa0946849c89f$export$8f314e512d92575f = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-69w8vc-0"
})`${$6t2I3.flexCenter};height:${$513aa0946849c89f$var$ICON_SIZE_MOBILE}px;width:${$513aa0946849c89f$var$ICON_SIZE_MOBILE}px;margin-right:${$513aa0946849c89f$var$MARGIN_RIGHT};flex-shrink:0;${$1p41U.fromXSmall.css`
        height: ${$513aa0946849c89f$var$ICON_SIZE_DESKTOP}px;
        width: ${$513aa0946849c89f$var$ICON_SIZE_DESKTOP}px;
    `};`;
const $513aa0946849c89f$export$c8db0106bd269e8c = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-69w8vc-1"
})`display:flex;justify-content:flex-start;align-items:center;margin-top:${$513aa0946849c89f$var$SUBHEADING_MARGIN_TOP_MOBILE};${$1p41U.fromXSmall.css`
        margin-top: ${$513aa0946849c89f$var$SUBHEADING_MARGIN_TOP_DESKTOP};
    `};`;
const $513aa0946849c89f$export$210dc657affc8afd = /*#__PURE__*/ (0, $2UsNA.default).h1.withConfig({
    componentId: "sc-69w8vc-2"
})`${$kBzhX.h700};${$6t2I3.breakWord};margin:0;`;
const $513aa0946849c89f$export$393edc798c47379d = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-69w8vc-3"
})`display:block;color:${"var(--ds-text, #172B4D)"};margin-top:${$513aa0946849c89f$var$DESCRIPTION_MARGIN_TOP_MOBILE};width:100%;`;

});



parcelRegister("aFamU", function(module, exports) {
$parcel$export(module.exports, "ArticleList", () => (parcelRequire("km9xC")).default);

var $km9xC = parcelRequire("km9xC");

});
parcelRegister("km9xC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d1fffae913ae215$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");

var $04X5p = parcelRequire("04X5p");

var $l4cjO = parcelRequire("l4cjO");
parcelRequire("dwWBt");
var $i7w4f = parcelRequire("i7w4f");
parcelRequire("72LHL");
var $4Em1B = parcelRequire("4Em1B");
parcelRequire("cMJuC");
var $bJxQf = parcelRequire("bJxQf");

var $8gu7I = parcelRequire("8gu7I");

var $aQXm8 = parcelRequire("aQXm8");
parcelRequire("lmghH");
var $5tn6a = parcelRequire("5tn6a");

var $5Zgyz = parcelRequire("5Zgyz");
const $7d1fffae913ae215$export$cf74bb99f97bf995 = (portalId, categoryId, articles, opts)=>{
    return /*#__PURE__*/ $8P7DW.createElement("section", null, opts.showHeading && /*#__PURE__*/ $8P7DW.createElement($7d1fffae913ae215$export$72d7ca7a5d1d4807, null, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), opts.isFeatured ? (0, $5Zgyz.default).featuredArticlesHeading : (0, $5Zgyz.default).moreArticlesHeading)), /*#__PURE__*/ $8P7DW.createElement($7d1fffae913ae215$export$9d0ad9ba52d8bb58, null, articles.map((article)=>{
        const { title: title, summaryExcerpt: summaryExcerpt, id: articleId } = article;
        return /*#__PURE__*/ $8P7DW.createElement((0, $5tn6a.default), {
            portalId: portalId,
            categoryId: categoryId,
            articleId: articleId,
            key: articleId,
            title: title,
            summaryExcerpt: summaryExcerpt,
            isFeatured: opts.isFeatured
        });
    })));
};
/**
 * ArticleList comes with forced top margin because of the featured vs. non featured articles
 * groupings. Take this into consideration when using in places no under knowledge category page.
 */ const $7d1fffae913ae215$var$ArticleList = ({ articles: articles, portalName: portalName, portalId: portalId, portalLink: portalLink, categoryId: categoryId, showRequestCreateButton: showRequestCreateButton, isLoading: isLoading })=>{
    const featuredArticles = articles ? articles.filter((article)=>article.isFeatured) : [];
    const regularArticles = articles ? articles.filter((article)=>!article.isFeatured) : [];
    const hasRegularArticles = regularArticles.length > 0;
    const hasFeaturedArticles = featuredArticles.length > 0;
    const hasAnyArticles = hasRegularArticles || hasFeaturedArticles;
    const containerHasExtraMargin = hasRegularArticles && hasFeaturedArticles || !hasAnyArticles;
    return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
        data: {
            attributes: {
                numberOfArticles: articles && articles.length
            }
        }
    }, /*#__PURE__*/ $8P7DW.createElement($7d1fffae913ae215$export$79927783e7566f41, {
        marginTop: containerHasExtraMargin
    }, /*#__PURE__*/ $8P7DW.createElement((0, $4Em1B.default), {
        isLoading: isLoading,
        loadingPosition: "fill-container"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $aQXm8.FireScreenEventOnMount), null), hasFeaturedArticles && $7d1fffae913ae215$export$cf74bb99f97bf995(portalId, categoryId, featuredArticles, {
        isFeatured: true,
        showHeading: hasRegularArticles
    }), hasRegularArticles && $7d1fffae913ae215$export$cf74bb99f97bf995(portalId, categoryId, regularArticles, {
        isFeatured: false,
        showHeading: hasFeaturedArticles
    }), !hasAnyArticles && /*#__PURE__*/ $8P7DW.createElement($7d1fffae913ae215$export$aff2890a94825ec8, null, /*#__PURE__*/ $8P7DW.createElement($7d1fffae913ae215$export$4ba49fb37bbab46d, null, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $5Zgyz.default).articlesEmptyStateText)), /*#__PURE__*/ $8P7DW.createElement((0, $04X5p.default), {
        to: `/portal/${portalId}`,
        actionSubjectId: "backToPortal"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), {
        ...(0, $5Zgyz.default).categoriesEmptyStateLink,
        values: {
            portalName: portalName
        }
    }))), showRequestCreateButton && /*#__PURE__*/ $8P7DW.createElement((0, $bJxQf.default), {
        to: portalLink
    }))));
};
var $7d1fffae913ae215$export$2e2bcd8739ae039 = $7d1fffae913ae215$var$ArticleList;
const $7d1fffae913ae215$export$4ba49fb37bbab46d = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1ejyd2g-0"
})`${$kBzhX.regular};margin-bottom:${"var(--ds-space-100, 8px)"};`;
const $7d1fffae913ae215$export$9d0ad9ba52d8bb58 = /*#__PURE__*/ (0, $2UsNA.default).ol.withConfig({
    componentId: "sc-1ejyd2g-1"
})`margin:0 -${(0, $i7w4f.GROUP_BOX_PADDING_LEFT_RIGHT)};padding:0;`;
const $7d1fffae913ae215$export$72d7ca7a5d1d4807 = /*#__PURE__*/ (0, $2UsNA.default).h2.withConfig({
    componentId: "sc-1ejyd2g-2"
})`${$kBzhX.h500};`;
const $7d1fffae913ae215$export$79927783e7566f41 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1ejyd2g-3"
})`margin-top:${(props)=>props.marginTop ? "var(--ds-space-200, 16px)" : 0};> *{margin-top:${"var(--ds-space-200, 16px)"};}`;
const $7d1fffae913ae215$export$aff2890a94825ec8 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1ejyd2g-4"
})`margin-bottom:${"var(--ds-space-500, 40px)"};`;

});
parcelRegister("dwWBt", function(module, exports) {
$parcel$export(module.exports, "GroupBox", () => (parcelRequire("XW6Mk")).default);
$parcel$export(module.exports, "GroupBoxLink", () => (parcelRequire("i7ZEn")).default);
$parcel$export(module.exports, "GROUP_BOX_PADDING_LEFT_RIGHT", () => (parcelRequire("i7w4f")).GROUP_BOX_PADDING_LEFT_RIGHT);
$parcel$export(module.exports, "GROUP_BOX_PADDING_TOP_BOTTOM", () => (parcelRequire("i7w4f")).GROUP_BOX_PADDING_TOP_BOTTOM);

var $XW6Mk = parcelRequire("XW6Mk");
parcelRequire("3AWxl");
var $i7ZEn = parcelRequire("i7ZEn");

var $i7w4f = parcelRequire("i7w4f");

});
parcelRegister("XW6Mk", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad77da5efd355e85$export$2e2bcd8739ae039);
/* group-box.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $kFYzS = parcelRequire("kFYzS");

var $iqJis = parcelRequire("iqJis");

var $i7w4f = parcelRequire("i7w4f");
const $ad77da5efd355e85$var$GroupBox = ({ heading: heading, description: description, icon: icon, editRequestTypeOnRequestList: editRequestTypeOnRequestList, headingAs: headingAs = 'h3', isAriaHidden: isAriaHidden = false, lineClamp: lineClamp = 0, ...props })=>{
    const showEditRequestButton = !!editRequestTypeOnRequestList;
    const ariaHidden = isAriaHidden ? undefined : true;
    const content = showEditRequestButton ? /*#__PURE__*/ $8P7DW.createElement("div", {
        className: (0, $8n1kL.default)([
            "_kqswh2mm"
        ])
    }, heading && /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
        size: "xsmall",
        as: headingAs
    }, /*#__PURE__*/ $8P7DW.createElement((0, $i7w4f.HeadingContent), {
        lineClamp: !!lineClamp
    }, heading)), /*#__PURE__*/ $8P7DW.createElement((0, $i7w4f.Description), {
        "aria-hidden": ariaHidden,
        lineClamp: lineClamp
    }, description), /*#__PURE__*/ $8P7DW.createElement("div", {
        "data-edit-overlay": "true",
        className: (0, $8n1kL.default)([
            "_kqswstnw _1xi2ze3t _154ize3t _tzy4idpf"
        ])
    }, editRequestTypeOnRequestList)) : /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, heading && /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
        size: "xsmall",
        as: headingAs
    }, /*#__PURE__*/ $8P7DW.createElement((0, $i7w4f.HeadingContent), {
        lineClamp: !!lineClamp
    }, heading)), /*#__PURE__*/ $8P7DW.createElement((0, $i7w4f.Description), {
        "aria-hidden": ariaHidden,
        lineClamp: lineClamp
    }, description));
    return /*#__PURE__*/ $8P7DW.createElement((0, $i7w4f.StyledIconCardLayout), {
        ...props,
        leftIcon: icon && /*#__PURE__*/ ($8P7DW.isValidElement(icon) ? icon : /*#__PURE__*/ $8P7DW.createElement((0, $kFYzS.default), {
            src: icon,
            alt: ""
        })),
        content: content
    });
};
const $ad77da5efd355e85$var$GroupBoxWithAdditionalButtonLayout = null;
const $ad77da5efd355e85$var$OverlayButtonLayout = null;
var $ad77da5efd355e85$export$2e2bcd8739ae039 = $ad77da5efd355e85$var$GroupBox;

});
parcelRegister("i7w4f", function(module, exports) {
$parcel$export(module.exports, "GROUP_BOX_PADDING_LEFT_RIGHT", () => $a4c82fcc53aadcdf$export$5ff888af59e97bf4);
$parcel$export(module.exports, "GROUP_BOX_PADDING_TOP_BOTTOM", () => $a4c82fcc53aadcdf$export$2968d5852daac253);
$parcel$export(module.exports, "StyledIconCardLayout", () => $a4c82fcc53aadcdf$export$66f468dd3258e073);
$parcel$export(module.exports, "HeadingContent", () => $a4c82fcc53aadcdf$export$5cb6fad052f5d74e);
$parcel$export(module.exports, "Description", () => $a4c82fcc53aadcdf$export$393edc798c47379d);
$parcel$export(module.exports, "StyledLink", () => $a4c82fcc53aadcdf$export$9048d548939551ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $cS6Xr = parcelRequire("cS6Xr");

var $kBzhX = parcelRequire("kBzhX");

var $6t2I3 = parcelRequire("6t2I3");
parcelRequire("kwIPj");
var $2lkCs = parcelRequire("2lkCs");
const $a4c82fcc53aadcdf$var$GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT = "var(--ds-space-200, 16px)";
const $a4c82fcc53aadcdf$export$5ff888af59e97bf4 = "var(--ds-space-300, 24px)";
const $a4c82fcc53aadcdf$export$2968d5852daac253 = "var(--ds-space-300, 24px)";
const $a4c82fcc53aadcdf$export$66f468dd3258e073 = /*#__PURE__*/ (0, $2UsNA.default)((0, $2lkCs.default)).withConfig({
    componentId: "sc-1p6gmq3-0"
})`padding:${$a4c82fcc53aadcdf$export$2968d5852daac253} ${(props)=>props.containerPadding === 'tight' ? $a4c82fcc53aadcdf$var$GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT : $a4c82fcc53aadcdf$export$5ff888af59e97bf4};`;
const $a4c82fcc53aadcdf$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1p6gmq3-1"
})`${$kBzhX.h400};${(props)=>$6t2I3.applyIf(props.lineClamp, $6t2I3.clamp)};color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};margin:0;`;
const $a4c82fcc53aadcdf$export$5cb6fad052f5d74e = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1p6gmq3-2"
})`${(props)=>$6t2I3.applyIf(props.lineClamp, $6t2I3.clamp)};color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};margin:0;`;
const $a4c82fcc53aadcdf$export$393edc798c47379d = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1p6gmq3-3"
})`${(props)=>$6t2I3.applyIf(props.lineClamp > 0, /*
    We use multiline clamp so we avoid descriptions that have multi paragraphs looking like this:
    Clamped...
    Clamped...
    Clamped...
*/ $6t2I3.multiLineClamp(props.lineClamp))};color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-050, 4px)"};`;
const $a4c82fcc53aadcdf$export$9048d548939551ee = /*#__PURE__*/ (0, $2UsNA.default)((0, $cS6Xr.Link)).withConfig({
    componentId: "sc-1p6gmq3-4"
})`${$6t2I3.borderRadius};display:block;background-color:${(props)=>props.selected ? "var(--ds-surface-raised, #F4F5F7)" : 'inherit'};&:hover,&:focus-visible{text-decoration:none;background-color:${"var(--ds-surface-raised-hovered, #F4F5F7)"};}&:hover [data-edit-overlay]{opacity:1;}&:focus{text-decoration:none;}`;

});
parcelRegister("kwIPj", function(module, exports) {
$parcel$export(module.exports, "IconCardLayout", () => (parcelRequire("2lkCs")).default);

var $2lkCs = parcelRequire("2lkCs");

});
parcelRegister("2lkCs", function(module, exports) {
$parcel$export(module.exports, "default", () => $c652b7b24ede48ab$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $1We2B = parcelRequire("1We2B");
const $c652b7b24ede48ab$var$DEFAULT_RESULT_PADDING = "var(--ds-space-200, 16px)";
const $c652b7b24ede48ab$var$DEFAULT_ICON_SIZE = "var(--ds-space-400, 32px)";
const $c652b7b24ede48ab$var$DEFAULT_ICON_MARGIN = "var(--ds-space-200, 16px)";
const $c652b7b24ede48ab$var$getSpaceValueWithDefault = (defaultSpacing, value, customSpacing)=>{
    if (!(0, $1We2B.isNil)(value)) return `${value}px`;
    return customSpacing || defaultSpacing;
};
const $c652b7b24ede48ab$var$IconCardLayout = ({ leftIcon: leftIcon, rightIcon: rightIcon, content: content, iconSize: iconSize, iconMargin: iconMargin, padding: padding, alignItems: alignItems, className: className, centerAlignLeftIcon: centerAlignLeftIcon, centerAlignRightIcon: centerAlignRightIcon, dataTestId: dataTestId, customStyling: customStyling })=>{
    const { iconSize: customIconSize, iconMargin: customIconMargin, padding: customPadding } = customStyling || {};
    const iconSizeWithDefault = $c652b7b24ede48ab$var$getSpaceValueWithDefault($c652b7b24ede48ab$var$DEFAULT_ICON_SIZE, iconSize, customIconSize);
    const iconMarginWithDefault = $c652b7b24ede48ab$var$getSpaceValueWithDefault($c652b7b24ede48ab$var$DEFAULT_ICON_MARGIN, iconMargin, customIconMargin);
    const paddingWithDefault = $c652b7b24ede48ab$var$getSpaceValueWithDefault($c652b7b24ede48ab$var$DEFAULT_RESULT_PADDING, padding, customPadding);
    return /*#__PURE__*/ $8P7DW.createElement($c652b7b24ede48ab$var$ResultContainer, {
        "data-test-id": dataTestId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        padding: paddingWithDefault,
        align: alignItems || 'center'
    }, leftIcon && /*#__PURE__*/ $8P7DW.createElement($c652b7b24ede48ab$var$IconContainer, {
        iconMargin: iconMarginWithDefault,
        iconSize: iconSizeWithDefault,
        isCenterAlignIcon: centerAlignLeftIcon
    }, leftIcon), /*#__PURE__*/ $8P7DW.createElement($c652b7b24ede48ab$var$ResultContentContainer, null, content), rightIcon && /*#__PURE__*/ $8P7DW.createElement($c652b7b24ede48ab$var$IconContainer, {
        iconMargin: $c652b7b24ede48ab$var$DEFAULT_ICON_MARGIN,
        iconSize: iconSizeWithDefault,
        isCenterAlignIcon: centerAlignRightIcon,
        right: true
    }, rightIcon));
};
var $c652b7b24ede48ab$export$2e2bcd8739ae039 = $c652b7b24ede48ab$var$IconCardLayout;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c652b7b24ede48ab$var$ResultContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-fn7rhf-0"
})`display:flex;width:100%;box-sizing:border-box;align-items:${(props)=>props.align};padding:0 ${(props)=>props.padding};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c652b7b24ede48ab$var$IconContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-fn7rhf-1"
})`display:flex;align-items:center;justify-content:center;width:${(props)=>props.iconSize};align-self:flex-start;margin-top:${"var(--ds-space-050, 4px)"};flex-shrink:0;${(props)=>props.isCenterAlignIcon && `margin: auto`};${(props)=>props.right ? `margin-left: ${props.iconMargin}` : `margin-right: ${props.iconMargin}`};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c652b7b24ede48ab$var$ResultContentContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-fn7rhf-2"
})`width:100%;`;

});




parcelRegister("3AWxl", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("i7ZEn")).default);

var $i7ZEn = parcelRequire("i7ZEn");

});
parcelRegister("i7ZEn", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ec85586dcf72be1$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("lt2dp");
var $8tYIv = parcelRequire("8tYIv");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $6GNhI = parcelRequire("6GNhI");

var $XW6Mk = parcelRequire("XW6Mk");

var $i7w4f = parcelRequire("i7w4f");
const $0ec85586dcf72be1$var$isExternalLink = (target)=>{
    return target instanceof HTMLElement && target.className.includes('external-link');
};
const $0ec85586dcf72be1$var$handleExternalLink = (e)=>{
    e.preventDefault();
    (0, $6GNhI.open)(e.target.toString(), '_blank');
};
const $0ec85586dcf72be1$var$GroupBoxLink = ({ className: className, selected: selected, onClick: onClick, target: target, dataTestId: dataTestId, actionSubjectId: actionSubjectId, ...rest })=>{
    const [isPageInEditMode] = (0, $8tYIv.useIsPageInEditMode)();
    const tabIndex = isPageInEditMode ? -1 : undefined;
    const handleClick = $8P7DW.useCallback((e)=>{
        if (isPageInEditMode) return;
        if ($0ec85586dcf72be1$var$isExternalLink(e.target)) {
            $0ec85586dcf72be1$var$handleExternalLink(e);
            return;
        }
        onClick === null || onClick === void 0 || onClick();
    }, [
        isPageInEditMode,
        onClick
    ]);
    if ('to' in rest) {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // oxlint-disable-next-line no-shadow
        const { to: to, editRequestTypeOnRequestList: editRequestTypeOnRequestList, ...forGroupBox } = rest;
        const showEditRequestTypeButton = !isPageInEditMode && !!editRequestTypeOnRequestList;
        const contentWithTo = showEditRequestTypeButton ? /*#__PURE__*/ $8P7DW.createElement((0, $i7w4f.StyledLink), {
            selected: !!selected,
            to: to,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: handleClick,
            target: target,
            actionSubjectId: actionSubjectId,
            "data-test-id": dataTestId
        }, /*#__PURE__*/ $8P7DW.createElement((0, $XW6Mk.default), {
            ...forGroupBox,
            editRequestTypeOnRequestList: editRequestTypeOnRequestList
        })) : /*#__PURE__*/ $8P7DW.createElement((0, $i7w4f.StyledLink), {
            selected: !!selected,
            to: to,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: handleClick,
            target: target,
            actionSubjectId: actionSubjectId,
            "data-test-id": dataTestId,
            tabIndex: tabIndex
        }, /*#__PURE__*/ $8P7DW.createElement((0, $XW6Mk.default), forGroupBox));
        return isPageInEditMode ? /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
            xcss: $0ec85586dcf72be1$var$disabledLink
        }, contentWithTo) : contentWithTo;
    }
    const { href: href, ...forGroupBox } = rest;
    const content = /*#__PURE__*/ $8P7DW.createElement((0, $i7w4f.StyledLink), {
        selected: !!selected,
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        onClick: handleClick,
        target: target,
        actionSubjectId: actionSubjectId,
        "data-test-id": dataTestId,
        tabIndex: tabIndex
    }, /*#__PURE__*/ $8P7DW.createElement((0, $XW6Mk.default), forGroupBox));
    return isPageInEditMode ? /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        xcss: $0ec85586dcf72be1$var$disabledLink
    }, content) : content;
};
const $0ec85586dcf72be1$var$disabledLink = (0, $37U6z.xcss)({
    pointerEvents: 'none'
});
var $0ec85586dcf72be1$export$2e2bcd8739ae039 = $0ec85586dcf72be1$var$GroupBoxLink;

});



parcelRegister("cMJuC", function(module, exports) {
$parcel$export(module.exports, "RaiseRequestLink", () => (parcelRequire("bJxQf")).default);

var $bJxQf = parcelRequire("bJxQf");

});
parcelRegister("bJxQf", function(module, exports) {
$parcel$export(module.exports, "default", () => $494fc3516d62187b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $l4cjO = parcelRequire("l4cjO");
parcelRequire("jiDCA");
var $e4qkL = parcelRequire("e4qkL");
parcelRequire("dwWBt");
var $i7w4f = parcelRequire("i7w4f");

var $b0vs4 = parcelRequire("b0vs4");
const $494fc3516d62187b$var$RaiseRequestLink = ({ to: to, isEmbeddedRoute: isEmbeddedRoute, ...props })=>/*#__PURE__*/ $8P7DW.createElement((0, $e4qkL.default), {
        to: to,
        padding: 0,
        actionSubjectId: "requestCreateLink",
        target: isEmbeddedRoute ? '_blank' : undefined,
        ...props
    }, /*#__PURE__*/ $8P7DW.createElement($494fc3516d62187b$var$MessageContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $b0vs4.default).raiseRequestText)));
var $494fc3516d62187b$export$2e2bcd8739ae039 = $494fc3516d62187b$var$RaiseRequestLink;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $494fc3516d62187b$var$MessageContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-r621zd-0"
})`padding:${(0, $i7w4f.GROUP_BOX_PADDING_TOP_BOTTOM)} ${(0, $i7w4f.GROUP_BOX_PADDING_LEFT_RIGHT)};`;

});
parcelRegister("jiDCA", function(module, exports) {
$parcel$export(module.exports, "CardLink", () => (parcelRequire("e4qkL")).default);

var $e4qkL = parcelRequire("e4qkL");

});
parcelRegister("e4qkL", function(module, exports) {
$parcel$export(module.exports, "default", () => $cba9215a85bdca9d$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("lt2dp");
var $8tYIv = parcelRequire("8tYIv");

var $gKlvt = parcelRequire("gKlvt");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $gRASy = parcelRequire("gRASy");
const $cba9215a85bdca9d$var$CardLink = ({ children: children, to: to, padding: padding, className: className, appearance: appearance, actionSubjectId: actionSubjectId, dataTestId: dataTestId, target: target, onClick: onClick })=>{
    const [isPageInEditMode] = (0, $8tYIv.useIsPageInEditMode)();
    const handleClick = $8P7DW.useCallback(()=>{
        if (isPageInEditMode) return;
        onClick === null || onClick === void 0 || onClick();
    }, [
        isPageInEditMode,
        onClick
    ]);
    const content = /*#__PURE__*/ $8P7DW.createElement((0, $gRASy.Card), {
        to: to,
        padding: padding,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        appearance: appearance,
        actionSubjectId: actionSubjectId,
        "data-test-id": dataTestId,
        target: target,
        onClick: handleClick,
        tabIndex: isPageInEditMode ? -1 : undefined
    }, /*#__PURE__*/ $8P7DW.createElement((0, $gRASy.Container), null, children, /*#__PURE__*/ $8P7DW.createElement((0, $gRASy.IconContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKlvt))), {
        size: "small",
        spacing: "spacious",
        label: "",
        "aria-hidden": "true",
        color: "var(--ds-text, #172B4D)"
    }))));
    return isPageInEditMode ? /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        xcss: $cba9215a85bdca9d$var$disabledCard
    }, content) : content;
};
$cba9215a85bdca9d$var$CardLink.defaultProps = {
    appearance: 'gray'
};
const $cba9215a85bdca9d$var$disabledCard = (0, $37U6z.xcss)({
    pointerEvents: 'none'
});
var $cba9215a85bdca9d$export$2e2bcd8739ae039 = $cba9215a85bdca9d$var$CardLink;

});
parcelRegister("gKlvt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbc9eb298cfdac722b50cf5246108693>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3119ffcbbea6d9e$var$_react = $c3119ffcbbea6d9e$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $c3119ffcbbea6d9e$var$_baseNew = $c3119ffcbbea6d9e$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $c3119ffcbbea6d9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3119ffcbbea6d9e$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $c3119ffcbbea6d9e$var$_react.default.createElement($c3119ffcbbea6d9e$var$_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$c3119ffcbbea6d9e$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $c3119ffcbbea6d9e$var$_default = module.exports.default = $c3119ffcbbea6d9e$var$ChevronRightIcon;

});

parcelRegister("gRASy", function(module, exports) {
$parcel$export(module.exports, "Container", () => $8917ea194349392f$export$42a852a2b6b56249);
$parcel$export(module.exports, "IconContainer", () => $8917ea194349392f$export$8f314e512d92575f);
$parcel$export(module.exports, "Card", () => $8917ea194349392f$export$60332b2344f7fe41);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $6t2I3 = parcelRequire("6t2I3");
parcelRequire("4ybJd");
var $hY8o1 = parcelRequire("hY8o1");
const $8917ea194349392f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-15f4chr-0"
})`display:flex;align-items:center;justify-content:space-between;`;
const $8917ea194349392f$export$8f314e512d92575f = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-15f4chr-1"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $8917ea194349392f$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $2UsNA.default)((0, $hY8o1.LinkCard)).withConfig({
    componentId: "sc-15f4chr-2"
})`${$6t2I3.borderRadius};background:${(props)=>props.appearance === 'gray' ? "var(--ds-surface-raised, #FAFBFC)" : "var(--ds-surface-raised, #FFFFFF)"};padding:${(props)=>props.padding !== undefined ? `${props.padding}px` : "var(--ds-space-200, 16px)"};span{color:${"var(--ds-text, #172B4D)"};}&:hover{background:${(props)=>props.appearance === 'gray' ? "var(--ds-surface-raised-hovered, #FAFBFC)" : "var(--ds-surface-raised-hovered, #FFFFFF)"};}`;

});
parcelRegister("4ybJd", function(module, exports) {
$parcel$export(module.exports, "LinkCard", () => (parcelRequire("hY8o1")).LinkCard);

var $hY8o1 = parcelRequire("hY8o1");

});
parcelRegister("hY8o1", function(module, exports) {
$parcel$export(module.exports, "LinkCard", () => $648980b8cda6efb3$export$2c381a86421d5abf);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");

var $cS6Xr = parcelRequire("cS6Xr");

var $9yRgH = parcelRequire("9yRgH");

var $6t2I3 = parcelRequire("6t2I3");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $648980b8cda6efb3$var$linkCardBase = /*#__PURE__*/ (0, $2UsNA.css)`${$6t2I3.raiseUpOnHoverOrFocus((0, $9yRgH.newElevationsFromDesignSystems).e100, (0, $9yRgH.newElevationsFromDesignSystems).e200)};${$6t2I3.borderRadius};${$6t2I3.focusRing.default};display:block;background-color:${"var(--ds-surface-raised, #FFFFFF)"};:hover,:focus{text-decoration:none;}`;
const $648980b8cda6efb3$export$2c381a86421d5abf = /*#__PURE__*/ (0, $2UsNA.default)((0, $cS6Xr.Link)).withConfig({
    componentId: "sc-axlah-0"
})`${$648980b8cda6efb3$var$linkCardBase};`;

});





parcelRegister("b0vs4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffb10f1fb157fb17$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $ffb10f1fb157fb17$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    raiseRequestText: {
        defaultMessage: 'Need to raise a request? Contact us.',
        description: 'Card button text to raise request',
        id: 'sd.customerview.portal.card.button.text'
    }
});

});



parcelRegister("lmghH", function(module, exports) {
$parcel$export(module.exports, "ArticleListItem", () => (parcelRequire("5tn6a")).default);

var $5tn6a = parcelRequire("5tn6a");

});
parcelRegister("5tn6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $db30411ae1c82703$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $4cxV2 = parcelRequire("4cxV2");

var $6t2I3 = parcelRequire("6t2I3");
parcelRequire("dwWBt");
var $i7ZEn = parcelRequire("i7ZEn");

var $8gu7I = parcelRequire("8gu7I");

var $llRcE = parcelRequire("llRcE");
const $db30411ae1c82703$var$ArticleListItem = ({ portalId: portalId, categoryId: categoryId, articleId: articleId, title: title, summaryExcerpt: summaryExcerpt, onClick: onClick })=>{
    const articleUrl = `/portal/${portalId}/topic/${categoryId}/article/${articleId}`;
    const analyticData = {
        attributes: {
            articleId: articleId,
            portalId: portalId,
            categoryId: categoryId
        }
    };
    return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
        data: analyticData
    }, /*#__PURE__*/ $8P7DW.createElement($db30411ae1c82703$var$ListItem, null, /*#__PURE__*/ $8P7DW.createElement((0, $i7ZEn.default), {
        actionSubjectId: "article",
        to: articleUrl,
        onClick: onClick,
        heading: title,
        description: /*#__PURE__*/ $8P7DW.createElement($db30411ae1c82703$export$ef81c5adc5a715ed, {
            dangerouslySetInnerHTML: {
                __html: summaryExcerpt
            }
        }),
        icon: /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($llRcE))), {
            label: "",
            "aria-hidden": "true",
            size: "medium",
            color: "var(--ds-icon, #42526E)",
            spacing: "spacious"
        }),
        lineClamp: 2
    })));
};
var $db30411ae1c82703$export$2e2bcd8739ae039 = $db30411ae1c82703$var$ArticleListItem;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $db30411ae1c82703$var$ListItem = /*#__PURE__*/ (0, $2UsNA.default).li.withConfig({
    componentId: "sc-1u8m6l-0"
})`margin:0;list-style:none;`;
const $db30411ae1c82703$export$ef81c5adc5a715ed = /*#__PURE__*/ (0, $2UsNA.default).p.withConfig({
    componentId: "sc-1u8m6l-1"
})`${$6t2I3.multiLineClamp(2, $4cxV2.multiple(2.5).unitless)};margin:0;`;

});
parcelRegister("llRcE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::240d2a2d2ecd17e4d685f807cd1b54f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8b4d42c1f9bf14e$var$_react = $f8b4d42c1f9bf14e$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $f8b4d42c1f9bf14e$var$_baseNew = $f8b4d42c1f9bf14e$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $f8b4d42c1f9bf14e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8b4d42c1f9bf14e$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $f8b4d42c1f9bf14e$var$_react.default.createElement($f8b4d42c1f9bf14e$var$_baseNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$f8b4d42c1f9bf14e$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $f8b4d42c1f9bf14e$var$_default = module.exports.default = $f8b4d42c1f9bf14e$var$BookWithBookmarkIcon;

});



parcelRegister("5Zgyz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4222fc4e017b81b$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $b4222fc4e017b81b$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    featuredArticlesHeading: {
        defaultMessage: 'Featured articles',
        description: 'Heading for the featured articles section.',
        id: 'cv.categories.page.featured-articles.heading'
    },
    moreArticlesHeading: {
        defaultMessage: 'More articles',
        description: 'Heading for the featured articles section.',
        id: 'cv.categories.page.more-articles.heading'
    },
    articlesEmptyStateText: {
        defaultMessage: 'There are no articles in this category yet. Try another category, or raise a request below.',
        description: 'Articles empty state message',
        id: 'cv.categories.page.no.articles.message'
    },
    categoriesEmptyStateLink: {
        defaultMessage: 'Back to {portalName}',
        description: 'Articles empty state back link text',
        id: 'cv.categories.page.no.articles.back.link'
    }
});

});



parcelRegister("gmuFJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $630f31be78425238$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $630f31be78425238$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    categoryDocumentTitle: {
        defaultMessage: '{portalName} - {categoryName}',
        description: 'Document title for portal article topics page',
        id: 'cv.categories.page.title'
    }
});

});



parcelRegister("3z1nF", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("HmSN0").then(()=>parcelRequire('8nIaE'));

});

parcelRegister("9DavY", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("2nxgV").then(()=>parcelRequire('cUpn4'));

});


parcelRegister("cX0wo", function(module, exports) {
$parcel$export(module.exports, "loginRoute", () => $5a66f2cc159dc01f$export$798bfdbebc5ea68e);
$parcel$export(module.exports, "portalLoginRoute", () => $5a66f2cc159dc01f$export$e338715dbbd45865);

var $8rTkC = parcelRequire("8rTkC");
parcelRequire("e6BIw");
var $2u4W2 = parcelRequire("2u4W2");

var $1EFS8 = parcelRequire("1EFS8");

var $bpyxC = parcelRequire("bpyxC");

var $bXs4i = parcelRequire("bXs4i");

var $2VSOc = parcelRequire("2VSOc");
var $cuqN1 = parcelRequire("cuqN1");
const $5a66f2cc159dc01f$var$resources = (0, $1EFS8.default).checkGate('jsm_multi_helpcenter_login_ssr_improvements') ? [
    (0, $cuqN1.waitingBrandingResource),
    (0, $2VSOc.loginAnnouncementsCardResource)
] : [];
const $5a66f2cc159dc01f$var$portalLogin = {
    resources: $5a66f2cc159dc01f$var$resources,
    name: 'portal-login',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/login`,
    exact: true,
    component: (0, $2u4W2.default)
};
const $5a66f2cc159dc01f$var$login = {
    resources: $5a66f2cc159dc01f$var$resources,
    name: 'login',
    path: (0, $bXs4i.LOGIN_ROUTE),
    exact: true,
    component: (0, $2u4W2.default)
};
const $5a66f2cc159dc01f$var$screenName = (0, $8rTkC.ScreenName).LOGIN;
const $5a66f2cc159dc01f$var$layoutProps = (0, $1EFS8.default).checkGate('jsm_multi_helpcenter_login_ssr_improvements') ? {
    ...(0, $bXs4i.anonymousScreenLayout),
    prefetchBrandingModel: true
} : (0, $bXs4i.anonymousScreenLayout);
const $5a66f2cc159dc01f$export$798bfdbebc5ea68e = (0, $bpyxC.createRouteWithLayout)($5a66f2cc159dc01f$var$login, $5a66f2cc159dc01f$var$screenName, $5a66f2cc159dc01f$var$layoutProps);
const $5a66f2cc159dc01f$export$e338715dbbd45865 = (0, $bpyxC.createRouteWithLayout)($5a66f2cc159dc01f$var$portalLogin, $5a66f2cc159dc01f$var$screenName, $5a66f2cc159dc01f$var$layoutProps);

});
parcelRegister("e6BIw", function(module, exports) {
$parcel$export(module.exports, "Login", () => (parcelRequire("2u4W2")).default);

var $2u4W2 = parcelRequire("2u4W2");

});
parcelRegister("2u4W2", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d0857465625d188$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $hWt0u = parcelRequire("hWt0u");

var $2O4bV = parcelRequire("2O4bV");

var $dUoD8 = parcelRequire("dUoD8");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");
parcelRequire("6Fjys");
var $8ICBx = parcelRequire("8ICBx");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");
parcelRequire("eQhkf");
var $jtqro = parcelRequire("jtqro");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("35WUi");
var $7AYpn = parcelRequire("7AYpn");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $8Y9TA = parcelRequire("8Y9TA");
const $9d0857465625d188$var$selector = (0, $ehscL.createSelector)((state)=>(0, $ikoP4.getSharedPortalName)(state), (state)=>(0, $7AYpn.getLogin)(state), (state)=>(0, $7AYpn.getIsLoginLoaded)(state), (state)=>(0, $jtqro.getResetUrl)(state), (state)=>(0, $hx8zX.isLoggedIn)(state), (state)=>(0, $7AYpn.getLoginUIState)(state), (state)=>(0, $8Wisn.getIsAnonymousEnabled)(state), (helpCenterName, loginModel, loaded, resetUrl, isUserLoggedIn, loginUIState, isAnonymousEnabled)=>({
        helpCenterName: helpCenterName,
        loginModel: loginModel,
        resetUrl: resetUrl,
        loginUIState: loginUIState,
        isAnonymousEnabled: isAnonymousEnabled,
        isLoggedIn: isUserLoggedIn,
        isLoading: !loaded
    }));
var $9d0857465625d188$export$2e2bcd8739ae039 = (0, $jvoWT.default)($9d0857465625d188$var$selector, {
    resetLogin: $uiV1X.resetLogin,
    fetchLoginModel: $dUoD8.fetchLoginModel,
    checkLoginActionSuccess: $uiV1X.checkLoginActionSuccess,
    fetchForgotPasswordModel: $2O4bV.fetchForgotPasswordModel,
    successfullyLoggedInAction: (0, $8ICBx.successfullyLoggedIn),
    onExitTestMode: (0, $uiV1X.exitTestModeAction)
})((0, $eS4yu.default)({
    component: 'login'
})((0, $k7ZVu.default)()((0, $hWt0u.default)((0, $8Y9TA.default)))));

});
parcelRegister("eQhkf", function(module, exports) {
$parcel$export(module.exports, "getResetUrl", () => (parcelRequire("jtqro")).getResetUrl);

var $jtqro = parcelRequire("jtqro");

});
parcelRegister("jtqro", function(module, exports) {
$parcel$export(module.exports, "getResetUrl", () => $328c9a517ce27ffd$export$8f4db1396a1458f2);
const $328c9a517ce27ffd$var$getForgotPasswordOrError = (state)=>{
    return state.persisted.forgotPassword;
};
const $328c9a517ce27ffd$export$8f4db1396a1458f2 = (state)=>{
    const data = $328c9a517ce27ffd$var$getForgotPasswordOrError(state);
    return data && 'forgotPassword' in data && data.forgotPassword ? data.forgotPassword.resetUrl : undefined;
};

});


parcelRegister("35WUi", function(module, exports) {
$parcel$export(module.exports, "getLogin", () => (parcelRequire("7AYpn")).getLogin);
$parcel$export(module.exports, "getIsLoginLoaded", () => (parcelRequire("7AYpn")).getIsLoginLoaded);
$parcel$export(module.exports, "getLoginUIState", () => (parcelRequire("7AYpn")).getLoginUIState);
$parcel$export(module.exports, "getIsFailedLoginAttempt", () => (parcelRequire("7AYpn")).getIsFailedLoginAttempt);
$parcel$export(module.exports, "getLoginAnnouncementLocale", () => (parcelRequire("7AYpn")).getLoginAnnouncementLocale);

var $7AYpn = parcelRequire("7AYpn");

});
parcelRegister("7AYpn", function(module, exports) {
$parcel$export(module.exports, "getLogin", () => $eab0570ec027ed58$export$b91571cfe9876bf7);
$parcel$export(module.exports, "getLoginAnnouncementLocale", () => $eab0570ec027ed58$export$30a66755de1b0435);
$parcel$export(module.exports, "getIsLoginLoaded", () => $eab0570ec027ed58$export$b8e9d5ecaaf5cf65);
$parcel$export(module.exports, "getLoginUIState", () => $eab0570ec027ed58$export$3751fae82567dd3f);
$parcel$export(module.exports, "getIsFailedLoginAttempt", () => $eab0570ec027ed58$export$bd53bde676b5f183);
const $eab0570ec027ed58$var$getLoginOrError = (state)=>{
    return state.persisted.login;
};
const $eab0570ec027ed58$export$b91571cfe9876bf7 = (state)=>{
    const data = $eab0570ec027ed58$var$getLoginOrError(state);
    return data && 'login' in data && data.login ? data.login : undefined;
};
const $eab0570ec027ed58$export$30a66755de1b0435 = (state)=>{
    var _data$login;
    const data = $eab0570ec027ed58$var$getLoginOrError(state);
    return data && 'login' in data && data.login ? (_data$login = data.login) === null || _data$login === void 0 ? void 0 : _data$login.loginAnnouncementLocale : undefined;
};
const $eab0570ec027ed58$export$b8e9d5ecaaf5cf65 = (state)=>{
    const login = $eab0570ec027ed58$export$b91571cfe9876bf7(state);
    return login !== undefined;
};
const $eab0570ec027ed58$export$3751fae82567dd3f = (state)=>{
    return state.ui.login;
};
const $eab0570ec027ed58$export$9fd495314b248bd5 = (state)=>{
    return $eab0570ec027ed58$export$3751fae82567dd3f(state).error;
};
const $eab0570ec027ed58$export$bd53bde676b5f183 = (state)=>{
    const loginUIState = $eab0570ec027ed58$export$3751fae82567dd3f(state);
    return $eab0570ec027ed58$export$9fd495314b248bd5(state) !== undefined || loginUIState.loginAttemptResponse !== undefined && !loginUIState.loginAttemptResponse.loginSucceeded;
};

});


parcelRegister("8Y9TA", function(module, exports) {
$parcel$export(module.exports, "default", () => $8499abb21f0b560c$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $1pfMV = parcelRequire("1pfMV");

var $8rTkC = parcelRequire("8rTkC");

var $gzPDp = parcelRequire("gzPDp");

var $HGACo = parcelRequire("HGACo");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $04X5p = parcelRequire("04X5p");

var $f73iJ = parcelRequire("f73iJ");

var $loEqA = parcelRequire("loEqA");

var $l4a5B = parcelRequire("l4a5B");
parcelRequire("bE2j5");
var $zFOUM = parcelRequire("zFOUM");
parcelRequire("9i6OK");
var $3szzY = parcelRequire("3szzY");

var $bhHsQ = parcelRequire("bhHsQ");

var $8gu7I = parcelRequire("8gu7I");

var $1EFS8 = parcelRequire("1EFS8");

var $iqJis = parcelRequire("iqJis");

var $7zDtY = parcelRequire("7zDtY");

var $aEpPp = parcelRequire("aEpPp");

var $4peLG = parcelRequire("4peLG");

var $iziiq = parcelRequire("iziiq");

var $1lG1b = parcelRequire("1lG1b");
var $gOotW = parcelRequire("gOotW");

var $gk18s = parcelRequire("gk18s");

var $g2qf8 = parcelRequire("g2qf8");

var $c7dQO = parcelRequire("c7dQO");

var $hrPHR = parcelRequire("hrPHR");

var $7FSs7 = parcelRequire("7FSs7");

var $6GNhI = parcelRequire("6GNhI");

var $g1L0m = parcelRequire("g1L0m");

var $4IxnQ = parcelRequire("4IxnQ");

var $mZdfM = parcelRequire("mZdfM");

var $jsmb9 = parcelRequire("jsmb9");

var $hgZG5 = parcelRequire("hgZG5");
parcelRequire("aMplK");
var $2kdX8 = parcelRequire("2kdX8");
parcelRequire("liysv");
var $bmaMH = parcelRequire("bmaMH");
parcelRequire("e16zw");
var $lKKqX = parcelRequire("lKKqX");
parcelRequire("lk3rU");
var $698O0 = parcelRequire("698O0");
parcelRequire("1e9y2");
var $hhVLu = parcelRequire("hhVLu");
parcelRequire("iHfu2");
var $lbFaP = parcelRequire("lbFaP");

var $81goj = parcelRequire("81goj");
/**
 * Check if loginAnnouncement is present
 */ const $8499abb21f0b560c$var$isAnnouncementPresent = (loginModel)=>{
    if (!loginModel) return false;
    const { loginAnnouncementSubject: loginAnnouncementSubject, loginAnnouncementMessage: loginAnnouncementMessage } = loginModel;
    return (0, $4IxnQ.isValidAnnouncement)(loginAnnouncementSubject, loginAnnouncementMessage);
};
const $8499abb21f0b560c$var$getLoginAnnouncementText = (loginAnnouncementMessage)=>{
    return /*#__PURE__*/ $8P7DW.createElement($8499abb21f0b560c$var$LoginAnnouncementBody, {
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(loginAnnouncementMessage) : (0, $f73iJ.sanitize)(loginAnnouncementMessage)
        }
    });
};
const $8499abb21f0b560c$export$f20e6faa97f704fb = ({ loginAnnouncementSubject: loginAnnouncementSubject, loginAnnouncementMessage: loginAnnouncementMessage })=>/*#__PURE__*/ $8P7DW.createElement($8499abb21f0b560c$var$LoginAnnouncementContainer, null, loginAnnouncementSubject ? /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
            size: "small"
        }, loginAnnouncementSubject)
    }, /*#__PURE__*/ $8P7DW.createElement($8499abb21f0b560c$var$LoginAnnouncementTitle, null, loginAnnouncementSubject)) : null, loginAnnouncementMessage ? $8499abb21f0b560c$var$getLoginAnnouncementText(loginAnnouncementMessage) : null);
class $8499abb21f0b560c$export$21a94553ffa41578 extends $8P7DW.Component {
    componentDidMount() {
        const { isLoading: isLoading, resetUrl: resetUrl, loginUIState: loginUIState } = this.props;
        const ssoCustomerMethod = loginUIState.authInfo.authMethods.get((0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_SSO);
        if (isLoading) this.props.fetchLoginModel();
        if (!resetUrl) this.props.fetchForgotPasswordModel();
        if (loginUIState.authInfo.authMethods.size === 0) this.fireLoginFailedOperationalEvent({
            noMethodsAvailable: true,
            redirectUrlIsMissing: false
        });
        else if (ssoCustomerMethod && ssoCustomerMethod.redirectLink === undefined) this.fireLoginFailedOperationalEvent({
            noMethodsAvailable: false,
            redirectUrlIsMissing: true
        });
    }
    getNavigationTiming() {
        if ((0, $1EFS8.default).checkGate('fix_old_browser_support_on_help_center_login')) {
            var _globalThis$performan, _globalThis$performan2;
            return (_globalThis$performan = globalThis.performance) === null || _globalThis$performan === void 0 || (_globalThis$performan2 = _globalThis$performan.getEntriesByType) === null || _globalThis$performan2 === void 0 || (_globalThis$performan2 = _globalThis$performan2.call(_globalThis$performan, 'navigation')) === null || _globalThis$performan2 === void 0 ? void 0 : _globalThis$performan2[0];
        }
        return performance.getEntriesByType('navigation')[0];
    }
    render() {
        const { isLoggedIn: isLoggedIn, portalId: portalId } = this.props;
        const navigation = this.getNavigationTiming();
        if (isLoggedIn) return /*#__PURE__*/ $8P7DW.createElement((0, $mZdfM.RedirectLoggedInUser), {
            portalId: portalId
        });
        return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
            data: {
                attributes: {
                    isSsoTestMode: (0, $jsmb9.getSsoTestModeParamFromUrl)(new URLSearchParams((0, $6GNhI.search)()))
                }
            }
        }, /*#__PURE__*/ $8P7DW.createElement((0, $aEpPp.default), {
            data: {
                isFromRedirect: navigation ? navigation.redirectCount > 0 : undefined,
                redirectCount: navigation ? navigation.redirectCount : undefined,
                isDefaultHelpCenter: (0, $gk18s.isDefaultHelpCenter)()
            }
        }), /*#__PURE__*/ $8P7DW.createElement("div", {
            "data-test-id": "login-page.wrapper"
        }, this.renderLoginPage()));
    }
    constructor(...args){
        super(...args), this.fireLoginFailedOperationalEvent = (attributes)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const { noMethodsAvailable: noMethodsAvailable, redirectUrlIsMissing: redirectUrlIsMissing } = attributes;
            if (createAnalyticsEvent) createAnalyticsEvent({
                analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'login',
                action: 'failed',
                attributes: {
                    noMethodsAvailable: noMethodsAvailable,
                    redirectUrlIsMissing: redirectUrlIsMissing
                }
            }).fire();
        }, this.getJITContinueParam = ()=>{
            const { destination: destination, isAbsolute: isAbsolute } = (0, $jsmb9.parseLoginSignupRedirectUrlParams)();
            const prefix = destination && isAbsolute ? '' : `${(0, $6GNhI.origin)()}${(0, $7FSs7.getBaseName)()}/aa-redirect?from=portalLoginJitSignup`;
            return `${prefix}`;
        }, this.resetHasLoginPageUpdated = ()=>{
            this.props.resetLogin(this.props.loginUIState.email);
        }, this.renderForgotPasswordConfirmation = ()=>{
            const { isLoading: isLoading, loginUIState: loginUIState, helpCenterName: helpCenterName, resetUrl: resetUrl } = this.props;
            return /*#__PURE__*/ $8P7DW.createElement((0, $g2qf8.default), {
                screenName: (0, $8rTkC.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION
            }, /*#__PURE__*/ $8P7DW.createElement((0, $3szzY.default), {
                screenName: (0, $8rTkC.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION
            }, /*#__PURE__*/ $8P7DW.createElement((0, $zFOUM.NoteContent), {
                isLoading: isLoading
            }, /*#__PURE__*/ $8P7DW.createElement((0, $bmaMH.default), {
                email: loginUIState.email,
                helpCenterName: helpCenterName,
                resetUrl: resetUrl || '',
                onBackButtonClick: this.resetHasLoginPageUpdated
            }))));
        }, this.renderSsoTestModeErrorPage = ()=>{
            const { isLoading: isLoading } = this.props;
            return /*#__PURE__*/ $8P7DW.createElement((0, $g2qf8.default), {
                screenName: (0, $8rTkC.ScreenName).LOGIN_SSO_TEST_MODE_ERROR
            }, /*#__PURE__*/ $8P7DW.createElement((0, $zFOUM.NoteContent), {
                isLoading: isLoading
            }, /*#__PURE__*/ $8P7DW.createElement((0, $2kdX8.default), null)));
        }, this.renderSingleSignOn = ()=>{
            const { loginUIState: loginUIState } = this.props;
            const ssoMethod = loginUIState.authInfo.authMethods.get((0, $g1L0m.AuthMethodType).ATLASSIAN_ACCOUNT_SSO);
            if (ssoMethod) {
                const { redirectLink: redirectLink } = ssoMethod;
                const singleSignOnSupplier = ()=>/*#__PURE__*/ $8P7DW.createElement((0, $g2qf8.default), {
                        screenName: (0, $8rTkC.ScreenName).LOGIN_SINGLE_SIGN_ON
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $hhVLu.default), {
                        redirectUrl: redirectLink,
                        email: loginUIState.email
                    }));
                return this.renderWithTitleAndFooter(singleSignOnSupplier);
            }
            return undefined;
        }, this.resetToCustomerPasswordLogin = ()=>{
            this.props.checkLoginActionSuccess((0, $g1L0m.LoginType).CUSTOMER_ACCOUNT_LOGIN, {
                accountStage: (0, $g1L0m.AccountStageType).LOGIN,
                authMethods: new Map([
                    [
                        (0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ]
                ])
            });
        }, this.renderSingleSignOnCustomer = ()=>{
            const { loginUIState: loginUIState } = this.props;
            const ssoMethod = loginUIState.authInfo.authMethods.get((0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_SSO);
            if (ssoMethod) {
                const { redirectLink: redirectLink } = ssoMethod;
                const passwordLoginAvailable = loginUIState.authInfo.authMethods.has((0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD);
                const singleSignOnSupplier = ()=>/*#__PURE__*/ $8P7DW.createElement((0, $g2qf8.default), {
                        screenName: (0, $8rTkC.ScreenName).LOGIN_SINGLE_SIGN_ON_CUSTOMER
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $lbFaP.default), {
                        email: loginUIState.email,
                        redirectLink: redirectLink,
                        passwordLoginAvailable: passwordLoginAvailable,
                        onContinueWithPassword: this.resetToCustomerPasswordLogin
                    }));
                return this.renderWithTitleAndFooter(singleSignOnSupplier);
            }
            return undefined;
        }, this.renderLoginPasswordForm = ()=>{
            return /*#__PURE__*/ $8P7DW.createElement((0, $g2qf8.default), {
                screenName: (0, $8rTkC.ScreenName).LOGIN_PASSWORD
            }, this.renderLoginForm());
        }, this.renderLoginForm = ()=>{
            const { resetUrl: resetUrl, loginUIState: loginUIState, portalId: portalId } = this.props;
            const formSupplier = (loginModel)=>/*#__PURE__*/ $8P7DW.createElement((0, $698O0.default), {
                    portalId: portalId,
                    contactAdminLink: loginModel.contactAdminLink,
                    resetUrl: resetUrl || '',
                    loginUIState: loginUIState,
                    canResetPassword: loginModel.canReset,
                    continueParam: (0, $jsmb9.getContinueParam)(portalId)
                });
            return this.renderWithTitleAndFooter(formSupplier);
        }, this.renderFooter = ()=>{
            const { intl: intl, isAnonymousEnabled: isAnonymousEnabled, loginUIState: loginUIState, helpCenterName: helpCenterName } = this.props;
            return isAnonymousEnabled && !loginUIState.atlassianAccountCheckPerformed && /*#__PURE__*/ $8P7DW.createElement($8499abb21f0b560c$var$FooterContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $04X5p.default), {
                to: (0, $jsmb9.getHelpCenterUrl)(),
                actionSubjectId: "helpCenterLink",
                onClick: (e)=>{
                    if ((0, $HGACo.isCsmLoginPageLinkBlankPageFixEnabled)()) {
                        // This is ugly but we want to do a full page load (not an SPA load/transition)
                        // to allow the backend to make the decision about where we should end up.
                        // If CSM DOES NOT allow anonymous access but Jira Admin settings DOES, then
                        // an SPA transition will lead to a blank homepage as the backend actually
                        // wants to redirect the user to the login page.
                        e.preventDefault();
                        (0, $6GNhI.assign)((0, $hrPHR.getEnv)().baseUrl);
                    }
                }
            }, intl.formatMessage((0, $81goj.default).helpCenterLink, {
                helpCenterName: helpCenterName
            })));
        }, this.renderBackButton = ()=>{
            const { intl: intl } = this.props;
            const buttonText = intl.formatMessage((0, $81goj.default).backButton);
            return /*#__PURE__*/ $8P7DW.createElement((0, $hgZG5.default), {
                appearance: "link",
                actionSubjectId: "returnToLogin",
                onClick: this.resetHasLoginPageUpdated
            }, buttonText);
        }, this.getLoginAnnouncementCard = ()=>{
            const { loginModel: loginModel } = this.props;
            if ((0, $gk18s.isKoshEnabledForDefaultHelpCenter)()) // render new login announcement with relay fetch
            return /*#__PURE__*/ $8P7DW.createElement((0, $lKKqX.default), null);
            if (loginModel && $8499abb21f0b560c$var$isAnnouncementPresent(loginModel)) // render old login announcement card with model
            return /*#__PURE__*/ $8P7DW.createElement($8499abb21f0b560c$export$f20e6faa97f704fb, {
                loginAnnouncementSubject: loginModel.loginAnnouncementSubject,
                loginAnnouncementMessage: loginModel.loginAnnouncementMessage
            });
            return null;
        }, // oxlint-disable-next-line no-shadow
        this.getContent = (componentSupplier)=>{
            const { intl: intl, helpCenterName: helpCenterName, isLoading: isLoading, loginModel: loginModel, loginUIState: loginUIState } = this.props;
            let description = intl.formatMessage((0, $81goj.default).description);
            if (loginUIState.atlassianAccountCheckPerformed) {
                if (loginUIState.authInfo.authMethods.has((0, $g1L0m.AuthMethodType).ATLASSIAN_ACCOUNT_SSO)) switch(loginUIState.authInfo.accountStage){
                    case (0, $g1L0m.AccountStageType).SIGNUP:
                        description = intl.formatMessage((0, $81goj.default).useAtlassianAccountSignup);
                        break;
                    case (0, $g1L0m.AccountStageType).LOGIN:
                    default:
                        description = intl.formatMessage((0, $81goj.default).useAtlassianAccountLogin);
                        break;
                }
                else description = intl.formatMessage((0, $81goj.default).descriptionLogin);
            }
            const loginAnnouncementCard = this.getLoginAnnouncementCard();
            if (!isLoading && loginModel) return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, loginUIState.atlassianAccountCheckPerformed && this.renderBackButton(), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
                    size: "large"
                }, helpCenterName)
            }, /*#__PURE__*/ $8P7DW.createElement($8499abb21f0b560c$export$8faa746ec8bdfab3, null, helpCenterName)), !loginUIState.atlassianAccountCheckPerformed ? loginAnnouncementCard : null, /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
                    size: "medium"
                }, description)
            }, /*#__PURE__*/ $8P7DW.createElement($8499abb21f0b560c$var$LoginDescription, null, description)), /*#__PURE__*/ $8P7DW.createElement($8499abb21f0b560c$var$LoginFormContainer, null, componentSupplier(loginModel)), this.renderFooter());
            return /*#__PURE__*/ $8P7DW.createElement((0, $4peLG.default), {
                name: "render-login-page-loading"
            });
        }, this.renderWithTitleAndFooter = (componentSupplier)=>{
            const { isLoading: isLoading } = this.props;
            const content = this.getContent(componentSupplier);
            const renderSsoTestModeBanner = ()=>{
                const isOptimizedSsoTestModeBannerEnabled = (0, $1EFS8.default).checkGate('portal_login-optimize-ssotestbanner-render');
                if (isOptimizedSsoTestModeBannerEnabled) {
                    // Extract sso_test from url params
                    const urlParams = new URLSearchParams((0, $6GNhI.search)());
                    const ssoTest = urlParams.get((0, $g1L0m.QUERY_PARAM_SSO_TEST));
                    return ssoTest === 'true' ? /*#__PURE__*/ $8P7DW.createElement((0, $bhHsQ.SsoTestModeBanner), null) : null;
                }
                return /*#__PURE__*/ $8P7DW.createElement((0, $bhHsQ.SsoTestModeBanner), null);
            };
            return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, renderSsoTestModeBanner(), /*#__PURE__*/ $8P7DW.createElement((0, $zFOUM.NoteContent), {
                isLoading: isLoading
            }, content));
        }, this.isInvalidFedRampLogin = ()=>{
            // Gate ON: environment-aware enablement for Help Center password login; Gate OFF: legacy FedRAMP fallback
            const isPasswordLoginDisabledByEnv = (0, $1EFS8.default).checkGate('use_frontend_feature_encoding_sdk_help_center') ? !(0, $1pfMV.isFeatureEnabled)('jira-service-management', 'jsm-help-center-password-login') : (0, $1lG1b.isFedRamp)();
            return isPasswordLoginDisabledByEnv && this.noAuthMethodOrOnlyHasPasswordAuthMethod();
        }, this.isInvalidIcLogin = ()=>{
            // Gate ON: environment-aware enablement handles IC via Cosmos; Gate OFF: legacy IC FG
            const isPasswordLoginDisabledByEnv = (0, $1EFS8.default).checkGate('use_frontend_feature_encoding_sdk_help_center') ? !(0, $1pfMV.isFeatureEnabled)('jira-service-management', 'jsm-help-center-password-login') : (0, $gOotW.isIsolatedCloud)();
            return isPasswordLoginDisabledByEnv && this.noAuthMethodOrOnlyHasPasswordAuthMethod();
        }, this.noAuthMethodOrOnlyHasPasswordAuthMethod = ()=>{
            const { loginUIState: loginUIState } = this.props;
            return loginUIState.authInfo.authMethods.size === 0 || loginUIState.authInfo.authMethods.size === 1 && loginUIState.authInfo.authMethods.has((0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD);
        }, this.renderNoLoginMethodPage = ()=>{
            const { intl: intl, helpCenterName: helpCenterName, isLoading: isLoading } = this.props;
            return /*#__PURE__*/ $8P7DW.createElement((0, $zFOUM.NoteContent), {
                isLoading: isLoading
            }, this.renderBackButton(), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
                    size: "large"
                }, helpCenterName)
            }, /*#__PURE__*/ $8P7DW.createElement($8499abb21f0b560c$export$8faa746ec8bdfab3, null, helpCenterName)), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $7zDtY.default), null, intl.formatMessage((0, $81goj.default).noLoginMethodWarningContent))
            }, /*#__PURE__*/ $8P7DW.createElement("p", null, intl.formatMessage((0, $81goj.default).noLoginMethodWarningContent))));
        }, this.renderLoginPage = ()=>{
            const { intl: intl, loginUIState: loginUIState } = this.props;
            let loginPage;
            if (loginUIState.showPasswordConfirmation) loginPage = this.renderForgotPasswordConfirmation();
            else if (loginUIState.authInfo.authMethods.has((0, $g1L0m.AuthMethodType).CUSTOMER_ACCOUNT_SSO)) loginPage = this.renderSingleSignOnCustomer();
            else if (loginUIState.authInfo.authMethods.has((0, $g1L0m.AuthMethodType).ATLASSIAN_ACCOUNT_SSO)) loginPage = this.renderSingleSignOn();
            else if (loginUIState.showSsoTestModeErrorPage) loginPage = this.renderSsoTestModeErrorPage();
            else if (loginUIState.atlassianAccountCheckPerformed) {
                if (this.isInvalidFedRampLogin() || this.isInvalidIcLogin()) loginPage = this.renderNoLoginMethodPage();
                else loginPage = this.renderLoginPasswordForm();
            } else loginPage = this.renderLoginForm();
            return /*#__PURE__*/ $8P7DW.createElement((0, $gzPDp.default), {
                title: intl.formatMessage((0, $81goj.default).documentTitle)
            }, loginPage);
        };
    }
}
var $8499abb21f0b560c$export$2e2bcd8739ae039 = (0, $l4a5B.default)($8499abb21f0b560c$export$21a94553ffa41578);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8499abb21f0b560c$var$LoginDescription = /*#__PURE__*/ (0, $2UsNA.default).h2.withConfig({
    componentId: "sc-1ifnvh3-0"
})`${(0, $kBzhX.h600)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8499abb21f0b560c$var$LoginFormContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1ifnvh3-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8499abb21f0b560c$var$FooterContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1ifnvh3-2"
})`margin-top:${"var(--ds-space-400, 32px)"};text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8499abb21f0b560c$var$LoginAnnouncementContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1ifnvh3-3"
})`padding-bottom:${"var(--ds-space-200, 16px)"};border-bottom:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8499abb21f0b560c$var$LoginAnnouncementTitle = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1ifnvh3-4"
})`${(0, $kBzhX.h500)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8499abb21f0b560c$var$LoginAnnouncementBody = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1ifnvh3-5"
})`margin-top:${"var(--ds-space-100, 8px)"};max-width:${$4cxV2.multiple(42).px};overflow-wrap:break-word;`;
const $8499abb21f0b560c$export$8faa746ec8bdfab3 = /*#__PURE__*/ (0, $2UsNA.default).h1.withConfig({
    componentId: "sc-1ifnvh3-6"
})`${(0, $kBzhX.h700)};`;

});
parcelRegister("bE2j5", function(module, exports) {
$parcel$export(module.exports, "NoteContent", () => (parcelRequire("zFOUM")).NoteContent);

var $zFOUM = parcelRequire("zFOUM");

});
parcelRegister("zFOUM", function(module, exports) {
$parcel$export(module.exports, "NoteContent", () => $e1d5252c0a32cc2b$export$fe2e0d4376bdc305);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $4cxV2 = parcelRequire("4cxV2");
parcelRequire("72LHL");
var $4Em1B = parcelRequire("4Em1B");
class $e1d5252c0a32cc2b$export$fe2e0d4376bdc305 extends $8P7DW.Component {
    render() {
        return /*#__PURE__*/ $8P7DW.createElement($e1d5252c0a32cc2b$var$NoteContentContainer, {
            isCentered: this.props.isCentered,
            "data-testid": "note-content-container"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $4Em1B.default), {
            isLoading: this.props.isLoading,
            loadingPosition: "fill-container"
        }, this.props.children));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e1d5252c0a32cc2b$var$NoteContentContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-x5t5ez-0"
})`margin:${"var(--ds-space-800, 64px)"};max-width:${$4cxV2.multiple(44).px};text-align:${(props)=>props.isCentered ? 'center' : 'start'};`;

});


parcelRegister("bhHsQ", function(module, exports) {
$parcel$export(module.exports, "SsoTestModeBanner", () => $8388cff99ce05e4e$export$c5b94d186c592c02);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $8388cff99ce05e4e$export$c5b94d186c592c02 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("dTV0B")), {
        moduleId: "./src/view/sso-test-mode-banner/hocs.tsx"
    })
});

});
parcelRegister("dTV0B", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("3oKqD").then(()=>parcelRequire('8dPdr'));

});


parcelRegister("aEpPp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdb81b6b9a17a209$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $bdb81b6b9a17a209$export$d12f56a472cdbe6c);

var $8P7DW = parcelRequire("8P7DW");

var $18KuK = parcelRequire("18KuK");

var $8uTBY = parcelRequire("8uTBY");

var $9TwI7 = parcelRequire("9TwI7");
function $bdb81b6b9a17a209$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $8P7DW.useContext)((0, $18KuK.default));
    (0, $8P7DW.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $bdb81b6b9a17a209$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $8uTBY.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') (0, $9TwI7.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $9TwI7.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("4IxnQ", function(module, exports) {
$parcel$export(module.exports, "isValidAnnouncement", () => $1376b183f3b63202$export$12ee192c1d1082df);
$parcel$export(module.exports, "DEFAULT_LANG_ANNOUNCEMENT_TITLE_LIMIT", () => $1376b183f3b63202$export$6cca6da7b99ee46e);
$parcel$export(module.exports, "DEFAULT_LANG_ANNOUNCEMENT_MESSAGE_LIMIT", () => $1376b183f3b63202$export$24036c5b680cb85);
const $1376b183f3b63202$export$12ee192c1d1082df = (header, message)=>header !== '' || message !== '';
const $1376b183f3b63202$export$6cca6da7b99ee46e = 50;
const $1376b183f3b63202$export$24036c5b680cb85 = 480;

});

parcelRegister("mZdfM", function(module, exports) {
$parcel$export(module.exports, "RedirectLoggedInUser", () => $6e0d333c615ad7ae$export$b883ffb676ea4071);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $7FSs7 = parcelRequire("7FSs7");

var $6GNhI = parcelRequire("6GNhI");

var $3Wo8f = parcelRequire("3Wo8f");

var $jsmb9 = parcelRequire("jsmb9");
const $6e0d333c615ad7ae$export$b883ffb676ea4071 = ({ portalId: portalId })=>{
    const { destination: destination } = (0, $jsmb9.parseLoginSignupRedirectUrlParams)();
    if ((0, $HGACo.isHubsEnabledInHelpCenter)() && (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType)) {
        const redirectPath = `${(0, $7FSs7.getRelativeBasePath)()}${destination ? `/${destination}` : ''}`;
        (0, $6GNhI.replace)(redirectPath);
        return null;
    }
    if (destination) {
        if ((0, $6GNhI.isValidLocation)(destination)) {
            const relativeUrl = (0, $jsmb9.convertAbsoluteUrlToRelativeUrl)(destination);
            (0, $6GNhI.assign)(relativeUrl);
            return null;
        }
        if (decodeURIComponent(destination).startsWith('//')) {
            (0, $6GNhI.assign)((0, $jsmb9.getHelpCenterUrl)());
            return null;
        }
    }
    if ($6e0d333c615ad7ae$var$shouldExecuteFullPageReload(destination)) {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        (0, $6GNhI.replace)(`${(0, $7FSs7.getRelativeBasePath)()}/${destination}`);
        return null;
    }
    const relativeDestination = `/${destination || (0, $jsmb9.getDefaultDestination)(portalId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3Wo8f.Redirect), {
        to: relativeDestination
    });
};
const $6e0d333c615ad7ae$var$fullPageReloadPathsRegexs = [
    /^request\/[0-9]+\/attachment\/[0-9]+[/]?(\?.*)?$/,
    /^request\/[0-9]+\/attachment\/[0-9]+\/thumbnail[/]?(\?.*)?$/
];
/**
 * Some URLs, even though they start with /servicedesk/customer, don't have any specific component mapped to that route.
 * When customers account log in the portal will simply do an SPA redirection and it will end up in 404
 * This method will allow for these "special" URLs to execute a full page reload after a customer account logs in.
 */ const $6e0d333c615ad7ae$var$shouldExecuteFullPageReload = (destination)=>{
    if (destination) return $6e0d333c615ad7ae$var$fullPageReloadPathsRegexs.some((regex)=>regex.test(destination));
    return false;
};

});

parcelRegister("hgZG5", function(module, exports) {
$parcel$export(module.exports, "default", () => $98b546e4278b4ebc$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $jShty = parcelRequire("jShty");

var $6YKjX = parcelRequire("6YKjX");

var $1EFS8 = parcelRequire("1EFS8");
// A11Y-28852, A11Y-28899, A11Y-28901: gate name for decorative back icon fix
const $98b546e4278b4ebc$var$A11Y_DECORATIVE_BACK_ICON_GATE = 'ai-a11y-111-28852-28899-28901';
const $98b546e4278b4ebc$var$ThemedBackButton = (props)=>{
    const { children: children, onClick: onClick, actionSubjectId: actionSubjectId, appearance: appearance } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($98b546e4278b4ebc$var$BackButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jShty.ThemedButton), {
        iconBefore: // Icon is decorative — adjacent button text already conveys the label
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6YKjX))), {
            spacing: "spacious",
            label: (0, $1EFS8.default).checkGate($98b546e4278b4ebc$var$A11Y_DECORATIVE_BACK_ICON_GATE) ? '' : children
        }),
        appearance: appearance,
        spacing: "compact",
        actionSubjectId: actionSubjectId,
        onClick: onClick
    }, children));
};
var $98b546e4278b4ebc$export$2e2bcd8739ae039 = $98b546e4278b4ebc$var$ThemedBackButton;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $98b546e4278b4ebc$var$BackButtonWrapper = /*#__PURE__*/ (0, $2UsNA.default).span.withConfig({
    componentId: "sc-x420oi-0"
})`margin-left:${"var(--ds-space-negative-200, -16px)"};`;

});

parcelRegister("aMplK", function(module, exports) {
$parcel$export(module.exports, "SsoTestModeErrorPage", () => (parcelRequire("2kdX8")).default);

var $2kdX8 = parcelRequire("2kdX8");

});
parcelRegister("2kdX8", function(module, exports) {
$parcel$export(module.exports, "default", () => $66f177d4857a6c57$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $04X5p = parcelRequire("04X5p");

var $9Nmb7 = parcelRequire("9Nmb7");

var $5jYgE = parcelRequire("5jYgE");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $7zDtY = parcelRequire("7zDtY");

var $aQXm8 = parcelRequire("aQXm8");

var $c7dQO = parcelRequire("c7dQO");

var $ZNoCb = parcelRequire("ZNoCb");
const $66f177d4857a6c57$var$LEARN_MORE_LINK = 'https://support.atlassian.com/jira-service-management-cloud/docs/test-single-sign-on-for-customer-login/';
const $66f177d4857a6c57$var$CaSsoTestModeErrorPage = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ $8P7DW.createElement($66f177d4857a6c57$var$Container, {
        "data-test-id": "ca-sso-test-mode-error-screen-container"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $aQXm8.FireScreenEventOnMount), null), /*#__PURE__*/ $8P7DW.createElement($66f177d4857a6c57$var$IconContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $9Nmb7.default), null)), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
            paddingBlockEnd: "space.050"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
            size: "medium"
        }, formatMessage((0, $ZNoCb.default).title)))
    }, /*#__PURE__*/ $8P7DW.createElement($66f177d4857a6c57$var$Title, null, formatMessage((0, $ZNoCb.default).title))), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $7zDtY.default), null, formatMessage((0, $ZNoCb.default).instructionMessage))
    }, /*#__PURE__*/ $8P7DW.createElement("p", null, formatMessage((0, $ZNoCb.default).instructionMessage))), /*#__PURE__*/ $8P7DW.createElement((0, $04X5p.default), {
        actionSubjectId: "learnMoreSsoTestMode",
        href: $66f177d4857a6c57$var$LEARN_MORE_LINK,
        target: "_blank"
    }, formatMessage((0, $ZNoCb.default).learnMoreLinkLabel)));
};
var $66f177d4857a6c57$export$2e2bcd8739ae039 = $66f177d4857a6c57$var$CaSsoTestModeErrorPage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $66f177d4857a6c57$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1q5wzvf-0"
})`text-align:center;> *{margin-bottom:${"var(--ds-space-300, 24px)"};}> *:last-child{margin-bottom:0;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $66f177d4857a6c57$var$Title = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1q5wzvf-1"
})`${(0, $kBzhX.h600)};margin-bottom:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $66f177d4857a6c57$var$IconContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1q5wzvf-2"
})`width:${$4cxV2.multiple(10.5).px};margin:0 auto ${"var(--ds-space-300, 24px)"} auto;`;

});
parcelRegister("ZNoCb", function(module, exports) {
$parcel$export(module.exports, "default", () => $540ca9803f497190$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $540ca9803f497190$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    learnMoreLinkLabel: {
        defaultMessage: 'Learn more about testing single sign-on',
        description: 'label for learn more link for sso test mode failure',
        id: 'cv.login.ca.sso.test.mode.error.learn.more.label'
    },
    instructionMessage: {
        defaultMessage: 'Turn on the single sign-on test mode in your Authentication settings.',
        description: 'message with instruction for SSO test mode',
        id: 'cv.login.ca.sso.test.mode.error.instruction.message'
    },
    title: {
        defaultMessage: 'Single Sign-on test mode is disabled',
        description: 'title for SSO test mode error page',
        id: 'cv.login.ca.sso.test.mode.error.title'
    }
});

});



parcelRegister("liysv", function(module, exports) {
$parcel$export(module.exports, "ForgotPasswordConfirmation", () => (parcelRequire("bmaMH")).default);

var $bmaMH = parcelRequire("bmaMH");

});
parcelRegister("bmaMH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b5d3b0acd9f895f$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $6p5HB = parcelRequire("6p5HB");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");

var $iPyHA = parcelRequire("iPyHA");
var $2b5d3b0acd9f895f$export$2e2bcd8739ae039 = (0, $jvoWT.default)((state)=>({
        baseUrl: (0, $8Wisn.getBaseUrl)(state)
    }), {
    resetLoginAction: (0, $uiV1X.resetLogin),
    onResendLinkError: (0, $6p5HB.handleAjaxError),
    onResendSuccess: (0, $6p5HB.showSuccessFlag)
})((0, $iPyHA.default));

});
parcelRegister("iPyHA", function(module, exports) {
$parcel$export(module.exports, "default", () => $24ae5f84c8a56f84$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");

var $jShty = parcelRequire("jShty");

var $l4cjO = parcelRequire("l4cjO");
var $l4a5B = parcelRequire("l4a5B");

var $9VNXn = parcelRequire("9VNXn");

var $hgZG5 = parcelRequire("hgZG5");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $7zDtY = parcelRequire("7zDtY");

var $aQXm8 = parcelRequire("aQXm8");

var $c7dQO = parcelRequire("c7dQO");

var $jsmb9 = parcelRequire("jsmb9");

var $81goj = parcelRequire("81goj");

var $7Lv1P = parcelRequire("7Lv1P");
class $24ae5f84c8a56f84$export$3ed80e0e31a57da extends $8P7DW.Component {
    render() {
        return /*#__PURE__*/ $8P7DW.createElement($24ae5f84c8a56f84$var$Container, {
            "data-test-id": "forgot-password-container"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $aQXm8.FireScreenEventOnMount), null), this.renderContent());
    }
    constructor(...args){
        super(...args), this.state = {
            isSendingForgotPasswordEmail: false
        }, this.getRedirectUrl = (baseUrl)=>{
            return (0, $jsmb9.getRedirectUrlForSignupAndResetPasswordRequestParam)(baseUrl);
        }, this.onResendButtonClick = ()=>{
            this.setState({
                isSendingForgotPasswordEmail: true
            });
            const redirectUrl = this.getRedirectUrl(this.props.baseUrl);
            (0, $9VNXn.forgotPassword)(this.props.resetUrl, this.props.email, redirectUrl).toPromise().then(()=>{
                this.setState({
                    isSendingForgotPasswordEmail: false
                });
                this.props.onResendSuccess((0, $7Lv1P.default).resendSuccessMessage, {
                    emailAddress: this.props.email
                });
            }).catch((err)=>{
                this.setState({
                    isSendingForgotPasswordEmail: false
                });
                this.props.onResendLinkError(err);
            });
        }, this.renderContent = ()=>{
            const { intl: intl, email: email, helpCenterName: helpCenterName, onBackButtonClick: onBackButtonClick } = this.props;
            return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $hgZG5.default), {
                appearance: "link",
                onClick: onBackButtonClick,
                actionSubjectId: "returnToLogin"
            }, intl.formatMessage((0, $81goj.default).backButton)), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
                    paddingBlockEnd: "space.300"
                }, /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
                    size: "large"
                }, helpCenterName))
            }, /*#__PURE__*/ $8P7DW.createElement($24ae5f84c8a56f84$var$Title, null, helpCenterName)), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
                    size: "medium"
                }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $7Lv1P.default).checkYourEmail))
            }, /*#__PURE__*/ $8P7DW.createElement($24ae5f84c8a56f84$var$Subtitle, null, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $7Lv1P.default).checkYourEmail))), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $7zDtY.default), null, intl.formatMessage((0, $7Lv1P.default).emailHasBeenSentMessage, {
                    emailAddress: email
                }))
            }, /*#__PURE__*/ $8P7DW.createElement("div", null, intl.formatMessage((0, $7Lv1P.default).emailHasBeenSentMessage, {
                emailAddress: email
            }))), /*#__PURE__*/ $8P7DW.createElement((0, $jShty.ThemedButton), {
                appearance: 'primary',
                onClick: this.onResendButtonClick,
                actionSubjectId: "returnToLogin",
                shouldFitContainer: true,
                isLoading: this.state.isSendingForgotPasswordEmail
            }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $7Lv1P.default).resendResetPasswordLinkLabel)));
        };
    }
}
var $24ae5f84c8a56f84$export$2e2bcd8739ae039 = (0, $l4a5B.default)($24ae5f84c8a56f84$export$3ed80e0e31a57da);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $24ae5f84c8a56f84$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-11c9vcd-0"
})`> *{margin-bottom:${"var(--ds-space-300, 24px)"};}> *:last-child{margin-bottom:0;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $24ae5f84c8a56f84$var$Title = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-11c9vcd-1"
})`${(0, $kBzhX.h700)};margin-bottom:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $24ae5f84c8a56f84$var$Subtitle = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-11c9vcd-2"
})`${(0, $kBzhX.h600)};`;

});
parcelRegister("81goj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f85cce1c8f2dbea8$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $f85cce1c8f2dbea8$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    documentTitle: {
        defaultMessage: 'Customer Login - Help Center',
        description: 'Login page document title',
        id: 'cv.login.document.title'
    },
    header: {
        defaultMessage: 'Log in to {helpCenterName}',
        description: 'Page header',
        id: 'cv.login.header'
    },
    helpCenterLink: {
        defaultMessage: 'Go to { helpCenterName } home page',
        description: 'Text for link that redirects to the portals home page',
        id: 'cv.login.helpcenter.link'
    },
    description: {
        defaultMessage: 'Enter your email to log in or sign up',
        description: 'Description shown about the initial login screen',
        id: 'cv.login.description'
    },
    descriptionLogin: {
        defaultMessage: 'Log in to continue',
        description: 'Description shown after email check is customer login',
        id: 'cv.login.description.login'
    },
    useAtlassianAccountLogin: {
        defaultMessage: 'Use Atlassian account to log in',
        description: 'Description shown when login form is in atlassian SSO state',
        id: 'cv.login.use.atlassian.account.log.in'
    },
    useAtlassianAccountSignup: {
        defaultMessage: 'Use Atlassian account to sign up',
        description: 'Description shown when login form is in atlassian JIT state',
        id: 'cv.login.use.atlassian.account.sign.up'
    },
    backButton: {
        defaultMessage: 'Back',
        description: 'Button text for navigating back in the login screen',
        id: 'cv.login.back.button'
    },
    noLoginMethodWarningContent: {
        defaultMessage: 'Access to the help center is unavailable. Try again later or contact your admin for assistance.',
        description: 'No available login method warning content',
        id: 'cv.login.no.login.method.warning.content'
    }
});

});

parcelRegister("7Lv1P", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f35fe936e1356c9$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $3f35fe936e1356c9$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    checkYourEmail: {
        defaultMessage: 'Check your email to reset your password',
        description: 'Help text to tell user check their mailbox for reset password email',
        id: 'cv.login.forgot.password.check.your.email'
    },
    emailHasBeenSentMessage: {
        defaultMessage: "We've sent a reset password link to {emailAddress}",
        description: 'A help text to inform the user that email has been sent',
        id: 'cv.login.forgot.password.email.has.been.sent'
    },
    resendResetPasswordLinkLabel: {
        defaultMessage: 'Resend reset password link',
        description: 'label for Resend reset password link button',
        id: 'cv.login.forgot.password.resend.button.label'
    },
    resendSuccessMessage: {
        defaultMessage: 'Email sent to {emailAddress}',
        description: 'email sent success message',
        id: 'cv.login.forgot.password.resend.success.flag.message'
    }
});

});




parcelRegister("e16zw", function(module, exports) {
$parcel$export(module.exports, "LoginAnnouncement", () => (parcelRequire("lKKqX")).default);

var $lKKqX = parcelRequire("lKKqX");

});
parcelRegister("lKKqX", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9332ae8225978b3$export$2e2bcd8739ae039);

var $36QVm = parcelRequire("36QVm");

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $edC7N = parcelRequire("edC7N");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $4cxV2 = parcelRequire("4cxV2");

var $f73iJ = parcelRequire("f73iJ");

var $loEqA = parcelRequire("loEqA");

var $h3cOB = parcelRequire("h3cOB");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $4IxnQ = parcelRequire("4IxnQ");
// Since LoginAnnouncement epic is made for home page which get messages as plain text, we can't use this epic for our use case, hence we are using useLazyLoadQuery to get the data using graphql query
const $a9332ae8225978b3$var$LoginAnnouncement = ()=>{
    var _data$helpCenter, _data$helpCenter2;
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $36QVm.default), {
        helpCenterAri: (0, $jByYr.getHelpCenterAri)(),
        cloudId: (0, $jByYr.getCloudId)()
    });
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') // not displaying anything if the response is not of type HelpCenter
    return null;
    // As confirmed by the backend team, there will be only one login announcement for now, hence using the first element
    const announcementDetails = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.announcements) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.loginAnnouncements) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2[0];
    const loginAnnouncementSubject = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.name) ?? '';
    const loginAnnouncementMessage = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.description) ?? '';
    const loginAnnouncementDescriptionType = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.descriptionType) ?? '';
    const isAnnouncementValid = (0, $4IxnQ.isValidAnnouncement)(loginAnnouncementSubject, loginAnnouncementMessage);
    if (!isAnnouncementValid) // not displaying anything if the announcement is not valid or the description type is not WIKI_MARKUP
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $a9332ae8225978b3$var$loginAnnouncementContainerStyles
    }, loginAnnouncementSubject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "small"
    }, loginAnnouncementSubject) : null, loginAnnouncementMessage && loginAnnouncementDescriptionType === 'WIKI_MARKUP' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $a9332ae8225978b3$var$loginAnnouncementBodyStyles,
        dangerouslySetInnerHTML: {
            __html: (0, $HGACo.isIsomorphicDompurifyLibUsed)() ? (0, $loEqA.sanitize)(loginAnnouncementMessage) : (0, $f73iJ.sanitize)(loginAnnouncementMessage)
        }
    }) : null);
};
const $a9332ae8225978b3$var$LoginAnnouncementLoader = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: (0, $8rTkC.ScreenName).LOGIN,
        id: 'login-announcements'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($a9332ae8225978b3$var$LoginAnnouncement, null)));
};
var $a9332ae8225978b3$export$2e2bcd8739ae039 = $a9332ae8225978b3$var$LoginAnnouncementLoader;
const $a9332ae8225978b3$var$loginAnnouncementContainerStyles = (0, $37U6z.xcss)({
    marginTop: 'space.300',
    paddingBottom: 'space.200',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"}`
});
const $a9332ae8225978b3$var$loginAnnouncementBodyStyles = (0, $37U6z.xcss)({
    marginTop: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    maxWidth: $4cxV2.multiple(42).px,
    overflowWrap: 'break-word'
});

});
parcelRegister("36QVm", function(module, exports) {
$parcel$export(module.exports, "default", () => $c14321fd19003968$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e8a4b4a6bed407a9fc4f291f36515f8a>>
 * @relayHash 81efd7e37c8c0c5533e02b03e01e4763
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3bb061da4730c40a436a93422bb41d959c3d9096b82b057c2c588b7f9da0d6b2
const $c14321fd19003968$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "loginAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "descriptionType"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3bb061da4730c40a436a93422bb41d959c3d9096b82b057c2c588b7f9da0d6b2",
            "metadata": {},
            "name": "loginAnnouncementsCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c14321fd19003968$var$node.hash = "263cd15a061b12291f170e7431e9e440";
var $c14321fd19003968$export$2e2bcd8739ae039 = $c14321fd19003968$var$node;

});



parcelRegister("lk3rU", function(module, exports) {
$parcel$export(module.exports, "LoginForm", () => (parcelRequire("698O0")).default);

var $698O0 = parcelRequire("698O0");

});
parcelRegister("698O0", function(module, exports) {
$parcel$export(module.exports, "default", () => $02feabea157324a7$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");
parcelRequire("9T0nv");
var $uiV1X = parcelRequire("uiV1X");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");
parcelRequire("35WUi");
var $7AYpn = parcelRequire("7AYpn");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $bvNqR = parcelRequire("bvNqR");
var $02feabea157324a7$export$2e2bcd8739ae039 = (0, $jvoWT.default)((state)=>({
        loginAnnouncementLocale: (0, $7AYpn.getLoginAnnouncementLocale)(state),
        baseUrl: (0, $8Wisn.getBaseUrl)(state)
    }), {
    changeEmailInputAction: (0, $uiV1X.changeEmailInput),
    checkLoginActionAction: (0, $uiV1X.checkLoginAction),
    forgotPasswordAction: (0, $uiV1X.forgotPassword),
    createPasswordAction: (0, $uiV1X.createPassword),
    loginAttemptAction: (0, $uiV1X.loginAttempt),
    resetLoginAction: (0, $uiV1X.resetLogin)
})((0, $eS4yu.default)({
    componentName: 'loginForm'
})((0, $k7ZVu.default)()((0, $bvNqR.LoginForm))));

});
parcelRegister("bvNqR", function(module, exports) {
$parcel$export(module.exports, "LoginForm", () => $1f32cc87c1c0d2f4$export$1f58f750f20f344b);

var $8P7DW = parcelRequire("8P7DW");

var $9Y6sr = parcelRequire("9Y6sr");

var $HGACo = parcelRequire("HGACo");

var $9VNXn = parcelRequire("9VNXn");

var $hb5oz = parcelRequire("hb5oz");

var $7FSs7 = parcelRequire("7FSs7");

var $6GNhI = parcelRequire("6GNhI");

var $jsmb9 = parcelRequire("jsmb9");

var $jsmb9 = parcelRequire("jsmb9");
parcelRequire("kyqok");
var $hcfr8 = parcelRequire("hcfr8");

var $bZQY1 = parcelRequire("bZQY1");
// eslint-disable-next-line no-useless-escape
const $1f32cc87c1c0d2f4$var$EMAIL_PATTERN = /.+\@.+\..+/;
class $1f32cc87c1c0d2f4$export$1f58f750f20f344b extends $8P7DW.Component {
    buildAuthDataRequest() {
        const isInIframe = window.self !== window.top;
        const { destination: destination, isAbsolute: isAbsolute } = (0, $jsmb9.parseLoginSignupRedirectUrlParams)();
        const prefix = destination && isAbsolute ? '' : `${(0, $7FSs7.getBaseName)()}/`;
        const redirectUrl = `${prefix}${destination || this.getDefaultDestination()}`;
        const params = new URLSearchParams((0, $6GNhI.search)());
        return isInIframe && (0, $HGACo.isJsmPortalRovoIntegrationEnabled)() ? {
            ssoTest: (0, $jsmb9.getSsoTestModeParamFromUrl)(params),
            redirectTo: '/servicedesk/customer/embeds/login-success',
            absoluteRedirectUrl: false
        } : {
            ssoTest: (0, $jsmb9.getSsoTestModeParamFromUrl)(params),
            redirectTo: redirectUrl,
            absoluteRedirectUrl: isAbsolute
        };
    }
    render() {
        var _loginUIState$loginAt;
        const { canResetPassword: canResetPassword, loginUIState: loginUIState, contactAdminLink: contactAdminLink, loginAnnouncementLocale: loginAnnouncementLocale } = this.props;
        const { validEmail: validEmail, isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit, password: password } = this.state;
        return /*#__PURE__*/ $8P7DW.createElement((0, $hcfr8.default), {
            isSubmitting: loginUIState.isSubmitting,
            isSendingForgotPasswordEmail: loginUIState.isSendingForgotPasswordEmail,
            isSendingCreatePasswordEmail: loginUIState.isSendingCreatePasswordEmail,
            onSubmit: this.onSubmit,
            onEmailFieldChange: this.onEmailFieldChange,
            onPasswordChange: this.onPasswordChange,
            validEmail: validEmail,
            isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit,
            email: loginUIState.email,
            password: password,
            loginError: this.getLoginError(),
            atlassianAccountCheckPerformed: loginUIState.atlassianAccountCheckPerformed,
            loginFailure: (_loginUIState$loginAt = loginUIState.loginAttemptResponse) === null || _loginUIState$loginAt === void 0 ? void 0 : _loginUIState$loginAt.error,
            showLoginConsentError: loginUIState.showLoginConsentErrorPage,
            createAnalyticsEvent: this.props.createAnalyticsEvent,
            onEmailFieldFocus: this.onEmailFieldFocus,
            onForgotPasswordLinkClick: this.onForgotPasswordLinkClick,
            onCreatePasswordLinkClick: this.onCreatePasswordLinkClick,
            contactAdminLink: contactAdminLink,
            canResetPassword: canResetPassword,
            loginAnnouncementLocale: loginAnnouncementLocale
        });
    }
    constructor(...args){
        super(...args), this.state = {
            password: '',
            validEmail: true,
            isPasswordEmptyOnSubmit: false
        }, this.onEmailFieldChange = (email)=>{
            this.props.changeEmailInputAction(email);
        }, this.onEmailFieldFocus = ()=>{
            if (!this.props.loginUIState.email) this.props.resetLoginAction(this.props.loginUIState.email);
        }, this.onPasswordChange = (password)=>{
            this.setState({
                password: password
            });
        }, this.validateEmail = ()=>{
            const validEmail = $1f32cc87c1c0d2f4$var$EMAIL_PATTERN.test(this.props.loginUIState.email);
            this.setState({
                validEmail: validEmail
            });
            return validEmail;
        }, this.onSubmit = ()=>{
            if (this.validateEmail()) {
                const { loginUIState: loginUIState, loginAttemptAction: loginAttemptAction, checkLoginActionAction: checkLoginActionAction, createAnalyticsEvent: createAnalyticsEvent, continueParam: continueParam } = this.props;
                const authData = this.buildAuthDataRequest();
                const { password: password } = this.state;
                if (loginUIState.atlassianAccountCheckPerformed) {
                    const isPasswordEmptyOnSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($9Y6sr)))(password);
                    this.setState({
                        isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit
                    });
                    if (!isPasswordEmptyOnSubmit) loginAttemptAction({
                        password: password,
                        continueParam: continueParam,
                        email: loginUIState.email.trim()
                    });
                } else checkLoginActionAction(loginUIState.email.trim(), this.props.portalId, authData, createAnalyticsEvent);
            } else (0, $hb5oz.focus)('user-email');
        }, this.getDefaultDestination = ()=>{
            const { portalId: portalId } = this.props;
            if (portalId) return `portal/${portalId}`;
            return 'portals';
        }, this.getRedirectUrl = (baseUrl)=>{
            return (0, $jsmb9.getRedirectUrlForSignupAndResetPasswordRequestParam)(baseUrl);
        }, this.onForgotPasswordLinkClick = ()=>{
            const { loginUIState: loginUIState, forgotPasswordAction: forgotPasswordAction, resetUrl: resetUrl, baseUrl: baseUrl } = this.props;
            const redirectUrl = this.getRedirectUrl(baseUrl);
            forgotPasswordAction(resetUrl, loginUIState.email.trim(), redirectUrl);
        }, this.onCreatePasswordLinkClick = ()=>{
            const { loginUIState: loginUIState, createPasswordAction: createPasswordAction, resetUrl: resetUrl } = this.props;
            createPasswordAction(resetUrl, loginUIState.email.trim());
        }, this.getLoginError = ()=>{
            const { error: error, loginAttemptResponse: loginAttemptResponse } = this.props.loginUIState;
            if (error) return error.description;
            const loginFailure = loginAttemptResponse === null || loginAttemptResponse === void 0 ? void 0 : loginAttemptResponse.error;
            if (loginFailure) switch(loginFailure.errorType){
                case (0, $9VNXn.LoginAttemptErrorType).INVALID_CREDENTIALS:
                    return (0, $bZQY1.default).invalidLogin;
                case (0, $9VNXn.LoginAttemptErrorType).ACCOUNT_LOCKED_ERROR:
                    return (0, $bZQY1.default).accountLocked;
                case (0, $9VNXn.LoginAttemptErrorType).MISC_LOGIN_ERROR:
                default:
                    return (0, $bZQY1.default).miscLoginError;
            }
            return undefined;
        };
    }
}

});
parcelRegister("kyqok", function(module, exports) {
$parcel$export(module.exports, "LoginFormStateless", () => (parcelRequire("hcfr8")).default);

var $hcfr8 = parcelRequire("hcfr8");

});
parcelRegister("hcfr8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0a228ded6626a9d$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $jShty = parcelRequire("jShty");

var $l4cjO = parcelRequire("l4cjO");
var $l4a5B = parcelRequire("l4a5B");

var $9VNXn = parcelRequire("9VNXn");
parcelRequire("knWzX");
var $4P2uu = parcelRequire("4P2uu");
parcelRequire("1fvLS");
var $9QYFS = parcelRequire("9QYFS");
parcelRequire("5Xax4");
var $jxZlp = parcelRequire("jxZlp");
parcelRequire("hZDsh");
var $7ZQXi = parcelRequire("7ZQXi");

var $8gu7I = parcelRequire("8gu7I");

var $7zDtY = parcelRequire("7zDtY");

var $ggKR1 = parcelRequire("ggKR1");

var $iziiq = parcelRequire("iziiq");

var $aQXm8 = parcelRequire("aQXm8");

var $hb5oz = parcelRequire("hb5oz");

var $c7dQO = parcelRequire("c7dQO");

var $7FSs7 = parcelRequire("7FSs7");

var $6GNhI = parcelRequire("6GNhI");

var $clEkf = parcelRequire("clEkf");
const $e0a228ded6626a9d$var$USER_EMAIL_ID = 'user-email';
const $e0a228ded6626a9d$var$SUBMIT_BUTTON_ID = 'login-button';
const $e0a228ded6626a9d$var$USER_PASSWORD_ID = 'user-password';
class $e0a228ded6626a9d$export$464b5747f72597dd extends $8P7DW.Component {
    getForm() {
        return /*#__PURE__*/ $8P7DW.createElement($e0a228ded6626a9d$var$Form, {
            id: "login-form",
            "data-testid": "login-form",
            onSubmit: this.onSubmit
        }, this.getLoginError(), this.getLoginConsentError(), this.getEmailField(), this.getPasswordField(), this.getSubmitButton());
    }
    render() {
        const { loginAnnouncementLocale: loginAnnouncementLocale } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
            data: loginAnnouncementLocale ? {
                attributes: {
                    loginAnnouncementLocale: loginAnnouncementLocale
                }
            } : {}
        }, this.getForm(), this.getForgotPasswordLink(), this.getSetPasswordLink(), /*#__PURE__*/ $8P7DW.createElement((0, $aQXm8.FireScreenEventOnMount), null));
    }
    constructor(...args){
        super(...args), this.onSubmit = (event)=>{
            if (event) event.preventDefault();
            // We need to do this here in order to work on chrome. Calling this method on password field focus
            // had no effect.
            this.blurEmailFieldAndFocusSubmitButton();
            this.cleanErrorCodeFromParams();
            this.props.onSubmit();
        }, this.blurEmailFieldAndFocusSubmitButton = ()=>{
            /*
     * We need to blur the email field this way because when typing an email clicking the submit button after (for checking atlassian account)
     * does not blur the email field on Chrome and Edge. So after clicking the button it looks like the email and password field have the focus.
     * There is no way to reference the html element on @atlaskit/textfield that's why we use document.getElementById .
     */ (0, $hb5oz.blur)($e0a228ded6626a9d$var$USER_EMAIL_ID);
            /*
     * In order to create an understandable focus state on errors (and it will be the same one when using keyboard or clicking the button)
     * we need to focus the button after calling blur on the email text field.
     */ (0, $hb5oz.focus)($e0a228ded6626a9d$var$SUBMIT_BUTTON_ID);
        }, this.cleanErrorCodeFromParams = ()=>{
            const params = new URLSearchParams((0, $6GNhI.search)());
            if (params.has('error_code')) {
                params.delete('error_code');
                (0, $7FSs7.default).replace({
                    search: params.toString()
                });
            }
        }, this.onEmailFieldChange = (_, email)=>{
            this.props.onEmailFieldChange(email);
        }, this.onPasswordChange = (password)=>{
            this.props.onPasswordChange(password);
        }, this.getEmailErrorMessage = ()=>{
            if (this.props.validEmail) return undefined;
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $clEkf.default).invalidEmailError);
        }, this.getPasswordErrorMessage = ()=>{
            const { intl: intl } = this.props;
            if (this.props.isPasswordEmptyOnSubmit) return intl.formatMessage((0, $clEkf.default).emptyPasswordError);
            return intl.formatMessage((0, $clEkf.default).incorrectPasswordError);
        }, this.getPasswordField = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, isSubmitting: isSubmitting, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, password: password, intl: intl, loginFailure: loginFailure, isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit } = this.props;
            if (atlassianAccountCheckPerformed) {
                const isInvalid = (loginFailure === null || loginFailure === void 0 ? void 0 : loginFailure.errorType) === (0, $9VNXn.LoginAttemptErrorType).INVALID_CREDENTIALS || isPasswordEmptyOnSubmit;
                const passwordLabelAndPlaceholder = intl.formatMessage((0, $clEkf.default).passwordLabelAndPlaceholder);
                return /*#__PURE__*/ $8P7DW.createElement((0, $9QYFS.default), {
                    label: passwordLabelAndPlaceholder,
                    htmlFor: $e0a228ded6626a9d$var$USER_PASSWORD_ID
                }, /*#__PURE__*/ $8P7DW.createElement((0, $7ZQXi.default), {
                    id: $e0a228ded6626a9d$var$USER_PASSWORD_ID,
                    testId: $e0a228ded6626a9d$var$USER_PASSWORD_ID,
                    value: password,
                    onChange: this.onPasswordChange,
                    isDisabled: isSubmitting || isSendingForgotPasswordEmail,
                    errorMessage: this.getPasswordErrorMessage(),
                    isInvalid: isInvalid,
                    hideStrengthMeter: true,
                    autoFocus: true
                }));
            }
            return undefined;
        }, this.getButtonText = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, intl: intl } = this.props;
            if (!atlassianAccountCheckPerformed) return intl.formatMessage((0, $clEkf.default).nextButton);
            return intl.formatMessage((0, $clEkf.default).continueButton);
        }, this.getSetPasswordLink = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, canResetPassword: canResetPassword, onCreatePasswordLinkClick: onCreatePasswordLinkClick, isSubmitting: isSubmitting, isSendingCreatePasswordEmail: isSendingCreatePasswordEmail } = this.props;
            if (atlassianAccountCheckPerformed && canResetPassword && onCreatePasswordLinkClick) return /*#__PURE__*/ $8P7DW.createElement($e0a228ded6626a9d$var$ForgotPasswordLinkContainer, null, /*#__PURE__*/ $8P7DW.createElement("div", null, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $clEkf.default).dontHavePasswordText)), /*#__PURE__*/ $8P7DW.createElement((0, $jShty.ThemedButton), {
                id: "set-password-link",
                testId: "set-password-link",
                appearance: "link",
                onClick: onCreatePasswordLinkClick,
                actionSubjectId: "createPassword",
                isDisabled: isSubmitting,
                isLoading: isSendingCreatePasswordEmail
            }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $clEkf.default).createPasswordLink)));
            return undefined;
        }, this.getForgotPasswordLink = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, canResetPassword: canResetPassword, onForgotPasswordLinkClick: onForgotPasswordLinkClick, intl: intl, isSubmitting: isSubmitting, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail } = this.props;
            if (atlassianAccountCheckPerformed && canResetPassword) {
                const linkText = intl.formatMessage((0, $clEkf.default).resetPasswordLink);
                return /*#__PURE__*/ $8P7DW.createElement($e0a228ded6626a9d$var$ForgotPasswordLinkContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $jShty.ThemedButton), {
                    id: "forgot-password-link",
                    testId: "forgot-password-link",
                    appearance: "link",
                    onClick: onForgotPasswordLinkClick,
                    actionSubjectId: "forgotPassword",
                    isDisabled: isSubmitting,
                    isLoading: isSendingForgotPasswordEmail
                }, linkText));
            }
            return undefined;
        }, this.getLoginError = ()=>{
            return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, this.getErrorFromParams(), this.getLoginErrorOnSubmitting());
        }, this.getLoginConsentError = ()=>{
            if (this.props.showLoginConsentError) {
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                createAnalyticsEvent && createAnalyticsEvent({
                    analyticsType: (0, $iziiq.UI_EVENT_TYPE),
                    action: 'viewed',
                    actionSubjectId: `showConsentError`
                }).fire();
                return /*#__PURE__*/ $8P7DW.createElement((0, $ggKR1.default), {
                    appearance: "warning",
                    testId: "login-consent-error"
                }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $clEkf.default).loginConsentErrorMessage));
            }
            return undefined;
        }, this.getLoginErrorOnSubmitting = ()=>{
            const { intl: intl, loginError: loginError, loginFailure: loginFailure, contactAdminLink: contactAdminLink } = this.props;
            const notInvalidCredentials = (loginFailure === null || loginFailure === void 0 ? void 0 : loginFailure.errorType) !== (0, $9VNXn.LoginAttemptErrorType).INVALID_CREDENTIALS;
            if (loginError && notInvalidCredentials) return /*#__PURE__*/ $8P7DW.createElement("div", {
                "aria-live": "assertive",
                role: "alert"
            }, /*#__PURE__*/ $8P7DW.createElement((0, $ggKR1.default), {
                appearance: "error",
                testId: "login-error-on-submit-section"
            }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), {
                ...loginError,
                values: {
                    contactAdminLink: /*#__PURE__*/ $8P7DW.createElement($e0a228ded6626a9d$export$8ffc1cb9f69665da, {
                        dangerouslySetInnerHTML: {
                            __html: contactAdminLink
                        }
                    }),
                    forgotPasswordLink: /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                        migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $7zDtY.default), {
                            weight: "semibold"
                        }, intl.formatMessage((0, $clEkf.default).resetPasswordLinkInlineBold))
                    }, /*#__PURE__*/ $8P7DW.createElement("strong", null, intl.formatMessage((0, $clEkf.default).resetPasswordLinkInlineBold)))
                }
            })));
            return undefined;
        }, this.getErrorFromParams = ()=>{
            const { intl: intl } = this.props;
            const params = new URLSearchParams((0, $6GNhI.search)());
            const errorCode = params.get('error_code');
            if (errorCode) {
                const errorMessage = errorCode === 'access_denied' ? intl.formatMessage((0, $clEkf.default).accessDeniedErrorCodeMessage) : intl.formatMessage((0, $clEkf.default).defaultErrorCodeMessage);
                return /*#__PURE__*/ $8P7DW.createElement((0, $ggKR1.default), {
                    appearance: "error"
                }, errorMessage);
            }
            return undefined;
        }, this.getEmailField = ()=>{
            const { intl: intl, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, isSubmitting: isSubmitting, atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, email: email, onEmailFieldFocus: onEmailFieldFocus } = this.props;
            return /*#__PURE__*/ $8P7DW.createElement((0, $4P2uu.default), {
                name: 'login-email-field'
            }, /*#__PURE__*/ $8P7DW.createElement((0, $jxZlp.default), {
                id: $e0a228ded6626a9d$var$USER_EMAIL_ID,
                shouldFitContainer: true,
                label: intl.formatMessage((0, $clEkf.default).emailLabel),
                onChange: this.onEmailFieldChange,
                errorMessage: this.getEmailErrorMessage(),
                ariaDescribedby: "field-error",
                disabled: isSubmitting || isSendingForgotPasswordEmail || atlassianAccountCheckPerformed,
                defaultValue: email,
                onFocus: onEmailFieldFocus,
                autoComplete: "email",
                autoFocus: !this.props.showLoginConsentError
            }));
        }, this.getSubmitButton = ()=>{
            const { isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, isSubmitting: isSubmitting, atlassianAccountCheckPerformed: atlassianAccountCheckPerformed } = this.props;
            const buttonText = this.getButtonText();
            const buttonActionSubjectId = atlassianAccountCheckPerformed ? 'submitLoginForm' : 'checkLoginEmail';
            return /*#__PURE__*/ $8P7DW.createElement((0, $jShty.ThemedButton), {
                id: $e0a228ded6626a9d$var$SUBMIT_BUTTON_ID,
                testId: $e0a228ded6626a9d$var$SUBMIT_BUTTON_ID,
                type: "submit",
                appearance: "primary",
                shouldFitContainer: true,
                isLoading: isSubmitting,
                isDisabled: isSendingForgotPasswordEmail,
                actionSubjectId: buttonActionSubjectId
            }, buttonText);
        };
    }
}
var $e0a228ded6626a9d$export$2e2bcd8739ae039 = (0, $l4a5B.default)($e0a228ded6626a9d$export$464b5747f72597dd);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e0a228ded6626a9d$var$Form = /*#__PURE__*/ (0, $2UsNA.default).form.withConfig({
    componentId: "sc-1wf191w-0"
})`#login-button{margin-top:${"var(--ds-space-300, 24px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e0a228ded6626a9d$var$ForgotPasswordLinkContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1wf191w-1"
})`margin-top:${"var(--ds-space-300, 24px)"};text-align:center;`;
const $e0a228ded6626a9d$export$8ffc1cb9f69665da = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1wf191w-2"
})`display:inline;`;

});
parcelRegister("knWzX", function(module, exports) {
$parcel$export(module.exports, "DisableViewUntilMount", () => (parcelRequire("4P2uu")).default);

var $4P2uu = parcelRequire("4P2uu");

});
parcelRegister("4P2uu", function(module, exports) {
$parcel$export(module.exports, "default", () => $333fa1f6a20c9ea1$export$2e2bcd8739ae039);
/* disable-view-until-mount.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");
const $333fa1f6a20c9ea1$var$DisableViewUntilMount = ({ children: children, name: name })=>{
    const componentPointerCssVar = `--pointer-events-${name}`;
    $8P7DW.useEffect(()=>{
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty(componentPointerCssVar, 'none');
    }, [
        componentPointerCssVar
    ]);
    return /*#__PURE__*/ $8P7DW.createElement("div", {
        "data-testid": `disable-view-until-mount`,
        className: (0, $8n1kL.default)([
            "_1bsb1osq"
        ])
    }, children, /*#__PURE__*/ $8P7DW.createElement("div", {
        style: {
            // @ts-ignore // because we want to use a dynamic css variable
            pointerEvents: `var(${componentPointerCssVar}, auto)`
        },
        className: (0, $8n1kL.default)([
            "_1bsb1osq _4t3i1osq _kqswstnw _154iidpf _1ltvidpf _80omv00u"
        ])
    }));
};
var $333fa1f6a20c9ea1$export$2e2bcd8739ae039 = $333fa1f6a20c9ea1$var$DisableViewUntilMount;
const $333fa1f6a20c9ea1$var$componentWrapper = null;
const $333fa1f6a20c9ea1$var$loaderWrapper = null;

});


parcelRegister("1fvLS", function(module, exports) {
$parcel$export(module.exports, "FieldBase", () => (parcelRequire("9QYFS")).default);

var $9QYFS = parcelRequire("9QYFS");

});
parcelRegister("9QYFS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccb773bb3548e3cb$export$2e2bcd8739ae039);
/* field-base.tsx generated by @compiled/babel-plugin v0.37.1 */ // Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @compiled/jsx-pragma

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");

var $1EFS8 = parcelRequire("1EFS8");

var $53Qft = parcelRequire("53Qft");
var $jsz0v = parcelRequire("jsz0v");

var $h82Rb = parcelRequire("h82Rb");

var $9pb7J = parcelRequire("9pb7J");

var $c7dQO = parcelRequire("c7dQO");
parcelRequire("13hup");
var $lUCWU = parcelRequire("lUCWU");
const $ccb773bb3548e3cb$var$ERROR_MESSAGE_ICON_A11Y_ISSUE = 'error_message_icon_a11y_issue';
const $ccb773bb3548e3cb$var$isErrorMessageIconA11yIssueEnabled = ()=>(0, $1EFS8.default).checkGate($ccb773bb3548e3cb$var$ERROR_MESSAGE_ICON_A11Y_ISSUE);
const $ccb773bb3548e3cb$var$FieldBase = ({ label: label, labelId: labelId, required: required, errorMessage: errorMessage, description: description, children: children, noLabel: noLabel, htmlFor: htmlFor, tooltip: tooltip })=>{
    const isCSMTypographyMigrationEnabled = (0, $c7dQO.useIsCSMTypographyMigrationEnabled)();
    const isErrorMessageIconEnabled = $ccb773bb3548e3cb$var$isErrorMessageIconA11yIssueEnabled();
    const renderField = ()=>noLabel ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ccb773bb3548e3cb$var$FieldContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $53Qft.Label), {
            htmlFor: htmlFor,
            id: labelId
        }, label, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jsz0v.default), null), isCSMTypographyMigrationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
            className: (0, $8n1kL.default)([
                "_1reo15vq _18m915vq _ogto7mnp _4t3it94y _kqswstnw _o5721q9c _1bsbt94y _p6m71wug _1chs1wug _1h2r1wug _umy61wug _106tstnw _11f21wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9pb7J.default), null, "(required)")) : // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ccb773bb3548e3cb$var$RequiredMessage, null, "(required)")), tooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, tooltip))), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        "data-test-id": `request-field-${htmlFor}`
    }, renderField(), !!errorMessage && (isCSMTypographyMigrationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        className: (0, $8n1kL.default)([
            "_19pk1b66 _syaz1tmw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9pb7J.default), {
        size: "small",
        color: "color.text.danger",
        testId: "field-error-text",
        id: "field-error",
        role: "status",
        "aria-live": "assertive"
    }, isErrorMessageIconEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        className: (0, $8n1kL.default)([
            "_2hwx1b66 _1e0c116y _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
        label: "error",
        size: "small",
        color: "var(--ds-text-danger, #AE2E24)"
    })), errorMessage)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ccb773bb3548e3cb$var$ErrorText, {
        "data-test-id": "field-error",
        id: "field-error",
        role: "status",
        "aria-live": "assertive"
    }, isErrorMessageIconEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        className: (0, $8n1kL.default)([
            "_2hwx1b66 _1e0c116y _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
        label: "error",
        size: "small",
        color: "var(--ds-text-danger, #AE2E24)"
    })), errorMessage))), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lUCWU.default), {
        id: `${htmlFor}-field-description`
    }, description));
};
var $ccb773bb3548e3cb$export$2e2bcd8739ae039 = $ccb773bb3548e3cb$var$FieldBase;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ccb773bb3548e3cb$var$ErrorText = /*#__PURE__*/ (0, $2UsNA.default).p.withConfig({
    componentId: "sc-1tyod05-0"
})`${$kBzhX.small};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-danger, #BF2600)"};`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ccb773bb3548e3cb$var$FieldContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_19pkpxbi _ca0qv77o",
            __cmplp.className
        ])
    });
});
const $ccb773bb3548e3cb$var$errorIconWrapperCSS = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ccb773bb3548e3cb$var$RequiredMessage = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1reo15vq _18m915vq _ogto7mnp _4t3it94y _kqswstnw _o5721q9c _1bsbt94y _p6m71wug _1chs1wug _1h2r1wug _umy61wug _106tstnw _11f21wug",
            __cmplp.className
        ])
    });
});
const $ccb773bb3548e3cb$var$requireMessageCSS = null;
const $ccb773bb3548e3cb$var$errorMessageCSS = null;

});
parcelRegister("13hup", function(module, exports) {
$parcel$export(module.exports, "FieldDescription", () => (parcelRequire("lUCWU")).default);

var $lUCWU = parcelRequire("lUCWU");

});
parcelRegister("lUCWU", function(module, exports) {
$parcel$export(module.exports, "default", () => $9db0f5f432850258$export$2e2bcd8739ae039);
/* field-description.tsx generated by @compiled/babel-plugin v0.37.1 */ // Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @compiled/jsx-pragma

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $2Doj8 = parcelRequire("2Doj8");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $l4a5B = parcelRequire("l4a5B");

var $eVE81 = parcelRequire("eVE81");

var $1EFS8 = parcelRequire("1EFS8");

var $9pb7J = parcelRequire("9pb7J");

var $iD9mC = parcelRequire("iD9mC");

var $hb5oz = parcelRequire("hb5oz");

var $c7dQO = parcelRequire("c7dQO");

var $iYO4A = parcelRequire("iYO4A");
class $9db0f5f432850258$export$873ced4623a3149c extends $8P7DW.PureComponent {
    componentDidMount() {
        this.checkIfShouldCollapse();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) this.checkIfShouldCollapse();
    }
    render() {
        const { intl: intl } = this.props;
        const { shouldCollapse: shouldCollapse, isOpen: isOpen } = this.state;
        const removeWidthObserver = (0, $1EFS8.default).checkGate('remove_widthobserver_from_field_description');
        return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, removeWidthObserver ? null : /*#__PURE__*/ $8P7DW.createElement((0, $iD9mC.WidthObserver), {
            setWidth: this.checkIfShouldCollapse
        }), shouldCollapse ? /*#__PURE__*/ $8P7DW.createElement($9db0f5f432850258$export$b7e78554be83b35d, {
            onClick: this.onToggle
        }, /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eVE81))), {
            expanded: isOpen,
            collapsedHeight: `${$9db0f5f432850258$export$4ea46454a0bad5c3}px`
        }, this.renderHelpText()), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
            migratedComponent: /*#__PURE__*/ $8P7DW.createElement("div", {
                className: (0, $8n1kL.default)([
                    "_syaz131l"
                ])
            }, /*#__PURE__*/ $8P7DW.createElement((0, $9pb7J.default), {
                size: "small",
                color: "color.text.subtlest",
                weight: "medium"
            }, intl.formatMessage(isOpen ? (0, $iYO4A.default).showLess : (0, $iYO4A.default).showMore)))
        }, /*#__PURE__*/ $8P7DW.createElement($9db0f5f432850258$export$5f734e3a73651e57, null, intl.formatMessage(isOpen ? (0, $iYO4A.default).showLess : (0, $iYO4A.default).showMore)))) : this.renderHelpText());
    }
    constructor(...args){
        super(...args), this.state = {
            shouldCollapse: false,
            isOpen: false
        }, this.helpTextRef = /*#__PURE__*/ $8P7DW.createRef(), this.checkIfShouldCollapse = ()=>{
            if (this.helpTextRef.current && (0, $hb5oz.getElementHeight)(this.helpTextRef.current) > $9db0f5f432850258$export$4ea46454a0bad5c3) this.setState({
                shouldCollapse: true
            });
            else if (this.state.shouldCollapse) this.setState({
                shouldCollapse: false
            });
        }, this.onToggle = (e)=>{
            e.preventDefault();
            this.setState((prevState)=>({
                    isOpen: !prevState.isOpen
                }));
        }, this.renderHelpText = ()=>{
            const { children: children, id: id } = this.props;
            if (typeof children === 'string') return /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement($9db0f5f432850258$export$29708599cbdda103, {
                    id: id,
                    innerRef: this.helpTextRef,
                    dangerouslySetInnerHTML: {
                        __html: children
                    }
                })
            }, /*#__PURE__*/ $8P7DW.createElement($9db0f5f432850258$export$a67c0bc59081311a, {
                id: id,
                innerRef: this.helpTextRef,
                dangerouslySetInnerHTML: {
                    __html: children
                }
            }));
            return /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement($9db0f5f432850258$export$29708599cbdda103, {
                    id: id,
                    innerRef: this.helpTextRef
                }, children)
            }, /*#__PURE__*/ $8P7DW.createElement($9db0f5f432850258$export$a67c0bc59081311a, {
                id: id,
                innerRef: this.helpTextRef
            }, children));
        };
    }
}
var $9db0f5f432850258$export$2e2bcd8739ae039 = (0, $l4a5B.default)($9db0f5f432850258$export$873ced4623a3149c);
const $9db0f5f432850258$export$a67c0bc59081311a = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-mimyi-0"
})`${$kBzhX.xsmall};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-subtlest, #6B778C)"};`;
const $9db0f5f432850258$export$29708599cbdda103 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-mimyi-1"
})`font:${"var(--ds-font-heading-xsmall, normal 600 0.875rem/1rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-subtlest, #6B778C)"};`;
const $9db0f5f432850258$export$5f734e3a73651e57 = /*#__PURE__*/ (0, $2UsNA.default).span.withConfig({
    componentId: "sc-mimyi-2"
})`${$kBzhX.xsmall};color:${"var(--ds-text-subtlest, #6B778C)"};font-weight:500;`;
const $9db0f5f432850258$var$buttonTextCSS = null;
const $9db0f5f432850258$export$b7e78554be83b35d = /*#__PURE__*/ (0, $2UsNA.default)((0, $2Doj8.default)).withConfig({
    componentId: "sc-mimyi-3"
})`display:block;`;
const $9db0f5f432850258$export$4ea46454a0bad5c3 = $4cxV2.multiple(4.5).unitless;

});
parcelRegister("eVE81", function(module, exports) {
"use strict";

var $dw9g1 = parcelRequire("dw9g1");

var $1ychu = parcelRequire("1ychu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ade584394a1e0543$var$_objectWithoutProperties2 = $dw9g1((parcelRequire("fczlm")));

var $ade584394a1e0543$var$_classCallCheck2 = $dw9g1((parcelRequire("3bFYv")));

var $ade584394a1e0543$var$_createClass2 = $dw9g1((parcelRequire("2fngX")));

var $ade584394a1e0543$var$_assertThisInitialized2 = $dw9g1((parcelRequire("k1oZn")));

var $ade584394a1e0543$var$_inherits2 = $dw9g1((parcelRequire("f16vF")));

var $ade584394a1e0543$var$_possibleConstructorReturn2 = $dw9g1((parcelRequire("3SkTb")));

var $ade584394a1e0543$var$_getPrototypeOf2 = $dw9g1((parcelRequire("4Oj7O")));

var $ade584394a1e0543$var$_defineProperty2 = $dw9g1((parcelRequire("cO17m")));

var $ade584394a1e0543$var$React = $ade584394a1e0543$var$_interopRequireWildcard((parcelRequire("8P7DW")));

var $ade584394a1e0543$var$_propTypes = $dw9g1((parcelRequire("93Fg7")));

var $ade584394a1e0543$var$_getTransitionTimeMs = $dw9g1((parcelRequire("cdLrj")));

var $gWgPx = parcelRequire("gWgPx");
var $ade584394a1e0543$var$_excluded = [
    "allowOverflowWhenOpen",
    "children",
    "collapsedHeight",
    "eagerRender",
    "expanded",
    "heightTransition",
    "onChangeEnd"
];
function $ade584394a1e0543$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ade584394a1e0543$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ade584394a1e0543$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $1ychu(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $ade584394a1e0543$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ade584394a1e0543$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ade584394a1e0543$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ade584394a1e0543$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $ade584394a1e0543$var$_defineProperty2["default"])(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ade584394a1e0543$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ade584394a1e0543$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ade584394a1e0543$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $ade584394a1e0543$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ade584394a1e0543$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $ade584394a1e0543$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $ade584394a1e0543$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $ade584394a1e0543$var$SmoothCollapse = /*#__PURE__*/ function(_React$Component) {
    (0, $ade584394a1e0543$var$_inherits2["default"])(SmoothCollapse, _React$Component);
    var _super = $ade584394a1e0543$var$_createSuper(SmoothCollapse);
    function SmoothCollapse(props) {
        var _this;
        (0, $ade584394a1e0543$var$_classCallCheck2["default"])(this, SmoothCollapse);
        _this = _super.call(this, props);
        (0, $ade584394a1e0543$var$_defineProperty2["default"])((0, $ade584394a1e0543$var$_assertThisInitialized2["default"])(_this), "_removeTransitionEndListener", function() {});
        (0, $ade584394a1e0543$var$_defineProperty2["default"])((0, $ade584394a1e0543$var$_assertThisInitialized2["default"])(_this), "_main", /*#__PURE__*/ $ade584394a1e0543$var$React.createRef());
        (0, $ade584394a1e0543$var$_defineProperty2["default"])((0, $ade584394a1e0543$var$_assertThisInitialized2["default"])(_this), "_inner", /*#__PURE__*/ $ade584394a1e0543$var$React.createRef());
        (0, $ade584394a1e0543$var$_defineProperty2["default"])((0, $ade584394a1e0543$var$_assertThisInitialized2["default"])(_this), "_onNextTransitionEnd", function(el, callback) {
            _this._removeTransitionEndListener();
            var listener = function listener() {
                _this._removeTransitionEndListener();
                callback();
            };
            var timeout;
            _this._removeTransitionEndListener = function() {
                _this._removeTransitionEndListener = function() {};
                clearTimeout(timeout);
                el.removeEventListener('transitionend', listener);
            }; // Wait until the transitionend event, or until a timer goes off in
            // case the event doesn't fire because the browser doesn't support it
            // or the element is hidden before it happens. The timer is a little
            // longer than the transition is supposed to take to make sure we don't
            // cut the animation early while it's still going if the browser is
            // running it just a little slow.
            el.addEventListener('transitionend', listener);
            var ms = (0, $ade584394a1e0543$var$_getTransitionTimeMs["default"])(_this.props.heightTransition) * 1.1 + 500;
            timeout = setTimeout(listener, ms);
        });
        _this.state = {
            renderInner: props.expanded || SmoothCollapse._visibleWhenClosed(props),
            closing: false,
            fullyClosed: !props.expanded,
            height: props.expanded ? 'auto' : props.collapsedHeight
        };
        return _this;
    }
    (0, $ade584394a1e0543$var$_createClass2["default"])(SmoothCollapse, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._removeTransitionEndListener();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                if (!prevProps.expanded && this.props.expanded) {
                    this._removeTransitionEndListener();
                    var mainEl = this._main.current;
                    var innerEl = this._inner.current;
                    if (!mainEl || !innerEl) throw new Error('Should not happen'); // Set the collapser to the target height instead of auto so that it
                    // animates correctly. Then switch it to 'auto' after the animation so
                    // that it flows correctly if the page is resized.
                    var targetHeight = "".concat(innerEl.clientHeight, "px");
                    this.setState({
                        height: targetHeight
                    });
                    this._onNextTransitionEnd(mainEl, function() {
                        _this2.setState({
                            height: 'auto'
                        }, function() {
                            if (_this2.props.onChangeEnd) _this2.props.onChangeEnd();
                        });
                    });
                } else if (prevProps.expanded && !this.props.expanded) {
                    this._removeTransitionEndListener();
                    if (!this._inner.current) throw new Error('Should not happen');
                    this.setState({
                        height: "".concat(this._inner.current.clientHeight, "px")
                    }, function() {
                        var mainEl = _this2._main.current;
                        if (!mainEl) throw new Error('Should not happen');
                        mainEl.clientHeight; // force the page layout
                        _this2.setState({
                            height: _this2.props.collapsedHeight,
                            closing: true
                        });
                        _this2._onNextTransitionEnd(mainEl, function() {
                            _this2.setState({
                                closing: false,
                                fullyClosed: true
                            });
                            if (_this2.props.onChangeEnd) _this2.props.onChangeEnd();
                        });
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var visibleWhenClosed = SmoothCollapse._visibleWhenClosed(this.props);
                var _this$props = this.props, allowOverflowWhenOpen = _this$props.allowOverflowWhenOpen, children = _this$props.children, collapsedHeight = _this$props.collapsedHeight, eagerRender = _this$props.eagerRender, expanded = _this$props.expanded, heightTransition = _this$props.heightTransition, onChangeEnd = _this$props.onChangeEnd, props = (0, $ade584394a1e0543$var$_objectWithoutProperties2["default"])(_this$props, $ade584394a1e0543$var$_excluded);
                var _this$state = this.state, height = _this$state.height, fullyClosed = _this$state.fullyClosed, renderInner = _this$state.renderInner;
                var innerEl = renderInner ? /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    ref: this._inner,
                    style: {
                        overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden'
                    },
                    children: children
                }) : null;
                return /*#__PURE__*/ (0, $gWgPx.jsx)("div", $ade584394a1e0543$var$_objectSpread($ade584394a1e0543$var$_objectSpread({}, props), {}, {
                    ref: this._main,
                    style: {
                        height: height,
                        overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden',
                        display: fullyClosed && !visibleWhenClosed ? 'none' : null,
                        transition: "height ".concat(heightTransition)
                    },
                    children: innerEl
                }));
            }
        }
    ], [
        {
            key: "_visibleWhenClosed",
            value: function _visibleWhenClosed(props) {
                return props.eagerRender || parseFloat(props.collapsedHeight) !== 0;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (props.expanded && (state.closing || state.fullyClosed)) return {
                    closing: false,
                    fullyClosed: false,
                    renderInner: true
                };
                else if (!props.expanded && (state.closing || state.fullyClosed) && state.height !== props.collapsedHeight) return {
                    height: props.collapsedHeight,
                    renderInner: state.renderInner || SmoothCollapse._visibleWhenClosed(props)
                };
                return null;
            }
        }
    ]);
    return SmoothCollapse;
}($ade584394a1e0543$var$React.Component);
module.exports["default"] = $ade584394a1e0543$var$SmoothCollapse;
(0, $ade584394a1e0543$var$_defineProperty2["default"])($ade584394a1e0543$var$SmoothCollapse, "propTypes", {
    expanded: $ade584394a1e0543$var$_propTypes["default"].bool.isRequired,
    onChangeEnd: $ade584394a1e0543$var$_propTypes["default"].func,
    collapsedHeight: $ade584394a1e0543$var$_propTypes["default"].string,
    heightTransition: $ade584394a1e0543$var$_propTypes["default"].string,
    className: $ade584394a1e0543$var$_propTypes["default"].string,
    allowOverflowWhenOpen: $ade584394a1e0543$var$_propTypes["default"].bool,
    eagerRender: $ade584394a1e0543$var$_propTypes["default"].bool
});
(0, $ade584394a1e0543$var$_defineProperty2["default"])($ade584394a1e0543$var$SmoothCollapse, "defaultProps", {
    collapsedHeight: '0',
    heightTransition: '.25s ease',
    className: '',
    allowOverflowWhenOpen: false,
    eagerRender: false
});

});
parcelRegister("fczlm", function(module, exports) {

var $9wUL7 = parcelRequire("9wUL7");
function $b11364814cc5a143$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $9wUL7(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $b11364814cc5a143$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3bFYv", function(module, exports) {
function $2522f583c9808a1e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $2522f583c9808a1e$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2fngX", function(module, exports) {

var $MYMsF = parcelRequire("MYMsF");
function $1a2f08ed9076d371$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $MYMsF(o.key), o);
    }
}
function $1a2f08ed9076d371$var$_createClass(e, r, t) {
    return r && $1a2f08ed9076d371$var$_defineProperties(e.prototype, r), t && $1a2f08ed9076d371$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $1a2f08ed9076d371$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f16vF", function(module, exports) {

var $8laJj = parcelRequire("8laJj");
function $aeebffb095be9a39$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $8laJj(t, e);
}
module.exports = $aeebffb095be9a39$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3SkTb", function(module, exports) {

var $1ychu = parcelRequire("1ychu");
var $2d269e5bc737edb2$var$_typeof = $1ychu.default;

var $k1oZn = parcelRequire("k1oZn");
function $2d269e5bc737edb2$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $2d269e5bc737edb2$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $k1oZn(t);
}
module.exports = $2d269e5bc737edb2$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cdLrj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $8e5b7f6bd40a5a32$var$getTransitionTimeMs;
function $8e5b7f6bd40a5a32$var$getTransitionTimeMs(heightTransition) {
    var m = /(\d+(?:\.\d+)?|\.\d+)(m?s)\b/i.exec(heightTransition);
    if (!m) throw new Error('Could not parse time from transition value');
    return Number(m[1]) * (m[2].length === 1 ? 1000 : 1);
}

});


parcelRegister("iYO4A", function(module, exports) {
$parcel$export(module.exports, "default", () => $05ef3a31031f64b1$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $05ef3a31031f64b1$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    showMore: {
        defaultMessage: 'Show more...',
        description: 'Button action text to expand a form fields description',
        id: 'cv.field-base.description.show-more'
    },
    showLess: {
        defaultMessage: 'Show less...',
        description: 'Button action text to collapse a form fields description',
        id: 'cv.field-base.description.show-less'
    }
});

});





parcelRegister("5Xax4", function(module, exports) {
$parcel$export(module.exports, "TextField", () => (parcelRequire("jxZlp")).default);
$parcel$export(module.exports, "ControlledTextField", () => (parcelRequire("jxZlp")).ControlledTextField);

var $jxZlp = parcelRequire("jxZlp");

});
parcelRegister("jxZlp", function(module, exports) {
$parcel$export(module.exports, "default", () => $13d4f5dbb3bfd808$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ControlledTextField", () => $13d4f5dbb3bfd808$export$befa4be8e9119768);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $1We2B = parcelRequire("1We2B");
parcelRequire("1fvLS");
var $9QYFS = parcelRequire("9QYFS");

var $1EFS8 = parcelRequire("1EFS8");

var $gFpea = parcelRequire("gFpea");
parcelRequire("kbY4O");
var $azHRf = parcelRequire("azHRf");
const $13d4f5dbb3bfd808$var$ariaRequiredToTextFieldEnabled = ()=>{
    return (0, $1EFS8.default).checkGate('add_aria-required_to_text_field_');
};
class $13d4f5dbb3bfd808$export$2e2bcd8739ae039 extends $8P7DW.PureComponent {
    static #_ = this.defaultProps = {
        shouldFitContainer: true,
        type: 'text'
    };
    render() {
        const { id: id, testId: testId, label: label, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, maxLength: maxLength, disabled: disabled, render: render, placeholder: placeholder, isLabelHidden: isLabelHidden, type: type, autoFocus: autoFocus, value: value, onFocus: onFocus, onKeyDown: onKeyDown, ariaDescribedby: ariaDescribedby, autoComplete: autoComplete, ariaLabelledby: ariaLabelledby, tooltip: tooltip, isInvalid: isInvalidProp } = this.props;
        const isInvalid = isInvalidProp || !(0, $1We2B.isEmpty)(errorMessage);
        const inputType = type;
        /** Currently to match the legacy behavior in some cases we are passing both value and defaultValue
     * there will be a sentry alert to either use controlled or uncontrolled but not both
     * to prevent this we only pass one of value or defaultValue
     * such scenarios can be avoided once we clean the legacy code
     * when cleaning up feature flag see if this can be removed
     */ const isValueDefined = typeof value === 'string';
        const textFieldValueProps = isValueDefined ? {
            value: value
        } : {
            defaultValue: defaultValue
        };
        const ariaDescribedByText = ariaDescribedby || `${id}-field-description ${isInvalid ? 'field-error' : ''}`;
        const ariaLabelledByText = ariaLabelledby || `${id}-label`;
        const field = /*#__PURE__*/ $8P7DW.createElement((0, $gFpea.default), {
            id: id,
            testId: testId,
            name: id,
            "aria-describedby": ariaDescribedByText,
            "aria-labelledby": ariaLabelledByText,
            "aria-invalid": isInvalid,
            ...$13d4f5dbb3bfd808$var$ariaRequiredToTextFieldEnabled() ? {
                'aria-required': required
            } : {},
            ...textFieldValueProps,
            onChange: this.onChange,
            isInvalid: isInvalid,
            isDisabled: disabled,
            placeholder: placeholder,
            type: inputType,
            maxLength: maxLength,
            autoFocus: autoFocus,
            onFocus: onFocus,
            onBlur: this.onBlur,
            onKeyDown: onKeyDown,
            autoComplete: autoComplete
        });
        return /*#__PURE__*/ $8P7DW.createElement((0, $9QYFS.default), {
            htmlFor: id,
            label: label,
            required: required,
            description: description,
            errorMessage: errorMessage,
            noLabel: isLabelHidden,
            labelId: `${id}-label`,
            ...(0, $HGACo.isUiModificationsSupportEnabled)() ? {
                tooltip: tooltip
            } : null
        }, render ? render(field) : field);
    }
    constructor(...args){
        super(...args), this.inputRef = /*#__PURE__*/ $8P7DW.createRef(), //TODO - We need to find a better way to add focus to input field when there is an error. This should be done in the form component. https://hello.jira.atlassian.cloud/browse/CHANNELSUI-258
        this.onChange = (e)=>{
            if (this.props.onChange) this.props.onChange(this.props.id, e.target.value, false, {
                rawObject: e,
                rawValue: e.target.value
            });
        }, this.onBlur = (e)=>{
            if (this.props.onFieldBlurredByUser) this.props.onFieldBlurredByUser({
                field: this.props.id,
                value: e.target.value,
                additionalFieldData: {
                    rawObject: e,
                    rawValue: e.target.value
                }
            });
            if (this.props.onBlur) this.props.onBlur();
        };
    }
}
const $13d4f5dbb3bfd808$export$befa4be8e9119768 = (0, $azHRf.withControlledFormComponentValue)((_field, value)=>value)($13d4f5dbb3bfd808$export$2e2bcd8739ae039);

});
parcelRegister("kbY4O", function(module, exports) {
$parcel$export(module.exports, "withControlledFormComponentValue", () => (parcelRequire("azHRf")).withControlledFormComponentValue);

var $azHRf = parcelRequire("azHRf");

});
parcelRegister("azHRf", function(module, exports) {
$parcel$export(module.exports, "withControlledFormComponentValue", () => $e588b2781bc28b1a$export$cd499d091f6810cd);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $curyK = parcelRequire("curyK");
function $e588b2781bc28b1a$export$cd499d091f6810cd(mapOnChangeValue, valueTransformer) {
    return (FormComponent)=>class ControlledFormComponentWrapper extends $8P7DW.PureComponent {
            static #_ = this.displayName = 'ControlledFormComponentWrapper';
            componentDidUpdate(prevProps, prevState) {
                // Handle valueOverride changes (UI Modifications)
                if (this.checkIsValueOverride() && this.props.valueOverride !== prevProps.valueOverride && this.props.valueOverride !== prevState.controlledValue) this.setState({
                    controlledValue: this.props.valueOverride
                });
                // Handle external value changes (native automation rules, form resets, etc.)
                if ((0, $HGACo.isMultiSelectEnabled)() && this.props.value !== prevProps.value && this.props.value !== prevState.controlledValue && !this.checkIsValueOverride()) this.setState({
                    controlledValue: this.props.value
                });
            }
            render() {
                const { defaultValue: _1, value: _2, valueOverride: _3, onChange: _4, ...remainingProps } = this.props;
                if ((0, $HGACo.isUiModificationsSupportEnabled)()) {
                    const transformedValue = valueTransformer ? valueTransformer(this.state.controlledValue) : this.state.controlledValue;
                    const componentProps = {
                        ...remainingProps,
                        value: transformedValue,
                        onChange: this.onChange,
                        shouldReplaceValue: this.checkIsValueOverride()
                    };
                    return /*#__PURE__*/ $8P7DW.createElement((0, $curyK.FieldDecoratorAsync), {
                        Component: FormComponent,
                        componentProps: componentProps
                    });
                }
                return /*#__PURE__*/ $8P7DW.createElement(FormComponent, {
                    ...remainingProps,
                    value: this.state.controlledValue,
                    onChange: this.onChange
                });
            }
            constructor(...args){
                super(...args), this.checkIsValueOverride = ()=>{
                    if (this.props.valueOverride === null || this.props.valueOverride === '' || this.props.valueOverride) return true;
                    return false;
                }, this.state = {
                    controlledValue: this.checkIsValueOverride() ? this.props.valueOverride : this.props.defaultValue
                }, this.onChange = (...args)=>{
                    var _this$props$onChange, _this$props;
                    this.setState({
                        controlledValue: mapOnChangeValue(...args)
                    });
                    (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, ...args);
                };
            }
        };
}

});
parcelRegister("curyK", function(module, exports) {
$parcel$export(module.exports, "FieldDecoratorAsync", () => $8740e5f6d9cdb9ae$export$7bf1fdc8d847e1ea);

var $8P7DW = parcelRequire("8P7DW");

var $8MVOi = parcelRequire("8MVOi");
var $2t9fp = parcelRequire("2t9fp");

var $9Qkcz = parcelRequire("9Qkcz");

var $29Aem = parcelRequire("29Aem");
const $8740e5f6d9cdb9ae$var$FieldDecoratorAsyncNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const isUiModificationsEnabled = (0, $2t9fp.useAdjustmentsEnabled)();
    const undecoratedComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, componentProps);
    if (!isUiModificationsEnabled) return undecoratedComponent;
    if (!(0, $8MVOi.isFieldTypeSupported)((0, $9Qkcz.REQUEST_CREATE_VIEW_TYPE), componentProps.jiraFieldType ?? componentProps.id)) return undecoratedComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $29Aem.EnabledFieldDecorator), {
        componentProps: componentProps,
        Component: Component
    });
};
const $8740e5f6d9cdb9ae$export$7bf1fdc8d847e1ea = /*#__PURE__*/ (0, $8P7DW.memo)($8740e5f6d9cdb9ae$var$FieldDecoratorAsyncNoMemo);

});
parcelRegister("29Aem", function(module, exports) {
$parcel$export(module.exports, "EnabledFieldDecorator", () => $d2de0e23a3316c9d$export$a39682472306ffd4);

var $8P7DW = parcelRequire("8P7DW");

var $6gHxW = parcelRequire("6gHxW");

var $cGuaG = parcelRequire("cGuaG");
const $d2de0e23a3316c9d$var$EnabledFieldDecoratorNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const { id: id } = componentProps;
    const isBusy = (0, $cGuaG.useFieldIsBusy)(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, {
        ...componentProps,
        ...isBusy ? {
            disabled: true,
            isDisabled: true,
            tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6gHxW.FieldBusyIndicator), {
                fieldId: id
            })
        } : {}
    });
};
const $d2de0e23a3316c9d$export$a39682472306ffd4 = /*#__PURE__*/ (0, $8P7DW.memo)($d2de0e23a3316c9d$var$EnabledFieldDecoratorNoMemo);

});
parcelRegister("6gHxW", function(module, exports) {
$parcel$export(module.exports, "FieldBusyIndicator", () => $2f434a845f274c0e$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $k7INq = parcelRequire("k7INq");

var $2GReq = parcelRequire("2GReq");

var $cjn3r = parcelRequire("cjn3r");

var $ea6bZ = parcelRequire("ea6bZ");

var $huz3N = parcelRequire("huz3N");
const $2f434a845f274c0e$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $8P7DW.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const loadingMessage = formatMessage((0, $huz3N.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ea6bZ.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($2f434a845f274c0e$export$4e31364808fb7483, {
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2GReq.default), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                    testId: indicatorId,
                    size: "small"
                })
            })
        })
    });
});
$2f434a845f274c0e$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
const $2f434a845f274c0e$export$4e31364808fb7483 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2GReq", function(module, exports) {
$parcel$export(module.exports, "default", () => $042ba8283ae4cda2$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $90lTs = parcelRequire("90lTs");
function $042ba8283ae4cda2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $90lTs.default), {
        ...props
    });
}

});
parcelRegister("90lTs", function(module, exports) {
$parcel$export(module.exports, "default", () => $45339169b3e98e1e$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $9uKqY = parcelRequire("9uKqY");
/**
 * Prevent a subtree from holding up an interaction
 * Use this when you have a component which loads in late, but
 * isn't considered to be a breach of SLO
 *
 * ```js
 * <App>
 *   <Main />
 *   <Sidebar>
 *     <UFOIgnoreHolds>
 *       <InsightsButton />
 *     </UFOIgnoreHolds>
 *   </Sidebar>
 * </App>
 * ```
 *
 * Has an `ignore` prop, to allow you to use it conditionally
 * Has a `reason` prop, to specify why the hold is being ignored
 */ const $45339169b3e98e1e$var$UFOIgnoreHolds = ({ children: children, ignore: ignore = true })=>{
    const parentContext = (0, $8P7DW.useContext)((0, $9uKqY.default));
    const ignoredInteractionContext = (0, $8P7DW.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: kids
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9uKqY.default).Provider, {
        value: ignoredInteractionContext,
        children: kids
    });
};
$45339169b3e98e1e$var$UFOIgnoreHolds.displayName = 'UFOIgnoreHolds';
var $45339169b3e98e1e$export$2e2bcd8739ae039 = $45339169b3e98e1e$var$UFOIgnoreHolds;

});


parcelRegister("huz3N", function(module, exports) {
$parcel$export(module.exports, "default", () => $47b54806a1cad224$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $47b54806a1cad224$var$_default_1 = (0, $6K2Gm.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
        defaultMessage: 'Loading UI modifications...',
        description: 'A tooltip message showed on UI modifications loading icon on each loading field'
    }
});
var $47b54806a1cad224$export$2e2bcd8739ae039 = $47b54806a1cad224$var$_default_1;

});


parcelRegister("cGuaG", function(module, exports) {
$parcel$export(module.exports, "useFieldIsBusy", () => $665894d59b9a121b$export$b4ae28da91c35ed4);

var $iW8tR = parcelRequire("iW8tR");

var $ex5tK = parcelRequire("ex5tK");

var $8oBRi = parcelRequire("8oBRi");
const $665894d59b9a121b$export$b4ae28da91c35ed4 = (fieldId)=>{
    const [isBusyData] = (0, $8oBRi.useFieldIsProcessing)(fieldId);
    const uimConsentMap = (0, $iW8tR.useUIModificationsConsentStatusForApps)();
    const { isBusy: isBusy, appsIds: appsIds } = isBusyData;
    if (!isBusy) return false;
    return appsIds.some((appId)=>uimConsentMap[appId] !== (0, $ex5tK.UIM_CONSENT_REQUIRED));
};

});
parcelRegister("iW8tR", function(module, exports) {
$parcel$export(module.exports, "useUIModificationsConsentStatusForApp", () => $0f0d2850b4fd518e$export$7700bb22109a011e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApps", () => $0f0d2850b4fd518e$export$2a5a8f1570c161c6);

var $lJS87 = parcelRequire("lJS87");
var $6xLCs = parcelRequire("6xLCs");

var $2t9fp = parcelRequire("2t9fp");

var $ex5tK = parcelRequire("ex5tK");
const $0f0d2850b4fd518e$var$selectOverallConsentStatus = (0, $lJS87.createSelector)((state)=>state.uiModificationsConsentStatus, (consentMap)=>Object.values(consentMap).includes((0, $ex5tK.UIM_CONSENT_REQUIRED)) ? (0, $ex5tK.UIM_CONSENT_REQUIRED) : (0, $ex5tK.UIM_CONSENT_CONSENTED));
const $0f0d2850b4fd518e$export$e2c526d2c1843a0e = (0, $6xLCs.createStateHook)((0, $2t9fp.store), {
    selector: $0f0d2850b4fd518e$var$selectOverallConsentStatus
});
const $0f0d2850b4fd518e$export$7700bb22109a011e = (0, $6xLCs.createStateHook)((0, $2t9fp.store), {
    selector: (state, { appId: appId })=>state.uiModificationsConsentStatus[appId] || (0, $ex5tK.UIM_CONSENT_UNKNOWN)
});
const $0f0d2850b4fd518e$export$2a5a8f1570c161c6 = (0, $6xLCs.createStateHook)((0, $2t9fp.store), {
    selector: (state)=>state.uiModificationsConsentStatus
});

});
parcelRegister("ex5tK", function(module, exports) {
$parcel$export(module.exports, "UIM_CONSENT_UNKNOWN", () => $1421e8044089725f$export$39d15f3568f5a72c);
$parcel$export(module.exports, "UIM_CONSENT_REQUIRED", () => $1421e8044089725f$export$d67d63332ce3ce38);
$parcel$export(module.exports, "UIM_CONSENT_CONSENTED", () => $1421e8044089725f$export$45ca911896c5084f);
const $1421e8044089725f$export$39d15f3568f5a72c = 'unknown';
const $1421e8044089725f$export$d67d63332ce3ce38 = 'required';
const $1421e8044089725f$export$45ca911896c5084f = 'consented';

});


parcelRegister("8oBRi", function(module, exports) {
$parcel$export(module.exports, "useFieldIsProcessing", () => $37d83efa15de14d2$export$7fa63f8479e2806a);

var $cmTnD = parcelRequire("cmTnD");

var $6xLCs = parcelRequire("6xLCs");
var $lJS87 = parcelRequire("lJS87");

var $2FT8E = parcelRequire("2FT8E");
const $37d83efa15de14d2$export$9076a5ac331011bb = (0, $lJS87.createSelector)((state)=>state.registeredFields, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChangesMap, error, fieldId)=>{
    if (error) return {
        isBusy: false,
        appsIds: []
    };
    const appsIds = Object.entries(registeredChangesMap).filter(([_, registeredFields])=>!(0, (/*@__PURE__*/$parcel$interopDefault($cmTnD)))(registeredFields) && Object.values(registeredFields).flat().includes(fieldId)).map(([appId])=>appId);
    return {
        isBusy: appsIds.length > 0,
        appsIds: appsIds
    };
});
const $37d83efa15de14d2$export$7fa63f8479e2806a = (0, $6xLCs.createHook)((0, $2FT8E.store), {
    selector: $37d83efa15de14d2$export$9076a5ac331011bb
});

});








parcelRegister("hZDsh", function(module, exports) {
$parcel$export(module.exports, "PasswordField", () => (parcelRequire("7ZQXi")).default);

var $7ZQXi = parcelRequire("7ZQXi");

});
parcelRegister("7ZQXi", function(module, exports) {
$parcel$export(module.exports, "PasswordField", () => $0540fc6041d67e40$export$65ed9482db2257fa);
$parcel$export(module.exports, "default", () => $0540fc6041d67e40$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $8y05I = parcelRequire("8y05I");

var $l4a5B = parcelRequire("l4a5B");
parcelRequire("5YpAf");
var $dkHCW = parcelRequire("dkHCW");

var $elt7A = parcelRequire("elt7A");

var $3ZNUN = parcelRequire("3ZNUN");

var $gFpea = parcelRequire("gFpea");

var $ea6bZ = parcelRequire("ea6bZ");
parcelRequire("3hlyC");
var $2RjkG = parcelRequire("2RjkG");

var $meCbu = parcelRequire("meCbu");
class $0540fc6041d67e40$export$65ed9482db2257fa extends $8P7DW.Component {
    render() {
        const { autoFocus: autoFocus, intl: intl, id: id, maxLength: maxLength, value: value, isDisabled: isDisabled, isInvalid: isInvalid, weakPasswords: weakPasswords, errorMessage: errorMessage, hideStrengthMeter: hideStrengthMeter, testId: testId, onKeyDown: onKeyDown } = this.props;
        const { showPassword: showPassword } = this.state;
        const passwordFieldType = showPassword ? 'text' : 'password';
        const shouldRenderStrengthMeter = !hideStrengthMeter;
        return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $gFpea.default), {
            id: id,
            testId: testId,
            type: passwordFieldType,
            maxLength: maxLength,
            onChange: this.onChange,
            isDisabled: isDisabled,
            autoFocus: autoFocus,
            isInvalid: isInvalid,
            value: value,
            elemAfterInput: this.renderShowHideButton(),
            onKeyDown: onKeyDown
        }), isInvalid && errorMessage && /*#__PURE__*/ $8P7DW.createElement((0, $2RjkG.default), {
            errorMessage: errorMessage
        }), shouldRenderStrengthMeter && /*#__PURE__*/ $8P7DW.createElement((0, $dkHCW.default), {
            intl: intl,
            password: value,
            scoreWords: weakPasswords
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            showPassword: false
        }, this.onChange = (e)=>{
            this.props.onChange(e.target.value);
        }, this.onShowPasswordToggle = ()=>{
            this.setState((prevState)=>({
                    showPassword: !prevState.showPassword
                }));
        }, this.renderShowHideButton = ()=>{
            const { intl: intl, isDisabled: isDisabled } = this.props;
            const { showPassword: showPassword } = this.state;
            const buttonActionPrefix = showPassword ? 'hide' : 'show';
            const togglePasswordButtonDescription = showPassword ? intl.formatMessage((0, $meCbu.default).hidePassword) : intl.formatMessage((0, $meCbu.default).showPassword);
            const icon = showPassword ? /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZNUN))), {
                spacing: "spacious",
                testId: "watch-filled-icon",
                label: togglePasswordButtonDescription
            }) : /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($elt7A))), {
                spacing: "spacious",
                testId: "watch-icon",
                label: togglePasswordButtonDescription
            });
            return /*#__PURE__*/ $8P7DW.createElement((0, $ea6bZ.default), {
                content: togglePasswordButtonDescription
            }, /*#__PURE__*/ $8P7DW.createElement((0, $8y05I.Button), {
                actionSubjectId: `${buttonActionPrefix}-password`,
                appearance: "subtle",
                isDisabled: isDisabled,
                onClick: this.onShowPasswordToggle,
                iconBefore: /*#__PURE__*/ $8P7DW.createElement($0540fc6041d67e40$var$IconContainer, null, icon)
            }));
        };
    }
}
var $0540fc6041d67e40$export$2e2bcd8739ae039 = (0, $l4a5B.default)($0540fc6041d67e40$export$65ed9482db2257fa);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0540fc6041d67e40$var$IconContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-19v26xn-0"
})`padding-right:${"var(--ds-space-025, 2px)"};margin-left:${"var(--ds-space-negative-025, -2px)"};`;

});
parcelRegister("5YpAf", function(module, exports) {
$parcel$export(module.exports, "AsyncLoadedPasswordStrengthMeter", () => (parcelRequire("dkHCW")).default);

var $dkHCW = parcelRequire("dkHCW");

});
parcelRegister("dkHCW", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a61f74f57258920$export$2e2bcd8739ae039);
/**
 * Heavily inspired by https://stash.atlassian.com/projects/AID/repos/aid-frontend/browse/src/components/PasswordStrengthMeter.tsx.
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $1We2B = parcelRequire("1We2B");

var $nJL8q = parcelRequire("nJL8q");

var $a3Ha6 = parcelRequire("a3Ha6");

var $jMvfB = parcelRequire("jMvfB");
const $6a61f74f57258920$var$passwordAnalyzerUrl = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js';
const $6a61f74f57258920$var$splitter = /\W+/;
const $6a61f74f57258920$var$STRENGTH_SCORE_DEBOUNCE_IN_MILLIS = 200;
class $6a61f74f57258920$export$eebfb7c0549090 extends $8P7DW.Component {
    render() {
        const { score: score } = this.state;
        const strengthText = this.getStrengthTextForScore(score);
        return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement($6a61f74f57258920$export$bbc6c6369b38e3d1, {
            "data-testid": "password-strength-bar",
            score: score
        }, /*#__PURE__*/ $8P7DW.createElement($6a61f74f57258920$var$Dividers, null)), /*#__PURE__*/ $8P7DW.createElement($6a61f74f57258920$export$8d13340382210b65, {
            "data-testid": "password-strength-hint"
        }, strengthText));
    }
    constructor(...args){
        super(...args), this.state = {
            score: null
        }, this.calculateScoreDebounced = (0, $1We2B.debounce)(()=>{
            const { password: password, scoreWords: scoreWords, zxcvbn: passwordAnalyzer } = this.props;
            const result = passwordAnalyzer && password ? passwordAnalyzer(password, scoreWords) : null;
            this.setState({
                score: result ? result.score : null
            });
        }, $6a61f74f57258920$var$STRENGTH_SCORE_DEBOUNCE_IN_MILLIS), this.componentDidUpdate = (prevProps)=>{
            if (this.props.password === prevProps.password) return;
            if (!this.props.password) {
                this.setState({
                    score: null
                });
                return;
            }
            this.calculateScoreDebounced();
        }, this.getStrengthTextForScore = (score)=>{
            const { intl: intl, password: password, zxcvbn: passwordAnalyzer } = this.props;
            if (!password) return '';
            if (password.length < (0, $a3Ha6.MIN_PASSWORD_LENGTH_IN_CHARS)) return this.props.intl.formatMessage((0, $jMvfB.default).passwordInvalid);
            if (!passwordAnalyzer) return intl.formatMessage((0, $jMvfB.default).passwordStrengthUnavailable);
            return score !== null ? this.mapScoreToStrengthText(score) : '';
        }, this.mapScoreToStrengthText = (score)=>{
            let strengthText;
            switch(score){
                case 0:
                    strengthText = (0, $jMvfB.default).passwordStrengthLevel0;
                    break;
                case 1:
                    strengthText = (0, $jMvfB.default).passwordStrengthLevel1;
                    break;
                case 2:
                    strengthText = (0, $jMvfB.default).passwordStrengthLevel2;
                    break;
                case 3:
                    strengthText = (0, $jMvfB.default).passwordStrengthLevel3;
                    break;
                case 4:
                    strengthText = (0, $jMvfB.default).passwordStrengthLevel4;
                    break;
                default:
                    strengthText = (0, $jMvfB.default).passwordStrengthUnavailable;
            }
            return this.props.intl.formatMessage(strengthText);
        };
    }
}
const $6a61f74f57258920$export$6672436889ec70b1 = (0, $nJL8q.default)($6a61f74f57258920$var$passwordAnalyzerUrl, {
    globalName: 'zxcvbn'
})($6a61f74f57258920$export$eebfb7c0549090);
var $6a61f74f57258920$export$2e2bcd8739ae039 = $6a61f74f57258920$export$6672436889ec70b1;
const $6a61f74f57258920$var$addUnique = (seen, chunk)=>seen.includes(chunk) ? seen : [
        ...seen,
        chunk
    ];
function $6a61f74f57258920$export$9e2ea7bf181a4f5(strings) {
    const deduped = strings.reduce($6a61f74f57258920$var$addUnique, []);
    return deduped.reduce((arr, str)=>str.split($6a61f74f57258920$var$splitter).reduce($6a61f74f57258920$var$addUnique, arr), deduped);
}
const $6a61f74f57258920$var$leftPercentage = '19%';
const $6a61f74f57258920$var$rightPercentage = '19%';
const $6a61f74f57258920$var$leftPercentageAfter = '30%';
const $6a61f74f57258920$var$rightPercentageAfter = '30%';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6a61f74f57258920$var$Dividers = /*#__PURE__*/ (0, $2UsNA.default).span.withConfig({
    componentId: "sc-2owkvn-0"
})`border-left:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};border-right:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};bottom:0;left:${$6a61f74f57258920$var$leftPercentage};position:absolute;right:${$6a61f74f57258920$var$rightPercentage};top:0;&::after{border-left:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};border-right:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};bottom:0;content:'';left:${$6a61f74f57258920$var$leftPercentageAfter};position:absolute;right:${$6a61f74f57258920$var$rightPercentageAfter};top:0;}`;
const $6a61f74f57258920$var$barWidths = [
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $6a61f74f57258920$var$barColours = [
    "var(--ds-chart-danger-bold, #BF2600)",
    "var(--ds-chart-danger, #FF5630)",
    "var(--ds-chart-warning, #FFAB00)",
    "var(--ds-chart-success, #36B37E)",
    "var(--ds-chart-success-bold, #00875A)"
];
const $6a61f74f57258920$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-2owkvn-1"
})`background:${"var(--ds-chart-neutral, #DFE1E6)"};height:${$4cxV2.multiple(0.25).px};margin-top:${"var(--ds-space-075, 6px)"};position:relative;&::before{background-color:${(props)=>props.score === null ? "var(--ds-chart-neutral, #DFE1E6)" : $6a61f74f57258920$var$barColours[props.score]};bottom:0;content:'';left:0;position:absolute;top:0;transition:all 0.2s ease-out;width:${(props)=>props.score === null ? 0 : $6a61f74f57258920$var$barWidths[props.score]};}`;
const $6a61f74f57258920$export$8d13340382210b65 = /*#__PURE__*/ (0, $2UsNA.default).p.withConfig({
    componentId: "sc-2owkvn-2"
})`color:${"var(--ds-text-subtlest, #8993A4)"};${$kBzhX.small} height:${$4cxV2.multiple(2).px};line-height:${$4cxV2.multiple(2).px};margin-top:${"var(--ds-space-050, 4px)"};position:relative;text-align:center;`;

});
parcelRegister("nJL8q", function(module, exports) {
$parcel$export(module.exports, "default", () => $0475a4edcd22fff6$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $93Fg7 = parcelRequire("93Fg7");

var $fG5y9 = parcelRequire("fG5y9");
function $0475a4edcd22fff6$var$_extends() {
    $0475a4edcd22fff6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0475a4edcd22fff6$var$_extends.apply(this, arguments);
}
function $0475a4edcd22fff6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0475a4edcd22fff6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $0475a4edcd22fff6$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $0475a4edcd22fff6$var$idCount = 0;
function $0475a4edcd22fff6$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $0475a4edcd22fff6$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $0475a4edcd22fff6$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $0475a4edcd22fff6$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $0475a4edcd22fff6$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $0475a4edcd22fff6$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $8P7DW.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $8P7DW.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $8P7DW.forwardRef)(function(props, ref) {
            return (0, $8P7DW.createElement)(AsyncScriptLoader, $0475a4edcd22fff6$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($93Fg7))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($fG5y9)))(ForwardedComponent, WrappedComponent);
    };
}

});

parcelRegister("jMvfB", function(module, exports) {
$parcel$export(module.exports, "default", () => $da15951b2ab5d0f7$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $da15951b2ab5d0f7$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    passwordInvalid: {
        id: 'password.invalid.password.size',
        description: 'Displayed when the user has entered a password shorter than 8 characters',
        defaultMessage: 'Password must have at least 8 characters'
    },
    passwordStrengthLevel0: {
        id: 'password.strength.level.0',
        description: 'Displayed when the user has entered a weak password',
        defaultMessage: 'Weak'
    },
    passwordStrengthLevel1: {
        id: 'password.strength.level.1',
        description: 'Displayed when the user has entered a fair (not very good) password',
        defaultMessage: 'Fair'
    },
    passwordStrengthLevel2: {
        id: 'password.strength.level.2',
        description: 'Displayed when the user has entered a good password',
        defaultMessage: 'Good'
    },
    passwordStrengthLevel3: {
        id: 'password.strength.level.3',
        description: 'Displayed when the user has entered a strong password',
        defaultMessage: 'Strong'
    },
    passwordStrengthLevel4: {
        id: 'password.strength.level.4',
        description: 'Displayed when the user has entered a very strong password',
        defaultMessage: 'Very strong'
    },
    passwordStrengthUnavailable: {
        id: 'password.strength.unavailable',
        description: 'Displayed when the password strength cannot be determined due to an error',
        defaultMessage: 'Password strength unavailable'
    }
});

});



parcelRegister("3hlyC", function(module, exports) {
$parcel$export(module.exports, "ErrorIndication", () => (parcelRequire("2RjkG")).default);

var $2RjkG = parcelRequire("2RjkG");

});
parcelRegister("2RjkG", function(module, exports) {
$parcel$export(module.exports, "default", () => $415bfbdbed2c7736$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");

var $l4a5B = parcelRequire("l4a5B");

var $h82Rb = parcelRequire("h82Rb");

var $7zDtY = parcelRequire("7zDtY");

var $c7dQO = parcelRequire("c7dQO");
const $415bfbdbed2c7736$var$ErrorIndication = ({ errorMessage: errorMessage, intl: intl })=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $8P7DW.createElement($415bfbdbed2c7736$var$ContainerV2, null, /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
            label: "error",
            color: "var(--ds-icon-danger, #BF2600)",
            size: "small"
        }), /*#__PURE__*/ $8P7DW.createElement((0, $7zDtY.default), {
            size: "small",
            color: "color.text.danger"
        }, typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)))
    }, /*#__PURE__*/ $8P7DW.createElement($415bfbdbed2c7736$var$Container, null, /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
        label: "error",
        color: "var(--ds-icon-danger, #BF2600)",
        size: "small"
    }), typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)));
};
var $415bfbdbed2c7736$export$2e2bcd8739ae039 = (0, $l4a5B.default)($415bfbdbed2c7736$var$ErrorIndication);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $415bfbdbed2c7736$var$ContainerV2 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-xau1xe-0"
})`margin-top:${"var(--ds-space-050, 4px)"};display:flex;align-items:center;gap:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $415bfbdbed2c7736$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-xau1xe-1"
})`${$kBzhX.small};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-danger, #BF2600)"};display:flex;align-items:center;gap:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("meCbu", function(module, exports) {
$parcel$export(module.exports, "default", () => $d69f852f9101b157$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $d69f852f9101b157$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    label: {
        defaultMessage: 'Password',
        description: 'Label for password field',
        id: 'password.field.label'
    },
    showPassword: {
        defaultMessage: 'Show',
        description: 'Label for show password button',
        id: 'password.show.button.label'
    },
    hidePassword: {
        defaultMessage: 'Hide',
        description: 'Label for hide password button',
        id: 'password.hide.button.label'
    }
});

});



parcelRegister("ggKR1", function(module, exports) {
$parcel$export(module.exports, "default", () => $57ddea6fe2ecaa19$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $lRscM = parcelRequire("lRscM");

var $iqJis = parcelRequire("iqJis");

var $b9hQ0 = parcelRequire("b9hQ0");

var $e6Qdr = parcelRequire("e6Qdr");

var $iPrfN = parcelRequire("iPrfN");
var $6E5P5 = parcelRequire("6E5P5");

var $h8Drh = parcelRequire("h8Drh");
const $57ddea6fe2ecaa19$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
const $57ddea6fe2ecaa19$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $57ddea6fe2ecaa19$var$SectionMessage = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $8P7DW.useState)(false);
    const handleDismiss = (0, $8P7DW.useCallback)(()=>{
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $h8Drh.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $8P7DW.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $8P7DW.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gWgPx.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $8n1kL.default)([
            $57ddea6fe2ecaa19$var$sectionMessageStyles.container,
            (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $57ddea6fe2ecaa19$var$sectionMessageStyles.containerT26Shape,
            $57ddea6fe2ecaa19$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    className: (0, $8n1kL.default)([
                        $57ddea6fe2ecaa19$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6E5P5.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $57ddea6fe2ecaa19$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                            className: (0, $8n1kL.default)([
                                $57ddea6fe2ecaa19$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iPrfN.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $57ddea6fe2ecaa19$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iPrfN.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    className: (0, $8n1kL.default)([
                        $57ddea6fe2ecaa19$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lRscM.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$57ddea6fe2ecaa19$var$SectionMessage.displayName = 'SectionMessage';
var $57ddea6fe2ecaa19$export$2e2bcd8739ae039 = $57ddea6fe2ecaa19$var$SectionMessage;

});
parcelRegister("h8Drh", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $e201a27c5a1bfc37$export$e9b82d2e21ac0c1f);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $aDTzA = parcelRequire("aDTzA");

var $h82Rb = parcelRequire("h82Rb");

var $ebnVy = parcelRequire("ebnVy");

var $joUCG = parcelRequire("joUCG");

var $gKWTh = parcelRequire("gKWTh");
const $e201a27c5a1bfc37$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebnVy))),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKWTh))),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($joUCG))),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aDTzA))),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function $e201a27c5a1bfc37$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $e201a27c5a1bfc37$var$appearanceIconSchema[appearance] || $e201a27c5a1bfc37$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ primaryColor: primaryColor })=>/*#__PURE__*/ (0, $gWgPx.jsx)(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("aDTzA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b3613c7e18556761a1c0b5ad2c9a88f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bf8a78456c2fe7c$var$_react = $7bf8a78456c2fe7c$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $7bf8a78456c2fe7c$var$_baseNew = $7bf8a78456c2fe7c$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $7bf8a78456c2fe7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bf8a78456c2fe7c$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $7bf8a78456c2fe7c$var$_react.default.createElement($7bf8a78456c2fe7c$var$_baseNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$7bf8a78456c2fe7c$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $7bf8a78456c2fe7c$var$_default = module.exports.default = $7bf8a78456c2fe7c$var$StatusDiscoveryIcon;

});



parcelRegister("clEkf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea8888968fbbfb34$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $ea8888968fbbfb34$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    resetPasswordLink: {
        defaultMessage: 'Reset password',
        description: 'Text of the reset password link',
        id: 'cv.login.reset.password.link'
    },
    resetPasswordLinkInlineBold: {
        defaultMessage: 'Reset Password',
        description: 'Text of the reset password which is inline bold',
        id: 'cv.login.reset.password.link.bold'
    },
    createPasswordLink: {
        defaultMessage: 'Create password',
        description: "Text to create password for customers who haven't yet set a password",
        id: 'cv.login.create.a.password.link'
    },
    dontHavePasswordText: {
        defaultMessage: "Don't have a password?",
        description: "Text to prompt user if they don't already have a password due to a new account",
        id: 'cv.login.dont.have.password.text'
    },
    nextButton: {
        defaultMessage: 'Next',
        description: 'Next button label',
        id: 'cv.next.button.label'
    },
    continueButton: {
        defaultMessage: 'Continue',
        description: 'Continue button label',
        id: 'cv.continue.button.label'
    },
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for login email field',
        id: 'cv.login.page.email.label'
    },
    passwordLabelAndPlaceholder: {
        defaultMessage: 'Password',
        description: 'Placeholder and label for login password field',
        id: 'cv.signup.page.password'
    },
    invalidEmailError: {
        defaultMessage: 'Enter a valid email address and try again.',
        description: 'Error shown when the email does not have the correct format.',
        id: 'sd.login.error.invalid.email.error'
    },
    incorrectPasswordError: {
        defaultMessage: 'Incorrect password. Try again',
        description: 'Error shown when the password is incorrect.',
        id: 'sd.login.error.incorrect.password'
    },
    emptyPasswordError: {
        defaultMessage: 'You must enter your password to log in',
        description: 'Error shown when the password is empty',
        id: 'sd.login.error.empty.password'
    },
    accessDeniedErrorCodeMessage: {
        defaultMessage: "You can\u2019t continue with single sign-on. Try again.",
        description: 'Error shown when receiving access deny error code from identity.',
        id: 'sd.login.errorcode.access.denied'
    },
    defaultErrorCodeMessage: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Error shown when the receiving other error code',
        id: 'sd.login.errorcode.default'
    },
    loginConsentErrorMessage: {
        defaultMessage: 'Something went wrong while attempting to validate your consent. Try logging in again later',
        description: 'Error shown when the FedRAMP user failed to consent and got redirected to the login page',
        id: 'sd.login.consent.fail.error'
    }
});

});



parcelRegister("bZQY1", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3065d8d0ba18acc$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $a3065d8d0ba18acc$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    invalidLogin: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Message to show that email or password are incorrect and that the user should try again.',
        id: 'sd.login.error.invalid.login.unified'
    },
    accountLocked: {
        defaultMessage: "For security reasons, we've temporarily locked this account due to multiple unsuccessful login attempts. To regain access, select {forgotPasswordLink} to reset your password.",
        description: 'Error message if the account is locked.',
        id: 'sd.login.account.locked.unified'
    },
    miscLoginError: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Error message for any not classified errors.',
        id: 'sd.login.error.misc.unified'
    }
});

});




parcelRegister("1e9y2", function(module, exports) {
$parcel$export(module.exports, "LoginSingleSignOn", () => (parcelRequire("hhVLu")).default);

var $hhVLu = parcelRequire("hhVLu");

});
parcelRegister("hhVLu", function(module, exports) {
$parcel$export(module.exports, "default", () => $95b3e96eebaf8325$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $HGACo = parcelRequire("HGACo");

var $kBzhX = parcelRequire("kBzhX");

var $jShty = parcelRequire("jShty");

var $04X5p = parcelRequire("04X5p");

var $l4cjO = parcelRequire("l4cjO");
var $l4a5B = parcelRequire("l4a5B");
parcelRequire("5Xax4");
var $jxZlp = parcelRequire("jxZlp");

var $1EFS8 = parcelRequire("1EFS8");

var $iqJis = parcelRequire("iqJis");

var $6Hfjm = parcelRequire("6Hfjm");
var $7zDtY = parcelRequire("7zDtY");

var $aQXm8 = parcelRequire("aQXm8");

var $c7dQO = parcelRequire("c7dQO");

var $ll4s2 = parcelRequire("ll4s2");
class $95b3e96eebaf8325$export$b77dc1349d86cfac extends $8P7DW.Component {
    componentDidMount() {
        this.setState({
            isInIframe: window.self !== window.top
        });
    }
    render() {
        return /*#__PURE__*/ $8P7DW.createElement($95b3e96eebaf8325$var$Container, null, /*#__PURE__*/ $8P7DW.createElement((0, $aQXm8.FireScreenEventOnMount), null), this.getSSOFormContent(), /*#__PURE__*/ $8P7DW.createElement($95b3e96eebaf8325$var$ButtonContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $jShty.ThemedButton), {
            id: "login-button",
            "data-test-id": "login-sso-button",
            appearance: "primary",
            shouldFitContainer: true,
            actionSubjectId: "submitLoginSSO",
            href: this.getSSOUrl(),
            target: this.state.isInIframe && (0, $HGACo.isJsmPortalRovoIntegrationEnabled)() ? '_blank' : undefined,
            rel: this.state.isInIframe && (0, $HGACo.isJsmPortalRovoIntegrationEnabled)() ? 'opener' : undefined,
            autoFocus: true
        }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $ll4s2.default).continueWithAtlassianAccountButton))), this.getAtlassianAccountInfoSection());
    }
    constructor(...args){
        super(...args), this.state = {
            isInIframe: false
        }, this.getSSOUrl = ()=>{
            return this.props.redirectUrl;
        }, this.getSSOFormContent = ()=>{
            const { intl: intl, email: email } = this.props;
            return /*#__PURE__*/ $8P7DW.createElement((0, $jxZlp.default), {
                id: "user-email",
                shouldFitContainer: true,
                label: intl.formatMessage((0, $ll4s2.default).emailLabel),
                disabled: true,
                defaultValue: email
            });
        }, this.getAtlassianAccountInfoSection = ()=>{
            const { intl: intl } = this.props;
            const URI = 'https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/';
            const isA11y28889Fixed = (0, $1EFS8.default).checkGate('ai-a11y-131-28903-28906');
            const supportLink = /*#__PURE__*/ $8P7DW.createElement((0, $04X5p.default), {
                actionSubjectId: "learnMoreAtlassianAccount",
                href: URI,
                target: "_blank",
                id: isA11y28889Fixed ? 'sso-login-learn-more-link' : undefined,
                "aria-labelledby": isA11y28889Fixed ? 'sso-login-learn-more-link sso-login-atlassian-account-heading' : undefined
            }, intl.formatMessage((0, $ll4s2.default).atlassianAccountInfoLink));
            return /*#__PURE__*/ $8P7DW.createElement($95b3e96eebaf8325$var$InfoSectionContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
                    paddingBlockStart: "space.300"
                }, /*#__PURE__*/ $8P7DW.createElement((0, $iqJis.default), {
                    size: "xsmall"
                }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $ll4s2.default).atlassianAccountInfoTitle)))
            }, /*#__PURE__*/ $8P7DW.createElement($95b3e96eebaf8325$var$InfoSectionTitle, {
                role: isA11y28889Fixed ? 'heading' : undefined,
                "aria-level": isA11y28889Fixed ? 3 : undefined,
                id: isA11y28889Fixed ? 'sso-login-atlassian-account-heading' : undefined
            }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $ll4s2.default).atlassianAccountInfoTitle))), /*#__PURE__*/ $8P7DW.createElement((0, $c7dQO.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
                    paddingBlockStart: "space.050"
                }, /*#__PURE__*/ $8P7DW.createElement((0, $7zDtY.default), null, (0, $1EFS8.default).checkGate('jsm_rename_product_to_app') ? /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), {
                    ...(0, $ll4s2.default).atlassianAccountInfoContentAppify,
                    values: {
                        supportLink: supportLink
                    }
                }) : /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), {
                    ...(0, $ll4s2.default).atlassianAccountInfoContent,
                    values: {
                        supportLink: supportLink
                    }
                })))
            }, /*#__PURE__*/ $8P7DW.createElement($95b3e96eebaf8325$var$InfoSectionContent, null, (0, $1EFS8.default).checkGate('jsm_rename_product_to_app') ? /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), {
                ...(0, $ll4s2.default).atlassianAccountInfoContentAppify,
                values: {
                    supportLink: supportLink
                }
            }) : /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), {
                ...(0, $ll4s2.default).atlassianAccountInfoContent,
                values: {
                    supportLink: supportLink
                }
            }))));
        };
    }
}
var $95b3e96eebaf8325$export$2e2bcd8739ae039 = (0, $l4a5B.default)($95b3e96eebaf8325$export$b77dc1349d86cfac);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $95b3e96eebaf8325$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-qruqqd-0"
})`text-align:left;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $95b3e96eebaf8325$var$ButtonContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-qruqqd-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $95b3e96eebaf8325$var$InfoSectionContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-qruqqd-2"
})`margin-top:${"var(--ds-space-300, 24px)"};border-top:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $95b3e96eebaf8325$var$InfoSectionTitle = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-qruqqd-3"
})`${(0, $kBzhX.h400)};margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $95b3e96eebaf8325$var$InfoSectionContent = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-qruqqd-4"
})`margin-top:${"var(--ds-space-050, 4px)"};`;

});
parcelRegister("ll4s2", function(module, exports) {
$parcel$export(module.exports, "default", () => $035ed1233dc1ad06$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $035ed1233dc1ad06$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    continueWithAtlassianAccountButton: {
        defaultMessage: 'Continue with Atlassian account',
        description: 'The redirect button text for login with single sign-on',
        id: 'cv.login.sso.button.text'
    },
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for login email field',
        id: 'cv.login.sso.email.label'
    },
    atlassianAccountInfoTitle: {
        defaultMessage: 'Your Atlassian account',
        description: 'Title of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.title'
    },
    atlassianAccountInfoContent: {
        defaultMessage: 'Make things easier by using one account across all of your Atlassian products. {supportLink}',
        description: 'Content of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.content'
    },
    atlassianAccountInfoContentAppify: {
        defaultMessage: 'Make things easier by using one account across all of your Atlassian apps. {supportLink}',
        description: 'Content of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.content-appify'
    },
    atlassianAccountInfoLink: {
        defaultMessage: 'Learn more',
        description: 'Learn more link of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.link'
    }
});

});



parcelRegister("iHfu2", function(module, exports) {
$parcel$export(module.exports, "LoginSingleSignOnCustomer", () => (parcelRequire("lbFaP")).default);

var $lbFaP = parcelRequire("lbFaP");

});
parcelRegister("lbFaP", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a5da0babad9a6d0$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $HGACo = parcelRequire("HGACo");

var $4cxV2 = parcelRequire("4cxV2");

var $jShty = parcelRequire("jShty");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("5Xax4");
var $jxZlp = parcelRequire("jxZlp");

var $aQXm8 = parcelRequire("aQXm8");

var $9msNh = parcelRequire("9msNh");

var $4bOuv = parcelRequire("4bOuv");
const $2a5da0babad9a6d0$var$LoginSingleSignOnCustomer = (props)=>{
    const { email: email, redirectLink: redirectLink, passwordLoginAvailable: passwordLoginAvailable, onContinueWithPassword: onContinueWithPassword } = props;
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [isInIframe, setIsInIframe] = (0, $8P7DW.useState)(false);
    (0, $8P7DW.useEffect)(()=>{
        setIsInIframe(window.self !== window.top);
    }, []);
    const getContinueWithPasswordLink = ()=>{
        return passwordLoginAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($2a5da0babad9a6d0$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jShty.ThemedButton), {
            appearance: "link",
            actionSubjectId: "continueWithPassword",
            onClick: onContinueWithPassword
        }, formatMessage((0, $4bOuv.default).continueWithPasswordButton))) : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($2a5da0babad9a6d0$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jxZlp.default), {
        id: "user-email",
        shouldFitContainer: true,
        label: formatMessage((0, $4bOuv.default).emailLabel),
        disabled: true,
        defaultValue: email
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9msNh.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jShty.ThemedButton), {
        id: "continue-with-customer-sso-button",
        appearance: "primary",
        shouldFitContainer: true,
        actionSubjectId: "continueWithCustomerSSO",
        isDisabled: redirectLink === undefined,
        href: redirectLink,
        target: isInIframe && (0, $HGACo.isJsmPortalRovoIntegrationEnabled)() ? '_blank' : undefined,
        rel: isInIframe && (0, $HGACo.isJsmPortalRovoIntegrationEnabled)() ? 'opener' : undefined,
        autoFocus: true
    }, formatMessage((0, $4bOuv.default).continueWithSingleSignOnButton))), getContinueWithPasswordLink());
};
var $2a5da0babad9a6d0$export$2e2bcd8739ae039 = $2a5da0babad9a6d0$var$LoginSingleSignOnCustomer;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2a5da0babad9a6d0$var$FooterContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-t9atao-0"
})`margin-top:${$4cxV2.multiple(4.25).px};text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2a5da0babad9a6d0$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-t9atao-1"
})`text-align:left;`;

});
parcelRegister("9msNh", function(module, exports) {
$parcel$export(module.exports, "ButtonContainer", () => $c7ec5008b7a808d9$export$eddf54ea3db8d0f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $2UsNA = parcelRequire("2UsNA");
const $c7ec5008b7a808d9$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-mrwmoh-0"
})`margin-top:${"var(--ds-space-300, 24px)"};`;

});

parcelRegister("4bOuv", function(module, exports) {
$parcel$export(module.exports, "default", () => $15d28d41b80a53bc$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $15d28d41b80a53bc$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for login email field',
        id: 'cv.login.sso.customer.email.label'
    },
    continueWithPasswordButton: {
        defaultMessage: 'Continue with password',
        description: 'The button text for customer account login using password',
        id: 'cv.login.sso.customer.password.link.text'
    },
    continueWithSingleSignOnButton: {
        defaultMessage: 'Continue with single sign-on',
        description: 'The redirect button text for customer account login using single sign-on',
        id: 'cv.login.sso.customer.button.text'
    }
});

});






parcelRegister("2VSOc", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsCardResource", () => $0a6a508ef967c64d$export$978d7819e59e352f);

var $36QVm = parcelRequire("36QVm");

var $byuiX = parcelRequire("byuiX");
const $0a6a508ef967c64d$export$978d7819e59e352f = (0, $byuiX.createRelayResource)({
    type: 'HELP_CENTER_LOGIN_ANNOUNCEMENTS_CARD',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $36QVm.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});

parcelRegister("cuqN1", function(module, exports) {
$parcel$export(module.exports, "waitingBrandingResource", () => $584cd1ee8eeef867$export$e5e5917f15b57d37);

var $9Vr59 = parcelRequire("9Vr59");

var $5dezq = parcelRequire("5dezq");
parcelRequire("9wocP");
var $5U6in = parcelRequire("5U6in");

var $8iTFq = parcelRequire("8iTFq");

var $d1iVz = parcelRequire("d1iVz");
const $584cd1ee8eeef867$export$d23b87ed2b78c76d = 3000;
/**
 * Returns true when the branding data fetch has completed — either successfully or with an error.
 * The `isBrandingLoaded` flag is set by `updateHCBrandingLoaderAction(true)` which is dispatched
 * on both success and error paths in the epic.
 */ const $584cd1ee8eeef867$var$isBrandingResolved = (state)=>{
    return state.persisted.helpCenter.isBrandingLoaded === true;
};
const $584cd1ee8eeef867$export$3ba04cf2ed97ffdc = ()=>{
    return new Promise((resolve)=>{
        // Check if branding data is already in the store (e.g. from initialModel/SSR bootstrap)
        if ($584cd1ee8eeef867$var$isBrandingResolved((0, $5dezq.store).getState())) {
            resolve(null);
            return;
        }
        // Safety timeout: resolve even if the epic silently fails, so we don't block SSR forever.
        // We capture the unsubscribe function reference via a mutable object so we can use it in the timeout.
        const subscription = {};
        const timeoutId = setTimeout(()=>{
            var _subscription$unsubsc;
            (_subscription$unsubsc = subscription.unsubscribe) === null || _subscription$unsubsc === void 0 || _subscription$unsubsc.call(subscription);
            resolve(null);
        }, $584cd1ee8eeef867$export$d23b87ed2b78c76d);
        subscription.unsubscribe = (0, $5dezq.store).subscribe(()=>{
            const state = (0, $5dezq.store).getState();
            if ($584cd1ee8eeef867$var$isBrandingResolved(state)) {
                var _subscription$unsubsc2;
                clearTimeout(timeoutId);
                (_subscription$unsubsc2 = subscription.unsubscribe) === null || _subscription$unsubsc2 === void 0 || _subscription$unsubsc2.call(subscription);
                resolve(null);
            }
        });
    });
};
const $584cd1ee8eeef867$export$e5e5917f15b57d37 = (0, $5U6in.createResource)({
    type: 'RELAY_HELP_CENTER_BRANDING',
    getKey: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const request = (0, $8iTFq.getRequest)((0, $d1iVz.default));
        const params = request.params;
        return `${String(params.id)}${JSON.stringify({
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        })}`;
    },
    getData: ()=>{
        (0, $5dezq.store).dispatch((0, $9Vr59.fetchHelpCenterBrandingAction)());
        return $584cd1ee8eeef867$export$3ba04cf2ed97ffdc();
    }
});

});


parcelRegister("28TQC", function(module, exports) {
$parcel$export(module.exports, "portalAccessForbiddenRoute", () => $51547a31903bc5eb$export$51c7ebad0d50c69a);

var $8rTkC = parcelRequire("8rTkC");
parcelRequire("5iYcW");
var $lnAFD = parcelRequire("lnAFD");

var $bpyxC = parcelRequire("bpyxC");
const $51547a31903bc5eb$var$layoutProps = {
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'normal',
    fadeInSearchModal: true,
    headerless: true
};
const $51547a31903bc5eb$export$51c7ebad0d50c69a = (0, $bpyxC.createRouteWithLayout)({
    name: 'portal-access-forbidden',
    path: '/user/forbidden',
    exact: true,
    component: (0, $lnAFD.default),
    resources: []
}, (0, $8rTkC.ScreenName).PORTAL_ACCESS_FORBIDDEN, $51547a31903bc5eb$var$layoutProps);

});
parcelRegister("5iYcW", function(module, exports) {
$parcel$export(module.exports, "PortalAccessForbidden", () => (parcelRequire("lnAFD")).default);

var $lnAFD = parcelRequire("lnAFD");

});
parcelRegister("lnAFD", function(module, exports) {
$parcel$export(module.exports, "default", () => $b231187d739bea13$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $kr2LG = parcelRequire("kr2LG");
const $b231187d739bea13$var$selector = (0, $ehscL.createSelector)((state)=>(0, $hx8zX.isLoggedIn)(state), (state)=>(0, $hx8zX.getUserState)(state), (isUserLoggedIn, userState)=>({
        isUserLoggedIn: isUserLoggedIn,
        userEmail: userState.email || ''
    }));
var $b231187d739bea13$export$2e2bcd8739ae039 = (0, $jvoWT.default)($b231187d739bea13$var$selector)((0, $kr2LG.default));

});
parcelRegister("kr2LG", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba243491263f4dd8$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $gzPDp = parcelRequire("gzPDp");

var $kBzhX = parcelRequire("kBzhX");

var $4cxV2 = parcelRequire("4cxV2");

var $04X5p = parcelRequire("04X5p");

var $cbTZz = parcelRequire("cbTZz");

var $l4cjO = parcelRequire("l4cjO");
var $5jYgE = parcelRequire("5jYgE");
parcelRequire("1n2hY");
var $4fSTF = parcelRequire("4fSTF");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $3Wo8f = parcelRequire("3Wo8f");

var $jsmb9 = parcelRequire("jsmb9");

var $l3TeF = parcelRequire("l3TeF");
const $ba243491263f4dd8$var$PortalAccessForbidden = ({ isUserLoggedIn: isUserLoggedIn, userEmail: userEmail })=>{
    const callToActionUrl = 'https://start.atlassian.com/';
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const isCSMHelpCenterEnabled = (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType);
    if (!isUserLoggedIn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3Wo8f.Redirect), {
        to: (0, $jsmb9.getHelpCenterUrl)()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gzPDp.default), {
        title: formatMessage((0, $l3TeF.default).documentTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4fSTF.PaperContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba243491263f4dd8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba243491263f4dd8$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cbTZz.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba243491263f4dd8$var$Message, null, formatMessage((0, $l3TeF.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba243491263f4dd8$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), {
        ...isCSMHelpCenterEnabled ? (0, $l3TeF.default).errorDescriptionTextV2 : (0, $l3TeF.default).errorDescriptionText,
        values: {
            userEmail: userEmail,
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("br", null)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($ba243491263f4dd8$var$AnchorContainer, {
        actionSubjectId: "redirectToAtlassianStart",
        href: callToActionUrl
    }, formatMessage((0, $l3TeF.default).callToActionText)))));
};
var $ba243491263f4dd8$export$2e2bcd8739ae039 = $ba243491263f4dd8$var$PortalAccessForbidden;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ba243491263f4dd8$var$Container = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-98kmq7-0"
})`display:flex;flex-flow:column wrap;align-items:center;margin-top:${"var(--ds-space-600, 48px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ba243491263f4dd8$var$IconContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-98kmq7-1"
})`width:${$4cxV2.multiple(14).px};margin-bottom:${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ba243491263f4dd8$var$Message = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-98kmq7-2"
})`${$kBzhX.h600};margin:0 0 ${"var(--ds-space-100, 8px)"} 0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ba243491263f4dd8$var$Description = /*#__PURE__*/ (0, $2UsNA.default).p.withConfig({
    componentId: "sc-98kmq7-3"
})`${$kBzhX.regular};margin:0 0 ${"var(--ds-space-100, 8px)"} 0;text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ba243491263f4dd8$var$AnchorContainer = /*#__PURE__*/ (0, $2UsNA.default)((0, $04X5p.default)).withConfig({
    componentId: "sc-98kmq7-4"
})`text-align:center;`;

});
parcelRegister("l3TeF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac8be6dc6a57a6b5$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $ac8be6dc6a57a6b5$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    documentTitle: {
        defaultMessage: 'No access',
        description: 'Document title for user with no access to portal',
        id: 'cv.portal.forbidden.access.document.title'
    },
    errorHeading: {
        defaultMessage: 'No access',
        description: 'Error heading for user with no portal access',
        id: 'cv.portal.forbidden.access.error.heading'
    },
    errorDescriptionText: {
        defaultMessage: "It seems that your account {userEmail} doesn't have access to the help center.{br}Try contacting your admins to grant you permissions.",
        description: 'Error description for user with no portal access',
        id: 'cv.portal.forbidden.access.error.description.text'
    },
    errorDescriptionTextV2: {
        defaultMessage: "Your account {userEmail} doesn't have access to this website, help center, or hub.{br}Contact your admin(s) to request access permissions.",
        description: 'Error description for user with no portal access',
        id: 'cv.portal.forbidden.access.error.description.text.v2'
    },
    callToActionText: {
        defaultMessage: 'Go to Atlassian Start',
        description: 'Next action link label for user with no portal access',
        id: 'cv.portal.forbidden.access.error.action.link.label'
    }
});

});





parcelRegister("iC8fI", function(module, exports) {
$parcel$export(module.exports, "getPortalHomeRoutes", () => $8b1b99016b68cf15$export$87f7f4cc1cadb13a);

var $HGACo = parcelRequire("HGACo");

var $fBOCW = parcelRequire("fBOCW");
parcelRequire("ffMCg");
var $inpeY = parcelRequire("inpeY");

var $1EFS8 = parcelRequire("1EFS8");

var $bpyxC = parcelRequire("bpyxC");
const $8b1b99016b68cf15$var$getRoute = ()=>({
        name: 'portal-home',
        path: `/portal/:portalId/:group?/:requestGroupId?/:create?/:requestTypeId?`,
        exact: true,
        component: (0, $inpeY.default),
        getUFONameBasedOnRouteMatch: (routerState)=>{
            const { requestTypeId: requestTypeId } = routerState.params;
            if (requestTypeId) return 'request-create';
            return 'portal-home';
        },
        resources: (0, $HGACo.isUiModificationsSupportEnabled)() && !(0, $1EFS8.default).checkGate('ditto_uim_root_query_rest') ? [
            (0, $fBOCW.UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE)
        ] : []
    });
const $8b1b99016b68cf15$var$paperAppearance = 'xxwide';
const $8b1b99016b68cf15$var$layoutProps = {
    paperAppearance: $8b1b99016b68cf15$var$paperAppearance,
    fadeInSearchModal: true
};
const $8b1b99016b68cf15$export$87f7f4cc1cadb13a = ()=>(0, $bpyxC.createRouteWithLayout)($8b1b99016b68cf15$var$getRoute(), undefined, $8b1b99016b68cf15$var$layoutProps);

});
parcelRegister("ffMCg", function(module, exports) {
$parcel$export(module.exports, "PortalHome", () => (parcelRequire("inpeY")).default);

var $inpeY = parcelRequire("inpeY");

});
parcelRegister("inpeY", function(module, exports) {
$parcel$export(module.exports, "default", () => $c48ffdc2e05a4950$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("6KFgU");
var $cLBxy = parcelRequire("cLBxy");

var $8rTkC = parcelRequire("8rTkC");

var $2gQsf = parcelRequire("2gQsf");

var $gZNYv = parcelRequire("gZNYv");
parcelRequire("aaYFd");
var $8QZqc = parcelRequire("8QZqc");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("1BaaY");
var $8bKnT = parcelRequire("8bKnT");
parcelRequire("kj8xu");
var $4iHZF = parcelRequire("4iHZF");
parcelRequire("6SWKp");
var $gT7Rx = parcelRequire("gT7Rx");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("7dWmH");
var $5EB6B = parcelRequire("5EB6B");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $1EFS8 = parcelRequire("1EFS8");

var $iziiq = parcelRequire("iziiq");

var $jjE9o = parcelRequire("jjE9o");

var $g2qf8 = parcelRequire("g2qf8");

var $6GNhI = parcelRequire("6GNhI");

var $vYPX4 = parcelRequire("vYPX4");

var $e2jLh = parcelRequire("e2jLh");

var $90Qb9 = parcelRequire("90Qb9");
parcelRequire("9i6OK");
var $3szzY = parcelRequire("3szzY");
parcelRequire("9FbAp");
var $5LdUw = parcelRequire("5LdUw");
const $c48ffdc2e05a4950$export$3fbf10a15d6b2168 = (screenLocation)=>(0, $6GNhI.pathname)().endsWith(screenLocation);
class $c48ffdc2e05a4950$export$2521bdc6772d1464 extends $8P7DW.Component {
    componentDidMount() {
        const { portalId: portalId, fetchPortal: fetchPortal, fetchUser: fetchUser, fetchRequestCreate: fetchRequestCreate, fetchUiModifications: fetchUiModifications, requestTypeId: requestTypeId, categories: categories, isLoggedIn: isLoggedIn } = this.props;
        const analytics = this.getViewSinglePortalAnalyticsEvents();
        if (portalId) {
            fetchPortal({
                id: portalId,
                expand: [
                    'kbs',
                    'orderMapping',
                    'reqGroups',
                    'reqTypes',
                    'analyticsContext',
                    'categories'
                ]
            }, analytics);
            if (requestTypeId) {
                if (!this.props.requestCreateModelLoaded) fetchRequestCreate({
                    portalId: portalId,
                    id: requestTypeId
                });
                if (isLoggedIn && (0, $1EFS8.default).checkGate('ditto_uim_root_query_rest')) fetchUiModifications({
                    portalId: portalId,
                    requestTypeId: requestTypeId
                });
            }
            // FSD-2541: required to re-fetch user model inorder to send correct analytics remove in clean-up task FSD-2881
            fetchUser();
            if (!categories) this.tryFetchCategories();
        }
    }
    componentDidUpdate(prevProps) {
        const { projectId: projectId, requestTypeId: requestTypeId, portalId: portalId, fetchRequestCreate: fetchRequestCreate, fetchUiModifications: fetchUiModifications, kbEnabled: kbEnabled, isLoggedIn: isLoggedIn } = this.props;
        const projectUpdated = prevProps.projectId !== projectId;
        const kbEnabledUpdated = !prevProps.kbEnabled && kbEnabled;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId;
        const portalUpdated = prevProps.portalId !== portalId;
        if (projectUpdated || kbEnabledUpdated) this.tryFetchCategories();
        if (portalId && requestTypeId && (portalUpdated || requestTypeUpdated)) {
            fetchRequestCreate({
                portalId: portalId,
                id: requestTypeId
            });
            if ((0, $1EFS8.default).checkGate('ditto_uim_root_query_rest') && isLoggedIn) fetchUiModifications({
                portalId: portalId,
                requestTypeId: requestTypeId
            });
        }
    }
    getScreenName() {
        const { requestTypeId: requestTypeId, requestGroupId: requestGroupId } = this.props;
        let screenName;
        if (requestTypeId) screenName = (0, $8rTkC.ScreenName).REQUEST_CREATE;
        else if (requestGroupId === -1) screenName = (0, $8rTkC.ScreenName).REQUEST_GROUP_LIST;
        else if (requestGroupId) screenName = (0, $8rTkC.ScreenName).REQUEST_GROUP;
        else screenName = (0, $8rTkC.ScreenName).PORTAL_HOME;
        return screenName;
    }
    render() {
        const { sideBarOpen: sideBarOpen } = this.state;
        const { portalName: portalName, requestTypeName: requestTypeName, isLoading: isLoading, error: error, announcement: announcement, canEditAnnouncement: canEditAnnouncement, portalId: portalId, projectId: projectId, categories: categories, requestTypeId: requestTypeId, requestGroupId: requestGroupId, isProjectSimplified: isProjectSimplified, isAtlassianManagedAccount: isAtlassianManagedAccount, isProjectAdmin: isProjectAdmin, canCustomiseHelpCenter: canCustomiseHelpCenter, requestTypeBelongsToGroup: requestTypeBelongsToGroup, isBrandingLoaded: isBrandingLoaded, isLoggedIn: isLoggedIn, isChatSideBarOpen: isChatSideBarOpen, hasProformaForm: hasProformaForm, openChatSideBar: openChatSideBarAction, closeChatSideBar: closeChatSideBarAction } = this.props;
        const screenName = this.getScreenName();
        return /*#__PURE__*/ $8P7DW.createElement((0, $g2qf8.default), {
            screenName: screenName,
            screenId: requestTypeId || requestGroupId || portalId
        }, /*#__PURE__*/ $8P7DW.createElement((0, $3szzY.default), {
            screenName: screenName
        }, /*#__PURE__*/ $8P7DW.createElement((0, $cLBxy.default), {
            name: (0, $8rTkC.ExperienceName).REQUEST_CREATE
        }, /*#__PURE__*/ $8P7DW.createElement((0, $90Qb9.UiModificationsContainer), null, /*#__PURE__*/ $8P7DW.createElement((0, $5LdUw.default), {
            portalName: portalName,
            portalId: portalId,
            projectId: projectId,
            requestTypeName: requestTypeName,
            requestTypeId: requestTypeId,
            requestGroupId: requestGroupId,
            loading: isLoading,
            sideBarOpen: sideBarOpen,
            toggleSidebar: this.toggleSideBar,
            announcement: announcement,
            canEditAnnouncement: canEditAnnouncement,
            categories: categories,
            isProjectSimplified: isProjectSimplified,
            canCustomiseHelpCenter: canCustomiseHelpCenter,
            isProjectAdmin: isProjectAdmin,
            isAtlassianManagedAccount: isAtlassianManagedAccount,
            requestTypeBelongsToGroup: requestTypeBelongsToGroup,
            isBrandingLoaded: isBrandingLoaded,
            isLoggedIn: isLoggedIn,
            screenName: screenName,
            isChatSideBarOpen: isChatSideBarOpen,
            openChatSideBar: openChatSideBarAction,
            closeChatSideBar: closeChatSideBarAction,
            hasProformaForm: hasProformaForm,
            ...error
        })))));
    }
    constructor(...args){
        super(...args), this.state = {
            sideBarOpen: false
        }, this.tryFetchCategories = ()=>{
            const { portalId: portalId, kbEnabled: kbEnabled, projectId: projectId, categoriesLoaded: categoriesLoaded, fetchCategories: fetchCategories } = this.props;
            if (kbEnabled && projectId && portalId && !categoriesLoaded) {
                const meta = this.getAnalyticsEvents();
                fetchCategories(projectId, portalId, meta);
            }
        }, this.getAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsSuccessEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'fetchCategories success',
                    analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                }),
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'fetchCategories error',
                    analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE)
                })
            };
        }, this.getViewSinglePortalAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return {
                analyticsSuccessEvent: createAnalyticsEvent({
                    action: (0, $jjE9o.AnalyticsTrackActions).FETCHED,
                    analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                }),
                analyticsFailureEvent: createAnalyticsEvent({
                    action: (0, $jjE9o.AnalyticsTrackActions).FETCHED_FAILURE,
                    analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                })
            };
            return {};
        }, this.toggleSideBar = (value)=>{
            this.setState({
                sideBarOpen: value !== undefined ? value : !this.state.sideBarOpen
            });
            // this.props.location.pathname is used to check if the user is on the same page
            if (value === false && $c48ffdc2e05a4950$export$3fbf10a15d6b2168(this.props.location.pathname)) (0, $e2jLh.clearSidebarExperienceAndCustomize)();
        };
    }
}
const $c48ffdc2e05a4950$var$selector = (0, $ehscL.createSelector)((state, props)=>{
    const portalIdAsString = props.match.params && props.match.params.portalId;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const portalId = (0, $vYPX4.toNumber)(portalIdAsString);
    const kbEnabled = portalId && (0, $73V7l.getIsKbEnabled)(state, portalId);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestTypeId = props.match.params && (0, $vYPX4.toNumber)(props.match.params.requestTypeId);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestGroupId = props.match.params && (0, $vYPX4.toNumber)(props.match.params.requestGroupId);
    const portalName = portalId ? (0, $73V7l.getName)(state, portalId) : undefined;
    const requestType = portalId && requestTypeId ? (0, $73V7l.getPortalRequestType)(state, portalId, requestTypeId) : undefined;
    const requestTypeName = requestType ? requestType.name : undefined;
    const requestTypeBelongsToGroup = portalId && requestGroupId && requestTypeId && (0, $73V7l.getIsRequestTypeBelongsToGroup)(state, portalId, requestGroupId, requestTypeId);
    const requestCreateModelLoaded = portalId && requestTypeId && !!(0, $5EB6B.getRequestCreate)(state, portalId, requestTypeId);
    let hasProformaForm = false;
    if (portalId && requestTypeId) hasProformaForm = (0, $5EB6B.getRequestTypeHasProformaForm)(state, portalId, requestTypeId);
    return {
        portalId: portalId,
        portalName: portalName,
        kbEnabled: kbEnabled,
        requestTypeId: requestTypeId,
        requestGroupId: requestGroupId,
        requestTypeName: requestTypeName,
        requestTypeBelongsToGroup: requestTypeBelongsToGroup,
        requestCreateModelLoaded: requestCreateModelLoaded,
        hasProformaForm: hasProformaForm,
        isAtlassianManagedAccount: (0, $hx8zX.isAtlassianAccountManaged)(state),
        isLoggedIn: (0, $hx8zX.isLoggedIn)(state),
        categories: (0, $73V7l.getCategories)(state, portalId),
        portal: (0, $73V7l.getPortalOrError)(state, portalId),
        projectId: (0, $73V7l.getProjectId)(state, portalId),
        announcement: (0, $73V7l.getPortalAnnouncement)(state, portalId),
        isProjectAdmin: (0, $73V7l.getCanAdministerProject)(state, portalId),
        canCustomiseHelpCenter: (0, $ikoP4.getCanCustomize)(state),
        isProjectSimplified: (0, $73V7l.getIsProjectSimplified)(state, portalId),
        isBrandingLoaded: (0, $ikoP4.getHelpCenterBrandingLoader)(state),
        isChatSideBarOpen: (0, $gT7Rx.isChatSideBarOpen)(state)
    };
}, ({ portalId: portalId, portal: portal, announcement: announcement, requestTypeId: requestTypeId, requestGroupId: requestGroupId, portalName: portalName, hasProformaForm: hasProformaForm, requestTypeName: requestTypeName, requestTypeBelongsToGroup: requestTypeBelongsToGroup, requestCreateModelLoaded: requestCreateModelLoaded, isAtlassianManagedAccount: isAtlassianManagedAccount, projectId: projectId, kbEnabled: kbEnabled, categories: categories, isProjectAdmin: isProjectAdmin, isLoggedIn: isLoggedIn, canCustomiseHelpCenter: canCustomiseHelpCenter, isProjectSimplified: isProjectSimplified, isBrandingLoaded: isBrandingLoaded, isChatSideBarOpen: isChatSideBarOpen })=>{
    let isLoading = false;
    /**
   * Categories details are required only for single portal screen and not on portal groups / request create form screen (i.e when requestGroupId is present in the URL)
   */ if ((0, $1EFS8.default).checkGate('categories_loading_removed_for_request_create') && requestGroupId) isLoading = Boolean(!portal);
    else isLoading = Boolean(!portal || kbEnabled && !categories);
    const categoriesOrUndefined = Array.isArray(categories) ? categories : undefined;
    return {
        portalId: portalId,
        portalName: portalName,
        requestTypeId: requestTypeId,
        requestGroupId: requestGroupId,
        requestTypeName: requestTypeName,
        projectId: projectId,
        announcement: announcement,
        isLoading: isLoading,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        isAtlassianManagedAccount: isAtlassianManagedAccount,
        isBrandingLoaded: isBrandingLoaded,
        isLoggedIn: isLoggedIn,
        isChatSideBarOpen: isChatSideBarOpen,
        hasProformaForm: hasProformaForm,
        requestTypeBelongsToGroup: Boolean(requestTypeBelongsToGroup),
        requestCreateModelLoaded: Boolean(requestCreateModelLoaded),
        kbEnabled: Boolean(kbEnabled),
        categories: categoriesOrUndefined,
        isProjectAdmin: Boolean(isProjectAdmin),
        isProjectSimplified: Boolean(isProjectSimplified),
        categoriesLoaded: !!categories,
        error: portal && 'error' in portal ? portal : undefined,
        canEditAnnouncement: announcement ? announcement.canEditAnnouncement : undefined
    };
});
var $c48ffdc2e05a4950$export$2e2bcd8739ae039 = (0, $jvoWT.default)($c48ffdc2e05a4950$var$selector, {
    openChatSideBar: $8QZqc.openChatSideBar,
    closeChatSideBar: $8QZqc.closeChatSideBar,
    fetchPortal: (0, $d727K.fetchPortalAction),
    fetchUser: (0, $2gQsf.fetchUserModelAction),
    fetchCategories: (0, $gZNYv.fetchCategoriesAction),
    fetchRequestCreate: (0, $8bKnT.fetchRequestCreateAction),
    fetchUiModifications: (0, $4iHZF.fetchUiModificationsAction)
})((0, $eS4yu.default)({
    componentName: 'PortalHome'
})((0, $k7ZVu.default)()($c48ffdc2e05a4950$export$2521bdc6772d1464)));

});
parcelRegister("6KFgU", function(module, exports) {
$parcel$export(module.exports, "withExperience", () => $6f7d447bbe55fb57$export$7733b94414b7dcb7);
$parcel$export(module.exports, "Experience", () => (parcelRequire("cLBxy")).default);

var $8P7DW = parcelRequire("8P7DW");

var $cLBxy = parcelRequire("cLBxy");
const $6f7d447bbe55fb57$export$7733b94414b7dcb7 = (experienceName)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const Component = WrappedComponent;
            return /*#__PURE__*/ $8P7DW.createElement((0, $cLBxy.default), {
                name: experienceName
            }, /*#__PURE__*/ $8P7DW.createElement(Component, props));
        };

});

parcelRegister("7dWmH", function(module, exports) {
$parcel$export(module.exports, "getFormName", () => (parcelRequire("5EB6B")).getFormName);
$parcel$export(module.exports, "getFormInstructions", () => (parcelRequire("5EB6B")).getFormInstructions);
$parcel$export(module.exports, "getIconUrl", () => (parcelRequire("5EB6B")).getIconUrl);
$parcel$export(module.exports, "getRequestCreate", () => (parcelRequire("5EB6B")).getRequestCreate);
$parcel$export(module.exports, "getProjectId", () => (parcelRequire("5EB6B")).getProjectId);
$parcel$export(module.exports, "getIssueType", () => (parcelRequire("5EB6B")).getIssueType);
$parcel$export(module.exports, "getIssueTypeId", () => (parcelRequire("5EB6B")).getIssueTypeId);
$parcel$export(module.exports, "getRequestCreateOrError", () => (parcelRequire("5EB6B")).getRequestCreateOrError);
$parcel$export(module.exports, "getCanCreateUsers", () => (parcelRequire("5EB6B")).getCanCreateUsers);
$parcel$export(module.exports, "getDateFormat", () => (parcelRequire("5EB6B")).getDateFormat);
$parcel$export(module.exports, "getDateTimeFormat", () => (parcelRequire("5EB6B")).getDateTimeFormat);
$parcel$export(module.exports, "getFirstDay", () => (parcelRequire("5EB6B")).getFirstDay);
$parcel$export(module.exports, "getUseISO8601WeekNumbers", () => (parcelRequire("5EB6B")).getUseISO8601WeekNumbers);
$parcel$export(module.exports, "getOrganisationsForCurrentUser", () => (parcelRequire("5EB6B")).getOrganisationsForCurrentUser);
$parcel$export(module.exports, "getRequestTypeHasProformaForm", () => (parcelRequire("5EB6B")).getRequestTypeHasProformaForm);
$parcel$export(module.exports, "getProformaTemplateForm", () => (parcelRequire("5EB6B")).getProformaTemplateForm);
$parcel$export(module.exports, "getIsProformaFormDirty", () => (parcelRequire("5EB6B")).getIsProformaFormDirty);
$parcel$export(module.exports, "getIsPrefillPending", () => (parcelRequire("5EB6B")).getIsPrefillPending);

var $5EB6B = parcelRequire("5EB6B");

});
parcelRegister("5EB6B", function(module, exports) {
$parcel$export(module.exports, "getRequestCreate", () => $596b2ae8c814c753$export$15c8c5e17b9baa02);
$parcel$export(module.exports, "getFormName", () => $596b2ae8c814c753$export$fbe1ca2f3d088136);
$parcel$export(module.exports, "getIconUrl", () => $596b2ae8c814c753$export$89d1c740383224f4);
$parcel$export(module.exports, "getFormInstructions", () => $596b2ae8c814c753$export$76982f53d034f6b1);
$parcel$export(module.exports, "getRequestCreateOrError", () => $596b2ae8c814c753$export$16e5e434a1b5c95e);
$parcel$export(module.exports, "getProjectId", () => $596b2ae8c814c753$export$89040d072f281f85);
$parcel$export(module.exports, "getIssueType", () => $596b2ae8c814c753$export$ed2455632bf977ef);
$parcel$export(module.exports, "getIssueTypeId", () => $596b2ae8c814c753$export$110c9a4a16c5b8c9);
$parcel$export(module.exports, "getCanCreateUsers", () => $596b2ae8c814c753$export$cbe7d03f30fd0cb4);
$parcel$export(module.exports, "getDateFormat", () => $596b2ae8c814c753$export$fa96065c64444af6);
$parcel$export(module.exports, "getDateTimeFormat", () => $596b2ae8c814c753$export$c9c87e313820bd4c);
$parcel$export(module.exports, "getFirstDay", () => $596b2ae8c814c753$export$456eb4e172ef8704);
$parcel$export(module.exports, "getUseISO8601WeekNumbers", () => $596b2ae8c814c753$export$defea3d86e4ab71a);
$parcel$export(module.exports, "getOrganisationsForCurrentUser", () => $596b2ae8c814c753$export$fb4f9a76e583ce63);
$parcel$export(module.exports, "getRequestTypeHasProformaForm", () => $596b2ae8c814c753$export$740668767bebf9a);
$parcel$export(module.exports, "getProformaTemplateForm", () => $596b2ae8c814c753$export$9cb4f66aa30e267a);
$parcel$export(module.exports, "getIsProformaFormDirty", () => $596b2ae8c814c753$export$cd859d45f5982e2);
$parcel$export(module.exports, "getIsPrefillPending", () => $596b2ae8c814c753$export$c1f5b3a2b47daad);

var $e6Qdr = parcelRequire("e6Qdr");
const $596b2ae8c814c753$export$830c804e8d921bba = (state, portalId, requestTypeId)=>{
    if (!portalId || !requestTypeId) return undefined;
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.form;
};
const $596b2ae8c814c753$export$fbe1ca2f3d088136 = (state, portalId, requestTypeId)=>{
    const form = $596b2ae8c814c753$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.name;
};
const $596b2ae8c814c753$export$aa9648d61391326c = (state, portalId, requestTypeId)=>{
    const form = $596b2ae8c814c753$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.intro;
};
const $596b2ae8c814c753$export$89d1c740383224f4 = (state, portalId, requestTypeId)=>{
    const form = $596b2ae8c814c753$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.iconUrl;
};
const $596b2ae8c814c753$export$76982f53d034f6b1 = (state, portalId, requestTypeId)=>{
    const form = $596b2ae8c814c753$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.instructions;
};
const $596b2ae8c814c753$export$d5523731e7fe4ded = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.fields;
};
const $596b2ae8c814c753$export$b87c6f04552c18ef = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.mediaApiUploadToken;
};
const $596b2ae8c814c753$export$ddddbd1696231d6a = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.mediaApiError;
};
const $596b2ae8c814c753$export$15c8c5e17b9baa02 = (state, portalId, requestTypeId)=>{
    const data = $596b2ae8c814c753$export$16e5e434a1b5c95e(state, portalId, requestTypeId);
    return data && 'error' in data ? undefined : data;
};
const $596b2ae8c814c753$export$16e5e434a1b5c95e = (state, portalId, requestTypeId)=>{
    const id = `${portalId}/${requestTypeId}`;
    return state.persisted.requestCreate[id];
};
const $596b2ae8c814c753$export$89040d072f281f85 = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.projectId;
};
const $596b2ae8c814c753$export$ed2455632bf977ef = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.issueType;
};
const $596b2ae8c814c753$export$110c9a4a16c5b8c9 = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.issueTypeId;
};
const $596b2ae8c814c753$export$36651d42b0b3e63 = (state, portalId, requestTypeId)=>{
    const form = $596b2ae8c814c753$export$830c804e8d921bba(state, portalId, requestTypeId);
    return !!form && form.captchaEnabled && !!form.sitekey;
};
const $596b2ae8c814c753$export$490b07b05dbf5ae5 = (state, portalId, requestTypeId)=>{
    const form = $596b2ae8c814c753$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.captchaEnabled ? form.sitekey : undefined;
};
const $596b2ae8c814c753$export$cbe7d03f30fd0cb4 = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!requestCreate && !!requestCreate.canCreateUsers;
};
const $596b2ae8c814c753$export$fa96065c64444af6 = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.dateFormat;
};
const $596b2ae8c814c753$export$c9c87e313820bd4c = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.dateTimeFormat;
};
const $596b2ae8c814c753$export$456eb4e172ef8704 = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.firstDay;
};
const $596b2ae8c814c753$export$defea3d86e4ab71a = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.useISO8601WeekNumbers;
};
const $596b2ae8c814c753$export$fb4f9a76e583ce63 = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!requestCreate ? requestCreate.organisationsForCurrentUser : [];
};
const $596b2ae8c814c753$export$2808eba338b2ae16 = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!(requestCreate !== null && requestCreate !== void 0 && requestCreate.projectHasProformaForms);
};
const $596b2ae8c814c753$export$740668767bebf9a = (state, portalId, requestTypeId)=>{
    const requestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    if ((0, $e6Qdr.fg)('jsm_portal_enable_requestcreate_form_null_check')) {
        var _requestCreate$profor;
        return !!(requestCreate !== null && requestCreate !== void 0 && (_requestCreate$profor = requestCreate.proforma) !== null && _requestCreate$profor !== void 0 && _requestCreate$profor.formExists);
    }
    return !!(requestCreate !== null && requestCreate !== void 0 && requestCreate.proforma.formExists);
};
const $596b2ae8c814c753$export$9cb4f66aa30e267a = (state, portalId, requestTypeId)=>{
    var _getRequestCreate;
    const proformaTemplateForm = (_getRequestCreate = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) === null || _getRequestCreate === void 0 ? void 0 : _getRequestCreate.proformaTemplateForm;
    if (!proformaTemplateForm || Object.keys(proformaTemplateForm).length === 0) return undefined;
    return proformaTemplateForm;
};
const $596b2ae8c814c753$export$cd859d45f5982e2 = (state, portalId, requestTypeId)=>{
    var _getRequestCreate2;
    return !!((_getRequestCreate2 = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) !== null && _getRequestCreate2 !== void 0 && _getRequestCreate2.proformaFormIsDirty);
};
const $596b2ae8c814c753$export$c1f5b3a2b47daad = (state, portalId, requestTypeId)=>{
    var _getRequestCreate3;
    return !!((_getRequestCreate3 = $596b2ae8c814c753$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) !== null && _getRequestCreate3 !== void 0 && _getRequestCreate3.prefillPending);
};

});


parcelRegister("9FbAp", function(module, exports) {
$parcel$export(module.exports, "PortalHomeDumb", () => (parcelRequire("5LdUw")).default);

var $5LdUw = parcelRequire("5LdUw");

});
parcelRegister("5LdUw", function(module, exports) {
$parcel$export(module.exports, "default", () => $726dd61c2f820d12$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $c30HB = parcelRequire("c30HB");

var $fMDgb = parcelRequire("fMDgb");

var $8rTkC = parcelRequire("8rTkC");

var $gzPDp = parcelRequire("gzPDp");

var $edC7N = parcelRequire("edC7N");

var $4acrp = parcelRequire("4acrp");

var $HGACo = parcelRequire("HGACo");

var $7ex17 = parcelRequire("7ex17");

var $jByYr = parcelRequire("jByYr");

var $l4a5B = parcelRequire("l4a5B");
parcelRequire("4PbDu");
var $3FFzY = parcelRequire("3FFzY");

var $kKqLX = parcelRequire("kKqLX");

var $51hGk = parcelRequire("51hGk");
parcelRequire("16xQ4");
var $jZTWL = parcelRequire("jZTWL");
var $4qORj = parcelRequire("4qORj");
parcelRequire("26dY1");
var $bbQj2 = parcelRequire("bbQj2");
parcelRequire("72LHL");
var $4Em1B = parcelRequire("4Em1B");
parcelRequire("hGzcq");
var $gRzju = parcelRequire("gRzju");
parcelRequire("c4GhF");
var $i4cAY = parcelRequire("i4cAY");

var $14Dyz = parcelRequire("14Dyz");

var $bXfzz = parcelRequire("bXfzz");

var $cwHmd = parcelRequire("cwHmd");
parcelRequire("1n2hY");
var $4fSTF = parcelRequire("4fSTF");

var $uX9YM = parcelRequire("uX9YM");
parcelRequire("7Uadm");
var $dPp2Q = parcelRequire("dPp2Q");

var $lzhZC = parcelRequire("lzhZC");

var $78hCN = parcelRequire("78hCN");

var $hxumn = parcelRequire("hxumn");

var $9DaWq = parcelRequire("9DaWq");

var $8gu7I = parcelRequire("8gu7I");

var $1EFS8 = parcelRequire("1EFS8");

var $6Hfjm = parcelRequire("6Hfjm");
var $2Mjg8 = parcelRequire("2Mjg8");
var $37U6z = parcelRequire("37U6z");

var $4peLG = parcelRequire("4peLG");

var $b4JpE = parcelRequire("b4JpE");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $3Wo8f = parcelRequire("3Wo8f");

var $8IdoQ = parcelRequire("8IdoQ");

var $an0gU = parcelRequire("an0gU");

var $gjhiH = parcelRequire("gjhiH");

var $cVFW8 = parcelRequire("cVFW8");
parcelRequire("if06c");
var $3NLl7 = parcelRequire("3NLl7");
var $2vCgF = parcelRequire("2vCgF");
var $8O4Lj = parcelRequire("8O4Lj");

var $9blvX = parcelRequire("9blvX");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");
parcelRequire("fgzVg");
var $o7eIo = parcelRequire("o7eIo");

var $eBvxK = parcelRequire("eBvxK");
const $726dd61c2f820d12$var$validateRequestGroupIdPresent = (requestGroupId)=>{
    if (requestGroupId === -1) return false;
    return !!requestGroupId;
};
const $726dd61c2f820d12$var$getConnectPageType = (requestTypeId)=>{
    if (requestTypeId) return 0, $fMDgb.REQUEST_CREATE;
    return 0, $fMDgb.PORTAL_HOME;
};
const $726dd61c2f820d12$var$getForgePageType = (requestTypeId)=>{
    if (requestTypeId) return 0, $7ex17.FORGE_REQUEST_CREATE;
    return 0, $7ex17.FORGE_PORTAL_HOME;
};
const $726dd61c2f820d12$var$getPortalHomeTitle = ({ intl: intl, portalName: portalName, requestTypeName: requestTypeName, requestGroupId: requestGroupId })=>{
    if (requestTypeName) return intl.formatMessage((0, $eBvxK.default).requestTypePageTitle, {
        portalName: portalName,
        requestTypeName: requestTypeName
    });
    if (requestGroupId) return intl.formatMessage((0, $eBvxK.default).portalGroupPageTitle, {
        portalName: portalName
    });
    return intl.formatMessage((0, $eBvxK.default).portalPageTitle, {
        portalName: portalName
    });
};
const $726dd61c2f820d12$var$PortalHome = ({ intl: intl, requestTypeName: requestTypeName, requestTypeBelongsToGroup: requestTypeBelongsToGroup, portalName: portalName, portalId: portalId, projectId: projectId, loading: loading, requestTypeId: requestTypeId, requestGroupId: requestGroupId, sideBarOpen: sideBarOpen, announcement: announcement, categories: categories, canEditAnnouncement: canEditAnnouncement, isProjectSimplified: isProjectSimplified, isBrandingLoaded: isBrandingLoaded, isLoggedIn: isLoggedIn, canCustomiseHelpCenter: canCustomiseHelpCenter, isProjectAdmin: isProjectAdmin, isAtlassianManagedAccount: isAtlassianManagedAccount, toggleSidebar: toggleSidebar, screenName: screenName, isChatSideBarOpen: isChatSideBarOpen, hasProformaForm: hasProformaForm, openChatSideBar: openChatSideBarAction, closeChatSideBar: closeChatSideBarAction })=>{
    const customiseSidebarTriggerRef = (0, $gRzju.useCustomiseSidebarTriggerRef)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { [(0, $2vCgF.REFERRER_QUERY_PARAM)]: referrer } = (0, $iwSnV.useQueryParams)();
    const [isSubmitting, setIsSubmitting] = (0, $8P7DW.useState)(false);
    const openSidebar = (0, $8P7DW.useCallback)(()=>toggleSidebar(true), [
        toggleSidebar
    ]);
    const closeSidebar = (0, $8P7DW.useCallback)(()=>toggleSidebar(false), [
        toggleSidebar
    ]);
    const openChatSidebarCallback = (0, $8P7DW.useCallback)(()=>openChatSideBarAction === null || openChatSideBarAction === void 0 ? void 0 : openChatSideBarAction(), [
        openChatSideBarAction
    ]);
    const closeChatSidebarCallback = (0, $8P7DW.useCallback)(()=>closeChatSideBarAction === null || closeChatSideBarAction === void 0 ? void 0 : closeChatSideBarAction(), [
        closeChatSideBarAction
    ]);
    const onSubmit = (0, $8P7DW.useCallback)(()=>setIsSubmitting(true), [
        setIsSubmitting
    ]);
    const onSubmitComplete = (0, $8P7DW.useCallback)(()=>setIsSubmitting(false), [
        setIsSubmitting
    ]);
    const shouldRenderAsPortalAnnouncement = ()=>{
        // for simplified projects, render side bar as announcement for agents with permission
        if (isProjectSimplified && !isProjectAdmin && canEditAnnouncement) return true;
        // in classic projects render sidebar as announcement for users who can't modify helpcenter, but can edit announcements
        if (!isProjectSimplified && !canCustomiseHelpCenter && canEditAnnouncement) return true;
        return false;
    };
    const renderVsaChatSidebar = ()=>{
        if (!portalId || !isChatSideBarOpen) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $uX9YM.LazyVirtualServiceAgentChatSidebar), {
            isOpen: true,
            onOpen: openChatSidebarCallback,
            onClose: closeChatSidebarCallback,
            portalId: portalId
        }));
    };
    const renderSidebar = ()=>{
        if (!canEditAnnouncement) return null;
        if ((0, $gk18s.isKoshEnabledForDefaultHelpCenter)() && !isBrandingLoaded) // since check in shouldRenderAsPortalAnnouncement is dependent on "canCustomiseHelpCenter" which is coming from helpCenter model, we need to make sure branding relay call is completed
        return null;
        // Render the new 'next-gen' side bar, either as just the Announcement for agents with permission or with all customisation features available for admins
        if (shouldRenderAsPortalAnnouncement()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lzhZC.LazyPortalSettingsAnnouncementSidebar), {
            isOpen: sideBarOpen,
            onOpen: openSidebar,
            onClose: closeSidebar,
            triggerRef: customiseSidebarTriggerRef
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3FFzY.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $78hCN.LazyPortalSettingsSidebar), {
            isProjectSimplified: isProjectSimplified,
            isOpen: sideBarOpen,
            onOpen: openSidebar,
            onClose: closeSidebar,
            triggerRef: customiseSidebarTriggerRef
        }));
    };
    const key = String(requestTypeId);
    const title = portalName && $726dd61c2f820d12$var$getPortalHomeTitle({
        intl: intl,
        portalName: portalName,
        requestTypeName: requestTypeName,
        requestGroupId: requestGroupId
    });
    const shouldRenderDropdown = !!requestGroupId || !categories || !categories.length;
    const shouldShowRequestsInBreadcrumbs = !!shouldRenderDropdown && categories && !!categories.length;
    const isExternalLinksVisible = projectId && !$726dd61c2f820d12$var$validateRequestGroupIdPresent(requestGroupId) && !requestTypeId;
    const shouldShowSkeleton = projectId && requestTypeId; // show only on request create page (for now)
    const LoadingIndicator = shouldShowSkeleton ? (0, $i4cAY.SkeletonLoadingContainer) : (0, $4Em1B.default);
    const cloudId = (0, $jByYr.getCloudId)();
    const { isVirtualAgentEnabled: isVirtualAgentEnabled, isLoading: isVirtualAgentLoading } = (0, $an0gU.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const shouldShowLearnByDoingExperimentBanner = (0, $8O4Lj.shouldShowLearnByDoingBanner)(isProjectAdmin, referrer);
    if ((0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3Wo8f.Redirect), {
        to: '/'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gzPDp.default), {
        title: title,
        ignoreBaseTitle: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(LoadingIndicator, {
        isLoading: loading,
        enableUFOHold: true,
        ufoHoldName: "portal-home-dumb-fallback"
    }, loading && !announcement && !(0, $HGACo.isUseHelpCenterRefresh)() && (0, $1EFS8.default).checkGate('add_ufo_holds_to_request_create_form') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
        name: "announcement-banner-loading"
    }), !!announcement && !(0, $HGACo.isUseHelpCenterRefresh)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c30HB.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: $726dd61c2f820d12$var$AnnouncementInnerContainer
    }), requestGroupId && portalId && requestTypeId && !requestTypeBelongsToGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3Wo8f.Redirect), {
        to: `/portal/${portalId}/group/${requestGroupId}`,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            attributes: {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                [(0, $2vCgF.REFERRER_QUERY_PARAM)]: referrer
            }
        }
    }, shouldShowLearnByDoingExperimentBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        testId: "learn-by-doing-container",
        xcss: $726dd61c2f820d12$var$LearnByDoingContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3NLl7.default), {
        screenName: screenName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4fSTF.PaperContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cVFW8.UiModificationsEntryPoint), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $o7eIo.default), {
        showRequestsInBreadcrumbs: shouldShowRequestsInBreadcrumbs
    }), projectId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kKqLX.BlockedAppsBanner), {
        page: $726dd61c2f820d12$var$getForgePageType(requestTypeId),
        isAtlassianManagedAccount: isAtlassianManagedAccount,
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4qORj.default), {
        page: $726dd61c2f820d12$var$getConnectPageType(requestTypeId),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cwHmd.ForgeHeaderModule), {
        page: $726dd61c2f820d12$var$getForgePageType(requestTypeId),
        projectId: projectId,
        requestTypeId: requestTypeId,
        portalId: portalId
    }), isVirtualAgentLoading && (0, $1EFS8.default).checkGate('add_ufo_holds_to_request_create_form') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4peLG.default), {
        name: "virtual-agent-banner-loading"
    }), isVirtualAgentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $726dd61c2f820d12$var$virtualBannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gjhiH.VirtualAgentBanner), {
        cloudId: cloudId,
        portalId: portalId
    })), !requestGroupId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($726dd61c2f820d12$export$b1b1a7643a727bbc, {
        portalId: portalId
    }), shouldRenderDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($726dd61c2f820d12$export$a096e20ba94bf2ce, {
        autoFocus: true,
        portalId: portalId,
        requestGroupId: requestGroupId,
        requestTypeId: requestTypeId,
        isDisabled: isSubmitting
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dPp2Q.default), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), (0, $1EFS8.default).checkGate('chunk_for_request_create_form_with_proform') && hasProformaForm ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9DaWq.RequestCreateFormWithProforma), {
        portalId: portalId,
        requestTypeId: requestTypeId,
        key: key,
        onSubmit: onSubmit,
        onSubmitComplete: onSubmitComplete
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hxumn.RequestCreateForm), {
        portalId: portalId,
        requestTypeId: requestTypeId,
        key: key,
        onSubmit: onSubmit,
        onSubmitComplete: onSubmitComplete
    }), isExternalLinksVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($726dd61c2f820d12$var$ExternalLinksListWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $14Dyz.ExternalLinks), {
        projectId: projectId
    })), (0, $1EFS8.default).checkGate('rovo_service_agent_widget_experience') && projectId && isAtlassianManagedAccount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9blvX.RovoServiceAgentWidgetInjector), {
        siteId: cloudId,
        widgetId: (0, $b4JpE.JiraProjectAri).create({
            projectId: projectId.toString(),
            siteId: cloudId
        }).toString(),
        surface: "PORTAL"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jZTWL.default), {
        page: $726dd61c2f820d12$var$getConnectPageType(requestTypeId),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bXfzz.ForgeFooterModule), {
        page: $726dd61c2f820d12$var$getForgePageType(requestTypeId),
        projectId: projectId,
        requestTypeId: requestTypeId,
        portalId: portalId
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: (0, $8rTkC.ScreenName).HELP_CENTER_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR,
        id: 'portal-home-sidebar'
    }, sideBarOpen && renderSidebar()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: (0, $8rTkC.ScreenName).HELP_CENTER_VSA_CHAT_SIDEBAR,
        id: 'portal-home-vsa-chat-sidebar'
    }, isChatSideBarOpen && renderVsaChatSidebar()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8IdoQ.SidebarToggle), {
        openSidebar: openSidebar,
        closeSidebar: closeSidebar
    })));
};
const $726dd61c2f820d12$export$22ca00a6007ba086 = (0, $4acrp.withErrorPage)($726dd61c2f820d12$var$PortalHome, {
    isEmptyTraceIdLogExcluded: true
});
var $726dd61c2f820d12$export$2e2bcd8739ae039 = (0, $l4a5B.default)($726dd61c2f820d12$export$22ca00a6007ba086);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $726dd61c2f820d12$var$AnnouncementInnerContainer = /*#__PURE__*/ (0, $2UsNA.default)((0, $4fSTF.PaperContent)).withConfig({
    componentId: "sc-1lc3w8v-0"
})`padding-top:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $726dd61c2f820d12$var$ExternalLinksListWrapper = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1lc3w8v-1"
})`margin-top:${"var(--ds-space-400, 32px)"};`;
const $726dd61c2f820d12$export$a096e20ba94bf2ce = /*#__PURE__*/ (0, $2UsNA.default)((0, $bbQj2.default)).withConfig({
    componentId: "sc-1lc3w8v-2"
})`margin:${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-100, 8px)"};position:relative;`;
const $726dd61c2f820d12$export$b1b1a7643a727bbc = /*#__PURE__*/ (0, $2UsNA.default)((0, $51hGk.CategoryList)).withConfig({
    componentId: "sc-1lc3w8v-3"
})`margin-top:${"var(--ds-space-400, 32px)"};`;
const $726dd61c2f820d12$var$virtualBannerStyles = (0, $37U6z.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.200'
});
const $726dd61c2f820d12$var$LearnByDoingContainerStyles = (0, $37U6z.xcss)({
    height: '266px',
    display: 'none',
    [(0, $2Mjg8.media).above.md]: {
        display: 'flex'
    }
});

});
parcelRegister("kKqLX", function(module, exports) {
$parcel$export(module.exports, "BlockedAppsBanner", () => $60e775fdaaa433da$export$757c2c7994b73daa);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("gn4oJ");
var $6t6Ik = parcelRequire("6t6Ik");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $d5GcW = parcelRequire("d5GcW");

var $eS4yu = parcelRequire("eS4yu");
const $60e775fdaaa433da$var$blockedAppsBannerSelector = (0, $ehscL.createSelector)((0, $6t6Ik.getBlockedAppsBannerStatePortal), (0, $6t6Ik.getBlockedAppsBannerStateRequestView), (0, $6t6Ik.getBlockedAppsBannerStateCreateRequest), (0, $hx8zX.getAccountId), (portal, viewRequest, createRequest, accountId)=>{
    return {
        accountId: accountId,
        blockedAppsBannerState: {
            portal: portal,
            view_request: viewRequest,
            create_request: createRequest
        }
    };
});
const $60e775fdaaa433da$export$757c2c7994b73daa = (0, $jvoWT.default)($60e775fdaaa433da$var$blockedAppsBannerSelector)((0, $eS4yu.default)({
    componentName: 'blockedAppBanner'
})((0, $d5GcW.default)));

});
parcelRegister("gn4oJ", function(module, exports) {
$parcel$export(module.exports, "getBlockedAppsBannerStatePortal", () => (parcelRequire("6t6Ik")).getBlockedAppsBannerStatePortal);
$parcel$export(module.exports, "getBlockedAppsBannerStateCreateRequest", () => (parcelRequire("6t6Ik")).getBlockedAppsBannerStateCreateRequest);
$parcel$export(module.exports, "getBlockedAppsBannerStateRequestView", () => (parcelRequire("6t6Ik")).getBlockedAppsBannerStateRequestView);

var $6t6Ik = parcelRequire("6t6Ik");

});
parcelRegister("6t6Ik", function(module, exports) {
$parcel$export(module.exports, "getBlockedAppsBannerStatePortal", () => $1947df7bdbed9a6f$export$5d00eff3ead4a783);
$parcel$export(module.exports, "getBlockedAppsBannerStateRequestView", () => $1947df7bdbed9a6f$export$5e1a47e73ae7249);
$parcel$export(module.exports, "getBlockedAppsBannerStateCreateRequest", () => $1947df7bdbed9a6f$export$4b185f1cda5a42b9);
const $1947df7bdbed9a6f$export$5d00eff3ead4a783 = (state)=>{
    return state.persisted.blockedAppsBanner.portal || state.persisted.blockedAppsBanner.connect.portal;
};
const $1947df7bdbed9a6f$export$5e1a47e73ae7249 = (state)=>{
    return state.persisted.blockedAppsBanner.view_request || state.persisted.blockedAppsBanner.connect.view_request;
};
const $1947df7bdbed9a6f$export$4b185f1cda5a42b9 = (state)=>{
    return state.persisted.blockedAppsBanner.create_request || state.persisted.blockedAppsBanner.connect.create_request;
};

});


parcelRegister("d5GcW", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7599d88949f8d0e$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $7ex17 = parcelRequire("7ex17");

var $5jYgE = parcelRequire("5jYgE");

var $MmGmU = parcelRequire("MmGmU");

var $1EFS8 = parcelRequire("1EFS8");

var $ggKR1 = parcelRequire("ggKR1");
var $9aDu7 = parcelRequire("9aDu7");

var $iziiq = parcelRequire("iziiq");

var $hmGtR = parcelRequire("hmGtR");

var $jsmb9 = parcelRequire("jsmb9");

var $5K2Na = parcelRequire("5K2Na");
const $b7599d88949f8d0e$export$6db1cbf096e6afb2 = 'sd.portal.blocked.apps.banner.learnMore';
const $b7599d88949f8d0e$export$f35e1704e0ced261 = 'sd.portal.blocked.apps.banner.doNotShow';
const $b7599d88949f8d0e$var$getStyles = (page)=>{
    if (page === (0, $7ex17.FORGE_REQUEST_DETAILS)) return {
        marginBottom: `${"var(--ds-space-300, 24px)"}`
    };
    return {
        marginTop: `${"var(--ds-space-300, 24px)"}`
    };
};
const $b7599d88949f8d0e$export$1cac45d8ffd5ecc3 = (accountId, projectId)=>{
    return `showBlockedAppsBanner-${projectId}-${accountId}`;
};
const $b7599d88949f8d0e$var$BlockedAppsBannerComponent = ({ blockedAppsBannerState: blockedAppsBannerState, page: page, projectId: projectId, isAtlassianManagedAccount: isAtlassianManagedAccount, accountId: accountId })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const [showBannerForProject, setShowBannerForProject] = (0, $8P7DW.useState)(false);
    const doNotShowClickHandler = (0, $8P7DW.useCallback)(()=>{
        if (accountId) (0, $hmGtR.setLocalStorageItem)($b7599d88949f8d0e$export$1cac45d8ffd5ecc3(accountId, projectId), 'false');
        setShowBannerForProject(false);
    }, [
        accountId,
        projectId
    ]);
    const learnMoreUrl = (0, $8P7DW.useMemo)(()=>{
        return (0, $jsmb9.getLearnMoreUrl)();
    }, []);
    const isBannerCondtionsSatisfied = // @ts-ignore
    !!blockedAppsBannerState && !!blockedAppsBannerState[page] && isAtlassianManagedAccount && showBannerForProject;
    (0, $8P7DW.useEffect)(()=>{
        if (accountId) {
            const showBannerStatus = (0, $hmGtR.getLocalStorageItem)($b7599d88949f8d0e$export$1cac45d8ffd5ecc3(accountId, projectId));
            if (showBannerStatus && showBannerStatus === 'false') setShowBannerForProject(false);
            else setShowBannerForProject(true);
        }
    }, [
        accountId,
        projectId
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (isBannerCondtionsSatisfied) {
            const event = createAnalyticsEvent({
                analyticsType: (0, $iziiq.UI_EVENT_TYPE),
                action: 'viewed',
                actionSubject: 'blockedAppBanner',
                attributes: {
                    page: page,
                    userType: isAtlassianManagedAccount ? 'isAtlassianManagedAccount' : 'customer'
                }
            });
            event.fire();
        }
    }, [
        createAnalyticsEvent,
        isBannerCondtionsSatisfied,
        accountId,
        projectId,
        isAtlassianManagedAccount,
        page
    ]);
    if (isBannerCondtionsSatisfied) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        style: $b7599d88949f8d0e$var$getStyles(page)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ggKR1.default), {
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9aDu7.default), {
                testId: $b7599d88949f8d0e$export$6db1cbf096e6afb2,
                href: learnMoreUrl,
                key: $b7599d88949f8d0e$export$6db1cbf096e6afb2
            }, formatMessage((0, $5K2Na.default).learnMore)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9aDu7.default), {
                testId: $b7599d88949f8d0e$export$f35e1704e0ced261,
                onClick: doNotShowClickHandler,
                key: $b7599d88949f8d0e$export$f35e1704e0ced261
            }, formatMessage((0, $5K2Na.default).doNotShow))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("p", null, (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $5K2Na.default).bannerDescriptionGalaxia) : formatMessage((0, $5K2Na.default).bannerDescription)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null);
};
var $b7599d88949f8d0e$export$2e2bcd8739ae039 = $b7599d88949f8d0e$var$BlockedAppsBannerComponent;

});
parcelRegister("9aDu7", function(module, exports) {
$parcel$export(module.exports, "default", () => $683ff90fb328dd1e$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.37.1 */ /* section-message-action.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $ifRQf = parcelRequire("ifRQf");

var $6NJAV = parcelRequire("6NJAV");

var $2XLqF = parcelRequire("2XLqF");

var $e6Qdr = parcelRequire("e6Qdr");

var $2CGHX = parcelRequire("2CGHX");
var $bgvtM = parcelRequire("bgvtM");
const $683ff90fb328dd1e$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_syaz13af _k48p1wq8 _bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz",
    pressableT26Shape: "_2rkolb4i"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $683ff90fb328dd1e$var$SectionMessageAction = /*#__PURE__*/ (0, $8P7DW.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }) {
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
            className: (0, $8n1kL.default)([
                $683ff90fb328dd1e$var$styles.common,
                $683ff90fb328dd1e$var$styles.anchor
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2XLqF.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                target: target,
                children: children
            })
        });
        if (onClick) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bgvtM.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $6NJAV.cx)($683ff90fb328dd1e$var$styles.common, $683ff90fb328dd1e$var$styles.pressable, (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $683ff90fb328dd1e$var$styles.pressableT26Shape),
            children: children
        });
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
            as: "span",
            testId: testId,
            xcss: $683ff90fb328dd1e$var$styles.common,
            children: children
        });
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Fragment), {
        children: children
    });
});
var $683ff90fb328dd1e$export$2e2bcd8739ae039 = $683ff90fb328dd1e$var$SectionMessageAction;

});

parcelRegister("5K2Na", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b895a21751f0587$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $9b895a21751f0587$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    bannerDescription: {
        defaultMessage: "Can\u2019t find something? Some apps are blocked by your admin in this project through a data security policy.",
        description: 'The description of blocked apps banner',
        id: 'sd.portal.blocked.app.banner.description'
    },
    bannerDescriptionGalaxia: {
        defaultMessage: "Can\u2019t find something? Some apps are blocked by your admin in this space through a data security policy.",
        description: 'The description of blocked apps banner',
        id: 'sd.portal.blocked.app.banner.description-galaxia'
    },
    doNotShow: {
        defaultMessage: "Don't show again",
        description: 'Do not show again link. When the user clicks on this, he will not see the blocked apps banner again',
        id: 'sd.portal.blocked.app.banner.doNotShow'
    },
    learnMore: {
        defaultMessage: 'View blocked apps',
        description: 'This is a link that the users can click to view the blocked apps',
        id: 'sd.portal.blocked.app.banner.learnMore'
    }
});

});



parcelRegister("51hGk", function(module, exports) {
$parcel$export(module.exports, "CategoryList", () => $4bcf29997d2c2d8f$export$79717968ed9ae6cd);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");

var $gfLAG = parcelRequire("gfLAG");
const $4bcf29997d2c2d8f$var$selector = (0, $ehscL.createSelector)((state, props)=>(0, $73V7l.getCategories)(state, props.portalId), (state, props)=>(0, $73V7l.getIsKbEnabled)(state, props.portalId), (state, props)=>(0, $73V7l.getPortalLink)(state, props.portalId), (state, props)=>(0, $73V7l.canCreateRequest)(state, props.portalId), (maybeCategories, enabled, portalLink, showRequestCreateButton)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories,
        portalLink: portalLink,
        showRequestCreateButton: showRequestCreateButton,
        hidden: !enabled
    };
});
const $4bcf29997d2c2d8f$export$79717968ed9ae6cd = (0, $jvoWT.default)($4bcf29997d2c2d8f$var$selector)((0, $gfLAG.default));

});
parcelRegister("gfLAG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3813702820b70fc$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");

var $l4cjO = parcelRequire("l4cjO");
parcelRequire("dwWBt");
var $i7w4f = parcelRequire("i7w4f");
parcelRequire("cMJuC");
var $bJxQf = parcelRequire("bJxQf");

var $8gu7I = parcelRequire("8gu7I");

var $llRcE = parcelRequire("llRcE");

var $aQXm8 = parcelRequire("aQXm8");
parcelRequire("ZLsWM");
var $7CnQw = parcelRequire("7CnQw");

var $arnAF = parcelRequire("arnAF");
class $c3813702820b70fc$export$2e2bcd8739ae039 extends $8P7DW.Component {
    static #_ = this.defaultProps = {
        portalId: undefined,
        categories: []
    };
    render() {
        const { portalId: portalId, categories: categories, portalLink: portalLink, hidden: hidden, cardLinkAppearance: cardLinkAppearance, className: className, showRequestCreateButton: showRequestCreateButton, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        if (hidden || !portalId || categories.length === 0) return null;
        const analyticData = {
            attributes: {
                numberOfCategories: categories.length
            }
        };
        return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
            data: analyticData
        }, /*#__PURE__*/ $8P7DW.createElement($c3813702820b70fc$export$be92b6f5f03c0fe9, {
            className: className
        }, /*#__PURE__*/ $8P7DW.createElement((0, $aQXm8.FireScreenEventOnMount), null), /*#__PURE__*/ $8P7DW.createElement($c3813702820b70fc$var$CategorySectionTitle, null, /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($llRcE))), {
            spacing: "spacious",
            label: "",
            "aria-hidden": "true",
            color: "var(--ds-icon, #42526E)"
        }), /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $arnAF.default).kbCategorySectionTitle)), /*#__PURE__*/ $8P7DW.createElement($c3813702820b70fc$var$CategoryItems, null, categories.map((category)=>/*#__PURE__*/ $8P7DW.createElement($c3813702820b70fc$var$CategoryItemContainer, {
                key: category.id
            }, /*#__PURE__*/ $8P7DW.createElement((0, $7CnQw.default), {
                portalId: portalId,
                category: category,
                isEmbeddedRoute: isEmbeddedRoute
            })))), showRequestCreateButton && /*#__PURE__*/ $8P7DW.createElement((0, $bJxQf.default), {
            appearance: cardLinkAppearance,
            to: portalLink,
            isEmbeddedRoute: isEmbeddedRoute
        })));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c3813702820b70fc$var$CategorySectionTitle = /*#__PURE__*/ (0, $2UsNA.default).h2.withConfig({
    componentId: "sc-12gjrid-0"
})`${$kBzhX.h500};display:flex;align-items:center;font-weight:600;margin-bottom:0;> :first-child{margin-right:${"var(--ds-space-100, 8px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c3813702820b70fc$var$CategoryItems = /*#__PURE__*/ (0, $2UsNA.default).ul.withConfig({
    componentId: "sc-12gjrid-1"
})`padding:0;margin:0 -${(0, $i7w4f.GROUP_BOX_PADDING_LEFT_RIGHT)} ${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c3813702820b70fc$var$CategoryItemContainer = /*#__PURE__*/ (0, $2UsNA.default).li.withConfig({
    componentId: "sc-12gjrid-2"
})`padding:0;margin:0;list-style:none;`;
const $c3813702820b70fc$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-12gjrid-3"
})`flex:1 1 auto;`;

});
parcelRegister("ZLsWM", function(module, exports) {
$parcel$export(module.exports, "CategoryItem", () => (parcelRequire("7CnQw")).default);

var $7CnQw = parcelRequire("7CnQw");

});
parcelRegister("7CnQw", function(module, exports) {
$parcel$export(module.exports, "default", () => $15ebeb192f725196$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("3AWxl");
var $i7ZEn = parcelRequire("i7ZEn");

var $8gu7I = parcelRequire("8gu7I");

var $1EFS8 = parcelRequire("1EFS8");
class $15ebeb192f725196$export$2e2bcd8739ae039 extends $8P7DW.Component {
    render() {
        const { category: category, portalId: portalId, onClick: onClick, className: className, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        const analyticData = {
            attributes: {
                portalId: portalId,
                categoryId: category.id
            }
        };
        return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
            data: analyticData
        }, /*#__PURE__*/ $8P7DW.createElement((0, $i7ZEn.default), {
            actionSubjectId: "category",
            to: `/portal/${portalId}/topic/${category.id}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: onClick,
            heading: category.name,
            headingAs: (0, $1EFS8.default).checkGate('ff_a11y_hc_heading') ? 'div' : undefined,
            isAriaHidden: (0, $1EFS8.default).checkGate('ff_a11y_hc_aria'),
            description: category.description,
            lineClamp: 2,
            target: isEmbeddedRoute ? '_blank' : undefined
        }));
    }
}

});


parcelRegister("arnAF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7f30d106f8c1e48$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $d7f30d106f8c1e48$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    kbCategorySectionTitle: {
        defaultMessage: 'Learn more about',
        description: 'Section title for a section that shows a list of knowledge base categories',
        id: 'cv.portal.home.kb.category.section.title'
    }
});

});



parcelRegister("16xQ4", function(module, exports) {
$parcel$export(module.exports, "HeaderConnectFragments", () => (parcelRequire("4qORj")).default);
$parcel$export(module.exports, "FooterConnectFragments", () => (parcelRequire("jZTWL")).default);
/*
  Previously a distinction was made between the single portal and request-create pages when rendering connect fragments.
  In Portal X, the portal home and request create page display the same connect fragments.
*/ parcelRequire("5tGhb");
var $4qORj = parcelRequire("4qORj");
parcelRequire("fLXWT");
var $jZTWL = parcelRequire("jZTWL");

});
parcelRegister("5tGhb", function(module, exports) {
$parcel$export(module.exports, "HeaderConnectFragments", () => (parcelRequire("4qORj")).default);

var $4qORj = parcelRequire("4qORj");

});
parcelRegister("4qORj", function(module, exports) {
$parcel$export(module.exports, "default", () => $b05307fc2f28fbc8$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $6ecLQ = parcelRequire("6ecLQ");
var $fMDgb = parcelRequire("fMDgb");
const $b05307fc2f28fbc8$var$HeaderConnectFragments = ({ page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>/*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $6ecLQ.ConnectFragment), {
        page: page,
        location: (0, $fMDgb.HEADER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }), /*#__PURE__*/ $8P7DW.createElement((0, $6ecLQ.ConnectFragment), {
        page: page,
        location: (0, $fMDgb.SUB_HEADER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }));
var $b05307fc2f28fbc8$export$2e2bcd8739ae039 = $b05307fc2f28fbc8$var$HeaderConnectFragments;

});


parcelRegister("fLXWT", function(module, exports) {
$parcel$export(module.exports, "FooterConnectFragments", () => (parcelRequire("jZTWL")).default);

var $jZTWL = parcelRequire("jZTWL");

});
parcelRegister("jZTWL", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8e12d1db45777e6$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $6ecLQ = parcelRequire("6ecLQ");
var $fMDgb = parcelRequire("fMDgb");
const $b8e12d1db45777e6$var$FooterConnectFragments = ({ page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>/*#__PURE__*/ $8P7DW.createElement($b8e12d1db45777e6$var$ConnectFooterContainer, null, /*#__PURE__*/ $8P7DW.createElement((0, $6ecLQ.ConnectFragment), {
        page: page,
        location: (0, $fMDgb.FOOTER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }));
var $b8e12d1db45777e6$export$2e2bcd8739ae039 = $b8e12d1db45777e6$var$FooterConnectFragments;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b8e12d1db45777e6$var$ConnectFooterContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1lbb1kc-0"
})`padding-top:0;padding-bottom:0;`;

});



parcelRegister("26dY1", function(module, exports) {
$parcel$export(module.exports, "FormPicker", () => (parcelRequire("bbQj2")).default);

var $bbQj2 = parcelRequire("bbQj2");

});
parcelRegister("bbQj2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1587e12868b83f54$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("9FfOm");
var $2CIj9 = parcelRequire("2CIj9");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
parcelRequire("hj9aW");
var $1HQfD = parcelRequire("1HQfD");
const $1587e12868b83f54$var$getRequestTypes = (state, props)=>(0, $73V7l.getPortalRequestTypes)(state, props.portalId);
const $1587e12868b83f54$var$getRequestGroups = (state, props)=>(0, $73V7l.getPortalRequestGroups)(state, props.portalId);
const $1587e12868b83f54$var$getIsSimplifiedPortal = (state, props)=>Boolean((0, $73V7l.getIsProjectSimplified)(state, props.portalId));
const $1587e12868b83f54$var$getPortalProjectKey = (state, props)=>{
    const projectKey = (0, $73V7l.getProjectKey)(state, props === null || props === void 0 ? void 0 : props.portalId);
    return (projectKey === null || projectKey === void 0 ? void 0 : projectKey.toString()) || '';
};
const $1587e12868b83f54$var$getIsProjectAdmin = (state, props)=>{
    return Boolean((0, $73V7l.getCanAdministerProject)(state, props.portalId));
};
const $1587e12868b83f54$var$getIsJiraAdmin = (state, _)=>{
    return Boolean((0, $hx8zX.getCanAdministerJIRA)(state));
};
const $1587e12868b83f54$var$getRequestTypeNameById = (id, requestTypes)=>{
    const requestType = requestTypes.find((reqType)=>reqType.id === id);
    return requestType ? {
        name: requestType.name,
        id: requestType.id
    } : undefined;
};
const $1587e12868b83f54$var$getRequestTypeNames = (groupReqTypes = [], portalReqGroups)=>groupReqTypes.map((id)=>$1587e12868b83f54$var$getRequestTypeNameById(id, portalReqGroups)).filter(Boolean);
const $1587e12868b83f54$var$populateRequestTypeNames = (portalReqTypes)=>(requestGroup)=>({
            ...requestGroup,
            reqTypes: $1587e12868b83f54$var$getRequestTypeNames(requestGroup.reqTypes, portalReqTypes)
        });
const $1587e12868b83f54$var$selector = (0, $ehscL.createSelector)($1587e12868b83f54$var$getRequestGroups, $1587e12868b83f54$var$getRequestTypes, (0, $2CIj9.getPortals), $1587e12868b83f54$var$getIsSimplifiedPortal, $1587e12868b83f54$var$getPortalProjectKey, $1587e12868b83f54$var$getIsProjectAdmin, $1587e12868b83f54$var$getIsJiraAdmin, (requestGroups, requestTypes, allPortals, isProjectSimplified, projectKey, isProjectAdmin, isJiraAdmin)=>({
        requestTypes: requestTypes,
        isProjectSimplified: isProjectSimplified,
        projectKey: projectKey,
        isProjectAdmin: isProjectAdmin,
        isJiraAdmin: isJiraAdmin,
        requestGroups: requestGroups.map($1587e12868b83f54$var$populateRequestTypeNames(requestTypes)),
        // displayLinkWhenNoGroups will only return true if portals data is already populated. If this page is accessed by direct link, it'll return false.
        // As it's such an edge case, it was decided that's enough.
        displayLinkWhenNoGroups: Object.keys(allPortals).length > 1
    }));
var $1587e12868b83f54$export$2e2bcd8739ae039 = (0, $jvoWT.default)($1587e12868b83f54$var$selector)((0, $1HQfD.default));

});
parcelRegister("hj9aW", function(module, exports) {
$parcel$export(module.exports, "FormPickerDumb", () => (parcelRequire("1HQfD")).default);

var $1HQfD = parcelRequire("1HQfD");

});
parcelRegister("1HQfD", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f371d513f592f14$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $edC7N = parcelRequire("edC7N");

var $HGACo = parcelRequire("HGACo");

var $04X5p = parcelRequire("04X5p");

var $l4cjO = parcelRequire("l4cjO");
var $l4a5B = parcelRequire("l4a5B");
parcelRequire("drtq4");
var $gUiQ0 = parcelRequire("gUiQ0");
var $7qfPt = parcelRequire("7qfPt");
var $2iBdu = parcelRequire("2iBdu");

var $aQXm8 = parcelRequire("aQXm8");

var $7FSs7 = parcelRequire("7FSs7");

var $2Np0t = parcelRequire("2Np0t");
parcelRequire("if06c");
var $2vCgF = parcelRequire("2vCgF");
parcelRequire("3h5x9");
var $faNTC = parcelRequire("faNTC");
parcelRequire("gPk0D");
var $bMTX1 = parcelRequire("bMTX1");

var $iYSs5 = parcelRequire("iYSs5");
class $9f371d513f592f14$export$600c4eef2a10987b extends $8P7DW.Component {
    static #_ = this.defaultProps = {
        // Required to explicitly set this to false by default as the <AutoFocus />
        // component will focus when it is `undefined`.
        autoFocus: false
    };
    render() {
        const { requestGroupId: requestGroupId, requestTypeId: requestTypeId, portalId: portalId, requestGroups: requestGroups, isDisabled: isDisabled, className: className, intl: intl, hideLabels: hideLabels, autoFocus: autoFocus, cardLinkAppearance: cardLinkAppearance, displayLinkWhenNoGroups: displayLinkWhenNoGroups, isEmbeddedRoute: isEmbeddedRoute, isCSM: isCSM, isProjectSimplified: isProjectSimplified, projectKey: projectKey, isProjectAdmin: isProjectAdmin } = this.props;
        const hasSingleRequestGroup = requestGroups.length === 1;
        const hasRequestGroup = requestGroups.length > 0;
        // If a group id is passed through that isn't actually inside the request groups array we make it undefined
        const matchingRequestGroupId = !!requestGroups.find((group)=>group.id === requestGroupId) ? requestGroupId : undefined;
        // If there is only one element in the request groups array we force it to be selected.
        const selectedRequestGroupId = hasSingleRequestGroup ? requestGroups[0].id : matchingRequestGroupId;
        const requestTypesForGroup = this.getRequestTypesForSelectedRequestGroup(selectedRequestGroupId);
        // If a type id is passed through that isn't actually inside the request types array we make it undefined
        const selectedRequestTypeId = !!requestTypesForGroup.find((requestType)=>Number(requestType.id) === Number(requestTypeId)) ? requestTypeId : undefined;
        const { customizePortalButtonsGroup: customizePortalButtonsGroup, editRequestTypeOnRequestForm: editRequestTypeOnRequestForm, editRequestTypeOnRequestList: editRequestTypeOnRequestList } = this.getAdditionButtonsForCortopv2Experiment(isProjectAdmin, isProjectSimplified, projectKey, selectedRequestTypeId, selectedRequestGroupId);
        return hasRequestGroup ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $8P7DW.createElement("div", {
            className: className
        }, hasSingleRequestGroup || /*#__PURE__*/ $8P7DW.createElement((0, $faNTC.default), {
            autoFocus: autoFocus && !selectedRequestGroupId,
            portalId: portalId,
            requestGroups: requestGroups,
            label: !!hideLabels ? '' : intl.formatMessage((0, $iYSs5.default).requestGroupSelectLabel),
            value: selectedRequestGroupId,
            onChange: this.selectRequestGroup,
            disabled: isDisabled,
            cardLinkAppearance: cardLinkAppearance,
            isEmbeddedRoute: isEmbeddedRoute,
            ...!!customizePortalButtonsGroup && {
                customizePortalButtonsGroup: customizePortalButtonsGroup
            }
        }), !!requestTypesForGroup.length && /*#__PURE__*/ $8P7DW.createElement($9f371d513f592f14$export$d9d410f2d2df162e, {
            hasTopMargin: !hasSingleRequestGroup,
            autoFocus: autoFocus && !!selectedRequestGroupId,
            portalId: portalId,
            requestGroupId: selectedRequestGroupId,
            label: this.getStyledRequestTypeSelectLabel(),
            requestTypes: requestTypesForGroup,
            value: selectedRequestTypeId,
            onChange: this.selectRequestType,
            disabled: isDisabled,
            cardLinkAppearance: cardLinkAppearance,
            isEmbeddedRoute: isEmbeddedRoute,
            isCSM: isCSM,
            headingAs: "div",
            ...!!editRequestTypeOnRequestForm && {
                editRequestTypeOnRequestForm: editRequestTypeOnRequestForm
            },
            ...!!editRequestTypeOnRequestList && {
                editRequestTypeOnRequestList: editRequestTypeOnRequestList
            }
        })) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $8P7DW.createElement("div", {
            className: className
        }, /*#__PURE__*/ $8P7DW.createElement((0, $aQXm8.FireScreenEventOnMount), null), /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $iYSs5.default).emptyStateMessage), ' ', displayLinkWhenNoGroups && /*#__PURE__*/ $8P7DW.createElement((0, $04X5p.default), {
            actionSubjectId: "tryAnotherServiceDesk",
            to: "/portals"
        }, /*#__PURE__*/ $8P7DW.createElement((0, $l4cjO.default), (0, $iYSs5.default).tryAnotherServiceProjectLink)));
    }
    getAdditionButtonsForCortopv2Experiment(isProjectAdmin, isProjectSimplified, projectKey, selectedRequestTypeId, selectedRequestGroupId) {
        if (!(0, $HGACo.isCortopv2ExperimentTGEnabled)()) return {
            customizePortalButtonsGroup: null,
            editRequestTypeOnRequestForm: null,
            editRequestTypeOnRequestList: null
        };
        const shouldShowAdditionalPortalLinks = ()=>isProjectAdmin && !isProjectSimplified && (0, $HGACo.isCortopv2ExperimentEnabledWithExposure)(true);
        const customizePortalButtonsGroup = projectKey !== null && projectKey !== void 0 && projectKey.length && shouldShowAdditionalPortalLinks() ? /*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
            id: "customize-portal-button-group",
            renderError: ()=>null
        }, /*#__PURE__*/ $8P7DW.createElement((0, $gUiQ0.default), {
            projectKey: projectKey
        })) : null;
        const editRequestTypeOnRequestForm = projectKey !== null && projectKey !== void 0 && projectKey.length && !!selectedRequestTypeId && shouldShowAdditionalPortalLinks() ? /*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
            id: "edit-request-type-button",
            renderError: ()=>null
        }, /*#__PURE__*/ $8P7DW.createElement((0, $7qfPt.default), {
            projectKey: projectKey,
            requestTypeId: selectedRequestTypeId
        })) : null;
        const editRequestTypeOnRequestList = projectKey !== null && projectKey !== void 0 && projectKey.length && !!selectedRequestGroupId && shouldShowAdditionalPortalLinks() ? (requestTypeIdForListItem)=>/*#__PURE__*/ $8P7DW.createElement((0, $edC7N.default), {
                id: "edit-request-type-button",
                renderError: ()=>null
            }, /*#__PURE__*/ $8P7DW.createElement((0, $2iBdu.default), {
                projectKey: projectKey,
                requestTypeId: requestTypeIdForListItem
            })) : null;
        return {
            customizePortalButtonsGroup: customizePortalButtonsGroup,
            editRequestTypeOnRequestForm: editRequestTypeOnRequestForm,
            editRequestTypeOnRequestList: editRequestTypeOnRequestList
        };
    }
    constructor(...args){
        super(...args), this.getRequestTypesForSelectedRequestGroup = (requestGroupId)=>{
            const { requestTypes: requestTypes, requestGroups: requestGroups } = this.props;
            if (requestGroupId) {
                const selectedRequestGroup = requestGroups.find((requestGroup)=>requestGroup.id === requestGroupId);
                if (selectedRequestGroup) return selectedRequestGroup.reqTypes.map((reqType)=>requestTypes.find((rt)=>rt.id === reqType.id)).filter(Boolean);
            }
            return [];
        }, this.selectRequestGroup = (id)=>{
            // If id is undefined we push back to the /:portalId/group/-1 route.
            // This covers the case if there are article categories on the portal.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            const referrer = $2Np0t.get((0, $2vCgF.REFERRER_QUERY_PARAM));
            const shouldAddReferrer = referrer && referrer !== 'undefined';
            (0, $7FSs7.default).push({
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                pathname: `/portal/${this.props.portalId}/group/${id || '-1'}`,
                search: shouldAddReferrer ? `?${0, $2vCgF.REFERRER_QUERY_PARAM}=${referrer}` : ''
            });
        }, this.selectRequestType = (id)=>{
            const { requestGroups: requestGroups, portalId: portalId, requestGroupId: requestGroupId } = this.props;
            const hasSingleRequestGroup = requestGroups.length === 1;
            const groupId = hasSingleRequestGroup ? requestGroups[0].id : requestGroupId;
            const referrer = $2Np0t.get((0, $2vCgF.REFERRER_QUERY_PARAM));
            const shouldAddReferrer = referrer && referrer !== 'undefined';
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            (0, $7FSs7.default).push({
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                pathname: `/portal/${portalId}/group/${groupId}${id ? `/create/${id}` : ''}`,
                search: shouldAddReferrer ? `?${0, $2vCgF.REFERRER_QUERY_PARAM}=${referrer}` : ''
            });
        }, this.getStyledRequestTypeSelectLabel = ()=>{
            const { hideLabels: hideLabels, intl: intl, isCSM: isCSM } = this.props;
            if (!!hideLabels) return '';
            if (isCSM) return intl.formatMessage((0, $iYSs5.default).CSMRequestTypeSelectLabel);
            return intl.formatMessage((0, $iYSs5.default).requestTypeSelectLabel);
        };
    }
}
var $9f371d513f592f14$export$2e2bcd8739ae039 = (0, $l4a5B.default)($9f371d513f592f14$export$600c4eef2a10987b);
const $9f371d513f592f14$export$d9d410f2d2df162e = /*#__PURE__*/ (0, $2UsNA.default)((0, $bMTX1.default)).withConfig({
    componentId: "sc-1hnffkr-0"
})`margin-top:${(props)=>props.hasTopMargin ? "var(--ds-space-400, 32px)" : 0};`;

});
parcelRegister("drtq4", function(module, exports) {
$parcel$export(module.exports, "CustomizePortalButtonGroup", () => (parcelRequire("gUiQ0")).default);
$parcel$export(module.exports, "EditRequestTypeButton", () => (parcelRequire("7qfPt")).default);
$parcel$export(module.exports, "EditRequestTypeHoverButton", () => (parcelRequire("2iBdu")).default);
parcelRequire("7OZTN");
var $gUiQ0 = parcelRequire("gUiQ0");
parcelRequire("au8mr");
var $7qfPt = parcelRequire("7qfPt");
parcelRequire("fvvjB");
var $2iBdu = parcelRequire("2iBdu");

});
parcelRegister("7OZTN", function(module, exports) {
$parcel$export(module.exports, "CustomizePortalButtonGroup", () => (parcelRequire("gUiQ0")).default);

var $gUiQ0 = parcelRequire("gUiQ0");

});
parcelRegister("gUiQ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b5b6b3f2d522410$export$2e2bcd8739ae039);
/* customize-portal-button-group.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $5jYgE = parcelRequire("5jYgE");

var $MmGmU = parcelRequire("MmGmU");
var $eS4yu = parcelRequire("eS4yu");

var $ffFTG = parcelRequire("ffFTG");

var $8J3yJ = parcelRequire("8J3yJ");

var $3iEm8 = parcelRequire("3iEm8");
var $9pb7J = parcelRequire("9pb7J");

var $iziiq = parcelRequire("iziiq");

var $jsmb9 = parcelRequire("jsmb9");

var $aZP38 = parcelRequire("aZP38");
const $9b5b6b3f2d522410$var$CustomizePortalButtonGroup = (props)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { projectKey: projectKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const onClickManagePortalGroups = ()=>{
        createAnalyticsEvent({
            actionSubjectId: 'managePortalGroupsButton',
            action: 'clicked',
            actionSubject: 'CustomizePortalButtonGroup',
            analyticsType: (0, $iziiq.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $8P7DW.createElement((0, $3iEm8.default), {
        gap: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement("div", {
        className: (0, $8n1kL.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _4t3i1ns9"
        ])
    }, /*#__PURE__*/ $8P7DW.createElement((0, $ffFTG.default), {
        href: (0, $jsmb9.getPortalGroupSettingsUrl)(projectKey),
        appearance: "subtle",
        target: "_blank",
        testId: "manage-portal-groups-button",
        onClick: onClickManagePortalGroups,
        iconBefore: $9b5b6b3f2d522410$var$CustomizePortalButtonFolderOpenIcon
    }, /*#__PURE__*/ $8P7DW.createElement((0, $9pb7J.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $aZP38.default).managePortalGroupsLabel)))));
};
const $9b5b6b3f2d522410$var$CustomizePortalButtonFolderOpenIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8J3yJ))), {
        ...iconProps,
        label: formatMessage((0, $aZP38.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #44546F)"
    });
};
const $9b5b6b3f2d522410$var$ButtonStyles = null;
var $9b5b6b3f2d522410$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    component: 'CustomizePortalButtonGroup'
})($9b5b6b3f2d522410$var$CustomizePortalButtonGroup);

});
parcelRegister("ffFTG", function(module, exports) {
$parcel$export(module.exports, "default", () => $795a15687d11effc$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.37.1 */ /* link.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6NJAV = parcelRequire("6NJAV");

var $klxUK = parcelRequire("klxUK");

var $d4WRD = parcelRequire("d4WRD");

var $e6Qdr = parcelRequire("e6Qdr");

var $hIZ30 = parcelRequire("hIZ30");

var $6ZVn7 = parcelRequire("6ZVn7");

var $ko9LV = parcelRequire("ko9LV");
const $795a15687d11effc$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhkby5v _syaz1gmx _aetrglyw _irr3by5v _30l31gmx _1di6by5v _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    fullWidth: "_1bsb1osq"
};
const $795a15687d11effc$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $795a15687d11effc$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $795a15687d11effc$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $795a15687d11effc$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $795a15687d11effc$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $795a15687d11effc$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $795a15687d11effc$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $795a15687d11effc$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $8P7DW.useRef)(null);
    (0, $d4WRD.default)(localRef, autoFocus);
    const combinedRef = (0, $klxUK.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $hIZ30.default), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $6NJAV.cx)($795a15687d11effc$var$styles.base, (0, $e6Qdr.fg)('platform-dst-shape-theme-default') && $795a15687d11effc$var$styles.baseT26Shape, appearance === 'default' && $795a15687d11effc$var$defaultStyles.root, appearance === 'primary' && $795a15687d11effc$var$primaryStyles.root, appearance === 'warning' && $795a15687d11effc$var$warningStyles.root, appearance === 'danger' && $795a15687d11effc$var$dangerStyles.root, appearance === 'discovery' && $795a15687d11effc$var$discoveryStyles.root, appearance === 'subtle' && $795a15687d11effc$var$subtleStyles.root, $795a15687d11effc$var$styles.linkDecorationUnset, isSelected && $795a15687d11effc$var$selectedStyles.root, isSelected && appearance === 'danger' && $795a15687d11effc$var$selectedStyles.danger, isSelected && appearance === 'warning' && $795a15687d11effc$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $795a15687d11effc$var$selectedStyles.discovery, isDisabled && $795a15687d11effc$var$styles.disabled, spacing === 'compact' && $795a15687d11effc$var$styles.spacingCompact, hasIconBefore && $795a15687d11effc$var$styles.buttonIconBefore, hasIconAfter && $795a15687d11effc$var$styles.buttonIconAfter, shouldFitContainer && $795a15687d11effc$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6ZVn7.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ko9LV.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6ZVn7.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6ZVn7.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ko9LV.default), {
                    icon: iconAfter
                })
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $795a15687d11effc$var$LinkButton = /*#__PURE__*/ (0, $8P7DW.forwardRef)($795a15687d11effc$var$LinkButtonBase);
$795a15687d11effc$var$LinkButton.displayName = 'LinkButton';
var $795a15687d11effc$export$2e2bcd8739ae039 = $795a15687d11effc$var$LinkButton;

});

parcelRegister("8J3yJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6405c70debcc4f4b2a8d477842ac4ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65a5497d709f1efc$var$_react = $65a5497d709f1efc$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $65a5497d709f1efc$var$_baseNew = $65a5497d709f1efc$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $65a5497d709f1efc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65a5497d709f1efc$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $65a5497d709f1efc$var$_react.default.createElement($65a5497d709f1efc$var$_baseNew.default, Object.assign({
        name: "FolderOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v9.473L3.148 6.98c.174-.582.71-.98 1.317-.98H12.5V4.75a.5.5 0 0 0-.5-.5H6.69L4.94 2.5zM14 6h.66c.921 0 1.582.888 1.317 1.77l-1.741 5.805A2 2 0 0 1 12.32 15H1.75A1.75 1.75 0 0 1 0 13.25V3a2 2 0 0 1 2-2h3.56l1.75 1.75H12a2 2 0 0 1 2 2zM2.758 13.5h9.562a.5.5 0 0 0 .479-.356L14.492 7.5H4.558z" clip-rule="evenodd"/>`
    }, props));
$65a5497d709f1efc$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $65a5497d709f1efc$var$_default = module.exports.default = $65a5497d709f1efc$var$FolderOpenIcon;

});

parcelRegister("aZP38", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dbfda87e7a57207$export$2e2bcd8739ae039);

var $45a3E = parcelRequire("45a3E");
var $3dbfda87e7a57207$export$2e2bcd8739ae039 = (0, $45a3E.defineMessages)({
    managePortalGroupsLabel: {
        defaultMessage: 'Manage portal groups',
        description: 'Button text to Navigate user to Manage Portal Groups in JSM',
        id: 'help-center.app.common.customize-portal-buttons.manage-portal-groups-label'
    },
    editRequestTypeLabel: {
        defaultMessage: 'Edit request type',
        description: 'Button text to Navigate user to Request Type editor in JSM',
        id: 'help-center.app.common.customize-portal-buttons.edit-request-type-label '
    }
});

});



parcelRegister("au8mr", function(module, exports) {
$parcel$export(module.exports, "EditRequestTypeButton", () => (parcelRequire("7qfPt")).default);

var $7qfPt = parcelRequire("7qfPt");

});
parcelRegister("7qfPt", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c2953bea96db511$export$2e2bcd8739ae039);
/* edit-request-type-button.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $5jYgE = parcelRequire("5jYgE");

var $MmGmU = parcelRequire("MmGmU");
var $eS4yu = parcelRequire("eS4yu");

var $ffFTG = parcelRequire("ffFTG");

var $3WLDP = parcelRequire("3WLDP");

var $3iEm8 = parcelRequire("3iEm8");
var $9pb7J = parcelRequire("9pb7J");

var $iziiq = parcelRequire("iziiq");

var $jsmb9 = parcelRequire("jsmb9");

var $aZP38 = parcelRequire("aZP38");
const $7c2953bea96db511$var$EditRequestTypeButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { projectKey: projectKey, requestTypeId: requestTypeId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const onClickButton = ()=>{
        createAnalyticsEvent({
            actionSubjectId: 'EditRequestTypeButton',
            action: 'clicked',
            actionSubject: 'button',
            analyticsType: (0, $iziiq.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $8P7DW.createElement((0, $3iEm8.default), {
        gap: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement("div", {
        className: (0, $8n1kL.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _4t3i1ns9"
        ])
    }, /*#__PURE__*/ $8P7DW.createElement((0, $ffFTG.default), {
        href: (0, $jsmb9.getRequestTypeSettingsUrl)(projectKey, requestTypeId),
        appearance: "subtle",
        target: "_blank",
        testId: "edit-request-type-button",
        onClick: onClickButton,
        iconBefore: $7c2953bea96db511$var$EditRequestTypeButtonEditIcon
    }, /*#__PURE__*/ $8P7DW.createElement((0, $9pb7J.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $aZP38.default).editRequestTypeLabel)))));
};
const $7c2953bea96db511$var$EditRequestTypeButtonEditIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3WLDP))), {
        ...iconProps,
        label: formatMessage((0, $aZP38.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #44546F)"
    });
};
const $7c2953bea96db511$var$ButtonStyles = null;
var $7c2953bea96db511$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    component: 'EditRequestTypeButton'
})($7c2953bea96db511$var$EditRequestTypeButton);

});
parcelRegister("3WLDP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63ac376f9836d1894f72051899adf679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dfbbe78af730402$var$_react = $2dfbbe78af730402$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $2dfbbe78af730402$var$_baseNew = $2dfbbe78af730402$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $2dfbbe78af730402$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2dfbbe78af730402$var$EditIcon = (props)=>/*#__PURE__*/ $2dfbbe78af730402$var$_react.default.createElement($2dfbbe78af730402$var$_baseNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$2dfbbe78af730402$var$EditIcon.displayName = 'EditIcon';
var $2dfbbe78af730402$var$_default = module.exports.default = $2dfbbe78af730402$var$EditIcon;

});



parcelRegister("fvvjB", function(module, exports) {
$parcel$export(module.exports, "EditRequestTypeHoverButton", () => (parcelRequire("2iBdu")).default);

var $2iBdu = parcelRequire("2iBdu");

});
parcelRegister("2iBdu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfd9cf4fb6bfee70$export$2e2bcd8739ae039);
/* edit-request-type-hover-button.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $5jYgE = parcelRequire("5jYgE");

var $MmGmU = parcelRequire("MmGmU");
var $eS4yu = parcelRequire("eS4yu");

var $ffFTG = parcelRequire("ffFTG");

var $3WLDP = parcelRequire("3WLDP");

var $9pb7J = parcelRequire("9pb7J");

var $iziiq = parcelRequire("iziiq");

var $jsmb9 = parcelRequire("jsmb9");

var $aZP38 = parcelRequire("aZP38");
const $cfd9cf4fb6bfee70$var$EditRequestTypeHoverButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { projectKey: projectKey, requestTypeId: requestTypeId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const onClickButton = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            actionSubjectId: 'EditRequestTypeHoverButton',
            action: 'clicked',
            actionSubject: 'button',
            analyticsType: (0, $iziiq.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $8P7DW.createElement("div", {
        className: (0, $8n1kL.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _vchhusvi"
        ])
    }, /*#__PURE__*/ $8P7DW.createElement((0, $ffFTG.default), {
        href: (0, $jsmb9.getRequestTypeSettingsUrl)(projectKey, requestTypeId),
        appearance: "subtle",
        target: "_blank",
        testId: "edit-request-type-hover-button",
        onClick: onClickButton,
        spacing: 'compact',
        shouldFitContainer: true,
        iconBefore: $cfd9cf4fb6bfee70$var$EditRequestTypeHoverButtonEditIcon
    }, /*#__PURE__*/ $8P7DW.createElement((0, $9pb7J.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $aZP38.default).editRequestTypeLabel))));
};
const $cfd9cf4fb6bfee70$var$EditRequestTypeHoverButtonEditIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3WLDP))), {
        ...iconProps,
        label: formatMessage((0, $aZP38.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #505258)"
    });
};
const $cfd9cf4fb6bfee70$var$ButtonStyles = null;
var $cfd9cf4fb6bfee70$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    component: 'EditRequestTypeHoverButton'
})($cfd9cf4fb6bfee70$var$EditRequestTypeHoverButton);

});



parcelRegister("if06c", function(module, exports) {
$parcel$export(module.exports, "LearnByDoing", () => (parcelRequire("3NLl7")).default);
$parcel$export(module.exports, "shouldShowLearnByDoingBanner", () => (parcelRequire("8O4Lj")).shouldShowLearnByDoingBanner);
$parcel$export(module.exports, "REFERRER_QUERY_PARAM", () => (parcelRequire("2vCgF")).REFERRER_QUERY_PARAM);

var $3NLl7 = parcelRequire("3NLl7");

var $8O4Lj = parcelRequire("8O4Lj");

var $2vCgF = parcelRequire("2vCgF");

});
parcelRegister("3NLl7", function(module, exports) {
$parcel$export(module.exports, "default", () => $699f866130861a86$export$2e2bcd8739ae039);

var $2UsNA = parcelRequire("2UsNA");

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $edC7N = parcelRequire("edC7N");

var $5jYgE = parcelRequire("5jYgE");

var $MmGmU = parcelRequire("MmGmU");
var $eS4yu = parcelRequire("eS4yu");

var $5xZvq = parcelRequire("5xZvq");

var $ffFTG = parcelRequire("ffFTG");

var $iqJis = parcelRequire("iqJis");

var $bHKCU = parcelRequire("bHKCU");

var $e6Qdr = parcelRequire("e6Qdr");

var $6Hfjm = parcelRequire("6Hfjm");
var $dqsXi = parcelRequire("dqsXi");
var $ktwNU = parcelRequire("ktwNU");
var $2Mjg8 = parcelRequire("2Mjg8");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $iziiq = parcelRequire("iziiq");

var $k24Xc = parcelRequire("k24Xc");

var $fZLXt = parcelRequire("fZLXt");
var $699f866130861a86$export$8400747e4d4d02ee = /*#__PURE__*/ function(StepNumber) {
    StepNumber[StepNumber["STEP1"] = 0] = "STEP1";
    StepNumber[StepNumber["STEP2"] = 1] = "STEP2";
    StepNumber[StepNumber["STEP3"] = 2] = "STEP3";
    return StepNumber;
}({});
const $699f866130861a86$var$LearnByDoing = ({ projectRedirectionLink: projectRedirectionLink, screenName: screenName })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const getStepNumber = ()=>{
        let step;
        if (screenName === (0, $8rTkC.ScreenName).PORTAL_HOME || screenName === (0, $8rTkC.ScreenName).REQUEST_GROUP) step = 0;
        else if (screenName === (0, $8rTkC.ScreenName).REQUEST_CREATE) step = 1;
        else if (screenName === (0, $8rTkC.ScreenName).REQUEST_DETAILS) step = 2;
        else step = -1;
        return step;
    };
    (0, $8P7DW.useEffect)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $iziiq.UI_EVENT_TYPE),
            action: 'viewed',
            actionSubject: 'learnByDoing',
            attributes: {
                screenName: screenName
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        screenName
    ]);
    const stepNumber = getStepNumber();
    const steps = (0, $8P7DW.useMemo)(()=>[
            {
                stepNumber: 0,
                title: formatMessage((0, $fZLXt.default).chooseRequestTypeHeading),
                description: formatMessage((0, $fZLXt.default).chooseRequestTypeDesc)
            },
            {
                stepNumber: 1,
                title: formatMessage((0, $fZLXt.default).sendExampleRequestHeading),
                description: formatMessage((0, $fZLXt.default).sendExampleRequestDesc)
            },
            {
                stepNumber: 2,
                title: formatMessage((0, $fZLXt.default).requestCreatedHeading),
                description: formatMessage(// Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
                (0, $e6Qdr.fg)('itsm-project-renaming') ? (0, $fZLXt.default).requestCreatedDescGalaxia : (0, $fZLXt.default).requestCreatedDesc)
            }
        ], [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5xZvq.default), null, stepNumber >= 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        alignInline: "center",
        alignBlock: "center",
        xcss: $699f866130861a86$var$LearnByDoingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dqsXi.default), {
        xcss: $699f866130861a86$var$LearnByDoingStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "medium"
    }, formatMessage((0, $fZLXt.default).learnByDoingDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dqsXi.default), {
        xcss: $699f866130861a86$var$LearnByDoingFlowStyle
    }, steps.map((step, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dqsXi.default), {
            xcss: [
                $699f866130861a86$var$LearnByDoingStepDefaultStyle,
                index === stepNumber && $699f866130861a86$var$LearnByDoingStepActiveStyle,
                index < stepNumber && $699f866130861a86$var$LearnByDoingStepDisableStyle
            ],
            key: `step-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dqsXi.default), {
            xcss: [
                $699f866130861a86$var$StepNumberContainerDefaultStyle,
                index === stepNumber && $699f866130861a86$var$StepNumberContainerActiveStyle,
                index < stepNumber && $699f866130861a86$var$StepNumberContainerDisableStyle
            ]
        }, index >= stepNumber ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dqsXi.default), {
            alignItems: "center",
            xcss: [
                $699f866130861a86$var$headingContainerStepNumberDefaultStyles,
                index === stepNumber && $699f866130861a86$var$headingContainerStepNumberActiveStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($699f866130861a86$var$_StyledBox, null, step.stepNumber + 1)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bHKCU))), {
            label: "success",
            color: "var(--ds-icon-accent-green, #189864)",
            spacing: "spacious"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dqsXi.default), {
            xcss: $699f866130861a86$var$ContentStyle,
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
            size: "small"
        }, step.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $699f866130861a86$var$descriptionStyles
        }, step.description), index === steps.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dqsXi.default), {
            xcss: $699f866130861a86$var$QueuesRedirectButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ffFTG.default), {
            href: projectRedirectionLink ?? '#',
            appearance: "discovery",
            isDisabled: !projectRedirectionLink,
            testId: "project-redirect-link",
            analyticsContext: {
                actionSubjectId: 'learnByDoingRedirect'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
            weight: "medium",
            color: !projectRedirectionLink ? 'color.text.disabled' : 'color.text.inverse'
        }, formatMessage((0, $fZLXt.default).queuesRedirectLabel))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dqsXi.default), {
            xcss: $699f866130861a86$var$nextStepImageStyle
        }, index !== steps.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($k24Xc))),
            alt: ""
        })));
    })))));
};
const $699f866130861a86$var$LearnByDoingWithErrorBoundary = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: "learnByDoing",
        id: "create-request",
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($699f866130861a86$var$LearnByDoing, props));
};
var $699f866130861a86$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    component: 'LearnByDoing'
})($699f866130861a86$var$LearnByDoingWithErrorBoundary);
const $699f866130861a86$var$LearnByDoingWrapper = (0, $37U6z.xcss)({
    width: 'auto',
    position: 'absolute',
    right: 'space.400',
    left: 'space.400',
    height: '266px',
    backgroundColor: 'color.background.discovery',
    borderRadius: 'radius.large'
});
const $699f866130861a86$var$LearnByDoingStyles = (0, $37U6z.xcss)({
    display: 'none',
    width: '100%',
    maxWidth: '1200px',
    gap: 'space.200',
    paddingBlock: 'space.300',
    paddingInline: 'space.300',
    borderRadius: 'radius.small',
    [(0, $2Mjg8.media).above.md]: {
        display: 'flex'
    },
    [(0, $2Mjg8.media).above.lg]: {
        // Max valid space token space.1000 = 80px, have to use px to make it correctly aligned
        // @ts-expect-error - TODO should use token here, https://product-fabric.atlassian.net/browse/EDF-2517
        paddingRight: '108px',
        // @ts-expect-error - TODO should use token here, https://product-fabric.atlassian.net/browse/EDF-2517
        paddingLeft: '88px'
    }
});
const $699f866130861a86$var$LearnByDoingFlowStyle = (0, $37U6z.xcss)({
    width: '100%',
    gap: 'space.500',
    [(0, $2Mjg8.media).above.lg]: {
        gap: 'space.600'
    }
});
const $699f866130861a86$var$LearnByDoingStepDefaultStyle = (0, $37U6z.xcss)({
    gap: 'space.150',
    padding: 'space.200',
    backgroundColor: 'color.background.input',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    minHeight: '150px',
    position: 'relative',
    flex: '1 1 0px',
    [(0, $2Mjg8.media).above.lg]: {
        gap: 'space.200'
    }
});
const $699f866130861a86$var$LearnByDoingStepActiveStyle = (0, $37U6z.xcss)({
    backgroundColor: 'color.background.input',
    borderWidth: 'border.width.selected',
    borderStyle: 'solid',
    borderColor: 'color.border.discovery'
});
const $699f866130861a86$var$LearnByDoingStepDisableStyle = (0, $37U6z.xcss)({
    backgroundColor: 'color.background.discovery',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border'
});
const $699f866130861a86$var$StepNumberContainerDefaultStyle = (0, $37U6z.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.200',
    width: '40px',
    height: '40px',
    backgroundColor: 'color.background.discovery',
    borderRadius: 'radius.full',
    gap: 'space.100',
    alignItems: 'center',
    justifyContent: 'center'
});
const $699f866130861a86$var$StepNumberContainerActiveStyle = (0, $37U6z.xcss)({
    backgroundColor: 'color.background.discovery.bold'
});
const $699f866130861a86$var$StepNumberContainerDisableStyle = (0, $37U6z.xcss)({
    backgroundColor: 'color.background.success'
});
const $699f866130861a86$var$headingContainerStepNumberDefaultStyles = (0, $37U6z.xcss)({
    height: "var(--ds-space-250, 20px)",
    color: 'color.text.discovery'
});
const $699f866130861a86$var$headingContainerStepNumberActiveStyles = (0, $37U6z.xcss)({
    color: 'color.text.inverse'
});
const $699f866130861a86$var$stepNumberStyles = (0, $37U6z.xcss)({
    font: 'font.heading.small'
});
const $699f866130861a86$var$nextStepImageStyle = (0, $37U6z.xcss)({
    zIndex: 'card',
    position: 'absolute',
    top: 'space.300',
    right: '-52px',
    [(0, $2Mjg8.media).above.lg]: {
        right: '-60px'
    }
});
const $699f866130861a86$var$ContentStyle = (0, $37U6z.xcss)({
    width: '100%',
    gap: 'space.050'
});
const $699f866130861a86$var$descriptionStyles = (0, $37U6z.xcss)({
    color: 'color.text.subtle',
    font: 'font.body'
});
const $699f866130861a86$var$QueuesRedirectButtonStyles = (0, $37U6z.xcss)({
    width: 'fit-content',
    marginTop: 'space.050'
});
var $699f866130861a86$var$_StyledBox = /*#__PURE__*/ /*#__PURE__*/ (0, $2UsNA.default)((0, $6Hfjm.default)).withConfig({
    componentId: "sc-1fng6fm-0"
}).withConfig({
    componentId: "sc-1fng6fm-1"
})`${$699f866130861a86$var$stepNumberStyles}`;

});
parcelRegister("5xZvq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0edcf0141b60af4$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $9qiZO = parcelRequire("9qiZO");

var $lRc3b = parcelRequire("lRc3b");

var $5x7GG = parcelRequire("5x7GG");
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $c0edcf0141b60af4$var$AppProvider({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $9qiZO.useIsInsideAppProvider)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lRc3b.default), {
        routerLinkComponent: routerLinkComponent,
        children: children
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9qiZO.InsideAppProviderContext).Provider, {
        value: true,
        children: UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9qiZO.AppProviderThemingEnabledContext).Provider, {
            value: true,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $5x7GG.default), {
                defaultColorMode: defaultColorMode,
                defaultTheme: defaultTheme,
                children: routerLinkProvider
            })
        })
    });
}
var $c0edcf0141b60af4$export$2e2bcd8739ae039 = $c0edcf0141b60af4$var$AppProvider;

});

parcelRegister("bHKCU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8857e0f37e2122c5$var$_react = $8857e0f37e2122c5$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $8857e0f37e2122c5$var$_baseNew = $8857e0f37e2122c5$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $8857e0f37e2122c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8857e0f37e2122c5$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $8857e0f37e2122c5$var$_react.default.createElement($8857e0f37e2122c5$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$8857e0f37e2122c5$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $8857e0f37e2122c5$var$_default = module.exports.default = $8857e0f37e2122c5$var$CheckMarkIcon;

});

parcelRegister("k24Xc", function(module, exports) {
module.exports = new URL("../images/vector.dd7c71e0.svg", import.meta.url).toString();

});

parcelRegister("fZLXt", function(module, exports) {
$parcel$export(module.exports, "default", () => $8337e6730d434005$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $8337e6730d434005$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    learnByDoingDesc: {
        id: 'help-center.learn-by-doing.create-request.description',
        defaultMessage: 'Welcome to the portal! Try raising a request like your customers.',
        description: 'Description for Learn By Doing create Request component'
    },
    chooseRequestTypeHeading: {
        id: 'help-center.learn-by-doing.choose-request-type.heading',
        defaultMessage: 'Choose a request type',
        description: 'Heading for choosing a request type in Learn By Doing component'
    },
    chooseRequestTypeDesc: {
        id: 'help-center.learn-by-doing.choose-request-type.description',
        defaultMessage: 'Request types represent what your team can help customers with.',
        description: 'Description about request types'
    },
    sendExampleRequestHeading: {
        id: 'help-center.learn-by-doing.send-example-request.heading',
        defaultMessage: 'Send an example request',
        description: 'Heading for sending an example request in Learn By Doing component'
    },
    sendExampleRequestDesc: {
        id: 'help-center.learn-by-doing.send-example-request.description',
        defaultMessage: 'Fill out the request details, then send it off!',
        description: 'Description for sending a request'
    },
    requestCreatedHeading: {
        id: 'help-center.learn-by-doing.request-created.heading',
        defaultMessage: 'Manage request as an agent',
        description: 'Heading after request is created in Learn By Doing component'
    },
    requestCreatedDesc: {
        id: 'help-center.learn-by-doing.request-created.description',
        defaultMessage: 'Assign, add comments and resolve this request in your project.',
        description: 'Description after request is created'
    },
    requestCreatedDescGalaxia: {
        id: 'help-center.learn-by-doing.request-created.description-galaxia',
        defaultMessage: 'Assign, add comments and resolve this request in your space.',
        description: 'Description after request is created'
    },
    queuesRedirectLabel: {
        id: 'help-center.learn-by-doing.queues-redirect.label',
        defaultMessage: 'Go to agent view',
        description: 'Title for queues redirect button'
    }
});

});


parcelRegister("8O4Lj", function(module, exports) {
$parcel$export(module.exports, "shouldShowLearnByDoingBanner", () => $bd3010d40819a629$export$54a369ffec06fa13);

var $2vCgF = parcelRequire("2vCgF");
const $bd3010d40819a629$export$54a369ffec06fa13 = (isProjectAdmin, referrer = '')=>isProjectAdmin && (referrer === (0, $2vCgF.GETTING_STARTED_PAGE_LEARN_BY_DOING) || referrer === (0, $2vCgF.YOUR_WORK) || referrer === (0, $2vCgF.SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE));

});
parcelRegister("2vCgF", function(module, exports) {
$parcel$export(module.exports, "REFERRER_QUERY_PARAM", () => $a521592bfa9c2bcd$export$7640e1e223f51f1a);
$parcel$export(module.exports, "SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE", () => $a521592bfa9c2bcd$export$95ca3e9dccd62856);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_LEARN_BY_DOING", () => $a521592bfa9c2bcd$export$952482a78309d288);
$parcel$export(module.exports, "YOUR_WORK", () => $a521592bfa9c2bcd$export$3461424d6e65d62d);
const $a521592bfa9c2bcd$export$7640e1e223f51f1a = 'referrer';
const $a521592bfa9c2bcd$export$95ca3e9dccd62856 = 'overviewCreateRequest';
const $a521592bfa9c2bcd$export$952482a78309d288 = 'gettingStartedPageLearnByDoing';
const $a521592bfa9c2bcd$export$3461424d6e65d62d = 'yourWork';

});



parcelRegister("3h5x9", function(module, exports) {
$parcel$export(module.exports, "RequestGroupSelect", () => (parcelRequire("faNTC")).default);

var $faNTC = parcelRequire("faNTC");

});
parcelRegister("faNTC", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3eb6a4afc6b9b8b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $kBzhX = parcelRequire("kBzhX");
parcelRequire("8bBGe");
var $5qqUi = parcelRequire("5qqUi");

var $8gu7I = parcelRequire("8gu7I");

var $lH2hr = parcelRequire("lH2hr");

var $2Np0t = parcelRequire("2Np0t");
parcelRequire("if06c");
var $2vCgF = parcelRequire("2vCgF");
class $a3eb6a4afc6b9b8b$export$2e2bcd8739ae039 extends $8P7DW.PureComponent {
    getRedirectionUrl(requestGroupid, portalId) {
        const referrer = $2Np0t.get((0, $2vCgF.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return `/portal/${portalId}/group/${requestGroupid}${shouldAddReferrer ? `?${0, $2vCgF.REFERRER_QUERY_PARAM}=${referrer}` : ''}`;
    }
    getOptions() {
        const { requestGroups: requestGroups, portalId: portalId, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        return requestGroups.map((requestGroup)=>({
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                to: this.getRedirectionUrl(requestGroup === null || requestGroup === void 0 ? void 0 : requestGroup.id, portalId),
                value: requestGroup.id,
                label: requestGroup.name,
                description: /*#__PURE__*/ $8P7DW.createElement($a3eb6a4afc6b9b8b$var$RequestTypeList, null, this.formatReqGroupNames(requestGroup.reqTypes)),
                dataTestId: `request-group:${requestGroup.name}`,
                target: isEmbeddedRoute ? '_blank' : undefined
            }));
    }
    formatReqGroupNames(reqTypes) {
        return reqTypes.map((rt)=>rt.name).join(', ');
    }
    render() {
        const { label: label, onChange: onChange, value: value, disabled: disabled, ...props } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
            data: {
                actionSubjectId: 'requestTypeGroups',
                attributes: {
                    portalId: props.portalId,
                    numberOfRequestTypeGroups: props.requestGroups.length
                }
            }
        }, /*#__PURE__*/ $8P7DW.createElement((0, $5qqUi.default), {
            id: "request-group-select",
            actionSubjectId: "requestTypeGroupSelect",
            itemActionSubjectId: "requestTypeGroup",
            listAppearance: "card",
            selectAppearance: "simple",
            label: label,
            labelIcon: /*#__PURE__*/ $8P7DW.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lH2hr))), {
                spacing: "spacious",
                label: '',
                "aria-hidden": "true",
                color: "var(--ds-icon, #42526E)"
            }),
            options: this.getOptions(),
            onChange: onChange,
            value: value,
            disabled: !!disabled,
            ...props
        }));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a3eb6a4afc6b9b8b$var$RequestTypeList = /*#__PURE__*/ (0, $2UsNA.default).span.withConfig({
    componentId: "sc-1iqgmfs-0"
})`${$kBzhX.small};`;

});
parcelRegister("8bBGe", function(module, exports) {
$parcel$export(module.exports, "GroupBoxSelect", () => (parcelRequire("5qqUi")).default);

var $5qqUi = parcelRequire("5qqUi");

});
parcelRegister("5qqUi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ac00bbef8f2da99$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $llpuV = parcelRequire("llpuV");

var $kBzhX = parcelRequire("kBzhX");

var $6t2I3 = parcelRequire("6t2I3");
parcelRequire("7GFuC");
var $l0ubM = parcelRequire("l0ubM");
parcelRequire("jiDCA");
var $e4qkL = parcelRequire("e4qkL");

var $1EFS8 = parcelRequire("1EFS8");

var $dqsXi = parcelRequire("dqsXi");
var $37U6z = parcelRequire("37U6z");

var $aQXm8 = parcelRequire("aQXm8");

var $5EBGl = parcelRequire("5EBGl");
parcelRequire("dwWBt");
var $XW6Mk = parcelRequire("XW6Mk");
var $i7ZEn = parcelRequire("i7ZEn");
const $3ac00bbef8f2da99$var$REMOVE_FLEX_FROM_GROUP_BOX_SELECT = 'remove-flex-from-group-box-select';
const $3ac00bbef8f2da99$var$isRemoveFlexFromGroupBoxSelectEnabled = ()=>(0, $1EFS8.default).checkGate($3ac00bbef8f2da99$var$REMOVE_FLEX_FROM_GROUP_BOX_SELECT);
const $3ac00bbef8f2da99$var$isHeadingA11yEnabled = ()=>(0, $1EFS8.default).checkGate('ff_a11y_hc_heading');
class $3ac00bbef8f2da99$export$2e2bcd8739ae039 extends $8P7DW.PureComponent {
    static #_ = this.defaultProps = {
        listAppearance: 'default',
        selectAppearance: 'default'
    };
    getValue() {
        const { value: value, options: options } = this.props;
        if (value) return options.find((option)=>option.value === value);
        return null;
    }
    renderSmallLabel() {
        const { id: id, label: label, editRequestTypeOnRequestForm: editRequestTypeOnRequestForm } = this.props;
        const useDiv = $3ac00bbef8f2da99$var$isHeadingA11yEnabled();
        const HeaderComponent = useDiv ? $3ac00bbef8f2da99$var$SmallSelectHeaderDiv : $3ac00bbef8f2da99$export$105792bf13c50cea;
        return !!editRequestTypeOnRequestForm ? /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $3ac00bbef8f2da99$var$labelSmallStylesWrapper
        }, /*#__PURE__*/ $8P7DW.createElement(HeaderComponent, {
            isCORTOPSExperimentEnabled: true
        }, /*#__PURE__*/ $8P7DW.createElement("label", {
            htmlFor: id
        }, label)), editRequestTypeOnRequestForm) : /*#__PURE__*/ $8P7DW.createElement(HeaderComponent, null, /*#__PURE__*/ $8P7DW.createElement("label", {
            htmlFor: id
        }, label));
    }
    renderBigLabel() {
        const { id: id, label: label, labelIcon: labelIcon, customizePortalButtonsGroup: customizePortalButtonsGroup } = this.props;
        const useDiv = $3ac00bbef8f2da99$var$isHeadingA11yEnabled();
        const HeaderComponent = useDiv ? $3ac00bbef8f2da99$var$SelectHeaderDiv : $3ac00bbef8f2da99$export$2e1776684c14bc89;
        return !!customizePortalButtonsGroup ? /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $3ac00bbef8f2da99$var$labelStylesWrapper
        }, /*#__PURE__*/ $8P7DW.createElement(HeaderComponent, {
            isCORTOPSExperimentEnabled: true
        }, /*#__PURE__*/ $8P7DW.createElement($3ac00bbef8f2da99$var$LabelWithIcon, {
            htmlFor: id
        }, labelIcon, /*#__PURE__*/ $8P7DW.createElement("span", null, label))), customizePortalButtonsGroup) : /*#__PURE__*/ $8P7DW.createElement(HeaderComponent, null, /*#__PURE__*/ $8P7DW.createElement($3ac00bbef8f2da99$var$LabelWithIcon, {
            htmlFor: id
        }, labelIcon, /*#__PURE__*/ $8P7DW.createElement("span", null, label)));
    }
    renderAsSelect(optionValue) {
        const { id: id, disabled: disabled, options: options, autoFocus: autoFocus, actionSubjectId: actionSubjectId } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, this.renderSmallLabel(), /*#__PURE__*/ $8P7DW.createElement((0, $llpuV.Select), {
            actionSubjectId: actionSubjectId,
            inputId: id,
            autoFocus: autoFocus,
            options: options,
            onChange: this.onChange,
            value: optionValue,
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            menuPortalTarget: document.body,
            formatOptionLabel: this.formatOptionLabel,
            isDisabled: disabled,
            menuPlacement: "auto",
            // We want the selected option to be visible so customers can read the description if they desire.
            hideSelectedOptions: false,
            isSearchable: false,
            styles: {
                control: (supplied, { isFocused: isFocused })=>({
                        ...supplied,
                        // Don't allow flex children to wrap, since we reset styles of
                        // the value container we need this.
                        flexWrap: 'nowrap',
                        // Suppressing existing violation. Please fix this.
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        ':hover': {
                            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            ...supplied[':hover'],
                            backgroundColor: isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-accent-gray-subtler, #EBECF0)",
                            borderColor: isFocused ? "var(--ds-border-focused, #4C9AFF)" : "var(--ds-background-accent-gray-subtler, #EBECF0)"
                        },
                        backgroundColor: isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-accent-gray-subtlest, #F4F5F7)",
                        borderColor: isFocused ? "var(--ds-border-focused, #4C9AFF)" : "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
                    }),
                valueContainer: ()=>({
                        // We apply our own styles here.
                        //
                        // Set the container to be flex so its height matches the children
                        // instead of busting past it. Overflow hidden so the children
                        // show their ellipsis if needed.
                        ...!$3ac00bbef8f2da99$var$isRemoveFlexFromGroupBoxSelectEnabled() && {
                            display: 'flex'
                        },
                        overflow: 'hidden'
                    }),
                singleValue: ()=>({
                        // We apply our own styles here.
                        //
                        // Since the value is a flex child set its width to 100% so it only
                        // takes up the given space.
                        width: '100%'
                    }),
                option: (_, state)=>({
                        // We apply our own styles here.
                        backgroundColor: state.isFocused ? "var(--ds-surface-hovered, #F4F5F7)" : undefined,
                        cursor: 'pointer',
                        padding: 0,
                        margin: 0,
                        width: '100%'
                    }),
                menu: (styles)=>({
                        ...styles,
                        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)"
                    })
            }
        }));
    }
    renderAsList(optionValue) {
        const { options: options, autoFocus: autoFocus, listAppearance: listAppearance, renderItem: renderItem } = this.props;
        const hasSelectedSingleValue = options.length === 1 && optionValue === options[0];
        return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement((0, $aQXm8.FireScreenEventOnMount), null), hasSelectedSingleValue ? this.renderSmallLabel() : this.renderBigLabel(), /*#__PURE__*/ $8P7DW.createElement($3ac00bbef8f2da99$export$54c2e3dc7acea9f5, {
            offsetMargin: listAppearance === 'default' && !hasSelectedSingleValue
        }, options.map((option, index)=>{
            const content = this.renderListItemContent(option, optionValue === option, hasSelectedSingleValue);
            return /*#__PURE__*/ $8P7DW.createElement((0, $l0ubM.AutoFocus), {
                key: option.value,
                isEnabled: autoFocus && index === 0
            }, /*#__PURE__*/ $8P7DW.createElement($3ac00bbef8f2da99$var$ListItem, {
                withMargin: listAppearance === 'card'
            }, renderItem && !hasSelectedSingleValue ? renderItem(content, index) : content));
        })));
    }
    renderListItemContent(option, isSelected, hasSelectedSingleValue) {
        const { listAppearance: listAppearance, cardLinkAppearance: cardLinkAppearance, itemActionSubjectId: itemActionSubjectId, editRequestTypeOnRequestList: editRequestTypeOnRequestList } = this.props;
        switch(listAppearance){
            case 'card':
                return /*#__PURE__*/ $8P7DW.createElement((0, $e4qkL.default), {
                    to: option.to,
                    padding: 0,
                    appearance: cardLinkAppearance,
                    actionSubjectId: itemActionSubjectId,
                    dataTestId: option.dataTestId,
                    target: option.target
                }, /*#__PURE__*/ $8P7DW.createElement((0, $XW6Mk.default), {
                    icon: option.iconUrl,
                    heading: option.label,
                    description: option.description,
                    lineClamp: isSelected ? 1 : 0
                }));
            case 'default':
            default:
                return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, isSelected ? /*#__PURE__*/ $8P7DW.createElement((0, $XW6Mk.default), {
                    icon: option.iconUrl,
                    heading: option.label,
                    description: option.description,
                    dataTestId: option.dataTestId,
                    // oxlint-disable-next-line no-nested-ternary
                    lineClamp: isSelected ? hasSelectedSingleValue ? 0 : 1 : 0
                }) : /*#__PURE__*/ $8P7DW.createElement((0, $i7ZEn.default), {
                    icon: option.iconUrl,
                    to: option.to,
                    heading: option.label,
                    description: option.description,
                    // oxlint-disable-next-line no-nested-ternary
                    lineClamp: isSelected ? hasSelectedSingleValue ? 0 : 1 : 0,
                    selected: isSelected,
                    actionSubjectId: itemActionSubjectId,
                    dataTestId: option.dataTestId,
                    target: option.target,
                    ...!!editRequestTypeOnRequestList && {
                        editRequestTypeOnRequestList: editRequestTypeOnRequestList(option.value)
                    }
                }));
        }
    }
    render() {
        const { className: className, options: options } = this.props;
        const value = this.getValue();
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $8P7DW.createElement("div", {
            className: className
        }, options.length > 1 && value ? this.renderAsSelect(value) : this.renderAsList(value)));
    }
    constructor(...args){
        super(...args), this.formatOptionLabel = (option, context)=>{
            const { headingAs: headingAs } = this.props;
            switch(this.props.selectAppearance){
                case 'simple':
                    if (context.context === 'menu') return /*#__PURE__*/ $8P7DW.createElement((0, $XW6Mk.default), {
                        containerPadding: "tight",
                        icon: option.iconUrl,
                        heading: option.label,
                        description: option.description
                    });
                    return /*#__PURE__*/ $8P7DW.createElement($3ac00bbef8f2da99$var$SimpleSelectOption, null, option.label);
                case 'default':
                default:
                    return /*#__PURE__*/ $8P7DW.createElement((0, $XW6Mk.default), {
                        containerPadding: "tight",
                        headingAs: headingAs,
                        icon: option.iconUrl,
                        heading: option.label,
                        description: option.description,
                        lineClamp: context.context === 'value' ? 1 : 0
                    });
            }
        }, this.onChange = (optionValue)=>{
            var _this$props$onChange, _this$props, _toSingleSelectValue;
            return (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, (_toSingleSelectValue = (0, $5EBGl.toSingleSelectValue)(optionValue)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value);
        };
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ac00bbef8f2da99$var$ListItem = /*#__PURE__*/ (0, $2UsNA.default).li.withConfig({
    componentId: "sc-h09otw-0"
})`display:block;${(props)=>$6t2I3.applyIf(!!props.withMargin, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $2UsNA.css)`&:not(:last-child){margin-bottom:${"var(--ds-space-400, 32px)"};}`)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ac00bbef8f2da99$var$LabelWithIcon = /*#__PURE__*/ (0, $2UsNA.default).label.withConfig({
    componentId: "sc-h09otw-1"
})`display:flex;align-items:center;> :not(:last-child){margin-right:${"var(--ds-space-100, 8px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ac00bbef8f2da99$var$SimpleSelectOption = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-h09otw-2"
})`margin-left:${"var(--ds-space-100, 8px)"};`;
const $3ac00bbef8f2da99$var$GROUP_BOX_SELECT_LIST_TOP_MARGIN = "var(--ds-space-negative-200, -16px)";
const $3ac00bbef8f2da99$var$GROUP_BOX_SELECT_PADDING_INLINE = "var(--ds-space-negative-300, -24px)";
const $3ac00bbef8f2da99$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $2UsNA.default).ul.withConfig({
    componentId: "sc-h09otw-3"
})`margin:${(props)=>props.offsetMargin ? `${$3ac00bbef8f2da99$var$GROUP_BOX_SELECT_LIST_TOP_MARGIN} ${$3ac00bbef8f2da99$var$GROUP_BOX_SELECT_PADDING_INLINE} 0` : '0'};padding:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ac00bbef8f2da99$var$selectHeaderStyles = /*#__PURE__*/ (0, $2UsNA.css)`${$kBzhX.h500};display:block;margin-top:0;margin-bottom:${(props)=>props.isCORTOPSExperimentEnabled ? 0 : "var(--ds-space-200, 16px)"};`;
const $3ac00bbef8f2da99$export$2e1776684c14bc89 = /*#__PURE__*/ (0, $2UsNA.default).h2.withConfig({
    componentId: "sc-h09otw-4"
})`${$3ac00bbef8f2da99$var$selectHeaderStyles}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ac00bbef8f2da99$var$SelectHeaderDiv = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-h09otw-5"
})`${$3ac00bbef8f2da99$var$selectHeaderStyles}`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ac00bbef8f2da99$var$smallSelectHeaderBaseStyles = /*#__PURE__*/ (0, $2UsNA.css)`${$kBzhX.h500};display:block;margin-top:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ac00bbef8f2da99$var$smallSelectHeaderStyles = /*#__PURE__*/ (0, $2UsNA.css)`${$3ac00bbef8f2da99$var$smallSelectHeaderBaseStyles};${$kBzhX.h200};margin-top:0;margin-bottom:${(props)=>props.isCORTOPSExperimentEnabled ? 0 : "var(--ds-space-050, 4px)"};`;
const $3ac00bbef8f2da99$export$105792bf13c50cea = /*#__PURE__*/ (0, $2UsNA.default).h2.withConfig({
    componentId: "sc-h09otw-6"
})`${$3ac00bbef8f2da99$var$smallSelectHeaderStyles}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ac00bbef8f2da99$var$SmallSelectHeaderDiv = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-h09otw-7"
})`${$3ac00bbef8f2da99$var$smallSelectHeaderStyles}`;
const $3ac00bbef8f2da99$var$labelStylesWrapper = (0, $37U6z.xcss)({
    marginBottom: 'space.200'
});
const $3ac00bbef8f2da99$var$labelSmallStylesWrapper = (0, $37U6z.xcss)({
    marginBottom: 'space.100'
});

});
parcelRegister("7GFuC", function(module, exports) {
$parcel$export(module.exports, "AutoFocus", () => (parcelRequire("l0ubM")).AutoFocus);

var $l0ubM = parcelRequire("l0ubM");

});
parcelRegister("l0ubM", function(module, exports) {
$parcel$export(module.exports, "AutoFocus", () => $dd21151da8bc3ac2$export$9d8c528bc52bedf6);

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");
class $dd21151da8bc3ac2$export$9d8c528bc52bedf6 extends $8P7DW.Component {
    static #_ = this.defaultProps = {
        isEnabled: true
    };
    componentDidMount() {
        const { isEnabled: isEnabled } = this.props;
        // If we haven't yet triggered the focus we will focus on the ref if available
        if (isEnabled && !this.focused) {
            // eslint-disable-next-line react/no-find-dom-node
            const el = (0, $6Q1OD.findDOMNode)(this);
            if (el) {
                el.focus();
                this.focused = true;
            }
        }
    }
    render() {
        const { children: children } = this.props;
        return $8P7DW.Children.only(children);
    }
}

});


parcelRegister("5EBGl", function(module, exports) {
$parcel$export(module.exports, "toSingleSelectValue", () => $7da5d55e63f8a0f3$export$e6e136d0998f71a);
$parcel$export(module.exports, "toMultiSelectValue", () => $7da5d55e63f8a0f3$export$f3f3cd2c513af530);
const $7da5d55e63f8a0f3$export$e6e136d0998f71a = (value)=>{
    if (value == null) return value;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Array.isArray(value) ? value[0] : value;
};
const $7da5d55e63f8a0f3$export$f3f3cd2c513af530 = (value)=>{
    if (value == null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
};

});



parcelRegister("lH2hr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba6b12c8d889bd288c998a8deb3aaaee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fcaf61f482a5f634$var$_react = $fcaf61f482a5f634$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $fcaf61f482a5f634$var$_baseNew = $fcaf61f482a5f634$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $fcaf61f482a5f634$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fcaf61f482a5f634$var$SendIcon = (props)=>/*#__PURE__*/ $fcaf61f482a5f634$var$_react.default.createElement($fcaf61f482a5f634$var$_baseNew.default, Object.assign({
        name: "SendIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$fcaf61f482a5f634$var$SendIcon.displayName = 'SendIcon';
var $fcaf61f482a5f634$var$_default = module.exports.default = $fcaf61f482a5f634$var$SendIcon;

});



parcelRegister("gPk0D", function(module, exports) {
$parcel$export(module.exports, "RequestTypeSelect", () => (parcelRequire("bMTX1")).default);

var $bMTX1 = parcelRequire("bMTX1");

});
parcelRegister("bMTX1", function(module, exports) {
$parcel$export(module.exports, "default", () => $056e6bf5651b60b0$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");
parcelRequire("jDa9O");
var $c3t4p = parcelRequire("c3t4p");
parcelRequire("8bBGe");
var $5qqUi = parcelRequire("5qqUi");

var $8gu7I = parcelRequire("8gu7I");

var $2Np0t = parcelRequire("2Np0t");
parcelRequire("if06c");
var $2vCgF = parcelRequire("2vCgF");
class $056e6bf5651b60b0$export$2e2bcd8739ae039 extends $8P7DW.PureComponent {
    getOptions() {
        const referrer = $2Np0t.get((0, $2vCgF.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        const { requestTypes: requestTypes, portalId: portalId, requestGroupId: requestGroupId, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        return requestTypes.map((requestType)=>({
                value: Number(requestType.id),
                label: requestType.name,
                description: /*#__PURE__*/ $8P7DW.createElement($056e6bf5651b60b0$var$RequestTypeDescription, {
                    dangerouslySetInnerHTML: {
                        __html: requestType.descriptionHtml
                    }
                }),
                iconUrl: requestType.iconUrl,
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                to: `/portal/${portalId}/group/${requestGroupId}/create/${requestType.id}${shouldAddReferrer ? `?${0, $2vCgF.REFERRER_QUERY_PARAM}=${referrer}` : ''}`,
                dataTestId: `request-type:${requestType.name}`,
                target: isEmbeddedRoute ? '_blank' : undefined
            }));
    }
    getCSMOptions() {
        const { requestTypes: requestTypes } = this.props;
        return requestTypes.map((requestType)=>({
                value: requestType.name,
                label: requestType.name
            }));
    }
    getCSMValue(value) {
        const { requestTypes: requestTypes } = this.props;
        if (!value) return {
            value: '',
            label: ''
        };
        const requestType = requestTypes.find((requestTypeOption)=>Number(requestTypeOption.id) === value);
        return {
            value: (requestType === null || requestType === void 0 ? void 0 : requestType.name) || '',
            label: (requestType === null || requestType === void 0 ? void 0 : requestType.name) || ''
        };
    }
    render() {
        const { label: label, onChange: onChange, value: value, disabled: disabled, isCSM: isCSM, headingAs: headingAs, ...props } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement((0, $8gu7I.default), {
            data: {
                actionSubjectId: 'requestTypes',
                attributes: {
                    portalId: props.portalId,
                    requestGroupId: props.requestGroupId,
                    numberOfRequestTypes: props.requestTypes.length
                }
            }
        }, /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, isCSM ? /*#__PURE__*/ $8P7DW.createElement((0, $c3t4p.default), {
            id: "request-type-select",
            label: label,
            options: this.getCSMOptions(),
            defaultValue: this.getCSMValue(value),
            disabled: !!disabled
        }) : /*#__PURE__*/ $8P7DW.createElement((0, $5qqUi.default), {
            id: "request-type-select",
            actionSubjectId: "requestTypeSelect",
            itemActionSubjectId: "requestType",
            label: label,
            options: this.getOptions(),
            headingAs: headingAs,
            onChange: onChange,
            value: value,
            disabled: !!disabled,
            ...props
        })));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $056e6bf5651b60b0$var$RequestTypeDescription = /*#__PURE__*/ (0, $2UsNA.default).span.withConfig({
    componentId: "sc-1qcxsi7-0"
})`p{display:inline;}`;

});
parcelRegister("jDa9O", function(module, exports) {
$parcel$export(module.exports, "SingleSelectField", () => (parcelRequire("c3t4p")).default);
/** This is the single select form component type  */ 
var $c3t4p = parcelRequire("c3t4p");

});
parcelRegister("c3t4p", function(module, exports) {
$parcel$export(module.exports, "default", () => $878b785d55324b6f$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $dqFDv = parcelRequire("dqFDv");

var $5EBGl = parcelRequire("5EBGl");
class $878b785d55324b6f$var$SingleFieldSelect extends $8P7DW.PureComponent {
    componentDidMount() {
        // JDW-2280 - this is required to make url filling (e.g. ?customfield_10343=10657) work
        if (this.props.defaultValue) this.onChange(this.props.defaultValue);
    }
    render() {
        const { disabled: disabled, ...otherProps } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement((0, $dqFDv.FormSingleSelect), {
            ...otherProps,
            onChange: this.onChange,
            isDisabled: disabled
        });
    }
    constructor(...args){
        super(...args), this.onChange = (option, meta)=>{
            var _this$props$onChange, _this$props, _toSingleSelectValue;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, ((_toSingleSelectValue = (0, $5EBGl.toSingleSelectValue)(option)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value) ?? '', false, {
                rawObject: meta ?? {},
                rawValue: option
            });
        };
    }
}
var $878b785d55324b6f$export$2e2bcd8739ae039 = $878b785d55324b6f$var$SingleFieldSelect;

});
parcelRegister("dqFDv", function(module, exports) {
$parcel$export(module.exports, "FieldSingleSelect", () => $e7337a11b74f7c0f$export$a63157f03e4869bc);
$parcel$export(module.exports, "FormSingleSelect", () => $e7337a11b74f7c0f$export$6440c30e7d5bd2b2);
$parcel$export(module.exports, "FormAsyncSingleSelect", () => $e7337a11b74f7c0f$export$1232b3d2b9045cfb);
$parcel$export(module.exports, "FormAsyncCreatableSingleSelect", () => $e7337a11b74f7c0f$export$5e090ccc28fd7327);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");
parcelRequire("gcxeS");
var $cdcw0 = parcelRequire("cdcw0");
parcelRequire("kbY4O");
var $azHRf = parcelRequire("azHRf");

var $eN7Hl = parcelRequire("eN7Hl");

var $gtG3x = parcelRequire("gtG3x");

var $jq6ku = parcelRequire("jq6ku");
const $e7337a11b74f7c0f$export$a63157f03e4869bc = (0, $jq6ku.default)((0, $cdcw0.ThemedSelect));
const $e7337a11b74f7c0f$var$FieldAsyncSingleSelect = (0, $jq6ku.default)((0, $cdcw0.ThemedAsyncSelect));
const $e7337a11b74f7c0f$var$FieldAsyncCreatableSingleSelect = (0, $jq6ku.default)((0, $cdcw0.ThemedAsyncCreatableSelect));
class $e7337a11b74f7c0f$var$FormAsyncCreatableSingleSelectBase extends $8P7DW.PureComponent {
    render() {
        return /*#__PURE__*/ $8P7DW.createElement($e7337a11b74f7c0f$var$FieldAsyncCreatableSingleSelect, {
            ...this.props,
            onCreateOption: this.onCreateOption
        });
    }
    constructor(...args){
        super(...args), this.onCreateOption = (input)=>{
            const { onChange: onChange, showNewLabelForCreatedValues: showNewLabelForCreatedValues } = this.props;
            const newOption = {
                value: input,
                label: input,
                isNew: showNewLabelForCreatedValues
            };
            onChange === null || onChange === void 0 || onChange(newOption, {
                action: 'create-option',
                option: newOption
            });
        };
    }
}
const $e7337a11b74f7c0f$var$ControlledFieldAsyncSingleSelect = (0, $azHRf.withControlledFormComponentValue)((option)=>option)((props)=>/*#__PURE__*/ $8P7DW.createElement($e7337a11b74f7c0f$var$FieldAsyncSingleSelect, {
        ...props,
        isMulti: false,
        isClearable: true
    }));
const $e7337a11b74f7c0f$var$ControlledFormAsyncCreatableSingleSelectBase = (0, $azHRf.withControlledFormComponentValue)((option)=>option)((props)=>/*#__PURE__*/ $8P7DW.createElement($e7337a11b74f7c0f$var$FormAsyncCreatableSingleSelectBase, {
        ...props,
        isMulti: false,
        isClearable: true
    }));
const $e7337a11b74f7c0f$export$6440c30e7d5bd2b2 = (0, $azHRf.withControlledFormComponentValue)((option)=>option)($e7337a11b74f7c0f$export$a63157f03e4869bc);
const $e7337a11b74f7c0f$export$1232b3d2b9045cfb = (0, $eN7Hl.componentWithCondition)(()=>(0, $HGACo.isUserPickerSupportEnabled)(), $e7337a11b74f7c0f$var$ControlledFieldAsyncSingleSelect, (0, $gtG3x.default)($e7337a11b74f7c0f$var$FieldAsyncSingleSelect));
const $e7337a11b74f7c0f$export$5e090ccc28fd7327 = (0, $eN7Hl.componentWithCondition)(()=>(0, $HGACo.isUserPickerSupportEnabled)(), $e7337a11b74f7c0f$var$ControlledFormAsyncCreatableSingleSelectBase, (0, $gtG3x.default)($e7337a11b74f7c0f$var$FormAsyncCreatableSingleSelectBase));

});
parcelRegister("gcxeS", function(module, exports) {
$parcel$export(module.exports, "ThemedSelect", () => (parcelRequire("cdcw0")).ThemedSelect);
$parcel$export(module.exports, "ThemedAsyncCreatableSelect", () => (parcelRequire("cdcw0")).ThemedAsyncCreatableSelect);
$parcel$export(module.exports, "ThemedAsyncSelect", () => (parcelRequire("cdcw0")).ThemedAsyncSelect);

var $cdcw0 = parcelRequire("cdcw0");

});
parcelRegister("cdcw0", function(module, exports) {
$parcel$export(module.exports, "ThemedAsyncCreatableSelect", () => $67ff51302981c9bf$export$6ed24baf80289e3c);
$parcel$export(module.exports, "ThemedAsyncSelect", () => $67ff51302981c9bf$export$ffdb66031dcf42ea);
$parcel$export(module.exports, "ThemedSelect", () => $67ff51302981c9bf$export$336563657ba327fe);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $UGUgB = parcelRequire("UGUgB");
var $kf6y2 = parcelRequire("kf6y2");
var $6EUlD = parcelRequire("6EUlD");
var $llpuV = parcelRequire("llpuV");
function $67ff51302981c9bf$var$withThemeSelect(Component) {
    class ThemedSelectWrapper extends $8P7DW.PureComponent {
        render() {
            const { theme: theme, styles: externalStyles = {}, ...selectProps } = this.props;
            const customStyles = {
                // This is to ensure the multi select options stay within the container without overflowing
                valueContainer: (styles)=>({
                        ...styles,
                        width: '100%',
                        overflow: 'hidden'
                    }),
                // This is used to apply our theming
                option: (styles, { isFocused: isFocused, isSelected: isSelected })=>{
                    const themed = theme;
                    const optionFocusBackground = isFocused ? "var(--ds-background-neutral-subtle-hovered, #F4F5F7)" : null;
                    const backgroundColor = isSelected ? themed.lightColor : optionFocusBackground;
                    return {
                        ...styles,
                        backgroundColor: backgroundColor,
                        ':active': {
                            backgroundColor: themed.lightColor
                        },
                        color: "var(--ds-text, #172B4D)"
                    };
                },
                // This is to ensure long select options doesn't cause a horizontal scroll bar to appear in the select menu
                menu: (styles)=>({
                        ...styles,
                        'word-wrap': 'break-word',
                        'overflow-y': 'hidden',
                        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)"
                    })
            };
            return /*#__PURE__*/ $8P7DW.createElement(Component, {
                placeholder: "",
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage, @atlassian/ssr-linting/no-dom-globals-in-react-cc-render
                menuPortalTarget: document.body,
                menuPlacement: "auto",
                ...selectProps,
                styles: {
                    ...externalStyles,
                    ...customStyles
                }
            });
        }
    }
    return (0, $2UsNA.withTheme)(ThemedSelectWrapper);
}
const $67ff51302981c9bf$export$6ed24baf80289e3c = $67ff51302981c9bf$var$withThemeSelect((0, $UGUgB.AsyncCreatableSelect));
const $67ff51302981c9bf$export$1692d6296f3148ba = $67ff51302981c9bf$var$withThemeSelect((0, $6EUlD.CreatableSelect));
const $67ff51302981c9bf$export$ffdb66031dcf42ea = $67ff51302981c9bf$var$withThemeSelect((0, $kf6y2.AsyncSelect));
const $67ff51302981c9bf$export$336563657ba327fe = $67ff51302981c9bf$var$withThemeSelect((0, $llpuV.Select));

});
parcelRegister("UGUgB", function(module, exports) {
$parcel$export(module.exports, "AsyncCreatableSelect", () => $9b816ca8926d5670$export$c0b2520fe082e4aa);

var $aRm9w = parcelRequire("aRm9w");

var $frgWG = parcelRequire("frgWG");
const $9b816ca8926d5670$export$c0b2520fe082e4aa = (0, $frgWG.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $aRm9w.default));

});
parcelRegister("aRm9w", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb0368e1cfbb4235$export$2e2bcd8739ae039);

var $axQ6N = parcelRequire("axQ6N");

var $echec = parcelRequire("echec");
const $cb0368e1cfbb4235$var$AsyncCreatableSelect = (0, $echec.default)((0, $axQ6N.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb0368e1cfbb4235$export$2e2bcd8739ae039 = $cb0368e1cfbb4235$var$AsyncCreatableSelect;

});
parcelRegister("axQ6N", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcabaa0a24618442$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $dL6c3 = parcelRequire("dL6c3");

var $6A2cj = parcelRequire("6A2cj");

var $7Duub = parcelRequire("7Duub");

var $ZSWqE = parcelRequire("ZSWqE");
const $fcabaa0a24618442$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $6A2cj.default)(props);
    const creatableProps = (0, $ZSWqE.default)(stateManagerProps);
    const selectProps = (0, $7Duub.default)(creatableProps);
    // @ts-ignore - TS2322: Complex generic type causing issues for help-center local consumption with TS 5.9.2
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dL6c3.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fcabaa0a24618442$export$2e2bcd8739ae039 = $fcabaa0a24618442$var$AsyncCreatableSelect;

});
parcelRegister("7Duub", function(module, exports) {
$parcel$export(module.exports, "default", () => $f651ac6ec4128381$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $eub38 = parcelRequire("eub38");

var $labMK = parcelRequire("labMK");

var $LCqac = parcelRequire("LCqac");
const $f651ac6ec4128381$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $f651ac6ec4128381$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$f651ac6ec4128381$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$f651ac6ec4128381$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $f651ac6ec4128381$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $f651ac6ec4128381$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $f651ac6ec4128381$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $f651ac6ec4128381$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $eub38.getOptionValue), getOptionLabel: getOptionLabel = (0, $eub38.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $8P7DW.useMemo)(()=>isValidNewOption(inputValue, (0, $labMK.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $8P7DW.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $8P7DW.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $LCqac.valueTernary)(isMulti, [
                    ...(0, $labMK.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});




parcelRegister("kf6y2", function(module, exports) {
$parcel$export(module.exports, "AsyncSelect", () => $a404dca6ef234686$export$aca05dd54e009a80);

var $h4hbn = parcelRequire("h4hbn");

var $frgWG = parcelRequire("frgWG");
const $a404dca6ef234686$export$aca05dd54e009a80 = (0, $frgWG.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $h4hbn.default));

});
parcelRegister("h4hbn", function(module, exports) {
$parcel$export(module.exports, "default", () => $0818ec08533f4cf6$export$2e2bcd8739ae039);

var $kw1Aj = parcelRequire("kw1Aj");

var $echec = parcelRequire("echec");
const $0818ec08533f4cf6$var$AsyncSelect = (0, $echec.default)((0, $kw1Aj.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0818ec08533f4cf6$export$2e2bcd8739ae039 = $0818ec08533f4cf6$var$AsyncSelect;

});


parcelRegister("6EUlD", function(module, exports) {
$parcel$export(module.exports, "CreatableSelect", () => $5b8ff1c659f13eb5$export$4d213c67c76d12fa);

var $lAqrc = parcelRequire("lAqrc");

var $frgWG = parcelRequire("frgWG");
const $5b8ff1c659f13eb5$export$4d213c67c76d12fa = (0, $frgWG.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $lAqrc.default));

});
parcelRegister("lAqrc", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c7f54c0ef018961$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ 
var $b1ADQ = parcelRequire("b1ADQ");

var $echec = parcelRequire("echec");
const $1c7f54c0ef018961$var$CreatableSelect = (0, $echec.default)((0, $b1ADQ.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c7f54c0ef018961$export$2e2bcd8739ae039 = $1c7f54c0ef018961$var$CreatableSelect;

});
parcelRegister("b1ADQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $098b375416fb3365$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $dL6c3 = parcelRequire("dL6c3");

var $7Duub = parcelRequire("7Duub");

var $ZSWqE = parcelRequire("ZSWqE");
const $098b375416fb3365$var$CreatableSelect = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const creatableProps = (0, $ZSWqE.default)(props);
    const selectProps = (0, $7Duub.default)(creatableProps);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dL6c3.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$098b375416fb3365$export$2e2bcd8739ae039 = $098b375416fb3365$var$CreatableSelect;

});





parcelRegister("gtG3x", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf14e9aa7dda080a$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $cf14e9aa7dda080a$var$withControlledValueSingleSelect(SelectComponent) {
    return class ControlledValueSingleSelectWrapper extends $8P7DW.PureComponent {
        static #_ = this.displayName = 'ControlledValueSingleSelectWrapper';
        render() {
            return /*#__PURE__*/ $8P7DW.createElement(SelectComponent, {
                ...this.props,
                isMulti: false,
                value: this.state.selectedOption,
                onChange: this.onChange,
                isClearable: true
            });
        }
        constructor(...args){
            super(...args), this.state = {
                selectedOption: this.props.defaultValue
            }, this.onChange = (option, context)=>{
                var _this$props$onChange, _this$props;
                this.setState({
                    selectedOption: option
                });
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, option, context);
            };
        }
    };
}
var $cf14e9aa7dda080a$export$2e2bcd8739ae039 = $cf14e9aa7dda080a$var$withControlledValueSingleSelect;

});

parcelRegister("jq6ku", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a4c62f5006926f9$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");
parcelRequire("1fvLS");
var $9QYFS = parcelRequire("9QYFS");
function $6a4c62f5006926f9$var$withFieldBase(SelectComponent) {
    const wrappedComponent = (props)=>{
        const { label: label, required: required, errorMessage: errorMessage, description: description, id: id, tooltip: tooltip, ...otherProps } = props;
        return /*#__PURE__*/ $8P7DW.createElement((0, $9QYFS.default), {
            htmlFor: id,
            label: label,
            required: required,
            errorMessage: errorMessage,
            description: description,
            ...(0, $HGACo.isUiModificationsSupportEnabled)() ? {
                tooltip: tooltip
            } : null
        }, /*#__PURE__*/ $8P7DW.createElement(SelectComponent, {
            ...otherProps,
            inputId: id,
            "aria-describedby": `${id}-field-description`,
            validationState: !!errorMessage ? 'error' : 'default'
        }));
    };
    return wrappedComponent;
}
var $6a4c62f5006926f9$export$2e2bcd8739ae039 = $6a4c62f5006926f9$var$withFieldBase;

});






parcelRegister("iYSs5", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dd50a9cc831a997$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $8dd50a9cc831a997$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    requestGroupSelectLabel: {
        defaultMessage: 'Contact us about',
        description: 'Label shown for selecting a request group',
        id: 'sd.portal.request.group.select'
    },
    requestTypeSelectLabel: {
        defaultMessage: 'What can we help you with?',
        description: 'Label shown for picking a request type',
        id: 'sd.portal.request.type.select'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    CSMRequestTypeSelectLabel: {
        defaultMessage: 'What do you need help with?',
        description: 'Label shown for picking a request type',
        id: 'sd.portal.csm.request.type.select'
    },
    emptyStateMessage: {
        defaultMessage: "There's nothing in this portal yet.",
        description: 'This message is shown, when there are no configured request groups for service project',
        id: 'sd.jsm.portal.empty.request.type'
    },
    tryAnotherServiceProjectLink: {
        defaultMessage: 'Go to the help center',
        description: 'This link is shown, when there are no configured request groups for current service project and there are other service projects available',
        id: 'sd.jsm.portal.empty.sd.link'
    }
});

});





parcelRegister("c4GhF", function(module, exports) {
$parcel$export(module.exports, "SkeletonLoadingContainer", () => (parcelRequire("i4cAY")).SkeletonLoadingContainer);

var $i4cAY = parcelRequire("i4cAY");

});
parcelRegister("i4cAY", function(module, exports) {
$parcel$export(module.exports, "SkeletonLoadingContainer", () => $ff63157d3dd84f18$export$ed074b591cb3b239);

var $8P7DW = parcelRequire("8P7DW");

var $5OWUX = parcelRequire("5OWUX");
parcelRequire("1n2hY");
var $4fSTF = parcelRequire("4fSTF");

var $4peLG = parcelRequire("4peLG");
class $ff63157d3dd84f18$export$ed074b591cb3b239 extends $8P7DW.Component {
    static #_ = this.defaultProps = {
        loadingPosition: 'fill-container'
    };
    render() {
        const { children: children, loadingPosition: loadingPosition, isLoading: isLoading, enableUFOHold: enableUFOHold, ufoHoldName: ufoHoldName } = this.props;
        const skeleton = /*#__PURE__*/ $8P7DW.createElement((0, $5OWUX.SkeletonLoadingWrapper), {
            isLoading: true,
            loadingPosition: loadingPosition
        });
        return isLoading ? /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.PaperContent), null, enableUFOHold ? /*#__PURE__*/ $8P7DW.createElement((0, $4peLG.default), {
            name: ufoHoldName
        }, skeleton) : skeleton) : children;
    }
}

});


parcelRegister("14Dyz", function(module, exports) {
$parcel$export(module.exports, "ExternalLinks", () => $fced67521e1218c2$export$7c6fdaf98295312b);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $fced67521e1218c2$export$7c6fdaf98295312b = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("ksc7J")), {
        moduleId: "./src/view/external-links/external-links.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("ksc7J", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("kB8ya"),
    $j9MRt("kL7dU")
]).then(()=>parcelRequire('4LnnW'));

});


parcelRegister("bXfzz", function(module, exports) {
$parcel$export(module.exports, "ForgeFooterModule", () => $171ccba9216dd02f$export$c664a1597302ef11);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $171ccba9216dd02f$export$c664a1597302ef11 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("agvUt")), {
        moduleId: "./src/view/forge-ui/portal-footer/portal-footer.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("agvUt", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("bSf17").then(()=>parcelRequire('cCIuJ'));

});


parcelRegister("cwHmd", function(module, exports) {
$parcel$export(module.exports, "ForgeHeaderModule", () => $94bd869f8ad93e53$export$8010fd64cd5cfdb9);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $94bd869f8ad93e53$export$8010fd64cd5cfdb9 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("bVezE")), {
        moduleId: "./src/view/forge-ui/portal-header/portal-header.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("bVezE", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("kMDIF").then(()=>parcelRequire('aUQN5'));

});


parcelRegister("uX9YM", function(module, exports) {
$parcel$export(module.exports, "LazyVirtualServiceAgentChatSidebar", () => $4e692de9937c50ef$export$5ab8ce8fb542ac03);
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $4e692de9937c50ef$export$5ab8ce8fb542ac03 = (0, $fGOkV.lazy)(()=>(parcelRequire("7VlYj")), {
    moduleId: "./src/view/layout/virtual-service-agent-chat-sidebar/virtual-service-agent-chat-sidebar.tsx"
});

});
parcelRegister("7VlYj", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("kkO5y"),
    $j9MRt("8uIxy"),
    $j9MRt("fvR1S"),
    $j9MRt("21HHS"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("1mY5c"),
    $j9MRt("70snJ"),
    $j9MRt("ffePP"),
    $j9MRt("3jUo4"),
    $j9MRt("2fbJv"),
    $j9MRt("j60P8"),
    $j9MRt("aXPEi"),
    $j9MRt("4RNdI"),
    $j9MRt("hXkjJ"),
    $j9MRt("7Zi76"),
    $j9MRt("7FtPh"),
    $j9MRt("1z2hL"),
    $j9MRt("clTPs"),
    $j9MRt("glmjZ"),
    $j9MRt("apr9b"),
    $j9MRt("ikoh2"),
    $j9MRt("ffUPr"),
    $j9MRt("d3buT"),
    $j9MRt("jJPu8")
]).then(()=>parcelRequire('e3qWG'));

});


parcelRegister("7Uadm", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormHelpText", () => (parcelRequire("dPp2Q")).default);

var $dPp2Q = parcelRequire("dPp2Q");

});
parcelRegister("dPp2Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $48fbe817c3223d2e$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("b2uYE");
var $6tHdJ = parcelRequire("6tHdJ");
const $48fbe817c3223d2e$var$selector = (0, $ehscL.createSelector)((state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    const requestType = (0, $73V7l.getPortalRequestType)(state, portalId, requestTypeId);
    return requestType && requestType.helpTextHtml;
}, (helpText)=>({
        helpText: helpText
    }));
var $48fbe817c3223d2e$export$2e2bcd8739ae039 = (0, $jvoWT.default)($48fbe817c3223d2e$var$selector)((0, $6tHdJ.default));

});
parcelRegister("b2uYE", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormHelpTextDumb", () => (parcelRequire("6tHdJ")).default);

var $6tHdJ = parcelRequire("6tHdJ");

});
parcelRegister("6tHdJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8be1fc8eb5bc5fd4$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");
parcelRequire("fyNTk");
var $hMRug = parcelRequire("hMRug");
class $8be1fc8eb5bc5fd4$var$RequestCreateFormHelpTextDumb extends $8P7DW.Component {
    render() {
        return /*#__PURE__*/ $8P7DW.createElement((0, $hMRug.default), {
            in: !!this.props.helpText
        }, /*#__PURE__*/ $8P7DW.createElement($8be1fc8eb5bc5fd4$var$HelpTextContainer, {
            dangerouslySetInnerHTML: {
                __html: this.props.helpText
            }
        }));
    }
}
var $8be1fc8eb5bc5fd4$export$2e2bcd8739ae039 = $8be1fc8eb5bc5fd4$var$RequestCreateFormHelpTextDumb;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8be1fc8eb5bc5fd4$var$HelpTextContainer = /*#__PURE__*/ (0, $2UsNA.default).div.withConfig({
    componentId: "sc-1u76lr1-0"
})`margin-top:${"var(--ds-space-200, 16px)"};margin-bottom:${"var(--ds-space-100, 8px)"};a{text-decoration:underline;}`;

});
parcelRegister("fyNTk", function(module, exports) {
$parcel$export(module.exports, "Fade", () => (parcelRequire("hMRug")).default);
parcelRequire("edPWU");
var $hMRug = parcelRequire("hMRug");

});
parcelRegister("edPWU", function(module, exports) {
$parcel$export(module.exports, "Fade", () => (parcelRequire("hMRug")).default);

var $hMRug = parcelRequire("hMRug");

});
parcelRegister("hMRug", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f36f4efc98368c2$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2UsNA = parcelRequire("2UsNA");

var $b60z8 = parcelRequire("b60z8");

var $av4AB = parcelRequire("av4AB");
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8f36f4efc98368c2$var$Container = /*#__PURE__*/ (0, $2UsNA.default).span.withConfig({
    componentId: "sc-10ahj68-0"
})`${$b60z8.fadeInOut($b60z8.speedMs.fast)};`;
/**
 * This is for ease of use fade in/out. This will add an extra <span> around the children to do the
 * animating. If you need finer grained control, or don't want the extra span markup, use <Transition />
 * and our transition mixins directly.
 */ const $8f36f4efc98368c2$var$Fade = ({ children: children, appear: appear, in: show })=>/*#__PURE__*/ $8P7DW.createElement((0, $av4AB.default), {
        timeout: $b60z8.speedMs.fast,
        in: show,
        mountOnEnter: true,
        unmountOnExit: true,
        appear: appear
    }, (state)=>/*#__PURE__*/ $8P7DW.createElement($8f36f4efc98368c2$var$Container, {
            state: state
        }, children));
var $8f36f4efc98368c2$export$2e2bcd8739ae039 = $8f36f4efc98368c2$var$Fade;

});







parcelRegister("lzhZC", function(module, exports) {
$parcel$export(module.exports, "LazyPortalSettingsAnnouncementSidebar", () => $2b6da0be038ca6c8$export$454a2c99809e1b66);
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $2b6da0be038ca6c8$export$454a2c99809e1b66 = (0, $fGOkV.lazy)(()=>(parcelRequire("8hQVw")), {
    moduleId: "./src/view/portal-settings-announcement-sidebar/portal-settings-announcement-sidebar.tsx"
});

});
parcelRegister("8hQVw", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("gCQea"),
    $j9MRt("i5Sge"),
    $j9MRt("3aI3R"),
    $j9MRt("ig3rT"),
    $j9MRt("7UfmT"),
    $j9MRt("12ZeZ")
]).then(()=>parcelRequire('hj6CH'));

});


parcelRegister("78hCN", function(module, exports) {
$parcel$export(module.exports, "LazyPortalSettingsSidebar", () => $1a2d22de28bcd640$export$4bdb57f5e35140ab);
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $1a2d22de28bcd640$export$4bdb57f5e35140ab = (0, $fGOkV.lazy)(()=>(parcelRequire("21sAt")), {
    moduleId: "./src/view/portal-settings-sidebar/portal-settings-sidebar.tsx"
});

});
parcelRegister("21sAt", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("gCQea"),
    $j9MRt("i5Sge"),
    $j9MRt("gR3jJ"),
    $j9MRt("3aI3R"),
    $j9MRt("ig3rT"),
    $j9MRt("5WsnM"),
    $j9MRt("7UfmT"),
    $j9MRt("j5SwK"),
    $j9MRt("cDUzg"),
    $j9MRt("jKTRD"),
    $j9MRt("dnLyQ")
]).then(()=>parcelRequire('d2p9H'));

});


parcelRegister("hxumn", function(module, exports) {
$parcel$export(module.exports, "RequestCreateForm", () => $08090afee49e4b0a$export$23aadacdae45e79);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $08090afee49e4b0a$var$loader = (0, $fGOkV.lazyForPaint)(()=>{
    return (parcelRequire("depUR"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-form/hocs.tsx"
});
const $08090afee49e4b0a$export$23aadacdae45e79 = (0, $gweXC.default)({
    loader: $08090afee49e4b0a$var$loader
});

});
parcelRegister("depUR", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("1j2Ac"),
    $j9MRt("kZXFN"),
    $j9MRt("fVo08"),
    $j9MRt("TcRZT"),
    $j9MRt("gUXUg"),
    $j9MRt("4Bauu"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("hcxtc"),
    $j9MRt("hMKE4"),
    $j9MRt("huqUq")
]).then(()=>parcelRequire('f0o71'));

});


parcelRegister("9DaWq", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormWithProforma", () => $792ee6fa3cbdd214$export$4265d8dac3a1f25);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $792ee6fa3cbdd214$var$loader = (0, $fGOkV.lazyForPaint)(()=>{
    return (parcelRequire("98RZT"));
}, {
    moduleId: "./src/view/request-create-form/request-create-form-with-proforma/request-create-form-with-proforma.tsx"
});
const $792ee6fa3cbdd214$export$4265d8dac3a1f25 = (0, $gweXC.default)({
    loader: $792ee6fa3cbdd214$var$loader
});

});
parcelRegister("98RZT", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("1j2Ac"),
    $j9MRt("kZXFN"),
    $j9MRt("fVo08"),
    $j9MRt("TcRZT"),
    $j9MRt("gUXUg"),
    $j9MRt("4Bauu"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("hcxtc"),
    $j9MRt("hMKE4"),
    $j9MRt("huqUq"),
    $j9MRt("gRGGD"),
    $j9MRt("iEFkY"),
    $j9MRt("2HGZt"),
    $j9MRt("fSmVB"),
    $j9MRt("7UfmT"),
    $j9MRt("cH2oj"),
    $j9MRt("go01H")
]).then(()=>parcelRequire('7EHJW'));

});


parcelRegister("8IdoQ", function(module, exports) {
$parcel$export(module.exports, "SidebarToggle", () => $f6b0219dd32d8312$export$d1b4e884a11aa0f2);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("ibkPE");
var $iwSnV = parcelRequire("iwSnV");
const $f6b0219dd32d8312$export$d1b4e884a11aa0f2 = ({ openSidebar: openSidebar, closeSidebar: closeSidebar })=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $iwSnV.useQueryParams)();
    $8P7DW.useEffect(()=>{
        if (customize === 'true' && !!experience) openSidebar === null || openSidebar === void 0 || openSidebar();
        else closeSidebar === null || closeSidebar === void 0 || closeSidebar();
    }, [
        customize,
        openSidebar,
        closeSidebar,
        experience
    ]);
    return null;
};

});

parcelRegister("cVFW8", function(module, exports) {
$parcel$export(module.exports, "UiModificationsEntryPoint", () => $3212131bcc18c951$export$c89b83ae4e6840b3);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $edC7N = parcelRequire("edC7N");

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $fBOCW = parcelRequire("fBOCW");
parcelRequire("54NpL");
var $lvoGq = parcelRequire("lvoGq");

var $1EFS8 = parcelRequire("1EFS8");

var $4L08H = parcelRequire("4L08H");

var $byuiX = parcelRequire("byuiX");

var $2aJyl = parcelRequire("2aJyl");
var $cP8g6 = parcelRequire("cP8g6");

var $3UzpN = parcelRequire("3UzpN");
var $iOykB = parcelRequire("iOykB");

var $9Qkcz = parcelRequire("9Qkcz");

var $8Z0nB = parcelRequire("8Z0nB");

var $9jNvK = parcelRequire("9jNvK");
// TODO: add memo to the below component
const $3212131bcc18c951$var$EntryPointWithRelay = ({ portalId: portalId, requestTypeId: requestTypeId, triggerPointKey: triggerPointKey })=>{
    const executionContextKey = portalId && requestTypeId ? `${portalId}-${requestTypeId}` : null;
    const cloudId = (0, $jByYr.getCloudId)();
    const activationId = (0, $jByYr.getActivationId)();
    const { queryReference: queryReference } = (0, $byuiX.useRelayResource)((0, $fBOCW.UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE));
    const executionContext = (0, $8P7DW.useMemo)(()=>{
        if (!portalId || !requestTypeId) return null;
        return {
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId
            }
        };
    }, [
        portalId,
        requestTypeId
    ]);
    const triggerPointKeyVal = triggerPointKey ?? (0, $8Z0nB.DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3UzpN.UiModificationsRoot), {
        executionContext: executionContext,
        queryReference: queryReference,
        cloudId: cloudId,
        activationId: activationId,
        executionContextKey: executionContextKey,
        triggerPointKey: triggerPointKeyVal,
        ForgeAppRenderer: (0, $9jNvK.ForgeAppRenderer)
    });
};
/**
 * Entry point component that uses Redux data (behind feature flag ditto_uim_root_query_rest)
 */ const $3212131bcc18c951$var$EntryPointWithReduxData = ({ portalId: portalId, requestTypeId: requestTypeId, triggerPointKey: triggerPointKey, uiModifications: uiModifications, uiModificationsError: uiModificationsError })=>{
    const executionContextKey = portalId && requestTypeId ? `${portalId}-${requestTypeId}` : null;
    const cloudId = (0, $jByYr.getCloudId)();
    const activationId = (0, $jByYr.getActivationId)();
    // Fire analytics when there's an error fetching UI modifications
    (0, $8P7DW.useEffect)(()=>{
        if (uiModificationsError) (0, $cP8g6.fireErrorAnalytics)({
            error: new Error(uiModificationsError),
            id: 'fetchUiModificationsFailure',
            viewType: (0, $9Qkcz.REQUEST_CREATE_VIEW_TYPE),
            attributes: {
                portalId: portalId,
                requestTypeId: requestTypeId
            }
        });
    }, [
        uiModificationsError,
        portalId,
        requestTypeId
    ]);
    const executionContext = (0, $8P7DW.useMemo)(()=>{
        if (!portalId || !requestTypeId) return null;
        return {
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId
            }
        };
    }, [
        portalId,
        requestTypeId
    ]);
    // Wrap Redux data in { jira: ... } structure expected by platform component
    const wrappedUiModificationsData = (0, $8P7DW.useMemo)(()=>{
        if (!uiModifications) return {
            jira: {
                forge: {
                    uiModificationsExtensions: []
                },
                uiModifications: []
            }
        };
        return {
            jira: uiModifications
        };
    }, [
        uiModifications
    ]);
    const triggerPointKeyVal = triggerPointKey ?? (0, $8Z0nB.DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iOykB.UiModificationsRootWithData), {
        executionContext: executionContext,
        uiModificationsData: wrappedUiModificationsData,
        cloudId: cloudId,
        activationId: activationId,
        executionContextKey: executionContextKey,
        triggerPointKey: triggerPointKeyVal,
        ForgeAppRenderer: (0, $9jNvK.ForgeAppRenderer)
    });
};
const $3212131bcc18c951$var$selector = (0, $ehscL.createSelector)((state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    let uiModifications;
    let uiModificationsError;
    if (portalId && requestTypeId) {
        uiModifications = (0, $lvoGq.getUiModificationsData)(state, portalId, requestTypeId);
        uiModificationsError = (0, $lvoGq.getUiModificationsError)(state, portalId, requestTypeId);
    }
    return {
        portalId: portalId,
        requestTypeId: requestTypeId,
        uiModifications: uiModifications,
        uiModificationsError: uiModificationsError,
        triggerPointKey: props.triggerPointKey
    };
}, (selectorData)=>selectorData);
const $3212131bcc18c951$var$EntryPointRedux = (0, $jvoWT.default)($3212131bcc18c951$var$selector)($3212131bcc18c951$var$EntryPointWithReduxData);
const $3212131bcc18c951$var$EntryPoint = (props)=>{
    if ((0, $1EFS8.default).checkGate('ditto_uim_root_query_rest')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3212131bcc18c951$var$EntryPointRedux, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3212131bcc18c951$var$EntryPointWithRelay, props);
};
const $3212131bcc18c951$export$c89b83ae4e6840b3 = (props)=>{
    return (0, $HGACo.isUiModificationsSupportEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        id: "uiModifications",
        packageName: "jsmUiModificationsViewRequestCreate"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2aJyl.AnalyticsListener), {
        analyticsWebClient: (0, $4L08H.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3212131bcc18c951$var$EntryPoint, props))) : null;
};

});
parcelRegister("54NpL", function(module, exports) {
$parcel$export(module.exports, "getUiModificationsData", () => (parcelRequire("lvoGq")).getUiModificationsData);
$parcel$export(module.exports, "getUiModificationsError", () => (parcelRequire("lvoGq")).getUiModificationsError);

var $lvoGq = parcelRequire("lvoGq");

});
parcelRegister("lvoGq", function(module, exports) {
$parcel$export(module.exports, "getUiModificationsData", () => $3f3b27befff93356$export$3f2ec852b79889c8);
$parcel$export(module.exports, "getUiModificationsError", () => $3f3b27befff93356$export$a973ad30babc208b);
const $3f3b27befff93356$var$buildStoreKey = (portalId, requestTypeId)=>`${portalId}/${requestTypeId}`;
const $3f3b27befff93356$export$77a087943aa778c9 = (state, portalId, requestTypeId)=>{
    var _state$persisted$uiMo;
    const storeKey = $3f3b27befff93356$var$buildStoreKey(portalId, requestTypeId);
    return (_state$persisted$uiMo = state.persisted.uiModifications) === null || _state$persisted$uiMo === void 0 ? void 0 : _state$persisted$uiMo[storeKey];
};
const $3f3b27befff93356$export$3f2ec852b79889c8 = (state, portalId, requestTypeId)=>{
    var _getUiModificationsEn;
    return (_getUiModificationsEn = $3f3b27befff93356$export$77a087943aa778c9(state, portalId, requestTypeId)) === null || _getUiModificationsEn === void 0 ? void 0 : _getUiModificationsEn.data;
};
const $3f3b27befff93356$export$a973ad30babc208b = (state, portalId, requestTypeId)=>{
    var _getUiModificationsEn2;
    return (_getUiModificationsEn2 = $3f3b27befff93356$export$77a087943aa778c9(state, portalId, requestTypeId)) === null || _getUiModificationsEn2 === void 0 ? void 0 : _getUiModificationsEn2.error;
};

});


parcelRegister("2aJyl", function(module, exports) {
$parcel$export(module.exports, "AnalyticsListener", () => $c72b53812e35a12e$export$22edec767217cd60);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $bP2rs = parcelRequire("bP2rs");

var $8hleO = parcelRequire("8hleO");
var $17wqU = parcelRequire("17wqU");
parcelRequire("euslt");
var $9Lbe3 = parcelRequire("9Lbe3");

var $gqRjh = parcelRequire("gqRjh");
const $c72b53812e35a12e$export$7329bcdc3edcd90e = (event, client)=>{
    switch(event.type){
        case 0, $17wqU.OPERATIONAL_EVENT_TYPE:
            Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
            break;
        case 0, $17wqU.TRACK_EVENT_TYPE:
            Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
            break;
    }
};
const $c72b53812e35a12e$export$eee20638634729b3 = (analyticsWebClient)=>(event)=>{
        const eventData = (0, $8hleO.extractAWCDataFromEvent)(event);
        $c72b53812e35a12e$export$7329bcdc3edcd90e({
            type: eventData.type,
            ...eventData.payload
        }, analyticsWebClient);
    };
const $c72b53812e35a12e$export$22edec767217cd60 = ({ children: children, analyticsWebClient: analyticsWebClient })=>{
    const onEvent = (0, $8P7DW.useMemo)(()=>$c72b53812e35a12e$export$eee20638634729b3(analyticsWebClient), [
        analyticsWebClient
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const initClient = async ()=>{
            const client = await analyticsWebClient;
            (0, $9Lbe3.initialiseErrorAnalyticsClient)(client);
        };
        initClient();
    }, [
        analyticsWebClient
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bP2rs.default), {
        onEvent: onEvent,
        channel: (0, $gqRjh.UI_MODIFICATIONS_ANALYTICS_CHANNEL),
        children: children
    });
};

});

parcelRegister("3UzpN", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRoot", () => $dcb07f39bd07c4c3$export$da1a4f52b34addd2);

var $gWgPx = parcelRequire("gWgPx");

var $esvX7 = parcelRequire("esvX7");
parcelRequire("8P7DW");

var $h3cOB = parcelRequire("h3cOB");

var $ki2OF = parcelRequire("ki2OF");

var $lkETi = parcelRequire("lkETi");
const $dcb07f39bd07c4c3$export$da1a4f52b34addd2 = (props)=>{
    const { queryReference: queryReference } = props;
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ki2OF.default), {
        name: "ui-modifications-root-query",
        fallback: null,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($dcb07f39bd07c4c3$var$RootQuery, {
            ...props,
            queryReference: queryReference
        })
    });
};
const $dcb07f39bd07c4c3$var$RootQuery = (props)=>{
    const { queryReference: queryReference, ...restProps } = props;
    const data = (0, $h3cOB.usePreloadedQuery)((0, $esvX7.default), queryReference);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lkETi.UiModificationsRootFragment), {
        ...restProps,
        fragmentRef: data
    });
};

});
parcelRegister("lkETi", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRootFragment", () => $7f65fc8fe88a6f79$export$c460318ed1ecaf23);

var $gWgPx = parcelRequire("gWgPx");

var $7hx8B = parcelRequire("7hx8B");

var $8P7DW = parcelRequire("8P7DW");

var $h3cOB = parcelRequire("h3cOB");

var $8gu7I = parcelRequire("8gu7I");

var $2t9fp = parcelRequire("2t9fp");

var $hOkwG = parcelRequire("hOkwG");

var $lqPpg = parcelRequire("lqPpg");

var $8hPak = parcelRequire("8hPak");

var $8MVOi = parcelRequire("8MVOi");

var $eecjn = parcelRequire("eecjn");

var $jiCAh = parcelRequire("jiCAh");

var $aWCG9 = parcelRequire("aWCG9");

var $gknhx = parcelRequire("gknhx");
const $7f65fc8fe88a6f79$export$c460318ed1ecaf23 = (props)=>{
    const executionContext = (0, $gknhx.useEnrichedExecutionContext)({
        executionContext: props.executionContext
    });
    const { executionContextKey: executionContextKey, triggerPointKey: triggerPointKey } = props;
    const viewType = (0, $lqPpg.useViewType)();
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $2t9fp.useAdjustmentsContextActions)();
    const shouldLoad = executionContext && executionContextKey && (0, $8MVOi.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $8MVOi.isExecutionContextSupported)(executionContext);
    (0, $8P7DW.useEffect)(()=>{
        // `executionContextKey` has to be the dependency of the useEffect
        // to set the shouldUiModificationsLoad state according to context changes
        // that is represented by the `executionContextKey`
        if (shouldLoad) setShouldUiModificationsLoad(shouldLoad ? 'yes' : 'no');
    }, [
        setShouldUiModificationsLoad,
        shouldLoad,
        executionContextKey
    ]);
    if (!shouldLoad) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)($7f65fc8fe88a6f79$var$RootFragmentWithCleanup, {
        ...props,
        executionContext: executionContext,
        executionContextKey: executionContextKey
    });
};
/**
 * It is separated from
 * - `UiModificationsRootFragment` to run cleanup only when we know that we want to render UIM
 * - `RootFragment` to run cleanup imidiately without awaiting for the new Relay data when context changed
 */ const $7f65fc8fe88a6f79$var$RootFragmentWithCleanup = (props)=>{
    const { cloudId: cloudId, activationId: activationId, executionContextKey: executionContextKey, triggerPointKey: triggerPointKey, executionContext: executionContext, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = props;
    (0, $aWCG9.useContextCleanup)({
        executionContextKey: executionContextKey,
        numberOfSupportedFields: numberOfSupportedFields,
        resetFormFieldsCounter: resetFormFieldsCounter
    });
    const tenantContext = (0, $8P7DW.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId
        }), [
        cloudId,
        activationId
    ]);
    const analyticsContextData = (0, $8P7DW.useMemo)(()=>({
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }), [
        triggerPointKey
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8gu7I.default), {
        data: analyticsContextData,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hOkwG.ExecutionContextProvider), {
            value: executionContext,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8hPak.TenantContextProvider), {
                value: tenantContext,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)($7f65fc8fe88a6f79$var$RootFragment, {
                    ...props
                })
            })
        })
    });
};
const $7f65fc8fe88a6f79$var$RootFragment = ({ fragmentRef: fragmentRef, ForgeAppRenderer: ForgeAppRenderer, executionContextKey: executionContextKey })=>{
    const response = (0, $h3cOB.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $7hx8B.default), /* eslint-enable @atlassian/relay/unused-fields */ fragmentRef);
    const appsToRender = (0, $jiCAh.useAppsToRender)({
        data: response,
        executionContextKey: executionContextKey
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eecjn.AppsRenderer), {
        apps: appsToRender,
        ForgeAppRenderer: ForgeAppRenderer
    });
};

});
parcelRegister("7hx8B", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc2010c2d473d304$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b7187610f954913f8ea19c30503c4ed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dc2010c2d473d304$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "forgeExtensionRenderingContext"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "uiModificationsContext"
            }
        ],
        "kind": "Fragment",
        "name": "fragment_AtlassianUiModificationsCore_RootFragment",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "uiModificationsContext"
                                }
                            ],
                            "concreteType": "JiraAppUiModifications",
                            "kind": "LinkedField",
                            "name": "uiModifications",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appEnvId"
                                },
                                {
                                    "concreteType": "JiraUiModification",
                                    "kind": "LinkedField",
                                    "name": "uiModifications",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "NONE",
                        "path": "jira.uiModifications"
                    },
                    {
                        "concreteType": "JiraForgeQuery",
                        "kind": "LinkedField",
                        "name": "forge",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "uiModificationsExtensions",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "context",
                                            "variableName": "forgeExtensionRenderingContext"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "jira:uiModifications"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraForgeExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appVersion"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "installationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentKey"
                                        },
                                        {
                                            "concreteType": "JiraForgeExtensionLicense",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "active"
                                                },
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportEntitlementNumber"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "trialEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subscriptionEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEvaluation"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "billingPeriod"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementSlug"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "capabilitySet"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "properties"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "concreteType": "JiraForgeAppEgressDeclaration",
                                            "kind": "LinkedField",
                                            "name": "egress",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "addresses"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inScopeEUD"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraForgeInstallationConfigExtension",
                                            "kind": "LinkedField",
                                            "name": "installationConfig",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "consentUrl"
                                        },
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "enabled"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "jira.forge.uiModificationsExtensions"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$dc2010c2d473d304$var$node.hash = "ff48dbe4ed2ab636d857ff6d8fc8b30f";
var $dc2010c2d473d304$export$2e2bcd8739ae039 = $dc2010c2d473d304$var$node;

});

parcelRegister("hOkwG", function(module, exports) {
$parcel$export(module.exports, "useExecutionContext", () => $87da7a4702aa91af$export$b0467ce6d1ed861f);
$parcel$export(module.exports, "ExecutionContextProvider", () => $87da7a4702aa91af$export$14f2a780bc6de643);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $87da7a4702aa91af$export$7f8a924805594460 = /*#__PURE__*/ (0, $8P7DW.createContext)(null);
const $87da7a4702aa91af$export$b0467ce6d1ed861f = ()=>{
    const executionContext = (0, $8P7DW.useContext)($87da7a4702aa91af$export$7f8a924805594460);
    if (executionContext === null) throw new Error('executionContext value is null');
    return executionContext;
};
const $87da7a4702aa91af$export$14f2a780bc6de643 = ({ children: children, value: value })=>{
    if (!value) throw new Error('ExecutionContextProvider requires a value');
    return /*#__PURE__*/ (0, $gWgPx.jsx)($87da7a4702aa91af$export$7f8a924805594460.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("lqPpg", function(module, exports) {
$parcel$export(module.exports, "useViewType", () => $90b218ced142a813$export$1568c16ff8af07a3);

var $6xLCs = parcelRequire("6xLCs");

var $2FT8E = parcelRequire("2FT8E");
const $90b218ced142a813$export$1568c16ff8af07a3 = (0, $6xLCs.createStateHook)((0, $2FT8E.store), {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    selector: (state)=>state.viewType
});

});

parcelRegister("8hPak", function(module, exports) {
$parcel$export(module.exports, "useTenantContext", () => $c45ad50e2a9589c9$export$28e7c557f4d454d9);
$parcel$export(module.exports, "TenantContextProvider", () => $c45ad50e2a9589c9$export$e32355e80a92030c);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $c45ad50e2a9589c9$var$TenantContext = /*#__PURE__*/ (0, $8P7DW.createContext)(null);
const $c45ad50e2a9589c9$export$28e7c557f4d454d9 = ()=>{
    const tenantContext = (0, $8P7DW.useContext)($c45ad50e2a9589c9$var$TenantContext);
    if (tenantContext === null) throw new Error('tenantContext value is null');
    return tenantContext;
};
const $c45ad50e2a9589c9$export$e32355e80a92030c = ({ children: children, value: value })=>{
    if (!value) throw new Error('TenantContextProvider requires a value');
    return /*#__PURE__*/ (0, $gWgPx.jsx)($c45ad50e2a9589c9$var$TenantContext.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("eecjn", function(module, exports) {
$parcel$export(module.exports, "AppsRenderer", () => $06f8ecdb14634fad$export$d013b75640a90b27);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8gu7I = parcelRequire("8gu7I");

var $uxUw0 = parcelRequire("uxUw0");

var $3RDjW = parcelRequire("3RDjW");

var $afew4 = parcelRequire("afew4");
const $06f8ecdb14634fad$export$d013b75640a90b27 = ({ ForgeAppRenderer: ForgeAppRenderer, apps: apps })=>{
    const [triggerFieldInitializationKey] = (0, $3RDjW.useTriggerFieldInitialization)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: apps.map(({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig })=>{
            const { appId: appId, environmentId: envId } = (0, $uxUw0.parseExtensionId)(forgeExtension.id);
            return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8gu7I.default), {
                data: {
                    attributes: {
                        appId: appId,
                        envId: envId
                    }
                },
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $afew4.SingleAppRenderer), {
                    forgeExtension: forgeExtension,
                    uiModificationsConfig: uiModificationsConfig,
                    ForgeAppRenderer: ForgeAppRenderer
                })
            }, `${forgeExtension.id}-${triggerFieldInitializationKey}`);
        })
    });
};

});
parcelRegister("uxUw0", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $ad81a11c475fad7d$export$bae42cbaf7fa3e1b);

var $qvnRJ = parcelRequire("qvnRJ");
const $ad81a11c475fad7d$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $qvnRJ.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("qvnRJ", function(module, exports) {
"use strict";
var $04fac60459ca68b6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $04fac60459ca68b6$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $88zTZ = parcelRequire("88zTZ");

$04fac60459ca68b6$var$__export((parcelRequire("aLz3w")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $04fac60459ca68b6$var$InvalidAriError = /** @class */ function(_super) {
    $04fac60459ca68b6$var$__extends(InvalidAriError, _super);
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $04fac60459ca68b6$var$InvalidAriError;
function $04fac60459ca68b6$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $04fac60459ca68b6$var$basicCharConstraint = $88zTZ.pattern(/^[a-z][a-z.-]*$/);
var $04fac60459ca68b6$var$resourceOwnerConstraints = [
    $88zTZ.lengthBetween(3, 255),
    $04fac60459ca68b6$var$basicCharConstraint
];
var $04fac60459ca68b6$var$resourceTypeConstraints = [
    $88zTZ.lengthBetween(3, 255),
    $04fac60459ca68b6$var$basicCharConstraint
];
var $04fac60459ca68b6$var$cloudIdConstraints = [
    $88zTZ.lengthBetween(36, 255)
];
var $04fac60459ca68b6$var$siteResourceType = 'site';
var $04fac60459ca68b6$var$resourceIdChars = /[\w-._~:@#]/.source;
var $04fac60459ca68b6$var$resourceIdConstraints = [
    $88zTZ.pattern(new RegExp("^" + $04fac60459ca68b6$var$resourceIdChars + "+(/" + $04fac60459ca68b6$var$resourceIdChars + "*)*(;v=" + $04fac60459ca68b6$var$resourceIdChars + "*)*$"))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $04fac60459ca68b6$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $04fac60459ca68b6$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $04fac60459ca68b6$var$ResourceIdentifier = /** @class */ function() {
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ function ResourceIdentifier(values) {
        var _a = $04fac60459ca68b6$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $04fac60459ca68b6$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $04fac60459ca68b6$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $04fac60459ca68b6$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $04fac60459ca68b6$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $04fac60459ca68b6$var$parse(decodeURIComponent(encodedAriString));
    };
    /**
     * Converts this Ari to a string.
     */ ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $04fac60459ca68b6$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $04fac60459ca68b6$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    };
    /**
     * Converts this object to its json representation
     */ ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    };
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    };
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    };
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ ResourceIdentifier.prototype.matches = function(other) {
        return $04fac60459ca68b6$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $04fac60459ca68b6$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $04fac60459ca68b6$var$siteResourceType && !!other.resourceType || $04fac60459ca68b6$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $04fac60459ca68b6$var$siteResourceType && !!other.resourceType || $04fac60459ca68b6$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $04fac60459ca68b6$var$siteResourceType && !cloudId) return new $88zTZ.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $88zTZ.validateField(this, 'resourceOwner', $04fac60459ca68b6$var$resourceOwnerConstraints),
            $88zTZ.validateField(this, 'resourceType', $04fac60459ca68b6$var$resourceTypeConstraints),
            $88zTZ.validateField(this, 'resourceId', $04fac60459ca68b6$var$resourceIdConstraints),
            $88zTZ.validateField(this, 'cloudId', $04fac60459ca68b6$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $04fac60459ca68b6$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $04fac60459ca68b6$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $04fac60459ca68b6$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $04fac60459ca68b6$var$parse(ariString) {
    return $04fac60459ca68b6$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $04fac60459ca68b6$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $04fac60459ca68b6$var$parseEncoded(encodedAriString) {
    return $04fac60459ca68b6$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $04fac60459ca68b6$var$parseEncoded;

});
parcelRegister("88zTZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5ecaeb77c663f803$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $5ecaeb77c663f803$var$LengthConstraint;
var $5ecaeb77c663f803$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $5ecaeb77c663f803$var$RegexConstraint;
var $5ecaeb77c663f803$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $5ecaeb77c663f803$var$GeneralValidationError;
var $5ecaeb77c663f803$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $5ecaeb77c663f803$var$ConstraintViolation;
function $5ecaeb77c663f803$var$lengthBetween(min, max) {
    return new $5ecaeb77c663f803$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $5ecaeb77c663f803$var$lengthBetween;
function $5ecaeb77c663f803$var$pattern(regex) {
    return new $5ecaeb77c663f803$var$RegexConstraint(regex);
}
module.exports.pattern = $5ecaeb77c663f803$var$pattern;
function $5ecaeb77c663f803$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $5ecaeb77c663f803$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $5ecaeb77c663f803$var$validateField;

});

parcelRegister("aLz3w", function(module, exports) {
"use strict";
var $7d697c8b7ab859ff$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kYaep = parcelRequire("kYaep");
var $7d697c8b7ab859ff$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($7d697c8b7ab859ff$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $7d697c8b7ab859ff$var$AppFamilyAriError = /** @class */ function(_super) {
    $7d697c8b7ab859ff$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $7d697c8b7ab859ff$var$AppFamilyAriError;
var $7d697c8b7ab859ff$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $7d697c8b7ab859ff$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($7d697c8b7ab859ff$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $7d697c8b7ab859ff$var$NotAppFamilyAriError;
var $7d697c8b7ab859ff$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $7d697c8b7ab859ff$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($7d697c8b7ab859ff$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $7d697c8b7ab859ff$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $7d697c8b7ab859ff$var$parseAppAri(ari) {
    return $kYaep.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $7d697c8b7ab859ff$var$parseAppAri;
function $7d697c8b7ab859ff$var$createAppAri(json) {
    return new $kYaep.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $7d697c8b7ab859ff$var$createAppAri;

});
parcelRegister("kYaep", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aLz3w = parcelRequire("aLz3w");

var $qvnRJ = parcelRequire("qvnRJ");
var $f441590052283f05$var$versionPrefix = ';v=';
var $f441590052283f05$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $aLz3w.AppFamilyAri.resourceOwner) throw new $aLz3w.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $aLz3w.AppFamilyAri.resourceOwner);
        if (!resourceType || $aLz3w.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $aLz3w.NotAppFamilyAriError(ari, "resourceType must be one of " + $aLz3w.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $aLz3w.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($f441590052283f05$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($f441590052283f05$var$versionPrefix) > versionIndex) throw new $aLz3w.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($f441590052283f05$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($f441590052283f05$var$stripToUndefined);
        if (segments.length > 4) throw new $aLz3w.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $aLz3w.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $aLz3w.AppFamilyAri.extensionGroupResourceType || resourceType === $aLz3w.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $aLz3w.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $aLz3w.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $aLz3w.AppFamilyAri.extensionResourceType);
        else if (resourceType === $aLz3w.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $aLz3w.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $aLz3w.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $aLz3w.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $aLz3w.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $aLz3w.AppFamilyAri.environmentResourceType);
        else if (resourceType === $aLz3w.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $aLz3w.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $aLz3w.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $aLz3w.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $aLz3w.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $f441590052283f05$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $qvnRJ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $aLz3w.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $qvnRJ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $aLz3w.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $qvnRJ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $aLz3w.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $qvnRJ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $aLz3w.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $f441590052283f05$var$AppFamilyAriImpl;
function $f441590052283f05$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("3RDjW", function(module, exports) {
$parcel$export(module.exports, "useTriggerFieldInitialization", () => $a0c13a726ba6643f$export$1c69013aaf9112f0);

var $6xLCs = parcelRequire("6xLCs");

var $2FT8E = parcelRequire("2FT8E");
const $a0c13a726ba6643f$var$selectTriggerFieldInitializationKey = (state)=>state.triggerFieldInitializationKey;
const $a0c13a726ba6643f$export$1c69013aaf9112f0 = (0, $6xLCs.createHook)((0, $2FT8E.store), {
    selector: $a0c13a726ba6643f$var$selectTriggerFieldInitializationKey
});

});

parcelRegister("afew4", function(module, exports) {
$parcel$export(module.exports, "SingleAppRenderer", () => $0f6697f6960b38c1$export$53c5b0cb268c246d);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $ki2OF = parcelRequire("ki2OF");

var $uxUw0 = parcelRequire("uxUw0");

var $iW8tR = parcelRequire("iW8tR");

var $ex5tK = parcelRequire("ex5tK");

var $hOkwG = parcelRequire("hOkwG");

var $lqPpg = parcelRequire("lqPpg");

var $2FT8E = parcelRequire("2FT8E");

var $8MVOi = parcelRequire("8MVOi");

var $gmZRf = parcelRequire("gmZRf");

var $caMvb = parcelRequire("caMvb");

var $4xYAk = parcelRequire("4xYAk");

var $sIMef = parcelRequire("sIMef");

var $cn9bZ = parcelRequire("cn9bZ");
const $0f6697f6960b38c1$export$53c5b0cb268c246d = ({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig, ForgeAppRenderer: ForgeAppRenderer })=>{
    const { scopes: moduleScopes, id: moduleId } = forgeExtension;
    const { setError: setError } = (0, $2FT8E.useIssueAdjustmentsActions)();
    const viewType = (0, $lqPpg.useViewType)();
    const executionContext = (0, $hOkwG.useExecutionContext)();
    const extensionData = (0, $8P7DW.useMemo)(()=>(0, $cn9bZ.buildExtensionData)(executionContext), [
        executionContext
    ]);
    const { appId: appId } = (0, $uxUw0.parseExtensionId)(moduleId);
    // This hook can be removed and replaced with `onTimeout` from LazyIframe once
    // https://ecosystem.atlassian.net/browse/BUILD-1617 is done. For now it approximates an
    // iframe timeout if the iframe doesn't use the custom bridge method needed by @forge/jira-bridge
    const { setLoadingComplete: setLoadingComplete } = (0, $caMvb.useIframeTimeout)({
        forgeExtension: forgeExtension
    });
    const { customBridgeMethods: customBridgeMethods } = (0, $gmZRf.useCustomBridgeMethods)({
        onBridgeCommunicationReceived: setLoadingComplete,
        uiModifications: uiModificationsConfig,
        moduleScopes: moduleScopes,
        appId: appId
    });
    const requiredScopesFound = (0, $4xYAk.useScopeChecks)(moduleScopes);
    const currentUIModificationsConsentStatus = (0, $iW8tR.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    (0, $8P7DW.useEffect)(()=>{
        if (!requiredScopesFound) {
            setError({
                errorCode: 'SCOPES_MISSING_ERROR_CODE'
            });
            setLoadingComplete();
            (0, $8MVOi.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        requiredScopesFound,
        setError,
        setLoadingComplete,
        viewType
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (currentUIModificationsConsentStatus === (0, $ex5tK.UIM_CONSENT_REQUIRED)) {
            setLoadingComplete();
            (0, $8MVOi.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        currentUIModificationsConsentStatus,
        setLoadingComplete,
        viewType
    ]);
    const consentProps = (0, $sIMef.useThreeLOPromptProps)({
        forgeExtension: forgeExtension
    });
    if (!requiredScopesFound) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ki2OF.default), {
        name: "single-frame-iframe",
        fallback: null,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)(ForgeAppRenderer, {
            extension: forgeExtension,
            extensionData: extensionData,
            customBridgeMethods: customBridgeMethods,
            onIframeLoad: (0, $8MVOi.getAnalytics)(viewType).markIframeLoad,
            isIframeResizable: false,
            isIframeHidden: true,
            ...consentProps
        })
    }, moduleId);
};

});
parcelRegister("gmZRf", function(module, exports) {
$parcel$export(module.exports, "useCustomBridgeMethods", () => $f6dd3a29c5d37cbc$export$88571489e690a256);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $4NzXn = parcelRequire("4NzXn");

var $eINDJ = parcelRequire("eINDJ");

var $2zmab = parcelRequire("2zmab");

var $81uaA = parcelRequire("81uaA");

var $8Dw5s = parcelRequire("8Dw5s");

var $icM5S = parcelRequire("icM5S");

var $gFuOr = parcelRequire("gFuOr");
const $f6dd3a29c5d37cbc$export$88571489e690a256 = ({ onBridgeCommunicationReceived: onBridgeCommunicationReceived, uiModifications: uiModifications, moduleScopes: moduleScopes = [], appId: appId })=>{
    const { onInitPromise: onInitPromise } = (0, $8Dw5s.useOnInit)({
        moduleScopes: moduleScopes
    });
    const subscribeToChanges = (0, $2zmab.useOnChangeSubscription)({
        uiModifications: uiModifications,
        moduleScopes: moduleScopes
    });
    const submit = (0, $gFuOr.useSubmit)({
        moduleScopes: moduleScopes,
        appId: appId
    });
    const registerFields = (0, $icM5S.useRegisterFields)({
        appId: appId
    });
    const onBridgeError = (0, $eINDJ.useOnBridgeError)({
        appId: appId
    });
    const subscribeToErrors = (0, $81uaA.useOnErrorSubscription)({
        appId: appId
    });
    const getInternalAPI = (0, $8P7DW.useCallback)(()=>{
        onBridgeCommunicationReceived === null || onBridgeCommunicationReceived === void 0 || onBridgeCommunicationReceived();
        return {
            data: {
                onInitChangeId: (0, $4NzXn.ON_INIT_CHANGE_ID),
                uiModifications: uiModifications,
                featureFlags: {
                    // keep as true, we will also need to do the forge-bridge clean-up
                    // and wait for some period of time so the users will migrate to the version without this FG.
                    'forge-ui-modifications-screentabs_qoa33': true
                }
            },
            actions: {
                getOnInitData: ()=>onInitPromise,
                subscribeToChanges: subscribeToChanges,
                submit: submit,
                registerFields: registerFields,
                onBridgeError: onBridgeError,
                subscribeToErrors: subscribeToErrors
            }
        };
    }, [
        onBridgeCommunicationReceived,
        uiModifications,
        subscribeToChanges,
        submit,
        registerFields,
        onInitPromise,
        onBridgeError,
        subscribeToErrors
    ]);
    const customBridgeMethods = (0, $8P7DW.useMemo)(()=>({
            getUiModificationsInternalAPI: getInternalAPI
        }), // TODO: Make sure that the `getInternalAPI` is not being regenerated on the consecutive renders
    // because the bridge consumes only the first version of it, if so clear the array deps to be [].
    [
        getInternalAPI
    ]);
    return {
        customBridgeMethods: customBridgeMethods
    };
};

});
parcelRegister("eINDJ", function(module, exports) {
$parcel$export(module.exports, "useOnBridgeError", () => $c6d9a35ef692cf6e$export$7b14c142027ef2e2);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $j7DJp = parcelRequire("j7DJp");

var $cP8g6 = parcelRequire("cP8g6");

var $lqPpg = parcelRequire("lqPpg");

var $2FT8E = parcelRequire("2FT8E");

var $8MVOi = parcelRequire("8MVOi");

var $aTGEX = parcelRequire("aTGEX");
const $c6d9a35ef692cf6e$var$isValidPayload = (payload)=>payload !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($j7DJp)))(payload) && (0, $aTGEX.BRIDGE_ERROR_TYPES).includes(payload.error) && (!payload.changeId || typeof payload.changeId === 'string');
const $c6d9a35ef692cf6e$export$7b14c142027ef2e2 = ({ appId: appId })=>{
    const { setError: setError, unregisterFields: unregisterFields } = (0, $2FT8E.useIssueAdjustmentsActions)();
    const viewType = (0, $lqPpg.useViewType)();
    return (0, $8P7DW.useCallback)((payload)=>{
        if (!$c6d9a35ef692cf6e$var$isValidPayload(payload)) return;
        const { changeId: changeId, error: error, cause: cause } = payload;
        if (changeId) unregisterFields({
            changeId: changeId,
            appId: appId
        });
        setError({
            errorCode: 'ON_BRIDGE_ERROR_ERROR_CODE'
        });
        (0, $8MVOi.getAnalytics)(viewType).stopTTI({
            completionStatus: 'error',
            viewType: viewType
        });
        const UIMLoggableError = new Error(`An ${error} occurred in the UI Modifications code in the Jira Bridge`, {
            cause: cause
        });
        (0, $cP8g6.fireErrorAnalytics)({
            error: UIMLoggableError,
            id: 'UIModificationsJiraBridge',
            viewType: viewType,
            attributes: {
                type: error,
                cause: cause
            }
        });
    }, [
        setError,
        unregisterFields,
        viewType,
        appId
    ]);
};

});
parcelRegister("aTGEX", function(module, exports) {
$parcel$export(module.exports, "BRIDGE_ERROR_TYPES", () => $40e8448d633177dd$export$7845535459d8a620);
const $40e8448d633177dd$export$6634aa68b37142fc = 'onInitError';
const $40e8448d633177dd$export$7ab66e58aded6116 = 'subscribeToChangesError';
const $40e8448d633177dd$export$3018e0c759270938 = 'getApiError';
const $40e8448d633177dd$export$7845535459d8a620 = [
    $40e8448d633177dd$export$6634aa68b37142fc,
    $40e8448d633177dd$export$7ab66e58aded6116,
    $40e8448d633177dd$export$3018e0c759270938
];

});


parcelRegister("2zmab", function(module, exports) {
$parcel$export(module.exports, "useOnChangeSubscription", () => $f2f86d11c7f703d2$export$785e6020792a124f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $5UAqR = parcelRequire("5UAqR");

var $dx60X = parcelRequire("dx60X");

var $llMWs = parcelRequire("llMWs");

var $lqPpg = parcelRequire("lqPpg");

var $lSG07 = parcelRequire("lSG07");

var $hm3Li = parcelRequire("hm3Li");
const $f2f86d11c7f703d2$export$785e6020792a124f = ({ uiModifications: uiModifications, moduleScopes: moduleScopes })=>{
    const viewType = (0, $lqPpg.useViewType)();
    const notifyAppRef = (0, $8P7DW.useRef)(null);
    const { lastProcessedChange: lastProcessedChange } = (0, $llMWs.useLastProcessedChange)();
    const { currentFormState: currentFormState, currentScreenTabsState: currentScreenTabsState } = (0, $dx60X.useCurrentFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    /**
   * Single ref for all data that must be up-to-date but not trigger notification.
   */ const dataRef = (0, $8P7DW.useRef)({
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    });
    dataRef.current = {
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    };
    (0, $8P7DW.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if (notifyApp === null || lastProcessedChange === null) return;
        const changeId = lastProcessedChange.changeId;
        notifyApp({
            changedFieldId: lastProcessedChange.fieldId,
            changeId: changeId,
            currentFormState: (0, $lSG07.filterFormDataBasedOnScopes)(dataRef.current.currentFormState, dataRef.current.viewType, dataRef.current.moduleScopes),
            currentScreenTabsState: (0, $hm3Li.filterScreenTabsBasedOnReadScopes)(dataRef.current.moduleScopes, dataRef.current.currentScreenTabsState),
            uiModifications: dataRef.current.uiModifications
        });
        (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'change',
                viewType: dataRef.current.viewType
            }
        });
    }, [
        viewType,
        createAnalyticsEvent,
        lastProcessedChange
    ]);
    return (0, $8P7DW.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("dx60X", function(module, exports) {
$parcel$export(module.exports, "useCurrentFormState", () => $a85534b5c0ff0404$export$655680d54d70050d);

var $lJS87 = parcelRequire("lJS87");
var $6xLCs = parcelRequire("6xLCs");

var $2FT8E = parcelRequire("2FT8E");
const $a85534b5c0ff0404$var$stableEmpty = {};
const $a85534b5c0ff0404$var$stableEmptyScreenTabsArrray = [];
const $a85534b5c0ff0404$var$selectCurrentFormState = (0, $lJS87.createSelector)((state)=>state.formData, (state)=>state.screenTabs, (formData, screenTabs)=>{
    if (formData !== null) return {
        currentFormState: formData,
        currentScreenTabsState: screenTabs || $a85534b5c0ff0404$var$stableEmptyScreenTabsArrray
    };
    return {
        currentFormState: $a85534b5c0ff0404$var$stableEmpty,
        currentScreenTabsState: $a85534b5c0ff0404$var$stableEmptyScreenTabsArrray
    };
});
const $a85534b5c0ff0404$export$655680d54d70050d = (0, $6xLCs.createStateHook)((0, $2FT8E.store), {
    selector: $a85534b5c0ff0404$var$selectCurrentFormState
});

});

parcelRegister("llMWs", function(module, exports) {
$parcel$export(module.exports, "useLastProcessedChange", () => $f4b4fc7573ece4fc$export$e5124fbd2a3221d);

var $6xLCs = parcelRequire("6xLCs");

var $2FT8E = parcelRequire("2FT8E");
const $f4b4fc7573ece4fc$export$e5124fbd2a3221d = (0, $6xLCs.createStateHook)((0, $2FT8E.store), {
    // We need to wrap the selected slice of state to overcome react-sweet-state useHook with selector issue.
    // We rely on the strict equality of lastUserTriggeredChange (the structure of this object
    // will not change on consecutive updates to a given field but the reference will)
    // https://github.com/atlassian/react-sweet-state/issues/167
    selector: (state)=>({
            lastProcessedChange: state.lastProcessedChange
        })
});

});

parcelRegister("lSG07", function(module, exports) {
$parcel$export(module.exports, "filterFormDataBasedOnScopes", () => $9ce2368605e0c8cf$export$cd9f8248b807046e);
$parcel$export(module.exports, "filterFieldsChangesBasedOnScopes", () => $9ce2368605e0c8cf$export$51fbc854b278b1ff);

var $8MVOi = parcelRequire("8MVOi");
const $9ce2368605e0c8cf$export$4596199abc4d582e = (viewType, fieldType, moduleScopes)=>{
    var _getSupportedFieldCon;
    const fieldRequiredScopes = (_getSupportedFieldCon = (0, $8MVOi.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.requiredScopes;
    if (!fieldRequiredScopes) return true;
    const includeCoarseScopes = ()=>fieldRequiredScopes.coarse.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
    const includeGranularScopes = ()=>fieldRequiredScopes.granular.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
    return includeCoarseScopes() || includeGranularScopes();
};
const $9ce2368605e0c8cf$export$cd9f8248b807046e = (formData, viewType, moduleScopes)=>{
    const formDataAsArray = Object.entries(formData);
    const filteredFormDataArray = formDataAsArray.filter(([_, value])=>{
        if (!(value !== null && value !== void 0 && value.fieldType)) return false;
        const { fieldType: fieldType } = value;
        return $9ce2368605e0c8cf$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFormDataArray);
};
const $9ce2368605e0c8cf$export$51fbc854b278b1ff = (fieldsChanges, formData, viewType, moduleScopes)=>{
    const fieldsChangesAsArray = Object.entries(fieldsChanges);
    const filteredFieldsChangesArray = fieldsChangesAsArray.filter(([fieldId])=>{
        const field = formData[fieldId];
        const fieldType = field === null || field === void 0 ? void 0 : field.fieldType;
        if (!fieldType) return false;
        return $9ce2368605e0c8cf$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFieldsChangesArray);
};

});

parcelRegister("hm3Li", function(module, exports) {
$parcel$export(module.exports, "filterScreenTabsBasedOnReadScopes", () => $61a4b31351747ac4$export$e0e73d6641eefd01);
$parcel$export(module.exports, "moduleIncludesScreenTabsWriteScopes", () => $61a4b31351747ac4$export$6a622a0cc96dcad7);

var $5UAqR = parcelRequire("5UAqR");

var $3ZsM1 = parcelRequire("3ZsM1");
const $61a4b31351747ac4$var$includeCoarseScopes = (requiredScopes, moduleScopes)=>requiredScopes.coarse.length > 0 && requiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $61a4b31351747ac4$var$includeGranularScopes = (requiredScopes, moduleScopes)=>requiredScopes.granular.length > 0 && requiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $61a4b31351747ac4$export$e0e73d6641eefd01 = (moduleScopes, screenTabs)=>{
    if ($61a4b31351747ac4$var$includeCoarseScopes((0, $3ZsM1.baseRequiredReadScopes), moduleScopes) || $61a4b31351747ac4$var$includeGranularScopes((0, $3ZsM1.baseRequiredReadScopes), moduleScopes)) return screenTabs;
    return [];
};
const $61a4b31351747ac4$export$6a622a0cc96dcad7 = (viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)=>{
    if ($61a4b31351747ac4$var$includeCoarseScopes((0, $3ZsM1.baseRequiredWriteScopes), moduleScopes) || $61a4b31351747ac4$var$includeGranularScopes((0, $3ZsM1.baseRequiredWriteScopes), moduleScopes)) return true;
    if (Array.isArray(screenTabsChanges) && screenTabsChanges.length > 0) (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'missingScope',
        actionSubject: 'jiraUiModifications.screenTabs',
        attributes: {
            access: 'write',
            viewType: viewType
        }
    });
    return false;
};

});
parcelRegister("3ZsM1", function(module, exports) {
$parcel$export(module.exports, "baseRequiredReadScopes", () => $36918a3bac06a9c9$export$a6bf7d335c3c7d7f);
$parcel$export(module.exports, "baseRequiredWriteScopes", () => $36918a3bac06a9c9$export$1f346456d218ce0a);
// for reference: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-screen-tabs/#api-group-screen-tabs
const $36918a3bac06a9c9$export$a6bf7d335c3c7d7f = {
    granular: [
        'read:screen-tab:jira'
    ],
    coarse: [
        'read:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};
const $36918a3bac06a9c9$export$1f346456d218ce0a = {
    granular: [
        'write:screen-tab:jira'
    ],
    coarse: [
        'write:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};

});



parcelRegister("81uaA", function(module, exports) {
$parcel$export(module.exports, "useOnErrorSubscription", () => $d1ef3342191070e2$export$97d35fd8c60375e4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $cmTnD = parcelRequire("cmTnD");

var $MmGmU = parcelRequire("MmGmU");

var $5UAqR = parcelRequire("5UAqR");

var $kqaua = parcelRequire("kqaua");

var $lqPpg = parcelRequire("lqPpg");

var $2FT8E = parcelRequire("2FT8E");
const $d1ef3342191070e2$export$97d35fd8c60375e4 = ({ appId: appId })=>{
    const viewType = (0, $lqPpg.useViewType)();
    const notifyAppRef = (0, $8P7DW.useRef)(null);
    const { appErrors: appErrors } = (0, $kqaua.useAppErrors)({
        appId: appId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { resetAppErrors: resetAppErrors } = (0, $2FT8E.useIssueAdjustmentsActions)();
    (0, $8P7DW.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cmTnD)))(appId) || notifyApp === null || appErrors === null) return;
        notifyApp({
            errors: appErrors
        });
        (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'appError',
                viewType: viewType
            }
        });
        resetAppErrors({
            appId: appId
        });
    }, [
        createAnalyticsEvent,
        resetAppErrors,
        appErrors,
        appId,
        viewType
    ]);
    return (0, $8P7DW.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("kqaua", function(module, exports) {
$parcel$export(module.exports, "useAppErrors", () => $7425021be636ae32$export$535312244836989b);

var $6xLCs = parcelRequire("6xLCs");

var $2FT8E = parcelRequire("2FT8E");
const $7425021be636ae32$export$535312244836989b = (0, $6xLCs.createStateHook)((0, $2FT8E.store), {
    selector: (state, { appId: appId })=>({
            appErrors: state.appsErrors[appId] ?? null
        })
});

});


parcelRegister("8Dw5s", function(module, exports) {
$parcel$export(module.exports, "useOnInit", () => $cc72472e165a95ae$export$e09230681aa762b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $5UAqR = parcelRequire("5UAqR");

var $jnvCE = parcelRequire("jnvCE");

var $lqPpg = parcelRequire("lqPpg");

var $2FT8E = parcelRequire("2FT8E");

var $8MVOi = parcelRequire("8MVOi");

var $lSG07 = parcelRequire("lSG07");

var $hm3Li = parcelRequire("hm3Li");
const $cc72472e165a95ae$var$successTabsInitialisation = (createAnalyticsEvent, viewType, screenTabsData)=>{
    if (screenTabsData.length) (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'success',
        actionSubject: 'jiraUiModifications.screenTabsInitialization',
        attributes: {
            initializedTabsCount: screenTabsData.length,
            viewType: viewType
        }
    });
};
const $cc72472e165a95ae$export$e09230681aa762b4 = ({ moduleScopes: moduleScopes })=>{
    const resolveOnInitPromise = (0, $8P7DW.useRef)(null);
    const viewType = (0, $lqPpg.useViewType)();
    const publicUIMDataForApp = (0, $jnvCE.useReadyPublicDataForOnInit)({
        viewType: viewType
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { successFieldsInitalisation: successFieldsInitalisation } = (0, $2FT8E.useIssueAdjustmentsActions)();
    const onInitPromise = (0, $8P7DW.useMemo)(()=>{
        const promise = new Promise((resolve)=>{
            resolveOnInitPromise.current = resolve;
        });
        promise.then(()=>{
            // It cleans the resolveOnInitPromise to avoid calling the body
            // of the below useEffect after the onInit being resolved once.
            resolveOnInitPromise.current = null;
        });
        return promise;
    }, []);
    (0, $8P7DW.useEffect)(()=>{
        const handleChange = resolveOnInitPromise.current;
        if (publicUIMDataForApp === null || handleChange === null) return;
        const payload = {
            currentFormState: (0, $lSG07.filterFormDataBasedOnScopes)(publicUIMDataForApp.formData, viewType, moduleScopes),
            currentScreenTabsState: (0, $hm3Li.filterScreenTabsBasedOnReadScopes)(moduleScopes, publicUIMDataForApp.screenTabsData)
        };
        handleChange(payload);
        successFieldsInitalisation({
            createAnalyticsEvent: createAnalyticsEvent
        });
        (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'init',
                viewType: viewType
            }
        });
        $cc72472e165a95ae$var$successTabsInitialisation(createAnalyticsEvent, viewType, publicUIMDataForApp.screenTabsData);
        (0, $8MVOi.getAnalytics)(viewType).markOnInitResolved();
    }, [
        successFieldsInitalisation,
        createAnalyticsEvent,
        publicUIMDataForApp,
        moduleScopes,
        viewType
    ]);
    return {
        onInitPromise: onInitPromise
    };
};

});
parcelRegister("jnvCE", function(module, exports) {
$parcel$export(module.exports, "useReadyPublicDataForOnInit", () => $3a3cf88908465539$export$484a467ba25fea19);

var $6xLCs = parcelRequire("6xLCs");

var $2FT8E = parcelRequire("2FT8E");

var $3aXNe = parcelRequire("3aXNe");
const $3a3cf88908465539$export$484a467ba25fea19 = (0, $6xLCs.createStateHook)((0, $2FT8E.store), {
    selector: (0, $3aXNe.selectReadyPublicDataForOnInit)
});

});


parcelRegister("icM5S", function(module, exports) {
$parcel$export(module.exports, "useRegisterFields", () => $358337a246d2e260$export$fe9a0f40214d6955);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $lqPpg = parcelRequire("lqPpg");

var $2FT8E = parcelRequire("2FT8E");

var $8MVOi = parcelRequire("8MVOi");
const $358337a246d2e260$export$fe9a0f40214d6955 = ({ appId: appId })=>{
    const { setError: setError, registerFields: registerFields } = (0, $2FT8E.useIssueAdjustmentsActions)();
    const viewType = (0, $lqPpg.useViewType)();
    return (0, $8P7DW.useCallback)(async ({ fields: fields, changeId: changeId })=>{
        try {
            // We want to register only fields that are strings.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const validFieldIds = fields.filter((fieldId)=>typeof fieldId === 'string');
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            if (typeof changeId === 'string') registerFields({
                changeId: changeId,
                fieldsToBeRegistered: validFieldIds,
                appId: appId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_REGISTER_FIELDS_ERROR_CODE'
            });
            throw err;
        } finally{
            (0, $8MVOi.getAnalytics)(viewType).markFieldsRegistered();
        }
    }, [
        appId,
        registerFields,
        setError,
        viewType
    ]);
};

});

parcelRegister("gFuOr", function(module, exports) {
$parcel$export(module.exports, "useSubmit", () => $349b38ee19a4da83$export$47c85c6e3a081d3);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $h3cOB = parcelRequire("h3cOB");

var $MmGmU = parcelRequire("MmGmU");

var $cP8g6 = parcelRequire("cP8g6");
var $5UAqR = parcelRequire("5UAqR");
var $13gkp = parcelRequire("13gkp");

var $4NzXn = parcelRequire("4NzXn");

var $6jxX5 = parcelRequire("6jxX5");

var $hOkwG = parcelRequire("hOkwG");

var $3gNUj = parcelRequire("3gNUj");

var $2cjiH = parcelRequire("2cjiH");

var $llMWs = parcelRequire("llMWs");

var $lqPpg = parcelRequire("lqPpg");

var $2FT8E = parcelRequire("2FT8E");

var $1mKkC = parcelRequire("1mKkC");

var $8hPak = parcelRequire("8hPak");

var $8MVOi = parcelRequire("8MVOi");

var $hm3Li = parcelRequire("hm3Li");

var $5Kg62 = parcelRequire("5Kg62");

var $jxbhS = parcelRequire("jxbhS");
const $349b38ee19a4da83$export$47c85c6e3a081d3 = ({ moduleScopes: moduleScopes, appId: appId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { updateFields: updateFields, setError: setError, unregisterFields: unregisterFields, setAppErrors: setAppErrors, updateScreenTabs: updateScreenTabs, detectAppliedChangesConflicts: detectAppliedChangesConflicts } = (0, $2FT8E.useIssueAdjustmentsActions)();
    const viewType = (0, $lqPpg.useViewType)();
    const getAsyncLookupData = (0, $3gNUj.useLookupFieldData)();
    const getFilteredFieldChangesBasedOnScope = (0, $jxbhS.useFilterFieldChangesBasedOnScope)(moduleScopes);
    const tenantContext = (0, $8hPak.useTenantContext)();
    const executionContext = (0, $hOkwG.useExecutionContext)();
    const environment = (0, $h3cOB.useRelayEnvironment)();
    const getValidatedFieldsChanges = (0, $5Kg62.useFieldsChangesValidation)();
    const { lastProcessedChange: lastProcessedChange } = (0, $llMWs.useLastProcessedChange)();
    const lastChangedProcessRef = (0, $8P7DW.useRef)(lastProcessedChange);
    const formMetadata = (0, $2cjiH.useFormMetadata)();
    const formMetadataRef = (0, $8P7DW.useRef)(formMetadata);
    formMetadataRef.current = formMetadata;
    (0, $8P7DW.useEffect)(()=>{
        lastChangedProcessRef.current = lastProcessedChange;
    }, [
        lastProcessedChange
    ]);
    const intl = (0, $k7INq.default)();
    const getFieldAttributesForAnalytics = (0, $8P7DW.useCallback)((fieldsChanges)=>{
        try {
            const fieldAttributes = [];
            for(const fieldId in fieldsChanges){
                var _formMetadataRef$curr;
                if ((_formMetadataRef$curr = formMetadataRef.current) !== null && _formMetadataRef$curr !== void 0 && _formMetadataRef$curr[fieldId]) {
                    const { fieldType: fieldType } = formMetadataRef.current[fieldId];
                    const attributes = Object.keys(fieldsChanges[fieldId]);
                    fieldAttributes.push({
                        fieldType: fieldType,
                        attributes: attributes
                    });
                }
            }
            return JSON.stringify(fieldAttributes);
        // oxlint-disable-next-line no-unused-vars
        } catch (_error) {
            return 'NULL';
        }
    }, []);
    return (0, $8P7DW.useCallback)(async ({ fieldsChanges: fieldsChangesUnnormalized, screenTabsChanges: screenTabsChanges, changeId: changeId })=>{
        let isSameFieldValueChanged = false;
        let fieldType = null;
        try {
            var _lastChangedProcessRe, _formMetadataRef$curr2;
            const fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            const validatedFieldsChanges = await getValidatedFieldsChanges(fieldsChanges);
            const lookupDataFromApi = await getAsyncLookupData(validatedFieldsChanges);
            await updateFields({
                changeId: changeId,
                fieldsChanges: fieldsChanges,
                lookupDataFromApi: // TODO: We should pass validatedFieldsChanges instead of fieldsChanges, UIM-2214
                lookupDataFromApi,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                appId: appId,
                intl: intl,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (screenTabsChanges && (0, $hm3Li.moduleIncludesScreenTabsWriteScopes)(viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)) updateScreenTabs({
                screenTabsChanges: screenTabsChanges,
                appId: appId,
                changeId: changeId
            });
            detectAppliedChangesConflicts({
                appId: appId,
                changeId: changeId
            });
            (0, $8MVOi.getAnalytics)(viewType).stopTTI({
                completionStatus: 'success',
                viewType: viewType
            });
            isSameFieldValueChanged = (0, $6jxX5.checkSameFieldValueChanged)(fieldsChanges, lastChangedProcessRef.current, changeId);
            if ((_lastChangedProcessRe = lastChangedProcessRef.current) !== null && _lastChangedProcessRe !== void 0 && _lastChangedProcessRe.fieldId && (_formMetadataRef$curr2 = formMetadataRef.current) !== null && _formMetadataRef$curr2 !== void 0 && _formMetadataRef$curr2[lastChangedProcessRef.current.fieldId]) {
                const fieldId = lastChangedProcessRef.current.fieldId;
                const { fieldType: fieldTypeFromFormMetadata } = formMetadataRef.current[fieldId];
                fieldType = fieldTypeFromFormMetadata;
            }
            (0, $13gkp.fireTrackEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: `${viewType}jiraUiModificationsUseSubmit`,
                attributes: {
                    isSameFieldValueChanged: isSameFieldValueChanged,
                    isOnInit: changeId === (0, $4NzXn.ON_INIT_CHANGE_ID),
                    fieldType: fieldType,
                    submittedFields: getFieldAttributesForAnalytics(fieldsChanges)
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_SUBMIT_ERROR_CODE'
            });
            (0, $8MVOi.getAnalytics)(viewType).stopTTI({
                completionStatus: 'error',
                viewType: viewType
            });
            if (err instanceof (0, $1mKkC.UiModificationsValidationError)) {
                (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'failed',
                    actionSubject: 'jiraUiModifications.changesValidation',
                    attributes: {
                        type: err.validationErrorType,
                        ...err.attributes,
                        viewType: viewType
                    }
                });
                // Setting app errors to pass them to the onErrorCallback
                setAppErrors({
                    errors: err.attributes.errors,
                    appId: appId
                });
                return;
            }
            (0, $cP8g6.fireErrorAnalytics)({
                error: err,
                id: 'useSubmit',
                viewType: viewType,
                attributes: {
                    errorCause: err === null || err === void 0 ? void 0 : err.cause,
                    isSameFieldValueChanged: isSameFieldValueChanged,
                    isOnInit: changeId === (0, $4NzXn.ON_INIT_CHANGE_ID),
                    fieldType: fieldType
                },
                event: createAnalyticsEvent({})
            });
        } finally{
            unregisterFields({
                changeId: changeId,
                appId: appId
            });
        }
    }, [
        getFilteredFieldChangesBasedOnScope,
        getValidatedFieldsChanges,
        getAsyncLookupData,
        updateFields,
        tenantContext,
        executionContext,
        environment,
        appId,
        intl,
        viewType,
        createAnalyticsEvent,
        moduleScopes,
        updateScreenTabs,
        detectAppliedChangesConflicts,
        setError,
        setAppErrors,
        unregisterFields,
        getFieldAttributesForAnalytics
    ]);
};

});
parcelRegister("13gkp", function(module, exports) {
$parcel$export(module.exports, "fireTrackEvent", () => $77a5b6d54728ef5e$export$574d2f19a52d67ca);

var $5yo3H = parcelRequire("5yo3H");

var $17wqU = parcelRequire("17wqU");

var $gqRjh = parcelRequire("gqRjh");
const $77a5b6d54728ef5e$export$574d2f19a52d67ca = (createAnalyticsEvent, eventPayload)=>{
    (0, $5yo3H.default)((0, $gqRjh.UI_MODIFICATIONS_ANALYTICS_CHANNEL))({
        ...eventPayload,
        analyticsType: (0, $17wqU.TRACK_EVENT_TYPE)
    })(createAnalyticsEvent);
};

});

parcelRegister("3gNUj", function(module, exports) {
$parcel$export(module.exports, "useLookupFieldData", () => $035bac90600e49e8$export$d43e9e394c54e784);

var $8P7DW = parcelRequire("8P7DW");

var $cw4ow = parcelRequire("cw4ow");

var $h3cOB = parcelRequire("h3cOB");

var $MmGmU = parcelRequire("MmGmU");

var $l1rhI = parcelRequire("l1rhI");

var $bxCcT = parcelRequire("bxCcT");

var $fZamC = parcelRequire("fZamC");

var $k3oJI = parcelRequire("k3oJI");

var $7jIqD = parcelRequire("7jIqD");

var $2cjiH = parcelRequire("2cjiH");

var $lqPpg = parcelRequire("lqPpg");

var $8hPak = parcelRequire("8hPak");

var $8MVOi = parcelRequire("8MVOi");
const $035bac90600e49e8$export$d43e9e394c54e784 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $8hPak.useTenantContext)();
    const environment = (0, $h3cOB.useRelayEnvironment)();
    const formMetadata = (0, $2cjiH.useFormMetadata)();
    const formMetadataRef = (0, $8P7DW.useRef)(formMetadata);
    const viewType = (0, $lqPpg.useViewType)();
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ formMetadataRef.current = formMetadata;
    return (0, $8P7DW.useCallback)(async (fieldsChanges)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const lookupData = {};
        const asyncFieldsValues = Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldData])=>{
            if (!formMetadataRef.current[fieldId]) return acc;
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValue = fieldData.value;
            const supportedFieldsConfiguration = (0, $8MVOi.getSupportedFieldConfiguration)(viewType, fieldType);
            const lookupSource = supportedFieldsConfiguration === null || supportedFieldsConfiguration === void 0 ? void 0 : supportedFieldsConfiguration.lookupSource;
            const isUserLookupField = lookupSource === (0, $l1rhI.LOOKUP_SOURCE_USERS_ASYNC_DATA);
            const isProjectLookupField = lookupSource === (0, $l1rhI.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA);
            if (isUserLookupField && fieldValue && (0, $bxCcT.isNotAutomaticId)(fieldValue)) {
                const currentAccountIds = acc.accountIds ? [
                    ...acc.accountIds
                ] : [];
                const newAccountIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.accountIds = [
                    ...currentAccountIds,
                    ...newAccountIds
                ];
            }
            if (isProjectLookupField && fieldValue) {
                const currentProjectIds = acc.projectIds ? [
                    ...acc.projectIds
                ] : [];
                const newProjectIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.projectIds = [
                    ...currentProjectIds,
                    ...newProjectIds
                ];
            }
            /** Add extra checks to add other lookup type e.g. issues lookup */ return acc;
        }, {});
        let users = [];
        let projects = [];
        if (asyncFieldsValues.accountIds) {
            const uniqueAccountIds = (0, (/*@__PURE__*/$parcel$interopDefault($cw4ow)))(asyncFieldsValues.accountIds);
            users = await (0, $7jIqD.fetchUsers)(environment, uniqueAccountIds, createAnalyticsEvent);
        }
        if (asyncFieldsValues.projectIds) {
            const uniqueProjectIds = (0, (/*@__PURE__*/$parcel$interopDefault($cw4ow)))(asyncFieldsValues.projectIds);
            // Convert numeric project IDs to ARIs before fetching
            // GraphQL expects ARIs like "ari:cloud:jira:{cloudId}:project/10001", not plain "10001"
            const projectAris = (0, $fZamC.convertProjectIdsToAris)(uniqueProjectIds, cloudId);
            projects = await (0, $k3oJI.fetchProjects)(environment, projectAris, createAnalyticsEvent);
        }
        lookupData[0, $l1rhI.LOOKUP_SOURCE_USERS_ASYNC_DATA] = users;
        lookupData[0, $l1rhI.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA] = projects;
        return lookupData;
    }, [
        createAnalyticsEvent,
        viewType,
        environment,
        cloudId
    ]);
};

});
parcelRegister("fZamC", function(module, exports) {
$parcel$export(module.exports, "convertProjectIdsToAris", () => $626c9e326c609286$export$2a73bd4f6cc71a00);
/**
 * Converts a project ID to a Jira project ARI.
 *
 * @param projectId - The project ID (numeric string like "10001" or already an ARI)
 * @param cloudId - The cloud/tenant ID
 * @returns The full project ARI in format "ari:cloud:jira:{cloudId}:project/{projectId}"
 *
 * @example
 * ```typescript
 * convertProjectIdToAri("10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001"
 *
 * convertProjectIdToAri("ari:cloud:jira:abc-123-def:project/10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001" (unchanged)
 * ```
 */ const $626c9e326c609286$export$fee909b034ddb326 = (projectId, cloudId)=>{
    // If already an ARI, return as-is
    if (projectId.startsWith('ari:')) return projectId;
    // Convert numeric project ID to ARI format
    return `ari:cloud:jira:${cloudId}:project/${projectId}`;
};
const $626c9e326c609286$export$2a73bd4f6cc71a00 = (projectIds, cloudId)=>{
    return projectIds.map((id)=>$626c9e326c609286$export$fee909b034ddb326(id, cloudId));
};

});

parcelRegister("k3oJI", function(module, exports) {
$parcel$export(module.exports, "fetchProjects", () => $be24f09839279e3b$export$f0d2ca471cdb99b0);

var $cdLn7 = parcelRequire("cdLn7");

var $h3cOB = parcelRequire("h3cOB");

var $5UAqR = parcelRequire("5UAqR");

var $47Gwl = parcelRequire("47Gwl");
const $be24f09839279e3b$export$f0d2ca471cdb99b0 = async (environment, projectIds, createAnalyticsEvent)=>{
    try {
        var _response$jira;
        const apiStartTime = performance.now();
        const response = await (0, $h3cOB.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $cdLn7.default), {
            projectIds: projectIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!(response !== null && response !== void 0 && (_response$jira = response.jira) !== null && _response$jira !== void 0 && _response$jira.jiraProjects)) throw new (0, $47Gwl.ErrorWithStatusCode)('[fetch-projects service] [fetchProjectsQuery]: Property jira.jiraProjects does not exist.', {
            cause: 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY'
        }, 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchProjects',
            attributes: {
                projectsAPILatency: apiLatencyMs
            }
        });
        return response.jira.jiraProjects.filter((project)=>project !== null && project !== undefined && project.projectId !== null && project.projectId !== undefined).map((project)=>{
            var _project$avatar;
            return {
                // Use projectId (numeric ID like "10001"), not id (ARI)
                id: project.projectId,
                key: project.key,
                name: project.name,
                avatarUrls: {
                    '48x48': ((_project$avatar = project.avatar) === null || _project$avatar === void 0 ? void 0 : _project$avatar.large) || ''
                }
            };
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_PROJECTS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("cdLn7", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4df8b2e6c4ae846$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c528121b3b3629597112003cf32c4d44>>
 * @relayHash 8dddd1ce7676474299e324ca788770e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e
const $f4df8b2e6c4ae846$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ids",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jiraProjects",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e",
            "metadata": {},
            "name": "fetchProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f4df8b2e6c4ae846$var$node.hash = "bfbd83d6cfdfb7072506c62a347912b6";
var $f4df8b2e6c4ae846$export$2e2bcd8739ae039 = $f4df8b2e6c4ae846$var$node;

});

parcelRegister("47Gwl", function(module, exports) {
$parcel$export(module.exports, "ErrorWithStatusCode", () => $820a475b5cdc187c$export$13144d723cf04c);
class $820a475b5cdc187c$export$13144d723cf04c extends Error {
    constructor(message, options, statusCode){
        super(message, options);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("7jIqD", function(module, exports) {
$parcel$export(module.exports, "fetchUsers", () => $ac059086c5cfbd96$export$2bb8333a9210be15);

var $a0MP1 = parcelRequire("a0MP1");

var $h3cOB = parcelRequire("h3cOB");

var $5UAqR = parcelRequire("5UAqR");

var $47Gwl = parcelRequire("47Gwl");
const $ac059086c5cfbd96$export$2bb8333a9210be15 = async (environment, accountIds, createAnalyticsEvent)=>{
    try {
        const apiStartTime = performance.now();
        const response = await (0, $h3cOB.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $a0MP1.default), {
            accountIds: accountIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!(response !== null && response !== void 0 && response.users)) throw new (0, $47Gwl.ErrorWithStatusCode)('[fetch-users service] [fetchUsersQuery]: Property users does not exist.', {
            cause: 'FETCH_USERS_MISSING_USERS_PROPERTY'
        }, 'FETCH_USERS_MISSING_USERS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchUsers',
            attributes: {
                usersAPILatency: apiLatencyMs
            }
        });
        return [
            ...response.users
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_USERS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("a0MP1", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c43aeb1d8e1441c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9d3192d2f33102ad25f7c36f20d412b>>
 * @relayHash 8d49f086e404cd774990851cc2a7daa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def
const $6c43aeb1d8e1441c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def",
            "metadata": {},
            "name": "fetchUsersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6c43aeb1d8e1441c$var$node.hash = "55c7a5d564d3036b3714730d97d87482";
var $6c43aeb1d8e1441c$export$2e2bcd8739ae039 = $6c43aeb1d8e1441c$var$node;

});


parcelRegister("2cjiH", function(module, exports) {
$parcel$export(module.exports, "useFormMetadata", () => $0f3ec1548ea46f93$export$863414fa128cb7ef);

var $lJS87 = parcelRequire("lJS87");
var $6xLCs = parcelRequire("6xLCs");

var $2FT8E = parcelRequire("2FT8E");
const $0f3ec1548ea46f93$var$selectFormMetadata = (0, $lJS87.createSelector)((state)=>state.internalFormMetadata, (metadata)=>metadata);
const $0f3ec1548ea46f93$export$863414fa128cb7ef = (0, $6xLCs.createStateHook)((0, $2FT8E.store), {
    selector: $0f3ec1548ea46f93$var$selectFormMetadata
});

});


parcelRegister("5Kg62", function(module, exports) {
$parcel$export(module.exports, "useFieldsChangesValidation", () => $bdf06fc6012610ab$export$e3505fcc03e08574);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $dx60X = parcelRequire("dx60X");

var $2cjiH = parcelRequire("2cjiH");

var $lqPpg = parcelRequire("lqPpg");

var $1Zkoy = parcelRequire("1Zkoy");

var $1Nl9Y = parcelRequire("1Nl9Y");
const $bdf06fc6012610ab$var$filterInvalidResults = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $bdf06fc6012610ab$var$mapValidResultsToFieldChangesMap = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true) {
            const { data: { fieldId: fieldId, fieldData: fieldData } } = result;
            acc[fieldId] = fieldData;
        }
        return acc;
    }, {});
const $bdf06fc6012610ab$export$e3505fcc03e08574 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const formMetadata = (0, $2cjiH.useFormMetadata)();
    const formMetadataRef = (0, $8P7DW.useRef)(formMetadata);
    const viewType = (0, $lqPpg.useViewType)();
    const { currentFormState: currentFormState } = (0, $dx60X.useCurrentFormState)();
    const currentFormStateRef = (0, $8P7DW.useRef)(currentFormState);
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ formMetadataRef.current = formMetadata;
    currentFormStateRef.current = currentFormState;
    return (0, $8P7DW.useCallback)(async (fieldsChanges)=>{
        const fieldsChangesValidationResult = await Promise.all(Object.entries(fieldsChanges).filter(([fieldId])=>{
            return formMetadataRef.current[fieldId] !== undefined;
        }).map(async ([fieldId, fieldData])=>{
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValidationResult = await (0, $1Nl9Y.validateFieldChanges)({
                fieldType: fieldType,
                fieldId: fieldId,
                viewType: viewType,
                createAnalyticsEvent: createAnalyticsEvent,
                fieldMetadata: formMetadataRef.current[fieldId],
                currentField: currentFormStateRef.current[fieldId],
                fieldFromIframe: fieldData
            });
            if (fieldValidationResult.isValid === false) return fieldValidationResult;
            return {
                ...fieldValidationResult,
                data: {
                    fieldId: fieldId,
                    fieldData: fieldData
                }
            };
        }));
        const failedValidationResults = $bdf06fc6012610ab$var$filterInvalidResults(fieldsChangesValidationResult);
        if (failedValidationResults.length) throw new (0, $1Zkoy.UiModificationsFieldsValidationError)('Validation failed', {
            errors: failedValidationResults.flatMap((result)=>result.errors)
        });
        return $bdf06fc6012610ab$var$mapValidResultsToFieldChangesMap(fieldsChangesValidationResult);
    }, [
        createAnalyticsEvent,
        viewType
    ]);
};

});
parcelRegister("1Nl9Y", function(module, exports) {
$parcel$export(module.exports, "validateFieldChanges", () => $1502b9e5a3ba010f$export$a2b7ddd7c3d0703a);

var $8MVOi = parcelRequire("8MVOi");

var $k4o8g = parcelRequire("k4o8g");

var $8egMW = parcelRequire("8egMW");
const $1502b9e5a3ba010f$export$a2b7ddd7c3d0703a = async ({ fieldType: fieldType, fieldId: fieldId, currentField: currentField, fieldFromIframe: fieldFromIframe, fieldMetadata: fieldMetadata, viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fieldConfiguration = (0, $8MVOi.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
    if (!fieldFromIframe || !fieldValidators) return 0, $k4o8g.VALID_RESULT;
    const validatorsArray = Object.entries(fieldValidators);
    const fieldValidationResults = await Promise.all(validatorsArray.map(async ([propertyName, validate])=>{
        if ((0, $8egMW.isFieldPropertyName)(fieldFromIframe, propertyName)) {
            const propertyValue = fieldFromIframe[propertyName];
            const validationResult = await validate(propertyValue, fieldMetadata, createAnalyticsEvent, {
                currentField: currentField,
                viewType: viewType
            });
            return (0, $8egMW.prepareValidationResult)({
                validationResult: validationResult,
                fieldId: fieldId,
                fieldType: fieldType,
                propertyName: propertyName
            });
        }
        return 0, $k4o8g.VALID_RESULT;
    }));
    const invalidValidationResult = (0, $8egMW.filterInvalidResults)(fieldValidationResults);
    if (invalidValidationResult.length > 0) return {
        isValid: false,
        errors: invalidValidationResult.map((result)=>result.error)
    };
    return 0, $k4o8g.VALID_RESULT;
};

});
parcelRegister("k4o8g", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $532ea6ebe8156ec9$export$ee79e3ab53b8db79);
const $532ea6ebe8156ec9$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("8egMW", function(module, exports) {
$parcel$export(module.exports, "prepareValidationResult", () => $c55b2f98fbcce7f1$export$971a38960a5f1064);
$parcel$export(module.exports, "filterInvalidResults", () => $c55b2f98fbcce7f1$export$ddd005554aecd409);
$parcel$export(module.exports, "isFieldPropertyName", () => $c55b2f98fbcce7f1$export$fd744b06c9068a9e);

var $5O2np = parcelRequire("5O2np");

var $2FW0J = parcelRequire("2FW0J");

var $k4o8g = parcelRequire("k4o8g");
const $c55b2f98fbcce7f1$var$prepareValidationResultByBooleanValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    if (validationResult === false) return {
        isValid: false,
        error: {
            type: (0, $5O2np.FIELD_VALIDATION_ERROR),
            method: (0, $2FW0J.mapFieldPropertyToApiMethod)(propertyName),
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $k4o8g.VALID_RESULT;
};
const $c55b2f98fbcce7f1$var$prepareValidationResultByExtendedValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType })=>{
    if (validationResult.isValid === false) return {
        isValid: false,
        error: {
            type: (0, $5O2np.FIELD_VALIDATION_ERROR),
            method: validationResult.error.method,
            message: validationResult.error.message,
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $k4o8g.VALID_RESULT;
};
const $c55b2f98fbcce7f1$export$971a38960a5f1064 = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    // We will remove the boolean check and old method after changing all validators to return objects
    if (typeof validationResult === 'boolean') return $c55b2f98fbcce7f1$var$prepareValidationResultByBooleanValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType,
        propertyName: propertyName
    });
    return $c55b2f98fbcce7f1$var$prepareValidationResultByExtendedValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType
    });
};
const $c55b2f98fbcce7f1$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $c55b2f98fbcce7f1$export$fd744b06c9068a9e = (fieldFromIframe, propertyName)=>Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName);

});



parcelRegister("jxbhS", function(module, exports) {
$parcel$export(module.exports, "useFilterFieldChangesBasedOnScope", () => $15f12af02c805c38$export$2ee317ef8ccc699f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $dx60X = parcelRequire("dx60X");

var $lqPpg = parcelRequire("lqPpg");

var $lSG07 = parcelRequire("lSG07");
const $15f12af02c805c38$export$2ee317ef8ccc699f = (moduleScopes)=>{
    const { currentFormState: currentFormState } = (0, $dx60X.useCurrentFormState)();
    const currentFormStateRef = (0, $8P7DW.useRef)(currentFormState);
    const viewType = (0, $lqPpg.useViewType)();
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ currentFormStateRef.current = currentFormState;
    return (0, $8P7DW.useCallback)((fieldChanges)=>(0, $lSG07.filterFieldsChangesBasedOnScopes)(fieldChanges, currentFormStateRef.current, viewType, moduleScopes), [
        moduleScopes,
        viewType
    ]);
};

});



parcelRegister("caMvb", function(module, exports) {
$parcel$export(module.exports, "useIframeTimeout", () => $84e28dc64a5b5fc8$export$39fbc0513eb03420);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $7PRFC = parcelRequire("7PRFC");

var $MmGmU = parcelRequire("MmGmU");

var $5UAqR = parcelRequire("5UAqR");

var $lqPpg = parcelRequire("lqPpg");
const $84e28dc64a5b5fc8$export$45f7ef64ce535ffd = 12000;
const $84e28dc64a5b5fc8$export$39fbc0513eb03420 = ({ forgeExtension: forgeExtension })=>{
    const timeoutRef = (0, $8P7DW.useRef)(undefined);
    const callbackRef = (0, $8P7DW.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($7PRFC))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const viewType = (0, $lqPpg.useViewType)();
    const onTimeout = (0, $8P7DW.useCallback)(()=>{
        const { id: id } = forgeExtension;
        (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'failed',
            actionSubject: 'jiraUiModifications.iframeTimeout',
            attributes: {
                timeoutAfter: `${$84e28dc64a5b5fc8$export$45f7ef64ce535ffd / 1000}s`,
                extensionId: id,
                viewType: viewType
            }
        });
    }, [
        forgeExtension,
        viewType,
        createAnalyticsEvent
    ]);
    (0, $8P7DW.useEffect)(()=>{
        callbackRef.current = onTimeout;
    }, [
        onTimeout
    ]);
    const setLoadingComplete = (0, $8P7DW.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
    }, []);
    (0, $8P7DW.useEffect)(()=>{
        // For details on why we need to evaluate the callback in this way, see
        // https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/#explanation
        // tl;dr: it allows the latest version of `onTimeout` to be called, without
        // needing to cancel and start a new timer each time dependencies change
        const callback = ()=>callbackRef.current();
        timeoutRef.current = setTimeout(callback, $84e28dc64a5b5fc8$export$45f7ef64ce535ffd);
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    return {
        setLoadingComplete: setLoadingComplete
    };
};

});

parcelRegister("4xYAk", function(module, exports) {
$parcel$export(module.exports, "useScopeChecks", () => $bec91fcf862ed80a$export$5b312a37a22a70a8);

var $5opUz = parcelRequire("5opUz");
const $bec91fcf862ed80a$export$5b312a37a22a70a8 = (appInstallationScopes)=>{
    if (appInstallationScopes) {
        const appHasAllRequiredCoarseScopes = (0, $5opUz.REQUIRED_COARSE_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
        if (appHasAllRequiredCoarseScopes) return true;
        return (0, $5opUz.REQUIRED_GRANULAR_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
    }
    return false;
};

});
parcelRegister("5opUz", function(module, exports) {
$parcel$export(module.exports, "REQUIRED_GRANULAR_SCOPES", () => $c6560f7d031c3596$export$81920d3428c141d1);
$parcel$export(module.exports, "REQUIRED_COARSE_SCOPES", () => $c6560f7d031c3596$export$bdf22b2c717ce672);
// https://hello.atlassian.net/wiki/spaces/unbx/pages/1732638810/RFC+Set+of+scopes+to+be+required+in+UI+modifications+extension+point+in+GIC+location
const $c6560f7d031c3596$export$81920d3428c141d1 = [
    'read:project:jira',
    'read:issue-type:jira',
    'read:user-configuration:jira',
    'read:user:jira',
    'read:issue:jira',
    'read:priority:jira',
    'read:label:jira',
    'read:license:jira',
    'read:field:jira',
    'read:field-configuration:jira',
    'write:field-configuration:jira',
    'write:field.default-value:jira',
    'write:field:jira'
];
const $c6560f7d031c3596$export$bdf22b2c717ce672 = [
    'manage:jira-configuration',
    'read:jira-user',
    'read:jira-work',
    'write:jira-work'
];

});


parcelRegister("sIMef", function(module, exports) {
$parcel$export(module.exports, "useThreeLOPromptProps", () => $03191585297ce85c$export$cb62ba9a2eb7a0b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $MmGmU = parcelRequire("MmGmU");

var $uxUw0 = parcelRequire("uxUw0");

var $5UAqR = parcelRequire("5UAqR");

var $2t9fp = parcelRequire("2t9fp");

var $iW8tR = parcelRequire("iW8tR");

var $ex5tK = parcelRequire("ex5tK");

var $lqPpg = parcelRequire("lqPpg");

var $8MVOi = parcelRequire("8MVOi");
const $03191585297ce85c$export$cb62ba9a2eb7a0b4 = ({ forgeExtension: forgeExtension })=>{
    const [hasBeenTracked, setHasBeenTracked] = (0, $8P7DW.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { setUIModificationsConsentStatus: setUIModificationsConsentStatus } = (0, $2t9fp.useAdjustmentsContextActions)();
    const { appId: appId } = (0, $uxUw0.parseExtensionId)(forgeExtension.id);
    const viewType = (0, $lqPpg.useViewType)();
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const currentUIModificationsConsentStatus = (0, $iW8tR.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    const onConsentSuccess = (0, $8P7DW.useCallback)(()=>{
        setUIModificationsConsentStatus({
            appId: appId,
            status: (0, $ex5tK.UIM_CONSENT_CONSENTED)
        });
        (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'cleared',
            actionSubject: 'jiraUiModificationsObligatoryConsent'
        });
    }, [
        appId,
        createAnalyticsEvent,
        setUIModificationsConsentStatus
    ]);
    const onConsentInitialization = (0, $8P7DW.useCallback)(()=>{
        if (currentUIModificationsConsentStatus === (0, $ex5tK.UIM_CONSENT_UNKNOWN)) {
            setUIModificationsConsentStatus({
                appId: appId,
                status: (0, $ex5tK.UIM_CONSENT_REQUIRED)
            });
            if (!hasBeenTracked) {
                (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'triggered',
                    actionSubject: 'jiraUiModifications.obligatoryConsent',
                    attributes: {
                        viewType: viewType
                    }
                });
                setHasBeenTracked(true);
            }
        }
    }, [
        appId,
        currentUIModificationsConsentStatus,
        setUIModificationsConsentStatus,
        hasBeenTracked,
        viewType,
        createAnalyticsEvent
    ]);
    const consentMessage = (0, $8P7DW.useMemo)(()=>{
        return formatMessage((0, $8MVOi.getConsentMessage)(viewType), {
            appTitle: forgeExtension.properties.title
        });
    }, [
        formatMessage,
        forgeExtension.properties.title,
        viewType
    ]);
    const threeLOPromptComponentPropsMethods = (0, $8P7DW.useMemo)(()=>({
            onConsentSuccess: onConsentSuccess,
            onConsentInitialization: onConsentInitialization,
            consentMessage: consentMessage
        }), [
        onConsentSuccess,
        onConsentInitialization,
        consentMessage
    ]);
    return threeLOPromptComponentPropsMethods;
};

});

parcelRegister("cn9bZ", function(module, exports) {
$parcel$export(module.exports, "buildExtensionData", () => $b73bdf6df2770d77$export$141a9933f8885d99);

var $4NzXn = parcelRequire("4NzXn");
const $b73bdf6df2770d77$export$141a9933f8885d99 = (executionContext)=>{
    return {
        type: (0, $4NzXn.UI_MODIFICATIONS_MODULE),
        ...executionContext
    };
};

});



parcelRegister("jiCAh", function(module, exports) {
$parcel$export(module.exports, "useAppsToRender", () => $5598d4be58d156e6$export$bef357953bcc2428);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $5UAqR = parcelRequire("5UAqR");

var $2t9fp = parcelRequire("2t9fp");

var $lqPpg = parcelRequire("lqPpg");

var $2FT8E = parcelRequire("2FT8E");

var $5QlKZ = parcelRequire("5QlKZ");

var $bA9HF = parcelRequire("bA9HF");
const $5598d4be58d156e6$export$bef357953bcc2428 = (payload)=>{
    var _data$jira3, _data$jira4, _data$jira6, _data$jira9, _data$jira0;
    const { data: data, executionContextKey: executionContextKey } = payload;
    const { startFieldsInitialisationTimeout: startFieldsInitialisationTimeout } = (0, $2FT8E.useIssueAdjustmentsActions)();
    const { setAdjustmentsAreEnabled: setAdjustmentsAreEnabled, setHasFinishedLoading: setHasFinishedLoading } = (0, $2t9fp.useAdjustmentsContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const viewType = (0, $lqPpg.useViewType)();
    const configuredApps = (0, $8P7DW.useMemo)(()=>{
        var _data$jira, _data$jira2;
        return (0, $bA9HF.getConfiguredApps)((_data$jira = data.jira) === null || _data$jira === void 0 || (_data$jira = _data$jira.forge) === null || _data$jira === void 0 ? void 0 : _data$jira.uiModificationsExtensions, (_data$jira2 = data.jira) === null || _data$jira2 === void 0 ? void 0 : _data$jira2.uiModifications);
    }, [
        (_data$jira3 = data.jira) === null || _data$jira3 === void 0 || (_data$jira3 = _data$jira3.forge) === null || _data$jira3 === void 0 ? void 0 : _data$jira3.uiModificationsExtensions,
        (_data$jira4 = data.jira) === null || _data$jira4 === void 0 ? void 0 : _data$jira4.uiModifications
    ]);
    const appsToRender = (0, $8P7DW.useMemo)(()=>{
        return configuredApps.slice(0, (0, $5QlKZ.MAX_NUMBER_OF_UIM_APPS));
    }, [
        configuredApps
    ]);
    (0, $8P7DW.useEffect)(()=>{
        var _data$jira5;
        if (((_data$jira5 = data.jira) === null || _data$jira5 === void 0 ? void 0 : _data$jira5.uiModifications) !== undefined) setHasFinishedLoading(true);
    }, [
        setHasFinishedLoading,
        (_data$jira6 = data.jira) === null || _data$jira6 === void 0 ? void 0 : _data$jira6.uiModifications
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (appsToRender.length > 0) {
            setAdjustmentsAreEnabled(true);
            startFieldsInitialisationTimeout({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        appsToRender,
        setAdjustmentsAreEnabled,
        startFieldsInitialisationTimeout,
        createAnalyticsEvent
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const configuredAppsCount = configuredApps.length;
        if (configuredAppsCount >= 1) {
            var _data$jira7, _data$jira8;
            (0, $5UAqR.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: 'jiraUiModifications.configuredAppsPerContext',
                attributes: {
                    forgeModulesCount: (_data$jira7 = data.jira) === null || _data$jira7 === void 0 || (_data$jira7 = _data$jira7.forge) === null || _data$jira7 === void 0 ? void 0 : _data$jira7.uiModificationsExtensions.length,
                    uimConfiguredAppCount: (_data$jira8 = data.jira) === null || _data$jira8 === void 0 ? void 0 : _data$jira8.uiModifications.length,
                    configuredAndInstalledApps: configuredAppsCount,
                    areMultipleAppsConfiguredAndInstalled: configuredAppsCount > 1,
                    viewType: viewType
                }
            });
        }
    }, [
        // `executionContextKey` is required to track events when execution context changed
        executionContextKey,
        viewType,
        createAnalyticsEvent,
        configuredApps.length,
        (_data$jira9 = data.jira) === null || _data$jira9 === void 0 || (_data$jira9 = _data$jira9.forge) === null || _data$jira9 === void 0 ? void 0 : _data$jira9.uiModificationsExtensions.length,
        (_data$jira0 = data.jira) === null || _data$jira0 === void 0 ? void 0 : _data$jira0.uiModifications.length
    ]);
    return appsToRender;
};

});
parcelRegister("5QlKZ", function(module, exports) {
$parcel$export(module.exports, "MAX_NUMBER_OF_UIM_APPS", () => $67adce03a98a84ef$export$575c2f3c7fe81caa);
const $67adce03a98a84ef$export$575c2f3c7fe81caa = 5;

});

parcelRegister("bA9HF", function(module, exports) {
$parcel$export(module.exports, "getConfiguredApps", () => $31c78afae88d9690$export$6ead423ef319ea49);

var $ehfUH = parcelRequire("ehfUH");
const $31c78afae88d9690$var$STABLE_EMPTY_ARRAY = [];
const $31c78afae88d9690$export$6ead423ef319ea49 = (forgeExtensions, uiModificationsConfigs)=>{
    if (!forgeExtensions || !uiModificationsConfigs) return $31c78afae88d9690$var$STABLE_EMPTY_ARRAY;
    // Put modules in the HashMap for a fast search & get by appEnvId
    const modulesHashMap = (0, $ehfUH.normalizeExtensions)(forgeExtensions);
    return uiModificationsConfigs.filter((configuration)=>!!modulesHashMap[configuration.appEnvId]).map((configuration)=>({
            forgeExtension: modulesHashMap[configuration.appEnvId],
            uiModificationsConfig: configuration.uiModifications.map(({ id: id, data: data })=>({
                    id: id,
                    data: data
                }))
        }));
};

});
parcelRegister("ehfUH", function(module, exports) {
$parcel$export(module.exports, "normalizeExtensions", () => $1fc29ea1bae19fdd$export$7e2e604b6166a087);

var $uxUw0 = parcelRequire("uxUw0");
const $1fc29ea1bae19fdd$export$7e2e604b6166a087 = (forgeExtensions)=>forgeExtensions.reduce((accumulator, current)=>{
        const { appId: appId, environmentId: envId } = (0, $uxUw0.parseExtensionId)(current.id);
        const combinedAppEnvId = `${appId}/${envId}`;
        // by this condition we make sure the first IA module is rendered (appEnvId key is not overwritten)
        // and integration code is deterministic (if you add a new IA module,
        // the 1st one will be rendered, not the last one)
        if (!accumulator[combinedAppEnvId]) accumulator[combinedAppEnvId] = current;
        return accumulator;
    }, {});

});



parcelRegister("aWCG9", function(module, exports) {
$parcel$export(module.exports, "useContextCleanup", () => $3cd27d46e740fefd$export$c704babd3a8c2350);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $8P7DW = parcelRequire("8P7DW");

var $2t9fp = parcelRequire("2t9fp");

var $lqPpg = parcelRequire("lqPpg");

var $2FT8E = parcelRequire("2FT8E");

var $8MVOi = parcelRequire("8MVOi");
const $3cd27d46e740fefd$export$c704babd3a8c2350 = (payload)=>{
    const { executionContextKey: executionContextKey, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = payload;
    const { resetAllFields: resetAllFields, triggerFieldInitialization: triggerFieldInitialization, setNumberOfSupportedFields: setNumberOfSupportedFields } = (0, $2FT8E.useIssueAdjustmentsActions)();
    const { resetAdjustmentContext: resetAdjustmentContext } = (0, $2t9fp.useAdjustmentsContextActions)();
    const viewType = (0, $lqPpg.useViewType)();
    (0, $8P7DW.useEffect)(()=>{
        if (numberOfSupportedFields !== undefined) setNumberOfSupportedFields(numberOfSupportedFields);
        return ()=>setNumberOfSupportedFields(0);
    }, [
        numberOfSupportedFields,
        setNumberOfSupportedFields
    ]);
    (0, $8P7DW.useEffect)(()=>{
        triggerFieldInitialization();
        return resetAllFields;
    // Whenever the executionContextKey is changed, or the resetFormFieldsCounter
    // is incremented ("create another issue" GIC) we want to reset any data in our store.
    // For "create another issue" `resetFormFieldsCounter` we trigger re-initialization of field data.
    }, [
        executionContextKey,
        resetFormFieldsCounter,
        resetAllFields,
        triggerFieldInitialization
    ]);
    (0, $8P7DW.useEffect)(()=>()=>{
            resetAdjustmentContext();
            (0, $8MVOi.getAnalytics)(viewType).cancelTTI();
        }, // When executionContextKey is changed we reset the AdjustmentsContext because
    // other executionContextKey may not be configured to run UI modifications
    [
        executionContextKey,
        resetAdjustmentContext,
        viewType
    ]);
};

});

parcelRegister("gknhx", function(module, exports) {
$parcel$export(module.exports, "useEnrichedExecutionContext", () => $d5507a33a89ee985$export$649da33b72723913);

var $8P7DW = parcelRequire("8P7DW");

var $lqPpg = parcelRequire("lqPpg");
const $d5507a33a89ee985$export$649da33b72723913 = ({ executionContext: executionContext })=>{
    const viewType = (0, $lqPpg.useViewType)();
    const enrichedExecutionContext = (0, $8P7DW.useMemo)(()=>{
        return executionContext && {
            ...executionContext,
            viewType: viewType
        };
    }, [
        executionContext,
        viewType
    ]);
    return enrichedExecutionContext;
};

});



parcelRegister("iOykB", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRootWithData", () => $cf488f35c4dfd03b$export$56d75038a9162ad6);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8gu7I = parcelRequire("8gu7I");

var $2t9fp = parcelRequire("2t9fp");

var $hOkwG = parcelRequire("hOkwG");

var $lqPpg = parcelRequire("lqPpg");

var $8hPak = parcelRequire("8hPak");

var $8MVOi = parcelRequire("8MVOi");

var $eecjn = parcelRequire("eecjn");

var $jiCAh = parcelRequire("jiCAh");

var $aWCG9 = parcelRequire("aWCG9");

var $gknhx = parcelRequire("gknhx");
const $cf488f35c4dfd03b$export$56d75038a9162ad6 = (props)=>{
    const executionContext = (0, $gknhx.useEnrichedExecutionContext)({
        executionContext: props.executionContext
    });
    const { executionContextKey: executionContextKey, triggerPointKey: triggerPointKey } = props;
    const viewType = (0, $lqPpg.useViewType)();
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $2t9fp.useAdjustmentsContextActions)();
    const shouldLoad = executionContext && executionContextKey && (0, $8MVOi.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $8MVOi.isExecutionContextSupported)(executionContext);
    (0, $8P7DW.useEffect)(()=>{
        if (shouldLoad) setShouldUiModificationsLoad(shouldLoad ? 'yes' : 'no');
    }, [
        setShouldUiModificationsLoad,
        shouldLoad,
        executionContextKey
    ]);
    if (!shouldLoad) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)($cf488f35c4dfd03b$var$RootWithDataCleanup, {
        ...props,
        executionContext: executionContext,
        executionContextKey: executionContextKey
    });
};
const $cf488f35c4dfd03b$var$RootWithDataCleanup = (props)=>{
    const { cloudId: cloudId, activationId: activationId, executionContextKey: executionContextKey, triggerPointKey: triggerPointKey, executionContext: executionContext, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = props;
    (0, $aWCG9.useContextCleanup)({
        executionContextKey: executionContextKey,
        numberOfSupportedFields: numberOfSupportedFields,
        resetFormFieldsCounter: resetFormFieldsCounter
    });
    const tenantContext = (0, $8P7DW.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId
        }), [
        cloudId,
        activationId
    ]);
    const analyticsContextData = (0, $8P7DW.useMemo)(()=>({
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }), [
        triggerPointKey
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8gu7I.default), {
        data: analyticsContextData,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hOkwG.ExecutionContextProvider), {
            value: executionContext,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8hPak.TenantContextProvider), {
                value: tenantContext,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)($cf488f35c4dfd03b$var$RootWithData, {
                    ...props
                })
            })
        })
    });
};
const $cf488f35c4dfd03b$var$RootWithData = ({ uiModificationsData: uiModificationsData, ForgeAppRenderer: ForgeAppRenderer, executionContextKey: executionContextKey })=>{
    const appsToRender = (0, $jiCAh.useAppsToRender)({
        data: uiModificationsData,
        executionContextKey: executionContextKey
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eecjn.AppsRenderer), {
        apps: appsToRender,
        ForgeAppRenderer: ForgeAppRenderer
    });
};

});

parcelRegister("9jNvK", function(module, exports) {
$parcel$export(module.exports, "ForgeAppRenderer", () => $fcb3831fd21f11b5$export$6eef17fe5fde390c);

var $8P7DW = parcelRequire("8P7DW");

var $j6ARI = parcelRequire("j6ARI");

var $7ex17 = parcelRequire("7ex17");

var $cnQrb = parcelRequire("cnQrb");

var $7sII0 = parcelRequire("7sII0");
const $fcb3831fd21f11b5$export$6eef17fe5fde390c = (props)=>{
    const { extension: extension, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cnQrb.ExtensionPointProvider), {
        extensionType: (0, $7ex17.UI_MODIFICATIONS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7sII0.Renderer), {
        ...restProps,
        extension: extension,
        contextTokenType: (0, $j6ARI.ContextTokenType).JIRA
    }));
};

});
parcelRegister("j6ARI", function(module, exports) {
$parcel$export(module.exports, "ALLOWED", () => $40069941e63aacda$export$b4c0bb1de45ab46c);
$parcel$export(module.exports, "BLOCKED", () => $40069941e63aacda$export$c2dfa6e96815ac6b);
$parcel$export(module.exports, "EXTENSION", () => $40069941e63aacda$export$8a7e8af112e5972a);
$parcel$export(module.exports, "ContextTokenType", () => $40069941e63aacda$export$70a9026332abd115);
$parcel$export(module.exports, "AtlassianHelpConfigAccountType", () => $40069941e63aacda$export$5ea1c090b459f41f);
const $40069941e63aacda$export$b4c0bb1de45ab46c = 'ALLOWED';
const $40069941e63aacda$export$c2dfa6e96815ac6b = 'BLOCKED';
const $40069941e63aacda$export$8a7e8af112e5972a = 'extension';
var $40069941e63aacda$export$70a9026332abd115 = /*#__PURE__*/ function(ContextTokenType) {
    ContextTokenType["JSM"] = "JSM";
    ContextTokenType["JIRA"] = "JIRA";
    return ContextTokenType;
}({});
var $40069941e63aacda$export$5ea1c090b459f41f = /*#__PURE__*/ function(AtlassianHelpConfigAccountType) {
    AtlassianHelpConfigAccountType["ATLASSIAN"] = "atlassian";
    AtlassianHelpConfigAccountType["CUSTOMER"] = "customer";
    AtlassianHelpConfigAccountType["ANONYMOUS"] = "anonymous";
    return AtlassianHelpConfigAccountType;
}({});

});

parcelRegister("cnQrb", function(module, exports) {
$parcel$export(module.exports, "ExtensionPointProvider", () => $8a7fa88d8cfa855d$export$80b99728bc3dad9);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $8a7fa88d8cfa855d$export$80b99728bc3dad9 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("4ONlM")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/extension-point-provider/extension-point-provider.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("4ONlM", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("60SLj"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("6bRUf")
]).then(()=>parcelRequire('6DpKo'));

});


parcelRegister("7sII0", function(module, exports) {
$parcel$export(module.exports, "Renderer", () => $31f5dfd19c7c9abe$export$88530751e3977073);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $31f5dfd19c7c9abe$export$88530751e3977073 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("b32Vi")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/renderer/renderer.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("b32Vi", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("gkNMi"),
    $j9MRt("iVY1y"),
    $j9MRt("9hBNq"),
    $j9MRt("2RABw"),
    $j9MRt("4RNdI"),
    $j9MRt("iOgS1"),
    $j9MRt("hVSoa"),
    $j9MRt("cqe51"),
    $j9MRt("399y2"),
    $j9MRt("3XUZk"),
    $j9MRt("fOjDa"),
    $j9MRt("ivo6R"),
    $j9MRt("ikoh2"),
    $j9MRt("60SLj"),
    $j9MRt("ffUPr"),
    $j9MRt("cMr22"),
    $j9MRt("bbtqO")
]).then(()=>parcelRequire('bn95c'));

});




parcelRegister("9blvX", function(module, exports) {
$parcel$export(module.exports, "RovoServiceAgentWidgetInjector", () => $5dd5e98543114f05$export$19e4074f6781b5f7);

var $8P7DW = parcelRequire("8P7DW");

var $edC7N = parcelRequire("edC7N");

var $5jYgE = parcelRequire("5jYgE");

var $MmGmU = parcelRequire("MmGmU");

var $h5gSD = parcelRequire("h5gSD");
var $gvxin = parcelRequire("gvxin");

var $h82Rb = parcelRequire("h82Rb");

var $bZZgp = parcelRequire("bZZgp");

var $bQ8UI = parcelRequire("bQ8UI");
var $8LbZn = parcelRequire("8LbZn");
var $17wqU = parcelRequire("17wqU");

var $1lG1b = parcelRequire("1lG1b");

var $cMlcX = parcelRequire("cMlcX");

var $lKcXx = parcelRequire("lKcXx");
const $5dd5e98543114f05$var$InjectRovoServiceAgentWidgetScript = /*#__PURE__*/ (0, $8P7DW.memo)(function RovoServiceAgentWidget({ siteId: siteId, widgetId: widgetId, surface: surface }) {
    const [error, setError] = (0, $8P7DW.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { locale: locale } = (0, $5jYgE.default)();
    const handleOnOpen = (0, $8P7DW.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/88552
        (0, $8LbZn.fireUIAnalytics)(createAnalyticsEvent({}), 'rovoServiceAgentWidget opened');
    }, [
        createAnalyticsEvent
    ]);
    const handleOnClose = (0, $8P7DW.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/88553
        (0, $8LbZn.fireUIAnalytics)(createAnalyticsEvent({}), 'rovoServiceAgentWidget closed');
    }, [
        createAnalyticsEvent
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const loadScript = async ()=>{
            const startTime = performance.now();
            try {
                setError(null);
                await (0, $lKcXx.loadRovoWidgetSDKScript)({
                    siteId: siteId,
                    widgetId: widgetId,
                    surface: surface,
                    locale: locale,
                    onOpen: handleOnOpen,
                    onClose: handleOnClose
                });
                // Measure widget load time (non-blocking, fire-and-forget)
                const loadDuration = Math.round(performance.now() - startTime);
                (0, $8LbZn.fireOperationalAnalytics)(createAnalyticsEvent({
                    attributes: {
                        surface: surface,
                        duration: loadDuration
                    }
                }), 'rovoServiceAgentWidget scriptLoaded');
            } catch (err) {
                // Measure failed load time (non-blocking)
                const loadDuration = Math.round(performance.now() - startTime);
                (0, $8LbZn.fireOperationalAnalytics)(createAnalyticsEvent({
                    attributes: {
                        surface: surface,
                        duration: loadDuration,
                        error: err instanceof Error ? err.message : 'Unknown error'
                    }
                }), 'rovoServiceAgentWidget scriptFailed');
                setError(err instanceof Error ? err : new Error('Failed to load widget script'));
            }
        };
        // The error handler is inside loadScript, so we don't need to handle it here
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loadScript();
    }, [
        widgetId,
        siteId,
        handleOnClose,
        handleOnOpen,
        surface,
        locale,
        createAnalyticsEvent
    ]);
    (0, $8P7DW.useEffect)(()=>{
        return ()=>{
            (0, $lKcXx.cleanupRovoWidgetSDKScript)();
        };
    }, []);
    if (error) throw error;
    // Return null without blocking UFO experience - widget loads asynchronously
    return null;
});
const $5dd5e98543114f05$export$19e4074f6781b5f7 = ({ siteId: siteId, widgetId: widgetId, surface: surface })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const renderError = (0, $8P7DW.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gvxin.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $h5gSD.default), {
            id: "rovo-widget-error-flag",
            appearance: "error",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
                label: ""
            }),
            title: formatMessage((0, $cMlcX.default).widgetErrorTitle),
            description: formatMessage((0, $cMlcX.default).widgetErrorDescription),
            testId: "rovo-widget-error-flag"
        }));
    }, [
        formatMessage
    ]);
    if ((0, $1lG1b.isFedRamp)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bZZgp.default), {
        name: "rovo-service-agent-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: "rovo-service-agent",
        id: "widget-injector",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bQ8UI.ContextWrapper), {
        sourceName: "rovoServiceAgent",
        sourceType: (0, $17wqU.MODAL),
        attributes: {
            siteId: siteId,
            widgetId: widgetId,
            surface: surface
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($5dd5e98543114f05$var$InjectRovoServiceAgentWidgetScript, {
        siteId: siteId,
        widgetId: widgetId,
        surface: surface
    }))));
};

});
parcelRegister("cMlcX", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3f74c350551e729$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $b3f74c350551e729$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    widgetErrorTitle: {
        id: 'rovo.service-agent.widget.error-boundary.title.non-final',
        defaultMessage: 'Rovo Service Agent widget unavailable',
        description: 'Title for the error flag for when the widget failed to load'
    },
    widgetErrorDescription: {
        id: 'rovo.service-agent.widget.error-boundary.description.non-final',
        defaultMessage: 'The Rovo Service Agent failed to load. Please refresh the page to try again.',
        description: 'Description for the error flag for when the widget failed to load'
    }
});

});

parcelRegister("lKcXx", function(module, exports) {
$parcel$export(module.exports, "loadRovoWidgetSDKScript", () => $66ed32adfa51c85e$export$7547b32d5aede92f);
$parcel$export(module.exports, "cleanupRovoWidgetSDKScript", () => $66ed32adfa51c85e$export$8b3a5cba31576b8a);
let $66ed32adfa51c85e$var$promise = null;
const $66ed32adfa51c85e$var$SCRIPT_ID = 'rovo-service-agent-widget-script';
const $66ed32adfa51c85e$export$7bcdf693772d0a65 = ()=>{
    const q = function WidgetQueue(...args) {
        q.__q__.push(args);
    };
    q.__q__ = [];
    return q;
};
const $66ed32adfa51c85e$export$2319c1f51535cb1c = ()=>{
    if (typeof window === 'undefined') throw new Error('Failed to load CSM SDK: window is undefined');
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const body = document.querySelector('body');
    if (!body) throw new Error('Document body not found');
};
const $66ed32adfa51c85e$export$e0c468a317b25666 = (onOpen, onClose)=>{
    if (typeof window.ROVO_WIDGET === 'undefined') {
        window.ROVO_WIDGET = $66ed32adfa51c85e$export$7bcdf693772d0a65();
        if (onOpen) window.ROVO_WIDGET('onOpen', onOpen);
        if (onClose) window.ROVO_WIDGET('onClose', onClose);
        window.ROVO_WIDGET('open');
    }
};
const $66ed32adfa51c85e$export$bb8c6503cfd42bb6 = ()=>{
    return !!(window.ROVO_WIDGET && !('__q__' in window.ROVO_WIDGET));
};
const $66ed32adfa51c85e$export$8e6c9489c906e450 = (siteId, widgetId, surface, locale)=>{
    const site = window.location.hostname;
    const src = new URL(`https://${site}/rovo/widget/script.js`);
    src.searchParams.set('siteId', siteId);
    src.searchParams.set('site', site);
    src.searchParams.set('widgetId', widgetId);
    src.searchParams.set('surface', surface);
    src.searchParams.set('locale', locale);
    return src.toString();
};
const $66ed32adfa51c85e$export$9b542085e8be8f80 = (resolve, reject)=>{
    if ($66ed32adfa51c85e$export$bb8c6503cfd42bb6()) resolve(window.ROVO_WIDGET);
    else if (window.ROVO_WIDGET && '__q__' in window.ROVO_WIDGET) {
        $66ed32adfa51c85e$export$57f8607478cbbab6();
        if ($66ed32adfa51c85e$export$bb8c6503cfd42bb6()) resolve(window.ROVO_WIDGET);
        else {
            $66ed32adfa51c85e$var$promise = null;
            reject(new Error('SDK failed to initialize properly - still in queue mode'));
        }
    } else {
        $66ed32adfa51c85e$var$promise = null;
        reject(new Error('Failed to load ROVO_WIDGET SDK script: window.ROVO_WIDGET is undefined'));
    }
};
const $66ed32adfa51c85e$export$c20f7df29b9552b6 = (reject)=>{
    $66ed32adfa51c85e$var$promise = null;
    reject(new Error('Failed to load ROVO_WIDGET SDK script: onerror'));
};
const $66ed32adfa51c85e$export$a8c9f8edf0911bff = (scriptURL, resolve, reject)=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    script.id = $66ed32adfa51c85e$var$SCRIPT_ID;
    script.onerror = ()=>$66ed32adfa51c85e$export$c20f7df29b9552b6(reject);
    script.onload = ()=>$66ed32adfa51c85e$export$9b542085e8be8f80(resolve, reject);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const body = document.querySelector('body');
    body === null || body === void 0 || body.appendChild(script);
};
const $66ed32adfa51c85e$export$57f8607478cbbab6 = ()=>{
    if (window.ROVO_WIDGET_REINIT) window.ROVO_WIDGET_REINIT();
};
const $66ed32adfa51c85e$export$7547b32d5aede92f = ({ siteId: siteId, widgetId: widgetId, surface: surface, locale: locale, onOpen: onOpen, onClose: onClose })=>{
    if (!$66ed32adfa51c85e$var$promise) $66ed32adfa51c85e$var$promise = new Promise((resolve, reject)=>{
        try {
            $66ed32adfa51c85e$export$2319c1f51535cb1c();
            $66ed32adfa51c85e$export$e0c468a317b25666(onOpen, onClose);
            // If SDK is already loaded (not a queue), resolve immediately
            if ($66ed32adfa51c85e$export$bb8c6503cfd42bb6()) {
                resolve(window.ROVO_WIDGET);
                return;
            }
            const scriptURL = $66ed32adfa51c85e$export$8e6c9489c906e450(siteId, widgetId, surface, locale);
            $66ed32adfa51c85e$export$a8c9f8edf0911bff(scriptURL, resolve, reject);
        } catch (error) {
            reject(error);
        }
    });
    return $66ed32adfa51c85e$var$promise;
};
const $66ed32adfa51c85e$export$8b3a5cba31576b8a = ()=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const scriptElement = document.getElementById($66ed32adfa51c85e$var$SCRIPT_ID);
    if (scriptElement) // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    document.body.removeChild(scriptElement);
    if (window.ROVO_WIDGET_CLEANUP) window.ROVO_WIDGET_CLEANUP();
    if (window.ROVO_WIDGET) delete window.ROVO_WIDGET;
    // Reset the tracking variables
    $66ed32adfa51c85e$var$promise = null;
};

});


parcelRegister("fgzVg", function(module, exports) {
$parcel$export(module.exports, "HeaderSinglePortalMode", () => (parcelRequire("o7eIo")).default);

var $o7eIo = parcelRequire("o7eIo");

});
parcelRegister("o7eIo", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf133c01e9f12fd7$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("2tsrb");
var $7IL12 = parcelRequire("7IL12");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("jhiA9");
var $fmBB5 = parcelRequire("fmBB5");
const $bf133c01e9f12fd7$var$getPortalName = (state)=>{
    const portalId = (0, $7IL12.getPortalId)(state);
    return portalId ? (0, $73V7l.getName)(state, portalId) : undefined;
};
const $bf133c01e9f12fd7$var$getPortalDescription = (state)=>{
    const portalId = (0, $7IL12.getPortalId)(state);
    return portalId ? (0, $73V7l.getDescription)(state, portalId) : undefined;
};
const $bf133c01e9f12fd7$var$getPortalLogoUrl = (state)=>{
    const portalId = (0, $7IL12.getPortalId)(state);
    return portalId ? (0, $73V7l.getLogoUrl)(state, portalId) : undefined;
};
const $bf133c01e9f12fd7$var$selector = (0, $ehscL.createSelector)($bf133c01e9f12fd7$var$getPortalName, $bf133c01e9f12fd7$var$getPortalDescription, $bf133c01e9f12fd7$var$getPortalLogoUrl, (portalName, portalDescription, portalLogoUrl)=>({
        subHeading: portalName,
        description: portalDescription,
        logoUrl: portalLogoUrl,
        dangerouslyAllowHtmlInDescription: true
    }));
var $bf133c01e9f12fd7$export$2e2bcd8739ae039 = (0, $jvoWT.default)($bf133c01e9f12fd7$var$selector)((0, $fmBB5.default));

});


parcelRegister("eBvxK", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5619c1256410d2b$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $c5619c1256410d2b$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    addAnnoucement: {
        defaultMessage: 'Add announcement',
        description: 'Text for add announcement button',
        id: 'cv.portal.home.add.announcement.button'
    },
    editAnnouncement: {
        defaultMessage: 'Edit announcement',
        description: 'Text for edit announcement button',
        id: 'cv.portal.home.edit.announcement.button'
    },
    requestTypePageTitle: {
        defaultMessage: '{requestTypeName} - {portalName} - Jira Service Management',
        description: 'Page title for portal page when customer selected a request type form',
        id: 'sd.jsm.customerview.request.type.selected.portal.page.title'
    },
    portalPageTitle: {
        defaultMessage: '{portalName} - Jira Service Management',
        description: 'Page title for portal landing page',
        id: 'sd.jsm.customerview.portal.page.title'
    },
    portalGroupPageTitle: {
        defaultMessage: '{portalName} - Raise a request - Jira Service Management',
        description: 'Page title for portal group page',
        id: 'sd.jsm.customerview.portal.group.page.title'
    }
});

});






parcelRegister("lhiUD", function(module, exports) {
$parcel$export(module.exports, "requestApprovalRoute", () => $6292f42222eae28e$export$bcdc6af6b60bfb08);

var $8rTkC = parcelRequire("8rTkC");

var $8iplR = parcelRequire("8iplR");

var $bpyxC = parcelRequire("bpyxC");

var $bXs4i = parcelRequire("bXs4i");
const $6292f42222eae28e$var$route = {
    name: 'request-approval',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/:requestKey/approval/:approvalId/:decision`,
    exact: true,
    component: (0, $8iplR.RequestApproval)
};
const $6292f42222eae28e$var$screenName = (0, $8rTkC.ScreenName).REQUEST_APPROVAL;
const $6292f42222eae28e$var$paperAppearance = 'normal';
const $6292f42222eae28e$var$layoutProps = {
    ...(0, $bXs4i.anonymousScreenLayout),
    paperAppearance: $6292f42222eae28e$var$paperAppearance
};
const $6292f42222eae28e$export$bcdc6af6b60bfb08 = (0, $bpyxC.createRouteWithLayout)($6292f42222eae28e$var$route, $6292f42222eae28e$var$screenName, $6292f42222eae28e$var$layoutProps);

});
parcelRegister("8iplR", function(module, exports) {
$parcel$export(module.exports, "RequestApproval", () => $928f34c3d8bb2be6$export$741ffb1ed280e417);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $928f34c3d8bb2be6$export$741ffb1ed280e417 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("a3chN")), {
        moduleId: "./src/view/request-approval/hocs.tsx"
    })
});

});
parcelRegister("a3chN", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("kHWCO").then(()=>parcelRequire('cX43v'));

});



parcelRegister("3eD0H", function(module, exports) {
$parcel$export(module.exports, "requestDetailsRoute", () => $9bc0f91d9702ec82$export$c7023f3ff27ad6e1);

var $8rTkC = parcelRequire("8rTkC");
parcelRequire("l8dLt");
var $74aLF = parcelRequire("74aLF");

var $bpyxC = parcelRequire("bpyxC");

var $bXs4i = parcelRequire("bXs4i");
const $9bc0f91d9702ec82$var$route = {
    name: 'request-details',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/:requestKey`,
    exact: true,
    component: (0, $74aLF.default)
};
const $9bc0f91d9702ec82$var$screenName = (0, $8rTkC.ScreenName).REQUEST_DETAILS;
const $9bc0f91d9702ec82$var$paperAppearance = 'xxwide';
const $9bc0f91d9702ec82$var$layoutProps = {
    paperAppearance: $9bc0f91d9702ec82$var$paperAppearance,
    hideSearchButton: false,
    fadeInSearchModal: true
};
const $9bc0f91d9702ec82$export$c7023f3ff27ad6e1 = (0, $bpyxC.createRouteWithLayout)($9bc0f91d9702ec82$var$route, $9bc0f91d9702ec82$var$screenName, $9bc0f91d9702ec82$var$layoutProps);

});
parcelRegister("l8dLt", function(module, exports) {
$parcel$export(module.exports, "RequestDetails", () => (parcelRequire("74aLF")).default);

var $74aLF = parcelRequire("74aLF");

});
parcelRegister("74aLF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f1c9e97cb039e38$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $hWt0u = parcelRequire("hWt0u");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("TCR46");
var $jra4c = parcelRequire("jra4c");
parcelRequire("kdXIP");
var $g9lFj = parcelRequire("g9lFj");
parcelRequire("evz8b");
var $XzrkF = parcelRequire("XzrkF");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("7ySfo");
var $1YYoQ = parcelRequire("1YYoQ");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $29yve = parcelRequire("29yve");

var $vYPX4 = parcelRequire("vYPX4");

var $5pNbH = parcelRequire("5pNbH");
const $1f1c9e97cb039e38$var$selector = (0, $ehscL.createSelector)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $73V7l.getPortal)(state, (0, $vYPX4.toNumber)(props.match.params.portalId)), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $1YYoQ.getRequestDetails)(state, props.match.params.requestKey), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $1YYoQ.getError)(state, props.match.params.requestKey), (state, props)=>{
    return (0, $73V7l.getName)(state, Number(props.match.params.portalId)) ?? (0, $g9lFj.getPortalNameFromBranding)(state);
}, (state, props)=>(0, $29yve.getIssueAnalyticsContext)(state, Number(props.match.params.portalId)), (state)=>(0, $hx8zX.isAtlassianAccountManaged)(state), (state, props)=>(0, $XzrkF.getRequestSpecificConnectAddonPanels)({
        state: state,
        location: 'detailsPanels',
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        requestKey: props.match.params.requestKey
    }), (state, props)=>{
    return Boolean((0, $73V7l.getCanAdministerProject)(state, Number(props.match.params.portalId)));
}, (portal, requestDetails, persistedError, portalName, issueAnalyticsContext, isManagedAccount, connectPanels, isProjectAdmin)=>({
        portal: portal,
        requestDetails: requestDetails,
        issueAnalyticsContext: issueAnalyticsContext,
        portalName: portalName,
        isProjectAdmin: isProjectAdmin,
        isAtlassianManagedAccount: isManagedAccount,
        ...persistedError,
        hasConnectPanels: connectPanels && connectPanels.length > 0,
        isLoading: requestDetails === undefined && persistedError === undefined
    }));
var $1f1c9e97cb039e38$export$2e2bcd8739ae039 = (0, $jvoWT.default)($1f1c9e97cb039e38$var$selector, {
    fetchPortal: (0, $d727K.fetchPortalAction),
    fetchRequestDetails: (0, $jra4c.fetchRequestDetailsModel),
    changeSubscriptionAction: (0, $jra4c.changeSubscription)
})((0, $hWt0u.default)((0, $5pNbH.default)));

});
parcelRegister("7ySfo", function(module, exports) {
$parcel$export(module.exports, "getRequestDetails", () => (parcelRequire("1YYoQ")).getRequestDetails);
$parcel$export(module.exports, "getError", () => (parcelRequire("1YYoQ")).getError);
$parcel$export(module.exports, "isTransitionDialogVisible", () => (parcelRequire("1YYoQ")).isTransitionDialogVisible);
$parcel$export(module.exports, "isTransactionInProgress", () => (parcelRequire("1YYoQ")).isTransactionInProgress);
$parcel$export(module.exports, "getReadMediaApiCredentials", () => (parcelRequire("1YYoQ")).getReadMediaApiCredentials);
$parcel$export(module.exports, "getTransitionFailure", () => (parcelRequire("1YYoQ")).getTransitionFailure);
$parcel$export(module.exports, "getCommentIsSubmitting", () => (parcelRequire("1YYoQ")).getCommentIsSubmitting);
$parcel$export(module.exports, "getCommentBeingSubmitted", () => (parcelRequire("1YYoQ")).getCommentBeingSubmitted);
$parcel$export(module.exports, "getReporter", () => (parcelRequire("1YYoQ")).getReporter);
$parcel$export(module.exports, "getParticipants", () => (parcelRequire("1YYoQ")).getParticipants);
$parcel$export(module.exports, "getOrganisations", () => (parcelRequire("1YYoQ")).getOrganisations);
$parcel$export(module.exports, "getCanRemoveParticipants", () => (parcelRequire("1YYoQ")).getCanRemoveParticipants);
$parcel$export(module.exports, "getCanSearchParticipants", () => (parcelRequire("1YYoQ")).getCanSearchParticipants);
$parcel$export(module.exports, "getCanShareRequest", () => (parcelRequire("1YYoQ")).getCanShareRequest);
$parcel$export(module.exports, "getCanSubmitWithEmailAddress", () => (parcelRequire("1YYoQ")).getCanSubmitWithEmailAddress);
$parcel$export(module.exports, "getInProgressApprovalAction", () => (parcelRequire("1YYoQ")).getInProgressApprovalAction);
$parcel$export(module.exports, "getCanAddComment", () => (parcelRequire("1YYoQ")).getCanAddComment);
$parcel$export(module.exports, "getCanExport", () => (parcelRequire("1YYoQ")).getCanExport);
$parcel$export(module.exports, "getIssueType", () => (parcelRequire("1YYoQ")).getIssueType);
$parcel$export(module.exports, "getIssueTypeId", () => (parcelRequire("1YYoQ")).getIssueTypeId);
$parcel$export(module.exports, "getIssueKey", () => (parcelRequire("1YYoQ")).getIssueKey);
$parcel$export(module.exports, "getIssueId", () => (parcelRequire("1YYoQ")).getIssueId);

var $1YYoQ = parcelRequire("1YYoQ");

});
parcelRegister("1YYoQ", function(module, exports) {
$parcel$export(module.exports, "getRequestDetails", () => $9130907c3d15404d$export$76e59470e6bca129);
$parcel$export(module.exports, "getError", () => $9130907c3d15404d$export$e1599abf47b5b568);
$parcel$export(module.exports, "isTransactionInProgress", () => $9130907c3d15404d$export$5e8f929af64a353a);
$parcel$export(module.exports, "getTransitionFailure", () => $9130907c3d15404d$export$a047f9f9384611fe);
$parcel$export(module.exports, "getReadMediaApiCredentials", () => $9130907c3d15404d$export$cef4d2d501c0dcdb);
$parcel$export(module.exports, "getCommentIsSubmitting", () => $9130907c3d15404d$export$c18738b22e944190);
$parcel$export(module.exports, "getCommentBeingSubmitted", () => $9130907c3d15404d$export$706d262046c8358f);
$parcel$export(module.exports, "getReporter", () => $9130907c3d15404d$export$e8105f4fd5ecc593);
$parcel$export(module.exports, "getParticipants", () => $9130907c3d15404d$export$ccadfc093764e9cd);
$parcel$export(module.exports, "getOrganisations", () => $9130907c3d15404d$export$17495f9c20464b8);
$parcel$export(module.exports, "getCanSubmitWithEmailAddress", () => $9130907c3d15404d$export$c1d23959dfbf9e60);
$parcel$export(module.exports, "getCanSearchParticipants", () => $9130907c3d15404d$export$1fb693409140fdf8);
$parcel$export(module.exports, "getCanShareRequest", () => $9130907c3d15404d$export$bd1011b4c5e87dfc);
$parcel$export(module.exports, "getCanRemoveParticipants", () => $9130907c3d15404d$export$8e53e7bfa4b4035a);
$parcel$export(module.exports, "getCanAddComment", () => $9130907c3d15404d$export$71d5372270878818);
$parcel$export(module.exports, "isTransitionDialogVisible", () => $9130907c3d15404d$export$5d33edbc6a385b);
$parcel$export(module.exports, "getInProgressApprovalAction", () => $9130907c3d15404d$export$55685a606a2adcb4);
$parcel$export(module.exports, "getIssueType", () => $9130907c3d15404d$export$ed2455632bf977ef);
$parcel$export(module.exports, "getIssueTypeId", () => $9130907c3d15404d$export$110c9a4a16c5b8c9);
$parcel$export(module.exports, "getIssueKey", () => $9130907c3d15404d$export$4a030f6192bebe03);
$parcel$export(module.exports, "getIssueId", () => $9130907c3d15404d$export$b4dd560abafd1fae);
$parcel$export(module.exports, "getCanExport", () => $9130907c3d15404d$export$eda75b639af011cf);
const $9130907c3d15404d$var$getRequestDetailsOrError = (state, requestKey)=>{
    if (requestKey && state.persisted.requestDetails) return state.persisted.requestDetails[requestKey];
    return undefined;
};
const $9130907c3d15404d$export$76e59470e6bca129 = (state, requestKey)=>{
    const data = $9130907c3d15404d$var$getRequestDetailsOrError(state, requestKey);
    return $9130907c3d15404d$var$isError(data) ? undefined : data;
};
const $9130907c3d15404d$var$isError = (data)=>data !== undefined && 'error' in data;
const $9130907c3d15404d$export$e1599abf47b5b568 = (state, requestKey)=>{
    const data = $9130907c3d15404d$var$getRequestDetailsOrError(state, requestKey);
    return $9130907c3d15404d$var$isError(data) ? data : undefined;
};
const $9130907c3d15404d$export$5e8f929af64a353a = (state, transactionId)=>{
    const { inProgressTransitionId: inProgressTransitionId } = state.ui.requestDetails;
    return inProgressTransitionId !== undefined && inProgressTransitionId === transactionId;
};
const $9130907c3d15404d$export$a047f9f9384611fe = (state)=>{
    return state.ui.requestDetails.transitionFailure;
};
const $9130907c3d15404d$export$cef4d2d501c0dcdb = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.readFileMediaCredentials : undefined;
};
const $9130907c3d15404d$export$c18738b22e944190 = (state)=>{
    return state.ui.requestDetails.commentSubmitting;
};
const $9130907c3d15404d$export$706d262046c8358f = (state)=>{
    return state.ui.requestDetails.commentBeingSubmitted;
};
const $9130907c3d15404d$export$e8105f4fd5ecc593 = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.reporter : undefined;
};
const $9130907c3d15404d$export$ccadfc093764e9cd = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.participants : undefined;
};
const $9130907c3d15404d$export$17495f9c20464b8 = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.organisations : undefined;
};
const $9130907c3d15404d$export$c1d23959dfbf9e60 = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canSubmitWithEmailAddress : false;
};
const $9130907c3d15404d$export$1fb693409140fdf8 = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canSearchParticipants : false;
};
const $9130907c3d15404d$export$bd1011b4c5e87dfc = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canShareRequest : false;
};
const $9130907c3d15404d$export$8e53e7bfa4b4035a = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canRemoveParticipants : false;
};
const $9130907c3d15404d$export$71d5372270878818 = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canAddComment : false;
};
const $9130907c3d15404d$export$5d33edbc6a385b = (state, id)=>{
    return state.ui.requestDetails.visibleTransitionDialog === id;
};
const $9130907c3d15404d$export$55685a606a2adcb4 = (state)=>{
    return state.ui.requestDetails.inProgressApprovalAction;
};
const $9130907c3d15404d$export$d23b1708046e514c = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return !!(requestDetails !== null && requestDetails !== void 0 && requestDetails.hasProformaForm);
};
const $9130907c3d15404d$export$ed2455632bf977ef = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issueTypeName;
};
const $9130907c3d15404d$export$110c9a4a16c5b8c9 = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issueType;
};
const $9130907c3d15404d$export$4a030f6192bebe03 = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issue.key;
};
const $9130907c3d15404d$export$b4dd560abafd1fae = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issue.id;
};
const $9130907c3d15404d$export$eda75b639af011cf = (state, requestKey)=>{
    const requestDetails = $9130907c3d15404d$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.issue.canExport : false;
};

});


parcelRegister("29yve", function(module, exports) {
$parcel$export(module.exports, "getIssueAnalyticsContext", () => $05d3eaf7f328540f$export$fe0282397d97e2a6);
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
const $05d3eaf7f328540f$export$fe0282397d97e2a6 = (state, portalId)=>({
        user: {
            getAgentForPortal: ()=>(0, $hx8zX.getAgentForPortal)(state),
            getAccountId: ()=>(0, $hx8zX.getAccountId)(state)
        },
        portal: {
            getPortalAnnouncement: ()=>({
                    getCanAdministerProject: ()=>(0, $73V7l.getCanAdministerProject)(state, portalId)
                })
        }
    });

});

parcelRegister("5pNbH", function(module, exports) {
$parcel$export(module.exports, "APPROVAL_BY_EMAIL_RESULT_QUERY_PARAM", () => $4d84acfb6990d7bf$export$491313a4e8829a1a);
$parcel$export(module.exports, "APPROVAL_BY_EMAIL_QUERY_PARAM_SUCCESS", () => $4d84acfb6990d7bf$export$fddfe2b6ca9cfe5c);
$parcel$export(module.exports, "default", () => $4d84acfb6990d7bf$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $4acrp = parcelRequire("4acrp");

var $l4a5B = parcelRequire("l4a5B");

var $jjE9o = parcelRequire("jjE9o");

var $2Np0t = parcelRequire("2Np0t");
parcelRequire("if06c");
var $2vCgF = parcelRequire("2vCgF");
var $8O4Lj = parcelRequire("8O4Lj");
parcelRequire("jGKAL");
var $dkhiz = parcelRequire("dkhiz");

var $9e1KZ = parcelRequire("9e1KZ");

var $dXqaN = parcelRequire("dXqaN");
const $4d84acfb6990d7bf$export$491313a4e8829a1a = 'approval';
const $4d84acfb6990d7bf$export$fddfe2b6ca9cfe5c = '200';
class $4d84acfb6990d7bf$export$1ec22ccbfe26843b extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    componentDidMount() {
        const { portalId: portalId, fetchPortal: fetchPortal, fetchRequestDetails: fetchRequestDetails, requestKey: key } = this.props;
        fetchRequestDetails({
            key: key,
            portalId: Number(portalId)
        });
        fetchPortal({
            id: Number(portalId),
            expand: [
                'analyticsContext'
            ]
        });
        this.trackIssueViewed();
        this.setState({
            isApprovalError: this.checkIfApprovalError()
        });
    }
    componentDidUpdate(prevProps) {
        const { portal: portal, requestDetails: requestDetails } = this.props;
        if (portal && portal.analyticAttributes && requestDetails && !requestDetails.userMentionedDuringRequestCreation) {
            if (!prevProps.portal || !prevProps.portal.analyticAttributes || !prevProps.requestDetails) this.trackIssueViewed();
            else if (portal.id !== prevProps.portal.id || requestDetails.issue.id !== prevProps.requestDetails.issue.id) this.trackIssueViewed();
        }
    }
    trackIssueViewed() {
        const { portal: portal, requestDetails: requestDetails, issueAnalyticsContext: issueAnalyticsContext } = this.props;
        if (!portal || !portal.analyticAttributes || !requestDetails) return;
        const { issue: issue, issueType: issueType, workflowTransitions: workflowTransitions } = requestDetails;
        const { requestTypeId: requestTypeId, id: issueId } = issue;
        const customerTransitionIds = workflowTransitions ? workflowTransitions.map((transition)=>transition.id) : undefined;
        (0, $jjE9o.trackIssueEvent)({
            issueId: issueId,
            projectId: String(portal.projectId),
            action: 'viewed',
            attributes: {
                customerTransitionIds: customerTransitionIds,
                numberOfCustomerTransitionIds: customerTransitionIds && customerTransitionIds.length,
                portalId: String(portal.id),
                issueTypeId: issueType,
                requestTypeId: String(requestTypeId),
                ...portal.analyticAttributes
            }
        }, issueAnalyticsContext.user, issueAnalyticsContext.portal);
    }
    render() {
        var _this$props$portal, _requestDetails$appro2;
        const { isApprovalError: isApprovalError } = this.state;
        const { requestDetails: requestDetails, isLoading: isLoading, portalName: portalName, requestKey: requestKey, portal: portal, hasConnectPanels: hasConnectPanels, isProjectAdmin: isProjectAdmin } = this.props;
        const serviceDeskId = Number(portal === null || portal === void 0 ? void 0 : portal.serviceDeskId);
        const portalId = Number(this.props.portalId);
        const projectId = Number(portal === null || portal === void 0 ? void 0 : portal.projectId);
        const projectKey = (_this$props$portal = this.props.portal) === null || _this$props$portal === void 0 ? void 0 : _this$props$portal.projectKey;
        const isAtlassianManagedAccount = this.props.isAtlassianManagedAccount;
        const shouldShowLearnByDoingExperimentBanner = (0, $8O4Lj.shouldShowLearnByDoingBanner)(isProjectAdmin, $2Np0t.get((0, $2vCgF.REFERRER_QUERY_PARAM)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, isApprovalError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dkhiz.default), {
            approvalError: this.getApprovalError(),
            hasDecision: (requestDetails === null || requestDetails === void 0 || (_requestDetails$appro2 = requestDetails.approvalStatus[0]) === null || _requestDetails$appro2 === void 0 || (_requestDetails$appro2 = _requestDetails$appro2.decision) === null || _requestDetails$appro2 === void 0 ? void 0 : _requestDetails$appro2.decision) !== undefined,
            onDismissError: this.onDismissError
        }) : [], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dXqaN.default), {
            requestDetails: requestDetails,
            isLoading: isLoading,
            isAtlassianManagedAccount: isAtlassianManagedAccount,
            serviceDeskId: serviceDeskId,
            portalId: portalId,
            projectId: projectId,
            requestKey: requestKey,
            onNotificationChange: this.onNotificationChange,
            portalName: portalName,
            hasConnectPanels: hasConnectPanels,
            detailsHiddenOnInitialView: !!this.detailsHiddenOnInitialView,
            activityItemsHiddenOnInitialView: !!this.activityItemsHiddenOnInitialView,
            removeOldParticipantsAndReporterFromComment: this.removeOldParticipantsAndReporterFromComment,
            projectKey: projectKey,
            shouldShowLearnByDoingExperimentBanner: shouldShowLearnByDoingExperimentBanner
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            isApprovalError: false
        }, this.onNotificationChange = (shouldSubscribe)=>{
            const { requestDetails: requestDetails, changeSubscriptionAction: changeSubscriptionAction } = this.props;
            if (requestDetails) changeSubscriptionAction(requestDetails.key, requestDetails.issue.id, shouldSubscribe);
        }, this.checkIfApprovalError = ()=>{
            return !!$2Np0t.get($4d84acfb6990d7bf$export$491313a4e8829a1a) && $2Np0t.get($4d84acfb6990d7bf$export$491313a4e8829a1a) !== $4d84acfb6990d7bf$export$fddfe2b6ca9cfe5c;
        }, this.getApprovalError = ()=>{
            return this.checkIfApprovalError() ? $2Np0t.get($4d84acfb6990d7bf$export$491313a4e8829a1a) : undefined;
        }, this.onDismissError = ()=>{
            this.setState({
                isApprovalError: false
            });
        }, this.removeOldParticipantsAndReporterFromComment = (accountIds)=>{
            const requestDetails = this.props.requestDetails;
            if (requestDetails) {
                const { participants: participants, reporter: reporter } = requestDetails;
                /* Removing user mentions which should not be added as request participants */ (reporter === null || reporter === void 0 ? void 0 : reporter.accountId) && accountIds.delete(reporter === null || reporter === void 0 ? void 0 : reporter.accountId);
                participants.forEach((participant)=>accountIds.delete(participant.accountId));
            }
            return accountIds;
        }, this.getFlagTitleAndDescription = ()=>{
            var _requestDetails$appro;
            // Error messages for approve by email
            const { intl: intl, requestDetails: requestDetails } = this.props;
            const decision = requestDetails === null || requestDetails === void 0 || (_requestDetails$appro = requestDetails.approvalStatus[0]) === null || _requestDetails$appro === void 0 || (_requestDetails$appro = _requestDetails$appro.decision) === null || _requestDetails$appro === void 0 ? void 0 : _requestDetails$appro.decision;
            switch($2Np0t.get($4d84acfb6990d7bf$export$491313a4e8829a1a)){
                case '400':
                    if (decision) // if decision already made
                    return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitle400_2),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescription400_2)
                    };
                    // if misspelling in url
                    return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitle400_1),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescription400_1, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("b", null, chunks)
                        })
                    };
                case '403':
                    // if approver has been removed as approver by admin
                    return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitle403),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescription403)
                    };
                default:
                    return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitleDefault, {
                            value: $2Np0t.get($4d84acfb6990d7bf$export$491313a4e8829a1a) ?? ''
                        }),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescriptionDefault, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("b", null, chunks)
                        })
                    };
            }
        };
    }
}
var $4d84acfb6990d7bf$export$2e2bcd8739ae039 = (0, $4acrp.withErrorPage)((0, $l4a5B.default)($4d84acfb6990d7bf$export$1ec22ccbfe26843b));

});
parcelRegister("jGKAL", function(module, exports) {
$parcel$export(module.exports, "ApprovalErrorFlag", () => (parcelRequire("dkhiz")).default);

var $dkhiz = parcelRequire("dkhiz");

});
parcelRegister("dkhiz", function(module, exports) {
$parcel$export(module.exports, "default", () => $3768a6e7a1e4e4c1$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $l4a5B = parcelRequire("l4a5B");

var $h5gSD = parcelRequire("h5gSD");
var $gvxin = parcelRequire("gvxin");

var $4CMbU = parcelRequire("4CMbU");

var $9e1KZ = parcelRequire("9e1KZ");
class $3768a6e7a1e4e4c1$export$15f2320c01f1c048 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        const { approvalError: approvalError, onDismissError: onDismissError, intl: intl } = this.props;
        const { title: title, description: description } = this.getFlagTitleAndDescription();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gvxin.default), {
            onDismissed: onDismissError
        }, approvalError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $h5gSD.default), {
            id: "approve-by-email-fail-approve-error-flag",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4CMbU))), {
                spacing: "spacious",
                color: "var(--ds-icon-danger, #BF2600)",
                label: ""
            }),
            title: title,
            description: description,
            actions: [
                {
                    content: intl.formatMessage((0, $9e1KZ.default).dismiss),
                    onClick: ()=>onDismissError()
                }
            ]
        }) : []);
    }
    constructor(...args){
        super(...args), this.getFlagTitleAndDescription = ()=>{
            const { intl: intl, hasDecision: hasDecision, approvalError: approvalError } = this.props;
            switch(approvalError){
                case '400':
                    if (hasDecision) return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitle400_2),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescription400_2)
                    };
                    return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitle400_1),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescription400_1, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("b", null, chunks)
                        })
                    };
                case '403':
                    return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitle403),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescription403)
                    };
                case '404':
                    return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitle404),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescription404)
                    };
                case '409':
                    return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitle409),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescription409)
                    };
                default:
                    return {
                        title: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagTitleDefault, {}),
                        description: intl.formatMessage((0, $9e1KZ.default).approvalByEmailErrorFlagDescriptionDefault, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("b", null, chunks)
                        })
                    };
            }
        };
    }
}
var $3768a6e7a1e4e4c1$export$2e2bcd8739ae039 = (0, $l4a5B.default)($3768a6e7a1e4e4c1$export$15f2320c01f1c048);

});
parcelRegister("9e1KZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b8a2f86f97f2799$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $5b8a2f86f97f2799$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    dismiss: {
        defaultMessage: 'Dismiss',
        description: 'Dismiss error flag message',
        id: 'cv.request.details.approve.by.email.approval.error.dismiss.flag.message'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagTitle400_1: {
        defaultMessage: "We couldn't record your selection",
        description: 'Title for the flag when there is a 400 error, type 1 (misspelling in url)',
        id: 'cv.request.details.approve.by.email.approval.error.title400_1'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagDescription400_1: {
        defaultMessage: 'Select <b>Approve</b> or <b>Decline</b> on this page.',
        description: 'Description for the flag when there is a 400 error, type 1 (misspelling in url)',
        id: 'cv.request.details.approve.by.email.approval.error.description400_1'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagTitle400_2: {
        defaultMessage: 'You no longer need to approve or decline',
        description: 'Title for the flag when there is a 400 error, type 2 (approval already completed)',
        id: 'cv.request.details.approve.by.email.approval.error.title400_2'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagDescription400_2: {
        defaultMessage: 'This request has already been approved or declined.',
        description: 'Description for the flag when there is a 400 error, type 2 (approval already completed)',
        id: 'cv.request.details.approve.by.email.approval.error.description400_2'
    },
    approvalByEmailErrorFlagTitle403: {
        defaultMessage: 'You need permission to approve this request',
        description: 'Title for the flag when there is a 403 error',
        id: 'cv.request.details.approve.by.email.approval.error.title401'
    },
    approvalByEmailErrorFlagDescription403: {
        defaultMessage: `Ask your admin if you\u{2019}re on the approvers list, or check that you\u{2019}re logged in with the right account.`,
        description: 'Description for the flag when there is a 403 error',
        id: 'cv.request.details.approve.by.email.approval.error.description401'
    },
    approvalByEmailErrorFlagTitle404: {
        defaultMessage: `We couldn\u{2019}t update the request`,
        description: 'Title for the flag when there is a 404 error',
        id: 'cv.request.details.approve.by.email.approval.error.title404'
    },
    approvalByEmailErrorFlagDescription404: {
        defaultMessage: 'This request no longer needs approval. It may have been updated or deleted.',
        description: 'Description for the flag when there is a 404 error',
        id: 'cv.request.details.approve.by.email.approval.error.description404'
    },
    approvalByEmailErrorFlagTitle409: {
        defaultMessage: 'Approval not required',
        description: 'Title for the flag when there is a 409 error',
        id: 'cv.request.details.approve.by.email.approval.error.title409'
    },
    approvalByEmailErrorFlagDescription409: {
        defaultMessage: 'This request has already been approved or declined.',
        description: 'Description for the flag when there is a 409 error',
        id: 'cv.request.details.approve.by.email.approval.error.description409'
    },
    approvalByEmailErrorFlagTitleDefault: {
        defaultMessage: "We couldn't record your selection",
        description: 'Title for the flag when there is a an error not already accounted for',
        id: 'cv.request.details.approve.by.email.approval.error.title.default'
    },
    approvalByEmailErrorFlagDescriptionDefault: {
        defaultMessage: 'Select <b>Approve</b> or <b>Decline</b> on this page if available, or try again later.',
        description: 'Description for the flag when there is a an error not already accounted for',
        id: 'cv.request.details.approve.by.email.approval.error.description.default'
    }
});

});



parcelRegister("dXqaN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d4041b4fd95cef5$export$2e2bcd8739ae039);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $2d4041b4fd95cef5$var$loader = (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("1QDBA")), {
    moduleId: "./src/view/request-details/request-details-stateless/request-details-stateless.tsx"
});
var $2d4041b4fd95cef5$export$2e2bcd8739ae039 = (0, $gweXC.default)({
    loader: $2d4041b4fd95cef5$var$loader
});

});
parcelRegister("1QDBA", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("kZXFN"),
    $j9MRt("gUYyZ"),
    $j9MRt("3aI3R"),
    $j9MRt("5WsnM"),
    $j9MRt("hcxtc"),
    $j9MRt("hMKE4"),
    $j9MRt("hVSoa"),
    $j9MRt("cqe51"),
    $j9MRt("399y2"),
    $j9MRt("3XUZk"),
    $j9MRt("ikoh2"),
    $j9MRt("8YHHh")
]).then(()=>parcelRequire('7AJXA'));

});






parcelRegister("aN5rH", function(module, exports) {
$parcel$export(module.exports, "userSignupRoute", () => $9ac93bb1d43f466f$export$6c53daec3917ca4f);
$parcel$export(module.exports, "userResetPasswordRoute", () => $9ac93bb1d43f466f$export$a1ff4b1e673ba98c);
$parcel$export(module.exports, "userCompleteSignupRoute", () => $9ac93bb1d43f466f$export$61da5e60a0c99a8a);
$parcel$export(module.exports, "userCheckMailRoute", () => $9ac93bb1d43f466f$export$934c0e27338aac46);
$parcel$export(module.exports, "portalSignupRoute", () => $9ac93bb1d43f466f$export$766487cfd72c58e6);
$parcel$export(module.exports, "portalResetPasswordRoute", () => $9ac93bb1d43f466f$export$a52bd3b0b1b1499b);
$parcel$export(module.exports, "portalCompleteSignupRoute", () => $9ac93bb1d43f466f$export$c0d26476c776bd62);
$parcel$export(module.exports, "portalInvitedSignupRoute", () => $9ac93bb1d43f466f$export$124a02da2ab0bcaf);

var $8rTkC = parcelRequire("8rTkC");

var $zjSHi = parcelRequire("zjSHi");

var $gonrV = parcelRequire("gonrV");

var $7xh1z = parcelRequire("7xh1z");

var $2wFiT = parcelRequire("2wFiT");

var $33bGU = parcelRequire("33bGU");

var $bpyxC = parcelRequire("bpyxC");

var $bXs4i = parcelRequire("bXs4i");
const $9ac93bb1d43f466f$var$userSignup = {
    resources: [],
    name: 'user-signup',
    path: `/user/signup`,
    exact: true,
    component: (0, $2wFiT.SignUp)
};
const $9ac93bb1d43f466f$var$userResetPassword = {
    resources: [],
    name: 'user-reset-password',
    path: `/user/resetpassword`,
    exact: true,
    component: (0, $7xh1z.ResetPassword)
};
const $9ac93bb1d43f466f$var$userCompleteSignup = {
    resources: [],
    name: 'user-complete-signup',
    path: `/user/complete-signup`,
    exact: true,
    component: (0, $zjSHi.CompleteSignup)
};
const $9ac93bb1d43f466f$var$userCheckMail = {
    resources: [],
    name: 'user-checkmail',
    path: `/user/check-email`,
    exact: true,
    component: (0, $33bGU.CheckEmail)
};
const $9ac93bb1d43f466f$var$portalSignup = {
    resources: [],
    name: 'portal-signup',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/signup`,
    exact: true,
    component: (0, $2wFiT.SignUp)
};
const $9ac93bb1d43f466f$var$portalResetPassword = {
    resources: [],
    name: 'portal-reset-password',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/resetpassword`,
    exact: true,
    component: (0, $7xh1z.ResetPassword)
};
const $9ac93bb1d43f466f$var$portalCompleteSignup = {
    resources: [],
    name: 'portal-complete-signup',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/complete-signup`,
    exact: true,
    component: (0, $zjSHi.CompleteSignup)
};
const $9ac93bb1d43f466f$var$portalInvitedSignup = {
    resources: [],
    name: 'portal-invited-signup',
    path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/visitportal`,
    exact: true,
    component: (0, $gonrV.InvitedSignUp)
};
const $9ac93bb1d43f466f$var$signUpScreenName = (0, $8rTkC.ScreenName).SIGNUP;
const $9ac93bb1d43f466f$export$6c53daec3917ca4f = (0, $bpyxC.createRouteWithLayout)($9ac93bb1d43f466f$var$userSignup, $9ac93bb1d43f466f$var$signUpScreenName, (0, $bXs4i.anonymousScreenLayout));
const $9ac93bb1d43f466f$export$a1ff4b1e673ba98c = (0, $bpyxC.createRouteWithLayout)($9ac93bb1d43f466f$var$userResetPassword, (0, $8rTkC.ScreenName).RESET_PASSWORD, (0, $bXs4i.anonymousScreenLayout));
const $9ac93bb1d43f466f$export$61da5e60a0c99a8a = (0, $bpyxC.createRouteWithLayout)($9ac93bb1d43f466f$var$userCompleteSignup, (0, $8rTkC.ScreenName).COMPLETE_SIGNUP, (0, $bXs4i.anonymousScreenLayout));
const $9ac93bb1d43f466f$export$934c0e27338aac46 = (0, $bpyxC.createRouteWithLayout)($9ac93bb1d43f466f$var$userCheckMail, (0, $8rTkC.ScreenName).CHECK_EMAIL, (0, $bXs4i.anonymousScreenLayout));
const $9ac93bb1d43f466f$export$766487cfd72c58e6 = (0, $bpyxC.createRouteWithLayout)($9ac93bb1d43f466f$var$portalSignup, $9ac93bb1d43f466f$var$signUpScreenName, (0, $bXs4i.anonymousScreenLayout));
const $9ac93bb1d43f466f$export$a52bd3b0b1b1499b = (0, $bpyxC.createRouteWithLayout)($9ac93bb1d43f466f$var$portalResetPassword, (0, $8rTkC.ScreenName).RESET_PASSWORD, (0, $bXs4i.anonymousScreenLayout));
const $9ac93bb1d43f466f$export$c0d26476c776bd62 = (0, $bpyxC.createRouteWithLayout)($9ac93bb1d43f466f$var$portalCompleteSignup, (0, $8rTkC.ScreenName).COMPLETE_SIGNUP, (0, $bXs4i.anonymousScreenLayout));
const $9ac93bb1d43f466f$export$124a02da2ab0bcaf = (0, $bpyxC.createRouteWithLayout)($9ac93bb1d43f466f$var$portalInvitedSignup, (0, $8rTkC.ScreenName).INVITED_SIGNUP, (0, $bXs4i.anonymousScreenLayout));

});
parcelRegister("zjSHi", function(module, exports) {
$parcel$export(module.exports, "CompleteSignup", () => $323918ad7a0e7528$export$372770c8487ebcca);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $323918ad7a0e7528$export$372770c8487ebcca = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("hiWpg")), {
        moduleId: "./src/view/complete-signup/hocs.tsx"
    })
});

});
parcelRegister("hiWpg", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("8Movz").then(()=>parcelRequire('7GDOy'));

});


parcelRegister("gonrV", function(module, exports) {
$parcel$export(module.exports, "InvitedSignUp", () => $af957ef3ed505b5f$export$b6f2cb2bcdfbfdb9);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $af957ef3ed505b5f$export$b6f2cb2bcdfbfdb9 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("bBBq7")), {
        moduleId: "./src/view/invited-sign-up/hocs.tsx"
    })
});

});
parcelRegister("bBBq7", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("fmO7q").then(()=>parcelRequire('b5NZZ'));

});


parcelRegister("7xh1z", function(module, exports) {
$parcel$export(module.exports, "ResetPassword", () => $b69858b5bf1f9d50$export$a4c3d56613a57187);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $b69858b5bf1f9d50$export$a4c3d56613a57187 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("7Sddu")), {
        moduleId: "./src/view/reset-password/hocs.tsx"
    })
});

});
parcelRegister("7Sddu", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("4H2iF").then(()=>parcelRequire('88whr'));

});


parcelRegister("2wFiT", function(module, exports) {
$parcel$export(module.exports, "SignUp", () => $ff75ab02ea54ff54$export$4ee457d816cea81a);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $ff75ab02ea54ff54$export$4ee457d816cea81a = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("68JDT")), {
        moduleId: "./src/view/sign-up/hocs.tsx"
    })
});

});
parcelRegister("68JDT", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("lMkd4").then(()=>parcelRequire('hOyau'));

});


parcelRegister("33bGU", function(module, exports) {
$parcel$export(module.exports, "CheckEmail", () => $e866adc64ad85b94$export$fd89248056ed5439);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $e866adc64ad85b94$export$fd89248056ed5439 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("GuLix")), {
        moduleId: "./src/view/sign-up-check-email/hocs.tsx"
    })
});

});
parcelRegister("GuLix", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("3eiMI").then(()=>parcelRequire('1Kg7b'));

});



parcelRegister("9uhKS", function(module, exports) {
$parcel$export(module.exports, "getViewTopicRoute", () => $b9f59e226942629e$export$8c8c8d8cda238e84);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");

var $clS24 = parcelRequire("clS24");

var $6wFm9 = parcelRequire("6wFm9");

var $bpyxC = parcelRequire("bpyxC");
var $byuiX = parcelRequire("byuiX");

var $2ljSO = parcelRequire("2ljSO");
const $b9f59e226942629e$var$PageLoader = ()=>{
    const [{ match: { params: { id: id } } }] = (0, $i9cdb.useRouter)();
    (0, $clS24.default)(id);
    const { queryReference: queryReference } = (0, $byuiX.useRelayResource)((0, $2ljSO.viewTopicResource));
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6wFm9.ViewTopic), {
        topicId: id,
        queryReference: queryReference
    });
};
const $b9f59e226942629e$export$8c8c8d8cda238e84 = ()=>{
    const paperAppearance = (0, $HGACo.isUseHelpCenterRefresh)() ? 'xwide' : 'normal';
    const layoutProps = {
        paperAppearance: paperAppearance,
        fadeInSearchModal: true
    };
    return (0, $bpyxC.createRouteWithLayout)({
        name: 'view-topic',
        path: '/topic/:id',
        exact: true,
        component: $b9f59e226942629e$var$PageLoader,
        resources: [
            (0, $2ljSO.viewTopicResource)
        ]
    }, (0, $8rTkC.ScreenName).VIEW_TOPIC, layoutProps);
};

});
parcelRegister("6wFm9", function(module, exports) {
$parcel$export(module.exports, "ViewTopic", () => $20dead938204170b$export$8036aeb45d373d7d);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $20dead938204170b$var$loader = (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("gEdSR")), {
    moduleId: "./src/view/topic/topic.tsx"
});
const $20dead938204170b$export$8036aeb45d373d7d = (0, $gweXC.default)({
    loader: $20dead938204170b$var$loader
});

});
parcelRegister("gEdSR", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("kB8ya"),
    $j9MRt("js87r")
]).then(()=>parcelRequire('3eVAN'));

});


parcelRegister("2ljSO", function(module, exports) {
$parcel$export(module.exports, "viewTopicResource", () => $b597ec620ab674e1$export$425f51060493cc67);

var $6D9Lw = parcelRequire("6D9Lw");

var $byuiX = parcelRequire("byuiX");
const $b597ec620ab674e1$export$425f51060493cc67 = (0, $byuiX.createRelayResource)({
    type: 'VIEW_TOPIC',
    getQuery: ({ match: { params: { id: id } } }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $6D9Lw.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                topicId: String(id)
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("6D9Lw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3c36bfb7416833a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04f0af7279f78d72dbeae49d34853aac>>
 * @relayHash ebbdf9e39eabac61b9f8917e5b0cac0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eedf2118595dd8d898ad076ceca26fa45ca7388997a647bde47c19cb9867baf1
const $e3c36bfb7416833a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "topicId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "description"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v6 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "topicQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "helpCenterTopic_HelpCenterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "topicQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "helpCenterAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "topicId",
                                    "variableName": "topicId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterTopicById",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "HelpCenterTopicItemConnection",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterTopicItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "ari"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isHelpCenterHelpObject"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "HelpObjectStoreIcon",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "icon",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "iconUrl"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreRequestForm"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreArticle"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreChannel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ],
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        }
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "items(first:10)"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "mainHelpObjectsList_HelpCenterTopic_items",
                                            "kind": "LinkedHandle",
                                            "name": "items"
                                        }
                                    ],
                                    "type": "HelpCenterTopic"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "eedf2118595dd8d898ad076ceca26fa45ca7388997a647bde47c19cb9867baf1",
            "metadata": {},
            "name": "topicQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e3c36bfb7416833a$var$node.hash = "aad6fa68f7fdec1c20c0311c482bf40f";
var $e3c36bfb7416833a$export$2e2bcd8739ae039 = $e3c36bfb7416833a$var$node;

});



parcelRegister("j52uk", function(module, exports) {
$parcel$export(module.exports, "userVerifyEmailRoute", () => $b909b1110e7a91f8$export$421ececb54aacf4e);

var $8rTkC = parcelRequire("8rTkC");

var $eEX0J = parcelRequire("eEX0J");

var $bpyxC = parcelRequire("bpyxC");

var $bXs4i = parcelRequire("bXs4i");
const $b909b1110e7a91f8$var$userVerifyEmail = {
    resources: [],
    name: 'verify-email',
    path: `/user/verify-email`,
    exact: true,
    component: (0, $eEX0J.VerifyEmail)
};
const $b909b1110e7a91f8$export$421ececb54aacf4e = (0, $bpyxC.createRouteWithLayout)($b909b1110e7a91f8$var$userVerifyEmail, (0, $8rTkC.ScreenName).VERIFY_EMAIL, (0, $bXs4i.anonymousScreenLayout));

});
parcelRegister("eEX0J", function(module, exports) {
$parcel$export(module.exports, "VerifyEmail", () => $0a90f891f781e68b$export$3d3197b723615cc);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $0a90f891f781e68b$export$3d3197b723615cc = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("fxA0Y")), {
        moduleId: "./src/view/verify-email/hocs.tsx"
    })
});

});
parcelRegister("fxA0Y", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("lS7vG").then(()=>parcelRequire('eeovr'));

});



parcelRegister("9PD2z", function(module, exports) {
$parcel$export(module.exports, "UFOWatcher", () => $67349e3ad6284268$export$261b8a18a570aef7);

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");

var $9TwI7 = parcelRequire("9TwI7");

var $2E7aX = parcelRequire("2E7aX");

var $K219T = parcelRequire("K219T");

var $iNc05 = parcelRequire("iNc05");

var $dWc7u = parcelRequire("dWc7u");
const $67349e3ad6284268$var$INTERESTING_RESOURCE_PATTERNS = [
    {
        spanLabel: 'jsapi.js',
        regEx: /\/jsapi\.js/
    },
    {
        spanLabel: 'challenge.js',
        regEx: /\/challenge\.js/
    },
    {
        spanLabel: 'vendor-react.chunk.js',
        regEx: /\/vendor-react\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-vendor.chunk.js',
        regEx: /\/servicedesk-vendor\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-atlaskit.chunk.js',
        regEx: /\/servicedesk-atlaskit\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'compiled-css.chunk.js',
        regEx: /\/compiled-css\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-customerportal.bundle.js',
        regEx: /\/servicedesk-customerportal\.bundle\..{0,64}js/
    }
];
function $67349e3ad6284268$var$addResourceTimingsToUFO() {
    var _globalThis$performan, _globalThis$performan2;
    ((_globalThis$performan = globalThis.performance) === null || _globalThis$performan === void 0 ? void 0 : _globalThis$performan.getEntriesByType) && Array.from((_globalThis$performan2 = globalThis.performance) === null || _globalThis$performan2 === void 0 ? void 0 : _globalThis$performan2.getEntriesByType('resource')).forEach((entry)=>{
        for (const resource of $67349e3ad6284268$var$INTERESTING_RESOURCE_PATTERNS)if (resource.regEx.test(entry.name)) (0, $9TwI7.addSpanToAll)('fetch', resource.spanLabel, [
            {
                name: 'custom-network'
            },
            {
                name: 'resources'
            }
        ], entry.startTime, entry.startTime + entry.duration);
    });
}
const $67349e3ad6284268$export$261b8a18a570aef7 = ()=>{
    const isInitial = (0, $8P7DW.useRef)(true);
    const [routerState] = (0, $i9cdb.useRouter)();
    const route = routerState.route;
    const match = routerState.match;
    let ufoName = (0, $2E7aX.default)(route).toLowerCase();
    if ('getUFONameBasedOnRouteMatch' in route && route.getUFONameBasedOnRouteMatch instanceof Function) ufoName = route.getUFONameBasedOnRouteMatch(match);
    const lastUFOName = (0, $8P7DW.useRef)(ufoName);
    if (ufoName) {
        if ((0, $HGACo.isUiModificationsSupportEnabled)() && ufoName === (0, $8rTkC.ExperienceName).REQUEST_CREATE) (0, $dWc7u.startScreenTTIWithUIModifications)();
        if (isInitial.current) {
            $67349e3ad6284268$var$addResourceTimingsToUFO();
            (0, $K219T.default)(ufoName);
            isInitial.current = false;
        }
        if (lastUFOName.current !== ufoName && !isInitial.current) {
            lastUFOName.current = ufoName;
            (0, $iNc05.default)(ufoName);
        }
    }
    return null;
};

});
parcelRegister("2E7aX", function(module, exports) {
$parcel$export(module.exports, "default", () => $65ca22c0d7c057d1$export$2e2bcd8739ae039);
function $65ca22c0d7c057d1$var$getUFORouteName(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}
var $65ca22c0d7c057d1$export$2e2bcd8739ae039 = $65ca22c0d7c057d1$var$getUFORouteName;

});

parcelRegister("K219T", function(module, exports) {
$parcel$export(module.exports, "default", () => $77b3c7ed692b5724$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $gdnRs = parcelRequire("gdnRs");

var $2x96i = parcelRequire("2x96i");

var $cAaWV = parcelRequire("cAaWV");

var $l5LZV = parcelRequire("l5LZV");

var $8uTBY = parcelRequire("8uTBY");

var $9TwI7 = parcelRequire("9TwI7");

var $8WiY5 = parcelRequire("8WiY5");
const $77b3c7ed692b5724$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $77b3c7ed692b5724$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $cAaWV.isUFOEnabled)()) return;
    const activeInteraction = (0, $9TwI7.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $8WiY5.default).current = routeName || null;
    const rate = ufoName ? (0, $cAaWV.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $2x96i.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $gdnRs.v4)();
        (0, $8uTBY.DefaultInteractionID).current = newId;
        (0, $9TwI7.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $l5LZV.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $9TwI7.addHoldByID)(newId, [], $77b3c7ed692b5724$var$AWAITING_PAGELOAD_NAME, $77b3c7ed692b5724$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $9TwI7.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $9TwI7.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $9TwI7.removeHoldByID)(activeInteraction.id, $77b3c7ed692b5724$var$AWAITING_PAGELOAD_NAME);
    }
}
var $77b3c7ed692b5724$export$2e2bcd8739ae039 = $77b3c7ed692b5724$var$traceUFOPageLoad;
function $77b3c7ed692b5724$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    if (!(0, $cAaWV.isUFOEnabled)()) return;
    const interaction = (0, $9TwI7.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $cAaWV.getInteractionRate)(ufoName, 'page_load');
        (0, $9TwI7.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $2x96i.default)(rate)) (0, $8WiY5.default).current = ufoName;
        else (0, $9TwI7.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $9TwI7.removeHoldByID)(interaction.id, $77b3c7ed692b5724$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("iNc05", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ada81cead465ec4$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $gdnRs = parcelRequire("gdnRs");

var $2x96i = parcelRequire("2x96i");

var $cAaWV = parcelRequire("cAaWV");

var $l5LZV = parcelRequire("l5LZV");

var $8uTBY = parcelRequire("8uTBY");

var $9TwI7 = parcelRequire("9TwI7");

var $8WiY5 = parcelRequire("8WiY5");

var $d8qMH = parcelRequire("d8qMH");
function $0ada81cead465ec4$var$traceUFOTransition(ufoName, routeName = ufoName) {
    if (!(0, $cAaWV.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $cAaWV.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $9TwI7.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $9TwI7.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $8WiY5.default).current = ufoName;
        const rate = (0, $cAaWV.getInteractionRate)(ufoName, 'transition');
        if ((0, $2x96i.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $gdnRs.v4)();
            (0, $d8qMH.setInteractionActiveTrace)(newId);
            (0, $8uTBY.DefaultInteractionID).current = newId;
            (0, $9TwI7.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $l5LZV.getActiveTrace)());
        }
    }
}
function $0ada81cead465ec4$export$369f0ded13ce6c50() {
    const interactionId = (0, $8P7DW.useContext)((0, $8uTBY.default));
    const capturedInteractionId = interactionId.current;
    (0, $8P7DW.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $9TwI7.tryComplete)(capturedInteractionId);
                });
            });
            (0, $9TwI7.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var $0ada81cead465ec4$export$2e2bcd8739ae039 = $0ada81cead465ec4$var$traceUFOTransition;

});
parcelRegister("d8qMH", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $b5b519468e8bb7a8$export$f2e521e495a88544);

var $l5LZV = parcelRequire("l5LZV");

var $2UfvV = parcelRequire("2UfvV");
function $b5b519468e8bb7a8$export$f2e521e495a88544(newId) {
    (0, $l5LZV.setActiveTrace)(newId.replace(/-/g, ''), (0, $2UfvV.generateSpanId)(), 'transition');
}

});
parcelRegister("2UfvV", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $8af000e035055432$export$295213bc4d0c54ad);
function $8af000e035055432$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});




parcelRegister("lzEbC", function(module, exports) {
$parcel$export(module.exports, "getAnonymousRequestSuccessRouteWithHubShell", () => (parcelRequire("1Glz5")).getAnonymousRequestSuccessRouteWithHubShell);
$parcel$export(module.exports, "getCheckEmailRouteWithHubShell", () => (parcelRequire("1Glz5")).getCheckEmailRouteWithHubShell);
$parcel$export(module.exports, "getCompleteSignupRouteWithHubShell", () => (parcelRequire("1Glz5")).getCompleteSignupRouteWithHubShell);
$parcel$export(module.exports, "getCsmContactUsRouteWithHubShell", () => (parcelRequire("1Glz5")).getCsmContactUsRouteWithHubShell);
$parcel$export(module.exports, "getCsmFolderRouteWithHubShell", () => (parcelRequire("1Glz5")).getCsmFolderRouteWithHubShell);
$parcel$export(module.exports, "getCsmRequestDetailsRouteWithHubShell", () => (parcelRequire("1Glz5")).getCsmRequestDetailsRouteWithHubShell);
$parcel$export(module.exports, "getCsmRequestsListRouteWithHubShell", () => (parcelRequire("1Glz5")).getCsmRequestsListRouteWithHubShell);
$parcel$export(module.exports, "getCsmUserProfileRouteWithHubShell", () => (parcelRequire("1Glz5")).getCsmUserProfileRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewArticleRouteWithHubShell", () => (parcelRequire("1Glz5")).getCsmViewArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewCrossSiteArticleRouteWithHubShell", () => (parcelRequire("1Glz5")).getCsmViewCrossSiteArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewCrossSitePortalArticleRouteWithHubShell", () => (parcelRequire("1Glz5")).getCsmViewCrossSitePortalArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewPortalArticleRouteWithHubShell", () => (parcelRequire("1Glz5")).getCsmViewPortalArticleRouteWithHubShell);
$parcel$export(module.exports, "getHubCustompageRoute", () => (parcelRequire("1Glz5")).getHubCustompageRoute);
$parcel$export(module.exports, "getHubHomepageRoute", () => (parcelRequire("1Glz5")).getHubHomepageRoute);
$parcel$export(module.exports, "getHubPortalPageRoute", () => (parcelRequire("1Glz5")).getHubPortalPageRoute);
$parcel$export(module.exports, "getHubUserProfileRouteWithHubShell", () => (parcelRequire("1Glz5")).getHubUserProfileRouteWithHubShell);
$parcel$export(module.exports, "getHubViewArticleRoute", () => (parcelRequire("1Glz5")).getHubViewArticleRoute);
$parcel$export(module.exports, "getHubViewCrossSiteArticleRoute", () => (parcelRequire("1Glz5")).getHubViewCrossSiteArticleRoute);
$parcel$export(module.exports, "getHubViewCrossSitePortalArticleRoute", () => (parcelRequire("1Glz5")).getHubViewCrossSitePortalArticleRoute);
$parcel$export(module.exports, "getHubViewKbRoute", () => (parcelRequire("1Glz5")).getHubViewKbRoute);
$parcel$export(module.exports, "getHubViewPortalArticleRoute", () => (parcelRequire("1Glz5")).getHubViewPortalArticleRoute);
$parcel$export(module.exports, "getJsmApprovalsRouteWithHubShell", () => (parcelRequire("1Glz5")).getJsmApprovalsRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestApprovalRouteWithHubShell", () => (parcelRequire("1Glz5")).getJsmRequestApprovalRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestDetailsRouteWithHubShell", () => (parcelRequire("1Glz5")).getJsmRequestDetailsRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestsListRouteWithHubShell", () => (parcelRequire("1Glz5")).getJsmRequestsListRouteWithHubShell);
$parcel$export(module.exports, "getLoginRouteWithHubShell", () => (parcelRequire("1Glz5")).getLoginRouteWithHubShell);
$parcel$export(module.exports, "getNotFoundRouteWithHubShell", () => (parcelRequire("1Glz5")).getNotFoundRouteWithHubShell);
$parcel$export(module.exports, "getPortalAccessForbiddenRouteWithHubShell", () => (parcelRequire("1Glz5")).getPortalAccessForbiddenRouteWithHubShell);
$parcel$export(module.exports, "getPortalCompleteSignupRouteWithHubShell", () => (parcelRequire("1Glz5")).getPortalCompleteSignupRouteWithHubShell);
$parcel$export(module.exports, "getPortalInvitedSignupRouteWithHubShell", () => (parcelRequire("1Glz5")).getPortalInvitedSignupRouteWithHubShell);
$parcel$export(module.exports, "getPortalLoginRouteWithHubShell", () => (parcelRequire("1Glz5")).getPortalLoginRouteWithHubShell);
$parcel$export(module.exports, "getPortalResetPasswordRouteWithHubShell", () => (parcelRequire("1Glz5")).getPortalResetPasswordRouteWithHubShell);
$parcel$export(module.exports, "getPortalSignupRouteWithHubShell", () => (parcelRequire("1Glz5")).getPortalSignupRouteWithHubShell);
$parcel$export(module.exports, "getRequestCreateRouteWithHubShell", () => (parcelRequire("1Glz5")).getRequestCreateRouteWithHubShell);
$parcel$export(module.exports, "getRequestFeedbackRouteWithHubShell", () => (parcelRequire("1Glz5")).getRequestFeedbackRouteWithHubShell);
$parcel$export(module.exports, "getResetPasswordRouteWithHubShell", () => (parcelRequire("1Glz5")).getResetPasswordRouteWithHubShell);
$parcel$export(module.exports, "getSignupRouteWithHubShell", () => (parcelRequire("1Glz5")).getSignupRouteWithHubShell);
$parcel$export(module.exports, "getUnsubscribeRouteWithHubShell", () => (parcelRequire("1Glz5")).getUnsubscribeRouteWithHubShell);
parcelRequire("1Glz5");

});
parcelRegister("1Glz5", function(module, exports) {
$parcel$export(module.exports, "getHubHomepageRoute", () => $bcc1a03c9cce614e$export$3b1658f4569bf0ca);
$parcel$export(module.exports, "getHubCustompageRoute", () => $bcc1a03c9cce614e$export$737d1198516688ea);
$parcel$export(module.exports, "getHubPortalPageRoute", () => $bcc1a03c9cce614e$export$561a9432cf020904);
$parcel$export(module.exports, "getCsmUserProfileRouteWithHubShell", () => $bcc1a03c9cce614e$export$2a2a6f715f782520);
$parcel$export(module.exports, "getCsmRequestsListRouteWithHubShell", () => $bcc1a03c9cce614e$export$2a6efc2e2d50dd68);
$parcel$export(module.exports, "getCsmContactUsRouteWithHubShell", () => $bcc1a03c9cce614e$export$d59699c7220ea7d4);
$parcel$export(module.exports, "getNotFoundRouteWithHubShell", () => $bcc1a03c9cce614e$export$c8e491027fcd76d5);
$parcel$export(module.exports, "getCsmFolderRouteWithHubShell", () => $bcc1a03c9cce614e$export$7e31411194771e76);
$parcel$export(module.exports, "getCsmRequestDetailsRouteWithHubShell", () => $bcc1a03c9cce614e$export$eb078274575814fa);
$parcel$export(module.exports, "getCsmViewPortalArticleRouteWithHubShell", () => $bcc1a03c9cce614e$export$8628a4d0641114fc);
$parcel$export(module.exports, "getHubViewPortalArticleRoute", () => $bcc1a03c9cce614e$export$d23db2e306b7fa10);
$parcel$export(module.exports, "getPortalAccessForbiddenRouteWithHubShell", () => $bcc1a03c9cce614e$export$df37fdf84c1e0c73);
$parcel$export(module.exports, "getCsmViewArticleRouteWithHubShell", () => $bcc1a03c9cce614e$export$9bd8f060725abce6);
$parcel$export(module.exports, "getHubViewArticleRoute", () => $bcc1a03c9cce614e$export$215c0eb21c8c9bbd);
$parcel$export(module.exports, "getHubViewKbRoute", () => $bcc1a03c9cce614e$export$fe3b3b72e1ee1e3);
$parcel$export(module.exports, "getCsmViewCrossSitePortalArticleRouteWithHubShell", () => $bcc1a03c9cce614e$export$276f7d60ee8fa12a);
$parcel$export(module.exports, "getHubViewCrossSitePortalArticleRoute", () => $bcc1a03c9cce614e$export$3e0c0cee1ca6ead0);
$parcel$export(module.exports, "getHubViewCrossSiteArticleRoute", () => $bcc1a03c9cce614e$export$a2895ad4defdb0c4);
$parcel$export(module.exports, "getCsmViewCrossSiteArticleRouteWithHubShell", () => $bcc1a03c9cce614e$export$3677170bee4c0cc5);
$parcel$export(module.exports, "getLoginRouteWithHubShell", () => $bcc1a03c9cce614e$export$c80d2e838cbb1b16);
$parcel$export(module.exports, "getPortalLoginRouteWithHubShell", () => $bcc1a03c9cce614e$export$a60f6f9ee1a764cc);
$parcel$export(module.exports, "getSignupRouteWithHubShell", () => $bcc1a03c9cce614e$export$d0572cd96b5c4ab4);
$parcel$export(module.exports, "getPortalSignupRouteWithHubShell", () => $bcc1a03c9cce614e$export$cfbf23f65634d193);
$parcel$export(module.exports, "getCompleteSignupRouteWithHubShell", () => $bcc1a03c9cce614e$export$ab61a9d90fe1a668);
$parcel$export(module.exports, "getPortalCompleteSignupRouteWithHubShell", () => $bcc1a03c9cce614e$export$af956eb6d34eabf5);
$parcel$export(module.exports, "getResetPasswordRouteWithHubShell", () => $bcc1a03c9cce614e$export$ec03abb34db753b9);
$parcel$export(module.exports, "getPortalResetPasswordRouteWithHubShell", () => $bcc1a03c9cce614e$export$176415cbffecf519);
$parcel$export(module.exports, "getCheckEmailRouteWithHubShell", () => $bcc1a03c9cce614e$export$f8feb17b3d1c6ff8);
$parcel$export(module.exports, "getPortalInvitedSignupRouteWithHubShell", () => $bcc1a03c9cce614e$export$30dd11011e9a2dff);
$parcel$export(module.exports, "getUnsubscribeRouteWithHubShell", () => $bcc1a03c9cce614e$export$1b17db464925ac22);
$parcel$export(module.exports, "getRequestFeedbackRouteWithHubShell", () => $bcc1a03c9cce614e$export$dafd7c818cd58b07);
$parcel$export(module.exports, "getAnonymousRequestSuccessRouteWithHubShell", () => $bcc1a03c9cce614e$export$a02fb894ac2280da);
$parcel$export(module.exports, "getRequestCreateRouteWithHubShell", () => $bcc1a03c9cce614e$export$1914f2b2604a5e33);
$parcel$export(module.exports, "getHubUserProfileRouteWithHubShell", () => $bcc1a03c9cce614e$export$a5c23db41dcff27e);
$parcel$export(module.exports, "getJsmRequestDetailsRouteWithHubShell", () => $bcc1a03c9cce614e$export$aa08b576762efb0a);
$parcel$export(module.exports, "getJsmRequestsListRouteWithHubShell", () => $bcc1a03c9cce614e$export$603e83da51603bdd);
$parcel$export(module.exports, "getJsmApprovalsRouteWithHubShell", () => $bcc1a03c9cce614e$export$dbe932e8b71d8b83);
$parcel$export(module.exports, "getJsmRequestApprovalRouteWithHubShell", () => $bcc1a03c9cce614e$export$b5d541e9feeaef7e);

var $8P7DW = parcelRequire("8P7DW");

var $jByYr = parcelRequire("jByYr");

var $hWt0u = parcelRequire("hWt0u");
parcelRequire("9QKIl");
var $9t02C = parcelRequire("9t02C");

var $cq5Wa = parcelRequire("cq5Wa");

var $zjSHi = parcelRequire("zjSHi");

var $gonrV = parcelRequire("gonrV");
parcelRequire("e6BIw");
var $2u4W2 = parcelRequire("2u4W2");
parcelRequire("5iYcW");
var $lnAFD = parcelRequire("lnAFD");

var $7xh1z = parcelRequire("7xh1z");

var $2wFiT = parcelRequire("2wFiT");

var $33bGU = parcelRequire("33bGU");

var $1EFS8 = parcelRequire("1EFS8");

var $cLmLE = parcelRequire("cLmLE");

var $d1WV7 = parcelRequire("d1WV7");

var $kP6c6 = parcelRequire("kP6c6");

var $a373Q = parcelRequire("a373Q");

var $lspLZ = parcelRequire("lspLZ");

var $2L0mo = parcelRequire("2L0mo");

var $c126o = parcelRequire("c126o");

var $14pm9 = parcelRequire("14pm9");

var $5Fbq4 = parcelRequire("5Fbq4");

var $1ZM2A = parcelRequire("1ZM2A");

var $7dlel = parcelRequire("7dlel");

var $kpgiM = parcelRequire("kpgiM");

var $eC4tX = parcelRequire("eC4tX");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $7FSs7 = parcelRequire("7FSs7");

var $9EsDH = parcelRequire("9EsDH");

var $CYEMA = parcelRequire("CYEMA");
parcelRequire("eTJoQ");
var $bwfgf = parcelRequire("bwfgf");

var $6TwPW = parcelRequire("6TwPW");

var $dMQwV = parcelRequire("dMQwV");

var $5dezq = parcelRequire("5dezq");

var $ln5Af = parcelRequire("ln5Af");

var $5cu7I = parcelRequire("5cu7I");
parcelRequire("jWaRS");
var $b3h3N = parcelRequire("b3h3N");
parcelRequire("9vXcv");
var $iYaYV = parcelRequire("iYaYV");

var $8iplR = parcelRequire("8iplR");
parcelRequire("l8dLt");
var $74aLF = parcelRequire("74aLF");

var $hfoxB = parcelRequire("hfoxB");

var $7EEKy = parcelRequire("7EEKy");

var $cchjQ = parcelRequire("cchjQ");

var $lTEs4 = parcelRequire("lTEs4");

var $hilYh = parcelRequire("hilYh");

var $2Qxwd = parcelRequire("2Qxwd");
const $bcc1a03c9cce614e$var$helpCenterAri = (0, $jByYr.getHelpCenterAri)();
const $bcc1a03c9cce614e$var$renderAvatarMenuOptions = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iYaYV.HubAvatarMenuOptions), null);
};
const $bcc1a03c9cce614e$var$createHubRouteProps = (shouldRenderRightNavActions)=>{
    var _initialModelState$us, _initialModelState$us2, _initialModelState$us3, _initialModelState$us4;
    const initialModelState = (0, $9EsDH.default)();
    const renderRightNavActions = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bwfgf.default), {
            trigger: "icon"
        });
    };
    const isHelpHub = (0, $gk18s.getIsHelpHub)();
    return {
        renderRightNavActions: shouldRenderRightNavActions ? renderRightNavActions : undefined,
        renderAvatarMenuOptions: isHelpHub ? $bcc1a03c9cce614e$var$renderAvatarMenuOptions : undefined,
        user: {
            email: ((_initialModelState$us = initialModelState.user) === null || _initialModelState$us === void 0 ? void 0 : _initialModelState$us.email) || '',
            displayName: ((_initialModelState$us2 = initialModelState.user) === null || _initialModelState$us2 === void 0 ? void 0 : _initialModelState$us2.displayName) || '',
            avatarSrc: ((_initialModelState$us3 = initialModelState.user) === null || _initialModelState$us3 === void 0 || (_initialModelState$us3 = _initialModelState$us3.avatars) === null || _initialModelState$us3 === void 0 ? void 0 : _initialModelState$us3.xlarge) || '',
            isJiraAdmin: ((_initialModelState$us4 = initialModelState.user) === null || _initialModelState$us4 === void 0 ? void 0 : _initialModelState$us4.canAdministerJIRA) || false,
            id: ''
        },
        env: {
            helpCenterAri: $bcc1a03c9cce614e$var$helpCenterAri,
            cloudId: (0, $jByYr.getCloudId)(),
            helpCenterId: $bcc1a03c9cce614e$var$helpCenterAri && $bcc1a03c9cce614e$var$helpCenterAri !== 'null' ? (0, $cLmLE.HelpHelpCenterAri).parse($bcc1a03c9cce614e$var$helpCenterAri).helpCenterId : '',
            jiraDisplayUrl: (0, $hrPHR.getJiraDisplayUrl)(),
            hoistedProjectKey: (0, $hrPHR.getHoistedProjectKey)() || '',
            relativeBaseUrl: (0, $7FSs7.getRelativeBasePath)()
        },
        featureFlags: {
            enable_rovo_in_help_hubs: isHelpHub && (0, $1EFS8.default).checkGate('enable_rovo_in_help_hubs'),
            hub_component_upgrade: isHelpHub && (0, $1EFS8.default).checkGate('hub_component_upgrade'),
            hub_editor_floating_toolbar: isHelpHub && (0, $1EFS8.default).checkGate('hub_editor_floating_toolbar'),
            'portal-pages-in-hub': isHelpHub && (0, $1EFS8.default).checkGate('portal-pages-in-hub')
        },
        actions: {
            onLogoutClick: ()=>{
                const action = (0, $dMQwV.logOutAction)();
                (0, $5dezq.store).dispatch(action);
                return action;
            }
        }
    };
};
const $bcc1a03c9cce614e$var$createRouteWithHubShell = (...args)=>{
    const [props, component, ...restArgs] = args;
    return (0, $6TwPW.createRouteWithHubShell)(props, (0, $CYEMA.withSetThemeColorInRedux)((0, $hWt0u.withPathParamProvider)(component)), ...restArgs);
};
const $bcc1a03c9cce614e$export$3b1658f4569bf0ca = ()=>(0, $6TwPW.createHubHomepageRoute)($bcc1a03c9cce614e$var$createHubRouteProps(false));
const $bcc1a03c9cce614e$export$737d1198516688ea = ()=>(0, $6TwPW.createHubCustomPageRoute)($bcc1a03c9cce614e$var$createHubRouteProps(true));
const $bcc1a03c9cce614e$export$561a9432cf020904 = ()=>(0, $6TwPW.createHubPortalPageRoute)($bcc1a03c9cce614e$var$createHubRouteProps(true));
const $bcc1a03c9cce614e$export$2a2a6f715f782520 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $lTEs4.CsmUserProfileForHubs), (0, $2Qxwd.HUB_ROUTES).USER_PROFILE.path, (0, $2Qxwd.HUB_ROUTES).USER_PROFILE.name, [], 'full-width');
const $bcc1a03c9cce614e$export$2a6efc2e2d50dd68 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $7dlel.CsmRequestsListForHubs), (0, $2Qxwd.HUB_ROUTES).CSM_REQUESTS_LIST.path, (0, $2Qxwd.HUB_ROUTES).CSM_REQUESTS_LIST.name, [
        (0, $kpgiM.csmRequestsListQueryResource)
    ], 'full-width');
const $bcc1a03c9cce614e$export$d59699c7220ea7d4 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $d1WV7.CsmContactUsForHubs), (0, $2Qxwd.HUB_ROUTES).CSM_CONTACT_US.path, (0, $2Qxwd.HUB_ROUTES).CSM_CONTACT_US.name, [
        (0, $eC4tX.mediaUploadCredentialsResource)
    ], 'full-width');
const $bcc1a03c9cce614e$export$c8e491027fcd76d5 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $9t02C.NotFoundPage), (0, $2Qxwd.HUB_ROUTES).NOT_FOUND.path, (0, $2Qxwd.HUB_ROUTES).NOT_FOUND.name, [], 'normal');
const $bcc1a03c9cce614e$export$7e31411194771e76 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $kP6c6.CsmFolderForHubs), (0, $2Qxwd.HUB_ROUTES).CSM_FOLDER.path, (0, $2Qxwd.HUB_ROUTES).CSM_FOLDER.name, [
        (0, $lspLZ.CsmFolderResource),
        (0, $a373Q.CsmEmptyFolderResource)
    ], 'full-width');
const $bcc1a03c9cce614e$export$eb078274575814fa = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $1ZM2A.AsyncCsmRequestDetails), (0, $2Qxwd.HUB_ROUTES).CSM_REQUEST_DETAILS.path, (0, $2Qxwd.HUB_ROUTES).CSM_REQUEST_DETAILS.name, [
        (0, $2L0mo.csmRequestDetailsQueryResource),
        (0, $5Fbq4.requestConversationResource),
        (0, $c126o.mediaReadCredentialsResource),
        (0, $14pm9.mediaUploadCredentialsResource)
    ], 'xxwide');
const $bcc1a03c9cce614e$var$articlePageWidth = (0, $1EFS8.default).checkGate('fix_kb_article_scroll') ? 'wide' : 'normal';
const $bcc1a03c9cce614e$export$8628a4d0641114fc = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $cq5Wa.CsmArticle), (0, $2Qxwd.HUB_ROUTES).VIEW_PORTAL_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_PORTAL_ARTICLE.name, [], $bcc1a03c9cce614e$var$articlePageWidth);
const $bcc1a03c9cce614e$export$d23db2e306b7fa10 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $5cu7I.Article), (0, $2Qxwd.HUB_ROUTES).VIEW_PORTAL_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_PORTAL_ARTICLE.name, [], $bcc1a03c9cce614e$var$articlePageWidth);
const $bcc1a03c9cce614e$export$df37fdf84c1e0c73 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $lnAFD.default), (0, $2Qxwd.HUB_ROUTES).PORTAL_ACCESS_FORBIDDEN.path, (0, $2Qxwd.HUB_ROUTES).PORTAL_ACCESS_FORBIDDEN.name, [], 'normal');
const $bcc1a03c9cce614e$export$9bd8f060725abce6 = ()=>{
    if ((0, $1EFS8.default).checkGate('csm_support_site_article_view_custom_width_fix')) return $bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $cq5Wa.CsmArticle), (0, $2Qxwd.HUB_ROUTES).VIEW_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_ARTICLE.name, [], 'full-width');
    return $bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $cq5Wa.CsmArticle), (0, $2Qxwd.HUB_ROUTES).VIEW_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_ARTICLE.name, [], 'normal');
};
const $bcc1a03c9cce614e$export$215c0eb21c8c9bbd = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $5cu7I.Article), (0, $2Qxwd.HUB_ROUTES).VIEW_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_ARTICLE.name, [], 'normal');
const $bcc1a03c9cce614e$export$fe3b3b72e1ee1e3 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(true),
        appearance: 'full-width'
    }, (0, $5cu7I.Article), (0, $2Qxwd.HUB_ROUTES).VIEW_KB_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_KB_ARTICLE.name, [], 'normal');
const $bcc1a03c9cce614e$export$276f7d60ee8fa12a = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $cq5Wa.CsmArticle), (0, $2Qxwd.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.name, [], 'normal');
const $bcc1a03c9cce614e$export$3e0c0cee1ca6ead0 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $5cu7I.Article), (0, $2Qxwd.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.name, [], 'normal');
const $bcc1a03c9cce614e$export$a2895ad4defdb0c4 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $5cu7I.Article), (0, $2Qxwd.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.name, [], 'normal');
const $bcc1a03c9cce614e$export$3677170bee4c0cc5 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $cq5Wa.CsmArticle), (0, $2Qxwd.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.path, (0, $2Qxwd.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.name, [], 'normal');
const $bcc1a03c9cce614e$export$c80d2e838cbb1b16 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2u4W2.default), null)), (0, $2Qxwd.HUB_ROUTES).LOGIN.path, (0, $2Qxwd.HUB_ROUTES).LOGIN.name, [], 'note');
const $bcc1a03c9cce614e$export$a60f6f9ee1a764cc = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2u4W2.default), null)), (0, $2Qxwd.HUB_ROUTES).PORTAL_LOGIN.path, (0, $2Qxwd.HUB_ROUTES).PORTAL_LOGIN.name, [], 'note');
const $bcc1a03c9cce614e$export$d0572cd96b5c4ab4 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2wFiT.SignUp), routeProps)), (0, $2Qxwd.HUB_ROUTES).SIGNUP.path, (0, $2Qxwd.HUB_ROUTES).SIGNUP.name, [], 'note');
const $bcc1a03c9cce614e$export$cfbf23f65634d193 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2wFiT.SignUp), routeProps)), (0, $2Qxwd.HUB_ROUTES).PORTAL_SIGNUP.path, (0, $2Qxwd.HUB_ROUTES).PORTAL_SIGNUP.name, [], 'note');
const $bcc1a03c9cce614e$export$ab61a9d90fe1a668 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $zjSHi.CompleteSignup), routeProps)), (0, $2Qxwd.HUB_ROUTES).COMPLETE_SIGNUP.path, (0, $2Qxwd.HUB_ROUTES).COMPLETE_SIGNUP.name, [], 'note');
const $bcc1a03c9cce614e$export$af956eb6d34eabf5 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $zjSHi.CompleteSignup), routeProps)), (0, $2Qxwd.HUB_ROUTES).PORTAL_COMPLETE_SIGNUP.path, (0, $2Qxwd.HUB_ROUTES).PORTAL_COMPLETE_SIGNUP.name, [], 'note');
const $bcc1a03c9cce614e$export$ec03abb34db753b9 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7xh1z.ResetPassword), routeProps)), (0, $2Qxwd.HUB_ROUTES).RESET_PASSWORD.path, (0, $2Qxwd.HUB_ROUTES).RESET_PASSWORD.name, [], 'note');
const $bcc1a03c9cce614e$export$176415cbffecf519 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7xh1z.ResetPassword), routeProps)), (0, $2Qxwd.HUB_ROUTES).PORTAL_RESET_PASSWORD.path, (0, $2Qxwd.HUB_ROUTES).PORTAL_RESET_PASSWORD.name, [], 'note');
const $bcc1a03c9cce614e$export$f8feb17b3d1c6ff8 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $33bGU.CheckEmail), {
            ...routeProps,
            isLoading: false
        })), (0, $2Qxwd.HUB_ROUTES).CHECK_EMAIL.path, (0, $2Qxwd.HUB_ROUTES).CHECK_EMAIL.name, [], 'note');
const $bcc1a03c9cce614e$export$30dd11011e9a2dff = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b3h3N.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gonrV.InvitedSignUp), null)), (0, $2Qxwd.HUB_ROUTES).PORTAL_INVITED_SIGNUP.path, (0, $2Qxwd.HUB_ROUTES).PORTAL_INVITED_SIGNUP.name, [], 'note');
const $bcc1a03c9cce614e$export$1b17db464925ac22 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $cchjQ.Unsubscribe), (0, $2Qxwd.HUB_ROUTES).UNSUBSCRIBE.path, (0, $2Qxwd.HUB_ROUTES).UNSUBSCRIBE.name, [], 'note');
const $bcc1a03c9cce614e$export$dafd7c818cd58b07 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $hfoxB.RequestFeedback), (0, $2Qxwd.HUB_ROUTES).REQUEST_FEEDBACK.path, (0, $2Qxwd.HUB_ROUTES).REQUEST_FEEDBACK.name, [], 'note');
const $bcc1a03c9cce614e$export$a02fb894ac2280da = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $9t02C.RenderCreateAnonymousSuccess), (0, $2Qxwd.HUB_ROUTES).ANONYMOUS_REQUEST_SUCCESS.path, (0, $2Qxwd.HUB_ROUTES).ANONYMOUS_REQUEST_SUCCESS.name, [], 'xxwide');
const $bcc1a03c9cce614e$export$1914f2b2604a5e33 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $9t02C.RenderRequestCreateForHubs), (0, $2Qxwd.HUB_ROUTES).REQUEST_CREATE.path, (0, $2Qxwd.HUB_ROUTES).REQUEST_CREATE.name, [], 'full-width');
const $bcc1a03c9cce614e$export$a5c23db41dcff27e = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $hilYh.UserProfileForHubs), (0, $2Qxwd.HUB_ROUTES).USER_PROFILE.path, (0, $2Qxwd.HUB_ROUTES).USER_PROFILE.name, [], 'full-width');
const $bcc1a03c9cce614e$export$aa08b576762efb0a = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell($bcc1a03c9cce614e$var$createHubRouteProps(true), (0, $74aLF.default), (0, $2Qxwd.HUB_ROUTES).JSM_REQUEST_DETAILS.path, (0, $2Qxwd.HUB_ROUTES).JSM_REQUEST_DETAILS.name, [], 'xxwide');
const $bcc1a03c9cce614e$export$603e83da51603bdd = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell(/**
 * TODO: The banner text has to be internationalized
 */ {
        ...$bcc1a03c9cce614e$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: 'Requests',
            isAnonymousRoute: false
        }
    }, (0, $7EEKy.RequestList), (0, $2Qxwd.HUB_ROUTES).JSM_REQUESTS_LIST.path, (0, $2Qxwd.HUB_ROUTES).JSM_REQUESTS_LIST.name, [], 'xxwide');
const $bcc1a03c9cce614e$export$dbe932e8b71d8b83 = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: 'Approvals',
            isAnonymousRoute: false
        }
    }, (0, $ln5Af.ApprovalList), (0, $2Qxwd.HUB_ROUTES).JSM_APPROVALS.path, (0, $2Qxwd.HUB_ROUTES).JSM_APPROVALS.name, [], 'xxwide');
const $bcc1a03c9cce614e$export$b5d541e9feeaef7e = ()=>$bcc1a03c9cce614e$var$createRouteWithHubShell({
        ...$bcc1a03c9cce614e$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $8iplR.RequestApproval), (0, $2Qxwd.HUB_ROUTES).JSM_REQUEST_APPROVAL.path, (0, $2Qxwd.HUB_ROUTES).JSM_REQUEST_APPROVAL.name, [], 'xxwide');

});
parcelRegister("d1WV7", function(module, exports) {
$parcel$export(module.exports, "CsmContactUsForHubs", () => $07849d5936f12d16$export$18dcede65e3972a9);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $07849d5936f12d16$export$18dcede65e3972a9 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("fT7rt")), {
        moduleId: "./packages/customer-service/csm-contact-us/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("fT7rt", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("gRGGD"),
    $j9MRt("iEFkY"),
    $j9MRt("2HGZt"),
    $j9MRt("1j2Ac"),
    $j9MRt("fSmVB"),
    $j9MRt("8lt3h"),
    $j9MRt("217Xp"),
    $j9MRt("TRkIS"),
    $j9MRt("7UfmT"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("hcxtc"),
    $j9MRt("lN4QY"),
    $j9MRt("i93oX")
]).then(()=>parcelRequire('3ySwb'));

});


parcelRegister("kP6c6", function(module, exports) {
$parcel$export(module.exports, "CsmFolderForHubs", () => $a7b8698c620f80d4$export$46d643ae94fd657a);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $a7b8698c620f80d4$export$46d643ae94fd657a = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("izgfV")), {
        moduleId: "./packages/customer-service/csm-folder/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("izgfV", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("3B1TD"),
    $j9MRt("4rRPv")
]).then(()=>parcelRequire('40nQS'));

});


parcelRegister("7dlel", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsListForHubs", () => $692c6af379724729$export$3f37ab3da4f058a);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $692c6af379724729$export$3f37ab3da4f058a = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("iXZfH")), {
        moduleId: "./packages/customer-service/csm-requests-list/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("iXZfH", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("cVF3D"),
    $j9MRt("i98k0"),
    $j9MRt("8ZeM9"),
    $j9MRt("eyo81"),
    $j9MRt("5C1DQ")
]).then(()=>parcelRequire('jx9VR'));

});


parcelRegister("CYEMA", function(module, exports) {
$parcel$export(module.exports, "withSetThemeColorInRedux", () => $abb1954e156af2cd$export$e14001b3f71f56fc);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $6DnuY = parcelRequire("6DnuY");
const $abb1954e156af2cd$export$e14001b3f71f56fc = (InnerComponent)=>{
    const Component = (props)=>{
        const { bannerBackgroundColor: bannerBackgroundColor, setThemeColor: setThemeColor } = props;
        $8P7DW.useEffect(()=>{
            if (bannerBackgroundColor) setThemeColor({
                themeColor: bannerBackgroundColor
            });
        }, [
            bannerBackgroundColor,
            setThemeColor
        ]);
        return /*#__PURE__*/ $8P7DW.createElement(InnerComponent, props);
    };
    return (0, $jvoWT.default)(null, {
        setThemeColor: (0, $6DnuY.updateHCThemeColorAction)
    })(Component);
};

});

parcelRegister("6TwPW", function(module, exports) {
$parcel$export(module.exports, "createHubHomepageRoute", () => $f259e696883e18dd$export$5dafaf7a5091e51);
$parcel$export(module.exports, "createHubCustomPageRoute", () => $f259e696883e18dd$export$394540a667e798bf);
$parcel$export(module.exports, "createHubPortalPageRoute", () => $f259e696883e18dd$export$c7ef2adac2336d4a);
$parcel$export(module.exports, "createRouteWithHubShell", () => $f259e696883e18dd$export$bf7b7ea558d32a05);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("9wocP");
var $bDnSZ = parcelRequire("bDnSZ");

var $e6Qdr = parcelRequire("e6Qdr");

var $4peLG = parcelRequire("4peLG");

var $bZZgp = parcelRequire("bZZgp");

var $cjn3r = parcelRequire("cjn3r");

var $lxDv6 = parcelRequire("lxDv6");
var $MLtq6 = parcelRequire("MLtq6");
var $dI6dR = parcelRequire("dI6dR");
var $g56Er = parcelRequire("g56Er");

var $cgbM9 = parcelRequire("cgbM9");

var $6cLgn = parcelRequire("6cLgn");

var $70yzM = parcelRequire("70yzM");

var $ceBSw = parcelRequire("ceBSw");

var $4qYYH = parcelRequire("4qYYH");

var $6MtS4 = parcelRequire("6MtS4");
const $f259e696883e18dd$var$styles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc",
    root: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx21bp4 _1tke1osq _1bsb1osq"
};
const $f259e696883e18dd$export$74c90840fe177d0a = {
    component: (0, $ceBSw.HubApp),
    exact: true,
    name: (0, $6MtS4.HUB_ROUTE_NAME),
    resources: [
        (0, $6cLgn.hubBootstrapResource),
        (0, $6cLgn.hubPageResource)
    ],
    path: (0, $6MtS4.HUB_ROUTE_PATH)
};
const $f259e696883e18dd$export$ccad182393585435 = {
    component: (0, $ceBSw.HubApp),
    exact: true,
    name: (0, $6MtS4.HUB_CUSTOM_PAGE_ROUTE_NAME),
    resources: [
        (0, $6cLgn.hubBootstrapResource),
        (0, $6cLgn.hubPageResource)
    ],
    path: (0, $6MtS4.HUB_CUSTOM_PAGE_ROUTE_PATH)
};
const $f259e696883e18dd$var$isSupportSiteHeaderlessEnabled = ()=>typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('headerless') === 'true' && (0, $e6Qdr.fg)('csm-support-site-headerless-query-param');
const $f259e696883e18dd$export$5dafaf7a5091e51 = (hubAppProps)=>{
    const HubAppComponent = ()=>{
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ceBSw.HubApp), {
            ...hubAppProps,
            headerless: $f259e696883e18dd$var$isSupportSiteHeaderlessEnabled(),
            showPageNameAsHubDocumentTitle: true
        });
    };
    return {
        ...$f259e696883e18dd$export$74c90840fe177d0a,
        component: HubAppComponent
    };
};
const $f259e696883e18dd$export$8b1ac9e5cb498cd8 = ()=>{
    const hubRoute = $f259e696883e18dd$export$5dafaf7a5091e51((0, $g56Er.mockHubRouteProps));
    return {
        ...hubRoute,
        path: (0, $6MtS4.HUB_PREVIEW_ROUTE_PATH),
        name: (0, $6MtS4.HUB_PREVIEW_ROUTE_NAME)
    };
};
const $f259e696883e18dd$export$394540a667e798bf = (hubAppProps)=>{
    const HubCustomPageComponent = ()=>{
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ceBSw.HubApp), {
            ...hubAppProps,
            headerless: $f259e696883e18dd$var$isSupportSiteHeaderlessEnabled(),
            showPageNameAsHubDocumentTitle: true
        });
    };
    return {
        ...$f259e696883e18dd$export$ccad182393585435,
        component: HubCustomPageComponent
    };
};
const $f259e696883e18dd$export$c6260de3189c8f50 = {
    component: (0, $ceBSw.HubApp),
    exact: true,
    name: (0, $6MtS4.HUB_PORTAL_PAGE_ROUTE_NAME),
    resources: [
        (0, $6cLgn.hubBootstrapResource),
        (0, $6cLgn.hubPageResource)
    ],
    path: (0, $6MtS4.HUB_PORTAL_PAGE_ROUTE_PATH)
};
const $f259e696883e18dd$export$c7ef2adac2336d4a = (hubAppProps)=>{
    const HubPortalPageComponent = ()=>{
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ceBSw.HubApp), {
            ...hubAppProps,
            showPageNameAsHubDocumentTitle: true
        });
    };
    return {
        ...$f259e696883e18dd$export$c6260de3189c8f50,
        component: HubPortalPageComponent
    };
};
const $f259e696883e18dd$export$bf7b7ea558d32a05 = (hubAppProps, InnerComponent, path, name, resources, componentWidth)=>{
    const Component = ()=>{
        const { queryReference: hubBootstrapQueryReference } = (0, $70yzM.useRelayResource)((0, $6cLgn.hubBootstrapResource));
        if (!hubBootstrapQueryReference) return null;
        const InnerComponentWithRouter = (0, $bDnSZ.withRouter)(InnerComponent);
        const ComponentWithBannerBackgroundColor = (0, $4qYYH.withBannerBackgroundColor)(InnerComponentWithRouter);
        const cloudId = hubBootstrapQueryReference.variables.cloudId;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bZZgp.default), {
            name: "hub-shell",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dI6dR.HubErrorBoundary), {
                shouldForceError: true,
                id: "route-with-hub-shell",
                packageName: "@atlassian/hub",
                fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lxDv6.GenericErrorPage), {}),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
                    fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
                        name: "hub-shell-loader",
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                            className: (0, $8n1kL.default)([
                                $f259e696883e18dd$var$styles.spinnerContainer
                            ]),
                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                                size: 'large'
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $MLtq6.HubBootstrapWrapper), {
                        queryReference: hubBootstrapQueryReference,
                        ...hubAppProps,
                        cloudId: cloudId,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cgbM9.HubAppShell), {
                            children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                                style: {
                                    maxWidth: (0, $4qYYH.getContentWidth)(componentWidth)
                                },
                                className: (0, $8n1kL.default)([
                                    $f259e696883e18dd$var$styles.root
                                ]),
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)(ComponentWithBannerBackgroundColor, {})
                            })
                        })
                    })
                })
            })
        });
    };
    return {
        component: Component,
        exact: true,
        name: name,
        path: path,
        resources: [
            (0, $6cLgn.hubBootstrapResource),
            ...resources
        ]
    };
};

});
parcelRegister("lxDv6", function(module, exports) {
$parcel$export(module.exports, "GenericErrorPage", () => $562d0933a433ef03$export$5d76009b056f3e5d);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $fiikg = parcelRequire("fiikg");

var $iqJis = parcelRequire("iqJis");

var $6E5P5 = parcelRequire("6E5P5");
var $9pb7J = parcelRequire("9pb7J");

var $cY80l = parcelRequire("cY80l");

var $8lP9D = parcelRequire("8lP9D");
const $562d0933a433ef03$var$styles = {
    image: "_1bsbclpc",
    root: "_4t3i1osq _n3tdxncg",
    content: "_y3gn1h6o _p12f1dup"
};
const $562d0933a433ef03$export$5d76009b056f3e5d = ()=>{
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6E5P5.default), {
        alignInline: "center",
        space: "space.200",
        alignBlock: "center",
        xcss: $562d0933a433ef03$var$styles.root,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($cY80l))),
                alt: "error page",
                className: (0, $8n1kL.default)([
                    $562d0933a433ef03$var$styles.image
                ])
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    $562d0933a433ef03$var$styles.content
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6E5P5.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                            size: "xlarge",
                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                ...(0, $8lP9D.default).genericErrorHeading
                            })
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                ...(0, $8lP9D.default).genericErrorDescription
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("cY80l", function(module, exports) {
module.exports = new URL("../images/error-icon.fcea7b28.svg", import.meta.url).toString();

});

parcelRegister("8lP9D", function(module, exports) {
$parcel$export(module.exports, "default", () => $aae7bb7b419dc826$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $aae7bb7b419dc826$var$_default_1 = (0, $6K2Gm.defineMessages)({
    genericErrorHeading: {
        id: 'company-hub.generic-error-page.heading',
        defaultMessage: "We're on it",
        description: 'Heading for the generic error page'
    },
    genericErrorDescription: {
        id: 'company-hub.generic-error-page.description',
        defaultMessage: 'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
        description: 'Description for the generic error page'
    }
});
var $aae7bb7b419dc826$export$2e2bcd8739ae039 = $aae7bb7b419dc826$var$_default_1;

});


parcelRegister("MLtq6", function(module, exports) {
$parcel$export(module.exports, "HubBootstrap", () => $cd4a36ba284c14f9$export$caae1ac058a7a032);
$parcel$export(module.exports, "HubBootstrapWrapper", () => $cd4a36ba284c14f9$export$5f7521758ed90a1b);

var $gWgPx = parcelRequire("gWgPx");

var $3G5XU = parcelRequire("3G5XU");

var $7b26q = parcelRequire("7b26q");

var $gmI1X = parcelRequire("gmI1X");

var $8P7DW = parcelRequire("8P7DW");

var $h3cOB = parcelRequire("h3cOB");

var $2fABU = parcelRequire("2fABU");

var $fTpWL = parcelRequire("fTpWL");

var $8NbLB = parcelRequire("8NbLB");

var $fcpCb = parcelRequire("fcpCb");
const $cd4a36ba284c14f9$export$caae1ac058a7a032 = ({ bootstrapQueryReference: bootstrapQueryReference, tenantContextsQueryReference: tenantContextsQueryReference, children: children, cloudId: cloudId, isInPreviewMode: isInPreviewMode = false, ...props })=>{
    var _tenantData$tenantCon, _data$helpCenterById, _branding$colors, _data$helpCenterById2;
    const data = (0, $h3cOB.useFragment)((0, $gmI1X.default), bootstrapQueryReference);
    const tenantData = (0, $h3cOB.useFragment)((0, $7b26q.default), tenantContextsQueryReference);
    const cloudUrl = ((_tenantData$tenantCon = tenantData.tenantContexts) === null || _tenantData$tenantCon === void 0 || (_tenantData$tenantCon = _tenantData$tenantCon[0]) === null || _tenantData$tenantCon === void 0 ? void 0 : _tenantData$tenantCon.cloudUrl) ?? window.location.origin;
    if (!data.helpCenterById) throw new Error('Help center not found');
    const branding = (_data$helpCenterById = data.helpCenterById) === null || _data$helpCenterById === void 0 ? void 0 : _data$helpCenterById.helpCenterBranding;
    const logo = branding === null || branding === void 0 ? void 0 : branding.logo;
    const primaryColor = (branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary) ?? undefined;
    const fileId = (logo === null || logo === void 0 ? void 0 : logo.fileId) || '';
    const url = (logo === null || logo === void 0 ? void 0 : logo.url) || '';
    const hubType = ((_data$helpCenterById2 = data.helpCenterById) === null || _data$helpCenterById2 === void 0 ? void 0 : _data$helpCenterById2.type) || '';
    const navigationBar = (branding === null || branding === void 0 ? void 0 : branding.navigationBar) ?? null;
    const navStyleOptions = (0, $8P7DW.useMemo)(()=>({
            options: navigationBar ? (0, $fcpCb.mapApiToNavigationOptions)(navigationBar, primaryColor) : null,
            setOptions: ()=>void 0
        }), [
        navigationBar,
        primaryColor
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8NbLB.HubContext).Provider, {
        value: {
            pageMediaConfig: data.pageMediaConfig,
            hubMediaConfig: data.hubMediaConfig,
            branding: {
                logo: {
                    fileId: fileId,
                    url: url
                },
                colors: {
                    primary: primaryColor || (0, $2fABU.DEFAULT_BRANDING_COLOR)
                }
            },
            layout: props.layout,
            user: props.user,
            env: props.env,
            actions: props.actions,
            containerStyling: props.containerStyling,
            renderAvatarMenuOptions: props.renderAvatarMenuOptions,
            renderRightNavActions: props.renderRightNavActions,
            featureFlags: props.featureFlags,
            headerless: props.headerless,
            cloudId: cloudId,
            cloudUrl: cloudUrl,
            hubType: hubType,
            isInPreviewMode: isInPreviewMode
        },
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fTpWL.NavigationStyleContext).Provider, {
            value: navStyleOptions,
            children: children
        })
    });
};
const $cd4a36ba284c14f9$export$5f7521758ed90a1b = ({ children: children, queryReference: queryReference, ...props })=>{
    const data = (0, $h3cOB.usePreloadedQuery)((0, $3G5XU.default), queryReference);
    if (!data.helpCenter) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)($cd4a36ba284c14f9$export$caae1ac058a7a032, {
        bootstrapQueryReference: data.helpCenter,
        tenantContextsQueryReference: data,
        ...props,
        children: children
    });
};

});
parcelRegister("3G5XU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2315fb88213ce37f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<da5b98bdbb3b5d45db3c08eab798efd6>>
 * @relayHash 57b4bb3acd15631c8c9dfd0bed7e9b44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4022831f47fbe75e743cc366c372d6f1434e902abda956a325a71b539f547a6f
const $2315fb88213ce37f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubEditMode"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v6 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "asapIssuer"
        },
        {
            "kind": "ScalarField",
            "name": "mediaCollectionName"
        },
        {
            "kind": "ScalarField",
            "name": "mediaToken"
        },
        {
            "kind": "ScalarField",
            "name": "mediaUrl"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubBootstrapWrapperQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubBootstrapWrapperQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "hubAri"
                                },
                                v6 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        },
                        {
                            "alias": "pageMediaConfig",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "pageAri"
                                },
                                v6 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "hubAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterNavigationBar",
                                                    "kind": "LinkedField",
                                                    "name": "navigationBar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "backgroundColor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "borderColor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "borderType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cornerRadius"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "padding"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "positionType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "textColor"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "hubEditMode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cloudUrl"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4022831f47fbe75e743cc366c372d6f1434e902abda956a325a71b539f547a6f",
            "metadata": {},
            "name": "hubBootstrapWrapperQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2315fb88213ce37f$var$node.hash = "fc48fc6598d48c617cc16e7581ac6b2b";
var $2315fb88213ce37f$export$2e2bcd8739ae039 = $2315fb88213ce37f$var$node;

});

parcelRegister("7b26q", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e94b2ff8700d31c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14c188b33099b76141a45d4bf7c7351c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9e94b2ff8700d31c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "hubEditMode"
        }
    ],
    "kind": "Fragment",
    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference",
    "selections": [
        {
            "condition": "hubEditMode",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudIds.0",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "cloudIds"
                        }
                    ],
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cloudUrl"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$9e94b2ff8700d31c$var$node.hash = "951df66590a0cca5f7516d267ed12179";
var $9e94b2ff8700d31c$export$2e2bcd8739ae039 = $9e94b2ff8700d31c$var$node;

});

parcelRegister("gmI1X", function(module, exports) {
$parcel$export(module.exports, "default", () => $cab0eb9b652bde26$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6e9192d3b5b566887b411e7f1e81063>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cab0eb9b652bde26$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v1 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v2 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v4 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "hubAri"
            },
            {
                "kind": "RootArgument",
                "name": "operationType"
            },
            {
                "kind": "RootArgument",
                "name": "pageAri"
            }
        ],
        "kind": "Fragment",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "hubAri"
                        },
                        v0 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterMediaConfig",
                    "kind": "LinkedField",
                    "name": "hubMediaConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "hubMediaConfig.asapIssuer"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v2 /*: any*/ ,
                            "action": "THROW",
                            "path": "hubMediaConfig.mediaCollectionName"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "hubMediaConfig.mediaToken"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v4 /*: any*/ ,
                            "action": "THROW",
                            "path": "hubMediaConfig.mediaUrl"
                        }
                    ]
                },
                "action": "THROW",
                "path": "hubMediaConfig"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "pageMediaConfig",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "pageAri"
                        },
                        v0 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterMediaConfig",
                    "kind": "LinkedField",
                    "name": "hubMediaConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "pageMediaConfig.asapIssuer"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v2 /*: any*/ ,
                            "action": "THROW",
                            "path": "pageMediaConfig.mediaCollectionName"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "pageMediaConfig.mediaToken"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v4 /*: any*/ ,
                            "action": "THROW",
                            "path": "pageMediaConfig.mediaUrl"
                        }
                    ]
                },
                "action": "THROW",
                "path": "pageMediaConfig"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "helpCenterAri",
                        "variableName": "hubAri"
                    }
                ],
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            {
                                "concreteType": "HelpCenterBranding",
                                "kind": "LinkedField",
                                "name": "helpCenterBranding",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "HelpCenterLogo",
                                        "kind": "LinkedField",
                                        "name": "logo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "fileId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterBrandingColors",
                                        "kind": "LinkedField",
                                        "name": "colors",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "primary"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterNavigationBar",
                                        "kind": "LinkedField",
                                        "name": "navigationBar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "backgroundColor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "borderColor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "borderType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cornerRadius"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "padding"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "positionType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "textColor"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "HelpCenter"
                    }
                ]
            }
        ],
        "type": "HelpCenterQueryApi"
    };
}();
$cab0eb9b652bde26$var$node.hash = "82ac914cbee5ed69f1ef825f27d57201";
var $cab0eb9b652bde26$export$2e2bcd8739ae039 = $cab0eb9b652bde26$var$node;

});

parcelRegister("2fABU", function(module, exports) {
$parcel$export(module.exports, "SPOTLIGHT_EXTENSION_TYPE", () => $a24ceecbafba3b1d$export$df3c2062a081a534);
$parcel$export(module.exports, "SECTION_EXTENSION_TYPE", () => $a24ceecbafba3b1d$export$4454075c4322ae47);
$parcel$export(module.exports, "RESOURCE_TILES_EXTENSION_TYPE", () => $a24ceecbafba3b1d$export$2dd5fc71941a6787);
$parcel$export(module.exports, "DEFAULT_BRANDING_COLOR", () => $a24ceecbafba3b1d$export$8e1a1e8b8109dbf3);
$parcel$export(module.exports, "HUB_PRIMARY_COLOR_CSS_VAR", () => $a24ceecbafba3b1d$export$8161b1f4e2928fa0);
$parcel$export(module.exports, "HUB_PRIMARY_TEXT_COLOR_CSS_VAR", () => $a24ceecbafba3b1d$export$94d2a2331edd895d);
$parcel$export(module.exports, "HUB_PRIMARY_LINK_COLOR_CSS_VAR", () => $a24ceecbafba3b1d$export$64de52c9db8240f6);
$parcel$export(module.exports, "HUB_LOGO_HEIGHT", () => $a24ceecbafba3b1d$export$4c91e7265b76e3a1);
$parcel$export(module.exports, "HUB_LOGO_HEIGHT_LEGACY", () => $a24ceecbafba3b1d$export$d713f99e5e84a256);
$parcel$export(module.exports, "SENTRY_DSN", () => $a24ceecbafba3b1d$export$6faa4a850bc4d0ce);
$parcel$export(module.exports, "UNKNOWN_TAG", () => $a24ceecbafba3b1d$export$ea77880e3935182d);
$parcel$export(module.exports, "NETWORK_ERROR_CODE", () => $a24ceecbafba3b1d$export$c7f012c6e67c4217);
const $a24ceecbafba3b1d$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $a24ceecbafba3b1d$export$df3c2062a081a534 = 'com.atlassian.confluence.spotlight';
const $a24ceecbafba3b1d$export$4454075c4322ae47 = 'com.atlassian.confluence.hub-section';
const $a24ceecbafba3b1d$export$2dd5fc71941a6787 = 'com.atlassian.confluence.knowledge-cards';
const $a24ceecbafba3b1d$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $a24ceecbafba3b1d$export$514105ca7c79025d = 'com.atlassian.confluence.carousel';
const $a24ceecbafba3b1d$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $a24ceecbafba3b1d$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $a24ceecbafba3b1d$export$8e1a1e8b8109dbf3 = '#DDDEE1';
const $a24ceecbafba3b1d$export$8161b1f4e2928fa0 = '--hub-primary-color';
const $a24ceecbafba3b1d$export$94d2a2331edd895d = '--hub-primary-text-color';
const $a24ceecbafba3b1d$export$64de52c9db8240f6 = '--hub-primary-link-color';
const $a24ceecbafba3b1d$export$4c91e7265b76e3a1 = '32px';
const $a24ceecbafba3b1d$export$d713f99e5e84a256 = '40px'; // Pre-standardization height for CSM fallback
const $a24ceecbafba3b1d$export$6faa4a850bc4d0ce = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
const $a24ceecbafba3b1d$export$ea77880e3935182d = 'unknown';
const $a24ceecbafba3b1d$export$c7f012c6e67c4217 = 0;

});

parcelRegister("fTpWL", function(module, exports) {
$parcel$export(module.exports, "NavigationStyleContext", () => $9dbb238e1c699066$export$2c6067e95d1be081);
$parcel$export(module.exports, "useNavigationStyle", () => $9dbb238e1c699066$export$ce205152a61c4e11);

var $8P7DW = parcelRequire("8P7DW");
const $9dbb238e1c699066$var$noop = ()=>{};
const $9dbb238e1c699066$export$2c6067e95d1be081 = (0, $8P7DW.createContext)({
    options: null,
    setOptions: $9dbb238e1c699066$var$noop
});
const $9dbb238e1c699066$export$ce205152a61c4e11 = ()=>(0, $8P7DW.useContext)($9dbb238e1c699066$export$2c6067e95d1be081);

});

parcelRegister("8NbLB", function(module, exports) {
$parcel$export(module.exports, "getMediaProvider", () => $8d76ab54e6474113$export$98e696b66f6bbf2b);
$parcel$export(module.exports, "HubContext", () => $8d76ab54e6474113$export$6a5aa704056d141b);
$parcel$export(module.exports, "useHubContext", () => $8d76ab54e6474113$export$ac8576a9912be18c);

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $cLmLE = parcelRequire("cLmLE");
var $78eL2 = parcelRequire("78eL2");
const $8d76ab54e6474113$export$9a47313ad5d1f7c3 = (asapIssuer, mediaToken, mediaUrl)=>async ()=>{
        return {
            asapIssuer: asapIssuer,
            token: mediaToken,
            baseUrl: mediaUrl
        };
    };
const $8d76ab54e6474113$export$98e696b66f6bbf2b = (mediaCollectionName, asapIssuer, mediaToken, mediaUrl, isUploadMediaConfigRequired)=>{
    const authProvider = $8d76ab54e6474113$export$9a47313ad5d1f7c3(asapIssuer, mediaToken, mediaUrl);
    return {
        uploadParams: {
            collection: mediaCollectionName
        },
        viewMediaClientConfig: {
            authProvider: authProvider,
            useSha256ForUploads: true
        },
        ...isUploadMediaConfigRequired && (0, $e6Qdr.fg)('enable-upload-media') && {
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        }
    };
};
const $8d76ab54e6474113$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null') {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $8d76ab54e6474113$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $8d76ab54e6474113$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    return (0, $78eL2.HelpPageAri).create({
        activationId: activationId,
        pageId: pageId || helpCenterId
    }).toString() || '';
};
const $8d76ab54e6474113$export$6a5aa704056d141b = (0, $8P7DW.createContext)(null);
const $8d76ab54e6474113$export$ac8576a9912be18c = ()=>{
    const context = (0, $8P7DW.useContext)($8d76ab54e6474113$export$6a5aa704056d141b);
    if (!context) throw new Error('useHubContext must be used within a HubContextProvider');
    return context;
};

});

parcelRegister("fcpCb", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_NAVIGATION_OPTIONS", () => $ee4a6c4312ad3761$export$cfca0f39600e333c);
$parcel$export(module.exports, "getDefaultNavigationOptions", () => $ee4a6c4312ad3761$export$5046aed2fe45af56);
$parcel$export(module.exports, "mapApiToNavigationOptions", () => $ee4a6c4312ad3761$export$b35e3817d72db278);

var $hmxnn = parcelRequire("hmxnn");
const $ee4a6c4312ad3761$var$readableTextColor = (color)=>(0, $hmxnn.readableTextColor)(color, '@atlassian/company-hub-common');
const $ee4a6c4312ad3761$export$cfca0f39600e333c = {
    padding: true,
    fixedAtTop: false,
    backgroundColor: '#FFFFFF',
    textColor: '#172B4D',
    borderColor: '#DFE1E6',
    borderType: 'NO_BORDER',
    cornerRadius: 8
};
function $ee4a6c4312ad3761$export$5046aed2fe45af56(brandColor) {
    if (!brandColor) return $ee4a6c4312ad3761$export$cfca0f39600e333c;
    return {
        ...$ee4a6c4312ad3761$export$cfca0f39600e333c,
        backgroundColor: brandColor,
        textColor: $ee4a6c4312ad3761$var$readableTextColor(brandColor)
    };
}
function $ee4a6c4312ad3761$export$b35e3817d72db278(apiData, brandColor) {
    const defaults = $ee4a6c4312ad3761$export$5046aed2fe45af56(brandColor);
    if (!apiData) return defaults;
    return {
        padding: apiData.padding ?? defaults.padding,
        fixedAtTop: apiData.positionType === 'FIXED',
        backgroundColor: apiData.backgroundColor ?? defaults.backgroundColor,
        textColor: apiData.textColor ?? defaults.textColor,
        borderColor: apiData.borderColor ?? defaults.borderColor,
        borderType: apiData.borderType === 'BOTTOM_BORDER' ? 'BOTTOM_BORDER' : apiData.borderType === 'ALL_BORDER' ? 'ALL_BORDER' : 'NO_BORDER',
        cornerRadius: apiData.cornerRadius ?? defaults.cornerRadius
    };
}

});
parcelRegister("hmxnn", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $0d8ad289e0cf9d64$export$3d31854eb05903e0);

var $3G8st = parcelRequire("3G8st");

var $e6Qdr = parcelRequire("e6Qdr");
parcelRequire("euslt");
var $9Lbe3 = parcelRequire("9Lbe3");

var $lYqwN = parcelRequire("lYqwN");
const $0d8ad289e0cf9d64$export$3d31854eb05903e0 = (color, packageName)=>{
    try {
        // Convert to HEX as polished's getLuminance only accepts HEX colors
        const hexColor = (0, $e6Qdr.fg)('company_hub_color_format_conversion') ? (0, $lYqwN.toHexColor)(color) : color;
        return (0, $3G8st.getLuminance)(hexColor) > 0.5 ? "var(--ds-text, #292A2E)" : "var(--ds-text-inverse, #FFFFFF)";
    } catch (error) {
        (0, $9Lbe3.default)({
            error: error instanceof Error ? error : new Error(`Color luminance calculation failed for color: ${color}`),
            meta: {
                id: 'readableTextColor',
                packageName: packageName
            }
        });
        // Fallback to text color
        return "var(--ds-text, #292A2E)";
    }
};

});
parcelRegister("3G8st", function(module, exports) {
$parcel$export(module.exports, "getLuminance", () => $2adbdafb485e44ce$export$c852d90bf7403b62);
//      
// @private
function $2adbdafb485e44ce$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
//      
var $2adbdafb485e44ce$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $2adbdafb485e44ce$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return '' + acc + $2adbdafb485e44ce$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
    return property === joinedProperty ? '' + property + position : joinedProperty;
}
function $2adbdafb485e44ce$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$2adbdafb485e44ce$var$generateProperty(property, $2adbdafb485e44ce$var$positionMap[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $2adbdafb485e44ce$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === undefined ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === undefined ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === undefined ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $2adbdafb485e44ce$var$generateStyles(property, valuesWithDefaults);
}
//      
function $2adbdafb485e44ce$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
//      
/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $2adbdafb485e44ce$export$ef04e38dc423904(value) {
    var unitlessValue = parseFloat(value);
    if (isNaN(unitlessValue)) return value;
    return unitlessValue;
}
//      
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $2adbdafb485e44ce$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$2adbdafb485e44ce$var$endsWith(pxval, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
            newPxval = $2adbdafb485e44ce$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$2adbdafb485e44ce$var$endsWith(base, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
            newBase = $2adbdafb485e44ce$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
        if (typeof newBase === 'string') throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
        return '' + newPxval / newBase + to;
    };
};
//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $2adbdafb485e44ce$export$c63c6f932822f543 = /*#__PURE__*/ $2adbdafb485e44ce$var$pxtoFactory('em');
//      
var $2adbdafb485e44ce$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $2adbdafb485e44ce$export$c82a8a23c9e8bdb6(steps) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';
    if (typeof steps !== 'number') throw new Error('Please provide a number of steps to the modularScale helper.');
    if (typeof ratio === 'string' && !$2adbdafb485e44ce$var$ratioNames[ratio]) throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
    var realBase = typeof base === 'string' ? $2adbdafb485e44ce$export$ef04e38dc423904(base) : base;
    var realRatio = typeof ratio === 'string' ? $2adbdafb485e44ce$var$ratioNames[ratio] : ratio;
    if (typeof realBase === 'string') throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
    return realBase * Math.pow(realRatio, steps) + 'em';
}
//      
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $2adbdafb485e44ce$export$fb1897a40d146f7f = /*#__PURE__*/ $2adbdafb485e44ce$var$pxtoFactory('rem');
//      
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $2adbdafb485e44ce$export$8c467e8859fdef13() {
    var _ref;
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';
    var pseudoSelector = parent + '::after';
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
//      
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $2adbdafb485e44ce$export$a5b94313d6908893() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
    return {
        display: 'inline-block',
        maxWidth: width,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
}
//      
/** */ function $2adbdafb485e44ce$var$generateFileReferences(fontFilePath, fileFormats) {
    var fileFontReferences = fileFormats.map(function(format) {
        return 'url("' + fontFilePath + '.' + format + '")';
    });
    return fileFontReferences.join(', ');
}
function $2adbdafb485e44ce$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return 'local("' + font + '")';
    });
    return localFontReferences.join(', ');
}
function $2adbdafb485e44ce$var$generateSources(fontFilePath, localFonts, fileFormats) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($2adbdafb485e44ce$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($2adbdafb485e44ce$var$generateFileReferences(fontFilePath, fileFormats));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $2adbdafb485e44ce$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === undefined ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, localFonts = _ref.localFonts, unicodeRange = _ref.unicodeRange;
    // Error Handling
    if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
    if (!fontFilePath && !localFonts) throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
    if (localFonts && !Array.isArray(localFonts)) throw new Error('fontFace expects localFonts to be an array.');
    if (!Array.isArray(fileFormats)) throw new Error('fontFace expects fileFormats to be an array.');
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $2adbdafb485e44ce$var$generateSources(fontFilePath, localFonts, fileFormats),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight
        }
    };
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
//      
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $2adbdafb485e44ce$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
//      
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $2adbdafb485e44ce$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
//      
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $2adbdafb485e44ce$export$e79006618d7c6cc3() {
    var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
var $2adbdafb485e44ce$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2adbdafb485e44ce$var$taggedTemplateLiteralLoose = function(strings, raw) {
    strings.raw = raw;
    return strings;
};
var $2adbdafb485e44ce$var$_opinionatedRules;
var $2adbdafb485e44ce$var$_abbrTitle;
var $2adbdafb485e44ce$var$_unopinionatedRules;
//      
var $2adbdafb485e44ce$var$opinionatedRules = ($2adbdafb485e44ce$var$_opinionatedRules = {
    html: {
        fontFamily: 'sans-serif'
    },
    body: {
        margin: '0'
    }
}, $2adbdafb485e44ce$var$_opinionatedRules['a:active,\n  a:hover'] = {
    outlineWidth: '0'
}, $2adbdafb485e44ce$var$_opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    fontFamily: 'sans-serif',
    fontSize: '100%',
    lineHeight: '1.15'
}, $2adbdafb485e44ce$var$_opinionatedRules);
var $2adbdafb485e44ce$var$unopinionatedRules = ($2adbdafb485e44ce$var$_unopinionatedRules = {
    html: {
        lineHeight: '1.15',
        textSizeAdjust: '100%'
    }
}, $2adbdafb485e44ce$var$_unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
    display: 'block'
}, $2adbdafb485e44ce$var$_unopinionatedRules.h1 = {
    fontSize: '2em',
    margin: '0.67em 0'
}, $2adbdafb485e44ce$var$_unopinionatedRules['figcaption,\n  figure,\n  main'] = {
    display: 'block'
}, $2adbdafb485e44ce$var$_unopinionatedRules.figure = {
    margin: '1em 40px'
}, $2adbdafb485e44ce$var$_unopinionatedRules.hr = {
    boxSizing: 'content-box',
    height: '0',
    overflow: 'visible'
}, $2adbdafb485e44ce$var$_unopinionatedRules.pre = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $2adbdafb485e44ce$var$_unopinionatedRules.a = {
    'background-color': 'transparent',
    '-webkit-text-decoration-skip': 'objects'
}, $2adbdafb485e44ce$var$_unopinionatedRules['abbr[title]'] = ($2adbdafb485e44ce$var$_abbrTitle = {
    borderBottom: 'none',
    textDecoration: 'underline'
}, $2adbdafb485e44ce$var$_abbrTitle['textDecoration'] = 'underline dotted', $2adbdafb485e44ce$var$_abbrTitle), $2adbdafb485e44ce$var$_unopinionatedRules['b,\n  strong'] = {
    fontWeight: 'inherit'
}, $2adbdafb485e44ce$var$_unopinionatedRules['code,\n  kbd,\n  samp'] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $2adbdafb485e44ce$var$_unopinionatedRules.dfn = {
    fontStyle: 'italic'
}, $2adbdafb485e44ce$var$_unopinionatedRules.mark = {
    backgroundColor: '#ff0',
    color: '#000'
}, $2adbdafb485e44ce$var$_unopinionatedRules.small = {
    fontSize: '80%'
}, $2adbdafb485e44ce$var$_unopinionatedRules['sub,\n  sup'] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
}, $2adbdafb485e44ce$var$_unopinionatedRules.sub = {
    bottom: '-0.25em'
}, $2adbdafb485e44ce$var$_unopinionatedRules.sup = {
    top: '-0.5em'
}, $2adbdafb485e44ce$var$_unopinionatedRules['audio,\n  video'] = {
    display: 'inline-block'
}, $2adbdafb485e44ce$var$_unopinionatedRules['audio:not([controls])'] = {
    display: 'none',
    height: '0'
}, $2adbdafb485e44ce$var$_unopinionatedRules.img = {
    borderStyle: 'none'
}, $2adbdafb485e44ce$var$_unopinionatedRules['svg:not(:root)'] = {
    overflow: 'hidden'
}, $2adbdafb485e44ce$var$_unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    margin: '0'
}, $2adbdafb485e44ce$var$_unopinionatedRules['button,\n  input'] = {
    overflow: 'visible'
}, $2adbdafb485e44ce$var$_unopinionatedRules['button,\n  select'] = {
    textTransform: 'none'
}, $2adbdafb485e44ce$var$_unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
    '-webkit-appearance': 'button'
}, $2adbdafb485e44ce$var$_unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
    borderStyle: 'none',
    padding: '0'
}, $2adbdafb485e44ce$var$_unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
    outline: '1px dotted ButtonText'
}, $2adbdafb485e44ce$var$_unopinionatedRules.fieldset = {
    border: '1px solid #c0c0c0',
    margin: '0 2px',
    padding: '0.35em 0.625em 0.75em'
}, $2adbdafb485e44ce$var$_unopinionatedRules.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
}, $2adbdafb485e44ce$var$_unopinionatedRules.progress = {
    display: 'inline-block',
    verticalAlign: 'baseline'
}, $2adbdafb485e44ce$var$_unopinionatedRules.textarea = {
    overflow: 'auto'
}, $2adbdafb485e44ce$var$_unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
    boxSizing: 'border-box',
    padding: '0'
}, $2adbdafb485e44ce$var$_unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
    height: 'auto'
}, $2adbdafb485e44ce$var$_unopinionatedRules['[type="search"]'] = {
    '-webkit-appearance': 'textfield',
    outlineOffset: '-2px'
}, $2adbdafb485e44ce$var$_unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
    '-webkit-appearance': 'none'
}, $2adbdafb485e44ce$var$_unopinionatedRules['::-webkit-file-upload-button'] = {
    '-webkit-appearance': 'button',
    font: 'inherit'
}, $2adbdafb485e44ce$var$_unopinionatedRules['details,\n  menu'] = {
    display: 'block'
}, $2adbdafb485e44ce$var$_unopinionatedRules.summary = {
    display: 'list-item'
}, $2adbdafb485e44ce$var$_unopinionatedRules.canvas = {
    display: 'inline-block'
}, $2adbdafb485e44ce$var$_unopinionatedRules.template = {
    display: 'none'
}, $2adbdafb485e44ce$var$_unopinionatedRules['[hidden]'] = {
    display: 'none'
}, $2adbdafb485e44ce$var$_unopinionatedRules);
function $2adbdafb485e44ce$var$mergeRules(baseRules, additionalRules) {
    var mergedRules = $2adbdafb485e44ce$var$_extends({}, baseRules);
    Object.keys(additionalRules).forEach(function(key) {
        if (mergedRules[key]) mergedRules[key] = $2adbdafb485e44ce$var$_extends({}, mergedRules[key], additionalRules[key]);
        else mergedRules[key] = $2adbdafb485e44ce$var$_extends({}, additionalRules[key]);
    });
    return mergedRules;
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $2adbdafb485e44ce$export$a3295358bff77e(excludeOpinionated) {
    if (excludeOpinionated) return $2adbdafb485e44ce$var$unopinionatedRules;
    return $2adbdafb485e44ce$var$mergeRules($2adbdafb485e44ce$var$unopinionatedRules, $2adbdafb485e44ce$var$opinionatedRules);
}
//      
/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */ function $2adbdafb485e44ce$export$c7187bbd1a7a9244(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
    return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = $2adbdafb485e44ce$var$_extends({}, styles), _ref[parent + ':-moz-placeholder'] = $2adbdafb485e44ce$var$_extends({}, styles), _ref[parent + '::-moz-placeholder'] = $2adbdafb485e44ce$var$_extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = $2adbdafb485e44ce$var$_extends({}, styles), _ref;
}
var $2adbdafb485e44ce$var$_templateObject = /*#__PURE__*/ $2adbdafb485e44ce$var$taggedTemplateLiteralLoose([
    'radial-gradient(',
    '',
    '',
    '',
    ')'
], [
    'radial-gradient(',
    '',
    '',
    '',
    ')'
]);
//      
/** */ function $2adbdafb485e44ce$var$parseFallback(colorStops) {
    return colorStops[0].split(' ')[0];
}
function $2adbdafb485e44ce$var$constructGradientValue(literals) {
    var template = '';
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        // Adds leading coma if properties preceed color-stops
        if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
            template = template.slice(0, -1);
            template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        // No trailing space if color-stops is the only param provided
        } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
    return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $2adbdafb485e44ce$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, extent = _ref.extent, fallback = _ref.fallback, position = _ref.position, shape = _ref.shape;
    if (!colorStops || colorStops.length < 2) throw new Error('radialGradient requries at least 2 color-stops to properly render.');
    return {
        backgroundColor: fallback || $2adbdafb485e44ce$var$parseFallback(colorStops),
        backgroundImage: $2adbdafb485e44ce$var$constructGradientValue($2adbdafb485e44ce$var$_templateObject, position, shape, extent, colorStops.join(', '))
    };
}
//      
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $2adbdafb485e44ce$export$19389033401d366a(filename, backgroundSize) {
    var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';
    var _ref;
    var retinaFilename = arguments[3];
    var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';
    if (!filename) throw new Error('Please supply a filename to retinaImage() as the first argument.');
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;
    return _ref = {
        backgroundImage: 'url(' + filename + '.' + ext + ')'
    }, _ref[$2adbdafb485e44ce$export$e79006618d7c6cc3()] = {
        backgroundImage: 'url(' + rFilename + ')',
        backgroundSize: backgroundSize
    }, _ref;
}
//      
/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */ function $2adbdafb485e44ce$export$7c69810f7b8835c9(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return _ref = {}, _ref[parent + '::-moz-selection'] = $2adbdafb485e44ce$var$_extends({}, styles), _ref[parent + '::selection'] = $2adbdafb485e44ce$var$_extends({}, styles), _ref;
}
//      
/* eslint-disable key-spacing */ var $2adbdafb485e44ce$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
function $2adbdafb485e44ce$export$61210fa83792a81(timingFunction) {
    return $2adbdafb485e44ce$var$functionsMap[timingFunction];
}
//      
/** */ var $2adbdafb485e44ce$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    switch(pointingDirection){
        case 'top':
            return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
        case 'left':
            return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
        case 'bottom':
            return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
        case 'right':
            return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';
        default:
            throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
    }
};
// needed for border-color
var $2adbdafb485e44ce$var$reverseDirection = {
    left: 'Right',
    right: 'Left',
    top: 'Bottom',
    bottom: 'Top'
};
function $2adbdafb485e44ce$export$9eed783d03e0135c(_ref) {
    var _ref2;
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;
    var unitlessHeight = parseFloat(height);
    var unitlessWidth = parseFloat(width);
    if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
    return _ref2 = {
        borderColor: backgroundColor,
        width: '0',
        height: '0',
        borderWidth: $2adbdafb485e44ce$var$getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
        borderStyle: 'solid'
    }, _ref2['border' + $2adbdafb485e44ce$var$reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}
//      
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $2adbdafb485e44ce$export$dca3d8ad656c34d2() {
    var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
//      
function $2adbdafb485e44ce$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $2adbdafb485e44ce$var$convertToInt(red, green, blue) {
    return $2adbdafb485e44ce$var$colorToInt(red) + "," + $2adbdafb485e44ce$var$colorToInt(green) + "," + $2adbdafb485e44ce$var$colorToInt(blue);
}
function $2adbdafb485e44ce$var$hslToRgb(hue, saturation, lightness) {
    var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $2adbdafb485e44ce$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = hue % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
//      
var $2adbdafb485e44ce$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
function $2adbdafb485e44ce$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $2adbdafb485e44ce$var$namedColorMap[normalizedColorName] ? '#' + $2adbdafb485e44ce$var$namedColorMap[normalizedColorName] : color;
}
//      
var $2adbdafb485e44ce$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $2adbdafb485e44ce$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $2adbdafb485e44ce$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $2adbdafb485e44ce$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var $2adbdafb485e44ce$var$hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var $2adbdafb485e44ce$var$hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $2adbdafb485e44ce$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    var normalizedColor = $2adbdafb485e44ce$var$nameToHex(color);
    if (normalizedColor.match($2adbdafb485e44ce$var$hexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($2adbdafb485e44ce$var$reducedHexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
    var rgbMatched = $2adbdafb485e44ce$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt('' + rgbMatched[1], 10),
        green: parseInt('' + rgbMatched[2], 10),
        blue: parseInt('' + rgbMatched[3], 10)
    };
    var rgbaMatched = $2adbdafb485e44ce$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatched) return {
        red: parseInt('' + rgbaMatched[1], 10),
        green: parseInt('' + rgbaMatched[2], 10),
        blue: parseInt('' + rgbaMatched[3], 10),
        alpha: parseFloat('' + rgbaMatched[4])
    };
    var hslMatched = $2adbdafb485e44ce$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt('' + hslMatched[1], 10);
        var saturation = parseInt('' + hslMatched[2], 10) / 100;
        var lightness = parseInt('' + hslMatched[3], 10) / 100;
        var rgbColorString = 'rgb(' + $2adbdafb485e44ce$var$hslToRgb(hue, saturation, lightness) + ')';
        var hslRgbMatched = $2adbdafb485e44ce$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
        return {
            red: parseInt('' + hslRgbMatched[1], 10),
            green: parseInt('' + hslRgbMatched[2], 10),
            blue: parseInt('' + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $2adbdafb485e44ce$var$hslaRegex.exec(normalizedColor);
    if (hslaMatched) {
        var _hue = parseInt('' + hslaMatched[1], 10);
        var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
        var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
        var _rgbColorString = 'rgb(' + $2adbdafb485e44ce$var$hslToRgb(_hue, _saturation, _lightness) + ')';
        var _hslRgbMatched = $2adbdafb485e44ce$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
        return {
            red: parseInt('' + _hslRgbMatched[1], 10),
            green: parseInt('' + _hslRgbMatched[2], 10),
            blue: parseInt('' + _hslRgbMatched[3], 10),
            alpha: parseFloat('' + hslaMatched[4])
        };
    }
    throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
//      
function $2adbdafb485e44ce$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue = void 0;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
//      
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $2adbdafb485e44ce$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $2adbdafb485e44ce$var$rgbToHsl($2adbdafb485e44ce$export$2f48baff6995707a(color));
}
//      
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $2adbdafb485e44ce$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
//      
function $2adbdafb485e44ce$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $2adbdafb485e44ce$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $2adbdafb485e44ce$var$reduceHexValue('#' + $2adbdafb485e44ce$var$numberToHex(value) + $2adbdafb485e44ce$var$numberToHex(green) + $2adbdafb485e44ce$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $2adbdafb485e44ce$var$reduceHexValue('#' + $2adbdafb485e44ce$var$numberToHex(value.red) + $2adbdafb485e44ce$var$numberToHex(value.green) + $2adbdafb485e44ce$var$numberToHex(value.blue));
    throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $2adbdafb485e44ce$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $2adbdafb485e44ce$export$2f48baff6995707a(firstValue);
        return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $2adbdafb485e44ce$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $2adbdafb485e44ce$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
    throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}
//      
function $2adbdafb485e44ce$var$colorToHex(color) {
    return $2adbdafb485e44ce$var$numberToHex(Math.round(color * 255));
}
function $2adbdafb485e44ce$var$convertToHex(red, green, blue) {
    return $2adbdafb485e44ce$var$reduceHexValue('#' + $2adbdafb485e44ce$var$colorToHex(red) + $2adbdafb485e44ce$var$colorToHex(green) + $2adbdafb485e44ce$var$colorToHex(blue));
}
function $2adbdafb485e44ce$var$hslToHex(hue, saturation, lightness) {
    return $2adbdafb485e44ce$var$hslToRgb(hue, saturation, lightness, $2adbdafb485e44ce$var$convertToHex);
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $2adbdafb485e44ce$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $2adbdafb485e44ce$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $2adbdafb485e44ce$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $2adbdafb485e44ce$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $2adbdafb485e44ce$var$hslToHex(value, saturation, lightness) : 'rgba(' + $2adbdafb485e44ce$var$hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $2adbdafb485e44ce$var$hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + $2adbdafb485e44ce$var$hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
    throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}
//      
var $2adbdafb485e44ce$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $2adbdafb485e44ce$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $2adbdafb485e44ce$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $2adbdafb485e44ce$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
var $2adbdafb485e44ce$var$errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $2adbdafb485e44ce$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new Error($2adbdafb485e44ce$var$errMsg);
    if ($2adbdafb485e44ce$var$isRgba(color)) return $2adbdafb485e44ce$export$4e46ac54fc82cf3b(color);
    if ($2adbdafb485e44ce$var$isRgb(color)) return $2adbdafb485e44ce$export$8972dc0e6ad9238f(color);
    if ($2adbdafb485e44ce$var$isHsla(color)) return $2adbdafb485e44ce$export$810b04175080204c(color);
    if ($2adbdafb485e44ce$var$isHsl(color)) return $2adbdafb485e44ce$export$8f4a7c0bb78e6ea8(color);
    throw new Error($2adbdafb485e44ce$var$errMsg);
}
//      
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $2adbdafb485e44ce$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $2adbdafb485e44ce$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $2adbdafb485e44ce$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $2adbdafb485e44ce$var$curried(f, f.length, []);
}
//      
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $2adbdafb485e44ce$var$adjustHue(degree, color) {
    var hslColor = $2adbdafb485e44ce$export$1286688e1b3fde9c(color);
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, hslColor, {
        hue: (hslColor.hue + degree) % 360
    }));
}
var $2adbdafb485e44ce$export$2b372a09365374d6 = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$adjustHue);
//      
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $2adbdafb485e44ce$export$bd4f6f7e1823bc9e(color) {
    var hslColor = $2adbdafb485e44ce$export$1286688e1b3fde9c(color);
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
//      
function $2adbdafb485e44ce$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
//      
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $2adbdafb485e44ce$var$darken(amount, color) {
    var hslColor = $2adbdafb485e44ce$export$1286688e1b3fde9c(color);
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, hslColor, {
        lightness: $2adbdafb485e44ce$var$guard(0, 1, hslColor.lightness - amount)
    }));
}
var $2adbdafb485e44ce$export$4b073707ff63303 = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$darken);
//      
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $2adbdafb485e44ce$var$desaturate(amount, color) {
    var hslColor = $2adbdafb485e44ce$export$1286688e1b3fde9c(color);
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, hslColor, {
        saturation: $2adbdafb485e44ce$var$guard(0, 1, hslColor.saturation - amount)
    }));
}
var $2adbdafb485e44ce$export$fb75607d98509d9 = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$desaturate);
//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $2adbdafb485e44ce$export$c852d90bf7403b62(color) {
    var rgbColor = $2adbdafb485e44ce$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
//      
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $2adbdafb485e44ce$export$6f416a6db2dfcd5c(color) {
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, $2adbdafb485e44ce$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
//      
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $2adbdafb485e44ce$export$6897c284b6f9f4dc(color) {
    // parse color string to rgb
    var value = $2adbdafb485e44ce$export$2f48baff6995707a(color);
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
//      
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $2adbdafb485e44ce$var$lighten(amount, color) {
    var hslColor = $2adbdafb485e44ce$export$1286688e1b3fde9c(color);
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, hslColor, {
        lightness: $2adbdafb485e44ce$var$guard(0, 1, hslColor.lightness + amount)
    }));
}
var $2adbdafb485e44ce$export$c0816ed86df316af = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$lighten);
//      
/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $2adbdafb485e44ce$var$mix() {
    var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
    var color = arguments[1];
    var otherColor = arguments[2];
    var parsedColor1 = $2adbdafb485e44ce$export$2f48baff6995707a(color);
    var color1 = $2adbdafb485e44ce$var$_extends({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $2adbdafb485e44ce$export$2f48baff6995707a(otherColor);
    var color2 = $2adbdafb485e44ce$var$_extends({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    var alphaDelta = color1.alpha - color2.alpha;
    var x = weight * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
    };
    return $2adbdafb485e44ce$export$4e46ac54fc82cf3b(mixedColor);
}
var $2adbdafb485e44ce$export$2c9e8a9632a706b2 = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$mix);
//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $2adbdafb485e44ce$var$opacify(amount, color) {
    var parsedColor = $2adbdafb485e44ce$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $2adbdafb485e44ce$var$_extends({}, parsedColor, {
        alpha: $2adbdafb485e44ce$var$guard(0, 1, (alpha * 100 + amount * 100) / 100)
    });
    return $2adbdafb485e44ce$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $2adbdafb485e44ce$export$f4f50e3877dd0530 = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$opacify);
//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */ function $2adbdafb485e44ce$var$readableColor(color) {
    return $2adbdafb485e44ce$export$c852d90bf7403b62(color) > 0.179 ? '#000' : '#fff';
}
var $2adbdafb485e44ce$export$61654c1796c44811 = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$readableColor);
//      
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $2adbdafb485e44ce$var$saturate(amount, color) {
    var hslColor = $2adbdafb485e44ce$export$1286688e1b3fde9c(color);
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, hslColor, {
        saturation: $2adbdafb485e44ce$var$guard(0, 1, hslColor.saturation + amount)
    }));
}
var $2adbdafb485e44ce$export$5fcac96f5a87e3db = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$saturate);
//      
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $2adbdafb485e44ce$var$setHue(hue, color) {
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, $2adbdafb485e44ce$export$1286688e1b3fde9c(color), {
        hue: hue
    }));
}
var $2adbdafb485e44ce$export$3bf58ce3e497a846 = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$setHue);
//      
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $2adbdafb485e44ce$var$setLightness(lightness, color) {
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, $2adbdafb485e44ce$export$1286688e1b3fde9c(color), {
        lightness: lightness
    }));
}
var $2adbdafb485e44ce$export$7ef5d725337b805d = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$setLightness);
//      
/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $2adbdafb485e44ce$var$setSaturation(saturation, color) {
    return $2adbdafb485e44ce$export$42fe740cdf79b2df($2adbdafb485e44ce$var$_extends({}, $2adbdafb485e44ce$export$1286688e1b3fde9c(color), {
        saturation: saturation
    }));
}
var $2adbdafb485e44ce$export$b40fe421ea7a4f7e = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$setSaturation);
//      
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $2adbdafb485e44ce$var$shade(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $2adbdafb485e44ce$export$2c9e8a9632a706b2(percentage, color, 'rgb(0, 0, 0)');
}
var $2adbdafb485e44ce$export$3e32adda0df4ef5d = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$shade);
//      
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $2adbdafb485e44ce$var$tint(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $2adbdafb485e44ce$export$2c9e8a9632a706b2(percentage, color, 'rgb(255, 255, 255)');
}
var $2adbdafb485e44ce$export$fc176dd65a27d98b = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$tint);
//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $2adbdafb485e44ce$var$transparentize(amount, color) {
    var parsedColor = $2adbdafb485e44ce$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $2adbdafb485e44ce$var$_extends({}, parsedColor, {
        alpha: $2adbdafb485e44ce$var$guard(0, 1, (alpha * 100 - amount * 100) / 100)
    });
    return $2adbdafb485e44ce$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $2adbdafb485e44ce$export$d11da87e55cc498f = /*#__PURE__*/ $2adbdafb485e44ce$var$curry($2adbdafb485e44ce$var$transparentize);
//      
/** */ /**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $2adbdafb485e44ce$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
        if (Array.isArray(arg) && arg.length > 8) throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
//      
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $2adbdafb485e44ce$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $2adbdafb485e44ce$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $2adbdafb485e44ce$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $2adbdafb485e44ce$export$4fc00c04dd60af95.apply(undefined, [
        'borderColor'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $2adbdafb485e44ce$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $2adbdafb485e44ce$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
    }
    throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $2adbdafb485e44ce$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $2adbdafb485e44ce$export$4fc00c04dd60af95.apply(undefined, [
        'borderStyle'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $2adbdafb485e44ce$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $2adbdafb485e44ce$export$4fc00c04dd60af95.apply(undefined, [
        'borderWidth'
    ].concat(values));
}
//      
function $2adbdafb485e44ce$var$generateSelectors(template, state) {
    var stateSuffix = state ? ':' + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $2adbdafb485e44ce$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new Error('You must provide a template to this method.');
    if (states.length === 0) return $2adbdafb485e44ce$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new Error('You passed an unsupported selector state to this method.');
        selectors.push($2adbdafb485e44ce$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
//      
var $2adbdafb485e44ce$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $2adbdafb485e44ce$var$template(state) {
    return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $2adbdafb485e44ce$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $2adbdafb485e44ce$var$statefulSelectors(states, $2adbdafb485e44ce$var$template, $2adbdafb485e44ce$var$stateMap);
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $2adbdafb485e44ce$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $2adbdafb485e44ce$export$4fc00c04dd60af95.apply(undefined, [
        'margin'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $2adbdafb485e44ce$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $2adbdafb485e44ce$export$4fc00c04dd60af95.apply(undefined, [
        'padding'
    ].concat(values));
}
//      
var $2adbdafb485e44ce$var$positionMap$1 = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $2adbdafb485e44ce$export$5880b8b5730aff45(positionKeyword) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($2adbdafb485e44ce$var$positionMap$1.indexOf(positionKeyword) >= 0) return $2adbdafb485e44ce$var$_extends({
        position: positionKeyword
    }, $2adbdafb485e44ce$export$4fc00c04dd60af95.apply(undefined, [
        ''
    ].concat(values)));
    else {
        var firstValue = positionKeyword; // in this case position is actually the first value
        return $2adbdafb485e44ce$export$4fc00c04dd60af95.apply(undefined, [
            '',
            firstValue
        ].concat(values));
    }
}
//      
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $2adbdafb485e44ce$export$346677f925de839c(height) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
    return {
        height: height,
        width: width
    };
}
//      
var $2adbdafb485e44ce$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $2adbdafb485e44ce$var$template$1(state) {
    return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $2adbdafb485e44ce$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $2adbdafb485e44ce$var$statefulSelectors(states, $2adbdafb485e44ce$var$template$1, $2adbdafb485e44ce$var$stateMap$1);
}
//      
/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */ function $2adbdafb485e44ce$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        transition: properties.join(', ')
    };
}

});

parcelRegister("lYqwN", function(module, exports) {
$parcel$export(module.exports, "isValidColor", () => $cf077c02cf3affe5$export$35fa9d266cdb6f09);
$parcel$export(module.exports, "convertLegacyColor", () => $cf077c02cf3affe5$export$b2b344a3caf230bf);
$parcel$export(module.exports, "extractToken", () => $cf077c02cf3affe5$export$5039139b891079e8);
$parcel$export(module.exports, "getSanitizedColor", () => $cf077c02cf3affe5$export$d16dc80c78f978b3);
$parcel$export(module.exports, "toHexColor", () => $cf077c02cf3affe5$export$342249704b28d862);
$parcel$export(module.exports, "isReadable", () => $cf077c02cf3affe5$export$3fe5b5ca1e6a6a28);
$parcel$export(module.exports, "getMostReadableColor", () => $cf077c02cf3affe5$export$21e0b327e0d86beb);

var $e0Nl1 = parcelRequire("e0Nl1");
/* regular expressions obtained from CssColourValidator.java
 * CssColourValidator runs in legacy Color Scheme on updateSiteLookAndFeel mutation
 * instead of validating on Save, we are now validating as user enters custom input
 */ const $cf077c02cf3affe5$var$VAR_MATCH = new RegExp('^var\\((\\-\\-[a-zA-Z0-9\\-_]+)\\s*(,(.+))?\\)$');
const $cf077c02cf3affe5$var$SHORT_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){3}$');
const $cf077c02cf3affe5$var$LONG_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){6}$');
const $cf077c02cf3affe5$var$RGB_MATCH = new RegExp('^rgb\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*\\)$');
const $cf077c02cf3affe5$var$PERC_MATCH = new RegExp('^rgb\\((\\d+)%,\\s*(\\d+)%,\\s*(\\d+)%\\)$');
const $cf077c02cf3affe5$var$RGBA_MATCH = new RegExp('^rgba\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*((0.[0-9]*)|[01])\\s*\\)$');
const $cf077c02cf3affe5$var$HSL_MATCH = new RegExp('^hsl\\(\\s*(0|[1-9]\\d?|[12]\\d\\d|3[0-5]\\d)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*\\)$');
/* evaluates validity for any incoming colors from 1) siteConfiguration query 2) custom input field
 * until hsla and named color conversion errors are handled properly in app-navigation, we return the default Atlassian theme as in getSanitizedColor fn
 * it is an existing pattern under useNavigationTheme to return the theme as means of error handling
 * once resolved, this isValidColor can validate for HSLA_MATCH and NAMED_COLOR_MATCH
 */ function $cf077c02cf3affe5$var$isValidVarColor(color) {
    const matches = $cf077c02cf3affe5$var$VAR_MATCH.exec(color);
    if (matches) {
        var _matches$;
        const fallback = (_matches$ = matches[3]) === null || _matches$ === void 0 ? void 0 : _matches$.trim();
        if (fallback) {
            // If fallback is another var() call, validate it recursively
            if (fallback.startsWith('var(')) return $cf077c02cf3affe5$var$isValidVarColor(fallback);
            // Otherwise validate as a regular color
            return $cf077c02cf3affe5$export$35fa9d266cdb6f09(fallback, false);
        }
        // If there's a comma but no fallback (like "var(--token, )"), it's invalid
        if (matches[2] && !fallback) return false;
        return true;
    }
    return false;
}
function $cf077c02cf3affe5$export$35fa9d266cdb6f09(color, isVarColorAllowed = true) {
    return isVarColorAllowed && $cf077c02cf3affe5$var$isValidVarColor(color) || $cf077c02cf3affe5$var$SHORT_NUMERIC_MATCH.test(color) || $cf077c02cf3affe5$var$LONG_NUMERIC_MATCH.test(color) || $cf077c02cf3affe5$var$RGB_MATCH.test(color) || $cf077c02cf3affe5$var$PERC_MATCH.test(color) || $cf077c02cf3affe5$var$RGBA_MATCH.test(color) || $cf077c02cf3affe5$var$HSL_MATCH.test(color);
}
function $cf077c02cf3affe5$export$b2b344a3caf230bf(color) {
    if (!$cf077c02cf3affe5$export$35fa9d266cdb6f09(color)) return (0, $e0Nl1.default)('invalid');
    const colorCode = $cf077c02cf3affe5$var$extractColorCode(color);
    return (0, $e0Nl1.default)(colorCode);
}
/* simply extracts the color code from given color string.
 * If color is tokenized, either computes or extracts fallback hex value
 * Else return color as is
 */ function $cf077c02cf3affe5$var$extractColorCode(color) {
    const matches = $cf077c02cf3affe5$var$VAR_MATCH.exec(color);
    if (matches) {
        var _matches$2;
        const fallback = (_matches$2 = matches[3]) === null || _matches$2 === void 0 ? void 0 : _matches$2.trim();
        const token = matches[1].toLowerCase();
        // SSR guard
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            const compiledTokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
            // If we have a computed value, return it
            if (compiledTokenValue) return compiledTokenValue;
        }
        // If there's a fallback, process it recursively
        if (fallback) {
            // If fallback is another var() call, extract from it recursively
            if (fallback.startsWith('var(')) return $cf077c02cf3affe5$var$extractColorCode(fallback);
            // Otherwise return the fallback as is
            return fallback;
        }
        // No computed value and no fallback
        return '';
    }
    return color;
}
function $cf077c02cf3affe5$export$5039139b891079e8(color = '') {
    const matches = $cf077c02cf3affe5$var$VAR_MATCH.exec(color);
    return (matches === null || matches === void 0 ? void 0 : matches[1].toLowerCase()) ?? color;
}
function $cf077c02cf3affe5$export$d16dc80c78f978b3({ allColors: allColors, allTokens: allTokens, knownColors: knownColors }, color = '') {
    const index = allTokens.indexOf($cf077c02cf3affe5$export$5039139b891079e8(color));
    if (index !== -1) return allColors[index];
    if (!$cf077c02cf3affe5$export$35fa9d266cdb6f09(color)) return knownColors[0];
    return color;
}
function $cf077c02cf3affe5$export$342249704b28d862(color) {
    const converted = $cf077c02cf3affe5$export$b2b344a3caf230bf(color);
    if (converted.isValid()) return converted.toHexString();
    return color;
}
function $cf077c02cf3affe5$export$3fe5b5ca1e6a6a28(backgroundColor, highlightColor) {
    const backgroundCode = $cf077c02cf3affe5$var$extractColorCode(backgroundColor);
    const highlightCode = $cf077c02cf3affe5$var$extractColorCode(highlightColor);
    return (0, $e0Nl1.default).isReadable(backgroundCode, highlightCode);
}
function $cf077c02cf3affe5$export$21e0b327e0d86beb(color) {
    color = $cf077c02cf3affe5$var$extractColorCode(color);
    return (0, $e0Nl1.default).mostReadable(color, [
        '#000000',
        '#ffffff'
    ]).toHexString();
}
function $cf077c02cf3affe5$export$bf60f520e1f9cbf8(color1, color2) {
    return $cf077c02cf3affe5$var$extractColorCode(color1) === $cf077c02cf3affe5$var$extractColorCode(color2);
}

});
parcelRegister("e0Nl1", function(module, exports) {
$parcel$export(module.exports, "default", () => $a337564684504a6f$export$2e2bcd8739ae039);
// This file is autogenerated. It's used to publish ESM to npm.
function $a337564684504a6f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a337564684504a6f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a337564684504a6f$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $a337564684504a6f$var$trimLeft = /^\s+/;
var $a337564684504a6f$var$trimRight = /\s+$/;
function $a337564684504a6f$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $a337564684504a6f$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $a337564684504a6f$export$2e2bcd8739ae039)) return new $a337564684504a6f$export$2e2bcd8739ae039(color, opts);
    var rgb = $a337564684504a6f$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$a337564684504a6f$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $a337564684504a6f$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $a337564684504a6f$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $a337564684504a6f$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $a337564684504a6f$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $a337564684504a6f$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $a337564684504a6f$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $a337564684504a6f$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($a337564684504a6f$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($a337564684504a6f$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($a337564684504a6f$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($a337564684504a6f$var$bound01(this._r, 255) * 100) + "%, " + Math.round($a337564684504a6f$var$bound01(this._g, 255) * 100) + "%, " + Math.round($a337564684504a6f$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($a337564684504a6f$var$bound01(this._r, 255) * 100) + "%, " + Math.round($a337564684504a6f$var$bound01(this._g, 255) * 100) + "%, " + Math.round($a337564684504a6f$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $a337564684504a6f$var$hexNames[$a337564684504a6f$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $a337564684504a6f$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $a337564684504a6f$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $a337564684504a6f$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $a337564684504a6f$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($a337564684504a6f$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($a337564684504a6f$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($a337564684504a6f$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($a337564684504a6f$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($a337564684504a6f$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($a337564684504a6f$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($a337564684504a6f$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($a337564684504a6f$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($a337564684504a6f$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($a337564684504a6f$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($a337564684504a6f$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($a337564684504a6f$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($a337564684504a6f$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$a337564684504a6f$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($a337564684504a6f$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $a337564684504a6f$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $a337564684504a6f$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $a337564684504a6f$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $a337564684504a6f$var$stringInputToObject(color);
    if ($a337564684504a6f$var$_typeof(color) == "object") {
        if ($a337564684504a6f$var$isValidCSSUnit(color.r) && $a337564684504a6f$var$isValidCSSUnit(color.g) && $a337564684504a6f$var$isValidCSSUnit(color.b)) {
            rgb = $a337564684504a6f$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($a337564684504a6f$var$isValidCSSUnit(color.h) && $a337564684504a6f$var$isValidCSSUnit(color.s) && $a337564684504a6f$var$isValidCSSUnit(color.v)) {
            s = $a337564684504a6f$var$convertToPercentage(color.s);
            v = $a337564684504a6f$var$convertToPercentage(color.v);
            rgb = $a337564684504a6f$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($a337564684504a6f$var$isValidCSSUnit(color.h) && $a337564684504a6f$var$isValidCSSUnit(color.s) && $a337564684504a6f$var$isValidCSSUnit(color.l)) {
            s = $a337564684504a6f$var$convertToPercentage(color.s);
            l = $a337564684504a6f$var$convertToPercentage(color.l);
            rgb = $a337564684504a6f$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $a337564684504a6f$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $a337564684504a6f$var$rgbToRgb(r, g, b) {
    return {
        r: $a337564684504a6f$var$bound01(r, 255) * 255,
        g: $a337564684504a6f$var$bound01(g, 255) * 255,
        b: $a337564684504a6f$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $a337564684504a6f$var$rgbToHsl(r, g, b) {
    r = $a337564684504a6f$var$bound01(r, 255);
    g = $a337564684504a6f$var$bound01(g, 255);
    b = $a337564684504a6f$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $a337564684504a6f$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $a337564684504a6f$var$bound01(h, 360);
    s = $a337564684504a6f$var$bound01(s, 100);
    l = $a337564684504a6f$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $a337564684504a6f$var$rgbToHsv(r, g, b) {
    r = $a337564684504a6f$var$bound01(r, 255);
    g = $a337564684504a6f$var$bound01(g, 255);
    b = $a337564684504a6f$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $a337564684504a6f$var$hsvToRgb(h, s, v) {
    h = $a337564684504a6f$var$bound01(h, 360) * 6;
    s = $a337564684504a6f$var$bound01(s, 100);
    v = $a337564684504a6f$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $a337564684504a6f$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $a337564684504a6f$var$pad2(Math.round(r).toString(16)),
        $a337564684504a6f$var$pad2(Math.round(g).toString(16)),
        $a337564684504a6f$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $a337564684504a6f$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $a337564684504a6f$var$pad2(Math.round(r).toString(16)),
        $a337564684504a6f$var$pad2(Math.round(g).toString(16)),
        $a337564684504a6f$var$pad2(Math.round(b).toString(16)),
        $a337564684504a6f$var$pad2($a337564684504a6f$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $a337564684504a6f$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $a337564684504a6f$var$pad2($a337564684504a6f$var$convertDecimalToHex(a)),
        $a337564684504a6f$var$pad2(Math.round(r).toString(16)),
        $a337564684504a6f$var$pad2(Math.round(g).toString(16)),
        $a337564684504a6f$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$a337564684504a6f$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $a337564684504a6f$export$2e2bcd8739ae039(color1).toRgbString() == $a337564684504a6f$export$2e2bcd8739ae039(color2).toRgbString();
};
$a337564684504a6f$export$2e2bcd8739ae039.random = function() {
    return $a337564684504a6f$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $a337564684504a6f$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $a337564684504a6f$var$clamp01(hsl.s);
    return $a337564684504a6f$export$2e2bcd8739ae039(hsl);
}
function $a337564684504a6f$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $a337564684504a6f$var$clamp01(hsl.s);
    return $a337564684504a6f$export$2e2bcd8739ae039(hsl);
}
function $a337564684504a6f$var$_greyscale(color) {
    return $a337564684504a6f$export$2e2bcd8739ae039(color).desaturate(100);
}
function $a337564684504a6f$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $a337564684504a6f$var$clamp01(hsl.l);
    return $a337564684504a6f$export$2e2bcd8739ae039(hsl);
}
function $a337564684504a6f$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $a337564684504a6f$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $a337564684504a6f$export$2e2bcd8739ae039(rgb);
}
function $a337564684504a6f$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $a337564684504a6f$var$clamp01(hsl.l);
    return $a337564684504a6f$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $a337564684504a6f$var$_spin(color, amount) {
    var hsl = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $a337564684504a6f$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $a337564684504a6f$var$_complement(color) {
    var hsl = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $a337564684504a6f$export$2e2bcd8739ae039(hsl);
}
function $a337564684504a6f$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $a337564684504a6f$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($a337564684504a6f$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $a337564684504a6f$var$_splitcomplement(color) {
    var hsl = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $a337564684504a6f$export$2e2bcd8739ae039(color),
        $a337564684504a6f$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $a337564684504a6f$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $a337564684504a6f$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $a337564684504a6f$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($a337564684504a6f$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $a337564684504a6f$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $a337564684504a6f$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($a337564684504a6f$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$a337564684504a6f$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $a337564684504a6f$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $a337564684504a6f$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $a337564684504a6f$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$a337564684504a6f$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $a337564684504a6f$export$2e2bcd8739ae039(color1);
    var c2 = $a337564684504a6f$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$a337564684504a6f$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $a337564684504a6f$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $a337564684504a6f$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$a337564684504a6f$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $a337564684504a6f$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $a337564684504a6f$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($a337564684504a6f$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $a337564684504a6f$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $a337564684504a6f$var$names = $a337564684504a6f$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $a337564684504a6f$var$hexNames = $a337564684504a6f$export$2e2bcd8739ae039.hexNames = $a337564684504a6f$var$flip($a337564684504a6f$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $a337564684504a6f$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $a337564684504a6f$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $a337564684504a6f$var$bound01(n, max) {
    if ($a337564684504a6f$var$isOnePointZero(n)) n = "100%";
    var processPercent = $a337564684504a6f$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $a337564684504a6f$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $a337564684504a6f$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $a337564684504a6f$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $a337564684504a6f$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $a337564684504a6f$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $a337564684504a6f$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $a337564684504a6f$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $a337564684504a6f$var$convertHexToDecimal(h) {
    return $a337564684504a6f$var$parseIntFromHex(h) / 255;
}
var $a337564684504a6f$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $a337564684504a6f$var$isValidCSSUnit(color) {
    return !!$a337564684504a6f$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $a337564684504a6f$var$stringInputToObject(color) {
    color = color.replace($a337564684504a6f$var$trimLeft, "").replace($a337564684504a6f$var$trimRight, "").toLowerCase();
    var named = false;
    if ($a337564684504a6f$var$names[color]) {
        color = $a337564684504a6f$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $a337564684504a6f$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $a337564684504a6f$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $a337564684504a6f$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $a337564684504a6f$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $a337564684504a6f$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $a337564684504a6f$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $a337564684504a6f$var$matchers.hex8.exec(color)) return {
        r: $a337564684504a6f$var$parseIntFromHex(match[1]),
        g: $a337564684504a6f$var$parseIntFromHex(match[2]),
        b: $a337564684504a6f$var$parseIntFromHex(match[3]),
        a: $a337564684504a6f$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $a337564684504a6f$var$matchers.hex6.exec(color)) return {
        r: $a337564684504a6f$var$parseIntFromHex(match[1]),
        g: $a337564684504a6f$var$parseIntFromHex(match[2]),
        b: $a337564684504a6f$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $a337564684504a6f$var$matchers.hex4.exec(color)) return {
        r: $a337564684504a6f$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $a337564684504a6f$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $a337564684504a6f$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $a337564684504a6f$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $a337564684504a6f$var$matchers.hex3.exec(color)) return {
        r: $a337564684504a6f$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $a337564684504a6f$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $a337564684504a6f$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $a337564684504a6f$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}

});





parcelRegister("dI6dR", function(module, exports) {
$parcel$export(module.exports, "HubErrorBoundary", () => $e808a7a8be76401f$export$ba2f52e216142b3d);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $dCWA1 = parcelRequire("dCWA1");

var $9It0a = parcelRequire("9It0a");
parcelRequire("euslt");
var $9Lbe3 = parcelRequire("9Lbe3");
const $e808a7a8be76401f$var$isFetchClientError = (err)=>{
    return (err === null || err === void 0 ? void 0 : err.status) < 500;
};
const $e808a7a8be76401f$export$ba2f52e216142b3d = ({ children: children, packageName: packageName, id: id, fallback: fallback, shouldForceError: shouldForceError })=>{
    const logError = (0, $9It0a.useUFOReportError)();
    const onError = (error)=>{
        if ($e808a7a8be76401f$var$isFetchClientError(error)) // skip fetch client error e.g. 4xx
        return;
        // Fire additional error analytics
        try {
            // Log rUFO error metrics
            logError({
                name: error.name,
                errorMessage: error.message,
                errorStack: error.stack,
                forcedError: shouldForceError
            });
            (0, $9Lbe3.default)({
                error: error,
                meta: {
                    id: id,
                    packageName: packageName
                }
            });
        } catch (err) {
            // Added to silently fail Uncaught ReferenceError: __SERVER__ is not defined
            // eslint-disable-next-line no-console
            console.warn('Failed to fire error analytics:', err);
        }
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dCWA1.ErrorBoundary), {
        onError: onError,
        fallback: fallback,
        children: children
    });
};

});

parcelRegister("g56Er", function(module, exports) {
$parcel$export(module.exports, "mockHubRouteProps", () => $9308b055cc17bac6$export$427679abd9cc3708);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $9308b055cc17bac6$export$60332b2344f7fe41 = ({ url: url = '', onError: onError = (_error)=>{}, children: children = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {}) })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        "data-testid": `smart-card-${url}`,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("button", {
                onClick: ()=>onError({
                        status: 'not_found'
                    }),
                children: "Trigger not_found error status"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("button", {
                onClick: ()=>onError({
                        status: 'unauthorized'
                    }),
                children: "Trigger unauthorized error status"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("button", {
                onClick: ()=>onError({
                        status: 'forbidden'
                    }),
                children: "Trigger forbidden error status"
            }),
            children
        ]
    });
const $9308b055cc17bac6$export$7b5e1b7f9a325b6 = $9308b055cc17bac6$export$60332b2344f7fe41;
const $9308b055cc17bac6$export$2e4ce4ce734f69e1 = ({ primary: primary = [] })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        children: primary.map(({ name: name })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                children: [
                    "Primary metadata: ",
                    name
                ]
            }, name))
    });
const $9308b055cc17bac6$export$50a6a2d597e669c = ({ children: children = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {}) })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        children: [
            "CustomBlock",
            children
        ]
    });
const $9308b055cc17bac6$export$fff1c9c894fd3e9c = ({ overrideUrl: overrideUrl = 'NONE' })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        children: [
            "Preview: ",
            overrideUrl
        ]
    });
const $9308b055cc17bac6$export$ababd1478ac17bc0 = ({ text: text = '' })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        children: [
            "Snippet: ",
            text
        ]
    });
const $9308b055cc17bac6$export$ccf187e9bb6e68c = ({ metadata: metadata = [], text: text = '' })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
        children: [
            !!text ? text : 'TitleBlock',
            metadata.map(({ name: name })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                    children: [
                        "Metadata: ",
                        name
                    ]
                }, name))
        ]
    });
const $9308b055cc17bac6$export$427679abd9cc3708 = {
    actions: {
        onLogoutClick: ()=>({
                type: 'epic.logout.LOG_OUT'
            })
    },
    env: {
        cloudId: '17554ffe-ef18-4562-8222-e295e81a46bb',
        helpCenterAri: 'ari:cloud:help::help-center/5b32ba66-fea2-4010-893d-278bfac050bc/5e67e6f9-7753-41fa-811b-55cb9fd71897',
        helpCenterId: '5e67e6f9-7753-41fa-811b-55cb9fd71897',
        hoistedProjectKey: 'TR',
        hubEditMode: false,
        jiraDisplayUrl: '/',
        relativeBaseUrl: '/'
    },
    layout: {
        bannerText: '',
        isAnonymousRoute: false,
        showBanner: false
    },
    user: {
        avatarSrc: '',
        displayName: 'test_name',
        email: 'test@atlassian.com',
        id: 'some_random_id',
        isJiraAdmin: false
    }
};

});

parcelRegister("cgbM9", function(module, exports) {
$parcel$export(module.exports, "HubAppShell", () => $3343583a5236ed36$export$647b3ff790ea59d4);
/* main.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $2CGHX = parcelRequire("2CGHX");

var $4YrWz = parcelRequire("4YrWz");
var $8NbLB = parcelRequire("8NbLB");
var $fTpWL = parcelRequire("fTpWL");
var $8klCX = parcelRequire("8klCX");

var $68UBK = parcelRequire("68UBK");

var $gT19S = parcelRequire("gT19S");
const $3343583a5236ed36$var$containerStyles = {
    bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
    container: "_19itglyw _1reo1wug _18m91wug _vchhusvi _r06hglyw _kqswh2mm _bfhkhp5a _1tke1osq _1e0c1txw _2lx21bp4 _1bzh1gj0 _5cd81gj0",
    childrenWrapper: "_n3tdoahv",
    childrenWrapperEditMode: "_16jlkb7n _1tkeidpf"
};
const $3343583a5236ed36$export$647b3ff790ea59d4 = ({ children: children, isEditMode: isEditMode = false })=>{
    var _branding$colors;
    const { layout: layout, branding: branding, containerStyling: containerStyling, headerless: headerless } = (0, $8NbLB.useHubContext)();
    const { options: navStyle } = (0, $fTpWL.useNavigationStyle)();
    const fixedNavBarStyling = navStyle !== null && navStyle !== void 0 && navStyle.fixedAtTop ? {
        height: '100%'
    } : {};
    const isHeaderless = headerless && (0, $e6Qdr.fg)('csm-support-site-headerless-query-param');
    const showBanner = layout === null || layout === void 0 ? void 0 : layout.showBanner;
    const primaryColor = branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary;
    const shouldApplyContainerStyling = (0, $e6Qdr.fg)('enable-jsm-in-hubs');
    // Default hardcoded styles (used when feature flag is disabled for backward compatibility)
    const defaultContainerStyling = {
        borderRadius: "var(--ds-radius-large, 8px)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    };
    // Apply containerStyling from props if feature flag is enabled, otherwise use hardcoded defaults
    const appliedContainerStyling = shouldApplyContainerStyling ? containerStyling : defaultContainerStyling;
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        // we are targing whole document for branding style, because we need these variables in react portals as well, e.g. color picker
        return (0, $4YrWz.setHubBrandingStyle)({
            primaryColor: primaryColor
        });
    }, [
        primaryColor
    ]);
    const hubContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(null);
    (0, $8klCX.useUnsetGlobalTheme)(isEditMode ? hubContainerRef.current : null); // for view mode we don't need to unset the global theme
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $2CGHX.default), {
        xcss: $3343583a5236ed36$var$containerStyles.container,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic styles passed from outside via containerStyling prop
        style: {
            ...appliedContainerStyling,
            ...fixedNavBarStyling
        },
        ref: hubContainerRef,
        children: [
            !isHeaderless && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gT19S.Navbar), {
                isEditMode: isEditMode
            }),
            showBanner && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    $3343583a5236ed36$var$containerStyles.bannerContainer
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $68UBK.Banner), {})
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                xcss: isEditMode ? $3343583a5236ed36$var$containerStyles.childrenWrapperEditMode : $3343583a5236ed36$var$containerStyles.childrenWrapper,
                testId: "hub-app-shell-children-wrapper",
                children: children
            })
        ]
    });
};

});
parcelRegister("4YrWz", function(module, exports) {
$parcel$export(module.exports, "setHubBrandingStyle", () => $a5e29a06abb40f58$export$202bcc6267a600cb);

var $e6Qdr = parcelRequire("e6Qdr");

var $hmxnn = parcelRequire("hmxnn");
var $lYqwN = parcelRequire("lYqwN");

var $je3Qr = parcelRequire("je3Qr");
parcelRequire("euslt");
var $9Lbe3 = parcelRequire("9Lbe3");

var $2fABU = parcelRequire("2fABU");
const $a5e29a06abb40f58$var$readableTextColor = (color)=>{
    return (0, $hmxnn.readableTextColor)(color, '@atlassian/company-hub-common');
};
const $a5e29a06abb40f58$export$202bcc6267a600cb = ({ primaryColor: primaryColor, targetElement: targetElement })=>{
    const primaryColorToUse = primaryColor || (0, $2fABU.DEFAULT_BRANDING_COLOR);
    const finalTargetElement = targetElement || document.documentElement;
    try {
        // Convert to HEX for functions that require it (getLuminance, generateThemeBranding)
        const hexPrimaryColor = (0, $e6Qdr.fg)('company_hub_color_format_conversion') ? (0, $lYqwN.toHexColor)(primaryColorToUse) : primaryColorToUse;
        const primaryTextColor = $a5e29a06abb40f58$var$readableTextColor(hexPrimaryColor);
        // Keep original format for CSS custom property (works with any valid CSS color)
        finalTargetElement.style.setProperty((0, $2fABU.HUB_PRIMARY_COLOR_CSS_VAR), primaryColorToUse);
        finalTargetElement.style.setProperty((0, $2fABU.HUB_PRIMARY_TEXT_COLOR_CSS_VAR), primaryTextColor);
        // generateThemeBranding expects HEX colors
        const themeColours = (0, $je3Qr.generateThemeBranding)(hexPrimaryColor);
        finalTargetElement.style.setProperty((0, $2fABU.HUB_PRIMARY_LINK_COLOR_CSS_VAR), themeColours.color900);
    } catch (error) {
        (0, $9Lbe3.default)({
            error: error instanceof Error ? error : new Error(`Hub branding style processing failed for color: ${primaryColorToUse}`),
            meta: {
                id: 'setHubBrandingStyle',
                packageName: '@atlassian/company-hub-common'
            }
        });
        // Fallback to default branding if color processing fails
        finalTargetElement.style.setProperty((0, $2fABU.HUB_PRIMARY_COLOR_CSS_VAR), (0, $2fABU.DEFAULT_BRANDING_COLOR));
        finalTargetElement.style.setProperty((0, $2fABU.HUB_PRIMARY_TEXT_COLOR_CSS_VAR), "var(--ds-text, #292A2E)");
    }
    return ()=>{
        finalTargetElement.style.removeProperty((0, $2fABU.HUB_PRIMARY_COLOR_CSS_VAR));
        finalTargetElement.style.removeProperty((0, $2fABU.HUB_PRIMARY_TEXT_COLOR_CSS_VAR));
        finalTargetElement.style.removeProperty((0, $2fABU.HUB_PRIMARY_LINK_COLOR_CSS_VAR));
    };
};

});

parcelRegister("8klCX", function(module, exports) {
$parcel$export(module.exports, "useUnsetGlobalTheme", () => $aa85f5b91ce8f780$export$8726d385cd3f733);

var $8P7DW = parcelRequire("8P7DW");

var $dO9j7 = parcelRequire("dO9j7");
var $kHnjK = parcelRequire("kHnjK");
const $aa85f5b91ce8f780$export$8726d385cd3f733 = (targetElement, idsToUnset = [
    'light',
    'dark',
    'spacing'
])=>{
    const { colorMode: colorMode, dark: dark, light: light, spacing: spacing, typography: typography, UNSAFE_themeOptions: UNSAFE_themeOptions } = (0, $kHnjK.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        if (targetElement) (0, $dO9j7.default)().then((themeStyles)=>{
            themeStyles.forEach((themeStyle)=>{
                if (idsToUnset.includes(themeStyle.id)) {
                    const allCssVariables = themeStyle.css.match(/--[\w-]+/g); // output => ['--ds-text', '--ds-text-accent-lime']
                    allCssVariables === null || allCssVariables === void 0 || allCssVariables.forEach((cssVariable)=>{
                        targetElement.style.setProperty(cssVariable, 'initial');
                    });
                }
            });
        });
    }, [
        targetElement,
        idsToUnset,
        colorMode,
        dark,
        light,
        spacing,
        typography,
        UNSAFE_themeOptions
    ]);
};

});
parcelRegister("dO9j7", function(module, exports) {
$parcel$export(module.exports, "default", () => $1518a700fd7c27d5$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $4dNaw = parcelRequire("4dNaw");

var $8svlf = parcelRequire("8svlf");

var $6X8MD = parcelRequire("6X8MD");

var $9yGPt = parcelRequire("9yGPt");

/**
 * Takes an object containing theme preferences, and returns an array of objects for use in applying styles to the document head.
 * Only supplies the color themes necessary for initial render, based on the current themeState. I.e. if in light mode, dark mode themes are not returned.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns A Promise of an object array, containing theme IDs, data-attributes to attach to the theme, and the theme CSS.
 * If an error is encountered while loading themes, the themes array will be empty.
 */ const $1518a700fd7c27d5$var$getThemeStyles = async (preferences)=>{
    let themePreferences;
    let themeOverridePreferences = [];
    if (preferences === 'all') {
        themePreferences = (0, $4dNaw.themeIdsWithOverrides);
        // CLEANUP: Remove
        if (!(0, $e6Qdr.fg)('platform_increased-contrast-themes')) themePreferences = themePreferences.filter((n)=>n !== 'light-increased-contrast' && n !== 'dark-increased-contrast');
    } else {
        const themeState = {
            colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $4dNaw.themeStateDefaults)['colorMode'],
            contrastMode: (preferences === null || preferences === void 0 ? void 0 : preferences.contrastMode) || (0, $4dNaw.themeStateDefaults)['contrastMode'],
            dark: (preferences === null || preferences === void 0 ? void 0 : preferences.dark) || (0, $4dNaw.themeStateDefaults)['dark'],
            light: (preferences === null || preferences === void 0 ? void 0 : preferences.light) || (0, $4dNaw.themeStateDefaults)['light'],
            motion: (preferences === null || preferences === void 0 ? void 0 : preferences.motion) || (0, $4dNaw.themeStateDefaults)['motion'](),
            shape: (preferences === null || preferences === void 0 ? void 0 : preferences.shape) || (0, $4dNaw.themeStateDefaults)['shape'](),
            spacing: (preferences === null || preferences === void 0 ? void 0 : preferences.spacing) || (0, $4dNaw.themeStateDefaults)['spacing'],
            typography: (preferences === null || preferences === void 0 ? void 0 : preferences.typography) || (0, $4dNaw.themeStateDefaults)['typography']
        };
        themePreferences = (0, $6X8MD.getThemePreferences)(themeState);
        themeOverridePreferences = (0, $6X8MD.getThemeOverridePreferences)(themeState);
    }
    const results = await Promise.all([
        ...[
            ...themePreferences,
            ...themeOverridePreferences
        ].map(async (themeId)=>{
            try {
                const css = await (0, $9yGPt.loadThemeCss)(themeId);
                return {
                    id: themeId,
                    attrs: {
                        'data-theme': themeId
                    },
                    css: css
                };
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
        }),
        // Add custom themes if they're present
        (async (_preferences$UNSAFE_t)=>{
            if (preferences !== 'all' && preferences !== null && preferences !== void 0 && preferences.UNSAFE_themeOptions && (0, $8svlf.isValidBrandHex)(preferences === null || preferences === void 0 || (_preferences$UNSAFE_t = preferences.UNSAFE_themeOptions) === null || _preferences$UNSAFE_t === void 0 ? void 0 : _preferences$UNSAFE_t.brandColor)) try {
                const { getCustomThemeStyles: getCustomThemeStyles } = await (parcelRequire("lgSDe"));
                const customThemeStyles = await getCustomThemeStyles({
                    colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $4dNaw.themeStateDefaults)['colorMode'],
                    UNSAFE_themeOptions: preferences === null || preferences === void 0 ? void 0 : preferences.UNSAFE_themeOptions
                });
                return customThemeStyles;
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
            return undefined;
        })()
    ]);
    return results.flat().filter((theme)=>theme !== undefined);
};
var $1518a700fd7c27d5$export$2e2bcd8739ae039 = $1518a700fd7c27d5$var$getThemeStyles;

});

parcelRegister("kHnjK", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e5d14a22919c255$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $l5njV = parcelRequire("l5njV");

var $iXP8B = parcelRequire("iXP8B");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $7e5d14a22919c255$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $8P7DW.useState)((0, $l5njV.default)());
    (0, $8P7DW.useEffect)(()=>{
        const observer = new (0, $iXP8B.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $7e5d14a22919c255$export$2e2bcd8739ae039 = $7e5d14a22919c255$var$useThemeObserver;

});


parcelRegister("68UBK", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $d8483c9ec2c70e46$export$3b4e64e77073e307);
$parcel$export(module.exports, "withHubBanner", () => $d8483c9ec2c70e46$export$c5c3e0c2fc948b49);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $6E5P5 = parcelRequire("6E5P5");

var $2fABU = parcelRequire("2fABU");
var $dI6dR = parcelRequire("dI6dR");
var $8NbLB = parcelRequire("8NbLB");

var $ig0An = parcelRequire("ig0An");
const $d8483c9ec2c70e46$var$styles = {
    bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
    textContainer: "_4t3i8vuz _19pk1epz _otyr1epz",
    textContainerWidth: "_1bsb1vuk",
    bannerText: "_k48pwu06 _1wybckbl _vwz48vuz",
    bannerTextTruncation: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _y3gn1h6o",
    container: "_2rko12b0"
};
const $d8483c9ec2c70e46$var$BannerContent = ({ bannerText: bannerText })=>{
    const { branding: branding, layout: layout } = (0, $8NbLB.useHubContext)();
    const bannerBackgroundColour = branding.colors.primary;
    const title = bannerText ? bannerText : layout === null || layout === void 0 ? void 0 : layout.bannerText;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: bannerBackgroundColour
        },
        "data-testid": "banner",
        className: (0, $8n1kL.default)([
            $d8483c9ec2c70e46$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6E5P5.default), {
            alignInline: "center",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    $d8483c9ec2c70e46$var$styles.textContainer,
                    (0, $e6Qdr.fg)('enable-jsm-in-hubs') && $d8483c9ec2c70e46$var$styles.textContainerWidth
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    "data-testid": "banner-text",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    style: {
                        color: (0, $ig0An.readableTextColor)(bannerBackgroundColour)
                    },
                    className: (0, $8n1kL.default)([
                        $d8483c9ec2c70e46$var$styles.bannerText,
                        (0, $e6Qdr.fg)('enable-jsm-in-hubs') && $d8483c9ec2c70e46$var$styles.bannerTextTruncation
                    ]),
                    children: title || ''
                })
            })
        })
    });
};
// Fallback banner shown when BannerContent fails to render
const $d8483c9ec2c70e46$var$BannerFallback = ()=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            backgroundColor: (0, $2fABU.DEFAULT_BRANDING_COLOR)
        },
        "data-testid": "banner-fallback",
        className: (0, $8n1kL.default)([
            $d8483c9ec2c70e46$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6E5P5.default), {
            alignInline: "center",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    $d8483c9ec2c70e46$var$styles.textContainer
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: {
                        color: "var(--ds-text, #292A2E)"
                    },
                    className: (0, $8n1kL.default)([
                        $d8483c9ec2c70e46$var$styles.bannerText
                    ])
                })
            })
        })
    });
const $d8483c9ec2c70e46$export$3b4e64e77073e307 = ({ bannerText: bannerText })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dI6dR.HubErrorBoundary), {
        packageName: "@atlassian/hub-app-shell",
        id: "banner",
        fallback: /*#__PURE__*/ (0, $gWgPx.jsx)($d8483c9ec2c70e46$var$BannerFallback, {}),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($d8483c9ec2c70e46$var$BannerContent, {
            bannerText: bannerText
        })
    });
};
const $d8483c9ec2c70e46$export$c5c3e0c2fc948b49 = (InnerComponent)=>{
    const ComponentWithHubBanner = (props)=>{
        const { bannerText: bannerText, ...rest } = props;
        return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                    className: (0, $8n1kL.default)([
                        $d8483c9ec2c70e46$var$styles.bannerContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)($d8483c9ec2c70e46$export$3b4e64e77073e307, {
                        bannerText: bannerText
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)(InnerComponent, {
                    ...rest
                })
            ]
        });
    };
    return ComponentWithHubBanner;
};

});
parcelRegister("ig0An", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $ebfc4e49aff9b0f1$export$3d31854eb05903e0);

var $hmxnn = parcelRequire("hmxnn");
const $ebfc4e49aff9b0f1$export$3d31854eb05903e0 = (color)=>{
    return (0, $hmxnn.readableTextColor)(color, '@atlassian/hub-app-shell');
};

});


parcelRegister("gT19S", function(module, exports) {
$parcel$export(module.exports, "Navbar", () => $509698276ca8972c$export$42cfbb80f7861e77);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");
parcelRequire("9wocP");
var $cKYBS = parcelRequire("cKYBS");
var $dKPjT = parcelRequire("dKPjT");

var $2pAfo = parcelRequire("2pAfo");

var $hIXV0 = parcelRequire("hIXV0");

var $izQyW = parcelRequire("izQyW");
var $lRscM = parcelRequire("lRscM");

var $6NJAV = parcelRequire("6NJAV");

var $esjwb = parcelRequire("esjwb");

var $bAdLA = parcelRequire("bAdLA");

var $e6Qdr = parcelRequire("e6Qdr");

var $c2L1U = parcelRequire("c2L1U");

var $2CGHX = parcelRequire("2CGHX");
var $3iEm8 = parcelRequire("3iEm8");

var $d0WX2 = parcelRequire("d0WX2");
var $8NbLB = parcelRequire("8NbLB");
var $fTpWL = parcelRequire("fTpWL");

var $kuE33 = parcelRequire("kuE33");

var $4bV8X = parcelRequire("4bV8X");

var $gHkJq = parcelRequire("gHkJq");
const $509698276ca8972c$var$styles = {
    navbar: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    navbarUpdated: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    navBarDisabled: "_lcxvglyw",
    logoContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    rightSection: "_zulputpp _1e0c1txw _4cvr1h6o"
};
const $509698276ca8972c$export$42cfbb80f7861e77 = ({ isEditMode: isEditMode = false })=>{
    var _hubContext$layout;
    const [isAvatarMenuOpen, setIsAvatarMenuOpen] = (0, $8P7DW.useState)(false);
    const hubContext = (0, $8NbLB.useHubContext)();
    const { featureFlags: featureFlags, hubType: hubType } = hubContext;
    const { options: navStyle } = (0, $fTpWL.useNavigationStyle)();
    const isNavBarUpdated = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.hub_component_upgrade) ?? false;
    const dynamicStyle = (0, $8P7DW.useMemo)(()=>{
        if (!navStyle) return undefined;
        const border = `1px solid ${navStyle.borderColor}`;
        return {
            backgroundColor: navStyle.backgroundColor,
            color: navStyle.textColor,
            borderRadius: navStyle.padding ? `${navStyle.cornerRadius}px` : '0',
            border: navStyle.borderType === 'ALL_BORDER' ? border : 'none',
            // this will be the css 'none' value
            borderBottom: [
                'BOTTOM_BORDER',
                'ALL_BORDER'
            ].includes(navStyle.borderType) ? border : undefined,
            // bottom border is always applied for all borders
            position: navStyle.fixedAtTop ? 'sticky' : 'relative',
            top: navStyle.padding && navStyle.fixedAtTop ? "var(--ds-space-300, 24px)" : '0px',
            zIndex: navStyle.fixedAtTop ? 1 : undefined,
            margin: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginBottom: "var(--ds-space-300, 24px)" // we always add a margin bottom to the navbar
        };
    }, [
        navStyle
    ]);
    const iconColor = isNavBarUpdated ? navStyle === null || navStyle === void 0 ? void 0 : navStyle.textColor : undefined;
    const { push: push } = (0, $dKPjT.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const logoUrl = hubContext.branding.logo.url;
    const { avatarSrc: avatarSrc, email: email } = hubContext.user;
    const { renderRightNavActions: renderRightNavActions } = hubContext;
    const isAnonymousRoute = ((_hubContext$layout = hubContext.layout) === null || _hubContext$layout === void 0 ? void 0 : _hubContext$layout.isAnonymousRoute) || false;
    const handleInboxClick = (0, $8P7DW.useCallback)(()=>{
        push(`/user/requests`);
    }, [
        push
    ]);
    const handleProfileClick = (0, $8P7DW.useCallback)(()=>{
        setIsAvatarMenuOpen(!isAvatarMenuOpen);
    }, [
        isAvatarMenuOpen
    ]);
    const handleAvatarMenuClose = (0, $8P7DW.useCallback)(()=>{
        setIsAvatarMenuOpen(false);
    }, []);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        "data-testId": "navbar",
        xcss: (0, $6NJAV.cx)(isNavBarUpdated ? $509698276ca8972c$var$styles.navbarUpdated : $509698276ca8972c$var$styles.navbar, isEditMode && $509698276ca8972c$var$styles.navBarDisabled),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic navigation styles from context
        style: isNavBarUpdated ? dynamicStyle : {},
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $3iEm8.default), {
            justifyContent: "space-between",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                    xcss: $509698276ca8972c$var$styles.logoContainer,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cKYBS.default), {
                        to: !isAnonymousRoute ? '/' : '/user/login',
                        children: logoUrl ? /*#__PURE__*/ (0, $gWgPx.jsx)("img", {
                            height: (0, $d0WX2.getHubLogoHeight)(hubType),
                            src: logoUrl,
                            alt: formatMessage((0, $4bV8X.default).hubLogo)
                        }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lRscM.default), {
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($esjwb))), {
                                    ...iconProps,
                                    color: iconColor
                                }),
                            label: formatMessage((0, $4bV8X.default).hubLogo),
                            color: navStyle === null || navStyle === void 0 ? void 0 : navStyle.textColor
                        })
                    })
                }),
                !isAnonymousRoute && email && isNavBarUpdated && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gHkJq.NavLinks), {
                    textColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.textColor,
                    backgroundColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.backgroundColor
                }),
                !isAnonymousRoute && email && /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $2CGHX.default), {
                    xcss: $509698276ca8972c$var$styles.rightSection,
                    children: [
                        !isNavBarUpdated && /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                                    children: renderRightNavActions && renderRightNavActions()
                                }),
                                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lRscM.default), {
                                    appearance: "subtle",
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bAdLA))), {
                                            ...iconProps,
                                            color: iconColor
                                        }),
                                    label: "User requests",
                                    onClick: handleInboxClick
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $c2L1U.default), {
                            trigger: (triggerProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2pAfo.Profile), {
                                    ...triggerProps,
                                    tooltip: "Profile and settings",
                                    icon: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hIXV0.default), {
                                        appearance: "circle",
                                        size: "medium",
                                        src: avatarSrc
                                    }),
                                    onClick: handleProfileClick
                                }),
                            shouldRenderToParent: true,
                            placement: (0, $e6Qdr.fg)('csm_support_site_email_verification_updates') ? 'bottom-end' : 'bottom-start',
                            isOpen: isAvatarMenuOpen,
                            content: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $kuE33.AvatarMenu), {}),
                            onClose: handleAvatarMenuClose
                        })
                    ]
                }),
                !isAnonymousRoute && !email && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cKYBS.default), {
                    to: `/user/login`,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                        children: formatMessage((0, $4bV8X.default).login)
                    })
                })
            ]
        })
    });
};

});
parcelRegister("esjwb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd36682bcf7d93c8d6a4f8218f4f4e2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a862d21e534d6144$var$_react = $a862d21e534d6144$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $a862d21e534d6144$var$_baseNew = $a862d21e534d6144$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $a862d21e534d6144$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a862d21e534d6144$var$HomeIcon = (props)=>/*#__PURE__*/ $a862d21e534d6144$var$_react.default.createElement($a862d21e534d6144$var$_baseNew.default, Object.assign({
        name: "HomeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.799V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.799a2 2 0 0 1 .646-1.472zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.368V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.799a.5.5 0 0 0-.162-.368z" clip-rule="evenodd"/>`
    }, props));
$a862d21e534d6144$var$HomeIcon.displayName = 'HomeIcon';
var $a862d21e534d6144$var$_default = module.exports.default = $a862d21e534d6144$var$HomeIcon;

});

parcelRegister("d0WX2", function(module, exports) {
$parcel$export(module.exports, "getHubLogoHeight", () => $9fe144932ef5ab9c$export$8eeba3862e4455cf);

var $e6Qdr = parcelRequire("e6Qdr");

var $2fABU = parcelRequire("2fABU");
const $9fe144932ef5ab9c$export$8eeba3862e4455cf = (hubType)=>{
    // Help hubs always use new height
    if (hubType === 'HELP_HUB') return 0, $2fABU.HUB_LOGO_HEIGHT;
    // CSM hubs use new height only if feature gate is enabled
    if (hubType === 'CUSTOMER_SERVICE' && (0, $e6Qdr.fg)('csm_hub_logo_height_32px')) return 0, $2fABU.HUB_LOGO_HEIGHT;
    // Fallback to legacy height for CSM and other hub types
    return 0, $2fABU.HUB_LOGO_HEIGHT_LEGACY;
};

});

parcelRegister("kuE33", function(module, exports) {
$parcel$export(module.exports, "AvatarMenu", () => $34e38fda69ae4fa1$export$f7f58290278dd286);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $k7INq = parcelRequire("k7INq");
parcelRequire("9wocP");
var $cKYBS = parcelRequire("cKYBS");
var $i9cdb = parcelRequire("i9cdb");

var $6vx98 = parcelRequire("6vx98");
var $lkatq = parcelRequire("lkatq");
var $lSyMY = parcelRequire("lSyMY");
var $3rCJZ = parcelRequire("3rCJZ");
var $7qJSw = parcelRequire("7qJSw");

var $e6Qdr = parcelRequire("e6Qdr");

var $8NbLB = parcelRequire("8NbLB");

var $9HiEn = parcelRequire("9HiEn");

var $2EUCr = parcelRequire("2EUCr");

var $TPt4J = parcelRequire("TPt4J");
const $34e38fda69ae4fa1$var$styles = {
    menu: "_1bsbnpok"
};
const $34e38fda69ae4fa1$export$f7f58290278dd286 = ()=>{
    const hubContext = (0, $8NbLB.useHubContext)();
    const [{ match: match }] = (0, $i9cdb.useRouter)();
    const { user: user, env: env, actions: actions, renderAvatarMenuOptions: renderAvatarMenuOptions, cloudUrl: cloudUrl } = hubContext;
    const { isJiraAdmin: isJiraAdmin } = user;
    const { cloudId: cloudId, helpCenterId: helpCenterId, hoistedProjectKey: hoistedProjectKey } = env;
    const { id: pageId } = match.params;
    const { onLogoutClick: onLogoutClick } = actions;
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const shouldUseConsumerAvatarMenu = (0, $e6Qdr.fg)('enable-jsm-in-hubs');
    const consumerAvatarMenuContent = shouldUseConsumerAvatarMenu && typeof renderAvatarMenuOptions === 'function' ? renderAvatarMenuOptions() : null;
    const csmEditorUrl = `${cloudUrl}/jira/helpcenter/projects/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}`;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $8n1kL.default)([
            $34e38fda69ae4fa1$var$styles.menu
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $3rCJZ.default), {
            spacing: "cozy",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7qJSw.default), {
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9HiEn.AccountDetails), {})
                }),
                consumerAvatarMenuContent || isJiraAdmin && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7qJSw.default), {
                    hasSeparator: true,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lSyMY.default), {
                        href: (0, $e6Qdr.fg)('hub_edit_in_csm') ? csmEditorUrl : (0, $TPt4J.getStudioEditorUrl)(helpCenterId, cloudId || '', pageId),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
                        className: "cv-exclude-from-customisation",
                        children: formatMessage((0, $2EUCr.default).editSite)
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $7qJSw.default), {
                    hasSeparator: true,
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lkatq.default), {
                            component: (0, $cKYBS.default),
                            to: `/user/profile`,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
                            className: "cv-exclude-from-customisation",
                            children: formatMessage((0, $2EUCr.default).profile)
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6vx98.default), {
                            onClick: onLogoutClick,
                            children: formatMessage((0, $2EUCr.default).logout)
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("9HiEn", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $37292c1d17f86192$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $hIXV0 = parcelRequire("hIXV0");

var $e6Qdr = parcelRequire("e6Qdr");

var $3iEm8 = parcelRequire("3iEm8");
var $iPrfN = parcelRequire("iPrfN");
var $6E5P5 = parcelRequire("6E5P5");

var $8NbLB = parcelRequire("8NbLB");
const $37292c1d17f86192$var$styles = {
    displayName: "_11c8fhey",
    root: "_ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi",
    emailText: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _1e0c1o8l _p12f1lit"
};
const $37292c1d17f86192$export$66e04d0aacdb3b2 = ()=>{
    const { user: user } = (0, $8NbLB.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $8n1kL.default)([
            $37292c1d17f86192$var$styles.root
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3iEm8.default), {
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "space.100",
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hIXV0.default), {
                        appearance: "circle",
                        size: "medium",
                        src: avatarSrc
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6E5P5.default), {
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                            className: (0, $8n1kL.default)([
                                $37292c1d17f86192$var$styles.displayName
                            ]),
                            children: displayName
                        }),
                        (0, $e6Qdr.fg)('csm_support_site_email_verification_updates') ? /*#__PURE__*/ (0, $gWgPx.jsx)("small", {
                            className: (0, $8n1kL.default)([
                                $37292c1d17f86192$var$styles.emailText
                            ]),
                            children: email
                        }) : /*#__PURE__*/ (0, $gWgPx.jsx)("small", {
                            children: email
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("2EUCr", function(module, exports) {
$parcel$export(module.exports, "default", () => $85238fc0f4c55e6d$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $85238fc0f4c55e6d$var$_default_1 = (0, $6K2Gm.defineMessages)({
    editSite: {
        id: 'hub-app-shell.avatar-menu.edit-site',
        defaultMessage: 'Edit site',
        description: 'Edit the customer hub'
    },
    profile: {
        id: 'hub-app-shell.avatar-menu.profile',
        defaultMessage: 'Profile',
        description: 'Profile for the user'
    },
    logout: {
        id: 'hub-app-shell.avatar-menu.logout',
        defaultMessage: 'Logout',
        description: 'Logout for the user'
    }
});
var $85238fc0f4c55e6d$export$2e2bcd8739ae039 = $85238fc0f4c55e6d$var$_default_1;

});

parcelRegister("TPt4J", function(module, exports) {
$parcel$export(module.exports, "getStudioEditorUrl", () => $026f98a2767722c3$export$6cd112ed37714fd4);
const $026f98a2767722c3$var$STUDIO_URL = 'https://studio.atlassian.com';
const $026f98a2767722c3$var$STUDIO_URL_STAGING = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
const $026f98a2767722c3$var$isStaging = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
const $026f98a2767722c3$export$6cd112ed37714fd4 = (helpCenterId, cloudId, pageId)=>{
    const studioUrl = $026f98a2767722c3$var$isStaging() ? $026f98a2767722c3$var$STUDIO_URL_STAGING : $026f98a2767722c3$var$STUDIO_URL;
    if (!pageId) return `${studioUrl}/s/${cloudId}/hubs/${helpCenterId}`;
    return `${studioUrl}/s/${cloudId}/hubs/${helpCenterId}/pages/${pageId}`;
};

});


parcelRegister("4bV8X", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b82491e4ab9aeae$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $7b82491e4ab9aeae$var$_default_1 = (0, $6K2Gm.defineMessages)({
    hubLogo: {
        id: 'company-hub.hub-app-shell.navbar.hub.logo',
        defaultMessage: 'Support home',
        description: 'The logo of the Hub'
    },
    login: {
        id: 'company-hub.hub-app-shell.navbar.hub.log-in',
        defaultMessage: 'Log in',
        description: 'Log in button label'
    }
});
var $7b82491e4ab9aeae$export$2e2bcd8739ae039 = $7b82491e4ab9aeae$var$_default_1;

});

parcelRegister("gHkJq", function(module, exports) {
$parcel$export(module.exports, "NavLinks", () => $950acd19d4583e83$export$b615cd9717379c80);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $dzkwO = parcelRequire("dzkwO");

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");

var $ifRQf = parcelRequire("ifRQf");

var $2CGHX = parcelRequire("2CGHX");
var $iPrfN = parcelRequire("iPrfN");
var $6JY8y = parcelRequire("6JY8y");

var $4peLG = parcelRequire("4peLG");

var $8NbLB = parcelRequire("8NbLB");

var $gZSv6 = parcelRequire("gZSv6");

var $5tq0d = parcelRequire("5tq0d");

var $b80Ey = parcelRequire("b80Ey");

var $kPEjp = parcelRequire("kPEjp");
const $950acd19d4583e83$var$styles = {
    countBadge: "_2rkopb1k _4t3igktf _1ul9gktf _1e0c116y _4cvr1h6o _1bah1h6o _bfhk1aqn _syaz15cr _19bv1b66 _u5f31b66"
};
const $950acd19d4583e83$var$NavLinkItems = ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", requestCount: requestCount, textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    var _data$helpCenter;
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const { push: push } = (0, $dKPjT.useRouterActions)();
    const { cloudId: cloudId, env: { helpCenterAri: helpCenterAri } } = (0, $8NbLB.useHubContext)();
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $dzkwO.default), {
        cloudId: cloudId,
        hubAri: helpCenterAri
    });
    const helpCenterById = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const helpCenterRef = (helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.__typename) === 'HelpCenter' ? helpCenterById : null;
    const handleHomeClick = (0, $8P7DW.useCallback)(()=>{
        push('/');
    }, [
        push
    ]);
    const handleRequestsClick = (0, $8P7DW.useCallback)(()=>{
        push('/user/requests');
    }, [
        push
    ]);
    const handleApprovalsClick = (0, $8P7DW.useCallback)(()=>{
        push('/user/approvals');
    }, [
        push
    ]);
    if (!requestCount || !helpCenterById) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
        testId: "nav-links",
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                appearance: "subtle",
                onClick: handleHomeClick,
                style: {
                    color: textColor
                },
                children: formatMessage((0, $5tq0d.default).home)
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $kPEjp.PortalDropdown), {
                queryRef: helpCenterRef,
                textColor: textColor
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                appearance: "subtle",
                onClick: handleRequestsClick,
                style: {
                    color: textColor
                },
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
                    alignBlock: "center",
                    space: "space.075",
                    children: [
                        formatMessage((0, $5tq0d.default).requests),
                        requestCount.request > 0 && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                            as: "span",
                            style: {
                                backgroundColor: textColor,
                                color: backgroundColor
                            },
                            xcss: $950acd19d4583e83$var$styles.countBadge,
                            children: requestCount.request
                        })
                    ]
                })
            }),
            requestCount.approvals > 0 && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                appearance: "subtle",
                onClick: handleApprovalsClick,
                style: {
                    color: textColor
                },
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
                    alignBlock: "center",
                    space: "space.075",
                    children: [
                        formatMessage((0, $5tq0d.default).approvals),
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                            as: "span",
                            style: {
                                backgroundColor: textColor,
                                color: backgroundColor
                            },
                            xcss: $950acd19d4583e83$var$styles.countBadge,
                            children: requestCount.approvals
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $b80Ey.MoreDropdown), {
                queryRef: helpCenterRef,
                textColor: textColor
            })
        ]
    });
};
const $950acd19d4583e83$export$b615cd9717379c80 = ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    var _UNSAFE_useMediaQuery;
    const [requestCount, setRequestCount] = (0, $8P7DW.useState)(null);
    const { cloudUrl: cloudUrl, env: { helpCenterAri: helpCenterAri } } = (0, $8NbLB.useHubContext)();
    (0, $8P7DW.useEffect)(()=>{
        (0, $gZSv6.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
            setRequestCount({
                approvals: data.userRequestsCounts.approvalsCount,
                request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
            });
        }).catch(()=>{
            // fallback count to zero if request count API fails
            setRequestCount({
                approvals: 0,
                request: 0
            });
        });
    }, [
        cloudUrl,
        helpCenterAri
    ]);
    const isBelowSm = ((_UNSAFE_useMediaQuery = (0, $6JY8y.UNSAFE_useMediaQuery)('below.sm')) === null || _UNSAFE_useMediaQuery === void 0 ? void 0 : _UNSAFE_useMediaQuery.matches) ?? false;
    if (isBelowSm) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
        fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "nav-links-loader"
        }),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($950acd19d4583e83$var$NavLinkItems, {
            textColor: textColor,
            backgroundColor: backgroundColor,
            requestCount: requestCount
        })
    });
};

});
parcelRegister("dzkwO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e000c817c40f5d2b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3cd7e86fe1cd3b89ebfcd7c43e9ecdbf>>
 * @relayHash e3ab3c07799a07e48aa007432a9e01ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 514323f1394cfa2b2152df0caef6ade5d66a70e35ad4643bcac9ab5b68b507b4
const $e000c817c40f5d2b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hubAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "portalDropdown_AtlassianHubAppShell"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "moreDropdown_AtlassianHubAppShell"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterPortals",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterPortal",
                                                    "kind": "LinkedField",
                                                    "name": "portalsList",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "customPages",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "ids": [],
                                                        "type": "CUSTOM"
                                                    }
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterPageName",
                                                    "kind": "LinkedField",
                                                    "name": "name",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "default"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "514323f1394cfa2b2152df0caef6ade5d66a70e35ad4643bcac9ab5b68b507b4",
            "metadata": {},
            "name": "navLinksQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e000c817c40f5d2b$var$node.hash = "93d8a5027ba8ad5df73422d34d04542d";
var $e000c817c40f5d2b$export$2e2bcd8739ae039 = $e000c817c40f5d2b$var$node;

});

parcelRegister("gZSv6", function(module, exports) {
$parcel$export(module.exports, "getRequestCount", () => $9ee8128635141342$export$9aabeb09177df765);
const $9ee8128635141342$var$MODELS_API_URL = '/rest/servicedesk/1/customer/models';
const $9ee8128635141342$export$9aabeb09177df765 = async (cloudUrl, helpCenterAri)=>{
    const response = await fetch(`${cloudUrl}${$9ee8128635141342$var$MODELS_API_URL}`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                clientBasePath: cloudUrl,
                helpCenterAri: helpCenterAri
            },
            models: [
                'userRequestsCounts'
            ]
        })
    });
    return response.json();
};

});

parcelRegister("5tq0d", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3cd0bfe757abdcc$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $c3cd0bfe757abdcc$var$messages = (0, $6K2Gm.defineMessages)({
    downIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.down-icon',
        defaultMessage: 'Open dropdown',
        description: 'Icon label for the chevron down icon'
    },
    home: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.home.non-final',
        defaultMessage: 'Home',
        description: 'Navigation link label for the home page'
    },
    more: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.non-final',
        defaultMessage: 'More',
        description: 'Navigation link label for the more page'
    },
    portals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portals.non-final',
        defaultMessage: 'Portals',
        description: 'Navigation link label for the portals page'
    },
    requests: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.requests.non-final',
        defaultMessage: 'Requests',
        description: 'Navigation link label for user requests'
    },
    approvals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.approvals.non-final',
        defaultMessage: 'Approvals',
        description: 'Navigation link label for user approvals'
    }
});
var $c3cd0bfe757abdcc$export$2e2bcd8739ae039 = $c3cd0bfe757abdcc$var$messages;

});

parcelRegister("b80Ey", function(module, exports) {
$parcel$export(module.exports, "MoreDropdown", () => $d9c03bcd76bd4edd$export$6d7fd1d1521d3638);

var $gWgPx = parcelRequire("gWgPx");

var $93oQc = parcelRequire("93oQc");
parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");

var $ifRQf = parcelRequire("ifRQf");

var $1Gxf0 = parcelRequire("1Gxf0");
var $jfwik = parcelRequire("jfwik");
var $atwik = parcelRequire("atwik");

var $cDQfx = parcelRequire("cDQfx");

var $f1STa = parcelRequire("f1STa");

var $78eL2 = parcelRequire("78eL2");

var $emJfX = parcelRequire("emJfX");
const $d9c03bcd76bd4edd$export$6d7fd1d1521d3638 = ({ queryRef: queryRef, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const { push: push } = (0, $dKPjT.useRouterActions)();
    const data = (0, $h3cOB.useFragment)((0, $93oQc.default), queryRef);
    const customPages = data === null || data === void 0 ? void 0 : data.customPages;
    if (!customPages || customPages.length === 0) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1Gxf0.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
                    label: formatMessage((0, $emJfX.default).moreDownIcon)
                }),
                ref: triggerRef,
                children: formatMessage((0, $emJfX.default).more)
            }),
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $atwik.default), {
            children: customPages.map((page)=>{
                var _page$name;
                const pageId = page !== null && page !== void 0 && page.id ? (0, $78eL2.HelpPageAri).parse(page.id).pageId : '';
                return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jfwik.default), {
                    testId: `nav-custom-page-${pageId}`,
                    elemBefore: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f1STa))), {
                        label: formatMessage((0, $emJfX.default).pageIconLabel)
                    }),
                    onClick: ()=>{
                        push(`/page/${pageId}`);
                    },
                    children: page === null || page === void 0 || (_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default
                }, pageId);
            })
        })
    });
};

});
parcelRegister("93oQc", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2673ad8096cb91f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6146d83e6bd4550baf92d321251683d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f2673ad8096cb91f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "customPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "CUSTOM"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
        }
    ],
    "type": "HelpCenter"
};
$f2673ad8096cb91f$var$node.hash = "bdf2ee4c0e7d81a58ea6f6250d6f062a";
var $f2673ad8096cb91f$export$2e2bcd8739ae039 = $f2673ad8096cb91f$var$node;

});

parcelRegister("1Gxf0", function(module, exports) {
$parcel$export(module.exports, "default", () => $4101d0e89df267ec$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $izQyW = parcelRequire("izQyW");

var $dquZk = parcelRequire("dquZk");

var $klxUK = parcelRequire("klxUK");

var $5J6r2 = parcelRequire("5J6r2");

var $aCOCE = parcelRequire("aCOCE");

var $7qBJJ = parcelRequire("7qBJJ");

var $cDQfx = parcelRequire("cDQfx");

var $BnUzk = parcelRequire("BnUzk");

var $c2L1U = parcelRequire("c2L1U");

var $2nrNX = parcelRequire("2nrNX");

var $bkFoX = parcelRequire("bkFoX");

var $jIXix = parcelRequire("jIXix");

var $cbrsm = parcelRequire("cbrsm");

var $l6qSE = parcelRequire("l6qSE");

var $jDwX8 = parcelRequire("jDwX8");
const $4101d0e89df267ec$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $4101d0e89df267ec$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $4101d0e89df267ec$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$4101d0e89df267ec$var$opposites[crossAxis]}`,
            `${$4101d0e89df267ec$var$opposites[mainAxis]}-${crossAxis}`,
            `${$4101d0e89df267ec$var$opposites[mainAxis]}`,
            `${$4101d0e89df267ec$var$opposites[mainAxis]}-${$4101d0e89df267ec$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$4101d0e89df267ec$var$opposites[mainAxis]}`,
        `${$4101d0e89df267ec$var$opposites[mainAxis]}-start`,
        `${$4101d0e89df267ec$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $4101d0e89df267ec$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $4101d0e89df267ec$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5J6r2.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $2nrNX.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $aCOCE.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $8P7DW.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $8P7DW.useState)(false);
    const id = (0, $jDwX8.default)();
    const itemRef = (0, $l6qSE.default)();
    const { currentLevel: currentLevel } = (0, $BnUzk.useLayering)();
    const fallbackPlacements = (0, $8P7DW.useMemo)(()=>$4101d0e89df267ec$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $8P7DW.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $8P7DW.useCallback)((event, currentLevel)=>{
        var _event$target$closest, _event$target;
        const isTabLeftOrEscapeKey = $4101d0e89df267ec$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $dquZk.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $4101d0e89df267ec$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $dquZk.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, `[id^=${(0, $jDwX8.PREFIX)}] [aria-haspopup]`)) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($4101d0e89df267ec$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $dquZk.KEY_LEFT))) requestAnimationFrame(()=>{
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7qBJJ.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $8P7DW.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5J6r2.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5J6r2.default;
        return (0, $36kyW.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $jDwX8.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $dquZk.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $dquZk.KEY_SPACE) || e.key === (0, $dquZk.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $dquZk.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cbrsm.default), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $c2L1U.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $klxUK.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                    ...bindFocus,
                    ref: (0, $klxUK.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $bkFoX.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jIXix.default), {
                        spacing: spacing,
                        maxHeight: $4101d0e89df267ec$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $4101d0e89df267ec$export$2e2bcd8739ae039 = $4101d0e89df267ec$var$DropdownMenu;

});
parcelRegister("aCOCE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e07aafba2d149e76$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $e07aafba2d149e76$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $8P7DW.useState)(getDefaultPropValue);
    const isControlledRef = (0, $8P7DW.useRef)(isControlled);
    (0, $8P7DW.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $8P7DW.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7qBJJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $11a8f7c2e7958188$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $11a8f7c2e7958188$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $8P7DW.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $8P7DW.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $8P7DW.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("bkFoX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cfc6466f2db501f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");

var $BnUzk = parcelRequire("BnUzk");

var $3DYLm = parcelRequire("3DYLm");

var $7QXRJ = parcelRequire("7QXRJ");
/**
 * Focus manager logic.
 */ const $3cfc6466f2db501f$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $8P7DW.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $8P7DW.useState)(0);
    const registerMode = (0, $8P7DW.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $8P7DW.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $BnUzk.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $8P7DW.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $8P7DW.useEffect)(()=>(0, $36kyW.bind)(window, {
            type: 'keydown',
            listener: (0, $3DYLm.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7QXRJ.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $3cfc6466f2db501f$export$2e2bcd8739ae039 = $3cfc6466f2db501f$var$FocusManager;

});
parcelRegister("3DYLm", function(module, exports) {
$parcel$export(module.exports, "default", () => $91cd5855f95dd41b$export$2e2bcd8739ae039);

var $dquZk = parcelRequire("dquZk");

var $e6Qdr = parcelRequire("e6Qdr");

var $jDwX8 = parcelRequire("jDwX8");
const $91cd5855f95dd41b$var$actionMap = {
    [(0, $dquZk.KEY_DOWN)]: 'next',
    [(0, $dquZk.KEY_UP)]: 'prev',
    [(0, $dquZk.KEY_HOME)]: 'first',
    [(0, $dquZk.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $91cd5855f95dd41b$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $91cd5855f95dd41b$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $91cd5855f95dd41b$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>{
            var _document$activeEleme;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $e6Qdr.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest(`[id^=${(0, $jDwX8.PREFIX)}]`));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $dquZk.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $dquZk.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $dquZk.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $dquZk.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $91cd5855f95dd41b$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $91cd5855f95dd41b$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $91cd5855f95dd41b$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $91cd5855f95dd41b$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $91cd5855f95dd41b$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("jDwX8", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $7305062caf7e5b67$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $7305062caf7e5b67$export$2e2bcd8739ae039);

var $fnhqr = parcelRequire("fnhqr");
const $7305062caf7e5b67$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $7305062caf7e5b67$export$2e2bcd8739ae039() {
    const id = (0, $fnhqr.useId)();
    return `${$7305062caf7e5b67$export$8a682ae47622dbb9}${id}`;
}

});


parcelRegister("7QXRJ", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $f76162559427344e$export$f18c1d4fc7326096);

var $8P7DW = parcelRequire("8P7DW");

var $5J6r2 = parcelRequire("5J6r2");
const $f76162559427344e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $8P7DW.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5J6r2.default)
});

});


parcelRegister("jIXix", function(module, exports) {
$parcel$export(module.exports, "default", () => $35e6499532a18f49$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $3rCJZ = parcelRequire("3rCJZ");

var $e6Qdr = parcelRequire("e6Qdr");

var $2CGHX = parcelRequire("2CGHX");

var $cjn3r = parcelRequire("cjn3r");

var $6Wpec = parcelRequire("6Wpec");

var $fykqG = parcelRequire("fykqG");

var $7QXRJ = parcelRequire("7QXRJ");
const $35e6499532a18f49$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $35e6499532a18f49$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        xcss: $35e6499532a18f49$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $35e6499532a18f49$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $8P7DW.useContext)((0, $7QXRJ.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $6Wpec.default)(menuItem) || (0, $fykqG.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $8P7DW.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $e6Qdr.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3rCJZ.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $gWgPx.jsx)($35e6499532a18f49$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $35e6499532a18f49$export$2e2bcd8739ae039 = $35e6499532a18f49$var$MenuWrapper;

});
parcelRegister("6Wpec", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc8b60105897a626$export$2e2bcd8739ae039);
function $dc8b60105897a626$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("fykqG", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a667e8cd476d702$export$2e2bcd8739ae039);
function $4a667e8cd476d702$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("cbrsm", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a9c8509a4b7f2f1$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $c64W0 = parcelRequire("c64W0");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $0a9c8509a4b7f2f1$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $8P7DW.useRef)({});
    const context = (0, $8P7DW.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $c64W0.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $0a9c8509a4b7f2f1$export$2e2bcd8739ae039 = $0a9c8509a4b7f2f1$var$SelectionStore;

});
parcelRegister("c64W0", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $a8b1a474d760e61c$export$756f795847463ebd);

var $8P7DW = parcelRequire("8P7DW");

var $5J6r2 = parcelRequire("5J6r2");
const $a8b1a474d760e61c$export$756f795847463ebd = /*#__PURE__*/ (0, $8P7DW.createContext)({
    setItemState: (0, $5J6r2.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5J6r2.default),
    getGroupState: ()=>({})
});

});


parcelRegister("l6qSE", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8d36216f9ec9c9f$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $7QXRJ = parcelRequire("7QXRJ");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $b8d36216f9ec9c9f$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $8P7DW.useContext)((0, $7QXRJ.FocusManagerContext));
    const itemRef = (0, $8P7DW.useRef)(null);
    (0, $8P7DW.useEffect)(()=>{
        if (hasPopup && (0, $e6Qdr.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $b8d36216f9ec9c9f$export$2e2bcd8739ae039 = $b8d36216f9ec9c9f$var$useRegisterItemWithFocusManager;

});


parcelRegister("jfwik", function(module, exports) {
$parcel$export(module.exports, "default", () => $921d80c2ec113a03$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $klxUK = parcelRequire("klxUK");

var $6vx98 = parcelRequire("6vx98");

var $lkatq = parcelRequire("lkatq");

var $lSyMY = parcelRequire("lSyMY");

var $l6qSE = parcelRequire("l6qSE");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $921d80c2ec113a03$var$DropdownMenuItem = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $l6qSE.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $8P7DW.useCallback)((event)=>{
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lkatq.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $klxUK.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lSyMY.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $klxUK.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6vx98.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $klxUK.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $921d80c2ec113a03$export$2e2bcd8739ae039 = $921d80c2ec113a03$var$DropdownMenuItem;

});

parcelRegister("atwik", function(module, exports) {
$parcel$export(module.exports, "default", () => $c147867436ecca8c$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fnhqr = parcelRequire("fnhqr");

var $7qJSw = parcelRequire("7qJSw");

var $dI2SL = parcelRequire("dI2SL");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $c147867436ecca8c$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $fnhqr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $7qJSw.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dI2SL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $c147867436ecca8c$export$2e2bcd8739ae039 = $c147867436ecca8c$var$DropdownMenuItemGroup;

});
parcelRegister("dI2SL", function(module, exports) {
$parcel$export(module.exports, "default", () => $46175d25ca13ea7f$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $2CGHX = parcelRequire("2CGHX");
const $46175d25ca13ea7f$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $46175d25ca13ea7f$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $46175d25ca13ea7f$var$styles.heading,
        children: title
    });
var $46175d25ca13ea7f$export$2e2bcd8739ae039 = $46175d25ca13ea7f$var$GroupTitle;

});


parcelRegister("emJfX", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd4885270d692441$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $dd4885270d692441$var$messages = (0, $6K2Gm.defineMessages)({
    more: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.non-final',
        defaultMessage: 'More',
        description: 'Navigation link label for the more dropdown showing custom pages'
    },
    moreDownIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.chevron-down.non-final',
        defaultMessage: 'Open more dropdown',
        description: 'Icon label for the chevron down icon'
    },
    pageIconLabel: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.page-icon-label',
        defaultMessage: 'Page icon',
        description: 'Label for the page icon in the more dropdown'
    }
});
var $dd4885270d692441$export$2e2bcd8739ae039 = $dd4885270d692441$var$messages;

});


parcelRegister("kPEjp", function(module, exports) {
$parcel$export(module.exports, "PortalDropdown", () => $b4bd65ad93e0977e$export$32e0c0d1c2f88773);

var $gWgPx = parcelRequire("gWgPx");

var $5BGnG = parcelRequire("5BGnG");
parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");

var $ifRQf = parcelRequire("ifRQf");

var $1Gxf0 = parcelRequire("1Gxf0");
var $jfwik = parcelRequire("jfwik");
var $atwik = parcelRequire("atwik");

var $cDQfx = parcelRequire("cDQfx");

var $f1STa = parcelRequire("f1STa");

var $9KwAC = parcelRequire("9KwAC");
const $b4bd65ad93e0977e$export$32e0c0d1c2f88773 = ({ queryRef: queryRef, textColor: textColor })=>{
    var _data$portals;
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const { push: push } = (0, $dKPjT.useRouterActions)();
    const data = (0, $h3cOB.useFragment)((0, $5BGnG.default), queryRef);
    const portalPages = data === null || data === void 0 || (_data$portals = data.portals) === null || _data$portals === void 0 ? void 0 : _data$portals.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (hasSinglePortal) {
        var _portalPages$2;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
            appearance: "subtle",
            onClick: ()=>{
                var _portalPages$;
                push(`/portal/${(_portalPages$ = portalPages[0]) === null || _portalPages$ === void 0 ? void 0 : _portalPages$.id}`);
            },
            style: {
                color: textColor
            },
            children: (_portalPages$2 = portalPages[0]) === null || _portalPages$2 === void 0 ? void 0 : _portalPages$2.name
        });
    }
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1Gxf0.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
                    label: formatMessage((0, $9KwAC.default).portalDownIcon)
                }),
                ref: triggerRef,
                children: formatMessage((0, $9KwAC.default).portals)
            }),
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $atwik.default), {
            children: portalPages === null || portalPages === void 0 ? void 0 : portalPages.map((portal)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $jfwik.default), {
                    onClick: ()=>{
                        push(`/portal/${portal === null || portal === void 0 ? void 0 : portal.id}`);
                    },
                    elemBefore: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f1STa))), {
                        label: formatMessage((0, $9KwAC.default).pageIcon)
                    }),
                    children: portal === null || portal === void 0 ? void 0 : portal.name
                }, portal === null || portal === void 0 ? void 0 : portal.id))
        })
    });
};

});
parcelRegister("5BGnG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cc4578330fffc54$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<75fc6ffd3ccf7dc094dd961656b948ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0cc4578330fffc54$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "concreteType": "HelpCenterPortals",
            "kind": "LinkedField",
            "name": "portals",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HelpCenterPortal",
                    "kind": "LinkedField",
                    "name": "portalsList",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$0cc4578330fffc54$var$node.hash = "9321e563780af8e8cdc6d16d81e1564c";
var $0cc4578330fffc54$export$2e2bcd8739ae039 = $0cc4578330fffc54$var$node;

});

parcelRegister("9KwAC", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a285f2f50740a3b$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $6a285f2f50740a3b$var$messages = (0, $6K2Gm.defineMessages)({
    pageIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.page-icon.non-final',
        defaultMessage: 'Page icon',
        description: 'Icon label for the page icon'
    },
    portalDownIcon: {
        defaultMessage: 'Open portals dropdown',
        description: 'Icon label for the chevron down icon',
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-down.non-final'
    },
    portals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portals.non-final',
        defaultMessage: 'Portals',
        description: 'Navigation link label for the portals dropdown'
    }
});
var $6a285f2f50740a3b$export$2e2bcd8739ae039 = $6a285f2f50740a3b$var$messages;

});





parcelRegister("6cLgn", function(module, exports) {
$parcel$export(module.exports, "hubBootstrapResource", () => $4bcc3394517726d3$export$8ce4230d96a2a267);
$parcel$export(module.exports, "hubPageResource", () => $4bcc3394517726d3$export$6d8c7b8b2daae34c);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $e6Qdr = parcelRequire("e6Qdr");

var $3G5XU = parcelRequire("3G5XU");
var $g56Er = parcelRequire("g56Er");

var $6MtS4 = parcelRequire("6MtS4");

var $2qBo6 = parcelRequire("2qBo6");

var $70yzM = parcelRequire("70yzM");
const $4bcc3394517726d3$var$getPageIdFromRouteParams = (match, routeName)=>{
    if (routeName === (0, $6MtS4.HUB_PORTAL_PAGE_ROUTE_NAME) && (0, $e6Qdr.fg)('portal-pages-in-hub')) {
        const portalId = match.params.portalId;
        if (portalId) return `portal_page-${portalId}`;
    }
    return match.params.id || '';
};
const $4bcc3394517726d3$export$8ce4230d96a2a267 = (0, $70yzM.createRelayResource)({
    getQuery: ({ match: match, route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $6MtS4.HUB_PREVIEW_ROUTE_NAME);
        const pageId = $4bcc3394517726d3$var$getPageIdFromRouteParams(match, route === null || route === void 0 ? void 0 : route.name);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $g56Er.mockHubRouteProps).env.cloudId && (0, $g56Er.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $g56Er.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $g56Er.mockHubRouteProps).env.helpCenterAri;
        }
        return {
            variables: {
                cloudId: cloudIdDerived,
                hubAri: helpCenterAriDerived,
                pageAri: (0, $70yzM.getPageAri)(helpCenterAriDerived, pageId),
                operationType: 'READ',
                hubEditMode: false
            },
            query: (0, $3G5XU.default),
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $4bcc3394517726d3$export$6d8c7b8b2daae34c = (0, $70yzM.createRelayResource)({
    getQuery: ({ match: match, route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $6MtS4.HUB_PREVIEW_ROUTE_NAME);
        const pageId = $4bcc3394517726d3$var$getPageIdFromRouteParams(match, route === null || route === void 0 ? void 0 : route.name);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $g56Er.mockHubRouteProps).env.cloudId && (0, $g56Er.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $g56Er.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $g56Er.mockHubRouteProps).env.helpCenterAri;
        }
        return {
            variables: {
                cloudId: cloudIdDerived,
                hubAri: helpCenterAriDerived,
                pageAri: (0, $70yzM.getPageAri)(helpCenterAriDerived, pageId)
            },
            query: (0, $2qBo6.default),
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("6MtS4", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTE_NAME", () => $6f184b14173d2a38$export$b4255e69eefe642e);
$parcel$export(module.exports, "HUB_PREVIEW_ROUTE_NAME", () => $6f184b14173d2a38$export$35619d8059a56474);
$parcel$export(module.exports, "HUB_PREVIEW_ROUTE_PATH", () => $6f184b14173d2a38$export$a1b29fc86625d058);
$parcel$export(module.exports, "HUB_ROUTE_PATH", () => $6f184b14173d2a38$export$2735e29305134506);
$parcel$export(module.exports, "HUB_CUSTOM_PAGE_ROUTE_NAME", () => $6f184b14173d2a38$export$da6ac9e48027aa54);
$parcel$export(module.exports, "HUB_CUSTOM_PAGE_ROUTE_PATH", () => $6f184b14173d2a38$export$7815c1f7abc1c129);
$parcel$export(module.exports, "HUB_PORTAL_PAGE_ROUTE_NAME", () => $6f184b14173d2a38$export$54ede43f7406f46f);
$parcel$export(module.exports, "HUB_PORTAL_PAGE_ROUTE_PATH", () => $6f184b14173d2a38$export$c7f93458584dce24);
const $6f184b14173d2a38$export$b4255e69eefe642e = 'hub';
const $6f184b14173d2a38$export$35619d8059a56474 = 'hub-preview';
const $6f184b14173d2a38$export$a1b29fc86625d058 = '/s/:cloudId/hubs/:hubId/preview';
const $6f184b14173d2a38$export$2735e29305134506 = '/';
const $6f184b14173d2a38$export$da6ac9e48027aa54 = 'hub-custom-page';
const $6f184b14173d2a38$export$7815c1f7abc1c129 = '/page/:id/:title?';
const $6f184b14173d2a38$export$54ede43f7406f46f = 'hub-portal-page';
const $6f184b14173d2a38$export$c7f93458584dce24 = '/portal/:portalId';

});

parcelRegister("2qBo6", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5be68ae7cb5e599$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<afe44fa220b5c7fb0ff460e6349193c4>>
 * @relayHash 6ad7e184a22f66733c008a377d050f14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 921cc31002437f6de86a3114612b5ed1a537f0ccb6696470d35522b79c5422d9
const $b5be68ae7cb5e599$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hubAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": v4 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterNavigationBar",
                        "kind": "LinkedField",
                        "name": "navigationBar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "backgroundColor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "borderColor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "borderType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cornerRadius"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "padding"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "positionType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "textColor"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "fields": [
                            {
                                "items": [
                                    {
                                        "kind": "Variable",
                                        "name": "ids.0",
                                        "variableName": "pageAri"
                                    }
                                ],
                                "kind": "ListValue",
                                "name": "ids"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                    }
                ],
                "concreteType": "HelpCenterPage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "concreteType": "HelpCenterPageName",
                        "kind": "LinkedField",
                        "name": "name",
                        "plural": false,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterPageLayout",
                        "kind": "LinkedField",
                        "name": "pageLayout",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HelpCenterLayoutAdf",
                                "kind": "LinkedField",
                                "name": "layoutAdf",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "HelpCenterLayoutAdfContentConnection",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "HelpCenterLayoutAdfContentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "HelpCenterLayoutAdfContent",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "content"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hubQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hubQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "921cc31002437f6de86a3114612b5ed1a537f0ccb6696470d35522b79c5422d9",
            "metadata": {},
            "name": "hubQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b5be68ae7cb5e599$var$node.hash = "81428e49598201386f7e3697e3459acf";
var $b5be68ae7cb5e599$export$2e2bcd8739ae039 = $b5be68ae7cb5e599$var$node;

});

parcelRegister("70yzM", function(module, exports) {
$parcel$export(module.exports, "createRelayResource", () => $8b6bc968c7874cd4$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $8b6bc968c7874cd4$export$42ca7b248c7aaee);
$parcel$export(module.exports, "getPageAri", () => $8b6bc968c7874cd4$export$9e8d72642057ad79);

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $5U6in = parcelRequire("5U6in");
var $hgkVf = parcelRequire("hgkVf");

var $cLmLE = parcelRequire("cLmLE");
var $78eL2 = parcelRequire("78eL2");

var $AGp7W = parcelRequire("AGp7W");

var $dgYZM = parcelRequire("dgYZM");
function $8b6bc968c7874cd4$var$createCacheKey(query, variables) {
    const queryId = 'cacheID' in query.params ? query.params.cacheID : query.params.id;
    return `relay-${queryId}-${query.params.name}-${JSON.stringify(variables ?? {})}`;
}
const $8b6bc968c7874cd4$export$1cc887c62079ea32 = ({ getQuery: getQuery })=>(0, $5U6in.createResource)({
        type: 'RELAY_RESOURCE_TYPE',
        getKey: (routerContext, customContext)=>{
            const { query: query, variables: variables, cacheKey: cacheKey } = getQuery(routerContext, customContext);
            return cacheKey ?? $8b6bc968c7874cd4$var$createCacheKey(query, variables);
        },
        getData: (routerContext, customContext)=>{
            const { query: query, variables: variables, options: options } = getQuery(routerContext, customContext);
            const queryReference = (0, $h3cOB.loadQuery)((0, $dgYZM.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__), query, variables ?? {}, options);
            return Promise.resolve(queryReference);
        }
    });
const $8b6bc968c7874cd4$export$42ca7b248c7aaee = (resource)=>{
    const { data: queryReference } = (0, $hgkVf.useResource)(resource);
    return {
        queryReference: queryReference
    };
};
const $8b6bc968c7874cd4$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null' && (0, $cLmLE.HelpHelpCenterAri).check(helpCenterAri)) {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $8b6bc968c7874cd4$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $8b6bc968c7874cd4$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    const resolvedPageId = pageId || helpCenterId;
    if ((0, $AGp7W.isPortalPage)(resolvedPageId) && helpCenterId) return (0, $AGp7W.buildPortalPageAri)(helpCenterAri, resolvedPageId);
    return (0, $78eL2.HelpPageAri).create({
        activationId: activationId,
        pageId: resolvedPageId
    }).toString() || '';
};

});
parcelRegister("AGp7W", function(module, exports) {
$parcel$export(module.exports, "HubPageType", () => $748494297b49a69b$export$dbf470ddbd9b58b6);
$parcel$export(module.exports, "isPortalPage", () => $748494297b49a69b$export$646dda995799f7d5);
$parcel$export(module.exports, "getPortalIdFromPageId", () => $748494297b49a69b$export$fef05bffd39d3ca1);
$parcel$export(module.exports, "buildPortalPageAri", () => $748494297b49a69b$export$9d2b62eb20639695);
$parcel$export(module.exports, "isHomePageByAri", () => $748494297b49a69b$export$c0ca1e0679075a3);
$parcel$export(module.exports, "resolveCurrentPage", () => $748494297b49a69b$export$bec70b043200c466);
// eslint-disable-next-line no-restricted-imports

var $cLmLE = parcelRequire("cLmLE");
var $78eL2 = parcelRequire("78eL2");
const $748494297b49a69b$var$PORTAL_PAGE_PREFIX = 'portal_page-';
const $748494297b49a69b$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null' && (0, $cLmLE.HelpHelpCenterAri).check(helpCenterAri)) {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // Silently fail for invalid ARIs
    }
};
var $748494297b49a69b$export$dbf470ddbd9b58b6 = /*#__PURE__*/ function(HubPageType) {
    /** The hub's home/landing page */ HubPageType["HOME"] = "HOME";
    /** A custom page created in the hub editor */ HubPageType["CUSTOM"] = "CUSTOM";
    /** A portal page backed by a JSM portal */ HubPageType["PORTAL"] = "PORTAL";
    return HubPageType;
}({});
const $748494297b49a69b$export$c246174f38c9bde7 = (pageId)=>{
    if (!pageId) return "HOME";
    if (pageId.startsWith($748494297b49a69b$var$PORTAL_PAGE_PREFIX)) return "PORTAL";
    return "CUSTOM";
};
const $748494297b49a69b$export$646dda995799f7d5 = (pageId)=>$748494297b49a69b$export$c246174f38c9bde7(pageId) === "PORTAL";
const $748494297b49a69b$export$fef05bffd39d3ca1 = (pageId)=>{
    if (!$748494297b49a69b$export$646dda995799f7d5(pageId)) return '';
    return pageId.slice($748494297b49a69b$var$PORTAL_PAGE_PREFIX.length);
};
const $748494297b49a69b$export$9d2b62eb20639695 = (helpCenterAri, portalPageId)=>{
    const meta = $748494297b49a69b$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return '';
    const { activationId: activationId, helpCenterId: helpCenterId } = meta;
    return `ari:cloud:help::page/${activationId}/${portalPageId}/${helpCenterId}`;
};
const $748494297b49a69b$export$c0ca1e0679075a3 = (parsedPageId, helpCenterAri)=>{
    const meta = $748494297b49a69b$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return false;
    return parsedPageId === meta.helpCenterId;
};
const $748494297b49a69b$export$bec70b043200c466 = (pageId, filteredPages, helpCenterAri, currentPageName)=>{
    const pageType = $748494297b49a69b$export$c246174f38c9bde7(pageId);
    if (pageType === "PORTAL") return {
        pageType: pageType,
        isHomePage: false,
        pageAri: $748494297b49a69b$export$9d2b62eb20639695(helpCenterAri, pageId),
        pageName: currentPageName || ''
    };
    if (pageType === "CUSTOM") {
        const matchedPage = filteredPages.find((page)=>{
            var _page$name;
            return ((_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default) && (0, $78eL2.HelpPageAri).parse(page.id).pageId === pageId;
        });
        if (matchedPage) {
            var _matchedPage$name;
            return {
                pageType: pageType,
                isHomePage: false,
                pageAri: matchedPage.id,
                pageName: ((_matchedPage$name = matchedPage.name) === null || _matchedPage$name === void 0 ? void 0 : _matchedPage$name.default) || ''
            };
        }
    }
    return {
        pageType: "HOME",
        isHomePage: true,
        pageAri: '',
        pageName: ''
    };
};

});



parcelRegister("ceBSw", function(module, exports) {
$parcel$export(module.exports, "HubApp", () => $4018b575546c10b1$export$44db4a416180c024);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $2qBo6 = parcelRequire("2qBo6");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $dCWA1 = parcelRequire("dCWA1");

var $k7INq = parcelRequire("k7INq");

var $h3cOB = parcelRequire("h3cOB");

var $feOkE = parcelRequire("feOkE");

var $lbS2q = parcelRequire("lbS2q");

var $4peLG = parcelRequire("4peLG");

var $cjn3r = parcelRequire("cjn3r");

var $bQ8UI = parcelRequire("bQ8UI");
var $8vv1J = parcelRequire("8vv1J");
var $17wqU = parcelRequire("17wqU");

var $j1eUG = parcelRequire("j1eUG");

var $lxDv6 = parcelRequire("lxDv6");
var $8NbLB = parcelRequire("8NbLB");
var $jkNhT = parcelRequire("jkNhT");
var $MLtq6 = parcelRequire("MLtq6");
var $dI6dR = parcelRequire("dI6dR");
var $fTpWL = parcelRequire("fTpWL");

var $fcpCb = parcelRequire("fcpCb");

var $6Wwpo = parcelRequire("6Wwpo");
var $56bQK = parcelRequire("56bQK");

var $cgbM9 = parcelRequire("cgbM9");

var $ciwA7 = parcelRequire("ciwA7");

var $jbMcU = parcelRequire("jbMcU");

var $1I66f = parcelRequire("1I66f");

var $kvfqT = parcelRequire("kvfqT");

var $6cLgn = parcelRequire("6cLgn");

var $70yzM = parcelRequire("70yzM");

var $a6SQV = parcelRequire("a6SQV");

var $8EmED = parcelRequire("8EmED");

var $36FIx = parcelRequire("36FIx");
const $4018b575546c10b1$var$styles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc"
};
const $4018b575546c10b1$var$HubInner = ({ appearance: appearance = 'full-page', parsedAdf: parsedAdf, mediaProvider: mediaProvider, providerFactory: providerFactory, extensionHandlers: extensionHandlers, helpCenterData: helpCenterData })=>{
    var _helpCenterData$pages;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lbS2q.MediaClientProvider), {
        clientConfig: mediaProvider.viewMediaClientConfig,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jbMcU.default), {
            document: parsedAdf,
            appearance: appearance,
            dataProviders: providerFactory,
            product: (0, $jkNhT.helpCenterTypeToProduct)((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.type) || ''),
            additionalExtensionHandlers: extensionHandlers,
            contentId: (helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$pages = helpCenterData.pages) === null || _helpCenterData$pages === void 0 || (_helpCenterData$pages = _helpCenterData$pages[0]) === null || _helpCenterData$pages === void 0 ? void 0 : _helpCenterData$pages.id) || '',
            PropsProvider: (0, $j1eUG.CommonHubExtensionsDependenciesProvider)
        })
    });
};
const $4018b575546c10b1$var$Hub = ({ queryReference: queryReference, appearance: appearance = 'full-page', showPageNameAsHubDocumentTitle: showPageNameAsHubDocumentTitle = false })=>{
    var _data$helpCenter, _helpCenterData$pages2, _helpCenterData$pages3, _helpCenterData$pages4, _helpCenterData$helpC, _branding$colors;
    const hubContext = (0, $8NbLB.useHubContext)();
    if (!hubContext) throw new Error('HubContext not found. HubBootstrap must be used as a parent component.');
    const { pageMediaConfig: pageMediaConfig, user: user, cloudId: cloudId, env: { helpCenterAri: helpCenterAri } } = hubContext;
    const { mediaCollectionName: mediaCollectionName, asapIssuer: asapIssuer, mediaToken: mediaToken, mediaUrl: mediaUrl } = pageMediaConfig;
    /* eslint-disable @atlassian/relay/unused-fields */ const data = (0, $h3cOB.usePreloadedQuery)((0, $2qBo6.default), queryReference);
    /* eslint-enable @atlassian/relay/unused-fields */ const helpCenterData = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) === 'QueryError') throw new Error(`QueryError in hub query: ${helpCenterData.message}`);
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) !== 'HelpCenter') throw new Error('HelpCenter not found in hub query');
    const helpCenterType = (helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.type) || '';
    const title = showPageNameAsHubDocumentTitle && (_helpCenterData$pages2 = helpCenterData.pages) !== null && _helpCenterData$pages2 !== void 0 && (_helpCenterData$pages2 = _helpCenterData$pages2[0]) !== null && _helpCenterData$pages2 !== void 0 && (_helpCenterData$pages2 = _helpCenterData$pages2.name) !== null && _helpCenterData$pages2 !== void 0 && _helpCenterData$pages2.default ? (_helpCenterData$pages3 = helpCenterData.pages) === null || _helpCenterData$pages3 === void 0 || (_helpCenterData$pages3 = _helpCenterData$pages3[0]) === null || _helpCenterData$pages3 === void 0 || (_helpCenterData$pages3 = _helpCenterData$pages3.name) === null || _helpCenterData$pages3 === void 0 ? void 0 : _helpCenterData$pages3.default : '';
    const mediaProvider = (0, $8NbLB.getMediaProvider)(mediaCollectionName, asapIssuer, mediaToken, mediaUrl);
    const emojiProvider = (0, $ciwA7.getEmojiProvider)({
        cloudId: queryReference.variables.cloudId,
        // NOTE: id is not yet available in the user object, but will be in the near future
        // as per https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/186871/overview#comment-659373408.
        // userId is optional for getEmojiProvider so just leaving this here for now.
        userId: user.id
    });
    const providerFactory = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>{
        return (0, $feOkE.default).create({
            mediaProvider: Promise.resolve(mediaProvider),
            emojiProvider: Promise.resolve(emojiProvider)
        });
    }, [
        mediaProvider,
        emojiProvider
    ]);
    const layoutAdf = ((_helpCenterData$pages4 = helpCenterData.pages) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4[0]) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.pageLayout) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.layoutAdf) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.content) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.edges) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.map((edge)=>{
        var _edge$node;
        return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.content;
    })) === null || _helpCenterData$pages4 === void 0 ? void 0 : _helpCenterData$pages4.join('')) || '{}';
    const parsedAdf = JSON.parse(layoutAdf);
    // Use product extension handlers hook to get additional handlers for the product
    const extensionHandlers = (0, $kvfqT.useProductExtensionHandlers)({
        contentId: queryReference.variables.hubAri,
        PropsProvider: (0, $j1eUG.CommonHubExtensionsDependenciesProvider),
        product: helpCenterType
    });
    const environment = (0, $1I66f.useRelayEnvironmentProvider)().getEnvironment({});
    const aiWidgetProviderQueryReference = (0, $8P7DW.useMemo)(()=>{
        if (helpCenterType !== 'CUSTOMER_SERVICE') return null;
        return (0, $h3cOB.loadQuery)(environment, (0, $56bQK.default), {
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        });
    }, [
        helpCenterType,
        environment,
        cloudId,
        helpCenterAri
    ]);
    const navigationBar = (helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$helpC = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC === void 0 ? void 0 : _helpCenterData$helpC.navigationBar) ?? null;
    const { branding: branding } = (0, $8NbLB.useHubContext)();
    const brandColor = branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary;
    const navStyleOptions = (0, $8P7DW.useMemo)(()=>({
            options: navigationBar ? (0, $fcpCb.mapApiToNavigationOptions)(navigationBar, brandColor) : null,
            setOptions: ()=>void 0
        }), [
        navigationBar,
        brandColor
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fTpWL.NavigationStyleContext).Provider, {
        value: navStyleOptions,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cgbM9.HubAppShell), {
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8EmED.HubsDocumentTitle), {
                title: title,
                shouldRenderDocumentTitle: showPageNameAsHubDocumentTitle,
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsx)($4018b575546c10b1$var$HubInner, {
                            appearance: appearance,
                            parsedAdf: parsedAdf,
                            mediaProvider: mediaProvider,
                            providerFactory: providerFactory,
                            extensionHandlers: extensionHandlers,
                            helpCenterData: helpCenterData
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
                            fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
                                name: "ai-corner-agent-renderer-loader"
                            }),
                            children: aiWidgetProviderQueryReference && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dCWA1.ErrorBoundary), {
                                fallback: null,
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Wwpo.AiWidgetProvider), {
                                    queryReference: aiWidgetProviderQueryReference,
                                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $a6SQV.AiCornerAgentRenderer), {})
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $4018b575546c10b1$export$44db4a416180c024 = (props)=>{
    const { appearance: appearance = 'full-page' } = props;
    const { queryReference: hubPageQueryReference } = (0, $70yzM.useRelayResource)((0, $6cLgn.hubPageResource));
    const { queryReference: hubBootstrapQueryReference } = (0, $70yzM.useRelayResource)((0, $6cLgn.hubBootstrapResource));
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    if (!hubPageQueryReference || !hubBootstrapQueryReference) return null;
    const cloudId = hubBootstrapQueryReference.variables.cloudId;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dI6dR.HubErrorBoundary), {
        packageName: "hub",
        id: "hub-page",
        fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lxDv6.GenericErrorPage), {}),
        shouldForceError: true,
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $bQ8UI.ContextWrapper), {
            sourceType: (0, $17wqU.SCREEN),
            sourceName: "hub",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
                    fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
                        name: "hub-loader",
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                            className: (0, $8n1kL.default)([
                                $4018b575546c10b1$var$styles.spinnerContainer
                            ]),
                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                                size: "large",
                                label: formatMessage((0, $36FIx.default).hubLoadingSpinnerLabel)
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $MLtq6.HubBootstrapWrapper), {
                        queryReference: hubBootstrapQueryReference,
                        cloudId: cloudId,
                        ...props,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)($4018b575546c10b1$var$Hub, {
                            appearance: appearance,
                            queryReference: hubPageQueryReference,
                            showPageNameAsHubDocumentTitle: props === null || props === void 0 ? void 0 : props.showPageNameAsHubDocumentTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8vv1J.FireScreenAnalytics), {})
            ]
        })
    });
};

});
parcelRegister("feOkE", function(module, exports) {
$parcel$export(module.exports, "default", () => $76f9f06d98d10541$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $76f9f06d98d10541$var$isUndefined(x) {
    return x === undefined;
}
class $76f9f06d98d10541$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $76f9f06d98d10541$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$76f9f06d98d10541$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("j1eUG", function(module, exports) {
$parcel$export(module.exports, "CommonHubExtensionsDependenciesProvider", () => $3a50875f95613379$export$93e984eb90009a17);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $5pSgx = parcelRequire("5pSgx");

var $fGIfc = parcelRequire("fGIfc");
var $jvZc4 = parcelRequire("jvZc4");
var $j21To = parcelRequire("j21To");
var $iZRQD = parcelRequire("iZRQD");
var $8NbLB = parcelRequire("8NbLB");
const $3a50875f95613379$export$93e984eb90009a17 = ({ children: children })=>{
    var _branding$colors;
    const { cloudId: cloudId, cloudUrl: cloudUrl, pageMediaConfig: pageMediaConfig, hubMediaConfig: hubMediaConfig, env: env, branding: branding, user: user } = (0, $8NbLB.useHubContext)();
    const { hoistedProjectKey: hoistedProjectKey } = env;
    const defaultParameters = (0, $fGIfc.getHubDefaultParameters)();
    const brandBackgroundColorMap = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>{
        const brandBackgroundColors = [
            defaultParameters.backgroundColor
        ];
        return (0, $5pSgx.createBuiltInColorMap)({
            knownColors: brandBackgroundColors
        });
    }, [
        defaultParameters
    ]);
    const authProvider = (0, $8P7DW.useCallback)(()=>Promise.resolve({
            asapIssuer: pageMediaConfig.asapIssuer,
            token: pageMediaConfig.mediaToken,
            baseUrl: pageMediaConfig.mediaUrl
        }), [
        pageMediaConfig
    ]);
    const createEditorMediaProvider = (0, $8P7DW.useCallback)(async ({ onUploadRejection: onUploadRejection })=>{
        const mediaProvider = {
            uploadParams: {
                collection: pageMediaConfig.mediaCollectionName,
                onUploadRejection: onUploadRejection
            },
            viewMediaClientConfig: {
                authProvider: authProvider
            },
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        };
        return mediaProvider;
    }, [
        authProvider,
        pageMediaConfig
    ]);
    const useMediaConfig = (0, $8P7DW.useCallback)(({ imageSrc: imageSrc })=>{
        return {
            authProvider: authProvider,
            collection: pageMediaConfig.mediaCollectionName,
            fileId: imageSrc
        };
    }, [
        authProvider,
        pageMediaConfig
    ]);
    const contextValue = {
        smartCardProviderComponent: undefined,
        isTargetAudience: ()=>false,
        useSegmentationTargetGroups: ()=>({}),
        isCompanyHub: true,
        // need to pass this true to enable company hub specific extensions
        enableLinkInputInMediaPicker: true,
        cloudId: cloudId,
        cloudUrl: cloudUrl,
        hoistedProjectKey: hoistedProjectKey,
        helpCenterAri: env.helpCenterAri,
        isAdminHubAIEnabled: false,
        linkPickerConfig: {
            linkPickerPlugins: []
        },
        userId: (0, $e6Qdr.fg)('fix_user_context_in_hubs') ? user.id : '',
        customMediaConfig: hubMediaConfig,
        createEditorMediaProvider: createEditorMediaProvider,
        useMediaConfig: useMediaConfig,
        branding: {
            ...branding,
            defaultParameters: defaultParameters,
            hideDefaultColorPalette: !!(branding !== null && branding !== void 0 && (_branding$colors = branding.colors) !== null && _branding$colors !== void 0 && _branding$colors.primary),
            brandBackgroundColorMap: brandBackgroundColorMap
        },
        hideExtensionBorders: true,
        showConfigPreambleSupportLink: false,
        enableTargeting: false,
        enableUnifiedSearchFeatures: (0, $e6Qdr.fg)('enable_dynamic_cards_for_gday'),
        enableSmartCardsFields: false,
        experienceStopComponent: (0, $jvZc4.HubErrorLogger),
        submitError: (0, $j21To.logException)
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iZRQD.ProductDependenciesContext).Provider, {
        value: contextValue,
        children: children
    });
};

});
parcelRegister("5pSgx", function(module, exports) {
$parcel$export(module.exports, "createBuiltInColorMap", () => $8c72ef671894ab58$export$a4af15b2fa34f34e);

var $lYqwN = parcelRequire("lYqwN");

var $ahsmp = parcelRequire("ahsmp");
const $8c72ef671894ab58$export$a4af15b2fa34f34e = ({ knownColors: knownColors, allColors: allColors, humanReadableColors: humanReadableColors, getResponsiveColor: getResponsiveColor })=>{
    knownColors = knownColors.map((color)=>color.toLowerCase());
    const knownTokens = knownColors.map((color)=>(0, $lYqwN.extractToken)(color));
    if (!allColors) allColors = knownColors;
    else allColors = allColors.map((color)=>color.toLowerCase());
    const allTokens = allColors.map((color)=>(0, $lYqwN.extractToken)(color));
    const humanReadableColorsMap = humanReadableColors ? new Map([
        ...(0, $ahsmp.allHumanReadableColors).entries(),
        ...humanReadableColors.entries()
    ]) : (0, $ahsmp.allHumanReadableColors);
    return {
        knownColors: knownColors,
        knownTokens: knownTokens,
        allColors: allColors,
        allTokens: allTokens,
        humanReadableColors: humanReadableColorsMap,
        getResponsiveColor: getResponsiveColor || ((color)=>color)
    };
};

});
parcelRegister("ahsmp", function(module, exports) {
$parcel$export(module.exports, "allHumanReadableColors", () => $5c3c73c0f7ca69f0$export$37744bda14f72c19);

var $3Cciq = parcelRequire("3Cciq");
const $5c3c73c0f7ca69f0$export$37744bda14f72c19 = new Map([
    // background colors
    [
        "var(--ds-surface-overlay, #FFFFFF)".toLowerCase(),
        (0, $3Cciq.colorNames).defaultWhite
    ],
    [
        "var(--ds-background-accent-blue-subtlest, #E9F2FE)".toLowerCase(),
        (0, $3Cciq.colorNames).lightBlue
    ],
    [
        "var(--ds-background-accent-purple-subtlest, #F8EEFE)".toLowerCase(),
        (0, $3Cciq.colorNames).lightPurple
    ],
    [
        "var(--ds-background-accent-magenta-subtlest, #FFECF8)".toLowerCase(),
        (0, $3Cciq.colorNames).lightMagenta
    ],
    [
        "var(--ds-background-accent-red-subtlest, #FFECEB)".toLowerCase(),
        (0, $3Cciq.colorNames).lightRed
    ],
    [
        "var(--ds-background-accent-orange-subtlest, #FFF5DB)".toLowerCase(),
        (0, $3Cciq.colorNames).lightOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtlest, #FEF7C8)".toLowerCase(),
        (0, $3Cciq.colorNames).lightYellow
    ],
    [
        "var(--ds-background-accent-lime-subtlest, #EFFFD6)".toLowerCase(),
        (0, $3Cciq.colorNames).lightLime
    ],
    [
        "var(--ds-background-accent-green-subtlest, #DCFFF1)".toLowerCase(),
        (0, $3Cciq.colorNames).lightGreen
    ],
    [
        "var(--ds-background-accent-teal-subtlest, #E7F9FF)".toLowerCase(),
        (0, $3Cciq.colorNames).lightTeal
    ],
    [
        "var(--ds-background-accent-gray-subtler, #DDDEE1)".toLowerCase(),
        (0, $3Cciq.colorNames).subtleGray
    ],
    [
        "var(--ds-background-accent-blue-subtler, #CFE1FD)".toLowerCase(),
        (0, $3Cciq.colorNames).subtleBlue
    ],
    [
        "var(--ds-background-accent-purple-subtler, #EED7FC)".toLowerCase(),
        (0, $3Cciq.colorNames).subtlePurple
    ],
    [
        "var(--ds-background-accent-magenta-subtler, #FDD0EC)".toLowerCase(),
        (0, $3Cciq.colorNames).subtleMagenta
    ],
    [
        "var(--ds-background-accent-red-subtler, #FFD5D2)".toLowerCase(),
        (0, $3Cciq.colorNames).subtleRed
    ],
    [
        "var(--ds-background-accent-orange-subtler, #FCE4A6)".toLowerCase(),
        (0, $3Cciq.colorNames).subtleOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtler, #F5E989)".toLowerCase(),
        (0, $3Cciq.colorNames).subtleYellow
    ],
    [
        "var(--ds-background-accent-lime-subtler, #D3F1A7)".toLowerCase(),
        (0, $3Cciq.colorNames).subtleLime
    ],
    [
        "var(--ds-background-accent-green-subtler, #BAF3DB)".toLowerCase(),
        (0, $3Cciq.colorNames).subtleGreen
    ],
    [
        "var(--ds-background-accent-teal-subtler, #C6EDFB)".toLowerCase(),
        (0, $3Cciq.colorNames).subtleTeal
    ],
    [
        "var(--ds-background-accent-gray-subtle, #8C8F97)".toLowerCase(),
        (0, $3Cciq.colorNames).gray
    ],
    [
        "var(--ds-background-accent-blue-subtle, #669DF1)".toLowerCase(),
        (0, $3Cciq.colorNames).blue
    ],
    [
        "var(--ds-background-accent-purple-subtle, #C97CF4)".toLowerCase(),
        (0, $3Cciq.colorNames).purple
    ],
    [
        "var(--ds-background-accent-magenta-subtle, #E774BB)".toLowerCase(),
        (0, $3Cciq.colorNames).magenta
    ],
    [
        "var(--ds-background-accent-red-subtle, #F87168)".toLowerCase(),
        (0, $3Cciq.colorNames).red
    ],
    [
        "var(--ds-background-accent-orange-subtle, #FCA700)".toLowerCase(),
        (0, $3Cciq.colorNames).orange
    ],
    [
        "var(--ds-background-accent-yellow-subtle, #EED12B)".toLowerCase(),
        (0, $3Cciq.colorNames).yellow
    ],
    [
        "var(--ds-background-accent-lime-subtle, #94C748)".toLowerCase(),
        (0, $3Cciq.colorNames).lime
    ],
    [
        "var(--ds-background-accent-green-subtle, #4BCE97)".toLowerCase(),
        (0, $3Cciq.colorNames).green
    ],
    [
        "var(--ds-background-accent-teal-subtle, #6CC3E0)".toLowerCase(),
        (0, $3Cciq.colorNames).teal
    ],
    [
        "var(--ds-text-brand, #1868DB)".toLowerCase(),
        (0, $3Cciq.colorNames).defaultBlue
    ],
    [
        "var(--ds-background-accent-gray-bolder, #6B6E76)".toLowerCase(),
        (0, $3Cciq.colorNames).boldGray
    ],
    [
        "var(--ds-background-accent-blue-bolder, #1868DB)".toLowerCase(),
        (0, $3Cciq.colorNames).boldBlue
    ],
    [
        "var(--ds-background-accent-purple-bolder, #964AC0)".toLowerCase(),
        (0, $3Cciq.colorNames).boldPurple
    ],
    [
        "var(--ds-background-accent-magenta-bolder, #AE4787)".toLowerCase(),
        (0, $3Cciq.colorNames).boldMagenta
    ],
    [
        "var(--ds-background-accent-red-bolder, #C9372C)".toLowerCase(),
        (0, $3Cciq.colorNames).boldRed
    ],
    [
        "var(--ds-background-accent-orange-bolder, #BD5B00)".toLowerCase(),
        (0, $3Cciq.colorNames).boldOrange
    ],
    [
        "var(--ds-background-accent-yellow-bolder, #946F00)".toLowerCase(),
        (0, $3Cciq.colorNames).boldYellow
    ],
    [
        "var(--ds-background-accent-lime-bolder, #5B7F24)".toLowerCase(),
        (0, $3Cciq.colorNames).boldLime
    ],
    [
        "var(--ds-background-accent-green-bolder, #1F845A)".toLowerCase(),
        (0, $3Cciq.colorNames).boldGreen
    ],
    [
        "var(--ds-background-accent-teal-bolder, #227D9B)".toLowerCase(),
        (0, $3Cciq.colorNames).boldTeal
    ],
    // text colors
    [
        "var(--ds-text, #292A2E)".toLowerCase(),
        (0, $3Cciq.colorNames).boldGray
    ],
    [
        "var(--ds-text-accent-blue-bolder, #123263)".toLowerCase(),
        (0, $3Cciq.colorNames).boldBlue
    ],
    [
        "var(--ds-text-accent-purple-bolder, #48245D)".toLowerCase(),
        (0, $3Cciq.colorNames).boldPurple
    ],
    [
        "var(--ds-text-accent-magenta-bolder, #50253F)".toLowerCase(),
        (0, $3Cciq.colorNames).boldMagenta
    ],
    [
        "var(--ds-text-accent-red-bolder, #5D1F1A)".toLowerCase(),
        (0, $3Cciq.colorNames).boldRed
    ],
    [
        "var(--ds-text-accent-orange-bolder, #693200)".toLowerCase(),
        (0, $3Cciq.colorNames).boldOrange
    ],
    [
        "var(--ds-text-accent-yellow-bolder, #533F04)".toLowerCase(),
        (0, $3Cciq.colorNames).boldYellow
    ],
    [
        "var(--ds-text-accent-lime-bolder, #37471F)".toLowerCase(),
        (0, $3Cciq.colorNames).boldLime
    ],
    [
        "var(--ds-text-accent-green-bolder, #164B35)".toLowerCase(),
        (0, $3Cciq.colorNames).boldGreen
    ],
    [
        "var(--ds-text-accent-teal-bolder, #164555)".toLowerCase(),
        (0, $3Cciq.colorNames).boldTeal
    ],
    [
        "var(--ds-text-subtle, #505258)".toLowerCase(),
        (0, $3Cciq.colorNames).gray
    ],
    [
        "var(--ds-text-accent-blue, #1558BC)".toLowerCase(),
        (0, $3Cciq.colorNames).blue
    ],
    [
        "var(--ds-text-accent-purple, #803FA5)".toLowerCase(),
        (0, $3Cciq.colorNames).purple
    ],
    [
        "var(--ds-text-accent-magenta, #943D73)".toLowerCase(),
        (0, $3Cciq.colorNames).magenta
    ],
    [
        "var(--ds-text-accent-red, #AE2E24)".toLowerCase(),
        (0, $3Cciq.colorNames).red
    ],
    [
        "var(--ds-text-accent-orange, #9E4C00)".toLowerCase(),
        (0, $3Cciq.colorNames).orange
    ],
    [
        "var(--ds-text-accent-yellow, #7F5F01)".toLowerCase(),
        (0, $3Cciq.colorNames).yellow
    ],
    [
        "var(--ds-text-accent-lime, #4C6B1F)".toLowerCase(),
        (0, $3Cciq.colorNames).lime
    ],
    [
        "var(--ds-text-accent-green, #216E4E)".toLowerCase(),
        (0, $3Cciq.colorNames).green
    ],
    [
        "var(--ds-text-accent-teal, #206A83)".toLowerCase(),
        (0, $3Cciq.colorNames).teal
    ],
    [
        "var(--ds-text-inverse, #FFFFFF)".toLowerCase(),
        (0, $3Cciq.colorNames).white
    ],
    // border colors
    [
        "var(--ds-border-accent-blue, #357DE8)".toLowerCase(),
        (0, $3Cciq.colorNames).blue
    ],
    [
        "var(--ds-border-accent-purple, #AF59E1)".toLowerCase(),
        (0, $3Cciq.colorNames).purple
    ],
    [
        "var(--ds-border-accent-magenta, #CD519D)".toLowerCase(),
        (0, $3Cciq.colorNames).magenta
    ],
    [
        "var(--ds-border-accent-red, #E2483D)".toLowerCase(),
        (0, $3Cciq.colorNames).red
    ],
    [
        "var(--ds-border-accent-orange, #E06C00)".toLowerCase(),
        (0, $3Cciq.colorNames).orange
    ],
    [
        "var(--ds-border-accent-yellow, #B38600)".toLowerCase(),
        (0, $3Cciq.colorNames).yellow
    ],
    [
        "var(--ds-border-accent-lime, #6A9A23)".toLowerCase(),
        (0, $3Cciq.colorNames).lime
    ],
    [
        "var(--ds-border-accent-green, #22A06B)".toLowerCase(),
        (0, $3Cciq.colorNames).green
    ],
    [
        "var(--ds-border-accent-teal, #2898BD)".toLowerCase(),
        (0, $3Cciq.colorNames).teal
    ],
    [
        "var(--ds-border-inverse, #FFFFFF)".toLowerCase(),
        (0, $3Cciq.colorNames).white
    ],
    [
        "var(--ds-border-accent-gray, #7D818A)".toLowerCase(),
        (0, $3Cciq.colorNames).gray
    ]
]);

});
parcelRegister("3Cciq", function(module, exports) {
$parcel$export(module.exports, "colorNames", () => $8f315be1220f26d0$export$88bbe6beac980300);

var $6K2Gm = parcelRequire("6K2Gm");
const $8f315be1220f26d0$export$88bbe6beac980300 = (0, $6K2Gm.defineMessages)({
    defaultWhite: {
        id: 'company-hub.color-picker.default-white',
        description: 'Name of default white color',
        defaultMessage: 'Default white'
    },
    white: {
        id: 'company-hub.color-picker.white',
        description: 'Name of white color',
        defaultMessage: 'White'
    },
    lightGray: {
        id: 'company-hub.color-picker.light-gray',
        description: 'Name of light gray color',
        defaultMessage: 'Light gray'
    },
    lightBlue: {
        id: 'company-hub.color-picker.light-blue',
        description: 'Name of light blue color',
        defaultMessage: 'Light blue'
    },
    lightPurple: {
        id: 'company-hub.color-picker.light-purple',
        description: 'Name of light purple color',
        defaultMessage: 'Light purple'
    },
    lightMagenta: {
        id: 'company-hub.color-picker.light-magenta',
        description: 'Name of light magenta color',
        defaultMessage: 'Light magenta'
    },
    lightRed: {
        id: 'company-hub.color-picker.light-red',
        description: 'Name of light red color',
        defaultMessage: 'Light red'
    },
    lightOrange: {
        id: 'company-hub.color-picker.light-orange',
        description: 'Name of light orange color',
        defaultMessage: 'Light orange'
    },
    lightYellow: {
        id: 'company-hub.color-picker.light-yellow',
        description: 'Name of light yellow color',
        defaultMessage: 'Light yellow'
    },
    lightLime: {
        id: 'company-hub.color-picker.light-lime',
        description: 'Name of light lime color',
        defaultMessage: 'Light lime'
    },
    lightGreen: {
        id: 'company-hub.color-picker.light-green',
        description: 'Name of light green color',
        defaultMessage: 'Light green'
    },
    lightTeal: {
        id: 'company-hub.color-picker.light-teal',
        description: 'Name of light teal color',
        defaultMessage: 'Light teal'
    },
    subtleGray: {
        id: 'company-hub.color-picker.subtle-gray',
        description: 'Name of subtle gray color',
        defaultMessage: 'Subtle gray'
    },
    subtleBlue: {
        id: 'company-hub.color-picker.subtle-blue',
        description: 'Name of subtle blue color',
        defaultMessage: 'Subtle blue'
    },
    subtlePurple: {
        id: 'company-hub.color-picker.subtle-purple',
        description: 'Name of subtle purple color',
        defaultMessage: 'Subtle purple'
    },
    subtleMagenta: {
        id: 'company-hub.color-picker.subtle-magenta',
        description: 'Name of subtle magenta color',
        defaultMessage: 'Subtle magenta'
    },
    subtleRed: {
        id: 'company-hub.color-picker.subtle-red',
        description: 'Name of subtle red color',
        defaultMessage: 'Subtle red'
    },
    subtleOrange: {
        id: 'company-hub.color-picker.subtle-orange',
        description: 'Name of subtle orange color',
        defaultMessage: 'Subtle orange'
    },
    subtleYellow: {
        id: 'company-hub.color-picker.subtle-yellow',
        description: 'Name of subtle yellow color',
        defaultMessage: 'Subtle yellow'
    },
    subtleLime: {
        id: 'company-hub.color-picker.subtle-lime',
        description: 'Name of subtle lime color',
        defaultMessage: 'Subtle lime'
    },
    subtleGreen: {
        id: 'company-hub.color-picker.subtle-green',
        description: 'Name of subtle green color',
        defaultMessage: 'Subtle green'
    },
    subtleTeal: {
        id: 'company-hub.color-picker.subtle-teal',
        description: 'Name of subtle teal color',
        defaultMessage: 'Subtle teal'
    },
    gray: {
        id: 'company-hub.color-picker.gray',
        description: 'Name of gray color',
        defaultMessage: 'Gray'
    },
    blue: {
        id: 'company-hub.color-picker.blue',
        description: 'Name of blue color',
        defaultMessage: 'Blue'
    },
    purple: {
        id: 'company-hub.color-picker.purple',
        description: 'Name of purple color',
        defaultMessage: 'Purple'
    },
    magenta: {
        id: 'company-hub.color-picker.magenta',
        description: 'Name of magenta color',
        defaultMessage: 'Magenta'
    },
    red: {
        id: 'company-hub.color-picker.red',
        description: 'Name of red color',
        defaultMessage: 'Red'
    },
    orange: {
        id: 'company-hub.color-picker.orange',
        description: 'Name of orange color',
        defaultMessage: 'Orange'
    },
    yellow: {
        id: 'company-hub.color-picker.yellow',
        description: 'Name of yellow color',
        defaultMessage: 'Yellow'
    },
    lime: {
        id: 'company-hub.color-picker.lime',
        description: 'Name of lime color',
        defaultMessage: 'Lime'
    },
    green: {
        id: 'company-hub.color-picker.green',
        description: 'Name of green color',
        defaultMessage: 'Green'
    },
    teal: {
        id: 'company-hub.color-picker.teal',
        description: 'Name of teal color',
        defaultMessage: 'Teal'
    },
    boldGray: {
        id: 'company-hub.color-picker.bold-gray',
        description: 'Name of bold gray color',
        defaultMessage: 'Bold gray'
    },
    boldBlue: {
        id: 'company-hub.color-picker.bold-blue',
        description: 'Name of bold blue color',
        defaultMessage: 'Bold blue'
    },
    boldPurple: {
        id: 'company-hub.color-picker.bold-purple',
        description: 'Name of bold purple color',
        defaultMessage: 'Bold purple'
    },
    boldMagenta: {
        id: 'company-hub.color-picker.bold-magenta',
        description: 'Name of bold magenta color',
        defaultMessage: 'Bold magenta'
    },
    boldRed: {
        id: 'company-hub.color-picker.bold-red',
        description: 'Name of bold red color',
        defaultMessage: 'Bold red'
    },
    boldOrange: {
        id: 'company-hub.color-picker.bold-orange',
        description: 'Name of bold orange color',
        defaultMessage: 'Bold orange'
    },
    boldYellow: {
        id: 'company-hub.color-picker.bold-yellow',
        description: 'Name of bold yellow color',
        defaultMessage: 'Bold yellow'
    },
    boldLime: {
        id: 'company-hub.color-picker.bold-lime',
        description: 'Name of bold lime color',
        defaultMessage: 'Bold lime'
    },
    boldGreen: {
        id: 'company-hub.color-picker.bold-green',
        description: 'Name of bold green color',
        defaultMessage: 'Bold green'
    },
    boldTeal: {
        id: 'company-hub.color-picker.bold-teal',
        description: 'Name of bold teal color',
        defaultMessage: 'Bold teal'
    },
    defaultBlue: {
        id: 'company-hub.color-picker.default-blue',
        description: 'Name of default blue color',
        defaultMessage: 'Default blue'
    }
});

});



parcelRegister("fGIfc", function(module, exports) {
$parcel$export(module.exports, "getHubDefaultParameters", () => $439992c74e3db0d4$export$25a6d2da841ddb1d);

var $2fABU = parcelRequire("2fABU");
const $439992c74e3db0d4$export$25a6d2da841ddb1d = ()=>{
    return {
        backgroundColor: `var(${0, $2fABU.HUB_PRIMARY_COLOR_CSS_VAR}, ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"})`,
        textColor: `var(${0, $2fABU.HUB_PRIMARY_TEXT_COLOR_CSS_VAR}, ${"var(--ds-text, #292A2E)"})`
    };
};

});

parcelRegister("jvZc4", function(module, exports) {
$parcel$export(module.exports, "HubErrorLogger", () => $40f0c4d2b7eb8de7$export$9ef862d41b8c7d0f);

var $8P7DW = parcelRequire("8P7DW");

var $9It0a = parcelRequire("9It0a");
const $40f0c4d2b7eb8de7$export$9ef862d41b8c7d0f = ({ error: error, shouldForceError: shouldForceError })=>{
    const logError = (0, $9It0a.useUFOReportError)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        logError({
            name: (error === null || error === void 0 ? void 0 : error.name) || 'unknown',
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) || '',
            errorStack: (error === null || error === void 0 ? void 0 : error.stack) || '',
            forcedError: shouldForceError
        });
    }, [
        logError,
        error,
        shouldForceError
    ]);
    return null;
};

});

parcelRegister("j21To", function(module, exports) {
$parcel$export(module.exports, "logException", () => $b9bac0eefaf0c9ab$export$f86b2a1a2ce291b3);

var $2fABU = parcelRequire("2fABU");
let $b9bac0eefaf0c9ab$var$Sentry;
const $b9bac0eefaf0c9ab$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
const $b9bac0eefaf0c9ab$export$668f31ea3127f48f = window.BUILD_KEY;

const $b9bac0eefaf0c9ab$export$f553e8b08ef59d31 = async ()=>{
    if (!$b9bac0eefaf0c9ab$var$Sentry) $b9bac0eefaf0c9ab$var$Sentry = Promise.resolve((parcelRequire("fHwTC"))).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $2fABU.SENTRY_DSN),
            attachStacktrace: true,
            release: $b9bac0eefaf0c9ab$export$668f31ea3127f48f || (0, $2fABU.UNKNOWN_TAG),
            environment: $b9bac0eefaf0c9ab$export$57570b1603cf6adb()
        });
        return SentryModule;
    }).catch(()=>{});
    return $b9bac0eefaf0c9ab$var$Sentry;
};
const $b9bac0eefaf0c9ab$export$f86b2a1a2ce291b3 = async (error)=>{
    try {
        const SentryClient = await $b9bac0eefaf0c9ab$export$f553e8b08ef59d31();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            scope.setTag('product', 'hub');
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};

});
parcelRegister("fHwTC", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $b6e463a4ce8ca3aa$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("jA0wi")));

var $26Yns = parcelRequire("26Yns");

var $kvaCm = parcelRequire("kvaCm");

var $5ruwa = parcelRequire("5ruwa");
parcelRequire("khHJA");
var $eCKEK = parcelRequire("eCKEK");

var $lqZge = parcelRequire("lqZge");

var $jA0wi = parcelRequire("jA0wi");
var $b6e463a4ce8ca3aa$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $b6e463a4ce8ca3aa$var$_window = (0, $eCKEK.getGlobalObject)();
if ($b6e463a4ce8ca3aa$var$_window.Sentry && $b6e463a4ce8ca3aa$var$_window.Sentry.Integrations) $b6e463a4ce8ca3aa$var$windowIntegrations = $b6e463a4ce8ca3aa$var$_window.Sentry.Integrations;
var $b6e463a4ce8ca3aa$export$99d02219d259eb94 = (0, $26Yns.__assign)((0, $26Yns.__assign)((0, $26Yns.__assign)({}, $b6e463a4ce8ca3aa$var$windowIntegrations), (0, $5ruwa)), $lqZge);
$parcel$exportWildcard(module.exports, $kvaCm);

});
parcelRegister("kvaCm", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("7dUhV")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("9I9eJ")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9dPOl")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9dPOl")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9dPOl")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9dPOl")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9dPOl")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("jOQ1l")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("jOQ1l")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("jOQ1l")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("jOQ1l")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("9I9eJ")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("iOmYe")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9dPOl")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("9qb1h")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9dPOl")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9dPOl")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9dPOl")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9dPOl")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9dPOl")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9dPOl")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9dPOl")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("31xdy")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1gtR4")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("kgbg7")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("kgbg7")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("3Gufo")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("3Gufo")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("3Gufo")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("3Gufo")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("3Gufo")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("3Gufo")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("3Gufo")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("3Gufo")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("3Gufo")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("4rtUp")).SDK_NAME);

var $7dUhV = parcelRequire("7dUhV");

var $9dPOl = parcelRequire("9dPOl");
var $9I9eJ = parcelRequire("9I9eJ");
var $jOQ1l = parcelRequire("jOQ1l");
var $9qb1h = parcelRequire("9qb1h");
var $iOmYe = parcelRequire("iOmYe");

var $31xdy = parcelRequire("31xdy");

var $1gtR4 = parcelRequire("1gtR4");

var $kgbg7 = parcelRequire("kgbg7");

var $3Gufo = parcelRequire("3Gufo");

var $4rtUp = parcelRequire("4rtUp");

});
parcelRegister("4rtUp", function(module, exports) {
$parcel$export(module.exports, "SDK_NAME", () => $33c0e24f0d3514fd$export$ca61d37259221480);
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $33c0e24f0d3514fd$export$ca61d37259221480 = 'sentry.javascript.browser';

});


parcelRegister("lqZge", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("5pCOQ")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("aiiSG")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("hKlbM")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("9WQK8")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("91Czo")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("9Ez91")).Dedupe);

var $5pCOQ = parcelRequire("5pCOQ");

var $aiiSG = parcelRequire("aiiSG");

var $hKlbM = parcelRequire("hKlbM");

var $9WQK8 = parcelRequire("9WQK8");

var $91Czo = parcelRequire("91Czo");

var $9Ez91 = parcelRequire("9Ez91");

});

parcelRegister("jA0wi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("2PkH3")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("6KqSt")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("9bneS")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("kNFcE")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("e2ZoK")).makeNewXHRTransport);

var $2PkH3 = parcelRequire("2PkH3");

var $6KqSt = parcelRequire("6KqSt");

var $9bneS = parcelRequire("9bneS");

var $kNFcE = parcelRequire("kNFcE");

var $e2ZoK = parcelRequire("e2ZoK");

});



parcelRegister("iZRQD", function(module, exports) {
$parcel$export(module.exports, "ProductDependenciesContext", () => $493435b189bfdbab$export$49e1053dfc41d188);
$parcel$export(module.exports, "useProductDependencies", () => $493435b189bfdbab$export$8dcbb40932065737);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $493435b189bfdbab$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $8P7DW.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $493435b189bfdbab$export$774887fcc3922763 = ({ children: children, ...props })=>{
    const defaultValue = (0, $8P7DW.useContext)($493435b189bfdbab$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)($493435b189bfdbab$export$49e1053dfc41d188.Provider, {
        value: value,
        children: children
    });
};
function $493435b189bfdbab$export$8dcbb40932065737() {
    const ctx = (0, $8P7DW.useContext)($493435b189bfdbab$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
}

});


parcelRegister("jkNhT", function(module, exports) {
$parcel$export(module.exports, "helpCenterTypeToProduct", () => $bf0c3b58e300d798$export$cf749f9c25e568e8);
const $bf0c3b58e300d798$export$cf749f9c25e568e8 = (helpCenterType)=>{
    switch(helpCenterType){
        case 'CUSTOMER_SERVICE':
            return 'CSM';
        case 'HELP_HUB':
            return 'JSM';
        default:
            return 'CSM';
    }
};

});

parcelRegister("6Wwpo", function(module, exports) {
$parcel$export(module.exports, "AiWidgetProvider", () => $1e98624041b3e348$export$963f3fe63ca0f1aa);

var $gWgPx = parcelRequire("gWgPx");

var $56bQK = parcelRequire("56bQK");

var $8P7DW = parcelRequire("8P7DW");

var $h3cOB = parcelRequire("h3cOB");

var $dI6dR = parcelRequire("dI6dR");
var $8NbLB = parcelRequire("8NbLB");

var $3C9wC = parcelRequire("3C9wC");

var $jquW8 = parcelRequire("jquW8");
/**
 * Provides AI widget config via context when available.
 * On query failure or invalid data, it falls back to rendering children only.
 */ const $1e98624041b3e348$var$AiWidgetProviderInner = ({ queryReference: queryReference, children: children })=>{
    var _data$helpCenter;
    const { cloudId: siteId } = (0, $8NbLB.useHubContext)();
    const data = (0, $h3cOB.usePreloadedQuery)((0, $56bQK.default), queryReference);
    const primaryColor = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterBranding) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.colors) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.primary;
    const widgetConfig = data.csmAi_getSupportWidget;
    const supportWidgetConfig = (0, $8P7DW.useMemo)(()=>{
        if (!widgetConfig || !widgetConfig.id || !widgetConfig.theme || !primaryColor || !siteId) return null;
        return {
            siteId: siteId,
            widgetId: widgetConfig.id,
            widgetTheme: {
                primaryColor: primaryColor,
                radius: (0, $3C9wC.handleWidgetRadiusType)(widgetConfig.theme.radius),
                space: (0, $3C9wC.handleWidgetSpaceType)(widgetConfig.theme.space),
                chatBubbleVariant: (0, $3C9wC.handleChatBubbleVariant)(widgetConfig.theme.chatColor),
                widgetButtonVariant: (0, $3C9wC.handleWidgetButtonVariant)(widgetConfig.theme.colorVibeVariant),
                attribution: null
            },
            widgetPosition: (0, $3C9wC.handleWidgetPosition)(widgetConfig.position),
            isEnabled: Boolean(widgetConfig.isEnabled)
        };
    }, [
        widgetConfig,
        primaryColor,
        siteId
    ]);
    if (!supportWidgetConfig) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jquW8.AiWidgetConfigProvider), {
        supportWidgetConfig: supportWidgetConfig,
        children: children
    });
};
const $1e98624041b3e348$export$963f3fe63ca0f1aa = ({ queryReference: queryReference, children: children })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dI6dR.HubErrorBoundary), {
        packageName: "@atlassian/csm-ai-search-trigger",
        id: "AiWidgetProvider",
        fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Fragment), {
            children: children
        }),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($1e98624041b3e348$var$AiWidgetProviderInner, {
            queryReference: queryReference,
            children: children
        })
    });
};

});
parcelRegister("56bQK", function(module, exports) {
$parcel$export(module.exports, "default", () => $28003c9f7abea2be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1b73858a1b63b0af41ee92a6f069e9e8>>
 * @relayHash d24b4ad1a97ccd24bce6bb96d6c01dac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c
const $28003c9f7abea2be$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "position"
            },
            {
                "concreteType": "CsmAiWidgetBrandingTheme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorVibeVariant"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "radius"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "space"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "chatColor"
                    }
                ]
            }
        ],
        "type": "CsmAiWidgetConfig"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiWidgetProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiWidgetProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c",
            "metadata": {},
            "name": "aiWidgetProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$28003c9f7abea2be$var$node.hash = "cc0a8c3c2e0c2ac2a4e32f0440175bfe";
var $28003c9f7abea2be$export$2e2bcd8739ae039 = $28003c9f7abea2be$var$node;

});

parcelRegister("3C9wC", function(module, exports) {
$parcel$export(module.exports, "handleWidgetRadiusType", () => $18f4eda1d422aae6$export$21feeed55533391b);
$parcel$export(module.exports, "handleWidgetSpaceType", () => $18f4eda1d422aae6$export$882cd7667f1dc36b);
$parcel$export(module.exports, "handleWidgetPosition", () => $18f4eda1d422aae6$export$565c45f827c88f12);
$parcel$export(module.exports, "handleChatBubbleVariant", () => $18f4eda1d422aae6$export$8d7135a196764ba5);
$parcel$export(module.exports, "handleWidgetButtonVariant", () => $18f4eda1d422aae6$export$1e1d4315fa0edb5);
const $18f4eda1d422aae6$export$21feeed55533391b = (radius)=>{
    switch(radius){
        case 'ROUNDED':
            return 'rounded';
        case 'SHARP':
            return 'sharp';
        case 'NORMAL':
        default:
            return 'normal';
    }
};
const $18f4eda1d422aae6$export$882cd7667f1dc36b = (space)=>{
    switch(space){
        case 'COSY':
            return 'cosy';
        case 'GENEROUS':
            return 'generous';
        case 'COMFORTABLE':
        default:
            return 'comfortable';
    }
};
const $18f4eda1d422aae6$export$565c45f827c88f12 = (position)=>{
    switch(position){
        case 'CENTER':
            return 'CENTER';
        case 'CORNER':
        default:
            return 'CORNER';
    }
};
const $18f4eda1d422aae6$export$8d7135a196764ba5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'default';
    }
};
const $18f4eda1d422aae6$export$1e1d4315fa0edb5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'dark';
    }
};

});

parcelRegister("jquW8", function(module, exports) {
$parcel$export(module.exports, "AiWidgetConfigProvider", () => $e714e806c88e7348$export$6e44feab0c163a95);
$parcel$export(module.exports, "useOptionalAiWidgetConfig", () => $e714e806c88e7348$export$ab391f3a63cacd0);
$parcel$export(module.exports, "useAiWidgetConfig", () => $e714e806c88e7348$export$91842e2b4fccaca6);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $e714e806c88e7348$var$AiWidgetConfigContext = /*#__PURE__*/ (0, $8P7DW.createContext)(null);
const $e714e806c88e7348$export$6e44feab0c163a95 = ({ supportWidgetConfig: supportWidgetConfig, children: children })=>{
    const [value] = (0, $8P7DW.useState)({
        supportWidgetConfig: supportWidgetConfig
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)($e714e806c88e7348$var$AiWidgetConfigContext.Provider, {
        value: value,
        children: children
    });
};
const $e714e806c88e7348$export$ab391f3a63cacd0 = ()=>{
    return (0, $8P7DW.useContext)($e714e806c88e7348$var$AiWidgetConfigContext);
};
const $e714e806c88e7348$export$91842e2b4fccaca6 = ()=>{
    const contextValue = (0, $8P7DW.useContext)($e714e806c88e7348$var$AiWidgetConfigContext);
    if (!contextValue) throw new Error('useSuppportWidgetConfig must be used within a AiWidgetConfigProvider');
    return contextValue;
};

});


parcelRegister("ciwA7", function(module, exports) {
$parcel$export(module.exports, "getEmojiProvider", () => $4ca9de8372e86c44$export$8210f5f78c0bcf27);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $5yW8f = parcelRequire("5yW8f");

var $flLAo = parcelRequire("flLAo");
const $4ca9de8372e86c44$var$BASE_URL = '/gateway/api/emoji';
const $4ca9de8372e86c44$var$getEmojiConfig = (cloudId, userId, disableUpload, emojiSSRConfig, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const providers = [
        {
            url: `${$4ca9de8372e86c44$var$BASE_URL}/standard`
        },
        {
            url: `${$4ca9de8372e86c44$var$BASE_URL}/atlassian`
        }
    ];
    if (cloudId) providers.push({
        url: `${$4ca9de8372e86c44$var$BASE_URL}/${cloudId}/site`
    });
    const config = {
        providers: providers,
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $4ca9de8372e86c44$var$resolverOfMemoize = (extraConfig)=>{
    const cloudId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) ?? '';
    const userId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) ?? '';
    const disableUpload = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload) ?? false;
    const emojiSSRConfigString = extraConfig !== null && extraConfig !== void 0 && extraConfig.emojiSSRConfig ? JSON.stringify(extraConfig.emojiSSRConfig) : '';
    return `${cloudId}_${userId}_${disableUpload}_${emojiSSRConfigString}`;
};
const $4ca9de8372e86c44$var$getEmojiResource = (0, (/*@__PURE__*/$parcel$interopDefault($5yW8f)))((extraConfig)=>{
    const cloudId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) ?? '';
    const userId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) ?? undefined;
    const disableUpload = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload;
    const emojiSSRConfig = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.emojiSSRConfig) ?? undefined;
    const emojiConfig = $4ca9de8372e86c44$var$getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig);
    return new (0, $flLAo.default)(emojiConfig);
}, $4ca9de8372e86c44$var$resolverOfMemoize);
const $4ca9de8372e86c44$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5yW8f)))((extraConfig)=>{
    const emojiResource = $4ca9de8372e86c44$var$getEmojiResource(extraConfig);
    return emojiResource.getEmojiProvider();
}, $4ca9de8372e86c44$var$resolverOfMemoize);

});
parcelRegister("flLAo", function(module, exports) {
$parcel$export(module.exports, "supportsUploadFeature", () => $0fb59406c6259c9f$export$7b697b720032fd6f);
$parcel$export(module.exports, "default", () => $0fb59406c6259c9f$export$2e2bcd8739ae039);
parcelRequire("6SRxJ");
var $hBN81 = parcelRequire("hBN81");
var $6SRxJ = parcelRequire("6SRxJ");

var $3mXlj = parcelRequire("3mXlj");

var $il7mU = parcelRequire("il7mU");

var $8W24X = parcelRequire("8W24X");

var $1pFyE = parcelRequire("1pFyE");

var $l50JM = parcelRequire("l50JM");

var $7N0U9 = parcelRequire("7N0U9");

var $bUBD1 = parcelRequire("bUBD1");

var $3Ctug = parcelRequire("3Ctug");

var $dhnr5 = parcelRequire("dhnr5");

var $fA7Cq = parcelRequire("fA7Cq");
const $0fb59406c6259c9f$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $0fb59406c6259c9f$export$b5efafc6dd611ec5 extends (0, $hBN81.AbstractResource) {
    constructor(config){
        super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        }, this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        this.emojiProviderConfig = config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $1pFyE.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
   * Get the emoji provider from Emoji Resource
   * @returns Promise<EmojiProvider>
   */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $il7mU.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $dhnr5.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $3mXlj.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $dhnr5.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $7N0U9.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $dhnr5.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $dhnr5.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $il7mU.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $7N0U9.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $l50JM.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $l50JM.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $l50JM.ProviderTypes).ATLASSIAN;
        return (0, $l50JM.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $bUBD1.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $3Ctug.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $8W24X.isPromise)(done)) return done.then(()=>{
                    (0, $il7mU.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $il7mU.default)('Failed to prime siteEmojiResource');
                });
                else (0, $il7mU.default)('Already primed siteEmojiResource');
            } else (0, $il7mU.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $8W24X.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $3mXlj.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
   *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
   */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $8W24X.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $8W24X.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $8W24X.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $dhnr5.ufoExperiences)['emoji-searched'].start();
        (0, $dhnr5.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: (query === null || query === void 0 ? void 0 : query.length) || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $dhnr5.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: (options === null || options === void 0 ? void 0 : options.source) || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
   * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
   * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
   * for the purposes of tracking the frequency of use.
   *
   * @param emoji The full description of the emoji to record usage for.
   */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $8W24X.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $6SRxJ.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $1pFyE.default)('localStorage')) try {
            window.localStorage.setItem((0, $3mXlj.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $0fb59406c6259c9f$export$2e2bcd8739ae039 extends $0fb59406c6259c9f$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = 12000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $fA7Cq.promiseWithTimeout)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("6SRxJ", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("hBN81")).AbstractResource);
$parcel$export(module.exports, "utils", () => $ca23a1b29df069a6$export$eab97d15b1788b8d);
parcelRequire("3V8rS");
parcelRequire("hBN81");

var $73WTU = parcelRequire("73WTU");

var $9ticl = parcelRequire("9ticl");
const $ca23a1b29df069a6$export$eab97d15b1788b8d = $73WTU;
const $ca23a1b29df069a6$export$3b4c04cf7dad0e50 = $9ticl;

});
parcelRegister("3V8rS", function(module, exports) {
$parcel$export(module.exports, "buildCredentials", () => $d31ffd1ab997d4cc$export$2ac26f1ab7eda637);
const $d31ffd1ab997d4cc$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("hBN81", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $4af7f53f5d1bb39b$export$4529f10aed0950d4);
class $4af7f53f5d1bb39b$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("73WTU", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => $bbd6ad931d1054b4$export$4f34edf253146101);
$parcel$export(module.exports, "requestService", () => $bbd6ad931d1054b4$export$97bfde5a702aaeca);

var $l5LZV = parcelRequire("l5LZV");

var $3V8rS = parcelRequire("3V8rS");

var $eKFQP = parcelRequire("eKFQP");
const $bbd6ad931d1054b4$var$TRACING_RESPONSE_HEADERS = [
    'x-trace-id',
    'atl-request-id'
];
const $bbd6ad931d1054b4$export$4f34edf253146101 = (response)=>{
    const headers = {};
    for (const name of $bbd6ad931d1054b4$var$TRACING_RESPONSE_HEADERS){
        const value = response.headers.get(name);
        if (value) headers[name] = value;
    }
    return headers;
};
const $bbd6ad931d1054b4$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $eKFQP.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $eKFQP.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $eKFQP.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $3V8rS.buildCredentials)(secOptions);
    const ignoreResponsePayload = (options === null || options === void 0 ? void 0 : options.ignoreResponsePayload) || false;
    // Get tracing headers from UFO
    const tracingHeaders = (0, $l5LZV.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (options !== null && options !== void 0 && options.reportTracingHeaders) {
            const tracingHeaders = $bbd6ad931d1054b4$export$4f34edf253146101(response);
            if (Object.keys(tracingHeaders).length > 0) options.reportTracingHeaders(tracingHeaders);
        }
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $bbd6ad931d1054b4$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("eKFQP", function(module, exports) {
$parcel$export(module.exports, "defaultRequestServiceOptions", () => $5efad6ec742a3973$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $5efad6ec742a3973$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $5efad6ec742a3973$export$7d6ed858a91629c3);
const $5efad6ec742a3973$export$160dbda113bfad3b = {};
const $5efad6ec742a3973$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $5efad6ec742a3973$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $5efad6ec742a3973$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $5efad6ec742a3973$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $5efad6ec742a3973$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("9ticl", function(module, exports) {
$parcel$export(module.exports, "requestServiceMultipart", () => $3ecd66228f7df2bc$export$8b13532c81e8ac89);

var $ljf8N = parcelRequire("ljf8N");

var $3V8rS = parcelRequire("3V8rS");

var $eKFQP = parcelRequire("eKFQP");

var $l5LZV = parcelRequire("l5LZV");
const $3ecd66228f7df2bc$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $eKFQP.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $eKFQP.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $eKFQP.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $3V8rS.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const tracingHeaders = (0, $l5LZV.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $ljf8N.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $3ecd66228f7df2bc$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("ljf8N", function(module, exports) {
$parcel$export(module.exports, "meros", () => $f8371df665c398c3$export$74e0a034be2368c7);
var $f8371df665c398c3$var$e = new TextDecoder;
async function $f8371df665c398c3$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $f8371df665c398c3$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});



parcelRegister("3mXlj", function(module, exports) {
$parcel$export(module.exports, "customCategory", () => $003fd8281f0e7f60$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $003fd8281f0e7f60$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $003fd8281f0e7f60$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $003fd8281f0e7f60$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $003fd8281f0e7f60$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $003fd8281f0e7f60$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $003fd8281f0e7f60$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $003fd8281f0e7f60$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $003fd8281f0e7f60$export$1a817f1886276c6d);
$parcel$export(module.exports, "scaledEmojiHeightH1", () => $003fd8281f0e7f60$export$2e7088017339c92);
$parcel$export(module.exports, "scaledEmojiHeightH2", () => $003fd8281f0e7f60$export$4cb591b57c224c0);
$parcel$export(module.exports, "scaledEmojiHeightH3", () => $003fd8281f0e7f60$export$b31a41e904161dc1);
$parcel$export(module.exports, "scaledEmojiHeightH4", () => $003fd8281f0e7f60$export$7dd039b460c61389);
$parcel$export(module.exports, "denseEmojiHeightH1", () => $003fd8281f0e7f60$export$96ee6614460413a0);
$parcel$export(module.exports, "denseEmojiHeightH2", () => $003fd8281f0e7f60$export$103771a4cd74af90);
$parcel$export(module.exports, "denseEmojiHeightH3", () => $003fd8281f0e7f60$export$5cc2afcf38309ce9);
$parcel$export(module.exports, "denseEmojiHeightH4", () => $003fd8281f0e7f60$export$9a9984214a4bd724);
$parcel$export(module.exports, "defaultEmojiHeight", () => $003fd8281f0e7f60$export$3f99ac31dc0406db);
$parcel$export(module.exports, "defaultDenseEmojiHeight", () => $003fd8281f0e7f60$export$8efb414216030943);
$parcel$export(module.exports, "emojiPickerWidth", () => $003fd8281f0e7f60$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $003fd8281f0e7f60$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $003fd8281f0e7f60$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $003fd8281f0e7f60$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $003fd8281f0e7f60$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $003fd8281f0e7f60$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $003fd8281f0e7f60$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $003fd8281f0e7f60$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $003fd8281f0e7f60$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $003fd8281f0e7f60$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $003fd8281f0e7f60$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $003fd8281f0e7f60$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $003fd8281f0e7f60$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $003fd8281f0e7f60$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $003fd8281f0e7f60$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $003fd8281f0e7f60$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $003fd8281f0e7f60$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $003fd8281f0e7f60$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $003fd8281f0e7f60$export$66cabad5e268b05e);
const $003fd8281f0e7f60$export$5e4e3d1c3e43156a = 'CUSTOM';
const $003fd8281f0e7f60$export$78ccdc4be403c468 = 'FREQUENT';
const $003fd8281f0e7f60$export$2c4b04c3aacdf1b3 = 'SITE';
const $003fd8281f0e7f60$export$1b0258512be88334 = 'SEARCH';
const $003fd8281f0e7f60$export$42b510423367f354 = 'USER_CUSTOM';
const $003fd8281f0e7f60$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $003fd8281f0e7f60$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $003fd8281f0e7f60$export$8ac325bfd32359b0 = 'data:';
const $003fd8281f0e7f60$export$a330961542edfe6f = 'delete-emoji';
const $003fd8281f0e7f60$export$1a817f1886276c6d = 100000;
const $003fd8281f0e7f60$export$2e7088017339c92 = 28;
const $003fd8281f0e7f60$export$4cb591b57c224c0 = 26;
const $003fd8281f0e7f60$export$b31a41e904161dc1 = 24;
const $003fd8281f0e7f60$export$7dd039b460c61389 = 22;
const $003fd8281f0e7f60$export$96ee6614460413a0 = 24.25;
const $003fd8281f0e7f60$export$103771a4cd74af90 = 22.25;
const $003fd8281f0e7f60$export$5cc2afcf38309ce9 = 20.25;
const $003fd8281f0e7f60$export$9a9984214a4bd724 = 18.25;
const $003fd8281f0e7f60$export$3f99ac31dc0406db = 20;
const $003fd8281f0e7f60$export$8efb414216030943 = 16.25;
const $003fd8281f0e7f60$export$d171dc12fee2b1da = 350;
const $003fd8281f0e7f60$export$c10ac8125a260041 = 80;
const $003fd8281f0e7f60$export$5248fb9e0cccc41f = 'medium';
const $003fd8281f0e7f60$export$94f75d625e7801d3 = 260;
const $003fd8281f0e7f60$export$7ed599d166d65aea = 295;
const $003fd8281f0e7f60$export$7722b8e9522021df = $003fd8281f0e7f60$export$7ed599d166d65aea - 58; // picker height - actions height
const $003fd8281f0e7f60$export$e218e5cb105a0e22 = 54;
const $003fd8281f0e7f60$export$e67f617938b111f1 = $003fd8281f0e7f60$export$7ed599d166d65aea + $003fd8281f0e7f60$export$e218e5cb105a0e22;
const $003fd8281f0e7f60$export$e394a0c530ae5631 = 'fabric.emoji';
const $003fd8281f0e7f60$export$79ee4ef84c545f8f = `${$003fd8281f0e7f60$export$e394a0c530ae5631}.selectedTone`;
const $003fd8281f0e7f60$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $003fd8281f0e7f60$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $003fd8281f0e7f60$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $003fd8281f0e7f60$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $003fd8281f0e7f60$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $003fd8281f0e7f60$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $003fd8281f0e7f60$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $003fd8281f0e7f60$export$4f0ee90b28d6efc5 = 0;
const $003fd8281f0e7f60$export$9f7de4293d27f3aa = 50;
const $003fd8281f0e7f60$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $003fd8281f0e7f60$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $003fd8281f0e7f60$export$2829f3ec323f8ec0 = 8;
const $003fd8281f0e7f60$export$ce3a0e7d2d7d6ba2 = 5;
const $003fd8281f0e7f60$export$858e8dc100a97278 = 150;
const $003fd8281f0e7f60$export$83aab2ae64548423 = 20;
const $003fd8281f0e7f60$export$66cabad5e268b05e = 100;

});

parcelRegister("il7mU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c5abcc9aa075358$export$2e2bcd8739ae039);
let $6c5abcc9aa075358$var$debugEnabled = false;
let $6c5abcc9aa075358$var$stacktracesEnabled = false;
function $6c5abcc9aa075358$export$748ada60eaf985cc(enable) {
    $6c5abcc9aa075358$var$debugEnabled = enable;
}
function $6c5abcc9aa075358$export$4f7017086af31c25(enable) {
    $6c5abcc9aa075358$var$stacktracesEnabled = enable;
}
function $6c5abcc9aa075358$export$2a858f450a2f66d() {
    if ($6c5abcc9aa075358$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $6c5abcc9aa075358$export$2e2bcd8739ae039(msg, ...args) {
    if ($6c5abcc9aa075358$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("8W24X", function(module, exports) {
$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $414b4ec732ed991e$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $414b4ec732ed991e$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $414b4ec732ed991e$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $414b4ec732ed991e$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $414b4ec732ed991e$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $414b4ec732ed991e$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $414b4ec732ed991e$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $414b4ec732ed991e$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $414b4ec732ed991e$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $414b4ec732ed991e$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $414b4ec732ed991e$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $414b4ec732ed991e$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $414b4ec732ed991e$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $414b4ec732ed991e$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $414b4ec732ed991e$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $414b4ec732ed991e$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $414b4ec732ed991e$export$4bcbf61cb6832a8e);

var $ccFk5 = parcelRequire("ccFk5");

var $3mXlj = parcelRequire("3mXlj");
const $414b4ec732ed991e$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $414b4ec732ed991e$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $414b4ec732ed991e$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $414b4ec732ed991e$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $414b4ec732ed991e$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $414b4ec732ed991e$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $414b4ec732ed991e$export$a7e82c67204c73a1 = (emoji)=>$414b4ec732ed991e$export$979133dc1df141c6(emoji.representation);
const $414b4ec732ed991e$export$7720a4954d6f75f8 = (rep)=>$414b4ec732ed991e$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $3mXlj.dataURLPrefix)) === 0;
const $414b4ec732ed991e$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $3mXlj.customCategory) && $414b4ec732ed991e$export$7720a4954d6f75f8(emoji.representation);
const $414b4ec732ed991e$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $414b4ec732ed991e$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $414b4ec732ed991e$export$dddfba07c16c94d2 = (key)=>key in (0, $ccFk5.messages);
const $414b4ec732ed991e$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $414b4ec732ed991e$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $414b4ec732ed991e$export$8d7d3de6b5b305d1(emoji);
};
const $414b4ec732ed991e$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $414b4ec732ed991e$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($414b4ec732ed991e$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $414b4ec732ed991e$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $414b4ec732ed991e$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $414b4ec732ed991e$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$414b4ec732ed991e$export$979133dc1df141c6(mediaRepresentation) && !$414b4ec732ed991e$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $414b4ec732ed991e$export$979133dc1df141c6(mediaRepresentation) ? $414b4ec732ed991e$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $414b4ec732ed991e$export$979133dc1df141c6(mediaAltRepresentation) ? $414b4ec732ed991e$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $414b4ec732ed991e$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $414b4ec732ed991e$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $414b4ec732ed991e$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("ccFk5", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f3ea30c5f2803a7a$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $f3ea30c5f2803a7a$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Atlassian & productivity',
        description: 'Emoji Atlassian & productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    changeEmojiButtonLabel: {
        id: 'fabric.emoji.change.button.label',
        defaultMessage: 'Change emoji',
        description: 'Aria label for the button in page title used to change emoji'
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("1pFyE", function(module, exports) {
$parcel$export(module.exports, "default", () => $524afb78f3345c40$export$2e2bcd8739ae039);
function $524afb78f3345c40$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("l50JM", function(module, exports) {
$parcel$export(module.exports, "SearchSort", () => $7c9454965c9456ed$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $7c9454965c9456ed$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $7c9454965c9456ed$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $7c9454965c9456ed$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $7c9454965c9456ed$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $7c9454965c9456ed$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $7c9454965c9456ed$export$482549d945a3723);
var $7c9454965c9456ed$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $7c9454965c9456ed$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $7c9454965c9456ed$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $7c9454965c9456ed$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $7c9454965c9456ed$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $7c9454965c9456ed$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $7c9454965c9456ed$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("7N0U9", function(module, exports) {
$parcel$export(module.exports, "default", () => $69a17f4da6b64b98$export$2e2bcd8739ae039);

var $bsVrq = parcelRequire("bsVrq");
class $69a17f4da6b64b98$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
   * Returns a promise with an array of Emoji from all providers.
   */ loadEmoji() {
        const emojisPromise = (0, $bsVrq.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $bsVrq.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("bsVrq", function(module, exports) {
$parcel$export(module.exports, "emojiRequest", () => $6672615fe237ca79$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $6672615fe237ca79$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $6672615fe237ca79$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $6672615fe237ca79$export$b7e9058f156d8d19);

var $6SRxJ = parcelRequire("6SRxJ");

var $13svG = parcelRequire("13svG");

var $8W24X = parcelRequire("8W24X");

var $il7mU = parcelRequire("il7mU");
const $6672615fe237ca79$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $6672615fe237ca79$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $6672615fe237ca79$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $6SRxJ.utils).requestService(serviceConfig, requestOptions);
};
const $6672615fe237ca79$var$calculateScale = (getRatio)=>{
    if ((0, $13svG.expValEquals)('platform_editor_emoji_default_scale', 'isEnabled', true)) {
        // retina display
        if (getRatio() > 1) return {
            scale: 'XXXHDPI',
            altScale: 'XXXHDPI'
        };
        // default set used for desktop
        return {
            altScale: 'XXXHDPI'
        };
    }
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $6672615fe237ca79$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $6672615fe237ca79$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$6672615fe237ca79$var$calculateScale($6672615fe237ca79$export$d39ce20a37bba061).altScale];
};
const $6672615fe237ca79$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $6672615fe237ca79$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $8W24X.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $8W24X.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($6672615fe237ca79$export$db05e6ae1fd416af(imagePath, meta)) return (0, $8W24X.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $il7mU.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $6672615fe237ca79$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $6672615fe237ca79$export$55077db3efc820aa($6672615fe237ca79$export$4a0301d636367e1d(altReps), meta);
};
const $6672615fe237ca79$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $6672615fe237ca79$export$55077db3efc820aa(representation, meta),
            altRepresentation: $6672615fe237ca79$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $6672615fe237ca79$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $6672615fe237ca79$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $6672615fe237ca79$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $6672615fe237ca79$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: _representation, skinVariations: _skinVariations, altRepresentations: _altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $8W24X.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $6672615fe237ca79$var$getHeight = (fitToHeight)=>$6672615fe237ca79$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $6672615fe237ca79$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $6672615fe237ca79$var$getHeight(fitToHeight) > emoji.representation.height);

});
parcelRegister("13svG", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $25fbeca36d670610$export$45abdb3f977b5b14);

var $04AYY = parcelRequire("04AYY");
function $25fbeca36d670610$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $04AYY.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("04AYY", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $831a1ad3fa597aab$export$58e581060588c6bb);

var $1EFS8 = parcelRequire("1EFS8");

var $1M3oH = parcelRequire("1M3oH");

var $ffZCx = parcelRequire("ffZCx");
function $831a1ad3fa597aab$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $ffZCx._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $ffZCx._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $1EFS8.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $1EFS8.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $1EFS8.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $1M3oH.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("ffZCx", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $4797bd329bcdec59$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $4797bd329bcdec59$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $4797bd329bcdec59$export$cf7305fc65acbf0d);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $4CFp1 = parcelRequire("4CFp1");

var $cdTCr = parcelRequire("cdTCr");
let $4797bd329bcdec59$export$e5d73bf4f8e2ae96 = {};
let $4797bd329bcdec59$export$4e849416bb5c5b52 = {};
let $4797bd329bcdec59$export$cf7305fc65acbf0d;
function $4797bd329bcdec59$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $4CFp1.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $4797bd329bcdec59$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $4CFp1.editorExperimentsConfig)).map(([key, value])=>{
            var _groupOverrides;
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                ((_groupOverrides = groupOverrides) === null || _groupOverrides === void 0 ? void 0 : _groupOverrides[key]) ?? (0, $cdTCr.testMultivariateOverrides)[key] ?? (0, $cdTCr.testBooleanOverrides)[key] ?? defaultValue
            ];
        }));
        $4797bd329bcdec59$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $4797bd329bcdec59$export$cf7305fc65acbf0d = product;
    $4797bd329bcdec59$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("4CFp1", function(module, exports) {
$parcel$export(module.exports, "editorExperimentsConfig", () => $87b5e4fc83a75555$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $4Xe2Y = parcelRequire("4Xe2Y");
const $87b5e4fc83a75555$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-02-11
    ai_speech_to_text_in_editor: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'ai_speech_to_text_in_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 22-12-2025
    confluence_load_editor_title_on_transition: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_load_editor_title_on_transition'
        },
        param: 'contentPlaceholder',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-20
    editor_a11y_decision_aria_label: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_decision_aria_label',
            jira: 'editor_a11y_decision_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 05-03-2026
    platform_editor_ai_headingautocomplete: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_headingautocomplete'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-10
    confluence_max_width_content_appearance: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_content_appearance'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-15
    confluence_max_width_breakout_extension_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_breakout_extension_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_remix_icon_right_side: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-12-09
    cc_editor_hover_link_overlay_css_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_hover_link_overlay_css_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_integrations_editor_open_link_click_analytics: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_integrations_editor_open_link_click_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-7
    platform_editor_table_sticky_header_patch_10: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_10'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-12
    platform_editor_media_vc_fixes: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_vc_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_vc_fixes_patch1: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_vc_fixes_patch1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_media_reliability_observability: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_reliability_observability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_react19_migration: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_react19_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05 - gates DOM mutation observer for experience tracking (toolbar + block menu)
    platform_editor_experience_tracking_observer: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking_observer',
            jira: 'platform_editor_experience_tracking_observer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_editor_ssr_streaming: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_ssr_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-02
    platform_editor_inline_card_dispatch_guard: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_inline_card_dispatch_guard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_display_mode_in_to_dom: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_display_mode_in_to_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-12
    platform_editor_confluence_base_preset: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_confluence_base_preset'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_clean_up_widget_mark_logic: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_clean_up_widget_mark_logic',
            jira: 'platform_editor_clean_up_widget_mark_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_renderer_shadow_observer_cleanup: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_renderer_shadow_observer_cleanup',
            confluence: 'platform_editor_renderer_shadow_observer_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-17
    platform_editor_aifc_sync_block_stream_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_sync_block_stream_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-17-03
    platform_editor_media_name_fallback: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    platform_editor_table_update_table_ref: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_update_table_ref'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27
    platform_editor_table_excerpts_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_excerpts_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    // Added 2025-11-25
    smart_link_confluence_short_link_analytics: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'smart-link-confluence-short-link-analytics',
            jira: 'smart-link-confluence-short-link-analytics'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu',
            jira: 'platform_editor_block_menu_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-11-19
    platform_editor_pasting_text_in_panel: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_pasting_text_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_comment_editor_border_radius: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_editor_border_radius'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    platform_editor_perf_lint_cleanup: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_perf_lint_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-19
    cc_editor_limited_mode_expanded: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_expanded'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_native_embeds: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_embeds'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-12
    ccpi_fix_broken_uploaded_img: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'ccpi_fix_broken_uploaded_img'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block',
            jira: 'platform_synced_block_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_synced_block_use_new_source_nodeview: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block_use_new_source_nodeview',
            jira: 'platform_synced_block_use_new_source_nodeview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_synced_block_patch_6: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block_patch_6',
            jira: 'platform_synced_block_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-08
    platform_editor_table_toolbar_perf_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_toolbar_perf_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-25
    platform_editor_ai_escape_early_for_unhealthy_node: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_escape_early_for_unhealthy_node'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-04
    confluence_compact_text_format: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_compact_text_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_unify_native_dnd_selectors: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_unify_native_dnd_selectors',
            jira: 'platform_editor_unify_native_dnd_selectors'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_abort_ufo_on_user_interaction: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_abort_ufo_on_user_interaction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_disable_lcm_copy_button: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lcm_copy_button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-28-01
    platform_editor_primary_toolbar_early_exit: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_primary_toolbar_early_exit',
            jira: 'platform_editor_primary_toolbar_early_exit'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_flex_based_centering: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flex_based_centering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-27
    platform_sl_3p_unauth_paste_as_block_card: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_unauth_paste_as_block_card',
            jira: 'platform_sl_3p_unauth_paste_as_block_card'
        },
        values: [
            'control',
            'card_by_default_only',
            'card_by_default_and_new_design'
        ],
        param: 'cohort',
        defaultValue: 'control'
    }),
    // Added 2026-03-17 - 3P auth Rovo actions on smart link hover card (boolean: isEnabled)
    platform_sl_3p_auth_rovo_action: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_action',
            jira: 'platform_sl_3p_auth_rovo_action'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-09 — Inline action nudge on resolved inline smart links
    'rovogrowth-640-inline-action-nudge-exp': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'rovogrowth-640-inline-action-nudge-exp',
            jira: 'rovogrowth-640-inline-action-nudge-exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-23
    platform_editor_to_use_pmr_for_collab_edit_none_ic: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_to_use_pmr_for_collab_edit_none_ic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-12
    platform_editor_toolbar_delay_render_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_delay_render_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-08
    platform_editor_add_image_editing: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_image_editing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_aifc_use_editor_typography: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_use_editor_typography',
            jira: 'platform_editor_toolbar_aifc_use_editor_typography'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-30
    platform_editor_table_sticky_header_patch_9: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_9'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-22
    platform_editor_localid_ime_composition_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_localid_ime_composition_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-22
    platform_editor_sample_renderer_rendered_event: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sample_renderer_rendered_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-25
    platform_editor_expand_paste_in_comment_editor: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_expand_paste_in_comment_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-12
    platform_editor_table_sticky_header_patch_11: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_11'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_ai_fix_insert_after_selection: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_fix_insert_after_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-07
    platform_editor_ai_move_node: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_move_node'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-02
    platform_editor_ai_disable_bridge_without_ai: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_disable_bridge_without_ai'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-16
    platform_editor_ai_edit_unsupported_content: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_unsupported_content'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-19
    platform_editor_copy_paste_issue_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_paste_issue_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27 - AI create-page expand collapse fix
    platform_editor_aifc_expand_collapses_oncreate_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_expand_collapses_oncreate_fix',
            jira: 'platform_editor_aifc_expand_collapses_oncreate_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-22
    platform_editor_ai_loading_responsive_width: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_loading_responsive_width',
            jira: 'platform_editor_ai_loading_responsive_width'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-22
    platform_editor_nested_drag_handle_icon: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_drag_handle_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-23
    collab_bypass_out_of_sync_period_experiment: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'collab_bypass_out_of_sync_period_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-16
    platform_editor_ignore_metadata_connection_errors: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_collab_provider_suppress_metadata_errors'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    platform_editor_table_a11y_eslint_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_a11y_eslint_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-29
    platform_editor_renderer_toolbar_updates: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_toolbar_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_comment_rovoinlinechat_improvement: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_rovoinlinechat_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-16-05
    platform_editor_outdated_browser_update: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_outdated_browser_update'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-02
    cc_fd_cwr_quick_insert: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_cwr_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'slot-four',
            'slot-two'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-13
    cc_fd_cwr_quick_insert_aa: (0, $4Xe2Y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_cwr_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'slot-four',
            'slot-two'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-05 - A11Y-10416
    editor_a11y_role_textbox: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_role_textbox'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-28
    platform_editor_smartlink_local_cache: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smartlink_local_cache'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    platform_editor_toolbar_split_button_ui: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_split_button_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-06
    platform_rovo_inline_chat_missing_analytics_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_inline_chat_missing_analytics_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-12
    platform_editor_bodiedextension_layoutshift_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_bodiedextension_layoutshift_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-16
    platform_safari_cursor_typeahead_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_safari_cursor_typeahead_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-17
    confluence_frontend_fix_date_hydration_error: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_fix_date_hydration_error'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_a11y_eslint_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_eslint_fix',
            jira: 'platform_editor_a11y_eslint_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_fix_advanced_codeblocks_crlf_patch: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_advanced_codeblocks_crlf_patch',
            jira: 'platform_editor_fix_advanced_codeblocks_crlf_patch'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    'cc-maui-experiment-phase-2': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment-phase-2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    jira_maui_remix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    confluence_fe_cwr_outcome_picker_prompt_autoselect: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_cwr_outcome_picker_prompt_autoselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_table_border: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_table_border'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_expand_icon: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_expand_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_mentions: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-11
    platform_editor_prosemirror_rendered_data: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prosemirror_rendered_data',
            jira: 'platform_editor_prosemirror_rendered_data'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_flexible_list_indentation: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_indentation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_flexible_list_schema: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_schema'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-25
    platform_editor_a11y_typeahead_tab_keypress: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_typeahead_tab_keypress'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    platform_editor_early_exit_return_draft: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_early_exit_return_draft'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_update_actioned_event_timeout: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_update_actioned_event_timeout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-02
    platform_editor_discarded_unified_analytic_events: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_discarded_unified_analytic_events',
            jira: 'platform_editor_discarded_unified_analytic_events'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_appearance_shared_state: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_appearance_shared_state'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added for space shortcut plugin: when on, space shortcut is not added if AI opt-in is not enabled
    platform_editor_ai_aifc_space_shortcut_patch: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_aifc_space_shortcut_patch'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-02
    platform_editor_ai_smartlink_toolbar_v2_exp: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_smartlink_toolbar_v2_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_a11y_scrollable_region: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_scrollable_region'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_renderer_error_boundary_stable_key: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_renderer_error_boundary_stable_key',
            confluence: 'platform_editor_renderer_error_boundary_stable_key'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_editor_unhandled_type_errors: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_editor_unhandled_type_errors'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_insert_location_check: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_insert_location_check',
            confluence: 'platform_editor_insert_location_check'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    cc_drag_and_drop_smart_link_from_content_to_tree: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_drag_and_drop_smart_link_from_content_to_tree'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-19
    platform_editor_fix_table_row_drag_drop_target: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_table_row_drag_drop_target'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_remove_grid_init_reflow: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_grid_init_reflow'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-07
    platform_editor_table_remove_last_cell_decoration: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_remove_last_cell_decoration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_small_font_size: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_small_font_size',
            jira: 'platform_editor_small_font_size'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_fix_media_picker_hidden: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_picker_hidden',
            jira: 'platform_editor_fix_media_picker_hidden'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_analyse_table_with_merged_cells: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_analyse_table_with_merged_cells'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_ttvc_media_hold_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ttvc_media_hold_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_rovo_inline_chat_aria_label: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovo_inline_chat_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_are_nodes_equal_ignore_mark_order: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_are_nodes_equal_ignore_mark_order',
            jira: 'platform_editor_are_nodes_equal_ignore_mark_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_auto_convert: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_auto_convert'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_disable_last_node_para: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_last_node_para',
            jira: 'platform_editor_disable_last_node_para'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-13
    platform_editor_editor_centre_content_on_find: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_centre_content_on_find'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_table_ref_optimisation: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_ref_optimisation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-20
    platform_editor_chromeless_expand_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_chromeless_expand_fix',
            jira: 'platform_editor_chromeless_expand_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-23
    platform_editor_inline_media_copy_paste_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_inline_media_copy_paste_fix',
            jira: 'platform_editor_inline_media_copy_paste_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-13
    platform_editor_misaligned_ai_screens_firefox_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_misaligned_ai_screens_firefox_fix',
            jira: 'platform_editor_misaligned_ai_screens_firefox_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-19
    platform_editor_toolbar_two_stage_hydration: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_two_stage_hydration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_stricter_panelcolor_typecheck: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stricter_panelcolor_typecheck'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27
    platform_editor_preserve_node_identity: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preserve_node_identity'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-23
    confluence_toc_nav_a11y: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_toc_nav_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-004
    platform_editor_user_highlight_contrast: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_user_highlight_contrast'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    platform_editor_fix_comment_border: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_comment_border'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_spotlight_migration: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_spotlight_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-14
    platform_editor_ai_multi_format_streaming: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_multi_format_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_layout_column_resize_handle: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_lovability_distribute_column_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_distribute_column_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-02
    platform_editor_ai_aifc_listitem_indentation_fix: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_aifc_listitem_indentation_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-09
    platform_editor_fix_selection_wrapped_media_embed: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_selection_wrapped_media_embed',
            jira: 'platform_editor_fix_selection_wrapped_media_embed'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-07
    platform_editor_lovability_select_all_shortcut: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_select_all_shortcut',
            jira: 'platform_editor_lovability_select_all_shortcut'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-14
    improve_3p_smart_link_resolve_rate: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'improve_3p_smart_link_resolve_rate'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    platform_editor_drag_handle_keyboard_a11y: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_keyboard_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    show_mentions_in_suggest_reply: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            jira: 'show_mentions_in_suggest_reply'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-10
    platform_editor_static_css: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_static_css',
            jira: 'platform_editor_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-12
    platform_editor_media_reliability_enhancements: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_reliability_enhancements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-14
    platform_editor_ai_rename_add_polish: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_rename_add_polish'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-16
    cc_dnd_smart_link_changeboard_po_template: (0, $4Xe2Y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_dnd_smart_link_changeboard_po_template'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("4Xe2Y", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $08abdd02f2b0c926$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $08abdd02f2b0c926$export$fb89e8a786694d1);

var $3KRbz = parcelRequire("3KRbz");
function $08abdd02f2b0c926$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $3KRbz.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $08abdd02f2b0c926$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        // Maintains the tuple
        typeGuard: (0, $3KRbz.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("3KRbz", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $fa8a7cf5bf249a96$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $fa8a7cf5bf249a96$export$a9a18ae5ba42aeab);

var $6nQJh = parcelRequire("6nQJh");
var $fa8a7cf5bf249a96$var$_process, $fa8a7cf5bf249a96$var$_process2;
function $fa8a7cf5bf249a96$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $fa8a7cf5bf249a96$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($fa8a7cf5bf249a96$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $fa8a7cf5bf249a96$var$IS_TESTING_ENV = typeof $6nQJh !== 'undefined' && ((($fa8a7cf5bf249a96$var$_process = $6nQJh) === null || $fa8a7cf5bf249a96$var$_process === void 0 || ($fa8a7cf5bf249a96$var$_process = $fa8a7cf5bf249a96$var$_process.env) === null || $fa8a7cf5bf249a96$var$_process === void 0 ? void 0 : $fa8a7cf5bf249a96$var$_process.NODE_ENV) === 'test' || (($fa8a7cf5bf249a96$var$_process2 = $6nQJh) === null || $fa8a7cf5bf249a96$var$_process2 === void 0 || ($fa8a7cf5bf249a96$var$_process2 = $fa8a7cf5bf249a96$var$_process2.env) === null || $fa8a7cf5bf249a96$var$_process2 === void 0 ? void 0 : $fa8a7cf5bf249a96$var$_process2.JEST_WORKER_ID) !== undefined);

});



parcelRegister("cdTCr", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $9188dee99cb69584$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $9188dee99cb69584$export$54960937bb713f97);
const $9188dee99cb69584$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    smart_link_confluence_short_link_analytics: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    platform_sl_3p_unauth_paste_as_block_card: 'control',
    cc_fd_db_top_editor_toolbar: 'control',
    cc_fd_cwr_quick_insert: 'control',
    cc_fd_cwr_quick_insert_aa: 'control'
};
const $9188dee99cb69584$export$54960937bb713f97 = {
    platform_sl_3p_auth_rovo_action: false,
    platform_sl_3p_preauth_better_hovercard: true,
    'rovogrowth-640-inline-action-nudge-exp': true,
    cwr_blank_object_experiment: false,
    cc_editor_hover_link_overlay_css_fix: false,
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    platform_editor_prosemirror_rendered_data: false,
    confluence_compact_text_format: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_diff_plugin_extended: false,
    platform_editor_preserve_node_identity: false,
    platform_editor_ai_rename_add_polish: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_fit_to_content_auto_convert: false
};

});






parcelRegister("bUBD1", function(module, exports) {
$parcel$export(module.exports, "getEmojiVariation", () => $7acf4afaf4b11e3f$export$e55e46e1520c899d);
$parcel$export(module.exports, "default", () => $7acf4afaf4b11e3f$export$2e2bcd8739ae039);

var $QCH7r = parcelRequire("QCH7r");

var $3mXlj = parcelRequire("3mXlj");

var $8W24X = parcelRequire("8W24X");

var $l50JM = parcelRequire("l50JM");

var $8Nail = parcelRequire("8Nail");

var $dr63v = parcelRequire("dr63v");

var $4naPW = parcelRequire("4naPW");

var $e6Qdr = parcelRequire("e6Qdr");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $7acf4afaf4b11e3f$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $8Nail.tokenizerRegex).lastIndex = 0;
        while((match = (0, $8Nail.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $7acf4afaf4b11e3f$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $8W24X.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$7acf4afaf4b11e3f$var$addAllVariants(variation, fnKey, map));
    }
};
const $7acf4afaf4b11e3f$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $7acf4afaf4b11e3f$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $7acf4afaf4b11e3f$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $8W24X.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $7acf4afaf4b11e3f$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
class $7acf4afaf4b11e3f$export$2e2bcd8739ae039 {
    static #_ = this.defaultEmojiWeight = 1000000;
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
   * Returns all available (and searchable) emoji in some default order.
   */ all() {
        const options = {
            sort: (0, $l50JM.SearchSort).None
        };
        return this.search('', options);
    }
    /**
   * Text search of emoji shortName and name field for suitable matches.
   *
   * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
   *
   * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
   * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
   * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
   */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $7acf4afaf4b11e3f$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
   * Returns all emoji with matching shortName
   */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
   * Returns the first matching emoji matching the shortName, or null if none found.
   */ findByShortName(shortName) {
        return $7acf4afaf4b11e3f$var$findByKey(this.shortNameMap, shortName);
    }
    /**
   * Returns the first matching emoji matching the id, or null if none found.
   */ findById(id) {
        return $7acf4afaf4b11e3f$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $3mXlj.frequentCategory)) return this.getFrequentlyUsed();
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
   * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
   * there are none.
   *
   * @param options optional settings to be applied to the set of frequently used emoji
   */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
   * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
   * in sorting, etc).
   *
   * @param emoji the emoji that was just used
   */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $3mXlj.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $3mXlj.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $7acf4afaf4b11e3f$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $l50JM.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $l50JM.SearchSort).Default) comparator = (0, $dr63v.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $l50JM.SearchSort).UsageFrequency) comparator = (0, $dr63v.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $7acf4afaf4b11e3f$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $4naPW.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        if (!(0, $e6Qdr.fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
    }
    /**
   * Optimisation to initialise all map member variables in single loop over emojis
   */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(emoji.category);
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $3mXlj.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $3mXlj.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $QCH7r.Search)('id');
        this.fullSearch.tokenizer = new $7acf4afaf4b11e3f$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $QCH7r.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $7acf4afaf4b11e3f$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $7acf4afaf4b11e3f$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $7acf4afaf4b11e3f$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $7acf4afaf4b11e3f$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = (0, $8W24X.getCategoryId)(emoji);
        if ((0, $3mXlj.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
}

});
parcelRegister("QCH7r", function(module, exports) {
$parcel$export(module.exports, "UnorderedSearchIndex", () => $09e2df5be92bcc67$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $09e2df5be92bcc67$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $09e2df5be92bcc67$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $09e2df5be92bcc67$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $09e2df5be92bcc67$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $09e2df5be92bcc67$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $09e2df5be92bcc67$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $09e2df5be92bcc67$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $09e2df5be92bcc67$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    };
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $09e2df5be92bcc67$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $09e2df5be92bcc67$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    };
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $09e2df5be92bcc67$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $09e2df5be92bcc67$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($09e2df5be92bcc67$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $09e2df5be92bcc67$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $09e2df5be92bcc67$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$09e2df5be92bcc67$export$eeaf491a400e882a.constructor = false;
$09e2df5be92bcc67$export$eeaf491a400e882a.hasOwnProperty = false;
$09e2df5be92bcc67$export$eeaf491a400e882a.isPrototypeOf = false;
$09e2df5be92bcc67$export$eeaf491a400e882a.propertyIsEnumerable = false;
$09e2df5be92bcc67$export$eeaf491a400e882a.toLocaleString = false;
$09e2df5be92bcc67$export$eeaf491a400e882a.toString = false;
$09e2df5be92bcc67$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $09e2df5be92bcc67$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$09e2df5be92bcc67$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $09e2df5be92bcc67$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $09e2df5be92bcc67$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $09e2df5be92bcc67$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $09e2df5be92bcc67$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $09e2df5be92bcc67$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $09e2df5be92bcc67$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $09e2df5be92bcc67$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $09e2df5be92bcc67$export$147e8ac43c84713a();
        this._tokenizer = new $09e2df5be92bcc67$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    };
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    };
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    };
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    };
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $09e2df5be92bcc67$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $09e2df5be92bcc67$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $09e2df5be92bcc67$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $09e2df5be92bcc67$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $09e2df5be92bcc67$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $09e2df5be92bcc67$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    };
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("8Nail", function(module, exports) {
$parcel$export(module.exports, "tokenizerRegex", () => $8ac7ccba913c960e$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $8ac7ccba913c960e$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("dr63v", function(module, exports) {
$parcel$export(module.exports, "createSearchEmojiComparator", () => $31d5466781058d15$export$e6097b005751df7);
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $31d5466781058d15$export$1bd055808eeccb4e);

var $3mXlj = parcelRequire("3mXlj");

var $8W24X = parcelRequire("8W24X");
function $31d5466781058d15$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $31d5466781058d15$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $31d5466781058d15$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $31d5466781058d15$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $31d5466781058d15$export$587c775915dc4869(textQuery, 'shortName'), new $31d5466781058d15$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($31d5466781058d15$export$165e96ceead77edd.Instance, $31d5466781058d15$export$30ce221e1adf48c1.Instance);
    const comparator = new $31d5466781058d15$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $31d5466781058d15$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $31d5466781058d15$export$a8052d0852821684(new $31d5466781058d15$export$55e24837a4bf653(orderedIds), new $31d5466781058d15$export$a7f7a0b04013a8a8(), $31d5466781058d15$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $31d5466781058d15$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $31d5466781058d15$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}
class $31d5466781058d15$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $31d5466781058d15$export$a7f7a0b04013a8a8(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}
class $31d5466781058d15$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}
class $31d5466781058d15$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
   * Get the ordinal representing the position of this emoji.
   *
   * @param id the id of the emoji
   */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $8W24X.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $3mXlj.MAX_ORDINAL;
    }
}
class $31d5466781058d15$export$587c775915dc4869 {
    /**
   * @param query the query to match
   * @param propertyToCompare the property of EmojiDescription to check for query within
   */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $3mXlj.MAX_ORDINAL);
        return score === -1 ? (0, $3mXlj.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}
class $31d5466781058d15$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $3mXlj.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $3mXlj.MAX_ORDINAL);
        return o1 - o2;
    }
}
class $31d5466781058d15$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("4naPW", function(module, exports) {
$parcel$export(module.exports, "UsageFrequencyTracker", () => $f802c9a018eeaf6f$export$3f86810331c44209);

var $8W24X = parcelRequire("8W24X");

var $3mXlj = parcelRequire("3mXlj");

var $5iYSh = parcelRequire("5iYSh");

var $guyXg = parcelRequire("guyXg");

var $1pFyE = parcelRequire("1pFyE");
class $f802c9a018eeaf6f$export$3f86810331c44209 {
    static #_ = this.queueOptions = {
        storage: (0, $1pFyE.default)('localStorage') ? window.localStorage : undefined,
        storagePrefix: (0, $3mXlj.localStoragePrefix),
        maxDuplicates: 25,
        minUniqueItems: 5
    };
    constructor(useStorageIfPossible = true){
        const options = $f802c9a018eeaf6f$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $guyXg.default)(queueOptions);
        } else this.queue = new (0, $5iYSh.default)(options);
        this.gateway = new $f802c9a018eeaf6f$export$a0e1fa6601cae894(10);
    }
    /**
   * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
   * count on getOrder() reflecting this usage immediately.
   *
   * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
   */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $8W24X.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
   * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
   * are no usages then an empty array will be returned.
   */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
   * Exposed for testing only. Clear any recorded usage.
   */ clear() {
        this.queue.clear();
    }
}
class $f802c9a018eeaf6f$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
   * Run the supplied function if the count of already submitted work allows it. Drop the work
   * if it's not allowed to run.
   *
   * Will return true if the function has been submitted or false if it was not submitted.
   */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});
parcelRegister("5iYSh", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c738fb6954886e0$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $3c738fb6954886e0$export$2e2bcd8739ae039 {
    /**
   * Construct a new DuplicateLimitedQueue.
   *
   * @param options the options for this queue.
   */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
   * @param item the item to add to the queue.
   */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items in the queue, ordered by how often they are duplicated. The items with the
   * most duplicates come first in the returned Array.
   *
   * If there are no items in the queue then an empty Array will be returned.
   */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue.
   */ clear() {
        this.createEmptyState();
    }
    /**
   * A more efficient mechanism for adding multiple items. Ordering is only performed once all
   * the items have been added.
   *
   * @param items the items to be enqueued, which happens in their presented order.
   */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items currently stored in the queue.
   */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
   * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
   * performed by this enqueuing. You must trigger that manually if required.
   *
   * @param item the item to be queued
   */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
   * Get an array of items from the queue ordered by how often they are duplicated in the queue.
   */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
   * Walk the list of items and remove the first occurrence of the matching item.
   *
   * @param item the item to be removed.
   */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
   * Remove the first item from the queue and update the itemCountMap accordingly.
   * @return the item add the front of the queue or undefined if the queue is empty
   */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
   * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
   * @param item the item to be added to the queue
   */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("guyXg", function(module, exports) {
$parcel$export(module.exports, "default", () => $61ebcc358a0c7c91$export$2e2bcd8739ae039);

var $5iYSh = parcelRequire("5iYSh");

var $il7mU = parcelRequire("il7mU");
class $61ebcc358a0c7c91$export$2e2bcd8739ae039 extends (0, $5iYSh.default) {
    static #_ = this.storageKey = 'lastUsed';
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$61ebcc358a0c7c91$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
   * Enqueue the supplied item and also persist the new contents of the queue to storage.
   *
   * @param item the item to be enqueued
   */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
   */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
   * Initialise the queue contents from the configured Storage. If there is no data found in
   * storage then the queue will have no items added. Likewise, a failure to read or parse stored
   * data will be swallowed and no items are added to the queue.
   */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $il7mU.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
   * Save the current items in the queue, overwriting any previously stored queue.
   * Any failure in saving will be silently ignored with the likely outcome that any previous
   * saved items will remain unchanged in storage.
   */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $il7mU.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});



parcelRegister("3Ctug", function(module, exports) {
$parcel$export(module.exports, "default", () => $56b81d3ef1bcf16a$export$2e2bcd8739ae039);

var $6SRxJ = parcelRequire("6SRxJ");

var $c0KQ5 = parcelRequire("c0KQ5");

var $8W24X = parcelRequire("8W24X");

var $9xjdP = parcelRequire("9xjdP");

var $bsVrq = parcelRequire("bsVrq");

var $gCvab = parcelRequire("gCvab");

var $il7mU = parcelRequire("il7mU");
const $56b81d3ef1bcf16a$export$6f3a08dea02a7b2b = 0.95;
class $56b81d3ef1bcf16a$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $6SRxJ.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $8W24X.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $bsVrq.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $8W24X.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $8W24X.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $gCvab.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $9xjdP.default)(this.tokenManager);
    }
    /**
   * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
   */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $8W24X.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $8W24X.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
   * Will load media emoji, returning a new EmojiDescription if, for example,
   * the URL has changed.
   */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $8W24X.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $8W24X.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $il7mU.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $c0KQ5.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $56b81d3ef1bcf16a$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing' || state.status === 'processed') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $il7mU.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
   * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
   * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
   * completes with failure then the Promise will resolve to false.
   */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $bsVrq.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $bsVrq.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $il7mU.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
   * Calls to site-scoped EmojiResource to delete emoji
   * @param emoji media emoji to delete
   * @returns Promise.resolve() if success and Promise.reject() for failure
   */ deleteEmoji(emoji) {
        if (!(0, $8W24X.isMediaEmoji)(emoji) && !(0, $8W24X.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $6SRxJ.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("9xjdP", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dfd35e57b962655$export$2e2bcd8739ae039);

var $8W24X = parcelRequire("8W24X");

var $3SaIJ = parcelRequire("3SaIJ");

var $il7mU = parcelRequire("il7mU");

var $4E7es = parcelRequire("4E7es");
const $1dfd35e57b962655$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $1dfd35e57b962655$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $1dfd35e57b962655$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $il7mU.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = $1dfd35e57b962655$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $8W24X.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($1dfd35e57b962655$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}
const $1dfd35e57b962655$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $1dfd35e57b962655$var$maxImageSize = 10000;
class $1dfd35e57b962655$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $il7mU.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $4E7es.LRUMap)($1dfd35e57b962655$var$maxImageCached);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $1dfd35e57b962655$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $8W24X.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $8W24X.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $8W24X.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $1dfd35e57b962655$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $il7mU.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}
class $1dfd35e57b962655$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $il7mU.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $3SaIJ.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $1dfd35e57b962655$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $8W24X.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $8W24X.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $8W24X.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $1dfd35e57b962655$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $1dfd35e57b962655$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $1dfd35e57b962655$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("3SaIJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbde3ab1cc5f9664$export$2e2bcd8739ae039);

var $amGdo = parcelRequire("amGdo");
const $bbde3ab1cc5f9664$var$defaultConcurrentDownloadLimit = 16;
const $bbde3ab1cc5f9664$var$backoffMaxDelayInMillis = 600;
const $bbde3ab1cc5f9664$var$defaultMaxRetriesOnNotFound = 2;
class $bbde3ab1cc5f9664$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $bbde3ab1cc5f9664$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $bbde3ab1cc5f9664$var$defaultMaxRetriesOnNotFound) {
        return (0, $amGdo.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($bbde3ab1cc5f9664$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("amGdo", function(module, exports) {
$parcel$export(module.exports, "getNaturalImageSize", () => $2894784ca088a73a$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $2894784ca088a73a$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $2894784ca088a73a$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $2894784ca088a73a$export$f8e7886bc155c2e6);
const $2894784ca088a73a$var$maxEmojiSizeInBytes = 1048576;
const $2894784ca088a73a$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $2894784ca088a73a$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $2894784ca088a73a$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $2894784ca088a73a$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $2894784ca088a73a$var$isWebpSupported;
const $2894784ca088a73a$export$c5a964eb84c7fca8 = ()=>{
    if ($2894784ca088a73a$var$isWebpSupported !== undefined) return Promise.resolve($2894784ca088a73a$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $2894784ca088a73a$var$isWebpSupported = img.height === 2;
            resolve($2894784ca088a73a$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $2894784ca088a73a$export$f8e7886bc155c2e6 = ()=>$2894784ca088a73a$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});



parcelRegister("gCvab", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3885ef134665271$export$2e2bcd8739ae039);

var $6SRxJ = parcelRequire("6SRxJ");
const $e3885ef134665271$export$866c20c059277b6 = 30;
class $e3885ef134665271$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $e3885ef134665271$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $6SRxJ.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});


parcelRegister("dhnr5", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $0ba78ef717be2c7f$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $0ba78ef717be2c7f$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $0ba78ef717be2c7f$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $0ba78ef717be2c7f$export$1466212a1606133);

var $l50JM = parcelRequire("l50JM");

var $2Bslm = parcelRequire("2Bslm");
var $a1qEv = parcelRequire("a1qEv");
var $35qKa = parcelRequire("35qKa");

var $anOOG = parcelRequire("anOOG");
const $0ba78ef717be2c7f$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $a1qEv.ExperienceTypes).Load,
        performanceType: (0, $a1qEv.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $0ba78ef717be2c7f$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $a1qEv.ExperienceTypes).Experience,
        performanceType: (0, $a1qEv.ExperiencePerformanceTypes).InlineResult
    };
};
const $0ba78ef717be2c7f$var$customEmojiTimings = [
    {
        key: (0, $l50JM.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $l50JM.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $l50JM.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $l50JM.UfoEmojiTimings).METADATA_START,
        endMark: (0, $l50JM.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $l50JM.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $l50JM.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $l50JM.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $l50JM.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $l50JM.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $l50JM.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $l50JM.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $l50JM.UfoEmojiTimings).ONLOAD_END
    }
];
const $0ba78ef717be2c7f$export$615f888019c45765 = {
    'emoji-rendered': new (0, $2Bslm.ConcurrentExperience)((0, $l50JM.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $l50JM.UfoComponentName).EMOJI
        },
        type: (0, $a1qEv.ExperienceTypes).Operation,
        performanceType: (0, $a1qEv.ExperiencePerformanceTypes).Custom,
        timings: $0ba78ef717be2c7f$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $2Bslm.ConcurrentExperience)((0, $l50JM.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $0ba78ef717be2c7f$var$createRenderExperience((0, $l50JM.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $35qKa.UFOExperience)((0, $l50JM.UfoExperienceName).EMOJI_PICKER_OPENED, $0ba78ef717be2c7f$var$createRenderExperience((0, $l50JM.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $35qKa.UFOExperience)((0, $l50JM.UfoExperienceName).EMOJI_SELECTION_RECORDED, $0ba78ef717be2c7f$var$createInlineExperience((0, $l50JM.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $35qKa.UFOExperience)((0, $l50JM.UfoExperienceName).EMOJI_UPLOADED, $0ba78ef717be2c7f$var$createInlineExperience((0, $l50JM.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $35qKa.UFOExperience)((0, $l50JM.UfoExperienceName).EMOJI_SEARCHED, $0ba78ef717be2c7f$var$createInlineExperience((0, $l50JM.UfoComponentName).EMOJI_PICKER))
};
const $0ba78ef717be2c7f$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $anOOG.withSampling)($0ba78ef717be2c7f$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $0ba78ef717be2c7f$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $0ba78ef717be2c7f$export$1466212a1606133 = (providerType)=>{
    return (0, $anOOG.withSampling)($0ba78ef717be2c7f$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("2Bslm", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $1aca73c2ccfb0c96$export$ac1cddfee07ba6ac);

var $16Lc3 = parcelRequire("16Lc3");

var $35qKa = parcelRequire("35qKa");
class $1aca73c2ccfb0c96$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $35qKa.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $16Lc3.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("16Lc3", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $23dfbf8ff0059c31$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $23dfbf8ff0059c31$export$d53d07b6034c4560);
class $23dfbf8ff0059c31$var$UFOLogger {
    static #_ = this.UFOprefix = "[ufo\uD83D\uDEF8]";
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($23dfbf8ff0059c31$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($23dfbf8ff0059c31$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $23dfbf8ff0059c31$export$4ab84f6f04f6566d = new $23dfbf8ff0059c31$var$UFOLogger();
const $23dfbf8ff0059c31$export$b4958caff08a0960 = (...args)=>{
    $23dfbf8ff0059c31$export$4ab84f6f04f6566d.log(...args);
};
const $23dfbf8ff0059c31$export$d53d07b6034c4560 = (...args)=>{
    $23dfbf8ff0059c31$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("35qKa", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $f30286544f1a9dd6$export$c00d22927c60484a);

var $7Xr1C = parcelRequire("7Xr1C");
class $f30286544f1a9dd6$export$c00d22927c60484a extends (0, $7Xr1C.UFOAbstractExperience) {
}

});
parcelRegister("7Xr1C", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $f9f24b929962866a$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $gdnRs = parcelRequire("gdnRs");

var $2MjEP = parcelRequire("2MjEP");

var $2fU7P = parcelRequire("2fU7P");

var $16Lc3 = parcelRequire("16Lc3");

var $aDuWY = parcelRequire("aDuWY");

var $27y3J = parcelRequire("27y3J");

var $27i20 = parcelRequire("27i20");

var $bFMld = parcelRequire("bFMld");

var $5UIDa = parcelRequire("5UIDa");

var $kYCMn = parcelRequire("kYCMn");

var $a1qEv = parcelRequire("a1qEv");
const $f9f24b929962866a$var$getPageVisibleState = ()=>{
    return !(0, $bFMld.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $27y3J.PageVisibleState).VISIBLE : (0, $27y3J.PageVisibleState).HIDDEN;
};
const $f9f24b929962866a$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $27i20.roundPerfNow)();
};
class $f9f24b929962866a$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $5UIDa.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $27y3J.PageVisibleState).MIXED;
            (0, $aDuWY.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $f9f24b929962866a$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $a1qEv.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $a1qEv.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $16Lc3.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $kYCMn.canTransition)(this.state, newState)) {
            (0, $16Lc3.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $5UIDa.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $f9f24b929962866a$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $gdnRs.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $f9f24b929962866a$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $2fU7P.getGlobalEventStream)().push((0, $2fU7P.unsubscribeEvent)((0, $27y3J.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $16Lc3.ufolog)('this.parent', this.parent);
                (0, $2fU7P.getGlobalEventStream)().push((0, $2fU7P.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $16Lc3.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $16Lc3.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $5UIDa.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $f9f24b929962866a$var$getPageVisibleState();
            (0, $aDuWY.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $16Lc3.ufolog)('subscribed', this.id);
                (0, $2fU7P.getGlobalEventStream)().push((0, $2fU7P.subscribeEvent)((0, $27y3J.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $27y3J.FMP_MARK) && name !== (0, $27y3J.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $16Lc3.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $f9f24b929962866a$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $5UIDa.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $27y3J.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $27y3J.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $16Lc3.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $aDuWY.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $5UIDa.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $5UIDa.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $5UIDa.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $16Lc3.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $2MjEP.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("2MjEP", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $fb67c077f5a361c3$export$2295b861f318254a);
// temp solution until we can get it automated
const $fb67c077f5a361c3$export$2295b861f318254a = '0.1.5';

});

parcelRegister("2fU7P", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $79986de0fa85a898$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $79986de0fa85a898$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $79986de0fa85a898$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $79986de0fa85a898$export$7c957416596ca127);

var $16Lc3 = parcelRequire("16Lc3");

var $27y3J = parcelRequire("27y3J");
const $79986de0fa85a898$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $79986de0fa85a898$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $79986de0fa85a898$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $79986de0fa85a898$export$c1522520b417b066 = (eventStream)=>{
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $16Lc3.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $79986de0fa85a898$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $27y3J.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $79986de0fa85a898$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $27y3J.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $79986de0fa85a898$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $27y3J.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("27y3J", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $2b8864cd6f8aec84$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $2b8864cd6f8aec84$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $2b8864cd6f8aec84$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $2b8864cd6f8aec84$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $2b8864cd6f8aec84$export$837e0f79a8056912);
var $2b8864cd6f8aec84$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $2b8864cd6f8aec84$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $2b8864cd6f8aec84$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $2b8864cd6f8aec84$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $2b8864cd6f8aec84$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $2b8864cd6f8aec84$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $2b8864cd6f8aec84$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $2b8864cd6f8aec84$export$9f2bf58999404c75 = 'fmp';
const $2b8864cd6f8aec84$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("aDuWY", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $a11336c0b6a68400$export$13e680397ec8f3eb);

var $bFMld = parcelRequire("bFMld");
class $a11336c0b6a68400$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $bFMld.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $a11336c0b6a68400$export$13e680397ec8f3eb = new $a11336c0b6a68400$var$VisibilityChangeObserver();

});
parcelRegister("bFMld", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $b5a8bf05618caa2d$export$15e172712955e18f);
const $b5a8bf05618caa2d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("27i20", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $ff6ed3f70ee41e50$export$5f490af6b2b115cf);
const $ff6ed3f70ee41e50$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("5UIDa", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $b2a8f7af13417dbd$export$81b70111112841a0);
const $b2a8f7af13417dbd$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("kYCMn", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $b7b86e0ac140e46f$export$178881f329fdb81f);

var $5UIDa = parcelRequire("5UIDa");
const $b7b86e0ac140e46f$var$UFOStateAvailableTransitions = {
    [(0, $5UIDa.UFOExperienceState).NOT_STARTED.id]: [
        (0, $5UIDa.UFOExperienceState).STARTED.id
    ],
    [(0, $5UIDa.UFOExperienceState).STARTED.id]: [
        (0, $5UIDa.UFOExperienceState).IN_PROGRESS.id,
        (0, $5UIDa.UFOExperienceState).BLOCKED.id,
        (0, $5UIDa.UFOExperienceState).SUCCEEDED.id,
        (0, $5UIDa.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $5UIDa.UFOExperienceState).FAILED.id,
        (0, $5UIDa.UFOExperienceState).ABORTED.id
    ],
    [(0, $5UIDa.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $5UIDa.UFOExperienceState).BLOCKED.id,
        (0, $5UIDa.UFOExperienceState).SUCCEEDED.id,
        (0, $5UIDa.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $5UIDa.UFOExperienceState).FAILED.id,
        (0, $5UIDa.UFOExperienceState).ABORTED.id
    ],
    [(0, $5UIDa.UFOExperienceState).BLOCKED.id]: [
        (0, $5UIDa.UFOExperienceState).RECOVERED.id,
        (0, $5UIDa.UFOExperienceState).ABORTED.id
    ],
    [(0, $5UIDa.UFOExperienceState).RECOVERED.id]: [
        (0, $5UIDa.UFOExperienceState).STARTED.id,
        (0, $5UIDa.UFOExperienceState).SUCCEEDED.id,
        (0, $5UIDa.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $5UIDa.UFOExperienceState).FAILED.id,
        (0, $5UIDa.UFOExperienceState).ABORTED.id
    ],
    [(0, $5UIDa.UFOExperienceState).SUCCEEDED.id]: [
        (0, $5UIDa.UFOExperienceState).STARTED.id
    ],
    [(0, $5UIDa.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $5UIDa.UFOExperienceState).SUCCEEDED.id,
        (0, $5UIDa.UFOExperienceState).FAILED.id,
        (0, $5UIDa.UFOExperienceState).ABORTED.id
    ],
    [(0, $5UIDa.UFOExperienceState).FAILED.id]: [
        (0, $5UIDa.UFOExperienceState).STARTED.id
    ],
    [(0, $5UIDa.UFOExperienceState).ABORTED.id]: [
        (0, $5UIDa.UFOExperienceState).STARTED.id
    ]
};
const $b7b86e0ac140e46f$export$178881f329fdb81f = (state1, state2)=>{
    return $b7b86e0ac140e46f$var$UFOStateAvailableTransitions[state1.id] && $b7b86e0ac140e46f$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("a1qEv", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $0ad084089b8052e1$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $0ad084089b8052e1$export$cc26007c03242fff);
var $0ad084089b8052e1$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $0ad084089b8052e1$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});




parcelRegister("anOOG", function(module, exports) {
$parcel$export(module.exports, "withSampling", () => $179af49ba2d89f51$export$dc2f0946255b3f89);
const $179af49ba2d89f51$export$c7c4959fece2f3ec = {};
const $179af49ba2d89f51$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($179af49ba2d89f51$export$c7c4959fece2f3ec))delete $179af49ba2d89f51$export$c7c4959fece2f3ec[prop];
};
const $179af49ba2d89f51$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $179af49ba2d89f51$var$hasSampledFromStart = (experience)=>{
    if (!$179af49ba2d89f51$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $179af49ba2d89f51$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $179af49ba2d89f51$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $179af49ba2d89f51$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$179af49ba2d89f51$export$c7c4959fece2f3ec[ufoExperience.id]) $179af49ba2d89f51$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($179af49ba2d89f51$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $179af49ba2d89f51$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $179af49ba2d89f51$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $179af49ba2d89f51$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $179af49ba2d89f51$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $179af49ba2d89f51$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$179af49ba2d89f51$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$179af49ba2d89f51$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$179af49ba2d89f51$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$179af49ba2d89f51$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$179af49ba2d89f51$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$179af49ba2d89f51$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$179af49ba2d89f51$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("fA7Cq", function(module, exports) {
$parcel$export(module.exports, "promiseWithTimeout", () => $1f36d9fece855af3$export$a9cd205a244d9f54);
function $1f36d9fece855af3$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}

});



parcelRegister("jbMcU", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8018547c4cf1289$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $67yYu = parcelRequire("67yYu");

var $feOkE = parcelRequire("feOkE");

var $87huJ = parcelRequire("87huJ");
var $4tdJc = parcelRequire("4tdJc");

var $hXIhE = parcelRequire("hXIhE");

var $5Yojh = parcelRequire("5Yojh");
var $7gpfw = parcelRequire("7gpfw");

var $hnw2m = parcelRequire("hnw2m");

var $3Ks2d = parcelRequire("3Ks2d");

var $i9yMb = parcelRequire("i9yMb");
const $e8018547c4cf1289$export$8f69873d7d6eec35 = (props)=>{
    const { product: product, additionalExtensionHandlers: additionalExtensionHandlers = {}, PropsProvider: PropsProvider, contentId: contentId, dataProviders: dataProviders } = props;
    const [sectionsProvider, setSectionsProvider] = (0, $8P7DW.useState)(null);
    const intl = (0, $k7INq.default)();
    const hubExtensionHandlers = (0, $i9yMb.useHubExtensionHandlers)({
        contentId: contentId,
        PropsProvider: PropsProvider
    });
    const allExtensionHandlers = (0, $8P7DW.useMemo)(()=>{
        return {
            ...hubExtensionHandlers,
            ...additionalExtensionHandlers
        };
    }, [
        hubExtensionHandlers,
        additionalExtensionHandlers
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const loadSectionsProvider = async ()=>{
            const defaultExtensionProviderProps = {
                contentId: contentId,
                propsProvider: PropsProvider,
                mode: (0, $5Yojh.ExtensionMode).RENDERER,
                getSectionExtensionContents: $hnw2m.getSectionExtensionContents
            };
            const defaultExtensionInstanceProps = {
                intl: intl,
                contentId: contentId
            };
            const sectionsProviderInstance = await (0, $3Ks2d.sectionExtensionProvider)(defaultExtensionProviderProps);
            const sectionsProvider = await sectionsProviderInstance(defaultExtensionInstanceProps);
            setSectionsProvider(sectionsProvider);
        };
        loadSectionsProvider();
    }, [
        contentId,
        intl,
        PropsProvider
    ]);
    const providerFactory = (0, $8P7DW.useMemo)(()=>{
        const factory = dataProviders || (0, $feOkE.default).create({});
        if (sectionsProvider) factory.setProvider('extensionProvider', Promise.resolve((0, $67yYu.default)([
            sectionsProvider
        ])));
        return factory;
    }, [
        sectionsProvider,
        dataProviders
    ]);
    const smartCardClient = (0, $8P7DW.useMemo)(()=>new (0, $87huJ.default)(), []);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7gpfw.HubRendererWrapper), {
        "data-testid": "hub-renderer",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4tdJc.SmartCardProvider), {
            product: product,
            client: smartCardClient,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hXIhE.RendererWithAnalytics), {
                ...props,
                allowCustomPanels: true,
                media: {
                    allowLinking: true
                },
                extensionHandlers: allExtensionHandlers,
                // dataProviders supplies the extension provider factory which enables section extensions to be rendered within the hub
                dataProviders: providerFactory,
                adfStage: "stage0"
            })
        })
    });
};
var $e8018547c4cf1289$export$2e2bcd8739ae039 = $e8018547c4cf1289$export$8f69873d7d6eec35;

});
parcelRegister("67yYu", function(module, exports) {
$parcel$export(module.exports, "default", () => $d580053346af8b98$export$2e2bcd8739ae039);

var $kiUDc = parcelRequire("kiUDc");
var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $d580053346af8b98$export$2e2bcd8739ae039 = (extensionProviders)=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $kiUDc.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>{
                var _provider$preload;
                return provider === null || provider === void 0 || (_provider$preload = provider.preload) === null || _provider$preload === void 0 ? void 0 : _provider$preload.call(provider);
            }));
        },
        getPreloadedExtension (type, key) {
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                var _provider$getPreloade;
                const result = provider === null || provider === void 0 || (_provider$getPreloade = provider.getPreloadedExtension) === null || _provider$getPreloade === void 0 ? void 0 : _provider$getPreloade.call(provider, type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});
parcelRegister("kiUDc", function(module, exports) {
$parcel$export(module.exports, "default", () => $673c695696bed5a8$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $kUe8Y = parcelRequire("kUe8Y");
const $673c695696bed5a8$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $673c695696bed5a8$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $kUe8Y.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        if (!(0, $e6Qdr.fg)('platform_editor_fix_getautoconverter_null_error')) return (0, $kUe8Y.getOnlyFulfilled)(results);
        // Filter out null/undefined providers to prevent errors when calling methods on them
        return (0, $kUe8Y.getOnlyFulfilled)(results).filter((provider)=>provider != null);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
   * Run a method from the provider which expects to return a single item
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $kUe8Y.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
   * Run a method in the provider which expectes to return a list of items
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $kUe8Y.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $kUe8Y.getOnlyFulfilled)(results);
        return $673c695696bed5a8$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});
parcelRegister("kUe8Y", function(module, exports) {
$parcel$export(module.exports, "waitForAllPromises", () => $9ecc2e3c7f50d0eb$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "waitForFirstFulfilledPromise", () => $9ecc2e3c7f50d0eb$export$cb8861b0e3f3dd6f);
$parcel$export(module.exports, "getOnlyFulfilled", () => $9ecc2e3c7f50d0eb$export$b7581cbf0e22e36b);
var $9ecc2e3c7f50d0eb$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $9ecc2e3c7f50d0eb$var$isFullfilled = (result)=>result.status === "fulfilled";
const $9ecc2e3c7f50d0eb$var$markFullfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9ecc2e3c7f50d0eb$var$markRejected = (error)=>({
        status: "failed",
        reason: error
    });
const $9ecc2e3c7f50d0eb$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($9ecc2e3c7f50d0eb$var$markFullfilled).catch($9ecc2e3c7f50d0eb$var$markRejected)));
};
const $9ecc2e3c7f50d0eb$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
const $9ecc2e3c7f50d0eb$export$b7581cbf0e22e36b = (results)=>results.filter($9ecc2e3c7f50d0eb$var$isFullfilled).map((result)=>result.value);

});



parcelRegister("87huJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b89d9767381af402$export$2e2bcd8739ae039);

var $8qoQb = parcelRequire("8qoQb");

var $1Sgmo = parcelRequire("1Sgmo");

var $fTWt8 = parcelRequire("fTWt8");

var $enrNN = parcelRequire("enrNN");
var $3WKh6 = parcelRequire("3WKh6");
var $cE8LQ = parcelRequire("cE8LQ");
var $kVAsT = parcelRequire("kVAsT");

var $e7Zyy = parcelRequire("e7Zyy");

var $4E7es = parcelRequire("4E7es");

var $DCNJd = parcelRequire("DCNJd");

var $e6Qdr = parcelRequire("e6Qdr");
const $b89d9767381af402$var$MAX_BATCH_SIZE = 50;
const $b89d9767381af402$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $b89d9767381af402$var$URL_RESPONSE_CACHE_SIZE = 100;
const $b89d9767381af402$export$d6a66073b5d79eb3 = new (0, $4E7es.LRUMap)($b89d9767381af402$var$URL_RESPONSE_CACHE_SIZE);
class $b89d9767381af402$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($DCNJd)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
       * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
       * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $kVAsT.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $kVAsT.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $e7Zyy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
       * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
       * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $kVAsT.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $kVAsT.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $e7Zyy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $3WKh6.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($fTWt8)))({
            limit: 1,
            interval: $b89d9767381af402$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($8qoQb)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $b89d9767381af402$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($fTWt8)))({
            limit: 1,
            interval: $b89d9767381af402$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($8qoQb)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $b89d9767381af402$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $enrNN.InvalidUrlError)(error);
        }
    }
    async resolveUrl(url, force = false) {
        const hostname = this.getHostName(url);
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $b89d9767381af402$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            if ((0, $e6Qdr.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined
                });
            } else responsePromise = loader.load(url);
            $b89d9767381af402$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $b89d9767381af402$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $e7Zyy.isSuccessfulResponse)(response) || (0, $cE8LQ.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $b89d9767381af402$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $e7Zyy.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($1Sgmo)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $e7Zyy.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $e7Zyy.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($1Sgmo)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $e7Zyy.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $kVAsT.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $kVAsT.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $e7Zyy.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $kVAsT.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response !== null && response !== void 0 && response.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $kVAsT.NetworkError)) return new (0, $enrNN.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $enrNN.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $enrNN.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $enrNN.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $enrNN.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $enrNN.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("1Sgmo", function(module, exports) {
// Packages

var $gCDEF = parcelRequire("gCDEF");
function $15d78660f8eb1aaf$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $gCDEF.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $15d78660f8eb1aaf$var$retry;

});
parcelRegister("gCDEF", function(module, exports) {

module.exports = (parcelRequire("27hSK"));

});
parcelRegister("27hSK", function(module, exports) {

var $30qlh = parcelRequire("30qlh");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $30qlh(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("30qlh", function(module, exports) {
function $2305ce32c2e92e9b$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $2305ce32c2e92e9b$var$RetryOperation;
$2305ce32c2e92e9b$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$2305ce32c2e92e9b$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$2305ce32c2e92e9b$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$2305ce32c2e92e9b$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$2305ce32c2e92e9b$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$2305ce32c2e92e9b$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$2305ce32c2e92e9b$var$RetryOperation.prototype.start = $2305ce32c2e92e9b$var$RetryOperation.prototype.try;
$2305ce32c2e92e9b$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$2305ce32c2e92e9b$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$2305ce32c2e92e9b$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("fTWt8", function(module, exports) {
'use strict';
class $b93958c95b788638$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $b93958c95b788638$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $b93958c95b788638$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $b93958c95b788638$var$pThrottle;
module.exports.AbortError = $b93958c95b788638$var$AbortError;

});

parcelRegister("enrNN", function(module, exports) {
$parcel$export(module.exports, "APIError", () => $434e49522ed585c2$export$3e5b797e39668f84);
$parcel$export(module.exports, "InvalidUrlError", () => $434e49522ed585c2$export$19fa02dd69bd4efd);
class $434e49522ed585c2$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
class $434e49522ed585c2$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}

});

parcelRegister("3WKh6", function(module, exports) {
$parcel$export(module.exports, "getBaseUrl", () => $438831ea70d28c3e$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $438831ea70d28c3e$export$dc37652c1696f231);
const $438831ea70d28c3e$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $438831ea70d28c3e$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $438831ea70d28c3e$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $438831ea70d28c3e$export$e2b040f052407032 = {
    dev: $438831ea70d28c3e$var$devBaseUrl,
    development: $438831ea70d28c3e$var$devBaseUrl,
    stg: $438831ea70d28c3e$var$stgBaseUrl,
    staging: $438831ea70d28c3e$var$stgBaseUrl,
    prd: $438831ea70d28c3e$var$prodBaseUrl,
    prod: $438831ea70d28c3e$var$prodBaseUrl,
    production: $438831ea70d28c3e$var$prodBaseUrl
};
const $438831ea70d28c3e$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $438831ea70d28c3e$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $438831ea70d28c3e$export$e2b040f052407032 ? $438831ea70d28c3e$export$e2b040f052407032[envKey] : $438831ea70d28c3e$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $438831ea70d28c3e$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $438831ea70d28c3e$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $438831ea70d28c3e$export$2e2bcd8739ae039 = $438831ea70d28c3e$export$e2b040f052407032;

});

parcelRegister("cE8LQ", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $8b8435dccbd67758$export$b70265791d2079d4);
const $8b8435dccbd67758$var$getStatusForNotFoundVisibility = (meta)=>{
    var _meta$requestAccess;
    const accessType = (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $8b8435dccbd67758$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $8b8435dccbd67758$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("kVAsT", function(module, exports) {
$parcel$export(module.exports, "NetworkError", () => $6fb3d1af52038fca$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $6fb3d1af52038fca$export$b5fe3f66a567bec0);
const $6fb3d1af52038fca$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $6fb3d1af52038fca$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $6fb3d1af52038fca$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $6fb3d1af52038fca$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses !== null && statuses !== void 0 && statuses.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $6fb3d1af52038fca$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("e7Zyy", function(module, exports) {
$parcel$export(module.exports, "isSuccessfulResponse", () => $525699af64da1a28$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $525699af64da1a28$export$bea7bee8a87e7c52);
const $525699af64da1a28$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $525699af64da1a28$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("DCNJd", function(module, exports) {

var $2b4jE = parcelRequire("2b4jE");

var $9ynuU = parcelRequire("9ynuU");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $0771bdb7a2c89158$var$uniqBy(array, iteratee) {
    return array && array.length ? $9ynuU(array, $2b4jE(iteratee, 2)) : [];
}
module.exports = $0771bdb7a2c89158$var$uniqBy;

});


parcelRegister("4tdJc", function(module, exports) {
$parcel$export(module.exports, "SmartCardProvider", () => $d1324d37381146da$export$497ecb0280204df4);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $14lC8 = parcelRequire("14lC8");

var $4BY1L = parcelRequire("4BY1L");

var $lat3P = parcelRequire("lat3P");

var $673gs = parcelRequire("673gs");

var $8ur5I = parcelRequire("8ur5I");

var $73ark = parcelRequire("73ark");

var $87huJ = parcelRequire("87huJ");
function $d1324d37381146da$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions }) {
    const parentContext = (0, $8P7DW.useContext)((0, $73ark.SmartCardContext));
    const defaultInitialState = (0, $8P7DW.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $8P7DW.useMemo)(()=>{
        return (0, $14lC8.default)((0, $8ur5I.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $8P7DW.useMemo)(()=>{
        const client = customClient || new (0, $87huJ.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, _platform)=>{
            const cardState = (0, $lat3P.getUrl)(store, url);
            return cardState.details ? (0, $673gs.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions
        };
    }, [
        customAuthFlow,
        customClient,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        rovoOptions,
        store
    ]);
    const value = (0, $8P7DW.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4BY1L)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $73ark.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
var $d1324d37381146da$export$2e2bcd8739ae039 = $d1324d37381146da$export$497ecb0280204df4;

});
parcelRegister("lat3P", function(module, exports) {
$parcel$export(module.exports, "getUrl", () => $decbac248934006f$export$94df0e59ebebf4a7);
const $decbac248934006f$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("673gs", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkTitle", () => $bcbe51baecda7622$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $bcbe51baecda7622$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $bcbe51baecda7622$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $bcbe51baecda7622$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $bcbe51baecda7622$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $bcbe51baecda7622$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $bcbe51baecda7622$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $bcbe51baecda7622$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $bcbe51baecda7622$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $bcbe51baecda7622$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $bcbe51baecda7622$export$96ed4c1b14ac210a);

var $bVDzC = parcelRequire("bVDzC");
var $ico7w = parcelRequire("ico7w");
var $cKTDf = parcelRequire("cKTDf");
var $3tgms = parcelRequire("3tgms");
var $a22k7 = parcelRequire("a22k7");
var $fNlF1 = parcelRequire("fNlF1");
var $lDvXk = parcelRequire("lDvXk");
var $lqo5q = parcelRequire("lqo5q");

var $lm7Ce = parcelRequire("lm7Ce");

var $3Z03G = parcelRequire("3Z03G");
const $bcbe51baecda7622$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $3Z03G.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $3Z03G.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    return (0, $lqo5q.extractTitle)(response === null || response === void 0 ? void 0 : response.data, removeTextHighlightingFromTitle);
};
const $bcbe51baecda7622$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $3Z03G.isEntityPresent)(response)) {
        var _extractEntity2;
        return (_extractEntity2 = (0, $3Z03G.extractEntity)(response)) === null || _extractEntity2 === void 0 ? void 0 : _extractEntity2.url;
    }
    return (0, $3tgms.extractLink)(response === null || response === void 0 ? void 0 : response.data);
};
const $bcbe51baecda7622$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $3Z03G.isEntityPresent)(response)) {
        var _extractEntity3, _extractEntity4;
        return ((_extractEntity3 = (0, $3Z03G.extractEntity)(response)) === null || _extractEntity3 === void 0 ? void 0 : _extractEntity3.ari) || ((_extractEntity4 = (0, $3Z03G.extractEntity)(response)) === null || _extractEntity4 === void 0 ? void 0 : _extractEntity4.thirdPartyAri);
    }
    const data = response === null || response === void 0 ? void 0 : response.data;
    return (0, $bVDzC.extractAri)(data);
};
const $bcbe51baecda7622$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $3Z03G.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = (0, $3Z03G.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $lm7Ce.extractPreview)(response === null || response === void 0 ? void 0 : response.data, 'web', iframeUrlType);
};
const $bcbe51baecda7622$export$ff753ed519e96e9e = (response)=>{
    if ((0, $3Z03G.isEntityPresent)(response)) return (0, $3Z03G.extractEntityProvider)(response);
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $lDvXk.extractProvider)(response === null || response === void 0 ? void 0 : response.data);
};
const $bcbe51baecda7622$export$7a685df468cbf38f = (response)=>{
    if ((0, $3Z03G.isEntityPresent)(response)) {
        var _extractEntity5;
        return (_extractEntity5 = (0, $3Z03G.extractEntity)(response)) === null || _extractEntity5 === void 0 ? void 0 : _extractEntity5.createdAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $ico7w.extractDateCreated)(response.data);
};
const $bcbe51baecda7622$export$75047940e157fd1f = (response)=>{
    if ((0, $3Z03G.isEntityPresent)(response)) {
        var _extractEntity6;
        return (_extractEntity6 = (0, $3Z03G.extractEntity)(response)) === null || _extractEntity6 === void 0 ? void 0 : _extractEntity6.lastUpdatedAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $cKTDf.extractDateUpdated)(response.data);
};
const $bcbe51baecda7622$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3Z03G.isEntityPresent)(response)) {
        var _extractEntity7;
        return (_extractEntity7 = (0, $3Z03G.extractEntity)(response)) === null || _extractEntity7 === void 0 || (_extractEntity7 = _extractEntity7.createdBy) === null || _extractEntity7 === void 0 ? void 0 : _extractEntity7.displayName;
    }
    const persons = (0, $a22k7.extractPersonCreatedBy)(response.data);
    return !!(persons !== null && persons !== void 0 && persons.length) ? persons[0].name : undefined;
};
const $bcbe51baecda7622$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3Z03G.isEntityPresent)(response)) {
        const entity = (0, $3Z03G.extractEntity)(response);
        const owners = entity === null || entity === void 0 ? void 0 : entity.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $a22k7.extractPersonCreatedBy)(response.data);
};
const $bcbe51baecda7622$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $3Z03G.isEntityPresent)(response)) {
        var _extractEntity8;
        return (_extractEntity8 = (0, $3Z03G.extractEntity)(response)) === null || _extractEntity8 === void 0 || (_extractEntity8 = _extractEntity8.lastUpdatedBy) === null || _extractEntity8 === void 0 ? void 0 : _extractEntity8.displayName;
    }
    const person = (0, $fNlF1.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $bcbe51baecda7622$export$96ed4c1b14ac210a = (response)=>{
    var _response$data;
    if ((0, $3Z03G.isEntityPresent)(response)) {
        var _entity$exportLinks;
        const entity = (0, $3Z03G.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity === null || entity === void 0 || (_entity$exportLinks = entity.exportLinks) === null || _entity$exportLinks === void 0 ? void 0 : _entity$exportLinks[0].url : undefined;
    }
    return response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data['atlassian:downloadUrl'];
};

});
parcelRegister("bVDzC", function(module, exports) {
$parcel$export(module.exports, "extractAri", () => $a8077ab8824b97e9$export$be18a6294fd426ec);
const $a8077ab8824b97e9$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};

});

parcelRegister("ico7w", function(module, exports) {
$parcel$export(module.exports, "extractDateCreated", () => $1723423df3aff83b$export$e1226a5e0bbbf862);
const $1723423df3aff83b$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};

});

parcelRegister("cKTDf", function(module, exports) {
$parcel$export(module.exports, "extractDateUpdated", () => $423e8530ac50e384$export$7fc2f5e6f9d22ae7);
const $423e8530ac50e384$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};

});

parcelRegister("3tgms", function(module, exports) {
$parcel$export(module.exports, "extractLink", () => $63b5b4f69b062e85$export$63f54cf4c5883620);

var $db3bG = parcelRequire("db3bG");
const $63b5b4f69b062e85$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $db3bG.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};

});
parcelRegister("db3bG", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $6d9e14323f6111cb$export$396ba4ef2e37dc65);
const $6d9e14323f6111cb$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $6d9e14323f6111cb$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};

});


parcelRegister("a22k7", function(module, exports) {
$parcel$export(module.exports, "extractPersonCreatedBy", () => $3f6d0629d6cb6c68$export$a66235cba0c9d11a);

var $anJBW = parcelRequire("anJBW");
const $3f6d0629d6cb6c68$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $anJBW.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $anJBW.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});
parcelRegister("anJBW", function(module, exports) {
$parcel$export(module.exports, "extractPersonFromJsonLd", () => $33fb23396cab5e42$export$c471ae5fddcf1392);

var $hKbUE = parcelRequire("hKbUE");
const $33fb23396cab5e42$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $hKbUE.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};

});
parcelRegister("hKbUE", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $22ecaed8709696fc$export$67f3d92c824fd850);

var $db3bG = parcelRequire("db3bG");
const $22ecaed8709696fc$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $db3bG.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $db3bG.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};

});



parcelRegister("fNlF1", function(module, exports) {
$parcel$export(module.exports, "extractPersonUpdatedBy", () => $2c401d6fed9be016$export$8a2d1ed7e6f336f0);

var $anJBW = parcelRequire("anJBW");
const $2c401d6fed9be016$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $anJBW.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};

});

parcelRegister("lDvXk", function(module, exports) {
$parcel$export(module.exports, "extractProvider", () => $821474a0827ec7fb$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $821474a0827ec7fb$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $821474a0827ec7fb$export$38df542ff03a4183);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $i5dqB = parcelRequire("i5dqB");

var $iqc8I = parcelRequire("iqc8I");

var $e6Qdr = parcelRequire("e6Qdr");

var $i2QhJ = parcelRequire("i2QhJ");

var $hKbUE = parcelRequire("hKbUE");
var $db3bG = parcelRequire("db3bG");
const $821474a0827ec7fb$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $821474a0827ec7fb$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $821474a0827ec7fb$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $821474a0827ec7fb$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $i2QhJ.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $i5dqB.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $e6Qdr.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $i2QhJ.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqc8I.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $e6Qdr.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return (0, $hKbUE.extractUrlFromIconJsonLd)(icon);
    return undefined;
};
const $821474a0827ec7fb$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $db3bG.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $db3bG.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
const $821474a0827ec7fb$export$38df542ff03a4183 = (id)=>{
    return id === (0, $i2QhJ.CONFLUENCE_GENERATOR_ID);
};

});
parcelRegister("i5dqB", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $7682230ee757b536$export$68f3db7f6af48bcb);

var $ddWFJ = parcelRequire("ddWFJ");

var $b9F5i = parcelRequire("b9F5i");

var $fiJGd = parcelRequire("fiJGd");
const $7682230ee757b536$export$68f3db7f6af48bcb = (0, $fiJGd.createFeatureFlaggedComponent)((0, $b9F5i.ConfluenceIcon), (0, $ddWFJ.ConfluenceIcon));

});
parcelRegister("ddWFJ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $d9675101e93d924a$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d9675101e93d924a$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $d9675101e93d924a$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $d9675101e93d924a$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $d9675101e93d924a$var$svg,
        customThemeSvg: $d9675101e93d924a$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("4qlnm", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $8a25ae47dae62e9e$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $e6Qdr = parcelRequire("e6Qdr");

var $kHnjK = parcelRequire("kHnjK");
const $8a25ae47dae62e9e$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $8a25ae47dae62e9e$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $8a25ae47dae62e9e$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $8a25ae47dae62e9e$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $8a25ae47dae62e9e$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $8a25ae47dae62e9e$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $8a25ae47dae62e9e$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $8a25ae47dae62e9e$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $8a25ae47dae62e9e$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $8n1kL.default)([
            $8a25ae47dae62e9e$var$styles.root,
            $8a25ae47dae62e9e$var$sizeMap[size],
            colorMode === 'dark' ? $8a25ae47dae62e9e$var$dataCenterDarkAppearanceMap[appearance] : $8a25ae47dae62e9e$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $8a25ae47dae62e9e$var$rovoDarkAppearanceMap[appearance] : $8a25ae47dae62e9e$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $8a25ae47dae62e9e$var$cloudDarkAppearanceMap[appearance] : $8a25ae47dae62e9e$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $e6Qdr.fg)('assets-platform-branding') && $8a25ae47dae62e9e$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("b9F5i", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $1da6dd656582b7fd$export$68f3db7f6af48bcb);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $1da6dd656582b7fd$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $1da6dd656582b7fd$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $1da6dd656582b7fd$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("gnrsO", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", () => $cc26b7ebbda2b0b4$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $cc26b7ebbda2b0b4$export$793fba32aed8942a);
const $cc26b7ebbda2b0b4$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $cc26b7ebbda2b0b4$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};

});

parcelRegister("3hgWu", function(module, exports) {
$parcel$export(module.exports, "default", () => $c823f8dca39bfde4$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $c823f8dca39bfde4$var$CSS_VAR_COLOR = '--logo-color';
const $c823f8dca39bfde4$var$CSS_VAR_FILL = '--logo-fill';
const $c823f8dca39bfde4$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $c823f8dca39bfde4$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-testid": testId,
        style: {
            [$c823f8dca39bfde4$var$CSS_VAR_COLOR]: iconColor,
            [$c823f8dca39bfde4$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $8n1kL.default)([
            $c823f8dca39bfde4$var$styles.root,
            shouldApplyStopColor && $c823f8dca39bfde4$var$styles.stop,
            size && $c823f8dca39bfde4$var$styles[size]
        ])
    });
};
var $c823f8dca39bfde4$export$2e2bcd8739ae039 = $c823f8dca39bfde4$var$Wrapper;

});

parcelRegister("ipRYk", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $8703157088fad89d$export$362a25f017e2bc8a);
$parcel$export(module.exports, "getColorsFromAppearance", () => $8703157088fad89d$export$bbacc3980e0f3029);
$parcel$export(module.exports, "getColorsForLoom", () => $8703157088fad89d$export$7818df200941dbbf);
// TODO: This is where we need to add tokens for all appearance color values
const $8703157088fad89d$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = '#0052CC';
            iconGradientStop = '#2684FF';
            iconColor = '#2684FF';
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = '#0052CC';
            break;
        case 'neutral':
            iconGradientStart = '#344563';
            iconGradientStop = '#7A869A';
            iconColor = '#7A869A';
            textColor = '#505F79';
            atlassianLogoTextColor = '#505F79';
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $8703157088fad89d$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $8703157088fad89d$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = $8703157088fad89d$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    let textColor = $8703157088fad89d$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});


parcelRegister("fiJGd", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedComponent", () => $a48eb45e1df34c41$export$e30d2ddc605f6bb);
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", () => $a48eb45e1df34c41$export$436fcf6e31fbacea);
$parcel$export(module.exports, "createFeatureFlaggedRovoComponent", () => $a48eb45e1df34c41$export$2469203854060337);
$parcel$export(module.exports, "tempSizeWrapper", () => $a48eb45e1df34c41$export$667425256e2e7296);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");
const $a48eb45e1df34c41$export$e30d2ddc605f6bb = (LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return ({ size: size, shouldUseNewLogoDesign: shouldUseNewLogoDesign, ...props })=>{
        if ((0, $e6Qdr.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, $gWgPx.jsx)(NewComponent, {
            size: size || 'medium',
            ...props
        });
        return /*#__PURE__*/ (0, $gWgPx.jsx)(LegacyComponent, {
            size: size,
            ...props
        });
    };
};
const $a48eb45e1df34c41$export$436fcf6e31fbacea = (LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return ({ size: size, shouldUseNewLogoDesign: shouldUseNewLogoDesign, ...props })=>{
        if ((0, $e6Qdr.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, $gWgPx.jsx)(NewComponent, {
            size: size || 'medium',
            ...props
        });
        return /*#__PURE__*/ (0, $gWgPx.jsx)(LegacyComponent, {
            size: size,
            ...props
        });
    };
};
const $a48eb45e1df34c41$export$2469203854060337 = (LegacyComponent, NewComponent, NewHexComponent)=>{
    const RovoHexWrapped = $a48eb45e1df34c41$export$667425256e2e7296(NewHexComponent);
    const RovoServiceCollectionWrapped = $a48eb45e1df34c41$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return ({ shouldUseHexLogo: shouldUseHexLogo, ...props })=>{
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $e6Qdr.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, $gWgPx.jsx)(RovoHexWrapped, {
            ...props
        });
        else return /*#__PURE__*/ (0, $gWgPx.jsx)(RovoServiceCollectionWrapped, {
            ...props
        });
    };
};
const $a48eb45e1df34c41$export$667425256e2e7296 = (NewComponent)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $gWgPx.jsx)(NewComponent, {
            size: size || 'medium',
            ...props
        });
    };
};
const $a48eb45e1df34c41$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'feedback',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
const $a48eb45e1df34c41$export$62e1212796a86b1b = $a48eb45e1df34c41$export$172fd793eb6ecac4.filter((logo)=>logo.category === 'program' && !logo.skipExample).map((logo)=>logo.name);
const $a48eb45e1df34c41$export$e0dee4a765830f4d = $a48eb45e1df34c41$export$172fd793eb6ecac4.filter((logo)=>logo.category === 'app' && !logo.skipExample).map((logo)=>logo.name);
const $a48eb45e1df34c41$export$a13ce90e90d7bfc1 = $a48eb45e1df34c41$export$172fd793eb6ecac4.filter((logo)=>logo.category === 'agent' && !logo.skipExample).map((logo)=>logo.name) || [];
const $a48eb45e1df34c41$export$516fce44c502c1d3 = $a48eb45e1df34c41$export$172fd793eb6ecac4.filter((logo)=>logo.type === 'legacy');
const $a48eb45e1df34c41$export$b805fae8e798ed39 = $a48eb45e1df34c41$export$172fd793eb6ecac4.filter((logo)=>logo.type === 'migration');
const $a48eb45e1df34c41$export$3f9abd26214cd85f = $a48eb45e1df34c41$export$172fd793eb6ecac4.filter((logo)=>logo.type === 'new');

});


parcelRegister("iqc8I", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $221ab878d59f5c56$export$ef8e5f836dd989d3);
$parcel$export(module.exports, "AssetsIcon", () => $221ab878d59f5c56$export$d89497e7f33ca6f5);
$parcel$export(module.exports, "ChatIcon", () => $221ab878d59f5c56$export$52cd484a7ef4f2b9);
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $221ab878d59f5c56$export$6da5aa77c402ba0f);
$parcel$export(module.exports, "FeedbackIcon", () => $221ab878d59f5c56$export$34420f0520b19b1d);
$parcel$export(module.exports, "GoalsIcon", () => $221ab878d59f5c56$export$9eb74917ea768ed4);
$parcel$export(module.exports, "HomeIcon", () => $221ab878d59f5c56$export$92c8767b874048d);
$parcel$export(module.exports, "HubIcon", () => $221ab878d59f5c56$export$80b8b269d8b5014e);
$parcel$export(module.exports, "ProjectsIcon", () => $221ab878d59f5c56$export$5ed3e1bb3b04fc02);
$parcel$export(module.exports, "RovoDevIcon", () => $221ab878d59f5c56$export$8b784b3227531b3e);
$parcel$export(module.exports, "SearchIcon", () => $221ab878d59f5c56$export$82eafebb825fc23f);
$parcel$export(module.exports, "StudioIcon", () => $221ab878d59f5c56$export$290a0f24614cde9f);
$parcel$export(module.exports, "TalentIcon", () => $221ab878d59f5c56$export$4b05688514531169);
$parcel$export(module.exports, "TeamsIcon", () => $221ab878d59f5c56$export$1bcbc9c337da86da);
$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $221ab878d59f5c56$export$c42ad8a0b925c762);
$parcel$export(module.exports, "BitbucketIcon", () => $221ab878d59f5c56$export$5fc1066e677788d4);
$parcel$export(module.exports, "CompassIcon", () => $221ab878d59f5c56$export$f7857fe64d7161d9);
$parcel$export(module.exports, "DxIcon", () => $221ab878d59f5c56$export$9951d02c2d848122);
$parcel$export(module.exports, "ConfluenceIcon", () => $221ab878d59f5c56$export$68f3db7f6af48bcb);
$parcel$export(module.exports, "ConfluenceLogo", () => $221ab878d59f5c56$export$1b2e4fe6ef471556);
$parcel$export(module.exports, "JiraIcon", () => $221ab878d59f5c56$export$c4b5b1f965d8b3eb);
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $221ab878d59f5c56$export$21bfbeb62fdcce8d);
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $221ab878d59f5c56$export$3c6158790f5e01c4);
$parcel$export(module.exports, "JiraServiceManagementLogo", () => $221ab878d59f5c56$export$dabef2be6cd28c20);
$parcel$export(module.exports, "LoomIcon", () => $221ab878d59f5c56$export$8d789f76fde3e05);
$parcel$export(module.exports, "OpsgenieIcon", () => $221ab878d59f5c56$export$eeccc49dc7a12d9f);
$parcel$export(module.exports, "StatuspageIcon", () => $221ab878d59f5c56$export$f3f5aa321d88adf9);
$parcel$export(module.exports, "TrelloIcon", () => $221ab878d59f5c56$export$4384da9b8b140bf4);
$parcel$export(module.exports, "RovoIcon", () => $221ab878d59f5c56$export$e23ae35269442b4f);
$parcel$export(module.exports, "GuardIcon", () => $221ab878d59f5c56$export$3f95fcfdc25a741d);
$parcel$export(module.exports, "FocusIcon", () => $221ab878d59f5c56$export$1e02e7298035a77c);

var $47ETp = parcelRequire("47ETp");
var $eDmuc = parcelRequire("eDmuc");

var $7dOmi = parcelRequire("7dOmi");
var $7eeA5 = parcelRequire("7eeA5");

var $l6GJT = parcelRequire("l6GJT");
var $bRn3a = parcelRequire("bRn3a");

var $258cb = parcelRequire("258cb");
var $2Sam1 = parcelRequire("2Sam1");

var $f35G6 = parcelRequire("f35G6");
var $bTKdG = parcelRequire("bTKdG");

var $fXu9e = parcelRequire("fXu9e");
var $69iqG = parcelRequire("69iqG");

var $2ZzSO = parcelRequire("2ZzSO");
var $9XgOP = parcelRequire("9XgOP");

var $fEn7I = parcelRequire("fEn7I");
var $2PLNd = parcelRequire("2PLNd");

var $2OPm3 = parcelRequire("2OPm3");
var $2Y4q6 = parcelRequire("2Y4q6");

var $ddWFJ = parcelRequire("ddWFJ");
var $7yoZ8 = parcelRequire("7yoZ8");

var $fqX5E = parcelRequire("fqX5E");
var $ac987 = parcelRequire("ac987");

var $eDkW5 = parcelRequire("eDkW5");
var $jYIsB = parcelRequire("jYIsB");

var $aEhtI = parcelRequire("aEhtI");
var $jlhr7 = parcelRequire("jlhr7");

var $5yL6b = parcelRequire("5yL6b");

var $kpwVN = parcelRequire("kpwVN");
var $xfaZf = parcelRequire("xfaZf");

var $gVCex = parcelRequire("gVCex");
var $6IXGz = parcelRequire("6IXGz");

var $6dxH6 = parcelRequire("6dxH6");
var $5XE4V = parcelRequire("5XE4V");

var $9PnkW = parcelRequire("9PnkW");
var $3vMqw = parcelRequire("3vMqw");

var $dAO4a = parcelRequire("dAO4a");
var $3lNmr = parcelRequire("3lNmr");

var $5WT6T = parcelRequire("5WT6T");
var $cenZ8 = parcelRequire("cenZ8");

var $2XkL8 = parcelRequire("2XkL8");
var $iLjJ0 = parcelRequire("iLjJ0");

var $gU8rW = parcelRequire("gU8rW");
var $ixg9b = parcelRequire("ixg9b");

var $hk0ii = parcelRequire("hk0ii");
var $6Ff7b = parcelRequire("6Ff7b");

var $luAfM = parcelRequire("luAfM");
var $l89mj = parcelRequire("l89mj");

var $a5Yd7 = parcelRequire("a5Yd7");
var $hcwwB = parcelRequire("hcwwB");

var $ahOlk = parcelRequire("ahOlk");
var $eMfNl = parcelRequire("eMfNl");

var $5trRr = parcelRequire("5trRr");

var $gUomn = parcelRequire("gUomn");
var $eCF4x = parcelRequire("eCF4x");

var $iwdJv = parcelRequire("iwdJv");
var $9qNbO = parcelRequire("9qNbO");

var $gLetH = parcelRequire("gLetH");
var $cBbN4 = parcelRequire("cBbN4");

var $c4g4i = parcelRequire("c4g4i");
var $gJmXR = parcelRequire("gJmXR");

var $5yBq3 = parcelRequire("5yBq3");
var $jqFtz = parcelRequire("jqFtz");

var $iSa43 = parcelRequire("iSa43");
var $ctN6v = parcelRequire("ctN6v");

var $gVjB7 = parcelRequire("gVjB7");
var $anyTu = parcelRequire("anyTu");

var $av5aD = parcelRequire("av5aD");
var $balIc = parcelRequire("balIc");

var $dleYF = parcelRequire("dleYF");
var $i9nDJ = parcelRequire("i9nDJ");

var $cts1P = parcelRequire("cts1P");
var $6Z5Nx = parcelRequire("6Z5Nx");

var $fVAYe = parcelRequire("fVAYe");
var $lNNY7 = parcelRequire("lNNY7");

var $78xTM = parcelRequire("78xTM");
var $33sk5 = parcelRequire("33sk5");

var $faLSo = parcelRequire("faLSo");
var $6bWza = parcelRequire("6bWza");

var $je4UV = parcelRequire("je4UV");
var $cDrci = parcelRequire("cDrci");

var $8pCVo = parcelRequire("8pCVo");
var $1nNX0 = parcelRequire("1nNX0");

var $h5TI4 = parcelRequire("h5TI4");
var $jkcNn = parcelRequire("jkcNn");

var $lLj7Z = parcelRequire("lLj7Z");
var $geqXx = parcelRequire("geqXx");

var $kbKgV = parcelRequire("kbKgV");
var $leh3B = parcelRequire("leh3B");

var $b9F5i = parcelRequire("b9F5i");
var $iODG9 = parcelRequire("iODG9");

var $jOI6e = parcelRequire("jOI6e");
var $81dBD = parcelRequire("81dBD");

var $7kkSC = parcelRequire("7kkSC");
var $43bfp = parcelRequire("43bfp");

var $72YWo = parcelRequire("72YWo");
var $2R4Kr = parcelRequire("2R4Kr");

var $9sGEd = parcelRequire("9sGEd");
var $625YQ = parcelRequire("625YQ");

var $90Zqf = parcelRequire("90Zqf");
var $88dLv = parcelRequire("88dLv");

var $aVO0N = parcelRequire("aVO0N");
var $hM7Mq = parcelRequire("hM7Mq");

var $iTjUA = parcelRequire("iTjUA");
var $eh2n8 = parcelRequire("eh2n8");

var $5nH7l = parcelRequire("5nH7l");
var $1G1Km = parcelRequire("1G1Km");

var $iY3g5 = parcelRequire("iY3g5");
var $1mdd1 = parcelRequire("1mdd1");

var $ibxD9 = parcelRequire("ibxD9");
var $ktpkh = parcelRequire("ktpkh");

var $hEYed = parcelRequire("hEYed");
var $6H0qF = parcelRequire("6H0qF");

var $hDUTZ = parcelRequire("hDUTZ");
var $e7f5q = parcelRequire("e7f5q");




var $1UCp0 = parcelRequire("1UCp0");

var $hXRSF = parcelRequire("hXRSF");

var $k7u8y = parcelRequire("k7u8y");

var $fiJGd = parcelRequire("fiJGd");
const $221ab878d59f5c56$export$ef8e5f836dd989d3 = (0, $fiJGd.tempSizeWrapper)((0, $47ETp.AdminIcon));
const $221ab878d59f5c56$export$ebcd30672e67406 = (0, $fiJGd.tempSizeWrapper)((0, $eDmuc.AdminLogoCS));
const $221ab878d59f5c56$export$af3460f51ce3602a = (0, $fiJGd.tempSizeWrapper)((0, $l6GJT.AnalyticsIcon));
const $221ab878d59f5c56$export$c8415b6abe4a8587 = (0, $fiJGd.tempSizeWrapper)((0, $bRn3a.AnalyticsLogoCS));
const $221ab878d59f5c56$export$d89497e7f33ca6f5 = (0, $fiJGd.tempSizeWrapper)((0, $258cb.AssetsIcon));
const $221ab878d59f5c56$export$48ca930f3071e3e4 = (0, $fiJGd.tempSizeWrapper)((0, $2Sam1.AssetsLogoCS));
const $221ab878d59f5c56$export$52cd484a7ef4f2b9 = (0, $fiJGd.tempSizeWrapper)((0, $fEn7I.ChatIcon));
const $221ab878d59f5c56$export$9ca9881809919df8 = (0, $fiJGd.tempSizeWrapper)((0, $2PLNd.ChatLogoCS));
const $221ab878d59f5c56$export$6da5aa77c402ba0f = (0, $fiJGd.tempSizeWrapper)((0, $aEhtI.CustomerServiceManagementIcon));
const $221ab878d59f5c56$export$abc95e6180bb1d88 = (0, $fiJGd.tempSizeWrapper)((0, $jlhr7.CustomerServiceManagementLogoCS));
const $221ab878d59f5c56$export$34420f0520b19b1d = (0, $fiJGd.tempSizeWrapper)((0, $kpwVN.FeedbackIcon));
const $221ab878d59f5c56$export$c9696eb3c34c5a96 = (0, $fiJGd.tempSizeWrapper)((0, $xfaZf.FeedbackLogoCS));
const $221ab878d59f5c56$export$9eb74917ea768ed4 = (0, $fiJGd.tempSizeWrapper)((0, $6dxH6.GoalsIcon));
const $221ab878d59f5c56$export$d2577aa28451395f = (0, $fiJGd.tempSizeWrapper)((0, $5XE4V.GoalsLogoCS));
const $221ab878d59f5c56$export$92c8767b874048d = (0, $fiJGd.tempSizeWrapper)((0, $dAO4a.HomeIcon));
const $221ab878d59f5c56$export$d5648119d5b68e90 = (0, $fiJGd.tempSizeWrapper)((0, $3lNmr.HomeLogoCS));
const $221ab878d59f5c56$export$80b8b269d8b5014e = (0, $fiJGd.tempSizeWrapper)((0, $5WT6T.HubIcon));
const $221ab878d59f5c56$export$fc9bd6687b80fe3b = (0, $fiJGd.tempSizeWrapper)((0, $cenZ8.HubLogoCS));
const $221ab878d59f5c56$export$5ed3e1bb3b04fc02 = (0, $fiJGd.tempSizeWrapper)((0, $gLetH.ProjectsIcon));
const $221ab878d59f5c56$export$aeefab651bcf2338 = (0, $fiJGd.tempSizeWrapper)((0, $cBbN4.ProjectsLogoCS));
const $221ab878d59f5c56$export$8b784b3227531b3e = (0, $fiJGd.tempSizeWrapper)((0, $5yBq3.RovoDevIcon));
const $221ab878d59f5c56$export$f0750468d67c6902 = (0, $fiJGd.tempSizeWrapper)((0, $jqFtz.RovoDevLogoCS));
const $221ab878d59f5c56$export$813cff80931d9dbf = (0, $fiJGd.tempSizeWrapper)((0, $iSa43.RovoDevAgentIcon));
const $221ab878d59f5c56$export$409b7a5b7f180eba = (0, $fiJGd.tempSizeWrapper)((0, $ctN6v.RovoDevAgentLogoCS));
const $221ab878d59f5c56$export$82eafebb825fc23f = (0, $fiJGd.tempSizeWrapper)((0, $av5aD.SearchIcon));
const $221ab878d59f5c56$export$e4c5487c9a8ae3b1 = (0, $fiJGd.tempSizeWrapper)((0, $balIc.SearchLogoCS));
const $221ab878d59f5c56$export$290a0f24614cde9f = (0, $fiJGd.tempSizeWrapper)((0, $cts1P.StudioIcon));
const $221ab878d59f5c56$export$8aceb78c659789b6 = (0, $fiJGd.tempSizeWrapper)((0, $6Z5Nx.StudioLogoCS));
const $221ab878d59f5c56$export$4b05688514531169 = (0, $fiJGd.tempSizeWrapper)((0, $fVAYe.TalentIcon));
const $221ab878d59f5c56$export$4f6453e012279f89 = (0, $fiJGd.tempSizeWrapper)((0, $lNNY7.TalentLogoCS));
const $221ab878d59f5c56$export$1bcbc9c337da86da = (0, $fiJGd.tempSizeWrapper)((0, $78xTM.TeamsIcon));
const $221ab878d59f5c56$export$9b1a0a0c574cec2a = (0, $fiJGd.tempSizeWrapper)((0, $33sk5.TeamsLogoCS));
const $221ab878d59f5c56$export$e812398311cab9a3 = (0, $fiJGd.tempSizeWrapper)((0, $f35G6.BambooIcon));
const $221ab878d59f5c56$export$765f5afcc1a5a7e3 = (0, $fiJGd.tempSizeWrapper)((0, $bTKdG.BambooLogoCS));
const $221ab878d59f5c56$export$d3ab16bbf4f954ee = (0, $fiJGd.tempSizeWrapper)((0, $2ZzSO.BitbucketDataCenterIcon));
const $221ab878d59f5c56$export$36044946916e84a0 = (0, $fiJGd.tempSizeWrapper)((0, $9XgOP.BitbucketDataCenterLogoCS));
const $221ab878d59f5c56$export$53305f1f2855d3be = (0, $fiJGd.tempSizeWrapper)((0, $fqX5E.ConfluenceDataCenterIcon));
const $221ab878d59f5c56$export$5e06396bce773a3 = (0, $fiJGd.tempSizeWrapper)((0, $ac987.ConfluenceDataCenterLogoCS));
const $221ab878d59f5c56$export$eaf73f391f7103bd = (0, $fiJGd.tempSizeWrapper)((0, $eDkW5.CrowdIcon));
const $221ab878d59f5c56$export$6128b385660fd3c6 = (0, $fiJGd.tempSizeWrapper)((0, $jYIsB.CrowdLogoCS));
const $221ab878d59f5c56$export$f8455b5667a3ee0c = (0, $fiJGd.tempSizeWrapper)((0, $gU8rW.JiraDataCenterIcon));
const $221ab878d59f5c56$export$eb152ab3801b2ae3 = (0, $fiJGd.tempSizeWrapper)((0, $ixg9b.JiraDataCenterLogoCS));
const $221ab878d59f5c56$export$65fae0eaf343f2ca = (0, $fiJGd.tempSizeWrapper)((0, $a5Yd7.JiraServiceManagementDataCenterIcon));
const $221ab878d59f5c56$export$fffc0d480fb1ebf1 = (0, $fiJGd.tempSizeWrapper)((0, $hcwwB.JiraServiceManagementDataCenterLogoCS));
const $221ab878d59f5c56$export$74517ed253186308 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $8pCVo.AtlassianAdministrationIcon), (0, $47ETp.AdminIcon));
const $221ab878d59f5c56$export$833abe6c2ce5ebfd = (0, $fiJGd.createFeatureFlaggedComponent)((0, $1nNX0.AtlassianAdministrationLogo), (0, $eDmuc.AdminLogoCS));
const $221ab878d59f5c56$export$84109e099492cb5f = (0, $fiJGd.createFeatureFlaggedComponent)((0, $je4UV.AtlassianAdminIcon), (0, $47ETp.AdminIcon));
const $221ab878d59f5c56$export$f845d9b9254f0541 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $cDrci.AtlassianAdminLogo), (0, $eDmuc.AdminLogoCS));
const $221ab878d59f5c56$export$c42ad8a0b925c762 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $h5TI4.AtlassianAnalyticsIcon), (0, $l6GJT.AnalyticsIcon));
const $221ab878d59f5c56$export$e6470bfc39010cc4 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $jkcNn.AtlassianAnalyticsLogo), (0, $bRn3a.AnalyticsLogoCS));
const $221ab878d59f5c56$export$5fc1066e677788d4 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $lLj7Z.BitbucketIcon), (0, $fXu9e.BitbucketIcon));
const $221ab878d59f5c56$export$bd40525f5333524b = (0, $fiJGd.createFeatureFlaggedComponent)((0, $geqXx.BitbucketLogo), (0, $69iqG.BitbucketLogoCS));
const $221ab878d59f5c56$export$f7857fe64d7161d9 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $kbKgV.CompassIcon), (0, $2OPm3.CompassIcon));
const $221ab878d59f5c56$export$eb7d748e4f9c9676 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $leh3B.CompassLogo), (0, $2Y4q6.CompassLogoCS));
const $221ab878d59f5c56$export$9951d02c2d848122 = (0, $fiJGd.tempSizeWrapper)((0, $5yL6b.DxIcon));
const $221ab878d59f5c56$export$68f3db7f6af48bcb = (0, $fiJGd.createFeatureFlaggedComponent)((0, $b9F5i.ConfluenceIcon), (0, $ddWFJ.ConfluenceIcon));
const $221ab878d59f5c56$export$1b2e4fe6ef471556 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $iODG9.ConfluenceLogo), (0, $7yoZ8.ConfluenceLogoCS));
const $221ab878d59f5c56$export$70a0c2f5862937b6 = (0, $fiJGd.tempSizeWrapper)((0, $7dOmi.AlignIcon));
const $221ab878d59f5c56$export$1b8596b4b0ef673b = (0, $fiJGd.tempSizeWrapper)((0, $7eeA5.AlignLogoCS));
const $221ab878d59f5c56$export$407687b2dd89cc68 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $9sGEd.JiraAlignIcon), (0, $7dOmi.AlignIcon));
const $221ab878d59f5c56$export$ee11e928d3d045fd = (0, $fiJGd.createFeatureFlaggedComponent)((0, $625YQ.JiraAlignLogo), (0, $7eeA5.AlignLogoCS));
const $221ab878d59f5c56$export$c4b5b1f965d8b3eb = (0, $fiJGd.createFeatureFlaggedComponent)((0, $72YWo.JiraIcon), (0, $2XkL8.JiraIcon));
const $221ab878d59f5c56$export$17d3acb0b4379d02 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $2R4Kr.JiraLogo), (0, $iLjJ0.JiraLogoCS));
const $221ab878d59f5c56$export$21bfbeb62fdcce8d = (0, $fiJGd.createFeatureFlaggedComponent)((0, $90Zqf.JiraProductDiscoveryIcon), (0, $hk0ii.JiraProductDiscoveryIcon));
const $221ab878d59f5c56$export$c49a2b642fe9eef4 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $88dLv.JiraProductDiscoveryLogo), (0, $6Ff7b.JiraProductDiscoveryLogoCS));
const $221ab878d59f5c56$export$3c6158790f5e01c4 = (0, $fiJGd.createFeatureFlaggedServiceCollectionComponent)((0, $aVO0N.JiraServiceManagementIcon), (0, $luAfM.JiraServiceManagementIcon));
const $221ab878d59f5c56$export$dabef2be6cd28c20 = (0, $fiJGd.createFeatureFlaggedServiceCollectionComponent)((0, $hM7Mq.JiraServiceManagementLogo), (0, $l89mj.JiraServiceManagementLogoCS));
const $221ab878d59f5c56$export$8d789f76fde3e05 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $iTjUA.LoomIcon), (0, $ahOlk.LoomIcon));
const $221ab878d59f5c56$export$94e206806e36c2ec = (0, $fiJGd.createFeatureFlaggedComponent)((0, $eh2n8.LoomLogo), (0, $eMfNl.LoomLogoCS));
const $221ab878d59f5c56$export$1bf47cdade1a9fcb = (0, $fiJGd.createFeatureFlaggedComponent)((0, $5nH7l.LoomAttributionIcon), (0, $ahOlk.LoomIcon));
const $221ab878d59f5c56$export$6e87ce8d41eda665 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $1G1Km.LoomAttributionLogo), (0, $5trRr.LoomAttributionLogoCS));
const $221ab878d59f5c56$export$e84e925618e0e5bc = (0, $fiJGd.tempSizeWrapper)((0, $eCF4x.LoomInternalLogoCS));
const $221ab878d59f5c56$export$1940ba72c868b663 = (0, $fiJGd.tempSizeWrapper)((0, $gUomn.LoomInternalIcon));
const $221ab878d59f5c56$export$eeccc49dc7a12d9f = (0, $fiJGd.createFeatureFlaggedServiceCollectionComponent)((0, $iY3g5.OpsgenieIcon), (0, $iwdJv.OpsgenieIcon));
const $221ab878d59f5c56$export$a1c6484cdecc2c4b = (0, $fiJGd.createFeatureFlaggedServiceCollectionComponent)((0, $1mdd1.OpsgenieLogo), (0, $9qNbO.OpsgenieLogoCS));
const $221ab878d59f5c56$export$f3f5aa321d88adf9 = (0, $fiJGd.createFeatureFlaggedServiceCollectionComponent)((0, $hEYed.StatuspageIcon), (0, $dleYF.StatuspageIcon));
const $221ab878d59f5c56$export$bb4ae5b41b43be04 = (0, $fiJGd.createFeatureFlaggedServiceCollectionComponent)((0, $6H0qF.StatuspageLogo), (0, $i9nDJ.StatuspageLogoCS));
const $221ab878d59f5c56$export$4384da9b8b140bf4 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $hDUTZ.TrelloIcon), (0, $faLSo.TrelloIcon));
const $221ab878d59f5c56$export$60e26212f3b61a28 = (0, $fiJGd.createFeatureFlaggedComponent)((0, $e7f5q.TrelloLogo), (0, $6bWza.TrelloLogoCS));
const $221ab878d59f5c56$export$e23ae35269442b4f = (0, $fiJGd.createFeatureFlaggedRovoComponent)((0, $ibxD9.RovoIcon), (0, $c4g4i.RovoIcon), (0, $gVjB7.RovoHexIcon));
const $221ab878d59f5c56$export$a0f6cb8061290bbb = (0, $fiJGd.createFeatureFlaggedRovoComponent)((0, $ktpkh.RovoLogo), (0, $gJmXR.RovoLogoCS), (0, $anyTu.RovoHexLogoCS));
const $221ab878d59f5c56$export$3f95fcfdc25a741d = (0, $fiJGd.createFeatureFlaggedComponent)((0, $7kkSC.GuardIcon), (0, $9PnkW.GuardIcon));
const $221ab878d59f5c56$export$a4a891d202775deb = (0, $fiJGd.createFeatureFlaggedComponent)((0, $43bfp.GuardLogo), (0, $3vMqw.GuardLogoCS));
const $221ab878d59f5c56$export$1e02e7298035a77c = (0, $fiJGd.createFeatureFlaggedComponent)((0, $jOI6e.FocusIcon), (0, $gVCex.FocusIcon));
const $221ab878d59f5c56$export$33908560ea1b226d = (0, $fiJGd.createFeatureFlaggedComponent)((0, $81dBD.FocusLogo), (0, $6IXGz.FocusLogoCS));

});
parcelRegister("47ETp", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $8c713d1476505b9f$export$ef8e5f836dd989d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $8c713d1476505b9f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25" clip-rule="evenodd"/>
</svg>
`;
function $8c713d1476505b9f$export$ef8e5f836dd989d3({ size: size, appearance: appearance = 'brand', label: label = 'Admin', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $8c713d1476505b9f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eDmuc", function(module, exports) {
$parcel$export(module.exports, "AdminLogoCS", () => $0cf59a8e1656a09c$export$61afcb38c001e19);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $0cf59a8e1656a09c$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179" clip-rule="evenodd"/>
</svg>
`;
function $0cf59a8e1656a09c$export$61afcb38c001e19({ size: size, appearance: appearance = 'brand', label: label = 'Admin', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $0cf59a8e1656a09c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("bBB9h", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", () => $844c42fb17362964$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $e6Qdr = parcelRequire("e6Qdr");

var $kHnjK = parcelRequire("kHnjK");
const $844c42fb17362964$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $844c42fb17362964$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
const $844c42fb17362964$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $844c42fb17362964$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $844c42fb17362964$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $844c42fb17362964$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $844c42fb17362964$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $844c42fb17362964$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $844c42fb17362964$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $844c42fb17362964$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $844c42fb17362964$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $844c42fb17362964$export$f827d3c5a9c3f644({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $8n1kL.default)([
            $844c42fb17362964$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $844c42fb17362964$var$logoTextColorMap[colorMode ?? 'light'],
            $844c42fb17362964$var$sizeMap[size],
            colorMode === 'dark' ? $844c42fb17362964$var$textDarkAppearanceMap[appearance] : $844c42fb17362964$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $844c42fb17362964$var$dataCenterDarkAppearanceMap[appearance] : $844c42fb17362964$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $844c42fb17362964$var$rovoDarkAppearanceMap[appearance] : $844c42fb17362964$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $844c42fb17362964$var$cloudDarkAppearanceMap[appearance] : $844c42fb17362964$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && (0, $e6Qdr.fg)('assets-platform-branding') && $844c42fb17362964$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("7dOmi", function(module, exports) {
$parcel$export(module.exports, "AlignIcon", () => $daaf3c49a8f2be96$export$70a0c2f5862937b6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $daaf3c49a8f2be96$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z"/>
</svg>
`;
function $daaf3c49a8f2be96$export$70a0c2f5862937b6({ size: size, appearance: appearance = 'brand', label: label = 'Align', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $daaf3c49a8f2be96$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7eeA5", function(module, exports) {
$parcel$export(module.exports, "AlignLogoCS", () => $43bf2965f68842c7$export$8b5103382c06639c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $43bf2965f68842c7$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z"/>
</svg>
`;
function $43bf2965f68842c7$export$8b5103382c06639c({ size: size, appearance: appearance = 'brand', label: label = 'Align', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $43bf2965f68842c7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("l6GJT", function(module, exports) {
$parcel$export(module.exports, "AnalyticsIcon", () => $c3b655e191c9fb2c$export$af3460f51ce3602a);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $c3b655e191c9fb2c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z"/>
</svg>
`;
function $c3b655e191c9fb2c$export$af3460f51ce3602a({ size: size, appearance: appearance = 'brand', label: label = 'Analytics', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $c3b655e191c9fb2c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bRn3a", function(module, exports) {
$parcel$export(module.exports, "AnalyticsLogoCS", () => $911915277c1749cc$export$f0bac2b7ac3e3504);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $911915277c1749cc$var$svg = `<svg height="100%" viewBox="0 0 161 32">
    <path fill="var(--text-color, #1e1f21)" d="M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z"/>
</svg>
`;
function $911915277c1749cc$export$f0bac2b7ac3e3504({ size: size, appearance: appearance = 'brand', label: label = 'Analytics', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $911915277c1749cc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("258cb", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $fc7c8f3198d2f664$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $fc7c8f3198d2f664$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $fc7c8f3198d2f664$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function $fc7c8f3198d2f664$export$d89497e7f33ca6f5({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $fc7c8f3198d2f664$var$svg,
        customThemeSvg: $fc7c8f3198d2f664$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2Sam1", function(module, exports) {
$parcel$export(module.exports, "AssetsLogoCS", () => $f1223e8babc6c0c7$export$81c47abe19675c4c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $f1223e8babc6c0c7$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z"/>
</svg>
`;
function $f1223e8babc6c0c7$export$81c47abe19675c4c({ size: size, appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $f1223e8babc6c0c7$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("f35G6", function(module, exports) {
$parcel$export(module.exports, "BambooIcon", () => $16e7faf19da9b33f$export$e812398311cab9a3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $16e7faf19da9b33f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z"/>
</svg>
`;
function $16e7faf19da9b33f$export$e812398311cab9a3({ size: size, appearance: appearance = 'brand', label: label = 'Bamboo', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $16e7faf19da9b33f$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bTKdG", function(module, exports) {
$parcel$export(module.exports, "BambooLogoCS", () => $833d45edb9992890$export$7c51958462d750e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $833d45edb9992890$var$svg = `<svg height="100%" viewBox="0 0 154 32">
    <path fill="var(--text-color, #1e1f21)" d="M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z"/>
</svg>
`;
function $833d45edb9992890$export$7c51958462d750e({ size: size, appearance: appearance = 'brand', label: label = 'Bamboo', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $833d45edb9992890$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fXu9e", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $f439f8fa947ce6fc$export$5fc1066e677788d4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f439f8fa947ce6fc$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $f439f8fa947ce6fc$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
function $f439f8fa947ce6fc$export$5fc1066e677788d4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $f439f8fa947ce6fc$var$svg,
        customThemeSvg: $f439f8fa947ce6fc$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("69iqG", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogoCS", () => $e8561b20b4d57c64$export$f7ef5e5488e4b430);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $e8561b20b4d57c64$var$svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771"/>
</svg>
`;
function $e8561b20b4d57c64$export$f7ef5e5488e4b430({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $e8561b20b4d57c64$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2ZzSO", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterIcon", () => $e0eb90812320091b$export$d3ab16bbf4f954ee);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e0eb90812320091b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578"/>
</svg>
`;
function $e0eb90812320091b$export$d3ab16bbf4f954ee({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $e0eb90812320091b$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9XgOP", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterLogoCS", () => $b1a23069f041510f$export$cc55e2a4c4b40552);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b1a23069f041510f$var$svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771"/>
</svg>
`;
function $b1a23069f041510f$export$cc55e2a4c4b40552({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $b1a23069f041510f$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fEn7I", function(module, exports) {
$parcel$export(module.exports, "ChatIcon", () => $321bb6b253dc3259$export$52cd484a7ef4f2b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2ff2e36e1653e53734b97e7db9892da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $321bb6b253dc3259$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z" clip-rule="evenodd"/>
</svg>
`;
function $321bb6b253dc3259$export$52cd484a7ef4f2b9({ size: size, appearance: appearance = 'brand', label: label = 'Chat', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $321bb6b253dc3259$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2PLNd", function(module, exports) {
$parcel$export(module.exports, "ChatLogoCS", () => $4a949c4c647801a8$export$a529e78951cd6709);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c1cf578ed3b2b56aa2f85ac93abd2ba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4a949c4c647801a8$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z" clip-rule="evenodd"/>
</svg>
`;
function $4a949c4c647801a8$export$a529e78951cd6709({ size: size, appearance: appearance = 'brand', label: label = 'Chat', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $4a949c4c647801a8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2OPm3", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $4c1473bb91315cb8$export$f7857fe64d7161d9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $4c1473bb91315cb8$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
function $4c1473bb91315cb8$export$f7857fe64d7161d9({ size: size, appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $4c1473bb91315cb8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2Y4q6", function(module, exports) {
$parcel$export(module.exports, "CompassLogoCS", () => $8e7dba4bd8243e24$export$a16f50a81d183ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $8e7dba4bd8243e24$var$svg = `<svg height="100%" viewBox="0 0 162 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z"/>
</svg>
`;
function $8e7dba4bd8243e24$export$a16f50a81d183ce({ size: size, appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $8e7dba4bd8243e24$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7yoZ8", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoCS", () => $6e48da16b464ec8f$export$a88b0b0da9ef63ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $6e48da16b464ec8f$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>
</svg>
`;
function $6e48da16b464ec8f$export$a88b0b0da9ef63ce({ size: size, appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $6e48da16b464ec8f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fqX5E", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterIcon", () => $257185f86d7f3844$export$53305f1f2855d3be);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $257185f86d7f3844$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617"/>
</svg>
`;
function $257185f86d7f3844$export$53305f1f2855d3be({ size: size, appearance: appearance = 'brand', label: label = 'Confluence Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $257185f86d7f3844$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ac987", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", () => $dc2bc6abf96c7bd3$export$b3e508cb103e1f93);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $dc2bc6abf96c7bd3$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823"/>
</svg>
`;
function $dc2bc6abf96c7bd3$export$b3e508cb103e1f93({ size: size, appearance: appearance = 'brand', label: label = 'Confluence Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $dc2bc6abf96c7bd3$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eDkW5", function(module, exports) {
$parcel$export(module.exports, "CrowdIcon", () => $496cd59aef660181$export$eaf73f391f7103bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $496cd59aef660181$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433"/>
</svg>
`;
function $496cd59aef660181$export$eaf73f391f7103bd({ size: size, appearance: appearance = 'brand', label: label = 'Crowd', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $496cd59aef660181$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jYIsB", function(module, exports) {
$parcel$export(module.exports, "CrowdLogoCS", () => $9ecab3d5090763db$export$3c371bdbcdfcdce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $9ecab3d5090763db$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577"/>
</svg>
`;
function $9ecab3d5090763db$export$3c371bdbcdfcdce({ size: size, appearance: appearance = 'brand', label: label = 'Crowd', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $9ecab3d5090763db$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aEhtI", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $4395c58748334d37$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $4395c58748334d37$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $4395c58748334d37$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function $4395c58748334d37$export$6da5aa77c402ba0f({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $4395c58748334d37$var$svg,
        customThemeSvg: $4395c58748334d37$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jlhr7", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementLogoCS", () => $7943519502b0aede$export$f597f0f7fadce0b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $7943519502b0aede$var$svg = `<svg height="100%" viewBox="0 0 456 32">
    <path fill="var(--text-color, #1e1f21)" d="M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z"/>
</svg>
`;
function $7943519502b0aede$export$f597f0f7fadce0b9({ size: size, appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $7943519502b0aede$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5yL6b", function(module, exports) {
$parcel$export(module.exports, "DxIcon", () => $1bc3a68a453d716a$export$9951d02c2d848122);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $1bc3a68a453d716a$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <path fill="var(--tile-color,#94c748)" d="M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z"/>
    <path fill="var(--icon-color, #101214)" d="m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z"/>
</svg>
`;
function $1bc3a68a453d716a$export$9951d02c2d848122({ size: size, appearance: appearance = 'brand', label: label = 'Dx', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $1bc3a68a453d716a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kpwVN", function(module, exports) {
$parcel$export(module.exports, "FeedbackIcon", () => $beda6c3346ee6e3c$export$34420f0520b19b1d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43275811237134a9433985263fbf7530>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $beda6c3346ee6e3c$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="var(--tile-color,#c97cf4)" rx="12"/>
    <path fill="var(--icon-color, #101214)" d="M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z"/>
</svg>
`;
function $beda6c3346ee6e3c$export$34420f0520b19b1d({ size: size, appearance: appearance = 'brand', label: label = 'Feedback', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $beda6c3346ee6e3c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("xfaZf", function(module, exports) {
$parcel$export(module.exports, "FeedbackLogoCS", () => $a1083e7f8f4fa122$export$bbccafb125ebd50c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e0dda3588cef089e80240144a089b0a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $a1083e7f8f4fa122$var$svg = `<svg height="100%" viewBox="0 0 169 32">
    <path fill="var(--text-color, #1e1f21)" d="M157.894 25.334h-2.638V3.59h2.638v13.585L164.487 10h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.177zm-5.648-2.761v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.489s1.656 5.49 5.674 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-16.09-7.666c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.502-4.478 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.698H107.4V3.592h2.637v9.17c.982-2.025 2.822-3.068 5.183-3.068 4.079 0 6.133 3.466 6.133 7.974 0 4.324-2.146 7.973-6.44 7.973m-22.806-7.974c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.963-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.013 4.876 3.006V3.59h2.638v21.743zM80.502 12.085c-2.79 0-4.201 1.81-4.477 4.478h8.555c-.153-2.852-1.44-4.478-4.078-4.478M86.39 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.625 3.282 6.625 7.943v1.196H76.055c.368 2.607 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zM64.42 12.085c-2.79 0-4.202 1.81-4.477 4.478h8.556c-.154-2.852-1.442-4.478-4.08-4.478m5.888 12.635c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.238-7.943 4.722 0 6.623 3.282 6.623 7.943v1.196H59.974c.368 2.607 2.055 4.293 5.674 4.293 1.778 0 3.28-.337 4.66-.828zm-15.679-6.9H45.49v7.514h-2.76V5.186h12.94v2.637H45.49v7.36h9.138z"/>
    <rect width="32" height="32" fill="var(--tile-color,#c97cf4)" rx="8"/>
    <path fill="var(--icon-color, #101214)" d="M13.333 12.667h3.334V20h-3.334zm4.667-6h3.333v18.666H18zm4.667 4H26v10.666h-3.333zm-14 0H12v10.666H8.667zM4 14h3.333v4.666H4z"/>
</svg>
`;
function $a1083e7f8f4fa122$export$bbccafb125ebd50c({ size: size, appearance: appearance = 'brand', label: label = 'Feedback', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $a1083e7f8f4fa122$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gVCex", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $4d026f3cd3d85f35$export$1e02e7298035a77c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $4d026f3cd3d85f35$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
function $4d026f3cd3d85f35$export$1e02e7298035a77c({ size: size, appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $4d026f3cd3d85f35$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6IXGz", function(module, exports) {
$parcel$export(module.exports, "FocusLogoCS", () => $48974bae2e2e727f$export$3a6e8b37e069a69d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $48974bae2e2e727f$var$svg = `<svg height="100%" viewBox="0 0 117 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z"/>
</svg>
`;
function $48974bae2e2e727f$export$3a6e8b37e069a69d({ size: size, appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $48974bae2e2e727f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6dxH6", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", () => $440269a5243f7cd0$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $440269a5243f7cd0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function $440269a5243f7cd0$export$9eb74917ea768ed4({ size: size, appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $440269a5243f7cd0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5XE4V", function(module, exports) {
$parcel$export(module.exports, "GoalsLogoCS", () => $11fdfed5c525dbf2$export$c527a545aa426db3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $11fdfed5c525dbf2$var$svg = `<svg height="100%" viewBox="0 0 116 32">
    <path fill="var(--text-color, #1e1f21)" d="M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0" clip-rule="evenodd"/>
</svg>
`;
function $11fdfed5c525dbf2$export$c527a545aa426db3({ size: size, appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $11fdfed5c525dbf2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9PnkW", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $34132d3e03b4b4ef$export$3f95fcfdc25a741d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $34132d3e03b4b4ef$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
function $34132d3e03b4b4ef$export$3f95fcfdc25a741d({ size: size, appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $34132d3e03b4b4ef$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3vMqw", function(module, exports) {
$parcel$export(module.exports, "GuardLogoCS", () => $f0ffdc4e823dadcd$export$2b896c4d595a4331);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $f0ffdc4e823dadcd$var$svg = `<svg height="100%" viewBox="0 0 120 32">
    <path fill="var(--text-color, #1e1f21)" d="M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778"/>
</svg>
`;
function $f0ffdc4e823dadcd$export$2b896c4d595a4331({ size: size, appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $f0ffdc4e823dadcd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dAO4a", function(module, exports) {
$parcel$export(module.exports, "HomeIcon", () => $72b1dbe755c7053b$export$92c8767b874048d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $72b1dbe755c7053b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>
</svg>
`;
function $72b1dbe755c7053b$export$92c8767b874048d({ size: size, appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $72b1dbe755c7053b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3lNmr", function(module, exports) {
$parcel$export(module.exports, "HomeLogoCS", () => $39ed6b6aa3327ad6$export$8b6b7f1b1b2367d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $39ed6b6aa3327ad6$var$svg = `<svg height="100%" viewBox="0 0 121 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z"/>
</svg>
`;
function $39ed6b6aa3327ad6$export$8b6b7f1b1b2367d3({ size: size, appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $39ed6b6aa3327ad6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5WT6T", function(module, exports) {
$parcel$export(module.exports, "HubIcon", () => $f3c09f6aad089120$export$80b8b269d8b5014e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f3c09f6aad089120$var$svg = `<svg height="100%" viewBox="0 0 32 32">
    <g clip-path="url(#clip0_95164_16219)">
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16219)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16219">
            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16219">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
function $f3c09f6aad089120$export$80b8b269d8b5014e({ size: size, appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $f3c09f6aad089120$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cenZ8", function(module, exports) {
$parcel$export(module.exports, "HubLogoCS", () => $041dd3177e49cf11$export$7a38180641471460);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $041dd3177e49cf11$var$svg = `<svg height="100%" viewBox="0 0 95 32">
    <path fill="var(--text-color, #1e1f21)" d="M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
</svg>
`;
function $041dd3177e49cf11$export$7a38180641471460({ size: size, appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $041dd3177e49cf11$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2XkL8", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $fb09f58655550071$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $fb09f58655550071$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $fb09f58655550071$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $fb09f58655550071$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $fb09f58655550071$var$svg,
        customThemeSvg: $fb09f58655550071$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iLjJ0", function(module, exports) {
$parcel$export(module.exports, "JiraLogoCS", () => $d758e72e204ca0f1$export$bf4c5f97b468e8d6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $d758e72e204ca0f1$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
function $d758e72e204ca0f1$export$bf4c5f97b468e8d6({ size: size, appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $d758e72e204ca0f1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gU8rW", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterIcon", () => $56271f71d3670db8$export$f8455b5667a3ee0c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $56271f71d3670db8$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z"/>
</svg>
`;
function $56271f71d3670db8$export$f8455b5667a3ee0c({ size: size, appearance: appearance = 'brand', label: label = 'Jira Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $56271f71d3670db8$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ixg9b", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterLogoCS", () => $f9d7e884f4f87206$export$3224b07bc93ef23e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $f9d7e884f4f87206$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
function $f9d7e884f4f87206$export$3224b07bc93ef23e({ size: size, appearance: appearance = 'brand', label: label = 'Jira Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $f9d7e884f4f87206$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hk0ii", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $7b9b66c1d3c92a13$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $7b9b66c1d3c92a13$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $7b9b66c1d3c92a13$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function $7b9b66c1d3c92a13$export$21bfbeb62fdcce8d({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $7b9b66c1d3c92a13$var$svg,
        customThemeSvg: $7b9b66c1d3c92a13$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6Ff7b", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", () => $6a6c5dc6bcd4b16d$export$602140a6a10b02bf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $6a6c5dc6bcd4b16d$var$svg = `<svg height="100%" viewBox="0 0 327 32">
    <path fill="var(--text-color, #1e1f21)" d="M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#c97cf4)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z"/>
</svg>
`;
function $6a6c5dc6bcd4b16d$export$602140a6a10b02bf({ size: size, appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $6a6c5dc6bcd4b16d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("luAfM", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $06b7458cf6209789$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $06b7458cf6209789$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $06b7458cf6209789$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $06b7458cf6209789$export$3c6158790f5e01c4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $06b7458cf6209789$var$svg,
        customThemeSvg: $06b7458cf6209789$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("l89mj", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoCS", () => $21a346d901b75eba$export$de148263c75d2bc1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $21a346d901b75eba$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function $21a346d901b75eba$export$de148263c75d2bc1({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $21a346d901b75eba$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("a5Yd7", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", () => $96b83f4bd0dc1d5c$export$65fae0eaf343f2ca);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $96b83f4bd0dc1d5c$var$svg = `<svg height="100%" viewBox="0 0 25 24">
    <path fill="var(--tile-color, white)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z"/>
</svg>
`;
function $96b83f4bd0dc1d5c$export$65fae0eaf343f2ca({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $96b83f4bd0dc1d5c$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hcwwB", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", () => $325966f32f992f93$export$f64bc7a7f04428d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $325966f32f992f93$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function $325966f32f992f93$export$f64bc7a7f04428d0({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $325966f32f992f93$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ahOlk", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $e3237fdf797e47e9$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e3237fdf797e47e9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $e3237fdf797e47e9$export$8d789f76fde3e05({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $e3237fdf797e47e9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eMfNl", function(module, exports) {
$parcel$export(module.exports, "LoomLogoCS", () => $5ea7d2b11f9338ac$export$78c0b4d8be34c9b2);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $5ea7d2b11f9338ac$var$svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
function $5ea7d2b11f9338ac$export$78c0b4d8be34c9b2({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $5ea7d2b11f9338ac$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5trRr", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogoCS", () => $f236ba7c15614a47$export$68d7391318cdef11);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $f236ba7c15614a47$var$svg = `<svg height="100%" viewBox="0 0 100 32">
    <path fill="var(--icon-color, #101214)" d="M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68"/>
</svg>
`;
function $f236ba7c15614a47$export$68d7391318cdef11({ size: size, appearance: appearance = 'brand', label: label = 'Loom Attribution', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $f236ba7c15614a47$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gUomn", function(module, exports) {
$parcel$export(module.exports, "LoomInternalIcon", () => $72326e4fdb315914$export$38c7b37a3e5e8d70);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $72326e4fdb315914$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#625df5)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $72326e4fdb315914$export$38c7b37a3e5e8d70({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $72326e4fdb315914$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eCF4x", function(module, exports) {
$parcel$export(module.exports, "LoomInternalLogoCS", () => $7f5d3220d4882339$export$71743a944cb62e48);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $7f5d3220d4882339$var$svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#625df5)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
function $7f5d3220d4882339$export$71743a944cb62e48({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $7f5d3220d4882339$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iwdJv", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $85f07cd70db7dee0$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $85f07cd70db7dee0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function $85f07cd70db7dee0$export$eeccc49dc7a12d9f({ size: size, appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $85f07cd70db7dee0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9qNbO", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogoCS", () => $175d2453ede875a4$export$a5b9122e89b32ad3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $175d2453ede875a4$var$svg = `<svg height="100%" viewBox="0 0 164 32">
    <path fill="var(--text-color, #1e1f21)" d="M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001"/>
</svg>
`;
function $175d2453ede875a4$export$a5b9122e89b32ad3({ size: size, appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $175d2453ede875a4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gLetH", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $a5021e8f91862690$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $a5021e8f91862690$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $a5021e8f91862690$export$5ed3e1bb3b04fc02({ size: size, appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $a5021e8f91862690$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cBbN4", function(module, exports) {
$parcel$export(module.exports, "ProjectsLogoCS", () => $562139218ff21c55$export$e3d1678155aaab99);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $562139218ff21c55$var$svg = `<svg height="100%" viewBox="0 0 145 32">
    <path fill="var(--text-color, #1e1f21)" d="M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21" clip-rule="evenodd"/>
</svg>
`;
function $562139218ff21c55$export$e3d1678155aaab99({ size: size, appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $562139218ff21c55$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("c4g4i", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $fa0d0c57ba73db29$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $fa0d0c57ba73db29$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z"/>
    <path fill="var(--icon-color, white)" d="M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691"/>
</svg>
`;
function $fa0d0c57ba73db29$export$e23ae35269442b4f({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $fa0d0c57ba73db29$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gJmXR", function(module, exports) {
$parcel$export(module.exports, "RovoLogoCS", () => $cca642bd4cd94fd1$export$b0e15f0a1c9f4c55);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $cca642bd4cd94fd1$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, white)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
function $cca642bd4cd94fd1$export$b0e15f0a1c9f4c55({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $cca642bd4cd94fd1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5yBq3", function(module, exports) {
$parcel$export(module.exports, "RovoDevIcon", () => $d583130e067b0609$export$8b784b3227531b3e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d583130e067b0609$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z"/>
    <path fill="var(--icon-color, #101214)" d="M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75"/>
</svg>
`;
function $d583130e067b0609$export$8b784b3227531b3e({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $d583130e067b0609$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jqFtz", function(module, exports) {
$parcel$export(module.exports, "RovoDevLogoCS", () => $fd3defd795f64d51$export$4145bd793c9ed1d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $fd3defd795f64d51$var$svg = `<svg height="100%" viewBox="0 0 165 32">
    <path fill="var(--text-color, #1e1f21)" d="M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, #101214)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
function $fd3defd795f64d51$export$4145bd793c9ed1d0({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $fd3defd795f64d51$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iSa43", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentIcon", () => $8311d70b108752df$export$813cff80931d9dbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $8311d70b108752df$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z" clip-rule="evenodd"/>
</svg>
`;
function $8311d70b108752df$export$813cff80931d9dbf({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev Agent', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $8311d70b108752df$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ctN6v", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentLogoCS", () => $59bedf52c7f2ff53$export$58747af448450872);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $59bedf52c7f2ff53$var$svg = `<svg height="100%" viewBox="0 0 160 32">
    <path fill="var(--text-color, #1e1f21)" d="M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z" clip-rule="evenodd"/>
</svg>
`;
function $59bedf52c7f2ff53$export$58747af448450872({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev Agent', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $59bedf52c7f2ff53$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gVjB7", function(module, exports) {
$parcel$export(module.exports, "RovoHexIcon", () => $db7f5d153636e82e$export$9e62346a60cfb459);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $db7f5d153636e82e$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $db7f5d153636e82e$export$9e62346a60cfb459({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $db7f5d153636e82e$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("anyTu", function(module, exports) {
$parcel$export(module.exports, "RovoHexLogoCS", () => $ea86812fb2c9f94e$export$5e38d02efdb45577);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $ea86812fb2c9f94e$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z" clip-rule="evenodd"/>
</svg>
`;
function $ea86812fb2c9f94e$export$5e38d02efdb45577({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $ea86812fb2c9f94e$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("av5aD", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", () => $629cd6999e54eed1$export$82eafebb825fc23f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be11b64b046e775d05a59a39754fdeaf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $629cd6999e54eed1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z" clip-rule="evenodd"/>
</svg>
`;
function $629cd6999e54eed1$export$82eafebb825fc23f({ size: size, appearance: appearance = 'brand', label: label = 'Search', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $629cd6999e54eed1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("balIc", function(module, exports) {
$parcel$export(module.exports, "SearchLogoCS", () => $d9c83e92a7ea1f0b$export$fa08cbfe393f2a68);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::151d3b961b465b2b1ef70ce5cd1da70c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $d9c83e92a7ea1f0b$var$svg = `<svg height="100%" viewBox="0 0 130 32">
    <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z" clip-rule="evenodd"/>
</svg>
`;
function $d9c83e92a7ea1f0b$export$fa08cbfe393f2a68({ size: size, appearance: appearance = 'brand', label: label = 'Search', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $d9c83e92a7ea1f0b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dleYF", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $2c924fbc8aca38b0$export$f3f5aa321d88adf9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $2c924fbc8aca38b0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68"/>
</svg>
`;
function $2c924fbc8aca38b0$export$f3f5aa321d88adf9({ size: size, appearance: appearance = 'brand', label: label = 'Statuspage', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $2c924fbc8aca38b0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("i9nDJ", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogoCS", () => $fc22f4300fed72e8$export$2bc88a281410ffa7);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $fc22f4300fed72e8$var$svg = `<svg height="100%" viewBox="0 0 192 32">
    <path fill="var(--text-color, #1e1f21)" d="M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927"/>
</svg>
`;
function $fc22f4300fed72e8$export$2bc88a281410ffa7({ size: size, appearance: appearance = 'brand', label: label = 'Statuspage', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $fc22f4300fed72e8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cts1P", function(module, exports) {
$parcel$export(module.exports, "StudioIcon", () => $a37c5ca32772c602$export$290a0f24614cde9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab3266b216390c79d8a1dc3be47de23d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $a37c5ca32772c602$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z"/>
</svg>
`;
function $a37c5ca32772c602$export$290a0f24614cde9f({ size: size, appearance: appearance = 'brand', label: label = 'Studio', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $a37c5ca32772c602$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6Z5Nx", function(module, exports) {
$parcel$export(module.exports, "StudioLogoCS", () => $051acdeded2811ea$export$273fd56580e523ae);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3562c122e709e76d7d20dd81b620288>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $051acdeded2811ea$var$svg = `<svg height="100%" viewBox="0 0 124 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>
</svg>
`;
function $051acdeded2811ea$export$273fd56580e523ae({ size: size, appearance: appearance = 'brand', label: label = 'Studio', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $051acdeded2811ea$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fVAYe", function(module, exports) {
$parcel$export(module.exports, "TalentIcon", () => $93434e04c71fd9a0$export$4b05688514531169);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $93434e04c71fd9a0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
function $93434e04c71fd9a0$export$4b05688514531169({ size: size, appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $93434e04c71fd9a0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lNNY7", function(module, exports) {
$parcel$export(module.exports, "TalentLogoCS", () => $488a4ef7b4aa50dd$export$1b3979d995ebbc6e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $488a4ef7b4aa50dd$var$svg = `<svg height="100%" viewBox="0 0 122 32">
    <path fill="var(--text-color, #1e1f21)" d="M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714"/>
</svg>
`;
function $488a4ef7b4aa50dd$export$1b3979d995ebbc6e({ size: size, appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $488a4ef7b4aa50dd$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("78xTM", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", () => $60bd876a373da108$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $60bd876a373da108$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $60bd876a373da108$export$1bcbc9c337da86da({ size: size, appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $60bd876a373da108$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("33sk5", function(module, exports) {
$parcel$export(module.exports, "TeamsLogoCS", () => $e8c5fdcae92dfe1f$export$bfd8d1c4da84ce71);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $e8c5fdcae92dfe1f$var$svg = `<svg height="100%" viewBox="0 0 127 32">
    <path fill="var(--text-color, #1e1f21)" d="M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08"/>
</svg>
`;
function $e8c5fdcae92dfe1f$export$bfd8d1c4da84ce71({ size: size, appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $e8c5fdcae92dfe1f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("faLSo", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $bc183f9df33a21cf$export$4384da9b8b140bf4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $4qlnm = parcelRequire("4qlnm");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $bc183f9df33a21cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $bc183f9df33a21cf$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
function $bc183f9df33a21cf$export$4384da9b8b140bf4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4qlnm.IconWrapper), {
        svg: $bc183f9df33a21cf$var$svg,
        customThemeSvg: $bc183f9df33a21cf$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6bWza", function(module, exports) {
$parcel$export(module.exports, "TrelloLogoCS", () => $7179413214a4b162$export$1b13139dfc0336af);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bBB9h = parcelRequire("bBB9h");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $7179413214a4b162$var$svg = `<svg height="100%" viewBox="0 0 113 32">
    <path fill="var(--text-color, #1e1f21)" d="M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#1558bc)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z"/>
</svg>
`;
function $7179413214a4b162$export$1b13139dfc0336af({ size: size, appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bBB9h.LogoWrapper), {
        svg: $7179413214a4b162$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("je4UV", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminIcon", () => $6b9862d3ae50ff49$export$84109e099492cb5f);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $6b9862d3ae50ff49$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $6b9862d3ae50ff49$export$84109e099492cb5f = ({ appearance: appearance, label: label = 'Atlassian Admin', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        svg: $6b9862d3ae50ff49$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cDrci", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminLogo", () => $733d948dd7cffb12$export$f845d9b9254f0541);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $733d948dd7cffb12$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 295 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $733d948dd7cffb12$export$f845d9b9254f0541 = ({ appearance: appearance, label: label = 'Atlassian Admin', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $733d948dd7cffb12$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8pCVo", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationIcon", () => $3ef94ef9f118af10$export$74517ed253186308);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $3ef94ef9f118af10$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $3ef94ef9f118af10$export$74517ed253186308 = ({ appearance: appearance, label: label = 'Atlassian Administration', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        svg: $3ef94ef9f118af10$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1nNX0", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationLogo", () => $bd4edb9added1110$export$833abe6c2ce5ebfd);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $bd4edb9added1110$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 404 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $bd4edb9added1110$export$833abe6c2ce5ebfd = ({ appearance: appearance, label: label = 'Atlassian Administration', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $bd4edb9added1110$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("h5TI4", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $c6725aa16422a7c2$export$c42ad8a0b925c762);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $fnhqr = parcelRequire("fnhqr");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $c6725aa16422a7c2$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `<svg height="32" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="12.595" x2="12.595" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient id="${id}-b" x1="28.595" x2="28.595" y1="40" y2="27" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-b" id="${id}-c" x1="20.595" x2="20.595" y2="22"/>
    <linearGradient xlink:href="#${id}-b" id="${id}-d" x1="36.595" x2="36.595" y2="20"/>
  </defs>
  <path d="M10.595 30h4v10h-4z" fill="url(#${id}-a)"/>
  <path d="M26.595 27h4v13h-4z" fill="url(#${id}-b)"/>
  <path d="M18.595 22h4v18h-4z" fill="url(#${id}-c)"/>
  <path d="M34.595 20h4v20h-4z" fill="url(#${id}-d)"/>
  <path fill="${colors.iconColor}" d="m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z" />
</svg>`;
};
const $c6725aa16422a7c2$export$c42ad8a0b925c762 = ({ appearance: appearance, label: label = 'Atlassian Analytics', size: size = (0, $gnrsO.defaultLogoParams).size, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    const id = (0, $fnhqr.useId)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $c6725aa16422a7c2$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("jkcNn", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsLogo", () => $242294bfc9310707$export$e6470bfc39010cc4);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $fnhqr = parcelRequire("fnhqr");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $242294bfc9310707$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg height="32" viewBox="0 0 477 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="447.285" x2="447.285" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-a" id="${id}-b" x1="463.285" x2="463.285" y2="27"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-c" x1="455.285" x2="455.285" y2="22"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-d" x1="471.285" x2="471.285" y2="20"/>
  </defs>
  <g fill="${colors.atlassianLogoTextColor}">
    <path d="M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z"/>
  </g>
  <g fill="${colors.textColor}">
    <path d="m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z"/>
  </g>
  <path fill="url(#${id}-a)" d="M445.285 30h4v10h-4z"/>
  <path fill="url(#${id}-b)" d="M461.285 27h4v13h-4z"/>
  <path fill="url(#${id}-c)" d="M453.285 22h4v18h-4z"/>
  <path fill="url(#${id}-d)" d="M469.285 20h4v20h-4z"/>
  <path fill="${colors.iconColor}" d="m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z"/>
</svg>`;
};
const $242294bfc9310707$export$e6470bfc39010cc4 = ({ appearance: appearance, label: label = 'Atlassian Analytics', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    const id = (0, $fnhqr.useId)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $242294bfc9310707$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lLj7Z", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $38f1accd19bf64b1$export$5fc1066e677788d4);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $38f1accd19bf64b1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $38f1accd19bf64b1$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $38f1accd19bf64b1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("geqXx", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogo", () => $a7398ff34d90584b$export$bd40525f5333524b);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $a7398ff34d90584b$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path fill=${colors.iconColor} d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>
        <path fill=${colors.textColor} d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>
      </svg>`;
};
const $a7398ff34d90584b$export$bd40525f5333524b = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a7398ff34d90584b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kbKgV", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $9f5bae554b142725$export$f7857fe64d7161d9);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $9f5bae554b142725$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const $9f5bae554b142725$export$f7857fe64d7161d9 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $9f5bae554b142725$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("leh3B", function(module, exports) {
$parcel$export(module.exports, "CompassLogo", () => $9526b5d3ce3eb6df$export$eb7d748e4f9c9676);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $9526b5d3ce3eb6df$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path fill=${colors.iconColor} d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>
    <path fill="${colors.textColor}" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>
  </svg>`;
};
const $9526b5d3ce3eb6df$export$eb7d748e4f9c9676 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $9526b5d3ce3eb6df$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iODG9", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogo", () => $2383518032826225$export$1b2e4fe6ef471556);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $2383518032826225$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>
      <path fill="${colors.textColor}" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>
    </svg>
    `;
};
const $2383518032826225$export$1b2e4fe6ef471556 = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2383518032826225$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jOI6e", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $cdeef682c785e3da$export$1e02e7298035a77c);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $cdeef682c785e3da$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z"/>
		</svg>
		`;
};
const $cdeef682c785e3da$export$1e02e7298035a77c = ({ appearance: appearance, label: label = 'Focus', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $cdeef682c785e3da$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("81dBD", function(module, exports) {
$parcel$export(module.exports, "FocusLogo", () => $967d0a59e70e5dd5$export$33908560ea1b226d);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $967d0a59e70e5dd5$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 168 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z"/>
		<path fill="${colors.textColor}" d="M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z"/>
		<path fill="${colors.textColor}" d="M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z"/>
		<path fill="${colors.textColor}" d="M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z"/>
		<path fill="${colors.textColor}" d="M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z"/>
		<path fill="${colors.textColor}" d="M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z"/>
		</svg>
		`;
};
const $967d0a59e70e5dd5$export$33908560ea1b226d = ({ appearance: appearance, label: label = 'Focus', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $967d0a59e70e5dd5$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7kkSC", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $022357d505b662f5$export$3f95fcfdc25a741d);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $022357d505b662f5$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $022357d505b662f5$export$3f95fcfdc25a741d = ({ appearance: appearance, label: label = 'Guard', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        svg: $022357d505b662f5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("43bfp", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", () => $9d790bad511e68c6$export$a4a891d202775deb);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $9d790bad511e68c6$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">
      <path
        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"
        fill="${colors.iconColor}"
      />
      <path
        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $9d790bad511e68c6$export$a4a891d202775deb = ({ appearance: appearance, label: label = 'Guard', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $9d790bad511e68c6$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("72YWo", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $d1f67bdfe2b676d9$export$c4b5b1f965d8b3eb);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $d1f67bdfe2b676d9$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $d1f67bdfe2b676d9$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $d1f67bdfe2b676d9$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2R4Kr", function(module, exports) {
$parcel$export(module.exports, "JiraLogo", () => $24cb4525d0f1ca17$export$17d3acb0b4379d02);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $24cb4525d0f1ca17$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $24cb4525d0f1ca17$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $24cb4525d0f1ca17$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9sGEd", function(module, exports) {
$parcel$export(module.exports, "JiraAlignIcon", () => $36d8dade86f13129$export$407687b2dd89cc68);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $36d8dade86f13129$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="${colors.iconColor}"
      d="M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z"
    />
  </svg>`;
};
const $36d8dade86f13129$export$407687b2dd89cc68 = ({ appearance: appearance, label: label = 'Jira Align', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $36d8dade86f13129$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("625YQ", function(module, exports) {
$parcel$export(module.exports, "JiraAlignLogo", () => $45aa40106a5fa1fc$export$ee11e928d3d045fd);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $45aa40106a5fa1fc$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 146 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z" fill="${colors.iconColor}"/>
      <path d="M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" fill="${colors.textColor}"/>
    </svg>
  `;
};
const $45aa40106a5fa1fc$export$ee11e928d3d045fd = ({ appearance: appearance, label: label = 'Jira Align', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $45aa40106a5fa1fc$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("90Zqf", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $1a230f678d61a1f1$export$21bfbeb62fdcce8d);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $1a230f678d61a1f1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $1a230f678d61a1f1$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $1a230f678d61a1f1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("88dLv", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $9f1758043f9712df$export$c49a2b642fe9eef4);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $9f1758043f9712df$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $9f1758043f9712df$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $9f1758043f9712df$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("aVO0N", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $b476cf169f8241a0$export$3c6158790f5e01c4);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $b476cf169f8241a0$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $b476cf169f8241a0$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $b476cf169f8241a0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hM7Mq", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogo", () => $133cf32970d6b98d$export$dabef2be6cd28c20);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $133cf32970d6b98d$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $133cf32970d6b98d$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $133cf32970d6b98d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iTjUA", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $56593f2a7f8e76c2$export$8d789f76fde3e05);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $56593f2a7f8e76c2$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsForLoom)(appearance, colorMode);
    return `<svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"
      fill="${colors.iconColor}"
    />
  </svg>`;
};
const $56593f2a7f8e76c2$export$8d789f76fde3e05 = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $56593f2a7f8e76c2$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eh2n8", function(module, exports) {
$parcel$export(module.exports, "LoomLogo", () => $7b512a3e57d1980a$export$94e206806e36c2ec);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $7b512a3e57d1980a$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsForLoom)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 98 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006"
        fill="${colors.iconColor}"
      />
      <path
        d="M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $7b512a3e57d1980a$export$94e206806e36c2ec = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7b512a3e57d1980a$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5nH7l", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionIcon", () => $781c7b9678ffefee$export$1bf47cdade1a9fcb);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $gnrsO = parcelRequire("gnrsO");

var $iTjUA = parcelRequire("iTjUA");
const $781c7b9678ffefee$export$1bf47cdade1a9fcb = ({ appearance: appearance, label: label = 'Loom Attribution', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iTjUA.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("1G1Km", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogo", () => $41d9d7b3c2838305$export$6e87ce8d41eda665);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $41d9d7b3c2838305$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsForLoom)(appearance, colorMode);
    return `<svg
		fill="none"
		height="32"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
		aria-hidden="true"
		viewBox="0 0 88 32"
	>
		<path
			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"
			fill="${colors.iconColor}"
		/>
		<path
			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"
			fill="${colors.textColor}"
		/>
	</svg>`;
};
const $41d9d7b3c2838305$export$6e87ce8d41eda665 = ({ appearance: appearance, label: label = 'Loom Attribution', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $41d9d7b3c2838305$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iY3g5", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $82727563270a4563$export$eeccc49dc7a12d9f);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $82727563270a4563$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
    </svg>`;
};
const $82727563270a4563$export$eeccc49dc7a12d9f = ({ appearance: appearance, label: label = 'Opsgenie', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        svg: $82727563270a4563$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1mdd1", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogo", () => $4927681217659c2c$export$a1c6484cdecc2c4b);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $4927681217659c2c$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 154 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
      <path fill="${colors.textColor}" d="M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697" />
    </svg>`;
};
const $4927681217659c2c$export$a1c6484cdecc2c4b = ({ appearance: appearance, label: label = 'Opsgenie', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $4927681217659c2c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ibxD9", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $2f817efd4d40455c$export$e23ae35269442b4f);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $2f817efd4d40455c$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
};
const $2f817efd4d40455c$export$e23ae35269442b4f = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        svg: $2f817efd4d40455c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ktpkh", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", () => $b1776db5359b7682$export$a0f6cb8061290bbb);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $b1776db5359b7682$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 100 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $b1776db5359b7682$export$a0f6cb8061290bbb = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $b1776db5359b7682$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hEYed", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $dabf8ca393706a2a$export$f3f5aa321d88adf9);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $dabf8ca393706a2a$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063"/>
    </svg>`;
};
const $dabf8ca393706a2a$export$f3f5aa321d88adf9 = ({ appearance: appearance, label: label = 'Statuspage', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $dabf8ca393706a2a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6H0qF", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogo", () => $be29b3cc838fb0f1$export$bb4ae5b41b43be04);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $be29b3cc838fb0f1$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 188 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063" />
      <path fill="${colors.textColor}" d="M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072" />
    </svg>`;
};
const $be29b3cc838fb0f1$export$bb4ae5b41b43be04 = ({ appearance: appearance, label: label = 'Statuspage', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $be29b3cc838fb0f1$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hDUTZ", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $a16c941f957e1526$export$4384da9b8b140bf4);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $a16c941f957e1526$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>
    </svg>`;
};
const $a16c941f957e1526$export$4384da9b8b140bf4 = ({ appearance: appearance, label: label = 'Trello', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $a16c941f957e1526$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("e7f5q", function(module, exports) {
$parcel$export(module.exports, "TrelloLogo", () => $bcde7c6031e538f3$export$60e26212f3b61a28);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $bcde7c6031e538f3$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 106 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" clip-rule="evenodd" d="M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z" fill-rule="evenodd"/>
      <path fill="${colors.textColor}" d="M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z"/>
    </svg>`;
};
const $bcde7c6031e538f3$export$60e26212f3b61a28 = ({ appearance: appearance, label: label = 'Trello', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $bcde7c6031e538f3$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1UCp0", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementIcon", () => $ae6f5b73e02942c1$export$7330b9fc5718fd30);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $fnhqr = parcelRequire("fnhqr");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $ae6f5b73e02942c1$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $gnrsO.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $gnrsO.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const $ae6f5b73e02942c1$export$7330b9fc5718fd30 = ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    const id = (0, $fnhqr.useId)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $ae6f5b73e02942c1$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hXRSF", function(module, exports) {
$parcel$export(module.exports, "AtlassianIcon", () => $7c1a7d9fd59a149f$export$8a485e2e7ed91e8f);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $7c1a7d9fd59a149f$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $7c1a7d9fd59a149f$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $gnrsO.defaultLogoParams).size, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $7c1a7d9fd59a149f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("k7u8y", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareIcon", () => $fe89595fa4d7b47d$export$c3835feba2a66e67);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $fnhqr = parcelRequire("fnhqr");

var $kHnjK = parcelRequire("kHnjK");

var $gnrsO = parcelRequire("gnrsO");

var $3hgWu = parcelRequire("3hgWu");

var $ipRYk = parcelRequire("ipRYk");
const $fe89595fa4d7b47d$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $gnrsO.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $gnrsO.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $ipRYk.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const $fe89595fa4d7b47d$export$c3835feba2a66e67 = ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $gnrsO.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gnrsO.defaultLogoParams).iconColor, textColor: textColor = (0, $gnrsO.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    const id = (0, $fnhqr.useId)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3hgWu.default), {
        appearance: appearance,
        label: label,
        svg: $fe89595fa4d7b47d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("i2QhJ", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $7c8c7b7bcbba99f9$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $7c8c7b7bcbba99f9$export$f654d825189934a7);
const $7c8c7b7bcbba99f9$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $7c8c7b7bcbba99f9$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $7c8c7b7bcbba99f9$export$84a73a0383f58180 = 'JiraTask';
const $7c8c7b7bcbba99f9$export$c6c83963a9378a67 = 'JiraSubTask';
const $7c8c7b7bcbba99f9$export$58af3c426c111a6d = 'JiraStory';
const $7c8c7b7bcbba99f9$export$ac9898a63417219e = 'JiraBug';
const $7c8c7b7bcbba99f9$export$54db5e3fb12e39cd = 'JiraEpic';
const $7c8c7b7bcbba99f9$export$2f54a5a217202c85 = 'JiraIncident';
const $7c8c7b7bcbba99f9$export$d097371052bfc411 = 'JiraServiceRequest';
const $7c8c7b7bcbba99f9$export$efd9452ad16c6676 = 'JiraChange';
const $7c8c7b7bcbba99f9$export$2e7e70abb5d81f67 = 'JiraProblem';
const $7c8c7b7bcbba99f9$export$ce25cfc40b280dbc = 'JiraCustomTaskType';

});


parcelRegister("lqo5q", function(module, exports) {
$parcel$export(module.exports, "extractTitle", () => $d1db74cc10ff328e$export$b05803156e5015b6);

var $8Ptz7 = parcelRequire("8Ptz7");

var $8nwbS = parcelRequire("8nwbS");
const $d1db74cc10ff328e$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    var _jsonLd$name;
    if (!jsonLd) return undefined;
    const name = (_jsonLd$name = jsonLd.name) === null || _jsonLd$name === void 0 ? void 0 : _jsonLd$name.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $8Ptz7.extractContext)(jsonLd);
    const type = (0, $8nwbS.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name === null || name === void 0 ? void 0 : name.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("8Ptz7", function(module, exports) {
$parcel$export(module.exports, "extractContext", () => $cbe1afc25fe8e745$export$efdbd45f3e77a161);

var $8nwbS = parcelRequire("8nwbS");

var $hKbUE = parcelRequire("hKbUE");
const $cbe1afc25fe8e745$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $hKbUE.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $8nwbS.extractType)(context)
            };
        }
    }
    return undefined;
};

});
parcelRegister("8nwbS", function(module, exports) {
$parcel$export(module.exports, "extractType", () => $63c4016a1cad8b17$export$2e9ae379995d99e3);
const $63c4016a1cad8b17$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};

});



parcelRegister("lm7Ce", function(module, exports) {
$parcel$export(module.exports, "extractPreview", () => $34b77b31c44619d0$export$4b0d98b1b7f6d115);

var $c8j8I = parcelRequire("c8j8I");

var $db3bG = parcelRequire("db3bG");
const $34b77b31c44619d0$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.preview;
    const isSupported = (0, $c8j8I.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $db3bG.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $db3bG.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};

});
parcelRegister("c8j8I", function(module, exports) {
$parcel$export(module.exports, "extractPlatformIsSupported", () => $0992c08f669b437e$export$3e8ad908070b68b2);
const $0992c08f669b437e$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});


parcelRegister("3Z03G", function(module, exports) {
$parcel$export(module.exports, "extractEntity", () => $b968ee06bfa71577$export$8beff7405d020ddf);
$parcel$export(module.exports, "isEntityPresent", () => $b968ee06bfa71577$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntityEmbedUrl", () => $b968ee06bfa71577$export$f97663ee76ac5b24);
$parcel$export(module.exports, "extractEntityProvider", () => $b968ee06bfa71577$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $b968ee06bfa71577$export$19346520e937a99f);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $i5dqB = parcelRequire("i5dqB");

var $iqc8I = parcelRequire("iqc8I");

var $e6Qdr = parcelRequire("e6Qdr");

var $i2QhJ = parcelRequire("i2QhJ");
const $b968ee06bfa71577$export$8beff7405d020ddf = (response)=>response === null || response === void 0 ? void 0 : response.entityData;
const $b968ee06bfa71577$export$c7168210b81d9383 = (response)=>Boolean($b968ee06bfa71577$export$8beff7405d020ddf(response));
const $b968ee06bfa71577$export$f97663ee76ac5b24 = (response)=>{
    const entity = $b968ee06bfa71577$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl) === 'string' ? entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl : undefined;
};
const $b968ee06bfa71577$export$ad879f2c9d5100a0 = (response)=>{
    var _response$meta;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && _response$meta.generator)) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $i2QhJ.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $i5dqB.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $e6Qdr.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $i2QhJ.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqc8I.JiraIcon), {
                appearance: "brand",
                ...(0, $e6Qdr.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $b968ee06bfa71577$export$19346520e937a99f = (response)=>{
    const entity = $b968ee06bfa71577$export$8beff7405d020ddf(response);
    let url;
    if (entity) {
        var _response$meta$genera;
        url = 'iconUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.iconUrl) === 'string' ? entity.iconUrl : response === null || response === void 0 || (_response$meta$genera = response.meta.generator) === null || _response$meta$genera === void 0 || (_response$meta$genera = _response$meta$genera.icon) === null || _response$meta$genera === void 0 ? void 0 : _response$meta$genera.url;
    }
    return {
        url: url,
        label: entity === null || entity === void 0 ? void 0 : entity.displayName
    };
};

});


parcelRegister("8ur5I", function(module, exports) {
$parcel$export(module.exports, "cardReducer", () => $be8a6529930d5e74$export$3c7c3113a97b6492);

var $f09Q5 = parcelRequire("f09Q5");
var $cE8LQ = parcelRequire("cE8LQ");
const $be8a6529930d5e74$var$isCardAction = (action)=>{
    return [
        (0, $f09Q5.ACTION_PENDING),
        (0, $f09Q5.ACTION_RESOLVING),
        (0, $f09Q5.ACTION_RESOLVED),
        (0, $f09Q5.ACTION_RELOADING),
        (0, $f09Q5.ACTION_ERROR),
        (0, $f09Q5.ACTION_ERROR_FALLBACK),
        (0, $f09Q5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $be8a6529930d5e74$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $cE8LQ.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $be8a6529930d5e74$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $f09Q5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $f09Q5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $f09Q5.ACTION_RESOLVED:
            return $be8a6529930d5e74$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $f09Q5.ACTION_RELOADING:
            return $be8a6529930d5e74$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $f09Q5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $f09Q5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $f09Q5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $be8a6529930d5e74$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$be8a6529930d5e74$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $be8a6529930d5e74$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("f09Q5", function(module, exports) {
$parcel$export(module.exports, "ACTION_PENDING", () => $181b90015f2424c6$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $181b90015f2424c6$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $181b90015f2424c6$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $181b90015f2424c6$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $181b90015f2424c6$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $181b90015f2424c6$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $181b90015f2424c6$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $181b90015f2424c6$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $181b90015f2424c6$export$6e470aad5ba8952e = 'pending';
const $181b90015f2424c6$export$9a6a932a0a39498e = 'resolving';
const $181b90015f2424c6$export$63ec8bc7a8a75482 = 'resolved';
const $181b90015f2424c6$export$b8cfaa842c9ab487 = 'reloading';
const $181b90015f2424c6$export$6d8ed3f9433dd372 = 'errored';
const $181b90015f2424c6$export$cfbbb7126bc8a0c6 = 'fallback';
const $181b90015f2424c6$export$76b5c1aca20759c6 = 'preload';
const $181b90015f2424c6$export$2c5edb971b673330 = 'metadata';
const $181b90015f2424c6$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});


parcelRegister("73ark", function(module, exports) {
$parcel$export(module.exports, "SmartCardContext", () => $05d880386b7b1aa3$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $05d880386b7b1aa3$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $05d880386b7b1aa3$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $05d880386b7b1aa3$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $05d880386b7b1aa3$export$2a29ca11e08dc129);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

const $05d880386b7b1aa3$export$156b523e63b4f63a = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);
function $05d880386b7b1aa3$export$e1d190b530cf0ee9() {
    const context = (0, $8P7DW.useContext)($05d880386b7b1aa3$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $05d880386b7b1aa3$export$10e9cca30e50f657 = ()=>$05d880386b7b1aa3$var$useContextMemoized($05d880386b7b1aa3$export$156b523e63b4f63a);
const $05d880386b7b1aa3$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $05d880386b7b1aa3$export$10e9cca30e50f657();
    if (!(cardContext !== null && cardContext !== void 0 && cardContext.value)) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: children
    });
};
function $05d880386b7b1aa3$var$useContextMemoized(reactContext) {
    const value = (0, $8P7DW.useContext)(reactContext);
    const context = (0, $8P7DW.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $05d880386b7b1aa3$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $05d880386b7b1aa3$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $gWgPx.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $05d880386b7b1aa3$export$2e2bcd8739ae039 = $05d880386b7b1aa3$export$156b523e63b4f63a;

});


parcelRegister("hXIhE", function(module, exports) {
$parcel$export(module.exports, "RendererWithAnalytics", () => $94a0416e0d520049$export$af81ffb59b6ef0dd);
$parcel$export(module.exports, "default", () => $94a0416e0d520049$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $2WmUO = parcelRequire("2WmUO");

var $feOkE = parcelRequire("feOkE");
var $6RaaD = parcelRequire("6RaaD");

var $5jr6D = parcelRequire("5jr6D");
var $2aE1s = parcelRequire("2aE1s");
var $1I7g7 = parcelRequire("1I7g7");
var $94YFM = parcelRequire("94YFM");
var $kST4t = parcelRequire("kST4t");

var $h2boN = parcelRequire("h2boN");

var $8Z0o8 = parcelRequire("8Z0o8");

var $7CWXm = parcelRequire("7CWXm");

var $dxSZI = parcelRequire("dxSZI");

var $hpPtq = parcelRequire("hpPtq");

var $dqleT = parcelRequire("dqleT");

var $kfvAE = parcelRequire("kfvAE");

var $7VS6B = parcelRequire("7VS6B");
var $bzXkQ = parcelRequire("bzXkQ");

var $e6Qdr = parcelRequire("e6Qdr");

var $1s1Af = parcelRequire("1s1Af");
parcelRequire("9EJQR");
var $5VXGe = parcelRequire("5VXGe");

var $eguiP = parcelRequire("eguiP");

var $lUTku = parcelRequire("lUTku");

var $9e0lC = parcelRequire("9e0lC");

var $3gJSl = parcelRequire("3gJSl");
var $9NvnD = parcelRequire("9NvnD");

var $h5yjd = parcelRequire("h5yjd");

var $jS5mX = parcelRequire("jS5mX");

var $9CfQj = parcelRequire("9CfQj");

var $jBVmK = parcelRequire("jBVmK");

var $jcz6F = parcelRequire("jcz6F");

var $j88lh = parcelRequire("j88lh");

var $fscXt = parcelRequire("fscXt");

var $4ZS1b = parcelRequire("4ZS1b");

var $3yMdl = parcelRequire("3yMdl");

var $2x5h2 = parcelRequire("2x5h2");

var $jbPve = parcelRequire("jbPve");

var $gby7N = parcelRequire("gby7N");

var $44oYY = parcelRequire("44oYY");

var $3pW7R = parcelRequire("3pW7R");

var $1a7CN = parcelRequire("1a7CN");

var $9rAvi = parcelRequire("9rAvi");

var $bZbgj = parcelRequire("bZbgj");

var $f0OUv = parcelRequire("f0OUv");

var $WtfHk = parcelRequire("WtfHk");

var $3ztD5 = parcelRequire("3ztD5");

var $iQv2h = parcelRequire("iQv2h");

var $aFaoZ = parcelRequire("aFaoZ");

var $akJdH = parcelRequire("akJdH");

var $13svG = parcelRequire("13svG");

var $lJcO1 = parcelRequire("lJcO1");
function $94a0416e0d520049$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $94a0416e0d520049$export$47b2879ca9bbf67a = 2000;
const $94a0416e0d520049$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
const $94a0416e0d520049$var$TABLE_INFO_TIMEOUT = 10000;
const $94a0416e0d520049$var$RENDER_EVENT_SAMPLE_RATE = 0.2;
const $94a0416e0d520049$var$packageName = undefined;
const $94a0416e0d520049$var$packageVersion = undefined;
const $94a0416e0d520049$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $94a0416e0d520049$var$handleMouseTripleClickInTables = (event)=>{
    var _parentElement, _parentElement2;
    const browser = (0, $7CWXm.getBrowserInfo)();
    if (browser.ios || browser.android) return;
    const badBrowser = browser.chrome || browser.safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement = anchorNode.parentElement) === null || _parentElement === void 0 ? void 0 : _parentElement.closest('div,p') : focusInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement2 = focusNode.parentElement) === null || _parentElement2 === void 0 ? void 0 : _parentElement2.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $94a0416e0d520049$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    var _props$eventHandlers;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $94a0416e0d520049$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!((_props$eventHandlers = props.eventHandlers) !== null && _props$eventHandlers !== void 0 && _props$eventHandlers.onUnhandledClick)) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $j88lh.findInTree)(targetElement, rendererWrapper, (0, $44oYY.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $94a0416e0d520049$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $8P7DW.useRef)(undefined);
    const providerFactory = (0, $8P7DW.useMemo)(()=>props.dataProviders || new (0, $feOkE.default)(), [
        props.dataProviders
    ]);
    const { nestedRendererType: nestedRendererType } = (0, $jcz6F.useRendererContext)();
    const createRendererContext = (0, $8P7DW.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $lUTku.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined,
                nestedRendererType: // Propagate nestedRendererType into the inner RendererContextProvider so that
                // React components inside the renderer (e.g. Colgroup) can read it via
                // useRendererContext(). Without this, the inner provider overwrites the outer
                // AKRendererWrapper context and nestedRendererType becomes undefined.
                nestedRendererType
            };
        }, [
        nestedRendererType
    ]);
    const fireAnalyticsEventOld = (0, $8P7DW.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $1s1Af.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $8P7DW.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $1s1Af.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $h2boN.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $8P7DW.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $3ztD5.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext,
                nestedRendererType: nestedRendererType
            },
            appearance: props.appearance,
            contentMode: props.contentMode,
            onSetLinkTarget: props.onSetLinkTarget,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption,
            shouldDisplayExtensionAsInline: props.shouldDisplayExtensionAsInline
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent,
        nestedRendererType
    ]);
    const serializer = (0, $iQv2h.useMemoFromPropsDerivative)((serializerProps)=>{
        var _props$createSerializ;
        return ((_props$createSerializ = props.createSerializer) === null || _props$createSerializ === void 0 ? void 0 : _props$createSerializ.call(props, serializerProps)) ?? new (0, $3gJSl.default)(serializerProps);
    }, deriveSerializerProps, props);
    const localRef = (0, $8P7DW.useRef)(null);
    const editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $8P7DW.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($9e0lC)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $8P7DW.useMemo)(()=>(0, $hpPtq.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $8P7DW.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $dxSZI.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $8P7DW.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $eguiP.ACTION).VIEWED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $jS5mX.PLATFORM).WEB,
                    mode: (0, $jS5mX.MODE).RENDERER
                },
                eventType: (0, $eguiP.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $8P7DW.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $2WmUO.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $8P7DW.useEffect)(()=>{
        let rafID;
        let heightWidthAnalyticsSetTimeoutID;
        let heightWidthAnalyticsRicID;
        let heightWidthAnalyticsRafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $eguiP.ACTION).STARTED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $jS5mX.PLATFORM).WEB
                },
                eventType: (0, $eguiP.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $dxSZI.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $bzXkQ.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking !== null && analyticsEventSeverityTracking !== void 0 && analyticsEventSeverityTracking.enabled ? (0, $7VS6B.getAnalyticsEventSeverity)(duration, (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityNormalThreshold) ?? $94a0416e0d520049$export$47b2879ca9bbf67a, (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityDegradedThreshold) ?? $94a0416e0d520049$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.enabled) === false;
                    if (!isTTRTrackingExplicitlyDisabled) {
                        const event = {
                            action: (0, $eguiP.ACTION).RENDERED,
                            actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER,
                            attributes: {
                                platform: (0, $jS5mX.PLATFORM).WEB,
                                duration: duration,
                                // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                                ttfb: (0, $dqleT.getResponseEndTime)(),
                                nodes: (0, $3pW7R.countNodes)(props.document),
                                nestedRendererType: (0, $h2boN.editorExperiment)('platform_synced_block', true) ? nestedRendererType : undefined,
                                severity: severity
                            },
                            eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL
                        };
                        fireAnalyticsEvent(event);
                        if ((0, $13svG.expValEquals)('platform_editor_sample_renderer_rendered_event', 'isEnabled', true) && Math.random() < $94a0416e0d520049$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent({
                            ...event,
                            action: (0, $eguiP.ACTION).RENDERED_SAMPLED
                        });
                    }
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(()=>{
                const requestIdleCallbackFn = ()=>{
                    var _props$innerRef;
                    const renderer = (_props$innerRef = props.innerRef) === null || _props$innerRef === void 0 || (_props$innerRef = _props$innerRef.current) === null || _props$innerRef === void 0 ? void 0 : _props$innerRef.querySelector('.ak-renderer-document');
                    if (renderer) {
                        const payload = (0, $lJcO1.getWidthInfoPayload)(renderer);
                        if (payload) fireAnalyticsEvent(payload);
                        if ((0, $e6Qdr.fg)('platform_editor_table_height_analytics_event')) {
                            const payloadHeight = (0, $lJcO1.getHeightInfoPayload)(renderer);
                            if (payloadHeight) fireAnalyticsEvent(payloadHeight);
                        }
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $94a0416e0d520049$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $8P7DW.useMemo)(()=>({
            ...createRendererContext(props.featureFlags, props.isTopLevelRenderer),
            timeZone: props.timeZone
        }), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.timeZone
    ]);
    (0, $kfvAE.useScrollToBlock)(editorRef, props.document, props.scrollToBlock);
    try {
        var _props$media;
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $9NvnD.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $3ztD5.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, props.validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $jcz6F.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $3yMdl.ActiveHeaderIdProvider), {
            value: (0, $jBVmK.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $h5yjd.default).Provider, {
            // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $4ZS1b.Provider), null, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $6RaaD.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)($94a0416e0d520049$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $jBVmK.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$94a0416e0d520049$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: (_props$media = props.media) === null || _props$media === void 0 ? void 0 : _props$media.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $gby7N.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $8Z0o8.jsx)($94a0416e0d520049$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $9rAvi.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $8Z0o8.jsx)($94a0416e0d520049$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $jBVmK.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$94a0416e0d520049$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $1I7g7.default), null));
    }
};
const $94a0416e0d520049$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo($94a0416e0d520049$export$c49fe2316038f3c2);
const $94a0416e0d520049$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo((props)=>{
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($94a0416e0d520049$var$RendererFunctionalComponentMemoized, props);
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $aFaoZ.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($94a0416e0d520049$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $94a0416e0d520049$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext((0, $2x5h2.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $jcz6F.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $8P7DW.useContext)((0, $bZbgj.ValidationContext)) || {};
    const validationOverrides = (0, $8P7DW.useMemo)(()=>({
            allowNestedTables: allowNestedTables
        }), [
        allowNestedTables
    ]);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)($94a0416e0d520049$var$RendererFunctionalComponentWithPortalContext, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: props.isTopLevelRenderer ?? isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: validationOverrides
    });
}
const $94a0416e0d520049$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo((props)=>/*#__PURE__*/ (0, $8Z0o8.jsx)((0, $5VXGe.FabricEditorAnalyticsContext), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        data: {
            appearance: (0, $7VS6B.getAnalyticsAppearance)(props.appearance),
            packageName: $94a0416e0d520049$var$packageName,
            packageVersion: $94a0416e0d520049$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($9e0lC)))()
        }
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $kST4t.WithCreateAnalyticsEvent), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $jbPve.ErrorBoundary), {
                component: (0, $eguiP.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $2aE1s.IntlErrorBoundary), null, /*#__PURE__*/ (0, $8Z0o8.jsx)($94a0416e0d520049$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $94a0416e0d520049$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, contentMode: contentMode, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $1a7CN.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(true);
    const { nestedRendererType: nestedRendererType } = (0, $jcz6F.useRendererContext)();
    (0, $8P7DW.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef !== null && innerRef !== void 0 && innerRef.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation, _index)=>{
                    var _mutation$addedNodes$, _mutation$removedNode;
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $1a7CN.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $1a7CN.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ if (mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && ((_mutation$addedNodes$ = mutation.addedNodes[0]) === null || _mutation$addedNodes$ === void 0 ? void 0 : _mutation$addedNodes$.id) === (0, $1a7CN.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && ((_mutation$removedNode = mutation.removedNodes[0]) === null || _mutation$removedNode === void 0 ? void 0 : _mutation$removedNode.id) === (0, $1a7CN.TELEPOINTER_ID)) && (0, $e6Qdr.fg)('platform_editor_ai_adf_prompts_in_all_products')) {
                        const lastChild = renderer.lastChild;
                        if (lastChild) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ const contentElements = lastChild.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            const lastElement = contentElements[contentElements.length - 1];
                            const oldTelepointer = renderer.querySelector(`#${(0, $1a7CN.TELEPOINTER_ID)}`);
                            if (lastElement) {
                                oldTelepointer === null || oldTelepointer === void 0 || oldTelepointer.remove();
                                lastElement === null || lastElement === void 0 || lastElement.appendChild(createTelepointer());
                            } else {
                                oldTelepointer === null || oldTelepointer === void 0 || oldTelepointer.remove();
                                lastChild === null || lastChild === void 0 || lastChild.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $94YFM.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $5jr6D.BaseTheme), {
        baseFontSize: (0, $WtfHk.getBaseFontSize)(appearance, contentMode)
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $9CfQj.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $f0OUv.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles,
        isInsideSyncBlock: nestedRendererType === 'syncedBlock'
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer && (0, $e6Qdr.fg)('platform-ssr-table-resize')) return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $94a0416e0d520049$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || ((0, $akJdH.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && appearance === 'max') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && (0, $e6Qdr.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $94a0416e0d520049$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $94a0416e0d520049$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(null);
function $94a0416e0d520049$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext($94a0416e0d520049$var$RootRendererContext);
    const actions = (0, $8P7DW.useContext)((0, $fscXt.RendererContext));
    const rendererRef = (0, $8P7DW.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $h2boN.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $8P7DW.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $h2boN.editorExperiment)('comment_on_bodied_extensions', true)) return(// eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    /*#__PURE__*/ (0, $8Z0o8.jsx)($94a0416e0d520049$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children));
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $94a0416e0d520049$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(null);
    const innerRef = props.innerRef || localRef;
    // @see https://hello.jira.atlassian.cloud/browse/EDITOR-3389
    if (props.appearance === 'max' && !(0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) props.appearance = 'full-width';
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8Z0o8.jsx)($94a0416e0d520049$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $fscXt.RendererActionsContext), null, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $2x5h2.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)($94a0416e0d520049$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $94a0416e0d520049$export$2e2bcd8739ae039 = $94a0416e0d520049$var$RendererWithAnnotationSelection;

});
parcelRegister("2WmUO", function(module, exports) {
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $88deb11790acabb3$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $88deb11790acabb3$export$1db618b7b2275ea1);

var $hXXvg = parcelRequire("hXXvg");

var $1zZdw = parcelRequire("1zZdw");
var $c6xL4 = parcelRequire("c6xL4");
var $cfGoW = parcelRequire("cfGoW");
var $5mWOa = parcelRequire("5mWOa");
var $1l3LJ = parcelRequire("1l3LJ");
var $19Zep = parcelRequire("19Zep");

var $jhvO2 = parcelRequire("jhvO2");

var $afs8i = parcelRequire("afs8i");
const $88deb11790acabb3$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $88deb11790acabb3$export$e4e3ac1fa64862db = $88deb11790acabb3$var$getDefaultSchemaConfig();
const $88deb11790acabb3$export$fd147e7d448dea03 = (0, $hXXvg.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(stage = 'final')=>{
    const defaultSchemaConfig = $88deb11790acabb3$var$getDefaultSchemaConfig();
    if (stage === 'stage0') {
        defaultSchemaConfig.customNodeSpecs = {
            layoutSection: (0, $cfGoW.layoutSectionWithSingleColumn),
            multiBodiedExtension: (0, $c6xL4.multiBodiedExtension),
            extensionFrame: (0, $c6xL4.extensionFrame),
            expand: (0, $1zZdw.expandWithNestedExpand),
            listItem: (0, $5mWOa.listItemWithFlexibleFirstChildStage0),
            taskList: (0, $19Zep.taskListWithFlexibleFirstChildStage0),
            table: (0, $1l3LJ.tableWithNestedTable),
            tableRow: (0, $1l3LJ.tableRowWithNestedTable),
            tableCell: (0, $1l3LJ.tableCellWithNestedTable),
            tableHeader: (0, $1l3LJ.tableHeaderWithNestedTable)
        };
        defaultSchemaConfig.customMarkSpecs = {
            fontSize: (0, $afs8i.fontSize)
        };
    }
    return (0, $jhvO2.createSchema)(defaultSchemaConfig);
});
const $88deb11790acabb3$export$1db618b7b2275ea1 = $88deb11790acabb3$export$fd147e7d448dea03();

});
parcelRegister("1zZdw", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => $c8315379f80db965$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => $c8315379f80db965$export$2ae5e7565ff9ffa6);
$parcel$export(module.exports, "toJSON", () => $c8315379f80db965$export$54fd2c36b5cc6731);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
function $c8315379f80db965$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $c8315379f80db965$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $c8315379f80db965$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $c8315379f80db965$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $c8315379f80db965$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $c8315379f80db965$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $c8315379f80db965$export$7b80cba28d10b2c1 = (0, $6niQM.expand)($c8315379f80db965$var$nodeSpecOptions);
const $c8315379f80db965$export$2ae5e7565ff9ffa6 = (0, $6niQM.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $c8315379f80db965$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $c8315379f80db965$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $c8315379f80db965$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $c8315379f80db965$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c8315379f80db965$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});
parcelRegister("6niQM", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $4cf635e82c394344$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $4cf635e82c394344$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $4cf635e82c394344$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockTaskItem", () => $4cf635e82c394344$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $4cf635e82c394344$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedSyncBlock", () => $4cf635e82c394344$export$e92c7e4302dd4371);
$parcel$export(module.exports, "bulletList", () => $4cf635e82c394344$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $4cf635e82c394344$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $4cf635e82c394344$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $4cf635e82c394344$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $4cf635e82c394344$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $4cf635e82c394344$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $4cf635e82c394344$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $4cf635e82c394344$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $4cf635e82c394344$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $4cf635e82c394344$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $4cf635e82c394344$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $4cf635e82c394344$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $4cf635e82c394344$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $4cf635e82c394344$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $4cf635e82c394344$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $4cf635e82c394344$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $4cf635e82c394344$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $4cf635e82c394344$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $4cf635e82c394344$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $4cf635e82c394344$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $4cf635e82c394344$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $4cf635e82c394344$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $4cf635e82c394344$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $4cf635e82c394344$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $4cf635e82c394344$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithFlexibleFirstChildStage0", () => $4cf635e82c394344$export$fcbecfed570fc881);
$parcel$export(module.exports, "media", () => $4cf635e82c394344$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $4cf635e82c394344$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $4cf635e82c394344$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $4cf635e82c394344$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $4cf635e82c394344$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $4cf635e82c394344$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $4cf635e82c394344$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $4cf635e82c394344$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $4cf635e82c394344$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $4cf635e82c394344$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $4cf635e82c394344$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $4cf635e82c394344$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $4cf635e82c394344$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $4cf635e82c394344$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $4cf635e82c394344$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $4cf635e82c394344$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "syncBlock", () => $4cf635e82c394344$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $4cf635e82c394344$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $4cf635e82c394344$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $4cf635e82c394344$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $4cf635e82c394344$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $4cf635e82c394344$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $4cf635e82c394344$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $4cf635e82c394344$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $4cf635e82c394344$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $4cf635e82c394344$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $4cf635e82c394344$export$375b6afcc5f4d291);
$parcel$export(module.exports, "taskListWithFlexibleFirstChildStage0", () => $4cf635e82c394344$export$3c86306d85ad1f18);
$parcel$export(module.exports, "text", () => $4cf635e82c394344$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $4cf635e82c394344$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $4cf635e82c394344$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $6WaV8 = parcelRequire("6WaV8");
const $4cf635e82c394344$export$c4c2f833baaebdb8 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $4cf635e82c394344$export$67dc04e652a298ca = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $4cf635e82c394344$export$199922e5af8e9a6 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $4cf635e82c394344$export$16018c61064a18df = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$27903d543b563e39 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $4cf635e82c394344$export$e7320d153c538837 = (0, $6WaV8.createPMNodeSpecFactory)({
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $4cf635e82c394344$export$e92c7e4302dd4371 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel | rule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation fontSize breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
const $4cf635e82c394344$export$a140c94e5ea26bee = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$8e3c2dfdc4f0453d = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $4cf635e82c394344$export$7bb0d5c671655cc4 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $4cf635e82c394344$export$e4f1c66d84049f8b = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $4cf635e82c394344$export$daf889beb5092f95 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $4cf635e82c394344$export$e6e4878f43c27cab = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $4cf635e82c394344$export$3e6d667072febc87 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $4cf635e82c394344$export$324d90190a8b822a = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$47988d68fe575725 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$6959e16eeff859b4 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $4cf635e82c394344$export$62d45a65fb43d95e = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$2a111da947c407d2 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation fontSize dataConsumer fragment breakout'
});
const $4cf635e82c394344$export$be4283d9a1cb1ff6 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$a19185d1233fc4b2 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$f5574b5d45fc2112 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$9f77e0932fb78f72 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $4cf635e82c394344$export$7e3788972005cc72 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $4cf635e82c394344$export$1b45514b112dd749 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$a8baf338431a691 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$b555be60c7703afb = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $4cf635e82c394344$export$371da9dd35aba193 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $4cf635e82c394344$export$46e4a324ac90507f = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$1b0c1557b234fa00 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$85461f751c457cc2 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$2b380a0f7e250af1 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$5c452ff88e35e47d = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $4cf635e82c394344$export$cbf8224b64e0d942 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $4cf635e82c394344$export$2f4e72b9459914ad = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $4cf635e82c394344$export$16b353b2649bd8d9 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$b3b1e36c2105006d = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$ab76e7c03cd6f650 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation fontSize dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $4cf635e82c394344$export$b3b6a70a7fa4a5be = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $4cf635e82c394344$export$cdae19acb0a520fd = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $4cf635e82c394344$export$206007566ca0aca5 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
const $4cf635e82c394344$export$76c7e83ecc9cdf05 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$fcbecfed570fc881 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$987d49ffe1b0900f = (0, $6WaV8.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$2855e964765eac9 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $4cf635e82c394344$export$38bab695e3f720f1 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$969fe3781ca15058 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $4cf635e82c394344$export$8d067f22dc2d1254 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$7e767666f2ce108a = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$4bd9a38995f6bf50 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$db83999c14438df4 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$46f790bd65f760d0 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$750e45819f66d9d0 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $4cf635e82c394344$export$63cadbf5f4296627 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $4cf635e82c394344$export$f03786aa6312d1e4 = (0, $6WaV8.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $4cf635e82c394344$export$a5dc81035676e7a = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$21f42ab9b6679f44 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$9c206ddddb32a9b = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$4f98472e6dc14293 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$ab32079c0da00ac2 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$d1c89394b5f252a = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$961993701b15405a = (0, $6WaV8.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$ea332b61641b0588 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$a1f41dc4901771f8 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$c7187bbd1a7a9244 = (0, $6WaV8.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $4cf635e82c394344$export$fbeb3a3956e8a3c7 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
const $4cf635e82c394344$export$471f7ae5c4103ae1 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$b6ce52be8d7a261 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$faab0ca9701d7048 = (0, $6WaV8.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$9852986a3ec5f6a0 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $4cf635e82c394344$export$ce086a560a1d05f5 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $4cf635e82c394344$export$e1e720e5f4603e6a = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $4cf635e82c394344$export$abf39ca178940ff3 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $4cf635e82c394344$export$48884d2a5190dc73 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $4cf635e82c394344$export$2a5a518232fa1a97 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $4cf635e82c394344$export$ce666bf02318c957 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $4cf635e82c394344$export$7d657479499397 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $4cf635e82c394344$export$6d8b0ef52e2e6390 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$375b6afcc5f4d291 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$3c86306d85ad1f18 = (0, $6WaV8.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $4cf635e82c394344$export$6f093cfa640b7166 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline'
});
const $4cf635e82c394344$export$5ea06bc686c59dc2 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline'
});
const $4cf635e82c394344$export$93256a4c17b33a82 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline'
});
const $4cf635e82c394344$export$a12828d0f14a2762 = (0, $6WaV8.createPMNodeSpecFactory)({});
const $4cf635e82c394344$export$44b79b0979d0f0f7 = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $4cf635e82c394344$export$310ebe0d80122e9b = (0, $6WaV8.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("6WaV8", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", () => $9bc4c31f6ed70efa$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $9bc4c31f6ed70efa$export$cf5823ed4e9f4c6f);
const $9bc4c31f6ed70efa$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $9bc4c31f6ed70efa$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});


parcelRegister("dARvh", function(module, exports) {
$parcel$export(module.exports, "generateUuid", () => $8e70d46e1f01ccab$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $8e70d46e1f01ccab$export$31b40729666a4ae0);
const $8e70d46e1f01ccab$export$1c3aefb711c3a4cc = ()=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/gu, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
let $8e70d46e1f01ccab$var$staticValue = false;
const $8e70d46e1f01ccab$export$31b40729666a4ae0 = {
    setStatic (value) {
        $8e70d46e1f01ccab$var$staticValue = value;
    },
    generate () {
        return $8e70d46e1f01ccab$var$staticValue || $8e70d46e1f01ccab$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("c6xL4", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", () => $a56d26679d335554$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $a56d26679d335554$export$c3c04d555a8b9013);

var $3ZqIM = parcelRequire("3ZqIM");

var $6niQM = parcelRequire("6niQM");
const $a56d26679d335554$export$4fdcae991fd743e7 = (0, $6niQM.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $a56d26679d335554$export$c3c04d555a8b9013 = (0, $6niQM.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $3ZqIM.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("3ZqIM", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", () => $a0f656e87244ca0f$export$1765e2758fc47004);
const $a0f656e87244ca0f$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $a0f656e87244ca0f$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $a0f656e87244ca0f$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("cfGoW", function(module, exports) {
$parcel$export(module.exports, "layoutSection", () => $d8fd98bb1b22daf3$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $d8fd98bb1b22daf3$export$4f9d8f623ff17117);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => $d8fd98bb1b22daf3$export$d9d3c69a64270b13);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => $d8fd98bb1b22daf3$export$64facded20dfd85c);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $d8fd98bb1b22daf3$export$b3b6a70a7fa4a5be = (0, $6niQM.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $d8fd98bb1b22daf3$export$cdae19acb0a520fd = (0, $6niQM.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $d8fd98bb1b22daf3$export$4f9d8f623ff17117 = (0, $6niQM.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $d8fd98bb1b22daf3$export$d9d3c69a64270b13 = (0, $6niQM.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $dARvh.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $d8fd98bb1b22daf3$export$64facded20dfd85c = (0, $6niQM.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $dARvh.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5mWOa", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $465483431d45de3c$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithLocalId", () => $465483431d45de3c$export$483d52f09158e61c);
$parcel$export(module.exports, "listItemWithFlexibleFirstChildStage0", () => $465483431d45de3c$export$fcbecfed570fc881);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $465483431d45de3c$export$76c7e83ecc9cdf05 = (0, $6niQM.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $465483431d45de3c$export$483d52f09158e61c = (0, $6niQM.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
const $465483431d45de3c$export$fcbecfed570fc881 = (0, $6niQM.listItemWithFlexibleFirstChildStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("1l3LJ", function(module, exports) {
$parcel$export(module.exports, "tablePrefixSelector", () => $c5cd6e634be6a252$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $c5cd6e634be6a252$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $c5cd6e634be6a252$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $c5cd6e634be6a252$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $c5cd6e634be6a252$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $c5cd6e634be6a252$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $c5cd6e634be6a252$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $c5cd6e634be6a252$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $c5cd6e634be6a252$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $c5cd6e634be6a252$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $c5cd6e634be6a252$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $c5cd6e634be6a252$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $c5cd6e634be6a252$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $c5cd6e634be6a252$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $c5cd6e634be6a252$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $c5cd6e634be6a252$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $c5cd6e634be6a252$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $c5cd6e634be6a252$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $c5cd6e634be6a252$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $c5cd6e634be6a252$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $c5cd6e634be6a252$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $c5cd6e634be6a252$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $c5cd6e634be6a252$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRowWithLocalId", () => $c5cd6e634be6a252$export$c8f0853ac97552c9);
$parcel$export(module.exports, "tableCellWithLocalId", () => $c5cd6e634be6a252$export$db76cfd28a574029);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => $c5cd6e634be6a252$export$b82d2b1d8824143d);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => $c5cd6e634be6a252$export$27926e30c8a74147);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => $c5cd6e634be6a252$export$e9fd700fafee293a);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => $c5cd6e634be6a252$export$7928c3aeb4cd2213);

var $56p2S = parcelRequire("56p2S");

var $lXFgC = parcelRequire("lXFgC");

var $dARvh = parcelRequire("dARvh");

var $l0Qcj = parcelRequire("l0Qcj");

var $6niQM = parcelRequire("6niQM");
const $c5cd6e634be6a252$export$9cfceb893b24742a = 'pm-table';
const $c5cd6e634be6a252$export$69cb4c3f80383763 = `${$c5cd6e634be6a252$export$9cfceb893b24742a}-cell-content-wrap`;
const $c5cd6e634be6a252$export$7b07d37d879c957f = `${$c5cd6e634be6a252$export$9cfceb893b24742a}-header-content-wrap`;
const $c5cd6e634be6a252$export$8dd42a84cd52da07 = `${$c5cd6e634be6a252$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $c5cd6e634be6a252$export$5e26a5c19f0865d8 = `${$c5cd6e634be6a252$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $c5cd6e634be6a252$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $lXFgC.N20).toLocaleLowerCase();
const $c5cd6e634be6a252$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    widthAttr && /^\d+(,\d+)*$/u.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $lXFgC.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $lXFgC.isRgb)(backgroundColor)) {
        const result = (0, $lXFgC.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        }
    };
};
// these are for test only
let $c5cd6e634be6a252$var$testGlobalTheme;
const $c5cd6e634be6a252$export$fd7e0dd2b74807f7 = (theme)=>{
    $c5cd6e634be6a252$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $c5cd6e634be6a252$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($c5cd6e634be6a252$var$testGlobalTheme) return {
        colorMode: $c5cd6e634be6a252$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $c5cd6e634be6a252$var$cssVariablePattern = /^var\(--.*\)$/u;
const $c5cd6e634be6a252$export$363c8dda799bfe9c = (node)=>{
    var _node$attrs;
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $c5cd6e634be6a252$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $c5cd6e634be6a252$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $lXFgC.isRgb)(background) && (0, $lXFgC.rgbToHex)(background) ? (0, $lXFgC.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $56p2S.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $c5cd6e634be6a252$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($c5cd6e634be6a252$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $l0Qcj.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $c5cd6e634be6a252$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $c5cd6e634be6a252$export$7b07d37d879c957f;
    else attrs.class = $c5cd6e634be6a252$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
const $c5cd6e634be6a252$export$219b7f492ad209f8 = new Map();
const $c5cd6e634be6a252$export$95e9c925fbf01d1c = (0, $lXFgC.hexToRgba)((0, $lXFgC.N800), 0.12) || (0, $lXFgC.N0);
const $c5cd6e634be6a252$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $lXFgC.N0),
        'White'
    ],
    [
        (0, $lXFgC.B50),
        'Light blue'
    ],
    [
        (0, $lXFgC.T50),
        'Light teal'
    ],
    [
        (0, $lXFgC.G50),
        'Light green'
    ],
    [
        (0, $lXFgC.Y50),
        'Light yellow'
    ],
    [
        (0, $lXFgC.R50),
        'Light red'
    ],
    [
        (0, $lXFgC.P50),
        'Light purple'
    ],
    [
        (0, $lXFgC.N20),
        'Light gray'
    ],
    [
        (0, $lXFgC.B75),
        'Blue'
    ],
    [
        (0, $lXFgC.T75),
        'Teal'
    ],
    [
        (0, $lXFgC.G75),
        'Green'
    ],
    [
        (0, $lXFgC.Y75),
        'Yellow'
    ],
    [
        (0, $lXFgC.R75),
        'Red'
    ],
    [
        (0, $lXFgC.P75),
        'Purple'
    ],
    [
        (0, $lXFgC.N60),
        'Gray'
    ],
    [
        (0, $lXFgC.B100),
        'Dark blue'
    ],
    [
        (0, $lXFgC.T100),
        'Dark teal'
    ],
    [
        (0, $lXFgC.G200),
        'Dark green'
    ],
    [
        (0, $lXFgC.Y200),
        'Dark yellow'
    ],
    [
        (0, $lXFgC.R100),
        'Dark red'
    ],
    [
        (0, $lXFgC.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $c5cd6e634be6a252$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $c5cd6e634be6a252$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
const $c5cd6e634be6a252$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $dARvh.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
const $c5cd6e634be6a252$var$createTableSpec = ()=>(0, $6niQM.table)($c5cd6e634be6a252$var$tableNodeSpecOptions);
const $c5cd6e634be6a252$export$9852986a3ec5f6a0 = $c5cd6e634be6a252$var$createTableSpec();
const $c5cd6e634be6a252$export$90e634fbace1f0c4 = $c5cd6e634be6a252$var$createTableSpec();
const $c5cd6e634be6a252$export$3862de5c8c9098cf = $c5cd6e634be6a252$var$createTableSpec();
const $c5cd6e634be6a252$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $c5cd6e634be6a252$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$c5cd6e634be6a252$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $c5cd6e634be6a252$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $c5cd6e634be6a252$export$ce666bf02318c957 = (0, $6niQM.tableRow)($c5cd6e634be6a252$var$tableRowNodeSpecOptions);
const $c5cd6e634be6a252$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
const $c5cd6e634be6a252$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (dom)=>$c5cd6e634be6a252$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $c5cd6e634be6a252$export$363c8dda799bfe9c(node),
            0
        ]
};
const $c5cd6e634be6a252$export$e1e720e5f4603e6a = (0, $6niQM.tableCell)($c5cd6e634be6a252$var$tableCellNodeSpecOptions);
const $c5cd6e634be6a252$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($c5cd6e634be6a252$var$cellAttrs[key] && $c5cd6e634be6a252$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $c5cd6e634be6a252$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $c5cd6e634be6a252$export$43977bde391e007(dom, {
                    background: $c5cd6e634be6a252$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $c5cd6e634be6a252$export$363c8dda799bfe9c(node),
            0
        ]
};
const $c5cd6e634be6a252$export$48884d2a5190dc73 = (0, $6niQM.tableHeader)($c5cd6e634be6a252$var$tableHeaderNodeSpecOptions);
const $c5cd6e634be6a252$export$2af48797a1010bb1 = $c5cd6e634be6a252$export$2ac34c099660f1a8;
const $c5cd6e634be6a252$export$ce086a560a1d05f5 = (0, $6niQM.tableWithNestedTable)($c5cd6e634be6a252$var$tableNodeSpecOptions);
const $c5cd6e634be6a252$export$7d657479499397 = (0, $6niQM.tableRowWithNestedTable)($c5cd6e634be6a252$var$tableRowNodeSpecOptions);
const $c5cd6e634be6a252$export$abf39ca178940ff3 = (0, $6niQM.tableCellWithNestedTable)($c5cd6e634be6a252$var$tableCellNodeSpecOptions);
const $c5cd6e634be6a252$export$2a5a518232fa1a97 = (0, $6niQM.tableHeaderWithNestedTable)($c5cd6e634be6a252$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $c5cd6e634be6a252$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
const $c5cd6e634be6a252$export$c8f0853ac97552c9 = (0, $6niQM.tableRow)($c5cd6e634be6a252$var$tableRowNodeSpecOptionsWithLocalId);
const $c5cd6e634be6a252$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $c5cd6e634be6a252$export$43977bde391e007(dom, {
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $c5cd6e634be6a252$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $c5cd6e634be6a252$export$db76cfd28a574029 = (0, $6niQM.tableCell)($c5cd6e634be6a252$var$tableCellNodeSpecOptionsWithLocalId);
const $c5cd6e634be6a252$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $c5cd6e634be6a252$export$43977bde391e007(dom, {
                    background: $c5cd6e634be6a252$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $c5cd6e634be6a252$export$363c8dda799bfe9c(node),
            0
        ]
};
const $c5cd6e634be6a252$export$b82d2b1d8824143d = (0, $6niQM.tableHeader)($c5cd6e634be6a252$var$tableHeaderNodeSpecOptionsWithLocalId);
const $c5cd6e634be6a252$export$27926e30c8a74147 = (0, $6niQM.tableRowWithNestedTable)($c5cd6e634be6a252$var$tableRowNodeSpecOptionsWithLocalId);
const $c5cd6e634be6a252$export$e9fd700fafee293a = (0, $6niQM.tableCellWithNestedTable)($c5cd6e634be6a252$var$tableCellNodeSpecOptionsWithLocalId);
const $c5cd6e634be6a252$export$7928c3aeb4cd2213 = (0, $6niQM.tableHeaderWithNestedTable)($c5cd6e634be6a252$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("56p2S", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $061fd21be880d2c1$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $061fd21be880d2c1$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $061fd21be880d2c1$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $061fd21be880d2c1$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $061fd21be880d2c1$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $061fd21be880d2c1$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $061fd21be880d2c1$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $061fd21be880d2c1$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $061fd21be880d2c1$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $061fd21be880d2c1$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $061fd21be880d2c1$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $061fd21be880d2c1$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $061fd21be880d2c1$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $061fd21be880d2c1$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = hexColor ? $061fd21be880d2c1$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $061fd21be880d2c1$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("lXFgC", function(module, exports) {
$parcel$export(module.exports, "R50", () => $e8c38aaf7e51e56b$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $e8c38aaf7e51e56b$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $e8c38aaf7e51e56b$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $e8c38aaf7e51e56b$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $e8c38aaf7e51e56b$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $e8c38aaf7e51e56b$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $e8c38aaf7e51e56b$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $e8c38aaf7e51e56b$export$5aae31392d72caaa);
$parcel$export(module.exports, "Yellow200", () => $e8c38aaf7e51e56b$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $e8c38aaf7e51e56b$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $e8c38aaf7e51e56b$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $e8c38aaf7e51e56b$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $e8c38aaf7e51e56b$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $e8c38aaf7e51e56b$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $e8c38aaf7e51e56b$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $e8c38aaf7e51e56b$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $e8c38aaf7e51e56b$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $e8c38aaf7e51e56b$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $e8c38aaf7e51e56b$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $e8c38aaf7e51e56b$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $e8c38aaf7e51e56b$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $e8c38aaf7e51e56b$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $e8c38aaf7e51e56b$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $e8c38aaf7e51e56b$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $e8c38aaf7e51e56b$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $e8c38aaf7e51e56b$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "Neutral300", () => $e8c38aaf7e51e56b$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $e8c38aaf7e51e56b$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $e8c38aaf7e51e56b$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $e8c38aaf7e51e56b$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $e8c38aaf7e51e56b$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $e8c38aaf7e51e56b$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $e8c38aaf7e51e56b$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $e8c38aaf7e51e56b$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $e8c38aaf7e51e56b$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $e8c38aaf7e51e56b$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $e8c38aaf7e51e56b$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $e8c38aaf7e51e56b$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $e8c38aaf7e51e56b$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $e8c38aaf7e51e56b$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $e8c38aaf7e51e56b$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $e8c38aaf7e51e56b$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $e8c38aaf7e51e56b$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $e8c38aaf7e51e56b$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $e8c38aaf7e51e56b$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $e8c38aaf7e51e56b$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $e8c38aaf7e51e56b$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $e8c38aaf7e51e56b$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $e8c38aaf7e51e56b$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgba", () => $e8c38aaf7e51e56b$export$9665a07d9187b414);
// @ts-ignore
// eslint-disable-next-line import/no-namespace

var $8sfHs = parcelRequire("8sfHs");
const $e8c38aaf7e51e56b$export$4b84fd0e2c617bd = '#FFEBE6';
const $e8c38aaf7e51e56b$export$b34b069eff244586 = '#FFBDAD';
const $e8c38aaf7e51e56b$export$be802dd0d8b57f35 = '#FF8F73';
const $e8c38aaf7e51e56b$export$4a7404f376229999 = '#FF5630';
const $e8c38aaf7e51e56b$export$2010d0fb4295b346 = '#DE350B';
const $e8c38aaf7e51e56b$export$2837b5a1a71d5c02 = '#BF2600';
const $e8c38aaf7e51e56b$export$8d9596b529bbb9cf = '#FFFAE6';
const $e8c38aaf7e51e56b$export$41060a744ab0b7ae = '#FFF0B3';
const $e8c38aaf7e51e56b$export$5aae31392d72caaa = '#FFC400';
const $e8c38aaf7e51e56b$export$fc857b6f8771648a = '#F8E6A0';
const $e8c38aaf7e51e56b$export$59619663aa6500fb = '#FF991F';
const $e8c38aaf7e51e56b$export$874739ea9e379ab6 = '#FF8B00';
const $e8c38aaf7e51e56b$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $e8c38aaf7e51e56b$export$69a3bf21b9686c2b = '#ABF5D1';
const $e8c38aaf7e51e56b$export$747d86715d4175de = '#57D9A3';
const $e8c38aaf7e51e56b$export$940e1f69e873f202 = '#36B37E';
const $e8c38aaf7e51e56b$export$a49394138f7b8e85 = '#00875A';
const $e8c38aaf7e51e56b$export$6fa04827ac68a4fb = '#006644';
const $e8c38aaf7e51e56b$export$226de0355ed012f8 = '#DEEBFF';
const $e8c38aaf7e51e56b$export$8c13c2ee36917869 = '#B3D4FF';
const $e8c38aaf7e51e56b$export$ecfc1dff386a3e7a = '#4C9AFF';
const $e8c38aaf7e51e56b$export$b3de0ae08da2ce64 = '#0052CC';
const $e8c38aaf7e51e56b$export$a6ee3d71bc067634 = '#0747A6';
const $e8c38aaf7e51e56b$export$f72948ef771f6f15 = '#D3F1A7';
const $e8c38aaf7e51e56b$export$29a4f05edc054374 = '#FFFFFF';
const $e8c38aaf7e51e56b$export$9fdfb749e33cdf97 = '#F4F5F7';
const $e8c38aaf7e51e56b$export$3e51e8f1440314ba = '#EBECF0';
const $e8c38aaf7e51e56b$export$1ce2d1575d444ceb = '#DFE1E6';
const $e8c38aaf7e51e56b$export$8754fc7e6d8b3000 = '#C1C7D0';
const $e8c38aaf7e51e56b$export$c2e91cbeada39b8b = '#B3BAC5';
const $e8c38aaf7e51e56b$export$eaa8c8a70ac22806 = '#97A0AF';
const $e8c38aaf7e51e56b$export$7c87d337fb91a97d = '#8993A4';
const $e8c38aaf7e51e56b$export$f563ee71e9ee74cd = '#6B778C';
const $e8c38aaf7e51e56b$export$e2ef2124cf4024b1 = '#5E6C84';
const $e8c38aaf7e51e56b$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $e8c38aaf7e51e56b$export$13609db0e6812ab8 = '#091E4224';
const $e8c38aaf7e51e56b$export$c39c0fe0f26207ae = '#42526E';
const $e8c38aaf7e51e56b$export$7090862dc3038a9f = '#758195';
const $e8c38aaf7e51e56b$export$7d61b15e0da132af = '#172B4D';
const $e8c38aaf7e51e56b$export$f78789c8b01753cd = '#172B4D';
const $e8c38aaf7e51e56b$export$a19f0c33186f7767 = '#FDD0EC';
const $e8c38aaf7e51e56b$export$51716a84e62e022c = '#FEDEC8';
const $e8c38aaf7e51e56b$export$363e4475840015bb = '#EAE6FF';
const $e8c38aaf7e51e56b$export$4b0a4417ed59760f = '#C0B6F2';
const $e8c38aaf7e51e56b$export$6011520a64d9a187 = '#998DD9';
const $e8c38aaf7e51e56b$export$a7175d4e9206bc80 = '#DFD8FD';
const $e8c38aaf7e51e56b$export$b48405b95304b5a1 = '#6554C0';
const $e8c38aaf7e51e56b$export$c71e4279dd54a18d = '#5243AA';
const $e8c38aaf7e51e56b$export$147899de772240ec = '#403294';
const $e8c38aaf7e51e56b$export$2cf711fe14c66f06 = '#E6FCFF';
const $e8c38aaf7e51e56b$export$7a8f4d33f6f9772c = '#B3F5FF';
const $e8c38aaf7e51e56b$export$776c9c497ef08533 = '#79E2F2';
const $e8c38aaf7e51e56b$export$69cb3ca10c1e330e = '#C6EDFB';
const $e8c38aaf7e51e56b$export$9dc1ef0f3f48059b = '#00B8D9';
const $e8c38aaf7e51e56b$export$6036577f95c3877e = '#008DA6';
function $e8c38aaf7e51e56b$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($e8c38aaf7e51e56b$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($e8c38aaf7e51e56b$export$e698776ec826343(color)) return $e8c38aaf7e51e56b$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $8sfHs.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $8sfHs.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $8sfHs.default[color];
        else if ($8sfHs && $8sfHs[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $8sfHs[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $e8c38aaf7e51e56b$export$5a544e13ad4e1fa5(color) {
    if (!$e8c38aaf7e51e56b$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $e8c38aaf7e51e56b$export$9665a07d9187b414(rawColor, alpha) {
    const color = $e8c38aaf7e51e56b$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>{
        // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[a-z0-9]{2}/giu).map((hex)=>parseInt(hex, 16));
    };
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $e8c38aaf7e51e56b$export$34d09c4a771c46ef(value) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const matches = value.match(/(0?\.?\d{1,3})%?\b/gu);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}
function $e8c38aaf7e51e56b$export$e698776ec826343(color) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    return /rgba?\(/u.test(color);
}
function $e8c38aaf7e51e56b$export$8a9b6341a7c96bc(color) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    return /^#([A-Fa-f0-9]{3}){1,2}$/u.test(color);
}

});
parcelRegister("8sfHs", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("l0Qcj", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", () => $733548723facb968$export$a5065c3b8aacaf99);
const $733548723facb968$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $733548723facb968$var$expandShorthandHex = (input)=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/iu, (m, r, g, b)=>r + r + g + g + b + b);
const $733548723facb968$var$rgbFromHex = (input)=>{
    const fullHex = $733548723facb968$var$expandShorthandHex(input);
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/iu.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $733548723facb968$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $733548723facb968$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $733548723facb968$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $733548723facb968$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $733548723facb968$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $733548723facb968$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $733548723facb968$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $733548723facb968$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $733548723facb968$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $733548723facb968$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $733548723facb968$var$rgbToLch = (rgb)=>$733548723facb968$var$labToLch($733548723facb968$var$xyzToLab($733548723facb968$var$rgbToXyz(rgb)));
const $733548723facb968$var$lchToRgb = (lch)=>$733548723facb968$var$xyzToRgb($733548723facb968$var$labToXyz($733548723facb968$var$lchToLab(lch)));
const $733548723facb968$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $733548723facb968$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $733548723facb968$var$rgbToLch(rgb);
    lch.l = $733548723facb968$var$clamp(newPercent, 0, 100);
    return $733548723facb968$var$rgbToHex($733548723facb968$var$lchToRgb(lch));
};
const $733548723facb968$var$getLightness = (color)=>{
    const rgb = $733548723facb968$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $733548723facb968$var$rgbToLch(rgb);
    return lch.l;
};
const $733548723facb968$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $733548723facb968$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $733548723facb968$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("19Zep", function(module, exports) {
$parcel$export(module.exports, "taskListSelector", () => $fe6f74e13d267fdd$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $fe6f74e13d267fdd$export$375b6afcc5f4d291);
$parcel$export(module.exports, "taskListWithFlexibleFirstChildStage0", () => $fe6f74e13d267fdd$export$3c86306d85ad1f18);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $fe6f74e13d267fdd$var$name = 'actionList';
const $fe6f74e13d267fdd$export$c0ec71adb7a18fb2 = `[data-node-type="${$fe6f74e13d267fdd$var$name}"]`;
const $fe6f74e13d267fdd$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: `div${$fe6f74e13d267fdd$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $fe6f74e13d267fdd$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $fe6f74e13d267fdd$export$375b6afcc5f4d291 = (0, $6niQM.taskList)($fe6f74e13d267fdd$var$taskListParseDOMAndToDOM);
const $fe6f74e13d267fdd$var$taskListWithFlexibleFirstChild = (0, $6niQM.taskListWithFlexibleFirstChildStage0)($fe6f74e13d267fdd$var$taskListParseDOMAndToDOM);
const $fe6f74e13d267fdd$export$3c86306d85ad1f18 = {
    ...$fe6f74e13d267fdd$var$taskListWithFlexibleFirstChild,
    // Generated spec omits PM group; keep taskList in block content for doc validation.
    group: 'block'
};

});

parcelRegister("jhvO2", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $81dc9f94ec0187b1$export$5f4ce795563f4211);

var $2sVuK = parcelRequire("2sVuK");

var $dRQR7 = parcelRequire("dRQR7");

var $hoy2L = parcelRequire("hoy2L");

var $bJhS2 = parcelRequire("bJhS2");
var $cB1Zx = parcelRequire("cB1Zx");
var $h1ROD = parcelRequire("h1ROD");
var $jeSVr = parcelRequire("jeSVr");
var $9K2YL = parcelRequire("9K2YL");
var $qLEY7 = parcelRequire("qLEY7");
var $dT6Ck = parcelRequire("dT6Ck");
var $gvebP = parcelRequire("gvebP");
var $dHWlQ = parcelRequire("dHWlQ");
var $afs8i = parcelRequire("afs8i");
var $kUQJJ = parcelRequire("kUQJJ");
var $9NM2G = parcelRequire("9NM2G");
var $MLmfK = parcelRequire("MLmfK");
var $iEg3S = parcelRequire("iEg3S");
var $6d9fl = parcelRequire("6d9fl");
var $dWQi9 = parcelRequire("dWQi9");
var $6G3OJ = parcelRequire("6G3OJ");
var $kzufT = parcelRequire("kzufT");
var $iAxma = parcelRequire("iAxma");
var $gROYo = parcelRequire("gROYo");
var $21qCn = parcelRequire("21qCn");

var $bmo08 = parcelRequire("bmo08");
var $bVo5t = parcelRequire("bVo5t");
var $6N6sU = parcelRequire("6N6sU");
var $i98aq = parcelRequire("i98aq");
var $aaUQA = parcelRequire("aaUQA");
var $fu8gK = parcelRequire("fu8gK");
var $fYiX1 = parcelRequire("fYiX1");
var $5UpiG = parcelRequire("5UpiG");
var $2I8tJ = parcelRequire("2I8tJ");
var $2M46G = parcelRequire("2M46G");
var $iqs9I = parcelRequire("iqs9I");
var $eUPLO = parcelRequire("eUPLO");
var $jzyhn = parcelRequire("jzyhn");
var $6IkW5 = parcelRequire("6IkW5");
var $46xgW = parcelRequire("46xgW");
var $g8C7z = parcelRequire("g8C7z");
var $1zZdw = parcelRequire("1zZdw");
var $9qlBc = parcelRequire("9qlBc");
var $6IEi1 = parcelRequire("6IEi1");
var $6bkzW = parcelRequire("6bkzW");
var $c6xL4 = parcelRequire("c6xL4");
var $9UYHL = parcelRequire("9UYHL");
var $4hcwN = parcelRequire("4hcwN");
var $41YoF = parcelRequire("41YoF");
var $bZFVH = parcelRequire("bZFVH");
var $6fM2i = parcelRequire("6fM2i");
var $daSDG = parcelRequire("daSDG");
var $cfGoW = parcelRequire("cfGoW");
var $5mWOa = parcelRequire("5mWOa");
var $9enxE = parcelRequire("9enxE");
var $55v2Q = parcelRequire("55v2Q");
var $1P6GE = parcelRequire("1P6GE");
var $bkx8J = parcelRequire("bkx8J");
var $d0FgX = parcelRequire("d0FgX");
var $4w5Cd = parcelRequire("4w5Cd");
var $e5Nys = parcelRequire("e5Nys");
var $1i5tx = parcelRequire("1i5tx");
var $brIWK = parcelRequire("brIWK");
var $bathP = parcelRequire("bathP");
var $hrZYn = parcelRequire("hrZYn");
var $8Mesg = parcelRequire("8Mesg");
var $1l3LJ = parcelRequire("1l3LJ");
var $19Zep = parcelRequire("19Zep");
var $gPa31 = parcelRequire("gPa31");
var $iY0Bz = parcelRequire("iY0Bz");
var $3ZtT7 = parcelRequire("3ZtT7");
var $is2Xi = parcelRequire("is2Xi");
function $81dc9f94ec0187b1$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $81dc9f94ec0187b1$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $81dc9f94ec0187b1$var$markGroupDeclarations = [
    $81dc9f94ec0187b1$var$groupDeclaration((0, $dRQR7.COLOR)),
    $81dc9f94ec0187b1$var$groupDeclaration((0, $dRQR7.FONT_STYLE)),
    $81dc9f94ec0187b1$var$groupDeclaration((0, $dRQR7.SEARCH_QUERY)),
    $81dc9f94ec0187b1$var$groupDeclaration((0, $dRQR7.LINK))
];
const $81dc9f94ec0187b1$var$markGroupDeclarationsNames = $81dc9f94ec0187b1$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $81dc9f94ec0187b1$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $6IkW5.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $1i5tx.paragraph)
    },
    {
        name: 'text',
        spec: (0, $gPa31.text)
    },
    {
        name: 'bulletList',
        spec: (0, $aaUQA.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $e5Nys.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $5mWOa.listItem)
    },
    {
        name: 'heading',
        spec: (0, $4hcwN.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $9qlBc.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $fYiX1.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $6IEi1.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $bathP.rule)
    },
    {
        name: 'image',
        spec: (0, $41YoF.image)
    },
    {
        name: 'mention',
        spec: (0, $d0FgX.mention)
    },
    {
        name: 'caption',
        spec: (0, $fu8gK.caption)
    },
    {
        name: 'media',
        spec: (0, $9enxE.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $55v2Q.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $bkx8J.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $1P6GE.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $brIWK.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $cfGoW.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $daSDG.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $9UYHL.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $g8C7z.emoji)
    },
    {
        name: 'table',
        spec: (0, $1l3LJ.table)
    },
    {
        name: 'tableCell',
        spec: (0, $1l3LJ.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $1l3LJ.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $1l3LJ.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $5UpiG.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $2M46G.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $2I8tJ.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $jzyhn.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $eUPLO.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $19Zep.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $bVo5t.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $bVo5t.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $iqs9I.date)
    },
    {
        name: 'status',
        spec: (0, $hrZYn.status)
    },
    {
        name: 'expand',
        spec: (0, $1zZdw.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $4w5Cd.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $6bkzW.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $6fM2i.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $6N6sU.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $c6xL4.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $c6xL4.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $bZFVH.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $bmo08.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $46xgW.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $8Mesg.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $i98aq.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $iY0Bz.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $3ZtT7.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $is2Xi.unsupportedInline)
    }
];
const $81dc9f94ec0187b1$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $MLmfK.link)
    },
    {
        name: 'em',
        spec: (0, $dHWlQ.em)
    },
    {
        name: 'strong',
        spec: (0, $6d9fl.strong)
    },
    {
        name: 'textColor',
        spec: (0, $6G3OJ.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $h1ROD.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $iEg3S.strike)
    },
    {
        name: 'subsup',
        spec: (0, $dWQi9.subsup)
    },
    {
        name: 'underline',
        spec: (0, $iAxma.underline)
    },
    {
        name: 'code',
        spec: (0, $qLEY7.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $kzufT.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $bJhS2.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $cB1Zx.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $dT6Ck.confluenceInlineComment)
    },
    ...$81dc9f94ec0187b1$var$markGroupDeclarations,
    {
        name: 'fontSize',
        spec: (0, $afs8i.fontSize)
    },
    {
        name: 'breakout',
        spec: (0, $9K2YL.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $gvebP.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $kUQJJ.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $9NM2G.indentation)
    },
    {
        name: 'border',
        spec: (0, $jeSVr.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $gROYo.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $21qCn.unsupportedNodeAttribute)
    }
];
function $81dc9f94ec0187b1$export$2d0c32a809131488() {
    const nodes = $81dc9f94ec0187b1$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $81dc9f94ec0187b1$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $81dc9f94ec0187b1$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($81dc9f94ec0187b1$var$markGroupDeclarationsNames);
    let nodes = $81dc9f94ec0187b1$var$addItems($81dc9f94ec0187b1$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $81dc9f94ec0187b1$var$addItems($81dc9f94ec0187b1$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $hoy2L.sanitizeNodes)(nodes, marks);
    return new (0, $2sVuK.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $81dc9f94ec0187b1$export$c77b6d30da5276a1 = true;

});
parcelRegister("2sVuK", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $1cbacb9353f8aa06$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $1cbacb9353f8aa06$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $1cbacb9353f8aa06$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $1cbacb9353f8aa06$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $1cbacb9353f8aa06$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $1cbacb9353f8aa06$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $1cbacb9353f8aa06$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $1cbacb9353f8aa06$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $1cbacb9353f8aa06$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $1cbacb9353f8aa06$export$3476b78f8f5a8b72);

var $gfs8j = parcelRequire("gfs8j");
function $1cbacb9353f8aa06$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $1cbacb9353f8aa06$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $1cbacb9353f8aa06$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $1cbacb9353f8aa06$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $1cbacb9353f8aa06$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $1cbacb9353f8aa06$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $1cbacb9353f8aa06$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $1cbacb9353f8aa06$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $1cbacb9353f8aa06$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $1cbacb9353f8aa06$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $1cbacb9353f8aa06$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $1cbacb9353f8aa06$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $1cbacb9353f8aa06$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $1cbacb9353f8aa06$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $1cbacb9353f8aa06$var$retIndex(0, pos);
        if (pos == this.size) return $1cbacb9353f8aa06$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $1cbacb9353f8aa06$var$retIndex(i + 1, end);
                return $1cbacb9353f8aa06$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $1cbacb9353f8aa06$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $1cbacb9353f8aa06$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $1cbacb9353f8aa06$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $1cbacb9353f8aa06$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $1cbacb9353f8aa06$export$ffb0004e005737fa.empty;
        if (nodes instanceof $1cbacb9353f8aa06$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $1cbacb9353f8aa06$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $1cbacb9353f8aa06$export$ffb0004e005737fa.empty = new $1cbacb9353f8aa06$export$ffb0004e005737fa([], 0);
const $1cbacb9353f8aa06$var$found = {
    index: 0,
    offset: 0
};
function $1cbacb9353f8aa06$var$retIndex(index, offset) {
    $1cbacb9353f8aa06$var$found.index = index;
    $1cbacb9353f8aa06$var$found.offset = offset;
    return $1cbacb9353f8aa06$var$found;
}
function $1cbacb9353f8aa06$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$1cbacb9353f8aa06$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$1cbacb9353f8aa06$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $1cbacb9353f8aa06$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $1cbacb9353f8aa06$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none;
        if (marks instanceof $1cbacb9353f8aa06$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $1cbacb9353f8aa06$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $1cbacb9353f8aa06$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e($1cbacb9353f8aa06$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e($1cbacb9353f8aa06$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e.empty = new $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e($1cbacb9353f8aa06$export$ffb0004e005737fa.empty, 0, 0);
function $1cbacb9353f8aa06$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($1cbacb9353f8aa06$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $1cbacb9353f8aa06$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $1cbacb9353f8aa06$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $1cbacb9353f8aa06$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $1cbacb9353f8aa06$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $1cbacb9353f8aa06$export$6de0e778727af3f2("Inconsistent open depths");
    return $1cbacb9353f8aa06$var$replaceOuter($from, $to, slice, 0);
}
function $1cbacb9353f8aa06$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $1cbacb9353f8aa06$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $1cbacb9353f8aa06$var$close(node, $1cbacb9353f8aa06$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $1cbacb9353f8aa06$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $1cbacb9353f8aa06$var$prepareSliceForReplace(slice, $from);
        return $1cbacb9353f8aa06$var$close(node, $1cbacb9353f8aa06$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $1cbacb9353f8aa06$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $1cbacb9353f8aa06$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $1cbacb9353f8aa06$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $1cbacb9353f8aa06$var$checkJoin(node, $after.node(depth));
    return node;
}
function $1cbacb9353f8aa06$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $1cbacb9353f8aa06$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $1cbacb9353f8aa06$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$1cbacb9353f8aa06$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $1cbacb9353f8aa06$var$addNode($end.nodeBefore, target);
}
function $1cbacb9353f8aa06$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $1cbacb9353f8aa06$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $1cbacb9353f8aa06$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $1cbacb9353f8aa06$var$joinable($end, $to, depth + 1);
    let content = [];
    $1cbacb9353f8aa06$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $1cbacb9353f8aa06$var$checkJoin(openStart, openEnd);
        $1cbacb9353f8aa06$var$addNode($1cbacb9353f8aa06$var$close(openStart, $1cbacb9353f8aa06$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $1cbacb9353f8aa06$var$addNode($1cbacb9353f8aa06$var$close(openStart, $1cbacb9353f8aa06$var$replaceTwoWay($from, $start, depth + 1)), content);
        $1cbacb9353f8aa06$var$addRange($start, $end, depth, content);
        if (openEnd) $1cbacb9353f8aa06$var$addNode($1cbacb9353f8aa06$var$close(openEnd, $1cbacb9353f8aa06$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $1cbacb9353f8aa06$var$addRange($to, null, depth, content);
    return new $1cbacb9353f8aa06$export$ffb0004e005737fa(content);
}
function $1cbacb9353f8aa06$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $1cbacb9353f8aa06$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $1cbacb9353f8aa06$var$joinable($from, $to, depth + 1);
        $1cbacb9353f8aa06$var$addNode($1cbacb9353f8aa06$var$close(type, $1cbacb9353f8aa06$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $1cbacb9353f8aa06$var$addRange($to, null, depth, content);
    return new $1cbacb9353f8aa06$export$ffb0004e005737fa(content);
}
function $1cbacb9353f8aa06$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($1cbacb9353f8aa06$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $1cbacb9353f8aa06$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $1cbacb9353f8aa06$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $1cbacb9353f8aa06$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $1cbacb9353f8aa06$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $1cbacb9353f8aa06$var$resolveCache.set(doc, cache = new $1cbacb9353f8aa06$var$ResolveCache);
        let result = cache.elts[cache.i] = $1cbacb9353f8aa06$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $1cbacb9353f8aa06$var$resolveCacheSize;
        return result;
    }
}
class $1cbacb9353f8aa06$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $1cbacb9353f8aa06$var$resolveCacheSize = 12, $1cbacb9353f8aa06$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $1cbacb9353f8aa06$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $1cbacb9353f8aa06$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $1cbacb9353f8aa06$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $1cbacb9353f8aa06$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $1cbacb9353f8aa06$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $1cbacb9353f8aa06$var$emptyAttrs) && $1cbacb9353f8aa06$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $1cbacb9353f8aa06$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $1cbacb9353f8aa06$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $1cbacb9353f8aa06$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $1cbacb9353f8aa06$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $1cbacb9353f8aa06$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $1cbacb9353f8aa06$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $1cbacb9353f8aa06$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$1cbacb9353f8aa06$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $1cbacb9353f8aa06$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$1cbacb9353f8aa06$export$85c928794f8d04d4.prototype.text = undefined;
class $1cbacb9353f8aa06$var$TextNode extends $1cbacb9353f8aa06$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $1cbacb9353f8aa06$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $1cbacb9353f8aa06$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $1cbacb9353f8aa06$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $1cbacb9353f8aa06$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $1cbacb9353f8aa06$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $1cbacb9353f8aa06$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $1cbacb9353f8aa06$export$364ed450558d7ec4.empty;
        let expr = $1cbacb9353f8aa06$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $1cbacb9353f8aa06$var$dfa($1cbacb9353f8aa06$var$nfa(expr));
        $1cbacb9353f8aa06$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $1cbacb9353f8aa06$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $1cbacb9353f8aa06$export$364ed450558d7ec4.empty = new $1cbacb9353f8aa06$export$364ed450558d7ec4(true);
class $1cbacb9353f8aa06$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $1cbacb9353f8aa06$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($1cbacb9353f8aa06$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $1cbacb9353f8aa06$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($1cbacb9353f8aa06$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $1cbacb9353f8aa06$var$parseExprSubscript(stream) {
    let expr = $1cbacb9353f8aa06$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $1cbacb9353f8aa06$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $1cbacb9353f8aa06$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $1cbacb9353f8aa06$var$parseExprRange(stream, expr) {
    let min = $1cbacb9353f8aa06$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $1cbacb9353f8aa06$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $1cbacb9353f8aa06$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $1cbacb9353f8aa06$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $1cbacb9353f8aa06$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $1cbacb9353f8aa06$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $1cbacb9353f8aa06$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $1cbacb9353f8aa06$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $1cbacb9353f8aa06$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($1cbacb9353f8aa06$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $1cbacb9353f8aa06$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($1cbacb9353f8aa06$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $1cbacb9353f8aa06$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $1cbacb9353f8aa06$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($1cbacb9353f8aa06$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $1cbacb9353f8aa06$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $1cbacb9353f8aa06$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $1cbacb9353f8aa06$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $1cbacb9353f8aa06$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $1cbacb9353f8aa06$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $1cbacb9353f8aa06$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $1cbacb9353f8aa06$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $1cbacb9353f8aa06$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $1cbacb9353f8aa06$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $1cbacb9353f8aa06$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $1cbacb9353f8aa06$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $1cbacb9353f8aa06$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $1cbacb9353f8aa06$export$ffb0004e005737fa.from(content), $1cbacb9353f8aa06$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $1cbacb9353f8aa06$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $1cbacb9353f8aa06$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $1cbacb9353f8aa06$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $1cbacb9353f8aa06$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($1cbacb9353f8aa06$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $1cbacb9353f8aa06$export$85c928794f8d04d4(this, attrs, content.append(after), $1cbacb9353f8aa06$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $1cbacb9353f8aa06$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $1cbacb9353f8aa06$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $1cbacb9353f8aa06$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $1cbacb9353f8aa06$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $1cbacb9353f8aa06$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $1cbacb9353f8aa06$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $1cbacb9353f8aa06$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $1cbacb9353f8aa06$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $1cbacb9353f8aa06$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $1cbacb9353f8aa06$export$c9d15bcfc6d42044(this, $1cbacb9353f8aa06$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $1cbacb9353f8aa06$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $1cbacb9353f8aa06$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $1cbacb9353f8aa06$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $gfs8j.default).from(spec.nodes), instanceSpec.marks = (0, $gfs8j.default).from(spec.marks || {}), this.nodes = $1cbacb9353f8aa06$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $1cbacb9353f8aa06$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $1cbacb9353f8aa06$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $1cbacb9353f8aa06$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $1cbacb9353f8aa06$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $1cbacb9353f8aa06$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $1cbacb9353f8aa06$var$TextNode(type, type.defaultAttrs, text, $1cbacb9353f8aa06$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $1cbacb9353f8aa06$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $1cbacb9353f8aa06$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $1cbacb9353f8aa06$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $1cbacb9353f8aa06$var$isTagRule(rule) {
    return rule.tag != null;
}
function $1cbacb9353f8aa06$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $1cbacb9353f8aa06$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($1cbacb9353f8aa06$var$isTagRule(rule)) this.tags.push(rule);
            else if ($1cbacb9353f8aa06$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $1cbacb9353f8aa06$var$ParseContext(this, options, false);
        context.addAll(dom, $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $1cbacb9353f8aa06$var$ParseContext(this, options, true);
        context.addAll(dom, $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $1cbacb9353f8aa06$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($1cbacb9353f8aa06$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $1cbacb9353f8aa06$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $1cbacb9353f8aa06$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $1cbacb9353f8aa06$export$1059c6e7d2ce5669(schema, $1cbacb9353f8aa06$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $1cbacb9353f8aa06$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $1cbacb9353f8aa06$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $1cbacb9353f8aa06$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $1cbacb9353f8aa06$var$OPT_PRESERVE_WS = 1, $1cbacb9353f8aa06$var$OPT_PRESERVE_WS_FULL = 2, $1cbacb9353f8aa06$var$OPT_OPEN_LEFT = 4;
function $1cbacb9353f8aa06$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $1cbacb9353f8aa06$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $1cbacb9353f8aa06$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $1cbacb9353f8aa06$var$OPT_PRESERVE_WS | $1cbacb9353f8aa06$var$OPT_PRESERVE_WS_FULL : base & ~$1cbacb9353f8aa06$var$OPT_OPEN_LEFT;
}
class $1cbacb9353f8aa06$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $1cbacb9353f8aa06$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($1cbacb9353f8aa06$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $1cbacb9353f8aa06$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $1cbacb9353f8aa06$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($1cbacb9353f8aa06$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$1cbacb9353f8aa06$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $1cbacb9353f8aa06$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $1cbacb9353f8aa06$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $1cbacb9353f8aa06$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $1cbacb9353f8aa06$var$NodeContext(topNode.type, topNode.attrs, $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $1cbacb9353f8aa06$var$NodeContext(null, null, $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $1cbacb9353f8aa06$var$NodeContext(parser.schema.topNodeType, null, $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $1cbacb9353f8aa06$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $1cbacb9353f8aa06$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($1cbacb9353f8aa06$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $1cbacb9353f8aa06$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $1cbacb9353f8aa06$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($1cbacb9353f8aa06$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $1cbacb9353f8aa06$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $1cbacb9353f8aa06$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $1cbacb9353f8aa06$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $1cbacb9353f8aa06$var$OPT_OPEN_LEFT;
        let applyMarks = $1cbacb9353f8aa06$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $1cbacb9353f8aa06$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $1cbacb9353f8aa06$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $1cbacb9353f8aa06$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $1cbacb9353f8aa06$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $1cbacb9353f8aa06$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $1cbacb9353f8aa06$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $1cbacb9353f8aa06$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $1cbacb9353f8aa06$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $1cbacb9353f8aa06$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $1cbacb9353f8aa06$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $1cbacb9353f8aa06$var$renderSpec($1cbacb9353f8aa06$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $1cbacb9353f8aa06$var$renderSpec($1cbacb9353f8aa06$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $1cbacb9353f8aa06$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $1cbacb9353f8aa06$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $1cbacb9353f8aa06$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $1cbacb9353f8aa06$var$gatherToDOM(schema.marks);
    }
}
function $1cbacb9353f8aa06$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $1cbacb9353f8aa06$var$doc(options) {
    return options.document || window.document;
}
const $1cbacb9353f8aa06$var$suspiciousAttributeCache = new WeakMap();
function $1cbacb9353f8aa06$var$suspiciousAttributes(attrs) {
    let value = $1cbacb9353f8aa06$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $1cbacb9353f8aa06$var$suspiciousAttributeCache.set(attrs, value = $1cbacb9353f8aa06$var$suspiciousAttributesInner(attrs));
    return value;
}
function $1cbacb9353f8aa06$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $1cbacb9353f8aa06$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $1cbacb9353f8aa06$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $1cbacb9353f8aa06$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("gfs8j", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd43deb576c372e5$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $bd43deb576c372e5$var$OrderedMap(content) {
    this.content = content;
}
$bd43deb576c372e5$var$OrderedMap.prototype = {
    constructor: $bd43deb576c372e5$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $bd43deb576c372e5$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $bd43deb576c372e5$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $bd43deb576c372e5$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $bd43deb576c372e5$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $bd43deb576c372e5$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $bd43deb576c372e5$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $bd43deb576c372e5$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $bd43deb576c372e5$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $bd43deb576c372e5$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $bd43deb576c372e5$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$bd43deb576c372e5$var$OrderedMap.from = function(value) {
    if (value instanceof $bd43deb576c372e5$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $bd43deb576c372e5$var$OrderedMap(content);
};
var $bd43deb576c372e5$export$2e2bcd8739ae039 = $bd43deb576c372e5$var$OrderedMap;

});


parcelRegister("dRQR7", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", () => $f08fc4f40fea2944$export$4498a6080fed604c);
$parcel$export(module.exports, "SEARCH_QUERY", () => $f08fc4f40fea2944$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "LINK", () => $f08fc4f40fea2944$export$b395009ca7f092c7);
$parcel$export(module.exports, "COLOR", () => $f08fc4f40fea2944$export$9b982809044276a6);
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $f08fc4f40fea2944$export$4498a6080fed604c = 'fontStyle';
const $f08fc4f40fea2944$export$f8e8a5f34f6ea725 = 'searchQuery';
const $f08fc4f40fea2944$export$b395009ca7f092c7 = 'link';
const $f08fc4f40fea2944$export$9b982809044276a6 = 'color';
const $f08fc4f40fea2944$export$470d0905851e47a1 = 'alignment';
const $f08fc4f40fea2944$export$bacb7f4b06a06b22 = 'indentation';

});

parcelRegister("hoy2L", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", () => $3c0cd543361f490e$export$daf54fed04c8fb77);
function $3c0cd543361f490e$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $3c0cd543361f490e$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $3c0cd543361f490e$var$sanitizeNodeSpecContent(nodes, rawContent) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const content = rawContent.replace(/\W/gu, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$3c0cd543361f490e$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$3c0cd543361f490e$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $3c0cd543361f490e$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    if (!content || !content.match(/\w/u)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $3c0cd543361f490e$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("bJhS2", function(module, exports) {
$parcel$export(module.exports, "alignmentPositionMap", () => $2353462e843dcf3b$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $2353462e843dcf3b$export$8e53000a4ec837);

var $hG4P5 = parcelRequire("hG4P5");
const $2353462e843dcf3b$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $2353462e843dcf3b$export$8e53000a4ec837 = (0, $hG4P5.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("hG4P5", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $883b2be70abb7fcb$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $883b2be70abb7fcb$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $883b2be70abb7fcb$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $883b2be70abb7fcb$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $883b2be70abb7fcb$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $883b2be70abb7fcb$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $883b2be70abb7fcb$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $883b2be70abb7fcb$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $883b2be70abb7fcb$export$c63c6f932822f543);
$parcel$export(module.exports, "fontSize", () => $883b2be70abb7fcb$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $883b2be70abb7fcb$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $883b2be70abb7fcb$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $883b2be70abb7fcb$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $883b2be70abb7fcb$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $883b2be70abb7fcb$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $883b2be70abb7fcb$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $883b2be70abb7fcb$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $883b2be70abb7fcb$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $883b2be70abb7fcb$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $883b2be70abb7fcb$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $883b2be70abb7fcb$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $6WaV8 = parcelRequire("6WaV8");
const $883b2be70abb7fcb$export$8e53000a4ec837 = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $883b2be70abb7fcb$export$8512c9afa7b24c3b = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $883b2be70abb7fcb$export$8c5a050822fd698c = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $883b2be70abb7fcb$export$1edee58a52776cd9 = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $883b2be70abb7fcb$export$89015c65f1c75e3f = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $883b2be70abb7fcb$export$6565f9f03506010b = (0, $6WaV8.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $883b2be70abb7fcb$export$f3b72f8fc4684ecd = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $883b2be70abb7fcb$export$3024f02c495408d6 = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $883b2be70abb7fcb$export$c63c6f932822f543 = (0, $6WaV8.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $883b2be70abb7fcb$export$85e3c3ca0c6fb93 = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    }
});
const $883b2be70abb7fcb$export$f00aeb236b6f05af = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $883b2be70abb7fcb$export$480c699bd4ec0d86 = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $883b2be70abb7fcb$export$9c30223ca0a664fb = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $883b2be70abb7fcb$export$4899a95d70ec5056 = (0, $6WaV8.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $883b2be70abb7fcb$export$59ae2c325a998f89 = (0, $6WaV8.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $883b2be70abb7fcb$export$b3401ee80eb31041 = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $883b2be70abb7fcb$export$32f78bffcd82ff28 = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $883b2be70abb7fcb$export$20af3dabbb5538df = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $883b2be70abb7fcb$export$425327af25286e5e = (0, $6WaV8.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $883b2be70abb7fcb$export$30d78d5eb6719bb8 = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $883b2be70abb7fcb$export$a316dc07ff5182a2 = (0, $6WaV8.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("cB1Zx", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", () => $b2912bde33e8cf2c$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $b2912bde33e8cf2c$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $b2912bde33e8cf2c$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $b2912bde33e8cf2c$export$8512c9afa7b24c3b);

var $hG4P5 = parcelRequire("hG4P5");
var $b2912bde33e8cf2c$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $b2912bde33e8cf2c$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $b2912bde33e8cf2c$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $b2912bde33e8cf2c$export$8512c9afa7b24c3b = (0, $hG4P5.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$b2912bde33e8cf2c$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("h1ROD", function(module, exports) {
$parcel$export(module.exports, "backgroundColorPalette", () => $d766d2a43ec6e7c6$export$14ec3f21a268e497);
$parcel$export(module.exports, "backgroundColor", () => $d766d2a43ec6e7c6$export$8c5a050822fd698c);

var $hG4P5 = parcelRequire("hG4P5");

var $56p2S = parcelRequire("56p2S");

var $lXFgC = parcelRequire("lXFgC");

var $6G3OJ = parcelRequire("6G3OJ");

var $l0Qcj = parcelRequire("l0Qcj");
const $d766d2a43ec6e7c6$var$colorArrayPalette = [
    [
        (0, $lXFgC.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $lXFgC.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $lXFgC.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $lXFgC.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $lXFgC.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $lXFgC.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $lXFgC.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
const $d766d2a43ec6e7c6$export$14ec3f21a268e497 = new Map();
$d766d2a43ec6e7c6$var$colorArrayPalette.forEach(([color, label])=>$d766d2a43ec6e7c6$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $d766d2a43ec6e7c6$export$8c5a050822fd698c = (0, $hG4P5.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                if (value.match(/^rgb/iu)) hexColor = (0, $lXFgC.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $d766d2a43ec6e7c6$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $d766d2a43ec6e7c6$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $56p2S.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $6G3OJ.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $l0Qcj.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("6G3OJ", function(module, exports) {
$parcel$export(module.exports, "colorPalette", () => $38ee2097939900a4$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $38ee2097939900a4$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $38ee2097939900a4$export$32f78bffcd82ff28);

var $hG4P5 = parcelRequire("hG4P5");

var $56p2S = parcelRequire("56p2S");

var $lXFgC = parcelRequire("lXFgC");

var $l0Qcj = parcelRequire("l0Qcj");
// used for extended palette in text color picker
const $38ee2097939900a4$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $lXFgC.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $lXFgC.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $lXFgC.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $lXFgC.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $lXFgC.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $lXFgC.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $lXFgC.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $lXFgC.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $lXFgC.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $lXFgC.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $lXFgC.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $lXFgC.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $lXFgC.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $lXFgC.N0),
        'White'
    ],
    [
        (0, $lXFgC.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $lXFgC.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $lXFgC.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $lXFgC.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $lXFgC.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $lXFgC.P50),
        'Light purple'
    ] // Lavender secret
];
const $38ee2097939900a4$export$569885e57444f84a = new Map();
const $38ee2097939900a4$export$81e5ed9e84fe2e28 = $38ee2097939900a4$export$569885e57444f84a;
$38ee2097939900a4$var$colorArrayPalette.forEach(([color, label])=>$38ee2097939900a4$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $38ee2097939900a4$var$testGlobalTheme;
const $38ee2097939900a4$export$fd7e0dd2b74807f7 = (theme)=>{
    $38ee2097939900a4$var$testGlobalTheme = theme;
};
const $38ee2097939900a4$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($38ee2097939900a4$var$testGlobalTheme) return {
        colorMode: $38ee2097939900a4$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $38ee2097939900a4$export$32f78bffcd82ff28 = (0, $hG4P5.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                if (value.match(/^rgb/iu)) hexColor = (0, $lXFgC.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $38ee2097939900a4$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $38ee2097939900a4$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $56p2S.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($38ee2097939900a4$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $l0Qcj.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("jeSVr", function(module, exports) {
$parcel$export(module.exports, "borderColorPalette", () => $11be597fc1478464$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $11be597fc1478464$export$1edee58a52776cd9);

var $hG4P5 = parcelRequire("hG4P5");

var $56p2S = parcelRequire("56p2S");

var $lXFgC = parcelRequire("lXFgC");
const $11be597fc1478464$var$borderColorArrayPalette = [
    [
        (0, $lXFgC.N300A),
        'Subtle gray'
    ],
    [
        (0, $lXFgC.N600),
        'Gray'
    ],
    [
        (0, $lXFgC.N1000),
        'Bold gray'
    ]
];
const $11be597fc1478464$export$e4e044c989c86ca7 = new Map();
$11be597fc1478464$var$borderColorArrayPalette.forEach(([color, label])=>$11be597fc1478464$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $11be597fc1478464$export$1edee58a52776cd9 = (0, $hG4P5.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const color = (dom.getAttribute('data-color') ?? '').toLowerCase();
                const size = +(dom.getAttribute('data-size') ?? '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $11be597fc1478464$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $56p2S.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("9K2YL", function(module, exports) {
$parcel$export(module.exports, "breakout", () => $bbda8ea2ac00b19a$export$89015c65f1c75e3f);

var $hG4P5 = parcelRequire("hG4P5");
const $bbda8ea2ac00b19a$var$allowedTypes = [
    'wide',
    'full-width'
];
const $bbda8ea2ac00b19a$export$89015c65f1c75e3f = (0, $hG4P5.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const width = dom.getAttribute('data-width');
                return {
                    mode: $bbda8ea2ac00b19a$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("qLEY7", function(module, exports) {
$parcel$export(module.exports, "code", () => $924aecba109d7ead$export$6565f9f03506010b);

var $hG4P5 = parcelRequire("hG4P5");
const $924aecba109d7ead$export$6565f9f03506010b = (0, $hG4P5.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("dT6Ck", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", () => $40ba0013e3dc9e6e$export$f3b72f8fc4684ecd);

var $hG4P5 = parcelRequire("hG4P5");
const $40ba0013e3dc9e6e$export$f3b72f8fc4684ecd = (0, $hG4P5.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("gvebP", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", () => $6dd75114d88e2be1$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $6dd75114d88e2be1$export$54fd2c36b5cc6731);

var $hG4P5 = parcelRequire("hG4P5");

var $igwcf = parcelRequire("igwcf");
const $6dd75114d88e2be1$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $igwcf.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $6dd75114d88e2be1$export$3024f02c495408d6 = (0, $hG4P5.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$6dd75114d88e2be1$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $6dd75114d88e2be1$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("igwcf", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", () => $27e81ae5598aed60$export$c296e2d4365c37a5);
const $27e81ae5598aed60$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("dHWlQ", function(module, exports) {
$parcel$export(module.exports, "em", () => $f208886e9e1189de$export$c63c6f932822f543);

var $hG4P5 = parcelRequire("hG4P5");
const $f208886e9e1189de$var$emDOM = [
    'em'
];
const $f208886e9e1189de$export$c63c6f932822f543 = (0, $hG4P5.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $f208886e9e1189de$var$emDOM;
    }
});

});

parcelRegister("afs8i", function(module, exports) {
$parcel$export(module.exports, "fontSize", () => $694a7310e763754e$export$85e3c3ca0c6fb93);

var $hG4P5 = parcelRequire("hG4P5");
const $694a7310e763754e$var$allowedSizes = [
    'small'
];
const $694a7310e763754e$export$85e3c3ca0c6fb93 = (0, $hG4P5.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $694a7310e763754e$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});

});

parcelRegister("kUQJJ", function(module, exports) {
$parcel$export(module.exports, "fragment", () => $5c63db94c713a05a$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $5c63db94c713a05a$export$54fd2c36b5cc6731);

var $hG4P5 = parcelRequire("hG4P5");

var $igwcf = parcelRequire("igwcf");
const $5c63db94c713a05a$var$parseFragment = (maybeValue)=>{
    if (!(0, $igwcf.isDOMElement)(maybeValue)) return false;
    const name = maybeValue.getAttribute('data-name') ?? undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $5c63db94c713a05a$export$f00aeb236b6f05af = (0, $hG4P5.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$5c63db94c713a05a$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $5c63db94c713a05a$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("9NM2G", function(module, exports) {
$parcel$export(module.exports, "indentation", () => $ab7f398157c5323d$export$480c699bd4ec0d86);

var $hG4P5 = parcelRequire("hG4P5");
const $ab7f398157c5323d$export$480c699bd4ec0d86 = (0, $hG4P5.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("MLmfK", function(module, exports) {
$parcel$export(module.exports, "link", () => $e6275363c537da63$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $e6275363c537da63$export$54fd2c36b5cc6731);

var $hG4P5 = parcelRequire("hG4P5");

var $crC8K = parcelRequire("crC8K");
const $e6275363c537da63$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $crC8K.isSafeUrl)(href)) return false;
        if ((0, $crC8K.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $crC8K.normalizeUrl)(href);
        return attrs;
    };
const $e6275363c537da63$export$9c30223ca0a664fb = (0, $hG4P5.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $e6275363c537da63$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $e6275363c537da63$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $crC8K.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $e6275363c537da63$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $e6275363c537da63$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($e6275363c537da63$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("crC8K", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $7a17f0f6029c5b2a$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $7a17f0f6029c5b2a$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $7a17f0f6029c5b2a$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $7a17f0f6029c5b2a$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $7a17f0f6029c5b2a$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $7a17f0f6029c5b2a$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $hcXsa = parcelRequire("hcXsa");
const $7a17f0f6029c5b2a$var$whitelistedURLPatterns = [
    /^https?:\/\//imu,
    /^ftps?:\/\//imu,
    /^gopher:\/\//imu,
    /^integrity:\/\//imu,
    /^file:\/\//imu,
    /^smb:\/\//imu,
    /^dynamicsnav:\/\//imu,
    /^jamfselfservice:\/\//imu,
    /^\//imu,
    /^mailto:/imu,
    /^skype:/imu,
    /^callto:/imu,
    /^facetime:/imu,
    /^git:/imu,
    /^irc6?:/imu,
    /^news:/imu,
    /^nntp:/imu,
    /^feed:/imu,
    /^cvs:/imu,
    /^svn:/imu,
    /^mvn:/imu,
    /^ssh:/imu,
    /^scp:\/\//imu,
    /^sftp:\/\//imu,
    /^itms:/imu,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/imu,
    /^notes:\/\//imu,
    /^hipchat:\/\//imu,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/imu,
    /^sourcetree:\/\//imu,
    /^urn:/imu,
    /^tel:/imu,
    /^xmpp:/imu,
    /^telnet:/imu,
    /^vnc:/imu,
    /^rdp:/imu,
    /^whatsapp:/imu,
    /^slack:/imu,
    /^sips?:/imu,
    /^magnet:/imu,
    /^#/imu
];
const $7a17f0f6029c5b2a$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url === null || url === void 0 ? void 0 : url.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $7a17f0f6029c5b2a$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $7a17f0f6029c5b2a$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($hcXsa)))();
$7a17f0f6029c5b2a$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$7a17f0f6029c5b2a$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $7a17f0f6029c5b2a$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/u
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$7a17f0f6029c5b2a$export$8ccbde94d5c7f8e7.add('tel:', $7a17f0f6029c5b2a$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$7a17f0f6029c5b2a$export$8ccbde94d5c7f8e7.add('file:', $7a17f0f6029c5b2a$var$urlWithoutSpacesValidator);
$7a17f0f6029c5b2a$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $7a17f0f6029c5b2a$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $7a17f0f6029c5b2a$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$7a17f0f6029c5b2a$var$tlds.push($7a17f0f6029c5b2a$var$tlds2Char);
$7a17f0f6029c5b2a$export$8ccbde94d5c7f8e7.tlds($7a17f0f6029c5b2a$var$tlds, false);
const $7a17f0f6029c5b2a$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/u;
const $7a17f0f6029c5b2a$export$6f7d7761b97f967 = (text)=>{
    if (!$7a17f0f6029c5b2a$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    substr = text.substr(startpos);
    while(substr){
        const link = (substr.match($7a17f0f6029c5b2a$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($7a17f0f6029c5b2a$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};
function $7a17f0f6029c5b2a$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $7a17f0f6029c5b2a$export$6f7d7761b97f967(str);
    if (!match.length) match = $7a17f0f6029c5b2a$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $7a17f0f6029c5b2a$export$6535eb414fa2c8b6(url) {
    const match = $7a17f0f6029c5b2a$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $7a17f0f6029c5b2a$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("hcXsa", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $c871acdc8dfdc024$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $c871acdc8dfdc024$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $c871acdc8dfdc024$var$isString(obj) {
    return $c871acdc8dfdc024$var$_class(obj) === '[object String]';
}
function $c871acdc8dfdc024$var$isObject(obj) {
    return $c871acdc8dfdc024$var$_class(obj) === '[object Object]';
}
function $c871acdc8dfdc024$var$isRegExp(obj) {
    return $c871acdc8dfdc024$var$_class(obj) === '[object RegExp]';
}
function $c871acdc8dfdc024$var$isFunction(obj) {
    return $c871acdc8dfdc024$var$_class(obj) === '[object Function]';
}
function $c871acdc8dfdc024$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $c871acdc8dfdc024$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $c871acdc8dfdc024$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $c871acdc8dfdc024$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $c871acdc8dfdc024$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $c871acdc8dfdc024$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $c871acdc8dfdc024$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $c871acdc8dfdc024$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $c871acdc8dfdc024$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $c871acdc8dfdc024$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $c871acdc8dfdc024$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("56bDX"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($c871acdc8dfdc024$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($c871acdc8dfdc024$var$isObject(val)) {
            if ($c871acdc8dfdc024$var$isRegExp(val.validate)) compiled.validate = $c871acdc8dfdc024$var$createValidator(val.validate);
            else if ($c871acdc8dfdc024$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($c871acdc8dfdc024$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $c871acdc8dfdc024$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($c871acdc8dfdc024$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $c871acdc8dfdc024$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($c871acdc8dfdc024$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $c871acdc8dfdc024$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $c871acdc8dfdc024$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $c871acdc8dfdc024$var$createMatch(self, shift) {
    var match = new $c871acdc8dfdc024$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $c871acdc8dfdc024$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $c871acdc8dfdc024$var$LinkifyIt)) return new $c871acdc8dfdc024$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($c871acdc8dfdc024$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $c871acdc8dfdc024$var$assign({}, $c871acdc8dfdc024$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $c871acdc8dfdc024$var$assign({}, $c871acdc8dfdc024$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $c871acdc8dfdc024$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $c871acdc8dfdc024$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $c871acdc8dfdc024$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $c871acdc8dfdc024$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $c871acdc8dfdc024$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $c871acdc8dfdc024$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $c871acdc8dfdc024$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $c871acdc8dfdc024$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $c871acdc8dfdc024$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $c871acdc8dfdc024$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($c871acdc8dfdc024$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($c871acdc8dfdc024$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $c871acdc8dfdc024$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $c871acdc8dfdc024$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $c871acdc8dfdc024$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $c871acdc8dfdc024$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $c871acdc8dfdc024$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $c871acdc8dfdc024$var$LinkifyIt;

});
parcelRegister("56bDX", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("fOABH")).source;
    re.src_Cc = (parcelRequire("2wPU1")).source;
    re.src_Z = (parcelRequire("fUueU")).source;
    re.src_P = (parcelRequire("1wnuT")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("fOABH", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("2wPU1", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("fUueU", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("1wnuT", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("iEg3S", function(module, exports) {
$parcel$export(module.exports, "strike", () => $083945c2e1df59b8$export$4899a95d70ec5056);

var $hG4P5 = parcelRequire("hG4P5");
const $083945c2e1df59b8$export$4899a95d70ec5056 = (0, $hG4P5.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("6d9fl", function(module, exports) {
$parcel$export(module.exports, "strong", () => $b34d4b64fd66a83f$export$59ae2c325a998f89);

var $hG4P5 = parcelRequire("hG4P5");
const $b34d4b64fd66a83f$var$strongDOM = [
    'strong'
];
const $b34d4b64fd66a83f$export$59ae2c325a998f89 = (0, $hG4P5.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                /^(bold(er)?|[5-9]\d{2,})$/u.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $b34d4b64fd66a83f$var$strongDOM;
    }
});

});

parcelRegister("dWQi9", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $c2dd8ad5fef1a893$export$b3401ee80eb31041);

var $hG4P5 = parcelRequire("hG4P5");
function $c2dd8ad5fef1a893$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $c2dd8ad5fef1a893$export$b3401ee80eb31041 = (0, $hG4P5.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$c2dd8ad5fef1a893$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$c2dd8ad5fef1a893$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("kzufT", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", () => $16d75a1d27269bc7$export$20af3dabbb5538df);

var $hG4P5 = parcelRequire("hG4P5");

var $lXFgC = parcelRequire("lXFgC");
const $16d75a1d27269bc7$export$20af3dabbb5538df = (0, $hG4P5.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $lXFgC.B400)}`
            }
        ];
    }
});

});

parcelRegister("iAxma", function(module, exports) {
$parcel$export(module.exports, "underline", () => $8f7227141156d5f5$export$425327af25286e5e);

var $hG4P5 = parcelRequire("hG4P5");
const $8f7227141156d5f5$export$425327af25286e5e = (0, $hG4P5.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("gROYo", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", () => $31cd05032bcd0c05$export$30d78d5eb6719bb8);

var $hG4P5 = parcelRequire("hG4P5");
const $31cd05032bcd0c05$export$30d78d5eb6719bb8 = (0, $hG4P5.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("21qCn", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $20f8262104845acd$export$a316dc07ff5182a2);

var $hG4P5 = parcelRequire("hG4P5");
const $20f8262104845acd$export$a316dc07ff5182a2 = (0, $hG4P5.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("bmo08", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $4b2de50df3455e67$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockCardWithLocalId", () => $4b2de50df3455e67$export$9894f24949f094e5);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $4b2de50df3455e67$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $4b2de50df3455e67$export$c4c2f833baaebdb8 = (0, $6niQM.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$4b2de50df3455e67$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$4b2de50df3455e67$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
const $4b2de50df3455e67$export$9894f24949f094e5 = (0, $6niQM.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$4b2de50df3455e67$var$getCommonAttributesFromDom(dom),
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$4b2de50df3455e67$var$getCommonAttributesFromDom(dom),
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2, _node$attrs3;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 || (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});

parcelRegister("bVo5t", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $55638251825bcc58$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "blockTaskItem", () => $55638251825bcc58$export$16018c61064a18df);

var $dARvh = parcelRequire("dARvh");

var $6niQM = parcelRequire("6niQM");
const $55638251825bcc58$export$6d8b0ef52e2e6390 = (0, $6niQM.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $dARvh.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $55638251825bcc58$export$16018c61064a18df = (0, $6niQM.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $dARvh.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6N6sU", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", () => $06769b8d60d17a4a$export$27903d543b563e39);

var $3ZqIM = parcelRequire("3ZqIM");

var $6niQM = parcelRequire("6niQM");
const $06769b8d60d17a4a$export$27903d543b563e39 = (0, $6niQM.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $3ZqIM.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("i98aq", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $928a0f7422eb1bd5$export$e92c7e4302dd4371);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $928a0f7422eb1bd5$export$e92c7e4302dd4371 = (0, $6niQM.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $dARvh.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});

});

parcelRegister("aaUQA", function(module, exports) {
$parcel$export(module.exports, "bulletListSelector", () => $688880919aaeeefd$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $688880919aaeeefd$export$a140c94e5ea26bee);
$parcel$export(module.exports, "bulletListWithLocalId", () => $688880919aaeeefd$export$dfd406053b2bab40);

var $dARvh = parcelRequire("dARvh");

var $6niQM = parcelRequire("6niQM");
const $688880919aaeeefd$export$5f25a39efab3b58b = '.ak-ul';
const $688880919aaeeefd$export$a140c94e5ea26bee = (0, $6niQM.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $688880919aaeeefd$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $688880919aaeeefd$export$dfd406053b2bab40 = (0, $6niQM.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $688880919aaeeefd$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("fu8gK", function(module, exports) {
$parcel$export(module.exports, "caption", () => $aad059b2cfec34c5$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "captionWithLocalId", () => $aad059b2cfec34c5$export$b5d01ee303c467aa);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $aad059b2cfec34c5$export$8e3c2dfdc4f0453d = (0, $6niQM.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $aad059b2cfec34c5$export$b5d01ee303c467aa = (0, $6niQM.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-caption': 'true'
        };
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("fYiX1", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $6e7599b1e004f4a8$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $6e7599b1e004f4a8$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "codeBlockWithLocalId", () => $6e7599b1e004f4a8$export$3f75de798a0b5356);

var $2sVuK = parcelRequire("2sVuK");

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $6e7599b1e004f4a8$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $6e7599b1e004f4a8$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $6e7599b1e004f4a8$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $6e7599b1e004f4a8$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $6e7599b1e004f4a8$var$extractLanguageFromClass = (className)=>{
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const languageRegex = /(?:^|\s)language-([^\s]+)/u;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $6e7599b1e004f4a8$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace(/\n$/u, '');
    return dom;
};
function $6e7599b1e004f4a8$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $6e7599b1e004f4a8$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $6e7599b1e004f4a8$export$7bb0d5c671655cc4 = (0, $6niQM.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $6e7599b1e004f4a8$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $6e7599b1e004f4a8$var$getLanguageFromEditorStyle(dom.parentElement) || $6e7599b1e004f4a8$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $6e7599b1e004f4a8$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6e7599b1e004f4a8$var$parseCodeFromHtml(domNode);
                return code ? (0, $2sVuK.Fragment).from(schema.text(code)) : (0, $2sVuK.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $6e7599b1e004f4a8$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $6e7599b1e004f4a8$export$3f75de798a0b5356 = (0, $6niQM.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $6e7599b1e004f4a8$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $6e7599b1e004f4a8$var$getLanguageFromEditorStyle(dom.parentElement) || $6e7599b1e004f4a8$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $6e7599b1e004f4a8$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6e7599b1e004f4a8$var$parseCodeFromHtml(domNode);
                return code ? (0, $2sVuK.Fragment).from(schema.text(code)) : (0, $2sVuK.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {};
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("5UpiG", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", () => $3995475f44b339a6$export$daf889beb5092f95);

var $6niQM = parcelRequire("6niQM");
const $3995475f44b339a6$var$name = 'confluenceJiraIssue';
const $3995475f44b339a6$export$daf889beb5092f95 = (0, $6niQM.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$3995475f44b339a6$var$name}"]`,
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $3995475f44b339a6$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("2I8tJ", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $c7a9bf83c3a98d41$export$e6e4878f43c27cab);

var $6niQM = parcelRequire("6niQM");
const $c7a9bf83c3a98d41$var$name = 'confluenceUnsupportedBlock';
const $c7a9bf83c3a98d41$export$e6e4878f43c27cab = (0, $6niQM.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $c7a9bf83c3a98d41$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$c7a9bf83c3a98d41$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("2M46G", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $623ed89906bc62a3$export$3e6d667072febc87);

var $6niQM = parcelRequire("6niQM");
const $623ed89906bc62a3$var$name = 'confluenceUnsupportedInline';
const $623ed89906bc62a3$export$3e6d667072febc87 = (0, $6niQM.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $623ed89906bc62a3$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$623ed89906bc62a3$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("iqs9I", function(module, exports) {
$parcel$export(module.exports, "date", () => $1d81e0961762fd37$export$324d90190a8b822a);
$parcel$export(module.exports, "dateWithLocalId", () => $1d81e0961762fd37$export$a6a035390e3921b2);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $1d81e0961762fd37$export$324d90190a8b822a = (0, $6niQM.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $1d81e0961762fd37$export$a6a035390e3921b2 = (0, $6niQM.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("eUPLO", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $80a87ec5360e760d$export$6959e16eeff859b4);

var $dARvh = parcelRequire("dARvh");

var $6niQM = parcelRequire("6niQM");
const $80a87ec5360e760d$export$6959e16eeff859b4 = (0, $6niQM.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $dARvh.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("jzyhn", function(module, exports) {
$parcel$export(module.exports, "decisionListSelector", () => $52114ce6668c0a49$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $52114ce6668c0a49$export$62d45a65fb43d95e);

var $dARvh = parcelRequire("dARvh");

var $6niQM = parcelRequire("6niQM");
const $52114ce6668c0a49$var$name = 'decisionList';
const $52114ce6668c0a49$export$a5393ce68c2ff601 = `[data-node-type="${$52114ce6668c0a49$var$name}"]`;
const $52114ce6668c0a49$export$62d45a65fb43d95e = (0, $6niQM.decisionList)({
    parseDOM: [
        {
            tag: `ol${$52114ce6668c0a49$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $52114ce6668c0a49$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6IkW5", function(module, exports) {
$parcel$export(module.exports, "doc", () => $c7b966d3264ae4a2$export$2a111da947c407d2);

var $6niQM = parcelRequire("6niQM");
const $c7b966d3264ae4a2$export$2a111da947c407d2 = (0, $6niQM.doc)({});

});

parcelRegister("46xgW", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $126ca0d9e03bd6ae$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "embedCardWithLocalId", () => $126ca0d9e03bd6ae$export$36734475a7f6fd3e);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $126ca0d9e03bd6ae$export$be4283d9a1cb1ff6 = (0, $6niQM.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $126ca0d9e03bd6ae$export$36734475a7f6fd3e = (0, $6niQM.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("g8C7z", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $6be6bb3d9483d3b1$export$a19185d1233fc4b2);
$parcel$export(module.exports, "emojiWithLocalId", () => $6be6bb3d9483d3b1$export$ebb3b3c7a0ac9936);

var $gxLB5 = parcelRequire("gxLB5");

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $6be6bb3d9483d3b1$export$a19185d1233fc4b2 = (0, $6niQM.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: (dom)=>(0, $gxLB5.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: (dom)=>(0, $gxLB5.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $6be6bb3d9483d3b1$export$ebb3b3c7a0ac9936 = (0, $6niQM.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const attrs = (0, $gxLB5.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return {
                    ...attrs,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const attrs = (0, $gxLB5.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return {
                    ...attrs,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $6be6bb3d9483d3b1$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("gxLB5", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", () => $f7c09ef87dbf8fa0$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $f7c09ef87dbf8fa0$export$441f8b58f5790a68);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $f7c09ef87dbf8fa0$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $f7c09ef87dbf8fa0$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $f7c09ef87dbf8fa0$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $f7c09ef87dbf8fa0$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $f7c09ef87dbf8fa0$export$f61e93bda2a8b420(acName) {
    const emojiData = $f7c09ef87dbf8fa0$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $f7c09ef87dbf8fa0$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $f7c09ef87dbf8fa0$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$f7c09ef87dbf8fa0$var$acNameToEmojiMap[acName] ? $f7c09ef87dbf8fa0$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($f7c09ef87dbf8fa0$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $f7c09ef87dbf8fa0$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$f7c09ef87dbf8fa0$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $f7c09ef87dbf8fa0$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $f7c09ef87dbf8fa0$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($f7c09ef87dbf8fa0$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $f7c09ef87dbf8fa0$var$getAcNameFromShortName(shortName);
        if (possibleName in $f7c09ef87dbf8fa0$var$acNameToEmojiMap) return possibleName;
    }
    return $f7c09ef87dbf8fa0$export$bc94e44ec0e7bd82(id) || $f7c09ef87dbf8fa0$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("9qlBc", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $5df452b62827b569$export$67dc04e652a298ca);
$parcel$export(module.exports, "extendedBlockquote", () => $5df452b62827b569$export$70a64939da3e8455);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => $5df452b62827b569$export$950ebf43f3364a0f);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $5df452b62827b569$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $5df452b62827b569$export$67dc04e652a298ca = (0, $6niQM.blockquoteLegacy)($5df452b62827b569$var$nodeSpecOptions);
const $5df452b62827b569$export$70a64939da3e8455 = (0, $6niQM.blockquote)($5df452b62827b569$var$nodeSpecOptions);
const $5df452b62827b569$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
const $5df452b62827b569$export$950ebf43f3364a0f = (0, $6niQM.blockquote)($5df452b62827b569$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("6IEi1", function(module, exports) {
$parcel$export(module.exports, "PanelType", () => $ef60f03d27857a8b$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $ef60f03d27857a8b$export$ce20b13564211141);
$parcel$export(module.exports, "extendedPanelWithLocalId", () => $ef60f03d27857a8b$export$855c3c67c9c9ebaf);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
var $ef60f03d27857a8b$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ef60f03d27857a8b$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
const $ef60f03d27857a8b$var$getParseDOMAttrs = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $dARvh.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === "custom" ? "info" : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $ef60f03d27857a8b$var$createPanelNodeSpecOptions = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$ef60f03d27857a8b$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = $ef60f03d27857a8b$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $ef60f03d27857a8b$export$ce20b13564211141 = (allowCustomPanel)=>(0, $6niQM.panel)($ef60f03d27857a8b$var$createPanelNodeSpecOptions(allowCustomPanel));
const $ef60f03d27857a8b$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $6niQM.panel)($ef60f03d27857a8b$var$createPanelNodeSpecOptions(allowCustomPanel, true));

});

parcelRegister("6bkzW", function(module, exports) {
$parcel$export(module.exports, "extension", () => $bbc2a5846f80de4a$export$1b45514b112dd749);

var $3ZqIM = parcelRequire("3ZqIM");

var $6niQM = parcelRequire("6niQM");
const $bbc2a5846f80de4a$export$1b45514b112dd749 = (0, $6niQM.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $3ZqIM.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("9UYHL", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $dda53c19b3a908e6$export$371da9dd35aba193);

var $6niQM = parcelRequire("6niQM");
const $dda53c19b3a908e6$export$371da9dd35aba193 = (0, $6niQM.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("4hcwN", function(module, exports) {
$parcel$export(module.exports, "heading", () => $93d962430629fa2a$export$46e4a324ac90507f);

var $6niQM = parcelRequire("6niQM");
const $93d962430629fa2a$var$getAttrs = (level)=>(domNode)=>({
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        });
const $93d962430629fa2a$export$46e4a324ac90507f = (0, $6niQM.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $93d962430629fa2a$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $93d962430629fa2a$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $93d962430629fa2a$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $93d962430629fa2a$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $93d962430629fa2a$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $93d962430629fa2a$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("41YoF", function(module, exports) {
$parcel$export(module.exports, "image", () => $3dac4b8ae7ec035c$export$5c452ff88e35e47d);

var $6niQM = parcelRequire("6niQM");
const $3dac4b8ae7ec035c$export$5c452ff88e35e47d = (0, $6niQM.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("bZFVH", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $6266125d47c0b7cc$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineCardWithLocalId", () => $6266125d47c0b7cc$export$7ed775fc743eadd1);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $6266125d47c0b7cc$export$cbf8224b64e0d942 = (0, $6niQM.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $6266125d47c0b7cc$export$7ed775fc743eadd1 = (0, $6niQM.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("6fM2i", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", () => $5f7780e7c0af16ad$export$16b353b2649bd8d9);

var $3ZqIM = parcelRequire("3ZqIM");

var $6niQM = parcelRequire("6niQM");
const $5f7780e7c0af16ad$export$16b353b2649bd8d9 = (0, $6niQM.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $3ZqIM.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("daSDG", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", () => $480c02c51dc24b05$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => $480c02c51dc24b05$export$b2e27d292505bac2);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");

var $h2boN = parcelRequire("h2boN");
const $480c02c51dc24b05$export$ab76e7c03cd6f650 = (0, $6niQM.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            const baseStyle = `flex-basis: ${width}%`;
            const columnWidthVar = (0, $h2boN.editorExperiment)('platform_editor_layout_column_resize_handle', true) ? `; --column-width: ${width}%` : '';
            attrs['style'] = baseStyle + columnWidthVar;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
const $480c02c51dc24b05$export$b2e27d292505bac2 = (0, $6niQM.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $dARvh.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-layout-column': 'true'
        };
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        const { width: width } = node.attrs;
        if (width) {
            const baseStyle = `flex-basis: ${width}%`;
            const columnWidthVar = (0, $h2boN.editorExperiment)('platform_editor_layout_column_resize_handle', true) ? `; --column-width: ${width}%` : '';
            attrs['style'] = baseStyle + columnWidthVar;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});
parcelRegister("h2boN", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $baa37020a8a908dc$export$9b7cf3b74f250027);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $1EFS8 = parcelRequire("1EFS8");

var $1M3oH = parcelRequire("1M3oH");

var $4CFp1 = parcelRequire("4CFp1");

var $ffZCx = parcelRequire("ffZCx");
function $baa37020a8a908dc$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    var _experimentConfig$pro;
    const experimentConfig = (0, $4CFp1.editorExperimentsConfig)[experimentName];
    if ((0, $ffZCx._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $ffZCx._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $ffZCx._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $ffZCx._product];
    if (!experimentKey) {
        var _editorExperimentsCon;
        // This will be hit in the case of an experiment not being set up for the product
        return ((_editorExperimentsCon = (0, $4CFp1.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon.defaultValue) === expectedExperimentValue;
    }
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $1EFS8.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $1EFS8.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $1M3oH.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $baa37020a8a908dc$export$92316ae898e357eb(experimentName, paramName, options) {
    var _paramOverrides$exper;
    if (((_paramOverrides$exper = (0, $ffZCx._paramOverrides)[experimentName]) === null || _paramOverrides$exper === void 0 ? void 0 : _paramOverrides$exper[paramName]) !== undefined) // This will be hit in the case of a test setting an override
    return (0, $ffZCx._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $1EFS8.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});


parcelRegister("9enxE", function(module, exports) {
$parcel$export(module.exports, "copyPrivateAttributes", () => $3d010ab1432d76d0$export$111130fa8968d741);
$parcel$export(module.exports, "createMediaSpec", () => $3d010ab1432d76d0$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "media", () => $3d010ab1432d76d0$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $3d010ab1432d76d0$export$54fd2c36b5cc6731);

var $lXFgC = parcelRequire("lXFgC");

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $3d010ab1432d76d0$export$bb3fe706be61f640 = (0, $6niQM.media)({}).attrs;
const $3d010ab1432d76d0$export$f84fdfb973c05bd8 = (str)=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    str.replace(/([^A-Z]+)([A-Z])/gu, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $3d010ab1432d76d0$export$111130fa8968d741 = (from, to, attributes, map)=>{
    const attrs = attributes || {};
    Object.keys(attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
const $3d010ab1432d76d0$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    const key = $3d010ab1432d76d0$export$f84fdfb973c05bd8(k).replace(/^__/u, '');
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $dARvh.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $lXFgC.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $3d010ab1432d76d0$export$111130fa8968d741(node.attrs, attrs, attributes, (key)=>`data-${$3d010ab1432d76d0$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $6niQM.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $6niQM.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $dARvh.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};
const $3d010ab1432d76d0$export$987d49ffe1b0900f = $3d010ab1432d76d0$export$35bdbf5bc8caa677($3d010ab1432d76d0$export$bb3fe706be61f640, false, false);
const $3d010ab1432d76d0$export$8446e47a4c7fd000 = $3d010ab1432d76d0$export$35bdbf5bc8caa677({
    ...$3d010ab1432d76d0$export$bb3fe706be61f640,
    localId: {
        default: (0, $dARvh.uuid).generate()
    }
}, false, true);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $3d010ab1432d76d0$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
const $3d010ab1432d76d0$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
const $3d010ab1432d76d0$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_'))// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $3d010ab1432d76d0$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($3d010ab1432d76d0$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("55v2Q", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $2c5a306abf0bdee9$export$2855e964765eac9);

var $6niQM = parcelRequire("6niQM");
const $2c5a306abf0bdee9$export$2855e964765eac9 = (0, $6niQM.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("1P6GE", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $67869a694036ff02$export$38bab695e3f720f1);

var $9enxE = parcelRequire("9enxE");

var $dARvh = parcelRequire("dARvh");

var $6niQM = parcelRequire("6niQM");
const $67869a694036ff02$export$38bab695e3f720f1 = (0, $9enxE.createMediaSpec)((0, $6niQM.mediaInline)({}).attrs, true);
const $67869a694036ff02$export$aea8e9c496505c61 = (0, $9enxE.createMediaSpec)({
    ...(0, $6niQM.mediaInline)({}).attrs,
    localId: {
        default: (0, $dARvh.uuid).generate()
    }
}, true, true);

});

parcelRegister("bkx8J", function(module, exports) {
$parcel$export(module.exports, "mediaSingleSpec", () => $2ff18bc4d97f4738$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $2ff18bc4d97f4738$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $2ff18bc4d97f4738$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $2ff18bc4d97f4738$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $2ff18bc4d97f4738$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => $2ff18bc4d97f4738$export$75376a385837c942);
$parcel$export(module.exports, "toJSON", () => $2ff18bc4d97f4738$export$54fd2c36b5cc6731);

var $4WPDQ = parcelRequire("4WPDQ");

var $igwcf = parcelRequire("igwcf");

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $2ff18bc4d97f4738$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $2ff18bc4d97f4738$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $igwcf.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $dARvh.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $4WPDQ.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs;
            attrs['data-local-id'] = (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $4WPDQ.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $6niQM.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $6niQM.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $6niQM.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $6niQM.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $2ff18bc4d97f4738$export$969fe3781ca15058 = $2ff18bc4d97f4738$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $2ff18bc4d97f4738$export$d35e6c006d4abdfb = $2ff18bc4d97f4738$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $2ff18bc4d97f4738$export$9c58e19811ce4cf5 = $2ff18bc4d97f4738$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $2ff18bc4d97f4738$export$7e767666f2ce108a = $2ff18bc4d97f4738$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $2ff18bc4d97f4738$export$75376a385837c942 = $2ff18bc4d97f4738$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
const $2ff18bc4d97f4738$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("4WPDQ", function(module, exports) {
$parcel$export(module.exports, "WidthType", () => $50eb24bc887c1231$export$4d41558722ac7eed);
var $50eb24bc887c1231$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("d0FgX", function(module, exports) {
$parcel$export(module.exports, "mention", () => $a94fbb3528aa21fa$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $a94fbb3528aa21fa$export$54fd2c36b5cc6731);

var $dARvh = parcelRequire("dARvh");

var $6niQM = parcelRequire("6niQM");
var $a94fbb3528aa21fa$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $a94fbb3528aa21fa$export$db83999c14438df4 = (0, $6niQM.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $a94fbb3528aa21fa$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $a94fbb3528aa21fa$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $a94fbb3528aa21fa$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $dARvh.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($a94fbb3528aa21fa$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $a94fbb3528aa21fa$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $a94fbb3528aa21fa$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($a94fbb3528aa21fa$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("4w5Cd", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", () => $ea43d54a2d188b93$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => $ea43d54a2d188b93$export$b854197485aa1fa0);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
function $ea43d54a2d188b93$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $dARvh.uuid).generate() : undefined
    };
}
const $ea43d54a2d188b93$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$ea43d54a2d188b93$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$ea43d54a2d188b93$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $ea43d54a2d188b93$export$63cadbf5f4296627 = (0, $6niQM.nestedExpand)($ea43d54a2d188b93$var$nestedExpandFactoryOptions);
const $ea43d54a2d188b93$export$b854197485aa1fa0 = (0, $6niQM.nestedExpand)({
    ...$ea43d54a2d188b93$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$ea43d54a2d188b93$var$nestedExpandFactoryOptions.parseDOM || [],
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$ea43d54a2d188b93$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$ea43d54a2d188b93$var$getExpandAttrs(domNode, true)
        }
    ]
});

});

parcelRegister("e5Nys", function(module, exports) {
$parcel$export(module.exports, "orderedListSelector", () => $98a025015df40def$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $98a025015df40def$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithLocalId", () => $98a025015df40def$export$8157adc5747ec436);
$parcel$export(module.exports, "orderedListWithOrder", () => $98a025015df40def$export$b9ab759e8298198f);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => $98a025015df40def$export$2ea3505d41d7525d);

var $dARvh = parcelRequire("dARvh");

var $6niQM = parcelRequire("6niQM");
const $98a025015df40def$export$4e7125c7ff595be5 = '.ak-ol';
const $98a025015df40def$export$a5dc81035676e7a = (0, $6niQM.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $98a025015df40def$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $98a025015df40def$export$8157adc5747ec436 = (0, $6niQM.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $98a025015df40def$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $98a025015df40def$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $98a025015df40def$export$b9ab759e8298198f = (0, $6niQM.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $98a025015df40def$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        const start = $98a025015df40def$var$resolveStart(node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $98a025015df40def$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $98a025015df40def$export$2ea3505d41d7525d = (0, $6niQM.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $dARvh.uuid).generate();
                if (startDOMAttr) {
                    const start = $98a025015df40def$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs3, _node$attrs4;
        const start = $98a025015df40def$var$resolveStart(node === null || node === void 0 || (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $98a025015df40def$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("1i5tx", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $4e8861dff34a48a7$export$9c206ddddb32a9b);

var $6niQM = parcelRequire("6niQM");
const $4e8861dff34a48a7$export$9c206ddddb32a9b = (0, $6niQM.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $4e8861dff34a48a7$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 || (_paragraph$attrs = _paragraph$attrs.localId) === null || _paragraph$attrs === void 0 ? void 0 : _paragraph$attrs.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("brIWK", function(module, exports) {
$parcel$export(module.exports, "placeholder", () => $d329c9060693fdf1$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "placeholderWithLocalId", () => $d329c9060693fdf1$export$6205248609a8f7a0);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $d329c9060693fdf1$export$c7187bbd1a7a9244 = (0, $6niQM.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $d329c9060693fdf1$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $d329c9060693fdf1$export$6205248609a8f7a0 = (0, $6niQM.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $d329c9060693fdf1$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("bathP", function(module, exports) {
$parcel$export(module.exports, "rule", () => $802976745f8ae0be$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "ruleWithLocalId", () => $802976745f8ae0be$export$bf3ef6fb6ad90e7);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $802976745f8ae0be$var$hrDOM = [
    'hr'
];
const $802976745f8ae0be$export$fbeb3a3956e8a3c7 = (0, $6niQM.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $802976745f8ae0be$var$hrDOM;
    }
});
const $802976745f8ae0be$export$bf3ef6fb6ad90e7 = (0, $6niQM.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $dARvh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("hrZYn", function(module, exports) {
$parcel$export(module.exports, "status", () => $9f647340ea6318f6$export$471f7ae5c4103ae1);

var $dARvh = parcelRequire("dARvh");

var $6niQM = parcelRequire("6niQM");

var $13svG = parcelRequire("13svG");
const $9f647340ea6318f6$export$471f7ae5c4103ae1 = (0, $6niQM.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const textContent = dom.textContent.replace(/\n/u, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                const text = (0, $13svG.expValEquals)('platform_editor_copy_paste_issue_fix', 'isEnabled', true) ? dom.getAttribute('data-text') || textContent : textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $dARvh.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("8Mesg", function(module, exports) {
$parcel$export(module.exports, "syncBlock", () => $46ada011092df528$export$faab0ca9701d7048);

var $6niQM = parcelRequire("6niQM");

var $dARvh = parcelRequire("dARvh");
const $46ada011092df528$export$faab0ca9701d7048 = (0, $6niQM.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $dARvh.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("gPa31", function(module, exports) {
$parcel$export(module.exports, "text", () => $dc3e570eebb80b18$export$6f093cfa640b7166);

var $6niQM = parcelRequire("6niQM");
const $dc3e570eebb80b18$export$6f093cfa640b7166 = (0, $6niQM.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("iY0Bz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f434508c55fccddd$export$2e2bcd8739ae039);
const $f434508c55fccddd$var$name = 'unknownBlock';
var $f434508c55fccddd$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $f434508c55fccddd$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$f434508c55fccddd$var$name}"]`
        }
    ]
};

});

parcelRegister("3ZtT7", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", () => $97a43d5d16f0c64e$export$44b79b0979d0f0f7);

var $6niQM = parcelRequire("6niQM");
const $97a43d5d16f0c64e$export$44b79b0979d0f0f7 = (0, $6niQM.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("is2Xi", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", () => $114a2ca9ccc7cfc2$export$310ebe0d80122e9b);

var $6niQM = parcelRequire("6niQM");
const $114a2ca9ccc7cfc2$export$310ebe0d80122e9b = (0, $6niQM.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("6RaaD", function(module, exports) {
$parcel$export(module.exports, "ProviderFactoryProvider", () => $4c7c8c430832589b$export$617c134b25cc4265);
$parcel$export(module.exports, "useProviderFactory", () => $4c7c8c430832589b$export$a3af4b6980aa23b5);
$parcel$export(module.exports, "useProvider", () => $4c7c8c430832589b$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $4c7c8c430832589b$export$6fde1d0d81db98e1);

var $8P7DW = parcelRequire("8P7DW");

var $feOkE = parcelRequire("feOkE");
const $4c7c8c430832589b$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(new (0, $feOkE.default)());
const $4c7c8c430832589b$export$617c134b25cc4265 = $4c7c8c430832589b$var$ProviderFactoryContext.Provider;
const $4c7c8c430832589b$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext($4c7c8c430832589b$var$ProviderFactoryContext);
const $4c7c8c430832589b$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState();
    const providerFactory = $4c7c8c430832589b$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $4c7c8c430832589b$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState();
    const providerFactory = $4c7c8c430832589b$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("5jr6D", function(module, exports) {
$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $52e15e45a96922d9$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $52e15e45a96922d9$export$a1a213d350ca51ca);

var $8P7DW = parcelRequire("8P7DW");

var $cZiJt = parcelRequire("cZiJt");

var $e7vUY = parcelRequire("e7vUY");

var $94YFM = parcelRequire("94YFM");
function $52e15e45a96922d9$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $52e15e45a96922d9$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $8P7DW.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $e7vUY.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cZiJt.a), {
        theme: memoizedTheme
    }, children);
}
function $52e15e45a96922d9$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $94YFM.WidthConsumer), null, ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($52e15e45a96922d9$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, children)));
}

});
parcelRegister("e7vUY", function(module, exports) {
$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $e9ea388557a895c2$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorFullPageDenseFontSize", () => $e9ea388557a895c2$export$24495b314f307191);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $e9ea388557a895c2$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $e9ea388557a895c2$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $e9ea388557a895c2$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $e9ea388557a895c2$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $e9ea388557a895c2$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $e9ea388557a895c2$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $e9ea388557a895c2$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $e9ea388557a895c2$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $e9ea388557a895c2$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $e9ea388557a895c2$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $e9ea388557a895c2$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $e9ea388557a895c2$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $e9ea388557a895c2$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $e9ea388557a895c2$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $e9ea388557a895c2$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $e9ea388557a895c2$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $e9ea388557a895c2$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $e9ea388557a895c2$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $e9ea388557a895c2$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $e9ea388557a895c2$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $e9ea388557a895c2$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $e9ea388557a895c2$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorMaxWidthLayoutWidth", () => $e9ea388557a895c2$export$c0f7d71e10d277e9);
$parcel$export(module.exports, "akEditorMaxLayoutWidth", () => $e9ea388557a895c2$export$45eb0f5135abf6f1);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $e9ea388557a895c2$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $e9ea388557a895c2$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $e9ea388557a895c2$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $e9ea388557a895c2$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorGutterPaddingReduced", () => $e9ea388557a895c2$export$aae87d25ced827bb);
$parcel$export(module.exports, "akEditorFullPageNarrowBreakout", () => $e9ea388557a895c2$export$cccda66937c91e4c);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $e9ea388557a895c2$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $e9ea388557a895c2$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $e9ea388557a895c2$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $e9ea388557a895c2$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $e9ea388557a895c2$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $e9ea388557a895c2$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $e9ea388557a895c2$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $e9ea388557a895c2$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $e9ea388557a895c2$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $e9ea388557a895c2$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $e9ea388557a895c2$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $e9ea388557a895c2$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $e9ea388557a895c2$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $e9ea388557a895c2$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $e9ea388557a895c2$export$e88f6c898960b391);
$parcel$export(module.exports, "layoutBreakpointWidth", () => $e9ea388557a895c2$export$e5c605f2b2a12b00);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $e9ea388557a895c2$export$1d0d506416d457f1);
$parcel$export(module.exports, "scaledBlockNodesVerticalMargin", () => $e9ea388557a895c2$export$53030af820b542f5);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $e9ea388557a895c2$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $e9ea388557a895c2$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $e9ea388557a895c2$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $e9ea388557a895c2$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorFullPageToolbarHeight", () => $e9ea388557a895c2$export$d1343597f3b52d83);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $e9ea388557a895c2$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $e9ea388557a895c2$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $e9ea388557a895c2$export$59733a9f61449b25);
$parcel$export(module.exports, "relativeSizeToBaseFontSize", () => $e9ea388557a895c2$export$46715ac1fbd9e64e);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $e9ea388557a895c2$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $e9ea388557a895c2$export$42608c013398a830);

var $e6Qdr = parcelRequire("e6Qdr");

var $h2boN = parcelRequire("h2boN");
const $e9ea388557a895c2$export$fe6b0b821a0e9067 = 16;
const $e9ea388557a895c2$export$24495b314f307191 = 13;
const $e9ea388557a895c2$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $e9ea388557a895c2$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $e9ea388557a895c2$export$a7a75e50ae62d0a8 = "var(--ds-border, #0B120E24)";
const $e9ea388557a895c2$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $e9ea388557a895c2$export$f0e953d95429ca1 = '12px';
const $e9ea388557a895c2$export$a309dbdeca0adb1a = '2px 4px';
const $e9ea388557a895c2$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $e9ea388557a895c2$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $e9ea388557a895c2$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $e9ea388557a895c2$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $e9ea388557a895c2$export$d2715266dd4a1fd1 = 20;
const $e9ea388557a895c2$export$cf524c1b49838a49 = "var(--ds-border-selected, #1868DB)";
const $e9ea388557a895c2$export$8dac549e32469ac4 = 1;
const $e9ea388557a895c2$export$befaaae517e3d864 = 2;
const $e9ea388557a895c2$export$6e1e1996c4e8cc51 = `${$e9ea388557a895c2$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #1868DB)"}`;
const $e9ea388557a895c2$export$b6a59ac3a19b6343 = `0 0 0 ${$e9ea388557a895c2$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #1868DB)"}`;
const $e9ea388557a895c2$export$37e178ca41c198ca = `0 0 0 ${$e9ea388557a895c2$export$befaaae517e3d864}px ${"var(--ds-border-selected, #1868DB)"}`;
const $e9ea388557a895c2$export$4a007c22e25e31f6 = 0.3;
const $e9ea388557a895c2$export$f35cc48f3398ab79 = 1;
const $e9ea388557a895c2$export$b46cda584c619451 = 2;
const $e9ea388557a895c2$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $e9ea388557a895c2$export$321ddd2f049dd12 = $e9ea388557a895c2$export$6bed85de54b5de42 + 1;
const $e9ea388557a895c2$export$daeac9b8422ac3c2 = 2;
const $e9ea388557a895c2$export$501d46e11ed5bf73 = 500;
const $e9ea388557a895c2$export$6817b4b6a5ef78f1 = 400;
const $e9ea388557a895c2$export$93768eb72dec48ce = $e9ea388557a895c2$export$501d46e11ed5bf73 + 10;
const $e9ea388557a895c2$export$c0aec4e0896849a0 = $e9ea388557a895c2$export$93768eb72dec48ce - 5;
const $e9ea388557a895c2$export$5886f057e4f21fe4 = $e9ea388557a895c2$export$6817b4b6a5ef78f1 + 5;
const $e9ea388557a895c2$export$6e85faa46d537a3f = 11;
const $e9ea388557a895c2$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $e9ea388557a895c2$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $e9ea388557a895c2$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $e9ea388557a895c2$export$95e9a0285b97474d = '#2C333A';
const $e9ea388557a895c2$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #4688EC)";
const $e9ea388557a895c2$export$76b5e653883e5290 = '3px';
const $e9ea388557a895c2$export$6d85fe8177a50c0c = 0.5;
const $e9ea388557a895c2$export$fad19f16d3f953a3 = 680;
const $e9ea388557a895c2$export$9db045950eedb49f = 760;
const $e9ea388557a895c2$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $e9ea388557a895c2$export$f580e3d28d0986de = 1800;
const $e9ea388557a895c2$export$c0f7d71e10d277e9 = 4000;
const $e9ea388557a895c2$export$9d5488b5afad62bf = 1792;
const $e9ea388557a895c2$export$45eb0f5135abf6f1 = 4000;
const $e9ea388557a895c2$export$37df10057d36a0e5 = 42;
const $e9ea388557a895c2$export$437293c5e9fc2703 = 96;
const $e9ea388557a895c2$export$6e0f4d52efd3d2d = 32;
const $e9ea388557a895c2$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $e6Qdr.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $h2boN.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $e9ea388557a895c2$export$aae87d25ced827bb = 24;
const $e9ea388557a895c2$export$cccda66937c91e4c = 600;
const $e9ea388557a895c2$export$efe8561bbd3f74d2 = 720;
const $e9ea388557a895c2$export$e4d39a9e8607c1d3 = 48;
const $e9ea388557a895c2$export$43946f2400ab6f1f = 128;
const $e9ea388557a895c2$export$558438ae7fd4b8ce = 12;
const $e9ea388557a895c2$export$6beb98d32d4ca149 = 4;
const $e9ea388557a895c2$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $e9ea388557a895c2$export$5edb4f38c3eacb1a = 1024;
const $e9ea388557a895c2$export$e60820063058ed59 = 1.33;
const $e9ea388557a895c2$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $e9ea388557a895c2$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $e9ea388557a895c2$export$fb15fade89f67217 = $e9ea388557a895c2$export$f35cc48f3398ab79 * 99;
const $e9ea388557a895c2$export$847030921e9d5a40 = 12;
const $e9ea388557a895c2$export$40eb41ab799f0329 = 1.714;
const $e9ea388557a895c2$export$e271312fc7124aec = '1px';
const $e9ea388557a895c2$export$d29cb2c31fcbb7c5 = 2;
const $e9ea388557a895c2$export$688a6dc01e760755 = 320;
const $e9ea388557a895c2$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $e9ea388557a895c2$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $e9ea388557a895c2$export$e88f6c898960b391 = $e9ea388557a895c2$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $e9ea388557a895c2$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $e9ea388557a895c2$export$1d0d506416d457f1 = '0.75rem';
const $e9ea388557a895c2$export$53030af820b542f5 = '0.75em';
const $e9ea388557a895c2$export$e683ef42725d1713 = 680;
const $e9ea388557a895c2$export$226c784ba04bd04b = 480;
const $e9ea388557a895c2$export$214ff00e5618d86c = 20;
const $e9ea388557a895c2$export$c82675fa56f2eefd = '56px';
const $e9ea388557a895c2$var$DEFAULT_FONT_SIZE = 14;
const $e9ea388557a895c2$export$d7726a000ae2d7c = (isToolbarAIFCEnabled)=>{
    if (// if value is undefined assume this is being called outside of editor where the experiment can be checked
    isToolbarAIFCEnabled === undefined ? (0, $h2boN.editorExperiment)('platform_editor_toolbar_aifc', true) || (0, $e6Qdr.fg)('platform_editor_ai_aifc_streaming') : isToolbarAIFCEnabled) return '44px';
    if ((0, $h2boN.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
const $e9ea388557a895c2$export$d1343597f3b52d83 = 40;
const $e9ea388557a895c2$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $e9ea388557a895c2$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $e9ea388557a895c2$var$DEFAULT_FONT_SIZE;
const $e9ea388557a895c2$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$e9ea388557a895c2$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $e9ea388557a895c2$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $e9ea388557a895c2$export$46715ac1fbd9e64e = (value)=>{
    return `calc(${value} * var(--ak-editor-base-font-size) / ${$e9ea388557a895c2$export$fe6b0b821a0e9067})`;
};
const $e9ea388557a895c2$export$96b72b7f243fa693 = {
    a4KMonitor: {
        width: 3440,
        height: 1440
    },
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $e9ea388557a895c2$export$9369fd010fa0ddd6 = 0;
const $e9ea388557a895c2$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$e9ea388557a895c2$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $e9ea388557a895c2$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $e9ea388557a895c2$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E06C00)",
    "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #357DE8)",
    "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #AF59E1)",
    "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "var(--ds-icon-accent-gray, #7D818A)",
    "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #614A05)"
];
const $e9ea388557a895c2$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];

});

parcelRegister("94YFM", function(module, exports) {
$parcel$export(module.exports, "getBreakpoint", () => $09f277144ba78dcd$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $09f277144ba78dcd$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $09f277144ba78dcd$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $09f277144ba78dcd$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $09f277144ba78dcd$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $hXXvg = parcelRequire("hXXvg");

var $a4Hdp = parcelRequire("a4Hdp");

var $iD9mC = parcelRequire("iD9mC");

var $gLl3K = parcelRequire("gLl3K");
function $09f277144ba78dcd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $09f277144ba78dcd$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $09f277144ba78dcd$var$SCROLLBAR_WIDTH = 30;
function $09f277144ba78dcd$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $09f277144ba78dcd$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $09f277144ba78dcd$export$1eb095b00b926404(width)
    };
}
const $09f277144ba78dcd$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext($09f277144ba78dcd$export$31a4966bffb9ac98());
const $09f277144ba78dcd$var$Provider = $09f277144ba78dcd$export$27e39f636459b9f.Provider;
const $09f277144ba78dcd$export$5d8538aa831b6ebb = $09f277144ba78dcd$export$27e39f636459b9f.Consumer;
const $09f277144ba78dcd$export$df154c49e93b2ac2 = (0, $hXXvg.default)(()=>{
    var _document$body;
    return (0, $gLl3K.isSSR)() ? 0 : ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.offsetWidth) ?? 0;
});
const $09f277144ba78dcd$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $8P7DW.useContext)($09f277144ba78dcd$export$27e39f636459b9f);
    const [width, setWidth] = (0, $8P7DW.useState)($09f277144ba78dcd$export$df154c49e93b2ac2);
    const widthRef = (0, $8P7DW.useRef)(width);
    const isMountedRef = (0, $8P7DW.useRef)(true);
    const providerValue = (0, $8P7DW.useMemo)(()=>$09f277144ba78dcd$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $8P7DW.useMemo)(()=>{
        return (0, $a4Hdp.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $09f277144ba78dcd$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $09f277144ba78dcd$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $iD9mC.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $8Z0o8.jsx)($09f277144ba78dcd$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("gLl3K", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $0dc635b94e862d06$export$48d7c418edadb60c);

var $6nQJh = parcelRequire("6nQJh");
function $0dc635b94e862d06$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6nQJh !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("2aE1s", function(module, exports) {
$parcel$export(module.exports, "IntlErrorBoundary", () => $fcd3ae79f2b09cb5$export$7df0749115d18d19);

var $8P7DW = parcelRequire("8P7DW");

var $33yvY = parcelRequire("33yvY");
const $fcd3ae79f2b09cb5$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $fcd3ae79f2b09cb5$var$isMissingIntlProviderInAncestryError = (err)=>{
    var _err$toString;
    return err === null || err === void 0 || (_err$toString = err.toString()) === null || _err$toString === void 0 ? void 0 : _err$toString.includes('<IntlProvider> needs to exist in the component ancestry');
};
class $fcd3ae79f2b09cb5$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    componentDidCatch(error, _errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($fcd3ae79f2b09cb5$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $33yvY.default), {
            locale: "en"
        }, this.props.children);
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("1I7g7", function(module, exports) {
$parcel$export(module.exports, "default", () => $f826835ac58c5113$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $3SD6z = parcelRequire("3SD6z");

var $e7vUY = parcelRequire("e7vUY");

var $faea6 = parcelRequire("faea6");

var $ea6bZ = parcelRequire("ea6bZ");

var $eguiP = parcelRequire("eguiP");

var $FbXg8 = parcelRequire("FbXg8");

var $fZ6KA = parcelRequire("fZ6KA");

var $ejxna = parcelRequire("ejxna");
const $f826835ac58c5113$var$blockNodeStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    background: "var(--ds-background-disabled, #17171708)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $e7vUY.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $f826835ac58c5113$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $ejxna.getUnsupportedContent)((0, $FbXg8.unsupportedContentMessages).unsupportedBlockContent, (0, $FbXg8.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $FbXg8.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $8P7DW.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $8P7DW.useCallback)(()=>dispatchAnalyticsEvent && (0, $fZ6KA.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $eguiP.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $f826835ac58c5113$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $ea6bZ.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($faea6))), {
        label: "?"
    })))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $f826835ac58c5113$var$_default_1 = (0, $3SD6z.default)($f826835ac58c5113$var$UnsupportedBlockNode);
var $f826835ac58c5113$export$2e2bcd8739ae039 = $f826835ac58c5113$var$_default_1;

});
parcelRegister("faea6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0a2c66f2a53ff34$var$_react = $b0a2c66f2a53ff34$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $b0a2c66f2a53ff34$var$_baseNew = $b0a2c66f2a53ff34$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $b0a2c66f2a53ff34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0a2c66f2a53ff34$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $b0a2c66f2a53ff34$var$_react.default.createElement($b0a2c66f2a53ff34$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$b0a2c66f2a53ff34$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $b0a2c66f2a53ff34$var$_default = module.exports.default = $b0a2c66f2a53ff34$var$QuestionCircleIcon;

});

parcelRegister("eguiP", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $ce1551af2b80b91e$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $ce1551af2b80b91e$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $ce1551af2b80b91e$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $ce1551af2b80b91e$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $ce1551af2b80b91e$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $ce1551af2b80b91e$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $ce1551af2b80b91e$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $ce1551af2b80b91e$export$9f0b2adf3cfd71b7);
var $ce1551af2b80b91e$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $ce1551af2b80b91e$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["COPY_FAILED"] = "copyFailed";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    ACTION["DISCARDED"] = "discarded";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPLAYED"] = "displayed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPERIENCE_MEASURED"] = "experienceMeasured";
    ACTION["EXPERIENCE_SAMPLED"] = "experienceSampled";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FETCHED"] = "fetched";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OFFLINE_STORAGE_RESTORE_STEPS_INITIATED"] = "offlineStorageRestoreStepsInitiated";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION["REFERENCE_SYNCED_BLOCK_UNSYNC"] = "referenceSyncedBlockUnsync";
    ACTION["REFERENCE_SYNCED_BLOCK_COPY"] = "referenceSyncedBlockCopy";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION["SYNCED_BLOCK_UNSYNC"] = "syncedBlockUnsync";
    ACTION["SYNCED_BLOCK_EDIT_SOURCE"] = "syncedBlockEditSource";
    ACTION["SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS"] = "syncedBlockViewSyncedLocations";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["TRIGGERED"] = "triggered";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERED_SAMPLED"] = "renderedSampled";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
   * @private
   * @deprecated
   *
   * This is no longer used and can be removed at a later date
   */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NATIVE_EMBEDS_TRANSFORMED"] = "nativeEmbedsTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    // remove this enum when cleaning up platform_editor_remove_collab_step_metrics
    ACTION["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["ORGANIC_CHANGES_TRACKED"] = "organicChangesTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["TRANSFORMED"] = "transformed";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    ACTION["LOCAL_ID_NOT_FOUND"] = "localIdNotFound";
    ACTION["NO_DOC_CHANGE_FOUND"] = "noDocChangeFound";
    ACTION["INVALID_COMMAND_FOUND"] = "invalidCommandFound";
    ACTION["MEDIA_SINGLE_WIDTH_TRANSFORMED"] = "mediaSingleWidthTransformed";
    /**
   * used in Editor AI inline suggestion for a track event when a suggestion is inserted
   * previously tracked events being used by Editor AI proactive suggestion
   *
   */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    ACTION["SUPPRESSED"] = "suppressed";
    return ACTION;
}({});
var $ce1551af2b80b91e$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    INPUT_METHOD["SYNCED_BLOCK_TB"] = "syncedBlockToolbar";
    INPUT_METHOD["BLOCK_MENU"] = "blockMenu";
    INPUT_METHOD["SMART_LINK"] = "smartLink";
    INPUT_METHOD["ELEMENT_BROWSER"] = "elementBrowser";
    INPUT_METHOD["REMIX"] = "remix";
    return INPUT_METHOD;
}({});
var $ce1551af2b80b91e$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $ce1551af2b80b91e$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    // single key, e.g. Esc, Enter
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    // combination of keys, e.g. Mod + F
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $ce1551af2b80b91e$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["AI_STREAMING"] = "aiStreaming";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["AI_QUICK_PROMPT"] = "aiQuickPrompt";
    ACTION_SUBJECT["AI_AUTOCOMPLETE"] = "aiAutocomplete";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU"] = "toolbarDropdownMenu";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU_ITEM"] = "toolbarDropdownMenuItem";
    ACTION_SUBJECT["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT["BLOCK_MENU_ITEM"] = "blockMenuItem";
    ACTION_SUBJECT["PASTE_ACTIONS_MENU"] = "pasteActionsMenu";
    ACTION_SUBJECT["SYNCED_BLOCK"] = "syncedBlock";
    ACTION_SUBJECT["NATIVE_EMBED"] = "nativeEmbed";
    return ACTION_SUBJECT;
}({});
var $ce1551af2b80b91e$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_CHANGES_ACCEPT_BUTTON"] = "aiChangesAcceptButton";
    ACTION_SUBJECT_ID["AI_CHANGES_REJECT_BUTTON"] = "aiChangesRejectButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["AI_ASK_ROVO_BUTTON"] = "aiAskRovoButton";
    ACTION_SUBJECT_ID["AI_HERO_PROMPT_BUTTON"] = "aiHeroPromptButton";
    ACTION_SUBJECT_ID["AI_MORE_ROVO_OPTIONS"] = "aiMoreRovoOptions";
    ACTION_SUBJECT_ID["AI_TRANSLATE"] = "aiTranslate";
    ACTION_SUBJECT_ID["AI_CHANGE_TONE"] = "aiChangeTone";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["COPY_BLOCK"] = "copyBlock";
    ACTION_SUBJECT_ID["COPY_LINK_TO_BLOCK"] = "copyLinkToBlock";
    ACTION_SUBJECT_ID["DELETE_BLOCK"] = "deleteBlock";
    ACTION_SUBJECT_ID["MOVE_UP_BLOCK"] = "moveUpBlock";
    ACTION_SUBJECT_ID["MOVE_DOWN_BLOCK"] = "moveDownBlock";
    ACTION_SUBJECT_ID["TRANSFORM_BLOCK"] = "transformBlock";
    ACTION_SUBJECT_ID["FORMAT_MENU"] = "formatMenu";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DISCARD_STREAM"] = "discardStream";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR"] = "floatingToolbar";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_SMALL_TEXT"] = "smallText";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRIMARY_TOOLBAR"] = "primaryToolbar";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["SMART_LINK_ROVO_BUTTON"] = "smartLinkRovoButton";
    ACTION_SUBJECT_ID["SMART_LINK_SUMMARIZE_BUTTON"] = "smartLinkSummarizeButton";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["TOOLBAR_PREVIEW"] = "previewFromToolbar";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPDATE_STREAM"] = "updateStream";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR"] = "selectionToolbar";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    ACTION_SUBJECT_ID["TRANSFORM"] = "transform";
    ACTION_SUBJECT_ID["BODIED_SYNCED_BLOCK"] = "bodiedSyncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK"] = "syncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_TOOLBAR"] = "syncedBlockToolbar";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_COPY"] = "syncedBlockCopy";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_URL"] = "syncedBlockSourceUrl";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE_CACHE"] = "syncedBlockUpdateCache";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_CREATE"] = "referenceSyncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CLICK_SYNCED_LOCATION"] = "syncedBlockClickSyncedLocation";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_LABEL"] = "syncedBlockLabel";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SSR_ERROR"] = "syncedBlockSSRError";
    ACTION_SUBJECT_ID["TABLE_STICKY_HEADER"] = "tableStickyHeader";
    ACTION_SUBJECT_ID["SNIPPET"] = "snippet";
    return ACTION_SUBJECT_ID;
}({});
var $ce1551af2b80b91e$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $ce1551af2b80b91e$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    CONTENT_COMPONENT["SELECTION_TOOLBAR"] = "selectionToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("FbXg8", function(module, exports) {
$parcel$export(module.exports, "unsupportedContentMessages", () => $def23fe21eede09a$export$32ec96484dd3ba39);

var $6K2Gm = parcelRequire("6K2Gm");
const $def23fe21eede09a$export$32ec96484dd3ba39 = (0, $6K2Gm.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'The text is shown as an inline label in the editor when a content node type is not supported for display. It appears alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'The text is shown as a block-level message in the editor when a content block type is not supported for display. It appears centered within a dashed border container alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'The text is shown as tooltip content when the user hovers over the question mark icon on an unsupported content node in the editor. It reassures users that unsupported content will not be lost when they edit and save the document.'
    }
});

});

parcelRegister("fZ6KA", function(module, exports) {
$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $977003cd39f9d536$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $977003cd39f9d536$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $977003cd39f9d536$export$3a34598135e7219b);

var $eguiP = parcelRequire("eguiP");
const $977003cd39f9d536$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $977003cd39f9d536$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $977003cd39f9d536$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $977003cd39f9d536$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $977003cd39f9d536$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$977003cd39f9d536$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $977003cd39f9d536$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $eguiP.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $eguiP.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $977003cd39f9d536$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $977003cd39f9d536$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $eguiP.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $977003cd39f9d536$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $eguiP.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $eguiP.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $eguiP.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $977003cd39f9d536$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$977003cd39f9d536$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $977003cd39f9d536$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $977003cd39f9d536$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $977003cd39f9d536$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $977003cd39f9d536$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $eguiP.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $eguiP.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $eguiP.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $977003cd39f9d536$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $977003cd39f9d536$var$trackUnsupportedContentTooltipActionFor((0, $eguiP.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("ejxna", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContent", () => $0c63c75775569dcf$export$d4ded51d0f0bd2df);
function $0c63c75775569dcf$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("kST4t", function(module, exports) {
$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $f0832266fcd7cb6d$export$9ac3d19711324187);

var $8P7DW = parcelRequire("8P7DW");

var $k7ZVu = parcelRequire("k7ZVu");
const $f0832266fcd7cb6d$export$9ac3d19711324187 = (0, $k7ZVu.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("7CWXm", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $d1a6dd1b9019a14d$export$6c724a6ffa2dc3e1);

var $hXXvg = parcelRequire("hXXvg");
const $d1a6dd1b9019a14d$var$getFirstMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
const $d1a6dd1b9019a14d$var$getSecondMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
const $d1a6dd1b9019a14d$var$getSafeUserAgent = ()=>{
    var _window$navigator;
    if (typeof window === 'undefined') return undefined;
    // Fallback to navigator.userAgent with proper null checking
    return (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent;
};
const $d1a6dd1b9019a14d$var$getSafePlatform = ()=>{
    var _window$navigator2;
    if (typeof window === 'undefined') return undefined;
    return (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.platform;
};
const $d1a6dd1b9019a14d$var$hasIntersectionObserver = ()=>{
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
const $d1a6dd1b9019a14d$var$hasResizeObserver = ()=>{
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
const $d1a6dd1b9019a14d$export$6c724a6ffa2dc3e1 = (0, $hXXvg.default)(()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    const userAgent = $d1a6dd1b9019a14d$var$getSafeUserAgent();
    const platform = $d1a6dd1b9019a14d$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const ieEdge = /\sedg\//i.test(userAgent);
        // eslint-disable-next-line require-unicode-regexp
        const ieEdge2 = /edg([ea]|ios)/i.test(userAgent);
        // eslint-disable-next-line require-unicode-regexp
        const internetExplorer = /msie|trident/i.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.mac = platform && /Mac/.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        /Windows|Win\d+/i.test(userAgent);
        // used userAgent rather than relying on documentMode
        const ie = ieEdge || ieEdge2 || internetExplorer;
        result.ie = ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = ieEdge ? // eslint-disable-next-line require-unicode-regexp
        parseInt($d1a6dd1b9019a14d$var$getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, userAgent), 10) : // eslint-disable-next-line require-unicode-regexp
        ieEdge2 ? // eslint-disable-next-line require-unicode-regexp
        parseInt($d1a6dd1b9019a14d$var$getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, userAgent), 10) : // eslint-disable-next-line require-unicode-regexp
        parseInt($d1a6dd1b9019a14d$var$getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, userAgent), 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.gecko = !ie && /gecko\/\d/i.test(userAgent);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.gecko_version = parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.chrome = !ie && /Chrome\//.test(userAgent);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.chrome_version = parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.android = /Android \d/.test(userAgent);
        result.ios = // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        !ie && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        result.safari = !result.chrome && !result.ie && !result.gecko && !result.android && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS') && // eslint-disable-next-line require-unicode-regexp
        /safari|applewebkit/i.test(userAgent);
        result.safari_version = parseInt(// eslint-disable-next-line require-unicode-regexp
        (userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        // eslint-disable-next-line require-unicode-regexp
        result.webkit = /(apple)?webkit/i.test(userAgent);
        result.supportsIntersectionObserver = $d1a6dd1b9019a14d$var$hasIntersectionObserver();
        result.supportsResizeObserver = $d1a6dd1b9019a14d$var$hasResizeObserver();
    }
    return result;
});

});

parcelRegister("dxSZI", function(module, exports) {
$parcel$export(module.exports, "startMeasure", () => $207ee3580d335006$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $207ee3580d335006$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $207ee3580d335006$export$6f766653554dac02);
$parcel$export(module.exports, "isMeasuring", () => $207ee3580d335006$export$b0a51f9f0047ea32);

var $5StdA = parcelRequire("5StdA");
const $207ee3580d335006$var$measureMap = new Map();
function $207ee3580d335006$export$b62aa2130c86b59b(measureName) {
    if (!(0, $5StdA.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $207ee3580d335006$var$measureMap.set(measureName, performance.now());
}
function $207ee3580d335006$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $5StdA.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $207ee3580d335006$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $207ee3580d335006$export$6f766653554dac02(measureName);
    }
}
function $207ee3580d335006$export$6f766653554dac02(measureName) {
    if (!(0, $5StdA.isPerformanceAPIAvailable)()) return;
    $207ee3580d335006$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $207ee3580d335006$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $5StdA.isPerformanceAPIAvailable)()) return false;
    return $207ee3580d335006$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("5StdA", function(module, exports) {
$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $b7114a762932c7f5$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $b7114a762932c7f5$export$48995af1e77d8643);
let $b7114a762932c7f5$var$hasRequiredPerformanceAPIs;
function $b7114a762932c7f5$export$b5717a625dd4a3eb() {
    if ($b7114a762932c7f5$var$hasRequiredPerformanceAPIs === undefined) $b7114a762932c7f5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $b7114a762932c7f5$var$hasRequiredPerformanceAPIs;
}
function $b7114a762932c7f5$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $b7114a762932c7f5$export$4370ec0f52022f66() {
    return $b7114a762932c7f5$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("hpPtq", function(module, exports) {
$parcel$export(module.exports, "getDistortedDurationMonitor", () => $822da9b7e8ccd2d6$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $822da9b7e8ccd2d6$export$267ed650a5d21ae6);

var $5StdA = parcelRequire("5StdA");
const $822da9b7e8ccd2d6$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
     * Cleans up the document visibility event listener
     */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $822da9b7e8ccd2d6$export$267ed650a5d21ae6(/**
 * Unique name for the measurement
 *
 * Important: if multiple measureRender events are fired at the same time
 * with the same measure name -- the result will not be correct.
 */ measureName, /**
 * Call back fired when the measurement completes.
 *
 * Note: when this function is called when the Document.visibilityState is not
 * visible -- the duration is likely to be misleading/inaccurate. This is due
 * to the measurements use of the `requestAnimationFrame` api which only fires
 * when the Document.visibilityState is visible.
 */ onMeasureComplete) {
    if (!(0, $5StdA.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $822da9b7e8ccd2d6$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("dqleT", function(module, exports) {
$parcel$export(module.exports, "getResponseEndTime", () => $aa6a6bc287521466$export$92d097a1155bbe27);
$parcel$export(module.exports, "getRequestToResponseTime", () => $aa6a6bc287521466$export$c982229f6c12dcf);

var $5StdA = parcelRequire("5StdA");
function $aa6a6bc287521466$export$92d097a1155bbe27() {
    if (!(0, $5StdA.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}
function $aa6a6bc287521466$export$c982229f6c12dcf() {
    if (!(0, $5StdA.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd - nav.requestStart;
    return;
}

});

parcelRegister("kfvAE", function(module, exports) {
$parcel$export(module.exports, "useScrollToBlock", () => $9ed0c46e5c1c6fac$export$81bdbc2b3f1c95ef);

var $8P7DW = parcelRequire("8P7DW");

var $lCTyY = parcelRequire("lCTyY");

var $aKLci = parcelRequire("aKLci");
var $lSejx = parcelRequire("lSejx");

var $e6Qdr = parcelRequire("e6Qdr");

var $6NDYp = parcelRequire("6NDYp");
const $9ed0c46e5c1c6fac$export$81bdbc2b3f1c95ef = (containerRef, adfDoc, scrollToBlock)=>{
    const { waitForStability: waitForStability, cleanup: cleanupStability } = (0, $6NDYp.useStableScroll)({
        stabilityWaitTime: 750,
        maxStabilityWaitTime: 10000
    });
    (0, $8P7DW.useEffect)(()=>{
        var _getDocument;
        // Only run in browser environment.
        if (typeof window === 'undefined' || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return;
        // Parse hash fragment for block ID (format: #block-{localId}).
        const hash = window.location.hash;
        const defaultPrefixWithHash = `#${(0, $aKLci.DEFAULT_BLOCK_LINK_HASH_PREFIX)}`;
        const blockId = hash && hash.startsWith(defaultPrefixWithHash) ? hash.slice(defaultPrefixWithHash.length) : null;
        if (!blockId) return;
        let retryCount = 0;
        const maxRetries = 40;
        const retryInterval = 250;
        let intervalId = null;
        let hasScrolled = false;
        let cancelExpandAndScroll = null;
        const scrollToElement = ()=>{
            // Step 1: Search the ADF document for the node with the given blockId.
            // This works even if the node is hidden inside a collapsed expand.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            const nodeWithExpandParents = (0, $lSejx.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) // Node not found in ADF document.
            return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Step 2: If the node has expand parents, we need to expand them first.
            if (expandParentLocalIds.length > 0) {
                // Find the expand elements in the DOM using their localIds.
                // Note: We need to expand from outermost to innermost.
                let allExpandsFound = true;
                let anyExpandsCollapsed = false;
                for (const expandLocalId of expandParentLocalIds){
                    const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                    if (!expandContainer) {
                        // Expand not found in DOM yet (shouldn't happen but handle it).
                        allExpandsFound = false;
                        break;
                    }
                    // Check if this expand is collapsed.
                    if ((0, $lSejx.isExpandCollapsed)(expandContainer)) {
                        anyExpandsCollapsed = true;
                        // Expand it.
                        (0, $lSejx.expandElement)(expandContainer);
                        // After expanding, we need to retry to handle nested expands.
                        // The DOM needs time to update.
                        return false; // Will retry after interval.
                    }
                }
                if (!allExpandsFound) // Retry later when expands are in DOM.
                return false;
                // All parent expands are now open (or we just expanded one and need to wait).
                if (anyExpandsCollapsed) // Just expanded something, wait for DOM update.
                return false;
            }
            // Step 3: Now the target element should be visible in the DOM, find it and scroll.
            const element = (0, $lSejx.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) // Element still not in DOM, retry.
            return false;
            // Element found and all parent expands are open! Use the utility to scroll.
            // (This will handle any final edge cases and do the actual scrolling).
            // Capture cleanup function to cancel pending timeouts.
            if ((0, $e6Qdr.fg)('platform_editor_block_menu_v2_patch_4')) cancelExpandAndScroll = (0, $lSejx.expandAllParentsThenScroll)(element, 0, (el)=>{
                if (scrollToBlock) scrollToBlock(el);
                else el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
            else cancelExpandAndScroll = (0, $lSejx.expandAllParentsThenScroll)(element);
            return true;
        };
        const performScroll = ()=>{
            if (hasScrolled) return;
            // Try to scroll to element.
            if (scrollToElement()) {
                hasScrolled = true;
                cleanup();
            }
        };
        const attemptScroll = ()=>{
            retryCount++;
            // Try to find the element first.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            const nodeWithExpandParents = (0, $lSejx.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Check if all expands are expanded and element exists.
            let allReady = true;
            if (expandParentLocalIds.length > 0) for (const expandLocalId of expandParentLocalIds){
                const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                if (!expandContainer) {
                    allReady = false;
                    break;
                }
                if ((0, $lSejx.isExpandCollapsed)(expandContainer)) {
                    (0, $lSejx.expandElement)(expandContainer);
                    allReady = false;
                    break;
                }
            }
            const element = (0, $lSejx.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) allReady = false;
            // If everything is ready, start monitoring for stability.
            if (allReady) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                waitForStability(containerRef.current, performScroll);
                return true;
            }
            // Stop retrying if we've exceeded max retries.
            if (retryCount >= maxRetries) {
                cleanup();
                return false;
            }
            return false;
        };
        const cleanup = ()=>{
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
            cleanupStability();
            // Cancel any pending expand and scroll operations.
            if (cancelExpandAndScroll) {
                cancelExpandAndScroll();
                cancelExpandAndScroll = null;
            }
        };
        // Try to scroll immediately.
        if (attemptScroll()) return cleanup;
        if (((_getDocument = (0, $lCTyY.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.readyState) === 'complete') // Document is already ready, try a few more times with delays.
        // This handles cases where elements are added after document ready.
        intervalId = setInterval(()=>{
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry.
        intervalId = setInterval(()=>{
            var _getDocument2;
            if (((_getDocument2 = (0, $lCTyY.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.readyState) === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) cleanup();
            else retryCount++;
        }, retryInterval);
        // Cleanup function.
        return cleanup;
    // Intentionally not including adfDoc in the dependency array to avoid unnecessary re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        containerRef,
        waitForStability,
        cleanupStability,
        scrollToBlock
    ]);
};

});
parcelRegister("aKLci", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_BLOCK_LINK_HASH_PREFIX", () => $bd461e8ba9a051d3$export$18a71eb9fe4307bc);
$parcel$export(module.exports, "createBlockLinkHashValue", () => $bd461e8ba9a051d3$export$7d28ccc9eddf2197);
const $bd461e8ba9a051d3$export$18a71eb9fe4307bc = 'block-';
const $bd461e8ba9a051d3$export$d7e471f6502a69e2 = (hash, prefix = $bd461e8ba9a051d3$export$18a71eb9fe4307bc)=>{
    if (!hash || !prefix) return false;
    // Match either UUID format (8-4-4-4-12) or short hex ID format (exactly 12 hex chars without dashes).
    const uuidRegex = new RegExp(`^#?${prefix}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$`, 'iu');
    const shortIdRegex = new RegExp(`^#?${prefix}[0-9a-f]{12}$`, 'iu');
    return uuidRegex.test(hash) || shortIdRegex.test(hash);
};
const $bd461e8ba9a051d3$export$c95c8d5e0fd74b32 = (hash, prefix = $bd461e8ba9a051d3$export$18a71eb9fe4307bc)=>{
    if (!$bd461e8ba9a051d3$export$d7e471f6502a69e2(hash, prefix)) return null;
    // Remove leading # if present, then remove the prefix.
    const normalized = hash.startsWith('#') ? hash.slice(1) : hash;
    return normalized.slice(prefix.length);
};
const $bd461e8ba9a051d3$export$7d28ccc9eddf2197 = (blockId, prefix = $bd461e8ba9a051d3$export$18a71eb9fe4307bc)=>{
    return `${prefix}${blockId}`;
};

});

parcelRegister("lSejx", function(module, exports) {
$parcel$export(module.exports, "findNodeWithExpandParents", () => $fdb42b1308fa71c0$export$e070f925e0e65bbc);
$parcel$export(module.exports, "isExpandCollapsed", () => $fdb42b1308fa71c0$export$785b8bfd794fa7b6);
$parcel$export(module.exports, "expandElement", () => $fdb42b1308fa71c0$export$280ec17414a50cdd);
$parcel$export(module.exports, "expandAllParentsThenScroll", () => $fdb42b1308fa71c0$export$9d8f3695c9ce7da0);
$parcel$export(module.exports, "getLocalIdSelector", () => $fdb42b1308fa71c0$export$94a68fcf7c5634d2);
/**
 * Shared utilities for scrolling to block elements with expand node support.
 * Used by both Confluence's useScrollOnUrlChange and platform renderer's useScrollToBlock.
 */ 
var $e6Qdr = parcelRequire("e6Qdr");
const $fdb42b1308fa71c0$export$7f8747c9df4cadcb = {
    /** Minimal delay for DOM/React updates after expanding (no animation in expand component). */ DOM_UPDATE_DELAY: 50,
    /** Delay when expand operation fails and needs retry. */ RETRY_DELAY: 100,
    /** Maximum number of retry attempts before giving up and scrolling anyway. */ MAX_ATTEMPTS: 5,
    /** Maximum depth of nested expands to search (prevents infinite loops). */ MAX_EXPAND_DEPTH: 2
};
function $fdb42b1308fa71c0$export$e070f925e0e65bbc(adfDoc, targetLocalId) {
    let result;
    /**
   * Recursive helper to traverse the ADF document and track expand ancestors.
   * We use recursion to properly maintain the expand ancestor stack.
   */ const traverse = (node, expandAncestors)=>{
        var _node$attrs, _node$attrs2;
        // If we already found the target, stop traversing
        if (result) return false;
        // Check if this is the target node by localId
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) === targetLocalId) {
            result = {
                expandParentLocalIds: [
                    ...expandAncestors
                ] // Copy the array
            };
            return false; // Stop traversing
        }
        // Check if this node is an expand or nestedExpand
        const isExpand = (node === null || node === void 0 ? void 0 : node.type) === 'expand' || (node === null || node === void 0 ? void 0 : node.type) === 'nestedExpand';
        const newExpandAncestors = isExpand && node !== null && node !== void 0 && (_node$attrs2 = node.attrs) !== null && _node$attrs2 !== void 0 && _node$attrs2.localId ? [
            ...expandAncestors,
            node.attrs.localId
        ] : expandAncestors;
        // Traverse children if they exist
        if (node !== null && node !== void 0 && node.content && Array.isArray(node.content)) for (const child of node.content){
            if (result || !child) break;
            traverse(child, newExpandAncestors);
        }
        return !result; // Continue if we haven't found it yet
    };
    // Start traversal from the root
    traverse(adfDoc, []);
    return result;
}
const $fdb42b1308fa71c0$export$4fc3b03d60a46096 = (element, maxDepth = $fdb42b1308fa71c0$export$7f8747c9df4cadcb.MAX_EXPAND_DEPTH)=>{
    const expands = [];
    let currentElement = element;
    let depth = 0;
    while(currentElement && depth < maxDepth){
        // Look for expand container - handles both "expand" and "nestedExpand" types
        const expandContainer = currentElement.closest('[data-node-type="expand"], [data-node-type="nestedExpand"]');
        if (!expandContainer || expands.includes(expandContainer)) break;
        expands.push(expandContainer);
        currentElement = expandContainer.parentElement;
        depth++;
    }
    // Return in reverse order so we expand from outermost to innermost
    return expands.reverse();
};
const $fdb42b1308fa71c0$export$785b8bfd794fa7b6 = (expandContainer)=>{
    // Check for aria-expanded attribute on the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded]');
    if (toggleButton && toggleButton instanceof HTMLElement) return toggleButton.getAttribute('aria-expanded') === 'false';
    // Fallback: check if content div is hidden using the actual class name
    const contentDiv = expandContainer.querySelector('.ak-editor-expand__content');
    if (contentDiv && contentDiv instanceof HTMLElement) {
        const computedStyle = window.getComputedStyle(contentDiv);
        return computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || contentDiv.hidden;
    }
    return false;
};
const $fdb42b1308fa71c0$export$280ec17414a50cdd = (expandContainer)=>{
    // Find and click the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded="false"]');
    if (toggleButton && toggleButton instanceof HTMLElement) {
        toggleButton.click();
        return true;
    }
    return false;
};
const $fdb42b1308fa71c0$export$9d8f3695c9ce7da0 = (element, attempt = 0, scrollFn)=>{
    const { MAX_EXPAND_DEPTH: MAX_EXPAND_DEPTH, MAX_ATTEMPTS: MAX_ATTEMPTS, DOM_UPDATE_DELAY: DOM_UPDATE_DELAY, RETRY_DELAY: RETRY_DELAY } = $fdb42b1308fa71c0$export$7f8747c9df4cadcb;
    const doScroll = scrollFn ?? ((el)=>el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        }));
    // Store timeout ID and nested cleanup function so they can be cancelled.
    let timeoutId = null;
    let nestedCleanup = null;
    // Cleanup function that cancels pending timeout and any nested operations.
    const cleanup = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        if (nestedCleanup) {
            nestedCleanup();
            nestedCleanup = null;
        }
    };
    // Guard against element being disconnected from DOM or exceeding max attempts.
    if (attempt >= MAX_ATTEMPTS || !element.isConnected) {
        // Max attempts reached or element disconnected, scroll anyway.
        if (element.isConnected) doScroll(element);
        return cleanup;
    }
    try {
        // Step 1: Find all parent expands (outermost to innermost).
        const parentExpands = $fdb42b1308fa71c0$export$4fc3b03d60a46096(element, MAX_EXPAND_DEPTH);
        // Step 2: Find any collapsed expands (filter out disconnected elements).
        const collapsedExpands = parentExpands.filter((expandContainer)=>expandContainer.isConnected && $fdb42b1308fa71c0$export$785b8bfd794fa7b6(expandContainer));
        if (collapsedExpands.length === 0) {
            // All expands are open (or there are no expands), scroll to element.
            doScroll(element);
            return cleanup;
        }
        // Step 3: Expand ONLY the outermost collapsed expand first.
        // This is critical for nested expands - we must expand parent before child.
        const outermostCollapsed = collapsedExpands[0];
        try {
            const expanded = $fdb42b1308fa71c0$export$280ec17414a50cdd(outermostCollapsed);
            if (expanded) // Successfully expanded, wait briefly for DOM update then recurse to handle any nested expands.
            // Note: There's no animation, but we need a minimal delay for DOM/React updates.
            timeoutId = setTimeout(()=>{
                try {
                    // Verify element is still connected before proceeding.
                    if (!element.isConnected) return;
                    // Recurse to handle any nested collapsed expands or retry if still collapsed.
                    nestedCleanup = $fdb42b1308fa71c0$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
                } catch  {
                    // Fallback to simple scroll on error.
                    if (element.isConnected) doScroll(element);
                }
            }, DOM_UPDATE_DELAY);
            else // Failed to expand, retry with longer delay.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $fdb42b1308fa71c0$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        } catch  {
            // Retry on error.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $fdb42b1308fa71c0$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        }
    } catch  {
        // Fallback to simple scroll on error.
        if (element.isConnected) doScroll(element);
    }
    return cleanup;
};
const $fdb42b1308fa71c0$export$94a68fcf7c5634d2 = (localId, container)=>{
    // Check if the element with data-local-id exists
    let element = container.querySelector(`[data-local-id="${localId}"]`);
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (element) return element;
    element = container.querySelector(`[data-task-list-local-id="${localId}"]`);
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector(`[data-table-local-id="${localId}"]`);
    if (element) {
        if ((0, $e6Qdr.fg)('platform_editor_block_menu_v2_patch_4')) return element.parentElement; // return table wrapper instead of table div, so the height calculation is correct
        return element;
    }
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector(`[localid="${localId}"]`);
    if (element) return element;
    return null;
};

});

parcelRegister("6NDYp", function(module, exports) {
$parcel$export(module.exports, "useStableScroll", () => $9bc0aa7aaec53214$export$3325eba9424d3c32);

var $8P7DW = parcelRequire("8P7DW");
const $9bc0aa7aaec53214$export$3325eba9424d3c32 = (options = {})=>{
    const { stabilityWaitTime: stabilityWaitTime = 200, maxStabilityWaitTime: maxStabilityWaitTime = 10000 } = options;
    const stabilityTimeoutRef = (0, $8P7DW.useRef)(null);
    const resizeObserverRef = (0, $8P7DW.useRef)(null);
    const lastStableTimeRef = (0, $8P7DW.useRef)(0);
    const onStableCallbackRef = (0, $8P7DW.useRef)(null);
    const cleanup = (0, $8P7DW.useCallback)(()=>{
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        onStableCallbackRef.current = null;
        lastStableTimeRef.current = 0;
    }, []);
    const scheduleStabilityCheck = (0, $8P7DW.useCallback)(()=>{
        // Clear any existing stability timeout.
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        // Check if we've exceeded the maximum stability wait time.
        const now = Date.now();
        if (lastStableTimeRef.current === 0) lastStableTimeRef.current = now;
        else if (now - lastStableTimeRef.current > maxStabilityWaitTime) {
            // We've waited too long for stability, call the callback now.
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
            return;
        }
        // Set a timeout to call the callback after the stability wait time.
        stabilityTimeoutRef.current = setTimeout(()=>{
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
        }, stabilityWaitTime);
    }, [
        stabilityWaitTime,
        maxStabilityWaitTime,
        cleanup
    ]);
    const waitForStability = (0, $8P7DW.useCallback)((container, onStable)=>{
        // Clean up any existing observer
        cleanup();
        // Store the callback
        onStableCallbackRef.current = onStable;
        // Check if ResizeObserver is available
        if (typeof ResizeObserver === 'undefined') {
            // Fallback: just call the callback after the stability wait time
            stabilityTimeoutRef.current = setTimeout(()=>{
                if (onStableCallbackRef.current) {
                    onStableCallbackRef.current();
                    cleanup();
                }
            }, stabilityWaitTime);
            return;
        }
        // Create a ResizeObserver to monitor the container for size changes.
        resizeObserverRef.current = new ResizeObserver(()=>{
            // Container size changed, reset stability timer.
            scheduleStabilityCheck();
        });
        resizeObserverRef.current.observe(container);
        // Start the initial stability check
        scheduleStabilityCheck();
    }, [
        stabilityWaitTime,
        scheduleStabilityCheck,
        cleanup
    ]);
    return {
        waitForStability: waitForStability,
        cleanup: cleanup
    };
};

});


parcelRegister("7VS6B", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsAppearance", () => $d90d5e3f1b8a4efc$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $d90d5e3f1b8a4efc$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $d90d5e3f1b8a4efc$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "findInsertLocation", () => $d90d5e3f1b8a4efc$export$d770b562ead089d8);
$parcel$export(module.exports, "analyticsEventKey", () => $d90d5e3f1b8a4efc$export$288273ee3e3b6132);
$parcel$export(module.exports, "getBreakpointKey", () => $d90d5e3f1b8a4efc$export$afdcbbd112676ca8);

var $5VXGe = parcelRequire("5VXGe");

var $j3TCs = parcelRequire("j3TCs");

var $dqksE = parcelRequire("dqksE");

var $60eNJ = parcelRequire("60eNJ");
const $d90d5e3f1b8a4efc$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $5VXGe.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $5VXGe.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $5VXGe.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $5VXGe.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $5VXGe.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        case 'max':
            return (0, $5VXGe.EDITOR_APPEARANCE_CONTEXT).MAX;
    }
};
const $d90d5e3f1b8a4efc$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d90d5e3f1b8a4efc$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $d90d5e3f1b8a4efc$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $d90d5e3f1b8a4efc$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $j3TCs.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $60eNJ.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $dqksE.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $d90d5e3f1b8a4efc$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $d90d5e3f1b8a4efc$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
const $d90d5e3f1b8a4efc$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
const $d90d5e3f1b8a4efc$var$TABLE_BREAKPOINT_KEYS = Object.keys($d90d5e3f1b8a4efc$var$EDITOR_BREAKPOINT_WIDTH);
const $d90d5e3f1b8a4efc$export$afdcbbd112676ca8 = (width)=>{
    return $d90d5e3f1b8a4efc$var$TABLE_BREAKPOINT_KEYS.find((key)=>width <= $d90d5e3f1b8a4efc$var$EDITOR_BREAKPOINT_WIDTH[key]) || 'L';
};

});
parcelRegister("j3TCs", function(module, exports) {
$parcel$export(module.exports, "Selection", () => $de0970f4427fb757$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $de0970f4427fb757$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $de0970f4427fb757$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $de0970f4427fb757$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $de0970f4427fb757$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $de0970f4427fb757$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $de0970f4427fb757$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $de0970f4427fb757$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $de0970f4427fb757$export$1692d8b0e89cecc3);

var $2sVuK = parcelRequire("2sVuK");

var $jOegv = parcelRequire("jOegv");
const $de0970f4427fb757$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $de0970f4427fb757$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $de0970f4427fb757$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $2sVuK.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $2sVuK.Slice).empty : content);
            if (i == 0) $de0970f4427fb757$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $de0970f4427fb757$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $de0970f4427fb757$export$c2b25f346d19bcbb($pos) : $de0970f4427fb757$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $de0970f4427fb757$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $de0970f4427fb757$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $de0970f4427fb757$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $de0970f4427fb757$var$findSelectionIn(doc, doc, 0, 0, 1) || new $de0970f4427fb757$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $de0970f4427fb757$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $de0970f4427fb757$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $de0970f4427fb757$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $de0970f4427fb757$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $de0970f4427fb757$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $de0970f4427fb757$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$de0970f4427fb757$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $de0970f4427fb757$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $de0970f4427fb757$var$warnedAboutTextSelection = false;
function $de0970f4427fb757$var$checkTextSelection($pos) {
    if (!$de0970f4427fb757$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $de0970f4427fb757$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $de0970f4427fb757$export$c2b25f346d19bcbb extends $de0970f4427fb757$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $de0970f4427fb757$var$checkTextSelection($anchor);
        $de0970f4427fb757$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $de0970f4427fb757$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $de0970f4427fb757$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $2sVuK.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $2sVuK.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $de0970f4427fb757$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $de0970f4427fb757$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $de0970f4427fb757$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $de0970f4427fb757$export$52baac22726c72bf.findFrom($head, bias, true) || $de0970f4427fb757$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $de0970f4427fb757$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($de0970f4427fb757$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $de0970f4427fb757$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $de0970f4427fb757$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$de0970f4427fb757$export$52baac22726c72bf.jsonID("text", $de0970f4427fb757$export$c2b25f346d19bcbb);
class $de0970f4427fb757$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $de0970f4427fb757$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $de0970f4427fb757$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $de0970f4427fb757$export$e2940151ac854c0b extends $de0970f4427fb757$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $de0970f4427fb757$export$52baac22726c72bf.near($pos);
        return new $de0970f4427fb757$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $de0970f4427fb757$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $de0970f4427fb757$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $de0970f4427fb757$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $de0970f4427fb757$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$de0970f4427fb757$export$e2940151ac854c0b.prototype.visible = false;
$de0970f4427fb757$export$52baac22726c72bf.jsonID("node", $de0970f4427fb757$export$e2940151ac854c0b);
class $de0970f4427fb757$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $de0970f4427fb757$var$TextBookmark(pos, pos) : new $de0970f4427fb757$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $de0970f4427fb757$export$e2940151ac854c0b.isSelectable(node)) return new $de0970f4427fb757$export$e2940151ac854c0b($pos);
        return $de0970f4427fb757$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $de0970f4427fb757$export$c15d9ba76bdbcd95 extends $de0970f4427fb757$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $2sVuK.Slice).empty) {
        if (content == (0, $2sVuK.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $de0970f4427fb757$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $de0970f4427fb757$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $de0970f4427fb757$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $de0970f4427fb757$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $de0970f4427fb757$var$AllBookmark;
    }
}
$de0970f4427fb757$export$52baac22726c72bf.jsonID("all", $de0970f4427fb757$export$c15d9ba76bdbcd95);
const $de0970f4427fb757$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $de0970f4427fb757$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $de0970f4427fb757$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $de0970f4427fb757$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $de0970f4427fb757$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $de0970f4427fb757$export$e2940151ac854c0b.isSelectable(child)) return $de0970f4427fb757$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $de0970f4427fb757$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $jOegv.ReplaceStep) || step instanceof (0, $jOegv.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($de0970f4427fb757$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $de0970f4427fb757$var$UPDATED_SEL = 1, $de0970f4427fb757$var$UPDATED_MARKS = 2, $de0970f4427fb757$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $de0970f4427fb757$export$febc5573c75cefb0 extends (0, $jOegv.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $de0970f4427fb757$var$UPDATED_SEL) & ~$de0970f4427fb757$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $de0970f4427fb757$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $de0970f4427fb757$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $2sVuK.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $de0970f4427fb757$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$de0970f4427fb757$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $2sVuK.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($de0970f4427fb757$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $de0970f4427fb757$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $de0970f4427fb757$var$UPDATED_SCROLL) > 0;
    }
}
function $de0970f4427fb757$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $de0970f4427fb757$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $de0970f4427fb757$var$bind(desc.init, self);
        this.apply = $de0970f4427fb757$var$bind(desc.apply, self);
    }
}
const $de0970f4427fb757$var$baseFields = [
    new $de0970f4427fb757$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $de0970f4427fb757$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $de0970f4427fb757$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $de0970f4427fb757$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $de0970f4427fb757$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $de0970f4427fb757$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $de0970f4427fb757$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $de0970f4427fb757$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $de0970f4427fb757$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $de0970f4427fb757$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $de0970f4427fb757$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $de0970f4427fb757$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $de0970f4427fb757$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $de0970f4427fb757$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $de0970f4427fb757$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $de0970f4427fb757$var$Configuration(config.schema, config.plugins);
        let instance = new $de0970f4427fb757$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $2sVuK.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $de0970f4427fb757$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $de0970f4427fb757$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $de0970f4427fb757$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $de0970f4427fb757$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $de0970f4427fb757$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $de0970f4427fb757$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $de0970f4427fb757$var$keys = Object.create(null);
function $de0970f4427fb757$var$createKey(name) {
    if (name in $de0970f4427fb757$var$keys) return name + "$" + ++$de0970f4427fb757$var$keys[name];
    $de0970f4427fb757$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $de0970f4427fb757$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $de0970f4427fb757$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("jOegv", function(module, exports) {
$parcel$export(module.exports, "StepMap", () => $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $e6bdc09fefd7c5f9$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $e6bdc09fefd7c5f9$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $e6bdc09fefd7c5f9$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $e6bdc09fefd7c5f9$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $e6bdc09fefd7c5f9$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $e6bdc09fefd7c5f9$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $e6bdc09fefd7c5f9$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $e6bdc09fefd7c5f9$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $e6bdc09fefd7c5f9$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $e6bdc09fefd7c5f9$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $e6bdc09fefd7c5f9$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $e6bdc09fefd7c5f9$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $e6bdc09fefd7c5f9$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $e6bdc09fefd7c5f9$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $e6bdc09fefd7c5f9$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $e6bdc09fefd7c5f9$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $e6bdc09fefd7c5f9$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $e6bdc09fefd7c5f9$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $e6bdc09fefd7c5f9$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $e6bdc09fefd7c5f9$export$563a914cafbdc389);

var $2sVuK = parcelRequire("2sVuK");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $e6bdc09fefd7c5f9$var$lower16 = 0xffff;
const $e6bdc09fefd7c5f9$var$factor16 = Math.pow(2, 16);
function $e6bdc09fefd7c5f9$var$makeRecover(index, offset) {
    return index + offset * $e6bdc09fefd7c5f9$var$factor16;
}
function $e6bdc09fefd7c5f9$var$recoverIndex(value) {
    return value & $e6bdc09fefd7c5f9$var$lower16;
}
function $e6bdc09fefd7c5f9$var$recoverOffset(value) {
    return (value - (value & $e6bdc09fefd7c5f9$var$lower16)) / $e6bdc09fefd7c5f9$var$factor16;
}
const $e6bdc09fefd7c5f9$var$DEL_BEFORE = 1, $e6bdc09fefd7c5f9$var$DEL_AFTER = 2, $e6bdc09fefd7c5f9$var$DEL_ACROSS = 4, $e6bdc09fefd7c5f9$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $e6bdc09fefd7c5f9$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $e6bdc09fefd7c5f9$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($e6bdc09fefd7c5f9$var$DEL_BEFORE | $e6bdc09fefd7c5f9$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($e6bdc09fefd7c5f9$var$DEL_AFTER | $e6bdc09fefd7c5f9$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $e6bdc09fefd7c5f9$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3.empty) return $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $e6bdc09fefd7c5f9$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $e6bdc09fefd7c5f9$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $e6bdc09fefd7c5f9$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $e6bdc09fefd7c5f9$var$DEL_AFTER : pos == end ? $e6bdc09fefd7c5f9$var$DEL_BEFORE : $e6bdc09fefd7c5f9$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $e6bdc09fefd7c5f9$var$DEL_SIDE;
                return new $e6bdc09fefd7c5f9$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $e6bdc09fefd7c5f9$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $e6bdc09fefd7c5f9$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3.empty : new $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3.empty = new $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $e6bdc09fefd7c5f9$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $e6bdc09fefd7c5f9$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $e6bdc09fefd7c5f9$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $e6bdc09fefd7c5f9$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $e6bdc09fefd7c5f9$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $e6bdc09fefd7c5f9$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $e6bdc09fefd7c5f9$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $e6bdc09fefd7c5f9$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $e6bdc09fefd7c5f9$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $e6bdc09fefd7c5f9$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $e6bdc09fefd7c5f9$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $e6bdc09fefd7c5f9$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $e6bdc09fefd7c5f9$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $2sVuK.ReplaceError)) return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $e6bdc09fefd7c5f9$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($e6bdc09fefd7c5f9$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $2sVuK.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $e6bdc09fefd7c5f9$export$d24ba56b0e3464a9 extends $e6bdc09fefd7c5f9$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $2sVuK.Slice)($e6bdc09fefd7c5f9$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $e6bdc09fefd7c5f9$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $e6bdc09fefd7c5f9$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $e6bdc09fefd7c5f9$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $e6bdc09fefd7c5f9$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $e6bdc09fefd7c5f9$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$e6bdc09fefd7c5f9$export$fd55ce593607084a.jsonID("addMark", $e6bdc09fefd7c5f9$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $e6bdc09fefd7c5f9$export$94150db1311f67a9 extends $e6bdc09fefd7c5f9$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $2sVuK.Slice)($e6bdc09fefd7c5f9$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $e6bdc09fefd7c5f9$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $e6bdc09fefd7c5f9$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $e6bdc09fefd7c5f9$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $e6bdc09fefd7c5f9$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $e6bdc09fefd7c5f9$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$e6bdc09fefd7c5f9$export$fd55ce593607084a.jsonID("removeMark", $e6bdc09fefd7c5f9$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $e6bdc09fefd7c5f9$export$adefd16c402fee4e extends $e6bdc09fefd7c5f9$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $e6bdc09fefd7c5f9$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $e6bdc09fefd7c5f9$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $e6bdc09fefd7c5f9$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $e6bdc09fefd7c5f9$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $e6bdc09fefd7c5f9$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$e6bdc09fefd7c5f9$export$fd55ce593607084a.jsonID("addNodeMark", $e6bdc09fefd7c5f9$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $e6bdc09fefd7c5f9$export$fdf7d1dc10724da2 extends $e6bdc09fefd7c5f9$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $e6bdc09fefd7c5f9$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $e6bdc09fefd7c5f9$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $e6bdc09fefd7c5f9$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$e6bdc09fefd7c5f9$export$fd55ce593607084a.jsonID("removeNodeMark", $e6bdc09fefd7c5f9$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $e6bdc09fefd7c5f9$export$5c860b2e74034756 extends $e6bdc09fefd7c5f9$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $e6bdc09fefd7c5f9$var$contentBetween(doc, this.from, this.to)) return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $e6bdc09fefd7c5f9$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $e6bdc09fefd7c5f9$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $e6bdc09fefd7c5f9$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $2sVuK.Slice).empty : new (0, $2sVuK.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $e6bdc09fefd7c5f9$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $2sVuK.Slice).empty : new (0, $2sVuK.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $e6bdc09fefd7c5f9$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $e6bdc09fefd7c5f9$export$5c860b2e74034756(json.from, json.to, (0, $2sVuK.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$e6bdc09fefd7c5f9$export$fd55ce593607084a.jsonID("replace", $e6bdc09fefd7c5f9$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $e6bdc09fefd7c5f9$export$444ba800d6024a98 extends $e6bdc09fefd7c5f9$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($e6bdc09fefd7c5f9$var$contentBetween(doc, this.from, this.gapFrom) || $e6bdc09fefd7c5f9$var$contentBetween(doc, this.gapTo, this.to))) return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $e6bdc09fefd7c5f9$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $e6bdc09fefd7c5f9$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $e6bdc09fefd7c5f9$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $2sVuK.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$e6bdc09fefd7c5f9$export$fd55ce593607084a.jsonID("replaceAround", $e6bdc09fefd7c5f9$export$444ba800d6024a98);
function $e6bdc09fefd7c5f9$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $e6bdc09fefd7c5f9$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $e6bdc09fefd7c5f9$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $e6bdc09fefd7c5f9$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $e6bdc09fefd7c5f9$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $2sVuK.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $e6bdc09fefd7c5f9$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $e6bdc09fefd7c5f9$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $e6bdc09fefd7c5f9$export$5c860b2e74034756(cur, end, (0, $2sVuK.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $e6bdc09fefd7c5f9$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $e6bdc09fefd7c5f9$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $2sVuK.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $2sVuK.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $e6bdc09fefd7c5f9$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $e6bdc09fefd7c5f9$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$e6bdc09fefd7c5f9$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $e6bdc09fefd7c5f9$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $2sVuK.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $2sVuK.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $2sVuK.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $2sVuK.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $e6bdc09fefd7c5f9$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $2sVuK.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $e6bdc09fefd7c5f9$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $e6bdc09fefd7c5f9$var$findWrappingOutside(range, nodeType);
    let inner = around && $e6bdc09fefd7c5f9$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($e6bdc09fefd7c5f9$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($e6bdc09fefd7c5f9$var$withAttrs));
}
function $e6bdc09fefd7c5f9$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $e6bdc09fefd7c5f9$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $e6bdc09fefd7c5f9$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $e6bdc09fefd7c5f9$var$wrap(tr, range, wrappers) {
    let content = (0, $2sVuK.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $2sVuK.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $e6bdc09fefd7c5f9$export$444ba800d6024a98(start, end, start, end, new (0, $2sVuK.Slice)(content, 0, 0), wrappers.length, true));
}
function $e6bdc09fefd7c5f9$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $e6bdc09fefd7c5f9$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $e6bdc09fefd7c5f9$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $e6bdc09fefd7c5f9$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $e6bdc09fefd7c5f9$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $e6bdc09fefd7c5f9$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $e6bdc09fefd7c5f9$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $e6bdc09fefd7c5f9$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $e6bdc09fefd7c5f9$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $e6bdc09fefd7c5f9$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $e6bdc09fefd7c5f9$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $e6bdc09fefd7c5f9$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $e6bdc09fefd7c5f9$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $2sVuK.Fragment).empty, after = (0, $2sVuK.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $2sVuK.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $2sVuK.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $e6bdc09fefd7c5f9$export$5c860b2e74034756(pos, pos, new (0, $2sVuK.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $e6bdc09fefd7c5f9$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $e6bdc09fefd7c5f9$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $e6bdc09fefd7c5f9$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $e6bdc09fefd7c5f9$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $e6bdc09fefd7c5f9$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $e6bdc09fefd7c5f9$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $e6bdc09fefd7c5f9$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $e6bdc09fefd7c5f9$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $e6bdc09fefd7c5f9$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $e6bdc09fefd7c5f9$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $e6bdc09fefd7c5f9$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $2sVuK.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $e6bdc09fefd7c5f9$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $e6bdc09fefd7c5f9$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $e6bdc09fefd7c5f9$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $e6bdc09fefd7c5f9$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $2sVuK.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($e6bdc09fefd7c5f9$var$fitsTrivially($from, $to, slice)) return new $e6bdc09fefd7c5f9$export$5c860b2e74034756(from, to, slice);
    return new $e6bdc09fefd7c5f9$var$Fitter($from, $to, slice).fit();
}
function $e6bdc09fefd7c5f9$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $e6bdc09fefd7c5f9$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $2sVuK.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $2sVuK.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $2sVuK.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $e6bdc09fefd7c5f9$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $e6bdc09fefd7c5f9$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $e6bdc09fefd7c5f9$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $2sVuK.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $e6bdc09fefd7c5f9$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $2sVuK.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $e6bdc09fefd7c5f9$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $2sVuK.Slice)($e6bdc09fefd7c5f9$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $2sVuK.Slice)($e6bdc09fefd7c5f9$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($e6bdc09fefd7c5f9$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $e6bdc09fefd7c5f9$var$addToFragment(this.placed, frontierDepth, (0, $2sVuK.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $2sVuK.Slice)($e6bdc09fefd7c5f9$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $2sVuK.Slice).empty : new (0, $2sVuK.Slice)($e6bdc09fefd7c5f9$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$e6bdc09fefd7c5f9$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $e6bdc09fefd7c5f9$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $e6bdc09fefd7c5f9$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $e6bdc09fefd7c5f9$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $e6bdc09fefd7c5f9$var$addToFragment(this.placed, this.depth, (0, $2sVuK.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $2sVuK.Fragment).empty, true);
        if (add.childCount) this.placed = $e6bdc09fefd7c5f9$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $e6bdc09fefd7c5f9$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($e6bdc09fefd7c5f9$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $e6bdc09fefd7c5f9$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($e6bdc09fefd7c5f9$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $e6bdc09fefd7c5f9$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $e6bdc09fefd7c5f9$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $e6bdc09fefd7c5f9$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $2sVuK.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $e6bdc09fefd7c5f9$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$e6bdc09fefd7c5f9$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $e6bdc09fefd7c5f9$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $e6bdc09fefd7c5f9$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $e6bdc09fefd7c5f9$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($e6bdc09fefd7c5f9$var$fitsTrivially($from, $to, slice)) return tr.step(new $e6bdc09fefd7c5f9$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $e6bdc09fefd7c5f9$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $e6bdc09fefd7c5f9$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $2sVuK.Slice)($e6bdc09fefd7c5f9$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $e6bdc09fefd7c5f9$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($e6bdc09fefd7c5f9$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $2sVuK.Fragment).empty, true));
    }
    return fragment;
}
function $e6bdc09fefd7c5f9$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $e6bdc09fefd7c5f9$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(node), 0, 0));
}
function $e6bdc09fefd7c5f9$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $e6bdc09fefd7c5f9$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $e6bdc09fefd7c5f9$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $e6bdc09fefd7c5f9$export$626399c38172f669 extends $e6bdc09fefd7c5f9$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $e6bdc09fefd7c5f9$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $e6bdc09fefd7c5f9$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $e6bdc09fefd7c5f9$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$e6bdc09fefd7c5f9$export$fd55ce593607084a.jsonID("attr", $e6bdc09fefd7c5f9$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $e6bdc09fefd7c5f9$export$f50707b396300ac9 extends $e6bdc09fefd7c5f9$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $e6bdc09fefd7c5f9$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $e6bdc09fefd7c5f9$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $e6bdc09fefd7c5f9$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $e6bdc09fefd7c5f9$export$f50707b396300ac9(json.attr, json.value);
    }
}
$e6bdc09fefd7c5f9$export$fd55ce593607084a.jsonID("docAttr", $e6bdc09fefd7c5f9$export$f50707b396300ac9);
/**
@internal
*/ let $e6bdc09fefd7c5f9$export$88cc3a1dfce48dd3 = class extends Error {
};
$e6bdc09fefd7c5f9$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$e6bdc09fefd7c5f9$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$e6bdc09fefd7c5f9$export$88cc3a1dfce48dd3.prototype.constructor = $e6bdc09fefd7c5f9$export$88cc3a1dfce48dd3;
$e6bdc09fefd7c5f9$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $e6bdc09fefd7c5f9$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $e6bdc09fefd7c5f9$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $e6bdc09fefd7c5f9$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $2sVuK.Slice).empty) {
        let step = $e6bdc09fefd7c5f9$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $2sVuK.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $e6bdc09fefd7c5f9$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $e6bdc09fefd7c5f9$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $e6bdc09fefd7c5f9$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $e6bdc09fefd7c5f9$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $e6bdc09fefd7c5f9$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $e6bdc09fefd7c5f9$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $e6bdc09fefd7c5f9$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $e6bdc09fefd7c5f9$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $e6bdc09fefd7c5f9$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $e6bdc09fefd7c5f9$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $e6bdc09fefd7c5f9$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $2sVuK.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $e6bdc09fefd7c5f9$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $e6bdc09fefd7c5f9$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $e6bdc09fefd7c5f9$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $e6bdc09fefd7c5f9$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $e6bdc09fefd7c5f9$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("dqksE", function(module, exports) {
$parcel$export(module.exports, "removeParentNodeOfType", () => $9c5d933b7322b6be$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $9c5d933b7322b6be$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $9c5d933b7322b6be$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $9c5d933b7322b6be$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $9c5d933b7322b6be$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $9c5d933b7322b6be$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $9c5d933b7322b6be$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $9c5d933b7322b6be$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $9c5d933b7322b6be$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $9c5d933b7322b6be$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $9c5d933b7322b6be$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $9c5d933b7322b6be$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $9c5d933b7322b6be$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $9c5d933b7322b6be$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $9c5d933b7322b6be$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $9c5d933b7322b6be$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $9c5d933b7322b6be$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $9c5d933b7322b6be$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $9c5d933b7322b6be$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $9c5d933b7322b6be$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $9c5d933b7322b6be$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $9c5d933b7322b6be$export$96bb9476c7c69f39);
$parcel$export(module.exports, "findChildrenByMark", () => $9c5d933b7322b6be$export$c01a9e7ec615e821);
$parcel$export(module.exports, "contains", () => $9c5d933b7322b6be$export$2344b14b097df817);
// src/selection.ts

var $j3TCs = parcelRequire("j3TCs");

var $2sVuK = parcelRequire("2sVuK");
var $9c5d933b7322b6be$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $9c5d933b7322b6be$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $9c5d933b7322b6be$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $9c5d933b7322b6be$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $9c5d933b7322b6be$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $9c5d933b7322b6be$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $9c5d933b7322b6be$export$7d6e4e6663186878 = (tr)=>{
    if ($9c5d933b7322b6be$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $9c5d933b7322b6be$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $9c5d933b7322b6be$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($9c5d933b7322b6be$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $2sVuK.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $2sVuK.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $9c5d933b7322b6be$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $j3TCs.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $9c5d933b7322b6be$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $j3TCs.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $9c5d933b7322b6be$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $2sVuK.Node) && node.type && node.type.spec.selectable);
var $9c5d933b7322b6be$var$shouldSelectNode = (node)=>$9c5d933b7322b6be$var$isSelectableNode(node) && node.type.isLeaf;
var $9c5d933b7322b6be$var$setSelection = (node, pos, tr)=>{
    if ($9c5d933b7322b6be$var$shouldSelectNode(node)) return tr.setSelection(new (0, $j3TCs.NodeSelection)(tr.doc.resolve(pos)));
    return $9c5d933b7322b6be$export$1df6d14df6b0b758(pos)(tr);
};
var $9c5d933b7322b6be$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $9c5d933b7322b6be$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($9c5d933b7322b6be$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $9c5d933b7322b6be$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($9c5d933b7322b6be$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $9c5d933b7322b6be$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $9c5d933b7322b6be$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $9c5d933b7322b6be$var$setSelection(content, pos, tr);
            }
        }
        if ($9c5d933b7322b6be$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $9c5d933b7322b6be$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $9c5d933b7322b6be$var$cloneTr($9c5d933b7322b6be$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($9c5d933b7322b6be$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $9c5d933b7322b6be$var$cloneTr($9c5d933b7322b6be$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $9c5d933b7322b6be$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $9c5d933b7322b6be$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $9c5d933b7322b6be$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $9c5d933b7322b6be$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$9c5d933b7322b6be$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $9c5d933b7322b6be$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $9c5d933b7322b6be$var$cloneTr(tr.setSelection((0, $j3TCs.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $9c5d933b7322b6be$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $9c5d933b7322b6be$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $9c5d933b7322b6be$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $9c5d933b7322b6be$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $j3TCs.NodeSelection);
};
var $9c5d933b7322b6be$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $9c5d933b7322b6be$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $9c5d933b7322b6be$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($9c5d933b7322b6be$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $9c5d933b7322b6be$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $9c5d933b7322b6be$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $9c5d933b7322b6be$var$cloneTr(tr);
        }
        return tr;
    };
var $9c5d933b7322b6be$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $2sVuK.Fragment) ? content : (0, $2sVuK.Fragment).from(content));
};
var $9c5d933b7322b6be$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $9c5d933b7322b6be$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $9c5d933b7322b6be$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $2sVuK.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $2sVuK.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $9c5d933b7322b6be$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $9c5d933b7322b6be$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $9c5d933b7322b6be$export$fe09644e3bc6166b($from, predicate);
    };
var $9c5d933b7322b6be$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $9c5d933b7322b6be$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $9c5d933b7322b6be$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $9c5d933b7322b6be$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $9c5d933b7322b6be$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$9c5d933b7322b6be$export$dc159056ffdb4c76(predicate)(selection);
    };
var $9c5d933b7322b6be$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $9c5d933b7322b6be$export$dc159056ffdb4c76((node)=>$9c5d933b7322b6be$var$equalNodeType(nodeType, node))(selection);
    };
var $9c5d933b7322b6be$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $9c5d933b7322b6be$export$fe09644e3bc6166b($pos, (node)=>$9c5d933b7322b6be$var$equalNodeType(nodeType, node));
};
var $9c5d933b7322b6be$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $9c5d933b7322b6be$export$178ecaf80f45fdb6((node)=>$9c5d933b7322b6be$var$equalNodeType(nodeType, node))(selection);
    };
var $9c5d933b7322b6be$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $9c5d933b7322b6be$export$8556d79fa8189214((node)=>$9c5d933b7322b6be$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $9c5d933b7322b6be$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($9c5d933b7322b6be$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($9c5d933b7322b6be$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $9c5d933b7322b6be$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $j3TCs.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $9c5d933b7322b6be$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $9c5d933b7322b6be$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $9c5d933b7322b6be$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $9c5d933b7322b6be$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $9c5d933b7322b6be$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $9c5d933b7322b6be$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $9c5d933b7322b6be$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $9c5d933b7322b6be$export$ddc1620722e25671 = (node, descend = true)=>{
    return $9c5d933b7322b6be$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $9c5d933b7322b6be$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $9c5d933b7322b6be$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $9c5d933b7322b6be$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $9c5d933b7322b6be$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $9c5d933b7322b6be$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $9c5d933b7322b6be$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $9c5d933b7322b6be$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $9c5d933b7322b6be$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $9c5d933b7322b6be$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$9c5d933b7322b6be$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("60eNJ", function(module, exports) {
$parcel$export(module.exports, "CellSelection", () => $3c332a6f1f87cebe$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $2sVuK = parcelRequire("2sVuK");

var $j3TCs = parcelRequire("j3TCs");

var $4Oo1Y = parcelRequire("4Oo1Y");

var $idKHi = parcelRequire("idKHi");

var $2qtvG = parcelRequire("2qtvG");

var $Uyzfg = parcelRequire("Uyzfg");

var $iBNAw = parcelRequire("iBNAw");

var $j4ZHE = parcelRequire("j4ZHE");
class $3c332a6f1f87cebe$export$831cc7e2a83afa94 extends (0, $j3TCs.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $iBNAw.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $2qtvG.pointsAtCell)($anchorCell) && (0, $2qtvG.pointsAtCell)($headCell) && (0, $j4ZHE.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $3c332a6f1f87cebe$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $3c332a6f1f87cebe$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $3c332a6f1f87cebe$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $j3TCs.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $idKHi.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $Uyzfg.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $Uyzfg.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            const rowNode = table.child(row).copy((0, $2sVuK.Fragment).from(rowContent));
            rows.push(rowNode);
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $2sVuK.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $2sVuK.Slice).empty : content);
        }
        const sel = (0, $j3TCs.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $2sVuK.Slice)((0, $2sVuK.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $idKHi.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $idKHi.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $3c332a6f1f87cebe$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $idKHi.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $3c332a6f1f87cebe$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell, reverse = false) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $idKHi.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return reverse ? new $3c332a6f1f87cebe$export$831cc7e2a83afa94($calculatedHeadCell, $calculatedAnchorCell) : new $3c332a6f1f87cebe$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $3c332a6f1f87cebe$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $3c332a6f1f87cebe$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $4Oo1Y.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $j3TCs.Selection).jsonID('cell', $3c332a6f1f87cebe$export$831cc7e2a83afa94);

});
parcelRegister("4Oo1Y", function(module, exports) {
$parcel$export(module.exports, "CellBookmark", () => $0d9844513165f05f$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $j3TCs = parcelRequire("j3TCs");

var $j4ZHE = parcelRequire("j4ZHE");
class $0d9844513165f05f$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $0d9844513165f05f$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $j4ZHE.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $j3TCs.Selection).fromJSON(doc, data);
        }
        return (0, $j3TCs.Selection).near($headCell, 1);
    }
}

});
parcelRegister("j4ZHE", function(module, exports) {
$parcel$export(module.exports, "isInTable", () => $2bf13b5bcde11090$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $2bf13b5bcde11090$export$debd62b44eb7e281);
function $2bf13b5bcde11090$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $2bf13b5bcde11090$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("idKHi", function(module, exports) {
$parcel$export(module.exports, "Rect", () => $2f3409db7a9678a5$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $2f3409db7a9678a5$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $2f3409db7a9678a5$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $2f3409db7a9678a5$var$readFromCache, $2f3409db7a9678a5$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $2f3409db7a9678a5$var$readFromCache = (key)=>cache.get(key);
    $2f3409db7a9678a5$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $2f3409db7a9678a5$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $2f3409db7a9678a5$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $2f3409db7a9678a5$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $2f3409db7a9678a5$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $2f3409db7a9678a5$export$c60fae4049791eae = 140;
class $2f3409db7a9678a5$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $2f3409db7a9678a5$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $2f3409db7a9678a5$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $2f3409db7a9678a5$var$readFromCache(table) || $2f3409db7a9678a5$var$addToCache(table, $2f3409db7a9678a5$var$computeMap(table));
    }
}
// Compute a table map.
function $2f3409db7a9678a5$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $2f3409db7a9678a5$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $2f3409db7a9678a5$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($2f3409db7a9678a5$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $2f3409db7a9678a5$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $2f3409db7a9678a5$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $2f3409db7a9678a5$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $2f3409db7a9678a5$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2f3409db7a9678a5$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("2qtvG", function(module, exports) {
$parcel$export(module.exports, "pointsAtCell", () => $4e6ad16d0404d9af$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $4e6ad16d0404d9af$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $4e6ad16d0404d9af$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $4e6ad16d0404d9af$export$172699367bb25225);
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $idKHi = parcelRequire("idKHi");
function $4e6ad16d0404d9af$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $4e6ad16d0404d9af$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $4e6ad16d0404d9af$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $4e6ad16d0404d9af$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $idKHi.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("Uyzfg", function(module, exports) {
$parcel$export(module.exports, "removeColSpan", () => $f883fdba31721cc5$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $f883fdba31721cc5$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $f883fdba31721cc5$export$147ee78a1321ac36);
function $f883fdba31721cc5$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $f883fdba31721cc5$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $f883fdba31721cc5$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $f883fdba31721cc5$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("iBNAw", function(module, exports) {
$parcel$export(module.exports, "getCellSelectionRanges", () => $9f3a8ca0ceb3ed1e$export$a60a444208fd5099);

var $j3TCs = parcelRequire("j3TCs");

var $idKHi = parcelRequire("idKHi");
function $9f3a8ca0ceb3ed1e$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $idKHi.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $j3TCs.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("bzXkQ", function(module, exports) {
$parcel$export(module.exports, "shouldForceTracking", () => $5394034292671f76$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $5394034292671f76$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("lUTku", function(module, exports) {
$parcel$export(module.exports, "normalizeFeatureFlags", () => $80bb4d0b471faba8$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $80bb4d0b471faba8$export$6d018dd0f6cbebcb);

var $49RFO = parcelRequire("49RFO");

var $ajZcx = parcelRequire("ajZcx");
const $80bb4d0b471faba8$var$EMPTY = {};
function $80bb4d0b471faba8$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && (objectFlagKeys === null || objectFlagKeys === void 0 ? void 0 : objectFlagKeys.includes(key)));
}
function $80bb4d0b471faba8$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $80bb4d0b471faba8$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $80bb4d0b471faba8$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($80bb4d0b471faba8$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($49RFO)))(e[0]), e[1], options === null || options === void 0 ? void 0 : options.objectFlagKeys) && $80bb4d0b471faba8$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($ajZcx)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($49RFO)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($80bb4d0b471faba8$var$isObjectFlagKey(key, value, options === null || options === void 0 ? void 0 : options.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $80bb4d0b471faba8$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});
parcelRegister("49RFO", function(module, exports) {

var $3zE5H = parcelRequire("3zE5H");

var $cM2yV = parcelRequire("cM2yV");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $3071a316e418fd90$var$camelCase = $cM2yV(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $3zE5H(word) : word);
});
module.exports = $3071a316e418fd90$var$camelCase;

});
parcelRegister("3zE5H", function(module, exports) {

var $bDVqc = parcelRequire("bDVqc");

var $gcF9Q = parcelRequire("gcF9Q");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $29a3bd2e08a98046$var$capitalize(string) {
    return $gcF9Q($bDVqc(string).toLowerCase());
}
module.exports = $29a3bd2e08a98046$var$capitalize;

});
parcelRegister("gcF9Q", function(module, exports) {

var $gE7wf = parcelRequire("gE7wf");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $bcbdb16614b7c943$var$upperFirst = $gE7wf('toUpperCase');
module.exports = $bcbdb16614b7c943$var$upperFirst;

});
parcelRegister("gE7wf", function(module, exports) {

var $6XYjg = parcelRequire("6XYjg");

var $ho02T = parcelRequire("ho02T");

var $Gt7CI = parcelRequire("Gt7CI");

var $bDVqc = parcelRequire("bDVqc");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $c1e636ec2d154704$var$createCaseFirst(methodName) {
    return function(string) {
        string = $bDVqc(string);
        var strSymbols = $ho02T(string) ? $Gt7CI(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $6XYjg(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $c1e636ec2d154704$var$createCaseFirst;

});
parcelRegister("6XYjg", function(module, exports) {

var $jydVe = parcelRequire("jydVe");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $5127090af1f12a3a$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $jydVe(array, start, end);
}
module.exports = $5127090af1f12a3a$var$castSlice;

});

parcelRegister("ho02T", function(module, exports) {
/** Used to compose unicode character classes. */ var $ca84b69c91ad8663$var$rsAstralRange = '\\ud800-\\udfff', $ca84b69c91ad8663$var$rsComboMarksRange = '\\u0300-\\u036f', $ca84b69c91ad8663$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ca84b69c91ad8663$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ca84b69c91ad8663$var$rsComboRange = $ca84b69c91ad8663$var$rsComboMarksRange + $ca84b69c91ad8663$var$reComboHalfMarksRange + $ca84b69c91ad8663$var$rsComboSymbolsRange, $ca84b69c91ad8663$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $ca84b69c91ad8663$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $ca84b69c91ad8663$var$reHasUnicode = RegExp('[' + $ca84b69c91ad8663$var$rsZWJ + $ca84b69c91ad8663$var$rsAstralRange + $ca84b69c91ad8663$var$rsComboRange + $ca84b69c91ad8663$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $ca84b69c91ad8663$var$hasUnicode(string) {
    return $ca84b69c91ad8663$var$reHasUnicode.test(string);
}
module.exports = $ca84b69c91ad8663$var$hasUnicode;

});

parcelRegister("Gt7CI", function(module, exports) {

var $e1ANJ = parcelRequire("e1ANJ");

var $ho02T = parcelRequire("ho02T");

var $jt0mj = parcelRequire("jt0mj");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $07fa835f6cb38d31$var$stringToArray(string) {
    return $ho02T(string) ? $jt0mj(string) : $e1ANJ(string);
}
module.exports = $07fa835f6cb38d31$var$stringToArray;

});
parcelRegister("e1ANJ", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a35db49a1e9dd84c$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $a35db49a1e9dd84c$var$asciiToArray;

});

parcelRegister("jt0mj", function(module, exports) {
/** Used to compose unicode character classes. */ var $e2c10104a9594f33$var$rsAstralRange = '\\ud800-\\udfff', $e2c10104a9594f33$var$rsComboMarksRange = '\\u0300-\\u036f', $e2c10104a9594f33$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $e2c10104a9594f33$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $e2c10104a9594f33$var$rsComboRange = $e2c10104a9594f33$var$rsComboMarksRange + $e2c10104a9594f33$var$reComboHalfMarksRange + $e2c10104a9594f33$var$rsComboSymbolsRange, $e2c10104a9594f33$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $e2c10104a9594f33$var$rsAstral = '[' + $e2c10104a9594f33$var$rsAstralRange + ']', $e2c10104a9594f33$var$rsCombo = '[' + $e2c10104a9594f33$var$rsComboRange + ']', $e2c10104a9594f33$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $e2c10104a9594f33$var$rsModifier = '(?:' + $e2c10104a9594f33$var$rsCombo + '|' + $e2c10104a9594f33$var$rsFitz + ')', $e2c10104a9594f33$var$rsNonAstral = '[^' + $e2c10104a9594f33$var$rsAstralRange + ']', $e2c10104a9594f33$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $e2c10104a9594f33$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $e2c10104a9594f33$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $e2c10104a9594f33$var$reOptMod = $e2c10104a9594f33$var$rsModifier + '?', $e2c10104a9594f33$var$rsOptVar = '[' + $e2c10104a9594f33$var$rsVarRange + ']?', $e2c10104a9594f33$var$rsOptJoin = '(?:' + $e2c10104a9594f33$var$rsZWJ + '(?:' + [
    $e2c10104a9594f33$var$rsNonAstral,
    $e2c10104a9594f33$var$rsRegional,
    $e2c10104a9594f33$var$rsSurrPair
].join('|') + ')' + $e2c10104a9594f33$var$rsOptVar + $e2c10104a9594f33$var$reOptMod + ')*', $e2c10104a9594f33$var$rsSeq = $e2c10104a9594f33$var$rsOptVar + $e2c10104a9594f33$var$reOptMod + $e2c10104a9594f33$var$rsOptJoin, $e2c10104a9594f33$var$rsSymbol = '(?:' + [
    $e2c10104a9594f33$var$rsNonAstral + $e2c10104a9594f33$var$rsCombo + '?',
    $e2c10104a9594f33$var$rsCombo,
    $e2c10104a9594f33$var$rsRegional,
    $e2c10104a9594f33$var$rsSurrPair,
    $e2c10104a9594f33$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $e2c10104a9594f33$var$reUnicode = RegExp($e2c10104a9594f33$var$rsFitz + '(?=' + $e2c10104a9594f33$var$rsFitz + ')|' + $e2c10104a9594f33$var$rsSymbol + $e2c10104a9594f33$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $e2c10104a9594f33$var$unicodeToArray(string) {
    return string.match($e2c10104a9594f33$var$reUnicode) || [];
}
module.exports = $e2c10104a9594f33$var$unicodeToArray;

});





parcelRegister("cM2yV", function(module, exports) {

var $3gxkN = parcelRequire("3gxkN");

var $4CaI0 = parcelRequire("4CaI0");

var $3oTPN = parcelRequire("3oTPN");
/** Used to compose unicode capture groups. */ var $94cbf48ac84f1139$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $94cbf48ac84f1139$var$reApos = RegExp($94cbf48ac84f1139$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $94cbf48ac84f1139$var$createCompounder(callback) {
    return function(string) {
        return $3gxkN($3oTPN($4CaI0(string).replace($94cbf48ac84f1139$var$reApos, '')), callback, '');
    };
}
module.exports = $94cbf48ac84f1139$var$createCompounder;

});
parcelRegister("3gxkN", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $260cb93cacfd3055$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $260cb93cacfd3055$var$arrayReduce;

});

parcelRegister("4CaI0", function(module, exports) {

var $3DtAh = parcelRequire("3DtAh");

var $bDVqc = parcelRequire("bDVqc");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $35c3048c3dcfe16a$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $35c3048c3dcfe16a$var$rsComboMarksRange = '\\u0300-\\u036f', $35c3048c3dcfe16a$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $35c3048c3dcfe16a$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $35c3048c3dcfe16a$var$rsComboRange = $35c3048c3dcfe16a$var$rsComboMarksRange + $35c3048c3dcfe16a$var$reComboHalfMarksRange + $35c3048c3dcfe16a$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $35c3048c3dcfe16a$var$rsCombo = '[' + $35c3048c3dcfe16a$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $35c3048c3dcfe16a$var$reComboMark = RegExp($35c3048c3dcfe16a$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $35c3048c3dcfe16a$var$deburr(string) {
    string = $bDVqc(string);
    return string && string.replace($35c3048c3dcfe16a$var$reLatin, $3DtAh).replace($35c3048c3dcfe16a$var$reComboMark, '');
}
module.exports = $35c3048c3dcfe16a$var$deburr;

});
parcelRegister("3DtAh", function(module, exports) {

var $eiGm0 = parcelRequire("eiGm0");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $2a5bf668f188bcfa$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $2a5bf668f188bcfa$var$deburrLetter = $eiGm0($2a5bf668f188bcfa$var$deburredLetters);
module.exports = $2a5bf668f188bcfa$var$deburrLetter;

});
parcelRegister("eiGm0", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $a69399b8452076ea$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $a69399b8452076ea$var$basePropertyOf;

});



parcelRegister("3oTPN", function(module, exports) {

var $JMbG1 = parcelRequire("JMbG1");

var $9hSJU = parcelRequire("9hSJU");

var $bDVqc = parcelRequire("bDVqc");

var $9Pr6x = parcelRequire("9Pr6x");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $279eec8a7d032dbc$var$words(string, pattern, guard) {
    string = $bDVqc(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $9hSJU(string) ? $9Pr6x(string) : $JMbG1(string);
    return string.match(pattern) || [];
}
module.exports = $279eec8a7d032dbc$var$words;

});
parcelRegister("JMbG1", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $08999515af1ee20f$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $08999515af1ee20f$var$asciiWords(string) {
    return string.match($08999515af1ee20f$var$reAsciiWord) || [];
}
module.exports = $08999515af1ee20f$var$asciiWords;

});

parcelRegister("9hSJU", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $6c3029af4ba69dd7$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $6c3029af4ba69dd7$var$hasUnicodeWord(string) {
    return $6c3029af4ba69dd7$var$reHasUnicodeWord.test(string);
}
module.exports = $6c3029af4ba69dd7$var$hasUnicodeWord;

});

parcelRegister("9Pr6x", function(module, exports) {
/** Used to compose unicode character classes. */ var $01d8bd8798e82680$var$rsAstralRange = '\\ud800-\\udfff', $01d8bd8798e82680$var$rsComboMarksRange = '\\u0300-\\u036f', $01d8bd8798e82680$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $01d8bd8798e82680$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $01d8bd8798e82680$var$rsComboRange = $01d8bd8798e82680$var$rsComboMarksRange + $01d8bd8798e82680$var$reComboHalfMarksRange + $01d8bd8798e82680$var$rsComboSymbolsRange, $01d8bd8798e82680$var$rsDingbatRange = '\\u2700-\\u27bf', $01d8bd8798e82680$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $01d8bd8798e82680$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $01d8bd8798e82680$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $01d8bd8798e82680$var$rsPunctuationRange = '\\u2000-\\u206f', $01d8bd8798e82680$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $01d8bd8798e82680$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $01d8bd8798e82680$var$rsVarRange = '\\ufe0e\\ufe0f', $01d8bd8798e82680$var$rsBreakRange = $01d8bd8798e82680$var$rsMathOpRange + $01d8bd8798e82680$var$rsNonCharRange + $01d8bd8798e82680$var$rsPunctuationRange + $01d8bd8798e82680$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $01d8bd8798e82680$var$rsApos = "['\u2019]", $01d8bd8798e82680$var$rsBreak = '[' + $01d8bd8798e82680$var$rsBreakRange + ']', $01d8bd8798e82680$var$rsCombo = '[' + $01d8bd8798e82680$var$rsComboRange + ']', $01d8bd8798e82680$var$rsDigits = '\\d+', $01d8bd8798e82680$var$rsDingbat = '[' + $01d8bd8798e82680$var$rsDingbatRange + ']', $01d8bd8798e82680$var$rsLower = '[' + $01d8bd8798e82680$var$rsLowerRange + ']', $01d8bd8798e82680$var$rsMisc = '[^' + $01d8bd8798e82680$var$rsAstralRange + $01d8bd8798e82680$var$rsBreakRange + $01d8bd8798e82680$var$rsDigits + $01d8bd8798e82680$var$rsDingbatRange + $01d8bd8798e82680$var$rsLowerRange + $01d8bd8798e82680$var$rsUpperRange + ']', $01d8bd8798e82680$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $01d8bd8798e82680$var$rsModifier = '(?:' + $01d8bd8798e82680$var$rsCombo + '|' + $01d8bd8798e82680$var$rsFitz + ')', $01d8bd8798e82680$var$rsNonAstral = '[^' + $01d8bd8798e82680$var$rsAstralRange + ']', $01d8bd8798e82680$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $01d8bd8798e82680$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $01d8bd8798e82680$var$rsUpper = '[' + $01d8bd8798e82680$var$rsUpperRange + ']', $01d8bd8798e82680$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $01d8bd8798e82680$var$rsMiscLower = '(?:' + $01d8bd8798e82680$var$rsLower + '|' + $01d8bd8798e82680$var$rsMisc + ')', $01d8bd8798e82680$var$rsMiscUpper = '(?:' + $01d8bd8798e82680$var$rsUpper + '|' + $01d8bd8798e82680$var$rsMisc + ')', $01d8bd8798e82680$var$rsOptContrLower = '(?:' + $01d8bd8798e82680$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $01d8bd8798e82680$var$rsOptContrUpper = '(?:' + $01d8bd8798e82680$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $01d8bd8798e82680$var$reOptMod = $01d8bd8798e82680$var$rsModifier + '?', $01d8bd8798e82680$var$rsOptVar = '[' + $01d8bd8798e82680$var$rsVarRange + ']?', $01d8bd8798e82680$var$rsOptJoin = '(?:' + $01d8bd8798e82680$var$rsZWJ + '(?:' + [
    $01d8bd8798e82680$var$rsNonAstral,
    $01d8bd8798e82680$var$rsRegional,
    $01d8bd8798e82680$var$rsSurrPair
].join('|') + ')' + $01d8bd8798e82680$var$rsOptVar + $01d8bd8798e82680$var$reOptMod + ')*', $01d8bd8798e82680$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $01d8bd8798e82680$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $01d8bd8798e82680$var$rsSeq = $01d8bd8798e82680$var$rsOptVar + $01d8bd8798e82680$var$reOptMod + $01d8bd8798e82680$var$rsOptJoin, $01d8bd8798e82680$var$rsEmoji = '(?:' + [
    $01d8bd8798e82680$var$rsDingbat,
    $01d8bd8798e82680$var$rsRegional,
    $01d8bd8798e82680$var$rsSurrPair
].join('|') + ')' + $01d8bd8798e82680$var$rsSeq;
/** Used to match complex or compound words. */ var $01d8bd8798e82680$var$reUnicodeWord = RegExp([
    $01d8bd8798e82680$var$rsUpper + '?' + $01d8bd8798e82680$var$rsLower + '+' + $01d8bd8798e82680$var$rsOptContrLower + '(?=' + [
        $01d8bd8798e82680$var$rsBreak,
        $01d8bd8798e82680$var$rsUpper,
        '$'
    ].join('|') + ')',
    $01d8bd8798e82680$var$rsMiscUpper + '+' + $01d8bd8798e82680$var$rsOptContrUpper + '(?=' + [
        $01d8bd8798e82680$var$rsBreak,
        $01d8bd8798e82680$var$rsUpper + $01d8bd8798e82680$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $01d8bd8798e82680$var$rsUpper + '?' + $01d8bd8798e82680$var$rsMiscLower + '+' + $01d8bd8798e82680$var$rsOptContrLower,
    $01d8bd8798e82680$var$rsUpper + '+' + $01d8bd8798e82680$var$rsOptContrUpper,
    $01d8bd8798e82680$var$rsOrdUpper,
    $01d8bd8798e82680$var$rsOrdLower,
    $01d8bd8798e82680$var$rsDigits,
    $01d8bd8798e82680$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $01d8bd8798e82680$var$unicodeWords(string) {
    return string.match($01d8bd8798e82680$var$reUnicodeWord) || [];
}
module.exports = $01d8bd8798e82680$var$unicodeWords;

});




parcelRegister("ajZcx", function(module, exports) {

var $cM2yV = parcelRequire("cM2yV");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $783b270b2be807fd$var$kebabCase = $cM2yV(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $783b270b2be807fd$var$kebabCase;

});


parcelRegister("3gJSl", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2b4af69eea92be5$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $2sVuK = parcelRequire("2sVuK");

var $13svG = parcelRequire("13svG");

var $h2boN = parcelRequire("h2boN");
parcelRequire("9ip9v");
var $fBnrJ = parcelRequire("fBnrJ");
var $9ip9v = parcelRequire("9ip9v");

var $ayHMh = parcelRequire("ayHMh");

var $jBVmK = parcelRequire("jBVmK");

var $XIIuu = parcelRequire("XIIuu");

var $akJ5e = parcelRequire("akJ5e");

var $dqksE = parcelRequire("dqksE");

var $e6Qdr = parcelRequire("e6Qdr");

var $j88lh = parcelRequire("j88lh");

var $7VjJx = parcelRequire("7VjJx");
var $fDO3u = parcelRequire("fDO3u");

var $lMc1U = parcelRequire("lMc1U");

var $2H278 = parcelRequire("2H278");

var $l6I12 = parcelRequire("l6I12");

var $aWfaT = parcelRequire("aWfaT");

var $SmqKH = parcelRequire("SmqKH");

var $6vTsK = parcelRequire("6vTsK");
function $c2b4af69eea92be5$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $2sVuK.MarkType) && prev && prev.type instanceof (0, $2sVuK.MarkType) && Array.isArray(prev.content) && (0, $akJ5e.isSameMark)(prev, markOrNode)) prev.content = $c2b4af69eea92be5$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $c2b4af69eea92be5$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
   * The reason we have this extra array here is because we need to generate the same unique
   * heading id for 2 different nodes: headers and expands (check the implementation of
   * `getUniqueHeadingId` for more info).
   *
   * We will eventually need to refactor the current approach to generate unique ids
   * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
   */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.standaloneBackgroundColorMarks = [];
        this.inlinePositions = new Set();
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem' && (0, $13svG.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.parentIsIncompleteTask) === true && (0, $13svG.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true);
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $9ip9v.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>{
                    var _n$type;
                    return ((_n$type = n.type) === null || _n$type === void 0 ? void 0 : _n$type.name) !== 'mediaSingle';
                }) && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $fDO3u.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $7VjJx.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $7VjJx.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node === null || node === void 0 ? void 0 : node.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $lMc1U.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            // Add deepLinkTarget for link marks
            const linkSpecificProps = mark.type.name === 'link' ? {
                onSetLinkTarget: this.onSetLinkTarget
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                ...linkSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $h2boN.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.allowFixedColumnWidthOption = init.allowFixedColumnWidthOption;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
        this.onSetLinkTarget = init.onSetLinkTarget;
        this.shouldDisplayExtensionAsInline = init.shouldDisplayExtensionAsInline;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node, path);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'inlineCard':
                return this.getInlineCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'nestedExpand':
                if ((0, $e6Qdr.fg)('hot-121622_lazy_load_expand_content')) return this.getExpandProps(node, path);
                return this.getProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $fBnrJ.DocWithSelectAllTrap) : (0, $fBnrJ.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, this.getChildNodes(fragment).map((node, index)=>{
            if ((0, $9ip9v.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        this.standaloneBackgroundColorMarks.push(...(0, $SmqKH.getStandaloneBackgroundColorMarks)(content));
        return $c2b4af69eea92be5$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, _index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $9ip9v.isTextNode)(mark)) {
            const serializeContent = (childMark, _index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            const isStandalone = this.standaloneBackgroundColorMarks.some((m)=>mark.eq(m));
            return this.renderMark((0, $fDO3u.toReact)(mark), {
                ...this.getMarkProps(mark, parentMark.path),
                isStandalone: isStandalone
            }, markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ayHMh.default), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                children: mark.text
            }, textKey);
        }
        const segments = (0, $aWfaT.segmentText)(mark.text, this.textHighlighter);
        return (0, $l6I12.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gWgPx.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gWgPx.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $2H278.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $2H278.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $2H278.insideTable)(path, node.type.schema);
        const isStickySafeCenteringEnabled = (0, $13svG.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const isInsideBreakoutExpand = !isStickySafeCenteringEnabled && (0, $13svG.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $13svG.expValEquals)('platform_editor_table_sticky_header_patch_11', 'isEnabled', true) && (0, $2H278.insideBreakoutExpand)(path);
        const stickyHeaders = isStickySafeCenteringEnabled ? !isInsideOfTable ? this.stickyHeaders : undefined : !isInsideOfTable && !(0, $2H278.insideBreakoutLayout)(path) && !isInsideBreakoutExpand ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $XIIuu.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            // eslint-disable-next-line @atlaskit/platform/valid-gate-name
            isPresentational: (0, $e6Qdr.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow,
            allowFixedColumnWidthOption: this.allowFixedColumnWidthOption
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $2H278.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        var _this$media, _this$media2, _this$media3;
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>{
            var _n$type2;
            return ((_n$type2 = n.type) === null || _n$type2 === void 0 ? void 0 : _n$type2.name) === 'mediaSingle';
        });
        // Only check path for bodiedSyncBlock; syncBlock uses RendererContext
        const nestedUnder = (0, $h2boN.editorExperiment)('platform_synced_block', true) ? (0, $2H278.getNestedUnderNodes)(path, [
            'bodiedSyncBlock'
        ]) : undefined;
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: (_this$media = this.media) === null || _this$media === void 0 ? void 0 : _this$media.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            enableSyncMediaCard: (_this$media2 = this.media) === null || _this$media2 === void 0 ? void 0 : _this$media2.enableSyncMediaCard,
            mediaViewerExtensions: (_this$media3 = this.media) === null || _this$media3 === void 0 ? void 0 : _this$media3.mediaViewerExtensions,
            nestedUnder: nestedUnder
        };
    }
    getExtensionProps(node, path = []) {
        var _this$getExtensionHei;
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes,
            nodeHeight: (_this$getExtensionHei = this.getExtensionHeight) === null || _this$getExtensionHei === void 0 ? void 0 : _this$getExtensionHei.call(this, node),
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        };
    }
    getEmojiProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $2H278.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getInlineCardProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getMediaGroupProps(node) {
        var _this$media4, _this$media5;
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: (_this$media4 = this.media) === null || _this$media4 === void 0 ? void 0 : _this$media4.enableDownloadButton,
            ssr: (_this$media5 = this.media) === null || _this$media5 === void 0 ? void 0 : _this$media5.ssr
        };
    }
    getMediaInlineProps(node) {
        var _this$media6, _this$media7;
        return {
            ...this.getProps(node),
            ssr: (_this$media6 = this.media) === null || _this$media6 === void 0 ? void 0 : _this$media6.ssr,
            fallbackMediaNameFetcher: (_this$media7 = this.media) === null || _this$media7 === void 0 ? void 0 : _this$media7.fallbackMediaNameFetcher
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            rendererContentMode: this.contentMode,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $jBVmK.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, _path = []) {
        let loadBodyContent = false;
        if ((0, $e6Qdr.fg)('hot-121622_lazy_load_expand_content')) {
            const annotations = (0, $dqksE.findChildrenByMark)(node, node.type.schema.marks.annotation, true);
            // Force rendering children if there are inline comments to support comments navigation
            // which relies on the HTML node to be present.
            loadBodyContent = annotations.some((annotation)=>{
                return annotation.node.marks.some((mark)=>mark.attrs.annotationType === 'inlineComment');
            });
        }
        if (!(0, $jBVmK.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return {
            ...this.getProps(node),
            loadBodyContent: loadBodyContent
        };
        const nestedHeaderIds = (0, $dqksE.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds,
            loadBodyContent: loadBodyContent
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $j88lh.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    getChildNodes(fragment) {
        let children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        children = (0, $9ip9v.mergeTextNodes)(children);
        if (!!this.shouldDisplayExtensionAsInline && (0, $13svG.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true)) (0, $6vTsK.markBlockAsInline)({
            nodes: children,
            onMark: ({ pos: pos })=>{
                this.inlinePositions.add(pos);
            },
            parentPos: this.startPos,
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        });
        return children;
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $akJ5e.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $c2b4af69eea92be5$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
}

});
parcelRegister("9ip9v", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $55c9c964c31aab47$export$aff6291803939b05);
$parcel$export(module.exports, "toReact", () => $55c9c964c31aab47$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $55c9c964c31aab47$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $55c9c964c31aab47$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $55c9c964c31aab47$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("fBnrJ")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("fBnrJ")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $fuRVo = parcelRequire("fuRVo");

var $1I7g7 = parcelRequire("1I7g7");
var $icwVO = parcelRequire("icwVO");

var $e6Qdr = parcelRequire("e6Qdr");

var $8yO2L = parcelRequire("8yO2L");

var $60exD = parcelRequire("60exD");

var $jS7iR = parcelRequire("jS7iR");

var $76Erk = parcelRequire("76Erk");

var $kG7qV = parcelRequire("kG7qV");

var $fBnrJ = parcelRequire("fBnrJ");

var $hkN2b = parcelRequire("hkN2b");

var $PI7zm = parcelRequire("PI7zm");

var $cYAI0 = parcelRequire("cYAI0");

var $fLfF1 = parcelRequire("fLfF1");

var $3T25d = parcelRequire("3T25d");

var $8ts7z = parcelRequire("8ts7z");

var $8XiNx = parcelRequire("8XiNx");

var $hCvjx = parcelRequire("hCvjx");

var $41PEx = parcelRequire("41PEx");

var $bh79x = parcelRequire("bh79x");

var $6BPbg = parcelRequire("6BPbg");

var $jE5xs = parcelRequire("jE5xs");

var $luM3o = parcelRequire("luM3o");

var $dpO05 = parcelRequire("dpO05");

var $1F13I = parcelRequire("1F13I");

var $6gwNR = parcelRequire("6gwNR");

const $55c9c964c31aab47$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("3uCLE")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("5BGa0")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("i8ssM")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("xLA5e")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("iEiTR")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("c4VN8")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("dq9UJ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("9Xi8r")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("9oJW3")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("2kpd9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("ivJWB")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("1spU4")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("6fax1")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("lUl3d")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("7Oev4")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("TTwgd")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("PoLVK")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("cEupN")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("izACV")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("iIpQ7")).then((mod)=>mod.default),
    loading: ()=>null
});

const $55c9c964c31aab47$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: ()=>(parcelRequire("2wyay")).then((mod)=>mod.default),
    loading: ()=>null
});
const $55c9c964c31aab47$export$3931063f6a5f290e = {
    blockquote: (0, $8yO2L.default),
    bulletList: (0, $kG7qV.default),
    blockCard: $55c9c964c31aab47$export$d18ccd25c0d2c6b0,
    caption: (0, $hCvjx.default),
    date: $55c9c964c31aab47$export$6341f9a885713487,
    decisionItem: $55c9c964c31aab47$export$b6f73a2b0b0de599,
    decisionList: $55c9c964c31aab47$export$b458dfa720128865,
    doc: (0, $fBnrJ.default),
    emoji: $55c9c964c31aab47$export$56cc48506ff790a,
    extension: (0, $hkN2b.default),
    bodiedExtension: (0, $60exD.default),
    multiBodiedExtension: (0, $jS7iR.default),
    extensionFrame: (0, $76Erk.default),
    hardBreak: (0, $PI7zm.default),
    heading: (0, $cYAI0.default),
    inlineCard: $55c9c964c31aab47$export$aff6291803939b05,
    inlineExtension: (0, $fLfF1.default),
    layoutSection: (0, $3T25d.default),
    layoutColumn: (0, $8ts7z.default),
    listItem: (0, $8XiNx.default),
    media: $55c9c964c31aab47$export$7fc53215244aec38,
    mediaGroup: $55c9c964c31aab47$export$d7858be3df00d59,
    mediaInline: $55c9c964c31aab47$export$462ea7c2a1c4cb1f,
    mediaSingle: $55c9c964c31aab47$export$888d74bc001c3a5d,
    mention: $55c9c964c31aab47$export$e891316fea657d90,
    orderedList: (0, $41PEx.default),
    panel: $55c9c964c31aab47$export$2ddb90ad54e5f587,
    paragraph: (0, $bh79x.default),
    placeholder: (0, $6BPbg.default),
    rule: (0, $jE5xs.default),
    status: $55c9c964c31aab47$export$96e9906d6d93a972,
    taskItem: $55c9c964c31aab47$export$27c4189b8be1bf93,
    taskList: $55c9c964c31aab47$export$771a55a10b0a40ae,
    table: (0, $luM3o.default),
    tableCell: (0, $dpO05.TableCell),
    tableHeader: (0, $dpO05.TableHeader),
    tableRow: (0, $1F13I.default),
    unknownBlock: (0, $6gwNR.default),
    unsupportedBlock: (0, $1I7g7.default),
    unsupportedInline: (0, $icwVO.default),
    expand: $55c9c964c31aab47$export$49bd1dfb0ad29c40,
    syncBlock: $55c9c964c31aab47$var$SyncBlockLoader,
    bodiedSyncBlock: $55c9c964c31aab47$var$BodiedSyncBlock,
    nestedExpand: $55c9c964c31aab47$export$49bd1dfb0ad29c40,
    embedCard: $55c9c964c31aab47$export$6789d7ecdc77631b,
    blockTaskItem: $55c9c964c31aab47$export$27c4189b8be1bf93
};
const $55c9c964c31aab47$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && (flags === null || flags === void 0 ? void 0 : flags.allowSelectAllTrap) === true) return 0, $fBnrJ.DocWithSelectAllTrap;
    if (!(0, $e6Qdr.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) return $55c9c964c31aab47$export$a22ee8f907eecb5f;
            return $55c9c964c31aab47$export$6c415d1fdae3dfdb;
        }
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$55c9c964c31aab47$export$3931063f6a5f290e,
        ...nodeComponents
    };
    if ((0, $e6Qdr.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) return nodes.windowedCodeBlock ?? $55c9c964c31aab47$export$a22ee8f907eecb5f;
            return nodes.codeBlock ?? $55c9c964c31aab47$export$6c415d1fdae3dfdb;
        }
    }
    nodes['multiBodiedExtension'] = (0, $jS7iR.default);
    return nodes[node.type.name];
};
const $55c9c964c31aab47$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$55c9c964c31aab47$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $55c9c964c31aab47$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $55c9c964c31aab47$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $55c9c964c31aab47$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $55c9c964c31aab47$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $55c9c964c31aab47$var$whitespaceRegex = /^\s*$/;
const $55c9c964c31aab47$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $55c9c964c31aab47$var$isEmojiBlock(node.content);
};
const $55c9c964c31aab47$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($55c9c964c31aab47$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("fuRVo", function(module, exports) {
'use strict';
var $b4837cb176534b0a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $b4837cb176534b0a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b4837cb176534b0a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b4837cb176534b0a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $8P7DW = parcelRequire("8P7DW");

var $93Fg7 = parcelRequire("93Fg7");
var $b4837cb176534b0a$var$ALL_INITIALIZERS = [];
var $b4837cb176534b0a$var$READY_INITIALIZERS = [];
function $b4837cb176534b0a$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === 'undefined' ? 'undefined' : $b4837cb176534b0a$var$_typeof(__webpack_modules__)) !== 'object') return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== 'undefined' && typeof __webpack_modules__[moduleId] !== 'undefined';
    });
}
function $b4837cb176534b0a$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $b4837cb176534b0a$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $b4837cb176534b0a$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $b4837cb176534b0a$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $b4837cb176534b0a$var$render(loaded, props) {
    return $8P7DW.createElement($b4837cb176534b0a$var$resolve(loaded), props);
}
function $b4837cb176534b0a$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error('react-loadable requires a `loading` component');
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $b4837cb176534b0a$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $b4837cb176534b0a$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === 'function') $b4837cb176534b0a$var$READY_INITIALIZERS.push(function() {
        if ($b4837cb176534b0a$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $b4837cb176534b0a$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $b4837cb176534b0a$var$_classCallCheck(this, LoadableComponent);
            var _this = $b4837cb176534b0a$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        // renamed from componentWillMount See https://fb.me/react-unsafe-component-lifecycles
        LoadableComponent.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
            var _this2 = this;
            this._mounted = true;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === 'number') this._delay = setTimeout(function() {
                _this2.setState({
                    pastDelay: true
                });
            }, opts.delay);
            if (typeof opts.timeout === 'number') this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
                throw err;
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $8P7DW.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($8P7DW.Component), _class.contextTypes = {
        loadable: $93Fg7.shape({
            report: $93Fg7.func.isRequired
        })
    }, _temp;
}
function $b4837cb176534b0a$var$Loadable(opts) {
    return $b4837cb176534b0a$var$createLoadableComponent($b4837cb176534b0a$var$load, opts);
}
function $b4837cb176534b0a$var$LoadableMap(opts) {
    if (typeof opts.render !== 'function') throw new Error('LoadableMap requires a `render(loaded, props)` function');
    return $b4837cb176534b0a$var$createLoadableComponent($b4837cb176534b0a$var$loadMap, opts);
}
$b4837cb176534b0a$var$Loadable.Map = $b4837cb176534b0a$var$LoadableMap;
var $b4837cb176534b0a$var$Capture = function(_React$Component2) {
    $b4837cb176534b0a$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $b4837cb176534b0a$var$_classCallCheck(this, Capture);
        return $b4837cb176534b0a$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $8P7DW.Children.only(this.props.children);
    };
    return Capture;
}($8P7DW.Component);
$b4837cb176534b0a$var$Capture.propTypes = {
    report: $93Fg7.func.isRequired
};
$b4837cb176534b0a$var$Capture.childContextTypes = {
    loadable: $93Fg7.shape({
        report: $93Fg7.func.isRequired
    }).isRequired
};
$b4837cb176534b0a$var$Loadable.Capture = $b4837cb176534b0a$var$Capture;
function $b4837cb176534b0a$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $b4837cb176534b0a$var$flushInitializers(initializers);
    });
}
$b4837cb176534b0a$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $b4837cb176534b0a$var$flushInitializers($b4837cb176534b0a$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$b4837cb176534b0a$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $b4837cb176534b0a$var$flushInitializers($b4837cb176534b0a$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $b4837cb176534b0a$var$Loadable;

});

parcelRegister("icwVO", function(module, exports) {
$parcel$export(module.exports, "default", () => $478bc168efa7eb3c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $3SD6z = parcelRequire("3SD6z");

var $e7vUY = parcelRequire("e7vUY");

var $faea6 = parcelRequire("faea6");

var $ea6bZ = parcelRequire("ea6bZ");

var $eguiP = parcelRequire("eguiP");

var $FbXg8 = parcelRequire("FbXg8");

var $fZ6KA = parcelRequire("fZ6KA");

var $ejxna = parcelRequire("ejxna");
const $478bc168efa7eb3c$var$inlineNodeStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #17171708)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $e7vUY.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $478bc168efa7eb3c$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $ejxna.getUnsupportedContent)((0, $FbXg8.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $FbXg8.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $8P7DW.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $8P7DW.useCallback)(()=>dispatchAnalyticsEvent && (0, $fZ6KA.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $eguiP.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        css: $478bc168efa7eb3c$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $ea6bZ.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($faea6))), {
        label: "?"
    }))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $478bc168efa7eb3c$var$_default_1 = (0, $3SD6z.default)($478bc168efa7eb3c$var$UnsupportedInlineNode);
var $478bc168efa7eb3c$export$2e2bcd8739ae039 = $478bc168efa7eb3c$var$_default_1;

});

parcelRegister("8yO2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $da4fb415bdab0ff1$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $da4fb415bdab0ff1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("blockquote", {
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("60exD", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbe2874264ac1ff6$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $hkN2b = parcelRequire("hkN2b");

var $jbPve = parcelRequire("jbPve");

var $51HbM = parcelRequire("51HbM");

var $3zRHk = parcelRequire("3zRHk");

var $eguiP = parcelRequire("eguiP");

var $2x5h2 = parcelRequire("2x5h2");

var $bZbgj = parcelRequire("bZbgj");
const $dbe2874264ac1ff6$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes, localId: localId, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const validationContextValue = (0, $8P7DW.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jbPve.ErrorBoundary), {
        component: (0, $3zRHk.ACTION_SUBJECT).RENDERER,
        componentId: (0, $eguiP.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2x5h2.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bZbgj.ValidationContextProvider), {
                value: validationContextValue,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $51HbM.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ node: node, result: result })=>{
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $hkN2b.renderExtension)(result, layout, {
                                isTopLevel: path.length < 1,
                                rendererAppearance: props.rendererAppearance
                            }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
                        } catch  {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $hkN2b.renderExtension)(children, layout, {
                            isTopLevel: path.length < 1,
                            rendererAppearance: props.rendererAppearance
                        }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
                    }
                })
            })
        })
    });
};
var $dbe2874264ac1ff6$export$2e2bcd8739ae039 = $dbe2874264ac1ff6$var$BodiedExtension;

});
parcelRegister("hkN2b", function(module, exports) {
$parcel$export(module.exports, "renderExtension", () => $0089d646d4252ec2$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $0089d646d4252ec2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $8P7DW = parcelRequire("8P7DW");

var $51HbM = parcelRequire("51HbM");

var $4TACV = parcelRequire("4TACV");
var $94YFM = parcelRequire("94YFM");

var $iN6Wt = parcelRequire("iN6Wt");

var $lnxsR = parcelRequire("lnxsR");

var $13svG = parcelRequire("13svG");

var $2b9UX = parcelRequire("2b9UX");

var $e6Qdr = parcelRequire("e6Qdr");
function $0089d646d4252ec2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0089d646d4252ec2$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $0089d646d4252ec2$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $0089d646d4252ec2$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $0089d646d4252ec2$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $0089d646d4252ec2$var$macroHeights[viewportSize];
    }
};
const $0089d646d4252ec2$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
const $0089d646d4252ec2$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes, nodeHeight, localId, shouldDisplayExtensionAsInline, node, isInsideOfInlineExtension)=>{
    const overflowContainerClass = !removeOverflow ? (0, $lnxsR.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true, rendererAppearance: rendererAppearance } = options || {};
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $lnxsR.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ const viewportSize = $0089d646d4252ec2$var$getViewportSize(extensionId, extensionViewportSizes);
    const extensionHeight = nodeHeight || viewportSize;
    const isInline = (shouldDisplayExtensionAsInline === null || shouldDisplayExtensionAsInline === void 0 ? void 0 : shouldDisplayExtensionAsInline(node)) && (0, $13svG.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true);
    const inlineClassName = isInline ? (0, $lnxsR.RendererCssClassName).EXTENSION_AS_INLINE : '';
    if ((0, $13svG.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const extensionDiv = /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $lnxsR.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                width: isInline ? undefined : ((0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $2b9UX.calcBreakoutWidthCss)(layout) : (0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : extensionHeight && `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-testid": "extension--wrapper",
            "data-node-type": "extension"
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $lnxsR.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !isInsideOfInlineExtension && (0, $e6Qdr.fg)('platform_fix_macro_renders_in_layouts') && $0089d646d4252ec2$var$containerStyle
            ]
        }, content));
        return centerAlignClass && (0, $13svG.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $lnxsR.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $lnxsR.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    }
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $94YFM.WidthConsumer), null, ({ width: width })=>{
        const extensionDiv = /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $lnxsR.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isInline ? undefined : ((0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $iN6Wt.calcBreakoutWidth)(layout, width) : (0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $lnxsR.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !isInsideOfInlineExtension && (0, $e6Qdr.fg)('platform_fix_macro_renders_in_layouts') && $0089d646d4252ec2$var$containerStyle
            ]
        }, content));
        return centerAlignClass && (0, $13svG.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $lnxsR.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $lnxsR.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    });
};
const $0089d646d4252ec2$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters, nodeHeight: nodeHeight, localId: localId, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $51HbM.default), {
        ...props,
        type: "extension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(result)) return $0089d646d4252ec2$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames,
                tabIndex: props.tabIndex,
                rendererAppearance: props.rendererAppearance
            }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $0089d646d4252ec2$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames,
            tabIndex: props.tabIndex,
            rendererAppearance: props.rendererAppearance
        }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
    });
};
const $0089d646d4252ec2$var$_default_1 = (0, $4TACV.default)($0089d646d4252ec2$var$Extension, {
    overflowSelector: `.${(0, $lnxsR.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});
var $0089d646d4252ec2$export$2e2bcd8739ae039 = $0089d646d4252ec2$var$_default_1;

});
parcelRegister("51HbM", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a4d8420346c8234$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $8P7DW = parcelRequire("8P7DW");

var $hXXvg = parcelRequire("hXXvg");

var $37gEF = parcelRequire("37gEF");

var $bxSQz = parcelRequire("bxSQz");

var $7L4Sb = parcelRequire("7L4Sb");
function $1a4d8420346c8234$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1a4d8420346c8234$var$inlineExtensionStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
const $1a4d8420346c8234$var$plainTextMacroStyle = {
    name: "1b7osz4",
    styles: "display:inline;vertical-align:baseline;[data-macro-body]{display:inline;}"
};
function $1a4d8420346c8234$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>(0, $hXXvg.default)((0, $37gEF.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((_name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((extensionProvider)=>{
        var _marks$find, _node$parameters;
        const fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find((m)=>m.type.name === 'fragment')) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        const isPlainTextMacro = Boolean(node === null || node === void 0 || (_node$parameters = node.parameters) === null || _node$parameters === void 0 || (_node$parameters = _node$parameters.macroParams) === null || _node$parameters === void 0 ? void 0 : _node$parameters.__bodyContent);
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $7L4Sb.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $8Z0o8.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $8Z0o8.jsx)($1a4d8420346c8234$export$f41ccc3bd3324832, {
                    isPlainTextMacro: isPlainTextMacro
                }, /*#__PURE__*/ (0, $8Z0o8.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $8Z0o8.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            node: node,
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext === null || rendererContext === void 0 ? void 0 : rendererContext.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $bxSQz.WithProviders), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $1a4d8420346c8234$export$f41ccc3bd3324832 = ({ children: children, isPlainTextMacro: isPlainTextMacro, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `inline-extension-renderer ${isPlainTextMacro ? 'plain-text-macro' : ''}`,
        css: [
            $1a4d8420346c8234$var$inlineExtensionStyle,
            isPlainTextMacro && $1a4d8420346c8234$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};

});
parcelRegister("37gEF", function(module, exports) {
$parcel$export(module.exports, "getExtensionModuleNode", () => $68a9eb0b95edd77b$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $68a9eb0b95edd77b$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $68a9eb0b95edd77b$export$67a7d49db68d30a0);

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $fuRVo = parcelRequire("fuRVo");

var $e6Qdr = parcelRequire("e6Qdr");

var $krBAk = parcelRequire("krBAk");

var $ijLLe = parcelRequire("ijLLe");

var $9FtwX = parcelRequire("9FtwX");
function $68a9eb0b95edd77b$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
function $68a9eb0b95edd77b$export$573ee875a39e7e73(extensionProvider, extensionType, extensionKey) {
    const [extKey] = (0, $krBAk.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    return extensionProvider.getExtension(extensionType, extKey);
}
async function $68a9eb0b95edd77b$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $krBAk.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $68a9eb0b95edd77b$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $68a9eb0b95edd77b$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    var _extensionProvider$ge;
    const [extKey, nodeKey] = (0, $krBAk.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider === null || extensionProvider === void 0 || (_extensionProvider$ge = extensionProvider.getPreloadedExtension) === null || _extensionProvider$ge === void 0 ? void 0 : _extensionProvider$ge.call(extensionProvider, extensionType, extKey);
    if (manifest) return $68a9eb0b95edd77b$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$68a9eb0b95edd77b$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $68a9eb0b95edd77b$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $68a9eb0b95edd77b$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $68a9eb0b95edd77b$var$isUnknownConfluenceMacroWithBody(extensionNode) {
    var _extensionNode$parame;
    return extensionNode !== null && extensionNode.type === 'extension' && extensionNode.extensionType === 'com.atlassian.confluence.macro.core' && !!((_extensionNode$parame = extensionNode.parameters) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.macroParams) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.__bodyContent) !== null && _extensionNode$parame !== void 0 && _extensionNode$parame.value);
}
function $68a9eb0b95edd77b$var$ExtensionLoading(props) {
    const intl = (0, $k7INq.default)();
    const extensionNode = props.node;
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $68a9eb0b95edd77b$var$isUnknownConfluenceMacroWithBody(extensionNode) && (0, $e6Qdr.fg)('tinymce_display_unknown_macro_body_content')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9FtwX.UnknownMacroPlaceholder), {
            extensionNode: extensionNode
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", null, intl.formatMessage((0, $ijLLe.messages).extensionLoadingError));
    } else return null;
}
function $68a9eb0b95edd77b$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
        loader: ()=>{
            const maybePromise = $68a9eb0b95edd77b$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
            if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $krBAk.resolveImport)(node.render()));
            else {
                var _renderSync, _ref;
                const preloaded = maybePromise === null || maybePromise === void 0 || (_renderSync = (_ref = maybePromise).renderSync) === null || _renderSync === void 0 ? void 0 : _renderSync.call(_ref);
                // Only product implemented preloading will return sync result
                // However the out-of-box won't handle this. Confluence uses a custom implementation
                return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $krBAk.resolveImportSync)(preloaded) : (0, $krBAk.resolveImport)(maybePromise.render());
            }
        },
        // react-loadable passes all props from <NodeRenderer> to the loading component at runtime,
        // but its TypeScript types only expect LoadingComponentProps. We cast here because
        // ExtensionLoading accepts additional props (node, showUnknownMacroPlaceholder) that
        // react-loadable will pass through but doesn't know about in its type definitions.
        loading: $68a9eb0b95edd77b$var$ExtensionLoading
    });
}

});
parcelRegister("krBAk", function(module, exports) {
$parcel$export(module.exports, "NATIVE_EMBED_EXTENSION_TYPE", () => $4a055293df198184$export$862c0e8acc7585d7);
$parcel$export(module.exports, "NATIVE_EMBED_EXTENSION_KEY", () => $4a055293df198184$export$b343a94058bea058);
$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $4a055293df198184$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $4a055293df198184$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImportSync", () => $4a055293df198184$export$dca2026e63034304);
$parcel$export(module.exports, "resolveImport", () => $4a055293df198184$export$d69c9b451c47653b);
const $4a055293df198184$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $4a055293df198184$export$862c0e8acc7585d7 = 'com.atlassian.confluence.macro.core';
const $4a055293df198184$export$b343a94058bea058 = 'native-embed';
const $4a055293df198184$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $4a055293df198184$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $4a055293df198184$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $4a055293df198184$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $4a055293df198184$export$33863d887d6f4bfd(action, manifest);
}
const $4a055293df198184$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
const $4a055293df198184$export$d69c9b451c47653b = async (importPromise)=>{
    return $4a055293df198184$export$dca2026e63034304(await importPromise);
};
function $4a055293df198184$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $4a055293df198184$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});

parcelRegister("ijLLe", function(module, exports) {
$parcel$export(module.exports, "messages", () => $0ca450ea50fb4b5e$export$defe85febe8b728c);
$parcel$export(module.exports, "configPanelMessages", () => $0ca450ea50fb4b5e$export$163c7b0716312254);

var $6K2Gm = parcelRequire("6K2Gm");
const $0ca450ea50fb4b5e$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    edit: {
        id: 'fabric.editor.edit',
        defaultMessage: 'Edit',
        description: 'The text is shown as a button label in the extension context menu. Triggers opening the properties editor for the selected extension to modify its configuration.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting an extension linked to a data consumer.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'Label for a checkbox in a confirm modal that allows the user to also delete connected elements when deleting an extension.'
    },
    saveIndicator: {
        id: 'fabric.editor.extensions.config-panel.save-indicator',
        defaultMessage: 'All changes are always autosaved',
        description: 'Informational message displayed in the extension configuration panel to reassure users that their changes are being saved automatically without requiring manual save action.'
    },
    panelLoadingError: {
        id: 'fabric.editor.extensions.config-panel.loading-error.non-final',
        defaultMessage: 'We ran into a bit of trouble. Refresh to try again.',
        description: 'Error message displayed when the extension configuration panel fails to load. Instructs users to refresh the page to attempt loading the panel again.'
    },
    extensionLoadingError: {
        id: 'fabric.editor.extension.loading-error',
        defaultMessage: 'Error loading the extension!',
        description: 'Error message displayed when an extension fails to load in the editor. Indicates a problem occurred during the extension initialization or rendering process.'
    },
    unknownMacroPlaceholderAriaLabel: {
        id: 'fabric.editor.extension.unknownMacroPlaceholderAriaLabel',
        defaultMessage: 'Unknown macro placeholder',
        description: 'Accessible label for the unknown macro fallback block shown when a Confluence macro cannot be resolved.'
    },
    unknownMacroHeader: {
        id: 'fabric.editor.extension.unknownMacroHeader',
        defaultMessage: "Unknown macro: ''{macroTitle}''",
        description: 'Header text for an unresolved Confluence macro placeholder.'
    }
});
const $0ca450ea50fb4b5e$export$163c7b0716312254 = (0, $6K2Gm.defineMessages)({
    configFailedToLoad: {
        id: 'fabric.editor.configFailedToLoad',
        defaultMessage: 'Failed to load',
        description: 'Displayed when the config panel fails to load fields'
    },
    submit: {
        id: 'fabric.editor.configPanel.submit',
        defaultMessage: 'Submit',
        description: 'Label for a button in the extension configuration panel that the user clicks to submit and apply configuration changes.'
    },
    cancel: {
        id: 'fabric.editor.configPanel.cancel',
        defaultMessage: 'Cancel',
        description: 'Label for a button in the extension configuration panel that the user clicks to cancel and discard configuration changes.'
    },
    close: {
        id: 'fabric.editor.configPanel.close',
        defaultMessage: 'Close',
        description: 'Label for a button in the extension configuration panel that the user clicks to close the panel.'
    },
    required: {
        id: 'fabric.editor.configPanel.required',
        defaultMessage: 'Required field',
        description: 'Validation message for required field'
    },
    invalid: {
        id: 'fabric.editor.configPanel.invalid',
        defaultMessage: 'Invalid field',
        description: 'Validation message when a field value is not acceptable'
    },
    isMultipleAndRadio: {
        id: 'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio',
        defaultMessage: 'Can not combine isMultiple with style: radio',
        description: 'Error message displayed in the extension configuration panel when isMultiple and radio style options are incorrectly combined.'
    },
    addField: {
        id: 'fabric.editor.configPanel.formType.addField',
        defaultMessage: 'Add field',
        description: 'Button to add a new field in nested forms'
    },
    removeField: {
        id: 'fabric.editor.configPanel.formType.removeField',
        defaultMessage: 'Remove field',
        description: 'Button to remove a field in nested forms'
    },
    createOption: {
        id: 'fabric.editor.configPanel.customSelect.createOption',
        defaultMessage: 'Create',
        description: 'Create a new option for a select field'
    },
    documentation: {
        id: 'fabric.editor.configPanel.documentation',
        defaultMessage: 'Documentation',
        description: 'Label for the documentation link'
    },
    help: {
        id: 'fabric.editor.configPanel.help',
        defaultMessage: 'Need help?',
        description: 'Label for documentation link v.2 (to replace "Documentation" text)'
    },
    custom: {
        id: 'fabric.editor.configPanel.dateRange.option.custom',
        defaultMessage: 'Custom',
        description: 'Label for the option "Custom" in the date range UI element'
    },
    from: {
        id: 'fabric.editor.configPanel.dateRange.custom.from',
        defaultMessage: 'From',
        description: 'Label for the initial date when the option "Custom" is selected in the date range UI element'
    },
    to: {
        id: 'fabric.editor.configPanel.dateRange.custom.to',
        defaultMessage: 'To',
        description: 'Label for the end date when the option "Custom" is selected in the date range UI element'
    },
    expand: {
        id: 'fabric.editor.configPanel.dateRange.grouping.expand',
        defaultMessage: 'Expand',
        description: 'Label for expanding a group of fields'
    },
    collapse: {
        id: 'fabric.editor.configPanel.dateRange.grouping.collapse',
        defaultMessage: 'Collapse',
        description: 'Label for collapsing a group of fields'
    },
    errorBoundaryTitle: {
        id: 'fabric.editor.configPanel.errorBoundary.title',
        defaultMessage: 'Something went wrong.',
        description: 'Title for uncaught config panel error'
    },
    errorBoundaryNote: {
        id: 'fabric.editor.configPanel.errorBoundary.note',
        defaultMessage: `We've let the team know. You can still edit and publish this page, or check the error console for more information.`,
        description: 'Note for uncaught config panel error'
    }
});

});

parcelRegister("9FtwX", function(module, exports) {
$parcel$export(module.exports, "UnknownMacroPlaceholder", () => $dd6c10243f382d0e$export$414b5225f50e455b);
/* UnknownMacroPlaceholder.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $k7INq = parcelRequire("k7INq");

var $ijLLe = parcelRequire("ijLLe");
// Unknown macro placeholder styling aligned with Legacy Content Macro (LCM) for consistent look
const $dd6c10243f382d0e$var$neutralBorder = "var(--ds-background-neutral, #0515240F)";
const $dd6c10243f382d0e$var$unknownMacroContainerStyles = null;
// Match LCM header exactly: lcmHeaderStyles from LegacyContentHeader/index.tsx
const $dd6c10243f382d0e$var$unknownMacroHeaderStyles = null;
// Match LCM content area: white surface, text color inherits
const $dd6c10243f382d0e$var$unknownMacroBodyStyles = null;
const $dd6c10243f382d0e$var$unknownMacroPreStyles = null;
function $dd6c10243f382d0e$export$414b5225f50e455b({ extensionNode: extensionNode }) {
    var _extensionNode$parame, _extensionNode$parame2, _extensionNode$parame3;
    const intl = (0, $k7INq.default)();
    const macroTitle = ((_extensionNode$parame = extensionNode.parameters) === null || _extensionNode$parame === void 0 || (_extensionNode$parame = _extensionNode$parame.macroMetadata) === null || _extensionNode$parame === void 0 ? void 0 : _extensionNode$parame.title) || extensionNode.extensionKey;
    const bodyContent = (_extensionNode$parame2 = extensionNode.parameters) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.macroParams) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.__bodyContent) === null || _extensionNode$parame2 === void 0 ? void 0 : _extensionNode$parame2.value;
    const macroParams = ((_extensionNode$parame3 = extensionNode.parameters) === null || _extensionNode$parame3 === void 0 ? void 0 : _extensionNode$parame3.macroParams) ?? {};
    const formatParam = (key, param)=>{
        const value = String((param === null || param === void 0 ? void 0 : param.value) ?? '').trim();
        return `${key} = ${value}`;
    };
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const visibleParams = Object.entries(macroParams).filter(([key])=>!key.startsWith('_')).map(([key, param])=>formatParam(key, param)).join(' | ');
    const headerText = visibleParams ? `${intl.formatMessage((0, $ijLLe.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    })} | ${visibleParams}` : intl.formatMessage((0, $ijLLe.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    });
    return /*#__PURE__*/ $8P7DW.createElement("section", {
        "aria-label": intl.formatMessage((0, $ijLLe.messages).unknownMacroPlaceholderAriaLabel),
        className: (0, $8n1kL.default)([
            "_19it1tra _2rko12b0 _1reo15vq _18m915vq _bfhkhp5a"
        ])
    }, /*#__PURE__*/ $8P7DW.createElement("div", {
        className: (0, $8n1kL.default)([
            "_2rko14xi _11c8wadc _n7zlbjo2 _bfhki8nm _ca0qu2gc _u5f3pxbi _n3td1b66 _19bvpxbi _kqswh2mm _154i1n1a"
        ])
    }, headerText), /*#__PURE__*/ $8P7DW.createElement("div", {
        className: (0, $8n1kL.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
        ])
    }, /*#__PURE__*/ $8P7DW.createElement("pre", {
        className: (0, $8n1kL.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _o5721jtm _1nmz1hna _6z24egat"
        ])
    }, bodyContent)));
}

});


parcelRegister("bxSQz", function(module, exports) {
$parcel$export(module.exports, "WithProviders", () => $35c8da75e152ad7c$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $8P7DW = parcelRequire("8P7DW");
class $35c8da75e152ad7c$export$d498ee8be33e096f extends (0, $8P7DW.PureComponent) {
    static #_ = this.displayName = 'WithProviders';
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProviderIfMounted);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("7L4Sb", function(module, exports) {
$parcel$export(module.exports, "getExtensionRenderer", () => $c5c8fc03a3862c38$export$9214452ef07eda7);
function $c5c8fc03a3862c38$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("4TACV", function(module, exports) {
$parcel$export(module.exports, "shadowClassNames", () => $bad21d0aceb28632$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $bad21d0aceb28632$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $e8MYk = parcelRequire("e8MYk");
const $bad21d0aceb28632$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $bad21d0aceb28632$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $e8MYk.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            var _this$props, _this$props2;
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                !((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.disableTableOverflowShadow) && showRightShadow && $bad21d0aceb28632$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !((_this$props2 = this.props) !== null && _this$props2 !== void 0 && _this$props2.disableTableOverflowShadow) && showLeftShadow && $bad21d0aceb28632$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $e8MYk.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            /**
       * The widths have already been calculated to determine
       * showRightShadow and showLeftShadow. If either is true,
       * then the content is scrollable and we need to set the
       * tabIndex to 0 to allow the user to scroll the content
       * for a11y purposes.
       */ const hasOverflowScroll = showRightShadow || showLeftShadow;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, {
                handleRef: this.handleContainer,
                tabIndex: hasOverflowScroll ? 0 : undefined,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    if ($bad21d0aceb28632$var$isElementNode(scrollableElement)) width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}
// Helper function to check if the passed node is of Element class
function $bad21d0aceb28632$var$isElementNode(node) {
    return node.nodeType === 1;
}

});
parcelRegister("e8MYk", function(module, exports) {
$parcel$export(module.exports, "shadowObserverClassNames", () => $d6c4e50ab79ce8d9$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $d6c4e50ab79ce8d9$export$51a5b28e4fb2dba2);

var $13svG = parcelRequire("13svG");
var $d6c4e50ab79ce8d9$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $d6c4e50ab79ce8d9$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $d6c4e50ab79ce8d9$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $d6c4e50ab79ce8d9$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $d6c4e50ab79ce8d9$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($d6c4e50ab79ce8d9$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($d6c4e50ab79ce8d9$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $d6c4e50ab79ce8d9$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($d6c4e50ab79ce8d9$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($d6c4e50ab79ce8d9$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $d6c4e50ab79ce8d9$var$cancelIdleCallback(this.requestCallbackId);
        }
        if ((0, $13svG.expValEquals)('platform_editor_renderer_shadow_observer_cleanup', 'isEnabled', true)) {
            var _this$sentinels$left, _this$sentinels$right;
            (_this$sentinels$left = this.sentinels.left) === null || _this$sentinels$left === void 0 || _this$sentinels$left.remove();
            (_this$sentinels$right = this.sentinels.right) === null || _this$sentinels$right === void 0 || _this$sentinels$right.remove();
            this.sentinels = {};
        }
    }
}

});


parcelRegister("iN6Wt", function(module, exports) {
$parcel$export(module.exports, "breakoutResizableNodes", () => $a7fcd54e257e11a2$export$2626b4a7243208a1);
$parcel$export(module.exports, "getBreakoutResizableNodeTypes", () => $a7fcd54e257e11a2$export$c2c078d93ed82790);
$parcel$export(module.exports, "breakoutConsts", () => $a7fcd54e257e11a2$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $a7fcd54e257e11a2$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $a7fcd54e257e11a2$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $a7fcd54e257e11a2$export$5f4502874a28dfce);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $a7fcd54e257e11a2$export$c377853ecdd53e5b);
$parcel$export(module.exports, "getNextBreakoutMode", () => $a7fcd54e257e11a2$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $a7fcd54e257e11a2$export$70d1bf7729efff40);

var $e7vUY = parcelRequire("e7vUY");

var $apWx5 = parcelRequire("apWx5");

var $5jr6D = parcelRequire("5jr6D");

var $94YFM = parcelRequire("94YFM");

var $cVpck = parcelRequire("cVpck");
const $a7fcd54e257e11a2$export$2626b4a7243208a1 = [
    'expand',
    'layoutSection',
    'codeBlock',
    'syncBlock',
    'bodiedSyncBlock'
];
const $a7fcd54e257e11a2$export$c2c078d93ed82790 = (schema)=>{
    const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection, syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
    return new Set([
        expand,
        codeBlock,
        layoutSection,
        syncBlock,
        bodiedSyncBlock
    ]);
};
const $a7fcd54e257e11a2$export$ead1fecec2ecf57c = {
    padding: (0, $e7vUY.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $e7vUY.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $e7vUY.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $e7vUY.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $e7vUY.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $5jr6D.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $94YFM.getBreakpoint,
    /**
   * This function can return percentage value or px value depending upon the inputs
   */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $a7fcd54e257e11a2$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $a7fcd54e257e11a2$export$ead1fecec2ecf57c.calcBreakoutWidth($a7fcd54e257e11a2$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $e7vUY.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $e7vUY.akEditorWideLayoutWidth;
        default:
            return $a7fcd54e257e11a2$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($a7fcd54e257e11a2$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $a7fcd54e257e11a2$export$86325001fe8f3adc = $a7fcd54e257e11a2$export$ead1fecec2ecf57c.calcWideWidth($a7fcd54e257e11a2$export$ead1fecec2ecf57c);
const $a7fcd54e257e11a2$export$5f4502874a28dfce = $a7fcd54e257e11a2$export$ead1fecec2ecf57c.calcBreakoutWidth($a7fcd54e257e11a2$export$ead1fecec2ecf57c);
const $a7fcd54e257e11a2$export$ccc0a02edddeed39 = $a7fcd54e257e11a2$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($a7fcd54e257e11a2$export$ead1fecec2ecf57c);
function $a7fcd54e257e11a2$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $a7fcd54e257e11a2$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $cVpck.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $e7vUY.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $e7vUY.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $a7fcd54e257e11a2$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $cVpck.parsePx)($a7fcd54e257e11a2$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $a7fcd54e257e11a2$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $a7fcd54e257e11a2$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $apWx5.default).layoutFixedWidth;
        case 'wide':
            return (0, $apWx5.default).layoutFullWidth;
        default:
            return (0, $apWx5.default).layoutWide;
    }
};

});
parcelRegister("apWx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0098e582dc52e7bb$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6K2Gm = parcelRequire("6K2Gm");

var $eRhPq = parcelRequire("eRhPq");

var $h1BXj = parcelRequire("h1BXj");

var $jezg3 = parcelRequire("jezg3");

var $ir1j2 = parcelRequire("ir1j2");

var $cMkn9 = parcelRequire("cMkn9");

var $3qzDg = parcelRequire("3qzDg");


var $hFkLn = parcelRequire("hFkLn");

var $h98oC = parcelRequire("h98oC");


var $g2ANh = parcelRequire("g2ANh");

var $9zx3J = parcelRequire("9zx3J");

var $jo9w9 = parcelRequire("jo9w9");

var $joKHC = parcelRequire("joKHC");

var $6zkCu = parcelRequire("6zkCu");

var $5xeky = parcelRequire("5xeky");

var $b7qbe = parcelRequire("b7qbe");

var $3kPye = parcelRequire("3kPye");

var $b0tk2 = parcelRequire("b0tk2");

var $4x836 = parcelRequire("4x836");

var $284F9 = parcelRequire("284F9");

var $lFveo = parcelRequire("lFveo");

var $3crZN = parcelRequire("3crZN");

var $jZNua = parcelRequire("jZNua");

var $1I6pT = parcelRequire("1I6pT");

var $7iULu = parcelRequire("7iULu");


var $iGenE = parcelRequire("iGenE");

var $7PTAt = parcelRequire("7PTAt");

var $hIFwF = parcelRequire("hIFwF");

var $gUpGZ = parcelRequire("gUpGZ");

var $4Vbtn = parcelRequire("4Vbtn");

var $dPlyc = parcelRequire("dPlyc");

var $2yJSm = parcelRequire("2yJSm");

var $jjIj4 = parcelRequire("jjIj4");

var $9DWfm = parcelRequire("9DWfm");

var $49rBg = parcelRequire("49rBg");


var $70Otr = parcelRequire("70Otr");

var $66EHQ = parcelRequire("66EHQ");

var $aDSZW = parcelRequire("aDSZW");


var $6dcSS = parcelRequire("6dcSS");

var $5qAdy = parcelRequire("5qAdy");


var $asxNl = parcelRequire("asxNl");

const $0098e582dc52e7bb$var$_default_1 = (0, $6K2Gm.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutStateFixedWidth: {
        id: 'fabric.editor.layoutStateFixedWidth',
        defaultMessage: 'Centered',
        description: 'Displaying your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutStateWide: {
        id: 'fabric.editor.layoutStateWide',
        defaultMessage: 'Wide',
        description: 'Displaying your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    layoutStateFullWidth: {
        id: 'fabric.editor.layoutStateFullWidth',
        defaultMessage: 'Full width',
        description: 'Displaying your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'The text is shown as a button in the image toolbar when the user wants to align an image to the right side of the page.'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'The text is shown as a button in the image toolbar when the user wants to align an image to the center of the page.'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'The text is shown as a button in the image toolbar when the user wants to align an image to the left side of the page.'
    },
    delete: {
        id: 'fabric.editor.delete',
        defaultMessage: 'Delete',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'The text is shown as a link or button in the editor when the user wants to open the selected link in a new browser window.'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'The text is shown as a tooltip label in the editor to describe an action item element when the user interacts with it.'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'The text is shown as a tooltip label in the editor to describe a bullet list element when the user interacts with it.'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'The text is shown as a tooltip label in the editor to describe a nested expand element when the user interacts with it.'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'The text is shown as a tooltip label in the editor to describe a decision list element when the user interacts with it.'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'The text is shown as a tooltip label in the editor to describe a generic block node element when the user interacts with it.'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'The text is shown as a tooltip label in the editor to describe a panel element when the user interacts with it.'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'The text is shown as a tooltip label in the editor to describe a blockquote element when the user interacts with it.'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'The text is shown as a label in the editor to indicate when the content was last updated by a user.'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'The text is shown as a label in the editor to indicate when the content was last viewed by a user.'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'The text is shown as a label suffix after a time value to indicate that the action occurred in the past, for example "5 minutes ago".'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    },
    viewMore: {
        id: 'fabric.editor.overflowMenuViewMore',
        defaultMessage: 'View more',
        description: 'The text is shown as a button in the editor toolbar overflow menu when additional toolbar options are available for the user to view.'
    },
    imageEdit: {
        id: 'fabric.editor.imageEdit',
        defaultMessage: 'Edit image',
        description: 'Crop, flip or rotate the image'
    },
    error: {
        id: 'fabric.editor.error.message.label',
        defaultMessage: 'Error',
        description: 'The text is shown as a label for the error message icon in the editor when an operation fails or an error occurs.'
    },
    success: {
        id: 'fabric.editor.success.message.label',
        defaultMessage: 'Success',
        description: 'Label for success message icon'
    }
});
var $0098e582dc52e7bb$export$2e2bcd8739ae039 = $0098e582dc52e7bb$var$_default_1;

});
parcelRegister("eRhPq", function(module, exports) {
$parcel$export(module.exports, "alignmentMessages", () => $0149a1f706783c62$export$5229ffea355cfdf6);

var $6K2Gm = parcelRequire("6K2Gm");
const $0149a1f706783c62$export$5229ffea355cfdf6 = (0, $6K2Gm.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("h1BXj", function(module, exports) {
$parcel$export(module.exports, "annotationMessages", () => $eeeac4242e8aabcc$export$ff612ca71703201d);

var $6K2Gm = parcelRequire("6K2Gm");
const $eeeac4242e8aabcc$export$ff612ca71703201d = (0, $6K2Gm.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    // Duplicated by Confluence's
    // highlight-actions.inline-comments.comment.no.permission
    noPermissionToAddComment: {
        id: 'fabric.editor.noPermissionToAddComment',
        defaultMessage: '{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}',
        description: 'Tooltip for when the user does not have permission to add inline comments'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    }
});

});

parcelRegister("jezg3", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7b53e136a6c5360b$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $7b53e136a6c5360b$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    maxWidthLabel: {
        id: 'fabric.editor.breakoutMaxWidthLabel',
        defaultMessage: 'Max-width',
        description: 'Resize current element to max-width mode'
    },
    fullWidthLabel: {
        id: 'fabric.editor.breakoutFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Resize current element to full-width mode'
    },
    wideWidthLabel: {
        id: 'fabric.editor.breakoutWideWidthLabel',
        defaultMessage: 'Wide',
        description: 'Resize current element to wide mode'
    },
    resizeHandle: {
        id: 'fabric.editor.resizeHandle',
        defaultMessage: 'Resize handle',
        description: 'Label for the resize handle element displayed on content blocks in the editor, used to allow users to drag and resize the width of the element.'
    },
    resizeExpand: {
        id: 'fabric.editor.breakout.resizeExpand',
        defaultMessage: 'Resize expand',
        description: 'Tooltip displayed on custom expand width resize handle'
    },
    resizeCodeBlock: {
        id: 'fabric.editor.breakout.resizeCodeBlock',
        defaultMessage: 'Resize code snippet',
        description: 'Tooltip displayed on custom code block width resize handle'
    },
    resizeLayout: {
        id: 'fabric.editor.breakout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'Tooltip displayed on custom layout width resize handle'
    },
    resizeElement: {
        id: 'fabric.editor.breakout.resizeElement',
        defaultMessage: 'Resize element',
        description: 'Tooltip displayed on custom element (node) width resize handle'
    }
});

});

parcelRegister("ir1j2", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e2250fd728c34512$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $e2250fd728c34512$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    moveUpBlock: {
        id: 'fabric.editor.block.menu.move.up',
        defaultMessage: 'Move up',
        description: 'Move the selected block up in the document'
    },
    moveDownBlock: {
        id: 'fabric.editor.block.menu.move.down',
        defaultMessage: 'Move down',
        description: 'Move the selected block down in the document'
    },
    copy: {
        id: 'fabric.editor.block.menu.copy',
        defaultMessage: 'Copy',
        description: 'Copy the selected content to the clipboard'
    },
    copyLink: {
        id: 'fabric.editor.block.menu.copy.link',
        defaultMessage: 'Copy link',
        description: 'Copy link to the selected content'
    },
    copyLinkToSelection: {
        id: 'fabric.editor.block.menu.copy.link.to.selection',
        defaultMessage: 'Copy link to selection',
        description: 'Copy link to the selected content'
    },
    linkCopiedToClipboard: {
        id: 'fabric.editor.block.menu.link.copied.to.clipboard',
        defaultMessage: 'Link copied to clipboard',
        description: 'Confirmation message shown when link is copied to clipboard'
    },
    paragraph: {
        id: 'fabric.editor.block.menu.paragraph',
        defaultMessage: 'Paragraph',
        description: 'Change the selected block to a paragraph'
    },
    codeBlock: {
        id: 'fabric.editor.block.menu.codeblock',
        defaultMessage: 'Code block',
        description: 'Convert the selected block to a code block'
    },
    layout: {
        id: 'fabric.editor.block.menu.layout',
        defaultMessage: 'Layout',
        description: 'Convert the selected block to a layout node'
    },
    deleteBlock: {
        id: 'fabric.editor.block.menu.delete.block',
        defaultMessage: 'Delete',
        description: 'Delete the selected block from the document'
    },
    turnInto: {
        id: 'fabric.editor.block.menu.turn.into',
        defaultMessage: 'Turn into',
        description: 'Turn the selected block into another type'
    },
    syncBlock: {
        id: 'fabric.editor.block.menu.sync.block',
        defaultMessage: 'Sync block',
        description: 'Create a synced block at this line, converting the selection to a synced block if applicable'
    },
    copySyncedBlock: {
        id: 'fabric.editor.block.menu.copy.synced.block',
        defaultMessage: 'Copy synced block',
        description: 'Copy the selected synced block to the clipboard'
    },
    newLozenge: {
        id: 'fabric.editor.block.menu.new.lozenge',
        defaultMessage: 'New',
        description: 'Text in lozenge which appears next to newly added menu items'
    },
    decisionList: {
        id: 'fabric.editor.block.menu.decision',
        defaultMessage: 'Decision',
        description: 'Label for the decision option in the block menu transformation menu'
    },
    wrapIcon: {
        id: 'fabric.editor.block.menu.wrap.icon',
        defaultMessage: 'Wrap',
        description: 'Aria label for the wrap icon in code block toolbar'
    },
    create: {
        id: 'fabric.editor.block.menu.create',
        defaultMessage: 'Create',
        description: 'Menu section title for creating new block types'
    },
    headings: {
        id: 'fabric.editor.block.menu.headings',
        defaultMessage: 'Headings',
        description: 'Menu section title for heading block types'
    },
    suggested: {
        id: 'fabric.editor.block.menu.suggested',
        defaultMessage: 'Suggested',
        description: 'Menu section title for suggested block types'
    },
    structure: {
        id: 'fabric.editor.block.menu.structure',
        defaultMessage: 'Structure',
        description: 'Menu section title for structural block types'
    },
    fallbackNestedMenu: {
        id: 'fabric.editor.block.menu.fallback.nested.menu',
        defaultMessage: 'Nested Menu',
        description: 'Fallback text displayed for nested menu component in block menu when proper component is not available'
    },
    fallbackMenuItem: {
        id: 'fabric.editor.block.menu.fallback.menu.item',
        defaultMessage: 'Block Menu Item',
        description: 'Fallback text displayed for menu item component in block menu when proper component is not available'
    }
});

});

parcelRegister("cMkn9", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2e1947d5b71b3a8f$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $2e1947d5b71b3a8f$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    smallText: {
        id: 'fabric.editor.smallText',
        defaultMessage: 'Small text',
        description: 'This is a smaller variant of the normal text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: 'Description text shown in the block type menu to help users understand when to use Heading 3 for sub sections and group headings in the editor.'
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: 'Description text shown in the block type menu to help users understand when to use Heading 4 for deep headings in the editor.'
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: 'Description text shown in the block type menu to help users understand when to use Heading 5 for grouping list items in the editor.'
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: 'Description text shown in the block type menu to help users understand when to use Heading 6 for low level headings in the editor.'
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Label shown as a menu item in the block type dropdown to insert a blockquote for quoting text in the editor.'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Description text shown in the block type menu to help users understand the blockquote option for inserting a quote or citation in the editor.'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Menu description shown in the quick insert menu. Explains that selecting this option inserts a code block with syntax highlighting support.'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    syncedBlock: {
        id: 'fabric.editor.syncedBlock',
        defaultMessage: 'Create synced block',
        description: 'Inserts a synced block that auto-updates content across Atlassian apps'
    },
    syncedBlockDescription: {
        id: 'fabric.editor.syncedBlock.description',
        defaultMessage: 'Sync content across multiple locations',
        description: 'Description of the synced block that auto-updates content across Atlassian apps'
    },
    newLozenge: {
        id: 'fabric.editor.quickinsert.new.lozenge',
        defaultMessage: 'New',
        description: 'Text in lozenge that appears next to new quick insert items'
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Label shown as a menu item in the block type dropdown to access additional text formatting options in the editor.'
    }
});

});

parcelRegister("3qzDg", function(module, exports) {
$parcel$export(module.exports, "codeBidiWarningMessages", () => $95dd6662788e2421$export$42bb270d1224182);

var $6K2Gm = parcelRequire("6K2Gm");
const $95dd6662788e2421$export$42bb270d1224182 = (0, $6K2Gm.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("hFkLn", function(module, exports) {
$parcel$export(module.exports, "linkMessages", () => $4d061cf43ff2acc3$export$4ce3884394d6d9);

var $6K2Gm = parcelRequire("6K2Gm");
const $4d061cf43ff2acc3$export$4ce3884394d6d9 = (0, $6K2Gm.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'The text is shown as a link action in the editor toolbar or context menu when a user can open a linked URL in a new browser tab.'
    },
    openPreviewPanel: {
        id: 'fabric.editor.openPreviewPanel',
        defaultMessage: 'Open preview panel',
        description: 'Opens preview panel and loads the page inside it'
    }
});

});

parcelRegister("h98oC", function(module, exports) {
$parcel$export(module.exports, "linkToolbarMessages", () => $130305d6473dcc1b$export$2d7676d841c8ae9);

var $6K2Gm = parcelRequire("6K2Gm");
const $130305d6473dcc1b$export$2d7676d841c8ae9 = (0, $6K2Gm.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'The text is shown as a button label in the editor link toolbar when the user wants to add a hyperlink to selected content.'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'The text is shown as an error message in the editor link toolbar when the application cannot open the selected hyperlink.'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'The text is shown as placeholder text in the hyperlink toolbar input field where the user can paste a URL or search for a link.'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Label for the link address input field. Prompts users to enter or paste the URL address for the hyperlink.'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'The text is shown as an error message in the editor link toolbar when the user enters a URL that is not valid or properly formatted.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'The text is shown as an error message in the editor link toolbar when the user submits the link field without entering any URL.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'The text is shown as a link in the editor link toolbar that navigates the user to the link preferences settings page.'
    },
    preferencesLink: {
        id: 'fabric.editor.preferencesLink',
        defaultMessage: 'Link preferences',
        description: 'The text is shown as a link label in the editor toolbar that opens the link preferences settings for the user.'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("g2ANh", function(module, exports) {
$parcel$export(module.exports, "codeBlockMessages", () => $4218ecdb42b78d79$export$8bd807073e2c6716);

var $6K2Gm = parcelRequire("6K2Gm");
const $4218ecdb42b78d79$export$8bd807073e2c6716 = (0, $6K2Gm.defineMessages)({
    codeblockLanguageAriaDescription: {
        id: 'fabric.editor.codeBlock.languageAriaDescription',
        defaultMessage: 'Code snippet language: {language}.',
        description: 'A short message that provides information about what code language is being used in a code block for accessibility purposes, punctuation mark at the end as another message comes after'
    },
    codeBlockLanguageNotSet: {
        id: 'fabric.editor.codeBlock.languageNotSet',
        defaultMessage: 'Code language not set.',
        description: 'A short message that provides information that the code block language has not been set for accessibility purposes, punctuation mark at the end as another message comes after'
    }
});

});

parcelRegister("9zx3J", function(module, exports) {
$parcel$export(module.exports, "codeBlockButtonMessages", () => $2fdf2a936b4a666e$export$74e304339778e94d);

var $6K2Gm = parcelRequire("6K2Gm");
const $2fdf2a936b4a666e$export$74e304339778e94d = (0, $6K2Gm.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("jo9w9", function(module, exports) {
$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $dd0ddfd96c3ca200$export$70c8a7203d95247);

var $6K2Gm = parcelRequire("6K2Gm");
const $dd0ddfd96c3ca200$export$70c8a7203d95247 = (0, $6K2Gm.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: 'Displayed as a description text for the action item option in the editor insert menu, used to explain the purpose of creating and assigning action items.'
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Label for the close button on the insert right rail panel in the editor, used to dismiss the insert elements panel.'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Shown as a menu item label in the editor insert menu, used to insert a hyperlink into the document.'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Displayed as a description text for the link option in the editor insert menu, explaining that it allows users to insert a hyperlink into the document.'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Menu option shown in the quick insert menu. Allows users to insert one or more files, videos, or images into the document.'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Menu option shown in the quick insert menu. Allows users to add images, videos, or files to the document.'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Heading or title shown in the insert right rail panel. Indicates the purpose of the panel for inserting elements.'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Menu description shown in the quick insert menu. Explains that users can add images and other files to their page.'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Shown as a menu item label in the editor insert menu, used to insert an image into the document.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Menu description shown in the quick insert menu. Explains that users can insert emojis to enhance their content.'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a table into the document.'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Menu description shown in the quick insert menu. Explains that users can insert a table to organize data.'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Button label showing table dimensions. The placeholders {numberOfColumns} and {numberOfRows} will be substituted with the selected number of columns and rows.'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Popup menu shown when selecting table size. Allows users to choose custom dimensions for creating a table.'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Menu option shown in the quick insert menu. Allows users to insert an expandable/collapsible section into the document.'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Menu description shown in the quick insert menu. Explains that users can insert expandable content sections.'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a decision element to track and document decisions.'
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they're easy to track",
        description: 'Menu description shown in the quick insert menu. Explains that users can insert decision elements for tracking.'
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Menu option shown in the quick insert menu. Opens a dialog where users can provide feedback about the editor.'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the cloud editor',
        description: 'Menu description shown in the quick insert menu. Invites users to share their feedback about the editor experience.'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'Shown as a menu item label in the editor insert menu, used to insert a horizontal rule or divider to separate content in the document.'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'Displayed as a description text for the divider option in the editor insert menu, explaining that it inserts a horizontal line to separate content sections in the document.'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a date into the document using a date picker.'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Menu description shown in the quick insert menu. Explains how to add a date into the document using a calendar picker.'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a text placeholder into the document.'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Menu description shown in the quick insert menu. Explains how to insert a text placeholder for later content.'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Menu option shown in the quick insert menu. Allows users to create multi-column layouts and sections.'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Menu description shown in the quick insert menu. Explains how to use layouts to structure content.'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Menu option for advanced layouts. The placeholder {numberOfColumns} will be substituted with the number of equal columns being inserted.'
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.single.description',
        defaultMessage: 'Insert a single column layout',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a single column layout section.'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a status indicator for tasks or activities.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Menu description shown in the quick insert menu. Explains that users can add custom status labels.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: 'Button label shown in the quick insert menu. Allows users to see additional elements beyond the primary display.'
    },
    viewMoreAriaLabel: {
        id: 'fabric.editor.viewMoreAriaLabel',
        defaultMessage: 'View all elements',
        description: 'ARIA label for accessibility. Provides a more descriptive label to screen readers indicating users can view all insertable elements.'
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Menu option or button label shown in the editor toolbar. Opens a menu of additional items that can be inserted.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Shown as a menu item label in the editor insert menu, used to open the help dialog where users can browse keyboard shortcuts and markdown options.'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Displayed as a description text for the help option in the editor insert menu, explaining that it opens a dialog where users can view all available keyboard shortcuts and markdown formatting options.'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Shown as a menu item label in the editor insert menu, used to trigger recording a Loom video to embed in the document.'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Shown as a button label in the editor toolbar, used to trigger recording a Loom video to add to the document.'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Shown as a button label in the editor comment toolbar, used to trigger recording a Loom video comment to attach to the document.'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Displayed as a description text for the Loom video recording option in the editor insert menu, explaining that users can record and share their screen and thoughts.'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Shown as a short button label in the editor toolbar for recording a Loom video when space is limited.'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Menu option shown when right-clicking or selecting text. Allows users to convert selected text into different element types.'
    }
});

});

parcelRegister("joKHC", function(module, exports) {
$parcel$export(module.exports, "toolbarMessages", () => $0074681de07c666e$export$81b075fd34c2f0bb);

var $6K2Gm = parcelRequire("6K2Gm");
const $0074681de07c666e$export$81b075fd34c2f0bb = (0, $6K2Gm.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("6zkCu", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9e91bbf92fe922d3$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $9e91bbf92fe922d3$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'The text is shown as a title for the floating toolbar when a user selects an inline card or smart link in the editor, providing options to change the card display type.'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    openButtonTitle: {
        id: 'fabric.editor.openButtonTitle',
        defaultMessage: 'Open',
        description: 'Title for a button that opens a link when clicked.'
    },
    panelButtonTitle: {
        id: 'fabric.editor.panelButtonTitle',
        defaultMessage: 'Panel',
        description: 'Title for a button that opens side panel when clicked.'
    },
    previewButtonTitle: {
        id: 'fabric.editor.previewButtonTitle',
        defaultMessage: 'Preview',
        description: 'Title for a button that when clicked opens a preview modal or a preview panel.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    embedToBlockCardWarning: {
        id: 'fabric.editor.embedToBlockCardWarning',
        defaultMessage: 'Displays as a card on small screens',
        description: 'Warning message to show the user that embed card will be displayed as a block card on small screens.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.issue-term-refresh',
        defaultMessage: 'Jira Work Items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.description.issue-term-refresh',
        defaultMessage: 'Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    }
});

});

parcelRegister("5xeky", function(module, exports) {
$parcel$export(module.exports, "messages", () => $23eecfafe4da9ba4$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $23eecfafe4da9ba4$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("b7qbe", function(module, exports) {
$parcel$export(module.exports, "toolbarMessages", () => $603cd8ece9742ee3$export$81b075fd34c2f0bb);

var $6K2Gm = parcelRequire("6K2Gm");
const $603cd8ece9742ee3$export$81b075fd34c2f0bb = (0, $6K2Gm.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    },
    askAI: {
        id: 'fabric.editor.navigate.toolbar.askAI',
        defaultMessage: 'Ask AI',
        description: 'Open the AI panel to ask a question or generate content.'
    },
    selectionToolbarOverflowMenuTooltip: {
        id: 'fabric.editor.selectionToolbarOverflowMenuTooltip',
        defaultMessage: 'More options',
        description: 'Tooltip for the overflow menu in the selection toolbar'
    }
});

});

parcelRegister("3kPye", function(module, exports) {
$parcel$export(module.exports, "messages", () => $05d9d0756b4e96a7$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $05d9d0756b4e96a7$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    tableScrollRegion: {
        id: 'fabric.editor.tableScrollRegion',
        defaultMessage: 'Table scroll region',
        description: 'Label for the scrollable region of a table, used for accessibility purposes.'
    },
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'The text is shown as a menu item in the table options dropdown when the user wants to collapse a table by wrapping it inside an expand element.'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip text shown when hovering over the table width resize handle. Indicates users can drag to adjust the table width.'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'The text is shown as a menu item or button when the user selects one or more table columns to delete them. The message adapts for singular or plural columns.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnLeftHelpDialogLabel: {
        id: 'fabric.editor.moveColumnLeftHelpDialogLabel',
        defaultMessage: 'Move column left',
        description: 'Description of a keymap that moves one column or multiple columns left, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveColumnRightHelpDialogLabel: {
        id: 'fabric.editor.moveColumnRightHelpDialogLabel',
        defaultMessage: 'Move column right',
        description: 'Description of a keymap that moves one column or multiple columns right, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowUpHelpDialogLabel: {
        id: 'fabric.editor.moveRowUpHelpDialogLabel',
        defaultMessage: 'Move row up',
        description: 'Description of a keymap that moves one row or multiple rows up, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    moveRowDownHelpDialogLabel: {
        id: 'fabric.editor.moveRowDownHelpDialogLabel',
        defaultMessage: 'Move row down',
        description: 'Description of a keymap that moves one row or multiple rows down, this is in the help dialog and can be simpler than the puralisation version'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'The text is shown as a menu item or button when the user selects one or more table rows to delete them. The message adapts for singular or plural rows.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        description: 'The text is shown as a label for a toggle option in the table options menu that adds a number to each row except the header row.'
    },
    numberedRows: {
        id: 'fabrid.editor.numberedRows',
        defaultMessage: 'Numbered rows',
        description: 'The text is shown as a label for a toggle option in the table options menu that adds a number to each row except the header row.'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'The text is shown as a checkbox label in a confirmation dialog when the user is about to delete an element that has connected extensions.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'The text is shown as a menu item in the cell options menu when the user selects multiple table cells to merge them into a single cell.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'The text is shown as a menu item in the cell options menu when the user wants to split a previously merged table cell back into individual cells.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    fitToContent: {
        id: 'fabric.editor.fitToContent',
        defaultMessage: `Fit to content`,
        description: `Resize table columns to fit their content`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    dragHandleZone: {
        id: 'fabric.editor.dragHandleZone',
        defaultMessage: 'Activate drag handle zone',
        description: 'The drag handle zone to trigger the drag handle to move the row/column within the table.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'The text is shown as a menu item in the table alignment options menu when the user wants to align the table to the center of the page.'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'The text is shown as a menu item in the table alignment options menu when the user wants to align the table to the left side of the page.'
    }
});

});

parcelRegister("b0tk2", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3dfc32c8c79dca25$export$defe85febe8b728c);
// Common Translations will live here

var $6K2Gm = parcelRequire("6K2Gm");
const $3dfc32c8c79dca25$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: 'The text is shown as a description for the bullet list item in the quick insert menu when the user searches for formatting options.'
    },
    bulletedList: {
        id: 'fabric.editor.bulletedList',
        defaultMessage: 'Bulleted list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: 'The text is shown as a description for the numbered list item in the quick insert menu when the user searches for formatting options.'
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("4x836", function(module, exports) {
$parcel$export(module.exports, "messages", () => $692b33b60e6260d2$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $692b33b60e6260d2$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("284F9", function(module, exports) {
$parcel$export(module.exports, "messages", () => $88b5ffdd78b4ea62$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $88b5ffdd78b4ea62$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    statusEditorLabel: {
        id: 'fabric.editor.statusEditorLabel',
        defaultMessage: 'Status editor',
        description: 'Label for the status element editor'
    },
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    },
    statusPickerOpenedAlert: {
        id: 'fabric.editor.statusPickerOpenedAlert',
        defaultMessage: 'Status editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the status picker is opened, letting the user know they can press the Tab button to access the status picker'
    }
});

});

parcelRegister("lFveo", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a9427150bb902826$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $a9427150bb902826$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    },
    datePickerOpenedAlert: {
        id: 'fabric.editor.datePickerOpenedAlert',
        defaultMessage: 'Date editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the date picker is opened, letting the user know they can press the Tab button to access the date picker'
    }
});

});

parcelRegister("3crZN", function(module, exports) {
$parcel$export(module.exports, "toolbarMessages", () => $051159ea3801d081$export$81b075fd34c2f0bb);

var $6K2Gm = parcelRequire("6K2Gm");
const $051159ea3801d081$export$81b075fd34c2f0bb = (0, $6K2Gm.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'The text is shown as a label on a toolbar button when the user selects a single column layout option in the editor.'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    singleColumnAdvancedLayout: {
        id: 'fabric.editor.singleColumns',
        defaultMessage: '1 Column layout',
        description: 'Layout with one column of equal width'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 Column layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 Column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 Column layout',
        description: 'Layout with four columns of equal width'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 Column layout',
        description: 'Layout with five columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Add placeholder text for empty layout'
    },
    controlslayoutPlaceholder: {
        id: 'fabric.editor.layout.controls.placeholder',
        defaultMessage: '/ to insert',
        description: 'Add placeholder text for empty layout'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one {{count} Column} other {{count} Columns}}',
        description: 'The text is shown as a label for a layout column option in the editor toolbar. It displays the number of columns, for example "1 Column" or "3 Columns".'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'The text is shown as a label on a button or handle when the user can resize the layout columns in the editor.'
    }
});

});

parcelRegister("jZNua", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a5758feb0a873dcb$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $a5758feb0a873dcb$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("1I6pT", function(module, exports) {
$parcel$export(module.exports, "avatarGroupMessages", () => $1b009dccb4d84d61$export$8a0e7c3f8f5b8868);

var $6K2Gm = parcelRequire("6K2Gm");
const $1b009dccb4d84d61$export$8a0e7c3f8f5b8868 = (0, $6K2Gm.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    },
    anonymousCollaborator: {
        id: 'fabric.editor.anonymous-collaborator',
        defaultMessage: 'Anonymous collaborator',
        description: 'The name of an anonymous collaborator, used when the participant name is not specified'
    }
});

});

parcelRegister("7iULu", function(module, exports) {
$parcel$export(module.exports, "findReplaceMessages", () => $63d3c77c03e2493c$export$b46a930e1a386b2e);

var $6K2Gm = parcelRequire("6K2Gm");
const $63d3c77c03e2493c$export$b46a930e1a386b2e = (0, $6K2Gm.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    findReplaceDialogAriaLabel: {
        id: 'fabric.editor.findReplaceDialogAriaLabel',
        defaultMessage: 'Find and Replace',
        description: 'Aria label for the "Find and Replace" dialog'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("iGenE", function(module, exports) {
$parcel$export(module.exports, "textColorMessages", () => $34fce5f55d753db6$export$effb4ee8b6f74abe);

var $6K2Gm = parcelRequire("6K2Gm");
const $34fce5f55d753db6$export$effb4ee8b6f74abe = (0, $6K2Gm.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    },
    textColorHighlightTooltip: {
        id: 'fabric.editor.textColorHighlightTooltip',
        defaultMessage: 'Text and highlight color',
        description: 'Tooltip of menu that provides access to various colors of highlight.'
    }
});

});

parcelRegister("7PTAt", function(module, exports) {
$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $12572179f362cbe5$export$273d864e9e6d0b1f);

var $6K2Gm = parcelRequire("6K2Gm");
const $12572179f362cbe5$export$273d864e9e6d0b1f = (0, $6K2Gm.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    },
    markTaskAsCompleted: {
        id: 'fabric.editor.taskDecision.markTaskAsCompleted',
        defaultMessage: 'Mark task as completed',
        description: 'Button to mark a task as complete in the editor'
    },
    markTaskAsNotCompleted: {
        id: 'fabric.editor.taskDecision.markTaskAsNotCompleted',
        defaultMessage: 'Mark task as not completed',
        description: 'Button to mark a task as not complete in the editor'
    },
    taskList: {
        id: 'fabric.editor.taskList',
        defaultMessage: 'Task list',
        description: 'Label for the task list in the editor'
    },
    decisionAriaLabel: {
        id: 'fabric.editor.decisionAriaLabel',
        defaultMessage: 'Decision',
        description: 'Descriptive text for a decision element'
    },
    undefinedDecisionAriaLabel: {
        id: 'fabric.editor.undefinedDecisionAriaLabel',
        defaultMessage: 'Undefined decision',
        description: 'Descriptive text for an undefined decision element'
    }
});

});

parcelRegister("hIFwF", function(module, exports) {
$parcel$export(module.exports, "placeholderTextMessages", () => $52db4ebad69fd5e7$export$ee8ab8a034b5a8bd);

var $6K2Gm = parcelRequire("6K2Gm");
const $52db4ebad69fd5e7$export$ee8ab8a034b5a8bd = (0, $6K2Gm.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: 'Placeholder text shown in the editor when a placeholder text node is inserted, prompting the user to add custom placeholder content.'
    },
    shortEmptyNodePlaceholderText: {
        id: 'fabric.editor.shortEmptyNodePlaceholderText',
        defaultMessage: '/ to insert',
        description: 'Short placeholder text for empty nodes'
    },
    shortEmptyNodePlaceholderADFSlashShortcut: {
        id: 'fabric.editor.shortEmptyNodePlaceholderSlash',
        defaultMessage: '/',
        description: 'Slash character in short empty node placeholder'
    },
    shortEmptyNodePlaceholderADFSuffix: {
        id: 'fabric.editor.shortEmptyNodePlaceholderSuffix',
        defaultMessage: ' to insert',
        description: 'Text after slash in short empty node placeholder'
    },
    longEmptyNodePlaceholderText: {
        id: 'fabric.editor.longEmptyNodePlaceholderText',
        defaultMessage: 'Type / to insert elements',
        description: 'Long placeholder text for empty nodes'
    },
    longEmptyNodePlaceholderADFPrefix: {
        id: 'fabric.editor.longEmptyNodePlaceholderPrefix',
        defaultMessage: 'Type ',
        description: 'Text before slash in long empty node placeholder'
    },
    longEmptyNodePlaceholderADFSlashShortcut: {
        id: 'fabric.editor.longEmptyNodePlaceholderSlash',
        defaultMessage: '/',
        description: 'Slash character in long empty node placeholder'
    },
    longEmptyNodePlaceholderADFSuffix: {
        id: 'fabric.editor.longEmptyNodePlaceholderSuffix',
        defaultMessage: ' to insert elements',
        description: 'Text after slash in long empty node placeholder'
    },
    sourceSyncBlockPlaceholderText: {
        id: 'fabric.editor.sourceSyncBlockPlaceholderText',
        defaultMessage: 'Add content you want to reuse. Copy and paste this block to sync in other locations.',
        description: 'Placeholder text for source sync block'
    }
});

});

parcelRegister("gUpGZ", function(module, exports) {
$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $29ccfa48d9729d45$export$703e803e9cb0cea4);

var $6K2Gm = parcelRequire("6K2Gm");
const $29ccfa48d9729d45$export$703e803e9cb0cea4 = (0, $6K2Gm.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    },
    plainTextAction: {
        id: 'fabric.editor.plainTextAction',
        defaultMessage: 'Plain text',
        description: 'Converts pasted text into plain text'
    },
    markdownAction: {
        id: 'fabric.editor.useMarkdownAction',
        defaultMessage: 'Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richTextAction: {
        id: 'fabric.editor.richTextAction',
        defaultMessage: 'Rich text',
        description: 'Converts pasted text into Rich text'
    },
    pasteMenuActionsTitle: {
        id: 'fabric.editor.pasteMenuActionsTitle',
        defaultMessage: 'Paste actions',
        description: 'Section title for actions in the paste options menu'
    },
    pasteMenuActionsPasteAs: {
        id: 'fabric.editor.pasteMenuActionsPasteAs',
        defaultMessage: 'Paste as',
        description: 'Submenu title to surface pasting options to paste content as Markdown, Rich text or Plain text'
    }
});

});

parcelRegister("4Vbtn", function(module, exports) {
$parcel$export(module.exports, "panelMessages", () => $0c6af7a4225a7079$export$7bb18eb6f9170174);

var $6K2Gm = parcelRequire("6K2Gm");
const $0c6af7a4225a7079$export$7bb18eb6f9170174 = (0, $6K2Gm.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'The text is shown as a button label on a panel in the editor when the user can add or change the emoji icon displayed on the panel.'
    },
    custom: {
        id: 'fabric.editor.panel.custom',
        defaultMessage: 'Custom',
        description: 'Custom panels where user has selected custom emoji and background color'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'The text is shown as a button or menu label in the panel toolbar. Opens a color picker to select the background color for the panel.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("dPlyc", function(module, exports) {
$parcel$export(module.exports, "mentionMessages", () => $bc0dfd762bf7d795$export$33aafd5ccbbbd00a);

var $6K2Gm = parcelRequire("6K2Gm");
const $bc0dfd762bf7d795$export$33aafd5ccbbbd00a = (0, $6K2Gm.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Label to indicate unknown mention node'
    },
    inviteTeammateInvalidEmail: {
        id: 'fabric.editor.inviteItem.invalidEmail',
        defaultMessage: 'Enter a valid email address',
        description: 'By line text for invite teammate option shown in mentions when the email is invalid. This is a placeholder for the actual error message that will be shown to the user.'
    },
    sendInvite: {
        id: 'fabric.editor.inviteItem.sendInvite',
        defaultMessage: 'Send request to invite teammate',
        description: 'By line text for send request to invite teammate option shown in mentions.'
    }
});

});

parcelRegister("2yJSm", function(module, exports) {
$parcel$export(module.exports, "helpDialogMessages", () => $2702d6206a850ecf$export$83c85447c71428ba);

var $6K2Gm = parcelRequire("6K2Gm");
const $2702d6206a850ecf$export$83c85447c71428ba = (0, $6K2Gm.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'The text is shown as a title for the editor help dialog when the user opens the help panel to view keyboard shortcuts and formatting options.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: 'The text is shown as a heading in the editor help dialog to label the section that lists available keyboard shortcuts for the editor.'
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to paste content without formatting.'
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'Keyboard shortcut description shown in the help dialog. Explains how to toggle or check/uncheck action items in the editor using a keyboard shortcut.'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to insert a new column into a table.'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to insert a new row into a table.'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to add or edit alternative text for an image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    increaseElementSize: {
        id: 'fabric.editor.increaseElementSize',
        defaultMessage: 'Increase element size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    decreaseElementSize: {
        id: 'fabric.editor.decreaseElementSize',
        defaultMessage: 'Decrease element size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to move focus to the table resize handle for resizing columns.'
    },
    selectDragHandle: {
        id: 'fabric.editor.selectDragHandle',
        defaultMessage: 'Select drag handle',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to select and focus the drag handle on the current block.'
    },
    moveSelectionUp: {
        id: 'fabric.editor.moveSelectionUp',
        defaultMessage: 'Move selection up',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to move the selected block up in the document.'
    },
    moveSelectionDown: {
        id: 'fabric.editor.moveSelectionDown',
        defaultMessage: 'Move selection down',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to move the selected block down in the document.'
    },
    moveSelectionLeft: {
        id: 'fabric.editor.moveSelectionLeft',
        defaultMessage: 'Move selection left',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to move the selected block to the left layout column.'
    },
    moveSelectionRight: {
        id: 'fabric.editor.moveSelectionRight',
        defaultMessage: 'Move selection right',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to move the selected block to the right layout column.'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: 'The text is shown as a label for a keyboard shortcut in the editor help dialog that describes how to close the help dialog and return to the editor.'
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("jjIj4", function(module, exports) {
$parcel$export(module.exports, "highlightMessages", () => $900c00cd8265f140$export$456100c8374b6011);

var $6K2Gm = parcelRequire("6K2Gm");
const $900c00cd8265f140$export$456100c8374b6011 = (0, $6K2Gm.defineMessages)({
    highlight: {
        id: 'fabric.editor.highlight',
        defaultMessage: 'Highlight color',
        description: 'Label for the highlight color menu option in the primary editor toolbar. Opens up the color palette for the highlight colors.'
    },
    highlightFloatingToolbar: {
        id: 'fabric.editor.highlightFloatingToolbar',
        defaultMessage: 'Highlight',
        description: 'Button content for the highlight color menu option in the editor floating toolbar. Opens up the color palette for the highlight colors.'
    },
    removeColor: {
        id: 'fabric.editor.highlight.removeColor',
        defaultMessage: 'Remove color',
        description: 'Button content for the combined text highlight and color menu, removes either the applied text color or highlight color.'
    },
    removeHighlight: {
        id: 'fabric.editor.highlight.removeHighlight',
        defaultMessage: 'Remove highlight',
        description: 'Button content for removing the applied highlight color.'
    }
});

});

parcelRegister("9DWfm", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ae1900e1f374f141$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $ae1900e1f374f141$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    dragToMove: {
        id: 'fabric.editor.blockControlDragHandleMove',
        defaultMessage: 'Drag to move',
        description: 'Use drag handle to move content'
    },
    dragToMoveClickToOpen: {
        id: 'fabric.editor.blockControlDragHandleMoveOrOpen',
        defaultMessage: 'Drag to move {br} Click to open menu',
        description: 'Use drag handle to move content or click to open the menu'
    },
    dragToRearrange: {
        id: 'fabric.editor.blockControlDragHandleRearrange',
        defaultMessage: 'Drag to rearrange',
        description: 'Use drag handle to rearrange columns'
    },
    insert: {
        id: 'fabric.editor.blockControlInsert',
        defaultMessage: 'Insert',
        description: 'Label on button to insert content at the current cursor position'
    },
    moveUp: {
        id: 'fabric.editor.blockControlMoveUp',
        defaultMessage: 'Move up',
        description: 'Label for a button in the block controls menu that moves the selected content block up in the editor.'
    },
    moveDown: {
        id: 'fabric.editor.blockControlMoveDown',
        defaultMessage: 'Move down',
        description: 'Label for a button in the block controls menu that moves the selected content block down in the editor.'
    },
    movedup: {
        id: 'fabric.editor.blockControlMovedUp',
        defaultMessage: 'Content has been moved up',
        description: 'Selected content has been moved down'
    },
    movedDown: {
        id: 'fabric.editor.blockControlMovedDown',
        defaultMessage: 'Content has been moved down',
        description: 'Selected content has been moved down'
    },
    moveLeft: {
        id: 'fabric.editor.blockControlMoveLeft',
        defaultMessage: 'Move left',
        description: 'Label for a button in the block controls menu that moves the selected content block to the left.'
    },
    moveRight: {
        id: 'fabric.editor.blockControlMoveRight',
        defaultMessage: 'Move right',
        description: 'Label for a button in the block controls menu that moves the selected content block to the right.'
    },
    delete: {
        id: 'fabric.editor.blockControlDelete',
        defaultMessage: 'Delete',
        description: 'Label for a button in the block controls menu that deletes the currently selected content block from the editor.'
    }
});

});

parcelRegister("49rBg", function(module, exports) {
$parcel$export(module.exports, "mediaInsertMessages", () => $e8388344d6016d39$export$7eb9dc59242bbc45);

var $6K2Gm = parcelRequire("6K2Gm");
const $e8388344d6016d39$export$7eb9dc59242bbc45 = (0, $6K2Gm.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});

parcelRegister("70Otr", function(module, exports) {
$parcel$export(module.exports, "selectionExtensionMessages", () => $9fea9844a2bd2ac6$export$6bc8062c04c761fa);

var $6K2Gm = parcelRequire("6K2Gm");
const $9fea9844a2bd2ac6$export$6bc8062c04c761fa = (0, $6K2Gm.defineMessages)({
    selectionExtensionDropdownButtonLabel: {
        id: 'fabric.editor.selectionExtensionDropdownButtonLabel',
        defaultMessage: 'Select app',
        description: 'Label for the selection extension dropdown button'
    },
    externalExtensionsHeading: {
        id: 'fabric.editor.externalExtensionsHeading',
        defaultMessage: 'Apps',
        description: 'Heading text shown in the selection toolbar overflow dropdown to label the section containing external app extensions.'
    }
});

});

parcelRegister("66EHQ", function(module, exports) {
$parcel$export(module.exports, "selectionToolbarMessages", () => $26824d55d91cd4ec$export$b0226831bf5c0d3e);

var $6K2Gm = parcelRequire("6K2Gm");
const $26824d55d91cd4ec$export$b0226831bf5c0d3e = (0, $6K2Gm.defineMessages)({
    toolbarAppears: {
        id: 'fabric.editor.toolbarAppears',
        defaultMessage: 'Toolbar appears',
        description: 'Label for toolbar position options'
    },
    toolbarPositionInline: {
        id: 'fabric.editor.toolbarPositionInline',
        defaultMessage: 'In-line with text',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionFixedAtTop: {
        id: 'fabric.editor.toolbarPositionFixedAtTop',
        defaultMessage: 'Fixed at top',
        description: 'Label for fixed at top toolbar position option'
    },
    toolbarPositionUnpined: {
        id: 'fabric.editor.toolbarPositionUnpined',
        defaultMessage: 'Pin the toolbar at the top',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionPinedAtTop: {
        id: 'fabric.editor.toolbarPositionPinedAtTop',
        defaultMessage: 'Unpin the toolbar',
        description: 'Label for fixed at top toolbar position option'
    },
    toolbarPositionUnpinnedConcise: {
        id: 'fabric.editor.toolbarPositionUnpinnedConcise',
        defaultMessage: 'Pin toolbar to top',
        description: 'Label for menu item to pin the toolbar to the top of the page'
    }
});

});

parcelRegister("aDSZW", function(module, exports) {
$parcel$export(module.exports, "contextPanelMessages", () => $724a40ba03a4c328$export$8ea7f7e979b71fa5);

var $6K2Gm = parcelRequire("6K2Gm");
const $724a40ba03a4c328$export$8ea7f7e979b71fa5 = (0, $6K2Gm.defineMessages)({
    panelLabel: {
        id: 'fabric.editor.contextPanel.panelLabel',
        defaultMessage: 'Context panel',
        description: 'Accessibility label for the context panel dialog in the editor. Used as an aria-label to identify the panel for screen reader users.'
    },
    panelContentLabel: {
        id: 'fabric.editor.contextPanel.panelContentLabel',
        defaultMessage: 'Scrollable context panel content',
        description: 'Label for the context panel content'
    }
});

});

parcelRegister("6dcSS", function(module, exports) {
$parcel$export(module.exports, "roleDescriptionMessages", () => $a5f6d43447c01eb7$export$29c5997a25e4779b);

var $6K2Gm = parcelRequire("6K2Gm");
const $a5f6d43447c01eb7$export$29c5997a25e4779b = (0, $6K2Gm.defineMessages)({
    codeSnippetTextBox: {
        id: 'fabric.editor.ariaRoleDescription.codeSnippetTextBox',
        defaultMessage: 'codesnippet textbox',
        description: 'Aria role description for code snippet textbox. We are overriding the HTML role textbox so the translation should match the translation of the HTML role textbox in the language being used, but with "code snippet" added to the beginning to differentiate it from a regular textbox.'
    }
});

});

parcelRegister("5qAdy", function(module, exports) {
$parcel$export(module.exports, "syncBlockMessages", () => $72cb3e18f36c59cc$export$254768729b492c8b);

var $6K2Gm = parcelRequire("6K2Gm");
const $72cb3e18f36c59cc$export$254768729b492c8b = (0, $6K2Gm.defineMessages)({
    copySyncBlockLabel: {
        id: 'fabric.editor.copySyncBlock',
        defaultMessage: 'Copy',
        description: 'Button label for copying the reference of sync block element to your clipboard'
    },
    copySyncedBlockTooltip: {
        id: 'fabric.editor.copySyncedBlockTooltip',
        defaultMessage: 'Copy synced block',
        description: 'Tooltip for the button to copy synced block element '
    },
    editSourceLabel: {
        id: 'fabric.editor.editSourceLabel',
        defaultMessage: 'Edit source',
        description: 'Button label for editing the source of sync block element'
    },
    editSourceTooltip: {
        id: 'fabric.editor.editSourceTooltipEnabled',
        defaultMessage: 'Edit synced content at source location',
        description: 'Tooltip for the button to navigate to the source page of the sync block element'
    },
    editSourceTooltipDisabled: {
        id: 'fabric.editor.editSourceTooltipDisabled',
        defaultMessage: 'Source link is not currently available',
        description: 'Tooltip for the button to navigate to the source page, when URL is not available'
    },
    syncBlockGroup: {
        id: 'fabric.editor.syncBlockGroup',
        defaultMessage: 'Sync Block Types',
        description: 'aria-label for group of sync block the floating toolbar'
    },
    syncedBlockLabel: {
        id: 'fabric.editor.syncedBlock.label.text',
        defaultMessage: 'Synced block',
        description: 'Label which appears above the synced block when it is selected'
    },
    unsyncedBlockLabel: {
        id: 'fabric.editor.unsyncedBlock.label.text',
        defaultMessage: 'Unsynced block',
        description: 'Label which appears above the unsynced block when it is selected'
    },
    permissionDeniedHeading: {
        id: 'fabric.editor.syncedBlockPermissionDeniedHeading',
        defaultMessage: 'Request access to view synced block',
        description: 'Heading for error state where the user does not have permission to view the synced block'
    },
    permissionDeniedDescription: {
        id: 'fabric.editor.syncedBlockPermissionDeniedDescription',
        defaultMessage: "You don't have access to view the source content of this synced block.",
        description: 'Description for error state where the user does not have permission to view the synced block'
    },
    permissionDeniedAltText: {
        id: 'fabric.editor.syncedBlockPermissionDeniedIconAltText',
        defaultMessage: 'Permission denied.',
        description: 'Alt text for icon on error state where the user does not have permission to view the synced block'
    },
    requestAccessButton: {
        id: 'fabric.editor.requestAccessToSyncedBlock',
        defaultMessage: 'Request access',
        description: 'Label for button which requests access to view the source page of the sync block'
    },
    accessRequested: {
        id: 'fabric.editor.accessToSyncedBlockRequested',
        defaultMessage: 'Access requested',
        description: 'Text which displays after the request to view the source page of the sync block has been sent and is still pending'
    },
    requestAccessError: {
        id: 'fabric.editor.requestAccessToSyncedBlockError',
        defaultMessage: 'Something went wrong. Click to try again',
        description: 'Text which displays next to the request access button after something went wrong after clicking the button.'
    },
    sourceSyncBlockTooltip: {
        id: 'fabric.editor.sourceSyncBlockTooltip',
        defaultMessage: 'When you edit this source block it will update across synced locations.',
        description: 'Description in tooltip which appears when you hover over the synced block label'
    },
    defaultSyncBlockTooltip: {
        id: 'fabric.editor.sourceSyncBlockTooltip',
        defaultMessage: 'Synced block',
        description: "Description in tooltip which appears when we haven't been able to fetch other information about the sync block"
    },
    referenceSyncBlockTooltip: {
        id: 'fabric.editor.referenceSyncBlockTooltip',
        defaultMessage: 'Synced from: {title}',
        description: 'Tooltip that shows the source page title of the synced block'
    },
    referenceSyncBlockLastEdited: {
        id: 'fabric.editor.referenceSyncBlockLastEdited',
        defaultMessage: 'Last edited: ',
        description: 'Tooltip that shows the last edited time of the synced block'
    },
    taskInDestinationSyncedBlockTooltip: {
        id: 'fabric.editor.taskInDestinationSyncedBlockTooltip',
        defaultMessage: 'This content is synced. Edit it at the source.',
        description: 'Tooltip that shows when you hover over a task in the destination synced block'
    },
    deletionConfirmationModalTitleSingle: {
        id: 'fabric.editor.deletionConfirmationModalTitleSingle',
        defaultMessage: 'Delete synced content?',
        description: 'Title of delete confirmation modal that appears when user tries to delete source synced block that has no reference'
    },
    deleteConfirmationModalTitleMultiple: {
        id: 'fabric.editor.deleteConfirmationModalTitleMultiple',
        defaultMessage: 'Delete content in {count, plural, one {1 location} other {# locations}}?',
        description: 'Title of delete confirmation modal that appears when user tries to delete source synced block that has references'
    },
    deleteConfirmationModalCancelButton: {
        id: 'fabric.editor.deleteConfirmationModalCancelButton',
        defaultMessage: 'Cancel',
        description: 'Text on button which cancels deleting when user was trying to delete source synced block'
    },
    deleteConfirmationModalDeleteButton: {
        id: 'fabric.editor.deleteConfirmationModalDeleteButton',
        defaultMessage: 'Delete',
        description: 'Text on button which confirms deleting the sync block when user was trying to delete source synced block'
    },
    deleteRetryButton: {
        id: 'fabric.editor.deleteConfirmationModalRetryButton',
        defaultMessage: 'Try again',
        description: 'Text on button which retries deleting the sync block when the previous deletion failed'
    },
    deletionConfirmationModalDescription: {
        id: 'fabric.editor.deletionConfirmationModalDescription',
        defaultMessage: "If you delete this synced block, it will become an \u201CUnsynced block\u201D in other locations. This action is permanent and cannot be undone.",
        description: 'Description of delete confirmation modal that appears when user tries to delete source synced block'
    },
    deletionConfirmationModalDescriptionNew: {
        id: 'fabric.editor.deletionConfirmationModalDescriptionNew',
        defaultMessage: 'If you delete this synced block, it will appear as an empty "Unsynced block" in {syncBlockCount, plural, one {1 other synced location} other {# locations}}. This action is permanent and cannot be undone.',
        description: 'Description of delete confirmation modal that appears when user tries to delete source synced block with multiple references'
    },
    deletionConfirmationModalDescriptionNoRef: {
        id: 'fabric.editor.deletionConfirmationModalDescriptionNoRef',
        defaultMessage: 'Your content will no longer appear, and the synced block will be deleted. This action is permanent and cannot be undone.',
        description: 'Description of delete confirmation modal that appears when user tries to delete source synced block'
    },
    createSyncBlockLabel: {
        id: 'fabric.editor.createSyncBlockLabel',
        defaultMessage: 'Create synced block',
        description: 'Label for button which creates a new synced block'
    },
    newLozenge: {
        id: 'fabric.editor.syncBlock.toolbar.newLozenge',
        defaultMessage: 'New',
        description: 'Text in lozenge that appears next to the create synced block button in the toolbar dropdown menu to show that it is a new feature'
    },
    failToDeleteTitle: {
        id: 'fabric.editor.error.title.failToDelete',
        defaultMessage: 'Failed to delete',
        description: 'Title in flag which appears when a sync block cannot be deleted'
    },
    failToDeleteWhenOfflineDescription: {
        id: 'fabric.editor.error.description.failToDeleteWhenOffline',
        defaultMessage: 'You appear to be offline. Please connect to the internet to delete synced content.',
        description: 'Description in flag which appears when a sync block cannot be deleted in offline mode'
    },
    cannotDeleteTitle: {
        id: 'fabric.editor.error.flag.title.cannotDelete',
        defaultMessage: 'Failed to delete synced block',
        description: 'Title in flag which appears when a sync block cannot be deleted'
    },
    cannotDeleteDescription: {
        id: 'fabric.editor.error.description.cannotDelete',
        defaultMessage: 'An error occurred while trying to delete this synced block. ',
        description: 'Description in flag which appears when a sync block fails to be deleted'
    },
    failToEditTitle: {
        id: 'fabric.editor.error.title.failToEdit',
        defaultMessage: 'Cannot edit synced content offline',
        description: 'Title in flag which appears when a sync block cannot be edited'
    },
    failToEditWhenOfflineDescription: {
        id: 'fabric.editor.error.description.failToEditWhenOffline',
        defaultMessage: 'You appear to be offline. Please connect to the internet to edit synced content.',
        description: 'Description in flag which appears when a sync block cannot be edited in offline mode'
    },
    failToCreateTitle: {
        id: 'fabric.editor.error.title.failToCreate',
        defaultMessage: 'Cannot create synced content offline',
        description: 'Title in flag which appears when a sync block cannot be created'
    },
    failToCreateWhenOfflineDescription: {
        id: 'fabric.editor.error.description.failToCreateWhenOffline',
        defaultMessage: 'You appear to be offline. Please connect to the internet to create synced content.',
        description: 'Description in flag which appears when a sync block cannot be created in offline mode'
    },
    loadingSyncedContent: {
        id: 'fabric.editor.syncedBlockLoadingSyncedContent',
        defaultMessage: 'Loading synced content',
        description: 'Accessible label for the loading spinner shown while synced block content is being fetched'
    },
    generalErrorDescription: {
        id: 'fabric.editor.syncedBlockGeneralErrorDescription',
        defaultMessage: `We're unable to display this content at the moment.`,
        description: 'Description for general error state of the synced block'
    },
    notFoundAltText: {
        id: 'fabric.editor.syncedBlockNotFoundIconAltText',
        defaultMessage: 'Synced block not found.',
        description: 'Alt text for icon on error state where the synced block cannot be found or no longer exists'
    },
    notFoundDescription: {
        id: 'fabric.editor.syncedBlockNotFoundDescription.non-final',
        defaultMessage: "We're unable to display this content as its source has been deleted or archived.",
        description: 'Description for error state where the synced block cannot be found'
    },
    sourceUnsyncedDescription: {
        id: 'fabric.editor.syncedBlockSourceUnsyncedDescription',
        defaultMessage: "We're unable to display this content as it's been unsynced from <a>{title}</a>.",
        description: 'Description for error state where the synced block has its source unsynced'
    },
    sourceDeletedDescription: {
        id: 'fabric.editor.syncedBlockSourceDeletedDescription',
        defaultMessage: "We're unable to display this content as it's been deleted from <a>{title}</a>.",
        description: 'Description for error state where the synced block has its source unsynced'
    },
    entityNotFoundDescription: {
        id: 'fabric.editor.syncedBlockEntityNotFoundDescription',
        defaultMessage: "We're unable to display this synced block as it's not available on this site. <link>Learn more</link>",
        description: 'Description for error state where the synced block does not exist on this site (e.g. cross-site reference or hard deleted)'
    },
    genericNotFoundDescription: {
        id: 'fabric.editor.syncedBlockGenericNotFoundDescription',
        defaultMessage: "We're unable to display this synced content as it's been deleted or unsynced.",
        description: 'Description for error state where the synced block has its source unsynced or deleted'
    },
    retryButton: {
        id: 'fabric.editor.retrySyncedBlock',
        defaultMessage: 'Try again',
        description: 'Label for button which retries loading the synced block'
    },
    offlineError: {
        id: 'fabric.editor.error.description.reference.offline',
        defaultMessage: `We're unable to display synced blocks when you're offline`,
        description: 'Error message which is shown over sync block when the editor is offline'
    },
    unpublishedError: {
        id: 'fabric.editor.error.description.reference.unpublished',
        defaultMessage: 'Synced content will display <link>when the page is published</link>',
        description: 'Error message which is shown over sync block when the source page is unpublished.'
    },
    syncBlockCopiedTitle: {
        id: 'fabric.editor.syncBlockCopiedTitle',
        defaultMessage: 'Synced block copied to clipboard',
        description: 'Title in flag which appears when a sync block is copied'
    },
    syncBlockCopiedDescription: {
        id: 'fabric.editor.syncBlockCopiedDescription',
        defaultMessage: 'Paste your synced block to keep content auto-updated. Permissions are the same.',
        description: 'Description in flag which appears when a sync block is copied'
    },
    syncBlockCopiedAction: {
        id: 'fabric.editor.syncBlockCopiedAction',
        defaultMessage: 'Learn more',
        description: 'Action in flag which appears when a sync block is copied to learn more'
    },
    syncedLocationDropdownTitle: {
        id: 'fabric.editor.syncedLocationDropdownTitle',
        defaultMessage: 'Synced locations',
        description: 'Title for the dropdown menu that shows the synced (referenced) locations of the source sync block'
    },
    syncedLocationDropdownHeading: {
        id: 'fabric.editor.syncedLocationDropdownHeading',
        defaultMessage: '{count} locations:',
        description: 'Heading for the dropdown menu that shows the synced (referenced) locations of the source sync block'
    },
    syncedLocationDropdownError: {
        id: 'fabric.editor.syncedLocationDropdownError',
        defaultMessage: "We can't load locations right now. Please wait a few minutes and refresh your browser.",
        description: 'Error message shown in the synced location dropdown menu when fail to fetch the synced (referenced) locations of the source sync block'
    },
    syncedLocationDropdownNoResults: {
        id: 'fabric.editor.syncedLocationDropdownNoResults',
        defaultMessage: 'Copy and paste synced blocks to reuse in other locations.',
        description: 'Message shown in the synced location dropdown menu when no shared locations are found'
    },
    syncedLocationDropdownLearnMoreLink: {
        id: 'fabric.editor.syncedLocationDropdownLearnMoreLink',
        defaultMessage: 'Learn more about synced blocks',
        description: 'Link shown in the synced location dropdown menu to learn more about synced blocks'
    },
    syncedLocationDropdownSamePage: {
        id: 'fabric.editor.syncedLocationDropdownSamePage',
        defaultMessage: 'This page',
        description: 'Message shown in the synced location dropdown option when the reference sync block is on the same page'
    },
    syncedLocationDropdownTitleBlockIndex: {
        id: 'fabric.editor.syncedLocationDropdownTitleNote',
        defaultMessage: 'block {index}',
        description: 'Suffix for page title shown in synced location dropdown option when there are multiple references to the same page'
    },
    syncedLocationDropdownTitleNoteForConfluencePage: {
        id: 'fabric.editor.syncedLocationDropdownTitleNoteForConfluencePage',
        defaultMessage: 'This page',
        description: 'Note shown next to the page title in the synced location dropdown option when the sync block is on the current page'
    },
    syncedLocationDropdownTitleNoteForJiraWorkItem: {
        id: 'fabric.editor.syncedLocationDropdownTitleNoteForJiraWorkItem',
        defaultMessage: 'This work item',
        description: 'Note shown next to the work item title in the synced location dropdown option when the sync block is on the current work item'
    },
    syncedLocationDropdownSourceLozenge: {
        id: 'fabric.editor.syncedLocationDropdownSourceLozenge',
        defaultMessage: 'Source',
        description: 'Lozenge label shown in the synced location dropdown option when the sync block is source'
    },
    syncedLocationDropdownRequestAccess: {
        id: 'fabric.editor.syncedLocationDropdownRequestAccess',
        defaultMessage: 'Request access',
        description: 'Label shown in the synced location dropdown option when the sync block is not accessible to the user'
    },
    syncedLocationDropdownUntitledPage: {
        id: 'fabric.editor.syncedLocationDropdownUntitledPage',
        defaultMessage: 'Untitled',
        description: 'Placeholder title shown in the synced location dropdown when a page has no title yet'
    },
    unpublishedSyncBlockPastedTitle: {
        id: 'fabric.editor.unpublishedSyncBlockPastedTitle',
        defaultMessage: 'Pasted from unpublished page',
        description: 'Title in flag which appears when a reference to an unpublished sync block is pasted'
    },
    unpublishedSyncBlockPastedDescription: {
        id: 'fabric.editor.unpublishedSyncBlockPastedDescription',
        defaultMessage: 'When the page is published, the content will be displayed.',
        description: 'Description in flag which appears when a reference to an unpublished sync block is pasted'
    },
    unsyncButton: {
        id: 'fabric.editor.syncedBlock.unsync',
        defaultMessage: 'Unsync',
        description: 'Text on the button which unsyncs the sync block'
    },
    deleteConfirmationModalUnsyncButton: {
        id: 'fabric.editor.deleteConfirmationModalUnsyncButton',
        defaultMessage: 'Unsync',
        description: 'Text on button which confirms unsyncing the sync block when user was trying to unsync source synced block'
    },
    unsyncConfirmationModalTitle: {
        id: 'fabric.editor.unsyncConfirmationModalTitle',
        defaultMessage: 'Unsync this content?',
        description: 'Title of unsync confirmation modal that appears when user tries to unsync source synced block'
    },
    unsyncConfirmModalDescriptionSingle: {
        id: 'fabric.editor.unsyncConfirmModalDescriptionSingle',
        defaultMessage: 'Your content will stay here. It will no longer be a synced block. This action is permanent and cannot be undone.',
        description: 'Description of unsync confirmation modal that appears when user tries to unsync source synced block with no reference'
    },
    unsyncConfirmModalDescriptionMultiple: {
        id: 'fabric.editor.unsyncConfirmModalDescriptionMultiple',
        defaultMessage: 'Your content will stay here. In {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}} it will appear as an "Unsynced block". This action is permanent and cannot be undone.',
        description: 'Description of unsync confirmation modal that appears when user tries to unsync source synced block with multiple references'
    },
    unsyncConfirmModalDescriptionMultipleNew: {
        id: 'fabric.editor.unsyncConfirmModalDescriptionMultipleNew',
        defaultMessage: 'Your content will stay here. In {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}} it will appear as an empty "Unsynced block". This action is permanent and cannot be undone.',
        description: 'Description of unsync confirmation modal that appears when user tries to unsync source synced block with multiple references'
    },
    cannotPasteSyncedBlockTitle: {
        id: 'fabric.editor.cannotPasteSyncedBlockTitle',
        defaultMessage: 'Unable to paste',
        description: 'Title in flag which appears when a synced block cannot be pasted'
    },
    cannotPasteSyncedBlockDescription: {
        id: 'fabric.editor.cannotPasteSyncedBlockDescription',
        defaultMessage: "We\u2019re still building this feature. Currently, you can only paste synced content once your work item has been created. ",
        description: 'Description in flag which appears when a synced block cannot be pasted'
    },
    cannotPasteSyncedBlockAction: {
        id: 'fabric.editor.cannotPasteSyncedBlockAction',
        defaultMessage: 'Learn more',
        description: 'Action in flag which appears when a synced block cannot be pasted to learn more'
    },
    cannotCreateSyncBlockTitle: {
        id: 'fabric.editor.cannotCreateSyncBlockTitle',
        defaultMessage: 'Unable to create synced block',
        description: 'Title in flag which appears when a synced block cannot be created'
    },
    CannotCreateSyncBlockDescription: {
        id: 'fabric.editor.cannotCreateSyncBlockDescription',
        defaultMessage: 'An error occurred while trying to create this synced block. ',
        description: 'Description in flag which appears when a synced block cannot be created'
    },
    inlineExtensionInSyncBlockTitle: {
        id: 'fabric.editor.inlineExtensionInSyncBlockTitle',
        defaultMessage: 'Some macros may not work when adding synced blocks to new locations',
        description: 'Title in flag which appears when an inline extension is inserted into a synced block'
    },
    inlineExtensionInSyncBlockDescription: {
        id: 'fabric.editor.inlineExtensionInSyncBlockDescription',
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros.",
        description: 'Description in flag which appears when an inline extension is inserted into a synced block'
    },
    extensionInSyncBlockTitle: {
        id: 'fabric.editor.extensionInSyncBlockTitle',
        defaultMessage: 'Some macros may not work when adding synced blocks to new locations',
        description: 'Title in flag which appears when an extension is inserted into a synced block'
    },
    extensionInSyncBlockDescription: {
        id: 'fabric.editor.extensionInSyncBlockDescription',
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros.",
        description: 'Description in flag which appears when an extension is inserted into a synced block'
    },
    duplicateSourceSyncBlockTitle: {
        id: 'fabric.editor.duplicateSourceSyncBlockTitle',
        defaultMessage: 'Duplicate synced block removed',
        description: 'Title in flag which appears when a duplicate source synced block is removed from the document'
    },
    duplicateSourceSyncBlockDescription: {
        id: 'fabric.editor.duplicateSourceSyncBlockDescription',
        defaultMessage: 'Only one source synced block per source is allowed on a page. Use a reference synced block to reuse this content.',
        description: 'Description in flag which appears when a duplicate source synced block is removed from the document'
    }
});

});

parcelRegister("asxNl", function(module, exports) {
$parcel$export(module.exports, "companyHubTextColorMessages", () => $83c6f60c57ef8c47$export$8becdf1c29fc36cd);

var $6K2Gm = parcelRequire("6K2Gm");
const $83c6f60c57ef8c47$export$8becdf1c29fc36cd = (0, $6K2Gm.defineMessages)({
    colorPickerTitle: {
        id: 'company-hub-text-color.color-picker-dropdown.picker-title',
        description: 'Header of color picker dropdown for customizing text color of Company Hub',
        defaultMessage: 'Text Color'
    }
});

});


parcelRegister("cVpck", function(module, exports) {
$parcel$export(module.exports, "walkUpTreeUntil", () => $1abf2bfe5923a5a9$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $1abf2bfe5923a5a9$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $1abf2bfe5923a5a9$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $1abf2bfe5923a5a9$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $1abf2bfe5923a5a9$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $1abf2bfe5923a5a9$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $1abf2bfe5923a5a9$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $1abf2bfe5923a5a9$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $1abf2bfe5923a5a9$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $1abf2bfe5923a5a9$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $1abf2bfe5923a5a9$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $1abf2bfe5923a5a9$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $1abf2bfe5923a5a9$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $1abf2bfe5923a5a9$export$d508bcfb7f019487(node, s) {
    return $1abf2bfe5923a5a9$export$ff7f7c97cdce86e(node, s);
}
function $1abf2bfe5923a5a9$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $1abf2bfe5923a5a9$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $1abf2bfe5923a5a9$export$5b6ab01a6efa50e2(elem, callback) {
    return $1abf2bfe5923a5a9$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("lnxsR", function(module, exports) {
$parcel$export(module.exports, "RendererCssClassName", () => $8e9796889ee766b6$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $8e9796889ee766b6$var$clPrefix = 'ak-renderer-';
const $8e9796889ee766b6$export$91f3bbbf974496e2 = {
    FLEX_CENTER_WRAPPER: `${$8e9796889ee766b6$var$clPrefix}flex-center-wrapper`,
    DOCUMENT: `${$8e9796889ee766b6$var$clPrefix}document`,
    EXTENSION: `${$8e9796889ee766b6$var$clPrefix}extension`,
    EXTENSION_AS_INLINE: `${$8e9796889ee766b6$var$clPrefix}extension-as-inline`,
    EXTENSION_CENTER_ALIGN: `${$8e9796889ee766b6$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$8e9796889ee766b6$var$clPrefix}extension-overflow-container`,
    EXTENSION_INNER_WRAPPER: `${$8e9796889ee766b6$var$clPrefix}extension-inner-wrapper`,
    /** Wrapper for center-aligned extensions/MBE; margin here so it participates in collapse */ STICKY_SAFE_CENTER_WRAPPER: `${$8e9796889ee766b6$var$clPrefix}sticky-safe-center-wrapper`,
    /** Wrapper for center-aligned embed card (wide/full-width); margin here so it participates in collapse */ EMBED_CARD_CENTER_WRAPPER: `${$8e9796889ee766b6$var$clPrefix}embed-card-center-wrapper`,
    /** Wrapper for center-aligned block card datasource (wide/full-width); margin here so it participates in collapse */ BLOCK_CARD_DATASOURCE_CENTER_WRAPPER: `${$8e9796889ee766b6$var$clPrefix}block-card-datasource-center-wrapper`,
    /** Outer flex wrapper for sticky-safe breakout (has vertical margin); zero margin when first in doc */ STICKY_SAFE_BREAKOUT_WRAPPER: `${$8e9796889ee766b6$var$clPrefix}sticky-safe-breakout-wrapper`,
    /** Flex item in sticky-safe breakout; zero first/last child margin so flex container height matches legacy */ STICKY_SAFE_BREAKOUT_INNER: `${$8e9796889ee766b6$var$clPrefix}sticky-safe-breakout-inner`,
    NUMBER_COLUMN: `${$8e9796889ee766b6$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$8e9796889ee766b6$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$8e9796889ee766b6$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$8e9796889ee766b6$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$8e9796889ee766b6$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});

parcelRegister("2b9UX", function(module, exports) {
$parcel$export(module.exports, "calcBreakoutWidthCss", () => $ae5c2016f3c8dfbd$export$87eeb477611c8fe);
const $ae5c2016f3c8dfbd$export$87eeb477611c8fe = (layout)=>{
    if (layout === 'full-width') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--full-width-layout-width))';
    if (layout === 'wide') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--breakout-wide-layout-width))';
    return '100%';
};

});


parcelRegister("jbPve", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $41538ece49cb2de7$export$e926676385687eaf);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $eguiP = parcelRequire("eguiP");

var $1s1Af = parcelRequire("1s1Af");

var $2n5WO = parcelRequire("2n5WO");

var $jS5mX = parcelRequire("jS5mX");

var $13svG = parcelRequire("13svG");

var $gdnRs = parcelRequire("gdnRs");
class $41538ece49cb2de7$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $1s1Af.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $eguiP.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $jS5mX.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error === null || error === void 0 ? void 0 : error.message}`,
                componentStack: (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $2n5WO.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $eguiP.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $jS5mX.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error === null || error === void 0 ? void 0 : error.message}`
                }
            });
            this.setState((prevState)=>({
                    domError: true,
                    domErrorCount: prevState.domErrorCount + 1
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) {
            const key = (0, $13svG.expValEquals)('platform_editor_renderer_error_boundary_stable_key', 'isEnabled', true) ? this.state.domErrorCount : // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            (0, (/*@__PURE__*/$parcel$interopDefault($gdnRs)))();
            return /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, {
                children: this.props.children
            }, key);
        }
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false,
            domErrorCount: 0
        };
    }
}

});
parcelRegister("2n5WO", function(module, exports) {
$parcel$export(module.exports, "logException", () => $a55024109ea91e43$export$f86b2a1a2ce291b3);

var $fHwTC = parcelRequire("fHwTC");

var $e6Qdr = parcelRequire("e6Qdr");

var $1URNz = parcelRequire("1URNz");

var $jDSYs = parcelRequire("jDSYs");
const $a55024109ea91e43$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $a55024109ea91e43$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $a55024109ea91e43$var$packageVersion = undefined;
const $a55024109ea91e43$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $a55024109ea91e43$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await Promise.resolve((parcelRequire("fHwTC")));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("5yJ8I"));
        const breadcrumbsIntegration = (0, $e6Qdr.fg)('platform_editor_sentry_breadcrumbs') ? new (0, $fHwTC.Integrations).Breadcrumbs({
            // only enable breadcrumbs for dom (UI clicks and inputs)
            // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
            dom: {
                serializeAttribute: (0, $jDSYs.SERIALIZABLE_ATTRIBUTES)
            },
            fetch: false,
            xhr: false,
            console: false,
            history: false,
            sentry: false
        }) : undefined;
        const sentryOptions = {
            dsn: (0, $1URNz.isFedRamp)() ? undefined : $a55024109ea91e43$var$SENTRY_DSN,
            release: `${$a55024109ea91e43$var$packageName}@${$a55024109ea91e43$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            beforeBreadcrumb: (0, $e6Qdr.fg)('platform_editor_sentry_breadcrumbs') ? (0, $jDSYs.normaliseSentryBreadcrumbs) : undefined,
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    ...breadcrumbsIntegration ? [
                        breadcrumbsIntegration
                    ] : [],
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $a55024109ea91e43$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        // @ts-ignore - TypeScript 5.9.2 upgrade
        hub.bindClient(client);
        hub.withScope((scope)=>{
            var _buildInfo;
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': (_buildInfo = window.__buildInfo) === null || _buildInfo === void 0 ? void 0 : _buildInfo.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        // @ts-ignore - TypeScript 5.9.2 upgrade
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("1URNz", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $5b1ff5acc73d5e52$export$64d6499adf9b2e51);
const $5b1ff5acc73d5e52$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $5b1ff5acc73d5e52$export$64d6499adf9b2e51() {
    var _global$location;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $5b1ff5acc73d5e52$var$FEDRAMP_MODERATE;
    const matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("jDSYs", function(module, exports) {
$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $948239ebcec5e7e2$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $948239ebcec5e7e2$export$6f14342128c6eaa4);
const $948239ebcec5e7e2$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $948239ebcec5e7e2$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$948239ebcec5e7e2$export$b5bdb04ea16a02e3
];
const $948239ebcec5e7e2$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$948239ebcec5e7e2$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gmu');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $948239ebcec5e7e2$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($948239ebcec5e7e2$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $948239ebcec5e7e2$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category !== null && category !== void 0 && category.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $948239ebcec5e7e2$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("5yJ8I", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("ky0Bu").then(()=>parcelRequire('aaUWJ'));

});


parcelRegister("jS5mX", function(module, exports) {
$parcel$export(module.exports, "PLATFORM", () => $fc08948198054a3d$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $fc08948198054a3d$export$e48589d9e4824227);
var $fc08948198054a3d$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $fc08948198054a3d$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $fc08948198054a3d$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($fc08948198054a3d$var$RESOLVE_METHOD || {});

});


parcelRegister("3zRHk", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $142b98a2dbbb6819$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $142b98a2dbbb6819$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $142b98a2dbbb6819$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $142b98a2dbbb6819$export$9957974f8b4d8f74);
var $142b98a2dbbb6819$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $142b98a2dbbb6819$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $142b98a2dbbb6819$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $142b98a2dbbb6819$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("2x5h2", function(module, exports) {
$parcel$export(module.exports, "AnnotationsPositionContext", () => $7ffc3b6afe28dd73$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $7ffc3b6afe28dd73$export$cef0157dd42cbb3f);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $cB1Zx = parcelRequire("cB1Zx");

var $nGUYn = parcelRequire("nGUYn");

var $lgYwi = parcelRequire("lgYwi");

var $hoMpk = parcelRequire("hoMpk");

var $lCKum = parcelRequire("lCKum");

var $7K5Cn = parcelRequire("7K5Cn");

var $MmGmU = parcelRequire("MmGmU");

var $gSaqt = parcelRequire("gSaqt");

var $7F7AO = parcelRequire("7F7AO");

var $e3c7n = parcelRequire("e3c7n");
const $7ffc3b6afe28dd73$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $lCKum.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $7ffc3b6afe28dd73$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext({
    startPos: 1
});
const $7ffc3b6afe28dd73$export$7121915072388536 = (props)=>{
    var _providers$inlineComm;
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $8P7DW.useContext)((0, $hoMpk.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $7K5Cn.useAnnotationStateByTypeEvent)({
        type: (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hoMpk.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gSaqt.AnnotationRangeProvider), {
            allowCommentsOnMedia: (providers === null || providers === void 0 || (_providers$inlineComm = providers.inlineComment) === null || _providers$inlineComm === void 0 ? void 0 : _providers$inlineComm.allowCommentsOnMedia) ?? false,
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7F7AO.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $lgYwi.AnnotationsContextWrapper), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsx)($7ffc3b6afe28dd73$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, $nGUYn.AnnotationView), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $7ffc3b6afe28dd73$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider !== null && annotationProvider !== void 0 && annotationProvider.annotationManager) {
        var _annotationProvider$i;
        // We need to ensure there is a single instance of the annotation manager for the whole document
        // and that it is the same instance for all annotations.
        // This is because the annotation manager is responsible for managing the state of ALL annotations.
        // This includes annotations inside extensions.
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hoMpk.ProvidersContext).Provider, {
            value: annotationProvider,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $e3c7n.AnnotationManagerProvider), {
                annotationManager: annotationProvider.annotationManager,
                updateSubscriber: (annotationProvider === null || annotationProvider === void 0 || (_annotationProvider$i = annotationProvider.inlineComment) === null || _annotationProvider$i === void 0 ? void 0 : _annotationProvider$i.updateSubscriber) ?? undefined,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)($7ffc3b6afe28dd73$export$7121915072388536, {
                    rendererRef: rendererRef,
                    adfDocument: adfDocument,
                    isNestedRender: isNestedRender,
                    onLoadComplete: onLoadComplete,
                    children: children
                })
            })
        });
    } else return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $hoMpk.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($7ffc3b6afe28dd73$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};

});
parcelRegister("nGUYn", function(module, exports) {
$parcel$export(module.exports, "AnnotationView", () => $af17f5ac44a25752$export$41cd4a02859c2806);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $hoMpk = parcelRequire("hoMpk");

var $7K5Cn = parcelRequire("7K5Cn");

var $fscXt = parcelRequire("fscXt");
const $af17f5ac44a25752$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $8P7DW.useContext)((0, $hoMpk.ProvidersContext));
    const actionContext = (0, $8P7DW.useContext)((0, $fscXt.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $7K5Cn.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $8P7DW.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $8P7DW.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $gWgPx.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("hoMpk", function(module, exports) {
$parcel$export(module.exports, "ProvidersContext", () => $a3e223af56519c1d$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $a3e223af56519c1d$export$aafe46a36ef535ba);

var $8P7DW = parcelRequire("8P7DW");
const $a3e223af56519c1d$export$6a26b015ac619737 = /*#__PURE__*/ (0, $8P7DW.createContext)(null);
const $a3e223af56519c1d$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $8P7DW.createContext)({});

});

parcelRegister("7K5Cn", function(module, exports) {
$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $5e8e75a677682185$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $5e8e75a677682185$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $5e8e75a677682185$export$26cf539704e444c1);

var $8P7DW = parcelRequire("8P7DW");

var $izI49 = parcelRequire("izI49");

var $cB1Zx = parcelRequire("cB1Zx");

var $eguiP = parcelRequire("eguiP");

var $1s1Af = parcelRequire("1s1Af");

var $e3c7n = parcelRequire("e3c7n");
const $5e8e75a677682185$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $8P7DW.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $e3c7n.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $e3c7n.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $8P7DW.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $8P7DW.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $5e8e75a677682185$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $8P7DW.useState)(false);
    const [isHovered, setIsHovered] = (0, $8P7DW.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $e3c7n.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $e3c7n.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $8P7DW.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $5e8e75a677682185$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $5e8e75a677682185$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $8P7DW.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $e3c7n.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $e3c7n.useAnnotationManagerState)();
    const selectedAnnotation = (0, $8P7DW.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // This is a constant to represent the case when no annotation is selected.
        // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $5e8e75a677682185$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $8P7DW.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $eguiP.ACTION).VIEWED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $eguiP.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $1s1Af.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});
parcelRegister("izI49", function(module, exports) {
$parcel$export(module.exports, "AnnotationUpdateEvent", () => $5fba2a086e888a29$export$c1c4b33b4e7b1c70);

var $618PS = parcelRequire("618PS");
var $5fba2a086e888a29$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $5fba2a086e888a29$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($618PS)))();
    }
}

});

parcelRegister("e3c7n", function(module, exports) {
$parcel$export(module.exports, "AnnotationManagerProvider", () => $73ae941f1d5e2cee$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $73ae941f1d5e2cee$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $73ae941f1d5e2cee$export$12cbbb89fb7702d0);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $cB1Zx = parcelRequire("cB1Zx");

var $izI49 = parcelRequire("izI49");

var $fscXt = parcelRequire("fscXt");
const $73ae941f1d5e2cee$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $73ae941f1d5e2cee$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $8P7DW.createContext)($73ae941f1d5e2cee$var$initState);
const $73ae941f1d5e2cee$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $8P7DW.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $73ae941f1d5e2cee$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$73ae941f1d5e2cee$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    var _state$annotations$id, _state$annotations$id2;
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && ((_state$annotations$id = state.annotations[id]) === null || _state$annotations$id === void 0 ? void 0 : _state$annotations$id.markState) === (0, $cB1Zx.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $cB1Zx.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!(loadedAnnotation !== null && loadedAnnotation !== void 0 && loadedAnnotation.markState) && ((_state$annotations$id2 = state.annotations[id]) === null || _state$annotations$id2 === void 0 ? void 0 : _state$annotations$id2.markState) !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current === null || current === void 0 ? void 0 : current.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $cB1Zx.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if ((current === null || current === void 0 ? void 0 : current.markState) !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $cB1Zx.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $cB1Zx.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $73ae941f1d5e2cee$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $8P7DW.useReducer)($73ae941f1d5e2cee$var$reducer, $73ae941f1d5e2cee$var$initState);
    const actionContext = (0, $8P7DW.useContext)((0, $fscXt.RendererContext));
    (0, $8P7DW.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('getDraft', getDraft);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $8P7DW.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            var _state$annotations;
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!((_state$annotations = state.annotations) !== null && _state$annotations !== void 0 && _state$annotations[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $8P7DW.useRef)(undefined);
    (0, $8P7DW.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            var _state$annotations2;
            if (!((_state$annotations2 = state.annotations) !== null && _state$annotations2 !== void 0 && _state$annotations2[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            var _state$annotations3;
            if (!((_state$annotations3 = state.annotations) !== null && _state$annotations3 !== void 0 && _state$annotations3[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
   * This is a temporary solution to ensure that the annotation manager state is in sync with the
   * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
   * by the annotation manager itself.
   */ (0, $8P7DW.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: _eventTargetType, viewMethod: _viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $izI49.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $izI49.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $8P7DW.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)($73ae941f1d5e2cee$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($73ae941f1d5e2cee$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $73ae941f1d5e2cee$export$654a1fb45487f838 = ()=>{
    return (0, $8P7DW.useContext)($73ae941f1d5e2cee$var$AnnotationManagerStateContext);
};
const $73ae941f1d5e2cee$export$12cbbb89fb7702d0 = ()=>{
    return (0, $8P7DW.useContext)($73ae941f1d5e2cee$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("fscXt", function(module, exports) {
$parcel$export(module.exports, "RendererContext", () => $f48896163c84d6c9$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $f48896163c84d6c9$export$66feffbad722f9d4);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $MmGmU = parcelRequire("MmGmU");
parcelRequire("jp3Ur");
var $1s1Af = parcelRequire("1s1Af");

var $eguiP = parcelRequire("eguiP");

var $hERk0 = parcelRequire("hERk0");
const $f48896163c84d6c9$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(new (0, $hERk0.default)());
function $f48896163c84d6c9$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const actions = (0, $8P7DW.useMemo)(()=>new (0, $hERk0.default)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.count(children) > 1 && (0, $e6Qdr.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $eguiP.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $1s1Af.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, $gWgPx.jsx)($f48896163c84d6c9$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, $e6Qdr.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(children) : children
    });
}
const $f48896163c84d6c9$export$d5fcf151601331bc = $f48896163c84d6c9$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("hERk0", function(module, exports) {
$parcel$export(module.exports, "default", () => $4721f484e147a878$export$2e2bcd8739ae039);

var $cB1Zx = parcelRequire("cB1Zx");

var $5UCeT = parcelRequire("5UCeT");

var $8QDVw = parcelRequire("8QDVw");

var $j3TCs = parcelRequire("j3TCs");

var $eguiP = parcelRequire("eguiP");

var $jOegv = parcelRequire("jOegv");

var $e6Qdr = parcelRequire("e6Qdr");

var $eGhH5 = parcelRequire("eGhH5");

var $hI436 = parcelRequire("hI436");

var $cARSa = parcelRequire("cARSa");

var $5ic9g = parcelRequire("5ic9g");
class $4721f484e147a878$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $8QDVw.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
   * Validate whether we can create an annotation between two positions
   */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $j3TCs.TextSelection).create(this.doc, from, to);
        if ((0, $5UCeT.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
        const result = (0, $5UCeT.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $jOegv.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $jOegv.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $eguiP.ACTION).DELETED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $eguiP.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $jOegv.RemoveMarkStep) ? (0, $hI436.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, _annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $eGhH5.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $eGhH5.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            var _startContainer$paren, _endContainer$parentE;
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if ((_startContainer$paren = startContainer.parentElement) !== null && _startContainer$paren !== void 0 && _startContainer$paren.closest('.ak-renderer-extension') || (_endContainer$parentE = endContainer.parentElement) !== null && _endContainer$parentE !== void 0 && _endContainer$parentE.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * This is replaced by `isRangeAnnotatable`.
   *
   * @deprecated
   **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
   * Note: False indicates that the selection not able to be calculated.
   */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $eGhH5.getPosFromRange)(range);
    }
    getSelectionContext() {
        return (0, $5ic9g.getSelectionContext)({
            doc: this.doc,
            schema: this.schema
        });
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $eGhH5.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $5UCeT.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if ((possibleNode === null || possibleNode === void 0 ? void 0 : possibleNode.type.name) === 'media') {
            targetNodeType = 'media';
            step = new (0, $jOegv.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $eGhH5.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $cARSa.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $hI436.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            ancestorNodeTypes: (0, $hI436.getRendererRangeAncestorNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $cARSa.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $5UCeT.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("5UCeT", function(module, exports) {
$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $04b5fa2aa013b9fc$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $04b5fa2aa013b9fc$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $04b5fa2aa013b9fc$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $04b5fa2aa013b9fc$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $04b5fa2aa013b9fc$export$35054451202ed5d9);
$parcel$export(module.exports, "getRangeAncestorNodeNames", () => $04b5fa2aa013b9fc$export$2a160f09551a3adc);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $04b5fa2aa013b9fc$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $04b5fa2aa013b9fc$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $04b5fa2aa013b9fc$export$2efbc6d84ea0fbec);
$parcel$export(module.exports, "isEmptyTextSelectionRenderer", () => $04b5fa2aa013b9fc$export$a35880e7ecdcf47b);

var $cB1Zx = parcelRequire("cB1Zx");

var $e6Qdr = parcelRequire("e6Qdr");
const $04b5fa2aa013b9fc$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $04b5fa2aa013b9fc$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $04b5fa2aa013b9fc$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $04b5fa2aa013b9fc$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $04b5fa2aa013b9fc$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($04b5fa2aa013b9fc$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $04b5fa2aa013b9fc$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $04b5fa2aa013b9fc$export$2a160f09551a3adc({ doc: doc, pos: pos }) {
    if (!(0, $e6Qdr.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        // For a range, we can get ancestors at both from and to positions
        // or just use the from position if you want ancestors at the start
        const resolvedFromPos = doc.resolve(pos.from);
        const resolvedToPos = doc.resolve(pos.to);
        // Collect ancestors at the 'from' position
        for(let depth = resolvedFromPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedFromPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        // Use nodesBetween to collect parent types without additional resolve() calls
        // This isn't as precise as calling resolve() on each parent, but it's a lot faster
        // and should hopefully provide a good approximation of the ancestor nodes
        const seenParents = new Set();
        doc.nodesBetween(pos.from, pos.to, (_node, _nodePos, parent)=>{
            // Collect parent chain using the parent parameter
            const currentParent = parent;
            if (!!currentParent && !seenParents.has(currentParent)) {
                seenParents.add(currentParent);
                nodeNames.add(currentParent.type.name);
            // Note: We can't easily get the parent's parent from this context
            // without additional resolve calls, so this approach has limitations
            }
            return true;
        });
        // Optionally collect ancestors at the 'to' position if different
        // This ensures we capture all ancestor contexts across the range
        if (pos.from !== pos.to) for(let depth = resolvedToPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedToPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        return [
            ...nodeNames
        ];
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $04b5fa2aa013b9fc$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, _pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $04b5fa2aa013b9fc$export$bb1945a828f2864b(pos) {
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $04b5fa2aa013b9fc$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $04b5fa2aa013b9fc$export$a35880e7ecdcf47b(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("8QDVw", function(module, exports) {
$parcel$export(module.exports, "nodeToJSON", () => $e1e292b9b473ae6f$export$3a858d3babd60825);
$parcel$export(module.exports, "JSONTransformer", () => $e1e292b9b473ae6f$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $77MDz = parcelRequire("77MDz");

var $fYiX1 = parcelRequire("fYiX1");
var $gvebP = parcelRequire("gvebP");
var $1zZdw = parcelRequire("1zZdw");
var $kUQJJ = parcelRequire("kUQJJ");
var $MLmfK = parcelRequire("MLmfK");
var $bkx8J = parcelRequire("bkx8J");
var $9enxE = parcelRequire("9enxE");
var $d0FgX = parcelRequire("d0FgX");
var $1l3LJ = parcelRequire("1l3LJ");

var $2WmUO = parcelRequire("2WmUO");

var $1Nkti = parcelRequire("1Nkti");

var $aqFqo = parcelRequire("aqFqo");
var $e1e292b9b473ae6f$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $e1e292b9b473ae6f$var$isType = (type)=>(node)=>node.type.name === type;
// Create a Set of node types that should have empty attrs removed
const $e1e292b9b473ae6f$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
const $e1e292b9b473ae6f$var$isCodeBlock = $e1e292b9b473ae6f$var$isType('codeBlock');
const $e1e292b9b473ae6f$var$isMediaNode = $e1e292b9b473ae6f$var$isType('media');
const $e1e292b9b473ae6f$var$isMediaInline = $e1e292b9b473ae6f$var$isType('mediaInline');
const $e1e292b9b473ae6f$var$isMediaSingleNode = $e1e292b9b473ae6f$var$isType('mediaSingle');
const $e1e292b9b473ae6f$var$isMentionNode = $e1e292b9b473ae6f$var$isType('mention');
const $e1e292b9b473ae6f$var$isParagraph = $e1e292b9b473ae6f$var$isType('paragraph');
const $e1e292b9b473ae6f$var$isHeading = $e1e292b9b473ae6f$var$isType('heading');
const $e1e292b9b473ae6f$var$isTable = $e1e292b9b473ae6f$var$isType('table');
const $e1e292b9b473ae6f$var$isTableCell = $e1e292b9b473ae6f$var$isType('tableCell');
const $e1e292b9b473ae6f$var$isTableHeader = $e1e292b9b473ae6f$var$isType('tableHeader');
const $e1e292b9b473ae6f$var$isLinkMark = $e1e292b9b473ae6f$var$isType('link');
const $e1e292b9b473ae6f$var$isUnsupportedMark = $e1e292b9b473ae6f$var$isType('unsupportedMark');
const $e1e292b9b473ae6f$var$isUnsupportedNodeAttributeMark = $e1e292b9b473ae6f$var$isType('unsupportedNodeAttribute');
const $e1e292b9b473ae6f$var$isExpand = $e1e292b9b473ae6f$var$isType('expand');
const $e1e292b9b473ae6f$var$isNestedExpand = $e1e292b9b473ae6f$var$isType('nestedExpand');
const $e1e292b9b473ae6f$var$isUnsupportedNode = (node)=>$e1e292b9b473ae6f$var$isType('unsupportedBlock')(node) || $e1e292b9b473ae6f$var$isType('unsupportedInline')(node);
const $e1e292b9b473ae6f$var$isDataConsumer = $e1e292b9b473ae6f$var$isType('dataConsumer');
const $e1e292b9b473ae6f$var$isFragmentMark = $e1e292b9b473ae6f$var$isType('fragment');
const $e1e292b9b473ae6f$var$isHardBreak = $e1e292b9b473ae6f$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e1e292b9b473ae6f$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $e1e292b9b473ae6f$var$filterNull(current);
    }
    return output;
};
const $e1e292b9b473ae6f$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $e1e292b9b473ae6f$var$emptyDoc = $e1e292b9b473ae6f$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ const $e1e292b9b473ae6f$export$3a858d3babd60825 = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($e1e292b9b473ae6f$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($e1e292b9b473ae6f$var$isMediaNode(node)) obj.attrs = (0, $9enxE.toJSON)(node).attrs;
    else if ($e1e292b9b473ae6f$var$isMediaSingleNode(node)) obj.attrs = (0, $bkx8J.toJSON)(node).attrs;
    else if ($e1e292b9b473ae6f$var$isMediaInline(node)) obj.attrs = (0, $9enxE.toJSON)(node).attrs;
    else if ($e1e292b9b473ae6f$var$isMentionNode(node)) obj.attrs = (0, $d0FgX.toJSON)(node).attrs;
    else if ($e1e292b9b473ae6f$var$isCodeBlock(node)) obj.attrs = (0, $fYiX1.toJSON)(node).attrs;
    else if ($e1e292b9b473ae6f$var$isTable(node)) obj.attrs = (0, $1l3LJ.tableToJSON)(node).attrs;
    else if ($e1e292b9b473ae6f$var$isTableCell(node)) obj.attrs = (0, $1l3LJ.toJSONTableCell)(node).attrs;
    else if ($e1e292b9b473ae6f$var$isTableHeader(node)) obj.attrs = (0, $1l3LJ.toJSONTableHeader)(node).attrs;
    else if ($e1e292b9b473ae6f$var$isExpand(node) || $e1e292b9b473ae6f$var$isNestedExpand(node)) obj.attrs = (0, $1zZdw.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $e1e292b9b473ae6f$var$filterNull(obj.attrs);
    if ($e1e292b9b473ae6f$var$isMentionNode(node) && mentionMap) {
        var _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = ((_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    if ($e1e292b9b473ae6f$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $e1e292b9b473ae6f$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($e1e292b9b473ae6f$export$3a858d3babd60825(child, mentionMap));
    });
    if ($e1e292b9b473ae6f$var$isParagraph(node) || $e1e292b9b473ae6f$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($e1e292b9b473ae6f$var$isUnsupportedMark(mark)) return $e1e292b9b473ae6f$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($e1e292b9b473ae6f$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($e1e292b9b473ae6f$var$isLinkMark(mark)) return (0, $MLmfK.toJSON)(mark);
            else if ($e1e292b9b473ae6f$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                const serialised = (0, $gvebP.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($e1e292b9b473ae6f$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $kUQJJ.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($e1e292b9b473ae6f$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$e1e292b9b473ae6f$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $e1e292b9b473ae6f$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $1Nkti.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $e1e292b9b473ae6f$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $e1e292b9b473ae6f$export$98cb1d9308d0944d {
    /**
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ constructor(schema = (0, $2WmUO.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node, options = {}) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $aqFqo.sanitizeNode)($e1e292b9b473ae6f$export$3a858d3babd60825(child, this.mentionMap), options));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($77MDz)))(content, $e1e292b9b473ae6f$var$emptyDoc.content)) return $e1e292b9b473ae6f$var$createDocFromContent([]);
        return $e1e292b9b473ae6f$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $2WmUO.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($e1e292b9b473ae6f$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
   * This method is used to encode a single node
   */ encodeNode(node) {
        return (0, $aqFqo.sanitizeNode)($e1e292b9b473ae6f$export$3a858d3babd60825(node, this.mentionMap));
    }
}
function $e1e292b9b473ae6f$export$1c4065b3a9f04cf2(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}

});
parcelRegister("1Nkti", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", () => $d3aa066dbff535da$export$28e4e3c024cce988);
const $d3aa066dbff535da$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $d3aa066dbff535da$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $d3aa066dbff535da$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $d3aa066dbff535da$var$defaultAllowOverrideBehaviour;
        default:
            return $d3aa066dbff535da$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("aqFqo", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", () => $3467b820749032cb$export$48b382180baf8e88);

var $8Fw2S = parcelRequire("8Fw2S");

var $1CVmW = parcelRequire("1CVmW");

var $1SsQs = parcelRequire("1SsQs");
const $3467b820749032cb$var$hasNestedTable = (tableCellNode)=>{
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some((node)=>(node === null || node === void 0 ? void 0 : node.type) === 'table');
};
function $3467b820749032cb$export$48b382180baf8e88(json, options = {}) {
    const { keepNestedTables: keepNestedTables = false } = options;
    const sanitizedJSON = (0, $1CVmW.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $1SsQs.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($3467b820749032cb$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $8Fw2S.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: (node)=>{
            if ($3467b820749032cb$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $8Fw2S.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        emoji: (0, $1SsQs.removeNonAnnotationMarks),
        mention: (0, $1SsQs.removeNonAnnotationMarks),
        date: (0, $1SsQs.removeNonAnnotationMarks),
        hardBreak: (0, $1SsQs.removeMarks),
        inlineCard: (0, $1SsQs.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("8Fw2S", function(module, exports) {
$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $84e515771c934a17$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $84e515771c934a17$export$8a334a7d9fe120ec);

var $1CVmW = parcelRequire("1CVmW");

var $4flTN = parcelRequire("4flTN");

var $54esm = parcelRequire("54esm");
const $84e515771c934a17$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $84e515771c934a17$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $84e515771c934a17$export$f45e7335ec874bfe = (extensionNode)=>{
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === $84e515771c934a17$var$NESTED_TABLE_EXTENSION_TYPE && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === $84e515771c934a17$var$NESTED_TABLE_EXTENSION_KEY;
};
const $84e515771c934a17$var$transformNestedTableExtension = (nestedTableExtension)=>{
    var _nestedTableExtension;
    // No content - drop the extension node
    if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension = _nestedTableExtension.parameters) !== null && _nestedTableExtension !== void 0 && _nestedTableExtension.adf)) return false;
    try {
        var _nestedTableExtension2;
        const adf = JSON.parse((_nestedTableExtension2 = nestedTableExtension.attrs) === null || _nestedTableExtension2 === void 0 || (_nestedTableExtension2 = _nestedTableExtension2.parameters) === null || _nestedTableExtension2 === void 0 ? void 0 : _nestedTableExtension2.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $54esm.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
const $84e515771c934a17$export$18544d0b5f43e4a1 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $1CVmW.traverse)(adf, {
        extension: (node)=>{
            if ($84e515771c934a17$export$f45e7335ec874bfe(node)) {
                isTransformed = true;
                return $84e515771c934a17$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $84e515771c934a17$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        var _tableCellNode$conten;
        return {
            ...tableCellNode,
            content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map((childNode)=>{
                // wrap nested table in an extension node
                if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'table') return (0, $4flTN.extension)({
                    extensionType: $84e515771c934a17$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $84e515771c934a17$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $54esm.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("4flTN", function(module, exports) {
$parcel$export(module.exports, "extension", () => $fed77db54d5a6684$export$1b45514b112dd749);
const $fed77db54d5a6684$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("54esm", function(module, exports) {
$parcel$export(module.exports, "NodeNestingTransformError", () => $b6bb0ee36c80649c$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $b6bb0ee36c80649c$export$3d8e8d2182f13924 extends Error {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("1SsQs", function(module, exports) {
$parcel$export(module.exports, "removeMarks", () => $a7310a8fb4e12054$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $a7310a8fb4e12054$export$8cae9126fc577085);
function $a7310a8fb4e12054$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $a7310a8fb4e12054$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("eGhH5", function(module, exports) {
$parcel$export(module.exports, "getStartPos", () => $458c431e8dc39340$export$aabc9b13a308cc43);
$parcel$export(module.exports, "findParent", () => $458c431e8dc39340$export$25245567f53f158f);
$parcel$export(module.exports, "getPosFromRange", () => $458c431e8dc39340$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $458c431e8dc39340$export$74899f7e5acb5cd3);

var $e6Qdr = parcelRequire("e6Qdr");

var $jOegv = parcelRequire("jOegv");
function $458c431e8dc39340$export$aabc9b13a308cc43(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $458c431e8dc39340$var$getNodeType = (element)=>element.dataset.nodeType;
function $458c431e8dc39340$var$isPositionPointer(element) {
    return $458c431e8dc39340$export$aabc9b13a308cc43(element) > -1;
}
function $458c431e8dc39340$export$25245567f53f158f(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $458c431e8dc39340$export$9d1d5d87ae7da22f(parentElement)) return null;
    if ($458c431e8dc39340$var$isPositionPointer(parentElement)) return parentElement;
    return $458c431e8dc39340$export$25245567f53f158f(parentElement);
}
function $458c431e8dc39340$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $458c431e8dc39340$export$9d1d5d87ae7da22f(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $458c431e8dc39340$var$findMediaParent(parentElement);
}
function $458c431e8dc39340$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($458c431e8dc39340$export$9d1d5d87ae7da22f(parentElement) || !parentElement) return null;
    if ($458c431e8dc39340$var$isPositionPointer(parentElement)) return element;
    return $458c431e8dc39340$var$findParentBeforePointer(parentElement);
}
function $458c431e8dc39340$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $458c431e8dc39340$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $458c431e8dc39340$var$isHighlightTextNode(node) {
    var _dataset;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!(node !== null && node !== void 0 && (_dataset = node.dataset) !== null && _dataset !== void 0 && _dataset.highlighted);
}
function $458c431e8dc39340$var$isNodeInlineMark(node) {
    return $458c431e8dc39340$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $458c431e8dc39340$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $458c431e8dc39340$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $458c431e8dc39340$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($458c431e8dc39340$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $458c431e8dc39340$var$hasInlineNodeDescendant(node) {
    if ($458c431e8dc39340$var$isElementNode(node)) {
        if ((0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($458c431e8dc39340$var$hasInlineNodeDescendant);
    }
    return false;
}
function $458c431e8dc39340$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($458c431e8dc39340$var$isTextNode(prev) || $458c431e8dc39340$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($458c431e8dc39340$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($458c431e8dc39340$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $458c431e8dc39340$export$9d1d5d87ae7da22f(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $458c431e8dc39340$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) {
        var _node$parentElement;
        const startPosAncestor = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest('[data-renderer-start-pos');
        const potentialParent = (0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor !== null && startPosAncestor !== void 0 && startPosAncestor.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10) + 1;
            else return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $458c431e8dc39340$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $458c431e8dc39340$export$aabc9b13a308cc43(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++){
                var _children$i;
                count += ((_children$i = children[i]) === null || _children$i === void 0 || (_children$i = _children$i.textContent) === null || _children$i === void 0 ? void 0 : _children$i.length) || 1;
            }
            return count;
        }
        return $458c431e8dc39340$export$aabc9b13a308cc43(node) + offset;
    }
    const parent = $458c431e8dc39340$export$25245567f53f158f(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $458c431e8dc39340$export$aabc9b13a308cc43(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $458c431e8dc39340$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($458c431e8dc39340$var$isNodeInlineTextMark(preParentPointer) || $458c431e8dc39340$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($458c431e8dc39340$var$isElementInlineMark(preParentPointer) || $458c431e8dc39340$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $458c431e8dc39340$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $458c431e8dc39340$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $458c431e8dc39340$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $458c431e8dc39340$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $458c431e8dc39340$export$25245567f53f158f(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($458c431e8dc39340$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $458c431e8dc39340$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $458c431e8dc39340$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $458c431e8dc39340$export$aabc9b13a308cc43(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $458c431e8dc39340$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $458c431e8dc39340$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $458c431e8dc39340$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $jOegv.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("hI436", function(module, exports) {
$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $a05ee6f7861416eb$export$b0ea72d31617ccea);
$parcel$export(module.exports, "getRendererRangeAncestorNodeNames", () => $a05ee6f7861416eb$export$1726c23d64498b6);

var $5UCeT = parcelRequire("5UCeT");

var $e6Qdr = parcelRequire("e6Qdr");
function $a05ee6f7861416eb$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $5UCeT.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}
function $a05ee6f7861416eb$export$1726c23d64498b6({ actions: actions, pos: pos }) {
    if (!(0, $e6Qdr.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const ancestorNodeNames = (0, $5UCeT.getRangeAncestorNodeNames)({
        doc: doc,
        pos: pos
    });
    return ancestorNodeNames;
}

});

parcelRegister("cARSa", function(module, exports) {
$parcel$export(module.exports, "getIndexMatch", () => $b7c9ac751486ed83$export$fb7dab895a0d310e);
function $b7c9ac751486ed83$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $b7c9ac751486ed83$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $b7c9ac751486ed83$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $b7c9ac751486ed83$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});

parcelRegister("5ic9g", function(module, exports) {
$parcel$export(module.exports, "getSelectionContext", () => $5d309cf9d47a9c79$export$3726c4866ce829b5);

var $j3TCs = parcelRequire("j3TCs");

var $60as7 = parcelRequire("60as7");

var $eGhH5 = parcelRequire("eGhH5");
const $5d309cf9d47a9c79$export$3726c4866ce829b5 = ({ doc: doc, schema: schema })=>{
    if (!doc || !schema) return null;
    const selection = document.getSelection();
    if (!selection || selection.type !== 'Range' || selection.rangeCount !== 1) return null;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return null;
    const startNode = (0, $eGhH5.findParent)(range.startContainer);
    const endNode = (0, $eGhH5.findParent)(range.endContainer);
    if (!startNode || !endNode) return null;
    const startPos = (0, $eGhH5.getStartPos)(startNode);
    const endPos = (0, $eGhH5.getStartPos)(endNode);
    if (startPos === null || endPos === null) return null;
    const pos = (0, $eGhH5.getPosFromRange)(range);
    if (!pos) return null;
    const from = Math.min(pos.from, pos.to);
    const to = Math.max(pos.from, pos.to);
    if (from === to) return null;
    let pmSelection;
    try {
        pmSelection = (0, $j3TCs.TextSelection).create(doc, from, to);
    } catch  {
        return null;
    }
    const startIndex = from - startPos;
    const endIndex = to - endPos;
    if (startIndex < 0 || endIndex < 0) return null;
    const selectionFragment = (0, $60as7.getFragmentsFromSelection)(pmSelection);
    const localIds = (0, $60as7.getLocalIdsFromSelection)(pmSelection);
    return {
        localIds: localIds,
        selectionFragment: selectionFragment,
        selectionMarkdown: null,
        startIndex: startIndex,
        endIndex: endIndex
    };
};

});
parcelRegister("60as7", function(module, exports) {
$parcel$export(module.exports, "getFragmentsFromSelection", () => $8d45acd5c855567f$export$dae3dcae007fe30);
$parcel$export(module.exports, "getLocalIdsFromSelection", () => $8d45acd5c855567f$export$9ce8378d786d4035);

var $8QDVw = parcelRequire("8QDVw");

var $2sVuK = parcelRequire("2sVuK");

var $j3TCs = parcelRequire("j3TCs");
const $8d45acd5c855567f$var$listDepth = 3;
const $8d45acd5c855567f$export$8701765a689d47ab = ($from, $to)=>{
    // Block level lists
    const listParents = [
        'bulletList',
        'orderedList'
    ];
    if ($from.depth >= $8d45acd5c855567f$var$listDepth && $to.depth >= $8d45acd5c855567f$var$listDepth && $from.depth === $to.depth) {
        var _greatGrandparentFrom, _greatGrandparentFrom2;
        // Get grandparents (from)
        const grandparentFrom = $from.node($from.depth - 1);
        const greatGrandparentFrom = $from.node($from.depth - 2);
        // Get grandparents (to)
        const grandparentTo = $to.node($from.depth - 1);
        const greatGrandparentTo = $to.node($from.depth - 2);
        if (greatGrandparentTo.eq(greatGrandparentFrom) && listParents.includes(greatGrandparentFrom.type.name) && // Selection covers entire list
        (_greatGrandparentFrom = greatGrandparentFrom.firstChild) !== null && _greatGrandparentFrom !== void 0 && _greatGrandparentFrom.eq(grandparentFrom) && (_greatGrandparentFrom2 = greatGrandparentFrom.lastChild) !== null && _greatGrandparentFrom2 !== void 0 && _greatGrandparentFrom2.eq(grandparentTo)) return true;
    }
    return false;
};
const $8d45acd5c855567f$export$4fd509032ef7561b = (selection)=>{
    const { from: from, to: to } = selection;
    if (from === to) return (0, $2sVuK.Fragment).empty;
    let frag = (0, $2sVuK.Fragment).empty;
    const sortedRanges = [
        ...selection.ranges.slice()
    ].sort((a, b)=>a.$from.pos - b.$from.pos);
    for (const range of sortedRanges){
        const { $from: $from, $to: $to } = range;
        const to = $to.pos;
        const depth = // If we're in a text selection, and share the parent node across the anchor->head
        // make the depth the parent node
        selection instanceof (0, $j3TCs.TextSelection) && $from.parent.eq($to.parent) ? Math.max(0, $from.sharedDepth(to) - 1) : $from.sharedDepth(to);
        let finalDepth = depth;
        // For block-level lists (non-nested) specifically use the selection
        if ($8d45acd5c855567f$export$8701765a689d47ab($from, $to)) finalDepth = $from.depth - $8d45acd5c855567f$var$listDepth;
        const start = $from.start(finalDepth);
        const node = $from.node(finalDepth);
        const content = node.content.cut($from.pos - start, $to.pos - start);
        frag = frag.append(content);
    }
    return frag;
};
const $8d45acd5c855567f$export$dae3dcae007fe30 = (selection)=>{
    if (!selection || selection.empty) return null;
    const slice = $8d45acd5c855567f$export$4fd509032ef7561b(selection);
    const content = slice.content;
    const fragment = [];
    content.forEach((node)=>{
        fragment.push((0, $8QDVw.nodeToJSON)(node));
    });
    return fragment;
};
const $8d45acd5c855567f$export$9ce8378d786d4035 = (selection)=>{
    if (!selection) return null;
    if (selection instanceof (0, $j3TCs.NodeSelection)) return [
        selection.node.attrs.localId
    ];
    else if (selection.empty) return [
        selection.$from.parent.attrs.localId
    ];
    const slice = $8d45acd5c855567f$export$4fd509032ef7561b(selection);
    const content = slice.content;
    const ids = [];
    content.forEach((node)=>{
        var _node$attrs;
        const localId = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId;
        if (localId) ids.push(localId);
    });
    return ids;
};

});







parcelRegister("lgYwi", function(module, exports) {
$parcel$export(module.exports, "AnnotationsContextWrapper", () => $442bcbd2a5a4beaa$export$787af8a111ff3c03);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $hoMpk = parcelRequire("hoMpk");

var $2AO1N = parcelRequire("2AO1N");

var $6Mu5M = parcelRequire("6Mu5M");
const $442bcbd2a5a4beaa$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $8P7DW.useContext)((0, $hoMpk.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2AO1N.RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Mu5M.SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};

});
parcelRegister("2AO1N", function(module, exports) {
$parcel$export(module.exports, "RangeValidator", () => $9463adf8342be5c1$export$6d8376a902cb8aa7);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $4HJti = parcelRequire("4HJti");

var $fscXt = parcelRequire("fscXt");

var $gSaqt = parcelRequire("gSaqt");

var $7F7AO = parcelRequire("7F7AO");
const $9463adf8342be5c1$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $8P7DW.useContext)((0, $fscXt.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $gSaqt.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $gSaqt.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $7F7AO.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4HJti.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$9463adf8342be5c1$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("4HJti", function(module, exports) {
$parcel$export(module.exports, "Mounter", () => $44973aedb439fb4e$export$2109cd350bcf6eda);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $cB1Zx = parcelRequire("cB1Zx");

var $FzUDO = parcelRequire("FzUDO");

var $1s1Af = parcelRequire("1s1Af");

var $eguiP = parcelRequire("eguiP");

var $fscXt = parcelRequire("fscXt");

var $gSaqt = parcelRequire("gSaqt");
const $44973aedb439fb4e$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $gSaqt.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $gSaqt.useAnnotationRangeState)();
    const actions = (0, $8P7DW.useContext)((0, $fscXt.RendererContext));
    const onCreateCallback = (0, $8P7DW.useCallback)((annotationId)=>{
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $eguiP.ACTION).INSERTED,
            actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $eguiP.EVENT_TYPE).TRACK
        }).fire((0, $1s1Af.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $8P7DW.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $8P7DW.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $eguiP.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $eguiP.EVENT_TYPE).TRACK
            }).fire((0, $1s1Af.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $eguiP.ACTION).OPENED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $eguiP.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $1s1Af.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $FzUDO.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $eguiP.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $eguiP.EVENT_TYPE).TRACK
            }).fire((0, $1s1Af.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $8P7DW.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $8P7DW.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $eguiP.ACTION).CLOSED,
            actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $eguiP.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $1s1Af.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("FzUDO", function(module, exports) {
$parcel$export(module.exports, "dataAttributes", () => $614f38307d2b9ccc$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $614f38307d2b9ccc$export$e14699d956e87e73);
const $614f38307d2b9ccc$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $614f38307d2b9ccc$var$buildDataAttributesQuery = (pos)=>{
    const a = $614f38307d2b9ccc$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $614f38307d2b9ccc$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($614f38307d2b9ccc$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("gSaqt", function(module, exports) {
$parcel$export(module.exports, "AnnotationRangeProvider", () => $5886f72a5cc2b77f$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $5886f72a5cc2b77f$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $5886f72a5cc2b77f$export$708fc397e2b6f08d);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $5886f72a5cc2b77f$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $5886f72a5cc2b77f$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $5886f72a5cc2b77f$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $8P7DW.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $5886f72a5cc2b77f$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $8P7DW.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $5886f72a5cc2b77f$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $8P7DW.useReducer)($5886f72a5cc2b77f$var$reducer, $5886f72a5cc2b77f$var$initialState);
    const clearSelectionRange = (0, $8P7DW.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $8P7DW.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $8P7DW.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $8P7DW.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $8P7DW.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $8P7DW.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $8P7DW.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $8P7DW.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $8P7DW.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $8P7DW.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)($5886f72a5cc2b77f$export$145b9bb655c3d220.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($5886f72a5cc2b77f$export$efb0d1c8cbaac647.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $5886f72a5cc2b77f$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)($5886f72a5cc2b77f$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        children: children
    });
};
const $5886f72a5cc2b77f$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $8P7DW.useContext)($5886f72a5cc2b77f$export$145b9bb655c3d220);
};
const $5886f72a5cc2b77f$export$708fc397e2b6f08d = ()=>{
    return (0, $8P7DW.useContext)($5886f72a5cc2b77f$export$efb0d1c8cbaac647);
};

});


parcelRegister("7F7AO", function(module, exports) {
$parcel$export(module.exports, "AnnotationHoverContext", () => $a602f03ff54f006e$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $a602f03ff54f006e$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $a602f03ff54f006e$export$c288883964405c82);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $a602f03ff54f006e$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $8P7DW.createContext)({
    isWithinRange: false
});
const $a602f03ff54f006e$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $8P7DW.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $a602f03ff54f006e$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $8P7DW.useState)(false);
    const timeoutHandler = (0, $8P7DW.useRef)();
    const cancelTimeout = (0, $8P7DW.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $8P7DW.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $8P7DW.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $8P7DW.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)($a602f03ff54f006e$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($a602f03ff54f006e$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $a602f03ff54f006e$export$a02bfcbbbf920306 = ()=>{
    return (0, $8P7DW.useContext)($a602f03ff54f006e$var$AnnotationHoverStateContext);
};
const $a602f03ff54f006e$export$c288883964405c82 = ()=>{
    return (0, $8P7DW.useContext)($a602f03ff54f006e$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("6Mu5M", function(module, exports) {
$parcel$export(module.exports, "SelectionRangeValidator", () => $f006699b64d40549$export$74435b85e23b84d9);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6LfO3 = parcelRequire("6LfO3");

var $dfJEq = parcelRequire("dfJEq");

var $fscXt = parcelRequire("fscXt");
const $f006699b64d40549$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $8P7DW.useContext)((0, $fscXt.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $6LfO3.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dfJEq.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$f006699b64d40549$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("6LfO3", function(module, exports) {
$parcel$export(module.exports, "useUserSelectionRange", () => $42042fbc4fdd243d$export$47201332e612f5a4);

var $8P7DW = parcelRequire("8P7DW");

var $gSaqt = parcelRequire("gSaqt");

var $5Iqnl = parcelRequire("5Iqnl");

var $e3c7n = parcelRequire("e3c7n");
const $42042fbc4fdd243d$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $8P7DW.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $gSaqt.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $gSaqt.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $e3c7n.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $8P7DW.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $8P7DW.useCallback)((_event)=>{
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        selectionTimeoutRef.current = setTimeout(()=>{
            const sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            let _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $5Iqnl.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                const { startContainer: startContainer, endContainer: endContainer } = _range;
                const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    let p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        const range = document.createRange();
                        range.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, 100);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("5Iqnl", function(module, exports) {
$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $fafa54b339acda84$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $fafa54b339acda84$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("dfJEq", function(module, exports) {
$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $c3d14859c5683bc2$export$ca7741472ed8ba00);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $9e0lC = parcelRequire("9e0lC");

var $cB1Zx = parcelRequire("cB1Zx");

var $e6Qdr = parcelRequire("e6Qdr");

var $FzUDO = parcelRequire("FzUDO");

var $1s1Af = parcelRequire("1s1Af");

var $eguiP = parcelRequire("eguiP");

var $hI436 = parcelRequire("hI436");

var $fscXt = parcelRequire("fscXt");

var $e3c7n = parcelRequire("e3c7n");

var $gSaqt = parcelRequire("gSaqt");
const $c3d14859c5683bc2$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $gSaqt.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $gSaqt.useAnnotationRangeState)();
    const actions = (0, $8P7DW.useContext)((0, $fscXt.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $e3c7n.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $e3c7n.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $8P7DW.useMemo)(()=>{
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $hI436.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $8P7DW.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        // !!! at this point, the documentPosition can be the wrong position if the user select something else
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $eguiP.ACTION).INSERTED,
            actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $eguiP.EVENT_TYPE).TRACK
        }).fire((0, $1s1Af.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $8P7DW.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $8P7DW.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $eguiP.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $eguiP.EVENT_TYPE).TRACK
            }).fire((0, $1s1Af.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $eguiP.ACTION).OPENED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $eguiP.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $1s1Af.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $FzUDO.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // at this point, the documentPosition is the position that the user has selected,
        // not the selectionDraftDocumentPosition
        // because the documentPosition is not promoted to selectionDraftDocumentPosition yet
        // use platform_editor_comments_api_manager here so we can clear the code path when the flag is removed
        const positionToAnnotate = (0, $e6Qdr.fg)('platform_editor_comments_api_manager') ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $eguiP.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $eguiP.EVENT_TYPE).TRACK
            }).fire((0, $1s1Af.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $cB1Zx.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $8P7DW.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $8P7DW.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $eguiP.ACTION).CLOSED,
            actionSubject: (0, $eguiP.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $eguiP.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $1s1Af.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($9e0lC)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $cB1Zx.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $8P7DW.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("lCKum", function(module, exports) {
$parcel$export(module.exports, "useLoadAnnotations", () => $c97cd99597c6d661$export$39f7c1a861a0d41c);

var $8P7DW = parcelRequire("8P7DW");

var $izI49 = parcelRequire("izI49");

var $hoMpk = parcelRequire("hoMpk");

var $fscXt = parcelRequire("fscXt");

var $e3c7n = parcelRequire("e3c7n");
const $c97cd99597c6d661$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $8P7DW.useContext)((0, $fscXt.RendererContext));
    const providers = (0, $8P7DW.useContext)((0, $hoMpk.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $e3c7n.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $8P7DW.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $izI49.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};

});


parcelRegister("bZbgj", function(module, exports) {
$parcel$export(module.exports, "ValidationContext", () => $cacef07c02143f98$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $cacef07c02143f98$export$5b655fe45447a548);

var $8P7DW = parcelRequire("8P7DW");
const $cacef07c02143f98$export$d452675449e81987 = /*#__PURE__*/ (0, $8P7DW.createContext)(null);
const $cacef07c02143f98$export$5b655fe45447a548 = $cacef07c02143f98$export$d452675449e81987.Provider;

});


parcelRegister("jS7iR", function(module, exports) {
$parcel$export(module.exports, "default", () => $426e84a62fd0a957$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $8P7DW = parcelRequire("8P7DW");

var $94YFM = parcelRequire("94YFM");

var $lnxsR = parcelRequire("lnxsR");

var $iN6Wt = parcelRequire("iN6Wt");

var $lv6PI = parcelRequire("lv6PI");

var $9XwhB = parcelRequire("9XwhB");

var $13svG = parcelRequire("13svG");

var $2b9UX = parcelRequire("2b9UX");
function $426e84a62fd0a957$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $426e84a62fd0a957$var$containerStyles = {
    name: "hwppun",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}&:first-child > .ak-renderer-sticky-safe-center-wrapper{margin-top:0;}"
};
const $426e84a62fd0a957$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $426e84a62fd0a957$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $426e84a62fd0a957$var$MultiBodiedExtensionWrapperLegacy = ({ width: width, path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $lnxsR.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $lnxsR.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iN6Wt.calcBreakoutWidth)(layout, width) : (0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer"
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $lnxsR.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $426e84a62fd0a957$var$MultiBodiedExtensionWrapperNext = ({ path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $lnxsR.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $lnxsR.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2b9UX.calcBreakoutWidthCss)(layout) : (0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer"
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $lnxsR.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $426e84a62fd0a957$var$MultiBodiedExtension = (props)=>{
    var _extensionContext$pri;
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, content: content, marks: marks, localId: localId, rendererAppearance: rendererAppearance } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $8P7DW.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $9XwhB.useMultiBodiedExtensionContext)({
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $lv6PI.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $8Z0o8.jsx)($426e84a62fd0a957$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext === null || extensionContext === void 0 || (_extensionContext$pri = extensionContext.privateProps) === null || _extensionContext$pri === void 0 ? void 0 : _extensionContext$pri.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback(()=>{
        var _marks$find;
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find((m)=>m.type.name === 'fragment')) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $8Z0o8.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, $8Z0o8.jsx)($426e84a62fd0a957$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $8Z0o8.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $8Z0o8.jsx)($426e84a62fd0a957$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $8Z0o8.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    if ((0, $13svG.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const isTopLevel = path.length < 1;
        const useCenterWrapper = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) && (0, $13svG.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const wrapper = /*#__PURE__*/ (0, $8Z0o8.jsx)($426e84a62fd0a957$var$MultiBodiedExtensionWrapperNext, {
            layout: layout,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return /*#__PURE__*/ (0, $8Z0o8.jsx)("section", {
            css: [
                $426e84a62fd0a957$var$containerStyles,
                containerActiveFrameStyles
            ],
            "data-testid": "multiBodiedExtension--container",
            "data-multiBodiedExtension-container": true,
            "data-active-child-index": activeChildIndex,
            "data-layout": layout,
            "data-local-id": localId,
            "data-node-type": "multiBodiedExtension"
        }, useCenterWrapper ? /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $lnxsR.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $lnxsR.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper);
    }
    const isTopLevel = path.length < 1;
    const useCenterWrapper = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && (0, $13svG.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("section", {
        css: [
            $426e84a62fd0a957$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $94YFM.WidthConsumer), null, ({ width: width })=>{
        const wrapper = /*#__PURE__*/ (0, $8Z0o8.jsx)($426e84a62fd0a957$var$MultiBodiedExtensionWrapperLegacy, {
            layout: layout,
            width: width,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return useCenterWrapper ? /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $lnxsR.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $lnxsR.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper;
    }));
};
var $426e84a62fd0a957$export$2e2bcd8739ae039 = $426e84a62fd0a957$var$MultiBodiedExtension;

});
parcelRegister("lv6PI", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $65658c43d1efff0f$export$3c7139d93ecb4f1f);

var $8P7DW = parcelRequire("8P7DW");
const $65658c43d1efff0f$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            removeChild (_index) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};

});

parcelRegister("9XwhB", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $9c1160e69b193055$export$e55394818db35473);

var $8P7DW = parcelRequire("8P7DW");

var $hXXvg = parcelRequire("hXXvg");

var $37gEF = parcelRequire("37gEF");

var $6RaaD = parcelRequire("6RaaD");
const $9c1160e69b193055$export$e55394818db35473 = ({ extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>(0, $hXXvg.default)((0, $37gEF.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState();
    const providerPromise = (0, $6RaaD.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $37gEF.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>{
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};

});


parcelRegister("76Erk", function(module, exports) {
$parcel$export(module.exports, "default", () => $94d1abd8e9e9e4b4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");
const $94d1abd8e9e9e4b4$var$containerCSS = /*#__PURE__*/ (0, $8Z0o8.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $94d1abd8e9e9e4b4$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: [
            $94d1abd8e9e9e4b4$var$containerCSS
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $94d1abd8e9e9e4b4$export$2e2bcd8739ae039 = $94d1abd8e9e9e4b4$var$ExtensionFrame;

});

parcelRegister("kG7qV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c40bf85906b857f2$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $aaUQA = parcelRequire("aaUQA");

var $6HVjD = parcelRequire("6HVjD");
function $c40bf85906b857f2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $aaUQA.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $6HVjD.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});
parcelRegister("6HVjD", function(module, exports) {
$parcel$export(module.exports, "getListIndentLevel", () => $80bbe75e0d519be6$export$75aa84e85754623e);
function $80bbe75e0d519be6$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("fBnrJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ff98b8448ca43d4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $2ff98b8448ca43d4$export$41121a410ca2f650);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $lnxsR = parcelRequire("lnxsR");

var $gMd8N = parcelRequire("gMd8N");
function $2ff98b8448ca43d4$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $lnxsR.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $2ff98b8448ca43d4$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ref: (0, $gMd8N.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $lnxsR.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}

});
parcelRegister("gMd8N", function(module, exports) {
$parcel$export(module.exports, "useSelectAllTrap", () => $234a9fe58643edb7$export$98871b245ee25215);

var $eguiP = parcelRequire("eguiP");

var $8P7DW = parcelRequire("8P7DW");

var $h5yjd = parcelRequire("h5yjd");

var $1ZCK1 = parcelRequire("1ZCK1");
const $234a9fe58643edb7$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext((0, $h5yjd.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((e)=>{
        var _e$target, _e$target$matches;
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $1ZCK1.ElementSelection).fromWindow();
        const isInput = (_e$target = e.target) === null || _e$target === void 0 || (_e$target$matches = _e$target.matches) === null || _e$target$matches === void 0 ? void 0 : _e$target$matches.call(_e$target, 'input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $eguiP.EVENT_TYPE).TRACK,
                action: (0, $eguiP.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $eguiP.EVENT_TYPE).TRACK,
                action: (0, $eguiP.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useCallback((e)=>{
        var _ref$current;
        clicked.current = ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target)) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("h5yjd", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e44251feb4efea4$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
const $6e44251feb4efea4$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $6e44251feb4efea4$export$2e2bcd8739ae039 = $6e44251feb4efea4$var$AnalyticsContext;

});

parcelRegister("1ZCK1", function(module, exports) {
$parcel$export(module.exports, "ElementSelection", () => $249b1f7660f4d059$export$6e6724d89f27411);
class $249b1f7660f4d059$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            var _this$range, _this$range2;
            const startMatches = ((_this$range = this.range) === null || _this$range === void 0 ? void 0 : _this$range.compareBoundaryPoints(Range.START_TO_START, selection.range)) === 0;
            const endMatches = ((_this$range2 = this.range) === null || _this$range2 === void 0 ? void 0 : _this$range2.compareBoundaryPoints(Range.END_TO_END, selection.range)) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        var _this$range3;
        return el.contains(((_this$range3 = this.range) === null || _this$range3 === void 0 ? void 0 : _this$range3.commonAncestorContainer) ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $249b1f7660f4d059$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $249b1f7660f4d059$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("PI7zm", function(module, exports) {
$parcel$export(module.exports, "default", () => $80f782db9996fc01$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $80f782db9996fc01$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("br", {}),
            /*#__PURE__*/ (0, $gWgPx.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("br", {});
};
var $80f782db9996fc01$export$2e2bcd8739ae039 = $80f782db9996fc01$var$HardBreak;

});

parcelRegister("cYAI0", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb753f415e713246$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $9TwI7 = parcelRequire("9TwI7");

var $eguiP = parcelRequire("eguiP");

var $dojiU = parcelRequire("dojiU");

var $13svG = parcelRequire("13svG");

var $h5yjd = parcelRequire("h5yjd");

var $ou3Rg = parcelRequire("ou3Rg");

var $akFvq = parcelRequire("akFvq");

var $8Z0o8 = parcelRequire("8Z0o8");
function $bb753f415e713246$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bb753f415e713246$var$RENDERER_HEADING_WRAPPER = 'renderer-heading-wrapper';
const $bb753f415e713246$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $bb753f415e713246$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
const $bb753f415e713246$var$wrapperStyles = {
    name: "4zleql",
    styles: "display:block"
};
function $bb753f415e713246$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $h5yjd.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $8Z0o8.jsx)((0, $akFvq.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $eguiP.ACTION).CLICKED,
                    actionSubject: (0, $eguiP.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $eguiP.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $eguiP.EVENT_TYPE).UI
                });
                return (0, $ou3Rg.copyTextToClipboard)($bb753f415e713246$var$getCurrentUrlWithHash(headingId));
            },
            hideFromScreenReader: hideFromScreenReader,
            headingId: headingId
        }));
}
/**
 * Old heading structure (before a11y fix):
 * - headning anchor is rendered INSIDE the heading element
 * - A duplicate anchor is rendered in VisuallyHidden for screen readers
 * - The visible button has hideFromScreenReader={true}
 *
 */ function $bb753f415e713246$var$HeadingWithDuplicateAnchor(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $bb753f415e713246$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $9TwI7.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, $8Z0o8.jsx)(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: (0, $13svG.expValEquals)('confluence_toc_nav_a11y', 'isEnabled', true) ? -1 : undefined
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $8Z0o8.jsx)($bb753f415e713246$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: true
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $8Z0o8.jsx)($bb753f415e713246$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: true
    }))), /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $dojiU.default), {
        testId: "visually-hidden-heading-anchor"
    }, showAnchorLink && headingId && /*#__PURE__*/ (0, $8Z0o8.jsx)($bb753f415e713246$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId
    })));
}
/**
 * New heading structure (a11y fix):
 * - Heading anchor is rendered OUTSIDE the heading element in a .renderer-heading-wrapper div
 * - Uses data-level attribute for CSS styling
 * - Better accessibility: heading contains only text, button is a sibling
 */ function $bb753f415e713246$var$HeadingWithWrapper(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $bb753f415e713246$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $9TwI7.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $bb753f415e713246$var$RENDERER_HEADING_WRAPPER,
        "data-testid": $bb753f415e713246$var$RENDERER_HEADING_WRAPPER,
        "data-level": props.level,
        css: $bb753f415e713246$var$wrapperStyles
    }, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $8Z0o8.jsx)($bb753f415e713246$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: false
    }), /*#__PURE__*/ (0, $8Z0o8.jsx)(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: (0, $13svG.expValEquals)('confluence_toc_nav_a11y', 'isEnabled', true) ? -1 : undefined
    }, props.children), showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $8Z0o8.jsx)($bb753f415e713246$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: false
    }));
}
/**
 * Gated Heading component:
 * - When platform_editor_copy_link_a11y_inconsistency_fix experiment is enabled,
 *   returns HeadingWithWrapper (new a11y-improved structure)
 * - Otherwise returns HeadingWithDuplicateAnchor (old structure)
 */ function $bb753f415e713246$var$Heading({ allowHeadingAnchorLinks: allowHeadingAnchorLinks, children: children, dataAttributes: dataAttributes, headingId: headingId, invisible: invisible, level: level, localId: localId, marks: marks, nodeType: nodeType, showAnchorLink: showAnchorLink, serializer: serializer, asInline: asInline }) {
    if ((0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, $8Z0o8.jsx)($bb753f415e713246$var$HeadingWithWrapper, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)($bb753f415e713246$var$HeadingWithDuplicateAnchor, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
}
var $bb753f415e713246$export$2e2bcd8739ae039 = $bb753f415e713246$var$Heading;

});
parcelRegister("ou3Rg", function(module, exports) {
$parcel$export(module.exports, "copyTextToClipboard", () => $849a51b89c443d9a$export$f980440e1ab4537d);
const $849a51b89c443d9a$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});

parcelRegister("akFvq", function(module, exports) {
$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $8a0cf7b9f638ce82$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $8a0cf7b9f638ce82$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $3SD6z = parcelRequire("3SD6z");

var $7cjnx = parcelRequire("7cjnx");

var $13svG = parcelRequire("13svG");

var $ea6bZ = parcelRequire("ea6bZ");

var $kvuIc = parcelRequire("kvuIc");
function $8a0cf7b9f638ce82$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8a0cf7b9f638ce82$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $8a0cf7b9f638ce82$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $8a0cf7b9f638ce82$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $8a0cf7b9f638ce82$var$copyAnchorButtonStyles = {
    name: "x4slh0",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #292A2E);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $8a0cf7b9f638ce82$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).PureComponent {
    constructor(props){
        super(props), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $kvuIc.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $kvuIc.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch  {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            const tooltip = (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? (0, $kvuIc.headingAnchorLinkMessages).copyLinkToClipboard : (0, $kvuIc.headingAnchorLinkMessages).copyHeadingLinkToClipboard;
            this.setTooltipState(tooltip);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            const labelledBy = (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? this.props.intl.formatMessage((0, $kvuIc.headingAnchorLinkMessages).copyHeadingLinkLabelledBy, {
                copyLink: this.copyLinkId,
                heading: headingId
            }) : headingId;
            const tabIndex = (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? 0 : hideFromScreenReader ? undefined : -1;
            return /*#__PURE__*/ (0, $8Z0o8.jsx)("button", {
                "data-testid": "anchor-button",
                id: this.copyLinkId,
                css: $8a0cf7b9f638ce82$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onBlur: (0, $13svG.expValEquals)('platform_editor_a11y_eslint_fix', 'isEnabled', true) ? this.resetMessage : undefined,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7cjnx))), {
                label: this.getCopyAriaLabel(),
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        };
        this.copyLinkId = (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? crypto.randomUUID() : undefined;
    }
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $ea6bZ.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $8a0cf7b9f638ce82$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage,
            isScreenReaderAnnouncementDisabled: (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
}
var $8a0cf7b9f638ce82$export$2e2bcd8739ae039 = (0, $3SD6z.default)($8a0cf7b9f638ce82$var$HeadingAnchor);

});
parcelRegister("7cjnx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53d8af922e5e8e20$var$_react = $53d8af922e5e8e20$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $53d8af922e5e8e20$var$_baseNew = $53d8af922e5e8e20$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $53d8af922e5e8e20$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53d8af922e5e8e20$var$LinkIcon = (props)=>/*#__PURE__*/ $53d8af922e5e8e20$var$_react.default.createElement($53d8af922e5e8e20$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$53d8af922e5e8e20$var$LinkIcon.displayName = 'LinkIcon';
var $53d8af922e5e8e20$var$_default = module.exports.default = $53d8af922e5e8e20$var$LinkIcon;

});

parcelRegister("kvuIc", function(module, exports) {
$parcel$export(module.exports, "headingAnchorLinkMessages", () => $efaf223d36d70626$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $efaf223d36d70626$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $efaf223d36d70626$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6K2Gm = parcelRequire("6K2Gm");
const $efaf223d36d70626$export$74bada844422036d = (0, $6K2Gm.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copyLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLinkTo',
        defaultMessage: 'Copy link to',
        description: 'Copy heading link to clipboard. Will be used as part of a 2-part a11y label ("Copy link to", "{heading text}")'
    },
    copyHeadingLinkLabelledBy: {
        id: 'fabric.editor.headingLink.copyAnchorLinkLabelledBy',
        defaultMessage: '{copyLink} {heading}',
        description: 'The order in which to read the parts of the aria-labelledby for the copy heading link button depending on the grammar of the language. {copyLink} will be replaced with the "Copy link to" text and {heading} will be replaced with the actual heading text'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'Aria label for the copy link button displayed next to a heading. Used by screen readers to describe the button that copies the heading anchor link to the clipboard.'
    }
});
const $efaf223d36d70626$export$c79ebc36348824d1 = (0, $6K2Gm.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $efaf223d36d70626$export$9f52c375a6ef34fc = (0, $6K2Gm.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});



parcelRegister("fLfF1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5382a715f2d167c1$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $51HbM = parcelRequire("51HbM");
const $5382a715f2d167c1$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $51HbM.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(result)) return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $5382a715f2d167c1$export$2e2bcd8739ae039 = $5382a715f2d167c1$var$InlineExtension;

});

parcelRegister("3T25d", function(module, exports) {
$parcel$export(module.exports, "default", () => $92e220caa805f9ff$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $h2boN = parcelRequire("h2boN");
function $92e220caa805f9ff$export$2e2bcd8739ae039(props) {
    var _props$content;
    return (0, $h2boN.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: "layout-section-container",
        "data-local-id": props.localId,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": props === null || props === void 0 || (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-layout-section": true,
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("8ts7z", function(module, exports) {
$parcel$export(module.exports, "default", () => $b44a8589afbbf992$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $94YFM = parcelRequire("94YFM");

var $e6Qdr = parcelRequire("e6Qdr");
function $b44a8589afbbf992$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $b44a8589afbbf992$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $b44a8589afbbf992$var$multipleWrappedImagesStyle = {
    name: "y2yz5o",
    styles: "& [class*=\"image-wrap-\"] + [class*=\"image-wrap-\"], & [class*=\"image-wrap-\"]:has( + [class*=\"image-wrap-\"]){margin-top:0;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $b44a8589afbbf992$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
function $b44a8589afbbf992$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        },
        css: (0, $e6Qdr.fg)('platform_editor_fix_media_in_renderer') && $b44a8589afbbf992$var$multipleWrappedImagesStyle
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $94YFM.WidthProvider), null, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: [
            $b44a8589afbbf992$var$clearNextSiblingMarginTopStyle,
            $b44a8589afbbf992$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
}

});

parcelRegister("8XiNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d38208ec2e7394e$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $3d38208ec2e7394e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("hCvjx", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b395799e3709035$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $2RnbZ = parcelRequire("2RnbZ");
const $1b395799e3709035$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2RnbZ.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $1b395799e3709035$export$2e2bcd8739ae039 = $1b395799e3709035$var$RenderCaption;

});
parcelRegister("2RnbZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a1168564e6ae855$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $3SD6z = parcelRequire("3SD6z");

var $6Hfjm = parcelRequire("6Hfjm");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $1hsS8 = parcelRequire("1hsS8");
function $4a1168564e6ae855$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a1168564e6ae855$var$captionWrapperStyle = {
    name: "4iruax",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #505258)"
};
const $4a1168564e6ae855$var$placeholderStyle = (0, $37U6z.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $4a1168564e6ae855$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $4a1168564e6ae855$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $6Hfjm.default), {
            xcss: $4a1168564e6ae855$var$placeholderStyle
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $7zDtY.default), null, formatMessage((0, $1hsS8.messages).placeholder))) : null, children);
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $4a1168564e6ae855$var$_default_1 = (0, $3SD6z.default)($4a1168564e6ae855$export$f7feb87190a94c76);
var $4a1168564e6ae855$export$2e2bcd8739ae039 = $4a1168564e6ae855$var$_default_1;

});
parcelRegister("1hsS8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c00aa0857dfe0c6a$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $c00aa0857dfe0c6a$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("41PEx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f82e81c40594f813$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $e5Nys = parcelRequire("e5Nys");

var $kQ9Np = parcelRequire("kQ9Np");

var $cFjDv = parcelRequire("cFjDv");

var $6HVjD = parcelRequire("6HVjD");
function $f82e81c40594f813$export$2e2bcd8739ae039(props) {
    var _props$content;
    const extraProps = {};
    const itemCounterDigitsSize = (0, $cFjDv.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props === null || props === void 0 || (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $kQ9Np.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $cFjDv.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $e5Nys.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $6HVjD.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});
parcelRegister("kQ9Np", function(module, exports) {
$parcel$export(module.exports, "listItemCounterPadding", () => $c6a7a6bb1b257d9d$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $c6a7a6bb1b257d9d$export$6d31fdb1d74cee3e);
const $c6a7a6bb1b257d9d$export$bafd6beec0797f87 = 24;
var $c6a7a6bb1b257d9d$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($c6a7a6bb1b257d9d$var$CSS_VAR_NAMES || {});
const $c6a7a6bb1b257d9d$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $c6a7a6bb1b257d9d$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $c6a7a6bb1b257d9d$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $c6a7a6bb1b257d9d$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $c6a7a6bb1b257d9d$var$stringifyStyle(style);
    return style;
}

});

parcelRegister("cFjDv", function(module, exports) {
$parcel$export(module.exports, "resolveOrder", () => $cf153a3183ab95fb$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $cf153a3183ab95fb$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $cf153a3183ab95fb$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $cf153a3183ab95fb$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $cf153a3183ab95fb$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $cf153a3183ab95fb$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $cf153a3183ab95fb$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $cf153a3183ab95fb$export$8ef94ae42a3729bd = 1;
const $cf153a3183ab95fb$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $cf153a3183ab95fb$export$cbefb5b89ef0719f = (orderedListNode)=>{
    var _orderedListNode$attr;
    const order = orderedListNode === null || orderedListNode === void 0 || (_orderedListNode$attr = orderedListNode.attrs) === null || _orderedListNode$attr === void 0 ? void 0 : _orderedListNode$attr.order;
    return $cf153a3183ab95fb$export$d445360e2a3c026b(order) ?? $cf153a3183ab95fb$export$8ef94ae42a3729bd;
};
const $cf153a3183ab95fb$export$320582fc14ba1e0f = (options)=>{
    var _String;
    const order = $cf153a3183ab95fb$export$d445360e2a3c026b(options.order) ?? $cf153a3183ab95fb$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return (_String = String(largestCounter)) === null || _String === void 0 || (_String = _String.split('.')) === null || _String === void 0 || (_String = _String[0]) === null || _String === void 0 ? void 0 : _String.length;
};
function $cf153a3183ab95fb$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $cf153a3183ab95fb$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $cf153a3183ab95fb$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $cf153a3183ab95fb$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("bh79x", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa4975d762283283$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $eAuVE = parcelRequire("eAuVE");
function $aa4975d762283283$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes, localId: localId, asInline: asInline }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $gWgPx.jsx)("p", {
        ...dataAttributes,
        "data-local-id": localId,
        "data-as-inline": asInline,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eAuVE.default), {
            children: children
        })
    }));
}

});
parcelRegister("eAuVE", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd3b0b6887f85885$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
function $cd3b0b6887f85885$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: "\xa0"
    });
    return children;
}

});


parcelRegister("6BPbg", function(module, exports) {
$parcel$export(module.exports, "default", () => $266321a65dcce581$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $266321a65dcce581$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {});
}

});

parcelRegister("jE5xs", function(module, exports) {
$parcel$export(module.exports, "default", () => $332fc3d068a67e4f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $332fc3d068a67e4f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("luM3o", function(module, exports) {
$parcel$export(module.exports, "isTableResizingEnabled", () => $0df67dbd4c60f071$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $0df67dbd4c60f071$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $0df67dbd4c60f071$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $hxMBA = parcelRequire("hxMBA");

var $3kPye = parcelRequire("3kPye");

var $4TACV = parcelRequire("4TACV");
var $94YFM = parcelRequire("94YFM");

var $e6Qdr = parcelRequire("e6Qdr");

var $ePcZ6 = parcelRequire("ePcZ6");
var $XIIuu = parcelRequire("XIIuu");
var $ePT11 = parcelRequire("ePT11");

var $el3xb = parcelRequire("el3xb");

var $e7vUY = parcelRequire("e7vUY");

var $h8RmO = parcelRequire("h8RmO");

var $h2boN = parcelRequire("h2boN");

var $1a7CN = parcelRequire("1a7CN");

var $dpO05 = parcelRequire("dpO05");

var $4ZS1b = parcelRequire("4ZS1b");

var $gRzCP = parcelRequire("gRzCP");

var $KlxmS = parcelRequire("KlxmS");

var $iQ36n = parcelRequire("iQ36n");

var $1BFqf = parcelRequire("1BFqf");

var $eKyXT = parcelRequire("eKyXT");

var $13svG = parcelRequire("13svG");

var $gNOBJ = parcelRequire("gNOBJ");

var $8Y55V = parcelRequire("8Y55V");
const $0df67dbd4c60f071$export$eec82c0a93aa66d9 = (appearance)=>(0, $iQ36n.isFullWidthOrFullPageAppearance)(appearance) || (0, $iQ36n.isCommentAppearance)(appearance);
const $0df67dbd4c60f071$export$bdb2dadcb04aad50 = (appearance)=>(0, $iQ36n.isFullWidthOrFullPageAppearance)(appearance) && (0, $h2boN.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $0df67dbd4c60f071$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $el3xb.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $ePT11.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $XIIuu.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $0df67dbd4c60f071$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $0df67dbd4c60f071$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $0df67dbd4c60f071$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $0df67dbd4c60f071$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $0df67dbd4c60f071$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $0df67dbd4c60f071$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $dpO05.TableHeader);
    return children.every((node)=>node.type === (0, $dpO05.TableHeader));
};
/**
 * This TableWrapper component was created to make sure that the aria-label can be
 * internationalized without needing to add `intl` to the TableContainer.
 *
 * <TableWrapper wrapperRef={ref} onScroll={handleScroll} stickyHeaders={config}>
 *   <Table>...</Table>
 * </TableWrapper>
 */ const $0df67dbd4c60f071$var$TableWrapper = ({ children: children, wrapperRef: wrapperRef, onScroll: onScroll, stickyHeaders: stickyHeaders, tabIndex: tabIndex })=>{
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const isScrollableRegion = tabIndex !== undefined;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER,
        ref: wrapperRef,
        onScroll: stickyHeaders ? onScroll : undefined,
        // Adding tabIndex here because this is a scrollable container and it needs to be focusable so keyboard users can scroll it.
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
        tabIndex: tabIndex,
        role: isScrollableRegion ? 'region' : undefined,
        "aria-label": isScrollableRegion ? formatMessage((0, $3kPye.messages).tableScrollRegion) : undefined,
        children: children
    });
};
const $0df67dbd4c60f071$export$940095e914312886 = (node, children)=>{
    return $0df67dbd4c60f071$export$28daf78feed5098c(children) && node && node.firstChild && !$0df67dbd4c60f071$export$42f5658c8e0092da(node.firstChild);
};
class $0df67dbd4c60f071$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            var _this$props$stickyHea;
            this.overflowParent = (0, $gRzCP.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea = this.props.stickyHeaders) === null || _this$props$stickyHea === void 0 ? void 0 : _this$props$stickyHea.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $0df67dbd4c60f071$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $1BFqf.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) {
            var _this$props$stickyHea2;
            this.overflowParent = (0, $gRzCP.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea2 = this.props.stickyHeaders) === null || _this$props$stickyHea2 === void 0 ? void 0 : _this$props$stickyHea2.defaultScrollRootId_DO_NOT_USE);
        } else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $hxMBA.tableMarginTop) - (0, $gRzCP.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        var _this$tableRef$curren;
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $e7vUY.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const fullPageRendererWidthCSS = (0, $h2boN.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $1a7CN.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return [
                isRenderWidthValid ? Math.min((0, $e7vUY.akEditorFullWidthLayoutWidth), renderWidth) : (0, $e7vUY.akEditorFullWidthLayoutWidth),
                `min(${(0, $e7vUY.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'max' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return [
                isRenderWidthValid ? Math.min((0, $e7vUY.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $e7vUY.akEditorMaxWidthLayoutWidth),
                `min(${(0, $e7vUY.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) {
                const tableContainerWidth = (0, $h8RmO.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $h8RmO.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $e7vUY.akEditorFullWidthLayoutWidth), renderWidth) : (0, $e7vUY.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $e7vUY.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLength = isRenderWidthValid ? Math.min((0, $e7vUY.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $e7vUY.akEditorMaxWidthLayoutWidth);
        const maxWidthLineLengthCSS = `min(${(0, $e7vUY.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $iQ36n.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $iQ36n.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : (0, $iQ36n.isMaxWidthAppearance)(rendererAppearance) && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $iQ36n.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $iQ36n.isMaxWidthAppearance)(rendererAppearance) && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $h8RmO.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $iQ36n.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $iQ36n.isFullWidthAppearance)(rendererAppearance) || ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && (0, $iQ36n.isMaxWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $iQ36n.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $iQ36n.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode !== null && tableNode !== void 0 && tableNode.attrs.width && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width) !== (0, $e7vUY.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = ((tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'align-start' || (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'center') && tableNode !== null && tableNode !== void 0 && tableNode.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        const isContentModeTable = (0, $gNOBJ.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $8Y55V.isContentModeSupported)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfTable
        }) && (0, $13svG.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
        let style;
        if (fixTableSSRResizing) style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': `${renderWidth}px`
            },
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
            children: /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                children: [
                    $0df67dbd4c60f071$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && $0df67dbd4c60f071$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gRzCP.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: tableWidth,
                        layout: layout,
                        renderWidth: renderWidth,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsx)($0df67dbd4c60f071$var$TableWrapper, {
                        wrapperRef: this.wrapperRef,
                        onScroll: this.props.stickyHeaders ? this.onWrapperScrolled : undefined,
                        stickyHeaders: stickyHeaders,
                        tabIndex: this.props.tabIndex,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $KlxmS.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $0df67dbd4c60f071$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: fixTableSSRResizing ? 'none' : 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                            style: {
                                width: (_this$tableRef$curren = this.tableRef.current) === null || _this$tableRef$curren === void 0 ? void 0 : _this$tableRef$curren.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $0df67dbd4c60f071$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $gRzCP.tableStickyPadding);
            const tableTop = $0df67dbd4c60f071$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $0df67dbd4c60f071$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $0df67dbd4c60f071$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $0df67dbd4c60f071$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(children);
        const orderedChildren = (0, $ePcZ6.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gWgPx.jsx)($0df67dbd4c60f071$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $0df67dbd4c60f071$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $XIIuu.hasMergedCell)(tableNode)) return $0df67dbd4c60f071$export$100baa0f10804e6e($0df67dbd4c60f071$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $0df67dbd4c60f071$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0df67dbd4c60f071$var$TableWithShadowsAndContainerStyles = (0, $4TACV.default)((0, $eKyXT.TableProcessorWithContainerStyles), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0df67dbd4c60f071$var$TableWithShadows = (0, $4TACV.default)($0df67dbd4c60f071$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $0df67dbd4c60f071$var$TableWithWidth = (props)=>{
    if ((0, $e6Qdr.fg)('platform-ssr-table-resize')) {
        var _props$columnWidths;
        const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        ((_props$columnWidths = props.columnWidths) === null || _props$columnWidths === void 0 ? void 0 : _props$columnWidths.reduce((total, val)=>total + val, 0)) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gWgPx.jsx)($0df67dbd4c60f071$var$TableWithShadowsAndContainerStyles, {
            ...props
        });
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eKyXT.TableProcessorWithContainerStyles), {
            ...props
        });
    } else return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $94YFM.WidthConsumer), {
        children: ({ width: width })=>{
            var _props$columnWidths2;
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $1a7CN.FullPagePadding) * 2 : width;
            const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
            ((_props$columnWidths2 = props.columnWidths) === null || _props$columnWidths2 === void 0 ? void 0 : _props$columnWidths2.reduce((total, val)=>total + val, 0)) || 0;
            if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gWgPx.jsx)($0df67dbd4c60f071$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
            return /*#__PURE__*/ (0, $gWgPx.jsx)($0df67dbd4c60f071$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        }
    });
};
const $0df67dbd4c60f071$var$_default_1 = (0, $4ZS1b.withSmartCardStorage)($0df67dbd4c60f071$var$TableWithWidth);
var $0df67dbd4c60f071$export$2e2bcd8739ae039 = $0df67dbd4c60f071$var$_default_1;

});
parcelRegister("hxMBA", function(module, exports) {
$parcel$export(module.exports, "tableMarginTop", () => $c04ead1d85205d0b$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $c04ead1d85205d0b$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableCellMinWidth", () => $c04ead1d85205d0b$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $c04ead1d85205d0b$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $c04ead1d85205d0b$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $c04ead1d85205d0b$export$e56b8ca552b280f6);
$parcel$export(module.exports, "tableControlsSpacing", () => $c04ead1d85205d0b$export$880976487022eb5);
$parcel$export(module.exports, "TableSharedCssClassName", () => $c04ead1d85205d0b$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $c04ead1d85205d0b$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $c04ead1d85205d0b$export$d7ece4d8beb06815);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $1l3LJ = parcelRequire("1l3LJ");

var $e7vUY = parcelRequire("e7vUY");
var $cjVzK = parcelRequire("cjVzK");

var $e6Qdr = parcelRequire("e6Qdr");

var $13svG = parcelRequire("13svG");

var $7CWXm = parcelRequire("7CWXm");

var $96QRs = parcelRequire("96QRs");

var $7B3Ps = parcelRequire("7B3Ps");
function $c04ead1d85205d0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c04ead1d85205d0b$export$808015ab1dd6897a = 24;
const $c04ead1d85205d0b$export$afe1899c3eea9823 = 16;
const $c04ead1d85205d0b$export$910bf0d22c3d10f2 = 14;
const $c04ead1d85205d0b$export$a43e30915fab3ccf = 8;
const $c04ead1d85205d0b$export$531f77930bf508de = 48;
const $c04ead1d85205d0b$export$c60fae4049791eae = 140;
const $c04ead1d85205d0b$export$72aad729077aa0fb = 1;
const $c04ead1d85205d0b$export$e56b8ca552b280f6 = 8;
const $c04ead1d85205d0b$export$bba39e724bc39451 = 6;
const $c04ead1d85205d0b$export$e5ff276883773ffd = 8;
const $c04ead1d85205d0b$export$880976487022eb5 = $c04ead1d85205d0b$export$808015ab1dd6897a + $c04ead1d85205d0b$export$e5ff276883773ffd - $c04ead1d85205d0b$export$72aad729077aa0fb;
const $c04ead1d85205d0b$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $1l3LJ.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $1l3LJ.tablePrefixSelector)}-wrapper`,
    TABLE_NODE_WRAPPER_NO_OVERFLOW: `${(0, $1l3LJ.tablePrefixSelector)}-wrapper-no-overflow`,
    TABLE_SCROLL_INLINE_SHADOW: `${(0, $1l3LJ.tablePrefixSelector)}-scroll-inline-shadow`,
    TABLE_RIGHT_BORDER: `${(0, $1l3LJ.tablePrefixSelector)}-right-border`,
    TABLE_LEFT_BORDER: `${(0, $1l3LJ.tablePrefixSelector)}-left-border`,
    TABLE_LEFT_SHADOW: `${(0, $1l3LJ.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $1l3LJ.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $1l3LJ.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $1l3LJ.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $1l3LJ.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $1l3LJ.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $1l3LJ.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $1l3LJ.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $1l3LJ.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $1l3LJ.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $1l3LJ.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $1l3LJ.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $1l3LJ.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $1l3LJ.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $1l3LJ.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $1l3LJ.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $1l3LJ.tablePrefixSelector)}-resizer-container`,
    TABLE_VIEW_CONTENT_WRAP: 'tableView-content-wrap'
};
/* first block node has 0 top margin */ var $c04ead1d85205d0b$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $c04ead1d85205d0b$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $c04ead1d85205d0b$var$firstNodeWithNotMarginTop = ()=>(0, $e6Qdr.fg)('platform_editor_nested_dnd_styles_changes') ? $c04ead1d85205d0b$var$_ref2 : $c04ead1d85205d0b$var$_ref;
const $c04ead1d85205d0b$export$c2bf8eea75aa9302 = ()=>{
    const browser = (0, $7CWXm.getBrowserInfo)();
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return /*#__PURE__*/ (0, $8Z0o8.css)((0, $7B3Ps.tableCellBackgroundStyleOverride)(), " .", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER, ",.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_LEFT_BORDER, "{display:block;width:1px;height:calc(100% - var(--ds-space-300, 24px));background:var(--ds-background-accent-gray-subtler, #DDDEE1);position:absolute;top:var(--ds-space-300, 24px);}.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER, "{right:0;}.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_LEFT_BORDER, "{left:0;}.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_LEFT_BORDER, "[data-with-numbered-table='true']{left:", (0, $e7vUY.akEditorTableNumberColumnWidth) - 1, "px;}}.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $e7vUY.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $e6Qdr.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${$c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"};
		}` : '', ".", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $c04ead1d85205d0b$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $c04ead1d85205d0b$export$72aad729077aa0fb, "px solid var(--ds-background-accent-gray-subtler, #DDDEE1);border-left-color:transparent;border-right-color:transparent;table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, #00000000);}>tbody>tr>th,>tbody>tr>td{min-width:", $c04ead1d85205d0b$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid var(--ds-background-accent-gray-subtler, #DDDEE1);border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', " ", $c04ead1d85205d0b$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}th{background-color:var(--ds-background-accent-gray-subtlest, #F0F1F2);text-align:left;", (0, $13svG.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', "{.", (0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, #FFFFFF);:not(.", (0, $e7vUY.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, #0B120E24);}.", (0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $cjVzK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, #0515240F);}.", (0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #0515240F);}>[data-ds--code--code-block]{background-image:", (0, $cjVzK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, #0515240F)!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, #0515240F);}}}}}}");
};
const $c04ead1d85205d0b$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $e7vUY.akEditorBreakoutPadding) : 0), (0, $e7vUY.akEditorFullWidthLayoutWidth)) : (0, $e7vUY.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $e7vUY.akEditorBreakoutPadding) : 0), (0, $e7vUY.akEditorWideLayoutWidth));
            return 0, $e7vUY.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("cjVzK", function(module, exports) {
$parcel$export(module.exports, "overflowShadow", () => $adde5b71701cc47a$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");
const $adde5b71701cc47a$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $8Z0o8.css)();
};

});

parcelRegister("96QRs", function(module, exports) {
$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $8857609ae67df658$export$42659c26f026f6ea);
const $8857609ae67df658$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};

});

parcelRegister("7B3Ps", function(module, exports) {
$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $144e75997dc0b301$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $1l3LJ = parcelRequire("1l3LJ");

var $gbn6L = parcelRequire("gbn6L");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $144e75997dc0b301$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $1l3LJ.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $gbn6L.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $144e75997dc0b301$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $8Z0o8.css)($144e75997dc0b301$var$mapBackgroundColors());

});
parcelRegister("gbn6L", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $95f8f393c27f7a9f$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $95f8f393c27f7a9f$export$a270511a0e7fd61a);
// This import will be stripped on build

var $frT4m = parcelRequire("frT4m");
function $95f8f393c27f7a9f$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $95f8f393c27f7a9f$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $95f8f393c27f7a9f$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $95f8f393c27f7a9f$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $95f8f393c27f7a9f$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #669DF1)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E7F9FF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #C6EDFB)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #6CC3E0)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #DCFFF1)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #BAF3DB)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #4BCE97)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #F5E989)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FCA700)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFECEB)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFD5D2)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #F87168)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #F8EEFE)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #EED7FC)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #C97CF4)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $frT4m.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F0F1F2)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $frT4m.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #8C8F97)" // source for hex code was legacy token N60,
    }
};

});
parcelRegister("frT4m", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe87cb5899d60c87$export$2e2bcd8739ae039);


var $kQnTW = parcelRequire("kQnTW");

var $6nQJh = parcelRequire("6nQJh");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $fe87cb5899d60c87$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $kQnTW.default)[tokenId];
    let tokenValue = fallback;
    typeof $6nQJh;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $fe87cb5899d60c87$export$2e2bcd8739ae039 = $fe87cb5899d60c87$var$getTokenValue;

});




parcelRegister("ePcZ6", function(module, exports) {
$parcel$export(module.exports, "compose", () => $d390ac77ff085150$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $d390ac77ff085150$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("XIIuu", function(module, exports) {
$parcel$export(module.exports, "getColumnWidths", () => $65fe5a812a897e25$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $65fe5a812a897e25$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $65fe5a812a897e25$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $65fe5a812a897e25$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $65fe5a812a897e25$export$889a8e446452be16);
function $65fe5a812a897e25$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $65fe5a812a897e25$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
function $65fe5a812a897e25$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $65fe5a812a897e25$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $65fe5a812a897e25$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        var _resolved$sibling;
        const siblingType = (_resolved$sibling = resolved[sibling]) === null || _resolved$sibling === void 0 ? void 0 : _resolved$sibling.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("ePT11", function(module, exports) {
$parcel$export(module.exports, "createCompareNodes", () => $7bf64136170f55ed$export$49215374a8bec29c);

var $e6Qdr = parcelRequire("e6Qdr");

var $el3xb = parcelRequire("el3xb");
var $7bf64136170f55ed$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $7bf64136170f55ed$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $7bf64136170f55ed$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $7bf64136170f55ed$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!(stringNumber !== null && stringNumber !== void 0 && stringNumber.length)) return acc;
            const maybeANumber = $7bf64136170f55ed$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $7bf64136170f55ed$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $7bf64136170f55ed$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $7bf64136170f55ed$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
        Get Meta value from the first child if the cell is of type
          * Heading (Any cell where the text is set to a heading type)
          * Paragraph (Normal text)
       */ case 'heading':
        case 'paragraph':
            return $7bf64136170f55ed$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $7bf64136170f55ed$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $7bf64136170f55ed$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $7bf64136170f55ed$export$49215374a8bec29c = (options, order = (0, $el3xb.SortOrder).ASC)=>{
    const normalizeTextParser = $7bf64136170f55ed$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $7bf64136170f55ed$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $7bf64136170f55ed$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
        Donot switch the order (Asec or Desc) if either node is null.
        This will ensure that empty cells are always at the bottom during sorting.
      */ if (metaNodeA === null || metaNodeB === null) return $7bf64136170f55ed$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $el3xb.SortOrder).DESC ? -1 : 1) * $7bf64136170f55ed$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $7bf64136170f55ed$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if ((0, $e6Qdr.fg)('platform_editor_fix_mixed_types_column_sort')) {
        if (metaNodeA.type === 5 && metaNodeB.type === 0 || metaNodeA.type === 0 && metaNodeB.type === 5) return $7bf64136170f55ed$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    }
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $7bf64136170f55ed$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("el3xb", function(module, exports) {
$parcel$export(module.exports, "SortOrder", () => $49c51b139611a86d$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $izI49 = parcelRequire("izI49");

var $afODT = parcelRequire("afODT");

var $cfciq = parcelRequire("cfciq");
var $49c51b139611a86d$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("afODT", function(module, exports) {
$parcel$export(module.exports, "ToolbarSize", () => $668593ef78080ac5$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $668593ef78080ac5$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $668593ef78080ac5$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $668593ef78080ac5$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $668593ef78080ac5$export$501a79d885598191);
var $668593ef78080ac5$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $668593ef78080ac5$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $668593ef78080ac5$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $668593ef78080ac5$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $668593ef78080ac5$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});

parcelRegister("cfciq", function(module, exports) {
$parcel$export(module.exports, "DIRECTION", () => $164e867fd56b2931$export$9106728c49045482);
var $164e867fd56b2931$export$9106728c49045482 = /*#__PURE__*/ function(DIRECTION) {
    DIRECTION["UP"] = "up";
    DIRECTION["DOWN"] = "down";
    DIRECTION["LEFT"] = "left";
    DIRECTION["RIGHT"] = "right";
    return DIRECTION;
}({});

});



parcelRegister("h8RmO", function(module, exports) {
$parcel$export(module.exports, "layoutToWidth", () => $f7de03da9d8b3c57$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $f7de03da9d8b3c57$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $f7de03da9d8b3c57$export$3930799be057b305);

var $dqksE = parcelRequire("dqksE");

var $e7vUY = parcelRequire("e7vUY");

var $e6Qdr = parcelRequire("e6Qdr");

var $kUKmx = parcelRequire("kUKmx");

var $7FvYz = parcelRequire("7FvYz");

var $hxMBA = parcelRequire("hxMBA");

var $iN6Wt = parcelRequire("iN6Wt");
const $f7de03da9d8b3c57$var$GRID_SIZE = 8;
const $f7de03da9d8b3c57$var$NESTED_DND_GUTTER_OFFSET = 8;
const $f7de03da9d8b3c57$var$NESTED_DND_MARGIN_OFFSET = 12;
const $f7de03da9d8b3c57$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $e7vUY.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $e7vUY.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $e7vUY.akEditorFullWidthLayoutWidth)
};
const $f7de03da9d8b3c57$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    var _contextPanelPluginKe, _contextPanelPluginKe2;
    if (!pos) return;
    const node = $f7de03da9d8b3c57$export$84f6ca4f6812e69a(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    const breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    let parentWidth = $f7de03da9d8b3c57$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $e7vUY.gridMediumMaxWidth) || ((_contextPanelPluginKe = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe === void 0 ? void 0 : _contextPanelPluginKe.contents.length) > 0 && ((_contextPanelPluginKe2 = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe2 === void 0 ? void 0 : _contextPanelPluginKe2.contents[0]) !== undefined) {
                // margin between sections
                parentWidth -= (0, $e6Qdr.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $7FvYz.LAYOUT_SECTION_MARGIN) + $f7de03da9d8b3c57$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1) : ((0, $7FvYz.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $dqksE.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $e6Qdr.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $7FvYz.LAYOUT_COLUMN_PADDING) + $f7de03da9d8b3c57$var$NESTED_DND_GUTTER_OFFSET) * 2 : (0, $7FvYz.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $kUKmx.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $kUKmx.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $f7de03da9d8b3c57$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $f7de03da9d8b3c57$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $f7de03da9d8b3c57$var$GRID_SIZE;
            // padding left
            parentWidth -= $f7de03da9d8b3c57$var$GRID_SIZE * 4 - $f7de03da9d8b3c57$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $hxMBA.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $f7de03da9d8b3c57$export$84f6ca4f6812e69a = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $dqksE.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader,
        ...(0, $e6Qdr.fg)('platform_synced_block_patch_8') ? [
            state.schema.nodes.bodiedSyncBlock
        ] : []
    ]);
    return parent ? parent.node : null;
};
const $f7de03da9d8b3c57$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled, breakoutWidth)=>{
    if (breakoutWidth) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // container width minus breakout padding
    // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $e7vUY.akEditorGutterPaddingDynamic)() * 2 + (0, $e7vUY.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $e7vUY.akEditorFullWidthLayoutWidth)) : (0, $iN6Wt.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $f7de03da9d8b3c57$export$3930799be057b305 = (node)=>{
    if (node !== null && node !== void 0 && node.attrs.width) return node.attrs.width;
    return $f7de03da9d8b3c57$export$9b77d38feba5446[node === null || node === void 0 ? void 0 : node.attrs.layout] || (0, $e7vUY.akEditorDefaultLayoutWidth);
};
const $f7de03da9d8b3c57$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $f7de03da9d8b3c57$export$3930799be057b305(node) - offset;
    return $f7de03da9d8b3c57$export$3930799be057b305(node);
};

});
parcelRegister("kUKmx", function(module, exports) {
$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $400608beceebe688$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $400608beceebe688$export$91624ec52c59c24c);
const $400608beceebe688$export$f5ecdce4c60ff98b = 8;
const $400608beceebe688$export$5ac5087fe1217160 = $400608beceebe688$export$f5ecdce4c60ff98b * 2;
const $400608beceebe688$export$91624ec52c59c24c = 12;

});

parcelRegister("7FvYz", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $f7e48abf2ffcabb3$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $f7e48abf2ffcabb3$export$a1bb91aa2d5fcce8);
const $f7e48abf2ffcabb3$export$cd04f19842abff0 = 8;
const $f7e48abf2ffcabb3$export$a1bb91aa2d5fcce8 = $f7e48abf2ffcabb3$export$cd04f19842abff0 * 1.5;
const $f7e48abf2ffcabb3$export$e5ee675b2c7e739b = 50;

});


parcelRegister("1a7CN", function(module, exports) {
$parcel$export(module.exports, "FullPagePadding", () => $5840d9bdeaf96c6f$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $5840d9bdeaf96c6f$export$74b525449cc7cbd1);
const $5840d9bdeaf96c6f$export$12fd658e5eef0d79 = 32;
const $5840d9bdeaf96c6f$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

});

parcelRegister("dpO05", function(module, exports) {
$parcel$export(module.exports, "TableHeader", () => $edaae53112752147$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $edaae53112752147$export$1e4baea7053fc0e3);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $l0Qcj = parcelRequire("l0Qcj");
var $1l3LJ = parcelRequire("1l3LJ");

var $kHnjK = parcelRequire("kHnjK");

var $el3xb = parcelRequire("el3xb");

var $gbn6L = parcelRequire("gbn6L");

var $fj4tZ = parcelRequire("fj4tZ");

var $jS5mX = parcelRequire("jS5mX");

var $eguiP = parcelRequire("eguiP");

var $lnxsR = parcelRequire("lnxsR");

var $k7INq = parcelRequire("k7INq");

var $kvuIc = parcelRequire("kvuIc");
const $edaae53112752147$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $edaae53112752147$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $el3xb.SortOrder).NO_ORDER:
            return (0, $el3xb.SortOrder).ASC;
        case (0, $el3xb.SortOrder).ASC:
            return (0, $el3xb.SortOrder).DESC;
        case (0, $el3xb.SortOrder).DESC:
            return (0, $el3xb.SortOrder).NO_ORDER;
    }
    return (0, $el3xb.SortOrder).NO_ORDER;
};
const $edaae53112752147$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $kvuIc.tableCellMessages);
    switch(currentSortOrder){
        case (0, $el3xb.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $el3xb.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $el3xb.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $edaae53112752147$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $edaae53112752147$var$cssVariablePattern = /^var\(--.*\)$/;
const $edaae53112752147$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $gbn6L.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $edaae53112752147$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $l0Qcj.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $edaae53112752147$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $kHnjK.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $1l3LJ.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, $gWgPx.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $edaae53112752147$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$edaae53112752147$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $edaae53112752147$var$TH = $edaae53112752147$var$getWithCellProps('th');
const $edaae53112752147$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $k7INq.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $el3xb.SortOrder).NO_ORDER ? (0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gWgPx.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $gWgPx.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $edaae53112752147$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                className: (0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $gWgPx.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fj4tZ.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$edaae53112752147$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $edaae53112752147$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $eguiP.ACTION).SORT_COLUMN,
                    actionSubject: (0, $eguiP.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $jS5mX.PLATFORM).WEB,
                        mode: (0, $jS5mX.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $eguiP.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $eguiP.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $jS5mX.PLATFORM).WEB,
                    mode: (0, $jS5mX.MODE).RENDERER
                },
                eventType: (0, $eguiP.EVENT_TYPE).TRACK
            });
        }
    };
};
const $edaae53112752147$export$f850895b287ef28e = $edaae53112752147$export$cfca40ca5c56a38e($edaae53112752147$var$TH);
const $edaae53112752147$var$TD = $edaae53112752147$var$getWithCellProps('td');
const $edaae53112752147$export$1e4baea7053fc0e3 = $edaae53112752147$var$TD;

});
parcelRegister("fj4tZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $75e38c85cbb6fb92$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $3SD6z = parcelRequire("3SD6z");

var $ea6bZ = parcelRequire("ea6bZ");

var $el3xb = parcelRequire("el3xb");

var $d6Hb9 = parcelRequire("d6Hb9");

var $lNXJy = parcelRequire("lNXJy");
function $75e38c85cbb6fb92$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $75e38c85cbb6fb92$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $75e38c85cbb6fb92$var$buttonStyles = /*#__PURE__*/ (0, $8Z0o8.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:var(--ds-border-width-selected, 2px) solid var(--ds-border, #0B120E24);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F0F1F2);}&:active{background-color:var(--ds-surface-overlay-pressed, #DDDEE1);}&.", (0, $d6Hb9.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $75e38c85cbb6fb92$var$iconWrapperStyles = /*#__PURE__*/ (0, $8Z0o8.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $d6Hb9.SORTABLE_COLUMN_ICON_CLASSNAME), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $75e38c85cbb6fb92$var$iconStyles = {
    name: "3kmdk1",
    styles: "height:100%;width:2px;border-radius:var(--ds-radius-full, 9999px);background:var(--ds-icon, #292A2E);user-select:none;&::before, &::after{background:var(--ds-icon, #292A2E);content:'';height:2px;width:6px;position:absolute;border-radius:var(--ds-radius-full, 9999px);}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $75e38c85cbb6fb92$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $el3xb.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $d6Hb9.SORTABLE_COLUMN_ICON_CLASSNAME)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $el3xb.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $el3xb.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $75e38c85cbb6fb92$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $lNXJy.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $el3xb.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $el3xb.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $el3xb.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $75e38c85cbb6fb92$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $lNXJy.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $el3xb.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $el3xb.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $el3xb.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $75e38c85cbb6fb92$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $d6Hb9.SORTABLE_COLUMN_ICON_CLASSNAME)} ${sortOrdered !== (0, $el3xb.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $d6Hb9.SORTABLE_COLUMN_ICON_CLASSNAME}__not-allowed `}`;
    const content = $75e38c85cbb6fb92$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $75e38c85cbb6fb92$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $ea6bZ.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $75e38c85cbb6fb92$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $75e38c85cbb6fb92$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $75e38c85cbb6fb92$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: [
            $75e38c85cbb6fb92$var$iconStyles
        ]
    }))));
};
const $75e38c85cbb6fb92$var$_default_1 = (0, $3SD6z.default)($75e38c85cbb6fb92$var$SortingIcon);
var $75e38c85cbb6fb92$export$2e2bcd8739ae039 = $75e38c85cbb6fb92$var$_default_1;

});
parcelRegister("d6Hb9", function(module, exports) {
$parcel$export(module.exports, "SORTABLE_COLUMN_ICON_CLASSNAME", () => $6b92300b677c2e4c$export$bd4f24d8b1e86b23);
const $6b92300b677c2e4c$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

});

parcelRegister("lNXJy", function(module, exports) {
$parcel$export(module.exports, "sortingIconMessages", () => $49f60673f7e297f8$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $49f60673f7e297f8$export$f142573f51a67577);

var $6K2Gm = parcelRequire("6K2Gm");
const $49f60673f7e297f8$export$458c50917513cd1a = (0, $6K2Gm.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $49f60673f7e297f8$export$f142573f51a67577 = (0, $6K2Gm.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("4ZS1b", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $f8591743a1eaf644$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $f8591743a1eaf644$export$65e2d5a272a382b0);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const $f8591743a1eaf644$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(new Map());
const $f8591743a1eaf644$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)($f8591743a1eaf644$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $f8591743a1eaf644$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
        render() {
            return /*#__PURE__*/ (0, $gWgPx.jsx)($f8591743a1eaf644$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $gWgPx.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};

});

parcelRegister("gRzCP", function(module, exports) {
$parcel$export(module.exports, "tableStickyPadding", () => $6c92e2b1d0ad005d$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $6c92e2b1d0ad005d$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $6c92e2b1d0ad005d$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $hxMBA = parcelRequire("hxMBA");

var $e7vUY = parcelRequire("e7vUY");

var $KlxmS = parcelRequire("KlxmS");

var $4lgyR = parcelRequire("4lgyR");
function $6c92e2b1d0ad005d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6c92e2b1d0ad005d$export$3de6413b528017ca = 8;
const $6c92e2b1d0ad005d$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $6c92e2b1d0ad005d$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, #FFFFFF)"
        }
    },
    borderTop: `${$6c92e2b1d0ad005d$export$3de6413b528017ca}px solid ${"var(--ds-surface, #FFFFFF)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxShadow: `0 6px 4px -4px ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $6c92e2b1d0ad005d$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $e7vUY.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $6c92e2b1d0ad005d$var$fixedTableDivStaticStyles,
            $6c92e2b1d0ad005d$var$modeSpecficStyles === null || $6c92e2b1d0ad005d$var$modeSpecficStyles === void 0 ? void 0 : $6c92e2b1d0ad005d$var$modeSpecficStyles[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: typeof top === 'number' ? `${top}px` : undefined
        }
    }, props.children);
};
const $6c92e2b1d0ad005d$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $8Z0o8.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $8Z0o8.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)($6c92e2b1d0ad005d$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $KlxmS.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $4lgyR.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $6c92e2b1d0ad005d$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $6c92e2b1d0ad005d$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $6c92e2b1d0ad005d$export$e97bc6692974bd0b($6c92e2b1d0ad005d$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    addEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    removeEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("KlxmS", function(module, exports) {
$parcel$export(module.exports, "Table", () => $f400ec178b674bb7$export$54ec01a60f47d33d);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6mvBW = parcelRequire("6mvBW");

var $h8RmO = parcelRequire("h8RmO");

var $e7vUY = parcelRequire("e7vUY");

var $e6Qdr = parcelRequire("e6Qdr");

var $13svG = parcelRequire("13svG");

var $gNOBJ = parcelRequire("gNOBJ");

var $8Y55V = parcelRequire("8Y55V");
const $f400ec178b674bb7$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption = false })=>{
    var _tableNode$attrs;
    let tableWidth = tableNode ? (0, $h8RmO.getTableContainerWidth)(tableNode) : (0, $e7vUY.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !((_tableNode$attrs = tableNode.attrs) !== null && _tableNode$attrs !== void 0 && _tableNode$attrs.width)) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $e6Qdr.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') {
        if ((0, $e6Qdr.fg)('platform-ssr-table-resize')) tableColumnWidths = columnWidths && (0, $6mvBW.colWidthSum)(columnWidths) ? columnWidths : undefined;
    }
    const tableLayout = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout;
    const tableDisplayMode = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.displayMode;
    const isContentMode = (0, $gNOBJ.isTableInContentMode)({
        tableNode: tableNode,
        isSupported: (0, $8Y55V.isContentModeSupported)({
            allowTableResizing: allowTableResizing,
            rendererAppearance: rendererAppearance
        }),
        isTableNested: isInsideOfBlockNode || isInsideOfTable
    }) && (0, $13svG.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("table", {
        ...(0, $e6Qdr.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        "data-initial-width-mode": isContentMode ? 'content' : undefined,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6mvBW.Colgroup), {
                columnWidths: tableColumnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing,
                allowFixedColumnWidthOption: allowFixedColumnWidthOption
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("tbody", {
                children: children
            })
        ]
    });
});

});
parcelRegister("6mvBW", function(module, exports) {
$parcel$export(module.exports, "colWidthSum", () => $eb6f21b1b693c191$export$2d9bdaa5b8cd99f0);
$parcel$export(module.exports, "Colgroup", () => $eb6f21b1b693c191$export$89efc2d0ceeaa030);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $hxMBA = parcelRequire("hxMBA");

var $94YFM = parcelRequire("94YFM");

var $e7vUY = parcelRequire("e7vUY");

var $h8RmO = parcelRequire("h8RmO");

var $3uqas = parcelRequire("3uqas");

var $jcz6F = parcelRequire("jcz6F");

var $e6Qdr = parcelRequire("e6Qdr");

var $13svG = parcelRequire("13svG");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $eb6f21b1b693c191$var$MAX_SCALING_PERCENT = 0.3;
const $eb6f21b1b693c191$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $eb6f21b1b693c191$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $eb6f21b1b693c191$var$fixColumnWidth = ({ columnWidth: columnWidth, zeroWidthColumnsCount: zeroWidthColumnsCount, scaleDownPercent: scaleDownPercent, skipMinWidth: skipMinWidth })=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) {
        const scaled = Math.floor((1 - scaleDownPercent) * columnWidth);
        return skipMinWidth ? scaled : Math.max(scaled, (0, $hxMBA.tableCellMinWidth));
    }
    const adjusted = columnWidth - (0, $hxMBA.tableCellBorderWidth);
    if (skipMinWidth) return adjusted;
    return Math.max(adjusted, zeroWidthColumnsCount ? (0, $e7vUY.akEditorTableLegacyCellMinWidth) : (0, $hxMBA.tableCellMinWidth));
};
const $eb6f21b1b693c191$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $e7vUY.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $e7vUY.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $eb6f21b1b693c191$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
/**
 * Returns the data-column available width: total width minus the fixed number column if enabled.
 */ const $eb6f21b1b693c191$var$getDataColumnWidth = (totalWidth, isNumberColumnEnabled)=>isNumberColumnEnabled ? totalWidth - (0, $e7vUY.akEditorTableNumberColumnWidth) : totalWidth;
/**
 * Scales column widths proportionally to fit within availableWidth, matching the editor's
 * scaleTableTo(): floors each column to the nearest pixel, then redistributes any rounding
 * remainder to the first column that can absorb it without going below tableCellMinWidth.
 */ const $eb6f21b1b693c191$var$scaleColumnsToWidth = (columnWidths, availableWidth)=>{
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    const scaleFactor = availableWidth / rawTotalWidth;
    const scaledWidths = columnWidths.map((colWidth)=>Math.max(Math.floor(colWidth * scaleFactor), (0, $hxMBA.tableCellMinWidth)));
    const totalScaled = scaledWidths.reduce((sum, w)=>sum + w, 0);
    const diff = availableWidth - totalScaled;
    if (diff !== 0 && Math.abs(diff) < (0, $hxMBA.tableCellMinWidth)) {
        for(let i = 0; i < scaledWidths.length; i++)if (scaledWidths[i] + diff > (0, $hxMBA.tableCellMinWidth)) {
            scaledWidths[i] += diff;
            break;
        }
    }
    return scaledWidths.map((width)=>({
            width: `${width}px`
        }));
};
/**
 * Computes column widths for tables inside sync blocks, matching the editor's scaleTableTo() exactly.
 * Returns null if the flag is off or not inside a sync block.
 *
 * For nested tables (isInsideOfTable=true, gated by platform_synced_block_patch_9), we use
 * getTableContainerWidth(tableNode) as the reference — the width the editor saved, which already
 * accounts for the parent cell's available space (colwidth minus tableCellPadding * 2).
 * This matches bodiedSyncBlock where isRendererNested=false, so renderScaleDownColgroup uses
 * getTableContainerWidth(tableNode). For syncBlock the nested renderer has isRendererNested=true,
 * which incorrectly overrides tableContainerWidth with renderWidth (the full container), causing
 * overflow by 2 * tableCellPadding (16px).
 */ const $eb6f21b1b693c191$var$renderSyncBlockColgroup = ({ isInsideOfSyncBlock: isInsideOfSyncBlock, isInsideOfTable: isInsideOfTable, tableNode: tableNode, columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidthProp, contextWidth: contextWidth })=>{
    if (!isInsideOfSyncBlock || !(0, $e6Qdr.fg)('platform_synced_block_patch_9')) return null;
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    if (isInsideOfTable) return null;
    // SSR / first render before WidthContext measures. Output % of original ADF proportions so
    // columns are stable — the CSS container query (100cqw) handles actual scaling width.
    if (contextWidth <= 0 && renderWidthProp <= 0) {
        const fullTableWidth = isNumberColumnEnabled ? rawTotalWidth + (0, $e7vUY.akEditorTableNumberColumnWidth) : rawTotalWidth;
        return columnWidths.map((colWidth)=>({
                width: `${colWidth / fullTableWidth * 100}%`
            }));
    }
    // contextWidth measures the sync block content area. Subtract 2 to match the editor's
    // getParentNodeWidth() border offset. Fall back to renderWidthProp for the non-CSS path.
    const effectiveRenderWidth = contextWidth > 0 ? contextWidth - 2 : renderWidthProp;
    const availableWidth = $eb6f21b1b693c191$var$getDataColumnWidth(effectiveRenderWidth, isNumberColumnEnabled);
    return $eb6f21b1b693c191$var$scaleColumnsToWidth(columnWidths, availableWidth);
};
const $eb6f21b1b693c191$var$renderScaleDownColgroup = (props)=>{
    var _props$tableNode;
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, isInsideOfSyncBlock: isInsideOfSyncBlock } = props;
    const skipMinWidth = (0, $e6Qdr.fg)('platform_synced_block_patch_9') && !!(isInsideOfTable && isInsideOfSyncBlock);
    if (!columnWidths || columnWidths.every((width)=>width === 0) && (0, $e6Qdr.fg)('platform_editor_numbered_column_in_include')) return [];
    const tableColumnResized = $eb6f21b1b693c191$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) || isRendererNested && (!(0, $e6Qdr.fg)('platform_fix_nested_num_column_scaling') || !isNumberColumnEnabled) ? renderWidth : (0, $h8RmO.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $e7vUY.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $eb6f21b1b693c191$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $e7vUY.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $e7vUY.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $hxMBA.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $hxMBA.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $e7vUY.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $e7vUY.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && ((_props$tableNode = props.tableNode) === null || _props$tableNode === void 0 ? void 0 : _props$tableNode.attrs.displayMode) === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $eb6f21b1b693c191$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $eb6f21b1b693c191$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $e7vUY.akEditorTableLegacyCellMinWidth) ? (0, $e7vUY.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width);
        scaleDownPercent = $eb6f21b1b693c191$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: (0, $e6Qdr.fg)('platform-ssr-table-resize') ? maxScalingPercent : shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0)) {
        const fixedColWidths = targetWidths.map((width)=>$eb6f21b1b693c191$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent,
                skipMinWidth: skipMinWidth
            }) || cellMinWidth);
        const sumFixedColumnWidths = $eb6f21b1b693c191$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map((colWidth)=>{
            const width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $e7vUY.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: `${width / sumFixedColumnWidths * 100}%`
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                const style = width ? {
                    width: `${width}px`
                } : {};
                return style;
            }
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $eb6f21b1b693c191$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent,
            skipMinWidth: skipMinWidth
        }) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $eb6f21b1b693c191$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer, nestedRendererType: nestedRendererType } = (0, $jcz6F.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const { width: contextWidth } = (0, $8P7DW.useContext)((0, $94YFM.WidthContext));
    const flags = (0, $3uqas.useFeatureFlags)();
    if (!columnWidths) return null;
    const isTableFixedColumnWidthsOptionEnabled = ((0, $e6Qdr.fg)('platform_editor_table_fixed_column_width_prop') ? props.allowFixedColumnWidthOption : flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) ?? false;
    // For referenced sync blocks, nestedRendererType='syncedBlock' is set via RendererContextProvider
    // in AKRendererWrapper. ReactSerializer is a class and cannot read React context, so we detect
    // it here in the Colgroup component via useRendererContext() instead of prop-drilling.
    const isInsideOfSyncBlock = nestedRendererType === 'syncedBlock';
    // renderSyncBlockColgroup returns null when not applicable (flag off, SSR, not a sync block),
    // in which case ?? falls back to the standard renderScaleDownColgroup path.
    const colStyles = $eb6f21b1b693c191$var$renderSyncBlockColgroup({
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isInsideOfTable: !!props.isInsideOfTable,
        tableNode: props.tableNode,
        columnWidths: columnWidths,
        isNumberColumnEnabled: !!isNumberColumnEnabled,
        renderWidth: props.renderWidth,
        contextWidth: contextWidth
    }) ?? $eb6f21b1b693c191$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || props.rendererAppearance === 'comment',
        isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)))
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $gWgPx.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $e7vUY.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $gWgPx.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};

});
parcelRegister("3uqas", function(module, exports) {
$parcel$export(module.exports, "useFeatureFlags", () => $6f59b01d45c49c21$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $jcz6F = parcelRequire("jcz6F");
const $6f59b01d45c49c21$export$90335b3ff08f335 = ()=>{
    var _useRendererContext;
    return (_useRendererContext = (0, $jcz6F.useRendererContext)()) === null || _useRendererContext === void 0 ? void 0 : _useRendererContext.featureFlags;
};

});
parcelRegister("jcz6F", function(module, exports) {
$parcel$export(module.exports, "useRendererContext", () => $6fd2f5d0f90f8f24$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $6fd2f5d0f90f8f24$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8P7DW = parcelRequire("8P7DW");
const $6fd2f5d0f90f8f24$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext({});
const $6fd2f5d0f90f8f24$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useContext($6fd2f5d0f90f8f24$var$RendererContext);
const $6fd2f5d0f90f8f24$export$ca5df47902194781 = $6fd2f5d0f90f8f24$var$RendererContext.Provider;

});



parcelRegister("gNOBJ", function(module, exports) {
$parcel$export(module.exports, "hasTableBeenResized", () => $b45a96303f02d986$export$8c07f44cea64e3c7);
$parcel$export(module.exports, "isTableInContentMode", () => $b45a96303f02d986$export$90b9840b2d94b80a);

var $akJdH = parcelRequire("akJdH");
const $b45a96303f02d986$export$b44a013e4f554514 = (tableNode)=>{
    const firstRow = tableNode.content.firstChild;
    if (!firstRow) return false;
    for(let i = 0; i < firstRow.childCount; i++){
        if (firstRow.child(i).attrs.colwidth) return true;
    }
    return false;
};
const $b45a96303f02d986$export$8c07f44cea64e3c7 = (tableNode)=>tableNode.attrs.width !== null || $b45a96303f02d986$export$b44a013e4f554514(tableNode);
const $b45a96303f02d986$export$90b9840b2d94b80a = ({ tableNode: tableNode, isSupported: isSupported, isTableNested: isTableNested })=>{
    if (!(0, $akJdH.expValEqualsNoExposure)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true)) return false;
    if (!tableNode || isTableNested) return false;
    return isSupported && !$b45a96303f02d986$export$8c07f44cea64e3c7(tableNode) && tableNode.attrs.layout === 'align-start';
};

});
parcelRegister("akJdH", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $7e2c4fb02e27cf45$export$63eebf86443a0a61);

var $04AYY = parcelRequire("04AYY");
function $7e2c4fb02e27cf45$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $04AYY.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});


parcelRegister("8Y55V", function(module, exports) {
$parcel$export(module.exports, "isContentModeSupported", () => $970e254a003c521d$export$e217d2a535d6ae45);
const $970e254a003c521d$export$e217d2a535d6ae45 = ({ allowTableResizing: allowTableResizing, rendererAppearance: rendererAppearance })=>{
    return !!allowTableResizing && (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max');
};

});


parcelRegister("4lgyR", function(module, exports) {
$parcel$export(module.exports, "recursivelyInjectProps", () => $f9bf25b1975e7dc1$export$40e12ce8e0a76b0c);

var $8P7DW = parcelRequire("8P7DW");
function $f9bf25b1975e7dc1$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement(child, {
            children: $f9bf25b1975e7dc1$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("iQ36n", function(module, exports) {
$parcel$export(module.exports, "isFullWidthAppearance", () => $e4a3f0e5989f1029$export$c0112b8340d4924b);
$parcel$export(module.exports, "isMaxWidthAppearance", () => $e4a3f0e5989f1029$export$ab050440a1241762);
$parcel$export(module.exports, "isFullPageAppearance", () => $e4a3f0e5989f1029$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $e4a3f0e5989f1029$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $e4a3f0e5989f1029$export$33331a99fac775a1);
const $e4a3f0e5989f1029$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $e4a3f0e5989f1029$export$ab050440a1241762 = (appearance)=>appearance === 'max';
const $e4a3f0e5989f1029$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $e4a3f0e5989f1029$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $e4a3f0e5989f1029$export$33331a99fac775a1 = (appearance)=>$e4a3f0e5989f1029$export$a64737a81cde10b4(appearance) || $e4a3f0e5989f1029$export$c0112b8340d4924b(appearance) || $e4a3f0e5989f1029$export$ab050440a1241762(appearance);

});

parcelRegister("1BFqf", function(module, exports) {
$parcel$export(module.exports, "TableStickyScrollbar", () => $679a8deb815c8a05$export$8c072780619cfc83);

var $hxMBA = parcelRequire("hxMBA");

var $e6Qdr = parcelRequire("e6Qdr");
class $679a8deb815c8a05$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        var _this$wrapper$parentE, _this$wrapper$parentE2;
        if (!this.wrapper) return;
        const scrollbarContainers = (_this$wrapper$parentE = this.wrapper.parentElement) === null || _this$wrapper$parentE === void 0 ? void 0 : _this$wrapper$parentE.querySelectorAll(`.${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @atlaskit/platform/valid-gate-name
        this.stickyScrollbarContainerElement = (0, $e6Qdr.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers === null || scrollbarContainers === void 0 ? void 0 : scrollbarContainers.item(scrollbarContainers.length - 1) : (_this$wrapper$parentE2 = this.wrapper.parentElement) === null || _this$wrapper$parentE2 === void 0 ? void 0 : _this$wrapper$parentE2.querySelector(`.${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        var _this$wrapper, _this$wrapper2, _this$wrapper3;
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 || (_this$wrapper = _this$wrapper.parentElement) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.getElementsByClassName((0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/platform/valid-gate-name
        this.sentinels.bottom = (0, $e6Qdr.fg)('platform_editor_querySelector_fix_table_renderer') ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        bottomSentinels === null || bottomSentinels === void 0 ? void 0 : bottomSentinels.item(bottomSentinels.length - 1) : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.parentElement) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.getElementsByClassName((0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = (_this$wrapper3 = this.wrapper) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.parentElement) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.getElementsByClassName((0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) === null || _this$wrapper3 === void 0 ? void 0 : _this$wrapper3.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        var _entry$rootBounds;
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.top) || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        var _entry$rootBounds2;
        const sentinelIsBelowScrollArea = (((_entry$rootBounds2 = entry.rootBounds) === null || _entry$rootBounds2 === void 0 ? void 0 : _entry$rootBounds2.bottom) || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});

parcelRegister("eKyXT", function(module, exports) {
$parcel$export(module.exports, "TableProcessorWithContainerStyles", () => $f1f17334d4bc21b5$export$827f89182557f335);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $hxMBA = parcelRequire("hxMBA");

var $h8RmO = parcelRequire("h8RmO");

var $1a7CN = parcelRequire("1a7CN");

var $e6Qdr = parcelRequire("e6Qdr");

var $ePcZ6 = parcelRequire("ePcZ6");
var $XIIuu = parcelRequire("XIIuu");
var $ePT11 = parcelRequire("ePT11");

var $el3xb = parcelRequire("el3xb");

var $e7vUY = parcelRequire("e7vUY");

var $h2boN = parcelRequire("h2boN");

var $dpO05 = parcelRequire("dpO05");

var $gRzCP = parcelRequire("gRzCP");

var $KlxmS = parcelRequire("KlxmS");

var $iQ36n = parcelRequire("iQ36n");

var $1BFqf = parcelRequire("1BFqf");

var $13svG = parcelRequire("13svG");

var $gNOBJ = parcelRequire("gNOBJ");

var $8Y55V = parcelRequire("8Y55V");
const $f1f17334d4bc21b5$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $f1f17334d4bc21b5$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $f1f17334d4bc21b5$export$eec82c0a93aa66d9 = (appearance)=>(0, $iQ36n.isFullWidthOrFullPageAppearance)(appearance) || (0, $iQ36n.isCommentAppearance)(appearance);
const $f1f17334d4bc21b5$export$bdb2dadcb04aad50 = (appearance)=>(0, $iQ36n.isFullWidthOrFullPageAppearance)(appearance) && (0, $h2boN.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $f1f17334d4bc21b5$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $el3xb.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $ePT11.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $XIIuu.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $f1f17334d4bc21b5$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $f1f17334d4bc21b5$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $f1f17334d4bc21b5$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $f1f17334d4bc21b5$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $f1f17334d4bc21b5$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $f1f17334d4bc21b5$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $dpO05.TableHeader);
    return children.every((node)=>node.type === (0, $dpO05.TableHeader));
};
const $f1f17334d4bc21b5$export$940095e914312886 = (node, children)=>{
    return $f1f17334d4bc21b5$export$28daf78feed5098c(children) && node && node.firstChild && !$f1f17334d4bc21b5$export$42f5658c8e0092da(node.firstChild);
};
class $f1f17334d4bc21b5$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            var _this$props$stickyHea;
            this.overflowParent = (0, $gRzCP.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea = this.props.stickyHeaders) === null || _this$props$stickyHea === void 0 ? void 0 : _this$props$stickyHea.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $f1f17334d4bc21b5$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $1BFqf.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) {
            var _this$props$stickyHea2;
            this.overflowParent = (0, $gRzCP.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea2 = this.props.stickyHeaders) === null || _this$props$stickyHea2 === void 0 ? void 0 : _this$props$stickyHea2.defaultScrollRootId_DO_NOT_USE);
        } else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $hxMBA.tableMarginTop) - (0, $gRzCP.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        var _this$tableRef$curren;
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $e7vUY.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const fullPageRendererWidthCSS = (0, $h2boN.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $1a7CN.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'max' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) return `min(${0, $e7vUY.akEditorMaxWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'full-width' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return `min(${0, $e7vUY.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $h8RmO.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $e7vUY.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLengthCSS = `min(${(0, $e7vUY.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $iQ36n.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $iQ36n.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $iQ36n.isMaxWidthAppearance)(rendererAppearance) && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $h8RmO.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $iQ36n.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $iQ36n.isFullWidthAppearance)(rendererAppearance) || (0, $iQ36n.isMaxWidthAppearance)(rendererAppearance) && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $iQ36n.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max' && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode !== null && tableNode !== void 0 && tableNode.attrs.width && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width) !== (0, $e7vUY.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = ((tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'align-start' || (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'center') && tableNode !== null && tableNode !== void 0 && tableNode.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const isContentModeTable = (0, $gNOBJ.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $8Y55V.isContentModeSupported)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfTable
        }) && (0, $13svG.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
        const style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
            children: /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.props.handleRef,
                style: style,
                children: [
                    $f1f17334d4bc21b5$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && $f1f17334d4bc21b5$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gRzCP.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        fixTableSSRResizing: true,
                        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout,
                        "data-autosize": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.__autoSize,
                        "data-table-local-id": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId,
                        "data-table-width": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $KlxmS.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $f1f17334d4bc21b5$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $e6Qdr.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: (0, $e6Qdr.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                            ...$f1f17334d4bc21b5$var$stickyContainerBaseStyles,
                            ...$f1f17334d4bc21b5$var$stickyContainerAdditionalStyles
                        } : $f1f17334d4bc21b5$var$stickyContainerBaseStyles,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                            style: {
                                width: (0, $e6Qdr.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : (_this$tableRef$curren = this.tableRef.current) === null || _this$tableRef$curren === void 0 ? void 0 : _this$tableRef$curren.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $f1f17334d4bc21b5$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.overflowParent = null, this.updatedLayout = 'custom', this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $gRzCP.tableStickyPadding);
            const tableTop = $f1f17334d4bc21b5$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $f1f17334d4bc21b5$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $f1f17334d4bc21b5$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $f1f17334d4bc21b5$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(children);
        const orderedChildren = (0, $ePcZ6.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gWgPx.jsx)($f1f17334d4bc21b5$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $f1f17334d4bc21b5$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $XIIuu.hasMergedCell)(tableNode)) return $f1f17334d4bc21b5$export$100baa0f10804e6e($f1f17334d4bc21b5$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $f1f17334d4bc21b5$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}

});


parcelRegister("1F13I", function(module, exports) {
$parcel$export(module.exports, "default", () => $a23f9fce6260150f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $ePcZ6 = parcelRequire("ePcZ6");

var $el3xb = parcelRequire("el3xb");

var $lnxsR = parcelRequire("lnxsR");
class $a23f9fce6260150f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(children);
        return /*#__PURE__*/ (0, $gWgPx.jsxs)("tr", {
            ref: innerRef,
            children: [
                this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $gWgPx.jsx)("td", {
                    className: (0, $lnxsR.RendererCssClassName).NUMBER_COLUMN,
                    children: this.props.index
                }),
                (0, $ePcZ6.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray)
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && isHeaderRow) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $el3xb.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $el3xb.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            var _this$state$colGroupW;
            if ((_this$state$colGroupW = this.state.colGroupWidths) !== null && _this$state$colGroupW !== void 0 && _this$state$colGroupW.length) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("6gwNR", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d45787c48eec4ec$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $3d45787c48eec4ec$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("3uCLE", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("jplOj"),
    $j9MRt("8Dgo8"),
    $j9MRt("51tss")
]).then(()=>parcelRequire('5Mo9c'));

});

parcelRegister("5BGa0", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("iDN8o"),
    $j9MRt("jplOj"),
    $j9MRt("8Dgo8"),
    $j9MRt("6JEBU")
]).then(()=>parcelRequire('3WlIS'));

});

parcelRegister("i8ssM", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("cIown").then(()=>parcelRequire('kmrah'));

});

parcelRegister("xLA5e", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("1SH30"),
    $j9MRt("aOWu1")
]).then(()=>parcelRequire('5F3Mn'));

});

parcelRegister("iEiTR", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("9NtSH").then(()=>parcelRequire('ikHTD'));

});

parcelRegister("c4VN8", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("3dnzF"),
    $j9MRt("5WOnT")
]).then(()=>parcelRequire('28w4D'));

});

parcelRegister("dq9UJ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("27qdO").then(()=>parcelRequire('osdSZ'));

});

parcelRegister("9Xi8r", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("h0MJI").then(()=>parcelRequire('81rcG'));

});

parcelRegister("9oJW3", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("9A5aF"),
    $j9MRt("ly6TH")
]).then(()=>parcelRequire('21TLj'));

});

parcelRegister("2kpd9", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("cR8Ud"),
    $j9MRt("01B4C"),
    $j9MRt("9A5aF"),
    $j9MRt("ly6TH"),
    $j9MRt("5B4Zl")
]).then(()=>parcelRequire('6YSeo'));

});

parcelRegister("ivJWB", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("7D3qP"),
    $j9MRt("43nk4"),
    $j9MRt("iilsR"),
    $j9MRt("3T0Nj"),
    $j9MRt("1mY5c"),
    $j9MRt("70snJ"),
    $j9MRt("c3COr"),
    $j9MRt("ffePP"),
    $j9MRt("2fbJv"),
    $j9MRt("aXPEi"),
    $j9MRt("4RNdI"),
    $j9MRt("1OBja"),
    $j9MRt("eJ4Y9"),
    $j9MRt("3qEgY"),
    $j9MRt("hMKE4"),
    $j9MRt("fTBeD"),
    $j9MRt("7Zi76"),
    $j9MRt("7FtPh"),
    $j9MRt("1z2hL"),
    $j9MRt("clTPs"),
    $j9MRt("apr9b"),
    $j9MRt("hVSoa"),
    $j9MRt("4zI0M"),
    $j9MRt("i3Qg3"),
    $j9MRt("bqSmX")
]).then(()=>parcelRequire('hVzpe'));

});

parcelRegister("1spU4", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("43nk4"),
    $j9MRt("iilsR"),
    $j9MRt("3T0Nj"),
    $j9MRt("1mY5c"),
    $j9MRt("70snJ"),
    $j9MRt("c3COr"),
    $j9MRt("ffePP"),
    $j9MRt("2fbJv"),
    $j9MRt("aXPEi"),
    $j9MRt("4RNdI"),
    $j9MRt("1OBja"),
    $j9MRt("eJ4Y9"),
    $j9MRt("3qEgY"),
    $j9MRt("hMKE4"),
    $j9MRt("fTBeD"),
    $j9MRt("7Zi76"),
    $j9MRt("7FtPh"),
    $j9MRt("1z2hL"),
    $j9MRt("clTPs"),
    $j9MRt("apr9b"),
    $j9MRt("hVSoa"),
    $j9MRt("4zI0M")
]).then(()=>parcelRequire('iPYwT'));

});

parcelRegister("6fax1", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("43nk4"),
    $j9MRt("iilsR"),
    $j9MRt("3T0Nj"),
    $j9MRt("1mY5c"),
    $j9MRt("70snJ"),
    $j9MRt("c3COr"),
    $j9MRt("ffePP"),
    $j9MRt("2fbJv"),
    $j9MRt("aXPEi"),
    $j9MRt("4RNdI"),
    $j9MRt("1OBja"),
    $j9MRt("eJ4Y9"),
    $j9MRt("3qEgY"),
    $j9MRt("hMKE4"),
    $j9MRt("fTBeD"),
    $j9MRt("7Zi76"),
    $j9MRt("7FtPh"),
    $j9MRt("1z2hL"),
    $j9MRt("clTPs"),
    $j9MRt("apr9b"),
    $j9MRt("hVSoa"),
    $j9MRt("4zI0M"),
    $j9MRt("i3Qg3")
]).then(()=>parcelRequire('lF4j8'));

});

parcelRegister("lUl3d", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("jaaXP"),
    $j9MRt("7SdQf"),
    $j9MRt("bntex"),
    $j9MRt("gDiht"),
    $j9MRt("7D3qP"),
    $j9MRt("jKTRD"),
    $j9MRt("hIBZ1"),
    $j9MRt("jVVnL"),
    $j9MRt("hMKE4"),
    $j9MRt("90yEE")
]).then(()=>parcelRequire('grvBi'));

});

parcelRegister("7Oev4", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("atrci"),
    $j9MRt("oNqfc")
]).then(()=>parcelRequire('u4nz7'));

});

parcelRegister("TTwgd", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("1TtJi"),
    $j9MRt("jaaXP"),
    $j9MRt("7SdQf"),
    $j9MRt("bntex"),
    $j9MRt("gDiht"),
    $j9MRt("jKTRD"),
    $j9MRt("hIBZ1"),
    $j9MRt("jVVnL"),
    $j9MRt("hMKE4"),
    $j9MRt("a9zEK")
]).then(()=>parcelRequire('54MBw'));

});

parcelRegister("PoLVK", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("7D3qP"),
    $j9MRt("ikh0E")
]).then(()=>parcelRequire('7a2wK'));

});

parcelRegister("cEupN", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("bvf9Q"),
    $j9MRt("2DCy9"),
    $j9MRt("ikoh2"),
    $j9MRt("3HUM9")
]).then(()=>parcelRequire('3wCuV'));

});

parcelRegister("izACV", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("k8Woc").then(()=>parcelRequire('hzFfO'));

});

parcelRegister("iIpQ7", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("5oSOM").then(()=>parcelRequire('cDVkH'));

});

parcelRegister("2wyay", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("2D97j").then(()=>parcelRequire('gNWxV'));

});


parcelRegister("ayHMh", function(module, exports) {
$parcel$export(module.exports, "default", () => $79774e13a6e6f659$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $iP5Y9 = parcelRequire("iP5Y9");
const $79774e13a6e6f659$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iP5Y9.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        children: children
    });
};
var $79774e13a6e6f659$export$2e2bcd8739ae039 = $79774e13a6e6f659$var$TextWrapper;

});
parcelRegister("iP5Y9", function(module, exports) {
$parcel$export(module.exports, "TextWithAnnotationDraft", () => $b81c48bd32c22dd0$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $gSUQo = parcelRequire("gSUQo");

var $lSEtc = parcelRequire("lSEtc");

var $g1jgl = parcelRequire("g1jgl");

var $FzUDO = parcelRequire("FzUDO");

var $aWfaT = parcelRequire("aWfaT");

var $l6I12 = parcelRequire("l6I12");

var $e3c7n = parcelRequire("e3c7n");

var $gSaqt = parcelRequire("gSaqt");
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $b81c48bd32c22dd0$var$markStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
const $b81c48bd32c22dd0$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $e3c7n.useAnnotationManagerDispatch)();
    const markRef = (0, $8P7DW.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $FzUDO.dataAttributes)(draftPosition),
        css: $b81c48bd32c22dd0$var$markStyles,
        ref: markRef
    }, children);
};
const $b81c48bd32c22dd0$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $gSUQo.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $gSUQo.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $gSUQo.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $b81c48bd32c22dd0$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $b81c48bd32c22dd0$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $aWfaT.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $8Z0o8.jsx)($b81c48bd32c22dd0$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $l6I12.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $8Z0o8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, {
            key: index
        }, (0, $l6I12.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $b81c48bd32c22dd0$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $gSaqt.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $g1jgl.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $lSEtc.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $aWfaT.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, (0, $l6I12.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $gSUQo.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $aWfaT.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $8Z0o8.jsx)($b81c48bd32c22dd0$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $l6I12.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $lSEtc.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $lSEtc.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $aWfaT.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, (0, $l6I12.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $b81c48bd32c22dd0$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, components);
};

});
parcelRegister("gSUQo", function(module, exports) {
$parcel$export(module.exports, "InsertDraftPosition", () => $4b8b598d5b1e0ad3$export$c1bd4813440b4505);
var $4b8b598d5b1e0ad3$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("lSEtc", function(module, exports) {
$parcel$export(module.exports, "findTextString", () => $7af93559629c55eb$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $7af93559629c55eb$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $7af93559629c55eb$export$1059bfc467f4f55d);

var $8P7DW = parcelRequire("8P7DW");
const $7af93559629c55eb$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($7af93559629c55eb$var$isReactElement(childNode) && childNode.props.children) result = $7af93559629c55eb$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $7af93559629c55eb$var$isReactElement(child) {
    return !!child.type;
}
const $7af93559629c55eb$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $7af93559629c55eb$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("g1jgl", function(module, exports) {
$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $b901744c70f5b753$export$b1baddbd5f289877);

var $gSUQo = parcelRequire("gSUQo");
const $b901744c70f5b753$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $gSUQo.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $gSUQo.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $gSUQo.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $gSUQo.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("aWfaT", function(module, exports) {
$parcel$export(module.exports, "segmentText", () => $e4373c0433ff451f$export$93301b6f1ff0b0c3);
function $e4373c0433ff451f$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("l6I12", function(module, exports) {
$parcel$export(module.exports, "renderTextSegments", () => $6b5175dccf10f246$export$8a20fd0614851c5f);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
function $6b5175dccf10f246$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter === null || textHighlighter === void 0 ? void 0 : textHighlighter.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            })
        }, `${segment.text}_${startPos}_${idx}`);
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}

});



parcelRegister("jBVmK", function(module, exports) {
$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $4700e6a15846ea30$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $4700e6a15846ea30$export$acb253d79d72af92);
function $4700e6a15846ea30$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $4700e6a15846ea30$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$4700e6a15846ea30$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("akJ5e", function(module, exports) {
$parcel$export(module.exports, "getMarksByOrder", () => $85ae053c42d8d2e9$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $85ae053c42d8d2e9$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $85ae053c42d8d2e9$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $85ae053c42d8d2e9$export$81b20b6c83a56bd);

var $dARvh = parcelRequire("dARvh");
var $iubfm = parcelRequire("iubfm");
var $crC8K = parcelRequire("crC8K");
var $6IEi1 = parcelRequire("6IEi1");

var $2WmUO = parcelRequire("2WmUO");

var $e6Qdr = parcelRequire("e6Qdr");

var $h2boN = parcelRequire("h2boN");
const $85ae053c42d8d2e9$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $85ae053c42d8d2e9$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $85ae053c42d8d2e9$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $85ae053c42d8d2e9$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$85ae053c42d8d2e9$export$62d5811a2955c1d8.indexOf(a.type.name) - $85ae053c42d8d2e9$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $85ae053c42d8d2e9$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $85ae053c42d8d2e9$export$fb80336a7e408cb3 = (doc, schema = (0, $2WmUO.defaultSchema), adfStage = 'final')=>{
    const node = $85ae053c42d8d2e9$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $85ae053c42d8d2e9$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $85ae053c42d8d2e9$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $iubfm.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $85ae053c42d8d2e9$export$fafd4f799ee68da0 = (content, schema = (0, $2WmUO.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$85ae053c42d8d2e9$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $85ae053c42d8d2e9$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $85ae053c42d8d2e9$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $85ae053c42d8d2e9$var$ANCHOR_LINK = /^#/;
const $85ae053c42d8d2e9$var$flattenUnknownBlockTree = (node, schema = (0, $2WmUO.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($85ae053c42d8d2e9$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$85ae053c42d8d2e9$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $85ae053c42d8d2e9$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $crC8K.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
   * Find leaf nodes and join them. If leaf nodes' parent node is the same node
   * join with a blank space, otherwise they are children of different branches, i.e.
   * we need to join them with a hardBreak node
   */ return {
        type: 'unknownBlock',
        content: $85ae053c42d8d2e9$var$flattenUnknownBlockTree(node)
    };
};
const $85ae053c42d8d2e9$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $85ae053c42d8d2e9$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $85ae053c42d8d2e9$export$81b20b6c83a56bd = (originalNode, schema = (0, $2WmUO.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $85ae053c42d8d2e9$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $85ae053c42d8d2e9$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $crC8K.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $crC8K.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $crC8K.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $crC8K.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $crC8K.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $crC8K.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $85ae053c42d8d2e9$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $85ae053c42d8d2e9$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $85ae053c42d8d2e9$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $85ae053c42d8d2e9$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $85ae053c42d8d2e9$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $6IEi1.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $dARvh.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $dARvh.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $dARvh.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $dARvh.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $dARvh.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: (attrs === null || attrs === void 0 ? void 0 : attrs.localId) || (0, $dARvh.generateUuid)(),
                        width: (attrs === null || attrs === void 0 ? void 0 : attrs.width) || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $85ae053c42d8d2e9$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (attrs && attrs.resourceId && (0, $h2boN.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $dARvh.generateUuid)()
                },
                marks: marks
            };
            else return $85ae053c42d8d2e9$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (attrs && attrs.resourceId && Array.isArray(content) && content.length > 0 && (0, $h2boN.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $dARvh.generateUuid)()
                },
                marks: marks,
                content: content
            };
            else return $85ae053c42d8d2e9$export$b9908ef75cad1e0e(node);
    }
    return $85ae053c42d8d2e9$export$b9908ef75cad1e0e(node);
};
const $85ae053c42d8d2e9$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$85ae053c42d8d2e9$var$RELATIVE_LINK.test(linkHref) && !$85ae053c42d8d2e9$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $crC8K.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($85ae053c42d8d2e9$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $85ae053c42d8d2e9$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $85ae053c42d8d2e9$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("iubfm", function(module, exports) {
$parcel$export(module.exports, "inlineNodes", () => $d319939b5a1f3be6$export$b1f729c6af6f2a6e);
// eslint-disable-next-line import/no-namespace

var $85ZkZ = parcelRequire("85ZkZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d319939b5a1f3be6$var$typedNodes = $85ZkZ;
const $d319939b5a1f3be6$export$b1f729c6af6f2a6e = new Set(Object.keys($d319939b5a1f3be6$var$typedNodes).filter((key)=>$d319939b5a1f3be6$var$typedNodes[key] && $d319939b5a1f3be6$var$typedNodes[key].group === 'inline'));

});
parcelRegister("85ZkZ", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("1zZdw")).expandWithNestedExpand);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => (parcelRequire("1zZdw")).expandWithNestedExpandLocalId);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("1zZdw")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("5UpiG")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("2I8tJ")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("2M46G")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("6IkW5")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("9qlBc")).blockquote);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("9qlBc")).extendedBlockquote);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("9qlBc")).extendedBlockquoteWithLocalId);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("aaUQA")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("aaUQA")).bulletListSelector);
$parcel$export(module.exports, "bulletListWithLocalId", () => (parcelRequire("aaUQA")).bulletListWithLocalId);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("fYiX1")).codeBlock);
$parcel$export(module.exports, "codeBlockWithLocalId", () => (parcelRequire("fYiX1")).codeBlockWithLocalId);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("fYiX1")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("9UYHL")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("4hcwN")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("bathP")).rule);
$parcel$export(module.exports, "ruleWithLocalId", () => (parcelRequire("bathP")).ruleWithLocalId);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("e5Nys")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("e5Nys")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithLocalId", () => (parcelRequire("e5Nys")).orderedListWithLocalId);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("e5Nys")).orderedListWithOrder);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("e5Nys")).orderedListWithOrderAndLocalId);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("1i5tx")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("g8C7z")).emoji);
$parcel$export(module.exports, "emojiWithLocalId", () => (parcelRequire("g8C7z")).emojiWithLocalId);
$parcel$export(module.exports, "image", () => (parcelRequire("41YoF")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("d0FgX")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("d0FgX")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("5mWOa")).listItem);
$parcel$export(module.exports, "listItemWithFlexibleFirstChildStage0", () => (parcelRequire("5mWOa")).listItemWithFlexibleFirstChildStage0);
$parcel$export(module.exports, "listItemWithLocalId", () => (parcelRequire("5mWOa")).listItemWithLocalId);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("6IEi1")).extendedPanel);
$parcel$export(module.exports, "extendedPanelWithLocalId", () => (parcelRequire("6IEi1")).extendedPanelWithLocalId);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("6IEi1")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("gPa31")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("iY0Bz")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("fu8gK")).caption);
$parcel$export(module.exports, "captionWithLocalId", () => (parcelRequire("fu8gK")).captionWithLocalId);
$parcel$export(module.exports, "media", () => (parcelRequire("9enxE")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("9enxE")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("9enxE")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("55v2Q")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("1P6GE")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("bkx8J")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("bkx8J")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("bkx8J")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("bkx8J")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("bkx8J")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => (parcelRequire("bkx8J")).mediaSingleFullWithLocalId);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("bkx8J")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("1l3LJ")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("1l3LJ")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("1l3LJ")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("1l3LJ")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("1l3LJ")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableRowWithLocalId", () => (parcelRequire("1l3LJ")).tableRowWithLocalId);
$parcel$export(module.exports, "tableCellWithLocalId", () => (parcelRequire("1l3LJ")).tableCellWithLocalId);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => (parcelRequire("1l3LJ")).tableHeaderWithLocalId);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("1l3LJ")).tableRowWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("1l3LJ")).tableCellWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("1l3LJ")).tableHeaderWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("1l3LJ")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("1l3LJ")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("1l3LJ")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("1l3LJ")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("1l3LJ")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("1l3LJ")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("1l3LJ")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("1l3LJ")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("1l3LJ")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("1l3LJ")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("1l3LJ")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("1l3LJ")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("1l3LJ")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("1l3LJ")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("1l3LJ")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("1l3LJ")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("1l3LJ")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("1l3LJ")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("jzyhn")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("jzyhn")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("eUPLO")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("19Zep")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("19Zep")).taskListSelector);
$parcel$export(module.exports, "taskListWithFlexibleFirstChildStage0", () => (parcelRequire("19Zep")).taskListWithFlexibleFirstChildStage0);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("bVo5t")).taskItem);
$parcel$export(module.exports, "blockTaskItem", () => (parcelRequire("bVo5t")).blockTaskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("iqs9I")).date);
$parcel$export(module.exports, "dateWithLocalId", () => (parcelRequire("iqs9I")).dateWithLocalId);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("brIWK")).placeholder);
$parcel$export(module.exports, "placeholderWithLocalId", () => (parcelRequire("brIWK")).placeholderWithLocalId);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("cfGoW")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => (parcelRequire("cfGoW")).layoutSectionWithLocalId);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("cfGoW")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("cfGoW")).layoutSectionWithSingleColumnLocalId);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("daSDG")).layoutColumn);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => (parcelRequire("daSDG")).layoutColumnWithLocalId);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("bZFVH")).inlineCard);
$parcel$export(module.exports, "inlineCardWithLocalId", () => (parcelRequire("bZFVH")).inlineCardWithLocalId);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("bmo08")).blockCard);
$parcel$export(module.exports, "blockCardWithLocalId", () => (parcelRequire("bmo08")).blockCardWithLocalId);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("3ZtT7")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("is2Xi")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("hrZYn")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("4w5Cd")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => (parcelRequire("4w5Cd")).nestedExpandWithLocalId);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("46xgW")).embedCard);
$parcel$export(module.exports, "embedCardWithLocalId", () => (parcelRequire("46xgW")).embedCardWithLocalId);
$parcel$export(module.exports, "extension", () => (parcelRequire("6bkzW")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("6fM2i")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("6N6sU")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("c6xL4")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("c6xL4")).multiBodiedExtension);
$parcel$export(module.exports, "syncBlock", () => (parcelRequire("8Mesg")).syncBlock);
$parcel$export(module.exports, "bodiedSyncBlock", () => (parcelRequire("i98aq")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1zZdw = parcelRequire("1zZdw");

var $5UpiG = parcelRequire("5UpiG");

var $2I8tJ = parcelRequire("2I8tJ");

var $2M46G = parcelRequire("2M46G");

var $6IkW5 = parcelRequire("6IkW5");

var $9qlBc = parcelRequire("9qlBc");

var $aaUQA = parcelRequire("aaUQA");

var $fYiX1 = parcelRequire("fYiX1");

var $9UYHL = parcelRequire("9UYHL");

var $4hcwN = parcelRequire("4hcwN");

var $bathP = parcelRequire("bathP");

var $e5Nys = parcelRequire("e5Nys");

var $1i5tx = parcelRequire("1i5tx");

var $g8C7z = parcelRequire("g8C7z");

var $41YoF = parcelRequire("41YoF");

var $d0FgX = parcelRequire("d0FgX");

var $5mWOa = parcelRequire("5mWOa");

var $6IEi1 = parcelRequire("6IEi1");

var $gPa31 = parcelRequire("gPa31");

var $iY0Bz = parcelRequire("iY0Bz");

var $fu8gK = parcelRequire("fu8gK");

var $9enxE = parcelRequire("9enxE");

var $55v2Q = parcelRequire("55v2Q");

var $1P6GE = parcelRequire("1P6GE");

var $bkx8J = parcelRequire("bkx8J");

var $1l3LJ = parcelRequire("1l3LJ");

var $jzyhn = parcelRequire("jzyhn");

var $eUPLO = parcelRequire("eUPLO");

var $19Zep = parcelRequire("19Zep");

var $bVo5t = parcelRequire("bVo5t");

var $iqs9I = parcelRequire("iqs9I");

var $brIWK = parcelRequire("brIWK");

var $cfGoW = parcelRequire("cfGoW");

var $daSDG = parcelRequire("daSDG");

var $bZFVH = parcelRequire("bZFVH");

var $bmo08 = parcelRequire("bmo08");

var $3ZtT7 = parcelRequire("3ZtT7");

var $is2Xi = parcelRequire("is2Xi");

var $hrZYn = parcelRequire("hrZYn");

var $4w5Cd = parcelRequire("4w5Cd");

var $46xgW = parcelRequire("46xgW");

var $6bkzW = parcelRequire("6bkzW");

var $6fM2i = parcelRequire("6fM2i");

var $6N6sU = parcelRequire("6N6sU");

var $c6xL4 = parcelRequire("c6xL4");

var $8Mesg = parcelRequire("8Mesg");

var $i98aq = parcelRequire("i98aq");

});



parcelRegister("j88lh", function(module, exports) {
$parcel$export(module.exports, "ADFEncoder", () => $d4f7bd618e9b6cfb$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $d4f7bd618e9b6cfb$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $d4f7bd618e9b6cfb$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $d4f7bd618e9b6cfb$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $2WmUO = parcelRequire("2WmUO");

var $8QDVw = parcelRequire("8QDVw");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d4f7bd618e9b6cfb$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $d4f7bd618e9b6cfb$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $2WmUO.defaultSchema));
        this.encode = $d4f7bd618e9b6cfb$var$createEncoder(transformer, new (0, $8QDVw.JSONTransformer)());
    }
}
const $d4f7bd618e9b6cfb$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $d4f7bd618e9b6cfb$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $d4f7bd618e9b6cfb$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $d4f7bd618e9b6cfb$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("7VjJx", function(module, exports) {
$parcel$export(module.exports, "isAnnotationMark", () => $ca1d0bcc61769262$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $ca1d0bcc61769262$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $cB1Zx = parcelRequire("cB1Zx");

var $6D2Mh = parcelRequire("6D2Mh");
const $ca1d0bcc61769262$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $ca1d0bcc61769262$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $cB1Zx.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6D2Mh.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $ca1d0bcc61769262$export$2e2bcd8739ae039 = $ca1d0bcc61769262$var$AnnotationComponent;

});
parcelRegister("6D2Mh", function(module, exports) {
$parcel$export(module.exports, "MarkElement", () => $427d2192eed9adc7$export$f3069f755c1eba0b);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $cB1Zx = parcelRequire("cB1Zx");

var $izI49 = parcelRequire("izI49");

var $alwrO = parcelRequire("alwrO");

var $2CJ9M = parcelRequire("2CJ9M");

var $aWJJY = parcelRequire("aWJJY");

var $7K5Cn = parcelRequire("7K5Cn");

var $hoMpk = parcelRequire("hoMpk");

var $e3c7n = parcelRequire("e3c7n");
const $427d2192eed9adc7$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $aWJJY.useInlineCommentSubscriberContext)();
    const states = (0, $8P7DW.useContext)((0, $hoMpk.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $7K5Cn.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $8P7DW.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $e3c7n.useAnnotationManagerDispatch)();
    const onClick = (0, $8P7DW.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager === null || annotationManager === void 0 || annotationManager.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((_error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $izI49.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $2CJ9M.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $cB1Zx.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $alwrO.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        children: children
    });
};

});
parcelRegister("alwrO", function(module, exports) {
$parcel$export(module.exports, "MarkComponent", () => $2d38f683a6f2d4c8$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $cB1Zx = parcelRequire("cB1Zx");

var $e6Qdr = parcelRequire("e6Qdr");

var $k7INq = parcelRequire("k7INq");

var $kvuIc = parcelRequire("kvuIc");

var $e3c7n = parcelRequire("e3c7n");
const $2d38f683a6f2d4c8$var$markStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cB1Zx.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
            cursor: 'pointer'
        }
    }
});
const $2d38f683a6f2d4c8$var$markStylesLayeringFix = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cB1Zx.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $2d38f683a6f2d4c8$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cB1Zx.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $2d38f683a6f2d4c8$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cB1Zx.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $2d38f683a6f2d4c8$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cB1Zx.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $2d38f683a6f2d4c8$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $2d38f683a6f2d4c8$var$accessibilityStylesOld = /*#__PURE__*/ (0, $8Z0o8.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-startmarker)] '`
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-endmarker)] '`
    }
});
const $2d38f683a6f2d4c8$var$accessibilityStylesNew = /*#__PURE__*/ (0, $8Z0o8.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-startmarker)'
        ]
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-endmarker)'
        ]
    }
});
const $2d38f683a6f2d4c8$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $k7INq.default)();
    const annotationIds = (0, $8P7DW.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $e3c7n.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $e3c7n.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $8P7DW.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $8P7DW.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $cB1Zx.AnnotationMarkStates).ACTIVE) return;
        if ((0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        var _document$activeEleme;
        const focusedElementTag = (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $2d38f683a6f2d4c8$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $cB1Zx.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $8Z0o8.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $2d38f683a6f2d4c8$var$markStyles,
                $2d38f683a6f2d4c8$var$markStylesLayeringFix,
                (0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') && $2d38f683a6f2d4c8$var$markStylesWithInlineComments,
                $2d38f683a6f2d4c8$var$markStylesWithCommentsPanel,
                !$2d38f683a6f2d4c8$var$isMobile() && ((0, $e6Qdr.fg)('platform_renderer_a11y_inline_comment_fix') ? $2d38f683a6f2d4c8$var$accessibilityStylesNew : $2d38f683a6f2d4c8$var$accessibilityStylesOld),
                $2d38f683a6f2d4c8$var$markStylesWithUpdatedShadow
            ],
            style: (0, $e6Qdr.fg)('platform_renderer_a11y_inline_comment_fix') ? {
                '--ak-renderer-annotation-startmarker': `"${intl.formatMessage((0, $kvuIc.inlineCommentMessages).contentRendererInlineCommentMarkerStart)}"`,
                '--ak-renderer-annotation-endmarker': `"${intl.formatMessage((0, $kvuIc.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)}"`
            } : {
                '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $kvuIc.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
                '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $kvuIc.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
            }
        }
    }, children);
};

});

parcelRegister("2CJ9M", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentsFilter", () => $0dac84d00d2b142e$export$8e7d47f9e38ad4f1);

var $8P7DW = parcelRequire("8P7DW");

var $hoMpk = parcelRequire("hoMpk");
const $0dac84d00d2b142e$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $8P7DW.useContext)((0, $hoMpk.InlineCommentsStateContext));
    return (0, $8P7DW.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("aWJJY", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $68cec8f5481df377$export$b46737175cffd396);

var $8P7DW = parcelRequire("8P7DW");

var $hoMpk = parcelRequire("hoMpk");
const $68cec8f5481df377$export$b46737175cffd396 = ()=>{
    const providers = (0, $8P7DW.useContext)((0, $hoMpk.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("fDO3u", function(module, exports) {
$parcel$export(module.exports, "toReact", () => $37fe1307d758a43c$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $lMc1U = parcelRequire("lMc1U");

var $hEE6J = parcelRequire("hEE6J");

var $1nVrJ = parcelRequire("1nVrJ");

var $68JCX = parcelRequire("68JCX");

var $94y8N = parcelRequire("94y8N");

var $2Kc0g = parcelRequire("2Kc0g");

var $22U5P = parcelRequire("22U5P");

var $7Xf3E = parcelRequire("7Xf3E");

var $4LeSa = parcelRequire("4LeSa");

var $gRg1L = parcelRequire("gRg1L");

var $iUNsq = parcelRequire("iUNsq");

var $3Xnji = parcelRequire("3Xnji");

var $d9u15 = parcelRequire("d9u15");

var $fekM0 = parcelRequire("fekM0");

var $43lIe = parcelRequire("43lIe");

var $hw2Pj = parcelRequire("hw2Pj");

var $7VjJx = parcelRequire("7VjJx");

var $iUSHY = parcelRequire("iUSHY");

var $bDSKY = parcelRequire("bDSKY");

var $bpyyy = parcelRequire("bpyyy");
const $37fe1307d758a43c$export$c00d967a0f56fdb7 = {
    code: (0, $lMc1U.default),
    em: (0, $hEE6J.default),
    link: (0, $1nVrJ.default),
    strike: (0, $68JCX.default),
    strong: (0, $94y8N.default),
    subsup: (0, $2Kc0g.default),
    textColor: (0, $22U5P.default),
    backgroundColor: (0, $7Xf3E.default),
    underline: (0, $4LeSa.default),
    annotation: (0, $7VjJx.default),
    border: (0, $iUSHY.default),
    fontSize: (0, $bDSKY.default),
    // Stage0
    confluenceInlineComment: (0, $bpyyy.default),
    breakout: (0, $gRg1L.default),
    alignment: (0, $iUNsq.default),
    indentation: (0, $3Xnji.default),
    unsupportedMark: (0, $d9u15.default),
    unsupportedNodeAttribute: (0, $fekM0.default),
    dataConsumer: (0, $43lIe.default),
    fragment: (0, $hw2Pj.default)
};
const $37fe1307d758a43c$export$d4334b129116aad7 = (mark)=>{
    return $37fe1307d758a43c$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("lMc1U", function(module, exports) {
$parcel$export(module.exports, "isCodeMark", () => $22b31e6752cf376d$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $22b31e6752cf376d$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $3SD6z = parcelRequire("3SD6z");

var $jtMJU = parcelRequire("jtMJU");

var $3qzDg = parcelRequire("3qzDg");
const $22b31e6752cf376d$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $22b31e6752cf376d$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $3qzDg.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jtMJU.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
var $22b31e6752cf376d$export$2e2bcd8739ae039 = (0, $3SD6z.default)($22b31e6752cf376d$export$7cea6ffa7022e85f);

});
parcelRegister("jtMJU", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb9f5e45449fbd5e$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $6Dupw = parcelRequire("6Dupw");

var $8GhAC = parcelRequire("8GhAC");
const $fb9f5e45449fbd5e$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $fb9f5e45449fbd5e$var$Code = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $gWgPx.jsx)($fb9f5e45449fbd5e$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $8n1kL.default)([
            $fb9f5e45449fbd5e$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $fb9f5e45449fbd5e$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $8GhAC.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Dupw.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($fb9f5e45449fbd5e$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)($fb9f5e45449fbd5e$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, {
        children: replacedChildren
    });
}
function $fb9f5e45449fbd5e$var$isReactElement(child) {
    return !!child.type;
}
$fb9f5e45449fbd5e$var$Code.displayName = 'Code';
var $fb9f5e45449fbd5e$export$2e2bcd8739ae039 = $fb9f5e45449fbd5e$var$Code;

});
parcelRegister("6Dupw", function(module, exports) {
$parcel$export(module.exports, "default", () => $69d813a61e6e08cf$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $ea6bZ = parcelRequire("ea6bZ");

var $6FV3m = parcelRequire("6FV3m");
function $69d813a61e6e08cf$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ea6bZ.default), {
        content: label,
        tag: $69d813a61e6e08cf$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6FV3m.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6FV3m.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $69d813a61e6e08cf$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("6FV3m", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $2a5bb8d5288dd138$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $dojiU = parcelRequire("dojiU");
const $2a5bb8d5288dd138$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $2a5bb8d5288dd138$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $2a5bb8d5288dd138$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $8n1kL.default)([
                    $2a5bb8d5288dd138$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $2a5bb8d5288dd138$var$getBidiCharacterCode(bidiCharacter) {
    var _bidiCharacter$codePo;
    const bidiCharacterCode = (_bidiCharacter$codePo = bidiCharacter.codePointAt(0)) === null || _bidiCharacter$codePo === void 0 ? void 0 : _bidiCharacter$codePo.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("8GhAC", function(module, exports) {
$parcel$export(module.exports, "default", () => $556c69024c686cd0$export$2e2bcd8739ae039);
const $556c69024c686cd0$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $556c69024c686cd0$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($556c69024c686cd0$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});



parcelRegister("hEE6J", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c83c45660740095$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $9c83c45660740095$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $gWgPx.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("1nVrJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8b879cb1744921d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $j88lh = parcelRequire("j88lh");

var $jS5mX = parcelRequire("jS5mX");

var $eguiP = parcelRequire("eguiP");

var $1eip3 = parcelRequire("1eip3");

var $8gu7I = parcelRequire("8gu7I");
function $f8b879cb1744921d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f8b879cb1744921d$var$anchorStyles = {
    name: "sa5fy1",
    styles: "color:var(--ds-link, #1868DB);&:hover{color:var(--ds-link, #1868DB);text-decoration:underline;}&:active{color:var(--ds-link-pressed, #1558BC);}"
};
function $f8b879cb1744921d$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, onSetLinkTarget: onSetLinkTarget, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    let actualTarget = target;
    if (onSetLinkTarget && href) try {
        actualTarget = onSetLinkTarget(href) ?? actualTarget;
    } catch (error) {
    // eslint-disable-line no-unused-vars
    // If URL parsing fails, use the original target
    }
    const anchorProps = {
        href: href,
        target: actualTarget,
        title: href
    };
    if (actualTarget === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $j88lh.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8gu7I.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $1eip3.default), {
        css: $f8b879cb1744921d$var$anchorStyles,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $eguiP.ACTION).VISITED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).LINK,
                eventType: (0, $eguiP.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $jS5mX.PLATFORM).WEB,
                    mode: (0, $jS5mX.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        isLinkComponent: true,
        enableResolve: true
    }, props.children));
}

});
parcelRegister("1eip3", function(module, exports) {
$parcel$export(module.exports, "default", () => $8245fe32cbeca11e$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $eS4yu = parcelRequire("eS4yu");

var $1EFS8 = parcelRequire("1EFS8");

var $2XLqF = parcelRequire("2XLqF");

var $9jXLs = parcelRequire("9jXLs");

var $eu2C6 = parcelRequire("eu2C6");

var $gAwhe = parcelRequire("gAwhe");

var $2yjNX = parcelRequire("2yjNX");

var $lkIQ5 = parcelRequire("lkIQ5");

var $djI3I = parcelRequire("djI3I");
const $8245fe32cbeca11e$var$PACKAGE_DATA = {
    packageName: undefined,
    packageVersion: undefined,
    componentName: 'linkUrl'
};
const $8245fe32cbeca11e$var$Anchor = (0, $9jXLs.withLinkClickedEvent)('a');
const $8245fe32cbeca11e$export$8c0773eab230d49e = (0, $9jXLs.withLinkClickedEvent)((0, $2XLqF.default));
const $8245fe32cbeca11e$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $djI3I.useLinkWarningModal)();
    const resolveHyperlinkFG = (0, $1EFS8.default).checkGate('platform_editor_resolve_hyperlinks_killswitch');
    if (resolveHyperlinkFG) {
        const Link = enableResolve ? (0, $2yjNX.HyperlinkWithSmartLinkResolver) : (0, $gAwhe.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eu2C6.LinkAnalyticsContext), {
            url: href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Link, {
            href: href,
            isLinkComponent: isLinkComponent,
            onClick: (e)=>{
                if (!checkSafety) {
                    onClick && onClick(e);
                    return;
                }
                // Only call the onClick if the link is safe
                if (isLinkSafe(e, href)) onClick && onClick(e);
                else showSafetyWarningModal(e, href);
            },
            ...props
        }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkIQ5.default), linkWarningModalProps));
    }
    const Link = isLinkComponent ? $8245fe32cbeca11e$export$8c0773eab230d49e : $8245fe32cbeca11e$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eu2C6.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkIQ5.default), linkWarningModalProps));
};
const $8245fe32cbeca11e$var$_default_1 = (0, $eS4yu.default)($8245fe32cbeca11e$var$PACKAGE_DATA)($8245fe32cbeca11e$var$LinkUrl);
var $8245fe32cbeca11e$export$2e2bcd8739ae039 = $8245fe32cbeca11e$var$_default_1;

});
parcelRegister("9jXLs", function(module, exports) {
$parcel$export(module.exports, "fireLinkClickedEvent", () => $1e522012c2e0917d$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $1e522012c2e0917d$export$263352d59c0c5966);

var $8P7DW = parcelRequire("8P7DW");

var $2eDZj = parcelRequire("2eDZj");

var $bt6cj = parcelRequire("bt6cj");

var $13svG = parcelRequire("13svG");

var $9f7jz = parcelRequire("9f7jz");

var $hHhPM = parcelRequire("hHhPM");
const $1e522012c2e0917d$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $1e522012c2e0917d$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $1e522012c2e0917d$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $1e522012c2e0917d$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $2eDZj.browser)();
    /**
   * If the link/parent is content editable then left click won't have typical effect
   */ if ($1e522012c2e0917d$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $1e522012c2e0917d$var$linkClickedEventOld = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $1e522012c2e0917d$var$linkClickedEventWithShortLink = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented, isConfluenceShortLink: isConfluenceShortLink })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented,
            isConfluenceShortLink: isConfluenceShortLink
        }
    });
const $1e522012c2e0917d$export$880d2168464029dd = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $1e522012c2e0917d$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $1e522012c2e0917d$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $1e522012c2e0917d$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $1e522012c2e0917d$var$linkClickedEventOld({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $1e522012c2e0917d$export$fb40cb818618aeeb = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $1e522012c2e0917d$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $1e522012c2e0917d$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $1e522012c2e0917d$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    // Check if the URL is a Confluence shortLink (contains "/l/cp/")
    let isConfluenceShortLink = false;
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        isConfluenceShortLink = url.includes('/l/cp/');
    }
    const linkClickedEventResult = $1e522012c2e0917d$var$linkClickedEventWithShortLink({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented,
        isConfluenceShortLink: isConfluenceShortLink
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $1e522012c2e0917d$export$7fedc699766c16de = (0, $bt6cj.functionWithCondition)(()=>(0, $13svG.expValEquals)('smart_link_confluence_short_link_analytics', 'cohort', 'test'), // 12/17/2025: Clean up this feature gate once it's out in prod for 2 weeks - https://product-fabric.atlassian.net/browse/CCPERMS-5030
$1e522012c2e0917d$export$fb40cb818618aeeb, $1e522012c2e0917d$export$880d2168464029dd);
const $1e522012c2e0917d$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $1e522012c2e0917d$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides === null || overrides === void 0 ? void 0 : overrides.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides === null || overrides === void 0 ? void 0 : overrides.nonPrivacySafeAttributes
            }
        }).fire((0, $hHhPM.ANALYTICS_CHANNEL));
    };
const $1e522012c2e0917d$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $1e522012c2e0917d$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $9f7jz.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $9f7jz.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$1e522012c2e0917d$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("2eDZj", function(module, exports) {
$parcel$export(module.exports, "browser", () => $16e978facca66d2a$export$3f2684e5d7cb1006);
const $16e978facca66d2a$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $16e978facca66d2a$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $16e978facca66d2a$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $16e978facca66d2a$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $16e978facca66d2a$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $16e978facca66d2a$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $16e978facca66d2a$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $16e978facca66d2a$var$result.android = /Android \d/.test(navigator.userAgent);
    $16e978facca66d2a$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $16e978facca66d2a$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $16e978facca66d2a$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $16e978facca66d2a$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $16e978facca66d2a$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $16e978facca66d2a$export$3f2684e5d7cb1006() {
    return $16e978facca66d2a$var$result;
}

});

parcelRegister("9f7jz", function(module, exports) {
$parcel$export(module.exports, "useLinkClicked", () => $31bf7370b2caf77d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $31bf7370b2caf77d$export$df67f318ded0283c);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $9jXLs = parcelRequire("9jXLs");
var $31bf7370b2caf77d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $31bf7370b2caf77d$export$5993d3ca6c85f774 = (handler, predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    return (0, $8P7DW.useCallback)((...args)=>{
        const [event] = args;
        handler === null || handler === void 0 || handler.apply(null, args);
        if (!predicate || predicate !== null && predicate !== void 0 && predicate(event)) (0, $9jXLs.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $31bf7370b2caf77d$var$isNotLeftClick = (event)=>event.button !== 0;
const $31bf7370b2caf77d$export$df67f318ded0283c = (onMouseDown)=>{
    return $31bf7370b2caf77d$export$5993d3ca6c85f774(onMouseDown, $31bf7370b2caf77d$var$isNotLeftClick);
};

});

parcelRegister("hHhPM", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $b0d73f8185dcaf1a$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $b0d73f8185dcaf1a$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $b0d73f8185dcaf1a$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $b0d73f8185dcaf1a$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $b0d73f8185dcaf1a$export$b91e0203b928470c);
const $b0d73f8185dcaf1a$export$85183a312807388d = 'media';
const $b0d73f8185dcaf1a$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: undefined,
    packageVersion: undefined
};
var $b0d73f8185dcaf1a$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $b0d73f8185dcaf1a$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $b0d73f8185dcaf1a$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $b0d73f8185dcaf1a$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $b0d73f8185dcaf1a$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($b0d73f8185dcaf1a$export$85183a312807388d);
};

});


parcelRegister("eu2C6", function(module, exports) {
$parcel$export(module.exports, "LinkAnalyticsContext", () => $7d3ba439a33404b4$export$9458cdec663b9ff1);

var $8P7DW = parcelRequire("8P7DW");

var $8gu7I = parcelRequire("8gu7I");
const $7d3ba439a33404b4$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});

parcelRegister("gAwhe", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d9d1ae254221c2b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $2XLqF = parcelRequire("2XLqF");

var $9jXLs = parcelRequire("9jXLs");
const $4d9d1ae254221c2b$var$Anchor = (0, $9jXLs.withLinkClickedEvent)('a');
const $4d9d1ae254221c2b$export$8c0773eab230d49e = (0, $9jXLs.withLinkClickedEvent)((0, $2XLqF.default));
const $4d9d1ae254221c2b$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $4d9d1ae254221c2b$export$8c0773eab230d49e : $4d9d1ae254221c2b$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $4d9d1ae254221c2b$export$2e2bcd8739ae039 = $4d9d1ae254221c2b$var$Hyperlink;

});

parcelRegister("2yjNX", function(module, exports) {
$parcel$export(module.exports, "HyperlinkWithSmartLinkResolver", () => $e3d4b0a4cb910ef8$export$1fdb4f77fe528a52);

var $8P7DW = parcelRequire("8P7DW");

var $dCWA1 = parcelRequire("dCWA1");

var $3SD6z = parcelRequire("3SD6z");

var $1EFS8 = parcelRequire("1EFS8");

var $673gs = parcelRequire("673gs");

var $e6Qdr = parcelRequire("e6Qdr");

var $kTr6Y = parcelRequire("kTr6Y");

var $ixobs = parcelRequire("ixobs");

var $4sVTv = parcelRequire("4sVTv");

var $lvhBd = parcelRequire("lvhBd");

var $1mjzP = parcelRequire("1mjzP");

var $LnJME = parcelRequire("LnJME");

var $gAwhe = parcelRequire("gAwhe");

var $6pux3 = parcelRequire("6pux3");
const $e3d4b0a4cb910ef8$var$HyperlinkFallbackComponent = ()=>null;
const $e3d4b0a4cb910ef8$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $4sVTv.default)(props === null || props === void 0 ? void 0 : props.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lvhBd.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(DefaultComponent, props);
    };
const $e3d4b0a4cb910ef8$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { actions: actions, state: state } = (0, $ixobs.default)({
        href: props.href || ''
    });
    const services = (0, $kTr6Y.getServices)(state === null || state === void 0 ? void 0 : state.details);
    const thirdPartyARI = (0, $kTr6Y.getThirdPartyARI)(state === null || state === void 0 ? void 0 : state.details);
    const firstPartyIdentifier = (0, $kTr6Y.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $e6Qdr.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $LnJME.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    const onClick = (0, $8P7DW.useCallback)((e)=>{
        // Only fire the event if the feature flag is on and other conditions are met
        if ((state === null || state === void 0 ? void 0 : state.status) === 'resolved' && (e === null || e === void 0 ? void 0 : e.button) === 0 && fire3PClickEvent && (0, $e6Qdr.fg)('platform_smartlink_3pclick_analytics')) // 0 taken from button state representation -
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        fire3PClickEvent();
        onClickCallback === null || onClickCallback === void 0 || onClickCallback(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        state === null || state === void 0 ? void 0 : state.status
    ]);
    const onAuthorize = (0, $8P7DW.useCallback)(()=>actions.authorize('url'), [
        actions
    ]);
    const shouldRenderConnectBtn = ()=>{
        if (!props.children || !Array.isArray(props.children) || props.children.length === 0) return false;
        const firstChild = props.children[0];
        try {
            var _firstChild$props;
            // Check if first child has a string matching href
            if (typeof firstChild === 'string') return props.href === firstChild;
            // Check if first child has another child object containing matching href. This aligns with the behavior of the TextWrapper component used by editor to render link nodes
            if (firstChild !== null && firstChild !== void 0 && (_firstChild$props = firstChild.props) !== null && _firstChild$props !== void 0 && _firstChild$props.children && typeof firstChild.props.children === 'string') return props.href === firstChild.props.children;
        } catch (_) {
            return false;
        }
    };
    if ((state === null || state === void 0 ? void 0 : state.status) === 'unauthorized' && shouldRenderConnectBtn() && ((0, $1EFS8.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $1EFS8.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false))) {
        const provider = (0, $673gs.extractSmartLinkProvider)(state === null || state === void 0 ? void 0 : state.details);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6pux3.default), {
            ...props,
            onAuthorize: services !== null && services !== void 0 && services.length ? onAuthorize : undefined,
            onClick: onClick,
            showConnectBtn: (services === null || services === void 0 ? void 0 : services.length) > 0,
            provider: provider
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gAwhe.default), {
        ...props,
        onClick: onClick
    });
};
const $e3d4b0a4cb910ef8$export$1fdb4f77fe528a52 = (0, $dCWA1.withErrorBoundary)($e3d4b0a4cb910ef8$var$withValidator((0, $3SD6z.default)((0, $1mjzP.default)($e3d4b0a4cb910ef8$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $gAwhe.default)), {
    FallbackComponent: $e3d4b0a4cb910ef8$var$HyperlinkFallbackComponent
});

});
parcelRegister("kTr6Y", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $76e5969c57281c5a$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $76e5969c57281c5a$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $76e5969c57281c5a$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $76e5969c57281c5a$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $76e5969c57281c5a$export$81164c1570bcd038);
$parcel$export(module.exports, "getThirdPartyARI", () => $76e5969c57281c5a$export$e029950864672b4);
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $76e5969c57281c5a$export$48b4e58cdb8031ba);
$parcel$export(module.exports, "getObjectName", () => $76e5969c57281c5a$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $76e5969c57281c5a$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $76e5969c57281c5a$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $76e5969c57281c5a$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $76e5969c57281c5a$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $76e5969c57281c5a$export$3f9446bb21b945a0);

var $e6Qdr = parcelRequire("e6Qdr");

var $eqLma = parcelRequire("eqLma");
const $76e5969c57281c5a$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $76e5969c57281c5a$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $eqLma.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $76e5969c57281c5a$export$46fa3e7718c82e41 = (details)=>{
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId;
};
const $76e5969c57281c5a$export$218d96312e385949 = (details)=>{
    var _details$meta2;
    return details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key;
};
const $76e5969c57281c5a$export$81164c1570bcd038 = (details)=>(details === null || details === void 0 ? void 0 : details.data) && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $76e5969c57281c5a$export$e029950864672b4 = (details)=>{
    if ((0, $e6Qdr.fg)('platform_smartlink_3pclick_analytics')) {
        if (details !== null && details !== void 0 && details.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details !== null && details !== void 0 && details.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $76e5969c57281c5a$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $e6Qdr.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $76e5969c57281c5a$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $76e5969c57281c5a$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $76e5969c57281c5a$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $76e5969c57281c5a$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $76e5969c57281c5a$export$5615361d76a8be5 = (details)=>(details === null || details === void 0 ? void 0 : details.data) && 'name' in details.data && details.data.name || undefined;
const $76e5969c57281c5a$export$bcf275804417edda = (details)=>{
    if (details !== null && details !== void 0 && details.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $76e5969c57281c5a$export$16c0ebb0de9b767b = (details)=>{
    var _details$meta3;
    return details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.resourceType;
};
const $76e5969c57281c5a$export$e2005c9600188ac7 = (details)=>{
    var _details$meta4;
    return details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.product;
};
const $76e5969c57281c5a$export$f8fdefc70357968e = (details)=>{
    var _details$meta5;
    return details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.subproduct;
};
const $76e5969c57281c5a$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $76e5969c57281c5a$export$ac5d414b1ebfab5a = (details)=>details && $76e5969c57281c5a$export$cd41ae544cfc2a65(details) && $76e5969c57281c5a$export$795910f5f15a9633(details);
const $76e5969c57281c5a$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $76e5969c57281c5a$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $76e5969c57281c5a$export$a752a116d184ffbd = (details)=>{
    var _details$meta6;
    return details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 || (_details$meta6 = _details$meta6.requestAccess) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.accessType;
};
const $76e5969c57281c5a$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $76e5969c57281c5a$export$66805b16d2a1da7c = (details)=>details === null || details === void 0 ? void 0 : details.datasources;
const $76e5969c57281c5a$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $76e5969c57281c5a$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $76e5969c57281c5a$export$3f9446bb21b945a0 = (details)=>!!(details !== null && details !== void 0 && details.meta.hasScopeOverrides);
// Helper function to extract page ID from standard Confluence page URLs
const $76e5969c57281c5a$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $76e5969c57281c5a$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $76e5969c57281c5a$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $76e5969c57281c5a$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};

});
parcelRegister("eqLma", function(module, exports) {
$parcel$export(module.exports, "extractVisitUrl", () => $853d227311572248$export$c81497d3681f24f4);
const $853d227311572248$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("ixobs", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab9551ec4612115a$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $gdnRs = parcelRequire("gdnRs");

var $76KpV = parcelRequire("76KpV");

var $5TL8s = parcelRequire("5TL8s");

var $6Gezw = parcelRequire("6Gezw");

var $kTr6Y = parcelRequire("kTr6Y");

var $7UlKc = parcelRequire("7UlKc");

var $jgb5h = parcelRequire("jgb5h");
const $ab9551ec4612115a$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $8P7DW.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($gdnRs)))());
    const state = (0, $7UlKc.useSmartCardState)(href);
    const definitionId = (0, $kTr6Y.getDefinitionId)(state.details);
    const extensionKey = (0, $kTr6Y.getExtensionKey)(state.details);
    const resourceType = (0, $kTr6Y.getResourceType)(state.details);
    const actions = (0, $6Gezw.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $jgb5h.useScheduledRegister)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $76KpV.useAnalyticsEvents)();
    (0, $8P7DW.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $8P7DW.useEffect)(()=>{
        $5TL8s.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            var _state$error, _state$error2, _state$error3;
            $5TL8s.create(id, state.status);
            if (state.status === 'resolved') {
                var _measure$getMeasure;
                fireEvent('operational.hyperlink.resolved', {
                    definitionId: definitionId ?? null,
                    extensionKey: extensionKey ?? null,
                    resourceType: resourceType ?? null,
                    duration: ((_measure$getMeasure = $5TL8s.getMeasure(id, state.status)) === null || _measure$getMeasure === void 0 ? void 0 : _measure$getMeasure.duration) ?? null
                });
            } else if (((_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.type) !== 'ResolveUnsupportedError' && ((_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.type) !== 'UnsupportedError' && ((_state$error3 = state.error) === null || _state$error3 === void 0 ? void 0 : _state$error3.name) !== 'InvalidUrlError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $ab9551ec4612115a$export$2e2bcd8739ae039 = $ab9551ec4612115a$var$useResolveHyperlink;

});
parcelRegister("76KpV", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $f3f3438965de711a$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::676f76a2e45920437adc8c35a9af8b37>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $937Q3 = parcelRequire("937Q3");

var $hwj6b = parcelRequire("hwj6b");
const $f3f3438965de711a$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const fireEvent = (0, $8P7DW.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $hwj6b.default)(...params));
        event.fire((0, $937Q3.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("937Q3", function(module, exports) {
$parcel$export(module.exports, "EVENT_CHANNEL", () => $ba93186b60d95005$export$3f072f06b90c3985);
const $ba93186b60d95005$export$3f072f06b90c3985 = 'media';

});

parcelRegister("hwj6b", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb4a1361ce8619a1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f914fb83fac56e7154ef460866628f7d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $fb4a1361ce8619a1$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fb4a1361ce8619a1$export$2e2bcd8739ae039 = $fb4a1361ce8619a1$var$createEventPayload;

});


parcelRegister("5TL8s", function(module, exports) {
$parcel$export(module.exports, "clearMarks", () => $7b555835b3d790b8$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $7b555835b3d790b8$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $7b555835b3d790b8$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $7b555835b3d790b8$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $7b555835b3d790b8$export$185802fd694ee1f5);
const $7b555835b3d790b8$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $7b555835b3d790b8$var$hasPerformanceAPIAvailable = $7b555835b3d790b8$var$isPerformanceAPIAvailable();
const $7b555835b3d790b8$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $7b555835b3d790b8$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $7b555835b3d790b8$export$1a717feb4df1a945 = (id)=>{
    if ($7b555835b3d790b8$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $7b555835b3d790b8$export$de42547d395c8271 = (id)=>{
    if ($7b555835b3d790b8$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $7b555835b3d790b8$var$getMark = (id, status)=>{
    if ($7b555835b3d790b8$var$hasPerformanceAPIAvailable) {
        const name = $7b555835b3d790b8$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $7b555835b3d790b8$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($7b555835b3d790b8$var$hasPerformanceAPIAvailable) {
        const name = $7b555835b3d790b8$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $7b555835b3d790b8$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($7b555835b3d790b8$var$hasPerformanceAPIAvailable) {
        const name = $7b555835b3d790b8$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $7b555835b3d790b8$export$185802fd694ee1f5 = (id, status)=>{
    if ($7b555835b3d790b8$var$hasPerformanceAPIAvailable) {
        const name = $7b555835b3d790b8$export$984df7f61dd7928f(id, status);
        const measure = $7b555835b3d790b8$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $7b555835b3d790b8$var$getMark(id, 'pending');
            const endMark = $7b555835b3d790b8$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("6Gezw", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $212a5d4094a96bd4$export$f7c340395f31e832);

var $8P7DW = parcelRequire("8P7DW");

var $73ark = parcelRequire("73ark");

var $f09Q5 = parcelRequire("f09Q5");

var $kJe5c = parcelRequire("kJe5c");

var $76KpV = parcelRequire("76KpV");

var $57wR4 = parcelRequire("57wR4");

var $4VKNi = parcelRequire("4VKNi");

var $kTr6Y = parcelRequire("kTr6Y");

var $8BOms = parcelRequire("8BOms");

var $1RSgv = parcelRequire("1RSgv");
const $212a5d4094a96bd4$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $1RSgv.default)();
    const invokeClientAction = (0, $8BOms.default)({});
    const { fireEvent: fireEvent } = (0, $76KpV.useAnalyticsEvents)();
    const { store: store } = (0, $73ark.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $8P7DW.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $57wR4.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $8P7DW.useCallback)((metadataStatus)=>{
        dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $8P7DW.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $8P7DW.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $8P7DW.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $kTr6Y.getDefinitionId)(details);
        if (definitionId) (0, $kTr6Y.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $8P7DW.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $8P7DW.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $kTr6Y.getDefinitionId)(details);
        const extensionKey = (0, $kTr6Y.getExtensionKey)(details);
        const services = (0, $kTr6Y.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $kJe5c.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $4VKNi.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $4VKNi.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $8P7DW.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $8P7DW.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("kJe5c", function(module, exports) {
$parcel$export(module.exports, "auth", () => $db66f4714336fe57$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("fsuXl")).AuthError);

var $fsuXl = parcelRequire("fsuXl");

var $jIQ60 = parcelRequire("jIQ60");
function $db66f4714336fe57$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $jIQ60.isOfTypeAuthError)(errorType)) reject(new (0, $fsuXl.AuthError)(data.message, errorType));
                    else reject(new (0, $fsuXl.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $fsuXl.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("fsuXl", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $623c7a94c214ebed$export$145273558d58e0ac);
class $623c7a94c214ebed$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("jIQ60", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $8be0b4f39d05b6ba$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $8be0b4f39d05b6ba$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("57wR4", function(module, exports) {
$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $96c2b8e344ac57be$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $96c2b8e344ac57be$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $96c2b8e344ac57be$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $96c2b8e344ac57be$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $96c2b8e344ac57be$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $96c2b8e344ac57be$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $96c2b8e344ac57be$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $96c2b8e344ac57be$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $96c2b8e344ac57be$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $96c2b8e344ac57be$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $96c2b8e344ac57be$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $96c2b8e344ac57be$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $96c2b8e344ac57be$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $96c2b8e344ac57be$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $96c2b8e344ac57be$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $96c2b8e344ac57be$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $96c2b8e344ac57be$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $96c2b8e344ac57be$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $96c2b8e344ac57be$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $96c2b8e344ac57be$export$6ca4ef8b3dc2c804);
const $96c2b8e344ac57be$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $96c2b8e344ac57be$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $96c2b8e344ac57be$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $96c2b8e344ac57be$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $96c2b8e344ac57be$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $96c2b8e344ac57be$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $96c2b8e344ac57be$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $96c2b8e344ac57be$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $96c2b8e344ac57be$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $96c2b8e344ac57be$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $96c2b8e344ac57be$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $96c2b8e344ac57be$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $96c2b8e344ac57be$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $96c2b8e344ac57be$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $96c2b8e344ac57be$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $96c2b8e344ac57be$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["RovoChatAction"] = "RovoChatAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $96c2b8e344ac57be$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $96c2b8e344ac57be$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $96c2b8e344ac57be$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $96c2b8e344ac57be$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("4VKNi", function(module, exports) {
$parcel$export(module.exports, "startUfoExperience", () => $91b10d5fab749b5f$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $91b10d5fab749b5f$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $91b10d5fab749b5f$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $91b10d5fab749b5f$export$4084c0df4a03a6af);

var $2Bslm = parcelRequire("2Bslm");
var $a1qEv = parcelRequire("a1qEv");
const $91b10d5fab749b5f$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $a1qEv.ExperienceTypes).Experience,
    performanceType: (0, $a1qEv.ExperiencePerformanceTypes).InlineResult
};
const $91b10d5fab749b5f$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $a1qEv.ExperienceTypes).Load,
    performanceType: (0, $a1qEv.ExperiencePerformanceTypes).PageSegmentLoad
};
const $91b10d5fab749b5f$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $a1qEv.ExperienceTypes).Experience,
    performanceType: (0, $a1qEv.ExperiencePerformanceTypes).InlineResult
};
const $91b10d5fab749b5f$var$ufoExperiences = {
    'smart-link-rendered': new (0, $2Bslm.ConcurrentExperience)('smart-link-rendered', $91b10d5fab749b5f$var$renderExperience),
    'smart-link-authenticated': new (0, $2Bslm.ConcurrentExperience)('smart-link-authenticated', $91b10d5fab749b5f$var$inlineExperience),
    'smart-link-action-invocation': new (0, $2Bslm.ConcurrentExperience)('smart-link-action-invocation', $91b10d5fab749b5f$var$inlineExperience),
    'smart-link-ai-summary': new (0, $2Bslm.ConcurrentExperience)('smart-link-ai-summary', $91b10d5fab749b5f$var$aiExperience)
};
const $91b10d5fab749b5f$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $91b10d5fab749b5f$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $91b10d5fab749b5f$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $91b10d5fab749b5f$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $91b10d5fab749b5f$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $91b10d5fab749b5f$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $91b10d5fab749b5f$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $91b10d5fab749b5f$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("8BOms", function(module, exports) {
$parcel$export(module.exports, "default", () => $24093e6ff5702368$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $gdnRs = parcelRequire("gdnRs");

var $76KpV = parcelRequire("76KpV");

var $5TL8s = parcelRequire("5TL8s");

var $4VKNi = parcelRequire("4VKNi");
const $24093e6ff5702368$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $24093e6ff5702368$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $76KpV.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $8P7DW.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, prompt: prompt, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($gdnRs)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $5TL8s.mark(markName, 'pending');
        try {
            var _measure$getMeasure;
            // Begin UFO experience
            (0, $4VKNi.startUfoExperience)($24093e6ff5702368$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType,
                prompt: prompt
            });
            // Invoke action
            const result = await actionFn();
            $5TL8s.mark(markName, 'resolved');
            (0, $4VKNi.succeedUfoExperience)($24093e6ff5702368$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: ((_measure$getMeasure = $5TL8s.getMeasure(markName, 'resolved')) === null || _measure$getMeasure === void 0 ? void 0 : _measure$getMeasure.duration) ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            var _measure$getMeasure2;
            $5TL8s.mark(markName, 'errored');
            (0, $4VKNi.failUfoExperience)($24093e6ff5702368$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err === null || err === void 0 ? void 0 : err.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: ((_measure$getMeasure2 = $5TL8s.getMeasure(markName, 'errored')) === null || _measure$getMeasure2 === void 0 ? void 0 : _measure$getMeasure2.duration) ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $24093e6ff5702368$export$2e2bcd8739ae039 = $24093e6ff5702368$var$useInvokeClientAction;

});

parcelRegister("1RSgv", function(module, exports) {
$parcel$export(module.exports, "default", () => $7aaec854572827bc$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $3Z03G = parcelRequire("3Z03G");

var $73ark = parcelRequire("73ark");

var $57wR4 = parcelRequire("57wR4");

var $4VKNi = parcelRequire("4VKNi");

var $bJQxw = parcelRequire("bJQxw");
const $7aaec854572827bc$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $73ark.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $bJQxw.default)();
    return (0, $8P7DW.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $57wR4.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $3Z03G.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $4VKNi.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $7aaec854572827bc$export$2e2bcd8739ae039 = $7aaec854572827bc$var$useResolve;

});
parcelRegister("bJQxw", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f9d8077a3594960$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $6Q1OD = parcelRequire("6Q1OD");

var $73ark = parcelRequire("73ark");

var $f09Q5 = parcelRequire("f09Q5");
var $enrNN = parcelRequire("enrNN");
var $cE8LQ = parcelRequire("cE8LQ");

var $57wR4 = parcelRequire("57wR4");

var $82q42 = parcelRequire("82q42");

var $cZNBL = parcelRequire("cZNBL");
const $9f9d8077a3594960$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $73ark.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $8P7DW.useCallback)((url, metadataStatus)=>{
        dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $8P7DW.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $57wR4.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_RESOLVED), {
            url: url
        }, (0, $82q42.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $8P7DW.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $f09Q5.cardAction)((0, $f09Q5.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $8P7DW.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $cE8LQ.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $enrNN.APIError)('fallback', hostname, (0, $cZNBL.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $enrNN.APIError)('fatal', hostname, (0, $cZNBL.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $enrNN.APIError)('error', hostname, (0, $cZNBL.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
     * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
     * more info:
     * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
     * https://react-redux.js.org/api/batch
     */ (0, $6Q1OD.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $8P7DW.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $9f9d8077a3594960$export$2e2bcd8739ae039 = $9f9d8077a3594960$var$useResponse;

});
parcelRegister("82q42", function(module, exports) {
$parcel$export(module.exports, "getEmptyJsonLd", () => $cc7692a88ad44fd5$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $cc7692a88ad44fd5$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $cc7692a88ad44fd5$export$e32193033a594efb);
const $cc7692a88ad44fd5$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $cc7692a88ad44fd5$export$2796a804c6e44f63 = ()=>$cc7692a88ad44fd5$var$emptyData;
const $cc7692a88ad44fd5$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$cc7692a88ad44fd5$var$emptyData
        }
    });
const $cc7692a88ad44fd5$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$cc7692a88ad44fd5$var$emptyData
        }
    });

});

parcelRegister("cZNBL", function(module, exports) {
$parcel$export(module.exports, "ERROR_MESSAGE_OAUTH", () => $85cd7f31554f932f$export$3e81ce851ffda0ad);
$parcel$export(module.exports, "ERROR_MESSAGE_FATAL", () => $85cd7f31554f932f$export$45e7dda0d43d7f55);
$parcel$export(module.exports, "ERROR_MESSAGE_METADATA", () => $85cd7f31554f932f$export$338f7d9ccca1975d);
const $85cd7f31554f932f$export$297c39c8b9bfca0 = 'resolving';
const $85cd7f31554f932f$export$b64a888338c24e0e = 'errored';
const $85cd7f31554f932f$export$677b6edfa0002c70 = 'fallback';
const $85cd7f31554f932f$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $85cd7f31554f932f$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $85cd7f31554f932f$export$338f7d9ccca1975d = 'Error resolving metadata.';

});




parcelRegister("7UlKc", function(module, exports) {
$parcel$export(module.exports, "useSmartCardState", () => $bb58c9d650710255$export$b0444d00ba7313c6);

var $doeWf = parcelRequire("doeWf");

var $73ark = parcelRequire("73ark");
const $bb58c9d650710255$var$PENDING_STATE = {
    status: 'pending'
};
function $bb58c9d650710255$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $73ark.useSmartLinkContext)();
    const cardState = (0, $doeWf.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $bb58c9d650710255$var$PENDING_STATE;
}

});

parcelRegister("jgb5h", function(module, exports) {
$parcel$export(module.exports, "useScheduledRegister", () => $9f85954b2192a576$export$db80d61271e4d5af);
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $8P7DW = parcelRequire("8P7DW");
const $9f85954b2192a576$var$batchQueue = new Map();
const $9f85954b2192a576$var$batchTimeouts = new Map();
const $9f85954b2192a576$var$BATCH_DELAY = 250;
const $9f85954b2192a576$var$executeBatch = (hostname)=>{
    const items = $9f85954b2192a576$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $9f85954b2192a576$var$batchQueue.delete(hostname);
    $9f85954b2192a576$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $9f85954b2192a576$var$addToBatch = (hostname, item)=>{
    if (!$9f85954b2192a576$var$batchQueue.has(hostname)) $9f85954b2192a576$var$batchQueue.set(hostname, []);
    $9f85954b2192a576$var$batchQueue.get(hostname).push(item);
    if ($9f85954b2192a576$var$batchTimeouts.has(hostname)) clearTimeout($9f85954b2192a576$var$batchTimeouts.get(hostname));
    $9f85954b2192a576$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $9f85954b2192a576$var$executeBatch(hostname);
    }, $9f85954b2192a576$var$BATCH_DELAY));
};
const $9f85954b2192a576$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $8P7DW.useRef)(false);
    const scheduledRegister = (0, $8P7DW.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $9f85954b2192a576$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};

});


parcelRegister("4sVTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ff2159f02df4d59$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $73ark = parcelRequire("73ark");
const $8ff2159f02df4d59$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $8ff2159f02df4d59$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $8ff2159f02df4d59$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
const $8ff2159f02df4d59$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $8P7DW.useContext)((0, $73ark.SmartCardContext));
    return hasSmartCardProvider && $8ff2159f02df4d59$export$aa45d36a96427452(href);
};
var $8ff2159f02df4d59$export$2e2bcd8739ae039 = $8ff2159f02df4d59$var$useResolveHyperlinkValidator;

});

parcelRegister("lvhBd", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $29002564806abca8$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $29002564806abca8$export$eaff10f7ec59c455);

var $8P7DW = parcelRequire("8P7DW");

var $8gu7I = parcelRequire("8gu7I");

var $1EFS8 = parcelRequire("1EFS8");

var $bsdWy = parcelRequire("bsdWy");

var $73ark = parcelRequire("73ark");

var $lat3P = parcelRequire("lat3P");

var $e6Qdr = parcelRequire("e6Qdr");

var $7UlKc = parcelRequire("7UlKc");

var $hHhPM = parcelRequire("hHhPM");
const $29002564806abca8$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>{
    var _details$meta, _details$meta2;
    return {
        definitionId: (details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId) ?? null,
        resourceType: (details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.resourceType) ?? null,
        ...(0, $bsdWy.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    };
};
const $29002564806abca8$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const isHyperlinkConnectExperimentEnabled = (0, $1EFS8.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $1EFS8.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false);
    const resolvedAttributes = isHyperlinkConnectExperimentEnabled ? $29002564806abca8$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error) : $29002564806abca8$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $hHhPM.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $29002564806abca8$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $73ark.useSmartLinkContext)();
    const state = store ? (0, $lat3P.getUrl)(store, url) : undefined;
    return (0, $8P7DW.useMemo)(()=>{
        return $29002564806abca8$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state === null || state === void 0 ? void 0 : state.details,
            source: source,
            status: state === null || state === void 0 ? void 0 : state.status,
            url: url,
            error: state === null || state === void 0 ? void 0 : state.error
        });
    }, [
        display,
        id,
        source,
        state === null || state === void 0 ? void 0 : state.details,
        state === null || state === void 0 ? void 0 : state.status,
        url,
        state === null || state === void 0 ? void 0 : state.error
    ]);
};
const $29002564806abca8$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $7UlKc.useSmartCardState)(url);
    const data = $29002564806abca8$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $e6Qdr.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: data
    }, children);
};

});
parcelRegister("bsdWy", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $205f36768967fb06$export$7243431f5325a7b);

var $cE8LQ = parcelRequire("cE8LQ");

var $2FllC = parcelRequire("2FllC");

var $e6Qdr = parcelRequire("e6Qdr");
const $205f36768967fb06$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    var _details$meta, _details$meta2, _details$meta3, _details$meta4, _details$meta5, _details$meta6, _details$meta7, _details$meta8, _details$meta9, _details$meta0, _details$meta1;
    const status = linkStatus ?? (details && (0, $cE8LQ.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $2FllC.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: (details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 || (_details$meta = _details$meta.requestAccess) === null || _details$meta === void 0 ? void 0 : _details$meta.accessType) ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $e6Qdr.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? (details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key) ?? (error === null || error === void 0 ? void 0 : error.extensionKey) ?? null : (details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.key) ?? null,
        destinationTenantId: (details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.tenantId) ?? null,
        destinationActivationId: (details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.activationId) ?? null,
        destinationContainerId: (details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.containerId) ?? null,
        destinationCategory: (details === null || details === void 0 || (_details$meta7 = details.meta) === null || _details$meta7 === void 0 ? void 0 : _details$meta7.category) ?? null,
        destinationProduct: (details === null || details === void 0 || (_details$meta8 = details.meta) === null || _details$meta8 === void 0 ? void 0 : _details$meta8.product) ?? null,
        destinationSubproduct: (details === null || details === void 0 || (_details$meta9 = details.meta) === null || _details$meta9 === void 0 ? void 0 : _details$meta9.subproduct) ?? null,
        destinationObjectId: (details === null || details === void 0 || (_details$meta0 = details.meta) === null || _details$meta0 === void 0 ? void 0 : _details$meta0.objectId) ?? null,
        destinationObjectType: (details === null || details === void 0 || (_details$meta1 = details.meta) === null || _details$meta1 === void 0 ? void 0 : _details$meta1.resourceType) ?? null,
        canBeDatasource: ((details === null || details === void 0 ? void 0 : details.datasources) || []).length > 0
    };
};

});
parcelRegister("2FllC", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $839178bbc5d835cf$export$28ddbae335bd80b5);
const $839178bbc5d835cf$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});



parcelRegister("1mjzP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d890c1b8ff1fec9b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $33yvY = parcelRequire("33yvY");
/**
 * HOC to wrap component with IntlProvider if not available
 */ const $d890c1b8ff1fec9b$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, props);
        return props !== null && props !== void 0 && props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $33yvY.default), {
            locale: "en"
        }, content);
    };
var $d890c1b8ff1fec9b$export$2e2bcd8739ae039 = $d890c1b8ff1fec9b$var$withIntlProvider;

});

parcelRegister("LnJME", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkEvents", () => $614b647fb72c5d7e$export$ed70996d478e16d3);
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $614b647fb72c5d7e$export$e682245dc886cff2);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $hHhPM = parcelRequire("hHhPM");
function $614b647fb72c5d7e$export$ed70996d478e16d3() {
    /**
   * this utility maybe extended in the future to include
   * more contextual info about SLs
   */ const events = (0, $8P7DW.useMemo)(()=>new (0, $hHhPM.SmartLinkEvents)(), []);
    return events;
}
function $614b647fb72c5d7e$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    return ()=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});

parcelRegister("6pux3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5da7f5a6a27e3dbe$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");

var $kwzIf = parcelRequire("kwzIf");

var $aoJZN = parcelRequire("aoJZN");

var $gAwhe = parcelRequire("gAwhe");
const $5da7f5a6a27e3dbe$var$HyperlinkUnauthorizedView = ({ onAuthorize: onAuthorize, provider: provider, showConnectBtn: showConnectBtn, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gAwhe.default), props), showConnectBtn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aoJZN.ActionButton), {
        onClick: onAuthorize,
        testId: "button-connect-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fiikg.default), {
        ...(0, $kwzIf.messages).connect_link_account_card_name,
        values: {
            context: provider === null || provider === void 0 ? void 0 : provider.text
        }
    }))));
};
var $5da7f5a6a27e3dbe$export$2e2bcd8739ae039 = $5da7f5a6a27e3dbe$var$HyperlinkUnauthorizedView;

});
parcelRegister("kwzIf", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3c1683b22498f327$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $3c1683b22498f327$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: 'Title for a section or menu containing available actions for a resource.'
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    change_status: {
        id: 'fabric.linking.change_status',
        defaultMessage: 'Change status: {status}',
        description: 'Aria label for the button to change the status of a linked resource.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'Cancel the current action or close the modal.'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: 'Close the current screen or modal.'
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}',
        description: 'Indicates the number of components the resource is applied to.'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'Continue to the next step.'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: 'Action to copy the URL of the link to the clipboard.'
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: 'Action to download the resource.'
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_modal: {
        id: 'fabric.linking.preview_modal',
        defaultMessage: 'Open preview modal',
        description: 'Button used to view a modal view of your content without needing to navigate to it.'
    },
    preview_panel: {
        id: 'fabric.linking.preview_panel',
        defaultMessage: 'Open preview panel',
        description: 'Button used to view a side panel view of your content without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    rovo_actions_explore: {
        id: 'fabric.linking.rovo_actions_explore-non-final',
        defaultMessage: 'Explore',
        description: 'Label for the Rovo Actions button that allows users to explore AI actions for a link'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Indicates the count of team member'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    },
    follow_project_descriptionGalaxia: {
        id: 'fabric.linking.follow_project_description-galaxia',
        defaultMessage: 'Follow to get notifications on this space',
        description: 'Description on what Follow does'
    },
    follow_project_errorGalaxia: {
        id: 'fabric.linking.follow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    unfollow_project_descriptionGalaxia: {
        id: 'fabric.linking.unfollow_project_description-galaxia',
        defaultMessage: 'Unfollow to stop receiving space notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project_errorGalaxia: {
        id: 'fabric.linking.unfollow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    connect_unauthorised_account_description_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description-appify',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider-appify',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    learn_more_about_connecting_account_appify: {
        id: 'fabric.linking.learn_more_about_connecting_account-appify',
        defaultMessage: 'Learn more about connecting your account to Atlassian apps.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: 'fabric.linking.learn_more_about_connecting_account_experiment_short',
        defaultMessage: 'Turn your URLs into rich, interactive previews.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    rovo_summary_loading: {
        id: 'fabric.linking.rovo_summary.loading.non-final',
        defaultMessage: 'Rovo is thinking',
        description: 'Shown when a Rovo summary is loading, indicating that the AI is generating a summary for the user.'
    },
    ai_disclaimer: {
        id: 'fabric.linking.rovo_summary.ai_disclaimer.non-final',
        defaultMessage: 'Uses AI. Verify Results.',
        description: 'Shown on a Rovo summary to indicate that the summary was generated by AI and should be verified by the user for accuracy.'
    },
    rovo_unauthorised_title: {
        id: 'fabric.linking.rovo_unauthorised.title',
        defaultMessage: 'Get smarter workflows by connecting your {context} account',
        description: 'Banner headline in Rovo unauthorised hover card header. {context} is the third-party provider name (e.g. Google).'
    },
    rovo_unauthorised_title_no_provider: {
        id: 'fabric.linking.rovo_unauthorised.title_no_provider',
        defaultMessage: 'Get smarter workflows by connecting your account',
        description: 'Banner headline in Rovo unauthorised hover card header when the provider name is unknown.'
    },
    rovo_unauthorised_feature_clear_link_names: {
        id: 'fabric.linking.rovo_unauthorised.feature.clear_link_names',
        defaultMessage: 'Turn long URL into clear link names',
        description: 'First feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_understand_linked_docs: {
        id: 'fabric.linking.rovo_unauthorised.feature.understand_linked_docs',
        defaultMessage: 'Understand linked docs in seconds',
        description: 'Second feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_go_deeper_smart_suggestions: {
        id: 'fabric.linking.rovo_unauthorised.feature.go_deeper_smart_suggestions',
        defaultMessage: 'Go deeper with smart suggestions',
        description: 'Third feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_connect_account: {
        id: 'fabric.linking.rovo_unauthorised.connect_account',
        defaultMessage: 'Connect',
        description: 'Primary action button in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_not_now: {
        id: 'fabric.linking.rovo_unauthorised.not_now',
        defaultMessage: 'Maybe later',
        description: 'Secondary action in Rovo unauthorised hover card.'
    },
    rovo_prompt_context_generic: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'page',
        description: 'The location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_generic_plural: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'pages',
        description: 'The site-wide location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_confluence_page: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'Confluence page',
        description: 'The Confluence page the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_confluence_page_short: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page_short.non-final',
        defaultMessage: 'page',
        description: 'The Confluence page the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_jira_work_item: {
        id: 'fabric.linking.rovo_prompt_context_jira_work_item.non-final',
        defaultMessage: 'Jira work item',
        description: 'The Jira work item the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_jira_work_item_short: {
        id: 'fabric.linking.rovo_prompt_context_jira_work_item_short.non-final',
        defaultMessage: 'work item',
        description: 'The Jira work item the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_button_recommend_other_sources: {
        id: 'fabric.linking.rovo_prompt_button_recommend_other_sources.non-final',
        defaultMessage: 'Recommend other sources',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_recommend_other_sources: {
        id: 'fabric.linking.rovo_prompt_message_recommend_other_sources.non-final',
        defaultMessage: "<p>From this <a>{url}</a> and the {context} I\u2019m viewing now as context:</p><ul><li><p>Search across all sources I can access for items that discuss <b>similar concepts, themes, or problems</b>, or that <b>reference similar or closely related sources</b> (including links to the same or related pages, issues, or docs).</p></li><li><p>Return the results as a list or table with columns: <code>Item</code>, <code>Type</code>, <code>Short summary</code>, and <code>Why it\u2019s similar</code>.</p></li><li><p>For each result, give a one\u2011sentence <b>Short summary</b> of what the item is about.</p></li><li><p>In <b>Why it\u2019s similar</b>, briefly explain (in a phrase or short sentence) what makes it related to this Smart Link and/or the item I\u2019m viewing (for example: same project, similar decision, shared requirements, overlapping stakeholders, similar metrics, or referencing related docs).</p></li><li><p>Order the list from <b>most to least relevant</b> based on Rovo\u2019s assessment of semantic similarity to both the Smart Link target and the current item.  Prioritize items that I do not own or have not contributed to.</p></li><li><p>If there are more than 5 results, show the <b>5 most relevant</b> and state how many additional items you found.</p></li></ul>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_show_other_mentions: {
        id: 'fabric.linking.rovo_prompt_button_show_other_mentions.non-final',
        defaultMessage: 'Show other mentions',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_show_other_mentions: {
        id: 'fabric.linking.rovo_prompt_message_show_other_mentions.non-final',
        defaultMessage: "<p>From <a>{url}</a> and the {context} I\u2019m viewing now:</p><ul><li><p>Search across all Confluence pages and Jira work items I can access for other items that contain this exact Smart Link (same underlying URL/resource).</p></li><li><p>List all matching items in a table with columns: <code>Item</code>, <code>Type</code>, <code>Short summary</code>, <code>How this item uses the link</code>, and <code>Relevance to current item</code>.</p></li><li><p>For <code>Short summary</code>, give a one\u2011sentence description of what the {context} is about.</p></li><li><p>For <code>How this item uses the link</code>, briefly explain the role this link plays there (e.g., decision doc, background context, implementation details, status update).</p></li><li><p>For <code>Relevance to current item</code>, compare each item to the {context} I\u2019m viewing now and label it <code>High</code>, <code>Medium</code>, or <code>Low</code> relevance, with a short reason (a phrase or single clause).</p></li><li><p>If there are more than 15 matches, show the 15 most relevant and tell me how many additional matches exist.</p></li></ul>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_suggest_improvement: {
        id: 'fabric.linking.rovo_prompt_button_suggest_improvement.non-final',
        defaultMessage: 'Suggest {context} improvement',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_suggest_improvement: {
        id: 'fabric.linking.rovo_prompt_message_suggest_improvement.non-final',
        defaultMessage: "<p>Using the {context} I\u2019m viewing now, plus all files and links referenced in it (including <a>{url}</a>):</p><ul><li><p>Identify unclear reasoning, missing context, or contradictions between the item and its linked files.</p></li><li><p>Call out any places where assumptions are not backed up by data or prior docs.</p></li><li><p>Stay concise: summarize your findings in <b>no more than three short paragraphs of content listed as bullets</b> of no more than a couple of sentences long focused only on the two points above.</p></li><li><p>After presenting that summary, <b>ask me explicitly</b> if I want you to go deeper. Only if I say yes, then:</p><ul><li><p>Suggest concrete rewrites (bullets or short paragraphs) to make the argument clearer, more concise, and better aligned with the supporting files.</p></li><li><p>Propose 3\u20135 follow\u2011up edits or additions that would make this item and its linked docs \u201Cshare\u2011ready\u201D for stakeholders.</p></li></ul></li></ul>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_message_summarize: {
        id: 'fabric.linking.rovo_prompt_message_summarize.non-final',
        defaultMessage: '<p>Summarize the main ideas and key points of <a>{url}</a> in 3-5 clear, complete sentences.</p><p>Preserve any important details such as names, dates, and key decisions.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_key_highlights: {
        id: 'fabric.linking.rovo_prompt_button_key_highlights.non-final',
        defaultMessage: 'Key highlights',
        description: 'The name of the action to send a key highlights prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_key_highlights: {
        id: 'fabric.linking.rovo_prompt_message_key_highlights.non-final',
        defaultMessage: "<p>Based on <a>{url}</a> and the page or ticket I'm currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_button_ask_rovo.non-final',
        defaultMessage: 'Ask Rovo',
        description: 'The name of the action to open Rovo Chat and ask a question in relation to current Smart Link'
    },
    rovo_prompt_message_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_message_ask_rovo_anything.non-final',
        defaultMessage: '`I have a question about this linked item` {url}',
        description: "The placeholder prompt message pre-filled in Rovo Chat input. {url} refers to the Smart Link URL. This is not auto-submitted \u2014 the user types their question."
    }
});

});

parcelRegister("aoJZN", function(module, exports) {
$parcel$export(module.exports, "ActionButton", () => $d9e0eb5521621efd$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $bgvtM = parcelRequire("bgvtM");
const $d9e0eb5521621efd$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhkby5v",
    unauthorised: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13lilb4i _mrkblb4i _ca0qt94y _n3tdt94y _2hwxt94y _k48pi7a9 _irr31q28 _1di612kk",
    action: "_x3doia51 _1s7zia51 _n7zlia51 _syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13liidpf _mrkbidpf _2hwxv77o _k48pi7a9 _o5721q9c _4cvxq98m _irr31q28 _1di612kk"
};
const $d9e0eb5521621efd$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', ...props }, ref)=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $bgvtM.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $d9e0eb5521621efd$var$styles.button
    }, /*#__PURE__*/ $8P7DW.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $8n1kL.default)([
            $d9e0eb5521621efd$var$styles.innerContainer,
            isDisabled ? $d9e0eb5521621efd$var$styles.disabled : viewType === 'unauthorised' ? $d9e0eb5521621efd$var$styles.unauthorised : $d9e0eb5521621efd$var$styles.enabled
        ])
    }, children));
});

});



parcelRegister("lkIQ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a5d3e6844836dc7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $fiikg = parcelRequire("fiikg");
var $3SD6z = parcelRequire("3SD6z");
var $33yvY = parcelRequire("33yvY");

var $ifRQf = parcelRequire("ifRQf");

var $2XLqF = parcelRequire("2XLqF");

var $gtaKc = parcelRequire("gtaKc");
var $7KiOn = parcelRequire("7KiOn");
var $fCWQD = parcelRequire("fCWQD");
var $9euwv = parcelRequire("9euwv");
var $gMGo9 = parcelRequire("gMGo9");
var $33zHl = parcelRequire("33zHl");

var $kwzIf = parcelRequire("kwzIf");
const $4a5d3e6844836dc7$var$breakWordsCss = null;
const $4a5d3e6844836dc7$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $8P7DW.createElement((0, $33zHl.default), null, isOpen && /*#__PURE__*/ $8P7DW.createElement((0, $gtaKc.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $9euwv.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $8P7DW.createElement((0, $gMGo9.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $fiikg.default), (0, $kwzIf.messages).check_this_link))), /*#__PURE__*/ $8P7DW.createElement((0, $7KiOn.default), null, /*#__PURE__*/ $8P7DW.createElement("div", {
        className: (0, $8n1kL.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $8P7DW.createElement((0, $fiikg.default), {
        ...(0, $kwzIf.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $8P7DW.createElement((0, $2XLqF.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $fCWQD.default), null, /*#__PURE__*/ $8P7DW.createElement((0, $ifRQf.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $8P7DW.createElement((0, $fiikg.default), (0, $kwzIf.messages).go_back)), /*#__PURE__*/ $8P7DW.createElement((0, $ifRQf.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $8P7DW.createElement((0, $fiikg.default), (0, $kwzIf.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $8P7DW.createElement((0, $33yvY.default), {
        locale: "en"
    }, content);
};
const $4a5d3e6844836dc7$var$_default_1 = (0, $3SD6z.default)($4a5d3e6844836dc7$var$WarningModal, {
    enforceContext: false
});
var $4a5d3e6844836dc7$export$2e2bcd8739ae039 = $4a5d3e6844836dc7$var$_default_1;

});

parcelRegister("djI3I", function(module, exports) {
$parcel$export(module.exports, "useLinkWarningModal", () => $45551257d4996bb9$export$32b76c003683c2ec);

var $8P7DW = parcelRequire("8P7DW");

var $MmGmU = parcelRequire("MmGmU");

var $fLZVz = parcelRequire("fLZVz");

var $hHhPM = parcelRequire("hHhPM");
const $45551257d4996bb9$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $45551257d4996bb9$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $8P7DW.useState)(null);
    const [url, setUrl] = (0, $8P7DW.useState)(null);
    const [isOpen, setIsOpen] = (0, $8P7DW.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $hHhPM.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $hHhPM.ANALYTICS_CHANNEL));
    };
    /**
   * It checks and warns if a link text is a URL and different from an actual link destination
   */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $fLZVz.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $45551257d4996bb9$var$toUrl(href, window.location.origin);
        const linkTextUrl = $45551257d4996bb9$var$toUrl(normalisedUrlFromLinkText, hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = (hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin) === currentAtlassianProductOrigin && (linkTextUrl === null || linkTextUrl === void 0 ? void 0 : linkTextUrl.origin) === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("fLZVz", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $be51082fb3ef5e49$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $be51082fb3ef5e49$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $hcXsa = parcelRequire("hcXsa");
const $be51082fb3ef5e49$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($hcXsa)))();
$be51082fb3ef5e49$var$linkify.add('sourcetree:', 'http:');
$be51082fb3ef5e49$var$linkify.add('jamfselfservice:', 'http:');
$be51082fb3ef5e49$var$linkify.add('notes:', 'http:');
const $be51082fb3ef5e49$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $be51082fb3ef5e49$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$be51082fb3ef5e49$var$tlds.push($be51082fb3ef5e49$var$tlds2Char);
$be51082fb3ef5e49$var$linkify.tlds($be51082fb3ef5e49$var$tlds, false);
const $be51082fb3ef5e49$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $be51082fb3ef5e49$var$normaliseLinkHref = (url)=>{
    const match = $be51082fb3ef5e49$var$getLinkMatch(url);
    return match && match.url || null;
};
const $be51082fb3ef5e49$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $be51082fb3ef5e49$var$linkifyMatch(str);
    if (!match.length) match = $be51082fb3ef5e49$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $be51082fb3ef5e49$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $be51082fb3ef5e49$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$be51082fb3ef5e49$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($be51082fb3ef5e49$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($be51082fb3ef5e49$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $be51082fb3ef5e49$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $be51082fb3ef5e49$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $be51082fb3ef5e49$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($be51082fb3ef5e49$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $be51082fb3ef5e49$var$normaliseLinkHref(urlWithoutNewlines);
}

});




parcelRegister("68JCX", function(module, exports) {
$parcel$export(module.exports, "default", () => $73b17b5e72eed136$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $73b17b5e72eed136$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("94y8N", function(module, exports) {
$parcel$export(module.exports, "default", () => $9361f5ac4fab7e45$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $9361f5ac4fab7e45$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $gWgPx.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("2Kc0g", function(module, exports) {
$parcel$export(module.exports, "default", () => $3145c990e0104dd5$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $3145c990e0104dd5$var$isSub = (type)=>{
    return type === 'sub';
};
function $3145c990e0104dd5$export$2e2bcd8739ae039(props) {
    if ($3145c990e0104dd5$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gWgPx.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gWgPx.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("22U5P", function(module, exports) {
$parcel$export(module.exports, "default", () => $e189f860d0208aa1$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $l0Qcj = parcelRequire("l0Qcj");

var $eQXML = parcelRequire("eQXML");

var $kHnjK = parcelRequire("kHnjK");
function $e189f860d0208aa1$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $eQXML.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $eQXML.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $l0Qcj.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $8P7DW.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("eQXML", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $98277e790ea9d271$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $98277e790ea9d271$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $98277e790ea9d271$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $98277e790ea9d271$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #357DE8)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #1558BC)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #2898BD)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #206A83)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #22A06B)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #216E4E)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FCA700)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #E06C00)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #C9372C)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #AE2E24)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #AF59E1)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #803FA5)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #7D818A)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #292A2E)" // source for hex code was legacy token N800
};

});


parcelRegister("7Xf3E", function(module, exports) {
$parcel$export(module.exports, "default", () => $a74ff332c12712bc$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $l0Qcj = parcelRequire("l0Qcj");

var $jfqSC = parcelRequire("jfqSC");

var $kHnjK = parcelRequire("kHnjK");
function $a74ff332c12712bc$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $kHnjK.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $jfqSC.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $l0Qcj.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $8P7DW.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    if (props.isStandalone) return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "background-color-padding-left background-color-padding-right",
            children: props.children
        })
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("jfqSC", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $9e8eecdf65434714$export$8b58ff1b36bb75e0);
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $9e8eecdf65434714$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #EED7FC)"
};
function $9e8eecdf65434714$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $9e8eecdf65434714$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("4LeSa", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d1d318401daeb5d$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $5d1d318401daeb5d$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gWgPx.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("gRg1L", function(module, exports) {
$parcel$export(module.exports, "default", () => $b89c992314004a39$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $e7vUY = parcelRequire("e7vUY");

var $h2boN = parcelRequire("h2boN");

var $13svG = parcelRequire("13svG");

var $lnxsR = parcelRequire("lnxsR");
function $b89c992314004a39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Legacy centering (breaks position: sticky in nested content).
const $b89c992314004a39$var$legacyWrapperStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $e7vUY.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
const $b89c992314004a39$var$flexWrapperStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $e7vUY.blockNodesVerticalMargin)} 0`
});
// Flex item: no vertical margin so flex container height = content height (matches legacy single-wrapper height).
// flexShrink: 0 so the inner div keeps its width (matches legacy behaviour; flex items default to flex-shrink: 1).
const $b89c992314004a39$var$innerWrapperStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $b89c992314004a39$var$getWidth = (width, mode)=>{
    if ((0, $h2boN.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) {
            if (mode === 'max' || typeof width === 'number' && width >= (0, $e7vUY.akEditorFullWidthLayoutWidth)) return `min(${0, $e7vUY.akEditorMaxLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        }
        if (mode === 'full-width') return `min(${0, $e7vUY.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $b89c992314004a39$export$2e2bcd8739ae039(props) {
    const width = $b89c992314004a39$var$getWidth('width' in props ? props.width : null, props.mode);
    const useStickySafeCentering = (0, $13svG.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    if (useStickySafeCentering) return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $lnxsR.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER + ' ' + (0, $lnxsR.RendererCssClassName).FLEX_CENTER_WRAPPER,
        css: $b89c992314004a39$var$flexWrapperStyles
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $b89c992314004a39$var$innerWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $lnxsR.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} fabric-editor-breakout-mark fabric-editor-block-mark`,
        "data-mode": props.mode,
        ...(0, $h2boN.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: width
        }
    }, props.children));
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $b89c992314004a39$var$legacyWrapperStyles,
        "data-mode": props.mode,
        ...(0, $h2boN.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: $b89c992314004a39$var$getWidth('width' in props ? props.width : null, props.mode)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-breakout-mark fabric-editor-block-mark"
    }, props.children);
}

});

parcelRegister("iUNsq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7f10c17396552cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $bJhS2 = parcelRequire("bJhS2");
const $a7f10c17396552cb$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $bJhS2.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $a7f10c17396552cb$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8Z0o8.jsx)($a7f10c17396552cb$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("3Xnji", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f86de4ba1908a15$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $0f86de4ba1908a15$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}

});

parcelRegister("d9u15", function(module, exports) {
$parcel$export(module.exports, "default", () => $92bc4a3fe081ca9f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $92bc4a3fe081ca9f$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("fekM0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8119f138e5272de5$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $8119f138e5272de5$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("43lIe", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf1845df00c37fea$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $cf1845df00c37fea$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $gWgPx.jsx)(WrapperElement, {
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("hw2Pj", function(module, exports) {
$parcel$export(module.exports, "default", () => $7996dc163ed59f4f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $7996dc163ed59f4f$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $gWgPx.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("iUSHY", function(module, exports) {
$parcel$export(module.exports, "default", () => $62941602f970b148$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");
function $62941602f970b148$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("bDSKY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2ebccf93ceebfa3$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
function $f2ebccf93ceebfa3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-font-size",
        "data-font-size": props.fontSize,
        children: props.children
    });
}

});

parcelRegister("bpyyy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c76dd6c3d0d44b8b$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
class $c76dd6c3d0d44b8b$export$2e2bcd8739ae039 extends (0, $8P7DW.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}

});


parcelRegister("2H278", function(module, exports) {
$parcel$export(module.exports, "insideBreakoutLayout", () => $b5f85c6a44522648$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBreakoutExpand", () => $b5f85c6a44522648$export$3e763fd7277c58c5);
$parcel$export(module.exports, "insideBlockNode", () => $b5f85c6a44522648$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $b5f85c6a44522648$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $b5f85c6a44522648$export$244bf4b32387ef62);
$parcel$export(module.exports, "getNestedUnderNodes", () => $b5f85c6a44522648$export$a8df1f99c673fa27);
const $b5f85c6a44522648$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $b5f85c6a44522648$var$isExpandNode = (node)=>node.type.name === 'expand';
const $b5f85c6a44522648$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $b5f85c6a44522648$export$d7bc71cca336a3b = (path)=>path.some((item)=>$b5f85c6a44522648$var$isLayoutNode(item) && $b5f85c6a44522648$var$hasBreakOutMark(item));
const $b5f85c6a44522648$export$3e763fd7277c58c5 = (path)=>path.some((item)=>$b5f85c6a44522648$var$isExpandNode(item) && $b5f85c6a44522648$var$hasBreakOutMark(item));
const $b5f85c6a44522648$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $b5f85c6a44522648$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $b5f85c6a44522648$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};
const $b5f85c6a44522648$export$a8df1f99c673fa27 = (path, nodeTypeNames)=>{
    for (const node of path){
        if (nodeTypeNames.includes(node.type.name)) return node.type.name;
    }
    return undefined;
};

});

parcelRegister("SmqKH", function(module, exports) {
$parcel$export(module.exports, "getStandaloneBackgroundColorMarks", () => $29057f0bca35c449$export$eeb66772b38d7581);

var $3gJSl = parcelRequire("3gJSl");
const $29057f0bca35c449$export$eeb66772b38d7581 = (content)=>{
    const standaloneMarks = [];
    // keep track of the previous node's state
    let prev = {
        selfSpaceOnTheRight: true // initial value to handle leading BackgroundColor
    };
    let prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(let i = 0; i < content.length; i++){
        const node = content[i];
        const nodeMarks = (0, $3gJSl.default).getMarks(node);
        const isBackgroundColor = nodeMarks.some((m)=>m.type.name === 'backgroundColor');
        let selfSpaceOnTheLeft = false;
        let selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    const mark = (0, $3gJSl.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            const mark = (0, $3gJSl.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
            if (mark) standaloneMarks.push(mark);
        }
    }
    return standaloneMarks;
};

});

parcelRegister("6vTsK", function(module, exports) {
$parcel$export(module.exports, "markBlockAsInline", () => $7f5a12a52a5357e3$export$3a88c97d9b0d8d1c);
function $7f5a12a52a5357e3$export$3a88c97d9b0d8d1c({ nodes: nodes, onMark: onMark, parentPos: parentPos, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline }) {
    if (!nodes || nodes.length === 0 || nodes[0].isInline) return;
    function isInlineBodiedExtension(node) {
        var _node$attrs, _node$attrs2, _node$attrs3, _node$attrs4;
        return Boolean((node === null || node === void 0 ? void 0 : node.type.name) === 'bodiedExtension' && shouldDisplayExtensionAsInline({
            type: node.type.name,
            extensionKey: (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionKey,
            extensionType: (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionType,
            parameters: (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.parameters,
            content: node.content,
            localId: (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId
        }));
    }
    try {
        let prevPos = parentPos;
        let pos = parentPos;
        let prevTextBlockType;
        for (const [index, node] of nodes.entries()){
            const prevNode = nodes[index - 1];
            // textblock + inlinedBodiedExtension
            if (prevNode !== null && prevNode !== void 0 && prevNode.isTextblock && isInlineBodiedExtension(node)) onMark({
                pos: prevPos
            });
            else if (isInlineBodiedExtension(prevNode) && node.isTextblock && (!prevTextBlockType || node.type === prevTextBlockType)) onMark({
                pos: pos
            });
            if (!isInlineBodiedExtension(node)) prevTextBlockType = node.isTextblock ? node.type : undefined;
            prevPos = pos;
            pos += node.nodeSize;
        }
    } catch  {}
}

});


parcelRegister("9NvnD", function(module, exports) {
$parcel$export(module.exports, "renderDocument", () => $2dde52e3e2016738$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $2WmUO = parcelRequire("2WmUO");

var $imUSq = parcelRequire("imUSq");
var $8jHQ1 = parcelRequire("8jHQ1");
var $8Fw2S = parcelRequire("8Fw2S");

var $eguiP = parcelRequire("eguiP");

var $fZ6KA = parcelRequire("fZ6KA");
var $2AMqz = parcelRequire("2AMqz");

var $akJ5e = parcelRequire("akJ5e");

var $e6Qdr = parcelRequire("e6Qdr");

var $13svG = parcelRequire("13svG");

var $hXXvg = parcelRequire("hXXvg");

var $jS5mX = parcelRequire("jS5mX");

var $f3Ytk = parcelRequire("f3Ytk");

var $3pW7R = parcelRequire("3pW7R");
const $2dde52e3e2016738$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $2dde52e3e2016738$var$withStopwatch = (cb)=>{
    const startTime = $2dde52e3e2016738$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $2dde52e3e2016738$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $2dde52e3e2016738$var$_validation = (doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $8jHQ1.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $eguiP.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER,
            eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $2AMqz.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $akJ5e.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $8Fw2S.transformNestedTablesIncomingDocument)(result);
        if (isTransformed) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $eguiP.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER,
                eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $eguiP.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER,
            eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $jS5mX.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    if (result && !(0, $13svG.expValEquals)('cc-maui-experiment', 'isEnabled', true) && (0, $e6Qdr.fg)('platform_editor_native_embeds_fallback_transform')) {
        const { transformedAdf: transformedAdf, hasValidTransform: hasValidTransform } = (0, $imUSq.nativeEmbedsFallbackTransform)(result);
        if (hasValidTransform && transformedAdf) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $eguiP.ACTION).NATIVE_EMBEDS_TRANSFORMED,
                actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER,
                eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    }
    return result;
};
const $2dde52e3e2016738$var$memoValidation = (0, $hXXvg.default)($2dde52e3e2016738$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ newSkipValidation, newValidationOverrides] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ oldSkipValidation, oldValidationOverrides] = lastArgs;
    return $2dde52e3e2016738$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2dde52e3e2016738$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $2dde52e3e2016738$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $2dde52e3e2016738$var$memoSerializeFragment = (0, $hXXvg.default)($2dde52e3e2016738$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $2dde52e3e2016738$var$areDocsEqual(newDoc, oldDoc);
});
const $2dde52e3e2016738$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $eguiP.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $jS5mX.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $2dde52e3e2016738$var$memoCreateNodeAndCheck = (0, $hXXvg.default)($2dde52e3e2016738$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $2dde52e3e2016738$var$areDocsEqual(newDoc, oldDoc);
});
const $2dde52e3e2016738$export$59a54f98b9753d5c = (doc, serializer, schema = (0, $2WmUO.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    if ((0, $e6Qdr.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $2dde52e3e2016738$var$withStopwatch(()=>{
        return $2dde52e3e2016738$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $2dde52e3e2016738$var$withStopwatch(()=>{
        return $2dde52e3e2016738$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $2dde52e3e2016738$var$withStopwatch(()=>{
        return $2dde52e3e2016738$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $fZ6KA.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking !== null && unsupportedContentLevelsTracking !== void 0 && unsupportedContentLevelsTracking.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $f3Ytk.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $3pW7R.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("imUSq", function(module, exports) {
$parcel$export(module.exports, "nativeEmbedsFallbackTransform", () => $510cf4c0600ce426$export$fdee1e5f1664414c);

var $1CVmW = parcelRequire("1CVmW");

var $8o5I3 = parcelRequire("8o5I3");
const $510cf4c0600ce426$var$NATIVE_EMBED_EXTENSION_KEY = 'native-embed';
const $510cf4c0600ce426$export$fdee1e5f1664414c = (adf)=>{
    let didTransform = false;
    const transformedAdf = (0, $1CVmW.traverse)(adf, {
        extension: (node)=>{
            var _node$attrs, _node$attrs2;
            if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs['extensionKey'].split(':')[0]) !== $510cf4c0600ce426$var$NATIVE_EMBED_EXTENSION_KEY) return node;
            const url = (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2['parameters']) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.macroParams) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.url) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.value;
            if (!url) {
                didTransform = true;
                return false;
            }
            didTransform = true;
            return {
                type: 'paragraph',
                content: [
                    {
                        type: 'inlineCard',
                        attrs: {
                            url: url
                        }
                    }
                ]
            };
        }
    });
    if (didTransform && transformedAdf) try {
        const validate = (0, $8o5I3.validator)();
        const { valid: valid } = validate(transformedAdf);
        if (!valid) // Transformed ADF is invalid – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    } catch  {
        // Validation threw – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    }
    return {
        transformedAdf: transformedAdf,
        hasValidTransform: didTransform
    };
};

});
parcelRegister("8o5I3", function(module, exports) {
$parcel$export(module.exports, "validator", () => $a61f929251704e08$export$956325f45c5d174a);

var $akJdH = parcelRequire("akJdH");

var $dWY5g = parcelRequire("dWY5g");

var $fZqur = parcelRequire("fZqur");

var $7kbxO = parcelRequire("7kbxO");

var $66yyx = parcelRequire("66yyx");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a61f929251704e08$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
           * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
           * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
           */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a61f929251704e08$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Checks if a spec is a variant spec.
 * A variant spec is an array where the first element is a string (base spec name)
 * and the second element is a ValidatorSpec object { props: { ... } }
 *
 * @param spec - The spec to check
 * @returns true if the spec is a variant spec, false otherwise
 */ const $a61f929251704e08$var$isVariant = (spec)=>typeof spec === 'object' && !!spec && 0 in spec && 1 in spec && typeof spec[0] === 'string' && typeof spec[1] === 'object';
function $a61f929251704e08$export$a49afc9edc88765c(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($dWY5g).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let spec = {
            ...$dWY5g[k]
        };
        if ((0, $akJdH.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true) && $a61f929251704e08$var$isVariant(spec) && // Only apply to variants which are explicitly marked for override in `variantSpecOverrides`
        Object.values($a61f929251704e08$var$variantSpecOverrides).includes(k)) // This allows the variant spec to also have the content normalization applied to it
        // When the spec is a variant it will be in the form of ['base_spec_name', { props: { ... } }]
        // So the actual validator spec of the variant will be the second item in the array
        // We also need to shallow clone this to ensure we don't mutate the original spec
        spec = {
            ...spec[1]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $fZqur.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $dWY5g[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
           * Flatten
           *
           * Input:
           * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
           *
           * Output:
           * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
           */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items.map((item)=>(0, $fZqur.isString)(item) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($dWY5g[item]) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $dWY5g[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($dWY5g[subItem]) ? // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $dWY5g[subItem] : (0, $fZqur.isString)(subItem) ? subItem : // Now `NoMark` produces `items: []`, should be fixed in generator
                        [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                var _subItem$;
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && (_subItem$ = subItem[1]) !== null && _subItem$ !== void 0 && (_subItem$ = _subItem$.props) !== null && _subItem$ !== void 0 && (_subItem$ = _subItem$.content) !== null && _subItem$ !== void 0 && _subItem$.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
        * TODO: Probably try something like immer, but it's 3.3kb gzipped.
        * Not worth it just for this.
        */ [
                            subItem[0],
                            $a61f929251704e08$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a61f929251704e08$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $a61f929251704e08$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $a61f929251704e08$export$66c739158ef99a42(spec, value) {
    if (!(0, $fZqur.isDefined)(value)) return !!spec.optional;
    if ($a61f929251704e08$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $a61f929251704e08$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $a61f929251704e08$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $fZqur.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $fZqur.isBoolean)(value);
        case 'number':
            return (0, $fZqur.isNumber)(value) && ((0, $fZqur.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $fZqur.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $fZqur.isInteger)(value) && ((0, $fZqur.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $fZqur.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $fZqur.isDefined)((0, $66yyx.validatorFnMap)[rule]) && (0, $66yyx.validatorFnMap)[rule](value);
            return (0, $fZqur.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $fZqur.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $fZqur.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $fZqur.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$a61f929251704e08$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$a61f929251704e08$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $fZqur.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $a61f929251704e08$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $a61f929251704e08$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $a61f929251704e08$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $a61f929251704e08$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else {
        var _parentSpec$props;
        return errorCallback({
            ...child
        }, {
            code: 'INVALID_CONTENT',
            message: message,
            meta: {
                parentType: parentSpec === null || parentSpec === void 0 || (_parentSpec$props = parentSpec.props) === null || _parentSpec$props === void 0 || (_parentSpec$props = _parentSpec$props.type) === null || _parentSpec$props === void 0 ? void 0 : _parentSpec$props.values[0]
            }
        }, $a61f929251704e08$var$getUnsupportedOptions(parentSpec));
    }
};
const $a61f929251704e08$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $a61f929251704e08$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $a61f929251704e08$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
/**
 * Map of base spec names to a preferred variant spec that should be used in their place during validation.
 *
 * WARNING: The variant spec must be a strict superset of the base spec, i.e. any content valid
 * under the base spec must also be valid under the variant
 */ const $a61f929251704e08$var$variantSpecOverrides = {
    listItem: 'listItem_with_flexible_first_child',
    taskList: 'taskList_with_flexible_first_child'
};
/**
 * Replaces base validator specs with their designated variant overrides
 */ const $a61f929251704e08$var$applyVariantSpecOverrides = (validatorSpecs)=>{
    Object.entries($a61f929251704e08$var$variantSpecOverrides).forEach(([base, variant])=>{
        const baseSpec = validatorSpecs[base];
        const variantOverride = validatorSpecs[variant];
        if (baseSpec !== null && baseSpec !== void 0 && baseSpec.props && variantOverride !== null && variantOverride !== void 0 && variantOverride.props && typeof baseSpec.props === 'object' && typeof variantOverride.props === 'object') // Merge variant overrides INTO the base spec
        baseSpec.props = {
            ...baseSpec.props,
            // keeps type, attrs, marks, etc.
            ...variantOverride.props // overrides content (and anything else the variant changes)
        };
    });
};
function $a61f929251704e08$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $a61f929251704e08$export$a49afc9edc88765c(nodes, marks);
    if ((0, $akJdH.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true)) $a61f929251704e08$var$applyVariantSpecOverrides(validatorSpecs);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        if (!allowed) for (const allowed of (0, $7kbxO.extractAllowedContent)(validatorSpecs, entity)){
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            if (validationResult.valid) return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        }
        // If `allowed` was provided or we haven't passed yet, return the initial result
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $a61f929251704e08$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $a61f929251704e08$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $a61f929251704e08$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $a61f929251704e08$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $fZqur.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $fZqur.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$a61f929251704e08$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $fZqur.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $fZqur.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $fZqur.makeArray)(validatorSpec.props.attrs);
            /**
       * Attrs can be union type so try each path
       * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
       * Gotcha: It will always report the last failure.
       */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $a61f929251704e08$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $a61f929251704e08$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $a61f929251704e08$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $a61f929251704e08$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $a61f929251704e08$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $a61f929251704e08$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $a61f929251704e08$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $a61f929251704e08$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $fZqur.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $fZqur.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $a61f929251704e08$var$partitionObject(validatorSpec.props, (k, v)=>{
            var _validatorSpec$requir;
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !((_validatorSpec$requir = validatorSpec.required) !== null && _validatorSpec$requir !== void 0 && _validatorSpec$requir.includes(k)) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $fZqur.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $a61f929251704e08$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $fZqur.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $fZqur.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $a61f929251704e08$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
             * When there's multiple possible branches try all of them.
             * If all of them fails, throw the first one.
             * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
             */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $a61f929251704e08$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("dWY5g", function(module, exports) {
$parcel$export(module.exports, "alignment", () => (parcelRequire("jurrE")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("jurrE")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("jurrE")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("jurrE")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("jurrE")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("jurrE")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("jurrE")).blockquote);
$parcel$export(module.exports, "blockTaskItem", () => (parcelRequire("jurrE")).blockTaskItem);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("jurrE")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("jurrE")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("jurrE")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("jurrE")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("jurrE")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("jurrE")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("jurrE")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("jurrE")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("jurrE")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("jurrE")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("jurrE")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("jurrE")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("jurrE")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("jurrE")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("jurrE")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("jurrE")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("jurrE")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("jurrE")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("jurrE")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("jurrE")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("jurrE")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("jurrE")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("jurrE")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("jurrE")).extension_with_marks);
$parcel$export(module.exports, "fontSize", () => (parcelRequire("jurrE")).fontSize);
$parcel$export(module.exports, "fragment", () => (parcelRequire("jurrE")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("jurrE")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("jurrE")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("jurrE")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("jurrE")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("jurrE")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("jurrE")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("jurrE")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("jurrE")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("jurrE")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("jurrE")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("jurrE")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("jurrE")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("jurrE")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("jurrE")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("jurrE")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("jurrE")).listItem);
$parcel$export(module.exports, "listItem_with_flexible_first_child", () => (parcelRequire("jurrE")).listItem_with_flexible_first_child);
$parcel$export(module.exports, "media", () => (parcelRequire("jurrE")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("jurrE")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("jurrE")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("jurrE")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("jurrE")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("jurrE")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("jurrE")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("jurrE")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("jurrE")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("jurrE")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("jurrE")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("jurrE")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("jurrE")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("jurrE")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("jurrE")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("jurrE")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_font_size", () => (parcelRequire("jurrE")).paragraph_with_font_size);
$parcel$export(module.exports, "paragraph_with_font_size_and_alignment", () => (parcelRequire("jurrE")).paragraph_with_font_size_and_alignment);
$parcel$export(module.exports, "paragraph_with_font_size_and_indentation", () => (parcelRequire("jurrE")).paragraph_with_font_size_and_indentation);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("jurrE")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("jurrE")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("jurrE")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("jurrE")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("jurrE")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("jurrE")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("jurrE")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("jurrE")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("jurrE")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("jurrE")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("jurrE")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("jurrE")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("jurrE")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("jurrE")).taskList);
$parcel$export(module.exports, "taskList_with_flexible_first_child", () => (parcelRequire("jurrE")).taskList_with_flexible_first_child);
$parcel$export(module.exports, "text", () => (parcelRequire("jurrE")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("jurrE")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("jurrE")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("jurrE")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("jurrE")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("jurrE")).underline);
$parcel$export(module.exports, "syncBlock", () => (parcelRequire("jurrE")).syncBlock);
$parcel$export(module.exports, "bodiedSyncBlock", () => (parcelRequire("jurrE")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jurrE = parcelRequire("jurrE");

});
parcelRegister("jurrE", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $7509472459e5bf6a$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $7509472459e5bf6a$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $7509472459e5bf6a$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $7509472459e5bf6a$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $7509472459e5bf6a$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $7509472459e5bf6a$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $7509472459e5bf6a$export$ebb5393736e9ba23);
$parcel$export(module.exports, "blockTaskItem", () => $7509472459e5bf6a$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $7509472459e5bf6a$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $7509472459e5bf6a$export$ee052cc5b2356e83);
$parcel$export(module.exports, "bodiedSyncBlock", () => $7509472459e5bf6a$export$e92c7e4302dd4371);
$parcel$export(module.exports, "border", () => $7509472459e5bf6a$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $7509472459e5bf6a$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $7509472459e5bf6a$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $7509472459e5bf6a$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $7509472459e5bf6a$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $7509472459e5bf6a$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $7509472459e5bf6a$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $7509472459e5bf6a$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $7509472459e5bf6a$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $7509472459e5bf6a$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $7509472459e5bf6a$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $7509472459e5bf6a$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $7509472459e5bf6a$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $7509472459e5bf6a$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $7509472459e5bf6a$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $7509472459e5bf6a$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $7509472459e5bf6a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $7509472459e5bf6a$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $7509472459e5bf6a$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $7509472459e5bf6a$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $7509472459e5bf6a$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fontSize", () => $7509472459e5bf6a$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $7509472459e5bf6a$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $7509472459e5bf6a$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $7509472459e5bf6a$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $7509472459e5bf6a$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $7509472459e5bf6a$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $7509472459e5bf6a$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $7509472459e5bf6a$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $7509472459e5bf6a$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $7509472459e5bf6a$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $7509472459e5bf6a$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $7509472459e5bf6a$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $7509472459e5bf6a$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $7509472459e5bf6a$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $7509472459e5bf6a$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $7509472459e5bf6a$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $7509472459e5bf6a$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $7509472459e5bf6a$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItem_with_flexible_first_child", () => $7509472459e5bf6a$export$d80b696b842918ee);
$parcel$export(module.exports, "media", () => $7509472459e5bf6a$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $7509472459e5bf6a$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $7509472459e5bf6a$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $7509472459e5bf6a$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $7509472459e5bf6a$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $7509472459e5bf6a$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $7509472459e5bf6a$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $7509472459e5bf6a$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $7509472459e5bf6a$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $7509472459e5bf6a$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $7509472459e5bf6a$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $7509472459e5bf6a$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $7509472459e5bf6a$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $7509472459e5bf6a$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $7509472459e5bf6a$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $7509472459e5bf6a$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_font_size", () => $7509472459e5bf6a$export$f745a1f9fa5e1ca8);
$parcel$export(module.exports, "paragraph_with_font_size_and_alignment", () => $7509472459e5bf6a$export$20cf96f162e24b93);
$parcel$export(module.exports, "paragraph_with_font_size_and_indentation", () => $7509472459e5bf6a$export$8f4b0a3fbc7cdc91);
$parcel$export(module.exports, "paragraph_with_indentation", () => $7509472459e5bf6a$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $7509472459e5bf6a$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $7509472459e5bf6a$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $7509472459e5bf6a$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $7509472459e5bf6a$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $7509472459e5bf6a$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $7509472459e5bf6a$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $7509472459e5bf6a$export$b3401ee80eb31041);
$parcel$export(module.exports, "syncBlock", () => $7509472459e5bf6a$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $7509472459e5bf6a$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $7509472459e5bf6a$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $7509472459e5bf6a$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $7509472459e5bf6a$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $7509472459e5bf6a$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $7509472459e5bf6a$export$375b6afcc5f4d291);
$parcel$export(module.exports, "taskList_with_flexible_first_child", () => $7509472459e5bf6a$export$32c25bbc91b30817);
$parcel$export(module.exports, "text", () => $7509472459e5bf6a$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $7509472459e5bf6a$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $7509472459e5bf6a$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $7509472459e5bf6a$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $7509472459e5bf6a$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $7509472459e5bf6a$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $7509472459e5bf6a$export$425327af25286e5e);
const $7509472459e5bf6a$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'paragraph_with_font_size_and_alignment',
    'paragraph_with_font_size_and_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $7509472459e5bf6a$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $7509472459e5bf6a$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7509472459e5bf6a$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $7509472459e5bf6a$export$16018c61064a18df = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ]
            ],
            minItems: 1
        }
    }
};
const $7509472459e5bf6a$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7509472459e5bf6a$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$e92c7e4302dd4371 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_font_size_and_alignment',
                    'paragraph_with_font_size_and_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel',
                    'rule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $7509472459e5bf6a$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_flexible_first_child'
                ]
            ],
            minItems: 1
        }
    }
};
const $7509472459e5bf6a$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7509472459e5bf6a$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $7509472459e5bf6a$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7509472459e5bf6a$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7509472459e5bf6a$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7509472459e5bf6a$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7509472459e5bf6a$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_font_size_and_alignment',
                    'paragraph_with_font_size_and_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $7509472459e5bf6a$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $7509472459e5bf6a$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7509472459e5bf6a$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7509472459e5bf6a$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7509472459e5bf6a$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $7509472459e5bf6a$export$85e3c3ca0c6fb93 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fontSize'
            ]
        },
        attrs: {
            props: {
                fontSize: {
                    type: 'enum',
                    values: [
                        'small'
                    ]
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $7509472459e5bf6a$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7509472459e5bf6a$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7509472459e5bf6a$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $7509472459e5bf6a$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $7509472459e5bf6a$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7509472459e5bf6a$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7509472459e5bf6a$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $7509472459e5bf6a$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7509472459e5bf6a$export$d80b696b842918ee = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_font_size',
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'taskList_with_flexible_first_child',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7509472459e5bf6a$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $7509472459e5bf6a$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7509472459e5bf6a$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $7509472459e5bf6a$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $7509472459e5bf6a$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7509472459e5bf6a$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7509472459e5bf6a$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7509472459e5bf6a$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7509472459e5bf6a$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7509472459e5bf6a$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $7509472459e5bf6a$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_font_size',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $7509472459e5bf6a$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7509472459e5bf6a$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'paragraph_with_font_size',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $7509472459e5bf6a$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_flexible_first_child'
                ]
            ],
            minItems: 1
        }
    }
};
const $7509472459e5bf6a$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7509472459e5bf6a$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7509472459e5bf6a$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$f745a1f9fa5e1ca8 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'fontSize'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$20cf96f162e24b93 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'fontSize',
                        'alignment'
                    ]
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$8f4b0a3fbc7cdc91 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'fontSize',
                        'indentation'
                    ]
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7509472459e5bf6a$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $7509472459e5bf6a$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7509472459e5bf6a$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $7509472459e5bf6a$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $7509472459e5bf6a$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$faab0ca9701d7048 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $7509472459e5bf6a$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $7509472459e5bf6a$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_font_size_and_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $7509472459e5bf6a$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_font_size_and_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $7509472459e5bf6a$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $7509472459e5bf6a$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7509472459e5bf6a$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'taskItem',
                    'blockTaskItem'
                ],
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7509472459e5bf6a$export$32c25bbc91b30817 = [
    'taskList',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'taskItem',
                        'taskList',
                        'blockTaskItem'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7509472459e5bf6a$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7509472459e5bf6a$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $7509472459e5bf6a$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7509472459e5bf6a$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $7509472459e5bf6a$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("fZqur", function(module, exports) {
$parcel$export(module.exports, "isDefined", () => $9b12bf1a559049f1$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $9b12bf1a559049f1$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $9b12bf1a559049f1$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $9b12bf1a559049f1$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $9b12bf1a559049f1$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $9b12bf1a559049f1$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $9b12bf1a559049f1$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $9b12bf1a559049f1$export$7b85fd78dd236198);
const $9b12bf1a559049f1$export$4e62c701997796c1 = (x)=>x != null;
const $9b12bf1a559049f1$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $9b12bf1a559049f1$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $9b12bf1a559049f1$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $9b12bf1a559049f1$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $9b12bf1a559049f1$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $9b12bf1a559049f1$export$784d13d8ee351f07 = (source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $9b12bf1a559049f1$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("7kbxO", function(module, exports) {
$parcel$export(module.exports, "extractAllowedContent", () => $36be96fbb9129b0a$export$7d2123bc001cdbf8);
function $36be96fbb9129b0a$export$7d2123bc001cdbf8(validatorSpecs, entity) {
    // Filter out content type + irrelevant nodes
    const potentialAllowedContent = Object.entries(validatorSpecs).filter((item)=>{
        const [node, value] = item;
        if ($36be96fbb9129b0a$var$isValidatorSpec(value)) return node === entity.type;
        const [nodeName, spec] = [
            value[0],
            value[1]
        ];
        if (typeof spec === 'string' || typeof spec !== 'object') return false;
        return nodeName === entity.type;
    });
    // Keep types such as `mediaSingle_full` which contain additional spec information
    const contentArray = potentialAllowedContent.map((allowedContent)=>{
        if ($36be96fbb9129b0a$var$isValidatorSpec(allowedContent)) return undefined;
        const value = allowedContent[1];
        return !$36be96fbb9129b0a$var$isValidatorSpec(value) ? [
            [
                value[0],
                value[1]
            ]
        ] : undefined;
    });
    return contentArray.filter((x)=>!!x);
}
function $36be96fbb9129b0a$var$isValidatorSpec(spec) {
    return spec.props !== undefined || spec.required !== undefined || spec.maxItems !== undefined || spec.minItems !== undefined;
}

});

parcelRegister("66yyx", function(module, exports) {
$parcel$export(module.exports, "validatorFnMap", () => $9b50ad465d2ad14d$export$d1b377ca77ac267d);

var $crC8K = parcelRequire("crC8K");
const $9b50ad465d2ad14d$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $crC8K.isSafeUrl)
};

});



parcelRegister("8jHQ1", function(module, exports) {
$parcel$export(module.exports, "transformMediaLinkMarks", () => $eb7ab371105c7cc4$export$6528700f3fa2fe2a);

var $1CVmW = parcelRequire("1CVmW");
const $eb7ab371105c7cc4$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $1CVmW.traverse)(adf, {
        mediaSingle: (node)=>{
            var _node$content$;
            if (!node.marks || !node.content || ((_node$content$ = node.content[0]) === null || _node$content$ === void 0 ? void 0 : _node$content$.type) !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    var _node$marks;
                    linkMark = mark;
                    (_node$marks = node.marks) === null || _node$marks === void 0 || _node$marks.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                var _mediaNode$marks;
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if ((_mediaNode$marks = mediaNode.marks) !== null && _mediaNode$marks !== void 0 && _mediaNode$marks.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("2AMqz", function(module, exports) {
$parcel$export(module.exports, "validateADFEntity", () => $21b18154b260adcd$export$884cfad20dece33e);

var $8o5I3 = parcelRequire("8o5I3");

var $eguiP = parcelRequire("eguiP");

var $fZ6KA = parcelRequire("fZ6KA");
const $21b18154b260adcd$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $21b18154b260adcd$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $21b18154b260adcd$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $21b18154b260adcd$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $21b18154b260adcd$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $21b18154b260adcd$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $21b18154b260adcd$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
   * There's a inconsistency between ProseMirror and ADF.
   * `content` is actually optional in ProseMirror.
   * And, also empty `text` node is not valid.
   */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $21b18154b260adcd$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $21b18154b260adcd$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta !== null && meta !== void 0 && meta.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta === null || meta === void 0 ? void 0 : meta.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $21b18154b260adcd$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $21b18154b260adcd$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $21b18154b260adcd$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $21b18154b260adcd$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $21b18154b260adcd$export$87b732fa69cdf16e(child) : validate(child, $21b18154b260adcd$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $21b18154b260adcd$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $21b18154b260adcd$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $21b18154b260adcd$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $fZ6KA.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $eguiP.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $21b18154b260adcd$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $8o5I3.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $21b18154b260adcd$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $21b18154b260adcd$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});

parcelRegister("f3Ytk", function(module, exports) {
$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $91a24e7c6538e556$export$a43de96edd8d0a0);

var $7VS6B = parcelRequire("7VS6B");
var $ePRXW = parcelRequire("ePRXW");

var $eguiP = parcelRequire("eguiP");

var $jS5mX = parcelRequire("jS5mX");
const $91a24e7c6538e556$var$rendersMap = {};
const $91a24e7c6538e556$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $ePRXW.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $eguiP.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $7VS6B.getAnalyticsAppearance)(item.appearance),
                platform: (0, $jS5mX.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $eguiP.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $eguiP.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $jS5mX.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $91a24e7c6538e556$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $91a24e7c6538e556$var$DEFAULT_SAMPLING_RATE = 100;
const $91a24e7c6538e556$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$91a24e7c6538e556$var$rendersMap[appearance]) $91a24e7c6538e556$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $91a24e7c6538e556$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $91a24e7c6538e556$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $91a24e7c6538e556$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($91a24e7c6538e556$var$rendersMap[appearance].size === 1) $91a24e7c6538e556$var$schedule(()=>$91a24e7c6538e556$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($91a24e7c6538e556$var$rendersMap[appearance].size % sampleRate === 0) $91a24e7c6538e556$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("ePRXW", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $bea60fd33ab15981$export$484b83e0462998d);

var $1CVmW = parcelRequire("1CVmW");
var $bea60fd33ab15981$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $bea60fd33ab15981$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $bea60fd33ab15981$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.degraded) || $bea60fd33ab15981$export$f9f8a29778652c3e.DEGRADED,
        blocking: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.blocking) || $bea60fd33ab15981$export$f9f8a29778652c3e.BLOCKING
    };
};
const $bea60fd33ab15981$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $1CVmW.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                var _node$attrs;
                const originalNode = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $1CVmW.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        var _parent$parent;
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = ((_parent$parent = parent.parent) === null || _parent$parent === void 0 || (_parent$parent = _parent$parent.node) === null || _parent$parent === void 0 ? void 0 : _parent$parent.type) ?? 'unknown';
                        const type = `${parentType}/${(unsupportedNode === null || unsupportedNode === void 0 ? void 0 : unsupportedNode.type) ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = ((unsupportedNodeTypeCount === null || unsupportedNodeTypeCount === void 0 ? void 0 : unsupportedNodeTypeCount[type]) ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $bea60fd33ab15981$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $bea60fd33ab15981$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $bea60fd33ab15981$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $bea60fd33ab15981$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $bea60fd33ab15981$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("3pW7R", function(module, exports) {
$parcel$export(module.exports, "countNodes", () => $aea841196191fcf1$export$1daf15cbaf649dad);

var $d0GnQ = parcelRequire("d0GnQ");
function $aea841196191fcf1$export$1daf15cbaf649dad(adfDocument) {
    return (0, $d0GnQ.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("d0GnQ", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $2f8b544eacf8d838$export$533b26079ad0b4b);

var $1CVmW = parcelRequire("1CVmW");
function $2f8b544eacf8d838$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $1CVmW.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("9CfQj", function(module, exports) {
$parcel$export(module.exports, "EditorMediaClientProvider", () => $e1f08755aaa145e8$export$77218b6ff680865f);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $c0KQ5 = parcelRequire("c0KQ5");
var $lbS2q = parcelRequire("lbS2q");

var $6RaaD = parcelRequire("6RaaD");

var $13svG = parcelRequire("13svG");
const $e1f08755aaa145e8$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $8P7DW.useState)();
    const providerFactory = (0, $6RaaD.useProviderFactory)();
    const mediaProvider = (0, $6RaaD.useProviderLayout)('mediaProvider');
    /**
   * Whether this renderer has its own media provider and should never inherit
   * the mediaClient from a parent renderer's context.
   *
   * We use providerFactory.hasProvider() rather and checking the mediaProvider
   * state value, because useProviderLayout subscribes via useLayoutEffect —
   * meaning mediaProvider state is always undefined on the first render, even
   * if the ProviderFactory already has a provider registered. This would cause
   * shouldSkipContext to be false on the first render, incorrectly allowing the
   * inner renderer to inherit the outer renderer's MediaClientContext (which
   * carries the wrong media token for this page).
   *
   * hasProvider() is synchronous and correct from render 1, closing that window.
   */ const shouldSkipContext = (0, $13svG.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true) ? Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || providerFactory.hasProvider('mediaProvider') || mediaProvider) : Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || mediaProvider);
    const contextMediaClient = (0, $8P7DW.useContext)((0, $lbS2q.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $8P7DW.useMemo)(()=>mediaClientConfig ? (0, $c0KQ5.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $8P7DW.useLayoutEffect)(()=>{
        if (ssr !== null && ssr !== void 0 && ssr.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lbS2q.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};

});

parcelRegister("3yMdl", function(module, exports) {
$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $f6e8d55be72b3fdd$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $f6e8d55be72b3fdd$export$cddc3c6ebe2d2cec);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
const { Provider: $f6e8d55be72b3fdd$export$20439b49fdd0d26c, Consumer: $f6e8d55be72b3fdd$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $f6e8d55be72b3fdd$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $8P7DW.useState)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)($f6e8d55be72b3fdd$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};

});

parcelRegister("gby7N", function(module, exports) {
$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $b598664889101926$export$cfc1361be0de4203);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $iN6Wt = parcelRequire("iN6Wt");

var $e6Qdr = parcelRequire("e6Qdr");

var $1a7CN = parcelRequire("1a7CN");

var $13svG = parcelRequire("13svG");
function $b598664889101926$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: (0, $e6Qdr.fg)('platform-ssr-table-resize')
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $b598664889101926$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $b598664889101926$export$92859d13f30c883e(id, shouldSkipScript) {
    const flags = {
        platform_editor_fix_media_in_renderer: (0, $e6Qdr.fg)('platform_editor_fix_media_in_renderer'),
        platform_editor_renderer_extension_width_fix: (0, $13svG.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)
    };
    return `(function(window){
if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }
${$b598664889101926$export$47813c4121c8b4b3};
(${$b598664889101926$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)}, ${JSON.stringify(flags)});
})(window);
`;
}
const $b598664889101926$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $iN6Wt.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $iN6Wt.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $iN6Wt.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $iN6Wt.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $iN6Wt.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $iN6Wt.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $1a7CN.FullPagePadding).toString()};
`;
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b598664889101926$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript, flags) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>{
        var _elem$parentElement;
        return !!((_elem$parentElement = elem.parentElement) !== null && _elem$parentElement !== void 0 && _elem$parentElement.classList.contains('ak-renderer-wrapper'));
    });
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const nodeType = node.dataset.nodeType;
                const widthType = node.dataset.widthType;
                const isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                isMediaSingleWithPixelWidth && flags['platform_editor_fix_media_in_renderer'] || isExtension && flags['platform_editor_renderer_extension_width_fix']) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target, flags);
        });
    });
    const applyMediaBreakout = (card, flags)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override width
        if (isPixelBasedResizing) return;
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width) card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $b598664889101926$export$2a0b3eeee3f2ea40 = (0, $iN6Wt.breakoutConsts).calcLineLength((0, $iN6Wt.breakoutConsts));

});

parcelRegister("44oYY", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $e0999dddf41d0d50$export$3dee5e4542c672d9);

var $3qxsx = parcelRequire("3qxsx");

var $c3akh = parcelRequire("c3akh");
function $e0999dddf41d0d50$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $c3akh.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $3qxsx.fileCardImageViewSelector))) return true;
    return false;
}

});
parcelRegister("3qxsx", function(module, exports) {
$parcel$export(module.exports, "fileCardImageViewSelector", () => $80f89898a4a650ba$export$7a6526d4be3b7eb3);
const $80f89898a4a650ba$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $80f89898a4a650ba$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

});

parcelRegister("c3akh", function(module, exports) {
$parcel$export(module.exports, "mediaViewerPopupClass", () => $72dffb598dd57260$export$42c8d07e41ed1e74);
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $72dffb598dd57260$export$42c8d07e41ed1e74 = 'media-viewer-popup';

});


parcelRegister("9rAvi", function(module, exports) {
$parcel$export(module.exports, "TruncatedWrapper", () => $a3212c86629e497f$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $8P7DW = parcelRequire("8P7DW");
const $a3212c86629e497f$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $8Z0o8.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, #00000000)"}, ${backgroundColor} )`
        }
    });
const $a3212c86629e497f$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $a3212c86629e497f$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: styles
    }, children);
};
class $a3212c86629e497f$export$79ad592494094f07 extends (0, $8P7DW.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, #FFFFFF)", children: children } = this.props;
        return /*#__PURE__*/ (0, $8Z0o8.jsx)($a3212c86629e497f$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("f0OUv", function(module, exports) {
$parcel$export(module.exports, "RendererStyleContainer", () => $d765a8516df71e45$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $8Z0o8 = parcelRequire("8Z0o8");

var $1a7CN = parcelRequire("1a7CN");

var $e6Qdr = parcelRequire("e6Qdr");

var $lnxsR = parcelRequire("lnxsR");

var $e7vUY = parcelRequire("e7vUY");

var $asahk = parcelRequire("asahk");

var $akFvq = parcelRequire("akFvq");

var $96QRs = parcelRequire("96QRs");
var $gNjEp = parcelRequire("gNjEp");
var $kQ9Np = parcelRequire("kQ9Np");
var $60GDJ = parcelRequire("60GDJ");
var $c0CLP = parcelRequire("c0CLP");
var $hxMBA = parcelRequire("hxMBA");
var $cRJ6A = parcelRequire("cRJ6A");

var $aaUQA = parcelRequire("aaUQA");
var $e5Nys = parcelRequire("e5Nys");

var $4TACV = parcelRequire("4TACV");
var $e8MYk = parcelRequire("e8MYk");

var $7CWXm = parcelRequire("7CWXm");

var $h2boN = parcelRequire("h2boN");

var $luM3o = parcelRequire("luM3o");

var $d6Hb9 = parcelRequire("d6Hb9");

var $8BjtO = parcelRequire("8BjtO");

var $i4qXD = parcelRequire("i4qXD");

var $WtfHk = parcelRequire("WtfHk");

var $3mXlj = parcelRequire("3mXlj");
var $iBqpw = parcelRequire("iBqpw");

var $13svG = parcelRequire("13svG");

var $6NJxZ = parcelRequire("6NJxZ");
function $d765a8516df71e45$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d765a8516df71e45$var$wrappedMediaBreakoutPoint = 410;
const $d765a8516df71e45$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $d765a8516df71e45$var$tableShadowWidth = 32;
const $d765a8516df71e45$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $d765a8516df71e45$var$tableRowHeight = 44;
const $d765a8516df71e45$var$isBackgroundClipBrowserFixNeeded = ()=>{
    const browser = (0, $7CWXm.getBrowserInfo)();
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
const $d765a8516df71e45$var$baseFontStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    font: (0, $i4qXD.default)('editor.font.body')
});
const $d765a8516df71e45$var$fontSizeStyles = {
    name: "jdulnm",
    styles: ".fabric-editor-font-size{&[data-font-size='small']{font:var(--ak-renderer-editor-font-small-text);}}li:has(> .fabric-editor-font-size[data-font-size='small'])::marker{font:var(--ak-renderer-editor-font-small-text);}"
};
const $d765a8516df71e45$var$originalBaseFontLineHeight = {
    name: "1dw7ik1",
    styles: "line-height:1.5rem"
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $d765a8516df71e45$var$baseStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    color: "var(--ds-text, #292A2E)",
    '--ak-editor--full-width-layout-width': `${(0, $e7vUY.akEditorFullWidthLayoutWidth)}px`,
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $asahk.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    [`& span.akActionMark`]: {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: "var(--ds-link, #1868DB)",
            textDecoration: 'underline'
        },
        '&:active': {
            color: "var(--ds-link-pressed, #1558BC)"
        }
    },
    '& span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)"
    }
});
const $d765a8516df71e45$var$headingAnchorStylesDuplicateAnchor = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: 'translate(-8px, 0px)',
                    transition: 'opacity 0.2s ease 0s, transform 0.2s ease 0s'
                }
            },
            '&:hover': {
                [`.${0, $akFvq.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $d765a8516df71e45$var$headingAnchorStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $akFvq.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    // Line-height for heading anchor based on heading level (via data-level attribute on .renderer-heading-wrapper)
    '& .renderer-heading-wrapper[data-level="1"]': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $d765a8516df71e45$var$headingAnchorButtonFocusVisibleStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
        'button:focus-visible': {
            outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
            borderRadius: "var(--ds-radius-small, 3px)"
        }
    }
});
const $d765a8516df71e45$var$akEditorBreakpointForSmallDevice = '1266px';
const $d765a8516df71e45$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $8Z0o8.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $e7vUY.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $e7vUY.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$d765a8516df71e45$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $e7vUY.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $d765a8516df71e45$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $8Z0o8.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $e7vUY.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$d765a8516df71e45$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $e7vUY.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $d765a8516df71e45$var$responsiveBreakoutWidthWithReducedPadding = /*#__PURE__*/ (0, $8Z0o8.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $e7vUY.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$d765a8516df71e45$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $e7vUY.akEditorCalculatedWideLayoutWidth)}px`
    },
    [`@media (max-width: ${0, $e7vUY.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`
    }
});
const $d765a8516df71e45$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $d765a8516df71e45$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $d765a8516df71e45$var$rendererFullPageStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $e7vUY.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $1a7CN.FullPagePadding)}px`
});
const $d765a8516df71e45$var$rendererFullPageStylesWithReducedPadding = /*#__PURE__*/ (0, $8Z0o8.css)({
    '--ak-renderer--full-page-gutter': `${(0, $1a7CN.FullPagePadding)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $e7vUY.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 var(--ak-renderer--full-page-gutter)`,
    [`@media (max-width: ${0, $e7vUY.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-renderer--full-page-gutter': `${(0, $e7vUY.akEditorGutterPaddingReduced)}px`
    }
});
const $d765a8516df71e45$var$oldRendererFullWidthStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $e7vUY.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $d765a8516df71e45$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $e7vUY.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $d765a8516df71e45$var$oldRendererMaxWidthStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $e7vUY.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $d765a8516df71e45$var$rendererMaxWidthStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $e7vUY.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $d765a8516df71e45$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
const $d765a8516df71e45$var$rovoTelepointerStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`#${$d765a8516df71e45$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '24px',
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            width: '31.5px',
            height: '15.5px',
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
            'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
        },
        '&::before': {
            content: '"Rovo"',
            position: 'absolute',
            fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-text, #292A2E)",
            top: 1,
            left: 1,
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            zIndex: 1,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            padding: '0.5px 2.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});
const $d765a8516df71e45$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $d765a8516df71e45$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $e7vUY.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $d765a8516df71e45$var$headingsSharedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 20px)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    }
});
/**
 * When the copy-link a11y fix is enabled, the heading copy-link button is a sibling of the heading
 * text within `.renderer-heading-wrapper`. To ensure the button sits immediately after the last
 * rendered character (including when the heading wraps), the heading itself needs to participate in
 * inline layout.
 *
 * Since inline elements don't support vertical margins in normal flow, we migrate the UGC heading
 * `marginTop` values (from `headingsSharedStyles`) onto the wrapper.
 */ const $d765a8516df71e45$var$headingWrapperInlineFlowStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Ensure heading and copy-link button participate in inline flow so the button sits after the final wrapped line of text.
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        display: 'inline'
    },
    [`& .renderer-heading-wrapper > .${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
        display: 'inline',
        verticalAlign: 'baseline'
    },
    '& .renderer-heading-wrapper[data-level="1"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em'
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em'
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.25em'
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em'
    }
});
const $d765a8516df71e45$var$headingWithAlignmentStylesDuplicateAnchor = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $d765a8516df71e45$var$headingWithAlignmentStyles = {
    name: "1abdc8p",
    styles: ".fabric-editor-block-mark[data-align=\"center\"] > .renderer-heading-wrapper{justify-content:center;}.fabric-editor-block-mark[data-align=\"end\"] > .renderer-heading-wrapper{justify-content:flex-end;}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $d765a8516df71e45$var$ruleSharedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $e7vUY.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $d765a8516df71e45$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $e7vUY.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $d765a8516df71e45$var$paragraphStylesUGCScaledMargin = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $e7vUY.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $d765a8516df71e45$var$paragraphSharedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $e7vUY.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $e7vUY.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $d765a8516df71e45$var$paragraphSharedStyleScaledMargin = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $e7vUY.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $e7vUY.scaledBlockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $d765a8516df71e45$var$listsSharedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $kQ9Np.listItemCounterPadding)}px)`
    },
    [`${0, $e5Nys.orderedListSelector}, ${0, $aaUQA.bulletListSelector}`]: {
        /*
    Ensures list item content adheres to the list's margin instead
    of filling the entire block row. This is important to allow
    clicking interactive elements which are floated next to a list.
    	For some history and context on this block, see PRs related to tickets.:
    @see ED-6551 - original issue.
    @see ED-7015 - follow up issue.
    @see ED-7447 - flow-root change.
    	used to have display: 'table' in tag template style but not supported in object styles
    removed display: 'table' as 'flow-root' is supported in latest browsers
    	@see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $d765a8516df71e45$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
/**
 * Hides list markers for "wrapper items" - list items that only contain nested lists with no other content.
 * These wrapper items have no meaningful content themselves, only nested lists below.
 * Applied when platform_editor_flexible_list_schema experiment is enabled.
 */ const $d765a8516df71e45$var$listItemHiddenMarkerStyles = {
    name: "j8szsq",
    styles: "li:has(> ul:only-child), li:has(> ol:only-child){list-style-type:none;margin-top:0;margin-bottom:0;}li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol{margin-top:0;}div[data-task-list-local-id] > div[data-task-list-local-id]{margin-top:0;}div[data-task-local-id] + div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);}"
};
const $d765a8516df71e45$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $d765a8516df71e45$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $e7vUY.blockNodesVerticalMargin)
        }
    }
});
const $d765a8516df71e45$var$blockMarksSharedStylesDuplicateAnchor = /*#__PURE__*/ (0, $8Z0o8.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $d765a8516df71e45$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        },
        '.renderer-heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                'h1, h2, h3, h4, h5, h6': {
                    marginTop: 0
                }
            }
        }
    }
});
const $d765a8516df71e45$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        color: "var(--ds-text, #292A2E)",
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $d765a8516df71e45$var$extensionStyle = {
    name: "188isfx",
    styles: ".ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *){font-size:var(--ak-renderer-base-font-size);}"
};
const $d765a8516df71e45$var$oldExtensionAsInlineStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $lnxsR.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        // use !important here because the current width has !important applied to it and it's not working when used in React style prop
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        marginTop: 0
    },
    [`.${(0, $lnxsR.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $lnxsR.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $lnxsR.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $lnxsR.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
const $d765a8516df71e45$var$extensionAsInlineStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $lnxsR.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        width: 'auto',
        marginTop: 0
    },
    [`.${(0, $lnxsR.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $lnxsR.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $lnxsR.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $lnxsR.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
// Removes the blockNodesVerticalMargin styling for inline extensions, i.e. borderless excerpt-include
const $d765a8516df71e45$var$inlineExtensionRendererMarginFix = {
    name: "vgr91k",
    styles: ".ak-renderer-document .inline-extension-renderer .ak-renderer-extension{margin-top:0;}"
};
const $d765a8516df71e45$var$shadowSharedStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $4TACV.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $4TACV.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $4TACV.shadowClassNames).LEFT_SHADOW}::before, .${(0, $4TACV.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $e7vUY.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $4TACV.shadowClassNames).RIGHT_SHADOW}, .${(0, $4TACV.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $4TACV.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $4TACV.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $e8MYk.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $e8MYk.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $d765a8516df71e45$var$dateSharedStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $gNjEp.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $d765a8516df71e45$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $d765a8516df71e45$var$backgroundColorStyles = {
    name: "yf96ao",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $d765a8516df71e45$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $d765a8516df71e45$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $cRJ6A.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $e7vUY.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $cRJ6A.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $cRJ6A.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $e7vUY.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $cRJ6A.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $e7vUY.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $e7vUY.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $e7vUY.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-150, 12px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $d765a8516df71e45$var$headingPanelStyles = {
    name: "e0for6",
    styles: ".ak-editor-panel__content{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $d765a8516df71e45$var$smartCardStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $c0CLP.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $e7vUY.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $d765a8516df71e45$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $c0CLP.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $c0CLP.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $d765a8516df71e45$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $c0CLP.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $c0CLP.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $d765a8516df71e45$var$smartCardStylesAvatarListZeroMarginTop = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $c0CLP.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $c0CLP.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginTop: 0
        }
    }
});
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
const $d765a8516df71e45$var$headerSmartCardStyles = {
    name: "qwtpmh",
    styles: "[data-inline-card=\"true\"]{[data-inlinecard-button-overlay=\"icon-wrapper-line-height\"] span{line-height:0;}}"
};
// Flex wrapper for centering without transform (platform_editor_flex_based_centering).
// flex: 1 1 0% + minWidth: 0 so the wrapper takes full width when it's a flex item (full-width nodes otherwise render narrow).
// flexShrink: 0 on child so the node keeps size.
const $d765a8516df71e45$var$centerWrapperStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).FLEX_CENTER_WRAPPER}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        flex: '1 1 0%',
        minWidth: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flexShrink: 0
        }
    }
});
const $d765a8516df71e45$var$baseOtherStylesDuplicateAnchor = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $60GDJ.richMediaClassName}.rich-media-wrapped + .${0, $60GDJ.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $60GDJ.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $60GDJ.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $60GDJ.richMediaClassName}.image-align-start,
		.${0, $60GDJ.richMediaClassName}.image-center,
		.${0, $60GDJ.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $lnxsR.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $lnxsR.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $lnxsR.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $e7vUY.blockNodesVerticalMargin)}`
        },
        [`.${(0, $lnxsR.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $lnxsR.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $lnxsR.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $e8MYk.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $d765a8516df71e45$var$hideExtensionStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).EXTENSION}:has([data-extension-key='hide'])`]: {
        marginTop: 0
    }
});
const $d765a8516df71e45$var$extensionCenterAlignLegacyStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $lnxsR.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        }
    }
});
const $d765a8516df71e45$var$baseOtherStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $60GDJ.richMediaClassName}.rich-media-wrapped + .${0, $60GDJ.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $60GDJ.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $60GDJ.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $60GDJ.richMediaClassName}.image-align-start,
		.${0, $60GDJ.richMediaClassName}.image-center,
		.${0, $60GDJ.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $lnxsR.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $lnxsR.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $lnxsR.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $e7vUY.blockNodesVerticalMargin)}`
        },
        [`.${(0, $lnxsR.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $lnxsR.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $lnxsR.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $lnxsR.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $e8MYk.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $d765a8516df71e45$var$alignedHeadingAnchorStyleDuplicateAnchor = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $akFvq.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $d765a8516df71e45$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        '.renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                position: 'relative'
            }
        }
    },
    // Center alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="center"] > .renderer-heading-wrapper': {
        justifyContent: 'center'
    },
    // Right/end alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="end"] > .renderer-heading-wrapper': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $akFvq.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $d765a8516df71e45$var$firstWrappedMediaStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
    [`.${0, $60GDJ.richMediaClassName}[class*="image-wrap-"]:has(+ .${0, $60GDJ.richMediaClassName}[class*="image-wrap-"])`]: {
        marginRight: 0,
        marginLeft: 0
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $d765a8516df71e45$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $60GDJ.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $60GDJ.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $60GDJ.richMediaClassName}.image-wrap-right + .${0, $60GDJ.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $60GDJ.richMediaClassName}.image-wrap-left + .${0, $60GDJ.richMediaClassName}.image-wrap-right, .${0, $60GDJ.richMediaClassName}.image-wrap-right + .${0, $60GDJ.richMediaClassName}.image-wrap-left, .${0, $60GDJ.richMediaClassName}.image-wrap-left + .${0, $60GDJ.richMediaClassName}.image-wrap-left, .${0, $60GDJ.richMediaClassName}.image-wrap-right + .${0, $60GDJ.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$d765a8516df71e45$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            marginTop: "var(--ds-space-150, 12px)",
            marginRight: 0,
            marginBottom: "var(--ds-space-150, 12px)",
            marginLeft: 0
        }
    }
});
// was shared between editor-core and renderer
const $d765a8516df71e45$var$tableSharedStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E7F9FF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFECEB)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #CFE1FD)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #C6EDFB)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #BAF3DB)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #F5E989)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFD5D2)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #EED7FC)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #8C8F97)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #669DF1)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #6CC3E0)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #4BCE97)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FCA700)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #C97CF4)"} !important`
    },
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        marginTop: 0,
        marginRight: 'auto',
        marginBottom: "var(--ds-space-200, 16px)",
        marginLeft: 'auto',
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $e7vUY.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
    },
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: "var(--ds-space-100, 8px)",
        marginBottom: 0,
        marginLeft: 0
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $hxMBA.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '&[data-initial-width-mode="content"]': {
            tableLayout: 'auto',
            width: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
                    [`&:not(.${0, $e7vUY.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`
                    },
                    [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, #0515240F)"
                    }
                }
            }
        }
    }
});
const $d765a8516df71e45$var$tableContentModeStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}:has(table[data-initial-width-mode="content"])`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'max-content !important',
        maxWidth: 'var(--renderer-table-max-width)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > colgroup > col`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'unset !important'
    }
});
const $d765a8516df71e45$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $hxMBA.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $d765a8516df71e45$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
    }
});
const $d765a8516df71e45$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $d765a8516df71e45$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $d765a8516df71e45$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $d765a8516df71e45$var$rendererTableStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $4TACV.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $4TACV.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $hxMBA.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $hxMBA.tableMarginTop)}px)`,
            zIndex: `${(0, $e7vUY.akEditorStickyHeaderZIndex)}`,
            width: `${$d765a8516df71e45$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $4TACV.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $e8MYk.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $e8MYk.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $hxMBA.tableMarginTop)}px)`
        }
    }
});
const $d765a8516df71e45$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$d765a8516df71e45$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $d765a8516df71e45$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $d765a8516df71e45$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $hxMBA.tableCellPadding)}px`,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-shape
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${"var(--ds-border-focused, #4688EC)"}`
                        }
                    }
                },
                [`> .${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $d6Hb9.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $d6Hb9.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $d6Hb9.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
const $d765a8516df71e45$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $lnxsR.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
                borderRight: `${"var(--ds-border-width, 1px)"} solid
								${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
                width: `${(0, $e7vUY.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $lnxsR.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $d765a8516df71e45$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
const $d765a8516df71e45$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .${(0, $hxMBA.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $hxMBA.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $hxMBA.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $lnxsR.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $akFvq.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '> .renderer-heading-wrapper': {
                        // Reserve space for the sortable-column icon so the heading+anchor wrapper never overlaps it.
                        // Use padding (instead of margin on the heading) so we don't create a gap between the heading
                        // text and the copy-link anchor button
                        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                        paddingRight: '30px'
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $d765a8516df71e45$var$stickyHeaderStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $e7vUY.akEditorStickyHeaderZIndex)}`,
        borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $e7vUY.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -0.5px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			inset -1px 0px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $d765a8516df71e45$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $e7vUY.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT}
		> .${(0, $8BjtO.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $e7vUY.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $e7vUY.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $e7vUY.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $e7vUY.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $e7vUY.blockNodesVerticalMargin)
        }
    }
});
const $d765a8516df71e45$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $d765a8516df71e45$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $d765a8516df71e45$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $c0CLP.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $e7vUY.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $e7vUY.akEditorLineHeight)}em !important`
        }
    }
});
const $d765a8516df71e45$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $e7vUY.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $d765a8516df71e45$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $d765a8516df71e45$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$d765a8516df71e45$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $d765a8516df71e45$var$rendererAnnotationStylesOld = /*#__PURE__*/ (0, $8Z0o8.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    }
});
const $d765a8516df71e45$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    },
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'][data-has-focus='true'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
});
const $d765a8516df71e45$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        paddingRight: 0,
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: 0,
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $d765a8516df71e45$var$RENDERER_LIST_DENSE_GAP = `max(0px,calc((var(--ak-renderer-base-font-size) - ${(0, $e7vUY.akEditorFullPageDenseFontSize)}px)* (4/3)))`;
const $d765a8516df71e45$var$TASKLIST_CONTAINER_DENSE_MARGIN = `max(calc(10px + (var(--ak-renderer-base-font-size) - ${(0, $e7vUY.akEditorFullPageDenseFontSize)}px) *( 2 / 3)))`;
const $d765a8516df71e45$var$scaledDenseEmojiStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $3mXlj.defaultDenseEmojiHeight)}px`,
        minHeight: `${(0, $3mXlj.defaultDenseEmojiHeight)}px`,
        minWidth: `${(0, $3mXlj.defaultDenseEmojiHeight)}px`,
        maxHeight: `${(0, $3mXlj.denseEmojiHeightH1)}px`,
        maxWidth: `${(0, $3mXlj.denseEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.denseEmojiHeightH1)}px`,
        width: `${(0, $3mXlj.denseEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.denseEmojiHeightH2)}px`,
        width: `${(0, $3mXlj.denseEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.denseEmojiHeightH3)}px`,
        width: `${(0, $3mXlj.denseEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.denseEmojiHeightH4)}px`,
        width: `${(0, $3mXlj.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.defaultDenseEmojiHeight)}px`,
        width: `${(0, $3mXlj.defaultDenseEmojiHeight)}px`
    }
});
const $d765a8516df71e45$var$scaledEmojiStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $3mXlj.defaultEmojiHeight)}px`,
        minHeight: `${(0, $3mXlj.defaultEmojiHeight)}px`,
        minWidth: `${(0, $3mXlj.defaultEmojiHeight)}px`,
        maxHeight: `${(0, $3mXlj.scaledEmojiHeightH1)}px`,
        maxWidth: `${(0, $3mXlj.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.scaledEmojiHeightH1)}px`,
        width: `${(0, $3mXlj.scaledEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.scaledEmojiHeightH2)}px`,
        width: `${(0, $3mXlj.scaledEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.scaledEmojiHeightH3)}px`,
        width: `${(0, $3mXlj.scaledEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.scaledEmojiHeightH4)}px`,
        width: `${(0, $3mXlj.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $3mXlj.defaultEmojiHeight)}px`,
        width: `${(0, $3mXlj.defaultEmojiHeight)}px`
    }
});
const $d765a8516df71e45$var$denseStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Scale emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    [`.${(0, $iBqpw.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `calc(${(0, $3mXlj.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $e7vUY.akEditorFullPageDefaultFontSize)})`,
        width: `calc(${(0, $3mXlj.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $e7vUY.akEditorFullPageDefaultFontSize)})`,
        maxHeight: `calc(${(0, $3mXlj.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $e7vUY.akEditorFullPageDefaultFontSize)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Scale panel icon
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT} .ak-editor-panel .ak-editor-panel__icon`]: {
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    },
    // Condense spacing across lists, tasks and decisions
    [`.${(0, $lnxsR.RendererCssClassName).DOCUMENT}`]: {
        // Adjacent list items
        'li + li': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $d765a8516df71e45$var$RENDERER_LIST_DENSE_GAP
        },
        // Nested lists directly under an li (unordered and ordered)
        'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $d765a8516df71e45$var$RENDERER_LIST_DENSE_GAP
        },
        // Task lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id]': {
            // Task lists: container top margin
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $d765a8516df71e45$var$TASKLIST_CONTAINER_DENSE_MARGIN
        },
        // Task lists: sibling items and nested lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] > * + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $d765a8516df71e45$var$RENDERER_LIST_DENSE_GAP
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $d765a8516df71e45$var$RENDERER_LIST_DENSE_GAP
        }
    }
});
const $d765a8516df71e45$var$syncBlockRendererStyles = {
    name: "g5u32w",
    styles: "margin:0;max-width:none;padding:0"
};
const $d765a8516df71e45$var$syncBlockStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $6NJxZ.SyncBlockSharedCssClassName).renderer}, .${(0, $6NJxZ.BodiedSyncBlockSharedCssClassName).renderer}, .${(0, $6NJxZ.SyncBlockSharedCssClassName).error}, .${(0, $6NJxZ.SyncBlockSharedCssClassName).loading}`]: {
        borderRadius: "var(--ds-radius-small, 3px)",
        marginTop: "var(--ds-space-075, 6px)",
        paddingBlock: "var(--ds-space-150, 12px)",
        overflow: 'visible'
    },
    [`.${(0, $6NJxZ.SyncBlockSharedCssClassName).renderer}`]: {
        // First child node in syncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-renderer-document > :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $6NJxZ.BodiedSyncBlockSharedCssClassName).renderer}`]: {
        // First child node in bodiedSyncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '> :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $6NJxZ.SyncBlockSharedCssClassName).error}`]: {
        backgroundColor: "var(--ds-background-disabled, #17171708)"
    },
    [`.${(0, $6NJxZ.SyncBlockSharedCssClassName).loading}`]: {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $d765a8516df71e45$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, contentMode: contentMode, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId, isInsideSyncBlock: isInsideSyncBlock } = props;
    const isAdvancedLayoutsOn = (0, $h2boN.editorExperiment)('advanced_layouts', true);
    const isPreviewPanelResponsivenessOn = (0, $h2boN.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    const isCompactModeSupported = (0, $13svG.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $13svG.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $e6Qdr.fg)('platform_editor_content_mode_button_mvp');
    const isCompactModeEnabled = contentMode === 'compact' && isCompactModeSupported;
    const baseFontSize = (0, $WtfHk.getBaseFontSize)(appearance, contentMode);
    const browser = (0, $7CWXm.getBrowserInfo)();
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        role: "none",
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${baseFontSize}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $i4qXD.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $i4qXD.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $i4qXD.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $i4qXD.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $i4qXD.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $i4qXD.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $i4qXD.default)('editor.font.body')}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- CSS custom properties for UGC font tokens
            ...(0, $13svG.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && {
                '--ak-renderer-editor-font-small-text': (0, $i4qXD.default)('editor.font.body.small')
            }
        },
        css: [
            (0, $13svG.expValEquals)('confluence_ttvc_inline_extensions', 'isEnabled', true) ? $d765a8516df71e45$var$baseFontStyle : $d765a8516df71e45$var$originalBaseFontLineHeight,
            $d765a8516df71e45$var$baseStyles,
            (0, $13svG.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && $d765a8516df71e45$var$fontSizeStyles,
            (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $d765a8516df71e45$var$headingAnchorStyles : $d765a8516df71e45$var$headingAnchorStylesDuplicateAnchor,
            (0, $e6Qdr.fg)('ally_30945_accessibility_outline_fix') && $d765a8516df71e45$var$headingAnchorButtonFocusVisibleStyles,
            (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $d765a8516df71e45$var$hideHeadingCopyLinkWrapperStyles : $d765a8516df71e45$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $d765a8516df71e45$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $d765a8516df71e45$var$rendererFullPageStyles,
            appearance === 'full-width' && ((0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $d765a8516df71e45$var$rendererFullWidthStyles : $d765a8516df71e45$var$oldRendererFullWidthStyles),
            (appearance === 'full-width' || appearance === 'max' && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && !(0, $luM3o.isTableResizingEnabled)(appearance) && $d765a8516df71e45$var$rendererFullWidthStylesForTableResizing,
            appearance === 'max' && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && ((0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $d765a8516df71e45$var$rendererMaxWidthStyles : $d765a8516df71e45$var$oldRendererMaxWidthStyles),
            $d765a8516df71e45$var$rovoTelepointerStyles,
            $d765a8516df71e45$var$whitespaceSharedStyles,
            $d765a8516df71e45$var$blockquoteSharedStyles,
            $d765a8516df71e45$var$headingsSharedStyles,
            (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $d765a8516df71e45$var$headingWrapperInlineFlowStyles,
            (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $d765a8516df71e45$var$headingWithAlignmentStyles : $d765a8516df71e45$var$headingWithAlignmentStylesDuplicateAnchor,
            $d765a8516df71e45$var$ruleSharedStyles,
            contentMode === 'compact' && isCompactModeSupported && $d765a8516df71e45$var$extensionStyle,
            (0, $e6Qdr.fg)('platform_editor_typography_ugc') ? isCompactModeSupported ? $d765a8516df71e45$var$paragraphStylesUGCScaledMargin : $d765a8516df71e45$var$paragraphSharedStylesWithEditorUGC : isCompactModeSupported ? $d765a8516df71e45$var$paragraphSharedStyleScaledMargin : $d765a8516df71e45$var$paragraphSharedStyles,
            $d765a8516df71e45$var$listsSharedStyles,
            browser.gecko && $d765a8516df71e45$var$listsSharedStylesForGekko,
            (0, $13svG.expValEquals)('platform_editor_flexible_list_schema', 'isEnabled', true) && $d765a8516df71e45$var$listItemHiddenMarkerStyles,
            $d765a8516df71e45$var$indentationSharedStyles,
            (0, $e6Qdr.fg)('platform_editor__renderer_indentation_text_margin') && $d765a8516df71e45$var$indentationSharedStylesWithMarginFix,
            (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $d765a8516df71e45$var$blockMarksSharedStyles : $d765a8516df71e45$var$blockMarksSharedStylesDuplicateAnchor,
            $d765a8516df71e45$var$codeMarkSharedStyles,
            $d765a8516df71e45$var$shadowSharedStyle,
            $d765a8516df71e45$var$dateSharedStyle,
            $d765a8516df71e45$var$textColorStyles,
            $d765a8516df71e45$var$backgroundColorStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $d765a8516df71e45$export$a365082c2a191514,
            $d765a8516df71e45$var$tasksAndDecisionsStyles,
            (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $d765a8516df71e45$var$headingPanelStyles,
            $d765a8516df71e45$var$smartCardStyles,
            $d765a8516df71e45$var$smartCardStylesAvatarFix,
            (0, $h2boN.editorExperiment)('platform_editor_preview_panel_linking_exp', true) && $d765a8516df71e45$var$headerSmartCardStyles,
            $d765a8516df71e45$var$smartCardStylesAvatarMarginFix,
            $d765a8516df71e45$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') && ((0, $13svG.expValEquals)('confluence_fe_renderer_inline_node_mark_color_fix', 'isEnabled', true) ? $d765a8516df71e45$var$rendererAnnotationStyles : $d765a8516df71e45$var$rendererAnnotationStylesOld),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $e6Qdr.fg)('editor_inline_comments_on_inline_nodes') && $d765a8516df71e45$var$rendererAnnotationStylesCommentHeightFix,
            (0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $d765a8516df71e45$var$baseOtherStyles : $d765a8516df71e45$var$baseOtherStylesDuplicateAnchor,
            !(0, $13svG.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) && $d765a8516df71e45$var$extensionCenterAlignLegacyStyles,
            // this should be placed after baseOtherStyles
            (0, $13svG.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true) && ((0, $13svG.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $d765a8516df71e45$var$extensionAsInlineStyle : $d765a8516df71e45$var$oldExtensionAsInlineStyle),
            $d765a8516df71e45$var$inlineExtensionRendererMarginFix,
            allowNestedHeaderLinks && ((0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $d765a8516df71e45$var$alignedHeadingAnchorStyle : $d765a8516df71e45$var$alignedHeadingAnchorStyleDuplicateAnchor),
            $d765a8516df71e45$var$mediaSingleSharedStyle,
            // merge firstWrappedMediaStyles with mediaSingleSharedStyle when clean up platform_editor_fix_media_in_renderer
            (0, $e6Qdr.fg)('platform_editor_fix_media_in_renderer') && $d765a8516df71e45$var$firstWrappedMediaStyles,
            $d765a8516df71e45$var$tableSharedStyle,
            (0, $13svG.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) && $d765a8516df71e45$var$tableContentModeStyles,
            $d765a8516df71e45$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $e6Qdr.fg)('platform_editor_bordered_panel_nested_in_table') && $d765a8516df71e45$var$tableRendererNestedPanelStyles,
            $d765a8516df71e45$var$isBackgroundClipBrowserFixNeeded() && $d765a8516df71e45$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $e6Qdr.fg)('platform_editor_nested_dnd_styles_changes') ? $d765a8516df71e45$var$firstNodeWithNotMarginTopWithNestedDnD : $d765a8516df71e45$var$firstNodeWithNotMarginTop,
            $d765a8516df71e45$var$rendererTableStyles,
            (0, $luM3o.isStickyScrollbarEnabled)(appearance) && $d765a8516df71e45$var$stickyScrollbarStyles,
            $d765a8516df71e45$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $d765a8516df71e45$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && ((0, $13svG.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $d765a8516df71e45$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks : $d765a8516df71e45$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor),
            $d765a8516df71e45$var$rendererTableColumnStyles,
            $d765a8516df71e45$var$stickyHeaderStyles,
            $d765a8516df71e45$var$codeBlockAndLayoutStyles,
            $d765a8516df71e45$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $d765a8516df71e45$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $d765a8516df71e45$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $d765a8516df71e45$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $d765a8516df71e45$var$gridRenderForCodeBlockStyles,
            browser.safari && $d765a8516df71e45$var$codeBlockInListSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $d765a8516df71e45$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $d765a8516df71e45$var$responsiveBreakoutWidthWithReducedPadding,
            (appearance === 'full-width' || appearance === 'max' && ((0, $13svG.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $13svG.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && $d765a8516df71e45$var$responsiveBreakoutWidthFullWidth,
            (0, $13svG.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? isCompactModeEnabled ? $d765a8516df71e45$var$scaledDenseEmojiStyles : $d765a8516df71e45$var$scaledEmojiStyles : isCompactModeEnabled ? $d765a8516df71e45$var$denseStyles : undefined,
            (0, $h2boN.editorExperiment)('platform_synced_block', true) && $d765a8516df71e45$var$syncBlockStyles,
            $d765a8516df71e45$var$centerWrapperStyles,
            (0, $h2boN.editorExperiment)('platform_synced_block', true) && isInsideSyncBlock && (0, $e6Qdr.fg)('platform_synced_block_patch_9') ? $d765a8516df71e45$var$syncBlockRendererStyles : null,
            (0, $13svG.expValEquals)('platform_editor_hide_extension_renderer_support', 'isEnabled', true) && $d765a8516df71e45$var$hideExtensionStyles
        ],
        "data-testid": testId
    }, children);
};

});
parcelRegister("asahk", function(module, exports) {
$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $4bdf3f9483c83612$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $4bdf3f9483c83612$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $4bdf3f9483c83612$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $4bdf3f9483c83612$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "wrapperStyle", () => $4bdf3f9483c83612$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $4bdf3f9483c83612$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $4bdf3f9483c83612$export$4d0a7f76ad443516);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $ewS35 = parcelRequire("ewS35");
const $4bdf3f9483c83612$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $4bdf3f9483c83612$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $4bdf3f9483c83612$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $4bdf3f9483c83612$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $4bdf3f9483c83612$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $8Z0o8.css)(">.mediaInlineView-content-wrap>.", $4bdf3f9483c83612$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $4bdf3f9483c83612$export$dd2e16f83ae6aa78, ",>.", $4bdf3f9483c83612$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $4bdf3f9483c83612$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $4bdf3f9483c83612$export$dee15762144889b7 = /*#__PURE__*/ (0, $8Z0o8.css)(".", $4bdf3f9483c83612$export$dd2e16f83ae6aa78, "{height:", (0, $ewS35.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $4bdf3f9483c83612$var$inlineImageHeight((0, $ewS35.referenceHeights)['h1'], -3), ";}h2{", $4bdf3f9483c83612$var$inlineImageHeight((0, $ewS35.referenceHeights)['h2'], -3), ";}h3{", $4bdf3f9483c83612$var$inlineImageHeight((0, $ewS35.referenceHeights)['h3'], -2), ";}h4{", $4bdf3f9483c83612$var$inlineImageHeight((0, $ewS35.referenceHeights)['h4'], -2), ";}h5{", $4bdf3f9483c83612$var$inlineImageHeight((0, $ewS35.referenceHeights)['h5'], -2), ";}h6{", $4bdf3f9483c83612$var$inlineImageHeight((0, $ewS35.referenceHeights)['h6'], -2), ";}");
const $4bdf3f9483c83612$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $8Z0o8.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$4bdf3f9483c83612$export$7ab34e219ce6eef}, ${(0, $ewS35.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $4bdf3f9483c83612$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $8Z0o8.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    outline: 'none'
});
const $4bdf3f9483c83612$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $8Z0o8.css)({
    borderColor: `var(${$4bdf3f9483c83612$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$4bdf3f9483c83612$export$263a8a844c370a89}, ${(0, $ewS35.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$4bdf3f9483c83612$export$263a8a844c370a89}, ${(0, $ewS35.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("ewS35", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $d03e34911f30179f$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $d03e34911f30179f$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $d03e34911f30179f$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $d03e34911f30179f$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $d03e34911f30179f$export$c1317a9224e4d798);
const $d03e34911f30179f$export$d722b7527b1834a8 = 250;
const $d03e34911f30179f$export$da894f7669b4e67c = 200;
const $d03e34911f30179f$export$286cf28b87ad4b4f = $d03e34911f30179f$export$d722b7527b1834a8 / $d03e34911f30179f$export$da894f7669b4e67c;
const $d03e34911f30179f$export$64fe09732fb8680 = 0;
const $d03e34911f30179f$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("gNjEp", function(module, exports) {
$parcel$export(module.exports, "DateSharedCssClassName", () => $a5e42d5d52089039$export$99cdf122d0bb9f95);
const $a5e42d5d52089039$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};

});

parcelRegister("60GDJ", function(module, exports) {
$parcel$export(module.exports, "richMediaClassName", () => $b177ded6bdd8bb1e$export$cfe6da7d522d87bb);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8Z0o8 = parcelRequire("8Z0o8");

var $e7vUY = parcelRequire("e7vUY");
const $b177ded6bdd8bb1e$export$cfe6da7d522d87bb = 'rich-media-item';
const $b177ded6bdd8bb1e$var$wrappedMediaBreakoutPoint = 410;
const $b177ded6bdd8bb1e$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right, .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left, .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left, .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$b177ded6bdd8bb1e$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $b177ded6bdd8bb1e$export$b51dea84d928a378 = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $e7vUY.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right, .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left, .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-left, .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right + .${$b177ded6bdd8bb1e$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$b177ded6bdd8bb1e$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("c0CLP", function(module, exports) {
$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $bb5c6805494456ee$export$4ccd31bf665a88f6);
const $bb5c6805494456ee$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};

});

parcelRegister("cRJ6A", function(module, exports) {
$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $3e2278ba295df548$export$a7172b75d403a0e4);
const $3e2278ba295df548$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};

});

parcelRegister("8BjtO", function(module, exports) {
$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $74f54eb653793e71$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $74f54eb653793e71$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $e7vUY = parcelRequire("e7vUY");
var $cjVzK = parcelRequire("cjVzK");

var $96QRs = parcelRequire("96QRs");

var $kQo2Z = parcelRequire("kQo2Z");

var $lnxsR = parcelRequire("lnxsR");
const $74f54eb653793e71$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${(0, $e7vUY.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $e7vUY.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            display: 'flex',
            borderRadius: "var(--ds-radius-small, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #292A2E)",
                borderRadius: "var(--ds-radius-small, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #6B6E76)",
            boxSizing: 'content-box'
        }
    }
});
const $74f54eb653793e71$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    [`.${(0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $74f54eb653793e71$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $74f54eb653793e71$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $8Z0o8.css)(".", (0, $lnxsR.RendererCssClassName).DOCUMENT, ">.", $74f54eb653793e71$export$afbde0e7339bed51.CONTAINER, " .", (0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $e7vUY.blockNodesVerticalMargin), ";}");
};
const $74f54eb653793e71$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $8P7DW.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $kQo2Z.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $74f54eb653793e71$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $cjVzK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $74f54eb653793e71$var$codeBlockSharedStyles,
            $74f54eb653793e71$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        className: (0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        className: (0, $96QRs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("code", null, renderBidiWarnings(text))))));
});
var $74f54eb653793e71$export$2e2bcd8739ae039 = $74f54eb653793e71$var$LightWeightCodeBlock;

});
parcelRegister("kQo2Z", function(module, exports) {
$parcel$export(module.exports, "useBidiWarnings", () => $31292aa883f5892d$export$9fb9fe546a188c7b);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $6Dupw = parcelRequire("6Dupw");

var $3qzDg = parcelRequire("3qzDg");

var $8GhAC = parcelRequire("8GhAC");

var $13svG = parcelRequire("13svG");
const $31292aa883f5892d$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $k7INq.default)();
    const warningLabel = intl.formatMessage((0, $3qzDg.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        if ((0, $13svG.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return text;
        return (0, $8GhAC.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Dupw.default), {
                bidiCharacter: bidiCharacter,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }, index));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


parcelRegister("i4qXD", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fd813140daf742f$export$2e2bcd8739ae039);

var $e6Qdr = parcelRequire("e6Qdr");

var $eVmnA = parcelRequire("eVmnA");
function $4fd813140daf742f$var$editorUGCToken(path) {
    let tokens;
    if ((0, $e6Qdr.fg)('platform_editor_typography_ugc')) tokens = (0, $eVmnA.editorUGCTokensRefreshed);
    else tokens = (0, $eVmnA.editorUGCTokens);
    return tokens[path];
}
var $4fd813140daf742f$export$2e2bcd8739ae039 = $4fd813140daf742f$var$editorUGCToken;

});
parcelRegister("eVmnA", function(module, exports) {
$parcel$export(module.exports, "editorUGCTokens", () => $dd5bc821edb74cec$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $dd5bc821edb74cec$export$63adc0ebe3278d31);
const $dd5bc821edb74cec$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $dd5bc821edb74cec$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $dd5bc821edb74cec$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body.small': 'normal 400 0.875em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});


parcelRegister("WtfHk", function(module, exports) {
$parcel$export(module.exports, "getBaseFontSize", () => $901c675e7041ba75$export$8e2864079bc476bd);

var $e7vUY = parcelRequire("e7vUY");

var $13svG = parcelRequire("13svG");
const $901c675e7041ba75$export$8e2864079bc476bd = (appearance, contentMode)=>{
    if ((0, $13svG.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $13svG.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === 'compact') return 0, $e7vUY.akEditorFullPageDenseFontSize;
    }
    return appearance && appearance !== 'comment' ? (0, $e7vUY.akEditorFullPageDefaultFontSize) : 14;
};

});

parcelRegister("iBqpw", function(module, exports) {
$parcel$export(module.exports, "EmojiSharedCssClassName", () => $4431726d6f7df0a3$export$ee47248f9a998789);

var $lvPZY = parcelRequire("lvPZY");
const $4431726d6f7df0a3$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $lvPZY.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $lvPZY.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $lvPZY.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $lvPZY.placeholder)
};

});
parcelRegister("lvPZY", function(module, exports) {
$parcel$export(module.exports, "commonSelectedStyles", () => $1f387b6cd8b5d335$export$8633a0edef8e95dd);
$parcel$export(module.exports, "selectOnHoverStyles", () => $1f387b6cd8b5d335$export$860109dfd198259b);
$parcel$export(module.exports, "emojiSprite", () => $1f387b6cd8b5d335$export$1c10634420a08d8a);
$parcel$export(module.exports, "emojiNodeStyles", () => $1f387b6cd8b5d335$export$b06c4aab1d012063);
$parcel$export(module.exports, "emojiImage", () => $1f387b6cd8b5d335$export$da61cef1c8919f7c);
$parcel$export(module.exports, "emojiDeleteButton", () => $1f387b6cd8b5d335$export$b11fa39b56a371f6);
$parcel$export(module.exports, "emojiMainStyle", () => $1f387b6cd8b5d335$export$11462c0756c24ab6);
$parcel$export(module.exports, "deletableEmoji", () => $1f387b6cd8b5d335$export$22b19c311e9caa4);
$parcel$export(module.exports, "placeholder", () => $1f387b6cd8b5d335$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "emojiPickerAddEmoji", () => $1f387b6cd8b5d335$export$b0fe756d87022806);
const $1f387b6cd8b5d335$export$8633a0edef8e95dd = 'emoji-common-selected';
const $1f387b6cd8b5d335$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $1f387b6cd8b5d335$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $1f387b6cd8b5d335$export$b06c4aab1d012063 = 'emoji-common-node';
const $1f387b6cd8b5d335$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $1f387b6cd8b5d335$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $1f387b6cd8b5d335$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $1f387b6cd8b5d335$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $1f387b6cd8b5d335$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $1f387b6cd8b5d335$export$b0fe756d87022806 = 'emoji-picker-add-emoji';

});


parcelRegister("6NJxZ", function(module, exports) {
$parcel$export(module.exports, "SyncBlockSharedCssClassName", () => $51893d25c740b1b2$export$84840734cffb342f);
$parcel$export(module.exports, "SyncBlockRendererDataAttributeName", () => $51893d25c740b1b2$export$8c57d8325d08218b);
$parcel$export(module.exports, "BodiedSyncBlockSharedCssClassName", () => $51893d25c740b1b2$export$628f41eb22ec9a2);
$parcel$export(module.exports, "SyncBlockLabelSharedCssClassName", () => $51893d25c740b1b2$export$f75b6075afbd73af);
$parcel$export(module.exports, "SyncBlockStateCssClassName", () => $51893d25c740b1b2$export$9b10dd4c500e3ce8);
const $51893d25c740b1b2$var$prefix = 'ak-editor-sync-block';
const $51893d25c740b1b2$export$84840734cffb342f = {
    prefix: $51893d25c740b1b2$var$prefix,
    renderer: `${$51893d25c740b1b2$var$prefix}__renderer`,
    error: `${$51893d25c740b1b2$var$prefix}__error_state`,
    loading: `${$51893d25c740b1b2$var$prefix}__loading_state`
};
const $51893d25c740b1b2$export$8c57d8325d08218b = 'data-sync-block-renderer';
const $51893d25c740b1b2$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
const $51893d25c740b1b2$export$628f41eb22ec9a2 = {
    prefix: $51893d25c740b1b2$var$bodiedPrefix,
    renderer: `${$51893d25c740b1b2$var$bodiedPrefix}__renderer`,
    content: `${$51893d25c740b1b2$var$bodiedPrefix}__content`,
    selectionInside: `${$51893d25c740b1b2$var$bodiedPrefix}__selection_inside`
};
const $51893d25c740b1b2$var$labelClassName = 'ak-editor-sync-block__label';
const $51893d25c740b1b2$export$f75b6075afbd73af = {
    labelClassName: $51893d25c740b1b2$var$labelClassName
};
const $51893d25c740b1b2$export$7e44804769d54f36 = 'disabled';
const $51893d25c740b1b2$export$da351099a95c41a2 = 'view-mode';
const $51893d25c740b1b2$export$ddb90512ea536019 = 'creation-loading';
const $51893d25c740b1b2$export$52ab9fe57e8e4c2e = 'user-is-dragging';
const $51893d25c740b1b2$export$9b10dd4c500e3ce8 = {
    disabledClassName: $51893d25c740b1b2$export$7e44804769d54f36,
    viewModeClassName: $51893d25c740b1b2$export$da351099a95c41a2,
    creationLoadingClassName: $51893d25c740b1b2$export$ddb90512ea536019,
    draggingClassName: $51893d25c740b1b2$export$52ab9fe57e8e4c2e
};

});


parcelRegister("3ztD5", function(module, exports) {
$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $a84726a805c09af7$export$c94cfc0c675062a1);
const $a84726a805c09af7$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !((child === null || child === void 0 ? void 0 : child.type) === 'hardBreak' || (child === null || child === void 0 ? void 0 : child.type) === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});

parcelRegister("iQv2h", function(module, exports) {
$parcel$export(module.exports, "useMemoFromPropsDerivative", () => $84d896603fdcc3a7$export$80ffe7e3c6bf25c3);

var $8P7DW = parcelRequire("8P7DW");
function $84d896603fdcc3a7$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $8P7DW.useRef)(props);
    const prevFactory = (0, $8P7DW.useRef)(null);
    return (0, $8P7DW.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}

});

parcelRegister("aFaoZ", function(module, exports) {
$parcel$export(module.exports, "PortalContext", () => $75ed141045260c91$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $75ed141045260c91$export$b1072f43c67b540c);

var $8P7DW = parcelRequire("8P7DW");
const $75ed141045260c91$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(undefined);
function $75ed141045260c91$export$b1072f43c67b540c(props) {
    const portalFromContext = (0, $8P7DW.useContext)($75ed141045260c91$export$60d741e20e0aa309);
    return (props === null || props === void 0 ? void 0 : props.portal) || portalFromContext;
}

});

parcelRegister("lJcO1", function(module, exports) {
$parcel$export(module.exports, "getWidthInfoPayload", () => $72a5722fe9917e6c$export$208d2421b73f3f86);
$parcel$export(module.exports, "getHeightInfoPayload", () => $72a5722fe9917e6c$export$34e5b28c67455a81);

var $eguiP = parcelRequire("eguiP");
var $9esGq = parcelRequire("9esGq");
var $jdl3d = parcelRequire("jdl3d");

var $7VS6B = parcelRequire("7VS6B");
const $72a5722fe9917e6c$export$208d2421b73f3f86 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    const editorWidth = renderer.scrollWidth;
    return {
        action: (0, $jdl3d.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $eguiP.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $7VS6B.getBreakpointKey)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $7VS6B.getBreakpointKey)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            mode: (0, $9esGq.MODE).RENDERER
        },
        eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL
    };
};
const $72a5722fe9917e6c$export$34e5b28c67455a81 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ const rendererClientHeight = renderer.clientHeight;
    const viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $jdl3d.TABLE_ACTION).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $eguiP.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $eguiP.EVENT_TYPE).OPERATIONAL
    };
};

});
parcelRegister("9esGq", function(module, exports) {
$parcel$export(module.exports, "PLATFORMS", () => $bffcf317e823bd03$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $bffcf317e823bd03$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $bffcf317e823bd03$export$57453495b81e2dde);
$parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", () => $bffcf317e823bd03$export$60a219cfaef9722);
var $bffcf317e823bd03$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $bffcf317e823bd03$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $bffcf317e823bd03$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $bffcf317e823bd03$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

});

parcelRegister("jdl3d", function(module, exports) {
$parcel$export(module.exports, "TABLE_ACTION", () => $6a7812c8551de4a2$export$1627223e090990cf);
$parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", () => $6a7812c8551de4a2$export$e0b2ad636c1c8ab4);
$parcel$export(module.exports, "TABLE_STATUS", () => $6a7812c8551de4a2$export$90dde066fa32cf2f);
$parcel$export(module.exports, "TABLE_DISPLAY_MODE", () => $6a7812c8551de4a2$export$a62a68f32aa71693);
$parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", () => $6a7812c8551de4a2$export$ba2dfc055a59d951);
var $6a7812c8551de4a2$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    TABLE_ACTION["DRAG_MENU_OPENED"] = "dragMenuOpened";
    /**
   * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
   * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
   */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    TABLE_ACTION["STICKY_HEADER_METHOD_TOGGLED"] = "stickyHeaderMethodToggled";
    TABLE_ACTION["FIT_TO_CONTENT_AUTO_CONVERTED"] = "fitToContentAutoConverted";
    TABLE_ACTION["FIT_TO_CONTENT_ON_DEMAND"] = "fitToContentOnDemand";
    return TABLE_ACTION;
}({});
var $6a7812c8551de4a2$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $6a7812c8551de4a2$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $6a7812c8551de4a2$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $6a7812c8551de4a2$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $6a7812c8551de4a2$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});

});



parcelRegister("5Yojh", function(module, exports) {
$parcel$export(module.exports, "ButtonStyle", () => $91d53767f8c27c74$export$bdc3c19374266b98);
$parcel$export(module.exports, "CornerStyle", () => $91d53767f8c27c74$export$a6e645fda5339bf8);
$parcel$export(module.exports, "Height", () => $91d53767f8c27c74$export$8954cfac7c08d16a);
$parcel$export(module.exports, "Alignment", () => $91d53767f8c27c74$export$9d7927214ed7d2cf);
$parcel$export(module.exports, "Orientation", () => $91d53767f8c27c74$export$df54d73aa0ec5e82);
$parcel$export(module.exports, "CardLayout", () => $91d53767f8c27c74$export$21e76ed09a093e97);
$parcel$export(module.exports, "CommonLayout", () => $91d53767f8c27c74$export$42809f9f1496f50d);
$parcel$export(module.exports, "FeedbackType", () => $91d53767f8c27c74$export$d4c0482bf980ef26);
$parcel$export(module.exports, "ExtensionMode", () => $91d53767f8c27c74$export$533ae1c1b7b7ac6);
$parcel$export(module.exports, "RenderVariant", () => $91d53767f8c27c74$export$1f60141b6ce5efed);
$parcel$export(module.exports, "SegmentationTargets", () => $91d53767f8c27c74$export$f6cd408cac7f930c);
$parcel$export(module.exports, "ITEM_FIELDS", () => $91d53767f8c27c74$export$bf7ebf7fed6e7189);
var $91d53767f8c27c74$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $91d53767f8c27c74$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $91d53767f8c27c74$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $91d53767f8c27c74$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $91d53767f8c27c74$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $91d53767f8c27c74$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $91d53767f8c27c74$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $91d53767f8c27c74$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $91d53767f8c27c74$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $91d53767f8c27c74$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $91d53767f8c27c74$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $91d53767f8c27c74$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $91d53767f8c27c74$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});

});

parcelRegister("7gpfw", function(module, exports) {
$parcel$export(module.exports, "HubRendererWrapper", () => $c16f8154daf45bd5$export$1a063b7cda785385);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $c16f8154daf45bd5$export$1a063b7cda785385 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_1p9midpf _1awjidpf _1o1jckbl _1bweckbl _tnsdidpf _127midpf _128sckbl _s8ydckbl _utchidpf _ovodidpf _rtpd1uiu _1c211uiu _qndeidpf _1k6kidpf _tjcw1uiu _mctt1uiu _1cw71ihj _yqhm1ihj _1a031ssb _1fd01ssb _x0t7zr6s _ato1zr6s _14cj147o _13rb147o _1gygjo1l _78a5jo1l _1iimidpf _bq9jidpf _kf5midpf _e5isidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hnw2m", function(module, exports) {
$parcel$export(module.exports, "getSectionExtensionContents", () => $104a86cc1d4746d0$export$993dca3597b448e8);

var $al89p = parcelRequire("al89p");
const $104a86cc1d4746d0$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>[
        {
            type: 'extensionFrame',
            content: [
                {
                    type: 'heading',
                    attrs: {
                        level: 1,
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${header}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${subHeader}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    }
                },
                {
                    type: 'extension',
                    attrs: {
                        extensionKey: (0, $al89p.HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY),
                        extensionType: (0, $al89p.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
                        parameters: {
                            extensionTitle: placeholderTitle
                        },
                        text: null,
                        layout: 'default',
                        localId: null
                    }
                }
            ]
        }
    ];

});
parcelRegister("al89p", function(module, exports) {
$parcel$export(module.exports, "HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE", () => $6e874288acb6c201$export$c14e692c91462ed4);
$parcel$export(module.exports, "HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY", () => $6e874288acb6c201$export$ca3a94184e0fbd97);
const $6e874288acb6c201$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $6e874288acb6c201$export$ca3a94184e0fbd97 = 'hub-element-placeholder';

});


parcelRegister("3Ks2d", function(module, exports) {
$parcel$export(module.exports, "sectionExtensionProvider", () => $4a27ae0674a2a1b3$export$6775abcfdb3b0453);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $fuRVo = parcelRequire("fuRVo");

var $SrrP2 = parcelRequire("SrrP2");

var $4peLG = parcelRequire("4peLG");

var $5LbXW = parcelRequire("5LbXW");
var $2fABU = parcelRequire("2fABU");

var $647Wr = parcelRequire("647Wr");

var $3mXBL = parcelRequire("3mXBL");

const $4a27ae0674a2a1b3$var$SectionExtension = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: async ()=>(await (parcelRequire("4jn3D"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "section-extension-loader"
        })
});
const $4a27ae0674a2a1b3$var$sectionParameters = (intl)=>({
        extensionTitle: intl.formatMessage((0, $3mXBL.messages).lozengeTitle),
        backgroundColor: (0, $647Wr.DEFAULT_BACKGROUND_COLOR),
        contentWidth: (0, $647Wr.DEFAULT_CONTENT_WIDTH)
    });

const $4a27ae0674a2a1b3$export$6775abcfdb3b0453 = ({ getSectionExtensionContents: getSectionExtensionContents, mode: mode, propsProvider: propsProvider })=>async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const title = intl.formatMessage((0, $3mXBL.messages).title);
        const description = intl.formatMessage((0, $3mXBL.messages).description);
        const parameters = $4a27ae0674a2a1b3$var$sectionParameters(intl);
        const type = (0, $2fABU.SECTION_EXTENSION_TYPE);
        const key = (0, $647Wr.SECTION_EXTENSION_KEY);
        const initialContentText = {
            header: intl.formatMessage((0, $3mXBL.messages).contentHeader),
            subHeader: intl.formatMessage((0, $3mXBL.messages).contentSubHeader),
            placeholderTitle: intl.formatMessage((0, $3mXBL.messages).placeHolderTitle)
        };
        const icons = {
            '48': ()=>(parcelRequire("lFqBZ")).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, $gWgPx.jsx)(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const update = async ()=>{
            var _editorActions$getSel, _selectedNode$attrs;
            const selectedNode = editorActions === null || editorActions === void 0 || (_editorActions$getSel = editorActions.getSelectedNode()) === null || _editorActions$getSel === void 0 ? void 0 : _editorActions$getSel.toJSON();
            const selectedLocalId = selectedNode === null || selectedNode === void 0 || (_selectedNode$attrs = selectedNode.attrs) === null || _selectedNode$attrs === void 0 ? void 0 : _selectedNode$attrs.localId;
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        const render = async ()=>({ node: node, actions: actions })=>{
                return /*#__PURE__*/ (0, $gWgPx.jsx)($4a27ae0674a2a1b3$var$SectionExtension, {
                    contentId: contentId,
                    extensionNode: node,
                    editorActions: editorActions,
                    mbeActions: actions,
                    mode: mode,
                    propsProvider: propsProvider
                });
            };
        const additionalModuleNodeProps = {
            __allowBodiedOverride: true
        };
        return new (0, $SrrP2.default)([
            (0, $5LbXW.getExtensionManifest)({
                key: key,
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                source: 'premiumSectionInsert',
                nodeType: 'multiBodiedExtension',
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'multiBodiedExtension',
                        key: 'hub-section',
                        attrs: {
                            extensionType: type,
                            extensionKey: 'hub-section',
                            layout: 'full-width',
                            parameters: parameters
                        },
                        content: getSectionExtensionContents(initialContentText)
                    }),
                additionalModuleNodeProps: additionalModuleNodeProps
            })
        ]);
    };

});
parcelRegister("SrrP2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d6442d51acb73cd$export$2e2bcd8739ae039);

var $ppUL8 = parcelRequire("ppUL8");
class $5d6442d51acb73cd$export$2e2bcd8739ae039 {
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsCache = [];
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            var _manifest$modules;
            const nodes = manifest === null || manifest === void 0 || (_manifest$modules = manifest.modules) === null || _manifest$modules === void 0 ? void 0 : _manifest$modules.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                var _preloadRender, _ref;
                preloadCalls.push(node === null || node === void 0 || (_preloadRender = (_ref = node).preloadRender) === null || _preloadRender === void 0 ? void 0 : _preloadRender.call(_ref));
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $ppUL8.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
}

});
parcelRegister("ppUL8", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertItemsFromModule", () => $77c3cad08144712b$export$a1d0004a197b97a3);
$parcel$export(module.exports, "getAutoConvertPatternsFromModule", () => $77c3cad08144712b$export$60407594ea5edd1c);
$parcel$export(module.exports, "getExtensionAutoConvertersFromProvider", () => $77c3cad08144712b$export$38a3a11e6509754a);
$parcel$export(module.exports, "getContextualToolbarItemsFromModule", () => $77c3cad08144712b$export$9d13b95c50a2a6c9);

var $e6Qdr = parcelRequire("e6Qdr");

var $krBAk = parcelRequire("krBAk");
const $77c3cad08144712b$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arr.reduce((acc, item)=>{
        acc[keyRenamer(item[attr])] = item;
        return acc;
    }, {});
function $77c3cad08144712b$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $krBAk.buildAction)(extensionModule.action, manifest);
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        key: key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        categories: extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        ...((0, $e6Qdr.fg)('cc_fd_wb_create_priority_in_slash_menu_enabled') || (0, $e6Qdr.fg)('rovo_chat_enable_skills_ui_m1')) && {
            priority: extensionModule.priority
        },
        ...extensionModule.lozenge != null && {
            lozenge: extensionModule.lozenge
        },
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
const $77c3cad08144712b$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>$77c3cad08144712b$export$30871400b97708b4(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $77c3cad08144712b$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
const $77c3cad08144712b$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
async function $77c3cad08144712b$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return $77c3cad08144712b$export$5ae7aa0814ef4090(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $77c3cad08144712b$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $77c3cad08144712b$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $77c3cad08144712b$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $77c3cad08144712b$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $77c3cad08144712b$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $77c3cad08144712b$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $77c3cad08144712b$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $77c3cad08144712b$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$77c3cad08144712b$var$compareContext(currentContext, context)));
    }
};
const $77c3cad08144712b$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $77c3cad08144712b$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $77c3cad08144712b$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($77c3cad08144712b$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ($77c3cad08144712b$var$isToolbarButton(toolbarItem)) return $77c3cad08144712b$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                    return toolbarItem;
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $77c3cad08144712b$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $77c3cad08144712b$var$shouldAddExtensionItemForNode(item, node) {
    var _node$attrs;
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType)) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') {
        var _node$attrs2;
        return extensionKey === ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey);
    }
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) {
        var _node$attrs3;
        return extensionKey.includes((_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.extensionKey);
    }
    return false;
}

});


parcelRegister("5LbXW", function(module, exports) {
$parcel$export(module.exports, "getExtensionManifest", () => $d7a0a1771cc7b47d$export$573ee875a39e7e73);
const $d7a0a1771cc7b47d$export$573ee875a39e7e73 = ({ key: key, icons: icons, parameters: parameters, update: update, render: render, title: title, type: type, description: description, source: source, nodeType: nodeType = 'extension', quickInsertAction: quickInsertAction, setUpsellModalSource: setUpsellModalSource, additionalModuleNodeProps: additionalModuleNodeProps })=>{
    return {
        title: title,
        type: type,
        key: key,
        description: description,
        icons: icons,
        modules: {
            quickInsert: setUpsellModalSource ? [
                {
                    key: 'quick-insert',
                    action: async ()=>setUpsellModalSource(source)
                }
            ] : [
                {
                    key: 'quick-insert',
                    action: quickInsertAction || {
                        type: 'node',
                        key: 'default',
                        parameters: parameters
                    }
                }
            ],
            nodes: {
                default: {
                    type: nodeType,
                    render: render,
                    update: update,
                    ...additionalModuleNodeProps
                }
            }
        }
    };
};

});

parcelRegister("647Wr", function(module, exports) {
$parcel$export(module.exports, "SECTION_EXTENSION_KEY", () => $06b5ff1decd46404$export$bc69bf23ec1f99d5);
$parcel$export(module.exports, "SECTION_EXTENSION_ANALYTICS_SOURCE", () => $06b5ff1decd46404$export$7a75cc6a69e05549);
$parcel$export(module.exports, "CONTENT_WIDTH", () => $06b5ff1decd46404$export$3130b484681bf8bc);
$parcel$export(module.exports, "DEFAULT_CONTENT_WIDTH", () => $06b5ff1decd46404$export$6cccba5fae1d609d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_COLOR", () => $06b5ff1decd46404$export$617cdcc6afaae4f7);
const $06b5ff1decd46404$export$bc69bf23ec1f99d5 = 'hub-section';
const $06b5ff1decd46404$export$7a75cc6a69e05549 = 'hub-sectionExtensionConfig';
var $06b5ff1decd46404$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $06b5ff1decd46404$export$6cccba5fae1d609d = "wide";
const $06b5ff1decd46404$export$617cdcc6afaae4f7 = "var(--ds-surface-overlay, #FFFFFF)";

});

parcelRegister("3mXBL", function(module, exports) {
$parcel$export(module.exports, "messages", () => $130f5cb254541832$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $130f5cb254541832$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    title: {
        id: 'company-hub.section-extension.manifest.extension-title',
        defaultMessage: 'Section [New]',
        description: 'Title of section extension to be displayed in shortcut macros dropdown.'
    },
    lozengeTitle: {
        id: 'company-hub.section-extension.manifest.extension-lozenge-title',
        defaultMessage: 'Section',
        description: 'Title of section extension to be displayed in lozenge'
    },
    description: {
        id: 'company-hub.section-extension.manifest.macro-description',
        defaultMessage: 'Group elements together with a background',
        description: 'Description of section extension to be displayed in toolbar/shortcut macros dropdown'
    },
    contentHeader: {
        id: 'company-hub.section-extension.manifest.content.header',
        defaultMessage: 'Give your section a title',
        description: "Header of section extension's initial content"
    },
    contentSubHeader: {
        id: 'company-hub.section-extension.manifest.content.sub-header',
        defaultMessage: 'Organize elements into sections with customizable backgrounds.',
        description: "Sub-header of section extension's initial content"
    },
    placeHolderTitle: {
        id: 'company-hub.section-extension.manifest.content.placeholder-title',
        defaultMessage: 'Placeholder',
        description: 'Title of hub element placeholder extension to be displayed the macro is presented in the editor.'
    }
});

});

parcelRegister("4jn3D", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("9Mr2g").then(()=>parcelRequire('kqNCl'));

});

parcelRegister("lFqBZ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("7V8QL").then(()=>parcelRequire('fGvaY'));

});


parcelRegister("i9yMb", function(module, exports) {
$parcel$export(module.exports, "useHubExtensionHandlers", () => $ddc6080315fe65fe$export$617d11c0fd386821);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fuRVo = parcelRequire("fuRVo");

var $4peLG = parcelRequire("4peLG");

var $ausAh = parcelRequire("ausAh");

var $lDrNL = parcelRequire("lDrNL");

var $5Yojh = parcelRequire("5Yojh");
var $2fABU = parcelRequire("2fABU");

var $enFpa = parcelRequire("enFpa");

const $ddc6080315fe65fe$var$SpotlightExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: async ()=>(await (parcelRequire("gimGE"))).SpotlightExtension,
    loading: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "spotlight-extension-loader",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {})
        })
});

const $ddc6080315fe65fe$var$LinksMenuLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: async ()=>(await (parcelRequire("kqMke"))).LinksMenu,
    loading: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "links-menu-extension-loader",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {})
        })
});

const $ddc6080315fe65fe$export$b55cedbe49066c7 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: async ()=>(await (parcelRequire("98iAV"))).CardsExtension,
    loading: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "cards-extension-loader",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {})
        })
});

const $ddc6080315fe65fe$var$CarouselLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: async ()=>(await (parcelRequire("7uKDR"))).Carousel,
    loading: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "carousel-extension-loader",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {})
        })
});

const $ddc6080315fe65fe$var$SectionExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: async ()=>(await (parcelRequire("1NRYK"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "section-extension-loader",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {})
        })
});
const $ddc6080315fe65fe$export$617d11c0fd386821 = (props)=>{
    const { contentId: contentId, PropsProvider: PropsProvider } = props;
    const extensionHandlers = {
        [(0, $2fABU.SPOTLIGHT_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {}),
        [(0, $enFpa.LINKS_MENU_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {}),
        [(0, $ausAh.CARDS_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {}),
        [(0, $lDrNL.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {}),
        [(0, $2fABU.SECTION_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {})
    };
    const defaultExtensionHandlerProps = (0, $8P7DW.useMemo)(()=>({
            contentId: contentId,
            propsProvider: PropsProvider,
            mode: (0, $5Yojh.ExtensionMode).RENDERER
        }), [
        contentId,
        PropsProvider
    ]);
    const spotlightExtension = (0, $8P7DW.useCallback)((extension)=>/*#__PURE__*/ (0, $gWgPx.jsx)($ddc6080315fe65fe$var$SpotlightExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const linksMenuExtension = (0, $8P7DW.useCallback)((extension)=>/*#__PURE__*/ (0, $gWgPx.jsx)($ddc6080315fe65fe$var$LinksMenuLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const cardsExtension = (0, $8P7DW.useCallback)((extension)=>/*#__PURE__*/ (0, $gWgPx.jsx)($ddc6080315fe65fe$export$b55cedbe49066c7, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const carouselExtension = (0, $8P7DW.useCallback)((extension)=>/*#__PURE__*/ (0, $gWgPx.jsx)($ddc6080315fe65fe$var$CarouselLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const sectionExtension = (0, $8P7DW.useCallback)((extension)=>/*#__PURE__*/ (0, $gWgPx.jsx)($ddc6080315fe65fe$var$SectionExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    if (contentId) {
        extensionHandlers[0, $2fABU.SPOTLIGHT_EXTENSION_TYPE] = spotlightExtension;
        extensionHandlers[0, $enFpa.LINKS_MENU_EXTENSION_TYPE] = linksMenuExtension;
        extensionHandlers[0, $ausAh.CARDS_EXTENSION_TYPE] = cardsExtension;
        extensionHandlers[0, $lDrNL.carouselExtensionType] = carouselExtension;
        extensionHandlers[0, $2fABU.SECTION_EXTENSION_TYPE] = sectionExtension;
    }
    return extensionHandlers;
};

});
parcelRegister("ausAh", function(module, exports) {
$parcel$export(module.exports, "CARDS_EXTENSION_TYPE", () => $576ee2473507b267$export$81e5b59a1e176638);
$parcel$export(module.exports, "CARDS_EXTENSION_KEY", () => $576ee2473507b267$export$8a4891a61ff91b00);
$parcel$export(module.exports, "CARDS_EXTENSION_ANALYTIC_SOURCE", () => $576ee2473507b267$export$67bfcae6d68bb0bf);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE", () => $576ee2473507b267$export$7f17fab0aecb44ed);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE", () => $576ee2473507b267$export$6a35a50674becbae);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE", () => $576ee2473507b267$export$9bf56665bf6ea6ed);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE", () => $576ee2473507b267$export$cf23b6d2fd159502);
$parcel$export(module.exports, "CARDS_EXTENSION_VERSION_5", () => $576ee2473507b267$export$b84f9a7c097c895c);
$parcel$export(module.exports, "CARDS_IMAGES_V5", () => $576ee2473507b267$export$5e905747d7497a1f);
const $576ee2473507b267$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $576ee2473507b267$export$8a4891a61ff91b00 = 'cards';
const $576ee2473507b267$export$67bfcae6d68bb0bf = 'cardsExtension';
const $576ee2473507b267$export$7f17fab0aecb44ed = 'cardsExtensionConfig';
const $576ee2473507b267$export$6a35a50674becbae = 'cardsExtensionConfigBackgroundColor';
const $576ee2473507b267$export$9bf56665bf6ea6ed = 'cardsExtensionConfigBorderColor';
const $576ee2473507b267$export$cf23b6d2fd159502 = 'cardsExtensionConfigTextColor';
const $576ee2473507b267$export$131b76b4d30d2b44 = '2';
const $576ee2473507b267$export$a08b7507bedba276 = '3';
const $576ee2473507b267$export$c87753a8bb0c4e75 = '4';
const $576ee2473507b267$export$b84f9a7c097c895c = '5';
const $576ee2473507b267$export$5e905747d7497a1f = [
    {
        src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
        alt: 'closed wooden window'
    },
    {
        src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
        alt: 'green coconut trees'
    },
    {
        src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
        alt: 'white and black striped chair'
    },
    {
        src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
        alt: 'surfboard on top of a cement wall'
    },
    {
        src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
        alt: 'white stairs'
    },
    {
        src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
        alt: 'swimming pool tiles'
    }
];

});

parcelRegister("lDrNL", function(module, exports) {
$parcel$export(module.exports, "carouselExtensionType", () => $8ad74ffab9034bae$export$a06ac4f1777262dc);
$parcel$export(module.exports, "carouselExtensionKey", () => $8ad74ffab9034bae$export$6c8179fa243b4399);
$parcel$export(module.exports, "carouselContentAnalyticSource", () => $8ad74ffab9034bae$export$ca14f22a239c4ae9);
$parcel$export(module.exports, "carouselConfigAnalyticSource", () => $8ad74ffab9034bae$export$4cb671946a80c52e);
$parcel$export(module.exports, "AUTOPLAY_SECONDS", () => $8ad74ffab9034bae$export$93995a2609cff38d);
$parcel$export(module.exports, "ARIA_CONTROLS_PREFIX", () => $8ad74ffab9034bae$export$3a86d0fc7eb402f4);
$parcel$export(module.exports, "CAROUSEL_VERSION_2", () => $8ad74ffab9034bae$export$b429752dfe934bea);
$parcel$export(module.exports, "FRAMES_LIMIT_V2", () => $8ad74ffab9034bae$export$c5c6e75ceae0cc22);
const $8ad74ffab9034bae$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $8ad74ffab9034bae$export$6c8179fa243b4399 = 'carousel';
const $8ad74ffab9034bae$export$ca14f22a239c4ae9 = 'carouselExtension';
const $8ad74ffab9034bae$export$4cb671946a80c52e = 'carouselExtensionConfig';
const $8ad74ffab9034bae$export$93995a2609cff38d = 8;
const $8ad74ffab9034bae$export$3a86d0fc7eb402f4 = 'carousel-navigation-frame-';
const $8ad74ffab9034bae$export$9575b4f5d97a1c29 = '1';
const $8ad74ffab9034bae$export$b429752dfe934bea = '2';
const $8ad74ffab9034bae$export$c5c6e75ceae0cc22 = 10;

});

parcelRegister("enFpa", function(module, exports) {
$parcel$export(module.exports, "LINKS_MENU_EXTENSION_TYPE", () => $5157900478c82b5d$export$9fdf64a495514b4);
$parcel$export(module.exports, "LINKS_MENU_EXTENSION_ANALYTIC_SOURCE", () => $5157900478c82b5d$export$ed5854f17099adbf);
const $5157900478c82b5d$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $5157900478c82b5d$export$ed5854f17099adbf = 'linksMenuExtension';

});

parcelRegister("gimGE", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("gcuLe"),
    $j9MRt("8BvEw"),
    $j9MRt("9olHN"),
    $j9MRt("cJxC9"),
    $j9MRt("9avUk"),
    $j9MRt("hXHOO"),
    $j9MRt("jOqX4"),
    $j9MRt("ldNUV"),
    $j9MRt("8j9le"),
    $j9MRt("iilsR"),
    $j9MRt("3T0Nj"),
    $j9MRt("c3COr"),
    $j9MRt("4RNdI"),
    $j9MRt("8bspp"),
    $j9MRt("fa8kX"),
    $j9MRt("8j2yS"),
    $j9MRt("xmFKN"),
    $j9MRt("1lZlJ"),
    $j9MRt("dFi21"),
    $j9MRt("dGZiO"),
    $j9MRt("dtI78"),
    $j9MRt("kl68g"),
    $j9MRt("7FtPh"),
    $j9MRt("apr9b"),
    $j9MRt("8PAFa")
]).then(()=>parcelRequire('gtlaz'));

});

parcelRegister("kqMke", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("lILRo"),
    $j9MRt("8BvEw"),
    $j9MRt("9olHN"),
    $j9MRt("cJxC9"),
    $j9MRt("8kyys"),
    $j9MRt("ldNUV"),
    $j9MRt("8j9le"),
    $j9MRt("4aGdS"),
    $j9MRt("bvf9Q"),
    $j9MRt("9v13v"),
    $j9MRt("bZpYE"),
    $j9MRt("fa8kX"),
    $j9MRt("xmFKN"),
    $j9MRt("1OBja"),
    $j9MRt("dFi21"),
    $j9MRt("f6wee"),
    $j9MRt("37HiO"),
    $j9MRt("1z2hL"),
    $j9MRt("eGI7O"),
    $j9MRt("2DC3R"),
    $j9MRt("6h2qj"),
    $j9MRt("eP811"),
    $j9MRt("kU4E8"),
    $j9MRt("glmjZ"),
    $j9MRt("1f9SB")
]).then(()=>parcelRequire('invVu'));

});

parcelRegister("98iAV", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("cpj1W"),
    $j9MRt("cYpPH"),
    $j9MRt("2W1MK"),
    $j9MRt("gcuLe"),
    $j9MRt("8BvEw"),
    $j9MRt("9olHN"),
    $j9MRt("8uIxy"),
    $j9MRt("ldNUV"),
    $j9MRt("8j9le"),
    $j9MRt("k9PE9"),
    $j9MRt("1Seuf"),
    $j9MRt("iVY1y"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("iilsR"),
    $j9MRt("3T0Nj"),
    $j9MRt("c3COr"),
    $j9MRt("4RNdI"),
    $j9MRt("apr9b"),
    $j9MRt("iOgS1"),
    $j9MRt("399y2"),
    $j9MRt("6KH6K"),
    $j9MRt("fOjDa"),
    $j9MRt("bAXrf"),
    $j9MRt("dRNJC")
]).then(()=>parcelRequire('5mM5X'));

});

parcelRegister("7uKDR", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("22TWt"),
    $j9MRt("CLqDy"),
    $j9MRt("cpj1W"),
    $j9MRt("cYpPH"),
    $j9MRt("gcuLe"),
    $j9MRt("8BvEw"),
    $j9MRt("9olHN"),
    $j9MRt("cJxC9"),
    $j9MRt("9avUk"),
    $j9MRt("ldNUV"),
    $j9MRt("8j9le"),
    $j9MRt("k9PE9"),
    $j9MRt("1Seuf"),
    $j9MRt("iilsR"),
    $j9MRt("3T0Nj"),
    $j9MRt("c3COr"),
    $j9MRt("4RNdI"),
    $j9MRt("8bspp"),
    $j9MRt("dFi21"),
    $j9MRt("dGZiO"),
    $j9MRt("dtI78"),
    $j9MRt("kl68g"),
    $j9MRt("7FtPh"),
    $j9MRt("apr9b"),
    $j9MRt("6u8Mr")
]).then(()=>parcelRequire('c3m57'));

});

parcelRegister("1NRYK", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("9olHN"),
    $j9MRt("cJxC9"),
    $j9MRt("9Mr2g"),
    $j9MRt("ldNUV"),
    $j9MRt("eacO3"),
    $j9MRt("9gmbi"),
    $j9MRt("kd2gR"),
    $j9MRt("h76U6"),
    $j9MRt("imhcw"),
    $j9MRt("e4wG8")
]).then(()=>parcelRequire('2C8fB'));

});



parcelRegister("kvfqT", function(module, exports) {
$parcel$export(module.exports, "useProductExtensionHandlers", () => $f1c8f2f7ca41762b$export$f8392d0e24abe6db);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fuRVo = parcelRequire("fuRVo");

var $e6Qdr = parcelRequire("e6Qdr");

var $4peLG = parcelRequire("4peLG");

var $9gYHc = parcelRequire("9gYHc");
var $2mGqb = parcelRequire("2mGqb");

var $5Yojh = parcelRequire("5Yojh");
var $2fABU = parcelRequire("2fABU");

var $gZY1O = parcelRequire("gZY1O");

var $iygPU = parcelRequire("iygPU");

const $f1c8f2f7ca41762b$var$CalloutBannerExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: async ()=>(await (parcelRequire("4foXH"))).CalloutBannerExtension,
    loading: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "page-topper-extension-loader",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {})
        })
});

const $f1c8f2f7ca41762b$var$ResourceTilesExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: async ()=>(await (parcelRequire("dNK8n"))).ResourceTilesExtension,
    loading: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "resource-tiles-extension-loader",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {})
        })
});

const $f1c8f2f7ca41762b$var$JSMHelpExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: async ()=>(await (parcelRequire("bFYmI"))).JSMHelpExtension,
    loading: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
            name: "jsm-help-extension-loader",
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {})
        })
});

const $f1c8f2f7ca41762b$var$CalloutBannerExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).lazy(()=>(parcelRequire("4foXH")).then((mod)=>({
            default: mod.CalloutBannerExtension
        })));

const $f1c8f2f7ca41762b$var$ResourceTilesExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).lazy(()=>(parcelRequire("dNK8n")).then((mod)=>({
            default: mod.ResourceTilesExtension
        })));

const $f1c8f2f7ca41762b$var$JSMHelpExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).lazy(()=>(parcelRequire("bFYmI")).then((mod)=>({
            default: mod.JSMHelpExtension
        })));
const $f1c8f2f7ca41762b$var$getCSMExtensionHandlers = (contentId, PropsProvider)=>{
    const handlers = {};
    if (!contentId) return handlers;
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $5Yojh.ExtensionMode).RENDERER,
        CustomSearchComponent: (0, $9gYHc.ArticleSearchComponent)
    };
    // Callout banner Extension Handler
    handlers[0, $iygPU.CALLOUT_BANNER_EXTENSION_TYPE] = (extension)=>(0, $e6Qdr.fg)('hub_react_lazy') ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
            fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
                name: "page-topper-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)($f1c8f2f7ca41762b$var$CalloutBannerExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        }) : /*#__PURE__*/ (0, $gWgPx.jsx)($f1c8f2f7ca41762b$var$CalloutBannerExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        });
    // Resource Tiles Extension Handler
    handlers[0, $2fABU.RESOURCE_TILES_EXTENSION_TYPE] = (extension)=>(0, $e6Qdr.fg)('hub_react_lazy') ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
            fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
                name: "resource-tiles-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)($f1c8f2f7ca41762b$var$ResourceTilesExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension,
                isInEditor: false
            })
        }) : /*#__PURE__*/ (0, $gWgPx.jsx)($f1c8f2f7ca41762b$var$ResourceTilesExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension,
            isInEditor: false
        });
    return handlers;
};
const $f1c8f2f7ca41762b$var$getJSMExtensionHandlers = (contentId, PropsProvider)=>{
    const handlers = {};
    if (!contentId) return handlers;
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $5Yojh.ExtensionMode).RENDERER,
        CustomSearchComponent: (0, $2mGqb.HelpObjectSearchComponent)
    };
    handlers[0, $iygPU.CALLOUT_BANNER_EXTENSION_TYPE] = (extension)=>(0, $e6Qdr.fg)('hub_react_lazy') ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
            fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
                name: "page-topper-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)($f1c8f2f7ca41762b$var$CalloutBannerExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        }) : /*#__PURE__*/ (0, $gWgPx.jsx)($f1c8f2f7ca41762b$var$CalloutBannerExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        });
    // JSM Help Extension Handler
    handlers[0, $gZY1O.JSM_HELP_EXTENSION_TYPE] = (extension)=>(0, $e6Qdr.fg)('hub_react_lazy') ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
            fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4peLG.default), {
                name: "jsm-help-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)($f1c8f2f7ca41762b$var$JSMHelpExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        }) : /*#__PURE__*/ (0, $gWgPx.jsx)($f1c8f2f7ca41762b$var$JSMHelpExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        });
    return handlers;
};
const $f1c8f2f7ca41762b$export$f8392d0e24abe6db = (props)=>{
    const { contentId: contentId, PropsProvider: PropsProvider, product: product } = props;
    const extensionHandlers = (0, $8P7DW.useMemo)(()=>{
        if (product === 'CUSTOMER_SERVICE') return $f1c8f2f7ca41762b$var$getCSMExtensionHandlers(contentId, PropsProvider);
        // Future products can be added here with:
        if (product === 'HELP_HUB' && (0, $e6Qdr.fg)('enable-jsm-in-hubs')) return $f1c8f2f7ca41762b$var$getJSMExtensionHandlers(contentId, PropsProvider);
        return {};
    }, [
        product,
        contentId,
        PropsProvider
    ]);
    return extensionHandlers;
};

});
parcelRegister("9gYHc", function(module, exports) {
$parcel$export(module.exports, "ArticleSearchComponent", () => $edc744235dcf87f1$export$8a672206592a1254);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");
parcelRequire("c2L1U");
var $cqrss = parcelRequire("cqrss");

var $2CGHX = parcelRequire("2CGHX");

var $iZRQD = parcelRequire("iZRQD");

var $fe6Ty = parcelRequire("fe6Ty");

var $3xjKO = parcelRequire("3xjKO");

var $cUeBj = parcelRequire("cUeBj");
const $edc744235dcf87f1$export$8a672206592a1254 = ({ isEditor: isEditor, placeholderText: placeholderText })=>{
    var _inputBoxRef$current;
    const [queryWord, setQueryWord] = (0, $8P7DW.useState)('');
    const [showDropdown, setShowDropdown] = (0, $8P7DW.useState)(false);
    const inputBoxRef = (0, $8P7DW.useRef)(null);
    const inputRef = (0, $8P7DW.useRef)(null);
    const [_, setInputWidth] = (0, $8P7DW.useState)((_inputBoxRef$current = inputBoxRef.current) === null || _inputBoxRef$current === void 0 ? void 0 : _inputBoxRef$current.offsetWidth);
    const { cloudId: cloudId, helpCenterAri: helpCenterAri } = (0, $iZRQD.useProductDependencies)();
    (0, $8P7DW.useEffect)(()=>{
        const listener = ()=>{
            var _inputBoxRef$current2;
            return setInputWidth((_inputBoxRef$current2 = inputBoxRef.current) === null || _inputBoxRef$current2 === void 0 ? void 0 : _inputBoxRef$current2.offsetWidth);
        };
        const unbind = (0, $36kyW.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = ()=>{
        if (showDropdown) setShowDropdown(false);
    };
    const trigger = (0, $8P7DW.useCallback)((triggerProps)=>{
        const handleInput = (searchInput)=>{
            setQueryWord(searchInput);
            setShowDropdown(searchInput.trim().length > 0);
        };
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
            ref: inputBoxRef,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cUeBj.SearchTextField), {
                keyboardRef: inputRef,
                ...triggerProps,
                ref: triggerProps.ref,
                onInput: handleInput,
                isReadOnly: isEditor,
                placeholderText: placeholderText,
                showDropdown: showDropdown,
                queryWord: queryWord
            })
        });
    }, [
        isEditor,
        placeholderText,
        showDropdown,
        queryWord
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cqrss.Popup), {
        shouldReturnFocus: false,
        content: (contentProps)=>{
            var _inputBoxRef$current3;
            return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fe6Ty.KeyboardHighlightProvider), {
                listenerNode: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3xjKO.SearchDropdown), {
                    ...contentProps,
                    cloudId: cloudId,
                    helpCenterAri: helpCenterAri || '',
                    inputWidth: ((_inputBoxRef$current3 = inputBoxRef.current) === null || _inputBoxRef$current3 === void 0 ? void 0 : _inputBoxRef$current3.offsetWidth) || 0,
                    queryWord: queryWord
                })
            });
        },
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};

});
parcelRegister("fe6Ty", function(module, exports) {
$parcel$export(module.exports, "useKeyboardNavigation", () => $da295a1245e6667f$export$4da28cf324280418);
$parcel$export(module.exports, "KeyboardHighlightProvider", () => $da295a1245e6667f$export$c8551b32665b42b);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");
const $da295a1245e6667f$export$ef7af5d8bc5d5ac1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext({
    registerKeyboardEnabled: undefined,
    unregisterKeyboardEnabled: undefined,
    getSelectedIndex: undefined,
    highlightComponentAt: undefined,
    unhighlightComponentAt: undefined,
    unhighlightAll: undefined,
    keyboardNavComponents: []
});
const $da295a1245e6667f$export$4da28cf324280418 = (options)=>{
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(null);
    const navigationTrackingId = (options === null || options === void 0 ? void 0 : options.navigationTrackingId) ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $8P7DW.useContext)($da295a1245e6667f$export$ef7af5d8bc5d5ac1);
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const onKeydownCallback = options === null || options === void 0 ? void 0 : options.onKeydownCallback;
    const onHighlightedCallback = options === null || options === void 0 ? void 0 : options.onHighlightedCallback;
    const unregister = (0, $8P7DW.useCallback)(()=>{
        if (registrationId.current && unregisterKeyboardEnabled) // If the ref got removed or changed we unregister the current ref
        unregisterKeyboardEnabled(registrationId.current);
    }, [
        unregisterKeyboardEnabled
    ]);
    // Will unmount effect
    (0, $8P7DW.useEffect)(()=>()=>unregister(), [
        unregister
    ]);
    // Ref change to null
    (0, $8P7DW.useEffect)(()=>{
        !ref && unregister();
    }, [
        ref,
        unregister
    ]);
    // Everything else
    (0, $8P7DW.useEffect)(()=>{
        if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
        if (!ref) return;
        // Then we register the new ref
        if (ref) {
            // Another check here to ensure that the ref we get is actually a DOM node, there's probably better
            // ways to make this check but it doesn't matter too much.
            // If what we get is NOT a DOM node we will log a warning and default back to use React.findDOMNode
            if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                // eslint-disable-next-line
                console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                return;
            }
            registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
        }
    }, [
        ref,
        setIsHighlighted,
        onKeydownCallback,
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        navigationTrackingId,
        onHighlightedCallback
    ]);
    return [
        isHighlighted,
        setRef
    ];
};
class $da295a1245e6667f$export$c8551b32665b42b extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    componentDidMount() {
        this.attach(this.props.listenerNode);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.listenerNode !== this.props.listenerNode) {
            this.detach(prevProps.listenerNode);
            this.attach(this.props.listenerNode);
        }
    }
    componentWillUnmount() {
        this.detach(this.props.listenerNode);
    }
    render() {
        return /*#__PURE__*/ (0, $gWgPx.jsx)($da295a1245e6667f$export$ef7af5d8bc5d5ac1.Provider, {
            value: {
                registerKeyboardEnabled: this.registerKeyboardEnabled,
                unregisterKeyboardEnabled: this.unregisterKeyboardEnabled,
                getSelectedIndex: this.getSelectedIndex,
                highlightComponentAt: this.highlightComponentAt,
                unhighlightComponentAt: this.unhighlightComponentAt,
                unhighlightAll: this.unhighlightAll,
                keyboardNavComponents: this.keyboardNavComponents
            },
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.currentlySelected = undefined, this.currentSelectedTrackingId = null, this.keyboardNavComponents = [], this.registerKeyboardEnabled = (currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCallback)=>{
            const indexAt = this.keyboardNavComponents.findIndex(({ id: id })=>id === currentId);
            // If the currentId is null or we can't find any records of the id we will create a new entry
            const isNew = currentId === null || currentId === undefined || indexAt === -1;
            const id = isNew ? Math.max(...this.keyboardNavComponents.map((component)=>component.id), 0) + 1 : this.keyboardNavComponents[indexAt].id;
            if (isNew) this.keyboardNavComponents.push({
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            });
            else // Otherwise we will update the current entry
            this.keyboardNavComponents[indexAt] = {
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            };
            this.keyboardNavComponents = this.keyboardNavComponents.sort((c1, c2)=>{
                const result = c1.domRef.compareDocumentPosition(c2.domRef);
                if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
                else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
                return 0;
            });
            const indexToHighlight = this.getSearchIdIndex(this.currentSelectedTrackingId);
            if (indexToHighlight !== undefined && indexToHighlight >= 0) {
                this.unhighlightAll();
                this.highlightComponentAt(indexToHighlight);
            }
            return id;
        }, this.unregisterKeyboardEnabled = (unregisterRef)=>{
            if (this.currentlySelected === unregisterRef) this.currentlySelected = undefined;
            this.keyboardNavComponents = this.keyboardNavComponents.filter(({ id: ref })=>ref !== unregisterRef);
            // Reset currentSelectedTrackingId when all components are unregistered
            if (this.keyboardNavComponents.length === 0 && (0, $e6Qdr.fg)('search_fix_keyboard_highlight_persistence')) this.currentSelectedTrackingId = null;
        }, this.onKeyDownCallbackAt = (index, e)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const onKeyDown = this.keyboardNavComponents[index].onKeyDownWhenHighlighted;
                onKeyDown && onKeyDown(e, this.keyboardNavComponents[index].domRef);
            }
        }, this.onHighlightedCallback = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const callback = this.keyboardNavComponents[index].onHighlightedCallback;
                callback && callback(index);
            }
        }, this.unhighlightComponentAt = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) this.keyboardNavComponents[index].onHighlightChanged(false);
        }, this.highlightComponentAt = (index)=>{
            if (index >= 0 && index < this.keyboardNavComponents.length) {
                const { id: id, navigationTrackingId: navigationTrackingId } = this.keyboardNavComponents[index];
                this.currentlySelected = id;
                this.currentSelectedTrackingId = navigationTrackingId;
                this.keyboardNavComponents[index].onHighlightChanged(true);
            }
        }, this.unhighlightAll = ()=>{
            this.currentSelectedTrackingId = null;
            this.currentlySelected = undefined;
            this.keyboardNavComponents.forEach((component)=>component.onHighlightChanged(false));
        }, this.getSelectedIndex = ()=>{
            if (!this.currentlySelected) return undefined;
            return this.keyboardNavComponents.findIndex(({ id: id })=>id === this.currentlySelected);
        }, this.getSearchIdIndex = (searchId)=>searchId === null ? undefined : this.keyboardNavComponents.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), this.onKeyDown = (e)=>{
            if (this.keyboardNavComponents.length === 0) return;
            if (e.isComposing || e.keyCode === 229) return;
            let currentIndex = this.getSelectedIndex();
            const prevIndex = currentIndex;
            if (e.code === 'ArrowDown' || e.keyCode === 40) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = 0;
                    else currentIndex = (currentIndex + 1) % this.keyboardNavComponents.length;
                    e.preventDefault();
                }
            } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = this.keyboardNavComponents.length - 1;
                    else {
                        currentIndex -= 1;
                        if (currentIndex < 0) currentIndex = this.keyboardNavComponents.length - Math.abs(currentIndex);
                    }
                    e.preventDefault();
                }
            } else {
                if (typeof currentIndex !== 'undefined') this.onKeyDownCallbackAt(currentIndex, e);
                return;
            }
            if (prevIndex !== currentIndex && currentIndex !== undefined) {
                this.unhighlightComponentAt(prevIndex);
                this.highlightComponentAt(currentIndex);
                this.onHighlightedCallback(currentIndex);
            }
        }, this.attach = (listenerNode)=>{
            if (listenerNode) listenerNode.addEventListener('keydown', this.onKeyDown);
        }, this.detach = (listenerNode)=>{
            if (listenerNode) listenerNode.removeEventListener('keydown', this.onKeyDown);
        };
    }
}
const $da295a1245e6667f$export$cbeda0f7f7a8026c = ()=>{
    return (0, $8P7DW.useContext)($da295a1245e6667f$export$ef7af5d8bc5d5ac1);
};

});

parcelRegister("3xjKO", function(module, exports) {
$parcel$export(module.exports, "SearchDropdown", () => $4741fa27a2656bf1$export$e33d60b8f4099ae);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $km5oe = parcelRequire("km5oe");

var $cxiV4 = parcelRequire("cxiV4");

var $4dAbH = parcelRequire("4dAbH");
const $4741fa27a2656bf1$export$e33d60b8f4099ae = ({ inputWidth: inputWidth, ...props })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $km5oe.SearchDialog), {
        /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ style: {
            boxShadow: 'none',
            width: inputWidth
        },
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
            fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4dAbH.SearchSkeletons), {}),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cxiV4.ResolvedAndErrorContent), {
                ...props
            })
        })
    });
};

});
parcelRegister("km5oe", function(module, exports) {
$parcel$export(module.exports, "SearchDialog", () => $3fa5a0c7ec0b0931$export$2aadebb53f6015f6);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $bNUe6 = parcelRequire("bNUe6");
const $3fa5a0c7ec0b0931$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $bNUe6.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });

});
parcelRegister("bNUe6", function(module, exports) {
$parcel$export(module.exports, "SearchDialogWrapper", () => $2510ad882872a9ae$export$dcefba65c42da69c);
$parcel$export(module.exports, "ResultContainer", () => $2510ad882872a9ae$export$ab35601bed9ca017);
$parcel$export(module.exports, "SearchDialogContent", () => $2510ad882872a9ae$export$c9e0e8491f083dd5);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $k1WWO = parcelRequire("k1WWO");

var $ndUiP = parcelRequire("ndUiP");
function $2510ad882872a9ae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2510ad882872a9ae$var$SIDEBAR_PANE_WIDTH = 272;
const $2510ad882872a9ae$var$resultContainerVerticalPadding = 8;
const $2510ad882872a9ae$export$dcefba65c42da69c = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "ee3sr7s8"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $k1WWO.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $k1WWO.dialogWidth};` : '', " box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);border-radius:var(--ds-radius-large, 8px);background-color:var(--ds-surface-overlay, #FFFFFF);overflow:hidden;margin-top:", (0, $k1WWO.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $k1WWO.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");
const $2510ad882872a9ae$export$d6e44c2a92a613c2 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "ee3sr7s7"
})({
    name: "s8tasg",
    styles: "flex:1;display:flex;flex-direction:column;overflow:hidden;max-width:100%;box-sizing:border-box"
});
const $2510ad882872a9ae$export$ab35601bed9ca017 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "ee3sr7s6"
})({
    name: "n94oxe",
    styles: "overflow-x:hidden;overflow-y:auto;flex:1;max-width:100%;box-sizing:border-box"
});
const $2510ad882872a9ae$export$34a31057caff1acb = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "ee3sr7s5"
})({
    flex: '1 1 auto',
    overflowX: 'hidden',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`
});
const $2510ad882872a9ae$export$6b8430dd9f61a5c7 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "ee3sr7s4"
})("flex:0 1 auto;width:", $2510ad882872a9ae$var$SIDEBAR_PANE_WIDTH, "px;display:flex;flex-direction:column;max-height:100%;padding-bottom:var(--ds-space-200, 16px);@media screen and (max-width: ", (0, $k1WWO.dialogPageTakeoverWidth), "px){display:none;}");
const $2510ad882872a9ae$export$33eeaf745b96a17f = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "ee3sr7s3"
})({
    margin: `${"var(--ds-space-200, 16px)"} 0`,
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $2510ad882872a9ae$export$dc065bf90da5c17d = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "ee3sr7s2"
})({
    padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`,
    flex: '0 0 auto'
});
const $2510ad882872a9ae$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)($2510ad882872a9ae$export$33eeaf745b96a17f, {}),
            /*#__PURE__*/ (0, $gWgPx.jsx)($2510ad882872a9ae$export$6b8430dd9f61a5c7, {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)($2510ad882872a9ae$export$34a31057caff1acb, {
                    children: children
                })
            })
        ]
    });
const $2510ad882872a9ae$var$totalDialogHeightPx = 776 + $2510ad882872a9ae$var$resultContainerVerticalPadding * 2;
const $2510ad882872a9ae$var$footerHeight = 48;
const $2510ad882872a9ae$var$belowDialogSpace = 224;
const $2510ad882872a9ae$var$aiFullDialogPromptHeight = 64;
const $2510ad882872a9ae$export$c9e0e8491f083dd5 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "ee3sr7s1"
})("display:flex;max-height:", (props)=>`calc(100vh - ${$2510ad882872a9ae$var$belowDialogSpace - $2510ad882872a9ae$var$footerHeight + (props.showAtlassianHomeSearchLink ? $2510ad882872a9ae$var$footerHeight : 0) + (props.aiSearchFullDialogEnabled ? $2510ad882872a9ae$var$aiFullDialogPromptHeight : 0)}px)`, ";box-sizing:border-box;flex:1;min-height:", (props)=>props.minHeight ? `${props.minHeight}px` : 'auto', ";@media screen and (min-height: ", $2510ad882872a9ae$var$totalDialogHeightPx + $2510ad882872a9ae$var$belowDialogSpace, "px){max-height:", (props)=>`${$2510ad882872a9ae$var$totalDialogHeightPx - $2510ad882872a9ae$var$footerHeight - (props.aiSearchFullDialogEnabled ? $2510ad882872a9ae$var$aiFullDialogPromptHeight : 0)}px;`, ";}@media screen and (max-width: ", (0, $k1WWO.dialogPageTakeoverWidth), "px){max-height:initial;overflow:auto;}");
const $2510ad882872a9ae$export$8644783c0dd52b5e = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "ee3sr7s0"
})("position:relative;display:flex;flex-direction:column;justify-content:space-between;min-height:", (props)=>props.shouldFixMinimumHeight ? `${props.minimumHeight}px` : 'auto', ";@media screen and (max-width: ", (0, $k1WWO.dialogPageTakeoverWidth), "px){flex-grow:1;}");

});
parcelRegister("k1WWO", function(module, exports) {
$parcel$export(module.exports, "grid", () => $fde205563cef3cd6$export$85fc379452d91af0);
$parcel$export(module.exports, "dialogWidth", () => $fde205563cef3cd6$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $fde205563cef3cd6$export$ce4512df260a325a);
$parcel$export(module.exports, "primaryTextColour", () => $fde205563cef3cd6$export$eeb0307e2964e28d);
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $fde205563cef3cd6$export$7168c0a11fb9ab29);
$parcel$export(module.exports, "itemHighlightColor", () => $fde205563cef3cd6$export$4ac85ff259fe4fce);
$parcel$export(module.exports, "visitedLinkColor", () => $fde205563cef3cd6$export$271fb8b1437b1d62);
$parcel$export(module.exports, "nowrapEllipsis", () => $fde205563cef3cd6$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2nrNX = parcelRequire("2nrNX");
function $fde205563cef3cd6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fde205563cef3cd6$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$fde205563cef3cd6$var$AkGrid(multiplier * num),
        half: ()=>$fde205563cef3cd6$var$AkGrid(0.5 * num),
        twice: ()=>$fde205563cef3cd6$var$AkGrid(2 * num)
    });
const $fde205563cef3cd6$export$56446adcecbeec34 = {
    searchDialog: (0, $2nrNX.layers).dialog()
};
const $fde205563cef3cd6$export$85fc379452d91af0 = $fde205563cef3cd6$var$AkGrid(1);
const $fde205563cef3cd6$export$b9930dabfa4a3a3 = '56px';
const $fde205563cef3cd6$export$f6af7620e8789c39 = '200px';
const $fde205563cef3cd6$export$64d8573e83b64ff8 = '150px';
const $fde205563cef3cd6$export$a3da89b899389ed8 = '780px';
const $fde205563cef3cd6$export$ce4512df260a325a = 780;
const $fde205563cef3cd6$export$a406031ed42c8e02 = '1130px';
const $fde205563cef3cd6$export$e00021bea368c518 = $fde205563cef3cd6$export$85fc379452d91af0.multiple(4);
const $fde205563cef3cd6$export$30310ee354b45eb0 = $fde205563cef3cd6$export$85fc379452d91af0.multiple(6);
const $fde205563cef3cd6$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";
const $fde205563cef3cd6$export$7168c0a11fb9ab29 = "var(--ds-text-subtlest, #6B6E76)";
const $fde205563cef3cd6$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";
const $fde205563cef3cd6$export$271fb8b1437b1d62 = "var(--ds-link-visited, #803FA5)";
const $fde205563cef3cd6$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});

parcelRegister("ndUiP", function(module, exports) {
$parcel$export(module.exports, "default", () => $045cefc24b0a3996$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");
parcelRequire("8Z0o8");
var $cZiJt = parcelRequire("cZiJt");

var $jcYcQ = parcelRequire("jcYcQ");

var $fNqBd = parcelRequire("fNqBd");

var $aQXFp = parcelRequire("aQXFp");

var $8P7DW = parcelRequire("8P7DW");

var $9mZvX = parcelRequire("9mZvX");
var $045cefc24b0a3996$var$isDevelopment = false;
var $045cefc24b0a3996$var$testOmitPropsOnStringTag = (0, $9mZvX.default);
var $045cefc24b0a3996$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $045cefc24b0a3996$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $045cefc24b0a3996$var$testOmitPropsOnStringTag : $045cefc24b0a3996$var$testOmitPropsOnComponent;
};
var $045cefc24b0a3996$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $045cefc24b0a3996$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $aQXFp.registerStyles)(cache, serialized, isStringTag);
    (0, $fNqBd.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $aQXFp.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $045cefc24b0a3996$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $045cefc24b0a3996$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $045cefc24b0a3996$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $cZiJt.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8P7DW.useContext((0, $cZiJt.T));
            }
            if (typeof props.className === 'string') className = (0, $aQXFp.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $jcYcQ.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $045cefc24b0a3996$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement($045cefc24b0a3996$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $8P7DW.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $045cefc24b0a3996$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $cCnFQ.default)({}, options, nextOptions, {
                shouldForwardProp: $045cefc24b0a3996$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("fNqBd", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $b80010ad74492595$export$db21c7ffa21794e7);

var $8P7DW = parcelRequire("8P7DW");
var $b80010ad74492595$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b80010ad74492595$var$useInsertionEffect = $8P7DW.useInsertionEffect ? $8P7DW.useInsertionEffect : false;
var $b80010ad74492595$export$db21c7ffa21794e7 = $b80010ad74492595$var$useInsertionEffect || $b80010ad74492595$var$syncFallback;
var $b80010ad74492595$export$811a713a7276cb9d = $b80010ad74492595$var$useInsertionEffect || $8P7DW.useLayoutEffect;

});

parcelRegister("9mZvX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d25e2a126d30afa$export$2e2bcd8739ae039);

var $3t5HD = parcelRequire("3t5HD");
// eslint-disable-next-line no-undef
var $6d25e2a126d30afa$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $6d25e2a126d30afa$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $3t5HD.default)(function(prop) {
    return $6d25e2a126d30afa$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});




parcelRegister("cxiV4", function(module, exports) {
$parcel$export(module.exports, "ResolvedAndErrorContent", () => $f791a4fdd131453d$export$5d6737b8e2fd8b38);

var $gWgPx = parcelRequire("gWgPx");

var $kPDrU = parcelRequire("kPDrU");

var $8P7DW = parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");
var $k7INq = parcelRequire("k7INq");

var $h3cOB = parcelRequire("h3cOB");

var $eCciJ = parcelRequire("eCciJ");

var $f1STa = parcelRequire("f1STa");

var $1oLfT = parcelRequire("1oLfT");

var $bNUe6 = parcelRequire("bNUe6");

var $iw8Zd = parcelRequire("iw8Zd");

var $emfkf = parcelRequire("emfkf");

var $kg4l4 = parcelRequire("kg4l4");

var $52UCQ = parcelRequire("52UCQ");

var $cNM6k = parcelRequire("cNM6k");
const $f791a4fdd131453d$export$5d6737b8e2fd8b38 = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    /* eslint-disable @atlassian/relay/unused-fields */ const searchResponse = (0, $h3cOB.useLazyLoadQuery)((0, $kPDrU.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        input: {
            query: queryWord,
            contentTypes: [
                'FOLDER',
                'PAGE'
            ]
        },
        first: 10
    });
    /* eslint-enable @atlassian/relay/unused-fields */ const { articlesAndFolders: articlesAndFolders, hasQueryError: hasQueryError } = (0, $emfkf.useArticleSearch)(searchResponse, queryWord);
    const showEmptyState = articlesAndFolders && articlesAndFolders.length === 0;
    const showResolvedState = articlesAndFolders && articlesAndFolders.length > 0;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
        children: [
            (showEmptyState || hasQueryError) && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1oLfT.EmptyState), {
                title: hasQueryError ? formatMessage((0, $cNM6k.messages).errorTitle) : formatMessage((0, $cNM6k.messages).emptyStateTitle),
                Image: (0, $52UCQ.SearchErrorImage),
                content: hasQueryError ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                    ...(0, $cNM6k.messages).errorDescription
                }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                    ...(0, $cNM6k.messages).emptyStateDescription
                })
            }),
            showResolvedState && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bNUe6.SearchDialogContent), {
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bNUe6.ResultContainer), {
                        children: articlesAndFolders.map((result)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $iw8Zd.SearchResult), {
                                href: result.url,
                                title: result.title,
                                isCollapsed: true,
                                icon: result.type === (0, $kg4l4.ContentType).PAGE ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f1STa))), {
                                    label: ""
                                }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eCciJ))), {
                                    label: ""
                                })
                            }, result.id))
                    })
                })
            })
        ]
    });
};

});
parcelRegister("kPDrU", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f28172b9e6eadf2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7b64017091c825d7a9ab09bd0a8ae17>>
 * @relayHash d3adfd96cf5547776151651b69eb76b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a
const $8f28172b9e6eadf2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v6 = {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "contentType"
            },
            {
                "concreteType": "HelpObjectStoreArticleURLInfo",
                "kind": "LinkedField",
                "name": "urlInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "shareUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreSupportSiteArticleSearchResult"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v12 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "resolvedAndErrorContentQuery",
            "selections": [
                {
                    "alias": "helpObjectStore_searchArticlesForSupportSite",
                    "args": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ],
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "__ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite_connection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "resolvedAndErrorContentQuery",
            "selections": [
                {
                    "args": v12 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "args": v12 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "helpCenterAri",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "helpObjectStore_searchArticlesForSupportSite"
                        ]
                    }
                ]
            },
            "name": "resolvedAndErrorContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8f28172b9e6eadf2$var$node.hash = "8f52dcfd8c2f8d8ee3e0ac349b7693a1";
var $8f28172b9e6eadf2$export$2e2bcd8739ae039 = $8f28172b9e6eadf2$var$node;

});

parcelRegister("eCciJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::329ffe53264930b81eb140b6c3cd31f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa3e2812284ba46a$var$_react = $aa3e2812284ba46a$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $aa3e2812284ba46a$var$_baseNew = $aa3e2812284ba46a$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $aa3e2812284ba46a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa3e2812284ba46a$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $aa3e2812284ba46a$var$_react.default.createElement($aa3e2812284ba46a$var$_baseNew.default, Object.assign({
        name: "FolderClosedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$aa3e2812284ba46a$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $aa3e2812284ba46a$var$_default = module.exports.default = $aa3e2812284ba46a$var$FolderClosedIcon;

});

parcelRegister("1oLfT", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $b1b1ce6fc69889a1$export$fddf379e22a74b00);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $krvj0 = parcelRequire("krvj0");
const $b1b1ce6fc69889a1$export$fddf379e22a74b00 = ({ title: title, content: content, Image: Image })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $krvj0.Wrapper), {
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)(Image, {}),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $krvj0.Title), {
                    children: title
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $krvj0.Content), {
                    children: content
                })
            ]
        })
    });

});
parcelRegister("krvj0", function(module, exports) {
$parcel$export(module.exports, "Title", () => $62e0e88a8b86f6a1$export$f99233281efd08a0);
$parcel$export(module.exports, "Content", () => $62e0e88a8b86f6a1$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Wrapper", () => $62e0e88a8b86f6a1$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $gWgPx = parcelRequire("gWgPx");

var $k1WWO = parcelRequire("k1WWO");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");
parcelRequire("8P7DW");

var $ndUiP = parcelRequire("ndUiP");
const $62e0e88a8b86f6a1$var$TitleContainerStyles = (0, $37U6z.xcss)({
    position: 'relative',
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginTop: 'space.100'
});
const $62e0e88a8b86f6a1$export$f99233281efd08a0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Hfjm.default), {
        xcss: $62e0e88a8b86f6a1$var$TitleContainerStyles,
        children: children
    });
};
const $62e0e88a8b86f6a1$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e1ttkipm1"
})({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: (0, $k1WWO.grid).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $k1WWO.primaryTextColour)
});
const $62e0e88a8b86f6a1$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e1ttkipm0"
})({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $k1WWO.grid).twice().px
});

});


parcelRegister("iw8Zd", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $dd78fa2c0e9e836d$export$a2def421b23768aa);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $b5tCg = parcelRequire("b5tCg");

var $epJ2v = parcelRequire("epJ2v");

var $d5yrx = parcelRequire("d5yrx");
const $dd78fa2c0e9e836d$export$a2def421b23768aa = (props)=>{
    const ResultContentComponent = props.isQuickFind ? (0, $d5yrx.EnlargedSearchResultContent) : (0, $b5tCg.SearchResultContent);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $epJ2v.SearchResultLink), {
        ...props,
        children: (isKeyboardHighlighted)=>/*#__PURE__*/ (0, $gWgPx.jsx)(ResultContentComponent, {
                ...props,
                isKeyboardHighlighted: isKeyboardHighlighted
            })
    });
};

});
parcelRegister("b5tCg", function(module, exports) {
$parcel$export(module.exports, "SearchResultContent", () => $fbaf11d5c03e9347$export$b5fd7d6305bfbd3e);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $ePiFH = parcelRequire("ePiFH");

var $gar8O = parcelRequire("gar8O");
const $fbaf11d5c03e9347$export$595b9d59c3d65270 = '@@@hl@@@';
const $fbaf11d5c03e9347$export$eea8f6b95460c3c3 = '@@@endhl@@@';
const $fbaf11d5c03e9347$var$getResultLabel = (label)=>{
    if (typeof label === 'string') return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.ResultLabel), {
        title: typeof label === 'string' ? label : undefined,
        children: label
    });
    return label;
};
const $fbaf11d5c03e9347$var$getResultTitle = (title)=>{
    if (typeof title === 'string') return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
            title: title,
            className: "SearchDialogResultTitle",
            children: title
        })
    });
    return title;
};
const $fbaf11d5c03e9347$export$b5fd7d6305bfbd3e = ({ icon: icon, label: label, title: title, meta: meta, additionalMeta: additionalMeta, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    const getResultContent = ()=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
            children: isCollapsed ? /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gar8O.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gar8O.ResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            $fbaf11d5c03e9347$var$getResultLabel(label),
                            $fbaf11d5c03e9347$var$getResultTitle(title)
                        ]
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gar8O.CollapsedResultDetailWrapper), {
                        children: [
                            meta && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.CollapsedResultDetail), {
                                title: typeof meta === 'string' ? meta : undefined,
                                children: meta
                            }),
                            additionalMeta && /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.DetailsSeparator), {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.CollapsedResultDetail), {
                                        children: additionalMeta
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gar8O.ResultTitleContainer), {
                        children: [
                            $fbaf11d5c03e9347$var$getResultLabel(label),
                            $fbaf11d5c03e9347$var$getResultTitle(title)
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.ResultDetail), {
                        title: typeof meta === 'string' ? meta : undefined,
                        children: meta
                    }),
                    additionalMeta ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.ResultDetail), {
                        title: typeof additionalMeta === 'string' ? additionalMeta : undefined,
                        children: additionalMeta
                    }) : null
                ]
            })
        });
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(null);
    (0, $8P7DW.useEffect)(()=>{
        var _contentRef$current;
        if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gar8O.ResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.IconContainer), {
                children: icon
            }),
            getResultContent(),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.ReturnIconContainer), {
                isCollapsed: isCollapsed,
                isKeyboardHighlighted: isKeyboardHighlighted,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ePiFH.ReturnIcon), {
                    inverted: true
                })
            })
        ]
    });
};

});
parcelRegister("ePiFH", function(module, exports) {
$parcel$export(module.exports, "ReturnIcon", () => $7f8f2711c9f269e9$export$d6c38c54dfb7c9d5);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $7f8f2711c9f269e9$export$d6c38c54dfb7c9d5 = ({ inverted: inverted = false })=>/*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)("rect", {
                    width: "24",
                    height: "16",
                    fill: inverted ? "var(--ds-background-neutral-bold, #292A2E)" : "var(--ds-background-neutral, #0515240F)",
                    rx: "3"
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                    fill: inverted ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)",
                    fillRule: "nonzero",
                    d: "M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
                })
            ]
        })
    });

});

parcelRegister("gar8O", function(module, exports) {
$parcel$export(module.exports, "ResultLink", () => $aa8495a013e36f1c$export$d0a8235d2583609);
$parcel$export(module.exports, "ResultContentWrapper", () => $aa8495a013e36f1c$export$87a308048e18f5d7);
$parcel$export(module.exports, "EnlargedResultContentWrapper", () => $aa8495a013e36f1c$export$e10965f6350456f8);
$parcel$export(module.exports, "ReturnIconContainer", () => $aa8495a013e36f1c$export$b7244afbfdf4cb9a);
$parcel$export(module.exports, "EnlargedReturnIconContainer", () => $aa8495a013e36f1c$export$cc248e72bc9d7b85);
$parcel$export(module.exports, "IconContainer", () => $aa8495a013e36f1c$export$8f314e512d92575f);
$parcel$export(module.exports, "EnlargedIconContainer", () => $aa8495a013e36f1c$export$ca5c00fa71c2e27e);
$parcel$export(module.exports, "ResultTitleContainer", () => $aa8495a013e36f1c$export$9c613d6c52df949a);
$parcel$export(module.exports, "EnlargedResultTitleContainer", () => $aa8495a013e36f1c$export$e97ece467686c93c);
$parcel$export(module.exports, "ResultLabel", () => $aa8495a013e36f1c$export$a999164f6ebc756c);
$parcel$export(module.exports, "ResultDetail", () => $aa8495a013e36f1c$export$b695f824f00c1cb0);
$parcel$export(module.exports, "CollapsedResultDetail", () => $aa8495a013e36f1c$export$addf7aa0f753bbe8);
$parcel$export(module.exports, "EnlargedCollapsedResultDetail", () => $aa8495a013e36f1c$export$a44951d703db9a17);
$parcel$export(module.exports, "EnlargedResultDetail", () => $aa8495a013e36f1c$export$c8ec38cc79b76eaa);
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $aa8495a013e36f1c$export$43a2b5c94cb85d9c);
$parcel$export(module.exports, "EnlargedCollapsedResultDetailWrapper", () => $aa8495a013e36f1c$export$2dfb537c5a7f8cc3);
$parcel$export(module.exports, "DetailsSeparator", () => $aa8495a013e36f1c$export$35507434feaa4496);
$parcel$export(module.exports, "CollapsedResultContentWrapper", () => $aa8495a013e36f1c$export$ee32d1086c278cfc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $k1WWO = parcelRequire("k1WWO");

var $gWqTa = parcelRequire("gWqTa");

var $ndUiP = parcelRequire("ndUiP");
function $aa8495a013e36f1c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa8495a013e36f1c$export$d0a8235d2583609 = /*#__PURE__*/ (0, $ndUiP.default)((0, $gWqTa.Link), {
    target: "e8crcwv22"
})({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $k1WWO.primaryTextColour),
    '&:hover': {
        textDecoration: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $k1WWO.primaryTextColour)
    },
    '&:focus': {
        outlineOffset: '-2px'
    },
    '&:visited': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $k1WWO.primaryTextColour),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.SearchDialogResultTitle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: (0, $k1WWO.visitedLinkColor)
        }
    }
});
const $aa8495a013e36f1c$export$87a308048e18f5d7 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv21"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $k1WWO.grid).multiple(props.isCollapsed ? 5 : 4).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $k1WWO.grid).twice().px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $k1WWO.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $k1WWO.itemHighlightColor)
        }
    }));
const $aa8495a013e36f1c$export$e10965f6350456f8 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv20"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-radius-medium, 6px)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $k1WWO.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $k1WWO.itemHighlightColor)
        }
    }));
const $aa8495a013e36f1c$export$b7244afbfdf4cb9a = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv19"
})((props)=>({
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: (0, $k1WWO.grid).half().px,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $k1WWO.grid).multiple(3).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $k1WWO.grid).twice().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: (0, $k1WWO.grid).multiple(1.5).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: props.isCollapsed ? (0, $k1WWO.grid).px : (0, $k1WWO.grid).half().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isKeyboardHighlighted ? 1 : 0
    }));
const $aa8495a013e36f1c$export$cc248e72bc9d7b85 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv18"
})({
    name: "qrg2ys",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px)"
});
const $aa8495a013e36f1c$export$d84276b3ae03593f = /*#__PURE__*/ (0, $ndUiP.default)($aa8495a013e36f1c$export$b7244afbfdf4cb9a, {
    target: "e8crcwv17"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $k1WWO.grid).multiple(2.5).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $k1WWO.grid).multiple(2.5).px,
    opacity: 1
});
const $aa8495a013e36f1c$export$8f314e512d92575f = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv16"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $k1WWO.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $k1WWO.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flex: `0 0 ${(0, $k1WWO.grid).twice().px}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $k1WWO.grid).twice().px,
    display: 'flex',
    alignItems: 'center'
});
const $aa8495a013e36f1c$export$ca5c00fa71c2e27e = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv15"
})({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: "var(--ds-space-100, 8px)",
    flex: `0 0 ${"var(--ds-space-300, 24px)"}`,
    display: 'flex',
    alignItems: 'center'
});
const $aa8495a013e36f1c$export$9c613d6c52df949a = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv14"
})((0, $k1WWO.nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, $k1WWO.grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, $k1WWO.primaryTextColour), ";@media screen and (max-width: ", (0, $k1WWO.dialogPageTakeoverWidth), "px){width:100%;}");
const $aa8495a013e36f1c$export$e97ece467686c93c = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv13"
})((0, $k1WWO.nowrapEllipsis), " line-height:14px;flex:1 0 auto;color:", (0, $k1WWO.primaryTextColour), ";height:16px;@media screen and (max-width: ", (0, $k1WWO.dialogPageTakeoverWidth), "px){width:100%;}width:90%;");
const $aa8495a013e36f1c$export$a999164f6ebc756c = /*#__PURE__*/ (0, $ndUiP.default)("span", {
    target: "e8crcwv12"
})((0, $k1WWO.nowrapEllipsis), {
    color: "var(--ds-text-subtle, #505258)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $k1WWO.grid).px
});
const $aa8495a013e36f1c$export$b695f824f00c1cb0 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv11"
})((0, $k1WWO.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $k1WWO.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $k1WWO.grid).multiple(3).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $k1WWO.grid).multiple(19).px
});
const $aa8495a013e36f1c$export$addf7aa0f753bbe8 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv10"
})((0, $k1WWO.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $k1WWO.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $aa8495a013e36f1c$export$a44951d703db9a17 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv9"
})((0, $k1WWO.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $k1WWO.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $aa8495a013e36f1c$export$c571ffd341b1e6fe = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv8"
})({
    name: "boxk0o",
    styles: "max-width:100%;width:256px;height:14px;margin-bottom:var(--ds-space-025, 2px);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-skeleton, #0515240F)"
});
const $aa8495a013e36f1c$export$c8ec38cc79b76eaa = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv7"
})((0, $k1WWO.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $k1WWO.itemLinkSecondaryColor),
    maxWidth: "'initial'",
    minWidth: 'fit-content',
    marginLeft: "var(--ds-space-150, 12px)"
});
const $aa8495a013e36f1c$export$a15ed502bc39849a = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv6"
})({
    name: "c4lg89",
    styles: "max-width:100%;width:100px;height:12px;border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-skeleton, #0515240F)"
});
const $aa8495a013e36f1c$export$43a2b5c94cb85d9c = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv5"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $k1WWO.grid).multiple(54).px
});
const $aa8495a013e36f1c$export$2dfb537c5a7f8cc3 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv4"
})({
    name: "uy5e1i",
    styles: "display:flex;width:90%"
});
const $aa8495a013e36f1c$export$35507434feaa4496 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv3"
})({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $k1WWO.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $k1WWO.grid).px}`
});
const $aa8495a013e36f1c$export$ee32d1086c278cfc = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv2"
})({
    name: "1ls843y",
    styles: "display:block;min-width:0;flex-grow:1"
});
const $aa8495a013e36f1c$export$2cacbb382e8a2ce4 = /*#__PURE__*/ (0, $ndUiP.default)("button", {
    target: "e8crcwv1"
})({
    name: "ykaoo6",
    styles: "background-color:transparent;border:none;cursor:pointer;padding:0;width:100%;text-align:left"
});
const $aa8495a013e36f1c$export$3c77a9b2eee1dfc5 = /*#__PURE__*/ (0, $ndUiP.default)("div", {
    target: "e8crcwv0"
})({
    name: "2n36v1",
    styles: "width:100%;height:100%;border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-skeleton, #0515240F)"
});

});
parcelRegister("gWqTa", function(module, exports) {
$parcel$export(module.exports, "Link", () => $520e32875531ec0a$export$a6c7ac8248d6e38a);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $520e32875531ec0a$export$a6c7ac8248d6e38a = ({ linkComponent: linkComponent, ...props })=>{
    // Hack?
    const Component = linkComponent || 'a';
    return /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        ...props
    });
};

});



parcelRegister("epJ2v", function(module, exports) {
$parcel$export(module.exports, "SearchResultLink", () => $0468d1a0c9b1d20a$export$76cc11d043a1381);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $gar8O = parcelRequire("gar8O");

var $gPpID = parcelRequire("gPpID");
const $0468d1a0c9b1d20a$export$76cc11d043a1381 = ({ children: children, href: href, linkComponent: linkComponent, searchResultId: searchResultId, onSelect: onSelect, onHighlighted: onHighlighted, onContextMenu: onContextMenu, ...rest })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $gPpID.useKeyboardHighlighting)({
        searchResultId: searchResultId,
        onHighlighted: onHighlighted
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ref: ref,
        onClick: onSelect,
        onContextMenu: onContextMenu,
        role: "none",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.ResultLink), {
            linkComponent: linkComponent,
            href: href,
            ...rest,
            children: children(isKeyboardHighlighted)
        })
    }));
};

});
parcelRegister("gPpID", function(module, exports) {
$parcel$export(module.exports, "useKeyboardHighlighting", () => $5d31fd580dff8e86$export$9803d460130e453);

var $8P7DW = parcelRequire("8P7DW");

var $fe6Ty = parcelRequire("fe6Ty");
/**
 * Callback which simulates a click on the target element when the enter key
 * is pressed whilst the target element is active.
 *
 * @param e Event from key down
 * @param target Active element when key was pressed
 */ const $5d31fd580dff8e86$var$onKeyDown = (e, target)=>{
    // Only navigate if Enter was pressed without any modifiers
    if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        // Find the deepest child element in the DOM
        let clickTarget = target;
        while(clickTarget.firstElementChild instanceof HTMLElement && (_clickTarget$firstEle = clickTarget.firstElementChild) !== null && _clickTarget$firstEle !== void 0 && _clickTarget$firstEle.click){
            var _clickTarget$firstEle;
            clickTarget = clickTarget.firstElementChild;
        }
        clickTarget.click();
    }
};
const $5d31fd580dff8e86$export$9803d460130e453 = ({ searchResultId: searchResultId, onHighlighted: onHighlighted })=>{
    const [isKeyboardHighlighted, ref] = (0, $fe6Ty.useKeyboardNavigation)({
        onKeydownCallback: $5d31fd580dff8e86$var$onKeyDown,
        navigationTrackingId: searchResultId ?? null
    });
    // Ref for whether or not this search result was last highlighted
    const previousHighlight = (0, $8P7DW.useRef)(false);
    // Call the onHighlighted callback when this search result is highlighted
    (0, $8P7DW.useEffect)(()=>{
        if (!previousHighlight.current && isKeyboardHighlighted) onHighlighted === null || onHighlighted === void 0 || onHighlighted();
        previousHighlight.current = isKeyboardHighlighted;
    }, [
        isKeyboardHighlighted,
        previousHighlight,
        onHighlighted
    ]);
    return {
        isKeyboardHighlighted: isKeyboardHighlighted,
        ref: ref
    };
};

});


parcelRegister("d5yrx", function(module, exports) {
$parcel$export(module.exports, "EnlargedSearchResultContent", () => $78c555131ee79ade$export$171a2a7e5a778acc);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $eXiRA = parcelRequire("eXiRA");

var $31Z3u = parcelRequire("31Z3u");

var $9b2up = parcelRequire("9b2up");

var $fiikg = parcelRequire("fiikg");

var $afePj = parcelRequire("afePj");

var $lRscM = parcelRequire("lRscM");

var $gar8O = parcelRequire("gar8O");
const $78c555131ee79ade$export$171a2a7e5a778acc = ({ icon: icon, label: label, title: title, highlightedTitle: highlightedTitle, meta: meta, additionalMeta: additionalMeta, displayAdditionalMetaWhenHighlightedOnly: displayAdditionalMetaWhenHighlightedOnly, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, returnIcon: returnIcon = 'onHighlight', isRecentSearch: isRecentSearch, onRemove: onRemove })=>{
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useRef(null);
    const [isHover, setIsHover] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const isActive = isKeyboardHighlighted || isHover;
    const showReturnIcon = (0, $8P7DW.useMemo)(()=>(returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch, [
        isKeyboardHighlighted,
        returnIcon,
        isRecentSearch
    ]);
    const showRemoveIcon = (0, $8P7DW.useMemo)(()=>isRecentSearch && isActive, [
        isRecentSearch,
        isActive
    ]);
    const showAdditionalMeta = (0, $8P7DW.useMemo)(()=>additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive), [
        displayAdditionalMetaWhenHighlightedOnly,
        isActive,
        additionalMeta
    ]);
    (0, $8P7DW.useEffect)(()=>{
        var _contentRef$current;
        if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gar8O.EnlargedResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.EnlargedIconContainer), {
                children: icon
            }),
            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gar8O.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gar8O.EnlargedResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            typeof title === 'string' ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                                    title: title,
                                    className: "SearchDialogResultTitle",
                                    children: highlightedTitle ? (0, $afePj.enrichResultTitle)(highlightedTitle) : title
                                })
                            }) : title,
                            typeof label === 'string' ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.ResultLabel), {
                                title: label,
                                children: label
                            }) : label
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.EnlargedCollapsedResultDetailWrapper), {
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.EnlargedCollapsedResultDetail), {
                            children: meta
                        })
                    })
                ]
            }),
            showAdditionalMeta && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.EnlargedResultDetail), {
                children: additionalMeta
            }),
            showReturnIcon && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $31Z3u.SquareReturnIcon), {})
            }),
            showRemoveIcon && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gar8O.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lRscM.default), {
                    icon: (0, $eXiRA.RemoveIcon),
                    spacing: 'compact',
                    onClick: onRemove,
                    label: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                        ...(0, $9b2up.messages).remove_button_label
                    }),
                    appearance: 'subtle'
                })
            })
        ]
    });
};

});
parcelRegister("eXiRA", function(module, exports) {
$parcel$export(module.exports, "RemoveIcon", () => $45c1c8a870068956$export$6382847193091a26);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $45c1c8a870068956$export$6382847193091a26 = ()=>/*#__PURE__*/ (0, $gWgPx.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.185 7.4 12 10.585 8.815 7.399a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.7-.7a.496.496 0 0 0 .004-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.507.507 0 0 0-.36-.153.5.5 0 0 0-.353.15h-.001Z",
            fill: "var(--ds-icon, #292A2E)"
        })
    });

});

parcelRegister("31Z3u", function(module, exports) {
$parcel$export(module.exports, "SquareReturnIcon", () => $cffd4cf054b37ca4$export$4501fc029b186da8);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $cffd4cf054b37ca4$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $gWgPx.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: "var(--ds-background-neutral, #0515240F)"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: "var(--ds-icon-subtle, #505258)"
            })
        ]
    });

});

parcelRegister("9b2up", function(module, exports) {
$parcel$export(module.exports, "messages", () => $bd2414421263f81d$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $bd2414421263f81d$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    remove_button_label: {
        id: 'search_dialog.results.remove_button_label',
        defaultMessage: 'Remove this.',
        description: 'Label of the button that has remove function and appearance.'
    }
});

});

parcelRegister("afePj", function(module, exports) {
$parcel$export(module.exports, "enrichResultTitle", () => $704d2d7e8ebea05c$export$c43ff622b37ceaa9);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $2CGHX = parcelRequire("2CGHX");
const $704d2d7e8ebea05c$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $704d2d7e8ebea05c$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $704d2d7e8ebea05c$var$highlightRE = new RegExp(`${$704d2d7e8ebea05c$var$HIGHLIGHT_START_TAG}(.*?)${$704d2d7e8ebea05c$var$HIGHLIGHT_END_TAG}.*`);
const $704d2d7e8ebea05c$var$openingTagRE = new RegExp(`(.*?)${$704d2d7e8ebea05c$var$HIGHLIGHT_START_TAG}`);
const $704d2d7e8ebea05c$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($704d2d7e8ebea05c$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        as: "span",
        children: title
    }, title + counter);
    while(title){
        const [preMatch, preText] = title.match($704d2d7e8ebea05c$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
            as: "span",
            children: preText
        }, preText + counter));
        const [boldMatch, highlightText] = title.match($704d2d7e8ebea05c$var$highlightRE) || [];
        title = title.replace(`${$704d2d7e8ebea05c$var$HIGHLIGHT_START_TAG}${highlightText}${$704d2d7e8ebea05c$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
            as: "strong",
            children: highlightText
        }, highlightText + counter));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                as: "span",
                children: title
            }, title + counter));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};

});



parcelRegister("emfkf", function(module, exports) {
$parcel$export(module.exports, "useArticleSearch", () => $045e4e0582fb07ca$export$f4258d6b7c4900b8);

var $8P7DW = parcelRequire("8P7DW");
const $045e4e0582fb07ca$var$MIN_INPUT_CHAR_LENGTH = 1;
const $045e4e0582fb07ca$export$f4258d6b7c4900b8 = (searchResponse, queryWord)=>{
    var _searchResponse$helpO3;
    const entities = (0, $8P7DW.useMemo)(()=>{
        var _searchResponse$helpO;
        return (searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO === void 0 ? void 0 : _searchResponse$helpO.edges) || [];
    }, [
        searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.helpObjectStore_searchArticlesForSupportSite
    ]);
    const hasQueryError = Boolean(entities.find((edge)=>{
        var _edge$node;
        return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.message;
    }));
    const articlesAndFolders = (0, $8P7DW.useMemo)(()=>{
        var _searchResponse$helpO2;
        const edges = (_searchResponse$helpO2 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO2 === void 0 ? void 0 : _searchResponse$helpO2.edges;
        if (edges) {
            const resultItems = edges.map(({ node: node })=>{
                const { id: id, title: title, contentType: contentType, urlInfo: urlInfo } = node;
                if (id && title && contentType && urlInfo !== null && urlInfo !== void 0 && urlInfo.shareUrl) return {
                    id: id,
                    title: title,
                    type: contentType.toString(),
                    url: urlInfo.shareUrl
                };
                return null;
            }).filter((item)=>item !== null);
            return resultItems;
        }
        return undefined;
    }, [
        (_searchResponse$helpO3 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO3 === void 0 ? void 0 : _searchResponse$helpO3.edges
    ]);
    if (queryWord.length < $045e4e0582fb07ca$var$MIN_INPUT_CHAR_LENGTH) return {
        articlesAndFolders: undefined,
        hasQueryError: false
    };
    return {
        articlesAndFolders: articlesAndFolders,
        hasQueryError: hasQueryError
    };
};

});

parcelRegister("kg4l4", function(module, exports) {
$parcel$export(module.exports, "ContentType", () => $9e1659cb3f4e41b0$export$e2e108cbe2e4f865);
var $9e1659cb3f4e41b0$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "PAGE";
    ContentType["FOLDER"] = "FOLDER";
    return ContentType;
}({});

});

parcelRegister("52UCQ", function(module, exports) {
$parcel$export(module.exports, "SearchErrorImage", () => $966f243a45f90ea5$export$d689645a972509c2);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
const $966f243a45f90ea5$export$d689645a972509c2 = ()=>/*#__PURE__*/ (0, $gWgPx.jsxs)("svg", {
        width: "61",
        height: "82",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                fill: "var(--ds-surface, #FFFFFF)",
                fillOpacity: ".01",
                d: "M0 0h61v82H0z"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                d: "M42.676 60.465 39.8 57.71l-3.867 3.956 2.874 2.755a5.347 5.347 0 0 1 1.492 2.58 5.348 5.348 0 0 0 1.492 2.582l11.66 11.176a4.484 4.484 0 0 0 6.294-.102 4.377 4.377 0 0 0-.102-6.232l-11.66-11.176a5.412 5.412 0 0 0-2.654-1.394 5.377 5.377 0 0 1-2.654-1.39z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                d: "M45.213 61.83a5.409 5.409 0 0 1-2.537-1.365l-.876-.839a2.804 2.804 0 0 0-3.934.062 2.737 2.737 0 0 0 .062 3.895l.876.838a5.334 5.334 0 0 1 1.46 2.461 23.389 23.389 0 0 0 4.95-5.053z",
                fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                d: "M23.633 69.38c-6.214.097-12.095-2.204-16.56-6.483-9.218-8.832-9.456-23.441-.536-32.567 4.323-4.42 10.126-6.91 16.34-7.009 6.215-.098 12.096 2.203 16.561 6.483 4.466 4.28 6.981 10.025 7.08 16.174.1 6.149-2.225 11.975-6.548 16.396-4.322 4.417-10.126 6.907-16.337 7.005zm-.667-40.563c-4.73.076-9.148 1.97-12.44 5.336-6.794 6.947-6.61 18.072.407 24.798 3.399 3.26 7.879 5.01 12.608 4.937 4.73-.077 9.148-1.971 12.44-5.336s5.06-7.8 4.983-12.483c-.077-4.682-1.991-9.056-5.39-12.316-3.398-3.26-7.875-5.012-12.608-4.936z",
                fill: "url(#b)"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                d: "m31.78 40.93-2.384-2.317a1.04 1.04 0 0 0-1.466.015l-4.55 4.588-4.634-4.505a1.04 1.04 0 0 0-1.467.015l-2.339 2.36a1.016 1.016 0 0 0 .015 1.451l4.634 4.505-4.55 4.588a1.016 1.016 0 0 0 .015 1.452l2.383 2.316c.41.399 1.067.391 1.466-.015l4.55-4.588 4.635 4.505c.41.399 1.066.392 1.466-.015l2.34-2.36a1.016 1.016 0 0 0-.015-1.451l-4.638-4.505 4.55-4.588c.403-.403.4-1.053-.012-1.452zM26.075 10.073 22.555.156c-.08-.232-.421-.192-.45.05L20.967 9.82l-2.244-.262a.23.23 0 0 0-.246.305l3.52 9.917c.08.232.421.192.45-.051l1.137-9.612 2.244.261c.169.022.3-.145.246-.304zM14.999 16.374l-4.374-2.958c-.092-.062-.202.04-.147.134l2.405 4.185-.982.555a.1.1 0 0 0-.008.171l4.374 2.958c.092.062.202-.04.147-.134L14.01 17.1l.982-.556a.1.1 0 0 0 .008-.17z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)("path", {
                d: "M30.804 21.245a.363.363 0 0 1-.36-.443c-.09-.196-.754-.599-1.158-.842-.909-.552-1.693-1.027-1.48-1.655.212-.632 1.128-.54 2.188-.44.429.044 1.122.11 1.379.04-.165-.21-.756-.566-1.126-.79-.91-.552-1.694-1.024-1.481-1.656.213-.631 1.13-.54 2.189-.439.429.043 1.118.109 1.378.04-.165-.21-.755-.566-1.125-.791-.91-.552-1.694-1.024-1.482-1.656.213-.627 1.13-.54 2.19-.439.469.044 1.242.12 1.436.018a.367.367 0 0 1 .451-.192c.191.065.297.269.231.461-.212.628-1.129.54-2.188.436-.43-.044-1.122-.11-1.379-.04.165.21.755.566 1.126.79.909.553 1.693 1.024 1.48 1.656-.212.628-1.128.54-2.188.44-.429-.044-1.122-.11-1.379-.04.165.21.756.566 1.126.79.91.552 1.694 1.024 1.481 1.656-.212.631-1.13.54-2.189.439-.429-.044-1.122-.109-1.378-.04.165.21.755.57 1.125.791.91.552 1.694 1.028 1.482 1.656a.368.368 0 0 1-.349.25zM35.996 23.104a.361.361 0 0 1-.32-.186c-.403-.704-.857-1.502-.373-1.953.488-.45 1.265.059 2.09.6.348.228.909.595 1.158.645-.033-.246-.366-.827-.572-1.186-.487-.85-.95-1.652-.462-2.106.488-.45 1.265.058 2.09.6.374.246.994.649 1.206.649h.004a.37.37 0 0 1 .491.04.356.356 0 0 1-.018.512c-.488.453-1.265-.058-2.09-.6-.348-.228-.91-.595-1.158-.645.033.247.366.827.572 1.187.487.849.95 1.651.462 2.105-.488.45-1.265-.058-2.09-.599-.349-.229-.91-.595-1.155-.646.033.247.366.831.484 1.034a.36.36 0 0 1-.14.494.299.299 0 0 1-.18.055zM8.971 24.537c-.029 0-.055 0-.084-.003-.663-.08-.766-.999-.876-1.968-.048-.41-.121-1.074-.242-1.292-.172.185-.407.81-.55 1.198-.345.918-.675 1.782-1.33 1.702-.665-.08-.767-.998-.88-1.967-.052-.443-.136-1.18-.272-1.336a.365.365 0 0 1-.286-.4.366.366 0 0 1 .407-.315c.663.08.766.998.88 1.971.047.41.12 1.074.245 1.292.173-.185.407-.81.55-1.198.345-.914.671-1.774 1.331-1.702.664.08.766.998.88 1.971.048.41.121 1.07.242 1.292.169-.185.407-.813.491-1.034a.369.369 0 0 1 .473-.214c.191.069.286.28.217.468-.286.719-.594 1.535-1.196 1.535z",
                fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsxs)("linearGradient", {
                        id: "a",
                        x1: "45.58",
                        y1: "73.338",
                        x2: "51.997",
                        y2: "66.855",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)("stop", {
                                stopColor: "var(--ds-icon-subtle, #505258)"
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon-subtle, #505258)",
                                stopOpacity: ".5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsxs)("linearGradient", {
                        id: "b",
                        x1: "6.803",
                        y1: "62.638",
                        x2: "39.376",
                        y2: "29.737",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)("stop", {
                                offset: ".557",
                                stopColor: "var(--ds-icon-subtle, #505258)"
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsx)("stop", {
                                offset: ".966",
                                stopColor: "var(--ds-icon-subtle, #505258)",
                                stopOpacity: ".5"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});

parcelRegister("cNM6k", function(module, exports) {
$parcel$export(module.exports, "messages", () => $bfb6edc4fe6bc253$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $bfb6edc4fe6bc253$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    emptyStateTitle: {
        id: 'company-hub.article-search-component.empty-title',
        defaultMessage: "We couldn\u2019t find a match for your search",
        description: 'Text displayed in the dialog when an error occurs during the article search attempt.'
    },
    emptyStateDescription: {
        id: 'company-hub.article-search-component.empty-description',
        defaultMessage: 'Check for typos, or try another search term.',
        description: 'Text displayed in the article search dialog to guide users when there is an error.'
    },
    errorTitle: {
        id: 'company-hub.article-search-component.error-title',
        defaultMessage: "We\u2019re having trouble getting your results.",
        description: 'Text displayed in the dialog when an error occurs during the article search attempt.'
    },
    errorDescription: {
        id: 'company-hub.article-search-component.error-description',
        defaultMessage: 'Try again later',
        description: 'Text displayed in the article search dialog to guide users when there is an error.'
    }
});

});


parcelRegister("4dAbH", function(module, exports) {
$parcel$export(module.exports, "SearchSkeletons", () => $7fb86141e632fb04$export$d660f580aff4b70c);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $gdHPI = parcelRequire("gdHPI");
const $7fb86141e632fb04$export$d660f580aff4b70c = ()=>{
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gdHPI.RowSkeleton), {}),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gdHPI.RowSkeleton), {}),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gdHPI.RowSkeleton), {}),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gdHPI.RowSkeleton), {}),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gdHPI.RowSkeleton), {})
        ]
    });
};

});
parcelRegister("gdHPI", function(module, exports) {
$parcel$export(module.exports, "RowSkeleton", () => $627372cc35aaed69$export$94071f5afde0c224);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $2CGHX = parcelRequire("2CGHX");
const $627372cc35aaed69$var$styles = {
    rowWithDescription: "_2rko1mok _1bsb1ns9 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1e0c11p5 _gy1pu2gc _yv0e5bpd _1lmc1hhf _4cvr1h6o _4t3i12am",
    icon: "_nd5l2ec4 _2rkolb4i _bfhki8nm _1bsb1tcg _4t3i1tcg",
    title: "_nd5l1cy2 _2rkolb4i _bfhki8nm _1bsbgx0z _4t3idlk8",
    description: "_nd5ltgt2 _2rkolb4i _bfhki8nm _1bsb1w81 _4t3i19bv"
};
const $627372cc35aaed69$export$94071f5afde0c224 = ()=>{
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $2CGHX.default), {
        xcss: $627372cc35aaed69$var$styles.rowWithDescription,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                xcss: $627372cc35aaed69$var$styles.icon
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                xcss: $627372cc35aaed69$var$styles.title
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                xcss: $627372cc35aaed69$var$styles.description
            })
        ]
    });
};

});



parcelRegister("cUeBj", function(module, exports) {
$parcel$export(module.exports, "SearchTextField", () => $4cac09f852f6be2a$export$fb8d8fbc0c4c1705);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $k7INq = parcelRequire("k7INq");
parcelRequire("7tteh");
var $hL7ef = parcelRequire("hL7ef");
var $3dluW = parcelRequire("3dluW");

var $lRscM = parcelRequire("lRscM");

var $b9hQ0 = parcelRequire("b9hQ0");

var $kDg5W = parcelRequire("kDg5W");

var $2CGHX = parcelRequire("2CGHX");

var $gFpea = parcelRequire("gFpea");

var $P8bsr = parcelRequire("P8bsr");
const $4cac09f852f6be2a$var$cssOverrideWrapperStyles = null;
const $4cac09f852f6be2a$var$styles = {
    wrapper: "_1bsb1kdj",
    searchIcon: "_1ul91ns9 _1tke1ns9 _18u0u2gc _1e0c1txw _1bah1h6o _4cvr1h6o",
    clearIcon: "_2hwxu2gc"
};
const $4cac09f852f6be2a$export$fb8d8fbc0c4c1705 = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { isReadOnly: isReadOnly, onInput: onInput, placeholderText: placeholderText, queryWord: queryWord } = props;
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const { push: push } = (0, $3dluW.useRouterActions)();
    const [routerState] = (0, $hL7ef.useRouter)();
    const handleChange = (e)=>{
        const value = e.currentTarget.value;
        onInput(value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            const currentPath = routerState.location.pathname;
            const updatedPathIfHasMissingTrailingSlash = currentPath.endsWith('/') ? currentPath : `${currentPath}/`;
            push(`${updatedPathIfHasMissingTrailingSlash}articles/search?q=${encodeURIComponent(queryWord)}`);
        }
    };
    const handleClear = ()=>{
        onInput('');
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        ref: ref,
        xcss: $4cac09f852f6be2a$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
            className: (0, $8n1kL.default)([
                "_dhd01mok _1227e4h9"
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gFpea.default), {
                ref: props.keyboardRef,
                id: "article-search-query-input",
                onChange: handleChange,
                onKeyDown: handleKeyDown,
                isReadOnly: isReadOnly,
                placeholder: placeholderText ?? formatMessage((0, $P8bsr.messages).defaultPlaceholder),
                value: queryWord,
                elemBeforeInput: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                    xcss: $4cac09f852f6be2a$var$styles.searchIcon,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kDg5W))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: ""
                    })
                }),
                elemAfterInput: queryWord && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                    xcss: $4cac09f852f6be2a$var$styles.clearIcon,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lRscM.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))), {
                                ...iconProps,
                                color: "currentColor",
                                label: ""
                            }),
                        spacing: "compact",
                        onClick: handleClear,
                        label: "",
                        appearance: "subtle"
                    })
                })
            })
        })
    });
});

});
parcelRegister("7tteh", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("hL7ef")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("3dluW")).useRouterActions);

parcelRequire("gEXJG");
var $hL7ef = parcelRequire("hL7ef");
var $3dluW = parcelRequire("3dluW");
parcelRequire("bmFHk");
var $iAETh = parcelRequire("iAETh");
var $2ysIc = parcelRequire("2ysIc");
parcelRequire("g0X7d");
var $xHpmH = parcelRequire("xHpmH");
var $hIXw6 = parcelRequire("hIXw6");
var $fJLuE = parcelRequire("fJLuE");
var $g0X7d = parcelRequire("g0X7d");

var $5gHCc = parcelRequire("5gHCc");

var $eZJQz = parcelRequire("eZJQz");

var $8y9jR = parcelRequire("8y9jR");
parcelRequire("cc61O");
var $85p8t = parcelRequire("85p8t");
var $bIrCJ = parcelRequire("bIrCJ");
var $k1O6U = parcelRequire("k1O6U");

});
parcelRegister("gEXJG", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("hL7ef")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("3dluW")).useRouterActions);

var $4LA8b = parcelRequire("4LA8b");

var $kG37J = parcelRequire("kG37J");

var $a3566 = parcelRequire("a3566");

var $bEavN = parcelRequire("bEavN");

var $eZJQz = parcelRequire("eZJQz");

var $76paT = parcelRequire("76paT");

var $azwzm = parcelRequire("azwzm");

var $hL7ef = parcelRequire("hL7ef");

var $3dluW = parcelRequire("3dluW");

var $78j41 = parcelRequire("78j41");

});
parcelRegister("4LA8b", function(module, exports) {

var $cCnFQ = parcelRequire("cCnFQ");

var $ceo2e = parcelRequire("ceo2e");

var $02U4x = parcelRequire("02U4x");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("g0X7d");
var $bRicr = parcelRequire("bRicr");

var $hL7ef = parcelRequire("hL7ef");
class $37879413aa0e2684$var$Redirector extends (0, $8P7DW.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $02U4x.createPath)((0, $bRicr.generateLocationFromPath)(to.path, routeAttributes)) : (0, $02U4x.createPath)(to) : to;
        const currentPath = (0, $02U4x.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $ceo2e.default)($37879413aa0e2684$var$Redirector, "defaultProps", {
    push: false
});
const $37879413aa0e2684$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $hL7ef.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($37879413aa0e2684$var$Redirector, (0, $cCnFQ.default)({
        actions: actions,
        location: location
    }, props));
};

});
parcelRegister("g0X7d", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("bRicr")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("fJLuE")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("d7MXU")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("6ZbzR")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("hIXw6")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("hIXw6")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("6TiCT")).isSameRouteMatch);

var $xHpmH = parcelRequire("xHpmH");

var $bRicr = parcelRequire("bRicr");

var $fJLuE = parcelRequire("fJLuE");

var $d7MXU = parcelRequire("d7MXU");

var $6ZbzR = parcelRequire("6ZbzR");

var $hIXw6 = parcelRequire("hIXw6");

var $6TiCT = parcelRequire("6TiCT");

});
parcelRegister("xHpmH", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $0654c12110e487ea$export$883c3f3b6c000133);

var $cCnFQ = parcelRequire("cCnFQ");

var $02U4x = parcelRequire("02U4x");

var $cyxgG = parcelRequire("cyxgG");

var $66rHy = parcelRequire("66rHy");
const $0654c12110e487ea$var$hasWindow = ()=>typeof window !== 'undefined';
const $0654c12110e487ea$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($66rHy)))
};
const $0654c12110e487ea$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $0654c12110e487ea$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $0654c12110e487ea$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($cyxgG)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $0654c12110e487ea$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $0654c12110e487ea$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $0654c12110e487ea$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $cCnFQ.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $0654c12110e487ea$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $0654c12110e487ea$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $02U4x.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $02U4x.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $0654c12110e487ea$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
        createHref: (location)=>(0, $02U4x.createPath)(location)
    } : $0654c12110e487ea$var$methodsPlaceholders);
};

});

parcelRegister("bRicr", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $8a22c3025327bf1b$export$37e0729cc751960b);

var $3Xhgn = parcelRequire("3Xhgn");

var $lg6T0 = parcelRequire("lg6T0");
function $8a22c3025327bf1b$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $lg6T0.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $3Xhgn.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("3Xhgn", function(module, exports) {
$parcel$export(module.exports, "compile", () => $2e1445e041302e8a$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $2e1445e041302e8a$export$71304158c7e35877);
/**
 * Tokenize input string.
 */ function $2e1445e041302e8a$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $2e1445e041302e8a$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $2e1445e041302e8a$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($2e1445e041302e8a$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($2e1445e041302e8a$var$escapeString(prevText), ")[^").concat($2e1445e041302e8a$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $2e1445e041302e8a$export$ef7acd7185315e22(str, options) {
    return $2e1445e041302e8a$export$5b9bad9e403cf3d9($2e1445e041302e8a$export$98e6a39c04603d36(str, options), options);
}
function $2e1445e041302e8a$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $2e1445e041302e8a$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $2e1445e041302e8a$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $2e1445e041302e8a$export$71304158c7e35877(str, keys, options);
    return $2e1445e041302e8a$export$968e97c88708237a(re, keys, options);
}
function $2e1445e041302e8a$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $2e1445e041302e8a$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $2e1445e041302e8a$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $2e1445e041302e8a$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $2e1445e041302e8a$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $2e1445e041302e8a$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $2e1445e041302e8a$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $2e1445e041302e8a$var$stringToRegexp(path, keys, options) {
    return $2e1445e041302e8a$export$9a9303716def6456($2e1445e041302e8a$export$98e6a39c04603d36(path, options), keys, options);
}
function $2e1445e041302e8a$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($2e1445e041302e8a$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($2e1445e041302e8a$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $2e1445e041302e8a$var$escapeString(encode(token));
        else {
            var prefix = $2e1445e041302e8a$var$escapeString(encode(token.prefix));
            var suffix = $2e1445e041302e8a$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $2e1445e041302e8a$var$flags(options));
}
function $2e1445e041302e8a$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $2e1445e041302e8a$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $2e1445e041302e8a$var$arrayToRegexp(path, keys, options);
    return $2e1445e041302e8a$var$stringToRegexp(path, keys, options);
}

});


parcelRegister("fJLuE", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $b74fe62a0c87cc70$export$82476f982757e71e);

var $3Xhgn = parcelRequire("3Xhgn");
const $b74fe62a0c87cc70$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $3Xhgn.compile)(pattern)(params);

});

parcelRegister("d7MXU", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $98e1e94bb013f8dd$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $6nQJh = parcelRequire("6nQJh");
const $98e1e94bb013f8dd$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $98e1e94bb013f8dd$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $6nQJh !== 'undefined' && $6nQJh.versions != null && $6nQJh.versions.node != null) return true;
    if ($98e1e94bb013f8dd$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("6ZbzR", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $51616ba151b888f7$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $51616ba151b888f7$export$2e2bcd8739ae039);

var $lg6T0 = parcelRequire("lg6T0");

var $50b6i = parcelRequire("50b6i");

var $4hHWD = parcelRequire("4hHWD");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $51616ba151b888f7$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $lg6T0.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $4hHWD.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $50b6i.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $4hHWD.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $51616ba151b888f7$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$51616ba151b888f7$var$matchRoute(routes, pathname, queryParams, basePath);
const $51616ba151b888f7$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $51616ba151b888f7$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $51616ba151b888f7$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$51616ba151b888f7$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("50b6i", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a459028a8e6068b$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");

var $6G16e = parcelRequire("6G16e");

var $jCdEP = parcelRequire("jCdEP");
/* This should match what react-router does to compute a root match. */ const $3a459028a8e6068b$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $3a459028a8e6068b$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $6G16e.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $3a459028a8e6068b$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $jCdEP.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $cCnFQ.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $3a459028a8e6068b$export$2e2bcd8739ae039 = $3a459028a8e6068b$var$execRouteMatching;

});
parcelRegister("6G16e", function(module, exports) {
$parcel$export(module.exports, "default", () => $4dc784af86850c69$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $3Xhgn = parcelRequire("3Xhgn");
const $4dc784af86850c69$var$cache = {};
const $4dc784af86850c69$var$cacheLimit = 10000;
let $4dc784af86850c69$var$cacheCount = 0;
function $4dc784af86850c69$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $4dc784af86850c69$var$cache[cacheKey] || ($4dc784af86850c69$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $3Xhgn.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($4dc784af86850c69$var$cacheCount < $4dc784af86850c69$var$cacheLimit) {
        pathCache[path] = result;
        $4dc784af86850c69$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $4dc784af86850c69$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $4dc784af86850c69$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $4dc784af86850c69$export$2e2bcd8739ae039 = $4dc784af86850c69$var$matchPath;

});

parcelRegister("jCdEP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e47c2904426d1f4e$export$2e2bcd8739ae039);

var $cCnFQ = parcelRequire("cCnFQ");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $e47c2904426d1f4e$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $cCnFQ.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $e47c2904426d1f4e$export$2e2bcd8739ae039 = $e47c2904426d1f4e$var$matchQuery;

});


parcelRegister("4hHWD", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $31ead672df48ba19$export$f594abf16a5ad948);
const $31ead672df48ba19$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $31ead672df48ba19$var$MAX_CACHE_SIZE = 1000;
function $31ead672df48ba19$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$31ead672df48ba19$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $31ead672df48ba19$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($31ead672df48ba19$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $31ead672df48ba19$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $31ead672df48ba19$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("hIXw6", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $ce74b68c196e6edd$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $ce74b68c196e6edd$export$a0bd0313cbeabd49);

var $lg6T0 = parcelRequire("lg6T0");

var $8y9jR = parcelRequire("8y9jR");

var $fJLuE = parcelRequire("fJLuE");

var $6ZbzR = parcelRequire("6ZbzR");
const $ce74b68c196e6edd$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $fJLuE.generatePath)(route.path, params);
    const matchedRoute = (0, $6ZbzR.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $8y9jR.DEFAULT_MATCH),
        query: query
    };
};
const $ce74b68c196e6edd$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $lg6T0.qs).parse(search);
    const matchedRoute = (0, $6ZbzR.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $8y9jR.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $8y9jR.DEFAULT_MATCH)
    };
};

});
parcelRegister("8y9jR", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $6398ba51a72690dc$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $6398ba51a72690dc$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $6398ba51a72690dc$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $6398ba51a72690dc$export$fa440ddf675c8a93);

var $66rHy = parcelRequire("66rHy");

var $xHpmH = parcelRequire("xHpmH");
const $6398ba51a72690dc$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $6398ba51a72690dc$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $6398ba51a72690dc$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $6398ba51a72690dc$export$39607c9878cf5148 = (0, $xHpmH.createLegacyHistory)();
const $6398ba51a72690dc$export$1515254c8c90bebb = {
    location: $6398ba51a72690dc$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($66rHy)))
};
const $6398ba51a72690dc$export$fa440ddf675c8a93 = 'POP';

});


parcelRegister("6TiCT", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $504653f408d8c174$export$5997e70fc4543270);
const $504653f408d8c174$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $504653f408d8c174$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $504653f408d8c174$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $504653f408d8c174$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});


parcelRegister("hL7ef", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $cedc6ef2aaba2aa9$export$9a302a45f65d0572);

var $eZJQz = parcelRequire("eZJQz");
const $cedc6ef2aaba2aa9$export$9a302a45f65d0572 = (0, $eZJQz.useRouterStore);

});
parcelRegister("eZJQz", function(module, exports) {
$parcel$export(module.exports, "RouterStore", () => $aeaa53758f1d7186$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $aeaa53758f1d7186$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $aeaa53758f1d7186$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $aeaa53758f1d7186$export$ada49399abf7a3a1);

var $cCnFQ = parcelRequire("cCnFQ");

var $02U4x = parcelRequire("02U4x");

var $lR4hY = parcelRequire("lR4hY");
var $6xLCs = parcelRequire("6xLCs");
var $iOIPr = parcelRequire("iOIPr");
var $kUoOn = parcelRequire("kUoOn");
var $jvxRx = parcelRequire("jvxRx");

var $8y9jR = parcelRequire("8y9jR");
parcelRequire("g0X7d");
var $hIXw6 = parcelRequire("hIXw6");
var $bRicr = parcelRequire("bRicr");
var $fJLuE = parcelRequire("fJLuE");
var $d7MXU = parcelRequire("d7MXU");
var $6ZbzR = parcelRequire("6ZbzR");

var $kO6Ae = parcelRequire("kO6Ae");
const $aeaa53758f1d7186$export$36d128238e6b60f5 = {
    action: (0, $8y9jR.DEFAULT_ACTION),
    basePath: '',
    location: (0, $8y9jR.DEFAULT_HISTORY).location,
    history: (0, $8y9jR.DEFAULT_HISTORY),
    match: (0, $8y9jR.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $8y9jR.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $aeaa53758f1d7186$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $hIXw6.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $cCnFQ.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $d7MXU.isServerEnvironment)()) dispatch($aeaa53758f1d7186$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $hIXw6.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $kO6Ae.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $lR4hY.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $cCnFQ.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $kO6Ae.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $kO6Ae.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $bRicr.generateLocationFromPath)(route.path, (0, $cCnFQ.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $6ZbzR.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $kO6Ae.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $kO6Ae.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $bRicr.generateLocationFromPath)(route.path, (0, $cCnFQ.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $6ZbzR.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $cCnFQ.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $kO6Ae.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $kO6Ae.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $cCnFQ.default)({}, existingPathParams, params);
            const updatedPath = (0, $fJLuE.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $cCnFQ.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $kO6Ae.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $kO6Ae.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $aeaa53758f1d7186$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $kO6Ae.isExternalAbsolutePath)(path)) {
                const location = (0, $02U4x.parsePath)((0, $kO6Ae.getRelativePath)(path, basePath));
                nextContext = (0, $hIXw6.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $lR4hY.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $aeaa53758f1d7186$export$1cf0ecab63b1963c = (0, $kUoOn.createStore)({
    initialState: $aeaa53758f1d7186$export$36d128238e6b60f5,
    actions: $aeaa53758f1d7186$var$actions,
    name: 'router'
});
const $aeaa53758f1d7186$export$d6b817abe7a77ea5 = (0, $iOIPr.createContainer)($aeaa53758f1d7186$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($aeaa53758f1d7186$var$actions.bootstrapStore(props));
            !(0, $d7MXU.isServerEnvironment)() && dispatch($aeaa53758f1d7186$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $d7MXU.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $aeaa53758f1d7186$export$9569010eab09ae9e = (0, $6xLCs.createHook)($aeaa53758f1d7186$export$1cf0ecab63b1963c);
const $aeaa53758f1d7186$export$ada49399abf7a3a1 = (0, $6xLCs.createActionsHook)($aeaa53758f1d7186$export$1cf0ecab63b1963c);
function $aeaa53758f1d7186$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $6xLCs.createHook)($aeaa53758f1d7186$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $aeaa53758f1d7186$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $jvxRx.defaultRegistry).getStore($aeaa53758f1d7186$export$1cf0ecab63b1963c);
const $aeaa53758f1d7186$export$ebf37f7e180b13a9 = ()=>$aeaa53758f1d7186$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("kO6Ae", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $f25d957f7b41c259$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $f25d957f7b41c259$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $f25d957f7b41c259$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $f25d957f7b41c259$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $f25d957f7b41c259$export$c9237620ff7fdf7c);

var $lg6T0 = parcelRequire("lg6T0");
parcelRequire("g0X7d");
var $6TiCT = parcelRequire("6TiCT");
const $f25d957f7b41c259$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $f25d957f7b41c259$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $f25d957f7b41c259$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $f25d957f7b41c259$var$stripTrailingSlash(prefix);
        prefix = $f25d957f7b41c259$var$addLeadingSlash(prefix);
        path = $f25d957f7b41c259$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $f25d957f7b41c259$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $f25d957f7b41c259$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$f25d957f7b41c259$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($lg6T0)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($lg6T0)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $f25d957f7b41c259$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$f25d957f7b41c259$export$e83e3719fc818ee5(path)) {
        path = $f25d957f7b41c259$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($lg6T0)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $f25d957f7b41c259$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $lg6T0.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $f25d957f7b41c259$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $f25d957f7b41c259$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $6TiCT.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});




parcelRegister("kG37J", function(module, exports) {

var $cCnFQ = parcelRequire("cCnFQ");

var $02U4x = parcelRequire("02U4x");

var $8P7DW = parcelRequire("8P7DW");

var $eZJQz = parcelRequire("eZJQz");
const $f0da272f09855d52$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eZJQz.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $f0da272f09855d52$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $8P7DW.useMemo)(()=>(0, $02U4x.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($f0da272f09855d52$export$55185c17a0fcbe46, (0, $cCnFQ.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("a3566", function(module, exports) {

var $8P7DW = parcelRequire("8P7DW");

var $3dluW = parcelRequire("3dluW");
const $750e236e191fe201$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $3dluW.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, children(actions));
};
$750e236e191fe201$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("3dluW", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $2573430ca6378727$export$402e82ff1b20594b);

var $eZJQz = parcelRequire("eZJQz");
const $2573430ca6378727$export$402e82ff1b20594b = (0, $eZJQz.useRouterStoreActions);

});


parcelRegister("bEavN", function(module, exports) {

var $911Xe = parcelRequire("911Xe");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("g0X7d");
var $d7MXU = parcelRequire("d7MXU");

var $eZJQz = parcelRequire("eZJQz");
const $87ab958e50f7fdbc$var$_excluded = [
    "listen"
];
const $87ab958e50f7fdbc$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $eZJQz.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $911Xe.default)(_ref, $87ab958e50f7fdbc$var$_excluded);
    if (!state.unlisten && !(0, $d7MXU.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, children(state, actions));
};

});

parcelRegister("76paT", function(module, exports) {

var $8P7DW = parcelRequire("8P7DW");

var $6xLCs = parcelRequire("6xLCs");

var $eZJQz = parcelRequire("eZJQz");
const $52bc9f21bd13d166$var$createPathParamHook = (0, $6xLCs.createHook)((0, $eZJQz.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $52bc9f21bd13d166$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $52bc9f21bd13d166$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $8P7DW.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("azwzm", function(module, exports) {

var $8P7DW = parcelRequire("8P7DW");

var $6xLCs = parcelRequire("6xLCs");

var $eZJQz = parcelRequire("eZJQz");
const $7b266fda0e69b9a0$var$createQueryParamHook = (0, $6xLCs.createHook)((0, $eZJQz.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $7b266fda0e69b9a0$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $7b266fda0e69b9a0$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $8P7DW.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("78j41", function(module, exports) {

var $cCnFQ = parcelRequire("cCnFQ");

var $8P7DW = parcelRequire("8P7DW");

var $eZJQz = parcelRequire("eZJQz");
const $53181170ac4c7689$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $53181170ac4c7689$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $53181170ac4c7689$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $eZJQz.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, (0, $cCnFQ.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});


parcelRegister("bmFHk", function(module, exports) {

var $2ysIc = parcelRequire("2ysIc");

var $iAETh = parcelRequire("iAETh");

});
parcelRegister("2ysIc", function(module, exports) {

var $cCnFQ = parcelRequire("cCnFQ");

var $911Xe = parcelRequire("911Xe");

var $02U4x = parcelRequire("02U4x");

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("g0X7d");
var $hIXw6 = parcelRequire("hIXw6");
var $bRicr = parcelRequire("bRicr");

var $eZJQz = parcelRequire("eZJQz");

var $hGZkh = parcelRequire("hGZkh");
parcelRequire("9Wyev");
var $geUhL = parcelRequire("geUhL");
var $eVAVE = parcelRequire("eVAVE");
const $1dc50751a1a31329$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $1dc50751a1a31329$var$PREFETCH_DELAY = 225;
const $1dc50751a1a31329$var$Link = /*#__PURE__*/ (0, $8P7DW.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $911Xe.default)(_ref, $1dc50751a1a31329$var$_excluded);
    const routerActions = (0, $eZJQz.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $hGZkh.useTimeout)($1dc50751a1a31329$var$PREFETCH_DELAY);
    const validLinkType = (0, $geUhL.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $8P7DW.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $02U4x.createPath)((0, $bRicr.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $8P7DW.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $hIXw6.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $eVAVE.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $8P7DW.createElement)(validLinkType, (0, $cCnFQ.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$1dc50751a1a31329$var$Link.displayName = 'Link';
var $1dc50751a1a31329$export$2e2bcd8739ae039 = $1dc50751a1a31329$var$Link;

});
parcelRegister("hGZkh", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $ce15ee05c8434240$export$d8e6abf214c9ec0f);

var $8P7DW = parcelRequire("8P7DW");
const $ce15ee05c8434240$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $8P7DW.useRef)();
    const schedule = (0, $8P7DW.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $8P7DW.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("9Wyev", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("geUhL")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("eVAVE")).handleNavigation);

var $geUhL = parcelRequire("geUhL");

var $eVAVE = parcelRequire("eVAVE");

});
parcelRegister("geUhL", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => $bd299d4548034e6a$export$855ece989b15eb57);
const $bd299d4548034e6a$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $bd299d4548034e6a$export$855ece989b15eb57 = (type)=>$bd299d4548034e6a$var$VALID_LINK_TYPES.includes(type) ? type : 'a';

});

parcelRegister("eVAVE", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $ade308d631b2b2f7$export$706ad1af8096e280);

var $34Bfu = parcelRequire("34Bfu");
const $ade308d631b2b2f7$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $34Bfu.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $34Bfu.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $34Bfu.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("34Bfu", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $23cea3a77082ac23$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $23cea3a77082ac23$export$130b789831072f4c);
const $23cea3a77082ac23$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $23cea3a77082ac23$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});




parcelRegister("iAETh", function(module, exports) {

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("gEXJG");
var $hL7ef = parcelRequire("hL7ef");
const $d88b4eca7372a480$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $hL7ef.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});


parcelRegister("5gHCc", function(module, exports) {
parcelRequire("g0X7d");
var $hIXw6 = parcelRequire("hIXw6");
const $3d60476de4e95ab4$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $hIXw6.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("cc61O", function(module, exports) {

var $QuQmk = parcelRequire("QuQmk");

var $bIrCJ = parcelRequire("bIrCJ");

var $k1O6U = parcelRequire("k1O6U");

var $gKABY = parcelRequire("gKABY");

var $85p8t = parcelRequire("85p8t");

var $QuQmk = parcelRequire("QuQmk");

var $UjA2X = parcelRequire("UjA2X");

});
parcelRegister("QuQmk", function(module, exports) {

var $85p8t = parcelRequire("85p8t");
parcelRequire("ipiZi");
var $StWpL = parcelRequire("StWpL");
const $09dcc85203cfa37e$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $09dcc85203cfa37e$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $85p8t.getResourceStore)().actions;
    const nextResources = (0, $StWpL.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $09dcc85203cfa37e$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $85p8t.getResourceStore)().actions;
    const nextResources = (0, $StWpL.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $09dcc85203cfa37e$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $85p8t.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $09dcc85203cfa37e$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $09dcc85203cfa37e$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $09dcc85203cfa37e$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $85p8t.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $85p8t.getResourceStore)().actions;
            const nextResources = (0, $StWpL.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $85p8t.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("85p8t", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $5e3249c9d3ea20ce$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $5e3249c9d3ea20ce$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $5e3249c9d3ea20ce$export$98e41a62c9bef75e);

var $cCnFQ = parcelRequire("cCnFQ");

var $911Xe = parcelRequire("911Xe");

var $6xLCs = parcelRequire("6xLCs");
var $iOIPr = parcelRequire("iOIPr");
var $kUoOn = parcelRequire("kUoOn");
var $5SFeI = parcelRequire("5SFeI");
var $jvxRx = parcelRequire("jvxRx");
parcelRequire("g0X7d");
var $d7MXU = parcelRequire("d7MXU");

var $kmZoK = parcelRequire("kmZoK");
parcelRequire("ipiZi");
var $4L1Tl = parcelRequire("4L1Tl");
var $exA16 = parcelRequire("exA16");
var $d4yw9 = parcelRequire("d4yw9");
var $hQn7f = parcelRequire("hQn7f");
var $b5DAq = parcelRequire("b5DAq");
var $dDOs2 = parcelRequire("dDOs2");
var $9VilQ = parcelRequire("9VilQ");
var $f0KBL = parcelRequire("f0KBL");
var $3DpnK = parcelRequire("3DpnK");
var $ho6TT = parcelRequire("ho6TT");
var $80nnF = parcelRequire("80nnF");
var $ka5DW = parcelRequire("ka5DW");
const $5e3249c9d3ea20ce$var$_excluded = [
    "context"
], $5e3249c9d3ea20ce$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $5e3249c9d3ea20ce$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $d4yw9.deleteResourceState)(type, key));
                dispatch((0, $4L1Tl.executeForDependents)(resource, (dependentResource)=>$5e3249c9d3ea20ce$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $d4yw9.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $911Xe.default)(_getState, $5e3249c9d3ea20ce$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $kmZoK.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $cCnFQ.default)({}, prevSlice, changes, {
                expiresAt: (0, $9VilQ.getExpiresAt)(maxAge),
                accessedAt: (0, $b5DAq.getAccessedAt)()
            });
            dispatch((0, $d4yw9.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $4L1Tl.executeForDependents)(resource, (dependentResource)=>$5e3249c9d3ea20ce$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $d4yw9.getResourceState)(type, key));
            if (cached && (0, $f0KBL.shouldUseCache)(cached)) {
                if ((0, $f0KBL.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $3DpnK.setSsrDataPromise)(cached);
                    cached = (0, $9VilQ.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $b5DAq.getAccessedAt)();
                dispatch((0, $d4yw9.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($5e3249c9d3ea20ce$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $d4yw9.getResourceState)(type, key)) || (0, $dDOs2.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $ka5DW.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $d4yw9.getPrefetchSlice)(type, key)) || (0, $exA16.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $4L1Tl.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $d4yw9.setResourceState)(type, key, (0, $cCnFQ.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $b5DAq.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $4L1Tl.executeForDependents)(resource, (dependentResource)=>$5e3249c9d3ea20ce$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $ho6TT.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $d4yw9.getResourceState)(type, key));
            const finalSlice = (0, $cCnFQ.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $b5DAq.getAccessedAt)(),
                expiresAt: (0, $9VilQ.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $d4yw9.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $d4yw9.getPrefetchSlice)(type, key)) || (0, $exA16.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $4L1Tl.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $d4yw9.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $4L1Tl.executeForDependents)(resource, (dependentResource)=>$5e3249c9d3ea20ce$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $5e3249c9d3ea20ce$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $4L1Tl.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $5e3249c9d3ea20ce$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $4L1Tl.actionWithDependencies)(routerStoreContext.route.resources, resource, $5e3249c9d3ea20ce$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $4L1Tl.actionWithDependencies)(routerStoreContext.route.resources, resource, $5e3249c9d3ea20ce$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $4L1Tl.actionWithDependencies)(routerStoreContext.route.resources, resource, $5e3249c9d3ea20ce$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($5e3249c9d3ea20ce$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $d4yw9.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $d4yw9.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $d7MXU.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $4L1Tl.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$5e3249c9d3ea20ce$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $4L1Tl.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$5e3249c9d3ea20ce$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $cCnFQ.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $80nnF.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $911Xe.default)(_ref, $5e3249c9d3ea20ce$var$_excluded2);
                const deserializedError = !error ? null : (0, $hQn7f.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $cCnFQ.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $80nnF.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $hQn7f.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $ho6TT.TimeoutError) ? loading : false
                }))
};
const $5e3249c9d3ea20ce$export$94f50dade551bd01 = (0, $kUoOn.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $5e3249c9d3ea20ce$export$e324594224ef24da,
    name: 'router-resources'
});
const $5e3249c9d3ea20ce$export$cc90fb9c37c5589d = (0, $iOIPr.createContainer)($5e3249c9d3ea20ce$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $5e3249c9d3ea20ce$export$fee1a6213543bd78 = (0, $5SFeI.createSubscriber)($5e3249c9d3ea20ce$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $kmZoK.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $5e3249c9d3ea20ce$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $jvxRx.defaultRegistry).getStore($5e3249c9d3ea20ce$export$94f50dade551bd01);
const $5e3249c9d3ea20ce$export$ac3608e0bb357c7 = (0, $6xLCs.createHook)($5e3249c9d3ea20ce$export$94f50dade551bd01, {
    selector: (0, $kmZoK.getSliceForResource)
});
const $5e3249c9d3ea20ce$export$98e41a62c9bef75e = (0, $6xLCs.createActionsHook)($5e3249c9d3ea20ce$export$94f50dade551bd01);
const $5e3249c9d3ea20ce$export$e59f52df235ac7b3 = (0, $6xLCs.createHook)($5e3249c9d3ea20ce$export$94f50dade551bd01, {
    selector: (0, $kmZoK.getResourceStoreContext)
});

});
parcelRegister("kmZoK", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $ed457d18a9bc115b$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $ed457d18a9bc115b$export$6a0b1779210de0ee);

var $cCnFQ = parcelRequire("cCnFQ");
parcelRequire("ipiZi");
var $dDOs2 = parcelRequire("dDOs2");
const $ed457d18a9bc115b$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $cCnFQ.default)({}, slice) : (0, $dDOs2.getDefaultStateSlice)();
};
const $ed457d18a9bc115b$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("ipiZi", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("b5DAq")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("exA16")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("4L1Tl")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("4L1Tl")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("4L1Tl")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("4L1Tl")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("9VilQ")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("9VilQ")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("dDOs2")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("StWpL")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("ka5DW")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("d4yw9")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("d4yw9")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("d4yw9")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("d4yw9")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("d4yw9")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("hQn7f")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("hQn7f")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("f0KBL")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("f0KBL")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("3DpnK")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("ho6TT")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("80nnF")).transformData);

var $b5DAq = parcelRequire("b5DAq");

var $exA16 = parcelRequire("exA16");

var $9JTzC = parcelRequire("9JTzC");

var $4L1Tl = parcelRequire("4L1Tl");

var $9VilQ = parcelRequire("9VilQ");

var $b6Vsu = parcelRequire("b6Vsu");

var $dDOs2 = parcelRequire("dDOs2");

var $22PHh = parcelRequire("22PHh");

var $StWpL = parcelRequire("StWpL");

var $ka5DW = parcelRequire("ka5DW");

var $d4yw9 = parcelRequire("d4yw9");

var $7Kvq6 = parcelRequire("7Kvq6");

var $hQn7f = parcelRequire("hQn7f");

var $f0KBL = parcelRequire("f0KBL");

var $3DpnK = parcelRequire("3DpnK");

var $ho6TT = parcelRequire("ho6TT");

var $80nnF = parcelRequire("80nnF");

});
parcelRegister("b5DAq", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $812ede631c5ea790$export$9ccb639b7a119f61);
const $812ede631c5ea790$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("exA16", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $a96015ec0f0b4ec9$export$dc62515c8f0b52dd);

var $cCnFQ = parcelRequire("cCnFQ");

var $8fFxK = parcelRequire("8fFxK");

var $9VilQ = parcelRequire("9VilQ");

var $b6Vsu = parcelRequire("b6Vsu");

var $ho6TT = parcelRequire("ho6TT");

var $1ibTT = parcelRequire("1ibTT");
function $a96015ec0f0b4ec9$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $cCnFQ.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $b6Vsu.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $ho6TT.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $9VilQ.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $8fFxK.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $9VilQ.getExpiresAt)((0, $1ibTT.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("8fFxK", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", () => $601ff319c74e0e00$export$881d135f98d8d7d0);
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", () => $601ff319c74e0e00$export$9ab5bdcb8a1d6c34);
$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", () => $601ff319c74e0e00$export$12c1dc38ea1692da);
const $601ff319c74e0e00$export$881d135f98d8d7d0 = 100;
const $601ff319c74e0e00$export$9ab5bdcb8a1d6c34 = false;
const $601ff319c74e0e00$export$12c1dc38ea1692da = 0;

});

parcelRegister("9VilQ", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $7397ac1963778514$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $7397ac1963778514$export$18d1d420fd588368);

var $cCnFQ = parcelRequire("cCnFQ");
const $7397ac1963778514$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $7397ac1963778514$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $cCnFQ.default)({}, slice, {
        expiresAt: $7397ac1963778514$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("b6Vsu", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $816cd34e61f74f75$export$58634b3a58ae66b7);
const $816cd34e61f74f75$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("ho6TT", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $ca8a07db86eba36e$export$66d311bf29d5c89c);
class $ca8a07db86eba36e$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("1ibTT", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $0f10b41274e52ab7$export$37d3126be6549b13);
const $0f10b41274e52ab7$export$37d3126be6549b13 = 10000;

});


parcelRegister("9JTzC", function(module, exports) {

var $8fFxK = parcelRequire("8fFxK");
/**
 * Utility method to created async versions of getData functions
 */ const $01d4713ce4a794ef$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $01d4713ce4a794ef$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $01d4713ce4a794ef$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $8fFxK.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $8fFxK.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $8fFxK.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("4L1Tl", function(module, exports) {
$parcel$export(module.exports, "actionWithDependencies", () => $376d04dad467fc44$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $376d04dad467fc44$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $376d04dad467fc44$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $376d04dad467fc44$export$75915f81f2a6540a);

var $cCnFQ = parcelRequire("cCnFQ");

var $dDOs2 = parcelRequire("dDOs2");

var $d4yw9 = parcelRequire("d4yw9");
var $376d04dad467fc44$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $376d04dad467fc44$var$fromEntries = ($376d04dad467fc44$var$_Object$fromEntries = Object.fromEntries) != null ? $376d04dad467fc44$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $376d04dad467fc44$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $376d04dad467fc44$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $376d04dad467fc44$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($376d04dad467fc44$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($376d04dad467fc44$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($376d04dad467fc44$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $376d04dad467fc44$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($376d04dad467fc44$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $376d04dad467fc44$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$376d04dad467fc44$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $376d04dad467fc44$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($376d04dad467fc44$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $376d04dad467fc44$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($376d04dad467fc44$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $376d04dad467fc44$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($376d04dad467fc44$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $376d04dad467fc44$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $376d04dad467fc44$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $376d04dad467fc44$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $d4yw9.getResourceState)(dependencyType, key)) || (0, $dDOs2.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $d4yw9.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $cCnFQ.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("dDOs2", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $9ee60d734f548edf$export$fa8e33c3301e2e94);

var $cCnFQ = parcelRequire("cCnFQ");

var $b5DAq = parcelRequire("b5DAq");

var $8fFxK = parcelRequire("8fFxK");

var $9VilQ = parcelRequire("9VilQ");

var $gcD8U = parcelRequire("gcD8U");
const $9ee60d734f548edf$export$fa8e33c3301e2e94 = ()=>(0, $cCnFQ.default)({}, (0, $gcD8U.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, $9VilQ.getExpiresAt)((0, $8fFxK.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $b5DAq.getAccessedAt)()
    });

});
parcelRegister("gcD8U", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $bcbc214692cc3ca4$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $bcbc214692cc3ca4$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});


parcelRegister("d4yw9", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $98466c941779838c$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $98466c941779838c$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $98466c941779838c$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $98466c941779838c$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $98466c941779838c$export$d40f35dc5952864b);

var $911Xe = parcelRequire("911Xe");

var $cCnFQ = parcelRequire("cCnFQ");
function $98466c941779838c$var$_toPropertyKey(t) {
    var i = $98466c941779838c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $98466c941779838c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $98466c941779838c$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $98466c941779838c$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $cCnFQ.default)({}, prefetching, {
                [type]: (0, $cCnFQ.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $98466c941779838c$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($98466c941779838c$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $cCnFQ.default)({}, data, {
                [type]: (0, $cCnFQ.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $98466c941779838c$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $98466c941779838c$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $911Xe.default)(data, [
            type
        ].map($98466c941779838c$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $911Xe.default)(resourceForType, [
                key
            ].map($98466c941779838c$var$_toPropertyKey));
            setState({
                data: (0, $cCnFQ.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("22PHh", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $17d3dea8b68a67d0$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $17d3dea8b68a67d0$export$cd7fbe7e979df558);
const $17d3dea8b68a67d0$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $17d3dea8b68a67d0$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$17d3dea8b68a67d0$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("StWpL", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $0a3c44f3fed37f07$export$7cbbc763e2f3d65d);

var $22PHh = parcelRequire("22PHh");

var $7Kvq6 = parcelRequire("7Kvq6");
const $0a3c44f3fed37f07$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $7Kvq6.routeHasResources)(nextRoute)) return [];
    if ((0, $7Kvq6.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $22PHh.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $22PHh.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("7Kvq6", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $5a4533a5889bf794$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $5a4533a5889bf794$export$221027ff1aa38f82);
const $5a4533a5889bf794$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $5a4533a5889bf794$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("ka5DW", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $ead91e7803672a5f$export$89440b7623c2c75c);

var $d4yw9 = parcelRequire("d4yw9");
const $ead91e7803672a5f$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $ead91e7803672a5f$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $ead91e7803672a5f$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $ead91e7803672a5f$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $ead91e7803672a5f$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $d4yw9.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("hQn7f", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $cfd9395a1fd28700$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $cfd9395a1fd28700$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $cfd9395a1fd28700$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $cfd9395a1fd28700$var$NonError);
    }
}
const $cfd9395a1fd28700$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $cfd9395a1fd28700$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $cfd9395a1fd28700$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $cfd9395a1fd28700$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $cfd9395a1fd28700$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $cfd9395a1fd28700$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $cfd9395a1fd28700$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $cfd9395a1fd28700$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $cfd9395a1fd28700$var$NonError(value);
};

});

parcelRegister("f0KBL", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $aedb028642c1058b$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $aedb028642c1058b$export$399de8c43d0ece3c);
const $aedb028642c1058b$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $aedb028642c1058b$var$isFresh = (resource)=>{
    if ($aedb028642c1058b$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $aedb028642c1058b$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($aedb028642c1058b$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("3DpnK", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $2a58b3f9f67e2f5b$export$2e4da1b414980956);

var $cCnFQ = parcelRequire("cCnFQ");
const $2a58b3f9f67e2f5b$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $cCnFQ.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("80nnF", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $5d4075be582f07bb$export$3ceb62baab058c6b);
const $5d4075be582f07bb$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});





parcelRegister("bIrCJ", function(module, exports) {

var $8P7DW = parcelRequire("8P7DW");

var $k1O6U = parcelRequire("k1O6U");
const $88793b41dabace9f$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $k1O6U.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, children(result));
};

});
parcelRegister("k1O6U", function(module, exports) {
$parcel$export(module.exports, "useResource", () => $e94ac58305477d13$export$9f6abfd74295843b);

var $cCnFQ = parcelRequire("cCnFQ");

var $8P7DW = parcelRequire("8P7DW");

var $6xLCs = parcelRequire("6xLCs");

var $eZJQz = parcelRequire("eZJQz");

var $85p8t = parcelRequire("85p8t");
const $e94ac58305477d13$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $85p8t.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $eZJQz.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $8P7DW.useMemo)(()=>(0, $6xLCs.createHook)((0, $eZJQz.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $85p8t.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $8P7DW.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $8P7DW.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $8P7DW.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $8P7DW.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $8P7DW.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $cCnFQ.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});


parcelRegister("gKABY", function(module, exports) {

var $85p8t = parcelRequire("85p8t");
const $c31d577ecbbb80a9$export$dee7bf9fc0ff48c3 = (fn)=>(0, $85p8t.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("UjA2X", function(module, exports) {
const $0a946b562af1f0fc$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});



parcelRegister("P8bsr", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4a122818f8c9d74d$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $4a122818f8c9d74d$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    defaultPlaceholder: {
        id: 'company-hub.article-search-component.placeholder',
        defaultMessage: 'Search for help',
        description: 'Default placeholder text for the article search input.'
    }
});

});



parcelRegister("2mGqb", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchComponent", () => $ff021744cfd491c1$export$8fa6497fb1b229b0);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $36kyW = parcelRequire("36kyW");
parcelRequire("c2L1U");
var $cqrss = parcelRequire("cqrss");

var $2CGHX = parcelRequire("2CGHX");

var $8NbLB = parcelRequire("8NbLB");

var $fe6Ty = parcelRequire("fe6Ty");

var $cUeBj = parcelRequire("cUeBj");

var $d13pc = parcelRequire("d13pc");
const $ff021744cfd491c1$export$8fa6497fb1b229b0 = ({ isEditor: isEditor, placeholderText: placeholderText })=>{
    var _inputBoxRef$current;
    const [queryWord, setQueryWord] = (0, $8P7DW.useState)('');
    const [showDropdown, setShowDropdown] = (0, $8P7DW.useState)(false);
    const inputBoxRef = (0, $8P7DW.useRef)(null);
    const inputRef = (0, $8P7DW.useRef)(null);
    const [_, setInputWidth] = (0, $8P7DW.useState)((_inputBoxRef$current = inputBoxRef.current) === null || _inputBoxRef$current === void 0 ? void 0 : _inputBoxRef$current.offsetWidth);
    const { cloudId: cloudId, env: { helpCenterAri: helpCenterAri } } = (0, $8NbLB.useHubContext)();
    if (!helpCenterAri || !cloudId) throw new Error('Help center Ari and cloud ID are required');
    (0, $8P7DW.useEffect)(()=>{
        const listener = ()=>{
            var _inputBoxRef$current2;
            return setInputWidth((_inputBoxRef$current2 = inputBoxRef.current) === null || _inputBoxRef$current2 === void 0 ? void 0 : _inputBoxRef$current2.offsetWidth);
        };
        const unbind = (0, $36kyW.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = ()=>{
        if (showDropdown) setShowDropdown(false);
    };
    const trigger = (0, $8P7DW.useCallback)((triggerProps)=>{
        const handleInput = (searchInput)=>{
            setQueryWord(searchInput);
            setShowDropdown(searchInput.trim().length > 0);
        };
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
            ref: inputBoxRef,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cUeBj.SearchTextField), {
                keyboardRef: inputRef,
                ...triggerProps,
                ref: triggerProps.ref,
                onInput: handleInput,
                isReadOnly: isEditor,
                placeholderText: placeholderText,
                showDropdown: showDropdown,
                queryWord: queryWord
            })
        });
    }, [
        isEditor,
        placeholderText,
        showDropdown,
        queryWord
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cqrss.Popup), {
        shouldReturnFocus: false,
        content: (contentProps)=>{
            var _inputBoxRef$current3;
            return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fe6Ty.KeyboardHighlightProvider), {
                listenerNode: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $d13pc.HelpObjectSearchDropdown), {
                    ...contentProps,
                    cloudId: cloudId,
                    helpCenterAri: helpCenterAri || '',
                    inputWidth: ((_inputBoxRef$current3 = inputBoxRef.current) === null || _inputBoxRef$current3 === void 0 ? void 0 : _inputBoxRef$current3.offsetWidth) || 0,
                    queryWord: queryWord
                })
            });
        },
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};

});
parcelRegister("d13pc", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchDropdown", () => $5579a2680659455b$export$99781ab3c09b5cc0);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $km5oe = parcelRequire("km5oe");

var $4dAbH = parcelRequire("4dAbH");

var $eZmwX = parcelRequire("eZmwX");
const $5579a2680659455b$export$99781ab3c09b5cc0 = ({ inputWidth: inputWidth, ...props })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $km5oe.SearchDialog), {
        /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ style: {
            boxShadow: 'none',
            width: inputWidth
        },
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
            fallback: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4dAbH.SearchSkeletons), {}),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eZmwX.HelpObjectSearchResults), {
                ...props
            })
        })
    });
};

});
parcelRegister("eZmwX", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchResults", () => $04c888478a577f77$export$4d1c12e2349aa7cc);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $6AyZC = parcelRequire("6AyZC");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $fiikg = parcelRequire("fiikg");
var $k7INq = parcelRequire("k7INq");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $cKYBS = parcelRequire("cKYBS");

var $iqJis = parcelRequire("iqJis");

var $a9GGo = parcelRequire("a9GGo");

var $f1STa = parcelRequire("f1STa");

var $hIZ30 = parcelRequire("hIZ30");
var $2CGHX = parcelRequire("2CGHX");
var $6E5P5 = parcelRequire("6E5P5");

var $1oLfT = parcelRequire("1oLfT");

var $bNUe6 = parcelRequire("bNUe6");

var $iw8Zd = parcelRequire("iw8Zd");

var $52UCQ = parcelRequire("52UCQ");

var $4ZEu0 = parcelRequire("4ZEu0");
const $04c888478a577f77$var$DEFAULT_RESULTS_LIMIT = 3;
const $04c888478a577f77$var$ExternalLinkComponent = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ href: href = '#', ...props }, ref)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $hIZ30.default), {
        ref: ref,
        href: href,
        ...props,
        target: "_blank",
        xcss: $04c888478a577f77$var$styles.externalLink,
        rel: "noopener noreferrer"
    }));
const $04c888478a577f77$var$InternalLinkComponent = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ href: href = '#', children: children, ...props }, ref)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $cKYBS.default), {
        ref: ref,
        to: href,
        ...props,
        children: children
    }));
const $04c888478a577f77$export$4d1c12e2349aa7cc = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    var _searchResponse$helpO3, _searchResponse$helpO4;
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    /* eslint-disable @atlassian/relay/unused-fields */ const searchResponse = (0, $h3cOB.useLazyLoadQuery)((0, $6AyZC.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryTerm: queryWord,
        limit: $04c888478a577f77$var$DEFAULT_RESULTS_LIMIT
    });
    /* eslint-enable @atlassian/relay/unused-fields */ const articles = (0, $8P7DW.useMemo)(()=>{
        var _searchResponse$helpO;
        const results = searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO = searchResponse.helpObjectStore_searchArticles) === null || _searchResponse$helpO === void 0 ? void 0 : _searchResponse$helpO.results;
        if (!results) return [];
        return results.map((result)=>{
            var _result$metadata;
            return {
                ari: result.ari,
                title: result.title,
                url: result.displayLink,
                type: 'ARTICLE',
                isExternal: (_result$metadata = result.metadata) === null || _result$metadata === void 0 ? void 0 : _result$metadata.isExternal
            };
        });
    }, [
        searchResponse
    ]);
    const requestTypes = (0, $8P7DW.useMemo)(()=>{
        var _searchResponse$helpO2;
        const results = searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO2 = searchResponse.helpObjectStore_searchRequestTypes) === null || _searchResponse$helpO2 === void 0 ? void 0 : _searchResponse$helpO2.results;
        if (!results) return [];
        return results.map((result)=>({
                id: result.id,
                title: result.title,
                url: result.displayLink,
                iconUrl: result.iconUrl,
                type: 'REQUEST_TYPE'
            }));
    }, [
        searchResponse
    ]);
    const hasArticlesError = Boolean(searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO3 = searchResponse.helpObjectStore_searchArticles) === null || _searchResponse$helpO3 === void 0 ? void 0 : _searchResponse$helpO3.message);
    const hasRequestTypesError = Boolean(searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO4 = searchResponse.helpObjectStore_searchRequestTypes) === null || _searchResponse$helpO4 === void 0 ? void 0 : _searchResponse$helpO4.message);
    const hasBothErrors = hasArticlesError && hasRequestTypesError;
    const allResults = (0, $8P7DW.useMemo)(()=>{
        return [
            ...articles,
            ...requestTypes
        ];
    }, [
        articles,
        requestTypes
    ]);
    const showEmptyState = allResults.length === 0;
    const showResolvedState = allResults.length > 0;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8P7DW.Fragment), {
        children: [
            showEmptyState && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1oLfT.EmptyState), {
                title: hasBothErrors ? formatMessage((0, $4ZEu0.messages).errorTitle) : formatMessage((0, $4ZEu0.messages).emptyStateTitle),
                Image: (0, $52UCQ.SearchErrorImage),
                content: hasBothErrors ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                    ...(0, $4ZEu0.messages).errorDescription
                }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                    ...(0, $4ZEu0.messages).emptyStateDescription
                })
            }),
            showResolvedState && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bNUe6.SearchDialogContent), {
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6E5P5.default), {
                    xcss: $04c888478a577f77$var$styles.stackContainer,
                    children: [
                        articles.length > 0 && /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                                    xcss: $04c888478a577f77$var$styles.sectionHeading,
                                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                                        as: "h3",
                                        size: "xsmall",
                                        children: formatMessage((0, $4ZEu0.messages).resourcesHeading)
                                    })
                                }),
                                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
                                    children: articles.map((result)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                                            xcss: $04c888478a577f77$var$styles.searchResultContainer,
                                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iw8Zd.SearchResult), {
                                                href: result.url,
                                                linkComponent: result.isExternal ? $04c888478a577f77$var$ExternalLinkComponent : $04c888478a577f77$var$InternalLinkComponent,
                                                title: result.title,
                                                isCollapsed: true,
                                                icon: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f1STa))), {
                                                    label: "",
                                                    spacing: "spacious",
                                                    color: "var(--ds-text-subtle, #505258)"
                                                })
                                            })
                                        }, result.ari))
                                })
                            ]
                        }),
                        requestTypes.length > 0 && /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                                    xcss: $04c888478a577f77$var$styles.sectionHeading,
                                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                                        as: "h3",
                                        size: "xsmall",
                                        children: formatMessage((0, $4ZEu0.messages).requestFormsHeading)
                                    })
                                }),
                                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
                                    children: requestTypes.map((result)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                                            xcss: $04c888478a577f77$var$styles.searchResultContainer,
                                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iw8Zd.SearchResult), {
                                                linkComponent: $04c888478a577f77$var$InternalLinkComponent,
                                                href: result.url,
                                                title: result.title,
                                                isCollapsed: true,
                                                icon: result.iconUrl ? /*#__PURE__*/ (0, $gWgPx.jsx)("img", {
                                                    src: result.iconUrl,
                                                    alt: "",
                                                    className: (0, $8n1kL.default)([
                                                        $04c888478a577f77$var$styles.icon
                                                    ])
                                                }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a9GGo))), {
                                                    label: "",
                                                    spacing: "spacious"
                                                })
                                            })
                                        }, result.id))
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $04c888478a577f77$var$styles = {
    externalLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1ydc1r31 _1x28glyw _1726nqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
    icon: "_1bsb1tcg _4t3i1tcg _5ral1f51",
    stackContainer: "_1bsb1osq _n3tdpxbi",
    searchResultContainer: "_19bv1b66 _u5f31b66",
    sectionHeading: "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvv47k"
};

});
parcelRegister("6AyZC", function(module, exports) {
$parcel$export(module.exports, "default", () => $814331fc6ad9e2be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bcca1bc645c54a99192966f52b62e701>>
 * @relayHash 4f9e1fc12763ea436c7785c11780ff3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22d74b35331ccd017c3ac7fdd5f5d4bf2a7c5d16d649afd374497eb56f2df43e
const $814331fc6ad9e2be$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v6 = {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
    }, v7 = {
        "kind": "Variable",
        "name": "queryTerm",
        "variableName": "queryTerm"
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "highlight",
            "value": false
        },
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreArticleSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    {
                        "concreteType": "HelpObjectStoreArticleMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isExternal"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreArticleSearchResults"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreSearchError"
    }, v13 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreRequestTypeSearchResults"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpObjectSearchResultsQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpObjectSearchResultsQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "22d74b35331ccd017c3ac7fdd5f5d4bf2a7c5d16d649afd374497eb56f2df43e",
            "metadata": {},
            "name": "helpObjectSearchResultsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$814331fc6ad9e2be$var$node.hash = "6a19867fd32836b788744dc62a5ce984";
var $814331fc6ad9e2be$export$2e2bcd8739ae039 = $814331fc6ad9e2be$var$node;

});

parcelRegister("4ZEu0", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b99c7781efe63299$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $b99c7781efe63299$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    emptyStateTitle: {
        id: 'company-hub.help-object-search-component.empty-title',
        defaultMessage: "We couldn't find a match for your search",
        description: 'Text displayed in the dialog when no results are found during the search.'
    },
    emptyStateDescription: {
        id: 'company-hub.help-object-search-component.empty-description',
        defaultMessage: 'Check for typos, or try another search term.',
        description: 'Text displayed in the search dialog to guide users when there are no results.'
    },
    errorTitle: {
        id: 'company-hub.help-object-search-component.error-title',
        defaultMessage: "We're having trouble getting your results.",
        description: 'Text displayed in the dialog when an error occurs during the search.'
    },
    errorDescription: {
        id: 'company-hub.help-object-search-component.error-description',
        defaultMessage: 'Try again later',
        description: 'Text displayed in the search dialog to guide users when there is an error.'
    },
    resourcesHeading: {
        id: 'company-hub.help-object-search-component.resources-heading',
        defaultMessage: 'Resources',
        description: 'Heading for the resources section in search results.'
    },
    requestFormsHeading: {
        id: 'company-hub.help-object-search-component.request-forms-heading',
        defaultMessage: 'Request forms',
        description: 'Heading for the request forms section in search results.'
    }
});

});




parcelRegister("gZY1O", function(module, exports) {
$parcel$export(module.exports, "JSM_HELP_EXTENSION_TYPE", () => $533fcb0c62b8faa4$export$62b7ac1cc8a8f8d7);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_KEY", () => $533fcb0c62b8faa4$export$b5a30704f903627a);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE", () => $533fcb0c62b8faa4$export$5eecea5c34e4d0ec);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_VERSION_1", () => $533fcb0c62b8faa4$export$42fa33c628980eca);
$parcel$export(module.exports, "PAGE_SIZE", () => $533fcb0c62b8faa4$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "SourceType", () => $533fcb0c62b8faa4$export$d95e7684b6658cc2);
const $533fcb0c62b8faa4$export$62b7ac1cc8a8f8d7 = 'com.atlassian.hub.jsm-help';
const $533fcb0c62b8faa4$export$b5a30704f903627a = 'jsm-help';
const $533fcb0c62b8faa4$export$727d928d273126f1 = 'jsmHelpExtension';
const $533fcb0c62b8faa4$export$5eecea5c34e4d0ec = 'jsmHelpExtensionConfig';
const $533fcb0c62b8faa4$export$42fa33c628980eca = '1.0.0';
const $533fcb0c62b8faa4$export$8ec3d08588d2eeda = 9;
const $533fcb0c62b8faa4$export$93c0382b74e40ff9 = {
    SMALL: 'small',
    LARGE: 'large'
};
const $533fcb0c62b8faa4$export$d95e7684b6658cc2 = {
    COMMON_REQUESTS: 'common-requests',
    KB_ARTICLES: 'kb-articles',
    MANUAL: 'manual',
    PORTAL_CARDS: 'portal-cards',
    PORTAL_GROUPS: 'portal-groups'
};

});

parcelRegister("iygPU", function(module, exports) {
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_KEY", () => $e75343b33d1706a7$export$5eb13835d9fc35c6);
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_TYPE", () => $e75343b33d1706a7$export$1e0076557b3776e7);
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_ANALYTIC_SOURCE", () => $e75343b33d1706a7$export$bbe74ef6b7213123);
// Constants are renamed from PAGE_TOPPER prefix to CALLOUT_BANNER in anticipation of the extension rename to callout banner.
// Leaving the extension and type strings as page-topper, however, as the extension has already been added to a few instances
const $e75343b33d1706a7$export$5eb13835d9fc35c6 = 'page-topper';
const $e75343b33d1706a7$export$1e0076557b3776e7 = 'com.atlassian.confluence.page-topper';
const $e75343b33d1706a7$export$bbe74ef6b7213123 = 'calloutBannerExtension';

});

parcelRegister("4foXH", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("avO2M"),
    $j9MRt("gcuLe"),
    $j9MRt("9olHN"),
    $j9MRt("cJxC9"),
    $j9MRt("2aVzU"),
    $j9MRt("ldNUV"),
    $j9MRt("eacO3"),
    $j9MRt("9gmbi"),
    $j9MRt("6cXY2"),
    $j9MRt("fRT89"),
    $j9MRt("hfql0"),
    $j9MRt("imhcw"),
    $j9MRt("7UfmT"),
    $j9MRt("biANn"),
    $j9MRt("1SH30"),
    $j9MRt("6V15u")
]).then(()=>parcelRequire('hEa3t'));

});

parcelRegister("dNK8n", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("fNl1K"),
    $j9MRt("gcuLe"),
    $j9MRt("cJxC9"),
    $j9MRt("1Gg2Z"),
    $j9MRt("6cXY2"),
    $j9MRt("fRT89"),
    $j9MRt("hfql0"),
    $j9MRt("imhcw"),
    $j9MRt("5WsnM"),
    $j9MRt("7UfmT"),
    $j9MRt("biANn"),
    $j9MRt("hcxtc"),
    $j9MRt("1SH30"),
    $j9MRt("igJO6")
]).then(()=>parcelRequire('ahDqd'));

});

parcelRegister("bFYmI", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("i5fM3"),
    $j9MRt("cpj1W"),
    $j9MRt("gcuLe"),
    $j9MRt("9olHN"),
    $j9MRt("cJxC9"),
    $j9MRt("iyzIF"),
    $j9MRt("1b62v"),
    $j9MRt("ldNUV"),
    $j9MRt("k9PE9"),
    $j9MRt("1Seuf"),
    $j9MRt("217Xp"),
    $j9MRt("9gmbi"),
    $j9MRt("6cXY2"),
    $j9MRt("fRT89"),
    $j9MRt("hfql0"),
    $j9MRt("imhcw"),
    $j9MRt("5WsnM"),
    $j9MRt("7UfmT"),
    $j9MRt("biANn"),
    $j9MRt("hcxtc"),
    $j9MRt("1SH30"),
    $j9MRt("jplOj"),
    $j9MRt("g4FEF")
]).then(()=>parcelRequire('4wtWL'));

});


parcelRegister("a6SQV", function(module, exports) {
$parcel$export(module.exports, "AiCornerAgentRenderer", () => $742f504b93efd7ca$export$93c28c6c94b1d8af);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $eqrq1 = parcelRequire("eqrq1");
var $3C9wC = parcelRequire("3C9wC");
var $jquW8 = parcelRequire("jquW8");
const $742f504b93efd7ca$export$93c28c6c94b1d8af = ()=>{
    const aiWidgetConfig = (0, $jquW8.useOptionalAiWidgetConfig)();
    const supportWidgetConfig = aiWidgetConfig === null || aiWidgetConfig === void 0 ? void 0 : aiWidgetConfig.supportWidgetConfig;
    const isSSR = typeof window !== 'undefined' && !!window.__SSR_RENDERED__;
    const showCornerAgent = Boolean(!isSSR && supportWidgetConfig && supportWidgetConfig.isEnabled && (0, $3C9wC.handleWidgetPosition)(supportWidgetConfig.widgetPosition) === 'CORNER');
    return showCornerAgent ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $eqrq1.AiCornerAgentWithContext), {}) : null;
};

});
parcelRegister("eqrq1", function(module, exports) {
$parcel$export(module.exports, "AiSearchTriggerWithContext", () => $6f9339b488b52d31$export$ee4cebdd26cd9fad);
$parcel$export(module.exports, "AiSearchTriggerFloatingWithContext", () => $6f9339b488b52d31$export$48844b0016715530);
$parcel$export(module.exports, "AiCornerAgentWithContext", () => $6f9339b488b52d31$export$53048ab92eeb2224);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $jquW8 = parcelRequire("jquW8");

var $c1KOK = parcelRequire("c1KOK");

var $79cWB = parcelRequire("79cWB");
const $6f9339b488b52d31$export$ee4cebdd26cd9fad = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $jquW8.useAiWidgetConfig)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $79cWB.AiSearchTrigger), {
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $6f9339b488b52d31$export$48844b0016715530 = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $jquW8.useAiWidgetConfig)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $79cWB.AiSearchTriggerFloating), {
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $6f9339b488b52d31$export$53048ab92eeb2224 = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $jquW8.useAiWidgetConfig)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $c1KOK.AiCornerAgent), {
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId
    });
};

});
parcelRegister("c1KOK", function(module, exports) {
$parcel$export(module.exports, "AiCornerAgent", () => $c7a8911949078f98$export$df8fdfe108711d3f);

var $8P7DW = parcelRequire("8P7DW");

var $jZXh9 = parcelRequire("jZXh9");
const $c7a8911949078f98$export$df8fdfe108711d3f = ({ site: site, siteId: siteId, widgetId: widgetId })=>{
    (0, $8P7DW.useEffect)(()=>{
        (0, $jZXh9.initCSM)({
            site: site,
            siteId: siteId,
            widgetId: widgetId
        });
    }, [
        site,
        siteId,
        widgetId
    ]);
    return null;
};

});
parcelRegister("jZXh9", function(module, exports) {
$parcel$export(module.exports, "initCSM", () => $a5049ea689f8c98c$export$a161b0281c42400f);

var $2nrNX = parcelRequire("2nrNX");

var $2E70C = parcelRequire("2E70C");

var $baYXw = parcelRequire("baYXw");
const $a5049ea689f8c98c$var$belowDialog = (0, $2nrNX.layers).dialog() - 1;
const $a5049ea689f8c98c$export$a161b0281c42400f = ({ site: siteProp, siteId: siteId, widgetId: widgetId })=>{
    let site = siteProp ?? (typeof window !== 'undefined' && window.location.hostname);
    if (!site) return;
    if (site === 'localhost') // if in development and window.location.hostname === 'localhost'
    // we set it to the testing instance's site url. Change if using different one than the one below
    site = 'support-ccp.jira-dev.com';
    (0, $baYXw.CSM)({
        site: site,
        siteId: siteId,
        widgetId: widgetId
    });
    // Ensures the widget does not render on top of dialogs (e.g., search).
    (0, $2E70C.update)({
        zIndex: $a5049ea689f8c98c$var$belowDialog
    });
};

});
parcelRegister("2E70C", function(module, exports) {
$parcel$export(module.exports, "open", () => $98a6ffb4394fedfe$export$3ce6949f20cea765);
$parcel$export(module.exports, "hide", () => $98a6ffb4394fedfe$export$fe8985bb6374093c);
$parcel$export(module.exports, "show", () => $98a6ffb4394fedfe$export$57bf213be019eeb0);
$parcel$export(module.exports, "update", () => $98a6ffb4394fedfe$export$722fbec263ad908a);
$parcel$export(module.exports, "createNewConversation", () => $98a6ffb4394fedfe$export$319172c070d96d91);
$parcel$export(module.exports, "onOpen", () => $98a6ffb4394fedfe$export$16688e2160da47bd);
$parcel$export(module.exports, "onClose", () => $98a6ffb4394fedfe$export$f312d3bc7ef841a8);
$parcel$export(module.exports, "getCurrentConversation", () => $98a6ffb4394fedfe$export$8862049f62228856);
const $98a6ffb4394fedfe$var$createCommand = (command)=>{
    const fn = (...args)=>{
        if (typeof window === 'undefined' || !window.CSM) {
            // eslint-disable-next-line no-console
            console.warn('CSM SDK has not been loaded!');
            return;
        }
        // @ts-ignore i give up
        window.CSM(command, ...args);
    };
    return fn;
};
const $98a6ffb4394fedfe$export$3ce6949f20cea765 = $98a6ffb4394fedfe$var$createCommand('open');
const $98a6ffb4394fedfe$export$8360e631d277ea4d = $98a6ffb4394fedfe$var$createCommand('close');
const $98a6ffb4394fedfe$export$fe8985bb6374093c = $98a6ffb4394fedfe$var$createCommand('hide');
const $98a6ffb4394fedfe$export$57bf213be019eeb0 = $98a6ffb4394fedfe$var$createCommand('show');
const $98a6ffb4394fedfe$export$722fbec263ad908a = $98a6ffb4394fedfe$var$createCommand('update');
const $98a6ffb4394fedfe$export$319172c070d96d91 = $98a6ffb4394fedfe$var$createCommand('createNewConversation');
const $98a6ffb4394fedfe$export$16688e2160da47bd = $98a6ffb4394fedfe$var$createCommand('onOpen');
const $98a6ffb4394fedfe$export$f312d3bc7ef841a8 = $98a6ffb4394fedfe$var$createCommand('onClose');
const $98a6ffb4394fedfe$export$8862049f62228856 = $98a6ffb4394fedfe$var$createCommand('getCurrentConversation');

});

parcelRegister("baYXw", function(module, exports) {
$parcel$export(module.exports, "CSM", () => $a021e4e5af57920a$export$e20267fb524e653f);

var $eGv7i = parcelRequire("eGv7i");

var $5UM3i = parcelRequire("5UM3i");
const $a021e4e5af57920a$export$e20267fb524e653f = ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId })=>{
    if (typeof window === 'undefined') return;
    if (typeof window.CSM === 'undefined') window.CSM = (0, $eGv7i.createSDKQueue)();
    (0, $5UM3i.loadCSMSDK)({
        site: site,
        siteId: siteId,
        cloudId: cloudId,
        widgetId: widgetId
    });
};

});
parcelRegister("eGv7i", function(module, exports) {
$parcel$export(module.exports, "createSDKQueue", () => $41c271501e514ee6$export$7bcdf693772d0a65);
const $41c271501e514ee6$export$7bcdf693772d0a65 = ()=>{
    const q = function CMSQueue(...args) {
        q.__q__.push(args);
    };
    q.__q__ = [];
    return q;
};

});

parcelRegister("5UM3i", function(module, exports) {
$parcel$export(module.exports, "loadCSMSDK", () => $76b1843f5e0291d0$export$6aed1f3cc6c8351e);

var $2YtDl = parcelRequire("2YtDl");

var $a0p1W = parcelRequire("a0p1W");
let $76b1843f5e0291d0$var$promise = null;
const $76b1843f5e0291d0$var$NOOP = ()=>{};
const $76b1843f5e0291d0$export$6aed1f3cc6c8351e = ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId, debug: debug = $76b1843f5e0291d0$var$NOOP })=>{
    if (!$76b1843f5e0291d0$var$promise) $76b1843f5e0291d0$var$promise = new Promise((resolve, reject)=>{
        if (typeof window === 'undefined') {
            debug({
                message: '[SDKLoader]: window is undefined'
            });
            reject(new Error('Failed to load CSM SDK: window is undefined'));
        }
        if (window.CSM && !('__q__' in window.CSM)) {
            debug({
                message: '[SDKLoader]: window.CSM already exists'
            });
            resolve(window.CSM);
        }
        const script = document.createElement('script');
        script.src = (0, $2YtDl.getSDKSrc)({
            site: site,
            siteId: siteId,
            cloudId: cloudId,
            widgetId: widgetId
        });
        script.setAttribute('async', '');
        script.type = 'text/javascript';
        script.onerror = ()=>{
            reject(new Error('Failed to load CSM SDK script: onerror'));
        };
        script.onload = ()=>{
            debug({
                message: '[SDKLoader]: script onload called'
            });
            if (window.CSM && !('__q__' in window.CSM)) {
                debug({
                    message: '[SDKLoader]: CSM SDK found after script onload'
                });
                resolve(window.CSM);
            } else {
                debug({
                    message: '[SDKLoader]: CSM SDK not found after script onload'
                });
                reject(new Error('Failed to load CSM SDK: window.CSM is undefined'));
            }
        };
        debug({
            message: '[SDKLoader]: CSM SDK appended to body'
        });
        document.body.appendChild(script);
        /**
       * Preconnect to initialise the connection ahead of loading any iframe
       * which will load static assets from the JCS widget domain.
       */ const link = document.createElement('link');
        const linkHref = (0, $a0p1W.getPreconnectHref)(site);
        link.rel = 'preconnect';
        link.href = linkHref;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
        debug({
            message: `[SDKLoader]: CSM SDK preconnecting to ${linkHref}`
        });
    });
    return $76b1843f5e0291d0$var$promise;
};

});
parcelRegister("2YtDl", function(module, exports) {
$parcel$export(module.exports, "getSDKSrc", () => $242fc54b9a68c371$export$80f32c89482836ae);
const $242fc54b9a68c371$export$80f32c89482836ae = ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId })=>{
    const url = new URL(`/csm/widget/script.js`, `https://${site}`);
    if (siteId) {
        url.searchParams.set('siteId', siteId);
        url.searchParams.set('site', site);
    }
    if (cloudId) {
        url.searchParams.set('cloudId', cloudId);
        url.searchParams.set('site', site);
    }
    if (widgetId) url.searchParams.set('widgetId', widgetId);
    return url.toString();
};

});

parcelRegister("a0p1W", function(module, exports) {
$parcel$export(module.exports, "getPreconnectHref", () => $1414ba4931bd5a09$export$270686f4186620fa);
const $1414ba4931bd5a09$var$JCS_WIDGET_DOMAIN_PROD = 'https://jcs-chat-widget.atlassian.com';
const $1414ba4931bd5a09$var$JCS_WIDGET_DOMAIN_STG = 'https://jcs-chat-widget.stg.atlassian.com';
const $1414ba4931bd5a09$export$270686f4186620fa = (site)=>{
    return /jira-dev\.com/.test(site) ? $1414ba4931bd5a09$var$JCS_WIDGET_DOMAIN_STG : $1414ba4931bd5a09$var$JCS_WIDGET_DOMAIN_PROD;
};

});





parcelRegister("79cWB", function(module, exports) {
$parcel$export(module.exports, "AiSearchTrigger", () => $847db59b825f0992$export$999e3594add7a0eb);
$parcel$export(module.exports, "AiSearchTriggerFloating", () => $847db59b825f0992$export$950284a1ac54bad5);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $1NJBM = parcelRequire("1NJBM");

var $49pn5 = parcelRequire("49pn5");

var $2E70C = parcelRequire("2E70C");

var $7J2wO = parcelRequire("7J2wO");

var $cHQ7t = parcelRequire("cHQ7t");
const $847db59b825f0992$var$floatingBoxPositionStyles = null;
const $847db59b825f0992$var$AiSearchTriggerBase = ()=>{
    const { ref: ref } = (0, $7J2wO.useTriggerIntersectionObserver)();
    return /*#__PURE__*/ (0, $gWgPx.jsx)($847db59b825f0992$var$ConnectedAiSearchInput, {
        ref: ref
    });
};
const $847db59b825f0992$var$hiddenToBottomStyles = null;
const $847db59b825f0992$var$hiddenToRightStyles = null;
/**
 * Connected "smart" UI component
 *
 * This component is connected to the AI search context and will update the value and onChange
 * functions when the user types in the input.
 *
 * It also handles the submission of the form and the creation of a new conversation.
 *
 * @private
 */ const $847db59b825f0992$var$ConnectedAiSearchInput = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ className: className, hidden: hiddenByProp }, ref)=>{
    const { isTriggerVisible: isTriggerVisible } = (0, $7J2wO.useSearchTriggerVisibility)();
    const { value: value, onChange: onChange } = (0, $7J2wO.useAiSearch)();
    const hideTrigger = hiddenByProp || !isTriggerVisible;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cHQ7t.AiSearchInput), {
        ref: ref,
        hidden: hideTrigger,
        // eslint-disable-next-line
        className: (0, $8n1kL.default)([
            hiddenByProp && "_t9ecdgi6",
            !isTriggerVisible && "_t9ec14jq",
            className
        ]),
        value: value,
        onChange: onChange,
        onSubmit: ({ message: message })=>{
            (0, $2E70C.show)();
            (0, $2E70C.open)();
            (0, $2E70C.createNewConversation)(typeof message === 'string' && message.length > 0 ? {
                message: message
            } : {});
            onChange('');
        }
    });
});
const $847db59b825f0992$var$ConditionalThemeProvider = ({ children: children, themeConfig: themeConfig })=>{
    if (themeConfig) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $49pn5.ThemeProvider), {
        themeConfig: themeConfig,
        children: children
    });
    return children;
};
const $847db59b825f0992$export$999e3594add7a0eb = ({ site: site, siteId: siteId, widgetId: widgetId, widgetTheme: widgetTheme })=>/*#__PURE__*/ (0, $gWgPx.jsx)($847db59b825f0992$var$ConditionalThemeProvider, {
        themeConfig: widgetTheme,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7J2wO.AiSearchTriggerContainer), {
            site: site,
            siteId: siteId,
            widgetId: widgetId,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)($847db59b825f0992$var$AiSearchTriggerBase, {})
        })
    });
/**
 * The connected search trigger but connected to the store to hide
 * if there is a visible `AiSearchTrigger` in the viewport
 *
 * @private
 */ const $847db59b825f0992$var$AiSearchTriggerFloatingBase = ()=>{
    const [mounted, setMounted] = (0, $8P7DW.useState)(false);
    const hasIntersectingTrigger = (0, $7J2wO.useHasIntersectingTrigger)();
    const isHidden = !mounted || hasIntersectingTrigger;
    (0, $8P7DW.useLayoutEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0, $gWgPx.jsx)($847db59b825f0992$var$ConnectedAiSearchInput, {
        hidden: isHidden,
        className: (0, $8n1kL.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _kqsw1n9t _1ltvidpf _1xi2idpf _94n5xy5q _1pby16oo"
        ])
    });
};
const $847db59b825f0992$export$950284a1ac54bad5 = ({ site: site, siteId: siteId, widgetId: widgetId, widgetTheme: widgetTheme })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $1NJBM.default), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)($847db59b825f0992$var$ConditionalThemeProvider, {
            themeConfig: widgetTheme,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7J2wO.AiSearchTriggerContainer), {
                site: site,
                siteId: siteId,
                widgetId: widgetId,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)($847db59b825f0992$var$AiSearchTriggerFloatingBase, {})
            })
        })
    });

});
parcelRegister("49pn5", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $02a2798c7ca6de94$export$d8964aec282183a3);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6mQfL = parcelRequire("6mQfL");

var $kVlIs = parcelRequire("kVlIs");

var $jvEsT = parcelRequire("jvEsT");

var $cNrD0 = parcelRequire("cNrD0");
const $02a2798c7ca6de94$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);
const $02a2798c7ca6de94$export$93d4e7f90805808f = ()=>{
    const context = (0, $8P7DW.useContext)($02a2798c7ca6de94$export$2c657da244d00bd6);
    if (!context) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};
const $02a2798c7ca6de94$export$d8964aec282183a3 = ({ children: children, themeConfig: themeConfig, styles: styles = {} })=>{
    if (!themeConfig) throw new Error('themeConfig is required for the CSM Branding to works');
    const themeStyles = (0, $cNrD0.useGenerateThemeBranding)(themeConfig);
    const tokenStyles = (0, $8P7DW.useMemo)(()=>{
        const { borderRadius: borderRadius, space: space, colorRamps: colorRamps } = themeStyles;
        const iconColor = (0, $jvEsT.getContrastYIQ)(themeConfig.primaryColor) === 'dark' ? '#FFFFFF' : '#000000';
        const brandColor = (0, $kVlIs.deriveBrandColors)(colorRamps, themeConfig.primaryColor);
        const properties = {
            [(0, $6mQfL.csmAiTokens)['color.100']]: colorRamps.color100,
            [(0, $6mQfL.csmAiTokens)['color.200']]: colorRamps.color200,
            [(0, $6mQfL.csmAiTokens)['color.300']]: colorRamps.color300,
            [(0, $6mQfL.csmAiTokens)['color.400']]: colorRamps.color400,
            [(0, $6mQfL.csmAiTokens)['color.500']]: colorRamps.color500,
            [(0, $6mQfL.csmAiTokens)['color.600']]: colorRamps.color600,
            [(0, $6mQfL.csmAiTokens)['color.700']]: colorRamps.color700,
            [(0, $6mQfL.csmAiTokens)['color.800']]: colorRamps.color800,
            [(0, $6mQfL.csmAiTokens)['color.900']]: colorRamps.color900,
            [(0, $6mQfL.csmAiTokens)['color.1000']]: colorRamps.color1000,
            [(0, $6mQfL.csmAiTokens)['color.icon']]: iconColor,
            [(0, $6mQfL.csmAiTokens)['color.brand']]: brandColor.brand,
            [(0, $6mQfL.csmAiTokens)['color.brand.hover']]: brandColor.hover,
            [(0, $6mQfL.csmAiTokens)['color.brand.active']]: brandColor.active,
            [(0, $6mQfL.csmAiTokens)['color.brand.text']]: brandColor.brandText,
            [(0, $6mQfL.csmAiTokens)['color.brand.hover.text']]: brandColor.hoverText,
            [(0, $6mQfL.csmAiTokens)['color.brand.active.text']]: brandColor.activeText,
            [(0, $6mQfL.csmAiTokens)['border.radius.lg']]: borderRadius.lg,
            [(0, $6mQfL.csmAiTokens)['border.radius.md']]: borderRadius.md,
            [(0, $6mQfL.csmAiTokens)['border.radius.sm']]: borderRadius.sm,
            [(0, $6mQfL.csmAiTokens)['border.radius.container']]: borderRadius.container,
            [(0, $6mQfL.csmAiTokens)['border.radius.widget']]: borderRadius.widget,
            [(0, $6mQfL.csmAiTokens)['space.lg']]: space.lg,
            [(0, $6mQfL.csmAiTokens)['space.md']]: space.md,
            [(0, $6mQfL.csmAiTokens)['space.sm']]: space.sm
        };
        return properties;
    }, [
        themeConfig.primaryColor,
        themeStyles
    ]);
    const combineStyles = {
        ...tokenStyles,
        ...styles,
        // Use inline to ensure the wrapper won't mess with the style calculation
        // of the children (e.g. height calculation of the children)
        display: 'inline'
    };
    return /*#__PURE__*/ (0, $gWgPx.jsx)($02a2798c7ca6de94$export$2c657da244d00bd6.Provider, {
        value: themeStyles,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
            style: combineStyles,
            children: children
        })
    });
};

});
parcelRegister("6mQfL", function(module, exports) {
$parcel$export(module.exports, "csmAiTokens", () => $5ffa6671a9d69f22$export$e26bc1991ee46534);
const $5ffa6671a9d69f22$export$e26bc1991ee46534 = {
    'color.100': '--csm-color-100',
    'color.200': '--csm-color-200',
    'color.300': '--csm-color-300',
    'color.400': '--csm-color-400',
    'color.500': '--csm-color-500',
    'color.600': '--csm-color-600',
    'color.700': '--csm-color-700',
    'color.800': '--csm-color-800',
    'color.900': '--csm-color-900',
    'color.1000': '--csm-color-1000',
    'color.icon': '--csm-color-icon',
    'color.brand': '--csm-color-brand',
    'color.brand.hover': '--csm-color-brand-hover',
    'color.brand.active': '--csm-color-brand-active',
    'color.brand.text': '--csm-color-brand-text',
    'color.brand.hover.text': '--csm-color-brand-hover-text',
    'color.brand.active.text': '--csm-color-brand-active-text',
    'border.radius.lg': '--csm-border-radius-lg',
    'border.radius.md': '--csm-border-radius-md',
    'border.radius.sm': '--csm-border-radius-sm',
    'border.radius.container': '--csm-border-radius-container',
    'border.radius.widget': '--csm-border-radius-widget',
    'space.lg': '--csm-space-lg',
    'space.md': '--csm-space-md',
    'space.sm': '--csm-space-sm'
};

});

parcelRegister("kVlIs", function(module, exports) {
$parcel$export(module.exports, "deriveBrandColors", () => $7ff253fb7cb15594$export$56e08ca4c9e5e798);

var $jvEsT = parcelRequire("jvEsT");
const $7ff253fb7cb15594$var$clampRamp = (n)=>{
    const v = Math.max(100, Math.min(1000, n));
    return v;
};
const $7ff253fb7cb15594$var$buildRampMap = (r)=>new Map([
        [
            100,
            r.color100
        ],
        [
            200,
            r.color200
        ],
        [
            300,
            r.color300
        ],
        [
            400,
            r.color400
        ],
        [
            500,
            r.color500
        ],
        [
            600,
            r.color600
        ],
        [
            700,
            r.color700
        ],
        [
            800,
            r.color800
        ],
        [
            900,
            r.color900
        ],
        [
            1000,
            r.color1000
        ]
    ]);
const $7ff253fb7cb15594$var$textOn = (hex)=>(0, $jvEsT.getContrastYIQ)(hex) === 'dark' ? '#FFFFFF' : '#000000';
const $7ff253fb7cb15594$export$56e08ca4c9e5e798 = (ramps, primaryColor)=>{
    const rampMap = $7ff253fb7cb15594$var$buildRampMap(ramps);
    const target = primaryColor.toLowerCase();
    let baseRamp = 400;
    for (const [n, hex] of rampMap)if (hex.toLowerCase() === target) {
        baseRamp = n;
        break;
    }
    const goLighter = baseRamp >= 800;
    const hoverRamp = $7ff253fb7cb15594$var$clampRamp(baseRamp + (goLighter ? -200 : 200));
    const activeRamp = $7ff253fb7cb15594$var$clampRamp(baseRamp + (goLighter ? -300 : 300));
    const brand = rampMap.get(baseRamp);
    const hover = rampMap.get(hoverRamp);
    const active = rampMap.get(activeRamp);
    return {
        brand: brand,
        hover: hover,
        active: active,
        brandText: $7ff253fb7cb15594$var$textOn(brand),
        hoverText: $7ff253fb7cb15594$var$textOn(hover),
        activeText: $7ff253fb7cb15594$var$textOn(active)
    };
};

});
parcelRegister("jvEsT", function(module, exports) {
$parcel$export(module.exports, "getContrastYIQ", () => $7db6ff0168b646d5$export$5f6ad4d710455f9b);
const $7db6ff0168b646d5$var$hexToRgb = (hex)=>{
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `rgb(${$7db6ff0168b646d5$var$hexToInt(result, 1)}, ${$7db6ff0168b646d5$var$hexToInt(result, 2)},${$7db6ff0168b646d5$var$hexToInt(result, 3)})` : null;
};
const $7db6ff0168b646d5$var$hexToInt = (arr, index)=>parseInt(arr[index], 16);
const $7db6ff0168b646d5$export$5f6ad4d710455f9b = (hex)=>{
    const rgb = $7db6ff0168b646d5$var$hexToRgb(hex);
    const modifyRgb = rgb ? rgb.substring(4, rgb.length - 1).replace(/ /g, '').split(',') : [];
    const yiq = modifyRgb !== null && modifyRgb !== void 0 && modifyRgb.length ? (Number(modifyRgb[0]) * 299 + Number(modifyRgb[1]) * 587 + Number(modifyRgb[2]) * 114) / 1000 : 0;
    return yiq >= 128 ? 'light' : 'dark';
};

});


parcelRegister("cNrD0", function(module, exports) {
$parcel$export(module.exports, "useGenerateThemeBranding", () => $2f2a1f6035b92c36$export$4be1c3ef709f1b04);

var $8P7DW = parcelRequire("8P7DW");

var $hgU0X = parcelRequire("hgU0X");
const $2f2a1f6035b92c36$export$4be1c3ef709f1b04 = (themeConfig)=>{
    return (0, $8P7DW.useMemo)(()=>{
        const theme = (0, $hgU0X.generateThemeBranding)(themeConfig);
        return theme;
    }, [
        themeConfig
    ]);
};

});
parcelRegister("hgU0X", function(module, exports) {
$parcel$export(module.exports, "generateThemeBranding", () => $90d2f9ac4d40b8b6$export$c1410db1c88d6e0f);

var $57Qbv = parcelRequire("57Qbv");
// Values are taken from figma [design](https://www.figma.com/design/sxl0BlQxD2g2eU27Rl2VhG/CSM-X-Loom-Support---In-Product?node-id=2351-34333&t=d8zOoCnHa3EJORFr-4), some are guesstimated
const $90d2f9ac4d40b8b6$var$BORDER_RADIUS = {
    sharp: {
        lg: '8px',
        md: '4px',
        sm: '2px',
        container: '12px',
        widget: '12px'
    },
    normal: {
        lg: '10px',
        md: '6px',
        sm: '4px',
        container: '18px',
        widget: '18px'
    },
    rounded: {
        lg: '12px',
        md: '10px',
        sm: '6px',
        container: '22px',
        widget: '100%'
    }
};
const $90d2f9ac4d40b8b6$var$SPACE = {
    cosy: {
        lg: '12px',
        md: '8px',
        sm: '8px'
    },
    comfortable: {
        lg: '16px',
        md: '12px',
        sm: '8px'
    },
    generous: {
        lg: '24px',
        md: '16px',
        sm: '8px'
    }
};
const $90d2f9ac4d40b8b6$export$c1410db1c88d6e0f = (themeConfig)=>{
    const { radius: radius, space: space, primaryColor: primaryColor } = themeConfig;
    const colorRamps = (0, $57Qbv.generateColorRamps)(primaryColor);
    const borderRadius = $90d2f9ac4d40b8b6$var$BORDER_RADIUS[radius] || $90d2f9ac4d40b8b6$var$BORDER_RADIUS.normal;
    const themeSpace = $90d2f9ac4d40b8b6$var$SPACE[space] || $90d2f9ac4d40b8b6$var$SPACE.comfortable;
    return {
        colorRamps: colorRamps,
        borderRadius: borderRadius,
        space: themeSpace
    };
};

});
parcelRegister("57Qbv", function(module, exports) {
$parcel$export(module.exports, "generateColorRamps", () => $1bd20a0a91c3e02f$export$3a180ce5632a9d57);

var $ehTEk = parcelRequire("ehTEk");

var $a7GET = parcelRequire("a7GET");

var $fkQhC = parcelRequire("fkQhC");

var $iK9YW = parcelRequire("iK9YW");
const $1bd20a0a91c3e02f$var$lowLuminanceContrastRatios = [
    1.12,
    1.33,
    2.03,
    2.73,
    3.33,
    4.27,
    5.2,
    6.62,
    12.46,
    14.25
];
const $1bd20a0a91c3e02f$var$highLuminanceContrastRatios = [
    1.08,
    1.24,
    1.55,
    1.99,
    2.45,
    3.34,
    4.64,
    6.1,
    10.19,
    12.6
];
const $1bd20a0a91c3e02f$export$b102e016d69678f3 = (themeRamp, brandColor)=>{
    // Iterate over themeRamp and find whichever color is closest to brandColor
    let closestColorIndex = 0;
    let closestColorDistance = null;
    themeRamp.forEach((value, index)=>{
        const distance = (0, $ehTEk.deltaE)((0, $ehTEk.hexToRgb)(value), (0, $ehTEk.hexToRgb)(brandColor));
        if (closestColorDistance === null || distance < closestColorDistance) {
            closestColorIndex = index;
            closestColorDistance = distance;
        }
    });
    return closestColorIndex;
};
const $1bd20a0a91c3e02f$export$253cd51ce7d49924 = (brandColor)=>{
    // Determine luminance
    const HSLBrandColorHue = (0, $ehTEk.hexToHSL)(brandColor)[0];
    const baseRgb = (0, $ehTEk.HSLToRGB)(HSLBrandColorHue, 100, 60);
    const isLowLuminance = (0, $ehTEk.relativeLuminanceW3C)(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
    // Choose right palette
    const themeRatios = isLowLuminance ? $1bd20a0a91c3e02f$var$lowLuminanceContrastRatios : $1bd20a0a91c3e02f$var$highLuminanceContrastRatios;
    const brandRgba = (0, $ehTEk.hexToRgbA)(brandColor);
    const hctColor = (0, $iK9YW.Hct).fromInt((0, $a7GET.argbFromRgba)({
        r: brandRgba[0],
        g: brandRgba[1],
        b: brandRgba[2],
        a: brandRgba[3]
    }));
    const themeRamp = themeRatios.map((contrast)=>{
        const rgbaColor = (0, $a7GET.rgbaFromArgb)((0, $iK9YW.Hct).from(hctColor.hue, hctColor.chroma, (0, $fkQhC.Contrast).darker(100, contrast) + 0.25 // Material's utils provide an offset
        ).toInt());
        return (0, $ehTEk.rgbToHex)(rgbaColor.r, rgbaColor.g, rgbaColor.b);
    });
    const closestColorIndex = $1bd20a0a91c3e02f$export$b102e016d69678f3(themeRamp, brandColor);
    // Replace closet color with brandColor
    const updatedThemeRamp = [
        ...themeRamp
    ];
    updatedThemeRamp[closestColorIndex] = brandColor;
    return updatedThemeRamp;
};
const $1bd20a0a91c3e02f$export$3a180ce5632a9d57 = (primaryColor)=>{
    const colors = $1bd20a0a91c3e02f$export$253cd51ce7d49924(primaryColor);
    return {
        color100: colors[0],
        color200: colors[1],
        color300: colors[2],
        color400: colors[3],
        color500: colors[4],
        color600: colors[5],
        color700: colors[6],
        color800: colors[7],
        color900: colors[8],
        color1000: colors[9]
    };
};

});
parcelRegister("ehTEk", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $b736cdf8c8fb1983$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $b736cdf8c8fb1983$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $b736cdf8c8fb1983$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $b736cdf8c8fb1983$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $b736cdf8c8fb1983$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $b736cdf8c8fb1983$export$e770b01b744f3745);
$parcel$export(module.exports, "deltaE", () => $b736cdf8c8fb1983$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $b736cdf8c8fb1983$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $b736cdf8c8fb1983$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $b736cdf8c8fb1983$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $b736cdf8c8fb1983$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $b736cdf8c8fb1983$export$b36dbdb4f463f05c(hex) {
    if (!$b736cdf8c8fb1983$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $b736cdf8c8fb1983$export$1212645cf40ebf71(hex)
    ];
}
function $b736cdf8c8fb1983$export$5a544e13ad4e1fa5(hex) {
    if (!$b736cdf8c8fb1983$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $b736cdf8c8fb1983$export$47ea145a83f50dc0(hex) {
    if (!$b736cdf8c8fb1983$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $b736cdf8c8fb1983$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $b736cdf8c8fb1983$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $b736cdf8c8fb1983$export$d061e26956a60b0a(foreground, background) {
    if (!$b736cdf8c8fb1983$var$isValidHex(foreground) || !$b736cdf8c8fb1983$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $b736cdf8c8fb1983$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $b736cdf8c8fb1983$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $b736cdf8c8fb1983$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $b736cdf8c8fb1983$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $b736cdf8c8fb1983$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $b736cdf8c8fb1983$var$rgbToLab(rgbA);
    let labB = $b736cdf8c8fb1983$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $b736cdf8c8fb1983$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("a7GET", function(module, exports) {
$parcel$export(module.exports, "argbFromLinrgb", () => $c878e27abcdfe014$export$7928ddf440518d19);
$parcel$export(module.exports, "argbFromXyz", () => $c878e27abcdfe014$export$cbbbbc8b222df20);
$parcel$export(module.exports, "linearized", () => $c878e27abcdfe014$export$dec6bcda7bf47f2c);
$parcel$export(module.exports, "argbFromLstar", () => $c878e27abcdfe014$export$ae8c227f6d0cbddb);
$parcel$export(module.exports, "yFromLstar", () => $c878e27abcdfe014$export$7f3071c4a5db05a0);
$parcel$export(module.exports, "lstarFromArgb", () => $c878e27abcdfe014$export$8b8f7ef2e0a71c61);
$parcel$export(module.exports, "lstarFromY", () => $c878e27abcdfe014$export$bfc0d1dd9c64ada2);
$parcel$export(module.exports, "whitePointD65", () => $c878e27abcdfe014$export$d4534a444c6526c3);
$parcel$export(module.exports, "rgbaFromArgb", () => $c878e27abcdfe014$export$fb1fd26c787a8662);
$parcel$export(module.exports, "argbFromRgba", () => $c878e27abcdfe014$export$9128c3a9233ad1fd);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.

var $aIPro = parcelRequire("aIPro");
/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $c878e27abcdfe014$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $c878e27abcdfe014$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $c878e27abcdfe014$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
function $c878e27abcdfe014$export$58a74b9f8e513b7b(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
function $c878e27abcdfe014$export$7928ddf440518d19(linrgb) {
    const r = $c878e27abcdfe014$export$777e26aa2ec02b1(linrgb[0]);
    const g = $c878e27abcdfe014$export$777e26aa2ec02b1(linrgb[1]);
    const b = $c878e27abcdfe014$export$777e26aa2ec02b1(linrgb[2]);
    return $c878e27abcdfe014$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Returns the alpha component of a color in ARGB format.
 */ function $c878e27abcdfe014$var$alphaFromArgb(argb) {
    return argb >> 24 & 255;
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $c878e27abcdfe014$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $c878e27abcdfe014$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $c878e27abcdfe014$var$blueFromArgb(argb) {
    return argb & 255;
}
function $c878e27abcdfe014$export$cbbbbc8b222df20(x, y, z) {
    const matrix = $c878e27abcdfe014$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $c878e27abcdfe014$export$777e26aa2ec02b1(linearR);
    const g = $c878e27abcdfe014$export$777e26aa2ec02b1(linearG);
    const b = $c878e27abcdfe014$export$777e26aa2ec02b1(linearB);
    return $c878e27abcdfe014$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $c878e27abcdfe014$var$xyzFromArgb(argb) {
    const r = $c878e27abcdfe014$export$dec6bcda7bf47f2c($c878e27abcdfe014$var$redFromArgb(argb));
    const g = $c878e27abcdfe014$export$dec6bcda7bf47f2c($c878e27abcdfe014$var$greenFromArgb(argb));
    const b = $c878e27abcdfe014$export$dec6bcda7bf47f2c($c878e27abcdfe014$var$blueFromArgb(argb));
    return $aIPro.matrixMultiply([
        r,
        g,
        b
    ], $c878e27abcdfe014$var$SRGB_TO_XYZ);
}
function $c878e27abcdfe014$export$ae8c227f6d0cbddb(lstar) {
    const y = $c878e27abcdfe014$export$7f3071c4a5db05a0(lstar);
    const component = $c878e27abcdfe014$export$777e26aa2ec02b1(y);
    return $c878e27abcdfe014$export$58a74b9f8e513b7b(component, component, component);
}
function $c878e27abcdfe014$export$8b8f7ef2e0a71c61(argb) {
    const y = $c878e27abcdfe014$var$xyzFromArgb(argb)[1];
    return 116.0 * $c878e27abcdfe014$var$labF(y / 100.0) - 16.0;
}
function $c878e27abcdfe014$export$7f3071c4a5db05a0(lstar) {
    return 100.0 * $c878e27abcdfe014$var$labInvf((lstar + 16.0) / 116.0);
}
function $c878e27abcdfe014$export$bfc0d1dd9c64ada2(y) {
    return $c878e27abcdfe014$var$labF(y / 100.0) * 116.0 - 16.0;
}
function $c878e27abcdfe014$export$dec6bcda7bf47f2c(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
function $c878e27abcdfe014$export$777e26aa2ec02b1(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $aIPro.clampInt(0, 255, Math.round(delinearized * 255.0));
}
function $c878e27abcdfe014$export$d4534a444c6526c3() {
    return $c878e27abcdfe014$var$WHITE_POINT_D65;
}
function $c878e27abcdfe014$export$fb1fd26c787a8662(argb) {
    const r = $c878e27abcdfe014$var$redFromArgb(argb);
    const g = $c878e27abcdfe014$var$greenFromArgb(argb);
    const b = $c878e27abcdfe014$var$blueFromArgb(argb);
    const a = $c878e27abcdfe014$var$alphaFromArgb(argb);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $c878e27abcdfe014$export$9128c3a9233ad1fd({ r: r, g: g, b: b, a: a }) {
    const rValue = $c878e27abcdfe014$var$clampComponent(r);
    const gValue = $c878e27abcdfe014$var$clampComponent(g);
    const bValue = $c878e27abcdfe014$var$clampComponent(b);
    const aValue = $c878e27abcdfe014$var$clampComponent(a);
    return aValue << 24 | rValue << 16 | gValue << 8 | bValue;
}
function $c878e27abcdfe014$var$clampComponent(value) {
    if (value < 0) return 0;
    if (value > 255) return 255;
    return value;
}
function $c878e27abcdfe014$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $c878e27abcdfe014$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}

});
parcelRegister("aIPro", function(module, exports) {
$parcel$export(module.exports, "signum", () => $3c5fb2b46f3a1257$export$23e3e2011c250f0f);
$parcel$export(module.exports, "lerp", () => $3c5fb2b46f3a1257$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "clampInt", () => $3c5fb2b46f3a1257$export$d0498fe3d58e384f);
$parcel$export(module.exports, "clampDouble", () => $3c5fb2b46f3a1257$export$62d511a4580feff);
$parcel$export(module.exports, "sanitizeDegreesDouble", () => $3c5fb2b46f3a1257$export$7417613e514a9e72);
$parcel$export(module.exports, "matrixMultiply", () => $3c5fb2b46f3a1257$export$be586f9fe0391d67);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $3c5fb2b46f3a1257$export$23e3e2011c250f0f(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
function $3c5fb2b46f3a1257$export$3a89f8d6f6bf6c9f(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
function $3c5fb2b46f3a1257$export$d0498fe3d58e384f(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $3c5fb2b46f3a1257$export$62d511a4580feff(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $3c5fb2b46f3a1257$export$7417613e514a9e72(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
function $3c5fb2b46f3a1257$export$be586f9fe0391d67(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}

});


parcelRegister("fkQhC", function(module, exports) {
$parcel$export(module.exports, "Contrast", () => $5cebc70cc65d4ab2$export$656ae42051d0ca86);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace

var $a7GET = parcelRequire("a7GET");

var $aIPro = parcelRequire("aIPro");
class $5cebc70cc65d4ab2$export$656ae42051d0ca86 {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $aIPro.clampDouble(0.0, 100.0, toneA);
        toneB = $aIPro.clampDouble(0.0, 100.0, toneB);
        return $5cebc70cc65d4ab2$export$656ae42051d0ca86.ratioOfYs($a7GET.yFromLstar(toneA), $a7GET.yFromLstar(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $a7GET.yFromLstar(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $5cebc70cc65d4ab2$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $a7GET.lstarFromY(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $a7GET.yFromLstar(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $5cebc70cc65d4ab2$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $a7GET.lstarFromY(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $5cebc70cc65d4ab2$export$656ae42051d0ca86.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $5cebc70cc65d4ab2$export$656ae42051d0ca86.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}

});

parcelRegister("iK9YW", function(module, exports) {
$parcel$export(module.exports, "Hct", () => $7b496e10baf8131b$export$91d2e033b3924566);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $a7GET = parcelRequire("a7GET");

var $aIPro = parcelRequire("aIPro");
class $7b496e10baf8131b$export$91d2e033b3924566 {
    static from(hue, chroma, tone) {
        return new $7b496e10baf8131b$export$91d2e033b3924566($7b496e10baf8131b$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $7b496e10baf8131b$export$91d2e033b3924566(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($7b496e10baf8131b$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($7b496e10baf8131b$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /**
   * Lightness. Ranges from 0 to 100.
   */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($7b496e10baf8131b$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    constructor(argb){
        this.argb = argb;
        const cam = $7b496e10baf8131b$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $a7GET.lstarFromArgb(argb);
        this.argb = argb;
    }
    setInternalState(argb) {
        const cam = $7b496e10baf8131b$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $a7GET.lstarFromArgb(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $7b496e10baf8131b$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $7b496e10baf8131b$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $7b496e10baf8131b$export$159586e3808c6277.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $7b496e10baf8131b$export$91d2e033b3924566.from(recastInVc.hue, recastInVc.chroma, $a7GET.lstarFromY(viewedInVc[1]));
        return recastHct;
    }
}
/**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $7b496e10baf8131b$var$Cam16 {
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $7b496e10baf8131b$var$Cam16.fromIntInViewingConditions(argb, $7b496e10baf8131b$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $a7GET.linearized(red);
        const greenL = $a7GET.linearized(green);
        const blueL = $a7GET.linearized(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $aIPro.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $aIPro.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $aIPro.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $7b496e10baf8131b$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $7b496e10baf8131b$var$Cam16.fromJchInViewingConditions(j, c, h, $7b496e10baf8131b$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $7b496e10baf8131b$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $7b496e10baf8131b$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $7b496e10baf8131b$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $7b496e10baf8131b$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($7b496e10baf8131b$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $aIPro.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $aIPro.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $aIPro.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $a7GET.argbFromXyz(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $aIPro.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $aIPro.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $aIPro.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $7b496e10baf8131b$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $aIPro.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $aIPro.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $aIPro.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
}
// This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $7b496e10baf8131b$var$HctSolver {
    static #_ = this.SCALED_DISCOUNT_FROM_LINRGB = [
        [
            0.001200833568784504,
            0.002389694492170889,
            0.0002795742885861124
        ],
        [
            0.0005891086651375999,
            0.0029785502573438758,
            0.0003270666104008398
        ],
        [
            0.00010146692491640572,
            0.0005364214359186694,
            0.0032979401770712076
        ]
    ];
    static #_2 = this.LINRGB_FROM_SCALED_DISCOUNT = [
        [
            1373.2198709594231,
            -1100.4251190754821,
            -7.278681089101213
        ],
        [
            -271.815969077903,
            559.6580465940733,
            -32.46047482791194
        ],
        [
            1.9622899599665666,
            -57.173814538844006,
            308.7233197812385
        ]
    ];
    static #_3 = this.Y_FROM_LINRGB = [
        0.2126,
        0.7152,
        0.0722
    ];
    static #_4 = this.CRITICAL_PLANES = [
        0.015176349177441876,
        0.045529047532325624,
        0.07588174588720938,
        0.10623444424209313,
        0.13658714259697685,
        0.16693984095186062,
        0.19729253930674434,
        0.2276452376616281,
        0.2579979360165119,
        0.28835063437139563,
        0.3188300904430532,
        0.350925934958123,
        0.3848314933096426,
        0.42057480301049466,
        0.458183274052838,
        0.4976837250274023,
        0.5391024159806381,
        0.5824650784040898,
        0.6277969426914107,
        0.6751227633498623,
        0.7244668422128921,
        0.775853049866786,
        0.829304845476233,
        0.8848452951698498,
        0.942497089126609,
        1.0022825574869039,
        1.0642236851973577,
        1.1283421258858297,
        1.1946592148522128,
        1.2631959812511864,
        1.3339731595349034,
        1.407011200216447,
        1.4823302800086415,
        1.5599503113873272,
        1.6398909516233677,
        1.7221716113234105,
        1.8068114625156377,
        1.8938294463134073,
        1.9832442801866852,
        2.075074464868551,
        2.1693382909216234,
        2.2660538449872063,
        2.36523901573795,
        2.4669114995532007,
        2.5710888059345764,
        2.6777882626779785,
        2.7870270208169257,
        2.898822059350997,
        3.0131901897720907,
        3.1301480604002863,
        3.2497121605402226,
        3.3718988244681087,
        3.4967242352587946,
        3.624204428461639,
        3.754355295633311,
        3.887192587735158,
        4.022731918402185,
        4.160988767090289,
        4.301978482107941,
        4.445716283538092,
        4.592217266055746,
        4.741496401646282,
        4.893568542229298,
        5.048448422192488,
        5.20615066083972,
        5.3666897647573375,
        5.5300801301023865,
        5.696336044816294,
        5.865471690767354,
        6.037501145825082,
        6.212438385869475,
        6.390297286737924,
        6.571091626112461,
        6.7548350853498045,
        6.941541251256611,
        7.131223617812143,
        7.323895587840543,
        7.5195704746346665,
        7.7182615035334345,
        7.919981813454504,
        8.124744458384042,
        8.332562408825165,
        8.543448553206703,
        8.757415699253682,
        8.974476575321063,
        9.194643831691977,
        9.417930041841839,
        9.644347703669503,
        9.873909240696694,
        10.106627003236781,
        10.342513269534024,
        10.58158024687427,
        10.8238400726681,
        11.069304815507364,
        11.317986476196008,
        11.569896988756009,
        11.825048221409341,
        12.083451977536606,
        12.345119996613247,
        12.610063955123938,
        12.878295467455942,
        13.149826086772048,
        13.42466730586372,
        13.702830557985108,
        13.984327217668513,
        14.269168601521828,
        14.55736596900856,
        14.848930523210871,
        15.143873411576273,
        15.44220572664832,
        15.743938506781891,
        16.04908273684337,
        16.35764934889634,
        16.66964922287304,
        16.985093187232053,
        17.30399201960269,
        17.62635644741625,
        17.95219714852476,
        18.281524751807332,
        18.614349837764564,
        18.95068293910138,
        19.290534541298456,
        19.633915083172692,
        19.98083495742689,
        20.331304511189067,
        20.685334046541502,
        21.042933821039977,
        21.404114048223256,
        21.76888489811322,
        22.137256497705877,
        22.50923893145328,
        22.884842241736916,
        23.264076429332462,
        23.6469514538663,
        24.033477234264016,
        24.42366364919083,
        24.817520537484558,
        25.21505769858089,
        25.61628489293138,
        26.021211842414342,
        26.429848230738664,
        26.842203703840827,
        27.258287870275353,
        27.678110301598522,
        28.10168053274597,
        28.529008062403893,
        28.96010235337422,
        29.39497283293396,
        29.83362889318845,
        30.276079891419332,
        30.722335150426627,
        31.172403958865512,
        31.62629557157785,
        32.08401920991837,
        32.54558406207592,
        33.010999283389665,
        33.4802739966603,
        33.953417292456834,
        34.430438229418264,
        34.911345834551085,
        35.39614910352207,
        35.88485700094671,
        36.37747846067349,
        36.87402238606382,
        37.37449765026789,
        37.87891309649659,
        38.38727753828926,
        38.89959975977785,
        39.41588851594697,
        39.93615253289054,
        40.460400508064545,
        40.98864111053629,
        41.520882981230194,
        42.05713473317016,
        42.597404951718396,
        43.141702194811224,
        43.6900349931913,
        44.24241185063697,
        44.798841244188324,
        45.35933162437017,
        45.92389141541209,
        46.49252901546552,
        47.065252796817916,
        47.64207110610409,
        48.22299226451468,
        48.808024568002054,
        49.3971762874833,
        49.9904556690408,
        50.587870934119984,
        51.189430279724725,
        51.79514187861014,
        52.40501387947288,
        53.0190544071392,
        53.637271562750364,
        54.259673423945976,
        54.88626804504493,
        55.517063457223934,
        56.15206766869424,
        56.79128866487574,
        57.43473440856916,
        58.08241284012621,
        58.734331877617365,
        59.39049941699807,
        60.05092333227251,
        60.715611475655585,
        61.38457167773311,
        62.057811747619894,
        62.7353394731159,
        63.417162620860914,
        64.10328893648692,
        64.79372614476921,
        65.48848194977529,
        66.18756403501224,
        66.89098006357258,
        67.59873767827808,
        68.31084450182222,
        69.02730813691093,
        69.74813616640164,
        70.47333615344107,
        71.20291564160104,
        71.93688215501312,
        72.67524319850172,
        73.41800625771542,
        74.16517879925733,
        74.9167682708136,
        75.67278210128072,
        76.43322770089146,
        77.1981124613393,
        77.96744375590167,
        78.74122893956174,
        79.51947534912904,
        80.30219030335869,
        81.08938110306934,
        81.88105503125999,
        82.67721935322541,
        83.4778813166706,
        84.28304815182372,
        85.09272707154808,
        85.90692527145302,
        86.72564993000343,
        87.54890820862819,
        88.3767072518277,
        89.2090541872801,
        90.04595612594655,
        90.88742016217518,
        91.73345337380438,
        92.58406282226491,
        93.43925555268066,
        94.29903859396902,
        95.16341895893969,
        96.03240364439274,
        96.9059996312159,
        97.78421388448044,
        98.6670533535366,
        99.55452497210776
    ];
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $aIPro.signum(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $aIPro.matrixMultiply(linrgb, $7b496e10baf8131b$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $7b496e10baf8131b$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $7b496e10baf8131b$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $7b496e10baf8131b$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $7b496e10baf8131b$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $7b496e10baf8131b$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $7b496e10baf8131b$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $7b496e10baf8131b$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $7b496e10baf8131b$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $7b496e10baf8131b$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $7b496e10baf8131b$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($7b496e10baf8131b$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($7b496e10baf8131b$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($7b496e10baf8131b$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $7b496e10baf8131b$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $7b496e10baf8131b$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $7b496e10baf8131b$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($7b496e10baf8131b$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $7b496e10baf8131b$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $7b496e10baf8131b$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $7b496e10baf8131b$var$HctSolver.criticalPlaneBelow($7b496e10baf8131b$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $7b496e10baf8131b$var$HctSolver.criticalPlaneAbove($7b496e10baf8131b$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $7b496e10baf8131b$var$HctSolver.criticalPlaneAbove($7b496e10baf8131b$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $7b496e10baf8131b$var$HctSolver.criticalPlaneBelow($7b496e10baf8131b$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $7b496e10baf8131b$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $7b496e10baf8131b$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $7b496e10baf8131b$var$HctSolver.hueOf(mid);
                    if ($7b496e10baf8131b$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $7b496e10baf8131b$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $aIPro.signum(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $7b496e10baf8131b$export$159586e3808c6277.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $7b496e10baf8131b$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $7b496e10baf8131b$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $7b496e10baf8131b$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $aIPro.matrixMultiply([
                rCScaled,
                gCScaled,
                bCScaled
            ], $7b496e10baf8131b$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $7b496e10baf8131b$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $7b496e10baf8131b$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $7b496e10baf8131b$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $a7GET.argbFromLinrgb(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $a7GET.argbFromLstar(lstar);
        hueDegrees = $aIPro.sanitizeDegreesDouble(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $a7GET.yFromLstar(lstar);
        const exactAnswer = $7b496e10baf8131b$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $7b496e10baf8131b$var$HctSolver.bisectToLimit(y, hueRadians);
        return $a7GET.argbFromLinrgb(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $7b496e10baf8131b$var$Cam16.fromInt($7b496e10baf8131b$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
class $7b496e10baf8131b$export$159586e3808c6277 {
    static #_ = /**
   * sRGB-like viewing conditions.
   */ this.DEFAULT = $7b496e10baf8131b$export$159586e3808c6277.make();
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $a7GET.whitePointD65(), adaptingLuminance = 200.0 / Math.PI * $a7GET.yFromLstar(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $aIPro.lerp(0.59, 0.69, (f - 0.9) * 10.0) : $aIPro.lerp(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $a7GET.yFromLstar(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $7b496e10baf8131b$export$159586e3808c6277(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}

});





parcelRegister("7J2wO", function(module, exports) {
$parcel$export(module.exports, "AiSearchTriggerContainer", () => $7ea2fe341ff324c6$export$c23f578d84bfd719);
$parcel$export(module.exports, "useAiSearch", () => $7ea2fe341ff324c6$export$77f51d599ca38b3);
$parcel$export(module.exports, "useTriggerIntersectionObserver", () => $7ea2fe341ff324c6$export$d341e445290d4887);
$parcel$export(module.exports, "useHasIntersectingTrigger", () => $7ea2fe341ff324c6$export$e134485de3777bd2);
$parcel$export(module.exports, "useSearchTriggerVisibility", () => $7ea2fe341ff324c6$export$7f622cc0692430e8);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $iOIPr = parcelRequire("iOIPr");
var $6xLCs = parcelRequire("6xLCs");
var $kUoOn = parcelRequire("kUoOn");

var $2E70C = parcelRequire("2E70C");

var $jZXh9 = parcelRequire("jZXh9");
const $7ea2fe341ff324c6$var$actions = {
    setInputValue: (inputValue)=>({ setState: setState })=>{
            setState({
                inputValue: inputValue
            });
        },
    observe: (id, element)=>({ setState: setState, getState: getState })=>{
            const { triggers: triggers, observer: currentObserver } = getState();
            const observer = currentObserver ?? new IntersectionObserver(([entry])=>{
                setState({
                    triggers: {
                        ...triggers,
                        [id]: {
                            element: element,
                            isIntersecting: entry.isIntersecting
                        }
                    }
                });
            }, {
                threshold: 0
            });
            setState({
                observer: observer
            });
            observer.observe(element);
        },
    disconnect: (id)=>({ setState: setState, getState: getState })=>{
            const { triggers: prevTriggers, observer: observer } = getState();
            if (observer && prevTriggers[id]) observer.unobserve(prevTriggers[id].element);
            const triggers = {
                ...prevTriggers
            };
            delete triggers[id];
            setState({
                triggers: triggers
            });
        }
};
const $7ea2fe341ff324c6$var$StoreContainer = (0, $iOIPr.createContainer)();
const $7ea2fe341ff324c6$export$c23f578d84bfd719 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)($7ea2fe341ff324c6$var$StoreContainer, {
        ...props,
        isGlobal: true,
        children: children
    });
};
const $7ea2fe341ff324c6$var$store = (0, $kUoOn.createStore)({
    name: 'csm-ai-search-trigger-store',
    initialState: {
        inputValue: '',
        widgetVisibility: null,
        triggers: {},
        observer: null
    },
    actions: $7ea2fe341ff324c6$var$actions,
    containedBy: $7ea2fe341ff324c6$var$StoreContainer,
    handlers: {
        onInit: ()=>({ setState: setState }, { site: site, siteId: siteId, widgetId: widgetId })=>{
                (0, $jZXh9.initCSM)({
                    site: site,
                    siteId: siteId,
                    widgetId: widgetId
                });
                (0, $2E70C.hide)();
                setState({
                    widgetVisibility: 'hidden'
                });
                (0, $2E70C.onOpen)(()=>{
                    setState({
                        widgetVisibility: 'visible'
                    });
                });
                (0, $2E70C.onClose)(()=>{
                    (0, $2E70C.getCurrentConversation)((conversation)=>{
                        if (!conversation) {
                            (0, $2E70C.hide)();
                            setState({
                                widgetVisibility: 'hidden'
                            });
                        }
                    });
                });
            }
    }
});
const $7ea2fe341ff324c6$var$searchFieldValueSelector = (state)=>state.inputValue;
const $7ea2fe341ff324c6$var$useSearchFieldValueHook = (0, $6xLCs.createHook)($7ea2fe341ff324c6$var$store, {
    selector: $7ea2fe341ff324c6$var$searchFieldValueSelector
});
const $7ea2fe341ff324c6$export$77f51d599ca38b3 = ()=>{
    const [inputValue, { setInputValue: setInputValue }] = $7ea2fe341ff324c6$var$useSearchFieldValueHook();
    return {
        value: inputValue,
        onChange: (value)=>setInputValue(value)
    };
};
const $7ea2fe341ff324c6$var$useAiSearchStore = (0, $6xLCs.createHook)($7ea2fe341ff324c6$var$store);
const $7ea2fe341ff324c6$export$d341e445290d4887 = ()=>{
    const id = (0, $8P7DW.useId)();
    const [_, { observe: observe, disconnect: disconnect }] = $7ea2fe341ff324c6$var$useAiSearchStore();
    const ref = (0, $8P7DW.useCallback)((element)=>{
        if (element) observe(id, element);
        else disconnect(id);
    }, [
        observe,
        disconnect,
        id
    ]);
    return {
        ref: ref
    };
};
const $7ea2fe341ff324c6$var$hasIntersectingTriggerSelector = (state)=>{
    return Object.values(state.triggers).some((trigger)=>trigger.isIntersecting);
};
const $7ea2fe341ff324c6$var$useHasIntersectingTriggerHook = (0, $6xLCs.createHook)($7ea2fe341ff324c6$var$store, {
    selector: $7ea2fe341ff324c6$var$hasIntersectingTriggerSelector
});
const $7ea2fe341ff324c6$export$e134485de3777bd2 = ()=>{
    const [hasIntersectingTrigger] = $7ea2fe341ff324c6$var$useHasIntersectingTriggerHook();
    return hasIntersectingTrigger;
};
const $7ea2fe341ff324c6$export$7f622cc0692430e8 = ()=>{
    const [{ widgetVisibility: widgetVisibility }] = $7ea2fe341ff324c6$var$useAiSearchStore();
    return {
        isTriggerVisible: widgetVisibility !== 'visible'
    };
};

});

parcelRegister("cHQ7t", function(module, exports) {
$parcel$export(module.exports, "AiSearchInput", () => $232292d66234bdb3$export$39dac845faefc1b);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $9pb7J = parcelRequire("9pb7J");

var $dojiU = parcelRequire("dojiU");

var $aJ5F8 = parcelRequire("aJ5F8");

var $72N9l = parcelRequire("72N9l");

var $26XCt = parcelRequire("26XCt");

var $jKdwb = parcelRequire("jKdwb");
const $232292d66234bdb3$var$formStyles = null;
const $232292d66234bdb3$var$hiddenStyles = null;
const $232292d66234bdb3$export$39dac845faefc1b = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ className: className, hidden: hidden, onChange: onChange, onSubmit: onSubmit, value: value }, ref)=>{
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const id = (0, $8P7DW.useId)();
    const formLabelledById = `form-${id}-description`;
    const handleSubmit = (e)=>{
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const message = formData.get('message');
        if (typeof message !== 'string') throw new Error('Message is not a string');
        onSubmit({
            message: message
        });
    };
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("form", {
        ref: ref,
        "aria-hidden": hidden,
        // eslint-disable-next-line
        className: (0, $8n1kL.default)([
            "_v56410bs _1e0c1txw _4cvr1h6o _1bsb1ns9 _m6k4gioh _w6ng15vq _t9ecmk3q",
            hidden && "_lcxvglyw _tzy4idpf _3um015vq",
            className
        ]),
        "aria-labelledby": formLabelledById,
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                    id: formLabelledById,
                    children: formatMessage((0, $jKdwb.messages).searchFieldDescription)
                })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $aJ5F8.SearchTrigger), {
                value: value,
                onChange: onChange,
                placeholder: /*#__PURE__*/ (0, $gWgPx.jsx)("label", {
                    htmlFor: id,
                    children: formatMessage((0, $jKdwb.messages).searchPlaceholder)
                }),
                submitButton: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $26XCt.SearchTriggerSubmitButton), {
                    as: "button",
                    type: "submit"
                }),
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $72N9l.SearchTriggerInputElement), {
                    id: id,
                    inputLabel: formatMessage((0, $jKdwb.messages).searchInputLabel)
                })
            })
        ]
    });
});

});
parcelRegister("aJ5F8", function(module, exports) {
$parcel$export(module.exports, "SearchTrigger", () => $00b0798d331a4f49$export$d846b13db73b361e);
/* main.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $2Q894 = parcelRequire("2Q894");

var $dojiU = parcelRequire("dojiU");

var $gsYKS = parcelRequire("gsYKS");
const $00b0798d331a4f49$var$EXPANDED_WIDTH = '320px';
const $00b0798d331a4f49$var$rootStyles = null;
const $00b0798d331a4f49$var$hoverFocusStyles = null;
const $00b0798d331a4f49$var$expandedStyles = null;
const $00b0798d331a4f49$var$boxStyles = null;
const $00b0798d331a4f49$var$subtlePlaceholderStyles = null;
const $00b0798d331a4f49$var$layoutStyles = null;
const $00b0798d331a4f49$var$inputContainerStyles = null;
const $00b0798d331a4f49$var$labelOverlayStyles = null;
const $00b0798d331a4f49$var$buttonContainerStyles = null;
const $00b0798d331a4f49$export$d846b13db73b361e = ({ children: children, value: value = '', onChange: onChange, placeholder: placeholder, submitButton: submitButton, interactive: interactive = true })=>{
    const [isHovered, setIsHovered] = (0, $8P7DW.useState)(false);
    const [isFocused, setIsFocused] = (0, $8P7DW.useState)(false);
    const isAtRest = value.length === 0 && !isFocused;
    const isExpanded = !isAtRest || isHovered;
    const VisuallyHiddenPlaceholder = isFocused || value.length > 0 ? (0, $dojiU.default) : (0, $8P7DW.Fragment);
    const contextValue = (0, $8P7DW.useMemo)(()=>{
        return {
            isExpanded: isExpanded,
            isHovered: isHovered,
            isFocused: isFocused,
            setIsHovered: setIsHovered,
            setIsFocused: setIsFocused,
            value: value,
            onChange: onChange,
            isAtRest: isAtRest,
            interactive: interactive
        };
    }, [
        isExpanded,
        isHovered,
        isFocused,
        value,
        onChange,
        isAtRest,
        interactive
    ]);
    const mouseEnterLeaverProps = interactive ? {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    } : {};
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gsYKS.SearchTriggerInputContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
            className: (0, $8n1kL.default)([
                "_v564130x _1bsbp3fh _m6k41jlu",
                interactive && "_195pnklw _1chpnklw",
                interactive && isExpanded && "_1bsbnklw"
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                ...mouseEnterLeaverProps,
                className: (0, $8n1kL.default)([
                    "_2rko1rr0 _zulp12x7 _v5641yk7 _11c81d4k _1h6dysee _1dqonqa1 _1bsb1osq _vchhusvi _1e0c1txw _4cvr1fhb _bfhkvuon _16qst7xp _tzy4kb7n _3um0ewfl _w6ng15vq _t9ecmk3q _y4tiu2gc _syazi7uo _4t3i8vuz"
                ]),
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                    className: (0, $8n1kL.default)([
                        "_1e0c1txw _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                            className: (0, $8n1kL.default)([
                                "_kqswh2mm _1bsb1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $gWgPx.jsxs)("div", {
                                    className: (0, $8n1kL.default)([
                                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp12x7 _1wpz1h6o _1e0c1txw _kqswstnw _1ltvpxbi _154iidpf _94n5idpf _lcxvglyw _80om1kdv",
                                        isAtRest && "_syaz1rpy"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Q894))), {
                                            spacing: "spacious",
                                            label: ""
                                        }),
                                        /*#__PURE__*/ (0, $gWgPx.jsx)(VisuallyHiddenPlaceholder, {
                                            children: placeholder
                                        })
                                    ]
                                }),
                                children
                            ]
                        }),
                        /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                            className: (0, $8n1kL.default)([
                                "_1wpz1h6o"
                            ]),
                            children: submitButton
                        })
                    ]
                })
            })
        })
    });
};

});
parcelRegister("2Q894", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbcf1d1b12cba221f9c450106ed39371>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2116c1960ed27bfb$var$_react = $2116c1960ed27bfb$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $2116c1960ed27bfb$var$_baseNew = $2116c1960ed27bfb$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $2116c1960ed27bfb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2116c1960ed27bfb$var$AiChatIcon = (props)=>/*#__PURE__*/ $2116c1960ed27bfb$var$_react.default.createElement($2116c1960ed27bfb$var$_baseNew.default, Object.assign({
        name: "AiChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$2116c1960ed27bfb$var$AiChatIcon.displayName = 'AiChatIcon';
var $2116c1960ed27bfb$var$_default = module.exports.default = $2116c1960ed27bfb$var$AiChatIcon;

});

parcelRegister("gsYKS", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerInputContext", () => $504ec2c0678a4c9c$export$9cec4f4bc0c5ec28);
$parcel$export(module.exports, "useSearchTriggerInput", () => $504ec2c0678a4c9c$export$ffbcaaf65823abae);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");
const $504ec2c0678a4c9c$export$9cec4f4bc0c5ec28 = /*#__PURE__*/ (0, $8P7DW.createContext)(null);
const $504ec2c0678a4c9c$export$ffbcaaf65823abae = ()=>{
    const context = (0, $8P7DW.useContext)($504ec2c0678a4c9c$export$9cec4f4bc0c5ec28);
    if (!context) throw new Error('useSearchTriggerInput must be used within a SearchTriggerInputProvider');
    return context;
};

});


parcelRegister("72N9l", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerInputElement", () => $8c515a6795f69c22$export$42ccbc2c6177b53f);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $gsYKS = parcelRequire("gsYKS");
const $8c515a6795f69c22$var$inputStyles = null;
const $8c515a6795f69c22$export$42ccbc2c6177b53f = ({ id: id, inputLabel: inputLabel })=>{
    const { value: value, onChange: onChange, setIsFocused: setIsFocused } = (0, $gsYKS.useSearchTriggerInput)();
    // store the local value in state to avoid the input being "locked in" as a Latin character
    const [localValue, setLocalValue] = (0, $8P7DW.useState)(value);
    const isComposingRef = (0, $8P7DW.useRef)(false);
    // Sync local value with controlled value when not composing
    (0, $8P7DW.useEffect)(()=>{
        if (!isComposingRef.current) setLocalValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
        "data-testid": "csm-ai-search-input",
        id: id,
        value: localValue,
        name: "message",
        onChange: (e)=>{
            const newValue = e.currentTarget.value;
            setLocalValue(newValue);
            // Only propagate to parent when not composing (IME input)
            // This fixes Japanese/Chinese/Korean input where the first character
            // would otherwise be "locked in" as a Latin character
            if (!isComposingRef.current) onChange === null || onChange === void 0 || onChange(newValue);
        },
        onCompositionStart: ()=>{
            isComposingRef.current = true;
        },
        onCompositionEnd: (e)=>{
            isComposingRef.current = false;
            // Commit the final composed value after IME conversion completes
            onChange === null || onChange === void 0 || onChange(e.currentTarget.value);
        },
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false),
        autoComplete: "off",
        spellCheck: "false",
        "aria-label": inputLabel,
        className: (0, $8n1kL.default)([
            "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _11c81d4k _r06hglyw _bfhk1j28 _4t3i1osq _1bsb1osq _syazi7uo _vchhusvi _1q51idpf _85i5idpf _bozgoahv _y4tiu2gc"
        ])
    });
};

});

parcelRegister("26XCt", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerSubmitButton", () => $ca550bb2da82e346$export$c4e4405f3e81e277);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");
parcelRequire("8P7DW");

var $k7INq = parcelRequire("k7INq");

var $KmjAJ = parcelRequire("KmjAJ");

var $gsYKS = parcelRequire("gsYKS");

var $kT9pM = parcelRequire("kT9pM");
// TODO: connect with ADS to figure out the best approach to use dynamic value with cssMap, to avoid manually use the csm token
const $ca550bb2da82e346$var$styles = {
    pressable: "_2rko1qll _19itglyw _1e0c1txw _4cvr1h6o _1bah1h6o _1h1tkb7n _4t3i14no _1tkezwfg _bfhki8nm _13ix1yyw _mizu1g87",
    usedState: "_bfhk1y25 _30l3czge _irr31hsi _9h8h15cr _1di6jowl",
    cursorPointer: "_80omtlke"
};
const $ca550bb2da82e346$export$c4e4405f3e81e277 = ({ ...props })=>{
    const { formatMessage: formatMessage } = (0, $k7INq.default)();
    const { isExpanded: isExpanded, interactive: interactive } = (0, $gsYKS.useSearchTriggerInput)();
    const isDimmed = !isExpanded;
    if (props.as === 'button') {
        const { as: _, ...rest } = props;
        return /*#__PURE__*/ (0, $gWgPx.jsx)("button", {
            "aria-disabled": isDimmed,
            ...rest,
            className: (0, $8n1kL.default)([
                $ca550bb2da82e346$var$styles.pressable,
                $ca550bb2da82e346$var$styles.cursorPointer,
                interactive && !isDimmed && $ca550bb2da82e346$var$styles.usedState
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($KmjAJ))), {
                label: formatMessage((0, $kT9pM.messages).searchButtonLabel)
            })
        });
    }
    const { as: _, ...rest } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ...rest,
        className: (0, $8n1kL.default)([
            $ca550bb2da82e346$var$styles.pressable,
            interactive && !isDimmed && $ca550bb2da82e346$var$styles.usedState
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($KmjAJ))), {
            label: formatMessage((0, $kT9pM.messages).searchButtonLabel)
        })
    });
};

});
parcelRegister("KmjAJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08b59b48e0c186a1$var$_react = $08b59b48e0c186a1$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $08b59b48e0c186a1$var$_baseNew = $08b59b48e0c186a1$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $08b59b48e0c186a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08b59b48e0c186a1$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $08b59b48e0c186a1$var$_react.default.createElement($08b59b48e0c186a1$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$08b59b48e0c186a1$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $08b59b48e0c186a1$var$_default = module.exports.default = $08b59b48e0c186a1$var$ArrowRightIcon;

});

parcelRegister("kT9pM", function(module, exports) {
$parcel$export(module.exports, "messages", () => $cb64b3228d024b32$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $cb64b3228d024b32$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    searchButtonLabel: {
        id: 'csm.chat.widget.search.trigger.search.button.label.non-fin',
        defaultMessage: 'Search with AI',
        description: 'label for the CSM chat widget search trigger button'
    }
});

});


parcelRegister("jKdwb", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b0d3422b351b11f1$export$defe85febe8b728c);

var $6K2Gm = parcelRequire("6K2Gm");
const $b0d3422b351b11f1$export$defe85febe8b728c = (0, $6K2Gm.defineMessages)({
    searchPlaceholder: {
        id: 'csm.chat.widget.search.trigger.search.placeholder',
        defaultMessage: 'Ask anything',
        description: 'placeholder for the CSM chat widget search trigger input'
    },
    searchFieldDescription: {
        id: 'csm.chat.widget.search.trigger.search.field.description',
        defaultMessage: 'Submit your question to get chat with and get answers from our AI assistant',
        description: 'Describes that the input field upon submission will trigger the chat widget'
    },
    searchInputLabel: {
        id: 'csm.chat.widget.search.trigger.search.input.label',
        defaultMessage: 'Chat search trigger input',
        description: 'Accessibility label for chat search input'
    }
});

});





parcelRegister("8EmED", function(module, exports) {
$parcel$export(module.exports, "HubsDocumentTitle", () => $3ce539e8bbf78076$export$9b71b60159f818b1);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $LjMa7 = parcelRequire("LjMa7");
const $3ce539e8bbf78076$export$9b71b60159f818b1 = ({ title: title, shouldRenderDocumentTitle: shouldRenderDocumentTitle, children: children })=>{
    if (!title || !shouldRenderDocumentTitle) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LjMa7))), {
        title: title,
        children: children
    });
};

});

parcelRegister("36FIx", function(module, exports) {
$parcel$export(module.exports, "default", () => $6eb3ac6e0904977c$export$2e2bcd8739ae039);

var $6K2Gm = parcelRequire("6K2Gm");
const $6eb3ac6e0904977c$var$_default_1 = (0, $6K2Gm.defineMessages)({
    hubLoadingSpinnerLabel: {
        id: 'company-hub.hub.loading-spinner-label',
        defaultMessage: 'Loading hub',
        description: 'Label for the hub loading spinner'
    }
});
var $6eb3ac6e0904977c$export$2e2bcd8739ae039 = $6eb3ac6e0904977c$var$_default_1;

});


parcelRegister("4qYYH", function(module, exports) {
$parcel$export(module.exports, "getContentWidth", () => $265678f5bf3344a2$export$f61abf052f87399f);
$parcel$export(module.exports, "withBannerBackgroundColor", () => $265678f5bf3344a2$export$f6b6d100e7beb8c8);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8NbLB = parcelRequire("8NbLB");
// 800px is normal width
const $265678f5bf3344a2$var$GRID_NORMAL_WIDTH = '800px';
// 1000px is wide width
const $265678f5bf3344a2$var$GRID_WIDE_WIDTH = '1000px';
// 1100px is extra wide width
const $265678f5bf3344a2$var$GRID_XWIDE_WIDTH = '1100px';
// 1200px is extra wide width
const $265678f5bf3344a2$var$GRID_XXWIDE_WIDTH = '1200px';
const $265678f5bf3344a2$var$GRID_NOTE_WIDTH = '480px';
const $265678f5bf3344a2$var$GRID_FULL_WIDTH = '100%';
const $265678f5bf3344a2$export$f61abf052f87399f = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $265678f5bf3344a2$var$GRID_XXWIDE_WIDTH;
        case 'xwide':
            return $265678f5bf3344a2$var$GRID_XWIDE_WIDTH;
        case 'wide':
            return $265678f5bf3344a2$var$GRID_WIDE_WIDTH;
        case 'note':
            return $265678f5bf3344a2$var$GRID_NOTE_WIDTH;
        case 'full-width':
            return $265678f5bf3344a2$var$GRID_FULL_WIDTH;
        default:
            return $265678f5bf3344a2$var$GRID_NORMAL_WIDTH;
    }
};
const $265678f5bf3344a2$export$f6b6d100e7beb8c8 = (InnerComponent)=>{
    return (props)=>{
        const hubContext = (0, $8NbLB.useHubContext)();
        const bannerBackgroundColor = hubContext.branding.colors.primary;
        return /*#__PURE__*/ (0, $gWgPx.jsx)(InnerComponent, {
            ...props,
            bannerBackgroundColor: bannerBackgroundColor
        });
    };
};

});


parcelRegister("jWaRS", function(module, exports) {
$parcel$export(module.exports, "HubAnonymousLayout", () => (parcelRequire("b3h3N")).HubAnonymousLayout);
parcelRequire("b3h3N");

});
parcelRegister("b3h3N", function(module, exports) {
$parcel$export(module.exports, "HubAnonymousLayout", () => $c17ce0f680f803f9$export$ae9644df85d50589);
/* hub-anonymous-layout.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
var $77UGK = parcelRequire("77UGK");

var $4cxV2 = parcelRequire("4cxV2");

var $4fSTF = parcelRequire("4fSTF");
const $c17ce0f680f803f9$var$anonymousStyles = null;
const $c17ce0f680f803f9$export$ae9644df85d50589 = ({ children: children })=>/*#__PURE__*/ $8P7DW.createElement("div", {
        className: (0, $8n1kL.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _vchhusvi _1e0c1txw _2lx21bp4 _19pk1ai2 _18u01wug _2hwx1wug _1bsb1osq _p12f1osq _1tke1586 _1wpz1y6m _1c421osq _138yidpf"
        ]),
        style: {
            "--_19v4s1f-": (0, $77UGK.default)($4cxV2.multiple(15).unitless, "px", "-"),
            "--_jnopm3": (0, $77UGK.default)($4cxV2.multiple(52).unitless, "px")
        }
    }, /*#__PURE__*/ $8P7DW.createElement((0, $4fSTF.NoteBackground), null, children));

});


parcelRegister("9vXcv", function(module, exports) {
$parcel$export(module.exports, "HubAvatarMenuOptions", () => (parcelRequire("iYaYV")).HubAvatarMenuOptions);

var $iYaYV = parcelRequire("iYaYV");

});
parcelRegister("iYaYV", function(module, exports) {
$parcel$export(module.exports, "HubAvatarMenuOptions", () => $472644de48d29ebc$export$4f0698e82fb00313);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $cS6Xr = parcelRequire("cS6Xr");

var $4QM8d = parcelRequire("4QM8d");

var $2gQsf = parcelRequire("2gQsf");

var $jByYr = parcelRequire("jByYr");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");

var $2SIoy = parcelRequire("2SIoy");

var $1EFS8 = parcelRequire("1EFS8");

var $lkatq = parcelRequire("lkatq");
var $7qJSw = parcelRequire("7qJSw");

var $kkBq4 = parcelRequire("kkBq4");

var $7jGoV = parcelRequire("7jGoV");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");
parcelRequire("4Jtl9");
var $lMHED = parcelRequire("lMHED");

var $ffF1H = parcelRequire("ffF1H");

var $7Ftzu = parcelRequire("7Ftzu");
const $472644de48d29ebc$var$HubAvatarMenuOptionsComponent = ({ fetchUser: fetchUser, fetchUserRequestsCounts: fetchUserRequestsCounts, fetchOrganisations: fetchOrganisations, canAdministerJIRA: canAdministerJIRA, myRequestCount: myRequestCount = 0, pendingApprovalCount: pendingApprovalCount = 0, approvalCount: approvalCount = 0 })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [{ match: match }] = (0, $i9cdb.useRouter)();
    // Fetch user data and request counts on component mount
    (0, $8P7DW.useEffect)(()=>{
        fetchUser();
        fetchOrganisations();
        fetchUserRequestsCounts();
    }, [
        fetchUser,
        fetchOrganisations,
        fetchUserRequestsCounts
    ]);
    // Calculate total pending items for badges
    const totalRequestsCount = myRequestCount || 0;
    const totalApprovalsCount = pendingApprovalCount || 0;
    const { portalId: portalId, id: pageId } = match.params;
    const showApprovals = approvalCount > 0 || pendingApprovalCount > 0;
    const helpCenterAri = (0, $jByYr.getHelpCenterAri)();
    const helpCenterId = (0, $ffF1H.parseHelpCenterAri)(helpCenterAri).helpCenterId;
    let editHubSuffix = '';
    if (portalId) editHubSuffix = `/portal/${portalId}`;
    else if (pageId) editHubSuffix = `/${pageId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, !(0, $1EFS8.default).checkGate('hub_component_upgrade') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        component: (0, $cS6Xr.Link),
        actionSubjectId: "navbarUserRequests",
        to: "/user/requests?reporter=all&statuses=open",
        iconAfter: totalRequestsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2SIoy.default), null, totalRequestsCount) : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $7Ftzu.default).requests)), showApprovals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        component: (0, $cS6Xr.Link),
        actionSubjectId: "navbarUserApprovals",
        to: "/user/approvals",
        iconAfter: totalApprovalsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2SIoy.default), null, totalApprovalsCount) : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $7Ftzu.default).approvals))), canAdministerJIRA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7qJSw.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        component: (0, $4QM8d.HtmlAnchor),
        actionSubjectId: "navbarCustomiseHub",
        href: `/helpcenter-management/${helpCenterId}/edit-hub${editHubSuffix}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $7Ftzu.default).customiseHub)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lkatq.default), {
        component: (0, $4QM8d.HtmlAnchor),
        actionSubjectId: "navbarHubSettings",
        href: `/helpcenter-management/hubs`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $7Ftzu.default).hubSettings))));
};
const $472644de48d29ebc$var$mapStateToProps = (state)=>{
    const userRequestsCounts = (0, $lMHED.getUserRequestsCounts)(state);
    return {
        myRequestCount: userRequestsCounts.myRequestCount,
        pendingApprovalCount: userRequestsCounts.pendingApprovalCount,
        approvalCount: userRequestsCounts.approvalCount,
        canAdministerJIRA: (0, $hx8zX.getCanAdministerJIRA)(state)
    };
};
const $472644de48d29ebc$export$4f0698e82fb00313 = (0, $jvoWT.default)($472644de48d29ebc$var$mapStateToProps, {
    fetchUser: (0, $2gQsf.fetchUserModelAction),
    fetchUserRequestsCounts: (0, $7jGoV.fetchUserRequestsCountsAction),
    fetchOrganisations: (0, $kkBq4.fetchOrganisationsModelAction)
})($472644de48d29ebc$var$HubAvatarMenuOptionsComponent);

});
parcelRegister("ffF1H", function(module, exports) {
$parcel$export(module.exports, "parseHelpCenterAri", () => $72ca03e11a0e8d37$export$2b81f3445e8c13f4);
$parcel$export(module.exports, "getHelpCenterId", () => $72ca03e11a0e8d37$export$7ac65eebc1dbe637);
$parcel$export(module.exports, "createHelpCenterAri", () => $72ca03e11a0e8d37$export$dbcb6d0534e1f531);
// eslint-disable-next-line no-restricted-imports

var $cLmLE = parcelRequire("cLmLE");
const $72ca03e11a0e8d37$export$2b81f3445e8c13f4 = (helpCenterAri)=>{
    const isValidAri = (0, $cLmLE.HelpHelpCenterAri).check(helpCenterAri) && helpCenterAri !== 'null' && helpCenterAri !== '';
    return isValidAri ? (0, $cLmLE.HelpHelpCenterAri).parse(helpCenterAri) : {
        helpCenterId: ''
    };
};
const $72ca03e11a0e8d37$export$7ac65eebc1dbe637 = (helpCenterAri)=>{
    const { helpCenterId: helpCenterId } = $72ca03e11a0e8d37$export$2b81f3445e8c13f4(helpCenterAri);
    return helpCenterId;
};
const $72ca03e11a0e8d37$export$dbcb6d0534e1f531 = (activationId, helpCenterId)=>{
    if (!helpCenterId || !activationId || helpCenterId === 'null' || activationId === 'null') return '';
    return (0, $cLmLE.HelpHelpCenterAri).create({
        activationId: activationId,
        helpCenterId: helpCenterId
    }).toString();
};

});

parcelRegister("7Ftzu", function(module, exports) {
$parcel$export(module.exports, "default", () => $176367d4232e309e$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $176367d4232e309e$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    requests: {
        defaultMessage: 'Requests',
        description: 'Requests item in hub avatar menu',
        id: 'hub.avatar.menu.requests'
    },
    approvals: {
        defaultMessage: 'Approvals',
        description: 'Approvals item in hub avatar menu',
        id: 'hub.avatar.menu.approvals'
    },
    customiseHub: {
        defaultMessage: 'Customise hub',
        description: 'Customise hub item in hub avatar menu',
        id: 'hub.avatar.menu.customise.hub'
    },
    hubSettings: {
        defaultMessage: 'Hub settings',
        description: 'Hub settings item in hub avatar menu',
        id: 'hub.avatar.menu.hub.settings'
    }
});

});



parcelRegister("7EEKy", function(module, exports) {
$parcel$export(module.exports, "RequestList", () => $cf8d123aa45e0c45$export$c58d16d73d0428fb);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $cf8d123aa45e0c45$export$c58d16d73d0428fb = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("cEaj1")).then((module)=>{
            const { registerRequestsListEpicsndReducers: registerRequestsListEpicsndReducers } = module;
            registerRequestsListEpicsndReducers();
            return module.default;
        }), {
        moduleId: "./src/view/request-list/hocs.tsx"
    })
});

});
parcelRegister("cEaj1", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("kzYkG"),
    $j9MRt("gLYZj")
]).then(()=>parcelRequire('cdojm'));

});


parcelRegister("lTEs4", function(module, exports) {
$parcel$export(module.exports, "CsmUserProfileForHubs", () => $38f067e993b4dbb6$export$eca04c8a7924030c);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $38f067e993b4dbb6$export$eca04c8a7924030c = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("eZFwy")), {
        moduleId: "./src/view/user-profile/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("eZFwy", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("a8P1D"),
    $j9MRt("1vp44")
]).then(()=>parcelRequire('8da5W'));

});


parcelRegister("hilYh", function(module, exports) {
$parcel$export(module.exports, "UserProfileForHubs", () => $9068c1474a8867ac$export$4c16441af2ce2701);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $9068c1474a8867ac$var$loader = (0, $fGOkV.lazyForPaint)(()=>{
    return (parcelRequire("5NmZD"));
}, {
    ssr: true,
    moduleId: "./src/view/user-profile/hub-variant/hub-variant.tsx"
});
const $9068c1474a8867ac$export$4c16441af2ce2701 = (0, $gweXC.default)({
    loader: $9068c1474a8867ac$var$loader
});

});
parcelRegister("5NmZD", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("a8P1D"),
    $j9MRt("49BEh")
]).then(()=>parcelRequire('8ZA4u'));

});


parcelRegister("2Qxwd", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTES", () => $f1f5c49a8e07b502$export$89e88c91b6499ccb);

var $bXs4i = parcelRequire("bXs4i");
const $f1f5c49a8e07b502$export$89e88c91b6499ccb = {
    USER_PROFILE: {
        path: '/user/profile',
        name: 'hubs-user-profile'
    },
    REQUESTS_LIST: {
        path: '/user/requests',
        name: 'requests-list'
    },
    CSM_REQUESTS_LIST: {
        path: '/user/requests',
        name: 'csm-requests-list'
    },
    CSM_CONTACT_US: {
        path: '/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?',
        name: 'contact-us'
    },
    NOT_FOUND: {
        path: '(.*)',
        name: 'hubs-not-found-error-page'
    },
    CSM_FOLDER: {
        path: '/folder/:folderId',
        name: 'csm-folder'
    },
    CSM_REQUEST_DETAILS: {
        path: '/user/requests/:requestKey',
        name: 'csm-request-details'
    },
    VIEW_PORTAL_ARTICLE: {
        path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/article/:articleId`,
        name: 'hubs-view-portal-kb-article'
    },
    PORTAL_ACCESS_FORBIDDEN: {
        path: '/user/forbidden',
        name: 'hubs-portal-access-forbidden'
    },
    VIEW_ARTICLE: {
        path: '/article/:articleId',
        name: 'hubs-view-kb-article'
    },
    VIEW_KB_ARTICLE: {
        path: '/kb/view/:pageId',
        name: 'hubs-view-kb-article'
    },
    VIEW_CROSS_SITE_PORTAL_ARTICLE: {
        path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/cloudId/:cloudId/article/:articleId`,
        name: 'hubs-view-portal-cross-site-kb-article'
    },
    VIEW_CROSS_SITE_ARTICLE: {
        path: '/cloudId/:cloudId/article/:articleId',
        name: 'hubs-view-kb-cross-site-article'
    },
    LOGIN: {
        path: '/user/login',
        name: 'hubs-login'
    },
    PORTAL_LOGIN: {
        path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/login`,
        name: 'hubs-portal-login'
    },
    SIGNUP: {
        path: '/user/signup',
        name: 'hubs-user-signup'
    },
    PORTAL_SIGNUP: {
        path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/signup`,
        name: 'hubs-portal-signup'
    },
    COMPLETE_SIGNUP: {
        path: '/user/complete-signup',
        name: 'hubs-user-complete-signup'
    },
    PORTAL_COMPLETE_SIGNUP: {
        path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/complete-signup`,
        name: 'hubs-portal-complete-signup'
    },
    RESET_PASSWORD: {
        path: '/user/resetpassword',
        name: 'hubs-user-reset-password'
    },
    PORTAL_RESET_PASSWORD: {
        path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/resetpassword`,
        name: 'hubs-portal-reset-password'
    },
    CHECK_EMAIL: {
        path: '/user/check-email',
        name: 'hubs-user-checkmail'
    },
    PORTAL_INVITED_SIGNUP: {
        path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/user/visitportal`,
        name: 'hubs-portal-invited-signup'
    },
    UNSUBSCRIBE: {
        path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/:requestKey/unsubscribe`,
        name: 'hubs-unsubscribe'
    },
    REQUEST_FEEDBACK: {
        path: `${(0, $bXs4i.PORTAL_ROUTE_PREFIX)}/:requestKey/feedback`,
        name: 'jsm-hubs-request-feedback'
    },
    REQUEST_CREATE: {
        path: `/portal/:portalId/create/:requestTypeId`,
        name: 'jsm-hubs-request-create'
    },
    ANONYMOUS_REQUEST_SUCCESS: {
        path: `/portal/:portalId/create/:requestTypeId/confirm`,
        name: 'jsm-hubs-anonymous-request-success'
    },
    JSM_REQUEST_DETAILS: {
        path: `/portal/:portalId/:requestKey`,
        name: 'jsm-hubs-request-details'
    },
    JSM_REQUESTS_LIST: {
        path: `/user/requests`,
        name: 'jsm-hubs-requests-list'
    },
    JSM_APPROVALS: {
        path: `/user/approvals`,
        name: 'jsm-hubs-approvals'
    },
    JSM_REQUEST_APPROVAL: {
        path: `/portal/:portalId/:requestKey/approval/:approvalId/:decision`,
        name: 'jsm-hubs-request-approval'
    },
    HUB_ARTICLES: {
        name: 'view-kb-article',
        path: `/article/:articleId`
    },
    HUB_KB_PAGE: {
        name: 'view-kb-page',
        path: `/kb/view/:pageId`
    },
    HUB_CROSS_SITE_ARTICLE: {
        name: 'view-kb-cross-site-article',
        path: `/cloudId/:cloudId/article/:articleId`
    }
};

});



parcelRegister("fULfs", function(module, exports) {
$parcel$export(module.exports, "routeWithAiWidgetConfigResource", () => $9b4872163722ea55$export$66e676d5e26b883e);

var $3y0y1 = parcelRequire("3y0y1");
const $9b4872163722ea55$export$66e676d5e26b883e = (route)=>{
    return {
        ...route,
        resources: [
            ...route.resources ?? [],
            (0, $3y0y1.csmSupportWidgetConfigQueryResource)
        ]
    };
};

});
parcelRegister("3y0y1", function(module, exports) {
$parcel$export(module.exports, "csmSupportWidgetConfigQueryResource", () => $b427544872f64146$export$157d87119e3de36e);

var $jByYr = parcelRequire("jByYr");

var $byuiX = parcelRequire("byuiX");

var $fZv0V = parcelRequire("fZv0V");
const $b427544872f64146$export$157d87119e3de36e = (0, $byuiX.createRelayResource)({
    type: 'CSM_SUPPORT_WIDGET_CONFIG_QUERY',
    getQuery: ()=>({
            parameters: (0, $fZv0V.default),
            variables: {
                helpCenterAri: (0, $jByYr.getMeta)('help-center-ari') ?? '',
                cloudId: (0, $jByYr.getMeta)('tenant-id') ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("fZv0V", function(module, exports) {
$parcel$export(module.exports, "default", () => $964cbaa0363e99b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76a9357bfcbfee29f32a8b829c6a39c5>>
 * @relayHash 35cdd10bfcb6c0124f988dd9e3d183e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d93156dd0e55b54047f4b0df951ba8d0f7f5944745c9fc2a6f47738f320285fa
const $964cbaa0363e99b9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "position"
            },
            {
                "concreteType": "CsmAiWidgetBrandingTheme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorVibeVariant"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "radius"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "space"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "chatColor"
                    }
                ]
            }
        ],
        "type": "CsmAiWidgetConfig"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "supportWidgetConfigProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "supportWidgetConfigProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "d93156dd0e55b54047f4b0df951ba8d0f7f5944745c9fc2a6f47738f320285fa",
            "metadata": {},
            "name": "supportWidgetConfigProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$964cbaa0363e99b9$var$node.hash = "7afba16f32baf97fd3ce09f41645b442";
var $964cbaa0363e99b9$export$2e2bcd8739ae039 = $964cbaa0363e99b9$var$node;

});



parcelRegister("kovSu", function(module, exports) {
$parcel$export(module.exports, "default", () => $504ad338501e748b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $2UsNA = parcelRequire("2UsNA");

var $HGACo = parcelRequire("HGACo");

var $3Z4c2 = parcelRequire("3Z4c2");

var $fOqPA = parcelRequire("fOqPA");

parcelRequire("9wocP");
var $jT4Pl = parcelRequire("jT4Pl");
var $3vYjO = parcelRequire("3vYjO");

var $iA1ui = parcelRequire("iA1ui");

var $igTQ0 = parcelRequire("igTQ0");

var $9fRhz = parcelRequire("9fRhz");

var $17jzp = parcelRequire("17jzp");

var $bH3eB = parcelRequire("bH3eB");

var $5orRf = parcelRequire("5orRf");

var $dPlZw = parcelRequire("dPlZw");

var $7A2dq = parcelRequire("7A2dq");

var $lKYU4 = parcelRequire("lKYU4");

var $dQDRa = parcelRequire("dQDRa");

var $cX0wo = parcelRequire("cX0wo");

var $28TQC = parcelRequire("28TQC");

var $iC8fI = parcelRequire("iC8fI");

var $lhiUD = parcelRequire("lhiUD");

var $3eD0H = parcelRequire("3eD0H");

var $bPECR = parcelRequire("bPECR");

var $aN5rH = parcelRequire("aN5rH");

var $eD4ZV = parcelRequire("eD4ZV");

var $9uhKS = parcelRequire("9uhKS");

var $j52uk = parcelRequire("j52uk");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $9PD2z = parcelRequire("9PD2z");

var $1EFS8 = parcelRequire("1EFS8");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $7FSs7 = parcelRequire("7FSs7");

var $idbbE = parcelRequire("idbbE");
parcelRequire("9QKIl");
var $9t02C = parcelRequire("9t02C");
var $8kP0u = parcelRequire("8kP0u");
const $504ad338501e748b$export$2f7745f2f5ab3897 = ()=>{
    return [
        ...(0, $gk18s.isAdvancedHelpCenter)() || (0, $gk18s.isFlexiHCEnabledInDefaultHC)() ? [
            (0, $iA1ui.getViewHomePageRoute)(),
            (0, $iA1ui.getEditHomePageRoute)()
        ] : [],
        ...(0, $HGACo.isEmailVerifiedSignalEnabled)() ? [
            (0, $j52uk.userVerifyEmailRoute)
        ] : [],
        (0, $bH3eB.viewPortalConversationPageRoute),
        (0, $igTQ0.aiAnswerRoute),
        (0, $17jzp.consentFormRoute),
        (0, $cX0wo.loginRoute),
        (0, $aN5rH.userResetPasswordRoute),
        (0, $aN5rH.userSignupRoute),
        (0, $aN5rH.userCompleteSignupRoute),
        (0, $aN5rH.userCheckMailRoute),
        (0, $28TQC.portalAccessForbiddenRoute),
        (0, $cX0wo.portalLoginRoute),
        (0, $aN5rH.portalSignupRoute),
        (0, $aN5rH.portalResetPasswordRoute),
        (0, $aN5rH.portalCompleteSignupRoute),
        (0, $aN5rH.portalInvitedSignupRoute),
        (0, $9t02C.requestFeedbackRoute),
        (0, $9t02C.unsubscribeRoute),
        (0, $lKYU4.getHelpCenterRoute)(),
        (0, $iA1ui.getEditHomePageRoute)('edit-homepage', '/edit'),
        (0, $3eD0H.requestDetailsRoute),
        (0, $dQDRa.viewKbPageRoute),
        (0, $dQDRa.viewAllSearchResultsRoute),
        (0, $dQDRa.viewPortalAllSearchResultsRoute),
        (0, $dQDRa.viewPortalCategoryArticleRoute),
        (0, $dQDRa.viewPortalArticleRoute),
        (0, $dQDRa.viewCrossSitePortalArticleRoute),
        (0, $dQDRa.viewArticleRoute),
        (0, $dQDRa.viewCrossSiteArticleRoute),
        (0, $bPECR.requestsListRoute),
        (0, $9fRhz.approvalsRoute),
        (0, $lhiUD.requestApprovalRoute),
        (0, $9t02C.userProfileRoute),
        (0, $dQDRa.viewPortalKnowledgeCategoryRoute),
        (0, $9t02C.anonymousRequestSuccessRoute),
        (0, $9t02C.getRequestCreateRoute)(),
        ...(0, $HGACo.isSurveysRouteEnabled)() ? [
            (0, $eD4ZV.getSurveyRoute)()
        ] : [],
        (0, $iC8fI.getPortalHomeRoutes)(),
        (0, $7A2dq.getEmbedCreateRequestRoute)(),
        (0, $7A2dq.embedSinglePortalRoute),
        (0, $7A2dq.embedKBArticleRoute),
        ...(0, $1EFS8.default).checkGate('embed_hc_featured_portals') ? [
            (0, $7A2dq.embedFeaturedPortalsRoute)
        ] : [],
        ...(0, $1EFS8.default).checkGate('jsm_portal_rovo_integration') ? [
            (0, $7A2dq.embedLoginSuccessRoute)
        ] : [],
        (0, $8kP0u.portalReorderRoute)(true),
        (0, $dPlZw.editTopicRoute),
        (0, $dPlZw.addTopicRoute),
        (0, $9uhKS.getViewTopicRoute)(),
        ...(0, $bH3eB.getHelpCenterConversationPageRoute)(),
        ...(0, $HGACo.isCustomPagesUiEnabled)() && (0, $hrPHR.getIsHCCustomizationEnabled)() ? [
            (0, $5orRf.getEditCustomPageRoute)(),
            (0, $5orRf.getViewCustomPageRoute)()
        ] : [],
        (0, $9t02C.notFoundErrorRoute)
    ];
};
const $504ad338501e748b$export$360df1dbfef16ccf = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $3Z4c2.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $3Z4c2.lightenColor)(themeColor);
    const routes = (0, $8P7DW.useMemo)(()=>$504ad338501e748b$export$2f7745f2f5ab3897(), []);
    const location = globalThis.location.pathname + globalThis.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2UsNA.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3vYjO.Router), {
        routes: routes,
        history: (0, $7FSs7.default),
        isGlobal: false,
        plugins: [
            (0, $idbbE.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fOqPA.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9PD2z.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jT4Pl.RouteComponent), null)));
};
const $504ad338501e748b$var$selector = (0, $ehscL.createSelector)((0, $8Wisn.getHeadless), (0, $ikoP4.getThemeColor), (0, $ikoP4.getHelpCenterTitleColor), (headerless, themeColor, titleColor)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $504ad338501e748b$export$2e2bcd8739ae039 = (0, $jvoWT.default)($504ad338501e748b$var$selector)($504ad338501e748b$export$360df1dbfef16ccf);

});
parcelRegister("bH3eB", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterConversationPageRoute", () => $26321ff9316ebeaf$export$c0656a6d05f5099e);
$parcel$export(module.exports, "viewPortalConversationPageRoute", () => $26321ff9316ebeaf$export$226a8310910111d5);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $hxVai = parcelRequire("hxVai");

var $8rTkC = parcelRequire("8rTkC");

var $HGACo = parcelRequire("HGACo");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
var $hDCsk = parcelRequire("hDCsk");

var $8IHFj = parcelRequire("8IHFj");
parcelRequire("fZ17l");
var $hbdiU = parcelRequire("hbdiU");

var $cv4yG = parcelRequire("cv4yG");
parcelRequire("i2Zru");
var $jBIAB = parcelRequire("jBIAB");
parcelRequire("9QTc6");
var $8YM6h = parcelRequire("8YM6h");
parcelRequire("1jLom");
var $jnYRq = parcelRequire("jnYRq");
var $33kIu = parcelRequire("33kIu");
var $7BCns = parcelRequire("7BCns");

var $1EFS8 = parcelRequire("1EFS8");

var $jsmb9 = parcelRequire("jsmb9");
const $26321ff9316ebeaf$var$Error = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $33kIu.Error), null);
const $26321ff9316ebeaf$var$WrappedConversationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7BCns.default), {
        renderError: $26321ff9316ebeaf$var$Error,
        component: (0, $jnYRq.HelpCenterConversationPage),
        screenName: (0, $8rTkC.ScreenName).CONVERSATION_PAGE,
        headerless: true,
        footerless: true
    });
const $26321ff9316ebeaf$export$80dcf24036ea46a1 = ()=>{
    const WrappedComponent = (0, $HGACo.isUnifiedHelpAddFilterForCustomerAccounts)() ? (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($26321ff9316ebeaf$var$WrappedConversationPage, null)) : (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: '/'
    }), (0, $cv4yG.default)())(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($26321ff9316ebeaf$var$WrappedConversationPage, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, null);
};
const $26321ff9316ebeaf$export$ee1ce6de59399f4b = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const forbiddenPageOptions = {
        message: formatMessage((0, $jnYRq.authPageMessage)),
        callToActionText: formatMessage((0, $jnYRq.callToActionUrlText)),
        callToActionUrl: (0, $jsmb9.getHelpCenterUrl)()
    };
    const enhancer = (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: '/'
    }), (0, $hbdiU.default)(forbiddenPageOptions));
    const WrappedComponent = enhancer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($26321ff9316ebeaf$var$WrappedConversationPage, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, null);
};
const $26321ff9316ebeaf$export$c0656a6d05f5099e = ()=>{
    const viewConversationPageRoute = {
        name: (0, $8rTkC.ScreenName).CONVERSATION_PAGE,
        path: (0, $8rTkC.VA_ON_HC_CONVERSATION_PATH),
        exact: true,
        resources: [
            (0, $8IHFj.HelpCenterVirtualAgentResource)
        ],
        component: $26321ff9316ebeaf$export$80dcf24036ea46a1
    };
    return [
        {
            ...viewConversationPageRoute,
            component: $26321ff9316ebeaf$export$ee1ce6de59399f4b
        }
    ];
};
const $26321ff9316ebeaf$export$6cb15740fc92fb28 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [isTestConversationParam] = (0, $hDCsk.useQueryParam)('isTestConversation');
    const [isVSAAdoptionConversation] = (0, $hDCsk.useQueryParam)('vsaAdoption');
    const [portalIdAsString] = (0, $iyRi5.usePathParam)('portalId');
    const forbiddenPageOptions = {
        message: formatMessage((0, $jnYRq.authPageMessage)),
        callToActionText: formatMessage((0, $jnYRq.callToActionUrlText)),
        callToActionUrl: portalIdAsString ? `/portal/${portalIdAsString}` : (0, $jsmb9.getHelpCenterUrl)(),
        hideBanner: (0, $1EFS8.default).checkGate('jsm_vsa_adoption_flickering_issue_fix') && isVSAAdoptionConversation === 'true'
    };
    const enhancer = (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: '/'
    }), ...isTestConversationParam === 'true' ? [
        (0, $8YM6h.default)(forbiddenPageOptions)
    ] : []);
    const WrappedComponent = enhancer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7BCns.default), {
            renderError: $26321ff9316ebeaf$var$Error,
            component: (0, $jnYRq.PortalConversationPage),
            screenName: (0, $8rTkC.ScreenName).CONVERSATION_PAGE,
            headerless: true,
            footerless: true
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, props));
};
const $26321ff9316ebeaf$export$226a8310910111d5 = {
    name: (0, $8rTkC.ScreenName).CONVERSATION_PAGE,
    path: (0, $8rTkC.VA_ON_PORTAL_CONVERSATION_PATH),
    exact: true,
    component: $26321ff9316ebeaf$export$6cb15740fc92fb28
};

});
parcelRegister("8IHFj", function(module, exports) {
$parcel$export(module.exports, "HelpCenterVirtualAgentResource", () => $1609041e49380b6c$export$7ab6648586bf1bbf);

var $HGACo = parcelRequire("HGACo");

var $byuiX = parcelRequire("byuiX");

var $2ZaYt = parcelRequire("2ZaYt");
const $1609041e49380b6c$export$7ab6648586bf1bbf = (0, $byuiX.createRelayResource)({
    type: 'HELP_CENTER_CONVERSATION_PAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $2ZaYt.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                isVaOnHcGAEnabled: (0, $HGACo.isVAOnHelpCenterGAEnabled)()
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("2ZaYt", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cc61c91f9d334dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8315169d8d6438e260c1ba01b65e17df>>
 * @relayHash edea8cab7174eb3853f7e72b44d7aa5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c115be58886ea6ac6426e499fd226521bc50f4439d42461efe307f31039df41
const $0cc61c91f9d334dd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVaOnHcGAEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v6 = {
        "condition": "isVaOnHcGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "VirtualAgentQueryApi",
                "kind": "LinkedField",
                "name": "virtualAgent",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "containerId",
                                "variableName": "helpCenterAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "virtualAgentAvailability"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConversationPageVirtualAgentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConversationPageVirtualAgentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "id": "3c115be58886ea6ac6426e499fd226521bc50f4439d42461efe307f31039df41",
            "metadata": {},
            "name": "ConversationPageVirtualAgentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0cc61c91f9d334dd$var$node.hash = "c8de3321d0f65a7321d319b804610818";
var $0cc61c91f9d334dd$export$2e2bcd8739ae039 = $0cc61c91f9d334dd$var$node;

});


parcelRegister("fZ17l", function(module, exports) {
$parcel$export(module.exports, "withJsmAiConfigEnabled", () => (parcelRequire("hbdiU")).default);

var $hbdiU = parcelRequire("hbdiU");

});
parcelRegister("hbdiU", function(module, exports) {
$parcel$export(module.exports, "default", () => $04e3e22f79ec65d0$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $8rTkC = parcelRequire("8rTkC");

var $4acrp = parcelRequire("4acrp");
parcelRequire("9e24t");
var $8Wisn = parcelRequire("8Wisn");
parcelRequire("3ibrT");
var $lHAZd = parcelRequire("lHAZd");
const $04e3e22f79ec65d0$var$selector = (0, $ehscL.createSelector)((0, $8Wisn.getJsmAIConfigEnabled), (jsmAIConfigEnabled)=>({
        jsmAIConfigEnabled: jsmAIConfigEnabled
    }));
const $04e3e22f79ec65d0$var$connector = (0, $jvoWT.default)($04e3e22f79ec65d0$var$selector, null);
const $04e3e22f79ec65d0$var$withJsmAiConfigEnabled = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { jsmAIConfigEnabled: jsmAIConfigEnabled } = props;
            if (jsmAIConfigEnabled) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $8P7DW.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $8P7DW.createElement((0, $lHAZd.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $8P7DW.createElement((0, $4acrp.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $8rTkC.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        const ConnectedComponent = $04e3e22f79ec65d0$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithJsmAiConfigEnabled';
        return ConnectedComponent;
    };
var $04e3e22f79ec65d0$export$2e2bcd8739ae039 = $04e3e22f79ec65d0$var$withJsmAiConfigEnabled;

});


parcelRegister("cv4yG", function(module, exports) {
$parcel$export(module.exports, "default", () => $68fa5eb1eb9c1104$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $3Wo8f = parcelRequire("3Wo8f");
const $68fa5eb1eb9c1104$var$selector = (0, $ehscL.createSelector)((0, $hx8zX.isAtlassianAccountManaged), (isAtlassianAccount)=>({
        isAtlassianAccount: isAtlassianAccount
    }));
const $68fa5eb1eb9c1104$var$connector = (0, $jvoWT.default)($68fa5eb1eb9c1104$var$selector, null);
const $68fa5eb1eb9c1104$var$withOnlyAtlassianAccount = ()=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isAtlassianAccount: isAtlassianAccount } = props;
            if (isAtlassianAccount) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $8P7DW.createElement(WrappedComponent, props);
            return /*#__PURE__*/ $8P7DW.createElement((0, $3Wo8f.Redirect), {
                to: "/user/forbidden"
            });
        };
        const ConnectedComponent = $68fa5eb1eb9c1104$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyAtlassianAccount';
        return ConnectedComponent;
    };
var $68fa5eb1eb9c1104$export$2e2bcd8739ae039 = $68fa5eb1eb9c1104$var$withOnlyAtlassianAccount;

});

parcelRegister("9QTc6", function(module, exports) {
$parcel$export(module.exports, "withOnlyProjectAdmin", () => (parcelRequire("8YM6h")).default);

var $8YM6h = parcelRequire("8YM6h");

});
parcelRegister("8YM6h", function(module, exports) {
$parcel$export(module.exports, "default", () => $576fa042ddbd0b6c$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $8rTkC = parcelRequire("8rTkC");

var $4acrp = parcelRequire("4acrp");

var $5OWUX = parcelRequire("5OWUX");

var $1We2B = parcelRequire("1We2B");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
parcelRequire("eNGJq");
var $d727K = parcelRequire("d727K");
parcelRequire("1X8UE");
var $73V7l = parcelRequire("73V7l");
parcelRequire("3ibrT");
var $lHAZd = parcelRequire("lHAZd");
const $576fa042ddbd0b6c$var$selector = (0, $ehscL.createSelector)((state, props)=>{
    const portalIdAsString = props.match.params && props.match.params.portalId;
    if (portalIdAsString) return (0, $73V7l.getCanAdministerProject)(state, (0, $1We2B.toNumber)(portalIdAsString));
    return false;
}, (isProjectAdmin)=>({
        isProjectAdmin: isProjectAdmin
    }));
const $576fa042ddbd0b6c$var$connector = (0, $jvoWT.default)($576fa042ddbd0b6c$var$selector, {
    fetchPortals: (0, $d727K.fetchPortalAction)
});
const $576fa042ddbd0b6c$var$withOnlyProjectAdmin = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isProjectAdmin: isProjectAdmin, fetchPortals: fetchPortals } = props;
            const [portalId] = (0, $iyRi5.usePathParam)('portalId');
            $8P7DW.useEffect(()=>{
                if (isProjectAdmin === undefined && options.hideBanner) fetchPortals({
                    id: (0, $1We2B.toSafeInteger)(portalId),
                    expand: [
                        'kbs',
                        'reqTypes',
                        'reqGroups',
                        'orderMapping'
                    ]
                });
            }, [
                isProjectAdmin,
                fetchPortals,
                portalId
            ]);
            if (isProjectAdmin === undefined) return options.hideBanner ? /*#__PURE__*/ $8P7DW.createElement((0, $5OWUX.default), null) : /*#__PURE__*/ $8P7DW.createElement((0, $lHAZd.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $8P7DW.createElement((0, $5OWUX.default), null),
                layoutProps: {
                    headerless: false,
                    fadeInSearchModal: true
                }
            });
            if (isProjectAdmin) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $8P7DW.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $8P7DW.createElement((0, $lHAZd.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $8P7DW.createElement((0, $4acrp.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $8rTkC.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        // @ts-ignore
        const ConnectedComponent = $576fa042ddbd0b6c$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'withOnlyProjectAdmin';
        return ConnectedComponent;
    };
var $576fa042ddbd0b6c$export$2e2bcd8739ae039 = $576fa042ddbd0b6c$var$withOnlyProjectAdmin;

});


parcelRegister("1jLom", function(module, exports) {
$parcel$export(module.exports, "Layout", () => (parcelRequire("7BCns")).default);
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("33kIu")).Error);
$parcel$export(module.exports, "HelpCenterConversationPage", () => (parcelRequire("jnYRq")).HelpCenterConversationPage);
$parcel$export(module.exports, "PortalConversationPage", () => (parcelRequire("jnYRq")).PortalConversationPage);
$parcel$export(module.exports, "authPageMessage", () => (parcelRequire("jnYRq")).authPageMessage);
$parcel$export(module.exports, "callToActionUrlText", () => (parcelRequire("jnYRq")).callToActionUrlText);

var $7BCns = parcelRequire("7BCns");
parcelRequire("glGyn");
var $33kIu = parcelRequire("33kIu");

var $jnYRq = parcelRequire("jnYRq");

});
parcelRegister("7BCns", function(module, exports) {
$parcel$export(module.exports, "default", () => $24918ca1157925dd$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("ebTjc");
var $datZD = parcelRequire("datZD");

const $24918ca1157925dd$var$LoadAppLazily = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("2Qif1")).then(({ App: App })=>(0, $datZD.default)(App)), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/app/App.tsx"
    })
});
const $24918ca1157925dd$var$Layout = ({ component: component, screenName: screenName, renderError: renderError, headerless: headerless = false, footerless: footerless = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($24918ca1157925dd$var$LoadAppLazily, {
        component: component,
        screenName: screenName,
        renderError: renderError,
        layoutProps: {
            headerless: headerless,
            footerless: footerless
        }
    });
};
var $24918ca1157925dd$export$2e2bcd8739ae039 = $24918ca1157925dd$var$Layout;

});
parcelRegister("2Qif1", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("d3buT"),
    $j9MRt("biLKh")
]).then(()=>parcelRequire('cdfhX'));

});


parcelRegister("glGyn", function(module, exports) {
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("33kIu")).Error);

var $33kIu = parcelRequire("33kIu");

});
parcelRegister("33kIu", function(module, exports) {
$parcel$export(module.exports, "Error", () => $ca02bf46539fc6cb$export$edf27be85e5f6da0);

var $8P7DW = parcelRequire("8P7DW");

var $l4cjO = parcelRequire("l4cjO");
var $5jYgE = parcelRequire("5jYgE");
parcelRequire("5NIXX");
var $fuc2f = parcelRequire("fuc2f");

var $eAibY = parcelRequire("eAibY");
const $ca02bf46539fc6cb$export$edf27be85e5f6da0 = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fuc2f.default), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), (0, $eAibY.default).errorTitle),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, formatMessage((0, $eAibY.default).errorDescriptionText, {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("a", {
                    href: "/servicedesk"
                }, chunks)
        })),
        hideFooter: true
    });
};

});
parcelRegister("eAibY", function(module, exports) {
$parcel$export(module.exports, "default", () => $33089e1eeedd298f$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $33089e1eeedd298f$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    errorTitle: {
        defaultMessage: "We couldn\u2019t load this page",
        description: 'Text on show more results button',
        id: 'unified-help.error.page.title'
    },
    errorDescriptionText: {
        defaultMessage: 'Try refreshing the page or head to your <a>help center</a>.',
        description: 'Text for label on show more results icon',
        id: 'unified-help.error.page.description.text'
    }
});

});



parcelRegister("jnYRq", function(module, exports) {
$parcel$export(module.exports, "HelpCenterConversationPage", () => $6b1bd12374a132fc$export$1ebb9e18779d3716);
$parcel$export(module.exports, "PortalConversationPage", () => $6b1bd12374a132fc$export$68489d6e6f9646e7);
$parcel$export(module.exports, "callToActionUrlText", () => $6b1bd12374a132fc$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $6b1bd12374a132fc$export$5342e2a00fe6d647);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

var $g2x3f = parcelRequire("g2x3f");

const $6b1bd12374a132fc$export$1ebb9e18779d3716 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("6KEPM")), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/pages/conversation-page/ConversationPage.tsx"
    })
});

const $6b1bd12374a132fc$export$68489d6e6f9646e7 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("03dUV")), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/pages/portal-conversation-page/PortalConversationPage.tsx"
    })
});
const $6b1bd12374a132fc$export$d96795d242b62963 = (0, $g2x3f.default).callToActionUrlText;
const $6b1bd12374a132fc$export$5342e2a00fe6d647 = (0, $g2x3f.default).authPageMessage;

});
parcelRegister("g2x3f", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa1041dbe4976242$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $fa1041dbe4976242$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal',
        id: 'conversation.home.page.un.auth.action.message.nonFinal'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to portal',
        description: 'Call to action text for unauthorized page of portal',
        id: 'conversation.home.page.un.auth.action.text.nonFinal'
    }
});

});

parcelRegister("6KEPM", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("kkO5y"),
    $j9MRt("8uIxy"),
    $j9MRt("fvR1S"),
    $j9MRt("21HHS"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("1mY5c"),
    $j9MRt("70snJ"),
    $j9MRt("ffePP"),
    $j9MRt("3jUo4"),
    $j9MRt("2fbJv"),
    $j9MRt("j60P8"),
    $j9MRt("aXPEi"),
    $j9MRt("4RNdI"),
    $j9MRt("hXkjJ"),
    $j9MRt("7Zi76"),
    $j9MRt("7FtPh"),
    $j9MRt("1z2hL"),
    $j9MRt("clTPs"),
    $j9MRt("glmjZ"),
    $j9MRt("apr9b"),
    $j9MRt("ikoh2"),
    $j9MRt("ffUPr"),
    $j9MRt("d3buT"),
    $j9MRt("hTBTM")
]).then(()=>parcelRequire('9jEAI'));

});

parcelRegister("03dUV", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("kkO5y"),
    $j9MRt("8uIxy"),
    $j9MRt("fvR1S"),
    $j9MRt("21HHS"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("1mY5c"),
    $j9MRt("70snJ"),
    $j9MRt("ffePP"),
    $j9MRt("3jUo4"),
    $j9MRt("2fbJv"),
    $j9MRt("j60P8"),
    $j9MRt("aXPEi"),
    $j9MRt("4RNdI"),
    $j9MRt("hXkjJ"),
    $j9MRt("7Zi76"),
    $j9MRt("7FtPh"),
    $j9MRt("1z2hL"),
    $j9MRt("clTPs"),
    $j9MRt("glmjZ"),
    $j9MRt("apr9b"),
    $j9MRt("ikoh2"),
    $j9MRt("ffUPr"),
    $j9MRt("d3buT"),
    $j9MRt("dEat9")
]).then(()=>parcelRequire('4ufxl'));

});




parcelRegister("bPECR", function(module, exports) {
$parcel$export(module.exports, "requestsListRoute", () => $17c353a343003e4f$export$28cf91f271fafef3);

var $8rTkC = parcelRequire("8rTkC");

var $7EEKy = parcelRequire("7EEKy");

var $bpyxC = parcelRequire("bpyxC");
const $17c353a343003e4f$var$route = {
    name: 'requests-list',
    path: '/user/requests',
    exact: true,
    component: (0, $7EEKy.RequestList)
};
const $17c353a343003e4f$var$screeName = (0, $8rTkC.ScreenName).REQUEST_LIST;
const $17c353a343003e4f$var$paperAppearance = 'xxwide';
const $17c353a343003e4f$var$layoutProps = {
    paperAppearance: $17c353a343003e4f$var$paperAppearance,
    fadeInSearchModal: true
};
const $17c353a343003e4f$export$28cf91f271fafef3 = (0, $bpyxC.createRouteWithLayout)($17c353a343003e4f$var$route, $17c353a343003e4f$var$screeName, $17c353a343003e4f$var$layoutProps);

});

parcelRegister("eD4ZV", function(module, exports) {
$parcel$export(module.exports, "getSurveyRoute", () => $f14a495122a291bd$export$7cb84a2d5bf6d9c9);

var $8rTkC = parcelRequire("8rTkC");

var $bpyxC = parcelRequire("bpyxC");

var $30uLW = parcelRequire("30uLW");
const $f14a495122a291bd$export$7cb84a2d5bf6d9c9 = ()=>(0, $bpyxC.createRouteWithLayout)({
        name: 'survey',
        path: '/portal/:portalId/survey/:surveyId',
        exact: true,
        component: (0, $30uLW.AsyncSurveyDetails),
        resources: []
    }, (0, $8rTkC.ScreenName).SURVEY, {
        fadeInSearchModal: true,
        paperAppearance: 'xxwide'
    });

});
parcelRegister("30uLW", function(module, exports) {
$parcel$export(module.exports, "AsyncSurveyDetails", () => $aa0f266a45fb7e3c$export$b01dbc7a6c5c4fed);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

const $aa0f266a45fb7e3c$export$b01dbc7a6c5c4fed = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("iX7Au")), {
        moduleId: "./packages/surveys/src/Survey.tsx"
    })
});

});
parcelRegister("iX7Au", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("jVUFf"),
    $j9MRt("gRGGD"),
    $j9MRt("1j2Ac"),
    $j9MRt("fSmVB"),
    $j9MRt("5RZmE"),
    $j9MRt("atrci"),
    $j9MRt("7UfmT"),
    $j9MRt("2vnhP"),
    $j9MRt("fepL7"),
    $j9MRt("fOjDa"),
    $j9MRt("4yagt")
]).then(()=>parcelRequire('fiUvS'));

});



parcelRegister("idbbE", function(module, exports) {
$parcel$export(module.exports, "resourcesPlugin", () => $d8430d6228c1a3fd$export$f4f160418a82e3b7);

var $jByYr = parcelRequire("jByYr");
parcelRequire("889Kb");
var $4uyrL = parcelRequire("4uyrL");

var $bXs4i = parcelRequire("bXs4i");
const $d8430d6228c1a3fd$var$customContext = {
    cloudId: (0, $jByYr.getCloudId)(),
    productName: (0, $bXs4i.PROJECT_NAME),
    helpCenterAri: (0, $jByYr.getHelpCenterAri)(),
    workspaceAri: (0, $jByYr.getWorkspaceAri)(),
    layoutAri: (0, $jByYr.getLayoutAri)(),
    isUserLoggedIn: Boolean((0, $jByYr.getMeta)('ajs-atlassian-account-id')),
    accountType: (0, $jByYr.getMeta)('ajs-account-type') || ''
};
const $d8430d6228c1a3fd$export$f4f160418a82e3b7 = (0, $4uyrL.createResourcesPlugin)({
    context: $d8430d6228c1a3fd$var$customContext
});

});



parcelRegister("auztA", function(module, exports) {
$parcel$export(module.exports, "helpCenterViewHomePageExperience", () => $294afa021eb5637b$export$deb53e4c26a043b6);

var $lQb0x = parcelRequire("lQb0x");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $294afa021eb5637b$export$deb53e4c26a043b6 = new (0, $ghwxF.UFOExperience)((0, $lQb0x.helpCenterViewHomePageExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("2qHaK", function(module, exports) {
$parcel$export(module.exports, "default", () => $a685df9aaa500e1a$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $2UsNA = parcelRequire("2UsNA");

var $1pfMV = parcelRequire("1pfMV");

var $HGACo = parcelRequire("HGACo");

var $3Z4c2 = parcelRequire("3Z4c2");

var $fOqPA = parcelRequire("fOqPA");
parcelRequire("9wocP");
var $jT4Pl = parcelRequire("jT4Pl");
var $3vYjO = parcelRequire("3vYjO");

var $5IuVE = parcelRequire("5IuVE");

var $3wAsA = parcelRequire("3wAsA");

var $anUvS = parcelRequire("anUvS");

var $g7bTY = parcelRequire("g7bTY");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $9PD2z = parcelRequire("9PD2z");

var $1EFS8 = parcelRequire("1EFS8");

var $1lG1b = parcelRequire("1lG1b");

var $7FSs7 = parcelRequire("7FSs7");

var $idbbE = parcelRequire("idbbE");
parcelRequire("9QKIl");
var $9t02C = parcelRequire("9t02C");
const $a685df9aaa500e1a$export$4c59d19d881588b9 = (props)=>{
    //Order matters here
    const routes = (0, $8P7DW.useMemo)(()=>{
        const includeRovoAgentRoute = (0, $1EFS8.default).checkGate('use_frontend_feature_encoding_sdk_help_center') ? (0, $1pfMV.isFeatureEnabled)('jira-service-management', 'jsm-help-center-rovo-agent') : !(0, $1lG1b.isFedRamp)() && (0, $1EFS8.default).checkGate('jsm_help_center_one-click_rovo_agent');
        const includeVirtualAgentRoute = (0, $1EFS8.default).checkGate('use_frontend_feature_encoding_sdk_help_center') ? (0, $1pfMV.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent') : !(0, $1lG1b.isFedRamp)();
        return [
            ...(0, $HGACo.isProjectMappingInHelpCenterEnabled)() ? [
                (0, $3wAsA.helpcenterEditRoute),
                (0, $3wAsA.helpcenterManageProjectsRoute),
                ...(0, $HGACo.isCustomPagesUiEnabled)() ? [
                    (0, $3wAsA.helpcenterManageCustomPagesRoute)
                ] : [],
                ...(0, $1EFS8.default).checkGate('enable-jsm-in-hubs') ? [
                    ...(0, $1EFS8.default).checkGate('portal-pages-in-hub') ? [
                        (0, $3wAsA.hubEditPortalLayoutRoute)
                    ] : [],
                    (0, $3wAsA.hubEditLayoutRoute)
                ] : []
            ] : [],
            // Feature gate: jsm_help_center_one-click_rovo_agent
            ...includeRovoAgentRoute ? [
                (0, $5IuVE.helpcenterRovoServiceAgentRoute)
            ] : [],
            ...includeVirtualAgentRoute ? [
                (0, $anUvS.helpcenterVirtualAgentRoute)
            ] : [],
            (0, $g7bTY.viewHelpCentersManagementPageRoute),
            ...(0, $1EFS8.default).checkGate('enable-jsm-in-hubs') ? [
                (0, $g7bTY.viewHelpHubsManagementPageRoute)
            ] : [],
            (0, $9t02C.notFoundErrorRoute)
        ];
    }, []);
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $3Z4c2.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $3Z4c2.lightenColor)(themeColor);
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2UsNA.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3vYjO.Router), {
        routes: routes,
        history: (0, $7FSs7.default),
        isGlobal: false,
        plugins: [
            (0, $idbbE.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fOqPA.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9PD2z.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jT4Pl.RouteComponent), null)));
};
const $a685df9aaa500e1a$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getThemeColor), (0, $ikoP4.getHelpCenterTitleColor), (themeColor, titleColor)=>({
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $a685df9aaa500e1a$export$2e2bcd8739ae039 = (0, $jvoWT.default)($a685df9aaa500e1a$var$selector)($a685df9aaa500e1a$export$4c59d19d881588b9);

});
parcelRegister("5IuVE", function(module, exports) {
$parcel$export(module.exports, "helpcenterRovoServiceAgentRoute", () => $1252755e91d78cad$export$b887b8f40276e27c);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $hxVai = parcelRequire("hxVai");

var $gweXC = parcelRequire("gweXC");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("9wocP");
var $bDnSZ = parcelRequire("bDnSZ");
parcelRequire("chjsC");
var $h2NCY = parcelRequire("h2NCY");
parcelRequire("i2Zru");
var $jBIAB = parcelRequire("jBIAB");

var $1nQ48 = parcelRequire("1nQ48");
parcelRequire("6bvX1");
var $i3cng = parcelRequire("i3cng");

var $2aBl3 = parcelRequire("2aBl3");

const $1252755e91d78cad$var$AsyncRovoServiceAgentPage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("3uJjL")).then((module)=>({
                default: module.RovoServiceAgentSettingsPageLoader
            })), {
        moduleId: "./packages/rovo-service-agent/rovo-service-agent-settings/src/index.tsx"
    })
});
const $1252755e91d78cad$var$RovoServiceAgentPage = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const WrappedComponent = (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: '/'
    }), (0, $h2NCY.default)({
        message: formatMessage((0, $1nQ48.authPageMessage)),
        callToActionText: formatMessage((0, $1nQ48.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $i3cng.default), {
            featureName: "Rovo Service Agent Settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($1252755e91d78cad$var$AsyncRovoServiceAgentPage, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, null);
};
const $1252755e91d78cad$export$b887b8f40276e27c = {
    name: 'rovoServiceAgentSettings',
    path: '/:helpcenterId/rovo-agent',
    exact: true,
    resources: [
        (0, $2aBl3.HelpCenterRovoServiceAgentResource)
    ],
    component: (0, $bDnSZ.withRouter)($1252755e91d78cad$var$RovoServiceAgentPage)
};

});
parcelRegister("6bvX1", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("i3cng")).default);
$parcel$export(module.exports, "useHelpCenterAri", () => (parcelRequire("dSz79")).useHelpCenterAri);
$parcel$export(module.exports, "useConditionalMessage", () => (parcelRequire("Jhmxx")).useConditionalMessage);
parcelRequire("iJZk0");
var $i3cng = parcelRequire("i3cng");

var $dSz79 = parcelRequire("dSz79");

var $Jhmxx = parcelRequire("Jhmxx");

});
parcelRegister("iJZk0", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("i3cng")).default);
parcelRequire("irqBT");
var $i3cng = parcelRequire("i3cng");
parcelRequire("dnZw2");
var $bxvY7 = parcelRequire("bxvY7");

var $h4dv2 = parcelRequire("h4dv2");

});
parcelRegister("irqBT", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("i3cng")).default);

var $i3cng = parcelRequire("i3cng");

});
parcelRegister("i3cng", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ee8555a8a62eb5f$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $edC7N = parcelRequire("edC7N");

var $HGACo = parcelRequire("HGACo");

var $fOqPA = parcelRequire("fOqPA");

var $k1tWg = parcelRequire("k1tWg");

var $3ZeMI = parcelRequire("3ZeMI");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");
var $i9cdb = parcelRequire("i9cdb");
parcelRequire("ax322");
var $hx8zX = parcelRequire("hx8zX");

var $3pqTD = parcelRequire("3pqTD");

var $6Bfdg = parcelRequire("6Bfdg");

var $1EFS8 = parcelRequire("1EFS8");

var $2Q894 = parcelRequire("2Q894");

var $7cjnx = parcelRequire("7cjnx");

var $8gFTG = parcelRequire("8gFTG");

var $bfTlX = parcelRequire("bfTlX");

var $B7y7y = parcelRequire("B7y7y");

var $5JQIe = parcelRequire("5JQIe");

var $k2Ig6 = parcelRequire("k2Ig6");
var $9qqCD = parcelRequire("9qqCD");
var $j9fRu = parcelRequire("j9fRu");
var $cM8t6 = parcelRequire("cM8t6");
var $108jv = parcelRequire("108jv");

var $6Hfjm = parcelRequire("6Hfjm");
var $2Mjg8 = parcelRequire("2Mjg8");
var $37U6z = parcelRequire("37U6z");

var $hrPHR = parcelRequire("hrPHR");

var $fsZf3 = parcelRequire("fsZf3");

var $42qw9 = parcelRequire("42qw9");

var $aJI9b = parcelRequire("aJI9b");
parcelRequire("gw77d");
var $3Jwcb = parcelRequire("3Jwcb");
parcelRequire("3Ip9l");
var $eoJ1i = parcelRequire("eoJ1i");

var $20PEm = parcelRequire("20PEm");
const $7ee8555a8a62eb5f$var$AdminManagementLayoutContentBase = ({ children: children, featureName: featureName, hasSiteAdministerAccess: hasSiteAdministerAccess, hideSidebar: hideSidebar })=>{
    const [{ route: route }, { push: push }] = (0, $i9cdb.useRouter)();
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [helpCenterId = ''] = (0, $iyRi5.usePathParam)('helpcenterId');
    const { name: routeName } = route;
    const { isHelpHub: isHelpHub } = (0, $42qw9.useHelpCenterType)();
    const rovoServiceAgentRouteName = 'rovoServiceAgentSettings';
    const rovoServiceAgentUrl = `/${helpCenterId}/rovo-agent`;
    const virtualAgentRouteName = 'virtualAgentSettings';
    const virtualAgentUrl = `/${helpCenterId}/virtual-agent`;
    const mapProjectsScreenUrl = `/${helpCenterId}/projects`;
    const mapPagesScreenUrl = `/${helpCenterId}/pages`;
    const editProjectDetailsScreenUrl = `/${helpCenterId}/details`;
    const navigationContentItems = [
        {
            onClick: ()=>push(editProjectDetailsScreenUrl),
            text: formatMessage((0, $20PEm.default).helpcenterDetailsItem),
            isVisible: (0, $HGACo.isProjectMappingInHelpCenterEnabled)(),
            isSelected: routeName === 'edit-details',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($B7y7y))), {
                label: formatMessage((0, $20PEm.default).helpcenterDetailsItem)
            })
        },
        {
            onClick: ()=>push(mapProjectsScreenUrl),
            text: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $20PEm.default).helpcenterManageProjectsItemGalaxia) : formatMessage((0, $20PEm.default).helpcenterManageProjectsItem),
            isSelected: routeName === 'manage-projects',
            isVisible: (0, $HGACo.isProjectMappingInHelpCenterEnabled)(),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7cjnx))), {
                label: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $20PEm.default).helpcenterManageProjectsItemGalaxia) : formatMessage((0, $20PEm.default).helpcenterManageProjectsItem)
            })
        }
    ];
    // The manage-pages page is only an upsell for non-premium users.
    // So we only show it for premium users or users with billing permission.
    if ((0, $hrPHR.getIsHCCustomizationEnabled)() || hasSiteAdministerAccess) navigationContentItems.push({
        onClick: ()=>push(mapPagesScreenUrl),
        text: formatMessage((0, $20PEm.default).helpcenterManagePagesItem),
        isSelected: routeName === 'manage-pages',
        isVisible: (0, $HGACo.isCustomPagesUiEnabled)() && !isHelpHub,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8gFTG))), {
            label: formatMessage((0, $20PEm.default).helpcenterManagePagesItem)
        })
    });
    // Rovo Agent - independent of VSA settings
    // Feature gate: jsm_help_center_one-click_rovo_agent
    navigationContentItems.push({
        onClick: ()=>push(rovoServiceAgentUrl),
        text: formatMessage((0, $20PEm.default).helpcenterRovoServiceAgentItem),
        isSelected: routeName === rovoServiceAgentRouteName,
        isVisible: (0, $1EFS8.default).checkGate('jsm_help_center_one-click_rovo_agent'),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bfTlX))), {
            label: formatMessage((0, $20PEm.default).helpcenterRovoServiceAgentItem)
        })
    });
    // Virtual Service Agent
    if (!(0, $HGACo.isHideVsaEndpointsEnabled)() && !(0, $fsZf3.isPremiumUpsellExperimentEnabled)({
        hasSiteAdministerAccess: hasSiteAdministerAccess,
        isHCCustomizationEnabled: (0, $hrPHR.getIsHCCustomizationEnabled)()
    })) navigationContentItems.push({
        onClick: ()=>push(virtualAgentUrl),
        text: formatMessage((0, $20PEm.default).helpcenterVsaReportingItem),
        isSelected: routeName === virtualAgentRouteName,
        isVisible: (0, $hrPHR.getJsmAIConfigEnabled)() && !isHelpHub,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Q894))), {
            label: formatMessage((0, $20PEm.default).helpcenterVsaReportingItem)
        })
    });
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Bfdg.default), {
            header: formatMessage((0, $20PEm.default).errorTitle),
            description: formatMessage((0, $20PEm.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3ZeMI)))
        });
    };
    const packageName = ()=>{
        switch(routeName){
            case 'edit-details':
                return 'editDetails';
            case 'manage-projects':
                return 'manageProjects';
            case 'manage-pages':
                return 'managePages';
            case 'rovoServiceAgentSettings':
                return 'rovoServiceAgentSettings';
            case 'virtualAgentSettings':
                return 'virtualAgentSettings';
            case 'reporting':
                return 'reporting';
            default:
                return 'unknown';
        }
    };
    const isTablet = !(0, $3pqTD.useMediaQuery)(`(max-width: ${(0, $k1tWg.sizes).xsmall}px)`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5JQIe.default), {
        blanketIsTinted: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $7ee8555a8a62eb5f$var$pageLayoutWrapper,
        testId: "admin-layout-management-page-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cM8t6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $108jv.default), {
        isFixed: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3Jwcb.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9qqCD.default), null, isTablet && !hideSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eoJ1i.default), {
        width: (0, $aJI9b.SIDEBAR_WIDTH),
        navigationContentItems: navigationContentItems,
        featureName: featureName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $7ee8555a8a62eb5f$var$bodyContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $j9fRu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: packageName(),
        id: 'admin-layout-management-page',
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: [
            $7ee8555a8a62eb5f$var$container,
            !hideSidebar && $7ee8555a8a62eb5f$var$containerWithMaxWidth
        ]
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fOqPA.NewGlobalBGColor), null)))));
};
const $7ee8555a8a62eb5f$var$selector = (0, $ehscL.createSelector)((state)=>{
    return {
        hasSiteAdministerAccess: (0, $hx8zX.getHasSiteAdministerAccess)(state)
    };
}, ({ hasSiteAdministerAccess: hasSiteAdministerAccess })=>({
        hasSiteAdministerAccess: hasSiteAdministerAccess
    }));
const $7ee8555a8a62eb5f$var$AdminManagementLayoutContent = (0, $jvoWT.default)($7ee8555a8a62eb5f$var$selector)($7ee8555a8a62eb5f$var$AdminManagementLayoutContentBase);
const $7ee8555a8a62eb5f$export$b52b33be5684c42c = ({ children: children, featureName: featureName, hideSidebar: hideSidebar = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $42qw9.HelpCenterTypeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($7ee8555a8a62eb5f$var$AdminManagementLayoutContent, {
        featureName: featureName,
        hideSidebar: hideSidebar
    }, children)));
};
var $7ee8555a8a62eb5f$export$2e2bcd8739ae039 = $7ee8555a8a62eb5f$export$b52b33be5684c42c;
const $7ee8555a8a62eb5f$var$container = (0, $37U6z.xcss)({
    margin: '0 auto',
    paddingBottom: 'space.050',
    paddingInline: 'space.600',
    [(0, $2Mjg8.media).above.lg]: {
        paddingInline: 'space.0'
    }
});
const $7ee8555a8a62eb5f$var$containerWithMaxWidth = (0, $37U6z.xcss)({
    maxWidth: '1160px'
});
const $7ee8555a8a62eb5f$var$pageLayoutWrapper = (0, $37U6z.xcss)({
    overflowAnchor: 'none',
    height: '100%'
});
const $7ee8555a8a62eb5f$var$bodyContainer = (0, $37U6z.xcss)({
    overflow: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: `calc(100vh - (${(0, $k2Ig6.TOP_NAVIGATION_HEIGHT)} + ${(0, $k2Ig6.BANNER_HEIGHT)}))`,
    width: '100%'
});

});
parcelRegister("3ZeMI", function(module, exports) {
module.exports = new URL("../images/project-mapping-error.ef7a4be3.svg", import.meta.url).toString();

});

parcelRegister("3pqTD", function(module, exports) {
$parcel$export(module.exports, "useMediaQuery", () => $3840b7610c5d1700$export$32d5543ab307c01);

var $8P7DW = parcelRequire("8P7DW");

var $1We2B = parcelRequire("1We2B");
function $3840b7610c5d1700$export$32d5543ab307c01(query) {
    const [match, setMatch] = $8P7DW.useState(false);
    $8P7DW.useEffect(()=>{
        function screenTest(e) {
            setMatch(Boolean(e.matches));
        }
        if (window && Object.prototype.hasOwnProperty.call(window, 'matchMedia')) {
            const mql = window.matchMedia(query);
            /**
       * Trigger the screenTest even for the first call
       */ screenTest(mql);
            mql.addListener(screenTest);
            return ()=>{
                mql.removeListener(screenTest);
            };
        }
        return 0, $1We2B.noop;
    }, [
        query
    ]);
    return match;
}

});

parcelRegister("6Bfdg", function(module, exports) {
$parcel$export(module.exports, "default", () => $109432595abb8fd6$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $jp1Tm = parcelRequire("jp1Tm");

var $iqJis = parcelRequire("iqJis");

var $2CGHX = parcelRequire("2CGHX");
var $9pb7J = parcelRequire("9pb7J");

var $cjn3r = parcelRequire("cjn3r");

var $eFivs = parcelRequire("eFivs");

var $dYUHr = parcelRequire("dYUHr");

var $3wInK = parcelRequire("3wInK");

var $1jYOA = parcelRequire("1jYOA");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $109432595abb8fd6$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $eFivs.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $jp1Tm.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1jYOA.default), {
                children: isLoading && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $dYUHr.default), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3wInK.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $9pb7J.default), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $109432595abb8fd6$export$2e2bcd8739ae039 = $109432595abb8fd6$var$EmptyState;

});
parcelRegister("eFivs", function(module, exports) {
$parcel$export(module.exports, "default", () => $52614441a590e58c$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $52614441a590e58c$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $52614441a590e58c$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $8n1kL.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
var $52614441a590e58c$export$2e2bcd8739ae039 = $52614441a590e58c$var$ActionsContainer;

});

parcelRegister("dYUHr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac0f0ac7be22dd2c$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $ac0f0ac7be22dd2c$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $ac0f0ac7be22dd2c$var$wideContainerStyles = null;
const $ac0f0ac7be22dd2c$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $ac0f0ac7be22dd2c$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
var $ac0f0ac7be22dd2c$export$2e2bcd8739ae039 = $ac0f0ac7be22dd2c$var$Container;

});

parcelRegister("3wInK", function(module, exports) {
$parcel$export(module.exports, "default", () => $91ef07b402425f07$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $91ef07b402425f07$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $91ef07b402425f07$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $91ef07b402425f07$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $91ef07b402425f07$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $gWgPx.jsx)("img", {
        style: {
            [$91ef07b402425f07$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$91ef07b402425f07$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $8n1kL.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $91ef07b402425f07$export$2e2bcd8739ae039 = $91ef07b402425f07$var$Image;

});

parcelRegister("1jYOA", function(module, exports) {
$parcel$export(module.exports, "default", () => $00567a82bf63f940$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $00567a82bf63f940$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $00567a82bf63f940$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        className: (0, $8n1kL.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
var $00567a82bf63f940$export$2e2bcd8739ae039 = $00567a82bf63f940$var$SpinnerContainer;

});


parcelRegister("8gFTG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48827792ad56aec1327e3c5557d624a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60505143e8d20d39$var$_react = $60505143e8d20d39$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $60505143e8d20d39$var$_baseNew = $60505143e8d20d39$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $60505143e8d20d39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60505143e8d20d39$var$PagesIcon = (props)=>/*#__PURE__*/ $60505143e8d20d39$var$_react.default.createElement($60505143e8d20d39$var$_baseNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$60505143e8d20d39$var$PagesIcon.displayName = 'PagesIcon';
var $60505143e8d20d39$var$_default = module.exports.default = $60505143e8d20d39$var$PagesIcon;

});

parcelRegister("bfTlX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $831c0867a5995972$var$_react = $831c0867a5995972$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $831c0867a5995972$var$_baseNew = $831c0867a5995972$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $831c0867a5995972$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $831c0867a5995972$var$RovoIcon = (props)=>/*#__PURE__*/ $831c0867a5995972$var$_react.default.createElement($831c0867a5995972$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$831c0867a5995972$var$RovoIcon.displayName = 'RovoIcon';
var $831c0867a5995972$var$_default = module.exports.default = $831c0867a5995972$var$RovoIcon;

});

parcelRegister("B7y7y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac60b703236e33e11860080af1a47ce0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $06f94ff4fadac149$var$_react = $06f94ff4fadac149$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $06f94ff4fadac149$var$_baseNew = $06f94ff4fadac149$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $06f94ff4fadac149$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Wrench".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $06f94ff4fadac149$var$WrenchIcon = (props)=>/*#__PURE__*/ $06f94ff4fadac149$var$_react.default.createElement($06f94ff4fadac149$var$_baseNew.default, Object.assign({
        name: "WrenchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.5 1.5a4 4 0 0 0-3.614 5.718.75.75 0 0 1-.146.853l-4.95 4.95a.841.841 0 0 0 1.189 1.19l4.95-4.95a.75.75 0 0 1 .853-.147 4 4 0 0 0 5.667-4.252L12.03 7.28a.75.75 0 0 1-1.06 0L8.72 5.03a.75.75 0 0 1 0-1.06l2.419-2.42a4 4 0 0 0-.639-.05M5 5.5A5.5 5.5 0 0 1 12.863.532a.75.75 0 0 1 .208 1.208L10.31 4.5l1.19 1.19 2.76-2.76a.75.75 0 0 1 1.208.207 5.5 5.5 0 0 1-6.832 7.539L4.038 15.27a2.34 2.34 0 1 1-3.31-3.31l4.595-4.596A5.5 5.5 0 0 1 5 5.5" clip-rule="evenodd"/>`
    }, props));
$06f94ff4fadac149$var$WrenchIcon.displayName = 'WrenchIcon';
var $06f94ff4fadac149$var$_default = module.exports.default = $06f94ff4fadac149$var$WrenchIcon;

});

parcelRegister("108jv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e576a4a939b8317$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $k2Ig6 = parcelRequire("k2Ig6");

var $9toUq = parcelRequire("9toUq");

var $bJtLq = parcelRequire("bJtLq");
var $43fXs = parcelRequire("43fXs");

var $7QrIq = parcelRequire("7QrIq");

var $9FUL5 = parcelRequire("9FUL5");
const $9e576a4a939b8317$var$topNavigationStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $k2Ig6.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $k2Ig6.TOP_NAVIGATION)
});
const $9e576a4a939b8317$var$fixedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $k2Ig6.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $k2Ig6.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $k2Ig6.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $9e576a4a939b8317$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $k2Ig6.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $9toUq.resolveDimension)((0, $k2Ig6.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $8P7DW.useEffect)(()=>{
        (0, $bJtLq.default)({
            [(0, $k2Ig6.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $bJtLq.default)({
                [(0, $k2Ig6.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $43fXs.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $7QrIq.default), null, ({ className: className })=>/*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            css: [
                $9e576a4a939b8317$var$topNavigationStyles,
                isFixed && $9e576a4a939b8317$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $9toUq.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $9FUL5.default), {
            variableName: (0, $k2Ig6.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $9e576a4a939b8317$export$2e2bcd8739ae039 = $9e576a4a939b8317$var$TopNavigation;

});
parcelRegister("bJtLq", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa61b58d5e4f8ab0$export$2e2bcd8739ae039);

var $9toUq = parcelRequire("9toUq");
const $aa61b58d5e4f8ab0$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $9toUq.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $9toUq.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $aa61b58d5e4f8ab0$export$2e2bcd8739ae039 = $aa61b58d5e4f8ab0$var$publishGridState;

});

parcelRegister("9FUL5", function(module, exports) {
$parcel$export(module.exports, "default", () => $28c74d70bea983f6$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $2Mjg8 = parcelRequire("2Mjg8");
/**
 * Hoists slot dimension styles to the root element.
 */ const $28c74d70bea983f6$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $2Mjg8.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gWgPx.jsx)("style", {
        children: style
    }));
};
var $28c74d70bea983f6$export$2e2bcd8739ae039 = $28c74d70bea983f6$var$SlotDimensions;

});


parcelRegister("42qw9", function(module, exports) {
$parcel$export(module.exports, "HelpCenterTypeProvider", () => $1748612c5907cc62$export$d53895d6fb159859);
$parcel$export(module.exports, "useHelpCenterType", () => $1748612c5907cc62$export$f4dfe81df1da8e40);
$parcel$export(module.exports, "useOptionalHelpCenterType", () => $1748612c5907cc62$export$9f436e6b1d27b8b1);

var $cidpP = parcelRequire("cidpP");

var $8P7DW = parcelRequire("8P7DW");

var $jByYr = parcelRequire("jByYr");

var $h3cOB = parcelRequire("h3cOB");

var $dSz79 = parcelRequire("dSz79");
const $1748612c5907cc62$var$HelpCenterTypeContext = /*#__PURE__*/ (0, $8P7DW.createContext)(undefined);
const $1748612c5907cc62$export$d53895d6fb159859 = ({ children: children })=>{
    var _data$helpCenter;
    const helpCenterAri = (0, $dSz79.useHelpCenterAri)();
    const cloudId = (0, $jByYr.getCloudId)();
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $cidpP.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    const helpCenterById = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const helpCenterType = (helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.type) ?? null;
    const isHelpHub = helpCenterType === 'HELP_HUB';
    const value = {
        helpCenterType: helpCenterType,
        isHelpHub: isHelpHub
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($1748612c5907cc62$var$HelpCenterTypeContext.Provider, {
        value: value
    }, children);
};
const $1748612c5907cc62$export$f4dfe81df1da8e40 = ()=>{
    const context = (0, $8P7DW.useContext)($1748612c5907cc62$var$HelpCenterTypeContext);
    if (context === undefined) throw new Error('useHelpCenterType must be used within a HelpCenterTypeProvider');
    return context;
};
const $1748612c5907cc62$export$9f436e6b1d27b8b1 = ()=>{
    const context = (0, $8P7DW.useContext)($1748612c5907cc62$var$HelpCenterTypeContext);
    // Default to BASIC/Help Center when context is not available (e.g., creating new help centers)
    return context ?? {
        helpCenterType: null,
        isHelpHub: false
    };
};

});
parcelRegister("cidpP", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cbe2fcee2714af4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c36d860cd29904d698d9a55768075d9e>>
 * @relayHash beb53aa7a0d0e9601d0a8ed6e41c37bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb1e8729ae4e0808c70c1ef993eb6a61813494c8b8c66c4c54aa455fca242a65
const $3cbe2fcee2714af4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterTypeContextQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterTypeContextQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fb1e8729ae4e0808c70c1ef993eb6a61813494c8b8c66c4c54aa455fca242a65",
            "metadata": {},
            "name": "helpCenterTypeContextQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3cbe2fcee2714af4$var$node.hash = "84d5aba1364a6a49146d359035c72854";
var $3cbe2fcee2714af4$export$2e2bcd8739ae039 = $3cbe2fcee2714af4$var$node;

});

parcelRegister("dSz79", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterAri", () => $b71556348b2fbc00$export$f14e6e523bbc25e7);
/**
 This hook will only work if the helpcenterId exists in the path param and the activation-id exists in the meta tag.
 @returns {string} The Help Center ARI.
 */ 
var $jByYr = parcelRequire("jByYr");
parcelRequire("9wocP");
var $iyRi5 = parcelRequire("iyRi5");

var $cLmLE = parcelRequire("cLmLE");
const $b71556348b2fbc00$export$f14e6e523bbc25e7 = ()=>{
    const [helpCenterId = ''] = (0, $iyRi5.usePathParam)('helpcenterId');
    const activationId = (0, $jByYr.getMeta)('activation-id') || '';
    const helpCenterAri = (0, $cLmLE.HelpHelpCenterAri).create({
        activationId: activationId,
        helpCenterId: helpCenterId
    }).toString();
    return helpCenterAri;
};

});


parcelRegister("aJI9b", function(module, exports) {
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $87ec2c9eb1f3697f$export$780035d9fe48eb32);
$parcel$export(module.exports, "CANT_UNLINK_ALL_DIALOG", () => $87ec2c9eb1f3697f$export$34c86dd326ed7328);
$parcel$export(module.exports, "UNLINK_CONFIRMATION_DIALOG", () => $87ec2c9eb1f3697f$export$e1e71e4a40967783);
$parcel$export(module.exports, "MANAGE_PROJECT_HEAD_WIDTH", () => $87ec2c9eb1f3697f$export$39266233350d2cc1);
$parcel$export(module.exports, "MANAGE_PAGE_HEAD_WIDTH", () => $87ec2c9eb1f3697f$export$d93583f12bb7f663);
$parcel$export(module.exports, "ALREADY_EXISTED_CUSTOM_PAGE_MESSAGE", () => $87ec2c9eb1f3697f$export$24707863b4005c32);
$parcel$export(module.exports, "CUSTOM_PAGE_NAME_CHARACTER_LIMIT", () => $87ec2c9eb1f3697f$export$7b26638f36689ddd);
$parcel$export(module.exports, "CUSTOM_PAGE_DESC_CHARACTER_LIMIT", () => $87ec2c9eb1f3697f$export$8dc5686b04c6900a);
$parcel$export(module.exports, "NUMBER_OF_PAGES_INITIAL_FETCH", () => $87ec2c9eb1f3697f$export$4b69f23d48ad7a80);
$parcel$export(module.exports, "HARD_LIMIT_CUSTOM_PAGES_MESSAGE", () => $87ec2c9eb1f3697f$export$7e882a52c33de54f);
$parcel$export(module.exports, "NUMBER_OF_PAGES_PER_PAGE", () => $87ec2c9eb1f3697f$export$806937cd4427be30);
const $87ec2c9eb1f3697f$export$780035d9fe48eb32 = 240;
const $87ec2c9eb1f3697f$export$34c86dd326ed7328 = 'cant-unlink-all-dialog';
const $87ec2c9eb1f3697f$export$e1e71e4a40967783 = 'unlink-confirmation-dialog';
const $87ec2c9eb1f3697f$export$39266233350d2cc1 = {
    'select-all': 5,
    'project-name': 35,
    'lead-name': 35,
    status: 15,
    'action-button': 15
};
const $87ec2c9eb1f3697f$export$d93583f12bb7f663 = {
    'page-name': 20,
    'last-updated': 20,
    'page-description': 40,
    'action-button': 10
};
const $87ec2c9eb1f3697f$export$24707863b4005c32 = `A custom page with this name already exists on your site. Try again with a different name.`;
const $87ec2c9eb1f3697f$export$7b26638f36689ddd = 100;
const $87ec2c9eb1f3697f$export$8dc5686b04c6900a = 256;
const $87ec2c9eb1f3697f$export$4b69f23d48ad7a80 = 100;
const $87ec2c9eb1f3697f$export$7e882a52c33de54f = `Pages limit of ${$87ec2c9eb1f3697f$export$4b69f23d48ad7a80} is exceeded`;
const $87ec2c9eb1f3697f$export$806937cd4427be30 = 20;

});

parcelRegister("gw77d", function(module, exports) {
$parcel$export(module.exports, "Header", () => (parcelRequire("3Jwcb")).default);

var $3Jwcb = parcelRequire("3Jwcb");

});
parcelRegister("3Jwcb", function(module, exports) {
$parcel$export(module.exports, "default", () => $188ae30b8dc4419f$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $2gQsf = parcelRequire("2gQsf");

var $1dWqE = parcelRequire("1dWqE");
var $188ae30b8dc4419f$export$2e2bcd8739ae039 = (0, $jvoWT.default)(null, {
    fetchUser: (0, $2gQsf.fetchUserModelAction)
})((0, $1dWqE.default));

});
parcelRegister("1dWqE", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbcf2cecc84a9aee$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $eS4yu = parcelRequire("eS4yu");

var $h8mYz = parcelRequire("h8mYz");
var $ajSU4 = parcelRequire("ajSU4");

var $1EFS8 = parcelRequire("1EFS8");

var $iqc8I = parcelRequire("iqc8I");
parcelRequire("eem3A");
var $59NqE = parcelRequire("59NqE");

var $bH2ny = parcelRequire("bH2ny");
const $dbcf2cecc84a9aee$var$HomeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqc8I.JiraServiceManagementIcon), {
        size: "xsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    });
const $dbcf2cecc84a9aee$var$HomeLogo = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqc8I.JiraServiceManagementLogo), {
        size: "xsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    });
const $dbcf2cecc84a9aee$var$Home = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ajSU4.default), {
        icon: $dbcf2cecc84a9aee$var$HomeIcon,
        logo: $dbcf2cecc84a9aee$var$HomeLogo,
        href: `${window.location.origin}/jira/your-work`
    });
const $dbcf2cecc84a9aee$var$Header = ({ fetchUser: fetchUser })=>{
    (0, $8P7DW.useEffect)(()=>{
        fetchUser();
    }, [
        fetchUser
    ]);
    const AppSwitcher = ()=>(0, $1EFS8.default).checkGate('update_jsm_header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bH2ny.default), null) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $h8mYz.AtlassianNavigation), {
        label: "site",
        renderProductHome: $dbcf2cecc84a9aee$var$Home,
        renderProfile: (0, $59NqE.default),
        renderAppSwitcher: AppSwitcher,
        primaryItems: []
    });
};
var $dbcf2cecc84a9aee$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    component: 'Header'
})($dbcf2cecc84a9aee$var$Header);

});
parcelRegister("h8mYz", function(module, exports) {
$parcel$export(module.exports, "AtlassianNavigation", () => $50a128ae3b6478eb$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");
parcelRequire("9EJQR");
var $iCLnJ = parcelRequire("iCLnJ");

var $iHFbA = parcelRequire("iHFbA");

var $71yMi = parcelRequire("71yMi");
var $hcRiR = parcelRequire("hcRiR");

var $jQ1iH = parcelRequire("jQ1iH");
function $50a128ae3b6478eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $50a128ae3b6478eb$var$containerStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $iHFbA.HORIZONTAL_GLOBAL_NAV_HEIGHT),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $50a128ae3b6478eb$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $50a128ae3b6478eb$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $50a128ae3b6478eb$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $50a128ae3b6478eb$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $50a128ae3b6478eb$export$f66ccb39f60980e5 = (props)=>{
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $71yMi.defaultTheme), testId: testId, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $hcRiR.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $iCLnJ.NavigationAnalyticsContext), {
        data: $50a128ae3b6478eb$var$analyticsData
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $50a128ae3b6478eb$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'atlassian-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
        }
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("nav", {
        css: $50a128ae3b6478eb$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $8Z0o8.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $8Z0o8.jsx)(ProductHome, null), /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $jQ1iH.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $50a128ae3b6478eb$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $8Z0o8.jsx)(Search, null), /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        role: "list",
        css: [
            $50a128ae3b6478eb$var$rightStyles,
            $50a128ae3b6478eb$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $8Z0o8.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $8Z0o8.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $8Z0o8.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $8Z0o8.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $8Z0o8.jsx)(Profile, null))))));
};

});
parcelRegister("iHFbA", function(module, exports) {
$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", () => $dd557692f9286262$export$30fa7cc5f2690a43);
$parcel$export(module.exports, "PRODUCT_HOME_BREAKPOINT", () => $dd557692f9286262$export$4033a111ca79977d);
const $dd557692f9286262$export$30fa7cc5f2690a43 = 56;
const $dd557692f9286262$export$4033a111ca79977d = 1280;
const $dd557692f9286262$export$24ec62cee78b7042 = 1130;
const $dd557692f9286262$export$d8bde68ac946124f = '--ds--ans--fbc';
const $dd557692f9286262$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $dd557692f9286262$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $dd557692f9286262$export$d81606c1fc5119bc = '--ds--ans--c';
const $dd557692f9286262$export$65f656ad520ea71 = '--ds--ans--bc';

});

parcelRegister("jQ1iH", function(module, exports) {
$parcel$export(module.exports, "PrimaryItemsContainer", () => $2f49eb273d569f95$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $c2L1U = parcelRequire("c2L1U");

var $iD9mC = parcelRequire("iD9mC");

var $9vS8L = parcelRequire("9vS8L");

var $IcTXW = parcelRequire("IcTXW");
function $2f49eb273d569f95$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f49eb273d569f95$var$containerStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $2f49eb273d569f95$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $2f49eb273d569f95$var$overflowItemsStyles = {
    name: "4ekwwx",
    styles: "color:var(--ds-text, #292A2E)"
};
const $2f49eb273d569f95$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $8P7DW.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $9vS8L.useOverflowController)(items);
    const onMoreClick = (0, $8P7DW.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $8P7DW.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $8P7DW.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $8P7DW.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $8Z0o8.jsx)((0, $IcTXW.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $8P7DW.useCallback)(()=>/*#__PURE__*/ (0, $8Z0o8.jsx)((0, $9vS8L.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            css: $2f49eb273d569f95$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $2f49eb273d569f95$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $9vS8L.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $c2L1U.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $8Z0o8.jsx)(Create, null), /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: $2f49eb273d569f95$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $iD9mC.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("9vS8L", function(module, exports) {
$parcel$export(module.exports, "OverflowProvider", () => $1db1feda56729ec4$export$a3a2def3937905a0);
$parcel$export(module.exports, "useOverflowController", () => $1db1feda56729ec4$export$705aa66a39c35bf7);

var $8P7DW = parcelRequire("8P7DW");

var $87gfw = parcelRequire("87gfw");

var $5J6r2 = parcelRequire("5J6r2");
// Prevent width detector from triggering too many re-renders
const $1db1feda56729ec4$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
const $1db1feda56729ec4$var$ITEM_APPROX_MINWIDTH = 70;
const $1db1feda56729ec4$var$calculateHash = (w, n)=>w + '#' + n;
const $1db1feda56729ec4$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $1db1feda56729ec4$var$OverflowContext = /*#__PURE__*/ (0, $8P7DW.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $5J6r2.default),
    closeOverflowMenu: (0, $5J6r2.default)
});
const $1db1feda56729ec4$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const { Provider: Provider } = $1db1feda56729ec4$var$OverflowContext;
    const value = (0, $8P7DW.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Provider, {
        value: value
    }, children);
};
const $1db1feda56729ec4$export$3fcfc71fab3314f2 = ()=>(0, $8P7DW.useContext)($1db1feda56729ec4$var$OverflowContext);
const $1db1feda56729ec4$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.toArray(nodes);
    const [width, setWidth] = (0, $8P7DW.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $8P7DW.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $8P7DW.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $8P7DW.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $8P7DW.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $8P7DW.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($87gfw)))(setWidth, $1db1feda56729ec4$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $8P7DW.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $1db1feda56729ec4$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $1db1feda56729ec4$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $1db1feda56729ec4$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $1db1feda56729ec4$var$ITEM_APPROX_MINWIDTH * 2), $1db1feda56729ec4$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $1db1feda56729ec4$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $1db1feda56729ec4$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $1db1feda56729ec4$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $1db1feda56729ec4$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $1db1feda56729ec4$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $1db1feda56729ec4$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        return;
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line import/no-anonymous-default-export
$1db1feda56729ec4$export$2e2bcd8739ae039 = (_props)=>{};

});
parcelRegister("87gfw", function(module, exports) {

var $eGXTM = parcelRequire("eGXTM");

var $j7DJp = parcelRequire("j7DJp");
/** Error message constants. */ var $5e8b94f261cce15a$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $5e8b94f261cce15a$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($5e8b94f261cce15a$var$FUNC_ERROR_TEXT);
    if ($j7DJp(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $eGXTM(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $5e8b94f261cce15a$var$throttle;

});
parcelRegister("eGXTM", function(module, exports) {

var $j7DJp = parcelRequire("j7DJp");

var $4eB9A = parcelRequire("4eB9A");

var $lPeXJ = parcelRequire("lPeXJ");
/** Error message constants. */ var $ab2373968b8d9ac7$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ab2373968b8d9ac7$var$nativeMax = Math.max, $ab2373968b8d9ac7$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ab2373968b8d9ac7$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($ab2373968b8d9ac7$var$FUNC_ERROR_TEXT);
    wait = $lPeXJ(wait) || 0;
    if ($j7DJp(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $ab2373968b8d9ac7$var$nativeMax($lPeXJ(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        if (typeof setTimeout !== 'undefined') timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ab2373968b8d9ac7$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $4eB9A();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($4eB9A());
    }
    function debounced() {
        var time = $4eB9A(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $ab2373968b8d9ac7$var$debounce;

});
parcelRegister("4eB9A", function(module, exports) {

var $gTpPE = parcelRequire("gTpPE");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $31554a2c0f745a0c$var$now = function() {
    return $gTpPE.Date.now();
};
module.exports = $31554a2c0f745a0c$var$now;

});




parcelRegister("IcTXW", function(module, exports) {
$parcel$export(module.exports, "PrimaryDropdownButton", () => $1f73d3ea107cebeb$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $cDQfx = parcelRequire("cDQfx");

var $iIqNm = parcelRequire("iIqNm");
function $1f73d3ea107cebeb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1f73d3ea107cebeb$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $1f73d3ea107cebeb$export$bb3af89fb196520d = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $iIqNm.PrimaryButton), {
        component: component,
        iconAfter: /*#__PURE__*/ (0, $8Z0o8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cDQfx))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        css: [
            $1f73d3ea107cebeb$var$buttonNoOpStyle
        ],
        ...rest
    });
});

});
parcelRegister("iIqNm", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", () => $f9097adcabd0cacc$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $iFxfe = parcelRequire("iFxfe");

var $ea6bZ = parcelRequire("ea6bZ");

var $4mriZ = parcelRequire("4mriZ");

var $9In7Z = parcelRequire("9In7Z");
function $f9097adcabd0cacc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f9097adcabd0cacc$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $f9097adcabd0cacc$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $f9097adcabd0cacc$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $f9097adcabd0cacc$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $f9097adcabd0cacc$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$f9097adcabd0cacc$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$f9097adcabd0cacc$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $f9097adcabd0cacc$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $4mriZ.useTheme)();
    const button = /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        style: {
            [$f9097adcabd0cacc$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$f9097adcabd0cacc$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $f9097adcabd0cacc$var$buttonBaseStyles,
            isHighlighted && $f9097adcabd0cacc$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $iFxfe.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $9In7Z.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $f9097adcabd0cacc$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $ea6bZ.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});

});
parcelRegister("9In7Z", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", () => $4d5d60e08fff022c$export$14dd6915caf431fe);
const $4d5d60e08fff022c$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});





parcelRegister("ajSU4", function(module, exports) {
$parcel$export(module.exports, "default", () => $4dbc001ef4001da1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $iPrfN = parcelRequire("iPrfN");
var $9pb7J = parcelRequire("9pb7J");

var $iHFbA = parcelRequire("iHFbA");

var $4mriZ = parcelRequire("4mriZ");

var $cxUP9 = parcelRequire("cxUP9");

var $7HQsg = parcelRequire("7HQsg");
function $4dbc001ef4001da1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4dbc001ef4001da1$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $4dbc001ef4001da1$var$productHomeButtonStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $iHFbA.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $iHFbA.PRODUCT_HOME_BREAKPOINT}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $4dbc001ef4001da1$var$productLogoStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$4dbc001ef4001da1$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$4dbc001ef4001da1$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $iHFbA.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        display: 'none'
    }
});
const $4dbc001ef4001da1$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $4dbc001ef4001da1$var$productIconStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $iHFbA.PRODUCT_HOME_BREAKPOINT}px)`]: {
        display: 'none'
    }
});
const $4dbc001ef4001da1$var$appHomeIconStyles = {
    name: "ajq7oy",
    styles: "border-radius:10px"
};
const $4dbc001ef4001da1$var$appIconStyles = {
    name: "1i4kceg",
    styles: "display:flex;max-width:24px"
};
const $4dbc001ef4001da1$var$appLogoTextStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // Logo text should never wrap or overflow
    width: 'max-content',
    paddingInlineEnd: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $iHFbA.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        display: 'none'
    }
});
const $4dbc001ef4001da1$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
const $4dbc001ef4001da1$export$71fd2198c1e1a04a = ({ 'aria-label': ariaLabel, href: href, name: name, icon: Icon, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest })=>{
    const theme = (0, $4mriZ.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    // After the brand refresh, iconColor and textColor should be set to 'undefined' to allow the original
    // multi-color logo tile colors to be visible, rather than a hardcoded blue.
    let { iconColor: iconColor, textColor: textColor } = theme.mode.productHome;
    // The default theme is set at module scope and immediately used in context.
    // To allow the feature flag to switch the logo color at runtime, we also detect the original hardcoded
    // values and override them to undefined.
    if (iconColor === '#357DE8' && textColor === "var(--ds-text, #292A2E)") {
        iconColor = undefined;
        textColor = undefined;
    }
    const Tag = (0, $7HQsg.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $cxUP9.stripEmptyProperties)({
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
    });
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, /*#__PURE__*/ (0, $8Z0o8.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: [
            $4dbc001ef4001da1$var$productHomeButtonStyles,
            $4dbc001ef4001da1$var$appHomeIconStyles
        ],
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        "aria-label": ariaLabel,
        ...rest
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $iPrfN.default), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: [
            $4dbc001ef4001da1$var$appIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)(Icon, {
        iconColor: iconColor,
        shouldUseNewLogoDesign: true,
        size: "small",
        appearance: "brand"
    })), /*#__PURE__*/ (0, $8Z0o8.jsx)("span", {
        css: $4dbc001ef4001da1$var$appLogoTextStyles
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $9pb7J.default), {
        "aria-hidden": true,
        color: "inherit",
        weight: "semibold"
    }, name)))), siteTitle && /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $4dbc001ef4001da1$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $4dbc001ef4001da1$var$ProductHome = ({ 'aria-label': ariaLabel, href: href, icon: Icon, logo: Logo, logoMaxWidth: logoMaxWidth = 260, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest })=>{
    const theme = (0, $4mriZ.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    let { iconColor: iconColor, textColor: textColor } = theme.mode.productHome;
    // If the theme returns the default Atlassian theme, rely on the Logo default behaviour instead
    if (iconColor === '#357DE8' && textColor === "var(--ds-text, #292A2E)") {
        iconColor = undefined;
        textColor = undefined;
    }
    const Tag = (0, $7HQsg.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $cxUP9.stripEmptyProperties)({
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$4dbc001ef4001da1$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$4dbc001ef4001da1$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $8P7DW.Fragment), null, /*#__PURE__*/ (0, $8Z0o8.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $4dbc001ef4001da1$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        "aria-label": ariaLabel,
        ...rest
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: [
            $4dbc001ef4001da1$var$customMaxHeightStyles,
            $4dbc001ef4001da1$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: iconColor || textColor ? undefined : 'brand'
    })), /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: [
            $4dbc001ef4001da1$var$customMaxHeightStyles,
            $4dbc001ef4001da1$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)(Icon, {
        iconColor: iconColor,
        size: 'small',
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: iconColor || textColor ? undefined : 'brand'
    }))), siteTitle && /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $4dbc001ef4001da1$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $4dbc001ef4001da1$export$2e2bcd8739ae039 = $4dbc001ef4001da1$var$ProductHome;

});
parcelRegister("cxUP9", function(module, exports) {
$parcel$export(module.exports, "stripEmptyProperties", () => $a790620600dafc1a$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $a790620600dafc1a$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});

parcelRegister("7HQsg", function(module, exports) {
$parcel$export(module.exports, "getTag", () => $c35f19b41c0b127f$export$dad497fe1f6e27c0);
const $c35f19b41c0b127f$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("bH2ny", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a2897c41c3f7c44$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $jByYr = parcelRequire("jByYr");

var $0zNo9 = parcelRequire("0zNo9");

var $c2L1U = parcelRequire("c2L1U");

var $ittu8 = parcelRequire("ittu8");
var $ev77O = parcelRequire("ev77O");
const $8a2897c41c3f7c44$var$APP_SWITCHER_PRODUCT = 'jiraServiceManagement';
const $8a2897c41c3f7c44$var$AppSwitcherComponent = ()=>{
    const [isOpen, setIsOpen] = (0, $8P7DW.useState)(false);
    const cloudId = (0, $jByYr.getCloudId)();
    const onClick = ()=>{
        setIsOpen(!isOpen);
    };
    const onClose = ()=>{
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c2L1U.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ev77O.AtlassianSwitcherLoader), {
                product: $8a2897c41c3f7c44$var$APP_SWITCHER_PRODUCT,
                cloudId: cloudId
            }),
        isOpen: isOpen,
        onClose: onClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ittu8.default), {
                cloudId: cloudId,
                product: $8a2897c41c3f7c44$var$APP_SWITCHER_PRODUCT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $0zNo9.AppSwitcher), {
                onClick: onClick,
                tooltip: "Switch to...",
                ...triggerProps
            }))
    });
};
var $8a2897c41c3f7c44$export$2e2bcd8739ae039 = $8a2897c41c3f7c44$var$AppSwitcherComponent;

});
parcelRegister("0zNo9", function(module, exports) {
$parcel$export(module.exports, "AppSwitcher", () => $1c33e51d2b2b3cd9$export$9923361bd43fa030);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $lhqsk = parcelRequire("lhqsk");

var $3iEm8 = parcelRequire("3iEm8");

var $hFFbP = parcelRequire("hFFbP");
const $1c33e51d2b2b3cd9$var$iconSpacingStyles = {
    space050: "_1rjc1b66 _18zr1b66"
};
const $1c33e51d2b2b3cd9$export$9923361bd43fa030 = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hFFbP.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3iEm8.default), {
            xcss: $1c33e51d2b2b3cd9$var$iconSpacingStyles.space050
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lhqsk))), {
            color: "currentColor",
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        })),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
const $1c33e51d2b2b3cd9$export$28833e0dfbd2ac80 = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hFFbP.IconButton), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lhqsk))), {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
            color: "var(--ds-icon, #292A2E)"
        }),
        component: component,
        href: href,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
var // exists only to extract props
// eslint-disable-next-line import/no-anonymous-default-export
$1c33e51d2b2b3cd9$export$2e2bcd8739ae039 = (_props)=>{};

});
parcelRegister("lhqsk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55422f7c50559ad266d0694af3ada2f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7dfb51f858d0153$var$_react = $f7dfb51f858d0153$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $f7dfb51f858d0153$var$_baseNew = $f7dfb51f858d0153$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $f7dfb51f858d0153$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7dfb51f858d0153$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $f7dfb51f858d0153$var$_react.default.createElement($f7dfb51f858d0153$var$_baseNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$f7dfb51f858d0153$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $f7dfb51f858d0153$var$_default = module.exports.default = $f7dfb51f858d0153$var$AppSwitcherIcon;

});


parcelRegister("ittu8", function(module, exports) {
$parcel$export(module.exports, "default", () => $68b1ddc267b3bc91$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $87gfw = parcelRequire("87gfw");

var $hrByX = parcelRequire("hrByX");

var $7UaAQ = parcelRequire("7UaAQ");

var $jSRWx = parcelRequire("jSRWx");
var $iCLnJ = parcelRequire("iCLnJ");
var $9U53L = parcelRequire("9U53L");
var $k7ZVu = parcelRequire("k7ZVu");

var $4ji5K = parcelRequire("4ji5K");
const $68b1ddc267b3bc91$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $68b1ddc267b3bc91$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $68b1ddc267b3bc91$var$TRIGGER_CONTEXT = {
    componentName: (0, $jSRWx.TRIGGER_COMPONENT),
    ...(0, $4ji5K.default)
};
class $68b1ddc267b3bc91$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick
        }, children);
    }
    constructor(...args){
        super(...args), this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $9U53L.OPERATIONAL_EVENT_TYPE),
                actionSubject: (0, $jSRWx.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $jSRWx.NAVIGATION_CHANNEL));
        }, this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($87gfw)))(()=>{
            (0, $hrByX.prefetchAll)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $68b1ddc267b3bc91$var$THROTTLE_EXPIRES, $68b1ddc267b3bc91$var$THROTTLE_OPTIONS), this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $7UaAQ.performanceNow)();
        }, this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $7UaAQ.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $68b1ddc267b3bc91$var$PrefetchTriggerWithEvents = (0, $k7ZVu.default)()($68b1ddc267b3bc91$var$PrefetchTrigger);
var $68b1ddc267b3bc91$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iCLnJ.NavigationAnalyticsContext), {
        data: $68b1ddc267b3bc91$var$TRIGGER_CONTEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($68b1ddc267b3bc91$var$PrefetchTriggerWithEvents, props));

});
parcelRegister("hrByX", function(module, exports) {
$parcel$export(module.exports, "prefetchAll", () => $e0ef15713725d448$export$aba5d6cf034db22e);

var $i6UiC = parcelRequire("i6UiC");

var $1MReX = parcelRequire("1MReX");

var $5Zzgl = parcelRequire("5Zzgl");

var $8245b = parcelRequire("8245b");

var $2AAQ7 = parcelRequire("2AAQ7");
const $e0ef15713725d448$export$aba5d6cf034db22e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $5Zzgl.default)(product);
    (0, $8245b.prefetchFlightDeck)({});
    (0, $i6UiC.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $2AAQ7.prefetchThirdPartyProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $1MReX.prefetchJoinableSites)(props.joinableSitesDataProvider);
};

});
parcelRegister("i6UiC", function(module, exports) {
$parcel$export(module.exports, "AvailableProductsProvider", () => $3c417f65866ea816$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $3c417f65866ea816$export$1c5684a3ba697d80);

var $8P7DW = parcelRequire("8P7DW");

var $ngThI = parcelRequire("ngThI");
const { fetchMethod: $3c417f65866ea816$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $3c417f65866ea816$var$DefaultBffDataProviderComponent } = (0, $ngThI.createAppSwitcherBffAvailableProductsProvider)();
const $3c417f65866ea816$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($3c417f65866ea816$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product
    }, children);
const $3c417f65866ea816$export$1c5684a3ba697d80 = $3c417f65866ea816$var$fetchAppSwitcherBffAvailableProducts;
const $3c417f65866ea816$export$cd9fc41c59711bdd = ()=>$3c417f65866ea816$var$fetchAppSwitcherBffAvailableProducts.reset();

});
parcelRegister("ngThI", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $de670a542aa2ddb6$export$7fd9c7ae7afb494c);

var $eErbn = parcelRequire("eErbn");

var $4MVrt = parcelRequire("4MVrt");

var $jrLfA = parcelRequire("jrLfA");
const $de670a542aa2ddb6$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $de670a542aa2ddb6$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $4MVrt.fetchJsonWithNetworkRetries)(`${$de670a542aa2ddb6$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $de670a542aa2ddb6$export$7fd9c7ae7afb494c = ()=>{
    return (0, $eErbn.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $jrLfA.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $de670a542aa2ddb6$export$1096efb00c5f8afc);
};

});
parcelRegister("eErbn", function(module, exports) {
$parcel$export(module.exports, "createProviderWithCustomFetchData", () => $e87de689286b4541$export$310e48be95687c2f);

var $aQpZa = parcelRequire("aQpZa");

var $4MVrt = parcelRequire("4MVrt");

var $5PuGS = parcelRequire("5PuGS");
const $e87de689286b4541$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $5PuGS.withCached)((param)=>(0, $4MVrt.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $aQpZa.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $e87de689286b4541$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig)=>{
    const fetchMethod = (0, $5PuGS.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $aQpZa.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};

});
parcelRegister("aQpZa", function(module, exports) {
$parcel$export(module.exports, "Status", () => $f54c2d4d1343c316$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $f54c2d4d1343c316$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $f54c2d4d1343c316$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isLoading", () => $f54c2d4d1343c316$export$20bb0d907fbbe433);
$parcel$export(module.exports, "hasLoaded", () => $f54c2d4d1343c316$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $f54c2d4d1343c316$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $jSRWx = parcelRequire("jSRWx");
var $9U53L = parcelRequire("9U53L");

var $k7ZVu = parcelRequire("k7ZVu");

var $bpcYk = parcelRequire("bpcYk");

var $i6h9u = parcelRequire("i6h9u");

var $hWqIF = parcelRequire("hWqIF");
const $f54c2d4d1343c316$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $f54c2d4d1343c316$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $f54c2d4d1343c316$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $f54c2d4d1343c316$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $f54c2d4d1343c316$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $f54c2d4d1343c316$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $f54c2d4d1343c316$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $f54c2d4d1343c316$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
        static #_ = this.displayName = `DataProvider(${name})`;
        componentWillUnmount() {
            /**
       * Promise resolved after component is unmounted to be ignored
       */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate !== null && shouldUpdate !== void 0 && shouldUpdate(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $i6h9u.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: (retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS) || [],
                shouldRetryOnException: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig !== null && retryConfig !== void 0 && retryConfig.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $bpcYk.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
       * Do not transition from "complete" state to "error"
       */ if (this.acceptResults && !$f54c2d4d1343c316$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $bpcYk.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $9U53L.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $f54c2d4d1343c316$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $jSRWx.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $k7ZVu.default)()((0, $hWqIF.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(InnerComponent, {
            params: params
        }, children);
    };
    return OuterComponent;
}

});
parcelRegister("jSRWx", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $634668a1da5d3f20$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $634668a1da5d3f20$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", () => $634668a1da5d3f20$export$7598b001981cfda5);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $634668a1da5d3f20$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", () => $634668a1da5d3f20$export$7d4d527df0e3789c);
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", () => $634668a1da5d3f20$export$16cf10618135eb24);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $634668a1da5d3f20$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $634668a1da5d3f20$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $634668a1da5d3f20$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $634668a1da5d3f20$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $634668a1da5d3f20$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", () => $634668a1da5d3f20$export$6dd696c9ad636a67);
$parcel$export(module.exports, "SWITCHER_ORG_LIST", () => $634668a1da5d3f20$export$d9d2f872f3b91169);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $634668a1da5d3f20$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $634668a1da5d3f20$export$22f5f827d9934254);
$parcel$export(module.exports, "createAndFireNavigationEvent", () => $634668a1da5d3f20$export$884b1a4c7ac9dd14);
$parcel$export(module.exports, "analyticsAttributes", () => $634668a1da5d3f20$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $634668a1da5d3f20$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $634668a1da5d3f20$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $634668a1da5d3f20$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $634668a1da5d3f20$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $634668a1da5d3f20$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $634668a1da5d3f20$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("k7ZVu")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("iCLnJ")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => (parcelRequire("9U53L")).OPERATIONAL_EVENT_TYPE);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => (parcelRequire("9U53L")).UI_EVENT_TYPE);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("9EJQR");
var $iCLnJ = parcelRequire("iCLnJ");

var $5yo3H = parcelRequire("5yo3H");
var $k7ZVu = parcelRequire("k7ZVu");

var $9U53L = parcelRequire("9U53L");

var $aQpZa = parcelRequire("aQpZa");

var $bCLTw = parcelRequire("bCLTw");

var $dHnuR = parcelRequire("dHnuR");
const $634668a1da5d3f20$export$515664faa1398f37 = 'navigation';
const $634668a1da5d3f20$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $634668a1da5d3f20$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $634668a1da5d3f20$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $634668a1da5d3f20$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $634668a1da5d3f20$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $634668a1da5d3f20$export$2b570fc112cbca = 'atlassianSwitcher';
const $634668a1da5d3f20$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $634668a1da5d3f20$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $634668a1da5d3f20$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $634668a1da5d3f20$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $634668a1da5d3f20$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $634668a1da5d3f20$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $634668a1da5d3f20$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $634668a1da5d3f20$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $634668a1da5d3f20$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $634668a1da5d3f20$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $634668a1da5d3f20$var$RENDERED_ACTION = 'rendered';
const $634668a1da5d3f20$var$NOT_RENDERED_ACTION = 'not_rendered';
const $634668a1da5d3f20$var$VIEWED_ACTION = 'viewed';
const $634668a1da5d3f20$export$884b1a4c7ac9dd14 = (0, $5yo3H.default)($634668a1da5d3f20$export$515664faa1398f37);
const $634668a1da5d3f20$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $634668a1da5d3f20$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iCLnJ.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, props));
    };
};
const $634668a1da5d3f20$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $634668a1da5d3f20$export$e09ad93c2b74b853 = (0, $k7ZVu.default)({
    onRender: (createAnalyticsEvent, props)=>{
        var _props$data;
        const duration = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.duration;
        return createAnalyticsEvent({
            eventType: (0, $9U53L.OPERATIONAL_EVENT_TYPE),
            action: $634668a1da5d3f20$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$634668a1da5d3f20$var$isValidDuration(duration) && {
                    bucket: (0, $dHnuR.getMetricBucket)(duration, (0, $dHnuR.RenderTrackerBuckets))
                }
            }
        }).fire($634668a1da5d3f20$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $634668a1da5d3f20$export$95b1f1a72cad0dcb = (0, $k7ZVu.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $9U53L.OPERATIONAL_EVENT_TYPE),
            action: $634668a1da5d3f20$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($634668a1da5d3f20$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $634668a1da5d3f20$export$b3fd6624b6a6d057 = (0, $k7ZVu.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $9U53L.UI_EVENT_TYPE),
            action: $634668a1da5d3f20$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($634668a1da5d3f20$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $634668a1da5d3f20$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($634668a1da5d3f20$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($634668a1da5d3f20$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $634668a1da5d3f20$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($634668a1da5d3f20$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($634668a1da5d3f20$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $634668a1da5d3f20$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $aQpZa.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $634668a1da5d3f20$var$renderTracker({
        subject: $634668a1da5d3f20$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $634668a1da5d3f20$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if ((customLinksProviderResult === null || customLinksProviderResult === void 0 ? void 0 : customLinksProviderResult.status) === (0, $aQpZa.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $bCLTw.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $634668a1da5d3f20$var$renderTrackerWithReason({
        subject: $634668a1da5d3f20$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $634668a1da5d3f20$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$634668a1da5d3f20$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("bCLTw", function(module, exports) {
$parcel$export(module.exports, "UserSiteDataErrorReason", () => $4f8f1447fc51e034$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $4f8f1447fc51e034$export$c460344055e97b1);
var $4f8f1447fc51e034$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $4f8f1447fc51e034$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("dHnuR", function(module, exports) {
$parcel$export(module.exports, "RenderTrackerBuckets", () => $9752c730cdb897f8$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $9752c730cdb897f8$export$b59492d26971ae92);
const $9752c730cdb897f8$var$INFINITY = '+Inf';
const $9752c730cdb897f8$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $9752c730cdb897f8$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $9752c730cdb897f8$var$INFINITY) : null;
};

});


parcelRegister("bpcYk", function(module, exports) {
$parcel$export(module.exports, "errorToReason", () => $38eb5f42eaff7d39$export$a3e288208721751b);
function $38eb5f42eaff7d39$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("i6h9u", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $f316250dbf5a46dd$export$1d94629c94e7a17f);
const $f316250dbf5a46dd$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $f316250dbf5a46dd$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $f316250dbf5a46dd$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});

parcelRegister("hWqIF", function(module, exports) {
$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $4dd91f9f16b66e41$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $4dd91f9f16b66e41$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $4dd91f9f16b66e41$export$f88dde183f4d31cb);

var $8P7DW = parcelRequire("8P7DW");
const $4dd91f9f16b66e41$var$noop = ()=>{};
const $4dd91f9f16b66e41$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $8P7DW.createContext)({
    start: $4dd91f9f16b66e41$var$noop,
    success: $4dd91f9f16b66e41$var$noop,
    failure: $4dd91f9f16b66e41$var$noop,
    failureAll: $4dd91f9f16b66e41$var$noop,
    abort: $4dd91f9f16b66e41$var$noop,
    abortAll: $4dd91f9f16b66e41$var$noop,
    markStart: $4dd91f9f16b66e41$var$noop,
    markEnd: $4dd91f9f16b66e41$var$noop
});
const $4dd91f9f16b66e41$export$cdefb2a8b53f879f = ()=>(0, $8P7DW.useContext)($4dd91f9f16b66e41$export$3f3eebb4b8116461);
const $4dd91f9f16b66e41$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $4dd91f9f16b66e41$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("4MVrt", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $0d2152b7276cb366$export$6d71b655afe1638d);
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", () => $0d2152b7276cb366$export$16566b750080153d);
$parcel$export(module.exports, "postJson", () => $0d2152b7276cb366$export$c776284ef4b1209a);

var $7kJ77 = parcelRequire("7kJ77");

var $i6h9u = parcelRequire("i6h9u");

var $4ji5K = parcelRequire("4ji5K");
const $0d2152b7276cb366$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $7kJ77.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $0d2152b7276cb366$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $4ji5K.default).packageVersion,
            ...init === null || init === void 0 ? void 0 : init.headers
        }
    }).then(!emptyResponse ? $0d2152b7276cb366$var$extraJsonFromResponse : ()=>{});
const $0d2152b7276cb366$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $i6h9u.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $4ji5K.default).packageVersion,
                ...init === null || init === void 0 ? void 0 : init.headers
            }
        }), retryConfig).then($0d2152b7276cb366$var$extraJsonFromResponse);
};
const $0d2152b7276cb366$export$c776284ef4b1209a = (url, data, emptyResponse)=>$0d2152b7276cb366$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);

});
parcelRegister("7kJ77", function(module, exports) {
$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $1e6284377d09712d$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $1e6284377d09712d$export$26e841bcf1aeb894);
const $1e6284377d09712d$export$83179404a61b001a = 'FetchError';
class $1e6284377d09712d$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message), this.name = $1e6284377d09712d$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $1e6284377d09712d$export$26e841bcf1aeb894;
    }
}

});

parcelRegister("4ji5K", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4cd127788e0b9d6$export$2e2bcd8739ae039);
const $b4cd127788e0b9d6$var$packageName = undefined;
const $b4cd127788e0b9d6$var$packageVersion = undefined;
const $b4cd127788e0b9d6$var$_default_1 = {
    packageName: $b4cd127788e0b9d6$var$packageName,
    packageVersion: $b4cd127788e0b9d6$var$packageVersion
};
var $b4cd127788e0b9d6$export$2e2bcd8739ae039 = $b4cd127788e0b9d6$var$_default_1;

});


parcelRegister("5PuGS", function(module, exports) {
$parcel$export(module.exports, "withCached", () => $ff1704375ab56436$export$7f51828d6b6af163);
const $ff1704375ab56436$export$d4d4b402ab64e2f4 = 5000;
const $ff1704375ab56436$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $ff1704375ab56436$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($ff1704375ab56436$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $ff1704375ab56436$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});


parcelRegister("jrLfA", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $6dd28173b6f6234e$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $6dd28173b6f6234e$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $6dd28173b6f6234e$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $6dd28173b6f6234e$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $6dd28173b6f6234e$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $6dd28173b6f6234e$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $6dd28173b6f6234e$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $6dd28173b6f6234e$export$86919b84f9a64054);

var $2lzZD = parcelRequire("2lzZD");

var $lCCgB = parcelRequire("lCCgB");
var $6dd28173b6f6234e$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $6dd28173b6f6234e$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $2lzZD.ExperienceTypes).Load,
        performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $2lzZD.ExperienceTypes).Load,
        performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $2lzZD.ExperienceTypes).Load,
        performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $2lzZD.ExperienceTypes).Load,
        performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $6dd28173b6f6234e$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_GLOBAL_APPS"] = "api-app-switcher-bff-global-apps";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $6dd28173b6f6234e$var$allNonTestExperienceMarks = Object.values($6dd28173b6f6234e$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $6dd28173b6f6234e$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $6dd28173b6f6234e$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $6dd28173b6f6234e$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $6dd28173b6f6234e$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $6dd28173b6f6234e$var$allNonTestExperienceMarks
};
const $6dd28173b6f6234e$export$805ed806e0769ee4 = (0, $lCCgB.invertRecordOfArrays)($6dd28173b6f6234e$export$755e75afbd377bc4);
var $6dd28173b6f6234e$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $6dd28173b6f6234e$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $6dd28173b6f6234e$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("lCCgB", function(module, exports) {
$parcel$export(module.exports, "invertRecordOfArrays", () => $c629309921fe0217$export$c371a74fe5222b3);
function $c629309921fe0217$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});




parcelRegister("1MReX", function(module, exports) {
$parcel$export(module.exports, "JoinableSitesProvider", () => $f8d94f09ee37f066$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $f8d94f09ee37f066$export$2aed3ef1595b4d9);

var $8P7DW = parcelRequire("8P7DW");

var $lE99F = parcelRequire("lE99F");
const { fetchMethod: $f8d94f09ee37f066$var$fetchJoinableSites, ProviderComponent: $f8d94f09ee37f066$var$DefaultDataProviderComponent } = (0, $lE99F.createJoinableSitesProvider)();
const $f8d94f09ee37f066$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $f8d94f09ee37f066$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(DataProviderComponent, {
        cloudId: cloudId
    }, children);
};
const $f8d94f09ee37f066$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $f8d94f09ee37f066$var$fetchJoinableSites({});
};
const $f8d94f09ee37f066$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $f8d94f09ee37f066$var$fetchJoinableSites.reset();
};

});
parcelRegister("lE99F", function(module, exports) {
$parcel$export(module.exports, "createJoinableSitesProvider", () => $cc6caf4e890db7e6$export$c3b6af53f1ca17d8);

var $eErbn = parcelRequire("eErbn");

var $jrLfA = parcelRequire("jrLfA");
const $cc6caf4e890db7e6$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $cc6caf4e890db7e6$export$c3b6af53f1ca17d8 = (fetchData = $cc6caf4e890db7e6$export$62986affcccd56a5, retryConfig)=>{
    return (0, $eErbn.createProviderWithCustomFetchData)('joinableSites', (0, $jrLfA.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});


parcelRegister("5Zzgl", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5ac6673d526849f$export$2e2bcd8739ae039);

var $ev77O = parcelRequire("ev77O");

var $e6Qdr = parcelRequire("e6Qdr");
var $f5ac6673d526849f$export$2e2bcd8739ae039 = (product)=>{
    (0, $ev77O.loadAtlassianSwitcher)();
    if ((0, $e6Qdr.fg)('navx-4453-jira-confluence-use-generic-switcher')) return (0, $ev77O.loadGenericSwitcher)();
    if (product === 'jira') return (0, $ev77O.loadJiraSwitcher)();
    if (product === 'confluence') return (0, $ev77O.loadConfluenceSwitcher)();
    return (0, $ev77O.loadGenericSwitcher)();
};

});
parcelRegister("ev77O", function(module, exports) {
$parcel$export(module.exports, "loadAtlassianSwitcher", () => $59256ed14460f1cd$export$6c6894dd831bfacb);
$parcel$export(module.exports, "loadJiraSwitcher", () => $59256ed14460f1cd$export$52c59c5b477673fb);
$parcel$export(module.exports, "loadConfluenceSwitcher", () => $59256ed14460f1cd$export$2d2945898d9ee55f);
$parcel$export(module.exports, "loadGenericSwitcher", () => $59256ed14460f1cd$export$64191a36345a6b2b);
$parcel$export(module.exports, "AtlassianSwitcherLoader", () => $59256ed14460f1cd$export$25f16f9fee84a840);
$parcel$export(module.exports, "JiraSwitcherLoader", () => $59256ed14460f1cd$export$10767845f9f42bd);
$parcel$export(module.exports, "ConfluenceSwitcherLoader", () => $59256ed14460f1cd$export$71f961c620294b68);
$parcel$export(module.exports, "GenericSwitcherLoader", () => $59256ed14460f1cd$export$8c21d1a0c59fc17e);

var $fuRVo = parcelRequire("fuRVo");

var $8P7DW = parcelRequire("8P7DW");

var $hBvhS = parcelRequire("hBvhS");

const $59256ed14460f1cd$export$6c6894dd831bfacb = ()=>(parcelRequire("k7hA1")).then((module)=>module.default);

const $59256ed14460f1cd$export$52c59c5b477673fb = ()=>(parcelRequire("kLWF0")).then((module)=>module.default);

const $59256ed14460f1cd$export$2d2945898d9ee55f = ()=>(parcelRequire("ioz14")).then((module)=>module.default);

const $59256ed14460f1cd$export$64191a36345a6b2b = ()=>(parcelRequire("eBa6W")).then((module)=>module.default);
const $59256ed14460f1cd$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: $59256ed14460f1cd$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hBvhS.default), null)
});
const $59256ed14460f1cd$export$10767845f9f42bd = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: $59256ed14460f1cd$export$52c59c5b477673fb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hBvhS.default), null)
});
const $59256ed14460f1cd$export$71f961c620294b68 = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: $59256ed14460f1cd$export$2d2945898d9ee55f,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hBvhS.default), null)
});
const $59256ed14460f1cd$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($fuRVo)))({
    loader: $59256ed14460f1cd$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hBvhS.default), null)
});

});
parcelRegister("hBvhS", function(module, exports) {
$parcel$export(module.exports, "default", () => $78b2c880408010c4$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $8P7DW = parcelRequire("8P7DW");

var $2CGHX = parcelRequire("2CGHX");

var $jrLfA = parcelRequire("jrLfA");
var $iLagP = parcelRequire("iLagP");

var $5jYgE = parcelRequire("5jYgE");

var $c6LiK = parcelRequire("c6LiK");
/*
  In the Remote App Switcher, the Skeleton component shows up first as a fallback while the full Remote App Switcher is still loading.
  Since the styles (compiled CSS) are lazy-loaded with the full App Switcher, they are not be ready when the Skeleton appears.
  This causes visual issues where the Skeleton looks broken

  To avoid this, we use inline styles instead. This guarantees that all required styles are applied immediately with the component.
  https://hello.jira.atlassian.cloud/browse/NAVX-676
*/ const $78b2c880408010c4$var$iconSkeleton = /*#__PURE__*/ $8P7DW.createElement((0, $2CGHX.default), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-large, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $78b2c880408010c4$var$lineSkeleton = /*#__PURE__*/ $8P7DW.createElement((0, $2CGHX.default), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-small, 4px)"
    }
});
var $78b2c880408010c4$export$2e2bcd8739ae039 = ()=>{
    (0, $iLagP.useExperienceRenderAndMountMark)((0, $jrLfA.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const items = /*#__PURE__*/ $8P7DW.createElement((0, $2CGHX.default), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        }
    }, $78b2c880408010c4$var$iconSkeleton, $78b2c880408010c4$var$lineSkeleton);
    return /*#__PURE__*/ $8P7DW.createElement((0, $2CGHX.default), {
        as: "section",
        style: {
            width: '343px',
            height: '80vh'
        },
        role: "alert",
        "aria-label": formatMessage((0, $c6LiK.default).skeletonLoaderAriaLabel),
        testId: "skeleton"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $2CGHX.default), {
        "aria-hidden": "true",
        style: {
            paddingInline: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-300, 24px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        }
    }, $78b2c880408010c4$var$lineSkeleton), items, items, items);
};

});
parcelRegister("iLagP", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $e58e761d9cbf2f60$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $e58e761d9cbf2f60$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $hWqIF = parcelRequire("hWqIF");

var $8P7DW = parcelRequire("8P7DW");

var $4x50v = parcelRequire("4x50v");
function $e58e761d9cbf2f60$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $hWqIF.useExperienceTracker)();
    (0, $4x50v.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $e58e761d9cbf2f60$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $hWqIF.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $8P7DW.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $e58e761d9cbf2f60$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $hWqIF.useExperienceTracker)();
    (0, $4x50v.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $8P7DW.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("4x50v", function(module, exports) {
$parcel$export(module.exports, "useSingleton", () => $9ea387b2057eab15$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $9ea387b2057eab15$export$ad4f8d0eee7a0e24);

var $8P7DW = parcelRequire("8P7DW");
function $9ea387b2057eab15$export$abf4268d2dd55708(builder) {
    const ref = (0, $8P7DW.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $9ea387b2057eab15$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $8P7DW.useRef)(false);
    const result = (0, $8P7DW.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});


parcelRegister("c6LiK", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3729d03c2413da0$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
const $c3729d03c2413da0$var$messages = (0, $7B9et.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primitive'
    },
    skeleton3pLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel',
        defaultMessage: 'The App Switcher third party section is loading',
        description: 'The aria-label for the app switcher third party skeleton loader primitive'
    },
    reorderItemDropdown: {
        id: 'fabric.atlassianSwitcher.reorderItemDropdown',
        defaultMessage: 'Reorder menu item',
        description: 'The text of a button to reorder an item in the switcher'
    },
    moveItemUp: {
        id: 'fabric.atlassianSwitcher.moveItemUp',
        defaultMessage: 'Move up',
        description: 'The text of a button to move an item up in the switcher'
    },
    moveItemDown: {
        id: 'fabric.atlassianSwitcher.moveItemDown',
        defaultMessage: 'Move down',
        description: 'The text of a button to move an item down in the switcher'
    },
    moveItemToTop: {
        id: 'fabric.atlassianSwitcher.moveItemToTop',
        defaultMessage: 'Move to top',
        description: 'The text of a button to move an item to the top in the switcher'
    },
    moveItemToBottom: {
        id: 'fabric.atlassianSwitcher.moveItemToBottom',
        defaultMessage: 'Move to bottom',
        description: 'The text of a button to move an item to the bottom in the switcher'
    }
});
var $c3729d03c2413da0$export$2e2bcd8739ae039 = $c3729d03c2413da0$var$messages;

});


parcelRegister("k7hA1", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("hgWeJ"),
    $j9MRt("g2Yfg")
]).then(()=>parcelRequire('4NobD'));

});

parcelRegister("kLWF0", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("eAq5g"),
    $j9MRt("hgWeJ"),
    $j9MRt("1kNIV"),
    $j9MRt("k9PE9"),
    $j9MRt("c5xQO"),
    $j9MRt("9hBNq"),
    $j9MRt("4RNdI"),
    $j9MRt("jKTRD"),
    $j9MRt("3XUZk"),
    $j9MRt("lUtvv"),
    $j9MRt("jdwnH")
]).then(()=>parcelRequire('6wt8o'));

});

parcelRegister("ioz14", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("eAq5g"),
    $j9MRt("hgWeJ"),
    $j9MRt("1kNIV"),
    $j9MRt("k9PE9"),
    $j9MRt("c5xQO"),
    $j9MRt("9hBNq"),
    $j9MRt("4RNdI"),
    $j9MRt("jKTRD"),
    $j9MRt("3XUZk"),
    $j9MRt("lUtvv"),
    $j9MRt("iXjg7")
]).then(()=>parcelRequire('9oFrk'));

});

parcelRegister("eBa6W", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("eAq5g"),
    $j9MRt("hgWeJ"),
    $j9MRt("1kNIV"),
    $j9MRt("k9PE9"),
    $j9MRt("c5xQO"),
    $j9MRt("9hBNq"),
    $j9MRt("4RNdI"),
    $j9MRt("jKTRD"),
    $j9MRt("3XUZk"),
    $j9MRt("lUtvv"),
    $j9MRt("61j81")
]).then(()=>parcelRequire('2tnqH'));

});



parcelRegister("8245b", function(module, exports) {
$parcel$export(module.exports, "FlightDeckProvider", () => $9424cb8e89270738$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "prefetchFlightDeck", () => $9424cb8e89270738$export$7d2a567d3e50224);

var $8P7DW = parcelRequire("8P7DW");

var $2IxGf = parcelRequire("2IxGf");

var $eErbn = parcelRequire("eErbn");

var $jrLfA = parcelRequire("jrLfA");

var $9SDuz = parcelRequire("9SDuz");

var $1lG1b = parcelRequire("1lG1b");

var $2xfLa = parcelRequire("2xfLa");

var $iba7g = parcelRequire("iba7g");
const $9424cb8e89270738$var$client = new (0, $2IxGf.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const { fetchMethod: $9424cb8e89270738$var$fetchFlightDeck, ProviderComponent: $9424cb8e89270738$var$DefaultFlightDeckProviderComponent } = (0, $eErbn.createProviderWithCustomFetchData)('flightDeck', (0, $jrLfA.ExperienceMark).API_FLIGHT_DECK, async ()=>{
    const artifact = await $9424cb8e89270738$var$client.fetchConfigFromFlightDeck({
        name: 'app-switcher-fe',
        dimensions: {
            environmentType: 'prod',
            perimeter: (0, $1lG1b.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        }
    });
    return $9424cb8e89270738$var$transformFlightDeckArtifactToProductConfiguration(artifact);
});
const $9424cb8e89270738$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $9SDuz.formatLabel)(displayName),
            description: (0, $9SDuz.formatDescription)(subtitle),
            iconKey: iconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $2xfLa.ASSETS_APP_KEY))) artifactMap.set((0, $2xfLa.ASSETS_APP_KEY), {
            key: (0, $2xfLa.ASSETS_APP_KEY),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            // make sure assets is below jsm
            label: (0, $9SDuz.formatLabel)((0, $iba7g.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $9SDuz.formatLabel)(link.displayName),
                    description: (0, $9SDuz.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $9424cb8e89270738$export$56da85ac9d40dbcd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($9424cb8e89270738$var$DefaultFlightDeckProviderComponent, null, children);
const $9424cb8e89270738$export$7d2a567d3e50224 = $9424cb8e89270738$var$fetchFlightDeck;

});
parcelRegister("2IxGf", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fa9d10c943cafca$export$2e2bcd8739ae039);

var $ceo2e = parcelRequire("ceo2e");

var $iBEcB = parcelRequire("iBEcB");

var $gBuCc = parcelRequire("gBuCc");

var $btJ8z = parcelRequire("btJ8z");
var $lf92G = parcelRequire("lf92G");

var $lLikv = parcelRequire("lLikv");

var $8R3Wd = parcelRequire("8R3Wd");

var $88bcr = parcelRequire("88bcr");
function $1fa9d10c943cafca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fa9d10c943cafca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fa9d10c943cafca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ceo2e.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fa9d10c943cafca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1fa9d10c943cafca$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $1fa9d10c943cafca$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $1fa9d10c943cafca$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $ceo2e.default)(this, "fallbackArtifactMap", new Map());
        (0, $ceo2e.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $gBuCc.default)($1fa9d10c943cafca$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $8R3Wd.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $iBEcB.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $btJ8z.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $lLikv.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$1fa9d10c943cafca$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $88bcr.flightDeckClientExperience)() : new (0, $lf92G.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $1fa9d10c943cafca$var$_objectSpread($1fa9d10c943cafca$var$_objectSpread({}, artifact), {}, {
                key: (0, $8R3Wd.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $88bcr.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("iBEcB", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $98b11bb2db3dedbf$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("g0gAT")).default);

var $9F5gS = parcelRequire("9F5gS");

var $gxmHu = parcelRequire("gxmHu");

var $g0gAT = parcelRequire("g0gAT");
const $98b11bb2db3dedbf$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $98b11bb2db3dedbf$var$NO_CALLS_ERROR = 'No calls made';
const $98b11bb2db3dedbf$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $gxmHu.NO_RETRIES), retryOn: retryOn = [
    (0, $g0gAT.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($98b11bb2db3dedbf$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $98b11bb2db3dedbf$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $98b11bb2db3dedbf$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $9F5gS.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("9F5gS", function(module, exports) {
$parcel$export(module.exports, "default", () => $f01fe615a7a44eca$export$2e2bcd8739ae039);
const $f01fe615a7a44eca$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $f01fe615a7a44eca$export$2e2bcd8739ae039 = $f01fe615a7a44eca$var$convertToError;

});

parcelRegister("gxmHu", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", () => $ae63b26fb1bd9c3e$export$a0a1c8f90becc136);
const $ae63b26fb1bd9c3e$export$a0a1c8f90becc136 = [];
const $ae63b26fb1bd9c3e$export$972171517b12aa4 = [
    0,
    0
];
const $ae63b26fb1bd9c3e$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $ae63b26fb1bd9c3e$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("g0gAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $752315891c495dbb$export$2e2bcd8739ae039);
class $752315891c495dbb$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("gBuCc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e520141fbcbf21fe$export$2e2bcd8739ae039);

var $bqgwg = parcelRequire("bqgwg");
const $e520141fbcbf21fe$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $e520141fbcbf21fe$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        const storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || $e520141fbcbf21fe$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $bqgwg.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
    captureException(e, tags) {
        var _this$handlers;
        if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("bqgwg", function(module, exports) {
$parcel$export(module.exports, "mockWindowStorage", () => $f7e49e31a533cd4c$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $f7e49e31a533cd4c$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $f7e49e31a533cd4c$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$f7e49e31a533cd4c$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};

});


parcelRegister("btJ8z", function(module, exports) {
$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $85b56a77c0ba7b19$export$6026918e023c9101);

var $7Bus9 = parcelRequire("7Bus9");

var $arzFO = parcelRequire("arzFO");

var $fB5aI = parcelRequire("fB5aI");

var $4lzTZ = parcelRequire("4lzTZ");

var $9rLmS = parcelRequire("9rLmS");

var $lf92G = parcelRequire("lf92G");

var $aACgB = parcelRequire("aACgB");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $85b56a77c0ba7b19$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $85b56a77c0ba7b19$var$defaultPerimeter = "commercial";
async function $85b56a77c0ba7b19$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $85b56a77c0ba7b19$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $85b56a77c0ba7b19$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $85b56a77c0ba7b19$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $7Bus9.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $85b56a77c0ba7b19$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $85b56a77c0ba7b19$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $85b56a77c0ba7b19$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $85b56a77c0ba7b19$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $85b56a77c0ba7b19$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $85b56a77c0ba7b19$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $lf92G.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $lf92G.getVersionMetadataFetchExperience)();
    return new (0, $9rLmS.ConfigClient)(new (0, $fB5aI.BifrostDataSource)(new (0, $4lzTZ.BifrostHttpClientImpl)(env, perimeter), (0, $arzFO.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $85b56a77c0ba7b19$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("7Bus9", function(module, exports) {
$parcel$export(module.exports, "default", () => $34e7458660ec1cfc$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $34e7458660ec1cfc$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $34e7458660ec1cfc$export$2e2bcd8739ae039 = $34e7458660ec1cfc$export$852ff24d0930c62f;

});

parcelRegister("arzFO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $2ByxV = parcelRequire("2ByxV");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $2ByxV.Either;
    }
});

var $bqfIH = parcelRequire("bqfIH");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $bqfIH.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $bqfIH.tryGetArtifactData;
    }
});

var $jB0Se = parcelRequire("jB0Se");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $jB0Se.parseArtifactManifest;
    }
});

var $bHZQP = parcelRequire("bHZQP");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $bHZQP.parseVersionMetadata;
    }
});

var $bC0Id = parcelRequire("bC0Id");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $bC0Id.checkManifest;
    }
});

var $f7UCz = parcelRequire("f7UCz");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $f7UCz.ConfigRegistryDataSource;
    }
});

var $arm3Y = parcelRequire("arm3Y");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $arm3Y.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $arm3Y.Versions;
    }
});

});
parcelRegister("2ByxV", function(module, exports) {
"use strict";
var $1e59d59fd2b801ba$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $1e59d59fd2b801ba$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $1e59d59fd2b801ba$var$Right(value);
    };
    Either.left = function(error) {
        return new $1e59d59fd2b801ba$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $1e59d59fd2b801ba$var$Either;
var $1e59d59fd2b801ba$var$Right = /** @class */ function(_super) {
    $1e59d59fd2b801ba$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $1e59d59fd2b801ba$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $1e59d59fd2b801ba$var$Either.right(this.right);
    };
    return Right;
}($1e59d59fd2b801ba$var$Either);
var $1e59d59fd2b801ba$var$Left = /** @class */ function(_super) {
    $1e59d59fd2b801ba$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $1e59d59fd2b801ba$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $1e59d59fd2b801ba$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $1e59d59fd2b801ba$var$Either.left(f(this.left));
    };
    return Left;
}($1e59d59fd2b801ba$var$Either);

});

parcelRegister("bqfIH", function(module, exports) {
"use strict";
var $850e510f05bc2271$var$__assign = module.exports && module.exports.__assign || function() {
    $850e510f05bc2271$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $850e510f05bc2271$var$__assign.apply(this, arguments);
};
var $850e510f05bc2271$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $850e510f05bc2271$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $850e510f05bc2271$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $850e510f05bc2271$var$tryGetArtifactData;

var $lbAOV = parcelRequire("lbAOV");

var $arzFO = parcelRequire("arzFO");

var $1uZcG = parcelRequire("1uZcG");

var $Rmez2 = parcelRequire("Rmez2");

var $3XIWt = parcelRequire("3XIWt");
function $850e510f05bc2271$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $850e510f05bc2271$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $850e510f05bc2271$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $850e510f05bc2271$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $850e510f05bc2271$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $arzFO.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $1uZcG.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $850e510f05bc2271$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $Rmez2.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $850e510f05bc2271$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $850e510f05bc2271$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $850e510f05bc2271$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $lbAOV.interpolateTagScheme)(manifest.tagScheme, $850e510f05bc2271$var$__assign($850e510f05bc2271$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $850e510f05bc2271$var$__awaiter(_this, void 0, void 0, function() {
                                return $850e510f05bc2271$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $850e510f05bc2271$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $3XIWt.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $3XIWt.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $Rmez2.assertUnreachable)(artifact);
    }
}

});
parcelRegister("lbAOV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $f6c72fcaa122a232$var$interpolateTagScheme;
module.exports.generateTagScheme = $f6c72fcaa122a232$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $f6c72fcaa122a232$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $f6c72fcaa122a232$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $f6c72fcaa122a232$var$getVersionMetadataTag;
const $f6c72fcaa122a232$var$TAG_SCHEME_VERSION = 2;
function $f6c72fcaa122a232$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($f6c72fcaa122a232$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $f6c72fcaa122a232$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $f6c72fcaa122a232$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $f6c72fcaa122a232$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $f6c72fcaa122a232$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $f6c72fcaa122a232$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $f6c72fcaa122a232$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $f6c72fcaa122a232$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("1uZcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $11781188dc715341$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $11781188dc715341$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("Rmez2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $0a06328add84a282$var$assertUnreachable;
function $0a06328add84a282$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("3XIWt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $2e29be5e7781c8cb$var$toJson;
module.exports.toPrettyJson = $2e29be5e7781c8cb$var$toPrettyJson;
function $2e29be5e7781c8cb$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $2e29be5e7781c8cb$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("jB0Se", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $e44226812ad174a2$var$parseArtifactManifest;

var $7tR1K = parcelRequire("7tR1K");
function $e44226812ad174a2$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $7tR1K.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $7tR1K.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $e44226812ad174a2$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $7tR1K.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $e44226812ad174a2$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $e44226812ad174a2$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $7tR1K.parseUnknownObject)(dimensions);
    var supported = (0, $7tR1K.parseArray)(unparsedDimensions.supported).map($7tR1K.parseString);
    var fallback = (0, $7tR1K.parseUndefinedOr)($7tR1K.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $e44226812ad174a2$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $7tR1K.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $e44226812ad174a2$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $e44226812ad174a2$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $7tR1K.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $7tR1K.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $7tR1K.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $7tR1K.parseUndefinedOr)($7tR1K.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $e44226812ad174a2$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $e44226812ad174a2$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("7tR1K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $57245fea66be59cd$var$parseString;
module.exports.parseArray = $57245fea66be59cd$var$parseArray;
module.exports.parseBoolean = $57245fea66be59cd$var$parseBoolean;
module.exports.parseUnknownObject = $57245fea66be59cd$var$parseUnknownObject;
module.exports.parseUndefinedOr = $57245fea66be59cd$var$parseUndefinedOr;
function $57245fea66be59cd$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $57245fea66be59cd$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $57245fea66be59cd$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $57245fea66be59cd$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $57245fea66be59cd$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("bHZQP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $8863b031112fe77d$var$parseVersionMetadata;

var $7tR1K = parcelRequire("7tR1K");
function $8863b031112fe77d$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $7tR1K.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $7tR1K.parseString)(unknownObject.version);
    var publishTime = new Date((0, $7tR1K.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $7tR1K.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("bC0Id", function(module, exports) {
"use strict";
var $8743cbc09a481358$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $8743cbc09a481358$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $8743cbc09a481358$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $8743cbc09a481358$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("f7UCz", function(module, exports) {
"use strict";
var $b0336e39062f4c9c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b0336e39062f4c9c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $lbAOV = parcelRequire("lbAOV");

var $2ByxV = parcelRequire("2ByxV");

var $jB0Se = parcelRequire("jB0Se");

var $bHZQP = parcelRequire("bHZQP");
var $b0336e39062f4c9c$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $b0336e39062f4c9c$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $b0336e39062f4c9c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $lbAOV.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($jB0Se.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $2ByxV.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $b0336e39062f4c9c$var$__awaiter(this, void 0, void 0, function() {
            return $b0336e39062f4c9c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $b0336e39062f4c9c$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $b0336e39062f4c9c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $lbAOV.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $bHZQP.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $b0336e39062f4c9c$var$ConfigRegistryDataSource;

});

parcelRegister("arm3Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $799d8a435083c8ae$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $799d8a435083c8ae$var$BaseUrls;
var $799d8a435083c8ae$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $799d8a435083c8ae$var$Versions;

});


parcelRegister("fB5aI", function(module, exports) {
$parcel$export(module.exports, "BifrostDataSource", () => $b5ae52b7740cbc71$export$2cb8d79200775058);

var $arzFO = parcelRequire("arzFO");

var $lbAOV = parcelRequire("lbAOV");
class $b5ae52b7740cbc71$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $lbAOV.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $arzFO.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $arzFO.parseVersionMetadata)(response);
                return (0, $arzFO.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $arzFO.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $lbAOV.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $arzFO.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $arzFO.parseArtifactManifest)(response);
                return (0, $arzFO.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $arzFO.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("4lzTZ", function(module, exports) {
$parcel$export(module.exports, "BifrostHttpClientImpl", () => $32a4f902e87ce02d$export$45c6d12ca9c14f83);

var $arzFO = parcelRequire("arzFO");
function $32a4f902e87ce02d$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $32a4f902e87ce02d$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $32a4f902e87ce02d$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $arzFO.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $arzFO.Either).right(json)));
            }).catch((error)=>resolve((0, $arzFO.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("9rLmS", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", () => $6e0b60fcc4eb559a$export$8489e2f039bfcc4c);

var $ceo2e = parcelRequire("ceo2e");

var $arzFO = parcelRequire("arzFO");

var $1z7lH = parcelRequire("1z7lH");
function $6e0b60fcc4eb559a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e0b60fcc4eb559a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e0b60fcc4eb559a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ceo2e.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e0b60fcc4eb559a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $6e0b60fcc4eb559a$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $1z7lH.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $6e0b60fcc4eb559a$var$_objectSpread($6e0b60fcc4eb559a$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $arzFO.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $arzFO.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("1z7lH", function(module, exports) {
$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $123ec2b07df1ff40$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $123ec2b07df1ff40$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("lf92G", function(module, exports) {
$parcel$export(module.exports, "MockExperience", () => $f772034f53aae6ad$export$5e7536cf7bc56fee);
$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $f772034f53aae6ad$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $f772034f53aae6ad$export$c3ac7702bfd47c1b);
const $f772034f53aae6ad$var$SAMPLING_RATE = 10;
class $f772034f53aae6ad$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $f772034f53aae6ad$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $f772034f53aae6ad$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $f772034f53aae6ad$var$SAMPLING_RATE) return new $f772034f53aae6ad$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("96R0l"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $f772034f53aae6ad$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $f772034f53aae6ad$export$5e7536cf7bc56fee();
    }
}
const $f772034f53aae6ad$export$a3006f8f221c0a3b = ()=>$f772034f53aae6ad$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $f772034f53aae6ad$export$c3ac7702bfd47c1b = ()=>$f772034f53aae6ad$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("96R0l", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("jbnFP").then(()=>parcelRequire('d3Lzj'));

});


parcelRegister("aACgB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $ciFPk = parcelRequire("ciFPk");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $ciFPk.parseConfigWithTargeting;
    }
});

var $20Vzv = parcelRequire("20Vzv");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $20Vzv.TargetedConfig;
    }
});

});
parcelRegister("ciFPk", function(module, exports) {
"use strict";
var $8f479c6a1d519a50$var$__assign = module.exports && module.exports.__assign || function() {
    $8f479c6a1d519a50$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8f479c6a1d519a50$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $8f479c6a1d519a50$var$parseConfigWithTargeting;

var $20Vzv = parcelRequire("20Vzv");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $8f479c6a1d519a50$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $8f479c6a1d519a50$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $20Vzv.TargetedConfig({
                defaultConfig: $8f479c6a1d519a50$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $8f479c6a1d519a50$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $20Vzv.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $8f479c6a1d519a50$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $8f479c6a1d519a50$var$__assign($8f479c6a1d519a50$var$__assign({}, accObject), (_a = {}, _a[key] = $8f479c6a1d519a50$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $8f479c6a1d519a50$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $8f479c6a1d519a50$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $8f479c6a1d519a50$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $8f479c6a1d519a50$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $8f479c6a1d519a50$var$parseIdentifierList(target.orgIds),
            siteIds: $8f479c6a1d519a50$var$parseIdentifierList(target.siteIds),
            userIds: $8f479c6a1d519a50$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $8f479c6a1d519a50$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("20Vzv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $17783d62fe3c638d$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $17783d62fe3c638d$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $17783d62fe3c638d$var$TargetedConfig;
function $17783d62fe3c638d$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("lLikv", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd7c34a8d9407bc6$export$2e2bcd8739ae039);
class $fd7c34a8d9407bc6$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $fd7c34a8d9407bc6$export$1d76d155060824c9 = (e)=>e instanceof $fd7c34a8d9407bc6$export$2e2bcd8739ae039;

});

parcelRegister("8R3Wd", function(module, exports) {
$parcel$export(module.exports, "artifactKey", () => $672653f4ed6d7de7$export$e3553dc63541d477);
const $672653f4ed6d7de7$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("88bcr", function(module, exports) {
$parcel$export(module.exports, "flightDeckClientExperience", () => $5eb7c21b82b9cc8b$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $5eb7c21b82b9cc8b$export$f33622abb5224195);

var $ceo2e = parcelRequire("ceo2e");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
function $5eb7c21b82b9cc8b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5eb7c21b82b9cc8b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5eb7c21b82b9cc8b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ceo2e.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5eb7c21b82b9cc8b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5eb7c21b82b9cc8b$export$1e3a41a51f6457c5 = ()=>new (0, $ghwxF.UFOExperience)("retrieve-artifact", {
        type: (0, $2lzZD.ExperienceTypes).Operation,
        performanceType: (0, $2lzZD.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $5eb7c21b82b9cc8b$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $5eb7c21b82b9cc8b$var$_objectSpread($5eb7c21b82b9cc8b$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});


parcelRegister("9SDuz", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $7469813b55f06927$export$957d7daebd899f12);
$parcel$export(module.exports, "formatDescription", () => $7469813b55f06927$export$f731e929548061dc);

var $8P7DW = parcelRequire("8P7DW");

var $l4cjO = parcelRequire("l4cjO");
const $7469813b55f06927$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), label);
};
const $7469813b55f06927$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l4cjO.default), description) : null;
};

});

parcelRegister("2xfLa", function(module, exports) {
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $5da1dd9105d47531$export$45e63649edff1e2a);
$parcel$export(module.exports, "TENANTLESS_ORG_ID", () => $5da1dd9105d47531$export$eb7589a4ee50c678);
const $5da1dd9105d47531$export$45e63649edff1e2a = 'ASSETS';
const $5da1dd9105d47531$export$eb7589a4ee50c678 = 'tenantless';

});

parcelRegister("iba7g", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fa35ff339d3a978$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
const $3fa35ff339d3a978$var$messages = (0, $7B9et.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    home: {
        id: 'fabric.atlassianSwitcher.atlassianHome',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    rovo: {
        id: 'fabric.atlassianSwitcher.rovo.no-translate',
        defaultMessage: 'Rovo',
        description: 'The text of a link redirecting the user to the rovo site'
    },
    administration: {
        id: 'fabric.atlassianSwitcher.administration',
        defaultMessage: 'Administration',
        description: 'The text of a link redirecting the user to Administration'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    assets: {
        id: 'fabric.atlassianSwitcher.assets',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets'
    },
    analytics: {
        id: 'fabric.atlassianSwitcher.analytics',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics'
    },
    companyHub: {
        id: 'fabric.atlassianSwitcher.companyHub',
        defaultMessage: 'Company Hub',
        description: 'The text of a link redirecting the user to the Company Hub'
    },
    goals: {
        id: 'fabric.atlassianSwitcher.goals',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals'
    },
    projects: {
        id: 'fabric.atlassianSwitcher.projects',
        defaultMessage: 'Projects',
        description: 'The text of a link redirecting the user to the Projects'
    },
    teams: {
        id: 'fabric.atlassianSwitcher.teams',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams'
    },
    search: {
        id: 'fabric.atlassianSwitcher.search',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search'
    },
    chat: {
        id: 'fabric.atlassianSwitcher.chat',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat'
    },
    studio: {
        id: 'fabric.atlassianSwitcher.studio',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    },
    expandProductList: {
        id: 'fabric.atlassianSwitcher.expandProductList',
        defaultMessage: '{numItems} more',
        description: 'Text for the button that expands the product list in the Atlassian Switcher.'
    },
    collapseProductList: {
        id: 'fabric.atlassianSwitcher.contractProductList',
        defaultMessage: 'Less',
        description: 'Text for the button that collapses the product list in the Atlassian Switcher.'
    },
    emptyStateExploreProductsBodyAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify',
        defaultMessage: 'Try an app to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLinkAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify',
        defaultMessage: 'Explore apps',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    errorTextUnverifiedAppify: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified-appify',
        defaultMessage: 'Please confirm your email address to view a list of available apps.',
        description: 'Text that is displayed when we detect user account is unverified.'
    }
});
var $3fa35ff339d3a978$export$2e2bcd8739ae039 = $3fa35ff339d3a978$var$messages;

});


parcelRegister("2AAQ7", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyProductsProvider", () => $cde05edfc2611cb3$export$a7ffda257898c103);
$parcel$export(module.exports, "prefetchThirdPartyProducts", () => $cde05edfc2611cb3$export$ba83558707df5bbe);

var $8P7DW = parcelRequire("8P7DW");

var $1bR5B = parcelRequire("1bR5B");
const { fetchMethod: $cde05edfc2611cb3$var$fetchAppSwitcherBffThirdPartyProducts, ProviderComponent: $cde05edfc2611cb3$var$DefaultBffThirdPartyProductsDataProvider } = (0, $1bR5B.createAppSwitcherBffThirdPartyProductsProvider)();
const $cde05edfc2611cb3$export$a7ffda257898c103 = ({ cloudId: cloudId, children: children, product: product })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($cde05edfc2611cb3$var$DefaultBffThirdPartyProductsDataProvider, {
        cloudId: cloudId,
        product: product
    }, children);
const $cde05edfc2611cb3$export$ba83558707df5bbe = $cde05edfc2611cb3$var$fetchAppSwitcherBffThirdPartyProducts;
const $cde05edfc2611cb3$export$fdb5fe543e39bc7a = ()=>$cde05edfc2611cb3$var$fetchAppSwitcherBffThirdPartyProducts.reset();

});
parcelRegister("1bR5B", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffThirdPartyProductsProvider", () => $2c5ac31c73b85a6d$export$1a41882ddb3a9c38);

var $eErbn = parcelRequire("eErbn");

var $4MVrt = parcelRequire("4MVrt");

var $jrLfA = parcelRequire("jrLfA");
const $2c5ac31c73b85a6d$export$7cf62b3dbe96f5e8 = '/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';
const $2c5ac31c73b85a6d$export$c39ca0fbc2221bcc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $4MVrt.fetchJsonWithNetworkRetries)(`${$2c5ac31c73b85a6d$export$7cf62b3dbe96f5e8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $2c5ac31c73b85a6d$export$1a41882ddb3a9c38 = ()=>{
    return (0, $eErbn.createProviderWithCustomFetchData)('appSwitcherBffThirdPartyProducts', (0, $jrLfA.ExperienceMark).API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS, $2c5ac31c73b85a6d$export$c39ca0fbc2221bcc);
};

});



parcelRegister("7UaAQ", function(module, exports) {
$parcel$export(module.exports, "performanceNow", () => $5235bd9728d84270$export$fb4230f160368c88);
const $5235bd9728d84270$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});






parcelRegister("3Ip9l", function(module, exports) {
$parcel$export(module.exports, "Sidebar", () => (parcelRequire("eoJ1i")).default);

var $eoJ1i = parcelRequire("eoJ1i");

});
parcelRegister("eoJ1i", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1f64f3f9f442d68$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $edC7N = parcelRequire("edC7N");

var $HGACo = parcelRequire("HGACo");

var $gmupc = parcelRequire("gmupc");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");

var $MmGmU = parcelRequire("MmGmU");
var $eS4yu = parcelRequire("eS4yu");

var $1G9Mf = parcelRequire("1G9Mf");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $bKNUr = parcelRequire("bKNUr");
var $b9CTU = parcelRequire("b9CTU");
var $3lgJw = parcelRequire("3lgJw");
var $3crYh = parcelRequire("3crYh");
var $iWdxx = parcelRequire("iWdxx");
var $3eh7y = parcelRequire("3eh7y");
var $2q65C = parcelRequire("2q65C");

var $iziiq = parcelRequire("iziiq");

var $hrPHR = parcelRequire("hrPHR");

var $9JK9A = parcelRequire("9JK9A");

var $Jhmxx = parcelRequire("Jhmxx");

var $4fofT = parcelRequire("4fofT");
parcelRequire("fsZqG");
var $iOkYN = parcelRequire("iOkYN");
parcelRequire("5u6sS");
var $iDrjg = parcelRequire("iDrjg");
const $a1f64f3f9f442d68$var$Sidebar = ({ width: width, navigationContentItems: navigationContentItems, featureName: featureName })=>{
    const { push: push } = (0, $dKPjT.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const helpCenterMessages = (0, $Jhmxx.useHelpCenterMessageDictionary)();
    const onBackButtonClick = (0, $8P7DW.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $iziiq.UI_EVENT_TYPE),
            action: 'click',
            actionSubjectId: `SidebarBackButton`
        }).fire();
        if (!(0, $HGACo.isProjectMappingInHelpCenterEnabled)()) (0, $9JK9A.getWindow)().location.href = `${(0, $hrPHR.getEnv)().baseUrl}`;
        else push(helpCenterMessages.backButtonHref);
    }, [
        createAnalyticsEvent,
        push,
        helpCenterMessages.backButtonHref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1G9Mf.default), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $a1f64f3f9f442d68$var$sidebarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2q65C.default), {
        label: formatMessage((0, $4fofT.default).sidebarNavigationLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iDrjg.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iWdxx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iOkYN.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $b9CTU.default), {
        onClick: onBackButtonClick
    }, (0, $HGACo.isProjectMappingInHelpCenterEnabled)() ? formatMessage(helpCenterMessages.backButton) : formatMessage((0, $4fofT.default).backButtonWithoutProjectMapping))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3crYh.default), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, (0, $HGACo.isProjectMappingInHelpCenterEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3lgJw.default), null, formatMessage(helpCenterMessages.settingsLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3eh7y.default), {
        isList: true
    }, navigationContentItems.map(({ onClick: onClick, iconBefore: iconBefore, text: text, isSelected: isSelected, isVisible: isVisible })=>{
        const renderButtonItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bKNUr.default), {
                onClick: onClick,
                iconBefore: iconBefore,
                key: text,
                isSelected: isSelected
            }, text);
        return isVisible && renderButtonItem();
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $a1f64f3f9f442d68$var$navFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3crYh.default), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3eh7y.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gmupc.default), {
        showIcon: true,
        showTypeField: true,
        featureName: featureName,
        buttonLabel: (0, $4fofT.default).feedbackWidget,
        analyticsSubjectId: "SidebarFeedbackButton",
        useSideNavButton: true
    }))))))));
};
const $a1f64f3f9f442d68$var$navFooter = (0, $37U6z.xcss)({
    position: 'relative'
});
const $a1f64f3f9f442d68$var$sidebarContainerStyles = (0, $37U6z.xcss)({
    width: '100%',
    height: '100%',
    borderRightWidth: 'border.width',
    borderRightStyle: 'solid',
    borderColor: 'color.border',
    boxSizing: 'inherit'
});
var $a1f64f3f9f442d68$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    component: 'SideBar'
})($a1f64f3f9f442d68$var$Sidebar);

});
parcelRegister("1G9Mf", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1023e700414968c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $k2Ig6 = parcelRequire("k2Ig6");

var $9toUq = parcelRequire("9toUq");

var $bJtLq = parcelRequire("bJtLq");
var $43fXs = parcelRequire("43fXs");

var $1twfn = parcelRequire("1twfn");

var $hetuB = parcelRequire("hetuB");

var $9FUL5 = parcelRequire("9FUL5");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $d1023e700414968c$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $9toUq.resolveDimension)((0, $k2Ig6.VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $8P7DW.useEffect)(()=>{
        (0, $bJtLq.default)({
            [(0, $k2Ig6.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
        });
        return ()=>{
            (0, $bJtLq.default)({
                [(0, $k2Ig6.VAR_LEFT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $43fXs.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $hetuB.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $9FUL5.default), {
        variableName: (0, $k2Ig6.VAR_LEFT_SIDEBAR_WIDTH),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $1twfn.default), {
        isFixed: isFixed
    }, children));
};
var $d1023e700414968c$export$2e2bcd8739ae039 = $d1023e700414968c$var$LeftSidebarWithoutResize;

});
parcelRegister("1twfn", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b1de3cfc6f4a0bf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8Z0o8 = parcelRequire("8Z0o8");

var $j1C0s = parcelRequire("j1C0s");
var $jh41u = parcelRequire("jh41u");

var $2Mjg8 = parcelRequire("2Mjg8");

var $k2Ig6 = parcelRequire("k2Ig6");

var $24eKl = parcelRequire("24eKl");
function $3b1de3cfc6f4a0bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $3b1de3cfc6f4a0bf$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $8Z0o8.css)((0, $jh41u.prefersReducedMotion)());
const $3b1de3cfc6f4a0bf$var$mobileStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $2Mjg8.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $k2Ig6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $k2Ig6.BANNER_HEIGHT)} + ${(0, $k2Ig6.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $k2Ig6.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $k2Ig6.TRANSITION_DURATION)}ms ${(0, $j1C0s.easeOut)} 0s`
    }
});
const $3b1de3cfc6f4a0bf$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $2Mjg8.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $k2Ig6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $k2Ig6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $k2Ig6.TRANSITION_DURATION)}ms ${(0, $j1C0s.easeOut)} 0s, box-shadow ${(0, $k2Ig6.TRANSITION_DURATION)}ms ${(0, $j1C0s.easeOut)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $3b1de3cfc6f4a0bf$var$fixedInnerStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $k2Ig6.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $k2Ig6.BANNER_HEIGHT)} + ${(0, $k2Ig6.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $k2Ig6.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $k2Ig6.TRANSITION_DURATION)}ms ${(0, $j1C0s.easeOut)} 0s`
});
const $3b1de3cfc6f4a0bf$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $k2Ig6.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $3b1de3cfc6f4a0bf$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $3b1de3cfc6f4a0bf$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $3b1de3cfc6f4a0bf$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $24eKl.default)();
    return /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
        css: [
            // mobile viewport styles
            $3b1de3cfc6f4a0bf$var$mobileStyles,
            isFlyoutOpen && $3b1de3cfc6f4a0bf$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $3b1de3cfc6f4a0bf$var$staticInnerStyles,
            isFixed && $3b1de3cfc6f4a0bf$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $3b1de3cfc6f4a0bf$var$fixedInnerFlyoutStyles,
            isDragging && $3b1de3cfc6f4a0bf$var$draggingStyles,
            $3b1de3cfc6f4a0bf$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3b1de3cfc6f4a0bf$export$2e2bcd8739ae039 = $3b1de3cfc6f4a0bf$var$LeftSidebarInner;

});

parcelRegister("hetuB", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7b2f10321ebe751$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $j1C0s = parcelRequire("j1C0s");
var $jh41u = parcelRequire("jh41u");

var $2Mjg8 = parcelRequire("2Mjg8");

var $k2Ig6 = parcelRequire("k2Ig6");

var $24eKl = parcelRequire("24eKl");

var $9toUq = parcelRequire("9toUq");

var $cOX58 = parcelRequire("cOX58");

var $7QrIq = parcelRequire("7QrIq");
function $b7b2f10321ebe751$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $b7b2f10321ebe751$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $8Z0o8.css)((0, $jh41u.prefersReducedMotion)());
const $b7b2f10321ebe751$var$mobileStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $2Mjg8.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $k2Ig6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $k2Ig6.TRANSITION_DURATION)}ms ${(0, $j1C0s.easeOut)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $k2Ig6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $b7b2f10321ebe751$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $2Mjg8.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $b7b2f10321ebe751$var$outerStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $k2Ig6.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $k2Ig6.TRANSITION_DURATION)}ms ${(0, $j1C0s.easeOut)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $b7b2f10321ebe751$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $b7b2f10321ebe751$var$fixedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $k2Ig6.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $b7b2f10321ebe751$var$flyoutStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $k2Ig6.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $b7b2f10321ebe751$var$flyoutFixedStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $k2Ig6.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $b7b2f10321ebe751$var$selector = (0, $9toUq.getPageLayoutSlotSelector)('left-sidebar');
const $b7b2f10321ebe751$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $24eKl.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $8P7DW.useContext)((0, $cOX58.SidebarResizeContext));
    return /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $7QrIq.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $8Z0o8.jsx)("div", {
            css: [
                // mobile viewport styles
                $b7b2f10321ebe751$var$mobileStyles,
                isFlyoutOpen && $b7b2f10321ebe751$var$mobileFlyoutStyles,
                // generic styles
                $b7b2f10321ebe751$var$outerStyles,
                isFixed && $b7b2f10321ebe751$var$fixedStyles,
                isFlyoutOpen && $b7b2f10321ebe751$var$flyoutStyles,
                isFlyoutOpen && isFixed && $b7b2f10321ebe751$var$flyoutFixedStyles,
                isDragging && $b7b2f10321ebe751$var$draggingStyles,
                $b7b2f10321ebe751$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$b7b2f10321ebe751$var$selector
        }, children));
};
const $b7b2f10321ebe751$var$LeftSidebarOuter = /*#__PURE__*/ (0, $8P7DW.forwardRef)($b7b2f10321ebe751$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b7b2f10321ebe751$export$2e2bcd8739ae039 = $b7b2f10321ebe751$var$LeftSidebarOuter;

});


parcelRegister("b9CTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $70d74852dc1e7aec$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $6YKjX = parcelRequire("6YKjX");

var $bKNUr = parcelRequire("bKNUr");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $70d74852dc1e7aec$var$GoBackItem = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6YKjX))), {
    color: "currentColor",
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $8P7DW.useState)(false);
    const onClickHandler = (0, $8P7DW.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bKNUr.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $70d74852dc1e7aec$export$2e2bcd8739ae039 = $70d74852dc1e7aec$var$GoBackItem;

});

parcelRegister("3lgJw", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d52095d2e79ae09$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $rV4PT = parcelRequire("rV4PT");

var $ivYWB = parcelRequire("ivYWB");
const $9d52095d2e79ae09$var$styles = {
    headingItem: "_18zru2gc"
};
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $9d52095d2e79ae09$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $ivYWB.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    // @ts-expect-error - Although this isn't defined on props it is available because we've used
    // spread props below and on the jsx element in MenuHeadingItem.
    const UNSAFE_className = props.className;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $rV4PT.default), {
        ...props,
        // @ts-expect-error
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $8n1kL.default)([
            $9d52095d2e79ae09$var$styles.headingItem,
            UNSAFE_className
        ])
    });
};
var $9d52095d2e79ae09$export$2e2bcd8739ae039 = $9d52095d2e79ae09$var$HeadingItem;

});

parcelRegister("3crYh", function(module, exports) {
$parcel$export(module.exports, "default", () => $51ad3ca202e738b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $tkRiw = parcelRequire("tkRiw");

var $ivYWB = parcelRequire("ivYWB");
const $51ad3ca202e738b7$var$outerContainerCSS = null;
const $51ad3ca202e738b7$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjlb4i _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $51ad3ca202e738b7$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $51ad3ca202e738b7$var$NavigationContent = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $ivYWB.useShouldNestedElementRender)();
    const scrollbar = (0, $tkRiw.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $8n1kL.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rusvpsx _1kt9b3bt _1enwftgi _z5wtu2gc _14mjlb4i _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfkvpsx _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $8n1kL.default)([
                $51ad3ca202e738b7$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $51ad3ca202e738b7$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                className: (0, $8n1kL.default)([
                    $51ad3ca202e738b7$var$containerCSS.basic,
                    showTopScrollIndicator && $51ad3ca202e738b7$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $51ad3ca202e738b7$export$2e2bcd8739ae039 = $51ad3ca202e738b7$var$NavigationContent;

});
parcelRegister("tkRiw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e01a90dbe212bb2$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
function $0e01a90dbe212bb2$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $8P7DW.useState)(0);
    const elementRef = (0, $8P7DW.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $8P7DW.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("iWdxx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f468211dbd6e36ed$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $2CGHX = parcelRequire("2CGHX");
const $f468211dbd6e36ed$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $f468211dbd6e36ed$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        xcss: $f468211dbd6e36ed$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $f468211dbd6e36ed$export$2e2bcd8739ae039 = $f468211dbd6e36ed$var$NavigationHeader;

});

parcelRegister("3eh7y", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dc2ece7145e6bb4$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $7qJSw = parcelRequire("7qJSw");

var $ivYWB = parcelRequire("ivYWB");
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $9dc2ece7145e6bb4$var$Section = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $ivYWB.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7qJSw.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $9dc2ece7145e6bb4$export$2e2bcd8739ae039 = $9dc2ece7145e6bb4$var$Section;

});

parcelRegister("2q65C", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ea6f207310d3867$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $kFogY = parcelRequire("kFogY");
const $0ea6f207310d3867$var$sidebarMinWidth = '240px';
const $0ea6f207310d3867$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $0ea6f207310d3867$var$SideNavigation = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $8n1kL.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkvuon _syazazsu"
        ]),
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $kFogY.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $0ea6f207310d3867$export$2e2bcd8739ae039 = $0ea6f207310d3867$var$SideNavigation;

});

parcelRegister("9JK9A", function(module, exports) {
$parcel$export(module.exports, "getWindow", () => $15fc4568a108a64c$export$38b2d434cce3ea22);
const $15fc4568a108a64c$export$38b2d434cce3ea22 = ()=>window;

});

parcelRegister("Jhmxx", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterMessageDictionary", () => $54d7142d6c6fdd0f$export$5698e375f19e7351);
$parcel$export(module.exports, "useConditionalMessage", () => $54d7142d6c6fdd0f$export$17f06fb6e83cbd1d);

var $42qw9 = parcelRequire("42qw9");

var $1cmFi = parcelRequire("1cmFi");

var $4fofT = parcelRequire("4fofT");

var $f95zw = parcelRequire("f95zw");
const $54d7142d6c6fdd0f$export$5698e375f19e7351 = ()=>{
    const { isHelpHub: isHelpHub } = (0, $42qw9.useOptionalHelpCenterType)();
    return {
        // Sidebar messages
        backButton: isHelpHub ? (0, $4fofT.default).backButtonHelpHub : (0, $4fofT.default).backButton,
        backButtonHref: isHelpHub ? '/hubs' : '/',
        settingsLabel: isHelpHub ? (0, $4fofT.default).settingsLabelHelpHub : (0, $4fofT.default).settingsLabel,
        // Breadcrumb messages
        breadcrumbRoot: isHelpHub ? (0, $1cmFi.default).settingsPageBreadcrumbItemHelpHub : (0, $1cmFi.default).settingsPageBreadcrumbItem,
        // Sidebar header
        headerLabel: isHelpHub ? (0, $f95zw.default).helpHubLabel : (0, $f95zw.default).helpCenterLabel
    };
};
const $54d7142d6c6fdd0f$export$17f06fb6e83cbd1d = (helpHubMessage, helpCenterMessage)=>{
    const { isHelpHub: isHelpHub } = (0, $42qw9.useOptionalHelpCenterType)();
    return isHelpHub ? helpHubMessage : helpCenterMessage;
};

});
parcelRegister("1cmFi", function(module, exports) {
$parcel$export(module.exports, "default", () => $4565f1d9cf8bbdc3$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $4565f1d9cf8bbdc3$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    settingsPageBreadcrumbItem: {
        defaultMessage: 'Help centers',
        description: 'Help center edit details page breadcrumb item',
        id: 'help.center.settings.breadcrumb.item'
    },
    settingsPageBreadcrumbItemHelpHub: {
        defaultMessage: 'Help hubs',
        description: 'Help hub edit details page breadcrumb item',
        id: 'help.hub.settings.breadcrumb.item'
    },
    breadcrumbsLabel: {
        id: 'help.center.settings.breadcrumbs.container',
        defaultMessage: 'Breadcrumbs',
        description: 'Help Center Breadcrumbs wrapper label'
    }
});

});

parcelRegister("4fofT", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d64e7970fb51b7d$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $7d64e7970fb51b7d$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    feedbackWidget: {
        defaultMessage: 'Give feedback',
        description: 'The text for give feedback button for help centers management screen',
        id: 'sidebar.feedback.widget'
    },
    backButton: {
        defaultMessage: 'Back to all help centers',
        description: 'The text for the back button in the sidebar',
        id: 'sidebar.back.hc.management.button'
    },
    backButtonHelpHub: {
        defaultMessage: 'Back to help hubs',
        description: 'The text for the back button in the sidebar when viewing a help hub',
        id: 'sidebar.back.helphub.management.button'
    },
    backButtonWithoutProjectMapping: {
        defaultMessage: 'Back to help center',
        description: 'The text for the back button in the sidebar',
        id: 'sidebar.back.hc.button'
    },
    settingsLabel: {
        defaultMessage: 'Help center settings',
        description: 'Label for settings',
        id: 'sidebar.settings.label'
    },
    settingsLabelHelpHub: {
        defaultMessage: 'Help hub settings',
        description: 'Label for settings when viewing a help hub',
        id: 'sidebar.settings.label.helphub'
    },
    sidebarNavigationLabel: {
        defaultMessage: 'Sidebar navigation',
        description: 'Label for sidebar navigation',
        id: 'sidebar.navigation.label'
    }
});

});

parcelRegister("f95zw", function(module, exports) {
$parcel$export(module.exports, "default", () => $1be5994cab3f5080$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $1be5994cab3f5080$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    helpCenterLabel: {
        defaultMessage: 'Help Center',
        description: 'Label for help center',
        id: 'sidebar.help-center.header.helpcenter.label'
    },
    helpHubLabel: {
        defaultMessage: 'Help hub',
        description: 'Label for help hub',
        id: 'sidebar.help-center.header.helphub.label'
    },
    helpCenterImageAltLabel: {
        defaultMessage: 'help center icon',
        description: 'Label for help center icon in sidebar',
        id: 'sidebar.help-center.header.helpcenter.image.alt.label'
    }
});

});


parcelRegister("fsZqG", function(module, exports) {
$parcel$export(module.exports, "SidebarHelpCenterHeader", () => (parcelRequire("iOkYN")).default);

var $iOkYN = parcelRequire("iOkYN");

});
parcelRegister("iOkYN", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a5a8f517e7d121e$export$2e2bcd8739ae039);
/* sidebar-help-center-header.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4aLDz = parcelRequire("4aLDz");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
var $77UGK = parcelRequire("77UGK");

var $jByYr = parcelRequire("jByYr");

var $4mb4P = parcelRequire("4mb4P");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");

var $jjY8K = parcelRequire("jjY8K");

var $dSz79 = parcelRequire("dSz79");

var $Jhmxx = parcelRequire("Jhmxx");
const $0a5a8f517e7d121e$var$SidebarHelpCenterHeader = ()=>{
    var _data$helpCenter;
    const helpCenterAri = (0, $dSz79.useHelpCenterAri)();
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $4aLDz.default), {
        helpCenterAri: helpCenterAri,
        cloudId: (0, $jByYr.getCloudId)()
    });
    const helpCenterData = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    let { currentHcName: currentHcName, currentHcBannerUrl: currentHcBannerUrl, currentHcThemeColor: currentHcThemeColor, useDefaultBanner: useDefaultBanner } = {
        currentHcName: undefined,
        currentHcBannerUrl: null,
        currentHcThemeColor: null,
        useDefaultBanner: false
    };
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) === 'HelpCenter') {
        var _helpCenterData$name, _helpCenterData$helpC, _helpCenterData$helpC2, _helpCenterData$helpC3;
        currentHcName = helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$name = helpCenterData.name) === null || _helpCenterData$name === void 0 ? void 0 : _helpCenterData$name.default;
        currentHcBannerUrl = (_helpCenterData$helpC = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC === void 0 || (_helpCenterData$helpC = _helpCenterData$helpC.banner) === null || _helpCenterData$helpC === void 0 ? void 0 : _helpCenterData$helpC.url;
        currentHcThemeColor = (_helpCenterData$helpC2 = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC2 === void 0 || (_helpCenterData$helpC2 = _helpCenterData$helpC2.colors) === null || _helpCenterData$helpC2 === void 0 ? void 0 : _helpCenterData$helpC2.primary;
        useDefaultBanner = !!((_helpCenterData$helpC3 = helpCenterData.helpCenterBranding) !== null && _helpCenterData$helpC3 !== void 0 && _helpCenterData$helpC3.useDefaultBanner);
    }
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const helpCenterMessages = (0, $Jhmxx.useHelpCenterMessageDictionary)();
    const defaultImage = useDefaultBanner ? (0, (/*@__PURE__*/$parcel$interopDefault($4mb4P))) : undefined;
    const backgroundImage = currentHcBannerUrl ? currentHcBannerUrl : defaultImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jjY8K.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($0a5a8f517e7d121e$var$HelpCenterImage, {
            backgroundColor: currentHcThemeColor,
            src: backgroundImage || (0, (/*@__PURE__*/$parcel$interopDefault($4mb4P))),
            height: 24,
            width: 24,
            alt: formatMessage(helpCenterMessages.headerLabel)
        }),
        description: formatMessage(helpCenterMessages.headerLabel)
    }, currentHcName);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0a5a8f517e7d121e$var$HelpCenterImage = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_128mzge": (0, $77UGK.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_2rko1l7b _5ral1dfr",
            !__cmplp.backgroundColor ? "_bfhk4re7" : "_bfhkmpv7",
            __cmplp.className
        ])
    });
});
var $0a5a8f517e7d121e$export$2e2bcd8739ae039 = $0a5a8f517e7d121e$var$SidebarHelpCenterHeader;

});
parcelRegister("4aLDz", function(module, exports) {
$parcel$export(module.exports, "default", () => $869921dd1f6d115b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd214fccbd754a812c401ac49e37f1f1>>
 * @relayHash 6337212810c49a971e575c2b12da2d45
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03c90fb33e97de1111ac72fc2f5f2d0015bf74b51ff66581f9c6c1ae79817956
const $869921dd1f6d115b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "default"
            }
        ]
    }, v5 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterBanner",
                "kind": "LinkedField",
                "name": "banner",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "primary"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "useDefaultBanner"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarHelpCenterHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "helpCenter.helpCenterById.helpCenterBranding"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarHelpCenterHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "03c90fb33e97de1111ac72fc2f5f2d0015bf74b51ff66581f9c6c1ae79817956",
            "metadata": {},
            "name": "sidebarHelpCenterHeaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$869921dd1f6d115b$var$node.hash = "b1b17113e136ecbdd8bfb74c4910cc78";
var $869921dd1f6d115b$export$2e2bcd8739ae039 = $869921dd1f6d115b$var$node;

});

parcelRegister("jjY8K", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b6cc9108359de79$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $4SiNi = parcelRequire("4SiNi");

var $1hUNf = parcelRequire("1hUNf");
const $3b6cc9108359de79$var$styles = {
    header: "_uizt1wug _vrjt1qyo _1cmdi7uo _11kjsm61 _jl2n73ad _1et6sm61 _1v6ji7uo"
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $3b6cc9108359de79$var$Header = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $4SiNi.default), {
        ...props,
        ref: ref,
        component: props.component || (0, $1hUNf.default),
        isTitleHeading: true,
        className: (0, $8n1kL.default)([
            $3b6cc9108359de79$var$styles.header
        ])
    });
});
var $3b6cc9108359de79$export$2e2bcd8739ae039 = $3b6cc9108359de79$var$Header;

});
parcelRegister("4SiNi", function(module, exports) {
$parcel$export(module.exports, "default", () => $736b671e29634f36$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $lkatq = parcelRequire("lkatq");

var $ivYWB = parcelRequire("ivYWB");
const $736b671e29634f36$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhksm61 _1a391k8s _racp1k8s _30l3azsu _irr31dpa _ppn2azsu _183jfcek",
    selectedStyles: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $736b671e29634f36$var$CustomItem = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $ivYWB.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $lkatq.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8n1kL.default)([
            $736b671e29634f36$var$styles.root,
            props.isSelected && $736b671e29634f36$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $736b671e29634f36$export$2e2bcd8739ae039 = $736b671e29634f36$var$CustomItem;

});

parcelRegister("1hUNf", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8bdd19988e7f34e$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");
/**
 * __Container__
 *
 * A container for Header and Footer that safely handles props to the child component
 */ const $c8bdd19988e7f34e$var$HeaderContainer = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId,
        style: {
            position: 'relative'
        },
        ...safeProps,
        children: children
    }));
};
var $c8bdd19988e7f34e$export$2e2bcd8739ae039 = $c8bdd19988e7f34e$var$HeaderContainer;

});




parcelRegister("5u6sS", function(module, exports) {
$parcel$export(module.exports, "SidebarSkeleton", () => (parcelRequire("iDrjg")).default);

var $iDrjg = parcelRequire("iDrjg");

});
parcelRegister("iDrjg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a98d0e3a047861ab$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $HGACo = parcelRequire("HGACo");

var $iSvee = parcelRequire("iSvee");

var $6Hfjm = parcelRequire("6Hfjm");
var $dqsXi = parcelRequire("dqsXi");
var $2IKBM = parcelRequire("2IKBM");
var $37U6z = parcelRequire("37U6z");

var $jjY8K = parcelRequire("jjY8K");
var $3crYh = parcelRequire("3crYh");
var $iWdxx = parcelRequire("iWdxx");
var $3eh7y = parcelRequire("3eh7y");

var $hrPHR = parcelRequire("hrPHR");
const $a98d0e3a047861ab$var$SideBarContentSkeleton = ()=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        gap: "space.150",
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        height: "14px",
        width: "14px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        height: "16px",
        width: "35%"
    }));
};
const $a98d0e3a047861ab$var$SidebarHeaderSkeleton = ()=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $iWdxx.default), null, /*#__PURE__*/ $8P7DW.createElement((0, $jjY8K.default), {
        iconBefore: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
            height: "24px",
            width: "80%",
            "data-testid": "icon-skeleton"
        }),
        description: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
            height: "16px",
            width: "55%",
            "data-testid": "description-skeleton"
        })
    }, /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlockEnd: "space.025"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        height: "16px",
        width: "85%",
        "data-testid": "title-skeleton"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlockStart: "space.300",
        paddingBlockEnd: "space.150",
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        direction: "row",
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        height: "18px",
        width: "18px",
        isCircle: true
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        height: "16px",
        width: "60%"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $3crYh.default), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        height: "16px",
        width: "30%"
    })), /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.300"
    }, (0, $HGACo.isProjectMappingInHelpCenterEnabled)() && /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, /*#__PURE__*/ $8P7DW.createElement($a98d0e3a047861ab$var$SideBarContentSkeleton, null), /*#__PURE__*/ $8P7DW.createElement($a98d0e3a047861ab$var$SideBarContentSkeleton, null)), (0, $HGACo.isCustomPagesUiEnabled)() && (0, $hrPHR.getIsHCCustomizationEnabled)() && /*#__PURE__*/ $8P7DW.createElement($a98d0e3a047861ab$var$SideBarContentSkeleton, null), /*#__PURE__*/ $8P7DW.createElement($a98d0e3a047861ab$var$SideBarContentSkeleton, null)))), /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        xcss: $a98d0e3a047861ab$var$navFooter
    }, /*#__PURE__*/ $8P7DW.createElement((0, $3crYh.default), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ $8P7DW.createElement((0, $3eh7y.default), null, /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        gap: "space.150",
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        height: "14px",
        width: "14px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        height: "16px",
        width: "70%"
    })))))));
};
const $a98d0e3a047861ab$var$navFooter = (0, $37U6z.xcss)({
    position: 'absolute',
    bottom: 'space.0',
    width: '94%'
});
var $a98d0e3a047861ab$export$2e2bcd8739ae039 = $a98d0e3a047861ab$var$SidebarHeaderSkeleton;

});




parcelRegister("20PEm", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f88ed58630bdf1d$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $2f88ed58630bdf1d$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    helpcenterDetailsItem: {
        defaultMessage: 'Details',
        description: 'Label for the help center details item in the help center management screen sidebar',
        id: 'admin.management.sidebar.edit.details'
    },
    helpcenterManageProjectsItem: {
        defaultMessage: 'Projects',
        description: 'Label for the help center projects item in the help center management screen sidebar',
        id: 'admin.management.sidebar.manage.projects'
    },
    helpcenterManageProjectsItemGalaxia: {
        defaultMessage: 'Spaces',
        description: 'Label for the help center spaces item in the help center management screen sidebar',
        id: 'admin.management.sidebar.manage.projects-galaxia'
    },
    helpcenterManagePagesItem: {
        defaultMessage: 'Landing pages',
        description: 'Label for the help center landing pages item in the help center management screen sidebar',
        id: 'admin.management.sidebar.landing.pages'
    },
    helpcenterRovoServiceAgentItem: {
        defaultMessage: 'Rovo agent',
        description: 'Label for the help center Rovo service agent item in the help center management screen sidebar',
        id: 'admin.management.sidebar.rovo.service.agent'
    },
    helpcenterVsaReportingItem: {
        defaultMessage: 'Virtual service agent',
        description: 'Label for the help center reporting item in the help center management screen sidebar',
        id: 'admin.management.sidebar.reporting'
    },
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title',
        id: 'admin.management.sidebar.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error description',
        id: 'admin.management.sidebar.error.description'
    },
    landingPagesSidebarChangeBoardingHeading: {
        defaultMessage: 'Create unique pages in the help center',
        description: 'Heading text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.heading'
    },
    landingPagesSidebarChangeBoardingContent: {
        defaultMessage: "Customize layouts and curate help content to create visually-appealing landing pages that meet your audience's needs.",
        description: 'Spotlight content text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.content'
    },
    landingPagesSidebarChangeBoardingDismissButton: {
        defaultMessage: 'Dismiss',
        description: 'Dismiss button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.button.dismiss'
    },
    landingPagesSidebarChangeBoardingTryButton: {
        defaultMessage: 'Try now',
        description: 'Try now button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.button.try'
    }
});

});



parcelRegister("dnZw2", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManageProjects", () => (parcelRequire("bxvY7")).HelpCenterManageProjects);

var $bxvY7 = parcelRequire("bxvY7");

});
parcelRegister("bxvY7", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManageProjects", () => $c688147e6741e869$export$44752868a2f1a12);

var $7j8cd = parcelRequire("7j8cd");

var $8P7DW = parcelRequire("8P7DW");

var $cS6Xr = parcelRequire("cS6Xr");

var $4RQBu = parcelRequire("4RQBu");

var $8rTkC = parcelRequire("8rTkC");

var $edC7N = parcelRequire("edC7N");

var $jByYr = parcelRequire("jByYr");

var $3ZeMI = parcelRequire("3ZeMI");

var $1We2B = parcelRequire("1We2B");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");

var $8gu7I = parcelRequire("8gu7I");
var $MmGmU = parcelRequire("MmGmU");

var $1Gxf0 = parcelRequire("1Gxf0");
var $atwik = parcelRequire("atwik");

var $6Bfdg = parcelRequire("6Bfdg");

var $1EFS8 = parcelRequire("1EFS8");

var $iqJis = parcelRequire("iqJis");

var $kDg5W = parcelRequire("kDg5W");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $gFpea = parcelRequire("gFpea");

var $bQ8UI = parcelRequire("bQ8UI");
var $17wqU = parcelRequire("17wqU");

var $iziiq = parcelRequire("iziiq");

var $aQXm8 = parcelRequire("aQXm8");

var $hrPHR = parcelRequire("hrPHR");

var $klz3F = parcelRequire("klz3F");

var $dfS0m = parcelRequire("dfS0m");
var $8y0tS = parcelRequire("8y0tS");

var $42qw9 = parcelRequire("42qw9");

var $dSz79 = parcelRequire("dSz79");
parcelRequire("irqBT");
var $i3cng = parcelRequire("i3cng");
parcelRequire("2xFxw");
var $gRzNN = parcelRequire("gRzNN");

var $6wbA7 = parcelRequire("6wbA7");
parcelRequire("cTUuW");
var $2nHpE = parcelRequire("2nHpE");

var $9hPIF = parcelRequire("9hPIF");
parcelRequire("91Eu3");
var $gqvCg = parcelRequire("gqvCg");
parcelRequire("1HwKL");
var $DSjZz = parcelRequire("DSjZz");

var $iJzXX = parcelRequire("iJzXX");
const $c688147e6741e869$var$PROJECT_MAPPING_SUPPORT_DOC_URL = 'https://support.atlassian.com/jira-service-management-cloud/docs/link-service-projects-to-a-help-center/';
const $c688147e6741e869$var$StaticContent = ({ isReadOnlyView: isReadOnlyView })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { isHelpHub: isHelpHub } = (0, $42qw9.useHelpCenterType)();
    const isGalaxia = (0, $1EFS8.default).checkGate('itsm-project-renaming');
    const helpCenterManageProjectsLink = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cS6Xr.Link), {
            href: $c688147e6741e869$var$PROJECT_MAPPING_SUPPORT_DOC_URL,
            actionSubjectId: "manageProjectsLink",
            target: "_blank",
            rel: "noreferrer"
        }, chunks);
    const pageTitle = isGalaxia ? (0, $9hPIF.default).manageProjectsPageTitleGalaxia : (0, $9hPIF.default).manageProjectsPageTitle;
    let pageDescription;
    if (isReadOnlyView) pageDescription = isGalaxia ? (0, $9hPIF.default).manageProjectsPageDescriptionForDefaultHCGalaxia : (0, $9hPIF.default).manageProjectsPageDescriptionForDefaultHC;
    else if (isHelpHub) pageDescription = (0, $9hPIF.default).manageProjectsPageDescriptionHelpHub;
    else if (isGalaxia) pageDescription = (0, $9hPIF.default).manageProjectsPageDescriptionGalaxia;
    else pageDescription = (0, $9hPIF.default).manageProjectsPageDescription;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
        size: "large"
    }, formatMessage(pageTitle)), isReadOnlyView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, formatMessage(pageDescription, {
        link: helpCenterManageProjectsLink
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, isHelpHub ? formatMessage(pageDescription) : formatMessage(pageDescription, {
        link: helpCenterManageProjectsLink
    })));
};
const $c688147e6741e869$var$HelpCenterManageProjectsComponent = ()=>{
    var _data$jira, _data$helpCenter, _data$helpCenter2, _data$helpCenter3, _data$helpCenter4, _data$jira2;
    const [helpCenterMappingStatus, setHelpCenterMappingStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState((0, $iJzXX.ProjectsMappingStatus).LINKED);
    const helpCenterAri = (0, $dSz79.useHelpCenterAri)();
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $7j8cd.default), {
        helpCenterMappingStatus: helpCenterMappingStatus,
        helpCenterId: '',
        helpCenterARI: helpCenterAri,
        cloudId: (0, $jByYr.getCloudId)()
    });
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [searchQuery, setSearchQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState('');
    const onInputChange = (value)=>{
        setSearchQuery(value);
    };
    const debouncedOnChange = (0, $1We2B.debounce)(onInputChange, (0, $8rTkC.USER_TYPING_DEBOUNCE_TIME));
    const onTextFieldChange = (0, $8P7DW.useCallback)((event)=>{
        const value = event.target.value;
        debouncedOnChange(value);
    }, [
        debouncedOnChange
    ]);
    const statusTextMap = {
        [(0, $iJzXX.ProjectsMappingStatus).LINKED]: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $9hPIF.default).linkedFilterLabelGalaxia) : formatMessage((0, $9hPIF.default).linkedFilterLabel),
        [(0, $iJzXX.ProjectsMappingStatus).UNLINKED]: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $9hPIF.default).unlinkedFilterLabelGalaxia) : formatMessage((0, $9hPIF.default).unlinkedFilterLabel)
    };
    if (!(data !== null && data !== void 0 && (_data$jira = data.jira) !== null && _data$jira !== void 0 && _data$jira.jiraProjectsMappedToHelpCenter)) return null;
    if (!(data !== null && data !== void 0 && (_data$helpCenter = data.helpCenter) !== null && _data$helpCenter !== void 0 && _data$helpCenter.helpCenterById)) return null;
    const slug = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.slug;
    const isDefaultHC = !slug;
    const isReadOnlyView = !(0, $hrPHR.getIsMultiHCEnabled)() || isDefaultHC;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bQ8UI.ContextWrapper), {
        sourceName: (0, $8rTkC.ScreenName).MANAGE_PROJECTS,
        sourceType: (0, $17wqU.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gRzNN.default), {
        helpCenterData: (_data$helpCenter3 = data.helpCenter) === null || _data$helpCenter3 === void 0 ? void 0 : _data$helpCenter3.helpCenterById
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($c688147e6741e869$var$StaticContent, {
        isReadOnlyView: isReadOnlyView
    }), !isReadOnlyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $9hPIF.default).manageProjectPageToggleForDefaultLinkingGalaxia) : formatMessage((0, $9hPIF.default).manageProjectPageToggleForDefaultLinking)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $DSjZz.default), {
        syncProjectsToggleFragmentKey: (_data$helpCenter4 = data.helpCenter) === null || _data$helpCenter4 === void 0 ? void 0 : _data$helpCenter4.helpCenterById
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $c688147e6741e869$var$searchInputStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gFpea.default), {
        name: "search",
        autoComplete: "off",
        isCompact: true,
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            paddingInlineEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kDg5W))), {
            size: "small",
            label: "search icon",
            spacing: "spacious"
        })),
        defaultValue: searchQuery,
        onChange: onTextFieldChange,
        placeholder: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $9hPIF.default).searchProjectsPlaceholderGalaxia) : formatMessage((0, $9hPIF.default).searchProjectsPlaceholder)
    })), !isReadOnlyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: 'projectMappingMenu'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $c688147e6741e869$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $1Gxf0.default), {
        trigger: statusTextMap[helpCenterMappingStatus],
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $atwik.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: 'projectMappingLinkedMenuItem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4RQBu.DropdownItem), {
        onClick: ()=>{
            setHelpCenterMappingStatus((0, $iJzXX.ProjectsMappingStatus).LINKED);
        }
    }, statusTextMap[(0, $iJzXX.ProjectsMappingStatus).LINKED])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            actionSubjectId: 'projectMappingUnLinkedMenuItem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $4RQBu.DropdownItem), {
        onClick: ()=>{
            setHelpCenterMappingStatus((0, $iJzXX.ProjectsMappingStatus).UNLINKED);
        }
    }, statusTextMap[(0, $iJzXX.ProjectsMappingStatus).UNLINKED])))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gqvCg.default), {
        isReadOnlyView: isReadOnlyView,
        projectsListFragmentKey: data === null || data === void 0 || (_data$jira2 = data.jira) === null || _data$jira2 === void 0 ? void 0 : _data$jira2.jiraProjectsMappedToHelpCenter,
        selection: helpCenterMappingStatus,
        searchQuery: searchQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $6wbA7.manageProjectsExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), null)));
};
const $c688147e6741e869$export$44752868a2f1a12 = ()=>{
    (0, $8y0tS.useUFOComponentExperience)((0, $6wbA7.manageProjectsExperience));
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const onError = (error)=>{
        if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) {
            (0, $6wbA7.manageProjectsExperience).failure({
                metadata: {
                    error: error === null || error === void 0 ? void 0 : error.message,
                    statusCode: error === null || error === void 0 ? void 0 : error.status
                }
            }).then((0, $1We2B.noop)).catch((0, $1We2B.noop));
            //TODO: Add helpCenterMappingStatus
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'fetch_failed',
                actionSubject: 'project',
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                errorStatus: error === null || error === void 0 ? void 0 : error.status
            }).fire();
        }
    };
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Bfdg.default), {
            header: formatMessage((0, $9hPIF.default).errorTitle),
            description: formatMessage((0, $9hPIF.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3ZeMI)))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $i3cng.default), {
        featureName: "Helpcenter manage projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: (0, $8rTkC.ScreenName).MANAGE_PROJECTS,
        id: 'help-center-manage-projects',
        renderError: renderError,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2nHpE.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($c688147e6741e869$var$HelpCenterManageProjectsComponent, null))));
};
const $c688147e6741e869$var$searchInputStyles = (0, $37U6z.xcss)({
    width: '288px',
    marginRight: 'space.200'
});
const $c688147e6741e869$var$dropdownContainerStyles = (0, $37U6z.xcss)({
    zIndex: 'modal'
});

});
parcelRegister("7j8cd", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b9d59c0a810d3a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9bbb1cf10a2fb5627a3ff9a65f2d9ed>>
 * @relayHash bc210f0fbe988c79fde091a561d08224
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73e7bc2ccf5a80141d9d3113455fc6fcace13f1d53f66dc1b16481d93dc29392
const $7b9d59c0a810d3a1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterMappingStatus"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "helpCenterARI",
                    "variableName": "helpCenterARI"
                },
                {
                    "kind": "Variable",
                    "name": "helpCenterId",
                    "variableName": "helpCenterId"
                },
                {
                    "kind": "Variable",
                    "name": "helpCenterMappingStatus",
                    "variableName": "helpCenterMappingStatus"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        }
    ], v6 = [
        v4 /*: any*/ 
    ], v7 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterARI"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "slug"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "manageProjects_GetProjectsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraProjectsMappedToHelpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectsListFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "syncProjectsToggleFragment"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsBreadcrumbsFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "manageProjects_GetProjectsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraProjectsMappedToHelpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "small"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterProjectMappingData",
                                            "kind": "LinkedField",
                                            "name": "projectMappingData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "syncNewProjects"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v11 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "73e7bc2ccf5a80141d9d3113455fc6fcace13f1d53f66dc1b16481d93dc29392",
            "metadata": {},
            "name": "manageProjects_GetProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7b9d59c0a810d3a1$var$node.hash = "c194eb4ffd8c3c2e4203bc59d85fc9eb";
var $7b9d59c0a810d3a1$export$2e2bcd8739ae039 = $7b9d59c0a810d3a1$var$node;

});

parcelRegister("4RQBu", function(module, exports) {
$parcel$export(module.exports, "DropdownItem", () => $420092f07ef414d7$export$6648d5fa18559e7f);

var $5yo3H = parcelRequire("5yo3H");
var $eS4yu = parcelRequire("eS4yu");
var $k7ZVu = parcelRequire("k7ZVu");

var $jfwik = parcelRequire("jfwik");
const $420092f07ef414d7$export$6648d5fa18559e7f = (0, $eS4yu.default)({
    componentName: 'dropdownItem'
})((0, $k7ZVu.default)({
    onClick: (0, $5yo3H.default)('atlaskit')({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    })
})((0, $jfwik.default)));

});

parcelRegister("2xFxw", function(module, exports) {
$parcel$export(module.exports, "SettingsBreadcrumbs", () => (parcelRequire("gRzNN")).default);

var $gRzNN = parcelRequire("gRzNN");

});
parcelRegister("gRzNN", function(module, exports) {
$parcel$export(module.exports, "default", () => $78b2eab39450810a$export$2e2bcd8739ae039);

var $9SkcL = parcelRequire("9SkcL");

var $8P7DW = parcelRequire("8P7DW");

var $6RJZN = parcelRequire("6RJZN");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");

var $iycTY = parcelRequire("iycTY");

var $6Hfjm = parcelRequire("6Hfjm");

var $Jhmxx = parcelRequire("Jhmxx");

var $1cmFi = parcelRequire("1cmFi");
const $78b2eab39450810a$var$SettingsBreadcrumbs = ({ helpCenterData: helpCenterData })=>{
    var _data$name;
    const data = (0, $h3cOB.useFragment)((0, $9SkcL.default), helpCenterData);
    const helpCenterName = (data === null || data === void 0 || (_data$name = data.name) === null || _data$name === void 0 ? void 0 : _data$name.default) || '';
    const slug = data === null || data === void 0 ? void 0 : data.slug;
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const helpCenterMessages = (0, $Jhmxx.useHelpCenterMessageDictionary)();
    const rootBreadcrumbUrl = '/';
    const getHelpcenterBreadcrumbUrl = ()=>{
        return !slug ? `${window.location.origin}/servicedesk/customer` : `${window.location.origin}/helpcenter/${slug}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iycTY.default), {
        label: formatMessage((0, $1cmFi.default).breadcrumbsLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6RJZN.default), {
        isFirstCrumb: true,
        to: rootBreadcrumbUrl,
        name: formatMessage(helpCenterMessages.breadcrumbRoot),
        actionSubjectId: "helpCenterBreadcrumb",
        disableTheme: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6RJZN.default), {
        to: getHelpcenterBreadcrumbUrl(),
        name: helpCenterName,
        actionSubjectId: "helpDeskBreadcrumb",
        disableTheme: true
    }))));
};
var $78b2eab39450810a$export$2e2bcd8739ae039 = $78b2eab39450810a$var$SettingsBreadcrumbs;

});
parcelRegister("9SkcL", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd74a0a0b6ae502a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<553225e318a7f73ecb4c740a07c17569>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dd74a0a0b6ae502a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "settingsBreadcrumbsFragment",
    "selections": [
        {
            "concreteType": "HelpCenterName",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "default"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "slug"
        }
    ],
    "type": "HelpCenter"
};
$dd74a0a0b6ae502a$var$node.hash = "0716469cbe624819ae2ea879ee690b4e";
var $dd74a0a0b6ae502a$export$2e2bcd8739ae039 = $dd74a0a0b6ae502a$var$node;

});



parcelRegister("6wbA7", function(module, exports) {
$parcel$export(module.exports, "manageProjectsExperience", () => $229b35f24c3b72ac$export$500b6e6c6f0e66cd);

var $lQb0x = parcelRequire("lQb0x");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $229b35f24c3b72ac$export$500b6e6c6f0e66cd = new (0, $ghwxF.UFOExperience)((0, $lQb0x.manageProjectsExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("cTUuW", function(module, exports) {
$parcel$export(module.exports, "ManageProjectsLayoutSkeleton", () => (parcelRequire("2nHpE")).default);

var $2nHpE = parcelRequire("2nHpE");

});
parcelRegister("2nHpE", function(module, exports) {
$parcel$export(module.exports, "default", () => $5358f1bd44c74a74$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $iSvee = parcelRequire("iSvee");

var $3Snuc = parcelRequire("3Snuc");

var $6Hfjm = parcelRequire("6Hfjm");
var $dqsXi = parcelRequire("dqsXi");
var $2IKBM = parcelRequire("2IKBM");
var $37U6z = parcelRequire("37U6z");

var $aJI9b = parcelRequire("aJI9b");
const $5358f1bd44c74a74$var$ManageProjectsLayoutSkeleton = ()=>{
    const head = {
        cells: [
            {
                content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                    width: "12px",
                    height: "12px"
                }),
                width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH)['select-all']
            },
            {
                content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH)['project-name']
            },
            {
                content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH)['lead-name']
            },
            {
                content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH).status
            },
            {
                content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH)['action-button']
            }
        ]
    };
    const rows = Array.from({
        length: 10
    }).map((_, index)=>({
            key: `${index}`,
            cells: [
                {
                    content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "12px",
                        height: "12px"
                    })
                },
                {
                    content: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
                        gap: "space.100",
                        alignItems: "center"
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "24px",
                        height: "24px"
                    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    })))
                },
                {
                    content: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
                        gap: "space.100",
                        alignItems: "center"
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "24px",
                        height: "24px",
                        isCircle: true
                    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    })))
                },
                {
                    key: 'select-all-skeleton',
                    content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "28%",
                        height: "16px"
                    })
                },
                {
                    content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "30%",
                        height: "20px"
                    })
                }
            ]
        }));
    return /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.300"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.300"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "84px",
        height: "24px"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-project-title-skeleton"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.050"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "100%",
        height: "20px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "50%",
        height: "20px"
    })), /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        direction: "row",
        gap: "space.075"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "270px",
        height: "16px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "32px",
        height: "16px",
        "data-testid": "toggle-new-projects-layout-skeleton"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        direction: "row",
        gap: "space.075"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "25%",
        height: "32px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "20%",
        height: "32px"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        xcss: $5358f1bd44c74a74$var$tableSkeletonStyles
    }, /*#__PURE__*/ $8P7DW.createElement((0, $3Snuc.default), {
        head: head,
        rows: rows,
        isFixedSize: true,
        isRankingDisabled: true,
        highlightedRowIndex: 11
    })));
};
const $5358f1bd44c74a74$var$tableSkeletonStyles = (0, $37U6z.xcss)({
    pointerEvents: 'none'
});
var $5358f1bd44c74a74$export$2e2bcd8739ae039 = $5358f1bd44c74a74$var$ManageProjectsLayoutSkeleton;

});
parcelRegister("3Snuc", function(module, exports) {
$parcel$export(module.exports, "default", () => $555f151c5429a89c$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $5J6r2 = parcelRequire("5J6r2");

var $iwbri = parcelRequire("iwbri");

var $kfdG2 = parcelRequire("kfdG2");
class $555f151c5429a89c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    static #_ = this.defaultProps = {
        defaultPage: 1,
        isLoading: false,
        isFixedSize: false,
        isRankable: false,
        onSetPage: (0, $5J6r2.default),
        onSort: (0, $5J6r2.default),
        rowsPerPage: Infinity
    };
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $kfdG2.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $iwbri.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("iwbri", function(module, exports) {
$parcel$export(module.exports, "reorderRows", () => $3d86e6f91d4c749d$export$c476bbe5da59992d);

var $1DMw1 = parcelRequire("1DMw1");
const $3d86e6f91d4c749d$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = (0, $1DMw1.computeIndex)(sourceIndex, page, rowsPerPage);
    const toIndex = (0, $1DMw1.computeIndex)(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});
parcelRegister("1DMw1", function(module, exports) {
$parcel$export(module.exports, "computeIndex", () => $19e817519977c0ba$export$92bcb1ed38b134a1);
const $19e817519977c0ba$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};

});


parcelRegister("kfdG2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f218c9102327586$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $aeYmt = parcelRequire("aeYmt");

var $5J6r2 = parcelRequire("5J6r2");

var $8tY8w = parcelRequire("8tY8w");

var $8emxr = parcelRequire("8emxr");

var $ar7u1 = parcelRequire("ar7u1");

var $jvL9Q = parcelRequire("jvL9Q");

var $7tltO = parcelRequire("7tltO");

var $7HcjG = parcelRequire("7HcjG");

var $fpjbm = parcelRequire("fpjbm");

var $sZ8Rg = parcelRequire("sZ8Rg");

var $4wDhD = parcelRequire("4wDhD");

var $5ly99 = parcelRequire("5ly99");

var $b9UCW = parcelRequire("b9UCW");

var $cHAFF = parcelRequire("cHAFF");

var $1a88V = parcelRequire("1a88V");

var $cBbwE = parcelRequire("cBbwE");

var $3SImD = parcelRequire("3SImD");
function $8f218c9102327586$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $8emxr.DESC:
            return 0, $8emxr.ASC;
        case 0, $8emxr.ASC:
            return 0, $8emxr.DESC;
        default:
            return currentSortOrder;
    }
}
const $8f218c9102327586$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $5J6r2.default), onSort: providedOnSort = (0, $5J6r2.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $5J6r2.default), onRankEnd: providedOnRankEnd = (0, $5J6r2.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $8P7DW.useState)(false);
    const tableBodyRef = (0, $8P7DW.useRef)(null);
    const onSort = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: undefined,
        packageVersion: undefined
    });
    const onRankEnd = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: undefined,
        packageVersion: undefined
    });
    (0, $8P7DW.useEffect)(()=>{
        (0, $jvL9Q.validateSortKey)(sortKey, head);
        (0, $8tY8w.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $8emxr.DESC)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $8emxr.ASC) : $8f218c9102327586$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $ar7u1.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $8emxr.LARGE) : (0, $8emxr.SMALL);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fpjbm.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7HcjG.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $1a88V.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $4wDhD.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7tltO.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3SImD.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $gWgPx.jsx)($8f218c9102327586$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $sZ8Rg.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cBbwE.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cHAFF.default), {
                isLoading: isLoading,
                spinnerSize: (0, $8emxr.LARGE),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $8f218c9102327586$var$RankableTableBody = /*#__PURE__*/ (0, $8P7DW.lazy)(()=>(parcelRequire("46D2f")));
const $8f218c9102327586$var$TableBody = /*#__PURE__*/ (0, $8P7DW.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $8P7DW.useState)(false);
    (0, $8P7DW.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $5ly99.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $b9UCW.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $8P7DW.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)($8f218c9102327586$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8f218c9102327586$export$2e2bcd8739ae039 = $8f218c9102327586$var$DynamicTable;

});
parcelRegister("8tY8w", function(module, exports) {
$parcel$export(module.exports, "assertIsSortable", () => $7dee7475ec7b7473$export$5eb35a4771ec4090);
const $7dee7475ec7b7473$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};

});

parcelRegister("8emxr", function(module, exports) {
$parcel$export(module.exports, "ASC", () => $1860c1d1b5a539b8$export$1dee026a19752d6b);
$parcel$export(module.exports, "DESC", () => $1860c1d1b5a539b8$export$b6abcf7fa1d94f65);
$parcel$export(module.exports, "SMALL", () => $1860c1d1b5a539b8$export$71dd4c8ecd45e95f);
$parcel$export(module.exports, "LARGE", () => $1860c1d1b5a539b8$export$7b93a10c0fefe3e3);
$parcel$export(module.exports, "LOADING_CONTENTS_OPACITY", () => $1860c1d1b5a539b8$export$3843c586a90b9cbf);
const $1860c1d1b5a539b8$export$1dee026a19752d6b = 'ASC';
const $1860c1d1b5a539b8$export$b6abcf7fa1d94f65 = 'DESC';
const $1860c1d1b5a539b8$export$71dd4c8ecd45e95f = 'small';
const $1860c1d1b5a539b8$export$7b93a10c0fefe3e3 = 'large';
const $1860c1d1b5a539b8$export$3843c586a90b9cbf = 0.22;

});

parcelRegister("ar7u1", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $09b46f2cf8ec01e7$export$3987dc24b734dcab);
const $09b46f2cf8ec01e7$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};

});

parcelRegister("jvL9Q", function(module, exports) {
$parcel$export(module.exports, "validateSortKey", () => $c905a5966c6140ac$export$9133f5a8bfe8a200);
const $c905a5966c6140ac$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

});

parcelRegister("7tltO", function(module, exports) {
$parcel$export(module.exports, "Caption", () => $f7ec6961de69816d$export$32fbfacc5d962e0c);
/* caption.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $f7ec6961de69816d$var$captionStyles = null;
const $f7ec6961de69816d$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $gWgPx.jsx)("caption", {
        className: (0, $8n1kL.default)([
            "_11c81af2 _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });

});

parcelRegister("7HcjG", function(module, exports) {
$parcel$export(module.exports, "EmptyViewContainer", () => $5c98b43a7afad876$export$381ea436de119582);
/* empty-view-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $5c98b43a7afad876$var$emptyViewContainerStyles = null;
const $5c98b43a7afad876$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $8n1kL.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("fpjbm", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $b41c98257189b60f$export$8f45b9407d4090d7);
/* empty-view-with-fixed-height.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $b41c98257189b60f$var$fixedHeightStyles = null;
const $b41c98257189b60f$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $8n1kL.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });

});

parcelRegister("sZ8Rg", function(module, exports) {
$parcel$export(module.exports, "PaginationWrapper", () => $6c1161fecefa56e9$export$3e5e12dc01f20a43);
/* pagination-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $6c1161fecefa56e9$var$paginationWrapperStyles = null;
const $6c1161fecefa56e9$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $8n1kL.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("4wDhD", function(module, exports) {
$parcel$export(module.exports, "Table", () => $a92520b9eda09625$export$54ec01a60f47d33d);
/* table.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $a92520b9eda09625$var$fixedSizeTableStyles = null;
const $a92520b9eda09625$var$tableStyles = null;
const $a92520b9eda09625$var$bodyBorder = null;
const $a92520b9eda09625$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $8n1kL.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect4ttxp",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ]),
        children: children
    });
});

});

parcelRegister("5ly99", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3fd6f3a62eec70f$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $kc8e1 = parcelRequire("kc8e1");

var $gIZ6S = parcelRequire("gIZ6S");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $a3fd6f3a62eec70f$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $gWgPx.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $gIZ6S.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $a3fd6f3a62eec70f$var$Body = (0, $kc8e1.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)($a3fd6f3a62eec70f$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3fd6f3a62eec70f$export$2e2bcd8739ae039 = $a3fd6f3a62eec70f$var$Body;

});
parcelRegister("kc8e1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6df1b8ad37a9f29$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8emxr = parcelRequire("8emxr");

var $ar7u1 = parcelRequire("ar7u1");

var $jvL9Q = parcelRequire("jvL9Q");
const $e6df1b8ad37a9f29$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
const $e6df1b8ad37a9f29$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $8emxr.ASC) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $e6df1b8ad37a9f29$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $e6df1b8ad37a9f29$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $e6df1b8ad37a9f29$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $jvL9Q.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $e6df1b8ad37a9f29$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $ar7u1.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $gWgPx.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $gWgPx.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("gIZ6S", function(module, exports) {
$parcel$export(module.exports, "default", () => $2644494a328ef600$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $74hEu = parcelRequire("74hEu");

var $fRHsn = parcelRequire("fRHsn");
const $2644494a328ef600$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fRHsn.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $8P7DW.createElement)((0, $74hEu.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2644494a328ef600$export$2e2bcd8739ae039 = $2644494a328ef600$var$Row;

});
parcelRegister("74hEu", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $96328c052c13ced3$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $jef8R = parcelRequire("jef8R");
const $96328c052c13ced3$var$fixedSizeTruncateStyles = null;
const $96328c052c13ced3$var$overflowTruncateStyles = null;
const $96328c052c13ced3$var$truncationWidthStyles = null;
const $96328c052c13ced3$var$cellStyles = null;
const $96328c052c13ced3$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $gWgPx.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $jef8R.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8n1kL.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("jef8R", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $0396e2356796a182$export$5e6497a652ae30b5);
const $0396e2356796a182$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $0396e2356796a182$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$0396e2356796a182$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("fRHsn", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $c98f6e3689cc0274$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $c98f6e3689cc0274$var$rowStyles = null;
const $c98f6e3689cc0274$var$rowBackgroundStyles = null;
const $c98f6e3689cc0274$var$rowHighlightedBackgroundStyles = null;
const $c98f6e3689cc0274$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("tr", {
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $8n1kL.default)([
            "_bfhksm61 _1ygbdfik _1ah312gs",
            isHighlighted ? "_bfhk15s3 _irr3ufnl" : "_irr31dpa",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("b9UCW", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $87c9dc1c51b3d6f9$export$e926676385687eaf);

var $8P7DW = parcelRequire("8P7DW");
class $87c9dc1c51b3d6f9$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("cHAFF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a2118062b56b5c7$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $cjn3r = parcelRequire("cjn3r");

var $8emxr = parcelRequire("8emxr");

var $8cgBH = parcelRequire("8cgBH");

var $c1ZXn = parcelRequire("c1ZXn");

var $c7L4e = parcelRequire("c7L4e");
class $2a2118062b56b5c7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    static #_ = this.defaultProps = {
        isLoading: true,
        spinnerSize: (0, $8emxr.LARGE),
        contentsOpacity: (0, $8emxr.LOADING_CONTENTS_OPACITY),
        loadingLabel: 'Loading table'
    };
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $8cgBH.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $c1ZXn.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $c7L4e.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("8cgBH", function(module, exports) {
$parcel$export(module.exports, "Container", () => $2daf0867f3a2e4ee$export$42a852a2b6b56249);
/* container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $2daf0867f3a2e4ee$var$containerStyles = null;
const $2daf0867f3a2e4ee$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $8n1kL.default)([
            "_kqswh2mm"
        ]),
        children: children
    });

});

parcelRegister("c1ZXn", function(module, exports) {
$parcel$export(module.exports, "ContentsContainer", () => $bf30b31e800b5ac1$export$67c29eae8ae2137a);
/* contents-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $bf30b31e800b5ac1$var$CSS_VAR_CONTENTS_OPACITY = '--contents-opacity';
const $bf30b31e800b5ac1$var$contentsContainerStyles = null;
const $bf30b31e800b5ac1$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        style: {
            [$bf30b31e800b5ac1$var$CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $8n1kL.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });

});

parcelRegister("c7L4e", function(module, exports) {
$parcel$export(module.exports, "SpinnerContainer", () => $83330b89cd213da9$export$a5e06607a5ac6158);
/* spinner-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $83330b89cd213da9$var$spinnerContainerStyles = null;
const $83330b89cd213da9$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $8n1kL.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("1a88V", function(module, exports) {
$parcel$export(module.exports, "default", () => $381019d8de99c7dc$export$2e2bcd8739ae039);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $cjn3r = parcelRequire("cjn3r");

var $8emxr = parcelRequire("8emxr");
const $381019d8de99c7dc$var$containerStyles = null;
const $381019d8de99c7dc$var$Container = /*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $8n1kL.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $381019d8de99c7dc$var$spinnerBackdropStyles = null;
const $381019d8de99c7dc$var$SpinnerBackdrop = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $8n1kL.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $381019d8de99c7dc$var$spinnerContainerStyles = null;
const $381019d8de99c7dc$var$SpinnerContainer = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
        ref: ref,
        className: (0, $8n1kL.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));
class $381019d8de99c7dc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    static #_ = this.defaultProps = {
        isLoading: true,
        spinnerSize: (0, $8emxr.LARGE),
        contentsOpacity: "var(--ds-opacity-loading, 0.2)",
        loadingLabel: 'Loading table'
    };
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        var _this$spinnerRef, _this$containerRef;
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gWgPx.jsxs)($381019d8de99c7dc$var$Container, {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gWgPx.jsx)($381019d8de99c7dc$var$SpinnerBackdrop, {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gWgPx.jsx)($381019d8de99c7dc$var$SpinnerContainer, {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});

parcelRegister("cBbwE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b5651d11d15d82c$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $3JF18 = parcelRequire("3JF18");
class $6b5651d11d15d82c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3JF18.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
            nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
            previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
            pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("3JF18", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f40053a2eef79b6$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $aeYmt = parcelRequire("aeYmt");

var $5J6r2 = parcelRequire("5J6r2");

var $aCOCE = parcelRequire("aCOCE");

var $1LUbp = parcelRequire("1LUbp");

var $gKlvt = parcelRequire("gKlvt");

var $2CGHX = parcelRequire("2CGHX");
var $iPrfN = parcelRequire("iPrfN");

var $km8jz = parcelRequire("km8jz");

var $ehnlh = parcelRequire("ehnlh");

var $aiBpb = parcelRequire("aiBpb");

var $lO37w = parcelRequire("lO37w");

var $4nopn = parcelRequire("4nopn");
const $5f40053a2eef79b6$var$styles = {
    paginationMenu: "_1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t",
    paginationMenuItem: "_1pfhze3t _ect4ttxp",
    navigatorIconWrapper: "_18zr12x7"
};
const $5f40053a2eef79b6$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: undefined,
    packageVersion: undefined
};
function $5f40053a2eef79b6$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($1LUbp))) : (0, (/*@__PURE__*/$parcel$interopDefault($gKlvt)));
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        as: "span",
        xcss: $5f40053a2eef79b6$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)(Chevron, {
            label: "",
            color: "currentColor",
            size: "small"
        })
    });
}
function $5f40053a2eef79b6$var$InnerPagination({ components: components = (0, $lO37w.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $lO37w.emptyObject), max: max = 7, onChange: onChange = (0, $5J6r2.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $aiBpb.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $aCOCE.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$5f40053a2eef79b6$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iPrfN.default), {
            as: "li",
            xcss: $5f40053a2eef79b6$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ehnlh.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iPrfN.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $km8jz.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gWgPx.jsx)($5f40053a2eef79b6$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iPrfN.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $5f40053a2eef79b6$var$styles.paginationMenu,
                    children: (0, $4nopn.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $km8jz.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gWgPx.jsx)($5f40053a2eef79b6$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $5f40053a2eef79b6$var$Pagination = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)($5f40053a2eef79b6$var$InnerPagination));
var $5f40053a2eef79b6$export$2e2bcd8739ae039 = $5f40053a2eef79b6$var$Pagination;

});
parcelRegister("1LUbp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14a5c305d1d8a673$var$_react = $14a5c305d1d8a673$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $14a5c305d1d8a673$var$_baseNew = $14a5c305d1d8a673$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $14a5c305d1d8a673$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14a5c305d1d8a673$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $14a5c305d1d8a673$var$_react.default.createElement($14a5c305d1d8a673$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$14a5c305d1d8a673$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $14a5c305d1d8a673$var$_default = module.exports.default = $14a5c305d1d8a673$var$ChevronLeftIcon;

});

parcelRegister("km8jz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8212c8e329bf2427$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $ifRQf = parcelRequire("ifRQf");
function $8212c8e329bf2427$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("ehnlh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d015b33b10dddc54$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $ifRQf = parcelRequire("ifRQf");
function $d015b33b10dddc54$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("aiBpb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab290dda6ec3b3e1$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $2CGHX = parcelRequire("2CGHX");
var $9pb7J = parcelRequire("9pb7J");

var $dojiU = parcelRequire("dojiU");
const $ab290dda6ec3b3e1$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $ab290dda6ec3b3e1$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        as: "li",
        testId: testId,
        xcss: $ab290dda6ec3b3e1$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $9pb7J.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $dojiU.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("lO37w", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $503e2dce40690f3d$export$3f860eba1218f8d3);
const $503e2dce40690f3d$export$3f860eba1218f8d3 = {};

});

parcelRegister("4nopn", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7201bdef94a3697$export$2e2bcd8739ae039);

var $hXXvg = parcelRequire("hXXvg");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $f7201bdef94a3697$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $hXXvg.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $f7201bdef94a3697$export$2e2bcd8739ae039 = $f7201bdef94a3697$var$collapseRange;

});



parcelRegister("3SImD", function(module, exports) {
$parcel$export(module.exports, "default", () => $35268c3bd7abc1a7$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $jvL9Q = parcelRequire("jvL9Q");

var $cCfDC = parcelRequire("cCfDC");

var $9lAC1 = parcelRequire("9lAC1");

var $bFOEC = parcelRequire("bFOEC");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $35268c3bd7abc1a7$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $jvL9Q.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $jvL9Q.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $9lAC1.default) : (0, $bFOEC.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cCfDC.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $gWgPx.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $gWgPx.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35268c3bd7abc1a7$export$2e2bcd8739ae039 = $35268c3bd7abc1a7$var$TableHead;

});
parcelRegister("cCfDC", function(module, exports) {
$parcel$export(module.exports, "Head", () => $0b5ee8551e35b4ff$export$e93312b7773dfcac);
/* head.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
const $0b5ee8551e35b4ff$var$rankingStyles = null;
const $0b5ee8551e35b4ff$var$headStyles = null;
const $0b5ee8551e35b4ff$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $8n1kL.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};

});

parcelRegister("9lAC1", function(module, exports) {
$parcel$export(module.exports, "default", () => $25564473463db860$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $3INeK = parcelRequire("3INeK");

var $cblD9 = parcelRequire("cblD9");

var $bFOEC = parcelRequire("bFOEC");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $25564473463db860$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $cblD9.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $bFOEC.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $25564473463db860$var$RankableTableHeadCell = (0, $3INeK.default)($25564473463db860$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$25564473463db860$export$2e2bcd8739ae039 = $25564473463db860$var$RankableTableHeadCell;

});
parcelRegister("3INeK", function(module, exports) {
$parcel$export(module.exports, "default", () => $989510b79f8d10ed$export$2e2bcd8739ae039);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");
function $989510b79f8d10ed$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $gWgPx.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("cblD9", function(module, exports) {
$parcel$export(module.exports, "inlineStylesIfRanking", () => $92cb450b481d427d$export$a601f1775e10043f);
const $92cb450b481d427d$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};

});

parcelRegister("bFOEC", function(module, exports) {
$parcel$export(module.exports, "default", () => $73a693486db2f107$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/design-system/no-physical-properties */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $80ia8 = parcelRequire("80ia8");

var $aWhlb = parcelRequire("aWhlb");

var $2CGHX = parcelRequire("2CGHX");
var $3iEm8 = parcelRequire("3iEm8");
var $bgvtM = parcelRequire("bgvtM");

var $ea6bZ = parcelRequire("ea6bZ");

var $8emxr = parcelRequire("8emxr");

var $gFyhz = parcelRequire("gFyhz");
const $73a693486db2f107$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $73a693486db2f107$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c8wadc _syazazsu _k48pwu06"
};
const $73a693486db2f107$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $8P7DW.useState)(false);
    const [isFocused, setIsFocused] = (0, $8P7DW.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $8P7DW.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $8P7DW.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $8P7DW.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $8P7DW.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        xcss: $73a693486db2f107$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ea6bZ.default), {
            content: sortOrder === (0, $8emxr.ASC) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $bgvtM.default), {
                onClick: onClick,
                xcss: $73a693486db2f107$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3iEm8.default), {
                        xcss: isVisibleIconOnlyHeader ? $73a693486db2f107$var$styles.hideIconHeaderWrapper : $73a693486db2f107$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                            className: (0, $8n1kL.default)([
                                $73a693486db2f107$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $3iEm8.default), {
                        xcss: isSortIconVisible ? $73a693486db2f107$var$styles.sortIconVisibleWrapper : $73a693486db2f107$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $8emxr.ASC) ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aWhlb))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80ia8))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gFyhz.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$73a693486db2f107$export$2e2bcd8739ae039 = $73a693486db2f107$var$TableHeadCell;

});
parcelRegister("80ia8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d3c698275909dac$var$_react = $5d3c698275909dac$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $5d3c698275909dac$var$_baseNew = $5d3c698275909dac$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $5d3c698275909dac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d3c698275909dac$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $5d3c698275909dac$var$_react.default.createElement($5d3c698275909dac$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$5d3c698275909dac$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $5d3c698275909dac$var$_default = module.exports.default = $5d3c698275909dac$var$ArrowDownIcon;

});

parcelRegister("aWhlb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f6cc5a26c56c1c2$var$_react = $7f6cc5a26c56c1c2$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $7f6cc5a26c56c1c2$var$_baseNew = $7f6cc5a26c56c1c2$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $7f6cc5a26c56c1c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f6cc5a26c56c1c2$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7f6cc5a26c56c1c2$var$_react.default.createElement($7f6cc5a26c56c1c2$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7f6cc5a26c56c1c2$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7f6cc5a26c56c1c2$var$_default = module.exports.default = $7f6cc5a26c56c1c2$var$ArrowUpIcon;

});

parcelRegister("gFyhz", function(module, exports) {
$parcel$export(module.exports, "HeadCell", () => $4de87cb2e37090bf$export$4e8024263ace498b);
/* head-cell.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");

var $8emxr = parcelRequire("8emxr");

var $jef8R = parcelRequire("jef8R");
const $4de87cb2e37090bf$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $4de87cb2e37090bf$var$overflowTruncateStyles = null;
const $4de87cb2e37090bf$var$truncationWidthStyles = null;
const $4de87cb2e37090bf$var$fixedSizeTruncateStyles = null;
const $4de87cb2e37090bf$var$cellStyles = null;
const $4de87cb2e37090bf$var$headCellBaseStyles = null;
const $4de87cb2e37090bf$export$4e8024263ace498b = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $jef8R.getTruncationStyleVars)({
            width: width
        }),
        [$4de87cb2e37090bf$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === (0, $8emxr.ASC);
    const isDESC = sortOrder === (0, $8emxr.DESC);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $gWgPx.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $8n1kL.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8wadc _179r1uh4 _mqm2glyw _kqswh2mm _syazazsu _k48pwu06 _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});




parcelRegister("46D2f", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("gR3jJ"),
    $j9MRt("cDUzg"),
    $j9MRt("vNTMf")
]).then(()=>parcelRequire('anZ2A'));

});





parcelRegister("9hPIF", function(module, exports) {
$parcel$export(module.exports, "default", () => $12bf2d276fb859a1$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $12bf2d276fb859a1$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    manageProjectsPageTitle: {
        defaultMessage: 'Projects',
        description: 'Help center manage projects page title',
        id: 'manage.projects.page.title'
    },
    manageProjectsPageTitleGalaxia: {
        defaultMessage: 'Spaces',
        description: 'Help center manage spaces page title',
        id: 'manage.projects.page.title-galaxia'
    },
    manageProjectsPageDescription: {
        defaultMessage: 'Manage your help content effectively by linking projects to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking projects to a help center</link>',
        description: 'Help center manage projects page description',
        id: 'manage.projects.page.description'
    },
    manageProjectsPageDescriptionHelpHub: {
        defaultMessage: 'Manage spaces linked to your help hub to organize help content and show customers only relevant resources.',
        description: 'Help hub manage spaces page description',
        id: 'manage.projects.page.description.helphub'
    },
    manageProjectsPageDescriptionGalaxia: {
        defaultMessage: 'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.description-galaxia'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    manageProjectsPageDescriptionForDefaultHC: {
        defaultMessage: 'All the projects in your site are always linked to your default help center, the resources will always be available in help center portal sections, virtual service agent, search and recently used request forms. <link>Learn more about projects in help centers</link>',
        description: 'Help center manage projects page description',
        id: 'manage.projects.page.default.hc.description'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    manageProjectsPageDescriptionForDefaultHCGalaxia: {
        defaultMessage: 'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.default.hc.description-galaxia'
    },
    manageProjectPageToggleForDefaultLinking: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default linking',
        id: 'manage.projects.page.toggle.default.linking'
    },
    manageProjectPageToggleForDefaultLinkingHelpHub: {
        defaultMessage: 'Link all new projects to this help hub',
        description: 'Toggle label for default linking for help hub',
        id: 'manage.projects.page.toggle.default.linking.helphub'
    },
    manageProjectPageToggleForDefaultLinkingGalaxiaHelpHub: {
        defaultMessage: 'Link all new spaces to this help hub',
        description: 'Toggle label for default linking for help hub with Galaxia renaming',
        id: 'manage.projects.page.toggle.default.linking.galaxia.helphub'
    },
    manageProjectPageToggleForDefaultLinkingGalaxia: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default linking',
        id: 'manage.projects.page.toggle.default.linking-galaxia'
    },
    linkedFilterLabel: {
        defaultMessage: 'Linked projects',
        description: 'Label for linked dropdown item',
        id: 'manage.projects.page.linked.dropdown.item.label'
    },
    linkedFilterLabelGalaxia: {
        defaultMessage: 'Linked spaces',
        description: 'Label for linked dropdown item',
        id: 'manage.projects.page.linked.dropdown.item.label-galaxia'
    },
    unlinkedFilterLabel: {
        defaultMessage: 'Unlinked projects',
        description: 'Label for unlinked dropdown item',
        id: 'manage.projects.page.unlinked.dropdown.item.label'
    },
    unlinkedFilterLabelGalaxia: {
        defaultMessage: 'Unlinked spaces',
        description: 'Label for unlinked dropdown item',
        id: 'manage.projects.page.unlinked.dropdown.item.label-galaxia'
    },
    searchProjectsPlaceholder: {
        defaultMessage: 'Search for projects',
        description: 'Placeholder for search projects input',
        id: 'manage.projects.page.search.placeholder'
    },
    searchProjectsPlaceholderGalaxia: {
        defaultMessage: 'Search for spaces',
        description: 'Placeholder for search spaces input',
        id: 'manage.projects.page.search.placeholder-galaxia'
    },
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title',
        id: 'manage.projects.page.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error description',
        id: 'manage.projects.page.error.description'
    }
});

});

parcelRegister("91Eu3", function(module, exports) {
$parcel$export(module.exports, "ProjectsList", () => (parcelRequire("gqvCg")).default);

var $gqvCg = parcelRequire("gqvCg");

});
parcelRegister("gqvCg", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f2ad8ccd55e8879$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $6p5HB = parcelRequire("6p5HB");

var $ilmHs = parcelRequire("ilmHs");
var $9f2ad8ccd55e8879$export$2e2bcd8739ae039 = (0, $jvoWT.default)(null, {
    showErrorFlag: $6p5HB.showErrorFlag,
    showSuccessFlag: $6p5HB.showSuccessFlag
})((0, $ilmHs.default));

});
parcelRegister("ilmHs", function(module, exports) {
$parcel$export(module.exports, "default", () => $45338295032769f6$export$2e2bcd8739ae039);

var $c4Ck9 = parcelRequire("c4Ck9");

var $8P7DW = parcelRequire("8P7DW");

var $hYIJH = parcelRequire("hYIJH");

var $70g8n = parcelRequire("70g8n");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");
parcelRequire("9wocP");
var $cKYBS = parcelRequire("cKYBS");

var $MmGmU = parcelRequire("MmGmU");

var $hIXV0 = parcelRequire("hIXV0");

var $esBnn = parcelRequire("esBnn");

var $3Snuc = parcelRequire("3Snuc");

var $6Bfdg = parcelRequire("6Bfdg");

var $1EFS8 = parcelRequire("1EFS8");

var $eT7pr = parcelRequire("eT7pr");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $iziiq = parcelRequire("iziiq");

var $klz3F = parcelRequire("klz3F");
parcelRequire("1UNnN");
var $femsi = parcelRequire("femsi");

var $aJI9b = parcelRequire("aJI9b");
parcelRequire("bvAJe");
var $hzyd9 = parcelRequire("hzyd9");

var $31fjU = parcelRequire("31fjU");

var $iJzXX = parcelRequire("iJzXX");

var $krTBL = parcelRequire("krTBL");

var $6OASz = parcelRequire("6OASz");

var $l2LMB = parcelRequire("l2LMB");

var $hf11t = parcelRequire("hf11t");
const $45338295032769f6$export$680c2e5e5eec1385 = 20;
const $45338295032769f6$var$messagesMap = {
    [(0, $iJzXX.ProjectsMappingOperations).LINK]: {
        [(0, $iJzXX.ProjectsMappingMode).BULK]: {
            successTitle: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? (0, $31fjU.default).bulkLinkSuccessTitleGalaxia : (0, $31fjU.default).bulkLinkSuccessTitle,
            errorTitle: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? (0, $31fjU.default).bulkLinkErrorTitleGalaxia : (0, $31fjU.default).bulkLinkErrorTitle
        },
        [(0, $iJzXX.ProjectsMappingMode).SINGLE]: {
            successTitle: (0, $31fjU.default).linkSuccessTitle,
            errorTitle: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? (0, $31fjU.default).linkErrorTitleGalaxia : (0, $31fjU.default).linkErrorTitle
        }
    },
    [(0, $iJzXX.ProjectsMappingOperations).UNLINK]: {
        [(0, $iJzXX.ProjectsMappingMode).BULK]: {
            successTitle: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? (0, $31fjU.default).bulkUnlinkSuccessTitleGalaxia : (0, $31fjU.default).bulkUnlinkSuccessTitle,
            errorTitle: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? (0, $31fjU.default).bulkUnlinkErrorTitleGalaxia : (0, $31fjU.default).bulkUnlinkErrorTitle
        },
        [(0, $iJzXX.ProjectsMappingMode).SINGLE]: {
            successTitle: (0, $31fjU.default).unlinkSuccessTitle,
            errorTitle: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? (0, $31fjU.default).unlinkErrorTitleGalaxia : (0, $31fjU.default).unlinkErrorTitle
        }
    }
};
const $45338295032769f6$var$ProjectsList = ({ projectsListFragmentKey: projectsListFragmentKey, searchQuery: searchQuery, selection: selection, isReadOnlyView: isReadOnlyView, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const [isChecked, setIsChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const [isBulkActionLoading, setIsBulkActionLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const [selectedProjectsMap, setSelectedProjectsMap] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState({});
    const [modalVisibility, setModalVisibility] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState({
        [(0, $aJI9b.CANT_UNLINK_ALL_DIALOG)]: false,
        [(0, $aJI9b.UNLINK_CONFIRMATION_DIALOG)]: false
    });
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const data = (0, $h3cOB.useFragment)((0, $c4Ck9.default), projectsListFragmentKey);
    const { onLinkUnlinkProjects: onLinkUnlinkProjects } = (0, $femsi.useProjectMapping)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const selectedProjectsCount = Object.values(selectedProjectsMap).filter(Boolean).length;
    const disableSingleProjectActions = selectedProjectsCount > 0;
    const projects = data.edges || [];
    const handleProjectMapping = (selectedProjectIds, operationType, mappingStatus)=>{
        const getProjectName = ()=>{
            var _projects$find;
            return (_projects$find = projects.find((project)=>{
                var _project$node;
                return (project === null || project === void 0 || (_project$node = project.node) === null || _project$node === void 0 ? void 0 : _project$node.projectId) === selectedProjectIds[0];
            })) === null || _projects$find === void 0 || (_projects$find = _projects$find.node) === null || _projects$find === void 0 ? void 0 : _projects$find.name;
        };
        const mode = selectedProjectIds.length > 1 ? (0, $iJzXX.ProjectsMappingMode).BULK : (0, $iJzXX.ProjectsMappingMode).SINGLE;
        setIsBulkActionLoading(true);
        onLinkUnlinkProjects(selectedProjectIds, operationType, mappingStatus).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                bulkOperation: true,
                mapStatus: operationType,
                projectCount: selectedProjectIds.length
            }).fire();
            resetBulkSelection();
            showSuccessFlagAction($45338295032769f6$var$messagesMap[operationType][mode].successTitle, mode === (0, $iJzXX.ProjectsMappingMode).SINGLE ? {
                projectName: getProjectName()
            } : {
                number: selectedProjectIds.length
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            showErrorFlagAction($45338295032769f6$var$messagesMap[operationType][mode].errorTitle, (0, $31fjU.default).genericErrorDescription, [], mode === (0, $iJzXX.ProjectsMappingMode).SINGLE ? {
                projectName: getProjectName()
            } : undefined);
            if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: true,
                mapStatus: operationType,
                projectCount: selectedProjectIds.length,
                errorMessage: message,
                errorStatus: status
            }).fire();
        }).finally(()=>{
            setIsBulkActionLoading(false);
            setModalVisibility({
                ...modalVisibility,
                [(0, $aJI9b.UNLINK_CONFIRMATION_DIALOG)]: false
            });
        });
    };
    const onBulkActionClick = ()=>{
        const selectedProjectIds = Object.keys(selectedProjectsMap).filter((projectId)=>selectedProjectsMap[projectId]);
        const operation = selection === (0, $iJzXX.ProjectsMappingStatus).LINKED ? (0, $iJzXX.ProjectsMappingOperations).UNLINK : (0, $iJzXX.ProjectsMappingOperations).LINK;
        if (selectedProjectIds.length === 0) return;
        if (operation === (0, $iJzXX.ProjectsMappingOperations).UNLINK && selectedProjectIds.length === projects.length) {
            setModalVisibility({
                ...modalVisibility,
                [(0, $aJI9b.CANT_UNLINK_ALL_DIALOG)]: true
            });
            return;
        }
        if (operation === (0, $iJzXX.ProjectsMappingOperations).UNLINK) {
            setModalVisibility({
                ...modalVisibility,
                [(0, $aJI9b.UNLINK_CONFIRMATION_DIALOG)]: true
            });
            return;
        }
        handleProjectMapping(selectedProjectIds, (0, $iJzXX.ProjectsMappingOperations).LINK, selection);
    };
    const onUnlinkDialogButtonClick = ()=>{
        const selectedProjectIds = Object.keys(selectedProjectsMap).filter((projectId)=>selectedProjectsMap[projectId]);
        setIsBulkActionLoading(true);
        handleProjectMapping(selectedProjectIds, (0, $iJzXX.ProjectsMappingOperations).UNLINK, selection);
    };
    const isIndeterminate = !!(selectedProjectsCount > 0 && selectedProjectsCount < projects.length);
    const filteredProjects = projects.filter((project)=>{
        var _project$node2;
        return project === null || project === void 0 || (_project$node2 = project.node) === null || _project$node2 === void 0 || (_project$node2 = _project$node2.name) === null || _project$node2 === void 0 ? void 0 : _project$node2.toLowerCase().includes(searchQuery.toLowerCase());
    });
    const resetBulkSelection = ()=>{
        setIsChecked(false);
        setSelectedProjectsMap({});
    };
    // whenever the selection changes, reset the selected projects
    (0, $8P7DW.useEffect)(()=>{
        resetBulkSelection();
    }, [
        selection
    ]);
    (0, $8P7DW.useEffect)(()=>{
        // If all projects are selected one by one, check the select all checkbox
        if (selectedProjectsCount === filteredProjects.length) setIsChecked(true);
        // If all projects are unselected one by one, uncheck the select all checkbox
        if (selectedProjectsCount === 0) setIsChecked(false);
    }, [
        selectedProjectsCount,
        filteredProjects.length
    ]);
    const onChangeHandler = ()=>{
        const selectionMap = {};
        setSelectedProjectsMap(isChecked ? selectionMap : filteredProjects.reduce((acc, project)=>{
            var _project$node3, _project$node4;
            if (!(project !== null && project !== void 0 && (_project$node3 = project.node) !== null && _project$node3 !== void 0 && _project$node3.projectId)) return acc;
            acc[project === null || project === void 0 || (_project$node4 = project.node) === null || _project$node4 === void 0 ? void 0 : _project$node4.projectId] = true;
            return acc;
        }, selectionMap));
        setIsChecked(!isChecked);
    };
    const head = {
        cells: [
            ...isReadOnlyView ? [] : [
                {
                    key: 'select-all',
                    content: // eslint-disable-next-line @atlassian/a11y/role-supports-aria-props -- Disabling existing violation, should be fixed when revisited.
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $esBnn.default), {
                        "aria-checked": isChecked,
                        isChecked: isChecked,
                        isIndeterminate: isIndeterminate,
                        onChange: onChangeHandler,
                        "aria-label": (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6OASz.default).selectAllProjectsCheckboxLabelGalaxia) : formatMessage((0, $6OASz.default).selectAllProjectsCheckboxLabel),
                        name: "select-all-checkbox"
                    }),
                    width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH)['select-all']
                }
            ],
            {
                key: 'project-name',
                content: 'Project',
                shouldTruncate: true,
                isSortable: !isChecked ? true : undefined,
                width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH)['project-name']
            },
            {
                key: 'lead-name',
                content: 'Lead',
                shouldTruncate: true,
                isSortable: !isChecked ? true : undefined,
                width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH)['lead-name']
            },
            ...isReadOnlyView ? [] : [
                {
                    key: 'status',
                    content: 'Status',
                    width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH).status
                },
                {
                    key: 'action-button',
                    content: 'Actions',
                    width: (0, $aJI9b.MANAGE_PROJECT_HEAD_WIDTH)['action-button']
                }
            ]
        ]
    };
    const toggleProjectSelect = (projectId)=>{
        setSelectedProjectsMap((prevState)=>({
                ...prevState,
                [projectId]: !prevState[projectId]
            }));
    };
    const rows = filteredProjects.map((project)=>{
        var _project$node5, _project$node6, _project$node7, _project$node8, _project$node0, _project$node1, _project$node10, _project$node11, _project$node12, _project$node13, _project$node14, _project$node15, _project$node16, _project$node17, _project$node18, _project$node19;
        return {
            key: (project === null || project === void 0 || (_project$node5 = project.node) === null || _project$node5 === void 0 ? void 0 : _project$node5.projectId) || (project === null || project === void 0 || (_project$node6 = project.node) === null || _project$node6 === void 0 ? void 0 : _project$node6.name),
            isHighlighted: selectedProjectsMap[(project === null || project === void 0 || (_project$node7 = project.node) === null || _project$node7 === void 0 ? void 0 : _project$node7.projectId) || ''],
            cells: [
                ...isReadOnlyView ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $esBnn.default), {
                            isChecked: !!selectedProjectsMap[(project === null || project === void 0 || (_project$node8 = project.node) === null || _project$node8 === void 0 ? void 0 : _project$node8.projectId) || ''],
                            onChange: ()=>{
                                var _project$node9;
                                return toggleProjectSelect((project === null || project === void 0 || (_project$node9 = project.node) === null || _project$node9 === void 0 ? void 0 : _project$node9.projectId) || '');
                            },
                            name: "select-checkbox",
                            "aria-label": (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6OASz.default).selectProjectCheckboxLabelGalaxia) : formatMessage((0, $6OASz.default).selectProjectCheckboxLabel)
                        })
                    }
                ],
                {
                    key: project === null || project === void 0 || (_project$node0 = project.node) === null || _project$node0 === void 0 ? void 0 : _project$node0.name,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cKYBS.default), {
                        target: "_blank",
                        href: (project === null || project === void 0 || (_project$node1 = project.node) === null || _project$node1 === void 0 ? void 0 : _project$node1.webUrl) || '#'
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                        paddingBlock: "space.050",
                        paddingInlineEnd: "space.100"
                    }, (project === null || project === void 0 || (_project$node10 = project.node) === null || _project$node10 === void 0 || (_project$node10 = _project$node10.avatar) === null || _project$node10 === void 0 ? void 0 : _project$node10.small) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hIXV0.default), {
                        size: "small",
                        appearance: "square",
                        src: project === null || project === void 0 || (_project$node11 = project.node) === null || _project$node11 === void 0 || (_project$node11 = _project$node11.avatar) === null || _project$node11 === void 0 ? void 0 : _project$node11.small,
                        name: project === null || project === void 0 || (_project$node12 = project.node) === null || _project$node12 === void 0 || (_project$node12 = _project$node12.avatar) === null || _project$node12 === void 0 ? void 0 : _project$node12.small
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, project === null || project === void 0 || (_project$node13 = project.node) === null || _project$node13 === void 0 ? void 0 : _project$node13.name)))
                },
                {
                    key: project === null || project === void 0 || (_project$node14 = project.node) === null || _project$node14 === void 0 || (_project$node14 = _project$node14.lead) === null || _project$node14 === void 0 ? void 0 : _project$node14.name,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
                        paddingInlineEnd: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hIXV0.default), {
                        size: "small",
                        appearance: "circle",
                        src: project === null || project === void 0 || (_project$node15 = project.node) === null || _project$node15 === void 0 || (_project$node15 = _project$node15.lead) === null || _project$node15 === void 0 ? void 0 : _project$node15.picture,
                        name: project === null || project === void 0 || (_project$node16 = project.node) === null || _project$node16 === void 0 || (_project$node16 = _project$node16.lead) === null || _project$node16 === void 0 ? void 0 : _project$node16.picture
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, project === null || project === void 0 || (_project$node17 = project.node) === null || _project$node17 === void 0 || (_project$node17 = _project$node17.lead) === null || _project$node17 === void 0 ? void 0 : _project$node17.name))
                },
                ...isReadOnlyView ? [] : [
                    {
                        content: selection === (0, $iJzXX.ProjectsMappingStatus).LINKED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), {
                            appearance: "success"
                        }, formatMessage((0, $6OASz.default).projectsListLinkedLozengeLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $eT7pr.default), null, formatMessage((0, $6OASz.default).projectsListUnlinkedLozengeLabel))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hzyd9.default), {
                            isDisabled: disableSingleProjectActions,
                            projectId: (project === null || project === void 0 || (_project$node18 = project.node) === null || _project$node18 === void 0 ? void 0 : _project$node18.projectId) || '',
                            projectName: (project === null || project === void 0 || (_project$node19 = project.node) === null || _project$node19 === void 0 ? void 0 : _project$node19.name) || '',
                            selection: selection,
                            isLastProject: projects.length === 1,
                            onLinkUnlinkProjects: onLinkUnlinkProjects
                        })
                    }
                ]
            ]
        };
    });
    // If user searches for a project that doesn't exist
    if (rows.length === 0 && searchQuery.trim() !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Bfdg.default), {
        header: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6OASz.default).projectsListEmptySearchTitleGalaxia) : formatMessage((0, $6OASz.default).projectsListEmptySearchTitle),
        description: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6OASz.default).projectsListEmptySearchDescriptionGalaxia) : formatMessage((0, $6OASz.default).projectsListEmptySearchDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($70g8n)))
    });
    // If no projects are linked to the help center and the user is in the linked tab
    if (rows.length === 0 && selection === (0, $iJzXX.ProjectsMappingStatus).LINKED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Bfdg.default), {
        header: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6OASz.default).noLinkedProjectsTitleGalaxia) : formatMessage((0, $6OASz.default).noLinkedProjectsTitle),
        description: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6OASz.default).noLinkedProjectsDescriptionGalaxia) : formatMessage((0, $6OASz.default).noLinkedProjectsDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hYIJH)))
    });
    // If no projects are linked to the help center and the user is in the unlinked tab
    if (rows.length === 0 && selection === (0, $iJzXX.ProjectsMappingStatus).UNLINKED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Bfdg.default), {
        header: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6OASz.default).noUnlinkedProjectsTitleGalaxia) : formatMessage((0, $6OASz.default).noUnlinkedProjectsTitle),
        description: (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $6OASz.default).noUnlinkedProjectsDescriptionGalaxia) : formatMessage((0, $6OASz.default).noUnlinkedProjectsDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hYIJH)))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $45338295032769f6$var$tableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $krTBL.BulkActionToolbar), {
        selectedProjectsCount: selectedProjectsCount,
        selection: selection,
        onBulkActionClick: onBulkActionClick,
        isLoading: isBulkActionLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3Snuc.default), {
        head: head,
        rows: rows,
        rowsPerPage: $45338295032769f6$export$680c2e5e5eec1385,
        defaultPage: 1,
        isFixedSize: true,
        defaultSortKey: "project-name",
        defaultSortOrder: "ASC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hf11t.UnlinkConfirmationModal), {
        isOpen: modalVisibility[0, $aJI9b.UNLINK_CONFIRMATION_DIALOG],
        onClose: ()=>setModalVisibility({
                ...modalVisibility,
                [(0, $aJI9b.UNLINK_CONFIRMATION_DIALOG)]: false
            }),
        onUnlink: onUnlinkDialogButtonClick,
        isLoading: modalVisibility[0, $aJI9b.UNLINK_CONFIRMATION_DIALOG] && isBulkActionLoading,
        numberOfProjects: selectedProjectsCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $l2LMB.UnlinkAllProjectsWarningModal), {
        isOpen: modalVisibility[0, $aJI9b.CANT_UNLINK_ALL_DIALOG],
        onClose: ()=>setModalVisibility({
                ...modalVisibility,
                [(0, $aJI9b.CANT_UNLINK_ALL_DIALOG)]: false
            })
    }));
};
const $45338295032769f6$var$tableStyles = (0, $37U6z.xcss)({
    position: 'relative',
    // @ts-expect-error @atlaskit/ui-styling-standard/no-nested-selectors
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    th: {
        height: '100%',
        verticalAlign: 'middle'
    },
    marginBottom: 'space.100'
});
var $45338295032769f6$export$2e2bcd8739ae039 = $45338295032769f6$var$ProjectsList;

});
parcelRegister("c4Ck9", function(module, exports) {
$parcel$export(module.exports, "default", () => $54a851716b77b9a3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3bd7e00178917844f7a33fdcaf36e216>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $54a851716b77b9a3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectsListFragment",
        "selections": [
            {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "small"
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "lead",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProjectConnection"
    };
}();
$54a851716b77b9a3$var$node.hash = "3eeb7301918e0096af7f6ae5ad2df33f";
var $54a851716b77b9a3$export$2e2bcd8739ae039 = $54a851716b77b9a3$var$node;

});

parcelRegister("hYIJH", function(module, exports) {
module.exports = new URL("../images/project-mapping-empty.93914303.svg", import.meta.url).toString();

});

parcelRegister("70g8n", function(module, exports) {
module.exports = new URL("../images/project-mapping-search-no-match.507a41ed.svg", import.meta.url).toString();

});

parcelRegister("1UNnN", function(module, exports) {
$parcel$export(module.exports, "useProjectMapping", () => (parcelRequire("femsi")).useProjectMapping);

var $femsi = parcelRequire("femsi");

});
parcelRegister("femsi", function(module, exports) {
$parcel$export(module.exports, "useProjectMapping", () => $65bf7fad3b7fa225$export$79a4e4154c8382d5);

var $7GaBU = parcelRequire("7GaBU");

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $jByYr = parcelRequire("jByYr");

var $h3cOB = parcelRequire("h3cOB");

var $dSz79 = parcelRequire("dSz79");
const $65bf7fad3b7fa225$export$79a4e4154c8382d5 = ()=>{
    const cloudId = (0, $jByYr.getCloudId)();
    const helpCenterAri = (0, $dSz79.useHelpCenterAri)();
    const [linkUnlinkProject] = (0, $h3cOB.useMutation)((0, $7GaBU.default));
    const removeSelectedProjects = (0, $8P7DW.useCallback)((store, selection, projectIds)=>{
        var _root$getLinkedRecord;
        const root = store.getRoot();
        const connection = root === null || root === void 0 || (_root$getLinkedRecord = root.getLinkedRecord('jira')) === null || _root$getLinkedRecord === void 0 ? void 0 : _root$getLinkedRecord.getLinkedRecord('jiraProjectsMappedToHelpCenter', {
            cloudId: (0, $jByYr.getCloudId)(),
            filter: {
                helpCenterId: '',
                helpCenterARI: helpCenterAri,
                helpCenterMappingStatus: selection
            }
        });
        if (connection) {
            const connectionEdges = connection === null || connection === void 0 ? void 0 : connection.getLinkedRecords('edges');
            if (connectionEdges) {
                const newEdges = connectionEdges.filter((edge)=>{
                    var _edge$getLinkedRecord;
                    return !projectIds.includes(edge === null || edge === void 0 || (_edge$getLinkedRecord = edge.getLinkedRecord('node')) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getValue('projectId'));
                });
                connection === null || connection === void 0 || connection.setLinkedRecords(newEdges, 'edges');
            }
        }
        root.invalidateRecord();
    }, [
        helpCenterAri
    ]);
    const onLinkUnlinkProjects = (projectIds, operationType, selection)=>{
        return new Promise((resolve, reject)=>linkUnlinkProject({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri,
                        projectIds: projectIds,
                        operationType: operationType
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter;
                    if (response !== null && response !== void 0 && (_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateProjectMapping) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) removeSelectedProjects(store, selection, projectIds);
                },
                onCompleted: (response)=>{
                    var _response$helpCenter2, _response$helpCenter3, _error$extensions;
                    if ((_response$helpCenter2 = response.helpCenter) !== null && _response$helpCenter2 !== void 0 && (_response$helpCenter2 = _response$helpCenter2.updateProjectMapping) !== null && _response$helpCenter2 !== void 0 && _response$helpCenter2.success) resolve(response);
                    const errors = (_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.updateProjectMapping) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $8rTkC.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>{
                    reject(error);
                }
            }));
    };
    return {
        onLinkUnlinkProjects: onLinkUnlinkProjects
    };
};

});
parcelRegister("7GaBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $25739f9cbf5b2dc6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<05df172d747eabd2d04b5ed2e21f63b9>>
 * @relayHash db52eedba06b2bb692fa79d38cecc6eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a1ad194610b482240ddd6de134b99a55a5501781bc737bc73c504fe19c65f83f
const $25739f9cbf5b2dc6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useProjectMappingLinkUnlinkMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterProjectMappingUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateProjectMapping",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useProjectMappingLinkUnlinkMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterProjectMappingUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateProjectMapping",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a1ad194610b482240ddd6de134b99a55a5501781bc737bc73c504fe19c65f83f",
            "metadata": {},
            "name": "useProjectMappingLinkUnlinkMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$25739f9cbf5b2dc6$var$node.hash = "90453dabffd73b96361b3ab3d4d31c32";
var $25739f9cbf5b2dc6$export$2e2bcd8739ae039 = $25739f9cbf5b2dc6$var$node;

});



parcelRegister("bvAJe", function(module, exports) {
$parcel$export(module.exports, "LinkUnlinkProject", () => (parcelRequire("hzyd9")).default);

var $hzyd9 = parcelRequire("hzyd9");

});
parcelRegister("hzyd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa83ba5710a27e68$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $6p5HB = parcelRequire("6p5HB");

var $jjids = parcelRequire("jjids");
var $aa83ba5710a27e68$export$2e2bcd8739ae039 = (0, $jvoWT.default)(null, {
    showErrorFlag: $6p5HB.showErrorFlag,
    showSuccessFlag: $6p5HB.showSuccessFlag
})((0, $jjids.default));

});
parcelRegister("jjids", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7e2d81be549faf5$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $8y05I = parcelRequire("8y05I");

var $5jYgE = parcelRequire("5jYgE");

var $MmGmU = parcelRequire("MmGmU");

var $1EFS8 = parcelRequire("1EFS8");

var $c2L1U = parcelRequire("c2L1U");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $jbqt2 = parcelRequire("jbqt2");

var $bQ8UI = parcelRequire("bQ8UI");
var $17wqU = parcelRequire("17wqU");

var $iziiq = parcelRequire("iziiq");

var $aQXm8 = parcelRequire("aQXm8");

var $klz3F = parcelRequire("klz3F");

var $hf11t = parcelRequire("hf11t");

var $iJzXX = parcelRequire("iJzXX");

var $31fjU = parcelRequire("31fjU");
const $c7e2d81be549faf5$var$LinkUnlinkProject = ({ projectId: projectId, projectName: projectName, selection: selection, isLastProject: isLastProject, isDisabled: isDisabled, onLinkUnlinkProjects: onLinkUnlinkProjects, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const [openUnlinkDialog, setOpenUnlinkDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const [isUnlinking, setIsUnlinking] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const [isLinking, setIsLinking] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const [isLastUnlink, setIsLastUnlink] = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useState(false);
    const onLinkProject = (0, $8P7DW.useCallback)(()=>{
        setIsLinking(true);
        onLinkUnlinkProjects([
            projectId
        ], (0, $iJzXX.ProjectsMappingOperations).LINK, selection).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                operation: 'single',
                bulkOperation: false,
                mapStatus: (0, $iJzXX.ProjectsMappingOperations).LINK,
                projectCount: 1
            }).fire();
            showSuccessFlagAction((0, $31fjU.default).linkSuccessTitle, {
                projectName: projectName
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $iJzXX.ProjectsMappingOperations).LINK,
                projectCount: 1,
                errorMessage: message,
                errorStatus: status
            }).fire();
            showErrorFlagAction((0, $1EFS8.default).checkGate('itsm-project-renaming') ? (0, $31fjU.default).linkErrorTitleGalaxia : (0, $31fjU.default).linkErrorTitle, (0, $31fjU.default).genericErrorDescription, [], {
                projectName: projectName
            });
        }).finally(()=>{
            setIsLinking(false);
        });
    }, [
        onLinkUnlinkProjects,
        projectId,
        selection,
        showSuccessFlagAction,
        projectName,
        showErrorFlagAction,
        createAnalyticsEvent
    ]);
    const onUnLinkProject = (0, $8P7DW.useCallback)(()=>{
        if (isLastProject) setIsLastUnlink(true);
        else setOpenUnlinkDialog(true);
    }, [
        isLastProject
    ]);
    const onUnlinkDialogButtonClick = (0, $8P7DW.useCallback)(()=>{
        setIsUnlinking(true);
        onLinkUnlinkProjects([
            projectId
        ], (0, $iJzXX.ProjectsMappingOperations).UNLINK, selection).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $iJzXX.ProjectsMappingOperations).UNLINK,
                projectCount: 1
            }).fire();
            setIsUnlinking(false);
            setOpenUnlinkDialog(false);
            showSuccessFlagAction((0, $31fjU.default).unlinkSuccessTitle, {
                projectName: projectName
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $iJzXX.ProjectsMappingOperations).UNLINK,
                projectCount: 1,
                errorMessage: message,
                errorStatus: status
            }).fire();
            setIsUnlinking(false);
            setOpenUnlinkDialog(false);
            showErrorFlagAction((0, $1EFS8.default).checkGate('itsm-project-renaming') ? (0, $31fjU.default).unlinkErrorTitleGalaxia : (0, $31fjU.default).unlinkErrorTitle, (0, $31fjU.default).genericErrorDescription, [], {
                projectName: projectName
            });
        });
    }, [
        onLinkUnlinkProjects,
        projectId,
        projectName,
        selection,
        showErrorFlagAction,
        showSuccessFlagAction,
        createAnalyticsEvent
    ]);
    const contentCallback = (0, $8P7DW.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bQ8UI.ContextWrapper), {
            sourceType: (0, $17wqU.INLINE_DIALOG),
            sourceName: "lastProjectUnlink"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $c7e2d81be549faf5$var$unlinkDialogPopupStyles
        }, (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $31fjU.default).lastProjectUnlinkGalaxia) : formatMessage((0, $31fjU.default).lastProjectUnlink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), null));
    }, [
        formatMessage
    ]);
    const triggerCallback = (0, $8P7DW.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.LoadingButton), {
            ...triggerProps,
            appearance: "link",
            actionSubjectId: "projectUnLink",
            onClick: onUnLinkProject,
            isLoading: isLinking,
            isDisabled: isDisabled
        }, formatMessage((0, $31fjU.default).projectsListUnlinkButtonText));
    }, [
        formatMessage,
        isLinking,
        onUnLinkProject,
        isDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, selection === (0, $iJzXX.ProjectsMappingStatus).LINKED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $c2L1U.default), {
        isOpen: isLastUnlink,
        onClose: ()=>setIsLastUnlink(false),
        placement: "bottom-end",
        zIndex: (0, $jbqt2.layers).modal(),
        content: contentCallback,
        trigger: triggerCallback
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.LoadingButton), {
        actionSubjectId: "projectLink",
        appearance: "link",
        onClick: onLinkProject,
        isLoading: isLinking,
        isDisabled: isDisabled
    }, formatMessage((0, $31fjU.default).projectsListLinkButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hf11t.UnlinkConfirmationModal), {
        isOpen: openUnlinkDialog,
        onClose: ()=>setOpenUnlinkDialog(false),
        onUnlink: onUnlinkDialogButtonClick,
        isLoading: isUnlinking,
        numberOfProjects: 1
    }));
};
const $c7e2d81be549faf5$var$unlinkDialogPopupStyles = (0, $37U6z.xcss)({
    maxWidth: '230px',
    padding: 'space.200'
});
var $c7e2d81be549faf5$export$2e2bcd8739ae039 = $c7e2d81be549faf5$var$LinkUnlinkProject;

});
parcelRegister("hf11t", function(module, exports) {
$parcel$export(module.exports, "UnlinkConfirmationModal", () => $fa292d2f7bf63548$export$42f5f02e8155f94);

var $8P7DW = parcelRequire("8P7DW");

var $8y05I = parcelRequire("8y05I");

var $5jYgE = parcelRequire("5jYgE");

var $1EFS8 = parcelRequire("1EFS8");

var $gtaKc = parcelRequire("gtaKc");
var $7KiOn = parcelRequire("7KiOn");
var $fCWQD = parcelRequire("fCWQD");
var $9euwv = parcelRequire("9euwv");
var $gMGo9 = parcelRequire("gMGo9");
var $33zHl = parcelRequire("33zHl");

var $lNhFX = parcelRequire("lNhFX");
const $fa292d2f7bf63548$export$42f5f02e8155f94 = ({ isOpen: isOpen, onClose: onClose, onUnlink: onUnlink, isLoading: isLoading, projectName: projectName, numberOfProjects: numberOfProjects })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    let modalTitle;
    let modalDescription;
    if (numberOfProjects > 1) {
        modalTitle = (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $lNhFX.default).bulkUnlinkModalTitleGalaxia, {
            number: numberOfProjects
        }) : formatMessage((0, $lNhFX.default).bulkUnlinkModalTitle, {
            number: numberOfProjects
        });
        modalDescription = (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $lNhFX.default).bulkUnlinkModalDescGalaxia) : formatMessage((0, $lNhFX.default).bulkUnlinkModalDesc);
    } else {
        modalTitle = (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $lNhFX.default).unlinkModalTitleGalaxia) : formatMessage((0, $lNhFX.default).unlinkModalTitle);
        modalDescription = (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $lNhFX.default).unlinkModalDescGalaxia, {
            projectName: projectName
        }) : formatMessage((0, $lNhFX.default).unlinkModalDesc, {
            projectName: projectName
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $33zHl.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gtaKc.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9euwv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gMGo9.default), {
        appearance: "warning",
        testId: "help-center-unlink-modal-title"
    }, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7KiOn.default), null, modalDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fCWQD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.LoadingButton), {
        onClick: onUnlink,
        isLoading: isLoading,
        appearance: "warning",
        actionSubjectId: "unlinkModalConfirmButton",
        testId: "unlink-modal-confirm-button"
    }, formatMessage((0, $lNhFX.default).unlinkModalConfirmButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.Button), {
        onClick: onClose,
        appearance: "subtle",
        actionSubjectId: "unlinkModalCancelButton"
    }, formatMessage((0, $lNhFX.default).unlinkModalCancelButton)))));
};

});
parcelRegister("lNhFX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b3f1ae51f253902$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $7b3f1ae51f253902$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    unlinkModalTitle: {
        defaultMessage: 'Unlink this project?',
        description: 'Unlink project confirmation modal title',
        id: 'projects.list.unlink.confirmation.modal.title'
    },
    unlinkModalTitleGalaxia: {
        defaultMessage: 'Unlink this space?',
        description: 'Unlink space confirmation modal title',
        id: 'projects.list.unlink.confirmation.modal.title-galaxia'
    },
    unlinkModalDesc: {
        defaultMessage: `All help resources from the project {projectName} will be removed from the help center and will not show up in search.`,
        description: 'Unlink project confirmation modal description',
        id: 'projects.list.unlink.confirmation.modal.description'
    },
    unlinkModalDescGalaxia: {
        defaultMessage: `All help resources from the space {projectName} will be removed from the help center and will not show up in search.`,
        description: 'Unlink space confirmation modal description',
        id: 'projects.list.unlink.confirmation.modal.description-galaxia'
    },
    bulkUnlinkModalTitle: {
        defaultMessage: 'Unlink {number} projects?',
        description: 'Unlink project confirmation modal title in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.title'
    },
    bulkUnlinkModalTitleGalaxia: {
        defaultMessage: 'Unlink {number} spaces?',
        description: 'Unlink space confirmation modal title in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.title-galaxia'
    },
    bulkUnlinkModalDesc: {
        defaultMessage: `All help resources from these projects will be removed from the help center and will not show up in search.`,
        description: 'Unlink project confirmation modal description in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.description'
    },
    bulkUnlinkModalDescGalaxia: {
        defaultMessage: `All help resources from these spaces will be removed from the help center and will not show up in search.`,
        description: 'Unlink space confirmation modal description in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.description-galaxia'
    },
    unlinkModalConfirmButton: {
        defaultMessage: 'Unlink',
        description: 'Unlink project confirmation modal confirm button',
        id: 'projects.list.unlink.confirmation.modal.confirm.button'
    },
    unlinkModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Unlink project confirmation modal cancel button',
        id: 'projects.list.unlink.confirmation.modal.cancel.button'
    }
});

});


parcelRegister("iJzXX", function(module, exports) {
$parcel$export(module.exports, "ProjectsMappingStatus", () => $b35f8e3e3d5a896c$export$eaf9dd2a52d05588);
$parcel$export(module.exports, "ProjectsMappingMode", () => $b35f8e3e3d5a896c$export$6998efd89043b35d);
$parcel$export(module.exports, "ProjectsMappingOperations", () => $b35f8e3e3d5a896c$export$d0c0bb49dfced741);
var $b35f8e3e3d5a896c$export$eaf9dd2a52d05588 = /*#__PURE__*/ function(ProjectsMappingStatus) {
    ProjectsMappingStatus["UNLINKED"] = "UNLINKED";
    ProjectsMappingStatus["LINKED"] = "LINKED";
    ProjectsMappingStatus["ALL"] = "ALL";
    return ProjectsMappingStatus;
}({});
var $b35f8e3e3d5a896c$export$6998efd89043b35d = /*#__PURE__*/ function(ProjectsMappingMode) {
    ProjectsMappingMode["BULK"] = "bulk";
    ProjectsMappingMode["SINGLE"] = "single";
    return ProjectsMappingMode;
}({});
var $b35f8e3e3d5a896c$export$d0c0bb49dfced741 = /*#__PURE__*/ function(ProjectsMappingOperations) {
    ProjectsMappingOperations["UNLINK"] = "UNMAP_PROJECTS";
    ProjectsMappingOperations["LINK"] = "MAP_PROJECTS";
    return ProjectsMappingOperations;
}({});

});

parcelRegister("31fjU", function(module, exports) {
$parcel$export(module.exports, "default", () => $23f5a72d0cb5359b$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $23f5a72d0cb5359b$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    projectsListLinkButtonText: {
        defaultMessage: 'Link',
        description: 'Projects list link button text',
        id: 'projects.link.unlink.button.link.button.text'
    },
    projectsListUnlinkButtonText: {
        defaultMessage: 'Unlink',
        description: 'Projects list unlink button text',
        id: 'projects.link.unlink.button.unlink.button.text'
    },
    unlinkSuccessTitle: {
        defaultMessage: "\u2019{projectName}\u2019 is no longer linked to this help center",
        description: 'Unlink space flag success title',
        id: 'projects.link.unlink.button.unlink.flag.success.title'
    },
    linkSuccessTitle: {
        defaultMessage: "\u2019{projectName}\u2019 is now linked to this help center",
        description: 'Link space flag success title',
        id: 'projects.link.unlink.button.link.flag.success.title'
    },
    bulkLinkSuccessTitle: {
        defaultMessage: '{number} projects are now linked to this help center',
        description: 'Bulk link project flag success title',
        id: 'projects.link.unlink.button.bulk.link.flag.success.title'
    },
    bulkLinkSuccessTitleGalaxia: {
        defaultMessage: '{number} spaces are now linked to this help center',
        description: 'Bulk link space flag success title',
        id: 'projects.link.unlink.button.bulk.link.flag.success.title-galaxia'
    },
    bulkLinkErrorTitle: {
        defaultMessage: "We couldn\u2019t link the selected projects",
        description: 'Bulk link project flag error title',
        id: 'projects.link.unlink.button.bulk.link.flag.error.title'
    },
    bulkLinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t link the selected spaces",
        description: 'Bulk link space flag error title',
        id: 'projects.link.unlink.button.bulk.link.flag.error.title-galaxia'
    },
    bulkUnlinkSuccessTitle: {
        defaultMessage: '{number} projects have been unlinked from this help center',
        description: 'Bulk unlink projects flag success title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.success.title'
    },
    bulkUnlinkSuccessTitleGalaxia: {
        defaultMessage: '{number} spaces have been unlinked from this help center',
        description: 'Bulk unlink spaces flag success title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.success.title-galaxia'
    },
    bulkUnlinkErrorTitle: {
        defaultMessage: "We couldn\u2019t unlink the selected projects",
        description: 'Bulk unlink projects flag error title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.error.title'
    },
    bulkUnlinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t unlink the selected spaces",
        description: 'Bulk unlink spaces flag error title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.error.title-galaxia'
    },
    unlinkErrorTitle: {
        defaultMessage: "We couldn\u2019t unlink the projects \u2018{projectName}\u2019",
        description: 'Unlink project flag error title',
        id: 'projects.link.unlink.button.unlink.flag.error.title'
    },
    unlinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t unlink the spaces \u2018{projectName}\u2019",
        description: 'Unlink space flag error title',
        id: 'projects.link.unlink.button.unlink.flag.error.title-galaxia'
    },
    linkErrorTitle: {
        defaultMessage: "We couldn\u2019t link the project \u2019{projectName}\u2019",
        description: 'Link project flag error title',
        id: 'projects.link.unlink.button.link.flag.error.title'
    },
    linkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t link the space \u2018{projectName}\u2019",
        description: 'Link space flag error title',
        id: 'projects.link.unlink.button.link.flag.error.title-galaxia'
    },
    genericErrorDescription: {
        defaultMessage: 'Refresh the page and try again.',
        description: 'Unlink project flag error description',
        id: 'projects.link.unlink.button.flag.generic.error.description'
    },
    lastProjectUnlink: {
        defaultMessage: 'Your help center needs at least one linked project to ensure that your customers can access relevant information and resources.',
        description: 'Last project unlink project dialog message',
        id: 'projects.link.unlink.button.unlink.last.project.dialog.content'
    },
    lastProjectUnlinkGalaxia: {
        defaultMessage: 'Your help center needs at least one linked space to ensure that your customers can access relevant information and resources.',
        description: 'Last space unlink space dialog message',
        id: 'projects.link.unlink.button.unlink.last.project.dialog.content-galaxia'
    }
});

});




parcelRegister("krTBL", function(module, exports) {
$parcel$export(module.exports, "BulkActionToolbar", () => $3c5d87304a5b7d62$export$522b8308f1751ff5);

var $8P7DW = parcelRequire("8P7DW");

var $8y05I = parcelRequire("8y05I");

var $5jYgE = parcelRequire("5jYgE");

var $5ht1N = parcelRequire("5ht1N");

var $6Hfjm = parcelRequire("6Hfjm");
var $37U6z = parcelRequire("37U6z");

var $iJzXX = parcelRequire("iJzXX");

var $6OASz = parcelRequire("6OASz");

var $1EYjo = parcelRequire("1EYjo");
const $3c5d87304a5b7d62$export$522b8308f1751ff5 = ({ selectedProjectsCount: selectedProjectsCount, selection: selection, onBulkActionClick: onBulkActionClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const isVisible = selectedProjectsCount > 0;
    const toolbarAccessibilityLabelMessage = isVisible ? formatMessage((0, $1EYjo.default).toolbarAccessibilityLabel) : '';
    const buttonText = selection === (0, $iJzXX.ProjectsMappingStatus).LINKED ? formatMessage((0, $6OASz.default).projectsListUnlinkButtonText) : formatMessage((0, $6OASz.default).projectsListLinkButtonText);
    const actionSubjectId = selection === (0, $iJzXX.ProjectsMappingStatus).LINKED ? 'bulkActionUnLinkButton' : 'bulkActionLinkButton';
    return isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $3c5d87304a5b7d62$var$bulkActionToolbarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        as: "span",
        xcss: $3c5d87304a5b7d62$var$projectsCountTextStyles,
        role: "status"
    }, formatMessage((0, $1EYjo.default).selectedProjectsText, {
        count: selectedProjectsCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $3c5d87304a5b7d62$var$invisibleA11yTitleStyles,
        tabIndex: -1
    }, toolbarAccessibilityLabelMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.LoadingButton), {
        testId: "bulk-action-button",
        actionSubjectId: actionSubjectId,
        onClick: onBulkActionClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ht1N))), {
            label: buttonText,
            size: "small",
            spacing: "spacious"
        }),
        isLoading: isLoading,
        spacing: "compact"
    }, buttonText));
};
const $3c5d87304a5b7d62$var$bulkActionToolbarContainerStyles = (0, $37U6z.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    width: '96%',
    top: 'space.0',
    left: '4%',
    backgroundColor: 'elevation.surface',
    zIndex: 'layer',
    color: 'color.text.subtle',
    paddingBlock: 'space.050',
    paddingInline: 'space.0',
    margin: 'space.0'
});
const $3c5d87304a5b7d62$var$projectsCountTextStyles = (0, $37U6z.xcss)({
    paddingRight: 'space.200'
});
const $3c5d87304a5b7d62$var$invisibleA11yTitleStyles = (0, $37U6z.xcss)({
    opacity: 0,
    position: 'absolute'
});

});
parcelRegister("5ht1N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae3bff1d1955acd002e5417a314968c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d850e9bfb822ce2$var$_react = $3d850e9bfb822ce2$var$_interopRequireDefault((parcelRequire("8P7DW")));

var $3d850e9bfb822ce2$var$_baseNew = $3d850e9bfb822ce2$var$_interopRequireDefault((parcelRequire("kJTzo")));
function $3d850e9bfb822ce2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d850e9bfb822ce2$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $3d850e9bfb822ce2$var$_react.default.createElement($3d850e9bfb822ce2$var$_baseNew.default, Object.assign({
        name: "LinkBrokenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$3d850e9bfb822ce2$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $3d850e9bfb822ce2$var$_default = module.exports.default = $3d850e9bfb822ce2$var$LinkBrokenIcon;

});

parcelRegister("6OASz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8094f1504686ae7$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $f8094f1504686ae7$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    projectsListLinkedLozengeLabel: {
        defaultMessage: 'Linked',
        description: 'Projects list linked lozenge label',
        id: 'projects.list.linked.lozenge.label'
    },
    projectsListUnlinkedLozengeLabel: {
        defaultMessage: 'Unlinked',
        description: 'Projects list unlinked lozenge label',
        id: 'projects.list.unlinked.lozenge.label'
    },
    projectsListLinkButtonText: {
        defaultMessage: 'Link',
        description: 'Projects list link button text',
        id: 'projects.list.link.button.text'
    },
    projectsListUnlinkButtonText: {
        defaultMessage: 'Unlink',
        description: 'Projects list unlink button text',
        id: 'projects.list.unlink.button.text'
    },
    noUnlinkedProjectsDescription: {
        defaultMessage: "When you unlink projects, they\u2019ll appear here.",
        description: 'Projects list empty state description',
        id: 'projects.list.empty.description'
    },
    noUnlinkedProjectsDescriptionGalaxia: {
        defaultMessage: "When you unlink spaces, they\u2019ll appear here.",
        description: 'Spaces list empty state description',
        id: 'projects.list.empty.description-galaxia'
    },
    noUnlinkedProjectsTitle: {
        defaultMessage: 'All your projects are linked to this help center',
        description: 'Projects list empty state title',
        id: 'projects.list.empty.title'
    },
    noUnlinkedProjectsTitleGalaxia: {
        defaultMessage: 'All your spaces are linked to this help center',
        description: 'Spaces list empty state title',
        id: 'projects.list.empty.title-galaxia'
    },
    noLinkedProjectsDescription: {
        defaultMessage: "When you link projects, they\u2019ll appear here.",
        description: 'Projects list empty state description on linked tab',
        id: 'projects.list.empty.description.linked.tab'
    },
    noLinkedProjectsDescriptionGalaxia: {
        defaultMessage: "When you link spaces, they\u2019ll appear here.",
        description: 'Spaces list empty state description on linked tab',
        id: 'projects.list.empty.description.linked.tab-galaxia'
    },
    noLinkedProjectsTitle: {
        defaultMessage: 'All your projects have been unlinked from this help center',
        description: 'Projects list empty state title on linked tab',
        id: 'projects.list.empty.title.linked.tab'
    },
    noLinkedProjectsTitleGalaxia: {
        defaultMessage: 'All your spaces have been unlinked from this help center',
        description: 'Spaces list empty state title on linked tab',
        id: 'projects.list.empty.title.linked.tab-galaxia'
    },
    projectsListEmptySearchTitle: {
        defaultMessage: 'No projects found matching your search',
        description: 'Projects list empty search title',
        id: 'projects.list.empty.search.title'
    },
    projectsListEmptySearchTitleGalaxia: {
        defaultMessage: 'No spaces found matching your search',
        description: 'Spaces list empty search title',
        id: 'projects.list.empty.search.title-galaxia'
    },
    projectsListEmptySearchDescription: {
        defaultMessage: 'Try using specific project names or terms',
        description: 'Projects list empty search description',
        id: 'projects.list.empty.search.description'
    },
    projectsListEmptySearchDescriptionGalaxia: {
        defaultMessage: 'Try using specific space names or terms',
        description: 'Spaces list empty search description',
        id: 'projects.list.empty.search.description-galaxia'
    },
    selectAllProjectsCheckboxLabel: {
        defaultMessage: 'Select all projects',
        description: 'Checkbox label for selecting all projects',
        id: 'projects.list.select-all.projects.checkbox.label'
    },
    selectAllProjectsCheckboxLabelGalaxia: {
        defaultMessage: 'Select all spaces',
        description: 'Checkbox label for selecting all spaces',
        id: 'projects.list.select-all.projects.checkbox.label-galaxia'
    },
    selectProjectCheckboxLabel: {
        defaultMessage: 'Select project',
        description: 'Checkbox label for selecting a single project',
        id: 'projects.list.select.project.checkbox.label'
    },
    selectProjectCheckboxLabelGalaxia: {
        defaultMessage: 'Select space',
        description: 'Checkbox label for selecting a single space',
        id: 'projects.list.select.project.checkbox.label-galaxia'
    },
    columnHeaderSpace: {
        defaultMessage: 'Space',
        description: 'Spaces list column header space',
        id: 'spaces.list.column.header.space-galaxia'
    },
    columnHeaderLead: {
        defaultMessage: 'Lead',
        description: 'Spaces list column header lead',
        id: 'spaces.list.column.header.lead'
    },
    columnHeaderStatus: {
        defaultMessage: 'Status',
        description: 'Spaces list column header status',
        id: 'spaces.list.column.header.status'
    },
    columnHeaderActions: {
        defaultMessage: 'Actions',
        description: 'Spaces list column header actions',
        id: 'spaces.list.column.header.actions'
    }
});

});

parcelRegister("1EYjo", function(module, exports) {
$parcel$export(module.exports, "default", () => $807131d871ca4c3c$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $807131d871ca4c3c$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    selectedProjectsText: {
        defaultMessage: '{count, plural, one {1 selected} other { # selected}}',
        description: 'Text for displaying selected projects count',
        id: 'projects-list.bulk-action-toolbar.selected-spaces-text'
    },
    toolbarAccessibilityLabel: {
        defaultMessage: 'Actions for selected items are available before the table.',
        description: 'Accessibility label for the toolbar',
        id: 'projects-list.bulk-action-toolbar.toolbar-accessibility-label'
    }
});

});


parcelRegister("l2LMB", function(module, exports) {
$parcel$export(module.exports, "UnlinkAllProjectsWarningModal", () => $caa2b7e0b562a435$export$b442637e98a0429b);

var $8P7DW = parcelRequire("8P7DW");

var $8y05I = parcelRequire("8y05I");

var $5jYgE = parcelRequire("5jYgE");

var $1EFS8 = parcelRequire("1EFS8");

var $gtaKc = parcelRequire("gtaKc");
var $7KiOn = parcelRequire("7KiOn");
var $fCWQD = parcelRequire("fCWQD");
var $9euwv = parcelRequire("9euwv");
var $gMGo9 = parcelRequire("gMGo9");
var $33zHl = parcelRequire("33zHl");

var $bQ8UI = parcelRequire("bQ8UI");
var $17wqU = parcelRequire("17wqU");

var $aQXm8 = parcelRequire("aQXm8");

var $1Keya = parcelRequire("1Keya");
const $caa2b7e0b562a435$export$b442637e98a0429b = ({ isOpen: isOpen, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bQ8UI.ContextWrapper), {
        sourceType: (0, $17wqU.MODAL),
        sourceName: "helpCenterUnlinkAllWarning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $33zHl.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gtaKc.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9euwv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gMGo9.default), {
        testId: "help-center-unlink-all-projects-warning-modal-title"
    }, (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $1Keya.default).unlinkAllWarningModalTitleGalaxia) : formatMessage((0, $1Keya.default).unlinkAllWarningModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7KiOn.default), null, (0, $1EFS8.default).checkGate('itsm-project-renaming') ? formatMessage((0, $1Keya.default).unlinkAllWarningModalDescriptionGalaxia) : formatMessage((0, $1Keya.default).unlinkAllWarningModalDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fCWQD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.Button), {
        onClick: onClose,
        appearance: "primary",
        actionSubjectId: "unlinkAllWarningModalOkButton"
    }, formatMessage((0, $1Keya.default).unlinkAllWarningModalOkButton))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), null));
};

});
parcelRegister("1Keya", function(module, exports) {
$parcel$export(module.exports, "default", () => $54a21f045821f96a$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $54a21f045821f96a$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    unlinkAllWarningModalTitle: {
        defaultMessage: 'Your help center needs at least one linked project',
        description: 'Title of the unlink all projects warning modal',
        id: 'projects.list.unlink.all.warning.modal.title'
    },
    unlinkAllWarningModalTitleGalaxia: {
        defaultMessage: 'Your help center needs at least one linked space',
        description: 'Title of the unlink all spaces warning modal',
        id: 'projects.list.unlink.all.warning.modal.title-galaxia'
    },
    unlinkAllWarningModalDescription: {
        defaultMessage: 'To ensure that your customers can access relevant information and resources, at least one project needs to be linked to your help center. Uncheck a project and try again.',
        description: 'Description of the unlink all projects warning modal',
        id: 'projects.list.unlink.all.warning.modal.description'
    },
    unlinkAllWarningModalDescriptionGalaxia: {
        defaultMessage: 'To ensure that your customers can access relevant information and resources, at least one space needs to be linked to your help center. Uncheck a space and try again.',
        description: 'Description of the unlink all spaces warning modal',
        id: 'projects.list.unlink.all.warning.modal.description-galaxia'
    },
    unlinkAllWarningModalOkButton: {
        defaultMessage: 'OK',
        description: 'Unlink all projects warning modal ok button',
        id: 'projects.list.unlink.all.warning.modal.ok.button'
    }
});

});





parcelRegister("1HwKL", function(module, exports) {
$parcel$export(module.exports, "SyncProjectsToggle", () => (parcelRequire("DSjZz")).default);

var $DSjZz = parcelRequire("DSjZz");

});
parcelRegister("DSjZz", function(module, exports) {
$parcel$export(module.exports, "default", () => $efd70acc5bf8c338$export$2e2bcd8739ae039);
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $6p5HB = parcelRequire("6p5HB");

var $3JxfH = parcelRequire("3JxfH");
var $efd70acc5bf8c338$export$2e2bcd8739ae039 = (0, $jvoWT.default)(null, {
    showErrorFlag: $6p5HB.showErrorFlag,
    showSuccessFlag: $6p5HB.showSuccessFlag
})((0, $3JxfH.default));

});
parcelRegister("3JxfH", function(module, exports) {
$parcel$export(module.exports, "default", () => $43708d067d67fa4e$export$2e2bcd8739ae039);

var $fksXS = parcelRequire("fksXS");

var $hMaKb = parcelRequire("hMaKb");

var $8P7DW = parcelRequire("8P7DW");

var $jByYr = parcelRequire("jByYr");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");

var $MmGmU = parcelRequire("MmGmU");

var $ifRQf = parcelRequire("ifRQf");
var $5l93E = parcelRequire("5l93E");

var $1EFS8 = parcelRequire("1EFS8");

var $gtaKc = parcelRequire("gtaKc");
var $7KiOn = parcelRequire("7KiOn");
var $fCWQD = parcelRequire("fCWQD");
var $9euwv = parcelRequire("9euwv");
var $gMGo9 = parcelRequire("gMGo9");
var $33zHl = parcelRequire("33zHl");

var $a29h9 = parcelRequire("a29h9");

var $iziiq = parcelRequire("iziiq");

var $klz3F = parcelRequire("klz3F");

var $42qw9 = parcelRequire("42qw9");

var $dSz79 = parcelRequire("dSz79");

var $4o4XT = parcelRequire("4o4XT");
const $43708d067d67fa4e$var$SyncProjectsToggle = ({ syncProjectsToggleFragmentKey: syncProjectsToggleFragmentKey, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    var _helpCenterData$proje;
    const helpCenterData = (0, $h3cOB.useFragment)((0, $hMaKb.default), syncProjectsToggleFragmentKey);
    const [isChecked, setIsChecked] = (0, $8P7DW.useState)(!!(helpCenterData !== null && helpCenterData !== void 0 && (_helpCenterData$proje = helpCenterData.projectMappingData) !== null && _helpCenterData$proje !== void 0 && _helpCenterData$proje.syncNewProjects));
    const [isRemoveMappingDialogOpen, setRemoveMappingDialogOpen] = (0, $8P7DW.useState)(false);
    const [isUnSyncing, setIsUnSyncing] = (0, $8P7DW.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const helpCenterAri = (0, $dSz79.useHelpCenterAri)();
    const { isHelpHub: isHelpHub } = (0, $42qw9.useHelpCenterType)();
    const isProjectRenamingEnabled = (0, $1EFS8.default).checkGate('itsm-project-renaming');
    let toggleLabel;
    if (isHelpHub && isProjectRenamingEnabled) toggleLabel = (0, $4o4XT.default).defaultMappingToggleLabelGalaxiaHelpHub;
    else if (isHelpHub) toggleLabel = (0, $4o4XT.default).defaultMappingToggleLabelHelpHub;
    else if (isProjectRenamingEnabled) toggleLabel = (0, $4o4XT.default).defaultMappingToggleLabelGalaxia;
    else toggleLabel = (0, $4o4XT.default).defaultMappingToggleLabel;
    const [toggleDefaultSync] = (0, $h3cOB.useMutation)((0, $fksXS.default));
    const onToggleDefault = (0, $8P7DW.useCallback)((syncNewProjects)=>{
        return new Promise((resolve, reject)=>toggleDefaultSync({
                variables: {
                    cloudId: (0, $jByYr.getCloudId)(),
                    input: {
                        syncNewProjects: syncNewProjects,
                        helpCenterAri: helpCenterAri
                    }
                },
                onCompleted: (response)=>{
                    var _response$helpCenter, _response$helpCenter2;
                    if ((_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateProjectMapping) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) resolve(response);
                    const errors = (_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.updateProjectMapping) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.errors;
                    const error = errors && errors.length > 0 ? errors[0] : new Error('Unknown error');
                    return reject(error);
                },
                onError: (error)=>{
                    reject(error);
                }
            }));
    }, [
        toggleDefaultSync,
        helpCenterAri
    ]);
    const onToggleChange = (0, $8P7DW.useCallback)(()=>{
        if (isChecked) setRemoveMappingDialogOpen(true);
        else {
            setIsChecked(true);
            onToggleDefault(true).then(()=>{
                createAnalyticsEvent({
                    analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                    action: 'map',
                    actionSubject: 'newProjects',
                    toggleState: true
                }).fire();
            }).catch((error)=>{
                const { message: message, status: status } = error;
                setIsChecked(false);
                const errorTitle = isProjectRenamingEnabled ? (0, $4o4XT.default).syncErrorTitleGalaxia : (0, $4o4XT.default).syncErrorTitle;
                showErrorFlagAction(errorTitle, (0, $4o4XT.default).syncErrorDescription);
                if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                    analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                    action: 'map_failed',
                    actionSubject: 'newProjects',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
            });
        }
    }, [
        isChecked,
        onToggleDefault,
        showErrorFlagAction,
        createAnalyticsEvent,
        isProjectRenamingEnabled
    ]);
    const onUnMapNewProjects = (0, $8P7DW.useCallback)(()=>{
        setIsUnSyncing(true);
        onToggleDefault(false).then(()=>{
            setIsChecked(false);
            const successTitle = isProjectRenamingEnabled ? (0, $4o4XT.default).unSyncSuccessTitleGalaxia : (0, $4o4XT.default).unSyncSuccessTitle;
            showSuccessFlagAction(successTitle);
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'newProjects',
                toggleState: false
            }).fire();
        }).catch((error)=>{
            const { message: message, status: status } = error;
            const errorTitle = isProjectRenamingEnabled ? (0, $4o4XT.default).syncErrorTitleGalaxia : (0, $4o4XT.default).syncErrorTitle;
            showErrorFlagAction(errorTitle, (0, $4o4XT.default).syncErrorDescription);
            if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'newProjects',
                errorMessage: message,
                errorStatus: status
            }).fire();
        }).finally(()=>{
            setIsUnSyncing(false);
            setRemoveMappingDialogOpen(false);
        });
    }, [
        onToggleDefault,
        showErrorFlagAction,
        showSuccessFlagAction,
        createAnalyticsEvent,
        isProjectRenamingEnabled
    ]);
    const modalTitle = isProjectRenamingEnabled ? (0, $4o4XT.default).removeMappingModalTitleGalaxia : (0, $4o4XT.default).removeMappingModalTitle;
    const modalDesc = isProjectRenamingEnabled ? (0, $4o4XT.default).removeMappingModalDescGalaxia : (0, $4o4XT.default).removeMappingModalDesc;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $a29h9.default), {
        label: formatMessage(toggleLabel),
        isChecked: isChecked,
        onChange: onToggleChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $33zHl.default), null, isRemoveMappingDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gtaKc.default), {
        width: "small",
        onClose: ()=>setRemoveMappingDialogOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9euwv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gMGo9.default), {
        testId: "help-center-UnSync-modal-title"
    }, formatMessage(modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7KiOn.default), null, formatMessage(modalDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fCWQD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $5l93E.default), {
        onClick: onUnMapNewProjects,
        isLoading: isUnSyncing,
        appearance: "primary",
        testId: "help-center-modal-unSync-button"
    }, formatMessage((0, $4o4XT.default).removeMappingModalConfirmButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ifRQf.default), {
        onClick: ()=>setRemoveMappingDialogOpen(false),
        appearance: "subtle"
    }, formatMessage((0, $4o4XT.default).removeMappingModalCancelButton))))));
};
var $43708d067d67fa4e$export$2e2bcd8739ae039 = $43708d067d67fa4e$var$SyncProjectsToggle;

});
parcelRegister("fksXS", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e707d1e44e9e3e1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f237022b919191808dfb4771aef00246>>
 * @relayHash f6ad0a674b4deb767396c24696d6bb4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da8c746423a9772dac447f2fdbad8fd4ca55ac3024e4850bb499f3e66949b60d
const $3e707d1e44e9e3e1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterProjectMappingUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateProjectMapping",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "syncProjectsToggleMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "syncProjectsToggleMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "da8c746423a9772dac447f2fdbad8fd4ca55ac3024e4850bb499f3e66949b60d",
            "metadata": {},
            "name": "syncProjectsToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3e707d1e44e9e3e1$var$node.hash = "f63e31632e8452ce88ba847207c9b4ff";
var $3e707d1e44e9e3e1$export$2e2bcd8739ae039 = $3e707d1e44e9e3e1$var$node;

});

parcelRegister("hMaKb", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ca0e0b24ffbbec8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bed802131b6fd8739e7bfeaa0ed811e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5ca0e0b24ffbbec8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "syncProjectsToggleFragment",
    "selections": [
        {
            "concreteType": "HelpCenterProjectMappingData",
            "kind": "LinkedField",
            "name": "projectMappingData",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "syncNewProjects"
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$5ca0e0b24ffbbec8$var$node.hash = "b09d61797a2afad5be65329bfb50cc92";
var $5ca0e0b24ffbbec8$export$2e2bcd8739ae039 = $5ca0e0b24ffbbec8$var$node;

});

parcelRegister("a29h9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1f3afb620b10240$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");

var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $aeYmt = parcelRequire("aeYmt");

var $5J6r2 = parcelRequire("5J6r2");

var $fnhqr = parcelRequire("fnhqr");

var $bHKCU = parcelRequire("bHKCU");

var $b9hQ0 = parcelRequire("b9hQ0");

var $e6Qdr = parcelRequire("e6Qdr");

var $cjn3r = parcelRequire("cjn3r");

var $dojiU = parcelRequire("dojiU");

var $gNIvj = parcelRequire("gNIvj");
const $a1f3afb620b10240$var$LOADING_LABEL = ', Loading';
const $a1f3afb620b10240$var$basicStyles = null;
const $a1f3afb620b10240$var$sizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $a1f3afb620b10240$var$atomicBaseStyles = null;
const $a1f3afb620b10240$var$atomicSizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz"
};
/**
 * Slider knob translate transforms per size, applied when checked.
 */ const $a1f3afb620b10240$var$atomicCheckedSliderStyles = {
    regular: "_7dwz1fbe",
    large: "_7dwzw12q"
};
/**
 * Applied when the toggle is checked
 */ const $a1f3afb620b10240$var$atomicCheckedStyles = null;
/**
 * Applied when the toggle is checked and not disabled.
 */ const $a1f3afb620b10240$var$atomicCheckedHoveredStyles = null;
/**
 * Applied when the toggle is unchecked and not disabled.
 */ const $a1f3afb620b10240$var$atomicUncheckedHoveredStyles = null;
/**
 * Applied when the toggle is disabled.
 */ const $a1f3afb620b10240$var$atomicDisabledStyles = null;
const $a1f3afb620b10240$var$atomicInputStyles = null;
const $a1f3afb620b10240$var$noop = (0, $5J6r2.default);
const $a1f3afb620b10240$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: undefined,
    packageVersion: undefined
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $a1f3afb620b10240$var$Toggle = /*#__PURE__*/ (0, $8P7DW.memo)(/*#__PURE__*/ (0, $8P7DW.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $a1f3afb620b10240$var$noop, onChange: providedChange = $a1f3afb620b10240$var$noop, onFocus: providedFocus = $a1f3afb620b10240$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $8P7DW.useState)(defaultChecked);
    const loadingLabelId = (0, $fnhqr.useId)();
    const handleBlur = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$a1f3afb620b10240$var$analyticsAttributes
    });
    const handleFocus = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$a1f3afb620b10240$var$analyticsAttributes
    });
    const handleChange = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$a1f3afb620b10240$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        // In the legacy styling path, data-* attributes drive CSS styling via
        // attribute selectors. In the atomic path they are no longer needed.
        ...!(0, $e6Qdr.fg)('platform-toggle-atomic-styles') && {
            'data-checked': shouldChecked ? shouldChecked : undefined,
            'data-disabled': isDisabled ? isDisabled : undefined,
            'data-size': size
        },
        'data-testid': testId ? testId : undefined
    };
    const labelId = (0, $fnhqr.useId)();
    return /*#__PURE__*/ (0, $gWgPx.jsxs)("label", {
        ...controlProps,
        className: (0, $8n1kL.default)([
            !(0, $e6Qdr.fg)('platform-toggle-atomic-styles') && "_v564kete _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1ys41v1w _krlfnqa1 _ju3ddkaa _1bkiby5v _1fltby5v _3xv2by5v _9471kcmj _ucab5w2r _mqf82sac _3dj22sac _1dl92sac _1div5w2r _1il8kb7n _y54d5w2r _irr31ibz _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1pluy7x8 _1uo81ibz _178cby5v _16rslghj _i5ec1w7i",
            !(0, $e6Qdr.fg)('platform-toggle-atomic-styles') && $a1f3afb620b10240$var$sizeStyles[size],
            (0, $e6Qdr.fg)('platform-toggle-atomic-styles') && "_v564kete _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _80omtlke _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _1ys41v1w _ju3ddkaa _16rslghj _i5ec1w7i",
            (0, $e6Qdr.fg)('platform-toggle-atomic-styles') && $a1f3afb620b10240$var$atomicSizeStyles[size],
            shouldChecked && (0, $e6Qdr.fg)('platform-toggle-atomic-styles') && "_bfhkkcmj",
            shouldChecked && (0, $e6Qdr.fg)('platform-toggle-atomic-styles') && $a1f3afb620b10240$var$atomicCheckedSliderStyles[size],
            !isDisabled && shouldChecked && (0, $e6Qdr.fg)('platform-toggle-atomic-styles') && "_irr3y7x8",
            !isDisabled && !shouldChecked && (0, $e6Qdr.fg)('platform-toggle-atomic-styles') && "_irr31ibz",
            isDisabled && (0, $e6Qdr.fg)('platform-toggle-atomic-styles') && "_bfhkby5v _syaz2sac _80om13gf _1g0vkb7n"
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $gWgPx.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$a1f3afb620b10240$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $gWgPx.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId,
                // In the atomic styling path, apply input styles directly to the input element
                // rather than via nested styles on the parent label.
                className: (0, $8n1kL.default)([
                    (0, $e6Qdr.fg)('platform-toggle-atomic-styles') && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _tzy4idpf _nt751snc _49pcagmp _1hvw10yn"
                ])
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gNIvj.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bHKCU))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gNIvj.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cjn3r.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))), {
                    label: "",
                    color: "currentColor",
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dojiU.default), {
                id: loadingLabelId,
                children: $a1f3afb620b10240$var$LOADING_LABEL
            })
        ]
    });
}));
$a1f3afb620b10240$var$Toggle.displayName = 'Toggle';
var $a1f3afb620b10240$export$2e2bcd8739ae039 = $a1f3afb620b10240$var$Toggle;

});
parcelRegister("gNIvj", function(module, exports) {
$parcel$export(module.exports, "default", () => $976bdeb4e5ee05ef$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* icon-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $6NJAV = parcelRequire("6NJAV");

var $2CGHX = parcelRequire("2CGHX");
const $976bdeb4e5ee05ef$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $976bdeb4e5ee05ef$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $2CGHX.default), {
        as: "span",
        xcss: (0, $6NJAV.cx)($976bdeb4e5ee05ef$var$styles.iconContainer, isHidden && $976bdeb4e5ee05ef$var$styles.hidden, size === 'regular' && $976bdeb4e5ee05ef$var$styles.iconContainerRegular, size === 'large' && $976bdeb4e5ee05ef$var$styles.iconContainerLarge, position === 'left' && $976bdeb4e5ee05ef$var$styles.left, position === 'right' && $976bdeb4e5ee05ef$var$styles.right),
        children: children
    });
};
var $976bdeb4e5ee05ef$export$2e2bcd8739ae039 = $976bdeb4e5ee05ef$var$IconContainer;

});


parcelRegister("4o4XT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7f66a9fcc66994d$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $a7f66a9fcc66994d$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    defaultMappingToggleLabel: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default mapping',
        id: 'sync.project.toggle.label'
    },
    defaultMappingToggleLabelHelpHub: {
        defaultMessage: 'Link all new projects to this help hub',
        description: 'Toggle label for default mapping for help hub',
        id: 'sync.project.toggle.label.helphub'
    },
    defaultMappingToggleLabelGalaxiaHelpHub: {
        defaultMessage: 'Link all new spaces to this help hub',
        description: 'Toggle label for default mapping for help hub with Galaxia renaming',
        id: 'sync.project.toggle.label.galaxia.helphub'
    },
    defaultMappingToggleLabelGalaxia: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default mapping',
        id: 'sync.project.toggle.label-galaxia'
    },
    removeMappingModalTitle: {
        defaultMessage: 'Stop linking new projects to this help center?',
        description: 'removeMapping modal title',
        id: 'sync.project.toggle.removeMapping.modal.title'
    },
    removeMappingModalTitleGalaxia: {
        defaultMessage: 'Stop linking new spaces to this help center?',
        description: 'removeMapping modal title',
        id: 'sync.project.toggle.removeMapping.modal.title-galaxia'
    },
    removeMappingModalDesc: {
        defaultMessage: 'Help resources from new projects will not show up in this help center or search.',
        description: 'removeMapping modal description',
        id: 'sync.project.toggle.removeMapping.modal.description'
    },
    removeMappingModalDescGalaxia: {
        defaultMessage: 'Help resources from new spaces will not show up in this help center or search.',
        description: 'removeMapping modal description',
        id: 'sync.project.toggle.removeMapping.modal.description-galaxia'
    },
    removeMappingModalConfirmButton: {
        defaultMessage: 'Continue',
        description: 'removeMapping modal confirm button',
        id: 'sync.project.toggle.removeMapping.modal.confirm'
    },
    removeMappingModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'removeMapping modal cancel button',
        id: 'sync.project.toggle.removeMapping.modal.cancel'
    },
    syncErrorTitle: {
        defaultMessage: "We couldn't turn off automatic linking of new projects",
        description: 'Sync new projects flag error title',
        id: 'sync.project.toggle.sync.flag.error.title'
    },
    syncErrorTitleGalaxia: {
        defaultMessage: "We couldn't turn off automatic linking of new spaces",
        description: 'Sync new spaces flag error title',
        id: 'sync.project.toggle.sync.flag.error.title-galaxia'
    },
    syncErrorDescription: {
        defaultMessage: 'Refresh the page and try again.',
        description: 'Sync new projects flag error description',
        id: 'sync.project.toggle.sync.flag.error.description'
    },
    unSyncSuccessTitle: {
        defaultMessage: 'Automatic linking of new projects turned off',
        description: 'Sync new projects flag success title',
        id: 'sync.project.toggle.sync.flag.success.title'
    },
    unSyncSuccessTitleGalaxia: {
        defaultMessage: 'Automatic linking of new spaces turned off',
        description: 'Sync new spaces flag success title',
        id: 'sync.project.toggle.sync.flag.success.title-galaxia'
    }
});

});






parcelRegister("h4dv2", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManagePages", () => $d0257630a6d493f1$export$ede7df3d2ca0e51e);

var $8P7DW = parcelRequire("8P7DW");

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

var $8y0tS = parcelRequire("8y0tS");
parcelRequire("irqBT");
var $i3cng = parcelRequire("i3cng");

var $h8xIO = parcelRequire("h8xIO");
parcelRequire("73Uz8");
var $18Jju = parcelRequire("18Jju");

const $d0257630a6d493f1$var$AsyncHelpCenterManagePagesComponent = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("g6WQM")), {
        moduleId: "./packages/admin-layout/src/ui/manage-pages/manage-pages.tsx"
    }),
    LoadingSkeleton: (0, $18Jju.default)
});
const $d0257630a6d493f1$export$ede7df3d2ca0e51e = ()=>{
    (0, $8y0tS.useUFOComponentExperience)((0, $h8xIO.managePagesExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $i3cng.default), {
        featureName: "Helpcenter manage pages"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($d0257630a6d493f1$var$AsyncHelpCenterManagePagesComponent, null));
};

});
parcelRegister("h8xIO", function(module, exports) {
$parcel$export(module.exports, "managePagesExperience", () => $e0ab921210ca6382$export$5b30dfd9ef11a3c5);

var $lQb0x = parcelRequire("lQb0x");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $e0ab921210ca6382$export$5b30dfd9ef11a3c5 = new (0, $ghwxF.UFOExperience)((0, $lQb0x.managePagesExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("73Uz8", function(module, exports) {
$parcel$export(module.exports, "ManagePagesLayoutSkeleton", () => (parcelRequire("18Jju")).default);

var $18Jju = parcelRequire("18Jju");

});
parcelRegister("18Jju", function(module, exports) {
$parcel$export(module.exports, "default", () => $b900d04f72ceb52b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $iSvee = parcelRequire("iSvee");

var $3Snuc = parcelRequire("3Snuc");

var $6Hfjm = parcelRequire("6Hfjm");
var $dqsXi = parcelRequire("dqsXi");
var $2IKBM = parcelRequire("2IKBM");
var $37U6z = parcelRequire("37U6z");

var $aJI9b = parcelRequire("aJI9b");
const $b900d04f72ceb52b$var$ManagePagesLayoutSkeleton = ()=>{
    const head = {
        cells: [
            {
                key: 'page-name',
                content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                    width: "20%",
                    height: "16px"
                }),
                width: (0, $aJI9b.MANAGE_PAGE_HEAD_WIDTH)['page-name']
            },
            {
                key: 'last-updated',
                content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                    width: "20%",
                    height: "16px"
                }),
                width: (0, $aJI9b.MANAGE_PAGE_HEAD_WIDTH)['last-updated']
            },
            {
                key: 'page-description',
                content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                    width: "40%",
                    height: "16px"
                }),
                width: (0, $aJI9b.MANAGE_PAGE_HEAD_WIDTH)['page-description']
            },
            {
                key: 'action-button',
                content: /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                    width: "40%",
                    height: "16px"
                }),
                width: (0, $aJI9b.MANAGE_PAGE_HEAD_WIDTH)['action-button']
            }
        ]
    };
    const rows = Array.from({
        length: 20
    }).map((_, index)=>({
            key: `${index}`,
            cells: [
                {
                    content: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
                        width: "20%",
                        height: "20px"
                    }))
                }
            ]
        }));
    return /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.300"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.300"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "84px",
        height: "24px"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        direction: "row",
        justifyContent: "space-between"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-page-title-skeleton"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-page-create-button-skeleton"
    })), /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.050"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "75%",
        height: "20px"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        xcss: $b900d04f72ceb52b$var$tableSkeletonStyles
    }, /*#__PURE__*/ $8P7DW.createElement((0, $3Snuc.default), {
        head: head,
        rows: rows,
        isFixedSize: true,
        isRankingDisabled: true
    })));
};
const $b900d04f72ceb52b$var$tableSkeletonStyles = (0, $37U6z.xcss)({
    pointerEvents: 'none'
});
var $b900d04f72ceb52b$export$2e2bcd8739ae039 = $b900d04f72ceb52b$var$ManagePagesLayoutSkeleton;

});


parcelRegister("g6WQM", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("i0YHV"),
    $j9MRt("1kNIV"),
    $j9MRt("9hBNq"),
    $j9MRt("6UjUY")
]).then(()=>parcelRequire('hMMGe'));

});




parcelRegister("2aBl3", function(module, exports) {
$parcel$export(module.exports, "HelpCenterRovoServiceAgentResource", () => $ad663bb58c655ee9$export$edd09dd027b459f5);

var $jByYr = parcelRequire("jByYr");

var $byuiX = parcelRequire("byuiX");

var $ffF1H = parcelRequire("ffF1H");

var $kREet = parcelRequire("kREet");
const $ad663bb58c655ee9$export$edd09dd027b459f5 = (0, $byuiX.createRelayResource)({
    type: 'HELP_ROVO_SERVICE_AGENT_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const activationId = (0, $jByYr.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const computedHelpCenterAri = (0, $ffF1H.createHelpCenterAri)(activationId, helpCenterId);
        // Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
        const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
        return {
            parameters: (0, $kREet.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: finalHelpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("kREet", function(module, exports) {
$parcel$export(module.exports, "default", () => $259cb2f78d0a3416$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8bb85b1e96eae1c929995721763ddad5>>
 * @relayHash e8ae7ab32189fb155478d43e63c3f190
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b
const $259cb2f78d0a3416$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCustomAgentsAvailable"
            },
            {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                    }
                ]
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcRovoServiceAgentSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsBreadcrumbsFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcRovoServiceAgentSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b",
            "metadata": {},
            "name": "srcRovoServiceAgentSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$259cb2f78d0a3416$var$node.hash = "3ce1cdd1dbdfc24a36880f88710c85d7";
var $259cb2f78d0a3416$export$2e2bcd8739ae039 = $259cb2f78d0a3416$var$node;

});


parcelRegister("3uJjL", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("ejrQr"),
    $j9MRt("8n69V"),
    $j9MRt("29dwi")
]).then(()=>parcelRequire('5FJx7'));

});


parcelRegister("3wAsA", function(module, exports) {
$parcel$export(module.exports, "helpcenterEditRoute", () => $a69307865bd1835d$export$8c1389d3983434c);
$parcel$export(module.exports, "helpcenterManageProjectsRoute", () => $a69307865bd1835d$export$5fae61522b3dcb33);
$parcel$export(module.exports, "helpcenterManageCustomPagesRoute", () => $a69307865bd1835d$export$d1e5a4952efbcb);
$parcel$export(module.exports, "hubEditLayoutRoute", () => $a69307865bd1835d$export$8f54556241df66cd);
$parcel$export(module.exports, "hubEditPortalLayoutRoute", () => $a69307865bd1835d$export$b97f195684a7c2a4);

var $8P7DW = parcelRequire("8P7DW");

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("9wocP");
var $bDnSZ = parcelRequire("bDnSZ");

var $bsPHj = parcelRequire("bsPHj");

var $cjn3r = parcelRequire("cjn3r");

var $48p10 = parcelRequire("48p10");

const $a69307865bd1835d$var$AsyncHelpCenterEditDetailsPage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>Promise.resolve((parcelRequire("gaYiV"))).then(({ HelpCenterEditDetails: HelpCenterEditDetails })=>HelpCenterEditDetails), {
        moduleId: "./packages/help-center/help-centers-management/src/ui/edit-helpcenter/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $a69307865bd1835d$var$AsyncHelpCenterManageProjectsPage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>Promise.resolve((parcelRequire("dnZw2"))).then(({ HelpCenterManageProjects: HelpCenterManageProjects })=>HelpCenterManageProjects), {
        moduleId: "./packages/admin-layout/src/ui/manage-projects/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $a69307865bd1835d$var$AsyncHelpCenterManageCustomPagesPage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>Promise.resolve((parcelRequire("h4dv2"))).then(({ HelpCenterManagePages: HelpCenterManagePages })=>HelpCenterManagePages), {
        moduleId: "./packages/admin-layout/src/ui/manage-pages/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $a69307865bd1835d$var$AsyncHubEditLayoutComponent = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("4Nntd")).then(({ HubEditLayout: HubEditLayout })=>HubEditLayout), {
        ssr: false,
        moduleId: "./packages/admin-layout/src/ui/hub-edit-layout/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cjn3r.default), null)
});
const $a69307865bd1835d$export$8c1389d3983434c = {
    name: 'edit-details',
    path: '/:helpcenterId/details',
    exact: true,
    component: (0, $bDnSZ.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bsPHj.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($a69307865bd1835d$var$AsyncHelpCenterEditDetailsPage, null)))
};
const $a69307865bd1835d$export$5fae61522b3dcb33 = {
    name: 'manage-projects',
    path: '/:helpcenterId/projects',
    exact: true,
    component: (0, $bDnSZ.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bsPHj.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($a69307865bd1835d$var$AsyncHelpCenterManageProjectsPage, null)))
};
const $a69307865bd1835d$export$d1e5a4952efbcb = {
    name: 'manage-pages',
    path: '/:helpcenterId/pages',
    exact: true,
    component: (0, $bDnSZ.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bsPHj.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($a69307865bd1835d$var$AsyncHelpCenterManageCustomPagesPage, null)))
};
const $a69307865bd1835d$export$8f54556241df66cd = {
    name: 'edit-hub',
    path: '/:helpcenterId/edit-hub/:pageId?',
    exact: true,
    resources: [
        (0, $48p10.EditLayoutResource)
    ],
    component: (0, $bDnSZ.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bsPHj.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($a69307865bd1835d$var$AsyncHubEditLayoutComponent, null)))
};
const $a69307865bd1835d$export$b97f195684a7c2a4 = {
    name: 'edit-hub-portal',
    path: '/:helpcenterId/edit-hub/portal/:portalId',
    exact: true,
    resources: [
        (0, $48p10.EditLayoutResource)
    ],
    component: (0, $bDnSZ.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bsPHj.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($a69307865bd1835d$var$AsyncHubEditLayoutComponent, null)))
};

});
parcelRegister("bsPHj", function(module, exports) {
$parcel$export(module.exports, "JiraAdminPermissionWrapper", () => $62598d39ce19b60b$export$6061a3ec828d7435);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $hxVai = parcelRequire("hxVai");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("chjsC");
var $h2NCY = parcelRequire("h2NCY");
parcelRequire("i2Zru");
var $jBIAB = parcelRequire("jBIAB");

var $1nQ48 = parcelRequire("1nQ48");
const $62598d39ce19b60b$export$6061a3ec828d7435 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const WrappedComponent = (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: '/'
    }), (0, $h2NCY.default)({
        message: formatMessage((0, $1nQ48.authPageMessage)),
        callToActionText: formatMessage((0, $1nQ48.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>(0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).Children.only(children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, null);
};

});

parcelRegister("48p10", function(module, exports) {
$parcel$export(module.exports, "EditLayoutResource", () => $c32dcceceaa3c372$export$e44f9c093dbfbb53);

var $jByYr = parcelRequire("jByYr");

var $cLmLE = parcelRequire("cLmLE");
var $78eL2 = parcelRequire("78eL2");

var $1EFS8 = parcelRequire("1EFS8");

var $AGp7W = parcelRequire("AGp7W");

var $byuiX = parcelRequire("byuiX");

var $4f7O4 = parcelRequire("4f7O4");
const $c32dcceceaa3c372$export$f170ab873a147b4a = (match)=>{
    if ((0, $1EFS8.default).checkGate('portal-pages-in-hub')) {
        const portalId = match.params.portalId;
        if (portalId) return `portal_page-${portalId}`;
    }
    return match.params.pageId || '';
};
const $c32dcceceaa3c372$export$e44f9c093dbfbb53 = (0, $byuiX.createRelayResource)({
    type: 'EDIT_HUB_LAYOUT',
    getQuery: ({ match: match }, { cloudId: cloudId })=>{
        const activationId = (0, $jByYr.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const pageId = $c32dcceceaa3c372$export$f170ab873a147b4a(match);
        const computedHelpCenterAri = (0, $cLmLE.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        const resolvedPageId = pageId || helpCenterId;
        const computedPageAri = (0, $AGp7W.isPortalPage)(resolvedPageId) && helpCenterId ? (0, $AGp7W.buildPortalPageAri)(computedHelpCenterAri, resolvedPageId) : (0, $78eL2.HelpPageAri).create({
            activationId: activationId,
            pageId: resolvedPageId
        }).toString();
        return {
            parameters: (0, $4f7O4.default),
            variables: {
                cloudId: cloudId,
                hubAri: computedHelpCenterAri,
                hubEditMode: true,
                pageAri: computedPageAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("4f7O4", function(module, exports) {
$parcel$export(module.exports, "default", () => $6806cb12d1719b0b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<19743b9bf4881a52ce7574b697eda8c1>>
 * @relayHash 2972445b293d20a2b7ef6c3fdc36e944
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ecd72218165d9950115e3dc67fa246d6c6f38d00bab249cfaa845691d82984b

var $8iTFq = parcelRequire("8iTFq");
const $6806cb12d1719b0b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubEditMode"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v10 = {
        "concreteType": "HelpCenterNavigationBar",
        "kind": "LinkedField",
        "name": "navigationBar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "backgroundColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderType"
            },
            {
                "kind": "ScalarField",
                "name": "cornerRadius"
            },
            {
                "kind": "ScalarField",
                "name": "padding"
            },
            {
                "kind": "ScalarField",
                "name": "positionType"
            },
            {
                "kind": "ScalarField",
                "name": "textColor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        {
            "concreteType": "HelpCenterPageDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": v9 /*: any*/ 
        }
    ], v14 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "asapIssuer"
        },
        {
            "kind": "ScalarField",
            "name": "mediaCollectionName"
        },
        {
            "kind": "ScalarField",
            "name": "mediaToken"
        },
        {
            "kind": "ScalarField",
            "name": "mediaUrl"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "hubAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hoistedProjectKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": v9 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "allPages",
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": v13 /*: any*/ 
                                        },
                                        {
                                            "alias": "customPages",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "ids": [],
                                                        "type": "CUSTOM"
                                                    }
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": v13 /*: any*/ ,
                                            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "alias": "currentPage",
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "items": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "ids.0",
                                                                    "variableName": "pageAri"
                                                                }
                                                            ],
                                                            "kind": "ListValue",
                                                            "name": "ids"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "filter"
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterPageLayout",
                                                    "kind": "LinkedField",
                                                    "name": "pageLayout",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterLayoutAdf",
                                                            "kind": "LinkedField",
                                                            "name": "layoutAdf",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterLayoutAdfContentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpCenterLayoutAdfContentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpCenterLayoutAdfContent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "content"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v11 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "hubAri"
                                },
                                v14 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v15 /*: any*/ 
                        },
                        {
                            "alias": "pageMediaConfig",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "pageAri"
                                },
                                v14 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v15 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "hubEditMode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cloudUrl"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1ecd72218165d9950115e3dc67fa246d6c6f38d00bab249cfaa845691d82984b",
            "metadata": {},
            "name": "hubHomeContentWrapperQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6806cb12d1719b0b$var$node.hash = "1c2d5375a6eed0be7946bf9ea8b3a704";
(0, $8iTFq.PreloadableQueryRegistry).set($6806cb12d1719b0b$var$node.params.id, $6806cb12d1719b0b$var$node);
var $6806cb12d1719b0b$export$2e2bcd8739ae039 = $6806cb12d1719b0b$var$node;

});


parcelRegister("gaYiV", function(module, exports) {
$parcel$export(module.exports, "HelpCenterEditDetails", () => (parcelRequire("ivwEF")).default);

var $ivwEF = parcelRequire("ivwEF");

});
parcelRegister("ivwEF", function(module, exports) {
$parcel$export(module.exports, "default", () => $b163d93886c13b99$export$2e2bcd8739ae039);

var $ghqka = parcelRequire("ghqka");

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $edC7N = parcelRequire("edC7N");

var $jByYr = parcelRequire("jByYr");

var $3ZeMI = parcelRequire("3ZeMI");

var $1We2B = parcelRequire("1We2B");

var $5jYgE = parcelRequire("5jYgE");

var $h3cOB = parcelRequire("h3cOB");

var $8gu7I = parcelRequire("8gu7I");
var $MmGmU = parcelRequire("MmGmU");
var $eS4yu = parcelRequire("eS4yu");

var $6Bfdg = parcelRequire("6Bfdg");

var $6Hfjm = parcelRequire("6Hfjm");
var $55x6k = parcelRequire("55x6k");
var $2IKBM = parcelRequire("2IKBM");
parcelRequire("6bvX1");
var $i3cng = parcelRequire("i3cng");
var $dSz79 = parcelRequire("dSz79");
parcelRequire("2xFxw");
var $gRzNN = parcelRequire("gRzNN");

var $bQ8UI = parcelRequire("bQ8UI");
var $17wqU = parcelRequire("17wqU");

var $iziiq = parcelRequire("iziiq");

var $aQXm8 = parcelRequire("aQXm8");

var $klz3F = parcelRequire("klz3F");

var $dfS0m = parcelRequire("dfS0m");
var $8y0tS = parcelRequire("8y0tS");
parcelRequire("3FcbN");
var $kqdcj = parcelRequire("kqdcj");
parcelRequire("7wQOO");
var $lJAIJ = parcelRequire("lJAIJ");

var $hfRtk = parcelRequire("hfRtk");

var $iYuXv = parcelRequire("iYuXv");
const $b163d93886c13b99$var$HelpCenterEditDetailsComponent = ()=>{
    var _data$helpCenter, _data$helpCenter2, _data$helpCenter3;
    const cloudId = (0, $jByYr.getCloudId)();
    const helpCenterAri = (0, $dSz79.useHelpCenterAri)();
    const data = (0, $h3cOB.useLazyLoadQuery)((0, $ghqka.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const helpCenter = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const { name: name, slug: slug, id: id } = helpCenter ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $bQ8UI.ContextWrapper), {
        sourceName: (0, $8rTkC.ScreenName).EDIT_HELP_CENTER,
        sourceType: (0, $17wqU.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), null, (data === null || data === void 0 || (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.helpCenterById) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gRzNN.default), {
        helpCenterData: (_data$helpCenter3 = data.helpCenter) === null || _data$helpCenter3 === void 0 ? void 0 : _data$helpCenter3.helpCenterById
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $kqdcj.default), {
        helpCenterToEdit: {
            translations: name && name.translations ? name.translations.map((translation)=>({
                    value: (translation === null || translation === void 0 ? void 0 : translation.value) ?? '',
                    locale: (translation === null || translation === void 0 ? void 0 : translation.locale) ?? ''
                })) : [],
            slug: slug ?? '',
            name: (name === null || name === void 0 ? void 0 : name.default) ?? '',
            ari: id ?? ''
        },
        isStandaloneForm: true,
        isOpen: true,
        onClose: (0, $1We2B.noop)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $dfS0m.ExperienceSuccess), {
        experience: (0, $hfRtk.editHelpCenterExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aQXm8.FireScreenEventOnMount), null));
};
const $b163d93886c13b99$export$613b634f86450035 = ()=>{
    (0, $8y0tS.useUFOComponentExperience)((0, $hfRtk.editHelpCenterExperience));
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const onError = (error)=>{
        if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) {
            (0, $hfRtk.editHelpCenterExperience).failure({
                metadata: {
                    error: error === null || error === void 0 ? void 0 : error.message,
                    statusCode: error === null || error === void 0 ? void 0 : error.status
                }
            }).then((0, $1We2B.noop)).catch((0, $1We2B.noop));
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'fetch_failed',
                actionSubject: 'helpCenterDetails',
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                errorStatus: error === null || error === void 0 ? void 0 : error.status
            }).fire();
        }
    };
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Bfdg.default), {
            header: formatMessage((0, $iYuXv.default).errorTitle),
            description: formatMessage((0, $iYuXv.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3ZeMI)))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $i3cng.default), {
        featureName: "Helpcenter settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $edC7N.default), {
        packageName: (0, $8rTkC.ScreenName).EDIT_HELP_CENTER,
        id: 'help-center-edit-details',
        renderError: renderError,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            attributes: {
                workspaceAri: (0, $jByYr.getWorkspaceAri)()
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $55x6k.default), {
        templateColumns: "1fr 2fr 1fr",
        rowGap: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8P7DW.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $lJAIJ.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($b163d93886c13b99$var$HelpCenterEditDetailsComponent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null)))));
};
var $b163d93886c13b99$export$2e2bcd8739ae039 = (0, $eS4yu.default)({
    component: 'helpCenterEditDetails'
})($b163d93886c13b99$export$613b634f86450035);

});
parcelRegister("ghqka", function(module, exports) {
$parcel$export(module.exports, "default", () => $7869178c6e107100$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d5ec8b941e6601c36894fc1100ab9d58>>
 * @relayHash efdc5420deee34a8cc05fb680adbe347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b0a8c16e933459da97d8638f8b061a4a77543af7666f2d03b73dfac583090f0
const $7869178c6e107100$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "default"
            },
            {
                "concreteType": "HelpCenterTranslation",
                "kind": "LinkedField",
                "name": "translations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "locale"
                    }
                ]
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "slug"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHelpCenter_getHelpcenterById_Query",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "settingsBreadcrumbsFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHelpCenter_getHelpcenterById_Query",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7b0a8c16e933459da97d8638f8b061a4a77543af7666f2d03b73dfac583090f0",
            "metadata": {},
            "name": "editHelpCenter_getHelpcenterById_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7869178c6e107100$var$node.hash = "52e3cc7f44c0936e01ed59dd9c996799";
var $7869178c6e107100$export$2e2bcd8739ae039 = $7869178c6e107100$var$node;

});

parcelRegister("3FcbN", function(module, exports) {
$parcel$export(module.exports, "HelpCenterForm", () => (parcelRequire("kqdcj")).default);

var $kqdcj = parcelRequire("kqdcj");

});
parcelRegister("kqdcj", function(module, exports) {
$parcel$export(module.exports, "default", () => $39cd17f27c85b811$export$2e2bcd8739ae039);
/* help-center-form.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8n1kL = parcelRequire("8n1kL");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $8y05I = parcelRequire("8y05I");

var $HGACo = parcelRequire("HGACo");

var $6p5HB = parcelRequire("6p5HB");

var $jByYr = parcelRequire("jByYr");

var $9IawA = parcelRequire("9IawA");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");

var $8gu7I = parcelRequire("8gu7I");
var $MmGmU = parcelRequire("MmGmU");
var $eS4yu = parcelRequire("eS4yu");

var $iRXci = parcelRequire("iRXci");
var $jsz0v = parcelRequire("jsz0v");

var $iqJis = parcelRequire("iqJis");

var $b9hQ0 = parcelRequire("b9hQ0");

var $gtaKc = parcelRequire("gtaKc");
var $7KiOn = parcelRequire("7KiOn");
var $fCWQD = parcelRequire("fCWQD");
var $9euwv = parcelRequire("9euwv");
var $gMGo9 = parcelRequire("gMGo9");
var $33zHl = parcelRequire("33zHl");

var $6Hfjm = parcelRequire("6Hfjm");
var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");
parcelRequire("6bvX1");
var $Jhmxx = parcelRequire("Jhmxx");

var $iziiq = parcelRequire("iziiq");

var $cLmLE = parcelRequire("cLmLE");

var $9ypa9 = parcelRequire("9ypa9");

var $hrPHR = parcelRequire("hrPHR");

var $klz3F = parcelRequire("klz3F");

var $bX6HN = parcelRequire("bX6HN");
parcelRequire("49b11");
var $caTII = parcelRequire("caTII");

var $6B6mQ = parcelRequire("6B6mQ");
parcelRequire("90sv0");
var $hMgHi = parcelRequire("hMgHi");
parcelRequire("eoruB");
var $aeY1I = parcelRequire("aeY1I");

var $AuJCb = parcelRequire("AuJCb");
const $39cd17f27c85b811$var$MODAL_WIDTH = '506px';
const $39cd17f27c85b811$var$HelpCenterForm = ({ onClose: onClose, isOpen: isOpen, helpCenterToEdit: helpCenterToEdit, isStandaloneForm: isStandaloneForm = false, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { createHelpCenter: createHelpCenter, updateHelpCenter: updateHelpCenter } = (0, $caTII.useHelpCenter)();
    const displayUrl = (0, $hrPHR.getEnv)().baseUrl.replace(/^https?:\/\//i, '');
    const { slug: slug, name: name } = helpCenterToEdit || {};
    const detailsDescription = (0, $Jhmxx.useConditionalMessage)((0, $AuJCb.default).helpHubDetailsPageDescription, (0, $AuJCb.default).helpCenterDetailsPageDescription);
    const { push: push } = (0, $dKPjT.useRouterActions)();
    const successFlagAction = (0, $8P7DW.useCallback)((helpCenterSlug)=>[
            {
                contentNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("a", {
                    href: `${(0, $hrPHR.getEnv)().baseUrl}/helpcenter/${helpCenterSlug}`
                }, formatMessage((0, $AuJCb.default).helpCenterAddSuccessDesc))
            }
        ], [
        formatMessage
    ]);
    const onCreate = (0, $8P7DW.useCallback)(({ helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug })=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6B6mQ.addHelpCenterExperience).start();
        return createHelpCenter({
            helpCenterName: helpCenterName,
            helpCenterSlug: helpCenterSlug
        }).then((response)=>{
            var _response$helpCenter;
            createAnalyticsEvent({
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'created',
                actionSubject: 'helpCenter',
                helpCenterAri: (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 || (_response$helpCenter = _response$helpCenter.createHelpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterAri
            }).fire();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $6B6mQ.addHelpCenterExperience).success();
            onClose();
            if ((0, $HGACo.isProjectMappingInHelpCenterEnabled)()) setTimeout(()=>{
                var _response$helpCenter2;
                showSuccessFlagAction((0, $AuJCb.default).helpCenterAddSuccessTitleText, {
                    value: helpCenterName
                }, undefined, successFlagAction(helpCenterSlug));
                const helpCenterAri = (_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.createHelpCenter) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.helpCenterAri;
                const { helpCenterId: helpCenterId } = (0, $cLmLE.HelpHelpCenterAri).parse(helpCenterAri || '');
                push(`/${helpCenterId}/projects`);
            }, 1000);
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (message === (0, $bX6HN.HARD_LIMIT_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $AuJCb.default).helpCenterHardLimitErrorTitle, (0, $AuJCb.default).helpCenterHardLimitErrorDescription, undefined, undefined, {
                value: message
            });
            else if (message === (0, $bX6HN.RESERVED_TERM_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $AuJCb.default).helpCenterAddErrorTitle, (0, $AuJCb.default).helpCenterReservedSlugErrorDescription);
            else if (message === (0, $bX6HN.ALREADY_EXISTED_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $AuJCb.default).helpCenterAddErrorTitle, (0, $AuJCb.default).helpCenterAlreadyExistedSlugErrorDescription);
            else showErrorFlagAction((0, $AuJCb.default).helpCenterAddErrorTitle, (0, $AuJCb.default).helpCenterGenericErrorDesc);
            if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) {
                createAnalyticsEvent({
                    analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                    action: 'create_failed',
                    actionSubject: 'helpCenter',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
                return (0, $6B6mQ.addHelpCenterExperience).failure({
                    metadata: {
                        error: (0, $9ypa9.getErrorData)(message)
                    }
                });
            }
            return (0, $6B6mQ.addHelpCenterExperience).success();
        });
    }, [
        createAnalyticsEvent,
        createHelpCenter,
        onClose,
        push,
        showErrorFlagAction,
        showSuccessFlagAction,
        successFlagAction
    ]);
    const onEdit = (0, $8P7DW.useCallback)(({ helpCenterName: helpCenterName, helpCenterTranslations: helpCenterTranslations, helpCenterSlug: helpCenterSlug, helpCenterAri: helpCenterAri })=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6B6mQ.updateHelpCenterExperience).start();
        return updateHelpCenter({
            helpCenterAri: helpCenterAri,
            helpCenterName: helpCenterName,
            helpCenterTranslations: helpCenterTranslations,
            helpCenterSlug: helpCenterSlug
        }).then(()=>{
            createAnalyticsEvent({
                helpCenterAri: helpCenterAri,
                analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                action: 'updated',
                actionSubject: 'helpCenter'
            }).fire();
            showSuccessFlagAction((0, $AuJCb.default).helpCenterUpdateSuccessTitleText, {
                value: helpCenterName ? helpCenterName : name
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $6B6mQ.updateHelpCenterExperience).success();
            if (isStandaloneForm) push('/');
            else onClose();
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (message === (0, $bX6HN.RESERVED_TERM_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $AuJCb.default).helpCenterUpdateErrorTitle, (0, $AuJCb.default).helpCenterReservedSlugErrorDescription);
            else if (message === (0, $bX6HN.ALREADY_EXISTED_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $AuJCb.default).helpCenterUpdateErrorTitle, (0, $AuJCb.default).helpCenterAlreadyExistedSlugErrorDescription);
            else showErrorFlagAction((0, $AuJCb.default).helpCenterUpdateErrorTitle, (0, $AuJCb.default).helpCenterGenericErrorDesc);
            if (!(0, $klz3F.isFetchNetworkOrClientError)(error)) {
                createAnalyticsEvent({
                    helpCenterAri: helpCenterAri,
                    analyticsType: (0, $iziiq.TRACK_EVENT_TYPE),
                    action: 'update_failed',
                    actionSubject: 'helpCenter',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
                return (0, $6B6mQ.updateHelpCenterExperience).failure({
                    metadata: {
                        error: (0, $9ypa9.getErrorData)(message)
                    }
                });
            }
            return (0, $6B6mQ.updateHelpCenterExperience).success();
        });
    }, [
        createAnalyticsEvent,
        name,
        isStandaloneForm,
        onClose,
        push,
        showErrorFlagAction,
        showSuccessFlagAction,
        updateHelpCenter
    ]);
    const onSubmit = (0, $8P7DW.useCallback)((data)=>{
        const { name: helpCenterName, slug: helpCenterSlug } = data;
        if (!helpCenterToEdit) return onCreate({
            helpCenterName: helpCenterName,
            helpCenterSlug: helpCenterSlug
        });
        const { ari: ari, translations: translations } = helpCenterToEdit;
        return onEdit({
            helpCenterName: helpCenterName !== name ? helpCenterName : undefined,
            helpCenterSlug: helpCenterSlug !== slug ? helpCenterSlug : undefined,
            helpCenterAri: ari,
            helpCenterTranslations: translations
        });
    }, [
        helpCenterToEdit,
        name,
        onCreate,
        onEdit,
        slug
    ]);
    // used in settings page without a modal
    if (isStandaloneForm) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iRXci.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, dirty: dirty, submitting: submitting, reset: reset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
            space: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iqJis.default), {
            size: "large"
        }, formatMessage((0, $AuJCb.default).helpCenterDetailsPageTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, slug ? formatMessage(detailsDescription) : formatMessage((0, $AuJCb.default).defaultHelpCenterDetailsPageDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            paddingBlock: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), null, formatMessage((0, $AuJCb.default).helpCenterRequiredFieldsWarning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jsz0v.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hMgHi.HelpCenterFormFields), {
            mode: "EDIT",
            name: name,
            slug: slug,
            urlWithoutSlug: `${window.location.hostname}/helpcenter`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aeY1I.HelpCenterFormFooter), {
            mode: "EDIT",
            isStandaloneForm: true,
            isCancelDisabled: !dirty,
            submitting: submitting,
            onCancel: ()=>reset({
                    name: name ?? '',
                    slug: slug ?? ''
                })
        })));
    // TODO clean this up when enable_project_mapping_for_help_center is cleaned up.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $33zHl.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8gu7I.default), {
        data: {
            attributes: {
                workspaceAri: (0, $jByYr.getWorkspaceAri)()
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gtaKc.default), {
        onClose: onClose,
        width: $39cd17f27c85b811$var$MODAL_WIDTH,
        testId: "help-centers-management-form-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $iRXci.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($39cd17f27c85b811$var$HelpForm, formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9euwv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gMGo9.default), {
            testId: "help-centers-management-modal-title"
        }, formatMessage(!helpCenterToEdit ? (0, $AuJCb.default).helpCenterCreateFormTitle : (0, $AuJCb.default).helpCenterEditFormTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.Button), {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
            "aria-label": "Cancel create dialog",
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b9hQ0))), {
                spacing: "spacious",
                label: "cancel create dialog"
            }),
            onClick: onClose,
            actionSubjectId: "helpCenterCreateDialogCancelButton"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7KiOn.default), null, !helpCenterToEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($39cd17f27c85b811$var$DescriptionWrapper, null, formatMessage((0, $AuJCb.default).helpCenterCreateFormDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $hMgHi.HelpCenterFormFields), {
            mode: !helpCenterToEdit ? 'CREATE' : 'EDIT',
            name: name,
            slug: slug,
            urlWithoutSlug: `${displayUrl}/helpcenter`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fCWQD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $aeY1I.HelpCenterFormFooter), {
            submitting: submitting,
            onCancel: onClose,
            mode: helpCenterToEdit ? 'EDIT' : 'CREATE'
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9IawA.default), {
        preventNavigation: isOpen
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $39cd17f27c85b811$var$DescriptionWrapper = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_otyrv47k",
            __cmplp.className
        ])
    });
});
const $39cd17f27c85b811$var$HelpForm = /*#__PURE__*/ (0, $8P7DW.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $8n1kL.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});
var $39cd17f27c85b811$export$2e2bcd8739ae039 = (0, $jvoWT.default)(null, {
    showErrorFlag: $6p5HB.showErrorFlag,
    showSuccessFlag: $6p5HB.showSuccessFlag
})((0, $eS4yu.default)({
    component: 'helpCenterForm'
})($39cd17f27c85b811$var$HelpCenterForm));

});
parcelRegister("9IawA", function(module, exports) {
$parcel$export(module.exports, "default", () => $6069b73ae3208cf2$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $l4a5B = parcelRequire("l4a5B");

var $6GNhI = parcelRequire("6GNhI");

var $iTxP6 = parcelRequire("iTxP6");

var $4u4fX = parcelRequire("4u4fX");
class $6069b73ae3208cf2$export$5e156bf0bd6195af extends $8P7DW.PureComponent {
    componentDidMount() {
        if (this.props.preventNavigation) this.blockNavigation();
    }
    componentWillUnmount() {
        if (this.props.preventNavigation) this.allowNavigation();
    }
    componentDidUpdate(prevProps) {
        const { preventNavigation: preventNavigation } = this.props;
        if (preventNavigation && !prevProps.preventNavigation) this.blockNavigation();
        else if (!preventNavigation && prevProps.preventNavigation) this.allowNavigation();
    }
    render() {
        const { preventNavigation: preventNavigation, onBeforeNavigate: onBeforeNavigate } = this.props;
        return /*#__PURE__*/ $8P7DW.createElement((0, $4u4fX.default), {
            when: preventNavigation,
            message: this.checkCanNavigate,
            onBeforeNavigate: onBeforeNavigate
        });
    }
    constructor(...args){
        super(...args), this.checkCanNavigate = (routerLocation)=>{
            // This will cause the prompt to not prevent navigation if a "q" was, or is, going to be in the location search property.
            // Because we do that it will fail to prevent accidental navigation if interacting with the back button,
            // or pressing backspace/delete. We have another issue to pick up to make this better.
            // See: https://jdog.jira-dev.com/browse/FSD-3235
            const containsSearchQueryParam = (str)=>str.includes('q=');
            if (containsSearchQueryParam(routerLocation.search) || containsSearchQueryParam((0, $6GNhI.location)().search)) return true;
            /**
     * Do not show prevent navigation prompt for allowed paths
     */ const { allowedPaths: allowedPaths } = this.props;
            const { pathname: pathname } = routerLocation;
            if (allowedPaths) for (const pathRegExp of allowedPaths){
                if (pathname.match(pathRegExp)) return true;
            }
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $iTxP6.default).navigationWarning);
        }, this.onBeforeUnload = (event)=>{
            // Prompts the user before closing the page, see:
            // https://developer.mozilla.org/en-US/docs/Web/Events/beforeunload
            event.preventDefault();
            event.returnValue = '';
        }, this.blockNavigation = ()=>{
            window.addEventListener('beforeunload', this.onBeforeUnload);
        }, this.allowNavigation = ()=>{
            window.removeEventListener('beforeunload', this.onBeforeUnload);
        };
    }
}
var $6069b73ae3208cf2$export$2e2bcd8739ae039 = (0, $l4a5B.default)($6069b73ae3208cf2$export$5e156bf0bd6195af);

});
parcelRegister("iTxP6", function(module, exports) {
$parcel$export(module.exports, "default", () => $587fe7bb02f22ab0$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $587fe7bb02f22ab0$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    navigationWarning: {
        defaultMessage: 'You have unsubmitted changes. Are you sure you want to leave?',
        description: 'Messsage shown to users when they navigate away from a form that has been filled out.',
        id: 'cv.navigation.prompt.warning'
    }
});

});

parcelRegister("4u4fX", function(module, exports) {
$parcel$export(module.exports, "default", () => $411af75e5b064cb7$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("9wocP");
var $dKPjT = parcelRequire("dKPjT");
const $411af75e5b064cb7$var$NavBlocker = ({ when: when, message: message, onBeforeNavigate: onBeforeNavigate })=>{
    const { registerBlock: registerBlock } = (0, $dKPjT.useRouterActions)();
    (0, $8P7DW.useEffect)(()=>{
        const unRegisterBlock = registerBlock((location)=>{
            if (!when) return true;
            const result = message(location);
            if (typeof result === 'boolean') return result;
            //RRR doesn't support async block, so we cannot use our custom dialog here.
            //We need to fallback to using browser's confirm like react-router's prompt.
            // oxlint-disable-next-line no-alert
            const confirmation = window.confirm(result);
            if (confirmation && onBeforeNavigate) onBeforeNavigate(location);
            return confirmation;
        });
        return unRegisterBlock;
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        registerBlock,
        when
    ]);
    return null;
};
var $411af75e5b064cb7$export$2e2bcd8739ae039 = $411af75e5b064cb7$var$NavBlocker;

});


parcelRegister("bX6HN", function(module, exports) {
$parcel$export(module.exports, "BANNER_PREVIEW_WIDTH", () => $d46e96529618dd91$export$69656aaf76d15223);
$parcel$export(module.exports, "CARD_HEIGHT", () => $d46e96529618dd91$export$17f5f15729f028ea);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $d46e96529618dd91$export$780035d9fe48eb32);
$parcel$export(module.exports, "HELPCENTER_NAME_CHARACTER_LIMIT", () => $d46e96529618dd91$export$60a11b99c333dc54);
$parcel$export(module.exports, "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH", () => $d46e96529618dd91$export$434ed9a0808b5e5e);
$parcel$export(module.exports, "NUMBER_OF_HELP_CENTERS_PER_FETCH", () => $d46e96529618dd91$export$81026eacb893b971);
$parcel$export(module.exports, "SORT_ORDER", () => $d46e96529618dd91$export$d33cb9b119034d29);
$parcel$export(module.exports, "HARD_LIMIT_HELP_CENTERS_MESSAGE", () => $d46e96529618dd91$export$2426c5658dae9870);
$parcel$export(module.exports, "RESERVED_TERM_HELP_CENTERS_MESSAGE", () => $d46e96529618dd91$export$b7e744b1154b89ed);
$parcel$export(module.exports, "ALREADY_EXISTED_HELP_CENTERS_MESSAGE", () => $d46e96529618dd91$export$20efc88db71ca642);
$parcel$export(module.exports, "HARD_LIMIT_HELP_HUBS_MESSAGE", () => $d46e96529618dd91$export$78070db85cc402de);
$parcel$export(module.exports, "ALREADY_EXISTED_HELP_HUBS_MESSAGE", () => $d46e96529618dd91$export$c69b1c1edc5fccb0);
const $d46e96529618dd91$export$69656aaf76d15223 = '170px';
const $d46e96529618dd91$export$17f5f15729f028ea = '176px';
const $d46e96529618dd91$export$780035d9fe48eb32 = 240;
const $d46e96529618dd91$export$60a11b99c333dc54 = 30;
const $d46e96529618dd91$export$434ed9a0808b5e5e = 20;
const $d46e96529618dd91$export$81026eacb893b971 = 10;
const $d46e96529618dd91$export$d33cb9b119034d29 = 'CREATED_DATE_DESCENDING';
const $d46e96529618dd91$export$2426c5658dae9870 = 'This operation is not supported : Help Center limit exceeded';
const $d46e96529618dd91$export$b7e744b1154b89ed = `The slug you've entered contains a reserved term. Try again with a different slug.`;
const $d46e96529618dd91$export$20efc88db71ca642 = `A help center with this slug already exists on your site. Try again with a different slug.`;
const $d46e96529618dd91$export$78070db85cc402de = 'This operation is not supported : Help Hub limit exceeded';
const $d46e96529618dd91$export$c69b1c1edc5fccb0 = `A help hub with this slug already exists on your site. Try again with a different slug.`;

});

parcelRegister("49b11", function(module, exports) {
$parcel$export(module.exports, "useHelpCenter", () => (parcelRequire("caTII")).useHelpCenter);

var $caTII = parcelRequire("caTII");

});
parcelRegister("caTII", function(module, exports) {
$parcel$export(module.exports, "useHelpCenter", () => $ca13a3941ed23745$export$4545b8e2508a7415);

var $gmjEY = parcelRequire("gmjEY");

var $e0thG = parcelRequire("e0thG");

var $8WEyo = parcelRequire("8WEyo");

var $8P7DW = parcelRequire("8P7DW");

var $8rTkC = parcelRequire("8rTkC");

var $jByYr = parcelRequire("jByYr");

var $h3cOB = parcelRequire("h3cOB");

var $8iTFq = parcelRequire("8iTFq");

var $hrPHR = parcelRequire("hrPHR");
const $ca13a3941ed23745$export$4545b8e2508a7415 = ()=>{
    const cloudId = (0, $jByYr.getCloudId)();
    const workspaceAri = (0, $jByYr.getWorkspaceAri)();
    const [helpCenterCreateMutation] = (0, $h3cOB.useMutation)((0, $8WEyo.default));
    const [helpCenterUpdateMutation] = (0, $h3cOB.useMutation)((0, $e0thG.default));
    const [helpCenterDeleteMutation] = (0, $h3cOB.useMutation)((0, $gmjEY.default));
    const getHelpCenter = (0, $8P7DW.useCallback)((store)=>{
        const root = store.getRoot();
        const helpCenter = root.getLinkedRecord('helpCenter', {
            cloudId: cloudId
        });
        return helpCenter;
    }, [
        cloudId
    ]);
    const getHelpCenterList = (0, $8P7DW.useCallback)((store)=>{
        const helpCenter = getHelpCenter(store);
        if (helpCenter !== null && helpCenter !== void 0 && helpCenter.getDataID()) {
            const parent = store.get(helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.getDataID());
            if (parent) return (0, $8iTFq.ConnectionHandler).getConnection(parent, 'helpCentersManagementPageFragment_helpCenters');
        }
        return null;
    }, [
        getHelpCenter
    ]);
    const getHelpCenters = (0, $8P7DW.useCallback)((store)=>{
        const helpCenter = getHelpCenter(store);
        if (helpCenter !== null && helpCenter !== void 0 && helpCenter.getDataID()) {
            var _ConnectionHandler$ge;
            const parent = store.get(helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.getDataID());
            if (parent) return (_ConnectionHandler$ge = (0, $8iTFq.ConnectionHandler).getConnection(parent, 'helpCentersManagementPageFragment_helpCenters')) === null || _ConnectionHandler$ge === void 0 ? void 0 : _ConnectionHandler$ge.getLinkedRecords('edges');
        }
        return null;
    }, [
        getHelpCenter
    ]);
    const deleteHelpCenter = (0, $8P7DW.useCallback)(({ helpCenterAri: helpCenterAri })=>{
        return new Promise((resolve, reject)=>helpCenterDeleteMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter;
                    if (response !== null && response !== void 0 && (_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.deleteHelpCenter) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) {
                        const helpCenters = getHelpCenters(store);
                        const helpCentersList = getHelpCenterList(store);
                        if (helpCenters && helpCentersList) {
                            const updatedHelpCenters = [
                                ...helpCenters.filter((helpCenterRecord)=>{
                                    const node = helpCenterRecord.getLinkedRecord('node');
                                    return (node === null || node === void 0 ? void 0 : node.getValue('id')) !== helpCenterAri;
                                })
                            ];
                            helpCentersList === null || helpCentersList === void 0 || helpCentersList.setLinkedRecords(updatedHelpCenters, 'edges');
                        }
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter2, _response$helpCenter3;
                    if ((_response$helpCenter2 = response.helpCenter) !== null && _response$helpCenter2 !== void 0 && (_response$helpCenter2 = _response$helpCenter2.deleteHelpCenter) !== null && _response$helpCenter2 !== void 0 && _response$helpCenter2.success) return resolve(response);
                    const errors = (_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.deleteHelpCenter) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {};
                    return reject(error);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenterList,
        getHelpCenters,
        helpCenterDeleteMutation
    ]);
    const createHelpCenter = (0, $8P7DW.useCallback)(({ helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug, helpCenterType: helpCenterType, projectMapping: projectMapping, rovoConfig: rovoConfig })=>{
        return new Promise((resolve, reject)=>helpCenterCreateMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterType: helpCenterType,
                        projectMapping: projectMapping,
                        rovoConfig: rovoConfig,
                        workspaceARI: workspaceAri,
                        name: {
                            default: helpCenterName,
                            translations: [
                                {
                                    locale: (0, $hrPHR.getEnv)().siteDefaultLanguageTag,
                                    value: helpCenterName
                                }
                            ]
                        },
                        slug: helpCenterSlug
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter4, _response$helpCenter5;
                    if (response !== null && response !== void 0 && (_response$helpCenter4 = response.helpCenter) !== null && _response$helpCenter4 !== void 0 && (_response$helpCenter4 = _response$helpCenter4.createHelpCenter) !== null && _response$helpCenter4 !== void 0 && _response$helpCenter4.success && response !== null && response !== void 0 && (_response$helpCenter5 = response.helpCenter) !== null && _response$helpCenter5 !== void 0 && (_response$helpCenter5 = _response$helpCenter5.createHelpCenter) !== null && _response$helpCenter5 !== void 0 && _response$helpCenter5.helpCenterAri) {
                        var _response$helpCenter6;
                        const helpCenters = getHelpCenters(store);
                        const helpCenterList = getHelpCenterList(store);
                        const node = store.create((0, $8iTFq.generateUniqueClientID)(), 'node');
                        const helpCenterRecord = store.create((0, $8iTFq.generateUniqueClientID)(), 'HelpCenter');
                        const name = store.create((0, $8iTFq.generateUniqueClientID)(), 'HelpCenterName');
                        const branding = store.create((0, $8iTFq.generateUniqueClientID)(), 'HelpCenterBranding');
                        name.setValue(helpCenterName, 'default');
                        branding.setValue(true, 'useDefaultBanner');
                        helpCenterRecord.setLinkedRecord(name, 'name');
                        helpCenterRecord.setValue(helpCenterSlug, 'slug');
                        const date = new Date().toISOString();
                        helpCenterRecord === null || helpCenterRecord === void 0 || helpCenterRecord.setValue(date, 'lastUpdated');
                        helpCenterRecord.setValue((_response$helpCenter6 = response.helpCenter) === null || _response$helpCenter6 === void 0 || (_response$helpCenter6 = _response$helpCenter6.createHelpCenter) === null || _response$helpCenter6 === void 0 ? void 0 : _response$helpCenter6.helpCenterAri, 'id');
                        helpCenterRecord.setLinkedRecord(branding, 'helpCenterBranding');
                        node.setLinkedRecord(helpCenterRecord, 'node');
                        const updatedHelpCenters = [
                            node,
                            ...helpCenters ?? []
                        ];
                        if (helpCenters && helpCenterList) helpCenterList.setLinkedRecords(updatedHelpCenters, 'edges');
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter7, _response$helpCenter8, _error$extensions;
                    if ((_response$helpCenter7 = response.helpCenter) !== null && _response$helpCenter7 !== void 0 && (_response$helpCenter7 = _response$helpCenter7.createHelpCenter) !== null && _response$helpCenter7 !== void 0 && _response$helpCenter7.success) return resolve(response);
                    const errors = (_response$helpCenter8 = response.helpCenter) === null || _response$helpCenter8 === void 0 || (_response$helpCenter8 = _response$helpCenter8.createHelpCenter) === null || _response$helpCenter8 === void 0 ? void 0 : _response$helpCenter8.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $8rTkC.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenterList,
        getHelpCenters,
        helpCenterCreateMutation,
        workspaceAri
    ]);
    const updateHelpCenter = (0, $8P7DW.useCallback)(({ helpCenterAri: helpCenterAri, helpCenterTranslations: helpCenterTranslations, helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug })=>{
        return new Promise((resolve, reject)=>helpCenterUpdateMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri,
                        name: helpCenterName ? {
                            default: helpCenterName,
                            translations: helpCenterTranslations && helpCenterTranslations.length > 0 ? helpCenterTranslations.map((translations)=>{
                                if (translations.locale === (0, $hrPHR.getEnv)().siteDefaultLanguageTag) translations.value = helpCenterName;
                                return translations;
                            }) : [
                                {
                                    locale: (0, $hrPHR.getEnv)().siteDefaultLanguageTag,
                                    value: helpCenterName
                                }
                            ]
                        } : undefined,
                        slug: helpCenterSlug ? helpCenterSlug : undefined
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter9;
                    if (response !== null && response !== void 0 && (_response$helpCenter9 = response.helpCenter) !== null && _response$helpCenter9 !== void 0 && (_response$helpCenter9 = _response$helpCenter9.updateHelpCenter) !== null && _response$helpCenter9 !== void 0 && _response$helpCenter9.success) {
                        const helpCenters = getHelpCenters(store);
                        const currentHelpCenter = helpCenters === null || helpCenters === void 0 ? void 0 : helpCenters.find((helpCenter)=>{
                            const node = helpCenter.getLinkedRecord('node');
                            return (node === null || node === void 0 ? void 0 : node.getValue('id')) === helpCenterAri;
                        });
                        const currentHelpCenterNode = currentHelpCenter === null || currentHelpCenter === void 0 ? void 0 : currentHelpCenter.getLinkedRecord('node');
                        if (helpCenterName) {
                            const name = currentHelpCenterNode === null || currentHelpCenterNode === void 0 ? void 0 : currentHelpCenterNode.getLinkedRecord('name');
                            name === null || name === void 0 || name.setValue(helpCenterName, 'default');
                        }
                        if (helpCenterSlug) currentHelpCenterNode === null || currentHelpCenterNode === void 0 || currentHelpCenterNode.setValue(helpCenterSlug, 'slug');
                        const date = new Date().toISOString();
                        currentHelpCenterNode === null || currentHelpCenterNode === void 0 || currentHelpCenterNode.setValue(date, 'lastUpdated');
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter0, _response$helpCenter1, _error$extensions2;
                    if ((_response$helpCenter0 = response.helpCenter) !== null && _response$helpCenter0 !== void 0 && (_response$helpCenter0 = _response$helpCenter0.updateHelpCenter) !== null && _response$helpCenter0 !== void 0 && _response$helpCenter0.success) return resolve(response);
                    const errors = (_response$helpCenter1 = response.helpCenter) === null || _response$helpCenter1 === void 0 || (_response$helpCenter1 = _response$helpCenter1.updateHelpCenter) === null || _response$helpCenter1 === void 0 ? void 0 : _response$helpCenter1.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $8rTkC.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenters,
        helpCenterUpdateMutation
    ]);
    return {
        createHelpCenter: createHelpCenter,
        updateHelpCenter: updateHelpCenter,
        deleteHelpCenter: deleteHelpCenter
    };
};

});
parcelRegister("gmjEY", function(module, exports) {
$parcel$export(module.exports, "default", () => $564d589d34903c41$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5124256801d44a6d169f160743052cca>>
 * @relayHash fecf54055e7ebdf24f46943683e10daa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8
const $564d589d34903c41$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterDeletePayload",
                    "kind": "LinkedField",
                    "name": "deleteHelpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterDeleteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterDeleteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8",
            "metadata": {},
            "name": "useHelpCenterDeleteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$564d589d34903c41$var$node.hash = "7f1dd80d488ff1c4273819ebc7261544";
var $564d589d34903c41$export$2e2bcd8739ae039 = $564d589d34903c41$var$node;

});

parcelRegister("e0thG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c710b973cf4b297a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3533f3dc8b18459056d478f9aac42b99>>
 * @relayHash 760113b4d7a9d899532af7823cd6a3cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68
const $c710b973cf4b297a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68",
            "metadata": {},
            "name": "useHelpCenterUpdateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c710b973cf4b297a$var$node.hash = "162638a77ba5d44dfe258f5e31598716";
var $c710b973cf4b297a$export$2e2bcd8739ae039 = $c710b973cf4b297a$var$node;

});

parcelRegister("8WEyo", function(module, exports) {
$parcel$export(module.exports, "default", () => $da2ba785ddf6810d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<01cf7752e2aab1f5e931de941dfe1eb0>>
 * @relayHash 6f452febb43ea4f48f12803ae2f36059
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976
const $da2ba785ddf6810d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "helpCenterAri"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterCreateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterCreatePayload",
                            "kind": "LinkedField",
                            "name": "createHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterCreateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterCreatePayload",
                            "kind": "LinkedField",
                            "name": "createHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976",
            "metadata": {},
            "name": "useHelpCenterCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$da2ba785ddf6810d$var$node.hash = "50311be3a83d4bcff60feddeba10c3e5";
var $da2ba785ddf6810d$export$2e2bcd8739ae039 = $da2ba785ddf6810d$var$node;

});



parcelRegister("6B6mQ", function(module, exports) {
$parcel$export(module.exports, "updateHelpCenterExperience", () => $b444f4010d3f0998$export$9ee847b39a089524);
$parcel$export(module.exports, "addHelpCenterExperience", () => $b444f4010d3f0998$export$b2a851a784010834);

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $b444f4010d3f0998$export$88b7d3eb7bfc06a1 = 'service-management.help-center.add';
const $b444f4010d3f0998$export$588afedc10fc2da4 = 'service-management.help-center.update';
const $b444f4010d3f0998$export$9ee847b39a089524 = new (0, $ghwxF.UFOExperience)($b444f4010d3f0998$export$588afedc10fc2da4, {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});
const $b444f4010d3f0998$export$b2a851a784010834 = new (0, $ghwxF.UFOExperience)($b444f4010d3f0998$export$88b7d3eb7bfc06a1, {
    type: (0, $2lzZD.ExperienceTypes).Experience,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("90sv0", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFields", () => (parcelRequire("hMgHi")).HelpCenterFormFields);

var $hMgHi = parcelRequire("hMgHi");

});
parcelRegister("hMgHi", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFields", () => $b5c59e0bdfd233d3$export$14ec26006a1f0ef3);

var $8P7DW = parcelRequire("8P7DW");

var $5jYgE = parcelRequire("5jYgE");

var $7jDi7 = parcelRequire("7jDi7");
var $gFwdR = parcelRequire("gFwdR");

var $ebnVy = parcelRequire("ebnVy");

var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $gFpea = parcelRequire("gFpea");

var $ea6bZ = parcelRequire("ea6bZ");
parcelRequire("6bvX1");
var $Jhmxx = parcelRequire("Jhmxx");

var $bX6HN = parcelRequire("bX6HN");

var $AuJCb = parcelRequire("AuJCb");

var $bww9c = parcelRequire("bww9c");
const $b5c59e0bdfd233d3$var$SLUG_VALIDATION_REGEX = /^[a-zA-Z0-9_-]{1,30}$/;
const $b5c59e0bdfd233d3$var$SlugInfo = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
        xcss: $b5c59e0bdfd233d3$var$slugWarningStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ea6bZ.default), {
        content: formatMessage((0, $bww9c.default).helpCenterSlugInfoTooltip),
        position: "top-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebnVy))), {
        label: formatMessage((0, $bww9c.default).helpCenterSlugInfoLabel)
    })));
};
const $b5c59e0bdfd233d3$export$14ec26006a1f0ef3 = ({ name: name, slug: slug, urlWithoutSlug: urlWithoutSlug, mode: mode })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const nameLabel = (0, $Jhmxx.useConditionalMessage)((0, $bww9c.default).helpHubNameTextLabel, (0, $bww9c.default).helpCenterNameTextLabel);
    const urlLabel = (0, $Jhmxx.useConditionalMessage)((0, $bww9c.default).helpHubSlugTextLabel, (0, $bww9c.default).helpCenterSlugTextLabel);
    const validateHelpCenterName = (value)=>{
        if (!value || value.length <= 0) return formatMessage((0, $AuJCb.default).helpCenterNameRequiredError);
        if (value && value.length > (0, $bX6HN.HELPCENTER_NAME_CHARACTER_LIMIT)) return formatMessage((0, $AuJCb.default).helpCenterNameCharacterLimitError);
        return undefined;
    };
    const validateHelpCenterSlug = (value)=>{
        if (!value || value.length <= 0) return formatMessage((0, $AuJCb.default).helpCenterSlugRequiredError);
        if (value && value.length > (0, $bX6HN.HELPCENTER_NAME_CHARACTER_LIMIT)) return formatMessage((0, $AuJCb.default).helpCenterSlugCharacterLimitError);
        if (!$b5c59e0bdfd233d3$var$SLUG_VALIDATION_REGEX.test(value)) return formatMessage((0, $AuJCb.default).helpCenterSlugSpecialCharacterError);
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2IKBM.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gFwdR.default), {
        name: "name",
        key: "name",
        label: formatMessage(nameLabel),
        defaultValue: name ?? '',
        validate: validateHelpCenterName,
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            paddingBlockStart: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gFpea.default), {
            ...fieldProps,
            autoComplete: "off",
            autoFocus: true,
            placeholder: formatMessage((0, $bww9c.default).helpCenterNameTextFieldPlaceholder),
            testId: "help-centers-management-name-field"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7jDi7.ErrorMessage), null, error))), mode === 'CREATE' || slug ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gFwdR.default), {
        name: "slug",
        key: "slug",
        label: formatMessage(urlLabel),
        defaultValue: slug ?? '',
        validate: validateHelpCenterSlug,
        elementAfterLabel: mode !== 'CREATE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($b5c59e0bdfd233d3$var$SlugInfo, null),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $ktwNU.default), {
            grow: "fill",
            shouldWrap: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            paddingBlockStart: "space.100",
            paddingInlineEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7zDtY.default), {
            color: "color.text"
        }, urlWithoutSlug, '/')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $6Hfjm.default), {
            xcss: $b5c59e0bdfd233d3$var$slugTextFieldStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $gFpea.default), {
            autoComplete: "off",
            ...fieldProps,
            placeholder: formatMessage((0, $bww9c.default).helpCenterSlugTextFieldPlaceholder),
            testId: "help-centers-management-slug-field"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $7jDi7.ErrorMessage), null, error)))) : null);
};
const $b5c59e0bdfd233d3$var$slugTextFieldStyles = (0, $37U6z.xcss)({
    width: '10%',
    flexGrow: 1
});
const $b5c59e0bdfd233d3$var$slugWarningStyles = (0, $37U6z.xcss)({
    display: 'inline-flex',
    marginLeft: 'space.050',
    verticalAlign: 'middle'
});

});
parcelRegister("AuJCb", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a32fa6beafd347b$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $1a32fa6beafd347b$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    helpCenterDetailsPageTitle: {
        defaultMessage: 'Details',
        description: 'Help center edit details page title',
        id: 'help.center.edit.details.page.title'
    },
    helpCenterDetailsPageDescription: {
        defaultMessage: 'Customize the name and URL of your help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Help center edit details page description',
        id: 'help.center.edit.details.page.description'
    },
    helpHubDetailsPageDescription: {
        defaultMessage: 'Customize the name and URL of your help hub to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Help hub edit details page description',
        id: 'help.hub.edit.details.page.description'
    },
    defaultHelpCenterDetailsPageDescription: {
        defaultMessage: 'Customize the name of your default help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Default help center edit details page description',
        id: 'help.center.default.help.center.description'
    },
    helpCenterCreateFormTitle: {
        defaultMessage: 'Create help center',
        description: 'Help center create form title',
        id: 'help.center.create.form.title'
    },
    helpCenterCreateFormDescription: {
        defaultMessage: 'Every new help center displays all open portals on your site by default. You can edit the home page layout to show or hide portals based on the audience.',
        description: 'Help center create form description',
        id: 'help.center.create.form.description'
    },
    helpCenterEditFormTitle: {
        defaultMessage: 'Edit help center details',
        description: 'Help center edit form title',
        id: 'help.center.edit.form.title'
    },
    helpCenterAddErrorTitle: {
        defaultMessage: `We couldn\u{2019}t create your help center`,
        description: 'Title message for add help center error',
        id: 'help.center.add.error.title'
    },
    helpCenterAddSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 created",
        description: 'Title message for add help center success',
        id: 'help.center.add.success.title.text'
    },
    helpCenterAddSuccessDesc: {
        defaultMessage: 'Go to help center',
        description: 'Description message for add help center success',
        id: 'help.center.add.success.description'
    },
    helpCenterUpdateErrorTitle: {
        defaultMessage: "We couldn\u2019t update your help center",
        description: 'Title message for update help center error',
        id: 'help.center.update.error.title'
    },
    helpCenterUpdateSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 updated",
        description: 'Title message for add help center success',
        id: 'help.center.update.success.title.text'
    },
    helpCenterGenericErrorDesc: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Generic description message for help center error',
        id: 'help.center.update.error.description.generic'
    },
    helpCenterErrorDesc: {
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{value}',
        description: 'Description message for help center error',
        id: 'help.center.update.error.description'
    },
    helpCenterHardLimitErrorTitle: {
        defaultMessage: "You\u2019ve already created 300 help centers",
        description: 'Message title for help center hard limit reached error',
        id: 'help.center.create.hard.limit.error.title'
    },
    helpCenterHardLimitErrorDescription: {
        defaultMessage: 'Delete a help center to create another one.',
        description: 'Message description for help center hard limit reached error',
        id: 'help.center.create.hard.limit.error.description'
    },
    helpCenterNameRequiredError: {
        defaultMessage: 'Enter a name for your help center.',
        description: 'Validation error message when help center name is empty',
        id: 'help.center.name.required.validation.error'
    },
    helpCenterNameCharacterLimitError: {
        defaultMessage: 'Enter a help center name with 30 characters or less.',
        description: 'Validation error message when help center name is greater than required limit',
        id: 'help.center.name.character.limit.validation.error'
    },
    helpCenterSlugRequiredError: {
        defaultMessage: 'Add a slug.',
        description: 'Validation error message when help center slug is empty',
        id: 'help.center.slug.required.validation.error'
    },
    helpCenterSlugCharacterLimitError: {
        defaultMessage: 'Enter a slug with 30 characters or less.',
        description: 'Validation error message when help center slug is greater than required limit',
        id: 'help.center.slug.character.limit.validation.error'
    },
    helpCenterSlugSpecialCharacterError: {
        defaultMessage: `Add a slug that doesn\u{2019}t contain special characters other than hyphen (-) and underscore (_).`,
        description: 'Validation error message when help center slug contains special characters',
        id: 'help.center.slug.special.character.validation.error'
    },
    helpCenterAlreadyExistedSlugErrorDescription: {
        defaultMessage: 'A help center with this slug already exists on your site. Try again with a different slug.',
        description: 'Error message when help center slug already exists',
        id: 'help.center.already.existed.slug.error.description'
    },
    helpCenterReservedSlugErrorDescription: {
        defaultMessage: "The slug you\u2019ve entered contains a reserved term. Try again with a different slug.",
        description: 'Error message when entered slug contains reserved term',
        id: 'help.center.reserved.slug.error.description'
    },
    helpCenterRequiredFieldsWarning: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Required warning message for update help center fields',
        id: 'help.center.update.form.required.warning'
    }
});

});

parcelRegister("bww9c", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7d6defed3e730dd$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $f7d6defed3e730dd$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    helpCenterNameTextLabel: {
        defaultMessage: 'Help center name',
        description: 'Help center name text field label',
        id: 'help.center.name.text.field.label.title'
    },
    helpHubNameTextLabel: {
        defaultMessage: 'Help hub name',
        description: 'Help hub name text field label',
        id: 'help.hub.name.text.field.label.title'
    },
    helpCenterNameTextFieldPlaceholder: {
        defaultMessage: 'Enter a help center name',
        description: 'Help center name text field placeholder',
        id: 'help.center.name.text.field.placeholder.title'
    },
    helpCenterSlugTextLabel: {
        defaultMessage: 'Help center URL',
        description: 'Help center slug text field label',
        id: 'help.center.slug.text.field.label.title'
    },
    helpHubSlugTextLabel: {
        defaultMessage: 'Help hub URL',
        description: 'Help hub slug text field label',
        id: 'help.hub.slug.text.field.label.title'
    },
    helpCenterSlugInfoTooltip: {
        defaultMessage: 'Share your new help center URL with your team members and customers',
        description: 'Help center slug text change warning tooltip',
        id: 'help.center.slug.text.field.info.tooltip'
    },
    helpCenterSlugInfoLabel: {
        defaultMessage: 'Slug change info',
        description: 'Help center slug change info',
        id: 'help.center.slug.text.field.change.info.label'
    },
    helpCenterSlugTextFieldPlaceholder: {
        defaultMessage: 'Enter a slug',
        description: 'Help center slug text field placeholder',
        id: 'help.center.name.slug.field.placeholder.title'
    }
});

});



parcelRegister("eoruB", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFooter", () => (parcelRequire("aeY1I")).HelpCenterFormFooter);

var $aeY1I = parcelRequire("aeY1I");

});
parcelRegister("aeY1I", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFooter", () => $080261889cf4a69d$export$9f1ed90db1948ebe);

var $8P7DW = parcelRequire("8P7DW");

var $8y05I = parcelRequire("8y05I");

var $5jYgE = parcelRequire("5jYgE");

var $jp1Tm = parcelRequire("jp1Tm");

var $793wC = parcelRequire("793wC");

var $5l7tt = parcelRequire("5l7tt");
const $080261889cf4a69d$export$9f1ed90db1948ebe = ({ submitting: submitting, mode: mode, onCancel: onCancel, isStandaloneForm: isStandaloneForm = false, isCancelDisabled: isCancelDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const renderCancelButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.Button), {
            isDisabled: isCancelDisabled,
            onClick: onCancel,
            actionSubjectId: mode === 'CREATE' ? 'helpCenterCancelCreateButton' : 'helpCenterCancelEditButton',
            key: "cancel"
        }, formatMessage((0, $5l7tt.default).helpCenterCancelButtonText));
    const renderSaveButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $8y05I.LoadingButton), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting,
            actionSubjectId: mode === 'CREATE' ? 'helpCenterCreateButton' : 'helpCenterSaveButton',
            testId: "help-centers-management-primary-button",
            key: "save"
        }, formatMessage(mode === 'CREATE' ? (0, $5l7tt.default).helpCenterCreateButtonText : (0, $5l7tt.default).helpCenterSaveButtonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $793wC.default), {
        align: isStandaloneForm ? 'start' : 'end'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jp1Tm.default), null, isStandaloneForm ? [
        renderSaveButton(),
        renderCancelButton()
    ] : [
        renderCancelButton(),
        renderSaveButton()
    ]));
};

});
parcelRegister("5l7tt", function(module, exports) {
$parcel$export(module.exports, "default", () => $e25bcd1afe0e9aad$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $e25bcd1afe0e9aad$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    helpCenterSaveButtonText: {
        defaultMessage: 'Save',
        description: 'Help center save button text',
        id: 'help.center.save.button.text'
    },
    helpCenterCancelButtonText: {
        defaultMessage: 'Cancel',
        description: 'Help center cancel button text',
        id: 'help.center.cancel.button.text'
    },
    helpCenterCreateButtonText: {
        defaultMessage: 'Create',
        description: 'Help center create button text',
        id: 'help.center.create.button.text'
    }
});

});





parcelRegister("7wQOO", function(module, exports) {
$parcel$export(module.exports, "EditHelpCenterLayoutSkeleton", () => (parcelRequire("lJAIJ")).default);

var $lJAIJ = parcelRequire("lJAIJ");

});
parcelRegister("lJAIJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $10c66cb12ccb8b88$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $iSvee = parcelRequire("iSvee");

var $6Hfjm = parcelRequire("6Hfjm");
var $dqsXi = parcelRequire("dqsXi");
var $2IKBM = parcelRequire("2IKBM");
const $10c66cb12ccb8b88$var$EditHelpCenterLayoutSkeleton = ()=>{
    return /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.200"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "84px",
        height: "24px"
    })), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "20%",
        height: "28px",
        "data-testid": "edit-helpcenter-header-skeleton"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlockStart: "space.100",
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.050"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "100%",
        height: "20px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "60%",
        height: "20px"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "50%",
        height: "20px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlockEnd: "space.150"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "10%",
        height: "16px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "100%",
        height: "36px"
    }))), /*#__PURE__*/ $8P7DW.createElement((0, $6Hfjm.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $2IKBM.default), {
        space: "space.100"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "10%",
        height: "16px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        direction: "row",
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "50%",
        height: "20px"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "50%",
        height: "36px"
    }))))), /*#__PURE__*/ $8P7DW.createElement((0, $dqsXi.default), {
        direction: "row",
        gap: "space.050"
    }, /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "10%",
        height: "32px",
        "data-testid": "edit-helpcenter-button-skeleton"
    }), /*#__PURE__*/ $8P7DW.createElement((0, $iSvee.SkeletonItem), {
        width: "10%",
        height: "32px"
    })));
};
var $10c66cb12ccb8b88$export$2e2bcd8739ae039 = $10c66cb12ccb8b88$var$EditHelpCenterLayoutSkeleton;

});


parcelRegister("hfRtk", function(module, exports) {
$parcel$export(module.exports, "editHelpCenterExperience", () => $863631a820806078$export$f9e64dbdb3d531);

var $lQb0x = parcelRequire("lQb0x");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");
const $863631a820806078$export$f9e64dbdb3d531 = new (0, $ghwxF.UFOExperience)((0, $lQb0x.editHelpCenterExperienceId), {
    type: (0, $2lzZD.ExperienceTypes).Load,
    performanceType: (0, $2lzZD.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("iYuXv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a0ccc9569275276$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $3a0ccc9569275276$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title',
        id: 'help.center.management.sidebar.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error description',
        id: 'help.center.management.sidebar.error.description'
    }
});

});



parcelRegister("4Nntd", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("9olHN"),
    $j9MRt("ldNUV"),
    $j9MRt("1j2Ac"),
    $j9MRt("fSmVB"),
    $j9MRt("8j9le"),
    $j9MRt("21HHS"),
    $j9MRt("k9PE9"),
    $j9MRt("1Seuf"),
    $j9MRt("bKclB"),
    $j9MRt("cDvvv"),
    $j9MRt("atrci"),
    $j9MRt("7SdQf"),
    $j9MRt("9hBNq"),
    $j9MRt("8tnJT"),
    $j9MRt("43nk4"),
    $j9MRt("iilsR"),
    $j9MRt("3T0Nj"),
    $j9MRt("c3COr"),
    $j9MRt("4RNdI"),
    $j9MRt("apr9b"),
    $j9MRt("9A5aF"),
    $j9MRt("lUtvv"),
    $j9MRt("kDWWL"),
    $j9MRt("dpapA"),
    $j9MRt("he79R")
]).then(()=>parcelRequire('1xW1G'));

});


parcelRegister("anUvS", function(module, exports) {
$parcel$export(module.exports, "helpcenterVirtualAgentRoute", () => $fbad791cea903c93$export$60952d52d9999cc1);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $hxVai = parcelRequire("hxVai");

var $HGACo = parcelRequire("HGACo");

var $gweXC = parcelRequire("gweXC");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");
parcelRequire("9wocP");
var $bDnSZ = parcelRequire("bDnSZ");
parcelRequire("fZ17l");
var $hbdiU = parcelRequire("hbdiU");
parcelRequire("chjsC");
var $h2NCY = parcelRequire("h2NCY");
parcelRequire("i2Zru");
var $jBIAB = parcelRequire("jBIAB");

var $1nQ48 = parcelRequire("1nQ48");
parcelRequire("6bvX1");
var $i3cng = parcelRequire("i3cng");

var $kIDgu = parcelRequire("kIDgu");

var $gchkS = parcelRequire("gchkS");

const $fbad791cea903c93$var$AsyncVirtualAgentPage = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("kooKZ")).then((VirtualAgentSettingsPage)=>VirtualAgentSettingsPage), {
        moduleId: "./packages/virtual-agent/virtual-agent-settings/src/index.tsx"
    })
});
const $fbad791cea903c93$var$VirtualAgentPage = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const WrappedComponent = (0, $hxVai.default)((0, $jBIAB.default)({
        redirectUrl: '/'
    }), (0, $h2NCY.default)({
        message: formatMessage((0, $1nQ48.authPageMessage)),
        callToActionText: formatMessage((0, $1nQ48.callToActionUrlText)),
        callToActionUrl: '/portals'
    }), ...(0, $HGACo.isVAOnHelpCenterGAEnabled)() ? [] : [
        (0, $hbdiU.default)({
            message: formatMessage((0, $kIDgu.default).aiConfigNotEnabledError),
            callToActionText: formatMessage((0, $1nQ48.callToActionUrlText)),
            callToActionUrl: '/portals'
        })
    ])(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $i3cng.default), {
            featureName: "Virtual Agent Settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement($fbad791cea903c93$var$AsyncVirtualAgentPage, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, null);
};
const $fbad791cea903c93$export$60952d52d9999cc1 = {
    name: 'virtualAgentSettings',
    path: '/:helpcenterId/virtual-agent',
    exact: true,
    resources: [
        (0, $gchkS.HelpCenterVirtualAgentResource)
    ],
    component: (0, $bDnSZ.withRouter)($fbad791cea903c93$var$VirtualAgentPage)
};

});
parcelRegister("kIDgu", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0d6926e0d09f0ff$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $c0d6926e0d09f0ff$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    helpCenterReportingPageTitle: {
        defaultMessage: 'Performance',
        description: 'Title message for Help Center Reporting',
        id: 'helpcenter.reporting.title'
    },
    helpCenterReportingPageSubtitleV2: {
        defaultMessage: 'See the performance of the virtual service agent on your help center from the last 7 days. ',
        description: 'Subtitle message for Help Center Reporting',
        id: 'helpcenter.reporting.subtitle-v-2'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    IphLinkTextV2: {
        defaultMessage: 'Read more about using the virtual service agent on your help center.',
        description: 'Text for Link that should open in in-product help',
        id: 'helpcenter.reporting.iph-link-text-v-2'
    },
    aiConfigNotEnabledError: {
        defaultMessage: 'AI is not enabled for this portal',
        description: 'Error message when AI is not enabled for the tenant',
        id: 'helpcenter.reporting.ai.config.not.enabled.error.non-final'
    }
});

});

parcelRegister("gchkS", function(module, exports) {
$parcel$export(module.exports, "HelpCenterVirtualAgentResource", () => $100ddba6606341ba$export$7ab6648586bf1bbf);

var $HGACo = parcelRequire("HGACo");

var $jByYr = parcelRequire("jByYr");

var $cLmLE = parcelRequire("cLmLE");

var $hrPHR = parcelRequire("hrPHR");

var $byuiX = parcelRequire("byuiX");

var $j65FG = parcelRequire("j65FG");
const $100ddba6606341ba$export$7ab6648586bf1bbf = (0, $byuiX.createRelayResource)({
    type: 'HELP_REPORTING_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        let computedHelpCenterAri = helpCenterAri;
        const activationId = (0, $jByYr.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        computedHelpCenterAri = (0, $cLmLE.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        // Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
        const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
        return {
            parameters: (0, $j65FG.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: finalHelpCenterAri,
                isJsmAIConfigEnabled: (0, $hrPHR.getJsmAIConfigEnabled)(),
                isVAOnHelpCenterGAEnabled: (0, $HGACo.isVAOnHelpCenterGAEnabled)(),
                isHideKbColumnEnabled: (0, $HGACo.isHideKbColumnEnabled)(),
                isTotalArticleCountEnabled: (0, $HGACo.isTotalArticleCountEnabled)()
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("j65FG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a479a104f482a01f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9a12a95fef79035dd1b562ddf5ae22d0>>
 * @relayHash 127cb5587f2a92a32c9a887addd1d130
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c090c3adcd49e9b8d1327fa26dca86a9d8e82bf6747475b17f94ba52ad76e393
const $a479a104f482a01f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideKbColumnEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJsmAIConfigEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTotalArticleCountEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isVAOnHelpCenterGAEnabled"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v13 = [
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "InlineFragment",
        "selections": v15 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = [
        v6 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "helpCenterARI",
                    "variableName": "helpCenterAri"
                },
                {
                    "kind": "Literal",
                    "name": "helpCenterId",
                    "value": ""
                },
                {
                    "kind": "Literal",
                    "name": "helpCenterMappingStatus",
                    "value": "LINKED"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "selections": [
                {
                    "condition": "isJsmAIConfigEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "settingsVirtualAgentSettingsTabFragment"
                                                },
                                                v11 /*: any*/ 
                                            ],
                                            "type": "HelpCenter"
                                        },
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "settingsBreadcrumbsFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isTotalArticleCountEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpObjectStore_searchArticles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsVirtualAgentLinkedArticlesFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isVAOnHelpCenterGAEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "isHideKbColumnEnabled",
                                    "variableName": "isHideKbColumnEnabled"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isVAOnHelpCenterGAEnabled",
                                    "variableName": "isVAOnHelpCenterGAEnabled"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "settingsVirtualAgentSettingsTabMappedProjectsFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "selections": [
                {
                    "condition": "isJsmAIConfigEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterName",
                                                    "kind": "LinkedField",
                                                    "name": "name",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "default"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "slug"
                                                }
                                            ],
                                            "type": "HelpCenter"
                                        },
                                        v12 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isTotalArticleCountEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpObjectStore_searchArticles",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpObjectStoreArticleSearchResponse"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ],
                                    "type": "HelpObjectStoreArticleSearchResults"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isVAOnHelpCenterGAEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "condition": "isVAOnHelpCenterGAEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectsMappedToHelpCenter",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "isHideKbColumnEnabled",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": v7 /*: any*/ ,
                                                                            "kind": "LinkedField",
                                                                            "name": "knowledgeBaseArticlesCount",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "count"
                                                                                        }
                                                                                    ],
                                                                                    "type": "KnowledgeBaseArticleCountSource"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "virtualAgentConfiguration",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isAiResponsesEnabled"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "liveIntentsCount"
                                                                                }
                                                                            ],
                                                                            "type": "VirtualAgentConfiguration"
                                                                        },
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v15 /*: any*/ ,
                                                                            "type": "VirtualAgentQueryError"
                                                                        }
                                                                    ]
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v17 /*: any*/ ,
                                            "filters": [
                                                "cloudId",
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "projectBreakdownTableMappedProjectsFragment_jiraProjectsMappedToHelpCenter",
                                            "kind": "LinkedHandle",
                                            "name": "jiraProjectsMappedToHelpCenter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c090c3adcd49e9b8d1327fa26dca86a9d8e82bf6747475b17f94ba52ad76e393",
            "metadata": {},
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a479a104f482a01f$var$node.hash = "848394ca7a90b3bb8cc25854972756d0";
var $a479a104f482a01f$export$2e2bcd8739ae039 = $a479a104f482a01f$var$node;

});


parcelRegister("kooKZ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("fOoG5").then(()=>parcelRequire('j1YcY'));

});


parcelRegister("g7bTY", function(module, exports) {
$parcel$export(module.exports, "viewHelpCentersManagementPageRoute", () => $647535d382f28308$export$e49071c21a45635e);
$parcel$export(module.exports, "viewHelpHubsManagementPageRoute", () => $647535d382f28308$export$589f7c1da1d95244);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("haxwJ");
var $hxVai = parcelRequire("hxVai");

var $8rTkC = parcelRequire("8rTkC");

var $5jYgE = parcelRequire("5jYgE");
parcelRequire("chjsC");
var $h2NCY = parcelRequire("h2NCY");
parcelRequire("i2Zru");
var $jBIAB = parcelRequire("jBIAB");
parcelRequire("7fqDj");
var $faOUB = parcelRequire("faOUB");
var $aU0DY = parcelRequire("aU0DY");
const $647535d382f28308$var$HelpCentersManagement = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>(0, $hxVai.default)((0, $jBIAB.default)({
            redirectUrl: '/'
        }), (0, $h2NCY.default)({
            message: formatMessage((0, $faOUB.authPageMessage)),
            callToActionText: formatMessage((0, $faOUB.callToActionUrlText)),
            callToActionUrl: ''
        }))((0, $faOUB.HelpCentersManagementPage)), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, null);
};
const $647535d382f28308$var$HelpHubsManagement = ()=>{
    const { formatMessage: formatMessage } = (0, $5jYgE.default)();
    const WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).useMemo(()=>(0, $hxVai.default)((0, $jBIAB.default)({
            redirectUrl: '/'
        }), (0, $h2NCY.default)({
            message: formatMessage((0, $faOUB.authPageMessage)),
            callToActionText: formatMessage((0, $faOUB.callToActionUrlText)),
            callToActionUrl: ''
        }))((0, $faOUB.HelpCentersManagementPage)), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement(WrappedComponent, null);
};
const $647535d382f28308$export$e49071c21a45635e = {
    name: (0, $8rTkC.ScreenName).HELP_CENTERS_MANAGEMENT,
    path: '/',
    exact: true,
    component: $647535d382f28308$var$HelpCentersManagement,
    resources: [
        (0, $aU0DY.HelpCentersManagementResource)
    ]
};
const $647535d382f28308$export$589f7c1da1d95244 = {
    name: (0, $8rTkC.ScreenName).HELP_HUBS_MANAGEMENT,
    path: '/hubs',
    exact: true,
    component: $647535d382f28308$var$HelpHubsManagement,
    resources: [
        (0, $aU0DY.HelpCentersManagementResource)
    ]
};

});
parcelRegister("7fqDj", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementPage", () => (parcelRequire("faOUB")).HelpCentersManagementPage);
$parcel$export(module.exports, "HelpCentersManagementResource", () => (parcelRequire("aU0DY")).HelpCentersManagementResource);
$parcel$export(module.exports, "callToActionUrlText", () => (parcelRequire("faOUB")).callToActionUrlText);
$parcel$export(module.exports, "authPageMessage", () => (parcelRequire("faOUB")).authPageMessage);

var $faOUB = parcelRequire("faOUB");
var $aU0DY = parcelRequire("aU0DY");
parcelRequire("gaYiV");
var $ivwEF = parcelRequire("ivwEF");

});
parcelRegister("faOUB", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementPage", () => $43e3a1e962ba2ef6$export$233bfa78dd235938);
$parcel$export(module.exports, "callToActionUrlText", () => $43e3a1e962ba2ef6$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $43e3a1e962ba2ef6$export$5342e2a00fe6d647);
$parcel$export(module.exports, "HelpCentersManagementResource", () => (parcelRequire("aU0DY")).HelpCentersManagementResource);

var $gweXC = parcelRequire("gweXC");
parcelRequire("4PbDu");
var $fGOkV = parcelRequire("fGOkV");

var $1lO7E = parcelRequire("1lO7E");

var $aU0DY = parcelRequire("aU0DY");

const $43e3a1e962ba2ef6$export$233bfa78dd235938 = (0, $gweXC.default)({
    loader: (0, $fGOkV.lazyForPaint)(()=>(parcelRequire("iYtTm")), {
        moduleId: "./packages/help-center/help-centers-management/src/ui/help-centers-management-page/help-centers-management-page.tsx"
    })
});
const $43e3a1e962ba2ef6$export$d96795d242b62963 = (0, $1lO7E.default).callToActionUrlText;
const $43e3a1e962ba2ef6$export$5342e2a00fe6d647 = (0, $1lO7E.default).authPageMessage;

});
parcelRegister("1lO7E", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ccfd1890852d296$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $6ccfd1890852d296$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    headerTextHelpCenter: {
        defaultMessage: 'Help centers',
        description: 'Help centers management screen header text',
        id: 'help.center.management.page.header.text'
    },
    headerTextHelpHub: {
        defaultMessage: 'Help hubs',
        description: 'Help centers management screen header text hubs',
        id: 'help.center.management.page.header.text.hubs.non-final'
    },
    headerDescriptionHelpCenter: {
        defaultMessage: 'Set up and manage your help centers here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description'
    },
    headerDescriptionReadMoreLinkHelpCenter: {
        defaultMessage: 'Read more about help centers',
        description: 'Help centers management screen header description read more link',
        id: 'help.center.management.page.header.description.read.more.link'
    },
    headerDescriptionHelpHub: {
        defaultMessage: 'Set up and manage your help hubs here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description.hubs'
    },
    addButtonTextHelpCenter: {
        defaultMessage: 'Create help center',
        description: 'Help centers management screen add help center button text',
        id: 'help.center.management.add.help.center.button.text'
    },
    addButtonTextHelpHub: {
        defaultMessage: 'Create help hub',
        description: 'Help centers management screen create button text',
        id: 'help.center.management.create.button.text.hubs.non-final'
    },
    createOptionHelpCenterTitle: {
        defaultMessage: 'Help center',
        description: 'Help centers management screen create option help center title',
        id: 'help.center.management.create.option.help.center.title'
    },
    createOptionHelpCenterDescription: {
        defaultMessage: 'The default help experience with portals, topics, and more',
        description: 'Help centers management screen create option help center description',
        id: 'help.center.management.create.option.help.center.description'
    },
    createOptionHubTitle: {
        defaultMessage: 'Help hub',
        description: 'Help centers management screen create option hub title',
        id: 'help.center.management.create.option.hub.title.non-final'
    },
    createOptionHubDescription: {
        defaultMessage: 'Create a modern help experience with components and customisation',
        description: 'Help centers management screen create option hub description',
        id: 'help.center.management.create.option.hub.description.non-final'
    },
    genericErrorHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.heading'
    },
    genericErrorMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.message'
    },
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.message'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to help center',
        description: 'Call to action text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.text'
    },
    upgradeTitleCreateClick: {
        defaultMessage: 'Upgrade to create new help centers',
        description: 'Popup title to upgrade to create help center',
        id: 'help.center.management.upgrade.title.create.click'
    },
    upgradeDescriptionCreateClick: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to create multiple help centers on your site.',
        description: 'Popup description to upgrade to create help center',
        id: 'help.center.management.upgrade.description.create.click'
    },
    helpHubEmptyStateHeader: {
        defaultMessage: 'Create modern help hubs to serve your customers',
        description: 'Help hub empty state header',
        id: 'help.center.management.page.help.hub.empty.state.header'
    },
    helpHubEmptyStateDescription: {
        defaultMessage: 'Empower customers to find answers with knowledge base articles or get support by raising requests in Jira Service Management.',
        description: 'Help hub empty state description',
        id: 'help.center.management.page.help.hub.empty.state.description'
    }
});

});

parcelRegister("aU0DY", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementResource", () => $b644ac5d538025aa$export$7e2ebb4b559ed1ce);

var $8rTkC = parcelRequire("8rTkC");

var $1EFS8 = parcelRequire("1EFS8");

var $byuiX = parcelRequire("byuiX");

var $bX6HN = parcelRequire("bX6HN");

var $8essS = parcelRequire("8essS");
const $b644ac5d538025aa$export$7e2ebb4b559ed1ce = (0, $byuiX.createRelayResource)({
    type: 'HELP_CENTERS_MANAGEMENT',
    getQuery: ({ route: route }, { cloudId: cloudId, workspaceAri: workspaceAri })=>{
        const isHelpHubRoute = route.name === (0, $8rTkC.ScreenName).HELP_HUBS_MANAGEMENT;
        const filterType = isHelpHubRoute ? 'HELP_HUB' : 'BASIC';
        return {
            parameters: (0, $8essS.default),
            variables: {
                cloudId: cloudId,
                workspaceAri: workspaceAri,
                SORT_ORDER: $bX6HN.SORT_ORDER,
                NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $bX6HN.NUMBER_OF_HELP_CENTERS_INITIAL_FETCH,
                filterType: (0, $1EFS8.default).checkGate('enable-jsm-in-hubs') ? filterType : null
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("8essS", function(module, exports) {
$parcel$export(module.exports, "default", () => $02f16e06905ee211$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<720c20134123b856e9bd2eb389c3c4ac>>
 * @relayHash bfac5bcd27aeada23cd69a482e5f987f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f188fcb4a9e41becef087e9550e84163d2d7c12b335d6dc8730860e3e08c584
const $02f16e06905ee211$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "SORT_ORDER"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
    }, v7 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "type",
                    "variableName": "filterType"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
        },
        {
            "kind": "Variable",
            "name": "sortOrder",
            "variableName": "SORT_ORDER"
        },
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "slug"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpCentersManagementPageQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH",
                            "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
                        },
                        {
                            "kind": "Variable",
                            "name": "SORT_ORDER",
                            "variableName": "SORT_ORDER"
                        },
                        v5 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "filterType",
                            "variableName": "filterType"
                        },
                        v6 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "helpCentersManagementPageFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpCentersManagementPageQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterName",
                                                            "kind": "LinkedField",
                                                            "name": "name",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "default"
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterTranslation",
                                                                    "kind": "LinkedField",
                                                                    "name": "translations",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "locale"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterBranding",
                                                            "kind": "LinkedField",
                                                            "name": "helpCenterBranding",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isBannerAvailable"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "useDefaultBanner"
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterBrandingColors",
                                                                    "kind": "LinkedField",
                                                                    "name": "colors",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "primary"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterBanner",
                                                                    "kind": "LinkedField",
                                                                    "name": "banner",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdated"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mappedProjectsCount"
                                                        }
                                                    ],
                                                    "type": "HelpCenter"
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "helpCentersManagementPageFragment_helpCenters",
                            "kind": "LinkedHandle",
                            "name": "helpCenters"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1f188fcb4a9e41becef087e9550e84163d2d7c12b335d6dc8730860e3e08c584",
            "metadata": {},
            "name": "helpCentersManagementPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$02f16e06905ee211$var$node.hash = "767d192c1eee830ece678d269a62c024";
var $02f16e06905ee211$export$2e2bcd8739ae039 = $02f16e06905ee211$var$node;

});


parcelRegister("iYtTm", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = Promise.all([
    $j9MRt("ejrQr"),
    $j9MRt("i0YHV"),
    $j9MRt("1kNIV"),
    $j9MRt("qRvpe"),
    $j9MRt("5WsnM"),
    $j9MRt("8n69V"),
    $j9MRt("gUXUg"),
    $j9MRt("9hBNq"),
    $j9MRt("jKTRD"),
    $j9MRt("7YsTm")
]).then(()=>parcelRequire('3f71p'));

});





parcelRegister("ftaVT", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f305d184f83aa4b$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");

var $2UsNA = parcelRequire("2UsNA");

var $HGACo = parcelRequire("HGACo");

var $3Z4c2 = parcelRequire("3Z4c2");

var $fOqPA = parcelRequire("fOqPA");

parcelRequire("9wocP");
var $jT4Pl = parcelRequire("jT4Pl");
var $3vYjO = parcelRequire("3vYjO");

var $17jzp = parcelRequire("17jzp");

var $7A2dq = parcelRequire("7A2dq");

var $3wAsA = parcelRequire("3wAsA");

var $dQDRa = parcelRequire("dQDRa");

var $j52uk = parcelRequire("j52uk");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $9PD2z = parcelRequire("9PD2z");
parcelRequire("lzEbC");
var $1Glz5 = parcelRequire("1Glz5");

var $1EFS8 = parcelRequire("1EFS8");

var $7FSs7 = parcelRequire("7FSs7");

var $9lRNC = parcelRequire("9lRNC");

var $idbbE = parcelRequire("idbbE");
const $8f305d184f83aa4b$export$2f7745f2f5ab3897 = ()=>{
    return [
        (0, $1Glz5.getHubHomepageRoute)(),
        (0, $1Glz5.getHubCustompageRoute)(),
        ...(0, $1EFS8.default).checkGate('portal-pages-in-hub') ? [
            (0, $1Glz5.getHubPortalPageRoute)()
        ] : [],
        /**
   * Account Management Pages
   */ (0, $1Glz5.getLoginRouteWithHubShell)(),
        (0, $1Glz5.getPortalLoginRouteWithHubShell)(),
        (0, $1Glz5.getResetPasswordRouteWithHubShell)(),
        (0, $1Glz5.getPortalResetPasswordRouteWithHubShell)(),
        (0, $1Glz5.getSignupRouteWithHubShell)(),
        (0, $1Glz5.getPortalSignupRouteWithHubShell)(),
        (0, $1Glz5.getCompleteSignupRouteWithHubShell)(),
        (0, $1Glz5.getPortalCompleteSignupRouteWithHubShell)(),
        (0, $1Glz5.getPortalInvitedSignupRouteWithHubShell)(),
        (0, $1Glz5.getCheckEmailRouteWithHubShell)(),
        (0, $1Glz5.getUnsubscribeRouteWithHubShell)(),
        (0, $1Glz5.getHubUserProfileRouteWithHubShell)(),
        (0, $1Glz5.getPortalAccessForbiddenRouteWithHubShell)(),
        (0, $17jzp.consentFormRoute /* TODO: The consent form route needs the Hub Shell */ ),
        ...(0, $HGACo.isEmailVerifiedSignalEnabled)() ? [
            (0, $j52uk.userVerifyEmailRoute)
        ] : [],
        /**
   * Request Management Pages
   */ (0, $1Glz5.getRequestCreateRouteWithHubShell)(),
        (0, $1Glz5.getAnonymousRequestSuccessRouteWithHubShell)(),
        (0, $1Glz5.getRequestFeedbackRouteWithHubShell)(),
        (0, $1Glz5.getJsmRequestDetailsRouteWithHubShell)(),
        (0, $1Glz5.getJsmRequestsListRouteWithHubShell)(),
        (0, $1Glz5.getJsmApprovalsRouteWithHubShell)(),
        (0, $1Glz5.getJsmRequestApprovalRouteWithHubShell)(),
        /** TODO: Article Pages */ (0, $1Glz5.getHubViewKbRoute)(),
        (0, $1Glz5.getHubViewArticleRoute)(),
        (0, $1Glz5.getHubViewCrossSiteArticleRoute)(),
        (0, $1Glz5.getHubViewPortalArticleRoute)(),
        (0, $1Glz5.getHubViewCrossSitePortalArticleRoute)(),
        /**
   * Search related pages
   */ (0, $dQDRa.viewAllSearchResultsRoute),
        /**
   * Hub Management pages
   */ (0, $3wAsA.helpcenterEditRoute),
        (0, $3wAsA.helpcenterManageProjectsRoute),
        (0, $3wAsA.helpcenterManageCustomPagesRoute),
        /**
   * EmbeddablePages
   */ (0, $7A2dq.getEmbedCreateRequestRoute)(),
        (0, $7A2dq.embedKBArticleRoute),
        /**
   * Not found route
   */ (0, $1Glz5.getNotFoundRouteWithHubShell)()
    ];
};
const $8f305d184f83aa4b$export$bd848585fb624145 = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $3Z4c2.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $3Z4c2.lightenColor)(themeColor);
    const routes = (0, $8P7DW.useMemo)(()=>$8f305d184f83aa4b$export$2f7745f2f5ab3897(), []);
    const location = globalThis.location.pathname + globalThis.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $2UsNA.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $3vYjO.Router), {
        routes: routes,
        history: (0, $7FSs7.default),
        isGlobal: false,
        plugins: [
            (0, $idbbE.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $fOqPA.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9PD2z.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $jT4Pl.RouteComponent), null), (0, $1EFS8.default).checkGate('enable_rovo_in_help_hubs') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9lRNC.RovoWidgetRenderer), null)));
};
const $8f305d184f83aa4b$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getThemeColor), (0, $ikoP4.getHelpCenterTitleColor), (themeColor, titleColor)=>({
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $8f305d184f83aa4b$export$2e2bcd8739ae039 = (0, $jvoWT.default)($8f305d184f83aa4b$var$selector)($8f305d184f83aa4b$export$bd848585fb624145);

});
parcelRegister("9lRNC", function(module, exports) {
$parcel$export(module.exports, "RovoWidgetRenderer", () => $0e42138b16e1cb00$export$5d23099fbd84d512);

var $8P7DW = parcelRequire("8P7DW");

var $jByYr = parcelRequire("jByYr");
parcelRequire("9wocP");
var $i9cdb = parcelRequire("i9cdb");

var $9blvX = parcelRequire("9blvX");
// Route names to exclude from showing the Rovo widget
const $0e42138b16e1cb00$var$EXCLUDED_ROVO_WIDGET_ROUTES = [
    'hub',
    'hub-custom-page'
];
const $0e42138b16e1cb00$export$5d23099fbd84d512 = ()=>{
    var _routerState$route;
    const [routerState] = (0, $i9cdb.useRouter)();
    const currentRouteName = (_routerState$route = routerState.route) === null || _routerState$route === void 0 ? void 0 : _routerState$route.name;
    if (!currentRouteName || $0e42138b16e1cb00$var$EXCLUDED_ROVO_WIDGET_ROUTES.includes(currentRouteName)) return null;
    const cloudId = (0, $jByYr.getCloudId)();
    const helpCenterAri = (0, $jByYr.getHelpCenterAri)();
    if (!cloudId || !helpCenterAri) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $9blvX.RovoServiceAgentWidgetInjector), {
        siteId: cloudId,
        widgetId: helpCenterAri,
        surface: "HUB"
    });
};

});


parcelRegister("im4RM", function(module, exports) {
$parcel$export(module.exports, "JSMCookieConsentBanner", () => (parcelRequire("kQnik")).SSRSafeJSMCookieConsentBanner);

var $kQnik = parcelRequire("kQnik");

});
parcelRegister("kQnik", function(module, exports) {
$parcel$export(module.exports, "SSRSafeJSMCookieConsentBanner", () => $dd40376617f05988$export$757e76e75a25cb0c);

var $8P7DW = parcelRequire("8P7DW");

var $4zz2H = parcelRequire("4zz2H");

var $9655j = parcelRequire("9655j");
var $i8m9P = parcelRequire("i8m9P");
var $eKc2n = parcelRequire("eKc2n");
var $etQ5W = parcelRequire("etQ5W");
const $dd40376617f05988$export$757e76e75a25cb0c = ()=>{
    const ssrInput = (0, $4zz2H.getSSRInput)();
    const consentToken = (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_CONSENT_COOKIE_KEY)) || (ssrInput === null || ssrInput === void 0 ? void 0 : ssrInput.cookiesConsentToken);
    const fallbackConsentToken = (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) || (ssrInput === null || ssrInput === void 0 ? void 0 : ssrInput.cookiesFallbackToken);
    const cookieData = consentToken ? {
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    } : {
        fallbackConsentToken: fallbackConsentToken
    };
    (0, $8P7DW.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $etQ5W.initializeControls)({
            product: 'jira'
        });
    }, []);
    // The case of only the fallbackConsentToken being present is handled differently on the
    // server and on the client. So in order to SSR the same way, we have handle this case
    // specially. Only fallback token being present on the client results in banner not being shown.
    // However, if we pass that cookie data into the initialPreferences on the client, there is a short
    // flicker of the consent banner. So we also have to special case this on the client.
    const onlyFallbackTokenPresent = Boolean(fallbackConsentToken && !consentToken);
    return(// Wrapper needed for stable DOM to rehydrate. Otherwise, rehydration failures may break the entire page when
    // this returns a banner in SSR and no banner/null in CSR (or the other way around).
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        "data-testid": 'jsm-cookie-consent-banner-wrapper'
    }, onlyFallbackTokenPresent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $i8m9P.ConsentBanner), {
        product: "jira"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $i8m9P.ConsentBanner), {
        product: "jira",
        initialPreferences: cookieData
    })));
};

});
parcelRegister("4zz2H", function(module, exports) {
$parcel$export(module.exports, "getSSRInput", () => $4d4ecba7c3a16db7$export$57d34b7c393d6ac0);

const $4d4ecba7c3a16db7$export$57d34b7c393d6ac0 = ()=>{
    var error;
    return undefined;
};

});

parcelRegister("i8m9P", function(module, exports) {
$parcel$export(module.exports, "ConsentBanner", () => $138a41b823a74b8f$export$903b95b8397e77e9);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $dCWA1 = parcelRequire("dCWA1");

var $fToTc = parcelRequire("fToTc");

var $e6Qdr = parcelRequire("e6Qdr");

var $gc3OY = parcelRequire("gc3OY");

var $kIFRO = parcelRequire("kIFRO");
const $138a41b823a74b8f$export$903b95b8397e77e9 = (props)=>{
    if ((0, $e6Qdr.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $e6Qdr.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $8P7DW.useEffect)(()=>{
            onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 || onConsentBannerBailOut();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $dCWA1.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, $gWgPx.jsx)("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        },
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fToTc.FlagsProvider), {
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $kIFRO.ConsentBannerImpl), {
                ...props
            })
        })
    });
};

});
parcelRegister("fToTc", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $059dd3c9670b7c84$export$2879604e6aec4ab);
$parcel$export(module.exports, "FlagsProvider", () => $059dd3c9670b7c84$export$a4270ab432ac8a58);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $hse4G = parcelRequire("hse4G");

var $h5gSD = parcelRequire("h5gSD");

var $gvxin = parcelRequire("gvxin");
const $059dd3c9670b7c84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createContext(null);
function $059dd3c9670b7c84$export$2879604e6aec4ab() {
    const api = (0, $8P7DW.useContext)($059dd3c9670b7c84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $059dd3c9670b7c84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $059dd3c9670b7c84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $8P7DW.useState)([]);
    const removeFlag = (0, $8P7DW.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $8P7DW.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $059dd3c9670b7c84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)($059dd3c9670b7c84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gvxin.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $hse4G.default) : (0, $h5gSD.default);
                    return /*#__PURE__*/ (0, $8P7DW.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $059dd3c9670b7c84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $gWgPx.jsx)($059dd3c9670b7c84$export$a4270ab432ac8a58, {
        children: fn()
    });

});

parcelRegister("kIFRO", function(module, exports) {
$parcel$export(module.exports, "ConsentBannerImpl", () => $4944dd5bffdba7ae$export$24af610f9b900e82);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $3SD6z = parcelRequire("3SD6z");
var $k7INq = parcelRequire("k7INq");

var $fToTc = parcelRequire("fToTc");

var $h82Rb = parcelRequire("h82Rb");

var $joUCG = parcelRequire("joUCG");

var $e6Qdr = parcelRequire("e6Qdr");

var $aEpPp = parcelRequire("aEpPp");

var $5hOMA = parcelRequire("5hOMA");
var $hamKY = parcelRequire("hamKY");

var $jbZd2 = parcelRequire("jbZd2");

var $gc3OY = parcelRequire("gc3OY");

var $9655j = parcelRequire("9655j");

var $gLTQj = parcelRequire("gLTQj");
var $eKc2n = parcelRequire("eKc2n");

var $j4pBQ = parcelRequire("j4pBQ");

var $hbH2u = parcelRequire("hbH2u");

var $6xP82 = parcelRequire("6xP82");

var $k0Hun = parcelRequire("k0Hun");

var $5L9bY = parcelRequire("5L9bY");

var $heayX = parcelRequire("heayX");
const $4944dd5bffdba7ae$var$SuccessWithIntl = (0, $3SD6z.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($joUCG))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.success',
            defaultMessage: 'Success',
            description: 'The text is shown as the title of a success toast notification that appears in the consent banner after the user successfully saves their cookie preferences.'
        }),
        spacing: (0, $e6Qdr.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $4944dd5bffdba7ae$var$ErrorWithIntl = (0, $3SD6z.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h82Rb))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.error',
            defaultMessage: 'Error',
            description: 'The title for an error as a single word.'
        }),
        spacing: (0, $e6Qdr.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $4944dd5bffdba7ae$var$errorToastProps = ()=>({
        icon: /*#__PURE__*/ (0, $gWgPx.jsx)($4944dd5bffdba7ae$var$ErrorWithIntl, {}),
        appearance: 'normal'
    });
const $4944dd5bffdba7ae$var$successToastProps = ()=>({
        icon: /*#__PURE__*/ (0, $gWgPx.jsx)($4944dd5bffdba7ae$var$SuccessWithIntl, {}),
        appearance: 'normal',
        isAutoDismiss: true
    });
const $4944dd5bffdba7ae$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, newMinHeight: newMinHeight, ssrOptions: ssrOptions, perimeter: perimeter = 'commercial' })=>{
    const firstRender = (0, $8P7DW.useRef)(true);
    (0, $8P7DW.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $hamKY.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $gLTQj.deleteCookie)((0, $9655j.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $8P7DW.useEffect)(()=>{
        if ((0, $e6Qdr.fg)('fedramp-consent-banner-perimeter-prop')) (0, $5hOMA.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode,
            perimeter: perimeter
        });
        else (0, $5hOMA.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode,
        perimeter
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $8P7DW.useState)(false);
    const intl = (0, $k7INq.default)();
    const { showFlag: showFlag } = (0, $fToTc.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $k0Hun.default)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $heayX.default)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender,
        ssrOptions: ssrOptions
    });
    const closePreferenceModal = (0, $8P7DW.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $8P7DW.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $8P7DW.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $hamKY.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $8P7DW.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...$4944dd5bffdba7ae$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $hbH2u.i18n).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $hbH2u.i18n).successFlagTitle)
        });
        else showFlag({
            ...$4944dd5bffdba7ae$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $hbH2u.i18n).successFlagDescription),
            title: intl.formatMessage((0, $hbH2u.i18n).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $8P7DW.useCallback)(()=>{
        showFlag({
            ...$4944dd5bffdba7ae$var$errorToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $hbH2u.i18n).errorFlagDescription),
            title: intl.formatMessage((0, $hbH2u.i18n).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $8P7DW.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $hamKY.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $j4pBQ.updatePreferences)((0, $9655j.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $hamKY.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $9655j.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $8P7DW.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $hamKY.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $j4pBQ.updatePreferences)((0, $9655j.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $hamKY.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $9655j.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $8P7DW.useCallback)(()=>{
        (0, $hamKY.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    (0, $8P7DW.useEffect)(()=>{
        if (showBanner) (0, $aEpPp.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true
        });
        if (showBanner) onShow === null || onShow === void 0 || onShow();
        else if (!showBanner) onHide === null || onHide === void 0 || onHide();
    }, [
        showBanner,
        onShow,
        onHide
    ]);
    (0, $8P7DW.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 || onConsentBannerBailOut();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fToTc.FlagsProvider), {
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $jbZd2.BSCIntlProvider), {
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $5L9bY.PresentationalConsentBanner), {
                    onClickOnlyNecessary: onClickOnlyNecessary,
                    onClickAcceptAll: onClickAcceptAll,
                    onClickPreferences: onClickPreferences,
                    onClickTrackingNoticeLink: onClickTrackingNoticeLink,
                    minWidth: minWidth,
                    newMinHeight: newMinHeight
                }),
                isPreferencesModalOpen && /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6xP82.PreferenceModal), {
                    onClose: closePreferenceModal,
                    onSubmit: onPreferenceModalSubmit,
                    showSuccessFlag: showSuccessFlag,
                    showErrorFlag: showErrorFlag,
                    shouldAddWrappers: false
                })
            ]
        })
    });
};

});
parcelRegister("5hOMA", function(module, exports) {
$parcel$export(module.exports, "initializeGlobalState", () => $914671d7bf0d3aa5$export$882c4530c58781d8);

var $1pfMV = parcelRequire("1pfMV");

var $8Bt4H = parcelRequire("8Bt4H");

var $e6Qdr = parcelRequire("e6Qdr");

var $hQwKE = parcelRequire("hQwKE");

var $1FKAh = parcelRequire("1FKAh");

var $gc3OY = parcelRequire("gc3OY");

var $5ROjv = parcelRequire("5ROjv");
const $914671d7bf0d3aa5$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, indexedDbEnabled: indexedDbEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, disableIndexedDbConsentChecks: disableIndexedDbConsentChecks, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter = 'commercial', analyticsEnabled: analyticsEnabled = true, userId: userId, cloudId: cloudId, overrideOnceParams: overrideOnceParams = false } = {})=>{
    (0, $gc3OY.Logger).debug('Initialize global state invoked');
    const productGlobalState = (0, $5ROjv.__internalGetProductGlobalState)();
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) (0, $5ROjv.__internalApplyInitialState)({
        productGlobalState: product
    });
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    const webStorageControlsEnabledGlobalState = (0, $5ROjv.__internalGetWebStorageControlsEnabledGlobalState)();
    if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) (0, $5ROjv.__internalApplyInitialState)({
        webStorageControlsEnabledGlobalState: webStorageEnabled && !(0, $e6Qdr.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $e6Qdr.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const indexedDbControlsEnabledGlobalState = (0, $5ROjv.__internalGetIndexedDbControlsEnabledGlobalState)();
    if (indexedDbEnabled !== undefined && indexedDbControlsEnabledGlobalState === undefined) (0, $5ROjv.__internalApplyInitialState)({
        indexedDbControlsEnabledGlobalState: indexedDbEnabled && !(0, $e6Qdr.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $e6Qdr.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const allowUncategorizedCookiesInOverridesGlobalState = (0, $5ROjv.__internalGetAllowUncategorizedCookiesInOverridesGlobalState)();
    if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) (0, $5ROjv.__internalApplyInitialState)({
        allowUncategorizedCookiesInOverridesGlobalState: allowUncategorizedCookiesInOverrides
    });
    const disableIndexedDbConsentChecksGlobalState = (0, $5ROjv.__internalGetDisableIndexedDbConsentChecksGlobalState)();
    if (disableIndexedDbConsentChecks !== undefined && disableIndexedDbConsentChecksGlobalState === undefined) (0, $5ROjv.__internalApplyInitialState)({
        disableIndexedDbConsentChecksGlobalState: disableIndexedDbConsentChecks
    });
    // All other state can only be initialized once and is defaulted if not passed on the first initialization.
    // overrideOnceParams allows a subsequent call (e.g. from initializeControls) to bypass this guard
    // and re-apply these parameters, correcting values that were defaulted by an earlier accidental call
    // (e.g. from ConsentBannerImpl before initializeControls has run).
    // This behaviour is gated behind the fedramp-consent-banner-perimeter-prop feature flag.
    if ((0, $5ROjv.__internalGetHasInitialized)() && !(overrideOnceParams && (0, $e6Qdr.fg)('fedramp-consent-banner-perimeter-prop'))) return;
    let localConsentModeGlobalState;
    if ((0, $e6Qdr.fg)('jfp-magma-aem-cookie-check')) // Force local consent mode when ConsentHub is not enabled because ConsentHub is
    // not hydrated in the perimeter as of this comment
    localConsentModeGlobalState = localConsentMode || !(0, $1pfMV.isFeatureEnabled)('consent-platform', 'consenthub');
    else // Force local consent mode when in the FedRAMP Moderate perimeter because ConsentHub is
    // not hydrated in the perimeter as of this comment
    localConsentModeGlobalState = localConsentMode || perimeter === 'fedramp-moderate';
    const cookiesCacheLoader = new (0, $1FKAh.CacheLoader)((0, $hQwKE.CategoryStorageType).Cookies, perimeter);
    const localStorageCacheLoader = new (0, $1FKAh.CacheLoader)((0, $hQwKE.CategoryStorageType).LocalStorage, perimeter);
    const sessionStorageCacheLoader = new (0, $1FKAh.CacheLoader)((0, $hQwKE.CategoryStorageType).SessionStorage, perimeter);
    const indexedDBCacheLoader = new (0, $1FKAh.CacheLoader)((0, $hQwKE.CategoryStorageType).IndexedDB, perimeter);
    let packageDebugModeEnabledGlobalState;
    if ((0, $e6Qdr.fg)('platform_moonjelly_bsc_debug_mode')) packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).get('atl-bsc-debug-mode'));
    const updates = {
        localConsentModeGlobalState: localConsentModeGlobalState,
        analyticsEnabledGlobalState: analyticsEnabled,
        perimeterGlobalState: perimeter,
        cookiesCacheLoader: cookiesCacheLoader,
        localStorageCacheLoader: localStorageCacheLoader,
        sessionStorageCacheLoader: sessionStorageCacheLoader,
        indexedDBCacheLoader: indexedDBCacheLoader,
        packageDebugModeEnabledGlobalState: packageDebugModeEnabledGlobalState,
        hasInitialized: true
    };
    if (cloudId) updates.cloudIdGlobalState = cloudId;
    if (userId) updates.userIdGlobalState = userId;
    (0, $5ROjv.__internalApplyInitialState)(updates);
};

});
parcelRegister("1FKAh", function(module, exports) {
$parcel$export(module.exports, "CacheLoader", () => $de00c98aad79b81c$export$e479342c697b82a9);

var $e6Qdr = parcelRequire("e6Qdr");

var $2lzZD = parcelRequire("2lzZD");
var $ghwxF = parcelRequire("ghwxF");

var $gc3OY = parcelRequire("gc3OY");

var $9F6T2 = parcelRequire("9F6T2");
class $de00c98aad79b81c$export$e479342c697b82a9 {
    constructor(storageType, perimeter = 'commercial'){
        const shouldUseBifrost = (0, $e6Qdr.fg)('platform_atlassian_cookies_use_bifrost_source');
        this.shouldUseBifrost = shouldUseBifrost;
        const cacheUrlLookup = (0, $9F6T2.getCategoryCacheUrlPerimeterLookup)(shouldUseBifrost)[perimeter] || (0, $9F6T2.getCommercialCategoryCacheUrlLookup)(shouldUseBifrost);
        this.cacheUrl = cacheUrlLookup[storageType];
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        let fetchExperience = null;
        if (isFetchTrackingSampled) {
            fetchExperience = new (0, $ghwxF.UFOExperience)('browser-storage-controls-fetch-time', {
                type: (0, $2lzZD.ExperienceTypes).Load,
                performanceType: (0, $2lzZD.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $gc3OY.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            if (this.shouldUseBifrost) (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'bifrostLoadStorageControlsError',
                message: e.message || ''
            });
            else (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("9F6T2", function(module, exports) {
$parcel$export(module.exports, "getCommercialCategoryCacheUrlLookup", () => $aed57bd063374715$export$5989415260e0cf82);
$parcel$export(module.exports, "getCategoryCacheUrlPerimeterLookup", () => $aed57bd063374715$export$9797a362f9385b1a);

var $hQwKE = parcelRequire("hQwKE");
var $aed57bd063374715$export$40467b362aa82ae = /*#__PURE__*/ function(Sources) {
    Sources["BIFROST"] = "bifrost";
    Sources["CLOUDFRONT_S3"] = "cloudfrontS3";
    return Sources;
}({});
var $aed57bd063374715$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    FileType["COOKIE"] = "COOKIE";
    FileType["LOCAL_STORAGE"] = "LOCAL_STORAGE";
    FileType["SESSION_STORAGE"] = "SESSION_STORAGE";
    FileType["INDEXED_DB"] = "INDEXED_DB";
    return FileType;
}({});
const $aed57bd063374715$var$generateResourcePath = (source, perimeter, storageType)=>{
    const baseCloudfrontS3CommercialPath = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/';
    const baseCloudfrontS3FedrampPath = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/';
    const baseBifrostCommercialPath = 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
    const baseBifrostFedrampPath = 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';
    const fileName = `categories_${storageType}.json`;
    if (source === "cloudfrontS3") switch(perimeter){
        case 'fedramp-moderate':
            return `${baseCloudfrontS3FedrampPath}${fileName}`;
        case 'commercial':
            return `${baseCloudfrontS3CommercialPath}${fileName}`;
        default:
            return `${baseCloudfrontS3CommercialPath}${fileName}`;
    }
    switch(perimeter){
        case 'fedramp-moderate':
            return `${baseBifrostFedrampPath}${fileName}`;
        case 'commercial':
            return `${baseBifrostCommercialPath}${fileName}`;
        default:
            return `${baseBifrostCommercialPath}${fileName}`;
    }
};
const $aed57bd063374715$export$5989415260e0cf82 = (shouldUseBifrostSources)=>{
    const distribution = shouldUseBifrostSources ? "bifrost" : "cloudfrontS3";
    return {
        [(0, $hQwKE.CategoryStorageType).Cookies]: $aed57bd063374715$var$generateResourcePath(distribution, 'commercial', "COOKIE"),
        [(0, $hQwKE.CategoryStorageType).LocalStorage]: $aed57bd063374715$var$generateResourcePath(distribution, 'commercial', "LOCAL_STORAGE"),
        [(0, $hQwKE.CategoryStorageType).SessionStorage]: $aed57bd063374715$var$generateResourcePath(distribution, 'commercial', "SESSION_STORAGE"),
        [(0, $hQwKE.CategoryStorageType).IndexedDB]: $aed57bd063374715$var$generateResourcePath(distribution, 'commercial', "INDEXED_DB")
    };
};
const $aed57bd063374715$export$9797a362f9385b1a = (shouldUseBifrostSources)=>{
    const distribution = shouldUseBifrostSources ? "bifrost" : "cloudfrontS3";
    return {
        commercial: $aed57bd063374715$export$5989415260e0cf82(shouldUseBifrostSources),
        'fedramp-moderate': {
            [(0, $hQwKE.CategoryStorageType).Cookies]: $aed57bd063374715$var$generateResourcePath(distribution, 'fedramp-moderate', "COOKIE"),
            [(0, $hQwKE.CategoryStorageType).LocalStorage]: $aed57bd063374715$var$generateResourcePath(distribution, 'fedramp-moderate', "LOCAL_STORAGE"),
            [(0, $hQwKE.CategoryStorageType).SessionStorage]: $aed57bd063374715$var$generateResourcePath(distribution, 'fedramp-moderate', "SESSION_STORAGE"),
            [(0, $hQwKE.CategoryStorageType).IndexedDB]: $aed57bd063374715$var$generateResourcePath(distribution, 'fedramp-moderate', "INDEXED_DB")
        }
    };
};
const $aed57bd063374715$export$1f60178895e28eb8 = (source, perimeter, storageType)=>$aed57bd063374715$var$generateResourcePath(source, perimeter, storageType);

});



parcelRegister("jbZd2", function(module, exports) {
$parcel$export(module.exports, "BSCIntlProvider", () => $d64569ffb1198248$export$9aa38aed134c207f);

var $gWgPx = parcelRequire("gWgPx");
parcelRequire("8P7DW");

var $iaiGc = parcelRequire("iaiGc");

var $ORS6S = parcelRequire("ORS6S");
var $hLnan = parcelRequire("hLnan");
const $d64569ffb1198248$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iaiGc.default), {
        defaultMessages: (0, $ORS6S.default),
        loaderFn: (0, $hLnan.fetchMessagesForLocale),
        children: children
    });
};

});
parcelRegister("ORS6S", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $cc01c07e715f6de5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $f4WBt = parcelRequire("f4WBt");
var $cc01c07e715f6de5$export$2e2bcd8739ae039 = (0, $f4WBt.default);

});
parcelRegister("f4WBt", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4ffd61001161663$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a4ffd61001161663$export$2e2bcd8739ae039 = {
    'browser-storage-controls.consent-banner-modal.analytical.description.101024': 'Measures usage to improve product performance.',
    'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify': 'Measures usage to improve app performance.',
    'browser-storage-controls.consent-banner-modal.analytical.option.082624': 'Allow analytical cookies',
    'browser-storage-controls.consent-banner-modal.cancel.button': 'Cancel',
    'browser-storage-controls.consent-banner-modal.confirm.button': 'Confirm',
    'browser-storage-controls.consent-banner-modal.functional.description.082624': 'Provides enhanced functionality and personalization.',
    'browser-storage-controls.consent-banner-modal.functional.option.082624': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.marketing.description.082624': 'Used for targeted advertising.',
    'browser-storage-controls.consent-banner-modal.marketing.option.082624': 'Allow marketing cookies',
    'browser-storage-controls.consent-banner-modal.strict.description.082624': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.strict.description.082624-appify': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.summary.description.082624': 'Because we value your privacy, you can select which cookies you allow. {link}',
    'browser-storage-controls.consent-banner-modal.title': 'Cookie preferences',
    'browser-storage-controls.consent-banner-modal.tracking.link.082624': 'Review our cookies and tracking notice',
    'browser-storage-controls.consent-banner.accept-all.button': 'Accept all',
    'browser-storage-controls.consent-banner.cookies-description.text': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
    'browser-storage-controls.consent-banner.cookies-description.text.no.link': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
    'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024': 'Atlassian cookies and tracking notice',
    'browser-storage-controls.consent-banner.error-flag.description': 'Try again in a few minutes.',
    'browser-storage-controls.consent-banner.error-flag.title': "We're unable to update the policy",
    'browser-storage-controls.consent-banner.only-necessary.button': 'Only necessary',
    'browser-storage-controls.consent-banner.preferences.button': 'Preferences',
    'browser-storage-controls.consent-banner.success-flag.description': 'You can change this at any time in your Atlassian account.',
    'browser-storage-controls.consent-banner.success-flag.description-local-only': 'Your preferences will only affect this site.',
    'browser-storage-controls.consent-banner.success-flag.title': 'Cookie preferences saved',
    'browser-storage-controls.consent-banner.toast.error': 'Error',
    'browser-storage-controls.consent-banner.toast.success': 'Success'
};

});


parcelRegister("hLnan", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $a759d06d88df1836$export$2b153a2030b0feb2);

var $ORS6S = parcelRequire("ORS6S");




























const $a759d06d88df1836$var$locales = {
    cs: ()=>(parcelRequire("flgtH")),
    da: ()=>(parcelRequire("dgqNz")),
    de: ()=>(parcelRequire("8V5fy")),
    'en-GB': ()=>(parcelRequire("8yIAw")),
    'en-ZZ': ()=>(parcelRequire("5GGCx")),
    en: ()=>Promise.resolve((parcelRequire("ORS6S"))),
    es: ()=>(parcelRequire("76Xbt")),
    fi: ()=>(parcelRequire("ftrFp")),
    fr: ()=>(parcelRequire("20eJJ")),
    hu: ()=>(parcelRequire("l6qvm")),
    it: ()=>(parcelRequire("ffe2a")),
    ja: ()=>(parcelRequire("7GnwX")),
    ko: ()=>(parcelRequire("bq1rN")),
    nb: ()=>(parcelRequire("kCaH0")),
    nl: ()=>(parcelRequire("fKEYL")),
    pl: ()=>(parcelRequire("8w0wA")),
    'pt-BR': ()=>(parcelRequire("hJCkB")),
    ru: ()=>(parcelRequire("h5Qw9")),
    sl: ()=>(parcelRequire("aHCC2")),
    sr_RS: ()=>(parcelRequire("3fzTD")),
    sr_YR: ()=>(parcelRequire("kpb2l")),
    sv: ()=>(parcelRequire("gC1vI")),
    th: ()=>(parcelRequire("aZLgE")),
    tr: ()=>(parcelRequire("kPJtx")),
    uk: ()=>(parcelRequire("2BWVQ")),
    vi: ()=>(parcelRequire("li69s")),
    zh_TW: ()=>(parcelRequire("8wFon")),
    zh: ()=>(parcelRequire("cvriu"))
};
const $a759d06d88df1836$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await $a759d06d88df1836$var$locales[locale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await $a759d06d88df1836$var$locales[parentLocale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("flgtH", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("lmLo0").then(()=>parcelRequire('lGbyT'));

});

parcelRegister("dgqNz", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("3alnu").then(()=>parcelRequire('74oEn'));

});

parcelRegister("8V5fy", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("kntEJ").then(()=>parcelRequire('50f1X'));

});

parcelRegister("8yIAw", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("k5gUU").then(()=>parcelRequire('3oDPm'));

});

parcelRegister("5GGCx", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("64cIe").then(()=>parcelRequire('hkhF8'));

});

parcelRegister("76Xbt", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("eQwsx").then(()=>parcelRequire('aXa89'));

});

parcelRegister("ftrFp", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("6XbH3").then(()=>parcelRequire('3Rk7f'));

});

parcelRegister("20eJJ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("RJUqW").then(()=>parcelRequire('bkOxj'));

});

parcelRegister("l6qvm", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("jifqm").then(()=>parcelRequire('fLmbq'));

});

parcelRegister("ffe2a", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("6hl6c").then(()=>parcelRequire('fW73e'));

});

parcelRegister("7GnwX", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("kTjV0").then(()=>parcelRequire('aPMVz'));

});

parcelRegister("bq1rN", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("6mwsz").then(()=>parcelRequire('bIif5'));

});

parcelRegister("kCaH0", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("jyy1G").then(()=>parcelRequire('aMkDS'));

});

parcelRegister("fKEYL", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("eJSuu").then(()=>parcelRequire('4Mq0C'));

});

parcelRegister("8w0wA", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("fGjBe").then(()=>parcelRequire('kdgqK'));

});

parcelRegister("hJCkB", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("4woC5").then(()=>parcelRequire('4vCRP'));

});

parcelRegister("h5Qw9", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("7lJq7").then(()=>parcelRequire('kEHeV'));

});

parcelRegister("aHCC2", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("36dws").then(()=>parcelRequire('hvl7j'));

});

parcelRegister("3fzTD", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("keKgk").then(()=>parcelRequire('9TuMK'));

});

parcelRegister("kpb2l", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("76oX5").then(()=>parcelRequire('77RcA'));

});

parcelRegister("gC1vI", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("4GR1r").then(()=>parcelRequire('3n6TN'));

});

parcelRegister("aZLgE", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("fkEqm").then(()=>parcelRequire('hC5F2'));

});

parcelRegister("kPJtx", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("kq6dv").then(()=>parcelRequire('b0u4C'));

});

parcelRegister("2BWVQ", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("hUr2g").then(()=>parcelRequire('lzpAf'));

});

parcelRegister("li69s", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("dVrX1").then(()=>parcelRequire('cHQyu'));

});

parcelRegister("8wFon", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("3Pumw").then(()=>parcelRequire('8dOIo'));

});

parcelRegister("cvriu", function(module, exports) {

var $j9MRt = parcelRequire("j9MRt");
module.exports = $j9MRt("jmwCp").then(()=>parcelRequire('6F0CB'));

});



parcelRegister("gLTQj", function(module, exports) {
$parcel$export(module.exports, "deleteCookie", () => $f2e6aec8a7a8021b$export$b43e45590305ffaa);

var $8Bt4H = parcelRequire("8Bt4H");

var $e6Qdr = parcelRequire("e6Qdr");

var $hamKY = parcelRequire("hamKY");

var $gc3OY = parcelRequire("gc3OY");
const $f2e6aec8a7a8021b$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $e6Qdr.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).remove(key, attributes);
    else try {
        (0, $hamKY.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8Bt4H))).remove(key, attributes);
    } catch (e) {
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});

parcelRegister("j4pBQ", function(module, exports) {
$parcel$export(module.exports, "updatePreferences", () => $5144d85812ac6e1d$export$7bb3e177c1a1e841);

var $5ROjv = parcelRequire("5ROjv");

var $9655j = parcelRequire("9655j");

var $hQwKE = parcelRequire("hQwKE");

var $d3WR6 = parcelRequire("d3WR6");

var $4DT4d = parcelRequire("4DT4d");

var $68rNz = parcelRequire("68rNz");
const $5144d85812ac6e1d$var$emptyDisplayedTextMap = {
    [(0, $hQwKE.PreferenceCategory).Analytics]: '',
    [(0, $hQwKE.PreferenceCategory).Functional]: '',
    [(0, $hQwKE.PreferenceCategory).Marketing]: '',
    [(0, $hQwKE.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $hQwKE.PreferenceCategory).Unknown]: ''
};
async function $5144d85812ac6e1d$export$7bb3e177c1a1e841(preferences, displayedTextMap = $5144d85812ac6e1d$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $5ROjv.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $68rNz.packUserPreferences)(preferences);
        (0, $4DT4d.setStrictlyNecessaryCookie)((0, $9655j.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $d3WR6.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}

});
parcelRegister("d3WR6", function(module, exports) {
$parcel$export(module.exports, "setConsentToken", () => $c49837f74cf83633$export$fbf549fe6f0e91dc);

var $gc3OY = parcelRequire("gc3OY");

var $bh4gv = parcelRequire("bh4gv");

var $5Vfju = parcelRequire("5Vfju");

var $hQwKE = parcelRequire("hQwKE");

var $fX4zd = parcelRequire("fX4zd");

var $68rNz = parcelRequire("68rNz");

var $a10av = parcelRequire("a10av");
const $c49837f74cf83633$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, $68rNz.packUserPreferences)(mergedPrefs);
    // Check if the token is prefetched and set to default.
    if (usingPrefetchedData && (0, $5Vfju.checkIfTokenIsDefault)(consentToken)) return;
    if (usingPrefetchedData) (0, $a10av.onlySetFallbackIfDifferent)(consentToken);
    else (0, $fX4zd.setConsentTokenFallbackCookie)(consentToken);
    (0, $fX4zd.setConsentTokenCookie)(consentToken);
    (0, $fX4zd.setShouldShowBannerCookie)(consentToken);
};
const $c49837f74cf83633$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $5Vfju.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $5Vfju.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $68rNz.packUserPreferences)({
        ...mergedPrefs,
        [(0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible // Indicates we were unable to hit ConsentHub when the consents were created
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $gc3OY.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $a10av.onlySetFallbackIfDifferent)(consentToken);
        (0, $fX4zd.setConsentTokenCookie)(consentToken);
        (0, $fX4zd.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down > 10 minute expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $gc3OY.Logger).error('Token failed to save');
    (0, $a10av.onlySetFallbackIfDifferent)(consentToken);
    (0, $fX4zd.setShouldShowBannerCookie)(consentToken);
};
const $c49837f74cf83633$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $a10av.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $bh4gv.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $c49837f74cf83633$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $c49837f74cf83633$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};

});
parcelRegister("a10av", function(module, exports) {
$parcel$export(module.exports, "mergeConsentUpdates", () => $8241283c22ef28b4$export$c0214a364df3006f);
$parcel$export(module.exports, "onlySetFallbackIfDifferent", () => $8241283c22ef28b4$export$a023a0b818522757);

var $9655j = parcelRequire("9655j");

var $hQwKE = parcelRequire("hQwKE");

var $eKc2n = parcelRequire("eKc2n");

var $fX4zd = parcelRequire("fX4zd");

var $68rNz = parcelRequire("68rNz");
const $8241283c22ef28b4$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $hQwKE.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $hQwKE.PreferenceCategory).StrictlyNecessary],
        [(0, $hQwKE.PreferenceCategory).Functional]: updatedPreferences[(0, $hQwKE.PreferenceCategory).Functional],
        [(0, $hQwKE.PreferenceCategory).Analytics]: updatedPreferences[(0, $hQwKE.PreferenceCategory).Analytics],
        [(0, $hQwKE.PreferenceCategory).Marketing]: updatedPreferences[(0, $hQwKE.PreferenceCategory).Marketing],
        [(0, $hQwKE.PreferenceCategory).Unknown]: updatedPreferences[(0, $hQwKE.PreferenceCategory).Unknown]
    };
};
const $8241283c22ef28b4$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences === null || consentPreferences === void 0 ? void 0 : consentPreferences[(0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!(consentPreferences !== null && consentPreferences !== void 0 && consentPreferences[(0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable]);
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!(consentPreferences !== null && consentPreferences !== void 0 && consentPreferences[(0, $hQwKE.ContextualConsentProperty).ConsentsAreDefault]);
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $hQwKE.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $hQwKE.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $hQwKE.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $8241283c22ef28b4$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $68rNz.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $9655j.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$8241283c22ef28b4$var$pruneLegacyProperties(updatedPreferences),
            ...$8241283c22ef28b4$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $9655j.DEFAULT_PREFERENCES),
            ...$8241283c22ef28b4$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $9655j.DEFAULT_PREFERENCES),
        ...$8241283c22ef28b4$var$pruneLegacyProperties(updatedPreferences),
        ...$8241283c22ef28b4$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $8241283c22ef28b4$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $fX4zd.setConsentTokenFallbackCookie)(consentToken);
};

});



parcelRegister("hbH2u", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $91c52b751e14c6eb$export$a7357cdd1f0b0168);

var $6K2Gm = parcelRequire("6K2Gm");
const $91c52b751e14c6eb$export$a7357cdd1f0b0168 = (0, $6K2Gm.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024',
        defaultMessage: 'Atlassian cookies and tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    useCookiesDescriptionNoLink: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text.no.link',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});

});

parcelRegister("6xP82", function(module, exports) {
$parcel$export(module.exports, "PreferenceModal", () => $f773437626f0fb80$export$94c5684831c222e7);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fToTc = parcelRequire("fToTc");

var $e6Qdr = parcelRequire("e6Qdr");

var $hamKY = parcelRequire("hamKY");

var $jbZd2 = parcelRequire("jbZd2");

var $gc3OY = parcelRequire("gc3OY");

var $9655j = parcelRequire("9655j");

var $j4pBQ = parcelRequire("j4pBQ");

var $cGjL2 = parcelRequire("cGjL2");

var $k0Hun = parcelRequire("k0Hun");
const $f773437626f0fb80$export$94c5684831c222e7 = (props)=>{
    if ((0, $e6Qdr.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $e6Qdr.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)($f773437626f0fb80$export$30df3cfccbe10e6e, {
        ...props
    });
};
const $f773437626f0fb80$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag, shouldAddWrappers: shouldAddWrappers = true })=>{
    const [isModalOpen, setIsModalOpen] = (0, $8P7DW.useState)(true);
    const isEventSent = (0, $8P7DW.useRef)(false);
    (0, $8P7DW.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $hamKY.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $k0Hun.default)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $9655j.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $8P7DW.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $hamKY.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $j4pBQ.updatePreferences)(selectedPreferences, displayedTextMap);
                (0, $hamKY.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag === null || showSuccessFlag === void 0 || showSuccessFlag();
            } catch (e) {
                (0, $gc3OY.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
            }
            setIsModalOpen(false);
            onSubmit === null || onSubmit === void 0 || onSubmit();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    const modalContent = /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cGjL2.PresentationalPreferenceModal), {
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences ?? (0, $9655j.ONLY_NECESSARY_PREFERENCES),
        setPreferencesData: setPreferencesData
    });
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gWgPx.Fragment), {
        children: shouldAddWrappers ? /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fToTc.FlagsProvider), {
            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $jbZd2.BSCIntlProvider), {
                children: modalContent
            })
        }) : modalContent
    });
};

});
parcelRegister("cGjL2", function(module, exports) {
$parcel$export(module.exports, "PresentationalPreferenceModal", () => $648bb17640918a75$export$9921ee7829a3ba4);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");
var $k7INq = parcelRequire("k7INq");

var $ifRQf = parcelRequire("ifRQf");

var $iRXci = parcelRequire("iRXci");

var $iqJis = parcelRequire("iqJis");

var $cdPbd = parcelRequire("cdPbd");
var $gtaKc = parcelRequire("gtaKc");
var $7KiOn = parcelRequire("7KiOn");
var $fCWQD = parcelRequire("fCWQD");
var $33zHl = parcelRequire("33zHl");
var $4pgQo = parcelRequire("4pgQo");

var $e6Qdr = parcelRequire("e6Qdr");

var $n1BUj = parcelRequire("n1BUj");
var $6Hfjm = parcelRequire("6Hfjm");
var $2IKBM = parcelRequire("2IKBM");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $hamKY = parcelRequire("hamKY");

var $dfiNJ = parcelRequire("dfiNJ");

var $hQwKE = parcelRequire("hQwKE");

var $fKs5l = parcelRequire("fKs5l");

var $inCgD = parcelRequire("inCgD");
const $648bb17640918a75$var$categoryNameStyles = (0, $37U6z.xcss)({
    fontWeight: 'font.weight.bold'
});
const $648bb17640918a75$var$customHeaderStyles = (0, $37U6z.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const $648bb17640918a75$var$extractTextFromReactNode = (node)=>{
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($648bb17640918a75$var$extractTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).isValidElement(node)) {
        if (node.props.children) return $648bb17640918a75$var$extractTextFromReactNode(node.props.children);
    }
    return '';
};
const $648bb17640918a75$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $inCgD.i18n).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $inCgD.i18n).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $e6Qdr.fg)('product-terminology-refresh') ? (0, $inCgD.i18n).strictDescriptionAppify : (0, $inCgD.i18n).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = $648bb17640918a75$var$extractTextFromReactNode(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $648bb17640918a75$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $hQwKE.PreferenceCategory).Functional,
            title: (0, $inCgD.i18n).functionalOption,
            description: (0, $inCgD.i18n).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $hQwKE.PreferenceCategory).Analytics,
            title: (0, $inCgD.i18n).analyticalOption,
            description: (0, $e6Qdr.fg)('product-terminology-refresh') ? (0, $inCgD.i18n).analyticalOptionDescriptionAppify : (0, $inCgD.i18n).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $hQwKE.PreferenceCategory).Marketing,
            title: (0, $inCgD.i18n).marketingOption,
            description: (0, $inCgD.i18n).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $dfiNJ.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $648bb17640918a75$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Hfjm.default), {
                xcss: $648bb17640918a75$var$categoryNameStyles,
                children: translatedTitle
            }),
            descriptionElement: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Hfjm.default), {
                children: translatedDescription
            }),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $648bb17640918a75$var$noop = ()=>{};
const $648bb17640918a75$var$CustomHeader = ({ onClose: onClose })=>{
    const { titleId: titleId } = (0, $4pgQo.useModal)();
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6Hfjm.default), {
        xcss: $648bb17640918a75$var$customHeaderStyles,
        padding: "space.300",
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $cdPbd.CloseButton), {
                onClick: onClose,
                testId: "close-modal-button"
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iqJis.default), {
                as: "h1",
                size: "medium",
                id: titleId,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                    ...(0, $inCgD.i18n).title
                })
            })
        ]
    });
};
const $648bb17640918a75$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $648bb17640918a75$var$noop, onSubmit: onSubmit = $648bb17640918a75$var$noop, onClose: onClose = $648bb17640918a75$var$noop, setIsOpen: setIsOpen = $648bb17640918a75$var$noop })=>{
    const intl = (0, $k7INq.default)();
    const onCloseModal = (0, $8P7DW.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $8P7DW.useCallback)(()=>{
        onCloseModal();
        (0, $hamKY.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickClose = (0, $8P7DW.useCallback)(()=>{
        onCloseModal();
        (0, $hamKY.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'close',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $8P7DW.useCallback)(()=>{
        onCloseModal();
        (0, $hamKY.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $8P7DW.useCallback)(()=>{
        (0, $hamKY.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $8P7DW.useMemo)(()=>{
        return $648bb17640918a75$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $8P7DW.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $33zHl.default), {
        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $gtaKc.default), {
            onClose: onClickBackground,
            children: (0, $e6Qdr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $iRXci.default), {
                onSubmit: handleSubmission,
                children: [
                    /*#__PURE__*/ (0, $gWgPx.jsx)($648bb17640918a75$var$CustomHeader, {
                        onClose: onClickClose
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $7KiOn.default), {
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6Hfjm.default), {
                                children: [
                                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                        ...(0, $inCgD.i18n).summaryDescription,
                                        values: {
                                            link: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $n1BUj.default), {
                                                href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                                                target: "_blank",
                                                onClick: onClickTrackingNoticeLink,
                                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                                    ...(0, $inCgD.i18n).trackingLink
                                                })
                                            })
                                        },
                                        tagName: 'p'
                                    }),
                                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                        ...(0, $e6Qdr.fg)('product-terminology-refresh') ? (0, $inCgD.i18n).strictDescriptionAppify : (0, $inCgD.i18n).strictDescription,
                                        values: {
                                            bold: (msg)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $7zDtY.default), {
                                                    weight: "bold",
                                                    children: msg
                                                })
                                        },
                                        tagName: 'p'
                                    })
                                ]
                            }),
                            cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2IKBM.default), {
                                    children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fKs5l.CookieCategorySection), {
                                        category: category,
                                        titleElement: titleElement,
                                        titleString: titleString,
                                        descriptionElement: description,
                                        isChecked: (preferences && preferences[category]) ?? false,
                                        setPreferencesData: setPreferencesData
                                    })
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $fCWQD.default), {
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                                appearance: "subtle",
                                onClick: onClickCancel,
                                testId: "consent-preference-cancel",
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                    ...(0, $inCgD.i18n).cancelBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                                type: "submit",
                                appearance: "primary",
                                onClick: handleSubmission,
                                testId: "consent-preference-confirm",
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                    ...(0, $inCgD.i18n).confirmBtn
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $gWgPx.jsx)((0, $iRXci.default), {
                onSubmit: handleSubmission,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $gWgPx.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)($648bb17640918a75$var$CustomHeader, {
                                onClose: onClickClose
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $7KiOn.default), {
                                children: [
                                    /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6Hfjm.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                                ...(0, $inCgD.i18n).summaryDescription,
                                                values: {
                                                    link: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $n1BUj.default), {
                                                        href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                                                        target: "_blank",
                                                        onClick: onClickTrackingNoticeLink,
                                                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                                            ...(0, $inCgD.i18n).trackingLink
                                                        })
                                                    })
                                                },
                                                tagName: 'p'
                                            }),
                                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                                ...(0, $e6Qdr.fg)('product-terminology-refresh') ? (0, $inCgD.i18n).strictDescriptionAppify : (0, $inCgD.i18n).strictDescription,
                                                values: {
                                                    bold: (msg)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $7zDtY.default), {
                                                            weight: "bold",
                                                            children: msg
                                                        })
                                                },
                                                tagName: 'p'
                                            })
                                        ]
                                    }),
                                    cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, $gWgPx.jsx)((0, $2IKBM.default), {
                                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fKs5l.CookieCategorySection), {
                                                category: category,
                                                titleElement: titleElement,
                                                titleString: titleString,
                                                descriptionElement: description,
                                                isChecked: (preferences && preferences[category]) ?? false,
                                                setPreferencesData: setPreferencesData
                                            })
                                        }, index))
                                ]
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $fCWQD.default), {
                                children: [
                                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                                        appearance: "subtle",
                                        onClick: onClickCancel,
                                        testId: "consent-preference-cancel",
                                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                            ...(0, $inCgD.i18n).cancelBtn
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                                        type: "submit",
                                        appearance: "primary",
                                        onClick: handleSubmission,
                                        testId: "consent-preference-confirm",
                                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                            ...(0, $inCgD.i18n).confirmBtn
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        })
    });
};

});
parcelRegister("n1BUj", function(module, exports) {
$parcel$export(module.exports, "default", () => $c86aaa4e437cffbe$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8P7DW = parcelRequire("8P7DW");

var $8Z0o8 = parcelRequire("8Z0o8");

var $clS24 = parcelRequire("clS24");

var $aeYmt = parcelRequire("aeYmt");

var $8PtDM = parcelRequire("8PtDM");

var $5J6r2 = parcelRequire("5J6r2");

var $fnhqr = parcelRequire("fnhqr");

var $9uKqY = parcelRequire("9uKqY");

var $dojiU = parcelRequire("dojiU");

var $j4RVe = parcelRequire("j4RVe");

var $37U6z = parcelRequire("37U6z");
function $c86aaa4e437cffbe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $c86aaa4e437cffbe$var$focusRingStyles = /*#__PURE__*/ (0, $8Z0o8.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $j4RVe.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $j4RVe.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $j4RVe.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $j4RVe.borderWidthMap)['border.width']} solid`
        }
    }
});
const $c86aaa4e437cffbe$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $c86aaa4e437cffbe$var$positionStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $c86aaa4e437cffbe$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $c86aaa4e437cffbe$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $c86aaa4e437cffbe$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $c86aaa4e437cffbe$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $5J6r2.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $8P7DW.useContext)((0, $9uKqY.default));
    const handleClick = (0, $8P7DW.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $fnhqr.useId)();
    const onClick = (0, $aeYmt.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $37U6z.parseXcss)(xcss);
    const RouterLink = (0, $8PtDM.default)();
    const isExternal = typeof href === 'string' && $c86aaa4e437cffbe$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $c86aaa4e437cffbe$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $clS24.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $8Z0o8.jsx)(Component, {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $c86aaa4e437cffbe$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $c86aaa4e437cffbe$var$baseStyles,
            $c86aaa4e437cffbe$var$positionStyles,
            $c86aaa4e437cffbe$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $j4RVe.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $j4RVe.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $j4RVe.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $j4RVe.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $j4RVe.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $j4RVe.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $j4RVe.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $j4RVe.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $8Z0o8.jsx)((0, $dojiU.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $c86aaa4e437cffbe$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $c86aaa4e437cffbe$var$Anchor = /*#__PURE__*/ (0, $8P7DW.forwardRef)($c86aaa4e437cffbe$var$AnchorNoRef);
var $c86aaa4e437cffbe$export$2e2bcd8739ae039 = $c86aaa4e437cffbe$var$Anchor;

});

parcelRegister("dfiNJ", function(module, exports) {
$parcel$export(module.exports, "CONSENT_DISPLAYED_TEXT_ITEMS", () => $c57619c08f0d6e6b$export$99df83ca0f45bd54);

var $hQwKE = parcelRequire("hQwKE");
const $c57619c08f0d6e6b$export$99df83ca0f45bd54 = [
    (0, $hQwKE.PreferenceCategory).Analytics,
    (0, $hQwKE.PreferenceCategory).Functional,
    (0, $hQwKE.PreferenceCategory).Marketing,
    (0, $hQwKE.PreferenceCategory).StrictlyNecessary,
    (0, $hQwKE.PreferenceCategory).Unknown
];

});

parcelRegister("fKs5l", function(module, exports) {
$parcel$export(module.exports, "CookieCategorySection", () => $97490df288f1f9b6$export$3c97a3b492e10ae9);

var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $esBnn = parcelRequire("esBnn");

var $e6Qdr = parcelRequire("e6Qdr");

var $6Hfjm = parcelRequire("6Hfjm");
var $7zDtY = parcelRequire("7zDtY");
var $37U6z = parcelRequire("37U6z");

var $hamKY = parcelRequire("hamKY");

var $hQwKE = parcelRequire("hQwKE");
const $97490df288f1f9b6$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $97490df288f1f9b6$var$categoryBoxStyles = (0, $37U6z.xcss)({
    paddingBlockStart: 'space.200'
});
const $97490df288f1f9b6$var$categoryDescriptionStyles = (0, $37U6z.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $97490df288f1f9b6$var$categoryToEventSubjectMap = {
    [(0, $hQwKE.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $hQwKE.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $hQwKE.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $hQwKE.PreferenceCategory).Unknown]: null,
    [(0, $hQwKE.PreferenceCategory).StrictlyNecessary]: null
};
const $97490df288f1f9b6$var$categoryToTestIdMap = {
    [(0, $hQwKE.PreferenceCategory).StrictlyNecessary]: null,
    [(0, $hQwKE.PreferenceCategory).Analytics]: 'analytics',
    [(0, $hQwKE.PreferenceCategory).Functional]: 'functional',
    [(0, $hQwKE.PreferenceCategory).Marketing]: 'marketing',
    [(0, $hQwKE.PreferenceCategory).Unknown]: null
};
const $97490df288f1f9b6$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $8P7DW.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $hQwKE.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $97490df288f1f9b6$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $hamKY.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    const descriptionId = (0, $e6Qdr.fg)('cookies-modal-include-id-for-category-description') ? `consent-preference-${$97490df288f1f9b6$var$categoryToTestIdMap[category]}-description` : undefined;
    return /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $6Hfjm.default), {
        xcss: $97490df288f1f9b6$var$categoryBoxStyles,
        children: [
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $esBnn.default), {
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
                className: `${$97490df288f1f9b6$var$tmpTrelloClassNameOverride}`,
                isChecked: isChecked,
                value: isChecked.toString(),
                onChange: onCheckboxChange,
                label: titleElement,
                name: `${titleString}`,
                testId: `consent-preference-${$97490df288f1f9b6$var$categoryToTestIdMap[category]}`,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Hfjm.default), {
                xcss: $97490df288f1f9b6$var$categoryDescriptionStyles,
                id: descriptionId,
                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $7zDtY.default), {
                    size: "small",
                    color: "color.text.subtle",
                    children: descriptionElement
                })
            })
        ]
    });
};

});

parcelRegister("inCgD", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $5a7f5941a3f85e77$export$a7357cdd1f0b0168);

var $6K2Gm = parcelRequire("6K2Gm");
const $5a7f5941a3f85e77$export$a7357cdd1f0b0168 = (0, $6K2Gm.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'The text is shown as the heading at the top of the cookie preferences modal dialog, which allows users to manage and configure their browser cookie and storage settings.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    },
    strictDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624-appify',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    analyticalOptionDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify',
        defaultMessage: 'Measures usage to improve app performance.',
        description: 'Cookie preferences modal analytical option description.'
    }
});

});


parcelRegister("k0Hun", function(module, exports) {
$parcel$export(module.exports, "default", () => $b850f291df2b545a$export$2e2bcd8739ae039);

var $8P7DW = parcelRequire("8P7DW");

var $68rNz = parcelRequire("68rNz");

var $ilbEc = parcelRequire("ilbEc");

var $j4pBQ = parcelRequire("j4pBQ");
/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $b850f291df2b545a$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $ilbEc.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $b850f291df2b545a$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
   * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
   *  during the initial render. Without this flag, the application might incorrectly display a banner based on
   * incomplete or missing preference data. During the rehydration process, this initial render triggers
   * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
   * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
   * and the client-rendered state.
   */ const isInitialRender = (0, $8P7DW.useRef)(true);
    const prefetchedPreferencesData = (0, $8P7DW.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $8P7DW.useState)((0, $68rNz.initializePreferencesData)(initialPreferences));
    (0, $8P7DW.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $68rNz.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $j4pBQ.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $b850f291df2b545a$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.prefs,
        isPrefetchedPreferencesState: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $b850f291df2b545a$export$2e2bcd8739ae039 = $b850f291df2b545a$var$usePreferences;

});


parcelRegister("5L9bY", function(module, exports) {
$parcel$export(module.exports, "PresentationalConsentBanner", () => $faf425bd366b5157$export$dd3e60478510f81d);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $gWgPx = parcelRequire("gWgPx");

var $8P7DW = parcelRequire("8P7DW");

var $fiikg = parcelRequire("fiikg");
var $k7INq = parcelRequire("k7INq");

var $ifRQf = parcelRequire("ifRQf");

var $izQyW = parcelRequire("izQyW");

var $1EFS8 = parcelRequire("1EFS8");

var $bHKCU = parcelRequire("bHKCU");

var $e6Qdr = parcelRequire("e6Qdr");

var $n1BUj = parcelRequire("n1BUj");
var $6Hfjm = parcelRequire("6Hfjm");
var $ktwNU = parcelRequire("ktwNU");
var $37U6z = parcelRequire("37U6z");

var $2Mjg8 = parcelRequire("2Mjg8");

var $ea6bZ = parcelRequire("ea6bZ");

var $dfiNJ = parcelRequire("dfiNJ");

var $hbH2u = parcelRequire("hbH2u");
const $faf425bd366b5157$var$boxStylesBlueWithMinHeight = (0, $37U6z.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.information',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $faf425bd366b5157$var$boxStylesPurpleWithMinHeight = (0, $37U6z.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.discovery',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $faf425bd366b5157$var$noticeContainerStyles = (0, $37U6z.xcss)({
    flexDirection: 'column'
});
const $faf425bd366b5157$var$experimentContainerStyles = (0, $37U6z.xcss)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200'
});
const $faf425bd366b5157$var$inlineWrapperStylesStaticHeight = (0, $37U6z.xcss)({
    // Small & Medium viewport defaults
    gap: 'space.100',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    [(0, $2Mjg8.media).above.md]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $faf425bd366b5157$var$buttonContainerStylesStaticHeight = (0, $37U6z.xcss)({
    minWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $2Mjg8.media).above.md]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $faf425bd366b5157$var$truncatedTextStyles = (0, $37U6z.xcss)({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    flex: '0 1 auto'
});
const $faf425bd366b5157$var$linkNoTruncateStyles = (0, $37U6z.xcss)({
    flex: '0 0 auto',
    whiteSpace: 'nowrap'
});
const $faf425bd366b5157$var$smallMediumScreenContainerStyles = (0, $37U6z.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.050',
    alignItems: 'baseline',
    [(0, $2Mjg8.media).above.md]: {
        display: 'none'
    }
});
const $faf425bd366b5157$var$largeScreenContainerStyles = (0, $37U6z.xcss)({
    display: 'none',
    [(0, $2Mjg8.media).above.md]: {
        display: 'block'
    }
});
const $faf425bd366b5157$var$noop = ()=>{};
const $faf425bd366b5157$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $dfiNJ.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $hbH2u.i18n).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $hbH2u.i18n).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $faf425bd366b5157$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $hbH2u.i18n).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $hbH2u.i18n).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $faf425bd366b5157$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $faf425bd366b5157$var$noop, onClickAcceptAll: onClickAcceptAll = $faf425bd366b5157$var$noop, onClickPreferences: onClickPreferences = $faf425bd366b5157$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $faf425bd366b5157$var$noop, minWidth: minWidth = 400, newMinHeight: newMinHeight = 105 })=>{
    const isCookiesBannerExperimentEnabled = (0, $1EFS8.default).getExperimentValue('cookies_banner_redesign_experiment', 'isEnabled', false);
    const useNewAtlaskitButton = (0, $e6Qdr.fg)('cookies_banner_use_new_atlaskit_button');
    const intl = (0, $k7INq.default)();
    const displayedTextMap = (0, $8P7DW.useMemo)(()=>{
        return $faf425bd366b5157$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $8P7DW.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $faf425bd366b5157$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $8P7DW.useCallback)(()=>{
        const displayedTextAcceptAllMap = $faf425bd366b5157$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Hfjm.default), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: isCookiesBannerExperimentEnabled ? $faf425bd366b5157$var$boxStylesPurpleWithMinHeight : $faf425bd366b5157$var$boxStylesBlueWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`,
            height: `${newMinHeight}px`
        },
        children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $ktwNU.default), {
            xcss: $faf425bd366b5157$var$inlineWrapperStylesStaticHeight,
            children: [
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ktwNU.default), {
                    xcss: isCookiesBannerExperimentEnabled ? $faf425bd366b5157$var$experimentContainerStyles : $faf425bd366b5157$var$noticeContainerStyles,
                    children: /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $ktwNU.default), {
                                xcss: $faf425bd366b5157$var$smallMediumScreenContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ea6bZ.default), {
                                        content: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                            ...(0, $hbH2u.i18n).useCookiesDescriptionNoLink
                                        }),
                                        position: "top",
                                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ktwNU.default), {
                                            xcss: $faf425bd366b5157$var$truncatedTextStyles,
                                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                                ...(0, $hbH2u.i18n).useCookiesDescriptionNoLink,
                                                tagName: "span"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $gWgPx.jsx)((0, $n1BUj.default), {
                                        id: "cookiesTrackingNoticeLink",
                                        href: "https://www.atlassian.com/legal/cookies",
                                        target: "_blank",
                                        onClick: onClickTrackingNoticeLink,
                                        xcss: $faf425bd366b5157$var$linkNoTruncateStyles,
                                        children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                            ...(0, $hbH2u.i18n).cookiesTrackingNotice
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $6Hfjm.default), {
                                xcss: $faf425bd366b5157$var$largeScreenContainerStyles,
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                    ...(0, $hbH2u.i18n).useCookiesDescription,
                                    tagName: "span",
                                    values: {
                                        linkToCookiesTrackingNotice: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $n1BUj.default), {
                                            id: "cookiesTrackingNoticeLink",
                                            href: "https://www.atlassian.com/legal/cookies",
                                            target: "_blank",
                                            onClick: onClickTrackingNoticeLink,
                                            children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                                ...(0, $hbH2u.i18n).cookiesTrackingNotice
                                            })
                                        })
                                    }
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ktwNU.default), {
                    space: "space.100",
                    xcss: $faf425bd366b5157$var$buttonContainerStylesStaticHeight,
                    children: useNewAtlaskitButton ? /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                                testId: "preferences-button",
                                appearance: "subtle",
                                onClick: onClickPreferences,
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                    ...(0, $hbH2u.i18n).preferencesBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                                testId: "only-necessary-button",
                                onClick: handleOnlyNecessaryClick,
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                    ...(0, $hbH2u.i18n).onlyNecessaryBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $izQyW.default), {
                                testId: "accept-all-button",
                                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bHKCU))),
                                onClick: handleAcceptAllClick,
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                    ...(0, $hbH2u.i18n).acceptAllBtn
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $gWgPx.jsxs)((0, $gWgPx.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                                testId: "preferences-button",
                                appearance: "subtle",
                                onClick: onClickPreferences,
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                    ...(0, $hbH2u.i18n).preferencesBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                                testId: "only-necessary-button",
                                onClick: handleOnlyNecessaryClick,
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                    ...(0, $hbH2u.i18n).onlyNecessaryBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $gWgPx.jsx)((0, $ifRQf.default), {
                                testId: "accept-all-button",
                                iconBefore: /*#__PURE__*/ (0, $gWgPx.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bHKCU))), {
                                    color: "currentColor",
                                    spacing: "none",
                                    testId: "experiment-one-button-icon",
                                    label: ""
                                }),
                                onClick: handleAcceptAllClick,
                                children: /*#__PURE__*/ (0, $gWgPx.jsx)((0, $fiikg.default), {
                                    ...(0, $hbH2u.i18n).acceptAllBtn
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});

parcelRegister("heayX", function(module, exports) {
$parcel$export(module.exports, "default", () => $329c11b0d9a55139$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $5ROjv = parcelRequire("5ROjv");
var $hamKY = parcelRequire("hamKY");

var $7ca6J = parcelRequire("7ca6J");

var $9655j = parcelRequire("9655j");

var $6g3lw = parcelRequire("6g3lw");

var $4DT4d = parcelRequire("4DT4d");

var $eKc2n = parcelRequire("eKc2n");

var $68rNz = parcelRequire("68rNz");

var $5Vfju = parcelRequire("5Vfju");

var $hQwKE = parcelRequire("hQwKE");
/**
 * @private
 * @deprecated Legacy SSR banner visibility check that doesn't consider fallbackConsentToken.
 * Kept only as the feature-gate-off fallback for 'platform_moonjelly_bsc_ssr_banner_flash_fix'.
 * Will be removed once the gate is fully rolled out.
 */ const $329c11b0d9a55139$var$shouldShowBannerInSSRContextLegacy = (initialPreferences)=>{
    if (!initialPreferences || initialPreferences === (0, $hQwKE.PrefetchedPreferenceState).INTERNAL || (0, $68rNz.initialPreferencesAreMissing)(initialPreferences)) return true;
    return !(0, $5Vfju.hasPrefetchedDataConsents)(initialPreferences);
};
const $329c11b0d9a55139$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences, ssrOptions)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = ssrOptions !== null && ssrOptions !== void 0 && ssrOptions.getCookie ? ssrOptions.getCookie((0, $9655j.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)) : (0, $eKc2n.getCookie)((0, $9655j.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if (((ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) ?? (0, $7ca6J.isSSR)()) || inFlowWhereBannerStateIsUnknown) {
        // When coming from SSR, this hook will only execute once and won't update later
        // Instead, if we're on the server, have initial preference data with valid consents, don't render
        // On later checks (rehydration), this will always fail and skip to the normal rendering logic
        // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
        // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
        // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
        if (initialPreferences === (0, $hQwKE.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
        // if the user has consented or not yet since we need to fetch, so show the banner
        return true;
        if ((0, $e6Qdr.fg)('platform_moonjelly_bsc_ssr_banner_flash_fix')) // shouldRenderBannerPrefetched is the single source of truth for SSR/hydration banner visibility.
        // It is used here and by all external consumers (e.g. useCookiesConsentBanner) to guarantee
        // consistent decisions, including correct handling of fallbackConsentToken.
        //
        // Cast: PrefetchedConsentPreferenceData is a narrower type than PrefetchedConsentPreferences —
        // it excludes PrefetchedPreferenceState (handled above) but is otherwise compatible at this call site.
        return (0, $6g3lw.shouldRenderBannerPrefetched)(initialPreferences, ssrOptions);
        // Legacy path: uses hasPrefetchedDataConsents which doesn't consider fallbackConsentToken.
        // This path will be removed once the feature gate is fully rolled out.
        return $329c11b0d9a55139$var$shouldShowBannerInSSRContextLegacy(initialPreferences);
    }
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $329c11b0d9a55139$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, ssrOptions: ssrOptions })=>{
    const isEventSent = (0, $8P7DW.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $8P7DW.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $4DT4d.setStrictlyNecessaryCookie)((0, $9655j.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $8P7DW.useMemo)(()=>{
        return $329c11b0d9a55139$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed,
            ssrOptions: ssrOptions
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        ssrOptions
    ]);
    (0, $8P7DW.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $hamKY.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $329c11b0d9a55139$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed, ssrOptions: ssrOptions })=>{
    if ((0, $5ROjv.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if ((ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) ?? (0, $7ca6J.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $329c11b0d9a55139$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences, ssrOptions);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $329c11b0d9a55139$export$2e2bcd8739ae039 = $329c11b0d9a55139$var$useBannerVisibility;

});
parcelRegister("6g3lw", function(module, exports) {
$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $41069ec11dcfcda4$export$6406464aa126433e);

var $e6Qdr = parcelRequire("e6Qdr");

var $bh4gv = parcelRequire("bh4gv");

var $5Vfju = parcelRequire("5Vfju");

var $68rNz = parcelRequire("68rNz");

var $2BDRp = parcelRequire("2BDRp");
const $41069ec11dcfcda4$export$6406464aa126433e = (prefetchedPreferencesData, ssrOptions)=>{
    if ((0, $e6Qdr.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $68rNz.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $2BDRp.getBannerVisibility)(prefetchedPreferencesData, ssrOptions) : true;
    }
    // We've been given ConsentHub response data
    // Check if we have consents via prefetched data
    // to prevent mismatches where space is reserved but UI doesn't render
    const prefetchedDataHasConsents = (0, $5Vfju.hasPrefetchedDataConsents)(prefetchedPreferencesData);
    if (prefetchedDataHasConsents) return false;
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, $bh4gv.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $2BDRp.getBannerVisibility)(consentPrefsData, ssrOptions);
};

});




parcelRegister("etQ5W", function(module, exports) {
$parcel$export(module.exports, "initializeControls", () => $15b0762058d155be$export$919040c32a62c7db);

var $e6Qdr = parcelRequire("e6Qdr");

var $hamKY = parcelRequire("hamKY");
var $7ca6J = parcelRequire("7ca6J");
var $gc3OY = parcelRequire("gc3OY");

var $5ROjv = parcelRequire("5ROjv");
var $5hOMA = parcelRequire("5hOMA");
parcelRequire("ir9tA");
var $gkonM = parcelRequire("gkonM");

var $6DjF3 = parcelRequire("6DjF3");

var $Omzyx = parcelRequire("Omzyx");

var $a1NX0 = parcelRequire("a1NX0");
const $15b0762058d155be$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $e6Qdr.fg)('platform_moonjelly_bsc_master_killswitch')) // Exit if the master killswitch is enabled
    return;
    try {
        (0, $gc3OY.Logger).debug('initializeControls invoked');
        if ((0, $e6Qdr.fg)('fedramp-consent-banner-perimeter-prop')) (0, $5hOMA.initializeGlobalState)({
            ...args,
            overrideOnceParams: true
        });
        else (0, $5hOMA.initializeGlobalState)(args);
        // Exit silently if in SSR context
        if ((0, $7ca6J.isSSR)()) return;
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $hamKY.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, $6DjF3.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, $5ROjv.getBscGlobalState)().webStorageEnabled;
        if (isWebStorageControlsEnabled) {
            await (0, $a1NX0.createWebStoragePassthrough)((0, $gkonM.WebStorageType).LocalStorage);
            await (0, $a1NX0.createWebStoragePassthrough)((0, $gkonM.WebStorageType).SessionStorage);
        }
        const isIndexedDbEnabled = (0, $5ROjv.getBscGlobalState)().indexedDbEnabled;
        if (isIndexedDbEnabled) {
            const disableIndexedDbConsentChecks = (0, $5ROjv.getBscGlobalState)().disableIndexedDbConsentChecks ?? false;
            await (0, $Omzyx.createIndexedDBPassthrough)({
                performConsentChecks: !disableIndexedDbConsentChecks
            });
        }
        (0, $gc3OY.Logger).debug('initializeControls finished');
    } catch (e) {
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
};

});
parcelRegister("6DjF3", function(module, exports) {
$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $135a25fb4da90f79$export$45a5573b04db016c);

var $gc3OY = parcelRequire("gc3OY");

var $13RPv = parcelRequire("13RPv");
const $135a25fb4da90f79$export$45a5573b04db016c = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.set;
    const originalGetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.get;
    if (!originalSetter || !originalGetter) {
        (0, $gc3OY.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $13RPv.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};

});
parcelRegister("13RPv", function(module, exports) {
$parcel$export(module.exports, "getSetCookieOverride", () => $615121cbcdecb318$export$b7364c41ddbfdb0a);

var $5ROjv = parcelRequire("5ROjv");
var $hamKY = parcelRequire("hamKY");

var $hamKY = parcelRequire("hamKY");

var $l8Zmx = parcelRequire("l8Zmx");

var $gc3OY = parcelRequire("gc3OY");

var $hQwKE = parcelRequire("hQwKE");
const $615121cbcdecb318$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $hamKY.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $5ROjv.getBscGlobalState)().product;
                // Attempt to set a known cookie that was set from outside the package
                (0, $l8Zmx.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory })=>{
                        const isOverrideEventSampled = !Math.floor(Math.random() * 10);
                        if (isOverrideEventSampled) (0, $hamKY.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: (0, $hQwKE.CategoryStorageType).Cookies,
                                productName: productName,
                                originalItemKey: sanitizedCookieKey,
                                itemCategory: itemCategory ?? null
                            }
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $5ROjv.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else return;
                    },
                    storageType: (0, $hQwKE.CategoryStorageType).Cookies,
                    productName: productName
                });
            } catch (e) {
                (0, $gc3OY.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };

});


parcelRegister("Omzyx", function(module, exports) {
$parcel$export(module.exports, "createIndexedDBPassthrough", () => $8b3a10ef7fffd15b$export$a03098708eb0de1);

var $gc3OY = parcelRequire("gc3OY");

var $9FVGP = parcelRequire("9FVGP");
const $8b3a10ef7fffd15b$export$a03098708eb0de1 = async (config)=>{
    const indexedDB = window.indexedDB;
    if (!indexedDB) {
        (0, $gc3OY.Logger).warn('No IndexedDB capabilities found');
        return;
    }
    if (typeof indexedDB.open !== 'function') {
        (0, $gc3OY.Logger).warn('IndexedDB.open is not a function');
        return;
    }
    try {
        const originalOpen = indexedDB.open.bind(indexedDB);
        (0, $gc3OY.Logger).debug(`Installing IndexedDB override ${config.performConsentChecks ? 'with' : 'without'} consent checks`);
        // Use Object.defineProperty for better browser compatibility and consistency
        // with other passthrough implementations (document.cookie, localStorage/sessionStorage)
        Object.defineProperty(indexedDB, 'open', {
            value: config.performConsentChecks ? (0, $9FVGP.getIndexedDBOpenOverride)(originalOpen) : (0, $9FVGP.getIndexedDBOpenOverrideEventOnly)(originalOpen),
            writable: true,
            configurable: true
        });
        (0, $gc3OY.Logger).debug('IndexedDB open override installed');
    } catch (e) {
        (0, $gc3OY.Logger).error(`Failed to install IndexedDB open override. ${e.message || ''}`);
    }
};

});
parcelRegister("9FVGP", function(module, exports) {
$parcel$export(module.exports, "getIndexedDBOpenOverrideEventOnly", () => $3ed31a8368e0a083$export$5a412306febb78c);
$parcel$export(module.exports, "getIndexedDBOpenOverride", () => $3ed31a8368e0a083$export$5721aa15a04b1881);

var $5ROjv = parcelRequire("5ROjv");
var $hamKY = parcelRequire("hamKY");

var $l8Zmx = parcelRequire("l8Zmx");

var $gc3OY = parcelRequire("gc3OY");

var $kiiP9 = parcelRequire("kiiP9");

var $foPVm = parcelRequire("foPVm");

var $hKmJJ = parcelRequire("hKmJJ");

var $hQwKE = parcelRequire("hQwKE");
// DatabaseBlockedError extends DOMException in browser environments, but DOMException is not
// available in SSR/Node.js, which causes import errors. We conditionally extend DOMException
// only when it is available, falling back to a plain Error in SSR — the same pattern used
// for IDBOpenDBRequestWrapper.
let $3ed31a8368e0a083$var$DatabaseBlockedError;
if (typeof DOMException !== 'undefined') $3ed31a8368e0a083$var$DatabaseBlockedError = class DatabaseBlockedError extends DOMException {
};
else $3ed31a8368e0a083$var$DatabaseBlockedError = class DatabaseBlockedError extends Error {
    constructor(message, name = 'DatabaseBlockedError'){
        super(message), this.name = name;
    }
};
const $3ed31a8368e0a083$var$checkAndSendAnalyticsEvent = async (eventDetails)=>{
    const wasSetByPackage = (0, $hKmJJ.ItemKeyCache).wasSetByPackage((0, $hQwKE.CategoryStorageType).IndexedDB, eventDetails.databaseName);
    const productName = (0, $5ROjv.getBscGlobalState)().product;
    const itemCategory = await (0, $l8Zmx.getItemCategory)(eventDetails.databaseName, (0, $hQwKE.CategoryStorageType).IndexedDB, productName);
    const isStrictlyNecessary = itemCategory === (0, $hQwKE.PreferenceCategory).StrictlyNecessary;
    if (!isStrictlyNecessary && !wasSetByPackage) {
        const attributes = {
            ...eventDetails,
            productName: productName,
            outsidePackage: true
        };
        // Send analytics event for uncategorized IndexedDB usage
        (0, $hamKY.sendPackageOperationalEvent)({
            action: 'usedAtlIndexedDBOpen',
            attributes: attributes
        });
    }
};
const $3ed31a8368e0a083$var$checkIfAllowed = async (dbName)=>{
    if (!(0, $foPVm.isValidDBName)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, $gc3OY.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName: dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, $5ROjv.getBscGlobalState)().product;
    return await (0, $l8Zmx.isProcessingAllowedByPreferences)({
        itemKey: dbName,
        storageType: (0, $hQwKE.CategoryStorageType).IndexedDB,
        productName: productName
    });
};
const $3ed31a8368e0a083$export$5a412306febb78c = (originalOpen)=>(databaseName, version)=>{
        $3ed31a8368e0a083$var$checkAndSendAnalyticsEvent({
            databaseName: databaseName
        }).catch((e)=>{
            (0, $gc3OY.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
        });
        // Always allow the operation to proceed (we're only tracking usage)
        return originalOpen(databaseName, version);
    };
const $3ed31a8368e0a083$export$5721aa15a04b1881 = (originalOpen)=>(databaseName, version)=>{
        const wasSetByPackage = (0, $hKmJJ.ItemKeyCache).wasSetByPackage((0, $hQwKE.CategoryStorageType).IndexedDB, databaseName);
        if (wasSetByPackage) return originalOpen(databaseName, version);
        (0, $gc3OY.Logger).debug(`IndexedDB operation: overridden open on database \"${databaseName}\"`, {
            version: String(version ?? 'unspecified')
        });
        const requestWrapper = (0, $kiiP9.createIDBOpenDBRequestWrapper)();
        $3ed31a8368e0a083$var$checkIfAllowed(databaseName).then((isAllowed)=>{
            (0, $hamKY.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpen',
                attributes: {
                    databaseName: databaseName,
                    wasRejected: !isAllowed,
                    outsidePackage: true
                }
            });
            if (isAllowed) {
                (0, $gc3OY.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was ALLOWED`, {
                    version: String(version ?? 'unspecified')
                });
                const actualRequest = originalOpen(databaseName, version);
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, $gc3OY.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was REJECTED`, {
                    version: String(version ?? 'unspecified')
                });
                const error = new $3ed31a8368e0a083$var$DatabaseBlockedError('The database was blocked by consent preferences', 'storageItemBlocked');
                const errorEvent = new ErrorEvent('error', {
                    message: error.message,
                    error: error
                });
                requestWrapper.setError(error);
                requestWrapper.dispatchEvent(errorEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $gc3OY.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" ERROR: ${errorMessage}`, {
                version: String(version ?? 'unspecified')
            });
            (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: databaseName,
                    outsidePackage: true
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage,
                error: e
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    };

});
parcelRegister("kiiP9", function(module, exports) {
$parcel$export(module.exports, "createIDBOpenDBRequestWrapper", () => $480b24f6e857b145$export$4037ef1f5b40c4b6);

var $36kyW = parcelRequire("36kyW");

var $7ca6J = parcelRequire("7ca6J");

var $lozxH = parcelRequire("lozxH");
// Store the browser implementation class here - defined conditionally below
let $480b24f6e857b145$var$BrowserImpl;
/**
 * Browser-only implementation that extends EventTarget.
 * Only defined in browser environments where EventTarget is available.
 * This conditional definition prevents "EventTarget is not defined" errors in SSR.
 */ if (typeof EventTarget !== 'undefined') // Define the class inside this block so it's never parsed in SSR
$480b24f6e857b145$var$BrowserImpl = class IDBOpenDBRequestWrapperImpl extends EventTarget {
    // Implementing IDBRequest readonly properties with getters
    get error() {
        var _this$_wrappedRequest;
        return ((_this$_wrappedRequest = this._wrappedRequest) === null || _this$_wrappedRequest === void 0 ? void 0 : _this$_wrappedRequest.error) ?? this._error;
    }
    get result() {
        var _this$_wrappedRequest2;
        return ((_this$_wrappedRequest2 = this._wrappedRequest) === null || _this$_wrappedRequest2 === void 0 ? void 0 : _this$_wrappedRequest2.result) ?? this._result;
    }
    get readyState() {
        var _this$_wrappedRequest3;
        return ((_this$_wrappedRequest3 = this._wrappedRequest) === null || _this$_wrappedRequest3 === void 0 ? void 0 : _this$_wrappedRequest3.readyState) ?? this._readyState;
    }
    get source() {
        var _this$_wrappedRequest4;
        return ((_this$_wrappedRequest4 = this._wrappedRequest) === null || _this$_wrappedRequest4 === void 0 ? void 0 : _this$_wrappedRequest4.source) ?? this._source;
    }
    get transaction() {
        var _this$_wrappedRequest5;
        return ((_this$_wrappedRequest5 = this._wrappedRequest) === null || _this$_wrappedRequest5 === void 0 ? void 0 : _this$_wrappedRequest5.transaction) ?? this._transaction;
    }
    /**
     * Wrap an existing IDBOpenDBRequest to proxy its events to this wrapper.
     * Once wrapped, all property getters will delegate to the wrapped request,
     * and all events from the wrapped request will be re-dispatched on this wrapper.
     *
     * @param request - The real IDBOpenDBRequest to wrap
     */ wrapRequest(request) {
        if (this._wrappedRequest) throw new Error('This IDBOpenDBRequestWrapper is already wrapping another request');
        this._wrappedRequest = request;
        // Proxy all events from the wrapped request to this wrapper using bindAll
        this._unbindEventListeners = (0, $36kyW.bindAll)(request, [
            {
                type: 'success',
                listener: (e)=>{
                    this.dispatchEvent(new Event('success', e));
                }
            },
            {
                type: 'error',
                listener: (e)=>{
                    this.dispatchEvent(new Event('error', e));
                }
            },
            {
                type: 'blocked',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('blocked', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            },
            {
                type: 'upgradeneeded',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('upgradeneeded', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            }
        ]);
    }
    /**
     * Check if this mock is wrapping a real request
     */ isWrapping() {
        return this._wrappedRequest !== null;
    }
    /**
     * Get the wrapped request (if any)
     */ getWrappedRequest() {
        return this._wrappedRequest;
    }
    /**
     * Unbind all event listeners attached to the wrapped request.
     * Should be called when the wrapper is no longer needed.
     */ unbind() {
        if (this._unbindEventListeners) {
            this._unbindEventListeners();
            this._unbindEventListeners = null;
        }
        this._wrappedRequest = null;
    }
    /**
     * Set the error property (normally readonly)
     * Only works when not wrapping another request
     */ setError(error) {
        if (this._wrappedRequest) throw new Error('Cannot set error on a wrapping IDBOpenDBRequestWrapper');
        this._error = error;
    }
    /**
     * Set the result property (normally readonly)
     * Only works when not wrapping another request
     */ setResult(result) {
        if (this._wrappedRequest) throw new Error('Cannot set result on a wrapping IDBOpenDBRequestWrapper');
        this._result = result;
    }
    /**
     * Set the readyState property (normally readonly)
     * Only works when not wrapping another request
     */ setReadyState(state) {
        if (this._wrappedRequest) throw new Error('Cannot set readyState on a wrapping IDBOpenDBRequestWrapper');
        this._readyState = state;
    }
    /**
     * Set the source property (normally readonly)
     * Only works when not wrapping another request
     */ setSource(source) {
        if (this._wrappedRequest) throw new Error('Cannot set source on a wrapping IDBOpenDBRequestWrapper');
        this._source = source;
    }
    /**
     * Set the transaction property (normally readonly)
     * Only works when not wrapping another request
     */ setTransaction(transaction) {
        if (this._wrappedRequest) throw new Error('Cannot set transaction on a wrapping IDBOpenDBRequestWrapper');
        this._transaction = transaction;
    }
    /**
     * Override dispatchEvent to also call the corresponding event handler if set
     */ dispatchEvent(event) {
        const result = super.dispatchEvent(event);
        // Call the appropriate event handler if it exists
        switch(event.type){
            case 'error':
                if (this.onerror) this.onerror.call(this, event);
                break;
            case 'success':
                if (this.onsuccess) this.onsuccess.call(this, event);
                break;
            case 'blocked':
                if (this.onblocked) this.onblocked.call(this, event);
                break;
            case 'upgradeneeded':
                if (this.onupgradeneeded) this.onupgradeneeded.call(this, event);
                break;
        }
        return result;
    }
    constructor(...args){
        super(...args), this._error = null, this._result = null, this._readyState = 'pending', this._source = null, this._transaction = null, this._wrappedRequest = null, this._unbindEventListeners = null, // Event handler properties (can be set directly by consumers)
        this.onerror = null, this.onsuccess = null, this.onblocked = null, this.onupgradeneeded = null;
    }
};
function $480b24f6e857b145$export$4037ef1f5b40c4b6() {
    if ((0, $7ca6J.isSSR)() || typeof EventTarget === 'undefined' || !$480b24f6e857b145$var$BrowserImpl) return new (0, $lozxH.IDBOpenDBRequestNoOp)();
    return new $480b24f6e857b145$var$BrowserImpl();
}
const $480b24f6e857b145$export$c69b1cb39abae960 = $480b24f6e857b145$var$BrowserImpl;

});
parcelRegister("lozxH", function(module, exports) {
$parcel$export(module.exports, "IDBOpenDBRequestNoOp", () => $64012eb07f4ab9c4$export$55ffeaf417e03b66);
/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */ class $64012eb07f4ab9c4$export$55ffeaf417e03b66 {
    get error() {
        return this._error;
    }
    get result() {
        return this._result;
    }
    get readyState() {
        return this._readyState;
    }
    get source() {
        return this._source;
    }
    get transaction() {
        return this._transaction;
    }
    // No-op event methods for SSR
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return false;
    }
    // Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
    wrapRequest() {
        throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
    }
    isWrapping() {
        return false;
    }
    getWrappedRequest() {
        return null;
    }
    unbind() {}
    setError(error) {
        this._error = error;
    }
    setResult(result) {
        this._result = result;
    }
    setReadyState(state) {
        this._readyState = state;
    }
    setSource(source) {
        this._source = source;
    }
    setTransaction(transaction) {
        this._transaction = transaction;
    }
    constructor(){
        this._error = null;
        this._result = null;
        this._readyState = 'pending';
        this._source = null;
        this._transaction = null;
        this.onerror = null;
        this.onsuccess = null;
        this.onblocked = null;
        this.onupgradeneeded = null;
    }
}

});


parcelRegister("foPVm", function(module, exports) {
$parcel$export(module.exports, "isValidDBName", () => $580477daeeabc839$export$a5be9a74f3347ccf);

var $5ROjv = parcelRequire("5ROjv");
var $7ca6J = parcelRequire("7ca6J");
function $580477daeeabc839$export$ae0d255aec75942(enableSSRCheck = true, enableFeatureFlagCheck = true) {
    // Check if running in SSR environment
    if (enableSSRCheck && (0, $7ca6J.isSSR)()) return {
        available: false,
        reason: 'IndexedDB is not available in SSR environment'
    };
    if (!globalThis.indexedDB) return {
        available: false,
        reason: 'IndexedDB is not supported in this browser'
    };
    if (enableFeatureFlagCheck) {
        const globalState = (0, $5ROjv.getBscGlobalState)();
        if (globalState.indexedDbEnabled === false) return {
            available: true,
            reason: 'Using native IndexedDB: IndexedDB controls are disabled',
            bypassImplementation: true
        };
    }
    return {
        available: true
    };
}
function $580477daeeabc839$export$a5be9a74f3347ccf(dbName) {
    // Database name should not be empty and should be a string
    return typeof dbName === 'string' && dbName.trim().length > 0;
}
function $580477daeeabc839$export$396291456af4fc3(version) {
    // Version should be undefined or a positive integer
    if (version === undefined) return true;
    return Number.isInteger(version) && version > 0;
}

});

parcelRegister("hKmJJ", function(module, exports) {
$parcel$export(module.exports, "ItemKeyCache", () => $0a9411127a7ae743$export$ff3c91e80f54f26c);

var $hQwKE = parcelRequire("hQwKE");
class $0a9411127a7ae743$var$ItemKeyCacheService {
    constructor(){
        this.cache = Object.fromEntries(Object.keys((0, $hQwKE.CategoryStorageType)).map((storageType)=>{
            return [
                storageType,
                new Set()
            ];
        }));
    }
    markSetByPackage(storageType, itemKey) {
        this.cache[storageType].add(itemKey);
    }
    wasSetByPackage(storageType, itemKey) {
        return this.cache[storageType].has(itemKey);
    }
}
const $0a9411127a7ae743$export$ff3c91e80f54f26c = new $0a9411127a7ae743$var$ItemKeyCacheService();

});



parcelRegister("a1NX0", function(module, exports) {
$parcel$export(module.exports, "createWebStoragePassthrough", () => $01c5a441a432f0ad$export$619fe705922e5d61);

var $e6Qdr = parcelRequire("e6Qdr");

var $gc3OY = parcelRequire("gc3OY");

var $1NYQF = parcelRequire("1NYQF");

var $ir9tA = parcelRequire("ir9tA");
var $gkonM = parcelRequire("gkonM");

var $kjN9K = parcelRequire("kjN9K");
const $01c5a441a432f0ad$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $ir9tA.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $gc3OY.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $1NYQF.BSCIndexedDB).isAvailable) {
        (0, $gc3OY.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $1NYQF.BSCIndexedDB).isBooted) {
        if ((0, $e6Qdr.fg)('cookies-bsc-timeout-for-indexeddb')) try {
            await (0, $1NYQF.BSCIndexedDB).boot();
        } catch  {
            (0, $gc3OY.Logger).warn('IndexedDB boot failed, proceeding without IDB tracking');
        }
        else await (0, $1NYQF.BSCIndexedDB).boot();
    }
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $kjN9K.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    const caseSensitiveStorageType = storageType === (0, $gkonM.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};

});
parcelRegister("kjN9K", function(module, exports) {
$parcel$export(module.exports, "setItemOverride", () => $cc4c5dba327eca4e$export$b4469df6294ea6aa);

var $e6Qdr = parcelRequire("e6Qdr");

var $5ROjv = parcelRequire("5ROjv");
var $hamKY = parcelRequire("hamKY");

var $hamKY = parcelRequire("hamKY");

var $l8Zmx = parcelRequire("l8Zmx");

var $gc3OY = parcelRequire("gc3OY");
parcelRequire("ir9tA");
var $gkonM = parcelRequire("gkonM");

var $hQwKE = parcelRequire("hQwKE");
const $cc4c5dba327eca4e$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        if (!(0, $e6Qdr.fg)('platform_remove_bsc_overrides')) bscStorage.checkIfSetByPackage({
            itemKey: originalItemKey,
            isSetCallback: ()=>{
                itemSetByPackage = true;
            },
            isNotSetCallback: ()=>{
                // Note: This is async and could fail, but if the call errors out in IDB,
                // it will forcibly resolve to false here, so we're not catching the error again here ✅
                itemSetByPackage = false;
            }
        });
        if ((0, $e6Qdr.fg)('platform_remove_bsc_overrides')) originalSetItem.apply(storageContext, [
            originalItemKey,
            originalItemValue
        ]);
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                }
            });
        }
        try {
            (0, $hamKY.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    itemKey: originalItemKey,
                    outsidePackage: !itemSetByPackage,
                    storageType: storageType
                }
            });
            try {
                const productName = (0, $5ROjv.getBscGlobalState)().product;
                // Attempt to set a known item key that was set from outside the package
                (0, $l8Zmx.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ()=>{
                        if ((0, $e6Qdr.fg)('platform_remove_bsc_overrides')) return;
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory })=>{
                        const isOverrideEventSampled = !Math.floor(Math.random() * 10);
                        if (isOverrideEventSampled) (0, $hamKY.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null
                            }
                        });
                        if (!(0, $e6Qdr.fg)('platform_remove_bsc_overrides')) {
                            const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $5ROjv.getBscGlobalState)();
                            if (allowUncategorizedCookiesInOverrides && !itemHasCategory) originalSetItem.apply(storageContext, [
                                originalItemKey,
                                originalItemValue
                            ]);
                            else return;
                        }
                    },
                    storageType: storageType === (0, $gkonM.WebStorageType).LocalStorage ? (0, $hQwKE.CategoryStorageType).LocalStorage : (0, $hQwKE.CategoryStorageType).SessionStorage,
                    productName: productName
                });
            } catch (e) {
                (0, $gc3OY.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType
                    }
                });
            }
        } catch (e) {
            (0, $gc3OY.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`
            });
        }
    };

});





parcelRegister("7z6nO", function(module, exports) {
$parcel$export(module.exports, "ForgePortalHeaderModule", () => $ea95acae16759c1d$export$80fa523a90b09a3d);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8n1kL = parcelRequire("8n1kL");

var $8P7DW = parcelRequire("8P7DW");

var $cwHmd = parcelRequire("cwHmd");
const $ea95acae16759c1d$var$zeroSpace = "var(--ds-space-0, 0px)";
const $ea95acae16759c1d$var$containerStyles = null;
const $ea95acae16759c1d$export$80fa523a90b09a3d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement("div", {
        className: (0, $8n1kL.default)([
            "_1bsb1osq _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8P7DW))).createElement((0, $cwHmd.ForgeHeaderModule), {
        page: "portal",
        noWrapper: true,
        allowCustomPadding: false
    }));
};
var $ea95acae16759c1d$export$2e2bcd8739ae039 = $ea95acae16759c1d$export$80fa523a90b09a3d;

});

parcelRegister("3YDPc", function(module, exports) {
$parcel$export(module.exports, "default", () => $116bbeb9e87fbeee$export$2e2bcd8739ae039);

var $7B9et = parcelRequire("7B9et");
var $116bbeb9e87fbeee$export$2e2bcd8739ae039 = (0, $7B9et.defineMessages)({
    unsupportedBrowser: {
        defaultMessage: "We don't support your browser version anymore and this may cause problems when you raise requests. Upgrade to a newer version to ensure a smooth request creation experience.",
        description: 'Message on top screen banner to inform user that they are using unsupported browser version',
        id: 'cv.app.banner.unsupported.browser.version'
    }
});

});



parcelRegister("ar7wO", function(module, exports) {
$parcel$export(module.exports, "ThemingContainer", () => (parcelRequire("fj93T")).ThemingContainer);

var $fj93T = parcelRequire("fj93T");

});
parcelRegister("fj93T", function(module, exports) {
$parcel$export(module.exports, "ThemingContainer", () => $0d85372d8731a7f6$export$a29c32a54963ec02);

var $8P7DW = parcelRequire("8P7DW");
parcelRequire("hAQvO");
var $jvoWT = parcelRequire("jvoWT");

var $ehscL = parcelRequire("ehscL");
parcelRequire("5uOWq");
var $ikoP4 = parcelRequire("ikoP4");

var $MmGmU = parcelRequire("MmGmU");

var $1EFS8 = parcelRequire("1EFS8");

var $8hYHC = parcelRequire("8hYHC");

var $iziiq = parcelRequire("iziiq");

var $gk18s = parcelRequire("gk18s");

var $hrPHR = parcelRequire("hrPHR");

var $6lTuV = parcelRequire("6lTuV");

var $4U6KL = parcelRequire("4U6KL");
const $0d85372d8731a7f6$export$9156684d9d875025 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $MmGmU.useAnalyticsEvents)();
    const { children: children, themeColor: themeColor } = props;
    const isAddColorDesignTokenEnabled = (0, $1EFS8.default).checkGate('add_color_design_token_support_into_help_center');
    const isTypographyTokenMigrationEnabled = (0, $1EFS8.default).checkGate('enable_typography_token_migration_for_csm');
    const sendAnalyticsEvent = $8P7DW.useCallback((action)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            analyticsType: (0, $iziiq.OPERATIONAL_EVENT_TYPE),
            actionSubject: 'portalThemingBootstrap'
        });
        if ((0, $1EFS8.default).checkGate('help_center_login_compiled_css')) // this gets rid of browser warning: Failed to send analytic data. [...] Error: Missing event.actionSubject
        analyticsEvent.context.push({
            componentName: 'portalThemingBootstrap'
        });
        analyticsEvent.fire();
    }, [
        createAnalyticsEvent
    ]);
    const themeColorWithoutHash = themeColor.slice(1);
    (0, $6lTuV.useIsoMorphicLayoutEffect)(()=>{
        (0, $8hYHC.default)({
            // @ts-expect-error
            light: isAddColorDesignTokenEnabled ? 'light' : '',
            spacing: 'spacing',
            colorMode: 'light',
            // @ts-expect-error
            typography: null,
            ...isTypographyTokenMigrationEnabled && (0, $gk18s.isCSMHelpCenter)((0, $hrPHR.getEnv)().helpCenterType) && {
                typography: 'typography'
            },
            ...isAddColorDesignTokenEnabled && {
                UNSAFE_themeOptions: {
                    brandColor: `#${themeColorWithoutHash}`
                }
            }
        }).then(()=>sendAnalyticsEvent((0, $4U6KL.OUTCOME).SUCCESS)).catch(()=>sendAnalyticsEvent((0, $4U6KL.OUTCOME).FAILURE));
    }, [
        sendAnalyticsEvent,
        themeColor
    ]);
    return /*#__PURE__*/ $8P7DW.createElement($8P7DW.Fragment, null, children);
};
const $0d85372d8731a7f6$var$selector = (0, $ehscL.createSelector)((0, $ikoP4.getThemeColor), (themeColor)=>({
        themeColor: themeColor
    }));
const $0d85372d8731a7f6$export$a29c32a54963ec02 = (0, $jvoWT.default)($0d85372d8731a7f6$var$selector)($0d85372d8731a7f6$export$9156684d9d875025);

});
parcelRegister("4U6KL", function(module, exports) {
$parcel$export(module.exports, "OUTCOME", () => $00bcf54b0ff5e030$export$a12152da2bb8d161);
// oxlint-disable-next-line no-shadow
var $00bcf54b0ff5e030$export$a12152da2bb8d161 = /*#__PURE__*/ function(OUTCOME) {
    OUTCOME["SUCCESS"] = "SUCCESS";
    OUTCOME["FAILURE"] = "FAILURE";
    return OUTCOME;
}({});

});






var $9TwI7 = parcelRequire("9TwI7");

var $jByYr = parcelRequire("jByYr");

var $1EFS8 = parcelRequire("1EFS8");
parcelRequire("5bVra");
var $81CCG = parcelRequire("81CCG");

var $e6Qdr = parcelRequire("e6Qdr");

var $cInSQ = parcelRequire("cInSQ");

var $cAaWV = parcelRequire("cAaWV");

var $9GPxu = parcelRequire("9GPxu");

var $5UJvw = parcelRequire("5UJvw");

var $7IuMj = parcelRequire("7IuMj");

var $cHs48 = parcelRequire("cHs48");

var $9TwI7 = parcelRequire("9TwI7");

var $9TwI7 = parcelRequire("9TwI7");
const $89185eb569c3b5fd$var$nameCache = new WeakMap();
function $89185eb569c3b5fd$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $89185eb569c3b5fd$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $89185eb569c3b5fd$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $89185eb569c3b5fd$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $89185eb569c3b5fd$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $89185eb569c3b5fd$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $89185eb569c3b5fd$var$getAttributeSelector(currentElement, 'data-testid') || $89185eb569c3b5fd$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $89185eb569c3b5fd$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($89185eb569c3b5fd$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $89185eb569c3b5fd$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$89185eb569c3b5fd$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $89185eb569c3b5fd$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $89185eb569c3b5fd$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $89185eb569c3b5fd$var$getUniqueSelector(selectorConfig, element);
    $89185eb569c3b5fd$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $89185eb569c3b5fd$export$2e2bcd8739ae039 = $89185eb569c3b5fd$var$getElementName;


let $99550c5c89d0ef46$var$performanceEventObserver;
const $99550c5c89d0ef46$var$selectorConfig = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $99550c5c89d0ef46$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $99550c5c89d0ef46$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $99550c5c89d0ef46$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($99550c5c89d0ef46$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $99550c5c89d0ef46$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $99550c5c89d0ef46$export$17afbba0f16b4b19 = ()=>{
    $99550c5c89d0ef46$var$performanceEventObserver = $99550c5c89d0ef46$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $99550c5c89d0ef46$export$e6be05b411ce21a6(entry);
    });
    return $99550c5c89d0ef46$var$performanceEventObserver;
};
const $99550c5c89d0ef46$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $9TwI7.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var _interaction$responsi;
        if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
            var _interaction$responsi2, _interaction$responsi3;
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = $99550c5c89d0ef46$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $89185eb569c3b5fd$export$2e2bcd8739ae039)($99550c5c89d0ef46$var$selectorConfig, entry.target);
            }
        }
    }
};



var $czITK = parcelRequire("czITK");

var $8P7DW = parcelRequire("8P7DW");

var $e6Qdr = parcelRequire("e6Qdr");

var $l5LZV = parcelRequire("l5LZV");

var $18KuK = parcelRequire("18KuK");

var $9TwI7 = parcelRequire("9TwI7");

var $8WiY5 = parcelRequire("8WiY5");
let $f66b7d81aad96813$var$sinkHandlerFn = ()=>{};
function $f66b7d81aad96813$export$e5fa3ac6dc44efff(fn) {
    $f66b7d81aad96813$var$sinkHandlerFn = fn;
}
const $f66b7d81aad96813$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $f66b7d81aad96813$export$1a949ef92fd30eca = (error)=>error.name === $f66b7d81aad96813$var$RELAY_NETWORK_ERRORS_NAME;
const $f66b7d81aad96813$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $f66b7d81aad96813$var$getErrorStatusCode = (error)=>{
    if (!$f66b7d81aad96813$var$isErrorObject(error)) return undefined;
    if ($f66b7d81aad96813$export$1a949ef92fd30eca(error)) {
        var _error$source;
        return (_error$source = error.source) === null || _error$source === void 0 || (_error$source = _error$source.errors) === null || _error$source === void 0 || (_error$source = _error$source[0]) === null || _error$source === void 0 || (_error$source = _error$source.extensions) === null || _error$source === void 0 ? void 0 : _error$source.statusCode;
    }
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $f66b7d81aad96813$var$getErrorTraceId = (error)=>$f66b7d81aad96813$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $f66b7d81aad96813$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    var _error$message, _getActiveTrace;
    if (additionalAttributes !== null && additionalAttributes !== void 0 && additionalAttributes.isClientNetworkError) // Exclude client network errors from being reported to UFO
    return;
    const activeInteraction = (0, $9TwI7.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: ((_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.slice(0, 100)) || 'Unknown error',
        timestamp: currentTime
    };
    const errorData = (0, $e6Qdr.fg)('platform_ufo_terminal_errors_fix_missing_data') ? {
        ...baseErrorData,
        statusCode: (additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.statusCode) ?? $f66b7d81aad96813$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: ((_getActiveTrace = (0, $l5LZV.getActiveTrace)()) === null || _getActiveTrace === void 0 ? void 0 : _getActiveTrace.traceId) ?? $f66b7d81aad96813$var$getErrorTraceId(error),
        teamName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.teamName,
        packageName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.packageName,
        errorBoundaryId: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorBoundaryId,
        errorHash: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorHash,
        fallbackType: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.fallbackType
    } : {
        ...baseErrorData,
        ...additionalAttributes
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $9TwI7.PreviousInteractionLog).timestamp != null ? currentTime - (0, $9TwI7.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.ufoName) ?? null,
        activeInteractionId: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.id) ?? null,
        activeInteractionType: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.type) ?? null,
        previousInteractionId: (0, $9TwI7.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $9TwI7.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $9TwI7.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $8WiY5.default).current ?? null
    };
    $f66b7d81aad96813$var$sinkHandlerFn(errorData, context);
}
function $f66b7d81aad96813$export$79ee0f0d40355053(error, additionalAttributes) {
    const interactionContext = (0, $18KuK.useInteractionContext)();
    const hasReportedRef = (0, $8P7DW.useRef)(false);
    (0, $8P7DW.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $f66b7d81aad96813$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack
    ]);
}



var $2NwEO = parcelRequire("2NwEO");

var $e6Qdr = parcelRequire("e6Qdr");
function $656c967e6c505287$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $e6Qdr.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $2NwEO.unstable_scheduleCallback)((0, $2NwEO.unstable_IdlePriority), work);
}
var $656c967e6c505287$export$2e2bcd8739ae039 = $656c967e6c505287$var$scheduleIdleCallback;


let $edadc7166e933ef5$var$initialized = false;
function $edadc7166e933ef5$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $656c967e6c505287$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $9TwI7.sinkInteractionHandler)(sinkFn);
}
function $edadc7166e933ef5$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            const payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then((payload)=>{
                if (payload) instance.sendOperationalEvent(payload);
            });
        }
        (0, $656c967e6c505287$export$2e2bcd8739ae039)(experimentalMetricsOnIdle);
    }
    (0, $9GPxu.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $edadc7166e933ef5$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $9TwI7.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $656c967e6c505287$export$2e2bcd8739ae039)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $edadc7166e933ef5$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $f66b7d81aad96813$export$e5fa3ac6dc44efff)((errorData, context)=>{
        (0, $656c967e6c505287$export$2e2bcd8739ae039)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $edadc7166e933ef5$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $9TwI7.interactionExtraMetrics).sinkHandler((interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult)=>{
        (0, $656c967e6c505287$export$2e2bcd8739ae039)(async ()=>{
            const payload = await createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $edadc7166e933ef5$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $656c967e6c505287$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $5UJvw.sinkExtraSearchPageInteractionHandler)(sinkFn);
}




function $edadc7166e933ef5$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($edadc7166e933ef5$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $cAaWV.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $cAaWV.isUFOEnabled)()) {
        $edadc7166e933ef5$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $czITK.initialisePressureObserver)();
    (0, $czITK.initialiseMemoryObserver)();
    if ((0, $e6Qdr.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $7IuMj.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $7IuMj.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $81CCG.context).setGlobalContextManager(contextManager);
    }
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
        var _config$experimentalI, _config$extraInteract;
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $9TwI7.postInteractionLog).initializeVCObserver(vcOptions);
        if (config !== null && config !== void 0 && (_config$experimentalI = config.experimentalInteractionMetrics) !== null && _config$experimentalI !== void 0 && _config$experimentalI.enabled) (0, $9GPxu.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
        if (config !== null && config !== void 0 && (_config$extraInteract = config.extraInteractionMetrics) !== null && _config$extraInteract !== void 0 && _config$extraInteract.enabled) (0, $9TwI7.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $cHs48.setupHiddenTimingCapture)();
    (0, $cInSQ.startLighthouseObserver)();
    (0, $cHs48.setupThrottleDetection)();
    $edadc7166e933ef5$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $99550c5c89d0ef46$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("hL9vO")),
        (parcelRequire("OBHqn")),
        (parcelRequire("iFWS8")),
        (parcelRequire("llViW"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage, createInteractionExtraMetricsPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            var _config$terminalError, _config$experimentalI2, _config$postInteracti, _config$extraInteract2, _config$extraSearchPa;
            const instance = client.getInstance();
            $edadc7166e933ef5$var$sinkInteraction(instance, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError = config.terminalErrors) !== null && _config$terminalError !== void 0 && _config$terminalError.enabled && (0, $e6Qdr.fg)('platform_ufo_enable_terminal_errors')) $edadc7166e933ef5$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$experimentalI2 = config.experimentalInteractionMetrics) !== null && _config$experimentalI2 !== void 0 && _config$experimentalI2.enabled) $edadc7166e933ef5$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) $edadc7166e933ef5$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraInteract2 = config.extraInteractionMetrics) !== null && _config$extraInteract2 !== void 0 && _config$extraInteract2.enabled) $edadc7166e933ef5$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa = config.extraSearchPageInteraction) !== null && _config$extraSearchPa !== void 0 && _config$extraSearchPa.enabled) $edadc7166e933ef5$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config$terminalError2, _config$experimentalI3, _config$postInteracti2, _config$extraInteract3, _config$extraSearchPa2;
            $edadc7166e933ef5$var$sinkInteraction(awc, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError2 = config.terminalErrors) !== null && _config$terminalError2 !== void 0 && _config$terminalError2.enabled && (0, $e6Qdr.fg)('platform_ufo_enable_terminal_errors')) $edadc7166e933ef5$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$experimentalI3 = config.experimentalInteractionMetrics) !== null && _config$experimentalI3 !== void 0 && _config$experimentalI3.enabled) $edadc7166e933ef5$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) $edadc7166e933ef5$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraInteract3 = config.extraInteractionMetrics) !== null && _config$extraInteract3 !== void 0 && _config$extraInteract3.enabled) $edadc7166e933ef5$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa2 = config.extraSearchPageInteraction) !== null && _config$extraSearchPa2 !== void 0 && _config$extraSearchPa2.enabled) $edadc7166e933ef5$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}



var $CcUdd = parcelRequire("CcUdd");
var $d0x1x = parcelRequire("d0x1x");
function $043308afdc552e5c$export$a311cb1baa7d2d62() {
    (0, $d0x1x.resourceTimingBuffer).start();
}



var $a30pz = parcelRequire("a30pz");

var $K219T = parcelRequire("K219T");

var $hrPHR = parcelRequire("hrPHR");

var $h4skC = parcelRequire("h4skC");

var $jByYr = parcelRequire("jByYr");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $4e8e68bdd7214fe1$var$cacheableTypes = [
    'script',
    'link'
];
const $4e8e68bdd7214fe1$var$CACHE_NETWORK = 'network';
const $4e8e68bdd7214fe1$var$CACHE_MEMORY = 'memory';
const $4e8e68bdd7214fe1$var$CACHE_DISK = 'disk';
function $4e8e68bdd7214fe1$var$calculateTransferType(type, duration, size) {
    if (!$4e8e68bdd7214fe1$var$cacheableTypes.includes(type)) return $4e8e68bdd7214fe1$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $4e8e68bdd7214fe1$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $4e8e68bdd7214fe1$var$CACHE_DISK;
    if (size === undefined) return null;
    return $4e8e68bdd7214fe1$var$CACHE_NETWORK;
}
function $4e8e68bdd7214fe1$export$e8a9322c3d9da8a6({ start: start }) {
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        for (const entry of performance.getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $4e8e68bdd7214fe1$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
}


var $cInSQ = parcelRequire("cInSQ");

var $hrPHR = parcelRequire("hrPHR");
var $8687514a11a160a0$var$n = "undefined" != typeof window ? window.performance : null;
function $8687514a11a160a0$export$a2a699fa5b2b1ed4(n) {
    void 0 === n && (n = {});
    var t = {
        deviceType: $8687514a11a160a0$export$abfb0136cf8e916b(),
        effectiveConnectionType: $8687514a11a160a0$export$265dfeca3f5017b9(),
        timeToFirstByte: $8687514a11a160a0$export$9a2904da0506c3ba(),
        firstPaint: $8687514a11a160a0$export$819e7a0b13f5961(),
        firstContentfulPaint: $8687514a11a160a0$export$3086fa1a9fb7f683(),
        domContentLoaded: $8687514a11a160a0$export$d6856d1fab905de0(),
        onLoad: $8687514a11a160a0$export$7259a7b98f0280a3()
    };
    return t.onLoad ? ((n.url || n.all) && (t.url = $8687514a11a160a0$export$94df0e59ebebf4a7()), (n.userAgent || n.all) && (t.userAgent = $8687514a11a160a0$export$7935961ef7719cb0()), (n.deviceMemory || n.all) && (t.deviceMemory = $8687514a11a160a0$export$bf34885f68c1d5e5()), (n.userTiming || n.all) && (t.userTiming = $8687514a11a160a0$export$4660d4a735328f2a()), (n.longTasks || n.all) && (t.longTasks = $8687514a11a160a0$export$a08a64ac61b1ac4e()), (n.resources || n.all) && (t.resources = $8687514a11a160a0$export$a0d4d2a74c7df9f()), Promise.resolve(t)) : new Promise(function(n) {
        return setTimeout(n, 250);
    }).then(function() {
        return $8687514a11a160a0$export$a2a699fa5b2b1ed4(n);
    });
}
function $8687514a11a160a0$export$bf7f2fce5c1cf636(e) {
    $8687514a11a160a0$var$n && $8687514a11a160a0$var$n.mark && $8687514a11a160a0$var$n.mark(e);
}
function $8687514a11a160a0$export$83602b44513dc228(e, t) {
    if ($8687514a11a160a0$var$n && $8687514a11a160a0$var$n.measure) try {
        $8687514a11a160a0$var$n.measure(e, t);
    } catch (n) {
        console.error(n);
    }
}
function $8687514a11a160a0$export$265dfeca3f5017b9() {
    var n = "undefined" != typeof navigator ? navigator.connection || navigator.mozConnection || navigator.webkitConnection : null;
    return n ? n.effectiveType : null;
}
function $8687514a11a160a0$export$819e7a0b13f5961() {
    if (!$8687514a11a160a0$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $8687514a11a160a0$var$n.getEntriesByType("paint").find(function(n) {
        return "first-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $8687514a11a160a0$export$3086fa1a9fb7f683() {
    if (!$8687514a11a160a0$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $8687514a11a160a0$var$n.getEntriesByType("paint").find(function(n) {
        return "first-contentful-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $8687514a11a160a0$export$9a2904da0506c3ba() {
    if (!$8687514a11a160a0$var$n) return null;
    var e = $8687514a11a160a0$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].responseStart) : null;
}
function $8687514a11a160a0$export$d6856d1fab905de0() {
    if (!$8687514a11a160a0$var$n) return null;
    var e = $8687514a11a160a0$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].domContentLoadedEventEnd) : null;
}
function $8687514a11a160a0$export$7259a7b98f0280a3() {
    if (!$8687514a11a160a0$var$n) return null;
    var e = $8687514a11a160a0$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].loadEventEnd) : null;
}
function $8687514a11a160a0$export$abfb0136cf8e916b(n) {
    void 0 === n && (n = $8687514a11a160a0$export$7935961ef7719cb0()), n = n.toLowerCase();
    var e = function(e) {
        return -1 !== n.indexOf(e);
    }, t = e("windows"), r = t && e("phone"), i = t && e("touch") && !r, o = !t && e("iphone"), a = e("ipod"), u = e("ipad"), d = !t && e("android"), l = d && e("mobile"), f = d && !e("mobile");
    return l || o || a || r ? "phone" : u || f || i ? "tablet" : "desktop";
}
function $8687514a11a160a0$export$94df0e59ebebf4a7() {
    return window.location.href;
}
function $8687514a11a160a0$export$7935961ef7719cb0() {
    return window.navigator.userAgent;
}
function $8687514a11a160a0$export$bf34885f68c1d5e5() {
    var n = "undefined" != typeof navigator ? navigator.deviceMemory : void 0;
    return void 0 === n ? null : n > 1 ? "full" : "lite";
}
function $8687514a11a160a0$export$4660d4a735328f2a() {
    if (!$8687514a11a160a0$var$n || "undefined" == typeof PerformanceMark) return null;
    var e = $8687514a11a160a0$var$n.getEntriesByType("mark").map(function(n) {
        return {
            type: "mark",
            name: n.name,
            startTime: Math.round(n.startTime)
        };
    }), t = $8687514a11a160a0$var$n.getEntriesByType("measure").map(function(n) {
        return {
            type: "measure",
            name: n.name,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
    return e.concat(t);
}
function $8687514a11a160a0$export$a0d4d2a74c7df9f() {
    return $8687514a11a160a0$var$n && "undefined" != typeof PerformanceResourceTiming ? $8687514a11a160a0$var$n.getEntriesByType("navigation").concat($8687514a11a160a0$var$n.getEntriesByType("resource")).map(function(n) {
        return {
            url: n.name,
            type: n.initiatorType,
            size: n.transferSize,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    }) : null;
}
function $8687514a11a160a0$export$a08a64ac61b1ac4e() {
    return void 0 === window.__lt ? null : window.__lt.e.map(function(n) {
        return {
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
}


const $10c3341a3873e75d$var$JS_EVAL_START /*:: :JsEvalStart */  = ':eval-start';
const $10c3341a3873e75d$var$JS_EVAL_STOP /*:: :JsEvalStop */  = ':eval-stop';
const $10c3341a3873e75d$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $8687514a11a160a0$export$4660d4a735328f2a)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter((item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith($10c3341a3873e75d$var$JS_EVAL_START) && !item.name.endsWith($10c3341a3873e75d$var$JS_EVAL_STOP) && item.startTime >= data.start).forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};


const $e564b36030f51817$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $e564b36030f51817$export$b37a70af06e58097 = ()=>{
    if (!performance) return {};
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        decodedBodySize: navigation.decodedBodySize,
        encodedBodySize: navigation.encodedBodySize,
        transferSize: navigation.transferSize
    };
};
const $e564b36030f51817$var$assetsTypes = [
    'script',
    'link'
];
const $e564b36030f51817$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $e564b36030f51817$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    for (const entry of performance.getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($e564b36030f51817$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};


function $dd0443c5187c62f6$export$a63eb8eebf6a41d3(interaction) {
    var _find, _apdex$;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const region = (0, $jByYr.getMeta)('ajs-region');
    if (region !== null && region !== '') customData.region = region;
    customData.httpProtocol = ((_find = performance.getEntriesByType('resource').find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)) === null || _find === void 0 ? void 0 : _find.nextHopProtocol) ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = (apdex === null || apdex === void 0 || (_apdex$ = apdex[0]) === null || _apdex$ === void 0 ? void 0 : _apdex$.stopTime) ?? end;
    const lightHouseMetrics = (0, $cInSQ.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $10c3341a3873e75d$export$9d952633c9c2237b)({
            start: start
        }),
        ...(0, $e564b36030f51817$export$84e3d676f1564c75)(),
        ...(0, $e564b36030f51817$export$b37a70af06e58097)(),
        ...(0, $e564b36030f51817$export$b72e035af6568be7)({
            start: start,
            stop: stop
        }),
        ...(0, $4e8e68bdd7214fe1$export$e8a9322c3d9da8a6)({
            start: start
        }),
        'app:version:web': window.BUILD_KEY,
        buildKey: window.BUILD_KEY,
        bundlerType: typeof window.BUILD_KEY === 'string' && window.BUILD_KEY.includes('ATLASPACK') ? 'atlaspack' : 'webpack',
        'app:framework:name': 'react',
        helpCenterType: (0, $hrPHR.getEnv)().helpCenterType
    };
    return customData;
}


const $dfb03f5d6a44b7f2$var$allAtlassian = ({ entry: entry })=>{
    const assetNames = [
        'atl-paas.net',
        'atlastunnel',
        'batch.js'
    ];
    const isAtlassian = assetNames.some((name)=>entry.name.includes(name));
    return isAtlassian;
};
const $dfb03f5d6a44b7f2$var$preloaded = ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
    return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
};
const $dfb03f5d6a44b7f2$export$3c97e0dabadb52a9 = {
    // allowedTypes: ['js', 'css', 'image', 'font'], // By default only JS
    classification: {
        allAtlassian: $dfb03f5d6a44b7f2$var$allAtlassian,
        preloaded: $dfb03f5d6a44b7f2$var$preloaded,
        all: true
    }
};



var $4L08H = parcelRequire("4L08H");

var $l5LZV = parcelRequire("l5LZV");

var $jByYr = parcelRequire("jByYr");
let $8deaab3eed207622$var$alreadySet = false;
const $8deaab3eed207622$export$1a71d2bbe236de99 = ()=>{
    if ($8deaab3eed207622$var$alreadySet) return;
    const traceId = (0, $jByYr.getMeta)('X-B3-TraceId') || '';
    const spanId = (traceId === null || traceId === void 0 ? void 0 : traceId.substring(traceId.length - 16)) || ''; // set root span ID by convention
    $8deaab3eed207622$var$alreadySet = true;
    (0, $l5LZV.setActiveTrace)(traceId, spanId, 'page_load');
};


function $ded9a5344527306c$var$runConfigureSsrTiming() {
    (0, $a30pz.configure)({
        getDoneMark: ()=>{
            var _getMark;
            return ((_getMark = (0, $h4skC.getMark)('ssr.spa.rendered')) === null || _getMark === void 0 ? void 0 : _getMark.startTime) ?? null;
        },
        getTimings: ()=>null,
        getFeatureFlags: ()=>null
    });
}
function $ded9a5344527306c$var$getAdditionalHelpCenterFields(interaction) {
    try {
        return {
            jira: (0, $dd0443c5187c62f6$export$a63eb8eebf6a41d3)(interaction)
        };
    } catch (error) {
        return {};
    }
}
const $ded9a5344527306c$export$af995ee1d7017fea = ()=>{
    $ded9a5344527306c$var$runConfigureSsrTiming();
    if ((0, $1EFS8.default).checkGate('enable_chr_in_ufo_for_help_center_assets')) (0, $043308afdc552e5c$export$a311cb1baa7d2d62)();
    (0, $8deaab3eed207622$export$1a71d2bbe236de99)();
    const isStagingEnv = (0, $hrPHR.getEnv)().environment === (0, $hrPHR.EnvType).STAGING;
    //We are only interested in tracking the cache hit ratio of the vendor-react chunk, on the perf-portal.
    //If this works, we can generalise this to track all chunks.
    if ((0, $1EFS8.default).checkGate('help-center-vendor-react-cache-hit-ratio')) (0, $CcUdd.configure)({
        sanitiseEndpoints (url) {
            return url;
        },
        mapResources (url) {
            const parts = url.split('/');
            const chunkName = parts[parts.length - 1];
            if (chunkName.includes('vendor-react')) return chunkName;
            return url;
        }
    });
    (0, $edadc7166e933ef5$export$2cd8252107eb640b)(Promise.resolve({
        getAnalyticsWebClientPromise: $4L08H.getAnalyticsWebClientPromise
    }), {
        product: 'jira',
        region: (0, $jByYr.getMeta)('ajs-region') || 'unknown',
        //TODO:SSR and FF data
        namePrefix: 'help-center-ufo-',
        ssr: {
            getSSRDoneTime: ()=>{
                var _getMark2;
                return (_getMark2 = (0, $h4skC.getMark)('ssr.spa.rendered')) === null || _getMark2 === void 0 ? void 0 : _getMark2.startTime;
            }
        },
        assetsConfig: (0, $1EFS8.default).checkGate('enable_chr_in_ufo_for_help_center_assets') ? (0, $dfb03f5d6a44b7f2$export$3c97e0dabadb52a9) : undefined,
        additionalPayloadData: $ded9a5344527306c$var$getAdditionalHelpCenterFields,
        capability: {
            /*
       * Enabling feature flag data to be captured in UFO.
       */ feature_flag_access: 1,
            /*
       * https://atlassian.slack.com/archives/C01AY8132S3/p1723030532244489?thread_ts=1722580624.223629&cid=C01AY8132S3
       * react_profiler is added since it is required by the type,
       * will be cleaned up in the future
       */ react_profiler: 0
        },
        vc: {
            /*
       * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/129126/diff#platform%2F.changeset%2Fred-lemons-mate.md
       */ stopVCAtInteractionFinish: true,
            enabled: true,
            selectorConfig: {
                className: true,
                role: isStagingEnv,
                id: isStagingEnv,
                testId: isStagingEnv
            },
            includeSSRInV3: (0, $1EFS8.default).checkGate('help_center_add_ssr_to_ttvc_v3'),
            includeSSRRatio: (0, $1EFS8.default).checkGate('help_center_add_ssr_ratio_to_ttvc'),
            ssr: (0, $hrPHR.getIsPageServerSideRendered)(),
            devToolsEnabled: isStagingEnv,
            enabledVCRevisions: {
                all: (0, $1EFS8.default).checkGate('ufo_disable_ttvc_v4') ? [] : [
                    'fy26.04'
                ]
            }
        },
        kind: {
            /*
       * Sampling works in 1 in the rate specified.
       * If rate is 1, it captures all events - 1/1
       */ page_load: 1,
            transition: 1,
            press: 1,
            typing: 1,
            legacy: 0,
            //For some Jira events that will be cleaned up in UFO
            hover: 1
        },
        postInteractionLog: {
            enabled: true,
            rates: {
                'request-details': 1,
                'request-create': 1,
                login: 1
            }
        },
        extraInteractionMetrics: {
            enabled: true,
            rates: {
                'request-details': 1,
                'request-create': 1,
                login: 1,
                'portal-home': 1
            }
        }
    });
    /*
   * Start instrumenting the page load event.
   * We invoke `traceUFOPageLoad` once more
   * when we have the route context.
   * It attaches the route name to the event.
   * */ (0, $K219T.default)();
};



var $1EFS8 = parcelRequire("1EFS8");

var $1M3oH = parcelRequire("1M3oH");
/*
These are the feature flags data that we want to embed into UFO.
This FF data will be recorded in perf portal as well.
*/ const $cd5d6f6a69bc991d$var$UFO_FEATURE_FLAGS = [
    'advanced_help_center_customization'
];
const $cd5d6f6a69bc991d$export$7b278fada0929739 = ()=>{
    $cd5d6f6a69bc991d$var$UFO_FEATURE_FLAGS.forEach((featureFlag)=>{
        const ffValue = (0, $1EFS8.default).checkGate(featureFlag);
        (0, $1M3oH.addFeatureFlagAccessed)(featureFlag, ffValue);
    });
};



var $1EFS8 = parcelRequire("1EFS8");
var $4G9cg = parcelRequire("4G9cg");

var $1lG1b = parcelRequire("1lG1b");

var $jW99n = parcelRequire("jW99n");
const $030f35fb82c743f8$export$21f987f4268bfbca = ()=>$030f35fb82c743f8$var$parseJsonContentFromMetaTag('ajs-fe-statsig-values');
const $030f35fb82c743f8$var$parseJsonContentFromMetaTag = (metaTagName)=>{
    const metaContent = $030f35fb82c743f8$export$8fd697566e460c96(metaTagName);
    if (metaContent != null && metaContent !== '') try {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(metaContent);
    } catch (e) {
        throw new Error(`Can't parse '${metaTagName}' value`);
    }
    return {};
};
function $030f35fb82c743f8$export$8fd697566e460c96(name) {
    const objectModelRef = typeof window === 'undefined' ? (0, $jW99n.default) : document;
    const metaElement = objectModelRef.querySelector(`meta[name="${name}"]`);
    const metaValue = metaElement && metaElement.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
}


function $acc62994a6af1f82$export$4d3d588e55d2ee0f(vars) {
    if ((0, $1EFS8.default).initializeCalled()) return Promise.resolve();
    try {
        const cloudId = (0, $030f35fb82c743f8$export$8fd697566e460c96)('tenant-id') ?? undefined;
        const atlassianAccountId = (0, $030f35fb82c743f8$export$8fd697566e460c96)('ajs-atlassian-account-id');
        const region = (0, $030f35fb82c743f8$export$8fd697566e460c96)('ajs-region');
        const environment = region !== undefined && region !== null && region !== void 0 && region.startsWith('prod') ? (0, $4G9cg.FeatureGateEnvironment).Production : (0, $4G9cg.FeatureGateEnvironment).Staging;
        return (0, $1EFS8.default).initializeFromValues({
            environment: environment,
            perimeter: (0, $1lG1b.isFedRamp)() ? (0, $4G9cg.PerimeterType).FEDRAMP_MODERATE : (0, $4G9cg.PerimeterType).COMMERCIAL,
            targetApp: 'jsm-portal_web',
            sdkKey: environment === (0, $4G9cg.FeatureGateEnvironment).Production ? 'client-NKfwskfcfrondp65Ar9Mfv9GNLywVcUdkBvK1mLpNK6' : 'client-rRwj0kwrHSPVA9p8Gy6pMfyBouOlfD2DX6pMXJtx9y1'
        }, {
            atlassianAccountId: atlassianAccountId !== null ? atlassianAccountId : undefined,
            tenantId: cloudId
        }, {}, vars.statsigValues || (0, $030f35fb82c743f8$export$21f987f4268bfbca)());
    } catch (error) {
        return Promise.reject(error);
    }
}




var $4OjKJ = parcelRequire("4OjKJ");
const $a059d9cd4569d604$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
const $a059d9cd4569d604$var$PERFORMANCE_MARKS = {
    // These happen to currently exist in the Jira monolith. Will replace them with more meaningful marks on the backend and then update here
    BEFORE_FRAGMENT: 'jsd.performance.profile.customer.portal.wrm.resources.loaded',
    AFTER_FRAGMENT: 'jsd.performance.profile.customer.portal.first.chunk.loaded'
};

// Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope,@atlaskit/platform/no-direct-document-usage
document.addEventListener('DOMContentLoaded', ()=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const element = document.getElementById('page');
    element && element.parentElement && element.parentElement.removeChild(element);
    (0, $acc62994a6af1f82$export$4d3d588e55d2ee0f)($a059d9cd4569d604$var$globalVar).catch((err)=>(0, $4OjKJ.sentryQueue).pushError(err)).finally(()=>{
        try {
            (0, $ded9a5344527306c$export$af995ee1d7017fea)();
        } catch (err) {
            (0, $4OjKJ.sentryQueue).pushError(err);
        }
        (0, $cd5d6f6a69bc991d$export$7b278fada0929739)();
        const requiredBootstrapMarkBefore = performance.now();
        // Suppressing existing violation. Please fix this.
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */ /* oxlint-disable-next-line global-require */ const { bootstrap: bootstrap } = (parcelRequire("c88Yy"));
        const requiredBootstrapMarkAfter = performance.now();
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        bootstrap();
        const executedBootstrapMarkAfter = performance.now();
        {
            var _performance$getEntri, _performance$getEntri2;
            const beforeFragment = performance.getEntriesByName && ((_performance$getEntri = performance.getEntriesByName($a059d9cd4569d604$var$PERFORMANCE_MARKS.BEFORE_FRAGMENT)[0]) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.startTime);
            const afterFragment = beforeFragment && ((_performance$getEntri2 = performance.getEntriesByName($a059d9cd4569d604$var$PERFORMANCE_MARKS.AFTER_FRAGMENT)[0]) === null || _performance$getEntri2 === void 0 ? void 0 : _performance$getEntri2.startTime);
            beforeFragment && afterFragment && (0, $9TwI7.addSpanToAll)('custom', 'fragment executed', [
                {
                    name: 'bootstrap'
                }
            ], beforeFragment, afterFragment);
            (0, $9TwI7.addSpanToAll)('custom', 'bootstrap required', [
                {
                    name: 'bootstrap'
                }
            ], requiredBootstrapMarkBefore, requiredBootstrapMarkAfter);
            (0, $9TwI7.addSpanToAll)('custom', 'bootstrap executed', [
                {
                    name: 'bootstrap'
                }
            ], requiredBootstrapMarkAfter, executedBootstrapMarkAfter);
        }
    });
});


//# sourceMappingURL=entry.75f66d18.js.map
